
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire74ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire74ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fJAss", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $b74756cc4e9d9700$export$ffb0004e005737fa, (v) => $b74756cc4e9d9700$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $b74756cc4e9d9700$export$34b9dba7ce09269b, (v) => $b74756cc4e9d9700$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $b74756cc4e9d9700$export$25062201e9e25d76, (v) => $b74756cc4e9d9700$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b74756cc4e9d9700$export$ffb0004e005737fa;
var $b74756cc4e9d9700$export$34b9dba7ce09269b;
var $b74756cc4e9d9700$export$25062201e9e25d76;
"use strict";

var $dup7A = parcelRequire("dup7A");
var $b74756cc4e9d9700$var$k = Symbol.for("react.element"), $b74756cc4e9d9700$var$l = Symbol.for("react.fragment"), $b74756cc4e9d9700$var$m = Object.prototype.hasOwnProperty, $b74756cc4e9d9700$var$n = $dup7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b74756cc4e9d9700$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b74756cc4e9d9700$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b74756cc4e9d9700$var$m.call(a, b) && !$b74756cc4e9d9700$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b74756cc4e9d9700$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b74756cc4e9d9700$var$n.current
    };
}
$b74756cc4e9d9700$export$ffb0004e005737fa = $b74756cc4e9d9700$var$l;
$b74756cc4e9d9700$export$34b9dba7ce09269b = $b74756cc4e9d9700$var$q;
$b74756cc4e9d9700$export$25062201e9e25d76 = $b74756cc4e9d9700$var$q;

});
parcelRegister("dup7A", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fpMhT"));

});
parcelRegister("fpMhT", function(module, exports) {

$parcel$export(module.exports, "Children", () => $b38ea5b65b2045e0$export$dca3b0875bd9a954, (v) => $b38ea5b65b2045e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $b38ea5b65b2045e0$export$16fa2f45be04daa8, (v) => $b38ea5b65b2045e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $b38ea5b65b2045e0$export$ffb0004e005737fa, (v) => $b38ea5b65b2045e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $b38ea5b65b2045e0$export$e2c29f18771995cb, (v) => $b38ea5b65b2045e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $b38ea5b65b2045e0$export$221d75b3f55bb0bd, (v) => $b38ea5b65b2045e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $b38ea5b65b2045e0$export$5f8d39834fd61797, (v) => $b38ea5b65b2045e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b38ea5b65b2045e0$export$74bf444e3cd11ea5, (v) => $b38ea5b65b2045e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $b38ea5b65b2045e0$export$ae55be85d98224ed, (v) => $b38ea5b65b2045e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $b38ea5b65b2045e0$export$3ba232387fd5d6dd, (v) => $b38ea5b65b2045e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $b38ea5b65b2045e0$export$e530037191fcd5d7, (v) => $b38ea5b65b2045e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $b38ea5b65b2045e0$export$fd42f52fd3ae1109, (v) => $b38ea5b65b2045e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $b38ea5b65b2045e0$export$c8a8987d4410bf2d, (v) => $b38ea5b65b2045e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $b38ea5b65b2045e0$export$d38cd72104c1f0e9, (v) => $b38ea5b65b2045e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $b38ea5b65b2045e0$export$7d1e3a5e95ceca43, (v) => $b38ea5b65b2045e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $b38ea5b65b2045e0$export$257a8862b851cb5b, (v) => $b38ea5b65b2045e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $b38ea5b65b2045e0$export$a8257692ac88316c, (v) => $b38ea5b65b2045e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $b38ea5b65b2045e0$export$488013bae63b21da, (v) => $b38ea5b65b2045e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $b38ea5b65b2045e0$export$7c73462e0d25e514, (v) => $b38ea5b65b2045e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $b38ea5b65b2045e0$export$7568632d0d33d16d, (v) => $b38ea5b65b2045e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $b38ea5b65b2045e0$export$88948ce120ea2619, (v) => $b38ea5b65b2045e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $b38ea5b65b2045e0$export$35808ee640e87ca7, (v) => $b38ea5b65b2045e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $b38ea5b65b2045e0$export$fae74005e78b1a27, (v) => $b38ea5b65b2045e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e, (v) => $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $b38ea5b65b2045e0$export$6a7bc4e911dc01cf, (v) => $b38ea5b65b2045e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $b38ea5b65b2045e0$export$6d9c69b0de29b591, (v) => $b38ea5b65b2045e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $b38ea5b65b2045e0$export$f680877a34711e37, (v) => $b38ea5b65b2045e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $b38ea5b65b2045e0$export$d5a552a76deda3c2, (v) => $b38ea5b65b2045e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $b38ea5b65b2045e0$export$aaabe4eda9ed9969, (v) => $b38ea5b65b2045e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $b38ea5b65b2045e0$export$e5c5a5f917a5871c, (v) => $b38ea5b65b2045e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $b38ea5b65b2045e0$export$1538c33de8887b59, (v) => $b38ea5b65b2045e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $b38ea5b65b2045e0$export$13e3392192263954, (v) => $b38ea5b65b2045e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $b38ea5b65b2045e0$export$b8f5890fc79d6aca, (v) => $b38ea5b65b2045e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $b38ea5b65b2045e0$export$60241385465d0a34, (v) => $b38ea5b65b2045e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $b38ea5b65b2045e0$export$306c0aa65ff9ec16, (v) => $b38ea5b65b2045e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $b38ea5b65b2045e0$export$7b286972b8d8ccbf, (v) => $b38ea5b65b2045e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $b38ea5b65b2045e0$export$83d89fbfd8236492, (v) => $b38ea5b65b2045e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b38ea5b65b2045e0$export$dca3b0875bd9a954;
var $b38ea5b65b2045e0$export$16fa2f45be04daa8;
var $b38ea5b65b2045e0$export$ffb0004e005737fa;
var $b38ea5b65b2045e0$export$e2c29f18771995cb;
var $b38ea5b65b2045e0$export$221d75b3f55bb0bd;
var $b38ea5b65b2045e0$export$5f8d39834fd61797;
var $b38ea5b65b2045e0$export$74bf444e3cd11ea5;
var $b38ea5b65b2045e0$export$ae55be85d98224ed;
var $b38ea5b65b2045e0$export$3ba232387fd5d6dd;
var $b38ea5b65b2045e0$export$e530037191fcd5d7;
var $b38ea5b65b2045e0$export$fd42f52fd3ae1109;
var $b38ea5b65b2045e0$export$c8a8987d4410bf2d;
var $b38ea5b65b2045e0$export$d38cd72104c1f0e9;
var $b38ea5b65b2045e0$export$7d1e3a5e95ceca43;
var $b38ea5b65b2045e0$export$257a8862b851cb5b;
var $b38ea5b65b2045e0$export$a8257692ac88316c;
var $b38ea5b65b2045e0$export$488013bae63b21da;
var $b38ea5b65b2045e0$export$7c73462e0d25e514;
var $b38ea5b65b2045e0$export$7568632d0d33d16d;
var $b38ea5b65b2045e0$export$88948ce120ea2619;
var $b38ea5b65b2045e0$export$35808ee640e87ca7;
var $b38ea5b65b2045e0$export$fae74005e78b1a27;
var $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e;
var $b38ea5b65b2045e0$export$6a7bc4e911dc01cf;
var $b38ea5b65b2045e0$export$6d9c69b0de29b591;
var $b38ea5b65b2045e0$export$f680877a34711e37;
var $b38ea5b65b2045e0$export$d5a552a76deda3c2;
var $b38ea5b65b2045e0$export$aaabe4eda9ed9969;
var $b38ea5b65b2045e0$export$e5c5a5f917a5871c;
var $b38ea5b65b2045e0$export$1538c33de8887b59;
var $b38ea5b65b2045e0$export$13e3392192263954;
var $b38ea5b65b2045e0$export$b8f5890fc79d6aca;
var $b38ea5b65b2045e0$export$60241385465d0a34;
var $b38ea5b65b2045e0$export$306c0aa65ff9ec16;
var $b38ea5b65b2045e0$export$7b286972b8d8ccbf;
var $b38ea5b65b2045e0$export$83d89fbfd8236492;
"use strict";
var $b38ea5b65b2045e0$var$l = Symbol.for("react.element"), $b38ea5b65b2045e0$var$n = Symbol.for("react.portal"), $b38ea5b65b2045e0$var$p = Symbol.for("react.fragment"), $b38ea5b65b2045e0$var$q = Symbol.for("react.strict_mode"), $b38ea5b65b2045e0$var$r = Symbol.for("react.profiler"), $b38ea5b65b2045e0$var$t = Symbol.for("react.provider"), $b38ea5b65b2045e0$var$u = Symbol.for("react.context"), $b38ea5b65b2045e0$var$v = Symbol.for("react.forward_ref"), $b38ea5b65b2045e0$var$w = Symbol.for("react.suspense"), $b38ea5b65b2045e0$var$x = Symbol.for("react.memo"), $b38ea5b65b2045e0$var$y = Symbol.for("react.lazy"), $b38ea5b65b2045e0$var$z = Symbol.iterator;
function $b38ea5b65b2045e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b38ea5b65b2045e0$var$z && a[$b38ea5b65b2045e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b38ea5b65b2045e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b38ea5b65b2045e0$var$C = Object.assign, $b38ea5b65b2045e0$var$D = {};
function $b38ea5b65b2045e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b38ea5b65b2045e0$var$D;
    this.updater = e || $b38ea5b65b2045e0$var$B;
}
$b38ea5b65b2045e0$var$E.prototype.isReactComponent = {};
$b38ea5b65b2045e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b38ea5b65b2045e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b38ea5b65b2045e0$var$F() {}
$b38ea5b65b2045e0$var$F.prototype = $b38ea5b65b2045e0$var$E.prototype;
function $b38ea5b65b2045e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b38ea5b65b2045e0$var$D;
    this.updater = e || $b38ea5b65b2045e0$var$B;
}
var $b38ea5b65b2045e0$var$H = $b38ea5b65b2045e0$var$G.prototype = new $b38ea5b65b2045e0$var$F;
$b38ea5b65b2045e0$var$H.constructor = $b38ea5b65b2045e0$var$G;
$b38ea5b65b2045e0$var$C($b38ea5b65b2045e0$var$H, $b38ea5b65b2045e0$var$E.prototype);
$b38ea5b65b2045e0$var$H.isPureReactComponent = !0;
var $b38ea5b65b2045e0$var$I = Array.isArray, $b38ea5b65b2045e0$var$J = Object.prototype.hasOwnProperty, $b38ea5b65b2045e0$var$K = {
    current: null
}, $b38ea5b65b2045e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b38ea5b65b2045e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b38ea5b65b2045e0$var$J.call(b, d) && !$b38ea5b65b2045e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b38ea5b65b2045e0$var$K.current
    };
}
function $b38ea5b65b2045e0$var$N(a, b) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b38ea5b65b2045e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b38ea5b65b2045e0$var$l;
}
function $b38ea5b65b2045e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b38ea5b65b2045e0$var$P = /\/+/g;
function $b38ea5b65b2045e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b38ea5b65b2045e0$var$escape("" + a.key) : b.toString(36);
}
function $b38ea5b65b2045e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b38ea5b65b2045e0$var$l:
                case $b38ea5b65b2045e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b38ea5b65b2045e0$var$Q(h, 0) : d, $b38ea5b65b2045e0$var$I(c) ? (e = "", null != a && (e = a.replace($b38ea5b65b2045e0$var$P, "$&/") + "/"), $b38ea5b65b2045e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b38ea5b65b2045e0$var$O(c) && (c = $b38ea5b65b2045e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b38ea5b65b2045e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b38ea5b65b2045e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b38ea5b65b2045e0$var$Q(k, g);
        h += $b38ea5b65b2045e0$var$R(k, b, e, f, c);
    }
    else if (f = $b38ea5b65b2045e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b38ea5b65b2045e0$var$Q(k, g++), h += $b38ea5b65b2045e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b38ea5b65b2045e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b38ea5b65b2045e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b38ea5b65b2045e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b38ea5b65b2045e0$var$U = {
    current: null
}, $b38ea5b65b2045e0$var$V = {
    transition: null
}, $b38ea5b65b2045e0$var$W = {
    ReactCurrentDispatcher: $b38ea5b65b2045e0$var$U,
    ReactCurrentBatchConfig: $b38ea5b65b2045e0$var$V,
    ReactCurrentOwner: $b38ea5b65b2045e0$var$K
};
function $b38ea5b65b2045e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b38ea5b65b2045e0$export$dca3b0875bd9a954 = {
    map: $b38ea5b65b2045e0$var$S,
    forEach: function(a, b, e) {
        $b38ea5b65b2045e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b38ea5b65b2045e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b38ea5b65b2045e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b38ea5b65b2045e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b38ea5b65b2045e0$export$16fa2f45be04daa8 = $b38ea5b65b2045e0$var$E;
$b38ea5b65b2045e0$export$ffb0004e005737fa = $b38ea5b65b2045e0$var$p;
$b38ea5b65b2045e0$export$e2c29f18771995cb = $b38ea5b65b2045e0$var$r;
$b38ea5b65b2045e0$export$221d75b3f55bb0bd = $b38ea5b65b2045e0$var$G;
$b38ea5b65b2045e0$export$5f8d39834fd61797 = $b38ea5b65b2045e0$var$q;
$b38ea5b65b2045e0$export$74bf444e3cd11ea5 = $b38ea5b65b2045e0$var$w;
$b38ea5b65b2045e0$export$ae55be85d98224ed = $b38ea5b65b2045e0$var$W;
$b38ea5b65b2045e0$export$3ba232387fd5d6dd = $b38ea5b65b2045e0$var$X;
$b38ea5b65b2045e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b38ea5b65b2045e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b38ea5b65b2045e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b38ea5b65b2045e0$var$J.call(b, f) && !$b38ea5b65b2045e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b38ea5b65b2045e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b38ea5b65b2045e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b38ea5b65b2045e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b38ea5b65b2045e0$export$c8a8987d4410bf2d = $b38ea5b65b2045e0$var$M;
$b38ea5b65b2045e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $b38ea5b65b2045e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b38ea5b65b2045e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b38ea5b65b2045e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$v,
        render: a
    };
};
$b38ea5b65b2045e0$export$a8257692ac88316c = $b38ea5b65b2045e0$var$O;
$b38ea5b65b2045e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b38ea5b65b2045e0$var$T
    };
};
$b38ea5b65b2045e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b38ea5b65b2045e0$export$7568632d0d33d16d = function(a) {
    var b = $b38ea5b65b2045e0$var$V.transition;
    $b38ea5b65b2045e0$var$V.transition = {};
    try {
        a();
    } finally{
        $b38ea5b65b2045e0$var$V.transition = b;
    }
};
$b38ea5b65b2045e0$export$88948ce120ea2619 = $b38ea5b65b2045e0$var$X;
$b38ea5b65b2045e0$export$35808ee640e87ca7 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useCallback(a, b);
};
$b38ea5b65b2045e0$export$fae74005e78b1a27 = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useContext(a);
};
$b38ea5b65b2045e0$export$dc8fbce3eb94dc1e = function() {};
$b38ea5b65b2045e0$export$6a7bc4e911dc01cf = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useDeferredValue(a);
};
$b38ea5b65b2045e0$export$6d9c69b0de29b591 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useEffect(a, b);
};
$b38ea5b65b2045e0$export$f680877a34711e37 = function() {
    return $b38ea5b65b2045e0$var$U.current.useId();
};
$b38ea5b65b2045e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useImperativeHandle(a, b, e);
};
$b38ea5b65b2045e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useInsertionEffect(a, b);
};
$b38ea5b65b2045e0$export$e5c5a5f917a5871c = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useLayoutEffect(a, b);
};
$b38ea5b65b2045e0$export$1538c33de8887b59 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useMemo(a, b);
};
$b38ea5b65b2045e0$export$13e3392192263954 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useReducer(a, b, e);
};
$b38ea5b65b2045e0$export$b8f5890fc79d6aca = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useRef(a);
};
$b38ea5b65b2045e0$export$60241385465d0a34 = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useState(a);
};
$b38ea5b65b2045e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useSyncExternalStore(a, b, e);
};
$b38ea5b65b2045e0$export$7b286972b8d8ccbf = function() {
    return $b38ea5b65b2045e0$var$U.current.useTransition();
};
$b38ea5b65b2045e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("dpuiw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $9c351ca3251b0a6f$export$ae55be85d98224ed, (v) => $9c351ca3251b0a6f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $9c351ca3251b0a6f$export$d39a5bbd09211389, (v) => $9c351ca3251b0a6f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $9c351ca3251b0a6f$export$882461b6382ed46c, (v) => $9c351ca3251b0a6f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $9c351ca3251b0a6f$export$466bfc07425424d5, (v) => $9c351ca3251b0a6f$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $9c351ca3251b0a6f$export$cd75ccfd720a3cd4, (v) => $9c351ca3251b0a6f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $9c351ca3251b0a6f$export$fa8d919ba61d84db, (v) => $9c351ca3251b0a6f$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $9c351ca3251b0a6f$export$757ceba2d55c277e, (v) => $9c351ca3251b0a6f$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $9c351ca3251b0a6f$export$b3890eb0ae9dca99, (v) => $9c351ca3251b0a6f$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $9c351ca3251b0a6f$export$502457920280e6be, (v) => $9c351ca3251b0a6f$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $9c351ca3251b0a6f$export$c78a37762a8d58e1, (v) => $9c351ca3251b0a6f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $9c351ca3251b0a6f$export$dc54d992c10e8a18, (v) => $9c351ca3251b0a6f$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $9c351ca3251b0a6f$export$83d89fbfd8236492, (v) => $9c351ca3251b0a6f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9c351ca3251b0a6f$export$ae55be85d98224ed;
var $9c351ca3251b0a6f$export$d39a5bbd09211389;
var $9c351ca3251b0a6f$export$882461b6382ed46c;
var $9c351ca3251b0a6f$export$466bfc07425424d5;
var $9c351ca3251b0a6f$export$cd75ccfd720a3cd4;
var $9c351ca3251b0a6f$export$fa8d919ba61d84db;
var $9c351ca3251b0a6f$export$757ceba2d55c277e;
var $9c351ca3251b0a6f$export$b3890eb0ae9dca99;
var $9c351ca3251b0a6f$export$502457920280e6be;
var $9c351ca3251b0a6f$export$c78a37762a8d58e1;
var $9c351ca3251b0a6f$export$dc54d992c10e8a18;
var $9c351ca3251b0a6f$export$83d89fbfd8236492;
"use strict";

var $dup7A = parcelRequire("dup7A");

var $lnhio = parcelRequire("lnhio");
function $9c351ca3251b0a6f$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9c351ca3251b0a6f$var$da = new Set, $9c351ca3251b0a6f$var$ea = {};
function $9c351ca3251b0a6f$var$fa(a, b) {
    $9c351ca3251b0a6f$var$ha(a, b);
    $9c351ca3251b0a6f$var$ha(a + "Capture", b);
}
function $9c351ca3251b0a6f$var$ha(a, b) {
    $9c351ca3251b0a6f$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9c351ca3251b0a6f$var$da.add(b[a]);
}
var $9c351ca3251b0a6f$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9c351ca3251b0a6f$var$ja = Object.prototype.hasOwnProperty, $9c351ca3251b0a6f$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9c351ca3251b0a6f$var$la = {}, $9c351ca3251b0a6f$var$ma = {};
function $9c351ca3251b0a6f$var$oa(a) {
    if ($9c351ca3251b0a6f$var$ja.call($9c351ca3251b0a6f$var$ma, a)) return !0;
    if ($9c351ca3251b0a6f$var$ja.call($9c351ca3251b0a6f$var$la, a)) return !1;
    if ($9c351ca3251b0a6f$var$ka.test(a)) return $9c351ca3251b0a6f$var$ma[a] = !0;
    $9c351ca3251b0a6f$var$la[a] = !0;
    return !1;
}
function $9c351ca3251b0a6f$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9c351ca3251b0a6f$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9c351ca3251b0a6f$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9c351ca3251b0a6f$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9c351ca3251b0a6f$var$ra = /[\-:]([a-z])/g;
function $9c351ca3251b0a6f$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9c351ca3251b0a6f$var$z.xlinkHref = new $9c351ca3251b0a6f$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9c351ca3251b0a6f$var$ta(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$z.hasOwnProperty(b) ? $9c351ca3251b0a6f$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9c351ca3251b0a6f$var$qa(b, c, e, d) && (c = null), d || null === e ? $9c351ca3251b0a6f$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9c351ca3251b0a6f$var$ua = $dup7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9c351ca3251b0a6f$var$va = Symbol.for("react.element"), $9c351ca3251b0a6f$var$wa = Symbol.for("react.portal"), $9c351ca3251b0a6f$var$ya = Symbol.for("react.fragment"), $9c351ca3251b0a6f$var$za = Symbol.for("react.strict_mode"), $9c351ca3251b0a6f$var$Aa = Symbol.for("react.profiler"), $9c351ca3251b0a6f$var$Ba = Symbol.for("react.provider"), $9c351ca3251b0a6f$var$Ca = Symbol.for("react.context"), $9c351ca3251b0a6f$var$Da = Symbol.for("react.forward_ref"), $9c351ca3251b0a6f$var$Ea = Symbol.for("react.suspense"), $9c351ca3251b0a6f$var$Fa = Symbol.for("react.suspense_list"), $9c351ca3251b0a6f$var$Ga = Symbol.for("react.memo"), $9c351ca3251b0a6f$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9c351ca3251b0a6f$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9c351ca3251b0a6f$var$Ja = Symbol.iterator;
function $9c351ca3251b0a6f$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9c351ca3251b0a6f$var$Ja && a[$9c351ca3251b0a6f$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9c351ca3251b0a6f$var$A = Object.assign, $9c351ca3251b0a6f$var$La;
function $9c351ca3251b0a6f$var$Ma(a) {
    if (void 0 === $9c351ca3251b0a6f$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9c351ca3251b0a6f$var$La = b && b[1] || "";
    }
    return "\n" + $9c351ca3251b0a6f$var$La + a;
}
var $9c351ca3251b0a6f$var$Na = !1;
function $9c351ca3251b0a6f$var$Oa(a, b) {
    if (!a || $9c351ca3251b0a6f$var$Na) return "";
    $9c351ca3251b0a6f$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9c351ca3251b0a6f$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9c351ca3251b0a6f$var$Ma(a) : "";
}
function $9c351ca3251b0a6f$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9c351ca3251b0a6f$var$Ma(a.type);
        case 16:
            return $9c351ca3251b0a6f$var$Ma("Lazy");
        case 13:
            return $9c351ca3251b0a6f$var$Ma("Suspense");
        case 19:
            return $9c351ca3251b0a6f$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9c351ca3251b0a6f$var$Oa(a.type, !1), a;
        case 11:
            return a = $9c351ca3251b0a6f$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9c351ca3251b0a6f$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9c351ca3251b0a6f$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9c351ca3251b0a6f$var$ya:
            return "Fragment";
        case $9c351ca3251b0a6f$var$wa:
            return "Portal";
        case $9c351ca3251b0a6f$var$Aa:
            return "Profiler";
        case $9c351ca3251b0a6f$var$za:
            return "StrictMode";
        case $9c351ca3251b0a6f$var$Ea:
            return "Suspense";
        case $9c351ca3251b0a6f$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9c351ca3251b0a6f$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9c351ca3251b0a6f$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9c351ca3251b0a6f$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9c351ca3251b0a6f$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9c351ca3251b0a6f$var$Qa(a.type) || "Memo";
        case $9c351ca3251b0a6f$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9c351ca3251b0a6f$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9c351ca3251b0a6f$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9c351ca3251b0a6f$var$Qa(b);
        case 8:
            return b === $9c351ca3251b0a6f$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9c351ca3251b0a6f$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9c351ca3251b0a6f$var$Ua(a) {
    var b = $9c351ca3251b0a6f$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9c351ca3251b0a6f$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9c351ca3251b0a6f$var$Ua(a));
}
function $9c351ca3251b0a6f$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9c351ca3251b0a6f$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9c351ca3251b0a6f$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9c351ca3251b0a6f$var$Ya(a, b) {
    var c = b.checked;
    return $9c351ca3251b0a6f$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9c351ca3251b0a6f$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9c351ca3251b0a6f$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9c351ca3251b0a6f$var$ab(a, b) {
    b = b.checked;
    null != b && $9c351ca3251b0a6f$var$ta(a, "checked", b, !1);
}
function $9c351ca3251b0a6f$var$bb(a, b) {
    $9c351ca3251b0a6f$var$ab(a, b);
    var c = $9c351ca3251b0a6f$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9c351ca3251b0a6f$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9c351ca3251b0a6f$var$cb(a, b.type, $9c351ca3251b0a6f$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9c351ca3251b0a6f$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9c351ca3251b0a6f$var$cb(a, b, c) {
    if ("number" !== b || $9c351ca3251b0a6f$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9c351ca3251b0a6f$var$eb = Array.isArray;
function $9c351ca3251b0a6f$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9c351ca3251b0a6f$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9c351ca3251b0a6f$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9c351ca3251b0a6f$var$p(91));
    return $9c351ca3251b0a6f$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9c351ca3251b0a6f$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9c351ca3251b0a6f$var$p(92));
            if ($9c351ca3251b0a6f$var$eb(c)) {
                if (1 < c.length) throw Error($9c351ca3251b0a6f$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9c351ca3251b0a6f$var$Sa(c)
    };
}
function $9c351ca3251b0a6f$var$ib(a, b) {
    var c = $9c351ca3251b0a6f$var$Sa(b.value), d = $9c351ca3251b0a6f$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9c351ca3251b0a6f$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9c351ca3251b0a6f$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9c351ca3251b0a6f$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9c351ca3251b0a6f$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9c351ca3251b0a6f$var$mb, $9c351ca3251b0a6f$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9c351ca3251b0a6f$var$mb = $9c351ca3251b0a6f$var$mb || document.createElement("div");
        $9c351ca3251b0a6f$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9c351ca3251b0a6f$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9c351ca3251b0a6f$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9c351ca3251b0a6f$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9c351ca3251b0a6f$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9c351ca3251b0a6f$var$pb).forEach(function(a) {
    $9c351ca3251b0a6f$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9c351ca3251b0a6f$var$pb[b] = $9c351ca3251b0a6f$var$pb[a];
    });
});
function $9c351ca3251b0a6f$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9c351ca3251b0a6f$var$pb.hasOwnProperty(a) && $9c351ca3251b0a6f$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9c351ca3251b0a6f$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9c351ca3251b0a6f$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9c351ca3251b0a6f$var$tb = $9c351ca3251b0a6f$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9c351ca3251b0a6f$var$ub(a, b) {
    if (b) {
        if ($9c351ca3251b0a6f$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9c351ca3251b0a6f$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9c351ca3251b0a6f$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9c351ca3251b0a6f$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9c351ca3251b0a6f$var$p(62));
    }
}
function $9c351ca3251b0a6f$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9c351ca3251b0a6f$var$wb = null;
function $9c351ca3251b0a6f$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9c351ca3251b0a6f$var$yb = null, $9c351ca3251b0a6f$var$zb = null, $9c351ca3251b0a6f$var$Ab = null;
function $9c351ca3251b0a6f$var$Bb(a) {
    if (a = $9c351ca3251b0a6f$var$Cb(a)) {
        if ("function" !== typeof $9c351ca3251b0a6f$var$yb) throw Error($9c351ca3251b0a6f$var$p(280));
        var b = a.stateNode;
        b && (b = $9c351ca3251b0a6f$var$Db(b), $9c351ca3251b0a6f$var$yb(a.stateNode, a.type, b));
    }
}
function $9c351ca3251b0a6f$var$Eb(a) {
    $9c351ca3251b0a6f$var$zb ? $9c351ca3251b0a6f$var$Ab ? $9c351ca3251b0a6f$var$Ab.push(a) : $9c351ca3251b0a6f$var$Ab = [
        a
    ] : $9c351ca3251b0a6f$var$zb = a;
}
function $9c351ca3251b0a6f$var$Fb() {
    if ($9c351ca3251b0a6f$var$zb) {
        var a = $9c351ca3251b0a6f$var$zb, b = $9c351ca3251b0a6f$var$Ab;
        $9c351ca3251b0a6f$var$Ab = $9c351ca3251b0a6f$var$zb = null;
        $9c351ca3251b0a6f$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9c351ca3251b0a6f$var$Bb(b[a]);
    }
}
function $9c351ca3251b0a6f$var$Gb(a, b) {
    return a(b);
}
function $9c351ca3251b0a6f$var$Hb() {}
var $9c351ca3251b0a6f$var$Ib = !1;
function $9c351ca3251b0a6f$var$Jb(a, b, c) {
    if ($9c351ca3251b0a6f$var$Ib) return a(b, c);
    $9c351ca3251b0a6f$var$Ib = !0;
    try {
        return $9c351ca3251b0a6f$var$Gb(a, b, c);
    } finally{
        if ($9c351ca3251b0a6f$var$Ib = !1, null !== $9c351ca3251b0a6f$var$zb || null !== $9c351ca3251b0a6f$var$Ab) $9c351ca3251b0a6f$var$Hb(), $9c351ca3251b0a6f$var$Fb();
    }
}
function $9c351ca3251b0a6f$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9c351ca3251b0a6f$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9c351ca3251b0a6f$var$p(231, b, typeof c));
    return c;
}
var $9c351ca3251b0a6f$var$Lb = !1;
if ($9c351ca3251b0a6f$var$ia) try {
    var $9c351ca3251b0a6f$var$Mb = {};
    Object.defineProperty($9c351ca3251b0a6f$var$Mb, "passive", {
        get: function() {
            $9c351ca3251b0a6f$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9c351ca3251b0a6f$var$Mb, $9c351ca3251b0a6f$var$Mb);
    window.removeEventListener("test", $9c351ca3251b0a6f$var$Mb, $9c351ca3251b0a6f$var$Mb);
} catch (a) {
    $9c351ca3251b0a6f$var$Lb = !1;
}
function $9c351ca3251b0a6f$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9c351ca3251b0a6f$var$Ob = !1, $9c351ca3251b0a6f$var$Pb = null, $9c351ca3251b0a6f$var$Qb = !1, $9c351ca3251b0a6f$var$Rb = null, $9c351ca3251b0a6f$var$Sb = {
    onError: function(a) {
        $9c351ca3251b0a6f$var$Ob = !0;
        $9c351ca3251b0a6f$var$Pb = a;
    }
};
function $9c351ca3251b0a6f$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9c351ca3251b0a6f$var$Ob = !1;
    $9c351ca3251b0a6f$var$Pb = null;
    $9c351ca3251b0a6f$var$Nb.apply($9c351ca3251b0a6f$var$Sb, arguments);
}
function $9c351ca3251b0a6f$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9c351ca3251b0a6f$var$Tb.apply(this, arguments);
    if ($9c351ca3251b0a6f$var$Ob) {
        if ($9c351ca3251b0a6f$var$Ob) {
            var l = $9c351ca3251b0a6f$var$Pb;
            $9c351ca3251b0a6f$var$Ob = !1;
            $9c351ca3251b0a6f$var$Pb = null;
        } else throw Error($9c351ca3251b0a6f$var$p(198));
        $9c351ca3251b0a6f$var$Qb || ($9c351ca3251b0a6f$var$Qb = !0, $9c351ca3251b0a6f$var$Rb = l);
    }
}
function $9c351ca3251b0a6f$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9c351ca3251b0a6f$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Xb(a) {
    if ($9c351ca3251b0a6f$var$Vb(a) !== a) throw Error($9c351ca3251b0a6f$var$p(188));
}
function $9c351ca3251b0a6f$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9c351ca3251b0a6f$var$Vb(a);
        if (null === b) throw Error($9c351ca3251b0a6f$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9c351ca3251b0a6f$var$Xb(e), a;
                if (f === d) return $9c351ca3251b0a6f$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9c351ca3251b0a6f$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9c351ca3251b0a6f$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9c351ca3251b0a6f$var$p(190));
    }
    if (3 !== c.tag) throw Error($9c351ca3251b0a6f$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9c351ca3251b0a6f$var$Zb(a) {
    a = $9c351ca3251b0a6f$var$Yb(a);
    return null !== a ? $9c351ca3251b0a6f$var$$b(a) : null;
}
function $9c351ca3251b0a6f$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9c351ca3251b0a6f$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$ac = $lnhio.unstable_scheduleCallback, $9c351ca3251b0a6f$var$bc = $lnhio.unstable_cancelCallback, $9c351ca3251b0a6f$var$cc = $lnhio.unstable_shouldYield, $9c351ca3251b0a6f$var$dc = $lnhio.unstable_requestPaint, $9c351ca3251b0a6f$var$B = $lnhio.unstable_now, $9c351ca3251b0a6f$var$ec = $lnhio.unstable_getCurrentPriorityLevel, $9c351ca3251b0a6f$var$fc = $lnhio.unstable_ImmediatePriority, $9c351ca3251b0a6f$var$gc = $lnhio.unstable_UserBlockingPriority, $9c351ca3251b0a6f$var$hc = $lnhio.unstable_NormalPriority, $9c351ca3251b0a6f$var$ic = $lnhio.unstable_LowPriority, $9c351ca3251b0a6f$var$jc = $lnhio.unstable_IdlePriority, $9c351ca3251b0a6f$var$kc = null, $9c351ca3251b0a6f$var$lc = null;
function $9c351ca3251b0a6f$var$mc(a) {
    if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onCommitFiberRoot) try {
        $9c351ca3251b0a6f$var$lc.onCommitFiberRoot($9c351ca3251b0a6f$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9c351ca3251b0a6f$var$oc = Math.clz32 ? Math.clz32 : $9c351ca3251b0a6f$var$nc, $9c351ca3251b0a6f$var$pc = Math.log, $9c351ca3251b0a6f$var$qc = Math.LN2;
function $9c351ca3251b0a6f$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9c351ca3251b0a6f$var$pc(a) / $9c351ca3251b0a6f$var$qc | 0) | 0;
}
var $9c351ca3251b0a6f$var$rc = 64, $9c351ca3251b0a6f$var$sc = 4194304;
function $9c351ca3251b0a6f$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9c351ca3251b0a6f$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9c351ca3251b0a6f$var$tc(h) : (f &= g, 0 !== f && (d = $9c351ca3251b0a6f$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9c351ca3251b0a6f$var$tc(g) : 0 !== f && (d = $9c351ca3251b0a6f$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9c351ca3251b0a6f$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9c351ca3251b0a6f$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9c351ca3251b0a6f$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9c351ca3251b0a6f$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9c351ca3251b0a6f$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9c351ca3251b0a6f$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9c351ca3251b0a6f$var$yc() {
    var a = $9c351ca3251b0a6f$var$rc;
    $9c351ca3251b0a6f$var$rc <<= 1;
    0 === ($9c351ca3251b0a6f$var$rc & 4194240) && ($9c351ca3251b0a6f$var$rc = 64);
    return a;
}
function $9c351ca3251b0a6f$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9c351ca3251b0a6f$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9c351ca3251b0a6f$var$oc(b);
    a[b] = c;
}
function $9c351ca3251b0a6f$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9c351ca3251b0a6f$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9c351ca3251b0a6f$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9c351ca3251b0a6f$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9c351ca3251b0a6f$var$C = 0;
function $9c351ca3251b0a6f$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9c351ca3251b0a6f$var$Ec, $9c351ca3251b0a6f$var$Fc, $9c351ca3251b0a6f$var$Gc, $9c351ca3251b0a6f$var$Hc, $9c351ca3251b0a6f$var$Ic, $9c351ca3251b0a6f$var$Jc = !1, $9c351ca3251b0a6f$var$Kc = [], $9c351ca3251b0a6f$var$Lc = null, $9c351ca3251b0a6f$var$Mc = null, $9c351ca3251b0a6f$var$Nc = null, $9c351ca3251b0a6f$var$Oc = new Map, $9c351ca3251b0a6f$var$Pc = new Map, $9c351ca3251b0a6f$var$Qc = [], $9c351ca3251b0a6f$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9c351ca3251b0a6f$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9c351ca3251b0a6f$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9c351ca3251b0a6f$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9c351ca3251b0a6f$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9c351ca3251b0a6f$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9c351ca3251b0a6f$var$Pc.delete(b.pointerId);
    }
}
function $9c351ca3251b0a6f$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9c351ca3251b0a6f$var$Cb(b), null !== b && $9c351ca3251b0a6f$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9c351ca3251b0a6f$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9c351ca3251b0a6f$var$Lc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9c351ca3251b0a6f$var$Mc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9c351ca3251b0a6f$var$Nc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9c351ca3251b0a6f$var$Oc.set(f, $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9c351ca3251b0a6f$var$Pc.set(f, $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9c351ca3251b0a6f$var$Vc(a) {
    var b = $9c351ca3251b0a6f$var$Wc(a.target);
    if (null !== b) {
        var c = $9c351ca3251b0a6f$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9c351ca3251b0a6f$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9c351ca3251b0a6f$var$Ic(a.priority, function() {
                        $9c351ca3251b0a6f$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9c351ca3251b0a6f$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9c351ca3251b0a6f$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9c351ca3251b0a6f$var$wb = d;
            c.target.dispatchEvent(d);
            $9c351ca3251b0a6f$var$wb = null;
        } else return b = $9c351ca3251b0a6f$var$Cb(c), null !== b && $9c351ca3251b0a6f$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Zc(a, b, c) {
    $9c351ca3251b0a6f$var$Xc(a) && c.delete(b);
}
function $9c351ca3251b0a6f$var$$c() {
    $9c351ca3251b0a6f$var$Jc = !1;
    null !== $9c351ca3251b0a6f$var$Lc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Lc) && ($9c351ca3251b0a6f$var$Lc = null);
    null !== $9c351ca3251b0a6f$var$Mc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Mc) && ($9c351ca3251b0a6f$var$Mc = null);
    null !== $9c351ca3251b0a6f$var$Nc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Nc) && ($9c351ca3251b0a6f$var$Nc = null);
    $9c351ca3251b0a6f$var$Oc.forEach($9c351ca3251b0a6f$var$Zc);
    $9c351ca3251b0a6f$var$Pc.forEach($9c351ca3251b0a6f$var$Zc);
}
function $9c351ca3251b0a6f$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9c351ca3251b0a6f$var$Jc || ($9c351ca3251b0a6f$var$Jc = !0, $lnhio.unstable_scheduleCallback($lnhio.unstable_NormalPriority, $9c351ca3251b0a6f$var$$c)));
}
function $9c351ca3251b0a6f$var$bd(a) {
    function b(b) {
        return $9c351ca3251b0a6f$var$ad(b, a);
    }
    if (0 < $9c351ca3251b0a6f$var$Kc.length) {
        $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Kc[0], a);
        for(var c = 1; c < $9c351ca3251b0a6f$var$Kc.length; c++){
            var d = $9c351ca3251b0a6f$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9c351ca3251b0a6f$var$Lc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Lc, a);
    null !== $9c351ca3251b0a6f$var$Mc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Mc, a);
    null !== $9c351ca3251b0a6f$var$Nc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Nc, a);
    $9c351ca3251b0a6f$var$Oc.forEach(b);
    $9c351ca3251b0a6f$var$Pc.forEach(b);
    for(c = 0; c < $9c351ca3251b0a6f$var$Qc.length; c++)d = $9c351ca3251b0a6f$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9c351ca3251b0a6f$var$Qc.length && (c = $9c351ca3251b0a6f$var$Qc[0], null === c.blockedOn);)$9c351ca3251b0a6f$var$Vc(c), null === c.blockedOn && $9c351ca3251b0a6f$var$Qc.shift();
}
var $9c351ca3251b0a6f$var$cd = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$dd = !0;
function $9c351ca3251b0a6f$var$ed(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$C, f = $9c351ca3251b0a6f$var$cd.transition;
    $9c351ca3251b0a6f$var$cd.transition = null;
    try {
        $9c351ca3251b0a6f$var$C = 1, $9c351ca3251b0a6f$var$fd(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$C = e, $9c351ca3251b0a6f$var$cd.transition = f;
    }
}
function $9c351ca3251b0a6f$var$gd(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$C, f = $9c351ca3251b0a6f$var$cd.transition;
    $9c351ca3251b0a6f$var$cd.transition = null;
    try {
        $9c351ca3251b0a6f$var$C = 4, $9c351ca3251b0a6f$var$fd(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$C = e, $9c351ca3251b0a6f$var$cd.transition = f;
    }
}
function $9c351ca3251b0a6f$var$fd(a, b, c, d) {
    if ($9c351ca3251b0a6f$var$dd) {
        var e = $9c351ca3251b0a6f$var$Yc(a, b, c, d);
        if (null === e) $9c351ca3251b0a6f$var$hd(a, b, d, $9c351ca3251b0a6f$var$id, c), $9c351ca3251b0a6f$var$Sc(a, d);
        else if ($9c351ca3251b0a6f$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9c351ca3251b0a6f$var$Sc(a, d), b & 4 && -1 < $9c351ca3251b0a6f$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9c351ca3251b0a6f$var$Cb(e);
                null !== f && $9c351ca3251b0a6f$var$Ec(f);
                f = $9c351ca3251b0a6f$var$Yc(a, b, c, d);
                null === f && $9c351ca3251b0a6f$var$hd(a, b, d, $9c351ca3251b0a6f$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9c351ca3251b0a6f$var$hd(a, b, d, null, c);
    }
}
var $9c351ca3251b0a6f$var$id = null;
function $9c351ca3251b0a6f$var$Yc(a, b, c, d) {
    $9c351ca3251b0a6f$var$id = null;
    a = $9c351ca3251b0a6f$var$xb(d);
    a = $9c351ca3251b0a6f$var$Wc(a);
    if (null !== a) {
        if (b = $9c351ca3251b0a6f$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9c351ca3251b0a6f$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9c351ca3251b0a6f$var$id = a;
    return null;
}
function $9c351ca3251b0a6f$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9c351ca3251b0a6f$var$ec()){
                case $9c351ca3251b0a6f$var$fc:
                    return 1;
                case $9c351ca3251b0a6f$var$gc:
                    return 4;
                case $9c351ca3251b0a6f$var$hc:
                case $9c351ca3251b0a6f$var$ic:
                    return 16;
                case $9c351ca3251b0a6f$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9c351ca3251b0a6f$var$kd = null, $9c351ca3251b0a6f$var$ld = null, $9c351ca3251b0a6f$var$md = null;
function $9c351ca3251b0a6f$var$nd() {
    if ($9c351ca3251b0a6f$var$md) return $9c351ca3251b0a6f$var$md;
    var a, b = $9c351ca3251b0a6f$var$ld, c = b.length, d, e = "value" in $9c351ca3251b0a6f$var$kd ? $9c351ca3251b0a6f$var$kd.value : $9c351ca3251b0a6f$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9c351ca3251b0a6f$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9c351ca3251b0a6f$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9c351ca3251b0a6f$var$pd() {
    return !0;
}
function $9c351ca3251b0a6f$var$qd() {
    return !1;
}
function $9c351ca3251b0a6f$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9c351ca3251b0a6f$var$pd : $9c351ca3251b0a6f$var$qd;
        this.isPropagationStopped = $9c351ca3251b0a6f$var$qd;
        return this;
    }
    $9c351ca3251b0a6f$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9c351ca3251b0a6f$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9c351ca3251b0a6f$var$pd);
        },
        persist: function() {},
        isPersistent: $9c351ca3251b0a6f$var$pd
    });
    return b;
}
var $9c351ca3251b0a6f$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9c351ca3251b0a6f$var$td = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$sd), $9c351ca3251b0a6f$var$ud = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    view: 0,
    detail: 0
}), $9c351ca3251b0a6f$var$vd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$ud), $9c351ca3251b0a6f$var$wd, $9c351ca3251b0a6f$var$xd, $9c351ca3251b0a6f$var$yd, $9c351ca3251b0a6f$var$Ad = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9c351ca3251b0a6f$var$yd && ($9c351ca3251b0a6f$var$yd && "mousemove" === a.type ? ($9c351ca3251b0a6f$var$wd = a.screenX - $9c351ca3251b0a6f$var$yd.screenX, $9c351ca3251b0a6f$var$xd = a.screenY - $9c351ca3251b0a6f$var$yd.screenY) : $9c351ca3251b0a6f$var$xd = $9c351ca3251b0a6f$var$wd = 0, $9c351ca3251b0a6f$var$yd = a);
        return $9c351ca3251b0a6f$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9c351ca3251b0a6f$var$xd;
    }
}), $9c351ca3251b0a6f$var$Bd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ad), $9c351ca3251b0a6f$var$Cd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    dataTransfer: 0
}), $9c351ca3251b0a6f$var$Dd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Cd), $9c351ca3251b0a6f$var$Ed = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    relatedTarget: 0
}), $9c351ca3251b0a6f$var$Fd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ed), $9c351ca3251b0a6f$var$Gd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9c351ca3251b0a6f$var$Hd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Gd), $9c351ca3251b0a6f$var$Id = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9c351ca3251b0a6f$var$Jd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Id), $9c351ca3251b0a6f$var$Kd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    data: 0
}), $9c351ca3251b0a6f$var$Ld = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Kd), $9c351ca3251b0a6f$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9c351ca3251b0a6f$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9c351ca3251b0a6f$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9c351ca3251b0a6f$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9c351ca3251b0a6f$var$Od[a]) ? !!b[a] : !1;
}
function $9c351ca3251b0a6f$var$zd() {
    return $9c351ca3251b0a6f$var$Pd;
}
var $9c351ca3251b0a6f$var$Qd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9c351ca3251b0a6f$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9c351ca3251b0a6f$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9c351ca3251b0a6f$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9c351ca3251b0a6f$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9c351ca3251b0a6f$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9c351ca3251b0a6f$var$Rd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Qd), $9c351ca3251b0a6f$var$Sd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9c351ca3251b0a6f$var$Td = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Sd), $9c351ca3251b0a6f$var$Ud = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd
}), $9c351ca3251b0a6f$var$Vd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ud), $9c351ca3251b0a6f$var$Wd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9c351ca3251b0a6f$var$Xd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Wd), $9c351ca3251b0a6f$var$Yd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9c351ca3251b0a6f$var$Zd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Yd), $9c351ca3251b0a6f$var$$d = [
    9,
    13,
    27,
    32
], $9c351ca3251b0a6f$var$ae = $9c351ca3251b0a6f$var$ia && "CompositionEvent" in window, $9c351ca3251b0a6f$var$be = null;
$9c351ca3251b0a6f$var$ia && "documentMode" in document && ($9c351ca3251b0a6f$var$be = document.documentMode);
var $9c351ca3251b0a6f$var$ce = $9c351ca3251b0a6f$var$ia && "TextEvent" in window && !$9c351ca3251b0a6f$var$be, $9c351ca3251b0a6f$var$de = $9c351ca3251b0a6f$var$ia && (!$9c351ca3251b0a6f$var$ae || $9c351ca3251b0a6f$var$be && 8 < $9c351ca3251b0a6f$var$be && 11 >= $9c351ca3251b0a6f$var$be), $9c351ca3251b0a6f$var$ee = String.fromCharCode(32), $9c351ca3251b0a6f$var$fe = !1;
function $9c351ca3251b0a6f$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9c351ca3251b0a6f$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9c351ca3251b0a6f$var$ie = !1;
function $9c351ca3251b0a6f$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9c351ca3251b0a6f$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9c351ca3251b0a6f$var$fe = !0;
            return $9c351ca3251b0a6f$var$ee;
        case "textInput":
            return a = b.data, a === $9c351ca3251b0a6f$var$ee && $9c351ca3251b0a6f$var$fe ? null : a;
        default:
            return null;
    }
}
function $9c351ca3251b0a6f$var$ke(a, b) {
    if ($9c351ca3251b0a6f$var$ie) return "compositionend" === a || !$9c351ca3251b0a6f$var$ae && $9c351ca3251b0a6f$var$ge(a, b) ? (a = $9c351ca3251b0a6f$var$nd(), $9c351ca3251b0a6f$var$md = $9c351ca3251b0a6f$var$ld = $9c351ca3251b0a6f$var$kd = null, $9c351ca3251b0a6f$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9c351ca3251b0a6f$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9c351ca3251b0a6f$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9c351ca3251b0a6f$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9c351ca3251b0a6f$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9c351ca3251b0a6f$var$ne(a, b, c, d) {
    $9c351ca3251b0a6f$var$Eb(d);
    b = $9c351ca3251b0a6f$var$oe(b, "onChange");
    0 < b.length && (c = new $9c351ca3251b0a6f$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9c351ca3251b0a6f$var$pe = null, $9c351ca3251b0a6f$var$qe = null;
function $9c351ca3251b0a6f$var$re(a) {
    $9c351ca3251b0a6f$var$se(a, 0);
}
function $9c351ca3251b0a6f$var$te(a) {
    var b = $9c351ca3251b0a6f$var$ue(a);
    if ($9c351ca3251b0a6f$var$Wa(b)) return a;
}
function $9c351ca3251b0a6f$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9c351ca3251b0a6f$var$we = !1;
if ($9c351ca3251b0a6f$var$ia) {
    var $9c351ca3251b0a6f$var$xe;
    if ($9c351ca3251b0a6f$var$ia) {
        var $9c351ca3251b0a6f$var$ye = "oninput" in document;
        if (!$9c351ca3251b0a6f$var$ye) {
            var $9c351ca3251b0a6f$var$ze = document.createElement("div");
            $9c351ca3251b0a6f$var$ze.setAttribute("oninput", "return;");
            $9c351ca3251b0a6f$var$ye = "function" === typeof $9c351ca3251b0a6f$var$ze.oninput;
        }
        $9c351ca3251b0a6f$var$xe = $9c351ca3251b0a6f$var$ye;
    } else $9c351ca3251b0a6f$var$xe = !1;
    $9c351ca3251b0a6f$var$we = $9c351ca3251b0a6f$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9c351ca3251b0a6f$var$Ae() {
    $9c351ca3251b0a6f$var$pe && ($9c351ca3251b0a6f$var$pe.detachEvent("onpropertychange", $9c351ca3251b0a6f$var$Be), $9c351ca3251b0a6f$var$qe = $9c351ca3251b0a6f$var$pe = null);
}
function $9c351ca3251b0a6f$var$Be(a) {
    if ("value" === a.propertyName && $9c351ca3251b0a6f$var$te($9c351ca3251b0a6f$var$qe)) {
        var b = [];
        $9c351ca3251b0a6f$var$ne(b, $9c351ca3251b0a6f$var$qe, a, $9c351ca3251b0a6f$var$xb(a));
        $9c351ca3251b0a6f$var$Jb($9c351ca3251b0a6f$var$re, b);
    }
}
function $9c351ca3251b0a6f$var$Ce(a, b, c) {
    "focusin" === a ? ($9c351ca3251b0a6f$var$Ae(), $9c351ca3251b0a6f$var$pe = b, $9c351ca3251b0a6f$var$qe = c, $9c351ca3251b0a6f$var$pe.attachEvent("onpropertychange", $9c351ca3251b0a6f$var$Be)) : "focusout" === a && $9c351ca3251b0a6f$var$Ae();
}
function $9c351ca3251b0a6f$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9c351ca3251b0a6f$var$te($9c351ca3251b0a6f$var$qe);
}
function $9c351ca3251b0a6f$var$Ee(a, b) {
    if ("click" === a) return $9c351ca3251b0a6f$var$te(b);
}
function $9c351ca3251b0a6f$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9c351ca3251b0a6f$var$te(b);
}
function $9c351ca3251b0a6f$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9c351ca3251b0a6f$var$He = "function" === typeof Object.is ? Object.is : $9c351ca3251b0a6f$var$Ge;
function $9c351ca3251b0a6f$var$Ie(a, b) {
    if ($9c351ca3251b0a6f$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9c351ca3251b0a6f$var$ja.call(b, e) || !$9c351ca3251b0a6f$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9c351ca3251b0a6f$var$Ke(a, b) {
    var c = $9c351ca3251b0a6f$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9c351ca3251b0a6f$var$Je(c);
    }
}
function $9c351ca3251b0a6f$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9c351ca3251b0a6f$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9c351ca3251b0a6f$var$Me() {
    for(var a = window, b = $9c351ca3251b0a6f$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9c351ca3251b0a6f$var$Xa(a.document);
    }
    return b;
}
function $9c351ca3251b0a6f$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9c351ca3251b0a6f$var$Oe(a) {
    var b = $9c351ca3251b0a6f$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9c351ca3251b0a6f$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9c351ca3251b0a6f$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9c351ca3251b0a6f$var$Ke(c, f);
                var g = $9c351ca3251b0a6f$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9c351ca3251b0a6f$var$Pe = $9c351ca3251b0a6f$var$ia && "documentMode" in document && 11 >= document.documentMode, $9c351ca3251b0a6f$var$Qe = null, $9c351ca3251b0a6f$var$Re = null, $9c351ca3251b0a6f$var$Se = null, $9c351ca3251b0a6f$var$Te = !1;
function $9c351ca3251b0a6f$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9c351ca3251b0a6f$var$Te || null == $9c351ca3251b0a6f$var$Qe || $9c351ca3251b0a6f$var$Qe !== $9c351ca3251b0a6f$var$Xa(d) || (d = $9c351ca3251b0a6f$var$Qe, "selectionStart" in d && $9c351ca3251b0a6f$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9c351ca3251b0a6f$var$Se && $9c351ca3251b0a6f$var$Ie($9c351ca3251b0a6f$var$Se, d) || ($9c351ca3251b0a6f$var$Se = d, d = $9c351ca3251b0a6f$var$oe($9c351ca3251b0a6f$var$Re, "onSelect"), 0 < d.length && (b = new $9c351ca3251b0a6f$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9c351ca3251b0a6f$var$Qe)));
}
function $9c351ca3251b0a6f$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9c351ca3251b0a6f$var$We = {
    animationend: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationStart"),
    transitionend: $9c351ca3251b0a6f$var$Ve("Transition", "TransitionEnd")
}, $9c351ca3251b0a6f$var$Xe = {}, $9c351ca3251b0a6f$var$Ye = {};
$9c351ca3251b0a6f$var$ia && ($9c351ca3251b0a6f$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9c351ca3251b0a6f$var$We.animationend.animation, delete $9c351ca3251b0a6f$var$We.animationiteration.animation, delete $9c351ca3251b0a6f$var$We.animationstart.animation), "TransitionEvent" in window || delete $9c351ca3251b0a6f$var$We.transitionend.transition);
function $9c351ca3251b0a6f$var$Ze(a) {
    if ($9c351ca3251b0a6f$var$Xe[a]) return $9c351ca3251b0a6f$var$Xe[a];
    if (!$9c351ca3251b0a6f$var$We[a]) return a;
    var b = $9c351ca3251b0a6f$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9c351ca3251b0a6f$var$Ye) return $9c351ca3251b0a6f$var$Xe[a] = b[c];
    return a;
}
var $9c351ca3251b0a6f$var$$e = $9c351ca3251b0a6f$var$Ze("animationend"), $9c351ca3251b0a6f$var$af = $9c351ca3251b0a6f$var$Ze("animationiteration"), $9c351ca3251b0a6f$var$bf = $9c351ca3251b0a6f$var$Ze("animationstart"), $9c351ca3251b0a6f$var$cf = $9c351ca3251b0a6f$var$Ze("transitionend"), $9c351ca3251b0a6f$var$df = new Map, $9c351ca3251b0a6f$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9c351ca3251b0a6f$var$ff(a, b) {
    $9c351ca3251b0a6f$var$df.set(a, b);
    $9c351ca3251b0a6f$var$fa(b, [
        a
    ]);
}
for(var $9c351ca3251b0a6f$var$gf = 0; $9c351ca3251b0a6f$var$gf < $9c351ca3251b0a6f$var$ef.length; $9c351ca3251b0a6f$var$gf++){
    var $9c351ca3251b0a6f$var$hf = $9c351ca3251b0a6f$var$ef[$9c351ca3251b0a6f$var$gf], $9c351ca3251b0a6f$var$jf = $9c351ca3251b0a6f$var$hf.toLowerCase(), $9c351ca3251b0a6f$var$kf = $9c351ca3251b0a6f$var$hf[0].toUpperCase() + $9c351ca3251b0a6f$var$hf.slice(1);
    $9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$jf, "on" + $9c351ca3251b0a6f$var$kf);
}
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$$e, "onAnimationEnd");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$af, "onAnimationIteration");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$bf, "onAnimationStart");
$9c351ca3251b0a6f$var$ff("dblclick", "onDoubleClick");
$9c351ca3251b0a6f$var$ff("focusin", "onFocus");
$9c351ca3251b0a6f$var$ff("focusout", "onBlur");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$cf, "onTransitionEnd");
$9c351ca3251b0a6f$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9c351ca3251b0a6f$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9c351ca3251b0a6f$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9c351ca3251b0a6f$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9c351ca3251b0a6f$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9c351ca3251b0a6f$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9c351ca3251b0a6f$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9c351ca3251b0a6f$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9c351ca3251b0a6f$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9c351ca3251b0a6f$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9c351ca3251b0a6f$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9c351ca3251b0a6f$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9c351ca3251b0a6f$var$lf));
function $9c351ca3251b0a6f$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9c351ca3251b0a6f$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9c351ca3251b0a6f$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9c351ca3251b0a6f$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9c351ca3251b0a6f$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9c351ca3251b0a6f$var$Qb) throw a = $9c351ca3251b0a6f$var$Rb, $9c351ca3251b0a6f$var$Qb = !1, $9c351ca3251b0a6f$var$Rb = null, a;
}
function $9c351ca3251b0a6f$var$D(a, b) {
    var c = b[$9c351ca3251b0a6f$var$of];
    void 0 === c && (c = b[$9c351ca3251b0a6f$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9c351ca3251b0a6f$var$pf(b, a, 2, !1), c.add(d));
}
function $9c351ca3251b0a6f$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9c351ca3251b0a6f$var$pf(c, a, d, b);
}
var $9c351ca3251b0a6f$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9c351ca3251b0a6f$var$sf(a) {
    if (!a[$9c351ca3251b0a6f$var$rf]) {
        a[$9c351ca3251b0a6f$var$rf] = !0;
        $9c351ca3251b0a6f$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9c351ca3251b0a6f$var$mf.has(b) || $9c351ca3251b0a6f$var$qf(b, !1, a), $9c351ca3251b0a6f$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9c351ca3251b0a6f$var$rf] || (b[$9c351ca3251b0a6f$var$rf] = !0, $9c351ca3251b0a6f$var$qf("selectionchange", !1, b));
    }
}
function $9c351ca3251b0a6f$var$pf(a, b, c, d) {
    switch($9c351ca3251b0a6f$var$jd(b)){
        case 1:
            var e = $9c351ca3251b0a6f$var$ed;
            break;
        case 4:
            e = $9c351ca3251b0a6f$var$gd;
            break;
        default:
            e = $9c351ca3251b0a6f$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9c351ca3251b0a6f$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9c351ca3251b0a6f$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9c351ca3251b0a6f$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9c351ca3251b0a6f$var$Jb(function() {
        var d = f, e = $9c351ca3251b0a6f$var$xb(c), g = [];
        a: {
            var h = $9c351ca3251b0a6f$var$df.get(a);
            if (void 0 !== h) {
                var k = $9c351ca3251b0a6f$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9c351ca3251b0a6f$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9c351ca3251b0a6f$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9c351ca3251b0a6f$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9c351ca3251b0a6f$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9c351ca3251b0a6f$var$Vd;
                        break;
                    case $9c351ca3251b0a6f$var$$e:
                    case $9c351ca3251b0a6f$var$af:
                    case $9c351ca3251b0a6f$var$bf:
                        k = $9c351ca3251b0a6f$var$Hd;
                        break;
                    case $9c351ca3251b0a6f$var$cf:
                        k = $9c351ca3251b0a6f$var$Xd;
                        break;
                    case "scroll":
                        k = $9c351ca3251b0a6f$var$vd;
                        break;
                    case "wheel":
                        k = $9c351ca3251b0a6f$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9c351ca3251b0a6f$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9c351ca3251b0a6f$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9c351ca3251b0a6f$var$Kb(w, x), null != F && t.push($9c351ca3251b0a6f$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9c351ca3251b0a6f$var$wb && (n = c.relatedTarget || c.fromElement) && ($9c351ca3251b0a6f$var$Wc(n) || n[$9c351ca3251b0a6f$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9c351ca3251b0a6f$var$Wc(n) : null, null !== n && (J = $9c351ca3251b0a6f$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9c351ca3251b0a6f$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9c351ca3251b0a6f$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9c351ca3251b0a6f$var$ue(k);
                        u = null == n ? h : $9c351ca3251b0a6f$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9c351ca3251b0a6f$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9c351ca3251b0a6f$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9c351ca3251b0a6f$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9c351ca3251b0a6f$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9c351ca3251b0a6f$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9c351ca3251b0a6f$var$vf(t);
                                x = $9c351ca3251b0a6f$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9c351ca3251b0a6f$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9c351ca3251b0a6f$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9c351ca3251b0a6f$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9c351ca3251b0a6f$var$ve;
                else if ($9c351ca3251b0a6f$var$me(h)) {
                    if ($9c351ca3251b0a6f$var$we) na = $9c351ca3251b0a6f$var$Fe;
                    else {
                        na = $9c351ca3251b0a6f$var$De;
                        var xa = $9c351ca3251b0a6f$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9c351ca3251b0a6f$var$Ee);
                if (na && (na = na(a, d))) {
                    $9c351ca3251b0a6f$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9c351ca3251b0a6f$var$cb(h, "number", h.value);
            }
            xa = d ? $9c351ca3251b0a6f$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9c351ca3251b0a6f$var$me(xa) || "true" === xa.contentEditable) $9c351ca3251b0a6f$var$Qe = xa, $9c351ca3251b0a6f$var$Re = d, $9c351ca3251b0a6f$var$Se = null;
                    break;
                case "focusout":
                    $9c351ca3251b0a6f$var$Se = $9c351ca3251b0a6f$var$Re = $9c351ca3251b0a6f$var$Qe = null;
                    break;
                case "mousedown":
                    $9c351ca3251b0a6f$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9c351ca3251b0a6f$var$Te = !1;
                    $9c351ca3251b0a6f$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9c351ca3251b0a6f$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9c351ca3251b0a6f$var$Ue(g, c, e);
            }
            var $a;
            if ($9c351ca3251b0a6f$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9c351ca3251b0a6f$var$ie ? $9c351ca3251b0a6f$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9c351ca3251b0a6f$var$de && "ko" !== c.locale && ($9c351ca3251b0a6f$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9c351ca3251b0a6f$var$ie && ($a = $9c351ca3251b0a6f$var$nd()) : ($9c351ca3251b0a6f$var$kd = e, $9c351ca3251b0a6f$var$ld = "value" in $9c351ca3251b0a6f$var$kd ? $9c351ca3251b0a6f$var$kd.value : $9c351ca3251b0a6f$var$kd.textContent, $9c351ca3251b0a6f$var$ie = !0)), xa = $9c351ca3251b0a6f$var$oe(d, ba), 0 < xa.length && (ba = new $9c351ca3251b0a6f$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9c351ca3251b0a6f$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9c351ca3251b0a6f$var$ce ? $9c351ca3251b0a6f$var$je(a, c) : $9c351ca3251b0a6f$var$ke(a, c)) d = $9c351ca3251b0a6f$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9c351ca3251b0a6f$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9c351ca3251b0a6f$var$se(g, b);
    });
}
function $9c351ca3251b0a6f$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9c351ca3251b0a6f$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9c351ca3251b0a6f$var$Kb(a, c), null != f && d.unshift($9c351ca3251b0a6f$var$tf(a, f, e)), f = $9c351ca3251b0a6f$var$Kb(a, b), null != f && d.push($9c351ca3251b0a6f$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9c351ca3251b0a6f$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9c351ca3251b0a6f$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9c351ca3251b0a6f$var$Kb(c, f), null != k && g.unshift($9c351ca3251b0a6f$var$tf(c, k, h))) : e || (k = $9c351ca3251b0a6f$var$Kb(c, f), null != k && g.push($9c351ca3251b0a6f$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9c351ca3251b0a6f$var$xf = /\r\n?/g, $9c351ca3251b0a6f$var$yf = /\u0000|\uFFFD/g;
function $9c351ca3251b0a6f$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9c351ca3251b0a6f$var$xf, "\n").replace($9c351ca3251b0a6f$var$yf, "");
}
function $9c351ca3251b0a6f$var$Af(a, b, c) {
    b = $9c351ca3251b0a6f$var$zf(b);
    if ($9c351ca3251b0a6f$var$zf(a) !== b && c) throw Error($9c351ca3251b0a6f$var$p(425));
}
function $9c351ca3251b0a6f$var$Bf() {}
var $9c351ca3251b0a6f$var$Cf = null, $9c351ca3251b0a6f$var$Df = null;
function $9c351ca3251b0a6f$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9c351ca3251b0a6f$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9c351ca3251b0a6f$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9c351ca3251b0a6f$var$Hf = "function" === typeof Promise ? Promise : void 0, $9c351ca3251b0a6f$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9c351ca3251b0a6f$var$Hf ? function(a) {
    return $9c351ca3251b0a6f$var$Hf.resolve(null).then(a).catch($9c351ca3251b0a6f$var$If);
} : $9c351ca3251b0a6f$var$Ff;
function $9c351ca3251b0a6f$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9c351ca3251b0a6f$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9c351ca3251b0a6f$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9c351ca3251b0a6f$var$bd(b);
}
function $9c351ca3251b0a6f$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$Nf = Math.random().toString(36).slice(2), $9c351ca3251b0a6f$var$Of = "__reactFiber$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Pf = "__reactProps$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$uf = "__reactContainer$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$of = "__reactEvents$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Qf = "__reactListeners$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Rf = "__reactHandles$" + $9c351ca3251b0a6f$var$Nf;
function $9c351ca3251b0a6f$var$Wc(a) {
    var b = a[$9c351ca3251b0a6f$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9c351ca3251b0a6f$var$uf] || c[$9c351ca3251b0a6f$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9c351ca3251b0a6f$var$Mf(a); null !== a;){
                if (c = a[$9c351ca3251b0a6f$var$Of]) return c;
                a = $9c351ca3251b0a6f$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Cb(a) {
    a = a[$9c351ca3251b0a6f$var$Of] || a[$9c351ca3251b0a6f$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9c351ca3251b0a6f$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9c351ca3251b0a6f$var$p(33));
}
function $9c351ca3251b0a6f$var$Db(a) {
    return a[$9c351ca3251b0a6f$var$Pf] || null;
}
var $9c351ca3251b0a6f$var$Sf = [], $9c351ca3251b0a6f$var$Tf = -1;
function $9c351ca3251b0a6f$var$Uf(a) {
    return {
        current: a
    };
}
function $9c351ca3251b0a6f$var$E(a) {
    0 > $9c351ca3251b0a6f$var$Tf || (a.current = $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf], $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf] = null, $9c351ca3251b0a6f$var$Tf--);
}
function $9c351ca3251b0a6f$var$G(a, b) {
    $9c351ca3251b0a6f$var$Tf++;
    $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf] = a.current;
    a.current = b;
}
var $9c351ca3251b0a6f$var$Vf = {}, $9c351ca3251b0a6f$var$H = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$Vf), $9c351ca3251b0a6f$var$Wf = $9c351ca3251b0a6f$var$Uf(!1), $9c351ca3251b0a6f$var$Xf = $9c351ca3251b0a6f$var$Vf;
function $9c351ca3251b0a6f$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9c351ca3251b0a6f$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9c351ca3251b0a6f$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9c351ca3251b0a6f$var$$f() {
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
}
function $9c351ca3251b0a6f$var$ag(a, b, c) {
    if ($9c351ca3251b0a6f$var$H.current !== $9c351ca3251b0a6f$var$Vf) throw Error($9c351ca3251b0a6f$var$p(168));
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, b);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, c);
}
function $9c351ca3251b0a6f$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9c351ca3251b0a6f$var$p(108, $9c351ca3251b0a6f$var$Ra(a) || "Unknown", e));
    return $9c351ca3251b0a6f$var$A({}, c, d);
}
function $9c351ca3251b0a6f$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9c351ca3251b0a6f$var$Vf;
    $9c351ca3251b0a6f$var$Xf = $9c351ca3251b0a6f$var$H.current;
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, a);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, $9c351ca3251b0a6f$var$Wf.current);
    return !0;
}
function $9c351ca3251b0a6f$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9c351ca3251b0a6f$var$p(169));
    c ? (a = $9c351ca3251b0a6f$var$bg(a, b, $9c351ca3251b0a6f$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H), $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, a)) : $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, c);
}
var $9c351ca3251b0a6f$var$eg = null, $9c351ca3251b0a6f$var$fg = !1, $9c351ca3251b0a6f$var$gg = !1;
function $9c351ca3251b0a6f$var$hg(a) {
    null === $9c351ca3251b0a6f$var$eg ? $9c351ca3251b0a6f$var$eg = [
        a
    ] : $9c351ca3251b0a6f$var$eg.push(a);
}
function $9c351ca3251b0a6f$var$ig(a) {
    $9c351ca3251b0a6f$var$fg = !0;
    $9c351ca3251b0a6f$var$hg(a);
}
function $9c351ca3251b0a6f$var$jg() {
    if (!$9c351ca3251b0a6f$var$gg && null !== $9c351ca3251b0a6f$var$eg) {
        $9c351ca3251b0a6f$var$gg = !0;
        var a = 0, b = $9c351ca3251b0a6f$var$C;
        try {
            var c = $9c351ca3251b0a6f$var$eg;
            for($9c351ca3251b0a6f$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9c351ca3251b0a6f$var$eg = null;
            $9c351ca3251b0a6f$var$fg = !1;
        } catch (e) {
            throw null !== $9c351ca3251b0a6f$var$eg && ($9c351ca3251b0a6f$var$eg = $9c351ca3251b0a6f$var$eg.slice(a + 1)), $9c351ca3251b0a6f$var$ac($9c351ca3251b0a6f$var$fc, $9c351ca3251b0a6f$var$jg), e;
        } finally{
            $9c351ca3251b0a6f$var$C = b, $9c351ca3251b0a6f$var$gg = !1;
        }
    }
    return null;
}
var $9c351ca3251b0a6f$var$kg = [], $9c351ca3251b0a6f$var$lg = 0, $9c351ca3251b0a6f$var$mg = null, $9c351ca3251b0a6f$var$ng = 0, $9c351ca3251b0a6f$var$og = [], $9c351ca3251b0a6f$var$pg = 0, $9c351ca3251b0a6f$var$qg = null, $9c351ca3251b0a6f$var$rg = 1, $9c351ca3251b0a6f$var$sg = "";
function $9c351ca3251b0a6f$var$tg(a, b) {
    $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg++] = $9c351ca3251b0a6f$var$ng;
    $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg++] = $9c351ca3251b0a6f$var$mg;
    $9c351ca3251b0a6f$var$mg = a;
    $9c351ca3251b0a6f$var$ng = b;
}
function $9c351ca3251b0a6f$var$ug(a, b, c) {
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$rg;
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$sg;
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$qg;
    $9c351ca3251b0a6f$var$qg = a;
    var d = $9c351ca3251b0a6f$var$rg;
    a = $9c351ca3251b0a6f$var$sg;
    var e = 32 - $9c351ca3251b0a6f$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9c351ca3251b0a6f$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9c351ca3251b0a6f$var$rg = 1 << 32 - $9c351ca3251b0a6f$var$oc(b) + e | c << e | d;
        $9c351ca3251b0a6f$var$sg = f + a;
    } else $9c351ca3251b0a6f$var$rg = 1 << f | c << e | d, $9c351ca3251b0a6f$var$sg = a;
}
function $9c351ca3251b0a6f$var$vg(a) {
    null !== a.return && ($9c351ca3251b0a6f$var$tg(a, 1), $9c351ca3251b0a6f$var$ug(a, 1, 0));
}
function $9c351ca3251b0a6f$var$wg(a) {
    for(; a === $9c351ca3251b0a6f$var$mg;)$9c351ca3251b0a6f$var$mg = $9c351ca3251b0a6f$var$kg[--$9c351ca3251b0a6f$var$lg], $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg] = null, $9c351ca3251b0a6f$var$ng = $9c351ca3251b0a6f$var$kg[--$9c351ca3251b0a6f$var$lg], $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg] = null;
    for(; a === $9c351ca3251b0a6f$var$qg;)$9c351ca3251b0a6f$var$qg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null, $9c351ca3251b0a6f$var$sg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null, $9c351ca3251b0a6f$var$rg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null;
}
var $9c351ca3251b0a6f$var$xg = null, $9c351ca3251b0a6f$var$yg = null, $9c351ca3251b0a6f$var$I = !1, $9c351ca3251b0a6f$var$zg = null;
function $9c351ca3251b0a6f$var$Ag(a, b) {
    var c = $9c351ca3251b0a6f$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9c351ca3251b0a6f$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9c351ca3251b0a6f$var$qg ? {
                id: $9c351ca3251b0a6f$var$rg,
                overflow: $9c351ca3251b0a6f$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9c351ca3251b0a6f$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9c351ca3251b0a6f$var$Eg(a) {
    if ($9c351ca3251b0a6f$var$I) {
        var b = $9c351ca3251b0a6f$var$yg;
        if (b) {
            var c = b;
            if (!$9c351ca3251b0a6f$var$Cg(a, b)) {
                if ($9c351ca3251b0a6f$var$Dg(a)) throw Error($9c351ca3251b0a6f$var$p(418));
                b = $9c351ca3251b0a6f$var$Lf(c.nextSibling);
                var d = $9c351ca3251b0a6f$var$xg;
                b && $9c351ca3251b0a6f$var$Cg(a, b) ? $9c351ca3251b0a6f$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9c351ca3251b0a6f$var$I = !1, $9c351ca3251b0a6f$var$xg = a);
            }
        } else {
            if ($9c351ca3251b0a6f$var$Dg(a)) throw Error($9c351ca3251b0a6f$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9c351ca3251b0a6f$var$I = !1;
            $9c351ca3251b0a6f$var$xg = a;
        }
    }
}
function $9c351ca3251b0a6f$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9c351ca3251b0a6f$var$xg = a;
}
function $9c351ca3251b0a6f$var$Gg(a) {
    if (a !== $9c351ca3251b0a6f$var$xg) return !1;
    if (!$9c351ca3251b0a6f$var$I) return $9c351ca3251b0a6f$var$Fg(a), $9c351ca3251b0a6f$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9c351ca3251b0a6f$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9c351ca3251b0a6f$var$yg)) {
        if ($9c351ca3251b0a6f$var$Dg(a)) throw $9c351ca3251b0a6f$var$Hg(), Error($9c351ca3251b0a6f$var$p(418));
        for(; b;)$9c351ca3251b0a6f$var$Ag(a, b), b = $9c351ca3251b0a6f$var$Lf(b.nextSibling);
    }
    $9c351ca3251b0a6f$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9c351ca3251b0a6f$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9c351ca3251b0a6f$var$yg = null;
        }
    } else $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$xg ? $9c351ca3251b0a6f$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9c351ca3251b0a6f$var$Hg() {
    for(var a = $9c351ca3251b0a6f$var$yg; a;)a = $9c351ca3251b0a6f$var$Lf(a.nextSibling);
}
function $9c351ca3251b0a6f$var$Ig() {
    $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$xg = null;
    $9c351ca3251b0a6f$var$I = !1;
}
function $9c351ca3251b0a6f$var$Jg(a) {
    null === $9c351ca3251b0a6f$var$zg ? $9c351ca3251b0a6f$var$zg = [
        a
    ] : $9c351ca3251b0a6f$var$zg.push(a);
}
var $9c351ca3251b0a6f$var$Kg = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig;
function $9c351ca3251b0a6f$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9c351ca3251b0a6f$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9c351ca3251b0a6f$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9c351ca3251b0a6f$var$p(284));
        if (!c._owner) throw Error($9c351ca3251b0a6f$var$p(290, a));
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9c351ca3251b0a6f$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9c351ca3251b0a6f$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9c351ca3251b0a6f$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9c351ca3251b0a6f$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9c351ca3251b0a6f$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9c351ca3251b0a6f$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9c351ca3251b0a6f$var$Ha && $9c351ca3251b0a6f$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9c351ca3251b0a6f$var$Lg(a, b, c), d.return = a, d;
        d = $9c351ca3251b0a6f$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9c351ca3251b0a6f$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9c351ca3251b0a6f$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9c351ca3251b0a6f$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9c351ca3251b0a6f$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return c = $9c351ca3251b0a6f$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9c351ca3251b0a6f$var$Lg(a, null, b), c.return = a, c;
                case $9c351ca3251b0a6f$var$wa:
                    return b = $9c351ca3251b0a6f$var$Sg(b, a.mode, c), b.return = a, b;
                case $9c351ca3251b0a6f$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9c351ca3251b0a6f$var$eb(b) || $9c351ca3251b0a6f$var$Ka(b)) return b = $9c351ca3251b0a6f$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9c351ca3251b0a6f$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9c351ca3251b0a6f$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9c351ca3251b0a6f$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9c351ca3251b0a6f$var$eb(c) || $9c351ca3251b0a6f$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9c351ca3251b0a6f$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9c351ca3251b0a6f$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9c351ca3251b0a6f$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9c351ca3251b0a6f$var$eb(d) || $9c351ca3251b0a6f$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9c351ca3251b0a6f$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9c351ca3251b0a6f$var$Ka(h);
        if ("function" !== typeof l) throw Error($9c351ca3251b0a6f$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9c351ca3251b0a6f$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9c351ca3251b0a6f$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9c351ca3251b0a6f$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9c351ca3251b0a6f$var$Ha && $9c351ca3251b0a6f$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9c351ca3251b0a6f$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9c351ca3251b0a6f$var$ya ? (d = $9c351ca3251b0a6f$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9c351ca3251b0a6f$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9c351ca3251b0a6f$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9c351ca3251b0a6f$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9c351ca3251b0a6f$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9c351ca3251b0a6f$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9c351ca3251b0a6f$var$eb(f)) return n(a, d, f, h);
            if ($9c351ca3251b0a6f$var$Ka(f)) return t(a, d, f, h);
            $9c351ca3251b0a6f$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9c351ca3251b0a6f$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9c351ca3251b0a6f$var$Ug = $9c351ca3251b0a6f$var$Og(!0), $9c351ca3251b0a6f$var$Vg = $9c351ca3251b0a6f$var$Og(!1), $9c351ca3251b0a6f$var$Wg = $9c351ca3251b0a6f$var$Uf(null), $9c351ca3251b0a6f$var$Xg = null, $9c351ca3251b0a6f$var$Yg = null, $9c351ca3251b0a6f$var$Zg = null;
function $9c351ca3251b0a6f$var$$g() {
    $9c351ca3251b0a6f$var$Zg = $9c351ca3251b0a6f$var$Yg = $9c351ca3251b0a6f$var$Xg = null;
}
function $9c351ca3251b0a6f$var$ah(a) {
    var b = $9c351ca3251b0a6f$var$Wg.current;
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wg);
    a._currentValue = b;
}
function $9c351ca3251b0a6f$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9c351ca3251b0a6f$var$ch(a, b) {
    $9c351ca3251b0a6f$var$Xg = a;
    $9c351ca3251b0a6f$var$Zg = $9c351ca3251b0a6f$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9c351ca3251b0a6f$var$dh = !0), a.firstContext = null);
}
function $9c351ca3251b0a6f$var$eh(a) {
    var b = a._currentValue;
    if ($9c351ca3251b0a6f$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9c351ca3251b0a6f$var$Yg) {
            if (null === $9c351ca3251b0a6f$var$Xg) throw Error($9c351ca3251b0a6f$var$p(308));
            $9c351ca3251b0a6f$var$Yg = a;
            $9c351ca3251b0a6f$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9c351ca3251b0a6f$var$Yg = $9c351ca3251b0a6f$var$Yg.next = a;
    }
    return b;
}
var $9c351ca3251b0a6f$var$fh = null;
function $9c351ca3251b0a6f$var$gh(a) {
    null === $9c351ca3251b0a6f$var$fh ? $9c351ca3251b0a6f$var$fh = [
        a
    ] : $9c351ca3251b0a6f$var$fh.push(a);
}
function $9c351ca3251b0a6f$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9c351ca3251b0a6f$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9c351ca3251b0a6f$var$ih(a, d);
}
function $9c351ca3251b0a6f$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9c351ca3251b0a6f$var$jh = !1;
function $9c351ca3251b0a6f$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9c351ca3251b0a6f$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9c351ca3251b0a6f$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9c351ca3251b0a6f$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9c351ca3251b0a6f$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9c351ca3251b0a6f$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9c351ca3251b0a6f$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9c351ca3251b0a6f$var$ih(a, c);
}
function $9c351ca3251b0a6f$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9c351ca3251b0a6f$var$Cc(a, c);
    }
}
function $9c351ca3251b0a6f$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9c351ca3251b0a6f$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9c351ca3251b0a6f$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9c351ca3251b0a6f$var$A({}, q, r);
                            break a;
                        case 2:
                            $9c351ca3251b0a6f$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9c351ca3251b0a6f$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9c351ca3251b0a6f$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9c351ca3251b0a6f$var$p(191, e));
            e.call(d);
        }
    }
}
var $9c351ca3251b0a6f$var$th = {}, $9c351ca3251b0a6f$var$uh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th), $9c351ca3251b0a6f$var$vh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th), $9c351ca3251b0a6f$var$wh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th);
function $9c351ca3251b0a6f$var$xh(a) {
    if (a === $9c351ca3251b0a6f$var$th) throw Error($9c351ca3251b0a6f$var$p(174));
    return a;
}
function $9c351ca3251b0a6f$var$yh(a, b) {
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$wh, b);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$vh, a);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, $9c351ca3251b0a6f$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9c351ca3251b0a6f$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9c351ca3251b0a6f$var$lb(b, a);
    }
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, b);
}
function $9c351ca3251b0a6f$var$zh() {
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$vh);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$wh);
}
function $9c351ca3251b0a6f$var$Ah(a) {
    $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
    var b = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
    var c = $9c351ca3251b0a6f$var$lb(b, a.type);
    b !== c && ($9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$vh, a), $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, c));
}
function $9c351ca3251b0a6f$var$Bh(a) {
    $9c351ca3251b0a6f$var$vh.current === a && ($9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$vh));
}
var $9c351ca3251b0a6f$var$L = $9c351ca3251b0a6f$var$Uf(0);
function $9c351ca3251b0a6f$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$Dh = [];
function $9c351ca3251b0a6f$var$Eh() {
    for(var a = 0; a < $9c351ca3251b0a6f$var$Dh.length; a++)$9c351ca3251b0a6f$var$Dh[a]._workInProgressVersionPrimary = null;
    $9c351ca3251b0a6f$var$Dh.length = 0;
}
var $9c351ca3251b0a6f$var$Fh = $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher, $9c351ca3251b0a6f$var$Gh = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$Hh = 0, $9c351ca3251b0a6f$var$M = null, $9c351ca3251b0a6f$var$N = null, $9c351ca3251b0a6f$var$O = null, $9c351ca3251b0a6f$var$Ih = !1, $9c351ca3251b0a6f$var$Jh = !1, $9c351ca3251b0a6f$var$Kh = 0, $9c351ca3251b0a6f$var$Lh = 0;
function $9c351ca3251b0a6f$var$P() {
    throw Error($9c351ca3251b0a6f$var$p(321));
}
function $9c351ca3251b0a6f$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9c351ca3251b0a6f$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9c351ca3251b0a6f$var$Nh(a, b, c, d, e, f) {
    $9c351ca3251b0a6f$var$Hh = f;
    $9c351ca3251b0a6f$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9c351ca3251b0a6f$var$Fh.current = null === a || null === a.memoizedState ? $9c351ca3251b0a6f$var$Oh : $9c351ca3251b0a6f$var$Ph;
    a = c(d, e);
    if ($9c351ca3251b0a6f$var$Jh) {
        f = 0;
        do {
            $9c351ca3251b0a6f$var$Jh = !1;
            $9c351ca3251b0a6f$var$Kh = 0;
            if (25 <= f) throw Error($9c351ca3251b0a6f$var$p(301));
            f += 1;
            $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = null;
            b.updateQueue = null;
            $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Qh;
            a = c(d, e);
        }while ($9c351ca3251b0a6f$var$Jh);
    }
    $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Rh;
    b = null !== $9c351ca3251b0a6f$var$N && null !== $9c351ca3251b0a6f$var$N.next;
    $9c351ca3251b0a6f$var$Hh = 0;
    $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = $9c351ca3251b0a6f$var$M = null;
    $9c351ca3251b0a6f$var$Ih = !1;
    if (b) throw Error($9c351ca3251b0a6f$var$p(300));
    return a;
}
function $9c351ca3251b0a6f$var$Sh() {
    var a = 0 !== $9c351ca3251b0a6f$var$Kh;
    $9c351ca3251b0a6f$var$Kh = 0;
    return a;
}
function $9c351ca3251b0a6f$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState = $9c351ca3251b0a6f$var$O = a : $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$O.next = a;
    return $9c351ca3251b0a6f$var$O;
}
function $9c351ca3251b0a6f$var$Uh() {
    if (null === $9c351ca3251b0a6f$var$N) {
        var a = $9c351ca3251b0a6f$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9c351ca3251b0a6f$var$N.next;
    var b = null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState : $9c351ca3251b0a6f$var$O.next;
    if (null !== b) $9c351ca3251b0a6f$var$O = b, $9c351ca3251b0a6f$var$N = a;
    else {
        if (null === a) throw Error($9c351ca3251b0a6f$var$p(310));
        $9c351ca3251b0a6f$var$N = a;
        a = {
            memoizedState: $9c351ca3251b0a6f$var$N.memoizedState,
            baseState: $9c351ca3251b0a6f$var$N.baseState,
            baseQueue: $9c351ca3251b0a6f$var$N.baseQueue,
            queue: $9c351ca3251b0a6f$var$N.queue,
            next: null
        };
        null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState = $9c351ca3251b0a6f$var$O = a : $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$O.next = a;
    }
    return $9c351ca3251b0a6f$var$O;
}
function $9c351ca3251b0a6f$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9c351ca3251b0a6f$var$Wh(a) {
    var b = $9c351ca3251b0a6f$var$Uh(), c = b.queue;
    if (null === c) throw Error($9c351ca3251b0a6f$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9c351ca3251b0a6f$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9c351ca3251b0a6f$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9c351ca3251b0a6f$var$M.lanes |= m;
                $9c351ca3251b0a6f$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9c351ca3251b0a6f$var$He(d, b.memoizedState) || ($9c351ca3251b0a6f$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9c351ca3251b0a6f$var$M.lanes |= f, $9c351ca3251b0a6f$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9c351ca3251b0a6f$var$Xh(a) {
    var b = $9c351ca3251b0a6f$var$Uh(), c = b.queue;
    if (null === c) throw Error($9c351ca3251b0a6f$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9c351ca3251b0a6f$var$He(f, b.memoizedState) || ($9c351ca3251b0a6f$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9c351ca3251b0a6f$var$Yh() {}
function $9c351ca3251b0a6f$var$Zh(a, b) {
    var c = $9c351ca3251b0a6f$var$M, d = $9c351ca3251b0a6f$var$Uh(), e = b(), f = !$9c351ca3251b0a6f$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9c351ca3251b0a6f$var$dh = !0);
    d = d.queue;
    $9c351ca3251b0a6f$var$$h($9c351ca3251b0a6f$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9c351ca3251b0a6f$var$O && $9c351ca3251b0a6f$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9c351ca3251b0a6f$var$bi(9, $9c351ca3251b0a6f$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9c351ca3251b0a6f$var$Q) throw Error($9c351ca3251b0a6f$var$p(349));
        0 !== ($9c351ca3251b0a6f$var$Hh & 30) || $9c351ca3251b0a6f$var$di(c, b, e);
    }
    return e;
}
function $9c351ca3251b0a6f$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9c351ca3251b0a6f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9c351ca3251b0a6f$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9c351ca3251b0a6f$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9c351ca3251b0a6f$var$ei(b) && $9c351ca3251b0a6f$var$fi(a);
}
function $9c351ca3251b0a6f$var$ai(a, b, c) {
    return c(function() {
        $9c351ca3251b0a6f$var$ei(b) && $9c351ca3251b0a6f$var$fi(a);
    });
}
function $9c351ca3251b0a6f$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9c351ca3251b0a6f$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9c351ca3251b0a6f$var$fi(a) {
    var b = $9c351ca3251b0a6f$var$ih(a, 1);
    null !== b && $9c351ca3251b0a6f$var$gi(b, a, 1, -1);
}
function $9c351ca3251b0a6f$var$hi(a) {
    var b = $9c351ca3251b0a6f$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9c351ca3251b0a6f$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9c351ca3251b0a6f$var$ii.bind(null, $9c351ca3251b0a6f$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9c351ca3251b0a6f$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9c351ca3251b0a6f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9c351ca3251b0a6f$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9c351ca3251b0a6f$var$ji() {
    return $9c351ca3251b0a6f$var$Uh().memoizedState;
}
function $9c351ca3251b0a6f$var$ki(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$Th();
    $9c351ca3251b0a6f$var$M.flags |= a;
    e.memoizedState = $9c351ca3251b0a6f$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9c351ca3251b0a6f$var$li(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9c351ca3251b0a6f$var$N) {
        var g = $9c351ca3251b0a6f$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9c351ca3251b0a6f$var$Mh(d, g.deps)) {
            e.memoizedState = $9c351ca3251b0a6f$var$bi(b, c, f, d);
            return;
        }
    }
    $9c351ca3251b0a6f$var$M.flags |= a;
    e.memoizedState = $9c351ca3251b0a6f$var$bi(1 | b, c, f, d);
}
function $9c351ca3251b0a6f$var$mi(a, b) {
    return $9c351ca3251b0a6f$var$ki(8390656, 8, a, b);
}
function $9c351ca3251b0a6f$var$$h(a, b) {
    return $9c351ca3251b0a6f$var$li(2048, 8, a, b);
}
function $9c351ca3251b0a6f$var$ni(a, b) {
    return $9c351ca3251b0a6f$var$li(4, 2, a, b);
}
function $9c351ca3251b0a6f$var$oi(a, b) {
    return $9c351ca3251b0a6f$var$li(4, 4, a, b);
}
function $9c351ca3251b0a6f$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9c351ca3251b0a6f$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9c351ca3251b0a6f$var$li(4, 4, $9c351ca3251b0a6f$var$pi.bind(null, b, a), c);
}
function $9c351ca3251b0a6f$var$ri() {}
function $9c351ca3251b0a6f$var$si(a, b) {
    var c = $9c351ca3251b0a6f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9c351ca3251b0a6f$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c351ca3251b0a6f$var$ti(a, b) {
    var c = $9c351ca3251b0a6f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9c351ca3251b0a6f$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c351ca3251b0a6f$var$ui(a, b, c) {
    if (0 === ($9c351ca3251b0a6f$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9c351ca3251b0a6f$var$dh = !0), a.memoizedState = c;
    $9c351ca3251b0a6f$var$He(c, b) || (c = $9c351ca3251b0a6f$var$yc(), $9c351ca3251b0a6f$var$M.lanes |= c, $9c351ca3251b0a6f$var$rh |= c, a.baseState = !0);
    return b;
}
function $9c351ca3251b0a6f$var$vi(a, b) {
    var c = $9c351ca3251b0a6f$var$C;
    $9c351ca3251b0a6f$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9c351ca3251b0a6f$var$Gh.transition;
    $9c351ca3251b0a6f$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9c351ca3251b0a6f$var$C = c, $9c351ca3251b0a6f$var$Gh.transition = d;
    }
}
function $9c351ca3251b0a6f$var$wi() {
    return $9c351ca3251b0a6f$var$Uh().memoizedState;
}
function $9c351ca3251b0a6f$var$xi(a, b, c) {
    var d = $9c351ca3251b0a6f$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9c351ca3251b0a6f$var$zi(a)) $9c351ca3251b0a6f$var$Ai(b, c);
    else if (c = $9c351ca3251b0a6f$var$hh(a, b, c, d), null !== c) {
        var e = $9c351ca3251b0a6f$var$R();
        $9c351ca3251b0a6f$var$gi(c, a, d, e);
        $9c351ca3251b0a6f$var$Bi(c, b, d);
    }
}
function $9c351ca3251b0a6f$var$ii(a, b, c) {
    var d = $9c351ca3251b0a6f$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9c351ca3251b0a6f$var$zi(a)) $9c351ca3251b0a6f$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9c351ca3251b0a6f$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9c351ca3251b0a6f$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9c351ca3251b0a6f$var$hh(a, b, e, d);
        null !== c && (e = $9c351ca3251b0a6f$var$R(), $9c351ca3251b0a6f$var$gi(c, a, d, e), $9c351ca3251b0a6f$var$Bi(c, b, d));
    }
}
function $9c351ca3251b0a6f$var$zi(a) {
    var b = a.alternate;
    return a === $9c351ca3251b0a6f$var$M || null !== b && b === $9c351ca3251b0a6f$var$M;
}
function $9c351ca3251b0a6f$var$Ai(a, b) {
    $9c351ca3251b0a6f$var$Jh = $9c351ca3251b0a6f$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9c351ca3251b0a6f$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9c351ca3251b0a6f$var$Cc(a, c);
    }
}
var $9c351ca3251b0a6f$var$Rh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$P,
    useContext: $9c351ca3251b0a6f$var$P,
    useEffect: $9c351ca3251b0a6f$var$P,
    useImperativeHandle: $9c351ca3251b0a6f$var$P,
    useInsertionEffect: $9c351ca3251b0a6f$var$P,
    useLayoutEffect: $9c351ca3251b0a6f$var$P,
    useMemo: $9c351ca3251b0a6f$var$P,
    useReducer: $9c351ca3251b0a6f$var$P,
    useRef: $9c351ca3251b0a6f$var$P,
    useState: $9c351ca3251b0a6f$var$P,
    useDebugValue: $9c351ca3251b0a6f$var$P,
    useDeferredValue: $9c351ca3251b0a6f$var$P,
    useTransition: $9c351ca3251b0a6f$var$P,
    useMutableSource: $9c351ca3251b0a6f$var$P,
    useSyncExternalStore: $9c351ca3251b0a6f$var$P,
    useId: $9c351ca3251b0a6f$var$P,
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Oh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: function(a, b) {
        $9c351ca3251b0a6f$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9c351ca3251b0a6f$var$ki(4194308, 4, $9c351ca3251b0a6f$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9c351ca3251b0a6f$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9c351ca3251b0a6f$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9c351ca3251b0a6f$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9c351ca3251b0a6f$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9c351ca3251b0a6f$var$xi.bind(null, $9c351ca3251b0a6f$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9c351ca3251b0a6f$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9c351ca3251b0a6f$var$hi,
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        return $9c351ca3251b0a6f$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$hi(!1), b = a[0];
        a = $9c351ca3251b0a6f$var$vi.bind(null, a[1]);
        $9c351ca3251b0a6f$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9c351ca3251b0a6f$var$M, e = $9c351ca3251b0a6f$var$Th();
        if ($9c351ca3251b0a6f$var$I) {
            if (void 0 === c) throw Error($9c351ca3251b0a6f$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9c351ca3251b0a6f$var$Q) throw Error($9c351ca3251b0a6f$var$p(349));
            0 !== ($9c351ca3251b0a6f$var$Hh & 30) || $9c351ca3251b0a6f$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9c351ca3251b0a6f$var$mi($9c351ca3251b0a6f$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9c351ca3251b0a6f$var$bi(9, $9c351ca3251b0a6f$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9c351ca3251b0a6f$var$Th(), b = $9c351ca3251b0a6f$var$Q.identifierPrefix;
        if ($9c351ca3251b0a6f$var$I) {
            var c = $9c351ca3251b0a6f$var$sg;
            var d = $9c351ca3251b0a6f$var$rg;
            c = (d & ~(1 << 32 - $9c351ca3251b0a6f$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9c351ca3251b0a6f$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9c351ca3251b0a6f$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Ph = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$si,
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$$h,
    useImperativeHandle: $9c351ca3251b0a6f$var$qi,
    useInsertionEffect: $9c351ca3251b0a6f$var$ni,
    useLayoutEffect: $9c351ca3251b0a6f$var$oi,
    useMemo: $9c351ca3251b0a6f$var$ti,
    useReducer: $9c351ca3251b0a6f$var$Wh,
    useRef: $9c351ca3251b0a6f$var$ji,
    useState: function() {
        return $9c351ca3251b0a6f$var$Wh($9c351ca3251b0a6f$var$Vh);
    },
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        var b = $9c351ca3251b0a6f$var$Uh();
        return $9c351ca3251b0a6f$var$ui(b, $9c351ca3251b0a6f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$Wh($9c351ca3251b0a6f$var$Vh)[0], b = $9c351ca3251b0a6f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9c351ca3251b0a6f$var$Yh,
    useSyncExternalStore: $9c351ca3251b0a6f$var$Zh,
    useId: $9c351ca3251b0a6f$var$wi,
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Qh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$si,
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$$h,
    useImperativeHandle: $9c351ca3251b0a6f$var$qi,
    useInsertionEffect: $9c351ca3251b0a6f$var$ni,
    useLayoutEffect: $9c351ca3251b0a6f$var$oi,
    useMemo: $9c351ca3251b0a6f$var$ti,
    useReducer: $9c351ca3251b0a6f$var$Xh,
    useRef: $9c351ca3251b0a6f$var$ji,
    useState: function() {
        return $9c351ca3251b0a6f$var$Xh($9c351ca3251b0a6f$var$Vh);
    },
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        var b = $9c351ca3251b0a6f$var$Uh();
        return null === $9c351ca3251b0a6f$var$N ? b.memoizedState = a : $9c351ca3251b0a6f$var$ui(b, $9c351ca3251b0a6f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$Xh($9c351ca3251b0a6f$var$Vh)[0], b = $9c351ca3251b0a6f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9c351ca3251b0a6f$var$Yh,
    useSyncExternalStore: $9c351ca3251b0a6f$var$Zh,
    useId: $9c351ca3251b0a6f$var$wi,
    unstable_isNewReconciler: !1
};
function $9c351ca3251b0a6f$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9c351ca3251b0a6f$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9c351ca3251b0a6f$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9c351ca3251b0a6f$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9c351ca3251b0a6f$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9c351ca3251b0a6f$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9c351ca3251b0a6f$var$R(), e = $9c351ca3251b0a6f$var$yi(a), f = $9c351ca3251b0a6f$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9c351ca3251b0a6f$var$nh(a, f, e);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, e, d), $9c351ca3251b0a6f$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9c351ca3251b0a6f$var$R(), e = $9c351ca3251b0a6f$var$yi(a), f = $9c351ca3251b0a6f$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9c351ca3251b0a6f$var$nh(a, f, e);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, e, d), $9c351ca3251b0a6f$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9c351ca3251b0a6f$var$R(), d = $9c351ca3251b0a6f$var$yi(a), e = $9c351ca3251b0a6f$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9c351ca3251b0a6f$var$nh(a, e, d);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, d, c), $9c351ca3251b0a6f$var$oh(b, a, d));
    }
};
function $9c351ca3251b0a6f$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9c351ca3251b0a6f$var$Ie(c, d) || !$9c351ca3251b0a6f$var$Ie(e, f) : !0;
}
function $9c351ca3251b0a6f$var$Gi(a, b, c) {
    var d = !1, e = $9c351ca3251b0a6f$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9c351ca3251b0a6f$var$eh(f) : (e = $9c351ca3251b0a6f$var$Zf(b) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9c351ca3251b0a6f$var$Yf(a, e) : $9c351ca3251b0a6f$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9c351ca3251b0a6f$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9c351ca3251b0a6f$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9c351ca3251b0a6f$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9c351ca3251b0a6f$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9c351ca3251b0a6f$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9c351ca3251b0a6f$var$eh(f) : (f = $9c351ca3251b0a6f$var$Zf(b) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, e.context = $9c351ca3251b0a6f$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9c351ca3251b0a6f$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9c351ca3251b0a6f$var$Ei.enqueueReplaceState(e, e.state, null), $9c351ca3251b0a6f$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9c351ca3251b0a6f$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9c351ca3251b0a6f$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9c351ca3251b0a6f$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9c351ca3251b0a6f$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9c351ca3251b0a6f$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9c351ca3251b0a6f$var$Ni(a, b, c) {
    c = $9c351ca3251b0a6f$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9c351ca3251b0a6f$var$Oi || ($9c351ca3251b0a6f$var$Oi = !0, $9c351ca3251b0a6f$var$Pi = d);
        $9c351ca3251b0a6f$var$Li(a, b);
    };
    return c;
}
function $9c351ca3251b0a6f$var$Qi(a, b, c) {
    c = $9c351ca3251b0a6f$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9c351ca3251b0a6f$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9c351ca3251b0a6f$var$Li(a, b);
        "function" !== typeof d && (null === $9c351ca3251b0a6f$var$Ri ? $9c351ca3251b0a6f$var$Ri = new Set([
            this
        ]) : $9c351ca3251b0a6f$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9c351ca3251b0a6f$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9c351ca3251b0a6f$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9c351ca3251b0a6f$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9c351ca3251b0a6f$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9c351ca3251b0a6f$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9c351ca3251b0a6f$var$mh(-1, 1), b.tag = 2, $9c351ca3251b0a6f$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9c351ca3251b0a6f$var$Wi = $9c351ca3251b0a6f$var$ua.ReactCurrentOwner, $9c351ca3251b0a6f$var$dh = !1;
function $9c351ca3251b0a6f$var$Xi(a, b, c, d) {
    b.child = null === a ? $9c351ca3251b0a6f$var$Vg(b, null, c, d) : $9c351ca3251b0a6f$var$Ug(b, a.child, c, d);
}
function $9c351ca3251b0a6f$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9c351ca3251b0a6f$var$ch(b, e);
    d = $9c351ca3251b0a6f$var$Nh(a, b, c, d, f, e);
    c = $9c351ca3251b0a6f$var$Sh();
    if (null !== a && !$9c351ca3251b0a6f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9c351ca3251b0a6f$var$Zi(a, b, e);
    $9c351ca3251b0a6f$var$I && c && $9c351ca3251b0a6f$var$vg(b);
    b.flags |= 1;
    $9c351ca3251b0a6f$var$Xi(a, b, d, e);
    return b.child;
}
function $9c351ca3251b0a6f$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9c351ca3251b0a6f$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9c351ca3251b0a6f$var$bj(a, b, f, d, e);
        a = $9c351ca3251b0a6f$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9c351ca3251b0a6f$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9c351ca3251b0a6f$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9c351ca3251b0a6f$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9c351ca3251b0a6f$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9c351ca3251b0a6f$var$Ie(f, d) && a.ref === b.ref) {
            if ($9c351ca3251b0a6f$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9c351ca3251b0a6f$var$dh = !0);
            else return b.lanes = a.lanes, $9c351ca3251b0a6f$var$Zi(a, b, e);
        }
    }
    return $9c351ca3251b0a6f$var$cj(a, b, c, d, e);
}
function $9c351ca3251b0a6f$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj);
            $9c351ca3251b0a6f$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= d;
    $9c351ca3251b0a6f$var$Xi(a, b, e, c);
    return b.child;
}
function $9c351ca3251b0a6f$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9c351ca3251b0a6f$var$cj(a, b, c, d, e) {
    var f = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current;
    f = $9c351ca3251b0a6f$var$Yf(b, f);
    $9c351ca3251b0a6f$var$ch(b, e);
    c = $9c351ca3251b0a6f$var$Nh(a, b, c, d, f, e);
    d = $9c351ca3251b0a6f$var$Sh();
    if (null !== a && !$9c351ca3251b0a6f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9c351ca3251b0a6f$var$Zi(a, b, e);
    $9c351ca3251b0a6f$var$I && d && $9c351ca3251b0a6f$var$vg(b);
    b.flags |= 1;
    $9c351ca3251b0a6f$var$Xi(a, b, c, e);
    return b.child;
}
function $9c351ca3251b0a6f$var$hj(a, b, c, d, e) {
    if ($9c351ca3251b0a6f$var$Zf(c)) {
        var f = !0;
        $9c351ca3251b0a6f$var$cg(b);
    } else f = !1;
    $9c351ca3251b0a6f$var$ch(b, e);
    if (null === b.stateNode) $9c351ca3251b0a6f$var$ij(a, b), $9c351ca3251b0a6f$var$Gi(b, c, d), $9c351ca3251b0a6f$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9c351ca3251b0a6f$var$eh(l) : (l = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, l = $9c351ca3251b0a6f$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9c351ca3251b0a6f$var$Hi(b, g, d, l);
        $9c351ca3251b0a6f$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9c351ca3251b0a6f$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9c351ca3251b0a6f$var$Wf.current || $9c351ca3251b0a6f$var$jh ? ("function" === typeof m && ($9c351ca3251b0a6f$var$Di(b, c, m, d), k = b.memoizedState), (h = $9c351ca3251b0a6f$var$jh || $9c351ca3251b0a6f$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9c351ca3251b0a6f$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9c351ca3251b0a6f$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9c351ca3251b0a6f$var$eh(k) : (k = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, k = $9c351ca3251b0a6f$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9c351ca3251b0a6f$var$Hi(b, g, d, k);
        $9c351ca3251b0a6f$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9c351ca3251b0a6f$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9c351ca3251b0a6f$var$Wf.current || $9c351ca3251b0a6f$var$jh ? ("function" === typeof y && ($9c351ca3251b0a6f$var$Di(b, c, y, d), n = b.memoizedState), (l = $9c351ca3251b0a6f$var$jh || $9c351ca3251b0a6f$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9c351ca3251b0a6f$var$jj(a, b, c, d, f, e);
}
function $9c351ca3251b0a6f$var$jj(a, b, c, d, e, f) {
    $9c351ca3251b0a6f$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9c351ca3251b0a6f$var$dg(b, c, !1), $9c351ca3251b0a6f$var$Zi(a, b, f);
    d = b.stateNode;
    $9c351ca3251b0a6f$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9c351ca3251b0a6f$var$Ug(b, a.child, null, f), b.child = $9c351ca3251b0a6f$var$Ug(b, null, h, f)) : $9c351ca3251b0a6f$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9c351ca3251b0a6f$var$dg(b, c, !0);
    return b.child;
}
function $9c351ca3251b0a6f$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9c351ca3251b0a6f$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9c351ca3251b0a6f$var$ag(a, b.context, !1);
    $9c351ca3251b0a6f$var$yh(a, b.containerInfo);
}
function $9c351ca3251b0a6f$var$lj(a, b, c, d, e) {
    $9c351ca3251b0a6f$var$Ig();
    $9c351ca3251b0a6f$var$Jg(e);
    b.flags |= 256;
    $9c351ca3251b0a6f$var$Xi(a, b, c, d);
    return b.child;
}
var $9c351ca3251b0a6f$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9c351ca3251b0a6f$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9c351ca3251b0a6f$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9c351ca3251b0a6f$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, e & 1);
    if (null === a) {
        $9c351ca3251b0a6f$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9c351ca3251b0a6f$var$pj(g, d, 0, null), a = $9c351ca3251b0a6f$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9c351ca3251b0a6f$var$nj(c), b.memoizedState = $9c351ca3251b0a6f$var$mj, a) : $9c351ca3251b0a6f$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9c351ca3251b0a6f$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9c351ca3251b0a6f$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9c351ca3251b0a6f$var$Pg(h, f) : (f = $9c351ca3251b0a6f$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9c351ca3251b0a6f$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9c351ca3251b0a6f$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9c351ca3251b0a6f$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9c351ca3251b0a6f$var$qj(a, b) {
    b = $9c351ca3251b0a6f$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9c351ca3251b0a6f$var$sj(a, b, c, d) {
    null !== d && $9c351ca3251b0a6f$var$Jg(d);
    $9c351ca3251b0a6f$var$Ug(b, a.child, null, c);
    a = $9c351ca3251b0a6f$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9c351ca3251b0a6f$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9c351ca3251b0a6f$var$Ki(Error($9c351ca3251b0a6f$var$p(422))), $9c351ca3251b0a6f$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9c351ca3251b0a6f$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9c351ca3251b0a6f$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9c351ca3251b0a6f$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9c351ca3251b0a6f$var$nj(g);
        b.memoizedState = $9c351ca3251b0a6f$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9c351ca3251b0a6f$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9c351ca3251b0a6f$var$p(419));
        d = $9c351ca3251b0a6f$var$Ki(f, d, void 0);
        return $9c351ca3251b0a6f$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9c351ca3251b0a6f$var$dh || h) {
        d = $9c351ca3251b0a6f$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9c351ca3251b0a6f$var$ih(a, e), $9c351ca3251b0a6f$var$gi(d, a, e, -1));
        }
        $9c351ca3251b0a6f$var$tj();
        d = $9c351ca3251b0a6f$var$Ki(Error($9c351ca3251b0a6f$var$p(421)));
        return $9c351ca3251b0a6f$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9c351ca3251b0a6f$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(e.nextSibling);
    $9c351ca3251b0a6f$var$xg = b;
    $9c351ca3251b0a6f$var$I = !0;
    $9c351ca3251b0a6f$var$zg = null;
    null !== a && ($9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$rg, $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$sg, $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$qg, $9c351ca3251b0a6f$var$rg = a.id, $9c351ca3251b0a6f$var$sg = a.overflow, $9c351ca3251b0a6f$var$qg = b);
    b = $9c351ca3251b0a6f$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9c351ca3251b0a6f$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9c351ca3251b0a6f$var$bh(a.return, b, c);
}
function $9c351ca3251b0a6f$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9c351ca3251b0a6f$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9c351ca3251b0a6f$var$Xi(a, b, d.children, c);
    d = $9c351ca3251b0a6f$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9c351ca3251b0a6f$var$vj(a, c, b);
            else if (19 === a.tag) $9c351ca3251b0a6f$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9c351ca3251b0a6f$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9c351ca3251b0a6f$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9c351ca3251b0a6f$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9c351ca3251b0a6f$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9c351ca3251b0a6f$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9c351ca3251b0a6f$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9c351ca3251b0a6f$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9c351ca3251b0a6f$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9c351ca3251b0a6f$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9c351ca3251b0a6f$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9c351ca3251b0a6f$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9c351ca3251b0a6f$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9c351ca3251b0a6f$var$kj(b);
            $9c351ca3251b0a6f$var$Ig();
            break;
        case 5:
            $9c351ca3251b0a6f$var$Ah(b);
            break;
        case 1:
            $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$cg(b);
            break;
        case 4:
            $9c351ca3251b0a6f$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9c351ca3251b0a6f$var$oj(a, b, c);
                $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1);
                a = $9c351ca3251b0a6f$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9c351ca3251b0a6f$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9c351ca3251b0a6f$var$dj(a, b, c);
    }
    return $9c351ca3251b0a6f$var$Zi(a, b, c);
}
var $9c351ca3251b0a6f$var$zj, $9c351ca3251b0a6f$var$Aj, $9c351ca3251b0a6f$var$Bj, $9c351ca3251b0a6f$var$Cj;
$9c351ca3251b0a6f$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9c351ca3251b0a6f$var$Aj = function() {};
$9c351ca3251b0a6f$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9c351ca3251b0a6f$var$Ya(a, e);
                d = $9c351ca3251b0a6f$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9c351ca3251b0a6f$var$A({}, e, {
                    value: void 0
                });
                d = $9c351ca3251b0a6f$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9c351ca3251b0a6f$var$gb(a, e);
                d = $9c351ca3251b0a6f$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9c351ca3251b0a6f$var$Bf);
        }
        $9c351ca3251b0a6f$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9c351ca3251b0a6f$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9c351ca3251b0a6f$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9c351ca3251b0a6f$var$Dj(a, b) {
    if (!$9c351ca3251b0a6f$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9c351ca3251b0a6f$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9c351ca3251b0a6f$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9c351ca3251b0a6f$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9c351ca3251b0a6f$var$S(b), null;
        case 1:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), $9c351ca3251b0a6f$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9c351ca3251b0a6f$var$zh();
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
            $9c351ca3251b0a6f$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9c351ca3251b0a6f$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9c351ca3251b0a6f$var$zg && ($9c351ca3251b0a6f$var$Fj($9c351ca3251b0a6f$var$zg), $9c351ca3251b0a6f$var$zg = null));
            $9c351ca3251b0a6f$var$Aj(a, b);
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 5:
            $9c351ca3251b0a6f$var$Bh(b);
            var e = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9c351ca3251b0a6f$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9c351ca3251b0a6f$var$p(166));
                    $9c351ca3251b0a6f$var$S(b);
                    return null;
                }
                a = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
                if ($9c351ca3251b0a6f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9c351ca3251b0a6f$var$Of] = b;
                    d[$9c351ca3251b0a6f$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9c351ca3251b0a6f$var$D("cancel", d);
                            $9c351ca3251b0a6f$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9c351ca3251b0a6f$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9c351ca3251b0a6f$var$lf.length; e++)$9c351ca3251b0a6f$var$D($9c351ca3251b0a6f$var$lf[e], d);
                            break;
                        case "source":
                            $9c351ca3251b0a6f$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9c351ca3251b0a6f$var$D("error", d);
                            $9c351ca3251b0a6f$var$D("load", d);
                            break;
                        case "details":
                            $9c351ca3251b0a6f$var$D("toggle", d);
                            break;
                        case "input":
                            $9c351ca3251b0a6f$var$Za(d, f);
                            $9c351ca3251b0a6f$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9c351ca3251b0a6f$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$hb(d, f), $9c351ca3251b0a6f$var$D("invalid", d);
                    }
                    $9c351ca3251b0a6f$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9c351ca3251b0a6f$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9c351ca3251b0a6f$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9c351ca3251b0a6f$var$Va(d);
                            $9c351ca3251b0a6f$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$Va(d);
                            $9c351ca3251b0a6f$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9c351ca3251b0a6f$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9c351ca3251b0a6f$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9c351ca3251b0a6f$var$Of] = b;
                    a[$9c351ca3251b0a6f$var$Pf] = d;
                    $9c351ca3251b0a6f$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9c351ca3251b0a6f$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9c351ca3251b0a6f$var$D("cancel", a);
                                $9c351ca3251b0a6f$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9c351ca3251b0a6f$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9c351ca3251b0a6f$var$lf.length; e++)$9c351ca3251b0a6f$var$D($9c351ca3251b0a6f$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9c351ca3251b0a6f$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9c351ca3251b0a6f$var$D("error", a);
                                $9c351ca3251b0a6f$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9c351ca3251b0a6f$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9c351ca3251b0a6f$var$Za(a, d);
                                e = $9c351ca3251b0a6f$var$Ya(a, d);
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9c351ca3251b0a6f$var$A({}, d, {
                                    value: void 0
                                });
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9c351ca3251b0a6f$var$hb(a, d);
                                e = $9c351ca3251b0a6f$var$gb(a, d);
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9c351ca3251b0a6f$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9c351ca3251b0a6f$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9c351ca3251b0a6f$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9c351ca3251b0a6f$var$ob(a, k) : "number" === typeof k && $9c351ca3251b0a6f$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9c351ca3251b0a6f$var$D("scroll", a) : null != k && $9c351ca3251b0a6f$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9c351ca3251b0a6f$var$Va(a);
                                $9c351ca3251b0a6f$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9c351ca3251b0a6f$var$Va(a);
                                $9c351ca3251b0a6f$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9c351ca3251b0a6f$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9c351ca3251b0a6f$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9c351ca3251b0a6f$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9c351ca3251b0a6f$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9c351ca3251b0a6f$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9c351ca3251b0a6f$var$p(166));
                c = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
                $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
                if ($9c351ca3251b0a6f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9c351ca3251b0a6f$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9c351ca3251b0a6f$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9c351ca3251b0a6f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9c351ca3251b0a6f$var$Of] = b, b.stateNode = d;
            }
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 13:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9c351ca3251b0a6f$var$I && null !== $9c351ca3251b0a6f$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9c351ca3251b0a6f$var$Hg(), $9c351ca3251b0a6f$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9c351ca3251b0a6f$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9c351ca3251b0a6f$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9c351ca3251b0a6f$var$p(317));
                        f[$9c351ca3251b0a6f$var$Of] = b;
                    } else $9c351ca3251b0a6f$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9c351ca3251b0a6f$var$S(b);
                    f = !1;
                } else null !== $9c351ca3251b0a6f$var$zg && ($9c351ca3251b0a6f$var$Fj($9c351ca3251b0a6f$var$zg), $9c351ca3251b0a6f$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9c351ca3251b0a6f$var$L.current & 1) ? 0 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 3) : $9c351ca3251b0a6f$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 4:
            return $9c351ca3251b0a6f$var$zh(), $9c351ca3251b0a6f$var$Aj(a, b), null === a && $9c351ca3251b0a6f$var$sf(b.stateNode.containerInfo), $9c351ca3251b0a6f$var$S(b), null;
        case 10:
            return $9c351ca3251b0a6f$var$ah(b.type._context), $9c351ca3251b0a6f$var$S(b), null;
        case 17:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), $9c351ca3251b0a6f$var$S(b), null;
        case 19:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            f = b.memoizedState;
            if (null === f) return $9c351ca3251b0a6f$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9c351ca3251b0a6f$var$Dj(f, !1);
                else {
                    if (0 !== $9c351ca3251b0a6f$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9c351ca3251b0a6f$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9c351ca3251b0a6f$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9c351ca3251b0a6f$var$B() > $9c351ca3251b0a6f$var$Gj && (b.flags |= 128, d = !0, $9c351ca3251b0a6f$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9c351ca3251b0a6f$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9c351ca3251b0a6f$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9c351ca3251b0a6f$var$I) return $9c351ca3251b0a6f$var$S(b), null;
                    } else 2 * $9c351ca3251b0a6f$var$B() - f.renderingStartTime > $9c351ca3251b0a6f$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9c351ca3251b0a6f$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9c351ca3251b0a6f$var$B(), b.sibling = null, c = $9c351ca3251b0a6f$var$L.current, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, d ? c & 1 | 2 : c & 1), b;
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 22:
        case 23:
            return $9c351ca3251b0a6f$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9c351ca3251b0a6f$var$fj & 1073741824) && ($9c351ca3251b0a6f$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9c351ca3251b0a6f$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9c351ca3251b0a6f$var$p(156, b.tag));
}
function $9c351ca3251b0a6f$var$Ij(a, b) {
    $9c351ca3251b0a6f$var$wg(b);
    switch(b.tag){
        case 1:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9c351ca3251b0a6f$var$zh(), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H), $9c351ca3251b0a6f$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9c351ca3251b0a6f$var$Bh(b), null;
        case 13:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9c351ca3251b0a6f$var$p(340));
                $9c351ca3251b0a6f$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L), null;
        case 4:
            return $9c351ca3251b0a6f$var$zh(), null;
        case 10:
            return $9c351ca3251b0a6f$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9c351ca3251b0a6f$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9c351ca3251b0a6f$var$Jj = !1, $9c351ca3251b0a6f$var$U = !1, $9c351ca3251b0a6f$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9c351ca3251b0a6f$var$V = null;
function $9c351ca3251b0a6f$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9c351ca3251b0a6f$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9c351ca3251b0a6f$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9c351ca3251b0a6f$var$W(a, b, d);
    }
}
var $9c351ca3251b0a6f$var$Nj = !1;
function $9c351ca3251b0a6f$var$Oj(a, b) {
    $9c351ca3251b0a6f$var$Cf = $9c351ca3251b0a6f$var$dd;
    a = $9c351ca3251b0a6f$var$Me();
    if ($9c351ca3251b0a6f$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9c351ca3251b0a6f$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9c351ca3251b0a6f$var$dd = !1;
    for($9c351ca3251b0a6f$var$V = b; null !== $9c351ca3251b0a6f$var$V;)if (b = $9c351ca3251b0a6f$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9c351ca3251b0a6f$var$V = a;
    else for(; null !== $9c351ca3251b0a6f$var$V;){
        b = $9c351ca3251b0a6f$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9c351ca3251b0a6f$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(163));
            }
        } catch (F) {
            $9c351ca3251b0a6f$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9c351ca3251b0a6f$var$V = a;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
    n = $9c351ca3251b0a6f$var$Nj;
    $9c351ca3251b0a6f$var$Nj = !1;
    return n;
}
function $9c351ca3251b0a6f$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9c351ca3251b0a6f$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9c351ca3251b0a6f$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9c351ca3251b0a6f$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9c351ca3251b0a6f$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9c351ca3251b0a6f$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9c351ca3251b0a6f$var$Of], delete b[$9c351ca3251b0a6f$var$Pf], delete b[$9c351ca3251b0a6f$var$of], delete b[$9c351ca3251b0a6f$var$Qf], delete b[$9c351ca3251b0a6f$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9c351ca3251b0a6f$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9c351ca3251b0a6f$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9c351ca3251b0a6f$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9c351ca3251b0a6f$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9c351ca3251b0a6f$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9c351ca3251b0a6f$var$Vj(a, b, c), a = a.sibling; null !== a;)$9c351ca3251b0a6f$var$Vj(a, b, c), a = a.sibling;
}
function $9c351ca3251b0a6f$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9c351ca3251b0a6f$var$Wj(a, b, c), a = a.sibling; null !== a;)$9c351ca3251b0a6f$var$Wj(a, b, c), a = a.sibling;
}
var $9c351ca3251b0a6f$var$X = null, $9c351ca3251b0a6f$var$Xj = !1;
function $9c351ca3251b0a6f$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9c351ca3251b0a6f$var$Zj(a, b, c), c = c.sibling;
}
function $9c351ca3251b0a6f$var$Zj(a, b, c) {
    if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onCommitFiberUnmount) try {
        $9c351ca3251b0a6f$var$lc.onCommitFiberUnmount($9c351ca3251b0a6f$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9c351ca3251b0a6f$var$U || $9c351ca3251b0a6f$var$Lj(c, b);
        case 6:
            var d = $9c351ca3251b0a6f$var$X, e = $9c351ca3251b0a6f$var$Xj;
            $9c351ca3251b0a6f$var$X = null;
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            $9c351ca3251b0a6f$var$X = d;
            $9c351ca3251b0a6f$var$Xj = e;
            null !== $9c351ca3251b0a6f$var$X && ($9c351ca3251b0a6f$var$Xj ? (a = $9c351ca3251b0a6f$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9c351ca3251b0a6f$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9c351ca3251b0a6f$var$X && ($9c351ca3251b0a6f$var$Xj ? (a = $9c351ca3251b0a6f$var$X, c = c.stateNode, 8 === a.nodeType ? $9c351ca3251b0a6f$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9c351ca3251b0a6f$var$Kf(a, c), $9c351ca3251b0a6f$var$bd(a)) : $9c351ca3251b0a6f$var$Kf($9c351ca3251b0a6f$var$X, c.stateNode));
            break;
        case 4:
            d = $9c351ca3251b0a6f$var$X;
            e = $9c351ca3251b0a6f$var$Xj;
            $9c351ca3251b0a6f$var$X = c.stateNode.containerInfo;
            $9c351ca3251b0a6f$var$Xj = !0;
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            $9c351ca3251b0a6f$var$X = d;
            $9c351ca3251b0a6f$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9c351ca3251b0a6f$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9c351ca3251b0a6f$var$Mj(c, b, g) : 0 !== (f & 4) && $9c351ca3251b0a6f$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9c351ca3251b0a6f$var$U && ($9c351ca3251b0a6f$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9c351ca3251b0a6f$var$W(c, b, h);
            }
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 21:
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9c351ca3251b0a6f$var$U = (d = $9c351ca3251b0a6f$var$U) || null !== c.memoizedState, $9c351ca3251b0a6f$var$Yj(a, b, c), $9c351ca3251b0a6f$var$U = d) : $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        default:
            $9c351ca3251b0a6f$var$Yj(a, b, c);
    }
}
function $9c351ca3251b0a6f$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9c351ca3251b0a6f$var$Kj);
        b.forEach(function(b) {
            var d = $9c351ca3251b0a6f$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9c351ca3251b0a6f$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9c351ca3251b0a6f$var$X = h.stateNode;
                        $9c351ca3251b0a6f$var$Xj = !1;
                        break a;
                    case 3:
                        $9c351ca3251b0a6f$var$X = h.stateNode.containerInfo;
                        $9c351ca3251b0a6f$var$Xj = !0;
                        break a;
                    case 4:
                        $9c351ca3251b0a6f$var$X = h.stateNode.containerInfo;
                        $9c351ca3251b0a6f$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9c351ca3251b0a6f$var$X) throw Error($9c351ca3251b0a6f$var$p(160));
            $9c351ca3251b0a6f$var$Zj(f, g, e);
            $9c351ca3251b0a6f$var$X = null;
            $9c351ca3251b0a6f$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9c351ca3251b0a6f$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9c351ca3251b0a6f$var$dk(b, a), b = b.sibling;
}
function $9c351ca3251b0a6f$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4) {
                try {
                    $9c351ca3251b0a6f$var$Pj(3, a, a.return), $9c351ca3251b0a6f$var$Qj(3, a);
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
                try {
                    $9c351ca3251b0a6f$var$Pj(5, a, a.return);
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 512 && null !== c && $9c351ca3251b0a6f$var$Lj(c, c.return);
            break;
        case 5:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 512 && null !== c && $9c351ca3251b0a6f$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9c351ca3251b0a6f$var$ob(e, "");
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9c351ca3251b0a6f$var$ab(e, f);
                    $9c351ca3251b0a6f$var$vb(h, g);
                    var l = $9c351ca3251b0a6f$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9c351ca3251b0a6f$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9c351ca3251b0a6f$var$nb(e, q) : "children" === m ? $9c351ca3251b0a6f$var$ob(e, q) : $9c351ca3251b0a6f$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9c351ca3251b0a6f$var$bb(e, f);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9c351ca3251b0a6f$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9c351ca3251b0a6f$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9c351ca3251b0a6f$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9c351ca3251b0a6f$var$Pf] = f;
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9c351ca3251b0a6f$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9c351ca3251b0a6f$var$bd(b.containerInfo);
            } catch (t) {
                $9c351ca3251b0a6f$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            break;
        case 13:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9c351ca3251b0a6f$var$fk = $9c351ca3251b0a6f$var$B()));
            d & 4 && $9c351ca3251b0a6f$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9c351ca3251b0a6f$var$U = (l = $9c351ca3251b0a6f$var$U) || m, $9c351ca3251b0a6f$var$ck(b, a), $9c351ca3251b0a6f$var$U = l) : $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9c351ca3251b0a6f$var$V = a, m = a.child; null !== m;){
                    for(q = $9c351ca3251b0a6f$var$V = m; null !== $9c351ca3251b0a6f$var$V;){
                        r = $9c351ca3251b0a6f$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9c351ca3251b0a6f$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9c351ca3251b0a6f$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9c351ca3251b0a6f$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9c351ca3251b0a6f$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9c351ca3251b0a6f$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9c351ca3251b0a6f$var$V = y) : $9c351ca3251b0a6f$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9c351ca3251b0a6f$var$rb("display", g));
                            } catch (t) {
                                $9c351ca3251b0a6f$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9c351ca3251b0a6f$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 4 && $9c351ca3251b0a6f$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9c351ca3251b0a6f$var$ck(b, a), $9c351ca3251b0a6f$var$ek(a);
    }
}
function $9c351ca3251b0a6f$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9c351ca3251b0a6f$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9c351ca3251b0a6f$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9c351ca3251b0a6f$var$ob(e, ""), d.flags &= -33);
                    var f = $9c351ca3251b0a6f$var$Uj(a);
                    $9c351ca3251b0a6f$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9c351ca3251b0a6f$var$Uj(a);
                    $9c351ca3251b0a6f$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(161));
            }
        } catch (k) {
            $9c351ca3251b0a6f$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9c351ca3251b0a6f$var$hk(a, b, c) {
    $9c351ca3251b0a6f$var$V = a;
    $9c351ca3251b0a6f$var$ik(a, b, c);
}
function $9c351ca3251b0a6f$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9c351ca3251b0a6f$var$V;){
        var e = $9c351ca3251b0a6f$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9c351ca3251b0a6f$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9c351ca3251b0a6f$var$U;
                h = $9c351ca3251b0a6f$var$Jj;
                var l = $9c351ca3251b0a6f$var$U;
                $9c351ca3251b0a6f$var$Jj = g;
                if (($9c351ca3251b0a6f$var$U = k) && !l) for($9c351ca3251b0a6f$var$V = e; null !== $9c351ca3251b0a6f$var$V;)g = $9c351ca3251b0a6f$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9c351ca3251b0a6f$var$jk(e) : null !== k ? (k.return = g, $9c351ca3251b0a6f$var$V = k) : $9c351ca3251b0a6f$var$jk(e);
                for(; null !== f;)$9c351ca3251b0a6f$var$V = f, $9c351ca3251b0a6f$var$ik(f, b, c), f = f.sibling;
                $9c351ca3251b0a6f$var$V = e;
                $9c351ca3251b0a6f$var$Jj = h;
                $9c351ca3251b0a6f$var$U = l;
            }
            $9c351ca3251b0a6f$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9c351ca3251b0a6f$var$V = f) : $9c351ca3251b0a6f$var$kk(a, b, c);
    }
}
function $9c351ca3251b0a6f$var$kk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9c351ca3251b0a6f$var$U || $9c351ca3251b0a6f$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9c351ca3251b0a6f$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9c351ca3251b0a6f$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9c351ca3251b0a6f$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9c351ca3251b0a6f$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9c351ca3251b0a6f$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9c351ca3251b0a6f$var$p(163));
                }
                $9c351ca3251b0a6f$var$U || b.flags & 512 && $9c351ca3251b0a6f$var$Rj(b);
            } catch (r) {
                $9c351ca3251b0a6f$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9c351ca3251b0a6f$var$V = c;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
function $9c351ca3251b0a6f$var$gk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9c351ca3251b0a6f$var$V = c;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
function $9c351ca3251b0a6f$var$jk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Qj(4, b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9c351ca3251b0a6f$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Rj(b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Rj(b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9c351ca3251b0a6f$var$W(b, b.return, k);
        }
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9c351ca3251b0a6f$var$V = h;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
var $9c351ca3251b0a6f$var$lk = Math.ceil, $9c351ca3251b0a6f$var$mk = $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher, $9c351ca3251b0a6f$var$nk = $9c351ca3251b0a6f$var$ua.ReactCurrentOwner, $9c351ca3251b0a6f$var$ok = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$K = 0, $9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Y = null, $9c351ca3251b0a6f$var$Z = 0, $9c351ca3251b0a6f$var$fj = 0, $9c351ca3251b0a6f$var$ej = $9c351ca3251b0a6f$var$Uf(0), $9c351ca3251b0a6f$var$T = 0, $9c351ca3251b0a6f$var$pk = null, $9c351ca3251b0a6f$var$rh = 0, $9c351ca3251b0a6f$var$qk = 0, $9c351ca3251b0a6f$var$rk = 0, $9c351ca3251b0a6f$var$sk = null, $9c351ca3251b0a6f$var$tk = null, $9c351ca3251b0a6f$var$fk = 0, $9c351ca3251b0a6f$var$Gj = Infinity, $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Oi = !1, $9c351ca3251b0a6f$var$Pi = null, $9c351ca3251b0a6f$var$Ri = null, $9c351ca3251b0a6f$var$vk = !1, $9c351ca3251b0a6f$var$wk = null, $9c351ca3251b0a6f$var$xk = 0, $9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = null, $9c351ca3251b0a6f$var$Ak = -1, $9c351ca3251b0a6f$var$Bk = 0;
function $9c351ca3251b0a6f$var$R() {
    return 0 !== ($9c351ca3251b0a6f$var$K & 6) ? $9c351ca3251b0a6f$var$B() : -1 !== $9c351ca3251b0a6f$var$Ak ? $9c351ca3251b0a6f$var$Ak : $9c351ca3251b0a6f$var$Ak = $9c351ca3251b0a6f$var$B();
}
function $9c351ca3251b0a6f$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9c351ca3251b0a6f$var$K & 2) && 0 !== $9c351ca3251b0a6f$var$Z) return $9c351ca3251b0a6f$var$Z & -$9c351ca3251b0a6f$var$Z;
    if (null !== $9c351ca3251b0a6f$var$Kg.transition) return 0 === $9c351ca3251b0a6f$var$Bk && ($9c351ca3251b0a6f$var$Bk = $9c351ca3251b0a6f$var$yc()), $9c351ca3251b0a6f$var$Bk;
    a = $9c351ca3251b0a6f$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9c351ca3251b0a6f$var$jd(a.type);
    return a;
}
function $9c351ca3251b0a6f$var$gi(a, b, c, d) {
    if (50 < $9c351ca3251b0a6f$var$yk) throw $9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = null, Error($9c351ca3251b0a6f$var$p(185));
    $9c351ca3251b0a6f$var$Ac(a, c, d);
    if (0 === ($9c351ca3251b0a6f$var$K & 2) || a !== $9c351ca3251b0a6f$var$Q) a === $9c351ca3251b0a6f$var$Q && (0 === ($9c351ca3251b0a6f$var$K & 2) && ($9c351ca3251b0a6f$var$qk |= c), 4 === $9c351ca3251b0a6f$var$T && $9c351ca3251b0a6f$var$Ck(a, $9c351ca3251b0a6f$var$Z)), $9c351ca3251b0a6f$var$Dk(a, d), 1 === c && 0 === $9c351ca3251b0a6f$var$K && 0 === (b.mode & 1) && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$fg && $9c351ca3251b0a6f$var$jg());
}
function $9c351ca3251b0a6f$var$Dk(a, b) {
    var c = a.callbackNode;
    $9c351ca3251b0a6f$var$wc(a, b);
    var d = $9c351ca3251b0a6f$var$uc(a, a === $9c351ca3251b0a6f$var$Q ? $9c351ca3251b0a6f$var$Z : 0);
    if (0 === d) null !== c && $9c351ca3251b0a6f$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9c351ca3251b0a6f$var$bc(c);
        if (1 === b) 0 === a.tag ? $9c351ca3251b0a6f$var$ig($9c351ca3251b0a6f$var$Ek.bind(null, a)) : $9c351ca3251b0a6f$var$hg($9c351ca3251b0a6f$var$Ek.bind(null, a)), $9c351ca3251b0a6f$var$Jf(function() {
            0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$jg();
        }), c = null;
        else {
            switch($9c351ca3251b0a6f$var$Dc(d)){
                case 1:
                    c = $9c351ca3251b0a6f$var$fc;
                    break;
                case 4:
                    c = $9c351ca3251b0a6f$var$gc;
                    break;
                case 16:
                    c = $9c351ca3251b0a6f$var$hc;
                    break;
                case 536870912:
                    c = $9c351ca3251b0a6f$var$jc;
                    break;
                default:
                    c = $9c351ca3251b0a6f$var$hc;
            }
            c = $9c351ca3251b0a6f$var$Fk(c, $9c351ca3251b0a6f$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9c351ca3251b0a6f$var$Gk(a, b) {
    $9c351ca3251b0a6f$var$Ak = -1;
    $9c351ca3251b0a6f$var$Bk = 0;
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    var c = a.callbackNode;
    if ($9c351ca3251b0a6f$var$Hk() && a.callbackNode !== c) return null;
    var d = $9c351ca3251b0a6f$var$uc(a, a === $9c351ca3251b0a6f$var$Q ? $9c351ca3251b0a6f$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9c351ca3251b0a6f$var$Ik(a, d);
    else {
        b = d;
        var e = $9c351ca3251b0a6f$var$K;
        $9c351ca3251b0a6f$var$K |= 2;
        var f = $9c351ca3251b0a6f$var$Jk();
        if ($9c351ca3251b0a6f$var$Q !== a || $9c351ca3251b0a6f$var$Z !== b) $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$Kk(a, b);
        for(;;)try {
            $9c351ca3251b0a6f$var$Lk();
            break;
        } catch (h) {
            $9c351ca3251b0a6f$var$Mk(a, h);
        }
        $9c351ca3251b0a6f$var$$g();
        $9c351ca3251b0a6f$var$mk.current = f;
        $9c351ca3251b0a6f$var$K = e;
        null !== $9c351ca3251b0a6f$var$Y ? b = 0 : ($9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Z = 0, b = $9c351ca3251b0a6f$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9c351ca3251b0a6f$var$xc(a), 0 !== e && (d = e, b = $9c351ca3251b0a6f$var$Nk(a, e)));
        if (1 === b) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, d), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
        if (6 === b) $9c351ca3251b0a6f$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9c351ca3251b0a6f$var$Ok(e) && (b = $9c351ca3251b0a6f$var$Ik(a, d), 2 === b && (f = $9c351ca3251b0a6f$var$xc(a), 0 !== f && (d = f, b = $9c351ca3251b0a6f$var$Nk(a, f))), 1 === b)) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, d), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9c351ca3251b0a6f$var$p(345));
                case 2:
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 3:
                    $9c351ca3251b0a6f$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9c351ca3251b0a6f$var$fk + 500 - $9c351ca3251b0a6f$var$B(), 10 < b)) {
                        if (0 !== $9c351ca3251b0a6f$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9c351ca3251b0a6f$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9c351ca3251b0a6f$var$Ff($9c351ca3251b0a6f$var$Pk.bind(null, a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk), b);
                        break;
                    }
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 4:
                    $9c351ca3251b0a6f$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9c351ca3251b0a6f$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9c351ca3251b0a6f$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9c351ca3251b0a6f$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9c351ca3251b0a6f$var$Ff($9c351ca3251b0a6f$var$Pk.bind(null, a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk), d);
                        break;
                    }
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 5:
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(329));
            }
        }
    }
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    return a.callbackNode === c ? $9c351ca3251b0a6f$var$Gk.bind(null, a) : null;
}
function $9c351ca3251b0a6f$var$Nk(a, b) {
    var c = $9c351ca3251b0a6f$var$sk;
    a.current.memoizedState.isDehydrated && ($9c351ca3251b0a6f$var$Kk(a, b).flags |= 256);
    a = $9c351ca3251b0a6f$var$Ik(a, b);
    2 !== a && (b = $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$tk = c, null !== b && $9c351ca3251b0a6f$var$Fj(b));
    return a;
}
function $9c351ca3251b0a6f$var$Fj(a) {
    null === $9c351ca3251b0a6f$var$tk ? $9c351ca3251b0a6f$var$tk = a : $9c351ca3251b0a6f$var$tk.push.apply($9c351ca3251b0a6f$var$tk, a);
}
function $9c351ca3251b0a6f$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9c351ca3251b0a6f$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Ck(a, b) {
    b &= ~$9c351ca3251b0a6f$var$rk;
    b &= ~$9c351ca3251b0a6f$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9c351ca3251b0a6f$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9c351ca3251b0a6f$var$Ek(a) {
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    $9c351ca3251b0a6f$var$Hk();
    var b = $9c351ca3251b0a6f$var$uc(a, 0);
    if (0 === (b & 1)) return $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), null;
    var c = $9c351ca3251b0a6f$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9c351ca3251b0a6f$var$xc(a);
        0 !== d && (b = d, c = $9c351ca3251b0a6f$var$Nk(a, d));
    }
    if (1 === c) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, b), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
    if (6 === c) throw Error($9c351ca3251b0a6f$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    return null;
}
function $9c351ca3251b0a6f$var$Qk(a, b) {
    var c = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9c351ca3251b0a6f$var$K = c, 0 === $9c351ca3251b0a6f$var$K && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$fg && $9c351ca3251b0a6f$var$jg());
    }
}
function $9c351ca3251b0a6f$var$Rk(a) {
    null !== $9c351ca3251b0a6f$var$wk && 0 === $9c351ca3251b0a6f$var$wk.tag && 0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$Hk();
    var b = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 1;
    var c = $9c351ca3251b0a6f$var$ok.transition, d = $9c351ca3251b0a6f$var$C;
    try {
        if ($9c351ca3251b0a6f$var$ok.transition = null, $9c351ca3251b0a6f$var$C = 1, a) return a();
    } finally{
        $9c351ca3251b0a6f$var$C = d, $9c351ca3251b0a6f$var$ok.transition = c, $9c351ca3251b0a6f$var$K = b, 0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$jg();
    }
}
function $9c351ca3251b0a6f$var$Hj() {
    $9c351ca3251b0a6f$var$fj = $9c351ca3251b0a6f$var$ej.current;
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$ej);
}
function $9c351ca3251b0a6f$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9c351ca3251b0a6f$var$Gf(c));
    if (null !== $9c351ca3251b0a6f$var$Y) for(c = $9c351ca3251b0a6f$var$Y.return; null !== c;){
        var d = c;
        $9c351ca3251b0a6f$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9c351ca3251b0a6f$var$$f();
                break;
            case 3:
                $9c351ca3251b0a6f$var$zh();
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
                $9c351ca3251b0a6f$var$Eh();
                break;
            case 5:
                $9c351ca3251b0a6f$var$Bh(d);
                break;
            case 4:
                $9c351ca3251b0a6f$var$zh();
                break;
            case 13:
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
                break;
            case 19:
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
                break;
            case 10:
                $9c351ca3251b0a6f$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9c351ca3251b0a6f$var$Hj();
        }
        c = c.return;
    }
    $9c351ca3251b0a6f$var$Q = a;
    $9c351ca3251b0a6f$var$Y = a = $9c351ca3251b0a6f$var$Pg(a.current, null);
    $9c351ca3251b0a6f$var$Z = $9c351ca3251b0a6f$var$fj = b;
    $9c351ca3251b0a6f$var$T = 0;
    $9c351ca3251b0a6f$var$pk = null;
    $9c351ca3251b0a6f$var$rk = $9c351ca3251b0a6f$var$qk = $9c351ca3251b0a6f$var$rh = 0;
    $9c351ca3251b0a6f$var$tk = $9c351ca3251b0a6f$var$sk = null;
    if (null !== $9c351ca3251b0a6f$var$fh) {
        for(b = 0; b < $9c351ca3251b0a6f$var$fh.length; b++)if (c = $9c351ca3251b0a6f$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9c351ca3251b0a6f$var$fh = null;
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mk(a, b) {
    do {
        var c = $9c351ca3251b0a6f$var$Y;
        try {
            $9c351ca3251b0a6f$var$$g();
            $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Rh;
            if ($9c351ca3251b0a6f$var$Ih) {
                for(var d = $9c351ca3251b0a6f$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9c351ca3251b0a6f$var$Ih = !1;
            }
            $9c351ca3251b0a6f$var$Hh = 0;
            $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = $9c351ca3251b0a6f$var$M = null;
            $9c351ca3251b0a6f$var$Jh = !1;
            $9c351ca3251b0a6f$var$Kh = 0;
            $9c351ca3251b0a6f$var$nk.current = null;
            if (null === c || null === c.return) {
                $9c351ca3251b0a6f$var$T = 1;
                $9c351ca3251b0a6f$var$pk = b;
                $9c351ca3251b0a6f$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9c351ca3251b0a6f$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9c351ca3251b0a6f$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9c351ca3251b0a6f$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9c351ca3251b0a6f$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9c351ca3251b0a6f$var$Si(f, l, b);
                            $9c351ca3251b0a6f$var$tj();
                            break a;
                        }
                        k = Error($9c351ca3251b0a6f$var$p(426));
                    }
                } else if ($9c351ca3251b0a6f$var$I && h.mode & 1) {
                    var J = $9c351ca3251b0a6f$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9c351ca3251b0a6f$var$Vi(J, g, h, f, b);
                        $9c351ca3251b0a6f$var$Jg($9c351ca3251b0a6f$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9c351ca3251b0a6f$var$Ji(k, h);
                4 !== $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 2);
                null === $9c351ca3251b0a6f$var$sk ? $9c351ca3251b0a6f$var$sk = [
                    f
                ] : $9c351ca3251b0a6f$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9c351ca3251b0a6f$var$Ni(f, k, b);
                            $9c351ca3251b0a6f$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9c351ca3251b0a6f$var$Ri || !$9c351ca3251b0a6f$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9c351ca3251b0a6f$var$Qi(f, h, b);
                                $9c351ca3251b0a6f$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9c351ca3251b0a6f$var$Sk(c);
        } catch (na) {
            b = na;
            $9c351ca3251b0a6f$var$Y === c && null !== c && ($9c351ca3251b0a6f$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9c351ca3251b0a6f$var$Jk() {
    var a = $9c351ca3251b0a6f$var$mk.current;
    $9c351ca3251b0a6f$var$mk.current = $9c351ca3251b0a6f$var$Rh;
    return null === a ? $9c351ca3251b0a6f$var$Rh : a;
}
function $9c351ca3251b0a6f$var$tj() {
    if (0 === $9c351ca3251b0a6f$var$T || 3 === $9c351ca3251b0a6f$var$T || 2 === $9c351ca3251b0a6f$var$T) $9c351ca3251b0a6f$var$T = 4;
    null === $9c351ca3251b0a6f$var$Q || 0 === ($9c351ca3251b0a6f$var$rh & 268435455) && 0 === ($9c351ca3251b0a6f$var$qk & 268435455) || $9c351ca3251b0a6f$var$Ck($9c351ca3251b0a6f$var$Q, $9c351ca3251b0a6f$var$Z);
}
function $9c351ca3251b0a6f$var$Ik(a, b) {
    var c = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 2;
    var d = $9c351ca3251b0a6f$var$Jk();
    if ($9c351ca3251b0a6f$var$Q !== a || $9c351ca3251b0a6f$var$Z !== b) $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Kk(a, b);
    for(;;)try {
        $9c351ca3251b0a6f$var$Tk();
        break;
    } catch (e) {
        $9c351ca3251b0a6f$var$Mk(a, e);
    }
    $9c351ca3251b0a6f$var$$g();
    $9c351ca3251b0a6f$var$K = c;
    $9c351ca3251b0a6f$var$mk.current = d;
    if (null !== $9c351ca3251b0a6f$var$Y) throw Error($9c351ca3251b0a6f$var$p(261));
    $9c351ca3251b0a6f$var$Q = null;
    $9c351ca3251b0a6f$var$Z = 0;
    return $9c351ca3251b0a6f$var$T;
}
function $9c351ca3251b0a6f$var$Tk() {
    for(; null !== $9c351ca3251b0a6f$var$Y;)$9c351ca3251b0a6f$var$Uk($9c351ca3251b0a6f$var$Y);
}
function $9c351ca3251b0a6f$var$Lk() {
    for(; null !== $9c351ca3251b0a6f$var$Y && !$9c351ca3251b0a6f$var$cc();)$9c351ca3251b0a6f$var$Uk($9c351ca3251b0a6f$var$Y);
}
function $9c351ca3251b0a6f$var$Uk(a) {
    var b = $9c351ca3251b0a6f$var$Vk(a.alternate, a, $9c351ca3251b0a6f$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9c351ca3251b0a6f$var$Sk(a) : $9c351ca3251b0a6f$var$Y = b;
    $9c351ca3251b0a6f$var$nk.current = null;
}
function $9c351ca3251b0a6f$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9c351ca3251b0a6f$var$Ej(c, b, $9c351ca3251b0a6f$var$fj), null !== c) {
                $9c351ca3251b0a6f$var$Y = c;
                return;
            }
        } else {
            c = $9c351ca3251b0a6f$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9c351ca3251b0a6f$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9c351ca3251b0a6f$var$T = 6;
                $9c351ca3251b0a6f$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9c351ca3251b0a6f$var$Y = b;
            return;
        }
        $9c351ca3251b0a6f$var$Y = b = a;
    }while (null !== b);
    0 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 5);
}
function $9c351ca3251b0a6f$var$Pk(a, b, c) {
    var d = $9c351ca3251b0a6f$var$C, e = $9c351ca3251b0a6f$var$ok.transition;
    try {
        $9c351ca3251b0a6f$var$ok.transition = null, $9c351ca3251b0a6f$var$C = 1, $9c351ca3251b0a6f$var$Wk(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$ok.transition = e, $9c351ca3251b0a6f$var$C = d;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Wk(a, b, c, d) {
    do $9c351ca3251b0a6f$var$Hk();
    while (null !== $9c351ca3251b0a6f$var$wk);
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9c351ca3251b0a6f$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9c351ca3251b0a6f$var$Bc(a, f);
    a === $9c351ca3251b0a6f$var$Q && ($9c351ca3251b0a6f$var$Y = $9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9c351ca3251b0a6f$var$vk || ($9c351ca3251b0a6f$var$vk = !0, $9c351ca3251b0a6f$var$Fk($9c351ca3251b0a6f$var$hc, function() {
        $9c351ca3251b0a6f$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9c351ca3251b0a6f$var$ok.transition;
        $9c351ca3251b0a6f$var$ok.transition = null;
        var g = $9c351ca3251b0a6f$var$C;
        $9c351ca3251b0a6f$var$C = 1;
        var h = $9c351ca3251b0a6f$var$K;
        $9c351ca3251b0a6f$var$K |= 4;
        $9c351ca3251b0a6f$var$nk.current = null;
        $9c351ca3251b0a6f$var$Oj(a, c);
        $9c351ca3251b0a6f$var$dk(c, a);
        $9c351ca3251b0a6f$var$Oe($9c351ca3251b0a6f$var$Df);
        $9c351ca3251b0a6f$var$dd = !!$9c351ca3251b0a6f$var$Cf;
        $9c351ca3251b0a6f$var$Df = $9c351ca3251b0a6f$var$Cf = null;
        a.current = c;
        $9c351ca3251b0a6f$var$hk(c, a, e);
        $9c351ca3251b0a6f$var$dc();
        $9c351ca3251b0a6f$var$K = h;
        $9c351ca3251b0a6f$var$C = g;
        $9c351ca3251b0a6f$var$ok.transition = f;
    } else a.current = c;
    $9c351ca3251b0a6f$var$vk && ($9c351ca3251b0a6f$var$vk = !1, $9c351ca3251b0a6f$var$wk = a, $9c351ca3251b0a6f$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9c351ca3251b0a6f$var$Ri = null);
    $9c351ca3251b0a6f$var$mc(c.stateNode, d);
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9c351ca3251b0a6f$var$Oi) throw $9c351ca3251b0a6f$var$Oi = !1, a = $9c351ca3251b0a6f$var$Pi, $9c351ca3251b0a6f$var$Pi = null, a;
    0 !== ($9c351ca3251b0a6f$var$xk & 1) && 0 !== a.tag && $9c351ca3251b0a6f$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9c351ca3251b0a6f$var$zk ? $9c351ca3251b0a6f$var$yk++ : ($9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = a) : $9c351ca3251b0a6f$var$yk = 0;
    $9c351ca3251b0a6f$var$jg();
    return null;
}
function $9c351ca3251b0a6f$var$Hk() {
    if (null !== $9c351ca3251b0a6f$var$wk) {
        var a = $9c351ca3251b0a6f$var$Dc($9c351ca3251b0a6f$var$xk), b = $9c351ca3251b0a6f$var$ok.transition, c = $9c351ca3251b0a6f$var$C;
        try {
            $9c351ca3251b0a6f$var$ok.transition = null;
            $9c351ca3251b0a6f$var$C = 16 > a ? 16 : a;
            if (null === $9c351ca3251b0a6f$var$wk) var d = !1;
            else {
                a = $9c351ca3251b0a6f$var$wk;
                $9c351ca3251b0a6f$var$wk = null;
                $9c351ca3251b0a6f$var$xk = 0;
                if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(331));
                var e = $9c351ca3251b0a6f$var$K;
                $9c351ca3251b0a6f$var$K |= 4;
                for($9c351ca3251b0a6f$var$V = a.current; null !== $9c351ca3251b0a6f$var$V;){
                    var f = $9c351ca3251b0a6f$var$V, g = f.child;
                    if (0 !== ($9c351ca3251b0a6f$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9c351ca3251b0a6f$var$V = l; null !== $9c351ca3251b0a6f$var$V;){
                                    var m = $9c351ca3251b0a6f$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9c351ca3251b0a6f$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9c351ca3251b0a6f$var$V = q;
                                    else for(; null !== $9c351ca3251b0a6f$var$V;){
                                        m = $9c351ca3251b0a6f$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9c351ca3251b0a6f$var$Sj(m);
                                        if (m === l) {
                                            $9c351ca3251b0a6f$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9c351ca3251b0a6f$var$V = r;
                                            break;
                                        }
                                        $9c351ca3251b0a6f$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9c351ca3251b0a6f$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9c351ca3251b0a6f$var$V = g;
                    else b: for(; null !== $9c351ca3251b0a6f$var$V;){
                        f = $9c351ca3251b0a6f$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9c351ca3251b0a6f$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9c351ca3251b0a6f$var$V = x;
                            break b;
                        }
                        $9c351ca3251b0a6f$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9c351ca3251b0a6f$var$V = w; null !== $9c351ca3251b0a6f$var$V;){
                    g = $9c351ca3251b0a6f$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9c351ca3251b0a6f$var$V = u;
                    else b: for(g = w; null !== $9c351ca3251b0a6f$var$V;){
                        h = $9c351ca3251b0a6f$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9c351ca3251b0a6f$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9c351ca3251b0a6f$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9c351ca3251b0a6f$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9c351ca3251b0a6f$var$V = F;
                            break b;
                        }
                        $9c351ca3251b0a6f$var$V = h.return;
                    }
                }
                $9c351ca3251b0a6f$var$K = e;
                $9c351ca3251b0a6f$var$jg();
                if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onPostCommitFiberRoot) try {
                    $9c351ca3251b0a6f$var$lc.onPostCommitFiberRoot($9c351ca3251b0a6f$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9c351ca3251b0a6f$var$C = c, $9c351ca3251b0a6f$var$ok.transition = b;
        }
    }
    return !1;
}
function $9c351ca3251b0a6f$var$Xk(a, b, c) {
    b = $9c351ca3251b0a6f$var$Ji(c, b);
    b = $9c351ca3251b0a6f$var$Ni(a, b, 1);
    a = $9c351ca3251b0a6f$var$nh(a, b, 1);
    b = $9c351ca3251b0a6f$var$R();
    null !== a && ($9c351ca3251b0a6f$var$Ac(a, 1, b), $9c351ca3251b0a6f$var$Dk(a, b));
}
function $9c351ca3251b0a6f$var$W(a, b, c) {
    if (3 === a.tag) $9c351ca3251b0a6f$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9c351ca3251b0a6f$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9c351ca3251b0a6f$var$Ri || !$9c351ca3251b0a6f$var$Ri.has(d))) {
                a = $9c351ca3251b0a6f$var$Ji(c, a);
                a = $9c351ca3251b0a6f$var$Qi(b, a, 1);
                b = $9c351ca3251b0a6f$var$nh(b, a, 1);
                a = $9c351ca3251b0a6f$var$R();
                null !== b && ($9c351ca3251b0a6f$var$Ac(b, 1, a), $9c351ca3251b0a6f$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9c351ca3251b0a6f$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9c351ca3251b0a6f$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9c351ca3251b0a6f$var$Q === a && ($9c351ca3251b0a6f$var$Z & c) === c && (4 === $9c351ca3251b0a6f$var$T || 3 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$Z & 130023424) === $9c351ca3251b0a6f$var$Z && 500 > $9c351ca3251b0a6f$var$B() - $9c351ca3251b0a6f$var$fk ? $9c351ca3251b0a6f$var$Kk(a, 0) : $9c351ca3251b0a6f$var$rk |= c);
    $9c351ca3251b0a6f$var$Dk(a, b);
}
function $9c351ca3251b0a6f$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9c351ca3251b0a6f$var$sc, $9c351ca3251b0a6f$var$sc <<= 1, 0 === ($9c351ca3251b0a6f$var$sc & 130023424) && ($9c351ca3251b0a6f$var$sc = 4194304)));
    var c = $9c351ca3251b0a6f$var$R();
    a = $9c351ca3251b0a6f$var$ih(a, b);
    null !== a && ($9c351ca3251b0a6f$var$Ac(a, b, c), $9c351ca3251b0a6f$var$Dk(a, c));
}
function $9c351ca3251b0a6f$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9c351ca3251b0a6f$var$Yk(a, c);
}
function $9c351ca3251b0a6f$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9c351ca3251b0a6f$var$p(314));
    }
    null !== d && d.delete(b);
    $9c351ca3251b0a6f$var$Yk(a, c);
}
var $9c351ca3251b0a6f$var$Vk;
$9c351ca3251b0a6f$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9c351ca3251b0a6f$var$Wf.current) $9c351ca3251b0a6f$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9c351ca3251b0a6f$var$dh = !1, $9c351ca3251b0a6f$var$yj(a, b, c);
            $9c351ca3251b0a6f$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9c351ca3251b0a6f$var$dh = !1, $9c351ca3251b0a6f$var$I && 0 !== (b.flags & 1048576) && $9c351ca3251b0a6f$var$ug(b, $9c351ca3251b0a6f$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9c351ca3251b0a6f$var$ij(a, b);
            a = b.pendingProps;
            var e = $9c351ca3251b0a6f$var$Yf(b, $9c351ca3251b0a6f$var$H.current);
            $9c351ca3251b0a6f$var$ch(b, c);
            e = $9c351ca3251b0a6f$var$Nh(null, b, d, a, e, c);
            var f = $9c351ca3251b0a6f$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9c351ca3251b0a6f$var$Zf(d) ? (f = !0, $9c351ca3251b0a6f$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9c351ca3251b0a6f$var$kh(b), e.updater = $9c351ca3251b0a6f$var$Ei, b.stateNode = e, e._reactInternals = b, $9c351ca3251b0a6f$var$Ii(b, d, a, c), b = $9c351ca3251b0a6f$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9c351ca3251b0a6f$var$I && f && $9c351ca3251b0a6f$var$vg(b), $9c351ca3251b0a6f$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9c351ca3251b0a6f$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9c351ca3251b0a6f$var$Zk(d);
                a = $9c351ca3251b0a6f$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9c351ca3251b0a6f$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9c351ca3251b0a6f$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9c351ca3251b0a6f$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9c351ca3251b0a6f$var$$i(null, b, d, $9c351ca3251b0a6f$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9c351ca3251b0a6f$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9c351ca3251b0a6f$var$kj(b);
                if (null === a) throw Error($9c351ca3251b0a6f$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9c351ca3251b0a6f$var$lh(a, b);
                $9c351ca3251b0a6f$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9c351ca3251b0a6f$var$Ji(Error($9c351ca3251b0a6f$var$p(423)), b);
                        b = $9c351ca3251b0a6f$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9c351ca3251b0a6f$var$Ji(Error($9c351ca3251b0a6f$var$p(424)), b);
                        b = $9c351ca3251b0a6f$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(b.stateNode.containerInfo.firstChild), $9c351ca3251b0a6f$var$xg = b, $9c351ca3251b0a6f$var$I = !0, $9c351ca3251b0a6f$var$zg = null, c = $9c351ca3251b0a6f$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9c351ca3251b0a6f$var$Ig();
                    if (d === e) {
                        b = $9c351ca3251b0a6f$var$Zi(a, b, c);
                        break a;
                    }
                    $9c351ca3251b0a6f$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9c351ca3251b0a6f$var$Ah(b), null === a && $9c351ca3251b0a6f$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9c351ca3251b0a6f$var$Ef(d, e) ? g = null : null !== f && $9c351ca3251b0a6f$var$Ef(d, f) && (b.flags |= 32), $9c351ca3251b0a6f$var$gj(a, b), $9c351ca3251b0a6f$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9c351ca3251b0a6f$var$Eg(b), null;
        case 13:
            return $9c351ca3251b0a6f$var$oj(a, b, c);
        case 4:
            return $9c351ca3251b0a6f$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9c351ca3251b0a6f$var$Ug(b, null, d, c) : $9c351ca3251b0a6f$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$Yi(a, b, d, e, c);
        case 7:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9c351ca3251b0a6f$var$He(f.value, g)) {
                        if (f.children === e.children && !$9c351ca3251b0a6f$var$Wf.current) {
                            b = $9c351ca3251b0a6f$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9c351ca3251b0a6f$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9c351ca3251b0a6f$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9c351ca3251b0a6f$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9c351ca3251b0a6f$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9c351ca3251b0a6f$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9c351ca3251b0a6f$var$ch(b, c), e = $9c351ca3251b0a6f$var$eh(e), d = d(e), b.flags |= 1, $9c351ca3251b0a6f$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9c351ca3251b0a6f$var$Ci(d, b.pendingProps), e = $9c351ca3251b0a6f$var$Ci(d.type, e), $9c351ca3251b0a6f$var$$i(a, b, d, e, c);
        case 15:
            return $9c351ca3251b0a6f$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$ij(a, b), b.tag = 1, $9c351ca3251b0a6f$var$Zf(d) ? (a = !0, $9c351ca3251b0a6f$var$cg(b)) : a = !1, $9c351ca3251b0a6f$var$ch(b, c), $9c351ca3251b0a6f$var$Gi(b, d, e), $9c351ca3251b0a6f$var$Ii(b, d, e, c), $9c351ca3251b0a6f$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9c351ca3251b0a6f$var$xj(a, b, c);
        case 22:
            return $9c351ca3251b0a6f$var$dj(a, b, c);
    }
    throw Error($9c351ca3251b0a6f$var$p(156, b.tag));
};
function $9c351ca3251b0a6f$var$Fk(a, b) {
    return $9c351ca3251b0a6f$var$ac(a, b);
}
function $9c351ca3251b0a6f$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9c351ca3251b0a6f$var$Bg(a, b, c, d) {
    return new $9c351ca3251b0a6f$var$$k(a, b, c, d);
}
function $9c351ca3251b0a6f$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9c351ca3251b0a6f$var$Zk(a) {
    if ("function" === typeof a) return $9c351ca3251b0a6f$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9c351ca3251b0a6f$var$Da) return 11;
        if (a === $9c351ca3251b0a6f$var$Ga) return 14;
    }
    return 2;
}
function $9c351ca3251b0a6f$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9c351ca3251b0a6f$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9c351ca3251b0a6f$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9c351ca3251b0a6f$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9c351ca3251b0a6f$var$ya:
            return $9c351ca3251b0a6f$var$Tg(c.children, e, f, b);
        case $9c351ca3251b0a6f$var$za:
            g = 8;
            e |= 8;
            break;
        case $9c351ca3251b0a6f$var$Aa:
            return a = $9c351ca3251b0a6f$var$Bg(12, c, b, e | 2), a.elementType = $9c351ca3251b0a6f$var$Aa, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Ea:
            return a = $9c351ca3251b0a6f$var$Bg(13, c, b, e), a.elementType = $9c351ca3251b0a6f$var$Ea, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Fa:
            return a = $9c351ca3251b0a6f$var$Bg(19, c, b, e), a.elementType = $9c351ca3251b0a6f$var$Fa, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Ia:
            return $9c351ca3251b0a6f$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9c351ca3251b0a6f$var$Ba:
                    g = 10;
                    break a;
                case $9c351ca3251b0a6f$var$Ca:
                    g = 9;
                    break a;
                case $9c351ca3251b0a6f$var$Da:
                    g = 11;
                    break a;
                case $9c351ca3251b0a6f$var$Ga:
                    g = 14;
                    break a;
                case $9c351ca3251b0a6f$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9c351ca3251b0a6f$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9c351ca3251b0a6f$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9c351ca3251b0a6f$var$Tg(a, b, c, d) {
    a = $9c351ca3251b0a6f$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9c351ca3251b0a6f$var$pj(a, b, c, d) {
    a = $9c351ca3251b0a6f$var$Bg(22, a, d, b);
    a.elementType = $9c351ca3251b0a6f$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9c351ca3251b0a6f$var$Qg(a, b, c) {
    a = $9c351ca3251b0a6f$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9c351ca3251b0a6f$var$Sg(a, b, c) {
    b = $9c351ca3251b0a6f$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9c351ca3251b0a6f$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9c351ca3251b0a6f$var$zc(0);
    this.expirationTimes = $9c351ca3251b0a6f$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9c351ca3251b0a6f$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9c351ca3251b0a6f$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9c351ca3251b0a6f$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9c351ca3251b0a6f$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9c351ca3251b0a6f$var$kh(f);
    return a;
}
function $9c351ca3251b0a6f$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9c351ca3251b0a6f$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9c351ca3251b0a6f$var$dl(a) {
    if (!a) return $9c351ca3251b0a6f$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9c351ca3251b0a6f$var$Vb(a) !== a || 1 !== a.tag) throw Error($9c351ca3251b0a6f$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9c351ca3251b0a6f$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9c351ca3251b0a6f$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9c351ca3251b0a6f$var$Zf(c)) return $9c351ca3251b0a6f$var$bg(a, c, b);
    }
    return b;
}
function $9c351ca3251b0a6f$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9c351ca3251b0a6f$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9c351ca3251b0a6f$var$dl(null);
    c = a.current;
    d = $9c351ca3251b0a6f$var$R();
    e = $9c351ca3251b0a6f$var$yi(c);
    f = $9c351ca3251b0a6f$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9c351ca3251b0a6f$var$nh(c, f, e);
    a.current.lanes = e;
    $9c351ca3251b0a6f$var$Ac(a, e, d);
    $9c351ca3251b0a6f$var$Dk(a, d);
    return a;
}
function $9c351ca3251b0a6f$var$fl(a, b, c, d) {
    var e = b.current, f = $9c351ca3251b0a6f$var$R(), g = $9c351ca3251b0a6f$var$yi(e);
    c = $9c351ca3251b0a6f$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9c351ca3251b0a6f$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9c351ca3251b0a6f$var$nh(e, b, g);
    null !== a && ($9c351ca3251b0a6f$var$gi(a, e, g, f), $9c351ca3251b0a6f$var$oh(a, e, g));
    return g;
}
function $9c351ca3251b0a6f$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9c351ca3251b0a6f$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9c351ca3251b0a6f$var$il(a, b) {
    $9c351ca3251b0a6f$var$hl(a, b);
    (a = a.alternate) && $9c351ca3251b0a6f$var$hl(a, b);
}
function $9c351ca3251b0a6f$var$jl() {
    return null;
}
var $9c351ca3251b0a6f$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9c351ca3251b0a6f$var$ll(a) {
    this._internalRoot = a;
}
$9c351ca3251b0a6f$var$ml.prototype.render = $9c351ca3251b0a6f$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9c351ca3251b0a6f$var$p(409));
    $9c351ca3251b0a6f$var$fl(a, b, null, null);
};
$9c351ca3251b0a6f$var$ml.prototype.unmount = $9c351ca3251b0a6f$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9c351ca3251b0a6f$var$Rk(function() {
            $9c351ca3251b0a6f$var$fl(null, a, null, null);
        });
        b[$9c351ca3251b0a6f$var$uf] = null;
    }
};
function $9c351ca3251b0a6f$var$ml(a) {
    this._internalRoot = a;
}
$9c351ca3251b0a6f$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9c351ca3251b0a6f$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9c351ca3251b0a6f$var$Qc.length && 0 !== b && b < $9c351ca3251b0a6f$var$Qc[c].priority; c++);
        $9c351ca3251b0a6f$var$Qc.splice(c, 0, a);
        0 === c && $9c351ca3251b0a6f$var$Vc(a);
    }
};
function $9c351ca3251b0a6f$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9c351ca3251b0a6f$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9c351ca3251b0a6f$var$pl() {}
function $9c351ca3251b0a6f$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9c351ca3251b0a6f$var$gl(g);
                f.call(a);
            };
        }
        var g = $9c351ca3251b0a6f$var$el(b, d, a, 0, null, !1, !1, "", $9c351ca3251b0a6f$var$pl);
        a._reactRootContainer = g;
        a[$9c351ca3251b0a6f$var$uf] = g.current;
        $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9c351ca3251b0a6f$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9c351ca3251b0a6f$var$gl(k);
            h.call(a);
        };
    }
    var k = $9c351ca3251b0a6f$var$bl(a, 0, !1, null, null, !1, !1, "", $9c351ca3251b0a6f$var$pl);
    a._reactRootContainer = k;
    a[$9c351ca3251b0a6f$var$uf] = k.current;
    $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9c351ca3251b0a6f$var$Rk(function() {
        $9c351ca3251b0a6f$var$fl(b, k, c, d);
    });
    return k;
}
function $9c351ca3251b0a6f$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9c351ca3251b0a6f$var$gl(g);
                h.call(a);
            };
        }
        $9c351ca3251b0a6f$var$fl(b, g, a, e);
    } else g = $9c351ca3251b0a6f$var$ql(c, b, a, e, d);
    return $9c351ca3251b0a6f$var$gl(g);
}
$9c351ca3251b0a6f$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9c351ca3251b0a6f$var$tc(b.pendingLanes);
                0 !== c && ($9c351ca3251b0a6f$var$Cc(b, c | 1), $9c351ca3251b0a6f$var$Dk(b, $9c351ca3251b0a6f$var$B()), 0 === ($9c351ca3251b0a6f$var$K & 6) && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$jg()));
            }
            break;
        case 13:
            $9c351ca3251b0a6f$var$Rk(function() {
                var b = $9c351ca3251b0a6f$var$ih(a, 1);
                if (null !== b) {
                    var c = $9c351ca3251b0a6f$var$R();
                    $9c351ca3251b0a6f$var$gi(b, a, 1, c);
                }
            }), $9c351ca3251b0a6f$var$il(a, 1);
    }
};
$9c351ca3251b0a6f$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9c351ca3251b0a6f$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9c351ca3251b0a6f$var$R();
            $9c351ca3251b0a6f$var$gi(b, a, 134217728, c);
        }
        $9c351ca3251b0a6f$var$il(a, 134217728);
    }
};
$9c351ca3251b0a6f$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9c351ca3251b0a6f$var$yi(a), c = $9c351ca3251b0a6f$var$ih(a, b);
        if (null !== c) {
            var d = $9c351ca3251b0a6f$var$R();
            $9c351ca3251b0a6f$var$gi(c, a, b, d);
        }
        $9c351ca3251b0a6f$var$il(a, b);
    }
};
$9c351ca3251b0a6f$var$Hc = function() {
    return $9c351ca3251b0a6f$var$C;
};
$9c351ca3251b0a6f$var$Ic = function(a, b) {
    var c = $9c351ca3251b0a6f$var$C;
    try {
        return $9c351ca3251b0a6f$var$C = a, b();
    } finally{
        $9c351ca3251b0a6f$var$C = c;
    }
};
$9c351ca3251b0a6f$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9c351ca3251b0a6f$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9c351ca3251b0a6f$var$Db(d);
                        if (!e) throw Error($9c351ca3251b0a6f$var$p(90));
                        $9c351ca3251b0a6f$var$Wa(d);
                        $9c351ca3251b0a6f$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9c351ca3251b0a6f$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9c351ca3251b0a6f$var$fb(a, !!c.multiple, b, !1);
    }
};
$9c351ca3251b0a6f$var$Gb = $9c351ca3251b0a6f$var$Qk;
$9c351ca3251b0a6f$var$Hb = $9c351ca3251b0a6f$var$Rk;
var $9c351ca3251b0a6f$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9c351ca3251b0a6f$var$Cb,
        $9c351ca3251b0a6f$var$ue,
        $9c351ca3251b0a6f$var$Db,
        $9c351ca3251b0a6f$var$Eb,
        $9c351ca3251b0a6f$var$Fb,
        $9c351ca3251b0a6f$var$Qk
    ]
}, $9c351ca3251b0a6f$var$tl = {
    findFiberByHostInstance: $9c351ca3251b0a6f$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9c351ca3251b0a6f$var$ul = {
    bundleType: $9c351ca3251b0a6f$var$tl.bundleType,
    version: $9c351ca3251b0a6f$var$tl.version,
    rendererPackageName: $9c351ca3251b0a6f$var$tl.rendererPackageName,
    rendererConfig: $9c351ca3251b0a6f$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9c351ca3251b0a6f$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9c351ca3251b0a6f$var$tl.findFiberByHostInstance || $9c351ca3251b0a6f$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9c351ca3251b0a6f$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9c351ca3251b0a6f$var$vl.isDisabled && $9c351ca3251b0a6f$var$vl.supportsFiber) try {
        $9c351ca3251b0a6f$var$kc = $9c351ca3251b0a6f$var$vl.inject($9c351ca3251b0a6f$var$ul), $9c351ca3251b0a6f$var$lc = $9c351ca3251b0a6f$var$vl;
    } catch (a) {}
}
$9c351ca3251b0a6f$export$ae55be85d98224ed = $9c351ca3251b0a6f$var$sl;
$9c351ca3251b0a6f$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9c351ca3251b0a6f$var$nl(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$cl(a, b, null, c);
};
$9c351ca3251b0a6f$export$882461b6382ed46c = function(a, b) {
    if (!$9c351ca3251b0a6f$var$nl(a)) throw Error($9c351ca3251b0a6f$var$p(299));
    var c = !1, d = "", e = $9c351ca3251b0a6f$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9c351ca3251b0a6f$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9c351ca3251b0a6f$var$uf] = b.current;
    $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9c351ca3251b0a6f$var$ll(b);
};
$9c351ca3251b0a6f$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9c351ca3251b0a6f$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9c351ca3251b0a6f$var$p(268, a));
    }
    a = $9c351ca3251b0a6f$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9c351ca3251b0a6f$export$cd75ccfd720a3cd4 = function(a) {
    return $9c351ca3251b0a6f$var$Rk(a);
};
$9c351ca3251b0a6f$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$ol(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$rl(null, a, b, !0, c);
};
$9c351ca3251b0a6f$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$nl(a)) throw Error($9c351ca3251b0a6f$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9c351ca3251b0a6f$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9c351ca3251b0a6f$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9c351ca3251b0a6f$var$uf] = b.current;
    $9c351ca3251b0a6f$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9c351ca3251b0a6f$var$ml(b);
};
$9c351ca3251b0a6f$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$ol(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$rl(null, a, b, !1, c);
};
$9c351ca3251b0a6f$export$502457920280e6be = function(a) {
    if (!$9c351ca3251b0a6f$var$ol(a)) throw Error($9c351ca3251b0a6f$var$p(40));
    return a._reactRootContainer ? ($9c351ca3251b0a6f$var$Rk(function() {
        $9c351ca3251b0a6f$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9c351ca3251b0a6f$var$uf] = null;
        });
    }), !0) : !1;
};
$9c351ca3251b0a6f$export$c78a37762a8d58e1 = $9c351ca3251b0a6f$var$Qk;
$9c351ca3251b0a6f$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9c351ca3251b0a6f$var$ol(c)) throw Error($9c351ca3251b0a6f$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9c351ca3251b0a6f$var$p(38));
    return $9c351ca3251b0a6f$var$rl(a, b, c, !1, d);
};
$9c351ca3251b0a6f$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lnhio", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2i6kG"));

});
parcelRegister("2i6kG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1ab22cb55c6f35de$export$c4744153514ff05d, (v) => $1ab22cb55c6f35de$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1ab22cb55c6f35de$export$3e506c1ccc9cc1a7, (v) => $1ab22cb55c6f35de$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1ab22cb55c6f35de$export$e26fe2ed2fa76875, (v) => $1ab22cb55c6f35de$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1ab22cb55c6f35de$export$502329bbf4b505b1, (v) => $1ab22cb55c6f35de$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1ab22cb55c6f35de$export$6e3807111c4874c4, (v) => $1ab22cb55c6f35de$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1ab22cb55c6f35de$export$c27134553091fb3a, (v) => $1ab22cb55c6f35de$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1ab22cb55c6f35de$export$33ee1acdc04fd2a2, (v) => $1ab22cb55c6f35de$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1ab22cb55c6f35de$export$b00a404bbd5edef2, (v) => $1ab22cb55c6f35de$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1ab22cb55c6f35de$export$8352ce38b91d0c62, (v) => $1ab22cb55c6f35de$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1ab22cb55c6f35de$export$d66a1c1c77bd778b, (v) => $1ab22cb55c6f35de$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1ab22cb55c6f35de$export$d3dfb8e4810cb555, (v) => $1ab22cb55c6f35de$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1ab22cb55c6f35de$export$839f9183b0465a69, (v) => $1ab22cb55c6f35de$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1ab22cb55c6f35de$export$72fdf0e06517287b, (v) => $1ab22cb55c6f35de$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1ab22cb55c6f35de$export$4b844e58a3e414b4, (v) => $1ab22cb55c6f35de$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1ab22cb55c6f35de$export$816d2913ae6b83b1, (v) => $1ab22cb55c6f35de$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1ab22cb55c6f35de$export$61bcfe829111a1d0, (v) => $1ab22cb55c6f35de$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1ab22cb55c6f35de$export$7ee8c9beb337bc3f, (v) => $1ab22cb55c6f35de$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1ab22cb55c6f35de$export$b5836b71941fa3ed, (v) => $1ab22cb55c6f35de$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1ab22cb55c6f35de$export$cf845f2c119da08a, (v) => $1ab22cb55c6f35de$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1ab22cb55c6f35de$export$c4744153514ff05d;
var $1ab22cb55c6f35de$export$3e506c1ccc9cc1a7;
var $1ab22cb55c6f35de$export$e26fe2ed2fa76875;
var $1ab22cb55c6f35de$export$502329bbf4b505b1;
var $1ab22cb55c6f35de$export$6e3807111c4874c4;
var $1ab22cb55c6f35de$export$c27134553091fb3a;
var $1ab22cb55c6f35de$export$33ee1acdc04fd2a2;
var $1ab22cb55c6f35de$export$b00a404bbd5edef2;
var $1ab22cb55c6f35de$export$8352ce38b91d0c62;
var $1ab22cb55c6f35de$export$d66a1c1c77bd778b;
var $1ab22cb55c6f35de$export$d3dfb8e4810cb555;
var $1ab22cb55c6f35de$export$839f9183b0465a69;
var $1ab22cb55c6f35de$export$72fdf0e06517287b;
var $1ab22cb55c6f35de$export$4b844e58a3e414b4;
var $1ab22cb55c6f35de$export$816d2913ae6b83b1;
var $1ab22cb55c6f35de$export$61bcfe829111a1d0;
var $1ab22cb55c6f35de$export$7ee8c9beb337bc3f;
var $1ab22cb55c6f35de$export$b5836b71941fa3ed;
var $1ab22cb55c6f35de$export$cf845f2c119da08a;
"use strict";
function $1ab22cb55c6f35de$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1ab22cb55c6f35de$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1ab22cb55c6f35de$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1ab22cb55c6f35de$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1ab22cb55c6f35de$var$g(C, c)) n < e && 0 > $1ab22cb55c6f35de$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1ab22cb55c6f35de$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1ab22cb55c6f35de$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1ab22cb55c6f35de$var$l = performance;
    $1ab22cb55c6f35de$export$c4744153514ff05d = function() {
        return $1ab22cb55c6f35de$var$l.now();
    };
} else {
    var $1ab22cb55c6f35de$var$p = Date, $1ab22cb55c6f35de$var$q = $1ab22cb55c6f35de$var$p.now();
    $1ab22cb55c6f35de$export$c4744153514ff05d = function() {
        return $1ab22cb55c6f35de$var$p.now() - $1ab22cb55c6f35de$var$q;
    };
}
var $1ab22cb55c6f35de$var$r = [], $1ab22cb55c6f35de$var$t = [], $1ab22cb55c6f35de$var$u = 1, $1ab22cb55c6f35de$var$v = null, $1ab22cb55c6f35de$var$y = 3, $1ab22cb55c6f35de$var$z = !1, $1ab22cb55c6f35de$var$A = !1, $1ab22cb55c6f35de$var$B = !1, $1ab22cb55c6f35de$var$D = "function" === typeof setTimeout ? setTimeout : null, $1ab22cb55c6f35de$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1ab22cb55c6f35de$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1ab22cb55c6f35de$var$G(a) {
    for(var b = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$t); null !== b;){
        if (null === b.callback) $1ab22cb55c6f35de$var$k($1ab22cb55c6f35de$var$t);
        else if (b.startTime <= a) $1ab22cb55c6f35de$var$k($1ab22cb55c6f35de$var$t), b.sortIndex = b.expirationTime, $1ab22cb55c6f35de$var$f($1ab22cb55c6f35de$var$r, b);
        else break;
        b = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$t);
    }
}
function $1ab22cb55c6f35de$var$H(a) {
    $1ab22cb55c6f35de$var$B = !1;
    $1ab22cb55c6f35de$var$G(a);
    if (!$1ab22cb55c6f35de$var$A) {
        if (null !== $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r)) $1ab22cb55c6f35de$var$A = !0, $1ab22cb55c6f35de$var$I($1ab22cb55c6f35de$var$J);
        else {
            var b = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$t);
            null !== b && $1ab22cb55c6f35de$var$K($1ab22cb55c6f35de$var$H, b.startTime - a);
        }
    }
}
function $1ab22cb55c6f35de$var$J(a, b) {
    $1ab22cb55c6f35de$var$A = !1;
    $1ab22cb55c6f35de$var$B && ($1ab22cb55c6f35de$var$B = !1, $1ab22cb55c6f35de$var$E($1ab22cb55c6f35de$var$L), $1ab22cb55c6f35de$var$L = -1);
    $1ab22cb55c6f35de$var$z = !0;
    var c = $1ab22cb55c6f35de$var$y;
    try {
        $1ab22cb55c6f35de$var$G(b);
        for($1ab22cb55c6f35de$var$v = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r); null !== $1ab22cb55c6f35de$var$v && (!($1ab22cb55c6f35de$var$v.expirationTime > b) || a && !$1ab22cb55c6f35de$var$M());){
            var d = $1ab22cb55c6f35de$var$v.callback;
            if ("function" === typeof d) {
                $1ab22cb55c6f35de$var$v.callback = null;
                $1ab22cb55c6f35de$var$y = $1ab22cb55c6f35de$var$v.priorityLevel;
                var e = d($1ab22cb55c6f35de$var$v.expirationTime <= b);
                b = $1ab22cb55c6f35de$export$c4744153514ff05d();
                "function" === typeof e ? $1ab22cb55c6f35de$var$v.callback = e : $1ab22cb55c6f35de$var$v === $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r) && $1ab22cb55c6f35de$var$k($1ab22cb55c6f35de$var$r);
                $1ab22cb55c6f35de$var$G(b);
            } else $1ab22cb55c6f35de$var$k($1ab22cb55c6f35de$var$r);
            $1ab22cb55c6f35de$var$v = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r);
        }
        if (null !== $1ab22cb55c6f35de$var$v) var w = !0;
        else {
            var m = $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$t);
            null !== m && $1ab22cb55c6f35de$var$K($1ab22cb55c6f35de$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1ab22cb55c6f35de$var$v = null, $1ab22cb55c6f35de$var$y = c, $1ab22cb55c6f35de$var$z = !1;
    }
}
var $1ab22cb55c6f35de$var$N = !1, $1ab22cb55c6f35de$var$O = null, $1ab22cb55c6f35de$var$L = -1, $1ab22cb55c6f35de$var$P = 5, $1ab22cb55c6f35de$var$Q = -1;
function $1ab22cb55c6f35de$var$M() {
    return $1ab22cb55c6f35de$export$c4744153514ff05d() - $1ab22cb55c6f35de$var$Q < $1ab22cb55c6f35de$var$P ? !1 : !0;
}
function $1ab22cb55c6f35de$var$R() {
    if (null !== $1ab22cb55c6f35de$var$O) {
        var a = $1ab22cb55c6f35de$export$c4744153514ff05d();
        $1ab22cb55c6f35de$var$Q = a;
        var b = !0;
        try {
            b = $1ab22cb55c6f35de$var$O(!0, a);
        } finally{
            b ? $1ab22cb55c6f35de$var$S() : ($1ab22cb55c6f35de$var$N = !1, $1ab22cb55c6f35de$var$O = null);
        }
    } else $1ab22cb55c6f35de$var$N = !1;
}
var $1ab22cb55c6f35de$var$S;
if ("function" === typeof $1ab22cb55c6f35de$var$F) $1ab22cb55c6f35de$var$S = function() {
    $1ab22cb55c6f35de$var$F($1ab22cb55c6f35de$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1ab22cb55c6f35de$var$T = new MessageChannel, $1ab22cb55c6f35de$var$U = $1ab22cb55c6f35de$var$T.port2;
    $1ab22cb55c6f35de$var$T.port1.onmessage = $1ab22cb55c6f35de$var$R;
    $1ab22cb55c6f35de$var$S = function() {
        $1ab22cb55c6f35de$var$U.postMessage(null);
    };
} else $1ab22cb55c6f35de$var$S = function() {
    $1ab22cb55c6f35de$var$D($1ab22cb55c6f35de$var$R, 0);
};
function $1ab22cb55c6f35de$var$I(a) {
    $1ab22cb55c6f35de$var$O = a;
    $1ab22cb55c6f35de$var$N || ($1ab22cb55c6f35de$var$N = !0, $1ab22cb55c6f35de$var$S());
}
function $1ab22cb55c6f35de$var$K(a, b) {
    $1ab22cb55c6f35de$var$L = $1ab22cb55c6f35de$var$D(function() {
        a($1ab22cb55c6f35de$export$c4744153514ff05d());
    }, b);
}
$1ab22cb55c6f35de$export$3e506c1ccc9cc1a7 = 5;
$1ab22cb55c6f35de$export$e26fe2ed2fa76875 = 1;
$1ab22cb55c6f35de$export$502329bbf4b505b1 = 4;
$1ab22cb55c6f35de$export$6e3807111c4874c4 = 3;
$1ab22cb55c6f35de$export$c27134553091fb3a = null;
$1ab22cb55c6f35de$export$33ee1acdc04fd2a2 = 2;
$1ab22cb55c6f35de$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1ab22cb55c6f35de$export$8352ce38b91d0c62 = function() {
    $1ab22cb55c6f35de$var$A || $1ab22cb55c6f35de$var$z || ($1ab22cb55c6f35de$var$A = !0, $1ab22cb55c6f35de$var$I($1ab22cb55c6f35de$var$J));
};
$1ab22cb55c6f35de$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1ab22cb55c6f35de$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1ab22cb55c6f35de$export$d3dfb8e4810cb555 = function() {
    return $1ab22cb55c6f35de$var$y;
};
$1ab22cb55c6f35de$export$839f9183b0465a69 = function() {
    return $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r);
};
$1ab22cb55c6f35de$export$72fdf0e06517287b = function(a) {
    switch($1ab22cb55c6f35de$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1ab22cb55c6f35de$var$y;
    }
    var c = $1ab22cb55c6f35de$var$y;
    $1ab22cb55c6f35de$var$y = b;
    try {
        return a();
    } finally{
        $1ab22cb55c6f35de$var$y = c;
    }
};
$1ab22cb55c6f35de$export$4b844e58a3e414b4 = function() {};
$1ab22cb55c6f35de$export$816d2913ae6b83b1 = function() {};
$1ab22cb55c6f35de$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1ab22cb55c6f35de$var$y;
    $1ab22cb55c6f35de$var$y = a;
    try {
        return b();
    } finally{
        $1ab22cb55c6f35de$var$y = c;
    }
};
$1ab22cb55c6f35de$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1ab22cb55c6f35de$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1ab22cb55c6f35de$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1ab22cb55c6f35de$var$f($1ab22cb55c6f35de$var$t, a), null === $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$r) && a === $1ab22cb55c6f35de$var$h($1ab22cb55c6f35de$var$t) && ($1ab22cb55c6f35de$var$B ? ($1ab22cb55c6f35de$var$E($1ab22cb55c6f35de$var$L), $1ab22cb55c6f35de$var$L = -1) : $1ab22cb55c6f35de$var$B = !0, $1ab22cb55c6f35de$var$K($1ab22cb55c6f35de$var$H, c - d))) : (a.sortIndex = e, $1ab22cb55c6f35de$var$f($1ab22cb55c6f35de$var$r, a), $1ab22cb55c6f35de$var$A || $1ab22cb55c6f35de$var$z || ($1ab22cb55c6f35de$var$A = !0, $1ab22cb55c6f35de$var$I($1ab22cb55c6f35de$var$J)));
    return a;
};
$1ab22cb55c6f35de$export$b5836b71941fa3ed = $1ab22cb55c6f35de$var$M;
$1ab22cb55c6f35de$export$cf845f2c119da08a = function(a) {
    var b = $1ab22cb55c6f35de$var$y;
    return function() {
        var c = $1ab22cb55c6f35de$var$y;
        $1ab22cb55c6f35de$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1ab22cb55c6f35de$var$y = c;
        }
    };
};

});



parcelRegister("hWy5B", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $lKqck = parcelRequire("lKqck");
function $d1024be949a4fae7$var$emptyFunction() {}
function $d1024be949a4fae7$var$emptyFunctionWithReset() {}
$d1024be949a4fae7$var$emptyFunctionWithReset.resetWarningCache = $d1024be949a4fae7$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lKqck) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d1024be949a4fae7$var$emptyFunctionWithReset,
        resetWarningCache: $d1024be949a4fae7$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lKqck", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $fd523734c7da616c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $fd523734c7da616c$var$ReactPropTypesSecret;

});


parcelRegister("aUQjb", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("bIVSC", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $8890b3829b547d9a$export$306c0aa65ff9ec16, (v) => $8890b3829b547d9a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8890b3829b547d9a$export$306c0aa65ff9ec16;
"use strict";

var $dup7A = parcelRequire("dup7A");
function $8890b3829b547d9a$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8890b3829b547d9a$var$k = "function" === typeof Object.is ? Object.is : $8890b3829b547d9a$var$h, $8890b3829b547d9a$var$l = $dup7A.useState, $8890b3829b547d9a$var$m = $dup7A.useEffect, $8890b3829b547d9a$var$n = $dup7A.useLayoutEffect, $8890b3829b547d9a$var$p = $dup7A.useDebugValue;
function $8890b3829b547d9a$var$q(a, b) {
    var d = b(), f = $8890b3829b547d9a$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8890b3829b547d9a$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8890b3829b547d9a$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8890b3829b547d9a$var$m(function() {
        $8890b3829b547d9a$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8890b3829b547d9a$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8890b3829b547d9a$var$p(d);
    return d;
}
function $8890b3829b547d9a$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8890b3829b547d9a$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8890b3829b547d9a$var$t(a, b) {
    return b();
}
var $8890b3829b547d9a$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8890b3829b547d9a$var$t : $8890b3829b547d9a$var$q;
$8890b3829b547d9a$export$306c0aa65ff9ec16 = void 0 !== $dup7A.useSyncExternalStore ? $dup7A.useSyncExternalStore : $8890b3829b547d9a$var$u;

});

parcelRegister("eUiaP", function(module, exports) {

$parcel$export(module.exports, "configureChains", () => configureChains);
$parcel$export(module.exports, "deepEqual", () => deepEqual);
$parcel$export(module.exports, "getCallParameters", () => getCallParameters);
$parcel$export(module.exports, "getSendTransactionParameters", () => getSendTransactionParameters);
$parcel$export(module.exports, "noopStorage", () => noopStorage);
$parcel$export(module.exports, "createStorage", () => createStorage);
$parcel$export(module.exports, "createConfig", () => createConfig);
$parcel$export(module.exports, "connect", () => connect);
$parcel$export(module.exports, "disconnect", () => disconnect);
$parcel$export(module.exports, "fetchToken", () => fetchToken);
$parcel$export(module.exports, "readContracts", () => readContracts);
$parcel$export(module.exports, "getPublicClient", () => getPublicClient);
$parcel$export(module.exports, "getWalletClient", () => getWalletClient);
$parcel$export(module.exports, "getWebSocketPublicClient", () => getWebSocketPublicClient);
$parcel$export(module.exports, "watchPublicClient", () => watchPublicClient);
$parcel$export(module.exports, "watchWalletClient", () => watchWalletClient);
$parcel$export(module.exports, "watchWebSocketPublicClient", () => watchWebSocketPublicClient);
$parcel$export(module.exports, "prepareWriteContract", () => prepareWriteContract);
$parcel$export(module.exports, "getContract", () => getContract);
$parcel$export(module.exports, "readContract", () => readContract);
$parcel$export(module.exports, "watchContractEvent", () => watchContractEvent);
$parcel$export(module.exports, "writeContract", () => writeContract);
$parcel$export(module.exports, "fetchBalance", () => fetchBalance);
$parcel$export(module.exports, "getAccount", () => getAccount);
$parcel$export(module.exports, "getNetwork", () => getNetwork);
$parcel$export(module.exports, "signMessage", () => signMessage);
$parcel$export(module.exports, "signTypedData", () => signTypedData);
$parcel$export(module.exports, "switchNetwork", () => switchNetwork);
$parcel$export(module.exports, "watchAccount", () => watchAccount);
$parcel$export(module.exports, "watchNetwork", () => watchNetwork);
$parcel$export(module.exports, "fetchEnsAddress", () => fetchEnsAddress);
$parcel$export(module.exports, "fetchEnsAvatar", () => fetchEnsAvatar);
$parcel$export(module.exports, "fetchEnsName", () => fetchEnsName);
$parcel$export(module.exports, "fetchEnsResolver", () => fetchEnsResolver);
$parcel$export(module.exports, "fetchBlockNumber", () => fetchBlockNumber);
$parcel$export(module.exports, "fetchFeeData", () => fetchFeeData);
$parcel$export(module.exports, "fetchTransaction", () => fetchTransaction);
$parcel$export(module.exports, "prepareSendTransaction", () => prepareSendTransaction);
$parcel$export(module.exports, "sendTransaction", () => sendTransaction);
$parcel$export(module.exports, "waitForTransaction", () => waitForTransaction);

var $12u0G = parcelRequire("12u0G");

var $5kw0a = parcelRequire("5kw0a");

var $hdmf8 = parcelRequire("hdmf8");
var $8H2x6 = parcelRequire("8H2x6");
var $jOvAN = parcelRequire("jOvAN");
var $lTCHO = parcelRequire("lTCHO");
var $aegFK = parcelRequire("aegFK");
var $3MzNb = parcelRequire("3MzNb");
var $dKCgU = parcelRequire("dKCgU");
var $8p0q4 = parcelRequire("8p0q4");
var $gg0RY = parcelRequire("gg0RY");
var $9bv14 = parcelRequire("9bv14");
var $f6c2v = parcelRequire("f6c2v");
var $ioTPL = parcelRequire("ioTPL");
var $987xW = parcelRequire("987xW");

var $igV1L = parcelRequire("igV1L");

var $11Szb = parcelRequire("11Szb");

var $i57sw = parcelRequire("i57sw");

var $cZFtK = parcelRequire("cZFtK");
function configureChains(defaultChains, providers, { batch = {
    multicall: {
        wait: 32
    }
}, pollingInterval = 4e3, rank, retryCount, retryDelay, stallTimeout } = {}) {
    if (!defaultChains.length) throw new Error("must have at least one chain");
    let chains = [];
    const httpUrls = {};
    const wsUrls = {};
    for (const chain of defaultChains){
        let configExists = false;
        for (const provider of providers){
            const apiConfig = provider(chain);
            if (!apiConfig) continue;
            configExists = true;
            if (!chains.some(({ id })=>id === chain.id)) chains = [
                ...chains,
                apiConfig.chain
            ];
            httpUrls[chain.id] = [
                ...httpUrls[chain.id] || [],
                ...apiConfig.rpcUrls.http
            ];
            if (apiConfig.rpcUrls.webSocket) wsUrls[chain.id] = [
                ...wsUrls[chain.id] || [],
                ...apiConfig.rpcUrls.webSocket
            ];
        }
        if (!configExists) throw new Error([
            `Could not find valid provider configuration for chain "${chain.name}".
`,
            "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.",
            "Read more: https://wagmi.sh/core/providers/jsonRpc"
        ].join("\n"));
    }
    return {
        chains: chains,
        publicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainHttpUrls = httpUrls[activeChain.id];
            if (!chainHttpUrls || !chainHttpUrls[0]) throw new Error(`No providers configured for chain "${activeChain.id}"`);
            const publicClient = (0, $8H2x6.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $jOvAN.fallback)(chainHttpUrls.map((url)=>(0, $8p0q4.http)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        },
        webSocketPublicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainWsUrls = wsUrls[activeChain.id];
            if (!chainWsUrls || !chainWsUrls[0]) return void 0;
            const publicClient = (0, $8H2x6.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $jOvAN.fallback)(chainWsUrls.map((url)=>(0, $ioTPL.webSocket)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        }
    };
}
var ChainMismatchError = class extends Error {
    constructor({ activeChain, targetChain }){
        super(`Chain mismatch: Expected "${targetChain}", received "${activeChain}".`);
        this.name = "ChainMismatchError";
    }
};
var ChainNotConfiguredError = class extends Error {
    constructor({ chainId, connectorId }){
        super(`Chain "${chainId}" not configured${connectorId ? ` for connector "${connectorId}"` : ""}.`);
        this.name = "ChainNotConfigured";
    }
};
var ConnectorAlreadyConnectedError = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorAlreadyConnectedError";
        this.message = "Connector already connected";
    }
};
var ConfigChainsNotFound = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConfigChainsNotFound";
        this.message = "No chains were found on the wagmi config. Some functions that require a chain may not work.";
    }
};
var SwitchChainNotSupportedError = class extends Error {
    constructor({ connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        this.name = "SwitchChainNotSupportedError";
    }
};
// src/utils/deepEqual.ts
function deepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
// src/utils/deserialize.ts
var findAndReplace = (cacheRef, { find, replace })=>{
    if (cacheRef && find(cacheRef)) return replace(cacheRef);
    if (typeof cacheRef !== "object") return cacheRef;
    if (Array.isArray(cacheRef)) return cacheRef.map((item)=>findAndReplace(item, {
            find: find,
            replace: replace
        }));
    if (cacheRef instanceof Object) return Object.entries(cacheRef).reduce((curr, [key, value])=>({
            ...curr,
            [key]: findAndReplace(value, {
                find: find,
                replace: replace
            })
        }), {});
    return cacheRef;
};
function deserialize(cachedString) {
    const cache = JSON.parse(cachedString);
    const deserializedCacheWithBigInts = findAndReplace(cache, {
        find: (data)=>typeof data === "string" && data.startsWith("#bigint."),
        replace: (data)=>BigInt(data.replace("#bigint.", ""))
    });
    return deserializedCacheWithBigInts;
}
// src/utils/getParameters.ts
function getCallParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        blockNumber: args.blockNumber,
        blockTag: args.blockTag,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getSendTransactionParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getUnit(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $987xW.weiUnits)[unit]);
}
// src/utils/serialize.ts
function getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
function getCutoff(array, value) {
    const { length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
function createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, getReferenceKey(keys, valueCutoff)) : `[ref=${getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function serialize(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, createReplacer((key, value_)=>{
        const value2 = typeof value_ === "bigint" ? `#bigint.${value_.toString()}` : value_;
        return replacer?.(key, value2) || value2;
    }, circularReplacer), indent ?? void 0);
}
// src/storage.ts
var noopStorage = {
    getItem: (_key)=>"",
    setItem: (_key, _value)=>null,
    removeItem: (_key)=>null
};
function createStorage({ deserialize: deserialize2 = deserialize, key: prefix = "wagmi", serialize: serialize2 = serialize, storage }) {
    return {
        ...storage,
        getItem: (key, defaultState = null)=>{
            const value = storage.getItem(`${prefix}.${key}`);
            try {
                return value ? deserialize2(value) : defaultState;
            } catch (error) {
                console.warn(error);
                return defaultState;
            }
        },
        setItem: (key, value)=>{
            if (value === null) storage.removeItem(`${prefix}.${key}`);
            else try {
                storage.setItem(`${prefix}.${key}`, serialize2(value));
            } catch (err) {
                console.error(err);
            }
        },
        removeItem: (key)=>storage.removeItem(`${prefix}.${key}`)
    };
}
// src/config.ts
var storeKey = "store";
var _isAutoConnecting, _lastUsedConnector, _addEffects, addEffects_fn;
var Config = class {
    constructor({ autoConnect = false, connectors = [
        new (0, $12u0G.InjectedConnector)()
    ], publicClient, storage = createStorage({
        storage: typeof window !== "undefined" ? window.localStorage : noopStorage
    }), logger = {
        warn: console.warn
    }, webSocketPublicClient }){
        (0, $5kw0a.__privateAdd)(this, _addEffects);
        this.publicClients = /* @__PURE__ */ new Map();
        this.webSocketPublicClients = /* @__PURE__ */ new Map();
        (0, $5kw0a.__privateAdd)(this, _isAutoConnecting, void 0);
        (0, $5kw0a.__privateAdd)(this, _lastUsedConnector, void 0);
        this.args = {
            autoConnect: autoConnect,
            connectors: connectors,
            logger: logger,
            publicClient: publicClient,
            storage: storage,
            webSocketPublicClient: webSocketPublicClient
        };
        let status = "disconnected";
        let chainId;
        if (autoConnect) try {
            const rawState = storage.getItem(storeKey);
            const data = rawState?.state?.data;
            status = data?.account ? "reconnecting" : "connecting";
            chainId = data?.chain?.id;
        } catch (_error) {}
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(storage));
        this.store = (0, $i57sw.createStore)((0, $11Szb.subscribeWithSelector)((0, $11Szb.persist)(()=>({
                connectors: connectors_,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                status: status,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }), {
            name: storeKey,
            storage: storage,
            partialize: (state)=>({
                    ...autoConnect && {
                        data: {
                            account: state?.data?.account,
                            chain: state?.data?.chain
                        }
                    },
                    chains: state?.chains
                }),
            version: 2
        })));
        this.storage = storage;
        (0, $5kw0a.__privateSet)(this, _lastUsedConnector, storage?.getItem("wallet"));
        (0, $5kw0a.__privateMethod)(this, _addEffects, addEffects_fn).call(this);
        if (autoConnect && typeof window !== "undefined") setTimeout(async ()=>await this.autoConnect(), 0);
    }
    get chains() {
        return this.store.getState().chains;
    }
    get connectors() {
        return this.store.getState().connectors;
    }
    get connector() {
        return this.store.getState().connector;
    }
    get data() {
        return this.store.getState().data;
    }
    get error() {
        return this.store.getState().error;
    }
    get lastUsedChainId() {
        return this.data?.chain?.id;
    }
    get publicClient() {
        return this.store.getState().publicClient;
    }
    get status() {
        return this.store.getState().status;
    }
    get subscribe() {
        return this.store.subscribe;
    }
    get webSocketPublicClient() {
        return this.store.getState().webSocketPublicClient;
    }
    setState(updater) {
        const newState = typeof updater === "function" ? updater(this.store.getState()) : updater;
        this.store.setState(newState, true);
    }
    clearState() {
        this.setState((x)=>({
                ...x,
                chains: void 0,
                connector: void 0,
                data: void 0,
                error: void 0,
                status: "disconnected"
            }));
    }
    async destroy() {
        if (this.connector) await this.connector.disconnect?.();
        (0, $5kw0a.__privateSet)(this, _isAutoConnecting, false);
        this.clearState();
        this.store.destroy();
    }
    async autoConnect() {
        if ((0, $5kw0a.__privateGet)(this, _isAutoConnecting)) return;
        (0, $5kw0a.__privateSet)(this, _isAutoConnecting, true);
        this.setState((x)=>({
                ...x,
                status: x.data?.account ? "reconnecting" : "connecting"
            }));
        const sorted = (0, $5kw0a.__privateGet)(this, _lastUsedConnector) ? [
            ...this.connectors
        ].sort((x)=>x.id === (0, $5kw0a.__privateGet)(this, _lastUsedConnector) ? -1 : 1) : this.connectors;
        let connected = false;
        for (const connector of sorted){
            if (!connector.ready || !connector.isAuthorized) continue;
            const isAuthorized = await connector.isAuthorized();
            if (!isAuthorized) continue;
            const data = await connector.connect();
            this.setState((x)=>({
                    ...x,
                    connector: connector,
                    chains: connector?.chains,
                    data: data,
                    status: "connected"
                }));
            connected = true;
            break;
        }
        if (!connected) this.setState((x)=>({
                ...x,
                data: void 0,
                status: "disconnected"
            }));
        (0, $5kw0a.__privateSet)(this, _isAutoConnecting, false);
        return this.data;
    }
    setConnectors(connectors) {
        this.args = {
            ...this.args,
            connectors: connectors
        };
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(this.args.storage));
        this.setState((x)=>({
                ...x,
                connectors: connectors_
            }));
    }
    getPublicClient({ chainId } = {}) {
        let publicClient_ = this.publicClients.get(-1);
        if (publicClient_ && publicClient_?.chain.id === chainId) return publicClient_;
        publicClient_ = this.publicClients.get(chainId ?? -1);
        if (publicClient_) return publicClient_;
        const { publicClient } = this.args;
        publicClient_ = typeof publicClient === "function" ? publicClient({
            chainId: chainId
        }) : publicClient;
        this.publicClients.set(chainId ?? -1, publicClient_);
        return publicClient_;
    }
    setPublicClient(publicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            publicClient: publicClient
        };
        this.publicClients.clear();
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                })
            }));
    }
    getWebSocketPublicClient({ chainId } = {}) {
        let webSocketPublicClient_ = this.webSocketPublicClients.get(-1);
        if (webSocketPublicClient_ && webSocketPublicClient_?.chain.id === chainId) return webSocketPublicClient_;
        webSocketPublicClient_ = this.webSocketPublicClients.get(chainId ?? -1);
        if (webSocketPublicClient_) return webSocketPublicClient_;
        const { webSocketPublicClient } = this.args;
        webSocketPublicClient_ = typeof webSocketPublicClient === "function" ? webSocketPublicClient({
            chainId: chainId
        }) : webSocketPublicClient;
        if (webSocketPublicClient_) this.webSocketPublicClients.set(chainId ?? -1, webSocketPublicClient_);
        return webSocketPublicClient_;
    }
    setWebSocketPublicClient(webSocketPublicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            webSocketPublicClient: webSocketPublicClient
        };
        this.webSocketPublicClients.clear();
        this.setState((x)=>({
                ...x,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    }
    setLastUsedConnector(lastUsedConnector = null) {
        this.storage?.setItem("wallet", lastUsedConnector);
    }
};
_isAutoConnecting = new WeakMap();
_lastUsedConnector = new WeakMap();
_addEffects = new WeakSet();
addEffects_fn = function() {
    const onChange = (data)=>{
        this.setState((x)=>({
                ...x,
                data: {
                    ...x.data,
                    ...data
                }
            }));
    };
    const onDisconnect = ()=>{
        this.clearState();
    };
    const onError = (error)=>{
        this.setState((x)=>({
                ...x,
                error: error
            }));
    };
    this.store.subscribe(({ connector })=>connector, (connector, prevConnector)=>{
        prevConnector?.off?.("change", onChange);
        prevConnector?.off?.("disconnect", onDisconnect);
        prevConnector?.off?.("error", onError);
        if (!connector) return;
        connector.on?.("change", onChange);
        connector.on?.("disconnect", onDisconnect);
        connector.on?.("error", onError);
    });
    const { publicClient, webSocketPublicClient } = this.args;
    const subscribePublicClient = typeof publicClient === "function";
    const subscribeWebSocketPublicClient = typeof webSocketPublicClient === "function";
    if (subscribePublicClient || subscribeWebSocketPublicClient) this.store.subscribe(({ data })=>data?.chain?.id, (chainId)=>{
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    });
};
var config;
function createConfig(args) {
    const config_ = new Config(args);
    config = config_;
    return config_;
}
function getConfig() {
    if (!config) throw new Error("No wagmi config found. Ensure you have set up a config: https://wagmi.sh/react/config");
    return config;
}
// src/actions/accounts/connect.ts
async function connect({ chainId, connector }) {
    const config2 = getConfig();
    const activeConnector = config2.connector;
    if (activeConnector && connector.id === activeConnector.id) throw new ConnectorAlreadyConnectedError();
    try {
        config2.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        const data = await connector.connect({
            chainId: chainId
        });
        config2.setLastUsedConnector(connector.id);
        config2.setState((x)=>({
                ...x,
                connector: connector,
                chains: connector?.chains,
                data: data,
                status: "connected"
            }));
        config2.storage.setItem("connected", true);
        return {
            ...data,
            connector: connector
        };
    } catch (err) {
        config2.setState((x)=>{
            return {
                ...x,
                status: x.connector ? "connected" : "disconnected"
            };
        });
        throw err;
    }
}
// src/actions/accounts/disconnect.ts
async function disconnect() {
    const config2 = getConfig();
    if (config2.connector) await config2.connector.disconnect();
    config2.clearState();
    config2.storage.removeItem("connected");
}
// src/constants/abis.ts
var erc20ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc20ABI_bytes32 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc721ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
var erc4626ABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
async function fetchToken({ address, chainId, formatUnits: unit = 18 }) {
    async function fetchToken_({ abi }) {
        const erc20Config = {
            address: address,
            abi: abi,
            chainId: chainId
        };
        const [decimals, name, symbol, totalSupply] = await readContracts({
            allowFailure: false,
            contracts: [
                {
                    ...erc20Config,
                    functionName: "decimals"
                },
                {
                    ...erc20Config,
                    functionName: "name"
                },
                {
                    ...erc20Config,
                    functionName: "symbol"
                },
                {
                    ...erc20Config,
                    functionName: "totalSupply"
                }
            ]
        });
        return {
            address: address,
            decimals: decimals,
            name: name,
            symbol: symbol,
            totalSupply: {
                formatted: (0, $lTCHO.formatUnits)(totalSupply, getUnit(unit)),
                value: totalSupply
            }
        };
    }
    try {
        return await fetchToken_({
            abi: erc20ABI
        });
    } catch (err) {
        if (err instanceof (0, $hdmf8.ContractFunctionExecutionError)) {
            const { name, symbol, ...rest } = await fetchToken_({
                abi: erc20ABI_bytes32
            });
            return {
                name: (0, $dKCgU.hexToString)((0, $f6c2v.trim)(name, {
                    dir: "right"
                })),
                symbol: (0, $dKCgU.hexToString)((0, $f6c2v.trim)(symbol, {
                    dir: "right"
                })),
                ...rest
            };
        }
        throw err;
    }
}
// src/actions/viem/getPublicClient.ts
function getPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getPublicClient({
        chainId: chainId
    }) || config2.publicClient;
    return config2.publicClient;
}
// src/actions/viem/getWalletClient.ts
async function getWalletClient({ chainId } = {}) {
    const config2 = getConfig();
    const walletClient = await config2.connector?.getWalletClient?.({
        chainId: chainId
    }) || null;
    return walletClient;
}
// src/actions/viem/getWebSocketPublicClient.ts
function getWebSocketPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getWebSocketPublicClient({
        chainId: chainId
    }) || config2.webSocketPublicClient;
    return config2.webSocketPublicClient;
}
// src/actions/viem/watchPublicClient.ts
function watchPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getPublicClient(args));
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return unsubscribe;
}
function watchWalletClient({ chainId }, callback) {
    const config2 = getConfig();
    const handleChange = async ({ chainId: chainId_ })=>{
        if (chainId && chainId_ && chainId !== chainId_) return;
        const walletClient = await getWalletClient({
            chainId: chainId
        });
        if (!getConfig().connector) return callback(null);
        return callback(walletClient);
    };
    const unsubscribe = config2.subscribe(({ data, connector })=>({
            account: data?.account,
            chainId: data?.chain?.id,
            connector: connector
        }), handleChange, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return unsubscribe;
}
// src/actions/viem/watchWebSocketPublicClient.ts
function watchWebSocketPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getWebSocketPublicClient(args));
    const unsubscribe = config2.subscribe(({ webSocketPublicClient })=>webSocketPublicClient, handleChange);
    return unsubscribe;
}
// src/actions/contracts/prepareWriteContract.ts
async function prepareWriteContract({ abi, address, args, chainId, dataSuffix, functionName, walletClient: walletClient_, ...config2 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const { account, accessList, blockNumber, blockTag, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, value } = getCallParameters(config2);
    const { result, request } = await publicClient.simulateContract({
        abi: abi,
        address: address,
        functionName: functionName,
        args: args,
        account: account || walletClient.account,
        accessList: accessList,
        blockNumber: blockNumber,
        blockTag: blockTag,
        dataSuffix: dataSuffix,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        value: value
    });
    const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === functionName);
    return {
        mode: "prepared",
        request: {
            ...request,
            abi: minimizedAbi,
            chainId: chainId
        },
        result: result
    };
}
function getContract({ address, abi, chainId, walletClient }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return (0, $3MzNb.getContract)({
        address: address,
        abi: abi,
        publicClient: publicClient,
        walletClient: walletClient
    });
}
// src/actions/contracts/multicall.ts
async function multicall({ chainId, contracts, blockNumber, blockTag, ...args }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (!publicClient.chains) throw new ConfigChainsNotFound();
    if (chainId && publicClient.chain.id !== chainId) throw new ChainNotConfiguredError({
        chainId: chainId
    });
    return publicClient.multicall({
        allowFailure: args.allowFailure ?? true,
        blockNumber: blockNumber,
        blockTag: blockTag,
        contracts: contracts
    });
}
// src/actions/contracts/readContract.ts
async function readContract({ address, account, chainId, abi, args, functionName, blockNumber, blockTag }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.readContract({
        abi: abi,
        address: address,
        account: account,
        functionName: functionName,
        args: args,
        blockNumber: blockNumber,
        blockTag: blockTag
    });
}
async function readContracts({ contracts, blockNumber, blockTag, ...args }) {
    const { allowFailure = true } = args;
    try {
        const publicClient = getPublicClient();
        const contractsByChainId = contracts.reduce((contracts2, contract, index)=>{
            const chainId = contract.chainId ?? publicClient.chain.id;
            return {
                ...contracts2,
                [chainId]: [
                    ...contracts2[chainId] || [],
                    {
                        contract: contract,
                        index: index
                    }
                ]
            };
        }, {});
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts2])=>multicall({
                    allowFailure: allowFailure,
                    chainId: parseInt(chainId),
                    contracts: contracts2.map(({ contract })=>contract),
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts2)=>contracts2.map(({ index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (err) {
        if (err instanceof (0, $hdmf8.ContractFunctionExecutionError)) throw err;
        const promises = ()=>contracts.map((contract)=>readContract({
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: void 0,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}
function watchContractEvent({ address, abi, chainId, eventName }, callback) {
    let unwatch;
    const watchEvent = async ()=>{
        if (unwatch) unwatch();
        const publicClient = getWebSocketPublicClient({
            chainId: chainId
        }) || getPublicClient({
            chainId: chainId
        });
        unwatch = publicClient.watchContractEvent({
            address: address,
            abi: abi,
            eventName: eventName,
            onLogs: callback
        });
    };
    watchEvent();
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), watchEvent, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return ()=>{
        unwatch?.();
        unsubscribe();
    };
}
function watchBlockNumber(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchBlockNumber({
            onBlockNumber: callback,
            emitOnBegin: true,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    if (args.listen) createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (args.listen && !args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchMulticall.ts
function watchMulticall(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await multicall(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContract.ts
function watchReadContract(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContract(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContracts.ts
function watchReadContracts(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContracts(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/writeContract.ts
async function writeContract(config2) {
    const walletClient = await getWalletClient({
        chainId: config2.chainId
    });
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    if (config2.chainId) assertActiveChain({
        chainId: config2.chainId
    });
    let request;
    if (config2.mode === "prepared") request = config2.request;
    else {
        const { chainId: _, mode: __, ...args } = config2;
        const res = await prepareWriteContract(args);
        request = res.request;
    }
    const hash = await walletClient.writeContract({
        ...request,
        chain: config2.chainId ? {
            id: config2.chainId
        } : null
    });
    return {
        hash: hash
    };
}
// src/actions/accounts/fetchBalance.ts
async function fetchBalance({ address, chainId, formatUnits: unit, token }) {
    const config2 = getConfig();
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (token) {
        const fetchContractBalance = async ({ abi })=>{
            const erc20Config = {
                abi: abi,
                address: token,
                chainId: chainId
            };
            const [value2, decimals, symbol] = await readContracts({
                allowFailure: false,
                contracts: [
                    {
                        ...erc20Config,
                        functionName: "balanceOf",
                        args: [
                            address
                        ]
                    },
                    {
                        ...erc20Config,
                        functionName: "decimals"
                    },
                    {
                        ...erc20Config,
                        functionName: "symbol"
                    }
                ]
            });
            return {
                decimals: decimals,
                formatted: (0, $lTCHO.formatUnits)(value2 ?? "0", getUnit(unit ?? decimals)),
                symbol: symbol,
                value: value2
            };
        };
        try {
            return await fetchContractBalance({
                abi: erc20ABI
            });
        } catch (err) {
            if (err instanceof (0, $hdmf8.ContractFunctionExecutionError)) {
                const { symbol, ...rest } = await fetchContractBalance({
                    abi: erc20ABI_bytes32
                });
                return {
                    symbol: (0, $dKCgU.hexToString)((0, $f6c2v.trim)(symbol, {
                        dir: "right"
                    })),
                    ...rest
                };
            }
            throw err;
        }
    }
    const chains = [
        ...config2.publicClient.chains || [],
        ...config2.chains ?? []
    ];
    const value = await publicClient.getBalance({
        address: address
    });
    const chain = chains.find((x)=>x.id === publicClient.chain.id);
    return {
        decimals: chain?.nativeCurrency.decimals ?? 18,
        formatted: (0, $lTCHO.formatUnits)(value ?? "0", getUnit(unit ?? 18)),
        symbol: chain?.nativeCurrency.symbol ?? "ETH",
        value: value
    };
}
// src/actions/accounts/getAccount.ts
function getAccount() {
    const { data, connector, status } = getConfig();
    switch(status){
        case "connected":
            return {
                address: data?.account,
                connector: connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: !!data?.account,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: void 0,
                connector: void 0,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}
// src/actions/accounts/getNetwork.ts
function getNetwork() {
    const config2 = getConfig();
    const chainId = config2.data?.chain?.id;
    const activeChains = config2.chains ?? [];
    const activeChain = [
        ...config2.publicClient?.chains || [],
        ...activeChains
    ].find((x)=>x.id === chainId) ?? {
        id: chainId,
        name: `Chain ${chainId}`,
        network: `${chainId}`,
        nativeCurrency: {
            name: "Ether",
            decimals: 18,
            symbol: "ETH"
        },
        rpcUrls: {
            default: {
                http: [
                    ""
                ]
            },
            public: {
                http: [
                    ""
                ]
            }
        }
    };
    return {
        chain: chainId ? {
            ...activeChain,
            ...config2.data?.chain,
            id: chainId
        } : void 0,
        chains: activeChains
    };
}
// src/actions/accounts/signMessage.ts
async function signMessage(args) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    return await walletClient.signMessage({
        message: args.message
    });
}
// src/actions/accounts/signTypedData.ts
async function signTypedData({ domain, message, primaryType, types }) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    const { chainId } = domain;
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    return walletClient.signTypedData({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
}
// src/actions/accounts/switchNetwork.ts
async function switchNetwork({ chainId }) {
    const { connector } = getConfig();
    if (!connector) throw new (0, $igV1L.ConnectorNotFoundError)();
    if (!connector.switchChain) throw new SwitchChainNotSupportedError({
        connector: connector
    });
    return connector.switchChain(chainId);
}
function watchAccount(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getAccount());
    const unsubscribe = config2.subscribe(({ data, connector, status })=>selector({
            address: data?.account,
            connector: connector,
            status: status
        }), handleChange, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return unsubscribe;
}
function watchNetwork(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getNetwork());
    const unsubscribe = config2.subscribe(({ data, chains })=>selector({
            chainId: data?.chain?.id,
            chains: chains
        }), handleChange, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return unsubscribe;
}

async function fetchEnsAddress({ chainId, name }) {
    const { normalize } = await (parcelRequire("eIFWU"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const address = await publicClient.getEnsAddress({
        name: normalize(name)
    });
    try {
        if (address === "0x0000000000000000000000000000000000000000") return null;
        return address ? (0, $aegFK.getAddress)(address) : null;
    } catch (_error) {
        return null;
    }
}

// src/actions/ens/fetchEnsAvatar.ts
async function fetchEnsAvatar({ name, chainId }) {
    const { normalize } = await (parcelRequire("eIFWU"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const avatar = await publicClient.getEnsAvatar({
        name: normalize(name)
    });
    return avatar;
}
async function fetchEnsName({ address, chainId }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getEnsName({
        address: (0, $aegFK.getAddress)(address)
    });
}

// src/actions/ens/fetchEnsResolver.ts
async function fetchEnsResolver({ chainId, name }) {
    const { normalize } = await (parcelRequire("eIFWU"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const resolver = await publicClient.getEnsResolver({
        name: normalize(name)
    });
    return resolver;
}
// src/actions/network-status/fetchBlockNumber.ts
async function fetchBlockNumber({ chainId } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const blockNumber = await publicClient.getBlockNumber();
    return blockNumber;
}
async function fetchFeeData({ chainId, formatUnits: units = "gwei" } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const block = await publicClient.getBlock();
    let gasPrice = null;
    try {
        gasPrice = await publicClient.getGasPrice();
    } catch  {}
    let lastBaseFeePerGas = null;
    let maxFeePerGas = null;
    let maxPriorityFeePerGas = null;
    if (block?.baseFeePerGas) {
        lastBaseFeePerGas = block.baseFeePerGas;
        maxPriorityFeePerGas = (0, $9bv14.parseGwei)("1");
        maxFeePerGas = block.baseFeePerGas * 2n + maxPriorityFeePerGas;
    }
    const unit = getUnit(units);
    const formatted = {
        gasPrice: gasPrice ? (0, $lTCHO.formatUnits)(gasPrice, unit) : null,
        maxFeePerGas: maxFeePerGas ? (0, $lTCHO.formatUnits)(maxFeePerGas, unit) : null,
        maxPriorityFeePerGas: maxPriorityFeePerGas ? (0, $lTCHO.formatUnits)(maxPriorityFeePerGas, unit) : null
    };
    return {
        lastBaseFeePerGas: lastBaseFeePerGas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        formatted: formatted
    };
}
// src/actions/transactions/fetchTransaction.ts
async function fetchTransaction({ chainId, hash }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getTransaction({
        hash: hash
    });
}
async function prepareSendTransaction({ accessList, account, chainId, data, gas: gas_, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to: to_, value, walletClient: walletClient_ }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const to = (to_ && !(0, $gg0RY.isAddress)(to_) ? await fetchEnsAddress({
        name: to_
    }) : to_) || void 0;
    if (to && !(0, $gg0RY.isAddress)(to)) throw new Error("Invalid address");
    const gas = typeof gas_ === "undefined" ? await publicClient.estimateGas({
        accessList: accessList,
        account: walletClient.account,
        data: data,
        gas: gas_ ?? void 0,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    }) : gas_ || void 0;
    return {
        accessList: accessList,
        account: account,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: "prepared",
        nonce: nonce,
        to: to,
        value: value,
        ...chainId ? {
            chainId: chainId
        } : {}
    };
}
// src/actions/transactions/sendTransaction.ts
async function sendTransaction({ accessList, account, chainId, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, mode, nonce, to, value }) {
    const walletClient = await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $igV1L.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    let args;
    if (mode === "prepared") args = {
        account: account,
        accessList: accessList,
        chain: null,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    };
    else args = await prepareSendTransaction({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas || null,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    });
    const hash = await walletClient.sendTransaction({
        ...args,
        chain: chainId ? {
            id: chainId
        } : null
    });
    return {
        hash: hash
    };
}
async function waitForTransaction({ chainId, confirmations = 1, hash, onReplaced, timeout = 0 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const receipt = await publicClient.waitForTransactionReceipt({
        hash: hash,
        confirmations: confirmations,
        onReplaced: onReplaced,
        timeout: timeout
    });
    if (receipt.status === "reverted") {
        const txn = await publicClient.getTransaction({
            hash: receipt.transactionHash
        });
        const code = await publicClient.call({
            ...txn,
            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : void 0,
            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : void 0,
            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : void 0
        });
        const reason = (0, $dKCgU.hexToString)(`0x${code.substring(138)}`);
        throw new Error(reason);
    }
    return receipt;
}
function watchPendingTransactions(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchPendingTransactions({
            onTransactions: callback,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (!args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $cZFtK.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/utils/assertActiveChain.ts
function assertActiveChain({ chainId }) {
    const { chain: activeChain, chains } = getNetwork();
    const activeChainId = activeChain?.id;
    if (activeChainId && chainId !== activeChainId) throw new ChainMismatchError({
        activeChain: chains.find((x)=>x.id === activeChainId)?.name ?? `Chain ${activeChainId}`,
        targetChain: chains.find((x)=>x.id === chainId)?.name ?? `Chain ${chainId}`
    });
}

});
parcelRegister("12u0G", function(module, exports) {

$parcel$export(module.exports, "InjectedConnector", () => $0c1d41ba52dd6b18$export$2180bbd5f43a00b6);

var $igV1L = parcelRequire("igV1L");

var $hvJ1R = parcelRequire("hvJ1R");

var $kD2va = parcelRequire("kD2va");

var $kSNL7 = parcelRequire("kSNL7");
var $bCHCD = parcelRequire("bCHCD");
var $aegFK = parcelRequire("aegFK");
var $7S6Nv = parcelRequire("7S6Nv");
var $cYDOa = parcelRequire("cYDOa");
// src/utils/getInjectedName.ts
function $0c1d41ba52dd6b18$var$getInjectedName(ethereum) {
    if (!ethereum) return "Injected";
    const getName = (provider)=>{
        if (provider.isApexWallet) return "Apex Wallet";
        if (provider.isAvalanche) return "Core Wallet";
        if (provider.isBackpack) return "Backpack";
        if (provider.isBifrost) return "Bifrost Wallet";
        if (provider.isBitKeep) return "BitKeep";
        if (provider.isBitski) return "Bitski";
        if (provider.isBlockWallet) return "BlockWallet";
        if (provider.isBraveWallet) return "Brave Wallet";
        if (provider.isCoin98) return "Coin98 Wallet";
        if (provider.isCoinbaseWallet) return "Coinbase Wallet";
        if (provider.isDawn) return "Dawn Wallet";
        if (provider.isDefiant) return "Defiant";
        if (provider.isDesig) return "Desig Wallet";
        if (provider.isEnkrypt) return "Enkrypt";
        if (provider.isExodus) return "Exodus";
        if (provider.isFordefi) return "Fordefi";
        if (provider.isFrame) return "Frame";
        if (provider.isFrontier) return "Frontier Wallet";
        if (provider.isGamestop) return "GameStop Wallet";
        if (provider.isHaqqWallet) return "HAQQ Wallet";
        if (provider.isHyperPay) return "HyperPay Wallet";
        if (provider.isImToken) return "ImToken";
        if (provider.isHaloWallet) return "Halo Wallet";
        if (provider.isKuCoinWallet) return "KuCoin Wallet";
        if (provider.isMathWallet) return "MathWallet";
        if (provider.isNovaWallet) return "Nova Wallet";
        if (provider.isOkxWallet || provider.isOKExWallet) return "OKX Wallet";
        if (provider.isOktoWallet) return "Okto Wallet";
        if (provider.isOneInchIOSWallet || provider.isOneInchAndroidWallet) return "1inch Wallet";
        if (provider.isOneKey) return "OneKey Wallet";
        if (provider.isOpera) return "Opera";
        if (provider.isPhantom) return "Phantom";
        if (provider.isPortal) return "Ripio Portal";
        if (provider.isRabby) return "Rabby Wallet";
        if (provider.isRainbow) return "Rainbow";
        if (provider.isSafePal) return "SafePal Wallet";
        if (provider.isStatus) return "Status";
        if (provider.isSubWallet) return "SubWallet";
        if (provider.isTalisman) return "Talisman";
        if (provider.isTally) return "Taho";
        if (provider.isTokenPocket) return "TokenPocket";
        if (provider.isTokenary) return "Tokenary";
        if (provider.isTrust || provider.isTrustWallet) return "Trust Wallet";
        if (provider.isTTWallet) return "TTWallet";
        if (provider.isXDEFI) return "XDEFI Wallet";
        if (provider.isZeal) return "Zeal";
        if (provider.isZerion) return "Zerion";
        if (provider.isMetaMask) return "MetaMask";
    };
    if (ethereum.providers?.length) {
        const nameSet = /* @__PURE__ */ new Set();
        let unknownCount = 1;
        for (const provider of ethereum.providers){
            let name = getName(provider);
            if (!name) {
                name = `Unknown Wallet #${unknownCount}`;
                unknownCount += 1;
            }
            nameSet.add(name);
        }
        const names = [
            ...nameSet
        ];
        if (names.length) return names;
        return names[0] ?? "Injected";
    }
    return getName(ethereum) ?? "Injected";
}
// src/injected.ts
var $0c1d41ba52dd6b18$var$_provider;
var $0c1d41ba52dd6b18$export$2180bbd5f43a00b6 = class extends (0, $kD2va.Connector) {
    constructor({ chains: chains, options: options_ } = {}){
        const options = {
            shimDisconnect: true,
            getProvider () {
                if (typeof window === "undefined") return;
                const ethereum = window.ethereum;
                if (ethereum?.providers && ethereum.providers.length > 0) return ethereum.providers[0];
                return ethereum;
            },
            ...options_
        };
        super({
            chains: chains,
            options: options
        });
        this.id = "injected";
        (0, $kD2va.__privateAdd)(this, $0c1d41ba52dd6b18$var$_provider, void 0);
        this.shimDisconnectKey = `${this.id}.shimDisconnect`;
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $aegFK.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = (0, $hvJ1R.normalizeChainId)(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = async (error)=>{
            if (error.code === 1013) {
                const provider = await this.getProvider();
                if (provider) {
                    const isAuthorized = await this.getAccount();
                    if (isAuthorized) return;
                }
            }
            this.emit("disconnect");
            if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
        };
        const provider = options.getProvider();
        if (typeof options.name === "string") this.name = options.name;
        else if (provider) {
            const detectedName = $0c1d41ba52dd6b18$var$getInjectedName(provider);
            if (options.name) this.name = options.name(detectedName);
            else if (typeof detectedName === "string") this.name = detectedName;
            else this.name = detectedName[0];
        } else this.name = "Injected";
        this.ready = !!provider;
    }
    async connect({ chainId: chainId } = {}) {
        try {
            const provider = await this.getProvider();
            if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
            if (provider.on) {
                provider.on("accountsChanged", this.onAccountsChanged);
                provider.on("chainChanged", this.onChainChanged);
                provider.on("disconnect", this.onDisconnect);
            }
            this.emit("message", {
                type: "connecting"
            });
            const accounts = await provider.request({
                method: "eth_requestAccounts"
            });
            const account = (0, $aegFK.getAddress)(accounts[0]);
            let id = await this.getChainId();
            let unsupported = this.isChainUnsupported(id);
            if (chainId && id !== chainId) {
                const chain = await this.switchChain(chainId);
                id = chain.id;
                unsupported = this.isChainUnsupported(id);
            }
            if (this.options.shimDisconnect) this.storage?.setItem(this.shimDisconnectKey, true);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (this.isUserRejectedRequestError(error)) throw new (0, $cYDOa.UserRejectedRequestError)(error);
            if (error.code === -32002) throw new (0, $cYDOa.ResourceUnavailableRpcError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        if (!provider?.removeListener) return;
        provider.removeListener("accountsChanged", this.onAccountsChanged);
        provider.removeListener("chainChanged", this.onChainChanged);
        provider.removeListener("disconnect", this.onDisconnect);
        if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
    }
    async getAccount() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
        const accounts = await provider.request({
            method: "eth_accounts"
        });
        return (0, $aegFK.getAddress)(accounts[0]);
    }
    async getChainId() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
        return provider.request({
            method: "eth_chainId"
        }).then((0, $hvJ1R.normalizeChainId));
    }
    async getProvider() {
        const provider = this.options.getProvider();
        if (provider) (0, $kD2va.__privateSet)(this, $0c1d41ba52dd6b18$var$_provider, provider);
        return (0, $kD2va.__privateGet)(this, $0c1d41ba52dd6b18$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider(),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $kSNL7.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $bCHCD.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            if (this.options.shimDisconnect && !this.storage?.getItem(this.shimDisconnectKey)) return false;
            const provider = await this.getProvider();
            if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
            const account = await this.getAccount();
            return !!account;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
        const id = (0, $7S6Nv.numberToHex)(chainId);
        try {
            await Promise.all([
                provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: id
                        }
                    ]
                }),
                new Promise((res)=>this.on("change", ({ chain: chain })=>{
                        if (chain?.id === chainId) res();
                    }))
            ]);
            return this.chains.find((x)=>x.id === chainId) ?? {
                id: chainId,
                name: `Chain ${id}`,
                network: `${id}`,
                nativeCurrency: {
                    name: "Ether",
                    decimals: 18,
                    symbol: "ETH"
                },
                rpcUrls: {
                    default: {
                        http: [
                            ""
                        ]
                    },
                    public: {
                        http: [
                            ""
                        ]
                    }
                }
            };
        } catch (error) {
            const chain = this.chains.find((x)=>x.id === chainId);
            if (!chain) throw new (0, $igV1L.ChainNotConfiguredForConnectorError)({
                chainId: chainId,
                connectorId: this.id
            });
            if (error.code === 4902 || error?.data?.originalError?.code === 4902) try {
                await provider.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: id,
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                chain.rpcUrls.public?.http[0] ?? ""
                            ],
                            blockExplorerUrls: this.getBlockExplorerUrls(chain)
                        }
                    ]
                });
                const currentChainId = await this.getChainId();
                if (currentChainId !== chainId) throw new (0, $cYDOa.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                return chain;
            } catch (error2) {
                throw new (0, $cYDOa.UserRejectedRequestError)(error2);
            }
            if (this.isUserRejectedRequestError(error)) throw new (0, $cYDOa.UserRejectedRequestError)(error);
            throw new (0, $cYDOa.SwitchChainError)(error);
        }
    }
    async watchAsset({ address: address, decimals: decimals = 18, image: image, symbol: symbol }) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
        return provider.request({
            method: "wallet_watchAsset",
            params: {
                type: "ERC20",
                options: {
                    address: address,
                    decimals: decimals,
                    image: image,
                    symbol: symbol
                }
            }
        });
    }
    isUserRejectedRequestError(error) {
        return error.code === 4001;
    }
};
$0c1d41ba52dd6b18$var$_provider = new WeakMap();

});
parcelRegister("igV1L", function(module, exports) {

$parcel$export(module.exports, "ChainNotConfiguredForConnectorError", () => $d4d5f50ec8ccfedb$export$9e27fc4704f8e4c3);
$parcel$export(module.exports, "ConnectorNotFoundError", () => $d4d5f50ec8ccfedb$export$9f8a797207d6544e);
// src/errors.ts
var $d4d5f50ec8ccfedb$export$9e27fc4704f8e4c3 = class extends Error {
    constructor({ chainId: chainId, connectorId: connectorId }){
        super(`Chain "${chainId}" not configured for connector "${connectorId}".`);
        this.name = "ChainNotConfiguredForConnectorError";
    }
};
var $d4d5f50ec8ccfedb$export$9f8a797207d6544e = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorNotFoundError";
        this.message = "Connector not found";
    }
};

});

parcelRegister("hvJ1R", function(module, exports) {

$parcel$export(module.exports, "normalizeChainId", () => $cbf842c0de38352a$export$723927690c88894d);
// src/utils/normalizeChainId.ts
function $cbf842c0de38352a$export$723927690c88894d(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if (typeof chainId === "bigint") return Number(chainId);
    return chainId;
}

});

parcelRegister("kD2va", function(module, exports) {

$parcel$export(module.exports, "__privateGet", () => $f04963edb1ef5cad$export$18a094aefa070634);
$parcel$export(module.exports, "__privateAdd", () => $f04963edb1ef5cad$export$addf369becd23283);
$parcel$export(module.exports, "__privateSet", () => $f04963edb1ef5cad$export$42432efe6614d3b4);
$parcel$export(module.exports, "__privateMethod", () => $f04963edb1ef5cad$export$fa92d15b718fce20);
$parcel$export(module.exports, "Connector", () => $f04963edb1ef5cad$export$b2278035370d6017);

var $gIdD2 = parcelRequire("gIdD2");

var $jDvfy = parcelRequire("jDvfy");
var $5Lqmg = parcelRequire("5Lqmg");
var $f04963edb1ef5cad$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $f04963edb1ef5cad$export$18a094aefa070634 = (obj, member, getter)=>{
    $f04963edb1ef5cad$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $f04963edb1ef5cad$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $f04963edb1ef5cad$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $f04963edb1ef5cad$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $f04963edb1ef5cad$export$fa92d15b718fce20 = (obj, member, method)=>{
    $f04963edb1ef5cad$var$__accessCheck(obj, member, "access private method");
    return method;
};
var $f04963edb1ef5cad$export$b2278035370d6017 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($gIdD2))) {
    constructor({ chains: chains = [
        (0, $5Lqmg.mainnet),
        (0, $jDvfy.goerli)
    ], options: options }){
        super();
        this.chains = chains;
        this.options = options;
    }
    getBlockExplorerUrls(chain) {
        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
        if (blockExplorer) return [
            blockExplorer.url,
            ...Object.values(blockExplorers).map((x)=>x.url)
        ];
    }
    isChainUnsupported(chainId) {
        return !this.chains.some((x)=>x.id === chainId);
    }
    setStorage(storage) {
        this.storage = storage;
    }
};

});
parcelRegister("gIdD2", function(module, exports) {
"use strict";
var $c2ab53c69375aa75$var$has = Object.prototype.hasOwnProperty, $c2ab53c69375aa75$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c2ab53c69375aa75$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c2ab53c69375aa75$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c2ab53c69375aa75$var$Events().__proto__) $c2ab53c69375aa75$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c2ab53c69375aa75$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c2ab53c69375aa75$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $c2ab53c69375aa75$var$EE(fn, context || emitter, once), evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c2ab53c69375aa75$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c2ab53c69375aa75$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c2ab53c69375aa75$var$EventEmitter() {
    this._events = new $c2ab53c69375aa75$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c2ab53c69375aa75$var$has.call(events, name)) names.push($c2ab53c69375aa75$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c2ab53c69375aa75$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c2ab53c69375aa75$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c2ab53c69375aa75$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c2ab53c69375aa75$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c2ab53c69375aa75$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c2ab53c69375aa75$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c2ab53c69375aa75$var$prefix ? $c2ab53c69375aa75$var$prefix + event : event;
        if (this._events[evt]) $c2ab53c69375aa75$var$clearEvent(this, evt);
    } else {
        this._events = new $c2ab53c69375aa75$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c2ab53c69375aa75$var$EventEmitter.prototype.off = $c2ab53c69375aa75$var$EventEmitter.prototype.removeListener;
$c2ab53c69375aa75$var$EventEmitter.prototype.addListener = $c2ab53c69375aa75$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c2ab53c69375aa75$var$EventEmitter.prefixed = $c2ab53c69375aa75$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c2ab53c69375aa75$var$EventEmitter.EventEmitter = $c2ab53c69375aa75$var$EventEmitter;
module.exports = $c2ab53c69375aa75$var$EventEmitter;

});

parcelRegister("jDvfy", function(module, exports) {

$parcel$export(module.exports, "goerli", () => $e4b9e66c70c2866f$export$50b37201a1017e1e);

var $lKw3B = parcelRequire("lKw3B");
const $e4b9e66c70c2866f$export$50b37201a1017e1e = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 5,
    network: "goerli",
    name: "Goerli",
    nativeCurrency: {
        name: "Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-goerli.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        },
        public: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0x56522D00C410a43BFfDF00a9A569489297385790",
            blockCreated: 8765204
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 6507670
        }
    },
    testnet: true
});

});
parcelRegister("lKw3B", function(module, exports) {

$parcel$export(module.exports, "defineChain", () => $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb);
function $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb(chain, config = {}) {
    const { fees: fees = chain.fees, formatters: formatters = chain.formatters, serializers: serializers = chain.serializers } = config;
    return {
        ...chain,
        fees: fees,
        formatters: formatters,
        serializers: serializers
    };
}

});


parcelRegister("5Lqmg", function(module, exports) {

$parcel$export(module.exports, "mainnet", () => $4325c9b625f3e35f$export$536d3e0d2c7baf54);

var $lKw3B = parcelRequire("lKw3B");
const $4325c9b625f3e35f$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 1,
    network: "homestead",
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        },
        public: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
            blockCreated: 16966585
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});

});


parcelRegister("kSNL7", function(module, exports) {

$parcel$export(module.exports, "createWalletClient", () => $f33f72e009cad2f3$export$362b8ea2edbd9090);

var $dQ6cQ = parcelRequire("dQ6cQ");

var $K8lS0 = parcelRequire("K8lS0");
function $f33f72e009cad2f3$export$362b8ea2edbd9090(parameters) {
    const { key: key = "wallet", name: name = "Wallet Client", transport: transport } = parameters;
    const client = (0, $dQ6cQ.createClient)({
        ...parameters,
        key: key,
        name: name,
        transport: (opts)=>transport({
                ...opts,
                retryCount: 0
            }),
        type: "walletClient"
    });
    return client.extend((0, $K8lS0.walletActions));
}

});
parcelRegister("dQ6cQ", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $a134f221737b0733$export$5d730b7aed1a3eb0);

var $e4nLA = parcelRequire("e4nLA");

var $1jARV = parcelRequire("1jARV");
function $a134f221737b0733$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $e4nLA.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $1jARV.uid)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}

});
parcelRegister("e4nLA", function(module, exports) {

$parcel$export(module.exports, "parseAccount", () => $a3e3dff2115167bd$export$11027cbf6cf15da2);
function $a3e3dff2115167bd$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("1jARV", function(module, exports) {

$parcel$export(module.exports, "uid", () => $0f542a234bfd7dd2$export$e2a22331486dcca0);
const $0f542a234bfd7dd2$var$size = 256;
let $0f542a234bfd7dd2$var$index = $0f542a234bfd7dd2$var$size;
let $0f542a234bfd7dd2$var$buffer;
function $0f542a234bfd7dd2$export$e2a22331486dcca0(length = 11) {
    if (!$0f542a234bfd7dd2$var$buffer || $0f542a234bfd7dd2$var$index + length > $0f542a234bfd7dd2$var$size * 2) {
        $0f542a234bfd7dd2$var$buffer = "";
        $0f542a234bfd7dd2$var$index = 0;
        for(let i = 0; i < $0f542a234bfd7dd2$var$size; i++)$0f542a234bfd7dd2$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $0f542a234bfd7dd2$var$buffer.substring($0f542a234bfd7dd2$var$index, $0f542a234bfd7dd2$var$index++ + length);
}

});


parcelRegister("K8lS0", function(module, exports) {

$parcel$export(module.exports, "walletActions", () => $08aac67999c0e3d3$export$d07041b4ed194fbc);

var $63bwO = parcelRequire("63bwO");

var $6rEq8 = parcelRequire("6rEq8");

var $8z4GW = parcelRequire("8z4GW");

var $6L6k4 = parcelRequire("6L6k4");

var $l9nJJ = parcelRequire("l9nJJ");

var $e34Sq = parcelRequire("e34Sq");

var $eiu28 = parcelRequire("eiu28");

var $arBYz = parcelRequire("arBYz");

var $7vFPJ = parcelRequire("7vFPJ");

var $hc4Fy = parcelRequire("hc4Fy");

var $3J6W2 = parcelRequire("3J6W2");

var $hIihj = parcelRequire("hIihj");

var $e7uh1 = parcelRequire("e7uh1");

var $aTnNy = parcelRequire("aTnNy");

var $efAaV = parcelRequire("efAaV");

var $iHyR5 = parcelRequire("iHyR5");
function $08aac67999c0e3d3$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $6rEq8.addChain)(client, args),
        deployContract: (args)=>(0, $8z4GW.deployContract)(client, args),
        getAddresses: ()=>(0, $6L6k4.getAddresses)(client),
        getChainId: ()=>(0, $63bwO.getChainId)(client),
        getPermissions: ()=>(0, $l9nJJ.getPermissions)(client),
        prepareTransactionRequest: (args)=>(0, $e34Sq.prepareTransactionRequest)(client, args),
        requestAddresses: ()=>(0, $eiu28.requestAddresses)(client),
        requestPermissions: (args)=>(0, $arBYz.requestPermissions)(client, args),
        sendRawTransaction: (args)=>(0, $7vFPJ.sendRawTransaction)(client, args),
        sendTransaction: (args)=>(0, $hc4Fy.sendTransaction)(client, args),
        signMessage: (args)=>(0, $3J6W2.signMessage)(client, args),
        signTransaction: (args)=>(0, $hIihj.signTransaction)(client, args),
        signTypedData: (args)=>(0, $e7uh1.signTypedData)(client, args),
        switchChain: (args)=>(0, $aTnNy.switchChain)(client, args),
        watchAsset: (args)=>(0, $efAaV.watchAsset)(client, args),
        writeContract: (args)=>(0, $iHyR5.writeContract)(client, args)
    };
}

});
parcelRegister("63bwO", function(module, exports) {

$parcel$export(module.exports, "getChainId", () => $0123081d904ad22e$export$850fa7b3891187c);

var $dKCgU = parcelRequire("dKCgU");
async function $0123081d904ad22e$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    });
    return (0, $dKCgU.hexToNumber)(chainIdHex);
}

});
parcelRegister("dKCgU", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $a02d422fd0bd55d3$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $a02d422fd0bd55d3$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $a02d422fd0bd55d3$export$92a44656ec81b584);
$parcel$export(module.exports, "hexToString", () => $a02d422fd0bd55d3$export$f4bc7e46f3eb3ac3);
$parcel$export(module.exports, "hexToBool", () => $a02d422fd0bd55d3$export$bde1d77e6fe6c41e);

var $dd6fp = parcelRequire("dd6fp");

var $7ahE1 = parcelRequire("7ahE1");

var $f6c2v = parcelRequire("f6c2v");

var $ihras = parcelRequire("ihras");
function $a02d422fd0bd55d3$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $7ahE1.size)(hexOrBytes) > size) throw new (0, $dd6fp.SizeOverflowError)({
        givenSize: (0, $7ahE1.size)(hexOrBytes),
        maxSize: size
    });
}
function $a02d422fd0bd55d3$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $a02d422fd0bd55d3$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $a02d422fd0bd55d3$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $a02d422fd0bd55d3$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $a02d422fd0bd55d3$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $ihras.hexToBytes)(hex, opts);
}
function $a02d422fd0bd55d3$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $a02d422fd0bd55d3$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $a02d422fd0bd55d3$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $a02d422fd0bd55d3$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $f6c2v.trim)(hex);
    }
    if ((0, $f6c2v.trim)(hex) === "0x00") return false;
    if ((0, $f6c2v.trim)(hex) === "0x01") return true;
    throw new (0, $dd6fp.InvalidHexBooleanError)(hex);
}
function $a02d422fd0bd55d3$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($a02d422fd0bd55d3$export$92a44656ec81b584(hex, opts));
}
function $a02d422fd0bd55d3$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $ihras.hexToBytes)(hex);
    if (opts.size) {
        $a02d422fd0bd55d3$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $f6c2v.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("dd6fp", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $99e155e3d7209681$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $99e155e3d7209681$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $99e155e3d7209681$export$beb44ed4f8747d0e);

var $kpVTR = parcelRequire("kpVTR");
class $99e155e3d7209681$export$8615cc40e20f1eb extends (0, $kpVTR.BaseError) {
    constructor({ consumed: consumed, length: length }){
        super(`Consumed bytes (${consumed}) is shorter than data length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooLongError"
        });
    }
}
class $99e155e3d7209681$export$9579bcdb57e90be3 extends (0, $kpVTR.BaseError) {
    constructor({ length: length, dataLength: dataLength }){
        super(`Data length (${dataLength - 1}) is shorter than consumed bytes length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooShortError"
        });
    }
}
class $99e155e3d7209681$export$47d164a8071229a9 extends (0, $kpVTR.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntegerOutOfRangeError"
        });
    }
}
class $99e155e3d7209681$export$52fc62e5266c8838 extends (0, $kpVTR.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidBytesBooleanError"
        });
    }
}
class $99e155e3d7209681$export$f574ac54e35514c extends (0, $kpVTR.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexBooleanError"
        });
    }
}
class $99e155e3d7209681$export$ef05eafd11dd4a83 extends (0, $kpVTR.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexValueError"
        });
    }
}
class $99e155e3d7209681$export$a63b8c38d2c828ee extends (0, $kpVTR.BaseError) {
    constructor({ nextOffset: nextOffset, offset: offset }){
        super(`Next offset (${nextOffset}) is greater than previous offset + consumed bytes (${offset})`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "OffsetOutOfBoundsError"
        });
    }
}
class $99e155e3d7209681$export$beb44ed4f8747d0e extends (0, $kpVTR.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeOverflowError"
        });
    }
}

});
parcelRegister("kpVTR", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $edd30e2fd2426f63$export$a490eb03cb7a0a5e);

var $gcSc3 = parcelRequire("gcSc3");
class $edd30e2fd2426f63$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ViemError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $gcSc3.getVersion)()
        });
        const details = args.cause instanceof $edd30e2fd2426f63$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $edd30e2fd2426f63$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}.html${args.docsSlug ? `#${args.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $edd30e2fd2426f63$var$walk(this, fn);
    }
}
function $edd30e2fd2426f63$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $edd30e2fd2426f63$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("gcSc3", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $bcc7ce08db7dc976$export$b7fbffef12272e40);
$parcel$export(module.exports, "getUrl", () => $bcc7ce08db7dc976$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getVersion", () => $bcc7ce08db7dc976$export$c506eb22e615ba4a);

var $6rHfY = parcelRequire("6rHfY");
const $bcc7ce08db7dc976$export$b7fbffef12272e40 = (address)=>address;
const $bcc7ce08db7dc976$export$94df0e59ebebf4a7 = (url)=>url;
const $bcc7ce08db7dc976$export$c506eb22e615ba4a = ()=>`viem@${0, $6rHfY.version}`;

});
parcelRegister("6rHfY", function(module, exports) {

$parcel$export(module.exports, "version", () => $4b16d19289c14089$export$83d89fbfd8236492);
const $4b16d19289c14089$export$83d89fbfd8236492 = "1.21.3";

});




parcelRegister("7ahE1", function(module, exports) {

$parcel$export(module.exports, "size", () => $5377276e6dd1d7f3$export$346677f925de839c);

var $fmvmO = parcelRequire("fmvmO");
function $5377276e6dd1d7f3$export$346677f925de839c(value) {
    if ((0, $fmvmO.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("fmvmO", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $b2f13decf45fda1f$export$8a9b6341a7c96bc);
function $b2f13decf45fda1f$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});


parcelRegister("f6c2v", function(module, exports) {

$parcel$export(module.exports, "trim", () => $afe0c15247edde92$export$87c2784dc9fc4ab);
function $afe0c15247edde92$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("ihras", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $d4eee37424540dbc$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $d4eee37424540dbc$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $d4eee37424540dbc$export$c8dd6bc66a63753c);

var $kpVTR = parcelRequire("kpVTR");

var $fmvmO = parcelRequire("fmvmO");

var $15DC1 = parcelRequire("15DC1");

var $dKCgU = parcelRequire("dKCgU");

var $7S6Nv = parcelRequire("7S6Nv");
const $d4eee37424540dbc$var$encoder = /*#__PURE__*/ new TextEncoder();
function $d4eee37424540dbc$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $d4eee37424540dbc$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $d4eee37424540dbc$export$771517697a68241(value, opts);
    if ((0, $fmvmO.isHex)(value)) return $d4eee37424540dbc$export$31c96b9df38bc8d4(value, opts);
    return $d4eee37424540dbc$export$c8dd6bc66a63753c(value, opts);
}
function $d4eee37424540dbc$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $dKCgU.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $15DC1.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $d4eee37424540dbc$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $d4eee37424540dbc$var$charCodeToBase16(char) {
    if (char >= $d4eee37424540dbc$var$charCodeMap.zero && char <= $d4eee37424540dbc$var$charCodeMap.nine) return char - $d4eee37424540dbc$var$charCodeMap.zero;
    if (char >= $d4eee37424540dbc$var$charCodeMap.A && char <= $d4eee37424540dbc$var$charCodeMap.F) return char - ($d4eee37424540dbc$var$charCodeMap.A - 10);
    if (char >= $d4eee37424540dbc$var$charCodeMap.a && char <= $d4eee37424540dbc$var$charCodeMap.f) return char - ($d4eee37424540dbc$var$charCodeMap.a - 10);
    return undefined;
}
function $d4eee37424540dbc$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $dKCgU.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $15DC1.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $d4eee37424540dbc$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $d4eee37424540dbc$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $kpVTR.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $d4eee37424540dbc$export$49ad9be85c347998(value, opts) {
    const hex = (0, $7S6Nv.numberToHex)(value, opts);
    return $d4eee37424540dbc$export$31c96b9df38bc8d4(hex);
}
function $d4eee37424540dbc$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $d4eee37424540dbc$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $dKCgU.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $15DC1.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("15DC1", function(module, exports) {

$parcel$export(module.exports, "pad", () => $0cb4fc38c0bed089$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $0cb4fc38c0bed089$export$1bcd51c0fce8ee55);

var $f6Prl = parcelRequire("f6Prl");
function $0cb4fc38c0bed089$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $0cb4fc38c0bed089$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $0cb4fc38c0bed089$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $0cb4fc38c0bed089$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $f6Prl.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $0cb4fc38c0bed089$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $f6Prl.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("f6Prl", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $afff517d8f5b781f$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $afff517d8f5b781f$export$70445dc308a7f3d5);

var $kpVTR = parcelRequire("kpVTR");
class $afff517d8f5b781f$export$cfcd41bba8b36dbd extends (0, $kpVTR.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $afff517d8f5b781f$export$70445dc308a7f3d5 extends (0, $kpVTR.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeExceedsPaddingSizeError"
        });
    }
}

});


parcelRegister("7S6Nv", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $5bb2d95d7182eede$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $5bb2d95d7182eede$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $5bb2d95d7182eede$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $5bb2d95d7182eede$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $5bb2d95d7182eede$export$58b867e287a802c8);

var $dd6fp = parcelRequire("dd6fp");

var $15DC1 = parcelRequire("15DC1");

var $dKCgU = parcelRequire("dKCgU");
const $5bb2d95d7182eede$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $5bb2d95d7182eede$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $5bb2d95d7182eede$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $5bb2d95d7182eede$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $5bb2d95d7182eede$export$b5c95dec4f62ef7a(value, opts);
    return $5bb2d95d7182eede$export$58b867e287a802c8(value, opts);
}
function $5bb2d95d7182eede$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $dKCgU.assertSize)(hex, {
            size: opts.size
        });
        return (0, $15DC1.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $5bb2d95d7182eede$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $5bb2d95d7182eede$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $dKCgU.assertSize)(hex, {
            size: opts.size
        });
        return (0, $15DC1.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $5bb2d95d7182eede$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $dd6fp.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $15DC1.pad)(hex, {
        size: size
    });
    return hex;
}
const $5bb2d95d7182eede$var$encoder = /*#__PURE__*/ new TextEncoder();
function $5bb2d95d7182eede$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $5bb2d95d7182eede$var$encoder.encode(value_);
    return $5bb2d95d7182eede$export$58b867e287a802c8(value, opts);
}

});




parcelRegister("6rEq8", function(module, exports) {

$parcel$export(module.exports, "addChain", () => $4b149e5c8daa549d$export$e648161d6b1bb565);

var $7S6Nv = parcelRequire("7S6Nv");
async function $4b149e5c8daa549d$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: (0, $7S6Nv.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    });
}

});

parcelRegister("8z4GW", function(module, exports) {

$parcel$export(module.exports, "deployContract", () => $63c53b44b1c7cab9$export$46c7a79747abe6a9);

var $8OFop = parcelRequire("8OFop");

var $hc4Fy = parcelRequire("hc4Fy");
function $63c53b44b1c7cab9$export$46c7a79747abe6a9(walletClient, { abi: abi, args: args, bytecode: bytecode, ...request }) {
    const calldata = (0, $8OFop.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $hc4Fy.sendTransaction)(walletClient, {
        ...request,
        data: calldata
    });
}

});
parcelRegister("8OFop", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", () => $66b319f2f567dfb3$export$d7a7276006273fbd);

var $329cO = parcelRequire("329cO");

var $jSK74 = parcelRequire("jSK74");

var $iSG3s = parcelRequire("iSG3s");
const $66b319f2f567dfb3$var$docsPath = "/docs/contract/encodeDeployData";
function $66b319f2f567dfb3$export$d7a7276006273fbd({ abi: abi, args: args, bytecode: bytecode }) {
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $329cO.AbiConstructorNotFoundError)({
        docsPath: $66b319f2f567dfb3$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $329cO.AbiConstructorParamsNotFoundError)({
        docsPath: $66b319f2f567dfb3$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $329cO.AbiConstructorParamsNotFoundError)({
        docsPath: $66b319f2f567dfb3$var$docsPath
    });
    const data = (0, $iSG3s.encodeAbiParameters)(description.inputs, args);
    return (0, $jSK74.concatHex)([
        bytecode,
        data
    ]);
}

});
parcelRegister("329cO", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", () => $2358b30f4753feb8$export$efa723f306cf6168);
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", () => $2358b30f4753feb8$export$4faec14323ef9c47);
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", () => $2358b30f4753feb8$export$7a409e433c5f3a8c);
$parcel$export(module.exports, "AbiDecodingZeroDataError", () => $2358b30f4753feb8$export$a063cde4013f1935);
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", () => $2358b30f4753feb8$export$a851da9bf50b557);
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", () => $2358b30f4753feb8$export$19c281dc8e23a2ea);
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", () => $2358b30f4753feb8$export$20737d495bb13c2d);
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", () => $2358b30f4753feb8$export$8959cb729fefe1ea);
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", () => $2358b30f4753feb8$export$f83210ce5f9b901f);
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", () => $2358b30f4753feb8$export$3b44baeac92e4d3a);
$parcel$export(module.exports, "AbiEventNotFoundError", () => $2358b30f4753feb8$export$c7be62baad13b157);
$parcel$export(module.exports, "AbiFunctionNotFoundError", () => $2358b30f4753feb8$export$c4faa308ea7f9b2);
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", () => $2358b30f4753feb8$export$26f2edb605108b34);
$parcel$export(module.exports, "AbiItemAmbiguityError", () => $2358b30f4753feb8$export$fdbba54ba15f2c2d);
$parcel$export(module.exports, "BytesSizeMismatchError", () => $2358b30f4753feb8$export$a0eb884ede5c87eb);
$parcel$export(module.exports, "DecodeLogDataMismatch", () => $2358b30f4753feb8$export$3978f86c08fc8c25);
$parcel$export(module.exports, "DecodeLogTopicsMismatch", () => $2358b30f4753feb8$export$6d7c6f419cf52377);
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", () => $2358b30f4753feb8$export$53ed98b886965f49);
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", () => $2358b30f4753feb8$export$cf94ccff0ff97c65);
$parcel$export(module.exports, "InvalidArrayError", () => $2358b30f4753feb8$export$710dd6d4f78cc47e);
$parcel$export(module.exports, "InvalidDefinitionTypeError", () => $2358b30f4753feb8$export$81781a0fcfb9ed95);
$parcel$export(module.exports, "UnsupportedPackedAbiType", () => $2358b30f4753feb8$export$a16541e2fe420ef1);

var $j8Xjk = parcelRequire("j8Xjk");

var $7ahE1 = parcelRequire("7ahE1");

var $kpVTR = parcelRequire("kpVTR");
class $2358b30f4753feb8$export$efa723f306cf6168 extends (0, $kpVTR.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$4faec14323ef9c47 extends (0, $kpVTR.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$68a7b570091cba69 extends (0, $kpVTR.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $2358b30f4753feb8$export$7a409e433c5f3a8c extends (0, $kpVTR.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $j8Xjk.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $2358b30f4753feb8$export$a063cde4013f1935 extends (0, $kpVTR.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingZeroDataError"
        });
    }
}
class $2358b30f4753feb8$export$a851da9bf50b557 extends (0, $kpVTR.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $2358b30f4753feb8$export$19c281dc8e23a2ea extends (0, $kpVTR.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $7ahE1.size)(value)}) does not match expected size (bytes${expectedSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $2358b30f4753feb8$export$20737d495bb13c2d extends (0, $kpVTR.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingLengthMismatchError"
        });
    }
}
class $2358b30f4753feb8$export$d47cf5ef47eda817 extends (0, $kpVTR.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorInputsNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$86b719574b683f04 extends (0, $kpVTR.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$8959cb729fefe1ea extends (0, $kpVTR.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $2358b30f4753feb8$export$f83210ce5f9b901f extends (0, $kpVTR.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $2358b30f4753feb8$export$3b44baeac92e4d3a extends (0, $kpVTR.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$c7be62baad13b157 extends (0, $kpVTR.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$c4faa308ea7f9b2 extends (0, $kpVTR.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$26f2edb605108b34 extends (0, $kpVTR.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$14373147a0e60810 extends (0, $kpVTR.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $2358b30f4753feb8$export$fdbba54ba15f2c2d extends (0, $kpVTR.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $j8Xjk.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $j8Xjk.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItemAmbiguityError"
        });
    }
}
class $2358b30f4753feb8$export$a0eb884ede5c87eb extends (0, $kpVTR.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BytesSizeMismatchError"
        });
    }
}
class $2358b30f4753feb8$export$3978f86c08fc8c25 extends (0, $kpVTR.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $j8Xjk.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $2358b30f4753feb8$export$6d7c6f419cf52377 extends (0, $kpVTR.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $j8Xjk.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $2358b30f4753feb8$export$53ed98b886965f49 extends (0, $kpVTR.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiEncodingType"
        });
    }
}
class $2358b30f4753feb8$export$cf94ccff0ff97c65 extends (0, $kpVTR.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiDecodingType"
        });
    }
}
class $2358b30f4753feb8$export$710dd6d4f78cc47e extends (0, $kpVTR.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidArrayError"
        });
    }
}
class $2358b30f4753feb8$export$81781a0fcfb9ed95 extends (0, $kpVTR.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidDefinitionTypeError"
        });
    }
}
class $2358b30f4753feb8$export$a16541e2fe420ef1 extends (0, $kpVTR.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("j8Xjk", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $defcc5916a66633f$export$dc5d0ff4fc2fdee1);
$parcel$export(module.exports, "formatAbiParams", () => $defcc5916a66633f$export$849e499971de75b3);

var $329cO = parcelRequire("329cO");
function $defcc5916a66633f$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $329cO.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$defcc5916a66633f$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $defcc5916a66633f$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$defcc5916a66633f$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $defcc5916a66633f$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$defcc5916a66633f$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});


parcelRegister("jSK74", function(module, exports) {

$parcel$export(module.exports, "concat", () => $e796d4884484b5b3$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatHex", () => $e796d4884484b5b3$export$f6cc0b64b5a999af);
function $e796d4884484b5b3$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $e796d4884484b5b3$export$f6cc0b64b5a999af(values);
    return $e796d4884484b5b3$export$287dd7971339c972(values);
}
function $e796d4884484b5b3$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $e796d4884484b5b3$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("iSG3s", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", () => $dbede45547542be7$export$448ea0950d6dd7d7);
$parcel$export(module.exports, "getArrayComponents", () => $dbede45547542be7$export$ab502cfdbb1a0d07);

var $329cO = parcelRequire("329cO");

var $fcphM = parcelRequire("fcphM");

var $gg0RY = parcelRequire("gg0RY");

var $jSK74 = parcelRequire("jSK74");

var $15DC1 = parcelRequire("15DC1");

var $7ahE1 = parcelRequire("7ahE1");

var $h8fZV = parcelRequire("h8fZV");

var $7S6Nv = parcelRequire("7S6Nv");
function $dbede45547542be7$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $329cO.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $dbede45547542be7$var$prepareParams({
        params: params,
        values: values
    });
    const data = $dbede45547542be7$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $dbede45547542be7$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($dbede45547542be7$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $dbede45547542be7$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $dbede45547542be7$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $dbede45547542be7$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $dbede45547542be7$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $dbede45547542be7$var$encodeAddress(value);
    if (param.type === "bool") return $dbede45547542be7$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $dbede45547542be7$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $dbede45547542be7$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $dbede45547542be7$var$encodeString(value);
    throw new (0, $329cO.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $dbede45547542be7$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $7ahE1.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $7S6Nv.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $7ahE1.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $jSK74.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $dbede45547542be7$var$encodeAddress(value) {
    if (!(0, $gg0RY.isAddress)(value)) throw new (0, $fcphM.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $15DC1.padHex)(value.toLowerCase())
    };
}
function $dbede45547542be7$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $329cO.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $329cO.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $dbede45547542be7$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $dbede45547542be7$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $7S6Nv.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $jSK74.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $jSK74.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $dbede45547542be7$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $7ahE1.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $15DC1.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $jSK74.concat)([
                (0, $15DC1.padHex)((0, $7S6Nv.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== parseInt(paramSize)) throw new (0, $329cO.AbiEncodingBytesSizeMismatchError)({
        expectedSize: parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $15DC1.padHex)(value, {
            dir: "right"
        })
    };
}
function $dbede45547542be7$var$encodeBool(value) {
    return {
        dynamic: false,
        encoded: (0, $15DC1.padHex)((0, $7S6Nv.boolToHex)(value))
    };
}
function $dbede45547542be7$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $7S6Nv.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $dbede45547542be7$var$encodeString(value) {
    const hexValue = (0, $7S6Nv.stringToHex)(value);
    const partsLength = Math.ceil((0, $7ahE1.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $15DC1.padHex)((0, $h8fZV.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $jSK74.concat)([
            (0, $15DC1.padHex)((0, $7S6Nv.numberToHex)((0, $7ahE1.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $dbede45547542be7$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $dbede45547542be7$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $dbede45547542be7$var$encodeParams(preparedParams) : (0, $jSK74.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $dbede45547542be7$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("fcphM", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $b10b9738470f6fe9$export$66c44d927ffead98);

var $kpVTR = parcelRequire("kpVTR");
class $b10b9738470f6fe9$export$66c44d927ffead98 extends (0, $kpVTR.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAddressError"
        });
    }
}

});

parcelRegister("gg0RY", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $bd5ed09da60e9c74$export$977e255126d763d6);
const $bd5ed09da60e9c74$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
function $bd5ed09da60e9c74$export$977e255126d763d6(address) {
    return $bd5ed09da60e9c74$var$addressRegex.test(address);
}

});

parcelRegister("h8fZV", function(module, exports) {

$parcel$export(module.exports, "slice", () => $c78f97dce0e556b5$export$58adb3bec8346d0f);

var $f6Prl = parcelRequire("f6Prl");

var $fmvmO = parcelRequire("fmvmO");

var $7ahE1 = parcelRequire("7ahE1");
function $c78f97dce0e556b5$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $fmvmO.isHex)(value, {
        strict: false
    })) return $c78f97dce0e556b5$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $c78f97dce0e556b5$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $c78f97dce0e556b5$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $7ahE1.size)(value) - 1) throw new (0, $f6Prl.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $7ahE1.size)(value)
    });
}
function $c78f97dce0e556b5$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $7ahE1.size)(value) !== end - start) throw new (0, $f6Prl.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $7ahE1.size)(value)
    });
}
function $c78f97dce0e556b5$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $c78f97dce0e556b5$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $c78f97dce0e556b5$var$assertEndOffset(value, start, end);
    return value;
}
function $c78f97dce0e556b5$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $c78f97dce0e556b5$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $c78f97dce0e556b5$var$assertEndOffset(value, start, end);
    return value;
}

});



parcelRegister("hc4Fy", function(module, exports) {

$parcel$export(module.exports, "sendTransaction", () => $c8472de413a78edb$export$8e0e7ffc78696d30);

var $e4nLA = parcelRequire("e4nLA");

var $8td0U = parcelRequire("8td0U");

var $ibqtd = parcelRequire("ibqtd");

var $forn1 = parcelRequire("forn1");

var $2wY7l = parcelRequire("2wY7l");

var $iFIxy = parcelRequire("iFIxy");

var $govpX = parcelRequire("govpX");

var $fHEfg = parcelRequire("fHEfg");

var $63bwO = parcelRequire("63bwO");

var $e34Sq = parcelRequire("e34Sq");

var $7vFPJ = parcelRequire("7vFPJ");
async function $c8472de413a78edb$export$8e0e7ffc78696d30(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = (0, $e4nLA.parseAccount)(account_);
    try {
        (0, $fHEfg.assertRequest)(args);
        let chainId;
        if (chain !== null) {
            chainId = await (0, $govpX.getAction)(client, (0, $63bwO.getChainId), "getChainId")({});
            (0, $ibqtd.assertCurrentChain)({
                currentChainId: chainId,
                chain: chain
            });
        }
        if (account.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $govpX.getAction)(client, (0, $e34Sq.prepareTransactionRequest), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value,
                ...rest
            });
            if (!chainId) chainId = await (0, $govpX.getAction)(client, (0, $63bwO.getChainId), "getChainId")({});
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction({
                ...request,
                chainId: chainId
            }, {
                serializer: serializer
            });
            return await (0, $govpX.getAction)(client, (0, $7vFPJ.sendRawTransaction), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $iFIxy.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $2wY7l.extract)(rest, {
                format: chainFormat
            }),
            accessList: accessList,
            data: data,
            from: account.address,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        return await client.request({
            method: "eth_sendTransaction",
            params: [
                request
            ]
        });
    } catch (err) {
        throw (0, $forn1.getTransactionError)(err, {
            ...args,
            account: account,
            chain: args.chain || undefined
        });
    }
}

});
parcelRegister("8td0U", function(module, exports) {

$parcel$export(module.exports, "AccountNotFoundError", () => $62ab2061c6f88bda$export$62ee6b05f0767f28);

var $kpVTR = parcelRequire("kpVTR");
class $62ab2061c6f88bda$export$62ee6b05f0767f28 extends (0, $kpVTR.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AccountNotFoundError"
        });
    }
}

});

parcelRegister("ibqtd", function(module, exports) {

$parcel$export(module.exports, "assertCurrentChain", () => $d3cdc9872b962eb9$export$390d312ab46d0597);

var $leMPQ = parcelRequire("leMPQ");
function $d3cdc9872b962eb9$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $leMPQ.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $leMPQ.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}

});
parcelRegister("leMPQ", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", () => $f760c969a13dfa4c$export$f2b2bfa70417796b);
$parcel$export(module.exports, "ChainMismatchError", () => $f760c969a13dfa4c$export$535d82255cc17992);
$parcel$export(module.exports, "ChainNotFoundError", () => $f760c969a13dfa4c$export$b7f33b26fea1ae0b);
$parcel$export(module.exports, "ClientChainNotConfiguredError", () => $f760c969a13dfa4c$export$64807f0e18658482);
$parcel$export(module.exports, "InvalidChainIdError", () => $f760c969a13dfa4c$export$4836eb835ffca5b2);

var $kpVTR = parcelRequire("kpVTR");
class $f760c969a13dfa4c$export$f2b2bfa70417796b extends (0, $kpVTR.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDoesNotSupportContract"
        });
    }
}
class $f760c969a13dfa4c$export$535d82255cc17992 extends (0, $kpVTR.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainMismatchError"
        });
    }
}
class $f760c969a13dfa4c$export$b7f33b26fea1ae0b extends (0, $kpVTR.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotFoundError"
        });
    }
}
class $f760c969a13dfa4c$export$64807f0e18658482 extends (0, $kpVTR.BaseError) {
    constructor(){
        super("No chain was provided to the Client.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ClientChainNotConfiguredError"
        });
    }
}
class $f760c969a13dfa4c$export$4836eb835ffca5b2 extends (0, $kpVTR.BaseError) {
    constructor({ chainId: chainId }){
        super(`Chain ID "${chainId}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidChainIdError"
        });
    }
}

});


parcelRegister("forn1", function(module, exports) {

$parcel$export(module.exports, "getTransactionError", () => $b34e541038c7ef33$export$da1758db1985646e);

var $bI2Lm = parcelRequire("bI2Lm");

var $7UNP4 = parcelRequire("7UNP4");

var $6sGEt = parcelRequire("6sGEt");
function $b34e541038c7ef33$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $6sGEt.getNodeError)(err, args);
        if (cause instanceof (0, $bI2Lm.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $7UNP4.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("bI2Lm", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", () => $8865f2691f3d862d$export$a558573a20f90d54);
$parcel$export(module.exports, "FeeCapTooHighError", () => $8865f2691f3d862d$export$63c545de2a2ec844);
$parcel$export(module.exports, "FeeCapTooLowError", () => $8865f2691f3d862d$export$dbd5936ae1758966);
$parcel$export(module.exports, "NonceTooHighError", () => $8865f2691f3d862d$export$6147426561fdc965);
$parcel$export(module.exports, "NonceTooLowError", () => $8865f2691f3d862d$export$2bb6d6395b589b3b);
$parcel$export(module.exports, "NonceMaxValueError", () => $8865f2691f3d862d$export$71cf1d500f9be262);
$parcel$export(module.exports, "InsufficientFundsError", () => $8865f2691f3d862d$export$b276096bbba16879);
$parcel$export(module.exports, "IntrinsicGasTooHighError", () => $8865f2691f3d862d$export$7ad883b4998b9615);
$parcel$export(module.exports, "IntrinsicGasTooLowError", () => $8865f2691f3d862d$export$813ccdcce0428bcf);
$parcel$export(module.exports, "TransactionTypeNotSupportedError", () => $8865f2691f3d862d$export$a20c52a8beca5c20);
$parcel$export(module.exports, "TipAboveFeeCapError", () => $8865f2691f3d862d$export$6ef9dd5e2f836046);
$parcel$export(module.exports, "UnknownNodeError", () => $8865f2691f3d862d$export$d6085363229de344);

var $7xokh = parcelRequire("7xokh");

var $kpVTR = parcelRequire("kpVTR");
class $8865f2691f3d862d$export$a558573a20f90d54 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($8865f2691f3d862d$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $8865f2691f3d862d$export$63c545de2a2ec844 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7xokh.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooHigh"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $8865f2691f3d862d$export$dbd5936ae1758966 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7xokh.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooLow"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $8865f2691f3d862d$export$6147426561fdc965 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooHighError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $8865f2691f3d862d$export$2bb6d6395b589b3b extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooLowError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $8865f2691f3d862d$export$71cf1d500f9be262 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $8865f2691f3d862d$export$b276096bbba16879 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds/
});
class $8865f2691f3d862d$export$7ad883b4998b9615 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $8865f2691f3d862d$export$813ccdcce0428bcf extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $8865f2691f3d862d$export$a20c52a8beca5c20 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $8865f2691f3d862d$export$6ef9dd5e2f836046 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $7xokh.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7xokh.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($8865f2691f3d862d$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $8865f2691f3d862d$export$d6085363229de344 extends (0, $kpVTR.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownNodeError"
        });
    }
}

});
parcelRegister("7xokh", function(module, exports) {

$parcel$export(module.exports, "formatGwei", () => $57ce7c249376478a$export$a716d64a7f646b61);

var $987xW = parcelRequire("987xW");

var $lTCHO = parcelRequire("lTCHO");
function $57ce7c249376478a$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $lTCHO.formatUnits)(wei, (0, $987xW.gweiUnits)[unit]);
}

});
parcelRegister("987xW", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $6a5ab6ffff26e097$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $6a5ab6ffff26e097$export$a26120bf8be88528);
$parcel$export(module.exports, "weiUnits", () => $6a5ab6ffff26e097$export$b959b3594ea07183);
const $6a5ab6ffff26e097$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $6a5ab6ffff26e097$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $6a5ab6ffff26e097$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("lTCHO", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $ff0cc22bb9a98788$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits.html
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $ff0cc22bb9a98788$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});



parcelRegister("7UNP4", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", () => $5c346924a51552e9$export$cde3d1388a9feac3);
$parcel$export(module.exports, "FeeConflictError", () => $5c346924a51552e9$export$4e13f9693b10724d);
$parcel$export(module.exports, "InvalidLegacyVError", () => $5c346924a51552e9$export$8ffce3f13fa2ade4);
$parcel$export(module.exports, "InvalidSerializableTransactionError", () => $5c346924a51552e9$export$f2282ba9c8899971);
$parcel$export(module.exports, "InvalidStorageKeySizeError", () => $5c346924a51552e9$export$f5e370fd7cd91580);
$parcel$export(module.exports, "TransactionExecutionError", () => $5c346924a51552e9$export$17fc407b5aeb1e96);
$parcel$export(module.exports, "TransactionNotFoundError", () => $5c346924a51552e9$export$23c42bc218867b7c);
$parcel$export(module.exports, "TransactionReceiptNotFoundError", () => $5c346924a51552e9$export$df65591684d92652);
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", () => $5c346924a51552e9$export$69578a09754f4b33);

var $3Szoa = parcelRequire("3Szoa");

var $7xokh = parcelRequire("7xokh");

var $kpVTR = parcelRequire("kpVTR");
function $5c346924a51552e9$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $5c346924a51552e9$export$4e13f9693b10724d extends (0, $kpVTR.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeConflictError"
        });
    }
}
class $5c346924a51552e9$export$8ffce3f13fa2ade4 extends (0, $kpVTR.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidLegacyVError"
        });
    }
}
class $5c346924a51552e9$export$f2282ba9c8899971 extends (0, $kpVTR.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $5c346924a51552e9$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializableTransactionError"
        });
    }
}
class $5c346924a51552e9$export$e410925d6bb07863 extends (0, $kpVTR.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $5c346924a51552e9$export$75fa267d8b74b3b9 extends (0, $kpVTR.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $5c346924a51552e9$export$f5e370fd7cd91580 extends (0, $kpVTR.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStorageKeySizeError"
        });
    }
}
class $5c346924a51552e9$export$17fc407b5aeb1e96 extends (0, $kpVTR.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $5c346924a51552e9$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $3Szoa.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7xokh.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionExecutionError"
        });
        this.cause = cause;
    }
}
class $5c346924a51552e9$export$23c42bc218867b7c extends (0, $kpVTR.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionNotFoundError"
        });
    }
}
class $5c346924a51552e9$export$df65591684d92652 extends (0, $kpVTR.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionReceiptNotFoundError"
        });
    }
}
class $5c346924a51552e9$export$69578a09754f4b33 extends (0, $kpVTR.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});
parcelRegister("3Szoa", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $2d31ddb815755082$export$11bc63b4c03ea518);

var $987xW = parcelRequire("987xW");

var $lTCHO = parcelRequire("lTCHO");
function $2d31ddb815755082$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $lTCHO.formatUnits)(wei, (0, $987xW.etherUnits)[unit]);
}

});


parcelRegister("6sGEt", function(module, exports) {

$parcel$export(module.exports, "getNodeError", () => $4b46715c5cac840a$export$218ee3a1c831c34e);

var $kpVTR = parcelRequire("kpVTR");

var $bI2Lm = parcelRequire("bI2Lm");

var $klW82 = parcelRequire("klW82");

var $cYDOa = parcelRequire("cYDOa");
function $4b46715c5cac840a$export$620efda101db5601(err) {
    return err instanceof (0, $cYDOa.TransactionRejectedRpcError) || err instanceof (0, $cYDOa.InvalidInputRpcError) || err instanceof (0, $klW82.RpcRequestError) && err.code === (0, $bI2Lm.ExecutionRevertedError).code;
}
function $4b46715c5cac840a$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err.walk((e)=>e.code === (0, $bI2Lm.ExecutionRevertedError).code);
    if (executionRevertedError instanceof (0, $kpVTR.BaseError)) return new (0, $bI2Lm.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $bI2Lm.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $bI2Lm.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $bI2Lm.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $bI2Lm.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $bI2Lm.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $bI2Lm.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $bI2Lm.NonceTooHighError).nodeMessage.test(message)) return new (0, $bI2Lm.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $bI2Lm.NonceTooLowError).nodeMessage.test(message)) return new (0, $bI2Lm.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $bI2Lm.NonceMaxValueError).nodeMessage.test(message)) return new (0, $bI2Lm.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $bI2Lm.InsufficientFundsError).nodeMessage.test(message)) return new (0, $bI2Lm.InsufficientFundsError)({
        cause: err
    });
    if ((0, $bI2Lm.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $bI2Lm.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $bI2Lm.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $bI2Lm.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $bI2Lm.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $bI2Lm.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $bI2Lm.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $bI2Lm.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $bI2Lm.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("klW82", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", () => $ed12dbeeb9f4a9dd$export$715ba3385e9f2cf0);
$parcel$export(module.exports, "WebSocketRequestError", () => $ed12dbeeb9f4a9dd$export$e1d72a3a26ed1bc);
$parcel$export(module.exports, "RpcRequestError", () => $ed12dbeeb9f4a9dd$export$a823590631c47261);
$parcel$export(module.exports, "TimeoutError", () => $ed12dbeeb9f4a9dd$export$66d311bf29d5c89c);

var $7Vm0z = parcelRequire("7Vm0z");

var $kpVTR = parcelRequire("kpVTR");

var $gcSc3 = parcelRequire("gcSc3");
class $ed12dbeeb9f4a9dd$export$715ba3385e9f2cf0 extends (0, $kpVTR.BaseError) {
    constructor({ body: body, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $gcSc3.getUrl)(url)}`,
                body && `Request body: ${(0, $7Vm0z.stringify)(body)}`
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $ed12dbeeb9f4a9dd$export$e1d72a3a26ed1bc extends (0, $kpVTR.BaseError) {
    constructor({ body: body, details: details, url: url }){
        super("WebSocket request failed.", {
            details: details,
            metaMessages: [
                `URL: ${(0, $gcSc3.getUrl)(url)}`,
                `Request body: ${(0, $7Vm0z.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WebSocketRequestError"
        });
    }
}
class $ed12dbeeb9f4a9dd$export$a823590631c47261 extends (0, $kpVTR.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $gcSc3.getUrl)(url)}`,
                `Request body: ${(0, $7Vm0z.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
class $ed12dbeeb9f4a9dd$export$66d311bf29d5c89c extends (0, $kpVTR.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $gcSc3.getUrl)(url)}`,
                `Request body: ${(0, $7Vm0z.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TimeoutError"
        });
    }
}

});
parcelRegister("7Vm0z", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $5c4eeda9ff9ed5b2$export$fac44ee5b035f737);
const $5c4eeda9ff9ed5b2$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});


parcelRegister("cYDOa", function(module, exports) {

$parcel$export(module.exports, "RpcError", () => $9729f7b7d82dd814$export$5460eff990f31920);
$parcel$export(module.exports, "ParseRpcError", () => $9729f7b7d82dd814$export$aa31e6432f136746);
$parcel$export(module.exports, "InvalidRequestRpcError", () => $9729f7b7d82dd814$export$ff7b9f15f3eb8d4d);
$parcel$export(module.exports, "MethodNotFoundRpcError", () => $9729f7b7d82dd814$export$4c4044ac99c8d2d3);
$parcel$export(module.exports, "InvalidParamsRpcError", () => $9729f7b7d82dd814$export$c600faffd3cbd390);
$parcel$export(module.exports, "InternalRpcError", () => $9729f7b7d82dd814$export$4e62fafb20e19fd7);
$parcel$export(module.exports, "InvalidInputRpcError", () => $9729f7b7d82dd814$export$3ba2994324ab015e);
$parcel$export(module.exports, "ResourceNotFoundRpcError", () => $9729f7b7d82dd814$export$466772c50c6d6751);
$parcel$export(module.exports, "ResourceUnavailableRpcError", () => $9729f7b7d82dd814$export$270451347568a637);
$parcel$export(module.exports, "TransactionRejectedRpcError", () => $9729f7b7d82dd814$export$f714565c9176e28);
$parcel$export(module.exports, "MethodNotSupportedRpcError", () => $9729f7b7d82dd814$export$b106fe05a02d89c5);
$parcel$export(module.exports, "LimitExceededRpcError", () => $9729f7b7d82dd814$export$2c6f5ab73129d9d7);
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", () => $9729f7b7d82dd814$export$662f3764fa426a13);
$parcel$export(module.exports, "UserRejectedRequestError", () => $9729f7b7d82dd814$export$4af5b080d9e9e1a6);
$parcel$export(module.exports, "UnauthorizedProviderError", () => $9729f7b7d82dd814$export$cc1057a5779c7ffa);
$parcel$export(module.exports, "UnsupportedProviderMethodError", () => $9729f7b7d82dd814$export$6a557500ae315a49);
$parcel$export(module.exports, "ProviderDisconnectedError", () => $9729f7b7d82dd814$export$abb104bf1dd9c38b);
$parcel$export(module.exports, "ChainDisconnectedError", () => $9729f7b7d82dd814$export$ef186cf1cda0444);
$parcel$export(module.exports, "SwitchChainError", () => $9729f7b7d82dd814$export$d4ddb31968a9d366);
$parcel$export(module.exports, "UnknownRpcError", () => $9729f7b7d82dd814$export$bfc830e1ec76e31b);

var $kpVTR = parcelRequire("kpVTR");

var $klW82 = parcelRequire("klW82");
const $9729f7b7d82dd814$var$unknownErrorCode = -1;
class $9729f7b7d82dd814$export$5460eff990f31920 extends (0, $kpVTR.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = cause.name;
        this.code = cause instanceof (0, $klW82.RpcRequestError) ? cause.code : code ?? $9729f7b7d82dd814$var$unknownErrorCode;
    }
}
class $9729f7b7d82dd814$export$417589b978208a8f extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderRpcError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $9729f7b7d82dd814$export$aa31e6432f136746 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$aa31e6432f136746.code,
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ParseRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $9729f7b7d82dd814$export$ff7b9f15f3eb8d4d extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$ff7b9f15f3eb8d4d.code,
            shortMessage: "JSON is not a valid request object."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidRequestRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $9729f7b7d82dd814$export$4c4044ac99c8d2d3 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$4c4044ac99c8d2d3.code,
            shortMessage: "The method does not exist / is not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotFoundRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $9729f7b7d82dd814$export$c600faffd3cbd390 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$c600faffd3cbd390.code,
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParamsRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $9729f7b7d82dd814$export$4e62fafb20e19fd7 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$4e62fafb20e19fd7.code,
            shortMessage: "An internal error was received."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InternalRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $9729f7b7d82dd814$export$3ba2994324ab015e extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$3ba2994324ab015e.code,
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidInputRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $9729f7b7d82dd814$export$466772c50c6d6751 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$466772c50c6d6751.code,
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $9729f7b7d82dd814$export$270451347568a637 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$270451347568a637.code,
            shortMessage: "Requested resource not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceUnavailableRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $9729f7b7d82dd814$export$f714565c9176e28 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$f714565c9176e28.code,
            shortMessage: "Transaction creation failed."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionRejectedRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $9729f7b7d82dd814$export$b106fe05a02d89c5 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$b106fe05a02d89c5.code,
            shortMessage: "Method is not implemented."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotSupportedRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $9729f7b7d82dd814$export$2c6f5ab73129d9d7 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$2c6f5ab73129d9d7.code,
            shortMessage: "Request exceeds defined limit."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "LimitExceededRpcError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $9729f7b7d82dd814$export$662f3764fa426a13 extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$662f3764fa426a13.code,
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "JsonRpcVersionUnsupportedError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $9729f7b7d82dd814$export$4af5b080d9e9e1a6 extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$4af5b080d9e9e1a6.code,
            shortMessage: "User rejected the request."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UserRejectedRequestError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $9729f7b7d82dd814$export$cc1057a5779c7ffa extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$cc1057a5779c7ffa.code,
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnauthorizedProviderError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $9729f7b7d82dd814$export$6a557500ae315a49 extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$6a557500ae315a49.code,
            shortMessage: "The Provider does not support the requested method."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedProviderMethodError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $9729f7b7d82dd814$export$abb104bf1dd9c38b extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$abb104bf1dd9c38b.code,
            shortMessage: "The Provider is disconnected from all chains."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderDisconnectedError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $9729f7b7d82dd814$export$ef186cf1cda0444 extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$ef186cf1cda0444.code,
            shortMessage: "The Provider is not connected to the requested chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDisconnectedError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $9729f7b7d82dd814$export$d4ddb31968a9d366 extends $9729f7b7d82dd814$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $9729f7b7d82dd814$export$d4ddb31968a9d366.code,
            shortMessage: "An error occurred when attempting to switch chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainError"
        });
    }
}
Object.defineProperty($9729f7b7d82dd814$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $9729f7b7d82dd814$export$bfc830e1ec76e31b extends $9729f7b7d82dd814$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            shortMessage: "An unknown RPC error occurred."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownRpcError"
        });
    }
}

});



parcelRegister("2wY7l", function(module, exports) {

$parcel$export(module.exports, "extract", () => $1d7d34078b3bf4f1$export$f9380c9a627682d3);
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $1d7d34078b3bf4f1$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("iFIxy", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", () => $d97e9b15fd860cfa$export$d23fcba447c86a8e);

var $7S6Nv = parcelRequire("7S6Nv");

var $ab6Pi = parcelRequire("ab6Pi");
const $d97e9b15fd860cfa$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2"
};
function $d97e9b15fd860cfa$export$d23fcba447c86a8e(transactionRequest) {
    return {
        ...transactionRequest,
        gas: typeof transactionRequest.gas !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.gas) : undefined,
        gasPrice: typeof transactionRequest.gasPrice !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.gasPrice) : undefined,
        maxFeePerGas: typeof transactionRequest.maxFeePerGas !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.maxPriorityFeePerGas) : undefined,
        nonce: typeof transactionRequest.nonce !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.nonce) : undefined,
        type: typeof transactionRequest.type !== "undefined" ? $d97e9b15fd860cfa$export$b2a848539dcbb25f[transactionRequest.type] : undefined,
        value: typeof transactionRequest.value !== "undefined" ? (0, $7S6Nv.numberToHex)(transactionRequest.value) : undefined
    };
}
const $d97e9b15fd860cfa$export$aba208618cee26e3 = /*#__PURE__*/ (0, $ab6Pi.defineFormatter)("transactionRequest", $d97e9b15fd860cfa$export$d23fcba447c86a8e);

});
parcelRegister("ab6Pi", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", () => $76903a0b6c353f6b$export$5d08535cc975931a);
function $76903a0b6c353f6b$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("govpX", function(module, exports) {

$parcel$export(module.exports, "getAction", () => $bef7422101993237$export$6ca3170acb89054);
/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $bef7422101993237$export$6ca3170acb89054(client, action, // Some minifiers drop `Function.prototype.name`, meaning that `action.name`
// will not work. For that case, the consumer needs to pass the name explicitly.
name) {
    return (params)=>client[action.name || name]?.(params) ?? action(client, params);
}

});

parcelRegister("fHEfg", function(module, exports) {

$parcel$export(module.exports, "assertRequest", () => $b6ea170975dc8044$export$5378021d985ceaf8);

var $e4nLA = parcelRequire("e4nLA");

var $fcphM = parcelRequire("fcphM");

var $bI2Lm = parcelRequire("bI2Lm");

var $7UNP4 = parcelRequire("7UNP4");

var $gg0RY = parcelRequire("gg0RY");
function $b6ea170975dc8044$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $e4nLA.parseAccount)(account_) : undefined;
    if (account && !(0, $gg0RY.isAddress)(account.address)) throw new (0, $fcphM.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $gg0RY.isAddress)(to)) throw new (0, $fcphM.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $7UNP4.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $bI2Lm.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $bI2Lm.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("e34Sq", function(module, exports) {

$parcel$export(module.exports, "prepareTransactionRequest", () => $a3a520ea43d98ae7$export$2e8a9232fb815d77);

var $e4nLA = parcelRequire("e4nLA");

var $bQtjF = parcelRequire("bQtjF");

var $hcljR = parcelRequire("hcljR");

var $bOjxt = parcelRequire("bOjxt");

var $4SGSr = parcelRequire("4SGSr");

var $8td0U = parcelRequire("8td0U");

var $2By6l = parcelRequire("2By6l");

var $govpX = parcelRequire("govpX");

var $fHEfg = parcelRequire("fHEfg");

var $1DQ5d = parcelRequire("1DQ5d");
async function $a3a520ea43d98ae7$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, chain: chain, gas: gas, nonce: nonce, type: type } = args;
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)();
    const account = (0, $e4nLA.parseAccount)(account_);
    const block = await (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({
        blockTag: "latest"
    });
    const request = {
        ...args,
        from: account.address
    };
    if (typeof nonce === "undefined") request.nonce = await (0, $govpX.getAction)(client, (0, $4SGSr.getTransactionCount), "getTransactionCount")({
        address: account.address,
        blockTag: "pending"
    });
    if (typeof type === "undefined") try {
        request.type = (0, $1DQ5d.getTransactionType)(request);
    } catch  {
        // infer type from block
        request.type = typeof block.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
    }
    if (request.type === "eip1559") {
        // EIP-1559 fees
        const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $bQtjF.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $2By6l.MaxFeePerGasTooLowError)({
            maxPriorityFeePerGas: maxPriorityFeePerGas
        });
        request.maxPriorityFeePerGas = maxPriorityFeePerGas;
        request.maxFeePerGas = maxFeePerGas;
    } else {
        // Legacy fees
        if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $2By6l.Eip1559FeesNotSupportedError)();
        const { gasPrice: gasPrice_ } = await (0, $bQtjF.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request,
            type: "legacy"
        });
        request.gasPrice = gasPrice_;
    }
    if (typeof gas === "undefined") request.gas = await (0, $govpX.getAction)(client, (0, $hcljR.estimateGas), "estimateGas")({
        ...request,
        account: {
            address: account.address,
            type: "json-rpc"
        }
    });
    (0, $fHEfg.assertRequest)(request);
    return request;
}

});
parcelRegister("bQtjF", function(module, exports) {

$parcel$export(module.exports, "estimateFeesPerGas", () => $89fb4aa35be47832$export$8193bed8c46d2831);
$parcel$export(module.exports, "internal_estimateFeesPerGas", () => $89fb4aa35be47832$export$67115e8707c5a9e);

var $2By6l = parcelRequire("2By6l");

var $govpX = parcelRequire("govpX");

var $fOZxW = parcelRequire("fOZxW");

var $bOjxt = parcelRequire("bOjxt");

var $cjAPs = parcelRequire("cjAPs");
async function $89fb4aa35be47832$export$8193bed8c46d2831(client, args) {
    return $89fb4aa35be47832$export$67115e8707c5a9e(client, args);
}
async function $89fb4aa35be47832$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $2By6l.BaseFeeScalarError)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") return chain.fees.estimateFeesPerGas({
        block: block_,
        client: client,
        multiply: multiply,
        request: request,
        type: type
    });
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $2By6l.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = request?.maxPriorityFeePerGas ? request.maxPriorityFeePerGas : await (0, $fOZxW.internal_estimateMaxPriorityFeePerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $govpX.getAction)(client, (0, $cjAPs.getGasPrice), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}

});
parcelRegister("2By6l", function(module, exports) {

$parcel$export(module.exports, "BaseFeeScalarError", () => $1e597d4aad5db6ee$export$200c092bedf29ac0);
$parcel$export(module.exports, "Eip1559FeesNotSupportedError", () => $1e597d4aad5db6ee$export$dcf53c0ae183fb46);
$parcel$export(module.exports, "MaxFeePerGasTooLowError", () => $1e597d4aad5db6ee$export$bcf9730904a1086f);

var $7xokh = parcelRequire("7xokh");

var $kpVTR = parcelRequire("kpVTR");
class $1e597d4aad5db6ee$export$200c092bedf29ac0 extends (0, $kpVTR.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseFeeScalarError"
        });
    }
}
class $1e597d4aad5db6ee$export$dcf53c0ae183fb46 extends (0, $kpVTR.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Eip1559FeesNotSupportedError"
        });
    }
}
class $1e597d4aad5db6ee$export$bcf9730904a1086f extends (0, $kpVTR.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $7xokh.formatGwei)(maxPriorityFeePerGas)} gwei).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MaxFeePerGasTooLowError"
        });
    }
}

});

parcelRegister("fOZxW", function(module, exports) {

$parcel$export(module.exports, "estimateMaxPriorityFeePerGas", () => $b84b445d7f60bea9$export$fd79a693887f886c);
$parcel$export(module.exports, "internal_estimateMaxPriorityFeePerGas", () => $b84b445d7f60bea9$export$59275bafd388148);

var $2By6l = parcelRequire("2By6l");

var $dKCgU = parcelRequire("dKCgU");

var $govpX = parcelRequire("govpX");

var $bOjxt = parcelRequire("bOjxt");

var $cjAPs = parcelRequire("cjAPs");
async function $b84b445d7f60bea9$export$fd79a693887f886c(client, args) {
    return $b84b445d7f60bea9$export$59275bafd388148(client, args);
}
async function $b84b445d7f60bea9$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    if (typeof chain?.fees?.defaultPriorityFee === "function") {
        const block = block_ || await (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({});
        return chain.fees.defaultPriorityFee({
            block: block,
            client: client,
            request: request
        });
    }
    if (typeof chain?.fees?.defaultPriorityFee !== "undefined") return chain?.fees?.defaultPriorityFee;
    try {
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $dKCgU.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({}),
            (0, $govpX.getAction)(client, (0, $cjAPs.getGasPrice), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $2By6l.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}

});
parcelRegister("bOjxt", function(module, exports) {

$parcel$export(module.exports, "getBlock", () => $8993853ce419f01f$export$ea0af84ed2e77902);

var $cI1AV = parcelRequire("cI1AV");

var $7S6Nv = parcelRequire("7S6Nv");

var $6aJeG = parcelRequire("6aJeG");
async function $8993853ce419f01f$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    });
    if (!block) throw new (0, $cI1AV.BlockNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $6aJeG.formatBlock);
    return format(block);
}

});
parcelRegister("cI1AV", function(module, exports) {

$parcel$export(module.exports, "BlockNotFoundError", () => $940ad4b9cbb85fa0$export$f5a00468af285e38);

var $kpVTR = parcelRequire("kpVTR");
class $940ad4b9cbb85fa0$export$f5a00468af285e38 extends (0, $kpVTR.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BlockNotFoundError"
        });
    }
}

});

parcelRegister("6aJeG", function(module, exports) {

$parcel$export(module.exports, "formatBlock", () => $47e6c41ec57d85e1$export$ba1152bc4017d62a);
$parcel$export(module.exports, "defineBlock", () => $47e6c41ec57d85e1$export$9f35cb3327f1a5c5);

var $ab6Pi = parcelRequire("ab6Pi");

var $icori = parcelRequire("icori");
function $47e6c41ec57d85e1$export$ba1152bc4017d62a(block) {
    const transactions = block.transactions?.map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $icori.formatTransaction)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $47e6c41ec57d85e1$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $ab6Pi.defineFormatter)("block", $47e6c41ec57d85e1$export$ba1152bc4017d62a);

});
parcelRegister("icori", function(module, exports) {

$parcel$export(module.exports, "transactionType", () => $d3fc4e196b8ba2c9$export$cd5f936b62a5e91);
$parcel$export(module.exports, "formatTransaction", () => $d3fc4e196b8ba2c9$export$b02b16590d26dadc);
$parcel$export(module.exports, "defineTransaction", () => $d3fc4e196b8ba2c9$export$c19bdc7dbe69198d);

var $dKCgU = parcelRequire("dKCgU");

var $ab6Pi = parcelRequire("ab6Pi");
const $d3fc4e196b8ba2c9$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559"
};
function $d3fc4e196b8ba2c9$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $dKCgU.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $dKCgU.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $d3fc4e196b8ba2c9$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    return transaction_;
}
const $d3fc4e196b8ba2c9$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $ab6Pi.defineFormatter)("transaction", $d3fc4e196b8ba2c9$export$b02b16590d26dadc);

});



parcelRegister("cjAPs", function(module, exports) {

$parcel$export(module.exports, "getGasPrice", () => $8f73d3dc903bac09$export$89c15b50d46d3f8c);
/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice.html
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $8f73d3dc903bac09$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}

});



parcelRegister("hcljR", function(module, exports) {

$parcel$export(module.exports, "estimateGas", () => $c8541838485423b1$export$e0580ae1f48db848);

var $e4nLA = parcelRequire("e4nLA");

var $8td0U = parcelRequire("8td0U");

var $7S6Nv = parcelRequire("7S6Nv");

var $fOUXj = parcelRequire("fOUXj");

var $2wY7l = parcelRequire("2wY7l");

var $iFIxy = parcelRequire("iFIxy");

var $fHEfg = parcelRequire("fHEfg");

var $e34Sq = parcelRequire("e34Sq");
async function $c8541838485423b1$export$e0580ae1f48db848(client, args) {
    const account_ = args.account ?? client.account;
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)({
        docsPath: "/docs/actions/public/estimateGas"
    });
    const account = (0, $e4nLA.parseAccount)(account_);
    try {
        const { accessList: accessList, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = account.type === "local" ? await (0, $e34Sq.prepareTransactionRequest)(client, args) : args;
        const blockNumberHex = blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        (0, $fHEfg.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $iFIxy.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $2wY7l.extract)(rest, {
                format: chainFormat
            }),
            from: account.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        const balance = await client.request({
            method: "eth_estimateGas",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        return BigInt(balance);
    } catch (err) {
        throw (0, $fOUXj.getEstimateGasError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}

});
parcelRegister("fOUXj", function(module, exports) {

$parcel$export(module.exports, "getEstimateGasError", () => $b847b4b9985c74e4$export$f201b805dbcd7c48);

var $hbslX = parcelRequire("hbslX");

var $bI2Lm = parcelRequire("bI2Lm");

var $6sGEt = parcelRequire("6sGEt");
function $b847b4b9985c74e4$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $6sGEt.getNodeError)(err, args);
        if (cause instanceof (0, $bI2Lm.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $hbslX.EstimateGasExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("hbslX", function(module, exports) {

$parcel$export(module.exports, "EstimateGasExecutionError", () => $c829751299df96e3$export$9e393e362ab0c102);

var $3Szoa = parcelRequire("3Szoa");

var $7xokh = parcelRequire("7xokh");

var $kpVTR = parcelRequire("kpVTR");

var $7UNP4 = parcelRequire("7UNP4");
class $c829751299df96e3$export$9e393e362ab0c102 extends (0, $kpVTR.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $7UNP4.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $3Szoa.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7xokh.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EstimateGasExecutionError"
        });
        this.cause = cause;
    }
}

});



parcelRegister("4SGSr", function(module, exports) {

$parcel$export(module.exports, "getTransactionCount", () => $38dd7710eae95b41$export$b18e66333ec1361e);

var $dKCgU = parcelRequire("dKCgU");

var $7S6Nv = parcelRequire("7S6Nv");
async function $38dd7710eae95b41$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : blockTag
        ]
    });
    return (0, $dKCgU.hexToNumber)(count);
}

});

parcelRegister("1DQ5d", function(module, exports) {

$parcel$export(module.exports, "getTransactionType", () => $1321d5964eaa8bcd$export$944c6678cd5a1ea8);

var $7UNP4 = parcelRequire("7UNP4");
function $1321d5964eaa8bcd$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $7UNP4.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}

});


parcelRegister("7vFPJ", function(module, exports) {

$parcel$export(module.exports, "sendRawTransaction", () => $577be0e3855443f6$export$4e309754b4830e29);
/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction.html
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $577be0e3855443f6$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    });
}

});



parcelRegister("6L6k4", function(module, exports) {

$parcel$export(module.exports, "getAddresses", () => $4ebc096fde2616a5$export$17d5f00cfd692b8a);

var $aegFK = parcelRequire("aegFK");
async function $4ebc096fde2616a5$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === "local") return [
        client.account.address
    ];
    const addresses = await client.request({
        method: "eth_accounts"
    });
    return addresses.map((address)=>(0, $aegFK.checksumAddress)(address));
}

});
parcelRegister("aegFK", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $772824f360beed97$export$9ff46e8f6df13548);
$parcel$export(module.exports, "getAddress", () => $772824f360beed97$export$88411125f012957a);

var $fcphM = parcelRequire("fcphM");

var $ihras = parcelRequire("ihras");

var $9mkfv = parcelRequire("9mkfv");

var $gg0RY = parcelRequire("gg0RY");
function $772824f360beed97$export$9ff46e8f6df13548(address_, chainId) {
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $9mkfv.keccak256)((0, $ihras.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    return `0x${address.join("")}`;
}
function $772824f360beed97$export$88411125f012957a(address, chainId) {
    if (!(0, $gg0RY.isAddress)(address)) throw new (0, $fcphM.InvalidAddressError)({
        address: address
    });
    return $772824f360beed97$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("9mkfv", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $6d05e0302a5165cf$export$f8151fce47ad1c35);

var $6oSRo = parcelRequire("6oSRo");

var $fmvmO = parcelRequire("fmvmO");

var $ihras = parcelRequire("ihras");

var $7S6Nv = parcelRequire("7S6Nv");
function $6d05e0302a5165cf$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $6oSRo.keccak_256)((0, $fmvmO.isHex)(value, {
        strict: false
    }) ? (0, $ihras.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $7S6Nv.toHex)(bytes);
}

});
parcelRegister("6oSRo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $6Y25Y = parcelRequire("6Y25Y");

var $ayho8 = parcelRequire("ayho8");

var $8KPn4 = parcelRequire("8KPn4");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$4a8f8a0d65d877a9$var$SHA3_PI, $4a8f8a0d65d877a9$var$SHA3_ROTL, $4a8f8a0d65d877a9$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $4a8f8a0d65d877a9$var$_0n = /* @__PURE__ */ BigInt(0);
const $4a8f8a0d65d877a9$var$_1n = /* @__PURE__ */ BigInt(1);
const $4a8f8a0d65d877a9$var$_2n = /* @__PURE__ */ BigInt(2);
const $4a8f8a0d65d877a9$var$_7n = /* @__PURE__ */ BigInt(7);
const $4a8f8a0d65d877a9$var$_256n = /* @__PURE__ */ BigInt(256);
const $4a8f8a0d65d877a9$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $4a8f8a0d65d877a9$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $4a8f8a0d65d877a9$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $4a8f8a0d65d877a9$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $4a8f8a0d65d877a9$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $4a8f8a0d65d877a9$var$_1n ^ (R >> $4a8f8a0d65d877a9$var$_7n) * $4a8f8a0d65d877a9$var$_0x71n) % $4a8f8a0d65d877a9$var$_256n;
        if (R & $4a8f8a0d65d877a9$var$_2n) t ^= $4a8f8a0d65d877a9$var$_1n << ($4a8f8a0d65d877a9$var$_1n << /* @__PURE__ */ BigInt(j)) - $4a8f8a0d65d877a9$var$_1n;
    }
    $4a8f8a0d65d877a9$var$_SHA3_IOTA.push(t);
}
const [$4a8f8a0d65d877a9$var$SHA3_IOTA_H, $4a8f8a0d65d877a9$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $ayho8.split)($4a8f8a0d65d877a9$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $4a8f8a0d65d877a9$var$rotlH = (h, l, s)=>s > 32 ? (0, $ayho8.rotlBH)(h, l, s) : (0, $ayho8.rotlSH)(h, l, s);
const $4a8f8a0d65d877a9$var$rotlL = (h, l, s)=>s > 32 ? (0, $ayho8.rotlBL)(h, l, s) : (0, $ayho8.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $4a8f8a0d65d877a9$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $4a8f8a0d65d877a9$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $4a8f8a0d65d877a9$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $4a8f8a0d65d877a9$var$SHA3_ROTL[t];
            const Th = $4a8f8a0d65d877a9$var$rotlH(curH, curL, shift);
            const Tl = $4a8f8a0d65d877a9$var$rotlL(curH, curL, shift);
            const PI = $4a8f8a0d65d877a9$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $4a8f8a0d65d877a9$var$SHA3_IOTA_H[round];
        s[1] ^= $4a8f8a0d65d877a9$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $4a8f8a0d65d877a9$var$keccakP;
class $4a8f8a0d65d877a9$var$Keccak extends $8KPn4.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $6Y25Y.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $8KPn4.u32)(this.state);
    }
    keccak() {
        $4a8f8a0d65d877a9$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $6Y25Y.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $8KPn4.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $6Y25Y.exists)(this, false);
        (0, $6Y25Y.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $6Y25Y.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $6Y25Y.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $4a8f8a0d65d877a9$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $4a8f8a0d65d877a9$var$Keccak;
const $4a8f8a0d65d877a9$var$gen = (suffix, blockLen, outputLen)=>(0, $8KPn4.wrapConstructor)(()=>new $4a8f8a0d65d877a9$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $4a8f8a0d65d877a9$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $4a8f8a0d65d877a9$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $4a8f8a0d65d877a9$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $4a8f8a0d65d877a9$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $4a8f8a0d65d877a9$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $4a8f8a0d65d877a9$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $4a8f8a0d65d877a9$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $4a8f8a0d65d877a9$var$gen(0x01, 72, 64);
const $4a8f8a0d65d877a9$var$genShake = (suffix, blockLen, outputLen)=>(0, $8KPn4.wrapXOFConstructorWithOpts)((opts = {})=>new $4a8f8a0d65d877a9$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $4a8f8a0d65d877a9$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $4a8f8a0d65d877a9$var$genShake(0x1f, 136, 32);

});
parcelRegister("6Y25Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $5129f8bf9441acb0$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $5129f8bf9441acb0$var$number;
function $5129f8bf9441acb0$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $5129f8bf9441acb0$var$bool;
function $5129f8bf9441acb0$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $5129f8bf9441acb0$var$bytes;
function $5129f8bf9441acb0$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $5129f8bf9441acb0$var$number(hash.outputLen);
    $5129f8bf9441acb0$var$number(hash.blockLen);
}
module.exports.hash = $5129f8bf9441acb0$var$hash;
function $5129f8bf9441acb0$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $5129f8bf9441acb0$var$exists;
function $5129f8bf9441acb0$var$output(out, instance) {
    $5129f8bf9441acb0$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $5129f8bf9441acb0$var$output;
const $5129f8bf9441acb0$var$assert = {
    number: $5129f8bf9441acb0$var$number,
    bool: $5129f8bf9441acb0$var$bool,
    bytes: $5129f8bf9441acb0$var$bytes,
    hash: $5129f8bf9441acb0$var$hash,
    exists: $5129f8bf9441acb0$var$exists,
    output: $5129f8bf9441acb0$var$output
};
module.exports.default = $5129f8bf9441acb0$var$assert;

});

parcelRegister("ayho8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $7aea9150730d29e4$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $7aea9150730d29e4$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $7aea9150730d29e4$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $7aea9150730d29e4$var$U32_MASK64),
        l: Number(n >> $7aea9150730d29e4$var$_32n & $7aea9150730d29e4$var$U32_MASK64)
    };
    return {
        h: Number(n >> $7aea9150730d29e4$var$_32n & $7aea9150730d29e4$var$U32_MASK64) | 0,
        l: Number(n & $7aea9150730d29e4$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $7aea9150730d29e4$var$fromBig;
function $7aea9150730d29e4$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $7aea9150730d29e4$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $7aea9150730d29e4$var$split;
const $7aea9150730d29e4$var$toBig = (h, l)=>BigInt(h >>> 0) << $7aea9150730d29e4$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $7aea9150730d29e4$var$toBig;
// for Shift in [0, 32)
const $7aea9150730d29e4$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $7aea9150730d29e4$var$shrSH;
const $7aea9150730d29e4$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $7aea9150730d29e4$var$shrSL;
// Right rotate for Shift in [1, 32)
const $7aea9150730d29e4$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $7aea9150730d29e4$var$rotrSH;
const $7aea9150730d29e4$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $7aea9150730d29e4$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $7aea9150730d29e4$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $7aea9150730d29e4$var$rotrBH;
const $7aea9150730d29e4$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $7aea9150730d29e4$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $7aea9150730d29e4$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $7aea9150730d29e4$var$rotr32H;
const $7aea9150730d29e4$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $7aea9150730d29e4$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $7aea9150730d29e4$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $7aea9150730d29e4$var$rotlSH;
const $7aea9150730d29e4$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $7aea9150730d29e4$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $7aea9150730d29e4$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $7aea9150730d29e4$var$rotlBH;
const $7aea9150730d29e4$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $7aea9150730d29e4$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $7aea9150730d29e4$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $7aea9150730d29e4$var$add;
// Addition with more than 2 elements
const $7aea9150730d29e4$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $7aea9150730d29e4$var$add3L;
const $7aea9150730d29e4$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $7aea9150730d29e4$var$add3H;
const $7aea9150730d29e4$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $7aea9150730d29e4$var$add4L;
const $7aea9150730d29e4$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $7aea9150730d29e4$var$add4H;
const $7aea9150730d29e4$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $7aea9150730d29e4$var$add5L;
const $7aea9150730d29e4$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $7aea9150730d29e4$var$add5H;
// prettier-ignore
const $7aea9150730d29e4$var$u64 = {
    fromBig: $7aea9150730d29e4$var$fromBig,
    split: $7aea9150730d29e4$var$split,
    toBig: $7aea9150730d29e4$var$toBig,
    shrSH: $7aea9150730d29e4$var$shrSH,
    shrSL: $7aea9150730d29e4$var$shrSL,
    rotrSH: $7aea9150730d29e4$var$rotrSH,
    rotrSL: $7aea9150730d29e4$var$rotrSL,
    rotrBH: $7aea9150730d29e4$var$rotrBH,
    rotrBL: $7aea9150730d29e4$var$rotrBL,
    rotr32H: $7aea9150730d29e4$var$rotr32H,
    rotr32L: $7aea9150730d29e4$var$rotr32L,
    rotlSH: $7aea9150730d29e4$var$rotlSH,
    rotlSL: $7aea9150730d29e4$var$rotlSL,
    rotlBH: $7aea9150730d29e4$var$rotlBH,
    rotlBL: $7aea9150730d29e4$var$rotlBL,
    add: $7aea9150730d29e4$var$add,
    add3L: $7aea9150730d29e4$var$add3L,
    add3H: $7aea9150730d29e4$var$add3H,
    add4L: $7aea9150730d29e4$var$add4L,
    add4H: $7aea9150730d29e4$var$add4H,
    add5H: $7aea9150730d29e4$var$add5H,
    add5L: $7aea9150730d29e4$var$add5L
};
module.exports.default = $7aea9150730d29e4$var$u64;

});

parcelRegister("8KPn4", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $9Qjdv = parcelRequire("9Qjdv");
const $65fa77d2d28ffb9c$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $65fa77d2d28ffb9c$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $65fa77d2d28ffb9c$var$u8;
const $65fa77d2d28ffb9c$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $65fa77d2d28ffb9c$var$u32;
// Cast array to view
const $65fa77d2d28ffb9c$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $65fa77d2d28ffb9c$var$createView;
// The rotate right (circular right shift) operation for uint32
const $65fa77d2d28ffb9c$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $65fa77d2d28ffb9c$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $65fa77d2d28ffb9c$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $65fa77d2d28ffb9c$var$bytesToHex(bytes) {
    if (!$65fa77d2d28ffb9c$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $65fa77d2d28ffb9c$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $65fa77d2d28ffb9c$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $65fa77d2d28ffb9c$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $65fa77d2d28ffb9c$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $65fa77d2d28ffb9c$var$nextTick = async ()=>{};
module.exports.nextTick = $65fa77d2d28ffb9c$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $65fa77d2d28ffb9c$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $65fa77d2d28ffb9c$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $65fa77d2d28ffb9c$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $65fa77d2d28ffb9c$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $65fa77d2d28ffb9c$var$toBytes(data) {
    if (typeof data === "string") data = $65fa77d2d28ffb9c$var$utf8ToBytes(data);
    if (!$65fa77d2d28ffb9c$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $65fa77d2d28ffb9c$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $65fa77d2d28ffb9c$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$65fa77d2d28ffb9c$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $65fa77d2d28ffb9c$var$concatBytes;
// For runtime check if class implements interface
class $65fa77d2d28ffb9c$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $65fa77d2d28ffb9c$var$Hash;
const $65fa77d2d28ffb9c$var$toStr = {}.toString;
function $65fa77d2d28ffb9c$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $65fa77d2d28ffb9c$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $65fa77d2d28ffb9c$var$checkOpts;
function $65fa77d2d28ffb9c$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($65fa77d2d28ffb9c$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $65fa77d2d28ffb9c$var$wrapConstructor;
function $65fa77d2d28ffb9c$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($65fa77d2d28ffb9c$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $65fa77d2d28ffb9c$var$wrapConstructorWithOpts;
function $65fa77d2d28ffb9c$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($65fa77d2d28ffb9c$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $65fa77d2d28ffb9c$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $65fa77d2d28ffb9c$var$randomBytes(bytesLength = 32) {
    if ($9Qjdv.crypto && typeof $9Qjdv.crypto.getRandomValues === "function") return $9Qjdv.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $65fa77d2d28ffb9c$var$randomBytes;

});
parcelRegister("9Qjdv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("l9nJJ", function(module, exports) {

$parcel$export(module.exports, "getPermissions", () => $f65cd9d697a8083d$export$e10fd44ca431fa8e);
/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions.html
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $f65cd9d697a8083d$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: "wallet_getPermissions"
    });
    return permissions;
}

});

parcelRegister("eiu28", function(module, exports) {

$parcel$export(module.exports, "requestAddresses", () => $a68a0b1f0e16ba17$export$87c5bcc1dede6f06);

var $aegFK = parcelRequire("aegFK");
async function $a68a0b1f0e16ba17$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: "eth_requestAccounts"
    });
    return addresses.map((address)=>(0, $aegFK.getAddress)(address));
}

});

parcelRegister("arBYz", function(module, exports) {

$parcel$export(module.exports, "requestPermissions", () => $79a9e240f1eff4e5$export$8cec5d3683c6896e);
/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions.html
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $79a9e240f1eff4e5$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: "wallet_requestPermissions",
        params: [
            permissions
        ]
    });
}

});

parcelRegister("3J6W2", function(module, exports) {

$parcel$export(module.exports, "signMessage", () => $2b6af435b9eab42f$export$1d9a7a8a40780de);

var $e4nLA = parcelRequire("e4nLA");

var $8td0U = parcelRequire("8td0U");

var $7S6Nv = parcelRequire("7S6Nv");
async function $2b6af435b9eab42f$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $e4nLA.parseAccount)(account_);
    if (account.type === "local") return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $7S6Nv.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $7S6Nv.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    });
}

});

parcelRegister("hIihj", function(module, exports) {

$parcel$export(module.exports, "signTransaction", () => $ce54b964f84e810c$export$6ad02cc4966b42ab);

var $e4nLA = parcelRequire("e4nLA");

var $8td0U = parcelRequire("8td0U");


var $ibqtd = parcelRequire("ibqtd");

var $iFIxy = parcelRequire("iFIxy");

var $govpX = parcelRequire("govpX");

var $7S6Nv = parcelRequire("7S6Nv");

var $fHEfg = parcelRequire("fHEfg");

var $63bwO = parcelRequire("63bwO");
async function $ce54b964f84e810c$export$6ad02cc4966b42ab(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = args;
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, $e4nLA.parseAccount)(account_);
    (0, $fHEfg.assertRequest)({
        account: account,
        ...args
    });
    const chainId = await (0, $govpX.getAction)(client, (0, $63bwO.getChainId), "getChainId")({});
    if (chain !== null) (0, $ibqtd.assertCurrentChain)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $iFIxy.formatTransactionRequest);
    if (account.type === "local") return account.signTransaction({
        ...transaction,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: "eth_signTransaction",
        params: [
            {
                ...format(transaction),
                chainId: (0, $7S6Nv.numberToHex)(chainId),
                from: account.address
            }
        ]
    });
}

});

parcelRegister("e7uh1", function(module, exports) {

$parcel$export(module.exports, "signTypedData", () => $a47933d901cdcadd$export$9f05de2db4d31153);

var $e4nLA = parcelRequire("e4nLA");

var $8td0U = parcelRequire("8td0U");

var $fmvmO = parcelRequire("fmvmO");

var $7Vm0z = parcelRequire("7Vm0z");

var $iDwe1 = parcelRequire("iDwe1");
async function $a47933d901cdcadd$export$9f05de2db4d31153(client, { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    if (!account_) throw new (0, $8td0U.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, $e4nLA.parseAccount)(account_);
    const types = {
        EIP712Domain: (0, $iDwe1.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $iDwe1.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.type === "local") return account.signTypedData({
        domain: domain,
        primaryType: primaryType,
        types: types,
        message: message
    });
    const typedData = (0, $7Vm0z.stringify)({
        domain: domain ?? {},
        primaryType: primaryType,
        types: types,
        message: message
    }, (_, value)=>(0, $fmvmO.isHex)(value) ? value.toLowerCase() : value);
    return client.request({
        method: "eth_signTypedData_v4",
        params: [
            account.address,
            typedData
        ]
    });
}

});
parcelRegister("iDwe1", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", () => $d914ddc8a97b4cac$export$fac174f558903e26);
$parcel$export(module.exports, "getTypesForEIP712Domain", () => $d914ddc8a97b4cac$export$6a292159484ee032);

var $329cO = parcelRequire("329cO");

var $fcphM = parcelRequire("fcphM");

var $gg0RY = parcelRequire("gg0RY");

var $7ahE1 = parcelRequire("7ahE1");

var $7S6Nv = parcelRequire("7S6Nv");

var $9rq6f = parcelRequire("9rq6f");

var $behyn = parcelRequire("behyn");
function $d914ddc8a97b4cac$export$fac174f558903e26({ domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    const types = types_;
    const validateData = (struct, value_)=>{
        for (const param of struct){
            const { name: name, type: type_ } = param;
            const type = type_;
            const value = value_[name];
            const integerMatch = type.match((0, $9rq6f.integerRegex));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $7S6Nv.numberToHex)(value, {
                    signed: base === "int",
                    size: parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $gg0RY.isAddress)(value)) throw new (0, $fcphM.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $9rq6f.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $7ahE1.size)(value) !== parseInt(size_)) throw new (0, $329cO.BytesSizeMismatchError)({
                    expectedSize: parseInt(size_),
                    givenSize: (0, $7ahE1.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    if (primaryType !== "EIP712Domain") {
        // Validate message types.
        const type = types[primaryType];
        validateData(type, message);
    }
}
function $d914ddc8a97b4cac$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        typeof domain?.chainId === "number" && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $d914ddc8a97b4cac$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $behyn.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $d914ddc8a97b4cac$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}

});
parcelRegister("9rq6f", function(module, exports) {

$parcel$export(module.exports, "arrayRegex", () => $6dfae190df0c48a2$export$6cd562aaf6380f0e);
$parcel$export(module.exports, "bytesRegex", () => $6dfae190df0c48a2$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $6dfae190df0c48a2$export$45902cc189596eef);
const $6dfae190df0c48a2$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $6dfae190df0c48a2$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $6dfae190df0c48a2$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});

parcelRegister("behyn", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", () => $82ce9e4508bca389$export$9e2bd399d9aaab56);
$parcel$export(module.exports, "hashDomain", () => $82ce9e4508bca389$export$d4e887b08c47faea);
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $iSG3s = parcelRequire("iSG3s");

var $jSK74 = parcelRequire("jSK74");

var $7S6Nv = parcelRequire("7S6Nv");

var $9mkfv = parcelRequire("9mkfv");

var $iDwe1 = parcelRequire("iDwe1");
function $82ce9e4508bca389$export$9e2bd399d9aaab56({ domain: domain_, message: message, primaryType: primaryType, types: types_ }) {
    const domain = typeof domain_ === "undefined" ? {} : domain_;
    const types = {
        EIP712Domain: (0, $iDwe1.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $iDwe1.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($82ce9e4508bca389$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($82ce9e4508bca389$var$hashStruct({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $9mkfv.keccak256)((0, $jSK74.concat)(parts));
}
function $82ce9e4508bca389$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $82ce9e4508bca389$var$hashStruct({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $82ce9e4508bca389$var$hashStruct({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $82ce9e4508bca389$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $9mkfv.keccak256)(encoded);
}
function $82ce9e4508bca389$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $82ce9e4508bca389$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $82ce9e4508bca389$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $iSG3s.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $82ce9e4508bca389$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $7S6Nv.toHex)($82ce9e4508bca389$var$encodeType({
        primaryType: primaryType,
        types: types
    }));
    return (0, $9mkfv.keccak256)(encodedHashType);
}
function $82ce9e4508bca389$var$encodeType({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $82ce9e4508bca389$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $82ce9e4508bca389$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$82ce9e4508bca389$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $82ce9e4508bca389$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $9mkfv.keccak256)($82ce9e4508bca389$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $9mkfv.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $9mkfv.keccak256)((0, $7S6Nv.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$82ce9e4508bca389$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $9mkfv.keccak256)((0, $iSG3s.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});



parcelRegister("aTnNy", function(module, exports) {

$parcel$export(module.exports, "switchChain", () => $7ee1804829a4ad22$export$15599da40e72d2f);

var $7S6Nv = parcelRequire("7S6Nv");
async function $7ee1804829a4ad22$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: (0, $7S6Nv.numberToHex)(id)
            }
        ]
    });
}

});

parcelRegister("efAaV", function(module, exports) {

$parcel$export(module.exports, "watchAsset", () => $a5fe870c35b9f4f8$export$7eea68d1a70548bd);
/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset.html
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $a5fe870c35b9f4f8$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: "wallet_watchAsset",
        params: params
    });
    return added;
}

});

parcelRegister("iHyR5", function(module, exports) {

$parcel$export(module.exports, "writeContract", () => $d9d747b1b381f0d9$export$4c0f201bc17cbf23);

var $2tMbE = parcelRequire("2tMbE");

var $govpX = parcelRequire("govpX");

var $hc4Fy = parcelRequire("hc4Fy");
async function $d9d747b1b381f0d9$export$4c0f201bc17cbf23(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request }) {
    const data = (0, $2tMbE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    const hash = await (0, $govpX.getAction)(client, (0, $hc4Fy.sendTransaction), "sendTransaction")({
        data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
        to: address,
        ...request
    });
    return hash;
}

});
parcelRegister("2tMbE", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", () => $1ce3ab1bc091c869$export$f4ee15df45da9f03);

var $329cO = parcelRequire("329cO");

var $jSK74 = parcelRequire("jSK74");

var $9dV1M = parcelRequire("9dV1M");

var $iSG3s = parcelRequire("iSG3s");

var $j8Xjk = parcelRequire("j8Xjk");

var $5yVb5 = parcelRequire("5yVb5");
function $1ce3ab1bc091c869$export$f4ee15df45da9f03({ abi: abi, args: args, functionName: functionName }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $5yVb5.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $329cO.AbiFunctionNotFoundError)(functionName, {
            docsPath: "/docs/contract/encodeFunctionData"
        });
    }
    if (abiItem.type !== "function") throw new (0, $329cO.AbiFunctionNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeFunctionData"
    });
    const definition = (0, $j8Xjk.formatAbiItem)(abiItem);
    const signature = (0, $9dV1M.getFunctionSelector)(definition);
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $iSG3s.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $jSK74.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("9dV1M", function(module, exports) {

$parcel$export(module.exports, "getFunctionSelector", () => $6b7190775394445a$export$98bae2de9b88fbac);

var $h8fZV = parcelRequire("h8fZV");

var $ihras = parcelRequire("ihras");

var $gyUwH = parcelRequire("gyUwH");

var $9mkfv = parcelRequire("9mkfv");
const $6b7190775394445a$var$hash = (value)=>(0, $9mkfv.keccak256)((0, $ihras.toBytes)(value));
const $6b7190775394445a$export$98bae2de9b88fbac = (fn)=>(0, $h8fZV.slice)($6b7190775394445a$var$hash((0, $gyUwH.getFunctionSignature)(fn)), 0, 4);

});
parcelRegister("gyUwH", function(module, exports) {

$parcel$export(module.exports, "getFunctionSignature", () => $c0ebab4954a81504$export$d7a3ed3159f7637d);

var $euyto = parcelRequire("euyto");

var $gXIJV = parcelRequire("gXIJV");
const $c0ebab4954a81504$export$d7a3ed3159f7637d = (fn_)=>{
    const fn = (()=>{
        if (typeof fn_ === "string") return fn_;
        return (0, $euyto.formatAbiItem)(fn_);
    })();
    return (0, $gXIJV.normalizeSignature)(fn);
};

});
parcelRegister("euyto", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $a8ce9bafe4661c6c$export$dc5d0ff4fc2fdee1);

var $9Y25C = parcelRequire("9Y25C");
function $a8ce9bafe4661c6c$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $9Y25C.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $9Y25C.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    else if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $9Y25C.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $9Y25C.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "constructor") return `constructor(${(0, $9Y25C.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    else if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("9Y25C", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", () => $741b569dc19a3f6c$export$c55dbda1a081631e);

var $kfGwA = parcelRequire("kfGwA");
function $741b569dc19a3f6c$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $kfGwA.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("kfGwA", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", () => $ebe631df810985ce$export$c75e01ebc733dc6b);

var $7E0Rr = parcelRequire("7E0Rr");
const $ebe631df810985ce$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $ebe631df810985ce$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($ebe631df810985ce$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $ebe631df810985ce$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $7E0Rr.execTyped)($ebe631df810985ce$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $ebe631df810985ce$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("7E0Rr", function(module, exports) {

$parcel$export(module.exports, "execTyped", () => $590cefcc7d4bb23e$export$1cca4755fb17f5bd);
$parcel$export(module.exports, "bytesRegex", () => $590cefcc7d4bb23e$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $590cefcc7d4bb23e$export$45902cc189596eef);
$parcel$export(module.exports, "isTupleRegex", () => $590cefcc7d4bb23e$export$5c1628af1434aed0);
function $590cefcc7d4bb23e$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $590cefcc7d4bb23e$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $590cefcc7d4bb23e$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $590cefcc7d4bb23e$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("gXIJV", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", () => $c594dc6b55ea002a$export$5cba87ebe4d0307a);

var $kpVTR = parcelRequire("kpVTR");
function $c594dc6b55ea002a$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $kpVTR.BaseError)("Unable to normalize signature.");
    return result;
}

});



parcelRegister("5yVb5", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", () => $40cc7b0f15d4be4b$export$99b134cd177e9574);


var $329cO = parcelRequire("329cO");

var $fmvmO = parcelRequire("fmvmO");

var $apDyM = parcelRequire("apDyM");

var $9dV1M = parcelRequire("9dV1M");

var $gg0RY = parcelRequire("gg0RY");
function $40cc7b0f15d4be4b$export$99b134cd177e9574({ abi: abi, args: args = [], name: name }) {
    const isSelector = (0, $fmvmO.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $9dV1M.getFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $apDyM.getEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $40cc7b0f15d4be4b$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $40cc7b0f15d4be4b$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $329cO.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $40cc7b0f15d4be4b$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $gg0RY.isAddress)(arg);
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $40cc7b0f15d4be4b$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$40cc7b0f15d4be4b$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $40cc7b0f15d4be4b$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $40cc7b0f15d4be4b$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $gg0RY.isAddress)(args[parameterIndex]);
            if (types.includes("address") && types.includes("bytes")) return (0, $gg0RY.isAddress)(args[parameterIndex]);
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("apDyM", function(module, exports) {

$parcel$export(module.exports, "getEventSelector", () => $794aecf7fe6c199e$export$199f4d2b0dfd4569);

var $ihras = parcelRequire("ihras");

var $ilJ0t = parcelRequire("ilJ0t");

var $9mkfv = parcelRequire("9mkfv");
const $794aecf7fe6c199e$var$hash = (value)=>(0, $9mkfv.keccak256)((0, $ihras.toBytes)(value));
const $794aecf7fe6c199e$export$199f4d2b0dfd4569 = (fn)=>$794aecf7fe6c199e$var$hash((0, $ilJ0t.getEventSignature)(fn));

});
parcelRegister("ilJ0t", function(module, exports) {

$parcel$export(module.exports, "getEventSignature", () => $d5bd1987138a2a20$export$8edf22f667ee2562);

var $gyUwH = parcelRequire("gyUwH");
const $d5bd1987138a2a20$export$8edf22f667ee2562 = (fn)=>{
    return (0, $gyUwH.getFunctionSignature)(fn);
};

});







parcelRegister("bCHCD", function(module, exports) {

$parcel$export(module.exports, "custom", () => $876514bec7982e8d$export$4c00f665f0d4b443);

var $lmHde = parcelRequire("lmHde");
function $876514bec7982e8d$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $lmHde.createTransport)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}

});
parcelRegister("lmHde", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $f8dd2c279b636c76$export$d09f50d9ab7f7b69);

var $k2k77 = parcelRequire("k2k77");
function $f8dd2c279b636c76$export$d09f50d9ab7f7b69({ key: key, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $k2k77.buildRequest)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay
        }),
        value: value
    };
}

});
parcelRegister("k2k77", function(module, exports) {

$parcel$export(module.exports, "isDeterministicError", () => $e96398b8d54c7e9f$export$9c98b0fe9b5c1674);
$parcel$export(module.exports, "buildRequest", () => $e96398b8d54c7e9f$export$6c5295ef7e82f2b2);

var $kpVTR = parcelRequire("kpVTR");

var $klW82 = parcelRequire("klW82");

var $cYDOa = parcelRequire("cYDOa");

var $3RZ58 = parcelRequire("3RZ58");
const $e96398b8d54c7e9f$export$9c98b0fe9b5c1674 = (error)=>{
    if ("code" in error) return error.code !== -1 && error.code !== -32004 && error.code !== -32005 && error.code !== -32042 && error.code !== -32603;
    if (error instanceof (0, $klW82.HttpRequestError) && error.status) return error.status !== 403 && error.status !== 408 && error.status !== 413 && error.status !== 429 && error.status !== 500 && error.status !== 502 && error.status !== 503 && error.status !== 504;
    return false;
};
function $e96398b8d54c7e9f$export$6c5295ef7e82f2b2(request, { retryDelay: retryDelay = 150, retryCount: retryCount = 3 } = {}) {
    return async (args)=>(0, $3RZ58.withRetry)(async ()=>{
            try {
                return await request(args);
            } catch (err_) {
                const err = err_;
                switch(err.code){
                    // -32700
                    case (0, $cYDOa.ParseRpcError).code:
                        throw new (0, $cYDOa.ParseRpcError)(err);
                    // -32600
                    case (0, $cYDOa.InvalidRequestRpcError).code:
                        throw new (0, $cYDOa.InvalidRequestRpcError)(err);
                    // -32601
                    case (0, $cYDOa.MethodNotFoundRpcError).code:
                        throw new (0, $cYDOa.MethodNotFoundRpcError)(err);
                    // -32602
                    case (0, $cYDOa.InvalidParamsRpcError).code:
                        throw new (0, $cYDOa.InvalidParamsRpcError)(err);
                    // -32603
                    case (0, $cYDOa.InternalRpcError).code:
                        throw new (0, $cYDOa.InternalRpcError)(err);
                    // -32000
                    case (0, $cYDOa.InvalidInputRpcError).code:
                        throw new (0, $cYDOa.InvalidInputRpcError)(err);
                    // -32001
                    case (0, $cYDOa.ResourceNotFoundRpcError).code:
                        throw new (0, $cYDOa.ResourceNotFoundRpcError)(err);
                    // -32002
                    case (0, $cYDOa.ResourceUnavailableRpcError).code:
                        throw new (0, $cYDOa.ResourceUnavailableRpcError)(err);
                    // -32003
                    case (0, $cYDOa.TransactionRejectedRpcError).code:
                        throw new (0, $cYDOa.TransactionRejectedRpcError)(err);
                    // -32004
                    case (0, $cYDOa.MethodNotSupportedRpcError).code:
                        throw new (0, $cYDOa.MethodNotSupportedRpcError)(err);
                    // -32005
                    case (0, $cYDOa.LimitExceededRpcError).code:
                        throw new (0, $cYDOa.LimitExceededRpcError)(err);
                    // -32006
                    case (0, $cYDOa.JsonRpcVersionUnsupportedError).code:
                        throw new (0, $cYDOa.JsonRpcVersionUnsupportedError)(err);
                    // 4001
                    case (0, $cYDOa.UserRejectedRequestError).code:
                        throw new (0, $cYDOa.UserRejectedRequestError)(err);
                    // 4100
                    case (0, $cYDOa.UnauthorizedProviderError).code:
                        throw new (0, $cYDOa.UnauthorizedProviderError)(err);
                    // 4200
                    case (0, $cYDOa.UnsupportedProviderMethodError).code:
                        throw new (0, $cYDOa.UnsupportedProviderMethodError)(err);
                    // 4900
                    case (0, $cYDOa.ProviderDisconnectedError).code:
                        throw new (0, $cYDOa.ProviderDisconnectedError)(err);
                    // 4901
                    case (0, $cYDOa.ChainDisconnectedError).code:
                        throw new (0, $cYDOa.ChainDisconnectedError)(err);
                    // 4902
                    case (0, $cYDOa.SwitchChainError).code:
                        throw new (0, $cYDOa.SwitchChainError)(err);
                    // CAIP-25: User Rejected Error
                    // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                    case 5000:
                        throw new (0, $cYDOa.UserRejectedRequestError)(err);
                    default:
                        if (err_ instanceof (0, $kpVTR.BaseError)) throw err_;
                        throw new (0, $cYDOa.UnknownRpcError)(err);
                }
            }
        }, {
            delay: ({ count: count, error: error })=>{
                // If we find a Retry-After header, let's retry after the given time.
                if (error && error instanceof (0, $klW82.HttpRequestError)) {
                    const retryAfter = error?.headers?.get("Retry-After");
                    if (retryAfter?.match(/\d/)) return parseInt(retryAfter) * 1000;
                }
                // Otherwise, let's retry with an exponential backoff.
                return ~~(1 << count) * retryDelay;
            },
            retryCount: retryCount,
            shouldRetry: ({ error: error })=>!$e96398b8d54c7e9f$export$9c98b0fe9b5c1674(error)
        });
}

});
parcelRegister("3RZ58", function(module, exports) {

$parcel$export(module.exports, "withRetry", () => $2d15b3ea2f382acb$export$188df5ecf8e7961a);

var $k1zW2 = parcelRequire("k1zW2");
function $2d15b3ea2f382acb$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $k1zW2.wait)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}

});
parcelRegister("k1zW2", function(module, exports) {

$parcel$export(module.exports, "wait", () => $e93fc69571c7c6e2$export$5c069c93d2b7493f);
async function $e93fc69571c7c6e2$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}

});






parcelRegister("5kw0a", function(module, exports) {

$parcel$export(module.exports, "__privateGet", () => $3e17a4df72dc5da7$export$18a094aefa070634);
$parcel$export(module.exports, "__privateAdd", () => $3e17a4df72dc5da7$export$addf369becd23283);
$parcel$export(module.exports, "__privateSet", () => $3e17a4df72dc5da7$export$42432efe6614d3b4);
$parcel$export(module.exports, "__privateMethod", () => $3e17a4df72dc5da7$export$fa92d15b718fce20);
var $3e17a4df72dc5da7$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $3e17a4df72dc5da7$export$18a094aefa070634 = (obj, member, getter)=>{
    $3e17a4df72dc5da7$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $3e17a4df72dc5da7$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $3e17a4df72dc5da7$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $3e17a4df72dc5da7$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $3e17a4df72dc5da7$export$fa92d15b718fce20 = (obj, member, method)=>{
    $3e17a4df72dc5da7$var$__accessCheck(obj, member, "access private method");
    return method;
};

});

parcelRegister("hdmf8", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", () => $c884e7982b5043cf$export$e67b04e2cd29b7d);
$parcel$export(module.exports, "ContractFunctionExecutionError", () => $c884e7982b5043cf$export$399e62fddbe24423);
$parcel$export(module.exports, "ContractFunctionRevertedError", () => $c884e7982b5043cf$export$b3a6b9663001535f);
$parcel$export(module.exports, "ContractFunctionZeroDataError", () => $c884e7982b5043cf$export$46f5208cdcd5a621);
$parcel$export(module.exports, "RawContractError", () => $c884e7982b5043cf$export$5b877bc4d7d9d460);

var $e4nLA = parcelRequire("e4nLA");

var $1ZzA9 = parcelRequire("1ZzA9");

var $1fvWB = parcelRequire("1fvWB");

var $j8Xjk = parcelRequire("j8Xjk");

var $IYBra = parcelRequire("IYBra");

var $5yVb5 = parcelRequire("5yVb5");

var $3Szoa = parcelRequire("3Szoa");

var $7xokh = parcelRequire("7xokh");

var $329cO = parcelRequire("329cO");

var $kpVTR = parcelRequire("kpVTR");

var $7UNP4 = parcelRequire("7UNP4");

var $gcSc3 = parcelRequire("gcSc3");
class $c884e7982b5043cf$export$e67b04e2cd29b7d extends (0, $kpVTR.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const account = account_ ? (0, $e4nLA.parseAccount)(account_) : undefined;
        const prettyArgs = (0, $7UNP4.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $3Szoa.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7xokh.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7xokh.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CallExecutionError"
        });
        this.cause = cause;
    }
}
class $c884e7982b5043cf$export$399e62fddbe24423 extends (0, $kpVTR.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $5yVb5.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $IYBra.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $j8Xjk.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $7UNP4.prettyPrint)({
            address: contractAddress && (0, $gcSc3.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Contract Call:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionExecutionError"
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $c884e7982b5043cf$export$b3a6b9663001535f extends (0, $kpVTR.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $1fvWB.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $1ZzA9.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $j8Xjk.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $IYBra.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $329cO.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.reason = reason;
        this.signature = signature;
    }
}
class $c884e7982b5043cf$export$46f5208cdcd5a621 extends (0, $kpVTR.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionZeroDataError"
        });
    }
}
class $c884e7982b5043cf$export$5b877bc4d7d9d460 extends (0, $kpVTR.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "");
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RawContractError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("1ZzA9", function(module, exports) {

$parcel$export(module.exports, "panicReasons", () => $173716ce8f12e3b7$export$a618024566d3d221);
$parcel$export(module.exports, "solidityError", () => $173716ce8f12e3b7$export$730e9cc7aaa8ca20);
$parcel$export(module.exports, "solidityPanic", () => $173716ce8f12e3b7$export$e45b3aea1c5b33e6);
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $173716ce8f12e3b7$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $173716ce8f12e3b7$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $173716ce8f12e3b7$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("1fvWB", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", () => $0e8ff8a270ed3a8b$export$8f7898b7bcae6080);

var $1ZzA9 = parcelRequire("1ZzA9");

var $329cO = parcelRequire("329cO");

var $h8fZV = parcelRequire("h8fZV");

var $9dV1M = parcelRequire("9dV1M");

var $kwdse = parcelRequire("kwdse");

var $j8Xjk = parcelRequire("j8Xjk");
function $0e8ff8a270ed3a8b$export$8f7898b7bcae6080({ abi: abi, data: data }) {
    const signature = (0, $h8fZV.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $329cO.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $1ZzA9.solidityError),
        (0, $1ZzA9.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $9dV1M.getFunctionSelector)((0, $j8Xjk.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $329cO.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $kwdse.decodeAbiParameters)(abiItem.inputs, (0, $h8fZV.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("kwdse", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", () => $ef013b8e906c53b1$export$84d51ac2fffabd56);

var $329cO = parcelRequire("329cO");

var $aegFK = parcelRequire("aegFK");

var $7ahE1 = parcelRequire("7ahE1");

var $h8fZV = parcelRequire("h8fZV");

var $f6c2v = parcelRequire("f6c2v");

var $dKCgU = parcelRequire("dKCgU");

var $iSG3s = parcelRequire("iSG3s");
function $ef013b8e906c53b1$export$84d51ac2fffabd56(params, data) {
    if (data === "0x" && params.length > 0) throw new (0, $329cO.AbiDecodingZeroDataError)();
    if ((0, $7ahE1.size)(data) && (0, $7ahE1.size)(data) < 32) throw new (0, $329cO.AbiDecodingDataSizeTooSmallError)({
        data: data,
        params: params,
        size: (0, $7ahE1.size)(data)
    });
    return $ef013b8e906c53b1$var$decodeParams({
        data: data,
        params: params
    });
}
function $ef013b8e906c53b1$var$decodeParams({ data: data, params: params }) {
    const decodedValues = [];
    let position = 0;
    for(let i = 0; i < params.length; i++){
        if (position >= (0, $7ahE1.size)(data)) throw new (0, $329cO.AbiDecodingDataSizeTooSmallError)({
            data: data,
            params: params,
            size: (0, $7ahE1.size)(data)
        });
        const param = params[i];
        const { consumed: consumed, value: value } = $ef013b8e906c53b1$var$decodeParam({
            data: data,
            param: param,
            position: position
        });
        decodedValues.push(value);
        // Step across the data by the amount of data consumed by this parameter.
        position += consumed;
    }
    return decodedValues;
}
function $ef013b8e906c53b1$var$decodeParam({ data: data, param: param, position: position }) {
    const arrayComponents = (0, $iSG3s.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $ef013b8e906c53b1$var$decodeArray(data, {
            length: length,
            param: {
                ...param,
                type: type
            },
            position: position
        });
    }
    if (param.type === "tuple") return $ef013b8e906c53b1$var$decodeTuple(data, {
        param: param,
        position: position
    });
    if (param.type === "string") return $ef013b8e906c53b1$var$decodeString(data, {
        position: position
    });
    if (param.type.startsWith("bytes")) return $ef013b8e906c53b1$var$decodeBytes(data, {
        param: param,
        position: position
    });
    const value = (0, $h8fZV.slice)(data, position, position + 32, {
        strict: true
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $ef013b8e906c53b1$var$decodeNumber(value, {
        param: param
    });
    if (param.type === "address") return $ef013b8e906c53b1$var$decodeAddress(value);
    if (param.type === "bool") return $ef013b8e906c53b1$var$decodeBool(value);
    throw new (0, $329cO.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
function $ef013b8e906c53b1$var$decodeAddress(value) {
    return {
        consumed: 32,
        value: (0, $aegFK.checksumAddress)((0, $h8fZV.slice)(value, -20))
    };
}
function $ef013b8e906c53b1$var$decodeArray(data, { param: param, length: length, position: position }) {
    // If the length of the array is not known in advance (dynamic array),
    // we will need to decode the offset of the array data.
    if (!length) {
        // Get the offset of the array data.
        const offset = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, position, position + 32, {
            strict: true
        }));
        // Get the length of the array from the offset.
        const length = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, offset, offset + 32, {
            strict: true
        }));
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const decodedChild = $ef013b8e906c53b1$var$decodeParam({
                data: (0, $h8fZV.slice)(data, offset + 32),
                param: param,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($ef013b8e906c53b1$var$hasDynamicChild(param)) {
        // Get the child type of the array.
        const arrayComponents = (0, $iSG3s.getArrayComponents)(param.type);
        // If the child type is not known, the array is dynamic.
        const dynamicChild = !arrayComponents?.[0];
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const offset = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, position, position + 32, {
                strict: true
            }));
            const decodedChild = $ef013b8e906c53b1$var$decodeParam({
                data: (0, $h8fZV.slice)(data, offset),
                param: param,
                position: dynamicChild ? consumed : i * 32
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of each element in the array is known,
    // the array data is encoded contiguously after the array.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const decodedChild = $ef013b8e906c53b1$var$decodeParam({
            data: data,
            param: param,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value.push(decodedChild.value);
    }
    return {
        value: value,
        consumed: consumed
    };
}
function $ef013b8e906c53b1$var$decodeBool(value) {
    return {
        consumed: 32,
        value: (0, $dKCgU.hexToBool)(value)
    };
}
function $ef013b8e906c53b1$var$decodeBytes(data, { param: param, position: position }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // If we don't have a size, we're dealing with a dynamic-size array
        // so we need to read the offset of the data part first.
        const offset = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, position, position + 32, {
            strict: true
        }));
        const length = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, offset, offset + 32, {
            strict: true
        }));
        // If there is no length, we have zero data.
        if (length === 0) return {
            consumed: 32,
            value: "0x"
        };
        const value = (0, $h8fZV.slice)(data, offset + 32, offset + 32 + length, {
            strict: true
        });
        return {
            consumed: 32,
            value: value
        };
    }
    const value = (0, $h8fZV.slice)(data, position, position + parseInt(size), {
        strict: true
    });
    return {
        consumed: 32,
        value: value
    };
}
function $ef013b8e906c53b1$var$decodeNumber(value, { param: param }) {
    const signed = param.type.startsWith("int");
    const size = parseInt(param.type.split("int")[1] || "256");
    return {
        consumed: 32,
        value: size > 48 ? (0, $dKCgU.hexToBigInt)(value, {
            signed: signed
        }) : (0, $dKCgU.hexToNumber)(value, {
            signed: signed
        })
    };
}
function $ef013b8e906c53b1$var$decodeString(data, { position: position }) {
    const offset = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, position, position + 32, {
        strict: true
    }));
    const length = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, offset, offset + 32, {
        strict: true
    }));
    // If there is no length, we have zero data (empty string).
    if (length === 0) return {
        consumed: 32,
        value: ""
    };
    const value = (0, $dKCgU.hexToString)((0, $f6c2v.trim)((0, $h8fZV.slice)(data, offset + 32, offset + 32 + length, {
        strict: true
    })));
    return {
        consumed: 32,
        value: value
    };
}
function $ef013b8e906c53b1$var$decodeTuple(data, { param: param, position: position }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($ef013b8e906c53b1$var$hasDynamicChild(param)) {
        const offset = (0, $dKCgU.hexToNumber)((0, $h8fZV.slice)(data, position, position + 32, {
            strict: true
        }));
        // Decode each component of the tuple, starting at the offset.
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            const decodedChild = $ef013b8e906c53b1$var$decodeParam({
                data: (0, $h8fZV.slice)(data, offset),
                param: component,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
        }
        return {
            consumed: 32,
            value: value
        };
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const decodedChild = $ef013b8e906c53b1$var$decodeParam({
            data: data,
            param: component,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
    }
    return {
        consumed: consumed,
        value: value
    };
}
function $ef013b8e906c53b1$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($ef013b8e906c53b1$var$hasDynamicChild);
    const arrayComponents = (0, $iSG3s.getArrayComponents)(param.type);
    if (arrayComponents && $ef013b8e906c53b1$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});


parcelRegister("IYBra", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", () => $08731ea2460ae964$export$5266ec2b0e3e9205);

var $7Vm0z = parcelRequire("7Vm0z");
function $08731ea2460ae964$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $7Vm0z.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});


parcelRegister("8H2x6", function(module, exports) {

$parcel$export(module.exports, "createPublicClient", () => $65444de38d2d27bb$export$d8e090d8c6a7a6ad);

var $dQ6cQ = parcelRequire("dQ6cQ");

var $2FZMW = parcelRequire("2FZMW");
function $65444de38d2d27bb$export$d8e090d8c6a7a6ad(parameters) {
    const { key: key = "public", name: name = "Public Client" } = parameters;
    const client = (0, $dQ6cQ.createClient)({
        ...parameters,
        key: key,
        name: name,
        type: "publicClient"
    });
    return client.extend((0, $2FZMW.publicActions));
}

});
parcelRegister("2FZMW", function(module, exports) {

$parcel$export(module.exports, "publicActions", () => $1f2f56f7e97e06e9$export$8705b583fa097d24);

var $cnWKW = parcelRequire("cnWKW");

var $47tpB = parcelRequire("47tpB");

var $f6NHi = parcelRequire("f6NHi");

var $lHGJd = parcelRequire("lHGJd");

var $3zz6j = parcelRequire("3zz6j");

var $7kwTR = parcelRequire("7kwTR");

var $ggBwj = parcelRequire("ggBwj");

var $gPaZa = parcelRequire("gPaZa");

var $lwFhq = parcelRequire("lwFhq");

var $8OUYh = parcelRequire("8OUYh");

var $1moxn = parcelRequire("1moxn");

var $bQtjF = parcelRequire("bQtjF");

var $hcljR = parcelRequire("hcljR");

var $fOZxW = parcelRequire("fOZxW");

var $48rnw = parcelRequire("48rnw");

var $bOjxt = parcelRequire("bOjxt");

var $4aSYi = parcelRequire("4aSYi");

var $hmZYW = parcelRequire("hmZYW");

var $kCUHm = parcelRequire("kCUHm");

var $63bwO = parcelRequire("63bwO");

var $7IZOR = parcelRequire("7IZOR");

var $lcI4E = parcelRequire("lcI4E");

var $iOXvq = parcelRequire("iOXvq");

var $agrvL = parcelRequire("agrvL");

var $cjAPs = parcelRequire("cjAPs");

var $dtWJl = parcelRequire("dtWJl");

var $iHrXn = parcelRequire("iHrXn");

var $kNbPZ = parcelRequire("kNbPZ");

var $k934X = parcelRequire("k934X");

var $3iOgC = parcelRequire("3iOgC");

var $4SGSr = parcelRequire("4SGSr");

var $6LjrN = parcelRequire("6LjrN");

var $724DE = parcelRequire("724DE");

var $jLRKT = parcelRequire("jLRKT");

var $cQCwv = parcelRequire("cQCwv");

var $hFhHU = parcelRequire("hFhHU");

var $bmpDw = parcelRequire("bmpDw");

var $h3niV = parcelRequire("h3niV");

var $48U1S = parcelRequire("48U1S");

var $gwg6D = parcelRequire("gwg6D");

var $bsB0S = parcelRequire("bsB0S");

var $xTWIh = parcelRequire("xTWIh");

var $8OIXs = parcelRequire("8OIXs");

var $kVywx = parcelRequire("kVywx");

var $e34Sq = parcelRequire("e34Sq");

var $7vFPJ = parcelRequire("7vFPJ");
function $1f2f56f7e97e06e9$export$8705b583fa097d24(client) {
    return {
        call: (args)=>(0, $7kwTR.call)(client, args),
        createBlockFilter: ()=>(0, $ggBwj.createBlockFilter)(client),
        createContractEventFilter: (args)=>(0, $gPaZa.createContractEventFilter)(client, args),
        createEventFilter: (args)=>(0, $lwFhq.createEventFilter)(client, args),
        createPendingTransactionFilter: ()=>(0, $8OUYh.createPendingTransactionFilter)(client),
        estimateContractGas: (args)=>(0, $1moxn.estimateContractGas)(client, args),
        estimateGas: (args)=>(0, $hcljR.estimateGas)(client, args),
        getBalance: (args)=>(0, $48rnw.getBalance)(client, args),
        getBlock: (args)=>(0, $bOjxt.getBlock)(client, args),
        getBlockNumber: (args)=>(0, $4aSYi.getBlockNumber)(client, args),
        getBlockTransactionCount: (args)=>(0, $hmZYW.getBlockTransactionCount)(client, args),
        getBytecode: (args)=>(0, $kCUHm.getBytecode)(client, args),
        getChainId: ()=>(0, $63bwO.getChainId)(client),
        getContractEvents: (args)=>(0, $7IZOR.getContractEvents)(client, args),
        getEnsAddress: (args)=>(0, $cnWKW.getEnsAddress)(client, args),
        getEnsAvatar: (args)=>(0, $47tpB.getEnsAvatar)(client, args),
        getEnsName: (args)=>(0, $f6NHi.getEnsName)(client, args),
        getEnsResolver: (args)=>(0, $lHGJd.getEnsResolver)(client, args),
        getEnsText: (args)=>(0, $3zz6j.getEnsText)(client, args),
        getFeeHistory: (args)=>(0, $lcI4E.getFeeHistory)(client, args),
        estimateFeesPerGas: (args)=>(0, $bQtjF.estimateFeesPerGas)(client, args),
        getFilterChanges: (args)=>(0, $iOXvq.getFilterChanges)(client, args),
        getFilterLogs: (args)=>(0, $agrvL.getFilterLogs)(client, args),
        getGasPrice: ()=>(0, $cjAPs.getGasPrice)(client),
        getLogs: (args)=>(0, $dtWJl.getLogs)(client, args),
        getProof: (args)=>(0, $iHrXn.getProof)(client, args),
        estimateMaxPriorityFeePerGas: (args)=>(0, $fOZxW.estimateMaxPriorityFeePerGas)(client, args),
        getStorageAt: (args)=>(0, $kNbPZ.getStorageAt)(client, args),
        getTransaction: (args)=>(0, $k934X.getTransaction)(client, args),
        getTransactionConfirmations: (args)=>(0, $3iOgC.getTransactionConfirmations)(client, args),
        getTransactionCount: (args)=>(0, $4SGSr.getTransactionCount)(client, args),
        getTransactionReceipt: (args)=>(0, $6LjrN.getTransactionReceipt)(client, args),
        multicall: (args)=>(0, $724DE.multicall)(client, args),
        prepareTransactionRequest: (args)=>(0, $e34Sq.prepareTransactionRequest)(client, args),
        readContract: (args)=>(0, $jLRKT.readContract)(client, args),
        sendRawTransaction: (args)=>(0, $7vFPJ.sendRawTransaction)(client, args),
        simulateContract: (args)=>(0, $cQCwv.simulateContract)(client, args),
        verifyMessage: (args)=>(0, $bmpDw.verifyMessage)(client, args),
        verifyTypedData: (args)=>(0, $h3niV.verifyTypedData)(client, args),
        uninstallFilter: (args)=>(0, $hFhHU.uninstallFilter)(client, args),
        waitForTransactionReceipt: (args)=>(0, $48U1S.waitForTransactionReceipt)(client, args),
        watchBlocks: (args)=>(0, $bsB0S.watchBlocks)(client, args),
        watchBlockNumber: (args)=>(0, $gwg6D.watchBlockNumber)(client, args),
        watchContractEvent: (args)=>(0, $xTWIh.watchContractEvent)(client, args),
        watchEvent: (args)=>(0, $8OIXs.watchEvent)(client, args),
        watchPendingTransactions: (args)=>(0, $kVywx.watchPendingTransactions)(client, args)
    };
}

});
parcelRegister("cnWKW", function(module, exports) {

$parcel$export(module.exports, "getEnsAddress", () => $904535bcc1776ee2$export$24b77c7e87f05b8d);

var $cTGDr = parcelRequire("cTGDr");

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $c7sZv = parcelRequire("c7sZv");

var $f6c2v = parcelRequire("f6c2v");

var $7S6Nv = parcelRequire("7S6Nv");

var $cXQQO = parcelRequire("cXQQO");

var $bAzqD = parcelRequire("bAzqD");

var $i0eNG = parcelRequire("i0eNG");

var $govpX = parcelRequire("govpX");

var $jLRKT = parcelRequire("jLRKT");
async function $904535bcc1776ee2$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $2tMbE.encodeFunctionData)({
            abi: (0, $cTGDr.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $bAzqD.namehash)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $bAzqD.namehash)(name)
                ]
            }
        });
        const res = await (0, $govpX.getAction)(client, (0, $jLRKT.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $cTGDr.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $7S6Nv.toHex)((0, $i0eNG.packetToBytes)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const address = (0, $iA2mF.decodeFunctionResult)({
            abi: (0, $cTGDr.addressResolverAbi),
            args: coinType != null ? [
                (0, $bAzqD.namehash)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $f6c2v.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if ((0, $cXQQO.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});
parcelRegister("cTGDr", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", () => $963bb18e732788f7$export$4e233219477ffb48);
$parcel$export(module.exports, "universalResolverResolveAbi", () => $963bb18e732788f7$export$400f1d40cf4f98fe);
$parcel$export(module.exports, "universalResolverReverseAbi", () => $963bb18e732788f7$export$fd0db820daeebac9);
$parcel$export(module.exports, "textResolverAbi", () => $963bb18e732788f7$export$4e6990b9fd834e88);
$parcel$export(module.exports, "addressResolverAbi", () => $963bb18e732788f7$export$4c61cc2994c5d90b);
$parcel$export(module.exports, "universalSignatureValidatorAbi", () => $963bb18e732788f7$export$b10682c3fa53fbd1);
/* [Multicall3](https://github.com/mds1/multicall) */ const $963bb18e732788f7$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $963bb18e732788f7$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    }
];
const $963bb18e732788f7$export$400f1d40cf4f98fe = [
    ...$963bb18e732788f7$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $963bb18e732788f7$export$fd0db820daeebac9 = [
    ...$963bb18e732788f7$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $963bb18e732788f7$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $963bb18e732788f7$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $963bb18e732788f7$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $963bb18e732788f7$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_signer",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];

});

parcelRegister("iA2mF", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", () => $d86d6c5dbfd0d9d0$export$3a05a90c230f925);

var $329cO = parcelRequire("329cO");

var $kwdse = parcelRequire("kwdse");

var $5yVb5 = parcelRequire("5yVb5");
const $d86d6c5dbfd0d9d0$var$docsPath = "/docs/contract/decodeFunctionResult";
function $d86d6c5dbfd0d9d0$export$3a05a90c230f925({ abi: abi, args: args, functionName: functionName, data: data }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $5yVb5.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $329cO.AbiFunctionNotFoundError)(functionName, {
            docsPath: $d86d6c5dbfd0d9d0$var$docsPath
        });
    }
    if (abiItem.type !== "function") throw new (0, $329cO.AbiFunctionNotFoundError)(undefined, {
        docsPath: $d86d6c5dbfd0d9d0$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $329cO.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $d86d6c5dbfd0d9d0$var$docsPath
    });
    const values = (0, $kwdse.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("c7sZv", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", () => $8d2ca081eea8bc09$export$cf4414608a078996);

var $leMPQ = parcelRequire("leMPQ");
function $8d2ca081eea8bc09$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $leMPQ.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $leMPQ.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("cXQQO", function(module, exports) {

$parcel$export(module.exports, "isNullUniversalResolverError", () => $9703fdc6537e19ba$export$78f90e26b9356cd7);

var $1ZzA9 = parcelRequire("1ZzA9");

var $kpVTR = parcelRequire("kpVTR");

var $hdmf8 = parcelRequire("hdmf8");
function $9703fdc6537e19ba$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $kpVTR.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $hdmf8.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $hdmf8.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $1ZzA9.panicReasons)[50]) return true;
    return false;
}

});

parcelRegister("bAzqD", function(module, exports) {

$parcel$export(module.exports, "namehash", () => $86fe89e8a86527b6$export$91d651ee363e1209);

var $jSK74 = parcelRequire("jSK74");

var $ihras = parcelRequire("ihras");

var $7S6Nv = parcelRequire("7S6Nv");

var $9mkfv = parcelRequire("9mkfv");

var $ldOzq = parcelRequire("ldOzq");
function $86fe89e8a86527b6$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $7S6Nv.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $ldOzq.encodedLabelToLabelhash)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $ihras.toBytes)(hashFromEncodedLabel) : (0, $9mkfv.keccak256)((0, $ihras.stringToBytes)(labels[i]), "bytes");
        result = (0, $9mkfv.keccak256)((0, $jSK74.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $7S6Nv.bytesToHex)(result);
}

});
parcelRegister("ldOzq", function(module, exports) {

$parcel$export(module.exports, "encodedLabelToLabelhash", () => $f7320a173b93c691$export$cbf748cac2e87c52);

var $fmvmO = parcelRequire("fmvmO");
function $f7320a173b93c691$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $fmvmO.isHex)(hash)) return null;
    return hash;
}

});


parcelRegister("i0eNG", function(module, exports) {

$parcel$export(module.exports, "packetToBytes", () => $d1b3b51c4f8795d4$export$8a0899f9ded0844);

var $ihras = parcelRequire("ihras");

var $d1ukf = parcelRequire("d1ukf");

var $31ufG = parcelRequire("31ufG");
function $d1b3b51c4f8795d4$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $ihras.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $ihras.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $ihras.stringToBytes)((0, $d1ukf.encodeLabelhash)((0, $31ufG.labelhash)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}

});
parcelRegister("d1ukf", function(module, exports) {

$parcel$export(module.exports, "encodeLabelhash", () => $97b2e46785bb0c0f$export$c23ac52da6ff5062);
function $97b2e46785bb0c0f$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}

});

parcelRegister("31ufG", function(module, exports) {

$parcel$export(module.exports, "labelhash", () => $2338ee8524c1bd97$export$83615f6c30436a69);

var $ihras = parcelRequire("ihras");

var $7S6Nv = parcelRequire("7S6Nv");

var $9mkfv = parcelRequire("9mkfv");

var $ldOzq = parcelRequire("ldOzq");
function $2338ee8524c1bd97$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $7S6Nv.bytesToHex)(result);
    return (0, $ldOzq.encodedLabelToLabelhash)(label) || (0, $9mkfv.keccak256)((0, $ihras.stringToBytes)(label));
}

});


parcelRegister("jLRKT", function(module, exports) {

$parcel$export(module.exports, "readContract", () => $e64c1acdcdcf1669$export$43af7de392176737);

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $f2DqS = parcelRequire("f2DqS");

var $govpX = parcelRequire("govpX");

var $7kwTR = parcelRequire("7kwTR");
async function $e64c1acdcdcf1669$export$43af7de392176737(client, { abi: abi, address: address, args: args, functionName: functionName, ...callRequest }) {
    const calldata = (0, $2tMbE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $govpX.getAction)(client, (0, $7kwTR.call), "call")({
            data: calldata,
            to: address,
            ...callRequest
        });
        return (0, $iA2mF.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (err) {
        throw (0, $f2DqS.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}

});
parcelRegister("f2DqS", function(module, exports) {

$parcel$export(module.exports, "getContractError", () => $af35a163862ff25d$export$4414444aba6ddd8a);

var $329cO = parcelRequire("329cO");

var $kpVTR = parcelRequire("kpVTR");

var $hdmf8 = parcelRequire("hdmf8");

var $cYDOa = parcelRequire("cYDOa");
const $af35a163862ff25d$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $af35a163862ff25d$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const { code: code, data: data, message: message, shortMessage: shortMessage } = err instanceof (0, $hdmf8.RawContractError) ? err : err instanceof (0, $kpVTR.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const cause = (()=>{
        if (err instanceof (0, $329cO.AbiDecodingZeroDataError)) return new (0, $hdmf8.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $af35a163862ff25d$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $cYDOa.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $hdmf8.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage ?? message
        });
        return err;
    })();
    return new (0, $hdmf8.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}

});

parcelRegister("7kwTR", function(module, exports) {

$parcel$export(module.exports, "call", () => $5563ebe8d144e980$export$848feb93d8f32b9b);

var $e4nLA = parcelRequire("e4nLA");

var $cTGDr = parcelRequire("cTGDr");

var $4SdOl = parcelRequire("4SdOl");

var $kpVTR = parcelRequire("kpVTR");

var $leMPQ = parcelRequire("leMPQ");

var $hdmf8 = parcelRequire("hdmf8");

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $c7sZv = parcelRequire("c7sZv");

var $7S6Nv = parcelRequire("7S6Nv");

var $l0jJK = parcelRequire("l0jJK");

var $2wY7l = parcelRequire("2wY7l");

var $iFIxy = parcelRequire("iFIxy");

var $hKLjS = parcelRequire("hKLjS");

var $fHEfg = parcelRequire("fHEfg");

async function $5563ebe8d144e980$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    const account = account_ ? (0, $e4nLA.parseAccount)(account_) : undefined;
    try {
        (0, $fHEfg.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $iFIxy.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $2wY7l.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        if (batch && $5563ebe8d144e980$var$shouldPerformMulticall({
            request: request
        })) try {
            return await $5563ebe8d144e980$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $leMPQ.ClientChainNotConfiguredError)) && !(err instanceof (0, $leMPQ.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $5563ebe8d144e980$export$6ef1a527f868ca75(err);
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("clEsJ"));
        if (data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        throw (0, $l0jJK.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $5563ebe8d144e980$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $4SdOl.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $5563ebe8d144e980$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $leMPQ.ClientChainNotConfiguredError)();
        multicallAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $hKLjS.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $2tMbE.encodeFunctionData)({
                abi: (0, $cTGDr.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $iA2mF.decodeFunctionResult)({
                abi: (0, $cTGDr.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $hdmf8.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $5563ebe8d144e980$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $kpVTR.BaseError))) return undefined;
    const error = err.walk();
    return typeof error.data === "object" ? error.data.data : error.data;
}

});
parcelRegister("4SdOl", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", () => $38c6eb2531af4046$export$25fd9a7ba13a8409);
const $38c6eb2531af4046$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("l0jJK", function(module, exports) {

$parcel$export(module.exports, "getCallError", () => $f4a8e8613d86e878$export$7a3a4dfb724485e1);

var $hdmf8 = parcelRequire("hdmf8");

var $bI2Lm = parcelRequire("bI2Lm");

var $6sGEt = parcelRequire("6sGEt");
function $f4a8e8613d86e878$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $6sGEt.getNodeError)(err, args);
        if (cause instanceof (0, $bI2Lm.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $hdmf8.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});

parcelRegister("hKLjS", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", () => $cecb7034d0ee2a7e$export$24d3fde68b7c4167);
const $cecb7034d0ee2a7e$var$schedulerCache = /*#__PURE__*/ new Map();
function $cecb7034d0ee2a7e$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.reject?.(err);
            }
        });
    };
    const flush = ()=>$cecb7034d0ee2a7e$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$cecb7034d0ee2a7e$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$cecb7034d0ee2a7e$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const pendingPromise = {};
            const promise = new Promise((resolve, reject)=>{
                pendingPromise.resolve = resolve;
                pendingPromise.reject = reject;
            });
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    pendingPromise: pendingPromise
                });
                return promise;
            }
            setScheduler({
                args: args,
                pendingPromise: pendingPromise
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});

parcelRegister("clEsJ", function(module, exports) {

var $sJXAr = parcelRequire("sJXAr");
module.exports = $sJXAr("5v5VV").then(()=>parcelRequire("4OgzI"));

});
parcelRegister("sJXAr", function(module, exports) {
"use strict";

function $0566445a97bd9200$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("bmjiP")).resolve(id));
}
module.exports = $0566445a97bd9200$var$load;

});





parcelRegister("47tpB", function(module, exports) {

$parcel$export(module.exports, "getEnsAvatar", () => $2ffea17b723bc97f$export$65f1d2b9649a54e5);

var $7REhL = parcelRequire("7REhL");

var $govpX = parcelRequire("govpX");

var $3zz6j = parcelRequire("3zz6j");
async function $2ffea17b723bc97f$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, name: name, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $govpX.getAction)(client, (0, $3zz6j.getEnsText), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress
    });
    if (!record) return null;
    try {
        return await (0, $7REhL.parseAvatarRecord)(client, {
            record: record,
            gatewayUrls: gatewayUrls
        });
    } catch  {
        return null;
    }
}

});
parcelRegister("7REhL", function(module, exports) {

$parcel$export(module.exports, "parseAvatarRecord", () => $5b9cbb7b9f34127e$export$3713446b2fba5);

var $4shjC = parcelRequire("4shjC");
async function $5b9cbb7b9f34127e$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $5b9cbb7b9f34127e$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $4shjC.parseAvatarUri)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $5b9cbb7b9f34127e$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $4shjC.parseNftUri)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $4shjC.getNftTokenUri)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $4shjC.resolveAvatarUri)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $4shjC.parseAvatarUri)({
            uri: (0, $4shjC.getJsonImage)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $4shjC.getMetadataAvatarUri)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}

});
parcelRegister("4shjC", function(module, exports) {

$parcel$export(module.exports, "resolveAvatarUri", () => $33e735739681ec24$export$9c878106a0d8edac);
$parcel$export(module.exports, "getJsonImage", () => $33e735739681ec24$export$9be3fe34a3333ecb);
$parcel$export(module.exports, "getMetadataAvatarUri", () => $33e735739681ec24$export$b9759ed161b5e3c5);
$parcel$export(module.exports, "parseAvatarUri", () => $33e735739681ec24$export$1f4e569649d3a793);
$parcel$export(module.exports, "parseNftUri", () => $33e735739681ec24$export$e78cf22c9d52ca8a);
$parcel$export(module.exports, "getNftTokenUri", () => $33e735739681ec24$export$29b8ee2b96a1ed4f);

var $jLRKT = parcelRequire("jLRKT");

var $jp5wt = parcelRequire("jp5wt");
const $33e735739681ec24$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $33e735739681ec24$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $33e735739681ec24$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $33e735739681ec24$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $33e735739681ec24$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $33e735739681ec24$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $33e735739681ec24$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $33e735739681ec24$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $33e735739681ec24$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $33e735739681ec24$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($33e735739681ec24$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $33e735739681ec24$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($33e735739681ec24$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $jp5wt.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $33e735739681ec24$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $jp5wt.EnsAvatarInvalidMetadataError)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $33e735739681ec24$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $33e735739681ec24$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $33e735739681ec24$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $jp5wt.EnsAvatarUriResolutionError)({
            uri: uri
        });
    }
}
async function $33e735739681ec24$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $33e735739681ec24$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $33e735739681ec24$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $jp5wt.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $33e735739681ec24$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $jp5wt.EnsAvatarInvalidNftUriError)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $jp5wt.EnsAvatarInvalidNftUriError)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $jp5wt.EnsAvatarInvalidNftUriError)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $jp5wt.EnsAvatarInvalidNftUriError)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $jp5wt.EnsAvatarInvalidNftUriError)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $33e735739681ec24$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $jLRKT.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $jLRKT.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $jp5wt.EnsAvatarUnsupportedNamespaceError)({
        namespace: nft.namespace
    });
}

});
parcelRegister("jp5wt", function(module, exports) {

$parcel$export(module.exports, "EnsAvatarInvalidMetadataError", () => $e204a2d37a3be196$export$3d9377558041f9cf);
$parcel$export(module.exports, "EnsAvatarInvalidNftUriError", () => $e204a2d37a3be196$export$74a8ea52cecec305);
$parcel$export(module.exports, "EnsAvatarUriResolutionError", () => $e204a2d37a3be196$export$f202ff3d50da14eb);
$parcel$export(module.exports, "EnsAvatarUnsupportedNamespaceError", () => $e204a2d37a3be196$export$45137f20297c5e74);

var $kpVTR = parcelRequire("kpVTR");
class $e204a2d37a3be196$export$3d9377558041f9cf extends (0, $kpVTR.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $e204a2d37a3be196$export$74a8ea52cecec305 extends (0, $kpVTR.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $e204a2d37a3be196$export$f202ff3d50da14eb extends (0, $kpVTR.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUriResolutionError"
        });
    }
}
class $e204a2d37a3be196$export$45137f20297c5e74 extends (0, $kpVTR.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}

});



parcelRegister("3zz6j", function(module, exports) {

$parcel$export(module.exports, "getEnsText", () => $299fde44a919857b$export$2b2c96dabd62b431);

var $cTGDr = parcelRequire("cTGDr");

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $c7sZv = parcelRequire("c7sZv");

var $7S6Nv = parcelRequire("7S6Nv");

var $cXQQO = parcelRequire("cXQQO");

var $bAzqD = parcelRequire("bAzqD");

var $i0eNG = parcelRequire("i0eNG");

var $govpX = parcelRequire("govpX");

var $jLRKT = parcelRequire("jLRKT");
async function $299fde44a919857b$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const res = await (0, $govpX.getAction)(client, (0, $jLRKT.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $cTGDr.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $7S6Nv.toHex)((0, $i0eNG.packetToBytes)(name)),
                (0, $2tMbE.encodeFunctionData)({
                    abi: (0, $cTGDr.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $bAzqD.namehash)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const record = (0, $iA2mF.decodeFunctionResult)({
            abi: (0, $cTGDr.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if ((0, $cXQQO.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});


parcelRegister("f6NHi", function(module, exports) {

$parcel$export(module.exports, "getEnsName", () => $affdf769443e0709$export$e1b98d9bc05a9fc2);

var $cTGDr = parcelRequire("cTGDr");

var $c7sZv = parcelRequire("c7sZv");

var $7S6Nv = parcelRequire("7S6Nv");

var $cXQQO = parcelRequire("cXQQO");

var $i0eNG = parcelRequire("i0eNG");

var $govpX = parcelRequire("govpX");

var $jLRKT = parcelRequire("jLRKT");
async function $affdf769443e0709$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const [name, resolvedAddress] = await (0, $govpX.getAction)(client, (0, $jLRKT.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $cTGDr.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $7S6Nv.toHex)((0, $i0eNG.packetToBytes)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if ((0, $cXQQO.isNullUniversalResolverError)(err, "reverse")) return null;
        throw err;
    }
}

});

parcelRegister("lHGJd", function(module, exports) {

$parcel$export(module.exports, "getEnsResolver", () => $fccec2192835f89b$export$ba1240cd558e6b31);

var $c7sZv = parcelRequire("c7sZv");

var $7S6Nv = parcelRequire("7S6Nv");

var $i0eNG = parcelRequire("i0eNG");

var $govpX = parcelRequire("govpX");

var $jLRKT = parcelRequire("jLRKT");
async function $fccec2192835f89b$export$ba1240cd558e6b31(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const [resolverAddress] = await (0, $govpX.getAction)(client, (0, $jLRKT.readContract), "readContract")({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [
                    {
                        type: "bytes"
                    }
                ],
                name: "findResolver",
                outputs: [
                    {
                        type: "address"
                    },
                    {
                        type: "bytes32"
                    }
                ],
                stateMutability: "view",
                type: "function"
            }
        ],
        functionName: "findResolver",
        args: [
            (0, $7S6Nv.toHex)((0, $i0eNG.packetToBytes)(name))
        ],
        blockNumber: blockNumber,
        blockTag: blockTag
    });
    return resolverAddress;
}

});

parcelRegister("ggBwj", function(module, exports) {

$parcel$export(module.exports, "createBlockFilter", () => $bd7b3eb42f1c07fd$export$651edd5ecf84bf98);

var $3UxAW = parcelRequire("3UxAW");
async function $bd7b3eb42f1c07fd$export$651edd5ecf84bf98(client) {
    const getRequest = (0, $3UxAW.createFilterRequestScope)(client, {
        method: "eth_newBlockFilter"
    });
    const id = await client.request({
        method: "eth_newBlockFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "block"
    };
}

});
parcelRegister("3UxAW", function(module, exports) {

$parcel$export(module.exports, "createFilterRequestScope", () => $2d90a948cdcc488b$export$b7aadf80a875f555);
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $2d90a948cdcc488b$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}

});


parcelRegister("gPaZa", function(module, exports) {

$parcel$export(module.exports, "createContractEventFilter", () => $c3f9ee49115b9b15$export$36f99fdb90149e8b);

var $kC6lG = parcelRequire("kC6lG");

var $7S6Nv = parcelRequire("7S6Nv");

var $3UxAW = parcelRequire("3UxAW");
async function $c3f9ee49115b9b15$export$36f99fdb90149e8b(client, { address: address, abi: abi, args: args, eventName: eventName, fromBlock: fromBlock, strict: strict, toBlock: toBlock }) {
    const getRequest = (0, $3UxAW.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    const topics = eventName ? (0, $kC6lG.encodeEventTopics)({
        abi: abi,
        args: args,
        eventName: eventName
    }) : undefined;
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $7S6Nv.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $7S6Nv.numberToHex)(toBlock) : toBlock,
                topics: topics
            }
        ]
    });
    return {
        abi: abi,
        args: args,
        eventName: eventName,
        id: id,
        request: getRequest(id),
        strict: strict,
        type: "event"
    };
}

});
parcelRegister("kC6lG", function(module, exports) {

$parcel$export(module.exports, "encodeEventTopics", () => $f01c47fea6184dbf$export$64e9f7ca5ce29acd);

var $329cO = parcelRequire("329cO");

var $1zhso = parcelRequire("1zhso");

var $ihras = parcelRequire("ihras");

var $apDyM = parcelRequire("apDyM");

var $9mkfv = parcelRequire("9mkfv");

var $iSG3s = parcelRequire("iSG3s");

var $j8Xjk = parcelRequire("j8Xjk");

var $5yVb5 = parcelRequire("5yVb5");
function $f01c47fea6184dbf$export$64e9f7ca5ce29acd({ abi: abi, eventName: eventName, args: args }) {
    let abiItem = abi[0];
    if (eventName) {
        abiItem = (0, $5yVb5.getAbiItem)({
            abi: abi,
            args: args,
            name: eventName
        });
        if (!abiItem) throw new (0, $329cO.AbiEventNotFoundError)(eventName, {
            docsPath: "/docs/contract/encodeEventTopics"
        });
    }
    if (abiItem.type !== "event") throw new (0, $329cO.AbiEventNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeEventTopics"
    });
    const definition = (0, $j8Xjk.formatAbiItem)(abiItem);
    const signature = (0, $apDyM.getEventSelector)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>Array.isArray(args_[i]) ? args_[i].map((_, j)=>$f01c47fea6184dbf$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                })) : args_[i] ? $f01c47fea6184dbf$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $f01c47fea6184dbf$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $9mkfv.keccak256)((0, $ihras.toBytes)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $1zhso.FilterTypeNotSupportedError)(param.type);
    return (0, $iSG3s.encodeAbiParameters)([
        param
    ], [
        value
    ]);
}

});
parcelRegister("1zhso", function(module, exports) {

$parcel$export(module.exports, "FilterTypeNotSupportedError", () => $124699ee1762dd53$export$f71f080d25382681);

var $kpVTR = parcelRequire("kpVTR");
class $124699ee1762dd53$export$f71f080d25382681 extends (0, $kpVTR.BaseError) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FilterTypeNotSupportedError"
        });
    }
}

});



parcelRegister("lwFhq", function(module, exports) {

$parcel$export(module.exports, "createEventFilter", () => $fabc9b842e169f46$export$977ab14bbccde633);

var $kC6lG = parcelRequire("kC6lG");

var $7S6Nv = parcelRequire("7S6Nv");

var $3UxAW = parcelRequire("3UxAW");
async function $fabc9b842e169f46$export$977ab14bbccde633(client, { address: address, args: args, event: event, events: events_, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = {}) {
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    const getRequest = (0, $3UxAW.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $kC6lG.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $7S6Nv.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $7S6Nv.numberToHex)(toBlock) : toBlock,
                ...topics.length ? {
                    topics: topics
                } : {}
            }
        ]
    });
    return {
        abi: events,
        args: args,
        eventName: event ? event.name : undefined,
        fromBlock: fromBlock,
        id: id,
        request: getRequest(id),
        strict: strict,
        toBlock: toBlock,
        type: "event"
    };
}

});

parcelRegister("8OUYh", function(module, exports) {

$parcel$export(module.exports, "createPendingTransactionFilter", () => $66bf2f8d6f9cb998$export$d455ed04c3e85241);

var $3UxAW = parcelRequire("3UxAW");
async function $66bf2f8d6f9cb998$export$d455ed04c3e85241(client) {
    const getRequest = (0, $3UxAW.createFilterRequestScope)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}

});

parcelRegister("1moxn", function(module, exports) {

$parcel$export(module.exports, "estimateContractGas", () => $0fdae122062f69e8$export$7b896b3a3695de87);

var $e4nLA = parcelRequire("e4nLA");

var $2tMbE = parcelRequire("2tMbE");

var $f2DqS = parcelRequire("f2DqS");

var $govpX = parcelRequire("govpX");

var $hcljR = parcelRequire("hcljR");
async function $0fdae122062f69e8$export$7b896b3a3695de87(client, { abi: abi, address: address, args: args, functionName: functionName, ...request }) {
    const data = (0, $2tMbE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const gas = await (0, $govpX.getAction)(client, (0, $hcljR.estimateGas), "estimateGas")({
            data: data,
            to: address,
            ...request
        });
        return gas;
    } catch (err) {
        const account = request.account ? (0, $e4nLA.parseAccount)(request.account) : undefined;
        throw (0, $f2DqS.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/estimateContractGas",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("48rnw", function(module, exports) {

$parcel$export(module.exports, "getBalance", () => $302d2593e5c2d6d0$export$df96cd8d56be0ab1);

var $7S6Nv = parcelRequire("7S6Nv");
async function $302d2593e5c2d6d0$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}

});

parcelRegister("4aSYi", function(module, exports) {

$parcel$export(module.exports, "getBlockNumber", () => $30a2bcd15cf8519c$export$9328b5c92c53a20e);

var $iCC0K = parcelRequire("iCC0K");
const $30a2bcd15cf8519c$var$cacheKey = (id)=>`blockNumber.${id}`;
function $30a2bcd15cf8519c$export$bc78c57a2d1b4a2b(id) {
    return (0, $iCC0K.getCache)($30a2bcd15cf8519c$var$cacheKey(id));
}
async function $30a2bcd15cf8519c$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime, maxAge: maxAge } = {}) {
    const blockNumberHex = await (0, $iCC0K.withCache)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $30a2bcd15cf8519c$var$cacheKey(client.uid),
        cacheTime: maxAge ?? cacheTime
    });
    return BigInt(blockNumberHex);
}

});
parcelRegister("iCC0K", function(module, exports) {

$parcel$export(module.exports, "getCache", () => $d8e942d199d21a3b$export$e2575ed62a2f107b);
$parcel$export(module.exports, "withCache", () => $d8e942d199d21a3b$export$33b32b3abf8170f0);
const $d8e942d199d21a3b$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $d8e942d199d21a3b$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $d8e942d199d21a3b$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $d8e942d199d21a3b$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $d8e942d199d21a3b$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $d8e942d199d21a3b$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Infinity }) {
    const cache = $d8e942d199d21a3b$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}

});


parcelRegister("hmZYW", function(module, exports) {

$parcel$export(module.exports, "getBlockTransactionCount", () => $ca54920c5ca74645$export$8c2de5be7f4dfc0);

var $dKCgU = parcelRequire("dKCgU");

var $7S6Nv = parcelRequire("7S6Nv");
async function $ca54920c5ca74645$export$8c2de5be7f4dfc0(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = "latest" } = {}) {
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    let count;
    if (blockHash) count = await client.request({
        method: "eth_getBlockTransactionCountByHash",
        params: [
            blockHash
        ]
    });
    else count = await client.request({
        method: "eth_getBlockTransactionCountByNumber",
        params: [
            blockNumberHex || blockTag
        ]
    });
    return (0, $dKCgU.hexToNumber)(count);
}

});

parcelRegister("kCUHm", function(module, exports) {

$parcel$export(module.exports, "getBytecode", () => $f043566523238c97$export$81e5c8d8c8aa6ce1);

var $7S6Nv = parcelRequire("7S6Nv");
async function $f043566523238c97$export$81e5c8d8c8aa6ce1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const hex = await client.request({
        method: "eth_getCode",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    if (hex === "0x") return undefined;
    return hex;
}

});

parcelRegister("7IZOR", function(module, exports) {

$parcel$export(module.exports, "getContractEvents", () => $59fc9881973d4b0d$export$1e175955db02d8d);

var $5yVb5 = parcelRequire("5yVb5");

var $govpX = parcelRequire("govpX");

var $dtWJl = parcelRequire("dtWJl");
async function $59fc9881973d4b0d$export$1e175955db02d8d(client, { abi: abi, address: address, args: args, blockHash: blockHash, eventName: eventName, fromBlock: fromBlock, toBlock: toBlock, strict: strict }) {
    const event = eventName ? (0, $5yVb5.getAbiItem)({
        abi: abi,
        name: eventName
    }) : undefined;
    const events = !event ? abi.filter((x)=>x.type === "event") : undefined;
    return (0, $govpX.getAction)(client, (0, $dtWJl.getLogs), "getLogs")({
        address: address,
        args: args,
        blockHash: blockHash,
        event: event,
        events: events,
        fromBlock: fromBlock,
        toBlock: toBlock,
        strict: strict
    });
}

});
parcelRegister("dtWJl", function(module, exports) {

$parcel$export(module.exports, "getLogs", () => $9d0b8a725e62fd99$export$cb5260c832aab30a);

var $329cO = parcelRequire("329cO");

var $349Qk = parcelRequire("349Qk");

var $kC6lG = parcelRequire("kC6lG");

var $7S6Nv = parcelRequire("7S6Nv");

var $2BPth = parcelRequire("2BPth");
async function $9d0b8a725e62fd99$export$cb5260c832aab30a(client, { address: address, blockHash: blockHash, fromBlock: fromBlock, toBlock: toBlock, event: event, events: events_, args: args, strict: strict_ } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $kC6lG.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    let logs;
    if (blockHash) logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                blockHash: blockHash
            }
        ]
    });
    else logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                fromBlock: typeof fromBlock === "bigint" ? (0, $7S6Nv.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $7S6Nv.numberToHex)(toBlock) : toBlock
            }
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = events ? (0, $349Qk.decodeEventLog)({
                abi: events,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2BPth.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $329cO.DecodeLogDataMismatch) || err instanceof (0, $329cO.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2BPth.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});
parcelRegister("349Qk", function(module, exports) {

$parcel$export(module.exports, "decodeEventLog", () => $23b9616daa4de933$export$ec0597e81db3d947);

var $329cO = parcelRequire("329cO");

var $apDyM = parcelRequire("apDyM");

var $kwdse = parcelRequire("kwdse");

var $j8Xjk = parcelRequire("j8Xjk");
const $23b9616daa4de933$var$docsPath = "/docs/contract/decodeEventLog";
function $23b9616daa4de933$export$ec0597e81db3d947({ abi: abi, data: data, strict: strict_, topics: topics }) {
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $329cO.AbiEventSignatureEmptyTopicsError)({
        docsPath: $23b9616daa4de933$var$docsPath
    });
    const abiItem = abi.find((x)=>x.type === "event" && signature === (0, $apDyM.getEventSelector)((0, $j8Xjk.formatAbiItem)(x)));
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $329cO.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $23b9616daa4de933$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $329cO.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[param.name || i] = $23b9616daa4de933$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $kwdse.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $329cO.AbiDecodingDataSizeTooSmallError)) throw new (0, $329cO.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: err.data,
                    params: err.params,
                    size: err.size
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $329cO.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $23b9616daa4de933$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $kwdse.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}

});

parcelRegister("2BPth", function(module, exports) {

$parcel$export(module.exports, "formatLog", () => $1e66f691b295f267$export$fccdbdc2b9d7893);
function $1e66f691b295f267$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}

});



parcelRegister("lcI4E", function(module, exports) {

$parcel$export(module.exports, "getFeeHistory", () => $f6fce820b8f7c849$export$66598bc0c00a958e);

var $7S6Nv = parcelRequire("7S6Nv");

var $3IcY7 = parcelRequire("3IcY7");
async function $f6fce820b8f7c849$export$66598bc0c00a958e(client, { blockCount: blockCount, blockNumber: blockNumber, blockTag: blockTag = "latest", rewardPercentiles: rewardPercentiles }) {
    const blockNumberHex = blockNumber ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: "eth_feeHistory",
        params: [
            (0, $7S6Nv.numberToHex)(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles
        ]
    });
    return (0, $3IcY7.formatFeeHistory)(feeHistory);
}

});
parcelRegister("3IcY7", function(module, exports) {

$parcel$export(module.exports, "formatFeeHistory", () => $2b3f8a78641807aa$export$6c26435bc7761d23);
function $2b3f8a78641807aa$export$6c26435bc7761d23(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value)=>BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward)=>reward.map((value)=>BigInt(value)))
    };
}

});


parcelRegister("iOXvq", function(module, exports) {

$parcel$export(module.exports, "getFilterChanges", () => $db3b0e22d698a849$export$e69fa84ce52a94fd);

var $329cO = parcelRequire("329cO");

var $349Qk = parcelRequire("349Qk");

var $2BPth = parcelRequire("2BPth");
async function $db3b0e22d698a849$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        if (typeof log === "string") return log;
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $349Qk.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2BPth.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $329cO.DecodeLogDataMismatch) || err instanceof (0, $329cO.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args undefined if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2BPth.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("agrvL", function(module, exports) {

$parcel$export(module.exports, "getFilterLogs", () => $7790bd30ce140148$export$776d3b8c33a8b58);

var $329cO = parcelRequire("329cO");

var $349Qk = parcelRequire("349Qk");

var $2BPth = parcelRequire("2BPth");
async function $7790bd30ce140148$export$776d3b8c33a8b58(_client, { filter: filter }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: "eth_getFilterLogs",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $349Qk.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2BPth.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $329cO.DecodeLogDataMismatch) || err instanceof (0, $329cO.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2BPth.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("iHrXn", function(module, exports) {

$parcel$export(module.exports, "getProof", () => $d9d1edc4a958e0bb$export$4a314c097411dc17);

var $7S6Nv = parcelRequire("7S6Nv");

var $dfkL5 = parcelRequire("dfkL5");
async function $d9d1edc4a958e0bb$export$4a314c097411dc17(client, { address: address, blockNumber: blockNumber, blockTag: blockTag_, storageKeys: storageKeys }) {
    const blockTag = blockTag_ ?? "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const proof = await client.request({
        method: "eth_getProof",
        params: [
            address,
            storageKeys,
            blockNumberHex || blockTag
        ]
    });
    return (0, $dfkL5.formatProof)(proof);
}

});
parcelRegister("dfkL5", function(module, exports) {

$parcel$export(module.exports, "formatProof", () => $9a4cc745e5615d56$export$f37c234f0c7125e3);

var $dKCgU = parcelRequire("dKCgU");
function $9a4cc745e5615d56$var$formatStorageProof(storageProof) {
    return storageProof.map((proof)=>({
            ...proof,
            value: BigInt(proof.value)
        }));
}
function $9a4cc745e5615d56$export$f37c234f0c7125e3(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $dKCgU.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $9a4cc745e5615d56$var$formatStorageProof(proof.storageProof) : undefined
    };
}

});


parcelRegister("kNbPZ", function(module, exports) {

$parcel$export(module.exports, "getStorageAt", () => $f23190f3f5553cd9$export$14e244c1a3c8527e);

var $7S6Nv = parcelRequire("7S6Nv");
async function $f23190f3f5553cd9$export$14e244c1a3c8527e(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest", slot: slot }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    const data = await client.request({
        method: "eth_getStorageAt",
        params: [
            address,
            slot,
            blockNumberHex || blockTag
        ]
    });
    return data;
}

});

parcelRegister("k934X", function(module, exports) {

$parcel$export(module.exports, "getTransaction", () => $eaa70957969698c5$export$ec0c6556a09b65b8);

var $7UNP4 = parcelRequire("7UNP4");

var $7S6Nv = parcelRequire("7S6Nv");

var $icori = parcelRequire("icori");
async function $eaa70957969698c5$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $7S6Nv.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $7S6Nv.numberToHex)(index)
        ]
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $7S6Nv.numberToHex)(index)
        ]
    });
    if (!transaction) throw new (0, $7UNP4.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $icori.formatTransaction);
    return format(transaction);
}

});

parcelRegister("3iOgC", function(module, exports) {

$parcel$export(module.exports, "getTransactionConfirmations", () => $267a0b89302b446e$export$e2ccc904d713b66d);

var $govpX = parcelRequire("govpX");

var $4aSYi = parcelRequire("4aSYi");

var $k934X = parcelRequire("k934X");
async function $267a0b89302b446e$export$e2ccc904d713b66d(client, { hash: hash, transactionReceipt: transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        (0, $govpX.getAction)(client, (0, $4aSYi.getBlockNumber), "getBlockNumber")({}),
        hash ? (0, $govpX.getAction)(client, (0, $k934X.getTransaction), "getBlockNumber")({
            hash: hash
        }) : undefined
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}

});

parcelRegister("6LjrN", function(module, exports) {

$parcel$export(module.exports, "getTransactionReceipt", () => $4ec637ae745d54eb$export$6b1ceb3cd5f8b21f);

var $7UNP4 = parcelRequire("7UNP4");

var $8tYxy = parcelRequire("8tYxy");
async function $4ec637ae745d54eb$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    });
    if (!receipt) throw new (0, $7UNP4.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $8tYxy.formatTransactionReceipt);
    return format(receipt);
}

});
parcelRegister("8tYxy", function(module, exports) {

$parcel$export(module.exports, "formatTransactionReceipt", () => $62cffe301ffb8e08$export$30da670e49d6fc31);
$parcel$export(module.exports, "defineTransactionReceipt", () => $62cffe301ffb8e08$export$8d3f90420000ba71);

var $dKCgU = parcelRequire("dKCgU");

var $ab6Pi = parcelRequire("ab6Pi");

var $2BPth = parcelRequire("2BPth");

var $icori = parcelRequire("icori");
const $62cffe301ffb8e08$var$statuses = {
    "0x0": "reverted",
    "0x1": "success"
};
function $62cffe301ffb8e08$export$30da670e49d6fc31(transactionReceipt) {
    return {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $2BPth.formatLog)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $dKCgU.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $62cffe301ffb8e08$var$statuses[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $icori.transactionType)[transactionReceipt.type] || transactionReceipt.type : null
    };
}
const $62cffe301ffb8e08$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $ab6Pi.defineFormatter)("transactionReceipt", $62cffe301ffb8e08$export$30da670e49d6fc31);

});


parcelRegister("724DE", function(module, exports) {

$parcel$export(module.exports, "multicall", () => $51ec516fb48ab681$export$60ef70589ee4f7ad);

var $cTGDr = parcelRequire("cTGDr");

var $329cO = parcelRequire("329cO");

var $kpVTR = parcelRequire("kpVTR");

var $hdmf8 = parcelRequire("hdmf8");

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $c7sZv = parcelRequire("c7sZv");

var $f2DqS = parcelRequire("f2DqS");

var $govpX = parcelRequire("govpX");

var $jLRKT = parcelRequire("jLRKT");
async function $51ec516fb48ab681$export$60ef70589ee4f7ad(client, args) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, contracts: contracts, multicallAddress: multicallAddress_ } = args;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $c7sZv.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $2tMbE.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $f2DqS.getContractError)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $govpX.getAction)(client, (0, $jLRKT.readContract), "readContract")({
            abi: (0, $cTGDr.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3"
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $329cO.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $hdmf8.RawContractError)({
                    data: returnData
                });
                const result = (0, $iA2mF.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $f2DqS.getContractError)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $kpVTR.BaseError)("multicall results mismatch");
    return results;
}

});

parcelRegister("cQCwv", function(module, exports) {

$parcel$export(module.exports, "simulateContract", () => $95a8394eb3f0ca53$export$e8798d551e27a374);

var $e4nLA = parcelRequire("e4nLA");

var $iA2mF = parcelRequire("iA2mF");

var $2tMbE = parcelRequire("2tMbE");

var $f2DqS = parcelRequire("f2DqS");

var $govpX = parcelRequire("govpX");

var $7kwTR = parcelRequire("7kwTR");
async function $95a8394eb3f0ca53$export$e8798d551e27a374(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest }) {
    const account = callRequest.account ? (0, $e4nLA.parseAccount)(callRequest.account) : undefined;
    const calldata = (0, $2tMbE.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $govpX.getAction)(client, (0, $7kwTR.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest
        });
        const result = (0, $iA2mF.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        return {
            result: result,
            request: {
                abi: abi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest
            }
        };
    } catch (err) {
        throw (0, $f2DqS.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("hFhHU", function(module, exports) {

$parcel$export(module.exports, "uninstallFilter", () => $cdc40043c74488be$export$54eb7d691768f7f3);
/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types.html#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter.html
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter.html)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter.html)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter.html)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $cdc40043c74488be$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}

});

parcelRegister("bmpDw", function(module, exports) {

$parcel$export(module.exports, "verifyMessage", () => $8455a2a5512eeb13$export$228d0e772cc158cb);

var $hJsPq = parcelRequire("hJsPq");

var $iZ5id = parcelRequire("iZ5id");
async function $8455a2a5512eeb13$export$228d0e772cc158cb(client, { address: address, message: message, signature: signature, ...callRequest }) {
    const hash = (0, $hJsPq.hashMessage)(message);
    return (0, $iZ5id.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});
parcelRegister("hJsPq", function(module, exports) {

$parcel$export(module.exports, "hashMessage", () => $ce8d005d0e4b4d46$export$d4c241cec96564c1);

var $3pEkg = parcelRequire("3pEkg");

var $jSK74 = parcelRequire("jSK74");

var $ihras = parcelRequire("ihras");

var $9mkfv = parcelRequire("9mkfv");
function $ce8d005d0e4b4d46$export$d4c241cec96564c1(message, to_) {
    const messageBytes = (()=>{
        if (typeof message === "string") return (0, $ihras.stringToBytes)(message);
        if (message.raw instanceof Uint8Array) return message.raw;
        return (0, $ihras.toBytes)(message.raw);
    })();
    const prefixBytes = (0, $ihras.stringToBytes)(`${(0, $3pEkg.presignMessagePrefix)}${messageBytes.length}`);
    return (0, $9mkfv.keccak256)((0, $jSK74.concat)([
        prefixBytes,
        messageBytes
    ]), to_);
}

});
parcelRegister("3pEkg", function(module, exports) {

$parcel$export(module.exports, "presignMessagePrefix", () => $27c2fcc7b4483261$export$39d5d904b514ff63);
const $27c2fcc7b4483261$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";

});


parcelRegister("iZ5id", function(module, exports) {

$parcel$export(module.exports, "verifyHash", () => $dd2207890f03cae5$export$434ee6408013d7f2);

var $cTGDr = parcelRequire("cTGDr");

var $gK7j2 = parcelRequire("gK7j2");

var $hdmf8 = parcelRequire("hdmf8");

var $fvS1Y = parcelRequire("fvS1Y");

var $govpX = parcelRequire("govpX");

var $8OFop = parcelRequire("8OFop");
var $fmvmO = parcelRequire("fmvmO");
var $7S6Nv = parcelRequire("7S6Nv");

var $7kwTR = parcelRequire("7kwTR");
async function $dd2207890f03cae5$export$434ee6408013d7f2(client, { address: address, hash: hash, signature: signature, ...callRequest }) {
    const signatureHex = (0, $fmvmO.isHex)(signature) ? signature : (0, $7S6Nv.toHex)(signature);
    try {
        const { data: data } = await (0, $govpX.getAction)(client, (0, $7kwTR.call), "call")({
            data: (0, $8OFop.encodeDeployData)({
                abi: (0, $cTGDr.universalSignatureValidatorAbi),
                args: [
                    address,
                    hash,
                    signatureHex
                ],
                bytecode: (0, $gK7j2.universalSignatureValidatorByteCode)
            }),
            ...callRequest
        });
        return (0, $fvS1Y.isBytesEqual)(data ?? "0x0", "0x1");
    } catch (error) {
        if (error instanceof (0, $hdmf8.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
        // this can happen for many reasons, for example if signer can not be recovered from the signature
        // or if the signature has no valid format
        return false;
        throw error;
    }
}

});
parcelRegister("gK7j2", function(module, exports) {

$parcel$export(module.exports, "universalSignatureValidatorByteCode", () => $c3069c0a017131e6$export$76c7202cd92b9dbb);
const $c3069c0a017131e6$export$76c7202cd92b9dbb = "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";

});

parcelRegister("fvS1Y", function(module, exports) {

$parcel$export(module.exports, "isBytesEqual", () => $b4b3a9a5589da807$export$88282e62826c5bec);

var $hEqBT = parcelRequire("hEqBT");

var $ihras = parcelRequire("ihras");

var $fmvmO = parcelRequire("fmvmO");
function $b4b3a9a5589da807$export$88282e62826c5bec(a_, b_) {
    const a = (0, $fmvmO.isHex)(a_) ? (0, $ihras.toBytes)(a_) : a_;
    const b = (0, $fmvmO.isHex)(b_) ? (0, $ihras.toBytes)(b_) : b_;
    return (0, $hEqBT.equalBytes)(a, b);
}

});
parcelRegister("hEqBT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $cd9ad04d0320990f$var$_0n = BigInt(0);
const $cd9ad04d0320990f$var$_1n = BigInt(1);
const $cd9ad04d0320990f$var$_2n = BigInt(2);
const $cd9ad04d0320990f$var$u8a = (a)=>a instanceof Uint8Array;
const $cd9ad04d0320990f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $cd9ad04d0320990f$var$bytesToHex(bytes) {
    if (!$cd9ad04d0320990f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $cd9ad04d0320990f$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $cd9ad04d0320990f$var$bytesToHex;
function $cd9ad04d0320990f$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $cd9ad04d0320990f$var$numberToHexUnpadded;
function $cd9ad04d0320990f$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $cd9ad04d0320990f$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $cd9ad04d0320990f$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $cd9ad04d0320990f$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $cd9ad04d0320990f$var$bytesToNumberBE(bytes) {
    return $cd9ad04d0320990f$var$hexToNumber($cd9ad04d0320990f$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $cd9ad04d0320990f$var$bytesToNumberBE;
function $cd9ad04d0320990f$var$bytesToNumberLE(bytes) {
    if (!$cd9ad04d0320990f$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $cd9ad04d0320990f$var$hexToNumber($cd9ad04d0320990f$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $cd9ad04d0320990f$var$bytesToNumberLE;
function $cd9ad04d0320990f$var$numberToBytesBE(n, len) {
    return $cd9ad04d0320990f$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $cd9ad04d0320990f$var$numberToBytesBE;
function $cd9ad04d0320990f$var$numberToBytesLE(n, len) {
    return $cd9ad04d0320990f$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $cd9ad04d0320990f$var$numberToBytesLE;
// Unpadded, rarely used
function $cd9ad04d0320990f$var$numberToVarBytesBE(n) {
    return $cd9ad04d0320990f$var$hexToBytes($cd9ad04d0320990f$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $cd9ad04d0320990f$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $cd9ad04d0320990f$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $cd9ad04d0320990f$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($cd9ad04d0320990f$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $cd9ad04d0320990f$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $cd9ad04d0320990f$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$cd9ad04d0320990f$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $cd9ad04d0320990f$var$concatBytes;
function $cd9ad04d0320990f$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $cd9ad04d0320990f$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $cd9ad04d0320990f$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $cd9ad04d0320990f$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $cd9ad04d0320990f$var$bitLen(n) {
    let len;
    for(len = 0; n > $cd9ad04d0320990f$var$_0n; n >>= $cd9ad04d0320990f$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $cd9ad04d0320990f$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $cd9ad04d0320990f$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $cd9ad04d0320990f$var$_1n;
}
module.exports.bitGet = $cd9ad04d0320990f$var$bitGet;
/**
 * Sets single bit at position.
 */ const $cd9ad04d0320990f$var$bitSet = (n, pos, value)=>{
    return n | (value ? $cd9ad04d0320990f$var$_1n : $cd9ad04d0320990f$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $cd9ad04d0320990f$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $cd9ad04d0320990f$var$bitMask = (n)=>($cd9ad04d0320990f$var$_2n << BigInt(n - 1)) - $cd9ad04d0320990f$var$_1n;
module.exports.bitMask = $cd9ad04d0320990f$var$bitMask;
// DRBG
const $cd9ad04d0320990f$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $cd9ad04d0320990f$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $cd9ad04d0320990f$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $cd9ad04d0320990f$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $cd9ad04d0320990f$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $cd9ad04d0320990f$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($cd9ad04d0320990f$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($cd9ad04d0320990f$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $cd9ad04d0320990f$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $cd9ad04d0320990f$var$createHmacDrbg;
// Validating curves and fields
const $cd9ad04d0320990f$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $cd9ad04d0320990f$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $cd9ad04d0320990f$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $cd9ad04d0320990f$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});




parcelRegister("h3niV", function(module, exports) {

$parcel$export(module.exports, "verifyTypedData", () => $c6a4cb373fde5b45$export$3603b1c1bcd76798);

var $behyn = parcelRequire("behyn");

var $iZ5id = parcelRequire("iZ5id");
async function $c6a4cb373fde5b45$export$3603b1c1bcd76798(client, { address: address, signature: signature, message: message, primaryType: primaryType, types: types, domain: domain, ...callRequest }) {
    const hash = (0, $behyn.hashTypedData)({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
    return (0, $iZ5id.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});

parcelRegister("48U1S", function(module, exports) {

$parcel$export(module.exports, "waitForTransactionReceipt", () => $30435f02b6075f13$export$694ec9bdf0bb55cf);

var $cI1AV = parcelRequire("cI1AV");

var $7UNP4 = parcelRequire("7UNP4");

var $govpX = parcelRequire("govpX");

var $eUDfL = parcelRequire("eUDfL");

var $3RZ58 = parcelRequire("3RZ58");

var $7Vm0z = parcelRequire("7Vm0z");

var $bOjxt = parcelRequire("bOjxt");

var $k934X = parcelRequire("k934X");

var $6LjrN = parcelRequire("6LjrN");

var $gwg6D = parcelRequire("gwg6D");
async function $30435f02b6075f13$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, timeout: timeout }) {
    const observerId = (0, $7Vm0z.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject)=>{
        if (timeout) setTimeout(()=>reject(new (0, $7UNP4.WaitForTransactionReceiptTimeoutError)({
                hash: hash
            })), timeout);
        const _unobserve = (0, $eUDfL.observe)(observerId, {
            onReplaced: onReplaced,
            resolve: resolve,
            reject: reject
        }, (emit)=>{
            const _unwatch = (0, $govpX.getAction)(client, (0, $gwg6D.watchBlockNumber), "watchBlockNumber")({
                emitMissed: true,
                emitOnBegin: true,
                poll: true,
                pollingInterval: pollingInterval,
                async onBlockNumber (blockNumber_) {
                    if (retrying) return;
                    let blockNumber = blockNumber_;
                    const done = (fn)=>{
                        _unwatch();
                        fn();
                        _unobserve();
                    };
                    try {
                        // If we already have a valid receipt, let's check if we have enough
                        // confirmations. If we do, then we can resolve.
                        if (receipt) {
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            done(()=>emit.resolve(receipt));
                            return;
                        }
                        // Get the transaction to check if it's been replaced.
                        // We need to retry as some RPC Providers may be slow to sync
                        // up mined transactions.
                        if (!transaction) {
                            retrying = true;
                            await (0, $3RZ58.withRetry)(async ()=>{
                                transaction = await (0, $govpX.getAction)(client, (0, $k934X.getTransaction), "getTransaction")({
                                    hash: hash
                                });
                                if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                            }, {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6
                            });
                            retrying = false;
                        }
                        // Get the receipt to check if it's been processed.
                        receipt = await (0, $govpX.getAction)(client, (0, $6LjrN.getTransactionReceipt), "getTransactionReceipt")({
                            hash: hash
                        });
                        // Check if we have enough confirmations. If not, continue polling.
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                    } catch (err) {
                        // If the receipt is not found, the transaction will be pending.
                        // We need to check if it has potentially been replaced.
                        if (transaction && (err instanceof (0, $7UNP4.TransactionNotFoundError) || err instanceof (0, $7UNP4.TransactionReceiptNotFoundError))) try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $3RZ58.withRetry)(()=>(0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6,
                                shouldRetry: ({ error: error })=>error instanceof (0, $cI1AV.BlockNotFoundError)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $govpX.getAction)(client, (0, $6LjrN.getTransactionReceipt), "getTransactionReceipt")({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = "replaced";
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                        else done(()=>emit.reject(err));
                    }
                }
            });
        });
    });
}

});
parcelRegister("eUDfL", function(module, exports) {

$parcel$export(module.exports, "observe", () => $adb4be8622d15171$export$d1203567a167490e);
const $adb4be8622d15171$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $adb4be8622d15171$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $adb4be8622d15171$var$callbackCount = 0;
function $adb4be8622d15171$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$adb4be8622d15171$var$callbackCount;
    const getListeners = ()=>$adb4be8622d15171$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $adb4be8622d15171$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const cleanup = $adb4be8622d15171$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $adb4be8622d15171$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $adb4be8622d15171$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}

});

parcelRegister("gwg6D", function(module, exports) {

$parcel$export(module.exports, "watchBlockNumber", () => $c06c20cef76a65be$export$fc5f622dd0d82466);

var $dKCgU = parcelRequire("dKCgU");

var $govpX = parcelRequire("govpX");

var $eUDfL = parcelRequire("eUDfL");

var $8bjLH = parcelRequire("8bjLH");

var $7Vm0z = parcelRequire("7Vm0z");

var $4aSYi = parcelRequire("4aSYi");
function $c06c20cef76a65be$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $7Vm0z.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $eUDfL.observe)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $8bjLH.poll)(async ()=>{
                try {
                    const blockNumber = await (0, $govpX.getAction)(client, (0, $4aSYi.getBlockNumber), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const blockNumber = (0, $dKCgU.hexToBigInt)(data.result?.number);
                        onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}

});
parcelRegister("8bjLH", function(module, exports) {

$parcel$export(module.exports, "poll", () => $5f4eaf626730b6af$export$e0c10349b2c5e1d4);

var $k1zW2 = parcelRequire("k1zW2");
function $5f4eaf626730b6af$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $k1zW2.wait)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $k1zW2.wait)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}

});



parcelRegister("bsB0S", function(module, exports) {

$parcel$export(module.exports, "watchBlocks", () => $857f054155a47101$export$f04bd2888af8db20);

var $6aJeG = parcelRequire("6aJeG");

var $govpX = parcelRequire("govpX");

var $eUDfL = parcelRequire("eUDfL");

var $8bjLH = parcelRequire("8bjLH");

var $7Vm0z = parcelRequire("7Vm0z");

var $bOjxt = parcelRequire("bOjxt");
function $857f054155a47101$export$f04bd2888af8db20(client, { blockTag: blockTag = "latest", emitMissed: emitMissed = false, emitOnBegin: emitOnBegin = false, onBlock: onBlock, onError: onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = ()=>{
        const observerId = (0, $7Vm0z.stringify)([
            "watchBlocks",
            client.uid,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $eUDfL.observe)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, (emit)=>(0, $8bjLH.poll)(async ()=>{
                try {
                    const block = await (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({
                        blockTag: blockTag,
                        includeTransactions: includeTransactions
                    });
                    if (block.number && prevBlock?.number) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (block.number === prevBlock.number) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (block.number - prevBlock.number > 1 && emitMissed) for(let i = prevBlock?.number + 1n; i < block.number; i++){
                            const block = await (0, $govpX.getAction)(client, (0, $bOjxt.getBlock), "getBlock")({
                                blockNumber: i,
                                includeTransactions: includeTransactions
                            });
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                    if (// If no previous block exists, emit.
                    !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
                    blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    block.number && block.number > prevBlock.number) {
                        emit.onBlock(block, prevBlock);
                        prevBlock = block;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlocks = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const format = client.chain?.formatters?.block?.format || (0, $6aJeG.formatBlock);
                        const block = format(data.result);
                        onBlock(block, prevBlock);
                        prevBlock = block;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}

});

parcelRegister("xTWIh", function(module, exports) {

$parcel$export(module.exports, "watchContractEvent", () => $065e7ae3b8b4ede9$export$2a02a63daa2df376);

var $eUDfL = parcelRequire("eUDfL");

var $8bjLH = parcelRequire("8bjLH");

var $7Vm0z = parcelRequire("7Vm0z");

var $329cO = parcelRequire("329cO");

var $cYDOa = parcelRequire("cYDOa");

var $349Qk = parcelRequire("349Qk");

var $kC6lG = parcelRequire("kC6lG");

var $2BPth = parcelRequire("2BPth");

var $govpX = parcelRequire("govpX");

var $gPaZa = parcelRequire("gPaZa");

var $4aSYi = parcelRequire("4aSYi");

var $7IZOR = parcelRequire("7IZOR");

var $iOXvq = parcelRequire("iOXvq");

var $hFhHU = parcelRequire("hFhHU");
function $065e7ae3b8b4ede9$export$2a02a63daa2df376(client, { abi: abi, address: address, args: args, batch: batch = true, eventName: eventName, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollContractEvent = ()=>{
        const observerId = (0, $7Vm0z.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval
        ]);
        const strict = strict_ ?? false;
        return (0, $eUDfL.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $8bjLH.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $govpX.getAction)(client, (0, $gPaZa.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $govpX.getAction)(client, (0, $iOXvq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $govpX.getAction)(client, (0, $4aSYi.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $govpX.getAction)(client, (0, $7IZOR.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber,
                            strict: strict
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $cYDOa.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $govpX.getAction)(client, (0, $hFhHU.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const topics = eventName ? (0, $kC6lG.encodeEventTopics)({
                    abi: abi,
                    eventName: eventName,
                    args: args
                }) : [];
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $349Qk.decodeEventLog)({
                                abi: abi,
                                data: log.data,
                                topics: log.topics,
                                strict: strict_
                            });
                            const formatted = (0, $2BPth.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $329cO.DecodeLogDataMismatch) || err instanceof (0, $329cO.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $2BPth.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}

});

parcelRegister("8OIXs", function(module, exports) {

$parcel$export(module.exports, "watchEvent", () => $66b5ddf3c466645a$export$f6260ad5441916b4);

var $eUDfL = parcelRequire("eUDfL");

var $8bjLH = parcelRequire("8bjLH");

var $7Vm0z = parcelRequire("7Vm0z");

var $329cO = parcelRequire("329cO");

var $cYDOa = parcelRequire("cYDOa");

var $govpX = parcelRequire("govpX");

var $349Qk = parcelRequire("349Qk");
var $kC6lG = parcelRequire("kC6lG");
var $2BPth = parcelRequire("2BPth");

var $lwFhq = parcelRequire("lwFhq");

var $4aSYi = parcelRequire("4aSYi");

var $iOXvq = parcelRequire("iOXvq");

var $dtWJl = parcelRequire("dtWJl");

var $hFhHU = parcelRequire("hFhHU");
function $66b5ddf3c466645a$export$f6260ad5441916b4(client, { address: address, args: args, batch: batch = true, event: event, events: events, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const strict = strict_ ?? false;
    const pollEvent = ()=>{
        const observerId = (0, $7Vm0z.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval
        ]);
        return (0, $eUDfL.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $8bjLH.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $govpX.getAction)(client, (0, $lwFhq.createEventFilter), "createEventFilter")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $govpX.getAction)(client, (0, $iOXvq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $govpX.getAction)(client, (0, $4aSYi.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $govpX.getAction)(client, (0, $dtWJl.getLogs), "getLogs")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $cYDOa.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $govpX.getAction)(client, (0, $hFhHU.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const events_ = events ?? (event ? [
                    event
                ] : undefined);
                let topics = [];
                if (events_) {
                    topics = [
                        events_.flatMap((event)=>(0, $kC6lG.encodeEventTopics)({
                                abi: [
                                    event
                                ],
                                eventName: event.name,
                                args: args
                            }))
                    ];
                    if (event) topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $349Qk.decodeEventLog)({
                                abi: events_,
                                data: log.data,
                                topics: log.topics,
                                strict: strict
                            });
                            const formatted = (0, $2BPth.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $329cO.DecodeLogDataMismatch) || err instanceof (0, $329cO.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $2BPth.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}

});

parcelRegister("kVywx", function(module, exports) {

$parcel$export(module.exports, "watchPendingTransactions", () => $f3c3e93b12407907$export$223080172c87e789);

var $govpX = parcelRequire("govpX");

var $eUDfL = parcelRequire("eUDfL");

var $8bjLH = parcelRequire("8bjLH");

var $7Vm0z = parcelRequire("7Vm0z");

var $8OUYh = parcelRequire("8OUYh");

var $iOXvq = parcelRequire("iOXvq");

var $hFhHU = parcelRequire("hFhHU");
function $f3c3e93b12407907$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $7Vm0z.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $eUDfL.observe)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $8bjLH.poll)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $govpX.getAction)(client, (0, $8OUYh.createPendingTransactionFilter), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $govpX.getAction)(client, (0, $iOXvq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $govpX.getAction)(client, (0, $hFhHU.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}

});



parcelRegister("jOvAN", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $e6cb31775c33e39f$export$bcd1dd1f397bba12);

var $k2k77 = parcelRequire("k2k77");

var $k1zW2 = parcelRequire("k1zW2");

var $lmHde = parcelRequire("lmHde");
function $e6cb31775c33e39f$export$bcd1dd1f397bba12(transports_, config = {}) {
    const { key: key = "fallback", name: name = "Fallback", rank: rank = false, retryCount: retryCount, retryDelay: retryDelay } = config;
    return ({ chain: chain, pollingInterval: pollingInterval = 4000, timeout: timeout })=>{
        let transports = transports_;
        let onResponse = ()=>{};
        const transport = (0, $lmHde.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const fetch = async (i = 0)=>{
                    const transport = transports[i]({
                        chain: chain,
                        retryCount: 0,
                        timeout: timeout
                    });
                    try {
                        const response = await transport.request({
                            method: method,
                            params: params
                        });
                        onResponse({
                            method: method,
                            params: params,
                            response: response,
                            transport: transport,
                            status: "success"
                        });
                        return response;
                    } catch (err) {
                        onResponse({
                            error: err,
                            method: method,
                            params: params,
                            transport: transport,
                            status: "error"
                        });
                        // If the error is deterministic, we don't need to fall back.
                        // So throw the error.
                        if ((0, $k2k77.isDeterministicError)(err)) throw err;
                        // If we've reached the end of the fallbacks, throw the error.
                        if (i === transports.length - 1) throw err;
                        // Otherwise, try the next fallback.
                        return fetch(i + 1);
                    }
                };
                return fetch();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: (fn)=>onResponse = fn,
            transports: transports.map((fn)=>fn({
                    chain: chain,
                    retryCount: 0
                }))
        });
        if (rank) {
            const rankOptions = typeof rank === "object" ? rank : {};
            $e6cb31775c33e39f$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: rankOptions.interval ?? pollingInterval,
                onTransports: (transports_)=>transports = transports_,
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $e6cb31775c33e39f$export$f2bce5ae3fda4e76({ chain: chain, interval: interval = 4000, onTransports: onTransports, sampleCount: sampleCount = 10, timeout: timeout = 1000, transports: transports, weights: weights = {} }) {
    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
    const samples = [];
    const rankTransports_ = async ()=>{
        // 1. Take a sample from each Transport.
        const sample = await Promise.all(transports.map(async (transport)=>{
            const transport_ = transport({
                chain: chain,
                retryCount: 0,
                timeout: timeout
            });
            const start = Date.now();
            let end;
            let success;
            try {
                await transport_.request({
                    method: "net_listening"
                });
                success = 1;
            } catch  {
                success = 0;
            } finally{
                end = Date.now();
            }
            const latency = end - start;
            return {
                latency: latency,
                success: success
            };
        }));
        // 2. Store the sample. If we have more than `sampleCount` samples, remove
        // the oldest sample.
        samples.push(sample);
        if (samples.length > sampleCount) samples.shift();
        // 3. Calculate the max latency from samples.
        const maxLatency = Math.max(...samples.map((sample)=>Math.max(...sample.map(({ latency: latency })=>latency))));
        // 4. Calculate the score for each Transport.
        const scores = transports.map((_, i)=>{
            const latencies = samples.map((sample)=>sample[i].latency);
            const meanLatency = latencies.reduce((acc, latency)=>acc + latency, 0) / latencies.length;
            const latencyScore = 1 - meanLatency / maxLatency;
            const successes = samples.map((sample)=>sample[i].success);
            const stabilityScore = successes.reduce((acc, success)=>acc + success, 0) / successes.length;
            if (stabilityScore === 0) return [
                0,
                i
            ];
            return [
                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                i
            ];
        }).sort((a, b)=>b[0] - a[0]);
        // 5. Sort the Transports by score.
        onTransports(scores.map(([, i])=>transports[i]));
        // 6. Wait, and then rank again.
        await (0, $k1zW2.wait)(interval);
        rankTransports_();
    };
    rankTransports_();
}

});

parcelRegister("3MzNb", function(module, exports) {

$parcel$export(module.exports, "getContract", () => $2c119e6980485344$export$f518c38144e1f9d);

var $govpX = parcelRequire("govpX");

var $gPaZa = parcelRequire("gPaZa");

var $1moxn = parcelRequire("1moxn");

var $7IZOR = parcelRequire("7IZOR");

var $jLRKT = parcelRequire("jLRKT");

var $cQCwv = parcelRequire("cQCwv");

var $xTWIh = parcelRequire("xTWIh");

var $iHyR5 = parcelRequire("iHyR5");
function $2c119e6980485344$export$f518c38144e1f9d({ abi: abi, address: address, publicClient: publicClient, walletClient: walletClient }) {
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi){
        if (item.type === "function") {
            if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
            else hasWriteFunction = true;
        } else if (item.type === "event") hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent) break;
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $2c119e6980485344$export$b1d653474fdb0f41(parameters);
                    return (0, $govpX.getAction)(publicClient, (0, $jLRKT.readContract), "readContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $2c119e6980485344$export$b1d653474fdb0f41(parameters);
                    return (0, $govpX.getAction)(publicClient, (0, $cQCwv.simulateContract), "simulateContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $2c119e6980485344$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $govpX.getAction)(publicClient, (0, $gPaZa.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $2c119e6980485344$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $govpX.getAction)(publicClient, (0, $7IZOR.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $2c119e6980485344$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $govpX.getAction)(publicClient, (0, $xTWIh.watchContractEvent), "watchContractEvent")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $2c119e6980485344$export$b1d653474fdb0f41(parameters);
                    return (0, $govpX.getAction)(walletClient, (0, $iHyR5.writeContract), "writeContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $2c119e6980485344$export$b1d653474fdb0f41(parameters);
                    const client = publicClient ?? walletClient;
                    return (0, $govpX.getAction)(client, (0, $1moxn.estimateContractGas), "estimateContractGas")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options,
                        account: options.account ?? walletClient.account
                    });
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $2c119e6980485344$export$b1d653474fdb0f41(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}
function $2c119e6980485344$export$5d0aafa8249eb606(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some((x)=>x.indexed);
    else if (values.length === 2) hasArgs = true;
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}

});

parcelRegister("8p0q4", function(module, exports) {

$parcel$export(module.exports, "http", () => $61e0fbdaf09809bf$export$7d6f1c8842f9f527);

var $klW82 = parcelRequire("klW82");

var $ceopF = parcelRequire("ceopF");

var $hKLjS = parcelRequire("hKLjS");

var $9cdZ1 = parcelRequire("9cdZ1");

var $lmHde = parcelRequire("lmHde");
function $61e0fbdaf09809bf$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", name: name = "HTTP JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $ceopF.UrlRequiredError)();
        return (0, $lmHde.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $hKLjS.createBatchScheduler)({
                    id: `${url}`,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>(0, $9cdZ1.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await (0, $9cdZ1.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $klW82.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url
        });
    };
}

});
parcelRegister("ceopF", function(module, exports) {

$parcel$export(module.exports, "UrlRequiredError", () => $8e79babb60a72015$export$d0a48bf953f3c239);

var $kpVTR = parcelRequire("kpVTR");
class $8e79babb60a72015$export$d0a48bf953f3c239 extends (0, $kpVTR.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro"
        });
    }
}

});

parcelRegister("9cdZ1", function(module, exports) {

$parcel$export(module.exports, "getSocket", () => $6b2014cd65fc18dd$export$361cf94c2d913fd4);
$parcel$export(module.exports, "rpc", () => $6b2014cd65fc18dd$export$82f5954781486db2);

var $gzvcY = parcelRequire("gzvcY");

var $klW82 = parcelRequire("klW82");

var $hKLjS = parcelRequire("hKLjS");

var $awzbc = parcelRequire("awzbc");

var $7Vm0z = parcelRequire("7Vm0z");
let $6b2014cd65fc18dd$var$id = 0;
async function $6b2014cd65fc18dd$var$http(url, { body: body, fetchOptions: fetchOptions = {}, timeout: timeout = 10000 }) {
    const { headers: headers, method: method, signal: signal_ } = fetchOptions;
    try {
        const response = await (0, $awzbc.withTimeout)(async ({ signal: signal })=>{
            const response = await fetch(url, {
                ...fetchOptions,
                body: Array.isArray(body) ? (0, $7Vm0z.stringify)(body.map((body)=>({
                        jsonrpc: "2.0",
                        id: body.id ?? $6b2014cd65fc18dd$var$id++,
                        ...body
                    }))) : (0, $7Vm0z.stringify)({
                    jsonrpc: "2.0",
                    id: body.id ?? $6b2014cd65fc18dd$var$id++,
                    ...body
                }),
                headers: {
                    ...headers,
                    "Content-Type": "application/json"
                },
                method: method || "POST",
                signal: signal_ || (timeout > 0 ? signal : undefined)
            });
            return response;
        }, {
            errorInstance: new (0, $klW82.TimeoutError)({
                body: body,
                url: url
            }),
            timeout: timeout,
            signal: true
        });
        let data;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
        else data = await response.text();
        if (!response.ok) throw new (0, $klW82.HttpRequestError)({
            body: body,
            details: (0, $7Vm0z.stringify)(data.error) || response.statusText,
            headers: response.headers,
            status: response.status,
            url: url
        });
        return data;
    } catch (err) {
        if (err instanceof (0, $klW82.HttpRequestError)) throw err;
        if (err instanceof (0, $klW82.TimeoutError)) throw err;
        throw new (0, $klW82.HttpRequestError)({
            body: body,
            details: err.message,
            url: url
        });
    }
}
const $6b2014cd65fc18dd$export$d1a9365cd3e8f4dd = /*#__PURE__*/ new Map();
async function $6b2014cd65fc18dd$export$361cf94c2d913fd4(url) {
    let socket = $6b2014cd65fc18dd$export$d1a9365cd3e8f4dd.get(url);
    // If the socket already exists, return it.
    if (socket) return socket;
    const { schedule: schedule } = (0, $hKLjS.createBatchScheduler)({
        id: url,
        fn: async ()=>{
            const webSocket = new (0, $gzvcY.WebSocket)(url);
            // Set up a cache for incoming "synchronous" requests.
            const requests = new Map();
            // Set up a cache for subscriptions (eth_subscribe).
            const subscriptions = new Map();
            const onMessage = ({ data: data })=>{
                const message = JSON.parse(data);
                const isSubscription = message.method === "eth_subscription";
                const id = isSubscription ? message.params.subscription : message.id;
                const cache = isSubscription ? subscriptions : requests;
                const callback = cache.get(id);
                if (callback) callback({
                    data: data
                });
                if (!isSubscription) cache.delete(id);
            };
            const onClose = ()=>{
                $6b2014cd65fc18dd$export$d1a9365cd3e8f4dd.delete(url);
                webSocket.removeEventListener("close", onClose);
                webSocket.removeEventListener("message", onMessage);
            };
            // Setup event listeners for RPC & subscription responses.
            webSocket.addEventListener("close", onClose);
            webSocket.addEventListener("message", onMessage);
            // Wait for the socket to open.
            if (webSocket.readyState === (0, $gzvcY.WebSocket).CONNECTING) await new Promise((resolve, reject)=>{
                if (!webSocket) return;
                webSocket.onopen = resolve;
                webSocket.onerror = reject;
            });
            // Create a new socket instance.
            socket = Object.assign(webSocket, {
                requests: requests,
                subscriptions: subscriptions
            });
            $6b2014cd65fc18dd$export$d1a9365cd3e8f4dd.set(url, socket);
            return [
                socket
            ];
        }
    });
    const [_, [socket_]] = await schedule();
    return socket_;
}
function $6b2014cd65fc18dd$var$webSocket(socket, { body: body, onResponse: onResponse }) {
    if (socket.readyState === socket.CLOSED || socket.readyState === socket.CLOSING) throw new (0, $klW82.WebSocketRequestError)({
        body: body,
        url: socket.url,
        details: "Socket is closed."
    });
    const id_ = $6b2014cd65fc18dd$var$id++;
    const callback = ({ data: data })=>{
        const message = JSON.parse(data);
        if (typeof message.id === "number" && id_ !== message.id) return;
        onResponse?.(message);
        // If we are subscribing to a topic, we want to set up a listener for incoming
        // messages.
        if (body.method === "eth_subscribe" && typeof message.result === "string") socket.subscriptions.set(message.result, callback);
        // If we are unsubscribing from a topic, we want to remove the listener.
        if (body.method === "eth_unsubscribe") socket.subscriptions.delete(body.params?.[0]);
    };
    socket.requests.set(id_, callback);
    socket.send(JSON.stringify({
        jsonrpc: "2.0",
        ...body,
        id: id_
    }));
    return socket;
}
async function $6b2014cd65fc18dd$var$webSocketAsync(socket, { body: body, timeout: timeout = 10000 }) {
    return (0, $awzbc.withTimeout)(()=>new Promise((onResponse)=>$6b2014cd65fc18dd$export$82f5954781486db2.webSocket(socket, {
                body: body,
                onResponse: onResponse
            })), {
        errorInstance: new (0, $klW82.TimeoutError)({
            body: body,
            url: socket.url
        }),
        timeout: timeout
    });
}
const $6b2014cd65fc18dd$export$82f5954781486db2 = {
    http: $6b2014cd65fc18dd$var$http,
    webSocket: $6b2014cd65fc18dd$var$webSocket,
    webSocketAsync: $6b2014cd65fc18dd$var$webSocketAsync
};

});
parcelRegister("gzvcY", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $c1081f83285b72b4$export$3909fb301d3dc8c9);

var $arG7Y = parcelRequire("arG7Y");
const $c1081f83285b72b4$export$3909fb301d3dc8c9 = (0, $arG7Y.getNativeWebSocket)();

});
parcelRegister("arG7Y", function(module, exports) {

$parcel$export(module.exports, "getNativeWebSocket", () => $79ad1ab0a5955036$export$f67cfa4655f7ea21);
function $79ad1ab0a5955036$export$f67cfa4655f7ea21() {
    if (typeof WebSocket !== "undefined") return WebSocket;
    if (typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    if (typeof window.WebSocket !== "undefined") return window.WebSocket;
    if (typeof self.WebSocket !== "undefined") return self.WebSocket;
    throw new Error("`WebSocket` is not supported in this environment");
}

});


parcelRegister("awzbc", function(module, exports) {

$parcel$export(module.exports, "withTimeout", () => $7a982e79e9e4ed37$export$e86e19342bc4850e);
function $7a982e79e9e4ed37$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout);
                resolve(await fn({
                    signal: controller?.signal
                }));
            } catch (err) {
                if (err.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}

});



parcelRegister("9bv14", function(module, exports) {

$parcel$export(module.exports, "parseGwei", () => $6afd3353f73c98c8$export$7a255715fecbb534);

var $987xW = parcelRequire("987xW");

var $gxJ5d = parcelRequire("gxJ5d");
function $6afd3353f73c98c8$export$7a255715fecbb534(ether, unit = "wei") {
    return (0, $gxJ5d.parseUnits)(ether, (0, $987xW.gweiUnits)[unit]);
}

});
parcelRegister("gxJ5d", function(module, exports) {

$parcel$export(module.exports, "parseUnits", () => $c0b2b2fe11fd872b$export$203ae30b4f6490b3);
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits.html
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $c0b2b2fe11fd872b$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}

});


parcelRegister("ioTPL", function(module, exports) {

$parcel$export(module.exports, "webSocket", () => $d655c75c3755ef21$export$debf5095acd2163f);

var $klW82 = parcelRequire("klW82");

var $ceopF = parcelRequire("ceopF");

var $9cdZ1 = parcelRequire("9cdZ1");

var $lmHde = parcelRequire("lmHde");
function $d655c75c3755ef21$export$debf5095acd2163f(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { key: key = "webSocket", name: name = "WebSocket JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
        if (!url_) throw new (0, $ceopF.UrlRequiredError)();
        return (0, $lmHde.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const socket = await (0, $9cdZ1.getSocket)(url_);
                const { error: error, result: result } = await (0, $9cdZ1.rpc).webSocketAsync(socket, {
                    body: body,
                    timeout: timeout
                });
                if (error) throw new (0, $klW82.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "webSocket"
        }, {
            getSocket () {
                return (0, $9cdZ1.getSocket)(url_);
            },
            async subscribe ({ params: params, onData: onData, onError: onError }) {
                const socket = await (0, $9cdZ1.getSocket)(url_);
                const { result: subscriptionId } = await new Promise((resolve, reject)=>(0, $9cdZ1.rpc).webSocket(socket, {
                        body: {
                            method: "eth_subscribe",
                            params: params
                        },
                        onResponse (response) {
                            if (response.error) {
                                reject(response.error);
                                onError?.(response.error);
                                return;
                            }
                            if (typeof response.id === "number") {
                                resolve(response);
                                return;
                            }
                            if (response.method !== "eth_subscription") return;
                            onData(response.params);
                        }
                    }));
                return {
                    subscriptionId: subscriptionId,
                    async unsubscribe () {
                        return new Promise((resolve)=>(0, $9cdZ1.rpc).webSocket(socket, {
                                body: {
                                    method: "eth_unsubscribe",
                                    params: [
                                        subscriptionId
                                    ]
                                },
                                onResponse: resolve
                            }));
                    }
                };
            }
        });
    };
}

});

parcelRegister("11Szb", function(module, exports) {

$parcel$export(module.exports, "persist", () => $0c00362f0f0ce85a$export$9a6132153fba2e0, (v) => $0c00362f0f0ce85a$export$9a6132153fba2e0 = v);
$parcel$export(module.exports, "subscribeWithSelector", () => $0c00362f0f0ce85a$export$5c593627aef9f076, (v) => $0c00362f0f0ce85a$export$5c593627aef9f076 = v);
var $0c00362f0f0ce85a$export$1be1fc439b849fdf;
var $0c00362f0f0ce85a$export$95a3b7b12ab518f9;
var $0c00362f0f0ce85a$export$6922d3b3a607469e;
var $0c00362f0f0ce85a$export$9a6132153fba2e0;
var $0c00362f0f0ce85a$export$4feba8a1bc8e9afd;
var $0c00362f0f0ce85a$export$5c593627aef9f076;
"use strict";
function $0c00362f0f0ce85a$var$_extends() {
    $0c00362f0f0ce85a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c00362f0f0ce85a$var$_extends.apply(this, arguments);
}
function $0c00362f0f0ce85a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0c00362f0f0ce85a$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $0c00362f0f0ce85a$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $0c00362f0f0ce85a$var$redux = $0c00362f0f0ce85a$var$reduxImpl;
var $0c00362f0f0ce85a$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $0c00362f0f0ce85a$var$_excluded2 = [
    "connection"
];
var $0c00362f0f0ce85a$var$trackedConnections = new Map();
var $0c00362f0f0ce85a$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $0c00362f0f0ce85a$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $0c00362f0f0ce85a$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $0c00362f0f0ce85a$var$trackedConnections.get(options.name);
    if (existingConnection) return $0c00362f0f0ce85a$var$_extends({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $0c00362f0f0ce85a$var$trackedConnections.set(options.name, newConnection);
    return $0c00362f0f0ce85a$var$_extends({
        type: "tracked",
        store: store
    }, newConnection);
};
var $0c00362f0f0ce85a$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $0c00362f0f0ce85a$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $0c00362f0f0ce85a$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $0c00362f0f0ce85a$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $0c00362f0f0ce85a$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $0c00362f0f0ce85a$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($0c00362f0f0ce85a$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $0c00362f0f0ce85a$var$_extends({}, $0c00362f0f0ce85a$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $0c00362f0f0ce85a$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($0c00362f0f0ce85a$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($0c00362f0f0ce85a$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $0c00362f0f0ce85a$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($0c00362f0f0ce85a$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $0c00362f0f0ce85a$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $0c00362f0f0ce85a$var$devtools = $0c00362f0f0ce85a$var$devtoolsImpl;
var $0c00362f0f0ce85a$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var $0c00362f0f0ce85a$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $0c00362f0f0ce85a$var$subscribeWithSelector = $0c00362f0f0ce85a$var$subscribeWithSelectorImpl;
var $0c00362f0f0ce85a$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $0c00362f0f0ce85a$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $0c00362f0f0ce85a$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $0c00362f0f0ce85a$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $0c00362f0f0ce85a$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $0c00362f0f0ce85a$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $0c00362f0f0ce85a$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($0c00362f0f0ce85a$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $0c00362f0f0ce85a$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $0c00362f0f0ce85a$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $0c00362f0f0ce85a$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $0c00362f0f0ce85a$var$_extends({
            storage: $0c00362f0f0ce85a$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $0c00362f0f0ce85a$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($0c00362f0f0ce85a$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $0c00362f0f0ce85a$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $0c00362f0f0ce85a$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $0c00362f0f0ce85a$var$persistImpl = function persistImpl(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) return $0c00362f0f0ce85a$var$oldImpl(config, baseOptions);
    return $0c00362f0f0ce85a$var$newImpl(config, baseOptions);
};
var $0c00362f0f0ce85a$var$persist = $0c00362f0f0ce85a$var$persistImpl;
$0c00362f0f0ce85a$export$1be1fc439b849fdf = $0c00362f0f0ce85a$var$combine;
$0c00362f0f0ce85a$export$95a3b7b12ab518f9 = $0c00362f0f0ce85a$var$createJSONStorage;
$0c00362f0f0ce85a$export$6922d3b3a607469e = $0c00362f0f0ce85a$var$devtools;
$0c00362f0f0ce85a$export$9a6132153fba2e0 = $0c00362f0f0ce85a$var$persist;
$0c00362f0f0ce85a$export$4feba8a1bc8e9afd = $0c00362f0f0ce85a$var$redux;
$0c00362f0f0ce85a$export$5c593627aef9f076 = $0c00362f0f0ce85a$var$subscribeWithSelector;

});

parcelRegister("i57sw", function(module, exports) {
"use strict";
var $d29e7acf18c73e9a$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $d29e7acf18c73e9a$var$createStore = function createStore(createState) {
    return createState ? $d29e7acf18c73e9a$var$createStoreImpl(createState) : $d29e7acf18c73e9a$var$createStoreImpl;
};
var $d29e7acf18c73e9a$var$vanilla = function(createState) {
    return $d29e7acf18c73e9a$var$createStore(createState);
};
module.exports.createStore = $d29e7acf18c73e9a$var$createStore;
module.exports.default = $d29e7acf18c73e9a$var$vanilla;
module.exports = $d29e7acf18c73e9a$var$vanilla;
module.exports.createStore = $d29e7acf18c73e9a$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("cZFtK", function(module, exports) {
"use strict";
function $0270f51623d7afa9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0270f51623d7afa9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0270f51623d7afa9$var$_arrayLikeToArray(o, minLen);
}
function $0270f51623d7afa9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0270f51623d7afa9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0270f51623d7afa9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0270f51623d7afa9$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $0270f51623d7afa9$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $0270f51623d7afa9$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var $0270f51623d7afa9$var$shallow = function(objA, objB) {
    return $0270f51623d7afa9$var$shallow$1(objA, objB);
};
module.exports.default = $0270f51623d7afa9$var$shallow;
module.exports.shallow = $0270f51623d7afa9$var$shallow$1;
module.exports = $0270f51623d7afa9$var$shallow;
module.exports.shallow = $0270f51623d7afa9$var$shallow$1;
module.exports.default = module.exports;

});

parcelRegister("eIFWU", function(module, exports) {

var $sJXAr = parcelRequire("sJXAr");
module.exports = $sJXAr("1s6eq").then(()=>parcelRequire("fJFYW"));

});


parcelRegister("guCQ1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c01d931bdfa6f8ec$export$306c0aa65ff9ec16, (v) => $c01d931bdfa6f8ec$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c01d931bdfa6f8ec$export$306c0aa65ff9ec16;
"use strict";

var $dup7A = parcelRequire("dup7A");
function $c01d931bdfa6f8ec$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c01d931bdfa6f8ec$var$k = "function" === typeof Object.is ? Object.is : $c01d931bdfa6f8ec$var$h, $c01d931bdfa6f8ec$var$l = $dup7A.useState, $c01d931bdfa6f8ec$var$m = $dup7A.useEffect, $c01d931bdfa6f8ec$var$n = $dup7A.useLayoutEffect, $c01d931bdfa6f8ec$var$p = $dup7A.useDebugValue;
function $c01d931bdfa6f8ec$var$q(a, b) {
    var d = b(), f = $c01d931bdfa6f8ec$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $c01d931bdfa6f8ec$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $c01d931bdfa6f8ec$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $c01d931bdfa6f8ec$var$m(function() {
        $c01d931bdfa6f8ec$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $c01d931bdfa6f8ec$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $c01d931bdfa6f8ec$var$p(d);
    return d;
}
function $c01d931bdfa6f8ec$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$c01d931bdfa6f8ec$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $c01d931bdfa6f8ec$var$t(a, b) {
    return b();
}
var $c01d931bdfa6f8ec$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c01d931bdfa6f8ec$var$t : $c01d931bdfa6f8ec$var$q;
$c01d931bdfa6f8ec$export$306c0aa65ff9ec16 = void 0 !== $dup7A.useSyncExternalStore ? $dup7A.useSyncExternalStore : $c01d931bdfa6f8ec$var$u;

});

parcelRegister("8Gdy2", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $651cc14f88210a2c$export$bf730a2d8bf68b42, (v) => $651cc14f88210a2c$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $651cc14f88210a2c$export$bf730a2d8bf68b42;
"use strict";

var $dup7A = parcelRequire("dup7A");

var $fAYJg = parcelRequire("fAYJg");
function $651cc14f88210a2c$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $651cc14f88210a2c$var$q = "function" === typeof Object.is ? Object.is : $651cc14f88210a2c$var$p, $651cc14f88210a2c$var$r = $fAYJg.useSyncExternalStore, $651cc14f88210a2c$var$t = $dup7A.useRef, $651cc14f88210a2c$var$u = $dup7A.useEffect, $651cc14f88210a2c$var$v = $dup7A.useMemo, $651cc14f88210a2c$var$w = $dup7A.useDebugValue;
$651cc14f88210a2c$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $651cc14f88210a2c$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $651cc14f88210a2c$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($651cc14f88210a2c$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $651cc14f88210a2c$var$r(a, c[0], c[1]);
    $651cc14f88210a2c$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $651cc14f88210a2c$var$w(d);
    return d;
};

});
parcelRegister("fAYJg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("guCQ1"));

});


parcelRegister("gbdt3", function(module, exports) {
// shim for using process in browser
var $bc781ece6e652596$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $bc781ece6e652596$var$cachedSetTimeout;
var $bc781ece6e652596$var$cachedClearTimeout;
function $bc781ece6e652596$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $bc781ece6e652596$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $bc781ece6e652596$var$cachedSetTimeout = setTimeout;
        else $bc781ece6e652596$var$cachedSetTimeout = $bc781ece6e652596$var$defaultSetTimout;
    } catch (e) {
        $bc781ece6e652596$var$cachedSetTimeout = $bc781ece6e652596$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $bc781ece6e652596$var$cachedClearTimeout = clearTimeout;
        else $bc781ece6e652596$var$cachedClearTimeout = $bc781ece6e652596$var$defaultClearTimeout;
    } catch (e) {
        $bc781ece6e652596$var$cachedClearTimeout = $bc781ece6e652596$var$defaultClearTimeout;
    }
})();
function $bc781ece6e652596$var$runTimeout(fun) {
    if ($bc781ece6e652596$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($bc781ece6e652596$var$cachedSetTimeout === $bc781ece6e652596$var$defaultSetTimout || !$bc781ece6e652596$var$cachedSetTimeout) && setTimeout) {
        $bc781ece6e652596$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bc781ece6e652596$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $bc781ece6e652596$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $bc781ece6e652596$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $bc781ece6e652596$var$runClearTimeout(marker) {
    if ($bc781ece6e652596$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($bc781ece6e652596$var$cachedClearTimeout === $bc781ece6e652596$var$defaultClearTimeout || !$bc781ece6e652596$var$cachedClearTimeout) && clearTimeout) {
        $bc781ece6e652596$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $bc781ece6e652596$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $bc781ece6e652596$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $bc781ece6e652596$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $bc781ece6e652596$var$queue = [];
var $bc781ece6e652596$var$draining = false;
var $bc781ece6e652596$var$currentQueue;
var $bc781ece6e652596$var$queueIndex = -1;
function $bc781ece6e652596$var$cleanUpNextTick() {
    if (!$bc781ece6e652596$var$draining || !$bc781ece6e652596$var$currentQueue) return;
    $bc781ece6e652596$var$draining = false;
    if ($bc781ece6e652596$var$currentQueue.length) $bc781ece6e652596$var$queue = $bc781ece6e652596$var$currentQueue.concat($bc781ece6e652596$var$queue);
    else $bc781ece6e652596$var$queueIndex = -1;
    if ($bc781ece6e652596$var$queue.length) $bc781ece6e652596$var$drainQueue();
}
function $bc781ece6e652596$var$drainQueue() {
    if ($bc781ece6e652596$var$draining) return;
    var timeout = $bc781ece6e652596$var$runTimeout($bc781ece6e652596$var$cleanUpNextTick);
    $bc781ece6e652596$var$draining = true;
    var len = $bc781ece6e652596$var$queue.length;
    while(len){
        $bc781ece6e652596$var$currentQueue = $bc781ece6e652596$var$queue;
        $bc781ece6e652596$var$queue = [];
        while(++$bc781ece6e652596$var$queueIndex < len)if ($bc781ece6e652596$var$currentQueue) $bc781ece6e652596$var$currentQueue[$bc781ece6e652596$var$queueIndex].run();
        $bc781ece6e652596$var$queueIndex = -1;
        len = $bc781ece6e652596$var$queue.length;
    }
    $bc781ece6e652596$var$currentQueue = null;
    $bc781ece6e652596$var$draining = false;
    $bc781ece6e652596$var$runClearTimeout(timeout);
}
$bc781ece6e652596$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $bc781ece6e652596$var$queue.push(new $bc781ece6e652596$var$Item(fun, args));
    if ($bc781ece6e652596$var$queue.length === 1 && !$bc781ece6e652596$var$draining) $bc781ece6e652596$var$runTimeout($bc781ece6e652596$var$drainQueue);
};
// v8 likes predictible objects
function $bc781ece6e652596$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$bc781ece6e652596$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$bc781ece6e652596$var$process.title = "browser";
$bc781ece6e652596$var$process.browser = true;
$bc781ece6e652596$var$process.env = {};
$bc781ece6e652596$var$process.argv = [];
$bc781ece6e652596$var$process.version = ""; // empty string to avoid regexp issues
$bc781ece6e652596$var$process.versions = {};
function $bc781ece6e652596$var$noop() {}
$bc781ece6e652596$var$process.on = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.addListener = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.once = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.off = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.removeListener = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.removeAllListeners = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.emit = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.prependListener = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.prependOnceListener = $bc781ece6e652596$var$noop;
$bc781ece6e652596$var$process.listeners = function(name) {
    return [];
};
$bc781ece6e652596$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$bc781ece6e652596$var$process.cwd = function() {
    return "/";
};
$bc781ece6e652596$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$bc781ece6e652596$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hFL7V", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $cddad265fba5de75$export$a7c73072b1a182ae, (v) => $cddad265fba5de75$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $cddad265fba5de75$export$9f27bc3417b4524d, (v) => $cddad265fba5de75$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $cddad265fba5de75$export$db77ccec0bb4ccac, (v) => $cddad265fba5de75$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $cddad265fba5de75$export$8392c0c9d3dcbd35, (v) => $cddad265fba5de75$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $cddad265fba5de75$export$ffb0004e005737fa, (v) => $cddad265fba5de75$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $cddad265fba5de75$export$b624eff549462981, (v) => $cddad265fba5de75$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $cddad265fba5de75$export$7897aa7841a5380c, (v) => $cddad265fba5de75$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $cddad265fba5de75$export$602eac185826482c, (v) => $cddad265fba5de75$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $cddad265fba5de75$export$e2c29f18771995cb, (v) => $cddad265fba5de75$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $cddad265fba5de75$export$5f8d39834fd61797, (v) => $cddad265fba5de75$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $cddad265fba5de75$export$74bf444e3cd11ea5, (v) => $cddad265fba5de75$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $cddad265fba5de75$export$998bcd577473dd93, (v) => $cddad265fba5de75$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $cddad265fba5de75$export$92387174baf9b227, (v) => $cddad265fba5de75$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $cddad265fba5de75$export$ec112efeb987d9c6, (v) => $cddad265fba5de75$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $cddad265fba5de75$export$b706b080d889d2c9, (v) => $cddad265fba5de75$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $cddad265fba5de75$export$5be5a87408f70ddc, (v) => $cddad265fba5de75$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $cddad265fba5de75$export$45a5e7f76e0caa8d, (v) => $cddad265fba5de75$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $cddad265fba5de75$export$455c2e768291efa6, (v) => $cddad265fba5de75$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $cddad265fba5de75$export$9522e17588c12572, (v) => $cddad265fba5de75$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $cddad265fba5de75$export$2110ac352bb060b9, (v) => $cddad265fba5de75$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $cddad265fba5de75$export$56885ab8b9c456ab, (v) => $cddad265fba5de75$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $cddad265fba5de75$export$d927fcb6adf8f9de, (v) => $cddad265fba5de75$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $cddad265fba5de75$export$b82d16f27459e05a, (v) => $cddad265fba5de75$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $cddad265fba5de75$export$522c17b4f5e123e8, (v) => $cddad265fba5de75$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $cddad265fba5de75$export$1aabd8a0274ecfd6, (v) => $cddad265fba5de75$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $cddad265fba5de75$export$3d6c20d97e46b957, (v) => $cddad265fba5de75$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $cddad265fba5de75$export$9b621391a187a31a, (v) => $cddad265fba5de75$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $cddad265fba5de75$export$f5bbd400c2f4426f, (v) => $cddad265fba5de75$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cddad265fba5de75$export$a7c73072b1a182ae;
var $cddad265fba5de75$export$9f27bc3417b4524d;
var $cddad265fba5de75$export$db77ccec0bb4ccac;
var $cddad265fba5de75$export$8392c0c9d3dcbd35;
var $cddad265fba5de75$export$ffb0004e005737fa;
var $cddad265fba5de75$export$b624eff549462981;
var $cddad265fba5de75$export$7897aa7841a5380c;
var $cddad265fba5de75$export$602eac185826482c;
var $cddad265fba5de75$export$e2c29f18771995cb;
var $cddad265fba5de75$export$5f8d39834fd61797;
var $cddad265fba5de75$export$74bf444e3cd11ea5;
var $cddad265fba5de75$export$998bcd577473dd93;
var $cddad265fba5de75$export$92387174baf9b227;
var $cddad265fba5de75$export$ec112efeb987d9c6;
var $cddad265fba5de75$export$b706b080d889d2c9;
var $cddad265fba5de75$export$5be5a87408f70ddc;
var $cddad265fba5de75$export$45a5e7f76e0caa8d;
var $cddad265fba5de75$export$455c2e768291efa6;
var $cddad265fba5de75$export$9522e17588c12572;
var $cddad265fba5de75$export$2110ac352bb060b9;
var $cddad265fba5de75$export$56885ab8b9c456ab;
var $cddad265fba5de75$export$d927fcb6adf8f9de;
var $cddad265fba5de75$export$b82d16f27459e05a;
var $cddad265fba5de75$export$522c17b4f5e123e8;
var $cddad265fba5de75$export$1aabd8a0274ecfd6;
var $cddad265fba5de75$export$3d6c20d97e46b957;
var $cddad265fba5de75$export$9b621391a187a31a;
var $cddad265fba5de75$export$f5bbd400c2f4426f;
"use strict";
var $cddad265fba5de75$var$b = Symbol.for("react.element"), $cddad265fba5de75$var$c = Symbol.for("react.portal"), $cddad265fba5de75$var$d = Symbol.for("react.fragment"), $cddad265fba5de75$var$e = Symbol.for("react.strict_mode"), $cddad265fba5de75$var$f = Symbol.for("react.profiler"), $cddad265fba5de75$var$g = Symbol.for("react.provider"), $cddad265fba5de75$var$h = Symbol.for("react.context"), $cddad265fba5de75$var$k = Symbol.for("react.server_context"), $cddad265fba5de75$var$l = Symbol.for("react.forward_ref"), $cddad265fba5de75$var$m = Symbol.for("react.suspense"), $cddad265fba5de75$var$n = Symbol.for("react.suspense_list"), $cddad265fba5de75$var$p = Symbol.for("react.memo"), $cddad265fba5de75$var$q = Symbol.for("react.lazy"), $cddad265fba5de75$var$t = Symbol.for("react.offscreen"), $cddad265fba5de75$var$u;
$cddad265fba5de75$var$u = Symbol.for("react.module.reference");
function $cddad265fba5de75$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $cddad265fba5de75$var$b:
                switch(a = a.type, a){
                    case $cddad265fba5de75$var$d:
                    case $cddad265fba5de75$var$f:
                    case $cddad265fba5de75$var$e:
                    case $cddad265fba5de75$var$m:
                    case $cddad265fba5de75$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cddad265fba5de75$var$k:
                            case $cddad265fba5de75$var$h:
                            case $cddad265fba5de75$var$l:
                            case $cddad265fba5de75$var$q:
                            case $cddad265fba5de75$var$p:
                            case $cddad265fba5de75$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $cddad265fba5de75$var$c:
                return r;
        }
    }
}
$cddad265fba5de75$export$a7c73072b1a182ae = $cddad265fba5de75$var$h;
$cddad265fba5de75$export$9f27bc3417b4524d = $cddad265fba5de75$var$g;
$cddad265fba5de75$export$db77ccec0bb4ccac = $cddad265fba5de75$var$b;
$cddad265fba5de75$export$8392c0c9d3dcbd35 = $cddad265fba5de75$var$l;
$cddad265fba5de75$export$ffb0004e005737fa = $cddad265fba5de75$var$d;
$cddad265fba5de75$export$b624eff549462981 = $cddad265fba5de75$var$q;
$cddad265fba5de75$export$7897aa7841a5380c = $cddad265fba5de75$var$p;
$cddad265fba5de75$export$602eac185826482c = $cddad265fba5de75$var$c;
$cddad265fba5de75$export$e2c29f18771995cb = $cddad265fba5de75$var$f;
$cddad265fba5de75$export$5f8d39834fd61797 = $cddad265fba5de75$var$e;
$cddad265fba5de75$export$74bf444e3cd11ea5 = $cddad265fba5de75$var$m;
$cddad265fba5de75$export$998bcd577473dd93 = $cddad265fba5de75$var$n;
$cddad265fba5de75$export$92387174baf9b227 = function() {
    return !1;
};
$cddad265fba5de75$export$ec112efeb987d9c6 = function() {
    return !1;
};
$cddad265fba5de75$export$b706b080d889d2c9 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$h;
};
$cddad265fba5de75$export$5be5a87408f70ddc = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$g;
};
$cddad265fba5de75$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cddad265fba5de75$var$b;
};
$cddad265fba5de75$export$455c2e768291efa6 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$l;
};
$cddad265fba5de75$export$9522e17588c12572 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$d;
};
$cddad265fba5de75$export$2110ac352bb060b9 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$q;
};
$cddad265fba5de75$export$56885ab8b9c456ab = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$p;
};
$cddad265fba5de75$export$d927fcb6adf8f9de = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$c;
};
$cddad265fba5de75$export$b82d16f27459e05a = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$f;
};
$cddad265fba5de75$export$522c17b4f5e123e8 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$e;
};
$cddad265fba5de75$export$1aabd8a0274ecfd6 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$m;
};
$cddad265fba5de75$export$3d6c20d97e46b957 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$n;
};
$cddad265fba5de75$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cddad265fba5de75$var$d || a === $cddad265fba5de75$var$f || a === $cddad265fba5de75$var$e || a === $cddad265fba5de75$var$m || a === $cddad265fba5de75$var$n || a === $cddad265fba5de75$var$t || "object" === typeof a && null !== a && (a.$$typeof === $cddad265fba5de75$var$q || a.$$typeof === $cddad265fba5de75$var$p || a.$$typeof === $cddad265fba5de75$var$g || a.$$typeof === $cddad265fba5de75$var$h || a.$$typeof === $cddad265fba5de75$var$l || a.$$typeof === $cddad265fba5de75$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$cddad265fba5de75$export$f5bbd400c2f4426f = $cddad265fba5de75$var$v;

});

parcelRegister("19kfS", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $0d6657f4f2c16313$export$2b8d127b894957b9, (v) => $0d6657f4f2c16313$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $0d6657f4f2c16313$export$cea3a54a6425200c, (v) => $0d6657f4f2c16313$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $0d6657f4f2c16313$export$a7c73072b1a182ae, (v) => $0d6657f4f2c16313$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0d6657f4f2c16313$export$9f27bc3417b4524d, (v) => $0d6657f4f2c16313$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0d6657f4f2c16313$export$db77ccec0bb4ccac, (v) => $0d6657f4f2c16313$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0d6657f4f2c16313$export$8392c0c9d3dcbd35, (v) => $0d6657f4f2c16313$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0d6657f4f2c16313$export$ffb0004e005737fa, (v) => $0d6657f4f2c16313$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0d6657f4f2c16313$export$b624eff549462981, (v) => $0d6657f4f2c16313$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0d6657f4f2c16313$export$7897aa7841a5380c, (v) => $0d6657f4f2c16313$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0d6657f4f2c16313$export$602eac185826482c, (v) => $0d6657f4f2c16313$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0d6657f4f2c16313$export$e2c29f18771995cb, (v) => $0d6657f4f2c16313$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0d6657f4f2c16313$export$5f8d39834fd61797, (v) => $0d6657f4f2c16313$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0d6657f4f2c16313$export$74bf444e3cd11ea5, (v) => $0d6657f4f2c16313$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0d6657f4f2c16313$export$92387174baf9b227, (v) => $0d6657f4f2c16313$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0d6657f4f2c16313$export$ec112efeb987d9c6, (v) => $0d6657f4f2c16313$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0d6657f4f2c16313$export$b706b080d889d2c9, (v) => $0d6657f4f2c16313$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0d6657f4f2c16313$export$5be5a87408f70ddc, (v) => $0d6657f4f2c16313$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0d6657f4f2c16313$export$45a5e7f76e0caa8d, (v) => $0d6657f4f2c16313$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0d6657f4f2c16313$export$455c2e768291efa6, (v) => $0d6657f4f2c16313$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0d6657f4f2c16313$export$9522e17588c12572, (v) => $0d6657f4f2c16313$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0d6657f4f2c16313$export$2110ac352bb060b9, (v) => $0d6657f4f2c16313$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0d6657f4f2c16313$export$56885ab8b9c456ab, (v) => $0d6657f4f2c16313$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0d6657f4f2c16313$export$d927fcb6adf8f9de, (v) => $0d6657f4f2c16313$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0d6657f4f2c16313$export$b82d16f27459e05a, (v) => $0d6657f4f2c16313$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0d6657f4f2c16313$export$522c17b4f5e123e8, (v) => $0d6657f4f2c16313$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0d6657f4f2c16313$export$1aabd8a0274ecfd6, (v) => $0d6657f4f2c16313$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $0d6657f4f2c16313$export$9b621391a187a31a, (v) => $0d6657f4f2c16313$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0d6657f4f2c16313$export$f5bbd400c2f4426f, (v) => $0d6657f4f2c16313$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0d6657f4f2c16313$export$2b8d127b894957b9;
var $0d6657f4f2c16313$export$cea3a54a6425200c;
var $0d6657f4f2c16313$export$a7c73072b1a182ae;
var $0d6657f4f2c16313$export$9f27bc3417b4524d;
var $0d6657f4f2c16313$export$db77ccec0bb4ccac;
var $0d6657f4f2c16313$export$8392c0c9d3dcbd35;
var $0d6657f4f2c16313$export$ffb0004e005737fa;
var $0d6657f4f2c16313$export$b624eff549462981;
var $0d6657f4f2c16313$export$7897aa7841a5380c;
var $0d6657f4f2c16313$export$602eac185826482c;
var $0d6657f4f2c16313$export$e2c29f18771995cb;
var $0d6657f4f2c16313$export$5f8d39834fd61797;
var $0d6657f4f2c16313$export$74bf444e3cd11ea5;
var $0d6657f4f2c16313$export$92387174baf9b227;
var $0d6657f4f2c16313$export$ec112efeb987d9c6;
var $0d6657f4f2c16313$export$b706b080d889d2c9;
var $0d6657f4f2c16313$export$5be5a87408f70ddc;
var $0d6657f4f2c16313$export$45a5e7f76e0caa8d;
var $0d6657f4f2c16313$export$455c2e768291efa6;
var $0d6657f4f2c16313$export$9522e17588c12572;
var $0d6657f4f2c16313$export$2110ac352bb060b9;
var $0d6657f4f2c16313$export$56885ab8b9c456ab;
var $0d6657f4f2c16313$export$d927fcb6adf8f9de;
var $0d6657f4f2c16313$export$b82d16f27459e05a;
var $0d6657f4f2c16313$export$522c17b4f5e123e8;
var $0d6657f4f2c16313$export$1aabd8a0274ecfd6;
var $0d6657f4f2c16313$export$9b621391a187a31a;
var $0d6657f4f2c16313$export$f5bbd400c2f4426f;
"use strict";
var $0d6657f4f2c16313$var$b = "function" === typeof Symbol && Symbol.for, $0d6657f4f2c16313$var$c = $0d6657f4f2c16313$var$b ? Symbol.for("react.element") : 60103, $0d6657f4f2c16313$var$d = $0d6657f4f2c16313$var$b ? Symbol.for("react.portal") : 60106, $0d6657f4f2c16313$var$e = $0d6657f4f2c16313$var$b ? Symbol.for("react.fragment") : 60107, $0d6657f4f2c16313$var$f = $0d6657f4f2c16313$var$b ? Symbol.for("react.strict_mode") : 60108, $0d6657f4f2c16313$var$g = $0d6657f4f2c16313$var$b ? Symbol.for("react.profiler") : 60114, $0d6657f4f2c16313$var$h = $0d6657f4f2c16313$var$b ? Symbol.for("react.provider") : 60109, $0d6657f4f2c16313$var$k = $0d6657f4f2c16313$var$b ? Symbol.for("react.context") : 60110, $0d6657f4f2c16313$var$l = $0d6657f4f2c16313$var$b ? Symbol.for("react.async_mode") : 60111, $0d6657f4f2c16313$var$m = $0d6657f4f2c16313$var$b ? Symbol.for("react.concurrent_mode") : 60111, $0d6657f4f2c16313$var$n = $0d6657f4f2c16313$var$b ? Symbol.for("react.forward_ref") : 60112, $0d6657f4f2c16313$var$p = $0d6657f4f2c16313$var$b ? Symbol.for("react.suspense") : 60113, $0d6657f4f2c16313$var$q = $0d6657f4f2c16313$var$b ? Symbol.for("react.suspense_list") : 60120, $0d6657f4f2c16313$var$r = $0d6657f4f2c16313$var$b ? Symbol.for("react.memo") : 60115, $0d6657f4f2c16313$var$t = $0d6657f4f2c16313$var$b ? Symbol.for("react.lazy") : 60116, $0d6657f4f2c16313$var$v = $0d6657f4f2c16313$var$b ? Symbol.for("react.block") : 60121, $0d6657f4f2c16313$var$w = $0d6657f4f2c16313$var$b ? Symbol.for("react.fundamental") : 60117, $0d6657f4f2c16313$var$x = $0d6657f4f2c16313$var$b ? Symbol.for("react.responder") : 60118, $0d6657f4f2c16313$var$y = $0d6657f4f2c16313$var$b ? Symbol.for("react.scope") : 60119;
function $0d6657f4f2c16313$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0d6657f4f2c16313$var$c:
                switch(a = a.type, a){
                    case $0d6657f4f2c16313$var$l:
                    case $0d6657f4f2c16313$var$m:
                    case $0d6657f4f2c16313$var$e:
                    case $0d6657f4f2c16313$var$g:
                    case $0d6657f4f2c16313$var$f:
                    case $0d6657f4f2c16313$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0d6657f4f2c16313$var$k:
                            case $0d6657f4f2c16313$var$n:
                            case $0d6657f4f2c16313$var$t:
                            case $0d6657f4f2c16313$var$r:
                            case $0d6657f4f2c16313$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0d6657f4f2c16313$var$d:
                return u;
        }
    }
}
function $0d6657f4f2c16313$var$A(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$m;
}
$0d6657f4f2c16313$export$2b8d127b894957b9 = $0d6657f4f2c16313$var$l;
$0d6657f4f2c16313$export$cea3a54a6425200c = $0d6657f4f2c16313$var$m;
$0d6657f4f2c16313$export$a7c73072b1a182ae = $0d6657f4f2c16313$var$k;
$0d6657f4f2c16313$export$9f27bc3417b4524d = $0d6657f4f2c16313$var$h;
$0d6657f4f2c16313$export$db77ccec0bb4ccac = $0d6657f4f2c16313$var$c;
$0d6657f4f2c16313$export$8392c0c9d3dcbd35 = $0d6657f4f2c16313$var$n;
$0d6657f4f2c16313$export$ffb0004e005737fa = $0d6657f4f2c16313$var$e;
$0d6657f4f2c16313$export$b624eff549462981 = $0d6657f4f2c16313$var$t;
$0d6657f4f2c16313$export$7897aa7841a5380c = $0d6657f4f2c16313$var$r;
$0d6657f4f2c16313$export$602eac185826482c = $0d6657f4f2c16313$var$d;
$0d6657f4f2c16313$export$e2c29f18771995cb = $0d6657f4f2c16313$var$g;
$0d6657f4f2c16313$export$5f8d39834fd61797 = $0d6657f4f2c16313$var$f;
$0d6657f4f2c16313$export$74bf444e3cd11ea5 = $0d6657f4f2c16313$var$p;
$0d6657f4f2c16313$export$92387174baf9b227 = function(a) {
    return $0d6657f4f2c16313$var$A(a) || $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$l;
};
$0d6657f4f2c16313$export$ec112efeb987d9c6 = $0d6657f4f2c16313$var$A;
$0d6657f4f2c16313$export$b706b080d889d2c9 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$k;
};
$0d6657f4f2c16313$export$5be5a87408f70ddc = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$h;
};
$0d6657f4f2c16313$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0d6657f4f2c16313$var$c;
};
$0d6657f4f2c16313$export$455c2e768291efa6 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$n;
};
$0d6657f4f2c16313$export$9522e17588c12572 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$e;
};
$0d6657f4f2c16313$export$2110ac352bb060b9 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$t;
};
$0d6657f4f2c16313$export$56885ab8b9c456ab = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$r;
};
$0d6657f4f2c16313$export$d927fcb6adf8f9de = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$d;
};
$0d6657f4f2c16313$export$b82d16f27459e05a = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$g;
};
$0d6657f4f2c16313$export$522c17b4f5e123e8 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$f;
};
$0d6657f4f2c16313$export$1aabd8a0274ecfd6 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$p;
};
$0d6657f4f2c16313$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0d6657f4f2c16313$var$e || a === $0d6657f4f2c16313$var$m || a === $0d6657f4f2c16313$var$g || a === $0d6657f4f2c16313$var$f || a === $0d6657f4f2c16313$var$p || a === $0d6657f4f2c16313$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0d6657f4f2c16313$var$t || a.$$typeof === $0d6657f4f2c16313$var$r || a.$$typeof === $0d6657f4f2c16313$var$h || a.$$typeof === $0d6657f4f2c16313$var$k || a.$$typeof === $0d6657f4f2c16313$var$n || a.$$typeof === $0d6657f4f2c16313$var$w || a.$$typeof === $0d6657f4f2c16313$var$x || a.$$typeof === $0d6657f4f2c16313$var$y || a.$$typeof === $0d6657f4f2c16313$var$v);
};
$0d6657f4f2c16313$export$f5bbd400c2f4426f = $0d6657f4f2c16313$var$z;

});

parcelRegister("g3kzz", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8wLPD = parcelRequire("8wLPD");

var $74Pwa = parcelRequire("74Pwa");

var $7ks5V = parcelRequire("7ks5V");

var $3VxWR = parcelRequire("3VxWR");

var $aNeZ1 = parcelRequire("aNeZ1");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $bafce274314455aa$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $bafce274314455aa$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $8wLPD.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $8wLPD.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $7ks5V.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $8wLPD.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$aNeZ1.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $8wLPD.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $7ks5V.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $7ks5V.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $74Pwa.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($bafce274314455aa$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($bafce274314455aa$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $3VxWR.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $3VxWR.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $7ks5V.wipe(tag);
        $7ks5V.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $bafce274314455aa$var$ChaCha20Poly1305;

});
parcelRegister("8wLPD", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VxWR = parcelRequire("3VxWR");

var $7ks5V = parcelRequire("7ks5V");
// Number of ChaCha rounds (ChaCha20).
var $019a2b014bd38688$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $019a2b014bd38688$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $019a2b014bd38688$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $3VxWR.writeUint32LE(x0 + j0 | 0, out, 0);
    $3VxWR.writeUint32LE(x1 + j1 | 0, out, 4);
    $3VxWR.writeUint32LE(x2 + j2 | 0, out, 8);
    $3VxWR.writeUint32LE(x3 + j3 | 0, out, 12);
    $3VxWR.writeUint32LE(x4 + j4 | 0, out, 16);
    $3VxWR.writeUint32LE(x5 + j5 | 0, out, 20);
    $3VxWR.writeUint32LE(x6 + j6 | 0, out, 24);
    $3VxWR.writeUint32LE(x7 + j7 | 0, out, 28);
    $3VxWR.writeUint32LE(x8 + j8 | 0, out, 32);
    $3VxWR.writeUint32LE(x9 + j9 | 0, out, 36);
    $3VxWR.writeUint32LE(x10 + j10 | 0, out, 40);
    $3VxWR.writeUint32LE(x11 + j11 | 0, out, 44);
    $3VxWR.writeUint32LE(x12 + j12 | 0, out, 48);
    $3VxWR.writeUint32LE(x13 + j13 | 0, out, 52);
    $3VxWR.writeUint32LE(x14 + j14 | 0, out, 56);
    $3VxWR.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $019a2b014bd38688$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $019a2b014bd38688$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $019a2b014bd38688$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $7ks5V.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $7ks5V.wipe(nc);
    return dst;
}
module.exports.streamXOR = $019a2b014bd38688$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $019a2b014bd38688$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $7ks5V.wipe(dst);
    return $019a2b014bd38688$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $019a2b014bd38688$var$stream;
function $019a2b014bd38688$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});
parcelRegister("3VxWR", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ZQ2l = parcelRequire("5ZQ2l");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $2dc1076404020884$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $2dc1076404020884$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $2dc1076404020884$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $2dc1076404020884$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $2dc1076404020884$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $2dc1076404020884$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $2dc1076404020884$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $2dc1076404020884$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $2dc1076404020884$var$writeUint16BE;
module.exports.writeInt16BE = $2dc1076404020884$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $2dc1076404020884$var$writeUint16LE;
module.exports.writeInt16LE = $2dc1076404020884$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $2dc1076404020884$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $2dc1076404020884$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $2dc1076404020884$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $2dc1076404020884$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $2dc1076404020884$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $2dc1076404020884$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $2dc1076404020884$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $2dc1076404020884$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $2dc1076404020884$var$writeUint32BE;
module.exports.writeInt32BE = $2dc1076404020884$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $2dc1076404020884$var$writeUint32LE;
module.exports.writeInt32LE = $2dc1076404020884$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $2dc1076404020884$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $2dc1076404020884$var$readInt32BE(array, offset);
    var lo = $2dc1076404020884$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $2dc1076404020884$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $2dc1076404020884$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $2dc1076404020884$var$readUint32BE(array, offset);
    var lo = $2dc1076404020884$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $2dc1076404020884$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $2dc1076404020884$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $2dc1076404020884$var$readInt32LE(array, offset);
    var hi = $2dc1076404020884$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $2dc1076404020884$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $2dc1076404020884$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $2dc1076404020884$var$readUint32LE(array, offset);
    var hi = $2dc1076404020884$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $2dc1076404020884$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $2dc1076404020884$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $2dc1076404020884$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $2dc1076404020884$var$writeUint64BE;
module.exports.writeInt64BE = $2dc1076404020884$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $2dc1076404020884$var$writeUint32LE(value >>> 0, out, offset);
    $2dc1076404020884$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $2dc1076404020884$var$writeUint64LE;
module.exports.writeInt64LE = $2dc1076404020884$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $2dc1076404020884$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $2dc1076404020884$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $2dc1076404020884$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $2dc1076404020884$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$5ZQ2l.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $2dc1076404020884$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$5ZQ2l.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $2dc1076404020884$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $2dc1076404020884$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $2dc1076404020884$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $2dc1076404020884$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $2dc1076404020884$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $2dc1076404020884$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $2dc1076404020884$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $2dc1076404020884$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $2dc1076404020884$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $2dc1076404020884$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $2dc1076404020884$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $2dc1076404020884$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $2dc1076404020884$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $2dc1076404020884$var$writeFloat64LE;

});
parcelRegister("5ZQ2l", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $45db03a9c4d6b0cf$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $45db03a9c4d6b0cf$var$imulShim;
/** 32-bit integer addition.  */ function $45db03a9c4d6b0cf$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $45db03a9c4d6b0cf$var$add;
/**  32-bit integer subtraction.  */ function $45db03a9c4d6b0cf$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $45db03a9c4d6b0cf$var$sub;
/** 32-bit integer left rotation */ function $45db03a9c4d6b0cf$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $45db03a9c4d6b0cf$var$rotl;
/** 32-bit integer left rotation */ function $45db03a9c4d6b0cf$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $45db03a9c4d6b0cf$var$rotr;
function $45db03a9c4d6b0cf$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $45db03a9c4d6b0cf$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});


parcelRegister("7ks5V", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $556031a90c0368c4$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $556031a90c0368c4$var$wipe;

});


parcelRegister("74Pwa", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aNeZ1 = parcelRequire("aNeZ1");

var $7ks5V = parcelRequire("7ks5V");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $5270de8354bd8fae$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $7ks5V.wipe(this._buffer);
        $7ks5V.wipe(this._r);
        $7ks5V.wipe(this._h);
        $7ks5V.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $5270de8354bd8fae$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $5270de8354bd8fae$var$oneTimeAuth(key, data) {
    var h = new $5270de8354bd8fae$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $5270de8354bd8fae$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $5270de8354bd8fae$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $aNeZ1.equal(a, b);
}
module.exports.equal = $5270de8354bd8fae$var$equal;

});
parcelRegister("aNeZ1", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $7dba1a56442af4e7$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $7dba1a56442af4e7$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $7dba1a56442af4e7$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $7dba1a56442af4e7$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $7dba1a56442af4e7$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $7dba1a56442af4e7$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $7dba1a56442af4e7$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $7dba1a56442af4e7$var$compare(a, b) !== 0;
}
module.exports.equal = $7dba1a56442af4e7$var$equal;

});



parcelRegister("bwGWz", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j2QHW = parcelRequire("j2QHW");

var $7ks5V = parcelRequire("7ks5V");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $8643fe95c074c6b7$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $j2QHW.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $j2QHW.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $7ks5V.wipe(this._buffer);
        $7ks5V.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $8643fe95c074c6b7$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRegister("j2QHW", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8yHQ6 = parcelRequire("8yHQ6");

var $aNeZ1 = parcelRequire("aNeZ1");

var $7ks5V = parcelRequire("7ks5V");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $ddd716e2acdb9d7c$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($8yHQ6.isSerializableHash(this._inner) && $8yHQ6.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $7ks5V.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$8yHQ6.isSerializableHash(this._inner) || !$8yHQ6.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($8yHQ6.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($8yHQ6.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$8yHQ6.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$8yHQ6.isSerializableHash(this._inner) || !$8yHQ6.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$8yHQ6.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $ddd716e2acdb9d7c$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $ddd716e2acdb9d7c$var$hmac(hash, key, data) {
    var h = new $ddd716e2acdb9d7c$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $ddd716e2acdb9d7c$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $aNeZ1.equal;

});
parcelRegister("8yHQ6", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $63b3814af7a7f98a$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $63b3814af7a7f98a$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});



parcelRegister("lYmee", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $5X7Nh = parcelRequire("5X7Nh");

var $3VxWR = parcelRequire("3VxWR");

var $7ks5V = parcelRequire("7ks5V");
module.exports.defaultRandomSource = new $5X7Nh.SystemRandomSource();
function $fff071b80d607016$var$randomBytes(length, prng = module.exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
module.exports.randomBytes = $fff071b80d607016$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $fff071b80d607016$var$randomUint32(prng = module.exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $fff071b80d607016$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $3VxWR.readUint32LE)(buf);
    // Clean the buffer.
    (0, $7ks5V.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $fff071b80d607016$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $fff071b80d607016$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $fff071b80d607016$var$randomString(length, charset = $fff071b80d607016$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $fff071b80d607016$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $7ks5V.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $fff071b80d607016$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $fff071b80d607016$var$randomStringForEntropy(bits, charset = $fff071b80d607016$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $fff071b80d607016$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $fff071b80d607016$var$randomStringForEntropy;

});
parcelRegister("5X7Nh", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $iRgeM = parcelRequire("iRgeM");

var $hQny8 = parcelRequire("hQny8");
class $45588222f8532570$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $iRgeM.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $hQny8.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
module.exports.SystemRandomSource = $45588222f8532570$var$SystemRandomSource;

});
parcelRegister("iRgeM", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
const $dba9c5a3da319426$var$QUOTA = 65536;
class $dba9c5a3da319426$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $dba9c5a3da319426$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $dba9c5a3da319426$var$QUOTA)));
        return out;
    }
}
module.exports.BrowserRandomSource = $dba9c5a3da319426$var$BrowserRandomSource;

});

parcelRegister("hQny8", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $7ks5V = parcelRequire("7ks5V");

class $cfd98f75ac7da5a0$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("ejAqS"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $7ks5V.wipe)(buffer);
        return out;
    }
}
module.exports.NodeRandomSource = $cfd98f75ac7da5a0$var$NodeRandomSource;

});
parcelRegister("ejAqS", function(module, exports) {
"use strict";

});




parcelRegister("5GkW9", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VxWR = parcelRequire("3VxWR");

var $7ks5V = parcelRequire("7ks5V");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $42311d9fff48f46b$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $7ks5V.wipe(this._buffer);
        $7ks5V.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $42311d9fff48f46b$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $42311d9fff48f46b$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $3VxWR.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $3VxWR.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $42311d9fff48f46b$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$3VxWR.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $7ks5V.wipe(savedState.state);
        if (savedState.buffer) $7ks5V.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $42311d9fff48f46b$var$SHA256;
// Constants
var $42311d9fff48f46b$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $42311d9fff48f46b$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $3VxWR.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($42311d9fff48f46b$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $42311d9fff48f46b$var$hash(data) {
    var h = new $42311d9fff48f46b$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $42311d9fff48f46b$var$hash;

});

parcelRegister("89Tbs", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $lYmee = parcelRequire("lYmee");

var $7ks5V = parcelRequire("7ks5V");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $5f09f85e154aea85$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $5f09f85e154aea85$var$_9 = new Uint8Array(32);
$5f09f85e154aea85$var$_9[0] = 9;
const $5f09f85e154aea85$var$_121665 = $5f09f85e154aea85$var$gf([
    0xdb41,
    1
]);
function $5f09f85e154aea85$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $5f09f85e154aea85$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $5f09f85e154aea85$var$pack25519(o, n) {
    const m = $5f09f85e154aea85$var$gf();
    const t = $5f09f85e154aea85$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $5f09f85e154aea85$var$car25519(t);
    $5f09f85e154aea85$var$car25519(t);
    $5f09f85e154aea85$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $5f09f85e154aea85$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $5f09f85e154aea85$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $5f09f85e154aea85$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $5f09f85e154aea85$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $5f09f85e154aea85$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $5f09f85e154aea85$var$square(o, a) {
    $5f09f85e154aea85$var$mul(o, a, a);
}
function $5f09f85e154aea85$var$inv25519(o, inp) {
    const c = $5f09f85e154aea85$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $5f09f85e154aea85$var$square(c, c);
        if (i !== 2 && i !== 4) $5f09f85e154aea85$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $5f09f85e154aea85$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $5f09f85e154aea85$var$gf(), b = $5f09f85e154aea85$var$gf(), c = $5f09f85e154aea85$var$gf(), d = $5f09f85e154aea85$var$gf(), e = $5f09f85e154aea85$var$gf(), f = $5f09f85e154aea85$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $5f09f85e154aea85$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $5f09f85e154aea85$var$sel25519(a, b, r);
        $5f09f85e154aea85$var$sel25519(c, d, r);
        $5f09f85e154aea85$var$add(e, a, c);
        $5f09f85e154aea85$var$sub(a, a, c);
        $5f09f85e154aea85$var$add(c, b, d);
        $5f09f85e154aea85$var$sub(b, b, d);
        $5f09f85e154aea85$var$square(d, e);
        $5f09f85e154aea85$var$square(f, a);
        $5f09f85e154aea85$var$mul(a, c, a);
        $5f09f85e154aea85$var$mul(c, b, e);
        $5f09f85e154aea85$var$add(e, a, c);
        $5f09f85e154aea85$var$sub(a, a, c);
        $5f09f85e154aea85$var$square(b, a);
        $5f09f85e154aea85$var$sub(c, d, f);
        $5f09f85e154aea85$var$mul(a, c, $5f09f85e154aea85$var$_121665);
        $5f09f85e154aea85$var$add(a, a, d);
        $5f09f85e154aea85$var$mul(c, c, a);
        $5f09f85e154aea85$var$mul(a, d, f);
        $5f09f85e154aea85$var$mul(d, b, x);
        $5f09f85e154aea85$var$square(b, e);
        $5f09f85e154aea85$var$sel25519(a, b, r);
        $5f09f85e154aea85$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $5f09f85e154aea85$var$inv25519(x32, x32);
    $5f09f85e154aea85$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $5f09f85e154aea85$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $5f09f85e154aea85$var$scalarMult;
function $5f09f85e154aea85$var$scalarMultBase(n) {
    return $5f09f85e154aea85$var$scalarMult(n, $5f09f85e154aea85$var$_9);
}
module.exports.scalarMultBase = $5f09f85e154aea85$var$scalarMultBase;
function $5f09f85e154aea85$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $5f09f85e154aea85$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $5f09f85e154aea85$var$generateKeyPairFromSeed;
function $5f09f85e154aea85$var$generateKeyPair(prng) {
    const seed = (0, $lYmee.randomBytes)(32, prng);
    const result = $5f09f85e154aea85$var$generateKeyPairFromSeed(seed);
    (0, $7ks5V.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $5f09f85e154aea85$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $5f09f85e154aea85$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $5f09f85e154aea85$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $5f09f85e154aea85$var$sharedKey;

});

parcelRegister("k1mEp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cDjIQ = parcelRequire("cDjIQ");

var $3ly94 = parcelRequire("3ly94");

var $6cbmM = parcelRequire("6cbmM");

var $1Rhyp = parcelRequire("1Rhyp");

var $ez3MJ = parcelRequire("ez3MJ");

var $83mmv = parcelRequire("83mmv");
module.exports.compare = $cDjIQ.compare;
module.exports.concat = $3ly94.concat;
module.exports.equals = $6cbmM.equals;
module.exports.fromString = $1Rhyp.fromString;
module.exports.toString = $ez3MJ.toString;
module.exports.xor = $83mmv.xor;

});
parcelRegister("cDjIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $93286cfccc2f5f12$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
module.exports.compare = $93286cfccc2f5f12$var$compare;

});

parcelRegister("3ly94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fZqbm = parcelRequire("fZqbm");

var $bdjTx = parcelRequire("bdjTx");
function $26fdd1d07f3ba5a2$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $fZqbm.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $bdjTx.asUint8Array(output);
}
module.exports.concat = $26fdd1d07f3ba5a2$var$concat;

});
parcelRegister("fZqbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bdjTx = parcelRequire("bdjTx");
function $ba40dcc013561ed2$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $bdjTx.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $ba40dcc013561ed2$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $bdjTx.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
module.exports.alloc = $ba40dcc013561ed2$var$alloc;
module.exports.allocUnsafe = $ba40dcc013561ed2$var$allocUnsafe;

});
parcelRegister("bdjTx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $82a057456fa334c5$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
module.exports.asUint8Array = $82a057456fa334c5$var$asUint8Array;

});



parcelRegister("6cbmM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $482cae39c53b6738$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.equals = $482cae39c53b6738$var$equals;

});

parcelRegister("1Rhyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2XJKU = parcelRequire("2XJKU");

var $bdjTx = parcelRequire("bdjTx");
function $15a85b8f18e84af8$var$fromString(string, encoding = "utf8") {
    const base = $2XJKU[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $bdjTx.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports.fromString = $15a85b8f18e84af8$var$fromString;

});
parcelRegister("2XJKU", function(module, exports) {
"use strict";

var $4tv9y = parcelRequire("4tv9y");

var $fZqbm = parcelRequire("fZqbm");
function $22849596bee10d36$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $22849596bee10d36$var$string = $22849596bee10d36$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $22849596bee10d36$var$ascii = $22849596bee10d36$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $fZqbm.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $22849596bee10d36$var$BASES = {
    utf8: $22849596bee10d36$var$string,
    "utf-8": $22849596bee10d36$var$string,
    hex: $4tv9y.bases.base16,
    latin1: $22849596bee10d36$var$ascii,
    ascii: $22849596bee10d36$var$ascii,
    binary: $22849596bee10d36$var$ascii,
    ...$4tv9y.bases
};
module.exports = $22849596bee10d36$var$BASES;

});
parcelRegister("4tv9y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8thNv = parcelRequire("8thNv");

var $2RBgp = parcelRequire("2RBgp");

var $8dDHj = parcelRequire("8dDHj");

var $kFkNa = parcelRequire("kFkNa");

var $4sYAb = parcelRequire("4sYAb");

var $lrFUP = parcelRequire("lrFUP");

var $hQzaT = parcelRequire("hQzaT");

var $iRFx0 = parcelRequire("iRFx0");

var $hd4QZ = parcelRequire("hd4QZ");

var $5sb5Z = parcelRequire("5sb5Z");

var $h90mn = parcelRequire("h90mn");

var $6N0YZ = parcelRequire("6N0YZ");

var $94duQ = parcelRequire("94duQ");

var $13Uug = parcelRequire("13Uug");
parcelRequire("3Wivz");

var $hHJff = parcelRequire("hHJff");

var $i2wY7 = parcelRequire("i2wY7");

var $92UzB = parcelRequire("92UzB");

var $4n0vz = parcelRequire("4n0vz");

var $j1ICP = parcelRequire("j1ICP");
const $342209364c8e8763$var$bases = {
    ...$8thNv,
    ...$2RBgp,
    ...$8dDHj,
    ...$kFkNa,
    ...$4sYAb,
    ...$lrFUP,
    ...$hQzaT,
    ...$iRFx0,
    ...$hd4QZ,
    ...$5sb5Z
};
const $342209364c8e8763$var$hashes = {
    ...$h90mn,
    ...$6N0YZ
};
const $342209364c8e8763$var$codecs = {
    raw: $94duQ,
    json: $13Uug
};
module.exports.CID = $hHJff.CID;
module.exports.hasher = $i2wY7;
module.exports.digest = $92UzB;
module.exports.varint = $4n0vz;
module.exports.bytes = $j1ICP;
module.exports.bases = $342209364c8e8763$var$bases;
module.exports.codecs = $342209364c8e8763$var$codecs;
module.exports.hashes = $342209364c8e8763$var$hashes;

});
parcelRegister("8thNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");

var $j1ICP = parcelRequire("j1ICP");
const $62aed65c609ab2f7$var$identity = $bM0fm.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$j1ICP.toString(buf),
    decode: (str)=>$j1ICP.fromString(str)
});
module.exports.identity = $62aed65c609ab2f7$var$identity;

});
parcelRegister("bM0fm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cVxxo = parcelRequire("cVxxo");

var $j1ICP = parcelRequire("j1ICP");
class $89245e6c515d2649$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $89245e6c515d2649$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $89245e6c515d2649$var$or(this, decoder);
    }
}
class $89245e6c515d2649$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $89245e6c515d2649$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $89245e6c515d2649$var$or = (left, right)=>new $89245e6c515d2649$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $89245e6c515d2649$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $89245e6c515d2649$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $89245e6c515d2649$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $89245e6c515d2649$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $89245e6c515d2649$var$Codec(name, prefix, encode, decode);
const $89245e6c515d2649$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $cVxxo(alphabet, name);
    return $89245e6c515d2649$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$j1ICP.coerce(decode(text))
    });
};
const $89245e6c515d2649$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $89245e6c515d2649$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $89245e6c515d2649$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $89245e6c515d2649$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $89245e6c515d2649$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $89245e6c515d2649$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $89245e6c515d2649$var$Codec;
module.exports.baseX = $89245e6c515d2649$var$baseX;
module.exports.from = $89245e6c515d2649$var$from;
module.exports.or = $89245e6c515d2649$var$or;
module.exports.rfc4648 = $89245e6c515d2649$var$rfc4648;

});
parcelRegister("cVxxo", function(module, exports) {
"use strict";
function $9694d2c482d29a32$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $9694d2c482d29a32$var$src = $9694d2c482d29a32$var$base;
var $9694d2c482d29a32$var$_brrp__multiformats_scope_baseX = $9694d2c482d29a32$var$src;
module.exports = $9694d2c482d29a32$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("j1ICP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $dda0b9f519365c98$var$empty = new Uint8Array(0);
const $dda0b9f519365c98$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $dda0b9f519365c98$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $dda0b9f519365c98$var$empty;
};
const $dda0b9f519365c98$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $dda0b9f519365c98$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $dda0b9f519365c98$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $dda0b9f519365c98$var$fromString = (str)=>new TextEncoder().encode(str);
const $dda0b9f519365c98$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $dda0b9f519365c98$var$coerce;
module.exports.empty = $dda0b9f519365c98$var$empty;
module.exports.equals = $dda0b9f519365c98$var$equals;
module.exports.fromHex = $dda0b9f519365c98$var$fromHex;
module.exports.fromString = $dda0b9f519365c98$var$fromString;
module.exports.isBinary = $dda0b9f519365c98$var$isBinary;
module.exports.toHex = $dda0b9f519365c98$var$toHex;
module.exports.toString = $dda0b9f519365c98$var$toString;

});



parcelRegister("2RBgp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $215d6fc5b91abd67$var$base2 = $bM0fm.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
module.exports.base2 = $215d6fc5b91abd67$var$base2;

});

parcelRegister("8dDHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $5fbe54c0179ec444$var$base8 = $bM0fm.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
module.exports.base8 = $5fbe54c0179ec444$var$base8;

});

parcelRegister("kFkNa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $f0b7c3dbddfdb118$var$base10 = $bM0fm.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
module.exports.base10 = $f0b7c3dbddfdb118$var$base10;

});

parcelRegister("4sYAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $3408c56588495478$var$base16 = $bM0fm.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $3408c56588495478$var$base16upper = $bM0fm.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
module.exports.base16 = $3408c56588495478$var$base16;
module.exports.base16upper = $3408c56588495478$var$base16upper;

});

parcelRegister("lrFUP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $f9cca229cd2d8ede$var$base32 = $bM0fm.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32upper = $bM0fm.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32pad = $bM0fm.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32padupper = $bM0fm.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32hex = $bM0fm.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32hexupper = $bM0fm.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32hexpad = $bM0fm.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32hexpadupper = $bM0fm.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $f9cca229cd2d8ede$var$base32z = $bM0fm.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
module.exports.base32 = $f9cca229cd2d8ede$var$base32;
module.exports.base32hex = $f9cca229cd2d8ede$var$base32hex;
module.exports.base32hexpad = $f9cca229cd2d8ede$var$base32hexpad;
module.exports.base32hexpadupper = $f9cca229cd2d8ede$var$base32hexpadupper;
module.exports.base32hexupper = $f9cca229cd2d8ede$var$base32hexupper;
module.exports.base32pad = $f9cca229cd2d8ede$var$base32pad;
module.exports.base32padupper = $f9cca229cd2d8ede$var$base32padupper;
module.exports.base32upper = $f9cca229cd2d8ede$var$base32upper;
module.exports.base32z = $f9cca229cd2d8ede$var$base32z;

});

parcelRegister("hQzaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $cfe293fab448cebb$var$base36 = $bM0fm.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $cfe293fab448cebb$var$base36upper = $bM0fm.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
module.exports.base36 = $cfe293fab448cebb$var$base36;
module.exports.base36upper = $cfe293fab448cebb$var$base36upper;

});

parcelRegister("iRFx0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $dbbd648056a585d4$var$base58btc = $bM0fm.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $dbbd648056a585d4$var$base58flickr = $bM0fm.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
module.exports.base58btc = $dbbd648056a585d4$var$base58btc;
module.exports.base58flickr = $dbbd648056a585d4$var$base58flickr;

});

parcelRegister("hd4QZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $c8776a633b2dd8fd$var$base64 = $bM0fm.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $c8776a633b2dd8fd$var$base64pad = $bM0fm.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $c8776a633b2dd8fd$var$base64url = $bM0fm.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $c8776a633b2dd8fd$var$base64urlpad = $bM0fm.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
module.exports.base64 = $c8776a633b2dd8fd$var$base64;
module.exports.base64pad = $c8776a633b2dd8fd$var$base64pad;
module.exports.base64url = $c8776a633b2dd8fd$var$base64url;
module.exports.base64urlpad = $c8776a633b2dd8fd$var$base64urlpad;

});

parcelRegister("5sb5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bM0fm = parcelRequire("bM0fm");
const $3f882c9c25f95bfc$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $3f882c9c25f95bfc$var$alphabetBytesToChars = $3f882c9c25f95bfc$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $3f882c9c25f95bfc$var$alphabetCharsToBytes = $3f882c9c25f95bfc$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $3f882c9c25f95bfc$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $3f882c9c25f95bfc$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $3f882c9c25f95bfc$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $3f882c9c25f95bfc$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $3f882c9c25f95bfc$var$base256emoji = $bM0fm.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $3f882c9c25f95bfc$var$encode,
    decode: $3f882c9c25f95bfc$var$decode
});
module.exports.base256emoji = $3f882c9c25f95bfc$var$base256emoji;

});

parcelRegister("h90mn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i2wY7 = parcelRequire("i2wY7");
const $c7b38e6957db9eb7$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $c7b38e6957db9eb7$var$sha256 = $i2wY7.from({
    name: "sha2-256",
    code: 18,
    encode: $c7b38e6957db9eb7$var$sha("SHA-256")
});
const $c7b38e6957db9eb7$var$sha512 = $i2wY7.from({
    name: "sha2-512",
    code: 19,
    encode: $c7b38e6957db9eb7$var$sha("SHA-512")
});
module.exports.sha256 = $c7b38e6957db9eb7$var$sha256;
module.exports.sha512 = $c7b38e6957db9eb7$var$sha512;

});
parcelRegister("i2wY7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $92UzB = parcelRequire("92UzB");
const $d221fcce80b77649$var$from = ({ name: name, code: code, encode: encode })=>new $d221fcce80b77649$var$Hasher(name, code, encode);
class $d221fcce80b77649$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $92UzB.create(this.code, result) : result.then((digest$1)=>$92UzB.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
module.exports.Hasher = $d221fcce80b77649$var$Hasher;
module.exports.from = $d221fcce80b77649$var$from;

});
parcelRegister("92UzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j1ICP = parcelRequire("j1ICP");

var $4n0vz = parcelRequire("4n0vz");
const $69602f380081ab1c$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $4n0vz.encodingLength(code);
    const digestOffset = sizeOffset + $4n0vz.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $4n0vz.encodeTo(code, bytes, 0);
    $4n0vz.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $69602f380081ab1c$var$Digest(code, size, digest, bytes);
};
const $69602f380081ab1c$var$decode = (multihash)=>{
    const bytes$1 = $j1ICP.coerce(multihash);
    const [code, sizeOffset] = $4n0vz.decode(bytes$1);
    const [size, digestOffset] = $4n0vz.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $69602f380081ab1c$var$Digest(code, size, digest, bytes$1);
};
const $69602f380081ab1c$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $j1ICP.equals(a.bytes, b.bytes);
};
class $69602f380081ab1c$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
module.exports.Digest = $69602f380081ab1c$var$Digest;
module.exports.create = $69602f380081ab1c$var$create;
module.exports.decode = $69602f380081ab1c$var$decode;
module.exports.equals = $69602f380081ab1c$var$equals;

});
parcelRegister("4n0vz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cHc8V = parcelRequire("cHc8V");
const $32e9b44e7172e3a8$var$decode = (data, offset = 0)=>{
    const code = $cHc8V.decode(data, offset);
    return [
        code,
        $cHc8V.decode.bytes
    ];
};
const $32e9b44e7172e3a8$var$encodeTo = (int, target, offset = 0)=>{
    $cHc8V.encode(int, target, offset);
    return target;
};
const $32e9b44e7172e3a8$var$encodingLength = (int)=>{
    return $cHc8V.encodingLength(int);
};
module.exports.decode = $32e9b44e7172e3a8$var$decode;
module.exports.encodeTo = $32e9b44e7172e3a8$var$encodeTo;
module.exports.encodingLength = $32e9b44e7172e3a8$var$encodingLength;

});
parcelRegister("cHc8V", function(module, exports) {
"use strict";
var $93e2eb840a437cda$var$encode_1 = $93e2eb840a437cda$var$encode;
var $93e2eb840a437cda$var$MSB = 128, $93e2eb840a437cda$var$REST = 127, $93e2eb840a437cda$var$MSBALL = ~$93e2eb840a437cda$var$REST, $93e2eb840a437cda$var$INT = Math.pow(2, 31);
function $93e2eb840a437cda$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $93e2eb840a437cda$var$INT){
        out[offset++] = num & 255 | $93e2eb840a437cda$var$MSB;
        num /= 128;
    }
    while(num & $93e2eb840a437cda$var$MSBALL){
        out[offset++] = num & 255 | $93e2eb840a437cda$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $93e2eb840a437cda$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $93e2eb840a437cda$var$decode = $93e2eb840a437cda$var$read;
var $93e2eb840a437cda$var$MSB$1 = 128, $93e2eb840a437cda$var$REST$1 = 127;
function $93e2eb840a437cda$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $93e2eb840a437cda$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $93e2eb840a437cda$var$REST$1) << shift : (b & $93e2eb840a437cda$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $93e2eb840a437cda$var$MSB$1);
    $93e2eb840a437cda$var$read.bytes = counter - offset;
    return res;
}
var $93e2eb840a437cda$var$N1 = Math.pow(2, 7);
var $93e2eb840a437cda$var$N2 = Math.pow(2, 14);
var $93e2eb840a437cda$var$N3 = Math.pow(2, 21);
var $93e2eb840a437cda$var$N4 = Math.pow(2, 28);
var $93e2eb840a437cda$var$N5 = Math.pow(2, 35);
var $93e2eb840a437cda$var$N6 = Math.pow(2, 42);
var $93e2eb840a437cda$var$N7 = Math.pow(2, 49);
var $93e2eb840a437cda$var$N8 = Math.pow(2, 56);
var $93e2eb840a437cda$var$N9 = Math.pow(2, 63);
var $93e2eb840a437cda$var$length = function(value) {
    return value < $93e2eb840a437cda$var$N1 ? 1 : value < $93e2eb840a437cda$var$N2 ? 2 : value < $93e2eb840a437cda$var$N3 ? 3 : value < $93e2eb840a437cda$var$N4 ? 4 : value < $93e2eb840a437cda$var$N5 ? 5 : value < $93e2eb840a437cda$var$N6 ? 6 : value < $93e2eb840a437cda$var$N7 ? 7 : value < $93e2eb840a437cda$var$N8 ? 8 : value < $93e2eb840a437cda$var$N9 ? 9 : 10;
};
var $93e2eb840a437cda$var$varint = {
    encode: $93e2eb840a437cda$var$encode_1,
    decode: $93e2eb840a437cda$var$decode,
    encodingLength: $93e2eb840a437cda$var$length
};
var $93e2eb840a437cda$var$_brrp_varint = $93e2eb840a437cda$var$varint;
var $93e2eb840a437cda$var$varint$1 = $93e2eb840a437cda$var$_brrp_varint;
module.exports = $93e2eb840a437cda$var$varint$1;

});





parcelRegister("6N0YZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j1ICP = parcelRequire("j1ICP");

var $92UzB = parcelRequire("92UzB");
const $4f1814d39d574c55$var$code = 0;
const $4f1814d39d574c55$var$name = "identity";
const $4f1814d39d574c55$var$encode = $j1ICP.coerce;
const $4f1814d39d574c55$var$digest = (input)=>$92UzB.create($4f1814d39d574c55$var$code, $4f1814d39d574c55$var$encode(input));
const $4f1814d39d574c55$var$identity = {
    code: $4f1814d39d574c55$var$code,
    name: $4f1814d39d574c55$var$name,
    encode: $4f1814d39d574c55$var$encode,
    digest: $4f1814d39d574c55$var$digest
};
module.exports.identity = $4f1814d39d574c55$var$identity;

});

parcelRegister("94duQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j1ICP = parcelRequire("j1ICP");
const $699ef4e0bffd235f$var$name = "raw";
const $699ef4e0bffd235f$var$code = 85;
const $699ef4e0bffd235f$var$encode = (node)=>$j1ICP.coerce(node);
const $699ef4e0bffd235f$var$decode = (data)=>$j1ICP.coerce(data);
module.exports.code = $699ef4e0bffd235f$var$code;
module.exports.decode = $699ef4e0bffd235f$var$decode;
module.exports.encode = $699ef4e0bffd235f$var$encode;
module.exports.name = $699ef4e0bffd235f$var$name;

});

parcelRegister("13Uug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0c61e36a58ecefb2$var$textEncoder = new TextEncoder();
const $0c61e36a58ecefb2$var$textDecoder = new TextDecoder();
const $0c61e36a58ecefb2$var$name = "json";
const $0c61e36a58ecefb2$var$code = 512;
const $0c61e36a58ecefb2$var$encode = (node)=>$0c61e36a58ecefb2$var$textEncoder.encode(JSON.stringify(node));
const $0c61e36a58ecefb2$var$decode = (data)=>JSON.parse($0c61e36a58ecefb2$var$textDecoder.decode(data));
module.exports.code = $0c61e36a58ecefb2$var$code;
module.exports.decode = $0c61e36a58ecefb2$var$decode;
module.exports.encode = $0c61e36a58ecefb2$var$encode;
module.exports.name = $0c61e36a58ecefb2$var$name;

});

parcelRegister("3Wivz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hHJff = parcelRequire("hHJff");

var $4n0vz = parcelRequire("4n0vz");

var $j1ICP = parcelRequire("j1ICP");

var $i2wY7 = parcelRequire("i2wY7");

var $92UzB = parcelRequire("92UzB");
module.exports.CID = $hHJff.CID;
module.exports.varint = $4n0vz;
module.exports.bytes = $j1ICP;
module.exports.hasher = $i2wY7;
module.exports.digest = $92UzB;

});
parcelRegister("hHJff", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4n0vz = parcelRequire("4n0vz");

var $92UzB = parcelRequire("92UzB");

var $iRFx0 = parcelRequire("iRFx0");

var $lrFUP = parcelRequire("lrFUP");

var $j1ICP = parcelRequire("j1ICP");
class $ce398c8bd6eb7a13$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $ce398c8bd6eb7a13$var$hidden,
            byteLength: $ce398c8bd6eb7a13$var$hidden,
            code: $ce398c8bd6eb7a13$var$readonly,
            version: $ce398c8bd6eb7a13$var$readonly,
            multihash: $ce398c8bd6eb7a13$var$readonly,
            bytes: $ce398c8bd6eb7a13$var$readonly,
            _baseCache: $ce398c8bd6eb7a13$var$hidden,
            asCID: $ce398c8bd6eb7a13$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $ce398c8bd6eb7a13$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $ce398c8bd6eb7a13$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $ce398c8bd6eb7a13$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $92UzB.create(code, digest$1);
                    return $ce398c8bd6eb7a13$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $92UzB.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $ce398c8bd6eb7a13$var$toStringV0(bytes, _baseCache, base || $iRFx0.base58btc.encoder);
            default:
                return $ce398c8bd6eb7a13$var$toStringV1(bytes, _baseCache, base || $lrFUP.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $ce398c8bd6eb7a13$var$deprecate(/^0\.0/, $ce398c8bd6eb7a13$var$IS_CID_DEPRECATION);
        return !!(value && (value[$ce398c8bd6eb7a13$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $ce398c8bd6eb7a13$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $ce398c8bd6eb7a13$var$CID(version, code, multihash, bytes || $ce398c8bd6eb7a13$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$ce398c8bd6eb7a13$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $92UzB.decode(multihash);
            return $ce398c8bd6eb7a13$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $ce398c8bd6eb7a13$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$ce398c8bd6eb7a13$var$DAG_PB_CODE}) block encoding`);
                else return new $ce398c8bd6eb7a13$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $ce398c8bd6eb7a13$var$encodeCID(version, code, digest.bytes);
                    return new $ce398c8bd6eb7a13$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $ce398c8bd6eb7a13$var$CID.create(0, $ce398c8bd6eb7a13$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $ce398c8bd6eb7a13$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $ce398c8bd6eb7a13$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $ce398c8bd6eb7a13$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $j1ICP.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $92UzB.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $ce398c8bd6eb7a13$var$CID.createV0(digest$1) : $ce398c8bd6eb7a13$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $4n0vz.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $ce398c8bd6eb7a13$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $ce398c8bd6eb7a13$var$parseCIDtoBytes(source, base);
        const cid = $ce398c8bd6eb7a13$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $ce398c8bd6eb7a13$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $iRFx0.base58btc;
                return [
                    $iRFx0.base58btc.prefix,
                    decoder.decode(`${$iRFx0.base58btc.prefix}${source}`)
                ];
            }
        case $iRFx0.base58btc.prefix:
            {
                const decoder = base || $iRFx0.base58btc;
                return [
                    $iRFx0.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $lrFUP.base32.prefix:
            {
                const decoder = base || $lrFUP.base32;
                return [
                    $lrFUP.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $ce398c8bd6eb7a13$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $iRFx0.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $ce398c8bd6eb7a13$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $ce398c8bd6eb7a13$var$DAG_PB_CODE = 112;
const $ce398c8bd6eb7a13$var$SHA_256_CODE = 18;
const $ce398c8bd6eb7a13$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $4n0vz.encodingLength(version);
    const hashOffset = codeOffset + $4n0vz.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $4n0vz.encodeTo(version, bytes, 0);
    $4n0vz.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $ce398c8bd6eb7a13$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $ce398c8bd6eb7a13$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $ce398c8bd6eb7a13$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $ce398c8bd6eb7a13$var$version = "0.0.0-dev";
const $ce398c8bd6eb7a13$var$deprecate = (range, message)=>{
    if (range.test($ce398c8bd6eb7a13$var$version)) console.warn(message);
    else throw new Error(message);
};
const $ce398c8bd6eb7a13$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
module.exports.CID = $ce398c8bd6eb7a13$var$CID;

});





parcelRegister("ez3MJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2XJKU = parcelRequire("2XJKU");
function $a9a7452ea96a2910$var$toString(array, encoding = "utf8") {
    const base = $2XJKU[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
module.exports.toString = $a9a7452ea96a2910$var$toString;

});

parcelRegister("83mmv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fZqbm = parcelRequire("fZqbm");

var $bdjTx = parcelRequire("bdjTx");
function $5dcff325f9306950$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $fZqbm.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $bdjTx.asUint8Array(result);
}
module.exports.xor = $5dcff325f9306950$var$xor;

});


parcelRegister("lbkR2", function(module, exports) {

$parcel$export(module.exports, "detect", () => $f6bacd51f721e0d3$export$17b446b869dad473);

var $gbdt3 = parcelRequire("gbdt3");
var $f6bacd51f721e0d3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f6bacd51f721e0d3$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $f6bacd51f721e0d3$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $gbdt3.platform;
    }
    return NodeInfo;
}();
var $f6bacd51f721e0d3$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $f6bacd51f721e0d3$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $f6bacd51f721e0d3$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $f6bacd51f721e0d3$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $f6bacd51f721e0d3$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $f6bacd51f721e0d3$var$REQUIRED_VERSION_PARTS = 3;
var $f6bacd51f721e0d3$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $f6bacd51f721e0d3$var$SEARCHBOX_UA_REGEX
    ]
];
var $f6bacd51f721e0d3$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $f6bacd51f721e0d3$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $f6bacd51f721e0d3$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $f6bacd51f721e0d3$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $f6bacd51f721e0d3$export$1184956100eddc3c(navigator.userAgent);
    return $f6bacd51f721e0d3$export$bf2c6630ab904918();
}
function $f6bacd51f721e0d3$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $f6bacd51f721e0d3$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $f6bacd51f721e0d3$export$89ca9f8ca1a50fd5(ua) {
    var data = $f6bacd51f721e0d3$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $f6bacd51f721e0d3$export$1184956100eddc3c(ua) {
    var matchedRule = $f6bacd51f721e0d3$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $f6bacd51f721e0d3$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $f6bacd51f721e0d3$var$REQUIRED_VERSION_PARTS) versionParts = $f6bacd51f721e0d3$var$__spreadArray($f6bacd51f721e0d3$var$__spreadArray([], versionParts, true), $f6bacd51f721e0d3$var$createVersionParts($f6bacd51f721e0d3$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $f6bacd51f721e0d3$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $f6bacd51f721e0d3$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $f6bacd51f721e0d3$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $f6bacd51f721e0d3$export$8fa985da04a86f0(name, version, os);
}
function $f6bacd51f721e0d3$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $f6bacd51f721e0d3$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $f6bacd51f721e0d3$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $f6bacd51f721e0d3$export$bf2c6630ab904918() {
    var isNode = typeof $gbdt3 !== "undefined" && $gbdt3.version;
    return isNode ? new $f6bacd51f721e0d3$export$62457c674e0167c0($gbdt3.version.slice(1)) : null;
}
function $f6bacd51f721e0d3$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});

parcelRegister("8Yg5s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fvePh = parcelRequire("fvePh");

$fvePh.__exportStar((parcelRequire("971sA")), module.exports);

$fvePh.__exportStar((parcelRequire("4ceMk")), module.exports);

$fvePh.__exportStar((parcelRequire("iLRmA")), module.exports);

$fvePh.__exportStar((parcelRequire("edO3L")), module.exports);

});
parcelRegister("fvePh", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $b4954070568afe23$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b4954070568afe23$var$extendStatics = function(d, b) {
    $b4954070568afe23$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b4954070568afe23$var$extendStatics(d, b);
};
function $b4954070568afe23$export$a8ba968b8961cb8a(d, b) {
    $b4954070568afe23$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b4954070568afe23$export$18ce0697a983be9b = function() {
    $b4954070568afe23$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4954070568afe23$export$18ce0697a983be9b.apply(this, arguments);
};
function $b4954070568afe23$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b4954070568afe23$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b4954070568afe23$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b4954070568afe23$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b4954070568afe23$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b4954070568afe23$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b4954070568afe23$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b4954070568afe23$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b4954070568afe23$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b4954070568afe23$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b4954070568afe23$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b4954070568afe23$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b4954070568afe23$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b4954070568afe23$export$10c90e4f7922046c(v) {
    return this instanceof $b4954070568afe23$export$10c90e4f7922046c ? (this.v = v, this) : new $b4954070568afe23$export$10c90e4f7922046c(v);
}
function $b4954070568afe23$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b4954070568afe23$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b4954070568afe23$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b4954070568afe23$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b4954070568afe23$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b4954070568afe23$export$19a8beecd37a4c45 === "function" ? $b4954070568afe23$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b4954070568afe23$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b4954070568afe23$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b4954070568afe23$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b4954070568afe23$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b4954070568afe23$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("971sA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fvePh = parcelRequire("fvePh");

$fvePh.__exportStar((parcelRequire("9a5KJ")), module.exports);

$fvePh.__exportStar((parcelRequire("jPpJZ")), module.exports);

});
parcelRegister("9a5KJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $6ab98299a93616b8$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $6ab98299a93616b8$var$delay;

});

parcelRegister("jPpJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $edO3L = parcelRequire("edO3L");
function $e6f6bf57f9edf4dc$var$toMiliseconds(seconds) {
    return seconds * $edO3L.ONE_THOUSAND;
}
module.exports.toMiliseconds = $e6f6bf57f9edf4dc$var$toMiliseconds;
function $e6f6bf57f9edf4dc$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $edO3L.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $e6f6bf57f9edf4dc$var$fromMiliseconds;

});
parcelRegister("edO3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fvePh = parcelRequire("fvePh");

$fvePh.__exportStar((parcelRequire("ggW9P")), module.exports);

$fvePh.__exportStar((parcelRequire("67GEl")), module.exports);

});
parcelRegister("ggW9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("67GEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("4ceMk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $30e3bf209b53061f$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $30e3bf209b53061f$var$Watch;
module.exports.default = $30e3bf209b53061f$var$Watch;

});

parcelRegister("iLRmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fvePh = parcelRequire("fvePh");

$fvePh.__exportStar((parcelRequire("hqZJb")), module.exports);

});
parcelRegister("hqZJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $cb14bf358928f607$var$IWatch {
}
module.exports.IWatch = $cb14bf358928f607$var$IWatch;

});



parcelRegister("28JPH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $18efe191a514b92b$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $18efe191a514b92b$var$getFromWindow;
function $18efe191a514b92b$var$getFromWindowOrThrow(name) {
    const res = $18efe191a514b92b$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $18efe191a514b92b$var$getFromWindowOrThrow;
function $18efe191a514b92b$var$getDocumentOrThrow() {
    return $18efe191a514b92b$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $18efe191a514b92b$var$getDocumentOrThrow;
function $18efe191a514b92b$var$getDocument() {
    return $18efe191a514b92b$var$getFromWindow("document");
}
module.exports.getDocument = $18efe191a514b92b$var$getDocument;
function $18efe191a514b92b$var$getNavigatorOrThrow() {
    return $18efe191a514b92b$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $18efe191a514b92b$var$getNavigatorOrThrow;
function $18efe191a514b92b$var$getNavigator() {
    return $18efe191a514b92b$var$getFromWindow("navigator");
}
module.exports.getNavigator = $18efe191a514b92b$var$getNavigator;
function $18efe191a514b92b$var$getLocationOrThrow() {
    return $18efe191a514b92b$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $18efe191a514b92b$var$getLocationOrThrow;
function $18efe191a514b92b$var$getLocation() {
    return $18efe191a514b92b$var$getFromWindow("location");
}
module.exports.getLocation = $18efe191a514b92b$var$getLocation;
function $18efe191a514b92b$var$getCryptoOrThrow() {
    return $18efe191a514b92b$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $18efe191a514b92b$var$getCryptoOrThrow;
function $18efe191a514b92b$var$getCrypto() {
    return $18efe191a514b92b$var$getFromWindow("crypto");
}
module.exports.getCrypto = $18efe191a514b92b$var$getCrypto;
function $18efe191a514b92b$var$getLocalStorageOrThrow() {
    return $18efe191a514b92b$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $18efe191a514b92b$var$getLocalStorageOrThrow;
function $18efe191a514b92b$var$getLocalStorage() {
    return $18efe191a514b92b$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $18efe191a514b92b$var$getLocalStorage;

});

parcelRegister("81v59", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $28JPH = parcelRequire("28JPH");
function $5d7686fb3598f306$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $28JPH.getDocumentOrThrow();
        loc = $28JPH.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $5d7686fb3598f306$var$getWindowMetadata;

});

parcelRegister("7GGtC", function(module, exports) {

$parcel$export(module.exports, "extract", () => $598d67a6ef8dcf69$export$f9380c9a627682d3, (v) => $598d67a6ef8dcf69$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $598d67a6ef8dcf69$export$98e6a39c04603d36, (v) => $598d67a6ef8dcf69$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $598d67a6ef8dcf69$export$fac44ee5b035f737, (v) => $598d67a6ef8dcf69$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $598d67a6ef8dcf69$export$7a5253c0f62e0150, (v) => $598d67a6ef8dcf69$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $598d67a6ef8dcf69$export$a8c1621ea79325d3, (v) => $598d67a6ef8dcf69$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $598d67a6ef8dcf69$export$357523c63a2253b9, (v) => $598d67a6ef8dcf69$export$357523c63a2253b9 = v);
var $598d67a6ef8dcf69$export$f9380c9a627682d3;
var $598d67a6ef8dcf69$export$98e6a39c04603d36;
var $598d67a6ef8dcf69$export$fac44ee5b035f737;
var $598d67a6ef8dcf69$export$7a5253c0f62e0150;
var $598d67a6ef8dcf69$export$a8c1621ea79325d3;
var $598d67a6ef8dcf69$export$357523c63a2253b9;
var $598d67a6ef8dcf69$export$44c361b8ec72ef7f;
"use strict";

var $6kizP = parcelRequire("6kizP");

var $dRtGy = parcelRequire("dRtGy");

var $epKFP = parcelRequire("epKFP");

var $gIWR8 = parcelRequire("gIWR8");
const $598d67a6ef8dcf69$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $598d67a6ef8dcf69$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $598d67a6ef8dcf69$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            "[",
                            $598d67a6ef8dcf69$var$encode(index, options),
                            "]=",
                            $598d67a6ef8dcf69$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            "[]=",
                            $598d67a6ef8dcf69$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            ":list=",
                            $598d67a6ef8dcf69$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $598d67a6ef8dcf69$var$encode(key, options),
                                keyValueSep,
                                $598d67a6ef8dcf69$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $598d67a6ef8dcf69$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $598d67a6ef8dcf69$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $598d67a6ef8dcf69$var$encode(key, options),
                            "=",
                            $598d67a6ef8dcf69$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $598d67a6ef8dcf69$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $598d67a6ef8dcf69$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $598d67a6ef8dcf69$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$598d67a6ef8dcf69$var$decode(item, options)) : value === null ? value : $598d67a6ef8dcf69$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $598d67a6ef8dcf69$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$598d67a6ef8dcf69$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $598d67a6ef8dcf69$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $598d67a6ef8dcf69$var$encode(value, options) {
    if (options.encode) return options.strict ? $6kizP(value) : encodeURIComponent(value);
    return value;
}
function $598d67a6ef8dcf69$var$decode(value, options) {
    if (options.decode) return $dRtGy(value);
    return value;
}
function $598d67a6ef8dcf69$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $598d67a6ef8dcf69$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $598d67a6ef8dcf69$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $598d67a6ef8dcf69$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $598d67a6ef8dcf69$var$extract(input) {
    input = $598d67a6ef8dcf69$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $598d67a6ef8dcf69$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $598d67a6ef8dcf69$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $598d67a6ef8dcf69$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $598d67a6ef8dcf69$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $epKFP(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $598d67a6ef8dcf69$var$decode(value, options);
        formatter($598d67a6ef8dcf69$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $598d67a6ef8dcf69$var$parseValue(value[k], options);
        else ret[key] = $598d67a6ef8dcf69$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $598d67a6ef8dcf69$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$598d67a6ef8dcf69$export$f9380c9a627682d3 = $598d67a6ef8dcf69$var$extract;
$598d67a6ef8dcf69$export$98e6a39c04603d36 = $598d67a6ef8dcf69$var$parse;
$598d67a6ef8dcf69$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $598d67a6ef8dcf69$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $598d67a6ef8dcf69$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $598d67a6ef8dcf69$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $598d67a6ef8dcf69$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $598d67a6ef8dcf69$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $598d67a6ef8dcf69$var$encode(key, options) + "=" + $598d67a6ef8dcf69$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$598d67a6ef8dcf69$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $epKFP(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $598d67a6ef8dcf69$var$parse($598d67a6ef8dcf69$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $598d67a6ef8dcf69$var$decode(hash, options)
    } : {});
};
$598d67a6ef8dcf69$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$598d67a6ef8dcf69$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $598d67a6ef8dcf69$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $598d67a6ef8dcf69$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $598d67a6ef8dcf69$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $598d67a6ef8dcf69$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $598d67a6ef8dcf69$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$598d67a6ef8dcf69$var$encodeFragmentIdentifier] ? $598d67a6ef8dcf69$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$598d67a6ef8dcf69$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$598d67a6ef8dcf69$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $598d67a6ef8dcf69$export$7a5253c0f62e0150(input, options);
    return $598d67a6ef8dcf69$export$a8c1621ea79325d3({
        url: url,
        query: $gIWR8(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$598d67a6ef8dcf69$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $598d67a6ef8dcf69$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6kizP", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("dRtGy", function(module, exports) {
"use strict";
var $a177407d3f4d9708$var$token = "%[a-f0-9]{2}";
var $a177407d3f4d9708$var$singleMatcher = new RegExp("(" + $a177407d3f4d9708$var$token + ")|([^%]+?)", "gi");
var $a177407d3f4d9708$var$multiMatcher = new RegExp("(" + $a177407d3f4d9708$var$token + ")+", "gi");
function $a177407d3f4d9708$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $a177407d3f4d9708$var$decodeComponents(left), $a177407d3f4d9708$var$decodeComponents(right));
}
function $a177407d3f4d9708$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($a177407d3f4d9708$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $a177407d3f4d9708$var$decodeComponents(tokens, i).join("");
            tokens = input.match($a177407d3f4d9708$var$singleMatcher) || [];
        }
        return input;
    }
}
function $a177407d3f4d9708$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $a177407d3f4d9708$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $a177407d3f4d9708$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $a177407d3f4d9708$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $a177407d3f4d9708$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("epKFP", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("gIWR8", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("cZUWN", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", () => $97675b1698df3bb7$export$af490b3b9a6de00f);
function $97675b1698df3bb7$var$e(s, r, i = "string") {
    if (!s[r] || typeof s[r] !== i) throw new Error(`Missing or invalid "${r}" param`);
}
function $97675b1698df3bb7$var$l(s, r) {
    let i = !0;
    return r.forEach((t)=>{
        t in s || (i = !1);
    }), i;
}
function $97675b1698df3bb7$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $97675b1698df3bb7$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $97675b1698df3bb7$var$u(s, r, i) {
    return (i.length ? $97675b1698df3bb7$var$w(s, r.length) : $97675b1698df3bb7$var$f(s, r.length)) ? $97675b1698df3bb7$var$l(s, r) : !1;
}
function $97675b1698df3bb7$var$n(s, r, i = "_") {
    const t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $97675b1698df3bb7$export$c75580565fa025bd(s) {
    return $97675b1698df3bb7$export$f576347163de0984(s.method) && $97675b1698df3bb7$export$dae2311546d43680(s.params);
}
function $97675b1698df3bb7$export$f576347163de0984(s) {
    return $97675b1698df3bb7$var$n(s, "subscribe");
}
function $97675b1698df3bb7$export$dae2311546d43680(s) {
    return $97675b1698df3bb7$var$u(s, [
        "topic"
    ], []);
}
function $97675b1698df3bb7$export$8fa7cf76b41caee0(s) {
    return $97675b1698df3bb7$export$71d4d33ac7f7a269(s.method) && $97675b1698df3bb7$export$71e8d1aa48c3e86f(s.params);
}
function $97675b1698df3bb7$export$71d4d33ac7f7a269(s) {
    return $97675b1698df3bb7$var$n(s, "publish");
}
function $97675b1698df3bb7$export$71e8d1aa48c3e86f(s) {
    return $97675b1698df3bb7$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $97675b1698df3bb7$export$83e292763180b41b(s) {
    return $97675b1698df3bb7$export$568d956f39536025(s.method) && $97675b1698df3bb7$export$cbc597c53c3b4f80(s.params);
}
function $97675b1698df3bb7$export$568d956f39536025(s) {
    return $97675b1698df3bb7$var$n(s, "unsubscribe");
}
function $97675b1698df3bb7$export$cbc597c53c3b4f80(s) {
    return $97675b1698df3bb7$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $97675b1698df3bb7$export$43cf4100d6287b8e(s) {
    return $97675b1698df3bb7$export$3cb4ad320e3a46a4(s.method) && $97675b1698df3bb7$export$6366ff9a39f2da4c(s.params);
}
function $97675b1698df3bb7$export$3cb4ad320e3a46a4(s) {
    return $97675b1698df3bb7$var$n(s, "subscription");
}
function $97675b1698df3bb7$export$6366ff9a39f2da4c(s) {
    return $97675b1698df3bb7$var$u(s, [
        "id",
        "data"
    ], []);
}
function $97675b1698df3bb7$export$abdf96c288cb375(s) {
    if (!$97675b1698df3bb7$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$97675b1698df3bb7$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const r = s.params;
    return $97675b1698df3bb7$var$e(r, "topic"), r;
}
function $97675b1698df3bb7$export$eac3e45ac5c5c9fa(s) {
    if (!$97675b1698df3bb7$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$97675b1698df3bb7$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const r = s.params;
    return $97675b1698df3bb7$var$e(r, "topic"), $97675b1698df3bb7$var$e(r, "message"), $97675b1698df3bb7$var$e(r, "ttl", "number"), r;
}
function $97675b1698df3bb7$export$78baa72f78156594(s) {
    if (!$97675b1698df3bb7$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$97675b1698df3bb7$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const r = s.params;
    return $97675b1698df3bb7$var$e(r, "id"), r;
}
function $97675b1698df3bb7$export$4d5822edd41f3b48(s) {
    if (!$97675b1698df3bb7$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$97675b1698df3bb7$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const r = s.params;
    return $97675b1698df3bb7$var$e(r, "id"), $97675b1698df3bb7$var$e(r, "data"), r;
}
const $97675b1698df3bb7$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};

});

parcelRegister("1WeUc", function(module, exports) {

var $sJXAr = parcelRequire("sJXAr");
module.exports = $sJXAr("8sl6V").then(()=>parcelRequire("ewt5h"));

});

parcelRegister("cXShh", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", () => $9705191f7244cbb8$export$2dd8023fb2cd44c);
$parcel$export(module.exports, "CoreUtil", () => $9705191f7244cbb8$export$2ff3ceb398d6f444);
$parcel$export(module.exports, "ClientCtrl", () => $9705191f7244cbb8$export$7d2d093f32eecd30);
$parcel$export(module.exports, "EventsCtrl", () => $9705191f7244cbb8$export$59a837b99037295);
$parcel$export(module.exports, "OptionsCtrl", () => $9705191f7244cbb8$export$5f7b08e38aeeee56);
$parcel$export(module.exports, "ConfigCtrl", () => $9705191f7244cbb8$export$5239b2e4de4e2646);
$parcel$export(module.exports, "AccountCtrl", () => $9705191f7244cbb8$export$7a9b1b1b32fe2386);
$parcel$export(module.exports, "ExplorerCtrl", () => $9705191f7244cbb8$export$8a0e3ad54b37ee57);
$parcel$export(module.exports, "WcConnectionCtrl", () => $9705191f7244cbb8$export$d3e2d95fafb02657);
$parcel$export(module.exports, "ModalCtrl", () => $9705191f7244cbb8$export$f6ef1648e6110c37);
$parcel$export(module.exports, "ThemeCtrl", () => $9705191f7244cbb8$export$fed0363cf09933ba);
$parcel$export(module.exports, "ToastCtrl", () => $9705191f7244cbb8$export$49bec3d5b199c07);

var $lLawT = parcelRequire("lLawT");
const $9705191f7244cbb8$var$o = (0, $lLawT.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $9705191f7244cbb8$export$2dd8023fb2cd44c = {
    state: $9705191f7244cbb8$var$o,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$o, ()=>e($9705191f7244cbb8$var$o));
    },
    push (e, t) {
        e !== $9705191f7244cbb8$var$o.view && ($9705191f7244cbb8$var$o.view = e, t && ($9705191f7244cbb8$var$o.data = t), $9705191f7244cbb8$var$o.history.push(e));
    },
    reset (e) {
        $9705191f7244cbb8$var$o.view = e, $9705191f7244cbb8$var$o.history = [
            e
        ];
    },
    replace (e) {
        $9705191f7244cbb8$var$o.history.length > 1 && ($9705191f7244cbb8$var$o.history[$9705191f7244cbb8$var$o.history.length - 1] = e, $9705191f7244cbb8$var$o.view = e);
    },
    goBack () {
        if ($9705191f7244cbb8$var$o.history.length > 1) {
            $9705191f7244cbb8$var$o.history.pop();
            const [e] = $9705191f7244cbb8$var$o.history.slice(-1);
            $9705191f7244cbb8$var$o.view = e;
        }
    },
    setData (e) {
        $9705191f7244cbb8$var$o.data = e;
    }
}, $9705191f7244cbb8$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    W3M_VERSION: "W3M_VERSION",
    W3M_PREFER_INJECTED_URL_FLAG: "w3mPreferInjected",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $9705191f7244cbb8$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $9705191f7244cbb8$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, n) {
        if ($9705191f7244cbb8$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, n);
        let s = e;
        s.includes("://") || (s = e.replaceAll("/", "").replaceAll(":", ""), s = `${s}://`), s.endsWith("/") || (s = `${s}/`), this.setWalletConnectDeepLink(s, n);
        const a = encodeURIComponent(t);
        return `${s}wc?uri=${a}`;
    },
    formatUniversalUrl (e, t, n) {
        if (!$9705191f7244cbb8$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, n);
        let s = e;
        s.endsWith("/") || (s = `${s}/`), this.setWalletConnectDeepLink(s, n);
        const a = encodeURIComponent(t);
        return `${s}wc?uri=${a}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($9705191f7244cbb8$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($9705191f7244cbb8$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($9705191f7244cbb8$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setWeb3ModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($9705191f7244cbb8$export$2ff3ceb398d6f444.W3M_VERSION, "2.7.1");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $9705191f7244cbb8$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    },
    getSwitchNetworkRouterData () {
        var e;
        const t = (e = $9705191f7244cbb8$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.SwitchNetwork;
        if (!t) throw new Error('Missing "SwitchNetwork" view data');
        return t;
    },
    isPreferInjectedFlag () {
        return typeof location < "u" ? new URLSearchParams(location.search).has($9705191f7244cbb8$export$2ff3ceb398d6f444.W3M_PREFER_INJECTED_URL_FLAG) : !1;
    }
};
let $9705191f7244cbb8$var$k;
const $9705191f7244cbb8$export$7d2d093f32eecd30 = {
    ethereumClient: void 0,
    setEthereumClient (e) {
        $9705191f7244cbb8$var$k = e;
    },
    client () {
        if ($9705191f7244cbb8$var$k) return $9705191f7244cbb8$var$k;
        throw new Error("ClientCtrl has no client set");
    }
}, $9705191f7244cbb8$var$K = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $9705191f7244cbb8$var$l = (0, $lLawT.proxy)({
    enabled: $9705191f7244cbb8$var$K,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $9705191f7244cbb8$export$59a837b99037295 = {
    state: $9705191f7244cbb8$var$l,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$l.events, ()=>e((0, $lLawT.snapshot)($9705191f7244cbb8$var$l.events[$9705191f7244cbb8$var$l.events.length - 1])));
    },
    initialize () {
        $9705191f7244cbb8$var$l.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($9705191f7244cbb8$var$l.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $9705191f7244cbb8$var$l.connectedWalletId = e;
    },
    click (e) {
        if ($9705191f7244cbb8$var$l.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $9705191f7244cbb8$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $9705191f7244cbb8$var$l.events.push(t);
        }
    },
    track (e) {
        if ($9705191f7244cbb8$var$l.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $9705191f7244cbb8$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $9705191f7244cbb8$var$l.events.push(t);
        }
    },
    view (e) {
        if ($9705191f7244cbb8$var$l.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $9705191f7244cbb8$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $9705191f7244cbb8$var$l.events.push(t);
        }
    }
}, $9705191f7244cbb8$var$p = (0, $lLawT.proxy)({
    selectedChain: void 0,
    chains: void 0,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1,
    isPreferInjected: !1
}), $9705191f7244cbb8$export$5f7b08e38aeeee56 = {
    state: $9705191f7244cbb8$var$p,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$p, ()=>e($9705191f7244cbb8$var$p));
    },
    setChains (e) {
        $9705191f7244cbb8$var$p.chains = e;
    },
    getSelectedChain () {
        const e = $9705191f7244cbb8$export$7d2d093f32eecd30.client().getNetwork().chain;
        return e && ($9705191f7244cbb8$var$p.selectedChain = e), $9705191f7244cbb8$var$p.selectedChain;
    },
    setSelectedChain (e) {
        $9705191f7244cbb8$var$p.selectedChain = e;
    },
    setIsCustomDesktop (e) {
        $9705191f7244cbb8$var$p.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $9705191f7244cbb8$var$p.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $9705191f7244cbb8$var$p.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $9705191f7244cbb8$var$p.isUiLoaded = e;
    },
    setIsPreferInjected (e) {
        $9705191f7244cbb8$var$p.isPreferInjected = e;
    }
}, $9705191f7244cbb8$var$O = (0, $lLawT.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chainImages: void 0,
    tokenImages: void 0,
    tokenContracts: void 0,
    enableNetworkView: !1,
    enableAccountView: !0,
    enableExplorer: !0,
    defaultChain: void 0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $9705191f7244cbb8$export$5239b2e4de4e2646 = {
    state: $9705191f7244cbb8$var$O,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$O, ()=>e($9705191f7244cbb8$var$O));
    },
    setConfig (e) {
        var t, n;
        $9705191f7244cbb8$export$59a837b99037295.initialize(), $9705191f7244cbb8$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $9705191f7244cbb8$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((n = e.desktopWallets) == null ? void 0 : n.length)), $9705191f7244cbb8$export$5f7b08e38aeeee56.setChains($9705191f7244cbb8$export$7d2d093f32eecd30.client().chains), $9705191f7244cbb8$export$5f7b08e38aeeee56.setIsPreferInjected($9705191f7244cbb8$export$7d2d093f32eecd30.client().isInjectedProviderInstalled() && $9705191f7244cbb8$export$2ff3ceb398d6f444.isPreferInjectedFlag()), e.defaultChain && $9705191f7244cbb8$export$5f7b08e38aeeee56.setSelectedChain(e.defaultChain), $9705191f7244cbb8$export$2ff3ceb398d6f444.setWeb3ModalVersionInStorage(), Object.assign($9705191f7244cbb8$var$O, e);
    }
}, $9705191f7244cbb8$var$J = "eip155", $9705191f7244cbb8$var$z = "https://rpc.walletconnect.com", $9705191f7244cbb8$var$G = {
    async getIdentity (e, t) {
        const { projectId: n } = $9705191f7244cbb8$export$5239b2e4de4e2646.state, s = `${$9705191f7244cbb8$var$J}:${t}`, a = `${$9705191f7244cbb8$var$z}/v1/identity/${e}?chainId=${s}&projectId=${n}`;
        return (await fetch(a)).json();
    }
}, $9705191f7244cbb8$var$r = (0, $lLawT.proxy)({
    address: void 0,
    profileName: void 0,
    profileAvatar: void 0,
    profileLoading: !1,
    balanceLoading: !1,
    balance: void 0,
    isConnected: !1
}), $9705191f7244cbb8$export$7a9b1b1b32fe2386 = {
    state: $9705191f7244cbb8$var$r,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$r, ()=>e($9705191f7244cbb8$var$r));
    },
    getAccount () {
        const e = $9705191f7244cbb8$export$7d2d093f32eecd30.client().getAccount();
        $9705191f7244cbb8$var$r.address = e.address, $9705191f7244cbb8$var$r.isConnected = e.isConnected;
    },
    async fetchProfile (e, t) {
        var n;
        try {
            $9705191f7244cbb8$var$r.profileLoading = !0, $9705191f7244cbb8$var$r.profileName = null, $9705191f7244cbb8$var$r.profileAvatar = null;
            const s = t ?? $9705191f7244cbb8$var$r.address, a = 1, c = (n = $9705191f7244cbb8$export$5f7b08e38aeeee56.state.chains) == null ? void 0 : n.find((d)=>d.id === a);
            if (s && c) {
                try {
                    const d = await $9705191f7244cbb8$var$G.getIdentity(s, a);
                    $9705191f7244cbb8$var$r.profileName = d.name, $9705191f7244cbb8$var$r.profileAvatar = d.avatar;
                } catch  {
                    const m = await $9705191f7244cbb8$export$7d2d093f32eecd30.client().fetchEnsName({
                        address: s,
                        chainId: a
                    });
                    if ($9705191f7244cbb8$var$r.profileName = m, m) {
                        const v = await $9705191f7244cbb8$export$7d2d093f32eecd30.client().fetchEnsAvatar({
                            name: m,
                            chainId: a
                        });
                        $9705191f7244cbb8$var$r.profileAvatar = v;
                    }
                }
                $9705191f7244cbb8$var$r.profileAvatar && await e($9705191f7244cbb8$var$r.profileAvatar);
            }
        } finally{
            $9705191f7244cbb8$var$r.profileLoading = !1;
        }
    },
    async fetchBalance (e) {
        try {
            const { chain: t } = $9705191f7244cbb8$export$7d2d093f32eecd30.client().getNetwork(), { tokenContracts: n } = $9705191f7244cbb8$export$5239b2e4de4e2646.state;
            let s;
            t && n && (s = n[t.id]), $9705191f7244cbb8$var$r.balanceLoading = !0;
            const a = e ?? $9705191f7244cbb8$var$r.address;
            if (a) {
                const c = await $9705191f7244cbb8$export$7d2d093f32eecd30.client().fetchBalance({
                    address: a,
                    token: s
                });
                $9705191f7244cbb8$var$r.balance = {
                    amount: c.formatted,
                    symbol: c.symbol
                };
            }
        } finally{
            $9705191f7244cbb8$var$r.balanceLoading = !1;
        }
    },
    setAddress (e) {
        $9705191f7244cbb8$var$r.address = e;
    },
    setIsConnected (e) {
        $9705191f7244cbb8$var$r.isConnected = e;
    },
    resetBalance () {
        $9705191f7244cbb8$var$r.balance = void 0;
    },
    resetAccount () {
        $9705191f7244cbb8$var$r.address = void 0, $9705191f7244cbb8$var$r.isConnected = !1, $9705191f7244cbb8$var$r.profileName = void 0, $9705191f7244cbb8$var$r.profileAvatar = void 0, $9705191f7244cbb8$var$r.balance = void 0;
    }
};
var $9705191f7244cbb8$var$Q = Object.defineProperty, $9705191f7244cbb8$var$S = Object.getOwnPropertySymbols, $9705191f7244cbb8$var$X = Object.prototype.hasOwnProperty, $9705191f7244cbb8$var$Y = Object.prototype.propertyIsEnumerable, $9705191f7244cbb8$var$T = (e, t, n)=>t in e ? $9705191f7244cbb8$var$Q(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $9705191f7244cbb8$var$Z = (e, t)=>{
    for(var n in t || (t = {}))$9705191f7244cbb8$var$X.call(t, n) && $9705191f7244cbb8$var$T(e, n, t[n]);
    if ($9705191f7244cbb8$var$S) for (var n of $9705191f7244cbb8$var$S(t))$9705191f7244cbb8$var$Y.call(t, n) && $9705191f7244cbb8$var$T(e, n, t[n]);
    return e;
};
const $9705191f7244cbb8$var$D = "https://explorer-api.walletconnect.com", $9705191f7244cbb8$var$M = "w3m", $9705191f7244cbb8$var$$ = "js-2.7.1";
async function $9705191f7244cbb8$var$U(e, t) {
    const n = $9705191f7244cbb8$var$Z({
        sdkType: $9705191f7244cbb8$var$M,
        sdkVersion: $9705191f7244cbb8$var$$
    }, t), s = new URL(e, $9705191f7244cbb8$var$D);
    return s.searchParams.append("projectId", $9705191f7244cbb8$export$5239b2e4de4e2646.state.projectId), Object.entries(n).forEach(([a, c])=>{
        c && s.searchParams.append(a, String(c));
    }), (await fetch(s)).json();
}
const $9705191f7244cbb8$var$I = {
    async getDesktopListings (e) {
        return $9705191f7244cbb8$var$U("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $9705191f7244cbb8$var$U("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $9705191f7244cbb8$var$U("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $9705191f7244cbb8$var$U("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$9705191f7244cbb8$var$D}/w3m/v1/getWalletImage/${e}?projectId=${$9705191f7244cbb8$export$5239b2e4de4e2646.state.projectId}&sdkType=${$9705191f7244cbb8$var$M}&sdkVersion=${$9705191f7244cbb8$var$$}`;
    },
    getAssetImageUrl (e) {
        return `${$9705191f7244cbb8$var$D}/w3m/v1/getAssetImage/${e}?projectId=${$9705191f7244cbb8$export$5239b2e4de4e2646.state.projectId}&sdkType=${$9705191f7244cbb8$var$M}&sdkVersion=${$9705191f7244cbb8$var$$}`;
    }
};
var $9705191f7244cbb8$var$ee = Object.defineProperty, $9705191f7244cbb8$var$_ = Object.getOwnPropertySymbols, $9705191f7244cbb8$var$te = Object.prototype.hasOwnProperty, $9705191f7244cbb8$var$ne = Object.prototype.propertyIsEnumerable, $9705191f7244cbb8$var$x = (e, t, n)=>t in e ? $9705191f7244cbb8$var$ee(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $9705191f7244cbb8$var$se = (e, t)=>{
    for(var n in t || (t = {}))$9705191f7244cbb8$var$te.call(t, n) && $9705191f7244cbb8$var$x(e, n, t[n]);
    if ($9705191f7244cbb8$var$_) for (var n of $9705191f7244cbb8$var$_(t))$9705191f7244cbb8$var$ne.call(t, n) && $9705191f7244cbb8$var$x(e, n, t[n]);
    return e;
};
const $9705191f7244cbb8$var$R = $9705191f7244cbb8$export$2ff3ceb398d6f444.isMobile(), $9705191f7244cbb8$var$u = (0, $lLawT.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    injectedWallets: [],
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $9705191f7244cbb8$export$8a0e3ad54b37ee57 = {
    state: $9705191f7244cbb8$var$u,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $9705191f7244cbb8$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $9705191f7244cbb8$var$u.recomendedWallets;
        if ($9705191f7244cbb8$export$2ff3ceb398d6f444.isArray(e)) {
            const n = {
                recommendedIds: e.join(",")
            }, { listings: s } = await $9705191f7244cbb8$var$I.getAllListings(n), a = Object.values(s);
            a.sort((c, d)=>{
                const m = e.indexOf(c.id), v = e.indexOf(d.id);
                return m - v;
            }), $9705191f7244cbb8$var$u.recomendedWallets = a;
        } else {
            const n = $9705191f7244cbb8$export$2ff3ceb398d6f444.isArray(t), s = {
                page: 1,
                entries: $9705191f7244cbb8$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                version: 2,
                excludedIds: n ? t.join(",") : void 0
            }, { listings: a } = $9705191f7244cbb8$var$R ? await $9705191f7244cbb8$var$I.getMobileListings(s) : await $9705191f7244cbb8$var$I.getDesktopListings(s);
            $9705191f7244cbb8$var$u.recomendedWallets = Object.values(a);
        }
        return $9705191f7244cbb8$var$u.recomendedWallets;
    },
    async getWallets (e) {
        const t = $9705191f7244cbb8$var$se({}, e), { explorerRecommendedWalletIds: n, explorerExcludedWalletIds: s } = $9705191f7244cbb8$export$5239b2e4de4e2646.state, { recomendedWallets: a } = $9705191f7244cbb8$var$u;
        if (s === "ALL") return $9705191f7244cbb8$var$u.wallets;
        a.length ? t.excludedIds = a.map((N)=>N.id).join(",") : $9705191f7244cbb8$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = n.join(",")), $9705191f7244cbb8$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = [
            t.excludedIds,
            s
        ].filter(Boolean).join(","));
        const { page: c, search: d } = e, { listings: m, total: v } = $9705191f7244cbb8$var$R ? await $9705191f7244cbb8$var$I.getMobileListings(t) : await $9705191f7244cbb8$var$I.getDesktopListings(t), w = Object.values(m), A = d ? "search" : "wallets";
        return $9705191f7244cbb8$var$u[A] = {
            listings: [
                ...$9705191f7244cbb8$var$u[A].listings,
                ...w
            ],
            total: v,
            page: c ?? 1
        }, {
            listings: w,
            total: v
        };
    },
    async getInjectedWallets () {
        const { listings: e } = await $9705191f7244cbb8$var$I.getInjectedListings({}), t = Object.values(e);
        return $9705191f7244cbb8$var$u.injectedWallets = t, $9705191f7244cbb8$var$u.injectedWallets;
    },
    getWalletImageUrl (e) {
        return $9705191f7244cbb8$var$I.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $9705191f7244cbb8$var$I.getAssetImageUrl(e);
    },
    resetSearch () {
        $9705191f7244cbb8$var$u.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $9705191f7244cbb8$var$E = (0, $lLawT.proxy)({
    pairingEnabled: !1,
    pairingUri: "",
    pairingError: !1
}), $9705191f7244cbb8$export$d3e2d95fafb02657 = {
    state: $9705191f7244cbb8$var$E,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$E, ()=>e($9705191f7244cbb8$var$E));
    },
    setPairingUri (e) {
        $9705191f7244cbb8$var$E.pairingUri = e;
    },
    setPairingError (e) {
        $9705191f7244cbb8$var$E.pairingError = e;
    },
    setPairingEnabled (e) {
        $9705191f7244cbb8$var$E.pairingEnabled = e;
    }
}, $9705191f7244cbb8$var$L = (0, $lLawT.proxy)({
    open: !1
}), $9705191f7244cbb8$export$f6ef1648e6110c37 = {
    state: $9705191f7244cbb8$var$L,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$L, ()=>e($9705191f7244cbb8$var$L));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: n, isDataLoaded: s, isPreferInjected: a, selectedChain: c } = $9705191f7244cbb8$export$5f7b08e38aeeee56.state, { isConnected: d } = $9705191f7244cbb8$export$7a9b1b1b32fe2386.state, { enableNetworkView: m } = $9705191f7244cbb8$export$5239b2e4de4e2646.state;
            if ($9705191f7244cbb8$export$d3e2d95fafb02657.setPairingEnabled(!0), d || $9705191f7244cbb8$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), e != null && e.route) $9705191f7244cbb8$export$2dd8023fb2cd44c.reset(e.route);
            else if (d) $9705191f7244cbb8$export$2dd8023fb2cd44c.reset("Account");
            else if (m) $9705191f7244cbb8$export$2dd8023fb2cd44c.reset("SelectNetwork");
            else if (a) {
                $9705191f7244cbb8$export$7d2d093f32eecd30.client().connectConnector("injected", c?.id).catch((w)=>console.error(w)), t();
                return;
            } else $9705191f7244cbb8$export$2dd8023fb2cd44c.reset("ConnectWallet");
            const { pairingUri: v } = $9705191f7244cbb8$export$d3e2d95fafb02657.state;
            if (n && s && (v || d)) $9705191f7244cbb8$var$L.open = !0, t();
            else {
                const w = setInterval(()=>{
                    const A = $9705191f7244cbb8$export$5f7b08e38aeeee56.state, N = $9705191f7244cbb8$export$d3e2d95fafb02657.state;
                    A.isUiLoaded && A.isDataLoaded && (N.pairingUri || d) && (clearInterval(w), $9705191f7244cbb8$var$L.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $9705191f7244cbb8$var$L.open = !1;
    }
};
var $9705191f7244cbb8$var$re = Object.defineProperty, $9705191f7244cbb8$var$V = Object.getOwnPropertySymbols, $9705191f7244cbb8$var$ae = Object.prototype.hasOwnProperty, $9705191f7244cbb8$var$oe = Object.prototype.propertyIsEnumerable, $9705191f7244cbb8$var$B = (e, t, n)=>t in e ? $9705191f7244cbb8$var$re(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $9705191f7244cbb8$var$ie = (e, t)=>{
    for(var n in t || (t = {}))$9705191f7244cbb8$var$ae.call(t, n) && $9705191f7244cbb8$var$B(e, n, t[n]);
    if ($9705191f7244cbb8$var$V) for (var n of $9705191f7244cbb8$var$V(t))$9705191f7244cbb8$var$oe.call(t, n) && $9705191f7244cbb8$var$B(e, n, t[n]);
    return e;
};
function $9705191f7244cbb8$var$le() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $9705191f7244cbb8$var$j = (0, $lLawT.proxy)({
    themeMode: $9705191f7244cbb8$var$le() ? "dark" : "light"
}), $9705191f7244cbb8$export$fed0363cf09933ba = {
    state: $9705191f7244cbb8$var$j,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$j, ()=>e($9705191f7244cbb8$var$j));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: n } = e;
        t && ($9705191f7244cbb8$var$j.themeMode = t), n && ($9705191f7244cbb8$var$j.themeVariables = $9705191f7244cbb8$var$ie({}, n));
    }
}, $9705191f7244cbb8$var$y = (0, $lLawT.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $9705191f7244cbb8$export$49bec3d5b199c07 = {
    state: $9705191f7244cbb8$var$y,
    subscribe (e) {
        return (0, $lLawT.subscribe)($9705191f7244cbb8$var$y, ()=>e($9705191f7244cbb8$var$y));
    },
    openToast (e, t) {
        $9705191f7244cbb8$var$y.open = !0, $9705191f7244cbb8$var$y.message = e, $9705191f7244cbb8$var$y.variant = t;
    },
    closeToast () {
        $9705191f7244cbb8$var$y.open = !1;
    }
};

});
parcelRegister("lLawT", function(module, exports) {

$parcel$export(module.exports, "proxy", () => $fd7627b74fef0abf$export$923f96dd5afa9ce6, (v) => $fd7627b74fef0abf$export$923f96dd5afa9ce6 = v);
$parcel$export(module.exports, "snapshot", () => $fd7627b74fef0abf$export$b8801ea43165ed7d, (v) => $fd7627b74fef0abf$export$b8801ea43165ed7d = v);
$parcel$export(module.exports, "subscribe", () => $fd7627b74fef0abf$export$ec068583843480e7, (v) => $fd7627b74fef0abf$export$ec068583843480e7 = v);
var $fd7627b74fef0abf$export$c506eb22e615ba4a;
var $fd7627b74fef0abf$export$923f96dd5afa9ce6;
var $fd7627b74fef0abf$export$eff4d24c3ff7876e;
var $fd7627b74fef0abf$export$b8801ea43165ed7d;
var $fd7627b74fef0abf$export$ec068583843480e7;
var $fd7627b74fef0abf$export$e7b04d37d9502758;
"use strict";

var $eDDA4 = parcelRequire("eDDA4");
function $fd7627b74fef0abf$var$_extends() {
    $fd7627b74fef0abf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd7627b74fef0abf$var$_extends.apply(this, arguments);
}
var $fd7627b74fef0abf$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $fd7627b74fef0abf$var$proxyStateMap = new WeakMap();
var $fd7627b74fef0abf$var$refSet = new WeakSet();
var $fd7627b74fef0abf$var$buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, shouldTrapDefineProperty, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return $fd7627b74fef0abf$var$isObject(x) && !$fd7627b74fef0abf$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (shouldTrapDefineProperty === void 0) shouldTrapDefineProperty = function shouldTrapDefineProperty(desc) {
        return desc.configurable && desc.enumerable && desc.writable;
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        $eDDA4.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if ($fd7627b74fef0abf$var$refSet.has(value)) $eDDA4.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($fd7627b74fef0abf$var$proxyStateMap.has(value)) {
                var _ref = $fd7627b74fef0abf$var$proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!$fd7627b74fef0abf$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var trapSet = function trapSet(hasPrevValue, prevValue, prop, value, setValue) {
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return;
            removePropListener(prop);
            if ($fd7627b74fef0abf$var$isObject(value)) value = $eDDA4.getUntracked(value) || value;
            var nextValue = value;
            if (value instanceof Promise) value.then(function(v) {
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch(function(e) {
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$fd7627b74fef0abf$var$proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                var childProxyState = !$fd7627b74fef0abf$var$refSet.has(nextValue) && $fd7627b74fef0abf$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            setValue(nextValue);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
        };
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                trapSet(hasPrevValue, prevValue, prop, value, function(nextValue) {
                    Reflect.set(target, prop, nextValue, receiver);
                });
                return true;
            },
            defineProperty: function defineProperty(target, prop, desc) {
                if (shouldTrapDefineProperty(desc)) {
                    var prevDesc = Reflect.getOwnPropertyDescriptor(target, prop);
                    if (!prevDesc || shouldTrapDefineProperty(prevDesc)) {
                        trapSet(!!prevDesc && "value" in prevDesc, prevDesc == null ? void 0 : prevDesc.value, prop, desc.value, function(nextValue) {
                            Reflect.defineProperty(target, prop, $fd7627b74fef0abf$var$_extends({}, desc, {
                                value: nextValue
                            }));
                        });
                        return true;
                    }
                }
                return Reflect.defineProperty(target, prop, desc);
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $fd7627b74fef0abf$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        $fd7627b74fef0abf$var$proxyStateMap,
        $fd7627b74fef0abf$var$refSet,
        objectIs,
        newProxy,
        canProxy,
        shouldTrapDefineProperty,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $fd7627b74fef0abf$var$_buildProxyFunction = $fd7627b74fef0abf$var$buildProxyFunction(), $fd7627b74fef0abf$var$defaultProxyFunction = $fd7627b74fef0abf$var$_buildProxyFunction[0];
function $fd7627b74fef0abf$var$proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return $fd7627b74fef0abf$var$defaultProxyFunction(initialObject);
}
function $fd7627b74fef0abf$var$getVersion(proxyObject) {
    var proxyState = $fd7627b74fef0abf$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $fd7627b74fef0abf$var$subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = $fd7627b74fef0abf$var$proxyStateMap.get(proxyObject);
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $fd7627b74fef0abf$var$snapshot(proxyObject, handlePromise) {
    var proxyState = $fd7627b74fef0abf$var$proxyStateMap.get(proxyObject);
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $fd7627b74fef0abf$var$ref(obj) {
    $fd7627b74fef0abf$var$refSet.add(obj);
    return obj;
}
var $fd7627b74fef0abf$var$unstable_buildProxyFunction = $fd7627b74fef0abf$var$buildProxyFunction;
$fd7627b74fef0abf$export$c506eb22e615ba4a = $fd7627b74fef0abf$var$getVersion;
$fd7627b74fef0abf$export$923f96dd5afa9ce6 = $fd7627b74fef0abf$var$proxy;
$fd7627b74fef0abf$export$eff4d24c3ff7876e = $fd7627b74fef0abf$var$ref;
$fd7627b74fef0abf$export$b8801ea43165ed7d = $fd7627b74fef0abf$var$snapshot;
$fd7627b74fef0abf$export$ec068583843480e7 = $fd7627b74fef0abf$var$subscribe;
$fd7627b74fef0abf$export$e7b04d37d9502758 = $fd7627b74fef0abf$var$unstable_buildProxyFunction;

});
parcelRegister("eDDA4", function(module, exports) {

$parcel$export(module.exports, "getUntracked", () => $aa8369262eb58160$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $aa8369262eb58160$export$2c8383c890e26a1c);
const $aa8369262eb58160$var$e = Symbol(), $aa8369262eb58160$var$t = Symbol(), $aa8369262eb58160$var$r = "a", $aa8369262eb58160$var$n = "w";
let $aa8369262eb58160$var$o = (e, t)=>new Proxy(e, t);
const $aa8369262eb58160$var$s = Object.getPrototypeOf, $aa8369262eb58160$var$c = new WeakMap, $aa8369262eb58160$var$l = (e)=>e && ($aa8369262eb58160$var$c.has(e) ? $aa8369262eb58160$var$c.get(e) : $aa8369262eb58160$var$s(e) === Object.prototype || $aa8369262eb58160$var$s(e) === Array.prototype), $aa8369262eb58160$var$f = (e)=>"object" == typeof e && null !== e, $aa8369262eb58160$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($aa8369262eb58160$var$s(e), t);
}, $aa8369262eb58160$var$u = (e)=>e[$aa8369262eb58160$var$t] || e, $aa8369262eb58160$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$aa8369262eb58160$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $aa8369262eb58160$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $aa8369262eb58160$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$aa8369262eb58160$var$r].get(o);
                if (s || (s = {}, c[$aa8369262eb58160$var$r].set(o, s)), e === $aa8369262eb58160$var$n) s[$aa8369262eb58160$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $aa8369262eb58160$var$t ? o : (f("k", n), $aa8369262eb58160$export$7865d0c7f908de6b(Reflect.get(e, n), c[$aa8369262eb58160$var$r], c.c, c.t)),
            has: (t, n)=>n === $aa8369262eb58160$var$e ? (l = !0, c[$aa8369262eb58160$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($aa8369262eb58160$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $aa8369262eb58160$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$aa8369262eb58160$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $aa8369262eb58160$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$aa8369262eb58160$var$f(e) || !$aa8369262eb58160$var$f(t)) return !0;
    const s = r.get($aa8369262eb58160$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$aa8369262eb58160$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $aa8369262eb58160$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $aa8369262eb58160$export$badc26589cf7bb38 = (t)=>!!$aa8369262eb58160$var$l(t) && $aa8369262eb58160$var$e in t, $aa8369262eb58160$export$80d2cee7ee556e99 = (e)=>$aa8369262eb58160$var$l(e) && e[$aa8369262eb58160$var$t] || null, $aa8369262eb58160$export$2c8383c890e26a1c = (e, t = !0)=>{
    $aa8369262eb58160$var$c.set(e, t);
}, $aa8369262eb58160$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $aa8369262eb58160$var$f(e) && s.add(e);
        const i = $aa8369262eb58160$var$f(e) && t.get($aa8369262eb58160$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$aa8369262eb58160$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $aa8369262eb58160$export$9b4d5450dbd8e67e = (e)=>{
    $aa8369262eb58160$var$o = e;
};

});



parcelRegister("b9mfO", function(module, exports) {

var $sJXAr = parcelRequire("sJXAr");
module.exports = Promise.all([
    $sJXAr("bn9mE"),
    $sJXAr("cG97w")
]).then(()=>parcelRequire("8WKKM"));

});

parcelRegister("6wIS6", function(module, exports) {
"use strict";
var $4c0889cecf80b18f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4c0889cecf80b18f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4c0889cecf80b18f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4c0889cecf80b18f$var$__createBinding(result, mod, k);
    }
    $4c0889cecf80b18f$var$__setModuleDefault(result, mod);
    return result;
};
var $4c0889cecf80b18f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SiweMessage = void 0;

var $lN7y2 = parcelRequire("lN7y2");

const $4c0889cecf80b18f$var$uri = $4c0889cecf80b18f$var$__importStar((parcelRequire("hGNJn")));

var $3fhu7 = parcelRequire("3fhu7");

var $5omI5 = parcelRequire("5omI5");

var $53zBN = parcelRequire("53zBN");
class $4c0889cecf80b18f$var$SiweMessage {
    /**
     * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
     * string or an object. If a string is used an ABNF parser is called to
     * validate the parameter, otherwise the fields are attributed.
     * @param param {string | SiweMessage} Sign message as a string or an object.
     */ constructor(param){
        if (typeof param === "string") {
            const parsedMessage = new $lN7y2.ParsedMessage(param);
            this.scheme = parsedMessage.scheme;
            this.domain = parsedMessage.domain;
            this.address = parsedMessage.address;
            this.statement = parsedMessage.statement;
            this.uri = parsedMessage.uri;
            this.version = parsedMessage.version;
            this.nonce = parsedMessage.nonce;
            this.issuedAt = parsedMessage.issuedAt;
            this.expirationTime = parsedMessage.expirationTime;
            this.notBefore = parsedMessage.notBefore;
            this.requestId = parsedMessage.requestId;
            this.chainId = parsedMessage.chainId;
            this.resources = parsedMessage.resources;
        } else {
            this.scheme = param === null || param === void 0 ? void 0 : param.scheme;
            this.domain = param.domain;
            this.address = param.address;
            this.statement = param === null || param === void 0 ? void 0 : param.statement;
            this.uri = param.uri;
            this.version = param.version;
            this.chainId = param.chainId;
            this.nonce = param.nonce;
            this.issuedAt = param === null || param === void 0 ? void 0 : param.issuedAt;
            this.expirationTime = param === null || param === void 0 ? void 0 : param.expirationTime;
            this.notBefore = param === null || param === void 0 ? void 0 : param.notBefore;
            this.requestId = param === null || param === void 0 ? void 0 : param.requestId;
            this.resources = param === null || param === void 0 ? void 0 : param.resources;
            if (typeof this.chainId === "string") this.chainId = (0, $lN7y2.parseIntegerNumber)(this.chainId);
        }
        this.nonce = this.nonce || (0, $53zBN.generateNonce)();
        this.validateMessage();
    }
    /**
     * This function can be used to retrieve an EIP-4361 formated message for
     * signature, although you can call it directly it's advised to use
     * [prepareMessage()] instead which will resolve to the correct method based
     * on the [type] attribute of this object, in case of other formats being
     * implemented.
     * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
     */ toMessage() {
        /** Validates all fields of the object */ this.validateMessage();
        const headerPrefx = this.scheme ? `${this.scheme}://${this.domain}` : this.domain;
        const header = `${headerPrefx} wants you to sign in with your Ethereum account:`;
        const uriField = `URI: ${this.uri}`;
        let prefix = [
            header,
            this.address
        ].join("\n");
        const versionField = `Version: ${this.version}`;
        if (!this.nonce) this.nonce = (0, $53zBN.generateNonce)();
        const chainField = `Chain ID: ` + this.chainId || "1";
        const nonceField = `Nonce: ${this.nonce}`;
        const suffixArray = [
            uriField,
            versionField,
            chainField,
            nonceField
        ];
        this.issuedAt = this.issuedAt || new Date().toISOString();
        suffixArray.push(`Issued At: ${this.issuedAt}`);
        if (this.expirationTime) {
            const expiryField = `Expiration Time: ${this.expirationTime}`;
            suffixArray.push(expiryField);
        }
        if (this.notBefore) suffixArray.push(`Not Before: ${this.notBefore}`);
        if (this.requestId) suffixArray.push(`Request ID: ${this.requestId}`);
        if (this.resources) suffixArray.push([
            `Resources:`,
            ...this.resources.map((x)=>`- ${x}`)
        ].join("\n"));
        const suffix = suffixArray.join("\n");
        prefix = [
            prefix,
            this.statement
        ].join("\n\n");
        if (this.statement) prefix += "\n";
        return [
            prefix,
            suffix
        ].join("\n");
    }
    /**
     * This method parses all the fields in the object and creates a messaging for signing
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */ prepareMessage() {
        let message;
        switch(this.version){
            case "1":
                message = this.toMessage();
                break;
            default:
                message = this.toMessage();
                break;
        }
        return message;
    }
    /**
     * @deprecated
     * Verifies the integrity of the object by matching its signature.
     * @param signature Signature to match the address in the message.
     * @param provider Ethers provider to be used for EIP-1271 validation
     */ validate(signature, provider) {
        return $4c0889cecf80b18f$var$__awaiter(this, void 0, void 0, function*() {
            console.warn("validate() has been deprecated, please update your code to use verify(). validate() may be removed in future versions.");
            return this.verify({
                signature: signature
            }, {
                provider: provider,
                suppressExceptions: false
            }).then(({ data: data })=>data).catch(({ error: error })=>{
                throw error;
            });
        });
    }
    /**
     * Verifies the integrity of the object by matching its signature.
     * @param params Parameters to verify the integrity of the message, signature is required.
     * @returns {Promise<SiweMessage>} This object if valid.
     */ verify(params, opts = {
        suppressExceptions: false
    }) {
        return $4c0889cecf80b18f$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>{
                var _a, _b, _c;
                const fail = (result)=>{
                    if (opts.suppressExceptions) return resolve(result);
                    else return reject(result);
                };
                const invalidParams = (0, $53zBN.checkInvalidKeys)(params, $5omI5.VerifyParamsKeys);
                if (invalidParams.length > 0) fail({
                    success: false,
                    data: this,
                    error: new Error(`${invalidParams.join(", ")} is/are not valid key(s) for VerifyParams.`)
                });
                const invalidOpts = (0, $53zBN.checkInvalidKeys)(opts, $5omI5.VerifyOptsKeys);
                if (invalidParams.length > 0) fail({
                    success: false,
                    data: this,
                    error: new Error(`${invalidOpts.join(", ")} is/are not valid key(s) for VerifyOpts.`)
                });
                const { signature: signature, scheme: scheme, domain: domain, nonce: nonce, time: time } = params;
                /** Scheme for domain binding */ if (scheme && scheme !== this.scheme) fail({
                    success: false,
                    data: this,
                    error: new $5omI5.SiweError($5omI5.SiweErrorType.SCHEME_MISMATCH, scheme, this.scheme)
                });
                /** Domain binding */ if (domain && domain !== this.domain) fail({
                    success: false,
                    data: this,
                    error: new $5omI5.SiweError($5omI5.SiweErrorType.DOMAIN_MISMATCH, domain, this.domain)
                });
                /** Nonce binding */ if (nonce && nonce !== this.nonce) fail({
                    success: false,
                    data: this,
                    error: new $5omI5.SiweError($5omI5.SiweErrorType.NONCE_MISMATCH, nonce, this.nonce)
                });
                /** Check time or now */ const checkTime = new Date(time || new Date());
                /** Message not expired */ if (this.expirationTime) {
                    const expirationDate = new Date(this.expirationTime);
                    if (checkTime.getTime() >= expirationDate.getTime()) fail({
                        success: false,
                        data: this,
                        error: new $5omI5.SiweError($5omI5.SiweErrorType.EXPIRED_MESSAGE, `${checkTime.toISOString()} < ${expirationDate.toISOString()}`, `${checkTime.toISOString()} >= ${expirationDate.toISOString()}`)
                    });
                }
                /** Message is valid already */ if (this.notBefore) {
                    const notBefore = new Date(this.notBefore);
                    if (checkTime.getTime() < notBefore.getTime()) fail({
                        success: false,
                        data: this,
                        error: new $5omI5.SiweError($5omI5.SiweErrorType.NOT_YET_VALID_MESSAGE, `${checkTime.toISOString()} >= ${notBefore.toISOString()}`, `${checkTime.toISOString()} < ${notBefore.toISOString()}`)
                    });
                }
                let EIP4361Message;
                try {
                    EIP4361Message = this.prepareMessage();
                } catch (e) {
                    fail({
                        success: false,
                        data: this,
                        error: e
                    });
                }
                /** Recover address from signature */ let addr;
                try {
                    addr = (0, $3fhu7.verifyMessage)(EIP4361Message, signature);
                } catch (e) {
                    console.error(e);
                }
                /** Match signature with message's address */ if (addr === this.address) return resolve({
                    success: true,
                    data: this
                });
                else {
                    const EIP1271Promise = (0, $53zBN.checkContractWalletSignature)(this, signature, opts.provider).then((isValid)=>{
                        if (!isValid) return {
                            success: false,
                            data: this,
                            error: new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_SIGNATURE, addr, `Resolved address to be ${this.address}`)
                        };
                        return {
                            success: true,
                            data: this
                        };
                    }).catch((error)=>{
                        return {
                            success: false,
                            data: this,
                            error: error
                        };
                    });
                    Promise.all([
                        EIP1271Promise,
                        (_c = (_b = (_a = opts === null || opts === void 0 ? void 0 : opts.verificationFallback) === null || _a === void 0 ? void 0 : _a.call(opts, params, opts, this, EIP1271Promise)) === null || _b === void 0 ? void 0 : _b.then((res)=>res)) === null || _c === void 0 ? void 0 : _c.catch((res)=>res)
                    ]).then(([EIP1271Response, fallbackResponse])=>{
                        if (fallbackResponse) {
                            if (fallbackResponse.success) return resolve(fallbackResponse);
                            else fail(fallbackResponse);
                        } else {
                            if (EIP1271Response.success) return resolve(EIP1271Response);
                            else fail(EIP1271Response);
                        }
                    });
                }
            });
        });
    }
    /**
     * Validates the values of this object fields.
     * @throws Throws an {ErrorType} if a field is invalid.
     */ validateMessage(...args) {
        var _a;
        /** Checks if the user might be using the function to verify instead of validate. */ if (args.length > 0) throw new $5omI5.SiweError($5omI5.SiweErrorType.UNABLE_TO_PARSE, `Unexpected argument in the validateMessage function.`);
        /** `domain` check. */ if (!this.domain || this.domain.length === 0 || !/[^#?]*/.test(this.domain)) throw new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_DOMAIN, `${this.domain} to be a valid domain.`);
        /** EIP-55 `address` check. */ if (!(0, $lN7y2.isEIP55Address)(this.address)) throw new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_ADDRESS, (0, $3fhu7.getAddress)(this.address), this.address);
        /** Check if the URI is valid. */ if (!$4c0889cecf80b18f$var$uri.isUri(this.uri)) throw new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_URI, `${this.uri} to be a valid uri.`);
        /** Check if the version is 1. */ if (this.version !== "1") throw new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_MESSAGE_VERSION, "1", this.version);
        /** Check if the nonce is alphanumeric and bigger then 8 characters */ const nonce = (_a = this === null || this === void 0 ? void 0 : this.nonce) === null || _a === void 0 ? void 0 : _a.match(/[a-zA-Z0-9]{8,}/);
        if (!nonce || this.nonce.length < 8 || nonce[0] !== this.nonce) throw new $5omI5.SiweError($5omI5.SiweErrorType.INVALID_NONCE, `Length > 8 (${nonce.length}). Alphanumeric.`, this.nonce);
        /** `issuedAt` conforms to ISO-8601 and is a valid date. */ if (this.issuedAt) {
            if (!(0, $53zBN.isValidISO8601Date)(this.issuedAt)) throw new Error($5omI5.SiweErrorType.INVALID_TIME_FORMAT);
        }
        /** `expirationTime` conforms to ISO-8601 and is a valid date. */ if (this.expirationTime) {
            if (!(0, $53zBN.isValidISO8601Date)(this.expirationTime)) throw new Error($5omI5.SiweErrorType.INVALID_TIME_FORMAT);
        }
        /** `notBefore` conforms to ISO-8601 and is a valid date. */ if (this.notBefore) {
            if (!(0, $53zBN.isValidISO8601Date)(this.notBefore)) throw new Error($5omI5.SiweErrorType.INVALID_TIME_FORMAT);
        }
    }
}
module.exports.SiweMessage = $4c0889cecf80b18f$var$SiweMessage;

});
parcelRegister("lN7y2", function(module, exports) {
"use strict";
var $fdd4077947c69f7a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fdd4077947c69f7a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fdd4077947c69f7a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;

var $cxa6G = parcelRequire("cxa6G");
Object.defineProperty(module.exports, "ParsedMessage", {
    enumerable: true,
    get: function() {
        return $cxa6G.ParsedMessage;
    }
});

$fdd4077947c69f7a$var$__exportStar((parcelRequire("2qPOp")), module.exports);

});
parcelRegister("cxa6G", function(module, exports) {
"use strict";
var $920068176b40c21f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $920068176b40c21f$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;

const $920068176b40c21f$var$api_1 = $920068176b40c21f$var$__importDefault((parcelRequire("5ijUs")));

const $920068176b40c21f$var$node_exports_1 = $920068176b40c21f$var$__importDefault((parcelRequire("bK0XY")));

var $2qPOp = parcelRequire("2qPOp");
const $920068176b40c21f$var$GRAMMAR = `
sign-in-with-ethereum =
    [ scheme "://" ] domain %s" wants you to sign in with your Ethereum account:" LF
    address LF
    LF
    [ statement LF ]
    LF
    %s"URI: " URI LF
    %s"Version: " version LF
    %s"Chain ID: " chain-id LF
    %s"Nonce: " nonce LF
    %s"Issued At: " issued-at
    [ LF %s"Expiration Time: " expiration-time ]
    [ LF %s"Not Before: " not-before ]
    [ LF %s"Request ID: " request-id ]
    [ LF %s"Resources:"
    resources ]

domain = authority

address = "0x" 40*40HEXDIG
    ; Must also conform to captilization
    ; checksum encoding specified in EIP-55
    ; where applicable (EOAs).

statement = 1*( reserved / unreserved / " " )
    ; The purpose is to exclude LF (line breaks).

version = "1"

nonce = 8*( ALPHA / DIGIT )

issued-at = date-time
expiration-time = date-time
not-before = date-time

request-id = *pchar

chain-id = 1*DIGIT
    ; See EIP-155 for valid CHAIN_IDs.

resources = *( LF resource )

resource = "- " URI

; ------------------------------------------------------------------------------
; RFC 3986

URI           = scheme ":" hier-part [ "?" query ] [ "#" fragment ]

hier-part     = "//" authority path-abempty
              / path-absolute
              / path-rootless
              / path-empty

scheme        = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )

authority     = [ userinfo "@" ] host [ ":" port ]
userinfo      = *( unreserved / pct-encoded / sub-delims / ":" )
host          = IP-literal / IPv4address / reg-name
port          = *DIGIT

IP-literal    = "[" ( IPv6address / IPvFuture  ) "]"

IPvFuture     = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )

IPv6address   =                            6( h16 ":" ) ls32
              /                       "::" 5( h16 ":" ) ls32
              / [               h16 ] "::" 4( h16 ":" ) ls32
              / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
              / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
              / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
              / [ *4( h16 ":" ) h16 ] "::"              ls32
              / [ *5( h16 ":" ) h16 ] "::"              h16
              / [ *6( h16 ":" ) h16 ] "::"

h16           = 1*4HEXDIG
ls32          = ( h16 ":" h16 ) / IPv4address
IPv4address   = dec-octet "." dec-octet "." dec-octet "." dec-octet
dec-octet     = DIGIT                 ; 0-9
                 / %x31-39 DIGIT         ; 10-99
                 / "1" 2DIGIT            ; 100-199
                 / "2" %x30-34 DIGIT     ; 200-249
                 / "25" %x30-35          ; 250-255

reg-name      = *( unreserved / pct-encoded / sub-delims )

path-abempty  = *( "/" segment )
path-absolute = "/" [ segment-nz *( "/" segment ) ]
path-rootless = segment-nz *( "/" segment )
path-empty    = 0pchar

segment       = *pchar
segment-nz    = 1*pchar

pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"

query         = *( pchar / "/" / "?" )

fragment      = *( pchar / "/" / "?" )

pct-encoded   = "%" HEXDIG HEXDIG

unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
reserved      = gen-delims / sub-delims
gen-delims    = ":" / "/" / "?" / "#" / "[" / "]" / "@"
sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
              / "*" / "+" / "," / ";" / "="

; ------------------------------------------------------------------------------
; RFC 3339

date-fullyear   = 4DIGIT
date-month      = 2DIGIT  ; 01-12
date-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on
                          ; month/year
time-hour       = 2DIGIT  ; 00-23
time-minute     = 2DIGIT  ; 00-59
time-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second
                          ; rules
time-secfrac    = "." 1*DIGIT
time-numoffset  = ("+" / "-") time-hour ":" time-minute
time-offset     = "Z" / time-numoffset

partial-time    = time-hour ":" time-minute ":" time-second
                  [time-secfrac]
full-date       = date-fullyear "-" date-month "-" date-mday
full-time       = partial-time time-offset

date-time       = full-date "T" full-time

; ------------------------------------------------------------------------------
; RFC 5234

ALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z
LF             =  %x0A
                  ; linefeed
DIGIT          =  %x30-39
                  ; 0-9
HEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
`;
class $920068176b40c21f$var$GrammarApi {
    static generateApi() {
        const api = new $920068176b40c21f$var$api_1.default($920068176b40c21f$var$GRAMMAR);
        api.generate();
        if (api.errors.length) {
            console.error(api.errorsToAscii());
            console.error(api.linesToAscii());
            console.log(api.displayAttributeErrors());
            throw new Error(`ABNF grammar has errors`);
        }
        return api.toObject();
    }
}
$920068176b40c21f$var$_a = $920068176b40c21f$var$GrammarApi;
$920068176b40c21f$var$GrammarApi.grammarObj = $920068176b40c21f$var$_a.generateApi();
class $920068176b40c21f$var$ParsedMessage {
    constructor(msg){
        const parser = new $920068176b40c21f$var$node_exports_1.default.parser();
        parser.ast = new $920068176b40c21f$var$node_exports_1.default.ast();
        const id = $920068176b40c21f$var$node_exports_1.default.ids;
        const scheme = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE && phraseIndex === 0) data.scheme = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.scheme = scheme;
        const domain = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.domain = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.domain = domain;
        const address = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.address = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.address = address;
        const statement = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.statement = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.statement = statement;
        const uri = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                if (!data.uri) data.uri = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.uri = uri;
        const version = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.version = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.version = version;
        const chainId = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.chainId = (0, $2qPOp.parseIntegerNumber)($920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength));
            return ret;
        };
        parser.ast.callbacks["chain-id"] = chainId;
        const nonce = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.nonce = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.nonce = nonce;
        const issuedAt = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.issuedAt = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["issued-at"] = issuedAt;
        const expirationTime = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.expirationTime = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["expiration-time"] = expirationTime;
        const notBefore = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.notBefore = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["not-before"] = notBefore;
        const requestId = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.requestId = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["request-id"] = requestId;
        const resources = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.resources = $920068176b40c21f$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength).slice(3).split("\n- ");
            return ret;
        };
        parser.ast.callbacks.resources = resources;
        const result = parser.parse($920068176b40c21f$var$GrammarApi.grammarObj, "sign-in-with-ethereum", msg);
        if (!result.success) throw new Error(`Invalid message: ${JSON.stringify(result)}`);
        const elements = {};
        parser.ast.translate(elements);
        for (const [key, value] of Object.entries(elements))this[key] = value;
        if (this.domain.length === 0) throw new Error("Domain cannot be empty.");
        if (!(0, $2qPOp.isEIP55Address)(this.address)) throw new Error("Address not conformant to EIP-55.");
    }
}
module.exports.ParsedMessage = $920068176b40c21f$var$ParsedMessage;

});
parcelRegister("5ijUs", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is Application Programming Interface (API) for **APG** - the ABNF Parser Generator.
//
// *Note on teminology.*
// APG is a parser generator.
// However, it really only generates a "grammar object" (see below) from the defining SABNF grammar.
// The generated parser is incomplete at this stage.
// Remaining, it is the job of the user to develop the generated parser from the grammar object and the **APG** Library (**apg-lib**).
//
// The following terminology my help clear up any confusion between the idea of a "generated parser" versus a "generated grammar object".
// - The generating parser: **APG** is an **APG** parser (yes, there is a circular dependence between **apg-api** and **apg-lib**). We'll call it the generating parser.
// - The target parser: **APG**'s goal is to generate a parser. We'll call it the target parser.
// - The target grammar: this is the (ASCII) SABNF grammar defining the target parser.
// - The target grammar object: **APG** parses the SABNF grammar and generates the JavaScript source for a target grammar object constructor function
// and/or an actual grammar object.
// - The final target parser: The user then develops the final target parser using the generated target grammar
// object and the **APG** parsing library, **apg-lib**.
// Throws execeptions on fatal errors.
//
// src: the input SABNF grammar<br>
// may be one of:
// - Buffer of bytes
// - JavaScript string
// - Array of integer character codes







module.exports = function api(src) {
    const { Buffer: Buffer } = (parcelRequire("7ts9d"));
    const thisFileName = "api.js: ";
    const thisObject = this;
    /* PRIVATE PROPERTIES */ const apglib = (parcelRequire("bK0XY"));
    const converter = (parcelRequire("6QrXI"));
    const scanner = (parcelRequire("cPeg2"));
    const parser = new (parcelRequire("aBmP7"))();
    const { attributes: attributes, showAttributes: showAttributes, showAttributeErrors: showAttributeErrors, showRuleDependencies: showRuleDependencies } = (parcelRequire("j3tAf"));
    const showRules = (parcelRequire("dbqDA"));
    /* PRIVATE MEMBERS (FUNCTIONS) */ /* Convert a phrase (array of character codes) to HTML. */ const abnfToHtml = function abnfToHtml(chars, beg, len) {
        const NORMAL = 0;
        const CONTROL = 1;
        const INVALID = 2;
        const CONTROL_BEG = `<span class="${apglib.style.CLASS_CTRLCHAR}">`;
        const CONTROL_END = "</span>";
        const INVALID_BEG = `<span class="${apglib.style.CLASS_NOMATCH}">`;
        const INVALID_END = "</span>";
        let end;
        let html = "";
        const TRUE = true;
        while(TRUE){
            if (!Array.isArray(chars) || chars.length === 0) break;
            if (typeof beg !== "number") throw new Error("abnfToHtml: beg must be type number");
            if (beg >= chars.length) break;
            if (typeof len !== "number" || beg + len >= chars.length) end = chars.length;
            else end = beg + len;
            let state = NORMAL;
            for(let i = beg; i < end; i += 1){
                const ch = chars[i];
                if (ch >= 32 && ch <= 126) {
                    /* normal - printable ASCII characters */ if (state === CONTROL) {
                        html += CONTROL_END;
                        state = NORMAL;
                    } else if (state === INVALID) {
                        html += INVALID_END;
                        state = NORMAL;
                    }
                    /* handle reserved HTML entity characters */ switch(ch){
                        case 32:
                            html += "&nbsp;";
                            break;
                        case 60:
                            html += "&lt;";
                            break;
                        case 62:
                            html += "&gt;";
                            break;
                        case 38:
                            html += "&amp;";
                            break;
                        case 34:
                            html += "&quot;";
                            break;
                        case 39:
                            html += "&#039;";
                            break;
                        case 92:
                            html += "&#092;";
                            break;
                        default:
                            html += String.fromCharCode(ch);
                            break;
                    }
                } else if (ch === 9 || ch === 10 || ch === 13) {
                    /* control characters */ if (state === NORMAL) {
                        html += CONTROL_BEG;
                        state = CONTROL;
                    } else if (state === INVALID) {
                        html += INVALID_END + CONTROL_BEG;
                        state = CONTROL;
                    }
                    if (ch === 9) html += "TAB";
                    if (ch === 10) html += "LF";
                    if (ch === 13) html += "CR";
                } else {
                    /* invalid characters */ if (state === NORMAL) {
                        html += INVALID_BEG;
                        state = INVALID;
                    } else if (state === CONTROL) {
                        html += CONTROL_END + INVALID_BEG;
                        state = INVALID;
                    }
                    /* display character as hexadecimal value */ html += `\\x${apglib.utils.charToHex(ch)}`;
                }
            }
            if (state === INVALID) html += INVALID_END;
            if (state === CONTROL) html += CONTROL_END;
            break;
        }
        return html;
    };
    /* Convert a phrase (array of character codes) to ASCII text. */ const abnfToAscii = function abnfToAscii(chars, beg, len) {
        let str = "";
        for(let i = beg; i < beg + len; i += 1){
            const ch = chars[i];
            if (ch >= 32 && ch <= 126) str += String.fromCharCode(ch);
            else switch(ch){
                case 9:
                    str += "\\t";
                    break;
                case 10:
                    str += "\\n";
                    break;
                case 13:
                    str += "\\r";
                    break;
                default:
                    str += "\\unknown";
                    break;
            }
        }
        return str;
    };
    /* translate lines (SABNF grammar) to ASCII text */ const linesToAscii = function linesToAscii(lines) {
        let str = "Annotated Input Grammar";
        lines.forEach((val)=>{
            str += "\n";
            str += `line no: ${val.lineNo}`;
            str += ` : char index: ${val.beginChar}`;
            str += ` : length: ${val.length}`;
            str += ` : abnf: ${abnfToAscii(thisObject.chars, val.beginChar, val.length)}`;
        });
        str += "\n";
        return str;
    };
    /* translate lines (SABNF grammar) to HTML */ const linesToHtml = function linesToHtml(lines) {
        let html = "";
        html += `<table class="${apglib.style.CLASS_GRAMMAR}">\n`;
        const title = "Annotated Input Grammar";
        html += `<caption>${title}</caption>\n`;
        html += "<tr>";
        html += "<th>line<br>no.</th><th>first<br>char</th><th><br>length</th><th><br>text</th>";
        html += "</tr>\n";
        lines.forEach((val)=>{
            html += "<tr>";
            html += `<td>${val.lineNo}`;
            html += `</td><td>${val.beginChar}`;
            html += `</td><td>${val.length}`;
            html += `</td><td>${abnfToHtml(thisObject.chars, val.beginChar, val.length)}`;
            html += "</td>";
            html += "</tr>\n";
        });
        html += "</table>\n";
        return html;
    };
    /* Format the error messages to HTML, for page display. */ const errorsToHtml = function errorsToHtml(errors, lines, chars, title) {
        const [style] = apglib;
        let html = "";
        const errorArrow = `<span class="${style.CLASS_NOMATCH}">&raquo;</span>`;
        html += `<p><table class="${style.CLASS_GRAMMAR}">\n`;
        if (title && typeof title === "string") html += `<caption>${title}</caption>\n`;
        html += "<tr><th>line<br>no.</th><th>line<br>offset</th><th>error<br>offset</th><th><br>text</th></tr>\n";
        errors.forEach((val)=>{
            let line;
            let relchar;
            let beg;
            let end;
            let text;
            let prefix = "";
            let suffix = "";
            if (lines.length === 0) {
                text = errorArrow;
                relchar = 0;
            } else {
                line = lines[val.line];
                beg = line.beginChar;
                if (val.char > beg) prefix = abnfToHtml(chars, beg, val.char - beg);
                beg = val.char;
                end = line.beginChar + line.length;
                if (beg < end) suffix = abnfToHtml(chars, beg, end - beg);
                text = prefix + errorArrow + suffix;
                relchar = val.char - line.beginChar;
                html += "<tr>";
                html += `<td>${val.line}</td><td>${line.beginChar}</td><td>${relchar}</td><td>${text}</td>`;
                html += "</tr>\n";
                html += "<tr>";
                html += `<td colspan="3"></td><td>&uarr;:&nbsp;${apglib.utils.stringToAsciiHtml(val.msg)}</td>`;
                html += "</tr>\n";
            }
        });
        html += "</table></p>\n";
        return html;
    };
    /* Display an array of errors in ASCII text */ const errorsToAscii = function errorsToAscii(errors, lines, chars) {
        let str;
        let line;
        let beg;
        let len;
        str = "";
        errors.forEach((error)=>{
            line = lines[error.line];
            str += `${line.lineNo}: `;
            str += `${line.beginChar}: `;
            str += `${error.char - line.beginChar}: `;
            beg = line.beginChar;
            len = error.char - line.beginChar;
            str += abnfToAscii(chars, beg, len);
            str += " >> ";
            beg = error.char;
            len = line.beginChar + line.length - error.char;
            str += abnfToAscii(chars, beg, len);
            str += "\n";
            str += `${line.lineNo}: `;
            str += `${line.beginChar}: `;
            str += `${error.char - line.beginChar}: `;
            str += "error: ";
            str += error.msg;
            str += "\n";
        });
        return str;
    };
    let isScanned = false;
    let isParsed = false;
    let isTranslated = false;
    let haveAttributes = false;
    let attributeErrors = 0;
    let lineMap;
    /* PUBLIC PROPERTIES */ // The input SABNF grammar as a JavaScript string.
    // this.sabnf;
    // The input SABNF grammar as an array of character codes.
    // this.chars;
    // An array of line objects, defining each line of the input SABNF grammar
    // - lineNo : the zero-based line number
    // - beginChar : offset (into `this.chars`) of the first character in the line
    // - length : the number of characters in the line
    // - textLength : the number of characters of text in the line, excluding the line ending characters
    // - endType : "CRLF", "LF", "CR" or "none" if the last line has no line ending characters
    // - invalidChars : `true` if the line contains invalid characters, `false` otherwise
    // this.lines;
    // An array of rule names and data.
    // - name : the rule name
    // - lower : the rule name in lower case
    // - index : the index of the rule (ordered by appearance in SABNF grammar)
    // - isBkr : `true` if this rule has been back referenced, `false` otherwise
    // - opcodes : array of opcodes for this rule
    // - attrs : the rule attributes
    // - ctrl : system data
    // this.rules;
    // An array of UDT names and data.
    // this.udts;
    // An array of errors, if any.
    // - line : the line number containing the error
    // - char : the character offset of the error
    // - msg : the error message
    this.errors = [];
    /* CONSTRUCTOR */ if (Buffer.isBuffer(src)) this.chars = converter.decode("BINARY", src);
    else if (Array.isArray(src)) this.chars = src.slice();
    else if (typeof src === "string") this.chars = converter.decode("STRING", src);
    else throw new Error(`${thisFileName}input source is not a string, byte Buffer or character array`);
    this.sabnf = converter.encode("STRING", this.chars);
    /* PUBLIC MEMBERS (FUNCTIONS) */ // Scan the input SABNF grammar for invalid characters and catalog the lines via `this.lines`.
    // - strict : (optional) if `true`, all lines, including the last must end with CRLF (\r\n),
    // if `false` (in any JavaScript sense) then line endings may be any mix of CRLF, LF, CR, or end-of-file.
    // - trace (*) : (optional) a parser trace object, which will trace the parser that does the scan
    this.scan = function scan(strict, trace) {
        this.lines = scanner(this.chars, this.errors, strict, trace);
        isScanned = true;
    };
    // Parse the input SABNF grammar for correct syntax.
    // - strict : (optional) if `true`, the input grammar must be strict ABNF, conforming to [RFC 5234](https://tools.ietf.org/html/rfc5234)
    // and [RFC 7405](https://tools.ietf.org/html/rfc7405). No superset features allowed.
    // - trace (\*) : (optional) a parser trace object, which will trace the syntax parser
    //
    // <i>(*)NOTE: the trace option was used primarily during development.
    // Error detection and reporting is now fairly robust and tracing should be unnecessary. Use at your own peril.</i>
    this.parse = function parse(strict, lite, trace) {
        if (!isScanned) throw new Error(`${thisFileName}grammar not scanned`);
        parser.syntax(this.chars, this.lines, this.errors, strict, lite, trace);
        isParsed = true;
    };
    // Translate the SABNF grammar syntax into the opcodes that will guide the parser for this grammar.
    this.translate = function translate() {
        if (!isParsed) throw new Error(`${thisFileName}grammar not scanned and parsed`);
        const ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length === 0) {
            this.rules = ret.rules;
            this.udts = ret.udts;
            lineMap = ret.lineMap;
            isTranslated = true;
        }
    };
    // Compute the attributes of each rule.
    this.attributes = function attrs() {
        if (!isTranslated) throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
        return attributeErrors;
    };
    // This function will perform the full suite of steps required to generate a parser grammar object
    // from the input SABNF grammar.
    this.generate = function generate(strict) {
        this.lines = scanner(this.chars, this.errors, strict);
        if (this.errors.length) return;
        parser.syntax(this.chars, this.lines, this.errors, strict);
        if (this.errors.length) return;
        const ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length) return;
        this.rules = ret.rules;
        this.udts = ret.udts;
        lineMap = ret.lineMap;
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
    };
    // Display the rules.
    // Must scan, parse and translate before calling this function, otherwise there are no rules to display.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    this.displayRules = function displayRules(order = "index") {
        if (!isTranslated) throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
        return showRules(this.rules, this.udts, order);
    };
    // Display the rule dependencies.
    // Must scan, parse, translate and compute attributes before calling this function.
    // Otherwise the rule dependencies are not known.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    this.displayRuleDependencies = function displayRuleDependencies(order = "index") {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        return showRuleDependencies(order);
    };
    // Display the attributes.
    // Must scan, parse, translate and compute attributes before calling this function.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, type order (default)
    this.displayAttributes = function displayAttributes(order = "index") {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        if (attributeErrors) showAttributeErrors(order);
        return showAttributes(order);
    };
    this.displayAttributeErrors = function displayAttributeErrors() {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        return showAttributeErrors();
    };
    // Returns a parser grammar object constructor function as a JavaScript string.
    // This object can then be used to construct a parser.
    this.toSource = function toSource(config) {
        if (!haveAttributes) throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
        if (attributeErrors) throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
        return parser.generateSource(this.chars, this.lines, this.rules, this.udts, config);
    };
    // Returns a parser grammar object.
    // This grammar object may be used by the application to construct a parser.
    this.toObject = function toObject() {
        if (!haveAttributes) throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
        if (attributeErrors) throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
        return parser.generateObject(this.sabnf, this.rules, this.udts);
    };
    // Display errors in text format, suitable for `console.log()`.
    this.errorsToAscii = function errorsToAsciiFunc() {
        return errorsToAscii(this.errors, this.lines, this.chars);
    };
    // Display errors in HTML format, suitable for web page display.
    // (`apg-lib.css` required for proper styling)
    this.errorsToHtml = function errorsToHtmlFunc(title) {
        return errorsToHtml(this.errors, this.lines, this.chars, title);
    };
    // Generate an annotated the SABNF grammar display in text format.
    this.linesToAscii = function linesToAsciiFunc() {
        return linesToAscii(this.lines);
    };
    // Generate an annotated the SABNF grammar display in HTML format.
    // (`apg-lib.css` required for proper styling)
    this.linesToHtml = function linesToHtmlFunc() {
        return linesToHtml(this.lines);
    };
// This function was only used by apg.html which has been abandoned.
/*
    this.getAttributesObject = function () {
        return null;
    };
    */ };

});
parcelRegister("7ts9d", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $5711135d10e8160c$export$a143d493d941bafc, (v) => $5711135d10e8160c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $5711135d10e8160c$export$e4cf37d7f6fb9e0a, (v) => $5711135d10e8160c$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $5711135d10e8160c$export$f99ded8fe4b79145, (v) => $5711135d10e8160c$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $5711135d10e8160c$export$599f31c3813fae4d, (v) => $5711135d10e8160c$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5711135d10e8160c$export$a143d493d941bafc;
var $5711135d10e8160c$export$e4cf37d7f6fb9e0a;
var $5711135d10e8160c$export$f99ded8fe4b79145;
var $5711135d10e8160c$export$599f31c3813fae4d;
"use strict";

var $h3ILt = parcelRequire("h3ILt");

var $cwaFX = parcelRequire("cwaFX");
var $5711135d10e8160c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5711135d10e8160c$export$a143d493d941bafc = $5711135d10e8160c$var$Buffer;
$5711135d10e8160c$export$e4cf37d7f6fb9e0a = $5711135d10e8160c$var$SlowBuffer;
$5711135d10e8160c$export$f99ded8fe4b79145 = 50;
var $5711135d10e8160c$var$K_MAX_LENGTH = 0x7fffffff;
$5711135d10e8160c$export$599f31c3813fae4d = $5711135d10e8160c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5711135d10e8160c$var$Buffer.TYPED_ARRAY_SUPPORT = $5711135d10e8160c$var$typedArraySupport();
if (!$5711135d10e8160c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5711135d10e8160c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5711135d10e8160c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5711135d10e8160c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5711135d10e8160c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5711135d10e8160c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5711135d10e8160c$var$createBuffer(length) {
    if (length > $5711135d10e8160c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5711135d10e8160c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5711135d10e8160c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5711135d10e8160c$var$allocUnsafe(arg);
    }
    return $5711135d10e8160c$var$from(arg, encodingOrOffset, length);
}
$5711135d10e8160c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5711135d10e8160c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5711135d10e8160c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5711135d10e8160c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5711135d10e8160c$var$isInstance(value, ArrayBuffer) || value && $5711135d10e8160c$var$isInstance(value.buffer, ArrayBuffer)) return $5711135d10e8160c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5711135d10e8160c$var$isInstance(value, SharedArrayBuffer) || value && $5711135d10e8160c$var$isInstance(value.buffer, SharedArrayBuffer))) return $5711135d10e8160c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5711135d10e8160c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $5711135d10e8160c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5711135d10e8160c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5711135d10e8160c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5711135d10e8160c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5711135d10e8160c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5711135d10e8160c$var$Buffer, Uint8Array);
function $5711135d10e8160c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5711135d10e8160c$var$alloc(size, fill, encoding) {
    $5711135d10e8160c$var$assertSize(size);
    if (size <= 0) return $5711135d10e8160c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5711135d10e8160c$var$createBuffer(size).fill(fill, encoding) : $5711135d10e8160c$var$createBuffer(size).fill(fill);
    return $5711135d10e8160c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5711135d10e8160c$var$Buffer.alloc = function(size, fill, encoding) {
    return $5711135d10e8160c$var$alloc(size, fill, encoding);
};
function $5711135d10e8160c$var$allocUnsafe(size) {
    $5711135d10e8160c$var$assertSize(size);
    return $5711135d10e8160c$var$createBuffer(size < 0 ? 0 : $5711135d10e8160c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5711135d10e8160c$var$Buffer.allocUnsafe = function(size) {
    return $5711135d10e8160c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5711135d10e8160c$var$Buffer.allocUnsafeSlow = function(size) {
    return $5711135d10e8160c$var$allocUnsafe(size);
};
function $5711135d10e8160c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5711135d10e8160c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $5711135d10e8160c$var$byteLength(string, encoding) | 0;
    var buf = $5711135d10e8160c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5711135d10e8160c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $5711135d10e8160c$var$checked(array.length) | 0;
    var buf = $5711135d10e8160c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5711135d10e8160c$var$fromArrayView(arrayView) {
    if ($5711135d10e8160c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $5711135d10e8160c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5711135d10e8160c$var$fromArrayLike(arrayView);
}
function $5711135d10e8160c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5711135d10e8160c$var$Buffer.prototype);
    return buf;
}
function $5711135d10e8160c$var$fromObject(obj) {
    if ($5711135d10e8160c$var$Buffer.isBuffer(obj)) {
        var len = $5711135d10e8160c$var$checked(obj.length) | 0;
        var buf = $5711135d10e8160c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5711135d10e8160c$var$numberIsNaN(obj.length)) return $5711135d10e8160c$var$createBuffer(0);
        return $5711135d10e8160c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5711135d10e8160c$var$fromArrayLike(obj.data);
}
function $5711135d10e8160c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5711135d10e8160c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5711135d10e8160c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5711135d10e8160c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5711135d10e8160c$var$Buffer.alloc(+length);
}
$5711135d10e8160c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5711135d10e8160c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5711135d10e8160c$var$Buffer.compare = function compare(a, b) {
    if ($5711135d10e8160c$var$isInstance(a, Uint8Array)) a = $5711135d10e8160c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5711135d10e8160c$var$isInstance(b, Uint8Array)) b = $5711135d10e8160c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5711135d10e8160c$var$Buffer.isBuffer(a) || !$5711135d10e8160c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5711135d10e8160c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5711135d10e8160c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5711135d10e8160c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $5711135d10e8160c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($5711135d10e8160c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $5711135d10e8160c$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5711135d10e8160c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5711135d10e8160c$var$byteLength(string, encoding) {
    if ($5711135d10e8160c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5711135d10e8160c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5711135d10e8160c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5711135d10e8160c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5711135d10e8160c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5711135d10e8160c$var$Buffer.byteLength = $5711135d10e8160c$var$byteLength;
function $5711135d10e8160c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5711135d10e8160c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5711135d10e8160c$var$utf8Slice(this, start, end);
        case "ascii":
            return $5711135d10e8160c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5711135d10e8160c$var$latin1Slice(this, start, end);
        case "base64":
            return $5711135d10e8160c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5711135d10e8160c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5711135d10e8160c$var$Buffer.prototype._isBuffer = true;
function $5711135d10e8160c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5711135d10e8160c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$5711135d10e8160c$var$swap(this, i, i + 1);
    return this;
};
$5711135d10e8160c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $5711135d10e8160c$var$swap(this, i, i + 3);
        $5711135d10e8160c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5711135d10e8160c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $5711135d10e8160c$var$swap(this, i, i + 7);
        $5711135d10e8160c$var$swap(this, i + 1, i + 6);
        $5711135d10e8160c$var$swap(this, i + 2, i + 5);
        $5711135d10e8160c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5711135d10e8160c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5711135d10e8160c$var$utf8Slice(this, 0, length);
    return $5711135d10e8160c$var$slowToString.apply(this, arguments);
};
$5711135d10e8160c$var$Buffer.prototype.toLocaleString = $5711135d10e8160c$var$Buffer.prototype.toString;
$5711135d10e8160c$var$Buffer.prototype.equals = function equals(b) {
    if (!$5711135d10e8160c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5711135d10e8160c$var$Buffer.compare(this, b) === 0;
};
$5711135d10e8160c$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $5711135d10e8160c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5711135d10e8160c$var$customInspectSymbol) $5711135d10e8160c$var$Buffer.prototype[$5711135d10e8160c$var$customInspectSymbol] = $5711135d10e8160c$var$Buffer.prototype.inspect;
$5711135d10e8160c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5711135d10e8160c$var$isInstance(target, Uint8Array)) target = $5711135d10e8160c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5711135d10e8160c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5711135d10e8160c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5711135d10e8160c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5711135d10e8160c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5711135d10e8160c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5711135d10e8160c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5711135d10e8160c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5711135d10e8160c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5711135d10e8160c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5711135d10e8160c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5711135d10e8160c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5711135d10e8160c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5711135d10e8160c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5711135d10e8160c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5711135d10e8160c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5711135d10e8160c$var$utf8Write(buf, string, offset, length) {
    return $5711135d10e8160c$var$blitBuffer($5711135d10e8160c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5711135d10e8160c$var$asciiWrite(buf, string, offset, length) {
    return $5711135d10e8160c$var$blitBuffer($5711135d10e8160c$var$asciiToBytes(string), buf, offset, length);
}
function $5711135d10e8160c$var$base64Write(buf, string, offset, length) {
    return $5711135d10e8160c$var$blitBuffer($5711135d10e8160c$var$base64ToBytes(string), buf, offset, length);
}
function $5711135d10e8160c$var$ucs2Write(buf, string, offset, length) {
    return $5711135d10e8160c$var$blitBuffer($5711135d10e8160c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5711135d10e8160c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5711135d10e8160c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5711135d10e8160c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5711135d10e8160c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5711135d10e8160c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5711135d10e8160c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5711135d10e8160c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5711135d10e8160c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $h3ILt.fromByteArray(buf);
    else return $h3ILt.fromByteArray(buf.slice(start, end));
}
function $5711135d10e8160c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5711135d10e8160c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $5711135d10e8160c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5711135d10e8160c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $5711135d10e8160c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5711135d10e8160c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5711135d10e8160c$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5711135d10e8160c$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5711135d10e8160c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $5711135d10e8160c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5711135d10e8160c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5711135d10e8160c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5711135d10e8160c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5711135d10e8160c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5711135d10e8160c$var$Buffer.prototype.readUintLE = $5711135d10e8160c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5711135d10e8160c$var$Buffer.prototype.readUintBE = $5711135d10e8160c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5711135d10e8160c$var$Buffer.prototype.readUint8 = $5711135d10e8160c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5711135d10e8160c$var$Buffer.prototype.readUint16LE = $5711135d10e8160c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5711135d10e8160c$var$Buffer.prototype.readUint16BE = $5711135d10e8160c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5711135d10e8160c$var$Buffer.prototype.readUint32LE = $5711135d10e8160c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5711135d10e8160c$var$Buffer.prototype.readUint32BE = $5711135d10e8160c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5711135d10e8160c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5711135d10e8160c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5711135d10e8160c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5711135d10e8160c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5711135d10e8160c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5711135d10e8160c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5711135d10e8160c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5711135d10e8160c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return $cwaFX.read(this, offset, true, 23, 4);
};
$5711135d10e8160c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 4, this.length);
    return $cwaFX.read(this, offset, false, 23, 4);
};
$5711135d10e8160c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 8, this.length);
    return $cwaFX.read(this, offset, true, 52, 8);
};
$5711135d10e8160c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkOffset(offset, 8, this.length);
    return $cwaFX.read(this, offset, false, 52, 8);
};
function $5711135d10e8160c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5711135d10e8160c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5711135d10e8160c$var$Buffer.prototype.writeUintLE = $5711135d10e8160c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5711135d10e8160c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5711135d10e8160c$var$Buffer.prototype.writeUintBE = $5711135d10e8160c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5711135d10e8160c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5711135d10e8160c$var$Buffer.prototype.writeUint8 = $5711135d10e8160c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5711135d10e8160c$var$Buffer.prototype.writeUint16LE = $5711135d10e8160c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5711135d10e8160c$var$Buffer.prototype.writeUint16BE = $5711135d10e8160c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5711135d10e8160c$var$Buffer.prototype.writeUint32LE = $5711135d10e8160c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5711135d10e8160c$var$Buffer.prototype.writeUint32BE = $5711135d10e8160c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5711135d10e8160c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5711135d10e8160c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5711135d10e8160c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5711135d10e8160c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5711135d10e8160c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5711135d10e8160c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5711135d10e8160c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5711135d10e8160c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5711135d10e8160c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5711135d10e8160c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5711135d10e8160c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cwaFX.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5711135d10e8160c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5711135d10e8160c$var$writeFloat(this, value, offset, true, noAssert);
};
$5711135d10e8160c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5711135d10e8160c$var$writeFloat(this, value, offset, false, noAssert);
};
function $5711135d10e8160c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5711135d10e8160c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cwaFX.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5711135d10e8160c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5711135d10e8160c$var$writeDouble(this, value, offset, true, noAssert);
};
$5711135d10e8160c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5711135d10e8160c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5711135d10e8160c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5711135d10e8160c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5711135d10e8160c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5711135d10e8160c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $5711135d10e8160c$var$Buffer.isBuffer(val) ? val : $5711135d10e8160c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $5711135d10e8160c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5711135d10e8160c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5711135d10e8160c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5711135d10e8160c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5711135d10e8160c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5711135d10e8160c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5711135d10e8160c$var$base64ToBytes(str) {
    return $h3ILt.toByteArray($5711135d10e8160c$var$base64clean(str));
}
function $5711135d10e8160c$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5711135d10e8160c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5711135d10e8160c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $5711135d10e8160c$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("h3ILt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $c6b570caf77d20e4$export$d622b2ad8d90c771, (v) => $c6b570caf77d20e4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $c6b570caf77d20e4$export$6100ba28696e12de, (v) => $c6b570caf77d20e4$export$6100ba28696e12de = v);
var $c6b570caf77d20e4$export$a48f0734ac7c2329;
var $c6b570caf77d20e4$export$d622b2ad8d90c771;
var $c6b570caf77d20e4$export$6100ba28696e12de;
"use strict";
$c6b570caf77d20e4$export$a48f0734ac7c2329 = $c6b570caf77d20e4$var$byteLength;
$c6b570caf77d20e4$export$d622b2ad8d90c771 = $c6b570caf77d20e4$var$toByteArray;
$c6b570caf77d20e4$export$6100ba28696e12de = $c6b570caf77d20e4$var$fromByteArray;
var $c6b570caf77d20e4$var$lookup = [];
var $c6b570caf77d20e4$var$revLookup = [];
var $c6b570caf77d20e4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $c6b570caf77d20e4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $c6b570caf77d20e4$var$i = 0, $c6b570caf77d20e4$var$len = $c6b570caf77d20e4$var$code.length; $c6b570caf77d20e4$var$i < $c6b570caf77d20e4$var$len; ++$c6b570caf77d20e4$var$i){
    $c6b570caf77d20e4$var$lookup[$c6b570caf77d20e4$var$i] = $c6b570caf77d20e4$var$code[$c6b570caf77d20e4$var$i];
    $c6b570caf77d20e4$var$revLookup[$c6b570caf77d20e4$var$code.charCodeAt($c6b570caf77d20e4$var$i)] = $c6b570caf77d20e4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c6b570caf77d20e4$var$revLookup["-".charCodeAt(0)] = 62;
$c6b570caf77d20e4$var$revLookup["_".charCodeAt(0)] = 63;
function $c6b570caf77d20e4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c6b570caf77d20e4$var$byteLength(b64) {
    var lens = $c6b570caf77d20e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c6b570caf77d20e4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c6b570caf77d20e4$var$toByteArray(b64) {
    var tmp;
    var lens = $c6b570caf77d20e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c6b570caf77d20e4$var$Arr($c6b570caf77d20e4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i)] << 18 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i)] << 2 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i)] << 10 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c6b570caf77d20e4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c6b570caf77d20e4$var$tripletToBase64(num) {
    return $c6b570caf77d20e4$var$lookup[num >> 18 & 0x3F] + $c6b570caf77d20e4$var$lookup[num >> 12 & 0x3F] + $c6b570caf77d20e4$var$lookup[num >> 6 & 0x3F] + $c6b570caf77d20e4$var$lookup[num & 0x3F];
}
function $c6b570caf77d20e4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c6b570caf77d20e4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $c6b570caf77d20e4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c6b570caf77d20e4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c6b570caf77d20e4$var$lookup[tmp >> 2] + $c6b570caf77d20e4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c6b570caf77d20e4$var$lookup[tmp >> 10] + $c6b570caf77d20e4$var$lookup[tmp >> 4 & 0x3F] + $c6b570caf77d20e4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("cwaFX", function(module, exports) {

$parcel$export(module.exports, "read", () => $91d0c12bb34a45b8$export$aafa59e2e03f2942, (v) => $91d0c12bb34a45b8$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $91d0c12bb34a45b8$export$68d8715fc104d294, (v) => $91d0c12bb34a45b8$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $91d0c12bb34a45b8$export$aafa59e2e03f2942;
var $91d0c12bb34a45b8$export$68d8715fc104d294;
$91d0c12bb34a45b8$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$91d0c12bb34a45b8$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("bK0XY", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module serves to export all library objects and object constructors with the `require("apg-lib")` statement.
// For example, to create a new parser in your program,
// ````
// let apglib = require("../apg-lib/node-exports");
// let my-parser = new apglib.parser();
// ````









module.exports = {
    ast: (parcelRequire("i2ZiP")),
    circular: (parcelRequire("l9c3t")),
    ids: (parcelRequire("i0Pc2")),
    parser: (parcelRequire("4vivX")),
    stats: (parcelRequire("4Dqgn")),
    trace: (parcelRequire("73tM6")),
    utils: (parcelRequire("bvrBx")),
    emitcss: (parcelRequire("j7Qsi")),
    style: (parcelRequire("fq92n"))
};

});
parcelRegister("i2ZiP", function(module, exports) {
/* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is used by the parser to build an [Abstract Syntax Tree](https://en.wikipedia.org/wiki/Abstract_syntax_tree) (AST).
// The AST can be thought of as a subset of the full parse tree.
// Each node of the AST holds the phrase that was matched at the corresponding, named parse tree node.
// It is built as the parser successfully matches phrases to the rule names
// (`RNM` operators) and `UDT`s as it parses an input string.
// The user controls which `RNM` or `UDT` names to keep on the AST.
// The user can also associate callback functions with some or all of the retained
// AST nodes to be used to translate the node phrases. That is, associate semantic
// actions to the matched phrases.
// Translating the AST rather that attempting to apply semantic actions during
// the parsing process, has the advantage that there is no backtracking and that the phrases
// are known while traversing down tree as will as up.
//
// Let `ast` be an `ast.js` object. To identify a node to be kept on the AST:
// ```
// ast.callbacks["rulename"] = true; (all nodes default to false)
// ```
// To associate a callback function with a node:
// ```
// ast.callbacks["rulename"] = fn
// ```
// `rulename` is any `RNM` or `UDT` name defined by the associated grammar
// and `fn` is a user-written callback function.
// (See [`apg-examples`](https://github.com/ldthomas/apg-js2-examples/tree/master/ast) for examples of how to create an AST,
// define the nodes and callback functions and attach it to a parser.)


module.exports = function exportsAst() {
    const id = (parcelRequire("i0Pc2"));
    const utils = (parcelRequire("bvrBx"));
    const thisFileName = "ast.js: ";
    const that = this;
    let rules = null;
    let udts = null;
    let chars = null;
    let nodeCount = 0;
    const nodesDefined = [];
    const nodeCallbacks = [];
    const stack = [];
    const records = [];
    this.callbacks = [];
    this.astObject = "astObject";
    /* called by the parser to initialize the AST with the rules, UDTs and the input characters */ this.init = function init(rulesIn, udtsIn, charsIn) {
        stack.length = 0;
        records.length = 0;
        nodesDefined.length = 0;
        nodeCount = 0;
        rules = rulesIn;
        udts = udtsIn;
        chars = charsIn;
        let i;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        nodeCount = rules.length + udts.length;
        for(i = 0; i < nodeCount; i += 1){
            nodesDefined[i] = false;
            nodeCallbacks[i] = null;
        }
        for(const index in that.callbacks){
            const lower = index.toLowerCase();
            i = list.indexOf(lower);
            if (i < 0) throw new Error(`${thisFileName}init: node '${index}' not a rule or udt name`);
            if (typeof that.callbacks[index] === "function") {
                nodesDefined[i] = true;
                nodeCallbacks[i] = that.callbacks[index];
            }
            if (that.callbacks[index] === true) nodesDefined[i] = true;
        }
    };
    /* AST node definitions - called by the parser's `RNM` operator */ this.ruleDefined = function ruleDefined(index) {
        return nodesDefined[index] !== false;
    };
    /* AST node definitions - called by the parser's `UDT` operator */ this.udtDefined = function udtDefined(index) {
        return nodesDefined[rules.length + index] !== false;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the downward traversal of the node */ this.down = function down(callbackIndex, name) {
        const thisIndex = records.length;
        stack.push(thisIndex);
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: null,
            state: id.SEM_PRE,
            callbackIndex: callbackIndex,
            phraseIndex: null,
            phraseLength: null,
            stack: stack.length
        });
        return thisIndex;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the upward traversal of the node */ this.up = function up(callbackIndex, name, phraseIndex, phraseLength) {
        const thisIndex = records.length;
        const thatIndex = stack.pop();
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: thatIndex,
            state: id.SEM_POST,
            callbackIndex: callbackIndex,
            phraseIndex: phraseIndex,
            phraseLength: phraseLength,
            stack: stack.length
        });
        records[thatIndex].thatIndex = thisIndex;
        records[thatIndex].phraseIndex = phraseIndex;
        records[thatIndex].phraseLength = phraseLength;
        return thisIndex;
    };
    // Called by the user to translate the AST.
    // Translate means to associate or apply some semantic action to the
    // phrases that were syntactically matched to the AST nodes according
    // to the defining grammar.
    // ```
    // data - optional user-defined data
    //        passed to the callback functions by the translator
    // ```
    this.translate = function translate(data) {
        let ret;
        let callback;
        let record;
        for(let i = 0; i < records.length; i += 1){
            record = records[i];
            callback = nodeCallbacks[record.callbackIndex];
            if (record.state === id.SEM_PRE) {
                if (callback !== null) {
                    ret = callback(id.SEM_PRE, chars, record.phraseIndex, record.phraseLength, data);
                    if (ret === id.SEM_SKIP) i = record.thatIndex;
                }
            } else if (callback !== null) callback(id.SEM_POST, chars, record.phraseIndex, record.phraseLength, data);
        }
    };
    /* called by the parser to reset the length of the records array */ /* necessary on backtracking */ this.setLength = function setLength(length) {
        records.length = length;
        if (length > 0) stack.length = records[length - 1].stack;
        else stack.length = 0;
    };
    /* called by the parser to get the length of the records array */ this.getLength = function getLength() {
        return records.length;
    };
    /* helper for XML display */ function indent(n) {
        let ret = "";
        for(let i = 0; i < n; i += 1)ret += " ";
        return ret;
    }
    // Generate an `XML` version of the AST.
    // Useful if you want to use a special or favorite XML parser to translate the
    // AST.
    // ```
    // mode - the display mode of the captured phrases
    //      - default mode is "ascii"
    //      - can be: "ascii"
    //                "decimal"
    //                "hexadecimal"
    //                "unicode"
    // ```
    this.toXml = function toSml(modeArg) {
        let display = utils.charsToDec;
        let caption = "decimal integer character codes";
        if (typeof modeArg === "string" && modeArg.length >= 3) {
            const mode = modeArg.slice(0, 3).toLowerCase();
            if (mode === "asc") {
                display = utils.charsToAscii;
                caption = "ASCII for printing characters, hex for non-printing";
            } else if (mode === "hex") {
                display = utils.charsToHex;
                caption = "hexadecimal integer character codes";
            } else if (mode === "uni") {
                display = utils.charsToUnicode;
                caption = "Unicode UTF-32 integer character codes";
            }
        }
        let xml = "";
        let depth = 0;
        xml += '<?xml version="1.0" encoding="utf-8"?>\n';
        xml += `<root nodes="${records.length / 2}" characters="${chars.length}">\n`;
        xml += `<!-- input string, ${caption} -->\n`;
        xml += indent(depth + 2);
        xml += display(chars);
        xml += "\n";
        records.forEach((rec)=>{
            if (rec.state === id.SEM_PRE) {
                depth += 1;
                xml += indent(depth);
                xml += `<node name="${rec.name}" index="${rec.phraseIndex}" length="${rec.phraseLength}">\n`;
                xml += indent(depth + 2);
                xml += display(chars, rec.phraseIndex, rec.phraseLength);
                xml += "\n";
            } else {
                xml += indent(depth);
                xml += `</node><!-- name="${rec.name}" -->\n`;
                depth -= 1;
            }
        });
        xml += "</root>\n";
        return xml;
    };
    /* generate a JavaScript object version of the AST */ /* for the phrase-matching engine apg-exp */ this.phrases = function phrases() {
        const obj = {};
        let i;
        let record;
        for(i = 0; i < records.length; i += 1){
            record = records[i];
            if (record.state === id.SEM_PRE) {
                if (!Array.isArray(obj[record.name])) obj[record.name] = [];
                obj[record.name].push({
                    index: record.phraseIndex,
                    length: record.phraseLength
                });
            }
        }
        return obj;
    };
};

});
parcelRegister("i0Pc2", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes a list of named identifiers, shared across the parser generator
// and the parsers that are generated.
module.exports = {
    // Identifies the operator type. Used by the generator
    // to indicate operator types in the grammar object.
    // Used by the [parser](./parser.html) when interpreting the grammar object.
    /* the original ABNF operators */ ALT: 1 /* alternation */ ,
    CAT: 2 /* concatenation */ ,
    REP: 3 /* repetition */ ,
    RNM: 4 /* rule name */ ,
    TRG: 5 /* terminal range */ ,
    TBS: 6 /* terminal binary string, case sensitive */ ,
    TLS: 7 /* terminal literal string, case insensitive */ ,
    /* the super set, SABNF operators */ UDT: 11 /* user-defined terminal */ ,
    AND: 12 /* positive look ahead */ ,
    NOT: 13 /* negative look ahead */ ,
    BKR: 14 /* back reference to a previously matched rule name */ ,
    BKA: 15 /* positive look behind */ ,
    BKN: 16 /* negative look behind */ ,
    ABG: 17 /* anchor - begin of string */ ,
    AEN: 18 /* anchor - end of string */ ,
    // Used by the parser and the user's `RNM` and `UDT` callback functions.
    // Identifies the parser state as it traverses the parse tree nodes.
    // - *ACTIVE* - indicates the downward direction through the parse tree node.
    // - *MATCH* - indicates the upward direction and a phrase, of length \> 0, has been successfully matched
    // - *EMPTY* - indicates the upward direction and a phrase, of length = 0, has been successfully matched
    // - *NOMATCH* - indicates the upward direction and the parser failed to match any phrase at all
    ACTIVE: 100,
    MATCH: 101,
    EMPTY: 102,
    NOMATCH: 103,
    // Used by [`AST` translator](./ast.html) (semantic analysis) and the user's callback functions
    // to indicate the direction of flow through the `AST` nodes.
    // - *SEM_PRE* - indicates the downward (pre-branch) direction through the `AST` node.
    // - *SEM_POST* - indicates the upward (post-branch) direction through the `AST` node.
    SEM_PRE: 200,
    SEM_POST: 201,
    // Used by the user's callback functions to indicate to the `AST` translator (semantic analysis) how to proceed.
    // - *SEM_OK* - normal return value
    // - *SEM_SKIP* - if a callback function returns this value from the SEM_PRE state,
    // the translator will skip processing all `AST` nodes in the branch below the current node.
    // Ignored if returned from the SEM_POST state.
    SEM_OK: 300,
    SEM_SKIP: 301,
    // Used in attribute generation to distinguish the necessary attribute categories.
    // - *ATTR_N* - non-recursive
    // - *ATTR_R* - recursive
    // - *ATTR_MR* - belongs to a mutually-recursive set
    ATTR_N: 400,
    ATTR_R: 401,
    ATTR_MR: 402,
    // Look around values indicate whether the parser is in look ahead or look behind mode.
    // Used by the tracing facility to indicate the look around mode in the trace records display.
    // - *LOOKAROUND_NONE* - the parser is in normal parsing mode
    // - *LOOKAROUND_AHEAD* - the parse is in look-ahead mode, phrase matching for operator `AND(&)` or `NOT(!)`
    // - *LOOKAROUND_BEHIND* - the parse is in look-behind mode, phrase matching for operator `BKA(&&)` or `BKN(!!)`
    LOOKAROUND_NONE: 500,
    LOOKAROUND_AHEAD: 501,
    LOOKAROUND_BEHIND: 502,
    // Back reference rule mode indicators
    // - *BKR_MODE_UM* - the back reference is using universal mode
    // - *BKR_MODE_PM* - the back reference is using parent frame mode
    // - *BKR_MODE_CS* - the back reference is using case-sensitive phrase matching
    // - *BKR_MODE_CI* - the back reference is using case-insensitive phrase matching
    BKR_MODE_UM: 601,
    BKR_MODE_PM: 602,
    BKR_MODE_CS: 603,
    BKR_MODE_CI: 604
};

});

parcelRegister("bvrBx", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exports a variety of utility functions that support
// [`apg`](https://github.com/ldthomas/apg-js2), [`apg-lib`](https://github.com/ldthomas/apg-js2-lib)
// and the generated parser applications.

var $fq92n = parcelRequire("fq92n");

var $6QrXI = parcelRequire("6QrXI");

var $j7Qsi = parcelRequire("j7Qsi");

var $i0Pc2 = parcelRequire("i0Pc2");
const thisFileName = "utilities.js: ";
/* translate (implied) phrase beginning character and length to actual first and last character indexes */ /* used by multiple phrase handling functions */ const getBounds = function(length, begArg, len) {
    let end;
    let beg = begArg;
    const TRUE = true;
    while(TRUE){
        if (length <= 0) {
            beg = 0;
            end = 0;
            break;
        }
        if (typeof beg !== "number") {
            beg = 0;
            end = length;
            break;
        }
        if (beg >= length) {
            beg = length;
            end = length;
            break;
        }
        if (typeof len !== "number") {
            end = length;
            break;
        }
        end = beg + len;
        if (end > length) {
            end = length;
            break;
        }
        break;
    }
    return {
        beg: beg,
        end: end
    };
};
// Generates a complete, minimal HTML5 page, inserting the user's HTML text on the page.
// - *html* - the page text in HTML format
// - *title* - the HTML page `<title>` - defaults to `htmlToPage`.
exports.htmlToPage = function(html, titleArg) {
    let title;
    if (typeof html !== "string") throw new Error(`${thisFileName}htmlToPage: input HTML is not a string`);
    if (typeof titleArg !== "string") title = "htmlToPage";
    else title = titleArg;
    let page = "";
    page += "<!DOCTYPE html>\n";
    page += '<html lang="en">\n';
    page += "<head>\n";
    page += '<meta charset="utf-8">\n';
    page += `<title>${title}</title>\n`;
    page += "<style>\n";
    page += $j7Qsi();
    page += "</style>\n";
    page += "</head>\n<body>\n";
    page += `<p>${new Date()}</p>\n`;
    page += html;
    page += "</body>\n</html>\n";
    return page;
};
// Formats the returned object from `parser.parse()`
// into an HTML table.
// ```
// return {
//   success : sysData.success,
//   state : sysData.state,
//   length : charsLength,
//   matched : sysData.phraseLength,
//   maxMatched : maxMatched,
//   maxTreeDepth : maxTreeDepth,
//   nodeHits : nodeHits,
//   inputLength : chars.length,
//   subBegin : charsBegin,
//   subEnd : charsEnd,
//   subLength : charsLength
// };
// ```
exports.parserResultToHtml = function(result, caption) {
    let cap = null;
    if (typeof caption === "string" && caption !== "") cap = caption;
    let success;
    let state;
    if (result.success === true) success = `<span class="${$fq92n.CLASS_MATCH}">true</span>`;
    else success = `<span class="${$fq92n.CLASS_NOMATCH}">false</span>`;
    if (result.state === $i0Pc2.EMPTY) state = `<span class="${$fq92n.CLASS_EMPTY}">EMPTY</span>`;
    else if (result.state === $i0Pc2.MATCH) state = `<span class="${$fq92n.CLASS_MATCH}">MATCH</span>`;
    else if (result.state === $i0Pc2.NOMATCH) state = `<span class="${$fq92n.CLASS_NOMATCH}">NOMATCH</span>`;
    else state = `<span class="${$fq92n.CLASS_NOMATCH}">unrecognized</span>`;
    let html = "";
    html += `<table class="${$fq92n.CLASS_STATE}">\n`;
    if (cap) html += `<caption>${cap}</caption>\n`;
    html += "<tr><th>state item</th><th>value</th><th>description</th></tr>\n";
    html += `<tr><td>parser success</td><td>${success}</td>\n`;
    html += `<td><span class="${$fq92n.CLASS_MATCH}">true</span> if the parse succeeded,\n`;
    html += ` <span class="${$fq92n.CLASS_NOMATCH}">false</span> otherwise`;
    html += "<br><i>NOTE: for success, entire string must be matched</i></td></tr>\n";
    html += `<tr><td>parser state</td><td>${state}</td>\n`;
    html += `<td><span class="${$fq92n.CLASS_EMPTY}">EMPTY</span>, `;
    html += `<span class="${$fq92n.CLASS_MATCH}">MATCH</span> or \n`;
    html += `<span class="${$fq92n.CLASS_NOMATCH}">NOMATCH</span></td></tr>\n`;
    html += `<tr><td>string length</td><td>${result.length}</td><td>length of the input (sub)string</td></tr>\n`;
    html += `<tr><td>matched length</td><td>${result.matched}</td><td>number of input string characters matched</td></tr>\n`;
    html += `<tr><td>max matched</td><td>${result.maxMatched}</td><td>maximum number of input string characters matched</td></tr>\n`;
    html += `<tr><td>max tree depth</td><td>${result.maxTreeDepth}</td><td>maximum depth of the parse tree reached</td></tr>\n`;
    html += `<tr><td>node hits</td><td>${result.nodeHits}</td><td>number of parse tree node hits (opcode function calls)</td></tr>\n`;
    html += `<tr><td>input length</td><td>${result.inputLength}</td><td>length of full input string</td></tr>\n`;
    html += `<tr><td>sub-string begin</td><td>${result.subBegin}</td><td>sub-string first character index</td></tr>\n`;
    html += `<tr><td>sub-string end</td><td>${result.subEnd}</td><td>sub-string end-of-string index</td></tr>\n`;
    html += `<tr><td>sub-string length</td><td>${result.subLength}</td><td>sub-string length</td></tr>\n`;
    html += "</table>\n";
    return html;
};
// Translates a sub-array of integer character codes into a string.
// Very useful in callback functions to translate the matched phrases into strings.
exports.charsToString = function(chars, phraseIndex, phraseLength) {
    let beg;
    let end;
    if (typeof phraseIndex === "number") {
        if (phraseIndex >= chars.length) return "";
        beg = phraseIndex < 0 ? 0 : phraseIndex;
    } else beg = 0;
    if (typeof phraseLength === "number") {
        if (phraseLength <= 0) return "";
        end = phraseLength > chars.length - beg ? chars.length : beg + phraseLength;
    } else end = chars.length;
    if (beg < end) return $6QrXI.encode("UTF16LE", chars.slice(beg, end)).toString("utf16le");
    return "";
};
// Translates a string into an array of integer character codes.
exports.stringToChars = function(string) {
    return $6QrXI.decode("STRING", string);
};
// Translates an opcode identifier into a human-readable string.
exports.opcodeToString = function(type) {
    let ret = "unknown";
    switch(type){
        case $i0Pc2.ALT:
            ret = "ALT";
            break;
        case $i0Pc2.CAT:
            ret = "CAT";
            break;
        case $i0Pc2.RNM:
            ret = "RNM";
            break;
        case $i0Pc2.UDT:
            ret = "UDT";
            break;
        case $i0Pc2.AND:
            ret = "AND";
            break;
        case $i0Pc2.NOT:
            ret = "NOT";
            break;
        case $i0Pc2.REP:
            ret = "REP";
            break;
        case $i0Pc2.TRG:
            ret = "TRG";
            break;
        case $i0Pc2.TBS:
            ret = "TBS";
            break;
        case $i0Pc2.TLS:
            ret = "TLS";
            break;
        case $i0Pc2.BKR:
            ret = "BKR";
            break;
        case $i0Pc2.BKA:
            ret = "BKA";
            break;
        case $i0Pc2.BKN:
            ret = "BKN";
            break;
        case $i0Pc2.ABG:
            ret = "ABG";
            break;
        case $i0Pc2.AEN:
            ret = "AEN";
            break;
        default:
            throw new Error("unrecognized opcode");
    }
    return ret;
};
// Translates an state identifier into a human-readable string.
exports.stateToString = function(state) {
    let ret = "unknown";
    switch(state){
        case $i0Pc2.ACTIVE:
            ret = "ACTIVE";
            break;
        case $i0Pc2.MATCH:
            ret = "MATCH";
            break;
        case $i0Pc2.EMPTY:
            ret = "EMPTY";
            break;
        case $i0Pc2.NOMATCH:
            ret = "NOMATCH";
            break;
        default:
            throw new Error("unrecognized state");
    }
    return ret;
};
// Array which translates all 128, 7-bit ASCII character codes to their respective HTML format.
exports.asciiChars = [
    "NUL",
    "SOH",
    "STX",
    "ETX",
    "EOT",
    "ENQ",
    "ACK",
    "BEL",
    "BS",
    "TAB",
    "LF",
    "VT",
    "FF",
    "CR",
    "SO",
    "SI",
    "DLE",
    "DC1",
    "DC2",
    "DC3",
    "DC4",
    "NAK",
    "SYN",
    "ETB",
    "CAN",
    "EM",
    "SUB",
    "ESC",
    "FS",
    "GS",
    "RS",
    "US",
    "&nbsp;",
    "!",
    "&#34;",
    "#",
    "$",
    "%",
    "&#38;",
    "&#39;",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "&#60;",
    "=",
    "&#62;",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "&#92;",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "DEL"
];
// Translates a single character to hexadecimal with leading zeros for 2, 4, or 8 digit display.
exports.charToHex = function(char) {
    let ch = char.toString(16).toUpperCase();
    switch(ch.length){
        case 1:
        case 3:
        case 7:
            ch = `0${ch}`;
            break;
        case 2:
        case 6:
            ch = `00${ch}`;
            break;
        case 4:
            break;
        case 5:
            ch = `000${ch}`;
            break;
        default:
            throw new Error("unrecognized option");
    }
    return ch;
};
// Translates a sub-array of character codes to decimal display format.
exports.charsToDec = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToDec: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += chars[bounds.beg];
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,${chars[i]}`;
    }
    return ret;
};
// Translates a sub-array of character codes to hexadecimal display format.
exports.charsToHex = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += `\\x${exports.charToHex(chars[bounds.beg])}`;
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,\\x${exports.charToHex(chars[i])}`;
    }
    return ret;
};
exports.charsToHtmlEntities = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) for(let i = bounds.beg; i < bounds.end; i += 1)ret += `&#x${chars[i].toString(16)};`;
    return ret;
};
// Translates a sub-array of character codes to Unicode display format.
function isUnicode(char) {
    if (char >= 0xd800 && char <= 0xdfff) return false;
    if (char > 0x10ffff) return false;
    return true;
}
exports.charsToUnicode = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToUnicode: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        for(let i = bounds.beg; i < bounds.end; i += 1)if (isUnicode(chars[i])) ret += `&#${chars[i]};`;
        else ret += ` U+${exports.charToHex(chars[i])}`;
    }
    return ret;
};
// Translates a sub-array of character codes to JavaScript Unicode display format (`\uXXXX`).
exports.charsToJsUnicode = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToJsUnicode: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += `\\u${exports.charToHex(chars[bounds.beg])}`;
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,\\u${exports.charToHex(chars[i])}`;
    }
    return ret;
};
// Translates a sub-array of character codes to printing ASCII character display format.
exports.charsToAscii = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToAscii: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    for(let i = bounds.beg; i < bounds.end; i += 1){
        const char = chars[i];
        if (char >= 32 && char <= 126) ret += String.fromCharCode(char);
        else ret += `\\x${exports.charToHex(char)}`;
    }
    return ret;
};
// Translates a sub-array of character codes to HTML display format.
exports.charsToAsciiHtml = function(chars, beg, len) {
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToAsciiHtml: input must be an array of integers`);
    let html = "";
    let char;
    const bounds = getBounds(chars.length, beg, len);
    for(let i = bounds.beg; i < bounds.end; i += 1){
        char = chars[i];
        if (char < 32 || char === 127) /* control characters */ html += `<span class="${$fq92n.CLASS_CTRLCHAR}">${exports.asciiChars[char]}</span>`;
        else if (char > 127) /* non-ASCII */ html += `<span class="${$fq92n.CLASS_CTRLCHAR}">U+${exports.charToHex(char)}</span>`;
        else /* printing ASCII, 32 <= char <= 126 */ html += exports.asciiChars[char];
    }
    return html;
};
// Translates a JavaScript string to HTML display format.
exports.stringToAsciiHtml = function(str) {
    const chars = $6QrXI.decode("STRING", str);
    return this.charsToAsciiHtml(chars);
};

});
parcelRegister("fq92n", function(module, exports) {
module.exports = {
    // Generated by apglib/style.js 
    CLASS_MONOSPACE: "apg-mono",
    CLASS_ACTIVE: "apg-active",
    CLASS_EMPTY: "apg-empty",
    CLASS_MATCH: "apg-match",
    CLASS_NOMATCH: "apg-nomatch",
    CLASS_LOOKAHEAD: "apg-lh-match",
    CLASS_LOOKBEHIND: "apg-lb-match",
    CLASS_REMAINDER: "apg-remainder",
    CLASS_CTRLCHAR: "apg-ctrl-char",
    CLASS_LINEEND: "apg-line-end",
    CLASS_ERROR: "apg-error",
    CLASS_PHRASE: "apg-phrase",
    CLASS_EMPTYPHRASE: "apg-empty-phrase",
    CLASS_STATE: "apg-state",
    CLASS_STATS: "apg-stats",
    CLASS_TRACE: "apg-trace",
    CLASS_GRAMMAR: "apg-grammar",
    CLASS_RULES: "apg-rules",
    CLASS_RULESLINK: "apg-rules-link",
    CLASS_ATTRIBUTES: "apg-attrs"
};

});

parcelRegister("6QrXI", function(module, exports) {

$parcel$export(module.exports, "decode", () => $4fbd4a1aa876cd58$export$2f872c0f2117be69, (v) => $4fbd4a1aa876cd58$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "encode", () => $4fbd4a1aa876cd58$export$c564cdbbe6da493, (v) => $4fbd4a1aa876cd58$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "convert", () => $4fbd4a1aa876cd58$export$9c68d69a4c5bbcf9, (v) => $4fbd4a1aa876cd58$export$9c68d69a4c5bbcf9 = v);
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes the public encoding, decoding and conversion functions.
// Its private functions provide the disassembling and interpetation of the source and destination encoding types.
// In the case of Unicode encodings, private functions determine the presence of Byte Order Marks (BOMs), if any.
//
// Throws "TypeError" exceptions on input errors.
//
// The public decoding function. Returns an array of integers.
var $4fbd4a1aa876cd58$export$2f872c0f2117be69;
// The public encoding function. Returns a Buffer-typed byte array.
var $4fbd4a1aa876cd58$export$c564cdbbe6da493;
var $4fbd4a1aa876cd58$export$9c68d69a4c5bbcf9;
"use strict;";

var $7ts9d = parcelRequire("7ts9d");
var $4fbd4a1aa876cd58$require$Buffer = $7ts9d.Buffer;

var $9qEcm = parcelRequire("9qEcm");
/* types */ const $4fbd4a1aa876cd58$var$UTF8 = "UTF8";
const $4fbd4a1aa876cd58$var$UTF16 = "UTF16";
const $4fbd4a1aa876cd58$var$UTF16BE = "UTF16BE";
const $4fbd4a1aa876cd58$var$UTF16LE = "UTF16LE";
const $4fbd4a1aa876cd58$var$UTF32 = "UTF32";
const $4fbd4a1aa876cd58$var$UTF32BE = "UTF32BE";
const $4fbd4a1aa876cd58$var$UTF32LE = "UTF32LE";
const $4fbd4a1aa876cd58$var$UINT7 = "UINT7";
const $4fbd4a1aa876cd58$var$ASCII = "ASCII";
const $4fbd4a1aa876cd58$var$BINARY = "BINARY";
const $4fbd4a1aa876cd58$var$UINT8 = "UINT8";
const $4fbd4a1aa876cd58$var$UINT16 = "UINT16";
const $4fbd4a1aa876cd58$var$UINT16LE = "UINT16LE";
const $4fbd4a1aa876cd58$var$UINT16BE = "UINT16BE";
const $4fbd4a1aa876cd58$var$UINT32 = "UINT32";
const $4fbd4a1aa876cd58$var$UINT32LE = "UINT32LE";
const $4fbd4a1aa876cd58$var$UINT32BE = "UINT32BE";
const $4fbd4a1aa876cd58$var$ESCAPED = "ESCAPED";
const $4fbd4a1aa876cd58$var$STRING = "STRING";
/* private functions */ // Find the UTF8 BOM, if any.
const $4fbd4a1aa876cd58$var$bom8 = function bom8(src) {
    src.type = $4fbd4a1aa876cd58$var$UTF8;
    const buf = src.data;
    src.bom = 0;
    if (buf.length >= 3) {
        if (buf[0] === 0xef && buf[1] === 0xbb && buf[2] === 0xbf) src.bom = 3;
    }
};
// Find the UTF16 BOM, if any, and determine the UTF16 type.
// Defaults to UTF16BE.
// Throws TypeError exception if BOM does not match the specified type.
const $4fbd4a1aa876cd58$var$bom16 = function bom16(src) {
    const buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $4fbd4a1aa876cd58$var$UTF16:
            src.type = $4fbd4a1aa876cd58$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) {
                    src.type = $4fbd4a1aa876cd58$var$UTF16LE;
                    src.bom = 2;
                }
            }
            break;
        case $4fbd4a1aa876cd58$var$UTF16BE:
            src.type = $4fbd4a1aa876cd58$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) throw new TypeError(`src type: "${$4fbd4a1aa876cd58$var$UTF16BE}" specified but BOM is for "${$4fbd4a1aa876cd58$var$UTF16LE}"`);
            }
            break;
        case $4fbd4a1aa876cd58$var$UTF16LE:
            src.type = $4fbd4a1aa876cd58$var$UTF16LE;
            if (buf.length >= 0) {
                if (buf[0] === 0xfe && buf[1] === 0xff) throw new TypeError(`src type: "${$4fbd4a1aa876cd58$var$UTF16LE}" specified but BOM is for "${$4fbd4a1aa876cd58$var$UTF16BE}"`);
                else if (buf[0] === 0xff && buf[1] === 0xfe) src.bom = 2;
            }
            break;
        default:
            throw new TypeError(`UTF16 BOM: src type "${src.type}" unrecognized`);
    }
};
// Find the UTF32 BOM, if any, and determine the UTF32 type.
// Defaults to UTF32BE.
// Throws exception if BOM does not match the specified type.
const $4fbd4a1aa876cd58$var$bom32 = function bom32(src) {
    const buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $4fbd4a1aa876cd58$var$UTF32:
            src.type = $4fbd4a1aa876cd58$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
                    src.type = $4fbd4a1aa876cd58$var$UTF32LE;
                    src.bom = 4;
                }
            }
            break;
        case $4fbd4a1aa876cd58$var$UTF32BE:
            src.type = $4fbd4a1aa876cd58$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) throw new TypeError(`src type: ${$4fbd4a1aa876cd58$var$UTF32BE} specified but BOM is for ${$4fbd4a1aa876cd58$var$UTF32LE}"`);
            }
            break;
        case $4fbd4a1aa876cd58$var$UTF32LE:
            src.type = $4fbd4a1aa876cd58$var$UTF32LE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) throw new TypeError(`src type: "${$4fbd4a1aa876cd58$var$UTF32LE}" specified but BOM is for "${$4fbd4a1aa876cd58$var$UTF32BE}"`);
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) src.bom = 4;
            }
            break;
        default:
            throw new TypeError(`UTF32 BOM: src type "${src.type}" unrecognized`);
    }
};
// Validates the source encoding type and matching data.
// If the BASE64: prefix is present, the base 64 decoding is done here as the initial step.
// - For type STRING, data must be a JavaScript string.
// - For type BASE64:*, data may be a string or Buffer.
// - For all other types, data must be a Buffer.
// - The BASE64: prefix is not allowed for type STRING.
const $4fbd4a1aa876cd58$var$validateSrc = function validateSrc(type, data) {
    function getType(typeArg) {
        const ret = {
            type: "",
            base64: false
        };
        const rx = /^(base64:)?([a-zA-Z0-9]+)$/i;
        const result = rx.exec(typeArg);
        if (result) {
            if (result[2]) ret.type = result[2].toUpperCase();
            if (result[1]) ret.base64 = true;
        }
        return ret;
    }
    const ret = getType(type.toUpperCase());
    if (ret.base64) {
        /* handle base 64 */ if (ret.type === $4fbd4a1aa876cd58$var$STRING) throw new TypeError(`type: "${type} "BASE64:" prefix not allowed with type ${$4fbd4a1aa876cd58$var$STRING}`);
        if ($4fbd4a1aa876cd58$require$Buffer.isBuffer(data)) ret.data = $9qEcm.base64.decode(data);
        else if (typeof data === "string") {
            const buf = $4fbd4a1aa876cd58$require$Buffer.from(data, "ascii");
            ret.data = $9qEcm.base64.decode(buf);
        } else throw new TypeError(`type: "${type} unrecognized data type: typeof(data): ${typeof data}`);
    } else ret.data = data;
    switch(ret.type){
        case $4fbd4a1aa876cd58$var$UTF8:
            $4fbd4a1aa876cd58$var$bom8(ret);
            break;
        case $4fbd4a1aa876cd58$var$UTF16:
        case $4fbd4a1aa876cd58$var$UTF16BE:
        case $4fbd4a1aa876cd58$var$UTF16LE:
            $4fbd4a1aa876cd58$var$bom16(ret);
            break;
        case $4fbd4a1aa876cd58$var$UTF32:
        case $4fbd4a1aa876cd58$var$UTF32BE:
        case $4fbd4a1aa876cd58$var$UTF32LE:
            $4fbd4a1aa876cd58$var$bom32(ret);
            break;
        case $4fbd4a1aa876cd58$var$UINT16:
            ret.type = $4fbd4a1aa876cd58$var$UINT16BE;
            break;
        case $4fbd4a1aa876cd58$var$UINT32:
            ret.type = $4fbd4a1aa876cd58$var$UINT32BE;
            break;
        case $4fbd4a1aa876cd58$var$ASCII:
            ret.type = $4fbd4a1aa876cd58$var$UINT7;
            break;
        case $4fbd4a1aa876cd58$var$BINARY:
            ret.type = $4fbd4a1aa876cd58$var$UINT8;
            break;
        case $4fbd4a1aa876cd58$var$UINT7:
        case $4fbd4a1aa876cd58$var$UINT8:
        case $4fbd4a1aa876cd58$var$UINT16LE:
        case $4fbd4a1aa876cd58$var$UINT16BE:
        case $4fbd4a1aa876cd58$var$UINT32LE:
        case $4fbd4a1aa876cd58$var$UINT32BE:
        case $4fbd4a1aa876cd58$var$STRING:
        case $4fbd4a1aa876cd58$var$ESCAPED:
            break;
        default:
            throw new TypeError(`type: "${type}" not recognized`);
    }
    if (ret.type === $4fbd4a1aa876cd58$var$STRING) {
        if (typeof ret.data !== "string") throw new TypeError(`type: "${type}" but data is not a string`);
    } else if (!$4fbd4a1aa876cd58$require$Buffer.isBuffer(ret.data)) throw new TypeError(`type: "${type}" but data is not a Buffer`);
    return ret;
};
// Disassembles and validates the destination type.
// `chars` must be an Array of integers.
// The :BASE64 suffix is not allowed for type STRING.
const $4fbd4a1aa876cd58$var$validateDst = function validateDst(type, chars) {
    function getType(typeArg) {
        let fix;
        let rem;
        const ret = {
            crlf: false,
            lf: false,
            base64: false,
            type: ""
        };
        /* prefix, if any */ const TRUE = true;
        while(TRUE){
            rem = typeArg;
            fix = typeArg.slice(0, 5);
            if (fix === "CRLF:") {
                ret.crlf = true;
                rem = typeArg.slice(5);
                break;
            }
            fix = typeArg.slice(0, 3);
            if (fix === "LF:") {
                ret.lf = true;
                rem = typeArg.slice(3);
                break;
            }
            break;
        }
        /* suffix, if any */ fix = rem.split(":");
        if (fix.length === 1) // eslint-disable-next-line prefer-destructuring
        ret.type = fix[0];
        else if (fix.length === 2 && fix[1] === "BASE64") {
            ret.base64 = true;
            // eslint-disable-next-line prefer-destructuring
            ret.type = fix[0];
        }
        return ret;
    }
    if (!Array.isArray(chars)) throw new TypeError(`dst chars: not array: "${typeof chars}`);
    if (typeof type !== "string") throw new TypeError(`dst type: not string: "${typeof type}`);
    const ret = getType(type.toUpperCase());
    switch(ret.type){
        case $4fbd4a1aa876cd58$var$UTF8:
        case $4fbd4a1aa876cd58$var$UTF16BE:
        case $4fbd4a1aa876cd58$var$UTF16LE:
        case $4fbd4a1aa876cd58$var$UTF32BE:
        case $4fbd4a1aa876cd58$var$UTF32LE:
        case $4fbd4a1aa876cd58$var$UINT7:
        case $4fbd4a1aa876cd58$var$UINT8:
        case $4fbd4a1aa876cd58$var$UINT16LE:
        case $4fbd4a1aa876cd58$var$UINT16BE:
        case $4fbd4a1aa876cd58$var$UINT32LE:
        case $4fbd4a1aa876cd58$var$UINT32BE:
        case $4fbd4a1aa876cd58$var$ESCAPED:
            break;
        case $4fbd4a1aa876cd58$var$STRING:
            if (ret.base64) throw new TypeError(`":BASE64" suffix not allowed with type ${$4fbd4a1aa876cd58$var$STRING}`);
            break;
        case $4fbd4a1aa876cd58$var$ASCII:
            ret.type = $4fbd4a1aa876cd58$var$UINT7;
            break;
        case $4fbd4a1aa876cd58$var$BINARY:
            ret.type = $4fbd4a1aa876cd58$var$UINT8;
            break;
        case $4fbd4a1aa876cd58$var$UTF16:
            ret.type = $4fbd4a1aa876cd58$var$UTF16BE;
            break;
        case $4fbd4a1aa876cd58$var$UTF32:
            ret.type = $4fbd4a1aa876cd58$var$UTF32BE;
            break;
        case $4fbd4a1aa876cd58$var$UINT16:
            ret.type = $4fbd4a1aa876cd58$var$UINT16BE;
            break;
        case $4fbd4a1aa876cd58$var$UINT32:
            ret.type = $4fbd4a1aa876cd58$var$UINT32BE;
            break;
        default:
            throw new TypeError(`dst type unrecognized: "${type}" : must have form [crlf:|lf:]type[:base64]`);
    }
    return ret;
};
// Select and call the requested encoding function.
const $4fbd4a1aa876cd58$var$encode = function encode(type, chars) {
    switch(type){
        case $4fbd4a1aa876cd58$var$UTF8:
            return $9qEcm.utf8.encode(chars);
        case $4fbd4a1aa876cd58$var$UTF16BE:
            return $9qEcm.utf16be.encode(chars);
        case $4fbd4a1aa876cd58$var$UTF16LE:
            return $9qEcm.utf16le.encode(chars);
        case $4fbd4a1aa876cd58$var$UTF32BE:
            return $9qEcm.utf32be.encode(chars);
        case $4fbd4a1aa876cd58$var$UTF32LE:
            return $9qEcm.utf32le.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT7:
            return $9qEcm.uint7.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT8:
            return $9qEcm.uint8.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT16BE:
            return $9qEcm.uint16be.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT16LE:
            return $9qEcm.uint16le.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT32BE:
            return $9qEcm.uint32be.encode(chars);
        case $4fbd4a1aa876cd58$var$UINT32LE:
            return $9qEcm.uint32le.encode(chars);
        case $4fbd4a1aa876cd58$var$STRING:
            return $9qEcm.string.encode(chars);
        case $4fbd4a1aa876cd58$var$ESCAPED:
            return $9qEcm.escaped.encode(chars);
        default:
            throw new TypeError(`encode type "${type}" not recognized`);
    }
};
// Select and call the requested decoding function.
// `src` contains BOM information as well as the source type and data.
const $4fbd4a1aa876cd58$var$decode = function decode(src) {
    switch(src.type){
        case $4fbd4a1aa876cd58$var$UTF8:
            return $9qEcm.utf8.decode(src.data, src.bom);
        case $4fbd4a1aa876cd58$var$UTF16LE:
            return $9qEcm.utf16le.decode(src.data, src.bom);
        case $4fbd4a1aa876cd58$var$UTF16BE:
            return $9qEcm.utf16be.decode(src.data, src.bom);
        case $4fbd4a1aa876cd58$var$UTF32BE:
            return $9qEcm.utf32be.decode(src.data, src.bom);
        case $4fbd4a1aa876cd58$var$UTF32LE:
            return $9qEcm.utf32le.decode(src.data, src.bom);
        case $4fbd4a1aa876cd58$var$UINT7:
            return $9qEcm.uint7.decode(src.data);
        case $4fbd4a1aa876cd58$var$UINT8:
            return $9qEcm.uint8.decode(src.data);
        case $4fbd4a1aa876cd58$var$UINT16BE:
            return $9qEcm.uint16be.decode(src.data);
        case $4fbd4a1aa876cd58$var$UINT16LE:
            return $9qEcm.uint16le.decode(src.data);
        case $4fbd4a1aa876cd58$var$UINT32BE:
            return $9qEcm.uint32be.decode(src.data);
        case $4fbd4a1aa876cd58$var$UINT32LE:
            return $9qEcm.uint32le.decode(src.data);
        case $4fbd4a1aa876cd58$var$STRING:
            return $9qEcm.string.decode(src.data);
        case $4fbd4a1aa876cd58$var$ESCAPED:
            return $9qEcm.escaped.decode(src.data);
        default:
            throw new TypeError(`decode type "${src.type}" not recognized`);
    }
};
$4fbd4a1aa876cd58$export$2f872c0f2117be69 = function exportsDecode(type, data) {
    const src = $4fbd4a1aa876cd58$var$validateSrc(type, data);
    return $4fbd4a1aa876cd58$var$decode(src);
};
$4fbd4a1aa876cd58$export$c564cdbbe6da493 = function exportsEncode(type, chars) {
    let c;
    let buf;
    const dst = $4fbd4a1aa876cd58$var$validateDst(type, chars);
    if (dst.crlf) {
        /* prefix with CRLF line end conversion, don't contaminate caller's chars array */ c = $9qEcm.lineEnds.crlf(chars);
        buf = $4fbd4a1aa876cd58$var$encode(dst.type, c);
    } else if (dst.lf) {
        /* prefix with LF line end conversion, don't contaminate caller's chars array */ c = $9qEcm.lineEnds.lf(chars);
        buf = $4fbd4a1aa876cd58$var$encode(dst.type, c);
    } else buf = $4fbd4a1aa876cd58$var$encode(dst.type, chars);
    if (dst.base64) /* post base 64 encoding */ buf = $9qEcm.base64.encode(buf);
    return buf;
};
// Converts data of type `srcType` to data of type `dstType`.
// `srcData` may be a JavaScript String, or node.js Buffer, depending on the corresponding type.
const $4fbd4a1aa876cd58$var$convert = function convert(srcType, srcData, dstType) {
    return $4fbd4a1aa876cd58$export$c564cdbbe6da493(dstType, $4fbd4a1aa876cd58$export$2f872c0f2117be69(srcType, srcData));
};
$4fbd4a1aa876cd58$export$9c68d69a4c5bbcf9 = $4fbd4a1aa876cd58$var$convert;

});
parcelRegister("9qEcm", function(module, exports) {

$parcel$export(module.exports, "utf8", () => $6dd5b955d61beb8d$export$74329b762b589566, (v) => $6dd5b955d61beb8d$export$74329b762b589566 = v);
$parcel$export(module.exports, "utf16be", () => $6dd5b955d61beb8d$export$8b9ec48b10867f55, (v) => $6dd5b955d61beb8d$export$8b9ec48b10867f55 = v);
$parcel$export(module.exports, "utf16le", () => $6dd5b955d61beb8d$export$38eba41b60a2d16f, (v) => $6dd5b955d61beb8d$export$38eba41b60a2d16f = v);
$parcel$export(module.exports, "utf32be", () => $6dd5b955d61beb8d$export$197feba3617118ca, (v) => $6dd5b955d61beb8d$export$197feba3617118ca = v);
$parcel$export(module.exports, "utf32le", () => $6dd5b955d61beb8d$export$8ab18849c577cec0, (v) => $6dd5b955d61beb8d$export$8ab18849c577cec0 = v);
$parcel$export(module.exports, "uint7", () => $6dd5b955d61beb8d$export$b0c04bc19f7bc936, (v) => $6dd5b955d61beb8d$export$b0c04bc19f7bc936 = v);
$parcel$export(module.exports, "uint8", () => $6dd5b955d61beb8d$export$52e103c63c4e68cf, (v) => $6dd5b955d61beb8d$export$52e103c63c4e68cf = v);
$parcel$export(module.exports, "uint16be", () => $6dd5b955d61beb8d$export$60dfe43c8297a8f8, (v) => $6dd5b955d61beb8d$export$60dfe43c8297a8f8 = v);
$parcel$export(module.exports, "uint16le", () => $6dd5b955d61beb8d$export$b92d76f0ca6d1789, (v) => $6dd5b955d61beb8d$export$b92d76f0ca6d1789 = v);
$parcel$export(module.exports, "uint32be", () => $6dd5b955d61beb8d$export$74c16dba6c885532, (v) => $6dd5b955d61beb8d$export$74c16dba6c885532 = v);
$parcel$export(module.exports, "uint32le", () => $6dd5b955d61beb8d$export$5f744bb30a534bc9, (v) => $6dd5b955d61beb8d$export$5f744bb30a534bc9 = v);
$parcel$export(module.exports, "string", () => $6dd5b955d61beb8d$export$22b082955e083ec3, (v) => $6dd5b955d61beb8d$export$22b082955e083ec3 = v);
$parcel$export(module.exports, "escaped", () => $6dd5b955d61beb8d$export$a005f694cca0c8bd, (v) => $6dd5b955d61beb8d$export$a005f694cca0c8bd = v);
$parcel$export(module.exports, "lineEnds", () => $6dd5b955d61beb8d$export$835798d3a82482b, (v) => $6dd5b955d61beb8d$export$835798d3a82482b = v);
$parcel$export(module.exports, "base64", () => $6dd5b955d61beb8d$export$b3b2de96497acc47, (v) => $6dd5b955d61beb8d$export$b3b2de96497acc47 = v);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-plusplus */ /* eslint-disable no-bitwise */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module contains the actual encoding and decoding algorithms.
// Throws "RangeError" exceptions on characters or bytes out of range for the given encoding.
// The UTF8 algorithms.
var $6dd5b955d61beb8d$export$74329b762b589566;
// The UTF16BE algorithms.
var $6dd5b955d61beb8d$export$8b9ec48b10867f55;
// The UTF16LE algorithms.
var $6dd5b955d61beb8d$export$38eba41b60a2d16f;
// The UTF32BE algorithms.
var $6dd5b955d61beb8d$export$197feba3617118ca;
// The UTF32LE algorithms.
var $6dd5b955d61beb8d$export$8ab18849c577cec0;
// The UINT7 algorithms. ASCII or 7-bit unsigned integers.
var $6dd5b955d61beb8d$export$b0c04bc19f7bc936;
// The UINT8 algorithms. BINARY, Latin 1 or 8-bit unsigned integers.
var $6dd5b955d61beb8d$export$52e103c63c4e68cf;
// The UINT16BE algorithms. Big-endian 16-bit unsigned integers.
var $6dd5b955d61beb8d$export$60dfe43c8297a8f8;
// The UINT16LE algorithms. Little-endian 16-bit unsigned integers.
var $6dd5b955d61beb8d$export$b92d76f0ca6d1789;
// The UINT32BE algorithms. Big-endian 32-bit unsigned integers.
var $6dd5b955d61beb8d$export$74c16dba6c885532;
// The UINT32LE algorithms. Little-endian 32-bit unsigned integers.
var $6dd5b955d61beb8d$export$5f744bb30a534bc9;
// The STRING algorithms. Converts JavaScript strings to Array of 32-bit integers and vice versa.
// Uses the node.js Buffer's native "utf16le" capabilites.
var $6dd5b955d61beb8d$export$22b082955e083ec3;
// The ESCAPED algorithms.
// Note that ESCAPED format contains only ASCII characters.
// The characters are always in the form of a Buffer of bytes.
var $6dd5b955d61beb8d$export$a005f694cca0c8bd;
var $6dd5b955d61beb8d$export$835798d3a82482b;
// The base 64 algorithms.
var $6dd5b955d61beb8d$export$b3b2de96497acc47;
"use strict;";

var $7ts9d = parcelRequire("7ts9d");
var $6dd5b955d61beb8d$require$Buffer = $7ts9d.Buffer;
/* decoding error codes */ const $6dd5b955d61beb8d$var$NON_SHORTEST = 0xfffffffc;
const $6dd5b955d61beb8d$var$TRAILING = 0xfffffffd;
const $6dd5b955d61beb8d$var$RANGE = 0xfffffffe;
const $6dd5b955d61beb8d$var$ILL_FORMED = 0xffffffff;
/* mask[n] = 2**n - 1, ie. mask[n] = n bits on. e.g. mask[6] = %b111111 */ const $6dd5b955d61beb8d$var$mask = [
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023
];
/* ascii[n] = 'HH', where 0xHH = n, eg. ascii[254] = 'FE' */ const $6dd5b955d61beb8d$var$ascii = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0A",
    "0B",
    "0C",
    "0D",
    "0E",
    "0F",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1A",
    "1B",
    "1C",
    "1D",
    "1E",
    "1F",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2A",
    "2B",
    "2C",
    "2D",
    "2E",
    "2F",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3A",
    "3B",
    "3C",
    "3D",
    "3E",
    "3F",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4A",
    "4B",
    "4C",
    "4D",
    "4E",
    "4F",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5A",
    "5B",
    "5C",
    "5D",
    "5E",
    "5F",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6A",
    "6B",
    "6C",
    "6D",
    "6E",
    "6F",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7A",
    "7B",
    "7C",
    "7D",
    "7E",
    "7F",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8A",
    "8B",
    "8C",
    "8D",
    "8E",
    "8F",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9A",
    "9B",
    "9C",
    "9D",
    "9E",
    "9F",
    "A0",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "B0",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "C0",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "C6",
    "C7",
    "C8",
    "C9",
    "CA",
    "CB",
    "CC",
    "CD",
    "CE",
    "CF",
    "D0",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
    "DA",
    "DB",
    "DC",
    "DD",
    "DE",
    "DF",
    "E0",
    "E1",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "EA",
    "EB",
    "EC",
    "ED",
    "EE",
    "EF",
    "F0",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "FA",
    "FB",
    "FC",
    "FD",
    "FE",
    "FF"
];
/* vector of base 64 characters */ const $6dd5b955d61beb8d$var$base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("");
/* vector of base 64 character codes */ const $6dd5b955d61beb8d$var$base64codes = [];
$6dd5b955d61beb8d$var$base64chars.forEach((char)=>{
    $6dd5b955d61beb8d$var$base64codes.push(char.charCodeAt(0));
});
$6dd5b955d61beb8d$export$74329b762b589566 = {
    encode (chars) {
        const bytes = [];
        chars.forEach((char)=>{
            if (char >= 0 && char <= 0x7f) bytes.push(char);
            else if (char <= 0x7ff) {
                bytes.push(0xc0 + (char >> 6 & $6dd5b955d61beb8d$var$mask[5]));
                bytes.push(0x80 + (char & $6dd5b955d61beb8d$var$mask[6]));
            } else if (char < 0xd800 || char > 0xdfff && char <= 0xffff) {
                bytes.push(0xe0 + (char >> 12 & $6dd5b955d61beb8d$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $6dd5b955d61beb8d$var$mask[6]));
                bytes.push(0x80 + (char & $6dd5b955d61beb8d$var$mask[6]));
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                const u = char >> 16 & $6dd5b955d61beb8d$var$mask[5];
                bytes.push(0xf0 + (u >> 2));
                bytes.push(0x80 + ((u & $6dd5b955d61beb8d$var$mask[2]) << 4) + (char >> 12 & $6dd5b955d61beb8d$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $6dd5b955d61beb8d$var$mask[6]));
                bytes.push(0x80 + (char & $6dd5b955d61beb8d$var$mask[6]));
            } else throw new RangeError(`utf8.encode: character out of range: char: ${char}`);
        });
        return $6dd5b955d61beb8d$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* bytes functions return error for non-shortest forms & values out of range */ function bytes2(b1, b2) {
            /* U+0080..U+07FF */ /* 00000000 00000yyy yyxxxxxx | 110yyyyy 10xxxxxx */ if ((b2 & 0xc0) !== 0x80) return $6dd5b955d61beb8d$var$TRAILING;
            const x = ((b1 & $6dd5b955d61beb8d$var$mask[5]) << 6) + (b2 & $6dd5b955d61beb8d$var$mask[6]);
            if (x < 0x80) return $6dd5b955d61beb8d$var$NON_SHORTEST;
            return x;
        }
        function bytes3(b1, b2, b3) {
            /* U+0800..U+FFFF */ /* 00000000 zzzzyyyy yyxxxxxx | 1110zzzz 10yyyyyy 10xxxxxx */ if ((b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $6dd5b955d61beb8d$var$TRAILING;
            const x = ((b1 & $6dd5b955d61beb8d$var$mask[4]) << 12) + ((b2 & $6dd5b955d61beb8d$var$mask[6]) << 6) + (b3 & $6dd5b955d61beb8d$var$mask[6]);
            if (x < 0x800) return $6dd5b955d61beb8d$var$NON_SHORTEST;
            if (x >= 0xd800 && x <= 0xdfff) return $6dd5b955d61beb8d$var$RANGE;
            return x;
        }
        function bytes4(b1, b2, b3, b4) {
            /* U+10000..U+10FFFF */ /* 000uuuuu zzzzyyyy yyxxxxxx | 11110uuu 10uuzzzz 10yyyyyy 10xxxxxx */ if ((b4 & 0xc0) !== 0x80 || (b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $6dd5b955d61beb8d$var$TRAILING;
            const x = (((b1 & $6dd5b955d61beb8d$var$mask[3]) << 2) + (b2 >> 4 & $6dd5b955d61beb8d$var$mask[2]) << 16) + ((b2 & $6dd5b955d61beb8d$var$mask[4]) << 12) + ((b3 & $6dd5b955d61beb8d$var$mask[6]) << 6) + (b4 & $6dd5b955d61beb8d$var$mask[6]);
            if (x < 0x10000) return $6dd5b955d61beb8d$var$NON_SHORTEST;
            if (x > 0x10ffff) return $6dd5b955d61beb8d$var$RANGE;
            return x;
        }
        let c;
        let b1;
        let i1;
        let i2;
        let i3;
        let inc;
        const len = buf.length;
        let i = bom ? 3 : 0;
        const chars = [];
        while(i < len){
            b1 = buf[i];
            c = $6dd5b955d61beb8d$var$ILL_FORMED;
            const TRUE = true;
            while(TRUE){
                if (b1 >= 0 && b1 <= 0x7f) {
                    /* U+0000..U+007F 00..7F */ c = b1;
                    inc = 1;
                    break;
                }
                i1 = i + 1;
                if (i1 < len && b1 >= 0xc2 && b1 <= 0xdf) {
                    /* U+0080..U+07FF C2..DF 80..BF */ c = bytes2(b1, buf[i1]);
                    inc = 2;
                    break;
                }
                i2 = i + 2;
                if (i2 < len && b1 >= 0xe0 && b1 <= 0xef) {
                    /* U+0800..U+FFFF */ c = bytes3(b1, buf[i1], buf[i2]);
                    inc = 3;
                    break;
                }
                i3 = i + 3;
                if (i3 < len && b1 >= 0xf0 && b1 <= 0xf4) {
                    /* U+10000..U+10FFFF */ c = bytes4(b1, buf[i1], buf[i2], buf[i3]);
                    inc = 4;
                    break;
                }
                break;
            }
            if (c > 0x10ffff) {
                const at = `byte[${i}]`;
                if (c === $6dd5b955d61beb8d$var$ILL_FORMED) throw new RangeError(`utf8.decode: ill-formed UTF8 byte sequence found at: ${at}`);
                if (c === $6dd5b955d61beb8d$var$TRAILING) throw new RangeError(`utf8.decode: illegal trailing byte found at: ${at}`);
                if (c === $6dd5b955d61beb8d$var$RANGE) throw new RangeError(`utf8.decode: code point out of range found at: ${at}`);
                if (c === $6dd5b955d61beb8d$var$NON_SHORTEST) throw new RangeError(`utf8.decode: non-shortest form found at: ${at}`);
                throw new RangeError(`utf8.decode: unrecognized error found at: ${at}`);
            }
            chars.push(c);
            i += inc;
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$8b9ec48b10867f55 = {
    encode (chars) {
        const bytes = [];
        let char;
        let h;
        let l;
        for(let i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char >> 8 & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(char & $6dd5b955d61beb8d$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $6dd5b955d61beb8d$var$mask[10]);
                bytes.push(h >> 8 & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(h & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(l >> 8 & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(l & $6dd5b955d61beb8d$var$mask[8]);
            } else throw new RangeError(`utf16be.encode: UTF16BE value out of range: char[${i}]: ${char}`);
        }
        return $6dd5b955d61beb8d$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError(`utf16be.decode: data length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        const len = buf.length;
        let i = bom ? 2 : 0;
        let j = 0;
        let c;
        let inc;
        let i1;
        let i3;
        let high;
        let low;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i] << 8) + buf[i1];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i + 2] << 8) + buf[i3];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError(`utf16be.decode: ill-formed UTF16BE byte sequence found: byte[${i}]`);
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$38eba41b60a2d16f = {
    encode (chars) {
        const bytes = [];
        let char;
        let h;
        let l;
        for(let i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(char >> 8 & $6dd5b955d61beb8d$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $6dd5b955d61beb8d$var$mask[10]);
                bytes.push(h & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(h >> 8 & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(l & $6dd5b955d61beb8d$var$mask[8]);
                bytes.push(l >> 8 & $6dd5b955d61beb8d$var$mask[8]);
            } else throw new RangeError(`utf16le.encode: UTF16LE value out of range: char[${i}]: ${char}`);
        }
        return $6dd5b955d61beb8d$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError(`utf16le.decode: data length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        const len = buf.length;
        let i = bom ? 2 : 0;
        let j = 0;
        let c;
        let inc;
        let i1;
        let i3;
        let high;
        let low;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i1] << 8) + buf[i];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i3] << 8) + buf[i + 2];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError(`utf16le.decode: ill-formed UTF16LE byte sequence found: byte[${i}]`);
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$197feba3617118ca = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32be.encode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
            buf[i++] = char >> 24 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        let i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            const char = (buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32be.decode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
            chars.push(char);
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$8ab18849c577cec0 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 24 & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        let i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            const char = (buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
            chars.push(char);
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$b0c04bc19f7bc936 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length);
        for(let i = 0; i < chars.length; i += 1){
            if (chars[i] > 0x7f) throw new RangeError(`uint7.encode: UINT7 character code out of range: char[${i}]: ${chars[i]}`);
            buf[i] = chars[i];
        }
        return buf;
    },
    decode (buf) {
        const chars = [];
        for(let i = 0; i < buf.length; i += 1){
            if (buf[i] > 0x7f) throw new RangeError(`uint7.decode: UINT7 character code out of range: byte[${i}]: ${buf[i]}`);
            chars[i] = buf[i];
        }
        return chars;
    }
};
$6dd5b955d61beb8d$export$52e103c63c4e68cf = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length);
        for(let i = 0; i < chars.length; i += 1){
            if (chars[i] > 0xff) throw new RangeError(`uint8.encode: UINT8 character code out of range: char[${i}]: ${chars[i]}`);
            buf[i] = chars[i];
        }
        return buf;
    },
    decode (buf) {
        const chars = [];
        for(let i = 0; i < buf.length; i += 1)chars[i] = buf[i];
        return chars;
    }
};
$6dd5b955d61beb8d$export$60dfe43c8297a8f8 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 2);
        let i = 0;
        chars.forEach((char)=>{
            if (char > 0xffff) throw new RangeError(`uint16be.encode: UINT16BE character code out of range: char[${i / 2}]: ${char}`);
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 2 > 0) throw new RangeError(`uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 2)chars.push((buf[i] << 8) + buf[i + 1]);
        return chars;
    }
};
$6dd5b955d61beb8d$export$b92d76f0ca6d1789 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 2);
        let i = 0;
        chars.forEach((char)=>{
            if (char > 0xffff) throw new RangeError(`uint16le.encode: UINT16LE character code out of range: char[${i / 2}]: ${char}`);
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 2 > 0) throw new RangeError(`uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 2)chars.push((buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
$6dd5b955d61beb8d$export$74c16dba6c885532 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            buf[i++] = char >> 24 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 4 > 0) throw new RangeError(`uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 4)chars.push((buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3]);
        return chars;
    }
};
$6dd5b955d61beb8d$export$5f744bb30a534bc9 = {
    encode (chars) {
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            buf[i++] = char & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[i++] = char >> 24 & $6dd5b955d61beb8d$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 4)chars.push((buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
$6dd5b955d61beb8d$export$22b082955e083ec3 = {
    encode (chars) {
        return $6dd5b955d61beb8d$export$38eba41b60a2d16f.encode(chars).toString("utf16le");
    },
    decode (str) {
        return $6dd5b955d61beb8d$export$38eba41b60a2d16f.decode($6dd5b955d61beb8d$require$Buffer.from(str, "utf16le"), 0);
    }
};
$6dd5b955d61beb8d$export$a005f694cca0c8bd = {
    // Encodes an Array of 32-bit integers into ESCAPED format.
    encode (chars) {
        const bytes = [];
        for(let i = 0; i < chars.length; i += 1){
            const char = chars[i];
            if (char === 96) {
                bytes.push(char);
                bytes.push(char);
            } else if (char === 10) bytes.push(char);
            else if (char >= 32 && char <= 126) bytes.push(char);
            else {
                let str = "";
                if (char >= 0 && char <= 31) str += `\`x${$6dd5b955d61beb8d$var$ascii[char]}`;
                else if (char >= 127 && char <= 255) str += `\`x${$6dd5b955d61beb8d$var$ascii[char]}`;
                else if (char >= 0x100 && char <= 0xffff) str += `\`u${$6dd5b955d61beb8d$var$ascii[char >> 8 & $6dd5b955d61beb8d$var$mask[8]]}${$6dd5b955d61beb8d$var$ascii[char & $6dd5b955d61beb8d$var$mask[8]]}`;
                else if (char >= 0x10000 && char <= 0xffffffff) {
                    str += "`u{";
                    const digit = char >> 24 & $6dd5b955d61beb8d$var$mask[8];
                    if (digit > 0) str += $6dd5b955d61beb8d$var$ascii[digit];
                    str += `${$6dd5b955d61beb8d$var$ascii[char >> 16 & $6dd5b955d61beb8d$var$mask[8]] + $6dd5b955d61beb8d$var$ascii[char >> 8 & $6dd5b955d61beb8d$var$mask[8]] + $6dd5b955d61beb8d$var$ascii[char & $6dd5b955d61beb8d$var$mask[8]]}}`;
                } else throw new Error("escape.encode(char): char > 0xffffffff not allowed");
                const buf = $6dd5b955d61beb8d$require$Buffer.from(str);
                buf.forEach((b)=>{
                    bytes.push(b);
                });
            }
        }
        return $6dd5b955d61beb8d$require$Buffer.from(bytes);
    },
    // Decodes ESCAPED format from a Buffer of bytes to an Array of 32-bit integers.
    decode (buf) {
        function isHex(hex) {
            if (hex >= 48 && hex <= 57 || hex >= 65 && hex <= 70 || hex >= 97 && hex <= 102) return true;
            return false;
        }
        function getx(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 2,
                error: true
            };
            if (i + 1 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1])) {
                    const str = String.fromCodePoint(bufArg[i], bufArg[i + 1]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getu(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            if (i + 3 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1]) && isHex(bufArg[i + 2]) && isHex(bufArg[i + 3])) {
                    const str = String.fromCodePoint(bufArg[i], bufArg[i + 1], bufArg[i + 2], bufArg[i + 3]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getU(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            let str = "";
            while(i < len && isHex(bufArg[i])){
                str += String.fromCodePoint(bufArg[i]);
                // eslint-disable-next-line no-param-reassign
                i += 1;
            }
            ret.char = parseInt(str, 16);
            if (bufArg[i] === 125 && !Number.isNaN(ret.char)) ret.error = false;
            ret.nexti = i + 1;
            return ret;
        }
        const chars = [];
        const len = buf.length;
        let i1;
        let ret;
        let error;
        let i = 0;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                error = true;
                if (buf[i] !== 96) {
                    /* unescaped character */ chars.push(buf[i]);
                    i += 1;
                    error = false;
                    break;
                }
                i1 = i + 1;
                if (i1 >= len) break;
                if (buf[i1] === 96) {
                    /* escaped grave accent */ chars.push(96);
                    i += 2;
                    error = false;
                    break;
                }
                if (buf[i1] === 120) {
                    ret = getx(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped hex */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                if (buf[i1] === 117) {
                    if (buf[i1 + 1] === 123) {
                        ret = getU(i1 + 2, len, buf);
                        if (ret.error) break;
                        /* escaped utf-32 */ chars.push(ret.char);
                        i = ret.nexti;
                        error = false;
                        break;
                    }
                    ret = getu(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped utf-16 */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                break;
            }
            if (error) throw new Error(`escaped.decode: ill-formed escape sequence at buf[${i}]`);
        }
        return chars;
    }
};
// The line end conversion algorigthms.
const $6dd5b955d61beb8d$var$CR = 13;
const $6dd5b955d61beb8d$var$LF = 10;
$6dd5b955d61beb8d$export$835798d3a82482b = {
    crlf (chars) {
        const lfchars = [];
        let i = 0;
        while(i < chars.length)switch(chars[i]){
            case $6dd5b955d61beb8d$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $6dd5b955d61beb8d$var$LF) i += 2;
                else i += 1;
                lfchars.push($6dd5b955d61beb8d$var$CR);
                lfchars.push($6dd5b955d61beb8d$var$LF);
                break;
            case $6dd5b955d61beb8d$var$LF:
                lfchars.push($6dd5b955d61beb8d$var$CR);
                lfchars.push($6dd5b955d61beb8d$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $6dd5b955d61beb8d$var$LF) {
            lfchars.push($6dd5b955d61beb8d$var$CR);
            lfchars.push($6dd5b955d61beb8d$var$LF);
        }
        return lfchars;
    },
    lf (chars) {
        const lfchars = [];
        let i = 0;
        while(i < chars.length)switch(chars[i]){
            case $6dd5b955d61beb8d$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $6dd5b955d61beb8d$var$LF) i += 2;
                else i += 1;
                lfchars.push($6dd5b955d61beb8d$var$LF);
                break;
            case $6dd5b955d61beb8d$var$LF:
                lfchars.push($6dd5b955d61beb8d$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $6dd5b955d61beb8d$var$LF) lfchars.push($6dd5b955d61beb8d$var$LF);
        return lfchars;
    }
};
$6dd5b955d61beb8d$export$b3b2de96497acc47 = {
    encode (buf) {
        if (buf.length === 0) return $6dd5b955d61beb8d$require$Buffer.alloc(0);
        let i;
        let j;
        let n;
        let tail = buf.length % 3;
        tail = tail > 0 ? 3 - tail : 0;
        let units = (buf.length + tail) / 3;
        const base64 = $6dd5b955d61beb8d$require$Buffer.alloc(units * 4);
        if (tail > 0) units -= 1;
        i = 0;
        j = 0;
        for(let u = 0; u < units; u += 1){
            n = buf[i++] << 16;
            n += buf[i++] << 8;
            n += buf[i++];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 18 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 12 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 6 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n & $6dd5b955d61beb8d$var$mask[6]];
        }
        if (tail === 0) return base64;
        if (tail === 1) {
            n = buf[i++] << 16;
            n += buf[i] << 8;
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 18 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 12 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 6 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j] = $6dd5b955d61beb8d$var$base64codes[64];
            return base64;
        }
        if (tail === 2) {
            n = buf[i] << 16;
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 18 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[n >> 12 & $6dd5b955d61beb8d$var$mask[6]];
            base64[j++] = $6dd5b955d61beb8d$var$base64codes[64];
            base64[j] = $6dd5b955d61beb8d$var$base64codes[64];
            return base64;
        }
        return undefined;
    },
    decode (codes) {
        /* remove white space and ctrl characters, validate & translate characters */ function validate(buf) {
            const chars = [];
            let tail = 0;
            for(let i = 0; i < buf.length; i += 1){
                const char = buf[i];
                const TRUE = true;
                while(TRUE){
                    if (char === 32 || char === 9 || char === 10 || char === 13) break;
                    if (char >= 65 && char <= 90) {
                        chars.push(char - 65);
                        break;
                    }
                    if (char >= 97 && char <= 122) {
                        chars.push(char - 71);
                        break;
                    }
                    if (char >= 48 && char <= 57) {
                        chars.push(char + 4);
                        break;
                    }
                    if (char === 43) {
                        chars.push(62);
                        break;
                    }
                    if (char === 47) {
                        chars.push(63);
                        break;
                    }
                    if (char === 61) {
                        chars.push(64);
                        tail += 1;
                        break;
                    }
                    /* invalid character */ throw new RangeError(`base64.decode: invalid character buf[${i}]: ${char}`);
                }
            }
            /* validate length */ if (chars.length % 4 > 0) throw new RangeError(`base64.decode: string length not integral multiple of 4: ${chars.length}`);
            /* validate tail */ switch(tail){
                case 0:
                    break;
                case 1:
                    if (chars[chars.length - 1] !== 64) throw new RangeError("base64.decode: one tail character found: not last character");
                    break;
                case 2:
                    if (chars[chars.length - 1] !== 64 || chars[chars.length - 2] !== 64) throw new RangeError("base64.decode: two tail characters found: not last characters");
                    break;
                default:
                    throw new RangeError(`base64.decode: more than two tail characters found: ${tail}`);
            }
            return {
                tail: tail,
                buf: $6dd5b955d61beb8d$require$Buffer.from(chars)
            };
        }
        if (codes.length === 0) return $6dd5b955d61beb8d$require$Buffer.alloc(0);
        const val = validate(codes);
        const { tail: tail } = val;
        const base64 = val.buf;
        let i;
        let j;
        let n;
        let units = base64.length / 4;
        const buf = $6dd5b955d61beb8d$require$Buffer.alloc(units * 3 - tail);
        if (tail > 0) units -= 1;
        j = 0;
        i = 0;
        for(let u = 0; u < units; u += 1){
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i++] << 6;
            n += base64[i++];
            buf[j++] = n >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[j++] = n >> 8 & $6dd5b955d61beb8d$var$mask[8];
            buf[j++] = n & $6dd5b955d61beb8d$var$mask[8];
        }
        if (tail === 1) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i] << 6;
            buf[j++] = n >> 16 & $6dd5b955d61beb8d$var$mask[8];
            buf[j] = n >> 8 & $6dd5b955d61beb8d$var$mask[8];
        }
        if (tail === 2) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            buf[j] = n >> 16 & $6dd5b955d61beb8d$var$mask[8];
        }
        return buf;
    },
    // Converts a base 64 Buffer of bytes to a JavaScript string with line breaks.
    toString (buf) {
        if (buf.length % 4 > 0) throw new RangeError(`base64.toString: input buffer length not multiple of 4: ${buf.length}`);
        let str = "";
        let lineLen = 0;
        function buildLine(c1, c2, c3, c4) {
            switch(lineLen){
                case 76:
                    str += `\r\n${c1}${c2}${c3}${c4}`;
                    lineLen = 4;
                    break;
                case 75:
                    str += `${c1}\r\n${c2}${c3}${c4}`;
                    lineLen = 3;
                    break;
                case 74:
                    str += `${c1 + c2}\r\n${c3}${c4}`;
                    lineLen = 2;
                    break;
                case 73:
                    str += `${c1 + c2 + c3}\r\n${c4}`;
                    lineLen = 1;
                    break;
                default:
                    str += c1 + c2 + c3 + c4;
                    lineLen += 4;
                    break;
            }
        }
        function validate(c) {
            if (c >= 65 && c <= 90) return true;
            if (c >= 97 && c <= 122) return true;
            if (c >= 48 && c <= 57) return true;
            if (c === 43) return true;
            if (c === 47) return true;
            if (c === 61) return true;
            return false;
        }
        for(let i = 0; i < buf.length; i += 4){
            for(let j = i; j < i + 4; j += 1){
                if (!validate(buf[j])) throw new RangeError(`base64.toString: buf[${j}]: ${buf[j]} : not valid base64 character code`);
            }
            buildLine(String.fromCharCode(buf[i]), String.fromCharCode(buf[i + 1]), String.fromCharCode(buf[i + 2]), String.fromCharCode(buf[i + 3]));
        }
        return str;
    }
};

});


parcelRegister("j7Qsi", function(module, exports) {
// This module has been developed programmatically in the `apg-lib` build process.
// It is used to build web pages programatically on the fly without the need for <script> or <style> tags.
module.exports = function emittcss() {
    return "/* This file automatically generated by jsonToless() and LESS. */\n.apg-mono {\n  font-family: monospace;\n}\n.apg-active {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-match {\n  font-weight: bold;\n  color: #264BFF;\n}\n.apg-empty {\n  font-weight: bold;\n  color: #0fbd0f;\n}\n.apg-nomatch {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-lh-match {\n  font-weight: bold;\n  color: #1A97BA;\n}\n.apg-lb-match {\n  font-weight: bold;\n  color: #5F1687;\n}\n.apg-remainder {\n  font-weight: bold;\n  color: #999999;\n}\n.apg-ctrl-char {\n  font-weight: bolder;\n  font-style: italic;\n  font-size: 0.6em;\n}\n.apg-line-end {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-error {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-phrase {\n  color: #000000;\n  background-color: #8caae6;\n}\n.apg-empty-phrase {\n  color: #0fbd0f;\n}\ntable.apg-state {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th,\ntable.apg-state td {\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th:nth-last-child(2),\ntable.apg-state td:nth-last-child(2) {\n  text-align: right;\n}\ntable.apg-state caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-stats {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats th,\ntable.apg-stats td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace th,\ntable.apg-trace td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace th:last-child,\ntable.apg-trace th:nth-last-child(2),\ntable.apg-trace td:last-child,\ntable.apg-trace td:nth-last-child(2) {\n  text-align: left;\n}\ntable.apg-grammar {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-grammar th,\ntable.apg-grammar td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar th:last-child,\ntable.apg-grammar td:last-child {\n  text-align: left;\n}\ntable.apg-rules {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-rules th,\ntable.apg-rules td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules a {\n  color: #003399 !important;\n}\ntable.apg-rules a:hover {\n  color: #8caae6 !important;\n}\ntable.apg-attrs {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-attrs th,\ntable.apg-attrs td {\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs th:nth-child(1),\ntable.apg-attrs th:nth-child(2),\ntable.apg-attrs th:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs td:nth-child(1),\ntable.apg-attrs td:nth-child(2),\ntable.apg-attrs td:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs a {\n  color: #003399 !important;\n}\ntable.apg-attrs a:hover {\n  color: #8caae6 !important;\n}\n";
};

});



parcelRegister("l9c3t", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module acts as a "circular buffer". It is used to keep track
// only the last N records in an array of records. If more than N records
// are saved, each additional record overwrites the previously oldest record.
// This module deals only with the record indexes and does not save
// any actual records. It is used by [`trace.js`](./trace.html) for limiting the number of
// trace records saved.
module.exports = function exportsCircularBuffer() {
    "use strict;";
    const thisFileName = "circular-buffer.js: ";
    let itemIndex = -1;
    let maxListSize = 0;
    // Initialize buffer.<br>
    // *size* is `maxListSize`, the maximum number of records saved before overwriting begins.
    this.init = function init(size) {
        if (typeof size !== "number" || size <= 0) throw new Error(`${thisFileName}init: circular buffer size must an integer > 0`);
        maxListSize = Math.ceil(size);
        itemIndex = -1;
    };
    // Call this to increment the number of records collected.<br>
    // Returns the array index number to store the next record in.
    this.increment = function increment() {
        itemIndex += 1;
        return (itemIndex + maxListSize) % maxListSize;
    };
    // Returns `maxListSize` - the maximum number of records to keep in the buffer.
    this.maxSize = function maxSize() {
        return maxListSize;
    };
    // Returns the highest number of items saved.<br>
    // (The number of items is the actual number of records processed
    // even though only `maxListSize` records are actually retained.)
    this.items = function items() {
        return itemIndex + 1;
    };
    // Returns the record number associated with this item index.
    this.getListIndex = function getListIndex(item) {
        if (itemIndex === -1) return -1;
        if (item < 0 || item > itemIndex) return -1;
        if (itemIndex - item >= maxListSize) return -1;
        return (item + maxListSize) % maxListSize;
    };
    // The iterator over the circular buffer.
    // The user's function, `fn`, will be called with arguments `fn(listIndex, itemIndex)`
    // where `listIndex` is the saved record index and `itemIndex` is the actual item index.
    this.forEach = function forEach(fn) {
        if (itemIndex === -1) /* no records have been collected */ return;
        if (itemIndex < maxListSize) {
            /* fewer than maxListSize records have been collected - number of items = number of records */ for(let i = 0; i <= itemIndex; i += 1)fn(i, i);
            return;
        }
        /* start with the oldest record saved and finish with the most recent record saved */ for(let i = itemIndex - maxListSize + 1; i <= itemIndex; i += 1){
            const listIndex = (i + maxListSize) % maxListSize;
            fn(listIndex, i);
        }
    };
};

});

parcelRegister("4vivX", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable no-restricted-syntax */ /* eslint-disable new-cap */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This is the primary object of `apg-lib`. Calling its `parse()` member function
// walks the parse tree of opcodes, matching phrases from the input string as it goes.
// The working code for all of the operators, `ALT`, `CAT`, etc. is in this module.


module.exports = function parser() {
    const id = (parcelRequire("i0Pc2"));
    const utils = (parcelRequire("bvrBx"));
    const thisFileName = "parser.js: ";
    const thisThis = this;
    let opExecute;
    this.ast = null;
    this.stats = null;
    this.trace = null;
    this.callbacks = [];
    let opcodes = null;
    let chars = null;
    let charsBegin;
    let charsLength;
    let charsEnd;
    let lookAround;
    let treeDepth = 0;
    let maxTreeDepth = 0;
    let nodeHits = 0;
    let ruleCallbacks = null;
    let udtCallbacks = null;
    let rules = null;
    let udts = null;
    let syntaxData = null;
    let maxMatched = 0;
    let limitTreeDepth = Infinity;
    let limitNodeHits = Infinity;
    // Evaluates any given rule. This can be called from the syntax callback
    // functions to evaluate any rule in the grammar's rule list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    const evaluateRule = function evaluateRule(ruleIndex, phraseIndex, sysData) {
        const functionName = `${thisFileName}evaluateRule(): `;
        if (ruleIndex >= rules.length) throw new Error(`${functionName}rule index: ${ruleIndex} out of range`);
        if (phraseIndex >= charsEnd) throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
        const { length: length } = opcodes;
        opcodes.push({
            type: id.RNM,
            index: ruleIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    // Evaluates any given UDT. This can be called from the syntax callback
    // functions to evaluate any UDT in the grammar's UDT list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    const evaluateUdt = function(udtIndex, phraseIndex, sysData) {
        const functionName = `${thisFileName}evaluateUdt(): `;
        if (udtIndex >= udts.length) throw new Error(`${functionName}udt index: ${udtIndex} out of range`);
        if (phraseIndex >= charsEnd) throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
        const { length: length } = opcodes;
        opcodes.push({
            type: id.UDT,
            empty: udts[udtIndex].empty,
            index: udtIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    /* Clears this object of any/all data that has been initialized or added to it. */ /* Called by parse() on initialization, allowing this object to be re-used for multiple parsing calls. */ const clear = function() {
        treeDepth = 0;
        maxTreeDepth = 0;
        nodeHits = 0;
        maxMatched = 0;
        lookAround = [
            {
                lookAround: id.LOOKAROUND_NONE,
                anchor: 0,
                charsEnd: 0,
                charsLength: 0
            }
        ];
        rules = null;
        udts = null;
        chars = null;
        charsBegin = 0;
        charsLength = 0;
        charsEnd = 0;
        ruleCallbacks = null;
        udtCallbacks = null;
        syntaxData = null;
        opcodes = null;
    };
    /* object for maintaining a stack of back reference frames */ const backRef = function() {
        const stack = [];
        const init = function() {
            const obj = {};
            rules.forEach((rule)=>{
                if (rule.isBkr) obj[rule.lower] = null;
            });
            if (udts.length > 0) udts.forEach((udt)=>{
                if (udt.isBkr) obj[udt.lower] = null;
            });
            stack.push(obj);
        };
        const copy = function() {
            const top = stack[stack.length - 1];
            const obj = {};
            /* // eslint-disable-next-line no-restricted-syntax */ for(const name in top)obj[name] = top[name];
            return obj;
        };
        this.push = function push() {
            stack.push(copy());
        };
        this.pop = function pop(lengthArg) {
            let length = lengthArg;
            if (!length) length = stack.length - 1;
            if (length < 1 || length > stack.length) throw new Error(`${thisFileName}backRef.pop(): bad length: ${length}`);
            stack.length = length;
            return stack[stack.length - 1];
        };
        this.length = function length() {
            return stack.length;
        };
        this.savePhrase = function savePhrase(name, index, length) {
            stack[stack.length - 1][name] = {
                phraseIndex: index,
                phraseLength: length
            };
        };
        this.getPhrase = function(name) {
            return stack[stack.length - 1][name];
        };
        /* constructor */ init();
    };
    // The system data structure that relays system information to and from the rule and UDT callback functions.
    // - *state* - the state of the parser, ACTIVE, MATCH, EMPTY or NOMATCH (see the `identifiers` object in
    // [`apg-lib`](https://github.com/ldthomas/apg-js2-lib))
    // - *phraseLength* - the number of characters matched if the state is MATCHED or EMPTY
    // - *lookaround* - the top of the stack holds the current look around state,
    // LOOKAROUND_NONE, LOOKAROUND_AHEAD or LOOKAROUND_BEHIND,
    // - *uFrame* - the "universal" back reference frame.
    // Holds the last matched phrase for each of the back referenced rules and UDTs.
    // - *pFrame* - the stack of "parent" back reference frames.
    // Holds the matched phrase from the parent frame of each back referenced rules and UDTs.
    // - *evaluateRule* - a reference to this object's `evaluateRule()` function.
    // Can be called from a callback function (use with extreme caution!)
    // - *evaluateUdt* - a reference to this object's `evaluateUdt()` function.
    // Can be called from a callback function (use with extreme caution!)
    const systemData = function systemData() {
        const thisData = this;
        this.state = id.ACTIVE;
        this.phraseLength = 0;
        this.ruleIndex = 0;
        this.udtIndex = 0;
        this.lookAround = lookAround[lookAround.length - 1];
        this.uFrame = new backRef();
        this.pFrame = new backRef();
        this.evaluateRule = evaluateRule;
        this.evaluateUdt = evaluateUdt;
        /* refresh the parser state for the next operation */ this.refresh = function refresh() {
            thisData.state = id.ACTIVE;
            thisData.phraseLength = 0;
            thisData.lookAround = lookAround[lookAround.length - 1];
        };
    };
    /* some look around helper functions */ const lookAroundValue = function lookAroundValue() {
        return lookAround[lookAround.length - 1];
    };
    /* return true if parser is in look around (ahead or behind) state */ const inLookAround = function inLookAround() {
        return lookAround.length > 1;
    };
    /* return true if parser is in look behind state */ const inLookBehind = function() {
        return lookAround[lookAround.length - 1].lookAround === id.LOOKAROUND_BEHIND;
    };
    /* called by parse() to initialize the AST object, if one has been defined */ const initializeAst = function() {
        const functionName = `${thisFileName}initializeAst(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.ast === undefined) {
                thisThis.ast = null;
                break;
            }
            if (thisThis.ast === null) break;
            if (thisThis.ast.astObject !== "astObject") throw new Error(`${functionName}ast object not recognized`);
            break;
        }
        if (thisThis.ast !== null) thisThis.ast.init(rules, udts, chars);
    };
    /* called by parse() to initialize the trace object, if one has been defined */ const initializeTrace = function() {
        const functionName = `${thisFileName}initializeTrace(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.trace === undefined) {
                thisThis.trace = null;
                break;
            }
            if (thisThis.trace === null) break;
            if (thisThis.trace.traceObject !== "traceObject") throw new Error(`${functionName}trace object not recognized`);
            break;
        }
        if (thisThis.trace !== null) thisThis.trace.init(rules, udts, chars);
    };
    /* called by parse() to initialize the statistics object, if one has been defined */ const initializeStats = function() {
        const functionName = `${thisFileName}initializeStats(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.stats === undefined) {
                thisThis.stats = null;
                break;
            }
            if (thisThis.stats === null) break;
            if (thisThis.stats.statsObject !== "statsObject") throw new Error(`${functionName}stats object not recognized`);
            break;
        }
        if (thisThis.stats !== null) thisThis.stats.init(rules, udts);
    };
    /* called by parse() to initialize the rules & udts from the grammar object */ /* (the grammar object generated previously by apg) */ const initializeGrammar = function(grammar) {
        const functionName = `${thisFileName}initializeGrammar(): `;
        if (!grammar) throw new Error(`${functionName}grammar object undefined`);
        if (grammar.grammarObject !== "grammarObject") throw new Error(`${functionName}bad grammar object`);
        rules = grammar.rules;
        udts = grammar.udts;
    };
    /* called by parse() to initialize the start rule */ const initializeStartRule = function(startRule) {
        const functionName = `${thisFileName}initializeStartRule(): `;
        let start = null;
        if (typeof startRule === "number") {
            if (startRule >= rules.length) throw new Error(`${functionName}start rule index too large: max: ${rules.length}: index: ${startRule}`);
            start = startRule;
        } else if (typeof startRule === "string") {
            const lower = startRule.toLowerCase();
            for(let i = 0; i < rules.length; i += 1)if (lower === rules[i].lower) {
                start = rules[i].index;
                break;
            }
            if (start === null) throw new Error(`${functionName}start rule name '${startRule}' not recognized`);
        } else throw new Error(`${functionName}type of start rule '${typeof startRule}' not recognized`);
        return start;
    };
    /* called by parse() to initialize the array of characters codes representing the input string */ const initializeInputChars = function initializeInputChars(inputArg, begArg, lenArg) {
        const functionName = `${thisFileName}initializeInputChars(): `;
        /* varify and normalize input */ let input = inputArg;
        let beg = begArg;
        let len = lenArg;
        if (input === undefined) throw new Error(`${functionName}input string is undefined`);
        if (input === null) throw new Error(`${functionName}input string is null`);
        if (typeof input === "string") input = utils.stringToChars(input);
        else if (!Array.isArray(input)) throw new Error(`${functionName}input string is not a string or array`);
        if (input.length > 0) {
            if (typeof input[0] !== "number") throw new Error(`${functionName}input string not an array of integers`);
        }
        /* verify and normalize beginning index */ if (typeof beg !== "number") beg = 0;
        else {
            beg = Math.floor(beg);
            if (beg < 0 || beg > input.length) throw new Error(`${functionName}input beginning index out of range: ${beg}`);
        }
        /* verify and normalize input length */ if (typeof len !== "number") len = input.length - beg;
        else {
            len = Math.floor(len);
            if (len < 0 || len > input.length - beg) throw new Error(`${functionName}input length out of range: ${len}`);
        }
        chars = input;
        charsBegin = beg;
        charsLength = len;
        charsEnd = charsBegin + charsLength;
    };
    /* called by parse() to initialize the user-written, syntax callback functions, if any */ const initializeCallbacks = function() {
        const functionName = `${thisFileName}initializeCallbacks(): `;
        let i;
        ruleCallbacks = [];
        udtCallbacks = [];
        for(i = 0; i < rules.length; i += 1)ruleCallbacks[i] = null;
        for(i = 0; i < udts.length; i += 1)udtCallbacks[i] = null;
        let func;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        for(const index in thisThis.callbacks){
            i = list.indexOf(index.toLowerCase());
            if (i < 0) throw new Error(`${functionName}syntax callback '${index}' not a rule or udt name`);
            func = thisThis.callbacks[index];
            if (!func) func = null;
            if (typeof func === "function" || func === null) {
                if (i < rules.length) ruleCallbacks[i] = func;
                else udtCallbacks[i - rules.length] = func;
            } else throw new Error(`${functionName}syntax callback[${index}] must be function reference or 'false' (false/null/undefined/etc.)`);
        }
        /* make sure all udts have been defined - the parser can't work without them */ for(i = 0; i < udts.length; i += 1){
            if (udtCallbacks[i] === null) throw new Error(`${functionName}all UDT callbacks must be defined. UDT callback[${udts[i].lower}] not a function reference`);
        }
    };
    // Set the maximum parse tree depth allowed. The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // depth - max allowed parse tree depth. An exception is thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxTreeDepth = function(depth) {
        if (typeof depth !== "number") throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
        limitTreeDepth = Math.floor(depth);
        if (limitTreeDepth <= 0) throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
    };
    // Set the maximum number of node hits (parser unit steps or opcode function calls) allowed.
    // The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // hits - maximum number of node hits or parser unit steps allowed.
    // An exception thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxNodeHits = function(hits) {
        if (typeof hits !== "number") throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
        limitNodeHits = Math.floor(hits);
        if (limitNodeHits <= 0) throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
    };
    /* the main parser function */ const privateParse = function(grammar, startRuleArg, callbackData) {
        let success;
        const functionName = `${thisFileName}parse(): `;
        initializeGrammar(grammar);
        const startRule = initializeStartRule(startRuleArg);
        initializeCallbacks();
        initializeTrace();
        initializeStats();
        initializeAst();
        const sysData = new systemData();
        if (!(callbackData === undefined || callbackData === null)) syntaxData = callbackData;
        /* create a dummy opcode for the start rule */ opcodes = [
            {
                type: id.RNM,
                index: startRule
            }
        ];
        /* execute the start rule */ opExecute(0, charsBegin, sysData);
        opcodes = null;
        /* test and return the sysData */ switch(sysData.state){
            case id.ACTIVE:
                throw new Error(`${functionName}final state should never be 'ACTIVE'`);
            case id.NOMATCH:
                success = false;
                break;
            case id.EMPTY:
            case id.MATCH:
                if (sysData.phraseLength === charsLength) success = true;
                else success = false;
                break;
            default:
                throw new Error("unrecognized state");
        }
        return {
            success: success,
            state: sysData.state,
            length: charsLength,
            matched: sysData.phraseLength,
            maxMatched: maxMatched,
            maxTreeDepth: maxTreeDepth,
            nodeHits: nodeHits,
            inputLength: chars.length,
            subBegin: charsBegin,
            subEnd: charsEnd,
            subLength: charsLength
        };
    };
    // This form allows parsing of a sub-string of the full input string.
    // <ul>
    // <li>*inputIndex* - index of the first character in the sub-string</li>
    // <li>*inputLength* - length of the sub-string</li>
    // </ul>
    // All other parameters as for the above function `parse()`.
    this.parseSubstring = function parseSubstring(grammar, startRule, inputChars, inputIndex, inputLength, callbackData) {
        clear();
        initializeInputChars(inputChars, inputIndex, inputLength);
        return privateParse(grammar, startRule, callbackData);
    };
    // This is the main function, called to parse an input string.
    // <ul>
    // <li>*grammar* - an instantiated grammar object - the output of `apg` for a
    // specific SABNF grammar</li>
    // <li>*startRule* - the rule name or rule index to be used as the root of the
    // parse tree. This is usually the first rule, index = 0, of the grammar
    // but can be any rule defined in the above grammar object.</li>
    // <li>*inputChars* - the input string. Can be a string or an array of integer character codes representing the
    // string.</li>
    // <li>*callbackData* - user-defined data object to be passed to the user's
    // callback functions.
    // This is not used by the parser in any way, merely passed on to the user.
    // May be `null` or omitted.</li>
    // </ul>
    this.parse = function parse(grammar, startRule, inputChars, callbackData) {
        clear();
        initializeInputChars(inputChars, 0, inputChars.length);
        return privateParse(grammar, startRule, callbackData);
    };
    // The `ALT` operator.<br>
    // Executes its child nodes, from left to right, until it finds a match.
    // Fails if *all* of its child nodes fail.
    const opALT = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        for(let i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], phraseIndex, sysData);
            if (sysData.state !== id.NOMATCH) break;
        }
    };
    // The `CAT` operator.<br>
    // Executes all of its child nodes, from left to right,
    // concatenating the matched phrases.
    // Fails if *any* child nodes fail.
    const opCAT = function(opIndex, phraseIndex, sysData) {
        let success;
        let astLength;
        let catCharIndex;
        let catPhrase;
        const op = opcodes[opIndex];
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catPhrase = 0;
        for(let i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], catCharIndex, sysData);
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            } else {
                catCharIndex += sysData.phraseLength;
                catPhrase += sysData.phraseLength;
            }
        }
        if (success) {
            sysData.state = catPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The `REP` operator.<br>
    // Repeatedly executes its single child node,
    // concatenating each of the matched phrases found.
    // The number of repetitions executed and its final sysData depends
    // on its `min` & `max` repetition values.
    const opREP = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let repCharIndex;
        let repPhrase;
        let repCount;
        const op = opcodes[opIndex];
        if (op.max === 0) {
            // this is an empty-string acceptor
            // deprecated: use the TLS empty string operator, "", instead
            sysData.state = id.EMPTY;
            sysData.phraseLength = 0;
            return;
        }
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        const TRUE = true;
        while(TRUE){
            if (repCharIndex >= charsEnd) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex += sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get them right
    // but `RNM` fails if not.
    const validateRnmCallbackResult = function(rule, sysData, charsLeft, down) {
        if (sysData.phraseLength > charsLeft) {
            let str = `${thisFileName}opRNM(${rule.name}): callback function error: `;
            str += `sysData.phraseLength: ${sysData.phraseLength}`;
            str += ` must be <= remaining chars: ${charsLeft}`;
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                if (down !== true) throw new Error(`${thisFileName}opRNM(${rule.name}): callback function return error. ACTIVE state not allowed.`);
                break;
            case id.EMPTY:
                sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error(`${thisFileName}opRNM(${rule.name}): callback function return error. Unrecognized return state: ${sysData.state}`);
        }
    };
    // The `RNM` operator.<br>
    // This operator will acts as a root node for a parse tree branch below and
    // returns the matched phrase to its parent.
    // However, its larger responsibility is handling user-defined callback functions, back references and `AST` nodes.
    // Note that the `AST` is a separate object, but `RNM` calls its functions to create its nodes.
    // See [`ast.js`](./ast.html) for usage.
    const opRNM = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let astDefined;
        let savedOpcodes;
        let ulen;
        let plen;
        let saveFrame;
        const op = opcodes[opIndex];
        const rule = rules[op.index];
        const callback = ruleCallbacks[rule.index];
        const notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back references */ astDefined = thisThis.ast && thisThis.ast.ruleDefined(op.index);
            if (astDefined) {
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(op.index, rules[op.index].name);
            }
            ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        if (callback === null) {
            /* no callback - just execute the rule */ savedOpcodes = opcodes;
            opcodes = rule.opcodes;
            opExecute(0, phraseIndex, sysData);
            opcodes = savedOpcodes;
        } else {
            /* call user's callback */ const charsLeft = charsEnd - phraseIndex;
            sysData.ruleIndex = rule.index;
            callback(sysData, chars, phraseIndex, syntaxData);
            validateRnmCallbackResult(rule, sysData, charsLeft, true);
            if (sysData.state === id.ACTIVE) {
                savedOpcodes = opcodes;
                opcodes = rule.opcodes;
                opExecute(0, phraseIndex, sysData);
                opcodes = savedOpcodes;
                sysData.ruleIndex = rule.index;
                callback(sysData, chars, phraseIndex, syntaxData);
                validateRnmCallbackResult(rule, sysData, charsLeft, false);
            } /* implied else clause: just accept the callback sysData - RNM acting as UDT */ 
        }
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(op.index, rule.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (rule.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get it right but `UDT` fails if not.
    const validateUdtCallbackResult = function(udt, sysData, charsLeft) {
        if (sysData.phraseLength > charsLeft) {
            let str = `${thisFileName}opUDT(${udt.name}): callback function error: `;
            str += `sysData.phraseLength: ${sysData.phraseLength}`;
            str += ` must be <= remaining chars: ${charsLeft}`;
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. ACTIVE state not allowed.`);
            case id.EMPTY:
                if (udt.empty === false) throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
                else sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) {
                    if (udt.empty === false) throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
                    else sysData.state = id.EMPTY;
                }
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. Unrecognized return state: ${sysData.state}`);
        }
    };
    // The `UDT` operator.<br>
    // Simply calls the user's callback function, but operates like `RNM` with regard to the `AST`
    // and back referencing.
    // There is some ambiguity here. `UDT`s act as terminals for phrase recognition but as named rules
    // for `AST` nodes and back referencing.
    // See [`ast.js`](./ast.html) for usage.
    const opUDT = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let astIndex;
        let astDefined;
        let ulen;
        let plen;
        let saveFrame;
        const op = opcodes[opIndex];
        const udt = udts[op.index];
        sysData.UdtIndex = udt.index;
        const notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back reference */ astDefined = thisThis.ast && thisThis.ast.udtDefined(op.index);
            if (astDefined) {
                astIndex = rules.length + op.index;
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(astIndex, udt.name);
            }
            /* NOTE: push and pop of the back reference frame is normally not necessary */ /* only in the case that the UDT calls evaluateRule() or evaluateUdt() */ ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        /* call the UDT */ const charsLeft = charsEnd - phraseIndex;
        udtCallbacks[op.index](sysData, chars, phraseIndex, syntaxData);
        validateUdtCallbackResult(udt, sysData, charsLeft);
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(astIndex, udt.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (udt.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // The `AND` operator.<br>
    // This is the positive `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it succeedsand NOMATCH if it fails.
    // *Always* backtracks on any matched phrase and returns EMPTY on success.
    const opAND = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        const pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error(`opAND: invalid state ${sysData.state}`);
        }
    };
    // The `NOT` operator.<br>
    // This is the negative `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it *fails* and NOMATCH if it succeeds.
    // *Always* backtracks on any matched phrase and returns EMPTY
    // on success (failure of its child node).
    const opNOT = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        const pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error(`opNOT: invalid state ${sysData.state}`);
        }
    };
    // The `TRG` operator.<br>
    // Succeeds if the single first character of the phrase is
    // within the `min - max` range.
    const opTRG = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (phraseIndex < charsEnd) {
            if (op.min <= chars[phraseIndex] && chars[phraseIndex] <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The `TBS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // All characters must match exactly.
    // Case-sensitive literal strings (`'string'` & `%s"string"`) are translated to `TBS`
    // operators by `apg`.
    // Phrase length of zero is not allowed.
    // Empty phrases can only be defined with `TLS` operators.
    const opTBS = function(opIndex, phraseIndex, sysData) {
        let i;
        const op = opcodes[opIndex];
        const len = op.string.length;
        sysData.state = id.NOMATCH;
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                if (chars[phraseIndex + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `TLS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // A case-insensitive match is attempted for ASCII alphbetical characters.
    // `TLS` is the only operator that explicitly allows empty phrases.
    // `apg` will fail for empty `TBS`, case-sensitive strings (`''`) or
    // zero repetitions (`0*0RuleName` or `0RuleName`).
    const opTLS = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                if (code >= 65 && code <= 90) code += 32;
                if (code !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `ABG` operator.<br>
    // This is an "anchor" for the beginning of the string, similar to the familiar regex `^` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` is 0, NOMATCH otherwise.
    const opABG = function(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === 0 ? id.EMPTY : id.NOMATCH;
    };
    // The `AEN` operator.<br>
    // This is an "anchor" for the end of the string, similar to the familiar regex `$` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` equals the input string length, NOMATCH otherwise.
    const opAEN = function(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === chars.length ? id.EMPTY : id.NOMATCH;
    };
    // The `BKR` operator.<br>
    // The back reference operator.
    // Matches the last matched phrase of the named rule or UDT against the input string.
    // For ASCII alphbetical characters the match may be case sensitive (`%s`) or insensitive (`%i`),
    // depending on the back reference definition.
    // For `universal` mode (`%u`) matches the last phrase found anywhere in the grammar.
    // For `parent frame` mode (`%p`) matches the last phrase found in the parent rule only.
    const opBKR = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        let lmcode;
        let lower;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        const insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        const lmIndex = frame.phraseIndex;
        const len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[phraseIndex + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The `BKA` operator.<br>
    // This is the positive `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    const opBKA = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error(`opBKA: invalid state ${sysData.state}`);
        }
    };
    // The `BKN` operator.<br>
    // This is the negative `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is *not* found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    const opBKN = function(opIndex, phraseIndex, sysData) {
        // let op;
        // op = opcodes[opIndex];
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error(`opBKN: invalid state ${sysData.state}`);
        }
    };
    // The right-to-left `CAT` operator.<br>
    // Called for `CAT` operators when in look behind mode.
    // Calls its child nodes from right to left concatenating matched phrases right to left.
    const opCATBehind = function(opIndex, phraseIndex, sysData) {
        let success;
        let astLength;
        let catCharIndex;
        let catMatched;
        const op = opcodes[opIndex];
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catMatched = 0;
        // catPhrase = 0;
        for(let i = op.children.length - 1; i >= 0; i -= 1){
            opExecute(op.children[i], catCharIndex, sysData);
            catCharIndex -= sysData.phraseLength;
            catMatched += sysData.phraseLength;
            // catPhrase += sysData.phraseLength;
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            }
        }
        if (success) {
            sysData.state = catMatched === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catMatched;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `REP` operator.<br>
    // Called for `REP` operators in look behind mode.
    // Makes repeated calls to its child node, concatenating matched phrases right to left.
    const opREPBehind = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let repCharIndex;
        let repPhrase;
        let repCount;
        const op = opcodes[opIndex];
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        const TRUE = true;
        while(TRUE){
            if (repCharIndex <= 0) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex -= sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `TRG` operator.<br>
    // Called for `TRG` operators in look behind mode.
    // Matches a single character at `phraseIndex - 1` to the `min` - `max` range.
    const opTRGBehind = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (phraseIndex > 0) {
            const char = chars[phraseIndex - 1];
            if (op.min <= char && char <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The right-to-left `TBS` operator.<br>
    // Called for `TBS` operators in look behind mode.
    // Matches the `TBS` phrase to the left of `phraseIndex`.
    const opTBSBehind = function(opIndex, phraseIndex, sysData) {
        let i;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        const beg = phraseIndex - len;
        if (beg >= 0) {
            for(i = 0; i < len; i += 1){
                if (chars[beg + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left `TLS` operator.<br>
    // Called for `TLS` operators in look behind mode.
    // Matches the `TLS` phrase to the left of `phraseIndex`.
    const opTLSBehind = function(opIndex, phraseIndex, sysData) {
        let char;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        const beg = phraseIndex - len;
        if (beg >= 0) {
            for(let i = 0; i < len; i += 1){
                char = chars[beg + i];
                if (char >= 65 && char <= 90) char += 32;
                if (char !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left back reference operator.<br>
    // Matches the back referenced phrase to the left of `phraseIndex`.
    const opBKRBehind = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        let lmcode;
        let lower;
        const op = opcodes[opIndex];
        /* NOMATCH default */ sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        const insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        const lmIndex = frame.phraseIndex;
        const len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            sysData.phraseLength = 0;
            return;
        }
        const beg = phraseIndex - len;
        if (beg >= 0) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[beg + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[beg + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // Generalized execution function.<br>
    // Having a single, generalized function, allows a single location
    // for tracing and statistics gathering functions to be called.
    // Tracing and statistics are handled in separate objects.
    // However, the parser calls their API to build the object data records.
    // See [`trace.js`](./trace.html) and [`stats.js`](./stats.html) for their
    // usage.
    opExecute = function opExecuteFunc(opIndex, phraseIndex, sysData) {
        let ret = true;
        const op = opcodes[opIndex];
        nodeHits += 1;
        if (nodeHits > limitNodeHits) throw new Error(`parser: maximum number of node hits exceeded: ${limitNodeHits}`);
        treeDepth += 1;
        if (treeDepth > maxTreeDepth) {
            maxTreeDepth = treeDepth;
            if (maxTreeDepth > limitTreeDepth) throw new Error(`parser: maximum parse tree depth exceeded: ${limitTreeDepth}`);
        }
        sysData.refresh();
        if (thisThis.trace !== null) {
            /* collect the trace record for down the parse tree */ const lk = lookAroundValue();
            thisThis.trace.down(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
        }
        if (inLookBehind()) switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCATBehind(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREPBehind(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRGBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKRBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        else switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCAT(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREP(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRG(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBS(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLS(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKR(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        if (!inLookAround() && phraseIndex + sysData.phraseLength > maxMatched) maxMatched = phraseIndex + sysData.phraseLength;
        if (thisThis.stats !== null) /* collect the statistics */ thisThis.stats.collect(op, sysData);
        if (thisThis.trace !== null) {
            /* collect the trace record for up the parse tree */ const lk = lookAroundValue();
            thisThis.trace.up(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
        }
        treeDepth -= 1;
        return ret;
    };
};

});

parcelRegister("4Dqgn", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is the constructor for the statistics gathering object.
// The statistics are nothing more than keeping a count of the
// number of times each node in the parse tree is traversed.
//
// Counts are collected for each of the individual types of operators.
// Additionally, counts are collected for each of the individually named
// `RNM` and `UDT` operators.



module.exports = function statsFunc() {
    const id = (parcelRequire("i0Pc2"));
    const utils = (parcelRequire("bvrBx"));
    const style = (parcelRequire("fq92n"));
    const thisFileName = "stats.js: ";
    let rules = [];
    let udts = [];
    const stats = [];
    let totals;
    const ruleStats = [];
    const udtStats = [];
    this.statsObject = "statsObject";
    const nameId = "stats";
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators alphabetically by name. */ const sortAlpha = function sortAlpha(lhs, rhs) {
        if (lhs.lower < rhs.lower) return -1;
        if (lhs.lower > rhs.lower) return 1;
        return 0;
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by hit count. */ const sortHits = function sortHits(lhs, rhs) {
        if (lhs.total < rhs.total) return 1;
        if (lhs.total > rhs.total) return -1;
        return sortAlpha(lhs, rhs);
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by index */ /* (in the order in which they appear in the SABNF grammar). */ const sortIndex = function sortIndex(lhs, rhs) {
        if (lhs.index < rhs.index) return -1;
        if (lhs.index > rhs.index) return 1;
        return 0;
    };
    const EmptyStat = function EmptyStat() {
        this.empty = 0;
        this.match = 0;
        this.nomatch = 0;
        this.total = 0;
    };
    /* Zero out all stats */ const clear = function clear() {
        stats.length = 0;
        totals = new EmptyStat();
        stats[id.ALT] = new EmptyStat();
        stats[id.CAT] = new EmptyStat();
        stats[id.REP] = new EmptyStat();
        stats[id.RNM] = new EmptyStat();
        stats[id.TRG] = new EmptyStat();
        stats[id.TBS] = new EmptyStat();
        stats[id.TLS] = new EmptyStat();
        stats[id.UDT] = new EmptyStat();
        stats[id.AND] = new EmptyStat();
        stats[id.NOT] = new EmptyStat();
        stats[id.BKR] = new EmptyStat();
        stats[id.BKA] = new EmptyStat();
        stats[id.BKN] = new EmptyStat();
        stats[id.ABG] = new EmptyStat();
        stats[id.AEN] = new EmptyStat();
        ruleStats.length = 0;
        for(let i = 0; i < rules.length; i += 1)ruleStats.push({
            empty: 0,
            match: 0,
            nomatch: 0,
            total: 0,
            name: rules[i].name,
            lower: rules[i].lower,
            index: rules[i].index
        });
        if (udts.length > 0) {
            udtStats.length = 0;
            for(let i = 0; i < udts.length; i += 1)udtStats.push({
                empty: 0,
                match: 0,
                nomatch: 0,
                total: 0,
                name: udts[i].name,
                lower: udts[i].lower,
                index: udts[i].index
            });
        }
    };
    /* increment the designated operator hit count by one */ const incStat = function incStat(stat, state) {
        stat.total += 1;
        switch(state){
            case id.EMPTY:
                stat.empty += 1;
                break;
            case id.MATCH:
                stat.match += 1;
                break;
            case id.NOMATCH:
                stat.nomatch += 1;
                break;
            default:
                throw new Error(`${thisFileName}collect(): incStat(): unrecognized state: ${state}`);
        }
    };
    /* helper for toHtml() */ const displayRow = function displayRow(name, stat) {
        let html = "";
        html += "<tr>";
        html += `<td class="${style.CLASS_ACTIVE}">${name}</td>`;
        html += `<td class="${style.CLASS_EMPTY}">${stat.empty}</td>`;
        html += `<td class="${style.CLASS_MATCH}">${stat.match}</td>`;
        html += `<td class="${style.CLASS_NOMATCH}">${stat.nomatch}</td>`;
        html += `<td class="${style.CLASS_ACTIVE}">${stat.total}</td>`;
        html += "</tr>\n";
        return html;
    };
    const displayOpsOnly = function displayOpsOnly() {
        let html = "";
        html += displayRow("ALT", stats[id.ALT]);
        html += displayRow("CAT", stats[id.CAT]);
        html += displayRow("REP", stats[id.REP]);
        html += displayRow("RNM", stats[id.RNM]);
        html += displayRow("TRG", stats[id.TRG]);
        html += displayRow("TBS", stats[id.TBS]);
        html += displayRow("TLS", stats[id.TLS]);
        html += displayRow("UDT", stats[id.UDT]);
        html += displayRow("AND", stats[id.AND]);
        html += displayRow("NOT", stats[id.NOT]);
        html += displayRow("BKR", stats[id.BKR]);
        html += displayRow("BKA", stats[id.BKA]);
        html += displayRow("BKN", stats[id.BKN]);
        html += displayRow("ABG", stats[id.ABG]);
        html += displayRow("AEN", stats[id.AEN]);
        html += displayRow("totals", totals);
        return html;
    };
    /* helper for toHtml() */ const displayRules = function displayRules() {
        let html = "";
        html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
        html += "<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>\n";
        for(let i = 0; i < rules.length; i += 1)if (ruleStats[i].total > 0) {
            html += "<tr>";
            html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].name}</td>`;
            html += `<td class="${style.CLASS_EMPTY}">${ruleStats[i].empty}</td>`;
            html += `<td class="${style.CLASS_MATCH}">${ruleStats[i].match}</td>`;
            html += `<td class="${style.CLASS_NOMATCH}">${ruleStats[i].nomatch}</td>`;
            html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].total}</td>`;
            html += "</tr>\n";
        }
        if (udts.length > 0) {
            html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
            html += "<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>\n";
            for(let i = 0; i < udts.length; i += 1)if (udtStats[i].total > 0) {
                html += "<tr>";
                html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].name}</td>`;
                html += `<td class="${style.CLASS_EMPTY}">${udtStats[i].empty}</td>`;
                html += `<td class="${style.CLASS_MATCH}">${udtStats[i].match}</td>`;
                html += `<td class="${style.CLASS_NOMATCH}">${udtStats[i].nomatch}</td>`;
                html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].total}</td>`;
                html += "</tr>\n";
            }
        }
        return html;
    };
    /* called only by the parser to validate a stats object */ this.validate = function validate(name) {
        let ret = false;
        if (typeof name === "string" && nameId === name) ret = true;
        return ret;
    };
    /* no verification of input - only called by parser() */ this.init = function init(inputRules, inputUdts) {
        rules = inputRules;
        udts = inputUdts;
        clear();
    };
    /* This function is the main interaction with the parser. */ /* The parser calls it after each node has been traversed. */ this.collect = function collect(op, result) {
        incStat(totals, result.state, result.phraseLength);
        incStat(stats[op.type], result.state, result.phraseLength);
        if (op.type === id.RNM) incStat(ruleStats[op.index], result.state, result.phraseLength);
        if (op.type === id.UDT) incStat(udtStats[op.index], result.state, result.phraseLength);
    };
    // Display the statistics as an HTML table.
    // - *type*
    //   - "ops" - (default) display only the total hit counts for all operator types.
    //   - "index" - additionally, display the hit counts for the individual `RNM` and `UDT` operators ordered by index.
    //   - "hits" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by hit count.
    //   - "alpha" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by name alphabetically.
    // - *caption* - optional caption for the table
    this.toHtml = function toHtml(type, caption) {
        let html = "";
        html += `<table class="${style.CLASS_STATS}">\n`;
        if (typeof caption === "string") html += `<caption>${caption}</caption>\n`;
        html += `<tr><th class="${style.CLASS_ACTIVE}">ops</th>\n`;
        html += `<th class="${style.CLASS_EMPTY}">EMPTY</th>\n`;
        html += `<th class="${style.CLASS_MATCH}">MATCH</th>\n`;
        html += `<th class="${style.CLASS_NOMATCH}">NOMATCH</th>\n`;
        html += `<th class="${style.CLASS_ACTIVE}">totals</th></tr>\n`;
        const test = true;
        while(test){
            if (type === undefined) {
                html += displayOpsOnly();
                break;
            }
            if (type === null) {
                html += displayOpsOnly();
                break;
            }
            if (type === "ops") {
                html += displayOpsOnly();
                break;
            }
            if (type === "index") {
                ruleStats.sort(sortIndex);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "hits") {
                ruleStats.sort(sortHits);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "alpha") {
                ruleStats.sort(sortAlpha);
                if (udtStats.length > 0) udtStats.sort(sortAlpha);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            break;
        }
        html += "</table>\n";
        return html;
    };
    // Display the stats table in a complete HTML5 page.
    this.toHtmlPage = function toHtmlPage(type, caption, title) {
        return utils.htmlToPage(this.toHtml(type, caption), title);
    };
};

});

parcelRegister("73tM6", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable prefer-destructuring */ /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module provides a means of tracing the parser through the parse tree as it goes.
// It is the primary debugging facility for debugging both the SABNF grammar syntax
// and the input strings that are supposed to be valid grammar sentences.
// It is also a very informative and educational tool for understanding
// how a parser actually operates for a given language.
//
// Tracing is the process of generating and saving a record of information for each passage
// of the parser through a parse tree node. And since it traverses each node twice, once down the tree
// and once coming back up, there are two records for each node.
// This, obviously, has the potential of generating lots of records.
// And since these records are normally displayed on a web page
// it is important to have a means to limit the actual number of records generated to
// probably no more that a few thousand. This is almost always enough to find any errors.
// The problem is to get the *right* few thousand records.
// Therefore, this module has a number of ways of limiting and/or filtering, the number and type of records.
// Considerable effort has been made to make this filtering of the trace output as simple
// and intuitive as possible.
//
// However, the ability to filter the trace records, or for that matter even understand what they are
// and the information they contain, does require a minimum amount of understanding of the APG parsing
// method. The parse tree nodes are all represented by APG operators. They break down into two natural groups.
// - The `RNM` operators and `UDT` operators are named phrases.
// These are names chosen by the writer of the SABNF grammar to represent special phrases of interest.
// - All others collect, concatenate and otherwise manipulate various intermediate phrases along the way.
//
// There are separate means of filtering which of these operators in each of these two groups get traced.
// Let `trace` be an instantiated `trace.js` object.
// Prior to parsing the string, filtering the rules and UDTs can be defined as follows:
// ```
// trace.filter.rules["rulename"] = true;
//     /* trace rule name "rulename" */
// trace.filter.rules["udtname"]  = true;
//     /* trace UDT name "udtname" */
// trace.filter.rules["<ALL>"]    = true;
//     /* trace all rules and UDTs (the default) */
// trace.filter.rules["<NONE>"]   = true;
//     /* trace no rules or UDTS */
// ```
// If any rule or UDT name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of rule names, a filter statement is required for each rule/UDT name desired.
//
// Filtering of the other operators follows a similar procedure.
// ```
// trace.filter.operators["TRG"] = true;
//     /* trace the terminal range, TRG, operators */
// trace.filter.operators["CAT"]  = true;
//     /* trace the concatenations, CAT, operators */
// trace.filter.operators["<ALL>"]    = true;
//     /* trace all operators */
// trace.filter.operators["<NONE>"]   = true;
//     /* trace no operators (the default) */
// ```
// If any operator name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of operator names, a filter statement is required for each name desired.
//
// There is, additionally, a means for limiting the total number of filtered or saved trace records.
// See the function, `setMaxRecords(max)` below. This will result in only the last `max` records being saved.
//
// (See [`apg-examples`](https://github.com/ldthomas/apg-js-examples) for examples of using `trace.js`.)




module.exports = function exportTrace() {
    const utils = (parcelRequire("bvrBx"));
    const style = (parcelRequire("fq92n"));
    const circular = new (parcelRequire("l9c3t"))();
    const id = (parcelRequire("i0Pc2"));
    const thisFileName = "trace.js: ";
    const that = this;
    const MODE_HEX = 16;
    const MODE_DEC = 10;
    const MODE_ASCII = 8;
    const MODE_UNICODE = 32;
    const MAX_PHRASE = 80;
    const MAX_TLS = 5;
    const records = [];
    let maxRecords = 5000;
    let lastRecord = -1;
    let filteredRecords = 0;
    let treeDepth = 0;
    const recordStack = [];
    let chars = null;
    let rules = null;
    let udts = null;
    const operatorFilter = [];
    const ruleFilter = [];
    /* special trace table phrases */ const PHRASE_END = `<span class="${style.CLASS_LINEEND}">&bull;</span>`;
    const PHRASE_CONTINUE = `<span class="${style.CLASS_LINEEND}">&hellip;</span>`;
    const PHRASE_EMPTY = `<span class="${style.CLASS_EMPTY}">&#120634;</span>`;
    /* filter the non-RNM & non-UDT operators */ const initOperatorFilter = function() {
        const setOperators = function(set) {
            operatorFilter[id.ALT] = set;
            operatorFilter[id.CAT] = set;
            operatorFilter[id.REP] = set;
            operatorFilter[id.TLS] = set;
            operatorFilter[id.TBS] = set;
            operatorFilter[id.TRG] = set;
            operatorFilter[id.AND] = set;
            operatorFilter[id.NOT] = set;
            operatorFilter[id.BKR] = set;
            operatorFilter[id.BKA] = set;
            operatorFilter[id.BKN] = set;
            operatorFilter[id.ABG] = set;
            operatorFilter[id.AEN] = set;
        };
        let items = 0;
        // eslint-disable-next-line no-unused-vars
        for(const name in that.filter.operators)items += 1;
        if (items === 0) {
            /* case 1: no operators specified: default: do not trace any operators */ setOperators(false);
            return;
        }
        for(const name in that.filter.operators){
            const upper = name.toUpperCase();
            if (upper === "<ALL>") {
                /* case 2: <all> operators specified: trace all operators ignore all other operator commands */ setOperators(true);
                return;
            }
            if (upper === "<NONE>") {
                /* case 3: <none> operators specified: trace NO operators ignore all other operator commands */ setOperators(false);
                return;
            }
        }
        setOperators(false);
        for(const name in that.filter.operators){
            const upper = name.toUpperCase();
            /* case 4: one or more individual operators specified: trace 'true' operators only */ if (upper === "ALT") operatorFilter[id.ALT] = that.filter.operators[name] === true;
            else if (upper === "CAT") operatorFilter[id.CAT] = that.filter.operators[name] === true;
            else if (upper === "REP") operatorFilter[id.REP] = that.filter.operators[name] === true;
            else if (upper === "AND") operatorFilter[id.AND] = that.filter.operators[name] === true;
            else if (upper === "NOT") operatorFilter[id.NOT] = that.filter.operators[name] === true;
            else if (upper === "TLS") operatorFilter[id.TLS] = that.filter.operators[name] === true;
            else if (upper === "TBS") operatorFilter[id.TBS] = that.filter.operators[name] === true;
            else if (upper === "TRG") operatorFilter[id.TRG] = that.filter.operators[name] === true;
            else if (upper === "BKR") operatorFilter[id.BKR] = that.filter.operators[name] === true;
            else if (upper === "BKA") operatorFilter[id.BKA] = that.filter.operators[name] === true;
            else if (upper === "BKN") operatorFilter[id.BKN] = that.filter.operators[name] === true;
            else if (upper === "ABG") operatorFilter[id.ABG] = that.filter.operators[name] === true;
            else if (upper === "AEN") operatorFilter[id.AEN] = that.filter.operators[name] === true;
            else throw new Error(`${thisFileName}initOpratorFilter: '${name}' not a valid operator name.` + ` Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn`);
        }
    };
    /* filter the rule and `UDT` named operators */ const initRuleFilter = function() {
        const setRules = function(set) {
            operatorFilter[id.RNM] = set;
            operatorFilter[id.UDT] = set;
            const count = rules.length + udts.length;
            ruleFilter.length = 0;
            for(let i = 0; i < count; i += 1)ruleFilter.push(set);
        };
        let items;
        let i;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        ruleFilter.length = 0;
        items = 0;
        // eslint-disable-next-line no-unused-vars
        for(const name in that.filter.rules)items += 1;
        if (items === 0) {
            /* case 1: default to all rules & udts */ setRules(true);
            return;
        }
        for(const name in that.filter.rules){
            const lower = name.toLowerCase();
            if (lower === "<all>") {
                /* case 2: trace all rules ignore all other rule commands */ setRules(true);
                return;
            }
            if (lower === "<none>") {
                /* case 3: trace no rules */ setRules(false);
                return;
            }
        }
        /* case 4: trace only individually specified rules */ setRules(false);
        operatorFilter[id.RNM] = true;
        operatorFilter[id.UDT] = true;
        for(const name in that.filter.rules){
            const lower = name.toLowerCase();
            i = list.indexOf(lower);
            if (i < 0) throw new Error(`${thisFileName}initRuleFilter: '${name}' not a valid rule or udt name`);
            ruleFilter[i] = that.filter.rules[name] === true;
        }
    };
    /* used by other APG components to verify that they have a valid trace object */ this.traceObject = "traceObject";
    this.filter = {
        operators: [],
        rules: []
    };
    // Set the maximum number of records to keep (default = 5000).
    // Each record number larger than `maxRecords`
    // will result in deleting the previously oldest record.
    // - `max`: maximum number of records to retain (default = 5000)
    // - `last`: last record number to retain, (default = -1 for (unknown) actual last record)
    this.setMaxRecords = function(max, last) {
        lastRecord = -1;
        if (typeof max === "number" && max > 0) maxRecords = Math.ceil(max);
        else {
            maxRecords = 0;
            return;
        }
        if (typeof last === "number") {
            lastRecord = Math.floor(last);
            if (lastRecord < 0) lastRecord = -1;
        }
    };
    // Returns `maxRecords` to the caller.
    this.getMaxRecords = function() {
        return maxRecords;
    };
    // Returns `lastRecord` to the caller.
    this.getLastRecord = function() {
        return lastRecord;
    };
    /* Called only by the `parser.js` object. No verification of input. */ this.init = function(rulesIn, udtsIn, charsIn) {
        records.length = 0;
        recordStack.length = 0;
        filteredRecords = 0;
        treeDepth = 0;
        chars = charsIn;
        rules = rulesIn;
        udts = udtsIn;
        initOperatorFilter();
        initRuleFilter();
        circular.init(maxRecords);
    };
    /* returns true if this records passes through the designated filter, false if the record is to be skipped */ const filterOps = function(op) {
        let ret = false;
        if (op.type === id.RNM) {
            if (operatorFilter[op.type] && ruleFilter[op.index]) ret = true;
            else ret = false;
        } else if (op.type === id.UDT) {
            if (operatorFilter[op.type] && ruleFilter[rules.length + op.index]) ret = true;
            else ret = false;
        } else ret = operatorFilter[op.type];
        return ret;
    };
    const filterRecords = function(record) {
        if (lastRecord === -1) return true;
        if (record <= lastRecord) return true;
        return false;
    };
    /* Collect the "down" record. */ this.down = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            recordStack.push(filteredRecords);
            records[circular.increment()] = {
                dirUp: false,
                depth: treeDepth,
                thisLine: filteredRecords,
                thatLine: undefined,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
            treeDepth += 1;
        }
    };
    /* Collect the "up" record. */ this.up = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            const thisLine = filteredRecords;
            const thatLine = recordStack.pop();
            const thatRecord = circular.getListIndex(thatLine);
            if (thatRecord !== -1) records[thatRecord].thatLine = thisLine;
            treeDepth -= 1;
            records[circular.increment()] = {
                dirUp: true,
                depth: treeDepth,
                thisLine: thisLine,
                thatLine: thatLine,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
        }
    };
    /* convert the trace records to a tree of nodes */ const toTreeObj = function() {
        /* private helper functions */ function nodeOpcode(node, opcode) {
            let name;
            let casetype;
            let modetype;
            if (opcode) {
                node.op = {
                    id: opcode.type,
                    name: utils.opcodeToString(opcode.type)
                };
                node.opData = undefined;
                switch(opcode.type){
                    case id.RNM:
                        node.opData = rules[opcode.index].name;
                        break;
                    case id.UDT:
                        node.opData = udts[opcode.index].name;
                        break;
                    case id.BKR:
                        if (opcode.index < rules.length) name = rules[opcode.index].name;
                        else name = udts[opcode.index - rules.length].name;
                        casetype = opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                        modetype = opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                        node.opData = `\\\\${casetype}${modetype}${name}`;
                        break;
                    case id.TLS:
                        node.opData = [];
                        for(let i = 0; i < opcode.string.length; i += 1)node.opData.push(opcode.string[i]);
                        break;
                    case id.TBS:
                        node.opData = [];
                        for(let i = 0; i < opcode.string.length; i += 1)node.opData.push(opcode.string[i]);
                        break;
                    case id.TRG:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    case id.REP:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    default:
                        throw new Error("unrecognized opcode");
                }
            } else {
                node.op = {
                    id: undefined,
                    name: undefined
                };
                node.opData = undefined;
            }
        }
        function nodePhrase(state, index, length) {
            if (state === id.MATCH) return {
                index: index,
                length: length
            };
            if (state === id.NOMATCH) return {
                index: index,
                length: 0
            };
            if (state === id.EMPTY) return {
                index: index,
                length: 0
            };
            return null;
        }
        let nodeId = -1;
        function nodeDown(parent, record, depth) {
            const node = {
                // eslint-disable-next-line no-plusplus
                id: nodeId++,
                branch: -1,
                parent: parent,
                up: false,
                down: false,
                depth: depth,
                children: []
            };
            if (record) {
                node.down = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = null;
                nodeOpcode(node, record.opcode);
            } else {
                node.state = {
                    id: undefined,
                    name: undefined
                };
                node.phrase = nodePhrase();
                nodeOpcode(node, undefined);
            }
            return node;
        }
        function nodeUp(node, record) {
            if (record) {
                node.up = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = nodePhrase(record.state, record.phraseIndex, record.phraseLength);
                if (!node.down) nodeOpcode(node, record.opcode);
            }
        }
        /* walk the final tree: label branches and count leaf nodes */ let leafNodes = 0;
        let depth = -1;
        let branchCount = 1;
        function walk(node) {
            depth += 1;
            node.branch = branchCount;
            if (depth > treeDepth) treeDepth = depth;
            if (node.children.length === 0) leafNodes += 1;
            else for(let i = 0; i < node.children.length; i += 1){
                if (i > 0) branchCount += 1;
                node.children[i].leftMost = false;
                node.children[i].rightMost = false;
                if (node.leftMost) node.children[i].leftMost = i === 0;
                if (node.rightMost) node.children[i].rightMost = i === node.children.length - 1;
                walk(node.children[i]);
            }
            depth -= 1;
        }
        function display(node, offset) {
            let name;
            const obj = {};
            obj.id = node.id;
            obj.branch = node.branch;
            obj.leftMost = node.leftMost;
            obj.rightMost = node.rightMost;
            name = node.state.name ? node.state.name : "ACTIVE";
            obj.state = {
                id: node.state.id,
                name: name
            };
            name = node.op.name ? node.op.name : "?";
            obj.op = {
                id: node.op.id,
                name: name
            };
            if (typeof node.opData === "string") obj.opData = node.opData;
            else if (Array.isArray(node.opData)) {
                obj.opData = [];
                for(let i = 0; i < node.opData.length; i += 1)obj.opData[i] = node.opData[i];
            } else obj.opData = undefined;
            if (node.phrase) obj.phrase = {
                index: node.phrase.index,
                length: node.phrase.length
            };
            else obj.phrase = null;
            obj.depth = node.depth;
            obj.children = [];
            for(let i = 0; i < node.children.length; i += 1){
                const c = i !== node.children.length - 1;
                obj.children[i] = display(node.children[i], offset, c);
            }
            return obj;
        }
        /* construct the tree beginning here */ const branch = [];
        let root;
        let node;
        let parent;
        let record;
        let firstRecord = true;
        /* push a dummy node so the root node will have a non-null parent */ const dummy = nodeDown(null, null, -1);
        branch.push(dummy);
        node = dummy;
        circular.forEach((lineIndex)=>{
            record = records[lineIndex];
            if (firstRecord) {
                firstRecord = false;
                if (record.depth > 0) {
                    /* push some dummy nodes to fill in for missing records */ const num = record.dirUp ? record.depth + 1 : record.depth;
                    for(let i = 0; i < num; i += 1){
                        parent = node;
                        node = nodeDown(node, null, i);
                        branch.push(node);
                        parent.children.push(node);
                    }
                }
            }
            if (record.dirUp) {
                /* handle the next record up */ node = branch.pop();
                nodeUp(node, record);
                node = branch[branch.length - 1];
            } else {
                /* handle the next record down */ parent = node;
                node = nodeDown(node, record, record.depth);
                branch.push(node);
                parent.children.push(node);
            }
        });
        /* if not at root, walk it up to root */ while(branch.length > 1){
            node = branch.pop();
            nodeUp(node, null);
        }
        /* maybe redundant or paranoid tests: these should never happen */ if (dummy.children.length === 0) throw new Error("trace.toTree(): parse tree has no nodes");
        if (branch.length === 0) throw new Error("trace.toTree(): integrity check: dummy root node disappeared?");
        /* if no record for start rule: find the pseudo root node (first dummy node above a real node) */ root = dummy.children[0];
        let prev = root;
        while(root && !root.down && !root.up){
            prev = root;
            root = root.children[0];
        }
        root = prev;
        /* walk the tree of nodes: label brances and count leaves */ root.leftMost = true;
        root.rightMost = true;
        walk(root);
        root.branch = 0;
        /* generate the exported object */ const obj = {};
        obj.string = [];
        for(let i = 0; i < chars.length; i += 1)obj.string[i] = chars[i];
        /* generate the exported rule names */ obj.rules = [];
        for(let i = 0; i < rules.length; i += 1)obj.rules[i] = rules[i].name;
        /* generate the exported UDT names */ obj.udts = [];
        for(let i = 0; i < udts.length; i += 1)obj.udts[i] = udts[i].name;
        /* generate the ids */ obj.id = {};
        obj.id.ALT = {
            id: id.ALT,
            name: "ALT"
        };
        obj.id.CAT = {
            id: id.CAT,
            name: "CAT"
        };
        obj.id.REP = {
            id: id.REP,
            name: "REP"
        };
        obj.id.RNM = {
            id: id.RNM,
            name: "RNM"
        };
        obj.id.TLS = {
            id: id.TLS,
            name: "TLS"
        };
        obj.id.TBS = {
            id: id.TBS,
            name: "TBS"
        };
        obj.id.TRG = {
            id: id.TRG,
            name: "TRG"
        };
        obj.id.UDT = {
            id: id.UDT,
            name: "UDT"
        };
        obj.id.AND = {
            id: id.AND,
            name: "AND"
        };
        obj.id.NOT = {
            id: id.NOT,
            name: "NOT"
        };
        obj.id.BKR = {
            id: id.BKR,
            name: "BKR"
        };
        obj.id.BKA = {
            id: id.BKA,
            name: "BKA"
        };
        obj.id.BKN = {
            id: id.BKN,
            name: "BKN"
        };
        obj.id.ABG = {
            id: id.ABG,
            name: "ABG"
        };
        obj.id.AEN = {
            id: id.AEN,
            name: "AEN"
        };
        obj.id.ACTIVE = {
            id: id.ACTIVE,
            name: "ACTIVE"
        };
        obj.id.MATCH = {
            id: id.MATCH,
            name: "MATCH"
        };
        obj.id.EMPTY = {
            id: id.EMPTY,
            name: "EMPTY"
        };
        obj.id.NOMATCH = {
            id: id.NOMATCH,
            name: "NOMATCH"
        };
        /* generate the max tree depth */ obj.treeDepth = treeDepth;
        /* generate the number of leaf nodes (branches) */ obj.leafNodes = leafNodes;
        /* generate the types of the left- and right-most branches */ let branchesIncomplete;
        if (root.down) {
            if (root.up) branchesIncomplete = "none";
            else branchesIncomplete = "right";
        } else if (root.up) branchesIncomplete = "left";
        else branchesIncomplete = "both";
        obj.branchesIncomplete = branchesIncomplete;
        obj.tree = display(root, root.depth, false);
        return obj;
    };
    // Returns the trace records as JSON parse tree object.
    // - stringify: if `true`, the object is 'stringified' before returning, otherwise, the object itself is returned.
    this.toTree = function(stringify) {
        const obj = toTreeObj();
        if (stringify) return JSON.stringify(obj);
        return obj;
    };
    // Translate the trace records to HTML format and create a complete HTML page for browser display.
    this.toHtmlPage = function(mode, caption, title) {
        return utils.htmlToPage(this.toHtml(mode, caption), title);
    };
    /* From here on down, these are just helper functions for `toHtml()`. */ const htmlHeader = function(mode, caption) {
        /* open the page */ /* write the HTML5 header with table style */ /* open the <table> tag */ let modeName;
        switch(mode){
            case MODE_HEX:
                modeName = "hexadecimal";
                break;
            case MODE_DEC:
                modeName = "decimal";
                break;
            case MODE_ASCII:
                modeName = "ASCII";
                break;
            case MODE_UNICODE:
                modeName = "UNICODE";
                break;
            default:
                throw new Error(`${thisFileName}htmlHeader: unrecognized mode: ${mode}`);
        }
        let header = "";
        header += `<p>display mode: ${modeName}</p>\n`;
        header += `<table class="${style.CLASS_TRACE}">\n`;
        if (typeof caption === "string") header += `<caption>${caption}</caption>`;
        return header;
    };
    const htmlFooter = function() {
        let footer = "";
        /* close the </table> tag */ footer += "</table>\n";
        /* display a table legend */ footer += `<p class="${style.CLASS_MONOSPACE}">legend:<br>\n`;
        footer += "(a)&nbsp;-&nbsp;line number<br>\n";
        footer += "(b)&nbsp;-&nbsp;matching line number<br>\n";
        footer += "(c)&nbsp;-&nbsp;phrase offset<br>\n";
        footer += "(d)&nbsp;-&nbsp;phrase length<br>\n";
        footer += "(e)&nbsp;-&nbsp;tree depth<br>\n";
        footer += "(f)&nbsp;-&nbsp;operator state<br>\n";
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_ACTIVE}">&darr;</span>&nbsp;&nbsp;phrase opened<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">&uarr;M</span> phrase matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_EMPTY}">&uarr;E</span> empty phrase matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_NOMATCH}">&uarr;N</span> phrase not matched<br>\n`;
        footer += "operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>\n";
        footer += `phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to ${MAX_PHRASE} characters of the phrase being matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">matched characters</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKAHEAD}">matched characters in look ahead mode</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKBEHIND}">matched characters in look behind mode</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_REMAINDER}">remainder characters(not yet examined by parser)</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_CTRLCHAR}">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_EMPTY} empty string<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_END} end of input string<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_CONTINUE} input string display truncated<br>\n`;
        footer += "</p>\n";
        footer += `<p class="${style.CLASS_MONOSPACE}">\n`;
        footer += "<sup>&dagger;</sup>original ABNF operators:<br>\n";
        footer += "ALT - alternation<br>\n";
        footer += "CAT - concatenation<br>\n";
        footer += "REP - repetition<br>\n";
        footer += "RNM - rule name<br>\n";
        footer += "TRG - terminal range<br>\n";
        footer += "TLS - terminal literal string (case insensitive)<br>\n";
        footer += "TBS - terminal binary string (case sensitive)<br>\n";
        footer += "<br>\n";
        footer += "<sup>&Dagger;</sup>super set SABNF operators:<br>\n";
        footer += "UDT - user-defined terminal<br>\n";
        footer += "AND - positive look ahead<br>\n";
        footer += "NOT - negative look ahead<br>\n";
        footer += "BKA - positive look behind<br>\n";
        footer += "BKN - negative look behind<br>\n";
        footer += "BKR - back reference<br>\n";
        footer += "ABG - anchor - begin of input string<br>\n";
        footer += "AEN - anchor - end of input string<br>\n";
        footer += "</p>\n";
        return footer;
    };
    this.indent = function(depth) {
        let html = "";
        for(let i = 0; i < depth; i += 1)html += ".";
        return html;
    };
    /* format the TRG operator */ const displayTrg = function(mode, op) {
        let html = "";
        if (op.type === id.TRG) {
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                let hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html += mode === MODE_HEX ? "%x" : "U+";
                html += hex;
                hex = op.max.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html += `&ndash;${hex}`;
            } else html = `%d${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
        }
        return html;
    };
    /* format the REP operator */ const displayRep = function(mode, op) {
        let html = "";
        if (op.type === id.REP) {
            if (mode === MODE_HEX) {
                let hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html = `x${hex}`;
                if (op.max < Infinity) {
                    hex = op.max.toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = `0${hex}`;
                } else hex = "inf";
                html += `&ndash;${hex}`;
            } else if (op.max < Infinity) html = `${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
            else html = `${op.min.toString(10)}&ndash;inf`;
        }
        return html;
    };
    /* format the TBS operator */ const displayTbs = function(mode, op) {
        let html = "";
        if (op.type === id.TBS) {
            const len = Math.min(op.string.length, MAX_TLS * 2);
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                html += mode === MODE_HEX ? "%x" : "U+";
                for(let i = 0; i < len; i += 1){
                    let hex;
                    if (i > 0) html += ".";
                    hex = op.string[i].toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = `0${hex}`;
                    html += hex;
                }
            } else {
                html = "%d";
                for(let i = 0; i < len; i += 1){
                    if (i > 0) html += ".";
                    html += op.string[i].toString(10);
                }
            }
            if (len < op.string.length) html += PHRASE_CONTINUE;
        }
        return html;
    };
    /* format the TLS operator */ const displayTls = function(mode, op) {
        let html = "";
        if (op.type === id.TLS) {
            const len = Math.min(op.string.length, MAX_TLS);
            if (mode === MODE_HEX || mode === MODE_DEC) {
                let charu;
                let charl;
                let base;
                if (mode === MODE_HEX) {
                    html = "%x";
                    base = 16;
                } else {
                    html = "%d";
                    base = 10;
                }
                for(let i = 0; i < len; i += 1){
                    if (i > 0) html += ".";
                    charl = op.string[i];
                    if (charl >= 97 && charl <= 122) {
                        charu = charl - 32;
                        html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
                    } else if (charl >= 65 && charl <= 90) {
                        charu = charl;
                        charl += 32;
                        html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
                    } else html += charl.toString(base).toUpperCase();
                }
                if (len < op.string.length) html += PHRASE_CONTINUE;
            } else {
                html = '"';
                for(let i = 0; i < len; i += 1)html += utils.asciiChars[op.string[i]];
                if (len < op.string.length) html += PHRASE_CONTINUE;
                html += '"';
            }
        }
        return html;
    };
    const subPhrase = function(mode, charsArg, index, length, prev) {
        if (length === 0) return "";
        let phrase = "";
        const comma = prev ? "," : "";
        switch(mode){
            case MODE_HEX:
                phrase = comma + utils.charsToHex(charsArg, index, length);
                break;
            case MODE_DEC:
                if (prev) return `,${utils.charsToDec(charsArg, index, length)}`;
                phrase = comma + utils.charsToDec(charsArg, index, length);
                break;
            case MODE_UNICODE:
                phrase = utils.charsToUnicode(charsArg, index, length);
                break;
            case MODE_ASCII:
            default:
                phrase = utils.charsToAsciiHtml(charsArg, index, length);
                break;
        }
        return phrase;
    };
    /* display phrases matched in look-behind mode */ const displayBehind = function(mode, charsArg, state, index, length, anchor) {
        let html = "";
        let beg1;
        let len1;
        let beg2;
        let len2;
        let lastchar = PHRASE_END;
        const spanBehind = `<span class="${style.CLASS_LOOKBEHIND}">`;
        const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
        const spanend = "</span>";
        let prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.MATCH:
            case id.ACTIVE:
                beg1 = index - length;
                len1 = anchor - beg1;
                beg2 = anchor;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanBehind;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    const displayForward = function(mode, charsArg, state, index, length, spanAhead) {
        let html = "";
        let beg1;
        let len1;
        let beg2;
        let len2;
        let lastchar = PHRASE_END;
        const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
        const spanend = "</span>";
        let prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.ACTIVE:
                beg1 = index;
                len1 = 0;
                beg2 = index;
                len2 = charsArg.length - beg2;
                break;
            case id.MATCH:
                beg1 = index;
                len1 = length;
                beg2 = index + len1;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanAhead;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    /* display phrases matched in look-ahead mode */ const displayAhead = function(mode, charsArg, state, index, length) {
        const spanAhead = `<span class="${style.CLASS_LOOKAHEAD}">`;
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* display phrases matched in normal parsing mode */ const displayNone = function(mode, charsArg, state, index, length) {
        const spanAhead = `<span class="${style.CLASS_MATCH}">`;
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* Returns the filtered records, formatted as an HTML table. */ const htmlTable = function(mode) {
        if (rules === null) return "";
        let html = "";
        let thisLine;
        let thatLine;
        let lookAhead;
        let lookBehind;
        let lookAround;
        let anchor;
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        circular.forEach((lineIndex)=>{
            const line = records[lineIndex];
            thisLine = line.thisLine;
            thatLine = line.thatLine !== undefined ? line.thatLine : "--";
            lookAhead = false;
            lookBehind = false;
            lookAround = false;
            if (line.lookAround === id.LOOKAROUND_AHEAD) {
                lookAhead = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.AND || line.opcode.type === id.NOT) {
                lookAhead = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            if (line.lookAround === id.LOOKAROUND_BEHIND) {
                lookBehind = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.BKA || line.opcode.type === id.BKN) {
                lookBehind = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            html += "<tr>";
            html += `<td>${thisLine}</td><td>${thatLine}</td>`;
            html += `<td>${line.phraseIndex}</td>`;
            html += `<td>${line.phraseLength}</td>`;
            html += `<td>${line.depth}</td>`;
            html += "<td>";
            switch(line.state){
                case id.ACTIVE:
                    html += `<span class="${style.CLASS_ACTIVE}">&darr;&nbsp;</span>`;
                    break;
                case id.MATCH:
                    html += `<span class="${style.CLASS_MATCH}">&uarr;M</span>`;
                    break;
                case id.NOMATCH:
                    html += `<span class="${style.CLASS_NOMATCH}">&uarr;N</span>`;
                    break;
                case id.EMPTY:
                    html += `<span class="${style.CLASS_EMPTY}">&uarr;E</span>`;
                    break;
                default:
                    html += `<span class="${style.CLASS_ACTIVE}">--</span>`;
                    break;
            }
            html += "</td>";
            html += "<td>";
            html += that.indent(line.depth);
            if (lookAhead) html += `<span class="${style.CLASS_LOOKAHEAD}">`;
            else if (lookBehind) html += `<span class="${style.CLASS_LOOKBEHIND}">`;
            html += utils.opcodeToString(line.opcode.type);
            if (line.opcode.type === id.RNM) html += `(${rules[line.opcode.index].name}) `;
            if (line.opcode.type === id.BKR) {
                const casetype = line.opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                const modetype = line.opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                html += `(\\${casetype}${modetype}${rules[line.opcode.index].name}) `;
            }
            if (line.opcode.type === id.UDT) html += `(${udts[line.opcode.index].name}) `;
            if (line.opcode.type === id.TRG) html += `(${displayTrg(mode, line.opcode)}) `;
            if (line.opcode.type === id.TBS) html += `(${displayTbs(mode, line.opcode)}) `;
            if (line.opcode.type === id.TLS) html += `(${displayTls(mode, line.opcode)}) `;
            if (line.opcode.type === id.REP) html += `(${displayRep(mode, line.opcode)}) `;
            if (lookAround) html += "</span>";
            html += "</td>";
            html += "<td>";
            if (lookBehind) html += displayBehind(mode, chars, line.state, line.phraseIndex, line.phraseLength, anchor);
            else if (lookAhead) html += displayAhead(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            else html += displayNone(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            html += "</td></tr>\n";
        });
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        html += "</table>\n";
        return html;
    };
    // Translate the trace records to HTML format.
    // - *modearg* - can be `"ascii"`, `"decimal"`, `"hexadecimal"` or `"unicode"`.
    // Determines the format of the string character code display.
    // - *caption* - optional caption for the HTML table.
    this.toHtml = function(modearg, caption) {
        /* writes the trace records as a table in a complete html page */ let mode = MODE_ASCII;
        if (typeof modearg === "string" && modearg.length >= 3) {
            const modein = modearg.toLowerCase().slice(0, 3);
            if (modein === "hex") mode = MODE_HEX;
            else if (modein === "dec") mode = MODE_DEC;
            else if (modein === "uni") mode = MODE_UNICODE;
        }
        let html = "";
        html += htmlHeader(mode, caption);
        html += htmlTable(mode);
        html += htmlFooter();
        return html;
    };
};

});


parcelRegister("cPeg2", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module reads the input grammar file and does a preliminary analysis
// before attempting to parse it into a grammar object.
// See:<br>
// `./dist/scanner-grammar.bnf`<br>
// for the grammar file this parser is based on.
//
// It has two primary functions.
// - verify the character codes - no non-printing ASCII characters
// - catalog the lines - create an array with a line object for each line.
// The object carries information about the line number and character length which is used
// by the parser generator primarily for error reporting.



module.exports = function exfn(chars, errors, strict, trace) {
    const thisFileName = "scanner.js: ";
    const apglib = (parcelRequire("bK0XY"));
    const grammar = new (parcelRequire("2Thuy"))();
    const { callbacks: callbacks } = (parcelRequire("iGc7M"));
    /* Scan the grammar for character code errors and catalog the lines. */ const lines = [];
    // eslint-disable-next-line new-cap
    const parser = new apglib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new apglib.ast();
    parser.ast.callbacks = callbacks;
    if (trace) {
        if (trace.traceObject !== "traceObject") throw new TypeError(`${thisFileName}trace argument is not a trace object`);
        parser.trace = trace;
    }
    /* parse the input SABNF grammar */ const test = parser.parse(grammar, "file", chars);
    if (test.success !== true) {
        errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis error analyzing input SABNF grammar"
        });
        return;
    }
    const data = {
        lines: lines,
        lineNo: 0,
        errors: errors,
        strict: !!strict
    };
    /* translate (analyze) the input SABNF grammar */ parser.ast.translate(data);
    // eslint-disable-next-line consistent-return
    return lines;
};

});
parcelRegister("2Thuy", function(module, exports) {
// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 10
    //       udts = 0
    //    opcodes = 31
    //        ---   ABNF original opcodes
    //        ALT = 5
    //        CAT = 2
    //        REP = 4
    //        RNM = 11
    //        TLS = 0
    //        TBS = 4
    //        TRG = 5
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [0 - 4294967295]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "file",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "line",
        lower: "line",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "line-text",
        lower: "line-text",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "last-line",
        lower: "last-line",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "valid",
        lower: "valid",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "invalid",
        lower: "invalid",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "end",
        lower: "end",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "CRLF",
        lower: "crlf",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "LF",
        lower: "lf",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "CR",
        lower: "cr",
        index: 9,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* file */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[0].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(line)
    this.rules[0].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 3
    }; // RNM(last-line)
    /* line */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 4,
        index: 2
    }; // RNM(line-text)
    this.rules[1].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(end)
    /* line-text */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[2].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* last-line */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[3].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* valid */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[4].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* invalid */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[5].opcodes[1] = {
        type: 5,
        min: 0,
        max: 8
    }; // TRG
    this.rules[5].opcodes[2] = {
        type: 5,
        min: 11,
        max: 12
    }; // TRG
    this.rules[5].opcodes[3] = {
        type: 5,
        min: 14,
        max: 31
    }; // TRG
    this.rules[5].opcodes[4] = {
        type: 5,
        min: 127,
        max: 4294967295
    }; // TRG
    /* end */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[1] = {
        type: 4,
        index: 7
    }; // RNM(CRLF)
    this.rules[6].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(LF)
    this.rules[6].opcodes[3] = {
        type: 4,
        index: 9
    }; // RNM(CR)
    /* CRLF */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    /* LF */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    /* CR */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        let str = "";
        str += "file = *line [last-line]\n";
        str += "line = line-text end\n";
        str += "line-text = *(valid/invalid)\n";
        str += "last-line = 1*(valid/invalid)\n";
        str += "valid = %d32-126 / %d9\n";
        str += "invalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\n";
        str += "end = CRLF / LF / CR\n";
        str += "CRLF = %d13.10\n";
        str += "LF = %d10\n";
        str += "CR = %d13\n";
        return str;
    };
};

});

parcelRegister("iGc7M", function(module, exports) {

$parcel$export(module.exports, "callbacks", () => $d9958de8a569da02$export$b89c5c1b934d8237, (v) => $d9958de8a569da02$export$b89c5c1b934d8237 = v);
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // These are the AST translation callback functions used by the scanner
// to analyze the characters and lines.
var $d9958de8a569da02$export$b89c5c1b934d8237;

var $i0Pc2 = parcelRequire("i0Pc2");

var $bvrBx = parcelRequire("bvrBx");
function $d9958de8a569da02$var$semLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else data.lines.push({
        lineNo: data.lines.length,
        beginChar: phraseIndex,
        length: phraseCount,
        textLength: data.textLength,
        endType: data.endType,
        invalidChars: data.invalidCount
    });
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semLineText(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) data.textLength = phraseCount;
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semLastLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else if (data.strict) {
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount,
            textLength: phraseCount,
            endType: "none",
            invalidChars: data.invalidCount
        });
        data.errors.push({
            line: data.lineNo,
            char: phraseIndex + phraseCount,
            msg: "no line end on last line - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    } else {
        /* add a line ender */ chars.push(10);
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount + 1,
            textLength: phraseCount,
            endType: "LF",
            invalidChars: data.invalidCount
        });
    }
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semInvalid(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) data.errors.push({
        line: data.lineNo,
        char: phraseIndex,
        msg: `invalid character found '\\x${$bvrBx.charToHex(chars[phraseIndex])}'`
    });
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semEnd(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_POST) data.lineNo += 1;
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) {
        data.endType = "LF";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character LF(\\n, \\x0A) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semCR(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) {
        data.endType = "CR";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character CR(\\r, \\x0D) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $i0Pc2.SEM_OK;
}
function $d9958de8a569da02$var$semCRLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $i0Pc2.SEM_PRE) data.endType = "CRLF";
    return $i0Pc2.SEM_OK;
}
const $d9958de8a569da02$var$callbacks = [];
$d9958de8a569da02$var$callbacks.line = $d9958de8a569da02$var$semLine;
$d9958de8a569da02$var$callbacks["line-text"] = $d9958de8a569da02$var$semLineText;
$d9958de8a569da02$var$callbacks["last-line"] = $d9958de8a569da02$var$semLastLine;
$d9958de8a569da02$var$callbacks.invalid = $d9958de8a569da02$var$semInvalid;
$d9958de8a569da02$var$callbacks.end = $d9958de8a569da02$var$semEnd;
$d9958de8a569da02$var$callbacks.lf = $d9958de8a569da02$var$semLF;
$d9958de8a569da02$var$callbacks.cr = $d9958de8a569da02$var$semCR;
$d9958de8a569da02$var$callbacks.crlf = $d9958de8a569da02$var$semCRLF;
$d9958de8a569da02$export$b89c5c1b934d8237 = $d9958de8a569da02$var$callbacks;

});


parcelRegister("aBmP7", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module converts an input SABNF grammar text file into a
// grammar object that can be used with `apg-lib` in an application parser.
// **apg** is, in fact itself, an ABNF parser that generates an SABNF parser.
// It is based on the grammar<br>
// `./dist/abnf-for-sabnf-grammar.bnf`.<br>
// In its syntax phase, **apg** analyzes the user's input SABNF grammar for correct syntax, generating an AST as it goes.
// In its semantic phase, **apg** translates the AST to generate the parser for the input grammar.




module.exports = function exportParser() {
    const thisFileName = "parser: ";
    const ApgLib = (parcelRequire("bK0XY"));
    const id = ApgLib.ids;
    const syn = new (parcelRequire("kveh9"))();
    const sem = new (parcelRequire("jRoDF"))();
    const sabnfGrammar = new (parcelRequire("gS7vI"))();
    // eslint-disable-next-line new-cap
    const parser = new ApgLib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new ApgLib.ast();
    parser.callbacks = syn.callbacks;
    parser.ast.callbacks = sem.callbacks;
    /* find the line containing the given character index */ const findLine = function findLine(lines, charIndex, charLength) {
        if (charIndex < 0 || charIndex >= charLength) /* return error if out of range */ return -1;
        for(let i = 0; i < lines.length; i += 1){
            if (charIndex >= lines[i].beginChar && charIndex < lines[i].beginChar + lines[i].length) return i;
        }
        /* should never reach here */ return -1;
    };
    const translateIndex = function translateIndex(map, index) {
        let ret = -1;
        if (index < map.length) {
            for(let i = index; i < map.length; i += 1)if (map[i] !== null) {
                ret = map[i];
                break;
            }
        }
        return ret;
    };
    /* helper function when removing redundant opcodes */ const reduceOpcodes = function reduceOpcodes(rules) {
        rules.forEach((rule)=>{
            const opcodes = [];
            const map = [];
            let reducedIndex = 0;
            rule.opcodes.forEach((op)=>{
                if (op.type === id.ALT && op.children.length === 1) map.push(null);
                else if (op.type === id.CAT && op.children.length === 1) map.push(null);
                else if (op.type === id.REP && op.min === 1 && op.max === 1) map.push(null);
                else {
                    map.push(reducedIndex);
                    opcodes.push(op);
                    reducedIndex += 1;
                }
            });
            map.push(reducedIndex);
            /* translate original opcode indexes to the reduced set. */ opcodes.forEach((op)=>{
                if (op.type === id.ALT || op.type === id.CAT) for(let i = 0; i < op.children.length; i += 1)op.children[i] = translateIndex(map, op.children[i]);
            });
            rule.opcodes = opcodes;
        });
    };
    /* Parse the grammar - the syntax phase. */ /* SABNF grammar syntax errors are caught and reported here. */ this.syntax = function syntax(chars, lines, errors, strict, lite, trace) {
        if (trace) {
            if (trace.traceObject !== "traceObject") throw new TypeError(`${thisFileName}trace argument is not a trace object`);
            parser.trace = trace;
        }
        const data = {};
        data.errors = errors;
        data.strict = !!strict;
        data.lite = !!lite;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        data.ruleCount = 0;
        const result = parser.parse(sabnfGrammar, "file", chars, data);
        if (!result.success) errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis of input grammar failed"
        });
    };
    /* Parse the grammar - the semantic phase, translates the AST. */ /* SABNF grammar syntax errors are caught and reported here. */ this.semantic = function semantic(chars, lines, errors) {
        const data = {};
        data.errors = errors;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        parser.ast.translate(data);
        if (errors.length) return null;
        /* Remove unneeded operators. */ /* ALT operators with a single alternate */ /* CAT operators with a single phrase to concatenate */ /* REP(1,1) operators (`1*1RuleName` or `1RuleName` is the same as just `RuleName`.) */ reduceOpcodes(data.rules);
        return {
            rules: data.rules,
            udts: data.udts,
            lineMap: data.rulesLineMap
        };
    };
    // Generate a grammar constructor function.
    // An object instantiated from this constructor is used with the `apg-lib` `parser()` function.
    this.generateSource = function generateSource(chars, lines, rules, udts, config) {
        let source = "";
        let typescript = false;
        let lite = false;
        // config may have multiple grammar object type options in which case
        // --typescript > --lite  > no options
        if (config) {
            if (config.typescript) {
                typescript = true;
                lite = false;
            } else if (config.lite) {
                typescript = false;
                lite = true;
            }
        }
        let i;
        let bkrname;
        let bkrlower;
        let opcodeCount = 0;
        let charCodeMin = Infinity;
        let charCodeMax = 0;
        const ruleNames = [];
        const udtNames = [];
        let alt = 0;
        let cat = 0;
        let rnm = 0;
        let udt = 0;
        let rep = 0;
        let and = 0;
        let not = 0;
        let tls = 0;
        let tbs = 0;
        let trg = 0;
        let bkr = 0;
        let bka = 0;
        let bkn = 0;
        let abg = 0;
        let aen = 0;
        rules.forEach((rule)=>{
            ruleNames.push(rule.lower);
            opcodeCount += rule.opcodes.length;
            rule.opcodes.forEach((op)=>{
                switch(op.type){
                    case id.ALT:
                        alt += 1;
                        break;
                    case id.CAT:
                        cat += 1;
                        break;
                    case id.RNM:
                        rnm += 1;
                        break;
                    case id.UDT:
                        udt += 1;
                        break;
                    case id.REP:
                        rep += 1;
                        break;
                    case id.AND:
                        and += 1;
                        break;
                    case id.NOT:
                        not += 1;
                        break;
                    case id.BKA:
                        bka += 1;
                        break;
                    case id.BKN:
                        bkn += 1;
                        break;
                    case id.BKR:
                        bkr += 1;
                        break;
                    case id.ABG:
                        abg += 1;
                        break;
                    case id.AEN:
                        aen += 1;
                        break;
                    case id.TLS:
                        tls += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TBS:
                        tbs += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TRG:
                        trg += 1;
                        if (op.min < charCodeMin) charCodeMin = op.min;
                        if (op.max > charCodeMax) charCodeMax = op.max;
                        break;
                    default:
                        throw new Error("generateSource: unrecognized opcode");
                }
            });
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach((udtFunc)=>{
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        source += "// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>\n";
        source += "//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>\n";
        source += "//\n";
        source += "// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)\n";
        if (config) {
            if (config.funcName) source += `const ${config.funcName} = function grammar(){\n`;
            else if (typescript) source += "export function grammar(){\n";
            else if (lite) source += "export default function grammar(){\n";
            else source += `module.exports = function grammar(){\n`;
        } else source += `module.exports = function grammar(){\n`;
        source += "  // ```\n";
        source += "  // SUMMARY\n";
        source += `  //      rules = ${rules.length}\n`;
        source += `  //       udts = ${udts.length}\n`;
        source += `  //    opcodes = ${opcodeCount}\n`;
        source += "  //        ---   ABNF original opcodes\n";
        source += `  //        ALT = ${alt}\n`;
        source += `  //        CAT = ${cat}\n`;
        source += `  //        REP = ${rep}\n`;
        source += `  //        RNM = ${rnm}\n`;
        source += `  //        TLS = ${tls}\n`;
        source += `  //        TBS = ${tbs}\n`;
        source += `  //        TRG = ${trg}\n`;
        source += "  //        ---   SABNF superset opcodes\n";
        source += `  //        UDT = ${udt}\n`;
        source += `  //        AND = ${and}\n`;
        source += `  //        NOT = ${not}\n`;
        if (!lite) {
            source += `  //        BKA = ${bka}\n`;
            source += `  //        BKN = ${bkn}\n`;
            source += `  //        BKR = ${bkr}\n`;
            source += `  //        ABG = ${abg}\n`;
            source += `  //        AEN = ${aen}\n`;
        }
        source += "  // characters = [";
        if (tls + tbs + trg === 0) source += " none defined ]";
        else source += `${charCodeMin} - ${charCodeMax}]`;
        if (udt > 0) source += " + user defined";
        source += "\n";
        source += "  // ```\n";
        source += "  /* OBJECT IDENTIFIER (for internal parser use) */\n";
        source += "  this.grammarObject = 'grammarObject';\n";
        source += "\n";
        source += "  /* RULES */\n";
        source += "  this.rules = [];\n";
        rules.forEach((rule, ii)=>{
            let thisRule = "  this.rules[";
            thisRule += ii;
            thisRule += "] = { name: '";
            thisRule += rule.name;
            thisRule += "', lower: '";
            thisRule += rule.lower;
            thisRule += "', index: ";
            thisRule += rule.index;
            thisRule += ", isBkr: ";
            thisRule += rule.isBkr;
            thisRule += " };\n";
            source += thisRule;
        });
        source += "\n";
        source += "  /* UDTS */\n";
        source += "  this.udts = [];\n";
        if (udts.length > 0) udts.forEach((udtFunc, ii)=>{
            let thisUdt = "  this.udts[";
            thisUdt += ii;
            thisUdt += "] = { name: '";
            thisUdt += udtFunc.name;
            thisUdt += "', lower: '";
            thisUdt += udtFunc.lower;
            thisUdt += "', index: ";
            thisUdt += udtFunc.index;
            thisUdt += ", empty: ";
            thisUdt += udtFunc.empty;
            thisUdt += ", isBkr: ";
            thisUdt += udtFunc.isBkr;
            thisUdt += " };\n";
            source += thisUdt;
        });
        source += "\n";
        source += "  /* OPCODES */\n";
        rules.forEach((rule, ruleIndex)=>{
            if (ruleIndex > 0) source += "\n";
            source += `  /* ${rule.name} */\n`;
            source += `  this.rules[${ruleIndex}].opcodes = [];\n`;
            rule.opcodes.forEach((op, opIndex)=>{
                let prefix;
                switch(op.type){
                    case id.ALT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, children: [${op.children.toString()}] };// ALT\n`;
                        break;
                    case id.CAT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, children: [${op.children.toString()}] };// CAT\n`;
                        break;
                    case id.RNM:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, index: ${op.index} };// RNM(${rules[op.index].name})\n`;
                        break;
                    case id.BKR:
                        if (op.index >= rules.length) {
                            bkrname = udts[op.index - rules.length].name;
                            bkrlower = udts[op.index - rules.length].lower;
                        } else {
                            bkrname = rules[op.index].name;
                            bkrlower = rules[op.index].lower;
                        }
                        prefix = "%i";
                        if (op.bkrCase === id.BKR_MODE_CS) prefix = "%s";
                        if (op.bkrMode === id.BKR_MODE_UM) prefix += "%u";
                        else prefix += "%p";
                        bkrname = prefix + bkrname;
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, index: ${op.index}, lower: '${bkrlower}'` + `, bkrCase: ${op.bkrCase}, bkrMode: ${op.bkrMode} };// BKR(\\${bkrname})\n`;
                        break;
                    case id.UDT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, empty: ${op.empty}, index: ${op.index} };// UDT(${udts[op.index].name})\n`;
                        break;
                    case id.REP:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, min: ${op.min}, max: ${op.max} };// REP\n`;
                        break;
                    case id.AND:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// AND\n`;
                        break;
                    case id.NOT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// NOT\n`;
                        break;
                    case id.ABG:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// ABG(%^)\n`;
                        break;
                    case id.AEN:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// AEN(%$)\n`;
                        break;
                    case id.BKA:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// BKA\n`;
                        break;
                    case id.BKN:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// BKN\n`;
                        break;
                    case id.TLS:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, string: [${op.string.toString()}] };// TLS\n`;
                        break;
                    case id.TBS:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, string: [${op.string.toString()}] };// TBS\n`;
                        break;
                    case id.TRG:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, min: ${op.min}, max: ${op.max} };// TRG\n`;
                        break;
                    default:
                        throw new Error("parser.js: ~143: unrecognized opcode");
                }
            });
        });
        source += "\n";
        source += "  // The `toString()` function will display the original grammar file(s) that produced these opcodes.\n";
        source += "  this.toString = function toString(){\n";
        source += '    let str = "";\n';
        let str;
        lines.forEach((line)=>{
            const end = line.beginChar + line.length;
            str = "";
            source += '    str += "';
            for(let ii = line.beginChar; ii < end; ii += 1){
                switch(chars[ii]){
                    case 9:
                        str = " ";
                        break;
                    case 10:
                        str = "\\n";
                        break;
                    case 13:
                        str = "\\r";
                        break;
                    case 34:
                        str = '\\"';
                        break;
                    case 92:
                        str = "\\\\";
                        break;
                    default:
                        str = String.fromCharCode(chars[ii]);
                        break;
                }
                source += str;
            }
            source += '";\n';
        });
        source += "    return str;\n";
        source += "  }\n";
        source += "}\n";
        return source;
    };
    // Generate a grammar file object.
    // Returns the same object as instantiating the constructor function returned by<br>
    // `this.generateSource()`.<br>
    this.generateObject = function generateObject(stringArg, rules, udts) {
        const obj = {};
        const ruleNames = [];
        const udtNames = [];
        const string = stringArg.slice(0);
        obj.grammarObject = "grammarObject";
        rules.forEach((rule)=>{
            ruleNames.push(rule.lower);
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach((udtFunc)=>{
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        obj.callbacks = [];
        ruleNames.forEach((name)=>{
            obj.callbacks[name] = false;
        });
        if (udts.length > 0) udtNames.forEach((name)=>{
            obj.callbacks[name] = false;
        });
        obj.rules = rules;
        obj.udts = udts;
        obj.toString = function toStringFunc() {
            return string;
        };
        return obj;
    };
};

});
parcelRegister("kveh9", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the callback functions for the syntax phase of the generation.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    const thisFileName = "syntax-callbacks.js: ";
    const apglib = (parcelRequire("bK0XY"));
    const id = apglib.ids;
    let topAlt;
    /* syntax, RNM, callback functions */ const synFile = function synFile(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack = [];
                data.repCount = 0;
                break;
            case id.EMPTY:
                data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "grammar file is empty"
                });
                break;
            case id.MATCH:
                if (data.ruleCount === 0) data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "no rules defined"
                });
                break;
            case id.NOMATCH:
                throw new Error(`${thisFileName}synFile: grammar file NOMATCH: design error: should never happen.`);
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    // eslint-disable-next-line func-names
    const synRule = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack.length = 0;
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            case id.EMPTY:
                throw new Error(`${thisFileName}synRule: EMPTY: rule cannot be empty`);
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.ruleCount += 1;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRuleError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF line. Invalid rule, comment or blank line."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRuleNameError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Rule names must be alphanum and begin with alphabetic character."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synDefinedAsError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Expected '=' or '=/'. Not found."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAndOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "AND operator(&) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synNotOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "NOT operator(!) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBkaOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Positive look-behind operator(&&) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Positive look-behind operator(&&) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBknOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Negative look-behind operator(!!) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Negative look-behind operator(!!) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAbgOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Beginning of string anchor(%^) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Beginning of string anchor(%^) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAenOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "End of string anchor(%$) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "End of string anchor(%$) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBkrOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Back reference operator(${name}) found - strict ABNF specified.`
                    });
                } else if (data.lite) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Back reference operator(${name}) found - apg-lite specified.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synUdtOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `UDT operator found(${name}) - strict ABNF specified.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.tlsOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string (see 'quoted-string' definition, RFC 7405.)"
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synStringTab = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.stringTabChar = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.tlsOpen),
                    char: topAlt.tlsOpen,
                    msg: 'Case-insensitive literal string("...") opened but not closed.'
                });
                topAlt.basicError = true;
                topAlt.tlsOpen = null;
                break;
            case id.MATCH:
                topAlt.tlsOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.clsOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive literal string('...') opened but not closed."
                });
                topAlt.clsOpen = null;
                topAlt.basicError = true;
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive string operator('...') found - strict ABNF specified."
                });
                topAlt.clsOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.prosValOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in prose value string."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) opened but not closed."
                });
                topAlt.basicError = true;
                topAlt.prosValOpen = null;
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) found. The ABNF syntax is valid, but a parser cannot be generated from this grammar."
                });
                topAlt.prosValOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synGroupOpen = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: phraseIndex,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synGroupClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.groupOpen),
                    char: topAlt.groupOpen,
                    msg: 'Group "(...)" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.groupError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synOptionOpen = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: phraseIndex,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synOptionClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.optionOpen),
                    char: topAlt.optionOpen,
                    msg: 'Option "[...]" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.optionError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBasicElementError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (topAlt.basicError === false) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF element."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synLineEnd = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (result.phraseLength === 1 && data.strict) {
                    const end = chars[phraseIndex] === 13 ? "CR" : "LF";
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Line end '${end}' found - strict ABNF specified, only CRLF allowed.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synLineEndError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized grammar element or characters."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRepetition = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.repCount += 1;
                break;
            case id.MATCH:
                data.repCount += 1;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    // Define the list of callback functions.
    this.callbacks = [];
    this.callbacks.andop = synAndOp;
    this.callbacks.basicelementerr = synBasicElementError;
    this.callbacks.clsclose = synClsClose;
    this.callbacks.clsopen = synClsOpen;
    this.callbacks.clsstring = synClsString;
    this.callbacks.definedaserror = synDefinedAsError;
    this.callbacks.file = synFile;
    this.callbacks.groupclose = synGroupClose;
    this.callbacks.groupopen = synGroupOpen;
    this.callbacks.lineenderror = synLineEndError;
    this.callbacks.lineend = synLineEnd;
    this.callbacks.notop = synNotOp;
    this.callbacks.optionclose = synOptionClose;
    this.callbacks.optionopen = synOptionOpen;
    this.callbacks.prosvalclose = synProsValClose;
    this.callbacks.prosvalopen = synProsValOpen;
    this.callbacks.prosvalstring = synProsValString;
    this.callbacks.repetition = synRepetition;
    this.callbacks.rule = synRule;
    this.callbacks.ruleerror = synRuleError;
    this.callbacks.rulenameerror = synRuleNameError;
    this.callbacks.stringtab = synStringTab;
    this.callbacks.tlsclose = synTlsClose;
    this.callbacks.tlsopen = synTlsOpen;
    this.callbacks.tlsstring = synTlsString;
    this.callbacks.udtop = synUdtOp;
    this.callbacks.bkaop = synBkaOp;
    this.callbacks.bknop = synBknOp;
    this.callbacks.bkrop = synBkrOp;
    this.callbacks.abgop = synAbgOp;
    this.callbacks.aenop = synAenOp;
};

});

parcelRegister("jRoDF", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the AST translation callback functions for the semantic analysis
// phase of the generator.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    const apglib = (parcelRequire("bK0XY"));
    const id = apglib.ids;
    /* Some helper functions. */ const NameList = function NameList() {
        this.names = [];
        /* Adds a new rule name object to the list. Returns -1 if the name already exists. */ /* Returns the added name object if the name does not already exist. */ this.add = function add(name) {
            let ret = -1;
            const find = this.get(name);
            if (find === -1) {
                ret = {
                    name: name,
                    lower: name.toLowerCase(),
                    index: this.names.length
                };
                this.names.push(ret);
            }
            return ret;
        };
        /* Brute-force look up. */ this.get = function get(name) {
            let ret = -1;
            const lower = name.toLowerCase();
            for(let i = 0; i < this.names.length; i += 1)if (this.names[i].lower === lower) {
                ret = this.names[i];
                break;
            }
            return ret;
        };
    };
    /* converts text decimal numbers from, e.g. %d99, to an integer */ const decnum = function decnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1)num = 10 * num + chars[i] - 48;
        return num;
    };
    /* converts text binary numbers from, e.g. %b10, to an integer */ const binnum = function binnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1)num = 2 * num + chars[i] - 48;
        return num;
    };
    /* converts text hexadecimal numbers from, e.g. %xff, to an integer */ const hexnum = function hexnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1){
            let digit = chars[i];
            if (digit >= 48 && digit <= 57) digit -= 48;
            else if (digit >= 65 && digit <= 70) digit -= 55;
            else if (digit >= 97 && digit <= 102) digit -= 87;
            else throw new Error("hexnum out of range");
            num = 16 * num + digit;
        }
        return num;
    };
    // This is the prototype for all semantic analysis callback functions.
    // ````
    // state - the translator state
    //   id.SEM_PRE for downward (pre-branch) traversal of the AST
    //   id.SEM_POST for upward (post branch) traversal of the AST
    // chars - the array of character codes for the input string
    // phraseIndex - index into the chars array to the first
    //               character of the phrase
    // phraseCount - the number of characters in the phrase
    // data - user-defined data passed to the translator
    //        for use by the callback functions.
    // @return id.SEM_OK, normal return.
    //         id.SEM_SKIP in state id.SEM_PRE will
    //         skip the branch below.
    //         Any thing else is an error which will
    //         stop the translation.
    // ````
    /*
  function semCallbackPrototype(state, chars, phraseIndex, phraseCount, data) {
    let ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
    } else if (state === id.SEM_POST) {
    }
    return ret;
  }
  */ // The AST callback functions.
    function semFile(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleNames = new NameList();
            data.udtNames = new NameList();
            data.rules = [];
            data.udts = [];
            data.rulesLineMap = [];
            data.opcodes = [];
            data.altStack = [];
            data.topStack = null;
            data.topRule = null;
        } else if (state === id.SEM_POST) {
            /* validate RNM rule names and set opcode rule index */ let nameObj;
            data.rules.forEach((rule)=>{
                rule.isBkr = false;
                rule.opcodes.forEach((op)=>{
                    if (op.type === id.RNM) {
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj === -1) {
                            data.errors.push({
                                line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                char: op.index.phraseIndex,
                                msg: `Rule name '${op.index.name}' used but not defined.`
                            });
                            op.index = -1;
                        } else op.index = nameObj.index;
                    }
                });
            });
            /* validate BKR rule names and set opcode rule index */ data.udts.forEach((udt)=>{
                udt.isBkr = false;
            });
            data.rules.forEach((rule)=>{
                rule.opcodes.forEach((op)=>{
                    if (op.type === id.BKR) {
                        rule.hasBkr = true;
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj !== -1) {
                            data.rules[nameObj.index].isBkr = true;
                            op.index = nameObj.index;
                        } else {
                            nameObj = data.udtNames.get(op.index.name);
                            if (nameObj !== -1) {
                                data.udts[nameObj.index].isBkr = true;
                                op.index = data.rules.length + nameObj.index;
                            } else {
                                data.errors.push({
                                    line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                    char: op.index.phraseIndex,
                                    msg: `Back reference name '${op.index.name}' refers to undefined rule or unamed UDT.`
                                });
                                op.index = -1;
                            }
                        }
                    }
                });
            });
        }
        return ret;
    }
    function semRule(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.altStack.length = 0;
            data.topStack = null;
            data.rulesLineMap.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex
            });
        }
        return ret;
    }
    function semRuleLookup(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleName = "";
            data.definedas = "";
        } else if (state === id.SEM_POST) {
            let ruleName;
            if (data.definedas === "=") {
                ruleName = data.ruleNames.add(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Rule name '${data.ruleName}' previously defined.`
                    });
                } else {
                    /* start a new rule */ data.topRule = {
                        name: ruleName.name,
                        lower: ruleName.lower,
                        opcodes: [],
                        index: ruleName.index
                    };
                    data.rules.push(data.topRule);
                    data.opcodes = data.topRule.opcodes;
                }
            } else {
                ruleName = data.ruleNames.get(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Rule name '${data.ruleName}' for incremental alternate not previously defined.`
                    });
                } else {
                    data.topRule = data.rules[ruleName.index];
                    data.opcodes = data.topRule.opcodes;
                }
            }
        }
        return ret;
    }
    function semAlternation(state, chars, phraseIndex, phraseCount, data) {
        let ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            const TRUE = true;
            while(TRUE){
                if (data.definedas === null) {
                    /* rule error - skip opcode generation */ ret = id.SEM_SKIP;
                    break;
                }
                if (data.topStack === null) {
                    /* top-level ALT */ if (data.definedas === "=") {
                        /* "=" new rule */ data.topStack = {
                            alt: {
                                type: id.ALT,
                                children: []
                            },
                            cat: null
                        };
                        data.altStack.push(data.topStack);
                        data.opcodes.push(data.topStack.alt);
                        break;
                    }
                    /* "=/" incremental alternate */ data.topStack = {
                        alt: data.opcodes[0],
                        cat: null
                    };
                    data.altStack.push(data.topStack);
                    break;
                }
                /* lower-level ALT */ data.topStack = {
                    alt: {
                        type: id.ALT,
                        children: []
                    },
                    cat: null
                };
                data.altStack.push(data.topStack);
                data.opcodes.push(data.topStack.alt);
                break;
            }
        } else if (state === id.SEM_POST) {
            data.altStack.pop();
            if (data.altStack.length > 0) data.topStack = data.altStack[data.altStack.length - 1];
            else data.topStack = null;
        }
        return ret;
    }
    function semConcatenation(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.topStack.alt.children.push(data.opcodes.length);
            data.topStack.cat = {
                type: id.CAT,
                children: []
            };
            data.opcodes.push(data.topStack.cat);
        } else if (state === id.SEM_POST) data.topStack.cat = null;
        return ret;
    }
    function semRepetition(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.topStack.cat.children.push(data.opcodes.length);
        return ret;
    }
    function semOptionOpen(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.REP,
            min: 0,
            max: 1,
            char: phraseIndex
        });
        return ret;
    }
    function semRuleName(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.ruleName = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDefined(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=";
        return ret;
    }
    function semIncAlt(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=/";
        return ret;
    }
    function semRepOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = Infinity;
            data.topRep = {
                type: id.REP,
                min: 0,
                max: Infinity
            };
            data.opcodes.push(data.topRep);
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: `repetition min cannot be greater than max: min: ${data.min}: max: ${data.max}`
            });
            data.topRep.min = data.min;
            data.topRep.max = data.max;
        }
        return ret;
    }
    function semRepMin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMinMax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            data.max = decnum(chars, phraseIndex, phraseCount);
            data.min = data.max;
        }
        return ret;
    }
    function semAndOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AND
        });
        return ret;
    }
    function semNotOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.NOT
        });
        return ret;
    }
    function semRnmOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.RNM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: phraseIndex,
                name: apglib.utils.charsToString(chars, phraseIndex, phraseCount)
            }
        });
        return ret;
    }
    function semAbgOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.ABG
        });
        return ret;
    }
    function semAenOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AEN
        });
        return ret;
    }
    function semBkaOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKA
        });
        return ret;
    }
    function semBknOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKN
        });
        return ret;
    }
    function semBkrOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ci = true; /* default to case insensitive */ 
            data.cs = false;
            data.um = true;
            data.pm = false;
        } else if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKR,
            bkrCase: data.cs === true ? id.BKR_MODE_CS : id.BKR_MODE_CI,
            bkrMode: data.pm === true ? id.BKR_MODE_PM : id.BKR_MODE_UM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: data.bkrname.phraseIndex,
                name: apglib.utils.charsToString(chars, data.bkrname.phraseIndex, data.bkrname.phraseLength)
            }
        });
        return ret;
    }
    function semBkrCi(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.ci = true;
        return ret;
    }
    function semBkrCs(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.cs = true;
        return ret;
    }
    function semBkrUm(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.um = true;
        return ret;
    }
    function semBkrPm(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.pm = true;
        return ret;
    }
    function semBkrName(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.bkrname = {
            phraseIndex: phraseIndex,
            phraseLength: phraseCount
        };
        return ret;
    }
    function semUdtEmpty(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            let udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: true
            });
            data.opcodes.push({
                type: id.UDT,
                empty: true,
                index: udtName.index
            });
        }
        return ret;
    }
    function semUdtNonEmpty(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            let udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtNonEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: false
            });
            data.opcodes.push({
                type: id.UDT,
                empty: false,
                index: udtName.index,
                syntax: null,
                semantic: null
            });
        }
        return ret;
    }
    function semTlsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tlscase = true; /* default to case insensitive */ 
        return ret;
    }
    function semTlsCase(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount > 0 && (chars[phraseIndex + 1] === 83 || chars[phraseIndex + 1] === 115)) data.tlscase = false; /* set to case sensitive */ 
        }
        return ret;
    }
    function semTlsString(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (data.tlscase) {
                const str = chars.slice(phraseIndex, phraseIndex + phraseCount);
                for(let i = 0; i < str.length; i += 1)if (str[i] >= 65 && str[i] <= 90) str[i] += 32;
                data.opcodes.push({
                    type: id.TLS,
                    string: str
                });
            } else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex, phraseIndex + phraseCount)
            });
        }
        return ret;
    }
    function semClsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount <= 2) /* only TLS is allowed to be empty */ data.opcodes.push({
                type: id.TLS,
                string: []
            });
            else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex + 1, phraseIndex + phraseCount - 1)
            });
        }
        return ret;
    }
    function semTbsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tbsstr = [];
        else if (state === id.SEM_POST) data.opcodes.push({
            type: id.TBS,
            string: data.tbsstr
        });
        return ret;
    }
    function semTrgOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = 0;
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: `TRG, (%dmin-max), min cannot be greater than max: min: ${data.min}: max: ${data.max}`
            });
            data.opcodes.push({
                type: id.TRG,
                min: data.min,
                max: data.max
            });
        }
        return ret;
    }
    function semDmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(decnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semBstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(binnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semXstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(hexnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    // Define the callback functions to the AST object.
    this.callbacks = [];
    this.callbacks.abgop = semAbgOp;
    this.callbacks.aenop = semAenOp;
    this.callbacks.alternation = semAlternation;
    this.callbacks.andop = semAndOp;
    this.callbacks.bmax = semBmax;
    this.callbacks.bmin = semBmin;
    this.callbacks.bkaop = semBkaOp;
    this.callbacks.bknop = semBknOp;
    this.callbacks.bkrop = semBkrOp;
    this.callbacks["bkr-name"] = semBkrName;
    this.callbacks.bstring = semBstring;
    this.callbacks.clsop = semClsOp;
    this.callbacks.ci = semBkrCi;
    this.callbacks.cs = semBkrCs;
    this.callbacks.um = semBkrUm;
    this.callbacks.pm = semBkrPm;
    this.callbacks.concatenation = semConcatenation;
    this.callbacks.defined = semDefined;
    this.callbacks.dmax = semDmax;
    this.callbacks.dmin = semDmin;
    this.callbacks.dstring = semDstring;
    this.callbacks.file = semFile;
    this.callbacks.incalt = semIncAlt;
    this.callbacks.notop = semNotOp;
    this.callbacks.optionopen = semOptionOpen;
    this.callbacks["rep-max"] = semRepMax;
    this.callbacks["rep-min"] = semRepMin;
    this.callbacks["rep-min-max"] = semRepMinMax;
    this.callbacks.repetition = semRepetition;
    this.callbacks.repop = semRepOp;
    this.callbacks.rnmop = semRnmOp;
    this.callbacks.rule = semRule;
    this.callbacks.rulelookup = semRuleLookup;
    this.callbacks.rulename = semRuleName;
    this.callbacks.tbsop = semTbsOp;
    this.callbacks.tlscase = semTlsCase;
    this.callbacks.tlsstring = semTlsString;
    this.callbacks.tlsop = semTlsOp;
    this.callbacks.trgop = semTrgOp;
    this.callbacks["udt-empty"] = semUdtEmpty;
    this.callbacks["udt-non-empty"] = semUdtNonEmpty;
    this.callbacks.xmax = semXmax;
    this.callbacks.xmin = semXmin;
    this.callbacks.xstring = semXstring;
};

});

parcelRegister("gS7vI", function(module, exports) {
// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 95
    //       udts = 0
    //    opcodes = 372
    //        ---   ABNF original opcodes
    //        ALT = 43
    //        CAT = 48
    //        REP = 34
    //        RNM = 149
    //        TLS = 2
    //        TBS = 61
    //        TRG = 35
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [9 - 126]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "File",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "BlankLine",
        lower: "blankline",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "Rule",
        lower: "rule",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "RuleLookup",
        lower: "rulelookup",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "RuleNameTest",
        lower: "rulenametest",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "RuleName",
        lower: "rulename",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "RuleNameError",
        lower: "rulenameerror",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "DefinedAsTest",
        lower: "definedastest",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "DefinedAsError",
        lower: "definedaserror",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "DefinedAs",
        lower: "definedas",
        index: 9,
        isBkr: false
    };
    this.rules[10] = {
        name: "Defined",
        lower: "defined",
        index: 10,
        isBkr: false
    };
    this.rules[11] = {
        name: "IncAlt",
        lower: "incalt",
        index: 11,
        isBkr: false
    };
    this.rules[12] = {
        name: "RuleError",
        lower: "ruleerror",
        index: 12,
        isBkr: false
    };
    this.rules[13] = {
        name: "LineEndError",
        lower: "lineenderror",
        index: 13,
        isBkr: false
    };
    this.rules[14] = {
        name: "Alternation",
        lower: "alternation",
        index: 14,
        isBkr: false
    };
    this.rules[15] = {
        name: "Concatenation",
        lower: "concatenation",
        index: 15,
        isBkr: false
    };
    this.rules[16] = {
        name: "Repetition",
        lower: "repetition",
        index: 16,
        isBkr: false
    };
    this.rules[17] = {
        name: "Modifier",
        lower: "modifier",
        index: 17,
        isBkr: false
    };
    this.rules[18] = {
        name: "Predicate",
        lower: "predicate",
        index: 18,
        isBkr: false
    };
    this.rules[19] = {
        name: "BasicElement",
        lower: "basicelement",
        index: 19,
        isBkr: false
    };
    this.rules[20] = {
        name: "BasicElementErr",
        lower: "basicelementerr",
        index: 20,
        isBkr: false
    };
    this.rules[21] = {
        name: "Group",
        lower: "group",
        index: 21,
        isBkr: false
    };
    this.rules[22] = {
        name: "GroupError",
        lower: "grouperror",
        index: 22,
        isBkr: false
    };
    this.rules[23] = {
        name: "GroupOpen",
        lower: "groupopen",
        index: 23,
        isBkr: false
    };
    this.rules[24] = {
        name: "GroupClose",
        lower: "groupclose",
        index: 24,
        isBkr: false
    };
    this.rules[25] = {
        name: "Option",
        lower: "option",
        index: 25,
        isBkr: false
    };
    this.rules[26] = {
        name: "OptionError",
        lower: "optionerror",
        index: 26,
        isBkr: false
    };
    this.rules[27] = {
        name: "OptionOpen",
        lower: "optionopen",
        index: 27,
        isBkr: false
    };
    this.rules[28] = {
        name: "OptionClose",
        lower: "optionclose",
        index: 28,
        isBkr: false
    };
    this.rules[29] = {
        name: "RnmOp",
        lower: "rnmop",
        index: 29,
        isBkr: false
    };
    this.rules[30] = {
        name: "BkrOp",
        lower: "bkrop",
        index: 30,
        isBkr: false
    };
    this.rules[31] = {
        name: "bkrModifier",
        lower: "bkrmodifier",
        index: 31,
        isBkr: false
    };
    this.rules[32] = {
        name: "cs",
        lower: "cs",
        index: 32,
        isBkr: false
    };
    this.rules[33] = {
        name: "ci",
        lower: "ci",
        index: 33,
        isBkr: false
    };
    this.rules[34] = {
        name: "um",
        lower: "um",
        index: 34,
        isBkr: false
    };
    this.rules[35] = {
        name: "pm",
        lower: "pm",
        index: 35,
        isBkr: false
    };
    this.rules[36] = {
        name: "bkr-name",
        lower: "bkr-name",
        index: 36,
        isBkr: false
    };
    this.rules[37] = {
        name: "rname",
        lower: "rname",
        index: 37,
        isBkr: false
    };
    this.rules[38] = {
        name: "uname",
        lower: "uname",
        index: 38,
        isBkr: false
    };
    this.rules[39] = {
        name: "ename",
        lower: "ename",
        index: 39,
        isBkr: false
    };
    this.rules[40] = {
        name: "UdtOp",
        lower: "udtop",
        index: 40,
        isBkr: false
    };
    this.rules[41] = {
        name: "udt-non-empty",
        lower: "udt-non-empty",
        index: 41,
        isBkr: false
    };
    this.rules[42] = {
        name: "udt-empty",
        lower: "udt-empty",
        index: 42,
        isBkr: false
    };
    this.rules[43] = {
        name: "RepOp",
        lower: "repop",
        index: 43,
        isBkr: false
    };
    this.rules[44] = {
        name: "AltOp",
        lower: "altop",
        index: 44,
        isBkr: false
    };
    this.rules[45] = {
        name: "CatOp",
        lower: "catop",
        index: 45,
        isBkr: false
    };
    this.rules[46] = {
        name: "StarOp",
        lower: "starop",
        index: 46,
        isBkr: false
    };
    this.rules[47] = {
        name: "AndOp",
        lower: "andop",
        index: 47,
        isBkr: false
    };
    this.rules[48] = {
        name: "NotOp",
        lower: "notop",
        index: 48,
        isBkr: false
    };
    this.rules[49] = {
        name: "BkaOp",
        lower: "bkaop",
        index: 49,
        isBkr: false
    };
    this.rules[50] = {
        name: "BknOp",
        lower: "bknop",
        index: 50,
        isBkr: false
    };
    this.rules[51] = {
        name: "AbgOp",
        lower: "abgop",
        index: 51,
        isBkr: false
    };
    this.rules[52] = {
        name: "AenOp",
        lower: "aenop",
        index: 52,
        isBkr: false
    };
    this.rules[53] = {
        name: "TrgOp",
        lower: "trgop",
        index: 53,
        isBkr: false
    };
    this.rules[54] = {
        name: "TbsOp",
        lower: "tbsop",
        index: 54,
        isBkr: false
    };
    this.rules[55] = {
        name: "TlsOp",
        lower: "tlsop",
        index: 55,
        isBkr: false
    };
    this.rules[56] = {
        name: "TlsCase",
        lower: "tlscase",
        index: 56,
        isBkr: false
    };
    this.rules[57] = {
        name: "TlsOpen",
        lower: "tlsopen",
        index: 57,
        isBkr: false
    };
    this.rules[58] = {
        name: "TlsClose",
        lower: "tlsclose",
        index: 58,
        isBkr: false
    };
    this.rules[59] = {
        name: "TlsString",
        lower: "tlsstring",
        index: 59,
        isBkr: false
    };
    this.rules[60] = {
        name: "StringTab",
        lower: "stringtab",
        index: 60,
        isBkr: false
    };
    this.rules[61] = {
        name: "ClsOp",
        lower: "clsop",
        index: 61,
        isBkr: false
    };
    this.rules[62] = {
        name: "ClsOpen",
        lower: "clsopen",
        index: 62,
        isBkr: false
    };
    this.rules[63] = {
        name: "ClsClose",
        lower: "clsclose",
        index: 63,
        isBkr: false
    };
    this.rules[64] = {
        name: "ClsString",
        lower: "clsstring",
        index: 64,
        isBkr: false
    };
    this.rules[65] = {
        name: "ProsVal",
        lower: "prosval",
        index: 65,
        isBkr: false
    };
    this.rules[66] = {
        name: "ProsValOpen",
        lower: "prosvalopen",
        index: 66,
        isBkr: false
    };
    this.rules[67] = {
        name: "ProsValString",
        lower: "prosvalstring",
        index: 67,
        isBkr: false
    };
    this.rules[68] = {
        name: "ProsValClose",
        lower: "prosvalclose",
        index: 68,
        isBkr: false
    };
    this.rules[69] = {
        name: "rep-min",
        lower: "rep-min",
        index: 69,
        isBkr: false
    };
    this.rules[70] = {
        name: "rep-min-max",
        lower: "rep-min-max",
        index: 70,
        isBkr: false
    };
    this.rules[71] = {
        name: "rep-max",
        lower: "rep-max",
        index: 71,
        isBkr: false
    };
    this.rules[72] = {
        name: "rep-num",
        lower: "rep-num",
        index: 72,
        isBkr: false
    };
    this.rules[73] = {
        name: "dString",
        lower: "dstring",
        index: 73,
        isBkr: false
    };
    this.rules[74] = {
        name: "xString",
        lower: "xstring",
        index: 74,
        isBkr: false
    };
    this.rules[75] = {
        name: "bString",
        lower: "bstring",
        index: 75,
        isBkr: false
    };
    this.rules[76] = {
        name: "Dec",
        lower: "dec",
        index: 76,
        isBkr: false
    };
    this.rules[77] = {
        name: "Hex",
        lower: "hex",
        index: 77,
        isBkr: false
    };
    this.rules[78] = {
        name: "Bin",
        lower: "bin",
        index: 78,
        isBkr: false
    };
    this.rules[79] = {
        name: "dmin",
        lower: "dmin",
        index: 79,
        isBkr: false
    };
    this.rules[80] = {
        name: "dmax",
        lower: "dmax",
        index: 80,
        isBkr: false
    };
    this.rules[81] = {
        name: "bmin",
        lower: "bmin",
        index: 81,
        isBkr: false
    };
    this.rules[82] = {
        name: "bmax",
        lower: "bmax",
        index: 82,
        isBkr: false
    };
    this.rules[83] = {
        name: "xmin",
        lower: "xmin",
        index: 83,
        isBkr: false
    };
    this.rules[84] = {
        name: "xmax",
        lower: "xmax",
        index: 84,
        isBkr: false
    };
    this.rules[85] = {
        name: "dnum",
        lower: "dnum",
        index: 85,
        isBkr: false
    };
    this.rules[86] = {
        name: "bnum",
        lower: "bnum",
        index: 86,
        isBkr: false
    };
    this.rules[87] = {
        name: "xnum",
        lower: "xnum",
        index: 87,
        isBkr: false
    };
    this.rules[88] = {
        name: "alphanum",
        lower: "alphanum",
        index: 88,
        isBkr: false
    };
    this.rules[89] = {
        name: "owsp",
        lower: "owsp",
        index: 89,
        isBkr: false
    };
    this.rules[90] = {
        name: "wsp",
        lower: "wsp",
        index: 90,
        isBkr: false
    };
    this.rules[91] = {
        name: "space",
        lower: "space",
        index: 91,
        isBkr: false
    };
    this.rules[92] = {
        name: "comment",
        lower: "comment",
        index: 92,
        isBkr: false
    };
    this.rules[93] = {
        name: "LineEnd",
        lower: "lineend",
        index: 93,
        isBkr: false
    };
    this.rules[94] = {
        name: "LineContinue",
        lower: "linecontinue",
        index: 94,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* File */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(BlankLine)
    this.rules[0].opcodes[3] = {
        type: 4,
        index: 2
    }; // RNM(Rule)
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 12
    }; // RNM(RuleError)
    /* BlankLine */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            5,
            7
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[1].opcodes[2] = {
        type: 1,
        children: [
            3,
            4
        ]
    }; // ALT
    this.rules[1].opcodes[3] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[1].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[1].opcodes[5] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[1].opcodes[6] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[1].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* Rule */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[2].opcodes[1] = {
        type: 4,
        index: 3
    }; // RNM(RuleLookup)
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[2].opcodes[4] = {
        type: 1,
        children: [
            5,
            8
        ]
    }; // ALT
    this.rules[2].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[2].opcodes[6] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    this.rules[2].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[2].opcodes[9] = {
        type: 4,
        index: 13
    }; // RNM(LineEndError)
    this.rules[2].opcodes[10] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* RuleLookup */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[3].opcodes[1] = {
        type: 4,
        index: 4
    }; // RNM(RuleNameTest)
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 7
    }; // RNM(DefinedAsTest)
    /* RuleNameTest */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 4,
        index: 5
    }; // RNM(RuleName)
    this.rules[4].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(RuleNameError)
    /* RuleName */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RuleNameError */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[6].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[2] = {
        type: 5,
        min: 33,
        max: 60
    }; // TRG
    this.rules[6].opcodes[3] = {
        type: 5,
        min: 62,
        max: 126
    }; // TRG
    /* DefinedAsTest */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[7].opcodes[1] = {
        type: 4,
        index: 9
    }; // RNM(DefinedAs)
    this.rules[7].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(DefinedAsError)
    /* DefinedAsError */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 3,
        min: 1,
        max: 2
    }; // REP
    this.rules[8].opcodes[1] = {
        type: 5,
        min: 33,
        max: 126
    }; // TRG
    /* DefinedAs */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[9].opcodes[1] = {
        type: 4,
        index: 11
    }; // RNM(IncAlt)
    this.rules[9].opcodes[2] = {
        type: 4,
        index: 10
    }; // RNM(Defined)
    /* Defined */ this.rules[10].opcodes = [];
    this.rules[10].opcodes[0] = {
        type: 6,
        string: [
            61
        ]
    }; // TBS
    /* IncAlt */ this.rules[11].opcodes = [];
    this.rules[11].opcodes[0] = {
        type: 6,
        string: [
            61,
            47
        ]
    }; // TBS
    /* RuleError */ this.rules[12].opcodes = [];
    this.rules[12].opcodes[0] = {
        type: 2,
        children: [
            1,
            6
        ]
    }; // CAT
    this.rules[12].opcodes[1] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[12].opcodes[2] = {
        type: 1,
        children: [
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[12].opcodes[3] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[12].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[12].opcodes[5] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    this.rules[12].opcodes[6] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* LineEndError */ this.rules[13].opcodes = [];
    this.rules[13].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[13].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[13].opcodes[2] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[13].opcodes[3] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[13].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* Alternation */ this.rules[14].opcodes = [];
    this.rules[14].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[14].opcodes[1] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    this.rules[14].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[14].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[14].opcodes[4] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[14].opcodes[5] = {
        type: 4,
        index: 44
    }; // RNM(AltOp)
    this.rules[14].opcodes[6] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    /* Concatenation */ this.rules[15].opcodes = [];
    this.rules[15].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[15].opcodes[1] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    this.rules[15].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[15].opcodes[3] = {
        type: 2,
        children: [
            4,
            5
        ]
    }; // CAT
    this.rules[15].opcodes[4] = {
        type: 4,
        index: 45
    }; // RNM(CatOp)
    this.rules[15].opcodes[5] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    /* Repetition */ this.rules[16].opcodes = [];
    this.rules[16].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[16].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[16].opcodes[2] = {
        type: 4,
        index: 17
    }; // RNM(Modifier)
    this.rules[16].opcodes[3] = {
        type: 1,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // ALT
    this.rules[16].opcodes[4] = {
        type: 4,
        index: 21
    }; // RNM(Group)
    this.rules[16].opcodes[5] = {
        type: 4,
        index: 25
    }; // RNM(Option)
    this.rules[16].opcodes[6] = {
        type: 4,
        index: 19
    }; // RNM(BasicElement)
    this.rules[16].opcodes[7] = {
        type: 4,
        index: 20
    }; // RNM(BasicElementErr)
    /* Modifier */ this.rules[17].opcodes = [];
    this.rules[17].opcodes[0] = {
        type: 1,
        children: [
            1,
            5
        ]
    }; // ALT
    this.rules[17].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[17].opcodes[2] = {
        type: 4,
        index: 18
    }; // RNM(Predicate)
    this.rules[17].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[17].opcodes[4] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    this.rules[17].opcodes[5] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    /* Predicate */ this.rules[18].opcodes = [];
    this.rules[18].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[18].opcodes[1] = {
        type: 4,
        index: 49
    }; // RNM(BkaOp)
    this.rules[18].opcodes[2] = {
        type: 4,
        index: 50
    }; // RNM(BknOp)
    this.rules[18].opcodes[3] = {
        type: 4,
        index: 47
    }; // RNM(AndOp)
    this.rules[18].opcodes[4] = {
        type: 4,
        index: 48
    }; // RNM(NotOp)
    /* BasicElement */ this.rules[19].opcodes = [];
    this.rules[19].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10
        ]
    }; // ALT
    this.rules[19].opcodes[1] = {
        type: 4,
        index: 40
    }; // RNM(UdtOp)
    this.rules[19].opcodes[2] = {
        type: 4,
        index: 29
    }; // RNM(RnmOp)
    this.rules[19].opcodes[3] = {
        type: 4,
        index: 53
    }; // RNM(TrgOp)
    this.rules[19].opcodes[4] = {
        type: 4,
        index: 54
    }; // RNM(TbsOp)
    this.rules[19].opcodes[5] = {
        type: 4,
        index: 55
    }; // RNM(TlsOp)
    this.rules[19].opcodes[6] = {
        type: 4,
        index: 61
    }; // RNM(ClsOp)
    this.rules[19].opcodes[7] = {
        type: 4,
        index: 30
    }; // RNM(BkrOp)
    this.rules[19].opcodes[8] = {
        type: 4,
        index: 51
    }; // RNM(AbgOp)
    this.rules[19].opcodes[9] = {
        type: 4,
        index: 52
    }; // RNM(AenOp)
    this.rules[19].opcodes[10] = {
        type: 4,
        index: 65
    }; // RNM(ProsVal)
    /* BasicElementErr */ this.rules[20].opcodes = [];
    this.rules[20].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[20].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[20].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[20].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[20].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[20].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* Group */ this.rules[21].opcodes = [];
    this.rules[21].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[21].opcodes[1] = {
        type: 4,
        index: 23
    }; // RNM(GroupOpen)
    this.rules[21].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[21].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[21].opcodes[4] = {
        type: 4,
        index: 24
    }; // RNM(GroupClose)
    this.rules[21].opcodes[5] = {
        type: 4,
        index: 22
    }; // RNM(GroupError)
    /* GroupError */ this.rules[22].opcodes = [];
    this.rules[22].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[22].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[22].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[22].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[22].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[22].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* GroupOpen */ this.rules[23].opcodes = [];
    this.rules[23].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[23].opcodes[1] = {
        type: 6,
        string: [
            40
        ]
    }; // TBS
    this.rules[23].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* GroupClose */ this.rules[24].opcodes = [];
    this.rules[24].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[24].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[24].opcodes[2] = {
        type: 6,
        string: [
            41
        ]
    }; // TBS
    /* Option */ this.rules[25].opcodes = [];
    this.rules[25].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[25].opcodes[1] = {
        type: 4,
        index: 27
    }; // RNM(OptionOpen)
    this.rules[25].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[25].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[25].opcodes[4] = {
        type: 4,
        index: 28
    }; // RNM(OptionClose)
    this.rules[25].opcodes[5] = {
        type: 4,
        index: 26
    }; // RNM(OptionError)
    /* OptionError */ this.rules[26].opcodes = [];
    this.rules[26].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[26].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[26].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[26].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[26].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[26].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* OptionOpen */ this.rules[27].opcodes = [];
    this.rules[27].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[27].opcodes[1] = {
        type: 6,
        string: [
            91
        ]
    }; // TBS
    this.rules[27].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* OptionClose */ this.rules[28].opcodes = [];
    this.rules[28].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[28].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[28].opcodes[2] = {
        type: 6,
        string: [
            93
        ]
    }; // TBS
    /* RnmOp */ this.rules[29].opcodes = [];
    this.rules[29].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* BkrOp */ this.rules[30].opcodes = [];
    this.rules[30].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            4
        ]
    }; // CAT
    this.rules[30].opcodes[1] = {
        type: 6,
        string: [
            92
        ]
    }; // TBS
    this.rules[30].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[30].opcodes[3] = {
        type: 4,
        index: 31
    }; // RNM(bkrModifier)
    this.rules[30].opcodes[4] = {
        type: 4,
        index: 36
    }; // RNM(bkr-name)
    /* bkrModifier */ this.rules[31].opcodes = [];
    this.rules[31].opcodes[0] = {
        type: 1,
        children: [
            1,
            7,
            13,
            19
        ]
    }; // ALT
    this.rules[31].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[31].opcodes[2] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[4] = {
        type: 1,
        children: [
            5,
            6
        ]
    }; // ALT
    this.rules[31].opcodes[5] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[6] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[31].opcodes[8] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[9] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[10] = {
        type: 1,
        children: [
            11,
            12
        ]
    }; // ALT
    this.rules[31].opcodes[11] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[12] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[13] = {
        type: 2,
        children: [
            14,
            15
        ]
    }; // CAT
    this.rules[31].opcodes[14] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[15] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[16] = {
        type: 1,
        children: [
            17,
            18
        ]
    }; // ALT
    this.rules[31].opcodes[17] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[18] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[19] = {
        type: 2,
        children: [
            20,
            21
        ]
    }; // CAT
    this.rules[31].opcodes[20] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[21] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[22] = {
        type: 1,
        children: [
            23,
            24
        ]
    }; // ALT
    this.rules[31].opcodes[23] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[24] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    /* cs */ this.rules[32].opcodes = [];
    this.rules[32].opcodes[0] = {
        type: 6,
        string: [
            37,
            115
        ]
    }; // TBS
    /* ci */ this.rules[33].opcodes = [];
    this.rules[33].opcodes[0] = {
        type: 6,
        string: [
            37,
            105
        ]
    }; // TBS
    /* um */ this.rules[34].opcodes = [];
    this.rules[34].opcodes[0] = {
        type: 6,
        string: [
            37,
            117
        ]
    }; // TBS
    /* pm */ this.rules[35].opcodes = [];
    this.rules[35].opcodes[0] = {
        type: 6,
        string: [
            37,
            112
        ]
    }; // TBS
    /* bkr-name */ this.rules[36].opcodes = [];
    this.rules[36].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[36].opcodes[1] = {
        type: 4,
        index: 38
    }; // RNM(uname)
    this.rules[36].opcodes[2] = {
        type: 4,
        index: 39
    }; // RNM(ename)
    this.rules[36].opcodes[3] = {
        type: 4,
        index: 37
    }; // RNM(rname)
    /* rname */ this.rules[37].opcodes = [];
    this.rules[37].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* uname */ this.rules[38].opcodes = [];
    this.rules[38].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[38].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[38].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* ename */ this.rules[39].opcodes = [];
    this.rules[39].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[39].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[39].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* UdtOp */ this.rules[40].opcodes = [];
    this.rules[40].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[40].opcodes[1] = {
        type: 4,
        index: 42
    }; // RNM(udt-empty)
    this.rules[40].opcodes[2] = {
        type: 4,
        index: 41
    }; // RNM(udt-non-empty)
    /* udt-non-empty */ this.rules[41].opcodes = [];
    this.rules[41].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[41].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[41].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* udt-empty */ this.rules[42].opcodes = [];
    this.rules[42].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[42].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[42].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RepOp */ this.rules[43].opcodes = [];
    this.rules[43].opcodes[0] = {
        type: 1,
        children: [
            1,
            5,
            8,
            11,
            12
        ]
    }; // ALT
    this.rules[43].opcodes[1] = {
        type: 2,
        children: [
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[43].opcodes[2] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[3] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[4] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[43].opcodes[6] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[7] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[43].opcodes[9] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[10] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[11] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[12] = {
        type: 4,
        index: 70
    }; // RNM(rep-min-max)
    /* AltOp */ this.rules[44].opcodes = [];
    this.rules[44].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[44].opcodes[1] = {
        type: 6,
        string: [
            47
        ]
    }; // TBS
    this.rules[44].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* CatOp */ this.rules[45].opcodes = [];
    this.rules[45].opcodes[0] = {
        type: 4,
        index: 90
    }; // RNM(wsp)
    /* StarOp */ this.rules[46].opcodes = [];
    this.rules[46].opcodes[0] = {
        type: 6,
        string: [
            42
        ]
    }; // TBS
    /* AndOp */ this.rules[47].opcodes = [];
    this.rules[47].opcodes[0] = {
        type: 6,
        string: [
            38
        ]
    }; // TBS
    /* NotOp */ this.rules[48].opcodes = [];
    this.rules[48].opcodes[0] = {
        type: 6,
        string: [
            33
        ]
    }; // TBS
    /* BkaOp */ this.rules[49].opcodes = [];
    this.rules[49].opcodes[0] = {
        type: 6,
        string: [
            38,
            38
        ]
    }; // TBS
    /* BknOp */ this.rules[50].opcodes = [];
    this.rules[50].opcodes[0] = {
        type: 6,
        string: [
            33,
            33
        ]
    }; // TBS
    /* AbgOp */ this.rules[51].opcodes = [];
    this.rules[51].opcodes[0] = {
        type: 6,
        string: [
            37,
            94
        ]
    }; // TBS
    /* AenOp */ this.rules[52].opcodes = [];
    this.rules[52].opcodes[0] = {
        type: 6,
        string: [
            37,
            36
        ]
    }; // TBS
    /* TrgOp */ this.rules[53].opcodes = [];
    this.rules[53].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[53].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[53].opcodes[2] = {
        type: 1,
        children: [
            3,
            8,
            13
        ]
    }; // ALT
    this.rules[53].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // CAT
    this.rules[53].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[53].opcodes[5] = {
        type: 4,
        index: 79
    }; // RNM(dmin)
    this.rules[53].opcodes[6] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[7] = {
        type: 4,
        index: 80
    }; // RNM(dmax)
    this.rules[53].opcodes[8] = {
        type: 2,
        children: [
            9,
            10,
            11,
            12
        ]
    }; // CAT
    this.rules[53].opcodes[9] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[53].opcodes[10] = {
        type: 4,
        index: 83
    }; // RNM(xmin)
    this.rules[53].opcodes[11] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[12] = {
        type: 4,
        index: 84
    }; // RNM(xmax)
    this.rules[53].opcodes[13] = {
        type: 2,
        children: [
            14,
            15,
            16,
            17
        ]
    }; // CAT
    this.rules[53].opcodes[14] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[53].opcodes[15] = {
        type: 4,
        index: 81
    }; // RNM(bmin)
    this.rules[53].opcodes[16] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[17] = {
        type: 4,
        index: 82
    }; // RNM(bmax)
    /* TbsOp */ this.rules[54].opcodes = [];
    this.rules[54].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[54].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[54].opcodes[2] = {
        type: 1,
        children: [
            3,
            10,
            17
        ]
    }; // ALT
    this.rules[54].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[54].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[54].opcodes[5] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[6] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[54].opcodes[8] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[9] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[10] = {
        type: 2,
        children: [
            11,
            12,
            13
        ]
    }; // CAT
    this.rules[54].opcodes[11] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[54].opcodes[12] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[13] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[14] = {
        type: 2,
        children: [
            15,
            16
        ]
    }; // CAT
    this.rules[54].opcodes[15] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[16] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[17] = {
        type: 2,
        children: [
            18,
            19,
            20
        ]
    }; // CAT
    this.rules[54].opcodes[18] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[54].opcodes[19] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    this.rules[54].opcodes[20] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[21] = {
        type: 2,
        children: [
            22,
            23
        ]
    }; // CAT
    this.rules[54].opcodes[22] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[23] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    /* TlsOp */ this.rules[55].opcodes = [];
    this.rules[55].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[55].opcodes[1] = {
        type: 4,
        index: 56
    }; // RNM(TlsCase)
    this.rules[55].opcodes[2] = {
        type: 4,
        index: 57
    }; // RNM(TlsOpen)
    this.rules[55].opcodes[3] = {
        type: 4,
        index: 59
    }; // RNM(TlsString)
    this.rules[55].opcodes[4] = {
        type: 4,
        index: 58
    }; // RNM(TlsClose)
    /* TlsCase */ this.rules[56].opcodes = [];
    this.rules[56].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[56].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[56].opcodes[2] = {
        type: 7,
        string: [
            37,
            105
        ]
    }; // TLS
    this.rules[56].opcodes[3] = {
        type: 7,
        string: [
            37,
            115
        ]
    }; // TLS
    /* TlsOpen */ this.rules[57].opcodes = [];
    this.rules[57].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsClose */ this.rules[58].opcodes = [];
    this.rules[58].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsString */ this.rules[59].opcodes = [];
    this.rules[59].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[59].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[59].opcodes[2] = {
        type: 5,
        min: 32,
        max: 33
    }; // TRG
    this.rules[59].opcodes[3] = {
        type: 5,
        min: 35,
        max: 126
    }; // TRG
    this.rules[59].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* StringTab */ this.rules[60].opcodes = [];
    this.rules[60].opcodes[0] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* ClsOp */ this.rules[61].opcodes = [];
    this.rules[61].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[61].opcodes[1] = {
        type: 4,
        index: 62
    }; // RNM(ClsOpen)
    this.rules[61].opcodes[2] = {
        type: 4,
        index: 64
    }; // RNM(ClsString)
    this.rules[61].opcodes[3] = {
        type: 4,
        index: 63
    }; // RNM(ClsClose)
    /* ClsOpen */ this.rules[62].opcodes = [];
    this.rules[62].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsClose */ this.rules[63].opcodes = [];
    this.rules[63].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsString */ this.rules[64].opcodes = [];
    this.rules[64].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[64].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[64].opcodes[2] = {
        type: 5,
        min: 32,
        max: 38
    }; // TRG
    this.rules[64].opcodes[3] = {
        type: 5,
        min: 40,
        max: 126
    }; // TRG
    this.rules[64].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsVal */ this.rules[65].opcodes = [];
    this.rules[65].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[65].opcodes[1] = {
        type: 4,
        index: 66
    }; // RNM(ProsValOpen)
    this.rules[65].opcodes[2] = {
        type: 4,
        index: 67
    }; // RNM(ProsValString)
    this.rules[65].opcodes[3] = {
        type: 4,
        index: 68
    }; // RNM(ProsValClose)
    /* ProsValOpen */ this.rules[66].opcodes = [];
    this.rules[66].opcodes[0] = {
        type: 6,
        string: [
            60
        ]
    }; // TBS
    /* ProsValString */ this.rules[67].opcodes = [];
    this.rules[67].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[67].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[67].opcodes[2] = {
        type: 5,
        min: 32,
        max: 61
    }; // TRG
    this.rules[67].opcodes[3] = {
        type: 5,
        min: 63,
        max: 126
    }; // TRG
    this.rules[67].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsValClose */ this.rules[68].opcodes = [];
    this.rules[68].opcodes[0] = {
        type: 6,
        string: [
            62
        ]
    }; // TBS
    /* rep-min */ this.rules[69].opcodes = [];
    this.rules[69].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-min-max */ this.rules[70].opcodes = [];
    this.rules[70].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-max */ this.rules[71].opcodes = [];
    this.rules[71].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-num */ this.rules[72].opcodes = [];
    this.rules[72].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[72].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* dString */ this.rules[73].opcodes = [];
    this.rules[73].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* xString */ this.rules[74].opcodes = [];
    this.rules[74].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* bString */ this.rules[75].opcodes = [];
    this.rules[75].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* Dec */ this.rules[76].opcodes = [];
    this.rules[76].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[76].opcodes[1] = {
        type: 6,
        string: [
            68
        ]
    }; // TBS
    this.rules[76].opcodes[2] = {
        type: 6,
        string: [
            100
        ]
    }; // TBS
    /* Hex */ this.rules[77].opcodes = [];
    this.rules[77].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[77].opcodes[1] = {
        type: 6,
        string: [
            88
        ]
    }; // TBS
    this.rules[77].opcodes[2] = {
        type: 6,
        string: [
            120
        ]
    }; // TBS
    /* Bin */ this.rules[78].opcodes = [];
    this.rules[78].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[78].opcodes[1] = {
        type: 6,
        string: [
            66
        ]
    }; // TBS
    this.rules[78].opcodes[2] = {
        type: 6,
        string: [
            98
        ]
    }; // TBS
    /* dmin */ this.rules[79].opcodes = [];
    this.rules[79].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* dmax */ this.rules[80].opcodes = [];
    this.rules[80].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* bmin */ this.rules[81].opcodes = [];
    this.rules[81].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* bmax */ this.rules[82].opcodes = [];
    this.rules[82].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* xmin */ this.rules[83].opcodes = [];
    this.rules[83].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* xmax */ this.rules[84].opcodes = [];
    this.rules[84].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* dnum */ this.rules[85].opcodes = [];
    this.rules[85].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[85].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* bnum */ this.rules[86].opcodes = [];
    this.rules[86].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[86].opcodes[1] = {
        type: 5,
        min: 48,
        max: 49
    }; // TRG
    /* xnum */ this.rules[87].opcodes = [];
    this.rules[87].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[87].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[87].opcodes[2] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[87].opcodes[3] = {
        type: 5,
        min: 65,
        max: 70
    }; // TRG
    this.rules[87].opcodes[4] = {
        type: 5,
        min: 97,
        max: 102
    }; // TRG
    /* alphanum */ this.rules[88].opcodes = [];
    this.rules[88].opcodes[0] = {
        type: 2,
        children: [
            1,
            4
        ]
    }; // CAT
    this.rules[88].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[88].opcodes[2] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[3] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[4] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[88].opcodes[5] = {
        type: 1,
        children: [
            6,
            7,
            8,
            9
        ]
    }; // ALT
    this.rules[88].opcodes[6] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[7] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[8] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[88].opcodes[9] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    /* owsp */ this.rules[89].opcodes = [];
    this.rules[89].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[89].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* wsp */ this.rules[90].opcodes = [];
    this.rules[90].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[90].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* space */ this.rules[91].opcodes = [];
    this.rules[91].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[91].opcodes[1] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[91].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[91].opcodes[3] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[91].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* comment */ this.rules[92].opcodes = [];
    this.rules[92].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[92].opcodes[1] = {
        type: 6,
        string: [
            59
        ]
    }; // TBS
    this.rules[92].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[92].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[92].opcodes[4] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[92].opcodes[5] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* LineEnd */ this.rules[93].opcodes = [];
    this.rules[93].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[93].opcodes[1] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[93].opcodes[2] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[93].opcodes[3] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    /* LineContinue */ this.rules[94].opcodes = [];
    this.rules[94].opcodes[0] = {
        type: 2,
        children: [
            1,
            5
        ]
    }; // CAT
    this.rules[94].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[94].opcodes[2] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[94].opcodes[3] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[94].opcodes[4] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    this.rules[94].opcodes[5] = {
        type: 1,
        children: [
            6,
            7
        ]
    }; // ALT
    this.rules[94].opcodes[6] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[94].opcodes[7] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        let str = "";
        str += ";\n";
        str += "; ABNF for JavaScript APG 2.0 SABNF\n";
        str += "; RFC 5234 with some restrictions and additions.\n";
        str += "; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n";
        str += ';  - accepts %s"string" as a case-sensitive string\n';
        str += ';  - accepts %i"string" as a case-insensitive string\n';
        str += ';  - accepts "string" as a case-insensitive string\n';
        str += ";\n";
        str += "; Some restrictions:\n";
        str += ";   1. Rules must begin at first character of each line.\n";
        str += ";      Indentations on first rule and rules thereafter are not allowed.\n";
        str += ";   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n";
        str += ";   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n";
        str += ";      However, a working parser cannot be generated from them.\n";
        str += ";\n";
        str += "; Super set (SABNF) additions:\n";
        str += ";   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n";
        str += ";      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n";
        str += ";      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n";
        str += ";      e.g. &%d13 or &rule or !(A / B)\n";
        str += ";   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n";
        str += ";      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n";
        str += ";      u_name may be used as an element but no rule definition is given.\n";
        str += ";      e.g. rule = A / u_myUdt\n";
        str += ';           A = "a"\n';
        str += ";      would be a valid grammar.\n";
        str += ";   3. Case-sensitive, single-quoted strings are accepted.\n";
        str += ";      e.g. 'abc' would be equivalent to %d97.98.99\n";
        str += ';      (kept for backward compatibility, but superseded by %s"abc")  \n';
        str += "; New 12/26/2015\n";
        str += ";   4. Look-behind operators are accepted as element prefixes.\n";
        str += ";      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n";
        str += ";      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n";
        str += ";      e.g. &&%d13 or &&rule or !!(A / B)\n";
        str += ";   5. Back reference operators, i.e. \\rulename, are accepted.\n";
        str += ";      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n";
        str += ";      to match is a phrase previously matched by the rule 'rulename'.\n";
        str += ";      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n";
        str += ";      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n";
        str += ";      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n";
        str += ";      Back reference modifiers can be used to specify case and mode.\n";
        str += ";      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n";
        str += ";      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n";
        str += ";      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n";
        str += ";      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n";
        str += ";   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";   8. String end anchor, AEN(%$) matches the end of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";\n";
        str += "File            = *(BlankLine / Rule / RuleError)\n";
        str += "BlankLine       = *(%d32/%d9) [comment] LineEnd\n";
        str += "Rule            = RuleLookup owsp Alternation ((owsp LineEnd)\n";
        str += "                / (LineEndError LineEnd))\n";
        str += "RuleLookup      = RuleNameTest owsp DefinedAsTest\n";
        str += "RuleNameTest    = RuleName/RuleNameError\n";
        str += "RuleName        = alphanum\n";
        str += "RuleNameError   = 1*(%d33-60/%d62-126)\n";
        str += "DefinedAsTest   = DefinedAs / DefinedAsError\n";
        str += "DefinedAsError  = 1*2%d33-126\n";
        str += "DefinedAs       = IncAlt / Defined\n";
        str += "Defined         = %d61\n";
        str += "IncAlt          = %d61.47\n";
        str += "RuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\n";
        str += "LineEndError    = 1*(%d32-126 / %d9  / LineContinue)\n";
        str += "Alternation     = Concatenation *(owsp AltOp Concatenation)\n";
        str += "Concatenation   = Repetition *(CatOp Repetition)\n";
        str += "Repetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\n";
        str += "Modifier        = (Predicate [RepOp])\n";
        str += "                / RepOp\n";
        str += "Predicate       = BkaOp\n";
        str += "                / BknOp\n";
        str += "                / AndOp\n";
        str += "                / NotOp\n";
        str += "BasicElement    = UdtOp\n";
        str += "                / RnmOp\n";
        str += "                / TrgOp\n";
        str += "                / TbsOp\n";
        str += "                / TlsOp\n";
        str += "                / ClsOp\n";
        str += "                / BkrOp\n";
        str += "                / AbgOp\n";
        str += "                / AenOp\n";
        str += "                / ProsVal\n";
        str += "BasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\n";
        str += "Group           = GroupOpen  Alternation (GroupClose / GroupError)\n";
        str += "GroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "GroupOpen       = %d40 owsp\n";
        str += "GroupClose      = owsp %d41\n";
        str += "Option          = OptionOpen Alternation (OptionClose / OptionError)\n";
        str += "OptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "OptionOpen      = %d91 owsp\n";
        str += "OptionClose     = owsp %d93\n";
        str += "RnmOp           = alphanum\n";
        str += "BkrOp           = %d92 [bkrModifier] bkr-name\n";
        str += "bkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\n";
        str += "cs              = '%s'\n";
        str += "ci              = '%i'\n";
        str += "um              = '%u'\n";
        str += "pm              = '%p'\n";
        str += "bkr-name        = uname / ename / rname\n";
        str += "rname           = alphanum\n";
        str += "uname           = %d117.95 alphanum\n";
        str += "ename           = %d101.95 alphanum\n";
        str += "UdtOp           = udt-empty\n";
        str += "                / udt-non-empty\n";
        str += "udt-non-empty   = %d117.95 alphanum\n";
        str += "udt-empty       = %d101.95 alphanum\n";
        str += "RepOp           = (rep-min StarOp rep-max)\n";
        str += "                / (rep-min StarOp)\n";
        str += "                / (StarOp rep-max)\n";
        str += "                / StarOp\n";
        str += "                / rep-min-max\n";
        str += "AltOp           = %d47 owsp\n";
        str += "CatOp           = wsp\n";
        str += "StarOp          = %d42\n";
        str += "AndOp           = %d38\n";
        str += "NotOp           = %d33\n";
        str += "BkaOp           = %d38.38\n";
        str += "BknOp           = %d33.33\n";
        str += "AbgOp           = %d37.94\n";
        str += "AenOp           = %d37.36\n";
        str += "TrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\n";
        str += "TbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\n";
        str += "TlsOp           = TlsCase TlsOpen TlsString TlsClose\n";
        str += 'TlsCase         = ["%i" / "%s"]\n';
        str += "TlsOpen         = %d34\n";
        str += "TlsClose        = %d34\n";
        str += "TlsString       = *(%d32-33/%d35-126/StringTab)\n";
        str += "StringTab       = %d9\n";
        str += "ClsOp           = ClsOpen ClsString ClsClose\n";
        str += "ClsOpen         = %d39\n";
        str += "ClsClose        = %d39\n";
        str += "ClsString       = *(%d32-38/%d40-126/StringTab)\n";
        str += "ProsVal         = ProsValOpen ProsValString ProsValClose\n";
        str += "ProsValOpen     = %d60\n";
        str += "ProsValString   = *(%d32-61/%d63-126/StringTab)\n";
        str += "ProsValClose    = %d62\n";
        str += "rep-min         = rep-num\n";
        str += "rep-min-max     = rep-num\n";
        str += "rep-max         = rep-num\n";
        str += "rep-num         = 1*(%d48-57)\n";
        str += "dString         = dnum\n";
        str += "xString         = xnum\n";
        str += "bString         = bnum\n";
        str += "Dec             = (%d68/%d100)\n";
        str += "Hex             = (%d88/%d120)\n";
        str += "Bin             = (%d66/%d98)\n";
        str += "dmin            = dnum\n";
        str += "dmax            = dnum\n";
        str += "bmin            = bnum\n";
        str += "bmax            = bnum\n";
        str += "xmin            = xnum\n";
        str += "xmax            = xnum\n";
        str += "dnum            = 1*(%d48-57)\n";
        str += "bnum            = 1*%d48-49\n";
        str += "xnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n";
        str += ";\n";
        str += "; Basics\n";
        str += "alphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\n";
        str += "owsp            = *space\n";
        str += "wsp             = 1*space\n";
        str += "space           = %d32\n";
        str += "                / %d9\n";
        str += "                / comment\n";
        str += "                / LineContinue\n";
        str += "comment         = %d59 *(%d32-126 / %d9)\n";
        str += "LineEnd         = %d13.10\n";
        str += "                / %d10\n";
        str += "                / %d13\n";
        str += "LineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n";
        return str;
    };
};

});


parcelRegister("j3tAf", function(module, exports) {
/* eslint-disable class-methods-use-this */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Attributes Validation
//
// It is well known that recursive-descent parsers will fail if a rule is left recursive.
// Besides left recursion, there are a couple of other fatal attributes that need to be disclosed as well.
// There are several non-fatal attributes that are of interest also.
// This module will determine six different attributes listed here with simple examples.
//
// **fatal attributes**<br>
// left recursion<br>
// S = S "x" / "y"
//
// cyclic<br>
// S = S
//
// infinite<br>
// S = "y" S
//
// **non-fatal attributes** (but nice to know)<br>
// nested recursion<br>
// S = "a" S "b" / "y"
//
// right recursion<br>
// S = "x" S / "y"
//
// empty string<br>
// S = "x" S / ""
//
// Note that these are “aggregate” attributes, in that if the attribute is true it only means that it can be true,
// not that it will always be true for every input string.
// In the simple examples above the attributes may be obvious and definite – always true or false.
// However, for a large grammar with possibly hundreds of rules and parse tree branches,
// it can be obscure which branches lead to which attributes.
// Furthermore, different input strings will lead the parser down different branches.
// One input string may parse perfectly while another will hit a left-recursive branch and bottom out the call stack.
//
// It is for this reason that the APG parser generator computes these attributes.
// When using the API the attributes call is optional but generating a parser without checking the attributes - proceed at your own peril.
//
// Additionally, the attribute phase will identify rule dependencies and mutually-recursive groups. For example,
//
// S = "a" A "b" / "y"<br>
// A = "x"
//
// S is dependent on A but A is not dependent on S.
//
// S = "a" A "b" / "c"<br>
// A = "x" S "y" / "z"
//
// S and A are dependent on one another and are mutually recursive.



module.exports = function exportAttributes() {
    const id = (parcelRequire("i0Pc2"));
    const { ruleAttributes: ruleAttributes, showAttributes: showAttributes, showAttributeErrors: showAttributeErrors } = (parcelRequire("bVAxj"));
    const { ruleDependencies: ruleDependencies, showRuleDependencies: showRuleDependencies } = (parcelRequire("ctFDQ"));
    class State {
        constructor(rules, udts){
            this.rules = rules;
            this.udts = udts;
            this.ruleCount = rules.length;
            this.udtCount = udts.length;
            this.startRule = 0;
            this.dependenciesComplete = false;
            this.attributesComplete = false;
            this.isMutuallyRecursive = false;
            this.ruleIndexes = this.indexArray(this.ruleCount);
            this.ruleAlphaIndexes = this.indexArray(this.ruleCount);
            this.ruleTypeIndexes = this.indexArray(this.ruleCount);
            this.udtIndexes = this.indexArray(this.udtCount);
            this.udtAlphaIndexes = this.indexArray(this.udtCount);
            this.attrsErrorCount = 0;
            this.attrs = [];
            this.attrsErrors = [];
            this.attrsWorking = [];
            this.ruleDeps = [];
            for(let i = 0; i < this.ruleCount; i += 1){
                this.attrs.push(this.attrGen(this.rules[i]));
                this.attrsWorking.push(this.attrGen(this.rules[i]));
                this.ruleDeps.push(this.rdGen(rules[i], this.ruleCount, this.udtCount));
            }
            this.compRulesAlpha = this.compRulesAlpha.bind(this);
            this.compUdtsAlpha = this.compUdtsAlpha.bind(this);
            this.compRulesType = this.compRulesType.bind(this);
            this.compRulesGroup = this.compRulesGroup.bind(this);
        }
        // eslint-disable-next-line class-methods-use-this
        attrGen(rule) {
            return {
                left: false,
                nested: false,
                right: false,
                empty: false,
                finite: false,
                cyclic: false,
                leaf: false,
                isOpen: false,
                isComplete: false,
                rule: rule
            };
        }
        // eslint-disable-next-line class-methods-use-this
        attrInit(attr) {
            attr.left = false;
            attr.nested = false;
            attr.right = false;
            attr.empty = false;
            attr.finite = false;
            attr.cyclic = false;
            attr.leaf = false;
            attr.isOpen = false;
            attr.isComplete = false;
        }
        attrCopy(dst, src) {
            dst.left = src.left;
            dst.nested = src.nested;
            dst.right = src.right;
            dst.empty = src.empty;
            dst.finite = src.finite;
            dst.cyclic = src.cyclic;
            dst.leaf = src.leaf;
            dst.isOpen = src.isOpen;
            dst.isComplete = src.isComplete;
            dst.rule = src.rule;
        }
        rdGen(rule, ruleCount, udtCount) {
            const ret = {
                rule: rule,
                recursiveType: id.ATTR_N,
                groupNumber: -1,
                refersTo: this.falseArray(ruleCount),
                refersToUdt: this.falseArray(udtCount),
                referencedBy: this.falseArray(ruleCount)
            };
            return ret;
        }
        typeToString(recursiveType) {
            switch(recursiveType){
                case id.ATTR_N:
                    return " N";
                case id.ATTR_R:
                    return " R";
                case id.ATTR_MR:
                    return "MR";
                default:
                    return "UNKNOWN";
            }
        }
        falseArray(length) {
            const ret = [];
            if (length > 0) for(let i = 0; i < length; i += 1)ret.push(false);
            return ret;
        }
        falsifyArray(a) {
            for(let i = 0; i < a.length; i += 1)a[i] = false;
        }
        indexArray(length) {
            const ret = [];
            if (length > 0) for(let i = 0; i < length; i += 1)ret.push(i);
            return ret;
        }
        compRulesAlpha(left, right) {
            if (this.rules[left].lower < this.rules[right].lower) return -1;
            if (this.rules[left].lower > this.rules[right].lower) return 1;
            return 0;
        }
        compUdtsAlpha(left, right) {
            if (this.udts[left].lower < this.udts[right].lower) return -1;
            if (this.udts[left].lower > this.udts[right].lower) return 1;
            return 0;
        }
        compRulesType(left, right) {
            if (this.ruleDeps[left].recursiveType < this.ruleDeps[right].recursiveType) return -1;
            if (this.ruleDeps[left].recursiveType > this.ruleDeps[right].recursiveType) return 1;
            return 0;
        }
        compRulesGroup(left, right) {
            if (this.ruleDeps[left].recursiveType === id.ATTR_MR && this.ruleDeps[right].recursiveType === id.ATTR_MR) {
                if (this.ruleDeps[left].groupNumber < this.ruleDeps[right].groupNumber) return -1;
                if (this.ruleDeps[left].groupNumber > this.ruleDeps[right].groupNumber) return 1;
            }
            return 0;
        }
    }
    // eslint-disable-next-line no-unused-vars
    const attributes = function attributes(rules = [], udts = [], lineMap = [], errors = []) {
        // let i = 0;
        // Initialize the state. The state of the computation get passed around to multiple functions in multiple files.
        const state = new State(rules, udts);
        // Determine all rule dependencies
        //  - which rules each rule refers to
        //  - which rules reference each rule
        ruleDependencies(state);
        // Determine the attributes for each rule.
        ruleAttributes(state);
        if (state.attrsErrorCount) errors.push({
            line: 0,
            char: 0,
            msg: `${state.attrsErrorCount} attribute errors`
        });
        // Return the number of attribute errors to the caller.
        return state.attrsErrorCount;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        attributes: attributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors,
        showRuleDependencies: showRuleDependencies
    };
}();

});
parcelRegister("bVAxj", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module does the heavy lifting for attribute generation.

module.exports = function exportRuleAttributes() {
    const id = (parcelRequire("i0Pc2"));
    const thisFile = "rule-attributes.js";
    let state = null;
    function isEmptyOnly(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return false;
        return attr.empty;
    }
    function isRecursive(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return true;
        return false;
    }
    function isCatNested(attrs, count) {
        let i = 0;
        let j = 0;
        let k = 0;
        /* 1. if any child is nested, CAT is nested */ for(i = 0; i < count; i += 1){
            if (attrs[i].nested) return true;
        }
        /* 2.) the left-most right recursive child
               is followed by at least one non-empty child */ for(i = 0; i < count; i += 1){
            if (attrs[i].right && !attrs[i].leaf) for(j = i + 1; j < count; j += 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 3.) the right-most left recursive child
               is preceded by at least one non-empty child */ for(i = count - 1; i >= 0; i -= 1){
            if (attrs[i].left && !attrs[i].leaf) for(j = i - 1; j >= 0; j -= 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 4. there is at lease one recursive child between
              the left-most and right-most non-recursive, non-empty children */ for(i = 0; i < count; i += 1){
            if (!attrs[i].empty && !isRecursive(attrs[i])) for(j = i + 1; j < count; j += 1){
                if (isRecursive(attrs[j])) for(k = j + 1; k < count; k += 1){
                    if (!attrs[k].empty && !isRecursive(attrs[k])) return true;
                }
            }
        }
        /* none of the above */ return false;
    }
    function isCatCyclic(attrs, count) {
        /* if all children are cyclic, CAT is cyclic */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].cyclic) return false;
        }
        return true;
    }
    function isCatLeft(attrs, count) {
        /* if the left-most non-empty is left, CAT is left */ for(let i = 0; i < count; i += 1){
            if (attrs[i].left) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false; /* all left-most are empty */ 
    }
    function isCatRight(attrs, count) {
        /* if the right-most non-empty is right, CAT is right */ for(let i = count - 1; i >= 0; i -= 1){
            if (attrs[i].right) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false;
    }
    function isCatEmpty(attrs, count) {
        /* if all children are empty, CAT is empty */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].empty) return false;
        }
        return true;
    }
    function isCatFinite(attrs, count) {
        /* if all children are finite, CAT is finite */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].finite) return false;
        }
        return true;
    }
    function cat(stateArg, opcodes, opIndex, iAttr) {
        let i = 0;
        const opCat = opcodes[opIndex];
        const count = opCat.children.length;
        /* generate an empty array of child attributes */ const childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opCat.children[i], childAttrs[i]);
        iAttr.left = isCatLeft(childAttrs, count);
        iAttr.right = isCatRight(childAttrs, count);
        iAttr.nested = isCatNested(childAttrs, count);
        iAttr.empty = isCatEmpty(childAttrs, count);
        iAttr.finite = isCatFinite(childAttrs, count);
        iAttr.cyclic = isCatCyclic(childAttrs, count);
    }
    function alt(stateArg, opcodes, opIndex, iAttr) {
        let i = 0;
        const opAlt = opcodes[opIndex];
        const count = opAlt.children.length;
        /* generate an empty array of child attributes */ const childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opAlt.children[i], childAttrs[i]);
        /* if any child attribute is true, ALT is true */ iAttr.left = false;
        iAttr.right = false;
        iAttr.nested = false;
        iAttr.empty = false;
        iAttr.finite = false;
        iAttr.cyclic = false;
        for(i = 0; i < count; i += 1){
            if (childAttrs[i].left) iAttr.left = true;
            if (childAttrs[i].nested) iAttr.nested = true;
            if (childAttrs[i].right) iAttr.right = true;
            if (childAttrs[i].empty) iAttr.empty = true;
            if (childAttrs[i].finite) iAttr.finite = true;
            if (childAttrs[i].cyclic) iAttr.cyclic = true;
        }
    }
    function bkr(stateArg, opcodes, opIndex, iAttr) {
        const opBkr = opcodes[opIndex];
        if (opBkr.index >= stateArg.ruleCount) {
            /* use UDT values */ iAttr.empty = stateArg.udts[opBkr.index - stateArg.ruleCount].empty;
            iAttr.finite = true;
        } else {
            /* use the empty and finite values from the back referenced rule */ // eslint-disable-next-line no-use-before-define
            ruleAttrsEval(stateArg, opBkr.index, iAttr);
            /* however, this is a terminal node like TLS */ iAttr.left = false;
            iAttr.nested = false;
            iAttr.right = false;
            iAttr.cyclic = false;
        }
    }
    function opEval(stateArg, opcodes, opIndex, iAttr) {
        stateArg.attrInit(iAttr);
        const opi = opcodes[opIndex];
        switch(opi.type){
            case id.ALT:
                alt(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.CAT:
                cat(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.REP:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                if (opi.min === 0) {
                    iAttr.empty = true;
                    iAttr.finite = true;
                }
                break;
            case id.RNM:
                // eslint-disable-next-line no-use-before-define
                ruleAttrsEval(stateArg, opcodes[opIndex].index, iAttr);
                break;
            case id.BKR:
                bkr(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.AND:
            case id.NOT:
            case id.BKA:
            case id.BKN:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                iAttr.empty = true;
                break;
            case id.TLS:
                iAttr.empty = !opcodes[opIndex].string.length;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.TBS:
            case id.TRG:
                iAttr.empty = false;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.UDT:
                iAttr.empty = opi.empty;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.ABG:
            case id.AEN:
                iAttr.empty = true;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            default:
                throw new Error(`unknown opcode type: ${opi}`);
        }
    }
    // The main logic for handling rules that:
    //  - have already be evaluated
    //  - have not been evaluated and is the first occurrence on this branch
    //  - second occurrence on this branch for the start rule
    //  - second occurrence on this branch for non-start rules
    function ruleAttrsEval(stateArg, ruleIndex, iAttr) {
        const attri = stateArg.attrsWorking[ruleIndex];
        if (attri.isComplete) /* just use the completed values */ stateArg.attrCopy(iAttr, attri);
        else if (!attri.isOpen) {
            /* open the rule and traverse it */ attri.isOpen = true;
            opEval(stateArg, attri.rule.opcodes, 0, iAttr);
            /* complete this rule's attributes */ attri.left = iAttr.left;
            attri.right = iAttr.right;
            attri.nested = iAttr.nested;
            attri.empty = iAttr.empty;
            attri.finite = iAttr.finite;
            attri.cyclic = iAttr.cyclic;
            attri.leaf = false;
            attri.isOpen = false;
            attri.isComplete = true;
        } else if (ruleIndex === stateArg.startRule) /* use recursive leaf values */ {
            if (ruleIndex === stateArg.startRule) {
                iAttr.left = true;
                iAttr.right = true;
                iAttr.cyclic = true;
                iAttr.leaf = true;
            }
        } else /* non-start rule terminal leaf */ iAttr.finite = true;
    }
    // The main driver for the attribute generation.
    const ruleAttributes = (stateArg)=>{
        state = stateArg;
        let i = 0;
        let j = 0;
        const iAttr = state.attrGen();
        for(i = 0; i < state.ruleCount; i += 1){
            /* initialize working attributes */ for(j = 0; j < state.ruleCount; j += 1)state.attrInit(state.attrsWorking[j]);
            state.startRule = i;
            ruleAttrsEval(state, i, iAttr);
            /* save off the working attributes for this rule */ state.attrCopy(state.attrs[i], state.attrsWorking[i]);
        }
        state.attributesComplete = true;
        let attri = null;
        for(i = 0; i < state.ruleCount; i += 1){
            attri = state.attrs[i];
            if (attri.left || !attri.finite || attri.cyclic) {
                const temp = state.attrGen(attri.rule);
                state.attrCopy(temp, attri);
                state.attrsErrors.push(temp);
                state.attrsErrorCount += 1;
            }
        }
    };
    const truth = (val)=>val ? "t" : "f";
    const tError = (val)=>val ? "e" : "f";
    const fError = (val)=>val ? "t" : "e";
    const showAttr = (seq, index, attr, dep)=>{
        let str = `${seq}:${index}:`;
        str += `${tError(attr.left)} `;
        str += `${truth(attr.nested)} `;
        str += `${truth(attr.right)} `;
        str += `${tError(attr.cyclic)} `;
        str += `${fError(attr.finite)} `;
        str += `${truth(attr.empty)}:`;
        str += `${state.typeToString(dep.recursiveType)}:`;
        str += dep.recursiveType === id.ATTR_MR ? dep.groupNumber : "-";
        str += `:${attr.rule.name}\n`;
        return str;
    };
    const showLegend = ()=>{
        let str = "LEGEND - t=true, f=false, e=error\n";
        str += "sequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n";
        return str;
    };
    const showAttributeErrors = ()=>{
        let attri = null;
        let depi = null;
        let str = "";
        str += "RULE ATTRIBUTES WITH ERRORS\n";
        str += showLegend();
        if (state.attrsErrorCount) for(let i = 0; i < state.attrsErrorCount; i += 1){
            attri = state.attrsErrors[i];
            depi = state.ruleDeps[attri.rule.index];
            str += showAttr(i, attri.rule.index, attri, depi);
        }
        else str += "<none>\n";
        return str;
    };
    const show = (type)=>{
        let i = 0;
        let ii = 0;
        let attri = null;
        let depi = null;
        let str = "";
        let { ruleIndexes: ruleIndexes } = state;
        // let udtIndexes = state.udtIndexes;
        if (type === 97) ruleIndexes = state.ruleAlphaIndexes;
        else if (type === 116) ruleIndexes = state.ruleTypeIndexes;
        /* show all attributes */ for(i = 0; i < state.ruleCount; i += 1){
            ii = ruleIndexes[i];
            attri = state.attrs[ii];
            depi = state.ruleDeps[ii];
            str += showAttr(i, ii, attri, depi);
        }
        return str;
    };
    // Display the rule attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    const showAttributes = (order = "index")=>{
        if (!state.attributesComplete) throw new Error(`${thisFile}:showAttributes: attributes not available`);
        let str = "";
        const leader = "RULE ATTRIBUTES\n";
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += leader;
            str += showLegend();
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += leader;
            str += showLegend();
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += leader;
            str += showLegend();
            str += show();
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleAttributes: ruleAttributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors
    };
}();

});

parcelRegister("ctFDQ", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Determine rule dependencies and types.
// For each rule, determine which other rules it refers to
// and which of the other rules refer back to it.
//
// Rule types are:
//  - non-recursive - the rule never refers to itself, even indirectly
//  - recursive - the rule refers to itself, possibly indirectly
//  - mutually-recursive - belongs to a group of two or more rules, each of which refers to every other rule in the group, including itself.

module.exports = (()=>{
    const id = (parcelRequire("i0Pc2"));
    let state = null; /* keep a global reference to the state for the show functions */ 
    /* scan the opcodes of the indexed rule and discover which rules it references and which rule refer back to it */ const scan = (ruleCount, ruleDeps, index, isScanned)=>{
        let i = 0;
        let j = 0;
        const rdi = ruleDeps[index];
        isScanned[index] = true;
        const op = rdi.rule.opcodes;
        for(i = 0; i < op.length; i += 1){
            const opi = op[i];
            if (opi.type === id.RNM) {
                rdi.refersTo[opi.index] = true;
                if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                for(j = 0; j < ruleCount; j += 1)if (ruleDeps[opi.index].refersTo[j]) rdi.refersTo[j] = true;
            } else if (opi.type === id.UDT) rdi.refersToUdt[opi.index] = true;
            else if (opi.type === id.BKR) {
                if (opi.index < ruleCount) {
                    rdi.refersTo[opi.index] = true;
                    if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                } else rdi.refersToUdt[ruleCount - opi.index] = true;
            }
        }
    };
    // Determine the rule dependencies, types and mutually recursive groups.
    const ruleDependencies = (stateArg)=>{
        state = stateArg; /* make it global */ 
        let i = 0;
        let j = 0;
        let groupCount = 0;
        let rdi = null;
        let rdj = null;
        let newGroup = false;
        state.dependenciesComplete = false;
        /* make a working array of rule scanned markers */ const isScanned = state.falseArray(state.ruleCount);
        /* discover the rule dependencies */ for(i = 0; i < state.ruleCount; i += 1){
            state.falsifyArray(isScanned);
            scan(state.ruleCount, state.ruleDeps, i, isScanned);
        }
        /* discover all rules referencing each rule */ for(i = 0; i < state.ruleCount; i += 1)for(j = 0; j < state.ruleCount; j += 1){
            if (i !== j) {
                if (state.ruleDeps[j].refersTo[i]) state.ruleDeps[i].referencedBy[j] = true;
            }
        }
        /* find the non-recursive and recursive types */ for(i = 0; i < state.ruleCount; i += 1){
            state.ruleDeps[i].recursiveType = id.ATTR_N;
            if (state.ruleDeps[i].refersTo[i]) state.ruleDeps[i].recursiveType = id.ATTR_R;
        }
        /* find the mutually-recursive groups, if any */ groupCount = -1;
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[i];
            if (rdi.recursiveType === id.ATTR_R) {
                newGroup = true;
                for(j = 0; j < state.ruleCount; j += 1)if (i !== j) {
                    rdj = state.ruleDeps[j];
                    if (rdj.recursiveType === id.ATTR_R) {
                        if (rdi.refersTo[j] && rdj.refersTo[i]) {
                            if (newGroup) {
                                groupCount += 1;
                                rdi.recursiveType = id.ATTR_MR;
                                rdi.groupNumber = groupCount;
                                newGroup = false;
                            }
                            rdj.recursiveType = id.ATTR_MR;
                            rdj.groupNumber = groupCount;
                        }
                    }
                }
            }
        }
        state.isMutuallyRecursive = groupCount > -1;
        /* sort the rules/UDTS */ state.ruleAlphaIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesType);
        if (state.isMutuallyRecursive) state.ruleTypeIndexes.sort(state.compRulesGroup);
        if (state.udtCount) state.udtAlphaIndexes.sort(state.compUdtsAlpha);
        state.dependenciesComplete = true;
    };
    const show = (type = null)=>{
        let i = 0;
        let j = 0;
        let count = 0;
        let startSeg = 0;
        const maxRule = state.ruleCount - 1;
        const maxUdt = state.udtCount - 1;
        const lineLength = 100;
        let str = "";
        let pre = "";
        const toArrow = "=> ";
        const byArrow = "<= ";
        let first = false;
        let rdi = null;
        let { ruleIndexes: ruleIndexes } = state;
        let { udtIndexes: udtIndexes } = state;
        if (type === 97) {
            ruleIndexes = state.ruleAlphaIndexes;
            udtIndexes = state.udtAlphaIndexes;
        } else if (type === 116) {
            ruleIndexes = state.ruleTypeIndexes;
            udtIndexes = state.udtAlphaIndexes;
        }
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[ruleIndexes[i]];
            pre = `${ruleIndexes[i]}:${state.typeToString(rdi.recursiveType)}:`;
            if (state.isMutuallyRecursive) {
                pre += rdi.groupNumber > -1 ? rdi.groupNumber : "-";
                pre += ":";
            }
            pre += " ";
            str += `${pre + state.rules[ruleIndexes[i]].name}\n`;
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.refersTo[ruleIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (state.udtCount) for(j = 0; j < state.udtCount; j += 1){
                if (rdi.refersToUdt[udtIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.udts[udtIndexes[j]].name;
                    } else str += `, ${state.udts[udtIndexes[j]].name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxUdt) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "=> <none>\n";
            if (first === false) str += "\n";
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.referencedBy[ruleIndexes[j]]) {
                    if (first) {
                        str += byArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "<= <none>\n";
            if (first === false) str += "\n";
            str += "\n";
        }
        return str;
    };
    // Display the rule dependencies.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    const showRuleDependencies = (order = "index")=>{
        let str = "RULE DEPENDENCIES(index:type:[group number:])\n";
        str += "=> refers to rule names\n";
        str += "<= referenced by rule names\n";
        if (!state.dependenciesComplete) return str;
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += show(null);
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleDependencies: ruleDependencies,
        showRuleDependencies: showRuleDependencies
    };
})();

});


parcelRegister("dbqDA", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ module.exports = function exfn() {
    const thisFileName = "show-rules.js";
    // Display the rules.
    // This function may be called before the attributes calculation.
    // Sorting is done independently from the attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    const showRules = function showRules(rulesIn = [], udtsIn = [], order = "index") {
        const thisFuncName = "showRules";
        let alphaArray = [];
        let udtAlphaArray = [];
        const indexArray = [];
        const udtIndexArray = [];
        const rules = rulesIn;
        const udts = udtsIn;
        const ruleCount = rulesIn.length;
        const udtCount = udtsIn.length;
        let str = "RULE/UDT NAMES";
        let i;
        function compRulesAlpha(left, right) {
            if (rules[left].lower < rules[right].lower) return -1;
            if (rules[left].lower > rules[right].lower) return 1;
            return 0;
        }
        function compUdtsAlpha(left, right) {
            if (udts[left].lower < udts[right].lower) return -1;
            if (udts[left].lower > udts[right].lower) return 1;
            return 0;
        }
        if (!(Array.isArray(rulesIn) && rulesIn.length)) throw new Error(`${thisFileName}:${thisFuncName}: rules arg must be array with length > 0`);
        if (!Array.isArray(udtsIn)) throw new Error(`${thisFileName}:${thisFuncName}: udts arg must be array`);
        for(i = 0; i < ruleCount; i += 1)indexArray.push(i);
        alphaArray = indexArray.slice(0);
        alphaArray.sort(compRulesAlpha);
        if (udtCount) {
            for(i = 0; i < udtCount; i += 1)udtIndexArray.push(i);
            udtAlphaArray = udtIndexArray.slice(0);
            udtAlphaArray.sort(compUdtsAlpha);
        }
        if (order.charCodeAt(0) === 97) {
            str += " - alphabetical by rule/UDT name\n";
            for(i = 0; i < ruleCount; i += 1)str += `${i}: ${alphaArray[i]}: ${rules[alphaArray[i]].name}\n`;
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += `${i}: ${udtAlphaArray[i]}: ${udts[udtAlphaArray[i]].name}\n`;
        } else {
            str += " - ordered by rule/UDT index\n";
            for(i = 0; i < ruleCount; i += 1)str += `${i}: ${rules[i].name}\n`;
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += `${i}: ${udts[i].name}\n`;
        }
        return str;
    };
    return showRules;
}();

});


parcelRegister("2qPOp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseIntegerNumber = module.exports.isEIP55Address = void 0;

var $5sab6 = parcelRequire("5sab6");

var $L3Rdg = parcelRequire("L3Rdg");
/**
 * This method is supposed to check if an address is conforming to EIP-55.
 * @param address Address to be checked if conforms with EIP-55.
 * @returns Either the return is or not in the EIP-55 format.
 */ const $1c563346410bd186$var$isEIP55Address = (address)=>{
    if (address.length != 42) return false;
    const lowerAddress = `${address}`.toLowerCase().replace("0x", "");
    const hash = (0, $L3Rdg.bytesToHex)((0, $5sab6.keccak_256)(lowerAddress));
    let ret = "0x";
    for(let i = 0; i < lowerAddress.length; i++)if (parseInt(hash[i], 16) >= 8) ret += lowerAddress[i].toUpperCase();
    else ret += lowerAddress[i];
    return address === ret;
};
module.exports.isEIP55Address = $1c563346410bd186$var$isEIP55Address;
const $1c563346410bd186$var$parseIntegerNumber = (number)=>{
    const parsed = parseInt(number);
    if (isNaN(parsed)) throw new Error("Invalid number.");
    if (parsed === Infinity) throw new Error("Invalid number.");
    return parsed;
};
module.exports.parseIntegerNumber = $1c563346410bd186$var$parseIntegerNumber;

});
parcelRegister("5sab6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $6PxaQ = parcelRequire("6PxaQ");

var $6CiC8 = parcelRequire("6CiC8");

var $L3Rdg = parcelRequire("L3Rdg");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $3f87766e85559274$var$SHA3_PI = [];
const $3f87766e85559274$var$SHA3_ROTL = [];
const $3f87766e85559274$var$_SHA3_IOTA = [];
const $3f87766e85559274$var$_0n = /* @__PURE__ */ BigInt(0);
const $3f87766e85559274$var$_1n = /* @__PURE__ */ BigInt(1);
const $3f87766e85559274$var$_2n = /* @__PURE__ */ BigInt(2);
const $3f87766e85559274$var$_7n = /* @__PURE__ */ BigInt(7);
const $3f87766e85559274$var$_256n = /* @__PURE__ */ BigInt(256);
const $3f87766e85559274$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $3f87766e85559274$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $3f87766e85559274$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $3f87766e85559274$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $3f87766e85559274$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $3f87766e85559274$var$_1n ^ (R >> $3f87766e85559274$var$_7n) * $3f87766e85559274$var$_0x71n) % $3f87766e85559274$var$_256n;
        if (R & $3f87766e85559274$var$_2n) t ^= $3f87766e85559274$var$_1n << ($3f87766e85559274$var$_1n << /* @__PURE__ */ BigInt(j)) - $3f87766e85559274$var$_1n;
    }
    $3f87766e85559274$var$_SHA3_IOTA.push(t);
}
const [$3f87766e85559274$var$SHA3_IOTA_H, $3f87766e85559274$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $6CiC8.split)($3f87766e85559274$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $3f87766e85559274$var$rotlH = (h, l, s)=>s > 32 ? (0, $6CiC8.rotlBH)(h, l, s) : (0, $6CiC8.rotlSH)(h, l, s);
const $3f87766e85559274$var$rotlL = (h, l, s)=>s > 32 ? (0, $6CiC8.rotlBL)(h, l, s) : (0, $6CiC8.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $3f87766e85559274$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $3f87766e85559274$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $3f87766e85559274$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $3f87766e85559274$var$SHA3_ROTL[t];
            const Th = $3f87766e85559274$var$rotlH(curH, curL, shift);
            const Tl = $3f87766e85559274$var$rotlL(curH, curL, shift);
            const PI = $3f87766e85559274$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $3f87766e85559274$var$SHA3_IOTA_H[round];
        s[1] ^= $3f87766e85559274$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $3f87766e85559274$var$keccakP;
class $3f87766e85559274$var$Keccak extends $L3Rdg.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $6PxaQ.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $L3Rdg.u32)(this.state);
    }
    keccak() {
        if (!$L3Rdg.isLE) (0, $L3Rdg.byteSwap32)(this.state32);
        $3f87766e85559274$var$keccakP(this.state32, this.rounds);
        if (!$L3Rdg.isLE) (0, $L3Rdg.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $6PxaQ.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $L3Rdg.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $6PxaQ.exists)(this, false);
        (0, $6PxaQ.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $6PxaQ.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $6PxaQ.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $3f87766e85559274$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $3f87766e85559274$var$Keccak;
const $3f87766e85559274$var$gen = (suffix, blockLen, outputLen)=>(0, $L3Rdg.wrapConstructor)(()=>new $3f87766e85559274$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $3f87766e85559274$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $3f87766e85559274$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $3f87766e85559274$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $3f87766e85559274$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $3f87766e85559274$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $3f87766e85559274$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $3f87766e85559274$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $3f87766e85559274$var$gen(0x01, 72, 64);
const $3f87766e85559274$var$genShake = (suffix, blockLen, outputLen)=>(0, $L3Rdg.wrapXOFConstructorWithOpts)((opts = {})=>new $3f87766e85559274$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $3f87766e85559274$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $3f87766e85559274$var$genShake(0x1f, 136, 32);

});
parcelRegister("6PxaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = module.exports.isBytes = void 0;
function $4f913d2a0f51907c$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
module.exports.number = $4f913d2a0f51907c$var$number;
function $4f913d2a0f51907c$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
module.exports.bool = $4f913d2a0f51907c$var$bool;
// copied from utils
function $4f913d2a0f51907c$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $4f913d2a0f51907c$var$isBytes;
function $4f913d2a0f51907c$var$bytes(b, ...lengths) {
    if (!$4f913d2a0f51907c$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $4f913d2a0f51907c$var$bytes;
function $4f913d2a0f51907c$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $4f913d2a0f51907c$var$number(h.outputLen);
    $4f913d2a0f51907c$var$number(h.blockLen);
}
module.exports.hash = $4f913d2a0f51907c$var$hash;
function $4f913d2a0f51907c$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $4f913d2a0f51907c$var$exists;
function $4f913d2a0f51907c$var$output(out, instance) {
    $4f913d2a0f51907c$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $4f913d2a0f51907c$var$output;
const $4f913d2a0f51907c$var$assert = {
    number: $4f913d2a0f51907c$var$number,
    bool: $4f913d2a0f51907c$var$bool,
    bytes: $4f913d2a0f51907c$var$bytes,
    hash: $4f913d2a0f51907c$var$hash,
    exists: $4f913d2a0f51907c$var$exists,
    output: $4f913d2a0f51907c$var$output
};
module.exports.default = $4f913d2a0f51907c$var$assert;

});

parcelRegister("6CiC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $4d14bb11143692c5$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $4d14bb11143692c5$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $4d14bb11143692c5$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $4d14bb11143692c5$var$U32_MASK64),
        l: Number(n >> $4d14bb11143692c5$var$_32n & $4d14bb11143692c5$var$U32_MASK64)
    };
    return {
        h: Number(n >> $4d14bb11143692c5$var$_32n & $4d14bb11143692c5$var$U32_MASK64) | 0,
        l: Number(n & $4d14bb11143692c5$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $4d14bb11143692c5$var$fromBig;
function $4d14bb11143692c5$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $4d14bb11143692c5$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $4d14bb11143692c5$var$split;
const $4d14bb11143692c5$var$toBig = (h, l)=>BigInt(h >>> 0) << $4d14bb11143692c5$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $4d14bb11143692c5$var$toBig;
// for Shift in [0, 32)
const $4d14bb11143692c5$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $4d14bb11143692c5$var$shrSH;
const $4d14bb11143692c5$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $4d14bb11143692c5$var$shrSL;
// Right rotate for Shift in [1, 32)
const $4d14bb11143692c5$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $4d14bb11143692c5$var$rotrSH;
const $4d14bb11143692c5$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $4d14bb11143692c5$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $4d14bb11143692c5$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $4d14bb11143692c5$var$rotrBH;
const $4d14bb11143692c5$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $4d14bb11143692c5$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $4d14bb11143692c5$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $4d14bb11143692c5$var$rotr32H;
const $4d14bb11143692c5$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $4d14bb11143692c5$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $4d14bb11143692c5$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $4d14bb11143692c5$var$rotlSH;
const $4d14bb11143692c5$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $4d14bb11143692c5$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $4d14bb11143692c5$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $4d14bb11143692c5$var$rotlBH;
const $4d14bb11143692c5$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $4d14bb11143692c5$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $4d14bb11143692c5$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $4d14bb11143692c5$var$add;
// Addition with more than 2 elements
const $4d14bb11143692c5$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $4d14bb11143692c5$var$add3L;
const $4d14bb11143692c5$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $4d14bb11143692c5$var$add3H;
const $4d14bb11143692c5$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $4d14bb11143692c5$var$add4L;
const $4d14bb11143692c5$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $4d14bb11143692c5$var$add4H;
const $4d14bb11143692c5$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $4d14bb11143692c5$var$add5L;
const $4d14bb11143692c5$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $4d14bb11143692c5$var$add5H;
// prettier-ignore
const $4d14bb11143692c5$var$u64 = {
    fromBig: $4d14bb11143692c5$var$fromBig,
    split: $4d14bb11143692c5$var$split,
    toBig: $4d14bb11143692c5$var$toBig,
    shrSH: $4d14bb11143692c5$var$shrSH,
    shrSL: $4d14bb11143692c5$var$shrSL,
    rotrSH: $4d14bb11143692c5$var$rotrSH,
    rotrSL: $4d14bb11143692c5$var$rotrSL,
    rotrBH: $4d14bb11143692c5$var$rotrBH,
    rotrBL: $4d14bb11143692c5$var$rotrBL,
    rotr32H: $4d14bb11143692c5$var$rotr32H,
    rotr32L: $4d14bb11143692c5$var$rotr32L,
    rotlSH: $4d14bb11143692c5$var$rotlSH,
    rotlSL: $4d14bb11143692c5$var$rotlSL,
    rotlBH: $4d14bb11143692c5$var$rotlBH,
    rotlBL: $4d14bb11143692c5$var$rotlBL,
    add: $4d14bb11143692c5$var$add,
    add3L: $4d14bb11143692c5$var$add3L,
    add3H: $4d14bb11143692c5$var$add3H,
    add4L: $4d14bb11143692c5$var$add4L,
    add4H: $4d14bb11143692c5$var$add4H,
    add5H: $4d14bb11143692c5$var$add5H,
    add5L: $4d14bb11143692c5$var$add5L
};
module.exports.default = $4d14bb11143692c5$var$u64;

});

parcelRegister("L3Rdg", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.byteSwap32 = module.exports.byteSwapIfBE = module.exports.byteSwap = module.exports.isLE = module.exports.rotl = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = module.exports.isBytes = void 0;

var $1RmBS = parcelRequire("1RmBS");

var $6PxaQ = parcelRequire("6PxaQ");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $08d761dffac33464$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $08d761dffac33464$var$isBytes;
// Cast array to different type
const $08d761dffac33464$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $08d761dffac33464$var$u8;
const $08d761dffac33464$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $08d761dffac33464$var$u32;
// Cast array to view
const $08d761dffac33464$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $08d761dffac33464$var$createView;
// The rotate right (circular right shift) operation for uint32
const $08d761dffac33464$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $08d761dffac33464$var$rotr;
// The rotate left (circular left shift) operation for uint32
const $08d761dffac33464$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
module.exports.rotl = $08d761dffac33464$var$rotl;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const $08d761dffac33464$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
module.exports.byteSwap = $08d761dffac33464$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>(0, module.exports.byteSwap)(n);
// In place byte swap for Uint32Array
function $08d761dffac33464$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, module.exports.byteSwap)(arr[i]);
}
module.exports.byteSwap32 = $08d761dffac33464$var$byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $08d761dffac33464$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $08d761dffac33464$var$bytesToHex(bytes) {
    (0, $6PxaQ.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $08d761dffac33464$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $08d761dffac33464$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $08d761dffac33464$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $08d761dffac33464$var$asciiToBase16(char) {
    if (char >= $08d761dffac33464$var$asciis._0 && char <= $08d761dffac33464$var$asciis._9) return char - $08d761dffac33464$var$asciis._0;
    if (char >= $08d761dffac33464$var$asciis._A && char <= $08d761dffac33464$var$asciis._F) return char - ($08d761dffac33464$var$asciis._A - 10);
    if (char >= $08d761dffac33464$var$asciis._a && char <= $08d761dffac33464$var$asciis._f) return char - ($08d761dffac33464$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $08d761dffac33464$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $08d761dffac33464$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $08d761dffac33464$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $08d761dffac33464$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $08d761dffac33464$var$nextTick = async ()=>{};
module.exports.nextTick = $08d761dffac33464$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $08d761dffac33464$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $08d761dffac33464$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $08d761dffac33464$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $08d761dffac33464$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $08d761dffac33464$var$toBytes(data) {
    if (typeof data === "string") data = $08d761dffac33464$var$utf8ToBytes(data);
    (0, $6PxaQ.bytes)(data);
    return data;
}
module.exports.toBytes = $08d761dffac33464$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $08d761dffac33464$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $6PxaQ.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $08d761dffac33464$var$concatBytes;
// For runtime check if class implements interface
class $08d761dffac33464$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $08d761dffac33464$var$Hash;
const $08d761dffac33464$var$toStr = {}.toString;
function $08d761dffac33464$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $08d761dffac33464$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $08d761dffac33464$var$checkOpts;
function $08d761dffac33464$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($08d761dffac33464$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $08d761dffac33464$var$wrapConstructor;
function $08d761dffac33464$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($08d761dffac33464$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $08d761dffac33464$var$wrapConstructorWithOpts;
function $08d761dffac33464$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($08d761dffac33464$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $08d761dffac33464$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $08d761dffac33464$var$randomBytes(bytesLength = 32) {
    if ($1RmBS.crypto && typeof $1RmBS.crypto.getRandomValues === "function") return $1RmBS.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $08d761dffac33464$var$randomBytes;

});
parcelRegister("1RmBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("hGNJn", function(module, exports) {
(function(module1) {
    "use strict";
    module1.exports.is_uri = is_iri;
    module1.exports.is_http_uri = is_http_iri;
    module1.exports.is_https_uri = is_https_iri;
    module1.exports.is_web_uri = is_web_iri;
    // Create aliases
    module1.exports.isUri = is_iri;
    module1.exports.isHttpUri = is_http_iri;
    module1.exports.isHttpsUri = is_https_iri;
    module1.exports.isWebUri = is_web_iri;
    // private function
    // internal URI spitter method - direct from RFC 3986
    var splitUri = function(uri) {
        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return splitted;
    };
    function is_iri(value) {
        if (!value) return;
        // check for illegal characters
        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;
        // check for hex escapes that aren't complete
        if (/%[^0-9a-f]/i.test(value)) return;
        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
        var splitted = [];
        var scheme = "";
        var authority = "";
        var path = "";
        var query = "";
        var fragment = "";
        var out = "";
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        // scheme and path are required, though the path can be empty
        if (!(scheme && scheme.length && path.length >= 0)) return;
        // if authority is present, the path must be empty or begin with a /
        if (authority && authority.length) {
            if (!(path.length === 0 || /^\//.test(path))) return;
        } else {
            // if authority is not present, the path must not start with //
            if (/^\/\//.test(path)) return;
        }
        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return;
        // re-assemble the URL per section 5.3 in RFC 3986
        out += scheme + ":";
        if (authority && authority.length) out += "//" + authority;
        out += path;
        if (query && query.length) out += "?" + query;
        if (fragment && fragment.length) out += "#" + fragment;
        return out;
    }
    function is_http_iri(value, allowHttps) {
        if (!is_iri(value)) return;
        var splitted = [];
        var scheme = "";
        var authority = "";
        var path = "";
        var port = "";
        var query = "";
        var fragment = "";
        var out = "";
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        if (!scheme) return;
        if (allowHttps) {
            if (scheme.toLowerCase() != "https") return;
        } else {
            if (scheme.toLowerCase() != "http") return;
        }
        // fully-qualified URIs must have an authority section that is
        // a valid host
        if (!authority) return;
        // enable port component
        if (/:(\d+)$/.test(authority)) {
            port = authority.match(/:(\d+)$/)[0];
            authority = authority.replace(/:\d+$/, "");
        }
        out += scheme + ":";
        out += "//" + authority;
        if (port) out += port;
        out += path;
        if (query && query.length) out += "?" + query;
        if (fragment && fragment.length) out += "#" + fragment;
        return out;
    }
    function is_https_iri(value) {
        return is_http_iri(value, true);
    }
    function is_web_iri(value) {
        return is_http_iri(value) || is_https_iri(value);
    }
})(module);

});

parcelRegister("3fhu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAddress = module.exports.hashMessage = module.exports.verifyMessage = void 0;
parcelRequire("98vyO");
var $1tsUk = parcelRequire("1tsUk");
let $25d055ef79141070$var$ethersVerifyMessage = null;
let $25d055ef79141070$var$ethersHashMessage = null;
let $25d055ef79141070$var$ethersGetAddress = null;
try {
    // @ts-expect-error -- v6 compatibility hack
    $25d055ef79141070$var$ethersVerifyMessage = $1tsUk.utils.verifyMessage;
    // @ts-expect-error -- v6 compatibility hack
    $25d055ef79141070$var$ethersHashMessage = $1tsUk.utils.hashMessage;
    // @ts-expect-error -- v6 compatibility hack
    $25d055ef79141070$var$ethersGetAddress = $1tsUk.utils.getAddress;
} catch (_a) {
    $25d055ef79141070$var$ethersVerifyMessage = $1tsUk.verifyMessage;
    $25d055ef79141070$var$ethersHashMessage = $1tsUk.hashMessage;
    $25d055ef79141070$var$ethersGetAddress = $1tsUk.getAddress;
}
module.exports.verifyMessage = $25d055ef79141070$var$ethersVerifyMessage;
module.exports.hashMessage = $25d055ef79141070$var$ethersHashMessage;
module.exports.getAddress = $25d055ef79141070$var$ethersGetAddress;

});
parcelRegister("98vyO", function(module, exports) {

$parcel$export(module.exports, "ethers", () => (parcelRequire("1tsUk")));

var $1tsUk = parcelRequire("1tsUk");
var $40NDm = parcelRequire("40NDm");
var $7J4Ot = parcelRequire("7J4Ot");
var $8VNI3 = parcelRequire("8VNI3");
var $4lHHr = parcelRequire("4lHHr");
var $e0Utj = parcelRequire("e0Utj");
var $bC4om = parcelRequire("bC4om");
var $ltcCO = parcelRequire("ltcCO");
var $hAWyw = parcelRequire("hAWyw");
var $nAWpO = parcelRequire("nAWpO");
var $fJZJg = parcelRequire("fJZJg");
var $jhkQ1 = parcelRequire("jhkQ1");
var $2IdZM = parcelRequire("2IdZM");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $1tsUk;
} catch (error) {}

});
parcelRegister("1tsUk", function(module, exports) {

$parcel$export(module.exports, "logger", () => $112eec4f0ff96f8f$export$af88d00dbe7f521);
$parcel$export(module.exports, "Signer", () => (parcelRequire("40NDm")).Signer);
$parcel$export(module.exports, "Wallet", () => (parcelRequire("7J4Ot")).Wallet);
$parcel$export(module.exports, "VoidSigner", () => (parcelRequire("40NDm")).VoidSigner);
$parcel$export(module.exports, "getDefaultProvider", () => (parcelRequire("8VNI3")).getDefaultProvider);
$parcel$export(module.exports, "providers", () => (parcelRequire("8VNI3")));
$parcel$export(module.exports, "BaseContract", () => (parcelRequire("4lHHr")).BaseContract);
$parcel$export(module.exports, "Contract", () => (parcelRequire("4lHHr")).Contract);
$parcel$export(module.exports, "ContractFactory", () => (parcelRequire("4lHHr")).ContractFactory);
$parcel$export(module.exports, "BigNumber", () => (parcelRequire("e0Utj")).BigNumber);
$parcel$export(module.exports, "FixedNumber", () => (parcelRequire("bC4om")).FixedNumber);
$parcel$export(module.exports, "constants", () => (parcelRequire("ltcCO")));
$parcel$export(module.exports, "errors", () => (parcelRequire("hAWyw")).ErrorCode);
$parcel$export(module.exports, "utils", () => (parcelRequire("nAWpO")));
$parcel$export(module.exports, "wordlists", () => (parcelRequire("fJZJg")).wordlists);
$parcel$export(module.exports, "version", () => (parcelRequire("jhkQ1")).version);
$parcel$export(module.exports, "Wordlist", () => (parcelRequire("2IdZM")).Wordlist);

var $4lHHr = parcelRequire("4lHHr");

var $e0Utj = parcelRequire("e0Utj");
var $bC4om = parcelRequire("bC4om");

var $40NDm = parcelRequire("40NDm");

var $7J4Ot = parcelRequire("7J4Ot");

var $ltcCO = parcelRequire("ltcCO");

var $8VNI3 = parcelRequire("8VNI3");

var $2IdZM = parcelRequire("2IdZM");
var $fJZJg = parcelRequire("fJZJg");

var $nAWpO = parcelRequire("nAWpO");

var $hAWyw = parcelRequire("hAWyw");

var $jhkQ1 = parcelRequire("jhkQ1");
"use strict";
const $112eec4f0ff96f8f$export$af88d00dbe7f521 = new (0, $hAWyw.Logger)((0, $jhkQ1.version));

});
parcelRegister("4lHHr", function(module, exports) {

$parcel$export(module.exports, "BaseContract", () => $32ab056a4c8fadc1$export$304faa4fc17528db);
$parcel$export(module.exports, "Contract", () => $32ab056a4c8fadc1$export$8517d80acf00e19a);
$parcel$export(module.exports, "ContractFactory", () => $32ab056a4c8fadc1$export$505569a6bf584fd9);

var $H2p5T = parcelRequire("H2p5T");
var $6N7mB = parcelRequire("6N7mB");

var $cfLMn = parcelRequire("cfLMn");

var $40NDm = parcelRequire("40NDm");

var $8T6OQ = parcelRequire("8T6OQ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $fb2Z3 = parcelRequire("fb2Z3");

var $hAWyw = parcelRequire("hAWyw");

var $2P0wH = parcelRequire("2P0wH");
"use strict";
var $32ab056a4c8fadc1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $32ab056a4c8fadc1$var$logger = new (0, $hAWyw.Logger)((0, $2P0wH.version));
///////////////////////////////
const $32ab056a4c8fadc1$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $32ab056a4c8fadc1$var$resolveName(resolver, nameOrPromise) {
    return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $32ab056a4c8fadc1$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $8T6OQ.getAddress)(name);
        } catch (error) {}
        if (!resolver) $32ab056a4c8fadc1$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $32ab056a4c8fadc1$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $32ab056a4c8fadc1$var$resolveAddresses(resolver, value, paramType) {
    return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $32ab056a4c8fadc1$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $32ab056a4c8fadc1$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $32ab056a4c8fadc1$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($32ab056a4c8fadc1$var$logger.makeError("invalid value for array", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$32ab056a4c8fadc1$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $32ab056a4c8fadc1$var$populateTransaction(contract, fragment, args) {
    return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $cQEXW.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $32ab056a4c8fadc1$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $cQEXW.resolveProperties)({
                override: $32ab056a4c8fadc1$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $8T6OQ.getAddress)(check.signer) !== check.override) $32ab056a4c8fadc1$var$logger.throwError("Contract with a Signer cannot override from", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $32ab056a4c8fadc1$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $cQEXW.resolveProperties)({
            args: $32ab056a4c8fadc1$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $cQEXW.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $e0Utj.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $e0Utj.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $e0Utj.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $e0Utj.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $e0Utj.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $fb2Z3.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $is1Vq.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $e0Utj.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $e0Utj.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $32ab056a4c8fadc1$var$logger.throwError("non-payable method cannot override value", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $cQEXW.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $32ab056a4c8fadc1$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $32ab056a4c8fadc1$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $32ab056a4c8fadc1$var$populateTransaction(contract, fragment, args);
    };
}
function $32ab056a4c8fadc1$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $32ab056a4c8fadc1$var$logger.throwError("estimate require a provider or signer", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $32ab056a4c8fadc1$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $32ab056a4c8fadc1$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $cQEXW.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $32ab056a4c8fadc1$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $cQEXW.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $32ab056a4c8fadc1$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $hAWyw.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $32ab056a4c8fadc1$var$buildSend(contract, fragment) {
    return function(...args) {
        return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $32ab056a4c8fadc1$var$logger.throwError("sending a transaction requires a signer", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $32ab056a4c8fadc1$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $32ab056a4c8fadc1$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $32ab056a4c8fadc1$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $32ab056a4c8fadc1$var$buildCall(contract, fragment, collapseSimple);
    return $32ab056a4c8fadc1$var$buildSend(contract, fragment);
}
function $32ab056a4c8fadc1$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $32ab056a4c8fadc1$var$RunningEvent {
    constructor(tag, filter){
        (0, $cQEXW.defineReadOnly)(this, "tag", tag);
        (0, $cQEXW.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $32ab056a4c8fadc1$var$ErrorRunningEvent extends $32ab056a4c8fadc1$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $32ab056a4c8fadc1$var$FragmentRunningEvent extends $32ab056a4c8fadc1$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $32ab056a4c8fadc1$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($32ab056a4c8fadc1$var$getEventTag(filter), filter);
        (0, $cQEXW.defineReadOnly)(this, "address", address);
        (0, $cQEXW.defineReadOnly)(this, "interface", contractInterface);
        (0, $cQEXW.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $H2p5T.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $32ab056a4c8fadc1$var$WildcardRunningEvent extends $32ab056a4c8fadc1$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $cQEXW.defineReadOnly)(this, "address", address);
        (0, $cQEXW.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $32ab056a4c8fadc1$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $cQEXW.defineReadOnly)(this, "interface", (0, $cQEXW.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $cQEXW.defineReadOnly)(this, "provider", null);
            (0, $cQEXW.defineReadOnly)(this, "signer", null);
        } else if ((0, $40NDm.Signer).isSigner(signerOrProvider)) {
            (0, $cQEXW.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $cQEXW.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $cfLMn.Provider).isProvider(signerOrProvider)) {
            (0, $cQEXW.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $cQEXW.defineReadOnly)(this, "signer", null);
        } else $32ab056a4c8fadc1$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $cQEXW.defineReadOnly)(this, "callStatic", {});
        (0, $cQEXW.defineReadOnly)(this, "estimateGas", {});
        (0, $cQEXW.defineReadOnly)(this, "functions", {});
        (0, $cQEXW.defineReadOnly)(this, "populateTransaction", {});
        (0, $cQEXW.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $cQEXW.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $cQEXW.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $32ab056a4c8fadc1$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $cQEXW.defineReadOnly)(this, "_runningEvents", {});
        (0, $cQEXW.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $32ab056a4c8fadc1$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $cQEXW.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $cQEXW.defineReadOnly)(this, "resolvedAddress", $32ab056a4c8fadc1$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $cQEXW.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $8T6OQ.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $32ab056a4c8fadc1$var$logger.throwError("provider is required to use ENS name as contract address", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $32ab056a4c8fadc1$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $cQEXW.defineReadOnly)(this, signature, $32ab056a4c8fadc1$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $cQEXW.defineReadOnly)(this.functions, signature, $32ab056a4c8fadc1$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $cQEXW.defineReadOnly)(this.callStatic, signature, $32ab056a4c8fadc1$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $cQEXW.defineReadOnly)(this.populateTransaction, signature, $32ab056a4c8fadc1$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $cQEXW.defineReadOnly)(this.estimateGas, signature, $32ab056a4c8fadc1$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $cQEXW.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $cQEXW.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $cQEXW.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $cQEXW.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $cQEXW.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $8T6OQ.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $6N7mB.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $6N7mB.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $32ab056a4c8fadc1$var$logger.throwError("contract not deployed", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $32ab056a4c8fadc1$var$logger.throwError("sending a transactions require a signer", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $cQEXW.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $32ab056a4c8fadc1$var$logger.throwError("cannot override " + key, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $40NDm.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $cQEXW.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $6N7mB.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$RunningEvent($32ab056a4c8fadc1$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $32ab056a4c8fadc1$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $cQEXW.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $32ab056a4c8fadc1$var$logger.throwError("events require a provider or a signer with a provider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $cQEXW.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $is1Vq.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $32ab056a4c8fadc1$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $32ab056a4c8fadc1$export$8517d80acf00e19a extends $32ab056a4c8fadc1$export$304faa4fc17528db {
}
class $32ab056a4c8fadc1$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $is1Vq.isBytes)(bytecode)) bytecodeHex = (0, $is1Vq.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $is1Vq.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $32ab056a4c8fadc1$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $40NDm.Signer).isSigner(signer)) $32ab056a4c8fadc1$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $cQEXW.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $cQEXW.defineReadOnly)(this, "interface", (0, $cQEXW.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $cQEXW.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $cQEXW.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$32ab056a4c8fadc1$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $32ab056a4c8fadc1$var$logger.throwError("cannot override " + key, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $e0Utj.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $32ab056a4c8fadc1$var$logger.throwError("non-payable constructor cannot override value", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $32ab056a4c8fadc1$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $is1Vq.hexlify)((0, $is1Vq.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $32ab056a4c8fadc1$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $32ab056a4c8fadc1$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $32ab056a4c8fadc1$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $cQEXW.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $cQEXW.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $32ab056a4c8fadc1$var$addContractWait(contract, tx);
            (0, $cQEXW.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $32ab056a4c8fadc1$var$logger.throwError("missing compiler output", (0, $hAWyw.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $32ab056a4c8fadc1$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $8T6OQ.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $32ab056a4c8fadc1$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}

});
parcelRegister("H2p5T", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", () => $0815e199972126fe$export$5546b9ec21157cc2);
$parcel$export(module.exports, "Coder", () => $0815e199972126fe$export$2c0c39526f8bad46);
$parcel$export(module.exports, "Writer", () => $0815e199972126fe$export$d7a960146e1a269e);
$parcel$export(module.exports, "Reader", () => $0815e199972126fe$export$2f7a2f0e90c07dc4);

var $is1Vq = parcelRequire("is1Vq");

var $e0Utj = parcelRequire("e0Utj");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $lONVT = parcelRequire("lONVT");
"use strict";
const $0815e199972126fe$var$logger = new (0, $hAWyw.Logger)((0, $lONVT.version));
function $0815e199972126fe$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $0815e199972126fe$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $0815e199972126fe$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $0815e199972126fe$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $cQEXW.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $is1Vq.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $is1Vq.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $is1Vq.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $is1Vq.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $is1Vq.arrayify)((0, $e0Utj.BigNumber).from(value));
        if (bytes.length > this.wordSize) $0815e199972126fe$var$logger.throwError("value out-of-bounds", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $is1Vq.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $0815e199972126fe$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $cQEXW.defineReadOnly)(this, "_data", (0, $is1Vq.arrayify)(data));
        (0, $cQEXW.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $cQEXW.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $cQEXW.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $is1Vq.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $0815e199972126fe$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $0815e199972126fe$var$logger.throwError("data out-of-bounds", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $0815e199972126fe$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $e0Utj.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});
parcelRegister("is1Vq", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $d6ec55d6f17bcaca$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $d6ec55d6f17bcaca$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $d6ec55d6f17bcaca$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $d6ec55d6f17bcaca$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $d6ec55d6f17bcaca$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $d6ec55d6f17bcaca$export$a8f4574d0e56446c);
$parcel$export(module.exports, "zeroPad", () => $d6ec55d6f17bcaca$export$3cdc770bf8b2ed3d);
$parcel$export(module.exports, "hexlify", () => $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $d6ec55d6f17bcaca$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $d6ec55d6f17bcaca$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $d6ec55d6f17bcaca$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexValue", () => $d6ec55d6f17bcaca$export$6916af760a341dd3);
$parcel$export(module.exports, "hexStripZeros", () => $d6ec55d6f17bcaca$export$967bc0082a978949);
$parcel$export(module.exports, "hexZeroPad", () => $d6ec55d6f17bcaca$export$e9c46a54370b47e8);
$parcel$export(module.exports, "splitSignature", () => $d6ec55d6f17bcaca$export$7fb170f1e457988f);
$parcel$export(module.exports, "joinSignature", () => $d6ec55d6f17bcaca$export$71bb9d78a59bbe25);

var $hAWyw = parcelRequire("hAWyw");

var $1kRpz = parcelRequire("1kRpz");
"use strict";
const $d6ec55d6f17bcaca$var$logger = new (0, $hAWyw.Logger)((0, $1kRpz.version));
///////////////////////////////
function $d6ec55d6f17bcaca$var$isHexable(value) {
    return !!value.toHexString;
}
function $d6ec55d6f17bcaca$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $d6ec55d6f17bcaca$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $d6ec55d6f17bcaca$export$9a14abb1a440cd5e(value) {
    return $d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $d6ec55d6f17bcaca$export$c6fabfbfd097fc30(value);
}
function $d6ec55d6f17bcaca$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $d6ec55d6f17bcaca$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$d6ec55d6f17bcaca$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$d6ec55d6f17bcaca$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $d6ec55d6f17bcaca$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $d6ec55d6f17bcaca$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $d6ec55d6f17bcaca$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($d6ec55d6f17bcaca$var$isHexable(value)) value = value.toHexString();
    if ($d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $d6ec55d6f17bcaca$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $d6ec55d6f17bcaca$var$addSlice(new Uint8Array(result));
    }
    if ($d6ec55d6f17bcaca$export$c6fabfbfd097fc30(value)) return $d6ec55d6f17bcaca$var$addSlice(new Uint8Array(value));
    return $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $d6ec55d6f17bcaca$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$d6ec55d6f17bcaca$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $d6ec55d6f17bcaca$var$addSlice(result);
}
function $d6ec55d6f17bcaca$export$a8f4574d0e56446c(value) {
    let result = $d6ec55d6f17bcaca$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $d6ec55d6f17bcaca$export$3cdc770bf8b2ed3d(value, length) {
    value = $d6ec55d6f17bcaca$export$3131421a7d01b4fb(value);
    if (value.length > length) $d6ec55d6f17bcaca$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $d6ec55d6f17bcaca$var$addSlice(result);
}
function $d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $d6ec55d6f17bcaca$var$HexCharacters = "0123456789abcdef";
function $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $d6ec55d6f17bcaca$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $d6ec55d6f17bcaca$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($d6ec55d6f17bcaca$var$isHexable(value)) return value.toHexString();
    if ($d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $d6ec55d6f17bcaca$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($d6ec55d6f17bcaca$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $d6ec55d6f17bcaca$var$HexCharacters[(v & 0xf0) >> 4] + $d6ec55d6f17bcaca$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $d6ec55d6f17bcaca$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(data);
    else if (!$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $d6ec55d6f17bcaca$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(data);
    else if (!$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(data) || data.length % 2) $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $d6ec55d6f17bcaca$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $d6ec55d6f17bcaca$export$6916af760a341dd3(value) {
    const trimmed = $d6ec55d6f17bcaca$export$967bc0082a978949($d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $d6ec55d6f17bcaca$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(value);
    if (!$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value)) $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $d6ec55d6f17bcaca$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(value);
    else if (!$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(value)) $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $d6ec55d6f17bcaca$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $d6ec55d6f17bcaca$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($d6ec55d6f17bcaca$export$9a14abb1a440cd5e(signature)) {
        let bytes = $d6ec55d6f17bcaca$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $d6ec55d6f17bcaca$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $d6ec55d6f17bcaca$export$3cdc770bf8b2ed3d($d6ec55d6f17bcaca$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(result.r)) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $d6ec55d6f17bcaca$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(result.s)) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $d6ec55d6f17bcaca$export$e9c46a54370b47e8(result.s, 32);
        const vs = $d6ec55d6f17bcaca$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$d6ec55d6f17bcaca$export$b02a40aff8e4ad18(result._vs)) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $d6ec55d6f17bcaca$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $d6ec55d6f17bcaca$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $d6ec55d6f17bcaca$export$71bb9d78a59bbe25(signature) {
    signature = $d6ec55d6f17bcaca$export$7fb170f1e457988f(signature);
    return $d6ec55d6f17bcaca$export$2b0d6b5fbe698c70($d6ec55d6f17bcaca$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("hAWyw", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $ccf3387318d53984$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "Logger", () => $ccf3387318d53984$export$efa9a398d6368992);

var $ji9zR = parcelRequire("ji9zR");
"use strict";
let $ccf3387318d53984$var$_permanentCensorErrors = false;
let $ccf3387318d53984$var$_censorErrors = false;
const $ccf3387318d53984$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $ccf3387318d53984$var$_logLevel = $ccf3387318d53984$var$LogLevels["default"];
let $ccf3387318d53984$var$_globalLogger = null;
function $ccf3387318d53984$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $ccf3387318d53984$var$_normalizeError = $ccf3387318d53984$var$_checkNormalize();
var $ccf3387318d53984$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($ccf3387318d53984$export$243e62d78d3b544d || ($ccf3387318d53984$export$243e62d78d3b544d = {}));
var $ccf3387318d53984$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($ccf3387318d53984$export$d4e71bc0b80dc0fb || ($ccf3387318d53984$export$d4e71bc0b80dc0fb = {}));
const $ccf3387318d53984$var$HEX = "0123456789abcdef";
class $ccf3387318d53984$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($ccf3387318d53984$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($ccf3387318d53984$var$_logLevel > $ccf3387318d53984$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($ccf3387318d53984$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($ccf3387318d53984$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($ccf3387318d53984$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($ccf3387318d53984$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $ccf3387318d53984$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $ccf3387318d53984$var$HEX[value[i] >> 4];
                        hex += $ccf3387318d53984$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $ccf3387318d53984$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $ccf3387318d53984$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($ccf3387318d53984$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $ccf3387318d53984$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $ccf3387318d53984$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $ccf3387318d53984$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $ccf3387318d53984$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $ccf3387318d53984$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $ccf3387318d53984$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $ccf3387318d53984$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $ccf3387318d53984$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $ccf3387318d53984$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$ccf3387318d53984$var$_globalLogger) $ccf3387318d53984$var$_globalLogger = new $ccf3387318d53984$export$efa9a398d6368992((0, $ji9zR.version));
        return $ccf3387318d53984$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $ccf3387318d53984$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($ccf3387318d53984$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $ccf3387318d53984$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $ccf3387318d53984$var$_censorErrors = !!censorship;
        $ccf3387318d53984$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $ccf3387318d53984$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $ccf3387318d53984$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $ccf3387318d53984$var$_logLevel = level;
    }
    static from(version) {
        return new $ccf3387318d53984$export$efa9a398d6368992(version);
    }
}
$ccf3387318d53984$export$efa9a398d6368992.errors = $ccf3387318d53984$export$d4e71bc0b80dc0fb;
$ccf3387318d53984$export$efa9a398d6368992.levels = $ccf3387318d53984$export$243e62d78d3b544d;

});
parcelRegister("ji9zR", function(module, exports) {

$parcel$export(module.exports, "version", () => $e0b7209da46037e2$export$83d89fbfd8236492);
const $e0b7209da46037e2$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("1kRpz", function(module, exports) {

$parcel$export(module.exports, "version", () => $0f911715bcb92d12$export$83d89fbfd8236492);
const $0f911715bcb92d12$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("e0Utj", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", () => $a33cdee31296f7db$export$a3d0a7fa9b65683b);
$parcel$export(module.exports, "BigNumber", () => $a33cdee31296f7db$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $a33cdee31296f7db$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $a33cdee31296f7db$export$1293db5d29c264ff);

var $1NQM5 = parcelRequire("1NQM5");

var $is1Vq = parcelRequire("is1Vq");

var $hAWyw = parcelRequire("hAWyw");

var $dMMsS = parcelRequire("dMMsS");
"use strict";
var $a33cdee31296f7db$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($1NQM5))).BN;
const $a33cdee31296f7db$var$logger = new (0, $hAWyw.Logger)((0, $dMMsS.version));
const $a33cdee31296f7db$var$_constructorGuard = {};
const $a33cdee31296f7db$var$MAX_SAFE = 0x1fffffffffffff;
function $a33cdee31296f7db$export$a3d0a7fa9b65683b(value) {
    return value != null && ($a33cdee31296f7db$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $is1Vq.isHexString)(value) || typeof value === "bigint" || (0, $is1Vq.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $a33cdee31296f7db$var$_warnedToStringRadix = false;
class $a33cdee31296f7db$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $a33cdee31296f7db$var$_constructorGuard) $a33cdee31296f7db$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $a33cdee31296f7db$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).add($a33cdee31296f7db$var$toBN(other)));
    }
    sub(other) {
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).sub($a33cdee31296f7db$var$toBN(other)));
    }
    div(other) {
        const o = $a33cdee31296f7db$export$d97aa349ed20696.from(other);
        if (o.isZero()) $a33cdee31296f7db$var$throwFault("division-by-zero", "div");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).div($a33cdee31296f7db$var$toBN(other)));
    }
    mul(other) {
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).mul($a33cdee31296f7db$var$toBN(other)));
    }
    mod(other) {
        const value = $a33cdee31296f7db$var$toBN(other);
        if (value.isNeg()) $a33cdee31296f7db$var$throwFault("division-by-zero", "mod");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $a33cdee31296f7db$var$toBN(other);
        if (value.isNeg()) $a33cdee31296f7db$var$throwFault("negative-power", "pow");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $a33cdee31296f7db$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a33cdee31296f7db$var$throwFault("unbound-bitwise-result", "and");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).and(value));
    }
    or(other) {
        const value = $a33cdee31296f7db$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a33cdee31296f7db$var$throwFault("unbound-bitwise-result", "or");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $a33cdee31296f7db$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a33cdee31296f7db$var$throwFault("unbound-bitwise-result", "xor");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $a33cdee31296f7db$var$throwFault("negative-width", "mask");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $a33cdee31296f7db$var$throwFault("negative-width", "shl");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $a33cdee31296f7db$var$throwFault("negative-width", "shr");
        return $a33cdee31296f7db$var$toBigNumber($a33cdee31296f7db$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $a33cdee31296f7db$var$toBN(this).eq($a33cdee31296f7db$var$toBN(other));
    }
    lt(other) {
        return $a33cdee31296f7db$var$toBN(this).lt($a33cdee31296f7db$var$toBN(other));
    }
    lte(other) {
        return $a33cdee31296f7db$var$toBN(this).lte($a33cdee31296f7db$var$toBN(other));
    }
    gt(other) {
        return $a33cdee31296f7db$var$toBN(this).gt($a33cdee31296f7db$var$toBN(other));
    }
    gte(other) {
        return $a33cdee31296f7db$var$toBN(this).gte($a33cdee31296f7db$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $a33cdee31296f7db$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $a33cdee31296f7db$var$toBN(this).toNumber();
        } catch (error) {
            $a33cdee31296f7db$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $a33cdee31296f7db$var$logger.throwError("this platform does not support BigInt", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$a33cdee31296f7db$var$_warnedToStringRadix) {
                    $a33cdee31296f7db$var$_warnedToStringRadix = true;
                    $a33cdee31296f7db$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $a33cdee31296f7db$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $hAWyw.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $a33cdee31296f7db$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $hAWyw.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $a33cdee31296f7db$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $a33cdee31296f7db$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $a33cdee31296f7db$export$d97aa349ed20696($a33cdee31296f7db$var$_constructorGuard, $a33cdee31296f7db$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $a33cdee31296f7db$export$d97aa349ed20696($a33cdee31296f7db$var$_constructorGuard, $a33cdee31296f7db$var$toHex(new $a33cdee31296f7db$var$BN(value)));
            return $a33cdee31296f7db$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $a33cdee31296f7db$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $a33cdee31296f7db$var$MAX_SAFE || value <= -$a33cdee31296f7db$var$MAX_SAFE) $a33cdee31296f7db$var$throwFault("overflow", "BigNumber.from", value);
            return $a33cdee31296f7db$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $a33cdee31296f7db$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $is1Vq.isBytes)(anyValue)) return $a33cdee31296f7db$export$d97aa349ed20696.from((0, $is1Vq.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $a33cdee31296f7db$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $is1Vq.isHexString)(hex) || hex[0] === "-" && (0, $is1Vq.isHexString)(hex.substring(1))) return $a33cdee31296f7db$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $a33cdee31296f7db$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $a33cdee31296f7db$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $a33cdee31296f7db$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $a33cdee31296f7db$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $a33cdee31296f7db$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $a33cdee31296f7db$var$toBigNumber(value) {
    return $a33cdee31296f7db$export$d97aa349ed20696.from($a33cdee31296f7db$var$toHex(value));
}
function $a33cdee31296f7db$var$toBN(value) {
    const hex = $a33cdee31296f7db$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $a33cdee31296f7db$var$BN("-" + hex.substring(3), 16);
    return new $a33cdee31296f7db$var$BN(hex.substring(2), 16);
}
function $a33cdee31296f7db$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $a33cdee31296f7db$var$logger.throwError(fault, (0, $hAWyw.Logger).errors.NUMERIC_FAULT, params);
}
function $a33cdee31296f7db$export$51e4a08295f7770f(value) {
    return new $a33cdee31296f7db$var$BN(value, 36).toString(16);
}
function $a33cdee31296f7db$export$1293db5d29c264ff(value) {
    return new $a33cdee31296f7db$var$BN(value, 16).toString(36);
}

});
parcelRegister("1NQM5", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("dMMsS", function(module, exports) {

$parcel$export(module.exports, "version", () => $a0955a1f537ab253$export$83d89fbfd8236492);
const $a0955a1f537ab253$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("cQEXW", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", () => $95aa1e57db83f681$export$104236534534f9be);
$parcel$export(module.exports, "getStatic", () => $95aa1e57db83f681$export$f695fbbf3cdaaf47);
$parcel$export(module.exports, "resolveProperties", () => $95aa1e57db83f681$export$d503dd157d963b60);
$parcel$export(module.exports, "checkProperties", () => $95aa1e57db83f681$export$ae5a316ba623b73a);
$parcel$export(module.exports, "shallowCopy", () => $95aa1e57db83f681$export$9c13236873b118a5);
$parcel$export(module.exports, "deepCopy", () => $95aa1e57db83f681$export$6c40052bed430212);
$parcel$export(module.exports, "Description", () => $95aa1e57db83f681$export$393edc798c47379d);

var $hAWyw = parcelRequire("hAWyw");

var $gwJTH = parcelRequire("gwJTH");
"use strict";
var $95aa1e57db83f681$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $95aa1e57db83f681$var$logger = new (0, $hAWyw.Logger)((0, $gwJTH.version));
function $95aa1e57db83f681$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $95aa1e57db83f681$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $95aa1e57db83f681$export$d503dd157d963b60(object) {
    return $95aa1e57db83f681$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $95aa1e57db83f681$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $95aa1e57db83f681$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $95aa1e57db83f681$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $95aa1e57db83f681$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $95aa1e57db83f681$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $95aa1e57db83f681$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $95aa1e57db83f681$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$95aa1e57db83f681$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $95aa1e57db83f681$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $95aa1e57db83f681$var$_deepCopy(object) {
    if ($95aa1e57db83f681$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$95aa1e57db83f681$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $95aa1e57db83f681$export$104236534534f9be(result, key, $95aa1e57db83f681$export$6c40052bed430212(value));
        }
        return result;
    }
    return $95aa1e57db83f681$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $95aa1e57db83f681$export$6c40052bed430212(object) {
    return $95aa1e57db83f681$var$_deepCopy(object);
}
class $95aa1e57db83f681$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $95aa1e57db83f681$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("gwJTH", function(module, exports) {

$parcel$export(module.exports, "version", () => $c0833cc658cad96c$export$83d89fbfd8236492);
const $c0833cc658cad96c$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("lONVT", function(module, exports) {

$parcel$export(module.exports, "version", () => $fe2500169f3023f7$export$83d89fbfd8236492);
const $fe2500169f3023f7$export$83d89fbfd8236492 = "abi/5.7.0";

});


parcelRegister("6N7mB", function(module, exports) {

$parcel$export(module.exports, "LogDescription", () => $4f1d07f36b5056ce$export$c2ab6499be98b3c5);
$parcel$export(module.exports, "TransactionDescription", () => $4f1d07f36b5056ce$export$7a3223b0fadb690b);
$parcel$export(module.exports, "Indexed", () => $4f1d07f36b5056ce$export$8ef99100a3c56f8c);
$parcel$export(module.exports, "Interface", () => $4f1d07f36b5056ce$export$48cefb51a4e315b2);

var $8T6OQ = parcelRequire("8T6OQ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $kzd4T = parcelRequire("kzd4T");

var $koabN = parcelRequire("koabN");

var $cQEXW = parcelRequire("cQEXW");

var $3OfWd = parcelRequire("3OfWd");

var $H2p5T = parcelRequire("H2p5T");

var $2Pd4Q = parcelRequire("2Pd4Q");

var $hAWyw = parcelRequire("hAWyw");

var $lONVT = parcelRequire("lONVT");
"use strict";
const $4f1d07f36b5056ce$var$logger = new (0, $hAWyw.Logger)((0, $lONVT.version));
class $4f1d07f36b5056ce$export$c2ab6499be98b3c5 extends (0, $cQEXW.Description) {
}
class $4f1d07f36b5056ce$export$7a3223b0fadb690b extends (0, $cQEXW.Description) {
}
class $4f1d07f36b5056ce$export$cfba08fc0e40e2ab extends (0, $cQEXW.Description) {
}
class $4f1d07f36b5056ce$export$8ef99100a3c56f8c extends (0, $cQEXW.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $4f1d07f36b5056ce$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $4f1d07f36b5056ce$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $4f1d07f36b5056ce$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $cQEXW.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $2Pd4Q.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $cQEXW.defineReadOnly)(this, "_abiCoder", (0, $cQEXW.getStatic)(new.target, "getAbiCoder")());
        (0, $cQEXW.defineReadOnly)(this, "functions", {});
        (0, $cQEXW.defineReadOnly)(this, "errors", {});
        (0, $cQEXW.defineReadOnly)(this, "events", {});
        (0, $cQEXW.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $4f1d07f36b5056ce$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $cQEXW.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $4f1d07f36b5056ce$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $cQEXW.defineReadOnly)(this, "deploy", (0, $2Pd4Q.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $cQEXW.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $2Pd4Q.FormatTypes).full;
        if (format === (0, $2Pd4Q.FormatTypes).sighash) $4f1d07f36b5056ce$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $2Pd4Q.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $3OfWd.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $8T6OQ.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $is1Vq.hexDataSlice)((0, $kzd4T.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $kzd4T.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $is1Vq.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $4f1d07f36b5056ce$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $2Pd4Q.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $is1Vq.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $4f1d07f36b5056ce$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $2Pd4Q.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $is1Vq.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $cQEXW.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $4f1d07f36b5056ce$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $2Pd4Q.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $4f1d07f36b5056ce$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $cQEXW.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $cQEXW.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $is1Vq.arrayify)(data);
        if ((0, $is1Vq.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $4f1d07f36b5056ce$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $is1Vq.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $is1Vq.hexlify)((0, $is1Vq.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $is1Vq.arrayify)(data);
        if ((0, $is1Vq.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $4f1d07f36b5056ce$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $is1Vq.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $is1Vq.hexlify)((0, $is1Vq.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $is1Vq.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $is1Vq.hexlify)(bytes.slice(0, 4));
                    const builtin = $4f1d07f36b5056ce$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $4f1d07f36b5056ce$var$logger.throwError("call revert exception" + message, (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $is1Vq.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $is1Vq.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $4f1d07f36b5056ce$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $hAWyw.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $kzd4T.id)(value);
            else if (param.type === "bytes") return (0, $koabN.keccak256)((0, $is1Vq.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $e0Utj.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $is1Vq.hexZeroPad)((0, $is1Vq.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $4f1d07f36b5056ce$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $4f1d07f36b5056ce$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $4f1d07f36b5056ce$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $kzd4T.id)(value));
                else if (param.type === "bytes") topics.push((0, $koabN.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $is1Vq.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $4f1d07f36b5056ce$var$logger.throwError("fragment/topic mismatch", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $2Pd4Q.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $is1Vq.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $4f1d07f36b5056ce$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $4f1d07f36b5056ce$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $4f1d07f36b5056ce$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $4f1d07f36b5056ce$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $4f1d07f36b5056ce$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $e0Utj.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $4f1d07f36b5056ce$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $is1Vq.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $4f1d07f36b5056ce$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("8T6OQ", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $6788bfe8a2bf366b$export$88411125f012957a);
$parcel$export(module.exports, "isAddress", () => $6788bfe8a2bf366b$export$977e255126d763d6);
$parcel$export(module.exports, "getIcapAddress", () => $6788bfe8a2bf366b$export$962c4ddada9f668f);
$parcel$export(module.exports, "getContractAddress", () => $6788bfe8a2bf366b$export$b7fbffef12272e40);
$parcel$export(module.exports, "getCreate2Address", () => $6788bfe8a2bf366b$export$e0b22d96621f73a2);

var $is1Vq = parcelRequire("is1Vq");

var $e0Utj = parcelRequire("e0Utj");

var $koabN = parcelRequire("koabN");

var $aDs3C = parcelRequire("aDs3C");

var $hAWyw = parcelRequire("hAWyw");

var $YvJVz = parcelRequire("YvJVz");
"use strict";
const $6788bfe8a2bf366b$var$logger = new (0, $hAWyw.Logger)((0, $YvJVz.version));
function $6788bfe8a2bf366b$var$getChecksumAddress(address) {
    if (!(0, $is1Vq.isHexString)(address, 20)) $6788bfe8a2bf366b$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $is1Vq.arrayify)((0, $koabN.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $6788bfe8a2bf366b$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $6788bfe8a2bf366b$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $6788bfe8a2bf366b$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$6788bfe8a2bf366b$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$6788bfe8a2bf366b$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $6788bfe8a2bf366b$var$safeDigits = Math.floor($6788bfe8a2bf366b$var$log10($6788bfe8a2bf366b$var$MAX_SAFE_INTEGER));
function $6788bfe8a2bf366b$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $6788bfe8a2bf366b$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $6788bfe8a2bf366b$var$safeDigits){
        let block = expanded.substring(0, $6788bfe8a2bf366b$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $6788bfe8a2bf366b$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $6788bfe8a2bf366b$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $6788bfe8a2bf366b$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $6788bfe8a2bf366b$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $6788bfe8a2bf366b$var$ibanChecksum(address)) $6788bfe8a2bf366b$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $e0Utj._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $6788bfe8a2bf366b$var$getChecksumAddress("0x" + result);
    } else $6788bfe8a2bf366b$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $6788bfe8a2bf366b$export$977e255126d763d6(address) {
    try {
        $6788bfe8a2bf366b$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $6788bfe8a2bf366b$export$962c4ddada9f668f(address) {
    let base36 = (0, $e0Utj._base16To36)($6788bfe8a2bf366b$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $6788bfe8a2bf366b$var$ibanChecksum("XE00" + base36) + base36;
}
function $6788bfe8a2bf366b$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $6788bfe8a2bf366b$export$88411125f012957a(transaction.from);
    } catch (error) {
        $6788bfe8a2bf366b$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $is1Vq.stripZeros)((0, $is1Vq.arrayify)((0, $e0Utj.BigNumber).from(transaction.nonce).toHexString()));
    return $6788bfe8a2bf366b$export$88411125f012957a((0, $is1Vq.hexDataSlice)((0, $koabN.keccak256)((0, $aDs3C.encode)([
        from,
        nonce
    ])), 12));
}
function $6788bfe8a2bf366b$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $is1Vq.hexDataLength)(salt) !== 32) $6788bfe8a2bf366b$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $is1Vq.hexDataLength)(initCodeHash) !== 32) $6788bfe8a2bf366b$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $6788bfe8a2bf366b$export$88411125f012957a((0, $is1Vq.hexDataSlice)((0, $koabN.keccak256)((0, $is1Vq.concat)([
        "0xff",
        $6788bfe8a2bf366b$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("koabN", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $ed7df3e74436e93c$export$f8151fce47ad1c35);

var $3IYTz = parcelRequire("3IYTz");

var $is1Vq = parcelRequire("is1Vq");
"use strict";
function $ed7df3e74436e93c$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($3IYTz))).keccak_256((0, $is1Vq.arrayify)(data));
}

});
parcelRegister("3IYTz", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $gbdt3 === "object" && $gbdt3.versions && $gbdt3.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("aDs3C", function(module, exports) {

$parcel$export(module.exports, "encode", () => $7be34f8674b08142$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $7be34f8674b08142$export$2f872c0f2117be69);

var $is1Vq = parcelRequire("is1Vq");

var $hAWyw = parcelRequire("hAWyw");

var $FU9gL = parcelRequire("FU9gL");
"use strict";
const $7be34f8674b08142$var$logger = new (0, $hAWyw.Logger)((0, $FU9gL.version));
function $7be34f8674b08142$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $7be34f8674b08142$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $7be34f8674b08142$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($7be34f8674b08142$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $7be34f8674b08142$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $is1Vq.isBytesLike)(object)) $7be34f8674b08142$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $is1Vq.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $7be34f8674b08142$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $7be34f8674b08142$export$c564cdbbe6da493(object) {
    return (0, $is1Vq.hexlify)($7be34f8674b08142$var$_encode(object));
}
function $7be34f8674b08142$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $7be34f8674b08142$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $7be34f8674b08142$var$logger.throwError("child data too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $7be34f8674b08142$var$_decode(data, offset) {
    if (data.length === 0) $7be34f8674b08142$var$logger.throwError("data too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $7be34f8674b08142$var$logger.throwError("data short segment too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        const length = $7be34f8674b08142$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $7be34f8674b08142$var$logger.throwError("data long segment too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        return $7be34f8674b08142$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $7be34f8674b08142$var$logger.throwError("data array too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        return $7be34f8674b08142$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $7be34f8674b08142$var$logger.throwError("data array too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        const length = $7be34f8674b08142$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $7be34f8674b08142$var$logger.throwError("data array too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $is1Vq.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $7be34f8674b08142$var$logger.throwError("data too short", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $is1Vq.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $is1Vq.hexlify)(data[offset])
    };
}
function $7be34f8674b08142$export$2f872c0f2117be69(data) {
    const bytes = (0, $is1Vq.arrayify)(data);
    const decoded = $7be34f8674b08142$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $7be34f8674b08142$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("FU9gL", function(module, exports) {

$parcel$export(module.exports, "version", () => $07df625f9f1d49de$export$83d89fbfd8236492);
const $07df625f9f1d49de$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("YvJVz", function(module, exports) {

$parcel$export(module.exports, "version", () => $0b5e399166a4a44b$export$83d89fbfd8236492);
const $0b5e399166a4a44b$export$83d89fbfd8236492 = "address/5.7.0";

});


parcelRegister("kzd4T", function(module, exports) {

$parcel$export(module.exports, "id", () => $ef9138875c138dea$export$d560c7e4a29451c2);

var $koabN = parcelRequire("koabN");

var $itjXq = parcelRequire("itjXq");
function $ef9138875c138dea$export$d560c7e4a29451c2(text) {
    return (0, $koabN.keccak256)((0, $itjXq.toUtf8Bytes)(text));
}

});
parcelRegister("itjXq", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", () => $d72a6a9624de6437$export$c6986442964129f5);
$parcel$export(module.exports, "Utf8ErrorReason", () => $d72a6a9624de6437$export$c285fa6ac15ff6a6);
$parcel$export(module.exports, "Utf8ErrorFuncs", () => $d72a6a9624de6437$export$c6e2180c5bb5bc05);
$parcel$export(module.exports, "toUtf8Bytes", () => $d72a6a9624de6437$export$8feeb310b4b4752f);
$parcel$export(module.exports, "_toEscapedUtf8String", () => $d72a6a9624de6437$export$a7a0ec15960b9055);
$parcel$export(module.exports, "_toUtf8String", () => $d72a6a9624de6437$export$232e1dab03132235);
$parcel$export(module.exports, "toUtf8String", () => $d72a6a9624de6437$export$7643a1dc2c38d5eb);
$parcel$export(module.exports, "toUtf8CodePoints", () => $d72a6a9624de6437$export$ae470a36a31b28c2);

var $is1Vq = parcelRequire("is1Vq");

var $hAWyw = parcelRequire("hAWyw");

var $93NrR = parcelRequire("93NrR");
"use strict";
const $d72a6a9624de6437$var$logger = new (0, $hAWyw.Logger)((0, $93NrR.version));
var $d72a6a9624de6437$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($d72a6a9624de6437$export$c6986442964129f5 || ($d72a6a9624de6437$export$c6986442964129f5 = {}));
var $d72a6a9624de6437$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($d72a6a9624de6437$export$c285fa6ac15ff6a6 || ($d72a6a9624de6437$export$c285fa6ac15ff6a6 = {}));
function $d72a6a9624de6437$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $d72a6a9624de6437$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $d72a6a9624de6437$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $d72a6a9624de6437$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $d72a6a9624de6437$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $d72a6a9624de6437$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $d72a6a9624de6437$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $d72a6a9624de6437$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $d72a6a9624de6437$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $d72a6a9624de6437$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $d72a6a9624de6437$var$errorFunc,
    ignore: $d72a6a9624de6437$var$ignoreFunc,
    replace: $d72a6a9624de6437$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $d72a6a9624de6437$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $d72a6a9624de6437$export$c6e2180c5bb5bc05.error;
    bytes = (0, $is1Vq.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($d72a6a9624de6437$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $d72a6a9624de6437$export$8feeb310b4b4752f(str, form = $d72a6a9624de6437$export$c6986442964129f5.current) {
    if (form != $d72a6a9624de6437$export$c6986442964129f5.current) {
        $d72a6a9624de6437$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $is1Vq.arrayify)(result);
}
function $d72a6a9624de6437$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $d72a6a9624de6437$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $d72a6a9624de6437$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $d72a6a9624de6437$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $d72a6a9624de6437$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $d72a6a9624de6437$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $d72a6a9624de6437$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $d72a6a9624de6437$export$7643a1dc2c38d5eb(bytes, onError) {
    return $d72a6a9624de6437$export$232e1dab03132235($d72a6a9624de6437$var$getUtf8CodePoints(bytes, onError));
}
function $d72a6a9624de6437$export$ae470a36a31b28c2(str, form = $d72a6a9624de6437$export$c6986442964129f5.current) {
    return $d72a6a9624de6437$var$getUtf8CodePoints($d72a6a9624de6437$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("93NrR", function(module, exports) {

$parcel$export(module.exports, "version", () => $698ac04ec2a19c07$export$83d89fbfd8236492);
const $698ac04ec2a19c07$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("3OfWd", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => $2c62679439c3c77e$export$fe041e1a83d3efc6);
$parcel$export(module.exports, "defaultAbiCoder", () => $2c62679439c3c77e$export$51d1cfcdb913adff);

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $lONVT = parcelRequire("lONVT");

var $H2p5T = parcelRequire("H2p5T");

var $4VQR2 = parcelRequire("4VQR2");

var $aFD8R = parcelRequire("aFD8R");

var $f1uT4 = parcelRequire("f1uT4");

var $i4yUo = parcelRequire("i4yUo");

var $lSEOj = parcelRequire("lSEOj");

var $9dRNg = parcelRequire("9dRNg");

var $gA8gz = parcelRequire("gA8gz");

var $725C5 = parcelRequire("725C5");

var $jSSfb = parcelRequire("jSSfb");

var $2Pd4Q = parcelRequire("2Pd4Q");
"use strict";
const $2c62679439c3c77e$var$logger = new (0, $hAWyw.Logger)((0, $lONVT.version));
const $2c62679439c3c77e$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $2c62679439c3c77e$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $2c62679439c3c77e$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $cQEXW.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $4VQR2.AddressCoder)(param.name);
            case "bool":
                return new (0, $f1uT4.BooleanCoder)(param.name);
            case "string":
                return new (0, $725C5.StringCoder)(param.name);
            case "bytes":
                return new (0, $i4yUo.BytesCoder)(param.name);
            case "array":
                return new (0, $aFD8R.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $jSSfb.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $9dRNg.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($2c62679439c3c77e$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $2c62679439c3c77e$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $gA8gz.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($2c62679439c3c77e$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $2c62679439c3c77e$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $lSEOj.FixedBytesCoder)(size, param.name);
        }
        return $2c62679439c3c77e$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $H2p5T.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $H2p5T.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $2Pd4Q.ParamType).from(type)));
        const coder = new (0, $jSSfb.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $2c62679439c3c77e$var$logger.throwError("types/values length mismatch", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $2Pd4Q.ParamType).from(type)));
        const coder = new (0, $jSSfb.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $2Pd4Q.ParamType).from(type)));
        const coder = new (0, $jSSfb.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $is1Vq.arrayify)(data), loose));
    }
}
const $2c62679439c3c77e$export$51d1cfcdb913adff = new $2c62679439c3c77e$export$fe041e1a83d3efc6();

});
parcelRegister("4VQR2", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", () => $39757c17720b8472$export$59dbbded7775bfe7);

var $8T6OQ = parcelRequire("8T6OQ");

var $is1Vq = parcelRequire("is1Vq");

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $39757c17720b8472$export$59dbbded7775bfe7 extends (0, $H2p5T.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $8T6OQ.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $8T6OQ.getAddress)((0, $is1Vq.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("aFD8R", function(module, exports) {

$parcel$export(module.exports, "pack", () => $7c4c187f4fd0e270$export$2a703dbb0cb35339);
$parcel$export(module.exports, "unpack", () => $7c4c187f4fd0e270$export$417857010dc9287f);
$parcel$export(module.exports, "ArrayCoder", () => $7c4c187f4fd0e270$export$88bc419d2df11f54);

var $hAWyw = parcelRequire("hAWyw");

var $lONVT = parcelRequire("lONVT");

var $H2p5T = parcelRequire("H2p5T");

var $eleA8 = parcelRequire("eleA8");
"use strict";
const $7c4c187f4fd0e270$var$logger = new (0, $hAWyw.Logger)((0, $lONVT.version));
function $7c4c187f4fd0e270$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $7c4c187f4fd0e270$var$logger.throwError("cannot encode object for signature with missing names", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $7c4c187f4fd0e270$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $7c4c187f4fd0e270$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $7c4c187f4fd0e270$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $H2p5T.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $H2p5T.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $7c4c187f4fd0e270$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $hAWyw.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $hAWyw.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $7c4c187f4fd0e270$export$88bc419d2df11f54 extends (0, $H2p5T.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $7c4c187f4fd0e270$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $7c4c187f4fd0e270$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $7c4c187f4fd0e270$var$logger.throwError("insufficient data length", (0, $hAWyw.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $eleA8.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $7c4c187f4fd0e270$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("eleA8", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", () => $a70e5683743cbb30$export$87c41d1139a03fa2);

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $a70e5683743cbb30$export$87c41d1139a03fa2 extends (0, $H2p5T.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("f1uT4", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", () => $aefee88f3dfce88e$export$fe9118d6c093150c);

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $aefee88f3dfce88e$export$fe9118d6c093150c extends (0, $H2p5T.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("i4yUo", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", () => $d283add796d62d97$export$db9eadd8df12ad2e);
$parcel$export(module.exports, "BytesCoder", () => $d283add796d62d97$export$e5823e9574df18d2);

var $is1Vq = parcelRequire("is1Vq");

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $d283add796d62d97$export$db9eadd8df12ad2e extends (0, $H2p5T.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $is1Vq.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $d283add796d62d97$export$e5823e9574df18d2 extends $d283add796d62d97$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $is1Vq.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("lSEOj", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", () => $fede4c3fed75697d$export$7dec9db68e6bcf5a);

var $is1Vq = parcelRequire("is1Vq");

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $fede4c3fed75697d$export$7dec9db68e6bcf5a extends (0, $H2p5T.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $is1Vq.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $is1Vq.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("9dRNg", function(module, exports) {

$parcel$export(module.exports, "NullCoder", () => $6b6f0e3ea18f4e6b$export$70982cadf2d6b4ec);

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $6b6f0e3ea18f4e6b$export$70982cadf2d6b4ec extends (0, $H2p5T.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("gA8gz", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", () => $c1266ba6df583ecb$export$b934dc8cfe13938c);

var $e0Utj = parcelRequire("e0Utj");

var $kUxyG = parcelRequire("kUxyG");

var $H2p5T = parcelRequire("H2p5T");
"use strict";
class $c1266ba6df583ecb$export$b934dc8cfe13938c extends (0, $H2p5T.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $e0Utj.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $kUxyG.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $kUxyG.One)).mul((0, $kUxyG.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $kUxyG.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("kUxyG", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", () => $f39311a101e15ac6$export$c83ef0909a6ddeec);
$parcel$export(module.exports, "Zero", () => $f39311a101e15ac6$export$aaef8a3eae948f03);
$parcel$export(module.exports, "One", () => $f39311a101e15ac6$export$9aa05a5866350bcf);
$parcel$export(module.exports, "Two", () => $f39311a101e15ac6$export$9276dd97bf62cc8d);
$parcel$export(module.exports, "WeiPerEther", () => $f39311a101e15ac6$export$c8db55bd7405209e);
$parcel$export(module.exports, "MaxUint256", () => $f39311a101e15ac6$export$1b53890de5aabdd0);
$parcel$export(module.exports, "MinInt256", () => $f39311a101e15ac6$export$963c9b9317b80aaf);
$parcel$export(module.exports, "MaxInt256", () => $f39311a101e15ac6$export$6f8dbb07ebe6d738);

var $e0Utj = parcelRequire("e0Utj");
const $f39311a101e15ac6$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $e0Utj.BigNumber).from(-1);
const $f39311a101e15ac6$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $e0Utj.BigNumber).from(0);
const $f39311a101e15ac6$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $e0Utj.BigNumber).from(1);
const $f39311a101e15ac6$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $e0Utj.BigNumber).from(2);
const $f39311a101e15ac6$export$c8db55bd7405209e = /*#__PURE__*/ (0, $e0Utj.BigNumber).from("1000000000000000000");
const $f39311a101e15ac6$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $e0Utj.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $f39311a101e15ac6$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $e0Utj.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $f39311a101e15ac6$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $e0Utj.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("725C5", function(module, exports) {

$parcel$export(module.exports, "StringCoder", () => $51ed12f8439a8901$export$2d1b854518731426);

var $itjXq = parcelRequire("itjXq");

var $i4yUo = parcelRequire("i4yUo");
"use strict";
class $51ed12f8439a8901$export$2d1b854518731426 extends (0, $i4yUo.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $itjXq.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $itjXq.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("jSSfb", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", () => $e79d232c73993e9a$export$e9fceba8f110fea6);

var $H2p5T = parcelRequire("H2p5T");

var $aFD8R = parcelRequire("aFD8R");
"use strict";
class $e79d232c73993e9a$export$e9fceba8f110fea6 extends (0, $H2p5T.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $aFD8R.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $aFD8R.unpack)(reader, this.coders));
    }
}

});

parcelRegister("2Pd4Q", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", () => $20ea7d107fa98ba8$export$f010f239efc4d445);
$parcel$export(module.exports, "ParamType", () => $20ea7d107fa98ba8$export$426dc07f493a4c47);
$parcel$export(module.exports, "Fragment", () => $20ea7d107fa98ba8$export$ffb0004e005737fa);
$parcel$export(module.exports, "FunctionFragment", () => $20ea7d107fa98ba8$export$8d576c928b93668f);
$parcel$export(module.exports, "EventFragment", () => $20ea7d107fa98ba8$export$958548f08bac2833);
$parcel$export(module.exports, "ConstructorFragment", () => $20ea7d107fa98ba8$export$3ac5c9504f801ea4);
$parcel$export(module.exports, "ErrorFragment", () => $20ea7d107fa98ba8$export$2c42c6d543aa9b59);

var $e0Utj = parcelRequire("e0Utj");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $lONVT = parcelRequire("lONVT");
"use strict";
const $20ea7d107fa98ba8$var$logger = new (0, $hAWyw.Logger)((0, $lONVT.version));
const $20ea7d107fa98ba8$var$_constructorGuard = {};
let $20ea7d107fa98ba8$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $20ea7d107fa98ba8$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $20ea7d107fa98ba8$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($20ea7d107fa98ba8$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($20ea7d107fa98ba8$var$ModifiersNest[name]) return true;
    }
    if ($20ea7d107fa98ba8$var$ModifiersBytes[name] || name === "payable") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $20ea7d107fa98ba8$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $20ea7d107fa98ba8$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $20ea7d107fa98ba8$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($20ea7d107fa98ba8$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $20ea7d107fa98ba8$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($20ea7d107fa98ba8$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $20ea7d107fa98ba8$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $20ea7d107fa98ba8$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($20ea7d107fa98ba8$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $20ea7d107fa98ba8$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($20ea7d107fa98ba8$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $20ea7d107fa98ba8$var$verifyType(parent.type);
    return parent;
}
function $20ea7d107fa98ba8$var$populate(object, params) {
    for(let key in params)(0, $cQEXW.defineReadOnly)(object, key, params[key]);
}
const $20ea7d107fa98ba8$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $20ea7d107fa98ba8$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $20ea7d107fa98ba8$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $20ea7d107fa98ba8$var$_constructorGuard) $20ea7d107fa98ba8$var$logger.throwError("use fromString", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $20ea7d107fa98ba8$var$populate(this, params);
        let match = this.type.match($20ea7d107fa98ba8$var$paramTypeArray);
        if (match) $20ea7d107fa98ba8$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $20ea7d107fa98ba8$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $20ea7d107fa98ba8$export$f010f239efc4d445.sighash;
        if (!$20ea7d107fa98ba8$export$f010f239efc4d445[format]) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $20ea7d107fa98ba8$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $20ea7d107fa98ba8$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $20ea7d107fa98ba8$export$426dc07f493a4c47($20ea7d107fa98ba8$var$_constructorGuard, {
            name: value.name || null,
            type: $20ea7d107fa98ba8$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($20ea7d107fa98ba8$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $20ea7d107fa98ba8$var$parseParams(value, allowIndex) {
    return $20ea7d107fa98ba8$var$splitNesting(value).map((param)=>$20ea7d107fa98ba8$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $20ea7d107fa98ba8$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $20ea7d107fa98ba8$var$_constructorGuard) $20ea7d107fa98ba8$var$logger.throwError("use a static from method", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $20ea7d107fa98ba8$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($20ea7d107fa98ba8$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $20ea7d107fa98ba8$export$ffb0004e005737fa.fromString(value);
        return $20ea7d107fa98ba8$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $20ea7d107fa98ba8$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $20ea7d107fa98ba8$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $20ea7d107fa98ba8$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $20ea7d107fa98ba8$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $20ea7d107fa98ba8$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $20ea7d107fa98ba8$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $20ea7d107fa98ba8$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $20ea7d107fa98ba8$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $20ea7d107fa98ba8$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $20ea7d107fa98ba8$export$958548f08bac2833 extends $20ea7d107fa98ba8$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $20ea7d107fa98ba8$export$f010f239efc4d445.sighash;
        if (!$20ea7d107fa98ba8$export$f010f239efc4d445[format]) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $20ea7d107fa98ba8$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $20ea7d107fa98ba8$export$958548f08bac2833.fromString(value);
        return $20ea7d107fa98ba8$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $20ea7d107fa98ba8$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $20ea7d107fa98ba8$export$958548f08bac2833($20ea7d107fa98ba8$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($20ea7d107fa98ba8$var$regexParen);
        if (!match) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $20ea7d107fa98ba8$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $20ea7d107fa98ba8$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $20ea7d107fa98ba8$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $20ea7d107fa98ba8$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $e0Utj.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $20ea7d107fa98ba8$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $20ea7d107fa98ba8$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $20ea7d107fa98ba8$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $20ea7d107fa98ba8$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $20ea7d107fa98ba8$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $20ea7d107fa98ba8$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $20ea7d107fa98ba8$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $20ea7d107fa98ba8$export$3ac5c9504f801ea4 extends $20ea7d107fa98ba8$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $20ea7d107fa98ba8$export$f010f239efc4d445.sighash;
        if (!$20ea7d107fa98ba8$export$f010f239efc4d445[format]) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) $20ea7d107fa98ba8$var$logger.throwError("cannot format a constructor for sighash", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $20ea7d107fa98ba8$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $20ea7d107fa98ba8$export$3ac5c9504f801ea4.fromString(value);
        return $20ea7d107fa98ba8$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $20ea7d107fa98ba8$var$verifyState(value);
        if (state.constant) $20ea7d107fa98ba8$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $e0Utj.BigNumber).from(value.gas) : null
        };
        return new $20ea7d107fa98ba8$export$3ac5c9504f801ea4($20ea7d107fa98ba8$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $20ea7d107fa98ba8$var$parseGas(value, params);
        let parens = value.match($20ea7d107fa98ba8$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $20ea7d107fa98ba8$var$parseParams(parens[2].trim(), false);
        $20ea7d107fa98ba8$var$parseModifiers(parens[3].trim(), params);
        return $20ea7d107fa98ba8$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $20ea7d107fa98ba8$export$8d576c928b93668f extends $20ea7d107fa98ba8$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $20ea7d107fa98ba8$export$f010f239efc4d445.sighash;
        if (!$20ea7d107fa98ba8$export$f010f239efc4d445[format]) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $20ea7d107fa98ba8$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $20ea7d107fa98ba8$export$8d576c928b93668f.fromString(value);
        return $20ea7d107fa98ba8$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $20ea7d107fa98ba8$var$verifyState(value);
        const params = {
            type: value.type,
            name: $20ea7d107fa98ba8$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $e0Utj.BigNumber).from(value.gas) : null
        };
        return new $20ea7d107fa98ba8$export$8d576c928b93668f($20ea7d107fa98ba8$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $20ea7d107fa98ba8$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($20ea7d107fa98ba8$var$regexParen);
        if (!parens) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $20ea7d107fa98ba8$var$verifyIdentifier(params.name);
        params.inputs = $20ea7d107fa98ba8$var$parseParams(parens[2], false);
        $20ea7d107fa98ba8$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($20ea7d107fa98ba8$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $20ea7d107fa98ba8$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $20ea7d107fa98ba8$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $20ea7d107fa98ba8$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $20ea7d107fa98ba8$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $20ea7d107fa98ba8$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $20ea7d107fa98ba8$export$2c42c6d543aa9b59 extends $20ea7d107fa98ba8$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $20ea7d107fa98ba8$export$f010f239efc4d445.sighash;
        if (!$20ea7d107fa98ba8$export$f010f239efc4d445[format]) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $20ea7d107fa98ba8$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $20ea7d107fa98ba8$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $20ea7d107fa98ba8$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $20ea7d107fa98ba8$export$2c42c6d543aa9b59.fromString(value);
        return $20ea7d107fa98ba8$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($20ea7d107fa98ba8$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $20ea7d107fa98ba8$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($20ea7d107fa98ba8$export$426dc07f493a4c47.fromObject) : []
        };
        return $20ea7d107fa98ba8$var$checkForbidden(new $20ea7d107fa98ba8$export$2c42c6d543aa9b59($20ea7d107fa98ba8$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($20ea7d107fa98ba8$var$regexParen);
        if (!parens) $20ea7d107fa98ba8$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $20ea7d107fa98ba8$var$verifyIdentifier(params.name);
        params.inputs = $20ea7d107fa98ba8$var$parseParams(parens[2], false);
        return $20ea7d107fa98ba8$var$checkForbidden($20ea7d107fa98ba8$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $20ea7d107fa98ba8$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $20ea7d107fa98ba8$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $20ea7d107fa98ba8$var$verifyIdentifier(value) {
    if (!value || !value.match($20ea7d107fa98ba8$var$regexIdentifier)) $20ea7d107fa98ba8$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $20ea7d107fa98ba8$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $20ea7d107fa98ba8$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $20ea7d107fa98ba8$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("cfLMn", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", () => $8ebbf2bbca81e599$export$406ece1549ccd00e);
$parcel$export(module.exports, "Provider", () => $8ebbf2bbca81e599$export$2881499e37b75b9a);

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $kOlyi = parcelRequire("kOlyi");
"use strict";
var $8ebbf2bbca81e599$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8ebbf2bbca81e599$var$logger = new (0, $hAWyw.Logger)((0, $kOlyi.version));
class $8ebbf2bbca81e599$export$406ece1549ccd00e extends (0, $cQEXW.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $8ebbf2bbca81e599$export$5b2cada8494f9d99 extends $8ebbf2bbca81e599$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $is1Vq.isHexString)(blockHash, 32)) $8ebbf2bbca81e599$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $8ebbf2bbca81e599$export$26bcd61a55716c98 extends $8ebbf2bbca81e599$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $is1Vq.isHexString)(hash, 32)) $8ebbf2bbca81e599$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $8ebbf2bbca81e599$export$8f8609bfee47c93 extends $8ebbf2bbca81e599$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $is1Vq.isHexString)(beforeHash, 32)) $8ebbf2bbca81e599$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $is1Vq.isHexString)(afterHash, 32)) $8ebbf2bbca81e599$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $8ebbf2bbca81e599$export$2881499e37b75b9a {
    constructor(){
        $8ebbf2bbca81e599$var$logger.checkAbstract(new.target, $8ebbf2bbca81e599$export$2881499e37b75b9a);
        (0, $cQEXW.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $8ebbf2bbca81e599$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $cQEXW.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $e0Utj.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRegister("kOlyi", function(module, exports) {

$parcel$export(module.exports, "version", () => $f26931f44f4d62a1$export$83d89fbfd8236492);
const $f26931f44f4d62a1$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRegister("40NDm", function(module, exports) {

$parcel$export(module.exports, "Signer", () => $2ebda9c30eb6e86d$export$fdf54fdde81cc9f0);
$parcel$export(module.exports, "VoidSigner", () => $2ebda9c30eb6e86d$export$7dbc56d9b9612bad);

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $bb1bq = parcelRequire("bb1bq");
"use strict";
var $2ebda9c30eb6e86d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2ebda9c30eb6e86d$var$logger = new (0, $hAWyw.Logger)((0, $bb1bq.version));
const $2ebda9c30eb6e86d$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $2ebda9c30eb6e86d$var$forwardErrors = [
    (0, $hAWyw.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $hAWyw.Logger).errors.NONCE_EXPIRED,
    (0, $hAWyw.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $2ebda9c30eb6e86d$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $2ebda9c30eb6e86d$var$logger.checkAbstract(new.target, $2ebda9c30eb6e86d$export$fdf54fdde81cc9f0);
        (0, $cQEXW.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $cQEXW.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $cQEXW.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($2ebda9c30eb6e86d$var$allowedTransactionKeys.indexOf(key) === -1) $2ebda9c30eb6e86d$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $cQEXW.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $2ebda9c30eb6e86d$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $cQEXW.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$2ebda9c30eb6e86d$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $2ebda9c30eb6e86d$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $2ebda9c30eb6e86d$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $2ebda9c30eb6e86d$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $2ebda9c30eb6e86d$var$logger.throwError("network does not support EIP-1559", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $2ebda9c30eb6e86d$var$logger.throwError("failed to get consistent fee data", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($2ebda9c30eb6e86d$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $2ebda9c30eb6e86d$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $hAWyw.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $2ebda9c30eb6e86d$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $cQEXW.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $2ebda9c30eb6e86d$var$logger.throwError("missing provider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $2ebda9c30eb6e86d$export$7dbc56d9b9612bad extends $2ebda9c30eb6e86d$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $cQEXW.defineReadOnly)(this, "address", address);
        (0, $cQEXW.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $2ebda9c30eb6e86d$var$logger.throwError(message, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $2ebda9c30eb6e86d$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRegister("bb1bq", function(module, exports) {

$parcel$export(module.exports, "version", () => $8231a3c51b9ad9b8$export$83d89fbfd8236492);
const $8231a3c51b9ad9b8$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRegister("fb2Z3", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", () => $b0ca32a0f950e415$export$80349e05e0724e11);
$parcel$export(module.exports, "computeAddress", () => $b0ca32a0f950e415$export$e67e2732ba9803f9);
$parcel$export(module.exports, "recoverAddress", () => $b0ca32a0f950e415$export$23cc18f96d8510e2);
$parcel$export(module.exports, "accessListify", () => $b0ca32a0f950e415$export$6c8662b1600dce2);
$parcel$export(module.exports, "serialize", () => $b0ca32a0f950e415$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "parse", () => $b0ca32a0f950e415$export$98e6a39c04603d36);

var $8T6OQ = parcelRequire("8T6OQ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $kUxyG = parcelRequire("kUxyG");

var $koabN = parcelRequire("koabN");

var $cQEXW = parcelRequire("cQEXW");

var $aDs3C = parcelRequire("aDs3C");

var $12CVZ = parcelRequire("12CVZ");

var $hAWyw = parcelRequire("hAWyw");

var $43ehP = parcelRequire("43ehP");
"use strict";
const $b0ca32a0f950e415$var$logger = new (0, $hAWyw.Logger)((0, $43ehP.version));
var $b0ca32a0f950e415$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($b0ca32a0f950e415$export$80349e05e0724e11 || ($b0ca32a0f950e415$export$80349e05e0724e11 = {}));
///////////////////////////////
function $b0ca32a0f950e415$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $8T6OQ.getAddress)(value);
}
function $b0ca32a0f950e415$var$handleNumber(value) {
    if (value === "0x") return 0, $kUxyG.Zero;
    return (0, $e0Utj.BigNumber).from(value);
}
// Legacy Transaction Fields
const $b0ca32a0f950e415$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $b0ca32a0f950e415$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $b0ca32a0f950e415$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $12CVZ.computePublicKey)(key);
    return (0, $8T6OQ.getAddress)((0, $is1Vq.hexDataSlice)((0, $koabN.keccak256)((0, $is1Vq.hexDataSlice)(publicKey, 1)), 12));
}
function $b0ca32a0f950e415$export$23cc18f96d8510e2(digest, signature) {
    return $b0ca32a0f950e415$export$e67e2732ba9803f9((0, $12CVZ.recoverPublicKey)((0, $is1Vq.arrayify)(digest), signature));
}
function $b0ca32a0f950e415$var$formatNumber(value, name) {
    const result = (0, $is1Vq.stripZeros)((0, $e0Utj.BigNumber).from(value).toHexString());
    if (result.length > 32) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $b0ca32a0f950e415$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $8T6OQ.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $is1Vq.hexDataLength)(storageKey) !== 32) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $b0ca32a0f950e415$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $b0ca32a0f950e415$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $b0ca32a0f950e415$var$accessSetify(set[0], set[1]);
        }
        return $b0ca32a0f950e415$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $b0ca32a0f950e415$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $b0ca32a0f950e415$var$formatAccessList(value) {
    return $b0ca32a0f950e415$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $b0ca32a0f950e415$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $e0Utj.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $e0Utj.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $b0ca32a0f950e415$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $b0ca32a0f950e415$var$formatNumber(transaction.chainId || 0, "chainId"),
        $b0ca32a0f950e415$var$formatNumber(transaction.nonce || 0, "nonce"),
        $b0ca32a0f950e415$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $b0ca32a0f950e415$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $b0ca32a0f950e415$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8T6OQ.getAddress)(transaction.to) : "0x",
        $b0ca32a0f950e415$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $b0ca32a0f950e415$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $is1Vq.splitSignature)(signature);
        fields.push($b0ca32a0f950e415$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $is1Vq.stripZeros)(sig.r));
        fields.push((0, $is1Vq.stripZeros)(sig.s));
    }
    return (0, $is1Vq.hexConcat)([
        "0x02",
        $aDs3C.encode(fields)
    ]);
}
function $b0ca32a0f950e415$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $b0ca32a0f950e415$var$formatNumber(transaction.chainId || 0, "chainId"),
        $b0ca32a0f950e415$var$formatNumber(transaction.nonce || 0, "nonce"),
        $b0ca32a0f950e415$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $b0ca32a0f950e415$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8T6OQ.getAddress)(transaction.to) : "0x",
        $b0ca32a0f950e415$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $b0ca32a0f950e415$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $is1Vq.splitSignature)(signature);
        fields.push($b0ca32a0f950e415$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $is1Vq.stripZeros)(sig.r));
        fields.push((0, $is1Vq.stripZeros)(sig.s));
    }
    return (0, $is1Vq.hexConcat)([
        "0x01",
        $aDs3C.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $b0ca32a0f950e415$var$_serialize(transaction, signature) {
    (0, $cQEXW.checkProperties)(transaction, $b0ca32a0f950e415$var$allowedTransactionKeys);
    const raw = [];
    $b0ca32a0f950e415$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $is1Vq.arrayify)((0, $is1Vq.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $is1Vq.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $is1Vq.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $b0ca32a0f950e415$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $is1Vq.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $is1Vq.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $aDs3C.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $is1Vq.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $b0ca32a0f950e415$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $b0ca32a0f950e415$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $is1Vq.hexlify)(v));
    raw.push((0, $is1Vq.stripZeros)((0, $is1Vq.arrayify)(sig.r)));
    raw.push((0, $is1Vq.stripZeros)((0, $is1Vq.arrayify)(sig.s)));
    return $aDs3C.encode(raw);
}
function $b0ca32a0f950e415$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $b0ca32a0f950e415$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $b0ca32a0f950e415$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $b0ca32a0f950e415$var$_serializeEip2930(transaction, signature);
        case 2:
            return $b0ca32a0f950e415$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $b0ca32a0f950e415$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $b0ca32a0f950e415$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $b0ca32a0f950e415$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $b0ca32a0f950e415$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $is1Vq.hexZeroPad)(fields[1], 32);
    tx.s = (0, $is1Vq.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $koabN.keccak256)(serialize(tx));
        tx.from = $b0ca32a0f950e415$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $b0ca32a0f950e415$var$_parseEip1559(payload) {
    const transaction = $aDs3C.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $is1Vq.hexlify)(payload));
    const maxPriorityFeePerGas = $b0ca32a0f950e415$var$handleNumber(transaction[2]);
    const maxFeePerGas = $b0ca32a0f950e415$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $b0ca32a0f950e415$var$handleNumber(transaction[0]).toNumber(),
        nonce: $b0ca32a0f950e415$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $b0ca32a0f950e415$var$handleNumber(transaction[4]),
        to: $b0ca32a0f950e415$var$handleAddress(transaction[5]),
        value: $b0ca32a0f950e415$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $b0ca32a0f950e415$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $koabN.keccak256)(payload);
    $b0ca32a0f950e415$var$_parseEipSignature(tx, transaction.slice(9), $b0ca32a0f950e415$var$_serializeEip1559);
    return tx;
}
function $b0ca32a0f950e415$var$_parseEip2930(payload) {
    const transaction = $aDs3C.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $is1Vq.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $b0ca32a0f950e415$var$handleNumber(transaction[0]).toNumber(),
        nonce: $b0ca32a0f950e415$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $b0ca32a0f950e415$var$handleNumber(transaction[2]),
        gasLimit: $b0ca32a0f950e415$var$handleNumber(transaction[3]),
        to: $b0ca32a0f950e415$var$handleAddress(transaction[4]),
        value: $b0ca32a0f950e415$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $b0ca32a0f950e415$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $koabN.keccak256)(payload);
    $b0ca32a0f950e415$var$_parseEipSignature(tx, transaction.slice(8), $b0ca32a0f950e415$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $b0ca32a0f950e415$var$_parse(rawTransaction) {
    const transaction = $aDs3C.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $b0ca32a0f950e415$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $b0ca32a0f950e415$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $b0ca32a0f950e415$var$handleNumber(transaction[1]),
        gasLimit: $b0ca32a0f950e415$var$handleNumber(transaction[2]),
        to: $b0ca32a0f950e415$var$handleAddress(transaction[3]),
        value: $b0ca32a0f950e415$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $e0Utj.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $is1Vq.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $is1Vq.hexZeroPad)(transaction[8], 32);
    if ((0, $e0Utj.BigNumber).from(tx.r).isZero() && (0, $e0Utj.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $is1Vq.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $koabN.keccak256)($aDs3C.encode(raw));
        try {
            tx.from = $b0ca32a0f950e415$export$23cc18f96d8510e2(digest, {
                r: (0, $is1Vq.hexlify)(tx.r),
                s: (0, $is1Vq.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $koabN.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $b0ca32a0f950e415$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $is1Vq.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $b0ca32a0f950e415$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $b0ca32a0f950e415$var$_parseEip2930(payload);
        case 2:
            return $b0ca32a0f950e415$var$_parseEip1559(payload);
        default:
            break;
    }
    return $b0ca32a0f950e415$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("12CVZ", function(module, exports) {

$parcel$export(module.exports, "SigningKey", () => $0c242de99b213480$export$21643ca94aed3e83);
$parcel$export(module.exports, "computePublicKey", () => $0c242de99b213480$export$4a89473d39301224);
$parcel$export(module.exports, "recoverPublicKey", () => $0c242de99b213480$export$952dd09fbe0232b7);

var $1VNLf = parcelRequire("1VNLf");

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $32dMe = parcelRequire("32dMe");
"use strict";
const $0c242de99b213480$var$logger = new (0, $hAWyw.Logger)((0, $32dMe.version));
let $0c242de99b213480$var$_curve = null;
function $0c242de99b213480$var$getCurve() {
    if (!$0c242de99b213480$var$_curve) $0c242de99b213480$var$_curve = new (0, $1VNLf.EC)("secp256k1");
    return $0c242de99b213480$var$_curve;
}
class $0c242de99b213480$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $cQEXW.defineReadOnly)(this, "curve", "secp256k1");
        (0, $cQEXW.defineReadOnly)(this, "privateKey", (0, $is1Vq.hexlify)(privateKey));
        if ((0, $is1Vq.hexDataLength)(this.privateKey) !== 32) $0c242de99b213480$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $0c242de99b213480$var$getCurve().keyFromPrivate((0, $is1Vq.arrayify)(this.privateKey));
        (0, $cQEXW.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $cQEXW.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $cQEXW.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $0c242de99b213480$var$getCurve().keyFromPublic((0, $is1Vq.arrayify)(this.publicKey));
        const p1 = $0c242de99b213480$var$getCurve().keyFromPublic((0, $is1Vq.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $0c242de99b213480$var$getCurve().keyFromPrivate((0, $is1Vq.arrayify)(this.privateKey));
        const digestBytes = (0, $is1Vq.arrayify)(digest);
        if (digestBytes.length !== 32) $0c242de99b213480$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $is1Vq.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $is1Vq.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $is1Vq.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $0c242de99b213480$var$getCurve().keyFromPrivate((0, $is1Vq.arrayify)(this.privateKey));
        const otherKeyPair = $0c242de99b213480$var$getCurve().keyFromPublic((0, $is1Vq.arrayify)($0c242de99b213480$export$4a89473d39301224(otherKey)));
        return (0, $is1Vq.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $0c242de99b213480$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $is1Vq.splitSignature)(signature);
    const rs = {
        r: (0, $is1Vq.arrayify)(sig.r),
        s: (0, $is1Vq.arrayify)(sig.s)
    };
    return "0x" + $0c242de99b213480$var$getCurve().recoverPubKey((0, $is1Vq.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $0c242de99b213480$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $is1Vq.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $0c242de99b213480$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $0c242de99b213480$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $is1Vq.hexlify)(bytes);
        return "0x" + $0c242de99b213480$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $is1Vq.hexlify)(bytes);
        return "0x" + $0c242de99b213480$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $0c242de99b213480$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("1VNLf", function(module, exports) {

$parcel$export(module.exports, "EC", () => $1681b6d145b70a12$export$129fe12d32abc311);

var $1Ges2 = parcelRequire("1Ges2");

var $2peZt = parcelRequire("2peZt");
var $1681b6d145b70a12$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $1681b6d145b70a12$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $1681b6d145b70a12$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $1681b6d145b70a12$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $1681b6d145b70a12$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $1681b6d145b70a12$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $1681b6d145b70a12$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $1681b6d145b70a12$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $1681b6d145b70a12$var$minimalisticAssert = $1681b6d145b70a12$var$assert;
function $1681b6d145b70a12$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$1681b6d145b70a12$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $1681b6d145b70a12$var$utils_1 = $1681b6d145b70a12$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $1681b6d145b70a12$var$utils_1$1 = $1681b6d145b70a12$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $1681b6d145b70a12$var$minimalisticAssert;
    utils.toArray = $1681b6d145b70a12$var$utils_1.toArray;
    utils.zero2 = $1681b6d145b70a12$var$utils_1.zero2;
    utils.toHex = $1681b6d145b70a12$var$utils_1.toHex;
    utils.encode = $1681b6d145b70a12$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $1681b6d145b70a12$var$getNAF = $1681b6d145b70a12$var$utils_1$1.getNAF;
var $1681b6d145b70a12$var$getJSF = $1681b6d145b70a12$var$utils_1$1.getJSF;
var $1681b6d145b70a12$var$assert$1 = $1681b6d145b70a12$var$utils_1$1.assert;
function $1681b6d145b70a12$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $1681b6d145b70a12$var$base = $1681b6d145b70a12$var$BaseCurve;
$1681b6d145b70a12$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$1681b6d145b70a12$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$1681b6d145b70a12$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $1681b6d145b70a12$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $1681b6d145b70a12$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$1681b6d145b70a12$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $1681b6d145b70a12$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $1681b6d145b70a12$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$1681b6d145b70a12$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $1681b6d145b70a12$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $1681b6d145b70a12$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $1681b6d145b70a12$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $1681b6d145b70a12$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$1681b6d145b70a12$var$BaseCurve.BasePoint = $1681b6d145b70a12$var$BasePoint;
$1681b6d145b70a12$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$1681b6d145b70a12$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$1681b6d145b70a12$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $1681b6d145b70a12$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $1681b6d145b70a12$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $1681b6d145b70a12$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$1681b6d145b70a12$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$1681b6d145b70a12$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$1681b6d145b70a12$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $1681b6d145b70a12$var$utils_1$1.encode(this._encode(compact), enc);
};
$1681b6d145b70a12$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$1681b6d145b70a12$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$1681b6d145b70a12$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$1681b6d145b70a12$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$1681b6d145b70a12$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$1681b6d145b70a12$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $1681b6d145b70a12$var$inherits_browser = $1681b6d145b70a12$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $1681b6d145b70a12$var$assert$2 = $1681b6d145b70a12$var$utils_1$1.assert;
function $1681b6d145b70a12$var$ShortCurve(conf) {
    $1681b6d145b70a12$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$1681b6d145b70a12$var$inherits_browser($1681b6d145b70a12$var$ShortCurve, $1681b6d145b70a12$var$base);
var $1681b6d145b70a12$var$short_1 = $1681b6d145b70a12$var$ShortCurve;
$1681b6d145b70a12$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $1681b6d145b70a12$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$1681b6d145b70a12$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$1681b6d145b70a12$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$1681b6d145b70a12$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$1681b6d145b70a12$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$1681b6d145b70a12$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$1681b6d145b70a12$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $1681b6d145b70a12$var$Point(curve, x, y, isRed) {
    $1681b6d145b70a12$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$1681b6d145b70a12$var$inherits_browser($1681b6d145b70a12$var$Point, $1681b6d145b70a12$var$base.BasePoint);
$1681b6d145b70a12$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $1681b6d145b70a12$var$Point(this, x, y, isRed);
};
$1681b6d145b70a12$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $1681b6d145b70a12$var$Point.fromJSON(this, obj, red);
};
$1681b6d145b70a12$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$1681b6d145b70a12$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$1681b6d145b70a12$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$1681b6d145b70a12$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$1681b6d145b70a12$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$1681b6d145b70a12$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1681b6d145b70a12$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$1681b6d145b70a12$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$1681b6d145b70a12$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$1681b6d145b70a12$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$1681b6d145b70a12$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$1681b6d145b70a12$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$1681b6d145b70a12$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$1681b6d145b70a12$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$1681b6d145b70a12$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $1681b6d145b70a12$var$JPoint(curve, x, y, z) {
    $1681b6d145b70a12$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$1681b6d145b70a12$var$inherits_browser($1681b6d145b70a12$var$JPoint, $1681b6d145b70a12$var$base.BasePoint);
$1681b6d145b70a12$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $1681b6d145b70a12$var$JPoint(this, x, y, z);
};
$1681b6d145b70a12$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$1681b6d145b70a12$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$1681b6d145b70a12$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$1681b6d145b70a12$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$1681b6d145b70a12$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$1681b6d145b70a12$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$1681b6d145b70a12$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$1681b6d145b70a12$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$1681b6d145b70a12$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$1681b6d145b70a12$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $1681b6d145b70a12$var$curve_1 = $1681b6d145b70a12$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $1681b6d145b70a12$var$base;
    curve.short = $1681b6d145b70a12$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $1681b6d145b70a12$var$curves_1 = $1681b6d145b70a12$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $1681b6d145b70a12$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $1681b6d145b70a12$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $1681b6d145b70a12$var$curve_1.edwards(options);
        else this.curve = new $1681b6d145b70a12$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $1681b6d145b70a12$var$HmacDRBG(options) {
    if (!(this instanceof $1681b6d145b70a12$var$HmacDRBG)) return new $1681b6d145b70a12$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $1681b6d145b70a12$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $1681b6d145b70a12$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $1681b6d145b70a12$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $1681b6d145b70a12$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $1681b6d145b70a12$var$hmacDrbg = $1681b6d145b70a12$var$HmacDRBG;
$1681b6d145b70a12$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$1681b6d145b70a12$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).hmac(this.hash, this.K);
};
$1681b6d145b70a12$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$1681b6d145b70a12$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $1681b6d145b70a12$var$utils_1.toArray(entropy, entropyEnc);
    add = $1681b6d145b70a12$var$utils_1.toArray(add, addEnc);
    $1681b6d145b70a12$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$1681b6d145b70a12$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $1681b6d145b70a12$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $1681b6d145b70a12$var$utils_1.encode(res, enc);
};
"use strict";
var $1681b6d145b70a12$var$assert$3 = $1681b6d145b70a12$var$utils_1$1.assert;
function $1681b6d145b70a12$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $1681b6d145b70a12$var$key = $1681b6d145b70a12$var$KeyPair;
$1681b6d145b70a12$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $1681b6d145b70a12$var$KeyPair) return pub;
    return new $1681b6d145b70a12$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$1681b6d145b70a12$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $1681b6d145b70a12$var$KeyPair) return priv;
    return new $1681b6d145b70a12$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$1681b6d145b70a12$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$1681b6d145b70a12$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$1681b6d145b70a12$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$1681b6d145b70a12$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$1681b6d145b70a12$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $1681b6d145b70a12$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $1681b6d145b70a12$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$1681b6d145b70a12$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $1681b6d145b70a12$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$1681b6d145b70a12$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$1681b6d145b70a12$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$1681b6d145b70a12$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $1681b6d145b70a12$var$assert$4 = $1681b6d145b70a12$var$utils_1$1.assert;
function $1681b6d145b70a12$var$Signature(options, enc) {
    if (options instanceof $1681b6d145b70a12$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $1681b6d145b70a12$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $1681b6d145b70a12$var$signature = $1681b6d145b70a12$var$Signature;
function $1681b6d145b70a12$var$Position() {
    this.place = 0;
}
function $1681b6d145b70a12$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $1681b6d145b70a12$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$1681b6d145b70a12$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $1681b6d145b70a12$var$utils_1$1.toArray(data, enc);
    var p = new $1681b6d145b70a12$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $1681b6d145b70a12$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $1681b6d145b70a12$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $1681b6d145b70a12$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(s);
    this.recoveryParam = null;
    return true;
};
function $1681b6d145b70a12$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$1681b6d145b70a12$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $1681b6d145b70a12$var$rmPadding(r);
    s = $1681b6d145b70a12$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $1681b6d145b70a12$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $1681b6d145b70a12$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $1681b6d145b70a12$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $1681b6d145b70a12$var$utils_1$1.encode(res, enc);
};
"use strict";
var $1681b6d145b70a12$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $1681b6d145b70a12$var$assert$5 = $1681b6d145b70a12$var$utils_1$1.assert;
function $1681b6d145b70a12$var$EC(options) {
    if (!(this instanceof $1681b6d145b70a12$var$EC)) return new $1681b6d145b70a12$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $1681b6d145b70a12$var$assert$5(Object.prototype.hasOwnProperty.call($1681b6d145b70a12$var$curves_1, options), "Unknown curve " + options);
        options = $1681b6d145b70a12$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $1681b6d145b70a12$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $1681b6d145b70a12$var$ec = $1681b6d145b70a12$var$EC;
$1681b6d145b70a12$var$EC.prototype.keyPair = function keyPair(options) {
    return new $1681b6d145b70a12$var$key(this, options);
};
$1681b6d145b70a12$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $1681b6d145b70a12$var$key.fromPrivate(this, priv, enc);
};
$1681b6d145b70a12$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $1681b6d145b70a12$var$key.fromPublic(this, pub, enc);
};
$1681b6d145b70a12$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $1681b6d145b70a12$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $1681b6d145b70a12$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$1681b6d145b70a12$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$1681b6d145b70a12$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $1681b6d145b70a12$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $1681b6d145b70a12$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$1681b6d145b70a12$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $1681b6d145b70a12$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$1681b6d145b70a12$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $1681b6d145b70a12$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $1681b6d145b70a12$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($1Ges2)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$1681b6d145b70a12$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $1681b6d145b70a12$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $1681b6d145b70a12$var$elliptic_1 = $1681b6d145b70a12$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $1681b6d145b70a12$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $1681b6d145b70a12$var$curve_1;
    elliptic.curves = $1681b6d145b70a12$var$curves_1;
    // Protocols
    elliptic.ec = $1681b6d145b70a12$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $1681b6d145b70a12$export$129fe12d32abc311 = $1681b6d145b70a12$var$elliptic_1.ec;

});
parcelRegister("1Ges2", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("2peZt", function(module, exports) {
var $1c098b6199ad053c$var$hash = module.exports;

$1c098b6199ad053c$var$hash.utils = (parcelRequire("04Py3"));

$1c098b6199ad053c$var$hash.common = (parcelRequire("3z8eW"));

$1c098b6199ad053c$var$hash.sha = (parcelRequire("8QUF4"));

$1c098b6199ad053c$var$hash.ripemd = (parcelRequire("49Xj4"));

$1c098b6199ad053c$var$hash.hmac = (parcelRequire("1uGyH"));
// Proxy hash functions to the main object
$1c098b6199ad053c$var$hash.sha1 = $1c098b6199ad053c$var$hash.sha.sha1;
$1c098b6199ad053c$var$hash.sha256 = $1c098b6199ad053c$var$hash.sha.sha256;
$1c098b6199ad053c$var$hash.sha224 = $1c098b6199ad053c$var$hash.sha.sha224;
$1c098b6199ad053c$var$hash.sha384 = $1c098b6199ad053c$var$hash.sha.sha384;
$1c098b6199ad053c$var$hash.sha512 = $1c098b6199ad053c$var$hash.sha.sha512;
$1c098b6199ad053c$var$hash.ripemd160 = $1c098b6199ad053c$var$hash.ripemd.ripemd160;

});
parcelRegister("04Py3", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $00e85c46ac9d7406$export$69f1b2dcda23c5f8, (v) => $00e85c46ac9d7406$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $00e85c46ac9d7406$export$45b10814cc054894, (v) => $00e85c46ac9d7406$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $00e85c46ac9d7406$export$7ea66e3774a60b67, (v) => $00e85c46ac9d7406$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $00e85c46ac9d7406$export$34a52f00f601f6f1, (v) => $00e85c46ac9d7406$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $00e85c46ac9d7406$export$812b0cbd5e8a72ab, (v) => $00e85c46ac9d7406$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $00e85c46ac9d7406$export$f24f9e11d63bb314, (v) => $00e85c46ac9d7406$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $00e85c46ac9d7406$export$b71357c7e07ca1f1, (v) => $00e85c46ac9d7406$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $00e85c46ac9d7406$export$2e58a4b541fdcbe8, (v) => $00e85c46ac9d7406$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $00e85c46ac9d7406$export$183b950bde9faab8, (v) => $00e85c46ac9d7406$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $00e85c46ac9d7406$export$4785c77169fea59e, (v) => $00e85c46ac9d7406$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $00e85c46ac9d7406$export$242a185dfcffac5b, (v) => $00e85c46ac9d7406$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $00e85c46ac9d7406$export$58c04ae0ae31877d, (v) => $00e85c46ac9d7406$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $00e85c46ac9d7406$export$d058ca695f8c6f11, (v) => $00e85c46ac9d7406$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $00e85c46ac9d7406$export$a1efd7fc3e986367, (v) => $00e85c46ac9d7406$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $00e85c46ac9d7406$export$bbfea4a2b5abaab4, (v) => $00e85c46ac9d7406$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $00e85c46ac9d7406$export$97ad4afc7de86152, (v) => $00e85c46ac9d7406$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $00e85c46ac9d7406$export$ce4673d9a79f6a4b, (v) => $00e85c46ac9d7406$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $00e85c46ac9d7406$export$786cc99fc6eedc0b, (v) => $00e85c46ac9d7406$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $00e85c46ac9d7406$export$45c59b9a1848dd0, (v) => $00e85c46ac9d7406$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $00e85c46ac9d7406$export$50d8f613e76d3034, (v) => $00e85c46ac9d7406$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $00e85c46ac9d7406$export$b8e83683c60ee162, (v) => $00e85c46ac9d7406$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $00e85c46ac9d7406$export$aeeb51790d1bcc4a, (v) => $00e85c46ac9d7406$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $00e85c46ac9d7406$export$bb7c616f719ad9c, (v) => $00e85c46ac9d7406$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $00e85c46ac9d7406$export$4d63290824f9d7df, (v) => $00e85c46ac9d7406$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $00e85c46ac9d7406$export$2f64ceb90ef28ea1, (v) => $00e85c46ac9d7406$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $00e85c46ac9d7406$export$8d2089d465f6d10d, (v) => $00e85c46ac9d7406$export$8d2089d465f6d10d = v);
var $00e85c46ac9d7406$export$69f1b2dcda23c5f8;
var $00e85c46ac9d7406$export$45b10814cc054894;
var $00e85c46ac9d7406$export$7ea66e3774a60b67;
var $00e85c46ac9d7406$export$34a52f00f601f6f1;
var $00e85c46ac9d7406$export$812b0cbd5e8a72ab;
var $00e85c46ac9d7406$export$f24f9e11d63bb314;
var $00e85c46ac9d7406$export$b71357c7e07ca1f1;
var $00e85c46ac9d7406$export$2e58a4b541fdcbe8;
var $00e85c46ac9d7406$export$183b950bde9faab8;
var $00e85c46ac9d7406$export$4785c77169fea59e;
var $00e85c46ac9d7406$export$242a185dfcffac5b;
var $00e85c46ac9d7406$export$58c04ae0ae31877d;
var $00e85c46ac9d7406$export$d058ca695f8c6f11;
var $00e85c46ac9d7406$export$a1efd7fc3e986367;
var $00e85c46ac9d7406$export$bbfea4a2b5abaab4;
var $00e85c46ac9d7406$export$97ad4afc7de86152;
var $00e85c46ac9d7406$export$ce4673d9a79f6a4b;
var $00e85c46ac9d7406$export$786cc99fc6eedc0b;
var $00e85c46ac9d7406$export$45c59b9a1848dd0;
var $00e85c46ac9d7406$export$50d8f613e76d3034;
var $00e85c46ac9d7406$export$b8e83683c60ee162;
var $00e85c46ac9d7406$export$aeeb51790d1bcc4a;
var $00e85c46ac9d7406$export$bb7c616f719ad9c;
var $00e85c46ac9d7406$export$4d63290824f9d7df;
var $00e85c46ac9d7406$export$2f64ceb90ef28ea1;
var $00e85c46ac9d7406$export$8d2089d465f6d10d;
"use strict";

var $kAZVs = parcelRequire("kAZVs");

var $lfl9G = parcelRequire("lfl9G");
$00e85c46ac9d7406$export$69f1b2dcda23c5f8 = $lfl9G;
function $00e85c46ac9d7406$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $00e85c46ac9d7406$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($00e85c46ac9d7406$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$00e85c46ac9d7406$export$45b10814cc054894 = $00e85c46ac9d7406$var$toArray;
function $00e85c46ac9d7406$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $00e85c46ac9d7406$var$zero2(msg[i].toString(16));
    return res;
}
$00e85c46ac9d7406$export$7ea66e3774a60b67 = $00e85c46ac9d7406$var$toHex;
function $00e85c46ac9d7406$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$00e85c46ac9d7406$export$34a52f00f601f6f1 = $00e85c46ac9d7406$var$htonl;
function $00e85c46ac9d7406$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $00e85c46ac9d7406$var$htonl(w);
        res += $00e85c46ac9d7406$var$zero8(w.toString(16));
    }
    return res;
}
$00e85c46ac9d7406$export$812b0cbd5e8a72ab = $00e85c46ac9d7406$var$toHex32;
function $00e85c46ac9d7406$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$00e85c46ac9d7406$export$f24f9e11d63bb314 = $00e85c46ac9d7406$var$zero2;
function $00e85c46ac9d7406$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$00e85c46ac9d7406$export$b71357c7e07ca1f1 = $00e85c46ac9d7406$var$zero8;
function $00e85c46ac9d7406$var$join32(msg, start, end, endian) {
    var len = end - start;
    $kAZVs(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$00e85c46ac9d7406$export$2e58a4b541fdcbe8 = $00e85c46ac9d7406$var$join32;
function $00e85c46ac9d7406$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$00e85c46ac9d7406$export$183b950bde9faab8 = $00e85c46ac9d7406$var$split32;
function $00e85c46ac9d7406$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$00e85c46ac9d7406$export$4785c77169fea59e = $00e85c46ac9d7406$var$rotr32;
function $00e85c46ac9d7406$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$00e85c46ac9d7406$export$242a185dfcffac5b = $00e85c46ac9d7406$var$rotl32;
function $00e85c46ac9d7406$var$sum32(a, b) {
    return a + b >>> 0;
}
$00e85c46ac9d7406$export$58c04ae0ae31877d = $00e85c46ac9d7406$var$sum32;
function $00e85c46ac9d7406$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$00e85c46ac9d7406$export$d058ca695f8c6f11 = $00e85c46ac9d7406$var$sum32_3;
function $00e85c46ac9d7406$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$00e85c46ac9d7406$export$a1efd7fc3e986367 = $00e85c46ac9d7406$var$sum32_4;
function $00e85c46ac9d7406$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$00e85c46ac9d7406$export$bbfea4a2b5abaab4 = $00e85c46ac9d7406$var$sum32_5;
function $00e85c46ac9d7406$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$00e85c46ac9d7406$export$97ad4afc7de86152 = $00e85c46ac9d7406$var$sum64;
function $00e85c46ac9d7406$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$00e85c46ac9d7406$export$ce4673d9a79f6a4b = $00e85c46ac9d7406$var$sum64_hi;
function $00e85c46ac9d7406$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$00e85c46ac9d7406$export$786cc99fc6eedc0b = $00e85c46ac9d7406$var$sum64_lo;
function $00e85c46ac9d7406$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$00e85c46ac9d7406$export$45c59b9a1848dd0 = $00e85c46ac9d7406$var$sum64_4_hi;
function $00e85c46ac9d7406$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$00e85c46ac9d7406$export$50d8f613e76d3034 = $00e85c46ac9d7406$var$sum64_4_lo;
function $00e85c46ac9d7406$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$00e85c46ac9d7406$export$b8e83683c60ee162 = $00e85c46ac9d7406$var$sum64_5_hi;
function $00e85c46ac9d7406$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$00e85c46ac9d7406$export$aeeb51790d1bcc4a = $00e85c46ac9d7406$var$sum64_5_lo;
function $00e85c46ac9d7406$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$00e85c46ac9d7406$export$bb7c616f719ad9c = $00e85c46ac9d7406$var$rotr64_hi;
function $00e85c46ac9d7406$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$00e85c46ac9d7406$export$4d63290824f9d7df = $00e85c46ac9d7406$var$rotr64_lo;
function $00e85c46ac9d7406$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$00e85c46ac9d7406$export$2f64ceb90ef28ea1 = $00e85c46ac9d7406$var$shr64_hi;
function $00e85c46ac9d7406$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$00e85c46ac9d7406$export$8d2089d465f6d10d = $00e85c46ac9d7406$var$shr64_lo;

});
parcelRegister("kAZVs", function(module, exports) {
module.exports = $efe734983738216b$var$assert;
function $efe734983738216b$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$efe734983738216b$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("lfl9G", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("3z8eW", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $298b084516962de0$export$8687658379b577e6, (v) => $298b084516962de0$export$8687658379b577e6 = v);
var $298b084516962de0$export$8687658379b577e6;
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $kAZVs = parcelRequire("kAZVs");
function $298b084516962de0$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$298b084516962de0$export$8687658379b577e6 = $298b084516962de0$var$BlockHash;
$298b084516962de0$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $04Py3.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $04Py3.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$298b084516962de0$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $kAZVs(this.pending === null);
    return this._digest(enc);
};
$298b084516962de0$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("8QUF4", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $671f21d6ba736bbe$export$5091bdda49ba90f5, (v) => $671f21d6ba736bbe$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $671f21d6ba736bbe$export$97b70509d4e397ea, (v) => $671f21d6ba736bbe$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $671f21d6ba736bbe$export$bced8d2aada2d1c9, (v) => $671f21d6ba736bbe$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $671f21d6ba736bbe$export$612d47d55dedde45, (v) => $671f21d6ba736bbe$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $671f21d6ba736bbe$export$a888d2532e6dc7bb, (v) => $671f21d6ba736bbe$export$a888d2532e6dc7bb = v);
var $671f21d6ba736bbe$export$5091bdda49ba90f5;
var $671f21d6ba736bbe$export$97b70509d4e397ea;
var $671f21d6ba736bbe$export$bced8d2aada2d1c9;
var $671f21d6ba736bbe$export$612d47d55dedde45;
var $671f21d6ba736bbe$export$a888d2532e6dc7bb;
"use strict";

$671f21d6ba736bbe$export$5091bdda49ba90f5 = (parcelRequire("aUKMd"));

$671f21d6ba736bbe$export$97b70509d4e397ea = (parcelRequire("a7cZO"));

$671f21d6ba736bbe$export$bced8d2aada2d1c9 = (parcelRequire("hY5hY"));

$671f21d6ba736bbe$export$612d47d55dedde45 = (parcelRequire("kFfOa"));

$671f21d6ba736bbe$export$a888d2532e6dc7bb = (parcelRequire("J0PGZ"));

});
parcelRegister("aUKMd", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $3z8eW = parcelRequire("3z8eW");

var $b3u7b = parcelRequire("b3u7b");
var $7f236b335a285ca4$var$rotl32 = $04Py3.rotl32;
var $7f236b335a285ca4$var$sum32 = $04Py3.sum32;
var $7f236b335a285ca4$var$sum32_5 = $04Py3.sum32_5;
var $7f236b335a285ca4$var$ft_1 = $b3u7b.ft_1;
var $7f236b335a285ca4$var$BlockHash = $3z8eW.BlockHash;
var $7f236b335a285ca4$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $7f236b335a285ca4$var$SHA1() {
    if (!(this instanceof $7f236b335a285ca4$var$SHA1)) return new $7f236b335a285ca4$var$SHA1();
    $7f236b335a285ca4$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$04Py3.inherits($7f236b335a285ca4$var$SHA1, $7f236b335a285ca4$var$BlockHash);
module.exports = $7f236b335a285ca4$var$SHA1;
$7f236b335a285ca4$var$SHA1.blockSize = 512;
$7f236b335a285ca4$var$SHA1.outSize = 160;
$7f236b335a285ca4$var$SHA1.hmacStrength = 80;
$7f236b335a285ca4$var$SHA1.padLength = 64;
$7f236b335a285ca4$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $7f236b335a285ca4$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $7f236b335a285ca4$var$sum32_5($7f236b335a285ca4$var$rotl32(a, 5), $7f236b335a285ca4$var$ft_1(s, b, c, d), e, W[i], $7f236b335a285ca4$var$sha1_K[s]);
        e = d;
        d = c;
        c = $7f236b335a285ca4$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $7f236b335a285ca4$var$sum32(this.h[0], a);
    this.h[1] = $7f236b335a285ca4$var$sum32(this.h[1], b);
    this.h[2] = $7f236b335a285ca4$var$sum32(this.h[2], c);
    this.h[3] = $7f236b335a285ca4$var$sum32(this.h[3], d);
    this.h[4] = $7f236b335a285ca4$var$sum32(this.h[4], e);
};
$7f236b335a285ca4$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $04Py3.toHex32(this.h, "big");
    else return $04Py3.split32(this.h, "big");
};

});
parcelRegister("b3u7b", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $80c755b5d9f82890$export$5a92649d7ddb9f63, (v) => $80c755b5d9f82890$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $80c755b5d9f82890$export$c6d0d020c3a6269, (v) => $80c755b5d9f82890$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $80c755b5d9f82890$export$eb90c27fca05f956, (v) => $80c755b5d9f82890$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $80c755b5d9f82890$export$14a4a98e063b1999, (v) => $80c755b5d9f82890$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $80c755b5d9f82890$export$d20cecfa1564c686, (v) => $80c755b5d9f82890$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $80c755b5d9f82890$export$44fd472a12fc6db, (v) => $80c755b5d9f82890$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $80c755b5d9f82890$export$1ed238bb6ea1dd47, (v) => $80c755b5d9f82890$export$1ed238bb6ea1dd47 = v);
var $80c755b5d9f82890$export$5a92649d7ddb9f63;
var $80c755b5d9f82890$export$c6d0d020c3a6269;
var $80c755b5d9f82890$export$eb90c27fca05f956;
var $80c755b5d9f82890$export$cc992891a14496a1;
var $80c755b5d9f82890$export$14a4a98e063b1999;
var $80c755b5d9f82890$export$d20cecfa1564c686;
var $80c755b5d9f82890$export$44fd472a12fc6db;
var $80c755b5d9f82890$export$1ed238bb6ea1dd47;
"use strict";

var $04Py3 = parcelRequire("04Py3");
var $80c755b5d9f82890$var$rotr32 = $04Py3.rotr32;
function $80c755b5d9f82890$var$ft_1(s, x, y, z) {
    if (s === 0) return $80c755b5d9f82890$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $80c755b5d9f82890$var$p32(x, y, z);
    if (s === 2) return $80c755b5d9f82890$var$maj32(x, y, z);
}
$80c755b5d9f82890$export$5a92649d7ddb9f63 = $80c755b5d9f82890$var$ft_1;
function $80c755b5d9f82890$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$80c755b5d9f82890$export$c6d0d020c3a6269 = $80c755b5d9f82890$var$ch32;
function $80c755b5d9f82890$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$80c755b5d9f82890$export$eb90c27fca05f956 = $80c755b5d9f82890$var$maj32;
function $80c755b5d9f82890$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$80c755b5d9f82890$export$cc992891a14496a1 = $80c755b5d9f82890$var$p32;
function $80c755b5d9f82890$var$s0_256(x) {
    return $80c755b5d9f82890$var$rotr32(x, 2) ^ $80c755b5d9f82890$var$rotr32(x, 13) ^ $80c755b5d9f82890$var$rotr32(x, 22);
}
$80c755b5d9f82890$export$14a4a98e063b1999 = $80c755b5d9f82890$var$s0_256;
function $80c755b5d9f82890$var$s1_256(x) {
    return $80c755b5d9f82890$var$rotr32(x, 6) ^ $80c755b5d9f82890$var$rotr32(x, 11) ^ $80c755b5d9f82890$var$rotr32(x, 25);
}
$80c755b5d9f82890$export$d20cecfa1564c686 = $80c755b5d9f82890$var$s1_256;
function $80c755b5d9f82890$var$g0_256(x) {
    return $80c755b5d9f82890$var$rotr32(x, 7) ^ $80c755b5d9f82890$var$rotr32(x, 18) ^ x >>> 3;
}
$80c755b5d9f82890$export$44fd472a12fc6db = $80c755b5d9f82890$var$g0_256;
function $80c755b5d9f82890$var$g1_256(x) {
    return $80c755b5d9f82890$var$rotr32(x, 17) ^ $80c755b5d9f82890$var$rotr32(x, 19) ^ x >>> 10;
}
$80c755b5d9f82890$export$1ed238bb6ea1dd47 = $80c755b5d9f82890$var$g1_256;

});


parcelRegister("a7cZO", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $hY5hY = parcelRequire("hY5hY");
function $75d4a388934e8562$var$SHA224() {
    if (!(this instanceof $75d4a388934e8562$var$SHA224)) return new $75d4a388934e8562$var$SHA224();
    $hY5hY.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$04Py3.inherits($75d4a388934e8562$var$SHA224, $hY5hY);
module.exports = $75d4a388934e8562$var$SHA224;
$75d4a388934e8562$var$SHA224.blockSize = 512;
$75d4a388934e8562$var$SHA224.outSize = 224;
$75d4a388934e8562$var$SHA224.hmacStrength = 192;
$75d4a388934e8562$var$SHA224.padLength = 64;
$75d4a388934e8562$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $04Py3.toHex32(this.h.slice(0, 7), "big");
    else return $04Py3.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("hY5hY", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $3z8eW = parcelRequire("3z8eW");

var $b3u7b = parcelRequire("b3u7b");

var $kAZVs = parcelRequire("kAZVs");
var $d14c2488bd17700b$var$sum32 = $04Py3.sum32;
var $d14c2488bd17700b$var$sum32_4 = $04Py3.sum32_4;
var $d14c2488bd17700b$var$sum32_5 = $04Py3.sum32_5;
var $d14c2488bd17700b$var$ch32 = $b3u7b.ch32;
var $d14c2488bd17700b$var$maj32 = $b3u7b.maj32;
var $d14c2488bd17700b$var$s0_256 = $b3u7b.s0_256;
var $d14c2488bd17700b$var$s1_256 = $b3u7b.s1_256;
var $d14c2488bd17700b$var$g0_256 = $b3u7b.g0_256;
var $d14c2488bd17700b$var$g1_256 = $b3u7b.g1_256;
var $d14c2488bd17700b$var$BlockHash = $3z8eW.BlockHash;
var $d14c2488bd17700b$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $d14c2488bd17700b$var$SHA256() {
    if (!(this instanceof $d14c2488bd17700b$var$SHA256)) return new $d14c2488bd17700b$var$SHA256();
    $d14c2488bd17700b$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $d14c2488bd17700b$var$sha256_K;
    this.W = new Array(64);
}
$04Py3.inherits($d14c2488bd17700b$var$SHA256, $d14c2488bd17700b$var$BlockHash);
module.exports = $d14c2488bd17700b$var$SHA256;
$d14c2488bd17700b$var$SHA256.blockSize = 512;
$d14c2488bd17700b$var$SHA256.outSize = 256;
$d14c2488bd17700b$var$SHA256.hmacStrength = 192;
$d14c2488bd17700b$var$SHA256.padLength = 64;
$d14c2488bd17700b$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $d14c2488bd17700b$var$sum32_4($d14c2488bd17700b$var$g1_256(W[i - 2]), W[i - 7], $d14c2488bd17700b$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $kAZVs(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $d14c2488bd17700b$var$sum32_5(h, $d14c2488bd17700b$var$s1_256(e), $d14c2488bd17700b$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $d14c2488bd17700b$var$sum32($d14c2488bd17700b$var$s0_256(a), $d14c2488bd17700b$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $d14c2488bd17700b$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $d14c2488bd17700b$var$sum32(T1, T2);
    }
    this.h[0] = $d14c2488bd17700b$var$sum32(this.h[0], a);
    this.h[1] = $d14c2488bd17700b$var$sum32(this.h[1], b);
    this.h[2] = $d14c2488bd17700b$var$sum32(this.h[2], c);
    this.h[3] = $d14c2488bd17700b$var$sum32(this.h[3], d);
    this.h[4] = $d14c2488bd17700b$var$sum32(this.h[4], e);
    this.h[5] = $d14c2488bd17700b$var$sum32(this.h[5], f);
    this.h[6] = $d14c2488bd17700b$var$sum32(this.h[6], g);
    this.h[7] = $d14c2488bd17700b$var$sum32(this.h[7], h);
};
$d14c2488bd17700b$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $04Py3.toHex32(this.h, "big");
    else return $04Py3.split32(this.h, "big");
};

});


parcelRegister("kFfOa", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $J0PGZ = parcelRequire("J0PGZ");
function $f0b3e621537424d8$var$SHA384() {
    if (!(this instanceof $f0b3e621537424d8$var$SHA384)) return new $f0b3e621537424d8$var$SHA384();
    $J0PGZ.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$04Py3.inherits($f0b3e621537424d8$var$SHA384, $J0PGZ);
module.exports = $f0b3e621537424d8$var$SHA384;
$f0b3e621537424d8$var$SHA384.blockSize = 1024;
$f0b3e621537424d8$var$SHA384.outSize = 384;
$f0b3e621537424d8$var$SHA384.hmacStrength = 192;
$f0b3e621537424d8$var$SHA384.padLength = 128;
$f0b3e621537424d8$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $04Py3.toHex32(this.h.slice(0, 12), "big");
    else return $04Py3.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("J0PGZ", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $3z8eW = parcelRequire("3z8eW");

var $kAZVs = parcelRequire("kAZVs");
var $0874d9734c7c3b89$var$rotr64_hi = $04Py3.rotr64_hi;
var $0874d9734c7c3b89$var$rotr64_lo = $04Py3.rotr64_lo;
var $0874d9734c7c3b89$var$shr64_hi = $04Py3.shr64_hi;
var $0874d9734c7c3b89$var$shr64_lo = $04Py3.shr64_lo;
var $0874d9734c7c3b89$var$sum64 = $04Py3.sum64;
var $0874d9734c7c3b89$var$sum64_hi = $04Py3.sum64_hi;
var $0874d9734c7c3b89$var$sum64_lo = $04Py3.sum64_lo;
var $0874d9734c7c3b89$var$sum64_4_hi = $04Py3.sum64_4_hi;
var $0874d9734c7c3b89$var$sum64_4_lo = $04Py3.sum64_4_lo;
var $0874d9734c7c3b89$var$sum64_5_hi = $04Py3.sum64_5_hi;
var $0874d9734c7c3b89$var$sum64_5_lo = $04Py3.sum64_5_lo;
var $0874d9734c7c3b89$var$BlockHash = $3z8eW.BlockHash;
var $0874d9734c7c3b89$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $0874d9734c7c3b89$var$SHA512() {
    if (!(this instanceof $0874d9734c7c3b89$var$SHA512)) return new $0874d9734c7c3b89$var$SHA512();
    $0874d9734c7c3b89$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $0874d9734c7c3b89$var$sha512_K;
    this.W = new Array(160);
}
$04Py3.inherits($0874d9734c7c3b89$var$SHA512, $0874d9734c7c3b89$var$BlockHash);
module.exports = $0874d9734c7c3b89$var$SHA512;
$0874d9734c7c3b89$var$SHA512.blockSize = 1024;
$0874d9734c7c3b89$var$SHA512.outSize = 512;
$0874d9734c7c3b89$var$SHA512.hmacStrength = 192;
$0874d9734c7c3b89$var$SHA512.padLength = 128;
$0874d9734c7c3b89$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $0874d9734c7c3b89$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $0874d9734c7c3b89$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $0874d9734c7c3b89$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $0874d9734c7c3b89$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $0874d9734c7c3b89$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $0874d9734c7c3b89$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$0874d9734c7c3b89$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $kAZVs(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $0874d9734c7c3b89$var$s1_512_hi(eh, el);
        var c1_lo = $0874d9734c7c3b89$var$s1_512_lo(eh, el);
        var c2_hi = $0874d9734c7c3b89$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $0874d9734c7c3b89$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $0874d9734c7c3b89$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $0874d9734c7c3b89$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $0874d9734c7c3b89$var$s0_512_hi(ah, al);
        c0_lo = $0874d9734c7c3b89$var$s0_512_lo(ah, al);
        c1_hi = $0874d9734c7c3b89$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $0874d9734c7c3b89$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $0874d9734c7c3b89$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $0874d9734c7c3b89$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $0874d9734c7c3b89$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $0874d9734c7c3b89$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $0874d9734c7c3b89$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $0874d9734c7c3b89$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $0874d9734c7c3b89$var$sum64(this.h, 0, ah, al);
    $0874d9734c7c3b89$var$sum64(this.h, 2, bh, bl);
    $0874d9734c7c3b89$var$sum64(this.h, 4, ch, cl);
    $0874d9734c7c3b89$var$sum64(this.h, 6, dh, dl);
    $0874d9734c7c3b89$var$sum64(this.h, 8, eh, el);
    $0874d9734c7c3b89$var$sum64(this.h, 10, fh, fl);
    $0874d9734c7c3b89$var$sum64(this.h, 12, gh, gl);
    $0874d9734c7c3b89$var$sum64(this.h, 14, hh, hl);
};
$0874d9734c7c3b89$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $04Py3.toHex32(this.h, "big");
    else return $04Py3.split32(this.h, "big");
};
function $0874d9734c7c3b89$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$s0_512_hi(xh, xl) {
    var c0_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $0874d9734c7c3b89$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $0874d9734c7c3b89$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$s0_512_lo(xh, xl) {
    var c0_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $0874d9734c7c3b89$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $0874d9734c7c3b89$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$s1_512_hi(xh, xl) {
    var c0_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $0874d9734c7c3b89$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$s1_512_lo(xh, xl) {
    var c0_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $0874d9734c7c3b89$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$g0_512_hi(xh, xl) {
    var c0_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $0874d9734c7c3b89$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$g0_512_lo(xh, xl) {
    var c0_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $0874d9734c7c3b89$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$g1_512_hi(xh, xl) {
    var c0_hi = $0874d9734c7c3b89$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $0874d9734c7c3b89$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $0874d9734c7c3b89$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $0874d9734c7c3b89$var$g1_512_lo(xh, xl) {
    var c0_lo = $0874d9734c7c3b89$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $0874d9734c7c3b89$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $0874d9734c7c3b89$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("49Xj4", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $307601bb4f54b1bd$export$d1cea0ee4e3f0d3e, (v) => $307601bb4f54b1bd$export$d1cea0ee4e3f0d3e = v);
var $307601bb4f54b1bd$export$d1cea0ee4e3f0d3e;
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $3z8eW = parcelRequire("3z8eW");
var $307601bb4f54b1bd$var$rotl32 = $04Py3.rotl32;
var $307601bb4f54b1bd$var$sum32 = $04Py3.sum32;
var $307601bb4f54b1bd$var$sum32_3 = $04Py3.sum32_3;
var $307601bb4f54b1bd$var$sum32_4 = $04Py3.sum32_4;
var $307601bb4f54b1bd$var$BlockHash = $3z8eW.BlockHash;
function $307601bb4f54b1bd$var$RIPEMD160() {
    if (!(this instanceof $307601bb4f54b1bd$var$RIPEMD160)) return new $307601bb4f54b1bd$var$RIPEMD160();
    $307601bb4f54b1bd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$04Py3.inherits($307601bb4f54b1bd$var$RIPEMD160, $307601bb4f54b1bd$var$BlockHash);
$307601bb4f54b1bd$export$d1cea0ee4e3f0d3e = $307601bb4f54b1bd$var$RIPEMD160;
$307601bb4f54b1bd$var$RIPEMD160.blockSize = 512;
$307601bb4f54b1bd$var$RIPEMD160.outSize = 160;
$307601bb4f54b1bd$var$RIPEMD160.hmacStrength = 192;
$307601bb4f54b1bd$var$RIPEMD160.padLength = 64;
$307601bb4f54b1bd$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $307601bb4f54b1bd$var$sum32($307601bb4f54b1bd$var$rotl32($307601bb4f54b1bd$var$sum32_4(A, $307601bb4f54b1bd$var$f(j, B, C, D), msg[$307601bb4f54b1bd$var$r[j] + start], $307601bb4f54b1bd$var$K(j)), $307601bb4f54b1bd$var$s[j]), E);
        A = E;
        E = D;
        D = $307601bb4f54b1bd$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $307601bb4f54b1bd$var$sum32($307601bb4f54b1bd$var$rotl32($307601bb4f54b1bd$var$sum32_4(Ah, $307601bb4f54b1bd$var$f(79 - j, Bh, Ch, Dh), msg[$307601bb4f54b1bd$var$rh[j] + start], $307601bb4f54b1bd$var$Kh(j)), $307601bb4f54b1bd$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $307601bb4f54b1bd$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $307601bb4f54b1bd$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $307601bb4f54b1bd$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $307601bb4f54b1bd$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $307601bb4f54b1bd$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $307601bb4f54b1bd$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$307601bb4f54b1bd$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $04Py3.toHex32(this.h, "little");
    else return $04Py3.split32(this.h, "little");
};
function $307601bb4f54b1bd$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $307601bb4f54b1bd$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $307601bb4f54b1bd$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $307601bb4f54b1bd$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $307601bb4f54b1bd$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $307601bb4f54b1bd$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $307601bb4f54b1bd$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("1uGyH", function(module, exports) {
"use strict";

var $04Py3 = parcelRequire("04Py3");

var $kAZVs = parcelRequire("kAZVs");
function $11699b0d1d74fa37$var$Hmac(hash, key, enc) {
    if (!(this instanceof $11699b0d1d74fa37$var$Hmac)) return new $11699b0d1d74fa37$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($04Py3.toArray(key, enc));
}
module.exports = $11699b0d1d74fa37$var$Hmac;
$11699b0d1d74fa37$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $kAZVs(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$11699b0d1d74fa37$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$11699b0d1d74fa37$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});



parcelRegister("32dMe", function(module, exports) {

$parcel$export(module.exports, "version", () => $235c3ed38829a52a$export$83d89fbfd8236492);
const $235c3ed38829a52a$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRegister("43ehP", function(module, exports) {

$parcel$export(module.exports, "version", () => $2f328641a2eb5fa8$export$83d89fbfd8236492);
const $2f328641a2eb5fa8$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRegister("2P0wH", function(module, exports) {

$parcel$export(module.exports, "version", () => $20e0c0bc343fe641$export$83d89fbfd8236492);
const $20e0c0bc343fe641$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRegister("bC4om", function(module, exports) {

$parcel$export(module.exports, "formatFixed", () => $8746a6744944cec5$export$cc011b843b5d69f2);
$parcel$export(module.exports, "parseFixed", () => $8746a6744944cec5$export$1b039987e86d7269);
$parcel$export(module.exports, "FixedNumber", () => $8746a6744944cec5$export$d4693c66c2213e45);

var $is1Vq = parcelRequire("is1Vq");

var $hAWyw = parcelRequire("hAWyw");

var $dMMsS = parcelRequire("dMMsS");

var $e0Utj = parcelRequire("e0Utj");
"use strict";
const $8746a6744944cec5$var$logger = new (0, $hAWyw.Logger)((0, $dMMsS.version));
const $8746a6744944cec5$var$_constructorGuard = {};
const $8746a6744944cec5$var$Zero = (0, $e0Utj.BigNumber).from(0);
const $8746a6744944cec5$var$NegativeOne = (0, $e0Utj.BigNumber).from(-1);
function $8746a6744944cec5$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $8746a6744944cec5$var$logger.throwError(message, (0, $hAWyw.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $8746a6744944cec5$var$zeros = "0";
while($8746a6744944cec5$var$zeros.length < 256)$8746a6744944cec5$var$zeros += $8746a6744944cec5$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $8746a6744944cec5$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $e0Utj.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $8746a6744944cec5$var$zeros.substring(0, decimals);
    return $8746a6744944cec5$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $8746a6744944cec5$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $8746a6744944cec5$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $e0Utj.BigNumber).from(value);
    const negative = value.lt($8746a6744944cec5$var$Zero);
    if (negative) value = value.mul($8746a6744944cec5$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $8746a6744944cec5$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $8746a6744944cec5$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $8746a6744944cec5$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $8746a6744944cec5$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $8746a6744944cec5$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $8746a6744944cec5$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $e0Utj.BigNumber).from(whole);
    const fractionValue = (0, $e0Utj.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($8746a6744944cec5$var$NegativeOne);
    return wei;
}
class $8746a6744944cec5$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $8746a6744944cec5$var$_constructorGuard) $8746a6744944cec5$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $8746a6744944cec5$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $8746a6744944cec5$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $8746a6744944cec5$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $8746a6744944cec5$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $8746a6744944cec5$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $8746a6744944cec5$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $8746a6744944cec5$export$1f3ec5b8f47ebd4d($8746a6744944cec5$var$_constructorGuard, signed, width, decimals);
    }
}
class $8746a6744944cec5$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $8746a6744944cec5$var$_constructorGuard) $8746a6744944cec5$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $8746a6744944cec5$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $8746a6744944cec5$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $8746a6744944cec5$export$1b039987e86d7269(other._value, other.format.decimals);
        return $8746a6744944cec5$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $8746a6744944cec5$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $8746a6744944cec5$export$1b039987e86d7269(other._value, other.format.decimals);
        return $8746a6744944cec5$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $8746a6744944cec5$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $8746a6744944cec5$export$1b039987e86d7269(other._value, other.format.decimals);
        return $8746a6744944cec5$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $8746a6744944cec5$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $8746a6744944cec5$export$1b039987e86d7269(other._value, other.format.decimals);
        return $8746a6744944cec5$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $8746a6744944cec5$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($8746a6744944cec5$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $8746a6744944cec5$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($8746a6744944cec5$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $8746a6744944cec5$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $8746a6744944cec5$export$d4693c66c2213e45.from("1" + $8746a6744944cec5$var$zeros.substring(0, decimals), this.format);
        const bump = $8746a6744944cec5$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $8746a6744944cec5$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $e0Utj.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $is1Vq.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $8746a6744944cec5$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $e0Utj.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $8746a6744944cec5$export$d4693c66c2213e45.fromString($8746a6744944cec5$export$cc011b843b5d69f2(value, decimals), $8746a6744944cec5$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $8746a6744944cec5$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $8746a6744944cec5$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($8746a6744944cec5$var$Zero)) $8746a6744944cec5$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $is1Vq.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $8746a6744944cec5$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $8746a6744944cec5$export$d4693c66c2213e45($8746a6744944cec5$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $8746a6744944cec5$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $is1Vq.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $e0Utj.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $8746a6744944cec5$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $8746a6744944cec5$export$d4693c66c2213e45($8746a6744944cec5$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $8746a6744944cec5$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $is1Vq.isBytes)(value)) return $8746a6744944cec5$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $8746a6744944cec5$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $hAWyw.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $8746a6744944cec5$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $8746a6744944cec5$var$ONE = $8746a6744944cec5$export$d4693c66c2213e45.from(1);
const $8746a6744944cec5$var$BUMP = $8746a6744944cec5$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("7J4Ot", function(module, exports) {

$parcel$export(module.exports, "Wallet", () => $5a007822b2833cfe$export$bcca3ea514774656);
$parcel$export(module.exports, "verifyMessage", () => $5a007822b2833cfe$export$228d0e772cc158cb);
$parcel$export(module.exports, "verifyTypedData", () => $5a007822b2833cfe$export$3603b1c1bcd76798);

var $8T6OQ = parcelRequire("8T6OQ");

var $cfLMn = parcelRequire("cfLMn");

var $40NDm = parcelRequire("40NDm");

var $is1Vq = parcelRequire("is1Vq");

var $2u8sE = parcelRequire("2u8sE");
var $WIpZy = parcelRequire("WIpZy");

var $2joQB = parcelRequire("2joQB");

var $koabN = parcelRequire("koabN");

var $cQEXW = parcelRequire("cQEXW");

var $eL3F9 = parcelRequire("eL3F9");

var $12CVZ = parcelRequire("12CVZ");

var $8S4u8 = parcelRequire("8S4u8");
var $1kodS = parcelRequire("1kodS");

var $fb2Z3 = parcelRequire("fb2Z3");

var $hAWyw = parcelRequire("hAWyw");

var $l0i3E = parcelRequire("l0i3E");
"use strict";
var $5a007822b2833cfe$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5a007822b2833cfe$var$logger = new (0, $hAWyw.Logger)((0, $l0i3E.version));
function $5a007822b2833cfe$var$isAccount(value) {
    return value != null && (0, $is1Vq.isHexString)(value.privateKey, 32) && value.address != null;
}
function $5a007822b2833cfe$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $5a007822b2833cfe$export$bcca3ea514774656 extends (0, $40NDm.Signer) {
    constructor(privateKey, provider){
        super();
        if ($5a007822b2833cfe$var$isAccount(privateKey)) {
            const signingKey = new (0, $12CVZ.SigningKey)(privateKey.privateKey);
            (0, $cQEXW.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $cQEXW.defineReadOnly)(this, "address", (0, $fb2Z3.computeAddress)(this.publicKey));
            if (this.address !== (0, $8T6OQ.getAddress)(privateKey.address)) $5a007822b2833cfe$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($5a007822b2833cfe$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $cQEXW.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $2joQB.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $2joQB.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $fb2Z3.computeAddress)(node.privateKey) !== this.address) $5a007822b2833cfe$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $cQEXW.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $12CVZ.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $5a007822b2833cfe$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $cQEXW.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $12CVZ.SigningKey)(privateKey);
                (0, $cQEXW.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $cQEXW.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $cQEXW.defineReadOnly)(this, "address", (0, $fb2Z3.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $cfLMn.Provider).isProvider(provider)) $5a007822b2833cfe$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $cQEXW.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $5a007822b2833cfe$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $cQEXW.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $8T6OQ.getAddress)(tx.from) !== this.address) $5a007822b2833cfe$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $koabN.keccak256)((0, $fb2Z3.serialize)(tx)));
            return (0, $fb2Z3.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $5a007822b2833cfe$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $is1Vq.joinSignature)(this._signingKey().signDigest((0, $WIpZy.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $5a007822b2833cfe$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $2u8sE.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $5a007822b2833cfe$var$logger.throwError("cannot resolve ENS names without a provider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $is1Vq.joinSignature)(this._signingKey().signDigest((0, $2u8sE.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $1kodS.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $eL3F9.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $is1Vq.arrayify)((0, $is1Vq.hexDataSlice)((0, $koabN.keccak256)((0, $is1Vq.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $2joQB.entropyToMnemonic)(entropy, options.locale);
        return $5a007822b2833cfe$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $8S4u8.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $5a007822b2833cfe$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $5a007822b2833cfe$export$bcca3ea514774656((0, $8S4u8.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $2joQB.defaultPath);
        return new $5a007822b2833cfe$export$bcca3ea514774656((0, $2joQB.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $5a007822b2833cfe$export$228d0e772cc158cb(message, signature) {
    return (0, $fb2Z3.recoverAddress)((0, $WIpZy.hashMessage)(message), signature);
}
function $5a007822b2833cfe$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $fb2Z3.recoverAddress)((0, $2u8sE.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("2u8sE", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", () => $1cf4f24a74ca09a3$export$458ab927ae635c3);

var $8T6OQ = parcelRequire("8T6OQ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $koabN = parcelRequire("koabN");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $iR7JF = parcelRequire("iR7JF");

var $kzd4T = parcelRequire("kzd4T");
var $1cf4f24a74ca09a3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1cf4f24a74ca09a3$var$logger = new (0, $hAWyw.Logger)((0, $iR7JF.version));
const $1cf4f24a74ca09a3$var$padding = new Uint8Array(32);
$1cf4f24a74ca09a3$var$padding.fill(0);
const $1cf4f24a74ca09a3$var$NegativeOne = (0, $e0Utj.BigNumber).from(-1);
const $1cf4f24a74ca09a3$var$Zero = (0, $e0Utj.BigNumber).from(0);
const $1cf4f24a74ca09a3$var$One = (0, $e0Utj.BigNumber).from(1);
const $1cf4f24a74ca09a3$var$MaxUint256 = (0, $e0Utj.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $1cf4f24a74ca09a3$var$hexPadRight(value) {
    const bytes = (0, $is1Vq.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $is1Vq.hexConcat)([
        bytes,
        $1cf4f24a74ca09a3$var$padding.slice(padOffset)
    ]);
    return (0, $is1Vq.hexlify)(bytes);
}
const $1cf4f24a74ca09a3$var$hexTrue = (0, $is1Vq.hexZeroPad)($1cf4f24a74ca09a3$var$One.toHexString(), 32);
const $1cf4f24a74ca09a3$var$hexFalse = (0, $is1Vq.hexZeroPad)($1cf4f24a74ca09a3$var$Zero.toHexString(), 32);
const $1cf4f24a74ca09a3$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $1cf4f24a74ca09a3$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $1cf4f24a74ca09a3$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $1cf4f24a74ca09a3$var$domainChecks = {
    name: $1cf4f24a74ca09a3$var$checkString("name"),
    version: $1cf4f24a74ca09a3$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $e0Utj.BigNumber).from(value).toString();
        } catch (error) {}
        return $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $8T6OQ.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $is1Vq.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $is1Vq.hexlify)(bytes);
        } catch (error) {}
        return $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $1cf4f24a74ca09a3$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $1cf4f24a74ca09a3$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $1cf4f24a74ca09a3$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($1cf4f24a74ca09a3$var$One).mul($1cf4f24a74ca09a3$var$NegativeOne) : $1cf4f24a74ca09a3$var$Zero;
            return function(value) {
                const v = (0, $e0Utj.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $is1Vq.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $1cf4f24a74ca09a3$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $is1Vq.arrayify)(value);
                if (bytes.length !== width) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $1cf4f24a74ca09a3$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $is1Vq.hexZeroPad)((0, $8T6OQ.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $1cf4f24a74ca09a3$var$hexFalse : $1cf4f24a74ca09a3$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $koabN.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $kzd4T.id)(value);
            };
    }
    return null;
}
function $1cf4f24a74ca09a3$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $1cf4f24a74ca09a3$export$458ab927ae635c3 {
    constructor(types){
        (0, $cQEXW.defineReadOnly)(this, "types", Object.freeze((0, $cQEXW.deepCopy)(types)));
        (0, $cQEXW.defineReadOnly)(this, "_encoderCache", {});
        (0, $cQEXW.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $1cf4f24a74ca09a3$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $1cf4f24a74ca09a3$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $cQEXW.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $1cf4f24a74ca09a3$var$encodeType(name, types[name]) + st.map((t)=>$1cf4f24a74ca09a3$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $1cf4f24a74ca09a3$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $1cf4f24a74ca09a3$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $koabN.keccak256));
                return (0, $koabN.keccak256)((0, $is1Vq.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $kzd4T.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $koabN.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $is1Vq.hexConcat)(values);
            };
        }
        return $1cf4f24a74ca09a3$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $koabN.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $1cf4f24a74ca09a3$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $1cf4f24a74ca09a3$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $1cf4f24a74ca09a3$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $1cf4f24a74ca09a3$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $1cf4f24a74ca09a3$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $1cf4f24a74ca09a3$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $1cf4f24a74ca09a3$var$domainFieldTypes[name];
            if (!type) $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $1cf4f24a74ca09a3$var$domainFieldNames.indexOf(a.name) - $1cf4f24a74ca09a3$var$domainFieldNames.indexOf(b.name);
        });
        return $1cf4f24a74ca09a3$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $is1Vq.hexConcat)([
            "0x1901",
            $1cf4f24a74ca09a3$export$458ab927ae635c3.hashDomain(domain),
            $1cf4f24a74ca09a3$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $koabN.keccak256)($1cf4f24a74ca09a3$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $1cf4f24a74ca09a3$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $cQEXW.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $is1Vq.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $1cf4f24a74ca09a3$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $is1Vq.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $1cf4f24a74ca09a3$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $1cf4f24a74ca09a3$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $1cf4f24a74ca09a3$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $1cf4f24a74ca09a3$var$domainFieldTypes[name]
            });
        });
        const encoder = $1cf4f24a74ca09a3$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $cQEXW.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $1cf4f24a74ca09a3$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $is1Vq.hexlify)((0, $is1Vq.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $e0Utj.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $1cf4f24a74ca09a3$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $1cf4f24a74ca09a3$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRegister("iR7JF", function(module, exports) {

$parcel$export(module.exports, "version", () => $dba32d6138558b35$export$83d89fbfd8236492);
const $dba32d6138558b35$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRegister("WIpZy", function(module, exports) {

$parcel$export(module.exports, "hashMessage", () => $0b07df6da06b0c4b$export$d4c241cec96564c1);

var $is1Vq = parcelRequire("is1Vq");

var $koabN = parcelRequire("koabN");

var $itjXq = parcelRequire("itjXq");
const $0b07df6da06b0c4b$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $0b07df6da06b0c4b$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $itjXq.toUtf8Bytes)(message);
    return (0, $koabN.keccak256)((0, $is1Vq.concat)([
        (0, $itjXq.toUtf8Bytes)($0b07df6da06b0c4b$export$1ff3fdc4802a2ba6),
        (0, $itjXq.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("2joQB", function(module, exports) {

$parcel$export(module.exports, "defaultPath", () => $1af0a14cd182ec7e$export$d48ad89f7e11a603);
$parcel$export(module.exports, "HDNode", () => $1af0a14cd182ec7e$export$b68640c53e22b952);
$parcel$export(module.exports, "entropyToMnemonic", () => $1af0a14cd182ec7e$export$4becd65eb23312e6);
$parcel$export(module.exports, "mnemonicToEntropy", () => $1af0a14cd182ec7e$export$135e090d58b310ca);
$parcel$export(module.exports, "mnemonicToSeed", () => $1af0a14cd182ec7e$export$3dee74f1204ab09f);
$parcel$export(module.exports, "isValidMnemonic", () => $1af0a14cd182ec7e$export$5eea3393c6119c80);
$parcel$export(module.exports, "getAccountPath", () => $1af0a14cd182ec7e$export$22b80e4f9eff636d);

var $b1hNZ = parcelRequire("b1hNZ");

var $is1Vq = parcelRequire("is1Vq");

var $e0Utj = parcelRequire("e0Utj");

var $itjXq = parcelRequire("itjXq");

var $8F4Gu = parcelRequire("8F4Gu");

var $cQEXW = parcelRequire("cQEXW");

var $12CVZ = parcelRequire("12CVZ");

var $aHYQJ = parcelRequire("aHYQJ");
var $4Tw52 = parcelRequire("4Tw52");

var $fb2Z3 = parcelRequire("fb2Z3");

var $fJZJg = parcelRequire("fJZJg");

var $hAWyw = parcelRequire("hAWyw");

var $80KBn = parcelRequire("80KBn");
"use strict";
const $1af0a14cd182ec7e$var$logger = new (0, $hAWyw.Logger)((0, $80KBn.version));
const $1af0a14cd182ec7e$var$N = (0, $e0Utj.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $1af0a14cd182ec7e$var$MasterSecret = (0, $itjXq.toUtf8Bytes)("Bitcoin seed");
const $1af0a14cd182ec7e$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $1af0a14cd182ec7e$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $1af0a14cd182ec7e$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $1af0a14cd182ec7e$var$bytes32(value) {
    return (0, $is1Vq.hexZeroPad)((0, $is1Vq.hexlify)(value), 32);
}
function $1af0a14cd182ec7e$var$base58check(data) {
    return (0, $b1hNZ.Base58).encode((0, $is1Vq.concat)([
        data,
        (0, $is1Vq.hexDataSlice)((0, $aHYQJ.sha256)((0, $aHYQJ.sha256)(data)), 0, 4)
    ]));
}
function $1af0a14cd182ec7e$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $fJZJg.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $fJZJg.wordlists)[wordlist];
        if (words == null) $1af0a14cd182ec7e$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $1af0a14cd182ec7e$var$_constructorGuard = {};
const $1af0a14cd182ec7e$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $1af0a14cd182ec7e$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $1af0a14cd182ec7e$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $12CVZ.SigningKey)(privateKey);
            (0, $cQEXW.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $cQEXW.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $cQEXW.defineReadOnly)(this, "privateKey", null);
            (0, $cQEXW.defineReadOnly)(this, "publicKey", (0, $is1Vq.hexlify)(publicKey));
        }
        (0, $cQEXW.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $cQEXW.defineReadOnly)(this, "fingerprint", (0, $is1Vq.hexDataSlice)((0, $aHYQJ.ripemd160)((0, $aHYQJ.sha256)(this.publicKey)), 0, 4));
        (0, $cQEXW.defineReadOnly)(this, "address", (0, $fb2Z3.computeAddress)(this.publicKey));
        (0, $cQEXW.defineReadOnly)(this, "chainCode", chainCode);
        (0, $cQEXW.defineReadOnly)(this, "index", index);
        (0, $cQEXW.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $cQEXW.defineReadOnly)(this, "mnemonic", null);
            (0, $cQEXW.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $cQEXW.defineReadOnly)(this, "mnemonic", null);
            (0, $cQEXW.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $cQEXW.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $cQEXW.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $1af0a14cd182ec7e$var$base58check((0, $is1Vq.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $is1Vq.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $is1Vq.hexZeroPad)((0, $is1Vq.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $is1Vq.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $1af0a14cd182ec7e$export$b68640c53e22b952($1af0a14cd182ec7e$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$1af0a14cd182ec7e$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $1af0a14cd182ec7e$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $is1Vq.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $is1Vq.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $is1Vq.arrayify)((0, $aHYQJ.computeHmac)((0, $4Tw52.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $1af0a14cd182ec7e$var$bytes32((0, $e0Utj.BigNumber).from(IL).add(this.privateKey).mod($1af0a14cd182ec7e$var$N));
        else {
            const ek = new (0, $12CVZ.SigningKey)((0, $is1Vq.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $1af0a14cd182ec7e$export$b68640c53e22b952($1af0a14cd182ec7e$var$_constructorGuard, ki, Ki, this.fingerprint, $1af0a14cd182ec7e$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $1af0a14cd182ec7e$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($1af0a14cd182ec7e$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $1af0a14cd182ec7e$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $is1Vq.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $is1Vq.arrayify)((0, $aHYQJ.computeHmac)((0, $4Tw52.SupportedAlgorithm).sha512, $1af0a14cd182ec7e$var$MasterSecret, seedArray));
        return new $1af0a14cd182ec7e$export$b68640c53e22b952($1af0a14cd182ec7e$var$_constructorGuard, $1af0a14cd182ec7e$var$bytes32(I.slice(0, 32)), null, "0x00000000", $1af0a14cd182ec7e$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $1af0a14cd182ec7e$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $1af0a14cd182ec7e$export$4becd65eb23312e6($1af0a14cd182ec7e$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $1af0a14cd182ec7e$export$b68640c53e22b952._fromSeed($1af0a14cd182ec7e$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $1af0a14cd182ec7e$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $b1hNZ.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $1af0a14cd182ec7e$var$base58check(bytes.slice(0, 78)) !== extendedKey) $1af0a14cd182ec7e$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $is1Vq.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $is1Vq.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $is1Vq.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $is1Vq.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $1af0a14cd182ec7e$export$b68640c53e22b952($1af0a14cd182ec7e$var$_constructorGuard, null, (0, $is1Vq.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $1af0a14cd182ec7e$export$b68640c53e22b952($1af0a14cd182ec7e$var$_constructorGuard, (0, $is1Vq.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $1af0a14cd182ec7e$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $1af0a14cd182ec7e$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $itjXq.toUtf8Bytes)("mnemonic" + password, (0, $itjXq.UnicodeNormalizationForm).NFKD);
    return (0, $8F4Gu.pbkdf2)((0, $itjXq.toUtf8Bytes)(mnemonic, (0, $itjXq.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $1af0a14cd182ec7e$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $1af0a14cd182ec7e$var$getWordlist(wordlist);
    $1af0a14cd182ec7e$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $is1Vq.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $1af0a14cd182ec7e$var$getUpperMask(checksumBits);
    const checksum = (0, $is1Vq.arrayify)((0, $aHYQJ.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $is1Vq.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $1af0a14cd182ec7e$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $1af0a14cd182ec7e$var$getWordlist(wordlist);
    entropy = (0, $is1Vq.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $1af0a14cd182ec7e$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $is1Vq.arrayify)((0, $aHYQJ.sha256)(entropy))[0] & $1af0a14cd182ec7e$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $1af0a14cd182ec7e$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $1af0a14cd182ec7e$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $1af0a14cd182ec7e$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $1af0a14cd182ec7e$var$HardenedBit || index % 1) $1af0a14cd182ec7e$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("b1hNZ", function(module, exports) {

$parcel$export(module.exports, "Base58", () => $805d997985edb527$export$45a587635c9954b2);
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");
class $805d997985edb527$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $cQEXW.defineReadOnly)(this, "alphabet", alphabet);
        (0, $cQEXW.defineReadOnly)(this, "base", alphabet.length);
        (0, $cQEXW.defineReadOnly)(this, "_alphabetMap", {});
        (0, $cQEXW.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $is1Vq.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $is1Vq.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $805d997985edb527$export$cfabb2852920f5ec = new $805d997985edb527$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $805d997985edb527$export$45a587635c9954b2 = new $805d997985edb527$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("8F4Gu", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $64e5c945848cc2b2$export$448fa22aedc9dbca);

var $is1Vq = parcelRequire("is1Vq");

var $aHYQJ = parcelRequire("aHYQJ");
"use strict";
function $64e5c945848cc2b2$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $is1Vq.arrayify)(password);
    salt = (0, $is1Vq.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $is1Vq.arrayify)((0, $aHYQJ.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $is1Vq.arrayify)((0, $aHYQJ.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $is1Vq.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $is1Vq.hexlify)(DK);
}

});
parcelRegister("aHYQJ", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $7cbd1efef7ed022e$export$d1cea0ee4e3f0d3e);
$parcel$export(module.exports, "sha256", () => $7cbd1efef7ed022e$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha512", () => $7cbd1efef7ed022e$export$a888d2532e6dc7bb);
$parcel$export(module.exports, "computeHmac", () => $7cbd1efef7ed022e$export$967075d2f3b8e7ff);

var $2peZt = parcelRequire("2peZt");

var $is1Vq = parcelRequire("is1Vq");

var $4Tw52 = parcelRequire("4Tw52");

var $hAWyw = parcelRequire("hAWyw");

var $6SYqe = parcelRequire("6SYqe");
"use strict";
const $7cbd1efef7ed022e$var$logger = new (0, $hAWyw.Logger)((0, $6SYqe.version));
function $7cbd1efef7ed022e$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).ripemd160().update((0, $is1Vq.arrayify)(data)).digest("hex");
}
function $7cbd1efef7ed022e$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha256().update((0, $is1Vq.arrayify)(data)).digest("hex");
}
function $7cbd1efef7ed022e$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).sha512().update((0, $is1Vq.arrayify)(data)).digest("hex");
}
function $7cbd1efef7ed022e$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $4Tw52.SupportedAlgorithm)[algorithm]) $7cbd1efef7ed022e$var$logger.throwError("unsupported algorithm " + algorithm, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($2peZt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($2peZt)))[algorithm], (0, $is1Vq.arrayify)(key)).update((0, $is1Vq.arrayify)(data)).digest("hex");
}

});
parcelRegister("4Tw52", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", () => $39052ef43a0fca36$export$d2a8849cfb277c);
var $39052ef43a0fca36$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($39052ef43a0fca36$export$d2a8849cfb277c || ($39052ef43a0fca36$export$d2a8849cfb277c = {}));

});

parcelRegister("6SYqe", function(module, exports) {

$parcel$export(module.exports, "version", () => $5036a7c550bc3f71$export$83d89fbfd8236492);
const $5036a7c550bc3f71$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRegister("fJZJg", function(module, exports) {

$parcel$export(module.exports, "wordlists", () => $b75af11244e8ff2e$export$e8e1b4711c2d1939);

var $6kHV7 = parcelRequire("6kHV7");
"use strict";
const $b75af11244e8ff2e$export$e8e1b4711c2d1939 = {
    en: (0, $6kHV7.langEn)
};

});
parcelRegister("6kHV7", function(module, exports) {

$parcel$export(module.exports, "langEn", () => $49c6adfa11a3ac8f$export$a2c9518710cf1f49);

var $2IdZM = parcelRequire("2IdZM");
"use strict";
const $49c6adfa11a3ac8f$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $49c6adfa11a3ac8f$var$wordlist = null;
function $49c6adfa11a3ac8f$var$loadWords(lang) {
    if ($49c6adfa11a3ac8f$var$wordlist != null) return;
    $49c6adfa11a3ac8f$var$wordlist = $49c6adfa11a3ac8f$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $2IdZM.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $49c6adfa11a3ac8f$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $49c6adfa11a3ac8f$var$LangEn extends (0, $2IdZM.Wordlist) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $49c6adfa11a3ac8f$var$loadWords(this);
        return $49c6adfa11a3ac8f$var$wordlist[index];
    }
    getWordIndex(word) {
        $49c6adfa11a3ac8f$var$loadWords(this);
        return $49c6adfa11a3ac8f$var$wordlist.indexOf(word);
    }
}
const $49c6adfa11a3ac8f$export$a2c9518710cf1f49 = new $49c6adfa11a3ac8f$var$LangEn();
(0, $2IdZM.Wordlist).register($49c6adfa11a3ac8f$export$a2c9518710cf1f49);

});
parcelRegister("2IdZM", function(module, exports) {

$parcel$export(module.exports, "Wordlist", () => $1f9a8c0f83becdfd$export$4d9531a8ddb0ebca);

var $kzd4T = parcelRequire("kzd4T");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $9C2rB = parcelRequire("9C2rB");
"use strict";
// This gets overridden by rollup
const $1f9a8c0f83becdfd$var$exportWordlist = false;
const $1f9a8c0f83becdfd$export$af88d00dbe7f521 = new (0, $hAWyw.Logger)((0, $9C2rB.version));
class $1f9a8c0f83becdfd$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1f9a8c0f83becdfd$export$af88d00dbe7f521.checkAbstract(new.target, $1f9a8c0f83becdfd$export$4d9531a8ddb0ebca);
        (0, $cQEXW.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $kzd4T.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1f9a8c0f83becdfd$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $cQEXW.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}

});
parcelRegister("9C2rB", function(module, exports) {

$parcel$export(module.exports, "version", () => $6ff98f05a7ec5023$export$83d89fbfd8236492);
const $6ff98f05a7ec5023$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRegister("80KBn", function(module, exports) {

$parcel$export(module.exports, "version", () => $5d5278fb61ebd888$export$83d89fbfd8236492);
const $5d5278fb61ebd888$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRegister("eL3F9", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $abe84bcf11f2c850$export$5f828d93ff035aa8);

var $is1Vq = parcelRequire("is1Vq");

var $hAWyw = parcelRequire("hAWyw");

var $e8uzK = parcelRequire("e8uzK");
"use strict";
const $abe84bcf11f2c850$var$logger = new (0, $hAWyw.Logger)((0, $e8uzK.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $abe84bcf11f2c850$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $abe84bcf11f2c850$var$anyGlobal = $abe84bcf11f2c850$var$getGlobal();
let $abe84bcf11f2c850$var$crypto = $abe84bcf11f2c850$var$anyGlobal.crypto || $abe84bcf11f2c850$var$anyGlobal.msCrypto;
if (!$abe84bcf11f2c850$var$crypto || !$abe84bcf11f2c850$var$crypto.getRandomValues) {
    $abe84bcf11f2c850$var$logger.warn("WARNING: Missing strong random number source");
    $abe84bcf11f2c850$var$crypto = {
        getRandomValues: function(buffer) {
            return $abe84bcf11f2c850$var$logger.throwError("no secure random source avaialble", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $abe84bcf11f2c850$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $abe84bcf11f2c850$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $abe84bcf11f2c850$var$crypto.getRandomValues(result);
    return (0, $is1Vq.arrayify)(result);
}

});
parcelRegister("e8uzK", function(module, exports) {

$parcel$export(module.exports, "version", () => $a4a987b8b03802d8$export$83d89fbfd8236492);
const $a4a987b8b03802d8$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRegister("8S4u8", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", () => $6756d888468ba619$export$e74fcde37488267a);
$parcel$export(module.exports, "decryptJsonWalletSync", () => $6756d888468ba619$export$7a81c437a678891a);

var $7IDPX = parcelRequire("7IDPX");

var $8ZiQm = parcelRequire("8ZiQm");

var $1kodS = parcelRequire("1kodS");
"use strict";
function $6756d888468ba619$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $8ZiQm.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $7IDPX.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $8ZiQm.isKeystoreWallet)(json)) return (0, $1kodS.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $6756d888468ba619$export$7a81c437a678891a(json, password) {
    if ((0, $8ZiQm.isCrowdsaleWallet)(json)) return (0, $7IDPX.decrypt)(json, password);
    if ((0, $8ZiQm.isKeystoreWallet)(json)) return (0, $1kodS.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("7IDPX", function(module, exports) {

$parcel$export(module.exports, "decrypt", () => $59eb8b40a253af99$export$e85a0c9a1067c5d3);

var $gtct3 = parcelRequire("gtct3");

var $8T6OQ = parcelRequire("8T6OQ");

var $is1Vq = parcelRequire("is1Vq");

var $koabN = parcelRequire("koabN");

var $8F4Gu = parcelRequire("8F4Gu");

var $itjXq = parcelRequire("itjXq");

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $67tae = parcelRequire("67tae");

var $l3VhN = parcelRequire("l3VhN");
"use strict";
const $59eb8b40a253af99$var$logger = new (0, $hAWyw.Logger)((0, $67tae.version));
class $59eb8b40a253af99$export$93a76d16f88f2b3 extends (0, $cQEXW.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $59eb8b40a253af99$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $l3VhN.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $8T6OQ.getAddress)((0, $l3VhN.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $59eb8b40a253af99$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $is1Vq.arrayify)((0, $8F4Gu.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).padding.pkcs7.strip((0, $is1Vq.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $itjXq.toUtf8Bytes)(seedHex);
    const privateKey = (0, $koabN.keccak256)(seedHexBytes);
    return new $59eb8b40a253af99$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("gtct3", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("67tae", function(module, exports) {

$parcel$export(module.exports, "version", () => $474a04e8c8903afb$export$83d89fbfd8236492);
const $474a04e8c8903afb$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRegister("l3VhN", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", () => $f556509af1439fb8$export$2cde08bde0cfd932);
$parcel$export(module.exports, "zpad", () => $f556509af1439fb8$export$67752b99d3bc61c6);
$parcel$export(module.exports, "getPassword", () => $f556509af1439fb8$export$350bd33120f7413e);
$parcel$export(module.exports, "searchPath", () => $f556509af1439fb8$export$5a5c1dbd910e2c32);
$parcel$export(module.exports, "uuidV4", () => $f556509af1439fb8$export$ec7b18ebad55a3a9);

var $is1Vq = parcelRequire("is1Vq");

var $itjXq = parcelRequire("itjXq");
"use strict";
function $f556509af1439fb8$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $is1Vq.arrayify)(hexString);
}
function $f556509af1439fb8$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $f556509af1439fb8$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $itjXq.toUtf8Bytes)(password, (0, $itjXq.UnicodeNormalizationForm).NFKC);
    return (0, $is1Vq.arrayify)(password);
}
function $f556509af1439fb8$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $f556509af1439fb8$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $is1Vq.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $is1Vq.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("8ZiQm", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", () => $68b2a32a89d8ef56$export$724d6cf6b9fd8578);
$parcel$export(module.exports, "isKeystoreWallet", () => $68b2a32a89d8ef56$export$67dc926b8e68b2d8);
$parcel$export(module.exports, "getJsonWalletAddress", () => $68b2a32a89d8ef56$export$9a68ee9f8f3afd38);

var $8T6OQ = parcelRequire("8T6OQ");
"use strict";
function $68b2a32a89d8ef56$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $68b2a32a89d8ef56$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $68b2a32a89d8ef56$export$9a68ee9f8f3afd38(json) {
    if ($68b2a32a89d8ef56$export$724d6cf6b9fd8578(json)) try {
        return (0, $8T6OQ.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($68b2a32a89d8ef56$export$67dc926b8e68b2d8(json)) try {
        return (0, $8T6OQ.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("1kodS", function(module, exports) {

$parcel$export(module.exports, "decryptSync", () => $0f7a72df4cd58f1c$export$9bd2c37889ee5e36);
$parcel$export(module.exports, "decrypt", () => $0f7a72df4cd58f1c$export$e85a0c9a1067c5d3);
$parcel$export(module.exports, "encrypt", () => $0f7a72df4cd58f1c$export$5b0f6292f11d1d18);

var $gtct3 = parcelRequire("gtct3");

var $aVJ0x = parcelRequire("aVJ0x");

var $8T6OQ = parcelRequire("8T6OQ");

var $is1Vq = parcelRequire("is1Vq");

var $2joQB = parcelRequire("2joQB");

var $koabN = parcelRequire("koabN");

var $8F4Gu = parcelRequire("8F4Gu");

var $eL3F9 = parcelRequire("eL3F9");

var $cQEXW = parcelRequire("cQEXW");

var $fb2Z3 = parcelRequire("fb2Z3");

var $l3VhN = parcelRequire("l3VhN");

var $hAWyw = parcelRequire("hAWyw");

var $67tae = parcelRequire("67tae");
"use strict";
var $0f7a72df4cd58f1c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $0f7a72df4cd58f1c$var$logger = new (0, $hAWyw.Logger)((0, $67tae.version));
// Exported Types
function $0f7a72df4cd58f1c$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $0f7a72df4cd58f1c$export$cf9dc4fd6dde0315 extends (0, $cQEXW.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $0f7a72df4cd58f1c$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $l3VhN.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).ModeOfOperation.ctr(key, counter);
        return (0, $is1Vq.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $0f7a72df4cd58f1c$var$_getAccount(data, key) {
    const ciphertext = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $is1Vq.hexlify)((0, $koabN.keccak256)((0, $is1Vq.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $l3VhN.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $0f7a72df4cd58f1c$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $0f7a72df4cd58f1c$var$logger.throwError("unsupported cipher", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $fb2Z3.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $8T6OQ.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $is1Vq.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $l3VhN.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $l3VhN.searchPath)(data, "x-ethers/path") || (0, $2joQB.defaultPath);
        const locale = (0, $l3VhN.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $is1Vq.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $2joQB.entropyToMnemonic)(entropy, locale);
            const node = (0, $2joQB.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $hAWyw.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $0f7a72df4cd58f1c$export$cf9dc4fd6dde0315(account);
}
function $0f7a72df4cd58f1c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $is1Vq.arrayify)((0, $8F4Gu.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $0f7a72df4cd58f1c$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($0f7a72df4cd58f1c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $0f7a72df4cd58f1c$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $l3VhN.getPassword)(password);
    const kdf = (0, $l3VhN.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $0f7a72df4cd58f1c$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $l3VhN.looseArrayify)((0, $l3VhN.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $l3VhN.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $l3VhN.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $0f7a72df4cd58f1c$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $0f7a72df4cd58f1c$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $0f7a72df4cd58f1c$var$_computeKdfKey(data, password, $0f7a72df4cd58f1c$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($aVJ0x))).syncScrypt);
    return $0f7a72df4cd58f1c$var$_getAccount(data, key);
}
function $0f7a72df4cd58f1c$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $0f7a72df4cd58f1c$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $0f7a72df4cd58f1c$var$_computeKdfKey(data, password, $0f7a72df4cd58f1c$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($aVJ0x))).scrypt, progressCallback);
        return $0f7a72df4cd58f1c$var$_getAccount(data, key);
    });
}
function $0f7a72df4cd58f1c$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $8T6OQ.getAddress)(account.address) !== (0, $fb2Z3.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($0f7a72df4cd58f1c$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $2joQB.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $2joQB.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $is1Vq.arrayify)(account.privateKey);
    const passwordBytes = (0, $l3VhN.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($0f7a72df4cd58f1c$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $is1Vq.arrayify)((0, $2joQB.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $2joQB.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $is1Vq.arrayify)(options.salt);
    else salt = (0, $eL3F9.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $is1Vq.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $eL3F9.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $is1Vq.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $eL3F9.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($aVJ0x))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $is1Vq.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $is1Vq.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $koabN.keccak256)((0, $is1Vq.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $l3VhN.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $is1Vq.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $is1Vq.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $is1Vq.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $eL3F9.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($gtct3))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $is1Vq.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $l3VhN.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $l3VhN.zpad)(now.getUTCDate(), 2) + "T" + (0, $l3VhN.zpad)(now.getUTCHours(), 2) + "-" + (0, $l3VhN.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $l3VhN.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $is1Vq.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $is1Vq.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("aVJ0x", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRegister("l0i3E", function(module, exports) {

$parcel$export(module.exports, "version", () => $f4a79af984720e0e$export$83d89fbfd8236492);
const $f4a79af984720e0e$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRegister("ltcCO", function(module, exports) {

$parcel$export(module.exports, "AddressZero", () => (parcelRequire("g1fMd")).AddressZero);
$parcel$export(module.exports, "NegativeOne", () => (parcelRequire("kUxyG")).NegativeOne);
$parcel$export(module.exports, "Zero", () => (parcelRequire("kUxyG")).Zero);
$parcel$export(module.exports, "One", () => (parcelRequire("kUxyG")).One);
$parcel$export(module.exports, "Two", () => (parcelRequire("kUxyG")).Two);
$parcel$export(module.exports, "WeiPerEther", () => (parcelRequire("kUxyG")).WeiPerEther);
$parcel$export(module.exports, "MaxUint256", () => (parcelRequire("kUxyG")).MaxUint256);
$parcel$export(module.exports, "MinInt256", () => (parcelRequire("kUxyG")).MinInt256);
$parcel$export(module.exports, "MaxInt256", () => (parcelRequire("kUxyG")).MaxInt256);
$parcel$export(module.exports, "HashZero", () => (parcelRequire("lYhMT")).HashZero);
$parcel$export(module.exports, "EtherSymbol", () => (parcelRequire("guEgp")).EtherSymbol);

var $g1fMd = parcelRequire("g1fMd");

var $kUxyG = parcelRequire("kUxyG");

var $lYhMT = parcelRequire("lYhMT");

var $guEgp = parcelRequire("guEgp");
"use strict";

});
parcelRegister("g1fMd", function(module, exports) {

$parcel$export(module.exports, "AddressZero", () => $ba98fa3ce8647afd$export$badd13187c087617);
const $ba98fa3ce8647afd$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("lYhMT", function(module, exports) {

$parcel$export(module.exports, "HashZero", () => $ffecffcf1482d558$export$71c2e4e213dcb7f2);
const $ffecffcf1482d558$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("guEgp", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", () => $c01eae36490bcf12$export$c7e79fcb6f8ac048);
// NFKC (composed)             // (decomposed)
const $c01eae36490bcf12$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("8VNI3", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", () => $680a34e81a552f28$export$4f77a1d3c1ac6642);
$parcel$export(module.exports, "Provider", () => (parcelRequire("cfLMn")).Provider);
$parcel$export(module.exports, "BaseProvider", () => (parcelRequire("aPYeD")).BaseProvider);
$parcel$export(module.exports, "Resolver", () => (parcelRequire("aPYeD")).Resolver);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => (parcelRequire("cBOfq")).UrlJsonRpcProvider);
$parcel$export(module.exports, "FallbackProvider", () => (parcelRequire("80lZU")).FallbackProvider);
$parcel$export(module.exports, "AlchemyProvider", () => (parcelRequire("5f24G")).AlchemyProvider);
$parcel$export(module.exports, "AlchemyWebSocketProvider", () => (parcelRequire("5f24G")).AlchemyWebSocketProvider);
$parcel$export(module.exports, "AnkrProvider", () => (parcelRequire("hiZep")).AnkrProvider);
$parcel$export(module.exports, "CloudflareProvider", () => (parcelRequire("5DbOz")).CloudflareProvider);
$parcel$export(module.exports, "EtherscanProvider", () => (parcelRequire("hO1QT")).EtherscanProvider);
$parcel$export(module.exports, "InfuraProvider", () => (parcelRequire("2k12m")).InfuraProvider);
$parcel$export(module.exports, "InfuraWebSocketProvider", () => (parcelRequire("2k12m")).InfuraWebSocketProvider);
$parcel$export(module.exports, "JsonRpcProvider", () => (parcelRequire("i56cX")).JsonRpcProvider);
$parcel$export(module.exports, "JsonRpcBatchProvider", () => (parcelRequire("98FHx")).JsonRpcBatchProvider);
$parcel$export(module.exports, "NodesmithProvider", () => (parcelRequire("2R6JC")).NodesmithProvider);
$parcel$export(module.exports, "PocketProvider", () => (parcelRequire("7RWri")).PocketProvider);
$parcel$export(module.exports, "StaticJsonRpcProvider", () => (parcelRequire("cBOfq")).StaticJsonRpcProvider);
$parcel$export(module.exports, "Web3Provider", () => (parcelRequire("5lu0X")).Web3Provider);
$parcel$export(module.exports, "WebSocketProvider", () => (parcelRequire("4jN6K")).WebSocketProvider);
$parcel$export(module.exports, "IpcProvider", () => (parcelRequire("fEeyA")).IpcProvider);
$parcel$export(module.exports, "JsonRpcSigner", () => (parcelRequire("i56cX")).JsonRpcSigner);
$parcel$export(module.exports, "getNetwork", () => (parcelRequire("dLMrb")).getNetwork);
$parcel$export(module.exports, "isCommunityResource", () => (parcelRequire("bzgEz")).isCommunityResource);
$parcel$export(module.exports, "isCommunityResourcable", () => (parcelRequire("bzgEz")).isCommunityResourcable);
$parcel$export(module.exports, "showThrottleMessage", () => (parcelRequire("bzgEz")).showThrottleMessage);
$parcel$export(module.exports, "Formatter", () => (parcelRequire("bzgEz")).Formatter);

var $cfLMn = parcelRequire("cfLMn");

var $dLMrb = parcelRequire("dLMrb");

var $aPYeD = parcelRequire("aPYeD");

var $5f24G = parcelRequire("5f24G");

var $hiZep = parcelRequire("hiZep");

var $5DbOz = parcelRequire("5DbOz");

var $hO1QT = parcelRequire("hO1QT");

var $80lZU = parcelRequire("80lZU");

var $fEeyA = parcelRequire("fEeyA");

var $2k12m = parcelRequire("2k12m");

var $i56cX = parcelRequire("i56cX");

var $98FHx = parcelRequire("98FHx");

var $2R6JC = parcelRequire("2R6JC");

var $7RWri = parcelRequire("7RWri");

var $cBOfq = parcelRequire("cBOfq");

var $5lu0X = parcelRequire("5lu0X");

var $4jN6K = parcelRequire("4jN6K");

var $bzgEz = parcelRequire("bzgEz");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
const $680a34e81a552f28$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
////////////////////////
// Helper Functions
function $680a34e81a552f28$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $i56cX.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $4jN6K.WebSocketProvider)(network);
            default:
                $680a34e81a552f28$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $dLMrb.getNetwork)(network);
    if (!n || !n._defaultProvider) $680a34e81a552f28$var$logger.throwError("unsupported getDefaultProvider network", (0, $hAWyw.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $80lZU.FallbackProvider,
        AlchemyProvider: $5f24G.AlchemyProvider,
        AnkrProvider: $hiZep.AnkrProvider,
        CloudflareProvider: $5DbOz.CloudflareProvider,
        EtherscanProvider: $hO1QT.EtherscanProvider,
        InfuraProvider: $2k12m.InfuraProvider,
        JsonRpcProvider: $i56cX.JsonRpcProvider,
        NodesmithProvider: $2R6JC.NodesmithProvider,
        PocketProvider: $7RWri.PocketProvider,
        Web3Provider: $5lu0X.Web3Provider,
        IpcProvider: $fEeyA.IpcProvider
    }, options);
}

});
parcelRegister("dLMrb", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $a0653cca797227da$export$7de4970ebfd8206d);

var $hAWyw = parcelRequire("hAWyw");

var $hb6OG = parcelRequire("hb6OG");
"use strict";
const $a0653cca797227da$var$logger = new (0, $hAWyw.Logger)((0, $hb6OG.version));
function $a0653cca797227da$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $a0653cca797227da$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $a0653cca797227da$var$ethDefaultProvider(network);
    };
    return func;
}
function $a0653cca797227da$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $a0653cca797227da$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $a0653cca797227da$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("homestead")
};
const $a0653cca797227da$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("ropsten")
};
const $a0653cca797227da$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $a0653cca797227da$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $a0653cca797227da$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $a0653cca797227da$var$homestead,
    mainnet: $a0653cca797227da$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $a0653cca797227da$var$ropsten,
    testnet: $a0653cca797227da$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $a0653cca797227da$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $a0653cca797227da$var$classicMordor,
    classicTestnet: $a0653cca797227da$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $a0653cca797227da$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $a0653cca797227da$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $a0653cca797227da$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $a0653cca797227da$var$networks){
            const standard = $a0653cca797227da$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $a0653cca797227da$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $a0653cca797227da$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $a0653cca797227da$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $a0653cca797227da$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($a0653cca797227da$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("hb6OG", function(module, exports) {

$parcel$export(module.exports, "version", () => $c818c0552c0998ae$export$83d89fbfd8236492);
const $c818c0552c0998ae$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRegister("aPYeD", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $7e3d643c5495ec86$export$8b4c839865b08288);
$parcel$export(module.exports, "BaseProvider", () => $7e3d643c5495ec86$export$ff3f6dd83125ac45);

var $cfLMn = parcelRequire("cfLMn");

var $9DtaX = parcelRequire("9DtaX");

var $b1hNZ = parcelRequire("b1hNZ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $lYhMT = parcelRequire("lYhMT");

var $1kRIW = parcelRequire("1kRIW");

var $dLMrb = parcelRequire("dLMrb");

var $cQEXW = parcelRequire("cQEXW");

var $aHYQJ = parcelRequire("aHYQJ");

var $itjXq = parcelRequire("itjXq");

var $bpZ9V = parcelRequire("bpZ9V");

var $1H56A = parcelRequire("1H56A");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $bzgEz = parcelRequire("bzgEz");
"use strict";
var $7e3d643c5495ec86$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7e3d643c5495ec86$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
const $7e3d643c5495ec86$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $7e3d643c5495ec86$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $is1Vq.hexDataLength)(topic) !== 32) $7e3d643c5495ec86$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $7e3d643c5495ec86$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$7e3d643c5495ec86$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $7e3d643c5495ec86$var$checkTopic(topic);
    }).join("&");
}
function $7e3d643c5495ec86$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $7e3d643c5495ec86$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $is1Vq.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $7e3d643c5495ec86$var$serializeTopics(eventName);
    else if ((0, $cfLMn.ForkEvent).isForkEvent(eventName)) {
        $7e3d643c5495ec86$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $7e3d643c5495ec86$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $7e3d643c5495ec86$var$getTime() {
    return new Date().getTime();
}
function $7e3d643c5495ec86$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $7e3d643c5495ec86$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $7e3d643c5495ec86$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $cQEXW.defineReadOnly)(this, "tag", tag);
        (0, $cQEXW.defineReadOnly)(this, "listener", listener);
        (0, $cQEXW.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $7e3d643c5495ec86$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $7e3d643c5495ec86$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $7e3d643c5495ec86$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $7e3d643c5495ec86$var$bytes32ify(value) {
    return (0, $is1Vq.hexZeroPad)((0, $e0Utj.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $7e3d643c5495ec86$var$base58Encode(data) {
    return (0, $b1hNZ.Base58).encode((0, $is1Vq.concat)([
        data,
        (0, $is1Vq.hexDataSlice)((0, $aHYQJ.sha256)((0, $aHYQJ.sha256)(data)), 0, 4)
    ]));
}
const $7e3d643c5495ec86$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $7e3d643c5495ec86$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $7e3d643c5495ec86$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $7e3d643c5495ec86$var$_parseString(result, start) {
    try {
        return (0, $itjXq.toUtf8String)($7e3d643c5495ec86$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $7e3d643c5495ec86$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $e0Utj.BigNumber).from((0, $is1Vq.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $e0Utj.BigNumber).from((0, $is1Vq.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $is1Vq.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $7e3d643c5495ec86$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $7e3d643c5495ec86$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $7e3d643c5495ec86$var$numPad(value) {
    const result = (0, $is1Vq.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $7e3d643c5495ec86$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $7e3d643c5495ec86$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $is1Vq.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $7e3d643c5495ec86$var$numPad(byteCount);
        // The length and padded value of data
        result.push($7e3d643c5495ec86$var$numPad(data.length));
        result.push($7e3d643c5495ec86$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $is1Vq.hexConcat)(result);
}
class $7e3d643c5495ec86$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $cQEXW.defineReadOnly)(this, "provider", provider);
        (0, $cQEXW.defineReadOnly)(this, "name", name);
        (0, $cQEXW.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $cQEXW.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $e0Utj.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $hAWyw.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $is1Vq.hexConcat)([
                    selector,
                    (0, $1kRIW.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $is1Vq.hexConcat)([
                    "0x9061b923",
                    $7e3d643c5495ec86$var$encodeBytes([
                        (0, $1kRIW.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $is1Vq.arrayify)(result).length % 32 === 4) $7e3d643c5495ec86$var$logger.throwError("resolver threw error", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $7e3d643c5495ec86$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $hAWyw.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $7e3d643c5495ec86$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $7e3d643c5495ec86$var$coinInfos[String(coinType)];
        if (coinInfo == null) $7e3d643c5495ec86$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $is1Vq.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $7e3d643c5495ec86$var$base58Encode((0, $is1Vq.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $7e3d643c5495ec86$var$base58Encode((0, $is1Vq.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($1H56A))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($1H56A))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $lYhMT.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $hAWyw.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $7e3d643c5495ec86$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $7e3d643c5495ec86$var$logger.throwError(`invalid or unsupported coin data`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $7e3d643c5495ec86$var$matchers.length; i++){
                    const match = avatar.match($7e3d643c5495ec86$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $7e3d643c5495ec86$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $is1Vq.hexZeroPad)((0, $e0Utj.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $is1Vq.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $e0Utj.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $is1Vq.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $is1Vq.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $is1Vq.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $7e3d643c5495ec86$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $7e3d643c5495ec86$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $bpZ9V.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($7e3d643c5495ec86$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $7e3d643c5495ec86$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $b1hNZ.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $b1hNZ.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $9DtaX.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $7e3d643c5495ec86$var$logger.throwError(`invalid or unsupported content hash data`, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $itjXq.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $is1Vq.concat)([
                $7e3d643c5495ec86$var$bytes32ify(64),
                $7e3d643c5495ec86$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $is1Vq.concat)([
                keyBytes,
                (0, $is1Vq.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $is1Vq.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $itjXq.toUtf8String)(hexBytes);
        });
    }
}
let $7e3d643c5495ec86$var$defaultFormatter = null;
let $7e3d643c5495ec86$var$nextPollId = 1;
class $7e3d643c5495ec86$export$ff3f6dd83125ac45 extends (0, $cfLMn.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $cQEXW.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $cQEXW.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $cQEXW.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $7e3d643c5495ec86$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $7e3d643c5495ec86$var$logger.throwError("no network detected", (0, $hAWyw.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $cQEXW.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $bpZ9V.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $hAWyw.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($7e3d643c5495ec86$var$defaultFormatter == null) $7e3d643c5495ec86$var$defaultFormatter = new (0, $bzgEz.Formatter)();
        return $7e3d643c5495ec86$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $dLMrb.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $bpZ9V.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $7e3d643c5495ec86$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $7e3d643c5495ec86$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($7e3d643c5495ec86$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $7e3d643c5495ec86$var$getTime();
            const checkInternalBlockNumber = (0, $cQEXW.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $7e3d643c5495ec86$var$getTime();
                blockNumber = (0, $e0Utj.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $7e3d643c5495ec86$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $7e3d643c5495ec86$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $7e3d643c5495ec86$var$logger.makeError("network block skew detected", (0, $hAWyw.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            return $7e3d643c5495ec86$var$logger.throwError("provider does not support network detection", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $7e3d643c5495ec86$var$stall(0);
                    return this._network;
                }
                const error = $7e3d643c5495ec86$var$logger.makeError("underlying network changed", (0, $hAWyw.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $7e3d643c5495ec86$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $7e3d643c5495ec86$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $7e3d643c5495ec86$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($7e3d643c5495ec86$var$logger.makeError("transaction was replaced", (0, $hAWyw.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($7e3d643c5495ec86$var$logger.makeError("timeout exceeded", (0, $hAWyw.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $e0Utj.BigNumber).from(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $e0Utj.BigNumber).from(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $e0Utj.BigNumber).from(result).toNumber();
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $is1Vq.hexlify)(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $is1Vq.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $is1Vq.hexlify)(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $is1Vq.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $7e3d643c5495ec86$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $hAWyw.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $7e3d643c5495ec86$var$logger.throwError("transaction failed", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $is1Vq.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $e0Utj.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $is1Vq.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $cQEXW.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $cQEXW.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $7e3d643c5495ec86$var$MAX_CCIP_REDIRECTS) $7e3d643c5495ec86$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $is1Vq.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $is1Vq.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $is1Vq.hexDataSlice)(data, 0, 32);
                if (!(0, $e0Utj.BigNumber).from(sender).eq(txSender)) $7e3d643c5495ec86$var$logger.throwError("CCIP Read sender did not match", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $e0Utj.BigNumber).from((0, $is1Vq.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $e0Utj.BigNumber).from((0, $is1Vq.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $is1Vq.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $7e3d643c5495ec86$var$_parseString(urlsData, u * 32);
                    if (url == null) $7e3d643c5495ec86$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $7e3d643c5495ec86$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $e0Utj.BigNumber).from((0, $is1Vq.hexDataSlice)(data, 100, 128)).isZero()) $7e3d643c5495ec86$var$logger.throwError("CCIP Read callback selector included junk", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $is1Vq.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $7e3d643c5495ec86$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $7e3d643c5495ec86$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $is1Vq.hexConcat)([
                        callbackSelector,
                        $7e3d643c5495ec86$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $hAWyw.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $is1Vq.hexlify)(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $cQEXW.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $e0Utj.BigNumber).from(result);
            } catch (error) {
                return $7e3d643c5495ec86$var$logger.throwError("bad result from backend", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $7e3d643c5495ec86$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $7e3d643c5495ec86$var$logger.throwError("ENS name not configured", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $is1Vq.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $is1Vq.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $7e3d643c5495ec86$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $bpZ9V.poll)(()=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $bpZ9V.poll)(()=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $bpZ9V.poll)(()=>$7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $cQEXW.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $bzgEz.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $7e3d643c5495ec86$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $7e3d643c5495ec86$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $7e3d643c5495ec86$var$logger.throwError("network does not support ENS", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $1kRIW.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $is1Vq.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $7e3d643c5495ec86$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $7e3d643c5495ec86$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $1kRIW.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $7e3d643c5495ec86$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $is1Vq.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $7e3d643c5495ec86$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $hAWyw.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $7e3d643c5495ec86$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $1kRIW.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $hAWyw.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $7e3d643c5495ec86$var$logger.throwError(method + " not implemented", (0, $hAWyw.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $7e3d643c5495ec86$export$d61e24a684f9e51($7e3d643c5495ec86$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $7e3d643c5495ec86$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $7e3d643c5495ec86$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $7e3d643c5495ec86$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $7e3d643c5495ec86$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $7e3d643c5495ec86$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRegister("9DtaX", function(module, exports) {

$parcel$export(module.exports, "decode", () => $703e634227e7fbf6$export$2f872c0f2117be69);
$parcel$export(module.exports, "encode", () => $703e634227e7fbf6$export$c564cdbbe6da493);

var $is1Vq = parcelRequire("is1Vq");
"use strict";
function $703e634227e7fbf6$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $is1Vq.arrayify)(data);
}
function $703e634227e7fbf6$export$c564cdbbe6da493(data) {
    data = (0, $is1Vq.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("1kRIW", function(module, exports) {

$parcel$export(module.exports, "isValidName", () => $0f91552a41b869ef$export$cce2300886e7ace6);
$parcel$export(module.exports, "namehash", () => $0f91552a41b869ef$export$91d651ee363e1209);
$parcel$export(module.exports, "dnsEncode", () => $0f91552a41b869ef$export$6c0a8cdae51cb512);

var $is1Vq = parcelRequire("is1Vq");

var $itjXq = parcelRequire("itjXq");

var $koabN = parcelRequire("koabN");

var $hAWyw = parcelRequire("hAWyw");

var $iR7JF = parcelRequire("iR7JF");

var $2adzT = parcelRequire("2adzT");
const $0f91552a41b869ef$var$logger = new (0, $hAWyw.Logger)((0, $iR7JF.version));
const $0f91552a41b869ef$var$Zeros = new Uint8Array(32);
$0f91552a41b869ef$var$Zeros.fill(0);
function $0f91552a41b869ef$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $0f91552a41b869ef$var$ensNameSplit(name) {
    const bytes = (0, $itjXq.toUtf8Bytes)((0, $2adzT.ens_normalize)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($0f91552a41b869ef$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($0f91552a41b869ef$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $0f91552a41b869ef$export$5f232fd2f1a1e8ac(name) {
    return $0f91552a41b869ef$var$ensNameSplit(name).map((comp)=>(0, $itjXq.toUtf8String)(comp)).join(".");
}
function $0f91552a41b869ef$export$cce2300886e7ace6(name) {
    try {
        return $0f91552a41b869ef$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $0f91552a41b869ef$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $0f91552a41b869ef$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $0f91552a41b869ef$var$Zeros;
    const comps = $0f91552a41b869ef$var$ensNameSplit(name);
    while(comps.length)result = (0, $koabN.keccak256)((0, $is1Vq.concat)([
        result,
        (0, $koabN.keccak256)(comps.pop())
    ]));
    return (0, $is1Vq.hexlify)(result);
}
function $0f91552a41b869ef$export$6c0a8cdae51cb512(name) {
    return (0, $is1Vq.hexlify)((0, $is1Vq.concat)($0f91552a41b869ef$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("2adzT", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", () => $19370c3b7d9ecf75$export$499f715881831a51);
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $itjXq = parcelRequire("itjXq");

var $2tl1y = parcelRequire("2tl1y");

var $kPn77 = parcelRequire("kPn77");
const $19370c3b7d9ecf75$var$r = (0, $2tl1y.getData)();
// @TODO: This should be lazily loaded
const $19370c3b7d9ecf75$var$VALID = new Set((0, $kPn77.read_member_array)($19370c3b7d9ecf75$var$r));
const $19370c3b7d9ecf75$var$IGNORED = new Set((0, $kPn77.read_member_array)($19370c3b7d9ecf75$var$r));
const $19370c3b7d9ecf75$var$MAPPED = (0, $kPn77.read_mapped_map)($19370c3b7d9ecf75$var$r);
const $19370c3b7d9ecf75$var$EMOJI_ROOT = (0, $kPn77.read_emoji_trie)($19370c3b7d9ecf75$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $19370c3b7d9ecf75$var$HYPHEN = 0x2D;
const $19370c3b7d9ecf75$var$UNDERSCORE = 0x5F;
function $19370c3b7d9ecf75$var$explode_cp(name) {
    return (0, $itjXq.toUtf8CodePoints)(name);
}
function $19370c3b7d9ecf75$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $19370c3b7d9ecf75$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $19370c3b7d9ecf75$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($19370c3b7d9ecf75$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $19370c3b7d9ecf75$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $19370c3b7d9ecf75$var$HYPHEN && cps[3] === $19370c3b7d9ecf75$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $19370c3b7d9ecf75$export$499f715881831a51(name) {
    return $19370c3b7d9ecf75$export$5252e54b57fcf4fd($19370c3b7d9ecf75$var$normalize(name, $19370c3b7d9ecf75$var$filter_fe0f));
}
function $19370c3b7d9ecf75$var$normalize(name, emoji_filter) {
    let input = $19370c3b7d9ecf75$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $19370c3b7d9ecf75$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($19370c3b7d9ecf75$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($19370c3b7d9ecf75$var$IGNORED.has(cp)) continue;
        let cps = $19370c3b7d9ecf75$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $19370c3b7d9ecf75$export$5252e54b57fcf4fd($19370c3b7d9ecf75$var$nfc(String.fromCodePoint(...output)));
}
function $19370c3b7d9ecf75$var$nfc(s) {
    return s.normalize("NFC");
}
function $19370c3b7d9ecf75$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $19370c3b7d9ecf75$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}

});
parcelRegister("2tl1y", function(module, exports) {

$parcel$export(module.exports, "getData", () => $1cce992742fbb25a$export$7a171f172be0782e);
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $9DtaX = parcelRequire("9DtaX");

var $kPn77 = parcelRequire("kPn77");
function $1cce992742fbb25a$export$7a171f172be0782e() {
    return (0, $kPn77.read_compressed_payload)((0, $9DtaX.decode)("AEQF2AO2DEsA2wIrAGsBRABxAN8AZwCcAEwAqgA0AGwAUgByADcATAAVAFYAIQAyACEAKAAYAFgAGwAjABQAMAAmADIAFAAfABQAKwATACoADgAbAA8AHQAYABoAGQAxADgALAAoADwAEwA9ABMAGgARAA4ADwAWABMAFgAIAA8AHgQXBYMA5BHJAS8JtAYoAe4AExozi0UAH21tAaMnBT8CrnIyhrMDhRgDygIBUAEHcoFHUPe8AXBjAewCjgDQR8IICIcEcQLwATXCDgzvHwBmBoHNAqsBdBcUAykgDhAMShskMgo8AY8jqAQfAUAfHw8BDw87MioGlCIPBwZCa4ELatMAAMspJVgsDl8AIhckSg8XAHdvTwBcIQEiDT4OPhUqbyECAEoAS34Aej8Ybx83JgT/Xw8gHxZ/7w8RICxPHA9vBw+Pfw8PHwAPFv+fAsAvCc8vEr8ivwD/EQ8Bol8OEBa/A78hrwAPCU8vESNvvwWfHwNfAVoDHr+ZAAED34YaAdJPAK7PLwSEgDLHAGo1Pz8Pvx9fUwMrpb8O/58VTzAPIBoXIyQJNF8hpwIVAT8YGAUADDNBaX3RAMomJCg9EhUeA29MABsZBTMNJipjOhc19gcIDR8bBwQHEggCWi6DIgLuAQYA+BAFCha3A5XiAEsqM7UFFgFLhAMjFTMYE1Klnw74nRVBG/ASCm0BYRN/BrsU3VoWy+S0vV8LQx+vN8gF2AC2AK5EAWwApgYDKmAAroQ0NDQ0AT+OCg7wAAIHRAbpNgVcBV0APTA5BfbPFgMLzcYL/QqqA82eBALKCjQCjqYCht0/k2+OAsXQAoP3ASTKDgDw6ACKAUYCMpIKJpRaAE4A5womABzZvs0REEKiACIQAd5QdAECAj4Ywg/wGqY2AVgAYADYvAoCGAEubA0gvAY2ALAAbpbvqpyEAGAEpgQAJgAG7gAgAEACmghUFwCqAMpAINQIwC4DthRAAPcycKgApoIdABwBfCisABoATwBqASIAvhnSBP8aH/ECeAKXAq40NjgDBTwFYQU6AXs3oABgAD4XNgmcCY1eCl5tIFZeUqGgyoNHABgAEQAaABNwWQAmABMATPMa3T34ADldyprmM1M2XociUQgLzvwAXT3xABgAEQAaABNwIGFAnADD8AAgAD4BBJWzaCcIAIEBFMAWwKoAAdq9BWAF5wLQpALEtQAKUSGkahR4GnJM+gsAwCgeFAiUAECQ0BQuL8AAIAAAADKeIheclvFqQAAETr4iAMxIARMgAMIoHhQIAn0E0pDQFC4HhznoAAAAIAI2C0/4lvFqQAAETgBJJwYCAy4ABgYAFAA8MBKYEH4eRhTkAjYeFcgACAYAeABsOqyQ5gRwDayqugEgaIIAtgoACgDmEABmBAWGme5OBJJA2m4cDeoAmITWAXwrMgOgAGwBCh6CBXYF1Tzg1wKAAFdiuABRAFwAXQBsAG8AdgBrAHYAbwCEAHEwfxQBVE5TEQADVFhTBwBDANILAqcCzgLTApQCrQL6vAAMAL8APLhNBKkE6glGKTAU4Dr4N2EYEwBCkABKk8rHAbYBmwIoAiU4Ajf/Aq4CowCAANIChzgaNBsCsTgeODcFXrgClQKdAqQBiQGYAqsCsjTsNHsfNPA0ixsAWTWiOAMFPDQSNCk2BDZHNow2TTZUNhk28Jk9VzI3QkEoAoICoQKwAqcAQAAxBV4FXbS9BW47YkIXP1ciUqs05DS/FwABUwJW11e6nHuYZmSh/RAYA8oMKvZ8KASoUAJYWAJ6ILAsAZSoqjpgA0ocBIhmDgDWAAawRDQoAAcuAj5iAHABZiR2AIgiHgCaAU68ACxuHAG0ygM8MiZIAlgBdF4GagJqAPZOHAMuBgoATkYAsABiAHgAMLoGDPj0HpKEBAAOJgAuALggTAHWAeAMEDbd20Uege0ADwAWADkAQgA9OHd+2MUQZBBhBgNNDkxxPxUQArEPqwvqERoM1irQ090ANK4H8ANYB/ADWANYB/AH8ANYB/ADWANYA1gDWBwP8B/YxRBkD00EcgWTBZAE2wiIJk4RhgctCNdUEnQjHEwDSgEBIypJITuYMxAlR0wRTQgIATZHbKx9PQNMMbBU+pCnA9AyVDlxBgMedhKlAC8PeCE1uk6DekxxpQpQT7NX9wBFBgASqwAS5gBJDSgAUCwGPQBI4zTYABNGAE2bAE3KAExdGABKaAbgAFBXAFCOAFBJABI2SWdObALDOq0//QomCZhvwHdTBkIQHCemEPgMNAG2ATwN7kvZBPIGPATKH34ZGg/OlZ0Ipi3eDO4m5C6igFsj9iqEBe5L9TzeC05RaQ9aC2YJ5DpkgU8DIgEOIowK3g06CG4Q9ArKbA3mEUYHOgPWSZsApgcCCxIdNhW2JhFirQsKOXgG/Br3C5AmsBMqev0F1BoiBk4BKhsAANAu6IWxWjJcHU9gBgQLJiPIFKlQIQ0mQLh4SRocBxYlqgKSQ3FKiFE3HpQh9zw+DWcuFFF9B/Y8BhlQC4I8n0asRQ8R0z6OPUkiSkwtBDaALDAnjAnQD4YMunxzAVoJIgmyDHITMhEYN8YIOgcaLpclJxYIIkaWYJsE+KAD9BPSAwwFQAlCBxQDthwuEy8VKgUOgSXYAvQ21i60ApBWgQEYBcwPJh/gEFFH4Q7qCJwCZgOEJewALhUiABginAhEZABgj9lTBi7MCMhqbSN1A2gU6GIRdAeSDlgHqBw0FcAc4nDJXgyGCSiksAlcAXYJmgFgBOQICjVcjKEgQmdUi1kYnCBiQUBd/QIyDGYVoES+h3kCjA9sEhwBNgF0BzoNAgJ4Ee4RbBCWCOyGBTW2M/k6JgRQIYQgEgooA1BszwsoJvoM+WoBpBJjAw00PnfvZ6xgtyUX/gcaMsZBYSHyC5NPzgydGsIYQ1QvGeUHwAP0GvQn60FYBgADpAQUOk4z7wS+C2oIjAlAAEoOpBgH2BhrCnKM0QEyjAG4mgNYkoQCcJAGOAcMAGgMiAV65gAeAqgIpAAGANADWAA6Aq4HngAaAIZCAT4DKDABIuYCkAOUCDLMAZYwAfQqBBzEDBYA+DhuSwLDsgKAa2ajBd5ZAo8CSjYBTiYEBk9IUgOwcuIA3ABMBhTgSAEWrEvMG+REAeBwLADIAPwABjYHBkIBzgH0bgC4AWALMgmjtLYBTuoqAIQAFmwB2AKKAN4ANgCA8gFUAE4FWvoF1AJQSgESMhksWGIBvAMgATQBDgB6BsyOpsoIIARuB9QCEBwV4gLvLwe2AgMi4BPOQsYCvd9WADIXUu5eZwqoCqdeaAC0YTQHMnM9UQAPH6k+yAdy/BZIiQImSwBQ5gBQQzSaNTFWSTYBpwGqKQK38AFtqwBI/wK37gK3rQK3sAK6280C0gK33AK3zxAAUEIAUD9SklKDArekArw5AEQAzAHCO147WTteO1k7XjtZO147WTteO1kDmChYI03AVU0oJqkKbV9GYewMpw3VRMk6ShPcYFJgMxPJLbgUwhXPJVcZPhq9JwYl5VUKDwUt1GYxCC00dhe9AEApaYNCY4ceMQpMHOhTklT5LRwAskujM7ANrRsWREEFSHXuYisWDwojAmSCAmJDXE6wXDchAqH4AmiZAmYKAp+FOBwMAmY8AmYnBG8EgAN/FAN+kzkHOXgYOYM6JCQCbB4CMjc4CwJtyAJtr/CLADRoRiwBaADfAOIASwYHmQyOAP8MwwAOtgJ3MAJ2o0ACeUxEAni7Hl3cRa9G9AJ8QAJ6yQJ9CgJ88UgBSH5kJQAsFklZSlwWGErNAtECAtDNSygDiFADh+dExpEzAvKiXQQDA69Lz0wuJgTQTU1NsAKLQAKK2cIcCB5EaAa4Ao44Ao5dQZiCAo7aAo5deVG1UzYLUtVUhgKT/AKTDQDqAB1VH1WwVdEHLBwplocy4nhnRTw6ApegAu+zWCKpAFomApaQApZ9nQCqWa1aCoJOADwClrYClk9cRVzSApnMApllXMtdCBoCnJw5wzqeApwXAp+cAp65iwAeEDIrEAKd8gKekwC2PmE1YfACntQCoG8BqgKeoCACnk+mY8lkKCYsAiewAiZ/AqD8AqBN2AKmMAKlzwKoAAB+AqfzaH1osgAESmodatICrOQCrK8CrWgCrQMCVx4CVd0CseLYAx9PbJgCsr4OArLpGGzhbWRtSWADJc4Ctl08QG6RAylGArhfArlIFgK5K3hwN3DiAr0aAy2zAzISAr6JcgMDM3ICvhtzI3NQAsPMAsMFc4N0TDZGdOEDPKgDPJsDPcACxX0CxkgCxhGKAshqUgLIRQLJUALJLwJkngLd03h6YniveSZL0QMYpGcDAmH1GfSVJXsMXpNevBICz2wCz20wTFTT9BSgAMeuAs90ASrrA04TfkwGAtwoAtuLAtJQA1JdA1NgAQIDVY2AikABzBfuYUZ2AILPg44C2sgC2d+EEYRKpz0DhqYAMANkD4ZyWvoAVgLfZgLeuXR4AuIw7RUB8zEoAfScAfLTiALr9ALpcXoAAur6AurlAPpIAboC7ooC652Wq5cEAu5AA4XhmHpw4XGiAvMEAGoDjheZlAL3FAORbwOSiAL3mQL52gL4Z5odmqy8OJsfA52EAv77ARwAOp8dn7QDBY4DpmsDptoA0sYDBmuhiaIGCgMMSgFgASACtgNGAJwEgLpoBgC8BGzAEowcggCEDC6kdjoAJAM0C5IKRoABZCgiAIzw3AYBLACkfng9ogigkgNmWAN6AEQCvrkEVqTGAwCsBRbAA+4iQkMCHR072jI2PTbUNsk2RjY5NvA23TZKNiU3EDcZN5I+RTxDRTBCJkK5VBYKFhZfwQCWygU3AJBRHpu+OytgNxa61A40GMsYjsn7BVwFXQVcBV0FaAVdBVwFXQVcBV0FXAVdBVwFXUsaCNyKAK4AAQUHBwKU7oICoW1e7jAEzgPxA+YDwgCkBFDAwADABKzAAOxFLhitA1UFTDeyPkM+bj51QkRCuwTQWWQ8X+0AWBYzsACNA8xwzAGm7EZ/QisoCTAbLDs6fnLfb8H2GccsbgFw13M1HAVkBW/Jxsm9CNRO8E8FDD0FBQw9FkcClOYCoMFegpDfADgcMiA2AJQACB8AsigKAIzIEAJKeBIApY5yPZQIAKQiHb4fvj5BKSRPQrZCOz0oXyxgOywfKAnGbgMClQaCAkILXgdeCD9IIGUgQj5fPoY+dT52Ao5CM0dAX9BTVG9SDzFwWTQAbxBzJF/lOEIQQglCCkKJIAls5AcClQICoKPMODEFxhi6KSAbiyfIRrMjtCgdWCAkPlFBIitCsEJRzAbMAV/OEyQzDg0OAQQEJ36i328/Mk9AybDJsQlq3tDRApUKAkFzXf1d/j9uALYP6hCoFgCTGD8kPsFKQiobrm0+zj0KSD8kPnVCRBwMDyJRTHFgMTJa5rwXQiQ2YfI/JD7BMEJEHGINTw4TOFlIRzwJO0icMQpyPyQ+wzJCRBv6DVgnKB01NgUKj2bwYzMqCoBkznBgEF+zYDIocwRIX+NgHj4HICNfh2C4CwdwFWpTG/lgUhYGAwRfv2Ts8mAaXzVgml/XYIJfuWC4HI1gUF9pYJZgMR6ilQHMAOwLAlDRefC0in4AXAEJA6PjCwc0IamOANMMCAECRQDFNRTZBgd+CwQlRA+r6+gLBDEFBnwUBXgKATIArwAGRAAHA3cDdAN2A3kDdwN9A3oDdQN7A30DfAN4A3oDfQAYEAAlAtYASwMAUAFsAHcKAHcAmgB3AHUAdQB2AHVu8UgAygDAAHcAdQB1AHYAdQALCgB3AAsAmgB3AAsCOwB3AAtu8UgAygDAAHgKAJoAdwB3AHUAdQB2AHUAeAB1AHUAdgB1bvFIAMoAwAALCgCaAHcACwB3AAsCOwB3AAtu8UgAygDAAH4ACwGgALcBpwC6AahdAu0COwLtbvFIAMoAwAALCgCaAu0ACwLtAAsCOwLtAAtu8UgAygDAA24ACwNvAAu0VsQAAzsAABCkjUIpAAsAUIusOggWcgMeBxVsGwL67U/2HlzmWOEeOgALASvuAAseAfpKUpnpGgYJDCIZM6YyARUE9ThqAD5iXQgnAJYJPnOzw0ZAEZxEKsIAkA4DhAHnTAIDxxUDK0lxCQlPYgIvIQVYJQBVqE1GakUAKGYiDToSBA1EtAYAXQJYAIF8GgMHRyAAIAjOe9YncekRAA0KACUrjwE7Ayc6AAYWAqaiKG4McEcqANoN3+Mg9TwCBhIkuCny+JwUQ29L008JluRxu3K+oAdqiHOqFH0AG5SUIfUJ5SxCGfxdipRzqTmT4V5Zb+r1Uo4Vm+NqSSEl2mNvR2JhIa8SpYO6ntdwFXHCWTCK8f2+Hxo7uiG3drDycAuKIMP5bhi06ACnqArH1rz4Rqg//lm6SgJGEVbF9xJHISaR6HxqxSnkw6shDnelHKNEfGUXSJRJ1GcsmtJw25xrZMDK9gXSm1/YMkdX4/6NKYOdtk/NQ3/NnDASjTc3fPjIjW/5sVfVObX2oTDWkr1dF9f3kxBsD3/3aQO8hPfRz+e0uEiJqt1161griu7gz8hDDwtpy+F+BWtefnKHZPAxcZoWbnznhJpy0e842j36bcNzGnIEusgGX0a8ZxsnjcSsPDZ09yZ36fCQbriHeQ72JRMILNl6ePPf2HWoVwgWAm1fb3V2sAY0+B6rAXqSwPBgseVmoqsBTSrm91+XasMYYySI8eeRxH3ZvHkMz3BQ5aJ3iUVbYPNM3/7emRtjlsMgv/9VyTsyt/mK+8fgWeT6SoFaclXqn42dAIsvAarF5vNNWHzKSkKQ/8Hfk5ZWK7r9yliOsooyBjRhfkHP4Q2DkWXQi6FG/9r/IwbmkV5T7JSopHKn1pJwm9tb5Ot0oyN1Z2mPpKXHTxx2nlK08fKk1hEYA8WgVVWL5lgx0iTv+KdojJeU23ZDjmiubXOxVXJKKi2Wjuh2HLZOFLiSC7Tls5SMh4f+Pj6xUSrNjFqLGehRNB8lC0QSLNmkJJx/wSG3MnjE9T1CkPwJI0wH2lfzwETIiVqUxg0dfu5q39Gt+hwdcxkhhNvQ4TyrBceof3Mhs/IxFci1HmHr4FMZgXEEczPiGCx0HRwzAqDq2j9AVm1kwN0mRVLWLylgtoPNapF5cY4Y1wJh/e0BBwZj44YgZrDNqvD/9Hv7GFYdUQeDJuQ3EWI4HaKqavU1XjC/n41kT4L79kqGq0kLhdTZvgP3TA3fS0ozVz+5piZsoOtIvBUFoMKbNcmBL6YxxaUAusHB38XrS8dQMnQwJfUUkpRoGr5AUeWicvBTzyK9g77+yCkf5PAysL7r/JjcZgrbvRpMW9iyaxZvKO6ceZN2EwIxKwVFPuvFuiEPGCoagbMo+SpydLrXqBzNCDGFCrO/rkcwa2xhokQZ5CdZ0AsU3JfSqJ6n5I14YA+P/uAgfhPU84Tlw7cEFfp7AEE8ey4sP12PTt4Cods1GRgDOB5xvyiR5m+Bx8O5nBCNctU8BevfV5A08x6RHd5jcwPTMDSZJOedIZ1cGQ704lxbAzqZOP05ZxaOghzSdvFBHYqomATARyAADK4elP8Ly3IrUZKfWh23Xy20uBUmLS4Pfagu9+oyVa2iPgqRP3F2CTUsvJ7+RYnN8fFZbU/HVvxvcFFDKkiTqV5UBZ3Gz54JAKByi9hkKMZJvuGgcSYXFmw08UyoQyVdfTD1/dMkCHXcTGAKeROgArsvmRrQTLUOXioOHGK2QkjHuoYFgXciZoTJd6Fs5q1QX1G+p/e26hYsEf7QZD1nnIyl/SFkNtYYmmBhpBrxl9WbY0YpHWRuw2Ll/tj9mD8P4snVzJl4F9J+1arVeTb9E5r2ILH04qStjxQNwn3m4YNqxmaNbLAqW2TN6LidwuJRqS+NXbtqxoeDXpxeGWmxzSkWxjkyCkX4NQRme6q5SAcC+M7+9ETfA/EwrzQajKakCwYyeunP6ZFlxU2oMEn1Pz31zeStW74G406ZJFCl1wAXIoUKkWotYEpOuXB1uVNxJ63dpJEqfxBeptwIHNrPz8BllZoIcBoXwgfJ+8VAUnVPvRvexnw0Ma/WiGYuJO5y8QTvEYBigFmhUxY5RqzE8OcywN/8m4UYrlaniJO75XQ6KSo9+tWHlu+hMi0UVdiKQp7NelnoZUzNaIyBPVeOwK6GNp+FfHuPOoyhaWuNvTYFkvxscMQWDh+zeFCFkgwbXftiV23ywJ4+uwRqmg9k3KzwIQpzppt8DBBOMbrqwQM5Gb05sEwdKzMiAqOloaA/lr0KA+1pr0/+HiWoiIjHA/wir2nIuS3PeU/ji3O6ZwoxcR1SZ9FhtLC5S0FIzFhbBWcGVP/KpxOPSiUoAdWUpqKH++6Scz507iCcxYI6rdMBICPJZea7OcmeFw5mObJSiqpjg2UoWNIs+cFhyDSt6geV5qgi3FunmwwDoGSMgerFOZGX1m0dMCYo5XOruxO063dwENK9DbnVM9wYFREzh4vyU1WYYJ/LRRp6oxgjqP/X5a8/4Af6p6NWkQferzBmXme0zY/4nwMJm/wd1tIqSwGz+E3xPEAOoZlJit3XddD7/BT1pllzOx+8bmQtANQ/S6fZexc6qi3W+Q2xcmXTUhuS5mpHQRvcxZUN0S5+PL9lXWUAaRZhEH8hTdAcuNMMCuVNKTEGtSUKNi3O6KhSaTzck8csZ2vWRZ+d7mW8c4IKwXIYd25S/zIftPkwPzufjEvOHWVD1m+FjpDVUTV0DGDuHj6QnaEwLu/dEgdLQOg9E1Sro9XHJ8ykLAwtPu+pxqKDuFexqON1sKQm7rwbE1E68UCfA/erovrTCG+DBSNg0l4goDQvZN6uNlbyLpcZAwj2UclycvLpIZMgv4yRlpb3YuMftozorbcGVHt/VeDV3+Fdf1TP0iuaCsPi2G4XeGhsyF1ubVDxkoJhmniQ0/jSg/eYML9KLfnCFgISWkp91eauR3IQvED0nAPXK+6hPCYs+n3+hCZbiskmVMG2da+0EsZPonUeIY8EbfusQXjsK/eFDaosbPjEfQS0RKG7yj5GG69M7MeO1HmiUYocgygJHL6M1qzUDDwUSmr99V7Sdr2F3JjQAJY+F0yH33Iv3+C9M38eML7gTgmNu/r2bUMiPvpYbZ6v1/IaESirBHNa7mPKn4dEmYg7v/+HQgPN1G79jBQ1+soydfDC2r+h2Bl/KIc5KjMK7OH6nb1jLsNf0EHVe2KBiE51ox636uyG6Lho0t3J34L5QY/ilE3mikaF4HKXG1mG1rCevT1Vv6GavltxoQe/bMrpZvRggnBxSEPEeEzkEdOxTnPXHVjUYdw8JYvjB/o7Eegc3Ma+NUxLLnsK0kJlinPmUHzHGtrk5+CAbVzFOBqpyy3QVUnzTDfC/0XD94/okH+OB+i7g9lolhWIjSnfIb+Eq43ZXOWmwvjyV/qqD+t0e+7mTEM74qP/Ozt8nmC7mRpyu63OB4KnUzFc074SqoyPUAgM+/TJGFo6T44EHnQU4X4z6qannVqgw/U7zCpwcmXV1AubIrvOmkKHazJAR55ePjp5tLBsN8vAqs3NAHdcEHOR2xQ0lsNAFzSUuxFQCFYvXLZJdOj9p4fNq6p0HBGUik2YzaI4xySy91KzhQ0+q1hjxvImRwPRf76tChlRkhRCi74NXZ9qUNeIwP+s5p+3m5nwPdNOHgSLD79n7O9m1n1uDHiMntq4nkYwV5OZ1ENbXxFd4PgrlvavZsyUO4MqYlqqn1O8W/I1dEZq5dXhrbETLaZIbC2Kj/Aa/QM+fqUOHdf0tXAQ1huZ3cmWECWSXy/43j35+Mvq9xws7JKseriZ1pEWKc8qlzNrGPUGcVgOa9cPJYIJsGnJTAUsEcDOEVULO5x0rXBijc1lgXEzQQKhROf8zIV82w8eswc78YX11KYLWQRcgHNJElBxfXr72lS2RBSl07qTKorO2uUDZr3sFhYsvnhLZn0A94KRzJ/7DEGIAhW5ZWFpL8gEwu1aLA9MuWZzNwl8Oze9Y+bX+v9gywRVnoB5I/8kXTXU3141yRLYrIOOz6SOnyHNy4SieqzkBXharjfjqq1q6tklaEbA8Qfm2DaIPs7OTq/nvJBjKfO2H9bH2cCMh1+5gspfycu8f/cuuRmtDjyqZ7uCIMyjdV3a+p3fqmXsRx4C8lujezIFHnQiVTXLXuI1XrwN3+siYYj2HHTvESUx8DlOTXpak9qFRK+L3mgJ1WsD7F4cu1aJoFoYQnu+wGDMOjJM3kiBQWHCcvhJ/HRdxodOQp45YZaOTA22Nb4XKCVxqkbwMYFhzYQYIAnCW8FW14uf98jhUG2zrKhQQ0q0CEq0t5nXyvUyvR8DvD69LU+g3i+HFWQMQ8PqZuHD+sNKAV0+M6EJC0szq7rEr7B5bQ8BcNHzvDMc9eqB5ZCQdTf80Obn4uzjwpYU7SISdtV0QGa9D3Wrh2BDQtpBKxaNFV+/Cy2P/Sv+8s7Ud0Fd74X4+o/TNztWgETUapy+majNQ68Lq3ee0ZO48VEbTZYiH1Co4OlfWef82RWeyUXo7woM03PyapGfikTnQinoNq5z5veLpeMV3HCAMTaZmA1oGLAn7XS3XYsz+XK7VMQsc4XKrmDXOLU/pSXVNUq8dIqTba///3x6LiLS6xs1xuCAYSfcQ3+rQgmu7uvf3THKt5Ooo97TqcbRqxx7EASizaQCBQllG/rYxVapMLgtLbZS64w1MDBMXX+PQpBKNwqUKOf2DDRDUXQf9EhOS0Qj4nTmlA8dzSLz/G1d+Ud8MTy/6ghhdiLpeerGY/UlDOfiuqFsMUU5/UYlP+BAmgRLuNpvrUaLlVkrqDievNVEAwF+4CoM1MZTmjxjJMsKJq+u8Zd7tNCUFy6LiyYXRJQ4VyvEQFFaCGKsxIwQkk7EzZ6LTJq2hUuPhvAW+gQnSG6J+MszC+7QCRHcnqDdyNRJ6T9xyS87A6MDutbzKGvGktpbXqtzWtXb9HsfK2cBMomjN9a4y+TaJLnXxAeX/HWzmf4cR4vALt/P4w4qgKY04ml4ZdLOinFYS6cup3G/1ie4+t1eOnpBNlqGqs75ilzkT4+DsZQxNvaSKJ//6zIbbk/M7LOhFmRc/1R+kBtz7JFGdZm/COotIdvQoXpTqP/1uqEUmCb/QWoGLMwO5ANcHzxdY48IGP5+J+zKOTBFZ4Pid+GTM+Wq12MV/H86xEJptBa6T+p3kgpwLedManBHC2GgNrFpoN2xnrMz9WFWX/8/ygSBkavq2Uv7FdCsLEYLu9LLIvAU0bNRDtzYl+/vXmjpIvuJFYjmI0im6QEYqnIeMsNjXG4vIutIGHijeAG/9EDBozKV5cldkHbLxHh25vT+ZEzbhXlqvpzKJwcEgfNwLAKFeo0/pvEE10XDB+EXRTXtSzJozQKFFAJhMxYkVaCW+E9AL7tMeU8acxidHqzb6lX4691UsDpy/LLRmT+epgW56+5Cw8tB4kMUv6s9lh3eRKbyGs+H/4mQMaYzPTf2OOdokEn+zzgvoD3FqNKk8QqGAXVsqcGdXrT62fSPkR2vROFi68A6se86UxRUk4cajfPyCC4G5wDhD+zNq4jodQ4u4n/m37Lr36n4LIAAsVr02dFi9AiwA81MYs2rm4eDlDNmdMRvEKRHfBwW5DdMNp0jPFZMeARqF/wL4XBfd+EMLBfMzpH5GH6NaW+1vrvMdg+VxDzatk3MXgO3ro3P/DpcC6+Mo4MySJhKJhSR01SGGGp5hPWmrrUgrv3lDnP+HhcI3nt3YqBoVAVTBAQT5iuhTg8nvPtd8ZeYj6w1x6RqGUBrSku7+N1+BaasZvjTk64RoIDlL8brpEcJx3OmY7jLoZsswdtmhfC/G21llXhITOwmvRDDeTTPbyASOa16cF5/A1fZAidJpqju3wYAy9avPR1ya6eNp9K8XYrrtuxlqi+bDKwlfrYdR0RRiKRVTLOH85+ZY7XSmzRpfZBJjaTa81VDcJHpZnZnSQLASGYW9l51ZV/h7eVzTi3Hv6hUsgc/51AqJRTkpbFVLXXszoBL8nBX0u/0jBLT8nH+fJePbrwURT58OY+UieRjd1vs04w0VG5VN2U6MoGZkQzKN/ptz0Q366dxoTGmj7i1NQGHi9GgnquXFYdrCfZBmeb7s0T6yrdlZH5cZuwHFyIJ/kAtGsTg0xH5taAAq44BAk1CPk9KVVbqQzrCUiFdF/6gtlPQ8bHHc1G1W92MXGZ5HEHftyLYs8mbD/9xYRUWkHmlM0zC2ilJlnNgV4bfALpQghxOUoZL7VTqtCHIaQSXm+YUMnpkXybnV+A6xlm2CVy8fn0Xlm2XRa0+zzOa21JWWmixfiPMSCZ7qA4rS93VN3pkpF1s5TonQjisHf7iU9ZGvUPOAKZcR1pbeVf/Ul7OhepGCaId9wOtqo7pJ7yLcBZ0pFkOF28y4zEI/kcUNmutBHaQpBdNM8vjCS6HZRokkeo88TBAjGyG7SR+6vUgTcyK9Imalj0kuxz0wmK+byQU11AiJFk/ya5dNduRClcnU64yGu/ieWSeOos1t3ep+RPIWQ2pyTYVbZltTbsb7NiwSi3AV+8KLWk7LxCnfZUetEM8ThnsSoGH38/nyAwFguJp8FjvlHtcWZuU4hPva0rHfr0UhOOJ/F6vS62FW7KzkmRll2HEc7oUq4fyi5T70Vl7YVIfsPHUCdHesf9Lk7WNVWO75JDkYbMI8TOW8JKVtLY9d6UJRITO8oKo0xS+o99Yy04iniGHAaGj88kEWgwv0OrHdY/nr76DOGNS59hXCGXzTKUvDl9iKpLSWYN1lxIeyywdNpTkhay74w2jFT6NS8qkjo5CxA1yfSYwp6AJIZNKIeEK5PJAW7ORgWgwp0VgzYpqovMrWxbu+DGZ6Lhie1RAqpzm8VUzKJOH3mCzWuTOLsN3VT/dv2eeYe9UjbR8YTBsLz7q60VN1sU51k+um1f8JxD5pPhbhSC8rRaB454tmh6YUWrJI3+GWY0qeWioj/tbkYITOkJaeuGt4JrJvHA+l0Gu7kY7XOaa05alMnRWVCXqFgLIwSY4uF59Ue5SU4QKuc/HamDxbr0x6csCetXGoP7Qn1Bk/J9DsynO/UD6iZ1Hyrz+jit0hDCwi/E9OjgKTbB3ZQKQ/0ZOvevfNHG0NK4Aj3Cp7NpRk07RT1i/S0EL93Ag8GRgKI9CfpajKyK6+Jj/PI1KO5/85VAwz2AwzP8FTBb075IxCXv6T9RVvWT2tUaqxDS92zrGUbWzUYk9mSs82pECH+fkqsDt93VW++4YsR/dHCYcQSYTO/KaBMDj9LSD/J/+z20Kq8XvZUAIHtm9hRPP3ItbuAu2Hm5lkPs92pd7kCxgRs0xOVBnZ13ccdA0aunrwv9SdqElJRC3g+oCu+nXyCgmXUs9yMjTMAIHfxZV+aPKcZeUBWt057Xo85Ks1Ir5gzEHCWqZEhrLZMuF11ziGtFQUds/EESajhagzcKsxamcSZxGth4UII+adPhQkUnx2WyN+4YWR+r3f8MnkyGFuR4zjzxJS8WsQYR5PTyRaD9ixa6Mh741nBHbzfjXHskGDq179xaRNrCIB1z1xRfWfjqw2pHc1zk9xlPpL8sQWAIuETZZhbnmL54rceXVNRvUiKrrqIkeogsl0XXb17ylNb0f4GA9Wd44vffEG8FSZGHEL2fbaTGRcSiCeA8PmA/f6Hz8HCS76fXUHwgwkzSwlI71ekZ7Fapmlk/KC+Hs8hUcw3N2LN5LhkVYyizYFl/uPeVP5lsoJHhhfWvvSWruCUW1ZcJOeuTbrDgywJ/qG07gZJplnTvLcYdNaH0KMYOYMGX+rB4NGPFmQsNaIwlWrfCezxre8zXBrsMT+edVLbLqN1BqB76JH4BvZTqUIMfGwPGEn+EnmTV86fPBaYbFL3DFEhjB45CewkXEAtJxk4/Ms2pPXnaRqdky0HOYdcUcE2zcXq4vaIvW2/v0nHFJH2XXe22ueDmq/18XGtELSq85j9X8q0tcNSSKJIX8FTuJF/Pf8j5PhqG2u+osvsLxYrvvfeVJL+4tkcXcr9JV7v0ERmj/X6fM3NC4j6dS1+9Umr2oPavqiAydTZPLMNRGY23LO9zAVDly7jD+70G5TPPLdhRIl4WxcYjLnM+SNcJ26FOrkrISUtPObIz5Zb3AG612krnpy15RMW+1cQjlnWFI6538qky9axd2oJmHIHP08KyP0ubGO+TQNOYuv2uh17yCIvR8VcStw7o1g0NM60sk+8Tq7YfIBJrtp53GkvzXH7OA0p8/n/u1satf/VJhtR1l8Wa6Gmaug7haSpaCaYQax6ta0mkutlb+eAOSG1aobM81D9A4iS1RRlzBBoVX6tU1S6WE2N9ORY6DfeLRC4l9Rvr5h95XDWB2mR1d4WFudpsgVYwiTwT31ljskD8ZyDOlm5DkGh9N/UB/0AI5Xvb8ZBmai2hQ4BWMqFwYnzxwB26YHSOv9WgY3JXnvoN+2R4rqGVh/LLDMtpFP+SpMGJNWvbIl5SOodbCczW2RKleksPoUeGEzrjtKHVdtZA+kfqO+rVx/iclCqwoopepvJpSTDjT+b9GWylGRF8EDbGlw6eUzmJM95Ovoz+kwLX3c2fTjFeYEsE7vUZm3mqdGJuKh2w9/QGSaqRHs99aScGOdDqkFcACoqdbBoQqqjamhH6Q9ng39JCg3lrGJwd50Qk9ovnqBTr8MME7Ps2wiVfygUmPoUBJJfJWX5Nda0nuncbFkA=="));
}

});
parcelRegister("kPn77", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", () => $f29a7ffc9ff8d4e3$export$671d8b4ebc0c42ad);
$parcel$export(module.exports, "read_member_array", () => $f29a7ffc9ff8d4e3$export$9303bf4e1ede4914);
$parcel$export(module.exports, "read_mapped_map", () => $f29a7ffc9ff8d4e3$export$824d00fb01c38bd9);
$parcel$export(module.exports, "read_emoji_trie", () => $f29a7ffc9ff8d4e3$export$d7b24c6ce369e1b7);
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $f29a7ffc9ff8d4e3$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $f29a7ffc9ff8d4e3$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $f29a7ffc9ff8d4e3$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $f29a7ffc9ff8d4e3$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $f29a7ffc9ff8d4e3$export$671d8b4ebc0c42ad(bytes) {
    return $f29a7ffc9ff8d4e3$export$2cda812f22276871($f29a7ffc9ff8d4e3$export$956eeed0f8f2ceff(bytes));
}
function $f29a7ffc9ff8d4e3$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $f29a7ffc9ff8d4e3$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $f29a7ffc9ff8d4e3$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $f29a7ffc9ff8d4e3$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $f29a7ffc9ff8d4e3$export$a785de3a2a8dd1aa(next());
    return v;
}
function $f29a7ffc9ff8d4e3$export$9303bf4e1ede4914(next, lookup) {
    let v = $f29a7ffc9ff8d4e3$var$read_ascending(next(), next);
    let n = next();
    let vX = $f29a7ffc9ff8d4e3$var$read_ascending(n, next);
    let vN = $f29a7ffc9ff8d4e3$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $f29a7ffc9ff8d4e3$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($f29a7ffc9ff8d4e3$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($f29a7ffc9ff8d4e3$var$read_replacement_table(w, next));
    }
    return $f29a7ffc9ff8d4e3$var$fromEntries($f29a7ffc9ff8d4e3$var$flat(ret));
}
function $f29a7ffc9ff8d4e3$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $f29a7ffc9ff8d4e3$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$f29a7ffc9ff8d4e3$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $f29a7ffc9ff8d4e3$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $f29a7ffc9ff8d4e3$export$e9011071590ab431(next);
    let m = $f29a7ffc9ff8d4e3$var$read_transposed(vN.length, 1 + w, next);
    return $f29a7ffc9ff8d4e3$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $f29a7ffc9ff8d4e3$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $f29a7ffc9ff8d4e3$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $f29a7ffc9ff8d4e3$export$d7b24c6ce369e1b7(next) {
    let sorted = $f29a7ffc9ff8d4e3$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $f29a7ffc9ff8d4e3$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRegister("bpZ9V", function(module, exports) {

$parcel$export(module.exports, "_fetchData", () => $8501786edf41fe0d$export$e37fa27017c6c012);
$parcel$export(module.exports, "fetchJson", () => $8501786edf41fe0d$export$6d71b655afe1638d);
$parcel$export(module.exports, "poll", () => $8501786edf41fe0d$export$e0c10349b2c5e1d4);

var $9DtaX = parcelRequire("9DtaX");

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $itjXq = parcelRequire("itjXq");

var $hAWyw = parcelRequire("hAWyw");

var $4kTbs = parcelRequire("4kTbs");

var $5WIOB = parcelRequire("5WIOB");
"use strict";
var $8501786edf41fe0d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8501786edf41fe0d$var$logger = new (0, $hAWyw.Logger)((0, $4kTbs.version));
function $8501786edf41fe0d$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $8501786edf41fe0d$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $is1Vq.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $itjXq.toUtf8String)(value);
        } catch (error) {}
        return (0, $is1Vq.hexlify)(value);
    }
    return value;
}
function $8501786edf41fe0d$var$unpercent(value) {
    return (0, $itjXq.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $8501786edf41fe0d$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $8501786edf41fe0d$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $8501786edf41fe0d$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $8501786edf41fe0d$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $8501786edf41fe0d$var$logger.throwError("basic authentication requires a secure https url", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $9DtaX.encode)((0, $itjXq.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $cQEXW.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $9DtaX.decode)(dataMatch[3]) : $8501786edf41fe0d$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $8501786edf41fe0d$var$logger.throwError("processing response error", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
            body: $8501786edf41fe0d$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($8501786edf41fe0d$var$logger.makeError("timeout", (0, $hAWyw.Logger).errors.TIMEOUT, {
                    requestBody: $8501786edf41fe0d$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $8501786edf41fe0d$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $5WIOB.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $8501786edf41fe0d$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $8501786edf41fe0d$var$logger.throwError("missing response", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                            requestBody: $8501786edf41fe0d$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $8501786edf41fe0d$var$logger.throwError("bad response", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $8501786edf41fe0d$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $8501786edf41fe0d$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $8501786edf41fe0d$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $8501786edf41fe0d$var$logger.throwError("processing response error", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                        body: $8501786edf41fe0d$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $8501786edf41fe0d$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $8501786edf41fe0d$var$logger.throwError("failed response", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                requestBody: $8501786edf41fe0d$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $8501786edf41fe0d$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $itjXq.toUtf8String)(value));
        } catch (error) {
            $8501786edf41fe0d$var$logger.throwError("invalid JSON", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $itjXq.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $cQEXW.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $cQEXW.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $8501786edf41fe0d$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $8501786edf41fe0d$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $cQEXW.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("4kTbs", function(module, exports) {

$parcel$export(module.exports, "version", () => $3283d60afdff451c$export$83d89fbfd8236492);
const $3283d60afdff451c$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRegister("5WIOB", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $454521e43f8cc42a$export$94df0e59ebebf4a7);

var $is1Vq = parcelRequire("is1Vq");
"use strict";
var $454521e43f8cc42a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $454521e43f8cc42a$export$94df0e59ebebf4a7(href, options) {
    return $454521e43f8cc42a$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $is1Vq.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRegister("1H56A", function(module, exports) {
"use strict";
var $13bdc46293750b4e$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $13bdc46293750b4e$var$ALPHABET_MAP = {};
for(var $13bdc46293750b4e$var$z = 0; $13bdc46293750b4e$var$z < $13bdc46293750b4e$var$ALPHABET.length; $13bdc46293750b4e$var$z++){
    var $13bdc46293750b4e$var$x = $13bdc46293750b4e$var$ALPHABET.charAt($13bdc46293750b4e$var$z);
    if ($13bdc46293750b4e$var$ALPHABET_MAP[$13bdc46293750b4e$var$x] !== undefined) throw new TypeError($13bdc46293750b4e$var$x + " is ambiguous");
    $13bdc46293750b4e$var$ALPHABET_MAP[$13bdc46293750b4e$var$x] = $13bdc46293750b4e$var$z;
}
function $13bdc46293750b4e$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $13bdc46293750b4e$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $13bdc46293750b4e$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $13bdc46293750b4e$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $13bdc46293750b4e$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $13bdc46293750b4e$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $13bdc46293750b4e$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $13bdc46293750b4e$var$polymodStep(chk) ^ x;
        result += $13bdc46293750b4e$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $13bdc46293750b4e$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $13bdc46293750b4e$var$ALPHABET.charAt(v);
    }
    return result;
}
function $13bdc46293750b4e$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $13bdc46293750b4e$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $13bdc46293750b4e$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $13bdc46293750b4e$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $13bdc46293750b4e$var$decodeUnsafe() {
    var res = $13bdc46293750b4e$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $13bdc46293750b4e$var$decode(str) {
    var res = $13bdc46293750b4e$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $13bdc46293750b4e$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $13bdc46293750b4e$var$toWordsUnsafe(bytes) {
    var res = $13bdc46293750b4e$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $13bdc46293750b4e$var$toWords(bytes) {
    var res = $13bdc46293750b4e$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $13bdc46293750b4e$var$fromWordsUnsafe(words) {
    var res = $13bdc46293750b4e$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $13bdc46293750b4e$var$fromWords(words) {
    var res = $13bdc46293750b4e$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $13bdc46293750b4e$var$decodeUnsafe,
    decode: $13bdc46293750b4e$var$decode,
    encode: $13bdc46293750b4e$var$encode,
    toWordsUnsafe: $13bdc46293750b4e$var$toWordsUnsafe,
    toWords: $13bdc46293750b4e$var$toWords,
    fromWordsUnsafe: $13bdc46293750b4e$var$fromWordsUnsafe,
    fromWords: $13bdc46293750b4e$var$fromWords
};

});

parcelRegister("iIW4W", function(module, exports) {

$parcel$export(module.exports, "version", () => $da19634a54d1169b$export$83d89fbfd8236492);
const $da19634a54d1169b$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRegister("bzgEz", function(module, exports) {

$parcel$export(module.exports, "Formatter", () => $86bfe19938516d7b$export$a06636add2a09fd8);
$parcel$export(module.exports, "isCommunityResourcable", () => $86bfe19938516d7b$export$3091239f5b20b896);
$parcel$export(module.exports, "isCommunityResource", () => $86bfe19938516d7b$export$d93d5f61c2498b6);
$parcel$export(module.exports, "showThrottleMessage", () => $86bfe19938516d7b$export$4c41bd49e82e82ab);

var $8T6OQ = parcelRequire("8T6OQ");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $g1fMd = parcelRequire("g1fMd");

var $cQEXW = parcelRequire("cQEXW");

var $fb2Z3 = parcelRequire("fb2Z3");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
const $86bfe19938516d7b$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
class $86bfe19938516d7b$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number),
            creates: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address, null),
            raw: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address),
            nonce: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address),
            value: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(strictData),
            type: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number),
            accessList: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $86bfe19938516d7b$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $86bfe19938516d7b$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull($86bfe19938516d7b$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $cQEXW.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $86bfe19938516d7b$export$a06636add2a09fd8.allowNull($86bfe19938516d7b$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(number),
            blockHash: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $86bfe19938516d7b$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $86bfe19938516d7b$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $86bfe19938516d7b$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $fb2Z3.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $e0Utj.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $e0Utj.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $e0Utj.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $is1Vq.isHexString)(value)) return value.toLowerCase();
        }
        return $86bfe19938516d7b$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $8T6OQ.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $is1Vq.isHexString)(value, 32)) return null;
        const address = (0, $8T6OQ.getAddress)((0, $is1Vq.hexDataSlice)(value, 12));
        return address === (0, $g1fMd.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $8T6OQ.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $is1Vq.isHexString)(blockTag)) return (0, $is1Vq.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $is1Vq.hexDataLength)(result) !== 32) return $86bfe19938516d7b$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $e0Utj.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $is1Vq.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $is1Vq.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $86bfe19938516d7b$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $e0Utj.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $e0Utj.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $is1Vq.isHexString)(chainId)) chainId = (0, $e0Utj.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $is1Vq.isHexString)(chainId)) chainId = (0, $e0Utj.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $fb2Z3.parse)(value);
    }
    receiptLog(value) {
        return $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $e0Utj.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $86bfe19938516d7b$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $86bfe19938516d7b$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $86bfe19938516d7b$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $86bfe19938516d7b$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $86bfe19938516d7b$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $86bfe19938516d7b$export$d93d5f61c2498b6(value) {
    return $86bfe19938516d7b$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $86bfe19938516d7b$var$throttleMessage = false;
function $86bfe19938516d7b$export$4c41bd49e82e82ab() {
    if ($86bfe19938516d7b$var$throttleMessage) return;
    $86bfe19938516d7b$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("5f24G", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", () => $3d0ff66dc5e7433f$export$f6c13301c7b76371);
$parcel$export(module.exports, "AlchemyProvider", () => $3d0ff66dc5e7433f$export$999cc40da3fbc6f);

var $cQEXW = parcelRequire("cQEXW");

var $bzgEz = parcelRequire("bzgEz");

var $4jN6K = parcelRequire("4jN6K");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $cBOfq = parcelRequire("cBOfq");
"use strict";
const $3d0ff66dc5e7433f$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $3d0ff66dc5e7433f$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $3d0ff66dc5e7433f$export$f6c13301c7b76371 extends (0, $4jN6K.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $3d0ff66dc5e7433f$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $cQEXW.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $3d0ff66dc5e7433f$var$defaultApiKey;
    }
}
class $3d0ff66dc5e7433f$export$999cc40da3fbc6f extends (0, $cBOfq.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $3d0ff66dc5e7433f$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $3d0ff66dc5e7433f$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $3d0ff66dc5e7433f$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $3d0ff66dc5e7433f$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $3d0ff66dc5e7433f$var$defaultApiKey) (0, $bzgEz.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $3d0ff66dc5e7433f$var$defaultApiKey;
    }
}

});
parcelRegister("4jN6K", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", () => $324f0793b7f43d60$export$bfafe629242f30bd);

var $e0Utj = parcelRequire("e0Utj");

var $cQEXW = parcelRequire("cQEXW");

var $i56cX = parcelRequire("i56cX");

var $5ErLa = parcelRequire("5ErLa");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
var $324f0793b7f43d60$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $324f0793b7f43d60$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $324f0793b7f43d60$var$NextId = 1;
class $324f0793b7f43d60$export$bfafe629242f30bd extends (0, $i56cX.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $324f0793b7f43d60$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $cQEXW.defineReadOnly)(this, "_websocket", new (0, $5ErLa.WebSocket)(this.connection.url));
        else (0, $cQEXW.defineReadOnly)(this, "_websocket", url);
        (0, $cQEXW.defineReadOnly)(this, "_requests", {});
        (0, $cQEXW.defineReadOnly)(this, "_subs", {});
        (0, $cQEXW.defineReadOnly)(this, "_subIds", {});
        (0, $cQEXW.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $cQEXW.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $cQEXW.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $324f0793b7f43d60$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $324f0793b7f43d60$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $324f0793b7f43d60$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $324f0793b7f43d60$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $324f0793b7f43d60$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $324f0793b7f43d60$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $e0Utj.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $324f0793b7f43d60$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $5ErLa.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}

});
parcelRegister("i56cX", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", () => $d29d8262f99e28c6$export$5f7b5fca3508545a);
$parcel$export(module.exports, "JsonRpcProvider", () => $d29d8262f99e28c6$export$da28308012bf6748);

var $40NDm = parcelRequire("40NDm");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $2u8sE = parcelRequire("2u8sE");

var $cQEXW = parcelRequire("cQEXW");

var $itjXq = parcelRequire("itjXq");

var $fb2Z3 = parcelRequire("fb2Z3");

var $bpZ9V = parcelRequire("bpZ9V");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $aPYeD = parcelRequire("aPYeD");
"use strict";
var $d29d8262f99e28c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d29d8262f99e28c6$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
const $d29d8262f99e28c6$var$errorGas = [
    "call",
    "estimateGas"
];
function $d29d8262f99e28c6$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $is1Vq.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $d29d8262f99e28c6$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $d29d8262f99e28c6$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $d29d8262f99e28c6$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $d29d8262f99e28c6$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $d29d8262f99e28c6$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $d29d8262f99e28c6$var$spelunk(error.body, false);
        if (result == null) result = $d29d8262f99e28c6$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $d29d8262f99e28c6$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $hAWyw.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $hAWyw.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $d29d8262f99e28c6$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $hAWyw.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $d29d8262f99e28c6$var$logger.throwError("nonce has already been used", (0, $hAWyw.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $d29d8262f99e28c6$var$logger.throwError("replacement fee too low", (0, $hAWyw.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $d29d8262f99e28c6$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($d29d8262f99e28c6$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $d29d8262f99e28c6$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $hAWyw.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $d29d8262f99e28c6$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $d29d8262f99e28c6$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $d29d8262f99e28c6$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $d29d8262f99e28c6$var$_constructorGuard = {};
class $d29d8262f99e28c6$export$5f7b5fca3508545a extends (0, $40NDm.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $d29d8262f99e28c6$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $cQEXW.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $cQEXW.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $cQEXW.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $cQEXW.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $cQEXW.defineReadOnly)(this, "_address", null);
        } else $d29d8262f99e28c6$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $d29d8262f99e28c6$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $d29d8262f99e28c6$var$UncheckedJsonRpcSigner($d29d8262f99e28c6$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $d29d8262f99e28c6$var$logger.throwError("unknown account #" + this._index, (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $cQEXW.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $cQEXW.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $d29d8262f99e28c6$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $cQEXW.resolveProperties)({
            tx: (0, $cQEXW.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $d29d8262f99e28c6$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $d29d8262f99e28c6$var$logger.throwError("user rejected transaction", (0, $hAWyw.Logger).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $d29d8262f99e28c6$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $d29d8262f99e28c6$var$logger.throwError("signing transactions is unsupported", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $bpZ9V.poll)(()=>$d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $itjXq.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $is1Vq.hexlify)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $d29d8262f99e28c6$var$logger.throwError("user rejected signing", (0, $hAWyw.Logger).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $itjXq.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $is1Vq.hexlify)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $d29d8262f99e28c6$var$logger.throwError("user rejected signing", (0, $hAWyw.Logger).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $2u8sE.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $2u8sE.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $d29d8262f99e28c6$var$logger.throwError("user rejected signing", (0, $hAWyw.Logger).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $d29d8262f99e28c6$var$UncheckedJsonRpcSigner extends $d29d8262f99e28c6$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $d29d8262f99e28c6$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $d29d8262f99e28c6$export$da28308012bf6748 extends (0, $aPYeD.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $cQEXW.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $cQEXW.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $cQEXW.defineReadOnly)(this, "connection", Object.freeze((0, $cQEXW.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            yield $d29d8262f99e28c6$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $cQEXW.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $e0Utj.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $d29d8262f99e28c6$var$logger.throwError("could not detect network", (0, $hAWyw.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $d29d8262f99e28c6$var$logger.throwError("could not detect network", (0, $hAWyw.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $d29d8262f99e28c6$export$5f7b5fca3508545a($d29d8262f99e28c6$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $cQEXW.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $bpZ9V.fetchJson)(this.connection, JSON.stringify(request), $d29d8262f99e28c6$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $d29d8262f99e28c6$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $d29d8262f99e28c6$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $d29d8262f99e28c6$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $d29d8262f99e28c6$var$getLowerCase(params.address),
                        (0, $is1Vq.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $cQEXW.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $cQEXW.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $d29d8262f99e28c6$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $d29d8262f99e28c6$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $e0Utj.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $cQEXW.shallowCopy)(params);
                            params.transaction = (0, $cQEXW.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $d29d8262f99e28c6$var$logger.throwError(method + " not implemented", (0, $hAWyw.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $d29d8262f99e28c6$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $d29d8262f99e28c6$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $cQEXW.shallowCopy)($d29d8262f99e28c6$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $cQEXW.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $is1Vq.hexValue)((0, $e0Utj.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $is1Vq.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $fb2Z3.accessListify)(transaction.accessList);
        return result;
    }
}

});

parcelRegister("5ErLa", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $41d638b3882e1c5f$export$3909fb301d3dc8c9);

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
let $41d638b3882e1c5f$export$3909fb301d3dc8c9 = null;
try {
    $41d638b3882e1c5f$export$3909fb301d3dc8c9 = WebSocket;
    if ($41d638b3882e1c5f$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
    $41d638b3882e1c5f$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("cBOfq", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", () => $92dfeae54141996f$export$b3d647c1c29df44d);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => $92dfeae54141996f$export$664128d6239ccf96);

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $i56cX = parcelRequire("i56cX");
"use strict";
var $92dfeae54141996f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $92dfeae54141996f$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
class $92dfeae54141996f$export$b3d647c1c29df44d extends (0, $i56cX.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $92dfeae54141996f$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $92dfeae54141996f$var$logger.throwError("no network detected", (0, $hAWyw.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $cQEXW.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $92dfeae54141996f$export$664128d6239ccf96 extends $92dfeae54141996f$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $92dfeae54141996f$var$logger.checkAbstract(new.target, $92dfeae54141996f$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $cQEXW.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $cQEXW.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $cQEXW.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $cQEXW.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $cQEXW.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $92dfeae54141996f$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $92dfeae54141996f$var$logger.throwError("API provider does not support signing", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $92dfeae54141996f$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $hAWyw.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRegister("hiZep", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", () => $c9939d6824c91ce9$export$72783b2aefa72a45);

var $bzgEz = parcelRequire("bzgEz");

var $cBOfq = parcelRequire("cBOfq");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
const $c9939d6824c91ce9$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
const $c9939d6824c91ce9$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $c9939d6824c91ce9$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $c9939d6824c91ce9$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $c9939d6824c91ce9$export$72783b2aefa72a45 extends (0, $cBOfq.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $c9939d6824c91ce9$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $c9939d6824c91ce9$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $c9939d6824c91ce9$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $c9939d6824c91ce9$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $c9939d6824c91ce9$var$defaultApiKey) (0, $bzgEz.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRegister("5DbOz", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", () => $4199c2644c7d9f5b$export$7113381f8f264fc0);

var $cBOfq = parcelRequire("cBOfq");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
var $4199c2644c7d9f5b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4199c2644c7d9f5b$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
class $4199c2644c7d9f5b$export$7113381f8f264fc0 extends (0, $cBOfq.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $4199c2644c7d9f5b$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $4199c2644c7d9f5b$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $4199c2644c7d9f5b$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("hO1QT", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", () => $cf688afce8f2f2be$export$dd1d942a536c7912);

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $fb2Z3 = parcelRequire("fb2Z3");

var $bpZ9V = parcelRequire("bpZ9V");

var $bzgEz = parcelRequire("bzgEz");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $aPYeD = parcelRequire("aPYeD");
"use strict";
var $cf688afce8f2f2be$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf688afce8f2f2be$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
// The transaction has already been sanitized by the calls in Provider
function $cf688afce8f2f2be$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $is1Vq.hexValue)((0, $is1Vq.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $fb2Z3.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $is1Vq.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $cf688afce8f2f2be$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $cf688afce8f2f2be$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $cf688afce8f2f2be$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $cf688afce8f2f2be$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $hAWyw.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $is1Vq.isHexString)(data)) return data;
            $cf688afce8f2f2be$var$logger.throwError("missing revert data in call exception", (0, $hAWyw.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $hAWyw.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $cf688afce8f2f2be$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $hAWyw.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $cf688afce8f2f2be$var$logger.throwError("nonce has already been used", (0, $hAWyw.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $cf688afce8f2f2be$var$logger.throwError("replacement fee too low", (0, $hAWyw.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $cf688afce8f2f2be$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $hAWyw.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $cf688afce8f2f2be$export$dd1d942a536c7912 extends (0, $aPYeD.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $cQEXW.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $cQEXW.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $cf688afce8f2f2be$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $cf688afce8f2f2be$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $cf688afce8f2f2be$var$getJsonResult : $cf688afce8f2f2be$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $bzgEz.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $bpZ9V.fetchJson)(connection, payloadStr, procFunc || $cf688afce8f2f2be$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $cQEXW.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $cf688afce8f2f2be$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $cf688afce8f2f2be$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $cf688afce8f2f2be$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $cf688afce8f2f2be$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $cf688afce8f2f2be$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $cf688afce8f2f2be$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $cf688afce8f2f2be$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $cf688afce8f2f2be$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $cf688afce8f2f2be$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $cf688afce8f2f2be$var$logger.throwError("unsupported topic count", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $cf688afce8f2f2be$var$logger.throwError("unsupported topic format", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $cf688afce8f2f2be$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}

});

parcelRegister("80lZU", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", () => $5d3f630dee335a45$export$cb1d0beacb55feb7);

var $cfLMn = parcelRequire("cfLMn");

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $cQEXW = parcelRequire("cQEXW");

var $hjEAG = parcelRequire("hjEAG");

var $bpZ9V = parcelRequire("bpZ9V");

var $aPYeD = parcelRequire("aPYeD");

var $bzgEz = parcelRequire("bzgEz");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
var $5d3f630dee335a45$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5d3f630dee335a45$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
function $5d3f630dee335a45$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $5d3f630dee335a45$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $5d3f630dee335a45$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $5d3f630dee335a45$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $5d3f630dee335a45$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $e0Utj.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$5d3f630dee335a45$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $5d3f630dee335a45$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $5d3f630dee335a45$var$nextRid = 1;
function $5d3f630dee335a45$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $5d3f630dee335a45$var$ForwardErrors = [
    (0, $hAWyw.Logger).errors.CALL_EXCEPTION,
    (0, $hAWyw.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $hAWyw.Logger).errors.NONCE_EXPIRED,
    (0, $hAWyw.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $hAWyw.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $5d3f630dee335a45$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $5d3f630dee335a45$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $5d3f630dee335a45$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $5d3f630dee335a45$var$getProcessFunc(provider, method, params) {
    let normalize = $5d3f630dee335a45$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $5d3f630dee335a45$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $5d3f630dee335a45$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $cQEXW.shallowCopy)(tx);
                tx.confirmations = -1;
                return $5d3f630dee335a45$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $cQEXW.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $cQEXW.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $5d3f630dee335a45$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $5d3f630dee335a45$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $5d3f630dee335a45$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $5d3f630dee335a45$var$waitForSync(config, blockNumber) {
    return $5d3f630dee335a45$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $bpZ9V.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $5d3f630dee335a45$var$getRunner(config, currentBlockNumber, method, params) {
    return $5d3f630dee335a45$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $is1Vq.isHexString)(params.blockTag)) provider = yield $5d3f630dee335a45$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $is1Vq.isHexString)(params.blockTag)) provider = yield $5d3f630dee335a45$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $is1Vq.isHexString)(params.blockTag)) provider = yield $5d3f630dee335a45$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $is1Vq.isHexString)(params.blockTag)) provider = yield $5d3f630dee335a45$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $is1Vq.isHexString)(filter.fromBlock) || filter.toBlock && (0, $is1Vq.isHexString)(filter.toBlock)) provider = yield $5d3f630dee335a45$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $5d3f630dee335a45$var$logger.throwError("unknown method error", (0, $hAWyw.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $5d3f630dee335a45$export$cb1d0beacb55feb7 extends (0, $aPYeD.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $5d3f630dee335a45$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $cfLMn.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $bzgEz.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $cQEXW.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $bzgEz.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $5d3f630dee335a45$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $5d3f630dee335a45$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $5d3f630dee335a45$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $cQEXW.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $cQEXW.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $5d3f630dee335a45$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $5d3f630dee335a45$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $5d3f630dee335a45$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $5d3f630dee335a45$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $hjEAG.shuffled)(this.providerConfigs.map((0, $cQEXW.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $5d3f630dee335a45$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $5d3f630dee335a45$var$nextRid++;
                    config.start = $5d3f630dee335a45$var$now();
                    config.staller = $5d3f630dee335a45$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $5d3f630dee335a45$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $5d3f630dee335a45$var$exposeDebugConfig(config, $5d3f630dee335a45$var$now()),
                            request: {
                                method: method,
                                params: (0, $cQEXW.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $5d3f630dee335a45$var$exposeDebugConfig(config, $5d3f630dee335a45$var$now()),
                            request: {
                                method: method,
                                params: (0, $cQEXW.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $5d3f630dee335a45$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $cQEXW.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $5d3f630dee335a45$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($5d3f630dee335a45$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $5d3f630dee335a45$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $5d3f630dee335a45$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $5d3f630dee335a45$var$logger.throwError("failed to meet quorum", (0, $hAWyw.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$5d3f630dee335a45$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRegister("hjEAG", function(module, exports) {

$parcel$export(module.exports, "shuffled", () => $c9b3b275065ef73d$export$e6c7296801b9b341);
"use strict";
function $c9b3b275065ef73d$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("fEeyA", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", () => $b645e22684bcca90$export$fbe151f90a1ece01);
"use strict";
const $b645e22684bcca90$export$fbe151f90a1ece01 = null;

});

parcelRegister("2k12m", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", () => $1b0e40fd56a16312$export$dd168a807d60da4f);
$parcel$export(module.exports, "InfuraProvider", () => $1b0e40fd56a16312$export$60ff1a559b5c6ebd);

var $cQEXW = parcelRequire("cQEXW");

var $4jN6K = parcelRequire("4jN6K");

var $bzgEz = parcelRequire("bzgEz");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $cBOfq = parcelRequire("cBOfq");
"use strict";
const $1b0e40fd56a16312$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
const $1b0e40fd56a16312$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $1b0e40fd56a16312$export$dd168a807d60da4f extends (0, $4jN6K.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $1b0e40fd56a16312$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $1b0e40fd56a16312$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $hAWyw.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $cQEXW.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $cQEXW.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $cQEXW.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $1b0e40fd56a16312$var$defaultProjectId;
    }
}
class $1b0e40fd56a16312$export$60ff1a559b5c6ebd extends (0, $cBOfq.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $1b0e40fd56a16312$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $1b0e40fd56a16312$var$defaultProjectId,
            projectId: $1b0e40fd56a16312$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $1b0e40fd56a16312$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $1b0e40fd56a16312$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $1b0e40fd56a16312$var$logger.throwError("unsupported network", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $1b0e40fd56a16312$var$defaultProjectId) (0, $bzgEz.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $1b0e40fd56a16312$var$defaultProjectId;
    }
}

});

parcelRegister("98FHx", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", () => $6a75356197f44ea2$export$5a16092bf20edf97);

var $cQEXW = parcelRequire("cQEXW");

var $bpZ9V = parcelRequire("bpZ9V");

var $i56cX = parcelRequire("i56cX");
class $6a75356197f44ea2$export$5a16092bf20edf97 extends (0, $i56cX.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $cQEXW.deepCopy)(request),
                provider: this
            });
            return (0, $bpZ9V.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("2R6JC", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", () => $2145c168e08c19bc$export$8235cbce3ce273bd);
/* istanbul ignore file */ 
var $cBOfq = parcelRequire("cBOfq");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");
"use strict";
const $2145c168e08c19bc$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
// Special API key provided by Nodesmith for ethers.js
const $2145c168e08c19bc$var$defaultApiKey = "ETHERS_JS_SHARED";
class $2145c168e08c19bc$export$8235cbce3ce273bd extends (0, $cBOfq.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $2145c168e08c19bc$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $2145c168e08c19bc$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $2145c168e08c19bc$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $2145c168e08c19bc$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("7RWri", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", () => $5baad07386dcede0$export$58bb47e42f6b092e);

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $cBOfq = parcelRequire("cBOfq");
"use strict";
const $5baad07386dcede0$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
const $5baad07386dcede0$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $5baad07386dcede0$export$58bb47e42f6b092e extends (0, $cBOfq.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $5baad07386dcede0$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $5baad07386dcede0$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $5baad07386dcede0$var$logger.throwError("unsupported network", (0, $hAWyw.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $5baad07386dcede0$var$defaultApplicationId;
    }
}

});

parcelRegister("5lu0X", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", () => $3e46322a609aa366$export$d05096c9fd9d936d);

var $cQEXW = parcelRequire("cQEXW");

var $hAWyw = parcelRequire("hAWyw");

var $iIW4W = parcelRequire("iIW4W");

var $i56cX = parcelRequire("i56cX");
"use strict";
const $3e46322a609aa366$var$logger = new (0, $hAWyw.Logger)((0, $iIW4W.version));
let $3e46322a609aa366$var$_nextId = 1;
function $3e46322a609aa366$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $3e46322a609aa366$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $cQEXW.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $3e46322a609aa366$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $cQEXW.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $3e46322a609aa366$export$d05096c9fd9d936d extends (0, $i56cX.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $3e46322a609aa366$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $3e46322a609aa366$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $3e46322a609aa366$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $3e46322a609aa366$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $3e46322a609aa366$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $cQEXW.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $cQEXW.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});


parcelRegister("nAWpO", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => (parcelRequire("3OfWd")).AbiCoder);
$parcel$export(module.exports, "defaultAbiCoder", () => (parcelRequire("3OfWd")).defaultAbiCoder);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("2Pd4Q")).Fragment);
$parcel$export(module.exports, "ConstructorFragment", () => (parcelRequire("2Pd4Q")).ConstructorFragment);
$parcel$export(module.exports, "ErrorFragment", () => (parcelRequire("2Pd4Q")).ErrorFragment);
$parcel$export(module.exports, "EventFragment", () => (parcelRequire("2Pd4Q")).EventFragment);
$parcel$export(module.exports, "FunctionFragment", () => (parcelRequire("2Pd4Q")).FunctionFragment);
$parcel$export(module.exports, "ParamType", () => (parcelRequire("2Pd4Q")).ParamType);
$parcel$export(module.exports, "FormatTypes", () => (parcelRequire("2Pd4Q")).FormatTypes);
$parcel$export(module.exports, "checkResultErrors", () => (parcelRequire("H2p5T")).checkResultErrors);
$parcel$export(module.exports, "Logger", () => (parcelRequire("hAWyw")).Logger);
$parcel$export(module.exports, "RLP", () => (parcelRequire("aDs3C")));
$parcel$export(module.exports, "_fetchData", () => (parcelRequire("bpZ9V"))._fetchData);
$parcel$export(module.exports, "fetchJson", () => (parcelRequire("bpZ9V")).fetchJson);
$parcel$export(module.exports, "poll", () => (parcelRequire("bpZ9V")).poll);
$parcel$export(module.exports, "checkProperties", () => (parcelRequire("cQEXW")).checkProperties);
$parcel$export(module.exports, "deepCopy", () => (parcelRequire("cQEXW")).deepCopy);
$parcel$export(module.exports, "defineReadOnly", () => (parcelRequire("cQEXW")).defineReadOnly);
$parcel$export(module.exports, "getStatic", () => (parcelRequire("cQEXW")).getStatic);
$parcel$export(module.exports, "resolveProperties", () => (parcelRequire("cQEXW")).resolveProperties);
$parcel$export(module.exports, "shallowCopy", () => (parcelRequire("cQEXW")).shallowCopy);
$parcel$export(module.exports, "arrayify", () => (parcelRequire("is1Vq")).arrayify);
$parcel$export(module.exports, "concat", () => (parcelRequire("is1Vq")).concat);
$parcel$export(module.exports, "stripZeros", () => (parcelRequire("is1Vq")).stripZeros);
$parcel$export(module.exports, "zeroPad", () => (parcelRequire("is1Vq")).zeroPad);
$parcel$export(module.exports, "isBytes", () => (parcelRequire("is1Vq")).isBytes);
$parcel$export(module.exports, "isBytesLike", () => (parcelRequire("is1Vq")).isBytesLike);
$parcel$export(module.exports, "defaultPath", () => (parcelRequire("2joQB")).defaultPath);
$parcel$export(module.exports, "HDNode", () => (parcelRequire("2joQB")).HDNode);
$parcel$export(module.exports, "SigningKey", () => (parcelRequire("12CVZ")).SigningKey);
$parcel$export(module.exports, "Interface", () => (parcelRequire("6N7mB")).Interface);
$parcel$export(module.exports, "LogDescription", () => (parcelRequire("6N7mB")).LogDescription);
$parcel$export(module.exports, "TransactionDescription", () => (parcelRequire("6N7mB")).TransactionDescription);
$parcel$export(module.exports, "base58", () => (parcelRequire("b1hNZ")).Base58);
$parcel$export(module.exports, "base64", () => (parcelRequire("eIwLZ")));
$parcel$export(module.exports, "hexlify", () => (parcelRequire("is1Vq")).hexlify);
$parcel$export(module.exports, "isHexString", () => (parcelRequire("is1Vq")).isHexString);
$parcel$export(module.exports, "hexConcat", () => (parcelRequire("is1Vq")).hexConcat);
$parcel$export(module.exports, "hexStripZeros", () => (parcelRequire("is1Vq")).hexStripZeros);
$parcel$export(module.exports, "hexValue", () => (parcelRequire("is1Vq")).hexValue);
$parcel$export(module.exports, "hexZeroPad", () => (parcelRequire("is1Vq")).hexZeroPad);
$parcel$export(module.exports, "hexDataLength", () => (parcelRequire("is1Vq")).hexDataLength);
$parcel$export(module.exports, "hexDataSlice", () => (parcelRequire("is1Vq")).hexDataSlice);
$parcel$export(module.exports, "nameprep", () => (parcelRequire("lMg2f")).nameprep);
$parcel$export(module.exports, "_toEscapedUtf8String", () => (parcelRequire("itjXq"))._toEscapedUtf8String);
$parcel$export(module.exports, "toUtf8Bytes", () => (parcelRequire("itjXq")).toUtf8Bytes);
$parcel$export(module.exports, "toUtf8CodePoints", () => (parcelRequire("itjXq")).toUtf8CodePoints);
$parcel$export(module.exports, "toUtf8String", () => (parcelRequire("itjXq")).toUtf8String);
$parcel$export(module.exports, "Utf8ErrorFuncs", () => (parcelRequire("itjXq")).Utf8ErrorFuncs);
$parcel$export(module.exports, "formatBytes32String", () => (parcelRequire("gTqlP")).formatBytes32String);
$parcel$export(module.exports, "parseBytes32String", () => (parcelRequire("gTqlP")).parseBytes32String);
$parcel$export(module.exports, "dnsEncode", () => (parcelRequire("1kRIW")).dnsEncode);
$parcel$export(module.exports, "hashMessage", () => (parcelRequire("WIpZy")).hashMessage);
$parcel$export(module.exports, "namehash", () => (parcelRequire("1kRIW")).namehash);
$parcel$export(module.exports, "isValidName", () => (parcelRequire("1kRIW")).isValidName);
$parcel$export(module.exports, "id", () => (parcelRequire("kzd4T")).id);
$parcel$export(module.exports, "_TypedDataEncoder", () => (parcelRequire("2u8sE")).TypedDataEncoder);
$parcel$export(module.exports, "getAddress", () => (parcelRequire("8T6OQ")).getAddress);
$parcel$export(module.exports, "getIcapAddress", () => (parcelRequire("8T6OQ")).getIcapAddress);
$parcel$export(module.exports, "getContractAddress", () => (parcelRequire("8T6OQ")).getContractAddress);
$parcel$export(module.exports, "getCreate2Address", () => (parcelRequire("8T6OQ")).getCreate2Address);
$parcel$export(module.exports, "isAddress", () => (parcelRequire("8T6OQ")).isAddress);
$parcel$export(module.exports, "formatEther", () => (parcelRequire("a75xs")).formatEther);
$parcel$export(module.exports, "parseEther", () => (parcelRequire("a75xs")).parseEther);
$parcel$export(module.exports, "formatUnits", () => (parcelRequire("a75xs")).formatUnits);
$parcel$export(module.exports, "parseUnits", () => (parcelRequire("a75xs")).parseUnits);
$parcel$export(module.exports, "commify", () => (parcelRequire("a75xs")).commify);
$parcel$export(module.exports, "computeHmac", () => (parcelRequire("aHYQJ")).computeHmac);
$parcel$export(module.exports, "keccak256", () => (parcelRequire("koabN")).keccak256);
$parcel$export(module.exports, "ripemd160", () => (parcelRequire("aHYQJ")).ripemd160);
$parcel$export(module.exports, "sha256", () => (parcelRequire("aHYQJ")).sha256);
$parcel$export(module.exports, "sha512", () => (parcelRequire("aHYQJ")).sha512);
$parcel$export(module.exports, "randomBytes", () => (parcelRequire("eL3F9")).randomBytes);
$parcel$export(module.exports, "shuffled", () => (parcelRequire("hjEAG")).shuffled);
$parcel$export(module.exports, "solidityPack", () => (parcelRequire("3Qe9R")).pack);
$parcel$export(module.exports, "solidityKeccak256", () => (parcelRequire("3Qe9R")).keccak256);
$parcel$export(module.exports, "soliditySha256", () => (parcelRequire("3Qe9R")).sha256);
$parcel$export(module.exports, "splitSignature", () => (parcelRequire("is1Vq")).splitSignature);
$parcel$export(module.exports, "joinSignature", () => (parcelRequire("is1Vq")).joinSignature);
$parcel$export(module.exports, "accessListify", () => (parcelRequire("fb2Z3")).accessListify);
$parcel$export(module.exports, "parseTransaction", () => (parcelRequire("fb2Z3")).parse);
$parcel$export(module.exports, "serializeTransaction", () => (parcelRequire("fb2Z3")).serialize);
$parcel$export(module.exports, "TransactionTypes", () => (parcelRequire("fb2Z3")).TransactionTypes);
$parcel$export(module.exports, "getJsonWalletAddress", () => (parcelRequire("8ZiQm")).getJsonWalletAddress);
$parcel$export(module.exports, "computeAddress", () => (parcelRequire("fb2Z3")).computeAddress);
$parcel$export(module.exports, "recoverAddress", () => (parcelRequire("fb2Z3")).recoverAddress);
$parcel$export(module.exports, "computePublicKey", () => (parcelRequire("12CVZ")).computePublicKey);
$parcel$export(module.exports, "recoverPublicKey", () => (parcelRequire("12CVZ")).recoverPublicKey);
$parcel$export(module.exports, "verifyMessage", () => (parcelRequire("7J4Ot")).verifyMessage);
$parcel$export(module.exports, "verifyTypedData", () => (parcelRequire("7J4Ot")).verifyTypedData);
$parcel$export(module.exports, "getAccountPath", () => (parcelRequire("2joQB")).getAccountPath);
$parcel$export(module.exports, "mnemonicToEntropy", () => (parcelRequire("2joQB")).mnemonicToEntropy);
$parcel$export(module.exports, "entropyToMnemonic", () => (parcelRequire("2joQB")).entropyToMnemonic);
$parcel$export(module.exports, "isValidMnemonic", () => (parcelRequire("2joQB")).isValidMnemonic);
$parcel$export(module.exports, "mnemonicToSeed", () => (parcelRequire("2joQB")).mnemonicToSeed);
$parcel$export(module.exports, "SupportedAlgorithm", () => (parcelRequire("4Tw52")).SupportedAlgorithm);
$parcel$export(module.exports, "UnicodeNormalizationForm", () => (parcelRequire("itjXq")).UnicodeNormalizationForm);
$parcel$export(module.exports, "Utf8ErrorReason", () => (parcelRequire("itjXq")).Utf8ErrorReason);
$parcel$export(module.exports, "Indexed", () => (parcelRequire("6N7mB")).Indexed);

var $3OfWd = parcelRequire("3OfWd");
var $H2p5T = parcelRequire("H2p5T");
var $2Pd4Q = parcelRequire("2Pd4Q");
var $6N7mB = parcelRequire("6N7mB");

var $8T6OQ = parcelRequire("8T6OQ");

var $eIwLZ = parcelRequire("eIwLZ");

var $b1hNZ = parcelRequire("b1hNZ");

var $is1Vq = parcelRequire("is1Vq");

var $2u8sE = parcelRequire("2u8sE");
var $1kRIW = parcelRequire("1kRIW");
var $WIpZy = parcelRequire("WIpZy");
var $kzd4T = parcelRequire("kzd4T");

var $2joQB = parcelRequire("2joQB");

var $8ZiQm = parcelRequire("8ZiQm");

var $koabN = parcelRequire("koabN");

var $hAWyw = parcelRequire("hAWyw");

var $aHYQJ = parcelRequire("aHYQJ");
var $4Tw52 = parcelRequire("4Tw52");

var $3Qe9R = parcelRequire("3Qe9R");

var $eL3F9 = parcelRequire("eL3F9");
var $hjEAG = parcelRequire("hjEAG");

var $cQEXW = parcelRequire("cQEXW");

var $aDs3C = parcelRequire("aDs3C");

var $12CVZ = parcelRequire("12CVZ");

var $itjXq = parcelRequire("itjXq");
var $gTqlP = parcelRequire("gTqlP");
var $lMg2f = parcelRequire("lMg2f");

var $fb2Z3 = parcelRequire("fb2Z3");

var $a75xs = parcelRequire("a75xs");

var $7J4Ot = parcelRequire("7J4Ot");

var $bpZ9V = parcelRequire("bpZ9V");
"use strict";

});
parcelRegister("eIwLZ", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("9DtaX")).decode);
$parcel$export(module.exports, "encode", () => (parcelRequire("9DtaX")).encode);

var $9DtaX = parcelRequire("9DtaX");
"use strict";

});

parcelRegister("3Qe9R", function(module, exports) {

$parcel$export(module.exports, "pack", () => $2cc135ea34ea5c8a$export$2a703dbb0cb35339);
$parcel$export(module.exports, "keccak256", () => $2cc135ea34ea5c8a$export$f8151fce47ad1c35);
$parcel$export(module.exports, "sha256", () => $2cc135ea34ea5c8a$export$bced8d2aada2d1c9);

var $e0Utj = parcelRequire("e0Utj");

var $is1Vq = parcelRequire("is1Vq");

var $koabN = parcelRequire("koabN");

var $aHYQJ = parcelRequire("aHYQJ");

var $itjXq = parcelRequire("itjXq");

var $hAWyw = parcelRequire("hAWyw");

var $7Bo9l = parcelRequire("7Bo9l");
"use strict";
const $2cc135ea34ea5c8a$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $2cc135ea34ea5c8a$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $2cc135ea34ea5c8a$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $2cc135ea34ea5c8a$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $2cc135ea34ea5c8a$var$logger = new (0, $hAWyw.Logger)((0, $7Bo9l.version));
function $2cc135ea34ea5c8a$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $is1Vq.zeroPad)(value, 32);
            return (0, $is1Vq.arrayify)(value);
        case "string":
            return (0, $itjXq.toUtf8Bytes)(value);
        case "bytes":
            return (0, $is1Vq.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $is1Vq.zeroPad)(value, 32);
            return (0, $is1Vq.arrayify)(value);
    }
    let match = type.match($2cc135ea34ea5c8a$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $2cc135ea34ea5c8a$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $e0Utj.BigNumber).from(value).toTwos(size);
        return (0, $is1Vq.zeroPad)(value, size / 8);
    }
    match = type.match($2cc135ea34ea5c8a$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $2cc135ea34ea5c8a$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $is1Vq.arrayify)(value).byteLength !== size) $2cc135ea34ea5c8a$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $is1Vq.arrayify)((value + $2cc135ea34ea5c8a$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($2cc135ea34ea5c8a$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $2cc135ea34ea5c8a$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($2cc135ea34ea5c8a$var$_pack(baseType, value, true));
        });
        return (0, $is1Vq.concat)(result);
    }
    return $2cc135ea34ea5c8a$var$logger.throwArgumentError("invalid type", "type", type);
}
function $2cc135ea34ea5c8a$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $2cc135ea34ea5c8a$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($2cc135ea34ea5c8a$var$_pack(type, values[index]));
    });
    return (0, $is1Vq.hexlify)((0, $is1Vq.concat)(tight));
}
function $2cc135ea34ea5c8a$export$f8151fce47ad1c35(types, values) {
    return (0, $koabN.keccak256)($2cc135ea34ea5c8a$export$2a703dbb0cb35339(types, values));
}
function $2cc135ea34ea5c8a$export$bced8d2aada2d1c9(types, values) {
    return (0, $aHYQJ.sha256)($2cc135ea34ea5c8a$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("7Bo9l", function(module, exports) {

$parcel$export(module.exports, "version", () => $588eb8c1d1e7b4c9$export$83d89fbfd8236492);
const $588eb8c1d1e7b4c9$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRegister("gTqlP", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", () => $c4c63927f87d02d3$export$b97e949c0076e971);
$parcel$export(module.exports, "parseBytes32String", () => $c4c63927f87d02d3$export$49340cb8f3954db8);

var $lYhMT = parcelRequire("lYhMT");

var $is1Vq = parcelRequire("is1Vq");

var $itjXq = parcelRequire("itjXq");
"use strict";
function $c4c63927f87d02d3$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $itjXq.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $is1Vq.hexlify)((0, $is1Vq.concat)([
        bytes,
        (0, $lYhMT.HashZero)
    ]).slice(0, 32));
}
function $c4c63927f87d02d3$export$49340cb8f3954db8(bytes) {
    const data = (0, $is1Vq.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $itjXq.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("lMg2f", function(module, exports) {

$parcel$export(module.exports, "nameprep", () => $fdaa84edd0a5cdaf$export$94f0b6f93c619bc);

var $itjXq = parcelRequire("itjXq");
"use strict";
function $fdaa84edd0a5cdaf$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $fdaa84edd0a5cdaf$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $fdaa84edd0a5cdaf$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $fdaa84edd0a5cdaf$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $fdaa84edd0a5cdaf$var$Table_A_1_ranges = $fdaa84edd0a5cdaf$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $fdaa84edd0a5cdaf$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $fdaa84edd0a5cdaf$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $fdaa84edd0a5cdaf$var$Table_B_2_lut_abs = $fdaa84edd0a5cdaf$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $fdaa84edd0a5cdaf$var$Table_B_2_lut_rel = $fdaa84edd0a5cdaf$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $fdaa84edd0a5cdaf$var$Table_B_2_complex = $fdaa84edd0a5cdaf$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $fdaa84edd0a5cdaf$var$bytes2);
const $fdaa84edd0a5cdaf$var$Table_C_ranges = $fdaa84edd0a5cdaf$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $fdaa84edd0a5cdaf$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $fdaa84edd0a5cdaf$export$d1ae0d802533bef0(codepoint) {
    return !!$fdaa84edd0a5cdaf$var$matchMap(codepoint, $fdaa84edd0a5cdaf$var$Table_A_1_ranges);
}
function $fdaa84edd0a5cdaf$export$9630a1f26a43b76c(codepoint) {
    let range = $fdaa84edd0a5cdaf$var$matchMap(codepoint, $fdaa84edd0a5cdaf$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $fdaa84edd0a5cdaf$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $fdaa84edd0a5cdaf$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $fdaa84edd0a5cdaf$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $fdaa84edd0a5cdaf$export$e07a548cae6d1553(codepoint) {
    return !!$fdaa84edd0a5cdaf$var$matchMap(codepoint, $fdaa84edd0a5cdaf$var$Table_C_ranges);
}
function $fdaa84edd0a5cdaf$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $itjXq.toUtf8CodePoints)(value);
    codes = $fdaa84edd0a5cdaf$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($fdaa84edd0a5cdaf$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $fdaa84edd0a5cdaf$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $itjXq.toUtf8CodePoints)((0, $itjXq._toUtf8String)(codes), (0, $itjXq.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($fdaa84edd0a5cdaf$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($fdaa84edd0a5cdaf$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $itjXq._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRegister("a75xs", function(module, exports) {

$parcel$export(module.exports, "commify", () => $75cedaaccd917bd0$export$de1294767e6ef661);
$parcel$export(module.exports, "formatUnits", () => $75cedaaccd917bd0$export$bd39b96f71da1885);
$parcel$export(module.exports, "parseUnits", () => $75cedaaccd917bd0$export$203ae30b4f6490b3);
$parcel$export(module.exports, "formatEther", () => $75cedaaccd917bd0$export$11bc63b4c03ea518);
$parcel$export(module.exports, "parseEther", () => $75cedaaccd917bd0$export$642c4e67bbdc0bc7);

var $bC4om = parcelRequire("bC4om");

var $hAWyw = parcelRequire("hAWyw");

var $fPclc = parcelRequire("fPclc");
"use strict";
const $75cedaaccd917bd0$var$logger = new (0, $hAWyw.Logger)((0, $fPclc.version));
const $75cedaaccd917bd0$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $75cedaaccd917bd0$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $75cedaaccd917bd0$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $75cedaaccd917bd0$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $75cedaaccd917bd0$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bC4om.formatFixed)(value, unitName != null ? unitName : 18);
}
function $75cedaaccd917bd0$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $75cedaaccd917bd0$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $75cedaaccd917bd0$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bC4om.parseFixed)(value, unitName != null ? unitName : 18);
}
function $75cedaaccd917bd0$export$11bc63b4c03ea518(wei) {
    return $75cedaaccd917bd0$export$bd39b96f71da1885(wei, 18);
}
function $75cedaaccd917bd0$export$642c4e67bbdc0bc7(ether) {
    return $75cedaaccd917bd0$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("fPclc", function(module, exports) {

$parcel$export(module.exports, "version", () => $b855311b268047cc$export$83d89fbfd8236492);
const $b855311b268047cc$export$83d89fbfd8236492 = "units/5.7.0";

});



parcelRegister("jhkQ1", function(module, exports) {

$parcel$export(module.exports, "version", () => $e08fc4da9c70399a$export$83d89fbfd8236492);
const $e08fc4da9c70399a$export$83d89fbfd8236492 = "ethers/5.7.2";

});




parcelRegister("5omI5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SiweErrorType = module.exports.SiweError = module.exports.VerifyOptsKeys = module.exports.VerifyParamsKeys = void 0;
module.exports.VerifyParamsKeys = [
    "signature",
    "scheme",
    "domain",
    "nonce",
    "time"
];
module.exports.VerifyOptsKeys = [
    "provider",
    "suppressExceptions",
    "verificationFallback"
];
/**
 * Interface used to return errors in SiweResponses.
 */ class $3ed0cf61301103ec$var$SiweError {
    constructor(type, expected, received){
        this.type = type;
        this.expected = expected;
        this.received = received;
    }
}
module.exports.SiweError = $3ed0cf61301103ec$var$SiweError;
/**
 * Possible message error types.
 */ var $3ed0cf61301103ec$var$SiweErrorType;
(function(SiweErrorType) {
    /** `expirationTime` is present and in the past. */ SiweErrorType["EXPIRED_MESSAGE"] = "Expired message.";
    /** `domain` is not a valid authority or is empty. */ SiweErrorType["INVALID_DOMAIN"] = "Invalid domain.";
    /** `scheme` don't match the scheme provided for verification. */ SiweErrorType["SCHEME_MISMATCH"] = "Scheme does not match provided scheme for verification.";
    /** `domain` don't match the domain provided for verification. */ SiweErrorType["DOMAIN_MISMATCH"] = "Domain does not match provided domain for verification.";
    /** `nonce` don't match the nonce provided for verification. */ SiweErrorType["NONCE_MISMATCH"] = "Nonce does not match provided nonce for verification.";
    /** `address` does not conform to EIP-55 or is not a valid address. */ SiweErrorType["INVALID_ADDRESS"] = "Invalid address.";
    /** `uri` does not conform to RFC 3986. */ SiweErrorType["INVALID_URI"] = "URI does not conform to RFC 3986.";
    /** `nonce` is smaller then 8 characters or is not alphanumeric */ SiweErrorType["INVALID_NONCE"] = "Nonce size smaller then 8 characters or is not alphanumeric.";
    /** `notBefore` is present and in the future. */ SiweErrorType["NOT_YET_VALID_MESSAGE"] = "Message is not valid yet.";
    /** Signature doesn't match the address of the message. */ SiweErrorType["INVALID_SIGNATURE"] = "Signature does not match address of the message.";
    /** `expirationTime`, `notBefore` or `issuedAt` not complient to ISO-8601. */ SiweErrorType["INVALID_TIME_FORMAT"] = "Invalid time format.";
    /** `version` is not 1. */ SiweErrorType["INVALID_MESSAGE_VERSION"] = "Invalid message version.";
    /** Thrown when some required field is missing. */ SiweErrorType["UNABLE_TO_PARSE"] = "Unable to parse the message.";
})($3ed0cf61301103ec$var$SiweErrorType = module.exports.SiweErrorType || (module.exports.SiweErrorType = {}));

});

parcelRegister("53zBN", function(module, exports) {
"use strict";
var $3ae8dab3399fef22$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkInvalidKeys = module.exports.isValidISO8601Date = module.exports.generateNonce = module.exports.checkContractWalletSignature = void 0;

var $lYmee = parcelRequire("lYmee");

var $4lHHr = parcelRequire("4lHHr");

var $3fhu7 = parcelRequire("3fhu7");
const $3ae8dab3399fef22$var$EIP1271_ABI = [
    "function isValidSignature(bytes32 _message, bytes _signature) public view returns (bytes4)"
];
const $3ae8dab3399fef22$var$EIP1271_MAGICVALUE = "0x1626ba7e";
const $3ae8dab3399fef22$var$ISO8601 = /^(?<date>[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(.[0-9]+)?(([Zz])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/;
/**
 * This method calls the EIP-1271 method for Smart Contract wallets
 * @param message The EIP-4361 parsed message
 * @param provider Web3 provider able to perform a contract check (Web3/EthersJS).
 * @returns {Promise<boolean>} Checks for the smart contract (if it exists) if
 * the signature is valid for given address.
 */ const $3ae8dab3399fef22$var$checkContractWalletSignature = (message, signature, provider)=>$3ae8dab3399fef22$var$__awaiter(void 0, void 0, void 0, function*() {
        if (!provider) return false;
        const walletContract = new $4lHHr.Contract(message.address, $3ae8dab3399fef22$var$EIP1271_ABI, provider);
        const hashedMessage = (0, $3fhu7.hashMessage)(message.prepareMessage());
        const res = yield walletContract.isValidSignature(hashedMessage, signature);
        return res === $3ae8dab3399fef22$var$EIP1271_MAGICVALUE;
    });
module.exports.checkContractWalletSignature = $3ae8dab3399fef22$var$checkContractWalletSignature;
/**
 * This method leverages a native CSPRNG with support for both browser and Node.js
 * environments in order generate a cryptographically secure nonce for use in the
 * SiweMessage in order to prevent replay attacks.
 *
 * 96 bits has been chosen as a number to sufficiently balance size and security considerations
 * relative to the lifespan of it's usage.
 *
 * @returns cryptographically generated random nonce with 96 bits of entropy encoded with
 * an alphanumeric character set.
 */ const $3ae8dab3399fef22$var$generateNonce = ()=>{
    const nonce = (0, $lYmee.randomStringForEntropy)(96);
    if (!nonce || nonce.length < 8) throw new Error("Error during nonce creation.");
    return nonce;
};
module.exports.generateNonce = $3ae8dab3399fef22$var$generateNonce;
/**
 * This method matches the given date string against the ISO-8601 regex and also
 * performs checks if it's a valid date.
 * @param inputDate any string to be validated against ISO-8601
 * @returns boolean indicating if the providade date is valid and conformant to ISO-8601
 */ const $3ae8dab3399fef22$var$isValidISO8601Date = (inputDate)=>{
    /* Split groups and make sure inputDate is in ISO8601 format */ const inputMatch = $3ae8dab3399fef22$var$ISO8601.exec(inputDate);
    /* if inputMatch is null the date is not ISO-8601 */ if (!inputDate) return false;
    /* Creates a date object with input date to parse for invalid days e.g. Feb, 30 -> Mar, 01 */ const inputDateParsed = new Date(inputMatch.groups.date).toISOString();
    /* Get groups from new parsed date to compare with the original input */ const parsedInputMatch = $3ae8dab3399fef22$var$ISO8601.exec(inputDateParsed);
    /* Compare remaining fields */ return inputMatch.groups.date === parsedInputMatch.groups.date;
};
module.exports.isValidISO8601Date = $3ae8dab3399fef22$var$isValidISO8601Date;
const $3ae8dab3399fef22$var$checkInvalidKeys = (obj, keys)=>{
    const invalidKeys = [];
    Object.keys(obj).forEach((key)=>{
        if (!keys.includes(key)) invalidKeys.push(key);
    });
    return invalidKeys;
};
module.exports.checkInvalidKeys = $3ae8dab3399fef22$var$checkInvalidKeys;

});


parcelRegister("fxidi", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $b4f810e63fa9ee68$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $b4f810e63fa9ee68$var$MAX_UINT32 = 4294967295;
function $b4f810e63fa9ee68$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $ZavwZ = parcelRequire("ZavwZ");
var $b4f810e63fa9ee68$require$Buffer = $ZavwZ.Buffer;
var $b4f810e63fa9ee68$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($b4f810e63fa9ee68$var$crypto && $b4f810e63fa9ee68$var$crypto.getRandomValues) module.exports = $b4f810e63fa9ee68$var$randomBytes;
else module.exports = $b4f810e63fa9ee68$var$oldBrowser;
function $b4f810e63fa9ee68$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $b4f810e63fa9ee68$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $b4f810e63fa9ee68$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $b4f810e63fa9ee68$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $b4f810e63fa9ee68$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $b4f810e63fa9ee68$var$crypto.getRandomValues(bytes.slice(generated, generated + $b4f810e63fa9ee68$var$MAX_BYTES));
        else $b4f810e63fa9ee68$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $gbdt3.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("ZavwZ", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $7ts9d = parcelRequire("7ts9d");
var $0b7dd934281528ef$var$Buffer = $7ts9d.Buffer;
// alternative to using Object.keys for old browsers
function $0b7dd934281528ef$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($0b7dd934281528ef$var$Buffer.from && $0b7dd934281528ef$var$Buffer.alloc && $0b7dd934281528ef$var$Buffer.allocUnsafe && $0b7dd934281528ef$var$Buffer.allocUnsafeSlow) module.exports = $7ts9d;
else {
    // Copy properties from require('buffer')
    $0b7dd934281528ef$var$copyProps($7ts9d, module.exports);
    module.exports.Buffer = $0b7dd934281528ef$var$SafeBuffer;
}
function $0b7dd934281528ef$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $0b7dd934281528ef$var$Buffer(arg, encodingOrOffset, length);
}
$0b7dd934281528ef$var$SafeBuffer.prototype = Object.create($0b7dd934281528ef$var$Buffer.prototype);
// Copy static methods from Buffer
$0b7dd934281528ef$var$copyProps($0b7dd934281528ef$var$Buffer, $0b7dd934281528ef$var$SafeBuffer);
$0b7dd934281528ef$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $0b7dd934281528ef$var$Buffer(arg, encodingOrOffset, length);
};
$0b7dd934281528ef$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $0b7dd934281528ef$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$0b7dd934281528ef$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $0b7dd934281528ef$var$Buffer(size);
};
$0b7dd934281528ef$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $7ts9d.SlowBuffer(size);
};

});


parcelRegister("lNfZR", function(module, exports) {
"use strict";

var $lfl9G = parcelRequire("lfl9G");

var $k7S11 = parcelRequire("k7S11");

var $60Enq = parcelRequire("60Enq");

var $1cw1e = parcelRequire("1cw1e");

var $f2cqU = parcelRequire("f2cqU");
function $fdda952e134fc15f$var$Hash(hash) {
    $f2cqU.call(this, "digest");
    this._hash = hash;
}
$lfl9G($fdda952e134fc15f$var$Hash, $f2cqU);
$fdda952e134fc15f$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$fdda952e134fc15f$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $k7S11();
    if (alg === "rmd160" || alg === "ripemd160") return new $60Enq();
    return new $fdda952e134fc15f$var$Hash($1cw1e(alg));
};

});
parcelRegister("k7S11", function(module, exports) {
"use strict";

var $lfl9G = parcelRequire("lfl9G");

var $gLBv8 = parcelRequire("gLBv8");

var $ZavwZ = parcelRequire("ZavwZ");
var $ea6e5c7333a9b5c6$require$Buffer = $ZavwZ.Buffer;
var $ea6e5c7333a9b5c6$var$ARRAY16 = new Array(16);
function $ea6e5c7333a9b5c6$var$MD5() {
    $gLBv8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lfl9G($ea6e5c7333a9b5c6$var$MD5, $gLBv8);
$ea6e5c7333a9b5c6$var$MD5.prototype._update = function() {
    var M = $ea6e5c7333a9b5c6$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $ea6e5c7333a9b5c6$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $ea6e5c7333a9b5c6$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $ea6e5c7333a9b5c6$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $ea6e5c7333a9b5c6$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $ea6e5c7333a9b5c6$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $ea6e5c7333a9b5c6$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $ea6e5c7333a9b5c6$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $ea6e5c7333a9b5c6$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $ea6e5c7333a9b5c6$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $ea6e5c7333a9b5c6$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $ea6e5c7333a9b5c6$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $ea6e5c7333a9b5c6$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $ea6e5c7333a9b5c6$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $ea6e5c7333a9b5c6$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $ea6e5c7333a9b5c6$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $ea6e5c7333a9b5c6$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $ea6e5c7333a9b5c6$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $ea6e5c7333a9b5c6$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $ea6e5c7333a9b5c6$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $ea6e5c7333a9b5c6$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $ea6e5c7333a9b5c6$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $ea6e5c7333a9b5c6$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $ea6e5c7333a9b5c6$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $ea6e5c7333a9b5c6$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $ea6e5c7333a9b5c6$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $ea6e5c7333a9b5c6$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $ea6e5c7333a9b5c6$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $ea6e5c7333a9b5c6$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $ea6e5c7333a9b5c6$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $ea6e5c7333a9b5c6$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $ea6e5c7333a9b5c6$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $ea6e5c7333a9b5c6$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $ea6e5c7333a9b5c6$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $ea6e5c7333a9b5c6$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $ea6e5c7333a9b5c6$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $ea6e5c7333a9b5c6$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $ea6e5c7333a9b5c6$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $ea6e5c7333a9b5c6$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $ea6e5c7333a9b5c6$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $ea6e5c7333a9b5c6$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $ea6e5c7333a9b5c6$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $ea6e5c7333a9b5c6$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $ea6e5c7333a9b5c6$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $ea6e5c7333a9b5c6$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $ea6e5c7333a9b5c6$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $ea6e5c7333a9b5c6$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $ea6e5c7333a9b5c6$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $ea6e5c7333a9b5c6$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $ea6e5c7333a9b5c6$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $ea6e5c7333a9b5c6$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $ea6e5c7333a9b5c6$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $ea6e5c7333a9b5c6$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $ea6e5c7333a9b5c6$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $ea6e5c7333a9b5c6$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $ea6e5c7333a9b5c6$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $ea6e5c7333a9b5c6$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $ea6e5c7333a9b5c6$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $ea6e5c7333a9b5c6$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $ea6e5c7333a9b5c6$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $ea6e5c7333a9b5c6$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $ea6e5c7333a9b5c6$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $ea6e5c7333a9b5c6$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $ea6e5c7333a9b5c6$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $ea6e5c7333a9b5c6$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$ea6e5c7333a9b5c6$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $ea6e5c7333a9b5c6$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $ea6e5c7333a9b5c6$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $ea6e5c7333a9b5c6$var$fnF(a, b, c, d, m, k, s) {
    return $ea6e5c7333a9b5c6$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $ea6e5c7333a9b5c6$var$fnG(a, b, c, d, m, k, s) {
    return $ea6e5c7333a9b5c6$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $ea6e5c7333a9b5c6$var$fnH(a, b, c, d, m, k, s) {
    return $ea6e5c7333a9b5c6$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $ea6e5c7333a9b5c6$var$fnI(a, b, c, d, m, k, s) {
    return $ea6e5c7333a9b5c6$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $ea6e5c7333a9b5c6$var$MD5;

});
parcelRegister("gLBv8", function(module, exports) {
"use strict";

var $ZavwZ = parcelRequire("ZavwZ");
var $c34e201a88d55d83$require$Buffer = $ZavwZ.Buffer;

var $ljG0D = parcelRequire("ljG0D");
var $c34e201a88d55d83$require$Transform = $ljG0D.Transform;

var $lfl9G = parcelRequire("lfl9G");
function $c34e201a88d55d83$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$c34e201a88d55d83$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $c34e201a88d55d83$var$HashBase(blockSize) {
    $c34e201a88d55d83$require$Transform.call(this);
    this._block = $c34e201a88d55d83$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lfl9G($c34e201a88d55d83$var$HashBase, $c34e201a88d55d83$require$Transform);
$c34e201a88d55d83$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c34e201a88d55d83$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c34e201a88d55d83$var$HashBase.prototype.update = function(data, encoding) {
    $c34e201a88d55d83$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$c34e201a88d55d83$require$Buffer.isBuffer(data)) data = $c34e201a88d55d83$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$c34e201a88d55d83$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$c34e201a88d55d83$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$c34e201a88d55d83$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $c34e201a88d55d83$var$HashBase;

});
parcelRegister("ljG0D", function(module, exports) {

exports = module.exports = (parcelRequire("7ARQa"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("dd7GY"));

exports.Duplex = (parcelRequire("kcOWY"));

exports.Transform = (parcelRequire("6mkFE"));

exports.PassThrough = (parcelRequire("6G8nA"));

exports.finished = (parcelRequire("irTo4"));

exports.pipeline = (parcelRequire("eHc2I"));

});
parcelRegister("7ARQa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
module.exports = $5875a8cbf9c61cc2$var$Readable;
/*<replacement>*/ var $5875a8cbf9c61cc2$var$Duplex;
/*</replacement>*/ $5875a8cbf9c61cc2$var$Readable.ReadableState = $5875a8cbf9c61cc2$var$ReadableState;

var $ej6Nm = parcelRequire("ej6Nm");
var $5875a8cbf9c61cc2$require$EE = $ej6Nm.EventEmitter;
var $5875a8cbf9c61cc2$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $eSC30 = parcelRequire("eSC30");

var $7ts9d = parcelRequire("7ts9d");
var $5875a8cbf9c61cc2$require$Buffer = $7ts9d.Buffer;
var $5875a8cbf9c61cc2$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5875a8cbf9c61cc2$var$_uint8ArrayToBuffer(chunk) {
    return $5875a8cbf9c61cc2$require$Buffer.from(chunk);
}
function $5875a8cbf9c61cc2$var$_isUint8Array(obj) {
    return $5875a8cbf9c61cc2$require$Buffer.isBuffer(obj) || obj instanceof $5875a8cbf9c61cc2$var$OurUint8Array;
}

var $ejAqS = parcelRequire("ejAqS");
var $5875a8cbf9c61cc2$var$debug;
if ($ejAqS && $ejAqS.debuglog) $5875a8cbf9c61cc2$var$debug = $ejAqS.debuglog("stream");
else $5875a8cbf9c61cc2$var$debug = function debug() {};

var $aJ83Z = parcelRequire("aJ83Z");

var $4onKy = parcelRequire("4onKy");

var $iTdG8 = parcelRequire("iTdG8");
var $5875a8cbf9c61cc2$var$getHighWaterMark = $iTdG8.getHighWaterMark;

var $hApZK = parcelRequire("hApZK");
var $5875a8cbf9c61cc2$require$_require$codes = $hApZK.codes;
var $5875a8cbf9c61cc2$var$ERR_INVALID_ARG_TYPE = $5875a8cbf9c61cc2$require$_require$codes.ERR_INVALID_ARG_TYPE, $5875a8cbf9c61cc2$var$ERR_STREAM_PUSH_AFTER_EOF = $5875a8cbf9c61cc2$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $5875a8cbf9c61cc2$var$ERR_METHOD_NOT_IMPLEMENTED = $5875a8cbf9c61cc2$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5875a8cbf9c61cc2$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $5875a8cbf9c61cc2$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $5875a8cbf9c61cc2$var$StringDecoder;
var $5875a8cbf9c61cc2$var$createReadableStreamAsyncIterator;
var $5875a8cbf9c61cc2$var$from;

(parcelRequire("lfl9G"))($5875a8cbf9c61cc2$var$Readable, $eSC30);
var $5875a8cbf9c61cc2$var$errorOrDestroy = $4onKy.errorOrDestroy;
var $5875a8cbf9c61cc2$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $5875a8cbf9c61cc2$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $5875a8cbf9c61cc2$var$ReadableState(options, stream, isDuplex) {
    $5875a8cbf9c61cc2$var$Duplex = $5875a8cbf9c61cc2$var$Duplex || (parcelRequire("kcOWY"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5875a8cbf9c61cc2$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $5875a8cbf9c61cc2$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aJ83Z();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$5875a8cbf9c61cc2$var$StringDecoder) $5875a8cbf9c61cc2$var$StringDecoder = (parcelRequire("km3X2")).StringDecoder;
        this.decoder = new $5875a8cbf9c61cc2$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $5875a8cbf9c61cc2$var$Readable(options) {
    $5875a8cbf9c61cc2$var$Duplex = $5875a8cbf9c61cc2$var$Duplex || (parcelRequire("kcOWY"));
    if (!(this instanceof $5875a8cbf9c61cc2$var$Readable)) return new $5875a8cbf9c61cc2$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5875a8cbf9c61cc2$var$Duplex;
    this._readableState = new $5875a8cbf9c61cc2$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $eSC30.call(this);
}
Object.defineProperty($5875a8cbf9c61cc2$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$5875a8cbf9c61cc2$var$Readable.prototype.destroy = $4onKy.destroy;
$5875a8cbf9c61cc2$var$Readable.prototype._undestroy = $4onKy.undestroy;
$5875a8cbf9c61cc2$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$5875a8cbf9c61cc2$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $5875a8cbf9c61cc2$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $5875a8cbf9c61cc2$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$5875a8cbf9c61cc2$var$Readable.prototype.unshift = function(chunk) {
    return $5875a8cbf9c61cc2$var$readableAddChunk(this, chunk, null, true, false);
};
function $5875a8cbf9c61cc2$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $5875a8cbf9c61cc2$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $5875a8cbf9c61cc2$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $5875a8cbf9c61cc2$var$chunkInvalid(state, chunk);
        if (er) $5875a8cbf9c61cc2$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $5875a8cbf9c61cc2$require$Buffer.prototype) chunk = $5875a8cbf9c61cc2$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $5875a8cbf9c61cc2$var$errorOrDestroy(stream, new $5875a8cbf9c61cc2$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $5875a8cbf9c61cc2$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $5875a8cbf9c61cc2$var$errorOrDestroy(stream, new $5875a8cbf9c61cc2$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $5875a8cbf9c61cc2$var$addChunk(stream, state, chunk, false);
                    else $5875a8cbf9c61cc2$var$maybeReadMore(stream, state);
                } else $5875a8cbf9c61cc2$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $5875a8cbf9c61cc2$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $5875a8cbf9c61cc2$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $5875a8cbf9c61cc2$var$emitReadable(stream);
    }
    $5875a8cbf9c61cc2$var$maybeReadMore(stream, state);
}
function $5875a8cbf9c61cc2$var$chunkInvalid(state, chunk) {
    var er;
    if (!$5875a8cbf9c61cc2$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $5875a8cbf9c61cc2$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$5875a8cbf9c61cc2$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$5875a8cbf9c61cc2$var$Readable.prototype.setEncoding = function(enc) {
    if (!$5875a8cbf9c61cc2$var$StringDecoder) $5875a8cbf9c61cc2$var$StringDecoder = (parcelRequire("km3X2")).StringDecoder;
    var decoder = new $5875a8cbf9c61cc2$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $5875a8cbf9c61cc2$var$MAX_HWM = 0x40000000;
function $5875a8cbf9c61cc2$var$computeNewHighWaterMark(n) {
    if (n >= $5875a8cbf9c61cc2$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $5875a8cbf9c61cc2$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5875a8cbf9c61cc2$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $5875a8cbf9c61cc2$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$5875a8cbf9c61cc2$var$Readable.prototype.read = function(n) {
    $5875a8cbf9c61cc2$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $5875a8cbf9c61cc2$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $5875a8cbf9c61cc2$var$endReadable(this);
        else $5875a8cbf9c61cc2$var$emitReadable(this);
        return null;
    }
    n = $5875a8cbf9c61cc2$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $5875a8cbf9c61cc2$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $5875a8cbf9c61cc2$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $5875a8cbf9c61cc2$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $5875a8cbf9c61cc2$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $5875a8cbf9c61cc2$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $5875a8cbf9c61cc2$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $5875a8cbf9c61cc2$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $5875a8cbf9c61cc2$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $5875a8cbf9c61cc2$var$onEofChunk(stream, state) {
    $5875a8cbf9c61cc2$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $5875a8cbf9c61cc2$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $5875a8cbf9c61cc2$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $5875a8cbf9c61cc2$var$emitReadable(stream) {
    var state = stream._readableState;
    $5875a8cbf9c61cc2$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $5875a8cbf9c61cc2$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $gbdt3.nextTick($5875a8cbf9c61cc2$var$emitReadable_, stream);
    }
}
function $5875a8cbf9c61cc2$var$emitReadable_(stream) {
    var state = stream._readableState;
    $5875a8cbf9c61cc2$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $5875a8cbf9c61cc2$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $5875a8cbf9c61cc2$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $gbdt3.nextTick($5875a8cbf9c61cc2$var$maybeReadMore_, stream, state);
    }
}
function $5875a8cbf9c61cc2$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $5875a8cbf9c61cc2$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$5875a8cbf9c61cc2$var$Readable.prototype._read = function(n) {
    $5875a8cbf9c61cc2$var$errorOrDestroy(this, new $5875a8cbf9c61cc2$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$5875a8cbf9c61cc2$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $5875a8cbf9c61cc2$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $gbdt3.stdout && dest !== $gbdt3.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $gbdt3.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $5875a8cbf9c61cc2$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $5875a8cbf9c61cc2$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $5875a8cbf9c61cc2$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $5875a8cbf9c61cc2$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $5875a8cbf9c61cc2$var$debug("ondata");
        var ret = dest.write(chunk);
        $5875a8cbf9c61cc2$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $5875a8cbf9c61cc2$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $5875a8cbf9c61cc2$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $5875a8cbf9c61cc2$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($5875a8cbf9c61cc2$var$EElistenerCount(dest, "error") === 0) $5875a8cbf9c61cc2$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $5875a8cbf9c61cc2$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $5875a8cbf9c61cc2$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $5875a8cbf9c61cc2$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $5875a8cbf9c61cc2$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $5875a8cbf9c61cc2$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $5875a8cbf9c61cc2$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $5875a8cbf9c61cc2$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $5875a8cbf9c61cc2$var$flow(src);
        }
    };
}
$5875a8cbf9c61cc2$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $5875a8cbf9c61cc2$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$5875a8cbf9c61cc2$var$Readable.prototype.on = function(ev, fn) {
    var res = $eSC30.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $5875a8cbf9c61cc2$var$debug("on readable", state.length, state.reading);
            if (state.length) $5875a8cbf9c61cc2$var$emitReadable(this);
            else if (!state.reading) $gbdt3.nextTick($5875a8cbf9c61cc2$var$nReadingNextTick, this);
        }
    }
    return res;
};
$5875a8cbf9c61cc2$var$Readable.prototype.addListener = $5875a8cbf9c61cc2$var$Readable.prototype.on;
$5875a8cbf9c61cc2$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $eSC30.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $gbdt3.nextTick($5875a8cbf9c61cc2$var$updateReadableListening, this);
    return res;
};
$5875a8cbf9c61cc2$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $eSC30.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $gbdt3.nextTick($5875a8cbf9c61cc2$var$updateReadableListening, this);
    return res;
};
function $5875a8cbf9c61cc2$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $5875a8cbf9c61cc2$var$nReadingNextTick(self1) {
    $5875a8cbf9c61cc2$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$5875a8cbf9c61cc2$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $5875a8cbf9c61cc2$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $5875a8cbf9c61cc2$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $5875a8cbf9c61cc2$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $gbdt3.nextTick($5875a8cbf9c61cc2$var$resume_, stream, state);
    }
}
function $5875a8cbf9c61cc2$var$resume_(stream, state) {
    $5875a8cbf9c61cc2$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $5875a8cbf9c61cc2$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$5875a8cbf9c61cc2$var$Readable.prototype.pause = function() {
    $5875a8cbf9c61cc2$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $5875a8cbf9c61cc2$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $5875a8cbf9c61cc2$var$flow(stream) {
    var state = stream._readableState;
    $5875a8cbf9c61cc2$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$5875a8cbf9c61cc2$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $5875a8cbf9c61cc2$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $5875a8cbf9c61cc2$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $5875a8cbf9c61cc2$var$kProxyEvents.length; n++)stream.on($5875a8cbf9c61cc2$var$kProxyEvents[n], this.emit.bind(this, $5875a8cbf9c61cc2$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $5875a8cbf9c61cc2$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $5875a8cbf9c61cc2$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($5875a8cbf9c61cc2$var$createReadableStreamAsyncIterator === undefined) $5875a8cbf9c61cc2$var$createReadableStreamAsyncIterator = (parcelRequire("kg24O"));
    return $5875a8cbf9c61cc2$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($5875a8cbf9c61cc2$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($5875a8cbf9c61cc2$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($5875a8cbf9c61cc2$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$5875a8cbf9c61cc2$var$Readable._fromList = $5875a8cbf9c61cc2$var$fromList;
Object.defineProperty($5875a8cbf9c61cc2$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5875a8cbf9c61cc2$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $5875a8cbf9c61cc2$var$endReadable(stream) {
    var state = stream._readableState;
    $5875a8cbf9c61cc2$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $gbdt3.nextTick($5875a8cbf9c61cc2$var$endReadableNT, state, stream);
    }
}
function $5875a8cbf9c61cc2$var$endReadableNT(state, stream) {
    $5875a8cbf9c61cc2$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $5875a8cbf9c61cc2$var$Readable.from = function(iterable, opts) {
    if ($5875a8cbf9c61cc2$var$from === undefined) $5875a8cbf9c61cc2$var$from = (parcelRequire("87hj1"));
    return $5875a8cbf9c61cc2$var$from($5875a8cbf9c61cc2$var$Readable, iterable, opts);
};
function $5875a8cbf9c61cc2$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("ej6Nm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $a6a81c6bf1495204$var$R = typeof Reflect === "object" ? Reflect : null;
var $a6a81c6bf1495204$var$ReflectApply = $a6a81c6bf1495204$var$R && typeof $a6a81c6bf1495204$var$R.apply === "function" ? $a6a81c6bf1495204$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $a6a81c6bf1495204$var$ReflectOwnKeys;
if ($a6a81c6bf1495204$var$R && typeof $a6a81c6bf1495204$var$R.ownKeys === "function") $a6a81c6bf1495204$var$ReflectOwnKeys = $a6a81c6bf1495204$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $a6a81c6bf1495204$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $a6a81c6bf1495204$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $a6a81c6bf1495204$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $a6a81c6bf1495204$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $a6a81c6bf1495204$var$EventEmitter() {
    $a6a81c6bf1495204$var$EventEmitter.init.call(this);
}
module.exports = $a6a81c6bf1495204$var$EventEmitter;
module.exports.once = $a6a81c6bf1495204$var$once;
// Backwards-compat with node 0.10.x
$a6a81c6bf1495204$var$EventEmitter.EventEmitter = $a6a81c6bf1495204$var$EventEmitter;
$a6a81c6bf1495204$var$EventEmitter.prototype._events = undefined;
$a6a81c6bf1495204$var$EventEmitter.prototype._eventsCount = 0;
$a6a81c6bf1495204$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $a6a81c6bf1495204$var$defaultMaxListeners = 10;
function $a6a81c6bf1495204$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($a6a81c6bf1495204$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $a6a81c6bf1495204$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $a6a81c6bf1495204$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $a6a81c6bf1495204$var$defaultMaxListeners = arg;
    }
});
$a6a81c6bf1495204$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$a6a81c6bf1495204$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $a6a81c6bf1495204$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $a6a81c6bf1495204$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $a6a81c6bf1495204$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$a6a81c6bf1495204$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $a6a81c6bf1495204$var$_getMaxListeners(this);
};
$a6a81c6bf1495204$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $a6a81c6bf1495204$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $a6a81c6bf1495204$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$a6a81c6bf1495204$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $a6a81c6bf1495204$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $a6a81c6bf1495204$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $a6a81c6bf1495204$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $a6a81c6bf1495204$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$a6a81c6bf1495204$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $a6a81c6bf1495204$var$_addListener(this, type, listener, false);
};
$a6a81c6bf1495204$var$EventEmitter.prototype.on = $a6a81c6bf1495204$var$EventEmitter.prototype.addListener;
$a6a81c6bf1495204$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $a6a81c6bf1495204$var$_addListener(this, type, listener, true);
};
function $a6a81c6bf1495204$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $a6a81c6bf1495204$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $a6a81c6bf1495204$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$a6a81c6bf1495204$var$EventEmitter.prototype.once = function once(type, listener) {
    $a6a81c6bf1495204$var$checkListener(listener);
    this.on(type, $a6a81c6bf1495204$var$_onceWrap(this, type, listener));
    return this;
};
$a6a81c6bf1495204$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $a6a81c6bf1495204$var$checkListener(listener);
    this.prependListener(type, $a6a81c6bf1495204$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$a6a81c6bf1495204$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $a6a81c6bf1495204$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $a6a81c6bf1495204$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$a6a81c6bf1495204$var$EventEmitter.prototype.off = $a6a81c6bf1495204$var$EventEmitter.prototype.removeListener;
$a6a81c6bf1495204$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $a6a81c6bf1495204$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $a6a81c6bf1495204$var$unwrapListeners(evlistener) : $a6a81c6bf1495204$var$arrayClone(evlistener, evlistener.length);
}
$a6a81c6bf1495204$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $a6a81c6bf1495204$var$_listeners(this, type, true);
};
$a6a81c6bf1495204$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $a6a81c6bf1495204$var$_listeners(this, type, false);
};
$a6a81c6bf1495204$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $a6a81c6bf1495204$var$listenerCount.call(emitter, type);
};
$a6a81c6bf1495204$var$EventEmitter.prototype.listenerCount = $a6a81c6bf1495204$var$listenerCount;
function $a6a81c6bf1495204$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$a6a81c6bf1495204$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $a6a81c6bf1495204$var$ReflectOwnKeys(this._events) : [];
};
function $a6a81c6bf1495204$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $a6a81c6bf1495204$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $a6a81c6bf1495204$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $a6a81c6bf1495204$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $a6a81c6bf1495204$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $a6a81c6bf1495204$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $a6a81c6bf1495204$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $a6a81c6bf1495204$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $a6a81c6bf1495204$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("eSC30", function(module, exports) {

module.exports = (parcelRequire("ej6Nm")).EventEmitter;

});

parcelRegister("aJ83Z", function(module, exports) {
"use strict";
function $7cf45c8e6ffd8848$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7cf45c8e6ffd8848$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7cf45c8e6ffd8848$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7cf45c8e6ffd8848$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7cf45c8e6ffd8848$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7cf45c8e6ffd8848$var$_defineProperty(obj, key, value) {
    key = $7cf45c8e6ffd8848$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7cf45c8e6ffd8848$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7cf45c8e6ffd8848$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7cf45c8e6ffd8848$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7cf45c8e6ffd8848$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7cf45c8e6ffd8848$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7cf45c8e6ffd8848$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7cf45c8e6ffd8848$var$_toPropertyKey(arg) {
    var key = $7cf45c8e6ffd8848$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7cf45c8e6ffd8848$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $7ts9d = parcelRequire("7ts9d");
var $7cf45c8e6ffd8848$var$Buffer = $7ts9d.Buffer;

var $ejAqS = parcelRequire("ejAqS");
var $7cf45c8e6ffd8848$var$inspect = $ejAqS.inspect;
var $7cf45c8e6ffd8848$var$custom = $7cf45c8e6ffd8848$var$inspect && $7cf45c8e6ffd8848$var$inspect.custom || "inspect";
function $7cf45c8e6ffd8848$var$copyBuffer(src, target, offset) {
    $7cf45c8e6ffd8848$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $7cf45c8e6ffd8848$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $7cf45c8e6ffd8848$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7cf45c8e6ffd8848$var$Buffer.alloc(0);
                var ret = $7cf45c8e6ffd8848$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7cf45c8e6ffd8848$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7cf45c8e6ffd8848$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $7cf45c8e6ffd8848$var$custom,
            value: function value(_, options) {
                return $7cf45c8e6ffd8848$var$inspect(this, $7cf45c8e6ffd8848$var$_objectSpread($7cf45c8e6ffd8848$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("4onKy", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $332bd38ce324dadd$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $gbdt3.nextTick($332bd38ce324dadd$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $gbdt3.nextTick($332bd38ce324dadd$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $gbdt3.nextTick($332bd38ce324dadd$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $gbdt3.nextTick($332bd38ce324dadd$var$emitErrorAndCloseNT, _this, err);
            } else $gbdt3.nextTick($332bd38ce324dadd$var$emitCloseNT, _this);
        } else if (cb) {
            $gbdt3.nextTick($332bd38ce324dadd$var$emitCloseNT, _this);
            cb(err);
        } else $gbdt3.nextTick($332bd38ce324dadd$var$emitCloseNT, _this);
    });
    return this;
}
function $332bd38ce324dadd$var$emitErrorAndCloseNT(self, err) {
    $332bd38ce324dadd$var$emitErrorNT(self, err);
    $332bd38ce324dadd$var$emitCloseNT(self);
}
function $332bd38ce324dadd$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $332bd38ce324dadd$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $332bd38ce324dadd$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $332bd38ce324dadd$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $332bd38ce324dadd$var$destroy,
    undestroy: $332bd38ce324dadd$var$undestroy,
    errorOrDestroy: $332bd38ce324dadd$var$errorOrDestroy
};

});

parcelRegister("iTdG8", function(module, exports) {
"use strict";

var $dc07f954da9b71da$var$ERR_INVALID_OPT_VALUE = (parcelRequire("hApZK")).codes.ERR_INVALID_OPT_VALUE;
function $dc07f954da9b71da$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $dc07f954da9b71da$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $dc07f954da9b71da$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $dc07f954da9b71da$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $dc07f954da9b71da$var$getHighWaterMark
};

});
parcelRegister("hApZK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $ccd9f68169c0c963$export$e45cb6485273080e, (v) => $ccd9f68169c0c963$export$e45cb6485273080e = v);
var $ccd9f68169c0c963$export$e45cb6485273080e;
"use strict";
function $ccd9f68169c0c963$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ccd9f68169c0c963$var$codes = {};
function $ccd9f68169c0c963$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $ccd9f68169c0c963$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $ccd9f68169c0c963$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $ccd9f68169c0c963$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $ccd9f68169c0c963$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $ccd9f68169c0c963$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $ccd9f68169c0c963$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$ccd9f68169c0c963$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$ccd9f68169c0c963$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $ccd9f68169c0c963$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($ccd9f68169c0c963$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($ccd9f68169c0c963$var$oneOf(expected, "type"));
    else {
        var type = $ccd9f68169c0c963$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($ccd9f68169c0c963$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$ccd9f68169c0c963$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$ccd9f68169c0c963$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$ccd9f68169c0c963$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$ccd9f68169c0c963$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$ccd9f68169c0c963$export$e45cb6485273080e = $ccd9f68169c0c963$var$codes;

});


parcelRegister("kcOWY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
/*<replacement>*/ var $eb5c734a867b2b93$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $eb5c734a867b2b93$var$Duplex;

var $7ARQa = parcelRequire("7ARQa");

var $dd7GY = parcelRequire("dd7GY");

(parcelRequire("lfl9G"))($eb5c734a867b2b93$var$Duplex, $7ARQa);
// Allow the keys array to be GC'ed.
var $eb5c734a867b2b93$var$keys = $eb5c734a867b2b93$var$objectKeys($dd7GY.prototype);
for(var $eb5c734a867b2b93$var$v = 0; $eb5c734a867b2b93$var$v < $eb5c734a867b2b93$var$keys.length; $eb5c734a867b2b93$var$v++){
    var $eb5c734a867b2b93$var$method = $eb5c734a867b2b93$var$keys[$eb5c734a867b2b93$var$v];
    if (!$eb5c734a867b2b93$var$Duplex.prototype[$eb5c734a867b2b93$var$method]) $eb5c734a867b2b93$var$Duplex.prototype[$eb5c734a867b2b93$var$method] = $dd7GY.prototype[$eb5c734a867b2b93$var$method];
}
function $eb5c734a867b2b93$var$Duplex(options) {
    if (!(this instanceof $eb5c734a867b2b93$var$Duplex)) return new $eb5c734a867b2b93$var$Duplex(options);
    $7ARQa.call(this, options);
    $dd7GY.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $eb5c734a867b2b93$var$onend);
        }
    }
}
Object.defineProperty($eb5c734a867b2b93$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($eb5c734a867b2b93$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($eb5c734a867b2b93$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $eb5c734a867b2b93$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $gbdt3.nextTick($eb5c734a867b2b93$var$onEndNT, this);
}
function $eb5c734a867b2b93$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($eb5c734a867b2b93$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("dd7GY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
module.exports = $99e274c1ab068d6b$var$Writable;
/* <replacement> */ function $99e274c1ab068d6b$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $99e274c1ab068d6b$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $99e274c1ab068d6b$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $99e274c1ab068d6b$var$Duplex;
/*</replacement>*/ $99e274c1ab068d6b$var$Writable.WritableState = $99e274c1ab068d6b$var$WritableState;

/*<replacement>*/ var $99e274c1ab068d6b$var$internalUtil = {
    deprecate: (parcelRequire("baRbS"))
};

var $eSC30 = parcelRequire("eSC30");

var $7ts9d = parcelRequire("7ts9d");
var $99e274c1ab068d6b$require$Buffer = $7ts9d.Buffer;
var $99e274c1ab068d6b$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $99e274c1ab068d6b$var$_uint8ArrayToBuffer(chunk) {
    return $99e274c1ab068d6b$require$Buffer.from(chunk);
}
function $99e274c1ab068d6b$var$_isUint8Array(obj) {
    return $99e274c1ab068d6b$require$Buffer.isBuffer(obj) || obj instanceof $99e274c1ab068d6b$var$OurUint8Array;
}

var $4onKy = parcelRequire("4onKy");

var $iTdG8 = parcelRequire("iTdG8");
var $99e274c1ab068d6b$var$getHighWaterMark = $iTdG8.getHighWaterMark;

var $hApZK = parcelRequire("hApZK");
var $99e274c1ab068d6b$require$_require$codes = $hApZK.codes;
var $99e274c1ab068d6b$var$ERR_INVALID_ARG_TYPE = $99e274c1ab068d6b$require$_require$codes.ERR_INVALID_ARG_TYPE, $99e274c1ab068d6b$var$ERR_METHOD_NOT_IMPLEMENTED = $99e274c1ab068d6b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $99e274c1ab068d6b$var$ERR_MULTIPLE_CALLBACK = $99e274c1ab068d6b$require$_require$codes.ERR_MULTIPLE_CALLBACK, $99e274c1ab068d6b$var$ERR_STREAM_CANNOT_PIPE = $99e274c1ab068d6b$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $99e274c1ab068d6b$var$ERR_STREAM_DESTROYED = $99e274c1ab068d6b$require$_require$codes.ERR_STREAM_DESTROYED, $99e274c1ab068d6b$var$ERR_STREAM_NULL_VALUES = $99e274c1ab068d6b$require$_require$codes.ERR_STREAM_NULL_VALUES, $99e274c1ab068d6b$var$ERR_STREAM_WRITE_AFTER_END = $99e274c1ab068d6b$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $99e274c1ab068d6b$var$ERR_UNKNOWN_ENCODING = $99e274c1ab068d6b$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $99e274c1ab068d6b$var$errorOrDestroy = $4onKy.errorOrDestroy;

(parcelRequire("lfl9G"))($99e274c1ab068d6b$var$Writable, $eSC30);
function $99e274c1ab068d6b$var$nop() {}

function $99e274c1ab068d6b$var$WritableState(options, stream, isDuplex) {
    $99e274c1ab068d6b$var$Duplex = $99e274c1ab068d6b$var$Duplex || (parcelRequire("kcOWY"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $99e274c1ab068d6b$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $99e274c1ab068d6b$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $99e274c1ab068d6b$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $99e274c1ab068d6b$var$CorkedRequest(this);
}
$99e274c1ab068d6b$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($99e274c1ab068d6b$var$WritableState.prototype, "buffer", {
            get: $99e274c1ab068d6b$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $99e274c1ab068d6b$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $99e274c1ab068d6b$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($99e274c1ab068d6b$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($99e274c1ab068d6b$var$realHasInstance.call(this, object)) return true;
            if (this !== $99e274c1ab068d6b$var$Writable) return false;
            return object && object._writableState instanceof $99e274c1ab068d6b$var$WritableState;
        }
    });
} else $99e274c1ab068d6b$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $99e274c1ab068d6b$var$Writable(options) {
    $99e274c1ab068d6b$var$Duplex = $99e274c1ab068d6b$var$Duplex || (parcelRequire("kcOWY"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $99e274c1ab068d6b$var$Duplex;
    if (!isDuplex && !$99e274c1ab068d6b$var$realHasInstance.call($99e274c1ab068d6b$var$Writable, this)) return new $99e274c1ab068d6b$var$Writable(options);
    this._writableState = new $99e274c1ab068d6b$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $eSC30.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$99e274c1ab068d6b$var$Writable.prototype.pipe = function() {
    $99e274c1ab068d6b$var$errorOrDestroy(this, new $99e274c1ab068d6b$var$ERR_STREAM_CANNOT_PIPE());
};
function $99e274c1ab068d6b$var$writeAfterEnd(stream, cb) {
    var er = new $99e274c1ab068d6b$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $99e274c1ab068d6b$var$errorOrDestroy(stream, er);
    $gbdt3.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $99e274c1ab068d6b$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $99e274c1ab068d6b$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $99e274c1ab068d6b$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $99e274c1ab068d6b$var$errorOrDestroy(stream, er);
        $gbdt3.nextTick(cb, er);
        return false;
    }
    return true;
}
$99e274c1ab068d6b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $99e274c1ab068d6b$var$_isUint8Array(chunk);
    if (isBuf && !$99e274c1ab068d6b$require$Buffer.isBuffer(chunk)) chunk = $99e274c1ab068d6b$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $99e274c1ab068d6b$var$nop;
    if (state.ending) $99e274c1ab068d6b$var$writeAfterEnd(this, cb);
    else if (isBuf || $99e274c1ab068d6b$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $99e274c1ab068d6b$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$99e274c1ab068d6b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$99e274c1ab068d6b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $99e274c1ab068d6b$var$clearBuffer(this, state);
    }
};
$99e274c1ab068d6b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $99e274c1ab068d6b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($99e274c1ab068d6b$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $99e274c1ab068d6b$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $99e274c1ab068d6b$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($99e274c1ab068d6b$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $99e274c1ab068d6b$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $99e274c1ab068d6b$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $99e274c1ab068d6b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $99e274c1ab068d6b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $99e274c1ab068d6b$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $99e274c1ab068d6b$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $gbdt3.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $gbdt3.nextTick($99e274c1ab068d6b$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $99e274c1ab068d6b$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $99e274c1ab068d6b$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $99e274c1ab068d6b$var$finishMaybe(stream, state);
    }
}
function $99e274c1ab068d6b$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $99e274c1ab068d6b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $99e274c1ab068d6b$var$ERR_MULTIPLE_CALLBACK();
    $99e274c1ab068d6b$var$onwriteStateUpdate(state);
    if (er) $99e274c1ab068d6b$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $99e274c1ab068d6b$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $99e274c1ab068d6b$var$clearBuffer(stream, state);
        if (sync) $gbdt3.nextTick($99e274c1ab068d6b$var$afterWrite, stream, state, finished, cb);
        else $99e274c1ab068d6b$var$afterWrite(stream, state, finished, cb);
    }
}
function $99e274c1ab068d6b$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $99e274c1ab068d6b$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $99e274c1ab068d6b$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $99e274c1ab068d6b$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $99e274c1ab068d6b$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $99e274c1ab068d6b$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $99e274c1ab068d6b$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $99e274c1ab068d6b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$99e274c1ab068d6b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $99e274c1ab068d6b$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$99e274c1ab068d6b$var$Writable.prototype._writev = null;
$99e274c1ab068d6b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $99e274c1ab068d6b$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($99e274c1ab068d6b$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $99e274c1ab068d6b$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $99e274c1ab068d6b$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $99e274c1ab068d6b$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $99e274c1ab068d6b$var$finishMaybe(stream, state);
    });
}
function $99e274c1ab068d6b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $gbdt3.nextTick($99e274c1ab068d6b$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $99e274c1ab068d6b$var$finishMaybe(stream, state) {
    var need = $99e274c1ab068d6b$var$needFinish(state);
    if (need) {
        $99e274c1ab068d6b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $99e274c1ab068d6b$var$endWritable(stream, state, cb) {
    state.ending = true;
    $99e274c1ab068d6b$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $gbdt3.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $99e274c1ab068d6b$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($99e274c1ab068d6b$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$99e274c1ab068d6b$var$Writable.prototype.destroy = $4onKy.destroy;
$99e274c1ab068d6b$var$Writable.prototype._undestroy = $4onKy.undestroy;
$99e274c1ab068d6b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("baRbS", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $8229e36b2c56f045$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $8229e36b2c56f045$var$deprecate(fn, msg) {
    if ($8229e36b2c56f045$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($8229e36b2c56f045$var$config("throwDeprecation")) throw new Error(msg);
            else if ($8229e36b2c56f045$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $8229e36b2c56f045$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("km3X2", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ed18ed59938b590f$export$63a7aa211a91ed69, (v) => $ed18ed59938b590f$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ed18ed59938b590f$export$63a7aa211a91ed69;
"use strict";

var $ZavwZ = parcelRequire("ZavwZ");
var $ed18ed59938b590f$require$Buffer = $ZavwZ.Buffer;
/*</replacement>*/ var $ed18ed59938b590f$var$isEncoding = $ed18ed59938b590f$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ed18ed59938b590f$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ed18ed59938b590f$var$normalizeEncoding(enc) {
    var nenc = $ed18ed59938b590f$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ed18ed59938b590f$require$Buffer.isEncoding === $ed18ed59938b590f$var$isEncoding || !$ed18ed59938b590f$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ed18ed59938b590f$export$63a7aa211a91ed69 = $ed18ed59938b590f$var$StringDecoder;
function $ed18ed59938b590f$var$StringDecoder(encoding) {
    this.encoding = $ed18ed59938b590f$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ed18ed59938b590f$var$utf16Text;
            this.end = $ed18ed59938b590f$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ed18ed59938b590f$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ed18ed59938b590f$var$base64Text;
            this.end = $ed18ed59938b590f$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ed18ed59938b590f$var$simpleWrite;
            this.end = $ed18ed59938b590f$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ed18ed59938b590f$require$Buffer.allocUnsafe(nb);
}
$ed18ed59938b590f$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ed18ed59938b590f$var$StringDecoder.prototype.end = $ed18ed59938b590f$var$utf8End;
// Returns only complete characters in a Buffer
$ed18ed59938b590f$var$StringDecoder.prototype.text = $ed18ed59938b590f$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ed18ed59938b590f$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ed18ed59938b590f$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ed18ed59938b590f$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ed18ed59938b590f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ed18ed59938b590f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ed18ed59938b590f$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ed18ed59938b590f$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ed18ed59938b590f$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ed18ed59938b590f$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ed18ed59938b590f$var$utf8Text(buf, i) {
    var total = $ed18ed59938b590f$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ed18ed59938b590f$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ed18ed59938b590f$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ed18ed59938b590f$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ed18ed59938b590f$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ed18ed59938b590f$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ed18ed59938b590f$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ed18ed59938b590f$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("kg24O", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
var $ebf6e9a6f18f067e$var$_Object$setPrototypeO;
function $ebf6e9a6f18f067e$var$_defineProperty(obj, key, value) {
    key = $ebf6e9a6f18f067e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ebf6e9a6f18f067e$var$_toPropertyKey(arg) {
    var key = $ebf6e9a6f18f067e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ebf6e9a6f18f067e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $irTo4 = parcelRequire("irTo4");
var $ebf6e9a6f18f067e$var$kLastResolve = Symbol("lastResolve");
var $ebf6e9a6f18f067e$var$kLastReject = Symbol("lastReject");
var $ebf6e9a6f18f067e$var$kError = Symbol("error");
var $ebf6e9a6f18f067e$var$kEnded = Symbol("ended");
var $ebf6e9a6f18f067e$var$kLastPromise = Symbol("lastPromise");
var $ebf6e9a6f18f067e$var$kHandlePromise = Symbol("handlePromise");
var $ebf6e9a6f18f067e$var$kStream = Symbol("stream");
function $ebf6e9a6f18f067e$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $ebf6e9a6f18f067e$var$readAndResolve(iter) {
    var resolve = iter[$ebf6e9a6f18f067e$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$ebf6e9a6f18f067e$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$ebf6e9a6f18f067e$var$kLastPromise] = null;
            iter[$ebf6e9a6f18f067e$var$kLastResolve] = null;
            iter[$ebf6e9a6f18f067e$var$kLastReject] = null;
            resolve($ebf6e9a6f18f067e$var$createIterResult(data, false));
        }
    }
}
function $ebf6e9a6f18f067e$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $gbdt3.nextTick($ebf6e9a6f18f067e$var$readAndResolve, iter);
}
function $ebf6e9a6f18f067e$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$ebf6e9a6f18f067e$var$kEnded]) {
                resolve($ebf6e9a6f18f067e$var$createIterResult(undefined, true));
                return;
            }
            iter[$ebf6e9a6f18f067e$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $ebf6e9a6f18f067e$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $ebf6e9a6f18f067e$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($ebf6e9a6f18f067e$var$_Object$setPrototypeO = {
    get stream () {
        return this[$ebf6e9a6f18f067e$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$ebf6e9a6f18f067e$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$ebf6e9a6f18f067e$var$kEnded]) return Promise.resolve($ebf6e9a6f18f067e$var$createIterResult(undefined, true));
        if (this[$ebf6e9a6f18f067e$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $gbdt3.nextTick(function() {
                if (_this[$ebf6e9a6f18f067e$var$kError]) reject(_this[$ebf6e9a6f18f067e$var$kError]);
                else resolve($ebf6e9a6f18f067e$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$ebf6e9a6f18f067e$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($ebf6e9a6f18f067e$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$ebf6e9a6f18f067e$var$kStream].read();
            if (data !== null) return Promise.resolve($ebf6e9a6f18f067e$var$createIterResult(data, false));
            promise = new Promise(this[$ebf6e9a6f18f067e$var$kHandlePromise]);
        }
        this[$ebf6e9a6f18f067e$var$kLastPromise] = promise;
        return promise;
    }
}, $ebf6e9a6f18f067e$var$_defineProperty($ebf6e9a6f18f067e$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $ebf6e9a6f18f067e$var$_defineProperty($ebf6e9a6f18f067e$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$ebf6e9a6f18f067e$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($ebf6e9a6f18f067e$var$createIterResult(undefined, true));
        });
    });
}), $ebf6e9a6f18f067e$var$_Object$setPrototypeO), $ebf6e9a6f18f067e$var$AsyncIteratorPrototype);
var $ebf6e9a6f18f067e$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($ebf6e9a6f18f067e$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kStream, {
        value: stream,
        writable: true
    }), $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kLastResolve, {
        value: null,
        writable: true
    }), $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kLastReject, {
        value: null,
        writable: true
    }), $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kError, {
        value: null,
        writable: true
    }), $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $ebf6e9a6f18f067e$var$_defineProperty(_Object$create, $ebf6e9a6f18f067e$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$ebf6e9a6f18f067e$var$kStream].read();
            if (data) {
                iterator[$ebf6e9a6f18f067e$var$kLastPromise] = null;
                iterator[$ebf6e9a6f18f067e$var$kLastResolve] = null;
                iterator[$ebf6e9a6f18f067e$var$kLastReject] = null;
                resolve($ebf6e9a6f18f067e$var$createIterResult(data, false));
            } else {
                iterator[$ebf6e9a6f18f067e$var$kLastResolve] = resolve;
                iterator[$ebf6e9a6f18f067e$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$ebf6e9a6f18f067e$var$kLastPromise] = null;
    $irTo4(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$ebf6e9a6f18f067e$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$ebf6e9a6f18f067e$var$kLastPromise] = null;
                iterator[$ebf6e9a6f18f067e$var$kLastResolve] = null;
                iterator[$ebf6e9a6f18f067e$var$kLastReject] = null;
                reject(err);
            }
            iterator[$ebf6e9a6f18f067e$var$kError] = err;
            return;
        }
        var resolve = iterator[$ebf6e9a6f18f067e$var$kLastResolve];
        if (resolve !== null) {
            iterator[$ebf6e9a6f18f067e$var$kLastPromise] = null;
            iterator[$ebf6e9a6f18f067e$var$kLastResolve] = null;
            iterator[$ebf6e9a6f18f067e$var$kLastReject] = null;
            resolve($ebf6e9a6f18f067e$var$createIterResult(undefined, true));
        }
        iterator[$ebf6e9a6f18f067e$var$kEnded] = true;
    });
    stream.on("readable", $ebf6e9a6f18f067e$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $ebf6e9a6f18f067e$var$createReadableStreamAsyncIterator;

});
parcelRegister("irTo4", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $d6e5b65b6c70e6db$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("hApZK")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $d6e5b65b6c70e6db$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d6e5b65b6c70e6db$var$noop() {}
function $d6e5b65b6c70e6db$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d6e5b65b6c70e6db$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d6e5b65b6c70e6db$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d6e5b65b6c70e6db$var$once(callback || $d6e5b65b6c70e6db$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d6e5b65b6c70e6db$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d6e5b65b6c70e6db$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d6e5b65b6c70e6db$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d6e5b65b6c70e6db$var$eos;

});


parcelRegister("87hj1", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("6mkFE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $4a14d4f38f3fc02b$var$Transform;

var $hApZK = parcelRequire("hApZK");
var $4a14d4f38f3fc02b$require$_require$codes = $hApZK.codes;
var $4a14d4f38f3fc02b$var$ERR_METHOD_NOT_IMPLEMENTED = $4a14d4f38f3fc02b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $4a14d4f38f3fc02b$var$ERR_MULTIPLE_CALLBACK = $4a14d4f38f3fc02b$require$_require$codes.ERR_MULTIPLE_CALLBACK, $4a14d4f38f3fc02b$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $4a14d4f38f3fc02b$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $4a14d4f38f3fc02b$var$ERR_TRANSFORM_WITH_LENGTH_0 = $4a14d4f38f3fc02b$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $kcOWY = parcelRequire("kcOWY");

(parcelRequire("lfl9G"))($4a14d4f38f3fc02b$var$Transform, $kcOWY);
function $4a14d4f38f3fc02b$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $4a14d4f38f3fc02b$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $4a14d4f38f3fc02b$var$Transform(options) {
    if (!(this instanceof $4a14d4f38f3fc02b$var$Transform)) return new $4a14d4f38f3fc02b$var$Transform(options);
    $kcOWY.call(this, options);
    this._transformState = {
        afterTransform: $4a14d4f38f3fc02b$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $4a14d4f38f3fc02b$var$prefinish);
}
function $4a14d4f38f3fc02b$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $4a14d4f38f3fc02b$var$done(_this, er, data);
    });
    else $4a14d4f38f3fc02b$var$done(this, null, null);
}
$4a14d4f38f3fc02b$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $kcOWY.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$4a14d4f38f3fc02b$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $4a14d4f38f3fc02b$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$4a14d4f38f3fc02b$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$4a14d4f38f3fc02b$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$4a14d4f38f3fc02b$var$Transform.prototype._destroy = function(err, cb) {
    $kcOWY.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $4a14d4f38f3fc02b$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $4a14d4f38f3fc02b$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $4a14d4f38f3fc02b$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G8nA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dcd2a4a6eb1e590$var$PassThrough;

var $6mkFE = parcelRequire("6mkFE");

(parcelRequire("lfl9G"))($4dcd2a4a6eb1e590$var$PassThrough, $6mkFE);
function $4dcd2a4a6eb1e590$var$PassThrough(options) {
    if (!(this instanceof $4dcd2a4a6eb1e590$var$PassThrough)) return new $4dcd2a4a6eb1e590$var$PassThrough(options);
    $6mkFE.call(this, options);
}
$4dcd2a4a6eb1e590$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("eHc2I", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $ab2e6c4d794e42d9$var$eos;
function $ab2e6c4d794e42d9$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $hApZK = parcelRequire("hApZK");
var $ab2e6c4d794e42d9$require$_require$codes = $hApZK.codes;
var $ab2e6c4d794e42d9$var$ERR_MISSING_ARGS = $ab2e6c4d794e42d9$require$_require$codes.ERR_MISSING_ARGS, $ab2e6c4d794e42d9$var$ERR_STREAM_DESTROYED = $ab2e6c4d794e42d9$require$_require$codes.ERR_STREAM_DESTROYED;
function $ab2e6c4d794e42d9$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ab2e6c4d794e42d9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $ab2e6c4d794e42d9$var$destroyer(stream, reading, writing, callback) {
    callback = $ab2e6c4d794e42d9$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($ab2e6c4d794e42d9$var$eos === undefined) $ab2e6c4d794e42d9$var$eos = (parcelRequire("irTo4"));
    $ab2e6c4d794e42d9$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ab2e6c4d794e42d9$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $ab2e6c4d794e42d9$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $ab2e6c4d794e42d9$var$call(fn) {
    fn();
}
function $ab2e6c4d794e42d9$var$pipe(from, to) {
    return from.pipe(to);
}
function $ab2e6c4d794e42d9$var$popCallback(streams) {
    if (!streams.length) return $ab2e6c4d794e42d9$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $ab2e6c4d794e42d9$var$noop;
    return streams.pop();
}
function $ab2e6c4d794e42d9$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ab2e6c4d794e42d9$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ab2e6c4d794e42d9$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ab2e6c4d794e42d9$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ab2e6c4d794e42d9$var$call);
            if (reading) return;
            destroys.forEach($ab2e6c4d794e42d9$var$call);
            callback(error);
        });
    });
    return streams.reduce($ab2e6c4d794e42d9$var$pipe);
}
module.exports = $ab2e6c4d794e42d9$var$pipeline;

});




parcelRegister("60Enq", function(module, exports) {
"use strict";

var $7ts9d = parcelRequire("7ts9d");
var $4602102bc24d53cb$require$Buffer = $7ts9d.Buffer;

var $lfl9G = parcelRequire("lfl9G");

var $gLBv8 = parcelRequire("gLBv8");
var $4602102bc24d53cb$var$ARRAY16 = new Array(16);
var $4602102bc24d53cb$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4602102bc24d53cb$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4602102bc24d53cb$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4602102bc24d53cb$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $4602102bc24d53cb$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $4602102bc24d53cb$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $4602102bc24d53cb$var$RIPEMD160() {
    $gLBv8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lfl9G($4602102bc24d53cb$var$RIPEMD160, $gLBv8);
$4602102bc24d53cb$var$RIPEMD160.prototype._update = function() {
    var words = $4602102bc24d53cb$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $4602102bc24d53cb$var$fn1(al, bl, cl, dl, el, words[$4602102bc24d53cb$var$zl[i]], $4602102bc24d53cb$var$hl[0], $4602102bc24d53cb$var$sl[i]);
            tr = $4602102bc24d53cb$var$fn5(ar, br, cr, dr, er, words[$4602102bc24d53cb$var$zr[i]], $4602102bc24d53cb$var$hr[0], $4602102bc24d53cb$var$sr[i]);
        } else if (i < 32) {
            tl = $4602102bc24d53cb$var$fn2(al, bl, cl, dl, el, words[$4602102bc24d53cb$var$zl[i]], $4602102bc24d53cb$var$hl[1], $4602102bc24d53cb$var$sl[i]);
            tr = $4602102bc24d53cb$var$fn4(ar, br, cr, dr, er, words[$4602102bc24d53cb$var$zr[i]], $4602102bc24d53cb$var$hr[1], $4602102bc24d53cb$var$sr[i]);
        } else if (i < 48) {
            tl = $4602102bc24d53cb$var$fn3(al, bl, cl, dl, el, words[$4602102bc24d53cb$var$zl[i]], $4602102bc24d53cb$var$hl[2], $4602102bc24d53cb$var$sl[i]);
            tr = $4602102bc24d53cb$var$fn3(ar, br, cr, dr, er, words[$4602102bc24d53cb$var$zr[i]], $4602102bc24d53cb$var$hr[2], $4602102bc24d53cb$var$sr[i]);
        } else if (i < 64) {
            tl = $4602102bc24d53cb$var$fn4(al, bl, cl, dl, el, words[$4602102bc24d53cb$var$zl[i]], $4602102bc24d53cb$var$hl[3], $4602102bc24d53cb$var$sl[i]);
            tr = $4602102bc24d53cb$var$fn2(ar, br, cr, dr, er, words[$4602102bc24d53cb$var$zr[i]], $4602102bc24d53cb$var$hr[3], $4602102bc24d53cb$var$sr[i]);
        } else {
            tl = $4602102bc24d53cb$var$fn5(al, bl, cl, dl, el, words[$4602102bc24d53cb$var$zl[i]], $4602102bc24d53cb$var$hl[4], $4602102bc24d53cb$var$sl[i]);
            tr = $4602102bc24d53cb$var$fn1(ar, br, cr, dr, er, words[$4602102bc24d53cb$var$zr[i]], $4602102bc24d53cb$var$hr[4], $4602102bc24d53cb$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $4602102bc24d53cb$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $4602102bc24d53cb$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$4602102bc24d53cb$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $4602102bc24d53cb$require$Buffer.alloc ? $4602102bc24d53cb$require$Buffer.alloc(20) : new $4602102bc24d53cb$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $4602102bc24d53cb$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $4602102bc24d53cb$var$fn1(a, b, c, d, e, m, k, s) {
    return $4602102bc24d53cb$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $4602102bc24d53cb$var$fn2(a, b, c, d, e, m, k, s) {
    return $4602102bc24d53cb$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $4602102bc24d53cb$var$fn3(a, b, c, d, e, m, k, s) {
    return $4602102bc24d53cb$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $4602102bc24d53cb$var$fn4(a, b, c, d, e, m, k, s) {
    return $4602102bc24d53cb$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $4602102bc24d53cb$var$fn5(a, b, c, d, e, m, k, s) {
    return $4602102bc24d53cb$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $4602102bc24d53cb$var$RIPEMD160;

});

parcelRegister("1cw1e", function(module, exports) {
var $0dffbfb480dbbd8b$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $0dffbfb480dbbd8b$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$0dffbfb480dbbd8b$var$exports.sha = (parcelRequire("7TaWU"));

$0dffbfb480dbbd8b$var$exports.sha1 = (parcelRequire("9uBgm"));

$0dffbfb480dbbd8b$var$exports.sha224 = (parcelRequire("hrvuU"));

$0dffbfb480dbbd8b$var$exports.sha256 = (parcelRequire("8nUl1"));

$0dffbfb480dbbd8b$var$exports.sha384 = (parcelRequire("cVNsj"));

$0dffbfb480dbbd8b$var$exports.sha512 = (parcelRequire("3h6tG"));

});
parcelRegister("7TaWU", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $lfl9G = parcelRequire("lfl9G");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $5be629b5ba3a62f1$require$Buffer = $ZavwZ.Buffer;
var $5be629b5ba3a62f1$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $5be629b5ba3a62f1$var$W = new Array(80);
function $5be629b5ba3a62f1$var$Sha() {
    this.init();
    this._w = $5be629b5ba3a62f1$var$W;
    $jj8aB.call(this, 64, 56);
}
$lfl9G($5be629b5ba3a62f1$var$Sha, $jj8aB);
$5be629b5ba3a62f1$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $5be629b5ba3a62f1$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $5be629b5ba3a62f1$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $5be629b5ba3a62f1$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$5be629b5ba3a62f1$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $5be629b5ba3a62f1$var$rotl5(a) + $5be629b5ba3a62f1$var$ft(s, b, c, d) + e + W[j] + $5be629b5ba3a62f1$var$K[s] | 0;
        e = d;
        d = c;
        c = $5be629b5ba3a62f1$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$5be629b5ba3a62f1$var$Sha.prototype._hash = function() {
    var H = $5be629b5ba3a62f1$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $5be629b5ba3a62f1$var$Sha;

});
parcelRegister("jj8aB", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $e0e6210a63e4e506$require$Buffer = $ZavwZ.Buffer;
// prototype class for hash functions
function $e0e6210a63e4e506$var$Hash(blockSize, finalSize) {
    this._block = $e0e6210a63e4e506$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e0e6210a63e4e506$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $e0e6210a63e4e506$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e0e6210a63e4e506$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e0e6210a63e4e506$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $e0e6210a63e4e506$var$Hash;

});


parcelRegister("9uBgm", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $lfl9G = parcelRequire("lfl9G");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $6e93d20395109244$require$Buffer = $ZavwZ.Buffer;
var $6e93d20395109244$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $6e93d20395109244$var$W = new Array(80);
function $6e93d20395109244$var$Sha1() {
    this.init();
    this._w = $6e93d20395109244$var$W;
    $jj8aB.call(this, 64, 56);
}
$lfl9G($6e93d20395109244$var$Sha1, $jj8aB);
$6e93d20395109244$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $6e93d20395109244$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $6e93d20395109244$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $6e93d20395109244$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $6e93d20395109244$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$6e93d20395109244$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $6e93d20395109244$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $6e93d20395109244$var$rotl5(a) + $6e93d20395109244$var$ft(s, b, c, d) + e + W[j] + $6e93d20395109244$var$K[s] | 0;
        e = d;
        d = c;
        c = $6e93d20395109244$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$6e93d20395109244$var$Sha1.prototype._hash = function() {
    var H = $6e93d20395109244$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $6e93d20395109244$var$Sha1;

});

parcelRegister("hrvuU", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lfl9G = parcelRequire("lfl9G");

var $8nUl1 = parcelRequire("8nUl1");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $cb2d640b2b2b05ae$require$Buffer = $ZavwZ.Buffer;
var $cb2d640b2b2b05ae$var$W = new Array(64);
function $cb2d640b2b2b05ae$var$Sha224() {
    this.init();
    this._w = $cb2d640b2b2b05ae$var$W // new Array(64)
    ;
    $jj8aB.call(this, 64, 56);
}
$lfl9G($cb2d640b2b2b05ae$var$Sha224, $8nUl1);
$cb2d640b2b2b05ae$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$cb2d640b2b2b05ae$var$Sha224.prototype._hash = function() {
    var H = $cb2d640b2b2b05ae$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $cb2d640b2b2b05ae$var$Sha224;

});
parcelRegister("8nUl1", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lfl9G = parcelRequire("lfl9G");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $61ac2c4237beb110$require$Buffer = $ZavwZ.Buffer;
var $61ac2c4237beb110$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $61ac2c4237beb110$var$W = new Array(64);
function $61ac2c4237beb110$var$Sha256() {
    this.init();
    this._w = $61ac2c4237beb110$var$W // new Array(64)
    ;
    $jj8aB.call(this, 64, 56);
}
$lfl9G($61ac2c4237beb110$var$Sha256, $jj8aB);
$61ac2c4237beb110$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $61ac2c4237beb110$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $61ac2c4237beb110$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $61ac2c4237beb110$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $61ac2c4237beb110$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $61ac2c4237beb110$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $61ac2c4237beb110$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$61ac2c4237beb110$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $61ac2c4237beb110$var$gamma1(W[i - 2]) + W[i - 7] + $61ac2c4237beb110$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $61ac2c4237beb110$var$sigma1(e) + $61ac2c4237beb110$var$ch(e, f, g) + $61ac2c4237beb110$var$K[j] + W[j] | 0;
        var T2 = $61ac2c4237beb110$var$sigma0(a) + $61ac2c4237beb110$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$61ac2c4237beb110$var$Sha256.prototype._hash = function() {
    var H = $61ac2c4237beb110$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $61ac2c4237beb110$var$Sha256;

});


parcelRegister("cVNsj", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $3h6tG = parcelRequire("3h6tG");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $96a12bc08f5c3c28$require$Buffer = $ZavwZ.Buffer;
var $96a12bc08f5c3c28$var$W = new Array(160);
function $96a12bc08f5c3c28$var$Sha384() {
    this.init();
    this._w = $96a12bc08f5c3c28$var$W;
    $jj8aB.call(this, 128, 112);
}
$lfl9G($96a12bc08f5c3c28$var$Sha384, $3h6tG);
$96a12bc08f5c3c28$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$96a12bc08f5c3c28$var$Sha384.prototype._hash = function() {
    var H = $96a12bc08f5c3c28$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $96a12bc08f5c3c28$var$Sha384;

});
parcelRegister("3h6tG", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $jj8aB = parcelRequire("jj8aB");

var $ZavwZ = parcelRequire("ZavwZ");
var $2627fbfef5d0389b$require$Buffer = $ZavwZ.Buffer;
var $2627fbfef5d0389b$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $2627fbfef5d0389b$var$W = new Array(160);
function $2627fbfef5d0389b$var$Sha512() {
    this.init();
    this._w = $2627fbfef5d0389b$var$W;
    $jj8aB.call(this, 128, 112);
}
$lfl9G($2627fbfef5d0389b$var$Sha512, $jj8aB);
$2627fbfef5d0389b$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $2627fbfef5d0389b$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2627fbfef5d0389b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2627fbfef5d0389b$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $2627fbfef5d0389b$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $2627fbfef5d0389b$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $2627fbfef5d0389b$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $2627fbfef5d0389b$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $2627fbfef5d0389b$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $2627fbfef5d0389b$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$2627fbfef5d0389b$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $2627fbfef5d0389b$var$Gamma0(xh, xl);
        var gamma0l = $2627fbfef5d0389b$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $2627fbfef5d0389b$var$Gamma1(xh, xl);
        var gamma1l = $2627fbfef5d0389b$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $2627fbfef5d0389b$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $2627fbfef5d0389b$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $2627fbfef5d0389b$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $2627fbfef5d0389b$var$maj(ah, bh, ch);
        var majl = $2627fbfef5d0389b$var$maj(al, bl, cl);
        var sigma0h = $2627fbfef5d0389b$var$sigma0(ah, al);
        var sigma0l = $2627fbfef5d0389b$var$sigma0(al, ah);
        var sigma1h = $2627fbfef5d0389b$var$sigma1(eh, el);
        var sigma1l = $2627fbfef5d0389b$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $2627fbfef5d0389b$var$K[j];
        var Kil = $2627fbfef5d0389b$var$K[j + 1];
        var chh = $2627fbfef5d0389b$var$Ch(eh, fh, gh);
        var chl = $2627fbfef5d0389b$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $2627fbfef5d0389b$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $2627fbfef5d0389b$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $2627fbfef5d0389b$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $2627fbfef5d0389b$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $2627fbfef5d0389b$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $2627fbfef5d0389b$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $2627fbfef5d0389b$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $2627fbfef5d0389b$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $2627fbfef5d0389b$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $2627fbfef5d0389b$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $2627fbfef5d0389b$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $2627fbfef5d0389b$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $2627fbfef5d0389b$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $2627fbfef5d0389b$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $2627fbfef5d0389b$var$getCarry(this._hl, hl) | 0;
};
$2627fbfef5d0389b$var$Sha512.prototype._hash = function() {
    var H = $2627fbfef5d0389b$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $2627fbfef5d0389b$var$Sha512;

});



parcelRegister("f2cqU", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $af20afdf21316440$require$Buffer = $ZavwZ.Buffer;

var $esseK = parcelRequire("esseK");
var $af20afdf21316440$require$Transform = $esseK.Transform;

var $km3X2 = parcelRequire("km3X2");
var $af20afdf21316440$require$StringDecoder = $km3X2.StringDecoder;

var $lfl9G = parcelRequire("lfl9G");
function $af20afdf21316440$var$CipherBase(hashMode) {
    $af20afdf21316440$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lfl9G($af20afdf21316440$var$CipherBase, $af20afdf21316440$require$Transform);
$af20afdf21316440$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $af20afdf21316440$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$af20afdf21316440$var$CipherBase.prototype.setAutoPadding = function() {};
$af20afdf21316440$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$af20afdf21316440$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$af20afdf21316440$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$af20afdf21316440$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$af20afdf21316440$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$af20afdf21316440$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $af20afdf21316440$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$af20afdf21316440$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $af20afdf21316440$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $af20afdf21316440$var$CipherBase;

});
parcelRegister("esseK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $a869957271d19df2$var$Stream;

var $ej6Nm = parcelRequire("ej6Nm");
var $a869957271d19df2$require$EE = $ej6Nm.EventEmitter;

var $lfl9G = parcelRequire("lfl9G");
$lfl9G($a869957271d19df2$var$Stream, $a869957271d19df2$require$EE);

$a869957271d19df2$var$Stream.Readable = (parcelRequire("7ARQa"));

$a869957271d19df2$var$Stream.Writable = (parcelRequire("dd7GY"));

$a869957271d19df2$var$Stream.Duplex = (parcelRequire("kcOWY"));

$a869957271d19df2$var$Stream.Transform = (parcelRequire("6mkFE"));

$a869957271d19df2$var$Stream.PassThrough = (parcelRequire("6G8nA"));

$a869957271d19df2$var$Stream.finished = (parcelRequire("irTo4"));

$a869957271d19df2$var$Stream.pipeline = (parcelRequire("eHc2I"));
// Backwards-compat with node 0.4.x
$a869957271d19df2$var$Stream.Stream = $a869957271d19df2$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $a869957271d19df2$var$Stream() {
    $a869957271d19df2$require$EE.call(this);
}
$a869957271d19df2$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a869957271d19df2$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("igtGq", function(module, exports) {
"use strict";

var $lfl9G = parcelRequire("lfl9G");

var $9bXpc = parcelRequire("9bXpc");

var $f2cqU = parcelRequire("f2cqU");

var $ZavwZ = parcelRequire("ZavwZ");
var $d4c0bf1406b06c43$require$Buffer = $ZavwZ.Buffer;

var $jC27b = parcelRequire("jC27b");

var $60Enq = parcelRequire("60Enq");

var $1cw1e = parcelRequire("1cw1e");
var $d4c0bf1406b06c43$var$ZEROS = $d4c0bf1406b06c43$require$Buffer.alloc(128);
function $d4c0bf1406b06c43$var$Hmac(alg, key) {
    $f2cqU.call(this, "digest");
    if (typeof key === "string") key = $d4c0bf1406b06c43$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $60Enq() : $1cw1e(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $d4c0bf1406b06c43$require$Buffer.concat([
        key,
        $d4c0bf1406b06c43$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $d4c0bf1406b06c43$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $d4c0bf1406b06c43$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $60Enq() : $1cw1e(alg);
    this._hash.update(ipad);
}
$lfl9G($d4c0bf1406b06c43$var$Hmac, $f2cqU);
$d4c0bf1406b06c43$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$d4c0bf1406b06c43$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $60Enq() : $1cw1e(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $d4c0bf1406b06c43$var$Hmac("rmd160", key);
    if (alg === "md5") return new $9bXpc($jC27b, key);
    return new $d4c0bf1406b06c43$var$Hmac(alg, key);
};

});
parcelRegister("9bXpc", function(module, exports) {
"use strict";

var $lfl9G = parcelRequire("lfl9G");

var $ZavwZ = parcelRequire("ZavwZ");
var $6b1338d0e857d0a2$require$Buffer = $ZavwZ.Buffer;

var $f2cqU = parcelRequire("f2cqU");
var $6b1338d0e857d0a2$var$ZEROS = $6b1338d0e857d0a2$require$Buffer.alloc(128);
var $6b1338d0e857d0a2$var$blocksize = 64;
function $6b1338d0e857d0a2$var$Hmac(alg, key) {
    $f2cqU.call(this, "digest");
    if (typeof key === "string") key = $6b1338d0e857d0a2$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $6b1338d0e857d0a2$var$blocksize) key = alg(key);
    else if (key.length < $6b1338d0e857d0a2$var$blocksize) key = $6b1338d0e857d0a2$require$Buffer.concat([
        key,
        $6b1338d0e857d0a2$var$ZEROS
    ], $6b1338d0e857d0a2$var$blocksize);
    var ipad = this._ipad = $6b1338d0e857d0a2$require$Buffer.allocUnsafe($6b1338d0e857d0a2$var$blocksize);
    var opad = this._opad = $6b1338d0e857d0a2$require$Buffer.allocUnsafe($6b1338d0e857d0a2$var$blocksize);
    for(var i = 0; i < $6b1338d0e857d0a2$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lfl9G($6b1338d0e857d0a2$var$Hmac, $f2cqU);
$6b1338d0e857d0a2$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$6b1338d0e857d0a2$var$Hmac.prototype._final = function() {
    var h = this._alg($6b1338d0e857d0a2$require$Buffer.concat(this._hash));
    return this._alg($6b1338d0e857d0a2$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $6b1338d0e857d0a2$var$Hmac;

});

parcelRegister("jC27b", function(module, exports) {

var $k7S11 = parcelRequire("k7S11");
module.exports = function(buffer) {
    return new $k7S11().update(buffer).digest();
};

});


parcelRegister("ePMUh", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("jnps3", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $e1b3e86c03e64b4d$require$Buffer = $ZavwZ.Buffer;

var $hiypy = parcelRequire("hiypy");

var $7uZmJ = parcelRequire("7uZmJ");

var $4iSka = parcelRequire("4iSka");

var $irkAR = parcelRequire("irkAR");
var $e1b3e86c03e64b4d$var$ZERO_BUF;
var $e1b3e86c03e64b4d$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $e1b3e86c03e64b4d$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $e1b3e86c03e64b4d$var$checks = [];
function $e1b3e86c03e64b4d$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$e1b3e86c03e64b4d$var$subtle || !$e1b3e86c03e64b4d$var$subtle.importKey || !$e1b3e86c03e64b4d$var$subtle.deriveBits) return Promise.resolve(false);
    if ($e1b3e86c03e64b4d$var$checks[algo] !== undefined) return $e1b3e86c03e64b4d$var$checks[algo];
    $e1b3e86c03e64b4d$var$ZERO_BUF = $e1b3e86c03e64b4d$var$ZERO_BUF || $e1b3e86c03e64b4d$require$Buffer.alloc(8);
    var prom = $e1b3e86c03e64b4d$var$browserPbkdf2($e1b3e86c03e64b4d$var$ZERO_BUF, $e1b3e86c03e64b4d$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $e1b3e86c03e64b4d$var$checks[algo] = prom;
    return prom;
}
var $e1b3e86c03e64b4d$var$nextTick;
function $e1b3e86c03e64b4d$var$getNextTick() {
    if ($e1b3e86c03e64b4d$var$nextTick) return $e1b3e86c03e64b4d$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $e1b3e86c03e64b4d$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $e1b3e86c03e64b4d$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $e1b3e86c03e64b4d$var$nextTick = $parcel$global.setImmediate;
    else $e1b3e86c03e64b4d$var$nextTick = $parcel$global.setTimeout;
    return $e1b3e86c03e64b4d$var$nextTick;
}
function $e1b3e86c03e64b4d$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $e1b3e86c03e64b4d$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $e1b3e86c03e64b4d$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $e1b3e86c03e64b4d$require$Buffer.from(res);
    });
}
function $e1b3e86c03e64b4d$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $e1b3e86c03e64b4d$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $e1b3e86c03e64b4d$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $e1b3e86c03e64b4d$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $e1b3e86c03e64b4d$var$getNextTick()(function() {
            var out;
            try {
                out = $4iSka(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $hiypy(iterations, keylen);
    password = $irkAR(password, $7uZmJ, "Password");
    salt = $irkAR(salt, $7uZmJ, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $e1b3e86c03e64b4d$var$resolvePromise($e1b3e86c03e64b4d$var$checkNative(algo).then(function(resp) {
        if (resp) return $e1b3e86c03e64b4d$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $4iSka(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("hiypy", function(module, exports) {
var $c97ecf78736fa07c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $c97ecf78736fa07c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("7uZmJ", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
var $575aefaebae88164$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $575aefaebae88164$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $575aefaebae88164$var$pVersionMajor = parseInt($gbdt3.version.split(".")[0].slice(1), 10);
    $575aefaebae88164$var$defaultEncoding = $575aefaebae88164$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $575aefaebae88164$var$defaultEncoding = "utf-8";
module.exports = $575aefaebae88164$var$defaultEncoding;

});

parcelRegister("4iSka", function(module, exports) {

var $jC27b = parcelRequire("jC27b");

var $60Enq = parcelRequire("60Enq");

var $1cw1e = parcelRequire("1cw1e");

var $ZavwZ = parcelRequire("ZavwZ");
var $3222fb83a39c02f0$require$Buffer = $ZavwZ.Buffer;

var $hiypy = parcelRequire("hiypy");

var $7uZmJ = parcelRequire("7uZmJ");

var $irkAR = parcelRequire("irkAR");
var $3222fb83a39c02f0$var$ZEROS = $3222fb83a39c02f0$require$Buffer.alloc(128);
var $3222fb83a39c02f0$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $3222fb83a39c02f0$var$Hmac(alg, key, saltLen) {
    var hash = $3222fb83a39c02f0$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $3222fb83a39c02f0$require$Buffer.concat([
        key,
        $3222fb83a39c02f0$var$ZEROS
    ], blocksize);
    var ipad = $3222fb83a39c02f0$require$Buffer.allocUnsafe(blocksize + $3222fb83a39c02f0$var$sizes[alg]);
    var opad = $3222fb83a39c02f0$require$Buffer.allocUnsafe(blocksize + $3222fb83a39c02f0$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $3222fb83a39c02f0$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $3222fb83a39c02f0$var$sizes[alg];
}
$3222fb83a39c02f0$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $3222fb83a39c02f0$var$getDigest(alg) {
    function shaFunc(data) {
        return $1cw1e(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $60Enq().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $jC27b;
    return shaFunc;
}
function $3222fb83a39c02f0$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $hiypy(iterations, keylen);
    password = $irkAR(password, $7uZmJ, "Password");
    salt = $irkAR(salt, $7uZmJ, "Salt");
    digest = digest || "sha1";
    var hmac = new $3222fb83a39c02f0$var$Hmac(digest, password, salt.length);
    var DK = $3222fb83a39c02f0$require$Buffer.allocUnsafe(keylen);
    var block1 = $3222fb83a39c02f0$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $3222fb83a39c02f0$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $3222fb83a39c02f0$var$pbkdf2;

});
parcelRegister("irkAR", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $d6cab90a3f379f0b$require$Buffer = $ZavwZ.Buffer;
module.exports = function(thing, encoding, name) {
    if ($d6cab90a3f379f0b$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $d6cab90a3f379f0b$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $d6cab90a3f379f0b$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("6SEVy", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $5027888670d2c7cf$export$cfaef8ed399428b0, (v) => $5027888670d2c7cf$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $5027888670d2c7cf$export$a80c7deaea7cbd80, (v) => $5027888670d2c7cf$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $5027888670d2c7cf$export$ed7577ae6e1cd0ef, (v) => $5027888670d2c7cf$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $5027888670d2c7cf$export$5dcbef3aa594f567, (v) => $5027888670d2c7cf$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $5027888670d2c7cf$export$5bc8001ca71ed9c5, (v) => $5027888670d2c7cf$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $5027888670d2c7cf$export$3e714e2c5d5d8cb2, (v) => $5027888670d2c7cf$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $5027888670d2c7cf$export$94c3e544fd062b7f, (v) => $5027888670d2c7cf$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $5027888670d2c7cf$export$9f77e0932fb78f72, (v) => $5027888670d2c7cf$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $5027888670d2c7cf$export$d865ce2836f5927f, (v) => $5027888670d2c7cf$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $5027888670d2c7cf$export$95e62ad65da8b7d2, (v) => $5027888670d2c7cf$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $5027888670d2c7cf$export$209139ff098c441a, (v) => $5027888670d2c7cf$export$209139ff098c441a = v);
var $5027888670d2c7cf$export$cfaef8ed399428b0;
var $5027888670d2c7cf$export$a80c7deaea7cbd80;
var $5027888670d2c7cf$export$ed7577ae6e1cd0ef;
var $5027888670d2c7cf$export$5dcbef3aa594f567;
var $5027888670d2c7cf$export$5bc8001ca71ed9c5;
var $5027888670d2c7cf$export$3e714e2c5d5d8cb2;
var $5027888670d2c7cf$export$94c3e544fd062b7f;
var $5027888670d2c7cf$export$9f77e0932fb78f72;
var $5027888670d2c7cf$export$d865ce2836f5927f;
var $5027888670d2c7cf$export$95e62ad65da8b7d2;
var $5027888670d2c7cf$export$209139ff098c441a;
"use strict";
$5027888670d2c7cf$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$5027888670d2c7cf$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$5027888670d2c7cf$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$5027888670d2c7cf$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$5027888670d2c7cf$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$5027888670d2c7cf$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $5027888670d2c7cf$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$5027888670d2c7cf$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $5027888670d2c7cf$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $5027888670d2c7cf$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $5027888670d2c7cf$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $5027888670d2c7cf$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$5027888670d2c7cf$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $5027888670d2c7cf$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$5027888670d2c7cf$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $5027888670d2c7cf$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $5027888670d2c7cf$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $5027888670d2c7cf$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$5027888670d2c7cf$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $5027888670d2c7cf$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $5027888670d2c7cf$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$5027888670d2c7cf$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("1tVy1", function(module, exports) {
"use strict";

var $kAZVs = parcelRequire("kAZVs");
function $114523aa4f5119dc$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $114523aa4f5119dc$var$Cipher;
$114523aa4f5119dc$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$114523aa4f5119dc$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$114523aa4f5119dc$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$114523aa4f5119dc$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$114523aa4f5119dc$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$114523aa4f5119dc$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$114523aa4f5119dc$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$114523aa4f5119dc$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$114523aa4f5119dc$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$114523aa4f5119dc$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$114523aa4f5119dc$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $kAZVs.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("1Ee2k", function(module, exports) {
"use strict";

var $kAZVs = parcelRequire("kAZVs");

var $lfl9G = parcelRequire("lfl9G");

var $6SEVy = parcelRequire("6SEVy");

var $1tVy1 = parcelRequire("1tVy1");
function $13346a3a3ddf500d$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $13346a3a3ddf500d$var$DES(options) {
    $1tVy1.call(this, options);
    var state = new $13346a3a3ddf500d$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lfl9G($13346a3a3ddf500d$var$DES, $1tVy1);
module.exports = $13346a3a3ddf500d$var$DES;
$13346a3a3ddf500d$var$DES.create = function create(options) {
    return new $13346a3a3ddf500d$var$DES(options);
};
var $13346a3a3ddf500d$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$13346a3a3ddf500d$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $kAZVs.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $6SEVy.readUInt32BE(key, 0);
    var kR = $6SEVy.readUInt32BE(key, 4);
    $6SEVy.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $13346a3a3ddf500d$var$shiftTable[i >>> 1];
        kL = $6SEVy.r28shl(kL, shift);
        kR = $6SEVy.r28shl(kR, shift);
        $6SEVy.pc2(kL, kR, state.keys, i);
    }
};
$13346a3a3ddf500d$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $6SEVy.readUInt32BE(inp, inOff);
    var r = $6SEVy.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $6SEVy.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $6SEVy.writeUInt32BE(out, l, outOff);
    $6SEVy.writeUInt32BE(out, r, outOff + 4);
};
$13346a3a3ddf500d$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$13346a3a3ddf500d$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$kAZVs.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$13346a3a3ddf500d$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $6SEVy.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $6SEVy.substitute(keyL, keyR);
        var f = $6SEVy.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $6SEVy.rip(r, l, out, off);
};
$13346a3a3ddf500d$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $6SEVy.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $6SEVy.substitute(keyL, keyR);
        var f = $6SEVy.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $6SEVy.rip(l, r, out, off);
};

});

parcelRegister("6s3Uk", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $4b286387716f55a4$export$f9bb8d20ccc7477a, (v) => $4b286387716f55a4$export$f9bb8d20ccc7477a = v);
var $4b286387716f55a4$export$f9bb8d20ccc7477a;
"use strict";

var $kAZVs = parcelRequire("kAZVs");

var $lfl9G = parcelRequire("lfl9G");
var $4b286387716f55a4$var$proto = {};
function $4b286387716f55a4$var$CBCState(iv) {
    $kAZVs.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $4b286387716f55a4$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lfl9G(CBC, Base);
    var keys = Object.keys($4b286387716f55a4$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $4b286387716f55a4$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$4b286387716f55a4$export$f9bb8d20ccc7477a = $4b286387716f55a4$var$instantiate;
$4b286387716f55a4$var$proto._cbcInit = function _cbcInit() {
    var state = new $4b286387716f55a4$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$4b286387716f55a4$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("lKBFy", function(module, exports) {
"use strict";

var $kAZVs = parcelRequire("kAZVs");

var $lfl9G = parcelRequire("lfl9G");

var $1tVy1 = parcelRequire("1tVy1");

var $1Ee2k = parcelRequire("1Ee2k");
function $fd5b1d26da17e956$var$EDEState(type, key) {
    $kAZVs.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $1Ee2k.create({
            type: "encrypt",
            key: k1
        }),
        $1Ee2k.create({
            type: "decrypt",
            key: k2
        }),
        $1Ee2k.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $1Ee2k.create({
            type: "decrypt",
            key: k3
        }),
        $1Ee2k.create({
            type: "encrypt",
            key: k2
        }),
        $1Ee2k.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $fd5b1d26da17e956$var$EDE(options) {
    $1tVy1.call(this, options);
    var state = new $fd5b1d26da17e956$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lfl9G($fd5b1d26da17e956$var$EDE, $1tVy1);
module.exports = $fd5b1d26da17e956$var$EDE;
$fd5b1d26da17e956$var$EDE.create = function create(options) {
    return new $fd5b1d26da17e956$var$EDE(options);
};
$fd5b1d26da17e956$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$fd5b1d26da17e956$var$EDE.prototype._pad = $1Ee2k.prototype._pad;
$fd5b1d26da17e956$var$EDE.prototype._unpad = $1Ee2k.prototype._unpad;

});

parcelRegister("qWsjv", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $050fc5e6bf675e67$export$5b0f6292f11d1d18, (v) => $050fc5e6bf675e67$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $050fc5e6bf675e67$export$e85a0c9a1067c5d3, (v) => $050fc5e6bf675e67$export$e85a0c9a1067c5d3 = v);
var $050fc5e6bf675e67$export$5b0f6292f11d1d18;
var $050fc5e6bf675e67$export$e85a0c9a1067c5d3;
$050fc5e6bf675e67$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$050fc5e6bf675e67$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("6haVV", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $491ccfb65ae84d16$export$5b0f6292f11d1d18, (v) => $491ccfb65ae84d16$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $491ccfb65ae84d16$export$e85a0c9a1067c5d3, (v) => $491ccfb65ae84d16$export$e85a0c9a1067c5d3 = v);
var $491ccfb65ae84d16$export$5b0f6292f11d1d18;
var $491ccfb65ae84d16$export$e85a0c9a1067c5d3;

var $95Vzl = parcelRequire("95Vzl");
$491ccfb65ae84d16$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $95Vzl(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$491ccfb65ae84d16$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $95Vzl(out, pad);
};

});
parcelRegister("95Vzl", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $69f13cb102563e70$require$Buffer = $7ts9d.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $69f13cb102563e70$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("35ZKd", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2411bbe3b9fc5789$export$5b0f6292f11d1d18, (v) => $2411bbe3b9fc5789$export$5b0f6292f11d1d18 = v);
var $2411bbe3b9fc5789$export$5b0f6292f11d1d18;

var $ZavwZ = parcelRequire("ZavwZ");
var $2411bbe3b9fc5789$require$Buffer = $ZavwZ.Buffer;

var $95Vzl = parcelRequire("95Vzl");
function $2411bbe3b9fc5789$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $95Vzl(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $2411bbe3b9fc5789$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$2411bbe3b9fc5789$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $2411bbe3b9fc5789$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $2411bbe3b9fc5789$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $2411bbe3b9fc5789$require$Buffer.concat([
                out,
                $2411bbe3b9fc5789$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $2411bbe3b9fc5789$require$Buffer.concat([
                out,
                $2411bbe3b9fc5789$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("dmScv", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $9bb75f932957573f$export$5b0f6292f11d1d18, (v) => $9bb75f932957573f$export$5b0f6292f11d1d18 = v);
var $9bb75f932957573f$export$5b0f6292f11d1d18;

var $ZavwZ = parcelRequire("ZavwZ");
var $9bb75f932957573f$require$Buffer = $ZavwZ.Buffer;
function $9bb75f932957573f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $9bb75f932957573f$require$Buffer.concat([
        self._prev.slice(1),
        $9bb75f932957573f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$9bb75f932957573f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $9bb75f932957573f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $9bb75f932957573f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("eVlef", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $add6db2ca208162e$export$5b0f6292f11d1d18, (v) => $add6db2ca208162e$export$5b0f6292f11d1d18 = v);
var $add6db2ca208162e$export$5b0f6292f11d1d18;

var $ZavwZ = parcelRequire("ZavwZ");
var $add6db2ca208162e$require$Buffer = $ZavwZ.Buffer;
function $add6db2ca208162e$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $add6db2ca208162e$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $add6db2ca208162e$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $add6db2ca208162e$require$Buffer.allocUnsafe(buffer.length);
    buffer = $add6db2ca208162e$require$Buffer.concat([
        buffer,
        $add6db2ca208162e$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$add6db2ca208162e$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $add6db2ca208162e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $add6db2ca208162e$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("eXcun", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $ae30436629789ed7$export$5b0f6292f11d1d18, (v) => $ae30436629789ed7$export$5b0f6292f11d1d18 = v);
var $ae30436629789ed7$export$5b0f6292f11d1d18;

var $7ts9d = parcelRequire("7ts9d");
var $ae30436629789ed7$require$Buffer = $7ts9d.Buffer;

var $95Vzl = parcelRequire("95Vzl");
function $ae30436629789ed7$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$ae30436629789ed7$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $ae30436629789ed7$require$Buffer.concat([
        self._cache,
        $ae30436629789ed7$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $95Vzl(chunk, pad);
};

});

parcelRegister("f08h4", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $aebd4639863fc7c6$export$5b0f6292f11d1d18, (v) => $aebd4639863fc7c6$export$5b0f6292f11d1d18 = v);
var $aebd4639863fc7c6$export$5b0f6292f11d1d18;

var $95Vzl = parcelRequire("95Vzl");

var $ZavwZ = parcelRequire("ZavwZ");
var $aebd4639863fc7c6$require$Buffer = $ZavwZ.Buffer;

var $ic08R = parcelRequire("ic08R");
function $aebd4639863fc7c6$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $ic08R(self._prev);
    return out;
}
var $aebd4639863fc7c6$var$blockSize = 16;
$aebd4639863fc7c6$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $aebd4639863fc7c6$var$blockSize);
    var start = self._cache.length;
    self._cache = $aebd4639863fc7c6$require$Buffer.concat([
        self._cache,
        $aebd4639863fc7c6$require$Buffer.allocUnsafe(chunkNum * $aebd4639863fc7c6$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $aebd4639863fc7c6$var$getBlock(self);
        var offset = start + i * $aebd4639863fc7c6$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $95Vzl(chunk, pad);
};

});
parcelRegister("ic08R", function(module, exports) {
function $d3e9752e5e01f627$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $d3e9752e5e01f627$var$incr32;

});


parcelRegister("7rVdb", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4Lrhy", function(module, exports) {
var $3780b6dd9a8600b1$var$r;
module.exports = function rand(len) {
    if (!$3780b6dd9a8600b1$var$r) $3780b6dd9a8600b1$var$r = new $3780b6dd9a8600b1$var$Rand(null);
    return $3780b6dd9a8600b1$var$r.generate(len);
};
function $3780b6dd9a8600b1$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $3780b6dd9a8600b1$var$Rand;
$3780b6dd9a8600b1$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$3780b6dd9a8600b1$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $3780b6dd9a8600b1$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $3780b6dd9a8600b1$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $3780b6dd9a8600b1$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $3780b6dd9a8600b1$var$crypto = (parcelRequire("ejAqS"));
    if (typeof $3780b6dd9a8600b1$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $3780b6dd9a8600b1$var$Rand.prototype._rand = function _rand(n) {
        return $3780b6dd9a8600b1$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("2r1bn", function(module, exports) {

exports = module.exports = (parcelRequire("jlngS"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("c5fmw"));

exports.Duplex = (parcelRequire("9NNKm"));

exports.Transform = (parcelRequire("4CVv9"));

exports.PassThrough = (parcelRequire("bLieI"));

});
parcelRegister("jlngS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";

var $zbGAD = parcelRequire("zbGAD");
/*</replacement>*/ module.exports = $e15207a6554b3c97$var$Readable;

var $8rXpD = parcelRequire("8rXpD");
/*</replacement>*/ /*<replacement>*/ var $e15207a6554b3c97$var$Duplex;
/*</replacement>*/ $e15207a6554b3c97$var$Readable.ReadableState = $e15207a6554b3c97$var$ReadableState;

var $ej6Nm = parcelRequire("ej6Nm");
var $e15207a6554b3c97$require$EE = $ej6Nm.EventEmitter;
var $e15207a6554b3c97$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $843hV = parcelRequire("843hV");

var $3wUNb = parcelRequire("3wUNb");
var $e15207a6554b3c97$require$Buffer = $3wUNb.Buffer;
var $e15207a6554b3c97$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $e15207a6554b3c97$var$_uint8ArrayToBuffer(chunk) {
    return $e15207a6554b3c97$require$Buffer.from(chunk);
}
function $e15207a6554b3c97$var$_isUint8Array(obj) {
    return $e15207a6554b3c97$require$Buffer.isBuffer(obj) || obj instanceof $e15207a6554b3c97$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $e15207a6554b3c97$var$util = Object.create((parcelRequire("dRbAs")));

$e15207a6554b3c97$var$util.inherits = (parcelRequire("lfl9G"));

var $ejAqS = parcelRequire("ejAqS");
var $e15207a6554b3c97$var$debug = void 0;
if ($ejAqS && $ejAqS.debuglog) $e15207a6554b3c97$var$debug = $ejAqS.debuglog("stream");
else $e15207a6554b3c97$var$debug = function() {};

var $4KhOM = parcelRequire("4KhOM");

var $b7gD8 = parcelRequire("b7gD8");
var $e15207a6554b3c97$var$StringDecoder;
$e15207a6554b3c97$var$util.inherits($e15207a6554b3c97$var$Readable, $843hV);
var $e15207a6554b3c97$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $e15207a6554b3c97$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($8rXpD(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $e15207a6554b3c97$var$ReadableState(options, stream) {
    $e15207a6554b3c97$var$Duplex = $e15207a6554b3c97$var$Duplex || (parcelRequire("9NNKm"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $e15207a6554b3c97$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $4KhOM();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$e15207a6554b3c97$var$StringDecoder) $e15207a6554b3c97$var$StringDecoder = (parcelRequire("8NdWd")).StringDecoder;
        this.decoder = new $e15207a6554b3c97$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $e15207a6554b3c97$var$Readable(options) {
    $e15207a6554b3c97$var$Duplex = $e15207a6554b3c97$var$Duplex || (parcelRequire("9NNKm"));
    if (!(this instanceof $e15207a6554b3c97$var$Readable)) return new $e15207a6554b3c97$var$Readable(options);
    this._readableState = new $e15207a6554b3c97$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $843hV.call(this);
}
Object.defineProperty($e15207a6554b3c97$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$e15207a6554b3c97$var$Readable.prototype.destroy = $b7gD8.destroy;
$e15207a6554b3c97$var$Readable.prototype._undestroy = $b7gD8.undestroy;
$e15207a6554b3c97$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$e15207a6554b3c97$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $e15207a6554b3c97$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $e15207a6554b3c97$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$e15207a6554b3c97$var$Readable.prototype.unshift = function(chunk) {
    return $e15207a6554b3c97$var$readableAddChunk(this, chunk, null, true, false);
};
function $e15207a6554b3c97$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $e15207a6554b3c97$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $e15207a6554b3c97$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $e15207a6554b3c97$require$Buffer.prototype) chunk = $e15207a6554b3c97$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $e15207a6554b3c97$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $e15207a6554b3c97$var$addChunk(stream, state, chunk, false);
                    else $e15207a6554b3c97$var$maybeReadMore(stream, state);
                } else $e15207a6554b3c97$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $e15207a6554b3c97$var$needMoreData(state);
}
function $e15207a6554b3c97$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $e15207a6554b3c97$var$emitReadable(stream);
    }
    $e15207a6554b3c97$var$maybeReadMore(stream, state);
}
function $e15207a6554b3c97$var$chunkInvalid(state, chunk) {
    var er;
    if (!$e15207a6554b3c97$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $e15207a6554b3c97$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$e15207a6554b3c97$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$e15207a6554b3c97$var$Readable.prototype.setEncoding = function(enc) {
    if (!$e15207a6554b3c97$var$StringDecoder) $e15207a6554b3c97$var$StringDecoder = (parcelRequire("8NdWd")).StringDecoder;
    this._readableState.decoder = new $e15207a6554b3c97$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $e15207a6554b3c97$var$MAX_HWM = 0x800000;
function $e15207a6554b3c97$var$computeNewHighWaterMark(n) {
    if (n >= $e15207a6554b3c97$var$MAX_HWM) n = $e15207a6554b3c97$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e15207a6554b3c97$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $e15207a6554b3c97$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$e15207a6554b3c97$var$Readable.prototype.read = function(n) {
    $e15207a6554b3c97$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $e15207a6554b3c97$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $e15207a6554b3c97$var$endReadable(this);
        else $e15207a6554b3c97$var$emitReadable(this);
        return null;
    }
    n = $e15207a6554b3c97$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $e15207a6554b3c97$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $e15207a6554b3c97$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $e15207a6554b3c97$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $e15207a6554b3c97$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $e15207a6554b3c97$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $e15207a6554b3c97$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $e15207a6554b3c97$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $e15207a6554b3c97$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $e15207a6554b3c97$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $e15207a6554b3c97$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $e15207a6554b3c97$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $e15207a6554b3c97$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $zbGAD.nextTick($e15207a6554b3c97$var$emitReadable_, stream);
        else $e15207a6554b3c97$var$emitReadable_(stream);
    }
}
function $e15207a6554b3c97$var$emitReadable_(stream) {
    $e15207a6554b3c97$var$debug("emit readable");
    stream.emit("readable");
    $e15207a6554b3c97$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $e15207a6554b3c97$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $zbGAD.nextTick($e15207a6554b3c97$var$maybeReadMore_, stream, state);
    }
}
function $e15207a6554b3c97$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $e15207a6554b3c97$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$e15207a6554b3c97$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$e15207a6554b3c97$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $e15207a6554b3c97$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $gbdt3.stdout && dest !== $gbdt3.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $zbGAD.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $e15207a6554b3c97$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $e15207a6554b3c97$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $e15207a6554b3c97$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $e15207a6554b3c97$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $e15207a6554b3c97$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $e15207a6554b3c97$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $e15207a6554b3c97$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $e15207a6554b3c97$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($e15207a6554b3c97$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $e15207a6554b3c97$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $e15207a6554b3c97$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $e15207a6554b3c97$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $e15207a6554b3c97$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $e15207a6554b3c97$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $e15207a6554b3c97$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $e15207a6554b3c97$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $e15207a6554b3c97$var$flow(src);
        }
    };
}
$e15207a6554b3c97$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $e15207a6554b3c97$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$e15207a6554b3c97$var$Readable.prototype.on = function(ev, fn) {
    var res = $843hV.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $zbGAD.nextTick($e15207a6554b3c97$var$nReadingNextTick, this);
            else if (state.length) $e15207a6554b3c97$var$emitReadable(this);
        }
    }
    return res;
};
$e15207a6554b3c97$var$Readable.prototype.addListener = $e15207a6554b3c97$var$Readable.prototype.on;
function $e15207a6554b3c97$var$nReadingNextTick(self1) {
    $e15207a6554b3c97$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$e15207a6554b3c97$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $e15207a6554b3c97$var$debug("resume");
        state.flowing = true;
        $e15207a6554b3c97$var$resume(this, state);
    }
    return this;
};
function $e15207a6554b3c97$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $zbGAD.nextTick($e15207a6554b3c97$var$resume_, stream, state);
    }
}
function $e15207a6554b3c97$var$resume_(stream, state) {
    if (!state.reading) {
        $e15207a6554b3c97$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $e15207a6554b3c97$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$e15207a6554b3c97$var$Readable.prototype.pause = function() {
    $e15207a6554b3c97$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $e15207a6554b3c97$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $e15207a6554b3c97$var$flow(stream) {
    var state = stream._readableState;
    $e15207a6554b3c97$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$e15207a6554b3c97$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $e15207a6554b3c97$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $e15207a6554b3c97$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $e15207a6554b3c97$var$kProxyEvents.length; n++)stream.on($e15207a6554b3c97$var$kProxyEvents[n], this.emit.bind(this, $e15207a6554b3c97$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $e15207a6554b3c97$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($e15207a6554b3c97$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$e15207a6554b3c97$var$Readable._fromList = $e15207a6554b3c97$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e15207a6554b3c97$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $e15207a6554b3c97$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e15207a6554b3c97$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $e15207a6554b3c97$var$copyFromBufferString(n, list) : $e15207a6554b3c97$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e15207a6554b3c97$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e15207a6554b3c97$var$copyFromBuffer(n, list) {
    var ret = $e15207a6554b3c97$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $e15207a6554b3c97$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $zbGAD.nextTick($e15207a6554b3c97$var$endReadableNT, state, stream);
    }
}
function $e15207a6554b3c97$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $e15207a6554b3c97$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("zbGAD", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
if (typeof $gbdt3 === "undefined" || !$gbdt3.version || $gbdt3.version.indexOf("v0.") === 0 || $gbdt3.version.indexOf("v1.") === 0 && $gbdt3.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: $069c5594f078d63b$var$nextTick
};
else module.exports = $gbdt3;
function $069c5594f078d63b$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $gbdt3.nextTick(fn);
        case 2:
            return $gbdt3.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $gbdt3.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $gbdt3.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $gbdt3.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("8rXpD", function(module, exports) {
var $626eee67e362c901$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $626eee67e362c901$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("843hV", function(module, exports) {

module.exports = (parcelRequire("ej6Nm")).EventEmitter;

});

parcelRegister("3wUNb", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $7ts9d = parcelRequire("7ts9d");
var $29206a026507214b$var$Buffer = $7ts9d.Buffer;
// alternative to using Object.keys for old browsers
function $29206a026507214b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($29206a026507214b$var$Buffer.from && $29206a026507214b$var$Buffer.alloc && $29206a026507214b$var$Buffer.allocUnsafe && $29206a026507214b$var$Buffer.allocUnsafeSlow) module.exports = $7ts9d;
else {
    // Copy properties from require('buffer')
    $29206a026507214b$var$copyProps($7ts9d, module.exports);
    module.exports.Buffer = $29206a026507214b$var$SafeBuffer;
}
function $29206a026507214b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $29206a026507214b$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$29206a026507214b$var$copyProps($29206a026507214b$var$Buffer, $29206a026507214b$var$SafeBuffer);
$29206a026507214b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $29206a026507214b$var$Buffer(arg, encodingOrOffset, length);
};
$29206a026507214b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $29206a026507214b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$29206a026507214b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $29206a026507214b$var$Buffer(size);
};
$29206a026507214b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $7ts9d.SlowBuffer(size);
};

});

parcelRegister("dRbAs", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $a1693685cf4fd831$export$43bee75e5e14138e, (v) => $a1693685cf4fd831$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $a1693685cf4fd831$export$f9ce7b637dfbe238, (v) => $a1693685cf4fd831$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $a1693685cf4fd831$export$630801d484da15df, (v) => $a1693685cf4fd831$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $a1693685cf4fd831$export$bedb7023a7733221, (v) => $a1693685cf4fd831$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $a1693685cf4fd831$export$7e4aa119212bc614, (v) => $a1693685cf4fd831$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $a1693685cf4fd831$export$844ec244b1367d54, (v) => $a1693685cf4fd831$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $a1693685cf4fd831$export$a244864fd9645c7f, (v) => $a1693685cf4fd831$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $a1693685cf4fd831$export$fce6876652108ab, (v) => $a1693685cf4fd831$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $a1693685cf4fd831$export$49841c62b9eff15, (v) => $a1693685cf4fd831$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $a1693685cf4fd831$export$a6cdc56e425d0d0a, (v) => $a1693685cf4fd831$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $a1693685cf4fd831$export$871608497c498473, (v) => $a1693685cf4fd831$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $a1693685cf4fd831$export$e6127cc7fe7395c3, (v) => $a1693685cf4fd831$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $a1693685cf4fd831$export$f6e2535fb5126e54, (v) => $a1693685cf4fd831$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $a1693685cf4fd831$export$c3825b437cbdea5c, (v) => $a1693685cf4fd831$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $a1693685cf4fd831$export$a7884ebc965f8f54, (v) => $a1693685cf4fd831$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $a1693685cf4fd831$export$43bee75e5e14138e;
var $a1693685cf4fd831$export$f9ce7b637dfbe238;
var $a1693685cf4fd831$export$630801d484da15df;
var $a1693685cf4fd831$export$bedb7023a7733221;
var $a1693685cf4fd831$export$7e4aa119212bc614;
var $a1693685cf4fd831$export$844ec244b1367d54;
var $a1693685cf4fd831$export$a244864fd9645c7f;
var $a1693685cf4fd831$export$fce6876652108ab;
var $a1693685cf4fd831$export$49841c62b9eff15;
var $a1693685cf4fd831$export$a6cdc56e425d0d0a;
var $a1693685cf4fd831$export$871608497c498473;
var $a1693685cf4fd831$export$e6127cc7fe7395c3;
var $a1693685cf4fd831$export$f6e2535fb5126e54;
var $a1693685cf4fd831$export$c3825b437cbdea5c;
var $a1693685cf4fd831$export$a7884ebc965f8f54;
function $a1693685cf4fd831$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $a1693685cf4fd831$var$objectToString(arg) === "[object Array]";
}
$a1693685cf4fd831$export$43bee75e5e14138e = $a1693685cf4fd831$var$isArray;
function $a1693685cf4fd831$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$a1693685cf4fd831$export$f9ce7b637dfbe238 = $a1693685cf4fd831$var$isBoolean;
function $a1693685cf4fd831$var$isNull(arg) {
    return arg === null;
}
$a1693685cf4fd831$export$630801d484da15df = $a1693685cf4fd831$var$isNull;
function $a1693685cf4fd831$var$isNullOrUndefined(arg) {
    return arg == null;
}
$a1693685cf4fd831$export$bedb7023a7733221 = $a1693685cf4fd831$var$isNullOrUndefined;
function $a1693685cf4fd831$var$isNumber(arg) {
    return typeof arg === "number";
}
$a1693685cf4fd831$export$7e4aa119212bc614 = $a1693685cf4fd831$var$isNumber;
function $a1693685cf4fd831$var$isString(arg) {
    return typeof arg === "string";
}
$a1693685cf4fd831$export$844ec244b1367d54 = $a1693685cf4fd831$var$isString;
function $a1693685cf4fd831$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$a1693685cf4fd831$export$a244864fd9645c7f = $a1693685cf4fd831$var$isSymbol;
function $a1693685cf4fd831$var$isUndefined(arg) {
    return arg === void 0;
}
$a1693685cf4fd831$export$fce6876652108ab = $a1693685cf4fd831$var$isUndefined;
function $a1693685cf4fd831$var$isRegExp(re) {
    return $a1693685cf4fd831$var$objectToString(re) === "[object RegExp]";
}
$a1693685cf4fd831$export$49841c62b9eff15 = $a1693685cf4fd831$var$isRegExp;
function $a1693685cf4fd831$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$a1693685cf4fd831$export$a6cdc56e425d0d0a = $a1693685cf4fd831$var$isObject;
function $a1693685cf4fd831$var$isDate(d) {
    return $a1693685cf4fd831$var$objectToString(d) === "[object Date]";
}
$a1693685cf4fd831$export$871608497c498473 = $a1693685cf4fd831$var$isDate;
function $a1693685cf4fd831$var$isError(e) {
    return $a1693685cf4fd831$var$objectToString(e) === "[object Error]" || e instanceof Error;
}
$a1693685cf4fd831$export$e6127cc7fe7395c3 = $a1693685cf4fd831$var$isError;
function $a1693685cf4fd831$var$isFunction(arg) {
    return typeof arg === "function";
}
$a1693685cf4fd831$export$f6e2535fb5126e54 = $a1693685cf4fd831$var$isFunction;
function $a1693685cf4fd831$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$a1693685cf4fd831$export$c3825b437cbdea5c = $a1693685cf4fd831$var$isPrimitive;

$a1693685cf4fd831$export$a7884ebc965f8f54 = (parcelRequire("7ts9d")).Buffer.isBuffer;
function $a1693685cf4fd831$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("4KhOM", function(module, exports) {
"use strict";
function $37494794f4f7d18b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $3wUNb = parcelRequire("3wUNb");
var $37494794f4f7d18b$require$Buffer = $3wUNb.Buffer;

var $ejAqS = parcelRequire("ejAqS");
function $37494794f4f7d18b$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $37494794f4f7d18b$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $37494794f4f7d18b$require$Buffer.alloc(0);
        var ret = $37494794f4f7d18b$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $37494794f4f7d18b$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($ejAqS && $ejAqS.inspect && $ejAqS.inspect.custom) module.exports.prototype[$ejAqS.inspect.custom] = function() {
    var obj = $ejAqS.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("b7gD8", function(module, exports) {
"use strict";

var $zbGAD = parcelRequire("zbGAD");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $817d3f8fafa10802$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $zbGAD.nextTick($817d3f8fafa10802$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $zbGAD.nextTick($817d3f8fafa10802$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $zbGAD.nextTick($817d3f8fafa10802$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $zbGAD.nextTick($817d3f8fafa10802$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $817d3f8fafa10802$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $817d3f8fafa10802$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $817d3f8fafa10802$var$destroy,
    undestroy: $817d3f8fafa10802$var$undestroy
};

});

parcelRegister("9NNKm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $zbGAD = parcelRequire("zbGAD");
/*</replacement>*/ /*<replacement>*/ var $722f47568a199107$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $722f47568a199107$var$Duplex;

/*<replacement>*/ var $722f47568a199107$var$util = Object.create((parcelRequire("dRbAs")));

$722f47568a199107$var$util.inherits = (parcelRequire("lfl9G"));

var $jlngS = parcelRequire("jlngS");

var $c5fmw = parcelRequire("c5fmw");
$722f47568a199107$var$util.inherits($722f47568a199107$var$Duplex, $jlngS);
// avoid scope creep, the keys array can then be collected
var $722f47568a199107$var$keys = $722f47568a199107$var$objectKeys($c5fmw.prototype);
for(var $722f47568a199107$var$v = 0; $722f47568a199107$var$v < $722f47568a199107$var$keys.length; $722f47568a199107$var$v++){
    var $722f47568a199107$var$method = $722f47568a199107$var$keys[$722f47568a199107$var$v];
    if (!$722f47568a199107$var$Duplex.prototype[$722f47568a199107$var$method]) $722f47568a199107$var$Duplex.prototype[$722f47568a199107$var$method] = $c5fmw.prototype[$722f47568a199107$var$method];
}
function $722f47568a199107$var$Duplex(options) {
    if (!(this instanceof $722f47568a199107$var$Duplex)) return new $722f47568a199107$var$Duplex(options);
    $jlngS.call(this, options);
    $c5fmw.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $722f47568a199107$var$onend);
}
Object.defineProperty($722f47568a199107$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $722f47568a199107$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $zbGAD.nextTick($722f47568a199107$var$onEndNT, this);
}
function $722f47568a199107$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($722f47568a199107$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$722f47568a199107$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $zbGAD.nextTick(cb, err);
};

});
parcelRegister("c5fmw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $zbGAD = parcelRequire("zbGAD");
/*</replacement>*/ module.exports = $8cc1de4fd7dae931$var$Writable;
/* <replacement> */ function $8cc1de4fd7dae931$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8cc1de4fd7dae931$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8cc1de4fd7dae931$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8cc1de4fd7dae931$var$asyncWrite = (0, $zbGAD.nextTick);
/*</replacement>*/ /*<replacement>*/ var $8cc1de4fd7dae931$var$Duplex;
/*</replacement>*/ $8cc1de4fd7dae931$var$Writable.WritableState = $8cc1de4fd7dae931$var$WritableState;

/*<replacement>*/ var $8cc1de4fd7dae931$var$util = Object.create((parcelRequire("dRbAs")));

$8cc1de4fd7dae931$var$util.inherits = (parcelRequire("lfl9G"));

/*</replacement>*/ /*<replacement>*/ var $8cc1de4fd7dae931$var$internalUtil = {
    deprecate: (parcelRequire("baRbS"))
};

var $843hV = parcelRequire("843hV");

var $3wUNb = parcelRequire("3wUNb");
var $8cc1de4fd7dae931$require$Buffer = $3wUNb.Buffer;
var $8cc1de4fd7dae931$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $8cc1de4fd7dae931$var$_uint8ArrayToBuffer(chunk) {
    return $8cc1de4fd7dae931$require$Buffer.from(chunk);
}
function $8cc1de4fd7dae931$var$_isUint8Array(obj) {
    return $8cc1de4fd7dae931$require$Buffer.isBuffer(obj) || obj instanceof $8cc1de4fd7dae931$var$OurUint8Array;
}

var $b7gD8 = parcelRequire("b7gD8");
$8cc1de4fd7dae931$var$util.inherits($8cc1de4fd7dae931$var$Writable, $843hV);
function $8cc1de4fd7dae931$var$nop() {}

function $8cc1de4fd7dae931$var$WritableState(options, stream) {
    $8cc1de4fd7dae931$var$Duplex = $8cc1de4fd7dae931$var$Duplex || (parcelRequire("9NNKm"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $8cc1de4fd7dae931$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8cc1de4fd7dae931$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8cc1de4fd7dae931$var$CorkedRequest(this);
}
$8cc1de4fd7dae931$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8cc1de4fd7dae931$var$WritableState.prototype, "buffer", {
            get: $8cc1de4fd7dae931$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8cc1de4fd7dae931$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8cc1de4fd7dae931$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8cc1de4fd7dae931$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($8cc1de4fd7dae931$var$realHasInstance.call(this, object)) return true;
            if (this !== $8cc1de4fd7dae931$var$Writable) return false;
            return object && object._writableState instanceof $8cc1de4fd7dae931$var$WritableState;
        }
    });
} else $8cc1de4fd7dae931$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $8cc1de4fd7dae931$var$Writable(options) {
    $8cc1de4fd7dae931$var$Duplex = $8cc1de4fd7dae931$var$Duplex || (parcelRequire("9NNKm"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$8cc1de4fd7dae931$var$realHasInstance.call($8cc1de4fd7dae931$var$Writable, this) && !(this instanceof $8cc1de4fd7dae931$var$Duplex)) return new $8cc1de4fd7dae931$var$Writable(options);
    this._writableState = new $8cc1de4fd7dae931$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $843hV.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8cc1de4fd7dae931$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $8cc1de4fd7dae931$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $zbGAD.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8cc1de4fd7dae931$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $zbGAD.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$8cc1de4fd7dae931$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8cc1de4fd7dae931$var$_isUint8Array(chunk);
    if (isBuf && !$8cc1de4fd7dae931$require$Buffer.isBuffer(chunk)) chunk = $8cc1de4fd7dae931$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8cc1de4fd7dae931$var$nop;
    if (state.ended) $8cc1de4fd7dae931$var$writeAfterEnd(this, cb);
    else if (isBuf || $8cc1de4fd7dae931$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8cc1de4fd7dae931$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8cc1de4fd7dae931$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$8cc1de4fd7dae931$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc1de4fd7dae931$var$clearBuffer(this, state);
    }
};
$8cc1de4fd7dae931$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $8cc1de4fd7dae931$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8cc1de4fd7dae931$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8cc1de4fd7dae931$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8cc1de4fd7dae931$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8cc1de4fd7dae931$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8cc1de4fd7dae931$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8cc1de4fd7dae931$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8cc1de4fd7dae931$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $zbGAD.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $zbGAD.nextTick($8cc1de4fd7dae931$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $8cc1de4fd7dae931$var$finishMaybe(stream, state);
    }
}
function $8cc1de4fd7dae931$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8cc1de4fd7dae931$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $8cc1de4fd7dae931$var$onwriteStateUpdate(state);
    if (er) $8cc1de4fd7dae931$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8cc1de4fd7dae931$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc1de4fd7dae931$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $8cc1de4fd7dae931$var$asyncWrite($8cc1de4fd7dae931$var$afterWrite, stream, state, finished, cb);
        else $8cc1de4fd7dae931$var$afterWrite(stream, state, finished, cb);
    }
}
function $8cc1de4fd7dae931$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8cc1de4fd7dae931$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8cc1de4fd7dae931$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8cc1de4fd7dae931$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $8cc1de4fd7dae931$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8cc1de4fd7dae931$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8cc1de4fd7dae931$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8cc1de4fd7dae931$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8cc1de4fd7dae931$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$8cc1de4fd7dae931$var$Writable.prototype._writev = null;
$8cc1de4fd7dae931$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8cc1de4fd7dae931$var$endWritable(this, state, cb);
};
function $8cc1de4fd7dae931$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8cc1de4fd7dae931$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8cc1de4fd7dae931$var$finishMaybe(stream, state);
    });
}
function $8cc1de4fd7dae931$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $zbGAD.nextTick($8cc1de4fd7dae931$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8cc1de4fd7dae931$var$finishMaybe(stream, state) {
    var need = $8cc1de4fd7dae931$var$needFinish(state);
    if (need) {
        $8cc1de4fd7dae931$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $8cc1de4fd7dae931$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8cc1de4fd7dae931$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $zbGAD.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8cc1de4fd7dae931$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8cc1de4fd7dae931$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8cc1de4fd7dae931$var$Writable.prototype.destroy = $b7gD8.destroy;
$8cc1de4fd7dae931$var$Writable.prototype._undestroy = $b7gD8.undestroy;
$8cc1de4fd7dae931$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("8NdWd", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $666db61da3280638$export$63a7aa211a91ed69, (v) => $666db61da3280638$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $666db61da3280638$export$63a7aa211a91ed69;
"use strict";

var $c95G0 = parcelRequire("c95G0");
var $666db61da3280638$require$Buffer = $c95G0.Buffer;
/*</replacement>*/ var $666db61da3280638$var$isEncoding = $666db61da3280638$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $666db61da3280638$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $666db61da3280638$var$normalizeEncoding(enc) {
    var nenc = $666db61da3280638$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($666db61da3280638$require$Buffer.isEncoding === $666db61da3280638$var$isEncoding || !$666db61da3280638$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$666db61da3280638$export$63a7aa211a91ed69 = $666db61da3280638$var$StringDecoder;
function $666db61da3280638$var$StringDecoder(encoding) {
    this.encoding = $666db61da3280638$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $666db61da3280638$var$utf16Text;
            this.end = $666db61da3280638$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $666db61da3280638$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $666db61da3280638$var$base64Text;
            this.end = $666db61da3280638$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $666db61da3280638$var$simpleWrite;
            this.end = $666db61da3280638$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $666db61da3280638$require$Buffer.allocUnsafe(nb);
}
$666db61da3280638$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$666db61da3280638$var$StringDecoder.prototype.end = $666db61da3280638$var$utf8End;
// Returns only complete characters in a Buffer
$666db61da3280638$var$StringDecoder.prototype.text = $666db61da3280638$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$666db61da3280638$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $666db61da3280638$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $666db61da3280638$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $666db61da3280638$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $666db61da3280638$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $666db61da3280638$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $666db61da3280638$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $666db61da3280638$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $666db61da3280638$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $666db61da3280638$var$utf8Text(buf, i) {
    var total = $666db61da3280638$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $666db61da3280638$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $666db61da3280638$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $666db61da3280638$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $666db61da3280638$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $666db61da3280638$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $666db61da3280638$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $666db61da3280638$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("c95G0", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $7ts9d = parcelRequire("7ts9d");
var $8d7aba87e6c669ce$var$Buffer = $7ts9d.Buffer;
// alternative to using Object.keys for old browsers
function $8d7aba87e6c669ce$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($8d7aba87e6c669ce$var$Buffer.from && $8d7aba87e6c669ce$var$Buffer.alloc && $8d7aba87e6c669ce$var$Buffer.allocUnsafe && $8d7aba87e6c669ce$var$Buffer.allocUnsafeSlow) module.exports = $7ts9d;
else {
    // Copy properties from require('buffer')
    $8d7aba87e6c669ce$var$copyProps($7ts9d, module.exports);
    module.exports.Buffer = $8d7aba87e6c669ce$var$SafeBuffer;
}
function $8d7aba87e6c669ce$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $8d7aba87e6c669ce$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$8d7aba87e6c669ce$var$copyProps($8d7aba87e6c669ce$var$Buffer, $8d7aba87e6c669ce$var$SafeBuffer);
$8d7aba87e6c669ce$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $8d7aba87e6c669ce$var$Buffer(arg, encodingOrOffset, length);
};
$8d7aba87e6c669ce$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $8d7aba87e6c669ce$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$8d7aba87e6c669ce$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $8d7aba87e6c669ce$var$Buffer(size);
};
$8d7aba87e6c669ce$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $7ts9d.SlowBuffer(size);
};

});



parcelRegister("4CVv9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $35e750a0d3296181$var$Transform;

var $9NNKm = parcelRequire("9NNKm");

/*<replacement>*/ var $35e750a0d3296181$var$util = Object.create((parcelRequire("dRbAs")));

$35e750a0d3296181$var$util.inherits = (parcelRequire("lfl9G"));
/*</replacement>*/ $35e750a0d3296181$var$util.inherits($35e750a0d3296181$var$Transform, $9NNKm);
function $35e750a0d3296181$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $35e750a0d3296181$var$Transform(options) {
    if (!(this instanceof $35e750a0d3296181$var$Transform)) return new $35e750a0d3296181$var$Transform(options);
    $9NNKm.call(this, options);
    this._transformState = {
        afterTransform: $35e750a0d3296181$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $35e750a0d3296181$var$prefinish);
}
function $35e750a0d3296181$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $35e750a0d3296181$var$done(_this, er, data);
    });
    else $35e750a0d3296181$var$done(this, null, null);
}
$35e750a0d3296181$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9NNKm.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$35e750a0d3296181$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$35e750a0d3296181$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$35e750a0d3296181$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$35e750a0d3296181$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $9NNKm.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $35e750a0d3296181$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("bLieI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $89023adafd8683a0$var$PassThrough;

var $4CVv9 = parcelRequire("4CVv9");

/*<replacement>*/ var $89023adafd8683a0$var$util = Object.create((parcelRequire("dRbAs")));

$89023adafd8683a0$var$util.inherits = (parcelRequire("lfl9G"));
/*</replacement>*/ $89023adafd8683a0$var$util.inherits($89023adafd8683a0$var$PassThrough, $4CVv9);
function $89023adafd8683a0$var$PassThrough(options) {
    if (!(this instanceof $89023adafd8683a0$var$PassThrough)) return new $89023adafd8683a0$var$PassThrough(options);
    $4CVv9.call(this, options);
}
$89023adafd8683a0$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("8NHEw", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4PoEe", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("7Xmwk", function(module, exports) {
"use strict";
var $5caf832eb9bf3a43$var$utils = module.exports;

var $7rVdb = parcelRequire("7rVdb");

var $kAZVs = parcelRequire("kAZVs");

var $3bsl0 = parcelRequire("3bsl0");
$5caf832eb9bf3a43$var$utils.assert = $kAZVs;
$5caf832eb9bf3a43$var$utils.toArray = $3bsl0.toArray;
$5caf832eb9bf3a43$var$utils.zero2 = $3bsl0.zero2;
$5caf832eb9bf3a43$var$utils.toHex = $3bsl0.toHex;
$5caf832eb9bf3a43$var$utils.encode = $3bsl0.encode;
// Represent num in a w-NAF form
function $5caf832eb9bf3a43$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$5caf832eb9bf3a43$var$utils.getNAF = $5caf832eb9bf3a43$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $5caf832eb9bf3a43$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$5caf832eb9bf3a43$var$utils.getJSF = $5caf832eb9bf3a43$var$getJSF;
function $5caf832eb9bf3a43$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$5caf832eb9bf3a43$var$utils.cachedProperty = $5caf832eb9bf3a43$var$cachedProperty;
function $5caf832eb9bf3a43$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $5caf832eb9bf3a43$var$utils.toArray(bytes, "hex") : bytes;
}
$5caf832eb9bf3a43$var$utils.parseBytes = $5caf832eb9bf3a43$var$parseBytes;
function $5caf832eb9bf3a43$var$intFromLE(bytes) {
    return new $7rVdb(bytes, "hex", "le");
}
$5caf832eb9bf3a43$var$utils.intFromLE = $5caf832eb9bf3a43$var$intFromLE;

});
parcelRegister("3bsl0", function(module, exports) {
"use strict";
var $2518617f51451923$var$utils = module.exports;
function $2518617f51451923$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$2518617f51451923$var$utils.toArray = $2518617f51451923$var$toArray;
function $2518617f51451923$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$2518617f51451923$var$utils.zero2 = $2518617f51451923$var$zero2;
function $2518617f51451923$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $2518617f51451923$var$zero2(msg[i].toString(16));
    return res;
}
$2518617f51451923$var$utils.toHex = $2518617f51451923$var$toHex;
$2518617f51451923$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $2518617f51451923$var$toHex(arr);
    else return arr;
};

});


parcelRegister("1J9Vk", function(module, exports) {
"use strict";
var $1421b11049ca57c0$var$curve = module.exports;

$1421b11049ca57c0$var$curve.base = (parcelRequire("hrzcF"));

$1421b11049ca57c0$var$curve.short = (parcelRequire("jpzNS"));

$1421b11049ca57c0$var$curve.mont = (parcelRequire("kalge"));

$1421b11049ca57c0$var$curve.edwards = (parcelRequire("j4v8G"));

});
parcelRegister("hrzcF", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $7Xmwk = parcelRequire("7Xmwk");
var $cb3043eec0fcbcf0$var$getNAF = $7Xmwk.getNAF;
var $cb3043eec0fcbcf0$var$getJSF = $7Xmwk.getJSF;
var $cb3043eec0fcbcf0$var$assert = $7Xmwk.assert;
function $cb3043eec0fcbcf0$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7rVdb(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7rVdb.red(conf.prime) : $7rVdb.mont(this.p);
    // Useful for many curves
    this.zero = new $7rVdb(0).toRed(this.red);
    this.one = new $7rVdb(1).toRed(this.red);
    this.two = new $7rVdb(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7rVdb(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $cb3043eec0fcbcf0$var$BaseCurve;
$cb3043eec0fcbcf0$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$cb3043eec0fcbcf0$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$cb3043eec0fcbcf0$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $cb3043eec0fcbcf0$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $cb3043eec0fcbcf0$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$cb3043eec0fcbcf0$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $cb3043eec0fcbcf0$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $cb3043eec0fcbcf0$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$cb3043eec0fcbcf0$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $cb3043eec0fcbcf0$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $cb3043eec0fcbcf0$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $cb3043eec0fcbcf0$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $cb3043eec0fcbcf0$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$cb3043eec0fcbcf0$var$BaseCurve.BasePoint = $cb3043eec0fcbcf0$var$BasePoint;
$cb3043eec0fcbcf0$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$cb3043eec0fcbcf0$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$cb3043eec0fcbcf0$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $7Xmwk.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $cb3043eec0fcbcf0$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $cb3043eec0fcbcf0$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$cb3043eec0fcbcf0$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$cb3043eec0fcbcf0$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$cb3043eec0fcbcf0$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $7Xmwk.encode(this._encode(compact), enc);
};
$cb3043eec0fcbcf0$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$cb3043eec0fcbcf0$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$cb3043eec0fcbcf0$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$cb3043eec0fcbcf0$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$cb3043eec0fcbcf0$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$cb3043eec0fcbcf0$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("jpzNS", function(module, exports) {
"use strict";

var $7Xmwk = parcelRequire("7Xmwk");

var $7rVdb = parcelRequire("7rVdb");

var $lfl9G = parcelRequire("lfl9G");

var $hrzcF = parcelRequire("hrzcF");
var $e21c1ff4340c2591$var$assert = $7Xmwk.assert;
function $e21c1ff4340c2591$var$ShortCurve(conf) {
    $hrzcF.call(this, "short", conf);
    this.a = new $7rVdb(conf.a, 16).toRed(this.red);
    this.b = new $7rVdb(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lfl9G($e21c1ff4340c2591$var$ShortCurve, $hrzcF);
module.exports = $e21c1ff4340c2591$var$ShortCurve;
$e21c1ff4340c2591$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7rVdb(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7rVdb(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $e21c1ff4340c2591$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7rVdb(vec.a, 16),
            b: new $7rVdb(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$e21c1ff4340c2591$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7rVdb.mont(num);
    var tinv = new $7rVdb(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7rVdb(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$e21c1ff4340c2591$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7rVdb(1);
    var y1 = new $7rVdb(0);
    var x2 = new $7rVdb(0);
    var y2 = new $7rVdb(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$e21c1ff4340c2591$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$e21c1ff4340c2591$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7rVdb(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$e21c1ff4340c2591$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$e21c1ff4340c2591$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $e21c1ff4340c2591$var$Point(curve, x, y, isRed) {
    $hrzcF.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7rVdb(x, 16);
        this.y = new $7rVdb(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lfl9G($e21c1ff4340c2591$var$Point, $hrzcF.BasePoint);
$e21c1ff4340c2591$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $e21c1ff4340c2591$var$Point(this, x, y, isRed);
};
$e21c1ff4340c2591$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $e21c1ff4340c2591$var$Point.fromJSON(this, obj, red);
};
$e21c1ff4340c2591$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$e21c1ff4340c2591$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$e21c1ff4340c2591$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$e21c1ff4340c2591$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$e21c1ff4340c2591$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$e21c1ff4340c2591$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$e21c1ff4340c2591$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$e21c1ff4340c2591$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$e21c1ff4340c2591$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$e21c1ff4340c2591$var$Point.prototype.mul = function mul(k) {
    k = new $7rVdb(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$e21c1ff4340c2591$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$e21c1ff4340c2591$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$e21c1ff4340c2591$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$e21c1ff4340c2591$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$e21c1ff4340c2591$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $e21c1ff4340c2591$var$JPoint(curve, x, y, z) {
    $hrzcF.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7rVdb(0);
    } else {
        this.x = new $7rVdb(x, 16);
        this.y = new $7rVdb(y, 16);
        this.z = new $7rVdb(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lfl9G($e21c1ff4340c2591$var$JPoint, $hrzcF.BasePoint);
$e21c1ff4340c2591$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $e21c1ff4340c2591$var$JPoint(this, x, y, z);
};
$e21c1ff4340c2591$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$e21c1ff4340c2591$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$e21c1ff4340c2591$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$e21c1ff4340c2591$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$e21c1ff4340c2591$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$e21c1ff4340c2591$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7rVdb(k, kbase);
    return this.curve._wnafMul(this, k);
};
$e21c1ff4340c2591$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$e21c1ff4340c2591$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$e21c1ff4340c2591$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$e21c1ff4340c2591$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("kalge", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $lfl9G = parcelRequire("lfl9G");

var $hrzcF = parcelRequire("hrzcF");

var $7Xmwk = parcelRequire("7Xmwk");
function $eae53bca8a426bfd$var$MontCurve(conf) {
    $hrzcF.call(this, "mont", conf);
    this.a = new $7rVdb(conf.a, 16).toRed(this.red);
    this.b = new $7rVdb(conf.b, 16).toRed(this.red);
    this.i4 = new $7rVdb(4).toRed(this.red).redInvm();
    this.two = new $7rVdb(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lfl9G($eae53bca8a426bfd$var$MontCurve, $hrzcF);
module.exports = $eae53bca8a426bfd$var$MontCurve;
$eae53bca8a426bfd$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $eae53bca8a426bfd$var$Point(curve, x, z) {
    $hrzcF.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7rVdb(x, 16);
        this.z = new $7rVdb(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lfl9G($eae53bca8a426bfd$var$Point, $hrzcF.BasePoint);
$eae53bca8a426bfd$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($7Xmwk.toArray(bytes, enc), 1);
};
$eae53bca8a426bfd$var$MontCurve.prototype.point = function point(x, z) {
    return new $eae53bca8a426bfd$var$Point(this, x, z);
};
$eae53bca8a426bfd$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $eae53bca8a426bfd$var$Point.fromJSON(this, obj);
};
$eae53bca8a426bfd$var$Point.prototype.precompute = function precompute() {
// No-op
};
$eae53bca8a426bfd$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$eae53bca8a426bfd$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $eae53bca8a426bfd$var$Point(curve, obj[0], obj[1] || curve.one);
};
$eae53bca8a426bfd$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$eae53bca8a426bfd$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$eae53bca8a426bfd$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$eae53bca8a426bfd$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$eae53bca8a426bfd$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$eae53bca8a426bfd$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$eae53bca8a426bfd$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$eae53bca8a426bfd$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$eae53bca8a426bfd$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$eae53bca8a426bfd$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$eae53bca8a426bfd$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("j4v8G", function(module, exports) {
"use strict";

var $7Xmwk = parcelRequire("7Xmwk");

var $7rVdb = parcelRequire("7rVdb");

var $lfl9G = parcelRequire("lfl9G");

var $hrzcF = parcelRequire("hrzcF");
var $de268b9ce4c1b830$var$assert = $7Xmwk.assert;
function $de268b9ce4c1b830$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hrzcF.call(this, "edwards", conf);
    this.a = new $7rVdb(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7rVdb(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7rVdb(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $de268b9ce4c1b830$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lfl9G($de268b9ce4c1b830$var$EdwardsCurve, $hrzcF);
module.exports = $de268b9ce4c1b830$var$EdwardsCurve;
$de268b9ce4c1b830$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$de268b9ce4c1b830$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$de268b9ce4c1b830$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$de268b9ce4c1b830$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7rVdb(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$de268b9ce4c1b830$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7rVdb(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$de268b9ce4c1b830$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $de268b9ce4c1b830$var$Point(curve, x, y, z, t) {
    $hrzcF.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7rVdb(x, 16);
        this.y = new $7rVdb(y, 16);
        this.z = z ? new $7rVdb(z, 16) : this.curve.one;
        this.t = t && new $7rVdb(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lfl9G($de268b9ce4c1b830$var$Point, $hrzcF.BasePoint);
$de268b9ce4c1b830$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $de268b9ce4c1b830$var$Point.fromJSON(this, obj);
};
$de268b9ce4c1b830$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $de268b9ce4c1b830$var$Point(this, x, y, z, t);
};
$de268b9ce4c1b830$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $de268b9ce4c1b830$var$Point(curve, obj[0], obj[1], obj[2]);
};
$de268b9ce4c1b830$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$de268b9ce4c1b830$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$de268b9ce4c1b830$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$de268b9ce4c1b830$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$de268b9ce4c1b830$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$de268b9ce4c1b830$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$de268b9ce4c1b830$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$de268b9ce4c1b830$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$de268b9ce4c1b830$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$de268b9ce4c1b830$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$de268b9ce4c1b830$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$de268b9ce4c1b830$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$de268b9ce4c1b830$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$de268b9ce4c1b830$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$de268b9ce4c1b830$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$de268b9ce4c1b830$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$de268b9ce4c1b830$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$de268b9ce4c1b830$var$Point.prototype.toP = $de268b9ce4c1b830$var$Point.prototype.normalize;
$de268b9ce4c1b830$var$Point.prototype.mixedAdd = $de268b9ce4c1b830$var$Point.prototype.add;

});


parcelRegister("dr4Pq", function(module, exports) {
"use strict";
var $9c818ac9eb93cb88$var$curves = module.exports;

var $2peZt = parcelRequire("2peZt");

var $1J9Vk = parcelRequire("1J9Vk");

var $7Xmwk = parcelRequire("7Xmwk");
var $9c818ac9eb93cb88$var$assert = $7Xmwk.assert;
function $9c818ac9eb93cb88$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $1J9Vk.short(options);
    else if (options.type === "edwards") this.curve = new $1J9Vk.edwards(options);
    else this.curve = new $1J9Vk.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $9c818ac9eb93cb88$var$assert(this.g.validate(), "Invalid curve");
    $9c818ac9eb93cb88$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$9c818ac9eb93cb88$var$curves.PresetCurve = $9c818ac9eb93cb88$var$PresetCurve;
function $9c818ac9eb93cb88$var$defineCurve(name, options) {
    Object.defineProperty($9c818ac9eb93cb88$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $9c818ac9eb93cb88$var$PresetCurve(options);
            Object.defineProperty($9c818ac9eb93cb88$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$9c818ac9eb93cb88$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $2peZt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $2peZt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $2peZt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $2peZt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $2peZt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2peZt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$9c818ac9eb93cb88$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2peZt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $9c818ac9eb93cb88$var$pre;

try {
    $9c818ac9eb93cb88$var$pre = (parcelRequire("8SjG3"));
} catch (e) {
    $9c818ac9eb93cb88$var$pre = undefined;
}
$9c818ac9eb93cb88$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $2peZt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $9c818ac9eb93cb88$var$pre
    ]
});

});
parcelRegister("8SjG3", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("dVBaf", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $2tGeW = parcelRequire("2tGeW");

var $7Xmwk = parcelRequire("7Xmwk");

var $dr4Pq = parcelRequire("dr4Pq");

var $4Lrhy = parcelRequire("4Lrhy");
var $a23d6d4cb50315db$var$assert = $7Xmwk.assert;

var $e5zhB = parcelRequire("e5zhB");

var $8o8FF = parcelRequire("8o8FF");
function $a23d6d4cb50315db$var$EC(options) {
    if (!(this instanceof $a23d6d4cb50315db$var$EC)) return new $a23d6d4cb50315db$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $a23d6d4cb50315db$var$assert(Object.prototype.hasOwnProperty.call($dr4Pq, options), "Unknown curve " + options);
        options = $dr4Pq[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $dr4Pq.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $a23d6d4cb50315db$var$EC;
$a23d6d4cb50315db$var$EC.prototype.keyPair = function keyPair(options) {
    return new $e5zhB(this, options);
};
$a23d6d4cb50315db$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $e5zhB.fromPrivate(this, priv, enc);
};
$a23d6d4cb50315db$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $e5zhB.fromPublic(this, pub, enc);
};
$a23d6d4cb50315db$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $2tGeW({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $4Lrhy(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7rVdb(2));
    for(;;){
        var priv = new $7rVdb(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$a23d6d4cb50315db$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$a23d6d4cb50315db$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $7rVdb(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $2tGeW({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7rVdb(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7rVdb(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $8o8FF({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$a23d6d4cb50315db$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $7rVdb(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $8o8FF(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$a23d6d4cb50315db$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $a23d6d4cb50315db$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $8o8FF(signature, enc);
    var n = this.n;
    var e = new $7rVdb(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$a23d6d4cb50315db$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $8o8FF(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("2tGeW", function(module, exports) {
"use strict";

var $2peZt = parcelRequire("2peZt");

var $3bsl0 = parcelRequire("3bsl0");

var $kAZVs = parcelRequire("kAZVs");
function $1cdf0e34d9bb401d$var$HmacDRBG(options) {
    if (!(this instanceof $1cdf0e34d9bb401d$var$HmacDRBG)) return new $1cdf0e34d9bb401d$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $3bsl0.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $3bsl0.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $3bsl0.toArray(options.pers, options.persEnc || "hex");
    $kAZVs(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $1cdf0e34d9bb401d$var$HmacDRBG;
$1cdf0e34d9bb401d$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$1cdf0e34d9bb401d$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $2peZt.hmac(this.hash, this.K);
};
$1cdf0e34d9bb401d$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$1cdf0e34d9bb401d$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $3bsl0.toArray(entropy, entropyEnc);
    add = $3bsl0.toArray(add, addEnc);
    $kAZVs(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$1cdf0e34d9bb401d$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $3bsl0.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $3bsl0.encode(res, enc);
};

});

parcelRegister("e5zhB", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $7Xmwk = parcelRequire("7Xmwk");
var $a41ce6c12cab1668$var$assert = $7Xmwk.assert;
function $a41ce6c12cab1668$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $a41ce6c12cab1668$var$KeyPair;
$a41ce6c12cab1668$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $a41ce6c12cab1668$var$KeyPair) return pub;
    return new $a41ce6c12cab1668$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$a41ce6c12cab1668$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $a41ce6c12cab1668$var$KeyPair) return priv;
    return new $a41ce6c12cab1668$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$a41ce6c12cab1668$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$a41ce6c12cab1668$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$a41ce6c12cab1668$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$a41ce6c12cab1668$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7rVdb(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$a41ce6c12cab1668$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $a41ce6c12cab1668$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $a41ce6c12cab1668$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$a41ce6c12cab1668$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $a41ce6c12cab1668$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$a41ce6c12cab1668$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$a41ce6c12cab1668$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$a41ce6c12cab1668$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("8o8FF", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $7Xmwk = parcelRequire("7Xmwk");
var $61b74a81536200c3$var$assert = $7Xmwk.assert;
function $61b74a81536200c3$var$Signature(options, enc) {
    if (options instanceof $61b74a81536200c3$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $61b74a81536200c3$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $7rVdb(options.r, 16);
    this.s = new $7rVdb(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $61b74a81536200c3$var$Signature;
function $61b74a81536200c3$var$Position() {
    this.place = 0;
}
function $61b74a81536200c3$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $61b74a81536200c3$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$61b74a81536200c3$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $7Xmwk.toArray(data, enc);
    var p = new $61b74a81536200c3$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $61b74a81536200c3$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $61b74a81536200c3$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $61b74a81536200c3$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7rVdb(r);
    this.s = new $7rVdb(s);
    this.recoveryParam = null;
    return true;
};
function $61b74a81536200c3$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$61b74a81536200c3$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $61b74a81536200c3$var$rmPadding(r);
    s = $61b74a81536200c3$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $61b74a81536200c3$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $61b74a81536200c3$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $61b74a81536200c3$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $7Xmwk.encode(res, enc);
};

});


parcelRegister("4trIP", function(module, exports) {
"use strict";

var $2peZt = parcelRequire("2peZt");

var $dr4Pq = parcelRequire("dr4Pq");

var $7Xmwk = parcelRequire("7Xmwk");
var $341f5fdc7ce67f94$var$assert = $7Xmwk.assert;
var $341f5fdc7ce67f94$var$parseBytes = $7Xmwk.parseBytes;

var $g518m = parcelRequire("g518m");

var $10oTw = parcelRequire("10oTw");
function $341f5fdc7ce67f94$var$EDDSA(curve) {
    $341f5fdc7ce67f94$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $341f5fdc7ce67f94$var$EDDSA)) return new $341f5fdc7ce67f94$var$EDDSA(curve);
    curve = $dr4Pq[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $2peZt.sha512;
}
module.exports = $341f5fdc7ce67f94$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $341f5fdc7ce67f94$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $341f5fdc7ce67f94$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $341f5fdc7ce67f94$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $341f5fdc7ce67f94$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $7Xmwk.intFromLE(hash.digest()).umod(this.curve.n);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $g518m.fromPublic(this, pub);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $g518m.fromSecret(this, secret);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $10oTw) return sig;
    return new $10oTw(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $341f5fdc7ce67f94$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$341f5fdc7ce67f94$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $7Xmwk.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $7Xmwk.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $7Xmwk.intFromLE(bytes);
};
$341f5fdc7ce67f94$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("g518m", function(module, exports) {
"use strict";

var $7Xmwk = parcelRequire("7Xmwk");
var $bb4dfe209775106e$var$assert = $7Xmwk.assert;
var $bb4dfe209775106e$var$parseBytes = $7Xmwk.parseBytes;
var $bb4dfe209775106e$var$cachedProperty = $7Xmwk.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $bb4dfe209775106e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $bb4dfe209775106e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $bb4dfe209775106e$var$parseBytes(params.pub);
}
$bb4dfe209775106e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $bb4dfe209775106e$var$KeyPair) return pub;
    return new $bb4dfe209775106e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$bb4dfe209775106e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $bb4dfe209775106e$var$KeyPair) return secret;
    return new $bb4dfe209775106e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$bb4dfe209775106e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$bb4dfe209775106e$var$cachedProperty($bb4dfe209775106e$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$bb4dfe209775106e$var$KeyPair.prototype.sign = function sign(message) {
    $bb4dfe209775106e$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$bb4dfe209775106e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$bb4dfe209775106e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $bb4dfe209775106e$var$assert(this._secret, "KeyPair is public only");
    return $7Xmwk.encode(this.secret(), enc);
};
$bb4dfe209775106e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $7Xmwk.encode(this.pubBytes(), enc);
};
module.exports = $bb4dfe209775106e$var$KeyPair;

});

parcelRegister("10oTw", function(module, exports) {
"use strict";

var $7rVdb = parcelRequire("7rVdb");

var $7Xmwk = parcelRequire("7Xmwk");
var $0bb91a105e1d03f6$var$assert = $7Xmwk.assert;
var $0bb91a105e1d03f6$var$cachedProperty = $7Xmwk.cachedProperty;
var $0bb91a105e1d03f6$var$parseBytes = $7Xmwk.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $0bb91a105e1d03f6$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $0bb91a105e1d03f6$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $0bb91a105e1d03f6$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7rVdb) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$0bb91a105e1d03f6$var$cachedProperty($0bb91a105e1d03f6$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$0bb91a105e1d03f6$var$cachedProperty($0bb91a105e1d03f6$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$0bb91a105e1d03f6$var$cachedProperty($0bb91a105e1d03f6$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$0bb91a105e1d03f6$var$cachedProperty($0bb91a105e1d03f6$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$0bb91a105e1d03f6$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$0bb91a105e1d03f6$var$Signature.prototype.toHex = function toHex() {
    return $7Xmwk.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $0bb91a105e1d03f6$var$Signature;

});


parcelRegister("ePKtE", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("l4Xep", function(module, exports) {

var $hFs5p = parcelRequire("hFs5p");

var $lfl9G = parcelRequire("lfl9G");
var $f587ead80aa893ac$var$api = module.exports;
$f587ead80aa893ac$var$api.define = function define(name, body) {
    return new $f587ead80aa893ac$var$Entity(name, body);
};
function $f587ead80aa893ac$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$f587ead80aa893ac$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("cSUEX")).runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lfl9G(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$f587ead80aa893ac$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($hFs5p.decoders[enc]);
    return this.decoders[enc];
};
$f587ead80aa893ac$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$f587ead80aa893ac$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($hFs5p.encoders[enc]);
    return this.encoders[enc];
};
$f587ead80aa893ac$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("hFs5p", function(module, exports) {
var $cdcc0d5235d72128$var$asn1 = module.exports;

$cdcc0d5235d72128$var$asn1.bignum = (parcelRequire("7rVdb"));

$cdcc0d5235d72128$var$asn1.define = (parcelRequire("l4Xep")).define;

$cdcc0d5235d72128$var$asn1.base = (parcelRequire("kZGoC"));

$cdcc0d5235d72128$var$asn1.constants = (parcelRequire("06xjo"));

$cdcc0d5235d72128$var$asn1.decoders = (parcelRequire("hUYdc"));

$cdcc0d5235d72128$var$asn1.encoders = (parcelRequire("f4X9I"));

});
parcelRegister("kZGoC", function(module, exports) {
var $f48a64200a7a90fc$var$base = module.exports;

$f48a64200a7a90fc$var$base.Reporter = (parcelRequire("e0PH5")).Reporter;

$f48a64200a7a90fc$var$base.DecoderBuffer = (parcelRequire("3fuqB")).DecoderBuffer;

$f48a64200a7a90fc$var$base.EncoderBuffer = (parcelRequire("3fuqB")).EncoderBuffer;

$f48a64200a7a90fc$var$base.Node = (parcelRequire("ahCxN"));

});
parcelRegister("e0PH5", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $a3392a1e6dfb0a61$export$957313a2f485e5ed, (v) => $a3392a1e6dfb0a61$export$957313a2f485e5ed = v);
var $a3392a1e6dfb0a61$export$957313a2f485e5ed;

var $lfl9G = parcelRequire("lfl9G");
function $a3392a1e6dfb0a61$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$a3392a1e6dfb0a61$export$957313a2f485e5ed = $a3392a1e6dfb0a61$var$Reporter;
$a3392a1e6dfb0a61$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $a3392a1e6dfb0a61$var$ReporterError;
};
$a3392a1e6dfb0a61$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$a3392a1e6dfb0a61$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$a3392a1e6dfb0a61$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$a3392a1e6dfb0a61$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$a3392a1e6dfb0a61$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$a3392a1e6dfb0a61$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$a3392a1e6dfb0a61$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$a3392a1e6dfb0a61$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$a3392a1e6dfb0a61$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $a3392a1e6dfb0a61$var$ReporterError;
    if (inherited) err = msg;
    else err = new $a3392a1e6dfb0a61$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$a3392a1e6dfb0a61$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $a3392a1e6dfb0a61$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lfl9G($a3392a1e6dfb0a61$var$ReporterError, Error);
$a3392a1e6dfb0a61$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $a3392a1e6dfb0a61$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("3fuqB", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $25da6035815ad149$export$bf9f79cdc4a49163, (v) => $25da6035815ad149$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $25da6035815ad149$export$8ff24f7760c7a78e, (v) => $25da6035815ad149$export$8ff24f7760c7a78e = v);
var $25da6035815ad149$export$bf9f79cdc4a49163;
var $25da6035815ad149$export$8ff24f7760c7a78e;

var $lfl9G = parcelRequire("lfl9G");

var $kZGoC = parcelRequire("kZGoC");
var $25da6035815ad149$require$Reporter = $kZGoC.Reporter;

var $7ts9d = parcelRequire("7ts9d");
var $25da6035815ad149$require$Buffer = $7ts9d.Buffer;
function $25da6035815ad149$var$DecoderBuffer(base, options) {
    $25da6035815ad149$require$Reporter.call(this, options);
    if (!$25da6035815ad149$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lfl9G($25da6035815ad149$var$DecoderBuffer, $25da6035815ad149$require$Reporter);
$25da6035815ad149$export$bf9f79cdc4a49163 = $25da6035815ad149$var$DecoderBuffer;
$25da6035815ad149$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $25da6035815ad149$require$Reporter.prototype.save.call(this)
    };
};
$25da6035815ad149$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $25da6035815ad149$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $25da6035815ad149$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$25da6035815ad149$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$25da6035815ad149$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$25da6035815ad149$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $25da6035815ad149$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$25da6035815ad149$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $25da6035815ad149$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $25da6035815ad149$var$EncoderBuffer)) item = new $25da6035815ad149$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $25da6035815ad149$require$Buffer.byteLength(value);
    } else if ($25da6035815ad149$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$25da6035815ad149$export$8ff24f7760c7a78e = $25da6035815ad149$var$EncoderBuffer;
$25da6035815ad149$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $25da6035815ad149$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($25da6035815ad149$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("ahCxN", function(module, exports) {

var $kZGoC = parcelRequire("kZGoC");
var $77c963f8626f4eee$require$Reporter = $kZGoC.Reporter;

var $kZGoC = parcelRequire("kZGoC");
var $77c963f8626f4eee$require$EncoderBuffer = $kZGoC.EncoderBuffer;

var $kZGoC = parcelRequire("kZGoC");
var $77c963f8626f4eee$require$DecoderBuffer = $kZGoC.DecoderBuffer;

var $kAZVs = parcelRequire("kAZVs");
// Supported tags
var $77c963f8626f4eee$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $77c963f8626f4eee$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($77c963f8626f4eee$var$tags);
// Overrided methods list
var $77c963f8626f4eee$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $77c963f8626f4eee$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $77c963f8626f4eee$var$Node;
var $77c963f8626f4eee$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$77c963f8626f4eee$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $77c963f8626f4eee$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$77c963f8626f4eee$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $77c963f8626f4eee$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$77c963f8626f4eee$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $kAZVs(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $kAZVs.equal(state.children.length, 1, "Root node can have only one child");
};
$77c963f8626f4eee$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $kAZVs(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $kAZVs(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$77c963f8626f4eee$var$overrided.forEach(function(method) {
    $77c963f8626f4eee$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$77c963f8626f4eee$var$tags.forEach(function(tag) {
    $77c963f8626f4eee$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $kAZVs(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$77c963f8626f4eee$var$Node.prototype.use = function use(item) {
    $kAZVs(item);
    var state = this._baseState;
    $kAZVs(state.use === null);
    state.use = item;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $kAZVs(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $kAZVs(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $kAZVs(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$77c963f8626f4eee$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $kAZVs(state.key === null);
    state.key = newKey;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$77c963f8626f4eee$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $kAZVs(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$77c963f8626f4eee$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $kAZVs(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$77c963f8626f4eee$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $77c963f8626f4eee$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$77c963f8626f4eee$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$77c963f8626f4eee$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $kAZVs(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$77c963f8626f4eee$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$77c963f8626f4eee$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $77c963f8626f4eee$require$EncoderBuffer(data, this.reporter);
};
$77c963f8626f4eee$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$77c963f8626f4eee$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $77c963f8626f4eee$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$77c963f8626f4eee$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $kAZVs(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$77c963f8626f4eee$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$77c963f8626f4eee$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$77c963f8626f4eee$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("06xjo", function(module, exports) {
var $0005122c158c5104$var$constants = module.exports;
// Helper
$0005122c158c5104$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0005122c158c5104$var$constants.der = (parcelRequire("kS6qC"));

});
parcelRegister("kS6qC", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $f31dd64f9bc47b16$export$3584c46ed60baee8, (v) => $f31dd64f9bc47b16$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $f31dd64f9bc47b16$export$f18596ef8d632e49, (v) => $f31dd64f9bc47b16$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $f31dd64f9bc47b16$export$2b067c6666111485, (v) => $f31dd64f9bc47b16$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $f31dd64f9bc47b16$export$f17df38a421ab9e3, (v) => $f31dd64f9bc47b16$export$f17df38a421ab9e3 = v);
var $f31dd64f9bc47b16$export$3584c46ed60baee8;
var $f31dd64f9bc47b16$export$f18596ef8d632e49;
var $f31dd64f9bc47b16$export$2b067c6666111485;
var $f31dd64f9bc47b16$export$f17df38a421ab9e3;

var $06xjo = parcelRequire("06xjo");
$f31dd64f9bc47b16$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$f31dd64f9bc47b16$export$f18596ef8d632e49 = $06xjo._reverse($f31dd64f9bc47b16$export$3584c46ed60baee8);
$f31dd64f9bc47b16$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$f31dd64f9bc47b16$export$f17df38a421ab9e3 = $06xjo._reverse($f31dd64f9bc47b16$export$2b067c6666111485);

});


parcelRegister("hUYdc", function(module, exports) {
var $d0b65f74a61885c5$var$decoders = module.exports;

$d0b65f74a61885c5$var$decoders.der = (parcelRequire("fDWhv"));

$d0b65f74a61885c5$var$decoders.pem = (parcelRequire("g6nzb"));

});
parcelRegister("fDWhv", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $hFs5p = parcelRequire("hFs5p");
var $b637b50359e9c54b$var$base = $hFs5p.base;
var $b637b50359e9c54b$var$bignum = $hFs5p.bignum;
// Import DER constants
var $b637b50359e9c54b$var$der = $hFs5p.constants.der;
function $b637b50359e9c54b$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b637b50359e9c54b$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b637b50359e9c54b$var$DERDecoder;
$b637b50359e9c54b$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b637b50359e9c54b$var$base.DecoderBuffer)) data = new $b637b50359e9c54b$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b637b50359e9c54b$var$DERNode(parent) {
    $b637b50359e9c54b$var$base.Node.call(this, "der", parent);
}
$lfl9G($b637b50359e9c54b$var$DERNode, $b637b50359e9c54b$var$base.Node);
$b637b50359e9c54b$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b637b50359e9c54b$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b637b50359e9c54b$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b637b50359e9c54b$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b637b50359e9c54b$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b637b50359e9c54b$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b637b50359e9c54b$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b637b50359e9c54b$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b637b50359e9c54b$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b637b50359e9c54b$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b637b50359e9c54b$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b637b50359e9c54b$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b637b50359e9c54b$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b637b50359e9c54b$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b637b50359e9c54b$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b637b50359e9c54b$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b637b50359e9c54b$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b637b50359e9c54b$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b637b50359e9c54b$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b637b50359e9c54b$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b637b50359e9c54b$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("g6nzb", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $7ts9d = parcelRequire("7ts9d");
var $bb8f7caefc14ce6a$require$Buffer = $7ts9d.Buffer;

var $fDWhv = parcelRequire("fDWhv");
function $bb8f7caefc14ce6a$var$PEMDecoder(entity) {
    $fDWhv.call(this, entity);
    this.enc = "pem";
}
$lfl9G($bb8f7caefc14ce6a$var$PEMDecoder, $fDWhv);
module.exports = $bb8f7caefc14ce6a$var$PEMDecoder;
$bb8f7caefc14ce6a$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new $bb8f7caefc14ce6a$require$Buffer(base64, "base64");
    return $fDWhv.prototype.decode.call(this, input, options);
};

});


parcelRegister("f4X9I", function(module, exports) {
var $afa51dd91a89f8b1$var$encoders = module.exports;

$afa51dd91a89f8b1$var$encoders.der = (parcelRequire("jPujh"));

$afa51dd91a89f8b1$var$encoders.pem = (parcelRequire("j8vBf"));

});
parcelRegister("jPujh", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $7ts9d = parcelRequire("7ts9d");
var $e6fa4aadc47aec1d$require$Buffer = $7ts9d.Buffer;

var $hFs5p = parcelRequire("hFs5p");
var $e6fa4aadc47aec1d$var$base = $hFs5p.base;
// Import DER constants
var $e6fa4aadc47aec1d$var$der = $hFs5p.constants.der;
function $e6fa4aadc47aec1d$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $e6fa4aadc47aec1d$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $e6fa4aadc47aec1d$var$DEREncoder;
$e6fa4aadc47aec1d$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $e6fa4aadc47aec1d$var$DERNode(parent) {
    $e6fa4aadc47aec1d$var$base.Node.call(this, "der", parent);
}
$lfl9G($e6fa4aadc47aec1d$var$DERNode, $e6fa4aadc47aec1d$var$base.Node);
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $e6fa4aadc47aec1d$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $e6fa4aadc47aec1d$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $e6fa4aadc47aec1d$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new $e6fa4aadc47aec1d$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $e6fa4aadc47aec1d$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $e6fa4aadc47aec1d$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $e6fa4aadc47aec1d$var$two(date.getFullYear()),
        $e6fa4aadc47aec1d$var$two(date.getUTCMonth() + 1),
        $e6fa4aadc47aec1d$var$two(date.getUTCDate()),
        $e6fa4aadc47aec1d$var$two(date.getUTCHours()),
        $e6fa4aadc47aec1d$var$two(date.getUTCMinutes()),
        $e6fa4aadc47aec1d$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $e6fa4aadc47aec1d$var$two(date.getFullYear() % 100),
        $e6fa4aadc47aec1d$var$two(date.getUTCMonth() + 1),
        $e6fa4aadc47aec1d$var$two(date.getUTCDate()),
        $e6fa4aadc47aec1d$var$two(date.getUTCHours()),
        $e6fa4aadc47aec1d$var$two(date.getUTCMinutes()),
        $e6fa4aadc47aec1d$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$e6fa4aadc47aec1d$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $e6fa4aadc47aec1d$require$Buffer(numArray);
    }
    if ($e6fa4aadc47aec1d$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $e6fa4aadc47aec1d$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $e6fa4aadc47aec1d$require$Buffer(out));
};
$e6fa4aadc47aec1d$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$e6fa4aadc47aec1d$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$e6fa4aadc47aec1d$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $e6fa4aadc47aec1d$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($e6fa4aadc47aec1d$var$der.tagByName.hasOwnProperty(tag)) res = $e6fa4aadc47aec1d$var$der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $e6fa4aadc47aec1d$var$der.tagClassByName[cls || "universal"] << 6;
    return res;
}

});

parcelRegister("j8vBf", function(module, exports) {

var $lfl9G = parcelRequire("lfl9G");

var $jPujh = parcelRequire("jPujh");
function $dee746b70f34634b$var$PEMEncoder(entity) {
    $jPujh.call(this, entity);
    this.enc = "pem";
}
$lfl9G($dee746b70f34634b$var$PEMEncoder, $jPujh);
module.exports = $dee746b70f34634b$var$PEMEncoder;
$dee746b70f34634b$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $jPujh.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});



parcelRegister("cSUEX", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("caHrZ", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $hFs5p = parcelRequire("hFs5p");
var $8dc81f8c52be5d83$var$Time = $hFs5p.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $8dc81f8c52be5d83$var$AttributeTypeValue = $hFs5p.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $8dc81f8c52be5d83$var$AlgorithmIdentifier = $hFs5p.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $8dc81f8c52be5d83$var$SubjectPublicKeyInfo = $hFs5p.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($8dc81f8c52be5d83$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $8dc81f8c52be5d83$var$RelativeDistinguishedName = $hFs5p.define("RelativeDistinguishedName", function() {
    this.setof($8dc81f8c52be5d83$var$AttributeTypeValue);
});
var $8dc81f8c52be5d83$var$RDNSequence = $hFs5p.define("RDNSequence", function() {
    this.seqof($8dc81f8c52be5d83$var$RelativeDistinguishedName);
});
var $8dc81f8c52be5d83$var$Name = $hFs5p.define("Name", function() {
    this.choice({
        rdnSequence: this.use($8dc81f8c52be5d83$var$RDNSequence)
    });
});
var $8dc81f8c52be5d83$var$Validity = $hFs5p.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($8dc81f8c52be5d83$var$Time), this.key("notAfter").use($8dc81f8c52be5d83$var$Time));
});
var $8dc81f8c52be5d83$var$Extension = $hFs5p.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $8dc81f8c52be5d83$var$TBSCertificate = $hFs5p.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use($8dc81f8c52be5d83$var$AlgorithmIdentifier), this.key("issuer").use($8dc81f8c52be5d83$var$Name), this.key("validity").use($8dc81f8c52be5d83$var$Validity), this.key("subject").use($8dc81f8c52be5d83$var$Name), this.key("subjectPublicKeyInfo").use($8dc81f8c52be5d83$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($8dc81f8c52be5d83$var$Extension).optional());
});
var $8dc81f8c52be5d83$var$X509Certificate = $hFs5p.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($8dc81f8c52be5d83$var$TBSCertificate), this.key("signatureAlgorithm").use($8dc81f8c52be5d83$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $8dc81f8c52be5d83$var$X509Certificate;

});

parcelRegister("kvGFf", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $eee7cc1ecc36811c$require$Buffer = $7ts9d.Buffer;

var $2jcP0 = parcelRequire("2jcP0");

var $7rVdb = parcelRequire("7rVdb");
module.exports = function createECDH(curve) {
    return new $eee7cc1ecc36811c$var$ECDH(curve);
};
var $eee7cc1ecc36811c$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$eee7cc1ecc36811c$var$aliases.p224 = $eee7cc1ecc36811c$var$aliases.secp224r1;
$eee7cc1ecc36811c$var$aliases.p256 = $eee7cc1ecc36811c$var$aliases.secp256r1 = $eee7cc1ecc36811c$var$aliases.prime256v1;
$eee7cc1ecc36811c$var$aliases.p192 = $eee7cc1ecc36811c$var$aliases.secp192r1 = $eee7cc1ecc36811c$var$aliases.prime192v1;
$eee7cc1ecc36811c$var$aliases.p384 = $eee7cc1ecc36811c$var$aliases.secp384r1;
$eee7cc1ecc36811c$var$aliases.p521 = $eee7cc1ecc36811c$var$aliases.secp521r1;
function $eee7cc1ecc36811c$var$ECDH(curve) {
    this.curveType = $eee7cc1ecc36811c$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $2jcP0.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$eee7cc1ecc36811c$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$eee7cc1ecc36811c$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$eee7cc1ecc36811c$require$Buffer.isBuffer(other)) other = new $eee7cc1ecc36811c$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $eee7cc1ecc36811c$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$eee7cc1ecc36811c$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $eee7cc1ecc36811c$var$formatReturnValue(key, enc);
};
$eee7cc1ecc36811c$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $eee7cc1ecc36811c$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$eee7cc1ecc36811c$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$eee7cc1ecc36811c$require$Buffer.isBuffer(pub)) pub = new $eee7cc1ecc36811c$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$eee7cc1ecc36811c$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$eee7cc1ecc36811c$require$Buffer.isBuffer(priv)) priv = new $eee7cc1ecc36811c$require$Buffer(priv, enc);
    var _priv = new $7rVdb(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $eee7cc1ecc36811c$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $eee7cc1ecc36811c$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $eee7cc1ecc36811c$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $eee7cc1ecc36811c$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("2jcP0", function(module, exports) {
"use strict";
var $1ae74d3fdc92c58e$var$elliptic = module.exports;

$1ae74d3fdc92c58e$var$elliptic.version = (parcelRequire("4PoEe")).version;

$1ae74d3fdc92c58e$var$elliptic.utils = (parcelRequire("7Xmwk"));

$1ae74d3fdc92c58e$var$elliptic.rand = (parcelRequire("4Lrhy"));

$1ae74d3fdc92c58e$var$elliptic.curve = (parcelRequire("1J9Vk"));

$1ae74d3fdc92c58e$var$elliptic.curves = (parcelRequire("dr4Pq"));

// Protocols
$1ae74d3fdc92c58e$var$elliptic.ec = (parcelRequire("dVBaf"));

$1ae74d3fdc92c58e$var$elliptic.eddsa = (parcelRequire("4trIP"));

});


parcelRegister("4Mmcf", function(module, exports) {

var $70L5t = parcelRequire("70L5t");

var $fxidi = parcelRequire("fxidi");

var $lNfZR = parcelRequire("lNfZR");

var $uinvg = parcelRequire("uinvg");

var $7PYGg = parcelRequire("7PYGg");

var $7rVdb = parcelRequire("7rVdb");

var $1Ed8n = parcelRequire("1Ed8n");

var $dnOLj = parcelRequire("dnOLj");

var $ZavwZ = parcelRequire("ZavwZ");
var $37acdce34440952a$require$Buffer = $ZavwZ.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $70L5t(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $37acdce34440952a$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $37acdce34440952a$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $7rVdb(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $dnOLj(paddedMsg, key);
    else return $1Ed8n(paddedMsg, key);
};
function $37acdce34440952a$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $lNfZR("sha1").update($37acdce34440952a$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $37acdce34440952a$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $fxidi(hLen);
    var maskedDb = $7PYGg($37acdce34440952a$require$Buffer.concat([
        iHash,
        ps,
        $37acdce34440952a$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $uinvg(seed, dblen));
    var maskedSeed = $7PYGg(seed, $uinvg(maskedDb, hLen));
    return new $7rVdb($37acdce34440952a$require$Buffer.concat([
        $37acdce34440952a$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $37acdce34440952a$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $37acdce34440952a$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $37acdce34440952a$var$nonZero(k - mLen - 3);
    return new $7rVdb($37acdce34440952a$require$Buffer.concat([
        $37acdce34440952a$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $37acdce34440952a$require$Buffer.alloc(1),
        msg
    ], k));
}
function $37acdce34440952a$var$nonZero(len) {
    var out = $37acdce34440952a$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $fxidi(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $fxidi(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("70L5t", function(module, exports) {
"use strict";

var $h7MBy = parcelRequire("h7MBy");

var $eXrXw = parcelRequire("eXrXw");

var $9MAmb = parcelRequire("9MAmb");

var $lOfc7 = parcelRequire("lOfc7");

var $32phK = parcelRequire("32phK");

var $ZavwZ = parcelRequire("ZavwZ");
var $51ad0f0eb53cc6da$require$Buffer = $ZavwZ.Buffer;
function $51ad0f0eb53cc6da$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $eXrXw[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $32phK.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $lOfc7.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return $51ad0f0eb53cc6da$require$Buffer.concat(out);
}
function $51ad0f0eb53cc6da$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$51ad0f0eb53cc6da$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $51ad0f0eb53cc6da$require$Buffer.from(buffer);
    var stripped = $9MAmb(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $h7MBy.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $h7MBy.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $h7MBy.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $h7MBy.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $h7MBy.EncryptedPrivateKey.decode(data, "der");
            data = $51ad0f0eb53cc6da$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $h7MBy.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $h7MBy.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $h7MBy.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $h7MBy.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $h7MBy.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $h7MBy.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $h7MBy.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $h7MBy.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$51ad0f0eb53cc6da$var$parseKeys.signature = $h7MBy.signature;
module.exports = $51ad0f0eb53cc6da$var$parseKeys;

});
parcelRegister("h7MBy", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $c778cb00986592ad$export$c98397a6eb8d0678, (v) => $c778cb00986592ad$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $c778cb00986592ad$export$f4aab6816f64fa6b, (v) => $c778cb00986592ad$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $c778cb00986592ad$export$4471f5c65d097c11, (v) => $c778cb00986592ad$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $c778cb00986592ad$export$ca8b6604d6ce14de, (v) => $c778cb00986592ad$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $c778cb00986592ad$export$8f54525b330fd87b, (v) => $c778cb00986592ad$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $c778cb00986592ad$export$23cd2842b44ca3e7, (v) => $c778cb00986592ad$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $c778cb00986592ad$export$245c9aaa9f5ce4ce, (v) => $c778cb00986592ad$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $c778cb00986592ad$export$8ad762e3e6399afe, (v) => $c778cb00986592ad$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $c778cb00986592ad$export$32ef6f92e22c6ab0, (v) => $c778cb00986592ad$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $c778cb00986592ad$export$c9cd164b539ebb63, (v) => $c778cb00986592ad$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $c778cb00986592ad$export$c98397a6eb8d0678;
var $c778cb00986592ad$export$f4aab6816f64fa6b;
var $c778cb00986592ad$export$4471f5c65d097c11;
var $c778cb00986592ad$export$ca8b6604d6ce14de;
var $c778cb00986592ad$export$8f54525b330fd87b;
var $c778cb00986592ad$export$23cd2842b44ca3e7;
var $c778cb00986592ad$export$245c9aaa9f5ce4ce;
var $c778cb00986592ad$export$8ad762e3e6399afe;
var $c778cb00986592ad$export$32ef6f92e22c6ab0;
var $c778cb00986592ad$export$c9cd164b539ebb63;
"use strict";

var $hFs5p = parcelRequire("hFs5p");

$c778cb00986592ad$export$c98397a6eb8d0678 = (parcelRequire("caHrZ"));
var $c778cb00986592ad$var$RSAPrivateKey = $hFs5p.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
$c778cb00986592ad$export$f4aab6816f64fa6b = $c778cb00986592ad$var$RSAPrivateKey;
var $c778cb00986592ad$var$RSAPublicKey = $hFs5p.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
$c778cb00986592ad$export$4471f5c65d097c11 = $c778cb00986592ad$var$RSAPublicKey;
var $c778cb00986592ad$var$AlgorithmIdentifier = $hFs5p.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var $c778cb00986592ad$var$PublicKey = $hFs5p.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($c778cb00986592ad$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$c778cb00986592ad$export$ca8b6604d6ce14de = $c778cb00986592ad$var$PublicKey;
var $c778cb00986592ad$var$PrivateKeyInfo = $hFs5p.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use($c778cb00986592ad$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$c778cb00986592ad$export$8f54525b330fd87b = $c778cb00986592ad$var$PrivateKeyInfo;
var $c778cb00986592ad$var$EncryptedPrivateKeyInfo = $hFs5p.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$c778cb00986592ad$export$23cd2842b44ca3e7 = $c778cb00986592ad$var$EncryptedPrivateKeyInfo;
var $c778cb00986592ad$var$DSAPrivateKey = $hFs5p.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
$c778cb00986592ad$export$245c9aaa9f5ce4ce = $c778cb00986592ad$var$DSAPrivateKey;
$c778cb00986592ad$export$8ad762e3e6399afe = $hFs5p.define("DSAparam", function() {
    this["int"]();
});
var $c778cb00986592ad$var$ECParameters = $hFs5p.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $c778cb00986592ad$var$ECPrivateKey = $hFs5p.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($c778cb00986592ad$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$c778cb00986592ad$export$32ef6f92e22c6ab0 = $c778cb00986592ad$var$ECPrivateKey;
$c778cb00986592ad$export$c9cd164b539ebb63 = $hFs5p.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

});

parcelRegister("eXrXw", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("9MAmb", function(module, exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var $71f4cc76a3b701b6$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $71f4cc76a3b701b6$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $71f4cc76a3b701b6$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $jAdOp = parcelRequire("jAdOp");

var $lOfc7 = parcelRequire("lOfc7");

var $ZavwZ = parcelRequire("ZavwZ");
var $71f4cc76a3b701b6$require$Buffer = $ZavwZ.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($71f4cc76a3b701b6$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($71f4cc76a3b701b6$var$fullRegex);
        decrypted = $71f4cc76a3b701b6$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $71f4cc76a3b701b6$require$Buffer.from(match[2], "hex");
        var cipherText = $71f4cc76a3b701b6$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $jAdOp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $lOfc7.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = $71f4cc76a3b701b6$require$Buffer.concat(out);
    }
    var tag = key.match($71f4cc76a3b701b6$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("jAdOp", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $e41c17e51efc6d13$require$Buffer = $ZavwZ.Buffer;

var $k7S11 = parcelRequire("k7S11");
/* eslint-disable camelcase */ function $e41c17e51efc6d13$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$e41c17e51efc6d13$require$Buffer.isBuffer(password)) password = $e41c17e51efc6d13$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$e41c17e51efc6d13$require$Buffer.isBuffer(salt)) salt = $e41c17e51efc6d13$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $e41c17e51efc6d13$require$Buffer.alloc(keyLen);
    var iv = $e41c17e51efc6d13$require$Buffer.alloc(ivLen || 0);
    var tmp = $e41c17e51efc6d13$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $k7S11();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $e41c17e51efc6d13$var$EVP_BytesToKey;

});

parcelRegister("lOfc7", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $fe0a0dcb0b4ef555$export$2f64596b8cbf08b4, (v) => $fe0a0dcb0b4ef555$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $fe0a0dcb0b4ef555$export$36b6d6ef312eab39, (v) => $fe0a0dcb0b4ef555$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $fe0a0dcb0b4ef555$export$58a258485f1e49f6, (v) => $fe0a0dcb0b4ef555$export$58a258485f1e49f6 = v);
var $fe0a0dcb0b4ef555$export$bdd223f16383713e;
var $fe0a0dcb0b4ef555$export$26e5786e8ac8e530;
var $fe0a0dcb0b4ef555$export$2f64596b8cbf08b4;
var $fe0a0dcb0b4ef555$export$20533d26f07f1ee0;
var $fe0a0dcb0b4ef555$export$12ada9414fbc594c;
var $fe0a0dcb0b4ef555$export$2ce6d8d0e8b04e1a;
var $fe0a0dcb0b4ef555$export$36b6d6ef312eab39;
var $fe0a0dcb0b4ef555$export$f5e7e39d57cd9700;
var $fe0a0dcb0b4ef555$export$dedd8dc3dc62b370;
var $fe0a0dcb0b4ef555$export$58a258485f1e49f6;

var $eo4Fi = parcelRequire("eo4Fi");

var $3crQu = parcelRequire("3crQu");

var $jR0Y6 = parcelRequire("jR0Y6");
function $fe0a0dcb0b4ef555$var$getCiphers() {
    return Object.keys($jR0Y6);
}
$fe0a0dcb0b4ef555$export$bdd223f16383713e = $fe0a0dcb0b4ef555$export$26e5786e8ac8e530 = $eo4Fi.createCipher;
$fe0a0dcb0b4ef555$export$2f64596b8cbf08b4 = $fe0a0dcb0b4ef555$export$20533d26f07f1ee0 = $eo4Fi.createCipheriv;
$fe0a0dcb0b4ef555$export$12ada9414fbc594c = $fe0a0dcb0b4ef555$export$2ce6d8d0e8b04e1a = $3crQu.createDecipher;
$fe0a0dcb0b4ef555$export$36b6d6ef312eab39 = $fe0a0dcb0b4ef555$export$f5e7e39d57cd9700 = $3crQu.createDecipheriv;
$fe0a0dcb0b4ef555$export$dedd8dc3dc62b370 = $fe0a0dcb0b4ef555$export$58a258485f1e49f6 = $fe0a0dcb0b4ef555$var$getCiphers;

});
parcelRegister("eo4Fi", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $a796ecfb285391d3$export$2f64596b8cbf08b4, (v) => $a796ecfb285391d3$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $a796ecfb285391d3$export$bdd223f16383713e, (v) => $a796ecfb285391d3$export$bdd223f16383713e = v);
var $a796ecfb285391d3$export$2f64596b8cbf08b4;
var $a796ecfb285391d3$export$bdd223f16383713e;

var $gkdoN = parcelRequire("gkdoN");

var $YAkqK = parcelRequire("YAkqK");

var $ZavwZ = parcelRequire("ZavwZ");
var $a796ecfb285391d3$require$Buffer = $ZavwZ.Buffer;

var $awHDR = parcelRequire("awHDR");

var $f2cqU = parcelRequire("f2cqU");

var $2UmCe = parcelRequire("2UmCe");

var $jAdOp = parcelRequire("jAdOp");

var $lfl9G = parcelRequire("lfl9G");
function $a796ecfb285391d3$var$Cipher(mode, key, iv) {
    $f2cqU.call(this);
    this._cache = new $a796ecfb285391d3$var$Splitter();
    this._cipher = new $2UmCe.AES(key);
    this._prev = $a796ecfb285391d3$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lfl9G($a796ecfb285391d3$var$Cipher, $f2cqU);
$a796ecfb285391d3$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $a796ecfb285391d3$require$Buffer.concat(out);
};
var $a796ecfb285391d3$var$PADDING = $a796ecfb285391d3$require$Buffer.alloc(16, 0x10);
$a796ecfb285391d3$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($a796ecfb285391d3$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$a796ecfb285391d3$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $a796ecfb285391d3$var$Splitter() {
    this.cache = $a796ecfb285391d3$require$Buffer.allocUnsafe(0);
}
$a796ecfb285391d3$var$Splitter.prototype.add = function(data) {
    this.cache = $a796ecfb285391d3$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$a796ecfb285391d3$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$a796ecfb285391d3$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $a796ecfb285391d3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $a796ecfb285391d3$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $a796ecfb285391d3$var$createCipheriv(suite, password, iv) {
    var config = $gkdoN[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $a796ecfb285391d3$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $a796ecfb285391d3$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $awHDR(config.module, password, iv);
    else if (config.type === "auth") return new $YAkqK(config.module, password, iv);
    return new $a796ecfb285391d3$var$Cipher(config.module, password, iv);
}
function $a796ecfb285391d3$var$createCipher(suite, password) {
    var config = $gkdoN[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $jAdOp(password, false, config.key, config.iv);
    return $a796ecfb285391d3$var$createCipheriv(suite, keys.key, keys.iv);
}
$a796ecfb285391d3$export$2f64596b8cbf08b4 = $a796ecfb285391d3$var$createCipheriv;
$a796ecfb285391d3$export$bdd223f16383713e = $a796ecfb285391d3$var$createCipher;

});
parcelRegister("gkdoN", function(module, exports) {








var $be28e858f34ab5ec$var$modeModules = {
    ECB: (parcelRequire("qWsjv")),
    CBC: (parcelRequire("6haVV")),
    CFB: (parcelRequire("35ZKd")),
    CFB8: (parcelRequire("dmScv")),
    CFB1: (parcelRequire("eVlef")),
    OFB: (parcelRequire("eXcun")),
    CTR: (parcelRequire("f08h4")),
    GCM: (parcelRequire("f08h4"))
};

var $jR0Y6 = parcelRequire("jR0Y6");
for(var $be28e858f34ab5ec$var$key in $jR0Y6)$jR0Y6[$be28e858f34ab5ec$var$key].module = $be28e858f34ab5ec$var$modeModules[$jR0Y6[$be28e858f34ab5ec$var$key].mode];
module.exports = $jR0Y6;

});
parcelRegister("jR0Y6", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("YAkqK", function(module, exports) {

var $2UmCe = parcelRequire("2UmCe");

var $ZavwZ = parcelRequire("ZavwZ");
var $0b61c8cc9b1d4195$require$Buffer = $ZavwZ.Buffer;

var $f2cqU = parcelRequire("f2cqU");

var $lfl9G = parcelRequire("lfl9G");

var $695pH = parcelRequire("695pH");

var $95Vzl = parcelRequire("95Vzl");

var $ic08R = parcelRequire("ic08R");
function $0b61c8cc9b1d4195$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $0b61c8cc9b1d4195$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $0b61c8cc9b1d4195$require$Buffer.concat([
            iv,
            $0b61c8cc9b1d4195$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $0b61c8cc9b1d4195$require$Buffer.concat([
            iv,
            $0b61c8cc9b1d4195$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $695pH(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($0b61c8cc9b1d4195$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($0b61c8cc9b1d4195$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $0b61c8cc9b1d4195$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $0b61c8cc9b1d4195$require$Buffer.from(self._finID);
    $ic08R(out);
    return out;
}
function $0b61c8cc9b1d4195$var$StreamCipher(mode, key, iv, decrypt) {
    $f2cqU.call(this);
    var h = $0b61c8cc9b1d4195$require$Buffer.alloc(4, 0);
    this._cipher = new $2UmCe.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $695pH(ck);
    iv = $0b61c8cc9b1d4195$var$calcIv(this, iv, ck);
    this._prev = $0b61c8cc9b1d4195$require$Buffer.from(iv);
    this._cache = $0b61c8cc9b1d4195$require$Buffer.allocUnsafe(0);
    this._secCache = $0b61c8cc9b1d4195$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lfl9G($0b61c8cc9b1d4195$var$StreamCipher, $f2cqU);
$0b61c8cc9b1d4195$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $0b61c8cc9b1d4195$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$0b61c8cc9b1d4195$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $95Vzl(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $0b61c8cc9b1d4195$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$0b61c8cc9b1d4195$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$0b61c8cc9b1d4195$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$0b61c8cc9b1d4195$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$0b61c8cc9b1d4195$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $0b61c8cc9b1d4195$var$StreamCipher;

});
parcelRegister("2UmCe", function(module, exports) {

$parcel$export(module.exports, "AES", () => $21e25abe01c54854$export$b80fbe1c3a2b92b5, (v) => $21e25abe01c54854$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $21e25abe01c54854$export$b80fbe1c3a2b92b5;

var $ZavwZ = parcelRequire("ZavwZ");
var $21e25abe01c54854$require$Buffer = $ZavwZ.Buffer;
function $21e25abe01c54854$var$asUInt32Array(buf) {
    if (!$21e25abe01c54854$require$Buffer.isBuffer(buf)) buf = $21e25abe01c54854$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $21e25abe01c54854$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $21e25abe01c54854$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $21e25abe01c54854$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $21e25abe01c54854$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $21e25abe01c54854$var$AES(key) {
    this._key = $21e25abe01c54854$var$asUInt32Array(key);
    this._reset();
}
$21e25abe01c54854$var$AES.blockSize = 16;
$21e25abe01c54854$var$AES.keySize = 32;
$21e25abe01c54854$var$AES.prototype.blockSize = $21e25abe01c54854$var$AES.blockSize;
$21e25abe01c54854$var$AES.prototype.keySize = $21e25abe01c54854$var$AES.keySize;
$21e25abe01c54854$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $21e25abe01c54854$var$G.SBOX[t >>> 24] << 24 | $21e25abe01c54854$var$G.SBOX[t >>> 16 & 0xff] << 16 | $21e25abe01c54854$var$G.SBOX[t >>> 8 & 0xff] << 8 | $21e25abe01c54854$var$G.SBOX[t & 0xff];
            t ^= $21e25abe01c54854$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $21e25abe01c54854$var$G.SBOX[t >>> 24] << 24 | $21e25abe01c54854$var$G.SBOX[t >>> 16 & 0xff] << 16 | $21e25abe01c54854$var$G.SBOX[t >>> 8 & 0xff] << 8 | $21e25abe01c54854$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $21e25abe01c54854$var$G.INV_SUB_MIX[0][$21e25abe01c54854$var$G.SBOX[tt >>> 24]] ^ $21e25abe01c54854$var$G.INV_SUB_MIX[1][$21e25abe01c54854$var$G.SBOX[tt >>> 16 & 0xff]] ^ $21e25abe01c54854$var$G.INV_SUB_MIX[2][$21e25abe01c54854$var$G.SBOX[tt >>> 8 & 0xff]] ^ $21e25abe01c54854$var$G.INV_SUB_MIX[3][$21e25abe01c54854$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$21e25abe01c54854$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $21e25abe01c54854$var$asUInt32Array(M);
    return $21e25abe01c54854$var$cryptBlock(M, this._keySchedule, $21e25abe01c54854$var$G.SUB_MIX, $21e25abe01c54854$var$G.SBOX, this._nRounds);
};
$21e25abe01c54854$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $21e25abe01c54854$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$21e25abe01c54854$var$AES.prototype.decryptBlock = function(M) {
    M = $21e25abe01c54854$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $21e25abe01c54854$var$cryptBlock(M, this._invKeySchedule, $21e25abe01c54854$var$G.INV_SUB_MIX, $21e25abe01c54854$var$G.INV_SBOX, this._nRounds);
    var buf = $21e25abe01c54854$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$21e25abe01c54854$var$AES.prototype.scrub = function() {
    $21e25abe01c54854$var$scrubVec(this._keySchedule);
    $21e25abe01c54854$var$scrubVec(this._invKeySchedule);
    $21e25abe01c54854$var$scrubVec(this._key);
};
$21e25abe01c54854$export$b80fbe1c3a2b92b5 = $21e25abe01c54854$var$AES;

});

parcelRegister("695pH", function(module, exports) {

var $ZavwZ = parcelRequire("ZavwZ");
var $4797c8595858f50f$require$Buffer = $ZavwZ.Buffer;
var $4797c8595858f50f$var$ZEROES = $4797c8595858f50f$require$Buffer.alloc(16, 0);
function $4797c8595858f50f$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $4797c8595858f50f$var$fromArray(out) {
    var buf = $4797c8595858f50f$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $4797c8595858f50f$var$GHASH(key) {
    this.h = key;
    this.state = $4797c8595858f50f$require$Buffer.alloc(16, 0);
    this.cache = $4797c8595858f50f$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$4797c8595858f50f$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$4797c8595858f50f$var$GHASH.prototype._multiply = function() {
    var Vi = $4797c8595858f50f$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $4797c8595858f50f$var$fromArray(Zi);
};
$4797c8595858f50f$var$GHASH.prototype.update = function(buf) {
    this.cache = $4797c8595858f50f$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$4797c8595858f50f$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($4797c8595858f50f$require$Buffer.concat([
        this.cache,
        $4797c8595858f50f$var$ZEROES
    ], 16));
    this.ghash($4797c8595858f50f$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $4797c8595858f50f$var$GHASH;

});


parcelRegister("awHDR", function(module, exports) {

var $2UmCe = parcelRequire("2UmCe");

var $ZavwZ = parcelRequire("ZavwZ");
var $7a9ebeede6d359f6$require$Buffer = $ZavwZ.Buffer;

var $f2cqU = parcelRequire("f2cqU");

var $lfl9G = parcelRequire("lfl9G");
function $7a9ebeede6d359f6$var$StreamCipher(mode, key, iv, decrypt) {
    $f2cqU.call(this);
    this._cipher = new $2UmCe.AES(key);
    this._prev = $7a9ebeede6d359f6$require$Buffer.from(iv);
    this._cache = $7a9ebeede6d359f6$require$Buffer.allocUnsafe(0);
    this._secCache = $7a9ebeede6d359f6$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lfl9G($7a9ebeede6d359f6$var$StreamCipher, $f2cqU);
$7a9ebeede6d359f6$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$7a9ebeede6d359f6$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $7a9ebeede6d359f6$var$StreamCipher;

});


parcelRegister("3crQu", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $254817a05bcf63d1$export$12ada9414fbc594c, (v) => $254817a05bcf63d1$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $254817a05bcf63d1$export$36b6d6ef312eab39, (v) => $254817a05bcf63d1$export$36b6d6ef312eab39 = v);
var $254817a05bcf63d1$export$12ada9414fbc594c;
var $254817a05bcf63d1$export$36b6d6ef312eab39;

var $YAkqK = parcelRequire("YAkqK");

var $ZavwZ = parcelRequire("ZavwZ");
var $254817a05bcf63d1$require$Buffer = $ZavwZ.Buffer;

var $gkdoN = parcelRequire("gkdoN");

var $awHDR = parcelRequire("awHDR");

var $f2cqU = parcelRequire("f2cqU");

var $2UmCe = parcelRequire("2UmCe");

var $jAdOp = parcelRequire("jAdOp");

var $lfl9G = parcelRequire("lfl9G");
function $254817a05bcf63d1$var$Decipher(mode, key, iv) {
    $f2cqU.call(this);
    this._cache = new $254817a05bcf63d1$var$Splitter();
    this._last = void 0;
    this._cipher = new $2UmCe.AES(key);
    this._prev = $254817a05bcf63d1$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lfl9G($254817a05bcf63d1$var$Decipher, $f2cqU);
$254817a05bcf63d1$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $254817a05bcf63d1$require$Buffer.concat(out);
};
$254817a05bcf63d1$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $254817a05bcf63d1$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$254817a05bcf63d1$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $254817a05bcf63d1$var$Splitter() {
    this.cache = $254817a05bcf63d1$require$Buffer.allocUnsafe(0);
}
$254817a05bcf63d1$var$Splitter.prototype.add = function(data) {
    this.cache = $254817a05bcf63d1$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$254817a05bcf63d1$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$254817a05bcf63d1$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $254817a05bcf63d1$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $254817a05bcf63d1$var$createDecipheriv(suite, password, iv) {
    var config = $gkdoN[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $254817a05bcf63d1$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $254817a05bcf63d1$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $awHDR(config.module, password, iv, true);
    else if (config.type === "auth") return new $YAkqK(config.module, password, iv, true);
    return new $254817a05bcf63d1$var$Decipher(config.module, password, iv);
}
function $254817a05bcf63d1$var$createDecipher(suite, password) {
    var config = $gkdoN[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $jAdOp(password, false, config.key, config.iv);
    return $254817a05bcf63d1$var$createDecipheriv(suite, keys.key, keys.iv);
}
$254817a05bcf63d1$export$12ada9414fbc594c = $254817a05bcf63d1$var$createDecipher;
$254817a05bcf63d1$export$36b6d6ef312eab39 = $254817a05bcf63d1$var$createDecipheriv;

});



parcelRegister("32phK", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $23652c21e816e725$export$448fa22aedc9dbca, (v) => $23652c21e816e725$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $23652c21e816e725$export$b80c7ba289c8fa56, (v) => $23652c21e816e725$export$b80c7ba289c8fa56 = v);
var $23652c21e816e725$export$448fa22aedc9dbca;
var $23652c21e816e725$export$b80c7ba289c8fa56;

$23652c21e816e725$export$448fa22aedc9dbca = (parcelRequire("jnps3"));

$23652c21e816e725$export$b80c7ba289c8fa56 = (parcelRequire("4iSka"));

});


parcelRegister("uinvg", function(module, exports) {

var $lNfZR = parcelRequire("lNfZR");

var $ZavwZ = parcelRequire("ZavwZ");
var $05b10ef61f5ff551$require$Buffer = $ZavwZ.Buffer;
module.exports = function(seed, len) {
    var t = $05b10ef61f5ff551$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $05b10ef61f5ff551$var$i2ops(i++);
        t = $05b10ef61f5ff551$require$Buffer.concat([
            t,
            $lNfZR("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $05b10ef61f5ff551$var$i2ops(c) {
    var out = $05b10ef61f5ff551$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("7PYGg", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("1Ed8n", function(module, exports) {

var $7rVdb = parcelRequire("7rVdb");

var $ZavwZ = parcelRequire("ZavwZ");
var $1333b707053b2175$require$Buffer = $ZavwZ.Buffer;
function $1333b707053b2175$var$withPublic(paddedMsg, key) {
    return $1333b707053b2175$require$Buffer.from(paddedMsg.toRed($7rVdb.mont(key.modulus)).redPow(new $7rVdb(key.publicExponent)).fromRed().toArray());
}
module.exports = $1333b707053b2175$var$withPublic;

});

parcelRegister("dnOLj", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $9be4cca415cdab39$require$Buffer = $7ts9d.Buffer;

var $8NHEw = parcelRequire("8NHEw");

var $fxidi = parcelRequire("fxidi");
function $9be4cca415cdab39$var$blind(priv) {
    var r = $9be4cca415cdab39$var$getr(priv);
    var blinder = r.toRed($8NHEw.mont(priv.modulus)).redPow(new $8NHEw(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $9be4cca415cdab39$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $8NHEw($fxidi(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $9be4cca415cdab39$var$crt(msg, priv) {
    var blinds = $9be4cca415cdab39$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $8NHEw(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($8NHEw.mont(priv.prime1));
    var c2 = blinded.toRed($8NHEw.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($9be4cca415cdab39$require$Buffer, "be", len);
}
$9be4cca415cdab39$var$crt.getr = $9be4cca415cdab39$var$getr;
module.exports = $9be4cca415cdab39$var$crt;

});


parcelRegister("aDFYT", function(module, exports) {

var $70L5t = parcelRequire("70L5t");

var $uinvg = parcelRequire("uinvg");

var $7PYGg = parcelRequire("7PYGg");

var $7rVdb = parcelRequire("7rVdb");

var $dnOLj = parcelRequire("dnOLj");

var $lNfZR = parcelRequire("lNfZR");

var $1Ed8n = parcelRequire("1Ed8n");

var $ZavwZ = parcelRequire("ZavwZ");
var $7bee1c808511993f$require$Buffer = $ZavwZ.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $70L5t(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $7rVdb(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $1Ed8n(new $7rVdb(enc), key);
    else msg = $dnOLj(enc, key);
    var zBuffer = $7bee1c808511993f$require$Buffer.alloc(k - msg.length);
    msg = $7bee1c808511993f$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $7bee1c808511993f$var$oaep(key, msg);
    else if (padding === 1) return $7bee1c808511993f$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $7bee1c808511993f$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $lNfZR("sha1").update($7bee1c808511993f$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $7PYGg(maskedSeed, $uinvg(maskedDb, hLen));
    var db = $7PYGg(maskedDb, $uinvg(seed, k - hLen - 1));
    if ($7bee1c808511993f$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $7bee1c808511993f$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $7bee1c808511993f$var$compare(a, b) {
    a = $7bee1c808511993f$require$Buffer.from(a);
    b = $7bee1c808511993f$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("3J7bM", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("lV0Il", function(module, exports) {

$parcel$export(module.exports, "delimiter", () => $ff4f79b0e116b27e$export$c889f2fcc19dbf12, (v) => $ff4f79b0e116b27e$export$c889f2fcc19dbf12 = v);
$parcel$export(module.exports, "contentHash", () => $ff4f79b0e116b27e$export$f20700480466e009, (v) => $ff4f79b0e116b27e$export$f20700480466e009 = v);
$parcel$export(module.exports, "questionID", () => $ff4f79b0e116b27e$export$dfd90215ac769789, (v) => $ff4f79b0e116b27e$export$dfd90215ac769789 = v);
$parcel$export(module.exports, "minNumber", () => $ff4f79b0e116b27e$export$cc1f0f220e919ed5, (v) => $ff4f79b0e116b27e$export$cc1f0f220e919ed5 = v);
$parcel$export(module.exports, "maxNumber", () => $ff4f79b0e116b27e$export$3a96eb95738a0fa3, (v) => $ff4f79b0e116b27e$export$3a96eb95738a0fa3 = v);
$parcel$export(module.exports, "arrayToBitmaskBigNumber", () => $ff4f79b0e116b27e$export$1bc7119b586f92c1, (v) => $ff4f79b0e116b27e$export$1bc7119b586f92c1 = v);
$parcel$export(module.exports, "answerToBytes32", () => $ff4f79b0e116b27e$export$bba259304df5eeba, (v) => $ff4f79b0e116b27e$export$bba259304df5eeba = v);
$parcel$export(module.exports, "padToBytes32", () => $ff4f79b0e116b27e$export$d228f09c551aa445, (v) => $ff4f79b0e116b27e$export$d228f09c551aa445 = v);
$parcel$export(module.exports, "bytes32ToString", () => $ff4f79b0e116b27e$export$a207f137563e55d3, (v) => $ff4f79b0e116b27e$export$a207f137563e55d3 = v);
$parcel$export(module.exports, "convertTsToString", () => $ff4f79b0e116b27e$export$69d2450c58fe5d2f, (v) => $ff4f79b0e116b27e$export$69d2450c58fe5d2f = v);
$parcel$export(module.exports, "secondsTodHms", () => $ff4f79b0e116b27e$export$7090f1849d8029fc, (v) => $ff4f79b0e116b27e$export$7090f1849d8029fc = v);
$parcel$export(module.exports, "parseQuestionJSON", () => $ff4f79b0e116b27e$export$e948dcfce3015a87, (v) => $ff4f79b0e116b27e$export$e948dcfce3015a87 = v);
$parcel$export(module.exports, "populatedJSONForTemplate", () => $ff4f79b0e116b27e$export$47ddbe1b9ec886da, (v) => $ff4f79b0e116b27e$export$47ddbe1b9ec886da = v);
$parcel$export(module.exports, "encodeCustomText", () => $ff4f79b0e116b27e$export$a39d48c1407e394, (v) => $ff4f79b0e116b27e$export$a39d48c1407e394 = v);
$parcel$export(module.exports, "guessTemplateConfig", () => $ff4f79b0e116b27e$export$a32e9b36b0d3fa78, (v) => $ff4f79b0e116b27e$export$a32e9b36b0d3fa78 = v);
$parcel$export(module.exports, "encodeText", () => $ff4f79b0e116b27e$export$7d0d7672e8a1c5cf, (v) => $ff4f79b0e116b27e$export$7d0d7672e8a1c5cf = v);
$parcel$export(module.exports, "getInvalidValue", () => $ff4f79b0e116b27e$export$29a6905318342909, (v) => $ff4f79b0e116b27e$export$29a6905318342909 = v);
$parcel$export(module.exports, "getAnsweredTooSoonValue", () => $ff4f79b0e116b27e$export$d5e76302a3421160, (v) => $ff4f79b0e116b27e$export$d5e76302a3421160 = v);
$parcel$export(module.exports, "getLanguage", () => $ff4f79b0e116b27e$export$64783e31db14f0ba, (v) => $ff4f79b0e116b27e$export$64783e31db14f0ba = v);
$parcel$export(module.exports, "hasInvalidOption", () => $ff4f79b0e116b27e$export$a03728fc9d60db26, (v) => $ff4f79b0e116b27e$export$a03728fc9d60db26 = v);
$parcel$export(module.exports, "hasAnsweredTooSoonOption", () => $ff4f79b0e116b27e$export$ef5b58ab43af2e60, (v) => $ff4f79b0e116b27e$export$ef5b58ab43af2e60 = v);
$parcel$export(module.exports, "getAnswerString", () => $ff4f79b0e116b27e$export$321a1787328666ce, (v) => $ff4f79b0e116b27e$export$321a1787328666ce = v);
$parcel$export(module.exports, "commitmentID", () => $ff4f79b0e116b27e$export$e2966b5ccc06009a, (v) => $ff4f79b0e116b27e$export$e2966b5ccc06009a = v);
$parcel$export(module.exports, "answerHash", () => $ff4f79b0e116b27e$export$4be02efda3cf9672, (v) => $ff4f79b0e116b27e$export$4be02efda3cf9672 = v);
var $ff4f79b0e116b27e$export$c889f2fcc19dbf12;
var $ff4f79b0e116b27e$export$f20700480466e009;
var $ff4f79b0e116b27e$export$dfd90215ac769789;
var $ff4f79b0e116b27e$export$cc1f0f220e919ed5;
var $ff4f79b0e116b27e$export$3a96eb95738a0fa3;
var $ff4f79b0e116b27e$export$1bc7119b586f92c1;
var $ff4f79b0e116b27e$export$bba259304df5eeba;
var $ff4f79b0e116b27e$export$a207f137563e55d3;
var $ff4f79b0e116b27e$export$d228f09c551aa445;
var $ff4f79b0e116b27e$export$69d2450c58fe5d2f;
var $ff4f79b0e116b27e$export$7090f1849d8029fc;
var $ff4f79b0e116b27e$export$e948dcfce3015a87;
var $ff4f79b0e116b27e$export$47ddbe1b9ec886da;
// Encode text, assuming the template has placeholders in the order specified in the params.
// Additional information about the template can be passed in as template_definitions.
// If not specified, we'll assume it works like our standard built-in templates.
var $ff4f79b0e116b27e$export$a39d48c1407e394;
var $ff4f79b0e116b27e$export$a32e9b36b0d3fa78;
var $ff4f79b0e116b27e$export$7d0d7672e8a1c5cf;
// A value used to denote that the question is invalid or can't be answered
var $ff4f79b0e116b27e$export$29a6905318342909;
// A value used to denote that the question is invalid or can't be answered
var $ff4f79b0e116b27e$export$d5e76302a3421160;
var $ff4f79b0e116b27e$export$64783e31db14f0ba;
var $ff4f79b0e116b27e$export$a03728fc9d60db26;
var $ff4f79b0e116b27e$export$ef5b58ab43af2e60;
var $ff4f79b0e116b27e$export$321a1787328666ce;
var $ff4f79b0e116b27e$export$e2966b5ccc06009a;
var $ff4f79b0e116b27e$export$4be02efda3cf9672;
"use strict;";

var $gCFJT = parcelRequire("gCFJT");

var $6c6Fl = parcelRequire("6c6Fl");

var $fX5pE = parcelRequire("fX5pE");

var $exiBu = parcelRequire("exiBu");
var $ff4f79b0e116b27e$require$vsprintf = $exiBu.vsprintf;
const $ff4f79b0e116b27e$var$QUESTION_MAX_OUTCOMES = 128;
const $ff4f79b0e116b27e$var$TEMPLATE_MAX_PLACEHOLDERS = 128;

var $i5cDi = parcelRequire("i5cDi");

var $lqIGV = parcelRequire("lqIGV");

var $5VA3M = parcelRequire("5VA3M");
var $ff4f79b0e116b27e$require$convert = $5VA3M.convert;
$i5cDi.setOptions({
    headerIds: false
});
$ff4f79b0e116b27e$export$c889f2fcc19dbf12 = function() {
    return "\u241F"; // Thought about '\u0000' but it seems to break something;
};
$ff4f79b0e116b27e$export$f20700480466e009 = function(template_id, opening_ts, content) {
    return "0x" + $fX5pE.soliditySHA3([
        "uint256",
        "uint32",
        "string"
    ], [
        new $gCFJT(template_id),
        new $gCFJT(opening_ts),
        content
    ]).toString("hex");
};
$ff4f79b0e116b27e$export$dfd90215ac769789 = function(template_id, question, arbitrator, timeout, opening_ts, sender, nonce, min_bond, contract, version) {
    // If there's a min_bond or a contract, insist we also get a version parameter
    if (typeof version === "undefined") {
        if (typeof min_bond === "string" || typeof contract === "string") throw Error("Version not defined");
    }
    if (!version) version = "2.0";
    const vernum = parseInt(version);
    if (isNaN(vernum) || vernum < 2 || vernum > 4) throw Error("Version not recognized");
    if (vernum >= 3) {
        if (typeof min_bond !== "string") throw Error('min_bond not supplied or invalid. Required in v3. Pass "0x0" for a zero bond');
    }
    var content_hash = $ff4f79b0e116b27e$export$f20700480466e009(template_id, opening_ts, question);
    let qid;
    if (vernum < 3) qid = $fX5pE.soliditySHA3(//["bytes32", "address", "uint256", "address", "uint256"],
    [
        "uint256",
        "address",
        "uint32",
        "address",
        "uint256"
    ], [
        new $gCFJT(content_hash.replace(/^0x/, ""), 16),
        arbitrator,
        new $gCFJT(timeout),
        sender,
        new $gCFJT(nonce)
    ]);
    else // bytes32 question_id = keccak256(abi.encodePacked(content_hash, arbitrator, timeout, uint256(min_bond), address(this), msg.sender, nonce));
    qid = $fX5pE.soliditySHA3([
        "uint256",
        "address",
        "uint32",
        "uint256",
        "address",
        "address",
        "uint256"
    ], [
        new $gCFJT(content_hash.replace(/^0x/, ""), 16),
        arbitrator,
        new $gCFJT(timeout),
        new $gCFJT(min_bond.replace(/^0x/, ""), 16),
        contract,
        sender,
        new $gCFJT(nonce)
    ]);
    // The seems to be something wrong with how soliditySHA3 handles bytes32, so tell it we gave it uint256
    return "0x" + qid.toString("hex");
};
$ff4f79b0e116b27e$export$cc1f0f220e919ed5 = function(qjson) {
    var is_signed = qjson["type"] == "int";
    if (!is_signed) return new $6c6Fl(0);
    return $ff4f79b0e116b27e$export$3a96eb95738a0fa3(qjson).neg();
};
$ff4f79b0e116b27e$export$3a96eb95738a0fa3 = function(qjson) {
    var is_signed = qjson["type"] == "int";
    var divby = new $6c6Fl(1);
    if (qjson["decimals"]) divby = new $6c6Fl(10).pow(new $6c6Fl(qjson["decimals"]));
    if (is_signed) divby = divby.times(2);
    return new $6c6Fl("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff").dividedBy(divby);
};
$ff4f79b0e116b27e$export$1bc7119b586f92c1 = function(selections) {
    // console.log('selections are ', selections);
    var bitstr = "";
    for(var i = 0; i < selections.length; i++){
        var item = selections[i] ? "1" : "0";
        bitstr = item + bitstr;
    }
    //console.log('bitstr',bitstr);
    return new $6c6Fl(bitstr, 2);
};
$ff4f79b0e116b27e$export$bba259304df5eeba = function(answer, qjson) {
    var qtype = qjson["type"];
    if (qtype == "multiple-select") answer = $ff4f79b0e116b27e$export$1bc7119b586f92c1(answer);
    var decimals = qtype == "uint" ? parseInt(qjson["decimals"]) : 0;
    if (!decimals) decimals = 0;
    if (decimals > 0) {
        var multiplier = new $6c6Fl(10).pow(new $6c6Fl(decimals));
        answer = new $6c6Fl(answer).times(multiplier).toString(16);
    }
    //console.log('muliplied to ',answer.toString());
    var bn;
    if (qtype == "int") bn = new $gCFJT(answer, 16).toTwos(256);
    else if (qtype == "uint") bn = new $gCFJT(answer, 16);
    else return $ff4f79b0e116b27e$export$d228f09c551aa445(new $6c6Fl(answer).toString(16));
    return $ff4f79b0e116b27e$export$d228f09c551aa445(bn.toString(16));
};
$ff4f79b0e116b27e$export$a207f137563e55d3 = function(bytes32str, qjson) {
    var qtype = qjson["type"];
    var decimals = parseInt(qjson["decimals"]);
    if (!decimals) decimals = 0;
    bytes32str = bytes32str.replace(/^0x/, "");
    var bn;
    if (qtype == "int") var bn = new $gCFJT(bytes32str, 16).fromTwos(256);
    else if (qtype == "uint" || qtype == "datetime") var bn = new $gCFJT(bytes32str, 16);
    else throw Error("Unrecognized answer type " + qtype);
    var ans = bn.toString();
    // Do the decimals with BigNumber as it seems to work better
    if (decimals > 0) {
        var multiplier = new $6c6Fl(10).pow(new $6c6Fl(decimals));
        ans = new $6c6Fl(ans).dividedBy(multiplier).toString();
    }
    return ans.toString();
};
$ff4f79b0e116b27e$export$d228f09c551aa445 = function(n, raw) {
    while(n.length < 64)n = "0" + n;
    if (raw) return n;
    return "0x" + n;
};
$ff4f79b0e116b27e$export$69d2450c58fe5d2f = function(ts) {
    if (typeof ts.toNumber === "function") ts = ts.toNumber();
    let date = new Date();
    date.setTime(ts * 1000);
    return date.toISOString();
};
$ff4f79b0e116b27e$export$7090f1849d8029fc = function(sec) {
    sec = Number(sec);
    let d = Math.floor(sec / 86400);
    let h = Math.floor(sec % 86400 / 3600);
    let m = Math.floor(sec % 86400 % 3600 / 60);
    let s = Math.floor(sec % 86400 % 3600 % 60);
    let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
    let hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
    let mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
    let sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
};
$ff4f79b0e116b27e$export$e948dcfce3015a87 = function(data, errors_to_title) {
    // Strip unicode null-terminated-string control characters if there are any.
    // These seem to be stripped already if we got data via The Graph, and only passed to us on RPC.
    data = data.replace(/\u0000/g, "");
    var question_json;
    try {
        question_json = JSON.parse(data);
    } catch (e) {
        question_json = {
            "title": "[Badly formatted question]: " + data,
            "type": "broken-question",
            "errors": {
                "json_parse_failed": true
            }
        };
    }
    if (question_json["outcomes"] && question_json["outcomes"].length > $ff4f79b0e116b27e$var$QUESTION_MAX_OUTCOMES) {
        if (!question_json["errors"]) question_json["errors"] = {};
        question_json["errors"]["too_many_outcomes"] = true;
    }
    if ("type" in question_json && question_json["type"] == "datetime" && "precision" in question_json) {
        if (![
            "Y",
            "m",
            "d",
            "H",
            "i",
            "s"
        ].includes(question_json["precision"])) {
            if (!question_json["errors"]) question_json["errors"] = {};
            question_json["errors"]["invalid_precision"] = true;
        }
    }
    // If errors_to_title is specified, we add any error message to the title to make sure we don't lose it
    if (errors_to_title) {
        if ("errors" in question_json) {
            const prependers = {
                "invalid_precision": "Invalid date format",
                "too_many_outcomes": "Too many outcomes"
            };
            for(const e in question_json["errors"])if (e in prependers) question_json["title"] = "[" + prependers[e] + "] " + question_json["title"];
        }
    }
    if (!question_json["format"]) question_json["format"] = "text/plain";
    if (question_json["format"] == "text/plain") question_json["title_text"] = question_json["title"];
    else if (question_json["format"] == "text/markdown") try {
        const safeMarkdown = $lqIGV.sanitize(question_json["title"], {
            USE_PROFILES: {
                html: false
            }
        });
        if (safeMarkdown !== question_json["title"]) {
            if (!question_json["errors"]) question_json["errors"] = {};
            question_json["errors"]["unsafe_markdown"] = true;
        } else {
            question_json["title_html"] = $i5cDi.parse(safeMarkdown).replace(/<img.*src=\"(.*?)\".*alt=\"(.*?)\".*\/?>/, '<a href="$1">$2</a>');
            question_json["title_text"] = $ff4f79b0e116b27e$require$convert(question_json["title_html"], {
                selectors: [
                    {
                        selector: "h1",
                        options: {
                            uppercase: false
                        }
                    },
                    {
                        selector: "h2",
                        options: {
                            uppercase: false
                        }
                    },
                    {
                        selector: "hr",
                        format: "skip"
                    }
                ]
            });
        }
    } catch (e) {
        if (!question_json["errors"]) question_json["errors"] = {};
        question_json["errors"]["markdown_parse_failed"] = true;
    }
    else {
        if (!question_json["errors"]) question_json["errors"] = {};
        question_json["errors"]["invalid_format"] = true;
    }
    // If errors_to_title is specified, we add any error message to the title to make sure we don't lose it
    if (errors_to_title) {
        if ("errors" in question_json) {
            const prependers = {
                "invalid_format": "Invalid format",
                "unsafe_markdown": "Unsafe markdown",
                "markdown_parse_failed": "Bad markdown parse"
            };
            for(const e in question_json["errors"])if (e in prependers) question_json["title"] = "[" + prependers[e] + "] " + question_json["title"];
        }
    }
    return question_json;
};
$ff4f79b0e116b27e$export$47ddbe1b9ec886da = function(template, question, errors_to_title) {
    var qbits = question.split($ff4f79b0e116b27e$export$c889f2fcc19dbf12());
    //console.log('pp', template);
    //console.log('qbits', qbits);
    var interpolated = $ff4f79b0e116b27e$require$vsprintf(template, qbits);
    //console.log('resulting template', interpolated);
    return $ff4f79b0e116b27e$export$e948dcfce3015a87(interpolated, errors_to_title);
};
$ff4f79b0e116b27e$export$a39d48c1407e394 = function(params) {
    var items = [];
    for(const p in params){
        var val = params[p];
        if (typeof val === "string") // Stringify puts quotation marks around the string, so strip them
        val = JSON.stringify(val).replace(/^"|"$/g, "");
        else if (typeof val === "object") // An array of values should be stringified as a JSON array.
        // However template should do "outcomes: [%s]" instead of "outcomes: %s".
        // In that case strip the closing brackets.
        val = JSON.stringify(val).replace(/^\[/, "").replace(/\]$/, "");
        else val = null;
        items.push(val);
    }
    const ret = items.join($ff4f79b0e116b27e$export$c889f2fcc19dbf12());
    return ret;
};
$ff4f79b0e116b27e$export$a32e9b36b0d3fa78 = function(template) {
    // Use the hash of the template as a temporary placeholder
    // Since you can't hash yourself we can be confident this won't collide.
    const placeholder = "0x" + $fX5pE.soliditySHA3([
        "string"
    ], [
        template
    ]).toString("hex");
    const arr_placeholder = "0x" + $fX5pE.soliditySHA3([
        "string"
    ], [
        template + "_arr"
    ]).toString("hex");
    var pl_arr = new Array($ff4f79b0e116b27e$var$TEMPLATE_MAX_PLACEHOLDERS);
    pl_arr.fill(placeholder);
    var interpolated = $ff4f79b0e116b27e$require$vsprintf(template, pl_arr);
    // Quote the placeholders in any arrays that didn't originally have quotes
    interpolated = interpolated.replaceAll("[" + placeholder + "]", '"' + arr_placeholder + '"');
    const fake_json = $ff4f79b0e116b27e$export$e948dcfce3015a87(interpolated, false);
    /*
    Meta example:
    {
        'labels': {'dog': 'Dogs', 'cat': 'Cats'},
        'tags': {'2': 'dog'}
        'defaults': {'lang': 'en_US'}
    }
    */ // If there's a section called __META, use that for titling columns etc
    var meta = "__META" in fake_json ? fake_json["__META"] : {};
    var labels = "labels" in meta ? meta["labels"] : {};
    var fields = {};
    for(const k in fake_json){
        if (k == "title_text" || k == "title_html" || k == "__META") continue;
        // We assume that every placeholder is either the value for a field, or contained in it.
        // ie we handle
        //    "myfield": "%s"
        //    "myfield": "A %s and another %s."
        //    "myfield": [%s]
        var fdef = {};
        fdef["label"] = k in labels ? labels[k] : k;
        const regexp = new RegExp("(" + placeholder + "|" + arr_placeholder + ")");
        //const regexp = new RegExp('('+placeholder+')');
        const bits = fake_json[k].split(regexp);
        // console.log(bits);
        var parts = [];
        var part_i = 0;
        for(const b in bits){
            if (bits[b] == "") continue;
            if (bits[b] == placeholder || bits[b] == arr_placeholder) {
                let part_label = k + "_" + part_i;
                if (part_label in labels) part_label = labels[part_label];
                if (bits[b] == placeholder) parts.push({
                    "part": "parameter",
                    "part_index": part_i,
                    "label": part_label
                });
                else parts.push({
                    "part": "array_parameter",
                    "part_index": part_i,
                    "label": part_label
                });
                part_i++;
            } else parts.push({
                "part": "text",
                "value": bits[b]
            });
        }
        fdef["parts"] = parts;
        fields[k] = fdef;
    }
    var tags = {};
    if ("tags" in meta) tags = meta["tags"];
    return {
        "fields": fields,
        "tags": tags
    };
};
$ff4f79b0e116b27e$export$7d0d7672e8a1c5cf = function(qtype, txt, outcomes, category, lang) {
    var def = {};
    def["title"] = txt;
    if (qtype == "single-select" || qtype == "multiple-select") def["outcomes"] = outcomes;
    def["category"] = category;
    def["lang"] = lang;
    return $ff4f79b0e116b27e$export$a39d48c1407e394(def);
};
$ff4f79b0e116b27e$export$29a6905318342909 = function(question_json) {
    // equivalent to -1 in twos complement
    return "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
};
$ff4f79b0e116b27e$export$d5e76302a3421160 = function(question_json) {
    // equivalent to -2 in twos complement
    return "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe";
};
$ff4f79b0e116b27e$export$64783e31db14f0ba = function(question_json) {
    if (typeof question_json["lang"] == "undefined" || question_json["lang"] == "") return "en_US";
    return question_json["lang"];
};
$ff4f79b0e116b27e$export$a03728fc9d60db26 = function(question_json, contract_version) {
    return !("has_invalid" in question_json && !question_json["has_invalid"]);
};
$ff4f79b0e116b27e$export$ef5b58ab43af2e60 = function(question_json, contract_version) {
    const bits = contract_version.split(".");
    return parseInt(bits[0]) >= 3;
};
$ff4f79b0e116b27e$export$321a1787328666ce = function(question_json, answer) {
    if (answer === null) return "null";
    if (answer == $ff4f79b0e116b27e$export$29a6905318342909(question_json)) return "Invalid";
    if (answer == $ff4f79b0e116b27e$export$d5e76302a3421160(question_json)) return "Answered too soon";
    var label = "";
    switch(question_json["type"]){
        case "uint":
            label = $ff4f79b0e116b27e$export$a207f137563e55d3(answer, question_json);
            break;
        case "int":
            label = $ff4f79b0e116b27e$export$a207f137563e55d3(answer, question_json);
            break;
        case "bool":
            if (new $6c6Fl(answer).toNumber() === 1) label = "Yes";
            else if (new $6c6Fl(answer).toNumber() === 0) label = "No";
            break;
        case "single-select":
            if (typeof question_json["outcomes"] !== "undefined" && question_json["outcomes"].length > 0) {
                var idx = new $6c6Fl(answer).toNumber();
                label = question_json["outcomes"][idx];
            }
            break;
        case "multiple-select":
            if (typeof question_json["outcomes"] !== "undefined" && question_json["outcomes"].length > 0) {
                var answer_bits = new $6c6Fl(answer).toString(2);
                var length = answer_bits.length;
                var entries = [];
                for(var i = question_json["outcomes"].length - 1; i >= 0; i--)if (answer_bits[i] === "1") {
                    var idx = answer_bits.length - 1 - i;
                    entries.push(question_json["outcomes"][idx]);
                }
                return entries.join(" / ");
            }
            break;
        case "datetime":
            let precision = "d";
            if ("precision" in question_json && [
                "Y",
                "m",
                "d",
                "H",
                "i",
                "s"
            ].includes(question_json["precision"])) precision = question_json["precision"];
            let ts = parseInt($ff4f79b0e116b27e$export$a207f137563e55d3(answer, question_json));
            let dateObj = new Date(ts * 1000);
            const year = dateObj.getUTCFullYear();
            const month = dateObj.getUTCMonth() + 1;
            const date = dateObj.getUTCDate();
            const hour = dateObj.getUTCHours();
            const min = dateObj.getUTCMinutes();
            const sec = dateObj.getUTCSeconds();
            // We need whatever the precision states, plus anything above
            const needy = true;
            const needm = precision != "Y";
            const needd = needm && precision != "m";
            const needH = needd && precision != "d";
            const needi = needH && precision != "H";
            const needs = needi && precision != "i";
            // If anything is set then we've got it.
            // We also consider that anything required by the precision is there, but set to 0
            const hass = needs || sec > 0;
            const hasi = needi || hass || min > 0;
            const hasH = needH || hasi || hour > 0;
            const hasd = needd || hasH || date > 1;
            const hasm = needm || hasd || month > 1;
            const hasy = true;
            // We'll show an invalid warning if we've got a more precise date than the precision demands
            let invalid = false;
            if (!needm && hasm) invalid = true;
            if (!needd && hasd) invalid = true;
            if (!needH && hasH) invalid = true;
            if (!needi && hasi) invalid = true;
            if (!needs && hass) invalid = true;
            if (invalid) label = "[Invalid datetime]: ";
            function pad2(n) {
                return ("0" + n).slice(-2);
            }
            if (hasy) label += year;
            if (hasm) label += "-" + pad2(month);
            if (hasd) label += "-" + pad2(date);
            if (hasH) label += " " + pad2(hour);
            if (hasi) label += ":" + pad2(min);
            else if (hasH) // "2021-12-23 11" without the minutes at the end is hard to understand so add "hr"
            label += "hr";
            if (hass) label += ":" + pad2(sec);
            break;
    }
    return label;
};
$ff4f79b0e116b27e$export$e2966b5ccc06009a = function(question_id, answer_hash, bond) {
    const bond_hex = typeof bond === "string" ? bond : bond.toString(16);
    return "0x" + $fX5pE.soliditySHA3([
        "uint256",
        "uint256",
        "uint256"
    ], [
        new $gCFJT(question_id.replace(/^0x/, ""), 16),
        new $gCFJT(answer_hash.replace(/^0x/, ""), 16),
        new $gCFJT(bond_hex.replace(/^0x/, ""), 16)
    ]).toString("hex");
};
$ff4f79b0e116b27e$export$4be02efda3cf9672 = function(answer_plaintext, nonce) {
    return "0x" + $fX5pE.soliditySHA3([
        "uint256",
        "uint256"
    ], [
        new $gCFJT(answer_plaintext.replace(/^0x/, ""), 16),
        new $gCFJT(nonce.replace(/^0x/, ""), 16)
    ]).toString("hex");
};

});
parcelRegister("gCFJT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("6c6Fl", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            decimalSeparator: ".",
            groupSeparator: ",",
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            fractionGroupSize: 0
        }, // The alphabet used for base conversion.
        // It must be at least 2 characters long, with no '.' or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor usage without new.
            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
            // '[BigNumber Error] Constructor call without new: {n}'
            //throw Error(bignumberError + ' Constructor call without new: ' + n);
            return new BigNumber(n, b);
            if (b == null) {
                // Duplicate.
                if (n instanceof BigNumber) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = (n = n.c) ? n.slice() : n;
                    return;
                }
                isNum = typeof n == "number";
                if (isNum && n * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                    // Faster path for integers.
                    if (n === ~~n) {
                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                        x.e = e;
                        x.c = [
                            n
                        ];
                        return;
                    }
                    str = n + "";
                } else {
                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                str = n + "";
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10) {
                    x = new BigNumber(n instanceof BigNumber ? n : str);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                isNum = typeof n == "number";
                if (isNum) {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                    // Prevent later check for length on converted number.
                    isNum = false;
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, n + "", isNum, b);
                }
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            str = str.slice(i, ++len);
            if (str) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                e = e - i - 1;
                // Overflow?
                if (e > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE;
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if only one character, or contains '.' or a repeated character.
                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                        else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
            return v instanceof BigNumber || v && v._isBigNumber === true || false;
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var m, n, i = 0;
            if (isArray(args[0])) args = args[0];
            m = new BigNumber(args[0]);
            for(; ++i < args.length;){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) {
                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                    x.c = x.e = null;
                } else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.c = x.e = x.s = null;
                }
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                nIsOdd = isOdd(n);
            } else nIsOdd = n % 2;
            if (nIsNeg) n.s = 1;
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (nIsBig) {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (!n.c[0]) break;
                    nIsBig = n.e > 14;
                    nIsOdd = isOdd(n);
                } else {
                    n = mathfloor(n / 2);
                    if (!n) break;
                    nIsOdd = n % 2;
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+x);
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "1e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
            var str = this.toFixed(dp, rm);
            if (this.c) {
                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
            }
            return str;
        };
        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
            }
            if (!xc) return x.toString();
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e *= 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1.toString(),
                d1.toString()
            ] : [
                n0.toString(),
                d0.toString()
            ];
            MAX_EXP = exp;
            return arr;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +this;
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                str = coeffToString(n.c);
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            var str, n = this, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
    }
    function isArray(obj) {
        return Object.prototype.toString.call(obj) == "[object Array]";
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("fX5pE", function(module, exports) {

module.exports = (parcelRequire("kxJxa"));

});
parcelRegister("kxJxa", function(module, exports) {
/* eslint-disable no-useless-escape */ 
var $7ts9d = parcelRequire("7ts9d");
var $ef4a35cad960b877$require$Buffer = $7ts9d.Buffer;

var $5Q6LK = parcelRequire("5Q6LK");

var $7rVdb = parcelRequire("7rVdb");
var $ef4a35cad960b877$var$ABI = function() {};
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function $ef4a35cad960b877$var$elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
$ef4a35cad960b877$var$ABI.eventID = function(name, types) {
    // FIXME: use node.js util.format?
    var sig = name + "(" + types.map($ef4a35cad960b877$var$elementaryName).join(",") + ")";
    return $5Q6LK.keccak256($ef4a35cad960b877$require$Buffer.from(sig));
};
$ef4a35cad960b877$var$ABI.methodID = function(name, types) {
    return $ef4a35cad960b877$var$ABI.eventID(name, types).slice(0, 4);
};
// Parse N from type<N>
function $ef4a35cad960b877$var$parseTypeN(type) {
    return parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function $ef4a35cad960b877$var$parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        parseInt(tmp[1], 10),
        parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function $ef4a35cad960b877$var$parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : parseInt(tmp[2], 10);
    return null;
}
function $ef4a35cad960b877$var$parseNumber(arg) {
    var type = typeof arg;
    if (type === "string") {
        if ($5Q6LK.isHexPrefixed(arg)) return new $7rVdb($5Q6LK.stripHexPrefix(arg), 16);
        else return new $7rVdb(arg, 10);
    } else if (type === "number") return new $7rVdb(arg);
    else if (arg.toArray) // assume this is a BN for the moment, replace with BN.isBN soon
    return arg;
    else throw new Error("Argument is not a number");
}
// someMethod(bytes,uint)
// someMethod(bytes,uint):(boolean)
function $ef4a35cad960b877$var$parseSignature(sig) {
    var tmp = /^(\w+)\((.*)\)$/.exec(sig);
    if (tmp.length !== 3) throw new Error("Invalid method signature");
    var args = /^(.+)\):\((.+)$/.exec(tmp[2]);
    if (args !== null && args.length === 3) return {
        method: tmp[1],
        args: args[1].split(","),
        retargs: args[2].split(",")
    };
    else {
        var params = tmp[2].split(",");
        if (params.length === 1 && params[0] === "") // Special-case (possibly naive) fixup for functions that take no arguments.
        // TODO: special cases are always bad, but this makes the function return
        // match what the calling functions expect
        params = [];
        return {
            method: tmp[1],
            args: params
        };
    }
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function $ef4a35cad960b877$var$encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return $ef4a35cad960b877$var$encodeSingle("uint160", $ef4a35cad960b877$var$parseNumber(arg));
    else if (type === "bool") return $ef4a35cad960b877$var$encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return $ef4a35cad960b877$var$encodeSingle("bytes", $ef4a35cad960b877$require$Buffer.from(arg, "utf8"));
    else if ($ef4a35cad960b877$var$isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = $ef4a35cad960b877$var$parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push($ef4a35cad960b877$var$encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = $ef4a35cad960b877$var$encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return $ef4a35cad960b877$require$Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = $ef4a35cad960b877$require$Buffer.from(arg);
        ret = $ef4a35cad960b877$require$Buffer.concat([
            $ef4a35cad960b877$var$encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = $ef4a35cad960b877$require$Buffer.concat([
            ret,
            $5Q6LK.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return $5Q6LK.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = $ef4a35cad960b877$var$parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num < 0) throw new Error("Supplied uint is negative");
        return num.toArrayLike($ef4a35cad960b877$require$Buffer, "be", 32);
    } else if (type.startsWith("int")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = $ef4a35cad960b877$var$parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        return num.toTwos(256).toArrayLike($ef4a35cad960b877$require$Buffer, "be", 32);
    } else if (type.startsWith("ufixed")) {
        size = $ef4a35cad960b877$var$parseTypeNxM(type);
        num = $ef4a35cad960b877$var$parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return $ef4a35cad960b877$var$encodeSingle("uint256", num.mul(new $7rVdb(2).pow(new $7rVdb(size[1]))));
    } else if (type.startsWith("fixed")) {
        size = $ef4a35cad960b877$var$parseTypeNxM(type);
        return $ef4a35cad960b877$var$encodeSingle("int256", $ef4a35cad960b877$var$parseNumber(arg).mul(new $7rVdb(2).pow(new $7rVdb(size[1]))));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Decodes a single item (can be dynamic array)
// @returns: array
// FIXME: this method will need a lot of attention at checking limits and validation
function $ef4a35cad960b877$var$decodeSingle(parsedType, data, offset) {
    if (typeof parsedType === "string") parsedType = $ef4a35cad960b877$var$parseType(parsedType);
    var size, num, ret, i;
    if (parsedType.name === "address") return $ef4a35cad960b877$var$decodeSingle(parsedType.rawType, data, offset).toArrayLike($ef4a35cad960b877$require$Buffer, "be", 20).toString("hex");
    else if (parsedType.name === "bool") return $ef4a35cad960b877$var$decodeSingle(parsedType.rawType, data, offset).toString() === new $7rVdb(1).toString();
    else if (parsedType.name === "string") {
        var bytes = $ef4a35cad960b877$var$decodeSingle(parsedType.rawType, data, offset);
        return $ef4a35cad960b877$require$Buffer.from(bytes, "utf8").toString();
    } else if (parsedType.isArray) {
        // this part handles fixed-length arrays ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        ret = [];
        size = parsedType.size;
        if (parsedType.size === "dynamic") {
            offset = $ef4a35cad960b877$var$decodeSingle("uint256", data, offset).toNumber();
            size = $ef4a35cad960b877$var$decodeSingle("uint256", data, offset).toNumber();
            offset = offset + 32;
        }
        for(i = 0; i < size; i++){
            var decoded = $ef4a35cad960b877$var$decodeSingle(parsedType.subArray, data, offset);
            ret.push(decoded);
            offset += parsedType.subArray.memoryUsage;
        }
        return ret;
    } else if (parsedType.name === "bytes") {
        offset = $ef4a35cad960b877$var$decodeSingle("uint256", data, offset).toNumber();
        size = $ef4a35cad960b877$var$decodeSingle("uint256", data, offset).toNumber();
        return data.slice(offset + 32, offset + 32 + size);
    } else if (parsedType.name.startsWith("bytes")) return data.slice(offset, offset + parsedType.size);
    else if (parsedType.name.startsWith("uint")) {
        num = new $7rVdb(data.slice(offset, offset + 32), 16, "be");
        if (num.bitLength() > parsedType.size) throw new Error("Decoded int exceeds width: " + parsedType.size + " vs " + num.bitLength());
        return num;
    } else if (parsedType.name.startsWith("int")) {
        num = new $7rVdb(data.slice(offset, offset + 32), 16, "be").fromTwos(256);
        if (num.bitLength() > parsedType.size) throw new Error("Decoded uint exceeds width: " + parsedType.size + " vs " + num.bitLength());
        return num;
    } else if (parsedType.name.startsWith("ufixed")) {
        size = new $7rVdb(2).pow(new $7rVdb(parsedType.size[1]));
        num = $ef4a35cad960b877$var$decodeSingle("uint256", data, offset);
        if (!num.mod(size).isZero()) throw new Error("Decimals not supported yet");
        return num.div(size);
    } else if (parsedType.name.startsWith("fixed")) {
        size = new $7rVdb(2).pow(new $7rVdb(parsedType.size[1]));
        num = $ef4a35cad960b877$var$decodeSingle("int256", data, offset);
        if (!num.mod(size).isZero()) throw new Error("Decimals not supported yet");
        return num.div(size);
    }
    throw new Error("Unsupported or invalid type: " + parsedType.name);
}
// Parse the given type
// @returns: {} containing the type itself, memory usage and (including size and subArray if applicable)
function $ef4a35cad960b877$var$parseType(type) {
    var size;
    var ret;
    if ($ef4a35cad960b877$var$isArray(type)) {
        size = $ef4a35cad960b877$var$parseTypeArray(type);
        var subArray = type.slice(0, type.lastIndexOf("["));
        subArray = $ef4a35cad960b877$var$parseType(subArray);
        ret = {
            isArray: true,
            name: type,
            size: size,
            memoryUsage: size === "dynamic" ? 32 : subArray.memoryUsage * size,
            subArray: subArray
        };
        return ret;
    } else {
        var rawType;
        switch(type){
            case "address":
                rawType = "uint160";
                break;
            case "bool":
                rawType = "uint8";
                break;
            case "string":
                rawType = "bytes";
                break;
        }
        ret = {
            rawType: rawType,
            name: type,
            memoryUsage: 32
        };
        if (type.startsWith("bytes") && type !== "bytes" || type.startsWith("uint") || type.startsWith("int")) ret.size = $ef4a35cad960b877$var$parseTypeN(type);
        else if (type.startsWith("ufixed") || type.startsWith("fixed")) ret.size = $ef4a35cad960b877$var$parseTypeNxM(type);
        if (type.startsWith("bytes") && type !== "bytes" && (ret.size < 1 || ret.size > 32)) throw new Error("Invalid bytes<N> width: " + ret.size);
        if ((type.startsWith("uint") || type.startsWith("int")) && (ret.size % 8 || ret.size < 8 || ret.size > 256)) throw new Error("Invalid int/uint<N> width: " + ret.size);
        return ret;
    }
}
// Is a type dynamic?
function $ef4a35cad960b877$var$isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || $ef4a35cad960b877$var$parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function $ef4a35cad960b877$var$isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
$ef4a35cad960b877$var$ABI.rawEncode = function(types, values) {
    var output = [];
    var data = [];
    var headLength = 0;
    types.forEach(function(type) {
        if ($ef4a35cad960b877$var$isArray(type)) {
            var size = $ef4a35cad960b877$var$parseTypeArray(type);
            if (size !== "dynamic") headLength += 32 * size;
            else headLength += 32;
        } else headLength += 32;
    });
    for(var i = 0; i < types.length; i++){
        var type = $ef4a35cad960b877$var$elementaryName(types[i]);
        var value = values[i];
        var cur = $ef4a35cad960b877$var$encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if ($ef4a35cad960b877$var$isDynamic(type)) {
            output.push($ef4a35cad960b877$var$encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return $ef4a35cad960b877$require$Buffer.concat(output.concat(data));
};
$ef4a35cad960b877$var$ABI.rawDecode = function(types, data) {
    var ret = [];
    data = $ef4a35cad960b877$require$Buffer.from(data);
    var offset = 0;
    for(var i = 0; i < types.length; i++){
        var type = $ef4a35cad960b877$var$elementaryName(types[i]);
        var parsed = $ef4a35cad960b877$var$parseType(type, data, offset);
        var decoded = $ef4a35cad960b877$var$decodeSingle(parsed, data, offset);
        offset += parsed.memoryUsage;
        ret.push(decoded);
    }
    return ret;
};
$ef4a35cad960b877$var$ABI.simpleEncode = function(method) {
    var args = Array.prototype.slice.call(arguments).slice(1);
    var sig = $ef4a35cad960b877$var$parseSignature(method);
    // FIXME: validate/convert arguments
    if (args.length !== sig.args.length) throw new Error("Argument count mismatch");
    return $ef4a35cad960b877$require$Buffer.concat([
        $ef4a35cad960b877$var$ABI.methodID(sig.method, sig.args),
        $ef4a35cad960b877$var$ABI.rawEncode(sig.args, args)
    ]);
};
$ef4a35cad960b877$var$ABI.simpleDecode = function(method, data) {
    var sig = $ef4a35cad960b877$var$parseSignature(method);
    // FIXME: validate/convert arguments
    if (!sig.retargs) throw new Error("No return values in method");
    return $ef4a35cad960b877$var$ABI.rawDecode(sig.retargs, data);
};
function $ef4a35cad960b877$var$stringify(type, value) {
    if (type.startsWith("address") || type.startsWith("bytes")) return "0x" + value.toString("hex");
    else return value.toString();
}
$ef4a35cad960b877$var$ABI.stringify = function(types, values) {
    var ret = [];
    for(var i in types){
        var type = types[i];
        var value = values[i];
        // if it is an array type, concat the items
        if (/^[^\[]+\[.*\]$/.test(type)) value = value.map(function(item) {
            return $ef4a35cad960b877$var$stringify(type, item);
        }).join(", ");
        else value = $ef4a35cad960b877$var$stringify(type, value);
        ret.push(value);
    }
    return ret;
};
$ef4a35cad960b877$var$ABI.solidityHexValue = function(type, value, bitsize) {
    // pass in bitsize = null if use default bitsize
    var size, num;
    if ($ef4a35cad960b877$var$isArray(type)) {
        var subType = type.replace(/\[.*?\]/, "");
        if (!$ef4a35cad960b877$var$isArray(subType)) {
            var arraySize = $ef4a35cad960b877$var$parseTypeArray(type);
            if (arraySize !== "dynamic" && arraySize !== 0 && value.length > arraySize) throw new Error("Elements exceed array size: " + arraySize);
        }
        var arrayValues = value.map(function(v) {
            return $ef4a35cad960b877$var$ABI.solidityHexValue(subType, v, 256);
        });
        return $ef4a35cad960b877$require$Buffer.concat(arrayValues);
    } else if (type === "bytes") return value;
    else if (type === "string") return $ef4a35cad960b877$require$Buffer.from(value, "utf8");
    else if (type === "bool") {
        bitsize = bitsize || 8;
        var padding = Array(bitsize / 4).join("0");
        return $ef4a35cad960b877$require$Buffer.from(value ? padding + "1" : padding + "0", "hex");
    } else if (type === "address") {
        var bytesize = 20;
        if (bitsize) bytesize = bitsize / 8;
        return $5Q6LK.setLengthLeft(value, bytesize);
    } else if (type.startsWith("bytes")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return $5Q6LK.setLengthRight(value, size);
    } else if (type.startsWith("uint")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = $ef4a35cad960b877$var$parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        bitsize = bitsize || size;
        return num.toArrayLike($ef4a35cad960b877$require$Buffer, "be", bitsize / 8);
    } else if (type.startsWith("int")) {
        size = $ef4a35cad960b877$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = $ef4a35cad960b877$var$parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        bitsize = bitsize || size;
        return num.toTwos(size).toArrayLike($ef4a35cad960b877$require$Buffer, "be", bitsize / 8);
    } else // FIXME: support all other types
    throw new Error("Unsupported or invalid type: " + type);
};
$ef4a35cad960b877$var$ABI.solidityPack = function(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = $ef4a35cad960b877$var$elementaryName(types[i]);
        var value = values[i];
        ret.push($ef4a35cad960b877$var$ABI.solidityHexValue(type, value, null));
    }
    return $ef4a35cad960b877$require$Buffer.concat(ret);
};
$ef4a35cad960b877$var$ABI.soliditySHA3 = function(types, values) {
    return $5Q6LK.keccak256($ef4a35cad960b877$var$ABI.solidityPack(types, values));
};
$ef4a35cad960b877$var$ABI.soliditySHA256 = function(types, values) {
    return $5Q6LK.sha256($ef4a35cad960b877$var$ABI.solidityPack(types, values));
};
$ef4a35cad960b877$var$ABI.solidityRIPEMD160 = function(types, values) {
    return $5Q6LK.ripemd160($ef4a35cad960b877$var$ABI.solidityPack(types, values), true);
};
// Serpent's users are familiar with this encoding
// - s: string
// - b: bytes
// - b<N>: bytes<N>
// - i: int256
// - a: int256[]
function $ef4a35cad960b877$var$isNumeric(c) {
    // FIXME: is this correct? Seems to work
    return c >= "0" && c <= "9";
}
// For a "documentation" refer to https://github.com/ethereum/serpent/blob/develop/preprocess.cpp
$ef4a35cad960b877$var$ABI.fromSerpent = function(sig) {
    var ret = [];
    for(var i = 0; i < sig.length; i++){
        var type = sig[i];
        if (type === "s") ret.push("bytes");
        else if (type === "b") {
            var tmp = "bytes";
            var j = i + 1;
            while(j < sig.length && $ef4a35cad960b877$var$isNumeric(sig[j])){
                tmp += sig[j] - "0";
                j++;
            }
            i = j - 1;
            ret.push(tmp);
        } else if (type === "i") ret.push("int256");
        else if (type === "a") ret.push("int256[]");
        else throw new Error("Unsupported or invalid type: " + type);
    }
    return ret;
};
$ef4a35cad960b877$var$ABI.toSerpent = function(types) {
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = types[i];
        if (type === "bytes") ret.push("s");
        else if (type.startsWith("bytes")) ret.push("b" + $ef4a35cad960b877$var$parseTypeN(type));
        else if (type === "int256") ret.push("i");
        else if (type === "int256[]") ret.push("a");
        else throw new Error("Unsupported or invalid type: " + type);
    }
    return ret.join("");
};
module.exports = $ef4a35cad960b877$var$ABI;

});
parcelRegister("5Q6LK", function(module, exports) {
"use strict";
var $44070f42d9a3341d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44070f42d9a3341d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $44070f42d9a3341d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.secp256k1 = module.exports.rlp = module.exports.BN = void 0;

var $8QU4z = parcelRequire("8QU4z");
module.exports.secp256k1 = $8QU4z;

var $d7Iry = parcelRequire("d7Iry");

var $7rVdb = parcelRequire("7rVdb");
module.exports.BN = $7rVdb;

var $4kLt4 = parcelRequire("4kLt4");
module.exports.rlp = $4kLt4;
Object.assign(module.exports, $d7Iry);

/**
 * Constants
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("bvdBK")), module.exports);

/**
 * Public-key cryptography (secp256k1) and addresses
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("iJZHQ")), module.exports);

/**
 * Hash functions
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("fdqUr")), module.exports);

/**
 * ECDSA signature
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("jNxzx")), module.exports);

/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("4o7XT")), module.exports);

/**
 * Function for definining properties on an object
 */ $44070f42d9a3341d$var$__exportStar((parcelRequire("bbScn")), module.exports);

});
parcelRegister("8QU4z", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $01a9c8fb92168741$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ecdhUnsafe = module.exports.ecdh = module.exports.recover = module.exports.verify = module.exports.sign = module.exports.signatureImportLax = module.exports.signatureImport = module.exports.signatureExport = module.exports.signatureNormalize = module.exports.publicKeyCombine = module.exports.publicKeyTweakMul = module.exports.publicKeyTweakAdd = module.exports.publicKeyVerify = module.exports.publicKeyConvert = module.exports.publicKeyCreate = module.exports.privateKeyTweakMul = module.exports.privateKeyTweakAdd = module.exports.privateKeyModInverse = module.exports.privateKeyNegate = module.exports.privateKeyImport = module.exports.privateKeyExport = module.exports.privateKeyVerify = void 0;

var $8SeF5 = parcelRequire("8SeF5");

var $g7ffu = parcelRequire("g7ffu");

var $2pFNS = parcelRequire("2pFNS");
/**
 * Verify an ECDSA privateKey
 * @method privateKeyVerify
 * @param {Buffer} privateKey
 * @return {boolean}
 */ module.exports.privateKeyVerify = function(privateKey) {
    // secp256k1 v4 version throws when privateKey length is not 32
    if (privateKey.length !== 32) return false;
    return $8SeF5.privateKeyVerify(Uint8Array.from(privateKey));
};
/**
 * Export a privateKey in DER format
 * @method privateKeyExport
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {boolean}
 */ module.exports.privateKeyExport = function(privateKey, compressed) {
    // secp256k1 v4 version throws when privateKey length is not 32
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    var publicKey = $g7ffu.privateKeyExport(privateKey, compressed);
    return $2pFNS.privateKeyExport(privateKey, publicKey, compressed);
};
/**
 * Import a privateKey in DER format
 * @method privateKeyImport
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ module.exports.privateKeyImport = function(privateKey) {
    // privateKeyImport method is not part of secp256k1 v4 package
    // this implementation is based on v3
    privateKey = $2pFNS.privateKeyImport(privateKey);
    if (privateKey !== null && privateKey.length === 32 && module.exports.privateKeyVerify(privateKey)) return privateKey;
    throw new Error("couldn't import from DER format");
};
/**
 * Negate a privateKey by subtracting it from the order of the curve's base point
 * @method privateKeyNegate
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ module.exports.privateKeyNegate = function(privateKey) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.privateKeyNegate(Uint8Array.from(privateKey)));
};
/**
 * Compute the inverse of a privateKey (modulo the order of the curve's base point).
 * @method privateKeyModInverse
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ module.exports.privateKeyModInverse = function(privateKey) {
    if (privateKey.length !== 32) throw new Error("private key length is invalid");
    return $01a9c8fb92168741$require$Buffer.from($g7ffu.privateKeyModInverse(Uint8Array.from(privateKey)));
};
/**
 * Tweak a privateKey by adding tweak to it.
 * @method privateKeyTweakAdd
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ module.exports.privateKeyTweakAdd = function(privateKey, tweak) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.privateKeyTweakAdd(Uint8Array.from(privateKey), tweak));
};
/**
 * Tweak a privateKey by multiplying it by a tweak.
 * @method privateKeyTweakMul
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ module.exports.privateKeyTweakMul = function(privateKey, tweak) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.privateKeyTweakMul(Uint8Array.from(privateKey), Uint8Array.from(tweak)));
};
/**
 * Compute the public key for a privateKey.
 * @method publicKeyCreate
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.publicKeyCreate = function(privateKey, compressed) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.publicKeyCreate(Uint8Array.from(privateKey), compressed));
};
/**
 * Convert a publicKey to compressed or uncompressed form.
 * @method publicKeyConvert
 * @param {Buffer} publicKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.publicKeyConvert = function(publicKey, compressed) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.publicKeyConvert(Uint8Array.from(publicKey), compressed));
};
/**
 * Verify an ECDSA publicKey.
 * @method publicKeyVerify
 * @param {Buffer} publicKey
 * @return {boolean}
 */ module.exports.publicKeyVerify = function(publicKey) {
    // secp256k1 v4 version throws when publicKey length is not 33 or 65
    if (publicKey.length !== 33 && publicKey.length !== 65) return false;
    return $8SeF5.publicKeyVerify(Uint8Array.from(publicKey));
};
/**
 * Tweak a publicKey by adding tweak times the generator to it.
 * @method publicKeyTweakAdd
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.publicKeyTweakAdd = function(publicKey, tweak, compressed) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.publicKeyTweakAdd(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Tweak a publicKey by multiplying it by a tweak value
 * @method publicKeyTweakMul
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.publicKeyTweakMul = function(publicKey, tweak, compressed) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.publicKeyTweakMul(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Add a given publicKeys together.
 * @method publicKeyCombine
 * @param {Array<Buffer>} publicKeys
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.publicKeyCombine = function(publicKeys, compressed) {
    var keys = [];
    publicKeys.forEach(function(publicKey) {
        keys.push(Uint8Array.from(publicKey));
    });
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.publicKeyCombine(keys, compressed));
};
/**
 * Convert a signature to a normalized lower-S form.
 * @method signatureNormalize
 * @param {Buffer} signature
 * @return {Buffer}
 */ module.exports.signatureNormalize = function(signature) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.signatureNormalize(Uint8Array.from(signature)));
};
/**
 * Serialize an ECDSA signature in DER format.
 * @method signatureExport
 * @param {Buffer} signature
 * @return {Buffer}
 */ module.exports.signatureExport = function(signature) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.signatureExport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImport
 * @param {Buffer} signature
 * @return {Buffer}
 */ module.exports.signatureImport = function(signature) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.signatureImport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (not follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImportLax
 * @param {Buffer} signature
 * @return {Buffer}
 */ module.exports.signatureImportLax = function(signature) {
    // signatureImportLax method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure that signature is greater than 0
    if (signature.length === 0) throw new RangeError("signature length is invalid");
    var sigObj = $2pFNS.signatureImportLax(signature);
    if (sigObj === null) throw new Error("couldn't parse DER signature");
    return $g7ffu.signatureImport(sigObj);
};
/**
 * Create an ECDSA signature. Always return low-S signature.
 * @method sign
 * @param {Buffer} message
 * @param {Buffer} privateKey
 * @param {Object} options
 * @return {Buffer}
 */ module.exports.sign = function(message, privateKey, options) {
    if (options === null) throw new TypeError("options should be an Object");
    var signOptions = undefined;
    if (options) {
        signOptions = {};
        if (options.data === null) // validate option.data length
        throw new TypeError("options.data should be a Buffer");
        if (options.data) {
            if (options.data.length != 32) throw new RangeError("options.data length is invalid");
            signOptions.data = new Uint8Array(options.data);
        }
        if (options.noncefn === null) throw new TypeError("options.noncefn should be a Function");
        if (options.noncefn) // convert option.noncefn function signature
        signOptions.noncefn = function(message, privateKey, algo, data, attempt) {
            var bufferAlgo = algo != null ? $01a9c8fb92168741$require$Buffer.from(algo) : null;
            var bufferData = data != null ? $01a9c8fb92168741$require$Buffer.from(data) : null;
            var buffer = $01a9c8fb92168741$require$Buffer.from("");
            if (options.noncefn) buffer = options.noncefn($01a9c8fb92168741$require$Buffer.from(message), $01a9c8fb92168741$require$Buffer.from(privateKey), bufferAlgo, bufferData, attempt);
            return new Uint8Array(buffer);
        };
    }
    var sig = $8SeF5.ecdsaSign(Uint8Array.from(message), Uint8Array.from(privateKey), signOptions);
    return {
        signature: $01a9c8fb92168741$require$Buffer.from(sig.signature),
        recovery: sig.recid
    };
};
/**
 * Verify an ECDSA signature.
 * @method verify
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Buffer} publicKey
 * @return {boolean}
 */ module.exports.verify = function(message, signature, publicKey) {
    return $8SeF5.ecdsaVerify(Uint8Array.from(signature), Uint8Array.from(message), publicKey);
};
/**
 * Recover an ECDSA public key from a signature.
 * @method recover
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Number} recid
 * @param {boolean} compressed
 * @return {Buffer}
 */ module.exports.recover = function(message, signature, recid, compressed) {
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.ecdsaRecover(Uint8Array.from(signature), recid, Uint8Array.from(message), compressed));
};
/**
 * Compute an EC Diffie-Hellman secret and applied sha256 to compressed public key.
 * @method ecdh
 * @param {Buffer} publicKey
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ module.exports.ecdh = function(publicKey, privateKey) {
    // note: secp256k1 v3 doesn't allow optional parameter
    return $01a9c8fb92168741$require$Buffer.from($8SeF5.ecdh(Uint8Array.from(publicKey), Uint8Array.from(privateKey), {}));
};
module.exports.ecdhUnsafe = function(publicKey, privateKey, compressed) {
    // ecdhUnsafe method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure valid publicKey length
    if (publicKey.length !== 33 && publicKey.length !== 65) throw new RangeError("public key length is invalid");
    // ensure valid privateKey length
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    return $01a9c8fb92168741$require$Buffer.from($g7ffu.ecdhUnsafe(Uint8Array.from(publicKey), Uint8Array.from(privateKey), compressed));
};

});
parcelRegister("8SeF5", function(module, exports) {
"use strict";
var $675ebd5d9a115a8f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $675ebd5d9a115a8f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $675ebd5d9a115a8f$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


var $8v8et = parcelRequire("8v8et");
var $675ebd5d9a115a8f$var$SECP256K1_PRIVATE_KEY_SIZE = 32;
function $675ebd5d9a115a8f$var$createPrivateKey() {
    return $675ebd5d9a115a8f$var$__awaiter(this, void 0, void 0, function() {
        var pk;
        return $675ebd5d9a115a8f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $8v8et.getRandomBytes($675ebd5d9a115a8f$var$SECP256K1_PRIVATE_KEY_SIZE)
                    ];
                case 1:
                    pk = _a.sent();
                    if ((parcelRequire("3TUYq")).privateKeyVerify(pk)) return [
                        2 /*return*/ ,
                        pk
                    ];
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.createPrivateKey = $675ebd5d9a115a8f$var$createPrivateKey;
function $675ebd5d9a115a8f$var$createPrivateKeySync() {
    while(true){
        var pk = $8v8et.getRandomBytesSync($675ebd5d9a115a8f$var$SECP256K1_PRIVATE_KEY_SIZE);
        if ((parcelRequire("3TUYq")).privateKeyVerify(pk)) return pk;
    }
}
module.exports.createPrivateKeySync = $675ebd5d9a115a8f$var$createPrivateKeySync;

$675ebd5d9a115a8f$var$__export((parcelRequire("3TUYq")));

});
parcelRegister("3TUYq", function(module, exports) {


module.exports = (parcelRequire("9mcav"))((parcelRequire("8J6UO")));

});
parcelRegister("9mcav", function(module, exports) {
const $6cff9b8587b20809$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $6cff9b8587b20809$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $6cff9b8587b20809$var$isUint8Array(name, value, length) {
    $6cff9b8587b20809$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $6cff9b8587b20809$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $6cff9b8587b20809$var$assert(value.length === length, msg);
        }
    }
}
function $6cff9b8587b20809$var$isCompressed(value) {
    $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $6cff9b8587b20809$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $6cff9b8587b20809$var$isUint8Array("output", output, length);
    return output;
}
function $6cff9b8587b20809$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $6cff9b8587b20809$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $6cff9b8587b20809$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            $6cff9b8587b20809$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            $6cff9b8587b20809$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $6cff9b8587b20809$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $6cff9b8587b20809$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isUint8Array("tweak", tweak, 32);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isUint8Array("tweak", tweak, 32);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $6cff9b8587b20809$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $6cff9b8587b20809$var$isUint8Array("signature", sig, 64);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $6cff9b8587b20809$var$isUint8Array("signature", sig);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $6cff9b8587b20809$var$isUint8Array("message", msg32, 32);
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $6cff9b8587b20809$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $6cff9b8587b20809$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIGN);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $6cff9b8587b20809$var$isUint8Array("signature", sig, 64);
            $6cff9b8587b20809$var$isUint8Array("message", msg32, 32);
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $6cff9b8587b20809$var$isUint8Array("signature", sig, 64);
            $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $6cff9b8587b20809$var$isUint8Array("message", msg32, 32);
            $6cff9b8587b20809$var$isCompressed(compressed);
            output = $6cff9b8587b20809$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.RECOVER);
                case 3:
                    throw new Error($6cff9b8587b20809$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $6cff9b8587b20809$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $6cff9b8587b20809$var$isUint8Array("private key", seckey, 32);
            $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $6cff9b8587b20809$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $6cff9b8587b20809$var$assert($6cff9b8587b20809$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $6cff9b8587b20809$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $6cff9b8587b20809$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $6cff9b8587b20809$var$isUint8Array("output", output);
            } else output = $6cff9b8587b20809$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($6cff9b8587b20809$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($6cff9b8587b20809$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("8J6UO", function(module, exports) {

var $2jcP0 = parcelRequire("2jcP0");
var $65a7e3f1be18f442$require$EC = $2jcP0.ec;
const $65a7e3f1be18f442$var$ec = new $65a7e3f1be18f442$require$EC("secp256k1");
const $65a7e3f1be18f442$var$ecparams = $65a7e3f1be18f442$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $65a7e3f1be18f442$var$BN = $65a7e3f1be18f442$var$ecparams.n.constructor;
function $65a7e3f1be18f442$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $65a7e3f1be18f442$var$BN(xbuf);
    // overflow
    if (x.cmp($65a7e3f1be18f442$var$ecparams.p) >= 0) return null;
    x = x.toRed($65a7e3f1be18f442$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($65a7e3f1be18f442$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $65a7e3f1be18f442$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $65a7e3f1be18f442$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $65a7e3f1be18f442$var$BN(xbuf);
    let y = new $65a7e3f1be18f442$var$BN(ybuf);
    // overflow
    if (x.cmp($65a7e3f1be18f442$var$ecparams.p) >= 0 || y.cmp($65a7e3f1be18f442$var$ecparams.p) >= 0) return null;
    x = x.toRed($65a7e3f1be18f442$var$ecparams.red);
    y = y.toRed($65a7e3f1be18f442$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($65a7e3f1be18f442$var$ecparams.b)).isZero()) return null;
    return $65a7e3f1be18f442$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $65a7e3f1be18f442$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $65a7e3f1be18f442$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $65a7e3f1be18f442$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $65a7e3f1be18f442$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $65a7e3f1be18f442$var$BN(seckey);
        return bn.cmp($65a7e3f1be18f442$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $65a7e3f1be18f442$var$BN(seckey);
        const negate = $65a7e3f1be18f442$var$ecparams.n.sub(bn).umod($65a7e3f1be18f442$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $65a7e3f1be18f442$var$BN(tweak);
        if (bn.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $65a7e3f1be18f442$var$BN(seckey));
        if (bn.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) bn.isub($65a7e3f1be18f442$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $65a7e3f1be18f442$var$BN(tweak);
        if (bn.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $65a7e3f1be18f442$var$BN(seckey));
        if (bn.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) bn = bn.umod($65a7e3f1be18f442$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $65a7e3f1be18f442$var$BN(seckey);
        if (bn.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $65a7e3f1be18f442$var$ec.keyFromPrivate(seckey).getPublic();
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $65a7e3f1be18f442$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $65a7e3f1be18f442$var$BN(tweak);
        if (tweak.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($65a7e3f1be18f442$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $65a7e3f1be18f442$var$BN(tweak);
        if (tweak.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $65a7e3f1be18f442$var$BN(sig.subarray(0, 32));
        const s = new $65a7e3f1be18f442$var$BN(sig.subarray(32, 64));
        if (r.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || s.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        if (s.cmp($65a7e3f1be18f442$var$ec.nh) === 1) sig.set($65a7e3f1be18f442$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $65a7e3f1be18f442$var$BN(sigR).cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        if (new $65a7e3f1be18f442$var$BN(sigS).cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $65a7e3f1be18f442$var$BN(sigR);
        if (r.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) r = new $65a7e3f1be18f442$var$BN(0);
        let s = new $65a7e3f1be18f442$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) s = new $65a7e3f1be18f442$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $65a7e3f1be18f442$var$BN(nonce);
            };
        }
        const d = new $65a7e3f1be18f442$var$BN(seckey);
        if (d.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $65a7e3f1be18f442$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $65a7e3f1be18f442$var$BN(sigObj.r);
        const sigs = new $65a7e3f1be18f442$var$BN(sigObj.s);
        if (sigr.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || sigs.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($65a7e3f1be18f442$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $65a7e3f1be18f442$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $65a7e3f1be18f442$var$BN(sigObj.r);
        const sigs = new $65a7e3f1be18f442$var$BN(sigObj.s);
        if (sigr.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || sigs.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $65a7e3f1be18f442$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $65a7e3f1be18f442$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $65a7e3f1be18f442$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $65a7e3f1be18f442$var$BN(seckey);
        if (scalar.cmp($65a7e3f1be18f442$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $65a7e3f1be18f442$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});


parcelRegister("8v8et", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fxidi = parcelRequire("fxidi");
function $63079ac92ec8571f$var$getRandomBytes(bytes) {
    return new Promise(function(resolve, reject) {
        $fxidi(bytes, function(err, resp) {
            if (err) {
                reject(err);
                return;
            }
            resolve(resp);
        });
    });
}
module.exports.getRandomBytes = $63079ac92ec8571f$var$getRandomBytes;
function $63079ac92ec8571f$var$getRandomBytesSync(bytes) {
    return $fxidi(bytes);
}
module.exports.getRandomBytesSync = $63079ac92ec8571f$var$getRandomBytesSync;

});


parcelRegister("g7ffu", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $bbb920e66ce8e83f$require$Buffer = $7ts9d.Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7rVdb = parcelRequire("7rVdb");

var $2jcP0 = parcelRequire("2jcP0");
var $bbb920e66ce8e83f$require$EC = $2jcP0.ec;
var $bbb920e66ce8e83f$var$ec = new $bbb920e66ce8e83f$require$EC("secp256k1");
var $bbb920e66ce8e83f$var$ecparams = $bbb920e66ce8e83f$var$ec.curve;
module.exports.privateKeyExport = function(privateKey, compressed) {
    if (compressed === void 0) compressed = true;
    var d = new $7rVdb(privateKey);
    if (d.ucmp($bbb920e66ce8e83f$var$ecparams.n) >= 0) throw new Error("couldn't export to DER format");
    var point = $bbb920e66ce8e83f$var$ec.g.mul(d);
    return $bbb920e66ce8e83f$var$toPublicKey(point.getX(), point.getY(), compressed);
};
module.exports.privateKeyModInverse = function(privateKey) {
    var bn = new $7rVdb(privateKey);
    if (bn.ucmp($bbb920e66ce8e83f$var$ecparams.n) >= 0 || bn.isZero()) throw new Error("private key range is invalid");
    return bn.invm($bbb920e66ce8e83f$var$ecparams.n).toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32);
};
module.exports.signatureImport = function(sigObj) {
    var r = new $7rVdb(sigObj.r);
    if (r.ucmp($bbb920e66ce8e83f$var$ecparams.n) >= 0) r = new $7rVdb(0);
    var s = new $7rVdb(sigObj.s);
    if (s.ucmp($bbb920e66ce8e83f$var$ecparams.n) >= 0) s = new $7rVdb(0);
    return $bbb920e66ce8e83f$require$Buffer.concat([
        r.toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32),
        s.toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32)
    ]);
};
module.exports.ecdhUnsafe = function(publicKey, privateKey, compressed) {
    if (compressed === void 0) compressed = true;
    var point = $bbb920e66ce8e83f$var$ec.keyFromPublic(publicKey);
    var scalar = new $7rVdb(privateKey);
    if (scalar.ucmp($bbb920e66ce8e83f$var$ecparams.n) >= 0 || scalar.isZero()) throw new Error("scalar was invalid (zero or overflow)");
    var shared = point.pub.mul(scalar);
    return $bbb920e66ce8e83f$var$toPublicKey(shared.getX(), shared.getY(), compressed);
};
var $bbb920e66ce8e83f$var$toPublicKey = function(x, y, compressed) {
    var publicKey;
    if (compressed) {
        publicKey = $bbb920e66ce8e83f$require$Buffer.alloc(33);
        publicKey[0] = y.isOdd() ? 0x03 : 0x02;
        x.toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32).copy(publicKey, 1);
    } else {
        publicKey = $bbb920e66ce8e83f$require$Buffer.alloc(65);
        publicKey[0] = 0x04;
        x.toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32).copy(publicKey, 1);
        y.toArrayLike($bbb920e66ce8e83f$require$Buffer, "be", 32).copy(publicKey, 33);
    }
    return publicKey;
};

});

parcelRegister("2pFNS", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $1c1e57db78fdeb30$require$Buffer = $7ts9d.Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1c1e57db78fdeb30$var$EC_PRIVKEY_EXPORT_DER_COMPRESSED = $1c1e57db78fdeb30$require$Buffer.from([
    // begin
    0x30,
    0x81,
    0xd3,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0x85,
    0x30,
    0x81,
    0x82,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x21,
    0x02,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x24,
    0x03,
    0x22,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
var $1c1e57db78fdeb30$var$EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = $1c1e57db78fdeb30$require$Buffer.from([
    // begin
    0x30,
    0x82,
    0x01,
    0x13,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0xa5,
    0x30,
    0x81,
    0xa2,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x41,
    0x04,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x48,
    0x3a,
    0xda,
    0x77,
    0x26,
    0xa3,
    0xc4,
    0x65,
    0x5d,
    0xa4,
    0xfb,
    0xfc,
    0x0e,
    0x11,
    0x08,
    0xa8,
    0xfd,
    0x17,
    0xb4,
    0x48,
    0xa6,
    0x85,
    0x54,
    0x19,
    0x9c,
    0x47,
    0xd0,
    0x8f,
    0xfb,
    0x10,
    0xd4,
    0xb8,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x44,
    0x03,
    0x42,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
module.exports.privateKeyExport = function(privateKey, publicKey, compressed) {
    if (compressed === void 0) compressed = true;
    var result = $1c1e57db78fdeb30$require$Buffer.from(compressed ? $1c1e57db78fdeb30$var$EC_PRIVKEY_EXPORT_DER_COMPRESSED : $1c1e57db78fdeb30$var$EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED);
    privateKey.copy(result, compressed ? 8 : 9);
    publicKey.copy(result, compressed ? 181 : 214);
    return result;
};
module.exports.privateKeyImport = function(privateKey) {
    var length = privateKey.length;
    // sequence header
    var index = 0;
    if (length < index + 1 || privateKey[index] !== 0x30) return null;
    index += 1;
    // sequence length constructor
    if (length < index + 1 || !(privateKey[index] & 0x80)) return null;
    var lenb = privateKey[index] & 0x7f;
    index += 1;
    if (lenb < 1 || lenb > 2) return null;
    if (length < index + lenb) return null;
    // sequence length
    var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0);
    index += lenb;
    if (length < index + len) return null;
    // sequence element 0: version number (=1)
    if (length < index + 3 || privateKey[index] !== 0x02 || privateKey[index + 1] !== 0x01 || privateKey[index + 2] !== 0x01) return null;
    index += 3;
    // sequence element 1: octet string, up to 32 bytes
    if (length < index + 2 || privateKey[index] !== 0x04 || privateKey[index + 1] > 0x20 || length < index + 2 + privateKey[index + 1]) return null;
    return privateKey.slice(index + 2, index + 2 + privateKey[index + 1]);
};
module.exports.signatureImportLax = function(signature) {
    var r = $1c1e57db78fdeb30$require$Buffer.alloc(32, 0);
    var s = $1c1e57db78fdeb30$require$Buffer.alloc(32, 0);
    var length = signature.length;
    var index = 0;
    // sequence tag byte
    if (signature[index++] !== 0x30) return null;
    // sequence length byte
    var lenbyte = signature[index++];
    if (lenbyte & 0x80) {
        index += lenbyte - 0x80;
        if (index > length) return null;
    }
    // sequence tag byte for r
    if (signature[index++] !== 0x02) return null;
    // length for r
    var rlen = signature[index++];
    if (rlen & 0x80) {
        lenbyte = rlen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1)rlen = (rlen << 8) + signature[index];
    }
    if (rlen > length - index) return null;
    var rindex = index;
    index += rlen;
    // sequence tag byte for s
    if (signature[index++] !== 0x02) return null;
    // length for s
    var slen = signature[index++];
    if (slen & 0x80) {
        lenbyte = slen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(slen = 0; lenbyte > 0; index += 1, lenbyte -= 1)slen = (slen << 8) + signature[index];
    }
    if (slen > length - index) return null;
    var sindex = index;
    index += slen;
    // ignore leading zeros in r
    for(; rlen > 0 && signature[rindex] === 0x00; rlen -= 1, rindex += 1);
    // copy r value
    if (rlen > 32) return null;
    var rvalue = signature.slice(rindex, rindex + rlen);
    rvalue.copy(r, 32 - rvalue.length);
    // ignore leading zeros in s
    for(; slen > 0 && signature[sindex] === 0x00; slen -= 1, sindex += 1);
    // copy s value
    if (slen > 32) return null;
    var svalue = signature.slice(sindex, sindex + slen);
    svalue.copy(s, 32 - svalue.length);
    return {
        r: r,
        s: s
    };
};

});


parcelRegister("d7Iry", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $98de67590a500db1$require$Buffer = $7ts9d.Buffer;
"use strict";

var $3u7L3 = parcelRequire("3u7L3");

var $2jJxE = parcelRequire("2jJxE");
/**
 * Pads a `String` to have an even length
 * @param {String} value
 * @return {String} output
 */ function $98de67590a500db1$var$padToEven(value) {
    var a = value; // eslint-disable-line
    if (typeof a !== "string") throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof a + ", while padToEven.");
    if (a.length % 2) a = "0" + a;
    return a;
}
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ function $98de67590a500db1$var$intToHex(i) {
    var hex = i.toString(16); // eslint-disable-line
    return "0x" + hex;
}
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ function $98de67590a500db1$var$intToBuffer(i) {
    var hex = $98de67590a500db1$var$intToHex(i);
    return new $98de67590a500db1$require$Buffer($98de67590a500db1$var$padToEven(hex.slice(2)), "hex");
}
/**
 * Get the binary size of a string
 * @param {String} str
 * @return {Number}
 */ function $98de67590a500db1$var$getBinarySize(str) {
    if (typeof str !== "string") throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof str + "'.");
    return $98de67590a500db1$require$Buffer.byteLength(str, "utf8");
}
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */ function $98de67590a500db1$var$arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof superset + "'");
    if (Array.isArray(subset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof subset + "'");
    return subset[Boolean(some) && "some" || "every"](function(value) {
        return superset.indexOf(value) >= 0;
    });
}
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method toUtf8
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function $98de67590a500db1$var$toUtf8(hex) {
    var bufferValue = new $98de67590a500db1$require$Buffer($98de67590a500db1$var$padToEven($2jJxE(hex).replace(/^0+|0+$/g, "")), "hex");
    return bufferValue.toString("utf8");
}
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method toAscii
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function $98de67590a500db1$var$toAscii(hex) {
    var str = ""; // eslint-disable-line
    var i = 0, l = hex.length; // eslint-disable-line
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method fromUtf8
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function $98de67590a500db1$var$fromUtf8(stringValue) {
    var str = new $98de67590a500db1$require$Buffer(stringValue, "utf8");
    return "0x" + $98de67590a500db1$var$padToEven(str.toString("hex")).replace(/^0+|0+$/g, "");
}
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method fromAscii
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function $98de67590a500db1$var$fromAscii(stringValue) {
    var hex = ""; // eslint-disable-line
    for(var i = 0; i < stringValue.length; i++){
        // eslint-disable-line
        var code = stringValue.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
}
/**
 * getKeys([{a: 1, b: 2}, {a: 3, b: 4}], 'a') => [1, 3]
 *
 * @method getKeys get specific key from inner object array of objects
 * @param {String} params
 * @param {String} key
 * @param {Boolean} allowEmpty
 * @returns {Array} output just a simple array of output keys
 */ function $98de67590a500db1$var$getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof params + "'");
    if (typeof key !== "string") throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof key + "'.");
    var result = []; // eslint-disable-line
    for(var i = 0; i < params.length; i++){
        // eslint-disable-line
        var value = params[i][key]; // eslint-disable-line
        if (allowEmpty && !value) value = "";
        else if (typeof value !== "string") throw new Error("invalid abi");
        result.push(value);
    }
    return result;
}
/**
 * Is the string a hex string.
 *
 * @method check if string is hex string of specific length
 * @param {String} value
 * @param {Number} length
 * @returns {Boolean} output the string is a hex string
 */ function $98de67590a500db1$var$isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports = {
    arrayContainsArray: $98de67590a500db1$var$arrayContainsArray,
    intToBuffer: $98de67590a500db1$var$intToBuffer,
    getBinarySize: $98de67590a500db1$var$getBinarySize,
    isHexPrefixed: $3u7L3,
    stripHexPrefix: $2jJxE,
    padToEven: $98de67590a500db1$var$padToEven,
    intToHex: $98de67590a500db1$var$intToHex,
    fromAscii: $98de67590a500db1$var$fromAscii,
    fromUtf8: $98de67590a500db1$var$fromUtf8,
    toAscii: $98de67590a500db1$var$toAscii,
    toUtf8: $98de67590a500db1$var$toUtf8,
    getKeys: $98de67590a500db1$var$getKeys,
    isHexString: $98de67590a500db1$var$isHexString
};

});
parcelRegister("3u7L3", function(module, exports) {
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param {String} str the string input value
 * @return {Boolean} a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ module.exports = function isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof str + ", while checking isHexPrefixed.");
    return str.slice(0, 2) === "0x";
};

});

parcelRegister("2jJxE", function(module, exports) {

var $3u7L3 = parcelRequire("3u7L3");
/**
 * Removes '0x' from a given `String` is present
 * @param {String} str the string value
 * @return {String|Optional} a string by pass if necessary
 */ module.exports = function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $3u7L3(str) ? str.slice(2) : str;
};

});


parcelRegister("4kLt4", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $327dd9cdc3b7f913$require$Buffer = $7ts9d.Buffer;
"use strict";
var $327dd9cdc3b7f913$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLength = module.exports.decode = module.exports.encode = void 0;

var $327dd9cdc3b7f913$var$bn_js_1 = $327dd9cdc3b7f913$var$__importDefault((parcelRequire("fMDYa")));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function $327dd9cdc3b7f913$var$encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push($327dd9cdc3b7f913$var$encode(input[i]));
        var buf = $327dd9cdc3b7f913$require$Buffer.concat(output);
        return $327dd9cdc3b7f913$require$Buffer.concat([
            $327dd9cdc3b7f913$var$encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = $327dd9cdc3b7f913$var$toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : $327dd9cdc3b7f913$require$Buffer.concat([
            $327dd9cdc3b7f913$var$encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
module.exports.encode = $327dd9cdc3b7f913$var$encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function $327dd9cdc3b7f913$var$safeParseInt(v, base) {
    if (v[0] === "0" && v[1] === "0") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function $327dd9cdc3b7f913$var$encodeLength(len, offset) {
    if (len < 56) return $327dd9cdc3b7f913$require$Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = $327dd9cdc3b7f913$var$intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = $327dd9cdc3b7f913$var$intToHex(offset + 55 + lLength);
        return $327dd9cdc3b7f913$require$Buffer.from(firstByte + hexLength, "hex");
    }
}
function $327dd9cdc3b7f913$var$decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return $327dd9cdc3b7f913$require$Buffer.from([]);
    var inputBuffer = $327dd9cdc3b7f913$var$toBuffer(input);
    var decoded = $327dd9cdc3b7f913$var$_decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
module.exports.decode = $327dd9cdc3b7f913$var$decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function $327dd9cdc3b7f913$var$getLength(input) {
    if (!input || input.length === 0) return $327dd9cdc3b7f913$require$Buffer.from([]);
    var inputBuffer = $327dd9cdc3b7f913$var$toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length_1 = $327dd9cdc3b7f913$var$safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length_1;
    }
}
module.exports.getLength = $327dd9cdc3b7f913$var$getLength;
/** Decode an input with RLP */ function $327dd9cdc3b7f913$var$_decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = $327dd9cdc3b7f913$require$Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $327dd9cdc3b7f913$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = $327dd9cdc3b7f913$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = $327dd9cdc3b7f913$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = $327dd9cdc3b7f913$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function $327dd9cdc3b7f913$var$isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function $327dd9cdc3b7f913$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $327dd9cdc3b7f913$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function $327dd9cdc3b7f913$var$intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function $327dd9cdc3b7f913$var$padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function $327dd9cdc3b7f913$var$intToBuffer(integer) {
    var hex = $327dd9cdc3b7f913$var$intToHex(integer);
    return $327dd9cdc3b7f913$require$Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function $327dd9cdc3b7f913$var$toBuffer(v) {
    if (!$327dd9cdc3b7f913$require$Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if ($327dd9cdc3b7f913$var$isHexPrefixed(v)) return $327dd9cdc3b7f913$require$Buffer.from($327dd9cdc3b7f913$var$padToEven($327dd9cdc3b7f913$var$stripHexPrefix(v)), "hex");
            else return $327dd9cdc3b7f913$require$Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return $327dd9cdc3b7f913$require$Buffer.from([]);
            else return $327dd9cdc3b7f913$var$intToBuffer(v);
        } else if (v === null || v === undefined) return $327dd9cdc3b7f913$require$Buffer.from([]);
        else if (v instanceof Uint8Array) return $327dd9cdc3b7f913$require$Buffer.from(v);
        else if ($327dd9cdc3b7f913$var$bn_js_1.default.isBN(v)) // converts a BN to a Buffer
        return $327dd9cdc3b7f913$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

});
parcelRegister("fMDYa", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ts9d")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("bvdBK", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $85fd252cb7150164$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KECCAK256_RLP = module.exports.KECCAK256_RLP_S = module.exports.KECCAK256_RLP_ARRAY = module.exports.KECCAK256_RLP_ARRAY_S = module.exports.KECCAK256_NULL = module.exports.KECCAK256_NULL_S = module.exports.TWO_POW256 = module.exports.MAX_INTEGER = void 0;

var $7rVdb = parcelRequire("7rVdb");
/**
 * The max integer that this VM can handle
 */ module.exports.MAX_INTEGER = new $7rVdb("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);
/**
 * 2^256
 */ module.exports.TWO_POW256 = new $7rVdb("10000000000000000000000000000000000000000000000000000000000000000", 16);
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL = $85fd252cb7150164$require$Buffer.from(module.exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY = $85fd252cb7150164$require$Buffer.from(module.exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP = $85fd252cb7150164$require$Buffer.from(module.exports.KECCAK256_RLP_S, "hex");

});

parcelRegister("iJZHQ", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $da4c4b84ea63a2a6$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.importPublic = module.exports.privateToPublic = module.exports.privateToAddress = module.exports.publicToAddress = module.exports.pubToAddress = module.exports.isValidPublic = module.exports.isValidPrivate = module.exports.isPrecompiled = module.exports.generateAddress2 = module.exports.generateAddress = module.exports.isValidChecksumAddress = module.exports.toChecksumAddress = module.exports.isZeroAddress = module.exports.isValidAddress = module.exports.zeroAddress = void 0;

var $3t0dw = parcelRequire("3t0dw");

var $d7Iry = parcelRequire("d7Iry");

var $8QU4z = parcelRequire("8QU4z");

var $7rVdb = parcelRequire("7rVdb");

var $4o7XT = parcelRequire("4o7XT");

var $fdqUr = parcelRequire("fdqUr");
/**
 * Returns a zero address.
 */ module.exports.zeroAddress = function() {
    var addressLength = 20;
    var addr = $4o7XT.zeros(addressLength);
    return $4o7XT.bufferToHex(addr);
};
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ module.exports.isValidAddress = function(address) {
    return /^0x[0-9a-fA-F]{40}$/.test(address);
};
/**
 * Checks if a given address is a zero address.
 */ module.exports.isZeroAddress = function(address) {
    var zeroAddr = module.exports.zeroAddress();
    return zeroAddr === $4o7XT.addHexPrefix(address);
};
/**
 * Returns a checksummed address.
 *
 * If a eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details, consult EIP-1191.
 *
 * WARNING: Checksums with and without the chainId will differ. As of 2019-06-26, the most commonly
 * used variation in Ethereum was without the chainId. This may change in the future.
 */ module.exports.toChecksumAddress = function(address, eip1191ChainId) {
    address = $d7Iry.stripHexPrefix(address).toLowerCase();
    var prefix = eip1191ChainId !== undefined ? eip1191ChainId.toString() + "0x" : "";
    var hash = $fdqUr.keccak(prefix + address).toString("hex");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ module.exports.isValidChecksumAddress = function(address, eip1191ChainId) {
    return module.exports.isValidAddress(address) && module.exports.toChecksumAddress(address, eip1191ChainId) === address;
};
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ module.exports.generateAddress = function(from, nonce) {
    from = $4o7XT.toBuffer(from);
    var nonceBN = new $7rVdb(nonce);
    if (nonceBN.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return $fdqUr.rlphash([
        from,
        null
    ]).slice(-20);
    // Only take the lower 160bits of the hash
    return $fdqUr.rlphash([
        from,
        $da4c4b84ea63a2a6$require$Buffer.from(nonceBN.toArray())
    ]).slice(-20);
};
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ module.exports.generateAddress2 = function(from, salt, initCode) {
    var fromBuf = $4o7XT.toBuffer(from);
    var saltBuf = $4o7XT.toBuffer(salt);
    var initCodeBuf = $4o7XT.toBuffer(initCode);
    $3t0dw(fromBuf.length === 20);
    $3t0dw(saltBuf.length === 32);
    var address = $fdqUr.keccak256($da4c4b84ea63a2a6$require$Buffer.concat([
        $da4c4b84ea63a2a6$require$Buffer.from("ff", "hex"),
        fromBuf,
        saltBuf,
        $fdqUr.keccak256(initCodeBuf)
    ]));
    return address.slice(-20);
};
/**
 * Returns true if the supplied address belongs to a precompiled account (Byzantium).
 */ module.exports.isPrecompiled = function(address) {
    var a = $4o7XT.unpad(address);
    return a.length === 1 && a[0] >= 1 && a[0] <= 8;
};
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ module.exports.isValidPrivate = function(privateKey) {
    return $8QU4z.privateKeyVerify(privateKey);
};
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ module.exports.isValidPublic = function(publicKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return $8QU4z.publicKeyVerify($da4c4b84ea63a2a6$require$Buffer.concat([
        $da4c4b84ea63a2a6$require$Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return $8QU4z.publicKeyVerify(publicKey);
};
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ module.exports.pubToAddress = function(pubKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    pubKey = $4o7XT.toBuffer(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = $8QU4z.publicKeyConvert(pubKey, false).slice(1);
    $3t0dw(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return $fdqUr.keccak(pubKey).slice(-20);
};
module.exports.publicToAddress = module.exports.pubToAddress;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ module.exports.privateToAddress = function(privateKey) {
    return module.exports.publicToAddress(module.exports.privateToPublic(privateKey));
};
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ module.exports.privateToPublic = function(privateKey) {
    privateKey = $4o7XT.toBuffer(privateKey);
    // skip the type flag and use the X, Y points
    return $8QU4z.publicKeyCreate(privateKey, false).slice(1);
};
/**
 * Converts a public key to the Ethereum format.
 */ module.exports.importPublic = function(publicKey) {
    publicKey = $4o7XT.toBuffer(publicKey);
    if (publicKey.length !== 64) publicKey = $8QU4z.publicKeyConvert(publicKey, false).slice(1);
    return publicKey;
};

});
parcelRegister("3t0dw", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
function $28643fa8cb4d8aa1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $28643fa8cb4d8aa1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $28643fa8cb4d8aa1$var$_typeof(o);
}
function $28643fa8cb4d8aa1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $28643fa8cb4d8aa1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $28643fa8cb4d8aa1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $28643fa8cb4d8aa1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $28643fa8cb4d8aa1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $28643fa8cb4d8aa1$var$_toPropertyKey(arg) {
    var key = $28643fa8cb4d8aa1$var$_toPrimitive(arg, "string");
    return $28643fa8cb4d8aa1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $28643fa8cb4d8aa1$var$_toPrimitive(input, hint) {
    if ($28643fa8cb4d8aa1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($28643fa8cb4d8aa1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $28643fa8cb4d8aa1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $BSX8Z = parcelRequire("BSX8Z");
var $28643fa8cb4d8aa1$var$_require$codes = $BSX8Z.codes, $28643fa8cb4d8aa1$var$ERR_AMBIGUOUS_ARGUMENT = $28643fa8cb4d8aa1$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE = $28643fa8cb4d8aa1$var$_require$codes.ERR_INVALID_ARG_TYPE, $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_VALUE = $28643fa8cb4d8aa1$var$_require$codes.ERR_INVALID_ARG_VALUE, $28643fa8cb4d8aa1$var$ERR_INVALID_RETURN_VALUE = $28643fa8cb4d8aa1$var$_require$codes.ERR_INVALID_RETURN_VALUE, $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS = $28643fa8cb4d8aa1$var$_require$codes.ERR_MISSING_ARGS;

var $1iZQe = parcelRequire("1iZQe");

var $fwvm4 = parcelRequire("fwvm4");
var $28643fa8cb4d8aa1$var$inspect = $fwvm4.inspect;

var $fwvm4 = parcelRequire("fwvm4");
var $28643fa8cb4d8aa1$require$_require$types = $fwvm4.types;
var $28643fa8cb4d8aa1$var$isPromise = $28643fa8cb4d8aa1$require$_require$types.isPromise, $28643fa8cb4d8aa1$var$isRegExp = $28643fa8cb4d8aa1$require$_require$types.isRegExp;

var $28643fa8cb4d8aa1$var$objectAssign = (parcelRequire("aosFD"))();

var $28643fa8cb4d8aa1$var$objectIs = (parcelRequire("hfZz9"))();

var $28643fa8cb4d8aa1$var$RegExpPrototypeTest = (parcelRequire("hWCYZ"))("RegExp.prototype.test");
var $28643fa8cb4d8aa1$var$errorCache = new Map();
var $28643fa8cb4d8aa1$var$isDeepEqual;
var $28643fa8cb4d8aa1$var$isDeepStrictEqual;
var $28643fa8cb4d8aa1$var$parseExpressionAt;
var $28643fa8cb4d8aa1$var$findNodeAround;
var $28643fa8cb4d8aa1$var$decoder;

function $28643fa8cb4d8aa1$var$lazyLoadComparison() {
    var comparison = (parcelRequire("jntFm"));
    $28643fa8cb4d8aa1$var$isDeepEqual = comparison.isDeepEqual;
    $28643fa8cb4d8aa1$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $28643fa8cb4d8aa1$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $28643fa8cb4d8aa1$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $28643fa8cb4d8aa1$var$escapeFn = function escapeFn(str) {
    return $28643fa8cb4d8aa1$var$meta[str.charCodeAt(0)];
};
var $28643fa8cb4d8aa1$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $28643fa8cb4d8aa1$var$assert = module.exports = $28643fa8cb4d8aa1$var$ok;
var $28643fa8cb4d8aa1$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $28643fa8cb4d8aa1$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1iZQe(obj);
}
function $28643fa8cb4d8aa1$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($28643fa8cb4d8aa1$var$warned === false) {
            $28643fa8cb4d8aa1$var$warned = true;
            var warn = $gbdt3.emitWarning ? $gbdt3.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $28643fa8cb4d8aa1$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $1iZQe(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$28643fa8cb4d8aa1$var$assert.fail = $28643fa8cb4d8aa1$var$fail;
// The AssertionError is defined in internal/error.
$28643fa8cb4d8aa1$var$assert.AssertionError = $1iZQe;
function $28643fa8cb4d8aa1$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $1iZQe({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $28643fa8cb4d8aa1$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $28643fa8cb4d8aa1$var$innerOk.apply(void 0, [
        $28643fa8cb4d8aa1$var$ok,
        args.length
    ].concat(args));
}
$28643fa8cb4d8aa1$var$assert.ok = $28643fa8cb4d8aa1$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $28643fa8cb4d8aa1$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$28643fa8cb4d8aa1$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$28643fa8cb4d8aa1$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($28643fa8cb4d8aa1$var$isDeepEqual === undefined) $28643fa8cb4d8aa1$var$lazyLoadComparison();
    if (!$28643fa8cb4d8aa1$var$isDeepEqual(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$28643fa8cb4d8aa1$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($28643fa8cb4d8aa1$var$isDeepEqual === undefined) $28643fa8cb4d8aa1$var$lazyLoadComparison();
    if ($28643fa8cb4d8aa1$var$isDeepEqual(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $28643fa8cb4d8aa1$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($28643fa8cb4d8aa1$var$isDeepEqual === undefined) $28643fa8cb4d8aa1$var$lazyLoadComparison();
    if (!$28643fa8cb4d8aa1$var$isDeepStrictEqual(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$28643fa8cb4d8aa1$var$assert.notDeepStrictEqual = $28643fa8cb4d8aa1$var$notDeepStrictEqual;
function $28643fa8cb4d8aa1$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($28643fa8cb4d8aa1$var$isDeepEqual === undefined) $28643fa8cb4d8aa1$var$lazyLoadComparison();
    if ($28643fa8cb4d8aa1$var$isDeepStrictEqual(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $28643fa8cb4d8aa1$var$notDeepStrictEqual
    });
}
$28643fa8cb4d8aa1$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$28643fa8cb4d8aa1$var$objectIs(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$28643fa8cb4d8aa1$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $28643fa8cb4d8aa1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($28643fa8cb4d8aa1$var$objectIs(actual, expected)) $28643fa8cb4d8aa1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $28643fa8cb4d8aa1$var$Comparison = /*#__PURE__*/ $28643fa8cb4d8aa1$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $28643fa8cb4d8aa1$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $28643fa8cb4d8aa1$var$isRegExp(obj[key]) && $28643fa8cb4d8aa1$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $28643fa8cb4d8aa1$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$28643fa8cb4d8aa1$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $28643fa8cb4d8aa1$var$Comparison(actual, keys);
            var b = new $28643fa8cb4d8aa1$var$Comparison(expected, keys, actual);
            var err = new $1iZQe({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $28643fa8cb4d8aa1$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $28643fa8cb4d8aa1$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($28643fa8cb4d8aa1$var$isRegExp(expected)) return $28643fa8cb4d8aa1$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($28643fa8cb4d8aa1$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $1iZQe({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($28643fa8cb4d8aa1$var$isDeepEqual === undefined) $28643fa8cb4d8aa1$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $28643fa8cb4d8aa1$var$isRegExp(expected[key]) && $28643fa8cb4d8aa1$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $28643fa8cb4d8aa1$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $28643fa8cb4d8aa1$var$getActual(fn) {
    if (typeof fn !== "function") throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $28643fa8cb4d8aa1$var$NO_EXCEPTION_SENTINEL;
}
function $28643fa8cb4d8aa1$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $28643fa8cb4d8aa1$var$isPromise(obj) || obj !== null && $28643fa8cb4d8aa1$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $28643fa8cb4d8aa1$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$28643fa8cb4d8aa1$var$checkIsPromise(resultPromise)) throw new $28643fa8cb4d8aa1$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($28643fa8cb4d8aa1$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $28643fa8cb4d8aa1$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $28643fa8cb4d8aa1$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($28643fa8cb4d8aa1$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $28643fa8cb4d8aa1$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $28643fa8cb4d8aa1$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $28643fa8cb4d8aa1$var$_typeof(error) !== "object" && typeof error !== "function") throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $28643fa8cb4d8aa1$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $28643fa8cb4d8aa1$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$28643fa8cb4d8aa1$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $28643fa8cb4d8aa1$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $28643fa8cb4d8aa1$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $28643fa8cb4d8aa1$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $28643fa8cb4d8aa1$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$28643fa8cb4d8aa1$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $28643fa8cb4d8aa1$var$expectsError.apply(void 0, [
        throws,
        $28643fa8cb4d8aa1$var$getActual(promiseFn)
    ].concat(args));
};
$28643fa8cb4d8aa1$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $28643fa8cb4d8aa1$var$waitForActual(promiseFn).then(function(result) {
        return $28643fa8cb4d8aa1$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$28643fa8cb4d8aa1$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $28643fa8cb4d8aa1$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $28643fa8cb4d8aa1$var$getActual(fn)
    ].concat(args));
};
$28643fa8cb4d8aa1$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $28643fa8cb4d8aa1$var$waitForActual(fn).then(function(result) {
        return $28643fa8cb4d8aa1$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$28643fa8cb4d8aa1$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($28643fa8cb4d8aa1$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $28643fa8cb4d8aa1$var$inspect(err);
        var newErr = new $1iZQe({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $28643fa8cb4d8aa1$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$28643fa8cb4d8aa1$var$isRegExp(regexp)) throw new $28643fa8cb4d8aa1$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $28643fa8cb4d8aa1$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($28643fa8cb4d8aa1$var$_typeof(string), " (").concat($28643fa8cb4d8aa1$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($28643fa8cb4d8aa1$var$inspect(regexp), ". Input:\n\n").concat($28643fa8cb4d8aa1$var$inspect(string), "\n"));
        var err = new $1iZQe({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$28643fa8cb4d8aa1$var$assert.match = function match(string, regexp, message) {
    $28643fa8cb4d8aa1$var$internalMatch(string, regexp, message, match, "match");
};
$28643fa8cb4d8aa1$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $28643fa8cb4d8aa1$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $28643fa8cb4d8aa1$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $28643fa8cb4d8aa1$var$innerOk.apply(void 0, [
        $28643fa8cb4d8aa1$var$strict,
        args.length
    ].concat(args));
}
$28643fa8cb4d8aa1$var$assert.strict = $28643fa8cb4d8aa1$var$objectAssign($28643fa8cb4d8aa1$var$strict, $28643fa8cb4d8aa1$var$assert, {
    equal: $28643fa8cb4d8aa1$var$assert.strictEqual,
    deepEqual: $28643fa8cb4d8aa1$var$assert.deepStrictEqual,
    notEqual: $28643fa8cb4d8aa1$var$assert.notStrictEqual,
    notDeepEqual: $28643fa8cb4d8aa1$var$assert.notDeepStrictEqual
});
$28643fa8cb4d8aa1$var$assert.strict.strict = $28643fa8cb4d8aa1$var$assert.strict;

});
parcelRegister("BSX8Z", function(module, exports) {

$parcel$export(module.exports, "codes", () => $071e1552f164aae2$export$e45cb6485273080e, (v) => $071e1552f164aae2$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $071e1552f164aae2$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $071e1552f164aae2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $071e1552f164aae2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $071e1552f164aae2$var$_typeof(o);
}
function $071e1552f164aae2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $071e1552f164aae2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $071e1552f164aae2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $071e1552f164aae2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $071e1552f164aae2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $071e1552f164aae2$var$_toPropertyKey(arg) {
    var key = $071e1552f164aae2$var$_toPrimitive(arg, "string");
    return $071e1552f164aae2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $071e1552f164aae2$var$_toPrimitive(input, hint) {
    if ($071e1552f164aae2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($071e1552f164aae2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $071e1552f164aae2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $071e1552f164aae2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $071e1552f164aae2$var$_setPrototypeOf(subClass, superClass);
}
function $071e1552f164aae2$var$_setPrototypeOf(o, p) {
    $071e1552f164aae2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $071e1552f164aae2$var$_setPrototypeOf(o, p);
}
function $071e1552f164aae2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $071e1552f164aae2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $071e1552f164aae2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $071e1552f164aae2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $071e1552f164aae2$var$_possibleConstructorReturn(this, result);
    };
}
function $071e1552f164aae2$var$_possibleConstructorReturn(self, call) {
    if (call && ($071e1552f164aae2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $071e1552f164aae2$var$_assertThisInitialized(self);
}
function $071e1552f164aae2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $071e1552f164aae2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $071e1552f164aae2$var$_getPrototypeOf(o) {
    $071e1552f164aae2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $071e1552f164aae2$var$_getPrototypeOf(o);
}
var $071e1552f164aae2$var$codes = {};
// Lazy loaded
var $071e1552f164aae2$var$assert;
var $071e1552f164aae2$var$util;
function $071e1552f164aae2$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $071e1552f164aae2$var$_inherits(NodeError, _Base);
        var _super = $071e1552f164aae2$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $071e1552f164aae2$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $071e1552f164aae2$var$_createClass(NodeError);
    }(Base);
    $071e1552f164aae2$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $071e1552f164aae2$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $071e1552f164aae2$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $071e1552f164aae2$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $071e1552f164aae2$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$071e1552f164aae2$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$071e1552f164aae2$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($071e1552f164aae2$var$assert === undefined) $071e1552f164aae2$var$assert = (parcelRequire("3t0dw"));
    $071e1552f164aae2$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $071e1552f164aae2$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($071e1552f164aae2$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($071e1552f164aae2$var$oneOf(expected, "type"));
    else {
        var type = $071e1552f164aae2$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($071e1552f164aae2$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($071e1552f164aae2$var$_typeof(actual));
    return msg;
}, TypeError);

$071e1552f164aae2$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($071e1552f164aae2$var$util === undefined) $071e1552f164aae2$var$util = (parcelRequire("fwvm4"));
    var inspected = $071e1552f164aae2$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$071e1552f164aae2$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($071e1552f164aae2$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$071e1552f164aae2$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($071e1552f164aae2$var$assert === undefined) $071e1552f164aae2$var$assert = (parcelRequire("3t0dw"));
    $071e1552f164aae2$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$071e1552f164aae2$export$e45cb6485273080e = $071e1552f164aae2$var$codes;

});
parcelRegister("fwvm4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gbdt3 = parcelRequire("gbdt3");
var $b4d22a985116bb70$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $b4d22a985116bb70$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$b4d22a985116bb70$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($b4d22a985116bb70$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($b4d22a985116bb70$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($b4d22a985116bb70$var$isNull(x) || !$b4d22a985116bb70$var$isObject(x)) str += " " + x;
    else str += " " + $b4d22a985116bb70$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $gbdt3 !== "undefined" && $gbdt3.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $gbdt3 === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($gbdt3.throwDeprecation) throw new Error(msg);
            else if ($gbdt3.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $b4d22a985116bb70$var$debugs = {};
var $b4d22a985116bb70$var$debugEnvRegex = /^$/;
var $b4d22a985116bb70$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$b4d22a985116bb70$var$debugs[set]) {
        if ($b4d22a985116bb70$var$debugEnvRegex.test(set)) {
            var pid = $gbdt3.pid;
            $b4d22a985116bb70$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $b4d22a985116bb70$var$debugs[set] = function() {};
    }
    return $b4d22a985116bb70$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $b4d22a985116bb70$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $b4d22a985116bb70$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($b4d22a985116bb70$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($b4d22a985116bb70$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($b4d22a985116bb70$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($b4d22a985116bb70$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($b4d22a985116bb70$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $b4d22a985116bb70$var$stylizeWithColor;
    return $b4d22a985116bb70$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $b4d22a985116bb70$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$b4d22a985116bb70$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$b4d22a985116bb70$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $b4d22a985116bb70$var$stylizeWithColor(str, styleType) {
    var style = $b4d22a985116bb70$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $b4d22a985116bb70$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $b4d22a985116bb70$var$inspect.colors[style][1] + "m";
    else return str;
}
function $b4d22a985116bb70$var$stylizeNoColor(str, styleType) {
    return str;
}
function $b4d22a985116bb70$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $b4d22a985116bb70$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $b4d22a985116bb70$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$b4d22a985116bb70$var$isString(ret)) ret = $b4d22a985116bb70$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $b4d22a985116bb70$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $b4d22a985116bb70$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($b4d22a985116bb70$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $b4d22a985116bb70$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($b4d22a985116bb70$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($b4d22a985116bb70$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($b4d22a985116bb70$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($b4d22a985116bb70$var$isError(value)) return $b4d22a985116bb70$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($b4d22a985116bb70$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($b4d22a985116bb70$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($b4d22a985116bb70$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($b4d22a985116bb70$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($b4d22a985116bb70$var$isError(value)) base = " " + $b4d22a985116bb70$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($b4d22a985116bb70$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $b4d22a985116bb70$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $b4d22a985116bb70$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $b4d22a985116bb70$var$reduceToSingleString(output, base, braces);
}
function $b4d22a985116bb70$var$formatPrimitive(ctx, value) {
    if ($b4d22a985116bb70$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($b4d22a985116bb70$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($b4d22a985116bb70$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($b4d22a985116bb70$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($b4d22a985116bb70$var$isNull(value)) return ctx.stylize("null", "null");
}
function $b4d22a985116bb70$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $b4d22a985116bb70$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($b4d22a985116bb70$var$hasOwnProperty(value, String(i))) output.push($b4d22a985116bb70$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($b4d22a985116bb70$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $b4d22a985116bb70$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$b4d22a985116bb70$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($b4d22a985116bb70$var$isNull(recurseTimes)) str = $b4d22a985116bb70$var$formatValue(ctx, desc.value, null);
            else str = $b4d22a985116bb70$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($b4d22a985116bb70$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $b4d22a985116bb70$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("2lCoP"));
function $b4d22a985116bb70$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $b4d22a985116bb70$var$isArray;
function $b4d22a985116bb70$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $b4d22a985116bb70$var$isBoolean;
function $b4d22a985116bb70$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $b4d22a985116bb70$var$isNull;
function $b4d22a985116bb70$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $b4d22a985116bb70$var$isNullOrUndefined;
function $b4d22a985116bb70$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $b4d22a985116bb70$var$isNumber;
function $b4d22a985116bb70$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $b4d22a985116bb70$var$isString;
function $b4d22a985116bb70$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $b4d22a985116bb70$var$isSymbol;
function $b4d22a985116bb70$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $b4d22a985116bb70$var$isUndefined;
function $b4d22a985116bb70$var$isRegExp(re) {
    return $b4d22a985116bb70$var$isObject(re) && $b4d22a985116bb70$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $b4d22a985116bb70$var$isRegExp;
module.exports.types.isRegExp = $b4d22a985116bb70$var$isRegExp;
function $b4d22a985116bb70$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $b4d22a985116bb70$var$isObject;
function $b4d22a985116bb70$var$isDate(d) {
    return $b4d22a985116bb70$var$isObject(d) && $b4d22a985116bb70$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $b4d22a985116bb70$var$isDate;
module.exports.types.isDate = $b4d22a985116bb70$var$isDate;
function $b4d22a985116bb70$var$isError(e) {
    return $b4d22a985116bb70$var$isObject(e) && ($b4d22a985116bb70$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $b4d22a985116bb70$var$isError;
module.exports.types.isNativeError = $b4d22a985116bb70$var$isError;
function $b4d22a985116bb70$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $b4d22a985116bb70$var$isFunction;
function $b4d22a985116bb70$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $b4d22a985116bb70$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("jFc9f"));
function $b4d22a985116bb70$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $b4d22a985116bb70$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $b4d22a985116bb70$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $b4d22a985116bb70$var$timestamp() {
    var d = new Date();
    var time = [
        $b4d22a985116bb70$var$pad(d.getHours()),
        $b4d22a985116bb70$var$pad(d.getMinutes()),
        $b4d22a985116bb70$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $b4d22a985116bb70$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $b4d22a985116bb70$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lfl9G"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$b4d22a985116bb70$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $b4d22a985116bb70$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $b4d22a985116bb70$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($b4d22a985116bb70$var$kCustomPromisifiedSymbol && original[$b4d22a985116bb70$var$kCustomPromisifiedSymbol]) {
        var fn = original[$b4d22a985116bb70$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $b4d22a985116bb70$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($b4d22a985116bb70$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $b4d22a985116bb70$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $b4d22a985116bb70$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $b4d22a985116bb70$var$kCustomPromisifiedSymbol;
function $b4d22a985116bb70$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $b4d22a985116bb70$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $gbdt3.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $gbdt3.nextTick($b4d22a985116bb70$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $b4d22a985116bb70$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $b4d22a985116bb70$var$callbackify;

});
parcelRegister("2lCoP", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $a69ge = parcelRequire("a69ge");

var $aUdfk = parcelRequire("aUdfk");

var $fzA8V = parcelRequire("fzA8V");

var $bcEdg = parcelRequire("bcEdg");
function $1b5b5440dc32a742$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $1b5b5440dc32a742$var$BigIntSupported = typeof BigInt !== "undefined";
var $1b5b5440dc32a742$var$SymbolSupported = typeof Symbol !== "undefined";
var $1b5b5440dc32a742$var$ObjectToString = $1b5b5440dc32a742$var$uncurryThis(Object.prototype.toString);
var $1b5b5440dc32a742$var$numberValue = $1b5b5440dc32a742$var$uncurryThis(Number.prototype.valueOf);
var $1b5b5440dc32a742$var$stringValue = $1b5b5440dc32a742$var$uncurryThis(String.prototype.valueOf);
var $1b5b5440dc32a742$var$booleanValue = $1b5b5440dc32a742$var$uncurryThis(Boolean.prototype.valueOf);
if ($1b5b5440dc32a742$var$BigIntSupported) var $1b5b5440dc32a742$var$bigIntValue = $1b5b5440dc32a742$var$uncurryThis(BigInt.prototype.valueOf);
if ($1b5b5440dc32a742$var$SymbolSupported) var $1b5b5440dc32a742$var$symbolValue = $1b5b5440dc32a742$var$uncurryThis(Symbol.prototype.valueOf);
function $1b5b5440dc32a742$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $a69ge;
module.exports.isGeneratorFunction = $aUdfk;
module.exports.isTypedArray = $bcEdg;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $1b5b5440dc32a742$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $1b5b5440dc32a742$var$isPromise;
function $1b5b5440dc32a742$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $bcEdg(value) || $1b5b5440dc32a742$var$isDataView(value);
}
module.exports.isArrayBufferView = $1b5b5440dc32a742$var$isArrayBufferView;
function $1b5b5440dc32a742$var$isUint8Array(value) {
    return $fzA8V(value) === "Uint8Array";
}
module.exports.isUint8Array = $1b5b5440dc32a742$var$isUint8Array;
function $1b5b5440dc32a742$var$isUint8ClampedArray(value) {
    return $fzA8V(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $1b5b5440dc32a742$var$isUint8ClampedArray;
function $1b5b5440dc32a742$var$isUint16Array(value) {
    return $fzA8V(value) === "Uint16Array";
}
module.exports.isUint16Array = $1b5b5440dc32a742$var$isUint16Array;
function $1b5b5440dc32a742$var$isUint32Array(value) {
    return $fzA8V(value) === "Uint32Array";
}
module.exports.isUint32Array = $1b5b5440dc32a742$var$isUint32Array;
function $1b5b5440dc32a742$var$isInt8Array(value) {
    return $fzA8V(value) === "Int8Array";
}
module.exports.isInt8Array = $1b5b5440dc32a742$var$isInt8Array;
function $1b5b5440dc32a742$var$isInt16Array(value) {
    return $fzA8V(value) === "Int16Array";
}
module.exports.isInt16Array = $1b5b5440dc32a742$var$isInt16Array;
function $1b5b5440dc32a742$var$isInt32Array(value) {
    return $fzA8V(value) === "Int32Array";
}
module.exports.isInt32Array = $1b5b5440dc32a742$var$isInt32Array;
function $1b5b5440dc32a742$var$isFloat32Array(value) {
    return $fzA8V(value) === "Float32Array";
}
module.exports.isFloat32Array = $1b5b5440dc32a742$var$isFloat32Array;
function $1b5b5440dc32a742$var$isFloat64Array(value) {
    return $fzA8V(value) === "Float64Array";
}
module.exports.isFloat64Array = $1b5b5440dc32a742$var$isFloat64Array;
function $1b5b5440dc32a742$var$isBigInt64Array(value) {
    return $fzA8V(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $1b5b5440dc32a742$var$isBigInt64Array;
function $1b5b5440dc32a742$var$isBigUint64Array(value) {
    return $fzA8V(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $1b5b5440dc32a742$var$isBigUint64Array;
function $1b5b5440dc32a742$var$isMapToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object Map]";
}
$1b5b5440dc32a742$var$isMapToString.working = typeof Map !== "undefined" && $1b5b5440dc32a742$var$isMapToString(new Map());
function $1b5b5440dc32a742$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $1b5b5440dc32a742$var$isMapToString.working ? $1b5b5440dc32a742$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $1b5b5440dc32a742$var$isMap;
function $1b5b5440dc32a742$var$isSetToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object Set]";
}
$1b5b5440dc32a742$var$isSetToString.working = typeof Set !== "undefined" && $1b5b5440dc32a742$var$isSetToString(new Set());
function $1b5b5440dc32a742$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $1b5b5440dc32a742$var$isSetToString.working ? $1b5b5440dc32a742$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $1b5b5440dc32a742$var$isSet;
function $1b5b5440dc32a742$var$isWeakMapToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object WeakMap]";
}
$1b5b5440dc32a742$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $1b5b5440dc32a742$var$isWeakMapToString(new WeakMap());
function $1b5b5440dc32a742$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $1b5b5440dc32a742$var$isWeakMapToString.working ? $1b5b5440dc32a742$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $1b5b5440dc32a742$var$isWeakMap;
function $1b5b5440dc32a742$var$isWeakSetToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object WeakSet]";
}
$1b5b5440dc32a742$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $1b5b5440dc32a742$var$isWeakSetToString(new WeakSet());
function $1b5b5440dc32a742$var$isWeakSet(value) {
    return $1b5b5440dc32a742$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $1b5b5440dc32a742$var$isWeakSet;
function $1b5b5440dc32a742$var$isArrayBufferToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$1b5b5440dc32a742$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $1b5b5440dc32a742$var$isArrayBufferToString(new ArrayBuffer());
function $1b5b5440dc32a742$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $1b5b5440dc32a742$var$isArrayBufferToString.working ? $1b5b5440dc32a742$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $1b5b5440dc32a742$var$isArrayBuffer;
function $1b5b5440dc32a742$var$isDataViewToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object DataView]";
}
$1b5b5440dc32a742$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $1b5b5440dc32a742$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $1b5b5440dc32a742$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $1b5b5440dc32a742$var$isDataViewToString.working ? $1b5b5440dc32a742$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $1b5b5440dc32a742$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $1b5b5440dc32a742$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $1b5b5440dc32a742$var$isSharedArrayBufferToString(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $1b5b5440dc32a742$var$isSharedArrayBuffer(value) {
    if (typeof $1b5b5440dc32a742$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $1b5b5440dc32a742$var$isSharedArrayBufferToString.working === "undefined") $1b5b5440dc32a742$var$isSharedArrayBufferToString.working = $1b5b5440dc32a742$var$isSharedArrayBufferToString(new $1b5b5440dc32a742$var$SharedArrayBufferCopy());
    return $1b5b5440dc32a742$var$isSharedArrayBufferToString.working ? $1b5b5440dc32a742$var$isSharedArrayBufferToString(value) : value instanceof $1b5b5440dc32a742$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $1b5b5440dc32a742$var$isSharedArrayBuffer;
function $1b5b5440dc32a742$var$isAsyncFunction(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $1b5b5440dc32a742$var$isAsyncFunction;
function $1b5b5440dc32a742$var$isMapIterator(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $1b5b5440dc32a742$var$isMapIterator;
function $1b5b5440dc32a742$var$isSetIterator(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $1b5b5440dc32a742$var$isSetIterator;
function $1b5b5440dc32a742$var$isGeneratorObject(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $1b5b5440dc32a742$var$isGeneratorObject;
function $1b5b5440dc32a742$var$isWebAssemblyCompiledModule(value) {
    return $1b5b5440dc32a742$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $1b5b5440dc32a742$var$isWebAssemblyCompiledModule;
function $1b5b5440dc32a742$var$isNumberObject(value) {
    return $1b5b5440dc32a742$var$checkBoxedPrimitive(value, $1b5b5440dc32a742$var$numberValue);
}
module.exports.isNumberObject = $1b5b5440dc32a742$var$isNumberObject;
function $1b5b5440dc32a742$var$isStringObject(value) {
    return $1b5b5440dc32a742$var$checkBoxedPrimitive(value, $1b5b5440dc32a742$var$stringValue);
}
module.exports.isStringObject = $1b5b5440dc32a742$var$isStringObject;
function $1b5b5440dc32a742$var$isBooleanObject(value) {
    return $1b5b5440dc32a742$var$checkBoxedPrimitive(value, $1b5b5440dc32a742$var$booleanValue);
}
module.exports.isBooleanObject = $1b5b5440dc32a742$var$isBooleanObject;
function $1b5b5440dc32a742$var$isBigIntObject(value) {
    return $1b5b5440dc32a742$var$BigIntSupported && $1b5b5440dc32a742$var$checkBoxedPrimitive(value, $1b5b5440dc32a742$var$bigIntValue);
}
module.exports.isBigIntObject = $1b5b5440dc32a742$var$isBigIntObject;
function $1b5b5440dc32a742$var$isSymbolObject(value) {
    return $1b5b5440dc32a742$var$SymbolSupported && $1b5b5440dc32a742$var$checkBoxedPrimitive(value, $1b5b5440dc32a742$var$symbolValue);
}
module.exports.isSymbolObject = $1b5b5440dc32a742$var$isSymbolObject;
function $1b5b5440dc32a742$var$isBoxedPrimitive(value) {
    return $1b5b5440dc32a742$var$isNumberObject(value) || $1b5b5440dc32a742$var$isStringObject(value) || $1b5b5440dc32a742$var$isBooleanObject(value) || $1b5b5440dc32a742$var$isBigIntObject(value) || $1b5b5440dc32a742$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $1b5b5440dc32a742$var$isBoxedPrimitive;
function $1b5b5440dc32a742$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($1b5b5440dc32a742$var$isArrayBuffer(value) || $1b5b5440dc32a742$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $1b5b5440dc32a742$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("a69ge", function(module, exports) {
"use strict";

var $75a1a5ec22b43adf$var$hasToStringTag = (parcelRequire("9s4kl"))();

var $hWCYZ = parcelRequire("hWCYZ");
var $75a1a5ec22b43adf$var$$toString = $hWCYZ("Object.prototype.toString");
var $75a1a5ec22b43adf$var$isStandardArguments = function isArguments(value) {
    if ($75a1a5ec22b43adf$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $75a1a5ec22b43adf$var$$toString(value) === "[object Arguments]";
};
var $75a1a5ec22b43adf$var$isLegacyArguments = function isArguments(value) {
    if ($75a1a5ec22b43adf$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $75a1a5ec22b43adf$var$$toString(value) !== "[object Array]" && $75a1a5ec22b43adf$var$$toString(value.callee) === "[object Function]";
};
var $75a1a5ec22b43adf$var$supportsStandardArguments = function() {
    return $75a1a5ec22b43adf$var$isStandardArguments(arguments);
}();
$75a1a5ec22b43adf$var$isStandardArguments.isLegacyArguments = $75a1a5ec22b43adf$var$isLegacyArguments; // for tests
module.exports = $75a1a5ec22b43adf$var$supportsStandardArguments ? $75a1a5ec22b43adf$var$isStandardArguments : $75a1a5ec22b43adf$var$isLegacyArguments;

});
parcelRegister("9s4kl", function(module, exports) {
"use strict";

var $ljx32 = parcelRequire("ljx32");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $ljx32() && !!Symbol.toStringTag;
};

});
parcelRegister("ljx32", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hWCYZ", function(module, exports) {
"use strict";

var $fFt6A = parcelRequire("fFt6A");

var $5TThM = parcelRequire("5TThM");
var $d1061794738dd02f$var$$indexOf = $5TThM($fFt6A("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $fFt6A(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d1061794738dd02f$var$$indexOf(name, ".prototype.") > -1) return $5TThM(intrinsic);
    return intrinsic;
};

});
parcelRegister("fFt6A", function(module, exports) {
"use strict";
var $b68143119e837f6d$var$undefined1;

var $eBg0O = parcelRequire("eBg0O");

var $oBPi7 = parcelRequire("oBPi7");

var $de511 = parcelRequire("de511");

var $iiBZs = parcelRequire("iiBZs");

var $6hKgi = parcelRequire("6hKgi");

var $jr432 = parcelRequire("jr432");

var $3V7ap = parcelRequire("3V7ap");
var $b68143119e837f6d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $b68143119e837f6d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $b68143119e837f6d$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $b68143119e837f6d$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($b68143119e837f6d$var$$gOPD) try {
    $b68143119e837f6d$var$$gOPD({}, "");
} catch (e) {
    $b68143119e837f6d$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $b68143119e837f6d$var$throwTypeError = function() {
    throw new $jr432();
};
var $b68143119e837f6d$var$ThrowTypeError = $b68143119e837f6d$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $b68143119e837f6d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $b68143119e837f6d$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $b68143119e837f6d$var$throwTypeError;
        }
    }
}() : $b68143119e837f6d$var$throwTypeError;

var $b68143119e837f6d$var$hasSymbols = (parcelRequire("5sypd"))();

var $b68143119e837f6d$var$hasProto = (parcelRequire("2utNx"))();
var $b68143119e837f6d$var$getProto = Object.getPrototypeOf || ($b68143119e837f6d$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $b68143119e837f6d$var$needsEval = {};
var $b68143119e837f6d$var$TypedArray = typeof Uint8Array === "undefined" || !$b68143119e837f6d$var$getProto ? undefined : $b68143119e837f6d$var$getProto(Uint8Array);
var $b68143119e837f6d$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $b68143119e837f6d$var$hasSymbols && $b68143119e837f6d$var$getProto ? $b68143119e837f6d$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $b68143119e837f6d$var$needsEval,
    "%AsyncGenerator%": $b68143119e837f6d$var$needsEval,
    "%AsyncGeneratorFunction%": $b68143119e837f6d$var$needsEval,
    "%AsyncIteratorPrototype%": $b68143119e837f6d$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $eBg0O,
    "%eval%": eval,
    "%EvalError%": $oBPi7,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $b68143119e837f6d$var$$Function,
    "%GeneratorFunction%": $b68143119e837f6d$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $b68143119e837f6d$var$hasSymbols && $b68143119e837f6d$var$getProto ? $b68143119e837f6d$var$getProto($b68143119e837f6d$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$b68143119e837f6d$var$hasSymbols || !$b68143119e837f6d$var$getProto ? undefined : $b68143119e837f6d$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $de511,
    "%ReferenceError%": $iiBZs,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$b68143119e837f6d$var$hasSymbols || !$b68143119e837f6d$var$getProto ? undefined : $b68143119e837f6d$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $b68143119e837f6d$var$hasSymbols && $b68143119e837f6d$var$getProto ? $b68143119e837f6d$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $b68143119e837f6d$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $6hKgi,
    "%ThrowTypeError%": $b68143119e837f6d$var$ThrowTypeError,
    "%TypedArray%": $b68143119e837f6d$var$TypedArray,
    "%TypeError%": $jr432,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $3V7ap,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($b68143119e837f6d$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $b68143119e837f6d$var$errorProto = $b68143119e837f6d$var$getProto($b68143119e837f6d$var$getProto(e));
    $b68143119e837f6d$var$INTRINSICS["%Error.prototype%"] = $b68143119e837f6d$var$errorProto;
}
var $b68143119e837f6d$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $b68143119e837f6d$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $b68143119e837f6d$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $b68143119e837f6d$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $b68143119e837f6d$var$getProto) value = $b68143119e837f6d$var$getProto(gen.prototype);
    }
    $b68143119e837f6d$var$INTRINSICS[name] = value;
    return value;
};
var $b68143119e837f6d$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $7vsvt = parcelRequire("7vsvt");

var $3bFEM = parcelRequire("3bFEM");
var $b68143119e837f6d$var$$concat = $7vsvt.call(Function.call, Array.prototype.concat);
var $b68143119e837f6d$var$$spliceApply = $7vsvt.call(Function.apply, Array.prototype.splice);
var $b68143119e837f6d$var$$replace = $7vsvt.call(Function.call, String.prototype.replace);
var $b68143119e837f6d$var$$strSlice = $7vsvt.call(Function.call, String.prototype.slice);
var $b68143119e837f6d$var$$exec = $7vsvt.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $b68143119e837f6d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $b68143119e837f6d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $b68143119e837f6d$var$stringToPath = function stringToPath(string) {
    var first = $b68143119e837f6d$var$$strSlice(string, 0, 1);
    var last = $b68143119e837f6d$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $6hKgi("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $6hKgi("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $b68143119e837f6d$var$$replace(string, $b68143119e837f6d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $b68143119e837f6d$var$$replace(subString, $b68143119e837f6d$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $b68143119e837f6d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($3bFEM($b68143119e837f6d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $b68143119e837f6d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($3bFEM($b68143119e837f6d$var$INTRINSICS, intrinsicName)) {
        var value = $b68143119e837f6d$var$INTRINSICS[intrinsicName];
        if (value === $b68143119e837f6d$var$needsEval) value = $b68143119e837f6d$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $jr432("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6hKgi("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $jr432("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $jr432('"allowMissing" argument must be a boolean');
    if ($b68143119e837f6d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6hKgi("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $b68143119e837f6d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $b68143119e837f6d$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $b68143119e837f6d$var$$spliceApply(parts, $b68143119e837f6d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $b68143119e837f6d$var$$strSlice(part, 0, 1);
        var last = $b68143119e837f6d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $6hKgi("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($3bFEM($b68143119e837f6d$var$INTRINSICS, intrinsicRealName)) value = $b68143119e837f6d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jr432("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($b68143119e837f6d$var$$gOPD && i + 1 >= parts.length) {
                var desc = $b68143119e837f6d$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $3bFEM(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $b68143119e837f6d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("eBg0O", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("oBPi7", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("de511", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("iiBZs", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6hKgi", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("jr432", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("3V7ap", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("5sypd", function(module, exports) {
"use strict";
var $3f9a41827dc6f208$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $ljx32 = parcelRequire("ljx32");
module.exports = function hasNativeSymbols() {
    if (typeof $3f9a41827dc6f208$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $3f9a41827dc6f208$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $ljx32();
};

});

parcelRegister("2utNx", function(module, exports) {
"use strict";
var $1d057f6215df77f0$var$test = {
    __proto__: null,
    foo: {}
};
var $1d057f6215df77f0$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $1d057f6215df77f0$var$test
    }).foo === $1d057f6215df77f0$var$test.foo && !($1d057f6215df77f0$var$test instanceof $1d057f6215df77f0$var$$Object);
};

});

parcelRegister("7vsvt", function(module, exports) {
"use strict";

var $b4qB1 = parcelRequire("b4qB1");
module.exports = Function.prototype.bind || $b4qB1;

});
parcelRegister("b4qB1", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $80f4b2d8556cb19c$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $80f4b2d8556cb19c$var$toStr = Object.prototype.toString;
var $80f4b2d8556cb19c$var$max = Math.max;
var $80f4b2d8556cb19c$var$funcType = "[object Function]";
var $80f4b2d8556cb19c$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $80f4b2d8556cb19c$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $80f4b2d8556cb19c$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $80f4b2d8556cb19c$var$toStr.apply(target) !== $80f4b2d8556cb19c$var$funcType) throw new TypeError($80f4b2d8556cb19c$var$ERROR_MESSAGE + target);
    var args = $80f4b2d8556cb19c$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $80f4b2d8556cb19c$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $80f4b2d8556cb19c$var$concatty(args, arguments));
    };
    var boundLength = $80f4b2d8556cb19c$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $80f4b2d8556cb19c$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("3bFEM", function(module, exports) {
"use strict";
var $2522b651654f4228$var$call = Function.prototype.call;
var $2522b651654f4228$var$$hasOwn = Object.prototype.hasOwnProperty;

var $7vsvt = parcelRequire("7vsvt");
/** @type {import('.')} */ module.exports = $7vsvt.call($2522b651654f4228$var$call, $2522b651654f4228$var$$hasOwn);

});


parcelRegister("5TThM", function(module, exports) {
"use strict";

var $7vsvt = parcelRequire("7vsvt");

var $fFt6A = parcelRequire("fFt6A");

var $gFBRs = parcelRequire("gFBRs");

var $jr432 = parcelRequire("jr432");
var $44bcf968fd424d6d$var$$apply = $fFt6A("%Function.prototype.apply%");
var $44bcf968fd424d6d$var$$call = $fFt6A("%Function.prototype.call%");
var $44bcf968fd424d6d$var$$reflectApply = $fFt6A("%Reflect.apply%", true) || $7vsvt.call($44bcf968fd424d6d$var$$call, $44bcf968fd424d6d$var$$apply);

var $28LBt = parcelRequire("28LBt");
var $44bcf968fd424d6d$var$$max = $fFt6A("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $jr432("a function is required");
    var func = $44bcf968fd424d6d$var$$reflectApply($7vsvt, $44bcf968fd424d6d$var$$call, arguments);
    return $gFBRs(func, 1 + $44bcf968fd424d6d$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $44bcf968fd424d6d$var$applyBind = function applyBind() {
    return $44bcf968fd424d6d$var$$reflectApply($7vsvt, $44bcf968fd424d6d$var$$apply, arguments);
};
if ($28LBt) $28LBt(module.exports, "apply", {
    value: $44bcf968fd424d6d$var$applyBind
});
else module.exports.apply = $44bcf968fd424d6d$var$applyBind;

});
parcelRegister("gFBRs", function(module, exports) {
"use strict";

var $fFt6A = parcelRequire("fFt6A");

var $II55L = parcelRequire("II55L");

var $c22dd824e5ab52f2$var$hasDescriptors = (parcelRequire("9Aa3x"))();

var $3GnYg = parcelRequire("3GnYg");

var $jr432 = parcelRequire("jr432");
var $c22dd824e5ab52f2$var$$floor = $fFt6A("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $jr432("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $c22dd824e5ab52f2$var$$floor(length) !== length) throw new $jr432("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $3GnYg) {
        var desc = $3GnYg(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($c22dd824e5ab52f2$var$hasDescriptors) $II55L(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $II55L(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("II55L", function(module, exports) {
"use strict";

var $28LBt = parcelRequire("28LBt");

var $6hKgi = parcelRequire("6hKgi");

var $jr432 = parcelRequire("jr432");

var $3GnYg = parcelRequire("3GnYg");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $jr432("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $jr432("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $jr432("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $jr432("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $jr432("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $jr432("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$3GnYg && $3GnYg(obj, property);
    if ($28LBt) $28LBt(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6hKgi("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("28LBt", function(module, exports) {
"use strict";

var $fFt6A = parcelRequire("fFt6A");
/** @type {import('.')} */ var $18f1412a2fabf1f7$var$$defineProperty = $fFt6A("%Object.defineProperty%", true) || false;
if ($18f1412a2fabf1f7$var$$defineProperty) try {
    $18f1412a2fabf1f7$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $18f1412a2fabf1f7$var$$defineProperty = false;
}
module.exports = $18f1412a2fabf1f7$var$$defineProperty;

});

parcelRegister("3GnYg", function(module, exports) {
"use strict";

var $fFt6A = parcelRequire("fFt6A");
var $2ae7e37c58a65d4a$var$$gOPD = $fFt6A("%Object.getOwnPropertyDescriptor%", true);
if ($2ae7e37c58a65d4a$var$$gOPD) try {
    $2ae7e37c58a65d4a$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $2ae7e37c58a65d4a$var$$gOPD = null;
}
module.exports = $2ae7e37c58a65d4a$var$$gOPD;

});


parcelRegister("9Aa3x", function(module, exports) {
"use strict";

var $28LBt = parcelRequire("28LBt");
var $6f9f46cb584a5f4b$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$28LBt;
};
$6f9f46cb584a5f4b$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$28LBt) return null;
    try {
        return $28LBt([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6f9f46cb584a5f4b$var$hasPropertyDescriptors;

});





parcelRegister("aUdfk", function(module, exports) {
"use strict";
var $7f0968c2b6007068$var$toStr = Object.prototype.toString;
var $7f0968c2b6007068$var$fnToStr = Function.prototype.toString;
var $7f0968c2b6007068$var$isFnRegex = /^\s*(?:function)?\*/;

var $7f0968c2b6007068$var$hasToStringTag = (parcelRequire("9s4kl"))();
var $7f0968c2b6007068$var$getProto = Object.getPrototypeOf;
var $7f0968c2b6007068$var$getGeneratorFunc = function() {
    if (!$7f0968c2b6007068$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $7f0968c2b6007068$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($7f0968c2b6007068$var$isFnRegex.test($7f0968c2b6007068$var$fnToStr.call(fn))) return true;
    if (!$7f0968c2b6007068$var$hasToStringTag) {
        var str = $7f0968c2b6007068$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$7f0968c2b6007068$var$getProto) return false;
    if (typeof $7f0968c2b6007068$var$GeneratorFunction === "undefined") {
        var generatorFunc = $7f0968c2b6007068$var$getGeneratorFunc();
        $7f0968c2b6007068$var$GeneratorFunction = generatorFunc ? $7f0968c2b6007068$var$getProto(generatorFunc) : false;
    }
    return $7f0968c2b6007068$var$getProto(fn) === $7f0968c2b6007068$var$GeneratorFunction;
};

});

parcelRegister("fzA8V", function(module, exports) {
"use strict";

var $65uri = parcelRequire("65uri");

var $atOlW = parcelRequire("atOlW");

var $5TThM = parcelRequire("5TThM");

var $hWCYZ = parcelRequire("hWCYZ");

var $3GnYg = parcelRequire("3GnYg");
/** @type {(O: object) => string} */ var $b566291e595c589f$var$$toString = $hWCYZ("Object.prototype.toString");

var $b566291e595c589f$var$hasToStringTag = (parcelRequire("9s4kl"))();
var $b566291e595c589f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $b566291e595c589f$var$typedArrays = $atOlW();
var $b566291e595c589f$var$$slice = $hWCYZ("String.prototype.slice");
var $b566291e595c589f$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $b566291e595c589f$var$$indexOf = $hWCYZ("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $b566291e595c589f$var$cache = {
    __proto__: null
};
if ($b566291e595c589f$var$hasToStringTag && $3GnYg && $b566291e595c589f$var$getPrototypeOf) $65uri($b566291e595c589f$var$typedArrays, function(typedArray) {
    var arr = new $b566291e595c589f$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $b566291e595c589f$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $3GnYg(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $b566291e595c589f$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $3GnYg(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $b566291e595c589f$var$cache["$" + typedArray] = $5TThM(descriptor.get);
    }
});
else $65uri($b566291e595c589f$var$typedArrays, function(typedArray) {
    var arr = new $b566291e595c589f$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $b566291e595c589f$var$cache["$" + typedArray] = $5TThM(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $b566291e595c589f$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $65uri(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $b566291e595c589f$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $b566291e595c589f$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $b566291e595c589f$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $65uri(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $b566291e595c589f$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $b566291e595c589f$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$b566291e595c589f$var$hasToStringTag) {
        /** @type {string} */ var tag = $b566291e595c589f$var$$slice($b566291e595c589f$var$$toString(value), 8, -1);
        if ($b566291e595c589f$var$$indexOf($b566291e595c589f$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $b566291e595c589f$var$trySlices(value);
    }
    if (!$3GnYg) return null;
     // unknown engine
    return $b566291e595c589f$var$tryTypedArrays(value);
};

});
parcelRegister("65uri", function(module, exports) {
"use strict";

var $37lBg = parcelRequire("37lBg");
var $46ead2493fce8f24$var$toStr = Object.prototype.toString;
var $46ead2493fce8f24$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $46ead2493fce8f24$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($46ead2493fce8f24$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $46ead2493fce8f24$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $46ead2493fce8f24$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($46ead2493fce8f24$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $46ead2493fce8f24$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$37lBg(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($46ead2493fce8f24$var$toStr.call(list) === "[object Array]") $46ead2493fce8f24$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $46ead2493fce8f24$var$forEachString(list, iterator, receiver);
    else $46ead2493fce8f24$var$forEachObject(list, iterator, receiver);
};
module.exports = $46ead2493fce8f24$var$forEach;

});
parcelRegister("37lBg", function(module, exports) {
"use strict";
var $2452c7e15ef4f6b1$var$fnToStr = Function.prototype.toString;
var $2452c7e15ef4f6b1$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $2452c7e15ef4f6b1$var$badArrayLike;
var $2452c7e15ef4f6b1$var$isCallableMarker;
if (typeof $2452c7e15ef4f6b1$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $2452c7e15ef4f6b1$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $2452c7e15ef4f6b1$var$isCallableMarker;
        }
    });
    $2452c7e15ef4f6b1$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $2452c7e15ef4f6b1$var$reflectApply(function() {
        throw 42;
    }, null, $2452c7e15ef4f6b1$var$badArrayLike);
} catch (_) {
    if (_ !== $2452c7e15ef4f6b1$var$isCallableMarker) $2452c7e15ef4f6b1$var$reflectApply = null;
}
else $2452c7e15ef4f6b1$var$reflectApply = null;
var $2452c7e15ef4f6b1$var$constructorRegex = /^\s*class\b/;
var $2452c7e15ef4f6b1$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $2452c7e15ef4f6b1$var$fnToStr.call(value);
        return $2452c7e15ef4f6b1$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $2452c7e15ef4f6b1$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($2452c7e15ef4f6b1$var$isES6ClassFn(value)) return false;
        $2452c7e15ef4f6b1$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $2452c7e15ef4f6b1$var$toStr = Object.prototype.toString;
var $2452c7e15ef4f6b1$var$objectClass = "[object Object]";
var $2452c7e15ef4f6b1$var$fnClass = "[object Function]";
var $2452c7e15ef4f6b1$var$genClass = "[object GeneratorFunction]";
var $2452c7e15ef4f6b1$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $2452c7e15ef4f6b1$var$ddaClass2 = "[object HTML document.all class]";
var $2452c7e15ef4f6b1$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $2452c7e15ef4f6b1$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $2452c7e15ef4f6b1$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $2452c7e15ef4f6b1$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $2452c7e15ef4f6b1$var$all = document.all;
    if ($2452c7e15ef4f6b1$var$toStr.call($2452c7e15ef4f6b1$var$all) === $2452c7e15ef4f6b1$var$toStr.call(document.all)) $2452c7e15ef4f6b1$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($2452c7e15ef4f6b1$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $2452c7e15ef4f6b1$var$toStr.call(value);
            return (str === $2452c7e15ef4f6b1$var$ddaClass || str === $2452c7e15ef4f6b1$var$ddaClass2 || str === $2452c7e15ef4f6b1$var$ddaClass3 // opera 12.16
             || str === $2452c7e15ef4f6b1$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $2452c7e15ef4f6b1$var$reflectApply ? function isCallable(value) {
    if ($2452c7e15ef4f6b1$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $2452c7e15ef4f6b1$var$reflectApply(value, null, $2452c7e15ef4f6b1$var$badArrayLike);
    } catch (e) {
        if (e !== $2452c7e15ef4f6b1$var$isCallableMarker) return false;
    }
    return !$2452c7e15ef4f6b1$var$isES6ClassFn(value) && $2452c7e15ef4f6b1$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($2452c7e15ef4f6b1$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($2452c7e15ef4f6b1$var$hasToStringTag) return $2452c7e15ef4f6b1$var$tryFunctionObject(value);
    if ($2452c7e15ef4f6b1$var$isES6ClassFn(value)) return false;
    var strClass = $2452c7e15ef4f6b1$var$toStr.call(value);
    if (strClass !== $2452c7e15ef4f6b1$var$fnClass && strClass !== $2452c7e15ef4f6b1$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $2452c7e15ef4f6b1$var$tryFunctionObject(value);
};

});


parcelRegister("atOlW", function(module, exports) {
"use strict";

var $d8SqV = parcelRequire("d8SqV");
var $7a13abdb57e004fa$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $d8SqV.length; i++)if (typeof $7a13abdb57e004fa$var$g[$d8SqV[i]] === "function") // @ts-expect-error
    out[out.length] = $d8SqV[i];
    return out;
};

});
parcelRegister("d8SqV", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("bcEdg", function(module, exports) {
"use strict";

var $fzA8V = parcelRequire("fzA8V");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$fzA8V(value);
};

});


parcelRegister("jFc9f", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRegister("1iZQe", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
function $0f37714a102cf0e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f37714a102cf0e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f37714a102cf0e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0f37714a102cf0e9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f37714a102cf0e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0f37714a102cf0e9$var$_defineProperty(obj, key, value) {
    key = $0f37714a102cf0e9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f37714a102cf0e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0f37714a102cf0e9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0f37714a102cf0e9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0f37714a102cf0e9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0f37714a102cf0e9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0f37714a102cf0e9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0f37714a102cf0e9$var$_toPropertyKey(arg) {
    var key = $0f37714a102cf0e9$var$_toPrimitive(arg, "string");
    return $0f37714a102cf0e9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0f37714a102cf0e9$var$_toPrimitive(input, hint) {
    if ($0f37714a102cf0e9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0f37714a102cf0e9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0f37714a102cf0e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0f37714a102cf0e9$var$_setPrototypeOf(subClass, superClass);
}
function $0f37714a102cf0e9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0f37714a102cf0e9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0f37714a102cf0e9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0f37714a102cf0e9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0f37714a102cf0e9$var$_possibleConstructorReturn(this, result);
    };
}
function $0f37714a102cf0e9$var$_possibleConstructorReturn(self, call) {
    if (call && ($0f37714a102cf0e9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0f37714a102cf0e9$var$_assertThisInitialized(self);
}
function $0f37714a102cf0e9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0f37714a102cf0e9$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $0f37714a102cf0e9$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$0f37714a102cf0e9$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $0f37714a102cf0e9$var$_construct(Class, arguments, $0f37714a102cf0e9$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $0f37714a102cf0e9$var$_setPrototypeOf(Wrapper, Class);
    };
    return $0f37714a102cf0e9$var$_wrapNativeSuper(Class);
}
function $0f37714a102cf0e9$var$_construct(Parent, args, Class) {
    if ($0f37714a102cf0e9$var$_isNativeReflectConstruct()) $0f37714a102cf0e9$var$_construct = Reflect.construct.bind();
    else $0f37714a102cf0e9$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $0f37714a102cf0e9$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $0f37714a102cf0e9$var$_construct.apply(null, arguments);
}
function $0f37714a102cf0e9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0f37714a102cf0e9$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $0f37714a102cf0e9$var$_setPrototypeOf(o, p) {
    $0f37714a102cf0e9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0f37714a102cf0e9$var$_setPrototypeOf(o, p);
}
function $0f37714a102cf0e9$var$_getPrototypeOf(o) {
    $0f37714a102cf0e9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0f37714a102cf0e9$var$_getPrototypeOf(o);
}
function $0f37714a102cf0e9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0f37714a102cf0e9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0f37714a102cf0e9$var$_typeof(o);
}

var $fwvm4 = parcelRequire("fwvm4");
var $0f37714a102cf0e9$var$inspect = $fwvm4.inspect;

var $BSX8Z = parcelRequire("BSX8Z");
var $0f37714a102cf0e9$var$ERR_INVALID_ARG_TYPE = $BSX8Z.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $0f37714a102cf0e9$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $0f37714a102cf0e9$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $0f37714a102cf0e9$var$blue = "";
var $0f37714a102cf0e9$var$green = "";
var $0f37714a102cf0e9$var$red = "";
var $0f37714a102cf0e9$var$white = "";
var $0f37714a102cf0e9$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $0f37714a102cf0e9$var$kMaxShortLength = 10;
function $0f37714a102cf0e9$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $0f37714a102cf0e9$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $0f37714a102cf0e9$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $0f37714a102cf0e9$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $0f37714a102cf0e9$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $0f37714a102cf0e9$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $0f37714a102cf0e9$var$_typeof(actual) === "object" && $0f37714a102cf0e9$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $0f37714a102cf0e9$var$kMaxShortLength) {
            if (($0f37714a102cf0e9$var$_typeof(actual) !== "object" || actual === null) && ($0f37714a102cf0e9$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($0f37714a102cf0e9$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $gbdt3.stderr && $gbdt3.stderr.isTTY ? $gbdt3.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($0f37714a102cf0e9$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($0f37714a102cf0e9$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $0f37714a102cf0e9$var$kReadableOperator[operator] + "\n".concat($0f37714a102cf0e9$var$green, "+ actual").concat($0f37714a102cf0e9$var$white, " ").concat($0f37714a102cf0e9$var$red, "- expected").concat($0f37714a102cf0e9$var$white);
    var skippedMsg = " ".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($0f37714a102cf0e9$var$red, "-").concat($0f37714a102cf0e9$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($0f37714a102cf0e9$var$green, "+").concat($0f37714a102cf0e9$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$0f37714a102cf0e9$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $0f37714a102cf0e9$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($0f37714a102cf0e9$var$green, "+").concat($0f37714a102cf0e9$var$white, " ").concat(actualLine);
                other += "\n".concat($0f37714a102cf0e9$var$red, "-").concat($0f37714a102cf0e9$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white).concat(other, "\n") + "".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $0f37714a102cf0e9$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $0f37714a102cf0e9$var$_inherits(AssertionError, _Error);
    var _super = $0f37714a102cf0e9$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $0f37714a102cf0e9$var$_classCallCheck(this, AssertionError);
        if ($0f37714a102cf0e9$var$_typeof(options) !== "object" || options === null) throw new $0f37714a102cf0e9$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($gbdt3.stderr && $gbdt3.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($gbdt3.stderr && $gbdt3.stderr.getColorDepth && $gbdt3.stderr.getColorDepth() !== 1) {
                    $0f37714a102cf0e9$var$blue = "\x1b[34m";
                    $0f37714a102cf0e9$var$green = "\x1b[32m";
                    $0f37714a102cf0e9$var$white = "\x1b[39m";
                    $0f37714a102cf0e9$var$red = "\x1b[31m";
                } else {
                    $0f37714a102cf0e9$var$blue = "";
                    $0f37714a102cf0e9$var$green = "";
                    $0f37714a102cf0e9$var$white = "";
                    $0f37714a102cf0e9$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($0f37714a102cf0e9$var$_typeof(actual) === "object" && actual !== null && $0f37714a102cf0e9$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $0f37714a102cf0e9$var$copyError(actual);
                expected = $0f37714a102cf0e9$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $0f37714a102cf0e9$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $0f37714a102cf0e9$var$kReadableOperator[operator];
                var res = $0f37714a102cf0e9$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $0f37714a102cf0e9$var$_typeof(actual) === "object" && actual !== null) base = $0f37714a102cf0e9$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($0f37714a102cf0e9$var$blue, "...").concat($0f37714a102cf0e9$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $0f37714a102cf0e9$var$inspectValue(actual);
                var other = "";
                var knownOperators = $0f37714a102cf0e9$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($0f37714a102cf0e9$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($0f37714a102cf0e9$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($0f37714a102cf0e9$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($0f37714a102cf0e9$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $0f37714a102cf0e9$var$_possibleConstructorReturn(_this);
    }
    $0f37714a102cf0e9$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $0f37714a102cf0e9$var$inspect(this, $0f37714a102cf0e9$var$_objectSpread($0f37714a102cf0e9$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $0f37714a102cf0e9$var$_wrapNativeSuper(Error), $0f37714a102cf0e9$var$inspect.custom);
module.exports = $0f37714a102cf0e9$var$AssertionError;

});

parcelRegister("aosFD", function(module, exports) {
"use strict";

var $lkSIQ = parcelRequire("lkSIQ");
var $791262aa831033fc$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $791262aa831033fc$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $lkSIQ;
    if ($791262aa831033fc$var$lacksProperEnumerationOrder()) return $lkSIQ;
    if ($791262aa831033fc$var$assignHasPendingExceptions()) return $lkSIQ;
    return Object.assign;
};

});
parcelRegister("lkSIQ", function(module, exports) {
"use strict";

var $iciC9 = parcelRequire("iciC9");

var $f885e9f1dae93245$var$hasSymbols = (parcelRequire("ljx32"))();

var $hWCYZ = parcelRequire("hWCYZ");
var $f885e9f1dae93245$var$toObject = Object;
var $f885e9f1dae93245$var$$push = $hWCYZ("Array.prototype.push");
var $f885e9f1dae93245$var$$propIsEnumerable = $hWCYZ("Object.prototype.propertyIsEnumerable");
var $f885e9f1dae93245$var$originalGetSymbols = $f885e9f1dae93245$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $f885e9f1dae93245$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $f885e9f1dae93245$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $iciC9(from);
        var getSymbols = $f885e9f1dae93245$var$hasSymbols && (Object.getOwnPropertySymbols || $f885e9f1dae93245$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($f885e9f1dae93245$var$$propIsEnumerable(from, key)) $f885e9f1dae93245$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($f885e9f1dae93245$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("iciC9", function(module, exports) {
"use strict";
var $d3f7c96519d754b6$var$slice = Array.prototype.slice;

var $gfSkn = parcelRequire("gfSkn");
var $d3f7c96519d754b6$var$origKeys = Object.keys;

var $d3f7c96519d754b6$var$keysShim = $d3f7c96519d754b6$var$origKeys ? function keys(o) {
    return $d3f7c96519d754b6$var$origKeys(o);
} : (parcelRequire("8HLfP"));
var $d3f7c96519d754b6$var$originalKeys = Object.keys;
$d3f7c96519d754b6$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($gfSkn(object)) return $d3f7c96519d754b6$var$originalKeys($d3f7c96519d754b6$var$slice.call(object));
            return $d3f7c96519d754b6$var$originalKeys(object);
        };
    } else Object.keys = $d3f7c96519d754b6$var$keysShim;
    return Object.keys || $d3f7c96519d754b6$var$keysShim;
};
module.exports = $d3f7c96519d754b6$var$keysShim;

});
parcelRegister("gfSkn", function(module, exports) {
"use strict";
var $bd5830640f449072$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $bd5830640f449072$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $bd5830640f449072$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("8HLfP", function(module, exports) {
"use strict";
var $6566fe9ff5335208$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $6566fe9ff5335208$var$has = Object.prototype.hasOwnProperty;
    var $6566fe9ff5335208$var$toStr = Object.prototype.toString;
    var $6566fe9ff5335208$var$isArgs = (parcelRequire("gfSkn")); // eslint-disable-line global-require
    var $6566fe9ff5335208$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $6566fe9ff5335208$var$hasDontEnumBug = !$6566fe9ff5335208$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $6566fe9ff5335208$var$hasProtoEnumBug = $6566fe9ff5335208$var$isEnumerable.call(function() {}, "prototype");
    var $6566fe9ff5335208$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $6566fe9ff5335208$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $6566fe9ff5335208$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $6566fe9ff5335208$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$6566fe9ff5335208$var$excludedKeys["$" + k] && $6566fe9ff5335208$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $6566fe9ff5335208$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $6566fe9ff5335208$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$6566fe9ff5335208$var$hasAutomationEqualityBug) return $6566fe9ff5335208$var$equalsConstructorPrototype(o);
        try {
            return $6566fe9ff5335208$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $6566fe9ff5335208$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $6566fe9ff5335208$var$toStr.call(object) === "[object Function]";
        var isArguments = $6566fe9ff5335208$var$isArgs(object);
        var isString = isObject && $6566fe9ff5335208$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $6566fe9ff5335208$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$6566fe9ff5335208$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $6566fe9ff5335208$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($6566fe9ff5335208$var$hasDontEnumBug) {
            var skipConstructor = $6566fe9ff5335208$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $6566fe9ff5335208$var$dontEnums.length; ++k)if (!(skipConstructor && $6566fe9ff5335208$var$dontEnums[k] === "constructor") && $6566fe9ff5335208$var$has.call(object, $6566fe9ff5335208$var$dontEnums[k])) theKeys.push($6566fe9ff5335208$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $6566fe9ff5335208$var$keysShim;

});




parcelRegister("hfZz9", function(module, exports) {
"use strict";

var $4Bt3m = parcelRequire("4Bt3m");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $4Bt3m;
};

});
parcelRegister("4Bt3m", function(module, exports) {
"use strict";
var $35a1277f454be3e2$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($35a1277f454be3e2$var$numberIsNaN(a) && $35a1277f454be3e2$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("jntFm", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $e1b72d5f75e4c48c$var$_slicedToArray(arr, i) {
    return $e1b72d5f75e4c48c$var$_arrayWithHoles(arr) || $e1b72d5f75e4c48c$var$_iterableToArrayLimit(arr, i) || $e1b72d5f75e4c48c$var$_unsupportedIterableToArray(arr, i) || $e1b72d5f75e4c48c$var$_nonIterableRest();
}
function $e1b72d5f75e4c48c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e1b72d5f75e4c48c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e1b72d5f75e4c48c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e1b72d5f75e4c48c$var$_arrayLikeToArray(o, minLen);
}
function $e1b72d5f75e4c48c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e1b72d5f75e4c48c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e1b72d5f75e4c48c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e1b72d5f75e4c48c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e1b72d5f75e4c48c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e1b72d5f75e4c48c$var$_typeof(o);
}
var $e1b72d5f75e4c48c$var$regexFlagsSupported = /a/g.flags !== undefined;
var $e1b72d5f75e4c48c$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $e1b72d5f75e4c48c$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $e1b72d5f75e4c48c$var$objectIs = Object.is ? Object.is : (parcelRequire("1TCw5"));
var $e1b72d5f75e4c48c$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $e1b72d5f75e4c48c$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("cpMdn"));
function $e1b72d5f75e4c48c$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e1b72d5f75e4c48c$var$hasOwnProperty = $e1b72d5f75e4c48c$var$uncurryThis(Object.prototype.hasOwnProperty);
var $e1b72d5f75e4c48c$var$propertyIsEnumerable = $e1b72d5f75e4c48c$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $e1b72d5f75e4c48c$var$objectToString = $e1b72d5f75e4c48c$var$uncurryThis(Object.prototype.toString);

var $fwvm4 = parcelRequire("fwvm4");
var $e1b72d5f75e4c48c$require$_require$types = $fwvm4.types;
var $e1b72d5f75e4c48c$var$isAnyArrayBuffer = $e1b72d5f75e4c48c$require$_require$types.isAnyArrayBuffer, $e1b72d5f75e4c48c$var$isArrayBufferView = $e1b72d5f75e4c48c$require$_require$types.isArrayBufferView, $e1b72d5f75e4c48c$var$isDate = $e1b72d5f75e4c48c$require$_require$types.isDate, $e1b72d5f75e4c48c$var$isMap = $e1b72d5f75e4c48c$require$_require$types.isMap, $e1b72d5f75e4c48c$var$isRegExp = $e1b72d5f75e4c48c$require$_require$types.isRegExp, $e1b72d5f75e4c48c$var$isSet = $e1b72d5f75e4c48c$require$_require$types.isSet, $e1b72d5f75e4c48c$var$isNativeError = $e1b72d5f75e4c48c$require$_require$types.isNativeError, $e1b72d5f75e4c48c$var$isBoxedPrimitive = $e1b72d5f75e4c48c$require$_require$types.isBoxedPrimitive, $e1b72d5f75e4c48c$var$isNumberObject = $e1b72d5f75e4c48c$require$_require$types.isNumberObject, $e1b72d5f75e4c48c$var$isStringObject = $e1b72d5f75e4c48c$require$_require$types.isStringObject, $e1b72d5f75e4c48c$var$isBooleanObject = $e1b72d5f75e4c48c$require$_require$types.isBooleanObject, $e1b72d5f75e4c48c$var$isBigIntObject = $e1b72d5f75e4c48c$require$_require$types.isBigIntObject, $e1b72d5f75e4c48c$var$isSymbolObject = $e1b72d5f75e4c48c$require$_require$types.isSymbolObject, $e1b72d5f75e4c48c$var$isFloat32Array = $e1b72d5f75e4c48c$require$_require$types.isFloat32Array, $e1b72d5f75e4c48c$var$isFloat64Array = $e1b72d5f75e4c48c$require$_require$types.isFloat64Array;
function $e1b72d5f75e4c48c$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $e1b72d5f75e4c48c$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($e1b72d5f75e4c48c$var$isNonIndex).concat($e1b72d5f75e4c48c$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $e1b72d5f75e4c48c$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $e1b72d5f75e4c48c$var$ONLY_ENUMERABLE = undefined;
var $e1b72d5f75e4c48c$var$kStrict = true;
var $e1b72d5f75e4c48c$var$kLoose = false;
var $e1b72d5f75e4c48c$var$kNoIterator = 0;
var $e1b72d5f75e4c48c$var$kIsArray = 1;
var $e1b72d5f75e4c48c$var$kIsSet = 2;
var $e1b72d5f75e4c48c$var$kIsMap = 3;
// Check if they have the same source and flags
function $e1b72d5f75e4c48c$var$areSimilarRegExps(a, b) {
    return $e1b72d5f75e4c48c$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $e1b72d5f75e4c48c$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $e1b72d5f75e4c48c$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $e1b72d5f75e4c48c$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $e1b72d5f75e4c48c$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $e1b72d5f75e4c48c$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $e1b72d5f75e4c48c$var$isEqualBoxedPrimitive(val1, val2) {
    if ($e1b72d5f75e4c48c$var$isNumberObject(val1)) return $e1b72d5f75e4c48c$var$isNumberObject(val2) && $e1b72d5f75e4c48c$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($e1b72d5f75e4c48c$var$isStringObject(val1)) return $e1b72d5f75e4c48c$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($e1b72d5f75e4c48c$var$isBooleanObject(val1)) return $e1b72d5f75e4c48c$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($e1b72d5f75e4c48c$var$isBigIntObject(val1)) return $e1b72d5f75e4c48c$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $e1b72d5f75e4c48c$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $e1b72d5f75e4c48c$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $e1b72d5f75e4c48c$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($e1b72d5f75e4c48c$var$_typeof(val1) !== "object") return typeof val1 === "number" && $e1b72d5f75e4c48c$var$numberIsNaN(val1) && $e1b72d5f75e4c48c$var$numberIsNaN(val2);
        if ($e1b72d5f75e4c48c$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $e1b72d5f75e4c48c$var$_typeof(val1) !== "object") {
            if (val2 === null || $e1b72d5f75e4c48c$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $e1b72d5f75e4c48c$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $e1b72d5f75e4c48c$var$objectToString(val1);
    var val2Tag = $e1b72d5f75e4c48c$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $e1b72d5f75e4c48c$var$getOwnNonIndexProperties(val1, $e1b72d5f75e4c48c$var$ONLY_ENUMERABLE);
        var keys2 = $e1b72d5f75e4c48c$var$getOwnNonIndexProperties(val2, $e1b72d5f75e4c48c$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, $e1b72d5f75e4c48c$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$e1b72d5f75e4c48c$var$isMap(val1) && $e1b72d5f75e4c48c$var$isMap(val2) || !$e1b72d5f75e4c48c$var$isSet(val1) && $e1b72d5f75e4c48c$var$isSet(val2)) return false;
    }
    if ($e1b72d5f75e4c48c$var$isDate(val1)) {
        if (!$e1b72d5f75e4c48c$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($e1b72d5f75e4c48c$var$isRegExp(val1)) {
        if (!$e1b72d5f75e4c48c$var$isRegExp(val2) || !$e1b72d5f75e4c48c$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($e1b72d5f75e4c48c$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($e1b72d5f75e4c48c$var$isArrayBufferView(val1)) {
        if (!strict && ($e1b72d5f75e4c48c$var$isFloat32Array(val1) || $e1b72d5f75e4c48c$var$isFloat64Array(val1))) {
            if (!$e1b72d5f75e4c48c$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$e1b72d5f75e4c48c$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $e1b72d5f75e4c48c$var$getOwnNonIndexProperties(val1, $e1b72d5f75e4c48c$var$ONLY_ENUMERABLE);
        var _keys2 = $e1b72d5f75e4c48c$var$getOwnNonIndexProperties(val2, $e1b72d5f75e4c48c$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, $e1b72d5f75e4c48c$var$kNoIterator, _keys);
    } else if ($e1b72d5f75e4c48c$var$isSet(val1)) {
        if (!$e1b72d5f75e4c48c$var$isSet(val2) || val1.size !== val2.size) return false;
        return $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, $e1b72d5f75e4c48c$var$kIsSet);
    } else if ($e1b72d5f75e4c48c$var$isMap(val1)) {
        if (!$e1b72d5f75e4c48c$var$isMap(val2) || val1.size !== val2.size) return false;
        return $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, $e1b72d5f75e4c48c$var$kIsMap);
    } else if ($e1b72d5f75e4c48c$var$isAnyArrayBuffer(val1)) {
        if (!$e1b72d5f75e4c48c$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($e1b72d5f75e4c48c$var$isBoxedPrimitive(val1) && !$e1b72d5f75e4c48c$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, $e1b72d5f75e4c48c$var$kNoIterator);
}
function $e1b72d5f75e4c48c$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $e1b72d5f75e4c48c$var$propertyIsEnumerable(val, k);
    });
}
function $e1b72d5f75e4c48c$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$e1b72d5f75e4c48c$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $e1b72d5f75e4c48c$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($e1b72d5f75e4c48c$var$propertyIsEnumerable(val1, key)) {
                    if (!$e1b72d5f75e4c48c$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($e1b72d5f75e4c48c$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $e1b72d5f75e4c48c$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $e1b72d5f75e4c48c$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $e1b72d5f75e4c48c$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $e1b72d5f75e4c48c$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $e1b72d5f75e4c48c$var$kNoIterator || iterationType === $e1b72d5f75e4c48c$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $e1b72d5f75e4c48c$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $e1b72d5f75e4c48c$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $e1b72d5f75e4c48c$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($e1b72d5f75e4c48c$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $e1b72d5f75e4c48c$var$findLooseMatchingPrimitives(prim) {
    switch($e1b72d5f75e4c48c$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($e1b72d5f75e4c48c$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $e1b72d5f75e4c48c$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $e1b72d5f75e4c48c$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $e1b72d5f75e4c48c$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $e1b72d5f75e4c48c$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$e1b72d5f75e4c48c$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $e1b72d5f75e4c48c$var$innerDeepEqual(item, curB, false, memo);
}
function $e1b72d5f75e4c48c$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $e1b72d5f75e4c48c$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($e1b72d5f75e4c48c$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$e1b72d5f75e4c48c$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $e1b72d5f75e4c48c$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($e1b72d5f75e4c48c$var$_typeof(_val) === "object" && _val !== null) {
                if (!$e1b72d5f75e4c48c$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$e1b72d5f75e4c48c$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $e1b72d5f75e4c48c$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $e1b72d5f75e4c48c$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($e1b72d5f75e4c48c$var$innerDeepEqual(key1, key2, strict, memo) && $e1b72d5f75e4c48c$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $e1b72d5f75e4c48c$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $e1b72d5f75e4c48c$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $e1b72d5f75e4c48c$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($e1b72d5f75e4c48c$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$e1b72d5f75e4c48c$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$e1b72d5f75e4c48c$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $e1b72d5f75e4c48c$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $e1b72d5f75e4c48c$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($e1b72d5f75e4c48c$var$_typeof(_key) === "object" && _key !== null) {
                if (!$e1b72d5f75e4c48c$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$e1b72d5f75e4c48c$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$e1b72d5f75e4c48c$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $e1b72d5f75e4c48c$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $e1b72d5f75e4c48c$var$kIsSet) {
        if (!$e1b72d5f75e4c48c$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $e1b72d5f75e4c48c$var$kIsMap) {
        if (!$e1b72d5f75e4c48c$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $e1b72d5f75e4c48c$var$kIsArray) for(; i < a.length; i++){
        if ($e1b72d5f75e4c48c$var$hasOwnProperty(a, i)) {
            if (!$e1b72d5f75e4c48c$var$hasOwnProperty(b, i) || !$e1b72d5f75e4c48c$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($e1b72d5f75e4c48c$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$e1b72d5f75e4c48c$var$hasOwnProperty(b, key) || !$e1b72d5f75e4c48c$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$e1b72d5f75e4c48c$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $e1b72d5f75e4c48c$var$isDeepEqual(val1, val2) {
    return $e1b72d5f75e4c48c$var$innerDeepEqual(val1, val2, $e1b72d5f75e4c48c$var$kLoose);
}
function $e1b72d5f75e4c48c$var$isDeepStrictEqual(val1, val2) {
    return $e1b72d5f75e4c48c$var$innerDeepEqual(val1, val2, $e1b72d5f75e4c48c$var$kStrict);
}
module.exports = {
    isDeepEqual: $e1b72d5f75e4c48c$var$isDeepEqual,
    isDeepStrictEqual: $e1b72d5f75e4c48c$var$isDeepStrictEqual
};

});
parcelRegister("1TCw5", function(module, exports) {
"use strict";

var $9m9mI = parcelRequire("9m9mI");

var $5TThM = parcelRequire("5TThM");

var $4Bt3m = parcelRequire("4Bt3m");

var $hfZz9 = parcelRequire("hfZz9");

var $aQps2 = parcelRequire("aQps2");
var $1618ce1ab0046c25$var$polyfill = $5TThM($hfZz9(), Object);
$9m9mI($1618ce1ab0046c25$var$polyfill, {
    getPolyfill: $hfZz9,
    implementation: $4Bt3m,
    shim: $aQps2
});
module.exports = $1618ce1ab0046c25$var$polyfill;

});
parcelRegister("9m9mI", function(module, exports) {
"use strict";

var $iciC9 = parcelRequire("iciC9");
var $6cfd6ee484d80e74$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $6cfd6ee484d80e74$var$toStr = Object.prototype.toString;
var $6cfd6ee484d80e74$var$concat = Array.prototype.concat;

var $II55L = parcelRequire("II55L");
var $6cfd6ee484d80e74$var$isFunction = function(fn) {
    return typeof fn === "function" && $6cfd6ee484d80e74$var$toStr.call(fn) === "[object Function]";
};

var $6cfd6ee484d80e74$var$supportsDescriptors = (parcelRequire("9Aa3x"))();
var $6cfd6ee484d80e74$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$6cfd6ee484d80e74$var$isFunction(predicate) || !predicate()) return;
    }
    if ($6cfd6ee484d80e74$var$supportsDescriptors) $II55L(object, name, value, true);
    else $II55L(object, name, value);
};
var $6cfd6ee484d80e74$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $iciC9(map);
    if ($6cfd6ee484d80e74$var$hasSymbols) props = $6cfd6ee484d80e74$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$6cfd6ee484d80e74$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$6cfd6ee484d80e74$var$defineProperties.supportsDescriptors = !!$6cfd6ee484d80e74$var$supportsDescriptors;
module.exports = $6cfd6ee484d80e74$var$defineProperties;

});

parcelRegister("aQps2", function(module, exports) {
"use strict";

var $hfZz9 = parcelRequire("hfZz9");

var $9m9mI = parcelRequire("9m9mI");
module.exports = function shimObjectIs() {
    var polyfill = $hfZz9();
    $9m9mI(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("cpMdn", function(module, exports) {
"use strict";

var $5TThM = parcelRequire("5TThM");

var $9m9mI = parcelRequire("9m9mI");

var $cOYRM = parcelRequire("cOYRM");

var $7TPef = parcelRequire("7TPef");

var $dgDBi = parcelRequire("dgDBi");
var $909d384a8211fe77$var$polyfill = $5TThM($7TPef(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $9m9mI($909d384a8211fe77$var$polyfill, {
    getPolyfill: $7TPef,
    implementation: $cOYRM,
    shim: $dgDBi
});
module.exports = $909d384a8211fe77$var$polyfill;

});
parcelRegister("cOYRM", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("7TPef", function(module, exports) {
"use strict";

var $cOYRM = parcelRequire("cOYRM");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $cOYRM;
};

});

parcelRegister("dgDBi", function(module, exports) {
"use strict";

var $9m9mI = parcelRequire("9m9mI");

var $7TPef = parcelRequire("7TPef");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $7TPef();
    $9m9mI(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("4o7XT", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $331f94fccb74212e$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.baToJSON = module.exports.addHexPrefix = module.exports.toUnsigned = module.exports.fromSigned = module.exports.bufferToHex = module.exports.bufferToInt = module.exports.toBuffer = module.exports.stripZeros = module.exports.unpad = module.exports.setLengthRight = module.exports.setLength = module.exports.setLengthLeft = module.exports.zeros = void 0;

var $d7Iry = parcelRequire("d7Iry");

var $7rVdb = parcelRequire("7rVdb");
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ module.exports.zeros = function(bytes) {
    return $331f94fccb74212e$require$Buffer.allocUnsafe(bytes).fill(0);
};
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer|Array)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer|Array)
 */ module.exports.setLengthLeft = function(msg, length, right) {
    if (right === void 0) right = false;
    var buf = module.exports.zeros(length);
    msg = module.exports.toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
module.exports.setLength = module.exports.setLengthLeft;
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer|Array)
 * @param length the number of bytes the output should be
 * @return (Buffer|Array)
 */ module.exports.setLengthRight = function(msg, length) {
    return module.exports.setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Buffer` or an `Array`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ module.exports.unpad = function(a) {
    a = $d7Iry.stripHexPrefix(a);
    var first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
module.exports.stripZeros = module.exports.unpad;
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
 * @param v the value
 */ module.exports.toBuffer = function(v) {
    if (!$331f94fccb74212e$require$Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = $331f94fccb74212e$require$Buffer.from(v);
        else if (typeof v === "string") {
            if ($d7Iry.isHexString(v)) v = $331f94fccb74212e$require$Buffer.from($d7Iry.padToEven($d7Iry.stripHexPrefix(v)), "hex");
            else throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: " + v);
        } else if (typeof v === "number") v = $d7Iry.intToBuffer(v);
        else if (v === null || v === undefined) v = $331f94fccb74212e$require$Buffer.allocUnsafe(0);
        else if ($7rVdb.isBN(v)) v = v.toArrayLike($331f94fccb74212e$require$Buffer);
        else if (v.toArray) // converts a BN to a Buffer
        v = $331f94fccb74212e$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
};
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ module.exports.bufferToInt = function(buf) {
    return new $7rVdb(module.exports.toBuffer(buf)).toNumber();
};
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ module.exports.bufferToHex = function(buf) {
    buf = module.exports.toBuffer(buf);
    return "0x" + buf.toString("hex");
};
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ module.exports.fromSigned = function(num) {
    return new $7rVdb(num).fromTwos(256);
};
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ module.exports.toUnsigned = function(num) {
    return $331f94fccb74212e$require$Buffer.from(num.toTwos(256).toArray());
};
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ module.exports.addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return $d7Iry.isHexPrefixed(str) ? str : "0x" + str;
};
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ module.exports.baToJSON = function(ba) {
    if ($331f94fccb74212e$require$Buffer.isBuffer(ba)) return "0x" + ba.toString("hex");
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push(module.exports.baToJSON(ba[i]));
        return array;
    }
};

});

parcelRegister("fdqUr", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $b13cf188a819b627$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlphash = module.exports.ripemd160 = module.exports.sha256 = module.exports.keccak256 = module.exports.keccak = void 0;

var $5lPdN = parcelRequire("5lPdN");
var $b13cf188a819b627$var$keccak224 = $5lPdN.keccak224, $b13cf188a819b627$var$keccak384 = $5lPdN.keccak384, $b13cf188a819b627$var$k256 = $5lPdN.keccak256, $b13cf188a819b627$var$keccak512 = $5lPdN.keccak512;

var $lNfZR = parcelRequire("lNfZR");

var $d7Iry = parcelRequire("d7Iry");

var $4kLt4 = parcelRequire("4kLt4");

var $4o7XT = parcelRequire("4o7XT");
/**
 * Creates Keccak hash of the input
 * @param a The input data (Buffer|Array|String|Number) If the string is a 0x-prefixed hex value
 * it's interpreted as hexadecimal, otherwise as utf8.
 * @param bits The Keccak width
 */ module.exports.keccak = function(a, bits) {
    if (bits === void 0) bits = 256;
    if (typeof a === "string" && !$d7Iry.isHexString(a)) a = $b13cf188a819b627$require$Buffer.from(a, "utf8");
    else a = $4o7XT.toBuffer(a);
    if (!bits) bits = 256;
    switch(bits){
        case 224:
            return $b13cf188a819b627$var$keccak224(a);
        case 256:
            return $b13cf188a819b627$var$k256(a);
        case 384:
            return $b13cf188a819b627$var$keccak384(a);
        case 512:
            return $b13cf188a819b627$var$keccak512(a);
        default:
            throw new Error("Invald algorithm: keccak" + bits);
    }
};
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256).
 * @param a The input data (Buffer|Array|String|Number)
 */ module.exports.keccak256 = function(a) {
    return module.exports.keccak(a);
};
/**
 * Creates SHA256 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 */ module.exports.sha256 = function(a) {
    a = $4o7XT.toBuffer(a);
    return $lNfZR("sha256").update(a).digest();
};
/**
 * Creates RIPEMD160 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 * @param padded Whether it should be padded to 256 bits or not
 */ module.exports.ripemd160 = function(a, padded) {
    a = $4o7XT.toBuffer(a);
    var hash = $lNfZR("rmd160").update(a).digest();
    if (padded === true) return $4o7XT.setLength(hash, 32);
    else return hash;
};
/**
 * Creates SHA-3 hash of the RLP encoded version of the input.
 * @param a The input data
 */ module.exports.rlphash = function(a) {
    return module.exports.keccak($4kLt4.encode(a));
};

});
parcelRegister("5lPdN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h3x6H = parcelRequire("h3x6H");

var $eVoaK = parcelRequire("eVoaK");
module.exports.keccak224 = $h3x6H.createHashFunction(function() {
    return $eVoaK("keccak224");
});
module.exports.keccak256 = $h3x6H.createHashFunction(function() {
    return $eVoaK("keccak256");
});
module.exports.keccak384 = $h3x6H.createHashFunction(function() {
    return $eVoaK("keccak384");
});
module.exports.keccak512 = $h3x6H.createHashFunction(function() {
    return $eVoaK("keccak512");
});

});
parcelRegister("h3x6H", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $c6ac65db697220d1$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c6ac65db697220d1$var$createHashFunction(hashConstructor) {
    return function(msg) {
        var hash = hashConstructor();
        hash.update(msg);
        return $c6ac65db697220d1$require$Buffer.from(hash.digest());
    };
}
module.exports.createHashFunction = $c6ac65db697220d1$var$createHashFunction;

});

parcelRegister("eVoaK", function(module, exports) {


module.exports = (parcelRequire("eQ3BO"))((parcelRequire("lpzeo")));

});
parcelRegister("eQ3BO", function(module, exports) {

var $arrCL = parcelRequire("arrCL");

var $4hP8L = parcelRequire("4hP8L");
module.exports = function(KeccakState) {
    const Keccak = $arrCL(KeccakState);
    const Shake = $4hP8L(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

});
parcelRegister("arrCL", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $79a1da9608a60e9b$require$Buffer = $7ts9d.Buffer;

var $ljG0D = parcelRequire("ljG0D");
var $79a1da9608a60e9b$require$Transform = $ljG0D.Transform;
module.exports = (KeccakState)=>class Keccak extends $79a1da9608a60e9b$require$Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!$79a1da9608a60e9b$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Digest already called");
            if (!$79a1da9608a60e9b$require$Buffer.isBuffer(data)) data = $79a1da9608a60e9b$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});

parcelRegister("4hP8L", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $31f06b5f37b117d1$require$Buffer = $7ts9d.Buffer;

var $ljG0D = parcelRequire("ljG0D");
var $31f06b5f37b117d1$require$Transform = $ljG0D.Transform;
module.exports = (KeccakState)=>class Shake extends $31f06b5f37b117d1$require$Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!$31f06b5f37b117d1$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Squeeze already called");
            if (!$31f06b5f37b117d1$require$Buffer.isBuffer(data)) data = $31f06b5f37b117d1$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});


parcelRegister("lpzeo", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $f96742ecaff49908$require$Buffer = $7ts9d.Buffer;

var $5UAq3 = parcelRequire("5UAq3");
function $f96742ecaff49908$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$f96742ecaff49908$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$f96742ecaff49908$var$Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $5UAq3.p1600(this.state);
            this.count = 0;
        }
    }
};
$f96742ecaff49908$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $5UAq3.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $5UAq3.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$f96742ecaff49908$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = $f96742ecaff49908$require$Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $5UAq3.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$f96742ecaff49908$var$Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $f96742ecaff49908$var$Keccak;

});
parcelRegister("5UAq3", function(module, exports) {

$parcel$export(module.exports, "p1600", () => $44de6ed5738a73c9$export$471358fe9e8379c0, (v) => $44de6ed5738a73c9$export$471358fe9e8379c0 = v);
var $44de6ed5738a73c9$export$471358fe9e8379c0;
const $44de6ed5738a73c9$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$44de6ed5738a73c9$export$471358fe9e8379c0 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $44de6ed5738a73c9$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $44de6ed5738a73c9$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});






parcelRegister("jNxzx", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $e69ca2a402e88504$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashPersonalMessage = module.exports.isValidSignature = module.exports.fromRpcSig = module.exports.toRpcSig = module.exports.ecrecover = module.exports.ecsign = void 0;

var $8QU4z = parcelRequire("8QU4z");

var $7rVdb = parcelRequire("7rVdb");

var $4o7XT = parcelRequire("4o7XT");

var $fdqUr = parcelRequire("fdqUr");
/**
 * Returns the ECDSA signature of a message hash.
 */ module.exports.ecsign = function(msgHash, privateKey, chainId) {
    var sig = $8QU4z.sign(msgHash, privateKey);
    var recovery = sig.recovery;
    var ret = {
        r: sig.signature.slice(0, 32),
        s: sig.signature.slice(32, 64),
        v: chainId ? recovery + (chainId * 2 + 35) : recovery + 27
    };
    return ret;
};
/**
 * ECDSA public key recovery from signature.
 * @returns Recovered public key
 */ module.exports.ecrecover = function(msgHash, v, r, s, chainId) {
    var signature = $e69ca2a402e88504$require$Buffer.concat([
        $4o7XT.setLength(r, 32),
        $4o7XT.setLength(s, 32)
    ], 64);
    var recovery = $e69ca2a402e88504$var$calculateSigRecovery(v, chainId);
    if (!$e69ca2a402e88504$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var senderPubKey = $8QU4z.recover(msgHash, signature, recovery);
    return $8QU4z.publicKeyConvert(senderPubKey, false).slice(1);
};
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * @returns Signature
 */ module.exports.toRpcSig = function(v, r, s, chainId) {
    var recovery = $e69ca2a402e88504$var$calculateSigRecovery(v, chainId);
    if (!$e69ca2a402e88504$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return $4o7XT.bufferToHex($e69ca2a402e88504$require$Buffer.concat([
        $4o7XT.setLengthLeft(r, 32),
        $4o7XT.setLengthLeft(s, 32),
        $4o7XT.toBuffer(v)
    ]));
};
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 */ module.exports.fromRpcSig = function(sig) {
    var buf = $4o7XT.toBuffer(sig);
    // NOTE: with potential introduction of chainId this might need to be updated
    if (buf.length !== 65) throw new Error("Invalid signature length");
    var v = buf[64];
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: buf.slice(0, 32),
        s: buf.slice(32, 64)
    };
};
/**
 * Validate a ECDSA signature.
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ module.exports.isValidSignature = function(v, r, s, homesteadOrLater, chainId) {
    if (homesteadOrLater === void 0) homesteadOrLater = true;
    var SECP256K1_N_DIV_2 = new $7rVdb("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
    var SECP256K1_N = new $7rVdb("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (!$e69ca2a402e88504$var$isValidSigRecovery($e69ca2a402e88504$var$calculateSigRecovery(v, chainId))) return false;
    var rBN = new $7rVdb(r);
    var sBN = new $7rVdb(s);
    if (rBN.isZero() || rBN.gt(SECP256K1_N) || sBN.isZero() || sBN.gt(SECP256K1_N)) return false;
    if (homesteadOrLater && sBN.cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ module.exports.hashPersonalMessage = function(message) {
    var prefix = $e69ca2a402e88504$require$Buffer.from("\x19Ethereum Signed Message:\n" + message.length.toString(), "utf-8");
    return $fdqUr.keccak($e69ca2a402e88504$require$Buffer.concat([
        prefix,
        message
    ]));
};
function $e69ca2a402e88504$var$calculateSigRecovery(v, chainId) {
    return chainId ? v - (2 * chainId + 35) : v - 27;
}
function $e69ca2a402e88504$var$isValidSigRecovery(recovery) {
    return recovery === 0 || recovery === 1;
}

});

parcelRegister("bbScn", function(module, exports) {

var $7ts9d = parcelRequire("7ts9d");
var $825ac37c27877563$require$Buffer = $7ts9d.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineProperties = void 0;

var $3t0dw = parcelRequire("3t0dw");

var $d7Iry = parcelRequire("d7Iry");

var $4kLt4 = parcelRequire("4kLt4");

var $4o7XT = parcelRequire("4o7XT");
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param self the `Object` to define properties on
 * @param fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param data data to be validated against the definitions
 * @deprecated
 */ module.exports.defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label === void 0) label = false;
        if (label) {
            var obj_1 = {};
            self._fields.forEach(function(field) {
                obj_1[field] = "0x" + self[field].toString("hex");
            });
            return obj_1;
        }
        return $4o7XT.baToJSON(self.raw);
    };
    self.serialize = function serialize() {
        return $4kLt4.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = $4o7XT.toBuffer(v);
            if (v.toString("hex") === "00" && !field.allowZero) v = $825ac37c27877563$require$Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = $4o7XT.stripZeros(v);
                $3t0dw(field.length >= v.length, "The field " + field.name + " must not have more " + field.length + " bytes");
            } else if (!(field.allowZero && v.length === 0) && field.length) $3t0dw(field.length === v.length, "The field " + field.name + " must have byte length of " + field.length);
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === "string") data = $825ac37c27877563$require$Buffer.from($d7Iry.stripHexPrefix(data), "hex");
        if ($825ac37c27877563$require$Buffer.isBuffer(data)) data = $4kLt4.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error("wrong number of fields in data");
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = $4o7XT.toBuffer(d);
            });
        } else if (typeof data === "object") {
            var keys_1 = Object.keys(data);
            fields.forEach(function(field) {
                if (keys_1.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys_1.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error("invalid data");
    }
};

});




parcelRegister("exiBu", function(module, exports) {

$parcel$export(module.exports, "vsprintf", () => $a952940d1a4e6948$export$790fb69b1a2884f9, (v) => $a952940d1a4e6948$export$790fb69b1a2884f9 = v);
/* global window, exports, define */ var $a952940d1a4e6948$export$63151d8bb18a49f9;
var $a952940d1a4e6948$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $a952940d1a4e6948$export$63151d8bb18a49f9 = sprintf;
    $a952940d1a4e6948$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

});

parcelRegister("i5cDi", function(module, exports) {
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function getDefaults() {
        return {
            async: false,
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: "",
            highlight: null,
            hooks: null,
            langPrefix: "language-",
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = new RegExp(escapeTest.source, "g");
    var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    var escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, "$1");
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, "").toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[" " + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[" " + base] = base + "/";
            else baseUrls[" " + base] = rtrim(base, "/", true);
        }
        base = baseUrls[" " + base];
        var relativeBase = base.indexOf(":") === -1;
        if (href.substring(0, 2) === "//") {
            if (relativeBase) return href;
            return base.replace(protocol, "$1") + href;
        } else if (href.charAt(0) === "/") {
            if (relativeBase) return href;
            return base.replace(domain, "$1") + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        var i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        var suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return "";
        var result = "";
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            var token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split("\n").map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, "$1") : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, "");
                var top = this.lexer.state.top;
                this.lexer.state.top = true;
                var tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[	 ][^\\n]*)?(?:\\n|$))");
                // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split("\n", 1)[0].replace(/^\t+/, function(t) {
                        return " ".repeat(3 * t.length);
                    });
                    nextLine = src.split("\n", 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
                        var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
                        var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");
                        // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) // Dedent if possible
                            itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length;
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        var spacers = list.items[i].tokens.filter(function(t) {
                            return t.type === "space";
                        });
                        var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                            return /\n.*\n/.test(t.raw);
                        });
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(i = 0; i < l; i++)list.items[i].loose = true;
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: "html",
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.type = "paragraph";
                    token.text = text;
                    token.tokens = this.lexer.inline(text);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                var tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                var href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "";
                var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: "table",
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? "text" : "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                var href = cap[2];
                var title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                    title: title ? title.replace(this.rules.inline._escapes, "$1") : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, " ");
                link = links[link.toLowerCase()];
                if (!link) {
                    var text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = "";
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || "";
            if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, " ");
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = _extends({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = _extends({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("table", block.gfm.table) // interrupt paragraphs with table
    .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = _extends({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    };
    // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    // lookbehind is not available on Safari as of version 16
    // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
    inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
    inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = _extends({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = _extends({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = _extends({}, inline.normal, {
        escape: edit(inline.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = _extends({}, inline.gfm, {
        br: edit(inline.br).replace("{2,}", "*").getRegex(),
        text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text// em-dashes
        .replace(/---/g, "\u2014")// en-dashes
        .replace(/--/g, "\u2013")// opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")// closing singles & apostrophes
        .replace(/'/g, "\u2019")// opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")// closing doubles
        .replace(/"/g, "\u201D")// ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = "", i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = "x" + ch.toString(16);
            out += "&#" + ch + ";";
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        } /**
     * Static Lex Inline Method
     */ ;
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        } /**
     * Preprocessing
     */ ;
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        } /**
     * Lexing
     */ ;
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + "    ".repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            if (tokens === void 0) tokens = [];
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        } /**
     * Lexing/Compiling
     */ ;
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null){
                maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
                this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
            }
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || "").match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
            return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
        } /**
     * @param {string} quote
     */ ;
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        } /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */ ;
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + ' id="' + id + '">' + text + "</h" + level + ">\n";
            }
            // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        } /**
     * @param {string} text
     */ ;
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
        } /**
     * @param {string} text
     */ ;
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        } /**
     * @param {string} header
     * @param {string} body
     */ ;
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        } /**
     * @param {string} content
     */ ;
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? "th" : "td";
            var tag = flags.align ? "<" + type + ' align="' + flags.align + '">' : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        } /**
     * span level renderer
     * @param {string} text
     */ ;
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        } /**
     * @param {string} text
     */ ;
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        } /**
     * @param {string} text
     */ ;
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? "<br/>" : "<br>";
        } /**
     * @param {string} text
     */ ;
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<img src="' + href + '" alt="' + text + '"';
            if (title) out += ' title="' + title + '"';
            out += this.options.xhtml ? "/>" : ">";
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return "" + text;
        };
        _proto.image = function image(href, title, text) {
            return "" + text;
        };
        _proto.br = function br() {
            return "";
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim()// remove html tags
            .replace(/<[!\/a-z].*?>/ig, "")// remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
        } /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */ ;
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + "-" + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        } /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */ ;
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        } /**
     * Static Parse Inline Method
     */ ;
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        } /**
     * Parse Loop
     */ ;
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = "", i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case "code":
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case "table":
                        header = "";
                        // header
                        cell = "";
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = "";
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = "";
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case "blockquote":
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case "list":
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = "";
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = "";
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: "text",
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case "html":
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case "text":
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === "text"){
                            token = tokens[++i];
                            body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        } /**
     * Parse Inline Tokens
     */ ;
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = "", i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        out += renderer.text(token.text);
                        break;
                    case "html":
                        out += renderer.html(token.text);
                        break;
                    case "link":
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case "image":
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case "strong":
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case "em":
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case "codespan":
                        out += renderer.codespan(token.text);
                        break;
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case "text":
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Hooks = /*#__PURE__*/ function() {
        function Hooks(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Hooks.prototype;
        /**
     * Process markdown before marked
     */ _proto.preprocess = function preprocess(markdown) {
            return markdown;
        } /**
     * Process HTML after marked is finished
     */ ;
        _proto.postprocess = function postprocess(html) {
            return html;
        };
        return Hooks;
    }();
    Hooks.passThroughHooks = new Set([
        "preprocess",
        "postprocess"
    ]);
    function onError(silent, async, callback) {
        return function(e) {
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                var msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                if (callback) {
                    callback(null, msg);
                    return;
                }
                return msg;
            }
            if (async) return Promise.reject(e);
            if (callback) {
                callback(e);
                return;
            }
            throw e;
        };
    }
    function parseMarkdown(lexer, parser) {
        return function(src, opt, callback) {
            if (typeof opt === "function") {
                callback = opt;
                opt = null;
            }
            var origOpt = _extends({}, opt);
            opt = _extends({}, marked.defaults, origOpt);
            var throwError = onError(opt.silent, opt.async, callback);
            // throw error in case of non string input
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            checkSanitizeDeprecation(opt);
            if (opt.hooks) opt.hooks.options = opt;
            if (callback) {
                var highlight = opt.highlight;
                var tokens;
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    tokens = lexer(src, opt);
                } catch (e) {
                    return throwError(e);
                }
                var done = function done(err) {
                    var out;
                    if (!err) try {
                        if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                        out = parser(tokens, opt);
                        if (opt.hooks) out = opt.hooks.postprocess(out);
                    } catch (e) {
                        err = e;
                    }
                    opt.highlight = highlight;
                    return err ? throwError(err) : callback(null, out);
                };
                if (!highlight || highlight.length < 3) return done();
                delete opt.highlight;
                if (!tokens.length) return done();
                var pending = 0;
                marked.walkTokens(tokens, function(token) {
                    if (token.type === "code") {
                        pending++;
                        setTimeout(function() {
                            highlight(token.text, token.lang, function(err, code) {
                                if (err) return done(err);
                                if (code != null && code !== token.text) {
                                    token.text = code;
                                    token.escaped = true;
                                }
                                pending--;
                                if (pending === 0) done();
                            });
                        }, 0);
                    }
                });
                if (pending === 0) done();
                return;
            }
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src) {
                return lexer(src, opt);
            }).then(function(tokens) {
                return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function() {
                    return tokens;
                }) : tokens;
            }).then(function(tokens) {
                return parser(tokens, opt);
            }).then(function(html) {
                return opt.hooks ? opt.hooks.postprocess(html) : html;
            })["catch"](throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                var _tokens = lexer(src, opt);
                if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
                var html = parser(_tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    /**
   * Marked
   */ function marked(src, opt, callback) {
        return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        marked.defaults = _extends({}, marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args.forEach(function(pack) {
            // copy options to new object
            var opts = _extends({}, pack);
            // set async to true if it was set to true before
            opts.async = marked.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error("extension name required");
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) (function() {
                var hooks = marked.defaults.hooks || new Hooks();
                var _loop3 = function _loop3(prop) {
                    var prevHook = hooks[prop];
                    if (Hooks.passThroughHooks.has(prop)) hooks[prop] = function(arg) {
                        if (marked.defaults.async) return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function(ret) {
                            return prevHook.call(hooks, ret);
                        });
                        var ret = pack.hooks[prop].call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[prop] = function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        var ret = pack.hooks[prop].apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                };
                for(var prop in pack.hooks)_loop3(prop);
                opts.hooks = hooks;
            })();
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    var values = [];
                    values.push(pack.walkTokens.call(this, token));
                    if (_walkTokens) values = values.concat(_walkTokens.call(this, token));
                    return values;
                };
            }
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var values = [];
        var _loop4 = function _loop4() {
            var token = _step.value;
            values = values.concat(callback.call(marked, token));
            switch(token.type){
                case "table":
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        values = values.concat(marked.walkTokens(cell.tokens, callback));
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            values = values.concat(marked.walkTokens(_cell.tokens, callback));
                        }
                    }
                    break;
                case "list":
                    values = values.concat(marked.walkTokens(token.items, callback));
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        values = values.concat(marked.walkTokens(token[childTokens], callback));
                    });
                    else if (token.tokens) values = values.concat(marked.walkTokens(token.tokens, callback));
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop4();
        return values;
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.Hooks = Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Hooks = Hooks;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});

});

parcelRegister("lqIGV", function(module, exports) {


module.exports = window.DOMPurify || (window.DOMPurify = (parcelRequire("5zcZT")).default || (parcelRequire("5zcZT")));

});
parcelRegister("5zcZT", function(module, exports) {
/*! @license DOMPurify 2.5.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.3/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    var numberIsNaN = unapply(Number.isNaN);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    var svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    var svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.5.3";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Specify the maximum element nesting depth to prevent mXSS */ var MAX_NESTING_DEPTH = 255;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.__depth !== "undefined" && typeof elm.__depth !== "number" || typeof elm.__removalCount !== "undefined" && typeof elm.__removalCount !== "number" || typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === "object" ? object instanceof Node : object && _typeof(object) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, " ");
                content = stringReplace(content, ERB_EXPR$1, " ");
                content = stringReplace(content, TMPLIT_EXPR$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement || value === "__depth" || value === "__removalCount")) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === "value" ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, " ");
                    value = stringReplace(value, ERB_EXPR$1, " ");
                    value = stringReplace(value, TMPLIT_EXPR$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                var parentNode = getParentNode(shadowNode);
                /* Set the nesting depth of an element */ if (shadowNode.nodeType === 1) {
                    if (parentNode && parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ shadowNode.__depth = (shadowNode.__removalCount || 0) + parentNode.__depth + 1;
                    else shadowNode.__depth = 1;
                }
                /*
         * Remove an element if nested too deeply to avoid mXSS
         * or if the __depth might have been tampered with
         */ if (shadowNode.__depth >= MAX_NESTING_DEPTH || numberIsNaN(shadowNode.__depth)) _forceRemove(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) {
                    shadowNode.content.__depth = shadowNode.__depth;
                    _sanitizeShadowDOM(shadowNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                var parentNode = getParentNode(currentNode);
                /* Set the nesting depth of an element */ if (currentNode.nodeType === 1) {
                    if (parentNode && parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ currentNode.__depth = (currentNode.__removalCount || 0) + parentNode.__depth + 1;
                    else currentNode.__depth = 1;
                }
                /*
         * Remove an element if nested too deeply to avoid mXSS
         * or if the __depth might have been tampered with
         */ if (currentNode.__depth >= MAX_NESTING_DEPTH || numberIsNaN(currentNode.__depth)) _forceRemove(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) {
                    currentNode.content.__depth = currentNode.__depth;
                    _sanitizeShadowDOM(currentNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("5VA3M", function(module, exports) {

module.exports = (parcelRequire("70iaY"));

});
parcelRegister("70iaY", function(module, exports) {

var $42w1W = parcelRequire("42w1W");
var $5196a1dcaa0d0e75$require$hp2Builder = $42w1W.hp2Builder;

var $4AGYB = parcelRequire("4AGYB");

var $2eMeB = parcelRequire("2eMeB");

var $4PyBn = parcelRequire("4PyBn");

var $3Neyk = parcelRequire("3Neyk");

var $cS2Y3 = parcelRequire("cS2Y3");
var $5196a1dcaa0d0e75$require$BlockTextBuilder = $cS2Y3.BlockTextBuilder;

var $2RzUw = parcelRequire("2RzUw");

var $1wZhs = parcelRequire("1wZhs");
var $5196a1dcaa0d0e75$require$limitedDepthRecursive = $1wZhs.limitedDepthRecursive;
var $5196a1dcaa0d0e75$require$mergeDuplicatesPreferLast = $1wZhs.mergeDuplicatesPreferLast;
var $5196a1dcaa0d0e75$require$get = $1wZhs.get;
parcelRequire("8xYvK");
/**
 * Default options.
 *
 * @constant
 * @type { Options }
 * @default
 * @private
 */ const $5196a1dcaa0d0e75$var$DEFAULT_OPTIONS = {
    baseElements: {
        selectors: [
            "body"
        ],
        orderBy: "selectors",
        returnDomByDefault: true
    },
    decodeOptions: {
        isAttributeValue: false,
        strict: false
    },
    formatters: {},
    limits: {
        ellipsis: "...",
        maxBaseElements: undefined,
        maxChildNodes: undefined,
        maxDepth: undefined,
        maxInputLength: 16777216 // 16_777_216
    },
    longWordSplit: {
        forceWrapOnLimit: false,
        wrapCharacters: []
    },
    preserveNewlines: false,
    selectors: [
        {
            selector: "*",
            format: "inline"
        },
        {
            selector: "a",
            format: "anchor",
            options: {
                baseUrl: null,
                hideLinkHrefIfSameAsText: false,
                ignoreHref: false,
                linkBrackets: [
                    "[",
                    "]"
                ],
                noAnchorUrl: true
            }
        },
        {
            selector: "article",
            format: "block"
        },
        {
            selector: "aside",
            format: "block"
        },
        {
            selector: "blockquote",
            format: "blockquote",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2,
                trimEmptyLines: true
            }
        },
        {
            selector: "br",
            format: "lineBreak"
        },
        {
            selector: "div",
            format: "block"
        },
        {
            selector: "footer",
            format: "block"
        },
        {
            selector: "form",
            format: "block"
        },
        {
            selector: "h1",
            format: "heading",
            options: {
                leadingLineBreaks: 3,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "h2",
            format: "heading",
            options: {
                leadingLineBreaks: 3,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "h3",
            format: "heading",
            options: {
                leadingLineBreaks: 3,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "h4",
            format: "heading",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "h5",
            format: "heading",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "h6",
            format: "heading",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2,
                uppercase: true
            }
        },
        {
            selector: "header",
            format: "block"
        },
        {
            selector: "hr",
            format: "horizontalLine",
            options: {
                leadingLineBreaks: 2,
                length: undefined,
                trailingLineBreaks: 2
            }
        },
        {
            selector: "img",
            format: "image",
            options: {
                baseUrl: null,
                linkBrackets: [
                    "[",
                    "]"
                ]
            }
        },
        {
            selector: "main",
            format: "block"
        },
        {
            selector: "nav",
            format: "block"
        },
        {
            selector: "ol",
            format: "orderedList",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2
            }
        },
        {
            selector: "p",
            format: "paragraph",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2
            }
        },
        {
            selector: "pre",
            format: "pre",
            options: {
                leadingLineBreaks: 2,
                trailingLineBreaks: 2
            }
        },
        {
            selector: "section",
            format: "block"
        },
        {
            selector: "table",
            format: "table",
            options: {
                colSpacing: 3,
                leadingLineBreaks: 2,
                maxColumnWidth: 60,
                rowSpacing: 0,
                trailingLineBreaks: 2,
                uppercaseHeaderCells: true
            }
        },
        {
            selector: "ul",
            format: "unorderedList",
            options: {
                itemPrefix: " * ",
                leadingLineBreaks: 2,
                trailingLineBreaks: 2
            }
        },
        {
            selector: "wbr",
            format: "wbr"
        }
    ],
    tables: [],
    whitespaceCharacters: " 	\r\n\f\u200B",
    wordwrap: 80
};
const $5196a1dcaa0d0e75$var$concatMerge = (acc, src, options)=>[
        ...acc,
        ...src
    ];
const $5196a1dcaa0d0e75$var$overwriteMerge = (acc, src, options)=>[
        ...src
    ];
const $5196a1dcaa0d0e75$var$selectorsMerge = (acc, src, options)=>acc.some((s)=>typeof s === "object") ? $5196a1dcaa0d0e75$var$concatMerge(acc, src, options) // selectors
     : $5196a1dcaa0d0e75$var$overwriteMerge(acc, src, options) // baseElements.selectors
;
/**
 * Preprocess options, compile selectors into a decision tree,
 * return a function intended for batch processing.
 *
 * @param   { Options } [options = {}]   HtmlToText options.
 * @returns { (html: string) => string } Pre-configured converter function.
 * @static
 */ function $5196a1dcaa0d0e75$var$compile(options = {}) {
    options = $4AGYB($5196a1dcaa0d0e75$var$DEFAULT_OPTIONS, options, {
        arrayMerge: $5196a1dcaa0d0e75$var$overwriteMerge,
        customMerge: (key)=>key === "selectors" ? $5196a1dcaa0d0e75$var$selectorsMerge : undefined
    });
    options.formatters = Object.assign({}, $2RzUw, options.formatters);
    options.selectors = $5196a1dcaa0d0e75$require$mergeDuplicatesPreferLast(options.selectors, (s)=>s.selector);
    $5196a1dcaa0d0e75$var$handleDeprecatedOptions(options);
    const selectorsWithoutFormat = options.selectors.filter((s)=>!s.format);
    if (selectorsWithoutFormat.length) throw new Error("Following selectors have no specified format: " + selectorsWithoutFormat.map((s)=>`\`${s.selector}\``).join(", "));
    const picker = new $3Neyk.DecisionTree(options.selectors.map((s)=>[
            s.selector,
            s
        ])).build($5196a1dcaa0d0e75$require$hp2Builder);
    const baseSelectorsPicker = new $3Neyk.DecisionTree(options.baseElements.selectors.map((s, i)=>[
            s,
            i + 1
        ])).build($5196a1dcaa0d0e75$require$hp2Builder);
    function findBaseElements(dom) {
        return $5196a1dcaa0d0e75$var$findBases(dom, options, baseSelectorsPicker);
    }
    const limitedWalk = $5196a1dcaa0d0e75$require$limitedDepthRecursive(options.limits.maxDepth, $5196a1dcaa0d0e75$var$recursiveWalk, function(dom, builder) {
        builder.addInline(options.limits.ellipsis || "");
    });
    return function(html) {
        return $5196a1dcaa0d0e75$var$process(html, options, picker, findBaseElements, limitedWalk);
    };
}
/**
 * Convert given HTML according to preprocessed options.
 *
 * @param { string } html HTML content to convert.
 * @param { Options } options HtmlToText options (preprocessed).
 * @param { Picker<DomNode, TagDefinition> } picker
 * Tag definition picker for DOM nodes processing.
 * @param { (dom: DomNode[]) => DomNode[] } findBaseElements
 * Function to extract elements from HTML DOM
 * that will only be present in the output text.
 * @param { RecursiveCallback } walk Recursive callback.
 * @returns { string }
 */ function $5196a1dcaa0d0e75$var$process(html, options, picker, findBaseElements, walk) {
    const maxInputLength = options.limits.maxInputLength;
    if (maxInputLength && html && html.length > maxInputLength) {
        console.warn(`Input length ${html.length} is above allowed limit of ${maxInputLength}. Truncating without ellipsis.`);
        html = html.substring(0, maxInputLength);
    }
    const handler = new $4PyBn.DomHandler();
    new $4PyBn.Parser(handler, {
        decodeEntities: false
    }).parseComplete(html);
    const bases = findBaseElements(handler.dom);
    const builder = new $5196a1dcaa0d0e75$require$BlockTextBuilder(options, picker);
    walk(bases, builder);
    return builder.toString();
}
/**
 * Convert given HTML content to plain text string.
 *
 * @param   { string }  html           HTML content to convert.
 * @param   { Options } [options = {}] HtmlToText options.
 * @returns { string }                 Plain text string.
 * @static
 *
 * @example
 * const { convert } = require('html-to-text');
 * const text = convert('<h1>Hello World</h1>', {
 *   wordwrap: 130
 * });
 * console.log(text); // HELLO WORLD
 */ function $5196a1dcaa0d0e75$var$convert(html, options = {}) {
    return $5196a1dcaa0d0e75$var$compile(options)(html);
}
/**
 * Map previously existing and now deprecated options to the new options layout.
 * This is a subject for cleanup in major releases.
 *
 * @param { Options } options HtmlToText options.
 */ function $5196a1dcaa0d0e75$var$handleDeprecatedOptions(options) {
    const selectorDefinitions = options.selectors;
    if (options.tags) {
        const tagDefinitions = Object.entries(options.tags).map(([selector, definition])=>({
                ...definition,
                selector: selector || "*"
            }));
        selectorDefinitions.push(...tagDefinitions);
    }
    function set(obj, path, value) {
        const valueKey = path.pop();
        for (const key of path){
            let nested = obj[key];
            if (!nested) {
                nested = {};
                obj[key] = nested;
            }
            obj = nested;
        }
        obj[valueKey] = value;
    }
    function copyFormatterOption(source, format, target) {
        if (options[source] === undefined) return;
        for (const definition of selectorDefinitions)if (definition.format === format) set(definition, [
            "options",
            target
        ], options[source]);
    }
    copyFormatterOption("hideLinkHrefIfSameAsText", "anchor", "hideLinkHrefIfSameAsText");
    copyFormatterOption("ignoreHref", "anchor", "ignoreHref");
    copyFormatterOption("linkHrefBaseUrl", "anchor", "baseUrl");
    copyFormatterOption("noAnchorUrl", "anchor", "noAnchorUrl");
    copyFormatterOption("noLinkBrackets", "anchor", "noLinkBrackets");
    copyFormatterOption("linkHrefBaseUrl", "image", "baseUrl");
    copyFormatterOption("unorderedListItemPrefix", "unorderedList", "itemPrefix");
    copyFormatterOption("uppercaseHeadings", "heading", "uppercase");
    copyFormatterOption("uppercaseHeadings", "table", "uppercaseHeadings");
    copyFormatterOption("uppercaseHeadings", "dataTable", "uppercaseHeadings");
    if (options["ignoreImage"]) {
        for (const definition of selectorDefinitions)if (definition.format === "image") definition.format = "skip";
    }
    if (options["singleNewLineParagraphs"]) {
        for (const definition of selectorDefinitions)if (definition.format === "paragraph" || definition.format === "pre") {
            set(definition, [
                "options",
                "leadingLineBreaks"
            ], 1);
            set(definition, [
                "options",
                "trailingLineBreaks"
            ], 1);
        }
    }
    if (options["baseElement"]) {
        const baseElement = options["baseElement"];
        set(options, [
            "baseElements",
            "selectors"
        ], Array.isArray(baseElement) ? baseElement : [
            baseElement
        ]);
    }
    if (options["returnDomByDefault"] !== undefined) set(options, [
        "baseElements",
        "returnDomByDefault"
    ], options["returnDomByDefault"]);
    for (const definition of selectorDefinitions)if (definition.format === "anchor" && $5196a1dcaa0d0e75$require$get(definition, [
        "options",
        "noLinkBrackets"
    ])) set(definition, [
        "options",
        "linkBrackets"
    ], false);
}
function $5196a1dcaa0d0e75$var$findBases(dom, options, baseSelectorsPicker) {
    const results = [];
    function recursiveWalk(walk, /** @type { DomNode[] } */ dom) {
        dom = dom.slice(0, options.limits.maxChildNodes);
        for (const elem of dom){
            if (elem.type !== "tag") continue;
            const pickedSelectorIndex = baseSelectorsPicker.pick1(elem);
            if (pickedSelectorIndex > 0) results.push({
                selectorIndex: pickedSelectorIndex,
                element: elem
            });
            else if (elem.children) walk(elem.children);
            if (results.length >= options.limits.maxBaseElements) return;
        }
    }
    const limitedWalk = $5196a1dcaa0d0e75$require$limitedDepthRecursive(options.limits.maxDepth, recursiveWalk);
    limitedWalk(dom);
    if (options.baseElements.orderBy !== "occurrence") results.sort((a, b)=>a.selectorIndex - b.selectorIndex);
    return options.baseElements.returnDomByDefault && results.length === 0 ? dom : results.map((x)=>x.element);
}
/**
 * Function to walk through DOM nodes and accumulate their string representations.
 *
 * @param   { RecursiveCallback } walk    Recursive callback.
 * @param   { DomNode[] }         [dom]   Nodes array to process.
 * @param   { BlockTextBuilder }  builder Passed around to accumulate output text.
 * @private
 */ function $5196a1dcaa0d0e75$var$recursiveWalk(walk, dom, builder) {
    if (!dom) return;
    const options = builder.options;
    const tooManyChildNodes = dom.length > options.limits.maxChildNodes;
    if (tooManyChildNodes) {
        dom = dom.slice(0, options.limits.maxChildNodes);
        dom.push({
            data: options.limits.ellipsis,
            type: "text"
        });
    }
    for (const elem of dom)switch(elem.type){
        case "text":
            builder.addInline($2eMeB.decode(elem.data, options.decodeOptions));
            break;
        case "tag":
            {
                const tagDefinition = builder.picker.pick1(elem);
                const format = options.formatters[tagDefinition.format];
                format(elem, walk, builder, tagDefinition.options || {});
                break;
            }
        default:
            break;
    }
    return;
}
/**
 * @deprecated Use `{ convert }` function instead!
 * @see convert
 *
 * @param   { string }  html           HTML content to convert.
 * @param   { Options } [options = {}] HtmlToText options.
 * @returns { string }                 Plain text string.
 * @static
 */ const $5196a1dcaa0d0e75$var$fromString = (html, options = {})=>$5196a1dcaa0d0e75$var$convert(html, options);
module.exports = {
    compile: $5196a1dcaa0d0e75$var$compile,
    convert: $5196a1dcaa0d0e75$var$convert,
    fromString: $5196a1dcaa0d0e75$var$fromString,
    htmlToText: $5196a1dcaa0d0e75$var$convert
};

});
parcelRegister("42w1W", function(module, exports) {

$parcel$export(module.exports, "hp2Builder", () => $6594b19fb3677083$export$dbda60a8f53eb466);

var $cAP9v = parcelRequire("cAP9v");

var $3Neyk = parcelRequire("3Neyk");
/**
 * A {@link BuilderFunction} implementation.
 *
 * Creates a function (in a {@link Picker} wrapper) that can run
 * the decision tree against `htmlparser2` `Element` nodes.
 *
 * @typeParam V - the type of values associated with selectors.
 *
 * @param nodes - nodes ({@link DecisionTreeNode})
 * from the root level of the decision tree.
 *
 * @returns a {@link Picker} object.
 */ function $6594b19fb3677083$export$dbda60a8f53eb466(nodes) {
    return new (0, $3Neyk.Picker)($6594b19fb3677083$var$handleArray(nodes));
}
// ==============================================
function $6594b19fb3677083$var$handleArray(nodes) {
    const matchers = nodes.map($6594b19fb3677083$var$handleNode);
    return (el, ...tail)=>$6594b19fb3677083$var$flatMap(matchers, (m)=>m(el, ...tail));
}
function $6594b19fb3677083$var$handleNode(node) {
    switch(node.type){
        case "terminal":
            {
                const result = [
                    node.valueContainer
                ];
                return (el, ...tail)=>result;
            }
        case "tagName":
            return $6594b19fb3677083$var$handleTagName(node);
        case "attrValue":
            return $6594b19fb3677083$var$handleAttrValueName(node);
        case "attrPresence":
            return $6594b19fb3677083$var$handleAttrPresenceName(node);
        case "pushElement":
            return $6594b19fb3677083$var$handlePushElementNode(node);
        case "popElement":
            return $6594b19fb3677083$var$handlePopElementNode(node);
    }
}
function $6594b19fb3677083$var$handleTagName(node) {
    const variants = {};
    for (const variant of node.variants)variants[variant.value] = $6594b19fb3677083$var$handleArray(variant.cont);
    return (el, ...tail)=>{
        const continuation = variants[el.name];
        return continuation ? continuation(el, ...tail) : [];
    };
}
function $6594b19fb3677083$var$handleAttrPresenceName(node) {
    const attrName = node.name;
    const continuation = $6594b19fb3677083$var$handleArray(node.cont);
    return (el, ...tail)=>Object.prototype.hasOwnProperty.call(el.attribs, attrName) ? continuation(el, ...tail) : [];
}
function $6594b19fb3677083$var$handleAttrValueName(node) {
    const callbacks = [];
    for (const matcher of node.matchers){
        const predicate = matcher.predicate;
        const continuation = $6594b19fb3677083$var$handleArray(matcher.cont);
        callbacks.push((attr, el, ...tail)=>predicate(attr) ? continuation(el, ...tail) : []);
    }
    const attrName = node.name;
    return (el, ...tail)=>{
        const attr = el.attribs[attrName];
        return attr || attr === "" ? $6594b19fb3677083$var$flatMap(callbacks, (cb)=>cb(attr, el, ...tail)) : [];
    };
}
function $6594b19fb3677083$var$handlePushElementNode(node) {
    const continuation = $6594b19fb3677083$var$handleArray(node.cont);
    const leftElementGetter = node.combinator === "+" ? $6594b19fb3677083$var$getPrecedingElement : $6594b19fb3677083$var$getParentElement;
    return (el, ...tail)=>{
        const next = leftElementGetter(el);
        if (next === null) return [];
        return continuation(next, el, ...tail);
    };
}
const $6594b19fb3677083$var$getPrecedingElement = (el)=>{
    const prev = el.prev;
    if (prev === null) return null;
    return (0, $cAP9v.isTag)(prev) ? prev : $6594b19fb3677083$var$getPrecedingElement(prev);
};
const $6594b19fb3677083$var$getParentElement = (el)=>{
    const parent = el.parent;
    return parent && (0, $cAP9v.isTag)(parent) ? parent : null;
};
function $6594b19fb3677083$var$handlePopElementNode(node) {
    const continuation = $6594b19fb3677083$var$handleArray(node.cont);
    return (el, next, ...tail)=>continuation(next, ...tail);
}
// Can be removed after transition to Node 12.
function $6594b19fb3677083$var$flatMap(items, mapper) {
    return [].concat(...$6594b19fb3677083$var$amap(items, mapper));
}
function $6594b19fb3677083$var$amap(items, mapper) {
    const len = items.length;
    const res = new Array(len);
    for(let i = 0; i < len; i++)res[i] = mapper(items[i]);
    return res;
}

});
parcelRegister("cAP9v", function(module, exports) {
"use strict";
var $92b086a266353a9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92b086a266353a9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $92b086a266353a9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $lbVaC = parcelRequire("lbVaC");


$92b086a266353a9b$var$__exportStar((parcelRequire("iQABB")), module.exports);
var $92b086a266353a9b$var$reWhitespace = /\s+/g;
// Default options
var $92b086a266353a9b$var$defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $92b086a266353a9b$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("iQABB")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $92b086a266353a9b$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $92b086a266353a9b$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("iQABB")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $lbVaC.ElementType.Tag : undefined;
        var element = new (parcelRequire("iQABB")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $lbVaC.ElementType.Text) {
            if (normalizeWhitespace) lastNode.data = (lastNode.data + data).replace($92b086a266353a9b$var$reWhitespace, " ");
            else lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            if (normalizeWhitespace) data = data.replace($92b086a266353a9b$var$reWhitespace, " ");
            var node = new (parcelRequire("iQABB")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $lbVaC.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("iQABB")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("iQABB")).Text("");
        var node = new (parcelRequire("iQABB")).NodeWithChildren($lbVaC.ElementType.CDATA, [
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("iQABB")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $92b086a266353a9b$var$DomHandler;
module.exports.default = $92b086a266353a9b$var$DomHandler;

});
parcelRegister("lbVaC", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $f6d6f8df8a09d5eb$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $f6d6f8df8a09d5eb$export$3bf645f08efe3292);
$parcel$export(module.exports, "Root", () => $f6d6f8df8a09d5eb$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Text", () => $f6d6f8df8a09d5eb$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Directive", () => $f6d6f8df8a09d5eb$export$befdefbdce210f91);
$parcel$export(module.exports, "Comment", () => $f6d6f8df8a09d5eb$export$4d299b491347818a);
$parcel$export(module.exports, "Script", () => $f6d6f8df8a09d5eb$export$2f8b47a141e57afc);
$parcel$export(module.exports, "Style", () => $f6d6f8df8a09d5eb$export$d9e45bc13d335801);
$parcel$export(module.exports, "Tag", () => $f6d6f8df8a09d5eb$export$3288d34c523a1192);
$parcel$export(module.exports, "CDATA", () => $f6d6f8df8a09d5eb$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Doctype", () => $f6d6f8df8a09d5eb$export$31b44af36ff2c60f);
/** Types of elements found in htmlparser2's DOM */ var $f6d6f8df8a09d5eb$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($f6d6f8df8a09d5eb$export$b992dc138d950e31 || ($f6d6f8df8a09d5eb$export$b992dc138d950e31 = {}));
function $f6d6f8df8a09d5eb$export$3bf645f08efe3292(elem) {
    return elem.type === $f6d6f8df8a09d5eb$export$b992dc138d950e31.Tag || elem.type === $f6d6f8df8a09d5eb$export$b992dc138d950e31.Script || elem.type === $f6d6f8df8a09d5eb$export$b992dc138d950e31.Style;
}
const $f6d6f8df8a09d5eb$export$be92b6f5f03c0fe9 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Root;
const $f6d6f8df8a09d5eb$export$5f1af8db9871e1d6 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Text;
const $f6d6f8df8a09d5eb$export$befdefbdce210f91 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Directive;
const $f6d6f8df8a09d5eb$export$4d299b491347818a = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Comment;
const $f6d6f8df8a09d5eb$export$2f8b47a141e57afc = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Script;
const $f6d6f8df8a09d5eb$export$d9e45bc13d335801 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Style;
const $f6d6f8df8a09d5eb$export$3288d34c523a1192 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Tag;
const $f6d6f8df8a09d5eb$export$1f8b8f7e5c763232 = $f6d6f8df8a09d5eb$export$b992dc138d950e31.CDATA;
const $f6d6f8df8a09d5eb$export$31b44af36ff2c60f = $f6d6f8df8a09d5eb$export$b992dc138d950e31.Doctype;

});

parcelRegister("iQABB", function(module, exports) {
"use strict";
var $db897a68db421198$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $db897a68db421198$var$__assign = module.exports && module.exports.__assign || function() {
    $db897a68db421198$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $db897a68db421198$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $lbVaC = parcelRequire("lbVaC");
var $db897a68db421198$var$nodeTypes = new Map([
    [
        $lbVaC.ElementType.Tag,
        1
    ],
    [
        $lbVaC.ElementType.Script,
        1
    ],
    [
        $lbVaC.ElementType.Style,
        1
    ],
    [
        $lbVaC.ElementType.Directive,
        1
    ],
    [
        $lbVaC.ElementType.Text,
        3
    ],
    [
        $lbVaC.ElementType.CDATA,
        4
    ],
    [
        $lbVaC.ElementType.Comment,
        8
    ],
    [
        $lbVaC.ElementType.Root,
        9
    ]
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $db897a68db421198$var$Node = /** @class */ function() {
    /**
     *
     * @param type The type of the node.
     */ function Node(type) {
        this.type = type;
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */ get: function() {
            var _a;
            return (_a = $db897a68db421198$var$nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $db897a68db421198$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $db897a68db421198$var$Node;
/**
 * A node that contains some data.
 */ var $db897a68db421198$var$DataNode = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */ function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($db897a68db421198$var$Node);
module.exports.DataNode = $db897a68db421198$var$DataNode;
/**
 * Text within the document.
 */ var $db897a68db421198$var$Text = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(Text, _super);
    function Text(data) {
        return _super.call(this, $lbVaC.ElementType.Text, data) || this;
    }
    return Text;
}($db897a68db421198$var$DataNode);
module.exports.Text = $db897a68db421198$var$Text;
/**
 * Comments within the document.
 */ var $db897a68db421198$var$Comment = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, $lbVaC.ElementType.Comment, data) || this;
    }
    return Comment;
}($db897a68db421198$var$DataNode);
module.exports.Comment = $db897a68db421198$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $db897a68db421198$var$ProcessingInstruction = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, $lbVaC.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}($db897a68db421198$var$DataNode);
module.exports.ProcessingInstruction = $db897a68db421198$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $db897a68db421198$var$NodeWithChildren = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($db897a68db421198$var$Node);
module.exports.NodeWithChildren = $db897a68db421198$var$NodeWithChildren;
/**
 * The root node of the document.
 */ var $db897a68db421198$var$Document = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(Document, _super);
    function Document(children) {
        return _super.call(this, $lbVaC.ElementType.Root, children) || this;
    }
    return Document;
}($db897a68db421198$var$NodeWithChildren);
module.exports.Document = $db897a68db421198$var$Document;
/**
 * An element within the DOM.
 */ var $db897a68db421198$var$Element = /** @class */ function(_super) {
    $db897a68db421198$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $lbVaC.ElementType.Script : name === "style" ? $lbVaC.ElementType.Style : $lbVaC.ElementType.Tag;
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($db897a68db421198$var$NodeWithChildren);
module.exports.Element = $db897a68db421198$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $db897a68db421198$var$isTag(node) {
    return (0, $lbVaC.isTag)(node);
}
module.exports.isTag = $db897a68db421198$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $db897a68db421198$var$isCDATA(node) {
    return node.type === $lbVaC.ElementType.CDATA;
}
module.exports.isCDATA = $db897a68db421198$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $db897a68db421198$var$isText(node) {
    return node.type === $lbVaC.ElementType.Text;
}
module.exports.isText = $db897a68db421198$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $db897a68db421198$var$isComment(node) {
    return node.type === $lbVaC.ElementType.Comment;
}
module.exports.isComment = $db897a68db421198$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $db897a68db421198$var$isDirective(node) {
    return node.type === $lbVaC.ElementType.Directive;
}
module.exports.isDirective = $db897a68db421198$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $db897a68db421198$var$isDocument(node) {
    return node.type === $lbVaC.ElementType.Root;
}
module.exports.isDocument = $db897a68db421198$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */ function $db897a68db421198$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $db897a68db421198$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $db897a68db421198$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($db897a68db421198$var$isText(node)) result = new $db897a68db421198$var$Text(node.data);
    else if ($db897a68db421198$var$isComment(node)) result = new $db897a68db421198$var$Comment(node.data);
    else if ($db897a68db421198$var$isTag(node)) {
        var children = recursive ? $db897a68db421198$var$cloneChildren(node.children) : [];
        var clone_1 = new $db897a68db421198$var$Element(node.name, $db897a68db421198$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $db897a68db421198$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $db897a68db421198$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($db897a68db421198$var$isCDATA(node)) {
        var children = recursive ? $db897a68db421198$var$cloneChildren(node.children) : [];
        var clone_2 = new $db897a68db421198$var$NodeWithChildren($lbVaC.ElementType.CDATA, children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($db897a68db421198$var$isDocument(node)) {
        var children = recursive ? $db897a68db421198$var$cloneChildren(node.children) : [];
        var clone_3 = new $db897a68db421198$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($db897a68db421198$var$isDirective(node)) {
        var instruction = new $db897a68db421198$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $db897a68db421198$var$cloneNode;
function $db897a68db421198$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $db897a68db421198$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("3Neyk", function(module, exports) {

$parcel$export(module.exports, "DecisionTree", () => $01ddabc59fb449a6$export$de34b2c812597081);
$parcel$export(module.exports, "Picker", () => $01ddabc59fb449a6$export$ba25329847403e11);

var $gjEPb = parcelRequire("gjEPb");
var $01ddabc59fb449a6$export$d994a69d14505b85 = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
var $01ddabc59fb449a6$export$4624c240901a6889 = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
/**
 * A {@link BuilderFunction} implementation.
 *
 * Produces a string representation of the tree
 * for testing and debug purposes.
 *
 * Only accepts `string` as the associated value type.
 * Map your input collection before creating a {@link DecisionTree}
 * if you want to use it with a different type -
 * the decision on how to stringify the value is up to you.
 *
 * @param nodes - nodes from the root level of the decision tree.
 * @returns the string representation of the tree.
 */ const $01ddabc59fb449a6$var$treeify = (nodes)=>"\u25BD\n" + $01ddabc59fb449a6$var$treeifyArray(nodes, $01ddabc59fb449a6$var$thinLines);
const $01ddabc59fb449a6$var$thinLines = [
    [
        "\u251C\u2500",
        "\u2502 "
    ],
    [
        "\u2514\u2500",
        "  "
    ]
];
const $01ddabc59fb449a6$var$heavyLines = [
    [
        "\u2520\u2500",
        "\u2503 "
    ],
    [
        "\u2516\u2500",
        "  "
    ]
];
const $01ddabc59fb449a6$var$doubleLines = [
    [
        "\u255F\u2500",
        "\u2551 "
    ],
    [
        "\u2559\u2500",
        "  "
    ]
];
function $01ddabc59fb449a6$var$treeifyArray(nodes, tpl = $01ddabc59fb449a6$var$heavyLines) {
    return $01ddabc59fb449a6$var$prefixItems(tpl, nodes.map((n)=>$01ddabc59fb449a6$var$treeifyNode(n)));
}
function $01ddabc59fb449a6$var$treeifyNode(node) {
    switch(node.type){
        case "terminal":
            {
                const vctr = node.valueContainer;
                return `\u{25C1} #${vctr.index} ${JSON.stringify(vctr.specificity)} ${vctr.value}`;
            }
        case "tagName":
            return `\u{25FB} Tag name
${$01ddabc59fb449a6$var$treeifyArray(node.variants, $01ddabc59fb449a6$var$doubleLines)}`;
        case "attrValue":
            return `\u{25A3} Attr value: ${node.name}\n${$01ddabc59fb449a6$var$treeifyArray(node.matchers, $01ddabc59fb449a6$var$doubleLines)}`;
        case "attrPresence":
            return `\u{25E8} Attr presence: ${node.name}\n${$01ddabc59fb449a6$var$treeifyArray(node.cont)}`;
        case "pushElement":
            return `\u{25C9} Push element: ${node.combinator}\n${$01ddabc59fb449a6$var$treeifyArray(node.cont, $01ddabc59fb449a6$var$thinLines)}`;
        case "popElement":
            return `\u{25CC} Pop element
${$01ddabc59fb449a6$var$treeifyArray(node.cont, $01ddabc59fb449a6$var$thinLines)}`;
        case "variant":
            return `\u{25C7} = ${node.value}\n${$01ddabc59fb449a6$var$treeifyArray(node.cont)}`;
        case "matcher":
            return `\u{25C8} ${node.matcher} "${node.value}"${node.modifier || ""}\n${$01ddabc59fb449a6$var$treeifyArray(node.cont)}`;
    }
}
function $01ddabc59fb449a6$var$prefixItems(tpl, items) {
    return items.map((item, i, { length: length })=>$01ddabc59fb449a6$var$prefixItem(tpl, item, i === length - 1)).join("\n");
}
function $01ddabc59fb449a6$var$prefixItem(tpl, item, tail = true) {
    const tpl1 = tpl[tail ? 1 : 0];
    return tpl1[0] + item.split("\n").join("\n" + tpl1[1]);
}
var $01ddabc59fb449a6$export$7c722b13327a12e5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    treeify: $01ddabc59fb449a6$var$treeify
});
/**
 * CSS selectors decision tree.
 * Data structure that weaves similar selectors together
 * in order to minimize the number of checks required
 * to find the ones matching a given HTML element.
 *
 * Converted into a functioning implementation via plugins
 * tailored for specific DOM ASTs.
 *
 * @typeParam V - the type of values associated with selectors.
 */ class $01ddabc59fb449a6$export$de34b2c812597081 {
    /**
     * Create new DecisionTree object.
     *
     * @param input - an array containing all selectors
     * paired with associated values.
     *
     * @typeParam V - the type of values associated with selectors.
     */ constructor(input){
        this.branches = $01ddabc59fb449a6$var$weave($01ddabc59fb449a6$var$toAstTerminalPairs(input));
    }
    /**
     * Turn this decision tree into a usable form.
     *
     * @typeParam R - return type defined by the builder function.
     *
     * @param builder - the builder function.
     *
     * @returns the decision tree in a form ready for use.
     */ build(builder) {
        return builder(this.branches);
    }
}
function $01ddabc59fb449a6$var$toAstTerminalPairs(array) {
    const len = array.length;
    const results = new Array(len);
    for(let i = 0; i < len; i++){
        const [selectorString, val] = array[i];
        const ast = $01ddabc59fb449a6$var$preprocess($gjEPb.parse1(selectorString));
        results[i] = {
            ast: ast,
            terminal: {
                type: "terminal",
                valueContainer: {
                    index: i,
                    value: val,
                    specificity: ast.specificity
                }
            }
        };
    }
    return results;
}
function $01ddabc59fb449a6$var$preprocess(ast) {
    $01ddabc59fb449a6$var$reduceSelectorVariants(ast);
    $gjEPb.normalize(ast);
    return ast;
}
function $01ddabc59fb449a6$var$reduceSelectorVariants(ast) {
    const newList = [];
    ast.list.forEach((sel)=>{
        switch(sel.type){
            case "class":
                newList.push({
                    matcher: "~=",
                    modifier: null,
                    name: "class",
                    namespace: null,
                    specificity: sel.specificity,
                    type: "attrValue",
                    value: sel.name
                });
                break;
            case "id":
                newList.push({
                    matcher: "=",
                    modifier: null,
                    name: "id",
                    namespace: null,
                    specificity: sel.specificity,
                    type: "attrValue",
                    value: sel.name
                });
                break;
            case "combinator":
                $01ddabc59fb449a6$var$reduceSelectorVariants(sel.left);
                newList.push(sel);
                break;
            case "universal":
                break;
            default:
                newList.push(sel);
                break;
        }
    });
    ast.list = newList;
}
function $01ddabc59fb449a6$var$weave(items) {
    const branches = [];
    while(items.length){
        const topKind = $01ddabc59fb449a6$var$findTopKey(items, (sel)=>true, $01ddabc59fb449a6$var$getSelectorKind);
        const { matches: matches, nonmatches: nonmatches, empty: empty } = $01ddabc59fb449a6$var$breakByKind(items, topKind);
        items = nonmatches;
        if (matches.length) branches.push($01ddabc59fb449a6$var$branchOfKind(topKind, matches));
        if (empty.length) branches.push(...$01ddabc59fb449a6$var$terminate(empty));
    }
    return branches;
}
function $01ddabc59fb449a6$var$terminate(items) {
    const results = [];
    for (const item of items){
        const terminal = item.terminal;
        if (terminal.type === "terminal") results.push(terminal);
        else {
            const { matches: matches, rest: rest } = $01ddabc59fb449a6$var$partition(terminal.cont, (node)=>node.type === "terminal");
            matches.forEach((node)=>results.push(node));
            if (rest.length) {
                terminal.cont = rest;
                results.push(terminal);
            }
        }
    }
    return results;
}
function $01ddabc59fb449a6$var$breakByKind(items, selectedKind) {
    const matches = [];
    const nonmatches = [];
    const empty = [];
    for (const item of items){
        const simpsels = item.ast.list;
        if (simpsels.length) {
            const isMatch = simpsels.some((node)=>$01ddabc59fb449a6$var$getSelectorKind(node) === selectedKind);
            (isMatch ? matches : nonmatches).push(item);
        } else empty.push(item);
    }
    return {
        matches: matches,
        nonmatches: nonmatches,
        empty: empty
    };
}
function $01ddabc59fb449a6$var$getSelectorKind(sel) {
    switch(sel.type){
        case "attrPresence":
            return `attrPresence ${sel.name}`;
        case "attrValue":
            return `attrValue ${sel.name}`;
        case "combinator":
            return `combinator ${sel.combinator}`;
        default:
            return sel.type;
    }
}
function $01ddabc59fb449a6$var$branchOfKind(kind, items) {
    if (kind === "tag") return $01ddabc59fb449a6$var$tagNameBranch(items);
    if (kind.startsWith("attrValue ")) return $01ddabc59fb449a6$var$attrValueBranch(kind.substring(10), items);
    if (kind.startsWith("attrPresence ")) return $01ddabc59fb449a6$var$attrPresenceBranch(kind.substring(13), items);
    if (kind === "combinator >") return $01ddabc59fb449a6$var$combinatorBranch(">", items);
    if (kind === "combinator +") return $01ddabc59fb449a6$var$combinatorBranch("+", items);
    throw new Error(`Unsupported selector kind: ${kind}`);
}
function $01ddabc59fb449a6$var$tagNameBranch(items) {
    const groups = $01ddabc59fb449a6$var$spliceAndGroup(items, (x)=>x.type === "tag", (x)=>x.name);
    const variants = Object.entries(groups).map(([name, group])=>({
            type: "variant",
            value: name,
            cont: $01ddabc59fb449a6$var$weave(group.items)
        }));
    return {
        type: "tagName",
        variants: variants
    };
}
function $01ddabc59fb449a6$var$attrPresenceBranch(name, items) {
    for (const item of items)$01ddabc59fb449a6$var$spliceSimpleSelector(item, (x)=>x.type === "attrPresence" && x.name === name);
    return {
        type: "attrPresence",
        name: name,
        cont: $01ddabc59fb449a6$var$weave(items)
    };
}
function $01ddabc59fb449a6$var$attrValueBranch(name, items) {
    const groups = $01ddabc59fb449a6$var$spliceAndGroup(items, (x)=>x.type === "attrValue" && x.name === name, (x)=>`${x.matcher} ${x.modifier || ""} ${x.value}`);
    const matchers = [];
    for (const group of Object.values(groups)){
        const sel = group.oneSimpleSelector;
        const predicate = $01ddabc59fb449a6$var$getAttrPredicate(sel);
        const continuation = $01ddabc59fb449a6$var$weave(group.items);
        matchers.push({
            type: "matcher",
            matcher: sel.matcher,
            modifier: sel.modifier,
            value: sel.value,
            predicate: predicate,
            cont: continuation
        });
    }
    return {
        type: "attrValue",
        name: name,
        matchers: matchers
    };
}
function $01ddabc59fb449a6$var$getAttrPredicate(sel) {
    if (sel.modifier === "i") {
        const expected = sel.value.toLowerCase();
        switch(sel.matcher){
            case "=":
                return (actual)=>expected === actual.toLowerCase();
            case "~=":
                return (actual)=>actual.toLowerCase().split(/[ \t]+/).includes(expected);
            case "^=":
                return (actual)=>actual.toLowerCase().startsWith(expected);
            case "$=":
                return (actual)=>actual.toLowerCase().endsWith(expected);
            case "*=":
                return (actual)=>actual.toLowerCase().includes(expected);
            case "|=":
                return (actual)=>{
                    const lower = actual.toLowerCase();
                    return expected === lower || lower.startsWith(expected) && lower[expected.length] === "-";
                };
        }
    } else {
        const expected = sel.value;
        switch(sel.matcher){
            case "=":
                return (actual)=>expected === actual;
            case "~=":
                return (actual)=>actual.split(/[ \t]+/).includes(expected);
            case "^=":
                return (actual)=>actual.startsWith(expected);
            case "$=":
                return (actual)=>actual.endsWith(expected);
            case "*=":
                return (actual)=>actual.includes(expected);
            case "|=":
                return (actual)=>expected === actual || actual.startsWith(expected) && actual[expected.length] === "-";
        }
    }
}
function $01ddabc59fb449a6$var$combinatorBranch(combinator, items) {
    const groups = $01ddabc59fb449a6$var$spliceAndGroup(items, (x)=>x.type === "combinator" && x.combinator === combinator, (x)=>$gjEPb.serialize(x.left));
    const leftItems = [];
    for (const group of Object.values(groups)){
        const rightCont = $01ddabc59fb449a6$var$weave(group.items);
        const leftAst = group.oneSimpleSelector.left;
        leftItems.push({
            ast: leftAst,
            terminal: {
                type: "popElement",
                cont: rightCont
            }
        });
    }
    return {
        type: "pushElement",
        combinator: combinator,
        cont: $01ddabc59fb449a6$var$weave(leftItems)
    };
}
function $01ddabc59fb449a6$var$spliceAndGroup(items, predicate, keyCallback) {
    const groups = {};
    while(items.length){
        const bestKey = $01ddabc59fb449a6$var$findTopKey(items, predicate, keyCallback);
        const bestKeyPredicate = (sel)=>predicate(sel) && keyCallback(sel) === bestKey;
        const hasBestKeyPredicate = (item)=>item.ast.list.some(bestKeyPredicate);
        const { matches: matches, rest: rest } = $01ddabc59fb449a6$var$partition1(items, hasBestKeyPredicate);
        let oneSimpleSelector = null;
        for (const item of matches){
            const splicedNode = $01ddabc59fb449a6$var$spliceSimpleSelector(item, bestKeyPredicate);
            if (!oneSimpleSelector) oneSimpleSelector = splicedNode;
        }
        if (oneSimpleSelector == null) throw new Error("No simple selector is found.");
        groups[bestKey] = {
            oneSimpleSelector: oneSimpleSelector,
            items: matches
        };
        items = rest;
    }
    return groups;
}
function $01ddabc59fb449a6$var$spliceSimpleSelector(item, predicate) {
    const simpsels = item.ast.list;
    const matches = new Array(simpsels.length);
    let firstIndex = -1;
    for(let i = simpsels.length; i-- > 0;)if (predicate(simpsels[i])) {
        matches[i] = true;
        firstIndex = i;
    }
    if (firstIndex == -1) throw new Error(`Couldn't find the required simple selector.`);
    const result = simpsels[firstIndex];
    item.ast.list = simpsels.filter((sel, i)=>!matches[i]);
    return result;
}
function $01ddabc59fb449a6$var$findTopKey(items, predicate, keyCallback) {
    const candidates = {};
    for (const item of items){
        const candidates1 = {};
        for (const node of item.ast.list.filter(predicate))candidates1[keyCallback(node)] = true;
        for (const key of Object.keys(candidates1))if (candidates[key]) candidates[key]++;
        else candidates[key] = 1;
    }
    let topKind = "";
    let topCounter = 0;
    for (const entry of Object.entries(candidates))if (entry[1] > topCounter) {
        topKind = entry[0];
        topCounter = entry[1];
    }
    return topKind;
}
function $01ddabc59fb449a6$var$partition(src, predicate) {
    const matches = [];
    const rest = [];
    for (const x of src)if (predicate(x)) matches.push(x);
    else rest.push(x);
    return {
        matches: matches,
        rest: rest
    };
}
function $01ddabc59fb449a6$var$partition1(src, predicate) {
    const matches = [];
    const rest = [];
    for (const x of src)if (predicate(x)) matches.push(x);
    else rest.push(x);
    return {
        matches: matches,
        rest: rest
    };
}
/**
 * Simple wrapper around the matcher function.
 * Recommended return type for builder plugins.
 *
 * @typeParam L - the type of HTML Element in the targeted DOM AST.
 * @typeParam V - the type of associated values.
 */ class $01ddabc59fb449a6$export$ba25329847403e11 {
    /**
     * Create new Picker object.
     *
     * @typeParam L - the type of HTML Element in the targeted DOM AST.
     * @typeParam V - the type of associated values.
     *
     * @param f - the function that matches an element
     * and returns all associated values.
     */ constructor(f){
        this.f = f;
    }
    /**
     * Run the selectors decision tree against one HTML Element
     * and return all matched associated values
     * along with selector specificities.
     *
     * Client code then decides how to further process them
     * (sort, filter, etc).
     *
     * @param el - an HTML Element.
     *
     * @returns all associated values along with
     * selector specificities for all matched selectors.
     */ pickAll(el) {
        return this.f(el);
    }
    /**
     * Run the selectors decision tree against one HTML Element
     * and choose the value from the most specific mached selector.
     *
     * @param el - an HTML Element.
     *
     * @param preferFirst - option to define which value to choose
     * when there are multiple matches with equal specificity.
     *
     * @returns the value from the most specific mached selector
     * or `null` if nothing matched.
     */ pick1(el, preferFirst = false) {
        const results = this.f(el);
        const len = results.length;
        if (len === 0) return null;
        if (len === 1) return results[0].value;
        const comparator = preferFirst ? $01ddabc59fb449a6$var$comparatorPreferFirst : $01ddabc59fb449a6$var$comparatorPreferLast;
        let result = results[0];
        for(let i = 1; i < len; i++){
            const next = results[i];
            if (comparator(result, next)) result = next;
        }
        return result.value;
    }
}
function $01ddabc59fb449a6$var$comparatorPreferFirst(acc, next) {
    const diff = (0, $gjEPb.compareSpecificity)(next.specificity, acc.specificity);
    return diff > 0 || diff === 0 && next.index < acc.index;
}
function $01ddabc59fb449a6$var$comparatorPreferLast(acc, next) {
    const diff = (0, $gjEPb.compareSpecificity)(next.specificity, acc.specificity);
    return diff > 0 || diff === 0 && next.index > acc.index;
}

});
parcelRegister("gjEPb", function(module, exports) {

$parcel$export(module.exports, "parse1", () => $e82e82c409542646$export$4b2beda2ad81cd3a);
$parcel$export(module.exports, "serialize", () => $e82e82c409542646$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "normalize", () => $e82e82c409542646$export$a3295358bff77e);
$parcel$export(module.exports, "compareSpecificity", () => $e82e82c409542646$export$8e957a6cd2bbd283);

var $lHz21 = parcelRequire("lHz21");

var $2DoKD = parcelRequire("2DoKD");
// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
// Bypasses TS6133. Allow declared but unused functions.
// @ts-ignore
function $e82e82c409542646$var$id(d) {
    return d[0];
}
const $e82e82c409542646$var$lexer = $2DoKD.compile({
    ws: {
        match: /[ \t\r\n\f]+/,
        lineBreaks: true
    },
    idn: {
        match: /[a-zA-Z_-][a-zA-Z0-9_-]*/
    },
    hashToken: {
        match: /#[a-zA-Z0-9_-]+/,
        value: (s)=>s.slice(1)
    },
    str1: {
        match: /'(?:\\['\\]|[^\n'\\])*'/,
        value: (s)=>s.slice(1, -1)
    },
    str2: {
        match: /"(?:\\["\\]|[^\n"\\])*"/,
        value: (s)=>s.slice(1, -1)
    },
    asterisk: "*",
    fullstop: ".",
    comma: ",",
    lbr: "[",
    rbr: "]",
    eq: "=",
    gt: ">",
    vbar: "|",
    plus: "+",
    tilde: "~",
    caret: "^",
    dollar: "$"
});
function $e82e82c409542646$var$firstTokenValue(tokens) {
    return tokens[0].value;
}
function $e82e82c409542646$var$second(tokens) {
    return tokens[1];
}
function $e82e82c409542646$var$sumSpec([a0, a1, a2], [b0, b1, b2]) {
    return [
        a0 + b0,
        a1 + b1,
        a2 + b2
    ];
}
const $e82e82c409542646$var$grammar = {
    Lexer: $e82e82c409542646$var$lexer,
    ParserRules: [
        {
            "name": "main",
            "symbols": [
                "_",
                "listSelector",
                "_"
            ],
            "postprocess": $e82e82c409542646$var$second
        },
        {
            "name": "mainNoList",
            "symbols": [
                "_",
                "complexSelector",
                "_"
            ],
            "postprocess": $e82e82c409542646$var$second
        },
        {
            "name": "listSelector",
            "symbols": [
                "complexSelector"
            ],
            "postprocess": ([next])=>({
                    type: "list",
                    list: [
                        next
                    ]
                })
        },
        {
            "name": "listSelector",
            "symbols": [
                "listSelector",
                "_",
                $e82e82c409542646$var$lexer.has("comma") ? {
                    type: "comma"
                } : comma,
                "_",
                "complexSelector"
            ],
            "postprocess": ([acc, , , , next])=>({
                    type: "list",
                    list: [
                        ...acc.list,
                        next
                    ]
                })
        },
        {
            "name": "complexSelector",
            "symbols": [
                "compoundSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "complexSelector",
            "symbols": [
                "complexSelector",
                "__",
                "compoundSelector"
            ],
            "postprocess": ([left, , right])=>({
                    type: "compound",
                    list: [
                        ...right.list,
                        {
                            type: "combinator",
                            combinator: " ",
                            left: left,
                            specificity: left.specificity
                        }
                    ],
                    specificity: $e82e82c409542646$var$sumSpec(left.specificity, right.specificity)
                })
        },
        {
            "name": "complexSelector",
            "symbols": [
                "complexSelector",
                "_",
                "combinator",
                "_",
                "compoundSelector"
            ],
            "postprocess": ([left, , c, , right])=>({
                    type: "compound",
                    list: [
                        ...right.list,
                        {
                            type: "combinator",
                            combinator: c,
                            left: left,
                            specificity: left.specificity
                        }
                    ],
                    specificity: $e82e82c409542646$var$sumSpec(left.specificity, right.specificity)
                })
        },
        {
            "name": "combinator",
            "symbols": [
                $e82e82c409542646$var$lexer.has("gt") ? {
                    type: "gt"
                } : gt
            ],
            "postprocess": ()=>">"
        },
        {
            "name": "combinator",
            "symbols": [
                $e82e82c409542646$var$lexer.has("plus") ? {
                    type: "plus"
                } : plus
            ],
            "postprocess": ()=>"+"
        },
        {
            "name": "combinator",
            "symbols": [
                $e82e82c409542646$var$lexer.has("tilde") ? {
                    type: "tilde"
                } : tilde
            ],
            "postprocess": ()=>"~"
        },
        {
            "name": "combinator",
            "symbols": [
                $e82e82c409542646$var$lexer.has("vbar") ? {
                    type: "vbar"
                } : vbar,
                $e82e82c409542646$var$lexer.has("vbar") ? {
                    type: "vbar"
                } : vbar
            ],
            "postprocess": ()=>"||"
        },
        {
            "name": "compoundSelector",
            "symbols": [
                "typeSelector"
            ],
            "postprocess": ([next])=>({
                    type: "compound",
                    list: [
                        next
                    ],
                    specificity: next.specificity
                })
        },
        {
            "name": "compoundSelector",
            "symbols": [
                "subclassSelector"
            ],
            "postprocess": ([next])=>({
                    type: "compound",
                    list: [
                        next
                    ],
                    specificity: next.specificity
                })
        },
        {
            "name": "compoundSelector",
            "symbols": [
                "compoundSelector",
                "subclassSelector"
            ],
            "postprocess": ([acc, next])=>({
                    type: "compound",
                    list: [
                        ...acc.list,
                        next
                    ],
                    specificity: $e82e82c409542646$var$sumSpec(acc.specificity, next.specificity)
                })
        },
        {
            "name": "subclassSelector",
            "symbols": [
                "idSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "subclassSelector",
            "symbols": [
                "classSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "subclassSelector",
            "symbols": [
                "attrSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "attrSelector",
            "symbols": [
                "attrPresenceSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "attrSelector",
            "symbols": [
                "attrValueSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "typeSelector",
            "symbols": [
                "tagSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "typeSelector",
            "symbols": [
                "uniSelector"
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "attrPresenceSelector",
            "symbols": [
                $e82e82c409542646$var$lexer.has("lbr") ? {
                    type: "lbr"
                } : lbr,
                "_",
                "wqname",
                "_",
                $e82e82c409542646$var$lexer.has("rbr") ? {
                    type: "rbr"
                } : rbr
            ],
            "postprocess": ([, , wqname])=>({
                    type: "attrPresence",
                    name: wqname.name,
                    namespace: wqname.namespace,
                    specificity: [
                        0,
                        1,
                        0
                    ]
                })
        },
        {
            "name": "attrValueSelector",
            "symbols": [
                $e82e82c409542646$var$lexer.has("lbr") ? {
                    type: "lbr"
                } : lbr,
                "_",
                "wqname",
                "_",
                "attrMatcher",
                "_",
                "attrValue",
                "_",
                $e82e82c409542646$var$lexer.has("rbr") ? {
                    type: "rbr"
                } : rbr
            ],
            "postprocess": ([, , wqname, , matcher, , v])=>({
                    type: "attrValue",
                    name: wqname.name,
                    namespace: wqname.namespace,
                    matcher: matcher,
                    value: v.value,
                    modifier: v.modifier,
                    specificity: [
                        0,
                        1,
                        0
                    ]
                })
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"="
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("tilde") ? {
                    type: "tilde"
                } : tilde,
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"~="
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("vbar") ? {
                    type: "vbar"
                } : vbar,
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"|="
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("caret") ? {
                    type: "caret"
                } : caret,
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"^="
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("dollar") ? {
                    type: "dollar"
                } : dollar,
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"$="
        },
        {
            "name": "attrMatcher",
            "symbols": [
                $e82e82c409542646$var$lexer.has("asterisk") ? {
                    type: "asterisk"
                } : asterisk,
                $e82e82c409542646$var$lexer.has("eq") ? {
                    type: "eq"
                } : eq
            ],
            "postprocess": ()=>"*="
        },
        {
            "name": "attrValue",
            "symbols": [
                "str"
            ],
            "postprocess": ([v])=>({
                    value: v,
                    modifier: null
                })
        },
        {
            "name": "attrValue",
            "symbols": [
                "idn"
            ],
            "postprocess": ([v])=>({
                    value: v,
                    modifier: null
                })
        },
        {
            "name": "attrValue",
            "symbols": [
                "str",
                "_",
                "attrModifier"
            ],
            "postprocess": ([v, , mod])=>({
                    value: v,
                    modifier: mod
                })
        },
        {
            "name": "attrValue",
            "symbols": [
                "idn",
                "__",
                "attrModifier"
            ],
            "postprocess": ([v, , mod])=>({
                    value: v,
                    modifier: mod
                })
        },
        {
            "name": "attrModifier",
            "symbols": [
                {
                    "literal": "i"
                }
            ],
            "postprocess": ()=>"i"
        },
        {
            "name": "attrModifier",
            "symbols": [
                {
                    "literal": "I"
                }
            ],
            "postprocess": ()=>"i"
        },
        {
            "name": "attrModifier",
            "symbols": [
                {
                    "literal": "s"
                }
            ],
            "postprocess": ()=>"s"
        },
        {
            "name": "attrModifier",
            "symbols": [
                {
                    "literal": "S"
                }
            ],
            "postprocess": ()=>"s"
        },
        {
            "name": "idSelector",
            "symbols": [
                $e82e82c409542646$var$lexer.has("hashToken") ? {
                    type: "hashToken"
                } : hashToken
            ],
            "postprocess": ([{ value: name }])=>({
                    type: "id",
                    name: name,
                    specificity: [
                        1,
                        0,
                        0
                    ]
                })
        },
        {
            "name": "classSelector",
            "symbols": [
                $e82e82c409542646$var$lexer.has("fullstop") ? {
                    type: "fullstop"
                } : fullstop,
                "idn"
            ],
            "postprocess": ([, name])=>({
                    type: "class",
                    name: name,
                    specificity: [
                        0,
                        1,
                        0
                    ]
                })
        },
        {
            "name": "tagSelector",
            "symbols": [
                "wqname"
            ],
            "postprocess": ([wqname])=>({
                    type: "tag",
                    name: wqname.name,
                    namespace: wqname.namespace,
                    specificity: [
                        0,
                        0,
                        1
                    ]
                })
        },
        {
            "name": "uniSelector",
            "symbols": [
                $e82e82c409542646$var$lexer.has("asterisk") ? {
                    type: "asterisk"
                } : asterisk
            ],
            "postprocess": ()=>({
                    type: "universal",
                    namespace: null,
                    specificity: [
                        0,
                        0,
                        0
                    ]
                })
        },
        {
            "name": "uniSelector",
            "symbols": [
                "ns",
                $e82e82c409542646$var$lexer.has("asterisk") ? {
                    type: "asterisk"
                } : asterisk
            ],
            "postprocess": ([ns])=>({
                    type: "universal",
                    namespace: ns,
                    specificity: [
                        0,
                        0,
                        0
                    ]
                })
        },
        {
            "name": "wqname",
            "symbols": [
                "idn"
            ],
            "postprocess": ([name])=>({
                    name: name,
                    namespace: null
                })
        },
        {
            "name": "wqname",
            "symbols": [
                "ns",
                "idn"
            ],
            "postprocess": ([ns, name])=>({
                    name: name,
                    namespace: ns
                })
        },
        {
            "name": "ns",
            "symbols": [
                $e82e82c409542646$var$lexer.has("vbar") ? {
                    type: "vbar"
                } : vbar
            ],
            "postprocess": ()=>""
        },
        {
            "name": "ns",
            "symbols": [
                "idn",
                $e82e82c409542646$var$lexer.has("vbar") ? {
                    type: "vbar"
                } : vbar
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "str",
            "symbols": [
                $e82e82c409542646$var$lexer.has("str1") ? {
                    type: "str1"
                } : str1
            ],
            "postprocess": $e82e82c409542646$var$firstTokenValue
        },
        {
            "name": "str",
            "symbols": [
                $e82e82c409542646$var$lexer.has("str2") ? {
                    type: "str2"
                } : str2
            ],
            "postprocess": $e82e82c409542646$var$firstTokenValue
        },
        {
            "name": "idn",
            "symbols": [
                $e82e82c409542646$var$lexer.has("idn") ? {
                    type: "idn"
                } : idn
            ],
            "postprocess": $e82e82c409542646$var$firstTokenValue
        },
        {
            "name": "_$ebnf$1",
            "symbols": [
                $e82e82c409542646$var$lexer.has("ws") ? {
                    type: "ws"
                } : ws
            ],
            "postprocess": $e82e82c409542646$var$id
        },
        {
            "name": "_$ebnf$1",
            "symbols": [],
            "postprocess": ()=>null
        },
        {
            "name": "_",
            "symbols": [
                "_$ebnf$1"
            ],
            "postprocess": ()=>null
        },
        {
            "name": "__",
            "symbols": [
                $e82e82c409542646$var$lexer.has("ws") ? {
                    type: "ws"
                } : ws
            ],
            "postprocess": ()=>null
        }
    ],
    ParserStart: "main"
};
var $e82e82c409542646$export$d994a69d14505b85 = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
// Passing the start argument to a parser or grammar constructor
// doesn't seem to work as expected.
const $e82e82c409542646$var$compiledRulesNoList = {
    ...$e82e82c409542646$var$grammar,
    ParserStart: "mainNoList"
};
/**
 * Parse a CSS selector string.
 *
 * This function supports comma-separated selector lists
 * and always returns an AST starting from a node of type `list`.
 *
 * @param str - CSS selector string (can contain commas).
 */ function $e82e82c409542646$export$98e6a39c04603d36(str) {
    return $e82e82c409542646$var$_parse($e82e82c409542646$var$grammar, str);
}
/**
 * Parse a CSS selector string.
 *
 * This function does not support comma-separated selector lists
 * and always returns an AST starting from a node of type `compound`.
 *
 * @param str - CSS selector string (no commas).
 */ function $e82e82c409542646$export$4b2beda2ad81cd3a(str) {
    return $e82e82c409542646$var$_parse($e82e82c409542646$var$compiledRulesNoList, str);
}
function $e82e82c409542646$var$_parse(compiledRules1, str) {
    const parser = new (0, $lHz21.Parser)((0, $lHz21.Grammar).fromCompiled(compiledRules1));
    parser.feed(str);
    if (parser.results.length === 0) throw new Error("Failed to parse - input string might be incomplete.");
    return parser.results[0];
}
/**
 * Convert a selector AST back to a string representation.
 *
 * Note: formatting is not preserved in the AST.
 *
 * @param selector - A selector AST object.
 */ function $e82e82c409542646$export$dfdc1655ccc5b9cb(selector) {
    if (!selector.type) throw new Error("This is not an AST node.");
    switch(selector.type){
        case "universal":
            return $e82e82c409542646$var$_serNs(selector.namespace) + "*";
        case "tag":
            return $e82e82c409542646$var$_serNs(selector.namespace) + selector.name;
        case "class":
            return "." + selector.name;
        case "id":
            return "#" + selector.name;
        case "attrPresence":
            return `[${$e82e82c409542646$var$_serNs(selector.namespace)}${selector.name}]`;
        case "attrValue":
            return `[${$e82e82c409542646$var$_serNs(selector.namespace)}${selector.name}${selector.matcher}${$e82e82c409542646$var$_serStr(selector.value)}${selector.modifier ? selector.modifier : ""}]`;
        case "combinator":
            return $e82e82c409542646$export$dfdc1655ccc5b9cb(selector.left) + selector.combinator;
        case "compound":
            return selector.list.reduce((acc, node)=>{
                if (node.type === "combinator") return $e82e82c409542646$export$dfdc1655ccc5b9cb(node) + acc;
                else return acc + $e82e82c409542646$export$dfdc1655ccc5b9cb(node);
            }, "");
        case "list":
            return selector.list.map($e82e82c409542646$export$dfdc1655ccc5b9cb).join(",");
    }
}
function $e82e82c409542646$var$_serNs(ns) {
    return ns || ns === "" ? ns + "|" : "";
}
function $e82e82c409542646$var$_serStr(str) {
    if (str.indexOf('"') === -1) return `"${str}"`;
    else if (str.indexOf("'") === -1) return `'${str}'`;
    else return `"${str.replace('"', '\\"')}"`;
}
/**
 * Modifies the given AST **in place** to have all internal arrays
 * in a stable order. Returns the AST.
 *
 * Intended for consitent processing and normalized `serialize()` output.
 *
 * @param selector - A selector AST object.
 */ function $e82e82c409542646$export$a3295358bff77e(selector) {
    if (!selector.type) throw new Error("This is not an AST node.");
    switch(selector.type){
        case "compound":
            selector.list.forEach($e82e82c409542646$export$a3295358bff77e);
            selector.list.sort((a, b)=>$e82e82c409542646$var$_compareArrays($e82e82c409542646$var$_getSelectorPriority(a), $e82e82c409542646$var$_getSelectorPriority(b)));
            break;
        case "combinator":
            $e82e82c409542646$export$a3295358bff77e(selector.left);
            break;
        case "list":
            selector.list.forEach($e82e82c409542646$export$a3295358bff77e);
            selector.list.sort((a, b)=>$e82e82c409542646$export$dfdc1655ccc5b9cb(a) < $e82e82c409542646$export$dfdc1655ccc5b9cb(b) ? -1 : 1);
            break;
    }
    return selector;
}
function $e82e82c409542646$var$_getSelectorPriority(selector) {
    switch(selector.type){
        case "universal":
            return [
                1
            ];
        case "tag":
            return [
                1
            ];
        case "id":
            return [
                2
            ];
        case "class":
            return [
                3,
                selector.name
            ];
        case "attrPresence":
            return [
                4,
                $e82e82c409542646$export$dfdc1655ccc5b9cb(selector)
            ];
        case "attrValue":
            return [
                5,
                $e82e82c409542646$export$dfdc1655ccc5b9cb(selector)
            ];
        case "combinator":
            return [
                15,
                $e82e82c409542646$export$dfdc1655ccc5b9cb(selector)
            ];
    }
}
/**
 * Compare selectors based on their specificity.
 *
 * Usable as a comparator for sorting.
 *
 * @param a - First selector.
 * @param b - Second selector.
 */ function $e82e82c409542646$export$38ef360853bc30ed(a, b) {
    return $e82e82c409542646$var$_compareArrays(a.specificity, b.specificity);
}
/**
 * Compare specificity values without reducing them
 * as arbitrary base numbers.
 *
 * Usable as a comparator for sorting.
 *
 * @param a - First specificity value.
 * @param b - Second specificity value.
 */ function $e82e82c409542646$export$8e957a6cd2bbd283(a, b) {
    return $e82e82c409542646$var$_compareArrays(a, b);
}
function $e82e82c409542646$var$_compareArrays(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) throw new Error("Arguments must be arrays.");
    const shorter = a.length < b.length ? a.length : b.length;
    for(let i = 0; i < shorter; i++){
        if (a[i] === b[i]) continue;
        return a[i] < b[i] ? -1 : 1;
    }
    return a.length - b.length;
}

});
parcelRegister("lHz21", function(module, exports) {
(function(root, factory) {
    if (0, module.exports) module.exports = factory();
    else root.nearley = factory();
})(module.exports, function() {
    function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols; // a list of literal | regex class | nonterminal
        this.postprocess = postprocess;
        return this;
    }
    Rule.highestId = 0;
    Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(" ") : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(" ") + " \u25CF " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(" ");
        return this.name + " \u2192 " + symbolSequence;
    };
    // a State is a rule at a position from a given starting point in the input stream (reference)
    function State(rule, dot, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
    }
    State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    };
    State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
            state.data = state.build();
            // Having right set here will prevent the right state and its children
            // form being garbage collected
            state.right = undefined;
        }
        return state;
    };
    State.prototype.build = function() {
        var children = [];
        var node = this;
        do {
            children.push(node.right.data);
            node = node.left;
        }while (node.left);
        children.reverse();
        return children;
    };
    State.prototype.finish = function() {
        if (this.rule.postprocess) this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
    };
    function Column(grammar, index) {
        this.grammar = grammar;
        this.index = index;
        this.states = [];
        this.wants = {}; // states indexed by the non-terminal they expect
        this.scannable = []; // list of states that expect a token
        this.completed = {}; // states that are nullable
    }
    Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;
        for(var w = 0; w < states.length; w++){
            var state = states[w];
            if (state.isComplete) {
                state.finish();
                if (state.data !== Parser.fail) {
                    // complete
                    var wantedBy = state.wantedBy;
                    for(var i = wantedBy.length; i--;){
                        var left = wantedBy[i];
                        this.complete(left, state);
                    }
                    // special-case nullables
                    if (state.reference === this.index) {
                        // make sure future predictors of this rule get completed.
                        var exp = state.rule.name;
                        (this.completed[exp] = this.completed[exp] || []).push(state);
                    }
                }
            } else {
                // queue scannable states
                var exp = state.rule.symbols[state.dot];
                if (typeof exp !== "string") {
                    this.scannable.push(state);
                    continue;
                }
                // predict
                if (wants[exp]) {
                    wants[exp].push(state);
                    if (completed.hasOwnProperty(exp)) {
                        var nulls = completed[exp];
                        for(var i = 0; i < nulls.length; i++){
                            var right = nulls[i];
                            this.complete(state, right);
                        }
                    }
                } else {
                    wants[exp] = [
                        state
                    ];
                    this.predict(exp);
                }
            }
        }
    };
    Column.prototype.predict = function(exp) {
        var rules = this.grammar.byName[exp] || [];
        for(var i = 0; i < rules.length; i++){
            var r = rules[i];
            var wantedBy = this.wants[exp];
            var s = new State(r, 0, this.index, wantedBy);
            this.states.push(s);
        }
    };
    Column.prototype.complete = function(left, right) {
        var copy = left.nextState(right);
        this.states.push(copy);
    };
    function Grammar(rules, start) {
        this.rules = rules;
        this.start = start || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
            if (!byName.hasOwnProperty(rule.name)) byName[rule.name] = [];
            byName[rule.name].push(rule);
        });
    }
    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
    Grammar.fromCompiled = function(rules, start) {
        var lexer = rules.Lexer;
        if (rules.ParserStart) {
            start = rules.ParserStart;
            rules = rules.ParserRules;
        }
        var rules = rules.map(function(r) {
            return new Rule(r.name, r.symbols, r.postprocess);
        });
        var g = new Grammar(rules, start);
        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
        return g;
    };
    function StreamLexer() {
        this.reset("");
    }
    StreamLexer.prototype.reset = function(data, state) {
        this.buffer = data;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
    };
    StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
            var ch = this.buffer[this.index++];
            if (ch === "\n") {
                this.line += 1;
                this.lastLineBreak = this.index;
            }
            return {
                value: ch
            };
        }
    };
    StreamLexer.prototype.save = function() {
        return {
            line: this.line,
            col: this.index - this.lastLineBreak
        };
    };
    StreamLexer.prototype.formatError = function(token, message) {
        // nb. this gets called after consuming the offending token,
        // so the culprit is index-1
        var buffer = this.buffer;
        if (typeof buffer === "string") {
            var lines = buffer.split("\n").slice(Math.max(0, this.line - 5), this.line);
            var nextLineBreak = buffer.indexOf("\n", this.index);
            if (nextLineBreak === -1) nextLineBreak = buffer.length;
            var col = this.index - this.lastLineBreak;
            var lastLineDigits = String(this.line).length;
            message += " at line " + this.line + " col " + col + ":\n\n";
            message += lines.map(function(line, i) {
                return pad(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
            }, this).join("\n");
            message += "\n" + pad("", lastLineDigits + col) + "^\n";
            return message;
        } else return message + " at index " + (this.index - 1);
        function pad(n, length) {
            var s = String(n);
            return Array(length - s.length + 1).join(" ") + s;
        }
    };
    function Parser(rules, start, options) {
        if (rules instanceof Grammar) {
            var grammar = rules;
            var options = start;
        } else var grammar = Grammar.fromCompiled(rules, start);
        this.grammar = grammar;
        // Read options
        this.options = {
            keepHistory: false,
            lexer: grammar.lexer || new StreamLexer
        };
        for(var key in options || {})this.options[key] = options[key];
        // Setup lexer
        this.lexer = this.options.lexer;
        this.lexerState = undefined;
        // Setup a table
        var column = new Column(grammar, 0);
        var table = this.table = [
            column
        ];
        // I could be expecting anything.
        column.wants[grammar.start] = [];
        column.predict(grammar.start);
        // TODO what if start rule is nullable?
        column.process();
        this.current = 0; // token index
    }
    // create a reserved token for indicating a parse fail
    Parser.fail = {};
    Parser.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);
        var token;
        while(true){
            try {
                token = lexer.next();
                if (!token) break;
            } catch (e) {
                // Create the next column so that the error reporter
                // can display the correctly predicted states.
                var nextColumn = new Column(this.grammar, this.current + 1);
                this.table.push(nextColumn);
                var err = new Error(this.reportLexerError(e));
                err.offset = this.current;
                err.token = e.token;
                throw err;
            }
            // We add new states to table[current+1]
            var column = this.table[this.current];
            // GC unused states
            if (!this.options.keepHistory) delete this.table[this.current - 1];
            var n = this.current + 1;
            var nextColumn = new Column(this.grammar, n);
            this.table.push(nextColumn);
            // Advance all tokens that expect the symbol
            var literal = token.text !== undefined ? token.text : token.value;
            var value = lexer.constructor === StreamLexer ? token.value : token;
            var scannable = column.scannable;
            for(var w = scannable.length; w--;){
                var state = scannable[w];
                var expect = state.rule.symbols[state.dot];
                // Try to consume the token
                // either regex or literal
                if (expect.test ? expect.test(value) : expect.type ? expect.type === token.type : expect.literal === literal) {
                    // Add it
                    var next = state.nextState({
                        data: value,
                        token: token,
                        isToken: true,
                        reference: n - 1
                    });
                    nextColumn.states.push(next);
                }
            }
            // Next, for each of the rules, we either
            // (a) complete it, and try to see if the reference row expected that
            //     rule
            // (b) predict the next nonterminal it expects by adding that
            //     nonterminal's start state
            // To prevent duplication, we also keep track of rules we have already
            // added
            nextColumn.process();
            // If needed, throw an error:
            if (nextColumn.states.length === 0) {
                // No states at all! This is not good.
                var err = new Error(this.reportError(token));
                err.offset = this.current;
                err.token = token;
                throw err;
            }
            // maybe save lexer state
            if (this.options.keepHistory) column.lexerState = lexer.save();
            this.current++;
        }
        if (column) this.lexerState = lexer.save();
        // Incrementally keep track of results
        this.results = this.finish();
        // Allow chaining, for whatever it's worth
        return this;
    };
    Parser.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        // Planning to add a token property to moo's thrown error
        // even on erroring tokens to be used in error display below
        var token = lexerError.token;
        if (token) {
            tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
            lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
            tokenDisplay = "input (lexer error)";
            lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== undefined ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
    };
    Parser.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states.filter(function(state) {
            var nextSymbol = state.rule.symbols[state.dot];
            return nextSymbol && typeof nextSymbol !== "string";
        });
        if (expectantStates.length === 0) {
            lines.push("Unexpected " + tokenDisplay + ". I did not expect any more input. Here is the state of my parse table:\n");
            this.displayStateStack(lastColumn.states, lines);
        } else {
            lines.push("Unexpected " + tokenDisplay + ". Instead, I was expecting to see one of the following:\n");
            // Display a "state stack" for each expectant state
            // - which shows you how this state came to be, step by step.
            // If there is more than one derivation, we only display the first one.
            var stateStacks = expectantStates.map(function(state) {
                return this.buildFirstStateStack(state, []) || [
                    state
                ];
            }, this);
            // Display each state that is expecting a terminal symbol next.
            stateStacks.forEach(function(stateStack) {
                var state = stateStack[0];
                var nextSymbol = state.rule.symbols[state.dot];
                var symbolDisplay = this.getSymbolDisplay(nextSymbol);
                lines.push("A " + symbolDisplay + " based on:");
                this.displayStateStack(stateStack, lines);
            }, this);
        }
        lines.push("");
        return lines.join("\n");
    };
    Parser.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for(var j = 0; j < stateStack.length; j++){
            var state = stateStack[j];
            var display = state.rule.toString(state.dot);
            if (display === lastDisplay) sameDisplayCount++;
            else {
                if (sameDisplayCount > 0) lines.push("    ^ " + sameDisplayCount + " more lines identical to this");
                sameDisplayCount = 0;
                lines.push("    " + display);
            }
            lastDisplay = display;
        }
    };
    Parser.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
    };
    /*
    Builds a the first state stack. You can think of a state stack as the call stack
    of the recursive-descent parser which the Nearley parse algorithm simulates.
    A state stack is represented as an array of state objects. Within a
    state stack, the first item of the array will be the starting
    state, with each successive item in the array going further back into history.

    This function needs to be given a starting state and an empty array representing
    the visited states, and it returns an single state stack.

    */ Parser.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) // Found cycle, return null
        // to eliminate this path from the results, because
        // we don't know how to display it meaningfully
        return null;
        if (state.wantedBy.length === 0) return [
            state
        ];
        var prevState = state.wantedBy[0];
        var childVisited = [
            state
        ].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) return null;
        return [
            state
        ].concat(childResult);
    };
    Parser.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
    };
    Parser.prototype.restore = function(column) {
        var index = column.index;
        this.current = index;
        this.table[index] = column;
        this.table.splice(index + 1);
        this.lexerState = column.lexerState;
        // Incrementally keep track of results
        this.results = this.finish();
    };
    // nb. deprecated: use save/restore instead!
    Parser.prototype.rewind = function(index) {
        if (!this.options.keepHistory) throw new Error("set option `keepHistory` to enable rewinding");
        // nb. recall column (table) indicies fall between token indicies.
        //        col 0   --   token 0   --   col 1
        this.restore(this.table[index]);
    };
    Parser.prototype.finish = function() {
        // Return the possible parsings
        var considerations = [];
        var start = this.grammar.start;
        var column = this.table[this.table.length - 1];
        column.states.forEach(function(t) {
            if (t.rule.name === start && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser.fail) considerations.push(t);
        });
        return considerations.map(function(c) {
            return c.data;
        });
    };
    function getSymbolLongDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return "character matching " + symbol;
            else if (symbol.type) return symbol.type + " token";
            else if (symbol.test) return "token matching " + String(symbol.test);
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    function getSymbolShortDisplay(symbol) {
        var type = typeof symbol;
        if (type === "string") return symbol;
        else if (type === "object") {
            if (symbol.literal) return JSON.stringify(symbol.literal);
            else if (symbol instanceof RegExp) return symbol.toString();
            else if (symbol.type) return "%" + symbol.type;
            else if (symbol.test) return "<" + String(symbol.test) + ">";
            else throw new Error("Unknown symbol type: " + symbol);
        }
    }
    return {
        Parser: Parser,
        Grammar: Grammar,
        Rule: Rule
    };
});

});

parcelRegister("2DoKD", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, module.exports) module.exports = factory();
    else root.moo = factory();
})(module.exports, function() {
    "use strict";
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var toString = Object.prototype.toString;
    var hasSticky = typeof new RegExp().sticky === "boolean";
    /***************************************************************************/ function isRegExp(o) {
        return o && toString.call(o) === "[object RegExp]";
    }
    function isObject(o) {
        return o && typeof o === "object" && !isRegExp(o) && !Array.isArray(o);
    }
    function reEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function reGroups(s) {
        var re = new RegExp("|" + s);
        return re.exec("").length - 1;
    }
    function reCapture(s) {
        return "(" + s + ")";
    }
    function reUnion(regexps) {
        if (!regexps.length) return "(?!)";
        var source = regexps.map(function(s) {
            return "(?:" + s + ")";
        }).join("|");
        return "(?:" + source + ")";
    }
    function regexpOrLiteral(obj) {
        if (typeof obj === "string") return "(?:" + reEscape(obj) + ")";
        else if (isRegExp(obj)) {
            // TODO: consider /u support
            if (obj.ignoreCase) throw new Error("RegExp /i flag not allowed");
            if (obj.global) throw new Error("RegExp /g flag is implied");
            if (obj.sticky) throw new Error("RegExp /y flag is implied");
            if (obj.multiline) throw new Error("RegExp /m flag is implied");
            return obj.source;
        } else throw new Error("Not a pattern: " + obj);
    }
    function pad(s, length) {
        if (s.length > length) return s;
        return Array(length - s.length + 1).join(" ") + s;
    }
    function lastNLines(string, numLines) {
        var position = string.length;
        var lineBreaks = 0;
        while(true){
            var idx = string.lastIndexOf("\n", position - 1);
            if (idx === -1) break;
            else lineBreaks++;
            position = idx;
            if (lineBreaks === numLines) break;
            if (position === 0) break;
        }
        var startPosition = lineBreaks < numLines ? 0 : position + 1;
        return string.substring(startPosition).split("\n");
    }
    function objectToRules(object) {
        var keys = Object.getOwnPropertyNames(object);
        var result = [];
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var thing = object[key];
            var rules = [].concat(thing);
            if (key === "include") {
                for(var j = 0; j < rules.length; j++)result.push({
                    include: rules[j]
                });
                continue;
            }
            var match = [];
            rules.forEach(function(rule) {
                if (isObject(rule)) {
                    if (match.length) result.push(ruleOptions(key, match));
                    result.push(ruleOptions(key, rule));
                    match = [];
                } else match.push(rule);
            });
            if (match.length) result.push(ruleOptions(key, match));
        }
        return result;
    }
    function arrayToRules(array) {
        var result = [];
        for(var i = 0; i < array.length; i++){
            var obj = array[i];
            if (obj.include) {
                var include = [].concat(obj.include);
                for(var j = 0; j < include.length; j++)result.push({
                    include: include[j]
                });
                continue;
            }
            if (!obj.type) throw new Error("Rule has no type: " + JSON.stringify(obj));
            result.push(ruleOptions(obj.type, obj));
        }
        return result;
    }
    function ruleOptions(type, obj) {
        if (!isObject(obj)) obj = {
            match: obj
        };
        if (obj.include) throw new Error("Matching rules cannot also include states");
        // nb. error and fallback imply lineBreaks
        var options = {
            defaultType: type,
            lineBreaks: !!obj.error || !!obj.fallback,
            pop: false,
            next: null,
            push: null,
            error: false,
            fallback: false,
            value: null,
            type: null,
            shouldThrow: false
        };
        // Avoid Object.assign(), so we support IE9+
        for(var key in obj)if (hasOwnProperty.call(obj, key)) options[key] = obj[key];
        // type transform cannot be a string
        if (typeof options.type === "string" && type !== options.type) throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')");
        // convert to array
        var match = options.match;
        options.match = Array.isArray(match) ? match : match ? [
            match
        ] : [];
        options.match.sort(function(a, b) {
            return isRegExp(a) && isRegExp(b) ? 0 : isRegExp(b) ? -1 : isRegExp(a) ? 1 : b.length - a.length;
        });
        return options;
    }
    function toRules(spec) {
        return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec);
    }
    var defaultErrorRule = ruleOptions("error", {
        lineBreaks: true,
        shouldThrow: true
    });
    function compileRules(rules, hasStates) {
        var errorRule = null;
        var fast = Object.create(null);
        var fastAllowed = true;
        var unicodeFlag = null;
        var groups = [];
        var parts = [];
        // If there is a fallback rule, then disable fast matching
        for(var i = 0; i < rules.length; i++)if (rules[i].fallback) fastAllowed = false;
        for(var i = 0; i < rules.length; i++){
            var options = rules[i];
            if (options.include) // all valid inclusions are removed by states() preprocessor
            throw new Error("Inheritance is not allowed in stateless lexers");
            if (options.error || options.fallback) {
                // errorRule can only be set once
                if (errorRule) {
                    if (!options.fallback === !errorRule.fallback) throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')");
                    else throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')");
                }
                errorRule = options;
            }
            var match = options.match.slice();
            if (fastAllowed) while(match.length && typeof match[0] === "string" && match[0].length === 1){
                var word = match.shift();
                fast[word.charCodeAt(0)] = options;
            }
            // Warn about inappropriate state-switching options
            if (options.pop || options.push || options.next) {
                if (!hasStates) throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')");
                if (options.fallback) throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')");
            }
            // Only rules with a .match are included in the RegExp
            if (match.length === 0) continue;
            fastAllowed = false;
            groups.push(options);
            // Check unicode flag is used everywhere or nowhere
            for(var j = 0; j < match.length; j++){
                var obj = match[j];
                if (!isRegExp(obj)) continue;
                if (unicodeFlag === null) unicodeFlag = obj.unicode;
                else if (unicodeFlag !== obj.unicode && options.fallback === false) throw new Error("If one rule is /u then all must be");
            }
            // convert to RegExp
            var pat = reUnion(match.map(regexpOrLiteral));
            // validate
            var regexp = new RegExp(pat);
            if (regexp.test("")) throw new Error("RegExp matches empty string: " + regexp);
            var groupCount = reGroups(pat);
            if (groupCount > 0) throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: \u2026 ) instead");
            // try and detect rules matching newlines
            if (!options.lineBreaks && regexp.test("\n")) throw new Error("Rule should declare lineBreaks: " + regexp);
            // store regex
            parts.push(reCapture(pat));
        }
        // If there's no fallback rule, use the sticky flag so we only look for
        // matches at the current index.
        //
        // If we don't support the sticky flag, then fake it using an irrefutable
        // match (i.e. an empty pattern).
        var fallbackRule = errorRule && errorRule.fallback;
        var flags = hasSticky && !fallbackRule ? "ym" : "gm";
        var suffix = hasSticky || fallbackRule ? "" : "|";
        if (unicodeFlag === true) flags += "u";
        var combined = new RegExp(reUnion(parts) + suffix, flags);
        return {
            regexp: combined,
            groups: groups,
            fast: fast,
            error: errorRule || defaultErrorRule
        };
    }
    function compile(rules) {
        var result = compileRules(toRules(rules));
        return new Lexer({
            start: result
        }, "start");
    }
    function checkStateGroup(g, name, map) {
        var state = g && (g.push || g.next);
        if (state && !map[state]) throw new Error("Missing state '" + state + "' (in token '" + g.defaultType + "' of state '" + name + "')");
        if (g && g.pop && +g.pop !== 1) throw new Error("pop must be 1 (in token '" + g.defaultType + "' of state '" + name + "')");
    }
    function compileStates(states, start) {
        var all = states.$all ? toRules(states.$all) : [];
        delete states.$all;
        var keys = Object.getOwnPropertyNames(states);
        if (!start) start = keys[0];
        var ruleMap = Object.create(null);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            ruleMap[key] = toRules(states[key]).concat(all);
        }
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var rules = ruleMap[key];
            var included = Object.create(null);
            for(var j = 0; j < rules.length; j++){
                var rule = rules[j];
                if (!rule.include) continue;
                var splice = [
                    j,
                    1
                ];
                if (rule.include !== key && !included[rule.include]) {
                    included[rule.include] = true;
                    var newRules = ruleMap[rule.include];
                    if (!newRules) throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')");
                    for(var k = 0; k < newRules.length; k++){
                        var newRule = newRules[k];
                        if (rules.indexOf(newRule) !== -1) continue;
                        splice.push(newRule);
                    }
                }
                rules.splice.apply(rules, splice);
                j--;
            }
        }
        var map = Object.create(null);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            map[key] = compileRules(ruleMap[key], true);
        }
        for(var i = 0; i < keys.length; i++){
            var name = keys[i];
            var state = map[name];
            var groups = state.groups;
            for(var j = 0; j < groups.length; j++)checkStateGroup(groups[j], name, map);
            var fastKeys = Object.getOwnPropertyNames(state.fast);
            for(var j = 0; j < fastKeys.length; j++)checkStateGroup(state.fast[fastKeys[j]], name, map);
        }
        return new Lexer(map, start);
    }
    function keywordTransform(map) {
        // Use a JavaScript Map to map keywords to their corresponding token type
        // unless Map is unsupported, then fall back to using an Object:
        var isMap = typeof Map !== "undefined";
        var reverseMap = isMap ? new Map : Object.create(null);
        var types = Object.getOwnPropertyNames(map);
        for(var i = 0; i < types.length; i++){
            var tokenType = types[i];
            var item = map[tokenType];
            var keywordList = Array.isArray(item) ? item : [
                item
            ];
            keywordList.forEach(function(keyword) {
                if (typeof keyword !== "string") throw new Error("keyword must be string (in keyword '" + tokenType + "')");
                if (isMap) reverseMap.set(keyword, tokenType);
                else reverseMap[keyword] = tokenType;
            });
        }
        return function(k) {
            return isMap ? reverseMap.get(k) : reverseMap[k];
        };
    }
    /***************************************************************************/ var Lexer = function(states, state) {
        this.startState = state;
        this.states = states;
        this.buffer = "";
        this.stack = [];
        this.reset();
    };
    Lexer.prototype.reset = function(data, info) {
        this.buffer = data || "";
        this.index = 0;
        this.line = info ? info.line : 1;
        this.col = info ? info.col : 1;
        this.queuedToken = info ? info.queuedToken : null;
        this.queuedText = info ? info.queuedText : "";
        this.queuedThrow = info ? info.queuedThrow : null;
        this.setState(info ? info.state : this.startState);
        this.stack = info && info.stack ? info.stack.slice() : [];
        return this;
    };
    Lexer.prototype.save = function() {
        return {
            line: this.line,
            col: this.col,
            state: this.state,
            stack: this.stack.slice(),
            queuedToken: this.queuedToken,
            queuedText: this.queuedText,
            queuedThrow: this.queuedThrow
        };
    };
    Lexer.prototype.setState = function(state) {
        if (!state || this.state === state) return;
        this.state = state;
        var info = this.states[state];
        this.groups = info.groups;
        this.error = info.error;
        this.re = info.regexp;
        this.fast = info.fast;
    };
    Lexer.prototype.popState = function() {
        this.setState(this.stack.pop());
    };
    Lexer.prototype.pushState = function(state) {
        this.stack.push(this.state);
        this.setState(state);
    };
    var eat = hasSticky ? function(re, buffer) {
        return re.exec(buffer);
    } : function(re, buffer) {
        var match = re.exec(buffer);
        // will always match, since we used the |(?:) trick
        if (match[0].length === 0) return null;
        return match;
    };
    Lexer.prototype._getGroup = function(match) {
        var groupCount = this.groups.length;
        for(var i = 0; i < groupCount; i++){
            if (match[i + 1] !== undefined) return this.groups[i];
        }
        throw new Error("Cannot find token type for matched text");
    };
    function tokenToString() {
        return this.value;
    }
    Lexer.prototype.next = function() {
        var index = this.index;
        // If a fallback token matched, we don't need to re-run the RegExp
        if (this.queuedGroup) {
            var token = this._token(this.queuedGroup, this.queuedText, index);
            this.queuedGroup = null;
            this.queuedText = "";
            return token;
        }
        var buffer = this.buffer;
        if (index === buffer.length) return; // EOF
        // Fast matching for single characters
        var group = this.fast[buffer.charCodeAt(index)];
        if (group) return this._token(group, buffer.charAt(index), index);
        // Execute RegExp
        var re = this.re;
        re.lastIndex = index;
        var match = eat(re, buffer);
        // Error tokens match the remaining buffer
        var error = this.error;
        if (match == null) return this._token(error, buffer.slice(index, buffer.length), index);
        var group = this._getGroup(match);
        var text = match[0];
        if (error.fallback && match.index !== index) {
            this.queuedGroup = group;
            this.queuedText = text;
            // Fallback tokens contain the unmatched portion of the buffer
            return this._token(error, buffer.slice(index, match.index), index);
        }
        return this._token(group, text, index);
    };
    Lexer.prototype._token = function(group, text, offset) {
        // count line breaks
        var lineBreaks = 0;
        if (group.lineBreaks) {
            var matchNL = /\n/g;
            var nl = 1;
            if (text === "\n") lineBreaks = 1;
            else while(matchNL.exec(text)){
                lineBreaks++;
                nl = matchNL.lastIndex;
            }
        }
        var token = {
            type: typeof group.type === "function" && group.type(text) || group.defaultType,
            value: typeof group.value === "function" ? group.value(text) : text,
            text: text,
            toString: tokenToString,
            offset: offset,
            lineBreaks: lineBreaks,
            line: this.line,
            col: this.col
        };
        // nb. adding more props to token object will make V8 sad!
        var size = text.length;
        this.index += size;
        this.line += lineBreaks;
        if (lineBreaks !== 0) this.col = size - nl + 1;
        else this.col += size;
        // throw, if no rule with {error: true}
        if (group.shouldThrow) {
            var err = new Error(this.formatError(token, "invalid syntax"));
            throw err;
        }
        if (group.pop) this.popState();
        else if (group.push) this.pushState(group.push);
        else if (group.next) this.setState(group.next);
        return token;
    };
    if (typeof Symbol !== "undefined" && Symbol.iterator) {
        var LexerIterator = function(lexer) {
            this.lexer = lexer;
        };
        LexerIterator.prototype.next = function() {
            var token = this.lexer.next();
            return {
                value: token,
                done: !token
            };
        };
        LexerIterator.prototype[Symbol.iterator] = function() {
            return this;
        };
        Lexer.prototype[Symbol.iterator] = function() {
            return new LexerIterator(this);
        };
    }
    Lexer.prototype.formatError = function(token, message) {
        if (token == null) {
            // An undefined token indicates EOF
            var text = this.buffer.slice(this.index);
            var token = {
                text: text,
                offset: this.index,
                lineBreaks: text.indexOf("\n") === -1 ? 0 : 1,
                line: this.line,
                col: this.col
            };
        }
        var numLinesAround = 2;
        var firstDisplayedLine = Math.max(token.line - numLinesAround, 1);
        var lastDisplayedLine = token.line + numLinesAround;
        var lastLineDigits = String(lastDisplayedLine).length;
        var displayedLines = lastNLines(this.buffer, this.line - token.line + numLinesAround + 1).slice(0, 5);
        var errorLines = [];
        errorLines.push(message + " at line " + token.line + " col " + token.col + ":");
        errorLines.push("");
        for(var i = 0; i < displayedLines.length; i++){
            var line = displayedLines[i];
            var lineNo = firstDisplayedLine + i;
            errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
            if (lineNo === token.line) errorLines.push(pad("", lastLineDigits + token.col + 1) + "^");
        }
        return errorLines.join("\n");
    };
    Lexer.prototype.clone = function() {
        return new Lexer(this.states, this.state);
    };
    Lexer.prototype.has = function(tokenType) {
        return true;
    };
    return {
        compile: compile,
        states: compileStates,
        error: Object.freeze({
            error: true
        }),
        fallback: Object.freeze({
            fallback: true
        }),
        keywords: keywordTransform
    };
});

});




parcelRegister("4AGYB", function(module, exports) {
"use strict";
var $357bdc6d20ef9d3c$var$isMergeableObject = function isMergeableObject(value) {
    return $357bdc6d20ef9d3c$var$isNonNullObject(value) && !$357bdc6d20ef9d3c$var$isSpecial(value);
};
function $357bdc6d20ef9d3c$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $357bdc6d20ef9d3c$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $357bdc6d20ef9d3c$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $357bdc6d20ef9d3c$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $357bdc6d20ef9d3c$var$REACT_ELEMENT_TYPE = $357bdc6d20ef9d3c$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $357bdc6d20ef9d3c$var$isReactElement(value) {
    return value.$$typeof === $357bdc6d20ef9d3c$var$REACT_ELEMENT_TYPE;
}
function $357bdc6d20ef9d3c$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $357bdc6d20ef9d3c$var$deepmerge($357bdc6d20ef9d3c$var$emptyTarget(value), value, options) : value;
}
function $357bdc6d20ef9d3c$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $357bdc6d20ef9d3c$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $357bdc6d20ef9d3c$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $357bdc6d20ef9d3c$var$deepmerge;
}
function $357bdc6d20ef9d3c$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $357bdc6d20ef9d3c$var$getKeys(target) {
    return Object.keys(target).concat($357bdc6d20ef9d3c$var$getEnumerableOwnPropertySymbols(target));
}
function $357bdc6d20ef9d3c$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $357bdc6d20ef9d3c$var$propertyIsUnsafe(target, key) {
    return $357bdc6d20ef9d3c$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $357bdc6d20ef9d3c$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $357bdc6d20ef9d3c$var$getKeys(target).forEach(function(key) {
        destination[key] = $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $357bdc6d20ef9d3c$var$getKeys(source).forEach(function(key) {
        if ($357bdc6d20ef9d3c$var$propertyIsUnsafe(target, key)) return;
        if ($357bdc6d20ef9d3c$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $357bdc6d20ef9d3c$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $357bdc6d20ef9d3c$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $357bdc6d20ef9d3c$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $357bdc6d20ef9d3c$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $357bdc6d20ef9d3c$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $357bdc6d20ef9d3c$var$mergeObject(target, source, options);
}
$357bdc6d20ef9d3c$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $357bdc6d20ef9d3c$var$deepmerge(prev, next, options);
    }, {});
};
var $357bdc6d20ef9d3c$var$deepmerge_1 = $357bdc6d20ef9d3c$var$deepmerge;
module.exports = $357bdc6d20ef9d3c$var$deepmerge_1;

});

parcelRegister("2eMeB", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        "\xad": "shy",
        "\u200C": "zwnj",
        "\u200D": "zwj",
        "\u200E": "lrm",
        "\u2063": "ic",
        "\u2062": "it",
        "\u2061": "af",
        "\u200F": "rlm",
        "\u200B": "ZeroWidthSpace",
        "\u2060": "NoBreak",
        "\u0311": "DownBreve",
        "\u20DB": "tdot",
        "\u20DC": "DotDot",
        "	": "Tab",
        "\n": "NewLine",
        "\u2008": "puncsp",
        "\u205F": "MediumSpace",
        "\u2009": "thinsp",
        "\u200A": "hairsp",
        "\u2004": "emsp13",
        "\u2002": "ensp",
        "\u2005": "emsp14",
        "\u2003": "emsp",
        "\u2007": "numsp",
        "\xa0": "nbsp",
        "\u205F\u200A": "ThickSpace",
        "\u203E": "oline",
        "_": "lowbar",
        "\u2010": "dash",
        "\u2013": "ndash",
        "\u2014": "mdash",
        "\u2015": "horbar",
        ",": "comma",
        ";": "semi",
        "\u204F": "bsemi",
        ":": "colon",
        "\u2A74": "Colone",
        "!": "excl",
        "\xa1": "iexcl",
        "?": "quest",
        "\xbf": "iquest",
        ".": "period",
        "\u2025": "nldr",
        "\u2026": "mldr",
        "\xb7": "middot",
        "'": "apos",
        "\u2018": "lsquo",
        "\u2019": "rsquo",
        "\u201A": "sbquo",
        "\u2039": "lsaquo",
        "\u203A": "rsaquo",
        '"': "quot",
        "\u201C": "ldquo",
        "\u201D": "rdquo",
        "\u201E": "bdquo",
        "\xab": "laquo",
        "\xbb": "raquo",
        "(": "lpar",
        ")": "rpar",
        "[": "lsqb",
        "]": "rsqb",
        "{": "lcub",
        "}": "rcub",
        "\u2308": "lceil",
        "\u2309": "rceil",
        "\u230A": "lfloor",
        "\u230B": "rfloor",
        "\u2985": "lopar",
        "\u2986": "ropar",
        "\u298B": "lbrke",
        "\u298C": "rbrke",
        "\u298D": "lbrkslu",
        "\u298E": "rbrksld",
        "\u298F": "lbrksld",
        "\u2990": "rbrkslu",
        "\u2991": "langd",
        "\u2992": "rangd",
        "\u2993": "lparlt",
        "\u2994": "rpargt",
        "\u2995": "gtlPar",
        "\u2996": "ltrPar",
        "\u27E6": "lobrk",
        "\u27E7": "robrk",
        "\u27E8": "lang",
        "\u27E9": "rang",
        "\u27EA": "Lang",
        "\u27EB": "Rang",
        "\u27EC": "loang",
        "\u27ED": "roang",
        "\u2772": "lbbrk",
        "\u2773": "rbbrk",
        "\u2016": "Vert",
        "\xa7": "sect",
        "\xb6": "para",
        "@": "commat",
        "*": "ast",
        "/": "sol",
        "undefined": null,
        "&": "amp",
        "#": "num",
        "%": "percnt",
        "\u2030": "permil",
        "\u2031": "pertenk",
        "\u2020": "dagger",
        "\u2021": "Dagger",
        "\u2022": "bull",
        "\u2043": "hybull",
        "\u2032": "prime",
        "\u2033": "Prime",
        "\u2034": "tprime",
        "\u2057": "qprime",
        "\u2035": "bprime",
        "\u2041": "caret",
        "`": "grave",
        "\xb4": "acute",
        "\u02DC": "tilde",
        "^": "Hat",
        "\xaf": "macr",
        "\u02D8": "breve",
        "\u02D9": "dot",
        "\xa8": "die",
        "\u02DA": "ring",
        "\u02DD": "dblac",
        "\xb8": "cedil",
        "\u02DB": "ogon",
        "\u02C6": "circ",
        "\u02C7": "caron",
        "\xb0": "deg",
        "\xa9": "copy",
        "\xae": "reg",
        "\u2117": "copysr",
        "\u2118": "wp",
        "\u211E": "rx",
        "\u2127": "mho",
        "\u2129": "iiota",
        "\u2190": "larr",
        "\u219A": "nlarr",
        "\u2192": "rarr",
        "\u219B": "nrarr",
        "\u2191": "uarr",
        "\u2193": "darr",
        "\u2194": "harr",
        "\u21AE": "nharr",
        "\u2195": "varr",
        "\u2196": "nwarr",
        "\u2197": "nearr",
        "\u2198": "searr",
        "\u2199": "swarr",
        "\u219D": "rarrw",
        "\u219D\u0338": "nrarrw",
        "\u219E": "Larr",
        "\u219F": "Uarr",
        "\u21A0": "Rarr",
        "\u21A1": "Darr",
        "\u21A2": "larrtl",
        "\u21A3": "rarrtl",
        "\u21A4": "mapstoleft",
        "\u21A5": "mapstoup",
        "\u21A6": "map",
        "\u21A7": "mapstodown",
        "\u21A9": "larrhk",
        "\u21AA": "rarrhk",
        "\u21AB": "larrlp",
        "\u21AC": "rarrlp",
        "\u21AD": "harrw",
        "\u21B0": "lsh",
        "\u21B1": "rsh",
        "\u21B2": "ldsh",
        "\u21B3": "rdsh",
        "\u21B5": "crarr",
        "\u21B6": "cularr",
        "\u21B7": "curarr",
        "\u21BA": "olarr",
        "\u21BB": "orarr",
        "\u21BC": "lharu",
        "\u21BD": "lhard",
        "\u21BE": "uharr",
        "\u21BF": "uharl",
        "\u21C0": "rharu",
        "\u21C1": "rhard",
        "\u21C2": "dharr",
        "\u21C3": "dharl",
        "\u21C4": "rlarr",
        "\u21C5": "udarr",
        "\u21C6": "lrarr",
        "\u21C7": "llarr",
        "\u21C8": "uuarr",
        "\u21C9": "rrarr",
        "\u21CA": "ddarr",
        "\u21CB": "lrhar",
        "\u21CC": "rlhar",
        "\u21D0": "lArr",
        "\u21CD": "nlArr",
        "\u21D1": "uArr",
        "\u21D2": "rArr",
        "\u21CF": "nrArr",
        "\u21D3": "dArr",
        "\u21D4": "iff",
        "\u21CE": "nhArr",
        "\u21D5": "vArr",
        "\u21D6": "nwArr",
        "\u21D7": "neArr",
        "\u21D8": "seArr",
        "\u21D9": "swArr",
        "\u21DA": "lAarr",
        "\u21DB": "rAarr",
        "\u21DD": "zigrarr",
        "\u21E4": "larrb",
        "\u21E5": "rarrb",
        "\u21F5": "duarr",
        "\u21FD": "loarr",
        "\u21FE": "roarr",
        "\u21FF": "hoarr",
        "\u2200": "forall",
        "\u2201": "comp",
        "\u2202": "part",
        "\u2202\u0338": "npart",
        "\u2203": "exist",
        "\u2204": "nexist",
        "\u2205": "empty",
        "\u2207": "Del",
        "\u2208": "in",
        "\u2209": "notin",
        "\u220B": "ni",
        "\u220C": "notni",
        "\u03F6": "bepsi",
        "\u220F": "prod",
        "\u2210": "coprod",
        "\u2211": "sum",
        "+": "plus",
        "\xb1": "pm",
        "\xf7": "div",
        "\xd7": "times",
        "<": "lt",
        "\u226E": "nlt",
        "<\u20D2": "nvlt",
        "=": "equals",
        "\u2260": "ne",
        "=\u20E5": "bne",
        "\u2A75": "Equal",
        ">": "gt",
        "\u226F": "ngt",
        ">\u20D2": "nvgt",
        "\xac": "not",
        "|": "vert",
        "\xa6": "brvbar",
        "\u2212": "minus",
        "\u2213": "mp",
        "\u2214": "plusdo",
        "\u2044": "frasl",
        "\u2216": "setmn",
        "\u2217": "lowast",
        "\u2218": "compfn",
        "\u221A": "Sqrt",
        "\u221D": "prop",
        "\u221E": "infin",
        "\u221F": "angrt",
        "\u2220": "ang",
        "\u2220\u20D2": "nang",
        "\u2221": "angmsd",
        "\u2222": "angsph",
        "\u2223": "mid",
        "\u2224": "nmid",
        "\u2225": "par",
        "\u2226": "npar",
        "\u2227": "and",
        "\u2228": "or",
        "\u2229": "cap",
        "\u2229\uFE00": "caps",
        "\u222A": "cup",
        "\u222A\uFE00": "cups",
        "\u222B": "int",
        "\u222C": "Int",
        "\u222D": "tint",
        "\u2A0C": "qint",
        "\u222E": "oint",
        "\u222F": "Conint",
        "\u2230": "Cconint",
        "\u2231": "cwint",
        "\u2232": "cwconint",
        "\u2233": "awconint",
        "\u2234": "there4",
        "\u2235": "becaus",
        "\u2236": "ratio",
        "\u2237": "Colon",
        "\u2238": "minusd",
        "\u223A": "mDDot",
        "\u223B": "homtht",
        "\u223C": "sim",
        "\u2241": "nsim",
        "\u223C\u20D2": "nvsim",
        "\u223D": "bsim",
        "\u223D\u0331": "race",
        "\u223E": "ac",
        "\u223E\u0333": "acE",
        "\u223F": "acd",
        "\u2240": "wr",
        "\u2242": "esim",
        "\u2242\u0338": "nesim",
        "\u2243": "sime",
        "\u2244": "nsime",
        "\u2245": "cong",
        "\u2247": "ncong",
        "\u2246": "simne",
        "\u2248": "ap",
        "\u2249": "nap",
        "\u224A": "ape",
        "\u224B": "apid",
        "\u224B\u0338": "napid",
        "\u224C": "bcong",
        "\u224D": "CupCap",
        "\u226D": "NotCupCap",
        "\u224D\u20D2": "nvap",
        "\u224E": "bump",
        "\u224E\u0338": "nbump",
        "\u224F": "bumpe",
        "\u224F\u0338": "nbumpe",
        "\u2250": "doteq",
        "\u2250\u0338": "nedot",
        "\u2251": "eDot",
        "\u2252": "efDot",
        "\u2253": "erDot",
        "\u2254": "colone",
        "\u2255": "ecolon",
        "\u2256": "ecir",
        "\u2257": "cire",
        "\u2259": "wedgeq",
        "\u225A": "veeeq",
        "\u225C": "trie",
        "\u225F": "equest",
        "\u2261": "equiv",
        "\u2262": "nequiv",
        "\u2261\u20E5": "bnequiv",
        "\u2264": "le",
        "\u2270": "nle",
        "\u2264\u20D2": "nvle",
        "\u2265": "ge",
        "\u2271": "nge",
        "\u2265\u20D2": "nvge",
        "\u2266": "lE",
        "\u2266\u0338": "nlE",
        "\u2267": "gE",
        "\u2267\u0338": "ngE",
        "\u2268\uFE00": "lvnE",
        "\u2268": "lnE",
        "\u2269": "gnE",
        "\u2269\uFE00": "gvnE",
        "\u226A": "ll",
        "\u226A\u0338": "nLtv",
        "\u226A\u20D2": "nLt",
        "\u226B": "gg",
        "\u226B\u0338": "nGtv",
        "\u226B\u20D2": "nGt",
        "\u226C": "twixt",
        "\u2272": "lsim",
        "\u2274": "nlsim",
        "\u2273": "gsim",
        "\u2275": "ngsim",
        "\u2276": "lg",
        "\u2278": "ntlg",
        "\u2277": "gl",
        "\u2279": "ntgl",
        "\u227A": "pr",
        "\u2280": "npr",
        "\u227B": "sc",
        "\u2281": "nsc",
        "\u227C": "prcue",
        "\u22E0": "nprcue",
        "\u227D": "sccue",
        "\u22E1": "nsccue",
        "\u227E": "prsim",
        "\u227F": "scsim",
        "\u227F\u0338": "NotSucceedsTilde",
        "\u2282": "sub",
        "\u2284": "nsub",
        "\u2282\u20D2": "vnsub",
        "\u2283": "sup",
        "\u2285": "nsup",
        "\u2283\u20D2": "vnsup",
        "\u2286": "sube",
        "\u2288": "nsube",
        "\u2287": "supe",
        "\u2289": "nsupe",
        "\u228A\uFE00": "vsubne",
        "\u228A": "subne",
        "\u228B\uFE00": "vsupne",
        "\u228B": "supne",
        "\u228D": "cupdot",
        "\u228E": "uplus",
        "\u228F": "sqsub",
        "\u228F\u0338": "NotSquareSubset",
        "\u2290": "sqsup",
        "\u2290\u0338": "NotSquareSuperset",
        "\u2291": "sqsube",
        "\u22E2": "nsqsube",
        "\u2292": "sqsupe",
        "\u22E3": "nsqsupe",
        "\u2293": "sqcap",
        "\u2293\uFE00": "sqcaps",
        "\u2294": "sqcup",
        "\u2294\uFE00": "sqcups",
        "\u2295": "oplus",
        "\u2296": "ominus",
        "\u2297": "otimes",
        "\u2298": "osol",
        "\u2299": "odot",
        "\u229A": "ocir",
        "\u229B": "oast",
        "\u229D": "odash",
        "\u229E": "plusb",
        "\u229F": "minusb",
        "\u22A0": "timesb",
        "\u22A1": "sdotb",
        "\u22A2": "vdash",
        "\u22AC": "nvdash",
        "\u22A3": "dashv",
        "\u22A4": "top",
        "\u22A5": "bot",
        "\u22A7": "models",
        "\u22A8": "vDash",
        "\u22AD": "nvDash",
        "\u22A9": "Vdash",
        "\u22AE": "nVdash",
        "\u22AA": "Vvdash",
        "\u22AB": "VDash",
        "\u22AF": "nVDash",
        "\u22B0": "prurel",
        "\u22B2": "vltri",
        "\u22EA": "nltri",
        "\u22B3": "vrtri",
        "\u22EB": "nrtri",
        "\u22B4": "ltrie",
        "\u22EC": "nltrie",
        "\u22B4\u20D2": "nvltrie",
        "\u22B5": "rtrie",
        "\u22ED": "nrtrie",
        "\u22B5\u20D2": "nvrtrie",
        "\u22B6": "origof",
        "\u22B7": "imof",
        "\u22B8": "mumap",
        "\u22B9": "hercon",
        "\u22BA": "intcal",
        "\u22BB": "veebar",
        "\u22BD": "barvee",
        "\u22BE": "angrtvb",
        "\u22BF": "lrtri",
        "\u22C0": "Wedge",
        "\u22C1": "Vee",
        "\u22C2": "xcap",
        "\u22C3": "xcup",
        "\u22C4": "diam",
        "\u22C5": "sdot",
        "\u22C6": "Star",
        "\u22C7": "divonx",
        "\u22C8": "bowtie",
        "\u22C9": "ltimes",
        "\u22CA": "rtimes",
        "\u22CB": "lthree",
        "\u22CC": "rthree",
        "\u22CD": "bsime",
        "\u22CE": "cuvee",
        "\u22CF": "cuwed",
        "\u22D0": "Sub",
        "\u22D1": "Sup",
        "\u22D2": "Cap",
        "\u22D3": "Cup",
        "\u22D4": "fork",
        "\u22D5": "epar",
        "\u22D6": "ltdot",
        "\u22D7": "gtdot",
        "\u22D8": "Ll",
        "\u22D8\u0338": "nLl",
        "\u22D9": "Gg",
        "\u22D9\u0338": "nGg",
        "\u22DA\uFE00": "lesg",
        "\u22DA": "leg",
        "\u22DB": "gel",
        "\u22DB\uFE00": "gesl",
        "\u22DE": "cuepr",
        "\u22DF": "cuesc",
        "\u22E6": "lnsim",
        "\u22E7": "gnsim",
        "\u22E8": "prnsim",
        "\u22E9": "scnsim",
        "\u22EE": "vellip",
        "\u22EF": "ctdot",
        "\u22F0": "utdot",
        "\u22F1": "dtdot",
        "\u22F2": "disin",
        "\u22F3": "isinsv",
        "\u22F4": "isins",
        "\u22F5": "isindot",
        "\u22F5\u0338": "notindot",
        "\u22F6": "notinvc",
        "\u22F7": "notinvb",
        "\u22F9": "isinE",
        "\u22F9\u0338": "notinE",
        "\u22FA": "nisd",
        "\u22FB": "xnis",
        "\u22FC": "nis",
        "\u22FD": "notnivc",
        "\u22FE": "notnivb",
        "\u2305": "barwed",
        "\u2306": "Barwed",
        "\u230C": "drcrop",
        "\u230D": "dlcrop",
        "\u230E": "urcrop",
        "\u230F": "ulcrop",
        "\u2310": "bnot",
        "\u2312": "profline",
        "\u2313": "profsurf",
        "\u2315": "telrec",
        "\u2316": "target",
        "\u231C": "ulcorn",
        "\u231D": "urcorn",
        "\u231E": "dlcorn",
        "\u231F": "drcorn",
        "\u2322": "frown",
        "\u2323": "smile",
        "\u232D": "cylcty",
        "\u232E": "profalar",
        "\u2336": "topbot",
        "\u233D": "ovbar",
        "\u233F": "solbar",
        "\u237C": "angzarr",
        "\u23B0": "lmoust",
        "\u23B1": "rmoust",
        "\u23B4": "tbrk",
        "\u23B5": "bbrk",
        "\u23B6": "bbrktbrk",
        "\u23DC": "OverParenthesis",
        "\u23DD": "UnderParenthesis",
        "\u23DE": "OverBrace",
        "\u23DF": "UnderBrace",
        "\u23E2": "trpezium",
        "\u23E7": "elinters",
        "\u2423": "blank",
        "\u2500": "boxh",
        "\u2502": "boxv",
        "\u250C": "boxdr",
        "\u2510": "boxdl",
        "\u2514": "boxur",
        "\u2518": "boxul",
        "\u251C": "boxvr",
        "\u2524": "boxvl",
        "\u252C": "boxhd",
        "\u2534": "boxhu",
        "\u253C": "boxvh",
        "\u2550": "boxH",
        "\u2551": "boxV",
        "\u2552": "boxdR",
        "\u2553": "boxDr",
        "\u2554": "boxDR",
        "\u2555": "boxdL",
        "\u2556": "boxDl",
        "\u2557": "boxDL",
        "\u2558": "boxuR",
        "\u2559": "boxUr",
        "\u255A": "boxUR",
        "\u255B": "boxuL",
        "\u255C": "boxUl",
        "\u255D": "boxUL",
        "\u255E": "boxvR",
        "\u255F": "boxVr",
        "\u2560": "boxVR",
        "\u2561": "boxvL",
        "\u2562": "boxVl",
        "\u2563": "boxVL",
        "\u2564": "boxHd",
        "\u2565": "boxhD",
        "\u2566": "boxHD",
        "\u2567": "boxHu",
        "\u2568": "boxhU",
        "\u2569": "boxHU",
        "\u256A": "boxvH",
        "\u256B": "boxVh",
        "\u256C": "boxVH",
        "\u2580": "uhblk",
        "\u2584": "lhblk",
        "\u2588": "block",
        "\u2591": "blk14",
        "\u2592": "blk12",
        "\u2593": "blk34",
        "\u25A1": "squ",
        "\u25AA": "squf",
        "\u25AB": "EmptyVerySmallSquare",
        "\u25AD": "rect",
        "\u25AE": "marker",
        "\u25B1": "fltns",
        "\u25B3": "xutri",
        "\u25B4": "utrif",
        "\u25B5": "utri",
        "\u25B8": "rtrif",
        "\u25B9": "rtri",
        "\u25BD": "xdtri",
        "\u25BE": "dtrif",
        "\u25BF": "dtri",
        "\u25C2": "ltrif",
        "\u25C3": "ltri",
        "\u25CA": "loz",
        "\u25CB": "cir",
        "\u25EC": "tridot",
        "\u25EF": "xcirc",
        "\u25F8": "ultri",
        "\u25F9": "urtri",
        "\u25FA": "lltri",
        "\u25FB": "EmptySmallSquare",
        "\u25FC": "FilledSmallSquare",
        "\u2605": "starf",
        "\u2606": "star",
        "\u260E": "phone",
        "\u2640": "female",
        "\u2642": "male",
        "\u2660": "spades",
        "\u2663": "clubs",
        "\u2665": "hearts",
        "\u2666": "diams",
        "\u266A": "sung",
        "\u2713": "check",
        "\u2717": "cross",
        "\u2720": "malt",
        "\u2736": "sext",
        "\u2758": "VerticalSeparator",
        "\u27C8": "bsolhsub",
        "\u27C9": "suphsol",
        "\u27F5": "xlarr",
        "\u27F6": "xrarr",
        "\u27F7": "xharr",
        "\u27F8": "xlArr",
        "\u27F9": "xrArr",
        "\u27FA": "xhArr",
        "\u27FC": "xmap",
        "\u27FF": "dzigrarr",
        "\u2902": "nvlArr",
        "\u2903": "nvrArr",
        "\u2904": "nvHarr",
        "\u2905": "Map",
        "\u290C": "lbarr",
        "\u290D": "rbarr",
        "\u290E": "lBarr",
        "\u290F": "rBarr",
        "\u2910": "RBarr",
        "\u2911": "DDotrahd",
        "\u2912": "UpArrowBar",
        "\u2913": "DownArrowBar",
        "\u2916": "Rarrtl",
        "\u2919": "latail",
        "\u291A": "ratail",
        "\u291B": "lAtail",
        "\u291C": "rAtail",
        "\u291D": "larrfs",
        "\u291E": "rarrfs",
        "\u291F": "larrbfs",
        "\u2920": "rarrbfs",
        "\u2923": "nwarhk",
        "\u2924": "nearhk",
        "\u2925": "searhk",
        "\u2926": "swarhk",
        "\u2927": "nwnear",
        "\u2928": "toea",
        "\u2929": "tosa",
        "\u292A": "swnwar",
        "\u2933": "rarrc",
        "\u2933\u0338": "nrarrc",
        "\u2935": "cudarrr",
        "\u2936": "ldca",
        "\u2937": "rdca",
        "\u2938": "cudarrl",
        "\u2939": "larrpl",
        "\u293C": "curarrm",
        "\u293D": "cularrp",
        "\u2945": "rarrpl",
        "\u2948": "harrcir",
        "\u2949": "Uarrocir",
        "\u294A": "lurdshar",
        "\u294B": "ldrushar",
        "\u294E": "LeftRightVector",
        "\u294F": "RightUpDownVector",
        "\u2950": "DownLeftRightVector",
        "\u2951": "LeftUpDownVector",
        "\u2952": "LeftVectorBar",
        "\u2953": "RightVectorBar",
        "\u2954": "RightUpVectorBar",
        "\u2955": "RightDownVectorBar",
        "\u2956": "DownLeftVectorBar",
        "\u2957": "DownRightVectorBar",
        "\u2958": "LeftUpVectorBar",
        "\u2959": "LeftDownVectorBar",
        "\u295A": "LeftTeeVector",
        "\u295B": "RightTeeVector",
        "\u295C": "RightUpTeeVector",
        "\u295D": "RightDownTeeVector",
        "\u295E": "DownLeftTeeVector",
        "\u295F": "DownRightTeeVector",
        "\u2960": "LeftUpTeeVector",
        "\u2961": "LeftDownTeeVector",
        "\u2962": "lHar",
        "\u2963": "uHar",
        "\u2964": "rHar",
        "\u2965": "dHar",
        "\u2966": "luruhar",
        "\u2967": "ldrdhar",
        "\u2968": "ruluhar",
        "\u2969": "rdldhar",
        "\u296A": "lharul",
        "\u296B": "llhard",
        "\u296C": "rharul",
        "\u296D": "lrhard",
        "\u296E": "udhar",
        "\u296F": "duhar",
        "\u2970": "RoundImplies",
        "\u2971": "erarr",
        "\u2972": "simrarr",
        "\u2973": "larrsim",
        "\u2974": "rarrsim",
        "\u2975": "rarrap",
        "\u2976": "ltlarr",
        "\u2978": "gtrarr",
        "\u2979": "subrarr",
        "\u297B": "suplarr",
        "\u297C": "lfisht",
        "\u297D": "rfisht",
        "\u297E": "ufisht",
        "\u297F": "dfisht",
        "\u299A": "vzigzag",
        "\u299C": "vangrt",
        "\u299D": "angrtvbd",
        "\u29A4": "ange",
        "\u29A5": "range",
        "\u29A6": "dwangle",
        "\u29A7": "uwangle",
        "\u29A8": "angmsdaa",
        "\u29A9": "angmsdab",
        "\u29AA": "angmsdac",
        "\u29AB": "angmsdad",
        "\u29AC": "angmsdae",
        "\u29AD": "angmsdaf",
        "\u29AE": "angmsdag",
        "\u29AF": "angmsdah",
        "\u29B0": "bemptyv",
        "\u29B1": "demptyv",
        "\u29B2": "cemptyv",
        "\u29B3": "raemptyv",
        "\u29B4": "laemptyv",
        "\u29B5": "ohbar",
        "\u29B6": "omid",
        "\u29B7": "opar",
        "\u29B9": "operp",
        "\u29BB": "olcross",
        "\u29BC": "odsold",
        "\u29BE": "olcir",
        "\u29BF": "ofcir",
        "\u29C0": "olt",
        "\u29C1": "ogt",
        "\u29C2": "cirscir",
        "\u29C3": "cirE",
        "\u29C4": "solb",
        "\u29C5": "bsolb",
        "\u29C9": "boxbox",
        "\u29CD": "trisb",
        "\u29CE": "rtriltri",
        "\u29CF": "LeftTriangleBar",
        "\u29CF\u0338": "NotLeftTriangleBar",
        "\u29D0": "RightTriangleBar",
        "\u29D0\u0338": "NotRightTriangleBar",
        "\u29DC": "iinfin",
        "\u29DD": "infintie",
        "\u29DE": "nvinfin",
        "\u29E3": "eparsl",
        "\u29E4": "smeparsl",
        "\u29E5": "eqvparsl",
        "\u29EB": "lozf",
        "\u29F4": "RuleDelayed",
        "\u29F6": "dsol",
        "\u2A00": "xodot",
        "\u2A01": "xoplus",
        "\u2A02": "xotime",
        "\u2A04": "xuplus",
        "\u2A06": "xsqcup",
        "\u2A0D": "fpartint",
        "\u2A10": "cirfnint",
        "\u2A11": "awint",
        "\u2A12": "rppolint",
        "\u2A13": "scpolint",
        "\u2A14": "npolint",
        "\u2A15": "pointint",
        "\u2A16": "quatint",
        "\u2A17": "intlarhk",
        "\u2A22": "pluscir",
        "\u2A23": "plusacir",
        "\u2A24": "simplus",
        "\u2A25": "plusdu",
        "\u2A26": "plussim",
        "\u2A27": "plustwo",
        "\u2A29": "mcomma",
        "\u2A2A": "minusdu",
        "\u2A2D": "loplus",
        "\u2A2E": "roplus",
        "\u2A2F": "Cross",
        "\u2A30": "timesd",
        "\u2A31": "timesbar",
        "\u2A33": "smashp",
        "\u2A34": "lotimes",
        "\u2A35": "rotimes",
        "\u2A36": "otimesas",
        "\u2A37": "Otimes",
        "\u2A38": "odiv",
        "\u2A39": "triplus",
        "\u2A3A": "triminus",
        "\u2A3B": "tritime",
        "\u2A3C": "iprod",
        "\u2A3F": "amalg",
        "\u2A40": "capdot",
        "\u2A42": "ncup",
        "\u2A43": "ncap",
        "\u2A44": "capand",
        "\u2A45": "cupor",
        "\u2A46": "cupcap",
        "\u2A47": "capcup",
        "\u2A48": "cupbrcap",
        "\u2A49": "capbrcup",
        "\u2A4A": "cupcup",
        "\u2A4B": "capcap",
        "\u2A4C": "ccups",
        "\u2A4D": "ccaps",
        "\u2A50": "ccupssm",
        "\u2A53": "And",
        "\u2A54": "Or",
        "\u2A55": "andand",
        "\u2A56": "oror",
        "\u2A57": "orslope",
        "\u2A58": "andslope",
        "\u2A5A": "andv",
        "\u2A5B": "orv",
        "\u2A5C": "andd",
        "\u2A5D": "ord",
        "\u2A5F": "wedbar",
        "\u2A66": "sdote",
        "\u2A6A": "simdot",
        "\u2A6D": "congdot",
        "\u2A6D\u0338": "ncongdot",
        "\u2A6E": "easter",
        "\u2A6F": "apacir",
        "\u2A70": "apE",
        "\u2A70\u0338": "napE",
        "\u2A71": "eplus",
        "\u2A72": "pluse",
        "\u2A73": "Esim",
        "\u2A77": "eDDot",
        "\u2A78": "equivDD",
        "\u2A79": "ltcir",
        "\u2A7A": "gtcir",
        "\u2A7B": "ltquest",
        "\u2A7C": "gtquest",
        "\u2A7D": "les",
        "\u2A7D\u0338": "nles",
        "\u2A7E": "ges",
        "\u2A7E\u0338": "nges",
        "\u2A7F": "lesdot",
        "\u2A80": "gesdot",
        "\u2A81": "lesdoto",
        "\u2A82": "gesdoto",
        "\u2A83": "lesdotor",
        "\u2A84": "gesdotol",
        "\u2A85": "lap",
        "\u2A86": "gap",
        "\u2A87": "lne",
        "\u2A88": "gne",
        "\u2A89": "lnap",
        "\u2A8A": "gnap",
        "\u2A8B": "lEg",
        "\u2A8C": "gEl",
        "\u2A8D": "lsime",
        "\u2A8E": "gsime",
        "\u2A8F": "lsimg",
        "\u2A90": "gsiml",
        "\u2A91": "lgE",
        "\u2A92": "glE",
        "\u2A93": "lesges",
        "\u2A94": "gesles",
        "\u2A95": "els",
        "\u2A96": "egs",
        "\u2A97": "elsdot",
        "\u2A98": "egsdot",
        "\u2A99": "el",
        "\u2A9A": "eg",
        "\u2A9D": "siml",
        "\u2A9E": "simg",
        "\u2A9F": "simlE",
        "\u2AA0": "simgE",
        "\u2AA1": "LessLess",
        "\u2AA1\u0338": "NotNestedLessLess",
        "\u2AA2": "GreaterGreater",
        "\u2AA2\u0338": "NotNestedGreaterGreater",
        "\u2AA4": "glj",
        "\u2AA5": "gla",
        "\u2AA6": "ltcc",
        "\u2AA7": "gtcc",
        "\u2AA8": "lescc",
        "\u2AA9": "gescc",
        "\u2AAA": "smt",
        "\u2AAB": "lat",
        "\u2AAC": "smte",
        "\u2AAC\uFE00": "smtes",
        "\u2AAD": "late",
        "\u2AAD\uFE00": "lates",
        "\u2AAE": "bumpE",
        "\u2AAF": "pre",
        "\u2AAF\u0338": "npre",
        "\u2AB0": "sce",
        "\u2AB0\u0338": "nsce",
        "\u2AB3": "prE",
        "\u2AB4": "scE",
        "\u2AB5": "prnE",
        "\u2AB6": "scnE",
        "\u2AB7": "prap",
        "\u2AB8": "scap",
        "\u2AB9": "prnap",
        "\u2ABA": "scnap",
        "\u2ABB": "Pr",
        "\u2ABC": "Sc",
        "\u2ABD": "subdot",
        "\u2ABE": "supdot",
        "\u2ABF": "subplus",
        "\u2AC0": "supplus",
        "\u2AC1": "submult",
        "\u2AC2": "supmult",
        "\u2AC3": "subedot",
        "\u2AC4": "supedot",
        "\u2AC5": "subE",
        "\u2AC5\u0338": "nsubE",
        "\u2AC6": "supE",
        "\u2AC6\u0338": "nsupE",
        "\u2AC7": "subsim",
        "\u2AC8": "supsim",
        "\u2ACB\uFE00": "vsubnE",
        "\u2ACB": "subnE",
        "\u2ACC\uFE00": "vsupnE",
        "\u2ACC": "supnE",
        "\u2ACF": "csub",
        "\u2AD0": "csup",
        "\u2AD1": "csube",
        "\u2AD2": "csupe",
        "\u2AD3": "subsup",
        "\u2AD4": "supsub",
        "\u2AD5": "subsub",
        "\u2AD6": "supsup",
        "\u2AD7": "suphsub",
        "\u2AD8": "supdsub",
        "\u2AD9": "forkv",
        "\u2ADA": "topfork",
        "\u2ADB": "mlcp",
        "\u2AE4": "Dashv",
        "\u2AE6": "Vdashl",
        "\u2AE7": "Barv",
        "\u2AE8": "vBar",
        "\u2AE9": "vBarv",
        "\u2AEB": "Vbar",
        "\u2AEC": "Not",
        "\u2AED": "bNot",
        "\u2AEE": "rnmid",
        "\u2AEF": "cirmid",
        "\u2AF0": "midcir",
        "\u2AF1": "topcir",
        "\u2AF2": "nhpar",
        "\u2AF3": "parsim",
        "\u2AFD": "parsl",
        "\u2AFD\u20E5": "nparsl",
        "\u266D": "flat",
        "\u266E": "natur",
        "\u266F": "sharp",
        "\xa4": "curren",
        "\xa2": "cent",
        "$": "dollar",
        "\xa3": "pound",
        "\xa5": "yen",
        "\u20AC": "euro",
        "\xb9": "sup1",
        "\xbd": "half",
        "\u2153": "frac13",
        "\xbc": "frac14",
        "\u2155": "frac15",
        "\u2159": "frac16",
        "\u215B": "frac18",
        "\xb2": "sup2",
        "\u2154": "frac23",
        "\u2156": "frac25",
        "\xb3": "sup3",
        "\xbe": "frac34",
        "\u2157": "frac35",
        "\u215C": "frac38",
        "\u2158": "frac45",
        "\u215A": "frac56",
        "\u215D": "frac58",
        "\u215E": "frac78",
        "\uD835\uDCB6": "ascr",
        "\uD835\uDD52": "aopf",
        "\uD835\uDD1E": "afr",
        "\uD835\uDD38": "Aopf",
        "\uD835\uDD04": "Afr",
        "\uD835\uDC9C": "Ascr",
        "\xaa": "ordf",
        "\xe1": "aacute",
        "\xc1": "Aacute",
        "\xe0": "agrave",
        "\xc0": "Agrave",
        "\u0103": "abreve",
        "\u0102": "Abreve",
        "\xe2": "acirc",
        "\xc2": "Acirc",
        "\xe5": "aring",
        "\xc5": "angst",
        "\xe4": "auml",
        "\xc4": "Auml",
        "\xe3": "atilde",
        "\xc3": "Atilde",
        "\u0105": "aogon",
        "\u0104": "Aogon",
        "\u0101": "amacr",
        "\u0100": "Amacr",
        "\xe6": "aelig",
        "\xc6": "AElig",
        "\uD835\uDCB7": "bscr",
        "\uD835\uDD53": "bopf",
        "\uD835\uDD1F": "bfr",
        "\uD835\uDD39": "Bopf",
        "\u212C": "Bscr",
        "\uD835\uDD05": "Bfr",
        "\uD835\uDD20": "cfr",
        "\uD835\uDCB8": "cscr",
        "\uD835\uDD54": "copf",
        "\u212D": "Cfr",
        "\uD835\uDC9E": "Cscr",
        "\u2102": "Copf",
        "\u0107": "cacute",
        "\u0106": "Cacute",
        "\u0109": "ccirc",
        "\u0108": "Ccirc",
        "\u010D": "ccaron",
        "\u010C": "Ccaron",
        "\u010B": "cdot",
        "\u010A": "Cdot",
        "\xe7": "ccedil",
        "\xc7": "Ccedil",
        "\u2105": "incare",
        "\uD835\uDD21": "dfr",
        "\u2146": "dd",
        "\uD835\uDD55": "dopf",
        "\uD835\uDCB9": "dscr",
        "\uD835\uDC9F": "Dscr",
        "\uD835\uDD07": "Dfr",
        "\u2145": "DD",
        "\uD835\uDD3B": "Dopf",
        "\u010F": "dcaron",
        "\u010E": "Dcaron",
        "\u0111": "dstrok",
        "\u0110": "Dstrok",
        "\xf0": "eth",
        "\xd0": "ETH",
        "\u2147": "ee",
        "\u212F": "escr",
        "\uD835\uDD22": "efr",
        "\uD835\uDD56": "eopf",
        "\u2130": "Escr",
        "\uD835\uDD08": "Efr",
        "\uD835\uDD3C": "Eopf",
        "\xe9": "eacute",
        "\xc9": "Eacute",
        "\xe8": "egrave",
        "\xc8": "Egrave",
        "\xea": "ecirc",
        "\xca": "Ecirc",
        "\u011B": "ecaron",
        "\u011A": "Ecaron",
        "\xeb": "euml",
        "\xcb": "Euml",
        "\u0117": "edot",
        "\u0116": "Edot",
        "\u0119": "eogon",
        "\u0118": "Eogon",
        "\u0113": "emacr",
        "\u0112": "Emacr",
        "\uD835\uDD23": "ffr",
        "\uD835\uDD57": "fopf",
        "\uD835\uDCBB": "fscr",
        "\uD835\uDD09": "Ffr",
        "\uD835\uDD3D": "Fopf",
        "\u2131": "Fscr",
        "\uFB00": "fflig",
        "\uFB03": "ffilig",
        "\uFB04": "ffllig",
        "\uFB01": "filig",
        "fj": "fjlig",
        "\uFB02": "fllig",
        "\u0192": "fnof",
        "\u210A": "gscr",
        "\uD835\uDD58": "gopf",
        "\uD835\uDD24": "gfr",
        "\uD835\uDCA2": "Gscr",
        "\uD835\uDD3E": "Gopf",
        "\uD835\uDD0A": "Gfr",
        "\u01F5": "gacute",
        "\u011F": "gbreve",
        "\u011E": "Gbreve",
        "\u011D": "gcirc",
        "\u011C": "Gcirc",
        "\u0121": "gdot",
        "\u0120": "Gdot",
        "\u0122": "Gcedil",
        "\uD835\uDD25": "hfr",
        "\u210E": "planckh",
        "\uD835\uDCBD": "hscr",
        "\uD835\uDD59": "hopf",
        "\u210B": "Hscr",
        "\u210C": "Hfr",
        "\u210D": "Hopf",
        "\u0125": "hcirc",
        "\u0124": "Hcirc",
        "\u210F": "hbar",
        "\u0127": "hstrok",
        "\u0126": "Hstrok",
        "\uD835\uDD5A": "iopf",
        "\uD835\uDD26": "ifr",
        "\uD835\uDCBE": "iscr",
        "\u2148": "ii",
        "\uD835\uDD40": "Iopf",
        "\u2110": "Iscr",
        "\u2111": "Im",
        "\xed": "iacute",
        "\xcd": "Iacute",
        "\xec": "igrave",
        "\xcc": "Igrave",
        "\xee": "icirc",
        "\xce": "Icirc",
        "\xef": "iuml",
        "\xcf": "Iuml",
        "\u0129": "itilde",
        "\u0128": "Itilde",
        "\u0130": "Idot",
        "\u012F": "iogon",
        "\u012E": "Iogon",
        "\u012B": "imacr",
        "\u012A": "Imacr",
        "\u0133": "ijlig",
        "\u0132": "IJlig",
        "\u0131": "imath",
        "\uD835\uDCBF": "jscr",
        "\uD835\uDD5B": "jopf",
        "\uD835\uDD27": "jfr",
        "\uD835\uDCA5": "Jscr",
        "\uD835\uDD0D": "Jfr",
        "\uD835\uDD41": "Jopf",
        "\u0135": "jcirc",
        "\u0134": "Jcirc",
        "\u0237": "jmath",
        "\uD835\uDD5C": "kopf",
        "\uD835\uDCC0": "kscr",
        "\uD835\uDD28": "kfr",
        "\uD835\uDCA6": "Kscr",
        "\uD835\uDD42": "Kopf",
        "\uD835\uDD0E": "Kfr",
        "\u0137": "kcedil",
        "\u0136": "Kcedil",
        "\uD835\uDD29": "lfr",
        "\uD835\uDCC1": "lscr",
        "\u2113": "ell",
        "\uD835\uDD5D": "lopf",
        "\u2112": "Lscr",
        "\uD835\uDD0F": "Lfr",
        "\uD835\uDD43": "Lopf",
        "\u013A": "lacute",
        "\u0139": "Lacute",
        "\u013E": "lcaron",
        "\u013D": "Lcaron",
        "\u013C": "lcedil",
        "\u013B": "Lcedil",
        "\u0142": "lstrok",
        "\u0141": "Lstrok",
        "\u0140": "lmidot",
        "\u013F": "Lmidot",
        "\uD835\uDD2A": "mfr",
        "\uD835\uDD5E": "mopf",
        "\uD835\uDCC2": "mscr",
        "\uD835\uDD10": "Mfr",
        "\uD835\uDD44": "Mopf",
        "\u2133": "Mscr",
        "\uD835\uDD2B": "nfr",
        "\uD835\uDD5F": "nopf",
        "\uD835\uDCC3": "nscr",
        "\u2115": "Nopf",
        "\uD835\uDCA9": "Nscr",
        "\uD835\uDD11": "Nfr",
        "\u0144": "nacute",
        "\u0143": "Nacute",
        "\u0148": "ncaron",
        "\u0147": "Ncaron",
        "\xf1": "ntilde",
        "\xd1": "Ntilde",
        "\u0146": "ncedil",
        "\u0145": "Ncedil",
        "\u2116": "numero",
        "\u014B": "eng",
        "\u014A": "ENG",
        "\uD835\uDD60": "oopf",
        "\uD835\uDD2C": "ofr",
        "\u2134": "oscr",
        "\uD835\uDCAA": "Oscr",
        "\uD835\uDD12": "Ofr",
        "\uD835\uDD46": "Oopf",
        "\xba": "ordm",
        "\xf3": "oacute",
        "\xd3": "Oacute",
        "\xf2": "ograve",
        "\xd2": "Ograve",
        "\xf4": "ocirc",
        "\xd4": "Ocirc",
        "\xf6": "ouml",
        "\xd6": "Ouml",
        "\u0151": "odblac",
        "\u0150": "Odblac",
        "\xf5": "otilde",
        "\xd5": "Otilde",
        "\xf8": "oslash",
        "\xd8": "Oslash",
        "\u014D": "omacr",
        "\u014C": "Omacr",
        "\u0153": "oelig",
        "\u0152": "OElig",
        "\uD835\uDD2D": "pfr",
        "\uD835\uDCC5": "pscr",
        "\uD835\uDD61": "popf",
        "\u2119": "Popf",
        "\uD835\uDD13": "Pfr",
        "\uD835\uDCAB": "Pscr",
        "\uD835\uDD62": "qopf",
        "\uD835\uDD2E": "qfr",
        "\uD835\uDCC6": "qscr",
        "\uD835\uDCAC": "Qscr",
        "\uD835\uDD14": "Qfr",
        "\u211A": "Qopf",
        "\u0138": "kgreen",
        "\uD835\uDD2F": "rfr",
        "\uD835\uDD63": "ropf",
        "\uD835\uDCC7": "rscr",
        "\u211B": "Rscr",
        "\u211C": "Re",
        "\u211D": "Ropf",
        "\u0155": "racute",
        "\u0154": "Racute",
        "\u0159": "rcaron",
        "\u0158": "Rcaron",
        "\u0157": "rcedil",
        "\u0156": "Rcedil",
        "\uD835\uDD64": "sopf",
        "\uD835\uDCC8": "sscr",
        "\uD835\uDD30": "sfr",
        "\uD835\uDD4A": "Sopf",
        "\uD835\uDD16": "Sfr",
        "\uD835\uDCAE": "Sscr",
        "\u24C8": "oS",
        "\u015B": "sacute",
        "\u015A": "Sacute",
        "\u015D": "scirc",
        "\u015C": "Scirc",
        "\u0161": "scaron",
        "\u0160": "Scaron",
        "\u015F": "scedil",
        "\u015E": "Scedil",
        "\xdf": "szlig",
        "\uD835\uDD31": "tfr",
        "\uD835\uDCC9": "tscr",
        "\uD835\uDD65": "topf",
        "\uD835\uDCAF": "Tscr",
        "\uD835\uDD17": "Tfr",
        "\uD835\uDD4B": "Topf",
        "\u0165": "tcaron",
        "\u0164": "Tcaron",
        "\u0163": "tcedil",
        "\u0162": "Tcedil",
        "\u2122": "trade",
        "\u0167": "tstrok",
        "\u0166": "Tstrok",
        "\uD835\uDCCA": "uscr",
        "\uD835\uDD66": "uopf",
        "\uD835\uDD32": "ufr",
        "\uD835\uDD4C": "Uopf",
        "\uD835\uDD18": "Ufr",
        "\uD835\uDCB0": "Uscr",
        "\xfa": "uacute",
        "\xda": "Uacute",
        "\xf9": "ugrave",
        "\xd9": "Ugrave",
        "\u016D": "ubreve",
        "\u016C": "Ubreve",
        "\xfb": "ucirc",
        "\xdb": "Ucirc",
        "\u016F": "uring",
        "\u016E": "Uring",
        "\xfc": "uuml",
        "\xdc": "Uuml",
        "\u0171": "udblac",
        "\u0170": "Udblac",
        "\u0169": "utilde",
        "\u0168": "Utilde",
        "\u0173": "uogon",
        "\u0172": "Uogon",
        "\u016B": "umacr",
        "\u016A": "Umacr",
        "\uD835\uDD33": "vfr",
        "\uD835\uDD67": "vopf",
        "\uD835\uDCCB": "vscr",
        "\uD835\uDD19": "Vfr",
        "\uD835\uDD4D": "Vopf",
        "\uD835\uDCB1": "Vscr",
        "\uD835\uDD68": "wopf",
        "\uD835\uDCCC": "wscr",
        "\uD835\uDD34": "wfr",
        "\uD835\uDCB2": "Wscr",
        "\uD835\uDD4E": "Wopf",
        "\uD835\uDD1A": "Wfr",
        "\u0175": "wcirc",
        "\u0174": "Wcirc",
        "\uD835\uDD35": "xfr",
        "\uD835\uDCCD": "xscr",
        "\uD835\uDD69": "xopf",
        "\uD835\uDD4F": "Xopf",
        "\uD835\uDD1B": "Xfr",
        "\uD835\uDCB3": "Xscr",
        "\uD835\uDD36": "yfr",
        "\uD835\uDCCE": "yscr",
        "\uD835\uDD6A": "yopf",
        "\uD835\uDCB4": "Yscr",
        "\uD835\uDD1C": "Yfr",
        "\uD835\uDD50": "Yopf",
        "\xfd": "yacute",
        "\xdd": "Yacute",
        "\u0177": "ycirc",
        "\u0176": "Ycirc",
        "\xff": "yuml",
        "\u0178": "Yuml",
        "\uD835\uDCCF": "zscr",
        "\uD835\uDD37": "zfr",
        "\uD835\uDD6B": "zopf",
        "\u2128": "Zfr",
        "\u2124": "Zopf",
        "\uD835\uDCB5": "Zscr",
        "\u017A": "zacute",
        "\u0179": "Zacute",
        "\u017E": "zcaron",
        "\u017D": "Zcaron",
        "\u017C": "zdot",
        "\u017B": "Zdot",
        "\u01B5": "imped",
        "\xfe": "thorn",
        "\xde": "THORN",
        "\u0149": "napos",
        "\u03B1": "alpha",
        "\u0391": "Alpha",
        "\u03B2": "beta",
        "\u0392": "Beta",
        "\u03B3": "gamma",
        "\u0393": "Gamma",
        "\u03B4": "delta",
        "\u0394": "Delta",
        "\u03B5": "epsi",
        "\u03F5": "epsiv",
        "\u0395": "Epsilon",
        "\u03DD": "gammad",
        "\u03DC": "Gammad",
        "\u03B6": "zeta",
        "\u0396": "Zeta",
        "\u03B7": "eta",
        "\u0397": "Eta",
        "\u03B8": "theta",
        "\u03D1": "thetav",
        "\u0398": "Theta",
        "\u03B9": "iota",
        "\u0399": "Iota",
        "\u03BA": "kappa",
        "\u03F0": "kappav",
        "\u039A": "Kappa",
        "\u03BB": "lambda",
        "\u039B": "Lambda",
        "\u03BC": "mu",
        "\xb5": "micro",
        "\u039C": "Mu",
        "\u03BD": "nu",
        "\u039D": "Nu",
        "\u03BE": "xi",
        "\u039E": "Xi",
        "\u03BF": "omicron",
        "\u039F": "Omicron",
        "\u03C0": "pi",
        "\u03D6": "piv",
        "\u03A0": "Pi",
        "\u03C1": "rho",
        "\u03F1": "rhov",
        "\u03A1": "Rho",
        "\u03C3": "sigma",
        "\u03A3": "Sigma",
        "\u03C2": "sigmaf",
        "\u03C4": "tau",
        "\u03A4": "Tau",
        "\u03C5": "upsi",
        "\u03A5": "Upsilon",
        "\u03D2": "Upsi",
        "\u03C6": "phi",
        "\u03D5": "phiv",
        "\u03A6": "Phi",
        "\u03C7": "chi",
        "\u03A7": "Chi",
        "\u03C8": "psi",
        "\u03A8": "Psi",
        "\u03C9": "omega",
        "\u03A9": "ohm",
        "\u0430": "acy",
        "\u0410": "Acy",
        "\u0431": "bcy",
        "\u0411": "Bcy",
        "\u0432": "vcy",
        "\u0412": "Vcy",
        "\u0433": "gcy",
        "\u0413": "Gcy",
        "\u0453": "gjcy",
        "\u0403": "GJcy",
        "\u0434": "dcy",
        "\u0414": "Dcy",
        "\u0452": "djcy",
        "\u0402": "DJcy",
        "\u0435": "iecy",
        "\u0415": "IEcy",
        "\u0451": "iocy",
        "\u0401": "IOcy",
        "\u0454": "jukcy",
        "\u0404": "Jukcy",
        "\u0436": "zhcy",
        "\u0416": "ZHcy",
        "\u0437": "zcy",
        "\u0417": "Zcy",
        "\u0455": "dscy",
        "\u0405": "DScy",
        "\u0438": "icy",
        "\u0418": "Icy",
        "\u0456": "iukcy",
        "\u0406": "Iukcy",
        "\u0457": "yicy",
        "\u0407": "YIcy",
        "\u0439": "jcy",
        "\u0419": "Jcy",
        "\u0458": "jsercy",
        "\u0408": "Jsercy",
        "\u043A": "kcy",
        "\u041A": "Kcy",
        "\u045C": "kjcy",
        "\u040C": "KJcy",
        "\u043B": "lcy",
        "\u041B": "Lcy",
        "\u0459": "ljcy",
        "\u0409": "LJcy",
        "\u043C": "mcy",
        "\u041C": "Mcy",
        "\u043D": "ncy",
        "\u041D": "Ncy",
        "\u045A": "njcy",
        "\u040A": "NJcy",
        "\u043E": "ocy",
        "\u041E": "Ocy",
        "\u043F": "pcy",
        "\u041F": "Pcy",
        "\u0440": "rcy",
        "\u0420": "Rcy",
        "\u0441": "scy",
        "\u0421": "Scy",
        "\u0442": "tcy",
        "\u0422": "Tcy",
        "\u045B": "tshcy",
        "\u040B": "TSHcy",
        "\u0443": "ucy",
        "\u0423": "Ucy",
        "\u045E": "ubrcy",
        "\u040E": "Ubrcy",
        "\u0444": "fcy",
        "\u0424": "Fcy",
        "\u0445": "khcy",
        "\u0425": "KHcy",
        "\u0446": "tscy",
        "\u0426": "TScy",
        "\u0447": "chcy",
        "\u0427": "CHcy",
        "\u045F": "dzcy",
        "\u040F": "DZcy",
        "\u0448": "shcy",
        "\u0428": "SHcy",
        "\u0449": "shchcy",
        "\u0429": "SHCHcy",
        "\u044A": "hardcy",
        "\u042A": "HARDcy",
        "\u044B": "ycy",
        "\u042B": "Ycy",
        "\u044C": "softcy",
        "\u042C": "SOFTcy",
        "\u044D": "ecy",
        "\u042D": "Ecy",
        "\u044E": "yucy",
        "\u042E": "YUcy",
        "\u044F": "yacy",
        "\u042F": "YAcy",
        "\u2135": "aleph",
        "\u2136": "beth",
        "\u2137": "gimel",
        "\u2138": "daleth"
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': "&quot;",
        "&": "&amp;",
        "'": "&#x27;",
        "<": "&lt;",
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        ">": "&gt;",
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        "`": "&#x60;"
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "abreve": "\u0103",
        "Abreve": "\u0102",
        "ac": "\u223E",
        "acd": "\u223F",
        "acE": "\u223E\u0333",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "acy": "\u0430",
        "Acy": "\u0410",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "af": "\u2061",
        "afr": "\uD835\uDD1E",
        "Afr": "\uD835\uDD04",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "alefsym": "\u2135",
        "aleph": "\u2135",
        "alpha": "\u03B1",
        "Alpha": "\u0391",
        "amacr": "\u0101",
        "Amacr": "\u0100",
        "amalg": "\u2A3F",
        "amp": "&",
        "AMP": "&",
        "and": "\u2227",
        "And": "\u2A53",
        "andand": "\u2A55",
        "andd": "\u2A5C",
        "andslope": "\u2A58",
        "andv": "\u2A5A",
        "ang": "\u2220",
        "ange": "\u29A4",
        "angle": "\u2220",
        "angmsd": "\u2221",
        "angmsdaa": "\u29A8",
        "angmsdab": "\u29A9",
        "angmsdac": "\u29AA",
        "angmsdad": "\u29AB",
        "angmsdae": "\u29AC",
        "angmsdaf": "\u29AD",
        "angmsdag": "\u29AE",
        "angmsdah": "\u29AF",
        "angrt": "\u221F",
        "angrtvb": "\u22BE",
        "angrtvbd": "\u299D",
        "angsph": "\u2222",
        "angst": "\xc5",
        "angzarr": "\u237C",
        "aogon": "\u0105",
        "Aogon": "\u0104",
        "aopf": "\uD835\uDD52",
        "Aopf": "\uD835\uDD38",
        "ap": "\u2248",
        "apacir": "\u2A6F",
        "ape": "\u224A",
        "apE": "\u2A70",
        "apid": "\u224B",
        "apos": "'",
        "ApplyFunction": "\u2061",
        "approx": "\u2248",
        "approxeq": "\u224A",
        "aring": "\xe5",
        "Aring": "\xc5",
        "ascr": "\uD835\uDCB6",
        "Ascr": "\uD835\uDC9C",
        "Assign": "\u2254",
        "ast": "*",
        "asymp": "\u2248",
        "asympeq": "\u224D",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "awconint": "\u2233",
        "awint": "\u2A11",
        "backcong": "\u224C",
        "backepsilon": "\u03F6",
        "backprime": "\u2035",
        "backsim": "\u223D",
        "backsimeq": "\u22CD",
        "Backslash": "\u2216",
        "Barv": "\u2AE7",
        "barvee": "\u22BD",
        "barwed": "\u2305",
        "Barwed": "\u2306",
        "barwedge": "\u2305",
        "bbrk": "\u23B5",
        "bbrktbrk": "\u23B6",
        "bcong": "\u224C",
        "bcy": "\u0431",
        "Bcy": "\u0411",
        "bdquo": "\u201E",
        "becaus": "\u2235",
        "because": "\u2235",
        "Because": "\u2235",
        "bemptyv": "\u29B0",
        "bepsi": "\u03F6",
        "bernou": "\u212C",
        "Bernoullis": "\u212C",
        "beta": "\u03B2",
        "Beta": "\u0392",
        "beth": "\u2136",
        "between": "\u226C",
        "bfr": "\uD835\uDD1F",
        "Bfr": "\uD835\uDD05",
        "bigcap": "\u22C2",
        "bigcirc": "\u25EF",
        "bigcup": "\u22C3",
        "bigodot": "\u2A00",
        "bigoplus": "\u2A01",
        "bigotimes": "\u2A02",
        "bigsqcup": "\u2A06",
        "bigstar": "\u2605",
        "bigtriangledown": "\u25BD",
        "bigtriangleup": "\u25B3",
        "biguplus": "\u2A04",
        "bigvee": "\u22C1",
        "bigwedge": "\u22C0",
        "bkarow": "\u290D",
        "blacklozenge": "\u29EB",
        "blacksquare": "\u25AA",
        "blacktriangle": "\u25B4",
        "blacktriangledown": "\u25BE",
        "blacktriangleleft": "\u25C2",
        "blacktriangleright": "\u25B8",
        "blank": "\u2423",
        "blk12": "\u2592",
        "blk14": "\u2591",
        "blk34": "\u2593",
        "block": "\u2588",
        "bne": "=\u20E5",
        "bnequiv": "\u2261\u20E5",
        "bnot": "\u2310",
        "bNot": "\u2AED",
        "bopf": "\uD835\uDD53",
        "Bopf": "\uD835\uDD39",
        "bot": "\u22A5",
        "bottom": "\u22A5",
        "bowtie": "\u22C8",
        "boxbox": "\u29C9",
        "boxdl": "\u2510",
        "boxdL": "\u2555",
        "boxDl": "\u2556",
        "boxDL": "\u2557",
        "boxdr": "\u250C",
        "boxdR": "\u2552",
        "boxDr": "\u2553",
        "boxDR": "\u2554",
        "boxh": "\u2500",
        "boxH": "\u2550",
        "boxhd": "\u252C",
        "boxhD": "\u2565",
        "boxHd": "\u2564",
        "boxHD": "\u2566",
        "boxhu": "\u2534",
        "boxhU": "\u2568",
        "boxHu": "\u2567",
        "boxHU": "\u2569",
        "boxminus": "\u229F",
        "boxplus": "\u229E",
        "boxtimes": "\u22A0",
        "boxul": "\u2518",
        "boxuL": "\u255B",
        "boxUl": "\u255C",
        "boxUL": "\u255D",
        "boxur": "\u2514",
        "boxuR": "\u2558",
        "boxUr": "\u2559",
        "boxUR": "\u255A",
        "boxv": "\u2502",
        "boxV": "\u2551",
        "boxvh": "\u253C",
        "boxvH": "\u256A",
        "boxVh": "\u256B",
        "boxVH": "\u256C",
        "boxvl": "\u2524",
        "boxvL": "\u2561",
        "boxVl": "\u2562",
        "boxVL": "\u2563",
        "boxvr": "\u251C",
        "boxvR": "\u255E",
        "boxVr": "\u255F",
        "boxVR": "\u2560",
        "bprime": "\u2035",
        "breve": "\u02D8",
        "Breve": "\u02D8",
        "brvbar": "\xa6",
        "bscr": "\uD835\uDCB7",
        "Bscr": "\u212C",
        "bsemi": "\u204F",
        "bsim": "\u223D",
        "bsime": "\u22CD",
        "bsol": "\\",
        "bsolb": "\u29C5",
        "bsolhsub": "\u27C8",
        "bull": "\u2022",
        "bullet": "\u2022",
        "bump": "\u224E",
        "bumpe": "\u224F",
        "bumpE": "\u2AAE",
        "bumpeq": "\u224F",
        "Bumpeq": "\u224E",
        "cacute": "\u0107",
        "Cacute": "\u0106",
        "cap": "\u2229",
        "Cap": "\u22D2",
        "capand": "\u2A44",
        "capbrcup": "\u2A49",
        "capcap": "\u2A4B",
        "capcup": "\u2A47",
        "capdot": "\u2A40",
        "CapitalDifferentialD": "\u2145",
        "caps": "\u2229\uFE00",
        "caret": "\u2041",
        "caron": "\u02C7",
        "Cayleys": "\u212D",
        "ccaps": "\u2A4D",
        "ccaron": "\u010D",
        "Ccaron": "\u010C",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "ccirc": "\u0109",
        "Ccirc": "\u0108",
        "Cconint": "\u2230",
        "ccups": "\u2A4C",
        "ccupssm": "\u2A50",
        "cdot": "\u010B",
        "Cdot": "\u010A",
        "cedil": "\xb8",
        "Cedilla": "\xb8",
        "cemptyv": "\u29B2",
        "cent": "\xa2",
        "centerdot": "\xb7",
        "CenterDot": "\xb7",
        "cfr": "\uD835\uDD20",
        "Cfr": "\u212D",
        "chcy": "\u0447",
        "CHcy": "\u0427",
        "check": "\u2713",
        "checkmark": "\u2713",
        "chi": "\u03C7",
        "Chi": "\u03A7",
        "cir": "\u25CB",
        "circ": "\u02C6",
        "circeq": "\u2257",
        "circlearrowleft": "\u21BA",
        "circlearrowright": "\u21BB",
        "circledast": "\u229B",
        "circledcirc": "\u229A",
        "circleddash": "\u229D",
        "CircleDot": "\u2299",
        "circledR": "\xae",
        "circledS": "\u24C8",
        "CircleMinus": "\u2296",
        "CirclePlus": "\u2295",
        "CircleTimes": "\u2297",
        "cire": "\u2257",
        "cirE": "\u29C3",
        "cirfnint": "\u2A10",
        "cirmid": "\u2AEF",
        "cirscir": "\u29C2",
        "ClockwiseContourIntegral": "\u2232",
        "CloseCurlyDoubleQuote": "\u201D",
        "CloseCurlyQuote": "\u2019",
        "clubs": "\u2663",
        "clubsuit": "\u2663",
        "colon": ":",
        "Colon": "\u2237",
        "colone": "\u2254",
        "Colone": "\u2A74",
        "coloneq": "\u2254",
        "comma": ",",
        "commat": "@",
        "comp": "\u2201",
        "compfn": "\u2218",
        "complement": "\u2201",
        "complexes": "\u2102",
        "cong": "\u2245",
        "congdot": "\u2A6D",
        "Congruent": "\u2261",
        "conint": "\u222E",
        "Conint": "\u222F",
        "ContourIntegral": "\u222E",
        "copf": "\uD835\uDD54",
        "Copf": "\u2102",
        "coprod": "\u2210",
        "Coproduct": "\u2210",
        "copy": "\xa9",
        "COPY": "\xa9",
        "copysr": "\u2117",
        "CounterClockwiseContourIntegral": "\u2233",
        "crarr": "\u21B5",
        "cross": "\u2717",
        "Cross": "\u2A2F",
        "cscr": "\uD835\uDCB8",
        "Cscr": "\uD835\uDC9E",
        "csub": "\u2ACF",
        "csube": "\u2AD1",
        "csup": "\u2AD0",
        "csupe": "\u2AD2",
        "ctdot": "\u22EF",
        "cudarrl": "\u2938",
        "cudarrr": "\u2935",
        "cuepr": "\u22DE",
        "cuesc": "\u22DF",
        "cularr": "\u21B6",
        "cularrp": "\u293D",
        "cup": "\u222A",
        "Cup": "\u22D3",
        "cupbrcap": "\u2A48",
        "cupcap": "\u2A46",
        "CupCap": "\u224D",
        "cupcup": "\u2A4A",
        "cupdot": "\u228D",
        "cupor": "\u2A45",
        "cups": "\u222A\uFE00",
        "curarr": "\u21B7",
        "curarrm": "\u293C",
        "curlyeqprec": "\u22DE",
        "curlyeqsucc": "\u22DF",
        "curlyvee": "\u22CE",
        "curlywedge": "\u22CF",
        "curren": "\xa4",
        "curvearrowleft": "\u21B6",
        "curvearrowright": "\u21B7",
        "cuvee": "\u22CE",
        "cuwed": "\u22CF",
        "cwconint": "\u2232",
        "cwint": "\u2231",
        "cylcty": "\u232D",
        "dagger": "\u2020",
        "Dagger": "\u2021",
        "daleth": "\u2138",
        "darr": "\u2193",
        "dArr": "\u21D3",
        "Darr": "\u21A1",
        "dash": "\u2010",
        "dashv": "\u22A3",
        "Dashv": "\u2AE4",
        "dbkarow": "\u290F",
        "dblac": "\u02DD",
        "dcaron": "\u010F",
        "Dcaron": "\u010E",
        "dcy": "\u0434",
        "Dcy": "\u0414",
        "dd": "\u2146",
        "DD": "\u2145",
        "ddagger": "\u2021",
        "ddarr": "\u21CA",
        "DDotrahd": "\u2911",
        "ddotseq": "\u2A77",
        "deg": "\xb0",
        "Del": "\u2207",
        "delta": "\u03B4",
        "Delta": "\u0394",
        "demptyv": "\u29B1",
        "dfisht": "\u297F",
        "dfr": "\uD835\uDD21",
        "Dfr": "\uD835\uDD07",
        "dHar": "\u2965",
        "dharl": "\u21C3",
        "dharr": "\u21C2",
        "DiacriticalAcute": "\xb4",
        "DiacriticalDot": "\u02D9",
        "DiacriticalDoubleAcute": "\u02DD",
        "DiacriticalGrave": "`",
        "DiacriticalTilde": "\u02DC",
        "diam": "\u22C4",
        "diamond": "\u22C4",
        "Diamond": "\u22C4",
        "diamondsuit": "\u2666",
        "diams": "\u2666",
        "die": "\xa8",
        "DifferentialD": "\u2146",
        "digamma": "\u03DD",
        "disin": "\u22F2",
        "div": "\xf7",
        "divide": "\xf7",
        "divideontimes": "\u22C7",
        "divonx": "\u22C7",
        "djcy": "\u0452",
        "DJcy": "\u0402",
        "dlcorn": "\u231E",
        "dlcrop": "\u230D",
        "dollar": "$",
        "dopf": "\uD835\uDD55",
        "Dopf": "\uD835\uDD3B",
        "dot": "\u02D9",
        "Dot": "\xa8",
        "DotDot": "\u20DC",
        "doteq": "\u2250",
        "doteqdot": "\u2251",
        "DotEqual": "\u2250",
        "dotminus": "\u2238",
        "dotplus": "\u2214",
        "dotsquare": "\u22A1",
        "doublebarwedge": "\u2306",
        "DoubleContourIntegral": "\u222F",
        "DoubleDot": "\xa8",
        "DoubleDownArrow": "\u21D3",
        "DoubleLeftArrow": "\u21D0",
        "DoubleLeftRightArrow": "\u21D4",
        "DoubleLeftTee": "\u2AE4",
        "DoubleLongLeftArrow": "\u27F8",
        "DoubleLongLeftRightArrow": "\u27FA",
        "DoubleLongRightArrow": "\u27F9",
        "DoubleRightArrow": "\u21D2",
        "DoubleRightTee": "\u22A8",
        "DoubleUpArrow": "\u21D1",
        "DoubleUpDownArrow": "\u21D5",
        "DoubleVerticalBar": "\u2225",
        "downarrow": "\u2193",
        "Downarrow": "\u21D3",
        "DownArrow": "\u2193",
        "DownArrowBar": "\u2913",
        "DownArrowUpArrow": "\u21F5",
        "DownBreve": "\u0311",
        "downdownarrows": "\u21CA",
        "downharpoonleft": "\u21C3",
        "downharpoonright": "\u21C2",
        "DownLeftRightVector": "\u2950",
        "DownLeftTeeVector": "\u295E",
        "DownLeftVector": "\u21BD",
        "DownLeftVectorBar": "\u2956",
        "DownRightTeeVector": "\u295F",
        "DownRightVector": "\u21C1",
        "DownRightVectorBar": "\u2957",
        "DownTee": "\u22A4",
        "DownTeeArrow": "\u21A7",
        "drbkarow": "\u2910",
        "drcorn": "\u231F",
        "drcrop": "\u230C",
        "dscr": "\uD835\uDCB9",
        "Dscr": "\uD835\uDC9F",
        "dscy": "\u0455",
        "DScy": "\u0405",
        "dsol": "\u29F6",
        "dstrok": "\u0111",
        "Dstrok": "\u0110",
        "dtdot": "\u22F1",
        "dtri": "\u25BF",
        "dtrif": "\u25BE",
        "duarr": "\u21F5",
        "duhar": "\u296F",
        "dwangle": "\u29A6",
        "dzcy": "\u045F",
        "DZcy": "\u040F",
        "dzigrarr": "\u27FF",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "easter": "\u2A6E",
        "ecaron": "\u011B",
        "Ecaron": "\u011A",
        "ecir": "\u2256",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "ecolon": "\u2255",
        "ecy": "\u044D",
        "Ecy": "\u042D",
        "eDDot": "\u2A77",
        "edot": "\u0117",
        "eDot": "\u2251",
        "Edot": "\u0116",
        "ee": "\u2147",
        "efDot": "\u2252",
        "efr": "\uD835\uDD22",
        "Efr": "\uD835\uDD08",
        "eg": "\u2A9A",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "egs": "\u2A96",
        "egsdot": "\u2A98",
        "el": "\u2A99",
        "Element": "\u2208",
        "elinters": "\u23E7",
        "ell": "\u2113",
        "els": "\u2A95",
        "elsdot": "\u2A97",
        "emacr": "\u0113",
        "Emacr": "\u0112",
        "empty": "\u2205",
        "emptyset": "\u2205",
        "EmptySmallSquare": "\u25FB",
        "emptyv": "\u2205",
        "EmptyVerySmallSquare": "\u25AB",
        "emsp": "\u2003",
        "emsp13": "\u2004",
        "emsp14": "\u2005",
        "eng": "\u014B",
        "ENG": "\u014A",
        "ensp": "\u2002",
        "eogon": "\u0119",
        "Eogon": "\u0118",
        "eopf": "\uD835\uDD56",
        "Eopf": "\uD835\uDD3C",
        "epar": "\u22D5",
        "eparsl": "\u29E3",
        "eplus": "\u2A71",
        "epsi": "\u03B5",
        "epsilon": "\u03B5",
        "Epsilon": "\u0395",
        "epsiv": "\u03F5",
        "eqcirc": "\u2256",
        "eqcolon": "\u2255",
        "eqsim": "\u2242",
        "eqslantgtr": "\u2A96",
        "eqslantless": "\u2A95",
        "Equal": "\u2A75",
        "equals": "=",
        "EqualTilde": "\u2242",
        "equest": "\u225F",
        "Equilibrium": "\u21CC",
        "equiv": "\u2261",
        "equivDD": "\u2A78",
        "eqvparsl": "\u29E5",
        "erarr": "\u2971",
        "erDot": "\u2253",
        "escr": "\u212F",
        "Escr": "\u2130",
        "esdot": "\u2250",
        "esim": "\u2242",
        "Esim": "\u2A73",
        "eta": "\u03B7",
        "Eta": "\u0397",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "euro": "\u20AC",
        "excl": "!",
        "exist": "\u2203",
        "Exists": "\u2203",
        "expectation": "\u2130",
        "exponentiale": "\u2147",
        "ExponentialE": "\u2147",
        "fallingdotseq": "\u2252",
        "fcy": "\u0444",
        "Fcy": "\u0424",
        "female": "\u2640",
        "ffilig": "\uFB03",
        "fflig": "\uFB00",
        "ffllig": "\uFB04",
        "ffr": "\uD835\uDD23",
        "Ffr": "\uD835\uDD09",
        "filig": "\uFB01",
        "FilledSmallSquare": "\u25FC",
        "FilledVerySmallSquare": "\u25AA",
        "fjlig": "fj",
        "flat": "\u266D",
        "fllig": "\uFB02",
        "fltns": "\u25B1",
        "fnof": "\u0192",
        "fopf": "\uD835\uDD57",
        "Fopf": "\uD835\uDD3D",
        "forall": "\u2200",
        "ForAll": "\u2200",
        "fork": "\u22D4",
        "forkv": "\u2AD9",
        "Fouriertrf": "\u2131",
        "fpartint": "\u2A0D",
        "frac12": "\xbd",
        "frac13": "\u2153",
        "frac14": "\xbc",
        "frac15": "\u2155",
        "frac16": "\u2159",
        "frac18": "\u215B",
        "frac23": "\u2154",
        "frac25": "\u2156",
        "frac34": "\xbe",
        "frac35": "\u2157",
        "frac38": "\u215C",
        "frac45": "\u2158",
        "frac56": "\u215A",
        "frac58": "\u215D",
        "frac78": "\u215E",
        "frasl": "\u2044",
        "frown": "\u2322",
        "fscr": "\uD835\uDCBB",
        "Fscr": "\u2131",
        "gacute": "\u01F5",
        "gamma": "\u03B3",
        "Gamma": "\u0393",
        "gammad": "\u03DD",
        "Gammad": "\u03DC",
        "gap": "\u2A86",
        "gbreve": "\u011F",
        "Gbreve": "\u011E",
        "Gcedil": "\u0122",
        "gcirc": "\u011D",
        "Gcirc": "\u011C",
        "gcy": "\u0433",
        "Gcy": "\u0413",
        "gdot": "\u0121",
        "Gdot": "\u0120",
        "ge": "\u2265",
        "gE": "\u2267",
        "gel": "\u22DB",
        "gEl": "\u2A8C",
        "geq": "\u2265",
        "geqq": "\u2267",
        "geqslant": "\u2A7E",
        "ges": "\u2A7E",
        "gescc": "\u2AA9",
        "gesdot": "\u2A80",
        "gesdoto": "\u2A82",
        "gesdotol": "\u2A84",
        "gesl": "\u22DB\uFE00",
        "gesles": "\u2A94",
        "gfr": "\uD835\uDD24",
        "Gfr": "\uD835\uDD0A",
        "gg": "\u226B",
        "Gg": "\u22D9",
        "ggg": "\u22D9",
        "gimel": "\u2137",
        "gjcy": "\u0453",
        "GJcy": "\u0403",
        "gl": "\u2277",
        "gla": "\u2AA5",
        "glE": "\u2A92",
        "glj": "\u2AA4",
        "gnap": "\u2A8A",
        "gnapprox": "\u2A8A",
        "gne": "\u2A88",
        "gnE": "\u2269",
        "gneq": "\u2A88",
        "gneqq": "\u2269",
        "gnsim": "\u22E7",
        "gopf": "\uD835\uDD58",
        "Gopf": "\uD835\uDD3E",
        "grave": "`",
        "GreaterEqual": "\u2265",
        "GreaterEqualLess": "\u22DB",
        "GreaterFullEqual": "\u2267",
        "GreaterGreater": "\u2AA2",
        "GreaterLess": "\u2277",
        "GreaterSlantEqual": "\u2A7E",
        "GreaterTilde": "\u2273",
        "gscr": "\u210A",
        "Gscr": "\uD835\uDCA2",
        "gsim": "\u2273",
        "gsime": "\u2A8E",
        "gsiml": "\u2A90",
        "gt": ">",
        "Gt": "\u226B",
        "GT": ">",
        "gtcc": "\u2AA7",
        "gtcir": "\u2A7A",
        "gtdot": "\u22D7",
        "gtlPar": "\u2995",
        "gtquest": "\u2A7C",
        "gtrapprox": "\u2A86",
        "gtrarr": "\u2978",
        "gtrdot": "\u22D7",
        "gtreqless": "\u22DB",
        "gtreqqless": "\u2A8C",
        "gtrless": "\u2277",
        "gtrsim": "\u2273",
        "gvertneqq": "\u2269\uFE00",
        "gvnE": "\u2269\uFE00",
        "Hacek": "\u02C7",
        "hairsp": "\u200A",
        "half": "\xbd",
        "hamilt": "\u210B",
        "hardcy": "\u044A",
        "HARDcy": "\u042A",
        "harr": "\u2194",
        "hArr": "\u21D4",
        "harrcir": "\u2948",
        "harrw": "\u21AD",
        "Hat": "^",
        "hbar": "\u210F",
        "hcirc": "\u0125",
        "Hcirc": "\u0124",
        "hearts": "\u2665",
        "heartsuit": "\u2665",
        "hellip": "\u2026",
        "hercon": "\u22B9",
        "hfr": "\uD835\uDD25",
        "Hfr": "\u210C",
        "HilbertSpace": "\u210B",
        "hksearow": "\u2925",
        "hkswarow": "\u2926",
        "hoarr": "\u21FF",
        "homtht": "\u223B",
        "hookleftarrow": "\u21A9",
        "hookrightarrow": "\u21AA",
        "hopf": "\uD835\uDD59",
        "Hopf": "\u210D",
        "horbar": "\u2015",
        "HorizontalLine": "\u2500",
        "hscr": "\uD835\uDCBD",
        "Hscr": "\u210B",
        "hslash": "\u210F",
        "hstrok": "\u0127",
        "Hstrok": "\u0126",
        "HumpDownHump": "\u224E",
        "HumpEqual": "\u224F",
        "hybull": "\u2043",
        "hyphen": "\u2010",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "ic": "\u2063",
        "icirc": "\xee",
        "Icirc": "\xce",
        "icy": "\u0438",
        "Icy": "\u0418",
        "Idot": "\u0130",
        "iecy": "\u0435",
        "IEcy": "\u0415",
        "iexcl": "\xa1",
        "iff": "\u21D4",
        "ifr": "\uD835\uDD26",
        "Ifr": "\u2111",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "ii": "\u2148",
        "iiiint": "\u2A0C",
        "iiint": "\u222D",
        "iinfin": "\u29DC",
        "iiota": "\u2129",
        "ijlig": "\u0133",
        "IJlig": "\u0132",
        "Im": "\u2111",
        "imacr": "\u012B",
        "Imacr": "\u012A",
        "image": "\u2111",
        "ImaginaryI": "\u2148",
        "imagline": "\u2110",
        "imagpart": "\u2111",
        "imath": "\u0131",
        "imof": "\u22B7",
        "imped": "\u01B5",
        "Implies": "\u21D2",
        "in": "\u2208",
        "incare": "\u2105",
        "infin": "\u221E",
        "infintie": "\u29DD",
        "inodot": "\u0131",
        "int": "\u222B",
        "Int": "\u222C",
        "intcal": "\u22BA",
        "integers": "\u2124",
        "Integral": "\u222B",
        "intercal": "\u22BA",
        "Intersection": "\u22C2",
        "intlarhk": "\u2A17",
        "intprod": "\u2A3C",
        "InvisibleComma": "\u2063",
        "InvisibleTimes": "\u2062",
        "iocy": "\u0451",
        "IOcy": "\u0401",
        "iogon": "\u012F",
        "Iogon": "\u012E",
        "iopf": "\uD835\uDD5A",
        "Iopf": "\uD835\uDD40",
        "iota": "\u03B9",
        "Iota": "\u0399",
        "iprod": "\u2A3C",
        "iquest": "\xbf",
        "iscr": "\uD835\uDCBE",
        "Iscr": "\u2110",
        "isin": "\u2208",
        "isindot": "\u22F5",
        "isinE": "\u22F9",
        "isins": "\u22F4",
        "isinsv": "\u22F3",
        "isinv": "\u2208",
        "it": "\u2062",
        "itilde": "\u0129",
        "Itilde": "\u0128",
        "iukcy": "\u0456",
        "Iukcy": "\u0406",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "jcirc": "\u0135",
        "Jcirc": "\u0134",
        "jcy": "\u0439",
        "Jcy": "\u0419",
        "jfr": "\uD835\uDD27",
        "Jfr": "\uD835\uDD0D",
        "jmath": "\u0237",
        "jopf": "\uD835\uDD5B",
        "Jopf": "\uD835\uDD41",
        "jscr": "\uD835\uDCBF",
        "Jscr": "\uD835\uDCA5",
        "jsercy": "\u0458",
        "Jsercy": "\u0408",
        "jukcy": "\u0454",
        "Jukcy": "\u0404",
        "kappa": "\u03BA",
        "Kappa": "\u039A",
        "kappav": "\u03F0",
        "kcedil": "\u0137",
        "Kcedil": "\u0136",
        "kcy": "\u043A",
        "Kcy": "\u041A",
        "kfr": "\uD835\uDD28",
        "Kfr": "\uD835\uDD0E",
        "kgreen": "\u0138",
        "khcy": "\u0445",
        "KHcy": "\u0425",
        "kjcy": "\u045C",
        "KJcy": "\u040C",
        "kopf": "\uD835\uDD5C",
        "Kopf": "\uD835\uDD42",
        "kscr": "\uD835\uDCC0",
        "Kscr": "\uD835\uDCA6",
        "lAarr": "\u21DA",
        "lacute": "\u013A",
        "Lacute": "\u0139",
        "laemptyv": "\u29B4",
        "lagran": "\u2112",
        "lambda": "\u03BB",
        "Lambda": "\u039B",
        "lang": "\u27E8",
        "Lang": "\u27EA",
        "langd": "\u2991",
        "langle": "\u27E8",
        "lap": "\u2A85",
        "Laplacetrf": "\u2112",
        "laquo": "\xab",
        "larr": "\u2190",
        "lArr": "\u21D0",
        "Larr": "\u219E",
        "larrb": "\u21E4",
        "larrbfs": "\u291F",
        "larrfs": "\u291D",
        "larrhk": "\u21A9",
        "larrlp": "\u21AB",
        "larrpl": "\u2939",
        "larrsim": "\u2973",
        "larrtl": "\u21A2",
        "lat": "\u2AAB",
        "latail": "\u2919",
        "lAtail": "\u291B",
        "late": "\u2AAD",
        "lates": "\u2AAD\uFE00",
        "lbarr": "\u290C",
        "lBarr": "\u290E",
        "lbbrk": "\u2772",
        "lbrace": "{",
        "lbrack": "[",
        "lbrke": "\u298B",
        "lbrksld": "\u298F",
        "lbrkslu": "\u298D",
        "lcaron": "\u013E",
        "Lcaron": "\u013D",
        "lcedil": "\u013C",
        "Lcedil": "\u013B",
        "lceil": "\u2308",
        "lcub": "{",
        "lcy": "\u043B",
        "Lcy": "\u041B",
        "ldca": "\u2936",
        "ldquo": "\u201C",
        "ldquor": "\u201E",
        "ldrdhar": "\u2967",
        "ldrushar": "\u294B",
        "ldsh": "\u21B2",
        "le": "\u2264",
        "lE": "\u2266",
        "LeftAngleBracket": "\u27E8",
        "leftarrow": "\u2190",
        "Leftarrow": "\u21D0",
        "LeftArrow": "\u2190",
        "LeftArrowBar": "\u21E4",
        "LeftArrowRightArrow": "\u21C6",
        "leftarrowtail": "\u21A2",
        "LeftCeiling": "\u2308",
        "LeftDoubleBracket": "\u27E6",
        "LeftDownTeeVector": "\u2961",
        "LeftDownVector": "\u21C3",
        "LeftDownVectorBar": "\u2959",
        "LeftFloor": "\u230A",
        "leftharpoondown": "\u21BD",
        "leftharpoonup": "\u21BC",
        "leftleftarrows": "\u21C7",
        "leftrightarrow": "\u2194",
        "Leftrightarrow": "\u21D4",
        "LeftRightArrow": "\u2194",
        "leftrightarrows": "\u21C6",
        "leftrightharpoons": "\u21CB",
        "leftrightsquigarrow": "\u21AD",
        "LeftRightVector": "\u294E",
        "LeftTee": "\u22A3",
        "LeftTeeArrow": "\u21A4",
        "LeftTeeVector": "\u295A",
        "leftthreetimes": "\u22CB",
        "LeftTriangle": "\u22B2",
        "LeftTriangleBar": "\u29CF",
        "LeftTriangleEqual": "\u22B4",
        "LeftUpDownVector": "\u2951",
        "LeftUpTeeVector": "\u2960",
        "LeftUpVector": "\u21BF",
        "LeftUpVectorBar": "\u2958",
        "LeftVector": "\u21BC",
        "LeftVectorBar": "\u2952",
        "leg": "\u22DA",
        "lEg": "\u2A8B",
        "leq": "\u2264",
        "leqq": "\u2266",
        "leqslant": "\u2A7D",
        "les": "\u2A7D",
        "lescc": "\u2AA8",
        "lesdot": "\u2A7F",
        "lesdoto": "\u2A81",
        "lesdotor": "\u2A83",
        "lesg": "\u22DA\uFE00",
        "lesges": "\u2A93",
        "lessapprox": "\u2A85",
        "lessdot": "\u22D6",
        "lesseqgtr": "\u22DA",
        "lesseqqgtr": "\u2A8B",
        "LessEqualGreater": "\u22DA",
        "LessFullEqual": "\u2266",
        "LessGreater": "\u2276",
        "lessgtr": "\u2276",
        "LessLess": "\u2AA1",
        "lesssim": "\u2272",
        "LessSlantEqual": "\u2A7D",
        "LessTilde": "\u2272",
        "lfisht": "\u297C",
        "lfloor": "\u230A",
        "lfr": "\uD835\uDD29",
        "Lfr": "\uD835\uDD0F",
        "lg": "\u2276",
        "lgE": "\u2A91",
        "lHar": "\u2962",
        "lhard": "\u21BD",
        "lharu": "\u21BC",
        "lharul": "\u296A",
        "lhblk": "\u2584",
        "ljcy": "\u0459",
        "LJcy": "\u0409",
        "ll": "\u226A",
        "Ll": "\u22D8",
        "llarr": "\u21C7",
        "llcorner": "\u231E",
        "Lleftarrow": "\u21DA",
        "llhard": "\u296B",
        "lltri": "\u25FA",
        "lmidot": "\u0140",
        "Lmidot": "\u013F",
        "lmoust": "\u23B0",
        "lmoustache": "\u23B0",
        "lnap": "\u2A89",
        "lnapprox": "\u2A89",
        "lne": "\u2A87",
        "lnE": "\u2268",
        "lneq": "\u2A87",
        "lneqq": "\u2268",
        "lnsim": "\u22E6",
        "loang": "\u27EC",
        "loarr": "\u21FD",
        "lobrk": "\u27E6",
        "longleftarrow": "\u27F5",
        "Longleftarrow": "\u27F8",
        "LongLeftArrow": "\u27F5",
        "longleftrightarrow": "\u27F7",
        "Longleftrightarrow": "\u27FA",
        "LongLeftRightArrow": "\u27F7",
        "longmapsto": "\u27FC",
        "longrightarrow": "\u27F6",
        "Longrightarrow": "\u27F9",
        "LongRightArrow": "\u27F6",
        "looparrowleft": "\u21AB",
        "looparrowright": "\u21AC",
        "lopar": "\u2985",
        "lopf": "\uD835\uDD5D",
        "Lopf": "\uD835\uDD43",
        "loplus": "\u2A2D",
        "lotimes": "\u2A34",
        "lowast": "\u2217",
        "lowbar": "_",
        "LowerLeftArrow": "\u2199",
        "LowerRightArrow": "\u2198",
        "loz": "\u25CA",
        "lozenge": "\u25CA",
        "lozf": "\u29EB",
        "lpar": "(",
        "lparlt": "\u2993",
        "lrarr": "\u21C6",
        "lrcorner": "\u231F",
        "lrhar": "\u21CB",
        "lrhard": "\u296D",
        "lrm": "\u200E",
        "lrtri": "\u22BF",
        "lsaquo": "\u2039",
        "lscr": "\uD835\uDCC1",
        "Lscr": "\u2112",
        "lsh": "\u21B0",
        "Lsh": "\u21B0",
        "lsim": "\u2272",
        "lsime": "\u2A8D",
        "lsimg": "\u2A8F",
        "lsqb": "[",
        "lsquo": "\u2018",
        "lsquor": "\u201A",
        "lstrok": "\u0142",
        "Lstrok": "\u0141",
        "lt": "<",
        "Lt": "\u226A",
        "LT": "<",
        "ltcc": "\u2AA6",
        "ltcir": "\u2A79",
        "ltdot": "\u22D6",
        "lthree": "\u22CB",
        "ltimes": "\u22C9",
        "ltlarr": "\u2976",
        "ltquest": "\u2A7B",
        "ltri": "\u25C3",
        "ltrie": "\u22B4",
        "ltrif": "\u25C2",
        "ltrPar": "\u2996",
        "lurdshar": "\u294A",
        "luruhar": "\u2966",
        "lvertneqq": "\u2268\uFE00",
        "lvnE": "\u2268\uFE00",
        "macr": "\xaf",
        "male": "\u2642",
        "malt": "\u2720",
        "maltese": "\u2720",
        "map": "\u21A6",
        "Map": "\u2905",
        "mapsto": "\u21A6",
        "mapstodown": "\u21A7",
        "mapstoleft": "\u21A4",
        "mapstoup": "\u21A5",
        "marker": "\u25AE",
        "mcomma": "\u2A29",
        "mcy": "\u043C",
        "Mcy": "\u041C",
        "mdash": "\u2014",
        "mDDot": "\u223A",
        "measuredangle": "\u2221",
        "MediumSpace": "\u205F",
        "Mellintrf": "\u2133",
        "mfr": "\uD835\uDD2A",
        "Mfr": "\uD835\uDD10",
        "mho": "\u2127",
        "micro": "\xb5",
        "mid": "\u2223",
        "midast": "*",
        "midcir": "\u2AF0",
        "middot": "\xb7",
        "minus": "\u2212",
        "minusb": "\u229F",
        "minusd": "\u2238",
        "minusdu": "\u2A2A",
        "MinusPlus": "\u2213",
        "mlcp": "\u2ADB",
        "mldr": "\u2026",
        "mnplus": "\u2213",
        "models": "\u22A7",
        "mopf": "\uD835\uDD5E",
        "Mopf": "\uD835\uDD44",
        "mp": "\u2213",
        "mscr": "\uD835\uDCC2",
        "Mscr": "\u2133",
        "mstpos": "\u223E",
        "mu": "\u03BC",
        "Mu": "\u039C",
        "multimap": "\u22B8",
        "mumap": "\u22B8",
        "nabla": "\u2207",
        "nacute": "\u0144",
        "Nacute": "\u0143",
        "nang": "\u2220\u20D2",
        "nap": "\u2249",
        "napE": "\u2A70\u0338",
        "napid": "\u224B\u0338",
        "napos": "\u0149",
        "napprox": "\u2249",
        "natur": "\u266E",
        "natural": "\u266E",
        "naturals": "\u2115",
        "nbsp": "\xa0",
        "nbump": "\u224E\u0338",
        "nbumpe": "\u224F\u0338",
        "ncap": "\u2A43",
        "ncaron": "\u0148",
        "Ncaron": "\u0147",
        "ncedil": "\u0146",
        "Ncedil": "\u0145",
        "ncong": "\u2247",
        "ncongdot": "\u2A6D\u0338",
        "ncup": "\u2A42",
        "ncy": "\u043D",
        "Ncy": "\u041D",
        "ndash": "\u2013",
        "ne": "\u2260",
        "nearhk": "\u2924",
        "nearr": "\u2197",
        "neArr": "\u21D7",
        "nearrow": "\u2197",
        "nedot": "\u2250\u0338",
        "NegativeMediumSpace": "\u200B",
        "NegativeThickSpace": "\u200B",
        "NegativeThinSpace": "\u200B",
        "NegativeVeryThinSpace": "\u200B",
        "nequiv": "\u2262",
        "nesear": "\u2928",
        "nesim": "\u2242\u0338",
        "NestedGreaterGreater": "\u226B",
        "NestedLessLess": "\u226A",
        "NewLine": "\n",
        "nexist": "\u2204",
        "nexists": "\u2204",
        "nfr": "\uD835\uDD2B",
        "Nfr": "\uD835\uDD11",
        "nge": "\u2271",
        "ngE": "\u2267\u0338",
        "ngeq": "\u2271",
        "ngeqq": "\u2267\u0338",
        "ngeqslant": "\u2A7E\u0338",
        "nges": "\u2A7E\u0338",
        "nGg": "\u22D9\u0338",
        "ngsim": "\u2275",
        "ngt": "\u226F",
        "nGt": "\u226B\u20D2",
        "ngtr": "\u226F",
        "nGtv": "\u226B\u0338",
        "nharr": "\u21AE",
        "nhArr": "\u21CE",
        "nhpar": "\u2AF2",
        "ni": "\u220B",
        "nis": "\u22FC",
        "nisd": "\u22FA",
        "niv": "\u220B",
        "njcy": "\u045A",
        "NJcy": "\u040A",
        "nlarr": "\u219A",
        "nlArr": "\u21CD",
        "nldr": "\u2025",
        "nle": "\u2270",
        "nlE": "\u2266\u0338",
        "nleftarrow": "\u219A",
        "nLeftarrow": "\u21CD",
        "nleftrightarrow": "\u21AE",
        "nLeftrightarrow": "\u21CE",
        "nleq": "\u2270",
        "nleqq": "\u2266\u0338",
        "nleqslant": "\u2A7D\u0338",
        "nles": "\u2A7D\u0338",
        "nless": "\u226E",
        "nLl": "\u22D8\u0338",
        "nlsim": "\u2274",
        "nlt": "\u226E",
        "nLt": "\u226A\u20D2",
        "nltri": "\u22EA",
        "nltrie": "\u22EC",
        "nLtv": "\u226A\u0338",
        "nmid": "\u2224",
        "NoBreak": "\u2060",
        "NonBreakingSpace": "\xa0",
        "nopf": "\uD835\uDD5F",
        "Nopf": "\u2115",
        "not": "\xac",
        "Not": "\u2AEC",
        "NotCongruent": "\u2262",
        "NotCupCap": "\u226D",
        "NotDoubleVerticalBar": "\u2226",
        "NotElement": "\u2209",
        "NotEqual": "\u2260",
        "NotEqualTilde": "\u2242\u0338",
        "NotExists": "\u2204",
        "NotGreater": "\u226F",
        "NotGreaterEqual": "\u2271",
        "NotGreaterFullEqual": "\u2267\u0338",
        "NotGreaterGreater": "\u226B\u0338",
        "NotGreaterLess": "\u2279",
        "NotGreaterSlantEqual": "\u2A7E\u0338",
        "NotGreaterTilde": "\u2275",
        "NotHumpDownHump": "\u224E\u0338",
        "NotHumpEqual": "\u224F\u0338",
        "notin": "\u2209",
        "notindot": "\u22F5\u0338",
        "notinE": "\u22F9\u0338",
        "notinva": "\u2209",
        "notinvb": "\u22F7",
        "notinvc": "\u22F6",
        "NotLeftTriangle": "\u22EA",
        "NotLeftTriangleBar": "\u29CF\u0338",
        "NotLeftTriangleEqual": "\u22EC",
        "NotLess": "\u226E",
        "NotLessEqual": "\u2270",
        "NotLessGreater": "\u2278",
        "NotLessLess": "\u226A\u0338",
        "NotLessSlantEqual": "\u2A7D\u0338",
        "NotLessTilde": "\u2274",
        "NotNestedGreaterGreater": "\u2AA2\u0338",
        "NotNestedLessLess": "\u2AA1\u0338",
        "notni": "\u220C",
        "notniva": "\u220C",
        "notnivb": "\u22FE",
        "notnivc": "\u22FD",
        "NotPrecedes": "\u2280",
        "NotPrecedesEqual": "\u2AAF\u0338",
        "NotPrecedesSlantEqual": "\u22E0",
        "NotReverseElement": "\u220C",
        "NotRightTriangle": "\u22EB",
        "NotRightTriangleBar": "\u29D0\u0338",
        "NotRightTriangleEqual": "\u22ED",
        "NotSquareSubset": "\u228F\u0338",
        "NotSquareSubsetEqual": "\u22E2",
        "NotSquareSuperset": "\u2290\u0338",
        "NotSquareSupersetEqual": "\u22E3",
        "NotSubset": "\u2282\u20D2",
        "NotSubsetEqual": "\u2288",
        "NotSucceeds": "\u2281",
        "NotSucceedsEqual": "\u2AB0\u0338",
        "NotSucceedsSlantEqual": "\u22E1",
        "NotSucceedsTilde": "\u227F\u0338",
        "NotSuperset": "\u2283\u20D2",
        "NotSupersetEqual": "\u2289",
        "NotTilde": "\u2241",
        "NotTildeEqual": "\u2244",
        "NotTildeFullEqual": "\u2247",
        "NotTildeTilde": "\u2249",
        "NotVerticalBar": "\u2224",
        "npar": "\u2226",
        "nparallel": "\u2226",
        "nparsl": "\u2AFD\u20E5",
        "npart": "\u2202\u0338",
        "npolint": "\u2A14",
        "npr": "\u2280",
        "nprcue": "\u22E0",
        "npre": "\u2AAF\u0338",
        "nprec": "\u2280",
        "npreceq": "\u2AAF\u0338",
        "nrarr": "\u219B",
        "nrArr": "\u21CF",
        "nrarrc": "\u2933\u0338",
        "nrarrw": "\u219D\u0338",
        "nrightarrow": "\u219B",
        "nRightarrow": "\u21CF",
        "nrtri": "\u22EB",
        "nrtrie": "\u22ED",
        "nsc": "\u2281",
        "nsccue": "\u22E1",
        "nsce": "\u2AB0\u0338",
        "nscr": "\uD835\uDCC3",
        "Nscr": "\uD835\uDCA9",
        "nshortmid": "\u2224",
        "nshortparallel": "\u2226",
        "nsim": "\u2241",
        "nsime": "\u2244",
        "nsimeq": "\u2244",
        "nsmid": "\u2224",
        "nspar": "\u2226",
        "nsqsube": "\u22E2",
        "nsqsupe": "\u22E3",
        "nsub": "\u2284",
        "nsube": "\u2288",
        "nsubE": "\u2AC5\u0338",
        "nsubset": "\u2282\u20D2",
        "nsubseteq": "\u2288",
        "nsubseteqq": "\u2AC5\u0338",
        "nsucc": "\u2281",
        "nsucceq": "\u2AB0\u0338",
        "nsup": "\u2285",
        "nsupe": "\u2289",
        "nsupE": "\u2AC6\u0338",
        "nsupset": "\u2283\u20D2",
        "nsupseteq": "\u2289",
        "nsupseteqq": "\u2AC6\u0338",
        "ntgl": "\u2279",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "ntlg": "\u2278",
        "ntriangleleft": "\u22EA",
        "ntrianglelefteq": "\u22EC",
        "ntriangleright": "\u22EB",
        "ntrianglerighteq": "\u22ED",
        "nu": "\u03BD",
        "Nu": "\u039D",
        "num": "#",
        "numero": "\u2116",
        "numsp": "\u2007",
        "nvap": "\u224D\u20D2",
        "nvdash": "\u22AC",
        "nvDash": "\u22AD",
        "nVdash": "\u22AE",
        "nVDash": "\u22AF",
        "nvge": "\u2265\u20D2",
        "nvgt": ">\u20D2",
        "nvHarr": "\u2904",
        "nvinfin": "\u29DE",
        "nvlArr": "\u2902",
        "nvle": "\u2264\u20D2",
        "nvlt": "<\u20D2",
        "nvltrie": "\u22B4\u20D2",
        "nvrArr": "\u2903",
        "nvrtrie": "\u22B5\u20D2",
        "nvsim": "\u223C\u20D2",
        "nwarhk": "\u2923",
        "nwarr": "\u2196",
        "nwArr": "\u21D6",
        "nwarrow": "\u2196",
        "nwnear": "\u2927",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "oast": "\u229B",
        "ocir": "\u229A",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ocy": "\u043E",
        "Ocy": "\u041E",
        "odash": "\u229D",
        "odblac": "\u0151",
        "Odblac": "\u0150",
        "odiv": "\u2A38",
        "odot": "\u2299",
        "odsold": "\u29BC",
        "oelig": "\u0153",
        "OElig": "\u0152",
        "ofcir": "\u29BF",
        "ofr": "\uD835\uDD2C",
        "Ofr": "\uD835\uDD12",
        "ogon": "\u02DB",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ogt": "\u29C1",
        "ohbar": "\u29B5",
        "ohm": "\u03A9",
        "oint": "\u222E",
        "olarr": "\u21BA",
        "olcir": "\u29BE",
        "olcross": "\u29BB",
        "oline": "\u203E",
        "olt": "\u29C0",
        "omacr": "\u014D",
        "Omacr": "\u014C",
        "omega": "\u03C9",
        "Omega": "\u03A9",
        "omicron": "\u03BF",
        "Omicron": "\u039F",
        "omid": "\u29B6",
        "ominus": "\u2296",
        "oopf": "\uD835\uDD60",
        "Oopf": "\uD835\uDD46",
        "opar": "\u29B7",
        "OpenCurlyDoubleQuote": "\u201C",
        "OpenCurlyQuote": "\u2018",
        "operp": "\u29B9",
        "oplus": "\u2295",
        "or": "\u2228",
        "Or": "\u2A54",
        "orarr": "\u21BB",
        "ord": "\u2A5D",
        "order": "\u2134",
        "orderof": "\u2134",
        "ordf": "\xaa",
        "ordm": "\xba",
        "origof": "\u22B6",
        "oror": "\u2A56",
        "orslope": "\u2A57",
        "orv": "\u2A5B",
        "oS": "\u24C8",
        "oscr": "\u2134",
        "Oscr": "\uD835\uDCAA",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "osol": "\u2298",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "otimes": "\u2297",
        "Otimes": "\u2A37",
        "otimesas": "\u2A36",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "ovbar": "\u233D",
        "OverBar": "\u203E",
        "OverBrace": "\u23DE",
        "OverBracket": "\u23B4",
        "OverParenthesis": "\u23DC",
        "par": "\u2225",
        "para": "\xb6",
        "parallel": "\u2225",
        "parsim": "\u2AF3",
        "parsl": "\u2AFD",
        "part": "\u2202",
        "PartialD": "\u2202",
        "pcy": "\u043F",
        "Pcy": "\u041F",
        "percnt": "%",
        "period": ".",
        "permil": "\u2030",
        "perp": "\u22A5",
        "pertenk": "\u2031",
        "pfr": "\uD835\uDD2D",
        "Pfr": "\uD835\uDD13",
        "phi": "\u03C6",
        "Phi": "\u03A6",
        "phiv": "\u03D5",
        "phmmat": "\u2133",
        "phone": "\u260E",
        "pi": "\u03C0",
        "Pi": "\u03A0",
        "pitchfork": "\u22D4",
        "piv": "\u03D6",
        "planck": "\u210F",
        "planckh": "\u210E",
        "plankv": "\u210F",
        "plus": "+",
        "plusacir": "\u2A23",
        "plusb": "\u229E",
        "pluscir": "\u2A22",
        "plusdo": "\u2214",
        "plusdu": "\u2A25",
        "pluse": "\u2A72",
        "PlusMinus": "\xb1",
        "plusmn": "\xb1",
        "plussim": "\u2A26",
        "plustwo": "\u2A27",
        "pm": "\xb1",
        "Poincareplane": "\u210C",
        "pointint": "\u2A15",
        "popf": "\uD835\uDD61",
        "Popf": "\u2119",
        "pound": "\xa3",
        "pr": "\u227A",
        "Pr": "\u2ABB",
        "prap": "\u2AB7",
        "prcue": "\u227C",
        "pre": "\u2AAF",
        "prE": "\u2AB3",
        "prec": "\u227A",
        "precapprox": "\u2AB7",
        "preccurlyeq": "\u227C",
        "Precedes": "\u227A",
        "PrecedesEqual": "\u2AAF",
        "PrecedesSlantEqual": "\u227C",
        "PrecedesTilde": "\u227E",
        "preceq": "\u2AAF",
        "precnapprox": "\u2AB9",
        "precneqq": "\u2AB5",
        "precnsim": "\u22E8",
        "precsim": "\u227E",
        "prime": "\u2032",
        "Prime": "\u2033",
        "primes": "\u2119",
        "prnap": "\u2AB9",
        "prnE": "\u2AB5",
        "prnsim": "\u22E8",
        "prod": "\u220F",
        "Product": "\u220F",
        "profalar": "\u232E",
        "profline": "\u2312",
        "profsurf": "\u2313",
        "prop": "\u221D",
        "Proportion": "\u2237",
        "Proportional": "\u221D",
        "propto": "\u221D",
        "prsim": "\u227E",
        "prurel": "\u22B0",
        "pscr": "\uD835\uDCC5",
        "Pscr": "\uD835\uDCAB",
        "psi": "\u03C8",
        "Psi": "\u03A8",
        "puncsp": "\u2008",
        "qfr": "\uD835\uDD2E",
        "Qfr": "\uD835\uDD14",
        "qint": "\u2A0C",
        "qopf": "\uD835\uDD62",
        "Qopf": "\u211A",
        "qprime": "\u2057",
        "qscr": "\uD835\uDCC6",
        "Qscr": "\uD835\uDCAC",
        "quaternions": "\u210D",
        "quatint": "\u2A16",
        "quest": "?",
        "questeq": "\u225F",
        "quot": '"',
        "QUOT": '"',
        "rAarr": "\u21DB",
        "race": "\u223D\u0331",
        "racute": "\u0155",
        "Racute": "\u0154",
        "radic": "\u221A",
        "raemptyv": "\u29B3",
        "rang": "\u27E9",
        "Rang": "\u27EB",
        "rangd": "\u2992",
        "range": "\u29A5",
        "rangle": "\u27E9",
        "raquo": "\xbb",
        "rarr": "\u2192",
        "rArr": "\u21D2",
        "Rarr": "\u21A0",
        "rarrap": "\u2975",
        "rarrb": "\u21E5",
        "rarrbfs": "\u2920",
        "rarrc": "\u2933",
        "rarrfs": "\u291E",
        "rarrhk": "\u21AA",
        "rarrlp": "\u21AC",
        "rarrpl": "\u2945",
        "rarrsim": "\u2974",
        "rarrtl": "\u21A3",
        "Rarrtl": "\u2916",
        "rarrw": "\u219D",
        "ratail": "\u291A",
        "rAtail": "\u291C",
        "ratio": "\u2236",
        "rationals": "\u211A",
        "rbarr": "\u290D",
        "rBarr": "\u290F",
        "RBarr": "\u2910",
        "rbbrk": "\u2773",
        "rbrace": "}",
        "rbrack": "]",
        "rbrke": "\u298C",
        "rbrksld": "\u298E",
        "rbrkslu": "\u2990",
        "rcaron": "\u0159",
        "Rcaron": "\u0158",
        "rcedil": "\u0157",
        "Rcedil": "\u0156",
        "rceil": "\u2309",
        "rcub": "}",
        "rcy": "\u0440",
        "Rcy": "\u0420",
        "rdca": "\u2937",
        "rdldhar": "\u2969",
        "rdquo": "\u201D",
        "rdquor": "\u201D",
        "rdsh": "\u21B3",
        "Re": "\u211C",
        "real": "\u211C",
        "realine": "\u211B",
        "realpart": "\u211C",
        "reals": "\u211D",
        "rect": "\u25AD",
        "reg": "\xae",
        "REG": "\xae",
        "ReverseElement": "\u220B",
        "ReverseEquilibrium": "\u21CB",
        "ReverseUpEquilibrium": "\u296F",
        "rfisht": "\u297D",
        "rfloor": "\u230B",
        "rfr": "\uD835\uDD2F",
        "Rfr": "\u211C",
        "rHar": "\u2964",
        "rhard": "\u21C1",
        "rharu": "\u21C0",
        "rharul": "\u296C",
        "rho": "\u03C1",
        "Rho": "\u03A1",
        "rhov": "\u03F1",
        "RightAngleBracket": "\u27E9",
        "rightarrow": "\u2192",
        "Rightarrow": "\u21D2",
        "RightArrow": "\u2192",
        "RightArrowBar": "\u21E5",
        "RightArrowLeftArrow": "\u21C4",
        "rightarrowtail": "\u21A3",
        "RightCeiling": "\u2309",
        "RightDoubleBracket": "\u27E7",
        "RightDownTeeVector": "\u295D",
        "RightDownVector": "\u21C2",
        "RightDownVectorBar": "\u2955",
        "RightFloor": "\u230B",
        "rightharpoondown": "\u21C1",
        "rightharpoonup": "\u21C0",
        "rightleftarrows": "\u21C4",
        "rightleftharpoons": "\u21CC",
        "rightrightarrows": "\u21C9",
        "rightsquigarrow": "\u219D",
        "RightTee": "\u22A2",
        "RightTeeArrow": "\u21A6",
        "RightTeeVector": "\u295B",
        "rightthreetimes": "\u22CC",
        "RightTriangle": "\u22B3",
        "RightTriangleBar": "\u29D0",
        "RightTriangleEqual": "\u22B5",
        "RightUpDownVector": "\u294F",
        "RightUpTeeVector": "\u295C",
        "RightUpVector": "\u21BE",
        "RightUpVectorBar": "\u2954",
        "RightVector": "\u21C0",
        "RightVectorBar": "\u2953",
        "ring": "\u02DA",
        "risingdotseq": "\u2253",
        "rlarr": "\u21C4",
        "rlhar": "\u21CC",
        "rlm": "\u200F",
        "rmoust": "\u23B1",
        "rmoustache": "\u23B1",
        "rnmid": "\u2AEE",
        "roang": "\u27ED",
        "roarr": "\u21FE",
        "robrk": "\u27E7",
        "ropar": "\u2986",
        "ropf": "\uD835\uDD63",
        "Ropf": "\u211D",
        "roplus": "\u2A2E",
        "rotimes": "\u2A35",
        "RoundImplies": "\u2970",
        "rpar": ")",
        "rpargt": "\u2994",
        "rppolint": "\u2A12",
        "rrarr": "\u21C9",
        "Rrightarrow": "\u21DB",
        "rsaquo": "\u203A",
        "rscr": "\uD835\uDCC7",
        "Rscr": "\u211B",
        "rsh": "\u21B1",
        "Rsh": "\u21B1",
        "rsqb": "]",
        "rsquo": "\u2019",
        "rsquor": "\u2019",
        "rthree": "\u22CC",
        "rtimes": "\u22CA",
        "rtri": "\u25B9",
        "rtrie": "\u22B5",
        "rtrif": "\u25B8",
        "rtriltri": "\u29CE",
        "RuleDelayed": "\u29F4",
        "ruluhar": "\u2968",
        "rx": "\u211E",
        "sacute": "\u015B",
        "Sacute": "\u015A",
        "sbquo": "\u201A",
        "sc": "\u227B",
        "Sc": "\u2ABC",
        "scap": "\u2AB8",
        "scaron": "\u0161",
        "Scaron": "\u0160",
        "sccue": "\u227D",
        "sce": "\u2AB0",
        "scE": "\u2AB4",
        "scedil": "\u015F",
        "Scedil": "\u015E",
        "scirc": "\u015D",
        "Scirc": "\u015C",
        "scnap": "\u2ABA",
        "scnE": "\u2AB6",
        "scnsim": "\u22E9",
        "scpolint": "\u2A13",
        "scsim": "\u227F",
        "scy": "\u0441",
        "Scy": "\u0421",
        "sdot": "\u22C5",
        "sdotb": "\u22A1",
        "sdote": "\u2A66",
        "searhk": "\u2925",
        "searr": "\u2198",
        "seArr": "\u21D8",
        "searrow": "\u2198",
        "sect": "\xa7",
        "semi": ";",
        "seswar": "\u2929",
        "setminus": "\u2216",
        "setmn": "\u2216",
        "sext": "\u2736",
        "sfr": "\uD835\uDD30",
        "Sfr": "\uD835\uDD16",
        "sfrown": "\u2322",
        "sharp": "\u266F",
        "shchcy": "\u0449",
        "SHCHcy": "\u0429",
        "shcy": "\u0448",
        "SHcy": "\u0428",
        "ShortDownArrow": "\u2193",
        "ShortLeftArrow": "\u2190",
        "shortmid": "\u2223",
        "shortparallel": "\u2225",
        "ShortRightArrow": "\u2192",
        "ShortUpArrow": "\u2191",
        "shy": "\xad",
        "sigma": "\u03C3",
        "Sigma": "\u03A3",
        "sigmaf": "\u03C2",
        "sigmav": "\u03C2",
        "sim": "\u223C",
        "simdot": "\u2A6A",
        "sime": "\u2243",
        "simeq": "\u2243",
        "simg": "\u2A9E",
        "simgE": "\u2AA0",
        "siml": "\u2A9D",
        "simlE": "\u2A9F",
        "simne": "\u2246",
        "simplus": "\u2A24",
        "simrarr": "\u2972",
        "slarr": "\u2190",
        "SmallCircle": "\u2218",
        "smallsetminus": "\u2216",
        "smashp": "\u2A33",
        "smeparsl": "\u29E4",
        "smid": "\u2223",
        "smile": "\u2323",
        "smt": "\u2AAA",
        "smte": "\u2AAC",
        "smtes": "\u2AAC\uFE00",
        "softcy": "\u044C",
        "SOFTcy": "\u042C",
        "sol": "/",
        "solb": "\u29C4",
        "solbar": "\u233F",
        "sopf": "\uD835\uDD64",
        "Sopf": "\uD835\uDD4A",
        "spades": "\u2660",
        "spadesuit": "\u2660",
        "spar": "\u2225",
        "sqcap": "\u2293",
        "sqcaps": "\u2293\uFE00",
        "sqcup": "\u2294",
        "sqcups": "\u2294\uFE00",
        "Sqrt": "\u221A",
        "sqsub": "\u228F",
        "sqsube": "\u2291",
        "sqsubset": "\u228F",
        "sqsubseteq": "\u2291",
        "sqsup": "\u2290",
        "sqsupe": "\u2292",
        "sqsupset": "\u2290",
        "sqsupseteq": "\u2292",
        "squ": "\u25A1",
        "square": "\u25A1",
        "Square": "\u25A1",
        "SquareIntersection": "\u2293",
        "SquareSubset": "\u228F",
        "SquareSubsetEqual": "\u2291",
        "SquareSuperset": "\u2290",
        "SquareSupersetEqual": "\u2292",
        "SquareUnion": "\u2294",
        "squarf": "\u25AA",
        "squf": "\u25AA",
        "srarr": "\u2192",
        "sscr": "\uD835\uDCC8",
        "Sscr": "\uD835\uDCAE",
        "ssetmn": "\u2216",
        "ssmile": "\u2323",
        "sstarf": "\u22C6",
        "star": "\u2606",
        "Star": "\u22C6",
        "starf": "\u2605",
        "straightepsilon": "\u03F5",
        "straightphi": "\u03D5",
        "strns": "\xaf",
        "sub": "\u2282",
        "Sub": "\u22D0",
        "subdot": "\u2ABD",
        "sube": "\u2286",
        "subE": "\u2AC5",
        "subedot": "\u2AC3",
        "submult": "\u2AC1",
        "subne": "\u228A",
        "subnE": "\u2ACB",
        "subplus": "\u2ABF",
        "subrarr": "\u2979",
        "subset": "\u2282",
        "Subset": "\u22D0",
        "subseteq": "\u2286",
        "subseteqq": "\u2AC5",
        "SubsetEqual": "\u2286",
        "subsetneq": "\u228A",
        "subsetneqq": "\u2ACB",
        "subsim": "\u2AC7",
        "subsub": "\u2AD5",
        "subsup": "\u2AD3",
        "succ": "\u227B",
        "succapprox": "\u2AB8",
        "succcurlyeq": "\u227D",
        "Succeeds": "\u227B",
        "SucceedsEqual": "\u2AB0",
        "SucceedsSlantEqual": "\u227D",
        "SucceedsTilde": "\u227F",
        "succeq": "\u2AB0",
        "succnapprox": "\u2ABA",
        "succneqq": "\u2AB6",
        "succnsim": "\u22E9",
        "succsim": "\u227F",
        "SuchThat": "\u220B",
        "sum": "\u2211",
        "Sum": "\u2211",
        "sung": "\u266A",
        "sup": "\u2283",
        "Sup": "\u22D1",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "supdot": "\u2ABE",
        "supdsub": "\u2AD8",
        "supe": "\u2287",
        "supE": "\u2AC6",
        "supedot": "\u2AC4",
        "Superset": "\u2283",
        "SupersetEqual": "\u2287",
        "suphsol": "\u27C9",
        "suphsub": "\u2AD7",
        "suplarr": "\u297B",
        "supmult": "\u2AC2",
        "supne": "\u228B",
        "supnE": "\u2ACC",
        "supplus": "\u2AC0",
        "supset": "\u2283",
        "Supset": "\u22D1",
        "supseteq": "\u2287",
        "supseteqq": "\u2AC6",
        "supsetneq": "\u228B",
        "supsetneqq": "\u2ACC",
        "supsim": "\u2AC8",
        "supsub": "\u2AD4",
        "supsup": "\u2AD6",
        "swarhk": "\u2926",
        "swarr": "\u2199",
        "swArr": "\u21D9",
        "swarrow": "\u2199",
        "swnwar": "\u292A",
        "szlig": "\xdf",
        "Tab": "	",
        "target": "\u2316",
        "tau": "\u03C4",
        "Tau": "\u03A4",
        "tbrk": "\u23B4",
        "tcaron": "\u0165",
        "Tcaron": "\u0164",
        "tcedil": "\u0163",
        "Tcedil": "\u0162",
        "tcy": "\u0442",
        "Tcy": "\u0422",
        "tdot": "\u20DB",
        "telrec": "\u2315",
        "tfr": "\uD835\uDD31",
        "Tfr": "\uD835\uDD17",
        "there4": "\u2234",
        "therefore": "\u2234",
        "Therefore": "\u2234",
        "theta": "\u03B8",
        "Theta": "\u0398",
        "thetasym": "\u03D1",
        "thetav": "\u03D1",
        "thickapprox": "\u2248",
        "thicksim": "\u223C",
        "ThickSpace": "\u205F\u200A",
        "thinsp": "\u2009",
        "ThinSpace": "\u2009",
        "thkap": "\u2248",
        "thksim": "\u223C",
        "thorn": "\xfe",
        "THORN": "\xde",
        "tilde": "\u02DC",
        "Tilde": "\u223C",
        "TildeEqual": "\u2243",
        "TildeFullEqual": "\u2245",
        "TildeTilde": "\u2248",
        "times": "\xd7",
        "timesb": "\u22A0",
        "timesbar": "\u2A31",
        "timesd": "\u2A30",
        "tint": "\u222D",
        "toea": "\u2928",
        "top": "\u22A4",
        "topbot": "\u2336",
        "topcir": "\u2AF1",
        "topf": "\uD835\uDD65",
        "Topf": "\uD835\uDD4B",
        "topfork": "\u2ADA",
        "tosa": "\u2929",
        "tprime": "\u2034",
        "trade": "\u2122",
        "TRADE": "\u2122",
        "triangle": "\u25B5",
        "triangledown": "\u25BF",
        "triangleleft": "\u25C3",
        "trianglelefteq": "\u22B4",
        "triangleq": "\u225C",
        "triangleright": "\u25B9",
        "trianglerighteq": "\u22B5",
        "tridot": "\u25EC",
        "trie": "\u225C",
        "triminus": "\u2A3A",
        "TripleDot": "\u20DB",
        "triplus": "\u2A39",
        "trisb": "\u29CD",
        "tritime": "\u2A3B",
        "trpezium": "\u23E2",
        "tscr": "\uD835\uDCC9",
        "Tscr": "\uD835\uDCAF",
        "tscy": "\u0446",
        "TScy": "\u0426",
        "tshcy": "\u045B",
        "TSHcy": "\u040B",
        "tstrok": "\u0167",
        "Tstrok": "\u0166",
        "twixt": "\u226C",
        "twoheadleftarrow": "\u219E",
        "twoheadrightarrow": "\u21A0",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "uarr": "\u2191",
        "uArr": "\u21D1",
        "Uarr": "\u219F",
        "Uarrocir": "\u2949",
        "ubrcy": "\u045E",
        "Ubrcy": "\u040E",
        "ubreve": "\u016D",
        "Ubreve": "\u016C",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ucy": "\u0443",
        "Ucy": "\u0423",
        "udarr": "\u21C5",
        "udblac": "\u0171",
        "Udblac": "\u0170",
        "udhar": "\u296E",
        "ufisht": "\u297E",
        "ufr": "\uD835\uDD32",
        "Ufr": "\uD835\uDD18",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uHar": "\u2963",
        "uharl": "\u21BF",
        "uharr": "\u21BE",
        "uhblk": "\u2580",
        "ulcorn": "\u231C",
        "ulcorner": "\u231C",
        "ulcrop": "\u230F",
        "ultri": "\u25F8",
        "umacr": "\u016B",
        "Umacr": "\u016A",
        "uml": "\xa8",
        "UnderBar": "_",
        "UnderBrace": "\u23DF",
        "UnderBracket": "\u23B5",
        "UnderParenthesis": "\u23DD",
        "Union": "\u22C3",
        "UnionPlus": "\u228E",
        "uogon": "\u0173",
        "Uogon": "\u0172",
        "uopf": "\uD835\uDD66",
        "Uopf": "\uD835\uDD4C",
        "uparrow": "\u2191",
        "Uparrow": "\u21D1",
        "UpArrow": "\u2191",
        "UpArrowBar": "\u2912",
        "UpArrowDownArrow": "\u21C5",
        "updownarrow": "\u2195",
        "Updownarrow": "\u21D5",
        "UpDownArrow": "\u2195",
        "UpEquilibrium": "\u296E",
        "upharpoonleft": "\u21BF",
        "upharpoonright": "\u21BE",
        "uplus": "\u228E",
        "UpperLeftArrow": "\u2196",
        "UpperRightArrow": "\u2197",
        "upsi": "\u03C5",
        "Upsi": "\u03D2",
        "upsih": "\u03D2",
        "upsilon": "\u03C5",
        "Upsilon": "\u03A5",
        "UpTee": "\u22A5",
        "UpTeeArrow": "\u21A5",
        "upuparrows": "\u21C8",
        "urcorn": "\u231D",
        "urcorner": "\u231D",
        "urcrop": "\u230E",
        "uring": "\u016F",
        "Uring": "\u016E",
        "urtri": "\u25F9",
        "uscr": "\uD835\uDCCA",
        "Uscr": "\uD835\uDCB0",
        "utdot": "\u22F0",
        "utilde": "\u0169",
        "Utilde": "\u0168",
        "utri": "\u25B5",
        "utrif": "\u25B4",
        "uuarr": "\u21C8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "uwangle": "\u29A7",
        "vangrt": "\u299C",
        "varepsilon": "\u03F5",
        "varkappa": "\u03F0",
        "varnothing": "\u2205",
        "varphi": "\u03D5",
        "varpi": "\u03D6",
        "varpropto": "\u221D",
        "varr": "\u2195",
        "vArr": "\u21D5",
        "varrho": "\u03F1",
        "varsigma": "\u03C2",
        "varsubsetneq": "\u228A\uFE00",
        "varsubsetneqq": "\u2ACB\uFE00",
        "varsupsetneq": "\u228B\uFE00",
        "varsupsetneqq": "\u2ACC\uFE00",
        "vartheta": "\u03D1",
        "vartriangleleft": "\u22B2",
        "vartriangleright": "\u22B3",
        "vBar": "\u2AE8",
        "Vbar": "\u2AEB",
        "vBarv": "\u2AE9",
        "vcy": "\u0432",
        "Vcy": "\u0412",
        "vdash": "\u22A2",
        "vDash": "\u22A8",
        "Vdash": "\u22A9",
        "VDash": "\u22AB",
        "Vdashl": "\u2AE6",
        "vee": "\u2228",
        "Vee": "\u22C1",
        "veebar": "\u22BB",
        "veeeq": "\u225A",
        "vellip": "\u22EE",
        "verbar": "|",
        "Verbar": "\u2016",
        "vert": "|",
        "Vert": "\u2016",
        "VerticalBar": "\u2223",
        "VerticalLine": "|",
        "VerticalSeparator": "\u2758",
        "VerticalTilde": "\u2240",
        "VeryThinSpace": "\u200A",
        "vfr": "\uD835\uDD33",
        "Vfr": "\uD835\uDD19",
        "vltri": "\u22B2",
        "vnsub": "\u2282\u20D2",
        "vnsup": "\u2283\u20D2",
        "vopf": "\uD835\uDD67",
        "Vopf": "\uD835\uDD4D",
        "vprop": "\u221D",
        "vrtri": "\u22B3",
        "vscr": "\uD835\uDCCB",
        "Vscr": "\uD835\uDCB1",
        "vsubne": "\u228A\uFE00",
        "vsubnE": "\u2ACB\uFE00",
        "vsupne": "\u228B\uFE00",
        "vsupnE": "\u2ACC\uFE00",
        "Vvdash": "\u22AA",
        "vzigzag": "\u299A",
        "wcirc": "\u0175",
        "Wcirc": "\u0174",
        "wedbar": "\u2A5F",
        "wedge": "\u2227",
        "Wedge": "\u22C0",
        "wedgeq": "\u2259",
        "weierp": "\u2118",
        "wfr": "\uD835\uDD34",
        "Wfr": "\uD835\uDD1A",
        "wopf": "\uD835\uDD68",
        "Wopf": "\uD835\uDD4E",
        "wp": "\u2118",
        "wr": "\u2240",
        "wreath": "\u2240",
        "wscr": "\uD835\uDCCC",
        "Wscr": "\uD835\uDCB2",
        "xcap": "\u22C2",
        "xcirc": "\u25EF",
        "xcup": "\u22C3",
        "xdtri": "\u25BD",
        "xfr": "\uD835\uDD35",
        "Xfr": "\uD835\uDD1B",
        "xharr": "\u27F7",
        "xhArr": "\u27FA",
        "xi": "\u03BE",
        "Xi": "\u039E",
        "xlarr": "\u27F5",
        "xlArr": "\u27F8",
        "xmap": "\u27FC",
        "xnis": "\u22FB",
        "xodot": "\u2A00",
        "xopf": "\uD835\uDD69",
        "Xopf": "\uD835\uDD4F",
        "xoplus": "\u2A01",
        "xotime": "\u2A02",
        "xrarr": "\u27F6",
        "xrArr": "\u27F9",
        "xscr": "\uD835\uDCCD",
        "Xscr": "\uD835\uDCB3",
        "xsqcup": "\u2A06",
        "xuplus": "\u2A04",
        "xutri": "\u25B3",
        "xvee": "\u22C1",
        "xwedge": "\u22C0",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yacy": "\u044F",
        "YAcy": "\u042F",
        "ycirc": "\u0177",
        "Ycirc": "\u0176",
        "ycy": "\u044B",
        "Ycy": "\u042B",
        "yen": "\xa5",
        "yfr": "\uD835\uDD36",
        "Yfr": "\uD835\uDD1C",
        "yicy": "\u0457",
        "YIcy": "\u0407",
        "yopf": "\uD835\uDD6A",
        "Yopf": "\uD835\uDD50",
        "yscr": "\uD835\uDCCE",
        "Yscr": "\uD835\uDCB4",
        "yucy": "\u044E",
        "YUcy": "\u042E",
        "yuml": "\xff",
        "Yuml": "\u0178",
        "zacute": "\u017A",
        "Zacute": "\u0179",
        "zcaron": "\u017E",
        "Zcaron": "\u017D",
        "zcy": "\u0437",
        "Zcy": "\u0417",
        "zdot": "\u017C",
        "Zdot": "\u017B",
        "zeetrf": "\u2128",
        "ZeroWidthSpace": "\u200B",
        "zeta": "\u03B6",
        "Zeta": "\u0396",
        "zfr": "\uD835\uDD37",
        "Zfr": "\u2128",
        "zhcy": "\u0436",
        "ZHcy": "\u0416",
        "zigrarr": "\u21DD",
        "zopf": "\uD835\uDD6B",
        "Zopf": "\u2124",
        "zscr": "\uD835\uDCCF",
        "Zscr": "\uD835\uDCB5",
        "zwj": "\u200D",
        "zwnj": "\u200C"
    };
    var decodeMapLegacy = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "amp": "&",
        "AMP": "&",
        "aring": "\xe5",
        "Aring": "\xc5",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "brvbar": "\xa6",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "cedil": "\xb8",
        "cent": "\xa2",
        "copy": "\xa9",
        "COPY": "\xa9",
        "curren": "\xa4",
        "deg": "\xb0",
        "divide": "\xf7",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "frac12": "\xbd",
        "frac14": "\xbc",
        "frac34": "\xbe",
        "gt": ">",
        "GT": ">",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "icirc": "\xee",
        "Icirc": "\xce",
        "iexcl": "\xa1",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "iquest": "\xbf",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "laquo": "\xab",
        "lt": "<",
        "LT": "<",
        "macr": "\xaf",
        "micro": "\xb5",
        "middot": "\xb7",
        "nbsp": "\xa0",
        "not": "\xac",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ordf": "\xaa",
        "ordm": "\xba",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "para": "\xb6",
        "plusmn": "\xb1",
        "pound": "\xa3",
        "quot": '"',
        "QUOT": '"',
        "raquo": "\xbb",
        "reg": "\xae",
        "REG": "\xae",
        "sect": "\xa7",
        "shy": "\xad",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "szlig": "\xdf",
        "thorn": "\xfe",
        "THORN": "\xde",
        "times": "\xd7",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uml": "\xa8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yen": "\xa5",
        "yuml": "\xff"
    };
    var decodeMapNumeric = {
        "0": "\uFFFD",
        "128": "\u20AC",
        "130": "\u201A",
        "131": "\u0192",
        "132": "\u201E",
        "133": "\u2026",
        "134": "\u2020",
        "135": "\u2021",
        "136": "\u02C6",
        "137": "\u2030",
        "138": "\u0160",
        "139": "\u2039",
        "140": "\u0152",
        "142": "\u017D",
        "145": "\u2018",
        "146": "\u2019",
        "147": "\u201C",
        "148": "\u201D",
        "149": "\u2022",
        "150": "\u2013",
        "151": "\u2014",
        "152": "\u02DC",
        "153": "\u2122",
        "154": "\u0161",
        "155": "\u203A",
        "156": "\u0153",
        "158": "\u017E",
        "159": "\u0178"
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = "";
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError("character reference outside the permissible Unicode range");
            return "\uFFFD";
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError("disallowed character reference");
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError("disallowed character reference");
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    };
    var decEscape = function(codePoint) {
        return "&#" + codePoint + ";";
    };
    var parseError = function(message) {
        throw Error("Parse error: " + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError("forbidden code point");
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return "&" + encodeMap[symbol] + ";";
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return "&" + encodeMap[string] + ";"; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        "allowUnsafeSymbols": false,
        "encodeEverything": false,
        "strict": false,
        "useNamedReferences": false,
        "decimal": false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError("malformed character reference");
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == "=") parseError("`&` did not start a character reference");
                    return $0;
                } else {
                    if (strict) parseError("named character reference was not terminated by a semicolon");
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || "");
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError("named character reference was not terminated by a semicolon");
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        "isAttributeValue": false,
        "strict": false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        "version": "1.2.0",
        "encode": encode,
        "decode": decode,
        "escape": escape,
        "unescape": decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("4PyBn", function(module, exports) {
"use strict";
var $3846c4084d24ed0c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3846c4084d24ed0c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3846c4084d24ed0c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3846c4084d24ed0c$var$__createBinding(result, mod, k);
    }
    $3846c4084d24ed0c$var$__setModuleDefault(result, mod);
    return result;
};
var $3846c4084d24ed0c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3846c4084d24ed0c$var$__createBinding(exports1, m, p);
};
var $3846c4084d24ed0c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RssHandler = module.exports.DefaultHandler = module.exports.DomUtils = module.exports.ElementType = module.exports.Tokenizer = module.exports.createDomStream = module.exports.parseDOM = module.exports.parseDocument = module.exports.DomHandler = module.exports.Parser = void 0;

var $enYrI = parcelRequire("enYrI");
Object.defineProperty(module.exports, "Parser", {
    enumerable: true,
    get: function() {
        return $enYrI.Parser;
    }
});

var $cAP9v = parcelRequire("cAP9v");
Object.defineProperty(module.exports, "DomHandler", {
    enumerable: true,
    get: function() {
        return $cAP9v.DomHandler;
    }
});
Object.defineProperty(module.exports, "DefaultHandler", {
    enumerable: true,
    get: function() {
        return $cAP9v.DomHandler;
    }
});
// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */ function $3846c4084d24ed0c$var$parseDocument(data, options) {
    var handler = new $cAP9v.DomHandler(undefined, options);
    new $enYrI.Parser(handler, options).end(data);
    return handler.root;
}
module.exports.parseDocument = $3846c4084d24ed0c$var$parseDocument;
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */ function $3846c4084d24ed0c$var$parseDOM(data, options) {
    return $3846c4084d24ed0c$var$parseDocument(data, options).children;
}
module.exports.parseDOM = $3846c4084d24ed0c$var$parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param cb A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
 */ function $3846c4084d24ed0c$var$createDomStream(cb, options, elementCb) {
    var handler = new $cAP9v.DomHandler(cb, options, elementCb);
    return new $enYrI.Parser(handler, options);
}
module.exports.createDomStream = $3846c4084d24ed0c$var$createDomStream;

var $glAEY = parcelRequire("glAEY");
Object.defineProperty(module.exports, "Tokenizer", {
    enumerable: true,
    get: function() {
        return $3846c4084d24ed0c$var$__importDefault($glAEY).default;
    }
});

var $3846c4084d24ed0c$var$ElementType = $3846c4084d24ed0c$var$__importStar((parcelRequire("lbVaC")));
module.exports.ElementType = $3846c4084d24ed0c$var$ElementType;

/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */ $3846c4084d24ed0c$var$__exportStar((parcelRequire("5xCYr")), module.exports);

module.exports.DomUtils = $3846c4084d24ed0c$var$__importStar((parcelRequire("aLus5")));

Object.defineProperty(module.exports, "RssHandler", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5xCYr")).FeedHandler;
    }
});

});
parcelRegister("enYrI", function(module, exports) {
"use strict";
var $a7921a00c84c77f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $a7921a00c84c77f9$var$Tokenizer_1 = $a7921a00c84c77f9$var$__importDefault((parcelRequire("glAEY")));
var $a7921a00c84c77f9$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $a7921a00c84c77f9$var$pTag = new Set([
    "p"
]);
var $a7921a00c84c77f9$var$openImpliesClose = {
    tr: new Set([
        "tr",
        "th",
        "td"
    ]),
    th: new Set([
        "th"
    ]),
    td: new Set([
        "thead",
        "th",
        "td"
    ]),
    body: new Set([
        "head",
        "link",
        "script"
    ]),
    li: new Set([
        "li"
    ]),
    p: $a7921a00c84c77f9$var$pTag,
    h1: $a7921a00c84c77f9$var$pTag,
    h2: $a7921a00c84c77f9$var$pTag,
    h3: $a7921a00c84c77f9$var$pTag,
    h4: $a7921a00c84c77f9$var$pTag,
    h5: $a7921a00c84c77f9$var$pTag,
    h6: $a7921a00c84c77f9$var$pTag,
    select: $a7921a00c84c77f9$var$formTags,
    input: $a7921a00c84c77f9$var$formTags,
    output: $a7921a00c84c77f9$var$formTags,
    button: $a7921a00c84c77f9$var$formTags,
    datalist: $a7921a00c84c77f9$var$formTags,
    textarea: $a7921a00c84c77f9$var$formTags,
    option: new Set([
        "option"
    ]),
    optgroup: new Set([
        "optgroup",
        "option"
    ]),
    dd: new Set([
        "dt",
        "dd"
    ]),
    dt: new Set([
        "dt",
        "dd"
    ]),
    address: $a7921a00c84c77f9$var$pTag,
    article: $a7921a00c84c77f9$var$pTag,
    aside: $a7921a00c84c77f9$var$pTag,
    blockquote: $a7921a00c84c77f9$var$pTag,
    details: $a7921a00c84c77f9$var$pTag,
    div: $a7921a00c84c77f9$var$pTag,
    dl: $a7921a00c84c77f9$var$pTag,
    fieldset: $a7921a00c84c77f9$var$pTag,
    figcaption: $a7921a00c84c77f9$var$pTag,
    figure: $a7921a00c84c77f9$var$pTag,
    footer: $a7921a00c84c77f9$var$pTag,
    form: $a7921a00c84c77f9$var$pTag,
    header: $a7921a00c84c77f9$var$pTag,
    hr: $a7921a00c84c77f9$var$pTag,
    main: $a7921a00c84c77f9$var$pTag,
    nav: $a7921a00c84c77f9$var$pTag,
    ol: $a7921a00c84c77f9$var$pTag,
    pre: $a7921a00c84c77f9$var$pTag,
    section: $a7921a00c84c77f9$var$pTag,
    table: $a7921a00c84c77f9$var$pTag,
    ul: $a7921a00c84c77f9$var$pTag,
    rt: new Set([
        "rt",
        "rp"
    ]),
    rp: new Set([
        "rt",
        "rp"
    ]),
    tbody: new Set([
        "thead",
        "tbody"
    ]),
    tfoot: new Set([
        "thead",
        "tbody"
    ])
};
var $a7921a00c84c77f9$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $a7921a00c84c77f9$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $a7921a00c84c77f9$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $a7921a00c84c77f9$var$reNameEnd = /\s|\//;
var $a7921a00c84c77f9$var$Parser = /** @class */ function() {
    function Parser(cbs, options) {
        if (options === void 0) options = {};
        var _a, _b, _c, _d, _e;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = null;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.options = options;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : $a7921a00c84c77f9$var$Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    Parser.prototype.updatePosition = function(initialOffset) {
        if (this.endIndex === null) {
            if (this.tokenizer.sectionStart <= initialOffset) this.startIndex = 0;
            else this.startIndex = this.tokenizer.sectionStart - initialOffset;
        } else this.startIndex = this.endIndex + 1;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
    };
    // Tokenizer event handlers
    Parser.prototype.ontext = function(data) {
        var _a, _b;
        this.updatePosition(1);
        this.endIndex--;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
    };
    Parser.prototype.onopentagname = function(name) {
        var _a, _b;
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.tagname = name;
        if (!this.options.xmlMode && Object.prototype.hasOwnProperty.call($a7921a00c84c77f9$var$openImpliesClose, name)) {
            var el = void 0;
            while(this.stack.length > 0 && $a7921a00c84c77f9$var$openImpliesClose[name].has(el = this.stack[this.stack.length - 1]))this.onclosetag(el);
        }
        if (this.options.xmlMode || !$a7921a00c84c77f9$var$voidElements.has(name)) {
            this.stack.push(name);
            if ($a7921a00c84c77f9$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($a7921a00c84c77f9$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, name);
        if (this.cbs.onopentag) this.attribs = {};
    };
    Parser.prototype.onopentagend = function() {
        var _a, _b;
        this.updatePosition(1);
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs);
            this.attribs = null;
        }
        if (!this.options.xmlMode && this.cbs.onclosetag && $a7921a00c84c77f9$var$voidElements.has(this.tagname)) this.cbs.onclosetag(this.tagname);
        this.tagname = "";
    };
    Parser.prototype.onclosetag = function(name) {
        this.updatePosition(1);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($a7921a00c84c77f9$var$foreignContextElements.has(name) || $a7921a00c84c77f9$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (this.stack.length && (this.options.xmlMode || !$a7921a00c84c77f9$var$voidElements.has(name))) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    pos = this.stack.length - pos;
                    while(pos--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop());
                } else this.stack.length = pos;
            } else if (name === "p" && !this.options.xmlMode) {
                this.onopentagname(name);
                this.closeCurrentTag();
            }
        } else if (!this.options.xmlMode && (name === "br" || name === "p")) {
            this.onopentagname(name);
            this.closeCurrentTag();
        }
    };
    Parser.prototype.onselfclosingtag = function() {
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) this.closeCurrentTag();
        else this.onopentagend();
    };
    Parser.prototype.closeCurrentTag = function() {
        var _a, _b;
        var name = this.tagname;
        this.onopentagend();
        /*
         * Self-closing tags will be on the top of the stack
         * (cheaper check than in onclosetag)
         */ if (this.stack[this.stack.length - 1] === name) {
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name);
            this.stack.pop();
        }
    };
    Parser.prototype.onattribname = function(name) {
        if (this.lowerCaseAttributeNames) name = name.toLowerCase();
        this.attribname = name;
    };
    Parser.prototype.onattribdata = function(value) {
        this.attribvalue += value;
    };
    Parser.prototype.onattribend = function(quote) {
        var _a, _b;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribname = "";
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function(value) {
        var idx = value.search($a7921a00c84c77f9$var$reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    };
    Parser.prototype.ondeclaration = function(value) {
        if (this.cbs.onprocessinginstruction) {
            var name_1 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
    };
    Parser.prototype.onprocessinginstruction = function(value) {
        if (this.cbs.onprocessinginstruction) {
            var name_2 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
    };
    Parser.prototype.oncomment = function(value) {
        var _a, _b, _c, _d;
        this.updatePosition(4);
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
    };
    Parser.prototype.oncdata = function(value) {
        var _a, _b, _c, _d, _e, _f;
        this.updatePosition(1);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else this.oncomment("[CDATA[" + value + "]]");
    };
    Parser.prototype.onerror = function(err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, err);
    };
    Parser.prototype.onend = function() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            for(var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i]));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ Parser.prototype.reset = function() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ Parser.prototype.parseComplete = function(data) {
        this.reset();
        this.end(data);
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ Parser.prototype.write = function(chunk) {
        this.tokenizer.write(chunk);
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ Parser.prototype.end = function(chunk) {
        this.tokenizer.end(chunk);
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ Parser.prototype.pause = function() {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */ Parser.prototype.resume = function() {
        this.tokenizer.resume();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ Parser.prototype.parseChunk = function(chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ Parser.prototype.done = function(chunk) {
        this.end(chunk);
    };
    return Parser;
}();
module.exports.Parser = $a7921a00c84c77f9$var$Parser;

});
parcelRegister("glAEY", function(module, exports) {
"use strict";
var $be6b0b6487ca08e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $be6b0b6487ca08e1$var$decode_codepoint_1 = $be6b0b6487ca08e1$var$__importDefault((parcelRequire("di1Xh")));

var $be6b0b6487ca08e1$var$entities_json_1 = $be6b0b6487ca08e1$var$__importDefault((parcelRequire("8XT1w")));

var $be6b0b6487ca08e1$var$legacy_json_1 = $be6b0b6487ca08e1$var$__importDefault((parcelRequire("eDiqq")));

var $be6b0b6487ca08e1$var$xml_json_1 = $be6b0b6487ca08e1$var$__importDefault((parcelRequire("72Wkn")));
function $be6b0b6487ca08e1$var$whitespace(c) {
    return c === " " || c === "\n" || c === "	" || c === "\f" || c === "\r";
}
function $be6b0b6487ca08e1$var$isASCIIAlpha(c) {
    return c >= "a" && c <= "z" || c >= "A" && c <= "Z";
}
function $be6b0b6487ca08e1$var$ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();
    if (upper === lower) return function(t, c) {
        if (c === lower) t._state = SUCCESS;
        else {
            t._state = FAILURE;
            t._index--;
        }
    };
    return function(t, c) {
        if (c === lower || c === upper) t._state = SUCCESS;
        else {
            t._state = FAILURE;
            t._index--;
        }
    };
}
function $be6b0b6487ca08e1$var$consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();
    return function(t, c) {
        if (c === lower || c === upper) t._state = NEXT_STATE;
        else {
            t._state = 3 /* InTagName */ ;
            t._index--; // Consume the token again
        }
    };
}
var $be6b0b6487ca08e1$var$stateBeforeCdata1 = $be6b0b6487ca08e1$var$ifElseState("C", 24 /* BeforeCdata2 */ , 16 /* InDeclaration */ );
var $be6b0b6487ca08e1$var$stateBeforeCdata2 = $be6b0b6487ca08e1$var$ifElseState("D", 25 /* BeforeCdata3 */ , 16 /* InDeclaration */ );
var $be6b0b6487ca08e1$var$stateBeforeCdata3 = $be6b0b6487ca08e1$var$ifElseState("A", 26 /* BeforeCdata4 */ , 16 /* InDeclaration */ );
var $be6b0b6487ca08e1$var$stateBeforeCdata4 = $be6b0b6487ca08e1$var$ifElseState("T", 27 /* BeforeCdata5 */ , 16 /* InDeclaration */ );
var $be6b0b6487ca08e1$var$stateBeforeCdata5 = $be6b0b6487ca08e1$var$ifElseState("A", 28 /* BeforeCdata6 */ , 16 /* InDeclaration */ );
var $be6b0b6487ca08e1$var$stateBeforeScript1 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("R", 35 /* BeforeScript2 */ );
var $be6b0b6487ca08e1$var$stateBeforeScript2 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("I", 36 /* BeforeScript3 */ );
var $be6b0b6487ca08e1$var$stateBeforeScript3 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("P", 37 /* BeforeScript4 */ );
var $be6b0b6487ca08e1$var$stateBeforeScript4 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("T", 38 /* BeforeScript5 */ );
var $be6b0b6487ca08e1$var$stateAfterScript1 = $be6b0b6487ca08e1$var$ifElseState("R", 40 /* AfterScript2 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterScript2 = $be6b0b6487ca08e1$var$ifElseState("I", 41 /* AfterScript3 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterScript3 = $be6b0b6487ca08e1$var$ifElseState("P", 42 /* AfterScript4 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterScript4 = $be6b0b6487ca08e1$var$ifElseState("T", 43 /* AfterScript5 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateBeforeStyle1 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("Y", 45 /* BeforeStyle2 */ );
var $be6b0b6487ca08e1$var$stateBeforeStyle2 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("L", 46 /* BeforeStyle3 */ );
var $be6b0b6487ca08e1$var$stateBeforeStyle3 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("E", 47 /* BeforeStyle4 */ );
var $be6b0b6487ca08e1$var$stateAfterStyle1 = $be6b0b6487ca08e1$var$ifElseState("Y", 49 /* AfterStyle2 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterStyle2 = $be6b0b6487ca08e1$var$ifElseState("L", 50 /* AfterStyle3 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterStyle3 = $be6b0b6487ca08e1$var$ifElseState("E", 51 /* AfterStyle4 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateBeforeSpecialT = $be6b0b6487ca08e1$var$consumeSpecialNameChar("I", 54 /* BeforeTitle1 */ );
var $be6b0b6487ca08e1$var$stateBeforeTitle1 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("T", 55 /* BeforeTitle2 */ );
var $be6b0b6487ca08e1$var$stateBeforeTitle2 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("L", 56 /* BeforeTitle3 */ );
var $be6b0b6487ca08e1$var$stateBeforeTitle3 = $be6b0b6487ca08e1$var$consumeSpecialNameChar("E", 57 /* BeforeTitle4 */ );
var $be6b0b6487ca08e1$var$stateAfterSpecialTEnd = $be6b0b6487ca08e1$var$ifElseState("I", 58 /* AfterTitle1 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterTitle1 = $be6b0b6487ca08e1$var$ifElseState("T", 59 /* AfterTitle2 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterTitle2 = $be6b0b6487ca08e1$var$ifElseState("L", 60 /* AfterTitle3 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateAfterTitle3 = $be6b0b6487ca08e1$var$ifElseState("E", 61 /* AfterTitle4 */ , 1 /* Text */ );
var $be6b0b6487ca08e1$var$stateBeforeEntity = $be6b0b6487ca08e1$var$ifElseState("#", 63 /* BeforeNumericEntity */ , 64 /* InNamedEntity */ );
var $be6b0b6487ca08e1$var$stateBeforeNumericEntity = $be6b0b6487ca08e1$var$ifElseState("X", 66 /* InHexEntity */ , 65 /* InNumericEntity */ );
var $be6b0b6487ca08e1$var$Tokenizer = /** @class */ function() {
    function Tokenizer(options, cbs) {
        var _a;
        /** The current state the tokenizer is in. */ this._state = 1 /* Text */ ;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this._index = 0;
        /**
         * Data that has already been processed will be removed from the buffer occasionally.
         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
         */ this.bufferOffset = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1 /* Text */ ;
        /** For special parsing behavior inside of script and style tags. */ this.special = 1 /* None */ ;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** Indicates whether the tokenizer has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs;
        this.xmlMode = !!(options === null || options === void 0 ? void 0 : options.xmlMode);
        this.decodeEntities = (_a = options === null || options === void 0 ? void 0 : options.decodeEntities) !== null && _a !== void 0 ? _a : true;
    }
    Tokenizer.prototype.reset = function() {
        this._state = 1 /* Text */ ;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 /* Text */ ;
        this.special = 1 /* None */ ;
        this.running = true;
        this.ended = false;
    };
    Tokenizer.prototype.write = function(chunk) {
        if (this.ended) this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function(chunk) {
        if (this.ended) this.cbs.onerror(Error(".end() after done!"));
        if (chunk) this.write(chunk);
        this.ended = true;
        if (this.running) this.finish();
    };
    Tokenizer.prototype.pause = function() {
        this.running = false;
    };
    Tokenizer.prototype.resume = function() {
        this.running = true;
        if (this._index < this.buffer.length) this.parse();
        if (this.ended) this.finish();
    };
    /**
     * The current index within all of the written data.
     */ Tokenizer.prototype.getAbsoluteIndex = function() {
        return this.bufferOffset + this._index;
    };
    Tokenizer.prototype.stateText = function(c) {
        if (c === "<") {
            if (this._index > this.sectionStart) this.cbs.ontext(this.getSection());
            this._state = 2 /* BeforeTagName */ ;
            this.sectionStart = this._index;
        } else if (this.decodeEntities && c === "&" && (this.special === 1 /* None */  || this.special === 4 /* Title */ )) {
            if (this._index > this.sectionStart) this.cbs.ontext(this.getSection());
            this.baseState = 1 /* Text */ ;
            this._state = 62 /* BeforeEntity */ ;
            this.sectionStart = this._index;
        }
    };
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ Tokenizer.prototype.isTagStartChar = function(c) {
        return $be6b0b6487ca08e1$var$isASCIIAlpha(c) || this.xmlMode && !$be6b0b6487ca08e1$var$whitespace(c) && c !== "/" && c !== ">";
    };
    Tokenizer.prototype.stateBeforeTagName = function(c) {
        if (c === "/") this._state = 5 /* BeforeClosingTagName */ ;
        else if (c === "<") {
            this.cbs.ontext(this.getSection());
            this.sectionStart = this._index;
        } else if (c === ">" || this.special !== 1 /* None */  || $be6b0b6487ca08e1$var$whitespace(c)) this._state = 1 /* Text */ ;
        else if (c === "!") {
            this._state = 15 /* BeforeDeclaration */ ;
            this.sectionStart = this._index + 1;
        } else if (c === "?") {
            this._state = 17 /* InProcessingInstruction */ ;
            this.sectionStart = this._index + 1;
        } else if (!this.isTagStartChar(c)) this._state = 1 /* Text */ ;
        else {
            this._state = !this.xmlMode && (c === "s" || c === "S") ? 32 /* BeforeSpecialS */  : !this.xmlMode && (c === "t" || c === "T") ? 52 /* BeforeSpecialT */  : 3 /* InTagName */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInTagName = function(c) {
        if (c === "/" || c === ">" || $be6b0b6487ca08e1$var$whitespace(c)) {
            this.emitToken("onopentagname");
            this._state = 8 /* BeforeAttributeName */ ;
            this._index--;
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function(c) {
        if ($be6b0b6487ca08e1$var$whitespace(c)) ;
        else if (c === ">") this._state = 1 /* Text */ ;
        else if (this.special !== 1 /* None */ ) {
            if (this.special !== 4 /* Title */  && (c === "s" || c === "S")) this._state = 33 /* BeforeSpecialSEnd */ ;
            else if (this.special === 4 /* Title */  && (c === "t" || c === "T")) this._state = 53 /* BeforeSpecialTEnd */ ;
            else {
                this._state = 1 /* Text */ ;
                this._index--;
            }
        } else if (!this.isTagStartChar(c)) {
            this._state = 20 /* InSpecialComment */ ;
            this.sectionStart = this._index;
        } else {
            this._state = 6 /* InClosingTagName */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function(c) {
        if (c === ">" || $be6b0b6487ca08e1$var$whitespace(c)) {
            this.emitToken("onclosetag");
            this._state = 7 /* AfterClosingTagName */ ;
            this._index--;
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function(c) {
        // Skip everything until ">"
        if (c === ">") {
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function(c) {
        if (c === ">") {
            this.cbs.onopentagend();
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        } else if (c === "/") this._state = 4 /* InSelfClosingTag */ ;
        else if (!$be6b0b6487ca08e1$var$whitespace(c)) {
            this._state = 9 /* InAttributeName */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function(c) {
        if (c === ">") {
            this.cbs.onselfclosingtag();
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
            this.special = 1 /* None */ ; // Reset special state, in case of self-closing special tags
        } else if (!$be6b0b6487ca08e1$var$whitespace(c)) {
            this._state = 8 /* BeforeAttributeName */ ;
            this._index--;
        }
    };
    Tokenizer.prototype.stateInAttributeName = function(c) {
        if (c === "=" || c === "/" || c === ">" || $be6b0b6487ca08e1$var$whitespace(c)) {
            this.cbs.onattribname(this.getSection());
            this.sectionStart = -1;
            this._state = 10 /* AfterAttributeName */ ;
            this._index--;
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function(c) {
        if (c === "=") this._state = 11 /* BeforeAttributeValue */ ;
        else if (c === "/" || c === ">") {
            this.cbs.onattribend(undefined);
            this._state = 8 /* BeforeAttributeName */ ;
            this._index--;
        } else if (!$be6b0b6487ca08e1$var$whitespace(c)) {
            this.cbs.onattribend(undefined);
            this._state = 9 /* InAttributeName */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function(c) {
        if (c === '"') {
            this._state = 12 /* InAttributeValueDq */ ;
            this.sectionStart = this._index + 1;
        } else if (c === "'") {
            this._state = 13 /* InAttributeValueSq */ ;
            this.sectionStart = this._index + 1;
        } else if (!$be6b0b6487ca08e1$var$whitespace(c)) {
            this._state = 14 /* InAttributeValueNq */ ;
            this.sectionStart = this._index;
            this._index--; // Reconsume token
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function(c, quote) {
        if (c === quote) {
            this.emitToken("onattribdata");
            this.cbs.onattribend(quote);
            this._state = 8 /* BeforeAttributeName */ ;
        } else if (this.decodeEntities && c === "&") {
            this.emitToken("onattribdata");
            this.baseState = this._state;
            this._state = 62 /* BeforeEntity */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, '"');
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, "'");
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function(c) {
        if ($be6b0b6487ca08e1$var$whitespace(c) || c === ">") {
            this.emitToken("onattribdata");
            this.cbs.onattribend(null);
            this._state = 8 /* BeforeAttributeName */ ;
            this._index--;
        } else if (this.decodeEntities && c === "&") {
            this.emitToken("onattribdata");
            this.baseState = this._state;
            this._state = 62 /* BeforeEntity */ ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function(c) {
        this._state = c === "[" ? 23 /* BeforeCdata1 */  : c === "-" ? 18 /* BeforeComment */  : 16 /* InDeclaration */ ;
    };
    Tokenizer.prototype.stateInDeclaration = function(c) {
        if (c === ">") {
            this.cbs.ondeclaration(this.getSection());
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function(c) {
        if (c === ">") {
            this.cbs.onprocessinginstruction(this.getSection());
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function(c) {
        if (c === "-") {
            this._state = 19 /* InComment */ ;
            this.sectionStart = this._index + 1;
        } else this._state = 16 /* InDeclaration */ ;
    };
    Tokenizer.prototype.stateInComment = function(c) {
        if (c === "-") this._state = 21 /* AfterComment1 */ ;
    };
    Tokenizer.prototype.stateInSpecialComment = function(c) {
        if (c === ">") {
            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index));
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateAfterComment1 = function(c) {
        if (c === "-") this._state = 22 /* AfterComment2 */ ;
        else this._state = 19 /* InComment */ ;
    };
    Tokenizer.prototype.stateAfterComment2 = function(c) {
        if (c === ">") {
            // Remove 2 trailing chars
            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index - 2));
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        } else if (c !== "-") this._state = 19 /* InComment */ ;
    // Else: stay in AFTER_COMMENT_2 (`--->`)
    };
    Tokenizer.prototype.stateBeforeCdata6 = function(c) {
        if (c === "[") {
            this._state = 29 /* InCdata */ ;
            this.sectionStart = this._index + 1;
        } else {
            this._state = 16 /* InDeclaration */ ;
            this._index--;
        }
    };
    Tokenizer.prototype.stateInCdata = function(c) {
        if (c === "]") this._state = 30 /* AfterCdata1 */ ;
    };
    Tokenizer.prototype.stateAfterCdata1 = function(c) {
        if (c === "]") this._state = 31 /* AfterCdata2 */ ;
        else this._state = 29 /* InCdata */ ;
    };
    Tokenizer.prototype.stateAfterCdata2 = function(c) {
        if (c === ">") {
            // Remove 2 trailing chars
            this.cbs.oncdata(this.buffer.substring(this.sectionStart, this._index - 2));
            this._state = 1 /* Text */ ;
            this.sectionStart = this._index + 1;
        } else if (c !== "]") this._state = 29 /* InCdata */ ;
    // Else: stay in AFTER_CDATA_2 (`]]]>`)
    };
    Tokenizer.prototype.stateBeforeSpecialS = function(c) {
        if (c === "c" || c === "C") this._state = 34 /* BeforeScript1 */ ;
        else if (c === "t" || c === "T") this._state = 44 /* BeforeStyle1 */ ;
        else {
            this._state = 3 /* InTagName */ ;
            this._index--; // Consume the token again
        }
    };
    Tokenizer.prototype.stateBeforeSpecialSEnd = function(c) {
        if (this.special === 2 /* Script */  && (c === "c" || c === "C")) this._state = 39 /* AfterScript1 */ ;
        else if (this.special === 3 /* Style */  && (c === "t" || c === "T")) this._state = 48 /* AfterStyle1 */ ;
        else this._state = 1 /* Text */ ;
    };
    Tokenizer.prototype.stateBeforeSpecialLast = function(c, special) {
        if (c === "/" || c === ">" || $be6b0b6487ca08e1$var$whitespace(c)) this.special = special;
        this._state = 3 /* InTagName */ ;
        this._index--; // Consume the token again
    };
    Tokenizer.prototype.stateAfterSpecialLast = function(c, sectionStartOffset) {
        if (c === ">" || $be6b0b6487ca08e1$var$whitespace(c)) {
            this.special = 1 /* None */ ;
            this._state = 6 /* InClosingTagName */ ;
            this.sectionStart = this._index - sectionStartOffset;
            this._index--; // Reconsume the token
        } else this._state = 1 /* Text */ ;
    };
    // For entities terminated with a semicolon
    Tokenizer.prototype.parseFixedEntity = function(map) {
        if (map === void 0) map = this.xmlMode ? $be6b0b6487ca08e1$var$xml_json_1.default : $be6b0b6487ca08e1$var$entities_json_1.default;
        // Offset = 1
        if (this.sectionStart + 1 < this._index) {
            var entity = this.buffer.substring(this.sectionStart + 1, this._index);
            if (Object.prototype.hasOwnProperty.call(map, entity)) {
                this.emitPartial(map[entity]);
                this.sectionStart = this._index + 1;
            }
        }
    };
    // Parses legacy entities (without trailing semicolon)
    Tokenizer.prototype.parseLegacyEntity = function() {
        var start = this.sectionStart + 1;
        // The max length of legacy entities is 6
        var limit = Math.min(this._index - start, 6);
        while(limit >= 2){
            // The min length of legacy entities is 2
            var entity = this.buffer.substr(start, limit);
            if (Object.prototype.hasOwnProperty.call($be6b0b6487ca08e1$var$legacy_json_1.default, entity)) {
                this.emitPartial($be6b0b6487ca08e1$var$legacy_json_1.default[entity]);
                this.sectionStart += limit + 1;
                return;
            }
            limit--;
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function(c) {
        if (c === ";") {
            this.parseFixedEntity();
            // Retry as legacy entity if entity wasn't parsed
            if (this.baseState === 1 /* Text */  && this.sectionStart + 1 < this._index && !this.xmlMode) this.parseLegacyEntity();
            this._state = this.baseState;
        } else if ((c < "0" || c > "9") && !$be6b0b6487ca08e1$var$isASCIIAlpha(c)) {
            if (this.xmlMode || this.sectionStart + 1 === this._index) ;
            else if (this.baseState !== 1 /* Text */ ) {
                if (c !== "=") // Parse as legacy entity, without allowing additional characters.
                this.parseFixedEntity($be6b0b6487ca08e1$var$legacy_json_1.default);
            } else this.parseLegacyEntity();
            this._state = this.baseState;
            this._index--;
        }
    };
    Tokenizer.prototype.decodeNumericEntity = function(offset, base, strict) {
        var sectionStart = this.sectionStart + offset;
        if (sectionStart !== this._index) {
            // Parse entity
            var entity = this.buffer.substring(sectionStart, this._index);
            var parsed = parseInt(entity, base);
            this.emitPartial($be6b0b6487ca08e1$var$decode_codepoint_1.default(parsed));
            this.sectionStart = strict ? this._index + 1 : this._index;
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function(c) {
        if (c === ";") this.decodeNumericEntity(2, 10, true);
        else if (c < "0" || c > "9") {
            if (!this.xmlMode) this.decodeNumericEntity(2, 10, false);
            else this._state = this.baseState;
            this._index--;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function(c) {
        if (c === ";") this.decodeNumericEntity(3, 16, true);
        else if ((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")) {
            if (!this.xmlMode) this.decodeNumericEntity(3, 16, false);
            else this._state = this.baseState;
            this._index--;
        }
    };
    Tokenizer.prototype.cleanup = function() {
        if (this.sectionStart < 0) {
            this.buffer = "";
            this.bufferOffset += this._index;
            this._index = 0;
        } else if (this.running) {
            if (this._state === 1 /* Text */ ) {
                if (this.sectionStart !== this._index) this.cbs.ontext(this.buffer.substr(this.sectionStart));
                this.buffer = "";
                this.bufferOffset += this._index;
                this._index = 0;
            } else if (this.sectionStart === this._index) {
                // The section just started
                this.buffer = "";
                this.bufferOffset += this._index;
                this._index = 0;
            } else {
                // Remove everything unnecessary
                this.buffer = this.buffer.substr(this.sectionStart);
                this._index -= this.sectionStart;
                this.bufferOffset += this.sectionStart;
            }
            this.sectionStart = 0;
        }
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ Tokenizer.prototype.parse = function() {
        while(this._index < this.buffer.length && this.running){
            var c = this.buffer.charAt(this._index);
            if (this._state === 1 /* Text */ ) this.stateText(c);
            else if (this._state === 12 /* InAttributeValueDq */ ) this.stateInAttributeValueDoubleQuotes(c);
            else if (this._state === 9 /* InAttributeName */ ) this.stateInAttributeName(c);
            else if (this._state === 19 /* InComment */ ) this.stateInComment(c);
            else if (this._state === 20 /* InSpecialComment */ ) this.stateInSpecialComment(c);
            else if (this._state === 8 /* BeforeAttributeName */ ) this.stateBeforeAttributeName(c);
            else if (this._state === 3 /* InTagName */ ) this.stateInTagName(c);
            else if (this._state === 6 /* InClosingTagName */ ) this.stateInClosingTagName(c);
            else if (this._state === 2 /* BeforeTagName */ ) this.stateBeforeTagName(c);
            else if (this._state === 10 /* AfterAttributeName */ ) this.stateAfterAttributeName(c);
            else if (this._state === 13 /* InAttributeValueSq */ ) this.stateInAttributeValueSingleQuotes(c);
            else if (this._state === 11 /* BeforeAttributeValue */ ) this.stateBeforeAttributeValue(c);
            else if (this._state === 5 /* BeforeClosingTagName */ ) this.stateBeforeClosingTagName(c);
            else if (this._state === 7 /* AfterClosingTagName */ ) this.stateAfterClosingTagName(c);
            else if (this._state === 32 /* BeforeSpecialS */ ) this.stateBeforeSpecialS(c);
            else if (this._state === 21 /* AfterComment1 */ ) this.stateAfterComment1(c);
            else if (this._state === 14 /* InAttributeValueNq */ ) this.stateInAttributeValueNoQuotes(c);
            else if (this._state === 4 /* InSelfClosingTag */ ) this.stateInSelfClosingTag(c);
            else if (this._state === 16 /* InDeclaration */ ) this.stateInDeclaration(c);
            else if (this._state === 15 /* BeforeDeclaration */ ) this.stateBeforeDeclaration(c);
            else if (this._state === 22 /* AfterComment2 */ ) this.stateAfterComment2(c);
            else if (this._state === 18 /* BeforeComment */ ) this.stateBeforeComment(c);
            else if (this._state === 33 /* BeforeSpecialSEnd */ ) this.stateBeforeSpecialSEnd(c);
            else if (this._state === 53 /* BeforeSpecialTEnd */ ) $be6b0b6487ca08e1$var$stateAfterSpecialTEnd(this, c);
            else if (this._state === 39 /* AfterScript1 */ ) $be6b0b6487ca08e1$var$stateAfterScript1(this, c);
            else if (this._state === 40 /* AfterScript2 */ ) $be6b0b6487ca08e1$var$stateAfterScript2(this, c);
            else if (this._state === 41 /* AfterScript3 */ ) $be6b0b6487ca08e1$var$stateAfterScript3(this, c);
            else if (this._state === 34 /* BeforeScript1 */ ) $be6b0b6487ca08e1$var$stateBeforeScript1(this, c);
            else if (this._state === 35 /* BeforeScript2 */ ) $be6b0b6487ca08e1$var$stateBeforeScript2(this, c);
            else if (this._state === 36 /* BeforeScript3 */ ) $be6b0b6487ca08e1$var$stateBeforeScript3(this, c);
            else if (this._state === 37 /* BeforeScript4 */ ) $be6b0b6487ca08e1$var$stateBeforeScript4(this, c);
            else if (this._state === 38 /* BeforeScript5 */ ) this.stateBeforeSpecialLast(c, 2 /* Script */ );
            else if (this._state === 42 /* AfterScript4 */ ) $be6b0b6487ca08e1$var$stateAfterScript4(this, c);
            else if (this._state === 43 /* AfterScript5 */ ) this.stateAfterSpecialLast(c, 6);
            else if (this._state === 44 /* BeforeStyle1 */ ) $be6b0b6487ca08e1$var$stateBeforeStyle1(this, c);
            else if (this._state === 29 /* InCdata */ ) this.stateInCdata(c);
            else if (this._state === 45 /* BeforeStyle2 */ ) $be6b0b6487ca08e1$var$stateBeforeStyle2(this, c);
            else if (this._state === 46 /* BeforeStyle3 */ ) $be6b0b6487ca08e1$var$stateBeforeStyle3(this, c);
            else if (this._state === 47 /* BeforeStyle4 */ ) this.stateBeforeSpecialLast(c, 3 /* Style */ );
            else if (this._state === 48 /* AfterStyle1 */ ) $be6b0b6487ca08e1$var$stateAfterStyle1(this, c);
            else if (this._state === 49 /* AfterStyle2 */ ) $be6b0b6487ca08e1$var$stateAfterStyle2(this, c);
            else if (this._state === 50 /* AfterStyle3 */ ) $be6b0b6487ca08e1$var$stateAfterStyle3(this, c);
            else if (this._state === 51 /* AfterStyle4 */ ) this.stateAfterSpecialLast(c, 5);
            else if (this._state === 52 /* BeforeSpecialT */ ) $be6b0b6487ca08e1$var$stateBeforeSpecialT(this, c);
            else if (this._state === 54 /* BeforeTitle1 */ ) $be6b0b6487ca08e1$var$stateBeforeTitle1(this, c);
            else if (this._state === 55 /* BeforeTitle2 */ ) $be6b0b6487ca08e1$var$stateBeforeTitle2(this, c);
            else if (this._state === 56 /* BeforeTitle3 */ ) $be6b0b6487ca08e1$var$stateBeforeTitle3(this, c);
            else if (this._state === 57 /* BeforeTitle4 */ ) this.stateBeforeSpecialLast(c, 4 /* Title */ );
            else if (this._state === 58 /* AfterTitle1 */ ) $be6b0b6487ca08e1$var$stateAfterTitle1(this, c);
            else if (this._state === 59 /* AfterTitle2 */ ) $be6b0b6487ca08e1$var$stateAfterTitle2(this, c);
            else if (this._state === 60 /* AfterTitle3 */ ) $be6b0b6487ca08e1$var$stateAfterTitle3(this, c);
            else if (this._state === 61 /* AfterTitle4 */ ) this.stateAfterSpecialLast(c, 5);
            else if (this._state === 17 /* InProcessingInstruction */ ) this.stateInProcessingInstruction(c);
            else if (this._state === 64 /* InNamedEntity */ ) this.stateInNamedEntity(c);
            else if (this._state === 23 /* BeforeCdata1 */ ) $be6b0b6487ca08e1$var$stateBeforeCdata1(this, c);
            else if (this._state === 62 /* BeforeEntity */ ) $be6b0b6487ca08e1$var$stateBeforeEntity(this, c);
            else if (this._state === 24 /* BeforeCdata2 */ ) $be6b0b6487ca08e1$var$stateBeforeCdata2(this, c);
            else if (this._state === 25 /* BeforeCdata3 */ ) $be6b0b6487ca08e1$var$stateBeforeCdata3(this, c);
            else if (this._state === 30 /* AfterCdata1 */ ) this.stateAfterCdata1(c);
            else if (this._state === 31 /* AfterCdata2 */ ) this.stateAfterCdata2(c);
            else if (this._state === 26 /* BeforeCdata4 */ ) $be6b0b6487ca08e1$var$stateBeforeCdata4(this, c);
            else if (this._state === 27 /* BeforeCdata5 */ ) $be6b0b6487ca08e1$var$stateBeforeCdata5(this, c);
            else if (this._state === 28 /* BeforeCdata6 */ ) this.stateBeforeCdata6(c);
            else if (this._state === 66 /* InHexEntity */ ) this.stateInHexEntity(c);
            else if (this._state === 65 /* InNumericEntity */ ) this.stateInNumericEntity(c);
            else if (this._state === 63 /* BeforeNumericEntity */ ) $be6b0b6487ca08e1$var$stateBeforeNumericEntity(this, c);
            else this.cbs.onerror(Error("unknown _state"), this._state);
            this._index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function() {
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this._index) this.handleTrailingData();
        this.cbs.onend();
    };
    Tokenizer.prototype.handleTrailingData = function() {
        var data = this.buffer.substr(this.sectionStart);
        if (this._state === 29 /* InCdata */  || this._state === 30 /* AfterCdata1 */  || this._state === 31 /* AfterCdata2 */ ) this.cbs.oncdata(data);
        else if (this._state === 19 /* InComment */  || this._state === 21 /* AfterComment1 */  || this._state === 22 /* AfterComment2 */ ) this.cbs.oncomment(data);
        else if (this._state === 64 /* InNamedEntity */  && !this.xmlMode) {
            this.parseLegacyEntity();
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        } else if (this._state === 65 /* InNumericEntity */  && !this.xmlMode) {
            this.decodeNumericEntity(2, 10, false);
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        } else if (this._state === 66 /* InHexEntity */  && !this.xmlMode) {
            this.decodeNumericEntity(3, 16, false);
            if (this.sectionStart < this._index) {
                this._state = this.baseState;
                this.handleTrailingData();
            }
        } else if (this._state !== 3 /* InTagName */  && this._state !== 8 /* BeforeAttributeName */  && this._state !== 11 /* BeforeAttributeValue */  && this._state !== 10 /* AfterAttributeName */  && this._state !== 9 /* InAttributeName */  && this._state !== 13 /* InAttributeValueSq */  && this._state !== 12 /* InAttributeValueDq */  && this._state !== 14 /* InAttributeValueNq */  && this._state !== 6 /* InClosingTagName */ ) this.cbs.ontext(data);
    /*
         * Else, ignore remaining data
         * TODO add a way to remove current tag
         */ };
    Tokenizer.prototype.getSection = function() {
        return this.buffer.substring(this.sectionStart, this._index);
    };
    Tokenizer.prototype.emitToken = function(name) {
        this.cbs[name](this.getSection());
        this.sectionStart = -1;
    };
    Tokenizer.prototype.emitPartial = function(value) {
        if (this.baseState !== 1 /* Text */ ) this.cbs.onattribdata(value); // TODO implement the new event
        else this.cbs.ontext(value);
    };
    return Tokenizer;
}();
module.exports.default = $be6b0b6487ca08e1$var$Tokenizer;

});
parcelRegister("di1Xh", function(module, exports) {
"use strict";
var $9ace7908449a200d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ace7908449a200d$var$decode_json_1 = $9ace7908449a200d$var$__importDefault((parcelRequire("a4jXN")));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var $9ace7908449a200d$var$fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint || function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $9ace7908449a200d$var$decodeCodePoint(codePoint) {
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return "\uFFFD";
    if (codePoint in $9ace7908449a200d$var$decode_json_1.default) codePoint = $9ace7908449a200d$var$decode_json_1.default[codePoint];
    return $9ace7908449a200d$var$fromCodePoint(codePoint);
}
module.exports.default = $9ace7908449a200d$var$decodeCodePoint;

});
parcelRegister("a4jXN", function(module, exports) {
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

});


parcelRegister("8XT1w", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});

parcelRegister("eDiqq", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","AElig":"\xc6","aelig":"\xe6","Agrave":"\xc0","agrave":"\xe0","amp":"&","AMP":"&","Aring":"\xc5","aring":"\xe5","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","brvbar":"\xa6","Ccedil":"\xc7","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","COPY":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","Eacute":"\xc9","eacute":"\xe9","Ecirc":"\xca","ecirc":"\xea","Egrave":"\xc8","egrave":"\xe8","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","GT":">","Iacute":"\xcd","iacute":"\xed","Icirc":"\xce","icirc":"\xee","iexcl":"\xa1","Igrave":"\xcc","igrave":"\xec","iquest":"\xbf","Iuml":"\xcf","iuml":"\xef","laquo":"\xab","lt":"<","LT":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","Ntilde":"\xd1","ntilde":"\xf1","Oacute":"\xd3","oacute":"\xf3","Ocirc":"\xd4","ocirc":"\xf4","Ograve":"\xd2","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","Oslash":"\xd8","oslash":"\xf8","Otilde":"\xd5","otilde":"\xf5","Ouml":"\xd6","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","QUOT":"\\"","raquo":"\xbb","reg":"\xae","REG":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","THORN":"\xde","thorn":"\xfe","times":"\xd7","Uacute":"\xda","uacute":"\xfa","Ucirc":"\xdb","ucirc":"\xfb","Ugrave":"\xd9","ugrave":"\xf9","uml":"\xa8","Uuml":"\xdc","uuml":"\xfc","Yacute":"\xdd","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');

});

parcelRegister("72Wkn", function(module, exports) {
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

});



parcelRegister("5xCYr", function(module, exports) {
"use strict";
var $408e4439531de5ea$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $408e4439531de5ea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $408e4439531de5ea$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $408e4439531de5ea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $408e4439531de5ea$var$__createBinding(result, mod, k);
    }
    $408e4439531de5ea$var$__setModuleDefault(result, mod);
    return result;
};
var $408e4439531de5ea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseFeed = module.exports.FeedHandler = void 0;

var $408e4439531de5ea$var$domhandler_1 = $408e4439531de5ea$var$__importDefault((parcelRequire("cAP9v")));

var $408e4439531de5ea$var$DomUtils = $408e4439531de5ea$var$__importStar((parcelRequire("aLus5")));

var $enYrI = parcelRequire("enYrI");
var $408e4439531de5ea$var$FeedItemMediaMedium;
(function(FeedItemMediaMedium) {
    FeedItemMediaMedium[FeedItemMediaMedium["image"] = 0] = "image";
    FeedItemMediaMedium[FeedItemMediaMedium["audio"] = 1] = "audio";
    FeedItemMediaMedium[FeedItemMediaMedium["video"] = 2] = "video";
    FeedItemMediaMedium[FeedItemMediaMedium["document"] = 3] = "document";
    FeedItemMediaMedium[FeedItemMediaMedium["executable"] = 4] = "executable";
})($408e4439531de5ea$var$FeedItemMediaMedium || ($408e4439531de5ea$var$FeedItemMediaMedium = {}));
var $408e4439531de5ea$var$FeedItemMediaExpression;
(function(FeedItemMediaExpression) {
    FeedItemMediaExpression[FeedItemMediaExpression["sample"] = 0] = "sample";
    FeedItemMediaExpression[FeedItemMediaExpression["full"] = 1] = "full";
    FeedItemMediaExpression[FeedItemMediaExpression["nonstop"] = 2] = "nonstop";
})($408e4439531de5ea$var$FeedItemMediaExpression || ($408e4439531de5ea$var$FeedItemMediaExpression = {}));
// TODO: Consume data as it is coming in
var $408e4439531de5ea$var$FeedHandler = /** @class */ function(_super) {
    $408e4439531de5ea$var$__extends(FeedHandler, _super);
    /**
     *
     * @param callback
     * @param options
     */ function FeedHandler(callback, options) {
        var _this = this;
        if (typeof callback === "object") {
            callback = undefined;
            options = callback;
        }
        _this = _super.call(this, callback, options) || this;
        return _this;
    }
    FeedHandler.prototype.onend = function() {
        var _a, _b;
        var feedRoot = $408e4439531de5ea$var$getOneElement($408e4439531de5ea$var$isValidFeed, this.dom);
        if (!feedRoot) {
            this.handleCallback(new Error("couldn't find root of feed"));
            return;
        }
        var feed = {};
        if (feedRoot.name === "feed") {
            var childs = feedRoot.children;
            feed.type = "atom";
            $408e4439531de5ea$var$addConditionally(feed, "id", "id", childs);
            $408e4439531de5ea$var$addConditionally(feed, "title", "title", childs);
            var href = $408e4439531de5ea$var$getAttribute("href", $408e4439531de5ea$var$getOneElement("link", childs));
            if (href) feed.link = href;
            $408e4439531de5ea$var$addConditionally(feed, "description", "subtitle", childs);
            var updated = $408e4439531de5ea$var$fetch("updated", childs);
            if (updated) feed.updated = new Date(updated);
            $408e4439531de5ea$var$addConditionally(feed, "author", "email", childs, true);
            feed.items = $408e4439531de5ea$var$getElements("entry", childs).map(function(item) {
                var entry = {};
                var children = item.children;
                $408e4439531de5ea$var$addConditionally(entry, "id", "id", children);
                $408e4439531de5ea$var$addConditionally(entry, "title", "title", children);
                var href = $408e4439531de5ea$var$getAttribute("href", $408e4439531de5ea$var$getOneElement("link", children));
                if (href) entry.link = href;
                var description = $408e4439531de5ea$var$fetch("summary", children) || $408e4439531de5ea$var$fetch("content", children);
                if (description) entry.description = description;
                var pubDate = $408e4439531de5ea$var$fetch("updated", children);
                if (pubDate) entry.pubDate = new Date(pubDate);
                entry.media = $408e4439531de5ea$var$getMediaElements(children);
                return entry;
            });
        } else {
            var childs = (_b = (_a = $408e4439531de5ea$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            $408e4439531de5ea$var$addConditionally(feed, "title", "title", childs);
            $408e4439531de5ea$var$addConditionally(feed, "link", "link", childs);
            $408e4439531de5ea$var$addConditionally(feed, "description", "description", childs);
            var updated = $408e4439531de5ea$var$fetch("lastBuildDate", childs);
            if (updated) feed.updated = new Date(updated);
            $408e4439531de5ea$var$addConditionally(feed, "author", "managingEditor", childs, true);
            feed.items = $408e4439531de5ea$var$getElements("item", feedRoot.children).map(function(item) {
                var entry = {};
                var children = item.children;
                $408e4439531de5ea$var$addConditionally(entry, "id", "guid", children);
                $408e4439531de5ea$var$addConditionally(entry, "title", "title", children);
                $408e4439531de5ea$var$addConditionally(entry, "link", "link", children);
                $408e4439531de5ea$var$addConditionally(entry, "description", "description", children);
                var pubDate = $408e4439531de5ea$var$fetch("pubDate", children);
                if (pubDate) entry.pubDate = new Date(pubDate);
                entry.media = $408e4439531de5ea$var$getMediaElements(children);
                return entry;
            });
        }
        this.feed = feed;
        this.handleCallback(null);
    };
    return FeedHandler;
}($408e4439531de5ea$var$domhandler_1.default);
module.exports.FeedHandler = $408e4439531de5ea$var$FeedHandler;
function $408e4439531de5ea$var$getMediaElements(where) {
    return $408e4439531de5ea$var$getElements("media:content", where).map(function(elem) {
        var media = {
            medium: elem.attribs.medium,
            isDefault: !!elem.attribs.isDefault
        };
        if (elem.attribs.url) media.url = elem.attribs.url;
        if (elem.attribs.fileSize) media.fileSize = parseInt(elem.attribs.fileSize, 10);
        if (elem.attribs.type) media.type = elem.attribs.type;
        if (elem.attribs.expression) media.expression = elem.attribs.expression;
        if (elem.attribs.bitrate) media.bitrate = parseInt(elem.attribs.bitrate, 10);
        if (elem.attribs.framerate) media.framerate = parseInt(elem.attribs.framerate, 10);
        if (elem.attribs.samplingrate) media.samplingrate = parseInt(elem.attribs.samplingrate, 10);
        if (elem.attribs.channels) media.channels = parseInt(elem.attribs.channels, 10);
        if (elem.attribs.duration) media.duration = parseInt(elem.attribs.duration, 10);
        if (elem.attribs.height) media.height = parseInt(elem.attribs.height, 10);
        if (elem.attribs.width) media.width = parseInt(elem.attribs.width, 10);
        if (elem.attribs.lang) media.lang = elem.attribs.lang;
        return media;
    });
}
function $408e4439531de5ea$var$getElements(tagName, where) {
    return $408e4439531de5ea$var$DomUtils.getElementsByTagName(tagName, where, true);
}
function $408e4439531de5ea$var$getOneElement(tagName, node) {
    return $408e4439531de5ea$var$DomUtils.getElementsByTagName(tagName, node, true, 1)[0];
}
function $408e4439531de5ea$var$fetch(tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    return $408e4439531de5ea$var$DomUtils.getText($408e4439531de5ea$var$DomUtils.getElementsByTagName(tagName, where, recurse, 1)).trim();
}
function $408e4439531de5ea$var$getAttribute(name, elem) {
    if (!elem) return null;
    var attribs = elem.attribs;
    return attribs[name];
}
function $408e4439531de5ea$var$addConditionally(obj, prop, what, where, recurse) {
    if (recurse === void 0) recurse = false;
    var tmp = $408e4439531de5ea$var$fetch(what, where, recurse);
    if (tmp) obj[prop] = tmp;
}
function $408e4439531de5ea$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this option, you should set `xmlMode` to `true`.
 */ function $408e4439531de5ea$var$parseFeed(feed, options) {
    if (options === void 0) options = {
        xmlMode: true
    };
    var handler = new $408e4439531de5ea$var$FeedHandler(options);
    new $enYrI.Parser(handler, options).end(feed);
    return handler.feed;
}
module.exports.parseFeed = $408e4439531de5ea$var$parseFeed;

});
parcelRegister("aLus5", function(module, exports) {
"use strict";
var $7d65ea50c04d7ee2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d65ea50c04d7ee2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7d65ea50c04d7ee2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasChildren = module.exports.isDocument = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = void 0;

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("kl7Jx")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("lRy5A")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("INJXT")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("l4cWI")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("hQmng")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("cQsBa")), module.exports);

$7d65ea50c04d7ee2$var$__exportStar((parcelRequire("YX4Yk")), module.exports);

var $cAP9v = parcelRequire("cAP9v");
Object.defineProperty(module.exports, "isTag", {
    enumerable: true,
    get: function() {
        return $cAP9v.isTag;
    }
});
Object.defineProperty(module.exports, "isCDATA", {
    enumerable: true,
    get: function() {
        return $cAP9v.isCDATA;
    }
});
Object.defineProperty(module.exports, "isText", {
    enumerable: true,
    get: function() {
        return $cAP9v.isText;
    }
});
Object.defineProperty(module.exports, "isComment", {
    enumerable: true,
    get: function() {
        return $cAP9v.isComment;
    }
});
Object.defineProperty(module.exports, "isDocument", {
    enumerable: true,
    get: function() {
        return $cAP9v.isDocument;
    }
});
Object.defineProperty(module.exports, "hasChildren", {
    enumerable: true,
    get: function() {
        return $cAP9v.hasChildren;
    }
});

});
parcelRegister("kl7Jx", function(module, exports) {
"use strict";
var $ecebc482f234f65c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.innerText = module.exports.textContent = module.exports.getText = module.exports.getInnerHTML = module.exports.getOuterHTML = void 0;

var $cAP9v = parcelRequire("cAP9v");

var $ecebc482f234f65c$var$dom_serializer_1 = $ecebc482f234f65c$var$__importDefault((parcelRequire("kD1kK")));

var $lbVaC = parcelRequire("lbVaC");
/**
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s outer HTML.
 */ function $ecebc482f234f65c$var$getOuterHTML(node, options) {
    return (0, $ecebc482f234f65c$var$dom_serializer_1.default)(node, options);
}
module.exports.getOuterHTML = $ecebc482f234f65c$var$getOuterHTML;
/**
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s inner HTML.
 */ function $ecebc482f234f65c$var$getInnerHTML(node, options) {
    return (0, $cAP9v.hasChildren)(node) ? node.children.map(function(node) {
        return $ecebc482f234f65c$var$getOuterHTML(node, options);
    }).join("") : "";
}
module.exports.getInnerHTML = $ecebc482f234f65c$var$getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags.
 *
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */ function $ecebc482f234f65c$var$getText(node) {
    if (Array.isArray(node)) return node.map($ecebc482f234f65c$var$getText).join("");
    if ((0, $cAP9v.isTag)(node)) return node.name === "br" ? "\n" : $ecebc482f234f65c$var$getText(node.children);
    if ((0, $cAP9v.isCDATA)(node)) return $ecebc482f234f65c$var$getText(node.children);
    if ((0, $cAP9v.isText)(node)) return node.data;
    return "";
}
module.exports.getText = $ecebc482f234f65c$var$getText;
/**
 * Get a node's text content.
 *
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */ function $ecebc482f234f65c$var$textContent(node) {
    if (Array.isArray(node)) return node.map($ecebc482f234f65c$var$textContent).join("");
    if ((0, $cAP9v.hasChildren)(node) && !(0, $cAP9v.isComment)(node)) return $ecebc482f234f65c$var$textContent(node.children);
    if ((0, $cAP9v.isText)(node)) return node.data;
    return "";
}
module.exports.textContent = $ecebc482f234f65c$var$textContent;
/**
 * Get a node's inner text.
 *
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */ function $ecebc482f234f65c$var$innerText(node) {
    if (Array.isArray(node)) return node.map($ecebc482f234f65c$var$innerText).join("");
    if ((0, $cAP9v.hasChildren)(node) && (node.type === $lbVaC.ElementType.Tag || (0, $cAP9v.isCDATA)(node))) return $ecebc482f234f65c$var$innerText(node.children);
    if ((0, $cAP9v.isText)(node)) return node.data;
    return "";
}
module.exports.innerText = $ecebc482f234f65c$var$innerText;

});
parcelRegister("kD1kK", function(module, exports) {
"use strict";
var $f0487bfc15aca4fa$var$__assign = module.exports && module.exports.__assign || function() {
    $f0487bfc15aca4fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0487bfc15aca4fa$var$__assign.apply(this, arguments);
};
var $f0487bfc15aca4fa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0487bfc15aca4fa$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f0487bfc15aca4fa$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f0487bfc15aca4fa$var$__createBinding(result, mod, k);
    }
    $f0487bfc15aca4fa$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/*
 * Module dependencies
 */ var $f0487bfc15aca4fa$var$ElementType = $f0487bfc15aca4fa$var$__importStar((parcelRequire("lbVaC")));

var $fFRWn = parcelRequire("fFRWn");

var $hhPsd = parcelRequire("hhPsd");
var $f0487bfc15aca4fa$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
/**
 * Format attributes
 */ function $f0487bfc15aca4fa$var$formatAttributes(attributes, opts) {
    if (!attributes) return;
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = $hhPsd.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return key + '="' + (opts.decodeEntities !== false ? $fFRWn.encodeXML(value) : value.replace(/"/g, "&quot;")) + '"';
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $f0487bfc15aca4fa$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */ function $f0487bfc15aca4fa$var$render(node, options) {
    if (options === void 0) options = {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $f0487bfc15aca4fa$var$renderNode(nodes[i], options);
    return output;
}
module.exports.default = $f0487bfc15aca4fa$var$render;
function $f0487bfc15aca4fa$var$renderNode(node, options) {
    switch(node.type){
        case $f0487bfc15aca4fa$var$ElementType.Root:
            return $f0487bfc15aca4fa$var$render(node.children, options);
        case $f0487bfc15aca4fa$var$ElementType.Directive:
        case $f0487bfc15aca4fa$var$ElementType.Doctype:
            return $f0487bfc15aca4fa$var$renderDirective(node);
        case $f0487bfc15aca4fa$var$ElementType.Comment:
            return $f0487bfc15aca4fa$var$renderComment(node);
        case $f0487bfc15aca4fa$var$ElementType.CDATA:
            return $f0487bfc15aca4fa$var$renderCdata(node);
        case $f0487bfc15aca4fa$var$ElementType.Script:
        case $f0487bfc15aca4fa$var$ElementType.Style:
        case $f0487bfc15aca4fa$var$ElementType.Tag:
            return $f0487bfc15aca4fa$var$renderTag(node, options);
        case $f0487bfc15aca4fa$var$ElementType.Text:
            return $f0487bfc15aca4fa$var$renderText(node, options);
    }
}
var $f0487bfc15aca4fa$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $f0487bfc15aca4fa$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $f0487bfc15aca4fa$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = $hhPsd.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $f0487bfc15aca4fa$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = $f0487bfc15aca4fa$var$__assign($f0487bfc15aca4fa$var$__assign({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $f0487bfc15aca4fa$var$foreignElements.has(elem.name)) opts = $f0487bfc15aca4fa$var$__assign($f0487bfc15aca4fa$var$__assign({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<" + elem.name;
    var attribs = $f0487bfc15aca4fa$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " " + attribs;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $f0487bfc15aca4fa$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $f0487bfc15aca4fa$var$render(elem.children, opts);
        if (opts.xmlMode || !$f0487bfc15aca4fa$var$singleTag.has(elem.name)) tag += "</" + elem.name + ">";
    }
    return tag;
}
function $f0487bfc15aca4fa$var$renderDirective(elem) {
    return "<" + elem.data + ">";
}
function $f0487bfc15aca4fa$var$renderText(elem, opts) {
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (opts.decodeEntities !== false && !(!opts.xmlMode && elem.parent && $f0487bfc15aca4fa$var$unencodedElements.has(elem.parent.name))) data = $fFRWn.encodeXML(data);
    return data;
}
function $f0487bfc15aca4fa$var$renderCdata(elem) {
    return "<![CDATA[" + elem.children[0].data + "]]>";
}
function $f0487bfc15aca4fa$var$renderComment(elem) {
    return "<!--" + elem.data + "-->";
}

});
parcelRegister("fFRWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXMLStrict = module.exports.decodeHTML5Strict = module.exports.decodeHTML4Strict = module.exports.decodeHTML5 = module.exports.decodeHTML4 = module.exports.decodeHTMLStrict = module.exports.decodeHTML = module.exports.decodeXML = module.exports.encodeHTML5 = module.exports.encodeHTML4 = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = module.exports.encodeXML = module.exports.encode = module.exports.decodeStrict = module.exports.decode = void 0;

var $kEoRT = parcelRequire("kEoRT");

var $8QTFQ = parcelRequire("8QTFQ");
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */ function $b69486d61ff12cd5$var$decode(data, level) {
    return (!level || level <= 0 ? $kEoRT.decodeXML : $kEoRT.decodeHTML)(data);
}
module.exports.decode = $b69486d61ff12cd5$var$decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */ function $b69486d61ff12cd5$var$decodeStrict(data, level) {
    return (!level || level <= 0 ? $kEoRT.decodeXML : $kEoRT.decodeHTMLStrict)(data);
}
module.exports.decodeStrict = $b69486d61ff12cd5$var$decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */ function $b69486d61ff12cd5$var$encode(data, level) {
    return (!level || level <= 0 ? $8QTFQ.encodeXML : $8QTFQ.encodeHTML)(data);
}
module.exports.encode = $b69486d61ff12cd5$var$encode;

var $8QTFQ = parcelRequire("8QTFQ");
Object.defineProperty(module.exports, "encodeXML", {
    enumerable: true,
    get: function() {
        return $8QTFQ.encodeXML;
    }
});
Object.defineProperty(module.exports, "encodeHTML", {
    enumerable: true,
    get: function() {
        return $8QTFQ.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
        return $8QTFQ.encodeNonAsciiHTML;
    }
});
Object.defineProperty(module.exports, "escape", {
    enumerable: true,
    get: function() {
        return $8QTFQ.escape;
    }
});
Object.defineProperty(module.exports, "escapeUTF8", {
    enumerable: true,
    get: function() {
        return $8QTFQ.escapeUTF8;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "encodeHTML4", {
    enumerable: true,
    get: function() {
        return $8QTFQ.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeHTML5", {
    enumerable: true,
    get: function() {
        return $8QTFQ.encodeHTML;
    }
});

var $kEoRT = parcelRequire("kEoRT");
Object.defineProperty(module.exports, "decodeXML", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeXML;
    }
});
Object.defineProperty(module.exports, "decodeHTML", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTMLStrict;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "decodeHTML4", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML5", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
        return $kEoRT.decodeXML;
    }
});

});
parcelRegister("kEoRT", function(module, exports) {
"use strict";
var $f08ad55f7f1ae931$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeHTML = module.exports.decodeHTMLStrict = module.exports.decodeXML = void 0;

var $f08ad55f7f1ae931$var$entities_json_1 = $f08ad55f7f1ae931$var$__importDefault((parcelRequire("8XT1w")));

var $f08ad55f7f1ae931$var$legacy_json_1 = $f08ad55f7f1ae931$var$__importDefault((parcelRequire("eDiqq")));

var $f08ad55f7f1ae931$var$xml_json_1 = $f08ad55f7f1ae931$var$__importDefault((parcelRequire("72Wkn")));

var $f08ad55f7f1ae931$var$decode_codepoint_1 = $f08ad55f7f1ae931$var$__importDefault((parcelRequire("di1Xh")));
var $f08ad55f7f1ae931$var$strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
module.exports.decodeXML = $f08ad55f7f1ae931$var$getStrictDecoder($f08ad55f7f1ae931$var$xml_json_1.default);
module.exports.decodeHTMLStrict = $f08ad55f7f1ae931$var$getStrictDecoder($f08ad55f7f1ae931$var$entities_json_1.default);
function $f08ad55f7f1ae931$var$getStrictDecoder(map) {
    var replace = $f08ad55f7f1ae931$var$getReplacer(map);
    return function(str) {
        return String(str).replace($f08ad55f7f1ae931$var$strictEntityRe, replace);
    };
}
var $f08ad55f7f1ae931$var$sorter = function(a, b) {
    return a < b ? 1 : -1;
};
module.exports.decodeHTML = function() {
    var legacy = Object.keys($f08ad55f7f1ae931$var$legacy_json_1.default).sort($f08ad55f7f1ae931$var$sorter);
    var keys = Object.keys($f08ad55f7f1ae931$var$entities_json_1.default).sort($f08ad55f7f1ae931$var$sorter);
    for(var i = 0, j = 0; i < keys.length; i++)if (legacy[j] === keys[i]) {
        keys[i] += ";?";
        j++;
    } else keys[i] += ";";
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = $f08ad55f7f1ae931$var$getReplacer($f08ad55f7f1ae931$var$entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
}();
function $f08ad55f7f1ae931$var$getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") return $f08ad55f7f1ae931$var$decode_codepoint_1.default(parseInt(str.substr(3), 16));
            return $f08ad55f7f1ae931$var$decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}

});

parcelRegister("8QTFQ", function(module, exports) {
"use strict";
var $671e5dc2f4d817cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = module.exports.encodeXML = void 0;

var $671e5dc2f4d817cb$var$xml_json_1 = $671e5dc2f4d817cb$var$__importDefault((parcelRequire("72Wkn")));
var $671e5dc2f4d817cb$var$inverseXML = $671e5dc2f4d817cb$var$getInverseObj($671e5dc2f4d817cb$var$xml_json_1.default);
var $671e5dc2f4d817cb$var$xmlReplacer = $671e5dc2f4d817cb$var$getInverseReplacer($671e5dc2f4d817cb$var$inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ module.exports.encodeXML = $671e5dc2f4d817cb$var$getASCIIEncoder($671e5dc2f4d817cb$var$inverseXML);

var $671e5dc2f4d817cb$var$entities_json_1 = $671e5dc2f4d817cb$var$__importDefault((parcelRequire("8XT1w")));
var $671e5dc2f4d817cb$var$inverseHTML = $671e5dc2f4d817cb$var$getInverseObj($671e5dc2f4d817cb$var$entities_json_1.default);
var $671e5dc2f4d817cb$var$htmlReplacer = $671e5dc2f4d817cb$var$getInverseReplacer($671e5dc2f4d817cb$var$inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ module.exports.encodeHTML = $671e5dc2f4d817cb$var$getInverse($671e5dc2f4d817cb$var$inverseHTML, $671e5dc2f4d817cb$var$htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ module.exports.encodeNonAsciiHTML = $671e5dc2f4d817cb$var$getASCIIEncoder($671e5dc2f4d817cb$var$inverseHTML);
function $671e5dc2f4d817cb$var$getInverseObj(obj) {
    return Object.keys(obj).sort().reduce(function(inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function $671e5dc2f4d817cb$var$getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for(var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++){
        var k = _a[_i];
        if (k.length === 1) // Add value to single array
        single.push("\\" + k);
        else // Add value to multiple array
        multiple.push(k);
    }
    // Add ranges to single characters.
    single.sort();
    for(var start = 0; start < single.length - 1; start++){
        // Find the end of a run of characters
        var end = start;
        while(end < single.length - 1 && single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1))end += 1;
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3) continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var $671e5dc2f4d817cb$var$reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var $671e5dc2f4d817cb$var$getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str) {
    return str.codePointAt(0);
} : function(c) {
    return (c.charCodeAt(0) - 0xd800) * 0x400 + c.charCodeAt(1) - 0xdc00 + 0x10000;
};
function $671e5dc2f4d817cb$var$singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? $671e5dc2f4d817cb$var$getCodePoint(c) : c.charCodeAt(0)).toString(16).toUpperCase() + ";";
}
function $671e5dc2f4d817cb$var$getInverse(inverse, re) {
    return function(data) {
        return data.replace(re, function(name) {
            return inverse[name];
        }).replace($671e5dc2f4d817cb$var$reNonASCII, $671e5dc2f4d817cb$var$singleCharReplacer);
    };
}
var $671e5dc2f4d817cb$var$reEscapeChars = new RegExp($671e5dc2f4d817cb$var$xmlReplacer.source + "|" + $671e5dc2f4d817cb$var$reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ function $671e5dc2f4d817cb$var$escape(data) {
    return data.replace($671e5dc2f4d817cb$var$reEscapeChars, $671e5dc2f4d817cb$var$singleCharReplacer);
}
module.exports.escape = $671e5dc2f4d817cb$var$escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ function $671e5dc2f4d817cb$var$escapeUTF8(data) {
    return data.replace($671e5dc2f4d817cb$var$xmlReplacer, $671e5dc2f4d817cb$var$singleCharReplacer);
}
module.exports.escapeUTF8 = $671e5dc2f4d817cb$var$escapeUTF8;
function $671e5dc2f4d817cb$var$getASCIIEncoder(obj) {
    return function(data) {
        return data.replace($671e5dc2f4d817cb$var$reEscapeChars, function(c) {
            return obj[c] || $671e5dc2f4d817cb$var$singleCharReplacer(c);
        });
    };
}

});


parcelRegister("hhPsd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attributeNames = module.exports.elementNames = void 0;
module.exports.elementNames = new Map([
    [
        "altglyph",
        "altGlyph"
    ],
    [
        "altglyphdef",
        "altGlyphDef"
    ],
    [
        "altglyphitem",
        "altGlyphItem"
    ],
    [
        "animatecolor",
        "animateColor"
    ],
    [
        "animatemotion",
        "animateMotion"
    ],
    [
        "animatetransform",
        "animateTransform"
    ],
    [
        "clippath",
        "clipPath"
    ],
    [
        "feblend",
        "feBlend"
    ],
    [
        "fecolormatrix",
        "feColorMatrix"
    ],
    [
        "fecomponenttransfer",
        "feComponentTransfer"
    ],
    [
        "fecomposite",
        "feComposite"
    ],
    [
        "feconvolvematrix",
        "feConvolveMatrix"
    ],
    [
        "fediffuselighting",
        "feDiffuseLighting"
    ],
    [
        "fedisplacementmap",
        "feDisplacementMap"
    ],
    [
        "fedistantlight",
        "feDistantLight"
    ],
    [
        "fedropshadow",
        "feDropShadow"
    ],
    [
        "feflood",
        "feFlood"
    ],
    [
        "fefunca",
        "feFuncA"
    ],
    [
        "fefuncb",
        "feFuncB"
    ],
    [
        "fefuncg",
        "feFuncG"
    ],
    [
        "fefuncr",
        "feFuncR"
    ],
    [
        "fegaussianblur",
        "feGaussianBlur"
    ],
    [
        "feimage",
        "feImage"
    ],
    [
        "femerge",
        "feMerge"
    ],
    [
        "femergenode",
        "feMergeNode"
    ],
    [
        "femorphology",
        "feMorphology"
    ],
    [
        "feoffset",
        "feOffset"
    ],
    [
        "fepointlight",
        "fePointLight"
    ],
    [
        "fespecularlighting",
        "feSpecularLighting"
    ],
    [
        "fespotlight",
        "feSpotLight"
    ],
    [
        "fetile",
        "feTile"
    ],
    [
        "feturbulence",
        "feTurbulence"
    ],
    [
        "foreignobject",
        "foreignObject"
    ],
    [
        "glyphref",
        "glyphRef"
    ],
    [
        "lineargradient",
        "linearGradient"
    ],
    [
        "radialgradient",
        "radialGradient"
    ],
    [
        "textpath",
        "textPath"
    ]
]);
module.exports.attributeNames = new Map([
    [
        "definitionurl",
        "definitionURL"
    ],
    [
        "attributename",
        "attributeName"
    ],
    [
        "attributetype",
        "attributeType"
    ],
    [
        "basefrequency",
        "baseFrequency"
    ],
    [
        "baseprofile",
        "baseProfile"
    ],
    [
        "calcmode",
        "calcMode"
    ],
    [
        "clippathunits",
        "clipPathUnits"
    ],
    [
        "diffuseconstant",
        "diffuseConstant"
    ],
    [
        "edgemode",
        "edgeMode"
    ],
    [
        "filterunits",
        "filterUnits"
    ],
    [
        "glyphref",
        "glyphRef"
    ],
    [
        "gradienttransform",
        "gradientTransform"
    ],
    [
        "gradientunits",
        "gradientUnits"
    ],
    [
        "kernelmatrix",
        "kernelMatrix"
    ],
    [
        "kernelunitlength",
        "kernelUnitLength"
    ],
    [
        "keypoints",
        "keyPoints"
    ],
    [
        "keysplines",
        "keySplines"
    ],
    [
        "keytimes",
        "keyTimes"
    ],
    [
        "lengthadjust",
        "lengthAdjust"
    ],
    [
        "limitingconeangle",
        "limitingConeAngle"
    ],
    [
        "markerheight",
        "markerHeight"
    ],
    [
        "markerunits",
        "markerUnits"
    ],
    [
        "markerwidth",
        "markerWidth"
    ],
    [
        "maskcontentunits",
        "maskContentUnits"
    ],
    [
        "maskunits",
        "maskUnits"
    ],
    [
        "numoctaves",
        "numOctaves"
    ],
    [
        "pathlength",
        "pathLength"
    ],
    [
        "patterncontentunits",
        "patternContentUnits"
    ],
    [
        "patterntransform",
        "patternTransform"
    ],
    [
        "patternunits",
        "patternUnits"
    ],
    [
        "pointsatx",
        "pointsAtX"
    ],
    [
        "pointsaty",
        "pointsAtY"
    ],
    [
        "pointsatz",
        "pointsAtZ"
    ],
    [
        "preservealpha",
        "preserveAlpha"
    ],
    [
        "preserveaspectratio",
        "preserveAspectRatio"
    ],
    [
        "primitiveunits",
        "primitiveUnits"
    ],
    [
        "refx",
        "refX"
    ],
    [
        "refy",
        "refY"
    ],
    [
        "repeatcount",
        "repeatCount"
    ],
    [
        "repeatdur",
        "repeatDur"
    ],
    [
        "requiredextensions",
        "requiredExtensions"
    ],
    [
        "requiredfeatures",
        "requiredFeatures"
    ],
    [
        "specularconstant",
        "specularConstant"
    ],
    [
        "specularexponent",
        "specularExponent"
    ],
    [
        "spreadmethod",
        "spreadMethod"
    ],
    [
        "startoffset",
        "startOffset"
    ],
    [
        "stddeviation",
        "stdDeviation"
    ],
    [
        "stitchtiles",
        "stitchTiles"
    ],
    [
        "surfacescale",
        "surfaceScale"
    ],
    [
        "systemlanguage",
        "systemLanguage"
    ],
    [
        "tablevalues",
        "tableValues"
    ],
    [
        "targetx",
        "targetX"
    ],
    [
        "targety",
        "targetY"
    ],
    [
        "textlength",
        "textLength"
    ],
    [
        "viewbox",
        "viewBox"
    ],
    [
        "viewtarget",
        "viewTarget"
    ],
    [
        "xchannelselector",
        "xChannelSelector"
    ],
    [
        "ychannelselector",
        "yChannelSelector"
    ],
    [
        "zoomandpan",
        "zoomAndPan"
    ]
]);

});



parcelRegister("lRy5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prevElementSibling = module.exports.nextElementSibling = module.exports.getName = module.exports.hasAttrib = module.exports.getAttributeValue = module.exports.getSiblings = module.exports.getParent = module.exports.getChildren = void 0;

var $cAP9v = parcelRequire("cAP9v");
var $fea8fd98c5d227b3$var$emptyArray = [];
/**
 * Get a node's children.
 *
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */ function $fea8fd98c5d227b3$var$getChildren(elem) {
    var _a;
    return (_a = elem.children) !== null && _a !== void 0 ? _a : $fea8fd98c5d227b3$var$emptyArray;
}
module.exports.getChildren = $fea8fd98c5d227b3$var$getChildren;
/**
 * Get a node's parent.
 *
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node.
 */ function $fea8fd98c5d227b3$var$getParent(elem) {
    return elem.parent || null;
}
module.exports.getParent = $fea8fd98c5d227b3$var$getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first.
 * If we don't have a parent (the element is a root node),
 * we walk the element's `prev` & `next` to get all remaining nodes.
 *
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings.
 */ function $fea8fd98c5d227b3$var$getSiblings(elem) {
    var _a, _b;
    var parent = $fea8fd98c5d227b3$var$getParent(elem);
    if (parent != null) return $fea8fd98c5d227b3$var$getChildren(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        _a = prev, prev = _a.prev;
    }
    while(next != null){
        siblings.push(next);
        _b = next, next = _b.next;
    }
    return siblings;
}
module.exports.getSiblings = $fea8fd98c5d227b3$var$getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */ function $fea8fd98c5d227b3$var$getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
module.exports.getAttributeValue = $fea8fd98c5d227b3$var$getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */ function $fea8fd98c5d227b3$var$hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
module.exports.hasAttrib = $fea8fd98c5d227b3$var$hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */ function $fea8fd98c5d227b3$var$getName(elem) {
    return elem.name;
}
module.exports.getName = $fea8fd98c5d227b3$var$getName;
/**
 * Returns the next element sibling of a node.
 *
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag.
 */ function $fea8fd98c5d227b3$var$nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while(next !== null && !(0, $cAP9v.isTag)(next))_a = next, next = _a.next;
    return next;
}
module.exports.nextElementSibling = $fea8fd98c5d227b3$var$nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag.
 */ function $fea8fd98c5d227b3$var$prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while(prev !== null && !(0, $cAP9v.isTag)(prev))_a = prev, prev = _a.prev;
    return prev;
}
module.exports.prevElementSibling = $fea8fd98c5d227b3$var$prevElementSibling;

});

parcelRegister("INJXT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepend = module.exports.prependChild = module.exports.append = module.exports.appendChild = module.exports.replaceElement = module.exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @param elem The element to be removed
 */ function $086ab193d32a8dc9$var$removeElement(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
    }
}
module.exports.removeElement = $086ab193d32a8dc9$var$removeElement;
/**
 * Replace an element in the dom
 *
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */ function $086ab193d32a8dc9$var$replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
    }
}
module.exports.replaceElement = $086ab193d32a8dc9$var$replaceElement;
/**
 * Append a child to an element.
 *
 * @param elem The element to append to.
 * @param child The element to be added as a child.
 */ function $086ab193d32a8dc9$var$appendChild(elem, child) {
    $086ab193d32a8dc9$var$removeElement(child);
    child.next = null;
    child.parent = elem;
    if (elem.children.push(child) > 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
module.exports.appendChild = $086ab193d32a8dc9$var$appendChild;
/**
 * Append an element after another.
 *
 * @param elem The element to append after.
 * @param next The element be added.
 */ function $086ab193d32a8dc9$var$append(elem, next) {
    $086ab193d32a8dc9$var$removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
module.exports.append = $086ab193d32a8dc9$var$append;
/**
 * Prepend a child to an element.
 *
 * @param elem The element to prepend before.
 * @param child The element to be added as a child.
 */ function $086ab193d32a8dc9$var$prependChild(elem, child) {
    $086ab193d32a8dc9$var$removeElement(child);
    child.parent = elem;
    child.prev = null;
    if (elem.children.unshift(child) !== 1) {
        var sibling = elem.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
module.exports.prependChild = $086ab193d32a8dc9$var$prependChild;
/**
 * Prepend an element before another.
 *
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */ function $086ab193d32a8dc9$var$prepend(elem, prev) {
    $086ab193d32a8dc9$var$removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
module.exports.prepend = $086ab193d32a8dc9$var$prepend;

});

parcelRegister("l4cWI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAll = module.exports.existsOne = module.exports.findOne = module.exports.findOneChild = module.exports.find = module.exports.filter = void 0;

var $cAP9v = parcelRequire("cAP9v");
/**
 * Search a node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $f56403822725ed9a$var$filter(test, node, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    if (!Array.isArray(node)) node = [
        node
    ];
    return $f56403822725ed9a$var$find(test, node, recurse, limit);
}
module.exports.filter = $f56403822725ed9a$var$filter;
/**
 * Search an array of node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $f56403822725ed9a$var$find(test, nodes, recurse, limit) {
    var result = [];
    for(var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++){
        var elem = nodes_1[_i];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) break;
        }
        if (recurse && (0, $cAP9v.hasChildren)(elem) && elem.children.length > 0) {
            var children = $f56403822725ed9a$var$find(test, elem.children, recurse, limit);
            result.push.apply(result, children);
            limit -= children.length;
            if (limit <= 0) break;
        }
    }
    return result;
}
module.exports.find = $f56403822725ed9a$var$find;
/**
 * Finds the first element inside of an array that matches a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 */ function $f56403822725ed9a$var$findOneChild(test, nodes) {
    return nodes.find(test);
}
module.exports.findOneChild = $f56403822725ed9a$var$findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first child node that passes `test`.
 */ function $f56403822725ed9a$var$findOne(test, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    var elem = null;
    for(var i = 0; i < nodes.length && !elem; i++){
        var checked = nodes[i];
        if (!(0, $cAP9v.isTag)(checked)) continue;
        else if (test(checked)) elem = checked;
        else if (recurse && checked.children.length > 0) elem = $f56403822725ed9a$var$findOne(test, checked.children);
    }
    return elem;
}
module.exports.findOne = $f56403822725ed9a$var$findOne;
/**
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing a test.
 */ function $f56403822725ed9a$var$existsOne(test, nodes) {
    return nodes.some(function(checked) {
        return (0, $cAP9v.isTag)(checked) && (test(checked) || checked.children.length > 0 && $f56403822725ed9a$var$existsOne(test, checked.children));
    });
}
module.exports.existsOne = $f56403822725ed9a$var$existsOne;
/**
 * Search and array of nodes and its children for nodes passing a test function.
 *
 * Same as `find`, only with less options, leading to reduced complexity.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */ function $f56403822725ed9a$var$findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter($cAP9v.isTag);
    var elem;
    while(elem = stack.shift()){
        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter($cAP9v.isTag);
        if (children && children.length > 0) stack.unshift.apply(stack, children);
        if (test(elem)) result.push(elem);
    }
    return result;
}
module.exports.findAll = $f56403822725ed9a$var$findAll;

});

parcelRegister("hQmng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getElementsByTagType = module.exports.getElementsByTagName = module.exports.getElementById = module.exports.getElements = module.exports.testElement = void 0;

var $cAP9v = parcelRequire("cAP9v");

var $l4cWI = parcelRequire("l4cWI");
var $cfd8a6118df976b6$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $cAP9v.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return $cAP9v.isTag;
        return function(elem) {
            return (0, $cAP9v.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $cAP9v.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $cAP9v.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a particular value.
 */ function $cfd8a6118df976b6$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $cAP9v.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $cAP9v.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either
 * of the input functions returns `true` for the node.
 */ function $cfd8a6118df976b6$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * @param options An object describing nodes to look for.
 * @returns A function executing all checks in `options` and returning `true`
 * if any of them match a node.
 */ function $cfd8a6118df976b6$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($cfd8a6118df976b6$var$Checks, key) ? $cfd8a6118df976b6$var$Checks[key](value) : $cfd8a6118df976b6$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($cfd8a6118df976b6$var$combineFuncs);
}
/**
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */ function $cfd8a6118df976b6$var$testElement(options, node) {
    var test = $cfd8a6118df976b6$var$compileTest(options);
    return test ? test(node) : true;
}
module.exports.testElement = $cfd8a6118df976b6$var$testElement;
/**
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */ function $cfd8a6118df976b6$var$getElements(options, nodes, recurse, limit) {
    if (limit === void 0) limit = Infinity;
    var test = $cfd8a6118df976b6$var$compileTest(options);
    return test ? (0, $l4cWI.filter)(test, nodes, recurse, limit) : [];
}
module.exports.getElements = $cfd8a6118df976b6$var$getElements;
/**
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */ function $cfd8a6118df976b6$var$getElementById(id, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $l4cWI.findOne)($cfd8a6118df976b6$var$getAttribCheck("id", id), nodes, recurse);
}
module.exports.getElementById = $cfd8a6118df976b6$var$getElementById;
/**
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */ function $cfd8a6118df976b6$var$getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $l4cWI.filter)($cfd8a6118df976b6$var$Checks.tag_name(tagName), nodes, recurse, limit);
}
module.exports.getElementsByTagName = $cfd8a6118df976b6$var$getElementsByTagName;
/**
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */ function $cfd8a6118df976b6$var$getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $l4cWI.filter)($cfd8a6118df976b6$var$Checks.tag_type(type), nodes, recurse, limit);
}
module.exports.getElementsByTagType = $cfd8a6118df976b6$var$getElementsByTagType;

});

parcelRegister("cQsBa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uniqueSort = module.exports.compareDocumentPosition = module.exports.removeSubsets = void 0;

var $cAP9v = parcelRequire("cAP9v");
/**
 * Given an array of nodes, remove any member that is contained by another.
 *
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't subtrees of each other.
 */ function $95a0866691d4c721$var$removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
module.exports.removeSubsets = $95a0866691d4c721$var$removeSubsets;
/**
 * Compare the position of one node against another node in any other document.
 * The return value is a bitmask with the following values:
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent./
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */ function $95a0866691d4c721$var$compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $cAP9v.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $cAP9v.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return 1 /* DISCONNECTED */ ;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return 20 /* CONTAINED_BY */ ;
        return 4 /* FOLLOWING */ ;
    }
    if (sharedParent === nodeA) return 10 /* CONTAINS */ ;
    return 2 /* PRECEDING */ ;
}
module.exports.compareDocumentPosition = $95a0866691d4c721$var$compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document and
 * remove any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */ function $95a0866691d4c721$var$uniqueSort(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $95a0866691d4c721$var$compareDocumentPosition(a, b);
        if (relative & 2 /* PRECEDING */ ) return -1;
        else if (relative & 4 /* FOLLOWING */ ) return 1;
        return 0;
    });
    return nodes;
}
module.exports.uniqueSort = $95a0866691d4c721$var$uniqueSort;

});

parcelRegister("YX4Yk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeed = void 0;

var $kl7Jx = parcelRequire("kl7Jx");

var $hQmng = parcelRequire("hQmng");
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */ function $0b736e9bd8550f4d$var$getFeed(doc) {
    var feedRoot = $0b736e9bd8550f4d$var$getOneElement($0b736e9bd8550f4d$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $0b736e9bd8550f4d$var$getAtomFeed(feedRoot) : $0b736e9bd8550f4d$var$getRssFeed(feedRoot);
}
module.exports.getFeed = $0b736e9bd8550f4d$var$getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $0b736e9bd8550f4d$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $hQmng.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $0b736e9bd8550f4d$var$getMediaElements(children)
            };
            $0b736e9bd8550f4d$var$addConditionally(entry, "id", "id", children);
            $0b736e9bd8550f4d$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $0b736e9bd8550f4d$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs.href;
            if (href) entry.link = href;
            var description = $0b736e9bd8550f4d$var$fetch("summary", children) || $0b736e9bd8550f4d$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $0b736e9bd8550f4d$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $0b736e9bd8550f4d$var$addConditionally(feed, "id", "id", childs);
    $0b736e9bd8550f4d$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $0b736e9bd8550f4d$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs.href;
    if (href) feed.link = href;
    $0b736e9bd8550f4d$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $0b736e9bd8550f4d$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $0b736e9bd8550f4d$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $0b736e9bd8550f4d$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $0b736e9bd8550f4d$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $hQmng.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $0b736e9bd8550f4d$var$getMediaElements(children)
            };
            $0b736e9bd8550f4d$var$addConditionally(entry, "id", "guid", children);
            $0b736e9bd8550f4d$var$addConditionally(entry, "title", "title", children);
            $0b736e9bd8550f4d$var$addConditionally(entry, "link", "link", children);
            $0b736e9bd8550f4d$var$addConditionally(entry, "description", "description", children);
            var pubDate = $0b736e9bd8550f4d$var$fetch("pubDate", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $0b736e9bd8550f4d$var$addConditionally(feed, "title", "title", childs);
    $0b736e9bd8550f4d$var$addConditionally(feed, "link", "link", childs);
    $0b736e9bd8550f4d$var$addConditionally(feed, "description", "description", childs);
    var updated = $0b736e9bd8550f4d$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $0b736e9bd8550f4d$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $0b736e9bd8550f4d$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $0b736e9bd8550f4d$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $0b736e9bd8550f4d$var$getMediaElements(where) {
    return (0, $hQmng.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs.medium,
            isDefault: !!attribs.isDefault
        };
        for(var _i = 0, MEDIA_KEYS_STRING_1 = $0b736e9bd8550f4d$var$MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++){
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) media[attrib] = attribs[attrib];
        }
        for(var _a = 0, MEDIA_KEYS_INT_1 = $0b736e9bd8550f4d$var$MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++){
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        }
        if (attribs.expression) media.expression = attribs.expression;
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $0b736e9bd8550f4d$var$getOneElement(tagName, node) {
    return (0, $hQmng.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where  Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $0b736e9bd8550f4d$var$fetch(tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    return (0, $kl7Jx.textContent)((0, $hQmng.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $0b736e9bd8550f4d$var$addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    var val = $0b736e9bd8550f4d$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $0b736e9bd8550f4d$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});




parcelRegister("cS2Y3", function(module, exports) {
// eslint-disable-next-line no-unused-vars

var $3Neyk = parcelRequire("3Neyk");
var $95ecd47ebff8e158$require$Picker = $3Neyk.Picker;

var $1wZhs = parcelRequire("1wZhs");
var $95ecd47ebff8e158$require$trimCharacter = $1wZhs.trimCharacter;

var $7DoPy = parcelRequire("7DoPy");
var $95ecd47ebff8e158$require$StackItem = $7DoPy.StackItem;
var $95ecd47ebff8e158$require$BlockStackItem = $7DoPy.BlockStackItem;
var $95ecd47ebff8e158$require$TableCellStackItem = $7DoPy.TableCellStackItem;
var $95ecd47ebff8e158$require$TableRowStackItem = $7DoPy.TableRowStackItem;
var $95ecd47ebff8e158$require$TableStackItem = $7DoPy.TableStackItem;
var $95ecd47ebff8e158$require$TransformerStackItem = $7DoPy.TransformerStackItem;

var $5T5UK = parcelRequire("5T5UK");
var $95ecd47ebff8e158$require$tableToString = $5T5UK.tableToString;

var $dxw4H = parcelRequire("dxw4H");
var $95ecd47ebff8e158$require$WhitespaceProcessor = $dxw4H.WhitespaceProcessor;
parcelRequire("8xYvK");
/**
 * Helps to build text from inline and block elements.
 *
 * @class BlockTextBuilder
 */ class $95ecd47ebff8e158$var$BlockTextBuilder {
    /**
   * Creates an instance of BlockTextBuilder.
   *
   * @param { Options } options HtmlToText options.
   * @param { Picker<DomNode, TagDefinition> } picker Selectors decision tree picker.
   */ constructor(options, picker){
        this.options = options;
        this.picker = picker;
        this.whitespaceProcessor = new $95ecd47ebff8e158$require$WhitespaceProcessor(options);
        /** @type { StackItem } */ this._stackItem = new $95ecd47ebff8e158$require$BlockStackItem(options);
        /** @type { TransformerStackItem } */ this._wordTransformer = undefined;
    }
    /**
   * Put a word-by-word transform function onto the transformations stack.
   *
   * Mainly used for uppercasing. Can be bypassed to add unformatted text such as URLs.
   *
   * Word transformations applied before wrapping.
   *
   * @param { (str: string) => string } wordTransform Word transformation function.
   */ pushWordTransform(wordTransform) {
        this._wordTransformer = new $95ecd47ebff8e158$require$TransformerStackItem(this._wordTransformer, wordTransform);
    }
    /**
   * Remove a function from the word transformations stack.
   *
   * @returns { (str: string) => string } A function that was removed.
   */ popWordTransform() {
        if (!this._wordTransformer) return undefined;
        const transform = this._wordTransformer.transform;
        this._wordTransformer = this._wordTransformer.next;
        return transform;
    }
    /** @returns { (str: string) => string } */ _getCombinedWordTransformer() {
        const applyTransformer = (str, transformer)=>transformer ? applyTransformer(transformer.transform(str), transformer.next) : str;
        return (str)=>applyTransformer(str, this._wordTransformer);
    }
    _popStackItem() {
        const item = this._stackItem;
        this._stackItem = item.next;
        return item;
    }
    /**
   * Add a line break into currently built block.
   */ addLineBreak() {
        if (!(this._stackItem instanceof $95ecd47ebff8e158$require$BlockStackItem || this._stackItem instanceof $95ecd47ebff8e158$require$TableCellStackItem)) return;
        if (this._stackItem.isPre) this._stackItem.rawText += "\n";
        else this._stackItem.inlineTextBuilder.startNewLine();
    }
    /**
   * Allow to break line in case directly following text will not fit.
   */ addWordBreakOpportunity() {
        if (this._stackItem instanceof $95ecd47ebff8e158$require$BlockStackItem || this._stackItem instanceof $95ecd47ebff8e158$require$TableCellStackItem) this._stackItem.inlineTextBuilder.wordBreakOpportunity = true;
    }
    /**
   * Add a node inline into the currently built block.
   *
   * @param { string } str
   * Text content of a node to add.
   *
   * @param { object | boolean } [ optionsObjectOrNoWordTransform ]
   * Object holding the parameters of the operation.
   *
   * Boolean value is deprecated.
   *
   * @param { boolean } [ optionsObjectOrNoWordTransform.noWordTransform = false ]
   * Ignore word transformers if there are any.
   */ addInline(str, optionsObjectOrNoWordTransform = {}) {
        if (typeof optionsObjectOrNoWordTransform === "object") this._addInline(str, optionsObjectOrNoWordTransform);
        else this._addInline(str, {
            noWordTransform: optionsObjectOrNoWordTransform
        });
    }
    _addInline(str, { noWordTransform: noWordTransform = false } = {}) {
        if (!(this._stackItem instanceof $95ecd47ebff8e158$require$BlockStackItem || this._stackItem instanceof $95ecd47ebff8e158$require$TableCellStackItem)) return;
        if (this._stackItem.isPre) {
            this._stackItem.rawText += str;
            return;
        }
        if (str.length === 0 || // empty string
        this._stackItem.stashedLineBreaks && // stashed linebreaks make whitespace irrelevant
        !this.whitespaceProcessor.testContainsWords(str) // no words to add
        ) return;
        if (this.options.preserveNewlines) {
            const newlinesNumber = this.whitespaceProcessor.countNewlinesNoWords(str);
            if (newlinesNumber > 0) {
                this._stackItem.inlineTextBuilder.startNewLine(newlinesNumber);
                // keep stashedLineBreaks unchanged
                return;
            }
        }
        if (this._stackItem.stashedLineBreaks) this._stackItem.inlineTextBuilder.startNewLine(this._stackItem.stashedLineBreaks);
        this.whitespaceProcessor.shrinkWrapAdd(str, this._stackItem.inlineTextBuilder, this._wordTransformer && !noWordTransform ? this._getCombinedWordTransformer() : undefined);
        this._stackItem.stashedLineBreaks = 0; // inline text doesn't introduce line breaks
    }
    /**
   * Start building a new block.
   *
   * @param { object | number } [optionsObjectOrLeadingLineBreaks]
   * Object holding the parameters of the block.
   *
   * Number value is deprecated.
   *
   * @param { number }  [optionsObjectOrLeadingLineBreaks.leadingLineBreaks = 1]
   * This block should have at least this number of line breaks to separate if from any preceding block.
   *
   * @param { number }  [optionsObjectOrLeadingLineBreaks.reservedLineLength = 0]
   * Reserve this number of characters on each line for block markup.
   *
   * @param { boolean } [optionsObjectOrLeadingLineBreaks.isPre = false]
   * Should HTML whitespace be preserved inside this block.
   *
   * @param { number }  [reservedLineLength]
   * Deprecated.
   *
   * @param { boolean } [isPre]
   * Deprecated.
   */ openBlock(optionsObjectOrLeadingLineBreaks = {}, reservedLineLength, isPre) {
        if (typeof optionsObjectOrLeadingLineBreaks === "object") this._openBlock(optionsObjectOrLeadingLineBreaks);
        else this._openBlock({
            isPre: isPre,
            leadingLineBreaks: optionsObjectOrLeadingLineBreaks,
            reservedLineLength: reservedLineLength
        });
    }
    _openBlock({ leadingLineBreaks: leadingLineBreaks = 1, reservedLineLength: reservedLineLength = 0, isPre: isPre = false } = {}) {
        const maxLineLength = Math.max(20, this._stackItem.inlineTextBuilder.maxLineLength - reservedLineLength);
        this._stackItem = new $95ecd47ebff8e158$require$BlockStackItem(this.options, this._stackItem, leadingLineBreaks, maxLineLength);
        if (isPre) this._stackItem.isPre = true;
    }
    /**
   * Finalize currently built block, add it's content to the parent block.
   *
   * @param { object | number }         [optionsObjectOrTrailingLineBreaks]
   * Object holding the parameters of the block.
   *
   * Number value is deprecated.
   *
   * @param { number }                  [optionsObjectOrTrailingLineBreaks.trailingLineBreaks = 1]
   * This block should have at least this number of line breaks to separate it from any following block.
   *
   * @param { (str: string) => string } [optionsObjectOrTrailingLineBreaks.blockTransform = undefined]
   * A function to transform the block text before adding to the parent block.
   * This happens after word wrap and should be used in combination with reserved line length
   * in order to keep line lengths correct.
   * Used for whole block markup.
   *
   * @param { (str: string) => string } [blockTransform]
   * Deprecated.
   */ closeBlock(optionsObjectOrTrailingLineBreaks = {}, blockTransform) {
        if (typeof optionsObjectOrTrailingLineBreaks === "object") this._closeBlock(optionsObjectOrTrailingLineBreaks);
        else this._closeBlock({
            trailingLineBreaks: optionsObjectOrTrailingLineBreaks,
            blockTransform: blockTransform
        });
    }
    _closeBlock({ trailingLineBreaks: trailingLineBreaks = 1, blockTransform: blockTransform } = {}) {
        const block = this._popStackItem();
        const blockText = blockTransform ? blockTransform($95ecd47ebff8e158$var$getText(block)) : $95ecd47ebff8e158$var$getText(block);
        $95ecd47ebff8e158$var$addText(this._stackItem, blockText, block.leadingLineBreaks, Math.max(block.stashedLineBreaks, trailingLineBreaks));
    }
    /**
   * Start building a table.
   */ openTable() {
        this._stackItem = new $95ecd47ebff8e158$require$TableStackItem(this._stackItem);
    }
    /**
   * Start building a table row.
   */ openTableRow() {
        if (!(this._stackItem instanceof $95ecd47ebff8e158$require$TableStackItem)) throw new Error("Can't add table row to something that is not a table! Check the formatter.");
        this._stackItem = new $95ecd47ebff8e158$require$TableRowStackItem(this._stackItem);
    }
    /**
   * Start building a table cell.
   *
   * @param { object | number } [optionsObjectOrMaxColumnWidth = undefined]
   * Object holding the parameters of the cell.
   *
   * Number value is deprecated.
   *
   * @param { number } [optionsObjectOrMaxColumnWidth.maxColumnWidth = undefined]
   * Wrap cell content to this width. Fall back to global wordwrap value if undefined.
   */ openTableCell(optionsObjectOrMaxColumnWidth = {}) {
        if (typeof optionsObjectOrMaxColumnWidth === "object") this._openTableCell(optionsObjectOrMaxColumnWidth);
        else this._openTableCell({
            maxColumnWidth: optionsObjectOrMaxColumnWidth
        });
    }
    _openTableCell({ maxColumnWidth: maxColumnWidth } = {}) {
        if (!(this._stackItem instanceof $95ecd47ebff8e158$require$TableRowStackItem)) throw new Error("Can't add table cell to something that is not a table row! Check the formatter.");
        this._stackItem = new $95ecd47ebff8e158$require$TableCellStackItem(this.options, this._stackItem, maxColumnWidth);
    }
    /**
   * Finalize currently built table cell and add it to parent table row's cells.
   *
   * @param { object | number } [optionsObjectOrColspan]
   * Object holding the parameters of the cell.
   *
   * Number value is deprecated.
   *
   * @param { number } [optionsObjectOrColspan.colspan = 1] How many columns this cell should occupy.
   * @param { number } [optionsObjectOrColspan.rowspan = 1] How many rows this cell should occupy.
   *
   * @param { number } [rowspan] Deprecated.
   */ closeTableCell(optionsObjectOrColspan = {}, rowspan) {
        if (typeof optionsObjectOrColspan === "object") this._closeTableCell(optionsObjectOrColspan);
        else this._closeTableCell({
            colspan: optionsObjectOrColspan,
            rowspan: rowspan
        });
    }
    _closeTableCell({ colspan: colspan = 1, rowspan: rowspan = 1 } = {}) {
        const cell = this._popStackItem();
        const text = $95ecd47ebff8e158$require$trimCharacter($95ecd47ebff8e158$var$getText(cell), "\n");
        cell.next.cells.push({
            colspan: colspan,
            rowspan: rowspan,
            text: text
        });
    }
    /**
   * Finalize currently built table row and add it to parent table's rows.
   */ closeTableRow() {
        const row = this._popStackItem();
        row.next.rows.push(row.cells);
    }
    /**
   * Finalize currently built table and add the rendered text to the parent block.
   *
   * @param { object | number } [optionsObjectOrColSpacing]
   * Object holding the parameters of the table.
   *
   * Number value is deprecated.
   *
   * @param { number } [optionsObjectOrColSpacing.colSpacing = 3]
   * Number of spaces between table columns.
   *
   * @param { number } [optionsObjectOrColSpacing.rowSpacing = 0]
   * Number of empty lines between table rows.
   *
   * @param { number } [optionsObjectOrColSpacing.leadingLineBreaks = 2]
   * This table should have at least this number of line breaks to separate if from any preceding block.
   *
   * @param { number } [optionsObjectOrColSpacing.trailingLineBreaks = 2]
   * This table should have at least this number of line breaks to separate it from any following block.
   *
   * @param { number } [rowSpacing]
   * Deprecated.
   *
   * @param { number } [leadingLineBreaks]
   * Deprecated.
   *
   * @param { number } [trailingLineBreaks]
   * Deprecated.
   */ closeTable(optionsObjectOrColSpacing = {}, rowSpacing, leadingLineBreaks, trailingLineBreaks) {
        if (typeof optionsObjectOrColSpacing === "object") this._closeTable(optionsObjectOrColSpacing);
        else this._closeTable({
            colSpacing: optionsObjectOrColSpacing,
            leadingLineBreaks: leadingLineBreaks,
            rowSpacing: rowSpacing,
            trailingLineBreaks: trailingLineBreaks
        });
    }
    _closeTable({ colSpacing: colSpacing = 3, rowSpacing: rowSpacing = 0, leadingLineBreaks: leadingLineBreaks = 2, trailingLineBreaks: trailingLineBreaks = 2 } = {}) {
        const table = this._popStackItem();
        const output = $95ecd47ebff8e158$require$tableToString(table.rows, rowSpacing, colSpacing);
        if (output) $95ecd47ebff8e158$var$addText(this._stackItem, output, leadingLineBreaks, trailingLineBreaks);
    }
    /**
   * Return the rendered text content of this builder.
   *
   * @returns { string }
   */ toString() {
        return $95ecd47ebff8e158$var$getText(this._stackItem.getRoot());
    // There should only be the root item if everything is closed properly.
    }
}
function $95ecd47ebff8e158$var$getText(stackItem) {
    if (!(stackItem instanceof $95ecd47ebff8e158$require$BlockStackItem || stackItem instanceof $95ecd47ebff8e158$require$TableCellStackItem)) throw new Error("Only blocks and table cells can be requested for text contents.");
    return stackItem.inlineTextBuilder.isEmpty() ? stackItem.rawText : stackItem.rawText + stackItem.inlineTextBuilder.toString();
}
function $95ecd47ebff8e158$var$addText(stackItem, text, leadingLineBreaks, trailingLineBreaks) {
    if (!(stackItem instanceof $95ecd47ebff8e158$require$BlockStackItem || stackItem instanceof $95ecd47ebff8e158$require$TableCellStackItem)) throw new Error("Only blocks and table cells can contain text.");
    const parentText = $95ecd47ebff8e158$var$getText(stackItem);
    const lineBreaks = Math.max(stackItem.stashedLineBreaks, leadingLineBreaks);
    stackItem.inlineTextBuilder.clear();
    if (parentText) stackItem.rawText = parentText + "\n".repeat(lineBreaks) + text;
    else {
        stackItem.rawText = text;
        stackItem.leadingLineBreaks = lineBreaks;
    }
    stackItem.stashedLineBreaks = trailingLineBreaks;
}
module.exports = {
    BlockTextBuilder: $95ecd47ebff8e158$var$BlockTextBuilder
};

});
parcelRegister("1wZhs", function(module, exports) {

var $4AGYB = parcelRequire("4AGYB");
/**
 * Given a list of class and ID selectors (prefixed with '.' and '#'),
 * return them as separate lists of names without prefixes.
 *
 * @param { string[] } selectors Class and ID selectors (`[".class", "#id"]` etc).
 * @returns { { classes: string[], ids: string[] } }
 */ function $11d850a25082dfa6$var$splitClassesAndIds(selectors) {
    const classes = [];
    const ids = [];
    for (const selector of selectors){
        if (selector.startsWith(".")) classes.push(selector.substring(1));
        else if (selector.startsWith("#")) ids.push(selector.substring(1));
    }
    return {
        classes: classes,
        ids: ids
    };
}
/**
 * Make a recursive function that will only run to a given depth
 * and switches to an alternative function at that depth. \
 * No limitation if `n` is `undefined` (Just wraps `f` in that case).
 *
 * @param   { number | undefined } n   Allowed depth of recursion. `undefined` for no limitation.
 * @param   { Function }           f   Function that accepts recursive callback as the first argument.
 * @param   { Function }           [g] Function to run instead, when maximum depth was reached. Do nothing by default.
 * @returns { Function }
 */ function $11d850a25082dfa6$var$limitedDepthRecursive(n, f, g = ()=>undefined) {
    if (n === undefined) {
        const f1 = function(...args) {
            return f(f1, ...args);
        };
        return f1;
    }
    if (n >= 0) return function(...args) {
        return f($11d850a25082dfa6$var$limitedDepthRecursive(n - 1, f, g), ...args);
    };
    return g;
}
/**
 * Convert a number into alphabetic sequence representation (Sequence without zeroes).
 *
 * For example: `a, ..., z, aa, ..., zz, aaa, ...`.
 *
 * @param   { number } num              Number to convert. Must be >= 1.
 * @param   { string } [baseChar = 'a'] Character for 1 in the sequence.
 * @param   { number } [base = 26]      Number of characters in the sequence.
 * @returns { string }
 */ function $11d850a25082dfa6$var$numberToLetterSequence(num, baseChar = "a", base = 26) {
    const digits = [];
    do {
        num -= 1;
        digits.push(num % base);
        num = num / base >> 0; // quick `floor`
    }while (num > 0);
    const baseCode = baseChar.charCodeAt(0);
    return digits.reverse().map((n)=>String.fromCharCode(baseCode + n)).join("");
}
const $11d850a25082dfa6$var$I = [
    "I",
    "X",
    "C",
    "M"
];
const $11d850a25082dfa6$var$V = [
    "V",
    "L",
    "D"
];
/**
 * Convert a number to it's Roman representation. No large numbers extension.
 *
 * @param   { number } num Number to convert. `0 < num <= 3999`.
 * @returns { string }
 */ function $11d850a25082dfa6$var$numberToRoman(num) {
    return [
        ...num + ""
    ].map((n)=>+n).reverse().map((v, i)=>v % 5 < 4 ? (v < 5 ? "" : $11d850a25082dfa6$var$V[i]) + $11d850a25082dfa6$var$I[i].repeat(v % 5) : $11d850a25082dfa6$var$I[i] + (v < 5 ? $11d850a25082dfa6$var$V[i] : $11d850a25082dfa6$var$I[i + 1])).reverse().join("");
}
/**
 * Return the same string or a substring with the given character occurences removed from each end if any.
 *
 * @param   { string } str  A string to trim.
 * @param   { string } char A character to be trimmed.
 * @returns { string }
 */ function $11d850a25082dfa6$var$trimCharacter(str, char) {
    let start = 0;
    let end = str.length;
    while(start < end && str[start] === char)++start;
    while(end > start && str[end - 1] === char)--end;
    return start > 0 || end < str.length ? str.substring(start, end) : str;
}
/**
 * Get a nested property from an object.
 *
 * @param   { object }   obj  The object to query for the value.
 * @param   { string[] } path The path to the property.
 * @returns { any }
 */ function $11d850a25082dfa6$var$get(obj, path) {
    for (const key of path){
        if (!obj) return undefined;
        obj = obj[key];
    }
    return obj;
}
/**
 * Deduplicate an array by a given key callback.
 * Item properties are merged recursively and with the preference for last defined values.
 * Of items with the same key, merged item takes the place of the last item,
 * others are omitted.
 *
 * @param { any[] } items An array to deduplicate.
 * @param { (x: any) => string } getKey Callback to get a value that distinguishes unique items.
 * @returns { any[] }
 */ function $11d850a25082dfa6$var$mergeDuplicatesPreferLast(items, getKey) {
    const map = new Map();
    for(let i = items.length; i-- > 0;){
        const item = items[i];
        const key = getKey(item);
        map.set(key, map.has(key) ? $4AGYB(item, map.get(key), {
            arrayMerge: $11d850a25082dfa6$var$overwriteMerge
        }) : item);
    }
    return [
        ...map.values()
    ].reverse();
}
const $11d850a25082dfa6$var$overwriteMerge = (acc, src, options)=>[
        ...src
    ];
module.exports = {
    get: $11d850a25082dfa6$var$get,
    limitedDepthRecursive: $11d850a25082dfa6$var$limitedDepthRecursive,
    mergeDuplicatesPreferLast: $11d850a25082dfa6$var$mergeDuplicatesPreferLast,
    numberToLetterSequence: $11d850a25082dfa6$var$numberToLetterSequence,
    numberToRoman: $11d850a25082dfa6$var$numberToRoman,
    splitClassesAndIds: $11d850a25082dfa6$var$splitClassesAndIds,
    trimCharacter: $11d850a25082dfa6$var$trimCharacter
};

});

parcelRegister("7DoPy", function(module, exports) {
/* eslint-disable max-classes-per-file */ 
var $7bycX = parcelRequire("7bycX");
var $58ef6fc4b3cc3105$require$InlineTextBuilder = $7bycX.InlineTextBuilder;
class $58ef6fc4b3cc3105$var$StackItem {
    constructor(next = null){
        this.next = next;
    }
    getRoot() {
        return this.next ? this.next : this;
    }
}
class $58ef6fc4b3cc3105$var$BlockStackItem extends $58ef6fc4b3cc3105$var$StackItem {
    constructor(options, next = null, leadingLineBreaks = 1, maxLineLength){
        super(next);
        this.leadingLineBreaks = leadingLineBreaks;
        this.inlineTextBuilder = new $58ef6fc4b3cc3105$require$InlineTextBuilder(options, maxLineLength);
        this.rawText = "";
        this.stashedLineBreaks = 0;
        this.isPre = next && next.isPre;
    }
}
class $58ef6fc4b3cc3105$var$TableStackItem extends $58ef6fc4b3cc3105$var$StackItem {
    constructor(next = null){
        super(next);
        this.rows = [];
        this.isPre = next && next.isPre;
    }
}
class $58ef6fc4b3cc3105$var$TableRowStackItem extends $58ef6fc4b3cc3105$var$StackItem {
    constructor(next = null){
        super(next);
        this.cells = [];
        this.isPre = next && next.isPre;
    }
}
class $58ef6fc4b3cc3105$var$TableCellStackItem extends $58ef6fc4b3cc3105$var$StackItem {
    constructor(options, next = null, maxColumnWidth){
        super(next);
        this.inlineTextBuilder = new $58ef6fc4b3cc3105$require$InlineTextBuilder(options, maxColumnWidth);
        this.rawText = "";
        this.stashedLineBreaks = 0;
        this.isPre = next && next.isPre;
    }
}
class $58ef6fc4b3cc3105$var$TransformerStackItem extends $58ef6fc4b3cc3105$var$StackItem {
    constructor(next = null, transform){
        super(next);
        this.transform = transform;
    }
}
module.exports = {
    BlockStackItem: $58ef6fc4b3cc3105$var$BlockStackItem,
    StackItem: $58ef6fc4b3cc3105$var$StackItem,
    TableCellStackItem: $58ef6fc4b3cc3105$var$TableCellStackItem,
    TableRowStackItem: $58ef6fc4b3cc3105$var$TableRowStackItem,
    TableStackItem: $58ef6fc4b3cc3105$var$TableStackItem,
    TransformerStackItem: $58ef6fc4b3cc3105$var$TransformerStackItem
};

});
parcelRegister("7bycX", function(module, exports) {
// eslint-disable-next-line import/no-unassigned-import
parcelRequire("8xYvK");
/**
 * Helps to build text from words.
 */ class $53b4187dfbf70296$var$InlineTextBuilder {
    /**
   * Creates an instance of InlineTextBuilder.
   *
   * If `maxLineLength` is not provided then it is either `options.wordwrap` or unlimited.
   *
   * @param { Options } options           HtmlToText options.
   * @param { number }  [ maxLineLength ] This builder will try to wrap text to fit this line length.
   */ constructor(options, maxLineLength){
        /** @type { string[][] } */ this.lines = [];
        /** @type { string[] }   */ this.nextLineWords = [];
        this.maxLineLength = maxLineLength || options.wordwrap || Number.MAX_VALUE;
        this.nextLineAvailableChars = this.maxLineLength;
        this.wrapCharacters = options.longWordSplit.wrapCharacters || [];
        this.forceWrapOnLimit = options.longWordSplit.forceWrapOnLimit || false;
        this.stashedSpace = false;
        this.wordBreakOpportunity = false;
    }
    /**
   * Add a new word.
   *
   * @param { string } word A word to add.
   */ pushWord(word) {
        if (this.nextLineAvailableChars <= 0) this.startNewLine();
        const isLineStart = this.nextLineWords.length === 0;
        const cost = word.length + (isLineStart ? 0 : 1);
        if (cost <= this.nextLineAvailableChars) {
            this.nextLineWords.push(word);
            this.nextLineAvailableChars -= cost;
        } else {
            // The word is moved to a new line - prefer to wrap between words.
            const [first, ...rest] = this.splitLongWord(word);
            if (!isLineStart) this.startNewLine();
            this.nextLineWords.push(first);
            this.nextLineAvailableChars -= first.length;
            for (const part of rest){
                this.startNewLine();
                this.nextLineWords.push(part);
                this.nextLineAvailableChars -= part.length;
            }
        }
    }
    /**
   * Pop a word from the currently built line.
   * This doesn't affect completed lines.
   *
   * @returns { string }
   */ popWord() {
        const lastWord = this.nextLineWords.pop();
        if (lastWord !== undefined) {
            const isLineStart = this.nextLineWords.length === 0;
            const cost = lastWord.length + (isLineStart ? 0 : 1);
            this.nextLineAvailableChars += cost;
        }
        return lastWord;
    }
    /**
   * Concat a word to the last word already in the builder.
   * Adds a new word in case there are no words yet in the last line.
   *
   * @param { string } word A word to be concatenated.
   */ concatWord(word) {
        if (this.wordBreakOpportunity && word.length > this.nextLineAvailableChars) {
            this.pushWord(word);
            this.wordBreakOpportunity = false;
        } else {
            const lastWord = this.popWord();
            this.pushWord(lastWord ? lastWord.concat(word) : word);
        }
    }
    /**
   * Add current line (and more empty lines if provided argument > 1) to the list of complete lines and start a new one.
   *
   * @param { number } n Number of line breaks that will be added to the resulting string.
   */ startNewLine(n = 1) {
        this.lines.push(this.nextLineWords);
        if (n > 1) this.lines.push(...Array.from({
            length: n - 1
        }, ()=>[]));
        this.nextLineWords = [];
        this.nextLineAvailableChars = this.maxLineLength;
    }
    /**
   * No words in this builder.
   *
   * @returns { boolean }
   */ isEmpty() {
        return this.lines.length === 0 && this.nextLineWords.length === 0;
    }
    clear() {
        this.lines.length = 0;
        this.nextLineWords.length = 0;
        this.nextLineAvailableChars = this.maxLineLength;
    }
    /**
   * Join all lines of words inside the InlineTextBuilder into a complete string.
   *
   * @returns { string }
   */ toString() {
        return [
            ...this.lines,
            this.nextLineWords
        ].map((words)=>words.join(" ")).join("\n");
    }
    /**
   * Split a long word up to fit within the word wrap limit.
   * Use either a character to split looking back from the word wrap limit,
   * or truncate to the word wrap limit.
   *
   * @param   { string }   word Input word.
   * @returns { string[] }      Parts of the word.
   */ splitLongWord(word) {
        const parts = [];
        let idx = 0;
        while(word.length > this.maxLineLength){
            const firstLine = word.substring(0, this.maxLineLength);
            const remainingChars = word.substring(this.maxLineLength);
            const splitIndex = firstLine.lastIndexOf(this.wrapCharacters[idx]);
            if (splitIndex > -1) {
                word = firstLine.substring(splitIndex + 1) + remainingChars;
                parts.push(firstLine.substring(0, splitIndex + 1));
            } else {
                idx++;
                if (idx < this.wrapCharacters.length) word = firstLine + remainingChars;
                else {
                    if (this.forceWrapOnLimit) {
                        parts.push(firstLine);
                        word = remainingChars;
                        if (word.length > this.maxLineLength) continue;
                    } else word = firstLine + remainingChars;
                    break;
                }
            }
        }
        parts.push(word); // Add remaining part to array
        return parts;
    }
}
module.exports = {
    InlineTextBuilder: $53b4187dfbf70296$var$InlineTextBuilder
};

});
parcelRegister("8xYvK", function(module, exports) {
/**
 * @typedef { object } Options
 * HtmlToText options.
 *
 * @property { BaseElementsOptions }  [baseElements]
 * Options for narrowing down to informative parts of HTML document.
 *
 * @property { DecodeOptions }        [decodeOptions]
 * Text decoding options given to `he.decode`.
 *
 * For more information see the [he](https://github.com/mathiasbynens/he) module.
 *
 * @property { object.< string, FormatCallback > } [formatters = {}]
 * A dictionary with custom formatting functions for specific kinds of elements.
 *
 * Keys are custom string identifiers, values are callbacks.
 *
 * @property { LimitsOptions }        [limits]
 * Options for handling complex documents and limiting the output size.
 *
 * @property { LongWordSplitOptions } [longWordSplit]
 * Describes how to wrap long words.
 *
 * @property { boolean }              [preserveNewlines = false]
 * By default, any newlines `\n` from the input HTML are collapsed into space as any other HTML whitespace characters.
 * If `true`, these newlines will be preserved in the output.
 * This is only useful when input HTML carries some plain text formatting instead of proper tags.
 *
 * @property { SelectorDefinition[] } [selectors = []]
 * Instructions for how to render HTML elements based on matched selectors.
 *
 * Use this to (re)define options for new or already supported tags.
 *
 * @property { string[] | boolean }   [tables = []]
 * Deprecated. Use selectors with `format: 'dataTable'` instead.
 *
 * @property { string }               [whitespaceCharacters = ' \t\r\n\f\u200b']
 * All characters that are considered whitespace.
 * Default is according to HTML specifications.
 *
 * @property { number | boolean | null } [wordwrap = 80]
 * After how many chars a line break should follow in `p` elements.
 *
 * Set to `null` or `false` to disable word-wrapping.
 */ /**
 * @typedef { object } BaseElementsOptions
 * Options for narrowing down to informative parts of HTML document.
 *
 * @property { string[] } [selectors = ['body']]
 * The resulting text output will be composed from the text content of elements
 * matched with these selectors.
 *
 * @property { 'selectors' | 'occurrence' } [orderBy = 'selectors']
 * When multiple selectors are set, this option specifies
 * whether the selectors order has to be reflected in the output text.
 *
 * `'selectors'` (default) - matches for the first selector will appear first, etc;
 *
 * `'occurrence'` - all bases will appear in the same order as in input HTML.
 *
 * @property { boolean } [returnDomByDefault = true]
 * Use the entire document if none of provided selectors matched.
 */ /**
 * @typedef { object } DecodeOptions
 * Text decoding options given to `he.decode`.
 *
 * For more information see the [he](https://github.com/mathiasbynens/he) module.
 *
 * @property { boolean } [isAttributeValue = false]
 * TL;DR: If set to `true` - leave attribute values raw, don't parse them as text content.
 *
 * @property { boolean } [strict = false]
 * TL;DR: If set to `true` - throw an error on invalid HTML input.
 */ /**
 * @typedef { object } LimitsOptions
 * Options for handling complex documents and limiting the output size.
 *
 * @property { string } [ellipsis = ...]
 * A string to put in place of skipped content.
 *
 * @property { number | undefined } [maxBaseElements = undefined]
 * Stop looking for new base elements after this number of matches.
 *
 * No ellipsis is used when this condition is met.
 *
 * No limit if undefined.
 *
 * @property { number | undefined } [maxChildNodes = undefined]
 * Process only this many child nodes of any element.
 *
 * Remaining nodes, if any, will be replaced with ellipsis.
 *
 * Text nodes are counted along with tags.
 *
 * No limit if undefined.
 *
 * @property { number | undefined } [maxDepth = undefined]
 * Only go to a certain depth starting from `Options.baseElement`.
 *
 * Replace deeper nodes with ellipsis.
 *
 * No depth limit if undefined.
 *
 * @property { number } [maxInputLength = 16_777_216]
 * If the input string is longer than this value - it will be truncated
 * and a message will be sent to `stderr`.
 *
 * Ellipsis is not used in this case.
 */ /**
 * @typedef { object } LongWordSplitOptions
 * Describes how to wrap long words.
 *
 * @property { boolean }  [forceWrapOnLimit = false]
 * Break long words on the `Options.wordwrap` limit when there are no characters to wrap on.
 *
 * @property { string[] } [wrapCharacters = []]
 * An array containing the characters that may be wrapped on.
 */ /**
 * @typedef { object } SelectorDefinition
 * Describes how to handle tags matched by a selector.
 *
 * @property { string } selector
 * CSS selector. Refer to README for notes on supported selectors etc.
 *
 * @property { string } format
 * Identifier of a {@link FormatCallback}, built-in or provided in `Options.formatters` dictionary.
 *
 * @property { FormatOptions } options
 * Options to customize the formatter for this element.
 */ /**
 * @typedef { object } FormatOptions
 * Options specific to different formatters ({@link FormatCallback}).
 * This is an umbrella type definition. Each formatter supports it's own subset of options.
 *
 * @property { number } [leadingLineBreaks]
 * Number of line breaks to separate previous block from this one.
 *
 * Note that N+1 line breaks are needed to make N empty lines.
 *
 * @property { number } [trailingLineBreaks]
 * Number of line breaks to separate this block from the next one.
 *
 * Note that N+1 line breaks are needed to make N empty lines.
 *
 * @property { string | null } [baseUrl = null]
 * (Only for: `anchor` and `image` formatters.) Server host for link `href` attributes and image `src` attributes
 * relative to the root (the ones that start with `/`).
 *
 * For example, with `baseUrl = 'http://asdf.com'` and `<a href='/dir/subdir'>...</a>`
 * the link in the text will be `http://asdf.com/dir/subdir`.
 *
 * Keep in mind that `baseUrl` should not end with a `/`.
 *
 * @property { boolean } [hideLinkHrefIfSameAsText = false]
 * (Only for: `anchor` formatter.) By default links are translated in the following way:
 *
 * `<a href='link'>text</a>` => becomes => `text [link]`.
 *
 * If this option is set to `true` and `link` and `text` are the same,
 * `[link]` will be omitted and only `text` will be present.
 *
 * @property { boolean } [ignoreHref = false]
 * (Only for: `anchor` formatter.) Ignore all links. Only process internal text of anchor tags.
 *
 * @property { [string, string] | false } [linkBrackets]
 * (Only for: `anchor` and `image` formatters.) Surround links with these brackets. Default: `['[', ']']`.
 *
 * Set to `false` or `['', '']` to disable.
 *
 * @property { boolean } [noAnchorUrl = true]
 * (Only for: `anchor` formatter.) Ignore anchor links (where `href='#...'`).
 *
 * @property { string } [itemPrefix = ' * ']
 * (Only for: `unorderedList` formatter.) String prefix for each list item.
 *
 * @property { boolean } [uppercase = true]
 * (Only for: `heading` formatter.) By default, headings (`<h1>`, `<h2>`, etc) are uppercased.
 *
 * Set this to `false` to leave headings as they are.
 *
 * @property { number | undefined } [length = undefined]
 * (Only for: `horizontalLine` formatter.) Length of the `<hr/>` line.
 *
 * If numeric value is provided - it is used.
 * Otherwise, if global `wordwrap` number is provided - it is used.
 * If neither is true, then the fallback value of 40 is used.
 *
 * @property { boolean } [trimEmptyLines = true]
 * (Only for: `blockquote` formatter.) Trim empty lines from blockquote.
 *
 * @property { boolean } [uppercaseHeaderCells = true]
 * (Only for: `table`, `dataTable` formatter.) By default, heading cells (`<th>`) are uppercased.
 *
 * Set this to `false` to leave heading cells as they are.
 *
 * @property { number } [maxColumnWidth = 60]
 * (Only for: `table`, `dataTable` formatter.) Data table cell content will be wrapped to fit this width
 * instead of global `wordwrap` limit.
 *
 * Set this to `undefined` in order to fall back to `wordwrap` limit.
 *
 * @property { number } [colSpacing = 3]
 * (Only for: `table`, `dataTable` formatter.) Number of spaces between data table columns.
 *
 * @property { number } [rowSpacing = 0]
 * (Only for: `table`, `dataTable` formatter.) Number of empty lines between data table rows.
 *
 */ /**
 * @typedef { object } DomNode
 * Simplified definition of [htmlparser2](https://github.com/fb55/htmlparser2) Node type.
 *
 * Makes no distinction between elements (tags) and data nodes (good enough for now).
 *
 * @property { string }                 type       Type of node - "text", "tag", "comment", "script", etc.
 * @property { string }                 [data]     Content of a data node.
 * @property { string }                 [name]     Tag name.
 * @property { object.<string,string> } [attribs]  Tag attributes dictionary.
 * @property { DomNode[] }              [children] Child nodes.
 * @property { DomNode }                [parent]   Parent node.
 */ /**
 * A function to stringify a DOM node.
 *
 * @callback FormatCallback
 *
 * @param   { DomNode }           elem          A DOM node as returned by [htmlparser2](https://github.com/fb55/htmlparser2).
 * @param   { RecursiveCallback } walk          Recursive callback to process child nodes.
 * @param   { BlockTextBuilder }  builder       Passed around to accumulate output text. Contains options object.
 * @param   { FormatOptions }     formatOptions Options specific to this callback.
 */ /**
 * A function to process child nodes.
 * Passed into a {@link FormatCallback} as an argument.
 *
 * @callback RecursiveCallback
 *
 * @param   { DomNode[] }        [nodes] DOM nodes array.
 * @param   { BlockTextBuilder } builder Passed around to accumulate output text. Contains options object.
 */ 
});



parcelRegister("5T5UK", function(module, exports) {
function $4496ad45526acea4$var$getRow(matrix, j) {
    if (!matrix[j]) matrix[j] = [];
    return matrix[j];
}
function $4496ad45526acea4$var$findFirstVacantIndex(row, x = 0) {
    while(row[x])x++;
    return x;
}
function $4496ad45526acea4$var$transposeInPlace(matrix, maxSize) {
    for(let i = 0; i < maxSize; i++){
        const rowI = $4496ad45526acea4$var$getRow(matrix, i);
        for(let j = 0; j < i; j++){
            const rowJ = $4496ad45526acea4$var$getRow(matrix, j);
            const temp = rowI[j];
            rowI[j] = rowJ[i];
            rowJ[i] = temp;
        }
    }
}
function $4496ad45526acea4$var$putCellIntoLayout(cell, layout, baseRow, baseCol) {
    for(let r = 0; r < cell.rowspan; r++){
        const layoutRow = $4496ad45526acea4$var$getRow(layout, baseRow + r);
        for(let c = 0; c < cell.colspan; c++)layoutRow[baseCol + c] = cell;
    }
}
function $4496ad45526acea4$var$updateOffset(offsets, base, span, value) {
    offsets[base + span] = Math.max(offsets[base + span] || 0, offsets[base] + value);
}
/**
 * @typedef { object } TablePrinterCell
 * Cell definition for the table printer.
 *
 * @property { number } colspan Number of columns this cell occupies.
 * @property { number } rowspan Number of rows this cell occupies.
 * @property { string } text Cell contents (pre-wrapped).
 */ /**
 * Render a table into string.
 * Cells can contain multiline text and span across multiple rows and columns.
 *
 * Modifies cells to add lines array.
 *
 * @param { TablePrinterCell[][] } tableRows Table to render.
 * @param { number } rowSpacing Number of spaces between columns.
 * @param { number } colSpacing Number of empty lines between rows.
 * @returns { string }
 */ function $4496ad45526acea4$var$tableToString(tableRows, rowSpacing, colSpacing) {
    const layout = [];
    let colNumber = 0;
    const rowNumber = tableRows.length;
    const rowOffsets = [
        0
    ];
    // Fill the layout table and row offsets row-by-row.
    for(let j = 0; j < rowNumber; j++){
        const layoutRow = $4496ad45526acea4$var$getRow(layout, j);
        const cells = tableRows[j];
        let x = 0;
        for(let i = 0; i < cells.length; i++){
            const cell = cells[i];
            x = $4496ad45526acea4$var$findFirstVacantIndex(layoutRow, x);
            $4496ad45526acea4$var$putCellIntoLayout(cell, layout, j, x);
            x += cell.colspan;
            cell.lines = cell.text.split("\n");
            const cellHeight = cell.lines.length;
            $4496ad45526acea4$var$updateOffset(rowOffsets, j, cell.rowspan, cellHeight + rowSpacing);
        }
        colNumber = layoutRow.length > colNumber ? layoutRow.length : colNumber;
    }
    $4496ad45526acea4$var$transposeInPlace(layout, rowNumber > colNumber ? rowNumber : colNumber);
    const outputLines = [];
    const colOffsets = [
        0
    ];
    // Fill column offsets and output lines column-by-column.
    for(let x = 0; x < colNumber; x++){
        let y = 0;
        let cell;
        while(y < rowNumber && (cell = layout[x][y])){
            if (!cell.rendered) {
                let cellWidth = 0;
                for(let j = 0; j < cell.lines.length; j++){
                    const line = cell.lines[j];
                    const lineOffset = rowOffsets[y] + j;
                    outputLines[lineOffset] = (outputLines[lineOffset] || "").padEnd(colOffsets[x]) + line;
                    cellWidth = line.length > cellWidth ? line.length : cellWidth;
                }
                $4496ad45526acea4$var$updateOffset(colOffsets, x, cell.colspan, cellWidth + colSpacing);
                cell.rendered = true;
            }
            y += cell.rowspan;
        }
    }
    return outputLines.join("\n");
}
module.exports = {
    tableToString: $4496ad45526acea4$var$tableToString
};

});

parcelRegister("dxw4H", function(module, exports) {
// eslint-disable-next-line no-unused-vars

var $7bycX = parcelRequire("7bycX");
var $9db73cd60ddf5d23$require$InlineTextBuilder = $7bycX.InlineTextBuilder;
parcelRequire("8xYvK");
function $9db73cd60ddf5d23$var$charactersToCodes(str) {
    return [
        ...str
    ].map((c)=>"\\u" + c.charCodeAt(0).toString(16).padStart(4, "0")).join("");
}
/**
 * Helps to handle HTML whitespaces.
 *
 * @class WhitespaceProcessor
 */ class $9db73cd60ddf5d23$var$WhitespaceProcessor {
    /**
   * Creates an instance of WhitespaceProcessor.
   *
   * @param { Options } options    HtmlToText options.
   * @memberof WhitespaceProcessor
   */ constructor(options){
        this.whitespaceChars = options.preserveNewlines ? options.whitespaceCharacters.replace(/\n/g, "") : options.whitespaceCharacters;
        const whitespaceCodes = $9db73cd60ddf5d23$var$charactersToCodes(this.whitespaceChars);
        this.leadingWhitespaceRe = new RegExp(`^[${whitespaceCodes}]`);
        this.trailingWhitespaceRe = new RegExp(`[${whitespaceCodes}]$`);
        this.allWhitespaceOrEmptyRe = new RegExp(`^[${whitespaceCodes}]*$`);
        this.newlineOrNonWhitespaceRe = new RegExp(`(\\n|[^\\n${whitespaceCodes}])`, "g");
        if (options.preserveNewlines) {
            const wordOrNewlineRe = new RegExp(`\\n|[^\\n${whitespaceCodes}]+`, "gm");
            /**
       * Shrink whitespaces and wrap text, add to the builder.
       *
       * @param { string }                  text              Input text.
       * @param { InlineTextBuilder }       inlineTextBuilder A builder to receive processed text.
       * @param { (str: string) => string } [ transform ]     A transform to be applied to words.
       */ this.shrinkWrapAdd = function(text, inlineTextBuilder, transform = (str)=>str) {
                if (!text) return;
                const previouslyStashedSpace = inlineTextBuilder.stashedSpace;
                let anyMatch = false;
                let m = wordOrNewlineRe.exec(text);
                if (m) {
                    anyMatch = true;
                    if (m[0] === "\n") inlineTextBuilder.startNewLine();
                    else if (previouslyStashedSpace || this.testLeadingWhitespace(text)) inlineTextBuilder.pushWord(transform(m[0]));
                    else inlineTextBuilder.concatWord(transform(m[0]));
                    while((m = wordOrNewlineRe.exec(text)) !== null)if (m[0] === "\n") inlineTextBuilder.startNewLine();
                    else inlineTextBuilder.pushWord(transform(m[0]));
                }
                inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
            // No need to stash a space in case last added item was a new line,
            // but that won't affect anything later anyway.
            };
        } else {
            const wordRe = new RegExp(`[^${whitespaceCodes}]+`, "g");
            this.shrinkWrapAdd = function(text, inlineTextBuilder, transform = (str)=>str) {
                if (!text) return;
                const previouslyStashedSpace = inlineTextBuilder.stashedSpace;
                let anyMatch = false;
                let m = wordRe.exec(text);
                if (m) {
                    anyMatch = true;
                    if (previouslyStashedSpace || this.testLeadingWhitespace(text)) inlineTextBuilder.pushWord(transform(m[0]));
                    else inlineTextBuilder.concatWord(transform(m[0]));
                    while((m = wordRe.exec(text)) !== null)inlineTextBuilder.pushWord(transform(m[0]));
                }
                inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
            };
        }
    }
    /**
   * Test whether the given text starts with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */ testLeadingWhitespace(text) {
        return this.leadingWhitespaceRe.test(text);
    }
    /**
   * Test whether the given text ends with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */ testTrailingWhitespace(text) {
        return this.trailingWhitespaceRe.test(text);
    }
    /**
   * Test whether the given text contains any non-whitespace characters.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */ testContainsWords(text) {
        return !this.allWhitespaceOrEmptyRe.test(text);
    }
    /**
   * Return the number of newlines if there are no words.
   *
   * If any word is found then return zero regardless of the actual number of newlines.
   *
   * @param   { string }  text  Input string.
   * @returns { number }
   */ countNewlinesNoWords(text) {
        this.newlineOrNonWhitespaceRe.lastIndex = 0;
        let counter = 0;
        let match;
        while((match = this.newlineOrNonWhitespaceRe.exec(text)) !== null){
            if (match[0] === "\n") counter++;
            else return 0;
        }
        return counter;
    }
}
module.exports = {
    WhitespaceProcessor: $9db73cd60ddf5d23$var$WhitespaceProcessor
};

});


parcelRegister("2RzUw", function(module, exports) {

var $2eMeB = parcelRequire("2eMeB");

var $1wZhs = parcelRequire("1wZhs");
var $215c631d5ce8277d$require$get = $1wZhs.get;
var $215c631d5ce8277d$require$numberToLetterSequence = $1wZhs.numberToLetterSequence;
var $215c631d5ce8277d$require$numberToRoman = $1wZhs.numberToRoman;
var $215c631d5ce8277d$require$splitClassesAndIds = $1wZhs.splitClassesAndIds;
var $215c631d5ce8277d$require$trimCharacter = $1wZhs.trimCharacter;
parcelRequire("8xYvK");
/**
 * Dummy formatter that discards the input and does nothing.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatSkip(elem, walk, builder, formatOptions) {
/* do nothing */ }
/**
 * Process an inline-level element.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatInline(elem, walk, builder, formatOptions) {
    walk(elem.children, builder);
}
/**
 * Process a block-level container.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatBlock(elem, walk, builder, formatOptions) {
    builder.openBlock({
        leadingLineBreaks: formatOptions.leadingLineBreaks
    });
    walk(elem.children, builder);
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks
    });
}
/**
 * Process a line-break.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatLineBreak(elem, walk, builder, formatOptions) {
    builder.addLineBreak();
}
/**
 * Process a `wbk` tag (word break opportunity).
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatWbr(elem, walk, builder, formatOptions) {
    builder.addWordBreakOpportunity();
}
/**
 * Process a horizontal line.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatHorizontalLine(elem, walk, builder, formatOptions) {
    builder.openBlock({
        leadingLineBreaks: formatOptions.leadingLineBreaks || 2
    });
    builder.addInline("-".repeat(formatOptions.length || builder.options.wordwrap || 40));
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks || 2
    });
}
/**
 * Process a paragraph.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatParagraph(elem, walk, builder, formatOptions) {
    builder.openBlock({
        leadingLineBreaks: formatOptions.leadingLineBreaks || 2
    });
    walk(elem.children, builder);
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks || 2
    });
}
/**
 * Process a preformatted content.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatPre(elem, walk, builder, formatOptions) {
    builder.openBlock({
        isPre: true,
        leadingLineBreaks: formatOptions.leadingLineBreaks || 2
    });
    walk(elem.children, builder);
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks || 2
    });
}
/**
 * Process a heading.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatHeading(elem, walk, builder, formatOptions) {
    builder.openBlock({
        leadingLineBreaks: formatOptions.leadingLineBreaks || 2
    });
    if (formatOptions.uppercase !== false) {
        builder.pushWordTransform((str)=>str.toUpperCase());
        walk(elem.children, builder);
        builder.popWordTransform();
    } else walk(elem.children, builder);
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks || 2
    });
}
/**
 * Process a blockquote.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatBlockquote(elem, walk, builder, formatOptions) {
    builder.openBlock({
        leadingLineBreaks: formatOptions.leadingLineBreaks || 2,
        reservedLineLength: 2
    });
    walk(elem.children, builder);
    builder.closeBlock({
        trailingLineBreaks: formatOptions.trailingLineBreaks || 2,
        blockTransform: (str)=>(formatOptions.trimEmptyLines !== false ? $215c631d5ce8277d$require$trimCharacter(str, "\n") : str).split("\n").map((line)=>"> " + line).join("\n")
    });
}
function $215c631d5ce8277d$var$withBrackets(str, brackets) {
    if (!brackets) return str;
    const lbr = typeof brackets[0] === "string" ? brackets[0] : "[";
    const rbr = typeof brackets[1] === "string" ? brackets[1] : "]";
    return lbr + str + rbr;
}
/**
 * Process an image.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatImage(elem, walk, builder, formatOptions) {
    const attribs = elem.attribs || {};
    const alt = attribs.alt ? $2eMeB.decode(attribs.alt, builder.options.decodeOptions) : "";
    const src = !attribs.src ? "" : formatOptions.baseUrl && attribs.src.indexOf("/") === 0 ? formatOptions.baseUrl + attribs.src : attribs.src;
    const text = !src ? alt : !alt ? $215c631d5ce8277d$var$withBrackets(src, formatOptions.linkBrackets) : alt + " " + $215c631d5ce8277d$var$withBrackets(src, formatOptions.linkBrackets);
    builder.addInline(text);
}
/**
 * Process an anchor.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatAnchor(elem, walk, builder, formatOptions) {
    function getHref() {
        if (formatOptions.ignoreHref) return "";
        if (!elem.attribs || !elem.attribs.href) return "";
        let href = elem.attribs.href.replace(/^mailto:/, "");
        if (formatOptions.noAnchorUrl && href[0] === "#") return "";
        href = formatOptions.baseUrl && href[0] === "/" ? formatOptions.baseUrl + href : href;
        return $2eMeB.decode(href, builder.options.decodeOptions);
    }
    const href = getHref();
    if (!href) walk(elem.children, builder);
    else {
        let text = "";
        builder.pushWordTransform((str)=>{
            if (str) text += str;
            return str;
        });
        walk(elem.children, builder);
        builder.popWordTransform();
        const hideSameLink = formatOptions.hideLinkHrefIfSameAsText && href === text;
        if (!hideSameLink) builder.addInline(!text ? href : " " + $215c631d5ce8277d$var$withBrackets(href, formatOptions.linkBrackets), {
            noWordTransform: true
        });
    }
}
/**
 * @param { DomNode }           elem               List items with their prefixes.
 * @param { RecursiveCallback } walk               Recursive callback to process child nodes.
 * @param { BlockTextBuilder }  builder            Passed around to accumulate output text.
 * @param { FormatOptions }     formatOptions      Options specific to a formatter.
 * @param { () => string }      nextPrefixCallback Function that returns increasing index each time it is called.
 */ function $215c631d5ce8277d$var$formatList(elem, walk, builder, formatOptions, nextPrefixCallback) {
    const isNestedList = $215c631d5ce8277d$require$get(elem, [
        "parent",
        "name"
    ]) === "li";
    // With Roman numbers, index length is not as straightforward as with Arabic numbers or letters,
    // so the dumb length comparison is the most robust way to get the correct value.
    let maxPrefixLength = 0;
    const listItems = (elem.children || [])// it might be more accurate to check only for html spaces here, but no significant benefit
    .filter((child)=>child.type !== "text" || !/^\s*$/.test(child.data)).map(function(child) {
        if (child.name !== "li") return {
            node: child,
            prefix: ""
        };
        const prefix = isNestedList ? nextPrefixCallback().trimStart() : nextPrefixCallback();
        if (prefix.length > maxPrefixLength) maxPrefixLength = prefix.length;
        return {
            node: child,
            prefix: prefix
        };
    });
    if (!listItems.length) return;
    const reservedLineLength = maxPrefixLength;
    const spacing = "\n" + " ".repeat(reservedLineLength);
    builder.openBlock({
        leadingLineBreaks: isNestedList ? 1 : formatOptions.leadingLineBreaks || 2
    });
    for (const { node: node, prefix: prefix } of listItems){
        builder.openBlock({
            leadingLineBreaks: 1,
            reservedLineLength: reservedLineLength
        });
        walk([
            node
        ], builder);
        builder.closeBlock({
            trailingLineBreaks: 1,
            blockTransform: (str)=>prefix + " ".repeat(reservedLineLength - prefix.length) + str.replace(/\n/g, spacing)
        });
    }
    builder.closeBlock({
        trailingLineBreaks: isNestedList ? 1 : formatOptions.trailingLineBreaks || 2
    });
}
/**
 * Process an unordered list.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatUnorderedList(elem, walk, builder, formatOptions) {
    const prefix = formatOptions.itemPrefix || " * ";
    return $215c631d5ce8277d$var$formatList(elem, walk, builder, formatOptions, ()=>prefix);
}
/**
 * Process an ordered list.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatOrderedList(elem, walk, builder, formatOptions) {
    let nextIndex = Number(elem.attribs.start || "1");
    const indexFunction = $215c631d5ce8277d$var$getOrderedListIndexFunction(elem.attribs.type);
    const nextPrefixCallback = ()=>" " + indexFunction(nextIndex++) + ". ";
    return $215c631d5ce8277d$var$formatList(elem, walk, builder, formatOptions, nextPrefixCallback);
}
/**
 * Return a function that can be used to generate index markers of a specified format.
 *
 * @param   { string } [olType='1'] Marker type.
 * @returns { (i: number) => string }
 */ function $215c631d5ce8277d$var$getOrderedListIndexFunction(olType = "1") {
    switch(olType){
        case "a":
            return (i)=>$215c631d5ce8277d$require$numberToLetterSequence(i, "a");
        case "A":
            return (i)=>$215c631d5ce8277d$require$numberToLetterSequence(i, "A");
        case "i":
            return (i)=>$215c631d5ce8277d$require$numberToRoman(i).toLowerCase();
        case "I":
            return (i)=>$215c631d5ce8277d$require$numberToRoman(i);
        case "1":
        default:
            return (i)=>i.toString();
    }
}
function $215c631d5ce8277d$var$isDataTable(attr, tables) {
    if (tables === true) return true;
    if (!attr) return false;
    const { classes: classes, ids: ids } = $215c631d5ce8277d$require$splitClassesAndIds(tables);
    const attrClasses = (attr["class"] || "").split(" ");
    const attrIds = (attr["id"] || "").split(" ");
    return attrClasses.some((x)=>classes.includes(x)) || attrIds.some((x)=>ids.includes(x));
}
/**
 * Process a table (either as a container or as a data table, depending on options).
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatTable(elem, walk, builder, formatOptions) {
    return $215c631d5ce8277d$var$isDataTable(elem.attribs, builder.options.tables) ? $215c631d5ce8277d$var$formatDataTable(elem, walk, builder, formatOptions) : $215c631d5ce8277d$var$formatBlock(elem, walk, builder, formatOptions);
}
/**
 * Process a data table.
 *
 * @type { FormatCallback }
 */ function $215c631d5ce8277d$var$formatDataTable(elem, walk, builder, formatOptions) {
    builder.openTable();
    elem.children.forEach(walkTable);
    builder.closeTable({
        colSpacing: formatOptions.colSpacing,
        leadingLineBreaks: formatOptions.leadingLineBreaks,
        rowSpacing: formatOptions.rowSpacing,
        trailingLineBreaks: formatOptions.trailingLineBreaks
    });
    function formatCell(cellNode) {
        const colspan = +$215c631d5ce8277d$require$get(cellNode, [
            "attribs",
            "colspan"
        ]) || 1;
        const rowspan = +$215c631d5ce8277d$require$get(cellNode, [
            "attribs",
            "rowspan"
        ]) || 1;
        builder.openTableCell({
            maxColumnWidth: formatOptions.maxColumnWidth
        });
        walk(cellNode.children, builder);
        builder.closeTableCell({
            colspan: colspan,
            rowspan: rowspan
        });
    }
    function walkTable(elem) {
        if (elem.type !== "tag") return;
        const formatHeaderCell = formatOptions.uppercaseHeaderCells !== false ? (cellNode)=>{
            builder.pushWordTransform((str)=>str.toUpperCase());
            formatCell(cellNode);
            builder.popWordTransform();
        } : formatCell;
        switch(elem.name){
            case "thead":
            case "tbody":
            case "tfoot":
            case "center":
                elem.children.forEach(walkTable);
                return;
            case "tr":
                builder.openTableRow();
                for (const childOfTr of elem.children){
                    if (childOfTr.type !== "tag") continue;
                    switch(childOfTr.name){
                        case "th":
                            formatHeaderCell(childOfTr);
                            break;
                        case "td":
                            formatCell(childOfTr);
                            break;
                        default:
                    }
                }
                builder.closeTableRow();
                break;
            default:
        }
    }
}
module.exports = {
    anchor: $215c631d5ce8277d$var$formatAnchor,
    block: $215c631d5ce8277d$var$formatBlock,
    blockquote: $215c631d5ce8277d$var$formatBlockquote,
    dataTable: $215c631d5ce8277d$var$formatDataTable,
    heading: $215c631d5ce8277d$var$formatHeading,
    horizontalLine: $215c631d5ce8277d$var$formatHorizontalLine,
    image: $215c631d5ce8277d$var$formatImage,
    inline: $215c631d5ce8277d$var$formatInline,
    lineBreak: $215c631d5ce8277d$var$formatLineBreak,
    orderedList: $215c631d5ce8277d$var$formatOrderedList,
    paragraph: $215c631d5ce8277d$var$formatParagraph,
    pre: $215c631d5ce8277d$var$formatPre,
    skip: $215c631d5ce8277d$var$formatSkip,
    table: $215c631d5ce8277d$var$formatTable,
    unorderedList: $215c631d5ce8277d$var$formatUnorderedList,
    wbr: $215c631d5ce8277d$var$formatWbr
};

});




parcelRegister("lIeXU", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $fce950d30a048d00$export$a3295358bff77e);

var $2g1ow = parcelRequire("2g1ow");
function $fce950d30a048d00$export$a3295358bff77e(name) {
    return (0, $2g1ow.ens_normalize)(name);
}

});
parcelRegister("2g1ow", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", () => $23e1af73ca596a78$export$499f715881831a51);
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var $23e1af73ca596a78$var$COMPRESSED$1 = "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";
const $23e1af73ca596a78$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $23e1af73ca596a78$var$NSM_MAX = 4;
function $23e1af73ca596a78$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $23e1af73ca596a78$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $23e1af73ca596a78$var$read_compressed_payload(s) {
    return $23e1af73ca596a78$var$read_payload($23e1af73ca596a78$var$decode_arithmetic($23e1af73ca596a78$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $23e1af73ca596a78$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $23e1af73ca596a78$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $23e1af73ca596a78$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $23e1af73ca596a78$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $23e1af73ca596a78$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $23e1af73ca596a78$var$read_sorted_arrays(next) {
    return $23e1af73ca596a78$var$read_array_while(()=>{
        let v = $23e1af73ca596a78$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $23e1af73ca596a78$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($23e1af73ca596a78$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($23e1af73ca596a78$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $23e1af73ca596a78$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $23e1af73ca596a78$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$23e1af73ca596a78$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $23e1af73ca596a78$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $23e1af73ca596a78$var$read_array_while(next);
    let m = $23e1af73ca596a78$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $23e1af73ca596a78$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $23e1af73ca596a78$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $23e1af73ca596a78$var$read_trie(next) {
    let ret = [];
    let sorted = $23e1af73ca596a78$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = $23e1af73ca596a78$var$read_array_while(()=>{
            let cps = $23e1af73ca596a78$var$read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand({ S: S, B: B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function $23e1af73ca596a78$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $23e1af73ca596a78$var$quote_cp(cp) {
    return `{${$23e1af73ca596a78$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $23e1af73ca596a78$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $23e1af73ca596a78$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $23e1af73ca596a78$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $23e1af73ca596a78$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $23e1af73ca596a78$var$S0 = 0xAC00;
const $23e1af73ca596a78$var$L0 = 0x1100;
const $23e1af73ca596a78$var$V0 = 0x1161;
const $23e1af73ca596a78$var$T0 = 0x11A7;
const $23e1af73ca596a78$var$L_COUNT = 19;
const $23e1af73ca596a78$var$V_COUNT = 21;
const $23e1af73ca596a78$var$T_COUNT = 28;
const $23e1af73ca596a78$var$N_COUNT = $23e1af73ca596a78$var$V_COUNT * $23e1af73ca596a78$var$T_COUNT;
const $23e1af73ca596a78$var$S_COUNT = $23e1af73ca596a78$var$L_COUNT * $23e1af73ca596a78$var$N_COUNT;
const $23e1af73ca596a78$var$S1 = $23e1af73ca596a78$var$S0 + $23e1af73ca596a78$var$S_COUNT;
const $23e1af73ca596a78$var$L1 = $23e1af73ca596a78$var$L0 + $23e1af73ca596a78$var$L_COUNT;
const $23e1af73ca596a78$var$V1 = $23e1af73ca596a78$var$V0 + $23e1af73ca596a78$var$V_COUNT;
const $23e1af73ca596a78$var$T1 = $23e1af73ca596a78$var$T0 + $23e1af73ca596a78$var$T_COUNT;
function $23e1af73ca596a78$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $23e1af73ca596a78$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let $23e1af73ca596a78$var$SHIFTED_RANK, $23e1af73ca596a78$var$EXCLUSIONS, $23e1af73ca596a78$var$DECOMP, $23e1af73ca596a78$var$RECOMP;
function $23e1af73ca596a78$var$init$1() {
    //console.time('nf');
    let r = $23e1af73ca596a78$var$read_compressed_payload($23e1af73ca596a78$var$COMPRESSED);
    $23e1af73ca596a78$var$SHIFTED_RANK = new Map($23e1af73ca596a78$var$read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    $23e1af73ca596a78$var$EXCLUSIONS = new Set($23e1af73ca596a78$var$read_sorted(r));
    $23e1af73ca596a78$var$DECOMP = new Map();
    $23e1af73ca596a78$var$RECOMP = new Map();
    for (let [cp, cps] of $23e1af73ca596a78$var$read_mapped(r)){
        if (!$23e1af73ca596a78$var$EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = $23e1af73ca596a78$var$RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                $23e1af73ca596a78$var$RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        $23e1af73ca596a78$var$DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $23e1af73ca596a78$var$is_hangul(cp) {
    return cp >= $23e1af73ca596a78$var$S0 && cp < $23e1af73ca596a78$var$S1;
}
function $23e1af73ca596a78$var$compose_pair(a, b) {
    if (a >= $23e1af73ca596a78$var$L0 && a < $23e1af73ca596a78$var$L1 && b >= $23e1af73ca596a78$var$V0 && b < $23e1af73ca596a78$var$V1) return $23e1af73ca596a78$var$S0 + (a - $23e1af73ca596a78$var$L0) * $23e1af73ca596a78$var$N_COUNT + (b - $23e1af73ca596a78$var$V0) * $23e1af73ca596a78$var$T_COUNT;
    else if ($23e1af73ca596a78$var$is_hangul(a) && b > $23e1af73ca596a78$var$T0 && b < $23e1af73ca596a78$var$T1 && (a - $23e1af73ca596a78$var$S0) % $23e1af73ca596a78$var$T_COUNT == 0) return a + (b - $23e1af73ca596a78$var$T0);
    else {
        let recomp = $23e1af73ca596a78$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $23e1af73ca596a78$var$decomposed(cps) {
    if (!$23e1af73ca596a78$var$SHIFTED_RANK) $23e1af73ca596a78$var$init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $23e1af73ca596a78$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($23e1af73ca596a78$var$is_hangul(cp)) {
            let s_index = cp - $23e1af73ca596a78$var$S0;
            let l_index = s_index / $23e1af73ca596a78$var$N_COUNT | 0;
            let v_index = s_index % $23e1af73ca596a78$var$N_COUNT / $23e1af73ca596a78$var$T_COUNT | 0;
            let t_index = s_index % $23e1af73ca596a78$var$T_COUNT;
            add($23e1af73ca596a78$var$L0 + l_index);
            add($23e1af73ca596a78$var$V0 + v_index);
            if (t_index > 0) add($23e1af73ca596a78$var$T0 + t_index);
        } else {
            let mapped = $23e1af73ca596a78$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $23e1af73ca596a78$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $23e1af73ca596a78$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $23e1af73ca596a78$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $23e1af73ca596a78$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $23e1af73ca596a78$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $23e1af73ca596a78$var$unpack_cc(packed);
        let cp = $23e1af73ca596a78$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $23e1af73ca596a78$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $23e1af73ca596a78$export$9d0d896b286a3dba(cps) {
    return $23e1af73ca596a78$var$decomposed(cps).map($23e1af73ca596a78$var$unpack_cp);
}
function $23e1af73ca596a78$export$f42252642e08449(cps) {
    return $23e1af73ca596a78$var$composed_from_decomposed($23e1af73ca596a78$var$decomposed(cps));
}
const $23e1af73ca596a78$var$HYPHEN = 0x2D;
const $23e1af73ca596a78$var$STOP = 0x2E;
const $23e1af73ca596a78$var$STOP_CH = ".";
const $23e1af73ca596a78$var$FE0F = 0xFE0F;
const $23e1af73ca596a78$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const $23e1af73ca596a78$var$Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function $23e1af73ca596a78$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class $23e1af73ca596a78$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let $23e1af73ca596a78$var$MAPPED, $23e1af73ca596a78$var$IGNORED, $23e1af73ca596a78$var$CM, $23e1af73ca596a78$var$NSM, $23e1af73ca596a78$var$ESCAPE, $23e1af73ca596a78$var$NFC_CHECK, $23e1af73ca596a78$var$GROUPS, $23e1af73ca596a78$var$WHOLE_VALID, $23e1af73ca596a78$var$WHOLE_MAP, $23e1af73ca596a78$var$VALID, $23e1af73ca596a78$var$EMOJI_LIST, $23e1af73ca596a78$var$EMOJI_ROOT;
function $23e1af73ca596a78$var$init() {
    if ($23e1af73ca596a78$var$MAPPED) return;
    let r = $23e1af73ca596a78$var$read_compressed_payload($23e1af73ca596a78$var$COMPRESSED$1);
    const read_sorted_array = ()=>$23e1af73ca596a78$var$read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    $23e1af73ca596a78$var$MAPPED = new Map($23e1af73ca596a78$var$read_mapped(r));
    $23e1af73ca596a78$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $23e1af73ca596a78$var$CM = read_sorted_array();
    $23e1af73ca596a78$var$NSM = new Set(read_sorted_array().map((i)=>$23e1af73ca596a78$var$CM[i]));
    $23e1af73ca596a78$var$CM = new Set($23e1af73ca596a78$var$CM);
    $23e1af73ca596a78$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $23e1af73ca596a78$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = $23e1af73ca596a78$var$read_sorted_arrays(r);
    let unrestricted = r();
    const read_chunked = ()=>new Set(read_sorted_array().flatMap((i)=>chunks[i]).concat(read_sorted_array()));
    $23e1af73ca596a78$var$GROUPS = $23e1af73ca596a78$var$read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = $23e1af73ca596a78$var$read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // first arent restricted
            N[0] -= 32; // capitalize
            N = $23e1af73ca596a78$var$str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $23e1af73ca596a78$var$WHOLE_VALID = read_sorted_set();
    $23e1af73ca596a78$var$WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat($23e1af73ca596a78$var$Array_from($23e1af73ca596a78$var$WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$23e1af73ca596a78$var$WHOLE_VALID.has(cp)) $23e1af73ca596a78$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    for (let { V: V, M: M } of new Set($23e1af73ca596a78$var$WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = $23e1af73ca596a78$var$GROUPS.filter((g)=>$23e1af73ca596a78$var$group_has_cp(g, cp));
            let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            gs.forEach((g)=>rec.G.add(g));
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>$23e1af73ca596a78$var$Array_from(x.G));
        for (let { G: G, V: V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g)));
            for (let cp of V)M.set(cp, complement);
        }
    }
    // compute valid set
    let union = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>union.has(cp) ? multi.add(cp) : union.add(cp);
    for (let g of $23e1af73ca596a78$var$GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of union)if (!$23e1af73ca596a78$var$WHOLE_MAP.has(cp) && !multi.has(cp)) $23e1af73ca596a78$var$WHOLE_MAP.set(cp, $23e1af73ca596a78$var$UNIQUE_PH);
    $23e1af73ca596a78$var$VALID = new Set($23e1af73ca596a78$var$Array_from(union).concat($23e1af73ca596a78$var$Array_from($23e1af73ca596a78$export$9d0d896b286a3dba(union)))); // possibly valid
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $23e1af73ca596a78$var$EMOJI_LIST = $23e1af73ca596a78$var$read_trie(r).map((v)=>$23e1af73ca596a78$var$Emoji.from(v)).sort($23e1af73ca596a78$var$compare_arrays);
    $23e1af73ca596a78$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of $23e1af73ca596a78$var$EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            $23e1af73ca596a78$var$EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === $23e1af73ca596a78$var$FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $23e1af73ca596a78$var$quoted_cp(cp) {
    return ($23e1af73ca596a78$export$4b1c9c18c687e5e9(cp) ? "" : `${$23e1af73ca596a78$var$bidi_qq($23e1af73ca596a78$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $23e1af73ca596a78$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $23e1af73ca596a78$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $23e1af73ca596a78$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $23e1af73ca596a78$var$HYPHEN && cps[3] == $23e1af73ca596a78$var$HYPHEN) throw new Error(`invalid label extension: "${$23e1af73ca596a78$var$str_from_cps(cps.slice(0, 4))}"`);
}
function $23e1af73ca596a78$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $23e1af73ca596a78$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $23e1af73ca596a78$var$FENCED.get(cp);
    if (prev) throw $23e1af73ca596a78$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $23e1af73ca596a78$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $23e1af73ca596a78$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $23e1af73ca596a78$var$error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $23e1af73ca596a78$export$6ec6f9a7f89f00db(cps, quoter = $23e1af73ca596a78$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($23e1af73ca596a78$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($23e1af73ca596a78$export$4b1c9c18c687e5e9(cp)) {
            buf.push($23e1af73ca596a78$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($23e1af73ca596a78$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $23e1af73ca596a78$export$e29a9e4d2573411c(cp) {
    $23e1af73ca596a78$var$init();
    return $23e1af73ca596a78$var$CM.has(cp);
}
function $23e1af73ca596a78$export$4b1c9c18c687e5e9(cp) {
    $23e1af73ca596a78$var$init();
    return $23e1af73ca596a78$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $23e1af73ca596a78$export$95d5ea4de7964366() {
    $23e1af73ca596a78$var$init();
    return $23e1af73ca596a78$var$EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function $23e1af73ca596a78$export$f4e6b2721065fb3d(frag, decompose) {
    $23e1af73ca596a78$var$init();
    let nf = decompose ? $23e1af73ca596a78$export$9d0d896b286a3dba : $23e1af73ca596a78$export$f42252642e08449;
    return frag.split($23e1af73ca596a78$var$STOP_CH).map((label)=>$23e1af73ca596a78$var$str_from_cps($23e1af73ca596a78$var$tokens_from_str($23e1af73ca596a78$var$explode_cp(label), nf, $23e1af73ca596a78$var$filter_fe0f).flat())).join($23e1af73ca596a78$var$STOP_CH);
}
function $23e1af73ca596a78$export$499f715881831a51(name) {
    return $23e1af73ca596a78$var$flatten($23e1af73ca596a78$var$split(name, $23e1af73ca596a78$export$f42252642e08449, $23e1af73ca596a78$var$filter_fe0f));
}
function $23e1af73ca596a78$export$d2ee080f6ab2341d(name) {
    let labels = $23e1af73ca596a78$var$split(name, $23e1af73ca596a78$export$f42252642e08449, (x)=>x); // emoji not exposed
    for (let { type: type, output: output, error: error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") {
            let prev = 0;
            while(true){
                let next = output.indexOf(0x3BE, prev);
                if (next < 0) break;
                output[next] = 0x39E;
                prev = next + 1;
            }
        }
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return $23e1af73ca596a78$var$flatten(labels);
}
function $23e1af73ca596a78$export$d2ba335951b08421(name, preserve_emoji) {
    return $23e1af73ca596a78$var$split(name, $23e1af73ca596a78$export$f42252642e08449, preserve_emoji ? (x)=>x.slice() : $23e1af73ca596a78$var$filter_fe0f); // emoji are exposed so copy
}
function $23e1af73ca596a78$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $23e1af73ca596a78$var$init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($23e1af73ca596a78$var$STOP_CH).map((label)=>{
        let input = $23e1af73ca596a78$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $23e1af73ca596a78$var$tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            $23e1af73ca596a78$var$check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                $23e1af73ca596a78$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($23e1af73ca596a78$var$CM.has(norm[0])) throw $23e1af73ca596a78$var$error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && $23e1af73ca596a78$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $23e1af73ca596a78$var$error_placement(`emoji + combining mark: "${$23e1af73ca596a78$var$str_from_cps(tokens[i - 1])} + ${$23e1af73ca596a78$export$6ec6f9a7f89f00db([
                            cps[0]
                        ])}"`);
                    }
                    $23e1af73ca596a78$var$check_fenced(norm);
                    let unique = $23e1af73ca596a78$var$Array_from(new Set(chars));
                    let [g] = $23e1af73ca596a78$var$determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $23e1af73ca596a78$var$check_group(g, chars); // need text in order
                    $23e1af73ca596a78$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $23e1af73ca596a78$var$check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = $23e1af73ca596a78$var$WHOLE_MAP.get(cp);
        if (whole === $23e1af73ca596a78$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : $23e1af73ca596a78$var$Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>$23e1af73ca596a78$var$group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $23e1af73ca596a78$var$determine_group(unique) {
    let groups = $23e1af73ca596a78$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>$23e1af73ca596a78$var$group_has_cp(g, cp));
        if (!gs.length) {
            if (!$23e1af73ca596a78$var$GROUPS.some((g)=>$23e1af73ca596a78$var$group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw $23e1af73ca596a78$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $23e1af73ca596a78$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $23e1af73ca596a78$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$23e1af73ca596a78$var$bidi_qq($23e1af73ca596a78$export$6ec6f9a7f89f00db(input))}: ${msg}`);
        }
        return $23e1af73ca596a78$var$str_from_cps(output);
    }).join($23e1af73ca596a78$var$STOP_CH);
}
function $23e1af73ca596a78$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$23e1af73ca596a78$var$quoted_cp(cp)}`);
}
function $23e1af73ca596a78$var$error_group_member(g, cp) {
    let quoted = $23e1af73ca596a78$var$quoted_cp(cp);
    let gg = $23e1af73ca596a78$var$GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $23e1af73ca596a78$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $23e1af73ca596a78$var$check_group(g, cps) {
    for (let cp of cps){
        if (!$23e1af73ca596a78$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $23e1af73ca596a78$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = $23e1af73ca596a78$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($23e1af73ca596a78$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $23e1af73ca596a78$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${$23e1af73ca596a78$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $23e1af73ca596a78$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${$23e1af73ca596a78$var$bidi_qq($23e1af73ca596a78$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$23e1af73ca596a78$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $23e1af73ca596a78$var$tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $23e1af73ca596a78$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if ($23e1af73ca596a78$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $23e1af73ca596a78$var$MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!$23e1af73ca596a78$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $23e1af73ca596a78$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $23e1af73ca596a78$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $23e1af73ca596a78$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $23e1af73ca596a78$var$consume_emoji_reversed(cps, eaten) {
    let node = $23e1af73ca596a78$var$EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V: V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const $23e1af73ca596a78$var$TY_VALID = "valid";
const $23e1af73ca596a78$var$TY_MAPPED = "mapped";
const $23e1af73ca596a78$var$TY_IGNORED = "ignored";
const $23e1af73ca596a78$var$TY_DISALLOWED = "disallowed";
const $23e1af73ca596a78$var$TY_EMOJI = "emoji";
const $23e1af73ca596a78$var$TY_NFC = "nfc";
const $23e1af73ca596a78$var$TY_STOP = "stop";
function $23e1af73ca596a78$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    $23e1af73ca596a78$var$init();
    let input = $23e1af73ca596a78$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $23e1af73ca596a78$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $23e1af73ca596a78$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $23e1af73ca596a78$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == $23e1af73ca596a78$var$STOP) tokens.push({
                type: $23e1af73ca596a78$var$TY_STOP,
                cp: cp
            });
            else if ($23e1af73ca596a78$var$VALID.has(cp)) tokens.push({
                type: $23e1af73ca596a78$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($23e1af73ca596a78$var$IGNORED.has(cp)) tokens.push({
                type: $23e1af73ca596a78$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $23e1af73ca596a78$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $23e1af73ca596a78$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $23e1af73ca596a78$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($23e1af73ca596a78$var$is_valid_or_mapped(token.type)) {
            if ($23e1af73ca596a78$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($23e1af73ca596a78$var$is_valid_or_mapped(type)) {
                        if (!$23e1af73ca596a78$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $23e1af73ca596a78$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$23e1af73ca596a78$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $23e1af73ca596a78$export$f42252642e08449(cps0);
                if ($23e1af73ca596a78$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $23e1af73ca596a78$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $23e1af73ca596a78$var$collapse_valid_tokens(slice),
                        tokens: $23e1af73ca596a78$export$bac129d8210aa825($23e1af73ca596a78$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $23e1af73ca596a78$var$TY_IGNORED) start = -1; // reset
    }
    return $23e1af73ca596a78$var$collapse_valid_tokens(tokens);
}
function $23e1af73ca596a78$var$is_valid_or_mapped(type) {
    return type == $23e1af73ca596a78$var$TY_VALID || type == $23e1af73ca596a78$var$TY_MAPPED;
}
function $23e1af73ca596a78$var$requires_check(cps) {
    return cps.some((cp)=>$23e1af73ca596a78$var$NFC_CHECK.has(cp));
}
function $23e1af73ca596a78$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $23e1af73ca596a78$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $23e1af73ca596a78$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $23e1af73ca596a78$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}

});


parcelRegister("l5W0K", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $NETJo = parcelRequire("NETJo");

var $hEqBT = parcelRequire("hEqBT");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $NETJo.validateField)(curve.Fp);
    (0, $hEqBT.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $NETJo.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});
parcelRegister("NETJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $hEqBT = parcelRequire("hEqBT");
// prettier-ignore
const $09544d2fcfd72b4a$var$_0n = BigInt(0), $09544d2fcfd72b4a$var$_1n = BigInt(1), $09544d2fcfd72b4a$var$_2n = BigInt(2), $09544d2fcfd72b4a$var$_3n = BigInt(3);
// prettier-ignore
const $09544d2fcfd72b4a$var$_4n = BigInt(4), $09544d2fcfd72b4a$var$_5n = BigInt(5), $09544d2fcfd72b4a$var$_8n = BigInt(8);
// prettier-ignore
const $09544d2fcfd72b4a$var$_9n = BigInt(9), $09544d2fcfd72b4a$var$_16n = BigInt(16);
// Calculates a modulo b
function $09544d2fcfd72b4a$var$mod(a, b) {
    const result = a % b;
    return result >= $09544d2fcfd72b4a$var$_0n ? result : b + result;
}
module.exports.mod = $09544d2fcfd72b4a$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $09544d2fcfd72b4a$var$pow(num, power, modulo) {
    if (modulo <= $09544d2fcfd72b4a$var$_0n || power < $09544d2fcfd72b4a$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $09544d2fcfd72b4a$var$_1n) return $09544d2fcfd72b4a$var$_0n;
    let res = $09544d2fcfd72b4a$var$_1n;
    while(power > $09544d2fcfd72b4a$var$_0n){
        if (power & $09544d2fcfd72b4a$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $09544d2fcfd72b4a$var$_1n;
    }
    return res;
}
module.exports.pow = $09544d2fcfd72b4a$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $09544d2fcfd72b4a$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $09544d2fcfd72b4a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $09544d2fcfd72b4a$var$pow2;
// Inverses number over modulo
function $09544d2fcfd72b4a$var$invert(number, modulo) {
    if (number === $09544d2fcfd72b4a$var$_0n || modulo <= $09544d2fcfd72b4a$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $09544d2fcfd72b4a$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $09544d2fcfd72b4a$var$_0n, y = $09544d2fcfd72b4a$var$_1n, u = $09544d2fcfd72b4a$var$_1n, v = $09544d2fcfd72b4a$var$_0n;
    while(a !== $09544d2fcfd72b4a$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $09544d2fcfd72b4a$var$_1n) throw new Error("invert: does not exist");
    return $09544d2fcfd72b4a$var$mod(x, modulo);
}
module.exports.invert = $09544d2fcfd72b4a$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $09544d2fcfd72b4a$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $09544d2fcfd72b4a$var$_1n) / $09544d2fcfd72b4a$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $09544d2fcfd72b4a$var$_1n, S = 0; Q % $09544d2fcfd72b4a$var$_2n === $09544d2fcfd72b4a$var$_0n; Q /= $09544d2fcfd72b4a$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $09544d2fcfd72b4a$var$_2n; Z < P && $09544d2fcfd72b4a$var$pow(Z, legendreC, P) !== P - $09544d2fcfd72b4a$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $09544d2fcfd72b4a$var$_1n) / $09544d2fcfd72b4a$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $09544d2fcfd72b4a$var$_1n) / $09544d2fcfd72b4a$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $09544d2fcfd72b4a$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $09544d2fcfd72b4a$var$tonelliShanks;
function $09544d2fcfd72b4a$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $09544d2fcfd72b4a$var$_4n === $09544d2fcfd72b4a$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $09544d2fcfd72b4a$var$_1n) / $09544d2fcfd72b4a$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $09544d2fcfd72b4a$var$_8n === $09544d2fcfd72b4a$var$_5n) {
        const c1 = (P - $09544d2fcfd72b4a$var$_5n) / $09544d2fcfd72b4a$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $09544d2fcfd72b4a$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $09544d2fcfd72b4a$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $09544d2fcfd72b4a$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $09544d2fcfd72b4a$var$tonelliShanks(P);
}
module.exports.FpSqrt = $09544d2fcfd72b4a$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $09544d2fcfd72b4a$var$isNegativeLE = (num, modulo)=>($09544d2fcfd72b4a$var$mod(num, modulo) & $09544d2fcfd72b4a$var$_1n) === $09544d2fcfd72b4a$var$_1n;
module.exports.isNegativeLE = $09544d2fcfd72b4a$var$isNegativeLE;
// prettier-ignore
const $09544d2fcfd72b4a$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $09544d2fcfd72b4a$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $09544d2fcfd72b4a$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $hEqBT.validateObject)(field, opts);
}
module.exports.validateField = $09544d2fcfd72b4a$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $09544d2fcfd72b4a$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $09544d2fcfd72b4a$var$_0n) throw new Error("Expected power > 0");
    if (power === $09544d2fcfd72b4a$var$_0n) return f.ONE;
    if (power === $09544d2fcfd72b4a$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $09544d2fcfd72b4a$var$_0n){
        if (power & $09544d2fcfd72b4a$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $09544d2fcfd72b4a$var$_1n;
    }
    return p;
}
module.exports.FpPow = $09544d2fcfd72b4a$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $09544d2fcfd72b4a$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $09544d2fcfd72b4a$var$FpInvertBatch;
function $09544d2fcfd72b4a$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $09544d2fcfd72b4a$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $09544d2fcfd72b4a$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $09544d2fcfd72b4a$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $09544d2fcfd72b4a$var$_1n) / $09544d2fcfd72b4a$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $09544d2fcfd72b4a$var$FpIsSquare;
// CURVE.n lengths
function $09544d2fcfd72b4a$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $09544d2fcfd72b4a$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $09544d2fcfd72b4a$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $09544d2fcfd72b4a$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $09544d2fcfd72b4a$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $09544d2fcfd72b4a$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $hEqBT.bitMask)(BITS),
        ZERO: $09544d2fcfd72b4a$var$_0n,
        ONE: $09544d2fcfd72b4a$var$_1n,
        create: (num)=>$09544d2fcfd72b4a$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $09544d2fcfd72b4a$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $09544d2fcfd72b4a$var$_0n,
        isOdd: (num)=>(num & $09544d2fcfd72b4a$var$_1n) === $09544d2fcfd72b4a$var$_1n,
        neg: (num)=>$09544d2fcfd72b4a$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$09544d2fcfd72b4a$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$09544d2fcfd72b4a$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$09544d2fcfd72b4a$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$09544d2fcfd72b4a$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$09544d2fcfd72b4a$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$09544d2fcfd72b4a$var$mod(lhs * $09544d2fcfd72b4a$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$09544d2fcfd72b4a$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$09544d2fcfd72b4a$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $hEqBT.numberToBytesLE)(num, BYTES) : (0, $hEqBT.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $hEqBT.bytesToNumberLE)(bytes) : (0, $hEqBT.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $09544d2fcfd72b4a$var$Field;
function $09544d2fcfd72b4a$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $09544d2fcfd72b4a$var$FpSqrtOdd;
function $09544d2fcfd72b4a$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $09544d2fcfd72b4a$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $09544d2fcfd72b4a$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $hEqBT.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $09544d2fcfd72b4a$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $hEqBT.bytesToNumberLE)(hash) : (0, $hEqBT.bytesToNumberBE)(hash);
    return $09544d2fcfd72b4a$var$mod(num, groupOrder - $09544d2fcfd72b4a$var$_1n) + $09544d2fcfd72b4a$var$_1n;
}
module.exports.hashToPrivateScalar = $09544d2fcfd72b4a$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $09544d2fcfd72b4a$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $09544d2fcfd72b4a$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $09544d2fcfd72b4a$var$getMinHashLength(fieldOrder) {
    const length = $09544d2fcfd72b4a$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $09544d2fcfd72b4a$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $09544d2fcfd72b4a$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $09544d2fcfd72b4a$var$getFieldBytesLength(fieldOrder);
    const minLen = $09544d2fcfd72b4a$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $hEqBT.bytesToNumberBE)(key) : (0, $hEqBT.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $09544d2fcfd72b4a$var$mod(num, fieldOrder - $09544d2fcfd72b4a$var$_1n) + $09544d2fcfd72b4a$var$_1n;
    return isLE ? (0, $hEqBT.numberToBytesLE)(reduced, fieldLen) : (0, $hEqBT.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $09544d2fcfd72b4a$var$mapHashToField;

});


parcelRegister("f9v1x", function(module, exports) {

$parcel$export(module.exports, "Mode", () => Qa);
$parcel$export(module.exports, "JSONEditor", () => R6);

var $gbdt3 = parcelRequire("gbdt3");
var e, t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M, E, A, P, T, R, N, I, D, z, q, B, L, F, V, H, W, U, J, K, G, Q, Y, X, Z, ee, te, ne, re, oe, ie, ae, se, ce, le, ue, fe, de, he, ve, pe, me, ge, ye, be, we, xe, ke, je, Se, Ce, $e, _e, Oe, Me, Ee, Ae, Pe, Te, Re, Ne, Ie, De, ze, qe, Be, Le, Fe, Ve, He, We, Ue, Je, Ke, Ge, Qe, Ye, Xe, Ze, et, tt, nt, rt, ot, it, at, st, ct, lt, ut, ft, dt, ht, vt, pt, mt, gt, yt, bt, wt, xt, kt, jt, St, Ct, $t, _t, Ot, Mt, Et, At, Pt, Tt, Rt, Nt, It, Dt, zt, qt, Bt, Lt, Ft, Vt, Ht, Wt, Ut, Jt, Kt, Gt, Qt, Yt, Xt, Zt, en, tn, nn, rn, on, an, sn, cn, ln, un, fn, dn, hn, vn, pn, mn, gn, yn, bn, wn, xn, kn, jn, Sn, Cn, $n, _n, On, Mn, En, An, Pn, Tn, Rn, Nn, In, Dn, zn, qn, Bn, Ln, Fn, Vn, Hn, Wn, Un, Jn, Kn, Gn, Qn, Yn, Xn, Zn, er, tr, nr, rr, or, ir, ar, sr, cr, lr, ur, fr, dr, hr, vr, pr, mr, gr, yr, br, wr, xr, kr, jr, Sr, Cr, $r, _r, Or, Mr, Er, Ar, Pr, Tr, Rr, Nr, Ir, Dr, zr, qr, Br, Lr, Fr, Vr, Hr, Wr, Ur, Jr, Kr, Gr, Qr, Yr, Xr, Zr, eo, to, no, ro, oo, io, ao, so, co, lo, uo, fo, ho, vo = [
    "mainAxis",
    "crossAxis",
    "fallbackPlacements",
    "fallbackStrategy",
    "fallbackAxisSideDirection",
    "flipAlignment"
], po = [
    "mainAxis",
    "crossAxis",
    "limiter"
];
function mo(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
function go() {
    return go = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, n) {
        var r = function(e, t) {
            for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Mo(e)););
            return e;
        }(e, t);
        if (r) {
            var o = Object.getOwnPropertyDescriptor(r, t);
            return o.get ? o.get.call(arguments.length < 3 ? e : n) : o.value;
        }
    }, go.apply(this, arguments);
}
function yo(e, t) {
    if (null == e) return {};
    var n, r, o = function(e, t) {
        if (null == e) return {};
        var n, r, o = {}, i = Object.keys(e);
        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
    return o;
}
function bo(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = Lo(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0, o = function() {};
            return {
                s: o,
                n: function() {
                    return r >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[r++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: o
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i, a = !0, s = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return a = e.done, e;
        },
        e: function(e) {
            s = !0, i = e;
        },
        f: function() {
            try {
                a || null == n.return || n.return();
            } finally{
                if (s) throw i;
            }
        }
    };
}
function wo() {
    wo = function() {
        return t;
    };
    var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(e, t, n) {
        e[t] = n.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", c = i.toStringTag || "@@toStringTag";
    function l(e, t, n) {
        return Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), e[t];
    }
    try {
        l({}, "");
    } catch (e) {
        l = function(e, t, n) {
            return e[t] = n;
        };
    }
    function u(e, t, n, r) {
        var i = t && t.prototype instanceof g ? t : g, a = Object.create(i.prototype), s = new E(r || []);
        return o(a, "_invoke", {
            value: $(e, n, s)
        }), a;
    }
    function f(e, t, n) {
        try {
            return {
                type: "normal",
                arg: e.call(t, n)
            };
        } catch (e) {
            return {
                type: "throw",
                arg: e
            };
        }
    }
    t.wrap = u;
    var d = "suspendedStart", h = "suspendedYield", v = "executing", p = "completed", m = {};
    function g() {}
    function y() {}
    function b() {}
    var w = {};
    l(w, a, function() {
        return this;
    });
    var x = Object.getPrototypeOf, k = x && x(x(A([])));
    k && k !== n && r.call(k, a) && (w = k);
    var j = b.prototype = g.prototype = Object.create(w);
    function S(e) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(t) {
            l(e, t, function(e) {
                return this._invoke(t, e);
            });
        });
    }
    function C(e, t) {
        function n(o, i, a, s) {
            var c = f(e[o], e, i);
            if ("throw" !== c.type) {
                var l = c.arg, u = l.value;
                return u && "object" == Ho(u) && r.call(u, "__await") ? t.resolve(u.__await).then(function(e) {
                    n("next", e, a, s);
                }, function(e) {
                    n("throw", e, a, s);
                }) : t.resolve(u).then(function(e) {
                    l.value = e, a(l);
                }, function(e) {
                    return n("throw", e, a, s);
                });
            }
            s(c.arg);
        }
        var i;
        o(this, "_invoke", {
            value: function(e, r) {
                function o() {
                    return new t(function(t, o) {
                        n(e, r, t, o);
                    });
                }
                return i = i ? i.then(o, o) : o();
            }
        });
    }
    function $(t, n, r) {
        var o = d;
        return function(i, a) {
            if (o === v) throw new Error("Generator is already running");
            if (o === p) {
                if ("throw" === i) throw a;
                return {
                    value: e,
                    done: !0
                };
            }
            for(r.method = i, r.arg = a;;){
                var s = r.delegate;
                if (s) {
                    var c = _(s, r);
                    if (c) {
                        if (c === m) continue;
                        return c;
                    }
                }
                if ("next" === r.method) r.sent = r._sent = r.arg;
                else if ("throw" === r.method) {
                    if (o === d) throw o = p, r.arg;
                    r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                o = v;
                var l = f(t, n, r);
                if ("normal" === l.type) {
                    if (o = r.done ? p : h, l.arg === m) continue;
                    return {
                        value: l.arg,
                        done: r.done
                    };
                }
                "throw" === l.type && (o = p, r.method = "throw", r.arg = l.arg);
            }
        };
    }
    function _(t, n) {
        var r = n.method, o = t.iterator[r];
        if (o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, _(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), m;
        var i = f(o, t.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, m) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m);
    }
    function O(e) {
        var t = {
            tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function M(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
    }
    function E(e) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], e.forEach(O, this), this.reset(!0);
    }
    function A(t) {
        if (t || "" === t) {
            var n = t[a];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
                var o = -1, i = function n() {
                    for(; ++o < t.length;)if (r.call(t, o)) return n.value = t[o], n.done = !1, n;
                    return n.value = e, n.done = !0, n;
                };
                return i.next = i;
            }
        }
        throw new TypeError(Ho(t) + " is not iterable");
    }
    return y.prototype = b, o(j, "constructor", {
        value: b,
        configurable: !0
    }), o(b, "constructor", {
        value: y,
        configurable: !0
    }), y.displayName = l(b, c, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
    }, t.mark = function(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, l(e, c, "GeneratorFunction")), e.prototype = Object.create(j), e;
    }, t.awrap = function(e) {
        return {
            __await: e
        };
    }, S(C.prototype), l(C.prototype, s, function() {
        return this;
    }), t.AsyncIterator = C, t.async = function(e, n, r, o, i) {
        void 0 === i && (i = Promise);
        var a = new C(u(e, n, r, o), i);
        return t.isGeneratorFunction(n) ? a : a.next().then(function(e) {
            return e.done ? e.value : a.next();
        });
    }, S(j), l(j, c, "Generator"), l(j, a, function() {
        return this;
    }), l(j, "toString", function() {
        return "[object Generator]";
    }), t.keys = function(e) {
        var t = Object(e), n = [];
        for(var r in t)n.push(r);
        return n.reverse(), function e() {
            for(; n.length;){
                var r = n.pop();
                if (r in t) return e.value = r, e.done = !1, e;
            }
            return e.done = !0, e;
        };
    }, t.values = A, E.prototype = {
        constructor: E,
        reset: function(t) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(M), !t) for(var n in this)"t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
        },
        stop: function() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
        },
        dispatchException: function(t) {
            if (this.done) throw t;
            var n = this;
            function o(r, o) {
                return s.type = "throw", s.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var a = this.tryEntries[i], s = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                    var c = r.call(a, "catchLoc"), l = r.call(a, "finallyLoc");
                    if (c && l) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    } else if (c) {
                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    } else {
                        if (!l) throw new Error("try statement without catch or finally");
                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(e, t) {
            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                var o = this.tryEntries[n];
                if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function(e) {
            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), M(n), m;
            }
        },
        catch: function(e) {
            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                    var r = n.completion;
                    if ("throw" === r.type) {
                        var o = r.arg;
                        M(n);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(t, n, r) {
            return this.delegate = {
                iterator: A(t),
                resultName: n,
                nextLoc: r
            }, "next" === this.method && (this.arg = e), m;
        }
    }, t;
}
function xo(e, t, n, r, o, i, a) {
    try {
        var s = e[i](a), c = s.value;
    } catch (e) {
        return void n(e);
    }
    s.done ? t(c) : Promise.resolve(c).then(r, o);
}
function ko(e) {
    return function() {
        var t = this, n = arguments;
        return new Promise(function(r, o) {
            var i = e.apply(t, n);
            function a(e) {
                xo(i, r, o, a, s, "next", e);
            }
            function s(e) {
                xo(i, r, o, a, s, "throw", e);
            }
            a(void 0);
        });
    };
}
function jo(e, t) {
    return Co(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null != n) {
            var r, o, i, a, s = [], c = !0, l = !1;
            try {
                if (i = (n = n.call(e)).next, 0 === t) {
                    if (Object(n) !== n) return;
                    c = !1;
                } else for(; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
            } catch (e) {
                l = !0, o = e;
            } finally{
                try {
                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                } finally{
                    if (l) throw o;
                }
            }
            return s;
        }
    }(e, t) || Lo(e, t) || So();
}
function So() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Co(e) {
    if (Array.isArray(e)) return e;
}
function $o(e) {
    var t = "function" == typeof Map ? new Map : void 0;
    return $o = function(e) {
        if (null === e || !function(e) {
            try {
                return -1 !== Function.toString.call(e).indexOf("[native code]");
            } catch (t) {
                return "function" == typeof e;
            }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
            if (t.has(e)) return t.get(e);
            t.set(e, n);
        }
        function n() {
            return function(e, t, n) {
                if (Oo()) return Reflect.construct.apply(null, arguments);
                var r = [
                    null
                ];
                r.push.apply(r, t);
                var o = new (e.bind.apply(e, r));
                return n && Po(o, n.prototype), o;
            }(e, arguments, Mo(this).constructor);
        }
        return n.prototype = Object.create(e.prototype, {
            constructor: {
                value: n,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), Po(n, e);
    }, $o(e);
}
function _o(e, t, n) {
    return t = Mo(t), function(e, t) {
        if (t && ("object" === Ho(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return Eo(e);
    }(e, Oo() ? Reflect.construct(t, n || [], Mo(e).constructor) : t.apply(e, n));
}
function Oo() {
    try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (e) {}
    return (Oo = function() {
        return !!e;
    })();
}
function Mo(e) {
    return Mo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, Mo(e);
}
function Eo(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function Ao(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && Po(e, t);
}
function Po(e, t) {
    return Po = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }, Po(e, t);
}
function To(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function Ro(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? To(Object(n), !0).forEach(function(t) {
            zo(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : To(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function No(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Io(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qo(r.key), r);
    }
}
function Do(e, t, n) {
    return t && Io(e.prototype, t), n && Io(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function zo(e, t, n) {
    return (t = qo(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function qo(e) {
    var t = function(e, t) {
        if ("object" != Ho(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
            var r = n.call(e, t || "default");
            if ("object" != Ho(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == Ho(t) ? t : String(t);
}
function Bo(e) {
    return function(e) {
        if (Array.isArray(e)) return Vo(e);
    }(e) || Fo(e) || Lo(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function Lo(e, t) {
    if (e) {
        if ("string" == typeof e) return Vo(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Vo(e, t) : void 0;
    }
}
function Fo(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function Vo(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function Ho(e) {
    return Ho = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, Ho(e);
}
function Wo() {}
var Uo = function(e) {
    return e;
};
function Jo(e, t) {
    for(var n in t)e[n] = t[n];
    return e;
}
function Ko(e) {
    return e();
}
function Go() {
    return Object.create(null);
}
function Qo(e) {
    e.forEach(Ko);
}
function Yo(e) {
    return "function" == typeof e;
}
function Xo(e, t) {
    return e != e ? t == t : e !== t || e && "object" === Ho(e) || "function" == typeof e;
}
function Zo(e, t) {
    return e != e ? t == t : e !== t;
}
function ei(e, t, n, r) {
    if (e) {
        var o = ti(e, t, n, r);
        return e[0](o);
    }
}
function ti(e, t, n, r) {
    return e[1] && r ? Jo(n.ctx.slice(), e[1](r(t))) : n.ctx;
}
function ni(e, t, n, r) {
    if (e[2] && r) {
        var o = e[2](r(n));
        if (void 0 === t.dirty) return o;
        if ("object" === Ho(o)) {
            for(var i = [], a = Math.max(t.dirty.length, o.length), s = 0; s < a; s += 1)i[s] = t.dirty[s] | o[s];
            return i;
        }
        return t.dirty | o;
    }
    return t.dirty;
}
function ri(e, t, n, r, o, i) {
    if (o) {
        var a = ti(t, n, r, i);
        e.p(a, o);
    }
}
function oi(e) {
    if (e.ctx.length > 32) {
        for(var t = [], n = e.ctx.length / 32, r = 0; r < n; r++)t[r] = -1;
        return t;
    }
    return -1;
}
function ii(e) {
    var t = {};
    for(var n in e)"$" !== n[0] && (t[n] = e[n]);
    return t;
}
function ai(e, t) {
    var n = {};
    for(var r in t = new Set(t), e)t.has(r) || "$" === r[0] || (n[r] = e[r]);
    return n;
}
function si(e) {
    return null == e ? "" : e;
}
function ci(e) {
    return e && Yo(e.destroy) ? e.destroy : Wo;
}
var li = "undefined" != typeof window, ui = li ? function() {
    return window.performance.now();
} : function() {
    return Date.now();
}, fi = li ? function(e) {
    return requestAnimationFrame(e);
} : Wo, di = new Set;
function hi(e) {
    di.forEach(function(t) {
        t.c(e) || (di.delete(t), t.f());
    }), 0 !== di.size && fi(hi);
}
var vi = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : $parcel$global;
function pi(e, t) {
    e.appendChild(t);
}
function mi(e, t, n) {
    var r = gi(e);
    if (!r.getElementById(t)) {
        var o = ji("style");
        o.id = t, o.textContent = n, bi(r, o);
    }
}
function gi(e) {
    if (!e) return document;
    var t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return t && t.host ? t : e.ownerDocument;
}
function yi(e) {
    var t = ji("style");
    return t.textContent = "/* empty */", bi(gi(e), t), t.sheet;
}
function bi(e, t) {
    return pi(e.head || e, t), t.sheet;
}
function wi(e, t, n) {
    e.insertBefore(t, n || null);
}
function xi(e) {
    e.parentNode && e.parentNode.removeChild(e);
}
function ki(e, t) {
    for(var n = 0; n < e.length; n += 1)e[n] && e[n].d(t);
}
function ji(e) {
    return document.createElement(e);
}
function Si(e) {
    return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function Ci(e) {
    return document.createTextNode(e);
}
function $i() {
    return Ci(" ");
}
function _i() {
    return Ci("");
}
function Oi(e, t, n, r) {
    return e.addEventListener(t, n, r), function() {
        return e.removeEventListener(t, n, r);
    };
}
function Mi(e) {
    return function(t) {
        return t.preventDefault(), e.call(this, t);
    };
}
function Ei(e) {
    return function(t) {
        return t.stopPropagation(), e.call(this, t);
    };
}
function Ai(e, t, n) {
    null == n ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
var Pi = [
    "width",
    "height"
];
function Ti(e, t) {
    var n = Object.getOwnPropertyDescriptors(e.__proto__);
    for(var r in t)null == t[r] ? e.removeAttribute(r) : "style" === r ? e.style.cssText = t[r] : "__value" === r ? e.value = e[r] = t[r] : n[r] && n[r].set && -1 === Pi.indexOf(r) ? e[r] = t[r] : Ai(e, r, t[r]);
}
function Ri(e, t) {
    for(var n in t)Ai(e, n, t[n]);
}
function Ni(e, t) {
    t = "" + t, e.data !== t && (e.data = t);
}
function Ii(e, t) {
    e.value = null == t ? "" : t;
}
function Di(e, t, n, r) {
    null == n ? e.style.removeProperty(t) : e.style.setProperty(t, n, r ? "important" : "");
}
function zi(e, t, n) {
    for(var r = 0; r < e.options.length; r += 1){
        var o = e.options[r];
        if (o.__value === t) return void (o.selected = !0);
    }
    n && void 0 === t || (e.selectedIndex = -1);
}
function qi(e, t, n) {
    e.classList.toggle(t, !!n);
}
function Bi(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = n.bubbles, o = void 0 !== r && r, i = n.cancelable;
    return new CustomEvent(e, {
        detail: t,
        bubbles: o,
        cancelable: void 0 !== i && i
    });
}
function Li(e, t) {
    return new e(t);
}
var Fi, Vi = new Map, Hi = 0;
function Wi(e, t, n, r, o, i, a) {
    for(var s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0, c = 16.666 / r, l = "{\n", u = 0; u <= 1; u += c){
        var f = t + (n - t) * i(u);
        l += 100 * u + "%{".concat(a(f, 1 - f), "}\n");
    }
    var d = l + "100% {".concat(a(n, 1 - n), "}\n}"), h = "__svelte_".concat(function(e) {
        for(var t = 5381, n = e.length; n--;)t = (t << 5) - t ^ e.charCodeAt(n);
        return t >>> 0;
    }(d), "_").concat(s), v = gi(e), p = Vi.get(v) || function(e, t) {
        var n = {
            stylesheet: yi(t),
            rules: {}
        };
        return Vi.set(e, n), n;
    }(v, e), m = p.stylesheet, g = p.rules;
    g[h] || (g[h] = !0, m.insertRule("@keyframes ".concat(h, " ").concat(d), m.cssRules.length));
    var y = e.style.animation || "";
    return e.style.animation = "".concat(y ? "".concat(y, ", ") : "").concat(h, " ").concat(r, "ms linear ").concat(o, "ms 1 both"), Hi += 1, h;
}
function Ui(e, t) {
    var n = (e.style.animation || "").split(", "), r = n.filter(t ? function(e) {
        return e.indexOf(t) < 0;
    } : function(e) {
        return -1 === e.indexOf("__svelte");
    }), o = n.length - r.length;
    o && (e.style.animation = r.join(", "), (Hi -= o) || fi(function() {
        Hi || (Vi.forEach(function(e) {
            var t = e.stylesheet.ownerNode;
            t && xi(t);
        }), Vi.clear());
    }));
}
function Ji(e) {
    Fi = e;
}
function Ki() {
    if (!Fi) throw new Error("Function called outside component initialization");
    return Fi;
}
function Gi(e) {
    Ki().$$.on_mount.push(e);
}
function Qi(e) {
    Ki().$$.on_destroy.push(e);
}
function Yi() {
    var e = Ki();
    return function(t, n) {
        var r = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).cancelable, o = void 0 !== r && r, i = e.$$.callbacks[t];
        if (i) {
            var a = Bi(t, n, {
                cancelable: o
            });
            return i.slice().forEach(function(t) {
                t.call(e, a);
            }), !a.defaultPrevented;
        }
        return !0;
    };
}
function Xi(e, t) {
    return Ki().$$.context.set(e, t), t;
}
function Zi(e) {
    return Ki().$$.context.get(e);
}
function ea(e, t) {
    var n = this, r = e.$$.callbacks[t.type];
    r && r.slice().forEach(function(e) {
        return e.call(n, t);
    });
}
var ta = [], na = [], ra = [], oa = [], ia = Promise.resolve(), aa = !1;
function sa() {
    aa || (aa = !0, ia.then(va));
}
function ca() {
    return sa(), ia;
}
function la(e) {
    ra.push(e);
}
function ua(e) {
    oa.push(e);
}
var fa, da = new Set, ha = 0;
function va() {
    if (0 === ha) {
        var e = Fi;
        do {
            try {
                for(; ha < ta.length;){
                    var t = ta[ha];
                    ha++, Ji(t), pa(t.$$);
                }
            } catch (e) {
                throw ta.length = 0, ha = 0, e;
            }
            for(Ji(null), ta.length = 0, ha = 0; na.length;)na.pop()();
            for(var n = 0; n < ra.length; n += 1){
                var r = ra[n];
                da.has(r) || (da.add(r), r());
            }
            ra.length = 0;
        }while (ta.length);
        for(; oa.length;)oa.pop()();
        aa = !1, da.clear(), Ji(e);
    }
}
function pa(e) {
    if (null !== e.fragment) {
        e.update(), Qo(e.before_update);
        var t = e.dirty;
        e.dirty = [
            -1
        ], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(la);
    }
}
function ma(e, t, n) {
    e.dispatchEvent(Bi("".concat(t ? "intro" : "outro").concat(n)));
}
var ga, ya = new Set;
function ba() {
    ga = {
        r: 0,
        c: [],
        p: ga
    };
}
function wa() {
    ga.r || Qo(ga.c), ga = ga.p;
}
function xa(e, t) {
    e && e.i && (ya.delete(e), e.i(t));
}
function ka(e, t, n, r) {
    if (e && e.o) {
        if (ya.has(e)) return;
        ya.add(e), ga.c.push(function() {
            ya.delete(e), r && (n && e.d(1), r());
        }), e.o(t);
    } else r && r();
}
var ja = {
    duration: 0
};
function Sa(e, t, n, r) {
    var o, i = t(e, n, {
        direction: "both"
    }), a = r ? 0 : 1, s = null, c = null, l = null;
    function u() {
        l && Ui(e, l);
    }
    function f(e, t) {
        var n = e.b - a;
        return t *= Math.abs(n), {
            a: a,
            b: e.b,
            d: n,
            duration: t,
            start: e.start,
            end: e.start + t,
            group: e.group
        };
    }
    function d(t) {
        var n, r = i || ja, d = r.delay, h = void 0 === d ? 0 : d, v = r.duration, p = void 0 === v ? 300 : v, m = r.easing, g = void 0 === m ? Uo : m, y = r.tick, b = void 0 === y ? Wo : y, w = r.css, x = {
            start: ui() + h,
            b: t
        };
        t || (x.group = ga, ga.r += 1), "inert" in e && (t ? void 0 !== o && (e.inert = o) : (o = e.inert, e.inert = !0)), s || c ? c = x : (w && (u(), l = Wi(e, a, t, p, h, g, w)), t && b(0, 1), s = f(x, p), la(function() {
            return ma(e, t, "start");
        }), n = function(t) {
            if (c && t > c.start && (s = f(c, p), c = null, ma(e, s.b, "start"), w && (u(), l = Wi(e, a, s.b, s.duration, 0, g, i.css))), s) {
                if (t >= s.end) b(a = s.b, 1 - a), ma(e, s.b, "end"), c || (s.b ? u() : --s.group.r || Qo(s.group.c)), s = null;
                else if (t >= s.start) {
                    var n = t - s.start;
                    a = s.a + s.d * g(n / s.duration), b(a, 1 - a);
                }
            }
            return !(!s && !c);
        }, 0 === di.size && fi(hi), new Promise(function(e) {
            di.add({
                c: n,
                f: e
            });
        }));
    }
    return {
        run: function(e) {
            Yo(i) ? (fa || (fa = Promise.resolve()).then(function() {
                fa = null;
            }), fa).then(function() {
                i = i({
                    direction: e ? "in" : "out"
                }), d(e);
            }) : d(e);
        },
        end: function() {
            u(), s = c = null;
        }
    };
}
function Ca(e) {
    return void 0 !== (null == e ? void 0 : e.length) ? e : Array.from(e);
}
function $a(e, t) {
    e.d(1), t.delete(e.key);
}
function _a(e, t) {
    ka(e, 1, 1, function() {
        t.delete(e.key);
    });
}
function Oa(e, t, n, r, o, i, a, s, c, l, u, f) {
    for(var d = e.length, h = i.length, v = d, p = {}; v--;)p[e[v].key] = v;
    var m = [], g = new Map, y = new Map, b = [];
    v = h;
    for(var w = function() {
        var e = f(o, i, v), s = n(e), c = a.get(s);
        c ? r && b.push(function() {
            return c.p(e, t);
        }) : (c = l(s, e)).c(), g.set(s, m[v] = c), (s in p) && y.set(s, Math.abs(v - p[s]));
    }; v--;)w();
    var x = new Set, k = new Set;
    function j(e) {
        xa(e, 1), e.m(s, u), a.set(e.key, e), u = e.first, h--;
    }
    for(; d && h;){
        var S = m[h - 1], C = e[d - 1], $ = S.key, _ = C.key;
        S === C ? (u = S.first, d--, h--) : g.has(_) ? !a.has($) || x.has($) ? j(S) : k.has(_) ? d-- : y.get($) > y.get(_) ? (k.add($), j(S)) : (x.add(_), d--) : (c(C, a), d--);
    }
    for(; d--;){
        var O = e[d];
        g.has(O.key) || c(O, a);
    }
    for(; h;)j(m[h - 1]);
    return Qo(b), m;
}
function Ma(e, t) {
    for(var n = {}, r = {}, o = {
        $$scope: 1
    }, i = e.length; i--;){
        var a = e[i], s = t[i];
        if (s) {
            for(var c in a)c in s || (r[c] = 1);
            for(var l in s)o[l] || (n[l] = s[l], o[l] = 1);
            e[i] = s;
        } else for(var u in a)o[u] = 1;
    }
    for(var f in r)f in n || (n[f] = void 0);
    return n;
}
function Ea(e) {
    return "object" === Ho(e) && null !== e ? e : {};
}
function Aa(e, t, n) {
    var r = e.$$.props[t];
    void 0 !== r && (e.$$.bound[r] = n, n(e.$$.ctx[r]));
}
function Pa(e) {
    e && e.c();
}
function Ta(e, t, n) {
    var r = e.$$, o = r.fragment, i = r.after_update;
    o && o.m(t, n), la(function() {
        var t, n = e.$$.on_mount.map(Ko).filter(Yo);
        e.$$.on_destroy ? (t = e.$$.on_destroy).push.apply(t, Bo(n)) : Qo(n);
        e.$$.on_mount = [];
    }), i.forEach(la);
}
function Ra(e, t) {
    var n, r, o, i = e.$$;
    null !== i.fragment && (n = i.after_update, r = [], o = [], ra.forEach(function(e) {
        return -1 === n.indexOf(e) ? r.push(e) : o.push(e);
    }), o.forEach(function(e) {
        return e();
    }), ra = r, Qo(i.on_destroy), i.fragment && i.fragment.d(t), i.on_destroy = i.fragment = null, i.ctx = []);
}
function Na(e, t, n, r, o, i) {
    var a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : [
        -1
    ], c = Fi;
    Ji(e);
    var l = e.$$ = {
        fragment: null,
        ctx: [],
        props: i,
        update: Wo,
        not_equal: o,
        bound: Go(),
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(t.context || (c ? c.$$.context : [])),
        callbacks: Go(),
        dirty: s,
        skip_bound: !1,
        root: t.target || c.$$.root
    };
    a && a(l.root);
    var u = !1;
    if (l.ctx = n ? n(e, t.props || {}, function(t, n) {
        var r = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : n;
        return l.ctx && o(l.ctx[t], l.ctx[t] = r) && (!l.skip_bound && l.bound[t] && l.bound[t](r), u && function(e, t) {
            -1 === e.$$.dirty[0] && (ta.push(e), sa(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
        }(e, t)), n;
    }) : [], l.update(), u = !0, Qo(l.before_update), l.fragment = !!r && r(l.ctx), t.target) {
        if (t.hydrate) {
            var f = function(e) {
                return Array.from(e.childNodes);
            }(t.target);
            l.fragment && l.fragment.l(f), f.forEach(xi);
        } else l.fragment && l.fragment.c();
        t.intro && xa(e.$$.fragment), Ta(e, t.target, t.anchor), va();
    }
    Ji(c);
}
var Ia = function() {
    function e() {
        No(this, e), zo(this, "$$", void 0), zo(this, "$$set", void 0);
    }
    return Do(e, [
        {
            key: "$destroy",
            value: function() {
                Ra(this, 1), this.$destroy = Wo;
            }
        },
        {
            key: "$on",
            value: function(e, t) {
                if (!Yo(t)) return Wo;
                var n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
                return n.push(t), function() {
                    var e = n.indexOf(t);
                    -1 !== e && n.splice(e, 1);
                };
            }
        },
        {
            key: "$set",
            value: function(e) {
                var t;
                this.$$set && (t = e, 0 !== Object.keys(t).length) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
            }
        }
    ]), e;
}();
function Da(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(e) {
        var t = function(e) {
            try {
                if ("undefined" != typeof window && void 0 !== window.localStorage) return window.localStorage[e];
            } catch (e) {}
        }("debug");
        return null != t && t.endsWith("*") ? e.startsWith(t.slice(0, -1)) : e === t;
    }(e);
    if (!t) return za;
    var n = function(e) {
        for(var t = 0, n = 0; n < e.length; n++)t = (t << 5) - t + e.charCodeAt(n), t |= 0;
        return qa[Math.abs(t) % qa.length];
    }(e);
    return function() {
        for(var t, r = arguments.length, o = new Array(r), i = 0; i < r; i++)o[i] = arguments[i];
        (t = console).log.apply(t, [
            "%c".concat(e),
            "color:".concat(n)
        ].concat(o));
    };
}
function za() {}
"undefined" != typeof window && (window.__svelte || (window.__svelte = {
    v: new Set
})).v.add("4");
var qa = [
    "#0000CC",
    "#0099FF",
    "#009400",
    "#8dd200",
    "#CCCC00",
    "#CC9933",
    "#ae04e7",
    "#ff35d7",
    "#FF3333",
    "#FF6600",
    "#FF9933",
    "#FFCC33"
];
function Ba(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.delay, r = void 0 === n ? 0 : n, o = t.duration, i = void 0 === o ? 400 : o, a = t.easing, s = void 0 === a ? Uo : a, c = +getComputedStyle(e).opacity;
    return {
        delay: r,
        duration: i,
        easing: s,
        css: function(e) {
            return "opacity: ".concat(e * c);
        }
    };
}
var La = vi.window;
function Fa(e) {
    mi(e, "svelte-n7cvum", ".svelte-n7cvum{box-sizing:border-box}.bg.svelte-n7cvum{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}@supports (-webkit-touch-callout: none){}.wrap.svelte-n7cvum{position:relative;margin:2rem;max-height:100%}.window.svelte-n7cvum{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-n7cvum{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-n7cvum{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-n7cvum:before,.close.svelte-n7cvum:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-n7cvum:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-n7cvum:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-n7cvum:hover{background:black}.close.svelte-n7cvum:hover:before,.close.svelte-n7cvum:hover:after{height:2px;background:white}.close.svelte-n7cvum:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-n7cvum:active{transform:scale(0.9)}.close.svelte-n7cvum:hover,.close.svelte-n7cvum:focus,.close.svelte-n7cvum:active{outline:none}");
}
function Va(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b = e[1].closeButton && Ha(e), w = e[2];
    return w && (a = Li(w, {})), {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("div"), b && b.c(), o = $i(), i = ji("div"), a && Pa(a.$$.fragment), Ai(i, "class", s = si(e[1].classContent) + " svelte-n7cvum"), Ai(i, "style", e[9]), qi(i, "content", !e[0]), Ai(r, "class", c = si(e[1].classWindow) + " svelte-n7cvum"), Ai(r, "role", "dialog"), Ai(r, "aria-modal", "true"), Ai(r, "aria-label", l = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null), Ai(r, "aria-labelledby", u = e[1].ariaLabelledBy || null), Ai(r, "style", e[8]), qi(r, "window", !e[0]), Ai(n, "class", d = si(e[1].classWindowWrap) + " svelte-n7cvum"), Ai(n, "style", e[7]), qi(n, "wrap", !e[0]), Ai(t, "aria-hidden", "true"), Ai(t, "id", h = e[1].id), Ai(t, "class", v = si(e[1].classBg) + " svelte-n7cvum"), Ai(t, "style", e[6]), qi(t, "bg", !e[0]);
        },
        m: function(s, c) {
            wi(s, t, c), pi(t, n), pi(n, r), b && b.m(r, null), pi(r, o), pi(r, i), a && Ta(a, i, null), e[50](r), e[51](n), e[52](t), m = !0, g || (y = [
                Oi(r, "introstart", function() {
                    Yo(e[13]) && e[13].apply(this, arguments);
                }),
                Oi(r, "outrostart", function() {
                    Yo(e[14]) && e[14].apply(this, arguments);
                }),
                Oi(r, "introend", function() {
                    Yo(e[15]) && e[15].apply(this, arguments);
                }),
                Oi(r, "outroend", function() {
                    Yo(e[16]) && e[16].apply(this, arguments);
                }),
                Oi(t, "mousedown", e[20]),
                Oi(t, "mouseup", e[21])
            ], g = !0);
        },
        p: function(f, p) {
            if ((e = f)[1].closeButton ? b ? (b.p(e, p), 2 & p[0] && xa(b, 1)) : ((b = Ha(e)).c(), xa(b, 1), b.m(r, o)) : b && (ba(), ka(b, 1, 1, function() {
                b = null;
            }), wa()), 4 & p[0] && w !== (w = e[2])) {
                if (a) {
                    ba();
                    var g = a;
                    ka(g.$$.fragment, 1, 0, function() {
                        Ra(g, 1);
                    }), wa();
                }
                w ? (Pa((a = Li(w, {})).$$.fragment), xa(a.$$.fragment, 1), Ta(a, i, null)) : a = null;
            }
            (!m || 2 & p[0] && s !== (s = si(e[1].classContent) + " svelte-n7cvum")) && Ai(i, "class", s), (!m || 512 & p[0]) && Ai(i, "style", e[9]), (!m || 3 & p[0]) && qi(i, "content", !e[0]), (!m || 2 & p[0] && c !== (c = si(e[1].classWindow) + " svelte-n7cvum")) && Ai(r, "class", c), (!m || 2 & p[0] && l !== (l = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null)) && Ai(r, "aria-label", l), (!m || 2 & p[0] && u !== (u = e[1].ariaLabelledBy || null)) && Ai(r, "aria-labelledby", u), (!m || 256 & p[0]) && Ai(r, "style", e[8]), (!m || 3 & p[0]) && qi(r, "window", !e[0]), (!m || 2 & p[0] && d !== (d = si(e[1].classWindowWrap) + " svelte-n7cvum")) && Ai(n, "class", d), (!m || 128 & p[0]) && Ai(n, "style", e[7]), (!m || 3 & p[0]) && qi(n, "wrap", !e[0]), (!m || 2 & p[0] && h !== (h = e[1].id)) && Ai(t, "id", h), (!m || 2 & p[0] && v !== (v = si(e[1].classBg) + " svelte-n7cvum")) && Ai(t, "class", v), (!m || 64 & p[0]) && Ai(t, "style", e[6]), (!m || 3 & p[0]) && qi(t, "bg", !e[0]);
        },
        i: function(n) {
            m || (xa(b), a && xa(a.$$.fragment, n), n && la(function() {
                m && (f || (f = Sa(r, e[12], e[1].transitionWindowProps, !0)), f.run(1));
            }), n && la(function() {
                m && (p || (p = Sa(t, e[11], e[1].transitionBgProps, !0)), p.run(1));
            }), m = !0);
        },
        o: function(n) {
            ka(b), a && ka(a.$$.fragment, n), n && (f || (f = Sa(r, e[12], e[1].transitionWindowProps, !1)), f.run(0)), n && (p || (p = Sa(t, e[11], e[1].transitionBgProps, !1)), p.run(0)), m = !1;
        },
        d: function(n) {
            n && xi(t), b && b.d(), a && Ra(a), e[50](null), n && f && f.end(), e[51](null), e[52](null), n && p && p.end(), g = !1, Qo(y);
        }
    };
}
function Ha(e) {
    var t, n, r, o, i, a = [
        Ua,
        Wa
    ], s = [];
    function c(e, n) {
        return 2 & n[0] && (t = null), null == t && (t = !!e[17](e[1].closeButton)), t ? 0 : 1;
    }
    return n = c(e, [
        -1,
        -1,
        -1
    ]), r = s[n] = a[n](e), {
        c: function() {
            r.c(), o = _i();
        },
        m: function(e, t) {
            s[n].m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, t) {
            var i = n;
            (n = c(e, t)) === i ? s[n].p(e, t) : (ba(), ka(s[i], 1, 1, function() {
                s[i] = null;
            }), wa(), (r = s[n]) ? r.p(e, t) : (r = s[n] = a[n](e)).c(), xa(r, 1), r.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(o), s[n].d(e);
        }
    };
}
function Wa(e) {
    var t, n, r, o;
    return {
        c: function() {
            Ai(t = ji("button"), "class", n = si(e[1].classCloseButton) + " svelte-n7cvum"), Ai(t, "aria-label", "Close modal"), Ai(t, "style", e[10]), Ai(t, "type", "button"), qi(t, "close", !e[0]);
        },
        m: function(n, i) {
            wi(n, t, i), r || (o = Oi(t, "click", e[18]), r = !0);
        },
        p: function(e, r) {
            2 & r[0] && n !== (n = si(e[1].classCloseButton) + " svelte-n7cvum") && Ai(t, "class", n), 1024 & r[0] && Ai(t, "style", e[10]), 3 & r[0] && qi(t, "close", !e[0]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), r = !1, o();
        }
    };
}
function Ua(e) {
    var t, n, r, o = e[1].closeButton;
    function i(e, t) {
        return {
            props: {
                onClose: e[18]
            }
        };
    }
    return o && (t = Li(o, i(e))), {
        c: function() {
            t && Pa(t.$$.fragment), n = _i();
        },
        m: function(e, o) {
            t && Ta(t, e, o), wi(e, n, o), r = !0;
        },
        p: function(e, r) {
            if (2 & r[0] && o !== (o = e[1].closeButton)) {
                if (t) {
                    ba();
                    var a = t;
                    ka(a.$$.fragment, 1, 0, function() {
                        Ra(a, 1);
                    }), wa();
                }
                o ? (Pa((t = Li(o, i(e))).$$.fragment), xa(t.$$.fragment, 1), Ta(t, n.parentNode, n)) : t = null;
            }
        },
        i: function(e) {
            r || (t && xa(t.$$.fragment, e), r = !0);
        },
        o: function(e) {
            t && ka(t.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(n), t && Ra(t, e);
        }
    };
}
function Ja(e) {
    var t, n, r, o, i = e[2] && Va(e), a = e[49].default, s = ei(a, e, e[48], null);
    return {
        c: function() {
            i && i.c(), t = $i(), s && s.c();
        },
        m: function(a, c) {
            i && i.m(a, c), wi(a, t, c), s && s.m(a, c), n = !0, r || (o = Oi(La, "keydown", e[19]), r = !0);
        },
        p: function(e, r) {
            e[2] ? i ? (i.p(e, r), 4 & r[0] && xa(i, 1)) : ((i = Va(e)).c(), xa(i, 1), i.m(t.parentNode, t)) : i && (ba(), ka(i, 1, 1, function() {
                i = null;
            }), wa()), s && s.p && (!n || 131072 & r[1]) && ri(s, a, e, e[48], n ? ni(a, e[48], r, null) : oi(e[48]), null);
        },
        i: function(e) {
            n || (xa(i), xa(s, e), n = !0);
        },
        o: function(e) {
            ka(i), ka(s, e), n = !1;
        },
        d: function(e) {
            e && xi(t), i && i.d(e), s && s.d(e), r = !1, o();
        }
    };
}
function Ka(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return function(n) {
        return new e(Ro(Ro({}, n), {}, {
            props: Ro(Ro({}, t), n.props)
        }));
    };
}
function Ga(e, t, n) {
    var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y = t.$$slots, b = void 0 === y ? {} : y, w = t.$$scope, x = Yi(), k = Xi, j = t.isTabbable, S = void 0 === j ? function(e) {
        return e.tabIndex >= 0 && !e.hidden && !e.disabled && "none" !== e.style.display && "hidden" !== e.type && Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    } : j, C = t.show, $ = void 0 === C ? null : C, _ = t.id, O = void 0 === _ ? null : _, M = t.key, E = void 0 === M ? "simple-modal" : M, A = t.ariaLabel, P = void 0 === A ? null : A, T = t.ariaLabelledBy, R = void 0 === T ? null : T, N = t.closeButton, I = void 0 === N || N, D = t.closeOnEsc, z = void 0 === D || D, q = t.closeOnOuterClick, B = void 0 === q || q, L = t.styleBg, F = void 0 === L ? {} : L, V = t.styleWindowWrap, H = void 0 === V ? {} : V, W = t.styleWindow, U = void 0 === W ? {} : W, J = t.styleContent, K = void 0 === J ? {} : J, G = t.styleCloseButton, Q = void 0 === G ? {} : G, Y = t.classBg, X = void 0 === Y ? null : Y, Z = t.classWindowWrap, ee = void 0 === Z ? null : Z, te = t.classWindow, ne = void 0 === te ? null : te, re = t.classContent, oe = void 0 === re ? null : re, ie = t.classCloseButton, ae = void 0 === ie ? null : ie, se = t.unstyled, ce = void 0 !== se && se, le = t.setContext, ue = void 0 === le ? k : le, fe = t.transitionBg, de = void 0 === fe ? Ba : fe, he = t.transitionBgProps, ve = void 0 === he ? {
        duration: 250
    } : he, pe = t.transitionWindow, me = void 0 === pe ? de : pe, ge = t.transitionWindowProps, ye = void 0 === ge ? ve : ge, be = t.disableFocusTrap, we = void 0 !== be && be, xe = {
        id: O,
        ariaLabel: P,
        ariaLabelledBy: R,
        closeButton: I,
        closeOnEsc: z,
        closeOnOuterClick: B,
        styleBg: F,
        styleWindowWrap: H,
        styleWindow: U,
        styleContent: K,
        styleCloseButton: Q,
        classBg: X,
        classWindowWrap: ee,
        classWindow: ne,
        classContent: oe,
        classCloseButton: ae,
        transitionBg: de,
        transitionBgProps: ve,
        transitionWindow: me,
        transitionWindowProps: ye,
        disableFocusTrap: we,
        isTabbable: S,
        unstyled: ce
    }, ke = Ro({}, xe), je = null, Se = function(e) {
        return e ? Object.keys(e).reduce(function(t, n) {
            return "".concat(t, "; ").concat(function(e) {
                return e.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
            }(n), ": ").concat(e[n]);
        }, "") : "";
    }, Ce = function(e) {
        return !!(e && e.constructor && e.call && e.apply);
    }, $e = function() {}, _e = $e, Oe = $e, Me = $e, Ee = $e, Ae = function(e) {
        var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        n(2, je = Ka(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {})), n(1, ke = Ro(Ro({}, xe), t)), n(6, s = Se(Object.assign({}, {
            width: window.innerWidth,
            height: window.innerHeight
        }, ke.styleBg))), n(7, c = Se(ke.styleWindowWrap)), n(8, l = Se(ke.styleWindow)), n(9, u = Se(ke.styleContent)), n(10, f = Se(ke.styleCloseButton)), n(11, d = ke.transitionBg), n(12, h = ke.transitionWindow), Te(), n(13, _e = function(e) {
            r.onOpen && r.onOpen(e), x("open"), x("opening");
        }), n(14, Oe = function(e) {
            r.onClose && r.onClose(e), x("close"), x("closing");
        }), n(15, Me = function(e) {
            r.onOpened && r.onOpened(e), x("opened");
        }), n(16, Ee = function(e) {
            r.onClosed && r.onClosed(e), x("closed");
        });
    }, Pe = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        je && (n(14, Oe = e.onClose || Oe), n(16, Ee = e.onClosed || Ee), n(2, je = null), Re());
    }, Te = function() {
        a = window.scrollY, v = document.body.style.position, p = document.body.style.overflow, m = document.body.style.width, document.body.style.position = "fixed", document.body.style.top = "-".concat(a, "px"), document.body.style.overflow = "hidden", document.body.style.width = "100%";
    }, Re = function() {
        document.body.style.position = v || "", document.body.style.top = "", document.body.style.overflow = p || "", document.body.style.width = m || "", window.scrollTo({
            top: a,
            left: 0,
            behavior: "instant"
        });
    };
    ue(E, {
        open: Ae,
        close: Pe
    });
    var Ne = !1;
    return Qi(function() {
        Ne && Pe();
    }), Gi(function() {
        n(47, Ne = !0);
    }), e.$$set = function(e) {
        "isTabbable" in e && n(22, S = e.isTabbable), "show" in e && n(23, $ = e.show), "id" in e && n(24, O = e.id), "key" in e && n(25, E = e.key), "ariaLabel" in e && n(26, P = e.ariaLabel), "ariaLabelledBy" in e && n(27, R = e.ariaLabelledBy), "closeButton" in e && n(28, I = e.closeButton), "closeOnEsc" in e && n(29, z = e.closeOnEsc), "closeOnOuterClick" in e && n(30, B = e.closeOnOuterClick), "styleBg" in e && n(31, F = e.styleBg), "styleWindowWrap" in e && n(32, H = e.styleWindowWrap), "styleWindow" in e && n(33, U = e.styleWindow), "styleContent" in e && n(34, K = e.styleContent), "styleCloseButton" in e && n(35, Q = e.styleCloseButton), "classBg" in e && n(36, X = e.classBg), "classWindowWrap" in e && n(37, ee = e.classWindowWrap), "classWindow" in e && n(38, ne = e.classWindow), "classContent" in e && n(39, oe = e.classContent), "classCloseButton" in e && n(40, ae = e.classCloseButton), "unstyled" in e && n(0, ce = e.unstyled), "setContext" in e && n(41, ue = e.setContext), "transitionBg" in e && n(42, de = e.transitionBg), "transitionBgProps" in e && n(43, ve = e.transitionBgProps), "transitionWindow" in e && n(44, me = e.transitionWindow), "transitionWindowProps" in e && n(45, ye = e.transitionWindowProps), "disableFocusTrap" in e && n(46, we = e.disableFocusTrap), "$$scope" in e && n(48, w = e.$$scope);
    }, e.$$.update = function() {
        8388608 & e.$$.dirty[0] | 65536 & e.$$.dirty[1] && Ne && (Ce($) ? Ae($) : Pe());
    }, [
        ce,
        ke,
        je,
        r,
        o,
        i,
        s,
        c,
        l,
        u,
        f,
        d,
        h,
        _e,
        Oe,
        Me,
        Ee,
        Ce,
        Pe,
        function(e) {
            if (ke.closeOnEsc && je && "Escape" === e.key && (e.preventDefault(), Pe()), je && "Tab" === e.key && !ke.disableFocusTrap) {
                var t = i.querySelectorAll("*"), n = Array.from(t).filter(ke.isTabbable).sort(function(e, t) {
                    return e.tabIndex - t.tabIndex;
                }), r = n.indexOf(document.activeElement);
                -1 === r && e.shiftKey && (r = 0), r += n.length + (e.shiftKey ? -1 : 1), n[r %= n.length].focus(), e.preventDefault();
            }
        },
        function(e) {
            !ke.closeOnOuterClick || e.target !== r && e.target !== o || (g = e.target);
        },
        function(e) {
            ke.closeOnOuterClick && e.target === g && (e.preventDefault(), Pe());
        },
        S,
        $,
        O,
        E,
        P,
        R,
        I,
        z,
        B,
        F,
        H,
        U,
        K,
        Q,
        X,
        ee,
        ne,
        oe,
        ae,
        ue,
        de,
        ve,
        me,
        ye,
        we,
        Ne,
        w,
        b,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(5, i = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(4, o = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(3, r = e);
            });
        }
    ];
}
var Qa, Ya, Xa, Za, es, ts, ns, rs = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, Ga, Ja, Xo, {
            isTabbable: 22,
            show: 23,
            id: 24,
            key: 25,
            ariaLabel: 26,
            ariaLabelledBy: 27,
            closeButton: 28,
            closeOnEsc: 29,
            closeOnOuterClick: 30,
            styleBg: 31,
            styleWindowWrap: 32,
            styleWindow: 33,
            styleContent: 34,
            styleCloseButton: 35,
            classBg: 36,
            classWindowWrap: 37,
            classWindow: 38,
            classContent: 39,
            classCloseButton: 40,
            unstyled: 0,
            setContext: 41,
            transitionBg: 42,
            transitionBgProps: 43,
            transitionWindow: 44,
            transitionWindowProps: 45,
            disableFocusTrap: 46
        }, Fa, [
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t);
}();
!function(e) {
    e.text = "text", e.tree = "tree", e.table = "table";
}(Qa || (Qa = {})), function(e) {
    e.after = "after", e.inside = "inside", e.key = "key", e.value = "value", e.multi = "multi", e.text = "text";
}(Ya || (Ya = {})), function(e) {
    e.after = "after", e.key = "key", e.value = "value", e.inside = "inside";
}(Xa || (Xa = {})), function(e) {
    e.info = "info", e.warning = "warning", e.error = "error";
}(Za || (Za = {})), function(e) {
    e.key = "key", e.value = "value";
}(es || (es = {})), function(e) {
    e.asc = "asc", e.desc = "desc";
}(ts || (ts = {})), function(e) {
    e.no = "no", e.self = "self", e.nextInside = "nextInside";
}(ns || (ns = {}));
var os = 50, is = 200, as = 400, ss = 1200, cs = 1e3, ls = 100, us = 100, fs = 2e4, ds = [
    {
        start: 0,
        end: ls
    }
], hs = 104857600, vs = 1048576, ps = 10485760, ms = 10240, gs = {
    closeButton: !1,
    classBg: "jse-modal-bg",
    classWindow: "jse-modal-window",
    classWindowWrap: "jse-modal-window-wrap",
    classContent: "jse-modal-container"
}, ys = Ro(Ro({}, gs), {}, {
    classWindow: "jse-modal-window jse-modal-window-sort"
}), bs = Ro(Ro({}, gs), {}, {
    classWindow: "jse-modal-window jse-modal-window-transform"
}), ws = Ro(Ro({}, gs), {}, {
    classWindow: "jse-modal-window jse-modal-window-jsoneditor"
}), xs = "Insert or paste contents, enter [ insert a new array, enter { to insert a new object, or start typing to insert a new value", ks = "Open context menu (Click here, right click on the selection, or use the context menu button or Ctrl+Q)", js = "hover-insert-inside", Ss = "hover-insert-after", Cs = "hover-collection", $s = "valid", _s = "repairable", Os = 336, Ms = 260, Es = zo(zo({}, ts.asc, "ascending"), ts.desc, "descending"), As = 0;
function Ps() {
    return ++As;
}
function Ts(e) {
    return Array.isArray(e);
}
function Rs(e) {
    return null !== e && "object" === Ho(e) && (void 0 === e.constructor || "Object" === e.constructor.name);
}
function Ns(e) {
    return !(!e || "object" !== Ho(e)) && "add" === e.op;
}
function Is(e) {
    return !(!e || "object" !== Ho(e)) && "remove" === e.op;
}
function Ds(e) {
    return !(!e || "object" !== Ho(e)) && "replace" === e.op;
}
function zs(e) {
    return !(!e || "object" !== Ho(e)) && "copy" === e.op;
}
function qs(e) {
    return !(!e || "object" !== Ho(e)) && "move" === e.op;
}
function Bs(e, t) {
    return e === t;
}
function Ls(e) {
    return e.slice(0, e.length - 1);
}
function Fs(e) {
    return "object" === Ho(e) && null !== e;
}
function Vs(e) {
    if (Ts(e)) {
        var t = e.slice();
        return Object.getOwnPropertySymbols(e).forEach(function(n) {
            t[n] = e[n];
        }), t;
    }
    if (Rs(e)) {
        var n = Ro({}, e);
        return Object.getOwnPropertySymbols(e).forEach(function(t) {
            n[t] = e[t];
        }), n;
    }
    return e;
}
function Hs(e, t, n) {
    if (e[t] === n) return e;
    var r = Vs(e);
    return r[t] = n, r;
}
function Ws(e, t) {
    for(var n = e, r = 0; r < t.length;)n = Rs(n) ? n[t[r]] : Ts(n) ? n[parseInt(t[r])] : void 0, r++;
    return n;
}
function Us(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (0 === t.length) return n;
    var o = t[0], i = Us(e ? e[o] : void 0, t.slice(1), n, r);
    if (Rs(e) || Ts(e)) return Hs(e, o, i);
    if (r) {
        var a = Js.test(o) ? [] : {};
        return a[o] = i, a;
    }
    throw new Error("Path does not exist");
}
var Js = /^\d+$/;
function Ks(e, t, n) {
    if (0 === t.length) return n(e);
    if (!Fs(e)) throw new Error("Path doesn't exist");
    var r = t[0];
    return Hs(e, r, Ks(e[r], t.slice(1), n));
}
function Gs(e, t) {
    if (0 === t.length) return e;
    if (!Fs(e)) throw new Error("Path does not exist");
    if (1 === t.length) {
        var n = t[0];
        if (n in e) {
            var r = Vs(e);
            return Ts(r) && r.splice(parseInt(n), 1), Rs(r) && delete r[n], r;
        }
        return e;
    }
    var o = t[0];
    return Hs(e, o, Gs(e[o], t.slice(1)));
}
function Qs(e, t, n) {
    var r = t.slice(0, t.length - 1), o = t[t.length - 1];
    return Ks(e, r, function(e) {
        if (!Array.isArray(e)) throw new TypeError("Array expected at path " + JSON.stringify(r));
        var t = Vs(e);
        return t.splice(parseInt(o), 0, n), t;
    });
}
function Ys(e, t) {
    return void 0 !== e && (0 === t.length || null !== e && Ys(e[t[0]], t.slice(1)));
}
function Xs(e) {
    var t = e.split("/");
    return t.shift(), t.map(function(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
    });
}
function Zs(e) {
    return e.map(ec).join("");
}
function ec(e) {
    return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
}
function tc(e, t) {
    return e + ec(t);
}
function nc(e, t) {
    return e.startsWith(t) && (e.length === t.length || "/" === e[t.length]);
}
function rc(e, t, n) {
    for(var r = e, o = 0; o < t.length; o++){
        fc(t[o]);
        var i = t[o];
        if (n && n.before) {
            var a = n.before(r, i);
            if (void 0 !== a) {
                if (void 0 !== a.document && (r = a.document), void 0 !== a.json) throw new Error('Deprecation warning: returned object property ".json" has been renamed to ".document"');
                void 0 !== a.operation && (i = a.operation);
            }
        }
        var s = r, c = dc(r, i.path);
        if ("add" === i.op) r = ac(r, c, i.value);
        else if ("remove" === i.op) r = ic(r, c);
        else if ("replace" === i.op) r = oc(r, c, i.value);
        else if ("copy" === i.op) r = sc(r, c, hc(i.from));
        else if ("move" === i.op) r = cc(r, c, hc(i.from));
        else {
            if ("test" !== i.op) throw new Error("Unknown JSONPatch operation " + JSON.stringify(i));
            lc(r, c, i.value);
        }
        if (n && n.after) {
            var l = n.after(r, i, s);
            void 0 !== l && (r = l);
        }
    }
    return r;
}
function oc(e, t, n) {
    return Us(e, t, n);
}
function ic(e, t) {
    return Gs(e, t);
}
function ac(e, t, n) {
    return uc(e, t) ? Qs(e, t, n) : Us(e, t, n);
}
function sc(e, t, n) {
    var r = Ws(e, n);
    return uc(e, t) ? Qs(e, t, r) : Us(e, t, Ws(e, n));
}
function cc(e, t, n) {
    var r = Ws(e, n), o = Gs(e, n);
    return uc(o, t) ? Qs(o, t, r) : Us(o, t, r);
}
function lc(e, t, n) {
    if (void 0 === n) throw new Error('Test failed: no value provided (path: "'.concat(Zs(t), '")'));
    if (!Ys(e, t)) throw new Error('Test failed: path not found (path: "'.concat(Zs(t), '")'));
    var r, o, i = Ws(e, t);
    if (r = i, o = n, JSON.stringify(r) !== JSON.stringify(o)) throw new Error('Test failed, value differs (path: "'.concat(Zs(t), '")'));
}
function uc(e, t) {
    if (0 === t.length) return !1;
    var n = Ws(e, Ls(t));
    return Array.isArray(n);
}
function fc(e) {
    if (![
        "add",
        "remove",
        "replace",
        "copy",
        "move",
        "test"
    ].includes(e.op)) throw new Error("Unknown JSONPatch op " + JSON.stringify(e.op));
    if ("string" != typeof e.path) throw new Error('Required property "path" missing or not a string in operation ' + JSON.stringify(e));
    if (("copy" === e.op || "move" === e.op) && "string" != typeof e.from) throw new Error('Required property "from" missing or not a string in operation ' + JSON.stringify(e));
}
function dc(e, t) {
    return function(e, t) {
        if ("-" !== function(e) {
            return e[e.length - 1];
        }(t)) return t;
        var n = Ls(t), r = Ws(e, n);
        return n.concat(r.length);
    }(e, Xs(t));
}
function hc(e) {
    return Xs(e);
}
function vc(e, t, n) {
    var r = [];
    return rc(e, t, {
        before: function(e, t) {
            var o, i, a = dc(e, t.path);
            if ("add" === t.op) o = gc(e, a);
            else if ("remove" === t.op) o = mc(e, a);
            else if ("replace" === t.op) o = pc(e, a);
            else if ("copy" === t.op) o = function(e, t) {
                return gc(e, t);
            }(e, a);
            else if ("move" === t.op) o = function(e, t, n) {
                if (t.length < n.length && function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Bs;
                    if (e.length < t.length) return !1;
                    for(var r = 0; r < t.length; r++)if (!n(e[r], t[r])) return !1;
                    return !0;
                }(n, t)) return [
                    {
                        op: "replace",
                        path: Zs(t),
                        value: e
                    }
                ];
                var r = {
                    op: "move",
                    from: Zs(t),
                    path: Zs(n)
                };
                return !uc(e, t) && Ys(e, t) ? [
                    r
                ].concat(Bo(mc(e, t))) : [
                    r
                ];
            }(e, a, hc(t.from));
            else {
                if ("test" !== t.op) throw new Error("Unknown JSONPatch operation " + JSON.stringify(t));
                o = [];
            }
            if (n && n.before) {
                var s = n.before(e, t, o);
                if (s && s.revertOperations && (o = s.revertOperations), s && s.document && (i = s.document), s && s.json) throw new Error('Deprecation warning: returned object property ".json" has been renamed to ".document"');
            }
            if (r = o.concat(r), void 0 !== i) return {
                document: i
            };
        }
    }), r;
}
function pc(e, t) {
    return [
        {
            op: "replace",
            path: Zs(t),
            value: Ws(e, t)
        }
    ];
}
function mc(e, t) {
    return [
        {
            op: "add",
            path: Zs(t),
            value: Ws(e, t)
        }
    ];
}
function gc(e, t) {
    return uc(e, t) || !Ys(e, t) ? [
        {
            op: "remove",
            path: Zs(t)
        }
    ] : pc(e, t);
}
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
function yc(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bc = {}, wc = {
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	",
    '"': '"',
    "/": "/",
    "\\": "\\"
}, xc = "a".charCodeAt();
bc.parse = function(e, t, n) {
    var r = {}, o = 0, i = 0, a = 0, s = n && n.bigint && "undefined" != typeof BigInt;
    return {
        data: c("", !0),
        pointers: r
    };
    function c(t, n) {
        var r;
        l(), m(t, "value");
        var o = d();
        switch(o){
            case "t":
                f("rue"), r = !0;
                break;
            case "f":
                f("alse"), r = !1;
                break;
            case "n":
                f("ull"), r = null;
                break;
            case '"':
                r = u();
                break;
            case "[":
                r = function(e) {
                    l();
                    var t = [], n = 0;
                    if ("]" == d()) return t;
                    h();
                    for(;;){
                        var r = e + "/" + n;
                        t.push(c(r)), l();
                        var o = d();
                        if ("]" == o) break;
                        "," != o && w(), l(), n++;
                    }
                    return t;
                }(t);
                break;
            case "{":
                r = function(e) {
                    l();
                    var t = {};
                    if ("}" == d()) return t;
                    h();
                    for(;;){
                        var n = y();
                        '"' != d() && w();
                        var r = u(), o = e + "/" + Tc(r);
                        g(o, "key", n), m(o, "keyEnd"), l(), ":" != d() && w(), l(), t[r] = c(o), l();
                        var i = d();
                        if ("}" == i) break;
                        "," != i && w(), l();
                    }
                    return t;
                }(t);
                break;
            default:
                h(), "-0123456789".indexOf(o) >= 0 ? r = function() {
                    var t = "", n = !0;
                    "-" == e[a] && (t += d());
                    t += "0" == e[a] ? d() : p(), "." == e[a] && (t += d() + p(), n = !1);
                    "e" != e[a] && "E" != e[a] || (t += d(), "+" != e[a] && "-" != e[a] || (t += d()), t += p(), n = !1);
                    var r = +t;
                    return s && n && (r > Number.MAX_SAFE_INTEGER || r < Number.MIN_SAFE_INTEGER) ? BigInt(t) : r;
                }() : b();
        }
        return m(t, "valueEnd"), l(), n && a < e.length && b(), r;
    }
    function l() {
        e: for(; a < e.length;){
            switch(e[a]){
                case " ":
                    i++;
                    break;
                case "	":
                    i += 4;
                    break;
                case "\r":
                    i = 0;
                    break;
                case "\n":
                    i = 0, o++;
                    break;
                default:
                    break e;
            }
            a++;
        }
    }
    function u() {
        for(var e, t = ""; '"' != (e = d());)"\\" == e ? (e = d()) in wc ? t += wc[e] : "u" == e ? t += v() : w() : t += e;
        return t;
    }
    function f(e) {
        for(var t = 0; t < e.length; t++)d() !== e[t] && w();
    }
    function d() {
        x();
        var t = e[a];
        return a++, i++, t;
    }
    function h() {
        a--, i--;
    }
    function v() {
        for(var e = 4, t = 0; e--;){
            t <<= 4;
            var n = d().toLowerCase();
            n >= "a" && n <= "f" ? t += n.charCodeAt() - xc + 10 : n >= "0" && n <= "9" ? t += +n : w();
        }
        return String.fromCharCode(t);
    }
    function p() {
        for(var t = ""; e[a] >= "0" && e[a] <= "9";)t += d();
        if (t.length) return t;
        x(), b();
    }
    function m(e, t) {
        g(e, t, y());
    }
    function g(e, t, n) {
        r[e] = r[e] || {}, r[e][t] = n;
    }
    function y() {
        return {
            line: o,
            column: i,
            pos: a
        };
    }
    function b() {
        throw new SyntaxError("Unexpected token " + e[a] + " in JSON at position " + a);
    }
    function w() {
        h(), b();
    }
    function x() {
        if (a >= e.length) throw new SyntaxError("Unexpected end of JSON input");
    }
}, bc.stringify = function(e, t, n) {
    if (jc(e)) {
        var r, o, i = 0, a = "object" == Ho(n) ? n.space : n;
        switch(Ho(a)){
            case "number":
                var s = a > 10 ? 10 : a < 0 ? 0 : Math.floor(a);
                a = s && y(s, " "), r = s, o = s;
                break;
            case "string":
                a = a.slice(0, 10), r = 0, o = 0;
                for(var c = 0; c < a.length; c++){
                    switch(a[c]){
                        case " ":
                            o++;
                            break;
                        case "	":
                            o += 4;
                            break;
                        case "\r":
                            o = 0;
                            break;
                        case "\n":
                            o = 0, i++;
                            break;
                        default:
                            throw new Error("whitespace characters not allowed in JSON");
                    }
                    r++;
                }
                break;
            default:
                a = void 0;
        }
        var l = "", u = {}, f = 0, d = 0, h = 0, v = n && n.es6 && "function" == typeof Map;
        return function e(t, n, r) {
            switch(g(r, "value"), Ho(t)){
                case "number":
                case "bigint":
                case "boolean":
                    p("" + t);
                    break;
                case "string":
                    p(Ec(t));
                    break;
                case "object":
                    null === t ? p("null") : "function" == typeof t.toJSON ? p(Ec(t.toJSON())) : Array.isArray(t) ? o() : v ? t.constructor.BYTES_PER_ELEMENT ? o() : t instanceof Map ? s() : t instanceof Set ? s(!0) : i() : i();
            }
            function o() {
                if (t.length) {
                    p("[");
                    for(var o = n + 1, i = 0; i < t.length; i++){
                        i && p(","), m(o);
                        var a = jc(t[i]) ? t[i] : null;
                        e(a, o, r + "/" + i);
                    }
                    m(n), p("]");
                } else p("[]");
            }
            function i() {
                var o = Object.keys(t);
                if (o.length) {
                    p("{");
                    for(var i = n + 1, s = 0; s < o.length; s++){
                        var c = o[s], l = t[c];
                        if (jc(l)) {
                            s && p(",");
                            var u = r + "/" + Tc(c);
                            m(i), g(u, "key"), p(Ec(c)), g(u, "keyEnd"), p(":"), a && p(" "), e(l, i, u);
                        }
                    }
                    m(n), p("}");
                } else p("{}");
            }
            function s(o) {
                if (t.size) {
                    p("{");
                    for(var i = n + 1, s = !0, c = t.entries(), l = c.next(); !l.done;){
                        var u = l.value, f = u[0], d = !!o || u[1];
                        if (jc(d)) {
                            s || p(","), s = !1;
                            var h = r + "/" + Tc(f);
                            m(i), g(h, "key"), p(Ec(f)), g(h, "keyEnd"), p(":"), a && p(" "), e(d, i, h);
                        }
                        l = c.next();
                    }
                    m(n), p("}");
                } else p("{}");
            }
            g(r, "valueEnd");
        }(e, 0, ""), {
            json: l,
            pointers: u
        };
    }
    function p(e) {
        d += e.length, h += e.length, l += e;
    }
    function m(e) {
        if (a) {
            for(l += "\n" + y(e, a), f++, d = 0; e--;)i ? (f += i, d = o) : d += o, h += r;
            h += 1;
        }
    }
    function g(e, t) {
        u[e] = u[e] || {}, u[e][t] = {
            line: f,
            column: d,
            pos: h
        };
    }
    function y(e, t) {
        return Array(e + 1).join(t);
    }
};
var kc = [
    "number",
    "bigint",
    "boolean",
    "string",
    "object"
];
function jc(e) {
    return kc.indexOf(Ho(e)) >= 0;
}
var Sc = /"|\\/g, Cc = /[\b]/g, $c = /\f/g, _c = /\n/g, Oc = /\r/g, Mc = /\t/g;
function Ec(e) {
    return '"' + (e = e.replace(Sc, "\\$&").replace($c, "\\f").replace(Cc, "\\b").replace(_c, "\\n").replace(Oc, "\\r").replace(Mc, "\\t")) + '"';
}
var Ac = /~/g, Pc = /\//g;
function Tc(e) {
    return e.replace(Ac, "~0").replace(Pc, "~1");
}
var Rc = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t, [
            e + " at position " + n
        ])).position = n, r;
    }
    return Ao(t, $o(Error)), Do(t);
}(), Nc = 92, Ic = 47, Dc = 42, zc = 123, qc = 125, Bc = 91, Lc = 93, Fc = 40, Vc = 41, Hc = 32, Wc = 10, Uc = 9, Jc = 13, Kc = 8, Gc = 12, Qc = 34, Yc = 43, Xc = 45, Zc = 39, el = 48, tl = 57, nl = 44, rl = 46, ol = 58, il = 59, al = 65, sl = 97, cl = 69, ll = 101, ul = 70, fl = 102, dl = 160, hl = 8192, vl = 8202, pl = 8239, ml = 8287, gl = 12288, yl = 8220, bl = 8221, wl = 8216, xl = 8217, kl = 96, jl = 180;
function Sl(e) {
    return e >= el && e <= tl || e >= al && e <= ul || e >= sl && e <= fl;
}
function Cl(e) {
    return e >= el && e <= tl;
}
function $l(e) {
    return e >= 32 && e <= 1114111;
}
function _l(e) {
    return Ol.test(e);
}
var Ol = /^[,:[\]/{}()\n+]$/;
function Ml(e) {
    return El.test(e) || e && Rl(e.charCodeAt(0));
}
var El = /^[[{\w-]$/;
function Al(e) {
    return e === Wc || e === Jc || e === Uc || e === Kc || e === Gc;
}
function Pl(e) {
    return e === Hc || e === Wc || e === Uc || e === Jc;
}
function Tl(e) {
    return e === dl || e >= hl && e <= vl || e === pl || e === ml || e === gl;
}
function Rl(e) {
    return Nl(e) || Dl(e);
}
function Nl(e) {
    return e === Qc || e === yl || e === bl;
}
function Il(e) {
    return e === Qc;
}
function Dl(e) {
    return e === Zc || e === wl || e === xl || e === kl || e === jl;
}
function zl(e) {
    return e === Zc;
}
function ql(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = e.lastIndexOf(t);
    return -1 !== r ? e.substring(0, r) + (n ? "" : e.substring(r + 1)) : e;
}
function Bl(e, t) {
    var n = e.length;
    if (!Pl(e.charCodeAt(n - 1))) return e + t;
    for(; Pl(e.charCodeAt(n - 1));)n--;
    return e.substring(0, n) + t + e.substring(n);
}
function Ll(e, t, n) {
    return e.substring(0, t) + e.substring(t + n);
}
var Fl = {
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t"
}, Vl = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	"
};
function Hl(e) {
    var t = 0, n = "";
    o() || function() {
        throw new Rc("Unexpected end of json string", e.length);
    }();
    var r = c(nl);
    for(r && i(), Ml(e[t]) && function(e) {
        return /[,\n][ \t\r]*$/.test(e);
    }(n) ? (r || (n = Bl(n, ",")), function() {
        var e = !0, t = !0;
        for(; t;){
            if (e) e = !1;
            else c(nl) || (n = Bl(n, ","));
            t = o();
        }
        t || (n = ql(n, ","));
        n = "[\n".concat(n, "\n]");
    }()) : r && (n = ql(n, ",")); e.charCodeAt(t) === qc || e.charCodeAt(t) === Lc;)t++, i();
    if (t >= e.length) return n;
    function o() {
        i();
        var r = function() {
            if (e.charCodeAt(t) === zc) {
                n += "{", t++, i();
                for(var r = !0; t < e.length && e.charCodeAt(t) !== qc;){
                    if (r ? r = !1 : (c(nl) || (n = Bl(n, ",")), i()), !(u() || h())) {
                        e.charCodeAt(t) === qc || e.charCodeAt(t) === zc || e.charCodeAt(t) === Lc || e.charCodeAt(t) === Bc || void 0 === e[t] ? n = ql(n, ",") : y();
                        break;
                    }
                    i();
                    var a = c(ol), s = t >= e.length;
                    a || (Ml(e[t]) || s ? n = Bl(n, ":") : b()), o() || (a || s ? n += "null" : b());
                }
                return e.charCodeAt(t) === qc ? (n += "}", t++) : n = Bl(n, "}"), !0;
            }
            return !1;
        }() || function() {
            if (e.charCodeAt(t) === Bc) {
                n += "[", t++, i();
                for(var r = !0; t < e.length && e.charCodeAt(t) !== Lc;){
                    if (r) r = !1;
                    else c(nl) || (n = Bl(n, ","));
                    if (!o()) {
                        n = ql(n, ",");
                        break;
                    }
                }
                return e.charCodeAt(t) === Lc ? (n += "]", t++) : n = Bl(n, "]"), !0;
            }
            return !1;
        }() || u() || function() {
            var r = t;
            if (e.charCodeAt(t) === Xc && (t++, m(r))) return !0;
            for(; Cl(e.charCodeAt(t));)t++;
            if (e.charCodeAt(t) === rl) {
                if (t++, m(r)) return !0;
                for(; Cl(e.charCodeAt(t));)t++;
            }
            if (e.charCodeAt(t) === ll || e.charCodeAt(t) === cl) {
                if (t++, e.charCodeAt(t) !== Xc && e.charCodeAt(t) !== Yc || t++, m(r)) return !0;
                for(; Cl(e.charCodeAt(t));)t++;
            }
            if (t > r) {
                var o = e.slice(r, t), i = /^0\d/.test(o);
                return n += i ? '"'.concat(o, '"') : o, !0;
            }
            return !1;
        }() || d("true", "true") || d("false", "false") || d("null", "null") || d("True", "true") || d("False", "false") || d("None", "null") || h();
        return i(), r;
    }
    function i() {
        var e = t, n = a();
        do (n = s()) && (n = a());
        while (n);
        return t > e;
    }
    function a() {
        for(var r, o = ""; (r = Pl(e.charCodeAt(t))) || Tl(e.charCodeAt(t));)o += r ? e[t] : " ", t++;
        return o.length > 0 && (n += o, !0);
    }
    function s() {
        if (e.charCodeAt(t) === Ic && e.charCodeAt(t + 1) === Dc) {
            for(; t < e.length && !Wl(e, t);)t++;
            return t += 2, !0;
        }
        if (e.charCodeAt(t) === Ic && e.charCodeAt(t + 1) === Ic) {
            for(; t < e.length && e.charCodeAt(t) !== Wc;)t++;
            return !0;
        }
        return !1;
    }
    function c(r) {
        return e.charCodeAt(t) === r && (n += e[t], t++, !0);
    }
    function l() {
        return function(n) {
            return e.charCodeAt(t) === n && (t++, !0);
        }(Nc);
    }
    function u() {
        var r = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], o = e.charCodeAt(t) === Nc;
        if (o && (t++, o = !0), Rl(e.charCodeAt(t))) {
            var a = Il(e.charCodeAt(t)) ? Il : zl(e.charCodeAt(t)) ? zl : Dl(e.charCodeAt(t)) ? Dl : Nl, s = t, c = n.length, d = '"';
            for(t++;;){
                if (t >= e.length) return r ? (d = Bl(d, '"'), n += d, !0) : (t = s, n = n.substring(0, c), u(!0));
                if (a(e.charCodeAt(t))) {
                    var h = t, p = d.length;
                    if (t++, n += d += '"', i(), r || t >= e.length || _l(e.charAt(t)) || Rl(e.charCodeAt(t))) return f(), !0;
                    if (_l(e.charAt(v(h - 1)))) return t = s, n = n.substring(0, c), u(!0);
                    n = n.substring(0, c), t = h + 1, d = d.substring(0, p) + "\\" + d.substring(p);
                } else {
                    if (r && _l(e[t])) return d = Bl(d, '"'), n += d, f(), !0;
                    if (e.charCodeAt(t) === Nc) {
                        var m = e.charAt(t + 1);
                        if (void 0 !== Vl[m]) d += e.slice(t, t + 2), t += 2;
                        else if ("u" === m) {
                            for(var y = 2; y < 6 && Sl(e.charCodeAt(t + y));)y++;
                            6 === y ? (d += e.slice(t, t + 6), t += 6) : t + y >= e.length ? t = e.length : w();
                        } else d += m, t += 2;
                    } else {
                        var b = e.charAt(t), x = e.charCodeAt(t);
                        x === Qc && e.charCodeAt(t - 1) !== Nc ? (d += "\\" + b, t++) : Al(x) ? (d += Fl[b], t++) : ($l(x) || g(b), d += b, t++);
                    }
                }
                o && l();
            }
        }
        return !1;
    }
    function f() {
        var r = !1;
        for(i(); e.charCodeAt(t) === Yc;){
            r = !0, t++, i();
            var o = (n = ql(n, '"', !0)).length, a = u();
            n = a ? Ll(n, o, 1) : Bl(n, '"');
        }
        return r;
    }
    function d(r, o) {
        return e.slice(t, t + r.length) === r && (n += o, t += r.length, !0);
    }
    function h() {
        for(var r = t; t < e.length && !_l(e[t]) && !Rl(e.charCodeAt(t));)t++;
        if (t > r) {
            if (e.charCodeAt(t) === Fc) return t++, o(), e.charCodeAt(t) === Vc && (t++, e.charCodeAt(t) === il && t++), !0;
            for(; Pl(e.charCodeAt(t - 1)) && t > 0;)t--;
            var i = e.slice(r, t);
            return n += "undefined" === i ? "null" : JSON.stringify(i), e.charCodeAt(t) === Qc && t++, !0;
        }
    }
    function v(t) {
        for(var n = t; n > 0 && Pl(e.charCodeAt(n));)n--;
        return n;
    }
    function p(n) {
        if (!Cl(e.charCodeAt(t))) {
            var r = e.slice(n, t);
            throw new Rc("Invalid number '".concat(r, "', expecting a digit ").concat(e[t] ? "but got '".concat(e[t], "'") : "but reached end of input"), t);
        }
    }
    function m(r) {
        return t >= e.length ? (n += e.slice(r, t) + "0", !0) : (p(r), !1);
    }
    function g(e) {
        throw new Rc("Invalid character " + JSON.stringify(e), t);
    }
    function y() {
        throw new Rc("Object key expected", t);
    }
    function b() {
        throw new Rc("Colon expected", t);
    }
    function w() {
        var n = e.slice(t, t + 6);
        throw new Rc('Invalid unicode character "'.concat(n, '"'), t);
    }
    !function() {
        throw new Rc("Unexpected character " + JSON.stringify(e[t]), t);
    }();
}
function Wl(e, t) {
    return "*" === e[t] && "/" === e[t + 1];
}
function Ul(e) {
    return parseInt(e, 10);
}
function Jl(e) {
    return Kl.test(e);
}
var Kl = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$/;
function Gl(e) {
    return "object" === Ho(e) && null !== e && (void 0 === e.constructor || "Object" === e.constructor.name);
}
function Ql(e) {
    return "object" === Ho(e) && null !== e && (void 0 === e.constructor || "Object" === e.constructor.name || "Array" === e.constructor.name);
}
function Yl(e) {
    if ("number" == typeof e) return e > 9466848e5 && isFinite(e) && Math.floor(e) === e && !isNaN(new Date(e).valueOf());
    if ("bigint" == typeof e) return Yl(Number(e));
    try {
        var t = e ? e.valueOf() : e;
        if (t !== e) return Yl(t);
    } catch (e) {
        return !1;
    }
    return !1;
}
function Xl(e) {
    (Zl = Zl || window.document.createElement("div")).style.color = "", Zl.style.color = e;
    var t = Zl.style.color;
    return "" !== t ? t.replace(/\s+/g, "").toLowerCase() : null;
}
var Zl = null;
function eu(e, t) {
    if ("number" == typeof e || "string" == typeof e || "boolean" == typeof e || void 0 === e) return Ho(e);
    if ("bigint" == typeof e) return "number";
    if (null === e) return "null";
    if (Array.isArray(e)) return "array";
    if (Gl(e)) return "object";
    var n = t.stringify(e);
    return n && Jl(n) ? "number" : "true" === n || "false" === n ? "boolean" : "null" === n ? "null" : "unknown";
}
var tu = /^https?:\/\/\S+$/;
function nu(e) {
    return "string" == typeof e && tu.test(e);
}
function ru(e, t) {
    if ("" === e) return "";
    var n = e.trim();
    return "null" === n ? null : "true" === n || "false" !== n && (Jl(n) ? t.parse(n) : e);
}
function ou(e) {
    return iu.test(e);
}
var iu = /^-?[0-9]+$/, au = "object" == ("undefined" == typeof $parcel$global ? "undefined" : Ho($parcel$global)) && $parcel$global && $parcel$global.Object === Object && $parcel$global, su = "object" == ("undefined" == typeof self ? "undefined" : Ho(self)) && self && self.Object === Object && self, cu = au || su || Function("return this")(), lu = cu.Symbol, uu = Object.prototype, fu = uu.hasOwnProperty, du = uu.toString, hu = lu ? lu.toStringTag : void 0;
var vu = Object.prototype.toString;
var pu = "[object Null]", mu = "[object Undefined]", gu = lu ? lu.toStringTag : void 0;
function yu(e) {
    return null == e ? void 0 === e ? mu : pu : gu && gu in Object(e) ? function(e) {
        var t = fu.call(e, hu), n = e[hu];
        try {
            e[hu] = void 0;
            var r = !0;
        } catch (e) {}
        var o = du.call(e);
        return r && (t ? e[hu] = n : delete e[hu]), o;
    }(e) : function(e) {
        return vu.call(e);
    }(e);
}
function bu(e) {
    return null != e && "object" == Ho(e);
}
var wu = "[object Symbol]";
function xu(e) {
    return "symbol" == Ho(e) || bu(e) && yu(e) == wu;
}
var ku = NaN;
function ju(e) {
    return "number" == typeof e ? e : xu(e) ? ku : +e;
}
function Su(e, t) {
    for(var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;)o[n] = t(e[n], n, e);
    return o;
}
var Cu = Array.isArray, $u = 1 / 0, _u = lu ? lu.prototype : void 0, Ou = _u ? _u.toString : void 0;
function Mu(e) {
    if ("string" == typeof e) return e;
    if (Cu(e)) return Su(e, Mu) + "";
    if (xu(e)) return Ou ? Ou.call(e) : "";
    var t = e + "";
    return "0" == t && 1 / e == -$u ? "-0" : t;
}
function Eu(e, t) {
    return function(n, r) {
        var o;
        if (void 0 === n && void 0 === r) return t;
        if (void 0 !== n && (o = n), void 0 !== r) {
            if (void 0 === o) return r;
            "string" == typeof n || "string" == typeof r ? (n = Mu(n), r = Mu(r)) : (n = ju(n), r = ju(r)), o = e(n, r);
        }
        return o;
    };
}
var Au = Eu(function(e, t) {
    return e + t;
}, 0), Pu = /\s/;
function Tu(e) {
    for(var t = e.length; t-- && Pu.test(e.charAt(t)););
    return t;
}
var Ru = /^\s+/;
function Nu(e) {
    return e ? e.slice(0, Tu(e) + 1).replace(Ru, "") : e;
}
function Iu(e) {
    var t = Ho(e);
    return null != e && ("object" == t || "function" == t);
}
var Du = NaN, zu = /^[-+]0x[0-9a-f]+$/i, qu = /^0b[01]+$/i, Bu = /^0o[0-7]+$/i, Lu = parseInt;
function Fu(e) {
    if ("number" == typeof e) return e;
    if (xu(e)) return Du;
    if (Iu(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = Iu(t) ? t + "" : t;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = Nu(e);
    var n = qu.test(e);
    return n || Bu.test(e) ? Lu(e.slice(2), n ? 2 : 8) : zu.test(e) ? Du : +e;
}
var Vu = 1 / 0, Hu = 17976931348623157e292;
function Wu(e) {
    return e ? (e = Fu(e)) === Vu || e === -Vu ? (e < 0 ? -1 : 1) * Hu : e == e ? e : 0 : 0 === e ? e : 0;
}
function Uu(e) {
    var t = Wu(e), n = t % 1;
    return t == t ? n ? t - n : t : 0;
}
function Ju(e, t) {
    if ("function" != typeof t) throw new TypeError("Expected a function");
    return e = Uu(e), function() {
        if (--e < 1) return t.apply(this, arguments);
    };
}
function Ku(e) {
    return e;
}
var Gu = "[object AsyncFunction]", Qu = "[object Function]", Yu = "[object GeneratorFunction]", Xu = "[object Proxy]";
function Zu(e) {
    if (!Iu(e)) return !1;
    var t = yu(e);
    return t == Qu || t == Yu || t == Gu || t == Xu;
}
var ef, tf = cu["__core-js_shared__"], nf = (ef = /[^.]+$/.exec(tf && tf.keys && tf.keys.IE_PROTO || "")) ? "Symbol(src)_1." + ef : "";
var rf = Function.prototype.toString;
function of(e) {
    if (null != e) {
        try {
            return rf.call(e);
        } catch (e) {}
        try {
            return e + "";
        } catch (e) {}
    }
    return "";
}
var af = /^\[object .+?Constructor\]$/, sf = Function.prototype, cf = Object.prototype, lf = sf.toString, uf = cf.hasOwnProperty, ff = RegExp("^" + lf.call(uf).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function df(e) {
    return !(!Iu(e) || function(e) {
        return !!nf && nf in e;
    }(e)) && (Zu(e) ? ff : af).test(of(e));
}
function hf(e, t) {
    var n = function(e, t) {
        return null == e ? void 0 : e[t];
    }(e, t);
    return df(n) ? n : void 0;
}
var vf = hf(cu, "WeakMap"), pf = vf && new vf, mf = pf ? function(e, t) {
    return pf.set(e, t), e;
} : Ku, gf = Object.create, yf = function() {
    function e() {}
    return function(t) {
        if (!Iu(t)) return {};
        if (gf) return gf(t);
        e.prototype = t;
        var n = new e;
        return e.prototype = void 0, n;
    };
}();
function bf(e) {
    return function() {
        var t = arguments;
        switch(t.length){
            case 0:
                return new e;
            case 1:
                return new e(t[0]);
            case 2:
                return new e(t[0], t[1]);
            case 3:
                return new e(t[0], t[1], t[2]);
            case 4:
                return new e(t[0], t[1], t[2], t[3]);
            case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
        }
        var n = yf(e.prototype), r = e.apply(n, t);
        return Iu(r) ? r : n;
    };
}
var wf = 1;
function xf(e, t, n) {
    switch(n.length){
        case 0:
            return e.call(t);
        case 1:
            return e.call(t, n[0]);
        case 2:
            return e.call(t, n[0], n[1]);
        case 3:
            return e.call(t, n[0], n[1], n[2]);
    }
    return e.apply(t, n);
}
var kf = Math.max;
function jf(e, t, n, r) {
    for(var o = -1, i = e.length, a = n.length, s = -1, c = t.length, l = kf(i - a, 0), u = Array(c + l), f = !r; ++s < c;)u[s] = t[s];
    for(; ++o < a;)(f || o < i) && (u[n[o]] = e[o]);
    for(; l--;)u[s++] = e[o++];
    return u;
}
var Sf = Math.max;
function Cf(e, t, n, r) {
    for(var o = -1, i = e.length, a = -1, s = n.length, c = -1, l = t.length, u = Sf(i - s, 0), f = Array(u + l), d = !r; ++o < u;)f[o] = e[o];
    for(var h = o; ++c < l;)f[h + c] = t[c];
    for(; ++a < s;)(d || o < i) && (f[h + n[a]] = e[o++]);
    return f;
}
function $f() {}
var _f = 4294967295;
function Of(e) {
    this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = _f, this.__views__ = [];
}
function Mf() {}
Of.prototype = yf($f.prototype), Of.prototype.constructor = Of;
var Ef = pf ? function(e) {
    return pf.get(e);
} : Mf, Af = {}, Pf = Object.prototype.hasOwnProperty;
function Tf(e) {
    for(var t = e.name + "", n = Af[t], r = Pf.call(Af, t) ? n.length : 0; r--;){
        var o = n[r], i = o.func;
        if (null == i || i == e) return o.name;
    }
    return t;
}
function Rf(e, t) {
    this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
function Nf(e, t) {
    var n = -1, r = e.length;
    for(t || (t = Array(r)); ++n < r;)t[n] = e[n];
    return t;
}
function If(e) {
    if (e instanceof Of) return e.clone();
    var t = new Rf(e.__wrapped__, e.__chain__);
    return t.__actions__ = Nf(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
Rf.prototype = yf($f.prototype), Rf.prototype.constructor = Rf;
var Df = Object.prototype.hasOwnProperty;
function zf(e) {
    if (bu(e) && !Cu(e) && !(e instanceof Of)) {
        if (e instanceof Rf) return e;
        if (Df.call(e, "__wrapped__")) return If(e);
    }
    return new Rf(e);
}
function qf(e) {
    var t = Tf(e), n = zf[t];
    if ("function" != typeof n || !(t in Of.prototype)) return !1;
    if (e === n) return !0;
    var r = Ef(n);
    return !!r && e === r[0];
}
zf.prototype = $f.prototype, zf.prototype.constructor = zf;
var Bf = Date.now;
function Lf(e) {
    var t = 0, n = 0;
    return function() {
        var r = Bf(), o = 16 - (r - n);
        if (n = r, o > 0) {
            if (++t >= 800) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
    };
}
var Ff = Lf(mf), Vf = /\{\n\/\* \[wrapped with (.+)\] \*/, Hf = /,? & /;
var Wf = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function Uf(e) {
    return function() {
        return e;
    };
}
var Jf = function() {
    try {
        var e = hf(Object, "defineProperty");
        return e({}, "", {}), e;
    } catch (e) {}
}(), Kf = Jf ? function(e, t) {
    return Jf(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Uf(t),
        writable: !0
    });
} : Ku, Gf = Lf(Kf);
function Qf(e, t) {
    for(var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e););
    return e;
}
function Yf(e, t, n, r) {
    for(var o = e.length, i = n + (r ? 1 : -1); r ? i-- : ++i < o;)if (t(e[i], i, e)) return i;
    return -1;
}
function Xf(e) {
    return e != e;
}
function Zf(e, t, n) {
    return t == t ? function(e, t, n) {
        for(var r = n - 1, o = e.length; ++r < o;)if (e[r] === t) return r;
        return -1;
    }(e, t, n) : Yf(e, Xf, n);
}
function ed(e, t) {
    return !!(null == e ? 0 : e.length) && Zf(e, t, 0) > -1;
}
var td = [
    [
        "ary",
        128
    ],
    [
        "bind",
        1
    ],
    [
        "bindKey",
        2
    ],
    [
        "curry",
        8
    ],
    [
        "curryRight",
        16
    ],
    [
        "flip",
        512
    ],
    [
        "partial",
        32
    ],
    [
        "partialRight",
        64
    ],
    [
        "rearg",
        256
    ]
];
function nd(e, t, n) {
    var r = t + "";
    return Gf(e, function(e, t) {
        var n = t.length;
        if (!n) return e;
        var r = n - 1;
        return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Wf, "{\n/* [wrapped with " + t + "] */\n");
    }(r, function(e, t) {
        return Qf(td, function(n) {
            var r = "_." + n[0];
            t & n[1] && !ed(e, r) && e.push(r);
        }), e.sort();
    }(function(e) {
        var t = e.match(Vf);
        return t ? t[1].split(Hf) : [];
    }(r), n)));
}
var rd = 1, od = 2, id = 4, ad = 8, sd = 32, cd = 64;
function ld(e, t, n, r, o, i, a, s, c, l) {
    var u = t & ad;
    t |= u ? sd : cd, (t &= ~(u ? cd : sd)) & id || (t &= ~(rd | od));
    var f = [
        e,
        t,
        o,
        u ? i : void 0,
        u ? a : void 0,
        u ? void 0 : i,
        u ? void 0 : a,
        s,
        c,
        l
    ], d = n.apply(void 0, f);
    return qf(e) && Ff(d, f), d.placeholder = r, nd(d, e, t);
}
function ud(e) {
    return e.placeholder;
}
var fd = 9007199254740991, dd = /^(?:0|[1-9]\d*)$/;
function hd(e, t) {
    var n = Ho(e);
    return !!(t = null == t ? fd : t) && ("number" == n || "symbol" != n && dd.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var vd = Math.min;
var pd = "__lodash_placeholder__";
function md(e, t) {
    for(var n = -1, r = e.length, o = 0, i = []; ++n < r;){
        var a = e[n];
        a !== t && a !== pd || (e[n] = pd, i[o++] = n);
    }
    return i;
}
var gd = 1, yd = 2, bd = 8, wd = 16, xd = 128, kd = 512;
function jd(e, t, n, r, o, i, a, s, c, l) {
    var u = t & xd, f = t & gd, d = t & yd, h = t & (bd | wd), v = t & kd, p = d ? void 0 : bf(e);
    return function m() {
        for(var g = arguments.length, y = Array(g), b = g; b--;)y[b] = arguments[b];
        if (h) var w = ud(m), x = function(e, t) {
            for(var n = e.length, r = 0; n--;)e[n] === t && ++r;
            return r;
        }(y, w);
        if (r && (y = jf(y, r, o, h)), i && (y = Cf(y, i, a, h)), g -= x, h && g < l) {
            var k = md(y, w);
            return ld(e, t, jd, m.placeholder, n, y, k, s, c, l - g);
        }
        var j = f ? n : this, S = d ? j[e] : e;
        return g = y.length, s ? y = function(e, t) {
            for(var n = e.length, r = vd(t.length, n), o = Nf(e); r--;){
                var i = t[r];
                e[r] = hd(i, n) ? o[i] : void 0;
            }
            return e;
        }(y, s) : v && g > 1 && y.reverse(), u && c < g && (y.length = c), this && this !== cu && this instanceof m && (S = p || bf(S)), S.apply(j, y);
    };
}
var Sd = 1;
var Cd = "__lodash_placeholder__", $d = 1, _d = 2, Od = 4, Md = 8, Ed = 128, Ad = 256, Pd = Math.min;
var Td = "Expected a function", Rd = 1, Nd = 2, Id = 8, Dd = 16, zd = 32, qd = 64, Bd = Math.max;
function Ld(e, t, n, r, o, i, a, s) {
    var c = t & Nd;
    if (!c && "function" != typeof e) throw new TypeError(Td);
    var l = r ? r.length : 0;
    if (l || (t &= ~(zd | qd), r = o = void 0), a = void 0 === a ? a : Bd(Uu(a), 0), s = void 0 === s ? s : Uu(s), l -= o ? o.length : 0, t & qd) {
        var u = r, f = o;
        r = o = void 0;
    }
    var d = c ? void 0 : Ef(e), h = [
        e,
        t,
        n,
        r,
        o,
        u,
        f,
        i,
        a,
        s
    ];
    if (d && function(e, t) {
        var n = e[1], r = t[1], o = n | r, i = o < ($d | _d | Ed), a = r == Ed && n == Md || r == Ed && n == Ad && e[7].length <= t[8] || r == (Ed | Ad) && t[7].length <= t[8] && n == Md;
        if (!i && !a) return e;
        r & $d && (e[2] = t[2], o |= n & $d ? 0 : Od);
        var s = t[3];
        if (s) {
            var c = e[3];
            e[3] = c ? jf(c, s, t[4]) : s, e[4] = c ? md(e[3], Cd) : t[4];
        }
        (s = t[5]) && (c = e[5], e[5] = c ? Cf(c, s, t[6]) : s, e[6] = c ? md(e[5], Cd) : t[6]), (s = t[7]) && (e[7] = s), r & Ed && (e[8] = null == e[8] ? t[8] : Pd(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = o;
    }(h, d), e = h[0], t = h[1], n = h[2], r = h[3], o = h[4], !(s = h[9] = void 0 === h[9] ? c ? 0 : e.length : Bd(h[9] - l, 0)) && t & (Id | Dd) && (t &= ~(Id | Dd)), t && t != Rd) v = t == Id || t == Dd ? function(e, t, n) {
        var r = bf(e);
        return function o() {
            for(var i = arguments.length, a = Array(i), s = i, c = ud(o); s--;)a[s] = arguments[s];
            var l = i < 3 && a[0] !== c && a[i - 1] !== c ? [] : md(a, c);
            return (i -= l.length) < n ? ld(e, t, jd, o.placeholder, void 0, a, l, void 0, void 0, n - i) : xf(this && this !== cu && this instanceof o ? r : e, this, a);
        };
    }(e, t, s) : t != zd && t != (Rd | zd) || o.length ? jd.apply(void 0, h) : function(e, t, n, r) {
        var o = t & Sd, i = bf(e);
        return function t() {
            for(var a = -1, s = arguments.length, c = -1, l = r.length, u = Array(l + s), f = this && this !== cu && this instanceof t ? i : e; ++c < l;)u[c] = r[c];
            for(; s--;)u[c++] = arguments[++a];
            return xf(f, o ? n : this, u);
        };
    }(e, t, n, r);
    else var v = function(e, t, n) {
        var r = t & wf, o = bf(e);
        return function t() {
            return (this && this !== cu && this instanceof t ? o : e).apply(r ? n : this, arguments);
        };
    }(e, t, n);
    return nd((d ? mf : Ff)(v, h), e, t);
}
var Fd = 128;
function Vd(e, t, n) {
    return t = n ? void 0 : t, t = e && null == t ? e.length : t, Ld(e, Fd, void 0, void 0, void 0, void 0, t);
}
function Hd(e, t, n) {
    "__proto__" == t && Jf ? Jf(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
    }) : e[t] = n;
}
function Wd(e, t) {
    return e === t || e != e && t != t;
}
var Ud = Object.prototype.hasOwnProperty;
function Jd(e, t, n) {
    var r = e[t];
    Ud.call(e, t) && Wd(r, n) && (void 0 !== n || t in e) || Hd(e, t, n);
}
function Kd(e, t, n, r) {
    var o = !n;
    n || (n = {});
    for(var i = -1, a = t.length; ++i < a;){
        var s = t[i], c = r ? r(n[s], e[s], s, n, e) : void 0;
        void 0 === c && (c = e[s]), o ? Hd(n, s, c) : Jd(n, s, c);
    }
    return n;
}
var Gd = Math.max;
function Qd(e, t, n) {
    return t = Gd(void 0 === t ? e.length - 1 : t, 0), function() {
        for(var r = arguments, o = -1, i = Gd(r.length - t, 0), a = Array(i); ++o < i;)a[o] = r[t + o];
        o = -1;
        for(var s = Array(t + 1); ++o < t;)s[o] = r[o];
        return s[t] = n(a), xf(e, this, s);
    };
}
function Yd(e, t) {
    return Gf(Qd(e, t, Ku), e + "");
}
var Xd = 9007199254740991;
function Zd(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= Xd;
}
function eh(e) {
    return null != e && Zd(e.length) && !Zu(e);
}
function th(e, t, n) {
    if (!Iu(n)) return !1;
    var r = Ho(t);
    return !!("number" == r ? eh(n) && hd(t, n.length) : "string" == r && t in n) && Wd(n[t], e);
}
function nh(e) {
    return Yd(function(t, n) {
        var r = -1, o = n.length, i = o > 1 ? n[o - 1] : void 0, a = o > 2 ? n[2] : void 0;
        for(i = e.length > 3 && "function" == typeof i ? (o--, i) : void 0, a && th(n[0], n[1], a) && (i = o < 3 ? void 0 : i, o = 1), t = Object(t); ++r < o;){
            var s = n[r];
            s && e(t, s, r, i);
        }
        return t;
    });
}
var rh = Object.prototype;
function oh(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || rh);
}
function ih(e, t) {
    for(var n = -1, r = Array(e); ++n < e;)r[n] = t(n);
    return r;
}
function ah(e) {
    return bu(e) && "[object Arguments]" == yu(e);
}
var sh = Object.prototype, ch = sh.hasOwnProperty, lh = sh.propertyIsEnumerable, uh = ah(function() {
    return arguments;
}()) ? ah : function(e) {
    return bu(e) && ch.call(e, "callee") && !lh.call(e, "callee");
};
function fh() {
    return !1;
}
var dh = "object" == Ho(exports) && exports && !exports.nodeType && exports, hh = dh && "object" == Ho(module) && module && !module.nodeType && module, vh = hh && hh.exports === dh ? cu.Buffer : void 0, ph = (vh ? vh.isBuffer : void 0) || fh, mh = {};
function gh(e) {
    return function(t) {
        return e(t);
    };
}
mh["[object Float32Array]"] = mh["[object Float64Array]"] = mh["[object Int8Array]"] = mh["[object Int16Array]"] = mh["[object Int32Array]"] = mh["[object Uint8Array]"] = mh["[object Uint8ClampedArray]"] = mh["[object Uint16Array]"] = mh["[object Uint32Array]"] = !0, mh["[object Arguments]"] = mh["[object Array]"] = mh["[object ArrayBuffer]"] = mh["[object Boolean]"] = mh["[object DataView]"] = mh["[object Date]"] = mh["[object Error]"] = mh["[object Function]"] = mh["[object Map]"] = mh["[object Number]"] = mh["[object Object]"] = mh["[object RegExp]"] = mh["[object Set]"] = mh["[object String]"] = mh["[object WeakMap]"] = !1;
var yh = "object" == Ho(exports) && exports && !exports.nodeType && exports, bh = yh && "object" == Ho(module) && module && !module.nodeType && module, wh = bh && bh.exports === yh && au.process, xh = function() {
    try {
        var e = bh && bh.require && bh.require("util").types;
        return e || wh && wh.binding && wh.binding("util");
    } catch (e) {}
}(), kh = xh && xh.isTypedArray, jh = kh ? gh(kh) : function(e) {
    return bu(e) && Zd(e.length) && !!mh[yu(e)];
}, Sh = Object.prototype.hasOwnProperty;
function Ch(e, t) {
    var n = Cu(e), r = !n && uh(e), o = !n && !r && ph(e), i = !n && !r && !o && jh(e), a = n || r || o || i, s = a ? ih(e.length, String) : [], c = s.length;
    for(var l in e)!t && !Sh.call(e, l) || a && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || hd(l, c)) || s.push(l);
    return s;
}
function $h(e, t) {
    return function(n) {
        return e(t(n));
    };
}
var _h = $h(Object.keys, Object), Oh = Object.prototype.hasOwnProperty;
function Mh(e) {
    if (!oh(e)) return _h(e);
    var t = [];
    for(var n in Object(e))Oh.call(e, n) && "constructor" != n && t.push(n);
    return t;
}
function Eh(e) {
    return eh(e) ? Ch(e) : Mh(e);
}
var Ah = Object.prototype.hasOwnProperty, Ph = nh(function(e, t) {
    if (oh(t) || eh(t)) Kd(t, Eh(t), e);
    else for(var n in t)Ah.call(t, n) && Jd(e, n, t[n]);
}), Th = Ph;
var Rh = Object.prototype.hasOwnProperty;
function Nh(e) {
    if (!Iu(e)) return function(e) {
        var t = [];
        if (null != e) for(var n in Object(e))t.push(n);
        return t;
    }(e);
    var t = oh(e), n = [];
    for(var r in e)("constructor" != r || !t && Rh.call(e, r)) && n.push(r);
    return n;
}
function Ih(e) {
    return eh(e) ? Ch(e, !0) : Nh(e);
}
var Dh = nh(function(e, t) {
    Kd(t, Ih(t), e);
}), zh = Dh, qh = nh(function(e, t, n, r) {
    Kd(t, Ih(t), e, r);
}), Bh = qh, Lh = nh(function(e, t, n, r) {
    Kd(t, Eh(t), e, r);
}), Fh = Lh, Vh = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Hh = /^\w*$/;
function Wh(e, t) {
    if (Cu(e)) return !1;
    var n = Ho(e);
    return !("number" != n && "symbol" != n && "boolean" != n && null != e && !xu(e)) || Hh.test(e) || !Vh.test(e) || null != t && e in Object(t);
}
var Uh = hf(Object, "create");
var Jh = Object.prototype.hasOwnProperty;
var Kh = Object.prototype.hasOwnProperty;
function Gh(e) {
    var t = -1, n = null == e ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
function Qh(e, t) {
    for(var n = e.length; n--;)if (Wd(e[n][0], t)) return n;
    return -1;
}
Gh.prototype.clear = function() {
    this.__data__ = Uh ? Uh(null) : {}, this.size = 0;
}, Gh.prototype.delete = function(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
}, Gh.prototype.get = function(e) {
    var t = this.__data__;
    if (Uh) {
        var n = t[e];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
    }
    return Jh.call(t, e) ? t[e] : void 0;
}, Gh.prototype.has = function(e) {
    var t = this.__data__;
    return Uh ? void 0 !== t[e] : Kh.call(t, e);
}, Gh.prototype.set = function(e, t) {
    var n = this.__data__;
    return this.size += this.has(e) ? 0 : 1, n[e] = Uh && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var Yh = Array.prototype.splice;
function Xh(e) {
    var t = -1, n = null == e ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
Xh.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, Xh.prototype.delete = function(e) {
    var t = this.__data__, n = Qh(t, e);
    return !(n < 0) && (n == t.length - 1 ? t.pop() : Yh.call(t, n, 1), --this.size, !0);
}, Xh.prototype.get = function(e) {
    var t = this.__data__, n = Qh(t, e);
    return n < 0 ? void 0 : t[n][1];
}, Xh.prototype.has = function(e) {
    return Qh(this.__data__, e) > -1;
}, Xh.prototype.set = function(e, t) {
    var n = this.__data__, r = Qh(n, e);
    return r < 0 ? (++this.size, n.push([
        e,
        t
    ])) : n[r][1] = t, this;
};
var Zh = hf(cu, "Map");
function ev(e, t) {
    var n = e.__data__;
    return function(e) {
        var t = Ho(e);
        return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    }(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
}
function tv(e) {
    var t = -1, n = null == e ? 0 : e.length;
    for(this.clear(); ++t < n;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
tv.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new Gh,
        map: new (Zh || Xh),
        string: new Gh
    };
}, tv.prototype.delete = function(e) {
    var t = ev(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
}, tv.prototype.get = function(e) {
    return ev(this, e).get(e);
}, tv.prototype.has = function(e) {
    return ev(this, e).has(e);
}, tv.prototype.set = function(e, t) {
    var n = ev(this, e), r = n.size;
    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
};
var nv = "Expected a function";
function rv(e, t) {
    if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(nv);
    var n = function n() {
        var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
        if (i.has(o)) return i.get(o);
        var a = e.apply(this, r);
        return n.cache = i.set(o, a) || i, a;
    };
    return n.cache = new (rv.Cache || tv), n;
}
rv.Cache = tv;
var ov = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, iv = /\\(\\)?/g, av = function(e) {
    var t = rv(e, function(e) {
        return 500 === n.size && n.clear(), e;
    }), n = t.cache;
    return t;
}(function(e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(ov, function(e, n, r, o) {
        t.push(r ? o.replace(iv, "$1") : n || e);
    }), t;
});
function sv(e) {
    return null == e ? "" : Mu(e);
}
function cv(e, t) {
    return Cu(e) ? e : Wh(e, t) ? [
        e
    ] : av(sv(e));
}
var lv = 1 / 0;
function uv(e) {
    if ("string" == typeof e || xu(e)) return e;
    var t = e + "";
    return "0" == t && 1 / e == -lv ? "-0" : t;
}
function fv(e, t) {
    for(var n = 0, r = (t = cv(t, e)).length; null != e && n < r;)e = e[uv(t[n++])];
    return n && n == r ? e : void 0;
}
function dv(e, t, n) {
    var r = null == e ? void 0 : fv(e, t);
    return void 0 === r ? n : r;
}
function hv(e, t) {
    for(var n = -1, r = t.length, o = Array(r), i = null == e; ++n < r;)o[n] = i ? void 0 : dv(e, t[n]);
    return o;
}
function vv(e, t) {
    for(var n = -1, r = t.length, o = e.length; ++n < r;)e[o + n] = t[n];
    return e;
}
var pv = lu ? lu.isConcatSpreadable : void 0;
function mv(e) {
    return Cu(e) || uh(e) || !!(pv && e && e[pv]);
}
function gv(e, t, n, r, o) {
    var i = -1, a = e.length;
    for(n || (n = mv), o || (o = []); ++i < a;){
        var s = e[i];
        t > 0 && n(s) ? t > 1 ? gv(s, t - 1, n, r, o) : vv(o, s) : r || (o[o.length] = s);
    }
    return o;
}
function yv(e) {
    return (null == e ? 0 : e.length) ? gv(e, 1) : [];
}
function bv(e) {
    return Gf(Qd(e, void 0, yv), e + "");
}
var wv = bv(hv), xv = $h(Object.getPrototypeOf, Object), kv = "[object Object]", jv = Function.prototype, Sv = Object.prototype, Cv = jv.toString, $v = Sv.hasOwnProperty, _v = Cv.call(Object);
function Ov(e) {
    if (!bu(e) || yu(e) != kv) return !1;
    var t = xv(e);
    if (null === t) return !0;
    var n = $v.call(t, "constructor") && t.constructor;
    return "function" == typeof n && n instanceof n && Cv.call(n) == _v;
}
var Mv = "[object DOMException]", Ev = "[object Error]";
function Av(e) {
    if (!bu(e)) return !1;
    var t = yu(e);
    return t == Ev || t == Mv || "string" == typeof e.message && "string" == typeof e.name && !Ov(e);
}
var Pv = Yd(function(e, t) {
    try {
        return xf(e, void 0, t);
    } catch (e) {
        return Av(e) ? e : new Error(e);
    }
}), Tv = Pv, Rv = "Expected a function";
function Nv(e, t) {
    var n;
    if ("function" != typeof t) throw new TypeError(Rv);
    return e = Uu(e), function() {
        return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
    };
}
var Iv = Yd(function(e, t, n) {
    var r = 1;
    if (n.length) {
        var o = md(n, ud(Iv));
        r |= 32;
    }
    return Ld(e, r, t, n, o);
});
Iv.placeholder = {};
var Dv = Iv, zv = bv(function(e, t) {
    return Qf(t, function(t) {
        t = uv(t), Hd(e, t, Dv(e[t], e));
    }), e;
}), qv = zv, Bv = Yd(function(e, t, n) {
    var r = 3;
    if (n.length) {
        var o = md(n, ud(Bv));
        r |= 32;
    }
    return Ld(t, r, e, n, o);
});
Bv.placeholder = {};
var Lv = Bv;
function Fv(e, t, n) {
    var r = -1, o = e.length;
    t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
    for(var i = Array(o); ++r < o;)i[r] = e[r + t];
    return i;
}
function Vv(e, t, n) {
    var r = e.length;
    return n = void 0 === n ? r : n, !t && n >= r ? e : Fv(e, t, n);
}
var Hv = RegExp("[\\u200d\ud800-\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
function Wv(e) {
    return Hv.test(e);
}
var Uv = "\ud800-\udfff", Jv = "[" + Uv + "]", Kv = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", Gv = "\ud83c[\udffb-\udfff]", Qv = "[^" + Uv + "]", Yv = "(?:\ud83c[\udde6-\uddff]){2}", Xv = "[\ud800-\udbff][\udc00-\udfff]", Zv = "(?:" + Kv + "|" + Gv + ")" + "?", ep = "[\\ufe0e\\ufe0f]?", tp = ep + Zv + ("(?:\\u200d(?:" + [
    Qv,
    Yv,
    Xv
].join("|") + ")" + ep + Zv + ")*"), np = "(?:" + [
    Qv + Kv + "?",
    Kv,
    Yv,
    Xv,
    Jv
].join("|") + ")", rp = RegExp(Gv + "(?=" + Gv + ")|" + np + tp, "g");
function op(e) {
    return Wv(e) ? function(e) {
        return e.match(rp) || [];
    }(e) : function(e) {
        return e.split("");
    }(e);
}
function ip(e) {
    return function(t) {
        var n = Wv(t = sv(t)) ? op(t) : void 0, r = n ? n[0] : t.charAt(0), o = n ? Vv(n, 1).join("") : t.slice(1);
        return r[e]() + o;
    };
}
var ap = ip("toUpperCase");
function sp(e) {
    return ap(sv(e).toLowerCase());
}
function cp(e, t, n, r) {
    var o = -1, i = null == e ? 0 : e.length;
    for(r && i && (n = e[++o]); ++o < i;)n = t(n, e[o], o, e);
    return n;
}
function lp(e) {
    return function(t) {
        return null == e ? void 0 : e[t];
    };
}
var up = lp({
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
}), fp = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, dp = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
function hp(e) {
    return (e = sv(e)) && e.replace(fp, up).replace(dp, "");
}
var vp = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
var pp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
var mp = "\ud800-\udfff", gp = "\\u2700-\\u27bf", yp = "a-z\\xdf-\\xf6\\xf8-\\xff", bp = "A-Z\\xc0-\\xd6\\xd8-\\xde", wp = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", xp = "[" + wp + "]", kp = "\\d+", jp = "[" + gp + "]", Sp = "[" + yp + "]", Cp = "[^" + mp + wp + kp + gp + yp + bp + "]", $p = "(?:\ud83c[\udde6-\uddff]){2}", _p = "[\ud800-\udbff][\udc00-\udfff]", Op = "[" + bp + "]", Mp = "(?:" + Sp + "|" + Cp + ")", Ep = "(?:" + Op + "|" + Cp + ")", Ap = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?", Pp = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", Tp = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\ud83c[\udffb-\udfff])?", Rp = "[\\ufe0e\\ufe0f]?", Np = Rp + Tp + ("(?:\\u200d(?:" + [
    "[^" + mp + "]",
    $p,
    _p
].join("|") + ")" + Rp + Tp + ")*"), Ip = "(?:" + [
    jp,
    $p,
    _p
].join("|") + ")" + Np, Dp = RegExp([
    Op + "?" + Sp + "+" + Ap + "(?=" + [
        xp,
        Op,
        "$"
    ].join("|") + ")",
    Ep + "+" + Pp + "(?=" + [
        xp,
        Op + Mp,
        "$"
    ].join("|") + ")",
    Op + "?" + Mp + "+" + Ap,
    Op + "+" + Pp,
    "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
    "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
    kp,
    Ip
].join("|"), "g");
function zp(e, t, n) {
    return e = sv(e), void 0 === (t = n ? void 0 : t) ? function(e) {
        return pp.test(e);
    }(e) ? function(e) {
        return e.match(Dp) || [];
    }(e) : function(e) {
        return e.match(vp) || [];
    }(e) : e.match(t) || [];
}
var qp = RegExp("['\u2019]", "g");
function Bp(e) {
    return function(t) {
        return cp(zp(hp(t).replace(qp, "")), e, "");
    };
}
var Lp = Bp(function(e, t, n) {
    return t = t.toLowerCase(), e + (n ? sp(t) : t);
}), Fp = Lp;
function Vp() {
    if (!arguments.length) return [];
    var e = arguments[0];
    return Cu(e) ? e : [
        e
    ];
}
var Hp = cu.isFinite, Wp = Math.min;
function Up(e) {
    var t = Math[e];
    return function(e, n) {
        if (e = Fu(e), (n = null == n ? 0 : Wp(Uu(n), 292)) && Hp(e)) {
            var r = (sv(e) + "e").split("e");
            return +((r = (sv(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
        }
        return t(e);
    };
}
var Jp = Up("ceil");
function Kp(e) {
    var t = zf(e);
    return t.__chain__ = !0, t;
}
var Gp = Math.ceil, Qp = Math.max;
function Yp(e, t, n) {
    t = (n ? th(e, t, n) : void 0 === t) ? 1 : Qp(Uu(t), 0);
    var r = null == e ? 0 : e.length;
    if (!r || t < 1) return [];
    for(var o = 0, i = 0, a = Array(Gp(r / t)); o < r;)a[i++] = Fv(e, o, o += t);
    return a;
}
function Xp(e, t, n) {
    return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
}
function Zp(e, t, n) {
    return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = Fu(n)) == n ? n : 0), void 0 !== t && (t = (t = Fu(t)) == t ? t : 0), Xp(Fu(e), t, n);
}
function em(e) {
    var t = this.__data__ = new Xh(e);
    this.size = t.size;
}
function tm(e, t) {
    return e && Kd(t, Eh(t), e);
}
em.prototype.clear = function() {
    this.__data__ = new Xh, this.size = 0;
}, em.prototype.delete = function(e) {
    var t = this.__data__, n = t.delete(e);
    return this.size = t.size, n;
}, em.prototype.get = function(e) {
    return this.__data__.get(e);
}, em.prototype.has = function(e) {
    return this.__data__.has(e);
}, em.prototype.set = function(e, t) {
    var n = this.__data__;
    if (n instanceof Xh) {
        var r = n.__data__;
        if (!Zh || r.length < 199) return r.push([
            e,
            t
        ]), this.size = ++n.size, this;
        n = this.__data__ = new tv(r);
    }
    return n.set(e, t), this.size = n.size, this;
};
var nm = "object" == Ho(exports) && exports && !exports.nodeType && exports, rm = nm && "object" == Ho(module) && module && !module.nodeType && module, om = rm && rm.exports === nm ? cu.Buffer : void 0, im = om ? om.allocUnsafe : void 0;
function am(e, t) {
    if (t) return e.slice();
    var n = e.length, r = im ? im(n) : new e.constructor(n);
    return e.copy(r), r;
}
function sm(e, t) {
    for(var n = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++n < r;){
        var a = e[n];
        t(a, n, e) && (i[o++] = a);
    }
    return i;
}
function cm() {
    return [];
}
var lm = Object.prototype.propertyIsEnumerable, um = Object.getOwnPropertySymbols, fm = um ? function(e) {
    return null == e ? [] : (e = Object(e), sm(um(e), function(t) {
        return lm.call(e, t);
    }));
} : cm;
var dm = Object.getOwnPropertySymbols ? function(e) {
    for(var t = []; e;)vv(t, fm(e)), e = xv(e);
    return t;
} : cm;
function hm(e, t, n) {
    var r = t(e);
    return Cu(e) ? r : vv(r, n(e));
}
function vm(e) {
    return hm(e, Eh, fm);
}
function pm(e) {
    return hm(e, Ih, dm);
}
var mm = hf(cu, "DataView"), gm = hf(cu, "Promise"), ym = hf(cu, "Set"), bm = "[object Map]", wm = "[object Promise]", xm = "[object Set]", km = "[object WeakMap]", jm = "[object DataView]", Sm = of(mm), Cm = of(Zh), $m = of(gm), _m = of(ym), Om = of(vf), Mm = yu;
(mm && Mm(new mm(new ArrayBuffer(1))) != jm || Zh && Mm(new Zh) != bm || gm && Mm(gm.resolve()) != wm || ym && Mm(new ym) != xm || vf && Mm(new vf) != km) && (Mm = function(e) {
    var t = yu(e), n = "[object Object]" == t ? e.constructor : void 0, r = n ? of(n) : "";
    if (r) switch(r){
        case Sm:
            return jm;
        case Cm:
            return bm;
        case $m:
            return wm;
        case _m:
            return xm;
        case Om:
            return km;
    }
    return t;
});
var Em = Mm, Am = Object.prototype.hasOwnProperty;
var Pm = cu.Uint8Array;
function Tm(e) {
    var t = new e.constructor(e.byteLength);
    return new Pm(t).set(new Pm(e)), t;
}
var Rm = /\w*$/;
var Nm = lu ? lu.prototype : void 0, Im = Nm ? Nm.valueOf : void 0;
function Dm(e, t) {
    var n = t ? Tm(e.buffer) : e.buffer;
    return new e.constructor(n, e.byteOffset, e.length);
}
var zm = "[object Boolean]", qm = "[object Date]", Bm = "[object Map]", Lm = "[object Number]", Fm = "[object RegExp]", Vm = "[object Set]", Hm = "[object String]", Wm = "[object Symbol]", Um = "[object ArrayBuffer]", Jm = "[object DataView]", Km = "[object Float32Array]", Gm = "[object Float64Array]", Qm = "[object Int8Array]", Ym = "[object Int16Array]", Xm = "[object Int32Array]", Zm = "[object Uint8Array]", eg = "[object Uint8ClampedArray]", tg = "[object Uint16Array]", ng = "[object Uint32Array]";
function rg(e, t, n) {
    var r, o = e.constructor;
    switch(t){
        case Um:
            return Tm(e);
        case zm:
        case qm:
            return new o(+e);
        case Jm:
            return function(e, t) {
                var n = t ? Tm(e.buffer) : e.buffer;
                return new e.constructor(n, e.byteOffset, e.byteLength);
            }(e, n);
        case Km:
        case Gm:
        case Qm:
        case Ym:
        case Xm:
        case Zm:
        case eg:
        case tg:
        case ng:
            return Dm(e, n);
        case Bm:
            return new o;
        case Lm:
        case Hm:
            return new o(e);
        case Fm:
            return function(e) {
                var t = new e.constructor(e.source, Rm.exec(e));
                return t.lastIndex = e.lastIndex, t;
            }(e);
        case Vm:
            return new o;
        case Wm:
            return r = e, Im ? Object(Im.call(r)) : {};
    }
}
function og(e) {
    return "function" != typeof e.constructor || oh(e) ? {} : yf(xv(e));
}
var ig = xh && xh.isMap, ag = ig ? gh(ig) : function(e) {
    return bu(e) && "[object Map]" == Em(e);
};
var sg = xh && xh.isSet, cg = sg ? gh(sg) : function(e) {
    return bu(e) && "[object Set]" == Em(e);
}, lg = 1, ug = 2, fg = 4, dg = "[object Arguments]", hg = "[object Function]", vg = "[object GeneratorFunction]", pg = "[object Object]", mg = {};
function gg(e, t, n, r, o, i) {
    var a, s = t & lg, c = t & ug, l = t & fg;
    if (n && (a = o ? n(e, r, o, i) : n(e)), void 0 !== a) return a;
    if (!Iu(e)) return e;
    var u = Cu(e);
    if (u) {
        if (a = function(e) {
            var t = e.length, n = new e.constructor(t);
            return t && "string" == typeof e[0] && Am.call(e, "index") && (n.index = e.index, n.input = e.input), n;
        }(e), !s) return Nf(e, a);
    } else {
        var f = Em(e), d = f == hg || f == vg;
        if (ph(e)) return am(e, s);
        if (f == pg || f == dg || d && !o) {
            if (a = c || d ? {} : og(e), !s) return c ? function(e, t) {
                return Kd(e, dm(e), t);
            }(e, function(e, t) {
                return e && Kd(t, Ih(t), e);
            }(a, e)) : function(e, t) {
                return Kd(e, fm(e), t);
            }(e, tm(a, e));
        } else {
            if (!mg[f]) return o ? e : {};
            a = rg(e, f, s);
        }
    }
    i || (i = new em);
    var h = i.get(e);
    if (h) return h;
    i.set(e, a), cg(e) ? e.forEach(function(r) {
        a.add(gg(r, t, n, r, e, i));
    }) : ag(e) && e.forEach(function(r, o) {
        a.set(o, gg(r, t, n, o, e, i));
    });
    var v = u ? void 0 : (l ? c ? pm : vm : c ? Ih : Eh)(e);
    return Qf(v || e, function(r, o) {
        v && (r = e[o = r]), Jd(a, o, gg(r, t, n, o, e, i));
    }), a;
}
mg[dg] = mg["[object Array]"] = mg["[object ArrayBuffer]"] = mg["[object DataView]"] = mg["[object Boolean]"] = mg["[object Date]"] = mg["[object Float32Array]"] = mg["[object Float64Array]"] = mg["[object Int8Array]"] = mg["[object Int16Array]"] = mg["[object Int32Array]"] = mg["[object Map]"] = mg["[object Number]"] = mg[pg] = mg["[object RegExp]"] = mg["[object Set]"] = mg["[object String]"] = mg["[object Symbol]"] = mg["[object Uint8Array]"] = mg["[object Uint8ClampedArray]"] = mg["[object Uint16Array]"] = mg["[object Uint32Array]"] = !0, mg["[object Error]"] = mg[hg] = mg["[object WeakMap]"] = !1;
function yg(e) {
    return gg(e, 4);
}
function bg(e) {
    return gg(e, 5);
}
var wg = 1, xg = 4;
function kg(e, t) {
    return gg(e, wg | xg, t = "function" == typeof t ? t : void 0);
}
function jg(e, t) {
    return gg(e, 4, t = "function" == typeof t ? t : void 0);
}
function Sg() {
    return new Rf(this.value(), this.__chain__);
}
function Cg(e) {
    for(var t = -1, n = null == e ? 0 : e.length, r = 0, o = []; ++t < n;){
        var i = e[t];
        i && (o[r++] = i);
    }
    return o;
}
function $g() {
    var e = arguments.length;
    if (!e) return [];
    for(var t = Array(e - 1), n = arguments[0], r = e; r--;)t[r - 1] = arguments[r];
    return vv(Cu(n) ? Nf(n) : [
        n
    ], gv(t, 1));
}
function _g(e) {
    var t = -1, n = null == e ? 0 : e.length;
    for(this.__data__ = new tv; ++t < n;)this.add(e[t]);
}
function Og(e, t) {
    for(var n = -1, r = null == e ? 0 : e.length; ++n < r;)if (t(e[n], n, e)) return !0;
    return !1;
}
function Mg(e, t) {
    return e.has(t);
}
_g.prototype.add = _g.prototype.push = function(e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, _g.prototype.has = function(e) {
    return this.__data__.has(e);
};
var Eg = 1, Ag = 2;
function Pg(e, t, n, r, o, i) {
    var a = n & Eg, s = e.length, c = t.length;
    if (s != c && !(a && c > s)) return !1;
    var l = i.get(e), u = i.get(t);
    if (l && u) return l == t && u == e;
    var f = -1, d = !0, h = n & Ag ? new _g : void 0;
    for(i.set(e, t), i.set(t, e); ++f < s;){
        var v = e[f], p = t[f];
        if (r) var m = a ? r(p, v, f, t, e, i) : r(v, p, f, e, t, i);
        if (void 0 !== m) {
            if (m) continue;
            d = !1;
            break;
        }
        if (h) {
            if (!Og(t, function(e, t) {
                if (!Mg(h, t) && (v === e || o(v, e, n, r, i))) return h.push(t);
            })) {
                d = !1;
                break;
            }
        } else if (v !== p && !o(v, p, n, r, i)) {
            d = !1;
            break;
        }
    }
    return i.delete(e), i.delete(t), d;
}
function Tg(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(e, r) {
        n[++t] = [
            r,
            e
        ];
    }), n;
}
function Rg(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(e) {
        n[++t] = e;
    }), n;
}
var Ng = 1, Ig = 2, Dg = "[object Boolean]", zg = "[object Date]", qg = "[object Error]", Bg = "[object Map]", Lg = "[object Number]", Fg = "[object RegExp]", Vg = "[object Set]", Hg = "[object String]", Wg = "[object Symbol]", Ug = "[object ArrayBuffer]", Jg = "[object DataView]", Kg = lu ? lu.prototype : void 0, Gg = Kg ? Kg.valueOf : void 0;
var Qg = 1, Yg = Object.prototype.hasOwnProperty;
var Xg = 1, Zg = "[object Arguments]", ey = "[object Array]", ty = "[object Object]", ny = Object.prototype.hasOwnProperty;
function ry(e, t, n, r, o, i) {
    var a = Cu(e), s = Cu(t), c = a ? ey : Em(e), l = s ? ey : Em(t), u = (c = c == Zg ? ty : c) == ty, f = (l = l == Zg ? ty : l) == ty, d = c == l;
    if (d && ph(e)) {
        if (!ph(t)) return !1;
        a = !0, u = !1;
    }
    if (d && !u) return i || (i = new em), a || jh(e) ? Pg(e, t, n, r, o, i) : function(e, t, n, r, o, i, a) {
        switch(n){
            case Jg:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;
            case Ug:
                return !(e.byteLength != t.byteLength || !i(new Pm(e), new Pm(t)));
            case Dg:
            case zg:
            case Lg:
                return Wd(+e, +t);
            case qg:
                return e.name == t.name && e.message == t.message;
            case Fg:
            case Hg:
                return e == t + "";
            case Bg:
                var s = Tg;
            case Vg:
                var c = r & Ng;
                if (s || (s = Rg), e.size != t.size && !c) return !1;
                var l = a.get(e);
                if (l) return l == t;
                r |= Ig, a.set(e, t);
                var u = Pg(s(e), s(t), r, o, i, a);
                return a.delete(e), u;
            case Wg:
                if (Gg) return Gg.call(e) == Gg.call(t);
        }
        return !1;
    }(e, t, c, n, r, o, i);
    if (!(n & Xg)) {
        var h = u && ny.call(e, "__wrapped__"), v = f && ny.call(t, "__wrapped__");
        if (h || v) {
            var p = h ? e.value() : e, m = v ? t.value() : t;
            return i || (i = new em), o(p, m, n, r, i);
        }
    }
    return !!d && (i || (i = new em), function(e, t, n, r, o, i) {
        var a = n & Qg, s = vm(e), c = s.length;
        if (c != vm(t).length && !a) return !1;
        for(var l = c; l--;){
            var u = s[l];
            if (!(a ? u in t : Yg.call(t, u))) return !1;
        }
        var f = i.get(e), d = i.get(t);
        if (f && d) return f == t && d == e;
        var h = !0;
        i.set(e, t), i.set(t, e);
        for(var v = a; ++l < c;){
            var p = e[u = s[l]], m = t[u];
            if (r) var g = a ? r(m, p, u, t, e, i) : r(p, m, u, e, t, i);
            if (!(void 0 === g ? p === m || o(p, m, n, r, i) : g)) {
                h = !1;
                break;
            }
            v || (v = "constructor" == u);
        }
        if (h && !v) {
            var y = e.constructor, b = t.constructor;
            y == b || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b || (h = !1);
        }
        return i.delete(e), i.delete(t), h;
    }(e, t, n, r, o, i));
}
function oy(e, t, n, r, o) {
    return e === t || (null == e || null == t || !bu(e) && !bu(t) ? e != e && t != t : ry(e, t, n, r, oy, o));
}
var iy = 1, ay = 2;
function sy(e, t, n, r) {
    var o = n.length, i = o, a = !r;
    if (null == e) return !i;
    for(e = Object(e); o--;){
        var s = n[o];
        if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
    }
    for(; ++o < i;){
        var c = (s = n[o])[0], l = e[c], u = s[1];
        if (a && s[2]) {
            if (void 0 === l && !(c in e)) return !1;
        } else {
            var f = new em;
            if (r) var d = r(l, u, c, e, t, f);
            if (!(void 0 === d ? oy(u, l, iy | ay, r, f) : d)) return !1;
        }
    }
    return !0;
}
function cy(e) {
    return e == e && !Iu(e);
}
function ly(e) {
    for(var t = Eh(e), n = t.length; n--;){
        var r = t[n], o = e[r];
        t[n] = [
            r,
            o,
            cy(o)
        ];
    }
    return t;
}
function uy(e, t) {
    return function(n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
    };
}
function fy(e) {
    var t = ly(e);
    return 1 == t.length && t[0][2] ? uy(t[0][0], t[0][1]) : function(n) {
        return n === e || sy(n, e, t);
    };
}
function dy(e, t) {
    return null != e && t in Object(e);
}
function hy(e, t, n) {
    for(var r = -1, o = (t = cv(t, e)).length, i = !1; ++r < o;){
        var a = uv(t[r]);
        if (!(i = null != e && n(e, a))) break;
        e = e[a];
    }
    return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && Zd(o) && hd(a, o) && (Cu(e) || uh(e));
}
function vy(e, t) {
    return null != e && hy(e, t, dy);
}
var py = 1, my = 2;
function gy(e, t) {
    return Wh(e) && cy(t) ? uy(uv(e), t) : function(n) {
        var r = dv(n, e);
        return void 0 === r && r === t ? vy(n, e) : oy(t, r, py | my);
    };
}
function yy(e) {
    return function(t) {
        return null == t ? void 0 : t[e];
    };
}
function by(e) {
    return Wh(e) ? yy(uv(e)) : function(e) {
        return function(t) {
            return fv(t, e);
        };
    }(e);
}
function wy(e) {
    return "function" == typeof e ? e : null == e ? Ku : "object" == Ho(e) ? Cu(e) ? gy(e[0], e[1]) : fy(e) : by(e);
}
function xy(e) {
    var t = null == e ? 0 : e.length, n = wy;
    return e = t ? Su(e, function(e) {
        if ("function" != typeof e[1]) throw new TypeError("Expected a function");
        return [
            n(e[0]),
            e[1]
        ];
    }) : [], Yd(function(n) {
        for(var r = -1; ++r < t;){
            var o = e[r];
            if (xf(o[0], this, n)) return xf(o[1], this, n);
        }
    });
}
function ky(e, t, n) {
    var r = n.length;
    if (null == e) return !r;
    for(e = Object(e); r--;){
        var o = n[r], i = t[o], a = e[o];
        if (void 0 === a && !(o in e) || !i(a)) return !1;
    }
    return !0;
}
function jy(e) {
    return function(e) {
        var t = Eh(e);
        return function(n) {
            return ky(n, e, t);
        };
    }(gg(e, 1));
}
function Sy(e, t) {
    return null == t || ky(e, t, Eh(t));
}
function Cy(e, t, n, r) {
    for(var o = -1, i = null == e ? 0 : e.length; ++o < i;){
        var a = e[o];
        t(r, a, n(a), e);
    }
    return r;
}
function $y(e) {
    return function(t, n, r) {
        for(var o = -1, i = Object(t), a = r(t), s = a.length; s--;){
            var c = a[e ? s : ++o];
            if (!1 === n(i[c], c, i)) break;
        }
        return t;
    };
}
var _y = $y();
function Oy(e, t) {
    return e && _y(e, t, Eh);
}
function My(e, t) {
    return function(n, r) {
        if (null == n) return n;
        if (!eh(n)) return e(n, r);
        for(var o = n.length, i = t ? o : -1, a = Object(n); (t ? i-- : ++i < o) && !1 !== r(a[i], i, a););
        return n;
    };
}
var Ey = My(Oy);
function Ay(e, t, n, r) {
    return Ey(e, function(e, o, i) {
        t(r, e, n(e), i);
    }), r;
}
function Py(e, t) {
    return function(n, r) {
        var o = Cu(n) ? Cy : Ay, i = t ? t() : {};
        return o(n, e, wy(r), i);
    };
}
var Ty = Object.prototype.hasOwnProperty, Ry = Py(function(e, t, n) {
    Ty.call(e, n) ? ++e[n] : Hd(e, n, 1);
}), Ny = Ry;
function Iy(e, t) {
    var n = yf(e);
    return null == t ? n : tm(n, t);
}
function Dy(e, t, n) {
    var r = Ld(e, 8, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
    return r.placeholder = Dy.placeholder, r;
}
Dy.placeholder = {};
function zy(e, t, n) {
    var r = Ld(e, 16, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
    return r.placeholder = zy.placeholder, r;
}
zy.placeholder = {};
var qy = function() {
    return cu.Date.now();
}, By = "Expected a function", Ly = Math.max, Fy = Math.min;
function Vy(e, t, n) {
    var r, o, i, a, s, c, l = 0, u = !1, f = !1, d = !0;
    if ("function" != typeof e) throw new TypeError(By);
    function h(t) {
        var n = r, i = o;
        return r = o = void 0, l = t, a = e.apply(i, n);
    }
    function v(e) {
        var n = e - c;
        return void 0 === c || n >= t || n < 0 || f && e - l >= i;
    }
    function p() {
        var e = qy();
        if (v(e)) return m(e);
        s = setTimeout(p, function(e) {
            var n = t - (e - c);
            return f ? Fy(n, i - (e - l)) : n;
        }(e));
    }
    function m(e) {
        return s = void 0, d && r ? h(e) : (r = o = void 0, a);
    }
    function g() {
        var e = qy(), n = v(e);
        if (r = arguments, o = this, c = e, n) {
            if (void 0 === s) return function(e) {
                return l = e, s = setTimeout(p, t), u ? h(e) : a;
            }(c);
            if (f) return clearTimeout(s), s = setTimeout(p, t), h(c);
        }
        return void 0 === s && (s = setTimeout(p, t)), a;
    }
    return t = Fu(t) || 0, Iu(n) && (u = !!n.leading, i = (f = "maxWait" in n) ? Ly(Fu(n.maxWait) || 0, t) : i, d = "trailing" in n ? !!n.trailing : d), g.cancel = function() {
        void 0 !== s && clearTimeout(s), l = 0, r = c = o = s = void 0;
    }, g.flush = function() {
        return void 0 === s ? a : m(qy());
    }, g;
}
function Hy(e, t) {
    return null == e || e != e ? t : e;
}
var Wy = Object.prototype, Uy = Wy.hasOwnProperty, Jy = Yd(function(e, t) {
    e = Object(e);
    var n = -1, r = t.length, o = r > 2 ? t[2] : void 0;
    for(o && th(t[0], t[1], o) && (r = 1); ++n < r;)for(var i = t[n], a = Ih(i), s = -1, c = a.length; ++s < c;){
        var l = a[s], u = e[l];
        (void 0 === u || Wd(u, Wy[l]) && !Uy.call(e, l)) && (e[l] = i[l]);
    }
    return e;
}), Ky = Jy;
function Gy(e, t, n) {
    (void 0 !== n && !Wd(e[t], n) || void 0 === n && !(t in e)) && Hd(e, t, n);
}
function Qy(e) {
    return bu(e) && eh(e);
}
function Yy(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
}
function Xy(e) {
    return Kd(e, Ih(e));
}
function Zy(e, t, n, r, o) {
    e !== t && _y(t, function(i, a) {
        if (o || (o = new em), Iu(i)) !function(e, t, n, r, o, i, a) {
            var s = Yy(e, n), c = Yy(t, n), l = a.get(c);
            if (l) Gy(e, n, l);
            else {
                var u = i ? i(s, c, n + "", e, t, a) : void 0, f = void 0 === u;
                if (f) {
                    var d = Cu(c), h = !d && ph(c), v = !d && !h && jh(c);
                    u = c, d || h || v ? Cu(s) ? u = s : Qy(s) ? u = Nf(s) : h ? (f = !1, u = am(c, !0)) : v ? (f = !1, u = Dm(c, !0)) : u = [] : Ov(c) || uh(c) ? (u = s, uh(s) ? u = Xy(s) : Iu(s) && !Zu(s) || (u = og(c))) : f = !1;
                }
                f && (a.set(c, u), o(u, c, r, i, a), a.delete(c)), Gy(e, n, u);
            }
        }(e, t, a, n, Zy, r, o);
        else {
            var s = r ? r(Yy(e, a), i, a + "", e, t, o) : void 0;
            void 0 === s && (s = i), Gy(e, a, s);
        }
    }, Ih);
}
function eb(e, t, n, r, o, i) {
    return Iu(e) && Iu(t) && (i.set(t, e), Zy(e, t, void 0, eb, i), i.delete(t)), e;
}
var tb = nh(function(e, t, n, r) {
    Zy(e, t, n, r);
}), nb = tb, rb = Yd(function(e) {
    return e.push(void 0, eb), xf(nb, void 0, e);
});
function ob(e, t, n) {
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return setTimeout(function() {
        e.apply(void 0, n);
    }, t);
}
var ib = Yd(function(e, t) {
    return ob(e, 1, t);
}), ab = ib, sb = Yd(function(e, t, n) {
    return ob(e, Fu(t) || 0, n);
}), cb = sb;
function lb(e, t, n) {
    for(var r = -1, o = null == e ? 0 : e.length; ++r < o;)if (n(t, e[r])) return !0;
    return !1;
}
var ub = 200;
function fb(e, t, n, r) {
    var o = -1, i = ed, a = !0, s = e.length, c = [], l = t.length;
    if (!s) return c;
    n && (t = Su(t, gh(n))), r ? (i = lb, a = !1) : t.length >= ub && (i = Mg, a = !1, t = new _g(t));
    e: for(; ++o < s;){
        var u = e[o], f = null == n ? u : n(u);
        if (u = r || 0 !== u ? u : 0, a && f == f) {
            for(var d = l; d--;)if (t[d] === f) continue e;
            c.push(u);
        } else i(t, f, r) || c.push(u);
    }
    return c;
}
var db = Yd(function(e, t) {
    return Qy(e) ? fb(e, gv(t, 1, Qy, !0)) : [];
}), hb = db;
function vb(e) {
    var t = null == e ? 0 : e.length;
    return t ? e[t - 1] : void 0;
}
var pb = Yd(function(e, t) {
    var n = vb(t);
    return Qy(n) && (n = void 0), Qy(e) ? fb(e, gv(t, 1, Qy, !0), wy(n)) : [];
}), mb = pb, gb = Yd(function(e, t) {
    var n = vb(t);
    return Qy(n) && (n = void 0), Qy(e) ? fb(e, gv(t, 1, Qy, !0), void 0, n) : [];
}), yb = gb, bb = Eu(function(e, t) {
    return e / t;
}, 1);
function wb(e, t, n) {
    var r = null == e ? 0 : e.length;
    return r ? Fv(e, (t = n || void 0 === t ? 1 : Uu(t)) < 0 ? 0 : t, r) : [];
}
function xb(e, t, n) {
    var r = null == e ? 0 : e.length;
    return r ? Fv(e, 0, (t = r - (t = n || void 0 === t ? 1 : Uu(t))) < 0 ? 0 : t) : [];
}
function kb(e, t, n, r) {
    for(var o = e.length, i = r ? o : -1; (r ? i-- : ++i < o) && t(e[i], i, e););
    return n ? Fv(e, r ? 0 : i, r ? i + 1 : o) : Fv(e, r ? i + 1 : 0, r ? o : i);
}
function jb(e, t) {
    return e && e.length ? kb(e, wy(t), !0, !0) : [];
}
function Sb(e, t) {
    return e && e.length ? kb(e, wy(t), !0) : [];
}
function Cb(e) {
    return "function" == typeof e ? e : Ku;
}
function $b(e, t) {
    return (Cu(e) ? Qf : Ey)(e, Cb(t));
}
function _b(e, t) {
    for(var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e););
    return e;
}
var Ob = $y(!0);
function Mb(e, t) {
    return e && Ob(e, t, Eh);
}
var Eb = My(Mb, !0);
function Ab(e, t) {
    return (Cu(e) ? _b : Eb)(e, Cb(t));
}
function Pb(e, t, n) {
    e = sv(e), t = Mu(t);
    var r = e.length, o = n = void 0 === n ? r : Xp(Uu(n), 0, r);
    return (n -= t.length) >= 0 && e.slice(n, o) == t;
}
function Tb(e) {
    return function(t) {
        var n = Em(t);
        return "[object Map]" == n ? Tg(t) : "[object Set]" == n ? function(e) {
            var t = -1, n = Array(e.size);
            return e.forEach(function(e) {
                n[++t] = [
                    e,
                    e
                ];
            }), n;
        }(t) : function(e, t) {
            return Su(t, function(t) {
                return [
                    t,
                    e[t]
                ];
            });
        }(t, e(t));
    };
}
var Rb = Tb(Eh), Nb = Tb(Ih), Ib = lp({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
}), Db = /[&<>"']/g, zb = RegExp(Db.source);
function qb(e) {
    return (e = sv(e)) && zb.test(e) ? e.replace(Db, Ib) : e;
}
var Bb = /[\\^$.*+?()[\]{}|]/g, Lb = RegExp(Bb.source);
function Fb(e) {
    return (e = sv(e)) && Lb.test(e) ? e.replace(Bb, "\\$&") : e;
}
function Vb(e, t) {
    for(var n = -1, r = null == e ? 0 : e.length; ++n < r;)if (!t(e[n], n, e)) return !1;
    return !0;
}
function Hb(e, t) {
    var n = !0;
    return Ey(e, function(e, r, o) {
        return n = !!t(e, r, o);
    }), n;
}
function Wb(e, t, n) {
    var r = Cu(e) ? Vb : Hb;
    return n && th(e, t, n) && (t = void 0), r(e, wy(t));
}
var Ub = 4294967295;
function Jb(e) {
    return e ? Xp(Uu(e), 0, Ub) : 0;
}
function Kb(e, t, n, r) {
    var o = null == e ? 0 : e.length;
    return o ? (n && "number" != typeof n && th(e, t, n) && (n = 0, r = o), function(e, t, n, r) {
        var o = e.length;
        for((n = Uu(n)) < 0 && (n = -n > o ? 0 : o + n), (r = void 0 === r || r > o ? o : Uu(r)) < 0 && (r += o), r = n > r ? 0 : Jb(r); n < r;)e[n++] = t;
        return e;
    }(e, t, n, r)) : [];
}
function Gb(e, t) {
    var n = [];
    return Ey(e, function(e, r, o) {
        t(e, r, o) && n.push(e);
    }), n;
}
function Qb(e, t) {
    return (Cu(e) ? sm : Gb)(e, wy(t));
}
function Yb(e) {
    return function(t, n, r) {
        var o = Object(t);
        if (!eh(t)) {
            var i = wy(n);
            t = Eh(t), n = function(e) {
                return i(o[e], e, o);
            };
        }
        var a = e(t, n, r);
        return a > -1 ? o[i ? t[a] : a] : void 0;
    };
}
var Xb = Math.max;
function Zb(e, t, n) {
    var r = null == e ? 0 : e.length;
    if (!r) return -1;
    var o = null == n ? 0 : Uu(n);
    return o < 0 && (o = Xb(r + o, 0)), Yf(e, wy(t), o);
}
var ew = Yb(Zb);
function tw(e, t, n) {
    var r;
    return n(e, function(e, n, o) {
        if (t(e, n, o)) return r = n, !1;
    }), r;
}
function nw(e, t) {
    return tw(e, wy(t), Oy);
}
var rw = Math.max, ow = Math.min;
function iw(e, t, n) {
    var r = null == e ? 0 : e.length;
    if (!r) return -1;
    var o = r - 1;
    return void 0 !== n && (o = Uu(n), o = n < 0 ? rw(r + o, 0) : ow(o, r - 1)), Yf(e, wy(t), o, !0);
}
var aw = Yb(iw);
function sw(e, t) {
    return tw(e, wy(t), Mb);
}
function cw(e) {
    return e && e.length ? e[0] : void 0;
}
function lw(e, t) {
    var n = -1, r = eh(e) ? Array(e.length) : [];
    return Ey(e, function(e, o, i) {
        r[++n] = t(e, o, i);
    }), r;
}
function uw(e, t) {
    return (Cu(e) ? Su : lw)(e, wy(t));
}
function fw(e, t) {
    return gv(uw(e, t), 1);
}
function dw(e, t) {
    return gv(uw(e, t), Infinity);
}
function hw(e, t, n) {
    return n = void 0 === n ? 1 : Uu(n), gv(uw(e, t), n);
}
function vw(e) {
    return (null == e ? 0 : e.length) ? gv(e, Infinity) : [];
}
function pw(e, t) {
    return (null == e ? 0 : e.length) ? gv(e, t = void 0 === t ? 1 : Uu(t)) : [];
}
function mw(e) {
    return Ld(e, 512);
}
var gw = Up("floor");
function yw(e) {
    return bv(function(t) {
        var n = t.length, r = n, o = Rf.prototype.thru;
        for(e && t.reverse(); r--;){
            var i = t[r];
            if ("function" != typeof i) throw new TypeError("Expected a function");
            if (o && !a && "wrapper" == Tf(i)) var a = new Rf([], !0);
        }
        for(r = a ? r : n; ++r < n;){
            var s = Tf(i = t[r]), c = "wrapper" == s ? Ef(i) : void 0;
            a = c && qf(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? a[Tf(c[0])].apply(a, c[3]) : 1 == i.length && qf(i) ? a[s]() : a.thru(i);
        }
        return function() {
            var e = arguments, r = e[0];
            if (a && 1 == e.length && Cu(r)) return a.plant(r).value();
            for(var o = 0, i = n ? t[o].apply(this, e) : r; ++o < n;)i = t[o].call(this, i);
            return i;
        };
    });
}
var bw = yw(), ww = yw(!0);
function xw(e, t) {
    return null == e ? e : _y(e, Cb(t), Ih);
}
function kw(e, t) {
    return null == e ? e : Ob(e, Cb(t), Ih);
}
function jw(e, t) {
    return e && Oy(e, Cb(t));
}
function Sw(e, t) {
    return e && Mb(e, Cb(t));
}
function Cw(e) {
    for(var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;){
        var o = e[t];
        r[o[0]] = o[1];
    }
    return r;
}
function $w(e, t) {
    return sm(t, function(t) {
        return Zu(e[t]);
    });
}
function _w(e) {
    return null == e ? [] : $w(e, Eh(e));
}
function Ow(e) {
    return null == e ? [] : $w(e, Ih(e));
}
var Mw = Object.prototype.hasOwnProperty, Ew = Py(function(e, t, n) {
    Mw.call(e, n) ? e[n].push(t) : Hd(e, n, [
        t
    ]);
}), Aw = Ew;
function Pw(e, t) {
    return e > t;
}
function Tw(e) {
    return function(t, n) {
        return "string" == typeof t && "string" == typeof n || (t = Fu(t), n = Fu(n)), e(t, n);
    };
}
var Rw = Tw(Pw), Nw = Tw(function(e, t) {
    return e >= t;
}), Iw = Object.prototype.hasOwnProperty;
function Dw(e, t) {
    return null != e && Iw.call(e, t);
}
function zw(e, t) {
    return null != e && hy(e, t, Dw);
}
var qw = Math.max, Bw = Math.min;
function Lw(e, t, n) {
    return t = Wu(t), void 0 === n ? (n = t, t = 0) : n = Wu(n), function(e, t, n) {
        return e >= Bw(t, n) && e < qw(t, n);
    }(e = Fu(e), t, n);
}
var Fw = "[object String]";
function Vw(e) {
    return "string" == typeof e || !Cu(e) && bu(e) && yu(e) == Fw;
}
function Hw(e, t) {
    return Su(t, function(t) {
        return e[t];
    });
}
function Ww(e) {
    return null == e ? [] : Hw(e, Eh(e));
}
var Uw = Math.max;
function Jw(e, t, n, r) {
    e = eh(e) ? e : Ww(e), n = n && !r ? Uu(n) : 0;
    var o = e.length;
    return n < 0 && (n = Uw(o + n, 0)), Vw(e) ? n <= o && e.indexOf(t, n) > -1 : !!o && Zf(e, t, n) > -1;
}
var Kw = Math.max;
function Gw(e, t, n) {
    var r = null == e ? 0 : e.length;
    if (!r) return -1;
    var o = null == n ? 0 : Uu(n);
    return o < 0 && (o = Kw(r + o, 0)), Zf(e, t, o);
}
function Qw(e) {
    return (null == e ? 0 : e.length) ? Fv(e, 0, -1) : [];
}
var Yw = Math.min;
function Xw(e, t, n) {
    for(var r = n ? lb : ed, o = e[0].length, i = e.length, a = i, s = Array(i), c = 1 / 0, l = []; a--;){
        var u = e[a];
        a && t && (u = Su(u, gh(t))), c = Yw(u.length, c), s[a] = !n && (t || o >= 120 && u.length >= 120) ? new _g(a && u) : void 0;
    }
    u = e[0];
    var f = -1, d = s[0];
    e: for(; ++f < o && l.length < c;){
        var h = u[f], v = t ? t(h) : h;
        if (h = n || 0 !== h ? h : 0, !(d ? Mg(d, v) : r(l, v, n))) {
            for(a = i; --a;){
                var p = s[a];
                if (!(p ? Mg(p, v) : r(e[a], v, n))) continue e;
            }
            d && d.push(v), l.push(h);
        }
    }
    return l;
}
function Zw(e) {
    return Qy(e) ? e : [];
}
var ex = Yd(function(e) {
    var t = Su(e, Zw);
    return t.length && t[0] === e[0] ? Xw(t) : [];
}), tx = Yd(function(e) {
    var t = vb(e), n = Su(e, Zw);
    return t === vb(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? Xw(n, wy(t)) : [];
}), nx = tx, rx = Yd(function(e) {
    var t = vb(e), n = Su(e, Zw);
    return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? Xw(n, void 0, t) : [];
});
function ox(e, t) {
    return function(n, r) {
        return function(e, t, n, r) {
            return Oy(e, function(e, o, i) {
                t(r, n(e), o, i);
            }), r;
        }(n, e, t(r), {});
    };
}
var ix = Object.prototype.toString, ax = ox(function(e, t, n) {
    null != t && "function" != typeof t.toString && (t = ix.call(t)), e[t] = n;
}, Uf(Ku)), sx = ax, cx = Object.prototype, lx = cx.hasOwnProperty, ux = cx.toString, fx = ox(function(e, t, n) {
    null != t && "function" != typeof t.toString && (t = ux.call(t)), lx.call(e, t) ? e[t].push(n) : e[t] = [
        n
    ];
}, wy), dx = fx;
function hx(e, t) {
    return t.length < 2 ? e : fv(e, Fv(t, 0, -1));
}
function vx(e, t, n) {
    var r = null == (e = hx(e, t = cv(t, e))) ? e : e[uv(vb(t))];
    return null == r ? void 0 : xf(r, e, n);
}
var px = Yd(vx), mx = Yd(function(e, t, n) {
    var r = -1, o = "function" == typeof t, i = eh(e) ? Array(e.length) : [];
    return Ey(e, function(e) {
        i[++r] = o ? xf(t, e, n) : vx(e, t, n);
    }), i;
}), gx = mx;
var yx = xh && xh.isArrayBuffer, bx = yx ? gh(yx) : function(e) {
    return bu(e) && "[object ArrayBuffer]" == yu(e);
};
function wx(e) {
    return !0 === e || !1 === e || bu(e) && "[object Boolean]" == yu(e);
}
var xx = xh && xh.isDate, kx = xx ? gh(xx) : function(e) {
    return bu(e) && "[object Date]" == yu(e);
};
function jx(e) {
    return bu(e) && 1 === e.nodeType && !Ov(e);
}
var Sx = "[object Map]", Cx = "[object Set]", $x = Object.prototype.hasOwnProperty;
function _x(e) {
    if (null == e) return !0;
    if (eh(e) && (Cu(e) || "string" == typeof e || "function" == typeof e.splice || ph(e) || jh(e) || uh(e))) return !e.length;
    var t = Em(e);
    if (t == Sx || t == Cx) return !e.size;
    if (oh(e)) return !Mh(e).length;
    for(var n in e)if ($x.call(e, n)) return !1;
    return !0;
}
function Ox(e, t) {
    return oy(e, t);
}
function Mx(e, t, n) {
    var r = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
    return void 0 === r ? oy(e, t, void 0, n) : !!r;
}
var Ex = cu.isFinite;
function Ax(e) {
    return "number" == typeof e && Ex(e);
}
function Px(e) {
    return "number" == typeof e && e == Uu(e);
}
function Tx(e, t) {
    return e === t || sy(e, t, ly(t));
}
function Rx(e, t, n) {
    return n = "function" == typeof n ? n : void 0, sy(e, t, ly(t), n);
}
var Nx = "[object Number]";
function Ix(e) {
    return "number" == typeof e || bu(e) && yu(e) == Nx;
}
function Dx(e) {
    return Ix(e) && e != +e;
}
var zx = tf ? Zu : fh;
function qx(e) {
    if (zx(e)) throw new Error("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
    return df(e);
}
function Bx(e) {
    return null == e;
}
function Lx(e) {
    return null === e;
}
var Fx = xh && xh.isRegExp, Vx = Fx ? gh(Fx) : function(e) {
    return bu(e) && "[object RegExp]" == yu(e);
}, Hx = 9007199254740991;
function Wx(e) {
    return Px(e) && e >= -9007199254740991 && e <= Hx;
}
function Ux(e) {
    return void 0 === e;
}
function Jx(e) {
    return bu(e) && "[object WeakMap]" == Em(e);
}
function Kx(e) {
    return bu(e) && "[object WeakSet]" == yu(e);
}
function Gx(e) {
    return wy("function" == typeof e ? e : gg(e, 1));
}
var Qx = Array.prototype.join;
function Yx(e, t) {
    return null == e ? "" : Qx.call(e, t);
}
var Xx = Bp(function(e, t, n) {
    return e + (n ? "-" : "") + t.toLowerCase();
}), Zx = Xx, ek = Py(function(e, t, n) {
    Hd(e, n, t);
}), tk = ek;
var nk = Math.max, rk = Math.min;
function ok(e, t, n) {
    var r = null == e ? 0 : e.length;
    if (!r) return -1;
    var o = r;
    return void 0 !== n && (o = (o = Uu(n)) < 0 ? nk(r + o, 0) : rk(o, r - 1)), t == t ? function(e, t, n) {
        for(var r = n + 1; r--;)if (e[r] === t) return r;
        return r;
    }(e, t, o) : Yf(e, Xf, o, !0);
}
var ik = Bp(function(e, t, n) {
    return e + (n ? " " : "") + t.toLowerCase();
}), ak = ik, sk = ip("toLowerCase");
function ck(e, t) {
    return e < t;
}
var lk = Tw(ck), uk = Tw(function(e, t) {
    return e <= t;
});
function fk(e, t) {
    var n = {};
    return t = wy(t), Oy(e, function(e, r, o) {
        Hd(n, t(e, r, o), e);
    }), n;
}
function dk(e, t) {
    var n = {};
    return t = wy(t), Oy(e, function(e, r, o) {
        Hd(n, r, t(e, r, o));
    }), n;
}
function hk(e) {
    return fy(gg(e, 1));
}
function vk(e, t) {
    return gy(e, gg(t, 1));
}
function pk(e, t, n) {
    for(var r = -1, o = e.length; ++r < o;){
        var i = e[r], a = t(i);
        if (null != a && (void 0 === s ? a == a && !xu(a) : n(a, s))) var s = a, c = i;
    }
    return c;
}
function mk(e) {
    return e && e.length ? pk(e, Ku, Pw) : void 0;
}
function gk(e, t) {
    return e && e.length ? pk(e, wy(t), Pw) : void 0;
}
function yk(e, t) {
    for(var n, r = -1, o = e.length; ++r < o;){
        var i = t(e[r]);
        void 0 !== i && (n = void 0 === n ? i : n + i);
    }
    return n;
}
var bk = NaN;
function wk(e, t) {
    var n = null == e ? 0 : e.length;
    return n ? yk(e, t) / n : bk;
}
function xk(e) {
    return wk(e, Ku);
}
function kk(e, t) {
    return wk(e, wy(t));
}
var jk = nh(function(e, t, n) {
    Zy(e, t, n);
}), Sk = jk, Ck = Yd(function(e, t) {
    return function(n) {
        return vx(n, e, t);
    };
}), $k = Ck, _k = Yd(function(e, t) {
    return function(n) {
        return vx(e, n, t);
    };
}), Ok = _k;
function Mk(e) {
    return e && e.length ? pk(e, Ku, ck) : void 0;
}
function Ek(e, t) {
    return e && e.length ? pk(e, wy(t), ck) : void 0;
}
function Ak(e, t, n) {
    var r = Eh(t), o = $w(t, r), i = !(Iu(n) && "chain" in n && !n.chain), a = Zu(e);
    return Qf(o, function(n) {
        var r = t[n];
        e[n] = r, a && (e.prototype[n] = function() {
            var t = this.__chain__;
            if (i || t) {
                var n = e(this.__wrapped__);
                return (n.__actions__ = Nf(this.__actions__)).push({
                    func: r,
                    args: arguments,
                    thisArg: e
                }), n.__chain__ = t, n;
            }
            return r.apply(e, vv([
                this.value()
            ], arguments));
        });
    }), e;
}
var Pk = Eu(function(e, t) {
    return e * t;
}, 1), Tk = "Expected a function";
function Rk(e) {
    if ("function" != typeof e) throw new TypeError(Tk);
    return function() {
        var t = arguments;
        switch(t.length){
            case 0:
                return !e.call(this);
            case 1:
                return !e.call(this, t[0]);
            case 2:
                return !e.call(this, t[0], t[1]);
            case 3:
                return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
    };
}
var Nk = "[object Map]", Ik = "[object Set]", Dk = lu ? lu.iterator : void 0;
function zk(e) {
    if (!e) return [];
    if (eh(e)) return Vw(e) ? op(e) : Nf(e);
    if (Dk && e[Dk]) return function(e) {
        for(var t, n = []; !(t = e.next()).done;)n.push(t.value);
        return n;
    }(e[Dk]());
    var t = Em(e);
    return (t == Nk ? Tg : t == Ik ? Rg : Ww)(e);
}
function qk() {
    void 0 === this.__values__ && (this.__values__ = zk(this.value()));
    var e = this.__index__ >= this.__values__.length;
    return {
        done: e,
        value: e ? void 0 : this.__values__[this.__index__++]
    };
}
function Bk(e, t) {
    var n = e.length;
    if (n) return hd(t += t < 0 ? n : 0, n) ? e[t] : void 0;
}
function Lk(e, t) {
    return e && e.length ? Bk(e, Uu(t)) : void 0;
}
function Fk(e) {
    return e = Uu(e), Yd(function(t) {
        return Bk(t, e);
    });
}
function Vk(e, t) {
    return null == (e = hx(e, t = cv(t, e))) || delete e[uv(vb(t))];
}
function Hk(e) {
    return Ov(e) ? void 0 : e;
}
var Wk = bv(function(e, t) {
    var n = {};
    if (null == e) return n;
    var r = !1;
    t = Su(t, function(t) {
        return t = cv(t, e), r || (r = t.length > 1), t;
    }), Kd(e, pm(e), n), r && (n = gg(n, 7, Hk));
    for(var o = t.length; o--;)Vk(n, t[o]);
    return n;
}), Uk = Wk;
function Jk(e, t, n, r) {
    if (!Iu(e)) return e;
    for(var o = -1, i = (t = cv(t, e)).length, a = i - 1, s = e; null != s && ++o < i;){
        var c = uv(t[o]), l = n;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return e;
        if (o != a) {
            var u = s[c];
            void 0 === (l = r ? r(u, c, s) : void 0) && (l = Iu(u) ? u : hd(t[o + 1]) ? [] : {});
        }
        Jd(s, c, l), s = s[c];
    }
    return e;
}
function Kk(e, t, n) {
    for(var r = -1, o = t.length, i = {}; ++r < o;){
        var a = t[r], s = fv(e, a);
        n(s, a) && Jk(i, cv(a, e), s);
    }
    return i;
}
function Gk(e, t) {
    if (null == e) return {};
    var n = Su(pm(e), function(e) {
        return [
            e
        ];
    });
    return t = wy(t), Kk(e, n, function(e, n) {
        return t(e, n[0]);
    });
}
function Qk(e, t) {
    return Gk(e, Rk(wy(t)));
}
function Yk(e) {
    return Nv(2, e);
}
function Xk(e, t) {
    if (e !== t) {
        var n = void 0 !== e, r = null === e, o = e == e, i = xu(e), a = void 0 !== t, s = null === t, c = t == t, l = xu(t);
        if (!s && !l && !i && e > t || i && a && c && !s && !l || r && a && c || !n && c || !o) return 1;
        if (!r && !i && !l && e < t || l && n && o && !r && !i || s && n && o || !a && o || !c) return -1;
    }
    return 0;
}
function Zk(e, t, n) {
    t = t.length ? Su(t, function(e) {
        return Cu(e) ? function(t) {
            return fv(t, 1 === e.length ? e[0] : e);
        } : e;
    }) : [
        Ku
    ];
    var r = -1;
    t = Su(t, gh(wy));
    var o = lw(e, function(e, n, o) {
        var i = Su(t, function(t) {
            return t(e);
        });
        return {
            criteria: i,
            index: ++r,
            value: e
        };
    });
    return function(e, t) {
        var n = e.length;
        for(e.sort(t); n--;)e[n] = e[n].value;
        return e;
    }(o, function(e, t) {
        return function(e, t, n) {
            for(var r = -1, o = e.criteria, i = t.criteria, a = o.length, s = n.length; ++r < a;){
                var c = Xk(o[r], i[r]);
                if (c) return r >= s ? c : c * ("desc" == n[r] ? -1 : 1);
            }
            return e.index - t.index;
        }(e, t, n);
    });
}
function ej(e, t, n, r) {
    return null == e ? [] : (Cu(t) || (t = null == t ? [] : [
        t
    ]), Cu(n = r ? void 0 : n) || (n = null == n ? [] : [
        n
    ]), Zk(e, t, n));
}
function tj(e) {
    return bv(function(t) {
        return t = Su(t, gh(wy)), Yd(function(n) {
            var r = this;
            return e(t, function(e) {
                return xf(e, r, n);
            });
        });
    });
}
var nj = tj(Su), rj = Yd, oj = Math.min, ij = rj(function(e, t) {
    var n = (t = 1 == t.length && Cu(t[0]) ? Su(t[0], gh(wy)) : Su(gv(t, 1), gh(wy))).length;
    return Yd(function(r) {
        for(var o = -1, i = oj(r.length, n); ++o < i;)r[o] = t[o].call(this, r[o]);
        return xf(e, this, r);
    });
}), aj = ij, sj = tj(Vb), cj = tj(Og), lj = 9007199254740991, uj = Math.floor;
function fj(e, t) {
    var n = "";
    if (!e || t < 1 || t > lj) return n;
    do t % 2 && (n += e), (t = uj(t / 2)) && (e += e);
    while (t);
    return n;
}
var dj = yy("length"), hj = "\ud800-\udfff", vj = "[" + hj + "]", pj = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", mj = "\ud83c[\udffb-\udfff]", gj = "[^" + hj + "]", yj = "(?:\ud83c[\udde6-\uddff]){2}", bj = "[\ud800-\udbff][\udc00-\udfff]", wj = "(?:" + pj + "|" + mj + ")" + "?", xj = "[\\ufe0e\\ufe0f]?", kj = xj + wj + ("(?:\\u200d(?:" + [
    gj,
    yj,
    bj
].join("|") + ")" + xj + wj + ")*"), jj = "(?:" + [
    gj + pj + "?",
    pj,
    yj,
    bj,
    vj
].join("|") + ")", Sj = RegExp(mj + "(?=" + mj + ")|" + jj + kj, "g");
function Cj(e) {
    return Wv(e) ? function(e) {
        for(var t = Sj.lastIndex = 0; Sj.test(e);)++t;
        return t;
    }(e) : dj(e);
}
var $j = Math.ceil;
function _j(e, t) {
    var n = (t = void 0 === t ? " " : Mu(t)).length;
    if (n < 2) return n ? fj(t, e) : t;
    var r = fj(t, $j(e / Cj(t)));
    return Wv(t) ? Vv(op(r), 0, e).join("") : r.slice(0, e);
}
var Oj = Math.ceil, Mj = Math.floor;
function Ej(e, t, n) {
    e = sv(e);
    var r = (t = Uu(t)) ? Cj(e) : 0;
    if (!t || r >= t) return e;
    var o = (t - r) / 2;
    return _j(Mj(o), n) + e + _j(Oj(o), n);
}
function Aj(e, t, n) {
    e = sv(e);
    var r = (t = Uu(t)) ? Cj(e) : 0;
    return t && r < t ? e + _j(t - r, n) : e;
}
function Pj(e, t, n) {
    e = sv(e);
    var r = (t = Uu(t)) ? Cj(e) : 0;
    return t && r < t ? _j(t - r, n) + e : e;
}
var Tj = /^\s+/, Rj = cu.parseInt;
function Nj(e, t, n) {
    return n || null == t ? t = 0 : t && (t = +t), Rj(sv(e).replace(Tj, ""), t || 0);
}
var Ij = Yd(function(e, t) {
    return Ld(e, 32, void 0, t, md(t, ud(Ij)));
});
Ij.placeholder = {};
var Dj = Ij, zj = Yd(function(e, t) {
    return Ld(e, 64, void 0, t, md(t, ud(zj)));
});
zj.placeholder = {};
var qj = zj, Bj = Py(function(e, t, n) {
    e[n ? 0 : 1].push(t);
}, function() {
    return [
        [],
        []
    ];
}), Lj = Bj;
var Fj = bv(function(e, t) {
    return null == e ? {} : function(e, t) {
        return Kk(e, t, function(t, n) {
            return vy(e, n);
        });
    }(e, t);
}), Vj = Fj;
function Hj(e) {
    for(var t, n = this; n instanceof $f;){
        var r = If(n);
        r.__index__ = 0, r.__values__ = void 0, t ? o.__wrapped__ = r : t = r;
        var o = r;
        n = n.__wrapped__;
    }
    return o.__wrapped__ = e, t;
}
function Wj(e) {
    return function(t) {
        return null == e ? void 0 : fv(e, t);
    };
}
function Uj(e, t, n, r) {
    for(var o = n - 1, i = e.length; ++o < i;)if (r(e[o], t)) return o;
    return -1;
}
var Jj = Array.prototype.splice;
function Kj(e, t, n, r) {
    var o = r ? Uj : Zf, i = -1, a = t.length, s = e;
    for(e === t && (t = Nf(t)), n && (s = Su(e, gh(n))); ++i < a;)for(var c = 0, l = t[i], u = n ? n(l) : l; (c = o(s, u, c, r)) > -1;)s !== e && Jj.call(s, c, 1), Jj.call(e, c, 1);
    return e;
}
function Gj(e, t) {
    return e && e.length && t && t.length ? Kj(e, t) : e;
}
var Qj = Yd(Gj);
function Yj(e, t, n) {
    return e && e.length && t && t.length ? Kj(e, t, wy(n)) : e;
}
function Xj(e, t, n) {
    return e && e.length && t && t.length ? Kj(e, t, void 0, n) : e;
}
var Zj = Array.prototype.splice;
function eS(e, t) {
    for(var n = e ? t.length : 0, r = n - 1; n--;){
        var o = t[n];
        if (n == r || o !== i) {
            var i = o;
            hd(o) ? Zj.call(e, o, 1) : Vk(e, o);
        }
    }
    return e;
}
var tS = bv(function(e, t) {
    var n = null == e ? 0 : e.length, r = hv(e, t);
    return eS(e, Su(t, function(e) {
        return hd(e, n) ? +e : e;
    }).sort(Xk)), r;
}), nS = tS, rS = Math.floor, oS = Math.random;
function iS(e, t) {
    return e + rS(oS() * (t - e + 1));
}
var aS = parseFloat, sS = Math.min, cS = Math.random;
function lS(e, t, n) {
    if (n && "boolean" != typeof n && th(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = Wu(e), void 0 === t ? (t = e, e = 0) : t = Wu(t)), e > t) {
        var r = e;
        e = t, t = r;
    }
    if (n || e % 1 || t % 1) {
        var o = cS();
        return sS(e + o * (t - e + aS("1e-" + ((o + "").length - 1))), t);
    }
    return iS(e, t);
}
var uS = Math.ceil, fS = Math.max;
function dS(e) {
    return function(t, n, r) {
        return r && "number" != typeof r && th(t, n, r) && (n = r = void 0), t = Wu(t), void 0 === n ? (n = t, t = 0) : n = Wu(n), function(e, t, n, r) {
            for(var o = -1, i = fS(uS((t - e) / (n || 1)), 0), a = Array(i); i--;)a[r ? i : ++o] = e, e += n;
            return a;
        }(t, n, r = void 0 === r ? t < n ? 1 : -1 : Wu(r), e);
    };
}
var hS = dS(), vS = dS(!0), pS = bv(function(e, t) {
    return Ld(e, 256, void 0, void 0, void 0, t);
}), mS = pS;
function gS(e, t, n, r, o) {
    return o(e, function(e, o, i) {
        n = r ? (r = !1, e) : t(n, e, o, i);
    }), n;
}
function yS(e, t, n) {
    var r = Cu(e) ? cp : gS, o = arguments.length < 3;
    return r(e, wy(t), n, o, Ey);
}
function bS(e, t, n, r) {
    var o = null == e ? 0 : e.length;
    for(r && o && (n = e[--o]); o--;)n = t(n, e[o], o, e);
    return n;
}
function wS(e, t, n) {
    var r = Cu(e) ? bS : gS, o = arguments.length < 3;
    return r(e, wy(t), n, o, Eb);
}
function xS(e, t) {
    return (Cu(e) ? sm : Gb)(e, Rk(wy(t)));
}
function kS(e, t) {
    var n = [];
    if (!e || !e.length) return n;
    var r = -1, o = [], i = e.length;
    for(t = wy(t); ++r < i;){
        var a = e[r];
        t(a, r, e) && (n.push(a), o.push(r));
    }
    return eS(e, o), n;
}
function jS(e, t, n) {
    return t = (n ? th(e, t, n) : void 0 === t) ? 1 : Uu(t), fj(sv(e), t);
}
function SS() {
    var e = arguments, t = sv(e[0]);
    return e.length < 3 ? t : t.replace(e[1], e[2]);
}
function CS(e, t) {
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return Yd(e, t = void 0 === t ? t : Uu(t));
}
function $S(e, t, n) {
    var r = -1, o = (t = cv(t, e)).length;
    for(o || (o = 1, e = void 0); ++r < o;){
        var i = null == e ? void 0 : e[uv(t[r])];
        void 0 === i && (r = o, i = n), e = Zu(i) ? i.call(e) : i;
    }
    return e;
}
var _S = Array.prototype.reverse;
function OS(e) {
    return null == e ? e : _S.call(e);
}
var MS = Up("round");
function ES(e) {
    var t = e.length;
    return t ? e[iS(0, t - 1)] : void 0;
}
function AS(e) {
    return ES(Ww(e));
}
function PS(e) {
    return (Cu(e) ? ES : AS)(e);
}
function TS(e, t) {
    var n = -1, r = e.length, o = r - 1;
    for(t = void 0 === t ? r : t; ++n < t;){
        var i = iS(n, o), a = e[i];
        e[i] = e[n], e[n] = a;
    }
    return e.length = t, e;
}
function RS(e, t) {
    return TS(Nf(e), Xp(t, 0, e.length));
}
function NS(e, t) {
    var n = Ww(e);
    return TS(n, Xp(t, 0, n.length));
}
function IS(e, t, n) {
    return t = (n ? th(e, t, n) : void 0 === t) ? 1 : Uu(t), (Cu(e) ? RS : NS)(e, t);
}
function DS(e, t, n) {
    return null == e ? e : Jk(e, t, n);
}
function zS(e, t, n, r) {
    return r = "function" == typeof r ? r : void 0, null == e ? e : Jk(e, t, n, r);
}
function qS(e) {
    return TS(Nf(e));
}
function BS(e) {
    return TS(Ww(e));
}
function LS(e) {
    return (Cu(e) ? qS : BS)(e);
}
function FS(e) {
    if (null == e) return 0;
    if (eh(e)) return Vw(e) ? Cj(e) : e.length;
    var t = Em(e);
    return "[object Map]" == t || "[object Set]" == t ? e.size : Mh(e).length;
}
function VS(e, t, n) {
    var r = null == e ? 0 : e.length;
    return r ? (n && "number" != typeof n && th(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : Uu(t), n = void 0 === n ? r : Uu(n)), Fv(e, t, n)) : [];
}
var HS = Bp(function(e, t, n) {
    return e + (n ? "_" : "") + t.toLowerCase();
}), WS = HS;
function US(e, t) {
    var n;
    return Ey(e, function(e, r, o) {
        return !(n = t(e, r, o));
    }), !!n;
}
function JS(e, t, n) {
    var r = Cu(e) ? Og : US;
    return n && th(e, t, n) && (t = void 0), r(e, wy(t));
}
var KS = Yd(function(e, t) {
    if (null == e) return [];
    var n = t.length;
    return n > 1 && th(e, t[0], t[1]) ? t = [] : n > 2 && th(t[0], t[1], t[2]) && (t = [
        t[0]
    ]), Zk(e, gv(t, 1), []);
}), GS = KS, QS = 4294967294, YS = Math.floor, XS = Math.min;
function ZS(e, t, n, r) {
    var o = 0, i = null == e ? 0 : e.length;
    if (0 === i) return 0;
    for(var a = (t = n(t)) != t, s = null === t, c = xu(t), l = void 0 === t; o < i;){
        var u = YS((o + i) / 2), f = n(e[u]), d = void 0 !== f, h = null === f, v = f == f, p = xu(f);
        if (a) var m = r || v;
        else m = l ? v && (r || d) : s ? v && d && (r || !h) : c ? v && d && !h && (r || !p) : !h && !p && (r ? f <= t : f < t);
        m ? o = u + 1 : i = u;
    }
    return XS(i, QS);
}
var eC = 2147483647;
function tC(e, t, n) {
    var r = 0, o = null == e ? r : e.length;
    if ("number" == typeof t && t == t && o <= eC) {
        for(; r < o;){
            var i = r + o >>> 1, a = e[i];
            null !== a && !xu(a) && (n ? a <= t : a < t) ? r = i + 1 : o = i;
        }
        return o;
    }
    return ZS(e, t, Ku, n);
}
function nC(e, t) {
    return tC(e, t);
}
function rC(e, t, n) {
    return ZS(e, t, wy(n));
}
function oC(e, t) {
    var n = null == e ? 0 : e.length;
    if (n) {
        var r = tC(e, t);
        if (r < n && Wd(e[r], t)) return r;
    }
    return -1;
}
function iC(e, t) {
    return tC(e, t, !0);
}
function aC(e, t, n) {
    return ZS(e, t, wy(n), !0);
}
function sC(e, t) {
    if (null == e ? 0 : e.length) {
        var n = tC(e, t, !0) - 1;
        if (Wd(e[n], t)) return n;
    }
    return -1;
}
function cC(e, t) {
    for(var n = -1, r = e.length, o = 0, i = []; ++n < r;){
        var a = e[n], s = t ? t(a) : a;
        if (!n || !Wd(s, c)) {
            var c = s;
            i[o++] = 0 === a ? 0 : a;
        }
    }
    return i;
}
function lC(e) {
    return e && e.length ? cC(e) : [];
}
function uC(e, t) {
    return e && e.length ? cC(e, wy(t)) : [];
}
function fC(e, t, n) {
    return n && "number" != typeof n && th(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = sv(e)) && ("string" == typeof t || null != t && !Vx(t)) && !(t = Mu(t)) && Wv(e) ? Vv(op(e), 0, n) : e.split(t, n) : [];
}
var dC = Math.max;
function hC(e, t) {
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return t = null == t ? 0 : dC(Uu(t), 0), Yd(function(n) {
        var r = n[t], o = Vv(n, 0, t);
        return r && vv(o, r), xf(e, this, o);
    });
}
var vC = Bp(function(e, t, n) {
    return e + (n ? " " : "") + ap(t);
}), pC = vC;
function mC(e, t, n) {
    return e = sv(e), n = null == n ? 0 : Xp(Uu(n), 0, e.length), t = Mu(t), e.slice(n, n + t.length) == t;
}
function gC() {
    return {};
}
function yC() {
    return "";
}
function bC() {
    return !0;
}
var wC = Eu(function(e, t) {
    return e - t;
}, 0);
function xC(e) {
    return e && e.length ? yk(e, Ku) : 0;
}
function kC(e, t) {
    return e && e.length ? yk(e, wy(t)) : 0;
}
function jC(e) {
    var t = null == e ? 0 : e.length;
    return t ? Fv(e, 1, t) : [];
}
function SC(e, t, n) {
    return e && e.length ? Fv(e, 0, (t = n || void 0 === t ? 1 : Uu(t)) < 0 ? 0 : t) : [];
}
function CC(e, t, n) {
    var r = null == e ? 0 : e.length;
    return r ? Fv(e, (t = r - (t = n || void 0 === t ? 1 : Uu(t))) < 0 ? 0 : t, r) : [];
}
function $C(e, t) {
    return e && e.length ? kb(e, wy(t), !1, !0) : [];
}
function _C(e, t) {
    return e && e.length ? kb(e, wy(t)) : [];
}
function OC(e, t) {
    return t(e), e;
}
var MC = Object.prototype, EC = MC.hasOwnProperty;
function AC(e, t, n, r) {
    return void 0 === e || Wd(e, MC[n]) && !EC.call(r, n) ? t : e;
}
var PC = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
};
function TC(e) {
    return "\\" + PC[e];
}
var RC = /<%=([\s\S]+?)%>/g, NC = {
    escape: /<%-([\s\S]+?)%>/g,
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: RC,
    variable: "",
    imports: {
        _: {
            escape: qb
        }
    }
}, IC = /\b__p \+= '';/g, DC = /\b(__p \+=) '' \+/g, zC = /(__e\(.*?\)|\b__t\)) \+\n'';/g, qC = /[()=,{}\[\]\/\s]/, BC = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, LC = /($^)/, FC = /['\n\r\u2028\u2029\\]/g, VC = Object.prototype.hasOwnProperty;
function HC(e, t, n) {
    var r = NC.imports._.templateSettings || NC;
    n && th(e, t, n) && (t = void 0), e = sv(e), t = Bh({}, t, r, AC);
    var o, i, a = Bh({}, t.imports, r.imports, AC), s = Eh(a), c = Hw(a, s), l = 0, u = t.interpolate || LC, f = "__p += '", d = RegExp((t.escape || LC).source + "|" + u.source + "|" + (u === RC ? BC : LC).source + "|" + (t.evaluate || LC).source + "|$", "g"), h = VC.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
    e.replace(d, function(t, n, r, a, s, c) {
        return r || (r = a), f += e.slice(l, c).replace(FC, TC), n && (o = !0, f += "' +\n__e(" + n + ") +\n'"), s && (i = !0, f += "';\n" + s + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), l = c + t.length, t;
    }), f += "';\n";
    var v = VC.call(t, "variable") && t.variable;
    if (v) {
        if (qC.test(v)) throw new Error("Invalid `variable` option passed into `_.template`");
    } else f = "with (obj) {\n" + f + "\n}\n";
    f = (i ? f.replace(IC, "") : f).replace(DC, "$1").replace(zC, "$1;"), f = "function(" + (v || "obj") + ") {\n" + (v ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (o ? ", __e = _.escape" : "") + (i ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
    var p = Tv(function() {
        return Function(s, h + "return " + f).apply(void 0, c);
    });
    if (p.source = f, Av(p)) throw p;
    return p;
}
var WC = "Expected a function";
function UC(e, t, n) {
    var r = !0, o = !0;
    if ("function" != typeof e) throw new TypeError(WC);
    return Iu(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), Vy(e, t, {
        leading: r,
        maxWait: t,
        trailing: o
    });
}
function JC(e, t) {
    return t(e);
}
var KC = 9007199254740991, GC = 4294967295, QC = Math.min;
function YC(e, t) {
    if ((e = Uu(e)) < 1 || e > KC) return [];
    var n = GC, r = QC(e, GC);
    t = Cb(t), e -= GC;
    for(var o = ih(r, t); ++n < e;)t(n);
    return o;
}
function XC() {
    return this;
}
function ZC(e, t) {
    var n = e;
    return n instanceof Of && (n = n.value()), cp(t, function(e, t) {
        return t.func.apply(t.thisArg, vv([
            e
        ], t.args));
    }, n);
}
function e$() {
    return ZC(this.__wrapped__, this.__actions__);
}
function t$(e) {
    return sv(e).toLowerCase();
}
function n$(e) {
    return Cu(e) ? Su(e, uv) : xu(e) ? [
        e
    ] : Nf(av(sv(e)));
}
var r$ = 9007199254740991;
function o$(e) {
    return e ? Xp(Uu(e), -9007199254740991, r$) : 0 === e ? e : 0;
}
function i$(e) {
    return sv(e).toUpperCase();
}
function a$(e, t, n) {
    var r = Cu(e), o = r || ph(e) || jh(e);
    if (t = wy(t), null == n) {
        var i = e && e.constructor;
        n = o ? r ? new i : [] : Iu(e) && Zu(i) ? yf(xv(e)) : {};
    }
    return (o ? Qf : Oy)(e, function(e, r, o) {
        return t(n, e, r, o);
    }), n;
}
function s$(e, t) {
    for(var n = e.length; n-- && Zf(t, e[n], 0) > -1;);
    return n;
}
function c$(e, t) {
    for(var n = -1, r = e.length; ++n < r && Zf(t, e[n], 0) > -1;);
    return n;
}
function l$(e, t, n) {
    if ((e = sv(e)) && (n || void 0 === t)) return Nu(e);
    if (!e || !(t = Mu(t))) return e;
    var r = op(e), o = op(t);
    return Vv(r, c$(r, o), s$(r, o) + 1).join("");
}
function u$(e, t, n) {
    if ((e = sv(e)) && (n || void 0 === t)) return e.slice(0, Tu(e) + 1);
    if (!e || !(t = Mu(t))) return e;
    var r = op(e);
    return Vv(r, 0, s$(r, op(t)) + 1).join("");
}
var f$ = /^\s+/;
function d$(e, t, n) {
    if ((e = sv(e)) && (n || void 0 === t)) return e.replace(f$, "");
    if (!e || !(t = Mu(t))) return e;
    var r = op(e);
    return Vv(r, c$(r, op(t))).join("");
}
var h$ = /\w*$/;
function v$(e, t) {
    var n = 30, r = "...";
    if (Iu(t)) {
        var o = "separator" in t ? t.separator : o;
        n = "length" in t ? Uu(t.length) : n, r = "omission" in t ? Mu(t.omission) : r;
    }
    var i = (e = sv(e)).length;
    if (Wv(e)) {
        var a = op(e);
        i = a.length;
    }
    if (n >= i) return e;
    var s = n - Cj(r);
    if (s < 1) return r;
    var c = a ? Vv(a, 0, s).join("") : e.slice(0, s);
    if (void 0 === o) return c + r;
    if (a && (s += c.length - s), Vx(o)) {
        if (e.slice(s).search(o)) {
            var l, u = c;
            for(o.global || (o = RegExp(o.source, sv(h$.exec(o)) + "g")), o.lastIndex = 0; l = o.exec(u);)var f = l.index;
            c = c.slice(0, void 0 === f ? s : f);
        }
    } else if (e.indexOf(Mu(o), s) != s) {
        var d = c.lastIndexOf(o);
        d > -1 && (c = c.slice(0, d));
    }
    return c + r;
}
function p$(e) {
    return Vd(e, 1);
}
var m$ = lp({
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
}), g$ = /&(?:amp|lt|gt|quot|#39);/g, y$ = RegExp(g$.source);
function b$(e) {
    return (e = sv(e)) && y$.test(e) ? e.replace(g$, m$) : e;
}
var w$ = ym && 1 / Rg(new ym([
    ,
    -0
]))[1] == 1 / 0 ? function(e) {
    return new ym(e);
} : Mf, x$ = 200;
function k$(e, t, n) {
    var r = -1, o = ed, i = e.length, a = !0, s = [], c = s;
    if (n) a = !1, o = lb;
    else if (i >= x$) {
        var l = t ? null : w$(e);
        if (l) return Rg(l);
        a = !1, o = Mg, c = new _g;
    } else c = t ? [] : s;
    e: for(; ++r < i;){
        var u = e[r], f = t ? t(u) : u;
        if (u = n || 0 !== u ? u : 0, a && f == f) {
            for(var d = c.length; d--;)if (c[d] === f) continue e;
            t && c.push(f), s.push(u);
        } else o(c, f, n) || (c !== s && c.push(f), s.push(u));
    }
    return s;
}
var j$ = Yd(function(e) {
    return k$(gv(e, 1, Qy, !0));
}), S$ = Yd(function(e) {
    var t = vb(e);
    return Qy(t) && (t = void 0), k$(gv(e, 1, Qy, !0), wy(t));
}), C$ = S$, $$ = Yd(function(e) {
    var t = vb(e);
    return t = "function" == typeof t ? t : void 0, k$(gv(e, 1, Qy, !0), void 0, t);
});
function _$(e) {
    return e && e.length ? k$(e) : [];
}
function O$(e, t) {
    return e && e.length ? k$(e, wy(t)) : [];
}
function M$(e, t) {
    return t = "function" == typeof t ? t : void 0, e && e.length ? k$(e, void 0, t) : [];
}
var E$ = 0;
function A$(e) {
    var t = ++E$;
    return sv(e) + t;
}
function P$(e, t) {
    return null == e || Vk(e, t);
}
var T$ = Math.max;
function R$(e) {
    if (!e || !e.length) return [];
    var t = 0;
    return e = sm(e, function(e) {
        if (Qy(e)) return t = T$(e.length, t), !0;
    }), ih(t, function(t) {
        return Su(e, yy(t));
    });
}
function N$(e, t) {
    if (!e || !e.length) return [];
    var n = R$(e);
    return null == t ? n : Su(n, function(e) {
        return xf(t, void 0, e);
    });
}
function I$(e, t, n, r) {
    return Jk(e, t, n(fv(e, t)), r);
}
function D$(e, t, n) {
    return null == e ? e : I$(e, t, Cb(n));
}
function z$(e, t, n, r) {
    return r = "function" == typeof r ? r : void 0, null == e ? e : I$(e, t, Cb(n), r);
}
var q$ = Bp(function(e, t, n) {
    return e + (n ? " " : "") + t.toUpperCase();
}), B$ = q$;
function L$(e) {
    return null == e ? [] : Hw(e, Ih(e));
}
var F$ = Yd(function(e, t) {
    return Qy(e) ? fb(e, t) : [];
}), V$ = F$;
function H$(e, t) {
    return Dj(Cb(t), e);
}
var W$ = bv(function(e) {
    var t = e.length, n = t ? e[0] : 0, r = this.__wrapped__, o = function(t) {
        return hv(t, e);
    };
    return !(t > 1 || this.__actions__.length) && r instanceof Of && hd(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
        func: JC,
        args: [
            o
        ],
        thisArg: void 0
    }), new Rf(r, this.__chain__).thru(function(e) {
        return t && !e.length && e.push(void 0), e;
    })) : this.thru(o);
}), U$ = W$;
function J$() {
    return Kp(this);
}
function K$() {
    var e = this.__wrapped__;
    if (e instanceof Of) {
        var t = e;
        return this.__actions__.length && (t = new Of(this)), (t = t.reverse()).__actions__.push({
            func: JC,
            args: [
                OS
            ],
            thisArg: void 0
        }), new Rf(t, this.__chain__);
    }
    return this.thru(OS);
}
function G$(e, t, n) {
    var r = e.length;
    if (r < 2) return r ? k$(e[0]) : [];
    for(var o = -1, i = Array(r); ++o < r;)for(var a = e[o], s = -1; ++s < r;)s != o && (i[o] = fb(i[o] || a, e[s], t, n));
    return k$(gv(i, 1), t, n);
}
var Q$ = Yd(function(e) {
    return G$(sm(e, Qy));
}), Y$ = Yd(function(e) {
    var t = vb(e);
    return Qy(t) && (t = void 0), G$(sm(e, Qy), wy(t));
}), X$ = Y$, Z$ = Yd(function(e) {
    var t = vb(e);
    return t = "function" == typeof t ? t : void 0, G$(sm(e, Qy), void 0, t);
}), e_ = Yd(R$);
function t_(e, t, n) {
    for(var r = -1, o = e.length, i = t.length, a = {}; ++r < o;){
        var s = r < i ? t[r] : void 0;
        n(a, e[r], s);
    }
    return a;
}
function n_(e, t) {
    return t_(e || [], t || [], Jd);
}
function r_(e, t) {
    return t_(e || [], t || [], Jk);
}
var o_ = Yd(function(e) {
    var t = e.length, n = t > 1 ? e[t - 1] : void 0;
    return n = "function" == typeof n ? (e.pop(), n) : void 0, N$(e, n);
}), i_ = o_, a_ = {
    chunk: Yp,
    compact: Cg,
    concat: $g,
    difference: hb,
    differenceBy: mb,
    differenceWith: yb,
    drop: wb,
    dropRight: xb,
    dropRightWhile: jb,
    dropWhile: Sb,
    fill: Kb,
    findIndex: Zb,
    findLastIndex: iw,
    first: cw,
    flatten: yv,
    flattenDeep: vw,
    flattenDepth: pw,
    fromPairs: Cw,
    head: cw,
    indexOf: Gw,
    initial: Qw,
    intersection: ex,
    intersectionBy: nx,
    intersectionWith: rx,
    join: Yx,
    last: vb,
    lastIndexOf: ok,
    nth: Lk,
    pull: Qj,
    pullAll: Gj,
    pullAllBy: Yj,
    pullAllWith: Xj,
    pullAt: nS,
    remove: kS,
    reverse: OS,
    slice: VS,
    sortedIndex: nC,
    sortedIndexBy: rC,
    sortedIndexOf: oC,
    sortedLastIndex: iC,
    sortedLastIndexBy: aC,
    sortedLastIndexOf: sC,
    sortedUniq: lC,
    sortedUniqBy: uC,
    tail: jC,
    take: SC,
    takeRight: CC,
    takeRightWhile: $C,
    takeWhile: _C,
    union: j$,
    unionBy: C$,
    unionWith: $$,
    uniq: _$,
    uniqBy: O$,
    uniqWith: M$,
    unzip: R$,
    unzipWith: N$,
    without: V$,
    xor: Q$,
    xorBy: X$,
    xorWith: Z$,
    zip: e_,
    zipObject: n_,
    zipObjectDeep: r_,
    zipWith: i_
}, s_ = {
    countBy: Ny,
    each: $b,
    eachRight: Ab,
    every: Wb,
    filter: Qb,
    find: ew,
    findLast: aw,
    flatMap: fw,
    flatMapDeep: dw,
    flatMapDepth: hw,
    forEach: $b,
    forEachRight: Ab,
    groupBy: Aw,
    includes: Jw,
    invokeMap: gx,
    keyBy: tk,
    map: uw,
    orderBy: ej,
    partition: Lj,
    reduce: yS,
    reduceRight: wS,
    reject: xS,
    sample: PS,
    sampleSize: IS,
    shuffle: LS,
    size: FS,
    some: JS,
    sortBy: GS
}, c_ = {
    now: qy
}, l_ = {
    after: Ju,
    ary: Vd,
    before: Nv,
    bind: Dv,
    bindKey: Lv,
    curry: Dy,
    curryRight: zy,
    debounce: Vy,
    defer: ab,
    delay: cb,
    flip: mw,
    memoize: rv,
    negate: Rk,
    once: Yk,
    overArgs: aj,
    partial: Dj,
    partialRight: qj,
    rearg: mS,
    rest: CS,
    spread: hC,
    throttle: UC,
    unary: p$,
    wrap: H$
}, u_ = {
    castArray: Vp,
    clone: yg,
    cloneDeep: bg,
    cloneDeepWith: kg,
    cloneWith: jg,
    conformsTo: Sy,
    eq: Wd,
    gt: Rw,
    gte: Nw,
    isArguments: uh,
    isArray: Cu,
    isArrayBuffer: bx,
    isArrayLike: eh,
    isArrayLikeObject: Qy,
    isBoolean: wx,
    isBuffer: ph,
    isDate: kx,
    isElement: jx,
    isEmpty: _x,
    isEqual: Ox,
    isEqualWith: Mx,
    isError: Av,
    isFinite: Ax,
    isFunction: Zu,
    isInteger: Px,
    isLength: Zd,
    isMap: ag,
    isMatch: Tx,
    isMatchWith: Rx,
    isNaN: Dx,
    isNative: qx,
    isNil: Bx,
    isNull: Lx,
    isNumber: Ix,
    isObject: Iu,
    isObjectLike: bu,
    isPlainObject: Ov,
    isRegExp: Vx,
    isSafeInteger: Wx,
    isSet: cg,
    isString: Vw,
    isSymbol: xu,
    isTypedArray: jh,
    isUndefined: Ux,
    isWeakMap: Jx,
    isWeakSet: Kx,
    lt: lk,
    lte: uk,
    toArray: zk,
    toFinite: Wu,
    toInteger: Uu,
    toLength: Jb,
    toNumber: Fu,
    toPlainObject: Xy,
    toSafeInteger: o$,
    toString: sv
}, f_ = {
    add: Au,
    ceil: Jp,
    divide: bb,
    floor: gw,
    max: mk,
    maxBy: gk,
    mean: xk,
    meanBy: kk,
    min: Mk,
    minBy: Ek,
    multiply: Pk,
    round: MS,
    subtract: wC,
    sum: xC,
    sumBy: kC
}, d_ = Zp, h_ = Lw, v_ = lS, p_ = {
    assign: Th,
    assignIn: zh,
    assignInWith: Bh,
    assignWith: Fh,
    at: wv,
    create: Iy,
    defaults: Ky,
    defaultsDeep: rb,
    entries: Rb,
    entriesIn: Nb,
    extend: zh,
    extendWith: Bh,
    findKey: nw,
    findLastKey: sw,
    forIn: xw,
    forInRight: kw,
    forOwn: jw,
    forOwnRight: Sw,
    functions: _w,
    functionsIn: Ow,
    get: dv,
    has: zw,
    hasIn: vy,
    invert: sx,
    invertBy: dx,
    invoke: px,
    keys: Eh,
    keysIn: Ih,
    mapKeys: fk,
    mapValues: dk,
    merge: Sk,
    mergeWith: nb,
    omit: Uk,
    omitBy: Qk,
    pick: Vj,
    pickBy: Gk,
    result: $S,
    set: DS,
    setWith: zS,
    toPairs: Rb,
    toPairsIn: Nb,
    transform: a$,
    unset: P$,
    update: D$,
    updateWith: z$,
    values: Ww,
    valuesIn: L$
}, m_ = {
    at: U$,
    chain: Kp,
    commit: Sg,
    lodash: zf,
    next: qk,
    plant: Hj,
    reverse: K$,
    tap: OC,
    thru: JC,
    toIterator: XC,
    toJSON: e$,
    value: e$,
    valueOf: e$,
    wrapperChain: J$
}, g_ = {
    camelCase: Fp,
    capitalize: sp,
    deburr: hp,
    endsWith: Pb,
    escape: qb,
    escapeRegExp: Fb,
    kebabCase: Zx,
    lowerCase: ak,
    lowerFirst: sk,
    pad: Ej,
    padEnd: Aj,
    padStart: Pj,
    parseInt: Nj,
    repeat: jS,
    replace: SS,
    snakeCase: WS,
    split: fC,
    startCase: pC,
    startsWith: mC,
    template: HC,
    templateSettings: NC,
    toLower: t$,
    toUpper: i$,
    trim: l$,
    trimEnd: u$,
    trimStart: d$,
    truncate: v$,
    unescape: b$,
    upperCase: B$,
    upperFirst: ap,
    words: zp
}, y_ = {
    attempt: Tv,
    bindAll: qv,
    cond: xy,
    conforms: jy,
    constant: Uf,
    defaultTo: Hy,
    flow: bw,
    flowRight: ww,
    identity: Ku,
    iteratee: Gx,
    matches: hk,
    matchesProperty: vk,
    method: $k,
    methodOf: Ok,
    mixin: Ak,
    noop: Mf,
    nthArg: Fk,
    over: nj,
    overEvery: sj,
    overSome: cj,
    property: by,
    propertyOf: Wj,
    range: hS,
    rangeRight: vS,
    stubArray: cm,
    stubFalse: fh,
    stubObject: gC,
    stubString: yC,
    stubTrue: bC,
    times: YC,
    toPath: n$,
    uniqueId: A$
};
var b_ = Math.max, w_ = Math.min;
var x_ = Math.min;
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ var k_, j_ = 4294967295, S_ = Array.prototype, C_ = Object.prototype.hasOwnProperty, $_ = lu ? lu.iterator : void 0, __ = Math.max, O_ = Math.min, M_ = function(e) {
    return function(t, n, r) {
        if (null == r) {
            var o = Iu(n), i = o && Eh(n), a = i && i.length && $w(n, i);
            (a ? a.length : o) || (r = n, n = t, t = this);
        }
        return e(t, n, r);
    };
}(Ak);
zf.after = l_.after, zf.ary = l_.ary, zf.assign = p_.assign, zf.assignIn = p_.assignIn, zf.assignInWith = p_.assignInWith, zf.assignWith = p_.assignWith, zf.at = p_.at, zf.before = l_.before, zf.bind = l_.bind, zf.bindAll = y_.bindAll, zf.bindKey = l_.bindKey, zf.castArray = u_.castArray, zf.chain = m_.chain, zf.chunk = a_.chunk, zf.compact = a_.compact, zf.concat = a_.concat, zf.cond = y_.cond, zf.conforms = y_.conforms, zf.constant = y_.constant, zf.countBy = s_.countBy, zf.create = p_.create, zf.curry = l_.curry, zf.curryRight = l_.curryRight, zf.debounce = l_.debounce, zf.defaults = p_.defaults, zf.defaultsDeep = p_.defaultsDeep, zf.defer = l_.defer, zf.delay = l_.delay, zf.difference = a_.difference, zf.differenceBy = a_.differenceBy, zf.differenceWith = a_.differenceWith, zf.drop = a_.drop, zf.dropRight = a_.dropRight, zf.dropRightWhile = a_.dropRightWhile, zf.dropWhile = a_.dropWhile, zf.fill = a_.fill, zf.filter = s_.filter, zf.flatMap = s_.flatMap, zf.flatMapDeep = s_.flatMapDeep, zf.flatMapDepth = s_.flatMapDepth, zf.flatten = a_.flatten, zf.flattenDeep = a_.flattenDeep, zf.flattenDepth = a_.flattenDepth, zf.flip = l_.flip, zf.flow = y_.flow, zf.flowRight = y_.flowRight, zf.fromPairs = a_.fromPairs, zf.functions = p_.functions, zf.functionsIn = p_.functionsIn, zf.groupBy = s_.groupBy, zf.initial = a_.initial, zf.intersection = a_.intersection, zf.intersectionBy = a_.intersectionBy, zf.intersectionWith = a_.intersectionWith, zf.invert = p_.invert, zf.invertBy = p_.invertBy, zf.invokeMap = s_.invokeMap, zf.iteratee = y_.iteratee, zf.keyBy = s_.keyBy, zf.keys = Eh, zf.keysIn = p_.keysIn, zf.map = s_.map, zf.mapKeys = p_.mapKeys, zf.mapValues = p_.mapValues, zf.matches = y_.matches, zf.matchesProperty = y_.matchesProperty, zf.memoize = l_.memoize, zf.merge = p_.merge, zf.mergeWith = p_.mergeWith, zf.method = y_.method, zf.methodOf = y_.methodOf, zf.mixin = M_, zf.negate = Rk, zf.nthArg = y_.nthArg, zf.omit = p_.omit, zf.omitBy = p_.omitBy, zf.once = l_.once, zf.orderBy = s_.orderBy, zf.over = y_.over, zf.overArgs = l_.overArgs, zf.overEvery = y_.overEvery, zf.overSome = y_.overSome, zf.partial = l_.partial, zf.partialRight = l_.partialRight, zf.partition = s_.partition, zf.pick = p_.pick, zf.pickBy = p_.pickBy, zf.property = y_.property, zf.propertyOf = y_.propertyOf, zf.pull = a_.pull, zf.pullAll = a_.pullAll, zf.pullAllBy = a_.pullAllBy, zf.pullAllWith = a_.pullAllWith, zf.pullAt = a_.pullAt, zf.range = y_.range, zf.rangeRight = y_.rangeRight, zf.rearg = l_.rearg, zf.reject = s_.reject, zf.remove = a_.remove, zf.rest = l_.rest, zf.reverse = a_.reverse, zf.sampleSize = s_.sampleSize, zf.set = p_.set, zf.setWith = p_.setWith, zf.shuffle = s_.shuffle, zf.slice = a_.slice, zf.sortBy = s_.sortBy, zf.sortedUniq = a_.sortedUniq, zf.sortedUniqBy = a_.sortedUniqBy, zf.split = g_.split, zf.spread = l_.spread, zf.tail = a_.tail, zf.take = a_.take, zf.takeRight = a_.takeRight, zf.takeRightWhile = a_.takeRightWhile, zf.takeWhile = a_.takeWhile, zf.tap = m_.tap, zf.throttle = l_.throttle, zf.thru = JC, zf.toArray = u_.toArray, zf.toPairs = p_.toPairs, zf.toPairsIn = p_.toPairsIn, zf.toPath = y_.toPath, zf.toPlainObject = u_.toPlainObject, zf.transform = p_.transform, zf.unary = l_.unary, zf.union = a_.union, zf.unionBy = a_.unionBy, zf.unionWith = a_.unionWith, zf.uniq = a_.uniq, zf.uniqBy = a_.uniqBy, zf.uniqWith = a_.uniqWith, zf.unset = p_.unset, zf.unzip = a_.unzip, zf.unzipWith = a_.unzipWith, zf.update = p_.update, zf.updateWith = p_.updateWith, zf.values = p_.values, zf.valuesIn = p_.valuesIn, zf.without = a_.without, zf.words = g_.words, zf.wrap = l_.wrap, zf.xor = a_.xor, zf.xorBy = a_.xorBy, zf.xorWith = a_.xorWith, zf.zip = a_.zip, zf.zipObject = a_.zipObject, zf.zipObjectDeep = a_.zipObjectDeep, zf.zipWith = a_.zipWith, zf.entries = p_.toPairs, zf.entriesIn = p_.toPairsIn, zf.extend = p_.assignIn, zf.extendWith = p_.assignInWith, M_(zf, zf), zf.add = f_.add, zf.attempt = y_.attempt, zf.camelCase = g_.camelCase, zf.capitalize = g_.capitalize, zf.ceil = f_.ceil, zf.clamp = d_, zf.clone = u_.clone, zf.cloneDeep = u_.cloneDeep, zf.cloneDeepWith = u_.cloneDeepWith, zf.cloneWith = u_.cloneWith, zf.conformsTo = u_.conformsTo, zf.deburr = g_.deburr, zf.defaultTo = y_.defaultTo, zf.divide = f_.divide, zf.endsWith = g_.endsWith, zf.eq = u_.eq, zf.escape = g_.escape, zf.escapeRegExp = g_.escapeRegExp, zf.every = s_.every, zf.find = s_.find, zf.findIndex = a_.findIndex, zf.findKey = p_.findKey, zf.findLast = s_.findLast, zf.findLastIndex = a_.findLastIndex, zf.findLastKey = p_.findLastKey, zf.floor = f_.floor, zf.forEach = s_.forEach, zf.forEachRight = s_.forEachRight, zf.forIn = p_.forIn, zf.forInRight = p_.forInRight, zf.forOwn = p_.forOwn, zf.forOwnRight = p_.forOwnRight, zf.get = p_.get, zf.gt = u_.gt, zf.gte = u_.gte, zf.has = p_.has, zf.hasIn = p_.hasIn, zf.head = a_.head, zf.identity = Ku, zf.includes = s_.includes, zf.indexOf = a_.indexOf, zf.inRange = h_, zf.invoke = p_.invoke, zf.isArguments = u_.isArguments, zf.isArray = Cu, zf.isArrayBuffer = u_.isArrayBuffer, zf.isArrayLike = u_.isArrayLike, zf.isArrayLikeObject = u_.isArrayLikeObject, zf.isBoolean = u_.isBoolean, zf.isBuffer = u_.isBuffer, zf.isDate = u_.isDate, zf.isElement = u_.isElement, zf.isEmpty = u_.isEmpty, zf.isEqual = u_.isEqual, zf.isEqualWith = u_.isEqualWith, zf.isError = u_.isError, zf.isFinite = u_.isFinite, zf.isFunction = u_.isFunction, zf.isInteger = u_.isInteger, zf.isLength = u_.isLength, zf.isMap = u_.isMap, zf.isMatch = u_.isMatch, zf.isMatchWith = u_.isMatchWith, zf.isNaN = u_.isNaN, zf.isNative = u_.isNative, zf.isNil = u_.isNil, zf.isNull = u_.isNull, zf.isNumber = u_.isNumber, zf.isObject = Iu, zf.isObjectLike = u_.isObjectLike, zf.isPlainObject = u_.isPlainObject, zf.isRegExp = u_.isRegExp, zf.isSafeInteger = u_.isSafeInteger, zf.isSet = u_.isSet, zf.isString = u_.isString, zf.isSymbol = u_.isSymbol, zf.isTypedArray = u_.isTypedArray, zf.isUndefined = u_.isUndefined, zf.isWeakMap = u_.isWeakMap, zf.isWeakSet = u_.isWeakSet, zf.join = a_.join, zf.kebabCase = g_.kebabCase, zf.last = vb, zf.lastIndexOf = a_.lastIndexOf, zf.lowerCase = g_.lowerCase, zf.lowerFirst = g_.lowerFirst, zf.lt = u_.lt, zf.lte = u_.lte, zf.max = f_.max, zf.maxBy = f_.maxBy, zf.mean = f_.mean, zf.meanBy = f_.meanBy, zf.min = f_.min, zf.minBy = f_.minBy, zf.stubArray = y_.stubArray, zf.stubFalse = y_.stubFalse, zf.stubObject = y_.stubObject, zf.stubString = y_.stubString, zf.stubTrue = y_.stubTrue, zf.multiply = f_.multiply, zf.nth = a_.nth, zf.noop = y_.noop, zf.now = c_.now, zf.pad = g_.pad, zf.padEnd = g_.padEnd, zf.padStart = g_.padStart, zf.parseInt = g_.parseInt, zf.random = v_, zf.reduce = s_.reduce, zf.reduceRight = s_.reduceRight, zf.repeat = g_.repeat, zf.replace = g_.replace, zf.result = p_.result, zf.round = f_.round, zf.sample = s_.sample, zf.size = s_.size, zf.snakeCase = g_.snakeCase, zf.some = s_.some, zf.sortedIndex = a_.sortedIndex, zf.sortedIndexBy = a_.sortedIndexBy, zf.sortedIndexOf = a_.sortedIndexOf, zf.sortedLastIndex = a_.sortedLastIndex, zf.sortedLastIndexBy = a_.sortedLastIndexBy, zf.sortedLastIndexOf = a_.sortedLastIndexOf, zf.startCase = g_.startCase, zf.startsWith = g_.startsWith, zf.subtract = f_.subtract, zf.sum = f_.sum, zf.sumBy = f_.sumBy, zf.template = g_.template, zf.times = y_.times, zf.toFinite = u_.toFinite, zf.toInteger = Uu, zf.toLength = u_.toLength, zf.toLower = g_.toLower, zf.toNumber = u_.toNumber, zf.toSafeInteger = u_.toSafeInteger, zf.toString = u_.toString, zf.toUpper = g_.toUpper, zf.trim = g_.trim, zf.trimEnd = g_.trimEnd, zf.trimStart = g_.trimStart, zf.truncate = g_.truncate, zf.unescape = g_.unescape, zf.uniqueId = y_.uniqueId, zf.upperCase = g_.upperCase, zf.upperFirst = g_.upperFirst, zf.each = s_.forEach, zf.eachRight = s_.forEachRight, zf.first = a_.head, M_(zf, (k_ = {}, Oy(zf, function(e, t) {
    C_.call(zf.prototype, t) || (k_[t] = e);
}), k_), {
    chain: !1
}), zf.VERSION = "4.17.21", (zf.templateSettings = g_.templateSettings).imports._ = zf, Qf([
    "bind",
    "bindKey",
    "curry",
    "curryRight",
    "partial",
    "partialRight"
], function(e) {
    zf[e].placeholder = zf;
}), Qf([
    "drop",
    "take"
], function(e, t) {
    Of.prototype[e] = function(n) {
        n = void 0 === n ? 1 : __(Uu(n), 0);
        var r = this.__filtered__ && !t ? new Of(this) : this.clone();
        return r.__filtered__ ? r.__takeCount__ = O_(n, r.__takeCount__) : r.__views__.push({
            size: O_(n, j_),
            type: e + (r.__dir__ < 0 ? "Right" : "")
        }), r;
    }, Of.prototype[e + "Right"] = function(t) {
        return this.reverse()[e](t).reverse();
    };
}), Qf([
    "filter",
    "map",
    "takeWhile"
], function(e, t) {
    var n = t + 1, r = 1 == n || 3 == n;
    Of.prototype[e] = function(e) {
        var t = this.clone();
        return t.__iteratees__.push({
            iteratee: wy(e),
            type: n
        }), t.__filtered__ = t.__filtered__ || r, t;
    };
}), Qf([
    "head",
    "last"
], function(e, t) {
    var n = "take" + (t ? "Right" : "");
    Of.prototype[e] = function() {
        return this[n](1).value()[0];
    };
}), Qf([
    "initial",
    "tail"
], function(e, t) {
    var n = "drop" + (t ? "" : "Right");
    Of.prototype[e] = function() {
        return this.__filtered__ ? new Of(this) : this[n](1);
    };
}), Of.prototype.compact = function() {
    return this.filter(Ku);
}, Of.prototype.find = function(e) {
    return this.filter(e).head();
}, Of.prototype.findLast = function(e) {
    return this.reverse().find(e);
}, Of.prototype.invokeMap = Yd(function(e, t) {
    return "function" == typeof e ? new Of(this) : this.map(function(n) {
        return vx(n, e, t);
    });
}), Of.prototype.reject = function(e) {
    return this.filter(Rk(wy(e)));
}, Of.prototype.slice = function(e, t) {
    e = Uu(e);
    var n = this;
    return n.__filtered__ && (e > 0 || t < 0) ? new Of(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = Uu(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
}, Of.prototype.takeRightWhile = function(e) {
    return this.reverse().takeWhile(e).reverse();
}, Of.prototype.toArray = function() {
    return this.take(j_);
}, Oy(Of.prototype, function(e, t) {
    var n = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), o = zf[r ? "take" + ("last" == t ? "Right" : "") : t], i = r || /^find/.test(t);
    o && (zf.prototype[t] = function() {
        var t = this.__wrapped__, a = r ? [
            1
        ] : arguments, s = t instanceof Of, c = a[0], l = s || Cu(t), u = function(e) {
            var t = o.apply(zf, vv([
                e
            ], a));
            return r && f ? t[0] : t;
        };
        l && n && "function" == typeof c && 1 != c.length && (s = l = !1);
        var f = this.__chain__, d = !!this.__actions__.length, h = i && !f, v = s && !d;
        if (!i && l) {
            t = v ? t : new Of(this);
            var p = e.apply(t, a);
            return p.__actions__.push({
                func: JC,
                args: [
                    u
                ],
                thisArg: void 0
            }), new Rf(p, f);
        }
        return h && v ? e.apply(this, a) : (p = this.thru(u), h ? r ? p.value()[0] : p.value() : p);
    });
}), Qf([
    "pop",
    "push",
    "shift",
    "sort",
    "splice",
    "unshift"
], function(e) {
    var t = S_[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
    zf.prototype[e] = function() {
        var e = arguments;
        if (r && !this.__chain__) {
            var o = this.value();
            return t.apply(Cu(o) ? o : [], e);
        }
        return this[n](function(n) {
            return t.apply(Cu(n) ? n : [], e);
        });
    };
}), Oy(Of.prototype, function(e, t) {
    var n = zf[t];
    if (n) {
        var r = n.name + "";
        C_.call(Af, r) || (Af[r] = []), Af[r].push({
            name: t,
            func: n
        });
    }
}), Af[jd(void 0, 2).name] = [
    {
        name: "wrapper",
        func: void 0
    }
], Of.prototype.clone = function() {
    var e = new Of(this.__wrapped__);
    return e.__actions__ = Nf(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Nf(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Nf(this.__views__), e;
}, Of.prototype.reverse = function() {
    if (this.__filtered__) {
        var e = new Of(this);
        e.__dir__ = -1, e.__filtered__ = !0;
    } else (e = this.clone()).__dir__ *= -1;
    return e;
}, Of.prototype.value = function() {
    var e = this.__wrapped__.value(), t = this.__dir__, n = Cu(e), r = t < 0, o = n ? e.length : 0, i = function(e, t, n) {
        for(var r = -1, o = n.length; ++r < o;){
            var i = n[r], a = i.size;
            switch(i.type){
                case "drop":
                    e += a;
                    break;
                case "dropRight":
                    t -= a;
                    break;
                case "take":
                    t = w_(t, e + a);
                    break;
                case "takeRight":
                    e = b_(e, t - a);
            }
        }
        return {
            start: e,
            end: t
        };
    }(0, o, this.__views__), a = i.start, s = i.end, c = s - a, l = r ? s : a - 1, u = this.__iteratees__, f = u.length, d = 0, h = x_(c, this.__takeCount__);
    if (!n || !r && o == c && h == c) return ZC(e, this.__actions__);
    var v = [];
    e: for(; c-- && d < h;){
        for(var p = -1, m = e[l += t]; ++p < f;){
            var g = u[p], y = g.iteratee, b = g.type, w = y(m);
            if (2 == b) m = w;
            else if (!w) {
                if (1 == b) continue e;
                break e;
            }
        }
        v[d++] = m;
    }
    return v;
}, zf.prototype.at = m_.at, zf.prototype.chain = m_.wrapperChain, zf.prototype.commit = m_.commit, zf.prototype.next = m_.next, zf.prototype.plant = m_.plant, zf.prototype.reverse = m_.reverse, zf.prototype.toJSON = zf.prototype.valueOf = zf.prototype.value = m_.value, zf.prototype.first = zf.prototype.head, $_ && (zf.prototype[$_] = m_.toIterator /**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ );
var E_ = Object.freeze({
    __proto__: null,
    add: Au,
    after: Ju,
    ary: Vd,
    assign: Th,
    assignIn: zh,
    assignInWith: Bh,
    assignWith: Fh,
    at: wv,
    attempt: Tv,
    before: Nv,
    bind: Dv,
    bindAll: qv,
    bindKey: Lv,
    camelCase: Fp,
    capitalize: sp,
    castArray: Vp,
    ceil: Jp,
    chain: Kp,
    chunk: Yp,
    clamp: Zp,
    clone: yg,
    cloneDeep: bg,
    cloneDeepWith: kg,
    cloneWith: jg,
    commit: Sg,
    compact: Cg,
    concat: $g,
    cond: xy,
    conforms: jy,
    conformsTo: Sy,
    constant: Uf,
    countBy: Ny,
    create: Iy,
    curry: Dy,
    curryRight: zy,
    debounce: Vy,
    deburr: hp,
    default: zf,
    defaultTo: Hy,
    defaults: Ky,
    defaultsDeep: rb,
    defer: ab,
    delay: cb,
    difference: hb,
    differenceBy: mb,
    differenceWith: yb,
    divide: bb,
    drop: wb,
    dropRight: xb,
    dropRightWhile: jb,
    dropWhile: Sb,
    each: $b,
    eachRight: Ab,
    endsWith: Pb,
    entries: Rb,
    entriesIn: Nb,
    eq: Wd,
    escape: qb,
    escapeRegExp: Fb,
    every: Wb,
    extend: zh,
    extendWith: Bh,
    fill: Kb,
    filter: Qb,
    find: ew,
    findIndex: Zb,
    findKey: nw,
    findLast: aw,
    findLastIndex: iw,
    findLastKey: sw,
    first: cw,
    flatMap: fw,
    flatMapDeep: dw,
    flatMapDepth: hw,
    flatten: yv,
    flattenDeep: vw,
    flattenDepth: pw,
    flip: mw,
    floor: gw,
    flow: bw,
    flowRight: ww,
    forEach: $b,
    forEachRight: Ab,
    forIn: xw,
    forInRight: kw,
    forOwn: jw,
    forOwnRight: Sw,
    fromPairs: Cw,
    functions: _w,
    functionsIn: Ow,
    get: dv,
    groupBy: Aw,
    gt: Rw,
    gte: Nw,
    has: zw,
    hasIn: vy,
    head: cw,
    identity: Ku,
    inRange: Lw,
    includes: Jw,
    indexOf: Gw,
    initial: Qw,
    intersection: ex,
    intersectionBy: nx,
    intersectionWith: rx,
    invert: sx,
    invertBy: dx,
    invoke: px,
    invokeMap: gx,
    isArguments: uh,
    isArray: Cu,
    isArrayBuffer: bx,
    isArrayLike: eh,
    isArrayLikeObject: Qy,
    isBoolean: wx,
    isBuffer: ph,
    isDate: kx,
    isElement: jx,
    isEmpty: _x,
    isEqual: Ox,
    isEqualWith: Mx,
    isError: Av,
    isFinite: Ax,
    isFunction: Zu,
    isInteger: Px,
    isLength: Zd,
    isMap: ag,
    isMatch: Tx,
    isMatchWith: Rx,
    isNaN: Dx,
    isNative: qx,
    isNil: Bx,
    isNull: Lx,
    isNumber: Ix,
    isObject: Iu,
    isObjectLike: bu,
    isPlainObject: Ov,
    isRegExp: Vx,
    isSafeInteger: Wx,
    isSet: cg,
    isString: Vw,
    isSymbol: xu,
    isTypedArray: jh,
    isUndefined: Ux,
    isWeakMap: Jx,
    isWeakSet: Kx,
    iteratee: Gx,
    join: Yx,
    kebabCase: Zx,
    keyBy: tk,
    keys: Eh,
    keysIn: Ih,
    last: vb,
    lastIndexOf: ok,
    lodash: zf,
    lowerCase: ak,
    lowerFirst: sk,
    lt: lk,
    lte: uk,
    map: uw,
    mapKeys: fk,
    mapValues: dk,
    matches: hk,
    matchesProperty: vk,
    max: mk,
    maxBy: gk,
    mean: xk,
    meanBy: kk,
    memoize: rv,
    merge: Sk,
    mergeWith: nb,
    method: $k,
    methodOf: Ok,
    min: Mk,
    minBy: Ek,
    mixin: Ak,
    multiply: Pk,
    negate: Rk,
    next: qk,
    noop: Mf,
    now: qy,
    nth: Lk,
    nthArg: Fk,
    omit: Uk,
    omitBy: Qk,
    once: Yk,
    orderBy: ej,
    over: nj,
    overArgs: aj,
    overEvery: sj,
    overSome: cj,
    pad: Ej,
    padEnd: Aj,
    padStart: Pj,
    parseInt: Nj,
    partial: Dj,
    partialRight: qj,
    partition: Lj,
    pick: Vj,
    pickBy: Gk,
    plant: Hj,
    property: by,
    propertyOf: Wj,
    pull: Qj,
    pullAll: Gj,
    pullAllBy: Yj,
    pullAllWith: Xj,
    pullAt: nS,
    random: lS,
    range: hS,
    rangeRight: vS,
    rearg: mS,
    reduce: yS,
    reduceRight: wS,
    reject: xS,
    remove: kS,
    repeat: jS,
    replace: SS,
    rest: CS,
    result: $S,
    reverse: OS,
    round: MS,
    sample: PS,
    sampleSize: IS,
    set: DS,
    setWith: zS,
    shuffle: LS,
    size: FS,
    slice: VS,
    snakeCase: WS,
    some: JS,
    sortBy: GS,
    sortedIndex: nC,
    sortedIndexBy: rC,
    sortedIndexOf: oC,
    sortedLastIndex: iC,
    sortedLastIndexBy: aC,
    sortedLastIndexOf: sC,
    sortedUniq: lC,
    sortedUniqBy: uC,
    split: fC,
    spread: hC,
    startCase: pC,
    startsWith: mC,
    stubArray: cm,
    stubFalse: fh,
    stubObject: gC,
    stubString: yC,
    stubTrue: bC,
    subtract: wC,
    sum: xC,
    sumBy: kC,
    tail: jC,
    take: SC,
    takeRight: CC,
    takeRightWhile: $C,
    takeWhile: _C,
    tap: OC,
    template: HC,
    templateSettings: NC,
    throttle: UC,
    thru: JC,
    times: YC,
    toArray: zk,
    toFinite: Wu,
    toInteger: Uu,
    toIterator: XC,
    toJSON: e$,
    toLength: Jb,
    toLower: t$,
    toNumber: Fu,
    toPairs: Rb,
    toPairsIn: Nb,
    toPath: n$,
    toPlainObject: Xy,
    toSafeInteger: o$,
    toString: sv,
    toUpper: i$,
    transform: a$,
    trim: l$,
    trimEnd: u$,
    trimStart: d$,
    truncate: v$,
    unary: p$,
    unescape: b$,
    union: j$,
    unionBy: C$,
    unionWith: $$,
    uniq: _$,
    uniqBy: O$,
    uniqWith: M$,
    uniqueId: A$,
    unset: P$,
    unzip: R$,
    unzipWith: N$,
    update: D$,
    updateWith: z$,
    upperCase: B$,
    upperFirst: ap,
    value: e$,
    valueOf: e$,
    values: Ww,
    valuesIn: L$,
    without: V$,
    words: zp,
    wrap: H$,
    wrapperAt: U$,
    wrapperChain: J$,
    wrapperCommit: Sg,
    wrapperLodash: zf,
    wrapperNext: qk,
    wrapperPlant: Hj,
    wrapperReverse: K$,
    wrapperToIterator: XC,
    wrapperValue: e$,
    xor: Q$,
    xorBy: X$,
    xorWith: Z$,
    zip: e_,
    zipObject: n_,
    zipObjectDeep: r_,
    zipWith: i_
}), A_ = 1e4, P_ = [];
function T_(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = {};
    if (!Array.isArray(e)) throw new TypeError("Array expected");
    function r(e, o) {
        (!Array.isArray(e) && !Gl(e) || t && o.length > 0) && (n[Zs(o)] = !0), Gl(e) && Object.keys(e).forEach(function(t) {
            r(e[t], o.concat(t));
        });
    }
    for(var o = Math.min(e.length, A_), i = 0; i < o; i++)r(e[i], P_);
    return Object.keys(n).sort().map(Xs);
}
function R_(e, t, n) {
    if (!(t <= e)) for(var r = e; r < t; r++)n(r);
}
function N_(e, t) {
    return e.length > t ? e.slice(0, t) : e;
}
function I_(e) {
    return Ro({}, e);
}
function D_(e) {
    return Object.values(e);
}
function z_(e, t, n, r) {
    var o = e.slice(0), i = o.splice(t, n);
    return o.splice.apply(o, [
        t + r,
        0
    ].concat(Bo(i))), o;
}
function q_(e, t) {
    try {
        return t.parse(e);
    } catch (n) {
        return t.parse(Hl(e));
    }
}
function B_(e, t) {
    try {
        return q_(e, t);
    } catch (e) {
        return;
    }
}
function L_(e, t) {
    e = e.replace(V_, "");
    try {
        return t(e);
    } catch (e) {}
    try {
        return t("[" + e + "]");
    } catch (e) {}
    try {
        return t("{" + e + "}");
    } catch (e) {}
    throw new Error("Failed to parse partial JSON");
}
function F_(e) {
    e = e.replace(V_, "");
    try {
        return Hl(e);
    } catch (e) {}
    try {
        var t = Hl("[" + e + "]");
        return t.substring(1, t.length - 1);
    } catch (e) {}
    try {
        var n = Hl("{" + e + "}");
        return n.substring(1, n.length - 1);
    } catch (e) {}
    throw new Error("Failed to repair partial JSON");
}
var V_ = /,\s*$/;
function H_(e, t) {
    var n = eO.exec(t);
    if (n) {
        var r = Ul(n[2]), o = function(e, t) {
            for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.length, o = 0, i = n; i < r; i++)e.charAt(i) === t && o++;
            return o;
        }(e, "\n", 0, r), i = r - e.lastIndexOf("\n", r) - 1;
        return {
            position: r,
            line: o,
            column: i,
            message: t.replace(eO, function() {
                return "line ".concat(o + 1, " column ").concat(i + 1);
            })
        };
    }
    var a = tO.exec(t), s = a ? Ul(a[1]) : null, c = null !== s ? s - 1 : null, l = nO.exec(t), u = l ? Ul(l[1]) : null, f = null !== u ? u - 1 : null, d = null !== c && null !== f ? function(e, t, n) {
        var r = e.indexOf("\n"), o = 1;
        for(; o < t && -1 !== r;)r = e.indexOf("\n", r + 1), o++;
        return -1 !== r ? r + n + 1 : null;
    }(e, c, f) : null;
    return {
        position: d,
        line: c,
        column: f,
        message: t.replace(/^JSON.parse: /, "").replace(/ of the JSON data$/, "")
    };
}
function W_(e) {
    return Gl(e) ? void 0 !== e.json ? void 0 !== e.text ? 'Content must contain either a property "json" or a property "text" but not both' : null : void 0 === e.text ? 'Content must contain either a property "json" or a property "text"' : "string" != typeof e.text ? 'Content "text" property must be a string containing a JSON document. Did you mean to use the "json" property instead?' : null : "Content must be an object";
}
function U_(e) {
    return Gl(e) && (void 0 !== e.json || "string" == typeof e.text);
}
function J_(e) {
    return Gl(e) && "string" == typeof e.text;
}
function K_(e) {
    return Gl(e) && void 0 !== e.json;
}
function G_(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : JSON;
    return J_(e) ? e : {
        text: n.stringify(e.json, null, t)
    };
}
function Q_(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : JSON;
    return K_(e) ? e : {
        json: t.parse(e.text)
    };
}
function Y_(e, t, n) {
    return G_(e, t, n).text;
}
function X_(e, t) {
    return Z_(e, t) > t;
}
function Z_(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1 / 0;
    if (J_(e)) return e.text.length;
    var n = e.json, r = 0;
    return function e(n) {
        if (Array.isArray(n)) {
            if ((r += n.length - 1 + 2) > t) return r;
            for(var o = 0; o < n.length; o++){
                if (e(n[o]), r > t) return r;
            }
        } else if (Gl(n)) {
            var i = Object.keys(n);
            r += 2 + i.length + (i.length - 1);
            for(var a = 0; a < i.length; a++){
                var s = i[a], c = n[s];
                r += s.length + 2, e(c);
            }
        } else r += "string" == typeof n ? n.length + 2 : String(n).length;
    }(n), r;
}
var eO = /(position|char) (\d+)/, tO = /line (\d+)/, nO = /column (\d+)/;
function rO(e, t) {
    return e.parse === t.parse && e.stringify === t.stringify;
}
function oO(e) {
    var t = e.substring(0, 999);
    return !t.includes("\n") && iO.test(t);
}
var iO = /[,:]\S/;
function aO(e) {
    var t = e.escapeControlCharacters, n = e.escapeUnicodeCharacters;
    return t ? n ? sO : cO : n ? lO : uO;
}
var sO = {
    escapeValue: function(e) {
        return fO(pO(String(e)));
    },
    unescapeValue: function(e) {
        return mO(dO(e));
    }
}, cO = {
    escapeValue: function(e) {
        return pO(String(e));
    },
    unescapeValue: function(e) {
        return mO(e);
    }
}, lO = {
    escapeValue: function(e) {
        return fO(String(e));
    },
    unescapeValue: function(e) {
        return dO(e);
    }
}, uO = {
    escapeValue: function(e) {
        return String(e);
    },
    unescapeValue: function(e) {
        return e;
    }
};
function fO(e) {
    return e.replace(/[^\x20-\x7F]/g, function(e) {
        var t;
        return "\b" === e || "\f" === e || "\n" === e || "\r" === e || "	" === e ? e : "\\u" + ("000" + (null === (t = e.codePointAt(0)) || void 0 === t ? void 0 : t.toString(16))).slice(-4);
    });
}
function dO(e) {
    return e.replace(/\\u[a-fA-F0-9]{4}/g, function(e) {
        try {
            var t = JSON.parse('"' + e + '"');
            return hO[t] || t;
        } catch (t) {
            return e;
        }
    });
}
var hO = {
    '"': '\\"',
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t"
}, vO = {
    '\\"': '"',
    "\\\\": "\\",
    "\\/": "/",
    "\\b": "\b",
    "\\f": "\f",
    "\\n": "\n",
    "\\r": "\r",
    "\\t": "	"
};
function pO(e) {
    return e.replace(/["\b\f\n\r\t\\]/g, function(e) {
        return hO[e] || e;
    });
}
function mO(e) {
    return e.replace(/\\["bfnrt\\]/g, function(e) {
        return vO[e] || e;
    });
}
function gO(e) {
    return "string" != typeof e ? String(e) : e.endsWith("\n") ? e + "\n" : e;
}
function yO(e, t) {
    return wO(e, function(e) {
        return e.nodeName.toUpperCase() === t.toUpperCase();
    });
}
function bO(e, t, n) {
    return wO(e, function(e) {
        return function(e, t, n) {
            return "function" == typeof e.getAttribute && e.getAttribute(t) === n;
        }(e, t, n);
    });
}
function wO(e, t) {
    return !!xO(e, t);
}
function xO(e, t) {
    for(var n = e; n && !t(n);)n = n.parentNode;
    return n || void 0;
}
function kO(e) {
    if (null != e.firstChild) {
        var t = document.createRange(), n = window.getSelection();
        t.setStart(e, 1), t.collapse(!0), null == n || n.removeAllRanges(), null == n || n.addRange(t);
    } else e.focus();
}
function jO(e, t, n, r) {
    var o = SO(e);
    if (o) {
        var i = o.document.activeElement ? o.document.activeElement : null;
        i && i.isContentEditable && (i.textContent = n ? t : i.textContent + t, kO(i), r && r(i));
    }
}
function SO(e) {
    return e && e.ownerDocument ? e.ownerDocument.defaultView : null;
}
function CO(e) {
    var t = SO(e), n = null == t ? void 0 : t.document.activeElement;
    return !!n && wO(n, function(t) {
        return t === e;
    });
}
function $O(e, t) {
    return xO(e, function(e) {
        return e.nodeName === t;
    });
}
function _O(e) {
    return bO(e, "data-type", "selectable-key") ? Ya.key : bO(e, "data-type", "selectable-value") ? Ya.value : bO(e, "data-type", "insert-selection-area-inside") ? Ya.inside : bO(e, "data-type", "insert-selection-area-after") ? Ya.after : Ya.multi;
}
function OO(e) {
    return encodeURIComponent(Zs(e));
}
function MO(e) {
    var t = xO(e, function(e) {
        return !(null == e || !e.hasAttribute) && e.hasAttribute("data-path");
    }), n = null == t ? void 0 : t.getAttribute("data-path");
    return n ? Xs(decodeURIComponent(n)) : null;
}
function EO(e) {
    var t = e.allElements, n = e.currentElement, r = e.direction, o = e.hasPrio, i = void 0 === o ? function() {
        return !0;
    } : o, a = e.margin, s = void 0 === a ? 10 : a, c = uw(t.filter(function(e) {
        var t = e.getBoundingClientRect();
        return t.width > 0 && t.height > 0;
    }), u), l = u(n);
    function u(e) {
        var t = e.getBoundingClientRect();
        return {
            x: t.left + t.width / 2,
            y: t.top + t.height / 2,
            rect: t,
            element: e
        };
    }
    function f(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, r = e.x - t.x, o = (e.y - t.y) * n;
        return Math.sqrt(r * r + o * o);
    }
    var d = function(e) {
        return f(e, l);
    };
    if ("Left" === r || "Right" === r) {
        var h = "Left" === r ? c.filter(function(e) {
            var t;
            return t = l, e.rect.left + s < t.rect.left;
        }) : c.filter(function(e) {
            var t;
            return t = l, e.rect.right > t.rect.right + s;
        }), v = Ek(h.filter(function(e) {
            var t, n;
            return t = e, n = l, Math.abs(t.y - n.y) < s;
        }), d) || Ek(h, function(e) {
            return f(e, l, 10);
        });
        return null == v ? void 0 : v.element;
    }
    if ("Up" === r || "Down" === r) {
        var p = "Up" === r ? c.filter(function(e) {
            var t;
            return t = l, e.y + s < t.y;
        }) : c.filter(function(e) {
            var t;
            return t = l, e.y > t.y + s;
        }), m = Ek(p.filter(function(e) {
            return i(e.element);
        }), d) || Ek(p, d);
        return null == m ? void 0 : m.element;
    }
}
function AO(e) {
    return !!e && "DIV" === e.nodeName && "function" == typeof e.refresh && "function" == typeof e.cancel;
}
function PO(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "+", n = [];
    e.ctrlKey && n.push("Ctrl"), e.metaKey && n.push("Ctrl"), e.altKey && n.push("Alt"), e.shiftKey && n.push("Shift");
    var r = 1 === e.key.length ? e.key.toUpperCase() : e.key;
    return r in TO || n.push(r), n.join(t);
}
var TO = {
    Ctrl: !0,
    Command: !0,
    Control: !0,
    Alt: !0,
    Option: !0,
    Shift: !0
}, RO = vi.window;
function NO(e) {
    mi(e, "svelte-1r8q3m8", ".jse-absolute-popup.svelte-1r8q3m8.svelte-1r8q3m8{position:relative;left:0;top:0;width:0;height:0;z-index:1001}.jse-absolute-popup.svelte-1r8q3m8 .jse-hidden-input.svelte-1r8q3m8{position:fixed;left:0;top:0;width:0;height:0;padding:0;margin:0;border:none;outline:none;overflow:hidden}.jse-absolute-popup.svelte-1r8q3m8 .jse-absolute-popup-content.svelte-1r8q3m8{position:absolute}");
}
function IO(e) {
    var t, n, r, o, i, a, s = [
        e[0].props
    ], c = e[0].component;
    function l(e, t) {
        var n = {};
        if (void 0 !== t && 1 & t) n = Ma(s, [
            Ea(e[0].props)
        ]);
        else for(var r = 0; r < s.length; r += 1)n = Jo(n, s[r]);
        return {
            props: n
        };
    }
    return c && (o = Li(c, l(e))), {
        c: function() {
            t = ji("div"), n = ji("input"), r = $i(), o && Pa(o.$$.fragment), Ai(n, "type", "text"), n.readOnly = !0, Ai(n, "tabindex", "-1"), Ai(n, "class", "jse-hidden-input svelte-1r8q3m8"), Ai(t, "class", "jse-absolute-popup-content svelte-1r8q3m8"), Ai(t, "style", i = qO(e[1], e[0].options));
        },
        m: function(i, s) {
            wi(i, t, s), pi(t, n), e[7](n), pi(t, r), o && Ta(o, t, null), a = !0;
        },
        p: function(e, n) {
            if (1 & n && c !== (c = e[0].component)) {
                if (o) {
                    ba();
                    var r = o;
                    ka(r.$$.fragment, 1, 0, function() {
                        Ra(r, 1);
                    }), wa();
                }
                c ? (Pa((o = Li(c, l(e, n))).$$.fragment), xa(o.$$.fragment, 1), Ta(o, t, null)) : o = null;
            } else if (c) {
                var u = 1 & n ? Ma(s, [
                    Ea(e[0].props)
                ]) : {};
                o.$set(u);
            }
            (!a || 3 & n && i !== (i = qO(e[1], e[0].options))) && Ai(t, "style", i);
        },
        i: function(e) {
            a || (o && xa(o.$$.fragment, e), a = !0);
        },
        o: function(e) {
            o && ka(o.$$.fragment, e), a = !1;
        },
        d: function(n) {
            n && xi(t), e[7](null), o && Ra(o);
        }
    };
}
function DO(e) {
    var t, n, r, o, i = e[1] && IO(e);
    return {
        c: function() {
            t = ji("div"), i && i.c(), Ai(t, "role", "none"), Ai(t, "class", "jse-absolute-popup svelte-1r8q3m8");
        },
        m: function(a, s) {
            wi(a, t, s), i && i.m(t, null), e[8](t), n = !0, r || (o = [
                Oi(RO, "mousedown", e[3], !0),
                Oi(RO, "keydown", e[4], !0),
                Oi(RO, "wheel", e[5], !0),
                Oi(t, "mousedown", zO),
                Oi(t, "keydown", e[4])
            ], r = !0);
        },
        p: function(e, n) {
            var r = jo(n, 1)[0];
            e[1] ? i ? (i.p(e, r), 2 & r && xa(i, 1)) : ((i = IO(e)).c(), xa(i, 1), i.m(t, null)) : i && (ba(), ka(i, 1, 1, function() {
                i = null;
            }), wa());
        },
        i: function(e) {
            n || (xa(i), n = !0);
        },
        o: function(e) {
            ka(i), n = !1;
        },
        d: function(n) {
            n && xi(t), i && i.d(), e[8](null), r = !1, Qo(o);
        }
    };
}
function zO(e) {
    e.stopPropagation();
}
function qO(e, t) {
    var n = e.getBoundingClientRect(), r = function() {
        if (t.anchor) {
            var e = t.anchor, n = t.width, r = void 0 === n ? 0 : n, o = t.height, i = void 0 === o ? 0 : o, a = t.offsetTop, s = void 0 === a ? 0 : a, c = t.offsetLeft, l = void 0 === c ? 0 : c, u = t.position, f = e.getBoundingClientRect(), d = f.left, h = f.top, v = f.bottom, p = f.right, m = "top" === u || h + i > window.innerHeight && h > i, g = "left" === u || d + r > window.innerWidth && d > r;
            return {
                left: g ? p - l : d + l,
                top: m ? h - s : v + s,
                positionAbove: m,
                positionLeft: g
            };
        }
        if ("number" == typeof t.left && "number" == typeof t.top) {
            var y = t.left, b = t.top, w = t.width, x = void 0 === w ? 0 : w, k = t.height, j = void 0 === k ? 0 : k;
            return {
                left: y,
                top: b,
                positionAbove: b + j > window.innerHeight && b > j,
                positionLeft: y + x > window.innerWidth && y > x
            };
        }
        throw new Error('Invalid config: pass either "left" and "top", or pass "anchor"');
    }(), o = r.left, i = r.top, a = r.positionAbove, s = r.positionLeft;
    return (a ? "bottom: ".concat(n.top - i, "px;") : "top: ".concat(i - n.top, "px;")) + (s ? "right: ".concat(n.left - o, "px;") : "left: ".concat(o - n.left, "px;"));
}
function BO(e, t, n) {
    var r, o, i = t.popup, a = t.closeAbsolutePopup;
    function s(e) {
        i.options && i.options.closeOnOuterClick && !wO(e.target, function(e) {
            return e === r;
        }) && a(i.id);
    }
    return Gi(function() {
        o && o.focus();
    }), e.$$set = function(e) {
        "popup" in e && n(0, i = e.popup), "closeAbsolutePopup" in e && n(6, a = e.closeAbsolutePopup);
    }, [
        i,
        r,
        o,
        function(e) {
            s(e);
        },
        function(e) {
            "Escape" === PO(e) && a(i.id);
        },
        function(e) {
            s(e);
        },
        a,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(2, o = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(1, r = e);
            });
        }
    ];
}
var LO = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, BO, DO, Xo, {
            popup: 0,
            closeAbsolutePopup: 6
        }, NO), n;
    }
    return Ao(t, Ia), Do(t);
}();
function FO(e, t, n) {
    var r = e.slice();
    return r[6] = t[n], r;
}
function VO(e) {
    var t, n;
    return t = new LO({
        props: {
            popup: e[6],
            closeAbsolutePopup: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.popup = e[6]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function HO(e) {
    for(var t, n, r = Ca(e[0]), o = [], i = 0; i < r.length; i += 1)o[i] = VO(FO(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    }, s = e[3].default, c = ei(s, e, e[2], null);
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = $i(), c && c.c();
        },
        m: function(e, r) {
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(e, r);
            wi(e, t, r), c && c.m(e, r), n = !0;
        },
        p: function(e, i) {
            var l = jo(i, 1)[0];
            if (3 & l) {
                var u;
                for(r = Ca(e[0]), u = 0; u < r.length; u += 1){
                    var f = FO(e, r, u);
                    o[u] ? (o[u].p(f, l), xa(o[u], 1)) : (o[u] = VO(f), o[u].c(), xa(o[u], 1), o[u].m(t.parentNode, t));
                }
                for(ba(), u = r.length; u < o.length; u += 1)a(u);
                wa();
            }
            c && c.p && (!n || 4 & l) && ri(c, s, e, e[2], n ? ni(s, e[2], l, null) : oi(e[2]), null);
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                xa(c, e), n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            ka(c, e), n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e), c && c.d(e);
        }
    };
}
function WO(e, t, n) {
    var r = t.$$slots, o = void 0 === r ? {} : r, i = t.$$scope, a = Da("jsoneditor:AbsolutePopup"), s = [];
    function c(e) {
        var t = s.findIndex(function(t) {
            return t.id === e;
        });
        if (-1 !== t) {
            var r = s[t];
            r.options.onClose && r.options.onClose(), n(0, s = s.filter(function(t) {
                return t.id !== e;
            }));
        }
    }
    return Xi("absolute-popup", {
        openAbsolutePopup: function(e, t, r) {
            a("open...", t, r);
            var o = {
                id: Ps(),
                component: e,
                props: t || {},
                options: r || {}
            };
            return n(0, s = [].concat(Bo(s), [
                o
            ])), o.id;
        },
        closeAbsolutePopup: c
    }), e.$$set = function(e) {
        "$$scope" in e && n(2, i = e.$$scope);
    }, e.$$.update = function() {
        1 & e.$$.dirty && a("popups", s);
    }, [
        s,
        c,
        i,
        o
    ];
}
var UO = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, WO, HO, Zo, {}), n;
    }
    return Ao(t, Ia), Do(t);
}();
function JO(e) {
    return e.map(function(e, t) {
        return ZO.test(e) ? "[" + e + "]" : /[.[\]]/.test(e) || "" === e ? '["' + (e.replace(/"/g, '\\"') + '"]') : (t > 0 ? "." : "") + e;
    }).join("");
}
function KO(e) {
    for(var t = [], n = 0; n < e.length;)"." === e[n] && n++, "[" === e[n] ? (n++, '"' === e[n] ? (n++, t.push(r(function(e) {
        return '"' === e;
    }, !0)), o('"')) : t.push(r(function(e) {
        return "]" === e;
    })), o("]")) : t.push(r(function(e) {
        return "." === e || "[" === e;
    }));
    function r(t) {
        for(var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = ""; n < e.length && !t(e[n]);)r && "\\" === e[n] && '"' === e[n + 1] ? (o += '"', n += 2) : (o += e[n], n++);
        return o;
    }
    function o(t) {
        if (e[n] !== t) throw new SyntaxError("Invalid JSON path: ".concat(t, " expected at position ").concat(n));
        n++;
    }
    return t;
}
function GO(e) {
    return {
        value: e,
        label: _x(e) ? "(item root)" : JO(e)
    };
}
function QO(e) {
    if (ZO.test(e)) return "[" + e + "]";
    if (XO.test(e)) return "." + e;
    var t = JSON.stringify(e);
    return "['" + t.substring(1, t.length - 1).replace(/\\"/g, '"') + "']";
}
function YO(e) {
    return e.map(function(e) {
        return ZO.test(e) ? "?.[".concat(e, "]") : XO.test(e) ? "?.".concat(e) : "?.[".concat(JSON.stringify(e), "]");
    }).join("");
}
var XO = /^[a-zA-Z$_][a-zA-Z$_\d]*$/, ZO = /^\d+$/;
function eM(e, t) {
    for(var n = new Set(t), r = e.replace(/ \(copy( \d+)?\)$/, ""), o = e, i = 1; n.has(o);){
        var a = "copy" + (i > 1 ? " " + i : "");
        o = "".concat(r, " (").concat(a, ")"), i++;
    }
    return o;
}
function tM(e, t) {
    var n = t - 3;
    return e.length > t ? e.substring(0, n) + "..." : e;
}
function nM(e) {
    if ("" === e) return "";
    var t = e.toLowerCase();
    if ("null" === t) return null;
    if ("true" === t) return !0;
    if ("false" === t) return !1;
    if ("undefined" !== t) {
        var n = Number(e), r = parseFloat(e);
        return isNaN(n) || isNaN(r) ? e : n;
    }
}
var rM = {
    id: "javascript",
    name: "JavaScript",
    description: "\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n</p>\n",
    createQuery: function(e, t) {
        var n = t.filter, r = t.sort, o = t.projection, i = [
            "  return data\n"
        ];
        if (n && n.path && n.relation && n.value) {
            var a = "item => item".concat(YO(n.path)), s = nM(n.value), c = "string" == typeof s ? "'".concat(n.value, "'") : ou(n.value) && !Number.isSafeInteger(s) ? "".concat(n.value, "n") : n.value;
            i.push("    .filter(".concat(a, " ").concat(n.relation, " ").concat(c, ")\n"));
        }
        r && r.path && r.direction && ("desc" === r.direction ? i.push("    .slice()\n    .sort((a, b) => {\n      // sort descending\n" + "      const valueA = a".concat(YO(r.path), "\n") + "      const valueB = b".concat(YO(r.path), "\n") + "      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0\n    })\n") : i.push("    .slice()\n    .sort((a, b) => {\n      // sort ascending\n" + "      const valueA = a".concat(YO(r.path), "\n") + "      const valueB = b".concat(YO(r.path), "\n") + "      return valueA > valueB ? 1 : valueA < valueB ? -1 : 0\n    })\n"));
        if (o && o.paths) {
            if (o.paths.length > 1) {
                var l = o.paths.map(function(e) {
                    var t = e[e.length - 1] || "item", n = "item".concat(YO(e));
                    return "      ".concat(JSON.stringify(t), ": ").concat(n);
                });
                i.push("    .map(item => ({\n".concat(l.join(",\n"), "})\n    )\n"));
            } else {
                var u = "item".concat(YO(o.paths[0]));
                i.push("    .map(item => ".concat(u, ")\n"));
            }
        }
        return "function query (data) {\n".concat(i.join(""), "}");
    },
    executeQuery: function(e, t) {
        var n = new Function('"use strict";\n\n' + t + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')()(e);
        return void 0 !== n ? n : null;
    }
};
var oM = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"
    ]
}, iM = {
    prefix: "far",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
}, aM = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
}, sM = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
function cM(e) {
    var t;
    return {
        c: function() {
            t = Si("g");
        },
        m: function(n, r) {
            wi(n, t, r), t.innerHTML = e[0];
        },
        p: function(e, n) {
            1 & jo(n, 1)[0] && (t.innerHTML = e[0]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function lM(e, t, n) {
    var r = 870711;
    var o = "", i = t.data;
    function a(e) {
        if (!e || !e.raw) return "";
        var t = e.raw, n = {};
        return t = t.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function(e, t) {
            var o = "fa-".concat((r += 1).toString(16));
            return n[t] = o, ' id="'.concat(o, '"');
        }), t = t.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function(e, t, r, o) {
            var i = t || o;
            return i && n[i] ? "#".concat(n[i]) : e;
        }), t;
    }
    return e.$$set = function(e) {
        "data" in e && n(1, i = e.data);
    }, e.$$.update = function() {
        2 & e.$$.dirty && n(0, o = a(i));
    }, [
        o,
        i
    ];
}
var uM = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, lM, cM, Xo, {
            data: 1
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function fM(e) {
    mi(e, "svelte-1mc5hvj", ".fa-icon.svelte-1mc5hvj{display:inline-block;fill:currentColor}.fa-flip-horizontal.svelte-1mc5hvj{transform:scale(-1, 1)}.fa-flip-vertical.svelte-1mc5hvj{transform:scale(1, -1)}.fa-spin.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s 0s infinite linear}.fa-inverse.svelte-1mc5hvj{color:#fff}.fa-pulse.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s infinite steps(8)}@keyframes svelte-1mc5hvj-fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
function dM(e) {
    for(var t, n, r, o, i = e[12].default, a = ei(i, e, e[11], null), s = [
        {
            version: "1.1"
        },
        {
            class: n = "fa-icon " + e[0]
        },
        {
            width: e[1]
        },
        {
            height: e[2]
        },
        {
            "aria-label": e[9]
        },
        {
            role: r = e[9] ? "img" : "presentation"
        },
        {
            viewBox: e[3]
        },
        {
            style: e[8]
        },
        e[10]
    ], c = {}, l = 0; l < s.length; l += 1)c = Jo(c, s[l]);
    return {
        c: function() {
            t = Si("svg"), a && a.c(), Ri(t, c), qi(t, "fa-spin", e[4]), qi(t, "fa-pulse", e[6]), qi(t, "fa-inverse", e[5]), qi(t, "fa-flip-horizontal", "horizontal" === e[7]), qi(t, "fa-flip-vertical", "vertical" === e[7]), qi(t, "svelte-1mc5hvj", !0);
        },
        m: function(e, n) {
            wi(e, t, n), a && a.m(t, null), o = !0;
        },
        p: function(e, l) {
            var u = jo(l, 1)[0];
            a && a.p && (!o || 2048 & u) && ri(a, i, e, e[11], o ? ni(i, e[11], u, null) : oi(e[11]), null), Ri(t, c = Ma(s, [
                {
                    version: "1.1"
                },
                (!o || 1 & u && n !== (n = "fa-icon " + e[0])) && {
                    class: n
                },
                (!o || 2 & u) && {
                    width: e[1]
                },
                (!o || 4 & u) && {
                    height: e[2]
                },
                (!o || 512 & u) && {
                    "aria-label": e[9]
                },
                (!o || 512 & u && r !== (r = e[9] ? "img" : "presentation")) && {
                    role: r
                },
                (!o || 8 & u) && {
                    viewBox: e[3]
                },
                (!o || 256 & u) && {
                    style: e[8]
                },
                1024 & u && e[10]
            ])), qi(t, "fa-spin", e[4]), qi(t, "fa-pulse", e[6]), qi(t, "fa-inverse", e[5]), qi(t, "fa-flip-horizontal", "horizontal" === e[7]), qi(t, "fa-flip-vertical", "vertical" === e[7]), qi(t, "svelte-1mc5hvj", !0);
        },
        i: function(e) {
            o || (xa(a, e), o = !0);
        },
        o: function(e) {
            ka(a, e), o = !1;
        },
        d: function(e) {
            e && xi(t), a && a.d(e);
        }
    };
}
function hM(e, t, n) {
    var r = [
        "class",
        "width",
        "height",
        "box",
        "spin",
        "inverse",
        "pulse",
        "flip",
        "style",
        "label"
    ], o = ai(t, r), i = t, a = i.$$slots, s = void 0 === a ? {} : a, c = i.$$scope, l = t.class, u = void 0 === l ? "" : l, f = t.width, d = t.height, h = t.box, v = void 0 === h ? "0 0 0 0" : h, p = t.spin, m = void 0 !== p && p, g = t.inverse, y = void 0 !== g && g, b = t.pulse, w = void 0 !== b && b, x = t.flip, k = void 0 === x ? "none" : x, j = t.style, S = void 0 === j ? "" : j, C = t.label, $ = void 0 === C ? "" : C;
    return e.$$set = function(e) {
        t = Jo(Jo({}, t), ii(e)), n(10, o = ai(t, r)), "class" in e && n(0, u = e.class), "width" in e && n(1, f = e.width), "height" in e && n(2, d = e.height), "box" in e && n(3, v = e.box), "spin" in e && n(4, m = e.spin), "inverse" in e && n(5, y = e.inverse), "pulse" in e && n(6, w = e.pulse), "flip" in e && n(7, k = e.flip), "style" in e && n(8, S = e.style), "label" in e && n(9, $ = e.label), "$$scope" in e && n(11, c = e.$$scope);
    }, [
        u,
        f,
        d,
        v,
        m,
        y,
        w,
        k,
        S,
        $,
        o,
        c,
        s
    ];
}
var vM = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, hM, dM, Xo, {
            class: 0,
            width: 1,
            height: 2,
            box: 3,
            spin: 4,
            inverse: 5,
            pulse: 6,
            flip: 7,
            style: 8,
            label: 9
        }, fM), n;
    }
    return Ao(t, Ia), Do(t);
}();
function pM(e, t, n) {
    var r = e.slice();
    return r[24] = t[n], r;
}
function mM(e, t, n) {
    var r = e.slice();
    return r[27] = t[n], r;
}
function gM(e) {
    for(var t, n = [
        e[27]
    ], r = {}, o = 0; o < n.length; o += 1)r = Jo(r, n[o]);
    return {
        c: function() {
            Ri(t = Si("path"), r);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, o) {
            Ri(t, r = Ma(n, [
                64 & o && e[27]
            ]));
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function yM(e) {
    for(var t, n = [
        e[24]
    ], r = {}, o = 0; o < n.length; o += 1)r = Jo(r, n[o]);
    return {
        c: function() {
            Ri(t = Si("polygon"), r);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, o) {
            Ri(t, r = Ma(n, [
                64 & o && e[24]
            ]));
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function bM(e) {
    var t, n, r;
    function o(t) {
        e[16](t);
    }
    var i = {};
    return void 0 !== e[6] && (i.data = e[6]), t = new uM({
        props: i
    }), na.push(function() {
        return Aa(t, "data", o);
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, n) {
            Ta(t, e, n), r = !0;
        },
        p: function(e, r) {
            var o = {};
            !n && 64 & r && (n = !0, o.data = e[6], ua(function() {
                return n = !1;
            })), t.$set(o);
        },
        i: function(e) {
            r || (xa(t.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), r = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function wM(e) {
    var t, n = e[15].default, r = ei(n, e, e[17], null), o = r || function(e) {
        for(var t, n, r, o, i, a, s, c = Ca((null === (t = e[6]) || void 0 === t ? void 0 : t.paths) || []), l = [], u = 0; u < c.length; u += 1)l[u] = gM(mM(e, c, u));
        for(var f = Ca((null === (n = e[6]) || void 0 === n ? void 0 : n.polygons) || []), d = [], h = 0; h < f.length; h += 1)d[h] = yM(pM(e, f, h));
        var v = (null === (r = e[6]) || void 0 === r ? void 0 : r.raw) && bM(e);
        return {
            c: function() {
                for(var e = 0; e < l.length; e += 1)l[e].c();
                o = $i();
                for(var t = 0; t < d.length; t += 1)d[t].c();
                i = $i(), v && v.c(), a = _i();
            },
            m: function(e, t) {
                for(var n = 0; n < l.length; n += 1)l[n] && l[n].m(e, t);
                wi(e, o, t);
                for(var r = 0; r < d.length; r += 1)d[r] && d[r].m(e, t);
                wi(e, i, t), v && v.m(e, t), wi(e, a, t), s = !0;
            },
            p: function(e, t) {
                var n;
                if (64 & t) {
                    var r, s;
                    for(c = Ca((null === (r = e[6]) || void 0 === r ? void 0 : r.paths) || []), s = 0; s < c.length; s += 1){
                        var u = mM(e, c, s);
                        l[s] ? l[s].p(u, t) : (l[s] = gM(u), l[s].c(), l[s].m(o.parentNode, o));
                    }
                    for(; s < l.length; s += 1)l[s].d(1);
                    l.length = c.length;
                }
                if (64 & t) {
                    var h, p;
                    for(f = Ca((null === (h = e[6]) || void 0 === h ? void 0 : h.polygons) || []), p = 0; p < f.length; p += 1){
                        var m = pM(e, f, p);
                        d[p] ? d[p].p(m, t) : (d[p] = yM(m), d[p].c(), d[p].m(i.parentNode, i));
                    }
                    for(; p < d.length; p += 1)d[p].d(1);
                    d.length = f.length;
                }
                null !== (n = e[6]) && void 0 !== n && n.raw ? v ? (v.p(e, t), 64 & t && xa(v, 1)) : ((v = bM(e)).c(), xa(v, 1), v.m(a.parentNode, a)) : v && (ba(), ka(v, 1, 1, function() {
                    v = null;
                }), wa());
            },
            i: function(e) {
                s || (xa(v), s = !0);
            },
            o: function(e) {
                ka(v), s = !1;
            },
            d: function(e) {
                e && (xi(o), xi(i), xi(a)), ki(l, e), ki(d, e), v && v.d(e);
            }
        };
    }(e);
    return {
        c: function() {
            o && o.c();
        },
        m: function(e, n) {
            o && o.m(e, n), t = !0;
        },
        p: function(e, i) {
            r ? r.p && (!t || 131072 & i) && ri(r, n, e, e[17], t ? ni(n, e[17], i, null) : oi(e[17]), null) : o && o.p && (!t || 64 & i) && o.p(e, t ? i : -1);
        },
        i: function(e) {
            t || (xa(o, e), t = !0);
        },
        o: function(e) {
            ka(o, e), t = !1;
        },
        d: function(e) {
            o && o.d(e);
        }
    };
}
function xM(e) {
    for(var t, n, r = [
        {
            label: e[5]
        },
        {
            width: e[7]
        },
        {
            height: e[8]
        },
        {
            box: e[10]
        },
        {
            style: e[9]
        },
        {
            spin: e[1]
        },
        {
            flip: e[4]
        },
        {
            inverse: e[2]
        },
        {
            pulse: e[3]
        },
        {
            class: e[0]
        },
        e[11]
    ], o = {
        $$slots: {
            default: [
                wM
            ]
        },
        $$scope: {
            ctx: e
        }
    }, i = 0; i < r.length; i += 1)o = Jo(o, r[i]);
    return t = new vM({
        props: o
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var o = jo(n, 1)[0], i = 4031 & o ? Ma(r, [
                32 & o && {
                    label: e[5]
                },
                128 & o && {
                    width: e[7]
                },
                256 & o && {
                    height: e[8]
                },
                1024 & o && {
                    box: e[10]
                },
                512 & o && {
                    style: e[9]
                },
                2 & o && {
                    spin: e[1]
                },
                16 & o && {
                    flip: e[4]
                },
                4 & o && {
                    inverse: e[2]
                },
                8 & o && {
                    pulse: e[3]
                },
                1 & o && {
                    class: e[0]
                },
                2048 & o && Ea(e[11])
            ]) : {};
            131136 & o && (i.$$scope = {
                dirty: o,
                ctx: e
            }), t.$set(i);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function kM(e, t, n) {
    var r, o, i, a = [
        "class",
        "data",
        "scale",
        "spin",
        "inverse",
        "pulse",
        "flip",
        "label",
        "style"
    ], s = ai(t, a), c = t, l = c.$$slots, u = void 0 === l ? {} : l, f = c.$$scope, d = t.class, h = void 0 === d ? "" : d, v = t.data, p = t.scale, m = void 0 === p ? 1 : p, g = t.spin, y = void 0 !== g && g, b = t.inverse, w = void 0 !== b && b, x = t.pulse, k = void 0 !== x && x, j = t.flip, S = void 0 === j ? void 0 : j, C = t.label, $ = void 0 === C ? "" : C, _ = t.style, O = void 0 === _ ? "" : _, M = 10, E = 10;
    function A() {
        var e = 1;
        return void 0 !== m && (e = Number(m)), isNaN(e) || e <= 0 ? (console.warn('Invalid prop: prop "scale" should be a number over 0.'), 1) : 1 * e;
    }
    function P() {
        return r ? Math.max(r.width, r.height) / 16 : 1;
    }
    return e.$$set = function(e) {
        t = Jo(Jo({}, t), ii(e)), n(11, s = ai(t, a)), "class" in e && n(0, h = e.class), "data" in e && n(12, v = e.data), "scale" in e && n(13, m = e.scale), "spin" in e && n(1, y = e.spin), "inverse" in e && n(2, w = e.inverse), "pulse" in e && n(3, k = e.pulse), "flip" in e && n(4, S = e.flip), "label" in e && n(5, $ = e.label), "style" in e && n(14, O = e.style), "$$scope" in e && n(17, f = e.$$scope);
    }, e.$$.update = function() {
        28672 & e.$$.dirty && (n(6, r = function(e) {
            var t;
            if (e) {
                if (!("definition" in e)) {
                    if ("iconName" in e && "icon" in e) {
                        e.iconName;
                        var n = jo(e.icon, 5), r = n[0], o = n[1], i = n[4];
                        t = {
                            width: r,
                            height: o,
                            paths: (Array.isArray(i) ? i : [
                                i
                            ]).map(function(e) {
                                return {
                                    d: e
                                };
                            })
                        };
                    } else t = e[Object.keys(e)[0]];
                    return t;
                }
                console.error("`import faIconName from '@fortawesome/package-name/faIconName` not supported - Please use `import { faIconName } from '@fortawesome/package-name/faIconName'` instead");
            }
        }(v)), n(7, M = r ? r.width / P() * A() : 0), n(8, E = r ? r.height / P() * A() : 0), n(9, o = function() {
            var e = "";
            null !== O && (e += O);
            var t = A();
            return 1 === t ? 0 === e.length ? "" : e : ("" === e || e.endsWith(";") || (e += "; "), "".concat(e, "font-size: ").concat(t, "em"));
        }()), n(10, i = r ? "0 0 ".concat(r.width, " ").concat(r.height) : "0 0 ".concat(M, " ").concat(E)));
    }, [
        h,
        y,
        w,
        k,
        S,
        $,
        r,
        M,
        E,
        o,
        i,
        s,
        v,
        m,
        O,
        u,
        function(e) {
            n(6, r = e), n(12, v), n(14, O), n(13, m);
        },
        f
    ];
}
var jM = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, kM, xM, Xo, {
            class: 0,
            data: 12,
            scale: 13,
            spin: 1,
            inverse: 2,
            pulse: 3,
            flip: 4,
            label: 5,
            style: 14
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function SM(e) {
    mi(e, "svelte-68vtq4", ".jse-boolean-toggle.svelte-68vtq4{padding:0;margin:1px 0 0;vertical-align:top;display:inline-flex;color:var(--jse-value-color-boolean, #ff8c00)}.jse-boolean-toggle.svelte-68vtq4:not(.jse-readonly){cursor:pointer}");
}
function CM(e) {
    var t, n, r, o, i, a, s;
    return n = new jM({
        props: {
            data: !0 === e[0] ? iM : aM
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "role", "checkbox"), Ai(t, "tabindex", "-1"), Ai(t, "aria-checked", r = !0 === e[0]), Ai(t, "class", "jse-boolean-toggle svelte-68vtq4"), Ai(t, "title", o = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value"), qi(t, "jse-readonly", e[1]);
        },
        m: function(r, o) {
            wi(r, t, o), Ta(n, t, null), i = !0, a || (s = Oi(t, "mousedown", e[2]), a = !0);
        },
        p: function(e, a) {
            var s = jo(a, 1)[0], c = {};
            1 & s && (c.data = !0 === e[0] ? iM : aM), n.$set(c), (!i || 1 & s && r !== (r = !0 === e[0])) && Ai(t, "aria-checked", r), (!i || 3 & s && o !== (o = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value")) && Ai(t, "title", o), (!i || 2 & s) && qi(t, "jse-readonly", e[1]);
        },
        i: function(e) {
            i || (xa(n.$$.fragment, e), i = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), i = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), a = !1, s();
        }
    };
}
function $M(e, t, n) {
    var r = t.path, o = t.value, i = t.readOnly, a = t.onPatch, s = t.focus;
    return e.$$set = function(e) {
        "path" in e && n(3, r = e.path), "value" in e && n(0, o = e.value), "readOnly" in e && n(1, i = e.readOnly), "onPatch" in e && n(4, a = e.onPatch), "focus" in e && n(5, s = e.focus);
    }, [
        o,
        i,
        function(e) {
            e.stopPropagation(), i || (a([
                {
                    op: "replace",
                    path: Zs(r),
                    value: !o
                }
            ]), s());
        },
        r,
        a,
        s
    ];
}
var _M = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, $M, CM, Zo, {
            path: 3,
            value: 0,
            readOnly: 1,
            onPatch: 4,
            focus: 5
        }, SM), n;
    }
    return Ao(t, Ia), Do(t);
}();
function OM(e) {
    mi(e, "svelte-1f4ayrt", ".jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::before,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::after{background:var(--jse-color-picker-background, var(--jse-panel-background, #ebebeb));line-height:normal}.jse-color-picker-popup.svelte-1f4ayrt .picker_slider,.jse-color-picker-popup.svelte-1f4ayrt .picker_sl,.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input,.jse-color-picker-popup.svelte-1f4ayrt .picker_sample,.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{box-shadow:var(--jse-color-picker-border-box-shadow, #cbcbcb 0 0 0 1px)}.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input{background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{background:var(--jse-button-background, #e0e0e0);color:var(--jse-button-color, var(--jse-text-color, #4d4d4d))}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button:hover{background:var(--jse-button-background-highlight, #e7e7e7)}");
}
function MM(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-color-picker-popup svelte-1f4ayrt");
        },
        m: function(n, r) {
            wi(n, t, r), e[4](t);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(n) {
            n && xi(t), e[4](null);
        }
    };
}
function EM(e, t, n) {
    var r, o = t.color, i = t.onChange, a = t.showOnTop, s = function() {};
    return Gi(ko(wo().mark(function e() {
        var t, n, c;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return e.next = 2, Promise.resolve().then(function() {
                        return hte;
                    });
                case 2:
                    if (e.t1 = t = e.sent, e.t0 = null === e.t1, e.t0) {
                        e.next = 6;
                        break;
                    }
                    e.t0 = void 0 === t;
                case 6:
                    if (!e.t0) {
                        e.next = 10;
                        break;
                    }
                    e.t2 = void 0, e.next = 11;
                    break;
                case 10:
                    e.t2 = t.default;
                case 11:
                    n = e.t2, c = new n({
                        parent: r,
                        color: o,
                        popup: a ? "top" : "bottom",
                        onDone: function(e) {
                            var t = 1 === e.rgba[3] ? e.hex.substring(0, 7) : e.hex;
                            i(t);
                        }
                    }), c.show(), s = function() {
                        c.destroy();
                    };
                case 15:
                case "end":
                    return e.stop();
            }
        }, e);
    }))), Qi(function() {
        s();
    }), e.$$set = function(e) {
        "color" in e && n(1, o = e.color), "onChange" in e && n(2, i = e.onChange), "showOnTop" in e && n(3, a = e.showOnTop);
    }, [
        r,
        o,
        i,
        a,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(0, r = e);
            });
        }
    ];
}
var AM = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, EM, MM, Xo, {
            color: 1,
            onChange: 2,
            showOnTop: 3
        }, OM), n;
    }
    return Ao(t, Ia), Do(t);
}();
function PM(e) {
    mi(e, "svelte-1zzxwe", ".jse-color-picker-button.svelte-1zzxwe{font-size:var(--jse-font-size-mono, 14px);width:var(--jse-color-picker-button-size, 1em);height:var(--jse-color-picker-button-size, 1em);box-sizing:border-box;padding:0;margin:2px 0 0;display:inline-flex;vertical-align:top;border:1px solid var(--jse-text-color, #4d4d4d);border-radius:2px;background:inherit;outline:none}.jse-color-picker-button.svelte-1zzxwe:not(.jse-readonly){cursor:pointer}");
}
function TM(e) {
    var t, n, r, o;
    return {
        c: function() {
            Ai(t = ji("button"), "type", "button"), Ai(t, "class", "jse-color-picker-button svelte-1zzxwe"), Di(t, "background", e[2]), Ai(t, "title", n = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker"), qi(t, "jse-readonly", e[1]);
        },
        m: function(n, i) {
            wi(n, t, i), r || (o = Oi(t, "click", e[3]), r = !0);
        },
        p: function(e, r) {
            var o = jo(r, 1)[0];
            4 & o && Di(t, "background", e[2]), 3 & o && n !== (n = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker") && Ai(t, "title", n), 2 & o && qi(t, "jse-readonly", e[1]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), r = !1, o();
        }
    };
}
function RM(e, t, n) {
    var r, o = Zi("absolute-popup").openAbsolutePopup, i = t.path, a = t.value, s = t.readOnly, c = t.onPatch, l = t.focus;
    function u(e) {
        c([
            {
                op: "replace",
                path: Zs(i),
                value: e
            }
        ]), f();
    }
    function f() {
        l();
    }
    return e.$$set = function(e) {
        "path" in e && n(4, i = e.path), "value" in e && n(0, a = e.value), "readOnly" in e && n(1, s = e.readOnly), "onPatch" in e && n(5, c = e.onPatch), "focus" in e && n(6, l = e.focus);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(2, r = Xl(a));
    }, [
        a,
        s,
        r,
        function(e) {
            var t, n;
            if (!s) {
                var r = e.target, i = r.getBoundingClientRect().top, c = null !== (t = null === (n = SO(r)) || void 0 === n ? void 0 : n.innerHeight) && void 0 !== t ? t : 0;
                o(AM, {
                    color: a,
                    onChange: u,
                    showOnTop: c - i < 300 && i > 300
                }, {
                    anchor: r,
                    closeOnOuterClick: !0,
                    onClose: f,
                    offsetTop: 18,
                    offsetLeft: -8,
                    height: 300
                });
            }
        },
        i,
        c,
        l
    ];
}
var NM = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, RM, TM, Zo, {
            path: 4,
            value: 0,
            readOnly: 1,
            onPatch: 5,
            focus: 6
        }, PM), n;
    }
    return Ao(t, Ia), Do(t);
}();
function IM(e) {
    for(var t = GS(e, function(e) {
        return e.start;
    }), n = [
        t[0]
    ], r = 0; r < t.length; r++){
        var o = n.length - 1, i = n[o], a = t[r];
        a.start <= i.end ? n[o] = {
            start: Math.min(i.start, a.start),
            end: Math.max(i.end, a.end)
        } : n.push(a);
    }
    return n;
}
function DM(e, t) {
    return e.some(function(e) {
        return t >= e.start && t < e.end;
    });
}
function zM(e) {
    return qM(e) + ls;
}
function qM(e) {
    return Math.floor(e / ls) * ls;
}
function BM(e) {
    var t = {
        expandedMap: {},
        enforceStringMap: {},
        visibleSectionsMap: {},
        selection: null,
        sortedColumn: null
    };
    return null != e && e.select && void 0 !== e.json && (t = Ro(Ro({}, t), {}, {
        selection: e.select(e.json, t)
    })), null != e && e.expand && (t = HM(e.json, t, [], e.expand)), t;
}
function LM(e, t) {
    return e.visibleSectionsMap[t] || ds;
}
function FM(e, t, n) {
    t.forEach(function(t) {
        var r = t.start, o = t.end;
        R_(r, Math.min(e.length, o), n);
    });
}
function VM(e, t, n) {
    for(var r = Ro({}, t.expandedMap), o = Ro({}, t.visibleSectionsMap), i = 0; i < n.length; i++){
        var a = n.slice(0, i), s = Zs(a), c = Ws(e, a);
        if (Ql(c) && (r[s] = !0), Array.isArray(c) && i < n.length) {
            var l = o[s] || ds, u = Ul(n[i]);
            if (!DM(l, u)) {
                var f = qM(u), d = {
                    start: f,
                    end: zM(f)
                };
                o[s] = IM(l.concat(d));
            }
        }
    }
    return Ro(Ro({}, t), {}, {
        expandedMap: r,
        visibleSectionsMap: o
    });
}
function HM(e, t, n, r) {
    var o = Ro({}, t.expandedMap);
    var i = n.slice(), a = void 0 !== e ? Ws(e, n) : e;
    return void 0 !== a && function e(n) {
        var a = i.length;
        if (Array.isArray(n)) {
            if (r(i)) {
                var s = Zs(i);
                if (o[s] = !0, n.length > 0) {
                    var c = LM(t, s);
                    FM(n, c, function(t) {
                        i[a] = String(t), e(n[t]);
                    }), i.pop();
                }
            }
        } else if (Gl(n) && r(i)) {
            o[Zs(i)] = !0;
            var l = Object.keys(n);
            if (l.length > 0) {
                var u, f = bo(l);
                try {
                    for(f.s(); !(u = f.n()).done;){
                        var d = u.value;
                        i[a] = d, e(n[d]);
                    }
                } catch (e) {
                    f.e(e);
                } finally{
                    f.f();
                }
                i.pop();
            }
        }
    }(a), Ro(Ro({}, t), {}, {
        expandedMap: o
    });
}
function WM(e, t) {
    var n = QM(e.expandedMap, t), r = QM(e.enforceStringMap, t), o = QM(e.visibleSectionsMap, t);
    return Ro(Ro({}, e), {}, {
        expandedMap: n,
        enforceStringMap: r,
        visibleSectionsMap: o
    });
}
function UM(e, t, n) {
    if (n) {
        var r = Ro({}, e.enforceStringMap);
        return r[t] = n, Ro(Ro({}, e), {}, {
            enforceStringMap: r
        });
    }
    if ("boolean" == typeof e.enforceStringMap[t]) {
        var o = Ro({}, e.enforceStringMap);
        return delete o[t], Ro(Ro({}, e), {}, {
            enforceStringMap: o
        });
    }
    return e;
}
function JM(e, t, n) {
    var r = rc(e, n), o = n.reduce(function(e, t) {
        return Ns(t) ? KM(r, e, t) : Is(t) ? GM(r, e, t) : Ds(t) ? function(e, t, n) {
            var r = n.path, o = tE(e, t.expandedMap), i = tE(e, t.enforceStringMap), a = tE(e, t.visibleSectionsMap);
            Rs(n.value) || Ts(n.value) || delete o[r];
            Ts(n.value) || delete a[r];
            (Rs(n.value) || Ts(n.value)) && delete i[r];
            return Ro(Ro({}, t), {}, {
                expandedMap: o,
                enforceStringMap: i,
                visibleSectionsMap: a
            });
        }(r, e, t) : zs(t) || qs(t) ? function(e, t, n) {
            if (qs(n) && n.from === n.path) return t;
            var r = function(e) {
                return n.path + e.substring(n.from.length);
            }, o = ZM(YM(t.expandedMap, n.from), r), i = ZM(YM(t.enforceStringMap, n.from), r), a = ZM(YM(t.visibleSectionsMap, n.from), r), s = t;
            qs(n) && (s = GM(e, s, {
                op: "remove",
                path: n.from
            }));
            s = KM(e, s, {
                op: "add",
                path: n.path,
                value: null
            });
            var c = XM(s.expandedMap, o), l = XM(s.enforceStringMap, i), u = XM(s.visibleSectionsMap, a);
            return Ro(Ro({}, t), {}, {
                expandedMap: c,
                enforceStringMap: l,
                visibleSectionsMap: u
            });
        }(r, e, t) : e;
    }, t);
    return {
        json: r,
        documentState: o
    };
}
function KM(e, t, n) {
    var r = dc(e, n.path), o = Qw(r), i = Zs(o);
    if (Ts(Ws(e, o))) {
        var a = Ul(vb(r)), s = eE(t.expandedMap, o, a, 1), c = eE(t.enforceStringMap, o, a, 1), l = eE(t.visibleSectionsMap, o, a, 1);
        return l = nE(l, i, function(e) {
            return rE(e, a, 1);
        }), Ro(Ro({}, t), {}, {
            expandedMap: s,
            enforceStringMap: c,
            visibleSectionsMap: l
        });
    }
    return t;
}
function GM(e, t, n) {
    var r = dc(e, n.path), o = Qw(r), i = Zs(o), a = Ws(e, o), s = t.expandedMap, c = t.enforceStringMap, l = t.visibleSectionsMap;
    if (s = QM(s, r), c = QM(c, r), l = QM(l, r), Ts(a)) {
        var u = Ul(vb(r));
        s = eE(s, o, u, -1), c = eE(c, o, u, -1), l = nE(l = eE(l, o, u, -1), i, function(e) {
            return rE(e, u, -1);
        });
    }
    return Ro(Ro({}, t), {}, {
        expandedMap: s,
        enforceStringMap: c,
        visibleSectionsMap: l
    });
}
function QM(e, t) {
    var n = {}, r = Zs(t);
    return Object.keys(e).forEach(function(t) {
        nc(t, r) || (n[t] = e[t]);
    }), n;
}
function YM(e, t) {
    var n = {};
    return Object.keys(e).forEach(function(r) {
        nc(r, t) && (n[r] = e[r]);
    }), n;
}
function XM(e, t) {
    return Ro(Ro({}, e), t);
}
function ZM(e, t) {
    var n = {};
    return Object.keys(e).forEach(function(r) {
        var o = t(r);
        n[o] = e[r];
    }), n;
}
function eE(e, t, n, r) {
    for(var o = t.length, i = Zs(t), a = [], s = 0, c = Object.keys(e); s < c.length; s++){
        var l = c[s];
        if (nc(l, i)) {
            var u = Xs(l), f = Ul(u[o]);
            f >= n && (u[o] = String(f + r), a.push({
                oldPointer: l,
                newPointer: Zs(u),
                value: e[l]
            }));
        }
    }
    if (0 === a.length) return e;
    var d = Ro({}, e);
    return a.forEach(function(e) {
        delete d[e.oldPointer];
    }), a.forEach(function(e) {
        d[e.newPointer] = e.value;
    }), d;
}
function tE(e, t) {
    var n = {};
    return Object.keys(t).filter(function(t) {
        return Ys(e, dc(e, t));
    }).forEach(function(e) {
        n[e] = t[e];
    }), n;
}
function nE(e, t, n) {
    var r = e[t];
    if (t in e) {
        var o = n(r);
        if (!Ox(r, o)) {
            var i = Ro({}, e);
            return void 0 === o ? delete i[t] : i[t] = o, i;
        }
    }
    return e;
}
function rE(e, t, n) {
    return function(e) {
        var t = e.slice(0), n = 1;
        for(; n < t.length;)t[n - 1].end === t[n].start && (t[n - 1] = {
            start: t[n - 1].start,
            end: t[n].end
        }, t.splice(n)), n++;
        return t;
    }(e.map(function(e) {
        return {
            start: e.start > t ? e.start + n : e.start,
            end: e.end > t ? e.end + n : e.end
        };
    }));
}
function oE(e, t, n, r) {
    var o = t ? t[n] : void 0;
    return "boolean" == typeof o ? o : function(e, t) {
        return "string" == typeof e && "string" != typeof ru(e, t);
    }(e, r);
}
function iE(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = e.indexOf(t);
    return -1 !== r ? n ? e.slice(r) : e.slice(r + 1) : [];
}
function aE(e, t) {
    var n = [];
    return function e(r, o) {
        n.push(o);
        var i = Zs(o);
        if (r && !0 === t.expandedMap[i]) {
            if (Ts(r)) {
                var a = LM(t, i);
                FM(r, a, function(t) {
                    e(r[t], o.concat(String(t)));
                });
            }
            Rs(r) && Object.keys(r).forEach(function(t) {
                e(r[t], o.concat(t));
            });
        }
    }(e, []), n;
}
function sE(e, t) {
    var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = [];
    return function e(o, i) {
        r.push({
            path: i,
            type: Xa.value
        });
        var a = Zs(i);
        if (o && !0 === t.expandedMap[a]) {
            if (n && r.push({
                path: i,
                type: Xa.inside
            }), Ts(o)) {
                var s = LM(t, a);
                FM(o, s, function(t) {
                    var a = i.concat(String(t));
                    e(o[t], a), n && r.push({
                        path: a,
                        type: Xa.after
                    });
                });
            }
            if (Rs(o)) Object.keys(o).forEach(function(t) {
                var a = i.concat(t);
                r.push({
                    path: a,
                    type: Xa.key
                }), e(o[t], a), n && r.push({
                    path: a,
                    type: Xa.after
                });
            });
        }
    }(e, []), r;
}
function cE(e, t, n) {
    var r = aE(e, t), o = r.map(Zs).indexOf(Zs(n));
    return -1 !== o && o < r.length - 1 ? r[o + 1] : null;
}
function lE(e, t, n) {
    var r = Ws(e, n);
    return void 0 === r ? t : HM(e, t, n, !X_({
        json: r
    }, ms) ? fE : uE);
}
function uE(e) {
    return 0 === e.length || 1 === e.length && "0" === e[0];
}
function fE() {
    return !0;
}
function dE(e) {
    return e && e.type === Ya.after || !1;
}
function hE(e) {
    return e && e.type === Ya.inside || !1;
}
function vE(e) {
    return e && e.type === Ya.key || !1;
}
function pE(e) {
    return e && e.type === Ya.value || !1;
}
function mE(e) {
    return e && e.type === Ya.multi || !1;
}
function gE(e) {
    return mE(e) && Ox(e.focusPath, e.anchorPath);
}
function yE(e) {
    return mE(e) || dE(e) || hE(e) || vE(e) || pE(e);
}
function bE(e) {
    return e && e.type === Ya.text || !1;
}
function wE(e, t) {
    var n = [];
    return function(e, t, n) {
        if (!t) return;
        var r = KE(t), o = JE(t);
        if (Ox(r, o)) return n(r);
        if (void 0 === e) return;
        var i = OE(r, o);
        if (r.length === i.length || o.length === i.length) return n(i);
        var a = DE(r, o), s = kE(e, a), c = jE(e, a), l = UE(e, a, s), u = UE(e, a, c);
        if (-1 === l || -1 === u) return;
        var f = Ws(e, i);
        if (Rs(f)) {
            for(var d = Object.keys(f), h = l; h <= u; h++){
                var v = n(i.concat(d[h]));
                if (void 0 !== v) return v;
            }
            return;
        }
        if (Ts(f)) {
            for(var p = l; p <= u; p++){
                var m = n(i.concat(String(p)));
                if (void 0 !== m) return m;
            }
            return;
        }
        throw new Error("Failed to create selection");
    }(e, t, function(e) {
        n.push(e);
    }), n;
}
function xE(e) {
    return hE(e) ? e.path : Qw(JE(e));
}
function kE(e, t) {
    if (!mE(t)) return t.path;
    var n = UE(e, t, t.anchorPath);
    return UE(e, t, t.focusPath) < n ? t.focusPath : t.anchorPath;
}
function jE(e, t) {
    if (!mE(t)) return t.path;
    var n = UE(e, t, t.anchorPath);
    return UE(e, t, t.focusPath) > n ? t.focusPath : t.anchorPath;
}
function SE(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = t.selection;
    if (!r) return null;
    var o = n ? JE(r) : kE(e, r), i = function(e, t, n) {
        var r = aE(e, t), o = r.map(Zs), i = Zs(n), a = o.indexOf(i);
        return -1 !== a && a > 0 ? r[a - 1] : null;
    }(e, t, o);
    if (n) return hE(r) || dE(r) ? null !== i ? DE(o, o) : null : null !== i ? DE(KE(r), i) : null;
    if (dE(r)) return RE(o, !1);
    if (hE(r)) return RE(o, !1);
    if (vE(r)) {
        if (null == i || 0 === i.length) return null;
        var a = Ws(e, Qw(i));
        return Array.isArray(a) || _x(i) ? RE(i, !1) : TE(i, !1);
    }
    return pE(r), null !== i ? RE(i, !1) : null;
}
function CE(e, t, n) {
    var r = t.selection;
    if (!r) return {
        caret: null,
        previous: null,
        next: null
    };
    var o = sE(e, t, n), i = o.findIndex(function(e) {
        return Ox(e.path, JE(r)) && String(e.type) === String(r.type);
    });
    return {
        caret: -1 !== i ? o[i] : null,
        previous: -1 !== i && i > 0 ? o[i - 1] : null,
        next: -1 !== i && i < o.length - 1 ? o[i + 1] : null
    };
}
function $E(e, t) {
    for(var n = aE(e, t), r = 0; r < n.length - 1 && n[r + 1].length > n[r].length;)r++;
    var o = n[r];
    return void 0 === o || 0 === o.length || Array.isArray(Ws(e, Qw(o))) ? RE(o, !1) : TE(o, !1);
}
function _E(e, t) {
    if (1 === t.length) {
        var n = cw(t);
        if ("replace" === n.op) return RE(dc(e, n.path), !1);
    }
    if (!_x(t) && t.every(function(e) {
        return "move" === e.op;
    })) {
        var r = cw(t), o = t.slice(1);
        if ((zs(r) || qs(r)) && r.from !== r.path && o.every(function(e) {
            return (zs(e) || qs(e)) && e.from === e.path;
        })) return TE(dc(e, r.path), !1);
    }
    var i = t.filter(function(e) {
        return "test" !== e.op && "remove" !== e.op && ("move" !== e.op || e.from !== e.path) && "string" == typeof e.path;
    }).map(function(t) {
        return dc(e, t.path);
    });
    return _x(i) ? null : {
        type: Ya.multi,
        anchorPath: cw(i),
        focusPath: vb(i)
    };
}
function OE(e, t) {
    for(var n = 0; n < e.length && n < t.length && e[n] === t[n];)n++;
    return e.slice(0, n);
}
function ME(e) {
    return vE(e) || pE(e) || gE(e);
}
function EE(e, t) {
    return ME(t) && Ql(Ws(e, JE(t))) ? JE(t) : Qw(JE(t));
}
function AE(e, t) {
    if (e.length < t.length) return !1;
    for(var n = 0; n < t.length; n++)if (e[n] !== t[n]) return !1;
    return !0;
}
function PE(e) {
    var t = e.selection;
    return (vE(t) || pE(t)) && t.edit ? Ro(Ro({}, e), {}, {
        selection: Ro(Ro({}, t), {}, {
            edit: !1
        })
    }) : e;
}
function TE(e, t) {
    return {
        type: Ya.key,
        path: e,
        edit: t
    };
}
function RE(e, t) {
    return {
        type: Ya.value,
        path: e,
        edit: t
    };
}
function NE(e) {
    return {
        type: Ya.inside,
        path: e
    };
}
function IE(e) {
    return {
        type: Ya.after,
        path: e
    };
}
function DE(e, t) {
    var n = OE(e, t), r = e.length > n.length && t.length > n.length;
    return {
        type: Ya.multi,
        anchorPath: r ? n.concat(e[n.length]) : n,
        focusPath: r ? n.concat(t[n.length]) : n
    };
}
function zE(e, t, n, r) {
    if (vE(t)) return String(vb(t.path));
    if (pE(t)) {
        var o, i = Ws(e, t.path);
        return "string" == typeof i ? i : null !== (o = r.stringify(i, null, n)) && void 0 !== o ? o : null;
    }
    if (mE(t)) {
        var a;
        if (_x(t.focusPath)) return null !== (a = r.stringify(e, null, n)) && void 0 !== a ? a : null;
        var s = xE(t), c = Ws(e, s);
        if (Array.isArray(c)) {
            if (gE(t)) {
                var l, u = Ws(e, t.focusPath);
                return null !== (l = r.stringify(u, null, n)) && void 0 !== l ? l : null;
            }
            return wE(e, t).map(function(t) {
                var o = Ws(e, t);
                return "".concat(r.stringify(o, null, n), ",");
            }).join("\n");
        }
        return wE(e, t).map(function(t) {
            var o = vb(t), i = Ws(e, t);
            return "".concat(r.stringify(o), ": ").concat(r.stringify(i, null, n), ",");
        }).join("\n");
    }
    return null;
}
function qE(e) {
    return (vE(e) || pE(e)) && !0 === e.edit;
}
function BE(e) {
    return vE(e) || pE(e) || mE(e);
}
function LE(e) {
    return vE(e) || pE(e) || gE(e);
}
function FE(e) {
    switch(e.type){
        case Xa.key:
            return TE(e.path, !1);
        case Xa.value:
            return RE(e.path, !1);
        case Xa.after:
            return IE(e.path);
        case Xa.inside:
            return NE(e.path);
    }
}
function VE(e, t, n) {
    switch(t){
        case Ya.key:
            return TE(n, !1);
        case Ya.value:
            return RE(n, !1);
        case Ya.after:
            return IE(n);
        case Ya.inside:
            return NE(n);
        case Ya.multi:
        case Ya.text:
            return DE(n, n);
    }
}
function HE(e, t, n) {
    return t && (WE(e, t, n) || AE(mE(t) ? Qw(t.focusPath) : t.path, n)) ? t : null;
}
function WE(e, t, n) {
    if (void 0 === e || !t) return !1;
    if (vE(t) || hE(t) || dE(t)) return Ox(t.path, n);
    if (pE(t)) return AE(n, t.path);
    if (mE(t)) {
        var r = kE(e, t), o = jE(e, t), i = Qw(t.focusPath);
        if (!AE(n, i) || n.length <= i.length) return !1;
        var a = UE(e, t, r), s = UE(e, t, o), c = UE(e, t, n);
        return -1 !== c && c >= a && c <= s;
    }
    return !1;
}
function UE(e, t, n) {
    var r = Qw(t.focusPath);
    if (!AE(n, r) || n.length <= r.length) return -1;
    var o = n[r.length], i = Ws(e, r);
    if (Rs(i)) return Object.keys(i).indexOf(o);
    if (Ts(i)) {
        var a = Ul(o);
        if (a < i.length) return a;
    }
    return -1;
}
function JE(e) {
    return mE(e) ? e.focusPath : e.path;
}
function KE(e) {
    return mE(e) ? e.anchorPath : e.path;
}
function GE() {
    for(var e = [], t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
    for(var o = 0, i = n; o < i.length; o++){
        var a = i[o];
        if ("string" == typeof a && e.push(a), a && "object" === Ho(a)) for(var s in a)Object.hasOwnProperty.call(a, s) && a[s] && e.push(s);
    }
    return e.join(" ");
}
function QE(e, t) {
    return GE("jse-value", "jse-" + eu(e, t), {
        "jse-url": nu(e),
        "jse-empty": "string" == typeof e && 0 === e.length
    });
}
function YE(e) {
    mi(e, "svelte-zwlnit", ".jse-value.jse-string.svelte-zwlnit{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-zwlnit,.jse-value.jse-array.svelte-zwlnit{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-zwlnit{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-zwlnit{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-zwlnit{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-zwlnit{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-zwlnit{color:var(--jse-value-color-url, #008000);text-decoration:underline}div.jse-editable-div.svelte-zwlnit{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:text !important;word-break:normal;white-space:pre-wrap;overflow-wrap:anywhere}div.jse-editable-div.jse-short-text.svelte-zwlnit{overflow-wrap:normal}div.jse-editable-div[contenteditable=true].svelte-zwlnit{outline:var(--jse-edit-outline, 2px solid #656565);background:inherit !important;position:relative;border-radius:0;z-index:3}div.jse-editable-div.jse-empty.svelte-zwlnit:not(:focus){outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}div.jse-editable-div.jse-empty.svelte-zwlnit::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2))}");
}
function XE(e) {
    var t, n, r, o;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "textbox"), Ai(t, "tabindex", "0"), Ai(t, "class", n = si(GE("jse-editable-div", e[2], {
                "jse-short-text": e[0]
            })) + " svelte-zwlnit"), Ai(t, "contenteditable", "true"), Ai(t, "spellcheck", "false");
        },
        m: function(n, i) {
            wi(n, t, i), e[13](t), r || (o = [
                Oi(t, "input", e[3]),
                Oi(t, "keydown", e[4]),
                Oi(t, "paste", e[5]),
                Oi(t, "blur", e[6])
            ], r = !0);
        },
        p: function(e, r) {
            5 & jo(r, 1)[0] && n !== (n = si(GE("jse-editable-div", e[2], {
                "jse-short-text": e[0]
            })) + " svelte-zwlnit") && Ai(t, "class", n);
        },
        i: Wo,
        o: Wo,
        d: function(n) {
            n && xi(t), e[13](null), r = !1, Qo(o);
        }
    };
}
function ZE(e, t, n) {
    var r, o, i = Da("jsoneditor:EditableDiv"), a = t.value, s = t.shortText, c = void 0 !== s && s, l = t.onChange, u = t.onCancel, f = t.onFind, d = t.onPaste, h = void 0 === d ? Mf : d, v = t.onValueClass, p = void 0 === v ? function() {
        return "";
    } : v, m = !1;
    function g() {
        return r ? function(e) {
            return e.replace(/\n$/, "");
        }(r.innerText) : "";
    }
    function y(e) {
        r && n(1, r.innerText = gO(e), r);
    }
    function b() {
        var e = g();
        "" === e && y(""), n(2, o = p(e));
    }
    function w() {
        m = !0, u();
    }
    return Gi(function() {
        i("onMount", {
            value: a
        }), y(a), r && (kO(r), n(1, r.refresh = b, r), n(1, r.cancel = w, r));
    }), Qi(function() {
        var e = g();
        i("onDestroy", {
            closed: m,
            value: a,
            newValue: e
        }), m || e === a || l(e, ns.no);
    }), e.$$set = function(e) {
        "value" in e && n(7, a = e.value), "shortText" in e && n(0, c = e.shortText), "onChange" in e && n(8, l = e.onChange), "onCancel" in e && n(9, u = e.onCancel), "onFind" in e && n(10, f = e.onFind), "onPaste" in e && n(11, h = e.onPaste), "onValueClass" in e && n(12, p = e.onValueClass);
    }, e.$$.update = function() {
        4224 & e.$$.dirty && n(2, o = p(a));
    }, [
        c,
        r,
        o,
        b,
        function(e) {
            e.stopPropagation();
            var t = PO(e);
            if ("Escape" === t && w(), "Enter" === t || "Tab" === t) {
                m = !0;
                var n = g();
                l(n, ns.nextInside);
            }
            "Ctrl+F" === t && (e.preventDefault(), f(!1)), "Ctrl+H" === t && (e.preventDefault(), f(!0));
        },
        function(e) {
            if (e.stopPropagation(), h && e.clipboardData) {
                var t = e.clipboardData.getData("text/plain");
                h(t);
            }
        },
        function() {
            var e = document.hasFocus(), t = g();
            i("handleBlur", {
                hasFocus: e,
                closed: m,
                value: a,
                newValue: t
            }), document.hasFocus() && !m && (m = !0, t !== a && l(t, ns.self));
        },
        a,
        l,
        u,
        f,
        h,
        p,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(1, r = e);
            });
        }
    ];
}
var eA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, ZE, XE, Zo, {
            value: 7,
            shortText: 0,
            onChange: 8,
            onCancel: 9,
            onFind: 10,
            onPaste: 11,
            onValueClass: 12
        }, YE), n;
    }
    return Ao(t, Ia), Do(t);
}();
function tA(e) {
    var t, n;
    return t = new eA({
        props: {
            value: e[1].escapeValue(e[0]),
            onChange: e[3],
            onCancel: e[4],
            onPaste: e[5],
            onFind: e[2],
            onValueClass: e[6]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = jo(n, 1)[0], o = {};
            3 & r && (o.value = e[1].escapeValue(e[0])), 4 & r && (o.onFind = e[2]), t.$set(o);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function nA(e, t, n) {
    var r = t.path, o = t.value, i = t.parser, a = t.normalization, s = t.enforceString, c = t.onPatch, l = t.onPasteJson, u = t.onSelect, f = t.onFind, d = t.focus, h = t.findNextInside;
    function v(e) {
        return s ? e : ru(e, i);
    }
    return e.$$set = function(e) {
        "path" in e && n(7, r = e.path), "value" in e && n(0, o = e.value), "parser" in e && n(8, i = e.parser), "normalization" in e && n(1, a = e.normalization), "enforceString" in e && n(9, s = e.enforceString), "onPatch" in e && n(10, c = e.onPatch), "onPasteJson" in e && n(11, l = e.onPasteJson), "onSelect" in e && n(12, u = e.onSelect), "onFind" in e && n(2, f = e.onFind), "focus" in e && n(13, d = e.focus), "findNextInside" in e && n(14, h = e.findNextInside);
    }, [
        o,
        a,
        f,
        function(e, t) {
            c([
                {
                    op: "replace",
                    path: Zs(r),
                    value: v(a.unescapeValue(e))
                }
            ], function(e, n) {
                if (!n.selection || Ox(r, JE(n.selection))) {
                    var o = t === ns.nextInside ? h(r) : RE(r, !1);
                    return {
                        state: Ro(Ro({}, n), {}, {
                            selection: o
                        })
                    };
                }
            }), d();
        },
        function() {
            u(RE(r, !1)), d();
        },
        function(e) {
            try {
                var t = i.parse(e);
                Ql(t) && l({
                    path: r,
                    contents: t
                });
            } catch (e) {}
        },
        function(e) {
            return QE(v(a.unescapeValue(e)), i);
        },
        r,
        i,
        s,
        c,
        l,
        u,
        d,
        h
    ];
}
var rA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, nA, tA, Zo, {
            path: 7,
            value: 0,
            parser: 8,
            normalization: 1,
            enforceString: 9,
            onPatch: 10,
            onPasteJson: 11,
            onSelect: 12,
            onFind: 2,
            focus: 13,
            findNextInside: 14
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function oA(e, t, n) {
    var r = Qw(t), o = Ws(e, r);
    if (Ts(o)) {
        var i = Ul(vb(t));
        return n.map(function(e, t) {
            return {
                op: "add",
                path: Zs(r.concat(String(i + t))),
                value: e.value
            };
        });
    }
    if (Rs(o)) {
        var a = vb(t), s = Object.keys(o), c = void 0 !== a ? iE(s, a, !0) : [];
        return [].concat(Bo(n.map(function(e) {
            var t = eM(e.key, s);
            return {
                op: "add",
                path: Zs(r.concat(t)),
                value: e.value
            };
        })), Bo(c.map(function(e) {
            return uA(r, e);
        })));
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
}
function iA(e, t, n) {
    var r = Ws(e, t);
    if (Array.isArray(r)) {
        var o = r.length;
        return n.map(function(e, n) {
            return {
                op: "add",
                path: Zs(t.concat(String(o + n))),
                value: e.value
            };
        });
    }
    return n.map(function(e) {
        var n = eM(e.key, Object.keys(r));
        return {
            op: "add",
            path: Zs(t.concat(n)),
            value: e.value
        };
    });
}
function aA(e, t, n, r) {
    var o = eM(r, t.filter(function(e) {
        return e !== n;
    })), i = iE(t, n, !1);
    return [
        {
            op: "move",
            from: Zs(e.concat(n)),
            path: Zs(e.concat(o))
        }
    ].concat(Bo(i.map(function(t) {
        return uA(e, t);
    })));
}
function sA(e, t) {
    var n = vb(t);
    if (_x(n)) throw new Error("Cannot duplicate root object");
    var r = Qw(n), o = vb(n), i = Ws(e, r);
    if (Ts(i)) {
        var a = vb(t), s = a ? Ul(vb(a)) + 1 : 0;
        return Bo(t.map(function(e, t) {
            return {
                op: "copy",
                from: Zs(e),
                path: Zs(r.concat(String(t + s)))
            };
        }));
    }
    if (Rs(i)) {
        var c = Object.keys(i), l = void 0 !== o ? iE(c, o, !1) : [];
        return [].concat(Bo(t.map(function(e) {
            var t = eM(vb(e), c);
            return {
                op: "copy",
                from: Zs(e),
                path: Zs(r.concat(t))
            };
        })), Bo(l.map(function(e) {
            return uA(r, e);
        })));
    }
    throw new Error("Cannot create duplicate operations: parent must be an Object or Array");
}
function cA(e, t, n, r) {
    if (vE(t)) {
        var o = B_(n, r), i = Qw(t.path), a = Ws(e, i);
        return aA(i, Object.keys(a), vb(t.path), "string" == typeof o ? o : n);
    }
    if (pE(t) || mE(t) && _x(t.focusPath)) try {
        return [
            {
                op: "replace",
                path: Zs(JE(t)),
                value: L_(n, function(e) {
                    return q_(e, r);
                })
            }
        ];
    } catch (e) {
        return [
            {
                op: "replace",
                path: Zs(JE(t)),
                value: n
            }
        ];
    }
    if (mE(t)) {
        var s = fA(n, r);
        return function(e, t, n) {
            var r = Qw(cw(t)), o = Ws(e, r);
            if (Ts(o)) {
                var i = cw(t), a = i ? Ul(vb(i)) : 0;
                return [].concat(Bo(lA(t)), Bo(n.map(function(e, t) {
                    return {
                        op: "add",
                        path: Zs(r.concat(String(t + a))),
                        value: e.value
                    };
                })));
            }
            if (Rs(o)) {
                var s = vb(t), c = Qw(s), l = vb(s), u = Object.keys(o), f = void 0 !== l ? iE(u, l, !1) : [], d = new Set(t.map(function(e) {
                    return vb(e);
                })), h = u.filter(function(e) {
                    return !d.has(e);
                });
                return [].concat(Bo(lA(t)), Bo(n.map(function(e) {
                    var t = eM(e.key, h);
                    return {
                        op: "add",
                        path: Zs(c.concat(t)),
                        value: e.value
                    };
                })), Bo(f.map(function(e) {
                    return uA(c, e);
                })));
            }
            throw new Error("Cannot create replace operations: parent must be an Object or Array");
        }(e, wE(e, t), s);
    }
    if (dE(t)) {
        var c = fA(n, r), l = t.path, u = Qw(l), f = Ws(e, u);
        if (Ts(f)) {
            var d = Ul(vb(l));
            return oA(e, u.concat(String(d + 1)), c);
        }
        if (Rs(f)) {
            var h = String(vb(l)), v = Object.keys(f);
            if (_x(v) || vb(v) === h) return iA(e, u, c);
            var p = v.indexOf(h), m = v[p + 1];
            return oA(e, u.concat(m), c);
        }
        throw new Error("Cannot create insert operations: parent must be an Object or Array");
    }
    if (hE(t)) {
        var g = fA(n, r), y = t.path, b = Ws(e, y);
        if (Ts(b)) return oA(e, y.concat("0"), g);
        if (Rs(b)) {
            var w = Object.keys(b);
            if (_x(w)) return iA(e, y, g);
            var x = cw(w);
            return oA(e, y.concat(x), g);
        }
        throw new Error("Cannot create insert operations: parent must be an Object or Array");
    }
    throw new Error("Cannot insert: unsupported type of selection " + JSON.stringify(t));
}
function lA(e) {
    return e.map(function(e) {
        return {
            op: "remove",
            path: Zs(e)
        };
    }).reverse();
}
function uA(e, t) {
    return {
        op: "move",
        from: Zs(e.concat(t)),
        path: Zs(e.concat(t))
    };
}
function fA(e, t) {
    var n = /^\s*{/.test(e), r = /^\s*\[/.test(e), o = B_(e, t), i = void 0 !== o ? o : L_(e, function(e) {
        return q_(e, t);
    });
    return n && Gl(i) || r && Array.isArray(i) ? [
        {
            key: "New item",
            value: i
        }
    ] : Array.isArray(i) ? i.map(function(e, t) {
        return {
            key: "New item " + t,
            value: e
        };
    }) : Gl(i) ? Object.keys(i).map(function(e) {
        return {
            key: e,
            value: i[e]
        };
    }) : [
        {
            key: "New item",
            value: i
        }
    ];
}
function dA(e, t) {
    if (vE(t)) {
        var n = Qw(t.path), r = Ws(e, n), o = aA(n, Object.keys(r), vb(t.path), "");
        return {
            operations: o,
            newSelection: _E(e, o)
        };
    }
    if (pE(t)) return {
        operations: [
            {
                op: "replace",
                path: Zs(t.path),
                value: ""
            }
        ],
        newSelection: t
    };
    if (mE(t)) {
        var i = wE(e, t), a = lA(i), s = vb(i);
        if (_x(s)) return {
            operations: [
                {
                    op: "replace",
                    path: "",
                    value: ""
                }
            ],
            newSelection: RE([], !1)
        };
        var c = Qw(s), l = Ws(e, c);
        if (Ts(l)) {
            var u = Ul(vb(cw(i)));
            return {
                operations: a,
                newSelection: 0 === u ? NE(c) : IE(c.concat(String(u - 1)))
            };
        }
        if (Rs(l)) {
            var f = Object.keys(l), d = vb(cw(i)), h = f.indexOf(d), v = f[h - 1];
            return {
                operations: a,
                newSelection: 0 === h ? NE(c) : IE(c.concat(v))
            };
        }
        throw new Error("Cannot create remove operations: parent must be an Object or Array");
    }
    throw new Error("Cannot remove: unsupported type of selection " + JSON.stringify(t));
}
function hA(e, t) {
    return vc(e, t, {
        before: function(e, t, n) {
            if (Is(t)) {
                var r = Xs(t.path);
                return {
                    revertOperations: [].concat(Bo(n), Bo(vA(e, r)))
                };
            }
            if (qs(t)) {
                var o = Xs(t.from);
                return {
                    revertOperations: [].concat(Bo(n), Bo(vA(e, o)))
                };
            }
            return {
                document: e
            };
        }
    });
}
function vA(e, t) {
    var n = Qw(t), r = vb(t), o = Ws(e, n);
    return Rs(o) ? iE(Object.keys(o), r, !1).map(function(e) {
        return uA(n, e);
    }) : [];
}
function pA(e) {
    var t = e.activeIndex < e.items.length - 1 ? e.activeIndex + 1 : e.items.length > 0 ? 0 : -1, n = e.items[t], r = e.items.map(function(e, n) {
        return Ro(Ro({}, e), {}, {
            active: n === t
        });
    });
    return Ro(Ro({}, e), {}, {
        items: r,
        itemsMap: Aw(r, function(e) {
            return Zs(e.path);
        }),
        activeItem: n,
        activeIndex: t
    });
}
function mA(e) {
    var t = e.activeIndex > 0 ? e.activeIndex - 1 : e.items.length - 1, n = e.items[t], r = e.items.map(function(e, n) {
        return Ro(Ro({}, e), {}, {
            active: n === t
        });
    });
    return Ro(Ro({}, e), {}, {
        items: r,
        itemsMap: Aw(r, function(e) {
            return Zs(e.path);
        }),
        activeItem: n,
        activeIndex: t
    });
}
function gA(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0, r = [], o = [];
    function i(e) {
        r.length < n && r.push(e);
    }
    "string" == typeof e && "" !== e && function e(t, a) {
        if (Ts(a)) {
            var s = o.length;
            o.push("0");
            for(var c = 0; c < a.length; c++)if (o[s] = String(c), e(t, a[c]), r.length >= n) return;
            o.pop();
        } else if (Rs(a)) {
            var l = Object.keys(a), u = o.length;
            o.push("");
            for(var f = 0, d = l; f < d.length; f++){
                var h = d[f];
                if (o[u] = h, yA(h, t, o, es.key, i), e(t, a[h]), r.length >= n) return;
            }
            o.pop();
        } else yA(String(a), t, o, es.value, i);
    }(e.toLowerCase(), t);
    return r;
}
function yA(e, t, n, r, o) {
    var i = e.toLowerCase(), a = 0, s = -1, c = -1;
    do -1 !== (c = i.indexOf(t, s)) && (s = c + t.length, o({
        path: n.slice(0),
        field: r,
        fieldIndex: a,
        start: c,
        end: s
    }), a++);
    while (-1 !== c);
}
function bA(e, t, n, r) {
    return e.substring(0, n) + t + e.substring(r);
}
function wA(e, t, n) {
    var r = e;
    return Ab(n, function(e) {
        r = bA(r, t, e.start, e.end);
    }), r;
}
function xA(e, t, n, r, o) {
    var i = r.field, a = r.path, s = r.start, c = r.end;
    if (i === es.key) {
        var l = Qw(a), u = Ws(e, l), f = vb(a), d = aA(l, Object.keys(u), f, bA(f, n, s, c));
        return {
            newSelection: _E(e, d),
            operations: d
        };
    }
    if (i === es.value) {
        var h = Ws(e, a);
        if (void 0 === h) throw new Error("Cannot replace: path not found ".concat(Zs(a)));
        var v = "string" == typeof h ? h : String(h), p = Zs(a), m = oE(h, t.enforceStringMap, p, o), g = bA(v, n, s, c), y = [
            {
                op: "replace",
                path: Zs(a),
                value: m ? g : ru(g, o)
            }
        ];
        return {
            newSelection: _E(e, y),
            operations: y
        };
    }
    throw new Error("Cannot replace: unknown type of search result field ".concat(i));
}
function kA(e, t, n, r, o) {
    for(var i = gA(n, e, 1 / 0), a = [], s = 0; s < i.length; s++){
        var c = i[s - 1], l = i[s];
        0 !== s && l.field === c.field && Ox(l.path, c.path) ? vb(a).items.push(l) : a.push({
            path: l.path,
            field: l.field,
            items: [
                l
            ]
        });
    }
    a.sort(function(e, t) {
        return e.field !== t.field ? e.field === es.key ? 1 : -1 : t.path.length - e.path.length;
    });
    var u = [], f = null;
    return a.forEach(function(n) {
        var i = n.field, a = n.path, s = n.items;
        if (i === es.key) {
            var c = Qw(a), l = Ws(e, c), d = vb(a), h = aA(c, Object.keys(l), d, wA(d, r, s));
            u = u.concat(h), f = _E(e, h);
        } else {
            if (i !== es.value) throw new Error("Cannot replace: unknown type of search result field ".concat(i));
            var v = Ws(e, a);
            if (void 0 === v) throw new Error("Cannot replace: path not found ".concat(Zs(a)));
            var p = "string" == typeof v ? v : String(v), m = Zs(a), g = oE(v, t.enforceStringMap, m, o), y = wA(p, r, s), b = [
                {
                    op: "replace",
                    path: Zs(a),
                    value: g ? y : ru(y, o)
                }
            ];
            u = u.concat(b), f = _E(e, b);
        }
    }), {
        operations: u,
        newSelection: f
    };
}
function jA(e) {
    return e.path.concat(e.field, String(e.fieldIndex));
}
function SA(e, t) {
    var n, r = null == e || null === (n = e[t]) || void 0 === n ? void 0 : n.filter(function(e) {
        return e.field === es.key;
    });
    if (r && 0 !== r.length) return r;
}
function CA(e, t) {
    var n, r = null == e || null === (n = e[t]) || void 0 === n ? void 0 : n.filter(function(e) {
        return e.field === es.value;
    });
    if (r && 0 !== r.length) return r;
}
function $A(e) {
    mi(e, "svelte-1n1l5ny", ".jse-highlight.svelte-1n1l5ny{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-highlight.jse-active.svelte-1n1l5ny{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}");
}
function _A(e, t, n) {
    var r = e.slice();
    return r[3] = t[n], r;
}
function OA(e) {
    var t, n, r = gO(e[3].text) + "";
    return {
        c: function() {
            t = ji("span"), n = Ci(r), Ai(t, "class", "jse-highlight svelte-1n1l5ny"), qi(t, "jse-active", e[3].active);
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, o) {
            1 & o && r !== (r = gO(e[3].text) + "") && Ni(n, r), 1 & o && qi(t, "jse-active", e[3].active);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function MA(e) {
    var t, n = e[3].text + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = e[3].text + "") && Ni(t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function EA(e) {
    var t;
    function n(e, t) {
        return "normal" === e[3].type ? MA : OA;
    }
    var r = n(e), o = r(e);
    return {
        c: function() {
            o.c(), t = _i();
        },
        m: function(e, n) {
            o.m(e, n), wi(e, t, n);
        },
        p: function(e, i) {
            r === (r = n(e)) && o ? o.p(e, i) : (o.d(1), (o = r(e)) && (o.c(), o.m(t.parentNode, t)));
        },
        d: function(e) {
            e && xi(t), o.d(e);
        }
    };
}
function AA(e) {
    for(var t, n = Ca(e[0]), r = [], o = 0; o < n.length; o += 1)r[o] = EA(_A(e, n, o));
    return {
        c: function() {
            for(var e = 0; e < r.length; e += 1)r[e].c();
            t = _i();
        },
        m: function(e, n) {
            for(var o = 0; o < r.length; o += 1)r[o] && r[o].m(e, n);
            wi(e, t, n);
        },
        p: function(e, o) {
            var i = jo(o, 1)[0];
            if (1 & i) {
                var a;
                for(n = Ca(e[0]), a = 0; a < n.length; a += 1){
                    var s = _A(e, n, a);
                    r[a] ? r[a].p(s, i) : (r[a] = EA(s), r[a].c(), r[a].m(t.parentNode, t));
                }
                for(; a < r.length; a += 1)r[a].d(1);
                r.length = n.length;
            }
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), ki(r, e);
        }
    };
}
function PA(e, t, n) {
    var r, o = t.text, i = t.searchResultItems;
    return e.$$set = function(e) {
        "text" in e && n(1, o = e.text), "searchResultItems" in e && n(2, i = e.searchResultItems);
    }, e.$$.update = function() {
        6 & e.$$.dirty && n(0, r = function(e, t) {
            var n, r = [], o = 0, i = bo(t);
            try {
                for(i.s(); !(n = i.n()).done;){
                    var a = n.value, s = e.slice(o, a.start);
                    "" !== s && r.push({
                        type: "normal",
                        text: s,
                        active: !1
                    });
                    var c = e.slice(a.start, a.end);
                    r.push({
                        type: "highlight",
                        text: c,
                        active: a.active
                    }), o = a.end;
                }
            } catch (e) {
                i.e(e);
            } finally{
                i.f();
            }
            var l = vb(t);
            return l && l.end < e.length && r.push({
                type: "normal",
                text: e.slice(l.end),
                active: !1
            }), r;
        }(String(o), i));
    }, [
        r,
        o,
        i
    ];
}
var TA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, PA, AA, Xo, {
            text: 1,
            searchResultItems: 2
        }, $A), n;
    }
    return Ao(t, Ia), Do(t);
}();
function RA(e) {
    mi(e, "svelte-1v88515", '.jse-value.jse-string.svelte-1v88515{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-1v88515,.jse-value.jse-array.svelte-1v88515{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-1v88515{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-1v88515{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-1v88515{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-1v88515{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-1v88515{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-value.svelte-1v88515{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:anywhere;white-space:pre-wrap}.jse-value.svelte-1v88515:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-value.jse-empty.svelte-1v88515{min-width:4em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-value.jse-empty.svelte-1v88515::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"value"}');
}
function NA(e) {
    var t, n = gO(e[1].escapeValue(e[0])) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            3 & r && n !== (n = gO(e[1].escapeValue(e[0])) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function IA(e) {
    var t, n;
    return t = new TA({
        props: {
            text: e[1].escapeValue(e[0]),
            searchResultItems: e[3]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            3 & n && (r.text = e[1].escapeValue(e[0])), 8 & n && (r.searchResultItems = e[3]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function DA(e) {
    var t, n, r, o, i, a, s, c, l = [
        IA,
        NA
    ], u = [];
    function f(e, t) {
        return e[3] ? 0 : 1;
    }
    return n = f(e), r = u[n] = l[n](e), {
        c: function() {
            t = ji("div"), r.c(), Ai(t, "role", "button"), Ai(t, "tabindex", "-1"), Ai(t, "data-type", "selectable-value"), Ai(t, "class", o = si(QE(e[0], e[2])) + " svelte-1v88515"), Ai(t, "title", i = e[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null);
        },
        m: function(r, o) {
            wi(r, t, o), u[n].m(t, null), a = !0, s || (c = [
                Oi(t, "click", e[5]),
                Oi(t, "dblclick", e[6])
            ], s = !0);
        },
        p: function(e, s) {
            var c = jo(s, 1)[0], d = n;
            (n = f(e)) === d ? u[n].p(e, c) : (ba(), ka(u[d], 1, 1, function() {
                u[d] = null;
            }), wa(), (r = u[n]) ? r.p(e, c) : (r = u[n] = l[n](e)).c(), xa(r, 1), r.m(t, null)), (!a || 5 & c && o !== (o = si(QE(e[0], e[2])) + " svelte-1v88515")) && Ai(t, "class", o), (!a || 16 & c && i !== (i = e[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null)) && Ai(t, "title", i);
        },
        i: function(e) {
            a || (xa(r), a = !0);
        },
        o: function(e) {
            ka(r), a = !1;
        },
        d: function(e) {
            e && xi(t), u[n].d(), s = !1, Qo(c);
        }
    };
}
function zA(e, t, n) {
    var r, o = t.path, i = t.value, a = t.readOnly, s = t.normalization, c = t.parser, l = t.onSelect, u = t.searchResultItems;
    return e.$$set = function(e) {
        "path" in e && n(7, o = e.path), "value" in e && n(0, i = e.value), "readOnly" in e && n(8, a = e.readOnly), "normalization" in e && n(1, s = e.normalization), "parser" in e && n(2, c = e.parser), "onSelect" in e && n(9, l = e.onSelect), "searchResultItems" in e && n(3, u = e.searchResultItems);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(4, r = nu(i));
    }, [
        i,
        s,
        c,
        u,
        r,
        function(e) {
            "string" == typeof i && r && e.ctrlKey && (e.preventDefault(), e.stopPropagation(), window.open(i, "_blank"));
        },
        function(e) {
            a || (e.preventDefault(), l(RE(o, !0)));
        },
        o,
        a,
        l
    ];
}
var qA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, zA, DA, Zo, {
            path: 7,
            value: 0,
            readOnly: 8,
            normalization: 1,
            parser: 2,
            onSelect: 9,
            searchResultItems: 3
        }, RA), n;
    }
    return Ao(t, Ia), Do(t);
}();
function BA(e) {
    mi(e, "svelte-1sftg37", '.jse-tooltip.svelte-1sftg37{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);border-radius:3px;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));white-space:nowrap;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}');
}
function LA(e) {
    var t, n;
    return {
        c: function() {
            t = ji("div"), n = Ci(e[0]), Ai(t, "class", "jse-tooltip svelte-1sftg37");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            1 & jo(t, 1)[0] && Ni(n, e[0]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function FA(e, t, n) {
    var r = t.text;
    return e.$$set = function(e) {
        "text" in e && n(0, r = e.text);
    }, [
        r
    ];
}
var VA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, FA, LA, Xo, {
            text: 0
        }, BA), n;
    }
    return Ao(t, Ia), Do(t);
}();
function HA(e, t) {
    var n, r = t.text, o = t.openAbsolutePopup, i = t.closeAbsolutePopup;
    function a() {
        n = o(VA, {
            text: r
        }, {
            position: "top",
            width: 10 * r.length,
            offsetTop: 3,
            anchor: e,
            closeOnOuterClick: !0
        });
    }
    function s() {
        i(n);
    }
    return e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", s), {
        destroy: function() {
            e.removeEventListener("mouseenter", a), e.removeEventListener("mouseleave", s);
        }
    };
}
function WA(e) {
    mi(e, "svelte-1sqrs1u", ".jse-timestamp.svelte-1sqrs1u{padding:0;margin:0;vertical-align:middle;display:inline-flex;color:var(--jse-value-color-number, #ee422e)}");
}
function UA(e) {
    var t, n, r, o, i, a;
    return n = new jM({
        props: {
            data: sM
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-timestamp svelte-1sqrs1u");
        },
        m: function(s, c) {
            wi(s, t, c), Ta(n, t, null), o = !0, i || (a = ci(r = HA.call(null, t, Ro({
                text: e[0]
            }, e[1]))), i = !0);
        },
        p: function(e, t) {
            var n = jo(t, 1)[0];
            r && Yo(r.update) && 1 & n && r.update.call(null, Ro({
                text: e[0]
            }, e[1]));
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, a();
        }
    };
}
function JA(e, t, n) {
    var r, o = Zi("absolute-popup"), i = t.value;
    return e.$$set = function(e) {
        "value" in e && n(2, i = e.value);
    }, e.$$.update = function() {
        4 & e.$$.dirty && n(0, r = "Time: ".concat(new Date(i).toString()));
    }, [
        r,
        o,
        i
    ];
}
var KA = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, JA, UA, Zo, {
            value: 2
        }, WA), n;
    }
    return Ao(t, Ia), Do(t);
}();
function GA(e) {
    var t = e.path, n = e.value, r = e.readOnly, o = e.enforceString, i = e.searchResultItems, a = e.isEditing, s = e.parser, c = e.normalization, l = e.onPatch, u = e.onPasteJson, f = e.onSelect, d = e.onFind, h = e.findNextInside, v = e.focus, p = [];
    return !a && function(e) {
        return !0 === e || !1 === e;
    }(n) && p.push({
        component: _M,
        props: {
            path: t,
            value: n,
            readOnly: r,
            onPatch: l,
            focus: v
        }
    }), !a && function(e) {
        return "string" == typeof e && e.length < 99 && !!Xl(e);
    }(n) && p.push({
        component: NM,
        props: {
            path: t,
            value: n,
            readOnly: r,
            onPatch: l,
            focus: v
        }
    }), a && p.push({
        component: rA,
        props: {
            path: t,
            value: n,
            enforceString: o,
            parser: s,
            normalization: c,
            onPatch: l,
            onPasteJson: u,
            onSelect: f,
            onFind: d,
            findNextInside: h,
            focus: v
        }
    }), a || p.push({
        component: qA,
        props: {
            path: t,
            value: n,
            readOnly: r,
            parser: s,
            normalization: c,
            searchResultItems: i,
            onSelect: f
        }
    }), !a && Yl(n) && p.push({
        component: KA,
        props: {
            value: n
        }
    }), p;
}
var QA = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
}, YA = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
}, XA = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
}, ZA = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
}, eP = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
}, tP = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
}, nP = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
}, rP = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
}, oP = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
}, iP = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
}, aP = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
}, sP = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
}, cP = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
}, lP = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
}, uP = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
}, fP = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
}, dP = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
}, hP = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
}, vP = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
}, pP = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
}, mP = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
}, gP = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
}, yP = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
}, bP = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
}, wP = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
}, xP = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
}, kP = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
}, jP = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
}, SP = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
}, CP = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    ]
}, $P = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
}, _P = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
}, OP = _P, MP = _P, EP = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
}, AP = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
}, PP = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
}, TP = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
}, RP = {}, NP = {
    showWizard: !0,
    showOriginal: !0
}, IP = Math.min, DP = Math.max, zP = Math.round, qP = Math.floor, BP = function(e) {
    return {
        x: e,
        y: e
    };
}, LP = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
}, FP = {
    start: "end",
    end: "start"
};
function VP(e, t, n) {
    return DP(e, IP(t, n));
}
function HP(e, t) {
    return "function" == typeof e ? e(t) : e;
}
function WP(e) {
    return e.split("-")[0];
}
function UP(e) {
    return e.split("-")[1];
}
function JP(e) {
    return "x" === e ? "y" : "x";
}
function KP(e) {
    return "y" === e ? "height" : "width";
}
function GP(e) {
    return [
        "top",
        "bottom"
    ].includes(WP(e)) ? "y" : "x";
}
function QP(e) {
    return JP(GP(e));
}
function YP(e, t, n) {
    void 0 === n && (n = !1);
    var r = UP(e), o = QP(e), i = KP(o), a = "x" === o ? r === (n ? "end" : "start") ? "right" : "left" : "start" === r ? "bottom" : "top";
    return t.reference[i] > t.floating[i] && (a = tT(a)), [
        a,
        tT(a)
    ];
}
function XP(e) {
    var t = tT(e);
    return [
        ZP(e),
        t,
        ZP(t)
    ];
}
function ZP(e) {
    return e.replace(/start|end/g, function(e) {
        return FP[e];
    });
}
function eT(e, t, n, r) {
    var o = UP(e), i = function(e, t, n) {
        var r = [
            "left",
            "right"
        ], o = [
            "right",
            "left"
        ];
        switch(e){
            case "top":
            case "bottom":
                return n ? t ? o : r : t ? r : o;
            case "left":
            case "right":
                return t ? [
                    "top",
                    "bottom"
                ] : [
                    "bottom",
                    "top"
                ];
            default:
                return [];
        }
    }(WP(e), "start" === n, r);
    return o && (i = i.map(function(e) {
        return e + "-" + o;
    }), t && (i = i.concat(i.map(ZP)))), i;
}
function tT(e) {
    return e.replace(/left|right|bottom|top/g, function(e) {
        return LP[e];
    });
}
function nT(e) {
    return "number" != typeof e ? function(e) {
        return Ro({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, e);
    }(e) : {
        top: e,
        right: e,
        bottom: e,
        left: e
    };
}
function rT(e) {
    return Ro(Ro({}, e), {}, {
        top: e.y,
        left: e.x,
        right: e.x + e.width,
        bottom: e.y + e.height
    });
}
function oT(e, t, n) {
    var r, o = e.reference, i = e.floating, a = GP(t), s = QP(t), c = KP(s), l = WP(t), u = "y" === a, f = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, h = o[c] / 2 - i[c] / 2;
    switch(l){
        case "top":
            r = {
                x: f,
                y: o.y - i.height
            };
            break;
        case "bottom":
            r = {
                x: f,
                y: o.y + o.height
            };
            break;
        case "right":
            r = {
                x: o.x + o.width,
                y: d
            };
            break;
        case "left":
            r = {
                x: o.x - i.width,
                y: d
            };
            break;
        default:
            r = {
                x: o.x,
                y: o.y
            };
    }
    switch(UP(t)){
        case "start":
            r[s] -= h * (n && u ? -1 : 1);
            break;
        case "end":
            r[s] += h * (n && u ? -1 : 1);
    }
    return r;
}
var iT = function() {
    var e = ko(wo().mark(function e(t, n, r) {
        var o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return o = r.placement, i = void 0 === o ? "bottom" : o, a = r.strategy, s = void 0 === a ? "absolute" : a, c = r.middleware, l = void 0 === c ? [] : c, u = r.platform, f = l.filter(Boolean), e.next = 4, null == u.isRTL ? void 0 : u.isRTL(n);
                case 4:
                    return d = e.sent, e.next = 7, u.getElementRects({
                        reference: t,
                        floating: n,
                        strategy: s
                    });
                case 7:
                    h = e.sent, v = oT(h, i, d), p = v.x, m = v.y, g = i, y = {}, b = 0, w = 0;
                case 13:
                    if (!(w < f.length)) {
                        e.next = 46;
                        break;
                    }
                    return x = f[w], k = x.name, j = x.fn, e.next = 17, j({
                        x: p,
                        y: m,
                        initialPlacement: i,
                        placement: g,
                        strategy: s,
                        middlewareData: y,
                        rects: h,
                        platform: u,
                        elements: {
                            reference: t,
                            floating: n
                        }
                    });
                case 17:
                    if (S = e.sent, C = S.x, $ = S.y, _ = S.data, O = S.reset, p = null != C ? C : p, m = null != $ ? $ : m, y = Ro(Ro({}, y), {}, zo({}, k, Ro(Ro({}, y[k]), _))), !(O && b <= 50)) {
                        e.next = 43;
                        break;
                    }
                    if (b++, "object" !== Ho(O)) {
                        e.next = 41;
                        break;
                    }
                    if (O.placement && (g = O.placement), !O.rects) {
                        e.next = 38;
                        break;
                    }
                    if (!0 !== O.rects) {
                        e.next = 36;
                        break;
                    }
                    return e.next = 33, u.getElementRects({
                        reference: t,
                        floating: n,
                        strategy: s
                    });
                case 33:
                    e.t0 = e.sent, e.next = 37;
                    break;
                case 36:
                    e.t0 = O.rects;
                case 37:
                    h = e.t0;
                case 38:
                    M = oT(h, g, d), p = M.x, m = M.y;
                case 41:
                    return w = -1, e.abrupt("continue", 43);
                case 43:
                    w++, e.next = 13;
                    break;
                case 46:
                    return e.abrupt("return", {
                        x: p,
                        y: m,
                        placement: g,
                        strategy: s,
                        middlewareData: y
                    });
                case 47:
                case "end":
                    return e.stop();
            }
        }, e);
    }));
    return function(t, n, r) {
        return e.apply(this, arguments);
    };
}();
function aT(e, t) {
    return sT.apply(this, arguments);
}
function sT() {
    return sT = ko(wo().mark(function e(t, n) {
        var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return void 0 === n && (n = {}), o = t.x, i = t.y, a = t.platform, s = t.rects, c = t.elements, l = t.strategy, u = HP(n, t), f = u.boundary, d = void 0 === f ? "clippingAncestors" : f, h = u.rootBoundary, v = void 0 === h ? "viewport" : h, p = u.elementContext, m = void 0 === p ? "floating" : p, g = u.altBoundary, y = void 0 !== g && g, b = u.padding, w = nT(void 0 === b ? 0 : b), x = "floating" === m ? "reference" : "floating", k = c[y ? x : m], e.t0 = rT, e.t1 = a, e.next = 10, null == a.isElement ? void 0 : a.isElement(k);
                case 10:
                    if (e.t2 = r = e.sent, null == e.t2) {
                        e.next = 15;
                        break;
                    }
                    e.t3 = r, e.next = 16;
                    break;
                case 15:
                    e.t3 = !0;
                case 16:
                    if (!e.t3) {
                        e.next = 20;
                        break;
                    }
                    e.t4 = k, e.next = 26;
                    break;
                case 20:
                    if (e.t5 = k.contextElement, e.t5) {
                        e.next = 25;
                        break;
                    }
                    return e.next = 24, null == a.getDocumentElement ? void 0 : a.getDocumentElement(c.floating);
                case 24:
                    e.t5 = e.sent;
                case 25:
                    e.t4 = e.t5;
                case 26:
                    return e.t6 = e.t4, e.t7 = d, e.t8 = v, e.t9 = l, e.t10 = {
                        element: e.t6,
                        boundary: e.t7,
                        rootBoundary: e.t8,
                        strategy: e.t9
                    }, e.next = 33, e.t1.getClippingRect.call(e.t1, e.t10);
                case 33:
                    return e.t11 = e.sent, j = (0, e.t0)(e.t11), S = "floating" === m ? Ro(Ro({}, s.floating), {}, {
                        x: o,
                        y: i
                    }) : s.reference, e.next = 38, null == a.getOffsetParent ? void 0 : a.getOffsetParent(c.floating);
                case 38:
                    return C = e.sent, e.next = 41, null == a.isElement ? void 0 : a.isElement(C);
                case 41:
                    if (!e.sent) {
                        e.next = 50;
                        break;
                    }
                    return e.next = 44, null == a.getScale ? void 0 : a.getScale(C);
                case 44:
                    if (e.t13 = e.sent, e.t13) {
                        e.next = 47;
                        break;
                    }
                    e.t13 = {
                        x: 1,
                        y: 1
                    };
                case 47:
                    e.t12 = e.t13, e.next = 51;
                    break;
                case 50:
                    e.t12 = {
                        x: 1,
                        y: 1
                    };
                case 51:
                    if ($ = e.t12, e.t14 = rT, !a.convertOffsetParentRelativeRectToViewportRelativeRect) {
                        e.next = 59;
                        break;
                    }
                    return e.next = 56, a.convertOffsetParentRelativeRectToViewportRelativeRect({
                        rect: S,
                        offsetParent: C,
                        strategy: l
                    });
                case 56:
                    e.t15 = e.sent, e.next = 60;
                    break;
                case 59:
                    e.t15 = S;
                case 60:
                    return e.t16 = e.t15, _ = (0, e.t14)(e.t16), e.abrupt("return", {
                        top: (j.top - _.top + w.top) / $.y,
                        bottom: (_.bottom - j.bottom + w.bottom) / $.y,
                        left: (j.left - _.left + w.left) / $.x,
                        right: (_.right - j.right + w.right) / $.x
                    });
                case 63:
                case "end":
                    return e.stop();
            }
        }, e);
    })), sT.apply(this, arguments);
}
function cT(e, t) {
    return lT.apply(this, arguments);
}
function lT() {
    return lT = ko(wo().mark(function e(t, n) {
        var r, o, i, a, s, c, l, u, f, d, h, v, p, m;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return r = t.placement, o = t.platform, i = t.elements, e.next = 3, null == o.isRTL ? void 0 : o.isRTL(i.floating);
                case 3:
                    return a = e.sent, s = WP(r), c = UP(r), l = "y" === GP(r), u = [
                        "left",
                        "top"
                    ].includes(s) ? -1 : 1, f = a && l ? -1 : 1, d = HP(n, t), h = "number" == typeof d ? {
                        mainAxis: d,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : Ro({
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null
                    }, d), v = h.mainAxis, p = h.crossAxis, m = h.alignmentAxis, c && "number" == typeof m && (p = "end" === c ? -1 * m : m), e.abrupt("return", l ? {
                        x: p * f,
                        y: v * u
                    } : {
                        x: v * u,
                        y: p * f
                    });
                case 13:
                case "end":
                    return e.stop();
            }
        }, e);
    })), lT.apply(this, arguments);
}
function uT(e) {
    return hT(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fT(e) {
    var t;
    return (null == e || null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window;
}
function dT(e) {
    var t;
    return null == (t = (hT(e) ? e.ownerDocument : e.document) || window.document) ? void 0 : t.documentElement;
}
function hT(e) {
    return e instanceof Node || e instanceof fT(e).Node;
}
function vT(e) {
    return e instanceof Element || e instanceof fT(e).Element;
}
function pT(e) {
    return e instanceof HTMLElement || e instanceof fT(e).HTMLElement;
}
function mT(e) {
    return "undefined" != typeof ShadowRoot && (e instanceof ShadowRoot || e instanceof fT(e).ShadowRoot);
}
function gT(e) {
    var t = kT(e), n = t.overflow, r = t.overflowX, o = t.overflowY, i = t.display;
    return /auto|scroll|overlay|hidden|clip/.test(n + o + r) && ![
        "inline",
        "contents"
    ].includes(i);
}
function yT(e) {
    return [
        "table",
        "td",
        "th"
    ].includes(uT(e));
}
function bT(e) {
    var t = wT(), n = kT(e);
    return "none" !== n.transform || "none" !== n.perspective || !!n.containerType && "normal" !== n.containerType || !t && !!n.backdropFilter && "none" !== n.backdropFilter || !t && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective",
        "filter"
    ].some(function(e) {
        return (n.willChange || "").includes(e);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(e) {
        return (n.contain || "").includes(e);
    });
}
function wT() {
    return !("undefined" == typeof CSS || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function xT(e) {
    return [
        "html",
        "body",
        "#document"
    ].includes(uT(e));
}
function kT(e) {
    return fT(e).getComputedStyle(e);
}
function jT(e) {
    return vT(e) ? {
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop
    } : {
        scrollLeft: e.pageXOffset,
        scrollTop: e.pageYOffset
    };
}
function ST(e) {
    if ("html" === uT(e)) return e;
    var t = e.assignedSlot || e.parentNode || mT(e) && e.host || dT(e);
    return mT(t) ? t.host : t;
}
function CT(e) {
    var t = ST(e);
    return xT(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pT(t) && gT(t) ? t : CT(t);
}
function $T(e, t, n) {
    var r;
    void 0 === t && (t = []), void 0 === n && (n = !0);
    var o = CT(e), i = o === (null == (r = e.ownerDocument) ? void 0 : r.body), a = fT(o);
    return i ? t.concat(a, a.visualViewport || [], gT(o) ? o : [], a.frameElement && n ? $T(a.frameElement) : []) : t.concat(o, $T(o, [], n));
}
function _T(e) {
    var t = kT(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, o = pT(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = zP(n) !== i || zP(r) !== a;
    return s && (n = i, r = a), {
        width: n,
        height: r,
        $: s
    };
}
function OT(e) {
    return vT(e) ? e : e.contextElement;
}
function MT(e) {
    var t = OT(e);
    if (!pT(t)) return BP(1);
    var n = t.getBoundingClientRect(), r = _T(t), o = r.width, i = r.height, a = r.$, s = (a ? zP(n.width) : n.width) / o, c = (a ? zP(n.height) : n.height) / i;
    return s && Number.isFinite(s) || (s = 1), c && Number.isFinite(c) || (c = 1), {
        x: s,
        y: c
    };
}
var ET = BP(0);
function AT(e) {
    var t = fT(e);
    return wT() && t.visualViewport ? {
        x: t.visualViewport.offsetLeft,
        y: t.visualViewport.offsetTop
    } : ET;
}
function PT(e, t, n, r) {
    void 0 === t && (t = !1), void 0 === n && (n = !1);
    var o = e.getBoundingClientRect(), i = OT(e), a = BP(1);
    t && (r ? vT(r) && (a = MT(r)) : a = MT(e));
    var s = function(e, t, n) {
        return void 0 === t && (t = !1), !(!n || t && n !== fT(e)) && t;
    }(i, n, r) ? AT(i) : BP(0), c = (o.left + s.x) / a.x, l = (o.top + s.y) / a.y, u = o.width / a.x, f = o.height / a.y;
    if (i) for(var d = fT(i), h = r && vT(r) ? fT(r) : r, v = d.frameElement; v && r && h !== d;){
        var p = MT(v), m = v.getBoundingClientRect(), g = kT(v), y = m.left + (v.clientLeft + parseFloat(g.paddingLeft)) * p.x, b = m.top + (v.clientTop + parseFloat(g.paddingTop)) * p.y;
        c *= p.x, l *= p.y, u *= p.x, f *= p.y, c += y, l += b, v = fT(v).frameElement;
    }
    return rT({
        width: u,
        height: f,
        x: c,
        y: l
    });
}
function TT(e) {
    return PT(dT(e)).left + jT(e).scrollLeft;
}
function RT(e, t, n) {
    var r;
    if ("viewport" === t) r = function(e, t) {
        var n = fT(e), r = dT(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
        if (o) {
            i = o.width, a = o.height;
            var l = wT();
            (!l || l && "fixed" === t) && (s = o.offsetLeft, c = o.offsetTop);
        }
        return {
            width: i,
            height: a,
            x: s,
            y: c
        };
    }(e, n);
    else if ("document" === t) r = function(e) {
        var t = dT(e), n = jT(e), r = e.ownerDocument.body, o = DP(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = DP(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), a = -n.scrollLeft + TT(e), s = -n.scrollTop;
        return "rtl" === kT(r).direction && (a += DP(t.clientWidth, r.clientWidth) - o), {
            width: o,
            height: i,
            x: a,
            y: s
        };
    }(dT(e));
    else if (vT(t)) r = function(e, t) {
        var n = PT(e, !0, "fixed" === t), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = pT(e) ? MT(e) : BP(1);
        return {
            width: e.clientWidth * i.x,
            height: e.clientHeight * i.y,
            x: o * i.x,
            y: r * i.y
        };
    }(t, n);
    else {
        var o = AT(e);
        r = Ro(Ro({}, t), {}, {
            x: t.x - o.x,
            y: t.y - o.y
        });
    }
    return rT(r);
}
function NT(e, t) {
    var n = ST(e);
    return !(n === t || !vT(n) || xT(n)) && ("fixed" === kT(n).position || NT(n, t));
}
function IT(e, t, n) {
    var r = pT(t), o = dT(t), i = "fixed" === n, a = PT(e, !0, i, t), s = {
        scrollLeft: 0,
        scrollTop: 0
    }, c = BP(0);
    if (r || !r && !i) {
        if (("body" !== uT(t) || gT(o)) && (s = jT(t)), r) {
            var l = PT(t, !0, i, t);
            c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
        } else o && (c.x = TT(o));
    }
    return {
        x: a.left + s.scrollLeft - c.x,
        y: a.top + s.scrollTop - c.y,
        width: a.width,
        height: a.height
    };
}
function DT(e, t) {
    return pT(e) && "fixed" !== kT(e).position ? t ? t(e) : e.offsetParent : null;
}
function zT(e, t) {
    var n = fT(e);
    if (!pT(e)) return n;
    for(var r = DT(e, t); r && yT(r) && "static" === kT(r).position;)r = DT(r, t);
    return r && ("html" === uT(r) || "body" === uT(r) && "static" === kT(r).position && !bT(r)) ? n : r || function(e) {
        for(var t = ST(e); pT(t) && !xT(t);){
            if (bT(t)) return t;
            t = ST(t);
        }
        return null;
    }(e) || n;
}
var qT = {
    convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
        var t = e.rect, n = e.offsetParent, r = e.strategy, o = pT(n), i = dT(n);
        if (n === i) return t;
        var a = {
            scrollLeft: 0,
            scrollTop: 0
        }, s = BP(1), c = BP(0);
        if ((o || !o && "fixed" !== r) && (("body" !== uT(n) || gT(i)) && (a = jT(n)), pT(n))) {
            var l = PT(n);
            s = MT(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
        }
        return {
            width: t.width * s.x,
            height: t.height * s.y,
            x: t.x * s.x - a.scrollLeft * s.x + c.x,
            y: t.y * s.y - a.scrollTop * s.y + c.y
        };
    },
    getDocumentElement: dT,
    getClippingRect: function(e) {
        var t = e.element, n = e.boundary, r = e.rootBoundary, o = e.strategy, i = "clippingAncestors" === n ? function(e, t) {
            var n = t.get(e);
            if (n) return n;
            for(var r = $T(e, [], !1).filter(function(e) {
                return vT(e) && "body" !== uT(e);
            }), o = null, i = "fixed" === kT(e).position, a = i ? ST(e) : e; vT(a) && !xT(a);){
                var s = kT(a), c = bT(a);
                c || "fixed" !== s.position || (o = null), (i ? !c && !o : !c && "static" === s.position && o && [
                    "absolute",
                    "fixed"
                ].includes(o.position) || gT(a) && !c && NT(e, a)) ? r = r.filter(function(e) {
                    return e !== a;
                }) : o = s, a = ST(a);
            }
            return t.set(e, r), r;
        }(t, this._c) : [].concat(n), a = [].concat(Bo(i), [
            r
        ]), s = a[0], c = a.reduce(function(e, n) {
            var r = RT(t, n, o);
            return e.top = DP(r.top, e.top), e.right = IP(r.right, e.right), e.bottom = IP(r.bottom, e.bottom), e.left = DP(r.left, e.left), e;
        }, RT(t, s, o));
        return {
            width: c.right - c.left,
            height: c.bottom - c.top,
            x: c.left,
            y: c.top
        };
    },
    getOffsetParent: zT,
    getElementRects: function() {
        var e = ko(wo().mark(function e(t) {
            var n, r, o, i, a;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return n = t.reference, r = t.floating, o = t.strategy, i = this.getOffsetParent || zT, a = this.getDimensions, e.t0 = IT, e.t1 = n, e.next = 7, i(r);
                    case 7:
                        return e.t2 = e.sent, e.t3 = o, e.t4 = (0, e.t0)(e.t1, e.t2, e.t3), e.t5 = Ro, e.t6 = {
                            x: 0,
                            y: 0
                        }, e.next = 14, a(r);
                    case 14:
                        return e.t7 = e.sent, e.t8 = (0, e.t5)(e.t6, e.t7), e.abrupt("return", {
                            reference: e.t4,
                            floating: e.t8
                        });
                    case 17:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        }));
        return function(t) {
            return e.apply(this, arguments);
        };
    }(),
    getClientRects: function(e) {
        return Array.from(e.getClientRects());
    },
    getDimensions: function(e) {
        var t = _T(e);
        return {
            width: t.width,
            height: t.height
        };
    },
    getScale: MT,
    isElement: vT,
    isRTL: function(e) {
        return "rtl" === kT(e).direction;
    }
};
function BT(e, t, n, r) {
    void 0 === r && (r = {});
    var o = r, i = o.ancestorScroll, a = void 0 === i || i, s = o.ancestorResize, c = void 0 === s || s, l = o.elementResize, u = void 0 === l ? "function" == typeof ResizeObserver : l, f = o.layoutShift, d = void 0 === f ? "function" == typeof IntersectionObserver : f, h = o.animationFrame, v = void 0 !== h && h, p = OT(e), m = a || c ? [].concat(Bo(p ? $T(p) : []), Bo($T(t))) : [];
    m.forEach(function(e) {
        a && e.addEventListener("scroll", n, {
            passive: !0
        }), c && e.addEventListener("resize", n);
    });
    var g, y = p && d ? function(e, t) {
        var n, r = null, o = dT(e);
        function i() {
            clearTimeout(n), r && r.disconnect(), r = null;
        }
        return function a(s, c) {
            void 0 === s && (s = !1), void 0 === c && (c = 1), i();
            var l = e.getBoundingClientRect(), u = l.left, f = l.top, d = l.width, h = l.height;
            if (s || t(), d && h) {
                var v = {
                    rootMargin: -qP(f) + "px " + -qP(o.clientWidth - (u + d)) + "px " + -qP(o.clientHeight - (f + h)) + "px " + -qP(u) + "px",
                    threshold: DP(0, IP(1, c)) || 1
                }, p = !0;
                try {
                    r = new IntersectionObserver(m, Ro(Ro({}, v), {}, {
                        root: o.ownerDocument
                    }));
                } catch (e) {
                    r = new IntersectionObserver(m, v);
                }
                r.observe(e);
            }
            function m(e) {
                var t = e[0].intersectionRatio;
                if (t !== c) {
                    if (!p) return a();
                    t ? a(!1, t) : n = setTimeout(function() {
                        a(!1, 1e-7);
                    }, 100);
                }
                p = !1;
            }
        }(!0), i;
    }(p, n) : null, b = -1, w = null;
    u && (w = new ResizeObserver(function(e) {
        var r = jo(e, 1)[0];
        r && r.target === p && w && (w.unobserve(t), cancelAnimationFrame(b), b = requestAnimationFrame(function() {
            w && w.observe(t);
        })), n();
    }), p && !v && w.observe(p), w.observe(t));
    var x = v ? PT(e) : null;
    return v && function t() {
        var r = PT(e);
        !x || r.x === x.x && r.y === x.y && r.width === x.width && r.height === x.height || n();
        x = r, g = requestAnimationFrame(t);
    }(), n(), function() {
        m.forEach(function(e) {
            a && e.removeEventListener("scroll", n), c && e.removeEventListener("resize", n);
        }), y && y(), w && w.disconnect(), w = null, v && cancelAnimationFrame(g);
    };
}
var LT = function(e) {
    return void 0 === e && (e = {}), {
        name: "shift",
        options: e,
        fn: function(t) {
            return ko(wo().mark(function n() {
                var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $;
                return wo().wrap(function(n) {
                    for(;;)switch(n.prev = n.next){
                        case 0:
                            return r = t.x, o = t.y, i = t.placement, a = HP(e, t), s = a.mainAxis, c = void 0 === s || s, l = a.crossAxis, u = void 0 !== l && l, f = a.limiter, d = void 0 === f ? {
                                fn: function(e) {
                                    return {
                                        x: e.x,
                                        y: e.y
                                    };
                                }
                            } : f, h = yo(a, po), v = {
                                x: r,
                                y: o
                            }, n.next = 5, aT(t, h);
                        case 5:
                            return p = n.sent, m = GP(WP(i)), g = JP(m), y = v[g], b = v[m], c && (w = "y" === g ? "bottom" : "right", x = y + p["y" === g ? "top" : "left"], k = y - p[w], y = VP(x, y, k)), u && (j = "y" === m ? "bottom" : "right", S = b + p["y" === m ? "top" : "left"], C = b - p[j], b = VP(S, b, C)), $ = d.fn(Ro(Ro({}, t), {}, zo(zo({}, g, y), m, b))), n.abrupt("return", Ro(Ro({}, $), {}, {
                                data: {
                                    x: $.x - r,
                                    y: $.y - o
                                }
                            }));
                        case 14:
                        case "end":
                            return n.stop();
                    }
                }, n);
            }))();
        }
    };
}, FT = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        fn: function(t) {
            return ko(wo().mark(function n() {
                var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M, E, A, P, T, R, N, I, D, z, q;
                return wo().wrap(function(n) {
                    for(;;)switch(n.prev = n.next){
                        case 0:
                            if (i = t.placement, a = t.middlewareData, s = t.rects, c = t.initialPlacement, l = t.platform, u = t.elements, f = HP(e, t), d = f.mainAxis, h = void 0 === d || d, v = f.crossAxis, p = void 0 === v || v, m = f.fallbackPlacements, g = f.fallbackStrategy, y = void 0 === g ? "bestFit" : g, b = f.fallbackAxisSideDirection, w = void 0 === b ? "none" : b, x = f.flipAlignment, k = void 0 === x || x, j = yo(f, vo), null == (r = a.arrow) || !r.alignmentOffset) {
                                n.next = 4;
                                break;
                            }
                            return n.abrupt("return", {});
                        case 4:
                            return S = WP(i), C = WP(c) === c, n.next = 8, null == l.isRTL ? void 0 : l.isRTL(u.floating);
                        case 8:
                            return $ = n.sent, _ = m || (C || !k ? [
                                tT(c)
                            ] : XP(c)), m || "none" === w || _.push.apply(_, Bo(eT(c, k, w, $))), O = [
                                c
                            ].concat(Bo(_)), n.next = 14, aT(t, j);
                        case 14:
                            if (M = n.sent, E = [], A = (null == (o = a.flip) ? void 0 : o.overflows) || [], h && E.push(M[S]), p && (P = YP(i, s, $), E.push(M[P[0]], M[P[1]])), A = [].concat(Bo(A), [
                                {
                                    placement: i,
                                    overflows: E
                                }
                            ]), E.every(function(e) {
                                return e <= 0;
                            })) {
                                n.next = 37;
                                break;
                            }
                            if (N = ((null == (T = a.flip) ? void 0 : T.index) || 0) + 1, !(I = O[N])) {
                                n.next = 25;
                                break;
                            }
                            return n.abrupt("return", {
                                data: {
                                    index: N,
                                    overflows: A
                                },
                                reset: {
                                    placement: I
                                }
                            });
                        case 25:
                            if (D = null == (R = A.filter(function(e) {
                                return e.overflows[0] <= 0;
                            }).sort(function(e, t) {
                                return e.overflows[1] - t.overflows[1];
                            })[0]) ? void 0 : R.placement) {
                                n.next = 35;
                                break;
                            }
                            n.t0 = y, n.next = "bestFit" === n.t0 ? 30 : "initialPlacement" === n.t0 ? 33 : 35;
                            break;
                        case 30:
                            return q = null == (z = A.map(function(e) {
                                return [
                                    e.placement,
                                    e.overflows.filter(function(e) {
                                        return e > 0;
                                    }).reduce(function(e, t) {
                                        return e + t;
                                    }, 0)
                                ];
                            }).sort(function(e, t) {
                                return e[1] - t[1];
                            })[0]) ? void 0 : z[0], q && (D = q), n.abrupt("break", 35);
                        case 33:
                            return D = c, n.abrupt("break", 35);
                        case 35:
                            if (i === D) {
                                n.next = 37;
                                break;
                            }
                            return n.abrupt("return", {
                                reset: {
                                    placement: D
                                }
                            });
                        case 37:
                            return n.abrupt("return", {});
                        case 38:
                        case "end":
                            return n.stop();
                    }
                }, n);
            }))();
        }
    };
}, VT = function(e, t, n) {
    var r = new Map, o = Ro({
        platform: qT
    }, n), i = Ro(Ro({}, o.platform), {}, {
        _c: r
    });
    return iT(e, t, Ro(Ro({}, o), {}, {
        platform: i
    }));
};
function HT(e) {
    var t = e.loadOptions, n = e.filterText, r = e.items, o = e.multiple, i = e.value, a = e.itemId, s = e.groupBy, c = e.filterSelectedItems, l = e.itemFilter, u = e.convertStringItemsToObjects, f = e.filterGroupedItems, d = e.label;
    if (r && t) return r;
    if (!r) return [];
    r && r.length > 0 && "object" !== Ho(r[0]) && (r = u(r));
    var h = r.filter(function(e) {
        var t = l(e[d], n, e);
        return t && o && null != i && i.length && (t = !i.some(function(t) {
            return !!c && t[a] === e[a];
        })), t;
    });
    return s && (h = f(h)), h;
}
function WT(e) {
    return UT.apply(this, arguments);
}
function UT() {
    return UT = ko(wo().mark(function e(t) {
        var n, r, o, i, a;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    return n = t.dispatch, r = t.loadOptions, o = t.convertStringItemsToObjects, i = t.filterText, e.next = 3, r(i).catch(function(e) {
                        console.warn("svelte-select loadOptions error :>> ", e), n("error", {
                            type: "loadOptions",
                            details: e
                        });
                    });
                case 3:
                    if (!(a = e.sent) || a.cancelled) {
                        e.next = 7;
                        break;
                    }
                    return a ? (a && a.length > 0 && "object" !== Ho(a[0]) && (a = o(a)), n("loaded", {
                        items: a
                    })) : a = [], e.abrupt("return", {
                        filteredItems: a,
                        loading: !1,
                        focused: !0,
                        listOpen: !0
                    });
                case 7:
                case "end":
                    return e.stop();
            }
        }, e);
    })), UT.apply(this, arguments);
}
function JT(e) {
    mi(e, "svelte-qbd276", "svg.svelte-qbd276{width:var(--chevron-icon-width, 20px);height:var(--chevron-icon-width, 20px);color:var(--chevron-icon-colour, currentColor)}");
}
function KT(e) {
    var t, n;
    return {
        c: function() {
            t = Si("svg"), Ai(n = Si("path"), "fill", "currentColor"), Ai(n, "d", "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747\n          3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0\n          1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502\n          0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0\n          0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"), Ai(t, "width", "100%"), Ai(t, "height", "100%"), Ai(t, "viewBox", "0 0 20 20"), Ai(t, "focusable", "false"), Ai(t, "aria-hidden", "true"), Ai(t, "class", "svelte-qbd276");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
var GT = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, null, KT, Xo, {}, JT), n;
    }
    return Ao(t, Ia), Do(t);
}();
function QT(e) {
    mi(e, "svelte-whdbu1", "svg.svelte-whdbu1{width:var(--clear-icon-width, 20px);height:var(--clear-icon-width, 20px);color:var(--clear-icon-color, currentColor)}");
}
function YT(e) {
    var t, n;
    return {
        c: function() {
            t = Si("svg"), Ai(n = Si("path"), "fill", "currentColor"), Ai(n, "d", "M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124\n    l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z"), Ai(t, "width", "100%"), Ai(t, "height", "100%"), Ai(t, "viewBox", "-2 -2 50 50"), Ai(t, "focusable", "false"), Ai(t, "aria-hidden", "true"), Ai(t, "role", "presentation"), Ai(t, "class", "svelte-whdbu1");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
var XT = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, null, YT, Xo, {}, QT), n;
    }
    return Ao(t, Ia), Do(t);
}();
function ZT(e) {
    mi(e, "svelte-1p3nqvd", ".loading.svelte-1p3nqvd{width:var(--spinner-width, 20px);height:var(--spinner-height, 20px);color:var(--spinner-color, var(--icons-color));animation:svelte-1p3nqvd-rotate 0.75s linear infinite;transform-origin:center center;transform:none}.circle_path.svelte-1p3nqvd{stroke-dasharray:90;stroke-linecap:round}@keyframes svelte-1p3nqvd-rotate{100%{transform:rotate(360deg)}}");
}
function eR(e) {
    var t, n;
    return {
        c: function() {
            t = Si("svg"), Ai(n = Si("circle"), "class", "circle_path svelte-1p3nqvd"), Ai(n, "cx", "50"), Ai(n, "cy", "50"), Ai(n, "r", "20"), Ai(n, "fill", "none"), Ai(n, "stroke", "currentColor"), Ai(n, "stroke-width", "5"), Ai(n, "stroke-miterlimit", "10"), Ai(t, "class", "loading svelte-1p3nqvd"), Ai(t, "viewBox", "25 25 50 50");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
var tR = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, null, eR, Xo, {}, ZT), n;
    }
    return Ao(t, Ia), Do(t);
}();
function nR(e) {
    mi(e, "svelte-82qwg8", ".svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{--borderRadius:var(--border-radius);--clearSelectColor:var(--clear-select-color);--clearSelectWidth:var(--clear-select-width);--disabledBackground:var(--disabled-background);--disabledBorderColor:var(--disabled-border-color);--disabledColor:var(--disabled-color);--disabledPlaceholderColor:var(--disabled-placeholder-color);--disabledPlaceholderOpacity:var(--disabled-placeholder-opacity);--errorBackground:var(--error-background);--errorBorder:var(--error-border);--groupItemPaddingLeft:var(--group-item-padding-left);--groupTitleColor:var(--group-title-color);--groupTitleFontSize:var(--group-title-font-size);--groupTitleFontWeight:var(--group-title-font-weight);--groupTitlePadding:var(--group-title-padding);--groupTitleTextTransform:var(--group-title-text-transform);--groupTitleBorderColor:var(--group-title-border-color);--groupTitleBorderWidth:var(--group-title-border-width);--groupTitleBorderStyle:var(--group-title-border-style);--indicatorColor:var(--chevron-color);--indicatorHeight:var(--chevron-height);--indicatorWidth:var(--chevron-width);--inputColor:var(--input-color);--inputLeft:var(--input-left);--inputLetterSpacing:var(--input-letter-spacing);--inputMargin:var(--input-margin);--inputPadding:var(--input-padding);--itemActiveBackground:var(--item-active-background);--itemColor:var(--item-color);--itemFirstBorderRadius:var(--item-first-border-radius);--itemHoverBG:var(--item-hover-bg);--itemHoverColor:var(--item-hover-color);--itemIsActiveBG:var(--item-is-active-bg);--itemIsActiveColor:var(--item-is-active-color);--itemIsNotSelectableColor:var(--item-is-not-selectable-color);--itemPadding:var(--item-padding);--listBackground:var(--list-background);--listBorder:var(--list-border);--listBorderRadius:var(--list-border-radius);--listEmptyColor:var(--list-empty-color);--listEmptyPadding:var(--list-empty-padding);--listEmptyTextAlign:var(--list-empty-text-align);--listMaxHeight:var(--list-max-height);--listPosition:var(--list-position);--listShadow:var(--list-shadow);--listZIndex:var(--list-z-index);--multiItemBG:var(--multi-item-bg);--multiItemBorderRadius:var(--multi-item-border-radius);--multiItemDisabledHoverBg:var(--multi-item-disabled-hover-bg);--multiItemDisabledHoverColor:var(--multi-item-disabled-hover-color);--multiItemHeight:var(--multi-item-height);--multiItemMargin:var(--multi-item-margin);--multiItemPadding:var(--multi-item-padding);--multiSelectInputMargin:var(--multi-select-input-margin);--multiSelectInputPadding:var(--multi-select-input-padding);--multiSelectPadding:var(--multi-select-padding);--placeholderColor:var(--placeholder-color);--placeholderOpacity:var(--placeholder-opacity);--selectedItemPadding:var(--selected-item-padding);--spinnerColor:var(--spinner-color);--spinnerHeight:var(--spinner-height);--spinnerWidth:var(--spinner-width);--internal-padding:0 0 0 16px;border:var(--border, 1px solid #d8dbdf);border-radius:var(--border-radius, 6px);min-height:var(--height, 42px);position:relative;display:flex;align-items:stretch;padding:var(--padding, var(--internal-padding));background:var(--background, #fff);margin:var(--margin, 0);width:var(--width, 100%);font-size:var(--font-size, 16px);max-height:var(--max-height)}.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-sizing:var(--box-sizing, border-box)}.svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{border:var(--border-hover, 1px solid #b2b8bf)}.value-container.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex:1 1 0%;flex-wrap:wrap;align-items:center;gap:5px 10px;padding:var(--value-container-padding, 5px 0);position:relative;overflow:var(--value-container-overflow, hidden);align-self:stretch}.prepend.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex-shrink:0;align-items:center}.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:var(--indicators-position);top:var(--indicators-top);right:var(--indicators-right);bottom:var(--indicators-bottom)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:absolute;cursor:default;border:none;color:var(--input-color, var(--item-color));padding:var(--input-padding, 0);letter-spacing:var(--input-letter-spacing, inherit);margin:var(--input-margin, 0);min-width:10px;top:0;right:0;bottom:0;left:0;background:transparent;font-size:var(--font-size, 16px)}.svelte-82qwg8:not(.multi)>.value-container.svelte-82qwg8>input.svelte-82qwg8{width:100%;height:100%}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--placeholder-color, #78848f);opacity:var(--placeholder-opacity, 1)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.svelte-select.focused.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--border-focused, 1px solid #006fe8);border-radius:var(--border-radius-focused, var(--border-radius, 6px))}.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--disabled-background, #ebedef);border-color:var(--disabled-border-color, #ebedef);color:var(--disabled-color, #c1c6cc)}.disabled.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--disabled-placeholder-color, #c1c6cc);opacity:var(--disabled-placeholder-opacity, 1)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:relative;overflow:var(--selected-item-overflow, hidden);padding:var(--selected-item-padding, 0 20px 0 0);text-overflow:ellipsis;white-space:nowrap;color:var(--selected-item-color, inherit);font-size:var(--font-size, 16px)}.multi.svelte-82qwg8 .selected-item.svelte-82qwg8.svelte-82qwg8{position:absolute;line-height:var(--height, 42px);height:var(--height, 42px)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.hide-selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0}.icon.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{all:unset;display:flex;align-items:center;justify-content:center;width:var(--clear-select-width, 40px);height:var(--clear-select-height, 100%);color:var(--clear-select-color, var(--icons-color));margin:var(--clear-select-margin, 0);pointer-events:all;flex-shrink:0}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:var(--clear-select-focus-outline, 1px solid #006fe8)}.loading.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--loading-width, 40px);height:var(--loading-height);color:var(--loading-color, var(--icons-color));margin:var(--loading--margin, 0);flex-shrink:0}.chevron.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--chevron-width, 40px);height:var(--chevron-height, 40px);background:var(--chevron-background, transparent);pointer-events:var(--chevron-pointer-events, none);color:var(--chevron-color, var(--icons-color));border:var(--chevron-border, 0 0 0 1px solid #d8dbdf);flex-shrink:0}.multi.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-padding, var(--internal-padding))}.multi.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-input-padding, 0);position:relative;margin:var(--multi-select-input-margin, 5px 0);flex:1 1 40px}.svelte-select.error.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--error-border, 1px solid #ff2d55);background:var(--error-background, #fff)}.a11y-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{z-index:9999;border:0px;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0px;white-space:nowrap}.multi-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--multi-item-bg, #ebedef);margin:var(--multi-item-margin, 0);outline:var(--multi-item-outline, 1px solid #ddd);border-radius:var(--multi-item-border-radius, 4px);height:var(--multi-item-height, 25px);line-height:var(--multi-item-height, 25px);display:flex;cursor:default;padding:var(--multi-item-padding, 0 5px);overflow:hidden;gap:var(--multi-item-gap, 4px);outline-offset:-1px;max-width:var(--multi-max-width, none);color:var(--multi-item-color, var(--item-color))}.multi-item.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{background:var(--multi-item-disabled-hover-bg, #ebedef);color:var(--multi-item-disabled-hover-color, #c1c6cc)}.multi-item-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multi-item-clear.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center;--clear-icon-color:var(--multi-item-clear-icon-color, #000)}.multi-item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{outline:var(--multi-item-active-outline, 1px solid #006fe8)}.svelte-select-list.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-shadow:var(--list-shadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));border-radius:var(--list-border-radius, 4px);max-height:var(--list-max-height, 252px);overflow-y:auto;background:var(--list-background, #fff);position:var(--list-position, absolute);z-index:var(--list-z-index, 2);border:var(--list-border)}.prefloat.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;pointer-events:none}.list-group-title.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{color:var(--group-title-color, #8f8f8f);cursor:default;font-size:var(--group-title-font-size, 16px);font-weight:var(--group-title-font-weight, 600);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--group-title-padding, 0 20px);text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;text-transform:var(--group-title-text-transform, uppercase);border-width:var(--group-title-border-width, medium);border-style:var(--group-title-border-style, none);border-color:var(--group-title-border-color, color)}.empty.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{text-align:var(--list-empty-text-align, center);padding:var(--list-empty-padding, 20px 0);color:var(--list-empty-color, #78848f)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{cursor:default;height:var(--item-height, var(--height, 42px));line-height:var(--item-line-height, var(--height, 42px));padding:var(--item-padding, 0 20px);color:var(--item-color, inherit);text-overflow:ellipsis;overflow:hidden;white-space:nowrap;transition:var(--item-transition, all 0.2s);align-items:center;width:100%}.item.group-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding-left:var(--group-item-padding-left, 40px)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{background:var(--item-active-background, #b9daff)}.item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--item-is-active-bg, #007aff);color:var(--item-is-active-color, #fff)}.item.first.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border-radius:var(--item-first-border-radius, 4px 4px 0 0)}.item.hover.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:not(.active){background:var(--item-hover-bg, #e7f2ff);color:var(--item-hover-color, inherit)}.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.hover.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.active.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{color:var(--item-is-not-selectable-color, #999);background:transparent}.required.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;z-index:-1;position:absolute;top:0;left:0;bottom:0;right:0}");
}
var rR = function(e) {
    return {
        value: 8 & e[0]
    };
}, oR = function(e) {
    return {
        value: e[3]
    };
}, iR = function(e) {
    return {
        value: 8 & e[0]
    };
}, aR = function(e) {
    return {
        value: e[3]
    };
}, sR = function(e) {
    return {
        listOpen: 64 & e[0]
    };
}, cR = function(e) {
    return {
        listOpen: e[6]
    };
}, lR = function(e) {
    return {};
}, uR = function(e) {
    return {};
}, fR = function(e) {
    return {};
}, dR = function(e) {
    return {};
}, hR = function(e) {
    return {
        selection: 8 & e[0]
    };
}, vR = function(e) {
    return {
        selection: e[3]
    };
};
function pR(e, t, n) {
    var r = e.slice();
    return r[126] = t[n], r[128] = n, r;
}
var mR = function(e) {
    return {};
}, gR = function(e) {
    return {};
}, yR = function(e) {
    return {
        selection: 8 & e[0]
    };
}, bR = function(e) {
    return {
        selection: e[126],
        index: e[128]
    };
}, wR = function(e) {
    return {};
}, xR = function(e) {
    return {};
}, kR = function(e) {
    return {};
}, jR = function(e) {
    return {};
}, SR = function(e) {
    return {};
}, CR = function(e) {
    return {};
};
function $R(e, t, n) {
    var r = e.slice();
    return r[126] = t[n], r[128] = n, r;
}
var _R = function(e) {
    return {
        item: 16777216 & e[0]
    };
}, OR = function(e) {
    return {
        item: e[126],
        index: e[128]
    };
}, MR = function(e) {
    return {
        filteredItems: 16777216 & e[0]
    };
}, ER = function(e) {
    return {
        filteredItems: e[24]
    };
}, AR = function(e) {
    return {};
}, PR = function(e) {
    return {};
};
function TR(e) {
    var t, n, r, o, i, a, s, c, l = e[50]["list-prepend"] && RR(e), u = [
        DR,
        IR,
        NR
    ], f = [];
    function d(e, t) {
        return e[50].list ? 0 : e[24].length > 0 ? 1 : e[19] ? -1 : 2;
    }
    ~(r = d(e)) && (o = f[r] = u[r](e));
    var h = e[50]["list-append"] && qR(e);
    return {
        c: function() {
            t = ji("div"), l && l.c(), n = $i(), o && o.c(), i = $i(), h && h.c(), Ai(t, "class", "svelte-select-list svelte-82qwg8"), Ai(t, "role", "none"), qi(t, "prefloat", e[28]);
        },
        m: function(o, u) {
            wi(o, t, u), l && l.m(t, null), pi(t, n), ~r && f[r].m(t, null), pi(t, i), h && h.m(t, null), e[91](t), a = !0, s || (c = [
                ci(e[49].call(null, t)),
                Oi(t, "scroll", e[41]),
                Oi(t, "pointerup", Ei(Mi(e[85]))),
                Oi(t, "mousedown", Ei(Mi(e[86])))
            ], s = !0);
        },
        p: function(e, s) {
            e[50]["list-prepend"] ? l ? (l.p(e, s), 524288 & s[1] && xa(l, 1)) : ((l = RR(e)).c(), xa(l, 1), l.m(t, n)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa());
            var c = r;
            (r = d(e)) === c ? ~r && f[r].p(e, s) : (o && (ba(), ka(f[c], 1, 1, function() {
                f[c] = null;
            }), wa()), ~r ? ((o = f[r]) ? o.p(e, s) : (o = f[r] = u[r](e)).c(), xa(o, 1), o.m(t, i)) : o = null), e[50]["list-append"] ? h ? (h.p(e, s), 524288 & s[1] && xa(h, 1)) : ((h = qR(e)).c(), xa(h, 1), h.m(t, null)) : h && (ba(), ka(h, 1, 1, function() {
                h = null;
            }), wa()), (!a || 268435456 & s[0]) && qi(t, "prefloat", e[28]);
        },
        i: function(e) {
            a || (xa(l), xa(o), xa(h), a = !0);
        },
        o: function(e) {
            ka(l), ka(o), ka(h), a = !1;
        },
        d: function(n) {
            n && xi(t), l && l.d(), ~r && f[r].d(), h && h.d(), e[91](null), s = !1, Qo(c);
        }
    };
}
function RR(e) {
    var t, n = e[83]["list-prepend"], r = ei(n, e, e[82], PR);
    return {
        c: function() {
            r && r.c();
        },
        m: function(e, n) {
            r && r.m(e, n), t = !0;
        },
        p: function(e, o) {
            r && r.p && (!t || 1048576 & o[2]) && ri(r, n, e, e[82], t ? ni(n, e[82], o, AR) : oi(e[82]), PR);
        },
        i: function(e) {
            t || (xa(r, e), t = !0);
        },
        o: function(e) {
            ka(r, e), t = !1;
        },
        d: function(e) {
            r && r.d(e);
        }
    };
}
function NR(e) {
    var t, n, r = e[83].empty, o = ei(r, e, e[82], CR), i = o || {
        c: function() {
            (n = ji("div")).textContent = "No options", Ai(n, "class", "empty svelte-82qwg8");
        },
        m: function(e, t) {
            wi(e, n, t);
        },
        p: Wo,
        d: function(e) {
            e && xi(n);
        }
    };
    return {
        c: function() {
            i && i.c();
        },
        m: function(e, n) {
            i && i.m(e, n), t = !0;
        },
        p: function(e, n) {
            o && o.p && (!t || 1048576 & n[2]) && ri(o, r, e, e[82], t ? ni(r, e[82], n, SR) : oi(e[82]), CR);
        },
        i: function(e) {
            t || (xa(i, e), t = !0);
        },
        o: function(e) {
            ka(i, e), t = !1;
        },
        d: function(e) {
            i && i.d(e);
        }
    };
}
function IR(e) {
    for(var t, n, r = Ca(e[24]), o = [], i = 0; i < r.length; i += 1)o[i] = zR($R(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = _i();
        },
        m: function(e, r) {
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(e, r);
            wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            if (1627402376 & n[0] | 28672 & n[1] | 1048576 & n[2]) {
                var i;
                for(r = Ca(e[24]), i = 0; i < r.length; i += 1){
                    var s = $R(e, r, i);
                    o[i] ? (o[i].p(s, n), xa(o[i], 1)) : (o[i] = zR(s), o[i].c(), xa(o[i], 1), o[i].m(t.parentNode, t));
                }
                for(ba(), i = r.length; i < o.length; i += 1)a(i);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function DR(e) {
    var t, n = e[83].list, r = ei(n, e, e[82], ER);
    return {
        c: function() {
            r && r.c();
        },
        m: function(e, n) {
            r && r.m(e, n), t = !0;
        },
        p: function(e, o) {
            r && r.p && (!t || 16777216 & o[0] | 1048576 & o[2]) && ri(r, n, e, e[82], t ? ni(n, e[82], o, MR) : oi(e[82]), ER);
        },
        i: function(e) {
            t || (xa(r, e), t = !0);
        },
        o: function(e) {
            ka(r, e), t = !1;
        },
        d: function(e) {
            r && r.d(e);
        }
    };
}
function zR(e) {
    var t, n, r, o, i, a, s, c, l = e[83].item, u = ei(l, e, e[82], OR), f = u || function(e) {
        var t, n, r = (null === (t = e[126]) || void 0 === t ? void 0 : t[e[12]]) + "";
        return {
            c: function() {
                n = Ci(r);
            },
            m: function(e, t) {
                wi(e, n, t);
            },
            p: function(e, t) {
                var o;
                16781312 & t[0] && r !== (r = (null === (o = e[126]) || void 0 === o ? void 0 : o[e[12]]) + "") && Ni(n, r);
            },
            d: function(e) {
                e && xi(n);
            }
        };
    }(e);
    function d() {
        return e[88](e[128]);
    }
    function h() {
        return e[89](e[128]);
    }
    function v() {
        return e[90](e[126], e[128]);
    }
    return {
        c: function() {
            var r;
            t = ji("div"), n = ji("div"), f && f.c(), i = $i(), Ai(n, "class", "item svelte-82qwg8"), qi(n, "list-group-title", e[126].groupHeader), qi(n, "active", e[45](e[126], e[3], e[13])), qi(n, "first", 0 === e[128]), qi(n, "hover", e[7] === e[128]), qi(n, "group-item", e[126].groupItem), qi(n, "not-selectable", !1 === (null === (r = e[126]) || void 0 === r ? void 0 : r.selectable)), Ai(t, "class", "list-item svelte-82qwg8"), Ai(t, "tabindex", "-1"), Ai(t, "role", "none");
        },
        m: function(l, u) {
            wi(l, t, u), pi(t, n), f && f.m(n, null), pi(t, i), a = !0, s || (c = [
                ci(r = e[46].call(null, n, {
                    scroll: e[45](e[126], e[3], e[13]),
                    listDom: e[30]
                })),
                ci(o = e[47].call(null, n, {
                    scroll: e[29] === e[128],
                    listDom: e[30]
                })),
                Oi(t, "mouseover", d),
                Oi(t, "focus", h),
                Oi(t, "click", Ei(v)),
                Oi(t, "keydown", Ei(Mi(e[87])))
            ], s = !0);
        },
        p: function(t, i) {
            var s;
            (e = t, u ? u.p && (!a || 16777216 & i[0] | 1048576 & i[2]) && ri(u, l, e, e[82], a ? ni(l, e[82], i, _R) : oi(e[82]), OR) : f && f.p && (!a || 16781312 & i[0]) && f.p(e, a ? i : [
                -1,
                -1,
                -1,
                -1,
                -1
            ]), r && Yo(r.update) && 1090527240 & i[0] && r.update.call(null, {
                scroll: e[45](e[126], e[3], e[13]),
                listDom: e[30]
            }), o && Yo(o.update) && 1610612736 & i[0] && o.update.call(null, {
                scroll: e[29] === e[128],
                listDom: e[30]
            }), (!a || 16777216 & i[0]) && qi(n, "list-group-title", e[126].groupHeader), (!a || 16785416 & i[0] | 16384 & i[1]) && qi(n, "active", e[45](e[126], e[3], e[13])), (!a || 128 & i[0]) && qi(n, "hover", e[7] === e[128]), (!a || 16777216 & i[0]) && qi(n, "group-item", e[126].groupItem), !a || 16777216 & i[0]) && qi(n, "not-selectable", !1 === (null === (s = e[126]) || void 0 === s ? void 0 : s.selectable));
        },
        i: function(e) {
            a || (xa(f, e), a = !0);
        },
        o: function(e) {
            ka(f, e), a = !1;
        },
        d: function(e) {
            e && xi(t), f && f.d(e), s = !1, Qo(c);
        }
    };
}
function qR(e) {
    var t, n = e[83]["list-append"], r = ei(n, e, e[82], jR);
    return {
        c: function() {
            r && r.c();
        },
        m: function(e, n) {
            r && r.m(e, n), t = !0;
        },
        p: function(e, o) {
            r && r.p && (!t || 1048576 & o[2]) && ri(r, n, e, e[82], t ? ni(n, e[82], o, kR) : oi(e[82]), jR);
        },
        i: function(e) {
            t || (xa(r, e), t = !0);
        },
        o: function(e) {
            ka(r, e), t = !1;
        },
        d: function(e) {
            r && r.d(e);
        }
    };
}
function BR(e) {
    var t, n, r, o, i;
    return {
        c: function() {
            t = ji("span"), n = Ci(e[32]), r = $i(), o = ji("span"), i = Ci(e[31]), Ai(t, "id", "aria-selection"), Ai(t, "class", "svelte-82qwg8"), Ai(o, "id", "aria-context"), Ai(o, "class", "svelte-82qwg8");
        },
        m: function(e, a) {
            wi(e, t, a), pi(t, n), wi(e, r, a), wi(e, o, a), pi(o, i);
        },
        p: function(e, t) {
            2 & t[1] && Ni(n, e[32]), 1 & t[1] && Ni(i, e[31]);
        },
        d: function(e) {
            e && (xi(t), xi(r), xi(o));
        }
    };
}
function LR(e) {
    var t, n, r, o, i = [
        VR,
        FR
    ], a = [];
    function s(e, t) {
        return e[9] ? 0 : 1;
    }
    return t = s(e), n = a[t] = i[t](e), {
        c: function() {
            n.c(), r = _i();
        },
        m: function(e, n) {
            a[t].m(e, n), wi(e, r, n), o = !0;
        },
        p: function(e, o) {
            var c = t;
            (t = s(e)) === c ? a[t].p(e, o) : (ba(), ka(a[c], 1, 1, function() {
                a[c] = null;
            }), wa(), (n = a[t]) ? n.p(e, o) : (n = a[t] = i[t](e)).c(), xa(n, 1), n.m(r.parentNode, r));
        },
        i: function(e) {
            o || (xa(n), o = !0);
        },
        o: function(e) {
            ka(n), o = !1;
        },
        d: function(e) {
            e && xi(r), a[t].d(e);
        }
    };
}
function FR(e) {
    var t, n, r = e[83].selection, o = ei(r, e, e[82], vR), i = o || function(e) {
        var t, n = e[3][e[12]] + "";
        return {
            c: function() {
                t = Ci(n);
            },
            m: function(e, n) {
                wi(e, t, n);
            },
            p: function(e, r) {
                4104 & r[0] && n !== (n = e[3][e[12]] + "") && Ni(t, n);
            },
            d: function(e) {
                e && xi(t);
            }
        };
    }(e);
    return {
        c: function() {
            t = ji("div"), i && i.c(), Ai(t, "class", "selected-item svelte-82qwg8"), qi(t, "hide-selected-item", e[35]);
        },
        m: function(e, r) {
            wi(e, t, r), i && i.m(t, null), n = !0;
        },
        p: function(e, a) {
            o ? o.p && (!n || 8 & a[0] | 1048576 & a[2]) && ri(o, r, e, e[82], n ? ni(r, e[82], a, hR) : oi(e[82]), vR) : i && i.p && (!n || 4104 & a[0]) && i.p(e, n ? a : [
                -1,
                -1,
                -1,
                -1,
                -1
            ]), (!n || 16 & a[1]) && qi(t, "hide-selected-item", e[35]);
        },
        i: function(e) {
            n || (xa(i, e), n = !0);
        },
        o: function(e) {
            ka(i, e), n = !1;
        },
        d: function(e) {
            e && xi(t), i && i.d(e);
        }
    };
}
function VR(e) {
    for(var t, n, r = Ca(e[3]), o = [], i = 0; i < r.length; i += 1)o[i] = WR(pR(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = _i();
        },
        m: function(e, r) {
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(e, r);
            wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            if (67116040 & n[0] | 32 & n[1] | 1048576 & n[2]) {
                var i;
                for(r = Ca(e[3]), i = 0; i < r.length; i += 1){
                    var s = pR(e, r, i);
                    o[i] ? (o[i].p(s, n), xa(o[i], 1)) : (o[i] = WR(s), o[i].c(), xa(o[i], 1), o[i].m(t.parentNode, t));
                }
                for(ba(), i = r.length; i < o.length; i += 1)a(i);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function HR(e) {
    var t, n, r, o, i = e[83]["multi-clear-icon"], a = ei(i, e, e[82], gR), s = a || function(e) {
        var t, n;
        return t = new XT({}), {
            c: function() {
                Pa(t.$$.fragment);
            },
            m: function(e, r) {
                Ta(t, e, r), n = !0;
            },
            i: function(e) {
                n || (xa(t.$$.fragment, e), n = !0);
            },
            o: function(e) {
                ka(t.$$.fragment, e), n = !1;
            },
            d: function(e) {
                Ra(t, e);
            }
        };
    }();
    function c() {
        return e[92](e[128]);
    }
    return {
        c: function() {
            t = ji("div"), s && s.c(), Ai(t, "class", "multi-item-clear svelte-82qwg8");
        },
        m: function(e, i) {
            wi(e, t, i), s && s.m(t, null), n = !0, r || (o = Oi(t, "pointerup", Ei(Mi(c))), r = !0);
        },
        p: function(t, r) {
            e = t, a && a.p && (!n || 1048576 & r[2]) && ri(a, i, e, e[82], n ? ni(i, e[82], r, mR) : oi(e[82]), gR);
        },
        i: function(e) {
            n || (xa(s, e), n = !0);
        },
        o: function(e) {
            ka(s, e), n = !1;
        },
        d: function(e) {
            e && xi(t), s && s.d(e), r = !1, o();
        }
    };
}
function WR(e) {
    var t, n, r, o, i, a, s, c = e[83].selection, l = ei(c, e, e[82], bR), u = l || function(e) {
        var t, n = e[126][e[12]] + "";
        return {
            c: function() {
                t = Ci(n);
            },
            m: function(e, n) {
                wi(e, t, n);
            },
            p: function(e, r) {
                4104 & r[0] && n !== (n = e[126][e[12]] + "") && Ni(t, n);
            },
            d: function(e) {
                e && xi(t);
            }
        };
    }(e), f = !e[11] && !e[10] && XT && HR(e);
    function d() {
        return e[93](e[128]);
    }
    return {
        c: function() {
            t = ji("div"), n = ji("span"), u && u.c(), r = $i(), f && f.c(), o = $i(), Ai(n, "class", "multi-item-text svelte-82qwg8"), Ai(t, "class", "multi-item svelte-82qwg8"), Ai(t, "role", "none"), qi(t, "active", e[26] === e[128]), qi(t, "disabled", e[11]);
        },
        m: function(c, l) {
            wi(c, t, l), pi(t, n), u && u.m(n, null), pi(t, r), f && f.m(t, null), pi(t, o), i = !0, a || (s = [
                Oi(t, "click", Mi(d)),
                Oi(t, "keydown", Ei(Mi(e[84])))
            ], a = !0);
        },
        p: function(n, r) {
            e = n, l ? l.p && (!i || 8 & r[0] | 1048576 & r[2]) && ri(l, c, e, e[82], i ? ni(c, e[82], r, yR) : oi(e[82]), bR) : u && u.p && (!i || 4104 & r[0]) && u.p(e, i ? r : [
                -1,
                -1,
                -1,
                -1,
                -1
            ]), e[11] || e[10] || !XT ? f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa()) : f ? (f.p(e, r), 3072 & r[0] && xa(f, 1)) : ((f = HR(e)).c(), xa(f, 1), f.m(t, o)), (!i || 67108864 & r[0]) && qi(t, "active", e[26] === e[128]), (!i || 2048 & r[0]) && qi(t, "disabled", e[11]);
        },
        i: function(e) {
            i || (xa(u, e), xa(f), i = !0);
        },
        o: function(e) {
            ka(u, e), ka(f), i = !1;
        },
        d: function(e) {
            e && xi(t), u && u.d(e), f && f.d(), a = !1, Qo(s);
        }
    };
}
function UR(e) {
    var t, n, r = e[83]["loading-icon"], o = ei(r, e, e[82], dR), i = o || function(e) {
        var t, n;
        return t = new tR({}), {
            c: function() {
                Pa(t.$$.fragment);
            },
            m: function(e, r) {
                Ta(t, e, r), n = !0;
            },
            i: function(e) {
                n || (xa(t.$$.fragment, e), n = !0);
            },
            o: function(e) {
                ka(t.$$.fragment, e), n = !1;
            },
            d: function(e) {
                Ra(t, e);
            }
        };
    }();
    return {
        c: function() {
            t = ji("div"), i && i.c(), Ai(t, "class", "icon loading svelte-82qwg8"), Ai(t, "aria-hidden", "true");
        },
        m: function(e, r) {
            wi(e, t, r), i && i.m(t, null), n = !0;
        },
        p: function(e, t) {
            o && o.p && (!n || 1048576 & t[2]) && ri(o, r, e, e[82], n ? ni(r, e[82], t, fR) : oi(e[82]), dR);
        },
        i: function(e) {
            n || (xa(i, e), n = !0);
        },
        o: function(e) {
            ka(i, e), n = !1;
        },
        d: function(e) {
            e && xi(t), i && i.d(e);
        }
    };
}
function JR(e) {
    var t, n, r, o, i = e[83]["clear-icon"], a = ei(i, e, e[82], uR), s = a || function(e) {
        var t, n;
        return t = new XT({}), {
            c: function() {
                Pa(t.$$.fragment);
            },
            m: function(e, r) {
                Ta(t, e, r), n = !0;
            },
            i: function(e) {
                n || (xa(t.$$.fragment, e), n = !0);
            },
            o: function(e) {
                ka(t.$$.fragment, e), n = !1;
            },
            d: function(e) {
                Ra(t, e);
            }
        };
    }();
    return {
        c: function() {
            t = ji("button"), s && s.c(), Ai(t, "type", "button"), Ai(t, "class", "icon clear-select svelte-82qwg8");
        },
        m: function(i, a) {
            wi(i, t, a), s && s.m(t, null), n = !0, r || (o = Oi(t, "click", e[22]), r = !0);
        },
        p: function(e, t) {
            a && a.p && (!n || 1048576 & t[2]) && ri(a, i, e, e[82], n ? ni(i, e[82], t, lR) : oi(e[82]), uR);
        },
        i: function(e) {
            n || (xa(s, e), n = !0);
        },
        o: function(e) {
            ka(s, e), n = !1;
        },
        d: function(e) {
            e && xi(t), s && s.d(e), r = !1, o();
        }
    };
}
function KR(e) {
    var t, n, r = e[83]["chevron-icon"], o = ei(r, e, e[82], cR), i = o || function(e) {
        var t, n;
        return t = new GT({}), {
            c: function() {
                Pa(t.$$.fragment);
            },
            m: function(e, r) {
                Ta(t, e, r), n = !0;
            },
            i: function(e) {
                n || (xa(t.$$.fragment, e), n = !0);
            },
            o: function(e) {
                ka(t.$$.fragment, e), n = !1;
            },
            d: function(e) {
                Ra(t, e);
            }
        };
    }();
    return {
        c: function() {
            t = ji("div"), i && i.c(), Ai(t, "class", "icon chevron svelte-82qwg8"), Ai(t, "aria-hidden", "true");
        },
        m: function(e, r) {
            wi(e, t, r), i && i.m(t, null), n = !0;
        },
        p: function(e, t) {
            o && o.p && (!n || 64 & t[0] | 1048576 & t[2]) && ri(o, r, e, e[82], n ? ni(r, e[82], t, sR) : oi(e[82]), cR);
        },
        i: function(e) {
            n || (xa(i, e), n = !0);
        },
        o: function(e) {
            ka(i, e), n = !1;
        },
        d: function(e) {
            e && xi(t), i && i.d(e);
        }
    };
}
function GR(e) {
    var t, n, r = e[83].required, o = ei(r, e, e[82], oR), i = o || {
        c: function() {
            Ai(n = ji("select"), "class", "required svelte-82qwg8"), n.required = !0, Ai(n, "tabindex", "-1"), Ai(n, "aria-hidden", "true");
        },
        m: function(e, t) {
            wi(e, n, t);
        },
        p: Wo,
        d: function(e) {
            e && xi(n);
        }
    };
    return {
        c: function() {
            i && i.c();
        },
        m: function(e, n) {
            i && i.m(e, n), t = !0;
        },
        p: function(e, n) {
            o && o.p && (!t || 8 & n[0] | 1048576 & n[2]) && ri(o, r, e, e[82], t ? ni(r, e[82], n, rR) : oi(e[82]), oR);
        },
        i: function(e) {
            t || (xa(i, e), t = !0);
        },
        o: function(e) {
            ka(i, e), t = !1;
        },
        d: function(e) {
            i && i.d(e);
        }
    };
}
function QR(e) {
    for(var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x = e[6] && TR(e), k = e[2] && BR(e), j = e[83].prepend, S = ei(j, e, e[82], xR), C = e[25] && LR(e), $ = [
        {
            readOnly: u = !e[17]
        },
        e[27],
        {
            placeholder: e[33]
        },
        {
            style: e[18]
        },
        {
            disabled: e[11]
        }
    ], _ = {}, O = 0; O < $.length; O += 1)_ = Jo(_, $[O]);
    var M = e[5] && UR(e), E = e[34] && JR(e), A = e[20] && KR(e), P = e[83]["input-hidden"], T = ei(P, e, e[82], aR), R = T || function(e) {
        var t, n;
        return {
            c: function() {
                Ai(t = ji("input"), "name", e[8]), Ai(t, "type", "hidden"), t.value = n = e[3] ? JSON.stringify(e[3]) : null, Ai(t, "class", "svelte-82qwg8");
            },
            m: function(e, n) {
                wi(e, t, n);
            },
            p: function(e, r) {
                256 & r[0] && Ai(t, "name", e[8]), 8 & r[0] && n !== (n = e[3] ? JSON.stringify(e[3]) : null) && (t.value = n);
            },
            d: function(e) {
                e && xi(t);
            }
        };
    }(e), N = e[16] && (!e[3] || 0 === e[3].length) && GR(e);
    return {
        c: function() {
            t = ji("div"), x && x.c(), n = $i(), r = ji("span"), k && k.c(), o = $i(), i = ji("div"), S && S.c(), a = $i(), s = ji("div"), C && C.c(), c = $i(), l = ji("input"), f = $i(), d = ji("div"), M && M.c(), h = $i(), E && E.c(), v = $i(), A && A.c(), p = $i(), R && R.c(), m = $i(), N && N.c(), Ai(r, "aria-live", "polite"), Ai(r, "aria-atomic", "false"), Ai(r, "aria-relevant", "additions text"), Ai(r, "class", "a11y-text svelte-82qwg8"), Ai(i, "class", "prepend svelte-82qwg8"), Ti(l, _), qi(l, "svelte-82qwg8", !0), Ai(s, "class", "value-container svelte-82qwg8"), Ai(d, "class", "indicators svelte-82qwg8"), Ai(t, "class", g = "svelte-select " + e[21] + " svelte-82qwg8"), Ai(t, "style", e[14]), Ai(t, "role", "none"), qi(t, "multi", e[9]), qi(t, "disabled", e[11]), qi(t, "focused", e[2]), qi(t, "list-open", e[6]), qi(t, "show-chevron", e[20]), qi(t, "error", e[15]);
        },
        m: function(u, g) {
            wi(u, t, g), x && x.m(t, null), pi(t, n), pi(t, r), k && k.m(r, null), pi(t, o), pi(t, i), S && S.m(i, null), pi(t, a), pi(t, s), C && C.m(s, null), pi(s, c), pi(s, l), l.autofocus && l.focus(), e[94](l), Ii(l, e[4]), pi(t, f), pi(t, d), M && M.m(d, null), pi(d, h), E && E.m(d, null), pi(d, v), A && A.m(d, null), pi(t, p), R && R.m(t, null), pi(t, m), N && N.m(t, null), e[96](t), y = !0, b || (w = [
                Oi(window, "click", e[42]),
                Oi(window, "keydown", e[37]),
                Oi(l, "keydown", e[37]),
                Oi(l, "blur", e[39]),
                Oi(l, "focus", e[38]),
                Oi(l, "input", e[95]),
                Oi(t, "pointerup", Mi(e[40])),
                ci(e[48].call(null, t))
            ], b = !0);
        },
        p: function(e, o) {
            e[6] ? x ? (x.p(e, o), 64 & o[0] && xa(x, 1)) : ((x = TR(e)).c(), xa(x, 1), x.m(t, n)) : x && (ba(), ka(x, 1, 1, function() {
                x = null;
            }), wa()), e[2] ? k ? k.p(e, o) : ((k = BR(e)).c(), k.m(r, null)) : k && (k.d(1), k = null), S && S.p && (!y || 1048576 & o[2]) && ri(S, j, e, e[82], y ? ni(j, e[82], o, wR) : oi(e[82]), xR), e[25] ? C ? (C.p(e, o), 33554432 & o[0] && xa(C, 1)) : ((C = LR(e)).c(), xa(C, 1), C.m(s, c)) : C && (ba(), ka(C, 1, 1, function() {
                C = null;
            }), wa()), Ti(l, _ = Ma($, [
                (!y || 131072 & o[0] && u !== (u = !e[17])) && {
                    readOnly: u
                },
                134217728 & o[0] && e[27],
                (!y || 4 & o[1]) && {
                    placeholder: e[33]
                },
                (!y || 262144 & o[0]) && {
                    style: e[18]
                },
                (!y || 2048 & o[0]) && {
                    disabled: e[11]
                }
            ])), 16 & o[0] && l.value !== e[4] && Ii(l, e[4]), qi(l, "svelte-82qwg8", !0), e[5] ? M ? (M.p(e, o), 32 & o[0] && xa(M, 1)) : ((M = UR(e)).c(), xa(M, 1), M.m(d, h)) : M && (ba(), ka(M, 1, 1, function() {
                M = null;
            }), wa()), e[34] ? E ? (E.p(e, o), 8 & o[1] && xa(E, 1)) : ((E = JR(e)).c(), xa(E, 1), E.m(d, v)) : E && (ba(), ka(E, 1, 1, function() {
                E = null;
            }), wa()), e[20] ? A ? (A.p(e, o), 1048576 & o[0] && xa(A, 1)) : ((A = KR(e)).c(), xa(A, 1), A.m(d, null)) : A && (ba(), ka(A, 1, 1, function() {
                A = null;
            }), wa()), T ? T.p && (!y || 8 & o[0] | 1048576 & o[2]) && ri(T, P, e, e[82], y ? ni(P, e[82], o, iR) : oi(e[82]), aR) : R && R.p && (!y || 264 & o[0]) && R.p(e, y ? o : [
                -1,
                -1,
                -1,
                -1,
                -1
            ]), !e[16] || e[3] && 0 !== e[3].length ? N && (ba(), ka(N, 1, 1, function() {
                N = null;
            }), wa()) : N ? (N.p(e, o), 65544 & o[0] && xa(N, 1)) : ((N = GR(e)).c(), xa(N, 1), N.m(t, null)), (!y || 2097152 & o[0] && g !== (g = "svelte-select " + e[21] + " svelte-82qwg8")) && Ai(t, "class", g), (!y || 16384 & o[0]) && Ai(t, "style", e[14]), (!y || 2097664 & o[0]) && qi(t, "multi", e[9]), (!y || 2099200 & o[0]) && qi(t, "disabled", e[11]), (!y || 2097156 & o[0]) && qi(t, "focused", e[2]), (!y || 2097216 & o[0]) && qi(t, "list-open", e[6]), (!y || 3145728 & o[0]) && qi(t, "show-chevron", e[20]), (!y || 2129920 & o[0]) && qi(t, "error", e[15]);
        },
        i: function(e) {
            y || (xa(x), xa(S, e), xa(C), xa(M), xa(E), xa(A), xa(R, e), xa(N), y = !0);
        },
        o: function(e) {
            ka(x), ka(S, e), ka(C), ka(M), ka(E), ka(A), ka(R, e), ka(N), y = !1;
        },
        d: function(n) {
            n && xi(t), x && x.d(), k && k.d(), S && S.d(n), C && C.d(), e[94](null), M && M.d(), E && E.d(), A && A.d(), R && R.d(n), N && N.d(), e[96](null), b = !1, Qo(w);
        }
    };
}
function YR(e) {
    return e.map(function(e, t) {
        return {
            index: t,
            value: e,
            label: "".concat(e)
        };
    });
}
function XR(e, t, n) {
    var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b = t.$$slots, w = void 0 === b ? {} : b, x = t.$$scope, k = function(e) {
        var t = {};
        for(var n in e)t[n] = !0;
        return t;
    }(w), j = Yi(), S = t.justValue, C = void 0 === S ? null : S, $ = t.filter, _ = void 0 === $ ? HT : $, O = t.getItems, M = void 0 === O ? WT : O, E = t.id, A = void 0 === E ? null : E, P = t.name, T = void 0 === P ? null : P, R = t.container, N = void 0 === R ? void 0 : R, I = t.input, D = void 0 === I ? void 0 : I, z = t.multiple, q = void 0 !== z && z, B = t.multiFullItemClearable, L = void 0 !== B && B, F = t.disabled, V = void 0 !== F && F, H = t.focused, W = void 0 !== H && H, U = t.value, J = void 0 === U ? null : U, K = t.filterText, G = void 0 === K ? "" : K, Q = t.placeholder, Y = void 0 === Q ? "Please select" : Q, X = t.placeholderAlwaysShow, Z = void 0 !== X && X, ee = t.items, te = void 0 === ee ? null : ee, ne = t.label, re = void 0 === ne ? "label" : ne, oe = t.itemFilter, ie = void 0 === oe ? function(e, t, n) {
        return "".concat(e).toLowerCase().includes(t.toLowerCase());
    } : oe, ae = t.groupBy, se = void 0 === ae ? void 0 : ae, ce = t.groupFilter, le = void 0 === ce ? function(e) {
        return e;
    } : ce, ue = t.groupHeaderSelectable, fe = void 0 !== ue && ue, de = t.itemId, he = void 0 === de ? "value" : de, ve = t.loadOptions, pe = void 0 === ve ? void 0 : ve, me = t.containerStyles, ge = void 0 === me ? "" : me, ye = t.hasError, be = void 0 !== ye && ye, we = t.filterSelectedItems, xe = void 0 === we || we, ke = t.required, je = void 0 !== ke && ke, Se = t.closeListOnChange, Ce = void 0 === Se || Se, $e = t.clearFilterTextOnBlur, _e = void 0 === $e || $e, Oe = t.createGroupHeaderItem, Me = void 0 === Oe ? function(e, t) {
        return zo({
            value: e
        }, re, e);
    } : Oe, Ee = t.searchable, Ae = void 0 === Ee || Ee, Pe = t.inputStyles, Te = void 0 === Pe ? "" : Pe, Re = t.clearable, Ne = void 0 === Re || Re, Ie = t.loading, De = void 0 !== Ie && Ie, ze = t.listOpen, qe = void 0 !== ze && ze, Be = t.debounce, Le = void 0 === Be ? function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        clearTimeout(d), d = setTimeout(e, t);
    } : Be, Fe = t.debounceWait, Ve = void 0 === Fe ? 300 : Fe, He = t.hideEmptyState, We = void 0 !== He && He, Ue = t.inputAttributes, Je = void 0 === Ue ? {} : Ue, Ke = t.listAutoWidth, Ge = void 0 === Ke || Ke, Qe = t.showChevron, Ye = void 0 !== Qe && Qe, Xe = t.listOffset, Ze = void 0 === Xe ? 5 : Xe, et = t.hoverItemIndex, tt = void 0 === et ? 0 : et, nt = t.floatingConfig, rt = void 0 === nt ? {} : nt, ot = t.class, it = void 0 === ot ? "" : ot;
    function at(e) {
        var t = [], n = {};
        e.forEach(function(e) {
            var r = se(e);
            t.includes(r) || (t.push(r), n[r] = [], r && n[r].push(Object.assign(Me(r, e), {
                id: r,
                groupHeader: !0,
                selectable: fe
            }))), n[r].push(Object.assign({
                groupItem: !!r
            }, e));
        });
        var r = [];
        return le(t).forEach(function(e) {
            n[e] && r.push.apply(r, Bo(n[e]));
        }), r;
    }
    function st() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 ? arguments[1] : void 0;
        n(7, tt = e < 0 ? 0 : e), !t && se && l[tt] && !l[tt].selectable && Mt(1);
    }
    function ct() {
        var e = !0;
        if (J) {
            var t = [], r = [];
            J.forEach(function(n) {
                t.includes(n[he]) ? e = !1 : (t.push(n[he]), r.push(n));
            }), e || n(3, J = r);
        }
        return e;
    }
    function lt(e) {
        var t = e ? e[he] : J[he];
        return te.find(function(e) {
            return e[he] === t;
        });
    }
    function ut(e) {
        return ft.apply(this, arguments);
    }
    function ft() {
        return ft = ko(wo().mark(function e(t) {
            var r;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        r = J[t], 1 === J.length ? n(3, J = void 0) : n(3, J = J.filter(function(e) {
                            return e !== r;
                        })), j("clear", r);
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), ft.apply(this, arguments);
    }
    function dt(e) {
        var t, r;
        W && D === (null === (t = document) || void 0 === t ? void 0 : t.activeElement) || (e && j("focus", e), null === (r = D) || void 0 === r || r.focus(), n(2, W = !0));
    }
    function ht(e) {
        return vt.apply(this, arguments);
    }
    function vt() {
        return (vt = ko(wo().mark(function e(t) {
            var r;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (!Ct) {
                            e.next = 2;
                            break;
                        }
                        return e.abrupt("return");
                    case 2:
                        (qe || W) && (j("blur", t), pt(), n(2, W = !1), n(26, h = void 0), null === (r = D) || void 0 === r || r.blur());
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function pt() {
        _e && n(4, G = ""), n(6, qe = !1);
    }
    y = ko(wo().mark(function e() {
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    n(78, v = J), n(79, p = G), n(80, m = q);
                case 3:
                case "end":
                    return e.stop();
            }
        }, e);
    })), Ki().$$.before_update.push(y), Gi(function() {
        qe && n(2, W = !0), W && D && D.focus();
    });
    var mt = t.ariaValues, gt = void 0 === mt ? function(e) {
        return "Option ".concat(e, ", selected.");
    } : mt, yt = t.ariaListOpen, bt = void 0 === yt ? function(e, t) {
        return "You are currently focused on option ".concat(e, ". There are ").concat(t, " results available.");
    } : yt, wt = t.ariaFocused, xt = void 0 === wt ? function() {
        return "Select is focused, type to refine list, press down to open the menu.";
    } : wt;
    var kt, jt = null;
    function St() {
        clearTimeout(kt), kt = setTimeout(function() {
            Ct = !1;
        }, 100);
    }
    Qi(function() {
        var e;
        null === (e = jt) || void 0 === e || e.remove();
    });
    var Ct = !1;
    function $t(e) {
        e && !1 !== e.selectable && function(e) {
            if (e) {
                n(4, G = "");
                var t = Object.assign({}, e);
                if (t.groupHeader && !t.selectable) return;
                n(3, J = q ? J ? J.concat([
                    t
                ]) : [
                    t
                ] : n(3, J = t)), setTimeout(function() {
                    Ce && pt(), n(26, h = void 0), j("change", J), j("select", e);
                });
            }
        }(e);
    }
    function _t(e) {
        Ct || n(7, tt = e);
    }
    function Ot(e) {
        var t = e.item, r = e.i;
        if (!1 !== (null == t ? void 0 : t.selectable)) return J && !q && J[he] === t[he] ? pt() : void (function(e) {
            return e.groupHeader && e.selectable || e.selectable || !e.hasOwnProperty("selectable");
        }(t) && (n(7, tt = r), $t(t)));
    }
    function Mt(e) {
        if (0 === l.filter(function(e) {
            return !Object.hasOwn(e, "selectable") || !0 === e.selectable;
        }).length) return n(7, tt = 0);
        e > 0 && tt === l.length - 1 ? n(7, tt = 0) : n(7, e < 0 && 0 === tt ? tt = l.length - 1 : tt += e);
        var t = l[tt];
        t && !1 === t.selectable && (1 !== e && -1 !== e || Mt(e));
    }
    var Et = Pt, At = Pt;
    function Pt(e) {
        return {
            update: function(t) {
                t.scroll && (St(), e.scrollIntoView({
                    behavior: "auto",
                    block: "nearest"
                }));
            }
        };
    }
    var Tt, Rt = {
        strategy: "absolute",
        placement: "bottom-start",
        middleware: [
            (Tt = Ze, void 0 === Tt && (Tt = 0), {
                name: "offset",
                options: Tt,
                fn: function(e) {
                    return ko(wo().mark(function t() {
                        var n, r, o, i, a, s, c;
                        return wo().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return o = e.x, i = e.y, a = e.placement, s = e.middlewareData, t.next = 3, cT(e, Tt);
                                case 3:
                                    if (c = t.sent, a !== (null == (n = s.offset) ? void 0 : n.placement) || null == (r = s.arrow) || !r.alignmentOffset) {
                                        t.next = 6;
                                        break;
                                    }
                                    return t.abrupt("return", {});
                                case 6:
                                    return t.abrupt("return", {
                                        x: o + c.x,
                                        y: i + c.y,
                                        data: Ro(Ro({}, c), {}, {
                                            placement: a
                                        })
                                    });
                                case 7:
                                case "end":
                                    return t.stop();
                            }
                        }, t);
                    }))();
                }
            }),
            FT(),
            LT()
        ],
        autoUpdate: !1
    }, Nt = function(e) {
        var t, n, r = {
            autoUpdate: !0
        }, o = e, i = function(t) {
            return Ro(Ro(Ro({}, r), e || {}), t || {});
        }, a = function(e) {
            t && n && (o = i(e), VT(t, n, o).then(function(e) {
                var t;
                Object.assign(n.style, {
                    position: e.strategy,
                    left: "".concat(e.x, "px"),
                    top: "".concat(e.y, "px")
                }), (null === (t = o) || void 0 === t ? void 0 : t.onComputed) && o.onComputed(e);
            }));
        }, s = function(e) {
            Qi(e.subscribe(function(e) {
                void 0 === t ? (t = e, a()) : (Object.assign(t, e), a());
            }));
        };
        return [
            function(e) {
                if ("subscribe" in e) return s(e), {};
                t = e, a();
            },
            function(e, r) {
                var s;
                n = e, o = i(r), setTimeout(function() {
                    return a(r);
                }, 0), a(r);
                var c = function() {
                    s && (s(), s = void 0);
                }, l = function() {
                    var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o || {}).autoUpdate;
                    c(), !1 !== e && ca().then(function() {
                        return BT(t, n, function() {
                            return a(o);
                        }, !0 === e ? {} : e);
                    });
                };
                return s = l(), {
                    update: function(e) {
                        a(e), s = l(e);
                    },
                    destroy: function() {
                        c();
                    }
                };
            },
            a
        ];
    }(Rt), It = jo(Nt, 3), Dt = It[0], zt = It[1], qt = It[2], Bt = !0;
    return e.$$set = function(e) {
        "justValue" in e && n(52, C = e.justValue), "filter" in e && n(53, _ = e.filter), "getItems" in e && n(54, M = e.getItems), "id" in e && n(55, A = e.id), "name" in e && n(8, T = e.name), "container" in e && n(0, N = e.container), "input" in e && n(1, D = e.input), "multiple" in e && n(9, q = e.multiple), "multiFullItemClearable" in e && n(10, L = e.multiFullItemClearable), "disabled" in e && n(11, V = e.disabled), "focused" in e && n(2, W = e.focused), "value" in e && n(3, J = e.value), "filterText" in e && n(4, G = e.filterText), "placeholder" in e && n(56, Y = e.placeholder), "placeholderAlwaysShow" in e && n(57, Z = e.placeholderAlwaysShow), "items" in e && n(51, te = e.items), "label" in e && n(12, re = e.label), "itemFilter" in e && n(58, ie = e.itemFilter), "groupBy" in e && n(59, se = e.groupBy), "groupFilter" in e && n(60, le = e.groupFilter), "groupHeaderSelectable" in e && n(61, fe = e.groupHeaderSelectable), "itemId" in e && n(13, he = e.itemId), "loadOptions" in e && n(62, pe = e.loadOptions), "containerStyles" in e && n(14, ge = e.containerStyles), "hasError" in e && n(15, be = e.hasError), "filterSelectedItems" in e && n(63, xe = e.filterSelectedItems), "required" in e && n(16, je = e.required), "closeListOnChange" in e && n(64, Ce = e.closeListOnChange), "clearFilterTextOnBlur" in e && n(65, _e = e.clearFilterTextOnBlur), "createGroupHeaderItem" in e && n(66, Me = e.createGroupHeaderItem), "searchable" in e && n(17, Ae = e.searchable), "inputStyles" in e && n(18, Te = e.inputStyles), "clearable" in e && n(68, Ne = e.clearable), "loading" in e && n(5, De = e.loading), "listOpen" in e && n(6, qe = e.listOpen), "debounce" in e && n(69, Le = e.debounce), "debounceWait" in e && n(70, Ve = e.debounceWait), "hideEmptyState" in e && n(19, We = e.hideEmptyState), "inputAttributes" in e && n(71, Je = e.inputAttributes), "listAutoWidth" in e && n(72, Ge = e.listAutoWidth), "showChevron" in e && n(20, Ye = e.showChevron), "listOffset" in e && n(73, Ze = e.listOffset), "hoverItemIndex" in e && n(7, tt = e.hoverItemIndex), "floatingConfig" in e && n(74, rt = e.floatingConfig), "class" in e && n(21, it = e.class), "ariaValues" in e && n(75, gt = e.ariaValues), "ariaListOpen" in e && n(76, bt = e.ariaListOpen), "ariaFocused" in e && n(77, xt = e.ariaFocused), "$$scope" in e && n(82, x = e.$$scope);
    }, e.$$.update = function() {
        var t, d, y, b, w;
        (8 & e.$$.dirty[0] | 1048576 & e.$$.dirty[1] && J && function() {
            if ("string" == typeof J) {
                var e = (te || []).find(function(e) {
                    return e[he] === J;
                });
                n(3, J = e || zo(zo({}, he, J), "label", J));
            } else q && Array.isArray(J) && J.length > 0 && n(3, J = J.map(function(e) {
                return "string" == typeof e ? {
                    value: e,
                    label: e
                } : e;
            }));
        }(), 131072 & e.$$.dirty[0] | 512 & e.$$.dirty[2] && (!Je && Ae || (n(27, g = Object.assign({
            autocapitalize: "none",
            autocomplete: "off",
            autocorrect: "off",
            spellcheck: !1,
            tabindex: 0,
            type: "text",
            "aria-autocomplete": "list"
        }, Je)), A && n(27, g.id = A, g), Ae || n(27, g.readonly = !0, g))), 512 & e.$$.dirty[0] && q && J && (Array.isArray(J) ? n(3, J = Bo(J)) : n(3, J = [
            J
        ])), 512 & e.$$.dirty[0] | 262144 & e.$$.dirty[2] && m && !q && J && n(3, J = null), 520 & e.$$.dirty[0] && q && J && J.length > 1 && ct(), 8 & e.$$.dirty[0] && J && (q ? JSON.stringify(J) !== JSON.stringify(v) && ct() && j("input", J) : v && JSON.stringify(J[he]) === JSON.stringify(v[he]) || j("input", J)), 520 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && !J && q && v && j("input", J), 6 & e.$$.dirty[0] && !W && D && pt(), 16 & e.$$.dirty[0] | 131072 & e.$$.dirty[2] && G !== p && (pe || 0 !== G.length) && (pe ? Le(ko(wo().mark(function e() {
            var t;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return n(5, De = !0), e.next = 3, M({
                            dispatch: j,
                            loadOptions: pe,
                            convertStringItemsToObjects: YR,
                            filterText: G
                        });
                    case 3:
                        (t = e.sent) ? (n(5, De = t.loading), n(6, qe = qe ? t.listOpen : G.length > 0), n(2, W = qe && t.focused), n(51, te = se ? at(t.filteredItems) : t.filteredItems)) : (n(5, De = !1), n(2, W = !0), n(6, qe = !0));
                    case 5:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), Ve) : (n(6, qe = !0), q && n(26, h = void 0))), 12824 & e.$$.dirty[0] | 407896064 & e.$$.dirty[1] | 3 & e.$$.dirty[2] && n(24, l = _({
            loadOptions: pe,
            filterText: G,
            items: te,
            multiple: q,
            value: J,
            itemId: he,
            groupBy: se,
            label: re,
            filterSelectedItems: xe,
            itemFilter: ie,
            convertStringItemsToObjects: YR,
            filterGroupedItems: at
        })), 16777800 & e.$$.dirty[0] && !q && qe && J && l && (t = l.findIndex(function(e) {
            return e[he] === J[he];
        }), st(t, !0)), 576 & e.$$.dirty[0] && qe && q && n(7, tt = 0), 16 & e.$$.dirty[0] && G && n(7, tt = 0), 128 & e.$$.dirty[0] && function(e) {
            j("hoverItem", e);
        }(tt), 520 & e.$$.dirty[0] && n(25, r = q ? J && J.length > 0 : J), 33554448 & e.$$.dirty[0] && n(35, o = r && G.length > 0), 33556512 & e.$$.dirty[0] | 64 & e.$$.dirty[2] && n(34, i = r && Ne && !V && !De), 520 & e.$$.dirty[0] | 100663296 & e.$$.dirty[1]) && n(33, a = Z && q || q && 0 === (null === (d = J) || void 0 === d ? void 0 : d.length) ? Y : J ? "" : Y);
        (520 & e.$$.dirty[0] && n(32, s = J ? (y = void 0, y = q && J.length > 0 ? J.map(function(e) {
            return e[re];
        }).join(", ") : J[re], gt(y)) : ""), 16777412 & e.$$.dirty[0] && n(31, c = function() {
            if (!l || 0 === l.length) return "";
            var e = l[tt];
            if (qe && e) {
                var t = l ? l.length : 0;
                return bt(e[re], t);
            }
            return xt();
        }()), 1048576 & e.$$.dirty[1] && function(e) {
            e && 0 !== e.length && !e.some(function(e) {
                return "object" !== Ho(e);
            }) && J && (q ? !J.some(function(e) {
                return !e || !e[he];
            }) : J[he]) && (Array.isArray(J) ? n(3, J = J.map(function(e) {
                return lt(e) || e;
            })) : n(3, J = lt() || J));
        }(te), 8712 & e.$$.dirty[0] && n(52, C = q ? J ? J.map(function(e) {
            return e[he];
        }) : null : J ? J[he] : J), 520 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && (q || !v || J || j("input", J)), 16777800 & e.$$.dirty[0] && qe && l && !q && !J && st(), 16777216 & e.$$.dirty[0] && function(e) {
            qe && j("filter", e);
        }(l), 1 & e.$$.dirty[0] | 4096 & e.$$.dirty[2]) && N && void 0 === (null === (b = rt) || void 0 === b ? void 0 : b.autoUpdate) && n(81, Rt.autoUpdate = !0, Rt);
        1 & e.$$.dirty[0] | 528384 & e.$$.dirty[2] && N && rt && qt(Object.assign(Rt, rt)), 8388608 & e.$$.dirty[0] && n(30, u = !!jt), 8388672 & e.$$.dirty[0] && function(e, t) {
            if (!e || !t) return n(28, Bt = !0);
            setTimeout(function() {
                n(28, Bt = !1);
            }, 0);
        }(jt, qe), 8388673 & e.$$.dirty[0] && qe && N && jt && (w = N.getBoundingClientRect().width, n(23, jt.style.width = Ge ? w + "px" : "auto", jt)), 128 & e.$$.dirty[0] && n(29, f = tt), 70 & e.$$.dirty[0] && D && qe && !W && dt();
    }, [
        N,
        D,
        W,
        J,
        G,
        De,
        qe,
        tt,
        T,
        q,
        L,
        V,
        re,
        he,
        ge,
        be,
        je,
        Ae,
        Te,
        We,
        Ye,
        it,
        function() {
            j("clear", J), n(3, J = void 0), pt(), dt();
        },
        jt,
        l,
        r,
        h,
        g,
        Bt,
        f,
        u,
        c,
        s,
        a,
        i,
        o,
        ut,
        function(e) {
            if (W) switch(e.stopPropagation(), e.key){
                case "Escape":
                    e.preventDefault(), pt();
                    break;
                case "Enter":
                    if (e.preventDefault(), qe) {
                        if (0 === l.length) break;
                        var t = l[tt];
                        if (J && !q && J[he] === t[he]) {
                            pt();
                            break;
                        }
                        $t(l[tt]);
                    }
                    break;
                case "ArrowDown":
                    e.preventDefault(), qe ? Mt(1) : (n(6, qe = !0), n(26, h = void 0));
                    break;
                case "ArrowUp":
                    e.preventDefault(), qe ? Mt(-1) : (n(6, qe = !0), n(26, h = void 0));
                    break;
                case "Tab":
                    if (qe && W) {
                        if (0 === l.length || J && J[he] === l[tt][he]) return pt();
                        e.preventDefault(), $t(l[tt]), pt();
                    }
                    break;
                case "Backspace":
                    if (!q || G.length > 0) return;
                    if (q && J && J.length > 0) {
                        if (ut(void 0 !== h ? h : J.length - 1), 0 === h || void 0 === h) break;
                        n(26, h = J.length > h ? h - 1 : void 0);
                    }
                    break;
                case "ArrowLeft":
                    if (!J || !q || G.length > 0) return;
                    void 0 === h ? n(26, h = J.length - 1) : J.length > h && 0 !== h && n(26, h -= 1);
                    break;
                case "ArrowRight":
                    if (!J || !q || G.length > 0 || void 0 === h) return;
                    h === J.length - 1 ? n(26, h = void 0) : h < J.length - 1 && n(26, h += 1);
            }
        },
        dt,
        ht,
        function() {
            if (!V) return G.length > 0 ? n(6, qe = !0) : void n(6, qe = !qe);
        },
        St,
        function(e) {
            var t;
            qe || W || !N || N.contains(e.target) || null !== (t = jt) && void 0 !== t && t.contains(e.target) || ht();
        },
        _t,
        Ot,
        function(e, t, n) {
            if (!q) return t && t[n] === e[n];
        },
        Et,
        At,
        Dt,
        zt,
        k,
        te,
        C,
        _,
        M,
        A,
        Y,
        Z,
        ie,
        se,
        le,
        fe,
        pe,
        xe,
        Ce,
        _e,
        Me,
        function() {
            return l;
        },
        Ne,
        Le,
        Ve,
        Je,
        Ge,
        Ze,
        rt,
        gt,
        bt,
        xt,
        v,
        p,
        m,
        Rt,
        x,
        w,
        function(t) {
            ea.call(this, e, t);
        },
        function(t) {
            ea.call(this, e, t);
        },
        function(t) {
            ea.call(this, e, t);
        },
        function(t) {
            ea.call(this, e, t);
        },
        function(e) {
            return _t(e);
        },
        function(e) {
            return _t(e);
        },
        function(e, t) {
            return Ot({
                item: e,
                i: t
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(23, jt = e);
            });
        },
        function(e) {
            return ut(e);
        },
        function(e) {
            return L ? ut(e) : {};
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(1, D = e);
            });
        },
        function() {
            G = this.value, n(4, G);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(0, N = e);
            });
        }
    ];
}
var ZR = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, XR, QR, Xo, {
            justValue: 52,
            filter: 53,
            getItems: 54,
            id: 55,
            name: 8,
            container: 0,
            input: 1,
            multiple: 9,
            multiFullItemClearable: 10,
            disabled: 11,
            focused: 2,
            value: 3,
            filterText: 4,
            placeholder: 56,
            placeholderAlwaysShow: 57,
            items: 51,
            label: 12,
            itemFilter: 58,
            groupBy: 59,
            groupFilter: 60,
            groupHeaderSelectable: 61,
            itemId: 13,
            loadOptions: 62,
            containerStyles: 14,
            hasError: 15,
            filterSelectedItems: 63,
            required: 16,
            closeListOnChange: 64,
            clearFilterTextOnBlur: 65,
            createGroupHeaderItem: 66,
            getFilteredItems: 67,
            searchable: 17,
            inputStyles: 18,
            clearable: 68,
            loading: 5,
            listOpen: 6,
            debounce: 69,
            debounceWait: 70,
            hideEmptyState: 19,
            inputAttributes: 71,
            listAutoWidth: 72,
            showChevron: 20,
            listOffset: 73,
            hoverItemIndex: 7,
            floatingConfig: 74,
            class: 21,
            handleClear: 22,
            ariaValues: 75,
            ariaListOpen: 76,
            ariaFocused: 77
        }, nR, [
            -1,
            -1,
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "getFilteredItems",
            get: function() {
                return this.$$.ctx[67];
            }
        },
        {
            key: "handleClear",
            get: function() {
                return this.$$.ctx[22];
            }
        }
    ]), t;
}();
function eN(e) {
    mi(e, "svelte-ijtq0l", "table.jse-transform-wizard.svelte-ijtq0l.svelte-ijtq0l{border-collapse:collapse;border-spacing:0;width:100%}table.jse-transform-wizard.svelte-ijtq0l input.svelte-ijtq0l{font-family:inherit;font-size:inherit}table.jse-transform-wizard.svelte-ijtq0l tr th.svelte-ijtq0l{font-weight:normal;text-align:left;width:60px}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l{width:100%;display:flex;flex-direction:row;margin-bottom:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .multi-item{align-items:center}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .value-container{gap:0 !important}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-path{flex:4;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-relation{flex:1.5;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-path{flex:3;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-direction{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-projection-paths{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select input{box-sizing:border-box}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l{flex:4;padding:4px 8px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);outline:none;background:var(--jse-input-background, var(--jse-background-color, #fff));color:inherit}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}");
}
function tN(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M, E, A, P, T, R, N;
    function I(t) {
        e[16](t);
    }
    var D = {
        class: "jse-filter-path",
        showChevron: !0,
        items: e[7]
    };
    function z(t) {
        e[17](t);
    }
    void 0 !== e[0] && (D.value = e[0]), s = new ZR({
        props: D
    }), na.push(function() {
        return Aa(s, "value", I);
    });
    var q = {
        class: "jse-filter-relation",
        showChevron: !0,
        items: e[8]
    };
    function B(t) {
        e[19](t);
    }
    void 0 !== e[1] && (q.value = e[1]), u = new ZR({
        props: q
    }), na.push(function() {
        return Aa(u, "value", z);
    });
    var L = {
        class: "jse-sort-path",
        showChevron: !0,
        items: e[7]
    };
    function F(t) {
        e[20](t);
    }
    void 0 !== e[3] && (L.value = e[3]), w = new ZR({
        props: L
    }), na.push(function() {
        return Aa(w, "value", B);
    });
    var V = {
        class: "jse-sort-direction",
        showChevron: !0,
        items: e[9]
    };
    function H(t) {
        e[21](t);
    }
    void 0 !== e[4] && (V.value = e[4]), j = new ZR({
        props: V
    }), na.push(function() {
        return Aa(j, "value", F);
    });
    var W = {
        class: "jse-projection-paths",
        multiple: !0,
        showChevron: !0,
        items: e[6]
    };
    return void 0 !== e[5] && (W.value = e[5]), A = new ZR({
        props: W
    }), na.push(function() {
        return Aa(A, "value", H);
    }), {
        c: function() {
            t = ji("table"), n = ji("tr"), (r = ji("th")).textContent = "Filter", o = $i(), i = ji("td"), a = ji("div"), Pa(s.$$.fragment), l = $i(), Pa(u.$$.fragment), d = $i(), h = ji("input"), v = $i(), p = ji("tr"), (m = ji("th")).textContent = "Sort", g = $i(), y = ji("td"), b = ji("div"), Pa(w.$$.fragment), k = $i(), Pa(j.$$.fragment), C = $i(), $ = ji("tr"), (_ = ji("th")).textContent = "Pick", O = $i(), M = ji("td"), E = ji("div"), Pa(A.$$.fragment), Ai(r, "class", "svelte-ijtq0l"), Ai(h, "class", "jse-filter-value svelte-ijtq0l"), Ai(a, "class", "jse-horizontal svelte-ijtq0l"), Ai(m, "class", "svelte-ijtq0l"), Ai(b, "class", "jse-horizontal svelte-ijtq0l"), Ai(_, "class", "svelte-ijtq0l"), Ai(E, "class", "jse-horizontal svelte-ijtq0l"), Ai(t, "class", "jse-transform-wizard svelte-ijtq0l");
        },
        m: function(c, f) {
            wi(c, t, f), pi(t, n), pi(n, r), pi(n, o), pi(n, i), pi(i, a), Ta(s, a, null), pi(a, l), Ta(u, a, null), pi(a, d), pi(a, h), Ii(h, e[2]), pi(t, v), pi(t, p), pi(p, m), pi(p, g), pi(p, y), pi(y, b), Ta(w, b, null), pi(b, k), Ta(j, b, null), pi(t, C), pi(t, $), pi($, _), pi($, O), pi($, M), pi(M, E), Ta(A, E, null), T = !0, R || (N = Oi(h, "input", e[18]), R = !0);
        },
        p: function(e, t) {
            var n = jo(t, 1)[0], r = {};
            128 & n && (r.items = e[7]), !c && 1 & n && (c = !0, r.value = e[0], ua(function() {
                return c = !1;
            })), s.$set(r);
            var o = {};
            !f && 2 & n && (f = !0, o.value = e[1], ua(function() {
                return f = !1;
            })), u.$set(o), 4 & n && h.value !== e[2] && Ii(h, e[2]);
            var i = {};
            128 & n && (i.items = e[7]), !x && 8 & n && (x = !0, i.value = e[3], ua(function() {
                return x = !1;
            })), w.$set(i);
            var a = {};
            !S && 16 & n && (S = !0, a.value = e[4], ua(function() {
                return S = !1;
            })), j.$set(a);
            var l = {};
            64 & n && (l.items = e[6]), !P && 32 & n && (P = !0, l.value = e[5], ua(function() {
                return P = !1;
            })), A.$set(l);
        },
        i: function(e) {
            T || (xa(s.$$.fragment, e), xa(u.$$.fragment, e), xa(w.$$.fragment, e), xa(j.$$.fragment, e), xa(A.$$.fragment, e), T = !0);
        },
        o: function(e) {
            ka(s.$$.fragment, e), ka(u.$$.fragment, e), ka(w.$$.fragment, e), ka(j.$$.fragment, e), ka(A.$$.fragment, e), T = !1;
        },
        d: function(e) {
            e && xi(t), Ra(s), Ra(u), Ra(w), Ra(j), Ra(A), R = !1, N();
        }
    };
}
function nN(e, t, n) {
    var r, o, i, a, s, c, l, u, f, d, h, v = Da("jsoneditor:TransformWizard"), p = t.json, m = t.queryOptions, g = void 0 === m ? {} : m, y = t.onChange, b = [
        "==",
        "!=",
        "<",
        "<=",
        ">",
        ">="
    ].map(function(e) {
        return {
            value: e,
            label: e
        };
    }), w = [
        {
            value: "asc",
            label: "ascending"
        },
        {
            value: "desc",
            label: "descending"
        }
    ], x = null !== (r = g) && void 0 !== r && null !== (r = r.filter) && void 0 !== r && r.path ? GO(g.filter.path) : null, k = null !== (o = g) && void 0 !== o && null !== (o = o.filter) && void 0 !== o && o.relation ? b.find(function(e) {
        var t;
        return e.value === (null === (t = g.filter) || void 0 === t ? void 0 : t.relation);
    }) : null, j = (null === (i = g) || void 0 === i || null === (i = i.filter) || void 0 === i ? void 0 : i.value) || "", S = null !== (a = g) && void 0 !== a && null !== (a = a.sort) && void 0 !== a && a.path ? GO(g.sort.path) : null, C = null !== (s = g) && void 0 !== s && null !== (s = s.sort) && void 0 !== s && s.direction ? w.find(function(e) {
        var t;
        return e.value === (null === (t = g.sort) || void 0 === t ? void 0 : t.direction);
    }) : null;
    return e.$$set = function(e) {
        "json" in e && n(11, p = e.json), "queryOptions" in e && n(10, g = e.queryOptions), "onChange" in e && n(12, y = e.onChange);
    }, e.$$.update = function() {
        var t, r, o, i, a, s, m, b, w, $, _, O, M;
        (2048 & e.$$.dirty && n(15, c = Array.isArray(p)), 34816 & e.$$.dirty && n(14, l = c ? T_(p) : []), 34816 & e.$$.dirty && n(13, u = c ? T_(p, !0) : []), 16384 & e.$$.dirty && n(7, f = l.map(GO)), 8192 & e.$$.dirty && n(6, d = u ? u.map(GO) : []), 1088 & e.$$.dirty) && n(5, h = null !== (t = g) && void 0 !== t && null !== (t = t.projection) && void 0 !== t && t.paths && d ? g.projection.paths.map(function(e) {
            return d.find(function(t) {
                return Ox(t.value, e);
            });
        }).filter(function(e) {
            return !!e;
        }) : null);
        1 & e.$$.dirty && (o = null === (r = x) || void 0 === r ? void 0 : r.value, Ox(null === (i = g) || void 0 === i || null === (i = i.filter) || void 0 === i ? void 0 : i.path, o) || (v("changeFilterPath", o), n(10, g = Us(g, [
            "filter",
            "path"
        ], o, !0)), y(g)));
        2 & e.$$.dirty && (s = null === (a = k) || void 0 === a ? void 0 : a.value, Ox(null === (m = g) || void 0 === m || null === (m = m.filter) || void 0 === m ? void 0 : m.relation, s) || (v("changeFilterRelation", s), n(10, g = Us(g, [
            "filter",
            "relation"
        ], s, !0)), y(g)));
        (4 & e.$$.dirty && (b = j, Ox(null === (w = g) || void 0 === w || null === (w = w.filter) || void 0 === w ? void 0 : w.value, b) || (v("changeFilterValue", b), n(10, g = Us(g, [
            "filter",
            "value"
        ], b, !0)), y(g))), 8 & e.$$.dirty) && function(e) {
            var t;
            Ox(null === (t = g) || void 0 === t || null === (t = t.sort) || void 0 === t ? void 0 : t.path, e) || (v("changeSortPath", e), n(10, g = Us(g, [
                "sort",
                "path"
            ], e, !0)), y(g));
        }(null === ($ = S) || void 0 === $ ? void 0 : $.value);
        16 & e.$$.dirty && (O = null === (_ = C) || void 0 === _ ? void 0 : _.value, Ox(null === (M = g) || void 0 === M || null === (M = M.sort) || void 0 === M ? void 0 : M.direction, O) || (v("changeSortDirection", O), n(10, g = Us(g, [
            "sort",
            "direction"
        ], O, !0)), y(g)));
        32 & e.$$.dirty && function(e) {
            var t;
            Ox(null === (t = g) || void 0 === t || null === (t = t.projection) || void 0 === t ? void 0 : t.paths, e) || (v("changeProjectionPaths", e), n(10, g = Us(g, [
                "projection",
                "paths"
            ], e, !0)), y(g));
        }(h ? h.map(function(e) {
            return e.value;
        }) : void 0);
    }, [
        x,
        k,
        j,
        S,
        C,
        h,
        d,
        f,
        b,
        w,
        g,
        p,
        y,
        u,
        l,
        c,
        function(e) {
            n(0, x = e);
        },
        function(e) {
            n(1, k = e);
        },
        function() {
            j = this.value, n(2, j);
        },
        function(e) {
            n(3, S = e);
        },
        function(e) {
            n(4, C = e);
        },
        function(e) {
            n(5, h = e), n(10, g), n(6, d), n(13, u), n(15, c), n(11, p);
        }
    ];
}
var rN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, nN, tN, Zo, {
            json: 11,
            queryOptions: 10,
            onChange: 12
        }, eN), n;
    }
    return Ao(t, Ia), Do(t);
}();
function oN(e) {
    mi(e, "svelte-1wg043c", '.jse-select-query-language.svelte-1wg043c.svelte-1wg043c{position:relative;width:32px}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container.svelte-1wg043c{position:absolute;top:0;right:0;display:flex;flex-direction:column;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;text-align:left;padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));white-space:nowrap;color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));background:var(--jse-context-menu-background, #656565)}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}');
}
function iN(e, t, n) {
    var r = e.slice();
    return r[5] = t[n], r;
}
function aN(e) {
    var t, n;
    return t = new jM({
        props: {
            data: aM
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function sN(e) {
    var t, n;
    return t = new jM({
        props: {
            data: iM
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function cN(e) {
    var t, n, r, o, i, a, s, c, l, u, f = e[5].name + "", d = [
        sN,
        aN
    ], h = [];
    function v(e, t) {
        return e[5].id === e[0] ? 0 : 1;
    }
    function p() {
        return e[4](e[5]);
    }
    return n = v(e), r = h[n] = d[n](e), {
        c: function() {
            t = ji("button"), r.c(), o = $i(), i = Ci(f), a = $i(), Ai(t, "type", "button"), Ai(t, "class", "jse-query-language svelte-1wg043c"), Ai(t, "title", s = "Select ".concat(e[5].name, " as query language")), qi(t, "selected", e[5].id === e[0]);
        },
        m: function(e, r) {
            wi(e, t, r), h[n].m(t, null), pi(t, o), pi(t, i), pi(t, a), c = !0, l || (u = Oi(t, "click", p), l = !0);
        },
        p: function(a, l) {
            var u = n;
            (n = v(e = a)) !== u && (ba(), ka(h[u], 1, 1, function() {
                h[u] = null;
            }), wa(), (r = h[n]) || (r = h[n] = d[n](e)).c(), xa(r, 1), r.m(t, o)), (!c || 2 & l) && f !== (f = e[5].name + "") && Ni(i, f), (!c || 2 & l && s !== (s = "Select ".concat(e[5].name, " as query language"))) && Ai(t, "title", s), (!c || 3 & l) && qi(t, "selected", e[5].id === e[0]);
        },
        i: function(e) {
            c || (xa(r), c = !0);
        },
        o: function(e) {
            ka(r), c = !1;
        },
        d: function(e) {
            e && xi(t), h[n].d(), l = !1, u();
        }
    };
}
function lN(e) {
    for(var t, n, r, o = Ca(e[1]), i = [], a = 0; a < o.length; a += 1)i[a] = cN(iN(e, o, a));
    var s = function(e) {
        return ka(i[e], 1, 1, function() {
            i[e] = null;
        });
    };
    return {
        c: function() {
            t = ji("div"), n = ji("div");
            for(var e = 0; e < i.length; e += 1)i[e].c();
            Ai(n, "class", "jse-select-query-language-container svelte-1wg043c"), Ai(t, "class", "jse-select-query-language svelte-1wg043c");
        },
        m: function(e, o) {
            wi(e, t, o), pi(t, n);
            for(var a = 0; a < i.length; a += 1)i[a] && i[a].m(n, null);
            r = !0;
        },
        p: function(e, t) {
            var r = jo(t, 1)[0];
            if (7 & r) {
                var a;
                for(o = Ca(e[1]), a = 0; a < o.length; a += 1){
                    var c = iN(e, o, a);
                    i[a] ? (i[a].p(c, r), xa(i[a], 1)) : (i[a] = cN(c), i[a].c(), xa(i[a], 1), i[a].m(n, null));
                }
                for(ba(), a = o.length; a < i.length; a += 1)s(a);
                wa();
            }
        },
        i: function(e) {
            if (!r) {
                for(var t = 0; t < o.length; t += 1)xa(i[t]);
                r = !0;
            }
        },
        o: function(e) {
            i = i.filter(Boolean);
            for(var t = 0; t < i.length; t += 1)ka(i[t]);
            r = !1;
        },
        d: function(e) {
            e && xi(t), ki(i, e);
        }
    };
}
function uN(e, t, n) {
    var r = t.queryLanguages, o = t.queryLanguageId, i = t.onChangeQueryLanguage;
    function a(e) {
        n(0, o = e), i(e);
    }
    return e.$$set = function(e) {
        "queryLanguages" in e && n(1, r = e.queryLanguages), "queryLanguageId" in e && n(0, o = e.queryLanguageId), "onChangeQueryLanguage" in e && n(3, i = e.onChangeQueryLanguage);
    }, [
        o,
        r,
        a,
        i,
        function(e) {
            return a(e.id);
        }
    ];
}
var fN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, uN, lN, Xo, {
            queryLanguages: 1,
            queryLanguageId: 0,
            onChangeQueryLanguage: 3
        }, oN), n;
    }
    return Ao(t, Ia), Do(t);
}();
function dN(e) {
    mi(e, "svelte-1n68mbh", ".jse-header.svelte-1n68mbh.svelte-1n68mbh{display:flex;background:var(--jse-theme-color, #3883fa);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-header.svelte-1n68mbh .jse-title.svelte-1n68mbh{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-1n68mbh button.svelte-1n68mbh{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-1n68mbh button.svelte-1n68mbh:hover{background:rgba(255, 255, 255, 0.1)}");
}
function hN(e) {
    var t, n, r, o, i;
    return n = new jM({
        props: {
            data: mP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-config svelte-1n68mbh"), Ai(t, "title", "Select a query language");
        },
        m: function(a, s) {
            wi(a, t, s), Ta(n, t, null), e[6](t), r = !0, o || (i = Oi(t, "click", e[3]), o = !0);
        },
        p: Wo,
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(r) {
            r && xi(t), Ra(n), e[6](null), o = !1, i();
        }
    };
}
function vN(e) {
    var t, n, r, o, i, a, s, c, l, u = e[0].length > 1 && hN(e);
    return a = new jM({
        props: {
            data: MP
        }
    }), {
        c: function() {
            t = ji("div"), (n = ji("div")).textContent = "Transform", r = $i(), u && u.c(), o = $i(), i = ji("button"), Pa(a.$$.fragment), Ai(n, "class", "jse-title svelte-1n68mbh"), Ai(i, "type", "button"), Ai(i, "class", "jse-close svelte-1n68mbh"), Ai(t, "class", "jse-header svelte-1n68mbh");
        },
        m: function(f, d) {
            wi(f, t, d), pi(t, n), pi(t, r), u && u.m(t, null), pi(t, o), pi(t, i), Ta(a, i, null), s = !0, c || (l = Oi(i, "click", e[7]), c = !0);
        },
        p: function(e, n) {
            var r = jo(n, 1)[0];
            e[0].length > 1 ? u ? (u.p(e, r), 1 & r && xa(u, 1)) : ((u = hN(e)).c(), xa(u, 1), u.m(t, o)) : u && (ba(), ka(u, 1, 1, function() {
                u = null;
            }), wa());
        },
        i: function(e) {
            s || (xa(u), xa(a.$$.fragment, e), s = !0);
        },
        o: function(e) {
            ka(u), ka(a.$$.fragment, e), s = !1;
        },
        d: function(e) {
            e && xi(t), u && u.d(), Ra(a), c = !1, l();
        }
    };
}
function pN(e, t, n) {
    var r, o, i = t.queryLanguages, a = t.queryLanguageId, s = t.onChangeQueryLanguage, c = Zi("simple-modal").close, l = Zi("absolute-popup"), u = l.openAbsolutePopup, f = l.closeAbsolutePopup;
    return e.$$set = function(e) {
        "queryLanguages" in e && n(0, i = e.queryLanguages), "queryLanguageId" in e && n(4, a = e.queryLanguageId), "onChangeQueryLanguage" in e && n(5, s = e.onChangeQueryLanguage);
    }, [
        i,
        r,
        c,
        function() {
            var e = {
                queryLanguages: i,
                queryLanguageId: a,
                onChangeQueryLanguage: function(e) {
                    f(o), s(e);
                }
            };
            o = u(fN, e, {
                offsetTop: -2,
                offsetLeft: 0,
                anchor: r,
                closeOnOuterClick: !0
            });
        },
        a,
        s,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(1, r = e);
            });
        },
        function() {
            return c();
        }
    ];
}
var mN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, pN, vN, Zo, {
            queryLanguages: 0,
            queryLanguageId: 4,
            onChangeQueryLanguage: 5
        }, dN), n;
    }
    return Ao(t, Ia), Do(t);
}(), gN = Da("jsoneditor:AutoScrollHandler");
var yN = function(e, t, n, r) {
    return (e /= r / 2) < 1 ? n / 2 * e * e + t : -n / 2 * (--e * (e - 2) - 1) + t;
}, bN = function() {
    var e, t, n, r, o, i, a, s, c, l, u, f, d;
    function h(t) {
        return t.getBoundingClientRect().top - (e.getBoundingClientRect ? e.getBoundingClientRect().top : 0) + n;
    }
    function v(t) {
        e.scrollTo ? e.scrollTo(e.scrollLeft, t) : e.scrollTop = t;
    }
    function p(e) {
        l || (l = e), v(i(u = e - l, n, s, c)), d = !0, u < c ? requestAnimationFrame(p) : function() {
            if (v(n + s), t && a) t.setAttribute("tabindex", "-1"), t.focus();
            "function" == typeof f && f();
            l = 0, d = !1;
        }();
    }
    return function(u) {
        var v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        switch(c = 1e3, o = v.offset || 0, f = v.callback, i = v.easing || yN, a = v.a11y || !1, Ho(v.container)){
            case "object":
                e = v.container;
                break;
            case "string":
                e = document.querySelector(v.container);
                break;
            default:
                e = window.document.documentElement;
        }
        switch(n = e.scrollTop, Ho(u)){
            case "number":
                t = void 0, a = !1, r = n + u;
                break;
            case "object":
                r = h(t = u);
                break;
            case "string":
                t = document.querySelector(u), r = h(t);
        }
        switch(s = r - n + o, Ho(v.duration)){
            case "number":
                c = v.duration;
                break;
            case "function":
                c = v.duration(s);
        }
        d ? l = 0 : requestAnimationFrame(p);
    };
}, wN = 1e3, xN = Da("jsoneditor:History");
function kN() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.maxItems || wN, n = [], r = 0;
    function o() {
        return r < n.length;
    }
    function i() {
        return r > 0;
    }
    function a() {
        return {
            canUndo: o(),
            canRedo: i(),
            length: n.length
        };
    }
    function s() {
        e.onChange && e.onChange(a());
    }
    return {
        add: function(e) {
            xN("add", e), n = [
                e
            ].concat(n.slice(r)).slice(0, t), r = 0, s();
        },
        clear: function() {
            xN("clear"), n = [], r = 0, s();
        },
        getState: a,
        undo: function() {
            if (o()) {
                var e = n[r];
                return r += 1, xN("undo", e), s(), e;
            }
        },
        redo: function() {
            if (i()) return xN("redo", n[r -= 1]), s(), n[r];
        }
    };
}
function jN(e, t) {
    var n = Date.now(), r = e();
    return t(Date.now() - n), r;
}
var SN = Da("validation");
function CN(e, t, n, r) {
    if (SN("validateJSON"), !t) return [];
    if (n !== r) {
        var o = n.stringify(e);
        return t(void 0 !== o ? r.parse(o) : void 0);
    }
    return t(e);
}
function $N(e, t, n, r) {
    if (SN("validateText"), e.length > hs) return {
        validationErrors: [
            {
                path: [],
                message: "Validation turned off: the document is too large",
                severity: Za.info
            }
        ]
    };
    if (0 === e.length) return null;
    try {
        var o = jN(function() {
            return n.parse(e);
        }, function(e) {
            return SN("validate: parsed json in ".concat(e, " ms"));
        });
        if (!t) return null;
        var i = n === r ? o : jN(function() {
            return r.parse(e);
        }, function(e) {
            return SN("validate: parsed json with the validationParser in ".concat(e, " ms"));
        }), a = jN(function() {
            return t(i);
        }, function(e) {
            return SN("validate: validated json in ".concat(e, " ms"));
        });
        return _x(a) ? null : {
            validationErrors: a
        };
    } catch (t) {
        var s = jN(function() {
            return function(e, t) {
                if (e.length > vs) return !1;
                try {
                    return t.parse(Hl(e)), !0;
                } catch (e) {
                    return !1;
                }
            }(e, n);
        }, function(e) {
            return SN("validate: checked whether repairable in ".concat(e, " ms"));
        });
        return {
            parseError: H_(e, t.message || t.toString()),
            isRepairable: s
        };
    }
}
var _N = Da("jsoneditor:FocusTracker");
function ON(e) {
    var t, n = e.onMount, r = e.onDestroy, o = e.getWindow, i = e.hasFocus, a = e.onFocus, s = e.onBlur, c = !1;
    function l() {
        var e = i();
        e && (clearTimeout(t), c || (_N("focus"), a(), c = e));
    }
    function u() {
        c && (clearTimeout(t), t = setTimeout(function() {
            i() || (_N("blur"), c = !1, s());
        }));
    }
    n(function() {
        _N("mount FocusTracker");
        var e = o();
        e && (e.addEventListener("focusin", l, !0), e.addEventListener("focusout", u, !0));
    }), r(function() {
        _N("destroy FocusTracker");
        var e = o();
        e && (e.removeEventListener("focusin", l, !0), e.removeEventListener("focusout", u, !0));
    });
}
function MN(e) {
    mi(e, "svelte-p1zf9f", '.jse-message.svelte-p1zf9f.svelte-p1zf9f{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:var(--jse-padding, 10px);display:flex;gap:var(--jse-padding, 10px);flex-wrap:wrap;align-items:stretch}.jse-message.jse-success.svelte-p1zf9f.svelte-p1zf9f{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff)}.jse-message.svelte-p1zf9f .jse-text.svelte-p1zf9f{display:flex;flex:1;min-width:60%;align-items:center}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f{cursor:pointer}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-message.jse-error.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-error-background, var(--jse-error-color, #ee5341));color:var(--jse-message-error-color, #fff)}.jse-message.jse-warning.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d)}.jse-message.jse-info.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-info-background, #4f91ff);color:var(--jse-message-info-color, #fff)}.jse-message.svelte-p1zf9f .jse-actions.svelte-p1zf9f{display:flex;gap:var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-message-action-background, rgba(255, 255, 255, 0.2));color:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f:hover{background:var(--jse-message-action-background-highlight, rgba(255, 255, 255, 0.3))}');
}
function EN(e, t, n) {
    var r = e.slice();
    return r[9] = t[n], r;
}
function AN(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2 & n && (r.data = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function PN(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[9].icon
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            8 & n && (r.data = e[9].icon), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function TN(e) {
    var t, n, r, o, i, a, s, c, l, u = e[9].text + "", f = e[9].icon && PN(e);
    function d() {
        return e[7](e[9]);
    }
    function h() {
        return e[8](e[9]);
    }
    return {
        c: function() {
            t = ji("button"), f && f.c(), n = $i(), r = Ci(u), o = $i(), Ai(t, "type", "button"), Ai(t, "class", "jse-button jse-action jse-primary svelte-p1zf9f"), Ai(t, "title", i = e[9].title), t.disabled = a = e[9].disabled;
        },
        m: function(e, i) {
            wi(e, t, i), f && f.m(t, null), pi(t, n), pi(t, r), pi(t, o), s = !0, c || (l = [
                Oi(t, "click", d),
                Oi(t, "mousedown", h)
            ], c = !0);
        },
        p: function(o, c) {
            (e = o)[9].icon ? f ? (f.p(e, c), 8 & c && xa(f, 1)) : ((f = PN(e)).c(), xa(f, 1), f.m(t, n)) : f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa()), (!s || 8 & c) && u !== (u = e[9].text + "") && Ni(r, u), (!s || 8 & c && i !== (i = e[9].title)) && Ai(t, "title", i), (!s || 8 & c && a !== (a = e[9].disabled)) && (t.disabled = a);
        },
        i: function(e) {
            s || (xa(f), s = !0);
        },
        o: function(e) {
            ka(f), s = !1;
        },
        d: function(e) {
            e && xi(t), f && f.d(), c = !1, Qo(l);
        }
    };
}
function RN(e) {
    for(var t, n, r, o, i, a, s, c, l, u, f, d = e[1] && AN(e), h = Ca(e[3]), v = [], p = 0; p < h.length; p += 1)v[p] = TN(EN(e, h, p));
    var m = function(e) {
        return ka(v[e], 1, 1, function() {
            v[e] = null;
        });
    };
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("div"), d && d.c(), o = $i(), i = Ci(e[2]), a = $i(), s = ji("div");
            for(var l = 0; l < v.length; l += 1)v[l].c();
            Ai(r, "class", "jse-text-centered"), Ai(n, "role", "button"), Ai(n, "tabindex", "-1"), Ai(n, "class", "jse-text svelte-p1zf9f"), qi(n, "jse-clickable", !!e[4]), Ai(s, "class", "jse-actions svelte-p1zf9f"), Ai(t, "class", c = "jse-message jse-" + e[0] + " svelte-p1zf9f");
        },
        m: function(c, h) {
            wi(c, t, h), pi(t, n), pi(n, r), d && d.m(r, null), pi(r, o), pi(r, i), pi(t, a), pi(t, s);
            for(var p = 0; p < v.length; p += 1)v[p] && v[p].m(s, null);
            l = !0, u || (f = Oi(n, "click", e[5]), u = !0);
        },
        p: function(e, a) {
            var u = jo(a, 1)[0];
            if (e[1] ? d ? (d.p(e, u), 2 & u && xa(d, 1)) : ((d = AN(e)).c(), xa(d, 1), d.m(r, o)) : d && (ba(), ka(d, 1, 1, function() {
                d = null;
            }), wa()), (!l || 4 & u) && Ni(i, e[2]), (!l || 16 & u) && qi(n, "jse-clickable", !!e[4]), 8 & u) {
                var f;
                for(h = Ca(e[3]), f = 0; f < h.length; f += 1){
                    var p = EN(e, h, f);
                    v[f] ? (v[f].p(p, u), xa(v[f], 1)) : (v[f] = TN(p), v[f].c(), xa(v[f], 1), v[f].m(s, null));
                }
                for(ba(), f = h.length; f < v.length; f += 1)m(f);
                wa();
            }
            (!l || 1 & u && c !== (c = "jse-message jse-" + e[0] + " svelte-p1zf9f")) && Ai(t, "class", c);
        },
        i: function(e) {
            if (!l) {
                xa(d);
                for(var t = 0; t < h.length; t += 1)xa(v[t]);
                l = !0;
            }
        },
        o: function(e) {
            ka(d), v = v.filter(Boolean);
            for(var t = 0; t < v.length; t += 1)ka(v[t]);
            l = !1;
        },
        d: function(e) {
            e && xi(t), d && d.d(), ki(v, e), u = !1, f();
        }
    };
}
function NN(e, t, n) {
    var r = t.type, o = void 0 === r ? "success" : r, i = t.icon, a = void 0 === i ? void 0 : i, s = t.message, c = void 0 === s ? void 0 : s, l = t.actions, u = void 0 === l ? [] : l, f = t.onClick, d = void 0 === f ? void 0 : f, h = t.onClose, v = void 0 === h ? void 0 : h;
    v && Qi(v);
    return e.$$set = function(e) {
        "type" in e && n(0, o = e.type), "icon" in e && n(1, a = e.icon), "message" in e && n(2, c = e.message), "actions" in e && n(3, u = e.actions), "onClick" in e && n(4, d = e.onClick), "onClose" in e && n(6, v = e.onClose);
    }, [
        o,
        a,
        c,
        u,
        d,
        function() {
            d && d();
        },
        v,
        function(e) {
            e.onClick && e.onClick();
        },
        function(e) {
            e.onMouseDown && e.onMouseDown();
        }
    ];
}
var IN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, NN, RN, Zo, {
            type: 0,
            icon: 1,
            message: 2,
            actions: 3,
            onClick: 4,
            onClose: 6
        }, MN), n;
    }
    return Ao(t, Ia), Do(t);
}();
function DN(e) {
    mi(e, "svelte-1ifg4t0", '.jse-validation-errors-overview.svelte-1ifg4t0.svelte-1ifg4t0{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d);overflow:auto;max-height:25%}.jse-validation-errors-overview.svelte-1ifg4t0 table.svelte-1ifg4t0{border-collapse:collapse;width:100%}.jse-validation-errors-overview.svelte-1ifg4t0 table tr.svelte-1ifg4t0{cursor:pointer}.jse-validation-errors-overview.svelte-1ifg4t0 table tr.svelte-1ifg4t0:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.svelte-1ifg4t0{padding:4px var(--jse-padding, 10px);vertical-align:middle}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-icon.svelte-1ifg4t0{width:36px;box-sizing:border-box}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action.svelte-1ifg4t0{width:36px;box-sizing:border-box;padding:0}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1ifg4t0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:36px;height:26px;cursor:pointer}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1ifg4t0:hover{background-color:rgba(255, 255, 255, 0.2)}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td div.jse-validation-errors-expand.svelte-1ifg4t0{display:inline-block;position:relative;top:3px}');
}
function zN(e, t, n) {
    var r = e.slice();
    return r[7] = t[n], r[9] = n, r;
}
function qN(e) {
    var t, n, r, o, i = [
        LN,
        BN
    ], a = [];
    function s(e, t) {
        return e[2] || 1 === e[3] ? 0 : 1;
    }
    return n = s(e), r = a[n] = i[n](e), {
        c: function() {
            t = ji("div"), r.c(), Ai(t, "class", "jse-validation-errors-overview svelte-1ifg4t0");
        },
        m: function(e, r) {
            wi(e, t, r), a[n].m(t, null), o = !0;
        },
        p: function(e, o) {
            var c = n;
            (n = s(e)) === c ? a[n].p(e, o) : (ba(), ka(a[c], 1, 1, function() {
                a[c] = null;
            }), wa(), (r = a[n]) ? r.p(e, o) : (r = a[n] = i[n](e)).c(), xa(r, 1), r.m(t, null));
        },
        i: function(e) {
            o || (xa(r), o = !0);
        },
        o: function(e) {
            ka(r), o = !1;
        },
        d: function(e) {
            e && xi(t), a[n].d();
        }
    };
}
function BN(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v;
    return i = new jM({
        props: {
            data: TP
        }
    }), f = new jM({
        props: {
            data: iP
        }
    }), {
        c: function() {
            t = ji("table"), n = ji("tbody"), r = ji("tr"), o = ji("td"), Pa(i.$$.fragment), a = $i(), s = ji("td"), c = Ci(e[3]), l = Ci(" validation errors\n              "), u = ji("div"), Pa(f.$$.fragment), Ai(o, "class", "jse-validation-error-icon svelte-1ifg4t0"), Ai(u, "class", "jse-validation-errors-expand svelte-1ifg4t0"), Ai(s, "class", "jse-validation-error-count svelte-1ifg4t0"), Ai(r, "class", "jse-validation-error svelte-1ifg4t0"), Ai(t, "class", "jse-validation-errors-overview-collapsed svelte-1ifg4t0");
        },
        m: function(p, m) {
            wi(p, t, m), pi(t, n), pi(n, r), pi(r, o), Ta(i, o, null), pi(r, a), pi(r, s), pi(s, c), pi(s, l), pi(s, u), Ta(f, u, null), d = !0, h || (v = Oi(r, "click", e[5]), h = !0);
        },
        p: function(e, t) {
            (!d || 8 & t) && Ni(c, e[3]);
        },
        i: function(e) {
            d || (xa(i.$$.fragment, e), xa(f.$$.fragment, e), d = !0);
        },
        o: function(e) {
            ka(i.$$.fragment, e), ka(f.$$.fragment, e), d = !1;
        },
        d: function(e) {
            e && xi(t), Ra(i), Ra(f), h = !1, v();
        }
    };
}
function LN(e) {
    for(var t, n, r, o, i = Ca(N_(e[0], us)), a = [], s = 0; s < i.length; s += 1)a[s] = VN(zN(e, i, s));
    var c = function(e) {
        return ka(a[e], 1, 1, function() {
            a[e] = null;
        });
    }, l = e[3] > us && HN(e);
    return {
        c: function() {
            t = ji("table"), n = ji("tbody");
            for(var e = 0; e < a.length; e += 1)a[e].c();
            r = $i(), l && l.c(), Ai(t, "class", "jse-validation-errors-overview-expanded svelte-1ifg4t0");
        },
        m: function(e, i) {
            wi(e, t, i), pi(t, n);
            for(var s = 0; s < a.length; s += 1)a[s] && a[s].m(n, null);
            pi(n, r), l && l.m(n, null), o = !0;
        },
        p: function(e, t) {
            if (19 & t) {
                var o;
                for(i = Ca(N_(e[0], us)), o = 0; o < i.length; o += 1){
                    var s = zN(e, i, o);
                    a[o] ? (a[o].p(s, t), xa(a[o], 1)) : (a[o] = VN(s), a[o].c(), xa(a[o], 1), a[o].m(n, r));
                }
                for(ba(), o = i.length; o < a.length; o += 1)c(o);
                wa();
            }
            e[3] > us ? l ? l.p(e, t) : ((l = HN(e)).c(), l.m(n, null)) : l && (l.d(1), l = null);
        },
        i: function(e) {
            if (!o) {
                for(var t = 0; t < i.length; t += 1)xa(a[t]);
                o = !0;
            }
        },
        o: function(e) {
            a = a.filter(Boolean);
            for(var t = 0; t < a.length; t += 1)ka(a[t]);
            o = !1;
        },
        d: function(e) {
            e && xi(t), ki(a, e), l && l.d();
        }
    };
}
function FN(e) {
    var t, n, r, o, i;
    return n = new jM({
        props: {
            data: xP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-validation-errors-collapse svelte-1ifg4t0"), Ai(t, "title", "Collapse validation errors");
        },
        m: function(a, s) {
            wi(a, t, s), Ta(n, t, null), r = !0, o || (i = Oi(t, "click", Ei(e[4])), o = !0);
        },
        p: Wo,
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), o = !1, i();
        }
    };
}
function VN(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p = JO(e[7].path) + "", m = e[7].message + "";
    r = new jM({
        props: {
            data: TP
        }
    });
    var g = 0 === e[9] && e[0].length > 1 && FN(e);
    function y() {
        return e[6](e[7]);
    }
    return {
        c: function() {
            t = ji("tr"), n = ji("td"), Pa(r.$$.fragment), o = $i(), i = ji("td"), a = Ci(p), s = $i(), c = ji("td"), l = Ci(m), u = $i(), f = ji("td"), g && g.c(), Ai(n, "class", "jse-validation-error-icon svelte-1ifg4t0"), Ai(i, "class", "jse-validation-error-path svelte-1ifg4t0"), Ai(c, "class", "jse-validation-error-message svelte-1ifg4t0"), Ai(f, "class", "jse-validation-error-action svelte-1ifg4t0"), Ai(t, "class", "jse-validation-error svelte-1ifg4t0");
        },
        m: function(e, p) {
            wi(e, t, p), pi(t, n), Ta(r, n, null), pi(t, o), pi(t, i), pi(i, a), pi(t, s), pi(t, c), pi(c, l), pi(t, u), pi(t, f), g && g.m(f, null), d = !0, h || (v = Oi(t, "click", y), h = !0);
        },
        p: function(t, n) {
            e = t, (!d || 1 & n) && p !== (p = JO(e[7].path) + "") && Ni(a, p), (!d || 1 & n) && m !== (m = e[7].message + "") && Ni(l, m), 0 === e[9] && e[0].length > 1 ? g ? (g.p(e, n), 1 & n && xa(g, 1)) : ((g = FN(e)).c(), xa(g, 1), g.m(f, null)) : g && (ba(), ka(g, 1, 1, function() {
                g = null;
            }), wa());
        },
        i: function(e) {
            d || (xa(r.$$.fragment, e), xa(g), d = !0);
        },
        o: function(e) {
            ka(r.$$.fragment, e), ka(g), d = !1;
        },
        d: function(e) {
            e && xi(t), Ra(r), g && g.d(), h = !1, v();
        }
    };
}
function HN(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d = e[3] - us + "";
    return {
        c: function() {
            t = ji("tr"), n = ji("td"), r = $i(), o = ji("td"), i = $i(), a = ji("td"), s = Ci("(and "), c = Ci(d), l = Ci(" more errors)"), u = $i(), f = ji("td"), Ai(n, "class", "svelte-1ifg4t0"), Ai(o, "class", "svelte-1ifg4t0"), Ai(a, "class", "svelte-1ifg4t0"), Ai(f, "class", "svelte-1ifg4t0"), Ai(t, "class", "jse-validation-error svelte-1ifg4t0");
        },
        m: function(e, d) {
            wi(e, t, d), pi(t, n), pi(t, r), pi(t, o), pi(t, i), pi(t, a), pi(a, s), pi(a, c), pi(a, l), pi(t, u), pi(t, f);
        },
        p: function(e, t) {
            8 & t && d !== (d = e[3] - us + "") && Ni(c, d);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function WN(e) {
    var t, n, r = !_x(e[0]), o = r && qN(e);
    return {
        c: function() {
            o && o.c(), t = _i();
        },
        m: function(e, r) {
            o && o.m(e, r), wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            var i = jo(n, 1)[0];
            1 & i && (r = !_x(e[0])), r ? o ? (o.p(e, i), 1 & i && xa(o, 1)) : ((o = qN(e)).c(), xa(o, 1), o.m(t.parentNode, t)) : o && (ba(), ka(o, 1, 1, function() {
                o = null;
            }), wa());
        },
        i: function(e) {
            n || (xa(o), n = !0);
        },
        o: function(e) {
            ka(o), n = !1;
        },
        d: function(e) {
            e && xi(t), o && o.d(e);
        }
    };
}
function UN(e, t, n) {
    var r, o = t.validationErrors, i = t.selectError, a = !0;
    return e.$$set = function(e) {
        "validationErrors" in e && n(0, o = e.validationErrors), "selectError" in e && n(1, i = e.selectError);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(3, r = o.length);
    }, [
        o,
        i,
        a,
        r,
        function() {
            n(2, a = !1);
        },
        function() {
            n(2, a = !0);
        },
        function(e) {
            setTimeout(function() {
                return i(e);
            });
        }
    ];
}
var JN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, UN, WN, Zo, {
            validationErrors: 0,
            selectError: 1
        }, DN), n;
    }
    return Ao(t, Ia), Do(t);
}(), KN = "undefined" != typeof navigator && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
function GN(e) {
    mi(e, "svelte-1n68mbh", ".jse-header.svelte-1n68mbh.svelte-1n68mbh{display:flex;background:var(--jse-theme-color, #3883fa);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-header.svelte-1n68mbh .jse-title.svelte-1n68mbh{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-1n68mbh button.svelte-1n68mbh{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-1n68mbh button.svelte-1n68mbh:hover{background:rgba(255, 255, 255, 0.1)}");
}
function QN(e) {
    var t, n, r, o, i, a, s, c, l;
    return a = new jM({
        props: {
            data: MP
        }
    }), {
        c: function() {
            t = ji("div"), n = ji("div"), r = Ci(e[0]), o = $i(), i = ji("button"), Pa(a.$$.fragment), Ai(n, "class", "jse-title svelte-1n68mbh"), Ai(i, "type", "button"), Ai(i, "class", "jse-close svelte-1n68mbh"), Ai(t, "class", "jse-header svelte-1n68mbh");
        },
        m: function(u, f) {
            wi(u, t, f), pi(t, n), pi(n, r), pi(t, o), pi(t, i), Ta(a, i, null), s = !0, c || (l = Oi(i, "click", e[3]), c = !0);
        },
        p: function(e, t) {
            var n = jo(t, 1)[0];
            (!s || 1 & n) && Ni(r, e[0]);
        },
        i: function(e) {
            s || (xa(a.$$.fragment, e), s = !0);
        },
        o: function(e) {
            ka(a.$$.fragment, e), s = !1;
        },
        d: function(e) {
            e && xi(t), Ra(a), c = !1, l();
        }
    };
}
function YN(e, t, n) {
    var r = t.title, o = void 0 === r ? "Modal" : r, i = t.onClose, a = void 0 === i ? void 0 : i, s = Zi("simple-modal").close;
    return e.$$set = function(e) {
        "title" in e && n(0, o = e.title), "onClose" in e && n(1, a = e.onClose);
    }, [
        o,
        a,
        s,
        function() {
            a ? a() : s();
        }
    ];
}
var XN = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, YN, QN, Zo, {
            title: 0,
            onClose: 1
        }, GN), n;
    }
    return Ao(t, Ia), Do(t);
}();
function ZN(e) {
    mi(e, "svelte-18bor9q", '.jse-modal.svelte-18bor9q.svelte-18bor9q{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-18bor9q .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-18bor9q .jse-modal-contents.svelte-18bor9q{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions.svelte-18bor9q{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-copy-paste.svelte-18bor9q .jse-shortcuts.svelte-18bor9q{display:flex;flex-wrap:wrap;justify-content:space-around;margin:calc(2 * var(--jse-padding, 10px)) 0}.jse-modal.jse-copy-paste.svelte-18bor9q .jse-shortcuts .jse-shortcut .jse-key.svelte-18bor9q{font-size:200%;color:var(--jse-theme-color, #3883fa)}');
}
function eI(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S;
    return n = new XN({
        props: {
            title: "Copying and pasting"
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), r = $i(), o = ji("div"), (i = ji("div")).textContent = "These actions are unavailable via the menu. Please use:", a = $i(), s = ji("div"), c = ji("div"), (l = ji("div")).textContent = "".concat(e[1], "+C"), u = Ci("\n        for copy"), f = $i(), d = ji("div"), (h = ji("div")).textContent = "".concat(e[1], "+X"), v = Ci("\n        for cut"), p = $i(), m = ji("div"), (g = ji("div")).textContent = "".concat(e[1], "+V"), y = Ci("\n        for paste"), b = $i(), w = ji("div"), (x = ji("button")).textContent = "Close", Ai(l, "class", "jse-key svelte-18bor9q"), Ai(c, "class", "jse-shortcut"), Ai(h, "class", "jse-key svelte-18bor9q"), Ai(d, "class", "jse-shortcut"), Ai(g, "class", "jse-key svelte-18bor9q"), Ai(m, "class", "jse-shortcut"), Ai(s, "class", "jse-shortcuts svelte-18bor9q"), Ai(x, "type", "button"), Ai(x, "class", "jse-primary svelte-18bor9q"), Ai(w, "class", "jse-actions svelte-18bor9q"), Ai(o, "class", "jse-modal-contents svelte-18bor9q"), Ai(t, "class", "jse-modal jse-copy-paste svelte-18bor9q");
        },
        m: function(C, $) {
            wi(C, t, $), Ta(n, t, null), pi(t, r), pi(t, o), pi(o, i), pi(o, a), pi(o, s), pi(s, c), pi(c, l), pi(c, u), pi(s, f), pi(s, d), pi(d, h), pi(d, v), pi(s, p), pi(s, m), pi(m, g), pi(m, y), pi(o, b), pi(o, w), pi(w, x), k = !0, j || (S = Oi(x, "click", e[2]), j = !0);
        },
        p: Wo,
        i: function(e) {
            k || (xa(n.$$.fragment, e), k = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), k = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), j = !1, S();
        }
    };
}
function tI(e) {
    var t = Zi("simple-modal").close;
    return [
        t,
        KN ? "\u2318" : "Ctrl",
        function() {
            return t();
        }
    ];
}
var nI = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, tI, eI, Zo, {}, ZN), n;
    }
    return Ao(t, Ia), Do(t);
}();
function rI(e) {
    return !!e && ("space" === e.type || !0 === e.space);
}
function oI(e) {
    return !!e && ("separator" === e.type || !0 === e.separator);
}
function iI(e) {
    return !!e && "label" === e.type && "string" == typeof e.text;
}
function aI(e) {
    return !!e && "function" == typeof e.onClick;
}
function sI(e) {
    return !!e && "dropdown-button" === e.type && aI(e.main) && Array.isArray(e.items);
}
function cI(e) {
    return !!e && "row" === e.type && Array.isArray(e.items);
}
function lI(e) {
    return !!e && "column" === e.type && Array.isArray(e.items);
}
function uI(e) {
    return Gl(e) && Gl(e.parseError);
}
function fI(e) {
    return Gl(e) && Array.isArray(e.validationErrors);
}
function dI(e) {
    return Gl(e) && Array.isArray(e.path) && "string" == typeof e.message && "severity" in e;
}
function hI(e) {
    return Gl(e) && dI(e) && "boolean" == typeof e.isChildError;
}
function vI(e) {
    return Gl(e) && "component" in e && Gl(e.props);
}
function pI(e) {
    return Gl(e) && "function" == typeof e.action && Gl(e.props);
}
function mI(e) {
    mi(e, "svelte-7deygj", '.jse-menu.svelte-7deygj.svelte-7deygj{background:var(--jse-theme-color, #3883fa);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-main-menu, 14px);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));display:flex;flex-wrap:wrap;align-items:stretch;position:relative}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj{font-family:inherit;font-size:inherit;line-height:1.5em;border:none;background:transparent;color:inherit;cursor:pointer;width:var(--jse-menu-button-size, 32px);height:var(--jse-menu-button-size, 32px);padding:calc(0.5 * var(--jse-padding, 10px));margin:0;border-radius:0;display:inline-flex;align-items:center;text-align:center;justify-content:center}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:disabled{color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.5;background:transparent}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj{width:auto;height:calc(var(--jse-menu-button-size, 32px) - var(--jse-padding, 10px));margin:calc(0.5 * var(--jse-padding, 10px)) 0;padding:0 calc(0.5 * var(--jse-padding, 10px)) 1px;border:1px solid var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:not(.jse-last){border-right:none}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-first.svelte-7deygj{margin-left:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-last.svelte-7deygj{margin-right:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-selected.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));color:var(--jse-theme-color, #3883fa)}.jse-menu.svelte-7deygj .jse-space.svelte-7deygj{flex:1}.jse-menu.svelte-7deygj .jse-separator.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.3;width:1px;margin:3px}');
}
var gI = function(e) {
    return {};
}, yI = function(e) {
    return {};
};
function bI(e, t, n) {
    var r = e.slice();
    return r[3] = t[n], r;
}
var wI = function(e) {
    return {};
}, xI = function(e) {
    return {};
};
function kI(e) {
    var t, n = EI(e[3]) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = EI(e[3]) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function jI(e) {
    var t, n, r, o, i, a, s, c, l = e[3].icon && $I(e), u = e[3].text && _I(e);
    return {
        c: function() {
            t = ji("button"), l && l.c(), n = $i(), u && u.c(), Ai(t, "type", "button"), Ai(t, "class", r = "jse-button " + e[3].className + " svelte-7deygj"), Ai(t, "title", o = e[3].title), t.disabled = i = e[3].disabled || !1;
        },
        m: function(r, o) {
            wi(r, t, o), l && l.m(t, null), pi(t, n), u && u.m(t, null), a = !0, s || (c = Oi(t, "click", function() {
                Yo(e[3].onClick) && e[3].onClick.apply(this, arguments);
            }), s = !0);
        },
        p: function(s, c) {
            (e = s)[3].icon ? l ? (l.p(e, c), 1 & c && xa(l, 1)) : ((l = $I(e)).c(), xa(l, 1), l.m(t, n)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()), e[3].text ? u ? u.p(e, c) : ((u = _I(e)).c(), u.m(t, null)) : u && (u.d(1), u = null), (!a || 1 & c && r !== (r = "jse-button " + e[3].className + " svelte-7deygj")) && Ai(t, "class", r), (!a || 1 & c && o !== (o = e[3].title)) && Ai(t, "title", o), (!a || 1 & c && i !== (i = e[3].disabled || !1)) && (t.disabled = i);
        },
        i: function(e) {
            a || (xa(l), a = !0);
        },
        o: function(e) {
            ka(l), a = !1;
        },
        d: function(e) {
            e && xi(t), l && l.d(), u && u.d(), s = !1, c();
        }
    };
}
function SI(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-space svelte-7deygj");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function CI(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-separator svelte-7deygj");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function $I(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[3].icon
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.data = e[3].icon), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function _I(e) {
    var t, n = e[3].text + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = e[3].text + "") && Ni(t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function OI(e) {
    var t, n, r, o, i, a, s, c = [
        CI,
        SI,
        jI,
        kI
    ], l = [];
    function u(e, o) {
        return 1 & o && (t = null), 1 & o && (n = null), 1 & o && (r = null), null == t && (t = !!oI(e[3])), t ? 0 : (null == n && (n = !!rI(e[3])), n ? 1 : (null == r && (r = !!aI(e[3])), r ? 2 : 3));
    }
    return o = u(e, -1), i = l[o] = c[o](e), {
        c: function() {
            i.c(), a = _i();
        },
        m: function(e, t) {
            l[o].m(e, t), wi(e, a, t), s = !0;
        },
        p: function(e, t) {
            var n = o;
            (o = u(e, t)) === n ? l[o].p(e, t) : (ba(), ka(l[n], 1, 1, function() {
                l[n] = null;
            }), wa(), (i = l[o]) ? i.p(e, t) : (i = l[o] = c[o](e)).c(), xa(i, 1), i.m(a.parentNode, a));
        },
        i: function(e) {
            s || (xa(i), s = !0);
        },
        o: function(e) {
            ka(i), s = !1;
        },
        d: function(e) {
            e && xi(a), l[o].d(e);
        }
    };
}
function MI(e) {
    for(var t, n, r, o, i = e[2].left, a = ei(i, e, e[1], xI), s = Ca(e[0]), c = [], l = 0; l < s.length; l += 1)c[l] = OI(bI(e, s, l));
    var u = function(e) {
        return ka(c[e], 1, 1, function() {
            c[e] = null;
        });
    }, f = e[2].right, d = ei(f, e, e[1], yI);
    return {
        c: function() {
            t = ji("div"), a && a.c(), n = $i();
            for(var e = 0; e < c.length; e += 1)c[e].c();
            r = $i(), d && d.c(), Ai(t, "class", "jse-menu svelte-7deygj");
        },
        m: function(e, i) {
            wi(e, t, i), a && a.m(t, null), pi(t, n);
            for(var s = 0; s < c.length; s += 1)c[s] && c[s].m(t, null);
            pi(t, r), d && d.m(t, null), o = !0;
        },
        p: function(e, n) {
            var l = jo(n, 1)[0];
            if (a && a.p && (!o || 2 & l) && ri(a, i, e, e[1], o ? ni(i, e[1], l, wI) : oi(e[1]), xI), 1 & l) {
                var h;
                for(s = Ca(e[0]), h = 0; h < s.length; h += 1){
                    var v = bI(e, s, h);
                    c[h] ? (c[h].p(v, l), xa(c[h], 1)) : (c[h] = OI(v), c[h].c(), xa(c[h], 1), c[h].m(t, r));
                }
                for(ba(), h = s.length; h < c.length; h += 1)u(h);
                wa();
            }
            d && d.p && (!o || 2 & l) && ri(d, f, e, e[1], o ? ni(f, e[1], l, gI) : oi(e[1]), yI);
        },
        i: function(e) {
            if (!o) {
                xa(a, e);
                for(var t = 0; t < s.length; t += 1)xa(c[t]);
                xa(d, e), o = !0;
            }
        },
        o: function(e) {
            ka(a, e), c = c.filter(Boolean);
            for(var t = 0; t < c.length; t += 1)ka(c[t]);
            ka(d, e), o = !1;
        },
        d: function(e) {
            e && xi(t), a && a.d(e), ki(c, e), d && d.d(e);
        }
    };
}
function EI(e) {
    return console.error("Unknown type of menu item", e), "???";
}
function AI(e, t, n) {
    var r = t.$$slots, o = void 0 === r ? {} : r, i = t.$$scope, a = t.items, s = void 0 === a ? [] : a;
    return e.$$set = function(e) {
        "items" in e && n(0, s = e.items), "$$scope" in e && n(1, i = e.$$scope);
    }, [
        s,
        i,
        o
    ];
}
var PI = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, AI, MI, Zo, {
            items: 0
        }, mI), n;
    }
    return Ao(t, Ia), Do(t);
}();
function TI(e) {
    mi(e, "svelte-1d84pok", '.jse-json-repair-component.svelte-1d84pok.svelte-1d84pok{flex:1;display:flex;flex-direction:column;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-json-repair-component.svelte-1d84pok .jse-menu .jse-info.svelte-1d84pok{padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);vertical-align:center}.jse-json-repair-component.svelte-1d84pok .jse-json-text.svelte-1d84pok{flex:1;border:none;padding:2px;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-input-background, var(--jse-background-color, #fff));color:var(--jse-text-color, #4d4d4d);resize:none;outline:none}');
}
function RI(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = "Repair invalid JSON, then click apply", Ai(t, "slot", "left"), Ai(t, "class", "jse-info svelte-1d84pok");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function NI(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "success",
            message: "JSON is valid now and can be parsed.",
            actions: e[5]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            32 & n && (r.actions = e[5]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function II(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "error",
            icon: TP,
            message: "Cannot parse JSON: ".concat(e[2].message),
            actions: e[6]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            4 & n && (r.message = "Cannot parse JSON: ".concat(e[2].message)), 64 & n && (r.actions = e[6]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function DI(e) {
    var t, n, r, o, i, a, s, c, l, u;
    n = new PI({
        props: {
            items: e[4],
            $$slots: {
                left: [
                    RI
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    });
    var f = [
        II,
        NI
    ], d = [];
    function h(e, t) {
        return e[2] ? 0 : 1;
    }
    return o = h(e), i = d[o] = f[o](e), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), r = $i(), i.c(), a = $i(), (s = ji("textarea")).readOnly = e[1], Ai(s, "class", "jse-json-text svelte-1d84pok"), Ai(s, "autocomplete", "off"), Ai(s, "autocapitalize", "off"), Ai(s, "spellcheck", "false"), s.value = e[0], Ai(t, "class", "jse-json-repair-component svelte-1d84pok");
        },
        m: function(i, f) {
            wi(i, t, f), Ta(n, t, null), pi(t, r), d[o].m(t, null), pi(t, a), pi(t, s), e[16](s), c = !0, l || (u = Oi(s, "input", e[7]), l = !0);
        },
        p: function(e, r) {
            var l = jo(r, 1)[0], u = {};
            16 & l && (u.items = e[4]), 8388608 & l && (u.$$scope = {
                dirty: l,
                ctx: e
            }), n.$set(u);
            var v = o;
            (o = h(e)) === v ? d[o].p(e, l) : (ba(), ka(d[v], 1, 1, function() {
                d[v] = null;
            }), wa(), (i = d[o]) ? i.p(e, l) : (i = d[o] = f[o](e)).c(), xa(i, 1), i.m(t, a)), (!c || 2 & l) && (s.readOnly = e[1]), (!c || 1 & l) && (s.value = e[0]);
        },
        i: function(e) {
            c || (xa(n.$$.fragment, e), xa(i), c = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), ka(i), c = !1;
        },
        d: function(r) {
            r && xi(t), Ra(n), d[o].d(), e[16](null), l = !1, u();
        }
    };
}
function zI(e, t, n) {
    var r, o, i, a, s, c, l, u, f = t.text, d = void 0 === f ? "" : f, h = t.readOnly, v = void 0 !== h && h, p = t.onParse, m = t.onRepair, g = t.onChange, y = void 0 === g ? null : g, b = t.onApply, w = t.onCancel, x = Da("jsoneditor:JSONRepair");
    function k() {
        b(d);
    }
    return e.$$set = function(e) {
        "text" in e && n(0, d = e.text), "readOnly" in e && n(1, v = e.readOnly), "onParse" in e && n(8, p = e.onParse), "onRepair" in e && n(9, m = e.onRepair), "onChange" in e && n(10, y = e.onChange), "onApply" in e && n(11, b = e.onApply), "onCancel" in e && n(12, w = e.onCancel);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(2, r = function(e) {
            try {
                return p(e), null;
            } catch (t) {
                return H_(e, t.message);
            }
        }(d)), 1 & e.$$.dirty && n(15, o = function(e) {
            try {
                return m(e), !0;
            } catch (e) {
                return !1;
            }
        }(d)), 4 & e.$$.dirty && x("error", r), 4096 & e.$$.dirty && n(4, u = [
            {
                type: "space"
            },
            {
                type: "button",
                icon: MP,
                title: "Cancel repair",
                className: "jse-cancel",
                onClick: w
            }
        ]), 57344 & e.$$.dirty && n(6, s = o ? [
            i,
            a
        ] : [
            i
        ]), 2 & e.$$.dirty && n(5, c = [
            {
                icon: PP,
                text: "Apply",
                title: "Apply fixed JSON",
                disabled: v,
                onClick: k
            }
        ]);
    }, n(13, i = {
        icon: kP,
        text: "Show me",
        title: "Scroll to the error location",
        onClick: function() {
            if (l && r) {
                var e = null != r.position ? r.position : 0;
                l.setSelectionRange(e, e), l.focus();
            }
        }
    }), n(14, a = {
        icon: uP,
        text: "Auto repair",
        title: "Automatically repair JSON",
        onClick: function() {
            try {
                n(0, d = m(d)), y && y(d);
            } catch (e) {}
        }
    }), [
        d,
        v,
        r,
        l,
        u,
        c,
        s,
        function(e) {
            x("handleChange");
            var t = e.target.value;
            d !== t && (n(0, d = t), y && y(d));
        },
        p,
        m,
        y,
        b,
        w,
        i,
        a,
        o,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(3, l = e);
            });
        }
    ];
}
var qI = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, zI, DI, Zo, {
            text: 0,
            readOnly: 1,
            onParse: 8,
            onRepair: 9,
            onChange: 10,
            onApply: 11,
            onCancel: 12
        }, TI), n;
    }
    return Ao(t, Ia), Do(t);
}(), BI = [];
function LI(e) {
    if ("Escape" === e.key) {
        var t = vb(BI);
        t && t();
    }
}
function FI(e, t) {
    return _x(BI) && window.addEventListener("keydown", LI), BI.push(t), {
        destroy: function() {
            _x(BI = BI.filter(function(e) {
                return e !== t;
            })) && window.removeEventListener("keydown", LI);
        }
    };
}
function VI(e) {
    mi(e, "svelte-rn18r0", '.jse-modal.jse-repair.svelte-rn18r0{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}');
}
function HI(e) {
    var t, n, r, o, i, a;
    function s(t) {
        e[7](t);
    }
    var c = {
        onParse: e[1],
        onRepair: e[2],
        onApply: e[4],
        onCancel: e[5]
    };
    return void 0 !== e[0] && (c.text = e[0]), n = new qI({
        props: c
    }), na.push(function() {
        return Aa(n, "text", s);
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-modal jse-repair svelte-rn18r0");
        },
        m: function(r, s) {
            wi(r, t, s), Ta(n, t, null), o = !0, i || (a = ci(FI.call(null, t, e[3])), i = !0);
        },
        p: function(e, t) {
            var o = jo(t, 1)[0], i = {};
            2 & o && (i.onParse = e[1]), 4 & o && (i.onRepair = e[2]), !r && 1 & o && (r = !0, i.text = e[0], ua(function() {
                return r = !1;
            })), n.$set(i);
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, a();
        }
    };
}
function WI(e, t, n) {
    var r = t.text, o = t.onParse, i = t.onRepair, a = t.onApply, s = Zi("simple-modal").close;
    return e.$$set = function(e) {
        "text" in e && n(0, r = e.text), "onParse" in e && n(1, o = e.onParse), "onRepair" in e && n(2, i = e.onRepair), "onApply" in e && n(6, a = e.onApply);
    }, [
        r,
        o,
        i,
        s,
        function(e) {
            s(), a(e);
        },
        function() {
            s();
        },
        a,
        function(e) {
            n(0, r = e);
        }
    ];
}
var UI = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, WI, HI, Zo, {
            text: 0,
            onParse: 1,
            onRepair: 2,
            onApply: 6
        }, VI), n;
    }
    return Ao(t, Ia), Do(t);
}();
function JI(e) {
    mi(e, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function KI(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[0].icon
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.data = e[0].icon), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function GI(e) {
    var t, n = e[0].text + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = e[0].text + "") && Ni(t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function QI(e) {
    var t, n, r, o, i, a, s, c, l = e[0].icon && KI(e), u = e[0].text && GI(e);
    return {
        c: function() {
            t = ji("button"), l && l.c(), n = $i(), u && u.c(), Ai(t, "type", "button"), Ai(t, "class", r = si(GE("jse-context-menu-button", e[1], e[0].className)) + " svelte-szeu2l"), Ai(t, "title", o = e[0].title), t.disabled = i = e[0].disabled || !1;
        },
        m: function(r, o) {
            wi(r, t, o), l && l.m(t, null), pi(t, n), u && u.m(t, null), a = !0, s || (c = Oi(t, "click", e[3]), s = !0);
        },
        p: function(e, s) {
            var c = jo(s, 1)[0];
            e[0].icon ? l ? (l.p(e, c), 1 & c && xa(l, 1)) : ((l = KI(e)).c(), xa(l, 1), l.m(t, n)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()), e[0].text ? u ? u.p(e, c) : ((u = GI(e)).c(), u.m(t, null)) : u && (u.d(1), u = null), (!a || 3 & c && r !== (r = si(GE("jse-context-menu-button", e[1], e[0].className)) + " svelte-szeu2l")) && Ai(t, "class", r), (!a || 1 & c && o !== (o = e[0].title)) && Ai(t, "title", o), (!a || 1 & c && i !== (i = e[0].disabled || !1)) && (t.disabled = i);
        },
        i: function(e) {
            a || (xa(l), a = !0);
        },
        o: function(e) {
            ka(l), a = !1;
        },
        d: function(e) {
            e && xi(t), l && l.d(), u && u.d(), s = !1, c();
        }
    };
}
function YI(e, t, n) {
    var r = t.item, o = t.className, i = void 0 === o ? void 0 : o, a = t.onCloseContextMenu;
    return e.$$set = function(e) {
        "item" in e && n(0, r = e.item), "className" in e && n(1, i = e.className), "onCloseContextMenu" in e && n(2, a = e.onCloseContextMenu);
    }, [
        r,
        i,
        a,
        function(e) {
            a(), r.onClick(e);
        }
    ];
}
var XI = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, YI, QI, Xo, {
            item: 0,
            className: 1,
            onCloseContextMenu: 2
        }, JI), n;
    }
    return Ao(t, Ia), Do(t);
}();
function ZI(e) {
    mi(e, "svelte-9i012w", '.jse-dropdown-button.svelte-9i012w.svelte-9i012w{flex:1;line-height:normal;border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;position:relative;padding:0;display:flex}.jse-dropdown-button.svelte-9i012w ul.svelte-9i012w{margin:0;padding:0}.jse-dropdown-button.svelte-9i012w ul li.svelte-9i012w{margin:0;padding:0;list-style-type:none}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:2em;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));border-radius:0}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.jse-visible.svelte-9i012w{background:var(--jse-context-menu-background, #656565)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:focus{z-index:1}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.svelte-9i012w{display:none;position:absolute;top:100%;left:0;z-index:1;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.jse-visible.svelte-9i012w{display:block}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:100%;text-align:left;padding:var(--jse-padding, 10px);margin:0}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}');
}
function eD(e, t, n) {
    var r = e.slice();
    return r[11] = t[n], r;
}
var tD = function(e) {
    return {};
}, nD = function(e) {
    return {};
};
function rD(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[11].icon
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.data = e[11].icon), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function oD(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d = e[11].text + "", h = e[11].icon && rD(e);
    function v() {
        for(var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
        return (t = e)[9].apply(t, [
            e[11]
        ].concat(r));
    }
    return {
        c: function() {
            t = ji("li"), n = ji("button"), h && h.c(), r = $i(), o = Ci(d), c = $i(), Ai(n, "type", "button"), Ai(n, "title", i = e[11].title), n.disabled = a = e[11].disabled, Ai(n, "class", s = si(e[11].className) + " svelte-9i012w"), Ai(t, "class", "svelte-9i012w");
        },
        m: function(e, i) {
            wi(e, t, i), pi(t, n), h && h.m(n, null), pi(n, r), pi(n, o), pi(t, c), l = !0, u || (f = Oi(n, "click", v), u = !0);
        },
        p: function(t, c) {
            (e = t)[11].icon ? h ? (h.p(e, c), 1 & c && xa(h, 1)) : ((h = rD(e)).c(), xa(h, 1), h.m(n, r)) : h && (ba(), ka(h, 1, 1, function() {
                h = null;
            }), wa()), (!l || 1 & c) && d !== (d = e[11].text + "") && Ni(o, d), (!l || 1 & c && i !== (i = e[11].title)) && Ai(n, "title", i), (!l || 1 & c && a !== (a = e[11].disabled)) && (n.disabled = a), (!l || 1 & c && s !== (s = si(e[11].className) + " svelte-9i012w")) && Ai(n, "class", s);
        },
        i: function(e) {
            l || (xa(h), l = !0);
        },
        o: function(e) {
            ka(h), l = !1;
        },
        d: function(e) {
            e && xi(t), h && h.d(), u = !1, f();
        }
    };
}
function iD(e) {
    var t, n, r, o, i, a, s, c, l, u, f = e[8].defaultItem, d = ei(f, e, e[7], nD);
    o = new jM({
        props: {
            data: gP
        }
    });
    for(var h = Ca(e[0]), v = [], p = 0; p < h.length; p += 1)v[p] = oD(eD(e, h, p));
    var m = function(e) {
        return ka(v[e], 1, 1, function() {
            v[e] = null;
        });
    };
    return {
        c: function() {
            t = ji("div"), d && d.c(), n = $i(), r = ji("button"), Pa(o.$$.fragment), i = $i(), a = ji("div"), s = ji("ul");
            for(var c = 0; c < v.length; c += 1)v[c].c();
            Ai(r, "type", "button"), Ai(r, "class", "jse-open-dropdown svelte-9i012w"), Ai(r, "data-type", "jse-open-dropdown"), r.disabled = e[4], qi(r, "jse-visible", e[3]), Ai(s, "class", "svelte-9i012w"), Ai(a, "class", "jse-dropdown-items svelte-9i012w"), Di(a, "width", e[2]), qi(a, "jse-visible", e[3]), Ai(t, "role", "button"), Ai(t, "tabindex", "0"), Ai(t, "class", "jse-dropdown-button svelte-9i012w"), Ai(t, "title", e[1]);
        },
        m: function(f, h) {
            wi(f, t, h), d && d.m(t, null), pi(t, n), pi(t, r), Ta(o, r, null), pi(t, i), pi(t, a), pi(a, s);
            for(var p = 0; p < v.length; p += 1)v[p] && v[p].m(s, null);
            c = !0, l || (u = [
                Oi(r, "click", e[5]),
                Oi(t, "click", e[6])
            ], l = !0);
        },
        p: function(e, n) {
            var o = jo(n, 1)[0];
            if (d && d.p && (!c || 128 & o) && ri(d, f, e, e[7], c ? ni(f, e[7], o, tD) : oi(e[7]), nD), (!c || 16 & o) && (r.disabled = e[4]), (!c || 8 & o) && qi(r, "jse-visible", e[3]), 1 & o) {
                var i;
                for(h = Ca(e[0]), i = 0; i < h.length; i += 1){
                    var l = eD(e, h, i);
                    v[i] ? (v[i].p(l, o), xa(v[i], 1)) : (v[i] = oD(l), v[i].c(), xa(v[i], 1), v[i].m(s, null));
                }
                for(ba(), i = h.length; i < v.length; i += 1)m(i);
                wa();
            }
            (!c || 4 & o) && Di(a, "width", e[2]), (!c || 8 & o) && qi(a, "jse-visible", e[3]), (!c || 2 & o) && Ai(t, "title", e[1]);
        },
        i: function(e) {
            if (!c) {
                xa(d, e), xa(o.$$.fragment, e);
                for(var t = 0; t < h.length; t += 1)xa(v[t]);
                c = !0;
            }
        },
        o: function(e) {
            ka(d, e), ka(o.$$.fragment, e), v = v.filter(Boolean);
            for(var t = 0; t < v.length; t += 1)ka(v[t]);
            c = !1;
        },
        d: function(e) {
            e && xi(t), d && d.d(e), Ra(o), ki(v, e), l = !1, Qo(u);
        }
    };
}
function aD(e, t, n) {
    var r, o = t.$$slots, i = void 0 === o ? {} : o, a = t.$$scope, s = t.items, c = void 0 === s ? [] : s, l = t.title, u = void 0 === l ? void 0 : l, f = t.width, d = void 0 === f ? "120px" : f, h = !1;
    function v() {
        n(3, h = !1);
    }
    function p(e) {
        "Escape" === PO(e) && (e.preventDefault(), n(3, h = !1));
    }
    Gi(function() {
        document.addEventListener("click", v), document.addEventListener("keydown", p);
    }), Qi(function() {
        document.removeEventListener("click", v), document.removeEventListener("keydown", p);
    });
    return e.$$set = function(e) {
        "items" in e && n(0, c = e.items), "title" in e && n(1, u = e.title), "width" in e && n(2, d = e.width), "$$scope" in e && n(7, a = e.$$scope);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(4, r = c.every(function(e) {
            return !0 === e.disabled;
        }));
    }, [
        c,
        u,
        d,
        h,
        r,
        function() {
            var e = h;
            setTimeout(function() {
                return n(3, h = !e);
            });
        },
        v,
        a,
        i,
        function(e, t) {
            return e.onClick(t);
        }
    ];
}
var sD = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, aD, iD, Zo, {
            items: 0,
            title: 1,
            width: 2
        }, ZI), n;
    }
    return Ao(t, Ia), Do(t);
}();
function cD(e) {
    mi(e, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function lD(e) {
    var t, n;
    return t = new jM({
        props: {
            data: e[0].main.icon
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.data = e[0].main.icon), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function uD(e) {
    var t, n, r, o, i, a, s, c, l, u = e[0].main.text + "", f = e[0].main.icon && lD(e);
    return {
        c: function() {
            t = ji("button"), f && f.c(), n = $i(), r = Ci(u), Ai(t, "class", o = si(GE("jse-context-menu-button", e[1], e[0].main.className)) + " svelte-szeu2l"), Ai(t, "type", "button"), Ai(t, "slot", "defaultItem"), Ai(t, "title", i = e[0].main.title), t.disabled = a = e[0].main.disabled || !1;
        },
        m: function(o, i) {
            wi(o, t, i), f && f.m(t, null), pi(t, n), pi(t, r), s = !0, c || (l = Oi(t, "click", e[3]), c = !0);
        },
        p: function(e, c) {
            e[0].main.icon ? f ? (f.p(e, c), 1 & c && xa(f, 1)) : ((f = lD(e)).c(), xa(f, 1), f.m(t, n)) : f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa()), (!s || 1 & c) && u !== (u = e[0].main.text + "") && Ni(r, u), (!s || 3 & c && o !== (o = si(GE("jse-context-menu-button", e[1], e[0].main.className)) + " svelte-szeu2l")) && Ai(t, "class", o), (!s || 1 & c && i !== (i = e[0].main.title)) && Ai(t, "title", i), (!s || 1 & c && a !== (a = e[0].main.disabled || !1)) && (t.disabled = a);
        },
        i: function(e) {
            s || (xa(f), s = !0);
        },
        o: function(e) {
            ka(f), s = !1;
        },
        d: function(e) {
            e && xi(t), f && f.d(), c = !1, l();
        }
    };
}
function fD(e) {
    var t, n;
    return t = new sD({
        props: {
            width: e[0].width,
            items: e[0].items,
            $$slots: {
                defaultItem: [
                    uD
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = jo(n, 1)[0], o = {};
            1 & r && (o.width = e[0].width), 1 & r && (o.items = e[0].items), 23 & r && (o.$$scope = {
                dirty: r,
                ctx: e
            }), t.$set(o);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function dD(e, t, n) {
    var r = t.item, o = t.className, i = void 0 === o ? void 0 : o, a = t.onCloseContextMenu;
    return e.$$set = function(e) {
        "item" in e && n(0, r = e.item), "className" in e && n(1, i = e.className), "onCloseContextMenu" in e && n(2, a = e.onCloseContextMenu);
    }, [
        r,
        i,
        a,
        function(e) {
            a(), r.main.onClick(e);
        }
    ];
}
var hD = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, dD, fD, Xo, {
            item: 0,
            className: 1,
            onCloseContextMenu: 2
        }, cD), n;
    }
    return Ao(t, Ia), Do(t);
}();
function vD(e) {
    mi(e, "svelte-fnyc8j", '.jse-contextmenu.svelte-fnyc8j.svelte-fnyc8j{box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff))}.jse-contextmenu.svelte-fnyc8j .jse-row.svelte-fnyc8j{display:flex;flex-direction:row;align-items:flex-start;justify-content:stretch}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-label.svelte-fnyc8j{flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:var(--jse-context-menu-color-disabled, #9d9d9d);line-height:normal}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-tip.svelte-fnyc8j{flex:1;background:var(--jse-context-menu-tip-background, rgba(255, 255, 255, 0.2));color:var(--context-menu-tip-color, inherit);margin:calc(0.5 * var(--jse-padding, 10px));padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);font-size:80%;line-height:1.3em;display:flex;flex-direction:row;align-items:flex-start;gap:var(--jse-padding, 10px);border-radius:3px}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-tip div.jse-tip-icon.svelte-fnyc8j{padding-top:calc(0.5 * var(--jse-padding, 10px))}.jse-contextmenu.svelte-fnyc8j .jse-column.svelte-fnyc8j{flex:1;display:flex;flex-direction:column;align-items:stretch}.jse-contextmenu.svelte-fnyc8j .jse-column.svelte-fnyc8j:not(:last-child){border-right:1px solid var(--jse-context-menu-separator-color, #7a7a7a)}.jse-contextmenu.svelte-fnyc8j .jse-separator.svelte-fnyc8j{width:100%;height:1px;background:var(--jse-context-menu-separator-color, #7a7a7a)}');
}
function pD(e, t, n) {
    var r = e.slice();
    return r[7] = t[n], r;
}
function mD(e, t, n) {
    var r = e.slice();
    return r[10] = t[n], r;
}
function gD(e, t, n) {
    var r = e.slice();
    return r[13] = t[n], r;
}
function yD(e) {
    var t, n = zD(e[7]) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = zD(e[7]) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function bD(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-separator svelte-fnyc8j");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function wD(e) {
    for(var t, n, r = Ca(e[7].items), o = [], i = 0; i < r.length; i += 1)o[i] = RD(mD(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            t = ji("div");
            for(var e = 0; e < o.length; e += 1)o[e].c();
            Ai(t, "class", "jse-row svelte-fnyc8j");
        },
        m: function(e, r) {
            wi(e, t, r);
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(t, null);
            n = !0;
        },
        p: function(e, n) {
            if (3 & n) {
                var i;
                for(r = Ca(e[7].items), i = 0; i < r.length; i += 1){
                    var s = mD(e, r, i);
                    o[i] ? (o[i].p(s, n), xa(o[i], 1)) : (o[i] = RD(s), o[i].c(), xa(o[i], 1), o[i].m(t, null));
                }
                for(ba(), i = r.length; i < o.length; i += 1)a(i);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function xD(e) {
    var t, n;
    return t = new hD({
        props: {
            item: e[7],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[7]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function kD(e) {
    var t, n;
    return t = new XI({
        props: {
            item: e[7],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[7]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function jD(e) {
    var t, n = zD(e[10]) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = zD(e[10]) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function SD(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-separator svelte-fnyc8j");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function CD(e) {
    for(var t, n, r = Ca(e[10].items), o = [], i = 0; i < r.length; i += 1)o[i] = TD(gD(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            t = ji("div");
            for(var e = 0; e < o.length; e += 1)o[e].c();
            Ai(t, "class", "jse-column svelte-fnyc8j");
        },
        m: function(e, r) {
            wi(e, t, r);
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(t, null);
            n = !0;
        },
        p: function(e, n) {
            if (3 & n) {
                var i;
                for(r = Ca(e[10].items), i = 0; i < r.length; i += 1){
                    var s = gD(e, r, i);
                    o[i] ? (o[i].p(s, n), xa(o[i], 1)) : (o[i] = TD(s), o[i].c(), xa(o[i], 1), o[i].m(t, null));
                }
                for(ba(), i = r.length; i < o.length; i += 1)a(i);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function $D(e) {
    var t, n;
    return t = new hD({
        props: {
            item: e[10],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[10]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function _D(e) {
    var t, n;
    return t = new XI({
        props: {
            item: e[10],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[10]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function OD(e) {
    var t, n = zD(e[13]) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            1 & r && n !== (n = zD(e[13]) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function MD(e) {
    var t, n, r = e[13].text + "";
    return {
        c: function() {
            t = ji("div"), n = Ci(r), Ai(t, "class", "jse-label svelte-fnyc8j");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            1 & t && r !== (r = e[13].text + "") && Ni(n, r);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function ED(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("div"), "class", "jse-separator svelte-fnyc8j");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function AD(e) {
    var t, n;
    return t = new hD({
        props: {
            className: "left",
            item: e[13],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[13]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function PD(e) {
    var t, n;
    return t = new XI({
        props: {
            className: "left",
            item: e[13],
            onCloseContextMenu: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n && (r.item = e[13]), 2 & n && (r.onCloseContextMenu = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function TD(e) {
    var t, n, r, o, i, a, s, c, l = [
        PD,
        AD,
        ED,
        MD,
        OD
    ], u = [];
    function f(e, i) {
        return 1 & i && (t = null), 1 & i && (n = null), 1 & i && (r = null), 1 & i && (o = null), null == t && (t = !!aI(e[13])), t ? 0 : (null == n && (n = !!sI(e[13])), n ? 1 : (null == r && (r = !!oI(e[13])), r ? 2 : (null == o && (o = !!iI(e[13])), o ? 3 : 4)));
    }
    return i = f(e, -1), a = u[i] = l[i](e), {
        c: function() {
            a.c(), s = _i();
        },
        m: function(e, t) {
            u[i].m(e, t), wi(e, s, t), c = !0;
        },
        p: function(e, t) {
            var n = i;
            (i = f(e, t)) === n ? u[i].p(e, t) : (ba(), ka(u[n], 1, 1, function() {
                u[n] = null;
            }), wa(), (a = u[i]) ? a.p(e, t) : (a = u[i] = l[i](e)).c(), xa(a, 1), a.m(s.parentNode, s));
        },
        i: function(e) {
            c || (xa(a), c = !0);
        },
        o: function(e) {
            ka(a), c = !1;
        },
        d: function(e) {
            e && xi(s), u[i].d(e);
        }
    };
}
function RD(e) {
    var t, n, r, o, i, a, s, c, l = [
        _D,
        $D,
        CD,
        SD,
        jD
    ], u = [];
    function f(e, i) {
        return 1 & i && (t = null), 1 & i && (n = null), 1 & i && (r = null), 1 & i && (o = null), null == t && (t = !!aI(e[10])), t ? 0 : (null == n && (n = !!sI(e[10])), n ? 1 : (null == r && (r = !!lI(e[10])), r ? 2 : (null == o && (o = !!oI(e[10])), o ? 3 : 4)));
    }
    return i = f(e, -1), a = u[i] = l[i](e), {
        c: function() {
            a.c(), s = _i();
        },
        m: function(e, t) {
            u[i].m(e, t), wi(e, s, t), c = !0;
        },
        p: function(e, t) {
            var n = i;
            (i = f(e, t)) === n ? u[i].p(e, t) : (ba(), ka(u[n], 1, 1, function() {
                u[n] = null;
            }), wa(), (a = u[i]) ? a.p(e, t) : (a = u[i] = l[i](e)).c(), xa(a, 1), a.m(s.parentNode, s));
        },
        i: function(e) {
            c || (xa(a), c = !0);
        },
        o: function(e) {
            ka(a), c = !1;
        },
        d: function(e) {
            e && xi(s), u[i].d(e);
        }
    };
}
function ND(e) {
    var t, n, r, o, i, a, s, c, l = [
        kD,
        xD,
        wD,
        bD,
        yD
    ], u = [];
    function f(e, i) {
        return 1 & i && (t = null), 1 & i && (n = null), 1 & i && (r = null), 1 & i && (o = null), null == t && (t = !!aI(e[7])), t ? 0 : (null == n && (n = !!sI(e[7])), n ? 1 : (null == r && (r = !!cI(e[7])), r ? 2 : (null == o && (o = !!oI(e[7])), o ? 3 : 4)));
    }
    return i = f(e, -1), a = u[i] = l[i](e), {
        c: function() {
            a.c(), s = _i();
        },
        m: function(e, t) {
            u[i].m(e, t), wi(e, s, t), c = !0;
        },
        p: function(e, t) {
            var n = i;
            (i = f(e, t)) === n ? u[i].p(e, t) : (ba(), ka(u[n], 1, 1, function() {
                u[n] = null;
            }), wa(), (a = u[i]) ? a.p(e, t) : (a = u[i] = l[i](e)).c(), xa(a, 1), a.m(s.parentNode, s));
        },
        i: function(e) {
            c || (xa(a), c = !0);
        },
        o: function(e) {
            ka(a), c = !1;
        },
        d: function(e) {
            e && xi(s), u[i].d(e);
        }
    };
}
function ID(e) {
    var t, n, r, o, i, a, s, c;
    return o = new jM({
        props: {
            data: oM
        }
    }), {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("div"), Pa(o.$$.fragment), i = $i(), a = ji("div"), s = Ci(e[2]), Ai(r, "class", "jse-tip-icon svelte-fnyc8j"), Ai(a, "class", "jse-tip-text"), Ai(n, "class", "jse-tip svelte-fnyc8j"), Ai(t, "class", "jse-row svelte-fnyc8j");
        },
        m: function(e, l) {
            wi(e, t, l), pi(t, n), pi(n, r), Ta(o, r, null), pi(n, i), pi(n, a), pi(a, s), c = !0;
        },
        p: function(e, t) {
            (!c || 4 & t) && Ni(s, e[2]);
        },
        i: function(e) {
            c || (xa(o.$$.fragment, e), c = !0);
        },
        o: function(e) {
            ka(o.$$.fragment, e), c = !1;
        },
        d: function(e) {
            e && xi(t), Ra(o);
        }
    };
}
function DD(e) {
    for(var t, n, r, o, i, a = Ca(e[0]), s = [], c = 0; c < a.length; c += 1)s[c] = ND(pD(e, a, c));
    var l = function(e) {
        return ka(s[e], 1, 1, function() {
            s[e] = null;
        });
    }, u = e[2] && ID(e);
    return {
        c: function() {
            t = ji("div");
            for(var e = 0; e < s.length; e += 1)s[e].c();
            n = $i(), u && u.c(), Ai(t, "role", "menu"), Ai(t, "tabindex", "-1"), Ai(t, "class", "jse-contextmenu svelte-fnyc8j");
        },
        m: function(a, c) {
            wi(a, t, c);
            for(var l = 0; l < s.length; l += 1)s[l] && s[l].m(t, null);
            pi(t, n), u && u.m(t, null), e[5](t), r = !0, o || (i = Oi(t, "keydown", e[4]), o = !0);
        },
        p: function(e, r) {
            var o = jo(r, 1)[0];
            if (3 & o) {
                var i;
                for(a = Ca(e[0]), i = 0; i < a.length; i += 1){
                    var c = pD(e, a, i);
                    s[i] ? (s[i].p(c, o), xa(s[i], 1)) : (s[i] = ND(c), s[i].c(), xa(s[i], 1), s[i].m(t, n));
                }
                for(ba(), i = a.length; i < s.length; i += 1)l(i);
                wa();
            }
            e[2] ? u ? (u.p(e, o), 4 & o && xa(u, 1)) : ((u = ID(e)).c(), xa(u, 1), u.m(t, null)) : u && (ba(), ka(u, 1, 1, function() {
                u = null;
            }), wa());
        },
        i: function(e) {
            if (!r) {
                for(var t = 0; t < a.length; t += 1)xa(s[t]);
                xa(u), r = !0;
            }
        },
        o: function(e) {
            s = s.filter(Boolean);
            for(var t = 0; t < s.length; t += 1)ka(s[t]);
            ka(u), r = !1;
        },
        d: function(n) {
            n && xi(t), ki(s, n), u && u.d(), e[5](null), o = !1, i();
        }
    };
}
function zD(e) {
    return console.error("Unknown type of context menu item", e), "???";
}
function qD(e, t, n) {
    var r, o = t.items, i = t.onCloseContextMenu, a = t.tip;
    Gi(function() {
        var e = Array.from(r.querySelectorAll("button")).find(function(e) {
            return !e.disabled;
        });
        e && e.focus();
    });
    var s = {
        ArrowUp: "Up",
        ArrowDown: "Down",
        ArrowLeft: "Left",
        ArrowRight: "Right"
    };
    return e.$$set = function(e) {
        "items" in e && n(0, o = e.items), "onCloseContextMenu" in e && n(1, i = e.onCloseContextMenu), "tip" in e && n(2, a = e.tip);
    }, [
        o,
        i,
        a,
        r,
        function(e) {
            var t = PO(e), n = s[t];
            if (n && e.target) {
                e.preventDefault();
                var o = EO({
                    allElements: Array.from(r.querySelectorAll("button:not([disabled])")),
                    currentElement: e.target,
                    direction: n,
                    hasPrio: function(e) {
                        return "jse-open-dropdown" !== e.getAttribute("data-type");
                    }
                });
                o && o.focus();
            }
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(3, r = e);
            });
        }
    ];
}
var BD = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, qD, DD, Zo, {
            items: 0,
            onCloseContextMenu: 1,
            tip: 2
        }, vD), n;
    }
    return Ao(t, Ia), Do(t);
}();
function LD(e) {
    var t, n;
    return t = new BD({
        props: {
            items: e[2],
            onCloseContextMenu: e[1],
            tip: e[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            4 & n[0] && (r.items = e[2]), 2 & n[0] && (r.onCloseContextMenu = e[1]), 1 & n[0] && (r.tip = e[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function FD(e, t, n) {
    var r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S = t.json, C = t.documentState, $ = t.parser, _ = t.showTip, O = t.onCloseContextMenu, M = t.onRenderContextMenu, E = t.onEditKey, A = t.onEditValue, P = t.onToggleEnforceString, T = t.onCut, R = t.onCopy, N = t.onPaste, I = t.onRemove, D = t.onDuplicate, z = t.onExtract, q = t.onInsertBefore, B = t.onInsert, L = t.onConvert, F = t.onInsertAfter, V = t.onSort, H = t.onTransform;
    function W(e) {
        l ? L(e) : B(e);
    }
    return e.$$set = function(e) {
        "json" in e && n(3, S = e.json), "documentState" in e && n(4, C = e.documentState), "parser" in e && n(5, $ = e.parser), "showTip" in e && n(0, _ = e.showTip), "onCloseContextMenu" in e && n(1, O = e.onCloseContextMenu), "onRenderContextMenu" in e && n(6, M = e.onRenderContextMenu), "onEditKey" in e && n(7, E = e.onEditKey), "onEditValue" in e && n(8, A = e.onEditValue), "onToggleEnforceString" in e && n(9, P = e.onToggleEnforceString), "onCut" in e && n(10, T = e.onCut), "onCopy" in e && n(11, R = e.onCopy), "onPaste" in e && n(12, N = e.onPaste), "onRemove" in e && n(13, I = e.onRemove), "onDuplicate" in e && n(14, D = e.onDuplicate), "onExtract" in e && n(15, z = e.onExtract), "onInsertBefore" in e && n(16, q = e.onInsertBefore), "onInsert" in e && n(17, B = e.onInsert), "onConvert" in e && n(18, L = e.onConvert), "onInsertAfter" in e && n(19, F = e.onInsertAfter), "onSort" in e && n(20, V = e.onSort), "onTransform" in e && n(21, H = e.onTransform);
    }, e.$$.update = function() {
        16 & e.$$.dirty[0] && n(39, r = C.selection), 8 & e.$$.dirty[0] && n(41, o = void 0 !== S), 256 & e.$$.dirty[1] && n(33, i = !!r), 256 & e.$$.dirty[1] && n(23, a = !!r && _x(JE(r))), 8 & e.$$.dirty[0] | 256 & e.$$.dirty[1] && n(40, s = r ? Ws(S, JE(r)) : void 0), 512 & e.$$.dirty[1] && n(37, c = Array.isArray(s) ? "Edit array" : Gl(s) ? "Edit object" : "Edit value"), 1280 & e.$$.dirty[1] && n(24, l = o && (mE(r) || vE(r) || pE(r))), 25165824 & e.$$.dirty[0] | 1024 & e.$$.dirty[1] && n(32, u = o && l && !a), 8388608 & e.$$.dirty[0] | 1280 & e.$$.dirty[1] && n(31, f = o && null != r && (mE(r) || pE(r)) && !a), 8388616 & e.$$.dirty[0] | 1280 & e.$$.dirty[1] && n(38, d = o && null != r && ME(r) && !a && !Array.isArray(Ws(S, Qw(JE(r))))), 1280 & e.$$.dirty[1] && n(36, h = o && null != r && ME(r)), 544 & e.$$.dirty[1] && n(34, v = h && !Ql(s)), 16777216 & e.$$.dirty[0] && n(27, p = l), 134217728 & e.$$.dirty[0] && n(26, m = p ? "Convert to:" : "Insert:"), 134217728 & e.$$.dirty[0] | 4 & e.$$.dirty[1] && n(30, g = !p && i), 134217728 & e.$$.dirty[0] | 772 & e.$$.dirty[1] && n(29, y = p ? LE(r) && !Gl(s) : i), 134217728 & e.$$.dirty[0] | 772 & e.$$.dirty[1] && n(28, b = p ? LE(r) && !Array.isArray(s) : i), 134217728 & e.$$.dirty[0] | 772 & e.$$.dirty[1] && n(25, w = p ? LE(r) && Ql(s) : i), 48 & e.$$.dirty[0] | 768 & e.$$.dirty[1] && n(35, x = !(null == r || !s) && oE(s, C.enforceStringMap, Zs(JE(r)), $)), 2142896e3 & e.$$.dirty[0] | 255 & e.$$.dirty[1] && n(22, j = [
            {
                type: "row",
                items: [
                    {
                        type: "button",
                        onClick: function() {
                            return E();
                        },
                        icon: dP,
                        text: "Edit key",
                        title: "Edit the key (Double-click on the key)",
                        disabled: !d
                    },
                    {
                        type: "dropdown-button",
                        main: {
                            type: "button",
                            onClick: function() {
                                return A();
                            },
                            icon: dP,
                            text: c,
                            title: "Edit the value (Double-click on the value)",
                            disabled: !h
                        },
                        width: "11em",
                        items: [
                            {
                                type: "button",
                                icon: dP,
                                text: c,
                                title: "Edit the value (Double-click on the value)",
                                onClick: function() {
                                    return A();
                                },
                                disabled: !h
                            },
                            {
                                type: "button",
                                icon: x ? iM : aM,
                                text: "Enforce string",
                                title: "Enforce keeping the value as string when it contains a numeric value",
                                onClick: function() {
                                    return P();
                                },
                                disabled: !v
                            }
                        ]
                    }
                ]
            },
            {
                type: "separator"
            },
            {
                type: "row",
                items: [
                    {
                        type: "dropdown-button",
                        main: {
                            type: "button",
                            onClick: function() {
                                return T(!0);
                            },
                            icon: eP,
                            text: "Cut",
                            title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                            disabled: !l
                        },
                        width: "10em",
                        items: [
                            {
                                type: "button",
                                icon: eP,
                                text: "Cut formatted",
                                title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                                onClick: function() {
                                    return T(!0);
                                },
                                disabled: !l
                            },
                            {
                                type: "button",
                                icon: eP,
                                text: "Cut compacted",
                                title: "Cut selected contents, without indentation (Ctrl+Shift+X)",
                                onClick: function() {
                                    return T(!1);
                                },
                                disabled: !l
                            }
                        ]
                    },
                    {
                        type: "dropdown-button",
                        main: {
                            type: "button",
                            onClick: function() {
                                return R(!0);
                            },
                            icon: CP,
                            text: "Copy",
                            title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                            disabled: !l
                        },
                        width: "12em",
                        items: [
                            {
                                type: "button",
                                icon: CP,
                                text: "Copy formatted",
                                title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                                onClick: function() {
                                    return R(!0);
                                },
                                disabled: !l
                            },
                            {
                                type: "button",
                                icon: CP,
                                text: "Copy compacted",
                                title: "Copy selected contents, without indentation (Ctrl+Shift+C)",
                                onClick: function() {
                                    return R(!1);
                                },
                                disabled: !l
                            }
                        ]
                    },
                    {
                        type: "button",
                        onClick: function() {
                            return N();
                        },
                        icon: XA,
                        text: "Paste",
                        title: "Paste clipboard contents (Ctrl+V)",
                        disabled: !i
                    }
                ]
            },
            {
                type: "separator"
            },
            {
                type: "row",
                items: [
                    {
                        type: "column",
                        items: [
                            {
                                type: "button",
                                onClick: function() {
                                    return D();
                                },
                                icon: AP,
                                text: "Duplicate",
                                title: "Duplicate selected contents (Ctrl+D)",
                                disabled: !u
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return z();
                                },
                                icon: pP,
                                text: "Extract",
                                title: "Extract selected contents",
                                disabled: !f
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return V();
                                },
                                icon: wP,
                                text: "Sort",
                                title: "Sort array or object contents",
                                disabled: !l
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return H();
                                },
                                icon: cP,
                                text: "Transform",
                                title: "Transform array or object contents (filter, sort, project)",
                                disabled: !l
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return I();
                                },
                                icon: QA,
                                text: "Remove",
                                title: "Remove selected contents (Delete)",
                                disabled: !l
                            }
                        ]
                    },
                    {
                        type: "column",
                        items: [
                            {
                                type: "label",
                                text: m
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return W("structure");
                                },
                                icon: p ? bP : $P,
                                text: "Structure",
                                title: m + " structure",
                                disabled: !g
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return W("object");
                                },
                                icon: p ? bP : $P,
                                text: "Object",
                                title: m + " structure",
                                disabled: !y
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return W("array");
                                },
                                icon: p ? bP : $P,
                                text: "Array",
                                title: m + " array",
                                disabled: !b
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return W("value");
                                },
                                icon: p ? bP : $P,
                                text: "Value",
                                title: m + " value",
                                disabled: !w
                            }
                        ]
                    }
                ]
            },
            {
                type: "separator"
            },
            {
                type: "row",
                items: [
                    {
                        type: "button",
                        onClick: function() {
                            return q();
                        },
                        icon: aP,
                        text: "Insert before",
                        title: "Select area before current entry to insert or paste contents",
                        disabled: !l || a
                    },
                    {
                        type: "button",
                        onClick: function() {
                            return F();
                        },
                        icon: tP,
                        text: "Insert after",
                        title: "Select area after current entry to insert or paste contents",
                        disabled: !l || a
                    }
                ]
            }
        ]), 4194368 & e.$$.dirty[0] && n(2, k = M(j));
    }, [
        _,
        O,
        k,
        S,
        C,
        $,
        M,
        E,
        A,
        P,
        T,
        R,
        N,
        I,
        D,
        z,
        q,
        B,
        L,
        F,
        V,
        H,
        j,
        a,
        l,
        w,
        m,
        p,
        b,
        y,
        g,
        f,
        u,
        i,
        v,
        x,
        h,
        c,
        d,
        r,
        s,
        o
    ];
}
var VD = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, FD, LD, Zo, {
            json: 3,
            documentState: 4,
            parser: 5,
            showTip: 0,
            onCloseContextMenu: 1,
            onRenderContextMenu: 6,
            onEditKey: 7,
            onEditValue: 8,
            onToggleEnforceString: 9,
            onCut: 10,
            onCopy: 11,
            onPaste: 12,
            onRemove: 13,
            onDuplicate: 14,
            onExtract: 15,
            onInsertBefore: 16,
            onInsert: 17,
            onConvert: 18,
            onInsertAfter: 19,
            onSort: 20,
            onTransform: 21
        }, null, [
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t);
}();
function HD(e) {
    mi(e, "svelte-lajpxi", 'div.jse-collapsed-items.svelte-lajpxi.svelte-lajpxi{margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));padding:calc(0.5 * var(--jse-padding, 10px));border:8px solid transparent;border-width:8px 0;background-color:var(--jse-contents-background-color, transparent);background-image:linear-gradient(var(--jse-collapsed-items-background-color, #f5f5f5), var(--jse-collapsed-items-background-color, #f5f5f5)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%);background-repeat:repeat, repeat-x, repeat-x, repeat-x, repeat-x;background-position:0 0, 8px 0, 8px 0, 8px 100%, 8px 100%;background-size:auto auto, 16px 16px, 16px 16px, 16px 16px, 16px 16px;background-clip:padding-box, border-box, border-box, border-box, border-box;background-origin:padding-box, border-box, border-box, border-box, border-box;display:flex}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{margin:0 calc(0.5 * var(--jse-padding, 10px))}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi{display:inline}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{font-family:inherit;font-size:inherit;color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));background:none;border:none;padding:0;text-decoration:underline;cursor:pointer}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:hover,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:focus{color:var(--jse-collapsed-items-link-color-highlight, #ee5341)}');
}
function WD(e, t, n) {
    var r = e.slice();
    return r[13] = t[n], r;
}
function UD(e) {
    var t, n, r, o, i, a, s, c, l = e[13].start + "", u = e[13].end + "";
    function f() {
        return e[12](e[13]);
    }
    return {
        c: function() {
            t = ji("button"), n = Ci("show "), r = Ci(l), o = Ci("-"), i = Ci(u), a = $i(), Ai(t, "type", "button"), Ai(t, "class", "jse-expand-items svelte-lajpxi");
        },
        m: function(e, l) {
            wi(e, t, l), pi(t, n), pi(t, r), pi(t, o), pi(t, i), pi(t, a), s || (c = Oi(t, "click", f), s = !0);
        },
        p: function(t, n) {
            e = t, 16 & n && l !== (l = e[13].start + "") && Ni(r, l), 16 & n && u !== (u = e[13].end + "") && Ni(i, u);
        },
        d: function(e) {
            e && xi(t), s = !1, c();
        }
    };
}
function JD(e) {
    for(var t, n, r, o, i, a, s, c, l, u, f = Ca(e[4]), d = [], h = 0; h < f.length; h += 1)d[h] = UD(WD(e, f, h));
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("div"), o = Ci("Items "), i = Ci(e[3]), a = Ci("-"), s = Ci(e[2]), c = $i();
            for(var l = 0; l < d.length; l += 1)d[l].c();
            Ai(r, "class", "jse-text svelte-lajpxi"), Ai(t, "role", "none"), Ai(t, "class", "jse-collapsed-items svelte-lajpxi"), qi(t, "jse-selected", e[5]), Di(t, "--level", e[0].length + 2);
        },
        m: function(e, f) {
            wi(e, t, f), pi(t, n), pi(n, r), pi(r, o), pi(r, i), pi(r, a), pi(r, s), pi(n, c);
            for(var h = 0; h < d.length; h += 1)d[h] && d[h].m(n, null);
            l || (u = Oi(t, "mousemove", KD), l = !0);
        },
        p: function(e, r) {
            var o = jo(r, 1)[0];
            if (8 & o && Ni(i, e[3]), 4 & o && Ni(s, e[2]), 19 & o) {
                var a;
                for(f = Ca(e[4]), a = 0; a < f.length; a += 1){
                    var c = WD(e, f, a);
                    d[a] ? d[a].p(c, o) : (d[a] = UD(c), d[a].c(), d[a].m(n, null));
                }
                for(; a < d.length; a += 1)d[a].d(1);
                d.length = f.length;
            }
            32 & o && qi(t, "jse-selected", e[5]), 1 & o && Di(t, "--level", e[0].length + 2);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), ki(d, e), l = !1, u();
        }
    };
}
function KD(e) {
    e.stopPropagation();
}
function GD(e, t, n) {
    var r, o, i, a, s, c = t.visibleSections, l = t.sectionIndex, u = t.total, f = t.path, d = t.selection, h = t.onExpandSection, v = t.context;
    return e.$$set = function(e) {
        "visibleSections" in e && n(6, c = e.visibleSections), "sectionIndex" in e && n(7, l = e.sectionIndex), "total" in e && n(8, u = e.total), "path" in e && n(0, f = e.path), "selection" in e && n(9, d = e.selection), "onExpandSection" in e && n(1, h = e.onExpandSection), "context" in e && n(10, v = e.context);
    }, e.$$.update = function() {
        192 & e.$$.dirty && n(11, r = c[l]), 2048 & e.$$.dirty && n(3, o = r.end), 448 & e.$$.dirty && n(2, i = c[l + 1] ? c[l + 1].start : u), 1545 & e.$$.dirty && n(5, a = WE(v.getJson(), d, f.concat(String(o)))), 12 & e.$$.dirty && n(4, s = function(e, t) {
            var n = {
                start: e,
                end: Math.min(zM(e), t)
            }, r = Math.max(qM((e + t) / 2), e), o = {
                start: r,
                end: Math.min(zM(r), t)
            }, i = qM(t), a = i === t ? i - ls : i, s = {
                start: Math.max(a, e),
                end: t
            }, c = [
                n
            ], l = o.start >= n.end && o.end <= s.start;
            return l && c.push(o), s.start >= (l ? o.end : n.end) && c.push(s), c;
        }(o, i));
    }, [
        f,
        h,
        i,
        o,
        s,
        a,
        c,
        l,
        u,
        d,
        v,
        r,
        function(e) {
            return h(f, e);
        }
    ];
}
var QD = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, GD, JD, Zo, {
            visibleSections: 6,
            sectionIndex: 7,
            total: 8,
            path: 0,
            selection: 9,
            onExpandSection: 1,
            context: 10
        }, HD), n;
    }
    return Ao(t, Ia), Do(t);
}();
function YD(e) {
    mi(e, "svelte-6k6355", ".jse-context-menu-pointer.svelte-6k6355{position:absolute;top:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));right:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));width:var(--jse-context-menu-pointer-size, calc(1em + 4px));height:var(--jse-context-menu-pointer-size, calc(1em + 4px));padding:0;margin:0;cursor:pointer;background:transparent;border-radius:2px;background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565));color:var(--jse-context-menu-pointer-color, var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff)));border:none;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-context-menu-pointer.svelte-6k6355:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}");
}
function XD(e) {
    var t, n, r, o, i;
    return n = new jM({
        props: {
            data: gP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-context-menu-pointer svelte-6k6355"), Ai(t, "title", ks), qi(t, "jse-selected", e[0]);
        },
        m: function(a, s) {
            wi(a, t, s), Ta(n, t, null), r = !0, o || (i = Oi(t, "click", e[1]), o = !0);
        },
        p: function(e, n) {
            var o = jo(n, 1)[0];
            (!r || 1 & o) && qi(t, "jse-selected", e[0]);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), o = !1, i();
        }
    };
}
function ZD(e, t, n) {
    var r = t.selected, o = t.onContextMenu;
    return e.$$set = function(e) {
        "selected" in e && n(0, r = e.selected), "onContextMenu" in e && n(2, o = e.onContextMenu);
    }, [
        r,
        function(e) {
            for(var t = e.target; t && "BUTTON" !== t.nodeName;)t = t.parentNode;
            t && o({
                anchor: t,
                left: 0,
                top: 0,
                width: Ms,
                height: Os,
                offsetTop: 2,
                offsetLeft: 0,
                showTip: !0
            });
        },
        o
    ];
}
var ez = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, ZD, XD, Zo, {
            selected: 0,
            onContextMenu: 2
        }, YD), n;
    }
    return Ao(t, Ia), Do(t);
}();
function tz(e) {
    mi(e, "svelte-10xe8tv", '.jse-key.svelte-10xe8tv{display:inline-block;min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;color:var(--jse-key-color, #1a1a1a);cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:normal;white-space:pre-wrap}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.jse-empty.svelte-10xe8tv{min-width:3em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-key.jse-empty.svelte-10xe8tv::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"key"}');
}
function nz(e) {
    var t, n, r, o, i, a, s, c = [
        iz,
        oz
    ], l = [];
    function u(e, t) {
        return e[1] ? 0 : 1;
    }
    return n = u(e), r = l[n] = c[n](e), {
        c: function() {
            t = ji("div"), r.c(), Ai(t, "role", "none"), Ai(t, "data-type", "selectable-key"), Ai(t, "class", o = si(e[6](e[0])) + " svelte-10xe8tv");
        },
        m: function(r, o) {
            wi(r, t, o), l[n].m(t, null), i = !0, a || (s = Oi(t, "dblclick", e[5]), a = !0);
        },
        p: function(e, a) {
            var s = n;
            (n = u(e)) === s ? l[n].p(e, a) : (ba(), ka(l[s], 1, 1, function() {
                l[s] = null;
            }), wa(), (r = l[n]) ? r.p(e, a) : (r = l[n] = c[n](e)).c(), xa(r, 1), r.m(t, null)), (!i || 1 & a && o !== (o = si(e[6](e[0])) + " svelte-10xe8tv")) && Ai(t, "class", o);
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(t), l[n].d(), a = !1, s();
        }
    };
}
function rz(e) {
    var t, n;
    return t = new eA({
        props: {
            value: e[2].normalization.escapeValue(e[0]),
            shortText: !0,
            onChange: e[7],
            onCancel: e[8],
            onFind: e[2].onFind
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            5 & n && (r.value = e[2].normalization.escapeValue(e[0])), 4 & n && (r.onFind = e[2].onFind), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function oz(e) {
    var t, n = gO(e[2].normalization.escapeValue(e[0])) + "";
    return {
        c: function() {
            t = Ci(n);
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: function(e, r) {
            5 & r && n !== (n = gO(e[2].normalization.escapeValue(e[0])) + "") && Ni(t, n);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function iz(e) {
    var t, n;
    return t = new TA({
        props: {
            text: e[2].normalization.escapeValue(e[0]),
            searchResultItems: e[1]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            5 & n && (r.text = e[2].normalization.escapeValue(e[0])), 2 & n && (r.searchResultItems = e[1]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function az(e) {
    var t, n;
    return t = new ez({
        props: {
            selected: !0,
            onContextMenu: e[2].onContextMenu
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            4 & n && (r.onContextMenu = e[2].onContextMenu), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function sz(e) {
    var t, n, r, o, i, a = [
        rz,
        nz
    ], s = [];
    function c(e, t) {
        return !e[2].readOnly && e[4] ? 0 : 1;
    }
    t = c(e), n = s[t] = a[t](e);
    var l = !e[2].readOnly && e[3] && !e[4] && az(e);
    return {
        c: function() {
            n.c(), r = $i(), l && l.c(), o = _i();
        },
        m: function(e, n) {
            s[t].m(e, n), wi(e, r, n), l && l.m(e, n), wi(e, o, n), i = !0;
        },
        p: function(e, i) {
            var u = jo(i, 1)[0], f = t;
            (t = c(e)) === f ? s[t].p(e, u) : (ba(), ka(s[f], 1, 1, function() {
                s[f] = null;
            }), wa(), (n = s[t]) ? n.p(e, u) : (n = s[t] = a[t](e)).c(), xa(n, 1), n.m(r.parentNode, r)), e[2].readOnly || !e[3] || e[4] ? l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()) : l ? (l.p(e, u), 28 & u && xa(l, 1)) : ((l = az(e)).c(), xa(l, 1), l.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(n), xa(l), i = !0);
        },
        o: function(e) {
            ka(n), ka(l), i = !1;
        },
        d: function(e) {
            e && (xi(r), xi(o)), s[t].d(e), l && l.d(e);
        }
    };
}
function cz(e, t, n) {
    var r, o, i = t.path, a = t.key, s = t.selection, c = t.searchResultItems, l = t.onUpdateKey, u = t.context;
    return e.$$set = function(e) {
        "path" in e && n(9, i = e.path), "key" in e && n(0, a = e.key), "selection" in e && n(10, s = e.selection), "searchResultItems" in e && n(1, c = e.searchResultItems), "onUpdateKey" in e && n(11, l = e.onUpdateKey), "context" in e && n(2, u = e.context);
    }, e.$$.update = function() {
        1536 & e.$$.dirty && n(3, r = !!s && vE(s) && Ox(s.path, i)), 1032 & e.$$.dirty && n(4, o = r && qE(s));
    }, [
        a,
        c,
        u,
        r,
        o,
        function(e) {
            o || u.readOnly || (e.preventDefault(), u.onSelect(TE(i, !0)));
        },
        function(e) {
            return GE("jse-key", {
                "jse-empty": "" === e
            });
        },
        function(e, t) {
            var n = l(a, u.normalization.unescapeValue(e)), r = Qw(i).concat(n);
            u.onSelect(t === ns.nextInside ? RE(r, !1) : TE(r, !1)), t !== ns.self && u.focus();
        },
        function() {
            u.onSelect(TE(i, !1)), u.focus();
        },
        i,
        s,
        l
    ];
}
var lz = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, cz, sz, Zo, {
            path: 9,
            key: 0,
            selection: 10,
            searchResultItems: 1,
            onUpdateKey: 11,
            context: 2
        }, tz), n;
    }
    return Ao(t, Ia), Do(t);
}();
function uz(e, t, n) {
    var r = e.slice();
    return r[8] = t[n], r;
}
function fz(e) {
    var t, n, r = e[8].component, o = hz(e);
    return {
        c: function() {
            o.c(), t = _i();
        },
        m: function(e, r) {
            o.m(e, r), wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            1 & n && Zo(r, r = e[8].component) ? (ba(), ka(o, 1, 1, Wo), wa(), (o = hz(e)).c(), xa(o, 1), o.m(t.parentNode, t)) : o.p(e, n);
        },
        i: function(e) {
            n || (xa(o), n = !0);
        },
        o: function(e) {
            ka(o), n = !1;
        },
        d: function(e) {
            e && xi(t), o.d(e);
        }
    };
}
function dz(e) {
    var t, n = e[8].action, r = vz(e);
    return {
        c: function() {
            r.c(), t = _i();
        },
        m: function(e, n) {
            r.m(e, n), wi(e, t, n);
        },
        p: function(e, o) {
            1 & o && Zo(n, n = e[8].action) ? (r.d(1), (r = vz(e)).c(), r.m(t.parentNode, t)) : r.p(e, o);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), r.d(e);
        }
    };
}
function hz(e) {
    var t, n, r, o = [
        e[8].props
    ], i = e[8].component;
    function a(e, t) {
        var n = {};
        if (void 0 !== t && 1 & t) n = Ma(o, [
            Ea(e[8].props)
        ]);
        else for(var r = 0; r < o.length; r += 1)n = Jo(n, o[r]);
        return {
            props: n
        };
    }
    return i && (t = Li(i, a(e))), {
        c: function() {
            t && Pa(t.$$.fragment), n = _i();
        },
        m: function(e, o) {
            t && Ta(t, e, o), wi(e, n, o), r = !0;
        },
        p: function(e, r) {
            if (1 & r && i !== (i = e[8].component)) {
                if (t) {
                    ba();
                    var s = t;
                    ka(s.$$.fragment, 1, 0, function() {
                        Ra(s, 1);
                    }), wa();
                }
                i ? (Pa((t = Li(i, a(e, r))).$$.fragment), xa(t.$$.fragment, 1), Ta(t, n.parentNode, n)) : t = null;
            } else if (i) {
                var c = 1 & r ? Ma(o, [
                    Ea(e[8].props)
                ]) : {};
                t.$set(c);
            }
        },
        i: function(e) {
            r || (t && xa(t.$$.fragment, e), r = !0);
        },
        o: function(e) {
            t && ka(t.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(n), t && Ra(t, e);
        }
    };
}
function vz(e) {
    var t, n, r, o;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "button"), Ai(t, "tabindex", "-1"), Ai(t, "class", "jse-value jse-readonly-password"), Ai(t, "data-type", "selectable-value");
        },
        m: function(i, a) {
            wi(i, t, a), r || (o = ci(n = e[11].call(null, t, e[8].props)), r = !0);
        },
        p: function(t, r) {
            e = t, n && Yo(n.update) && 1 & r && n.update.call(null, e[8].props);
        },
        d: function(e) {
            e && xi(t), r = !1, o();
        }
    };
}
function pz(e) {
    var t, n, r, o, i, a = [
        dz,
        fz
    ], s = [];
    function c(e, n) {
        return 1 & n && (t = null), null == t && (t = !!pI(e[8])), t ? 0 : 1;
    }
    function l(e, t) {
        return 0 === t ? function(e) {
            var t = e.slice(), n = t[8].action;
            return t[11] = n, t;
        }(e) : e;
    }
    return n = c(e, -1), r = s[n] = a[n](l(e, n)), {
        c: function() {
            r.c(), o = _i();
        },
        m: function(e, t) {
            s[n].m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, t) {
            var i = n;
            (n = c(e, t)) === i ? s[n].p(l(e, n), t) : (ba(), ka(s[i], 1, 1, function() {
                s[i] = null;
            }), wa(), (r = s[n]) ? r.p(l(e, n), t) : (r = s[n] = a[n](l(e, n))).c(), xa(r, 1), r.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(o), s[n].d(e);
        }
    };
}
function mz(e) {
    for(var t, n, r = Ca(e[0]), o = [], i = 0; i < r.length; i += 1)o[i] = pz(uz(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = _i();
        },
        m: function(e, r) {
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(e, r);
            wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            var i = jo(n, 1)[0];
            if (1 & i) {
                var s;
                for(r = Ca(e[0]), s = 0; s < r.length; s += 1){
                    var c = uz(e, r, s);
                    o[s] ? (o[s].p(c, i), xa(o[s], 1)) : (o[s] = pz(c), o[s].c(), xa(o[s], 1), o[s].m(t.parentNode, t));
                }
                for(ba(), s = r.length; s < o.length; s += 1)a(s);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function gz(e, t, n) {
    var r, o, i = t.path, a = t.value, s = t.context, c = t.enforceString, l = t.selection, u = t.searchResultItems;
    return e.$$set = function(e) {
        "path" in e && n(1, i = e.path), "value" in e && n(2, a = e.value), "context" in e && n(3, s = e.context), "enforceString" in e && n(4, c = e.enforceString), "selection" in e && n(5, l = e.selection), "searchResultItems" in e && n(6, u = e.searchResultItems);
    }, e.$$.update = function() {
        32 & e.$$.dirty && n(7, r = pE(l) && qE(l)), 254 & e.$$.dirty && n(0, o = s.onRenderValue({
            path: i,
            value: a,
            readOnly: s.readOnly,
            enforceString: c,
            isEditing: r,
            parser: s.parser,
            normalization: s.normalization,
            selection: l,
            searchResultItems: u,
            onPatch: s.onPatch,
            onPasteJson: s.onPasteJson,
            onSelect: s.onSelect,
            onFind: s.onFind,
            findNextInside: s.findNextInside,
            focus: s.focus
        }));
    }, [
        o,
        i,
        a,
        s,
        c,
        l,
        u,
        r
    ];
}
var yz = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, gz, mz, Zo, {
            path: 1,
            value: 2,
            context: 3,
            enforceString: 4,
            selection: 5,
            searchResultItems: 6
        }), n;
    }
    return Ao(t, Ia), Do(t);
}(), bz = yz, wz = {
    selecting: !1,
    selectionAnchor: null,
    selectionAnchorType: null,
    selectionFocus: null,
    dragging: !1
};
function xz(e) {
    var t = e.json, n = e.documentState, r = e.deltaY, o = e.items;
    if (!n.selection) return {
        operations: void 0,
        updatedSelection: null,
        offset: 0
    };
    var i = n.selection, a = r < 0 ? function(e) {
        var t = e.json, n = e.items, r = e.selection, o = e.deltaY, i = kE(t, r), a = n.findIndex(function(e) {
            return Ox(e.path, i);
        }), s = function() {
            var e;
            return null === (e = n[c - 1]) || void 0 === e ? void 0 : e.height;
        }, c = a, l = 0;
        for(; void 0 !== s() && Math.abs(o) > l + s() / 2;)l += s(), c -= 1;
        var u = n[c].path, f = c - a;
        return c !== a && void 0 !== n[c] ? {
            beforePath: u,
            offset: f
        } : void 0;
    }({
        json: t,
        selection: i,
        deltaY: r,
        items: o
    }) : function(e) {
        var t, n = e.json, r = e.items, o = e.selection, i = e.deltaY, a = jE(n, o), s = r.findIndex(function(e) {
            return Ox(e.path, a);
        }), c = 0, l = s, u = function() {
            var e;
            return null === (e = r[l + 1]) || void 0 === e ? void 0 : e.height;
        };
        for(; void 0 !== u() && Math.abs(i) > c + u() / 2;)c += u(), l += 1;
        var f = Qw(a), d = Ws(n, f), h = Array.isArray(d), v = h ? l : l + 1, p = null === (t = r[v]) || void 0 === t ? void 0 : t.path, m = l - s;
        return p ? {
            beforePath: p,
            offset: m
        } : {
            append: !0,
            offset: m
        };
    }({
        json: t,
        selection: i,
        deltaY: r,
        items: o
    });
    if (!a || 0 === a.offset) return {
        operations: void 0,
        updatedSelection: null,
        offset: 0
    };
    var s = function(e, t, n) {
        if (!t) return [];
        var r = "beforePath" in n ? n.beforePath : void 0, o = "append" in n ? n.append : void 0, i = Qw(JE(t)), a = Ws(e, i);
        if (!(o || r && AE(r, i) && r.length > i.length)) return [];
        var s = kE(e, t), c = jE(e, t), l = vb(s), u = vb(c), f = r ? r[i.length] : void 0;
        if (!Rs(a)) {
            if (Ts(a)) {
                var d = Ul(l), h = Ul(u), v = void 0 !== f ? Ul(f) : a.length;
                return YC(h - d + 1, v < d ? function(e) {
                    return {
                        op: "move",
                        from: Zs(i.concat(String(d + e))),
                        path: Zs(i.concat(String(v + e)))
                    };
                } : function() {
                    return {
                        op: "move",
                        from: Zs(i.concat(String(d))),
                        path: Zs(i.concat(String(v)))
                    };
                });
            }
            throw new Error("Cannot create move operations: parent must be an Object or Array");
        }
        var p = Object.keys(a), m = p.indexOf(l), g = p.indexOf(u), y = o ? p.length : void 0 !== f ? p.indexOf(f) : -1;
        return -1 !== m && -1 !== g && -1 !== y ? y > m ? [].concat(Bo(p.slice(m, g + 1)), Bo(p.slice(y, p.length))).map(function(e) {
            return uA(i, e);
        }) : [].concat(Bo(p.slice(y, m)), Bo(p.slice(g + 1, p.length))).map(function(e) {
            return uA(i, e);
        }) : [];
    }(t, i, a), c = Ws(t, Qw(kE(t, i)));
    if (Array.isArray(c)) {
        var l = function(e) {
            var t, n, r = e.items, o = e.json, i = e.selection, a = e.offset, s = kE(o, i), c = jE(o, i), l = r.findIndex(function(e) {
                return Ox(e.path, s);
            }), u = r.findIndex(function(e) {
                return Ox(e.path, c);
            }), f = null === (t = r[l + a]) || void 0 === t ? void 0 : t.path, d = null === (n = r[u + a]) || void 0 === n ? void 0 : n.path;
            return DE(f, d);
        }({
            items: o,
            json: t,
            selection: i,
            offset: a.offset
        });
        return {
            operations: s,
            updatedSelection: l,
            offset: a.offset
        };
    }
    return {
        operations: s,
        updatedSelection: null,
        offset: a.offset
    };
}
function kz(e, t) {
    return function(e, t) {
        if (e) {
            for(var n = {}, r = 0, o = Object.keys(e); r < o.length; r++){
                var i = o[r];
                t(i, e[i]) && (n[i] = e[i]);
            }
            return Object.keys(n).length > 0 ? n : void 0;
        }
    }(e, function(e) {
        return nc(e, t);
    });
}
function jz(e) {
    mi(e, "svelte-g0bfge", 'button.jse-validation-error.svelte-g0bfge{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;padding:0;margin:0;vertical-align:top;display:inline-flex;color:var(--jse-warning-color, #fdc539)}');
}
function Sz(e) {
    var t, n, r, o, i, a;
    return n = new jM({
        props: {
            data: TP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-validation-error svelte-g0bfge");
        },
        m: function(s, c) {
            wi(s, t, c), Ta(n, t, null), o = !0, i || (a = [
                Oi(t, "click", function() {
                    Yo(e[0]) && e[0].apply(this, arguments);
                }),
                ci(r = HA.call(null, t, Ro({
                    text: e[1]
                }, e[2])))
            ], i = !0);
        },
        p: function(t, n) {
            var o = jo(n, 1)[0];
            e = t, r && Yo(r.update) && 2 & o && r.update.call(null, Ro({
                text: e[1]
            }, e[2]));
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, Qo(a);
        }
    };
}
function Cz(e, t, n) {
    var r, o = Zi("absolute-popup"), i = t.validationError, a = t.onExpand;
    return e.$$set = function(e) {
        "validationError" in e && n(3, i = e.validationError), "onExpand" in e && n(0, a = e.onExpand);
    }, e.$$.update = function() {
        8 & e.$$.dirty && n(1, r = hI(i) && i.isChildError ? "Contains invalid data" : i.message);
    }, [
        a,
        r,
        o,
        i
    ];
}
var $z = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, Cz, Sz, Xo, {
            validationError: 3,
            onExpand: 0
        }, jz), n;
    }
    return Ao(t, Ia), Do(t);
}();
function _z(e) {
    mi(e, "svelte-6mjnsm", '.jse-json-node.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative;color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-root.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{min-height:100%;padding-bottom:2px;box-sizing:border-box}.jse-json-node.jse-root.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm .jse-context-menu-pointer,.jse-json-node.jse-root.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm .jse-context-menu-pointer{top:0;right:calc(-2px - var(--jse-context-menu-pointer-size, calc(1em + 4px)))}.jse-json-node.jse-root.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm.svelte-6mjnsm{padding-left:0}.jse-json-node.svelte-6mjnsm .jse-props.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-items.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-header-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-footer-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-header .jse-meta.svelte-6mjnsm>.jse-meta-inner.svelte-6mjnsm.svelte-6mjnsm{display:flex;justify-content:center}.jse-json-node.svelte-6mjnsm .jse-contents-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;flex-direction:row;align-items:flex-start}.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding-left:var(--jse-indent-size, calc(1em + 4px))}.jse-json-node.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:inline-flex;padding-left:calc(var(--jse-indent-size, calc(1em + 4px)) + 5px)}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-contents-background-color, transparent)}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{visibility:hidden;padding:0 calc(0.5 * var(--jse-padding, 10px));flex:1}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.jse-inside.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:inline-flex;align-items:center}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.jse-after.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;align-items:flex-end}.jse-json-node.svelte-6mjnsm .jse-context-menu-pointer-anchor.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-insert-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;position:relative;z-index:1;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));max-width:250px;min-width:100px;height:0;margin-right:calc(0.5 * var(--jse-padding, 10px));outline:1px solid}.jse-json-node.svelte-6mjnsm .jse-insert-area.svelte-6mjnsm .jse-context-menu-pointer{right:-1px;background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-hovered.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{outline-color:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-6mjnsm:hover>.jse-contents-outer .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected),.jse-json-node.svelte-6mjnsm .jse-header-outer.svelte-6mjnsm:hover>.jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected),.jse-json-node.svelte-6mjnsm .jse-footer-outer:hover .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected){visibility:visible}.jse-json-node.jse-hovered.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-json-node.jse-selected.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected.svelte-6mjnsm .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected.svelte-6mjnsm .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-key.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm>.jse-identifier>.jse-key,.jse-json-node.jse-selected-key.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-identifier>.jse-key{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm>.jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.svelte-6mjnsm .jse-collapsed-items.jse-selected,.jse-json-node.jse-selected.svelte-6mjnsm .jse-collapsed-items,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-collapsed-items{background-color:var(--jse-selection-background-color, #d3d3d3);--jse-collapsed-items-background-color:var(--jse-collapsed-items-selected-background-color, #c2c2c2)}.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-readonly.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{--jse-contents-selected-cursor:pointer}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{outline-color:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm .jse-context-menu-pointer{background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm .jse-context-menu-pointer:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}.jse-main:not(.jse-focus) .jse-json-node.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{--jse-selection-background-color:var(--jse-selection-background-inactive-color, #e8e8e8);--jse-context-menu-pointer-background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{width:var(--jse-indent-size, calc(1em + 4px));padding:0;margin:0;border:none;cursor:pointer;background:transparent;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38));font-size:var(--jse-font-size-mono, 14px);height:var(--jse-line-height, calc(1em + 4px))}.jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:hover{opacity:0.8}.jse-meta.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-separator.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-index.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-bracket.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{vertical-align:top;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-index.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding:0 calc(0.5 * var(--jse-padding, 10px))}.jse-bracket.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding:0 2px}.jse-bracket.jse-expanded.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding-right:var(--jse-padding, 10px)}.jse-tag.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{border:none;font-size:80%;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));border-radius:2px;cursor:pointer;display:inline-block;padding:0 4px;line-height:normal;margin:1px 0}.jse-tag.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:hover{opacity:0.8}.jse-tag.jse-expanded.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{opacity:0.7;cursor:inherit}.jse-identifier.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{vertical-align:top;position:relative}');
}
var Oz = function(e) {
    return {};
}, Mz = function(e) {
    return {};
};
function Ez(e, t, n) {
    var r = e.slice();
    return r[52] = t[n], r;
}
var Az = function(e) {
    return {};
}, Pz = function(e) {
    return {};
};
function Tz(e, t, n) {
    var r = e.slice();
    return r[46] = t[n], r[48] = n, r;
}
function Rz(e, t, n) {
    var r = e.slice();
    return r[49] = t[n], r;
}
var Nz = function(e) {
    return {};
}, Iz = function(e) {
    return {};
};
function Dz(e) {
    var t, n, r, o, i, a, s, c, l, u = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1]), f = e[33].identifier, d = ei(f, e, e[34], Mz), h = !e[17] && Bz();
    i = new bz({
        props: {
            path: e[1],
            value: e[0],
            enforceString: e[13] || !1,
            selection: e[16] ? e[7] : null,
            searchResultItems: CA(e[6], e[9]),
            context: e[8]
        }
    });
    var v = u && Lz(e), p = e[15] && Fz(e), m = !e[17] && Vz(e);
    return {
        c: function() {
            t = ji("div"), n = ji("div"), d && d.c(), r = $i(), h && h.c(), o = $i(), Pa(i.$$.fragment), a = $i(), v && v.c(), s = $i(), p && p.c(), c = $i(), m && m.c(), Ai(n, "class", "jse-contents svelte-6mjnsm"), Ai(t, "class", "jse-contents-outer svelte-6mjnsm");
        },
        m: function(e, u) {
            wi(e, t, u), pi(t, n), d && d.m(n, null), pi(n, r), h && h.m(n, null), pi(n, o), Ta(i, n, null), pi(n, a), v && v.m(n, null), pi(t, s), p && p.m(t, null), pi(t, c), m && m.m(t, null), l = !0;
        },
        p: function(e, r) {
            d && d.p && (!l || 8 & r[1]) && ri(d, f, e, e[34], l ? ni(f, e[34], r, Oz) : oi(e[34]), Mz), e[17] ? h && (h.d(1), h = null) : h || ((h = Bz()).c(), h.m(n, o));
            var a = {};
            2 & r[0] && (a.path = e[1]), 1 & r[0] && (a.value = e[0]), 8192 & r[0] && (a.enforceString = e[13] || !1), 65664 & r[0] && (a.selection = e[16] ? e[7] : null), 576 & r[0] && (a.searchResultItems = CA(e[6], e[9])), 256 & r[0] && (a.context = e[8]), i.$set(a), 65922 & r[0] && (u = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1])), u ? v ? (v.p(e, r), 65922 & r[0] && xa(v, 1)) : ((v = Lz(e)).c(), xa(v, 1), v.m(n, null)) : v && (ba(), ka(v, 1, 1, function() {
                v = null;
            }), wa()), e[15] ? p ? (p.p(e, r), 32768 & r[0] && xa(p, 1)) : ((p = Fz(e)).c(), xa(p, 1), p.m(t, c)) : p && (ba(), ka(p, 1, 1, function() {
                p = null;
            }), wa()), e[17] ? m && (m.d(1), m = null) : m ? m.p(e, r) : ((m = Vz(e)).c(), m.m(t, null));
        },
        i: function(e) {
            l || (xa(d, e), xa(i.$$.fragment, e), xa(v), xa(p), l = !0);
        },
        o: function(e) {
            ka(d, e), ka(i.$$.fragment, e), ka(v), ka(p), l = !1;
        },
        d: function(e) {
            e && xi(t), d && d.d(e), h && h.d(), Ra(i), v && v.d(), p && p.d(), m && m.d();
        }
    };
}
function zz(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1]), w = [
        Wz,
        Hz
    ], x = [];
    function k(e, t) {
        return e[12] ? 0 : 1;
    }
    o = k(e), i = x[o] = w[o](e);
    var j = e[33].identifier, S = ei(j, e, e[34], Pz), C = !e[17] && Uz();
    function $(e, t) {
        return e[12] ? Kz : Jz;
    }
    var _ = $(e), O = _(e), M = b && Gz(e), E = e[15] && (!e[12] || !e[15].isChildError) && Qz(e);
    function A(e, t) {
        return e[12] ? Xz : e[17] ? void 0 : Yz;
    }
    var P = A(e), T = P && P(e), R = e[12] && Zz(e);
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("button"), i.c(), a = $i(), S && S.c(), s = $i(), C && C.c(), c = $i(), l = ji("div"), u = ji("div"), O.c(), f = $i(), M && M.c(), d = $i(), E && E.c(), h = $i(), T && T.c(), v = $i(), R && R.c(), p = _i(), Ai(r, "type", "button"), Ai(r, "class", "jse-expand svelte-6mjnsm"), Ai(r, "title", "Expand or collapse this object (Ctrl+Click to expand/collapse recursively)"), Ai(u, "class", "jse-meta-inner svelte-6mjnsm"), Ai(l, "class", "jse-meta svelte-6mjnsm"), Ai(l, "data-type", "selectable-value"), Ai(n, "class", "jse-header svelte-6mjnsm"), Ai(t, "class", "jse-header-outer svelte-6mjnsm");
        },
        m: function(i, b) {
            wi(i, t, b), pi(t, n), pi(n, r), x[o].m(r, null), pi(n, a), S && S.m(n, null), pi(n, s), C && C.m(n, null), pi(n, c), pi(n, l), pi(l, u), O.m(u, null), pi(n, f), M && M.m(n, null), pi(t, d), E && E.m(t, null), pi(t, h), T && T.m(t, null), wi(i, v, b), R && R.m(i, b), wi(i, p, b), m = !0, g || (y = Oi(r, "click", e[20]), g = !0);
        },
        p: function(e, a) {
            var s = o;
            (o = k(e)) !== s && (ba(), ka(x[s], 1, 1, function() {
                x[s] = null;
            }), wa(), (i = x[o]) || (i = x[o] = w[o](e)).c(), xa(i, 1), i.m(r, null)), S && S.p && (!m || 8 & a[1]) && ri(S, j, e, e[34], m ? ni(j, e[34], a, Az) : oi(e[34]), Pz), e[17] ? C && (C.d(1), C = null) : C || ((C = Uz()).c(), C.m(n, c)), _ === (_ = $(e)) && O ? O.p(e, a) : (O.d(1), (O = _(e)) && (O.c(), O.m(u, null))), 65922 & a[0] && (b = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1])), b ? M ? (M.p(e, a), 65922 & a[0] && xa(M, 1)) : ((M = Gz(e)).c(), xa(M, 1), M.m(n, null)) : M && (ba(), ka(M, 1, 1, function() {
                M = null;
            }), wa()), !e[15] || e[12] && e[15].isChildError ? E && (ba(), ka(E, 1, 1, function() {
                E = null;
            }), wa()) : E ? (E.p(e, a), 36864 & a[0] && xa(E, 1)) : ((E = Qz(e)).c(), xa(E, 1), E.m(t, h)), P === (P = A(e)) && T ? T.p(e, a) : (T && T.d(1), (T = P && P(e)) && (T.c(), T.m(t, null))), e[12] ? R ? (R.p(e, a), 4096 & a[0] && xa(R, 1)) : ((R = Zz(e)).c(), xa(R, 1), R.m(p.parentNode, p)) : R && (ba(), ka(R, 1, 1, function() {
                R = null;
            }), wa());
        },
        i: function(e) {
            m || (xa(i), xa(S, e), xa(M), xa(E), xa(R), m = !0);
        },
        o: function(e) {
            ka(i), ka(S, e), ka(M), ka(E), ka(R), m = !1;
        },
        d: function(e) {
            e && (xi(t), xi(v), xi(p)), x[o].d(), S && S.d(e), C && C.d(), O.d(), M && M.d(), E && E.d(), T && T.d(), R && R.d(e), g = !1, y();
        }
    };
}
function qz(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1]), w = [
        iq,
        oq
    ], x = [];
    function k(e, t) {
        return e[12] ? 0 : 1;
    }
    o = k(e), i = x[o] = w[o](e);
    var j = e[33].identifier, S = ei(j, e, e[34], Iz), C = !e[17] && aq();
    function $(e, t) {
        return e[12] ? cq : sq;
    }
    var _ = $(e), O = _(e), M = b && lq(e), E = e[15] && (!e[12] || !e[15].isChildError) && uq(e);
    function A(e, t) {
        return e[12] ? dq : fq;
    }
    var P = A(e), T = P(e), R = e[12] && hq(e);
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = ji("button"), i.c(), a = $i(), S && S.c(), s = $i(), C && C.c(), c = $i(), l = ji("div"), u = ji("div"), O.c(), f = $i(), M && M.c(), d = $i(), E && E.c(), h = $i(), T.c(), v = $i(), R && R.c(), p = _i(), Ai(r, "type", "button"), Ai(r, "class", "jse-expand svelte-6mjnsm"), Ai(r, "title", "Expand or collapse this array (Ctrl+Click to expand/collapse recursively)"), Ai(u, "class", "jse-meta-inner svelte-6mjnsm"), Ai(u, "data-type", "selectable-value"), Ai(l, "class", "jse-meta svelte-6mjnsm"), Ai(n, "class", "jse-header svelte-6mjnsm"), Ai(t, "class", "jse-header-outer svelte-6mjnsm");
        },
        m: function(i, b) {
            wi(i, t, b), pi(t, n), pi(n, r), x[o].m(r, null), pi(n, a), S && S.m(n, null), pi(n, s), C && C.m(n, null), pi(n, c), pi(n, l), pi(l, u), O.m(u, null), pi(n, f), M && M.m(n, null), pi(t, d), E && E.m(t, null), pi(t, h), T.m(t, null), wi(i, v, b), R && R.m(i, b), wi(i, p, b), m = !0, g || (y = Oi(r, "click", e[20]), g = !0);
        },
        p: function(e, a) {
            var s = o;
            (o = k(e)) !== s && (ba(), ka(x[s], 1, 1, function() {
                x[s] = null;
            }), wa(), (i = x[o]) || (i = x[o] = w[o](e)).c(), xa(i, 1), i.m(r, null)), S && S.p && (!m || 8 & a[1]) && ri(S, j, e, e[34], m ? ni(j, e[34], a, Nz) : oi(e[34]), Iz), e[17] ? C && (C.d(1), C = null) : C || ((C = aq()).c(), C.m(n, c)), _ === (_ = $(e)) && O ? O.p(e, a) : (O.d(1), (O = _(e)) && (O.c(), O.m(u, null))), 65922 & a[0] && (b = !e[8].readOnly && e[16] && e[7] && (pE(e[7]) || mE(e[7])) && !qE(e[7]) && Ox(JE(e[7]), e[1])), b ? M ? (M.p(e, a), 65922 & a[0] && xa(M, 1)) : ((M = lq(e)).c(), xa(M, 1), M.m(n, null)) : M && (ba(), ka(M, 1, 1, function() {
                M = null;
            }), wa()), !e[15] || e[12] && e[15].isChildError ? E && (ba(), ka(E, 1, 1, function() {
                E = null;
            }), wa()) : E ? (E.p(e, a), 36864 & a[0] && xa(E, 1)) : ((E = uq(e)).c(), xa(E, 1), E.m(t, h)), P === (P = A(e)) && T ? T.p(e, a) : (T.d(1), (T = P(e)) && (T.c(), T.m(t, null))), e[12] ? R ? (R.p(e, a), 4096 & a[0] && xa(R, 1)) : ((R = hq(e)).c(), xa(R, 1), R.m(p.parentNode, p)) : R && (ba(), ka(R, 1, 1, function() {
                R = null;
            }), wa());
        },
        i: function(e) {
            m || (xa(i), xa(S, e), xa(M), xa(E), xa(R), m = !0);
        },
        o: function(e) {
            ka(i), ka(S, e), ka(M), ka(E), ka(R), m = !1;
        },
        d: function(e) {
            e && (xi(t), xi(v), xi(p)), x[o].d(), S && S.d(e), C && C.d(), O.d(), M && M.d(), E && E.d(), T.d(), R && R.d(e), g = !1, y();
        }
    };
}
function Bz(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = ":", Ai(t, "class", "jse-separator svelte-6mjnsm");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function Lz(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: !0,
            onContextMenu: e[8].onContextMenu
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            256 & t[0] && (r.onContextMenu = e[8].onContextMenu), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function Fz(e) {
    var t, n;
    return t = new $z({
        props: {
            validationError: e[15],
            onExpand: e[21]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            32768 & n[0] && (r.validationError = e[15]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Vz(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[29]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function Hz(e) {
    var t, n;
    return t = new jM({
        props: {
            data: YA
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Wz(e) {
    var t, n;
    return t = new jM({
        props: {
            data: gP
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Uz(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = ":", Ai(t, "class", "jse-separator svelte-6mjnsm");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function Jz(e) {
    var t, n, r, o, i, a, s, c, l, u, f = Object.keys(e[0]).length + "", d = 1 === Object.keys(e[0]).length ? "prop" : "props";
    return {
        c: function() {
            (t = ji("div")).textContent = "{", n = $i(), r = ji("button"), o = Ci(f), i = $i(), a = Ci(d), s = $i(), (c = ji("div")).textContent = "}", Ai(t, "class", "jse-bracket svelte-6mjnsm"), Ai(r, "type", "button"), Ai(r, "class", "jse-tag svelte-6mjnsm"), Ai(c, "class", "jse-bracket svelte-6mjnsm");
        },
        m: function(f, d) {
            wi(f, t, d), wi(f, n, d), wi(f, r, d), pi(r, o), pi(r, i), pi(r, a), wi(f, s, d), wi(f, c, d), l || (u = Oi(r, "click", e[21]), l = !0);
        },
        p: function(e, t) {
            1 & t[0] && f !== (f = Object.keys(e[0]).length + "") && Ni(o, f), 1 & t[0] && d !== (d = 1 === Object.keys(e[0]).length ? "prop" : "props") && Ni(a, d);
        },
        d: function(e) {
            e && (xi(t), xi(n), xi(r), xi(s), xi(c)), l = !1, u();
        }
    };
}
function Kz(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = "{", Ai(t, "class", "jse-bracket jse-expanded svelte-6mjnsm");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function Gz(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: !0,
            onContextMenu: e[8].onContextMenu
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            256 & t[0] && (r.onContextMenu = e[8].onContextMenu), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function Qz(e) {
    var t, n;
    return t = new $z({
        props: {
            validationError: e[15],
            onExpand: e[21]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            32768 & n[0] && (r.validationError = e[15]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Yz(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[29]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function Xz(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-inside svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-inside");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[28]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function Zz(e) {
    for(var t, n, r, o, i, a, s, c = !e[8].readOnly && (e[10] === js || e[16] && hE(e[7])), l = c && eq(e), u = Ca(e[18](e[1], e[0], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), f = [], d = 0; d < u.length; d += 1)f[d] = nq(Ez(e, u, d));
    var h = function(e) {
        return ka(f[e], 1, 1, function() {
            f[e] = null;
        });
    }, v = !e[17] && rq(e);
    return {
        c: function() {
            t = ji("div"), l && l.c(), n = $i();
            for(var e = 0; e < f.length; e += 1)f[e].c();
            r = $i(), o = ji("div"), (i = ji("div")).innerHTML = '<div class="jse-bracket svelte-6mjnsm">}</div>', a = $i(), v && v.c(), Ai(t, "class", "jse-props svelte-6mjnsm"), Ai(i, "data-type", "selectable-value"), Ai(i, "class", "jse-footer svelte-6mjnsm"), Ai(o, "class", "jse-footer-outer svelte-6mjnsm");
        },
        m: function(e, c) {
            wi(e, t, c), l && l.m(t, null), pi(t, n);
            for(var u = 0; u < f.length; u += 1)f[u] && f[u].m(t, null);
            wi(e, r, c), wi(e, o, c), pi(o, i), pi(o, a), v && v.m(o, null), s = !0;
        },
        p: function(e, r) {
            if (66944 & r[0] && (c = !e[8].readOnly && (e[10] === js || e[16] && hE(e[7]))), c ? l ? (l.p(e, r), 66944 & r[0] && xa(l, 1)) : ((l = eq(e)).c(), xa(l, 1), l.m(t, n)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()), 38013439 & r[0]) {
                var i;
                for(u = Ca(e[18](e[1], e[0], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), i = 0; i < u.length; i += 1){
                    var a = Ez(e, u, i);
                    f[i] ? (f[i].p(a, r), xa(f[i], 1)) : (f[i] = nq(a), f[i].c(), xa(f[i], 1), f[i].m(t, null));
                }
                for(ba(), i = u.length; i < f.length; i += 1)h(i);
                wa();
            }
            e[17] ? v && (v.d(1), v = null) : v ? v.p(e, r) : ((v = rq(e)).c(), v.m(o, null));
        },
        i: function(e) {
            if (!s) {
                xa(l);
                for(var t = 0; t < u.length; t += 1)xa(f[t]);
                s = !0;
            }
        },
        o: function(e) {
            ka(l), f = f.filter(Boolean);
            for(var t = 0; t < f.length; t += 1)ka(f[t]);
            s = !1;
        },
        d: function(e) {
            e && (xi(t), xi(r), xi(o)), l && l.d(), ki(f, e), v && v.d();
        }
    };
}
function eq(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: e[16] && hE(e[7]),
            onContextMenu: e[30]
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-insert-area jse-inside svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-inside"), Ai(t, "title", xs), qi(t, "jse-hovered", e[10] === js), qi(t, "jse-selected", e[16] && hE(e[7])), Di(t, "--level", e[1].length + 1);
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, o) {
            var i = {};
            65664 & o[0] && (i.selected = e[16] && hE(e[7])), n.$set(i), (!r || 1024 & o[0]) && qi(t, "jse-hovered", e[10] === js), (!r || 65664 & o[0]) && qi(t, "jse-selected", e[16] && hE(e[7])), 2 & o[0] && Di(t, "--level", e[1].length + 1);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function tq(e) {
    var t, n, r, o;
    return n = new lz({
        props: {
            path: e[52].path,
            key: e[52].key,
            selection: e[52].selection,
            searchResultItems: e[52].keySearchResultItemsMap,
            context: e[8],
            onUpdateKey: e[22]
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), r = $i(), Ai(t, "slot", "identifier"), Ai(t, "class", "jse-identifier svelte-6mjnsm");
        },
        m: function(e, i) {
            wi(e, t, i), Ta(n, t, null), pi(t, r), o = !0;
        },
        p: function(e, t) {
            var r = {};
            2303 & t[0] && (r.path = e[52].path), 2303 & t[0] && (r.key = e[52].key), 2303 & t[0] && (r.selection = e[52].selection), 2303 & t[0] && (r.searchResultItems = e[52].keySearchResultItemsMap), 256 & t[0] && (r.context = e[8]), n.$set(r);
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function nq(e) {
    var t, n;
    return t = new jq({
        props: {
            value: e[52].value,
            path: e[52].path,
            expandedMap: e[52].expandedMap,
            enforceStringMap: e[52].enforceStringMap,
            visibleSectionsMap: e[52].visibleSectionsMap,
            validationErrorsMap: e[52].validationErrorsMap,
            searchResultItemsMap: e[52].valueSearchResultItemsMap,
            selection: e[52].selection,
            context: e[8],
            onDragSelectionStart: e[25],
            $$slots: {
                identifier: [
                    tq
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2303 & n[0] && (r.value = e[52].value), 2303 & n[0] && (r.path = e[52].path), 2303 & n[0] && (r.expandedMap = e[52].expandedMap), 2303 & n[0] && (r.enforceStringMap = e[52].enforceStringMap), 2303 & n[0] && (r.visibleSectionsMap = e[52].visibleSectionsMap), 2303 & n[0] && (r.validationErrorsMap = e[52].validationErrorsMap), 2303 & n[0] && (r.searchResultItemsMap = e[52].valueSearchResultItemsMap), 2303 & n[0] && (r.selection = e[52].selection), 256 & n[0] && (r.context = e[8]), 2559 & n[0] | 8 & n[1] && (r.$$scope = {
                dirty: n,
                ctx: e
            }), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function rq(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[29]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function oq(e) {
    var t, n;
    return t = new jM({
        props: {
            data: YA
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function iq(e) {
    var t, n;
    return t = new jM({
        props: {
            data: gP
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function aq(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = ":", Ai(t, "class", "jse-separator svelte-6mjnsm");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function sq(e) {
    var t, n, r, o, i, a, s, c, l, u, f = e[0].length + "", d = 1 === e[0].length ? "item" : "items";
    return {
        c: function() {
            (t = ji("div")).textContent = "[", n = $i(), r = ji("button"), o = Ci(f), i = $i(), a = Ci(d), s = $i(), (c = ji("div")).textContent = "]", Ai(t, "class", "jse-bracket svelte-6mjnsm"), Ai(r, "type", "button"), Ai(r, "class", "jse-tag svelte-6mjnsm"), Ai(c, "class", "jse-bracket svelte-6mjnsm");
        },
        m: function(f, d) {
            wi(f, t, d), wi(f, n, d), wi(f, r, d), pi(r, o), pi(r, i), pi(r, a), wi(f, s, d), wi(f, c, d), l || (u = Oi(r, "click", e[21]), l = !0);
        },
        p: function(e, t) {
            1 & t[0] && f !== (f = e[0].length + "") && Ni(o, f), 1 & t[0] && d !== (d = 1 === e[0].length ? "item" : "items") && Ni(a, d);
        },
        d: function(e) {
            e && (xi(t), xi(n), xi(r), xi(s), xi(c)), l = !1, u();
        }
    };
}
function cq(e) {
    var t, n, r, o, i, a, s, c = e[0].length + "", l = 1 === e[0].length ? "item" : "items";
    return {
        c: function() {
            (t = ji("div")).textContent = "[", n = $i(), r = ji("span"), o = Ci(c), i = $i(), a = Ci(l), s = Ci("\n              \xa0"), Ai(t, "class", "jse-bracket svelte-6mjnsm"), Ai(r, "class", "jse-tag jse-expanded svelte-6mjnsm");
        },
        m: function(e, c) {
            wi(e, t, c), wi(e, n, c), wi(e, r, c), pi(r, o), pi(r, i), pi(r, a), wi(e, s, c);
        },
        p: function(e, t) {
            1 & t[0] && c !== (c = e[0].length + "") && Ni(o, c), 1 & t[0] && l !== (l = 1 === e[0].length ? "item" : "items") && Ni(a, l);
        },
        d: function(e) {
            e && (xi(t), xi(n), xi(r), xi(s));
        }
    };
}
function lq(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: !0,
            onContextMenu: e[8].onContextMenu
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            256 & t[0] && (r.onContextMenu = e[8].onContextMenu), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function uq(e) {
    var t, n;
    return t = new $z({
        props: {
            validationError: e[15],
            onExpand: e[21]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            32768 & n[0] && (r.validationError = e[15]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function fq(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[29]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function dq(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-inside svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-inside");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[28]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function hq(e) {
    for(var t, n, r, o, i, a, s, c = !e[8].readOnly && (e[10] === js || e[16] && hE(e[7])), l = [], u = new Map, f = c && vq(e), d = Ca(e[14] || ds), h = function(e) {
        return e[48];
    }, v = 0; v < d.length; v += 1){
        var p = Tz(e, d, v), m = h(p);
        u.set(m, l[v] = yq(m, p));
    }
    var g = !e[17] && bq(e);
    return {
        c: function() {
            t = ji("div"), f && f.c(), n = $i();
            for(var e = 0; e < l.length; e += 1)l[e].c();
            r = $i(), o = ji("div"), (i = ji("div")).innerHTML = '<span class="jse-bracket svelte-6mjnsm">]</span>', a = $i(), g && g.c(), Ai(t, "class", "jse-items svelte-6mjnsm"), Ai(i, "data-type", "selectable-value"), Ai(i, "class", "jse-footer svelte-6mjnsm"), Ai(o, "class", "jse-footer-outer svelte-6mjnsm");
        },
        m: function(e, c) {
            wi(e, t, c), f && f.m(t, null), pi(t, n);
            for(var u = 0; u < l.length; u += 1)l[u] && l[u].m(t, null);
            wi(e, r, c), wi(e, o, c), pi(o, i), pi(o, a), g && g.m(o, null), s = !0;
        },
        p: function(e, r) {
            66944 & r[0] && (c = !e[8].readOnly && (e[10] === js || e[16] && hE(e[7]))), c ? f ? (f.p(e, r), 66944 & r[0] && xa(f, 1)) : ((f = vq(e)).c(), xa(f, 1), f.m(t, n)) : f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa()), 34097663 & r[0] && (d = Ca(e[14] || ds), ba(), l = Oa(l, r, h, 1, e, d, u, t, _a, yq, null, Tz), wa()), e[17] ? g && (g.d(1), g = null) : g ? g.p(e, r) : ((g = bq(e)).c(), g.m(o, null));
        },
        i: function(e) {
            if (!s) {
                xa(f);
                for(var t = 0; t < d.length; t += 1)xa(l[t]);
                s = !0;
            }
        },
        o: function(e) {
            ka(f);
            for(var t = 0; t < l.length; t += 1)ka(l[t]);
            s = !1;
        },
        d: function(e) {
            e && (xi(t), xi(r), xi(o)), f && f.d();
            for(var n = 0; n < l.length; n += 1)l[n].d();
            g && g.d();
        }
    };
}
function vq(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: e[16] && hE(e[7]),
            onContextMenu: e[30]
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-insert-area jse-inside svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-inside"), Ai(t, "title", xs), qi(t, "jse-hovered", e[10] === js), qi(t, "jse-selected", e[16] && hE(e[7])), Di(t, "--level", e[1].length + 1);
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, o) {
            var i = {};
            65664 & o[0] && (i.selected = e[16] && hE(e[7])), n.$set(i), (!r || 1024 & o[0]) && qi(t, "jse-hovered", e[10] === js), (!r || 65664 & o[0]) && qi(t, "jse-selected", e[16] && hE(e[7])), 2 & o[0] && Di(t, "--level", e[1].length + 1);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function pq(e) {
    var t, n, r, o = e[49].index + "";
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = Ci(o), Ai(n, "class", "jse-index svelte-6mjnsm"), Ai(t, "slot", "identifier"), Ai(t, "class", "jse-identifier svelte-6mjnsm");
        },
        m: function(e, o) {
            wi(e, t, o), pi(t, n), pi(n, r);
        },
        p: function(e, t) {
            18687 & t[0] && o !== (o = e[49].index + "") && Ni(r, o);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function mq(e, t) {
    var n, r, o;
    return r = new jq({
        props: {
            value: t[49].value,
            path: t[49].path,
            expandedMap: t[49].expandedMap,
            enforceStringMap: t[49].enforceStringMap,
            visibleSectionsMap: t[49].visibleSectionsMap,
            validationErrorsMap: t[49].validationErrorsMap,
            searchResultItemsMap: t[49].searchResultItemsMap,
            selection: t[49].selection,
            context: t[8],
            onDragSelectionStart: t[25],
            $$slots: {
                identifier: [
                    pq
                ]
            },
            $$scope: {
                ctx: t
            }
        }
    }), {
        key: e,
        first: null,
        c: function() {
            n = _i(), Pa(r.$$.fragment), this.first = n;
        },
        m: function(e, t) {
            wi(e, n, t), Ta(r, e, t), o = !0;
        },
        p: function(e, n) {
            t = e;
            var o = {};
            18687 & n[0] && (o.value = t[49].value), 18687 & n[0] && (o.path = t[49].path), 18687 & n[0] && (o.expandedMap = t[49].expandedMap), 18687 & n[0] && (o.enforceStringMap = t[49].enforceStringMap), 18687 & n[0] && (o.visibleSectionsMap = t[49].visibleSectionsMap), 18687 & n[0] && (o.validationErrorsMap = t[49].validationErrorsMap), 18687 & n[0] && (o.searchResultItemsMap = t[49].searchResultItemsMap), 18687 & n[0] && (o.selection = t[49].selection), 256 & n[0] && (o.context = t[8]), 18687 & n[0] | 8 & n[1] && (o.$$scope = {
                dirty: n,
                ctx: t
            }), r.$set(o);
        },
        i: function(e) {
            o || (xa(r.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(r.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(n), Ra(r, e);
        }
    };
}
function gq(e) {
    var t, n;
    return t = new QD({
        props: {
            visibleSections: e[14] || ds,
            sectionIndex: e[48],
            total: e[0].length,
            path: e[1],
            onExpandSection: e[8].onExpandSection,
            selection: e[7],
            context: e[8]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            16384 & n[0] && (r.visibleSections = e[14] || ds), 16384 & n[0] && (r.sectionIndex = e[48]), 1 & n[0] && (r.total = e[0].length), 2 & n[0] && (r.path = e[1]), 256 & n[0] && (r.onExpandSection = e[8].onExpandSection), 128 & n[0] && (r.selection = e[7]), 256 & n[0] && (r.context = e[8]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function yq(e, t) {
    for(var n, r, o, i, a = [], s = new Map, c = Ca(t[19](t[1], t[0], t[46], t[2], t[3], t[4], t[5], t[6], t[7], t[11])), l = function(e) {
        return e[49].index;
    }, u = 0; u < c.length; u += 1){
        var f = Rz(t, c, u), d = l(f);
        s.set(d, a[u] = mq(d, f));
    }
    var h = t[46].end < t[0].length && gq(t);
    return {
        key: e,
        first: null,
        c: function() {
            n = _i();
            for(var e = 0; e < a.length; e += 1)a[e].c();
            r = $i(), h && h.c(), o = _i(), this.first = n;
        },
        m: function(e, t) {
            wi(e, n, t);
            for(var s = 0; s < a.length; s += 1)a[s] && a[s].m(e, t);
            wi(e, r, t), h && h.m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, n) {
            t = e, 34097663 & n[0] && (c = Ca(t[19](t[1], t[0], t[46], t[2], t[3], t[4], t[5], t[6], t[7], t[11])), ba(), a = Oa(a, n, l, 1, t, c, s, r.parentNode, _a, mq, r, Rz), wa()), t[46].end < t[0].length ? h ? (h.p(t, n), 16385 & n[0] && xa(h, 1)) : ((h = gq(t)).c(), xa(h, 1), h.m(o.parentNode, o)) : h && (ba(), ka(h, 1, 1, function() {
                h = null;
            }), wa());
        },
        i: function(e) {
            if (!i) {
                for(var t = 0; t < c.length; t += 1)xa(a[t]);
                xa(h), i = !0;
            }
        },
        o: function(e) {
            for(var t = 0; t < a.length; t += 1)ka(a[t]);
            ka(h), i = !1;
        },
        d: function(e) {
            e && (xi(n), xi(r), xi(o));
            for(var t = 0; t < a.length; t += 1)a[t].d(e);
            h && h.d(e);
        }
    };
}
function bq(e) {
    var t, n, r;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "none"), Ai(t, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = Oi(t, "click", e[29]), n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, r();
        }
    };
}
function wq(e) {
    var t, n, r;
    return n = new ez({
        props: {
            selected: e[16] && dE(e[7]),
            onContextMenu: e[31]
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-insert-area jse-after svelte-6mjnsm"), Ai(t, "data-type", "insert-selection-area-after"), Ai(t, "title", xs), qi(t, "jse-hovered", e[10] === Ss), qi(t, "jse-selected", e[16] && dE(e[7]));
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, o) {
            var i = {};
            65664 & o[0] && (i.selected = e[16] && dE(e[7])), n.$set(i), (!r || 1024 & o[0]) && qi(t, "jse-hovered", e[10] === Ss), (!r || 65664 & o[0]) && qi(t, "jse-selected", e[16] && dE(e[7]));
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function xq(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d = !e[8].readOnly && (e[10] === Ss || e[16] && dE(e[7])), h = [
        qz,
        zz,
        Dz
    ], v = [];
    function p(e, t) {
        return 1 & t[0] && (n = null), 1 & t[0] && (r = null), null == n && (n = !!Array.isArray(e[0])), n ? 0 : (null == r && (r = !!Gl(e[0])), r ? 1 : 2);
    }
    o = p(e, [
        -1,
        -1
    ]), i = v[o] = h[o](e);
    var m = d && wq(e);
    return {
        c: function() {
            t = ji("div"), i.c(), a = $i(), m && m.c(), Ai(t, "role", "treeitem"), Ai(t, "tabindex", "-1"), Ai(t, "class", s = si(GE("jse-json-node", {
                "jse-expanded": e[12]
            }, e[8].onClassName(e[1], e[0]))) + " svelte-6mjnsm"), Ai(t, "data-path", c = OO(e[1])), Ai(t, "aria-selected", e[16]), qi(t, "jse-root", e[17]), qi(t, "jse-selected", e[16] && mE(e[7])), qi(t, "jse-selected-key", e[16] && vE(e[7])), qi(t, "jse-selected-value", e[16] && pE(e[7])), qi(t, "jse-readonly", e[8].readOnly), qi(t, "jse-hovered", e[10] === Cs), Di(t, "--level", e[1].length);
        },
        m: function(n, r) {
            wi(n, t, r), v[o].m(t, null), pi(t, a), m && m.m(t, null), l = !0, u || (f = [
                Oi(t, "mousedown", e[23]),
                Oi(t, "mousemove", e[24]),
                Oi(t, "mouseover", e[26]),
                Oi(t, "mouseout", e[27]),
                Oi(t, "focus", void 0),
                Oi(t, "blur", void 0)
            ], u = !0);
        },
        p: function(e, n) {
            var r = o;
            (o = p(e, n)) === r ? v[o].p(e, n) : (ba(), ka(v[r], 1, 1, function() {
                v[r] = null;
            }), wa(), (i = v[o]) ? i.p(e, n) : (i = v[o] = h[o](e)).c(), xa(i, 1), i.m(t, a)), 66944 & n[0] && (d = !e[8].readOnly && (e[10] === Ss || e[16] && dE(e[7]))), d ? m ? (m.p(e, n), 66944 & n[0] && xa(m, 1)) : ((m = wq(e)).c(), xa(m, 1), m.m(t, null)) : m && (ba(), ka(m, 1, 1, function() {
                m = null;
            }), wa()), (!l || 4355 & n[0] && s !== (s = si(GE("jse-json-node", {
                "jse-expanded": e[12]
            }, e[8].onClassName(e[1], e[0]))) + " svelte-6mjnsm")) && Ai(t, "class", s), (!l || 2 & n[0] && c !== (c = OO(e[1]))) && Ai(t, "data-path", c), (!l || 65536 & n[0]) && Ai(t, "aria-selected", e[16]), (!l || 135427 & n[0]) && qi(t, "jse-root", e[17]), (!l || 70019 & n[0]) && qi(t, "jse-selected", e[16] && mE(e[7])), (!l || 70019 & n[0]) && qi(t, "jse-selected-key", e[16] && vE(e[7])), (!l || 70019 & n[0]) && qi(t, "jse-selected-value", e[16] && pE(e[7])), (!l || 4355 & n[0]) && qi(t, "jse-readonly", e[8].readOnly), (!l || 5379 & n[0]) && qi(t, "jse-hovered", e[10] === Cs), 2 & n[0] && Di(t, "--level", e[1].length);
        },
        i: function(e) {
            l || (xa(i), xa(m), l = !0);
        },
        o: function(e) {
            ka(i), ka(m), l = !1;
        },
        d: function(e) {
            e && xi(t), v[o].d(), m && m.d(), u = !1, Qo(f);
        }
    };
}
function kq(e, t, n) {
    var r, o, i, a, s, c, l, u = t.$$slots, f = void 0 === u ? {} : u, d = t.$$scope, h = t.value, v = t.path, p = t.expandedMap, m = t.enforceStringMap, g = t.visibleSectionsMap, y = t.validationErrorsMap, b = t.searchResultItemsMap, w = t.selection, x = t.context, k = t.onDragSelectionStart, j = Da("jsoneditor:JSONNode"), S = void 0, C = void 0, $ = void 0, _ = rv(function(e) {
        return e;
    }, JO);
    function O(e) {
        x.onDrag(e);
    }
    function M(e) {
        wz.selecting && (wz.selecting = !1, e.stopPropagation()), x.onDragEnd(), document.removeEventListener("mousemove", O, !0), document.removeEventListener("mouseup", M);
    }
    function E() {
        var e;
        return (null === (e = x.findElement([])) || void 0 === e || null === (e = e.getBoundingClientRect()) || void 0 === e ? void 0 : e.top) || 0;
    }
    function A(e, t) {
        var n = E() - e.initialContentTop;
        return t.clientY - e.initialClientY - n;
    }
    function P(e) {
        if ($) {
            var t = x.getJson();
            if (void 0 === t) return;
            var r = x.getDocumentState(), o = A($, e), i = xz({
                json: t,
                documentState: r,
                deltaY: o,
                items: $.items
            }).offset;
            i !== $.offset && (j("drag selection", i, o), n(11, $ = Ro(Ro({}, $), {}, {
                offset: i,
                didMoveItems: !0
            })));
        }
    }
    function T(e) {
        if ($) {
            var t = x.getJson();
            if (void 0 === t) return;
            var r = xz({
                json: t,
                documentState: x.getDocumentState(),
                deltaY: A($, e),
                items: $.items
            }), o = r.operations, i = r.updatedSelection;
            if (o) x.onPatch(o, function(e, t) {
                return {
                    state: Ro(Ro({}, t), {}, {
                        selection: i || w
                    })
                };
            });
            else if (e.target === $.initialTarget && !$.didMoveItems) {
                var a = _O(e.target), s = MO(e.target);
                s && x.onSelect(VE(0, a, s));
            }
            n(11, $ = void 0), wz.dragging = !1, document.removeEventListener("mousemove", P, !0), document.removeEventListener("mouseup", T);
        }
    }
    return e.$$set = function(e) {
        "value" in e && n(0, h = e.value), "path" in e && n(1, v = e.path), "expandedMap" in e && n(2, p = e.expandedMap), "enforceStringMap" in e && n(3, m = e.enforceStringMap), "visibleSectionsMap" in e && n(4, g = e.visibleSectionsMap), "validationErrorsMap" in e && n(5, y = e.validationErrorsMap), "searchResultItemsMap" in e && n(6, b = e.searchResultItemsMap), "selection" in e && n(7, w = e.selection), "context" in e && n(8, x = e.context), "onDragSelectionStart" in e && n(32, k = e.onDragSelectionStart), "$$scope" in e && n(34, d = e.$$scope);
    }, e.$$.update = function() {
        2 & e.$$.dirty[0] && n(9, o = Zs(v)), 516 & e.$$.dirty[0] && n(12, i = !!p && !0 === p[o]), 777 & e.$$.dirty[0] && n(13, a = oE(h, m, o, x.parser)), 528 & e.$$.dirty[0] && n(14, s = g ? g[o] : void 0), 544 & e.$$.dirty[0] && n(15, c = y ? y[o] : void 0), 386 & e.$$.dirty[0] && n(16, l = WE(x.getJson(), w, v)), 2 & e.$$.dirty[0] && n(17, r = 0 === v.length);
    }, [
        h,
        v,
        p,
        m,
        g,
        y,
        b,
        w,
        x,
        o,
        S,
        $,
        i,
        a,
        s,
        c,
        l,
        r,
        function(e, t, n, r, i, a, s, c, l) {
            var u = Object.keys(t).map(function(l) {
                var u = _(e.concat(l)), f = tc(o, l);
                return {
                    key: l,
                    value: t[l],
                    path: u,
                    expandedMap: kz(n, f),
                    enforceStringMap: kz(r, f),
                    visibleSectionsMap: kz(i, f),
                    validationErrorsMap: kz(a, f),
                    keySearchResultItemsMap: SA(s, f),
                    valueSearchResultItemsMap: kz(s, f),
                    selection: HE(x.getJson(), c, u)
                };
            });
            return l && 0 !== l.offset && (u = z_(u, l.selectionStartIndex, l.selectionItemsCount, l.offset)), u;
        },
        function(e, t, n, r, i, a, s, c, l, u) {
            for(var f = n.start, d = Math.min(n.end, t.length), h = [], v = f; v < d; v++){
                var p = _(e.concat(String(v))), m = tc(o, v);
                h.push({
                    index: v,
                    value: t[v],
                    path: p,
                    expandedMap: kz(r, m),
                    enforceStringMap: kz(i, m),
                    visibleSectionsMap: kz(a, m),
                    validationErrorsMap: kz(s, m),
                    searchResultItemsMap: kz(c, m),
                    selection: HE(x.getJson(), l, p)
                });
            }
            if (u && 0 !== u.offset) {
                var g = h.map(function(e) {
                    return e.index;
                });
                h = z_(h, u.selectionStartIndex, u.selectionItemsCount, u.offset);
                for(var y = 0; y < h.length; y++)h[y].index = g[y];
            }
            return h;
        },
        function(e) {
            e.stopPropagation();
            var t = e.ctrlKey;
            x.onExpand(v, !i, t);
        },
        function(e) {
            e.stopPropagation(), x.onExpand(v, !0);
        },
        function(e, t) {
            var n = aA(v, Object.keys(h), e, t);
            return x.onPatch(n), vb(Xs(n[0].path));
        },
        function(e) {
            if (!(function(e) {
                return "DIV" === e.nodeName && "true" === e.contentEditable;
            }(e.target) || 1 === e.which && yO(e.target, "BUTTON"))) {
                e.stopPropagation(), e.preventDefault(), x.focus(), document.addEventListener("mousemove", O, !0), document.addEventListener("mouseup", M);
                var t = _O(e.target), n = x.getJson(), o = x.getDocumentState();
                if (!w || t === Ya.after || t === Ya.inside || w.type !== t && w.type !== Ya.multi || !WE(n, w, v)) {
                    if (wz.selecting = !0, wz.selectionAnchor = v, wz.selectionAnchorType = t, wz.selectionFocus = v, e.shiftKey) {
                        var i = x.getDocumentState().selection;
                        i && x.onSelect(DE(KE(i), v));
                    } else if (t === Ya.multi) {
                        if (r && e.target.hasAttribute("data-path")) {
                            var a = vb(sE(h, o));
                            x.onSelect(FE(a));
                        } else x.onSelect(DE(v, v));
                    } else void 0 !== n && x.onSelect(VE(0, t, v));
                } else 0 === e.button && k(e);
            }
        },
        function(e) {
            if (wz.selecting) {
                e.preventDefault(), e.stopPropagation(), null == wz.selectionFocus && window.getSelection && window.getSelection().empty();
                var t = _O(e.target);
                Ox(v, wz.selectionFocus) && t === wz.selectionAnchorType || (wz.selectionFocus = v, wz.selectionAnchorType = t, x.onSelect(DE(wz.selectionAnchor || wz.selectionFocus, wz.selectionFocus)));
            }
        },
        function(e) {
            if (!x.readOnly && w) {
                var t = Qw(JE(w));
                if (Ox(v, t)) {
                    var r = function(e, t) {
                        var n = [];
                        function r(e) {
                            var t = v.concat(e), r = x.findElement(t);
                            null != r && n.push({
                                path: t,
                                height: r.clientHeight
                            });
                        }
                        if (Array.isArray(h)) {
                            var o = x.getJson();
                            if (void 0 === o) return null;
                            var i = kE(o, e), a = jE(o, e), s = parseInt(vb(i), 10), c = parseInt(vb(a), 10), l = t.find(function(e) {
                                return s >= e.start && c <= e.end;
                            });
                            if (!l) return null;
                            var u = l.start, f = l.end;
                            R_(u, Math.min(h.length, f), function(e) {
                                return r(String(e));
                            });
                        } else Object.keys(h).forEach(r);
                        return n;
                    }(w, s || ds);
                    if (j("dragSelectionStart", {
                        selection: w,
                        items: r
                    }), r) {
                        var o = x.getJson();
                        if (void 0 !== o) {
                            var i = kE(o, w), a = r.findIndex(function(e) {
                                return Ox(e.path, i);
                            }), c = xz({
                                json: o,
                                documentState: x.getDocumentState(),
                                deltaY: 0,
                                items: r
                            }).offset;
                            n(11, $ = {
                                initialTarget: e.target,
                                initialClientY: e.clientY,
                                initialContentTop: E(),
                                selectionStartIndex: a,
                                selectionItemsCount: wE(o, w).length,
                                items: r,
                                offset: c,
                                didMoveItems: !1
                            }), wz.dragging = !0, document.addEventListener("mousemove", P, !0), document.addEventListener("mouseup", T);
                        }
                    } else j("Cannot drag the current selection (probably spread over multiple sections)");
                } else k(e);
            }
        },
        function(e) {
            wz.selecting || wz.dragging || (e.stopPropagation(), bO(e.target, "data-type", "selectable-value") ? n(10, S = Cs) : bO(e.target, "data-type", "insert-selection-area-inside") ? n(10, S = js) : bO(e.target, "data-type", "insert-selection-area-after") && n(10, S = Ss), clearTimeout(C));
        },
        function(e) {
            e.stopPropagation(), C = window.setTimeout(function() {
                return n(10, S = void 0);
            });
        },
        function(e) {
            e.shiftKey || (e.stopPropagation(), e.preventDefault(), x.onSelect(NE(v)));
        },
        function(e) {
            e.shiftKey || (e.stopPropagation(), e.preventDefault(), x.onSelect(IE(v)));
        },
        function(e) {
            x.onSelect(NE(v)), x.onContextMenu(e);
        },
        function(e) {
            x.onSelect(IE(v)), x.onContextMenu(e);
        },
        k,
        f,
        d
    ];
}
var jq = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, kq, xq, Zo, {
            value: 0,
            path: 1,
            expandedMap: 2,
            enforceStringMap: 3,
            visibleSectionsMap: 4,
            validationErrorsMap: 5,
            searchResultItemsMap: 6,
            selection: 7,
            context: 8,
            onDragSelectionStart: 32
        }, _z, [
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t);
}(), Sq = jq, Cq = {
    prefix: "fas",
    iconName: "jsoneditor-expand",
    icon: [
        512,
        512,
        [],
        "",
        "M 0,448 V 512 h 512 v -64 z M 0,0 V 64 H 512 V 0 Z M 256,96 128,224 h 256 z M 256,416 384,288 H 128 Z"
    ]
}, $q = {
    prefix: "fas",
    iconName: "jsoneditor-collapse",
    icon: [
        512,
        512,
        [],
        "",
        "m 0,224 v 64 h 512 v -64 z M 256,192 384,64 H 128 Z M 256,320 128,448 h 256 z"
    ]
}, _q = {
    prefix: "fas",
    iconName: "jsoneditor-format",
    icon: [
        512,
        512,
        [],
        "",
        "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"
    ]
}, Oq = {
    prefix: "fas",
    iconName: "jsoneditor-compact",
    icon: [
        512,
        512,
        [],
        "",
        "M 0,32 v 64 h 512 v -64 z M 0,160 v 64 h 512 v -64 z M 0,288 v 64 h 352 v -64 z"
    ]
};
function Mq(e) {
    var t, n;
    return t = new PI({
        props: {
            items: e[0]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & jo(n, 1)[0] && (r.items = e[0]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Eq(e, t, n) {
    var r, o, i, a, s, c, l, u = t.json, f = t.selection, d = t.readOnly, h = t.showSearch, v = void 0 !== h && h, p = t.historyState, m = t.onExpandAll, g = t.onCollapseAll, y = t.onUndo, b = t.onRedo, w = t.onSort, x = t.onTransform, k = t.onContextMenu, j = t.onCopy, S = t.onRenderMenu;
    function C() {
        n(1, v = !v);
    }
    return e.$$set = function(e) {
        "json" in e && n(2, u = e.json), "selection" in e && n(3, f = e.selection), "readOnly" in e && n(4, d = e.readOnly), "showSearch" in e && n(1, v = e.showSearch), "historyState" in e && n(5, p = e.historyState), "onExpandAll" in e && n(6, m = e.onExpandAll), "onCollapseAll" in e && n(7, g = e.onCollapseAll), "onUndo" in e && n(8, y = e.onUndo), "onRedo" in e && n(9, b = e.onRedo), "onSort" in e && n(10, w = e.onSort), "onTransform" in e && n(11, x = e.onTransform), "onContextMenu" in e && n(12, k = e.onContextMenu), "onCopy" in e && n(13, j = e.onCopy), "onRenderMenu" in e && n(14, S = e.onRenderMenu);
    }, e.$$.update = function() {
        4 & e.$$.dirty && n(20, r = void 0 !== u), 1048584 & e.$$.dirty && n(19, o = r && (mE(f) || vE(f) || pE(f))), 68 & e.$$.dirty && n(15, a = {
            type: "button",
            icon: Cq,
            title: "Expand all",
            className: "jse-expand-all",
            onClick: m,
            disabled: !Ql(u)
        }), 132 & e.$$.dirty && n(16, s = {
            type: "button",
            icon: $q,
            title: "Collapse all",
            className: "jse-collapse-all",
            onClick: g,
            disabled: !Ql(u)
        }), 4 & e.$$.dirty && n(17, c = {
            type: "button",
            icon: jP,
            title: "Search (Ctrl+F)",
            className: "jse-search",
            onClick: C,
            disabled: void 0 === u
        }), 769844 & e.$$.dirty && n(18, l = d ? [
            a,
            s,
            {
                type: "separator"
            },
            {
                type: "button",
                icon: CP,
                title: "Copy (Ctrl+C)",
                className: "jse-copy",
                onClick: j,
                disabled: !o
            },
            {
                type: "separator"
            },
            c,
            {
                type: "space"
            }
        ] : [
            a,
            s,
            {
                type: "separator"
            },
            {
                type: "button",
                icon: wP,
                title: "Sort",
                className: "jse-sort",
                onClick: w,
                disabled: d || void 0 === u
            },
            {
                type: "button",
                icon: cP,
                title: "Transform contents (filter, sort, project)",
                className: "jse-transform",
                onClick: x,
                disabled: d || void 0 === u
            },
            c,
            {
                type: "button",
                icon: yP,
                title: ks,
                className: "jse-contextmenu",
                onClick: k
            },
            {
                type: "separator"
            },
            {
                type: "button",
                icon: vP,
                title: "Undo (Ctrl+Z)",
                className: "jse-undo",
                onClick: y,
                disabled: !p.canUndo
            },
            {
                type: "button",
                icon: hP,
                title: "Redo (Ctrl+Shift+Z)",
                className: "jse-redo",
                onClick: b,
                disabled: !p.canRedo
            },
            {
                type: "space"
            }
        ]), 278528 & e.$$.dirty && n(0, i = S(l));
    }, [
        i,
        v,
        u,
        f,
        d,
        p,
        m,
        g,
        y,
        b,
        w,
        x,
        k,
        j,
        S,
        a,
        s,
        c,
        l,
        o,
        r
    ];
}
var Aq = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, Eq, Mq, Zo, {
            json: 2,
            selection: 3,
            readOnly: 4,
            showSearch: 1,
            historyState: 5,
            onExpandAll: 6,
            onCollapseAll: 7,
            onUndo: 8,
            onRedo: 9,
            onSort: 10,
            onTransform: 11,
            onContextMenu: 12,
            onCopy: 13,
            onRenderMenu: 14
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function Pq(e) {
    mi(e, "svelte-s2toti", '.jse-welcome.svelte-s2toti.svelte-s2toti{flex:1;overflow:auto;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);display:flex;flex-direction:column;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti.svelte-s2toti:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti .jse-space.jse-before.svelte-s2toti{flex:1}.jse-welcome.svelte-s2toti .jse-space.jse-after.svelte-s2toti{flex:2}.jse-welcome.svelte-s2toti .jse-contents.svelte-s2toti{display:flex;flex-direction:column;max-width:300px;margin:2em var(--jse-padding, 10px);gap:var(--jse-padding, 10px)}.jse-welcome.svelte-s2toti .jse-contents .jse-welcome-info.svelte-s2toti{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}');
}
function Tq(e) {
    var t, n, r, o, i, a, s;
    return {
        c: function() {
            (t = ji("div")).innerHTML = "You can paste clipboard data using <b>Ctrl+V</b>, or use the following options:", n = $i(), (r = ji("button")).textContent = "Create object", o = $i(), (i = ji("button")).textContent = "Create array", Ai(t, "class", "jse-welcome-info svelte-s2toti"), Ai(r, "title", "Create an empty JSON object (press '{')"), Ai(r, "class", "svelte-s2toti"), Ai(i, "title", "Create an empty JSON array (press '[')"), Ai(i, "class", "svelte-s2toti");
        },
        m: function(c, l) {
            wi(c, t, l), wi(c, n, l), wi(c, r, l), wi(c, o, l), wi(c, i, l), a || (s = [
                Oi(r, "click", Ei(e[4])),
                Oi(i, "click", Ei(e[5]))
            ], a = !0);
        },
        p: Wo,
        d: function(e) {
            e && (xi(t), xi(n), xi(r), xi(o), xi(i)), a = !1, Qo(s);
        }
    };
}
function Rq(e) {
    var t, n, r, o, i, a, s, c, l, u, f = !e[0] && Tq(e);
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = $i(), o = ji("div"), (i = ji("div")).textContent = "Empty document", a = $i(), f && f.c(), s = $i(), c = ji("div"), Ai(n, "class", "jse-space jse-before svelte-s2toti"), Ai(i, "class", "jse-welcome-title"), Ai(o, "class", "jse-contents svelte-s2toti"), Ai(c, "class", "jse-space jse-after svelte-s2toti"), Ai(t, "class", "jse-welcome svelte-s2toti"), Ai(t, "role", "none");
        },
        m: function(d, h) {
            wi(d, t, h), pi(t, n), pi(t, r), pi(t, o), pi(o, i), pi(o, a), f && f.m(o, null), pi(t, s), pi(t, c), l || (u = Oi(t, "click", e[6]), l = !0);
        },
        p: function(e, t) {
            var n = jo(t, 1)[0];
            e[0] ? f && (f.d(1), f = null) : f ? f.p(e, n) : ((f = Tq(e)).c(), f.m(o, null));
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), f && f.d(), l = !1, u();
        }
    };
}
function Nq(e, t, n) {
    var r = t.readOnly, o = t.onCreateArray, i = t.onCreateObject, a = t.onClick;
    return e.$$set = function(e) {
        "readOnly" in e && n(0, r = e.readOnly), "onCreateArray" in e && n(1, o = e.onCreateArray), "onCreateObject" in e && n(2, i = e.onCreateObject), "onClick" in e && n(3, a = e.onClick);
    }, [
        r,
        o,
        i,
        a,
        function() {
            return i();
        },
        function() {
            return o();
        },
        function() {
            return a();
        }
    ];
}
var Iq = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, Nq, Rq, Zo, {
            readOnly: 0,
            onCreateArray: 1,
            onCreateObject: 2,
            onClick: 3
        }, Pq), n;
    }
    return Ao(t, Ia), Do(t);
}(), Dq = {
    exports: {}
}, zq = function(e, t) {
    var n, r, o = 1, i = 0, a = 0, s = String.alphabet;
    function c(e, t, r) {
        if (r) {
            for(n = t; (r = c(e, n)) < 76 && r > 65;)++n;
            return +e.slice(t - 1, n);
        }
        return (r = s && s.indexOf(e.charAt(t))) > -1 ? r + 76 : (r = e.charCodeAt(t) || 0) < 45 || r > 127 ? r : r < 46 ? 65 : r < 48 ? r - 1 : r < 58 ? r + 18 : r < 65 ? r - 11 : r < 91 ? r + 11 : r < 97 ? r - 37 : r < 123 ? r + 5 : r - 63;
    }
    if ((e += "") != (t += "")) {
        for(; o;)if (r = c(e, i++), o = c(t, a++), r < 76 && o < 76 && r > 66 && o > 66 && (r = c(e, i, i), o = c(t, a, i = n), a = n), r != o) return r < o ? -1 : 1;
    }
    return 0;
};
try {
    Dq.exports = zq;
} catch (e) {
    String.naturalCompare = zq;
}
var qq = yc(Dq.exports);
function Bq(e, t) {
    var n = "string" == typeof e ? e.toLowerCase() : e, r = "string" == typeof t ? t.toLowerCase() : t;
    return qq(n, r);
}
function Lq(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
    if (Ts(Ws(e, t))) {
        if (void 0 === n) throw new Error("Cannot sort: no property selected by which to sort the array");
        return function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, o = function(e, t) {
                return function(n, r) {
                    var o = Ws(n, e), i = Ws(r, e);
                    return void 0 === o ? t : void 0 === i ? -t : "string" != typeof o && "string" != typeof i ? o > i ? t : o < i ? -t : 0 : t * Bq(o, i);
                };
            }(n, r), i = Ws(e, t);
            return [
                {
                    op: "replace",
                    path: Zs(t),
                    value: i.slice(0).sort(o)
                }
            ];
        }(e, t, n, r);
    }
    if (Gl(e)) return function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, r = Ws(e, t), o = Object.keys(r), i = o.slice();
        i.sort(function(e, t) {
            return n * Bq(e, t);
        });
        for(var a = [], s = 0; s < i.length; s++){
            var c = i[s], l = Zs(t.concat(c));
            a.push({
                op: "move",
                from: l,
                path: l
            });
        }
        return a;
    }(e, t, r);
    throw new Error("Cannot sort: no array or object");
}
function Fq(e) {
    mi(e, "svelte-12glmu0", '.jse-navigation-bar-dropdown.svelte-12glmu0.svelte-12glmu0{position:absolute;top:100%;left:0;z-index:3;background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:flex;flex-direction:column;max-height:300px;overflow:auto;min-width:80px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);border:none;background:transparent;color:inherit;cursor:pointer;outline:none;text-align:left;white-space:nowrap;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px)) 36px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:focus,.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:hover{background:var(--jse-navigation-bar-background-highlight, #e5e5e5)}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.jse-selected.svelte-12glmu0{background:var(--jse-navigation-bar-dropdown-color, #656565);color:var(--jse-navigation-bar-background, var(--jse-background-color, #fff))}');
}
function Vq(e, t, n) {
    var r = e.slice();
    return r[4] = t[n], r;
}
function Hq(e, t) {
    var n, r, o, i, a, s = tM(t[4].toString(), Kq) + "";
    function c() {
        return t[3](t[4]);
    }
    return {
        key: e,
        first: null,
        c: function() {
            n = ji("button"), r = Ci(s), Ai(n, "type", "button"), Ai(n, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), Ai(n, "title", o = t[4].toString()), qi(n, "jse-selected", t[4] === t[1]), this.first = n;
        },
        m: function(e, t) {
            wi(e, n, t), pi(n, r), i || (a = Oi(n, "click", Ei(c)), i = !0);
        },
        p: function(e, i) {
            t = e, 1 & i && s !== (s = tM(t[4].toString(), Kq) + "") && Ni(r, s), 1 & i && o !== (o = t[4].toString()) && Ai(n, "title", o), 3 & i && qi(n, "jse-selected", t[4] === t[1]);
        },
        d: function(e) {
            e && xi(n), i = !1, a();
        }
    };
}
function Wq(e) {
    var t, n;
    return {
        c: function() {
            t = ji("button"), n = Ci("..."), Ai(t, "type", "button"), Ai(t, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), Ai(t, "title", "Limited to " + Jq + " items");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function Uq(e) {
    for(var t, n, r = [], o = new Map, i = Ca(N_(e[0], Jq)), a = function(e) {
        return e[4];
    }, s = 0; s < i.length; s += 1){
        var c = Vq(e, i, s), l = a(c);
        o.set(l, r[s] = Hq(l, c));
    }
    var u = e[0].length > Jq && Wq();
    return {
        c: function() {
            t = ji("div");
            for(var e = 0; e < r.length; e += 1)r[e].c();
            n = $i(), u && u.c(), Ai(t, "class", "jse-navigation-bar-dropdown svelte-12glmu0");
        },
        m: function(e, o) {
            wi(e, t, o);
            for(var i = 0; i < r.length; i += 1)r[i] && r[i].m(t, null);
            pi(t, n), u && u.m(t, null);
        },
        p: function(e, s) {
            var c = jo(s, 1)[0];
            7 & c && (i = Ca(N_(e[0], Jq)), r = Oa(r, c, a, 1, e, i, o, t, $a, Hq, n, Vq)), e[0].length > Jq ? u ? u.p(e, c) : ((u = Wq()).c(), u.m(t, null)) : u && (u.d(1), u = null);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
            for(var n = 0; n < r.length; n += 1)r[n].d();
            u && u.d();
        }
    };
}
var Jq = 100, Kq = 30;
function Gq(e, t, n) {
    var r = t.items, o = t.selectedItem, i = t.onSelect;
    return e.$$set = function(e) {
        "items" in e && n(0, r = e.items), "selectedItem" in e && n(1, o = e.selectedItem), "onSelect" in e && n(2, i = e.onSelect);
    }, [
        r,
        o,
        i,
        function(e) {
            return i(e);
        }
    ];
}
var Qq = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, Gq, Uq, Zo, {
            items: 0,
            selectedItem: 1,
            onSelect: 2
        }, Fq), n;
    }
    return Ao(t, Ia), Do(t);
}();
function Yq(e) {
    mi(e, "svelte-x08607", ".jse-navigation-bar-item.svelte-x08607.svelte-x08607{position:relative;display:flex}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607{font-family:inherit;font-size:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) 2px;border:none;background:transparent;color:inherit;cursor:pointer;outline:none;min-width:2em;white-space:nowrap}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:focus,.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:hover{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d))}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.svelte-x08607{padding:2px var(--jse-padding, 10px) 0}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.jse-open.svelte-x08607{background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565)}.jse-navigation-bar-item.svelte-x08607.svelte-x08607:last-child{padding-right:var(--jse-padding, 10px)}");
}
function Xq(e) {
    var t, n, r, o;
    return {
        c: function() {
            t = ji("button"), n = Ci(e[2]), Ai(t, "type", "button"), Ai(t, "class", "jse-navigation-bar-button svelte-x08607");
        },
        m: function(i, a) {
            wi(i, t, a), pi(t, n), r || (o = Oi(t, "click", e[9]), r = !0);
        },
        p: function(e, t) {
            4 & t && Ni(n, e[2]);
        },
        d: function(e) {
            e && xi(t), r = !1, o();
        }
    };
}
function Zq(e) {
    var t, n, r, o, i, a, s;
    r = new jM({
        props: {
            data: iP
        }
    });
    var c = void 0 !== e[2] && Xq(e);
    return {
        c: function() {
            t = ji("div"), n = ji("button"), Pa(r.$$.fragment), o = $i(), c && c.c(), Ai(n, "type", "button"), Ai(n, "class", "jse-navigation-bar-button jse-navigation-bar-arrow svelte-x08607"), qi(n, "jse-open", e[1]), Ai(t, "class", "jse-navigation-bar-item svelte-x08607");
        },
        m: function(l, u) {
            wi(l, t, u), pi(t, n), Ta(r, n, null), pi(t, o), c && c.m(t, null), e[10](t), i = !0, a || (s = Oi(n, "click", e[4]), a = !0);
        },
        p: function(e, r) {
            var o = jo(r, 1)[0];
            (!i || 2 & o) && qi(n, "jse-open", e[1]), void 0 !== e[2] ? c ? c.p(e, o) : ((c = Xq(e)).c(), c.m(t, null)) : c && (c.d(1), c = null);
        },
        i: function(e) {
            i || (xa(r.$$.fragment, e), i = !0);
        },
        o: function(e) {
            ka(r.$$.fragment, e), i = !1;
        },
        d: function(n) {
            n && xi(t), Ra(r), c && c.d(), e[10](null), a = !1, s();
        }
    };
}
function eB(e, t, n) {
    var r, o, i, a, s = Zi("absolute-popup"), c = s.openAbsolutePopup, l = s.closeAbsolutePopup, u = t.path, f = t.index, d = t.onSelect, h = t.getItems, v = !1;
    function p(e) {
        l(a), d(r.concat(e));
    }
    return e.$$set = function(e) {
        "path" in e && n(5, u = e.path), "index" in e && n(6, f = e.index), "onSelect" in e && n(7, d = e.onSelect), "getItems" in e && n(8, h = e.getItems);
    }, e.$$.update = function() {
        96 & e.$$.dirty && (r = u.slice(0, f)), 96 & e.$$.dirty && n(2, o = u[f]);
    }, [
        i,
        v,
        o,
        p,
        function() {
            if (i) {
                n(1, v = !0);
                var e = {
                    items: h(r),
                    selectedItem: o,
                    onSelect: p
                };
                a = c(Qq, e, {
                    anchor: i,
                    closeOnOuterClick: !0,
                    onClose: function() {
                        n(1, v = !1);
                    }
                });
            }
        },
        u,
        f,
        d,
        h,
        function() {
            return p(o);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(0, i = e);
            });
        }
    ];
}
var tB = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, eB, Zq, Zo, {
            path: 5,
            index: 6,
            onSelect: 7,
            getItems: 8
        }, Yq), n;
    }
    return Ao(t, Ia), Do(t);
}();
function nB(e) {
    var t, n;
    if (navigator.clipboard) return navigator.clipboard.writeText(e);
    if (null !== (t = (n = document).queryCommandSupported) && void 0 !== t && t.call(n, "copy")) {
        var r = document.createElement("textarea");
        r.value = e, r.style.position = "fixed", r.style.opacity = "0", document.body.appendChild(r), r.select();
        try {
            document.execCommand("copy");
        } catch (e) {
            console.error(e);
        } finally{
            document.body.removeChild(r);
        }
    } else console.error("Copy failed.");
}
function rB(e) {
    mi(e, "svelte-1844qyt", ".jse-navigation-bar-path-editor.svelte-1844qyt.svelte-1844qyt{flex:1;display:flex;border:var(--jse-edit-outline, 2px solid #656565);background:var(--jse-background-color, #fff)}.jse-navigation-bar-path-editor.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{flex:1;font-family:inherit;font-size:inherit;padding:0 5px 1px;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d);border:none;outline:none}.jse-navigation-bar-path-editor.svelte-1844qyt button.svelte-1844qyt{border:none;background:var(--jse-background-color, #fff);cursor:pointer;font-family:inherit;font-size:80%;color:inherit}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-copy.copied.svelte-1844qyt{color:var(--message-success-background, #9ac45d)}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-validation-error.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt.svelte-1844qyt{border-color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.svelte-1844qyt .jse-copied-text.svelte-1844qyt{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff);position:relative;margin:2px;padding:0 5px;border-radius:3px}");
}
function oB(e) {
    var t, n, r, o, i, a;
    return n = new jM({
        props: {
            data: TP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-navigation-bar-validation-error svelte-1844qyt");
        },
        m: function(s, c) {
            wi(s, t, c), Ta(n, t, null), o = !0, i || (a = ci(r = HA.call(null, t, Ro({
                text: String(e[3] || "")
            }, e[4]))), i = !0);
        },
        p: function(e, t) {
            r && Yo(r.update) && 8 & t && r.update.call(null, Ro({
                text: String(e[3] || "")
            }, e[4]));
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, a();
        }
    };
}
function iB(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).textContent = "Copied!", Ai(t, "class", "jse-copied-text svelte-1844qyt");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function aB(e) {
    var t, n, r, o, i, a, s, c, l, u, f = e[3] && oB(e), d = e[2] && iB();
    return s = new jM({
        props: {
            data: CP
        }
    }), {
        c: function() {
            t = ji("div"), n = ji("input"), r = $i(), f && f.c(), o = $i(), d && d.c(), i = $i(), a = ji("button"), Pa(s.$$.fragment), Ai(n, "type", "text"), Ai(n, "class", "jse-navigation-bar-text svelte-1844qyt"), n.value = e[0], Ai(a, "type", "button"), Ai(a, "class", "jse-navigation-bar-copy svelte-1844qyt"), Ai(a, "title", "Copy selected path to the clipboard"), qi(a, "copied", e[2]), Ai(t, "class", "jse-navigation-bar-path-editor svelte-1844qyt"), qi(t, "error", e[3]);
        },
        m: function(h, v) {
            wi(h, t, v), pi(t, n), e[15](n), pi(t, r), f && f.m(t, null), pi(t, o), d && d.m(t, null), pi(t, i), pi(t, a), Ta(s, a, null), c = !0, l || (u = [
                Oi(n, "keydown", Ei(e[6])),
                Oi(n, "input", e[5]),
                Oi(a, "click", e[7])
            ], l = !0);
        },
        p: function(e, r) {
            var s = jo(r, 1)[0];
            (!c || 1 & s && n.value !== e[0]) && (n.value = e[0]), e[3] ? f ? (f.p(e, s), 8 & s && xa(f, 1)) : ((f = oB(e)).c(), xa(f, 1), f.m(t, o)) : f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa()), e[2] ? d || ((d = iB()).c(), d.m(t, i)) : d && (d.d(1), d = null), (!c || 4 & s) && qi(a, "copied", e[2]), (!c || 8 & s) && qi(t, "error", e[3]);
        },
        i: function(e) {
            c || (xa(f), xa(s.$$.fragment, e), c = !0);
        },
        o: function(e) {
            ka(f), ka(s.$$.fragment, e), c = !1;
        },
        d: function(n) {
            n && xi(t), e[15](null), f && f.d(), d && d.d(), Ra(s), l = !1, Qo(u);
        }
    };
}
function sB(e, t, n) {
    var r, o, i, a = Zi("absolute-popup"), s = t.path, c = t.pathParser, l = t.onChange, u = t.onClose, f = t.onError, d = t.pathExists, h = !1, v = void 0, p = !1;
    function m() {
        o.focus();
    }
    function g(e) {
        try {
            var t = c.parse(e);
            return function(e) {
                if (!d(e)) throw new Error("Path does not exist in current document");
            }(t), {
                path: t,
                error: void 0
            };
        } catch (e) {
            return {
                path: void 0,
                error: e
            };
        }
    }
    return Gi(function() {
        m();
    }), Qi(function() {
        clearTimeout(v);
    }), e.$$set = function(e) {
        "path" in e && n(8, s = e.path), "pathParser" in e && n(9, c = e.pathParser), "onChange" in e && n(10, l = e.onChange), "onClose" in e && n(11, u = e.onClose), "onError" in e && n(12, f = e.onError), "pathExists" in e && n(13, d = e.pathExists);
    }, e.$$.update = function() {
        768 & e.$$.dirty && n(0, i = c.stringify(s)), 16385 & e.$$.dirty && n(3, r = h ? g(i).error : void 0);
    }, [
        i,
        o,
        p,
        r,
        a,
        function(e) {
            n(0, i = e.currentTarget.value);
        },
        function(e) {
            var t = PO(e);
            if ("Escape" === t && u(), "Enter" === t) {
                n(14, h = !0);
                var r = g(i);
                void 0 !== r.path ? l(r.path) : f(r.error);
            }
        },
        function() {
            nB(i), n(2, p = !0), v = window.setTimeout(function() {
                return n(2, p = !1);
            }, 1e3), m();
        },
        s,
        c,
        l,
        u,
        f,
        d,
        h,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(1, o = e);
            });
        }
    ];
}
var cB = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, sB, aB, Xo, {
            path: 8,
            pathParser: 9,
            onChange: 10,
            onClose: 11,
            onError: 12,
            pathExists: 13
        }, rB), n;
    }
    return Ao(t, Ia), Do(t);
}();
function lB(e) {
    mi(e, "svelte-1aycet9", '.jse-navigation-bar.svelte-1aycet9.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-button-color, inherit);padding:0;margin:0;display:flex;overflow:auto;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);color:var(--jse-panel-color-readonly, #b2b2b2);background:transparent;border:none;display:flex;cursor:pointer;outline:none;align-items:center}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.flex.svelte-1aycet9{flex:1}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:focus,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:hover,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.editing.svelte-1aycet9{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));transition:color 0.2s ease-in, background 0.2s ease-in}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit .jse-navigation-bar-space.svelte-1aycet9{flex:1;text-align:left}');
}
function uB(e, t, n) {
    var r = e.slice();
    return r[18] = t[n], r[20] = n, r;
}
function fB(e) {
    var t, n;
    return t = new cB({
        props: {
            path: e[3],
            onClose: e[11],
            onChange: e[12],
            onError: e[1],
            pathExists: e[8],
            pathParser: e[2]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            8 & n && (r.path = e[3]), 2 & n && (r.onError = e[1]), 4 & n && (r.pathParser = e[2]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function dB(e) {
    for(var t, n, r, o = [], i = new Map, a = Ca(e[3]), s = function(e) {
        return e[20];
    }, c = 0; c < a.length; c += 1){
        var l = uB(e, a, c), u = s(l);
        i.set(u, o[c] = hB(u, l));
    }
    var f = e[6] && vB(e);
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = $i(), f && f.c(), n = _i();
        },
        m: function(e, i) {
            for(var a = 0; a < o.length; a += 1)o[a] && o[a].m(e, i);
            wi(e, t, i), f && f.m(e, i), wi(e, n, i), r = !0;
        },
        p: function(e, r) {
            648 & r && (a = Ca(e[3]), ba(), o = Oa(o, r, s, 1, e, a, i, t.parentNode, _a, hB, t, uB), wa()), e[6] ? f ? (f.p(e, r), 64 & r && xa(f, 1)) : ((f = vB(e)).c(), xa(f, 1), f.m(n.parentNode, n)) : f && (ba(), ka(f, 1, 1, function() {
                f = null;
            }), wa());
        },
        i: function(e) {
            if (!r) {
                for(var t = 0; t < a.length; t += 1)xa(o[t]);
                xa(f), r = !0;
            }
        },
        o: function(e) {
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            ka(f), r = !1;
        },
        d: function(e) {
            e && (xi(t), xi(n));
            for(var r = 0; r < o.length; r += 1)o[r].d(e);
            f && f.d(e);
        }
    };
}
function hB(e, t) {
    var n, r, o;
    return r = new tB({
        props: {
            getItems: t[7],
            path: t[3],
            index: t[20],
            onSelect: t[9]
        }
    }), {
        key: e,
        first: null,
        c: function() {
            n = _i(), Pa(r.$$.fragment), this.first = n;
        },
        m: function(e, t) {
            wi(e, n, t), Ta(r, e, t), o = !0;
        },
        p: function(e, n) {
            t = e;
            var o = {};
            8 & n && (o.path = t[3]), 8 & n && (o.index = t[20]), r.$set(o);
        },
        i: function(e) {
            o || (xa(r.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(r.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(n), Ra(r, e);
        }
    };
}
function vB(e) {
    var t, n;
    return t = new tB({
        props: {
            getItems: e[7],
            path: e[3],
            index: e[3].length,
            onSelect: e[9]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            8 & n && (r.path = e[3]), 8 & n && (r.index = e[3].length), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function pB(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v = Ql(e[0]) || e[5] ? "\xa0" : "Navigation bar", p = [
        dB,
        fB
    ], m = [];
    function g(e, t) {
        return e[5] ? 1 : 0;
    }
    return n = g(e), r = m[n] = p[n](e), l = new jM({
        props: {
            data: e[5] ? OP : rP
        }
    }), {
        c: function() {
            t = ji("div"), r.c(), o = $i(), i = ji("button"), a = ji("span"), s = Ci(v), c = $i(), Pa(l.$$.fragment), Ai(a, "class", "jse-navigation-bar-space svelte-1aycet9"), Ai(i, "type", "button"), Ai(i, "class", "jse-navigation-bar-edit svelte-1aycet9"), Ai(i, "title", u = e[5] ? "Cancel editing the selected path" : "Edit the selected path"), qi(i, "flex", !e[5]), qi(i, "editing", e[5]), Ai(t, "class", "jse-navigation-bar svelte-1aycet9");
        },
        m: function(r, u) {
            wi(r, t, u), m[n].m(t, null), pi(t, o), pi(t, i), pi(i, a), pi(a, s), pi(i, c), Ta(l, i, null), e[15](t), f = !0, d || (h = Oi(i, "click", e[10]), d = !0);
        },
        p: function(e, a) {
            var c = jo(a, 1)[0], d = n;
            (n = g(e)) === d ? m[n].p(e, c) : (ba(), ka(m[d], 1, 1, function() {
                m[d] = null;
            }), wa(), (r = m[n]) ? r.p(e, c) : (r = m[n] = p[n](e)).c(), xa(r, 1), r.m(t, o)), (!f || 33 & c) && v !== (v = Ql(e[0]) || e[5] ? "\xa0" : "Navigation bar") && Ni(s, v);
            var h = {};
            32 & c && (h.data = e[5] ? OP : rP), l.$set(h), (!f || 32 & c && u !== (u = e[5] ? "Cancel editing the selected path" : "Edit the selected path")) && Ai(i, "title", u), (!f || 32 & c) && qi(i, "flex", !e[5]), (!f || 32 & c) && qi(i, "editing", e[5]);
        },
        i: function(e) {
            f || (xa(r), xa(l.$$.fragment, e), f = !0);
        },
        o: function(e) {
            ka(r), ka(l.$$.fragment, e), f = !1;
        },
        d: function(r) {
            r && xi(t), m[n].d(), Ra(l), e[15](null), d = !1, h();
        }
    };
}
function mB(e, t, n) {
    var r, o, i, a = Da("jsoneditor:NavigationBar"), s = t.json, c = t.selection, l = t.onSelect, u = t.onError, f = t.pathParser, d = !1;
    function h(e) {
        a("select path", JSON.stringify(e)), l(DE(e, e));
    }
    function v() {
        n(5, d = !1);
    }
    return e.$$set = function(e) {
        "json" in e && n(0, s = e.json), "selection" in e && n(13, c = e.selection), "onSelect" in e && n(14, l = e.onSelect), "onError" in e && n(1, u = e.onError), "pathParser" in e && n(2, f = e.pathParser);
    }, e.$$.update = function() {
        8192 & e.$$.dirty && n(3, r = c ? JE(c) : []), 9 & e.$$.dirty && n(6, o = Ql(Ws(s, r))), 8 & e.$$.dirty && setTimeout(function() {
            if (i && i.scrollTo) {
                var e = i.scrollWidth - i.clientWidth;
                e > 0 && (a("scrollTo ", e), i.scrollTo({
                    left: e,
                    behavior: "smooth"
                }));
            }
        });
    }, [
        s,
        u,
        f,
        r,
        i,
        d,
        o,
        function(e) {
            a("get items for path", e);
            var t = Ws(s, e);
            if (Array.isArray(t)) return hS(0, t.length).map(String);
            if (Gl(t)) {
                var n = Object.keys(t).slice(0);
                return n.sort(Bq), n;
            }
            return [];
        },
        function(e) {
            return Ys(s, e);
        },
        h,
        function() {
            n(5, d = !d);
        },
        v,
        function(e) {
            v(), h(e);
        },
        c,
        l,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(4, i = e);
            });
        }
    ];
}
var gB = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, mB, pB, Zo, {
            json: 0,
            selection: 13,
            onSelect: 14,
            onError: 1,
            pathParser: 2
        }, lB), n;
    }
    return Ao(t, Ia), Do(t);
}();
function yB(e) {
    mi(e, "svelte-1vkjt6l", '.jse-search-box.svelte-1vkjt6l.svelte-1vkjt6l{border:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-radius:3px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:inline-block;width:400px;max-width:100%;overflow:auto}.jse-search-box.svelte-1vkjt6l .jse-search-form.svelte-1vkjt6l{display:flex;align-items:stretch}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l,.jse-search-box.svelte-1vkjt6l .jse-search-form input.svelte-1vkjt6l{font-family:inherit;font-size:inherit}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l{display:block;text-align:center;border:none;padding:0 5px;margin:0;cursor:pointer;color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent)}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-1vkjt6l .jse-search-form input.svelte-1vkjt6l{color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:3px;background:var(--jse-input-background, var(--jse-background-color, #fff));height:28px;padding:0 5px;margin:0;flex:1;width:0;min-width:50px;outline:none}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-replace-toggle.svelte-1vkjt6l{padding:var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px));min-width:20px;background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents.svelte-1vkjt6l{flex:1;display:flex;flex-direction:column;padding:calc(0.5 * var(--jse-padding, 10px));gap:calc(0.5 * var(--jse-padding, 10px))}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section.svelte-1vkjt6l{flex:1;display:flex;align-items:center;position:relative;padding-left:32px}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-icon.svelte-1vkjt6l{color:inherit;cursor:inherit;background:inherit;position:absolute;top:calc(0.5 * var(--jse-padding, 10px));left:calc(0.5 * var(--jse-padding, 10px))}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section label.jse-search-input-label.svelte-1vkjt6l{flex:1;display:flex}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.svelte-1vkjt6l{color:inherit;font-size:80%;visibility:hidden;padding:0 5px;min-width:36px;text-align:center}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.jse-visible.svelte-1vkjt6l{visibility:visible}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-replace-section.svelte-1vkjt6l{padding-left:32px;flex:1;display:flex}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-replace-section button.svelte-1vkjt6l{width:auto}');
}
function bB(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M = (-1 !== e[3] ? "".concat(e[3] + 1, "/") : "") + "", E = !e[4] && wB(e), A = [
        kB,
        xB
    ], P = [];
    function T(e, t) {
        return e[2] ? 0 : 1;
    }
    s = T(e), c = P[s] = A[s](e), y = new jM({
        props: {
            data: SP
        }
    }), x = new jM({
        props: {
            data: oP
        }
    }), S = new jM({
        props: {
            data: MP
        }
    });
    var R = e[0] && !e[4] && jB(e);
    return {
        c: function() {
            t = ji("div"), n = ji("form"), E && E.c(), r = $i(), o = ji("div"), i = ji("div"), a = ji("div"), c.c(), l = $i(), u = ji("label"), f = ji("input"), d = $i(), h = ji("div"), v = Ci(M), p = Ci(e[10]), m = $i(), g = ji("button"), Pa(y.$$.fragment), b = $i(), w = ji("button"), Pa(x.$$.fragment), k = $i(), j = ji("button"), Pa(S.$$.fragment), C = $i(), R && R.c(), Ai(a, "class", "jse-search-icon svelte-1vkjt6l"), Ai(f, "class", "jse-search-input svelte-1vkjt6l"), Ai(f, "title", "Enter text to search"), Ai(f, "type", "text"), Ai(f, "placeholder", "Find"), Ai(u, "class", "jse-search-input-label svelte-1vkjt6l"), Ai(u, "about", "jse-search input"), Ai(h, "class", "jse-search-count svelte-1vkjt6l"), qi(h, "jse-visible", "" !== e[8]), Ai(g, "type", "button"), Ai(g, "class", "jse-search-next svelte-1vkjt6l"), Ai(g, "title", "Go to next search result (Enter)"), Ai(w, "type", "button"), Ai(w, "class", "jse-search-previous svelte-1vkjt6l"), Ai(w, "title", "Go to previous search result (Shift+Enter)"), Ai(j, "type", "button"), Ai(j, "class", "jse-search-clear svelte-1vkjt6l"), Ai(j, "title", "Close search box (Esc)"), Ai(i, "class", "jse-search-section svelte-1vkjt6l"), Ai(o, "class", "jse-search-contents svelte-1vkjt6l"), Ai(n, "class", "jse-search-form svelte-1vkjt6l"), Ai(t, "class", "jse-search-box svelte-1vkjt6l");
        },
        m: function(c, M) {
            wi(c, t, M), pi(t, n), E && E.m(n, null), pi(n, r), pi(n, o), pi(o, i), pi(i, a), P[s].m(a, null), pi(i, l), pi(i, u), pi(u, f), Ii(f, e[8]), pi(i, d), pi(i, h), pi(h, v), pi(h, p), pi(i, m), pi(i, g), Ta(y, g, null), pi(i, b), pi(i, w), Ta(x, w, null), pi(i, k), pi(i, j), Ta(S, j, null), pi(o, C), R && R.m(o, null), $ = !0, _ || (O = [
                Oi(f, "input", e[21]),
                ci(CB.call(null, f)),
                Oi(g, "click", e[22]),
                Oi(w, "click", e[23]),
                Oi(j, "click", e[24]),
                Oi(n, "submit", e[12]),
                Oi(n, "keydown", e[13])
            ], _ = !0);
        },
        p: function(e, t) {
            e[4] ? E && (ba(), ka(E, 1, 1, function() {
                E = null;
            }), wa()) : E ? (E.p(e, t), 16 & t && xa(E, 1)) : ((E = wB(e)).c(), xa(E, 1), E.m(n, r));
            var i = s;
            (s = T(e)) !== i && (ba(), ka(P[i], 1, 1, function() {
                P[i] = null;
            }), wa(), (c = P[s]) || (c = P[s] = A[s](e)).c(), xa(c, 1), c.m(a, null)), 256 & t && f.value !== e[8] && Ii(f, e[8]), (!$ || 8 & t) && M !== (M = (-1 !== e[3] ? "".concat(e[3] + 1, "/") : "") + "") && Ni(v, M), (!$ || 1024 & t) && Ni(p, e[10]), (!$ || 256 & t) && qi(h, "jse-visible", "" !== e[8]), e[0] && !e[4] ? R ? R.p(e, t) : ((R = jB(e)).c(), R.m(o, null)) : R && (R.d(1), R = null);
        },
        i: function(e) {
            $ || (xa(E), xa(c), xa(y.$$.fragment, e), xa(x.$$.fragment, e), xa(S.$$.fragment, e), $ = !0);
        },
        o: function(e) {
            ka(E), ka(c), ka(y.$$.fragment, e), ka(x.$$.fragment, e), ka(S.$$.fragment, e), $ = !1;
        },
        d: function(e) {
            e && xi(t), E && E.d(), P[s].d(), Ra(y), Ra(x), Ra(S), R && R.d(), _ = !1, Qo(O);
        }
    };
}
function wB(e) {
    var t, n, r, o, i;
    return n = new jM({
        props: {
            data: e[0] ? gP : YA
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-replace-toggle svelte-1vkjt6l"), Ai(t, "title", "Toggle visibility of replace options (Ctrl+H)");
        },
        m: function(a, s) {
            wi(a, t, s), Ta(n, t, null), r = !0, o || (i = Oi(t, "click", e[11]), o = !0);
        },
        p: function(e, t) {
            var r = {};
            1 & t && (r.data = e[0] ? gP : YA), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), o = !1, i();
        }
    };
}
function xB(e) {
    var t, n;
    return t = new jM({
        props: {
            data: jP
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function kB(e) {
    var t, n;
    return t = new jM({
        props: {
            data: ZA,
            spin: !0
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function jB(e) {
    var t, n, r, o, i, a, s, c;
    return {
        c: function() {
            t = ji("div"), n = ji("input"), r = $i(), (o = ji("button")).textContent = "Replace", i = $i(), (a = ji("button")).textContent = "All", Ai(n, "class", "jse-replace-input svelte-1vkjt6l"), Ai(n, "title", "Enter replacement text"), Ai(n, "type", "text"), Ai(n, "placeholder", "Replace"), Ai(o, "type", "button"), Ai(o, "title", "Replace current occurrence (Ctrl+Enter)"), Ai(o, "class", "svelte-1vkjt6l"), Ai(a, "type", "button"), Ai(a, "title", "Replace all occurrences"), Ai(a, "class", "svelte-1vkjt6l"), Ai(t, "class", "jse-replace-section svelte-1vkjt6l");
        },
        m: function(l, u) {
            wi(l, t, u), pi(t, n), Ii(n, e[9]), pi(t, r), pi(t, o), pi(t, i), pi(t, a), s || (c = [
                Oi(n, "input", e[25]),
                Oi(o, "click", e[14]),
                Oi(a, "click", e[15])
            ], s = !0);
        },
        p: function(e, t) {
            512 & t && n.value !== e[9] && Ii(n, e[9]);
        },
        d: function(e) {
            e && xi(t), s = !1, Qo(c);
        }
    };
}
function SB(e) {
    var t, n, r = e[1] && bB(e);
    return {
        c: function() {
            r && r.c(), t = _i();
        },
        m: function(e, o) {
            r && r.m(e, o), wi(e, t, o), n = !0;
        },
        p: function(e, n) {
            var o = jo(n, 1)[0];
            e[1] ? r ? (r.p(e, o), 2 & o && xa(r, 1)) : ((r = bB(e)).c(), xa(r, 1), r.m(t.parentNode, t)) : r && (ba(), ka(r, 1, 1, function() {
                r = null;
            }), wa());
        },
        i: function(e) {
            n || (xa(r), n = !0);
        },
        o: function(e) {
            ka(r), n = !1;
        },
        d: function(e) {
            e && xi(t), r && r.d(e);
        }
    };
}
function CB(e) {
    e.select();
}
function $B(e, t, n) {
    var r, o, i = t.show, a = void 0 !== i && i, s = t.searching, c = t.resultCount, l = void 0 === c ? 0 : c, u = t.activeIndex, f = void 0 === u ? 0 : u, d = t.showReplace, h = void 0 !== d && d, v = t.readOnly, p = void 0 !== v && v, m = t.onChange, g = void 0 === m ? Mf : m, y = t.onPrevious, b = void 0 === y ? Mf : y, w = t.onNext, x = void 0 === w ? Mf : w, k = t.onReplace, j = void 0 === k ? Mf : k, S = t.onReplaceAll, C = void 0 === S ? Mf : S, $ = t.onClose, _ = void 0 === $ ? Mf : $, O = "", M = "", E = "";
    function A() {
        n(0, h = !h && !p);
    }
    function P() {
        p || j(O, E);
    }
    return e.$$set = function(e) {
        "show" in e && n(1, a = e.show), "searching" in e && n(2, s = e.searching), "resultCount" in e && n(16, l = e.resultCount), "activeIndex" in e && n(3, f = e.activeIndex), "showReplace" in e && n(0, h = e.showReplace), "readOnly" in e && n(4, p = e.readOnly), "onChange" in e && n(17, g = e.onChange), "onPrevious" in e && n(5, b = e.onPrevious), "onNext" in e && n(6, x = e.onNext), "onReplace" in e && n(18, j = e.onReplace), "onReplaceAll" in e && n(19, C = e.onReplaceAll), "onClose" in e && n(7, _ = e.onClose);
    }, e.$$.update = function() {
        65536 & e.$$.dirty && n(10, r = l >= cs ? "".concat(999, "+") : String(l)), 131072 & e.$$.dirty && n(20, o = Vy(g, 300)), 1048832 & e.$$.dirty && o(O), 2 & e.$$.dirty && a && "" !== O && g(O);
    }, [
        h,
        a,
        s,
        f,
        p,
        b,
        x,
        _,
        O,
        E,
        r,
        A,
        function(e) {
            e.preventDefault(), O !== M ? (M = O, o.cancel(), g(O)) : x();
        },
        function(e) {
            e.stopPropagation();
            var t = PO(e);
            "Enter" === t && (e.preventDefault(), x()), "Shift+Enter" === t && (e.preventDefault(), b()), "Ctrl+Enter" === t && (e.preventDefault(), h ? P() : x()), "Ctrl+H" === t && (e.preventDefault(), A()), "Escape" === t && (e.preventDefault(), _());
        },
        P,
        function() {
            p || C(O, E);
        },
        l,
        g,
        j,
        C,
        o,
        function() {
            O = this.value, n(8, O);
        },
        function() {
            return x();
        },
        function() {
            return b();
        },
        function() {
            return _();
        },
        function() {
            E = this.value, n(9, E);
        }
    ];
}
var _B = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, $B, SB, Zo, {
            show: 1,
            searching: 2,
            resultCount: 16,
            activeIndex: 3,
            showReplace: 0,
            readOnly: 4,
            onChange: 17,
            onPrevious: 5,
            onNext: 6,
            onReplace: 18,
            onReplaceAll: 19,
            onClose: 7
        }, yB), n;
    }
    return Ao(t, Ia), Do(t);
}(), OB = Number.isNaN || function(e) {
    return "number" == typeof e && e != e;
};
function MB(e, t) {
    if (e.length !== t.length) return !1;
    for(var n = 0; n < e.length; n++)if (r = e[n], o = t[n], !(r === o || OB(r) && OB(o))) return !1;
    var r, o;
    return !0;
}
function EB(e, t) {
    void 0 === t && (t = MB);
    var n = null;
    function r() {
        for(var r = [], o = 0; o < arguments.length; o++)r[o] = arguments[o];
        if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
        var i = e.apply(this, r);
        return n = {
            lastResult: i,
            lastArgs: r,
            lastThis: this
        }, i;
    }
    return r.clear = function() {
        n = null;
    }, r;
}
var AB = Symbol("path");
function PB(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0, r = {};
    Array.isArray(e) && function(e, t, n) {
        if (e.length < t) e.forEach(n);
        else for(var r = t > 1 ? (e.length - 1) / (t - 1) : e.length, o = 0; o < t; o++){
            var i = Math.floor(o * r);
            n(e[i], i, e);
        }
    }(e, n, function(e) {
        Gl(e) ? TB(e, r, t) : r[AB] = !0;
    });
    var o = [];
    return AB in r && o.push([]), RB(r, [], o, t), o;
}
function TB(e, t, n) {
    for(var r in e){
        var o = e[r], i = t[r] || (t[r] = {});
        Gl(o) && n ? TB(o, i, n) : void 0 === i[AB] && (i[AB] = !0);
    }
}
function RB(e, t, n, r) {
    for(var o in e){
        var i = t.concat(o), a = e[o];
        a && !0 === a[AB] && n.push(i), Rs(a) && r && RB(a, i, n, r);
    }
}
function NB(e, t, n, r, o) {
    for(var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 80, a = Ts(n) ? n.length : 0, s = function(e, t) {
        var n = Object.values(e);
        if (_x(n)) return t;
        var r = function(e, t) {
            return e + t;
        }, o = n.reduce(r);
        return o / n.length;
    }(r, o), c = e - i, l = t + 2 * i, u = function(e) {
        return r[e] || o;
    }, f = 0, d = 0; d < c && f < a;)d += u(f), f++;
    f > 0 && (d -= u(--f));
    for(var h = f, v = 0; v < l && h < a;)v += u(h), h++;
    for(var p = 0, m = h; m < a; m++)p += u(m);
    return {
        startIndex: f,
        endIndex: h,
        startHeight: d,
        endHeight: p,
        averageItemHeight: s,
        visibleHeight: v,
        visibleItems: Ts(n) ? n.slice(f, h) : []
    };
}
function IB(e, t, n, r) {
    for(var o = DB(e, t).rowIndex, i = 0, a = 0; a < o; a++)i += n[a] || r;
    return i;
}
function DB(e, t) {
    var n, r = Co(n = e) || Fo(n) || Lo(n) || So(), o = r[0], i = r.slice(1), a = parseInt(o, 10);
    return {
        rowIndex: isNaN(a) ? -1 : a,
        columnIndex: t.findIndex(function(e) {
            return AE(i, e);
        })
    };
}
function zB(e, t) {
    var n = e.rowIndex, r = e.columnIndex;
    return [
        String(n)
    ].concat(Bo(t[r]));
}
function qB(e, t) {
    var n = jo(Lj(e, function(e) {
        return Jl(e.path[0]);
    }), 2), r = n[0], o = n[1], i = dk(Aw(r, LB), function(e) {
        var n = {
            row: [],
            columns: {}
        };
        return e.forEach(function(e) {
            var r = function(e, t) {
                var n = DB(e.path, t);
                if (-1 !== n.columnIndex) return n.columnIndex;
                return -1;
            }(e, t);
            -1 !== r ? (void 0 === n.columns[r] && (n.columns[r] = []), n.columns[r].push(e)) : n.row.push(e);
        }), n;
    });
    return {
        root: o,
        rows: i
    };
}
function BB(e, t) {
    if (t && 0 !== t.length) return 1 === t.length ? t[0] : {
        path: e,
        message: "Multiple validation issues: " + t.map(function(e) {
            return JO(e.path) + " " + e.message;
        }).join(", "),
        severity: Za.warning
    };
}
function LB(e) {
    return parseInt(e.path[0], 10);
}
function FB(e, t, n) {
    return t.some(function(t) {
        return function(e, t, n) {
            if (!e) return !1;
            if ("replace" === t.op) {
                var r = DB(Xs(t.path), n), o = r.rowIndex, i = r.columnIndex, a = n.findIndex(function(t) {
                    return Ox(t, e.path);
                });
                if (-1 !== o && -1 !== i && i !== a) return !1;
            }
            return !0;
        }(e.sortedColumn, t, n);
    }) ? Ro(Ro({}, e), {}, {
        sortedColumn: null
    }) : e;
}
var VB = Da("jsoneditor:actions");
function HB(e) {
    return WB.apply(this, arguments);
}
function WB() {
    return WB = ko(wo().mark(function e(t) {
        var n, r, o, i, a, s, c, l, u, f;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    if (n = t.json, r = t.documentState, o = t.indentation, i = t.readOnly, a = t.parser, s = t.onPatch, !i && void 0 !== n && r.selection && BE(r.selection)) {
                        e.next = 3;
                        break;
                    }
                    return e.abrupt("return");
                case 3:
                    if (null != (c = zE(n, r.selection, o, a))) {
                        e.next = 6;
                        break;
                    }
                    return e.abrupt("return");
                case 6:
                    return VB("cut", {
                        selection: r.selection,
                        clipboard: c,
                        indentation: o
                    }), e.next = 9, nB(c);
                case 9:
                    l = dA(n, r.selection), u = l.operations, f = l.newSelection, s(u, function(e, t) {
                        return {
                            state: Ro(Ro({}, t), {}, {
                                selection: f
                            })
                        };
                    });
                case 11:
                case "end":
                    return e.stop();
            }
        }, e);
    })), WB.apply(this, arguments);
}
function UB(e) {
    return JB.apply(this, arguments);
}
function JB() {
    return JB = ko(wo().mark(function e(t) {
        var n, r, o, i, a;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    if (n = t.json, r = t.documentState, o = t.indentation, i = t.parser, null != (a = zE(n, r.selection, o, i))) {
                        e.next = 4;
                        break;
                    }
                    return e.abrupt("return");
                case 4:
                    return VB("copy", {
                        clipboard: a,
                        indentation: o
                    }), e.next = 7, nB(a);
                case 7:
                case "end":
                    return e.stop();
            }
        }, e);
    })), JB.apply(this, arguments);
}
function KB(e) {
    var t = e.clipboardText, n = e.json, r = e.selection, o = e.readOnly, i = e.parser, a = e.onPatch, s = e.onChangeText, c = e.openRepairModal;
    if (!o) try {
        l(t);
    } catch (e) {
        c(t, function(e) {
            VB("repaired pasted text: ", e), l(e);
        });
    }
    function l(e) {
        if (void 0 !== n) {
            var o = r || RE([], !1), c = cA(n, o, e, i);
            VB("paste", {
                pastedText: e,
                operations: c,
                selectionNonNull: o
            }), a(c, function(e, t) {
                var r = t;
                return c.filter(function(e) {
                    return (Ns(e) || Ds(e)) && Ql(e.value);
                }).forEach(function(t) {
                    var o = dc(n, t.path);
                    r = lE(e, r, o);
                }), {
                    state: r
                };
            });
        } else VB("paste text", {
            pastedText: e
        }), s(t, function(e, t) {
            if (e) return {
                state: lE(e, t, [])
            };
        });
    }
}
function GB(e) {
    var t = e.json, n = e.text, r = e.documentState, o = e.keepSelection, i = e.readOnly, a = e.onChange, s = e.onPatch;
    if (!i && r.selection) {
        var c = void 0 !== t && (vE(r.selection) || pE(r.selection)) ? DE(r.selection.path, r.selection.path) : r.selection;
        if (_x(JE(r.selection))) VB("remove root", {
            selection: r.selection
        }), a && a({
            text: "",
            json: void 0
        }, void 0 !== t ? {
            text: void 0,
            json: t
        } : {
            text: n || "",
            json: t
        }, {
            contentErrors: null,
            patchResult: null
        });
        else if (void 0 !== t) {
            var l = dA(t, c), u = l.operations, f = l.newSelection;
            VB("remove", {
                operations: u,
                selection: r.selection,
                newSelection: f
            }), s(u, function(e, t) {
                return {
                    state: Ro(Ro({}, t), {}, {
                        selection: o ? r.selection : f
                    })
                };
            });
        }
    }
}
function QB(e) {
    var t = e.json, n = e.documentState, r = e.columns, o = e.readOnly, i = e.onPatch;
    if (!o && void 0 !== t && n.selection && BE(n.selection)) {
        var a = DB(JE(n.selection), r), s = a.rowIndex, c = a.columnIndex;
        VB("duplicate row", {
            rowIndex: s
        });
        var l = [
            String(s)
        ];
        i(sA(t, [
            l
        ]), function(e, n) {
            var o = RE(zB({
                rowIndex: s < t.length ? s + 1 : s,
                columnIndex: c
            }, r), !1);
            return {
                state: Ro(Ro({}, n), {}, {
                    selection: o
                })
            };
        });
    }
}
function YB(e) {
    var t = e.json, n = e.documentState, r = e.columns, o = e.readOnly, i = e.onPatch;
    if (!o && void 0 !== t && n.selection && BE(n.selection)) {
        var a = DB(JE(n.selection), r).rowIndex;
        VB("insert before row", {
            rowIndex: a
        }), i(oA(t, [
            String(a)
        ], [
            {
                key: "",
                value: Rs(t[0]) ? {} : ""
            }
        ]));
    }
}
function XB(e) {
    var t = e.json, n = e.documentState, r = e.columns, o = e.readOnly, i = e.onPatch;
    if (!o && void 0 !== t && n.selection && BE(n.selection)) {
        var a = DB(JE(n.selection), r), s = a.rowIndex, c = a.columnIndex;
        VB("insert after row", {
            rowIndex: s
        });
        var l = s + 1, u = [
            String(l)
        ], f = [
            {
                key: "",
                value: Rs(t[0]) ? {} : ""
            }
        ];
        i(l < t.length ? oA(t, u, f) : iA(t, [], f), function(e, t) {
            var n = RE(zB({
                rowIndex: l,
                columnIndex: c
            }, r), !1);
            return {
                state: Ro(Ro({}, t), {}, {
                    selection: n
                })
            };
        });
    }
}
function ZB(e) {
    var t = e.json, n = e.documentState, r = e.columns, o = e.readOnly, i = e.onPatch;
    if (!o && void 0 !== t && n.selection && BE(n.selection)) {
        var a = DB(JE(n.selection), r), s = a.rowIndex, c = a.columnIndex;
        VB("remove row", {
            rowIndex: s
        }), i(lA([
            [
                String(s)
            ]
        ]), function(e, t) {
            var n = s < e.length ? s : s > 0 ? s - 1 : void 0, o = void 0 !== n ? RE(zB({
                rowIndex: n,
                columnIndex: c
            }, r), !1) : null;
            return VB("remove row new selection", {
                rowIndex: s,
                newRowIndex: n,
                newSelection: o
            }), {
                state: Ro(Ro({}, t), {}, {
                    selection: o
                })
            };
        });
    }
}
function eL(e) {
    var t = e.insertType, n = e.selectInside, r = e.refJsonEditor, o = e.json, i = e.selection, a = e.readOnly, s = e.parser, c = e.onPatch, l = e.onReplaceJson;
    if (!a) {
        var u = function(e, t, n) {
            if ("object" === n) return {};
            if ("array" === n) return [];
            if ("structure" === n && void 0 !== e) {
                var r = Ws(e, t ? xE(t) : []);
                if (Array.isArray(r) && !_x(r)) {
                    var o = cw(r);
                    return Ql(o) ? kg(o, function(e) {
                        return Array.isArray(e) ? [] : Gl(e) ? void 0 : "";
                    }) : "";
                }
            }
            return "";
        }(o, i, t);
        if (void 0 !== o) {
            var f = s.stringify(u), d = cA(o, i, f, s);
            VB("onInsert", {
                insertType: t,
                operations: d,
                newValue: u,
                data: f
            });
            var h = vb(d.filter(function(e) {
                return "add" === e.op || "replace" === e.op;
            }));
            c(d, function(e, t) {
                if (h) {
                    var r = dc(e, h.path);
                    if (Ql(u)) return {
                        state: Ro(Ro({}, HM(e, t, r, fE)), {}, {
                            selection: n ? NE(r) : t.selection
                        })
                    };
                    if ("" === u) {
                        var o = _x(r) ? null : Ws(e, Qw(r));
                        return {
                            state: VM(e, Ro(Ro({}, t), {}, {
                                selection: Gl(o) ? TE(r, !0) : RE(r, !0)
                            }), r)
                        };
                    }
                }
            }), VB("after patch"), h && "" === u && iL(function() {
                return jO(r, "", !0, aL);
            });
        } else {
            VB("onInsert", {
                insertType: t,
                newValue: u
            });
            var v = [];
            l(u, function(e, t) {
                return {
                    state: Ro(Ro({}, lE(e, t, v)), {}, {
                        selection: Ql(u) ? NE(v) : RE(v, !0)
                    })
                };
            });
        }
    }
}
function tL(e) {
    return nL.apply(this, arguments);
}
function nL() {
    return nL = ko(wo().mark(function e(t) {
        var n, r, o, i, a, s, c, l, u, f, d, h;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    if (n = t.char, r = t.selectInside, o = t.refJsonEditor, i = t.json, a = t.selection, s = t.readOnly, c = t.parser, l = t.onPatch, u = t.onReplaceJson, f = t.onSelect, !s) {
                        e.next = 3;
                        break;
                    }
                    return e.abrupt("return");
                case 3:
                    if (!vE(a)) {
                        e.next = 8;
                        break;
                    }
                    return d = !a.edit, f(Ro(Ro({}, a), {}, {
                        edit: !0
                    })), iL(function() {
                        return jO(o, n, d, aL);
                    }), e.abrupt("return");
                case 8:
                    if ("{" !== n) {
                        e.next = 12;
                        break;
                    }
                    eL({
                        insertType: "object",
                        selectInside: r,
                        refJsonEditor: o,
                        json: i,
                        selection: a,
                        readOnly: s,
                        parser: c,
                        onPatch: l,
                        onReplaceJson: u
                    }), e.next = 23;
                    break;
                case 12:
                    if ("[" !== n) {
                        e.next = 16;
                        break;
                    }
                    eL({
                        insertType: "array",
                        selectInside: r,
                        refJsonEditor: o,
                        json: i,
                        selection: a,
                        readOnly: s,
                        parser: c,
                        onPatch: l,
                        onReplaceJson: u
                    }), e.next = 23;
                    break;
                case 16:
                    if (!pE(a) || void 0 === i) {
                        e.next = 20;
                        break;
                    }
                    Ql(Ws(i, a.path)) || (h = !a.edit, f(Ro(Ro({}, a), {}, {
                        edit: !0
                    })), iL(function() {
                        return jO(o, n, h, aL);
                    })), e.next = 23;
                    break;
                case 20:
                    return VB("onInsertValueWithCharacter", {
                        char: n
                    }), e.next = 23, rL({
                        char: n,
                        refJsonEditor: o,
                        json: i,
                        selection: a,
                        readOnly: s,
                        parser: c,
                        onPatch: l,
                        onReplaceJson: u
                    });
                case 23:
                case "end":
                    return e.stop();
            }
        }, e);
    })), nL.apply(this, arguments);
}
function rL(e) {
    return oL.apply(this, arguments);
}
function oL() {
    return oL = ko(wo().mark(function e(t) {
        var n, r, o, i, a, s, c, l, u;
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    if (n = t.char, r = t.refJsonEditor, o = t.json, i = t.selection, a = t.readOnly, s = t.parser, c = t.onPatch, l = t.onReplaceJson, !a) {
                        e.next = 3;
                        break;
                    }
                    return e.abrupt("return");
                case 3:
                    eL({
                        insertType: "value",
                        selectInside: !1,
                        refJsonEditor: r,
                        json: o,
                        selection: i,
                        readOnly: a,
                        parser: s,
                        onPatch: c,
                        onReplaceJson: l
                    }), u = !qE(i), iL(function() {
                        return jO(r, n, u, aL);
                    });
                case 6:
                case "end":
                    return e.stop();
            }
        }, e);
    })), oL.apply(this, arguments);
}
function iL(e) {
    setTimeout(function() {
        return setTimeout(e);
    });
}
function aL(e) {
    null == e || e.refresh();
}
function sL(e) {
    mi(e, "svelte-l2z0i3", '.jse-json-preview.svelte-l2z0i3{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;padding:2px;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}');
}
function cL(e) {
    var t, n;
    return {
        c: function() {
            t = ji("div"), n = Ci(e[0]), Ai(t, "class", "jse-json-preview svelte-l2z0i3");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            1 & jo(t, 1)[0] && Ni(n, e[0]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function lL(e, t, n) {
    var r, o, i = t.text, a = t.json, s = t.indentation, c = t.parser;
    return e.$$set = function(e) {
        "text" in e && n(1, i = e.text), "json" in e && n(2, a = e.json), "indentation" in e && n(3, s = e.indentation), "parser" in e && n(4, c = e.parser);
    }, e.$$.update = function() {
        6 & e.$$.dirty && n(5, r = void 0 !== a ? {
            json: a
        } : {
            text: i || ""
        }), 56 & e.$$.dirty && n(0, o = tM(Y_(r, s, c), fs));
    }, [
        o,
        i,
        a,
        s,
        c,
        r
    ];
}
var uL = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, lL, cL, Xo, {
            text: 1,
            json: 2,
            indentation: 3,
            parser: 4
        }, sL), n;
    }
    return Ao(t, Ia), Do(t);
}(), fL = vi.window;
function dL(e) {
    mi(e, "svelte-vx4hzc", '.jse-tree-mode.svelte-vx4hzc.svelte-vx4hzc{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-tree-mode.svelte-vx4hzc .jse-hidden-input-label .jse-hidden-input.svelte-vx4hzc{position:fixed;top:-10px;left:-10px;width:1px;height:1px;padding:0;border:0;outline:none}.jse-tree-mode.svelte-vx4hzc .jse-search-box-container.svelte-vx4hzc{position:relative;height:0;top:var(--jse-padding, 10px);margin-right:calc(var(--jse-padding, 10px) + 20px);margin-left:var(--jse-padding, 10px);text-align:right;z-index:3}.jse-tree-mode.no-main-menu.svelte-vx4hzc.svelte-vx4hzc{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-vx4hzc .jse-contents.svelte-vx4hzc{border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);flex:1;overflow:auto;position:relative;padding:2px;display:flex;flex-direction:column}.jse-tree-mode.svelte-vx4hzc .jse-contents.svelte-vx4hzc:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-vx4hzc .jse-contents .jse-loading-space.svelte-vx4hzc{flex:1}.jse-tree-mode.svelte-vx4hzc .jse-contents .jse-loading.svelte-vx4hzc{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function hL(e) {
    var t, n, r;
    function o(t) {
        e[79](t);
    }
    var i = {
        json: e[11],
        selection: e[12].selection,
        readOnly: e[0],
        historyState: e[23],
        onExpandAll: e[41],
        onCollapseAll: e[42],
        onUndo: e[37],
        onRedo: e[38],
        onSort: e[39],
        onTransform: e[40],
        onContextMenu: e[46],
        onCopy: e[34],
        onRenderMenu: e[7]
    };
    return void 0 !== e[20] && (i.showSearch = e[20]), t = new Aq({
        props: i
    }), na.push(function() {
        return Aa(t, "showSearch", o);
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, n) {
            Ta(t, e, n), r = !0;
        },
        p: function(e, r) {
            var o = {};
            2048 & r[0] && (o.json = e[11]), 4096 & r[0] && (o.selection = e[12].selection), 1 & r[0] && (o.readOnly = e[0]), 8388608 & r[0] && (o.historyState = e[23]), 128 & r[0] && (o.onRenderMenu = e[7]), !n && 1048576 & r[0] && (n = !0, o.showSearch = e[20], ua(function() {
                return n = !1;
            })), t.$set(o);
        },
        i: function(e) {
            r || (xa(t.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), r = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function vL(e) {
    var t, n;
    return t = new gB({
        props: {
            json: e[11],
            selection: e[12].selection,
            onSelect: e[50],
            onError: e[6],
            pathParser: e[4]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2048 & n[0] && (r.json = e[11]), 4096 & n[0] && (r.selection = e[12].selection), 64 & n[0] && (r.onError = e[6]), 16 & n[0] && (r.pathParser = e[4]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function pL(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).innerHTML = '<div class="jse-loading-space svelte-vx4hzc"></div> <div class="jse-loading svelte-vx4hzc">loading...</div>', Ai(t, "class", "jse-contents svelte-vx4hzc");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function mL(e) {
    var t, n, r, o, i, a, s, c, l, u = [
        yL,
        gL
    ], f = [];
    function d(e, t) {
        return void 0 === e[11] ? 0 : 1;
    }
    return o = d(e), i = f[o] = u[o](e), {
        c: function() {
            t = ji("label"), n = ji("input"), r = $i(), i.c(), a = _i(), Ai(n, "type", "text"), n.readOnly = !0, Ai(n, "tabindex", "-1"), Ai(n, "class", "jse-hidden-input svelte-vx4hzc"), Ai(t, "class", "jse-hidden-input-label");
        },
        m: function(i, u) {
            wi(i, t, u), pi(t, n), e[80](n), wi(i, r, u), f[o].m(i, u), wi(i, a, u), s = !0, c || (l = Oi(n, "paste", e[35]), c = !0);
        },
        p: function(e, t) {
            var n = o;
            (o = d(e)) === n ? f[o].p(e, t) : (ba(), ka(f[n], 1, 1, function() {
                f[n] = null;
            }), wa(), (i = f[o]) ? i.p(e, t) : (i = f[o] = u[o](e)).c(), xa(i, 1), i.m(a.parentNode, a));
        },
        i: function(e) {
            s || (xa(i), s = !0);
        },
        o: function(e) {
            ka(i), s = !1;
        },
        d: function(n) {
            n && (xi(t), xi(r), xi(a)), e[80](null), f[o].d(n), c = !1, l();
        }
    };
}
function gL(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h;
    i = new _B({
        props: {
            show: e[20],
            resultCount: (null === (t = e[18]) || void 0 === t || null === (t = t.items) || void 0 === t ? void 0 : t.length) || 0,
            activeIndex: (null === (n = e[18]) || void 0 === n ? void 0 : n.activeIndex) || 0,
            showReplace: e[21],
            searching: e[22],
            readOnly: e[0],
            onChange: e[27],
            onNext: e[28],
            onPrevious: e[29],
            onReplace: e[30],
            onReplaceAll: e[31],
            onClose: e[32]
        }
    }), c = new Sq({
        props: {
            value: e[11],
            path: [],
            expandedMap: e[12].expandedMap,
            enforceStringMap: e[12].enforceStringMap,
            visibleSectionsMap: e[12].visibleSectionsMap,
            validationErrorsMap: e[25],
            searchResultItemsMap: null === (r = e[18]) || void 0 === r ? void 0 : r.itemsMap,
            selection: e[12].selection,
            context: e[14],
            onDragSelectionStart: Mf
        }
    });
    var v = e[19] && bL(e), p = e[24] && wL(e);
    return d = new JN({
        props: {
            validationErrors: e[13],
            selectError: e[33]
        }
    }), {
        c: function() {
            o = ji("div"), Pa(i.$$.fragment), a = $i(), s = ji("div"), Pa(c.$$.fragment), l = $i(), v && v.c(), u = $i(), p && p.c(), f = $i(), Pa(d.$$.fragment), Ai(o, "class", "jse-search-box-container svelte-vx4hzc"), Ai(s, "class", "jse-contents svelte-vx4hzc"), Ai(s, "data-jsoneditor-scrollable-contents", !0);
        },
        m: function(t, n) {
            wi(t, o, n), Ta(i, o, null), wi(t, a, n), wi(t, s, n), Ta(c, s, null), e[84](s), wi(t, l, n), v && v.m(t, n), wi(t, u, n), p && p.m(t, n), wi(t, f, n), Ta(d, t, n), h = !0;
        },
        p: function(e, t) {
            var n, r, o, a = {};
            1048576 & t[0] && (a.show = e[20]), 262144 & t[0] && (a.resultCount = (null === (n = e[18]) || void 0 === n || null === (n = n.items) || void 0 === n ? void 0 : n.length) || 0), 262144 & t[0] && (a.activeIndex = (null === (r = e[18]) || void 0 === r ? void 0 : r.activeIndex) || 0), 2097152 & t[0] && (a.showReplace = e[21]), 4194304 & t[0] && (a.searching = e[22]), 1 & t[0] && (a.readOnly = e[0]), i.$set(a);
            var s = {};
            2048 & t[0] && (s.value = e[11]), 4096 & t[0] && (s.expandedMap = e[12].expandedMap), 4096 & t[0] && (s.enforceStringMap = e[12].enforceStringMap), 4096 & t[0] && (s.visibleSectionsMap = e[12].visibleSectionsMap), 33554432 & t[0] && (s.validationErrorsMap = e[25]), 262144 & t[0] && (s.searchResultItemsMap = null === (o = e[18]) || void 0 === o ? void 0 : o.itemsMap), 4096 & t[0] && (s.selection = e[12].selection), 16384 & t[0] && (s.context = e[14]), c.$set(s), e[19] ? v ? (v.p(e, t), 524288 & t[0] && xa(v, 1)) : ((v = bL(e)).c(), xa(v, 1), v.m(u.parentNode, u)) : v && (ba(), ka(v, 1, 1, function() {
                v = null;
            }), wa()), e[24] ? p ? (p.p(e, t), 16777216 & t[0] && xa(p, 1)) : ((p = wL(e)).c(), xa(p, 1), p.m(f.parentNode, f)) : p && (ba(), ka(p, 1, 1, function() {
                p = null;
            }), wa());
            var l = {};
            8192 & t[0] && (l.validationErrors = e[13]), d.$set(l);
        },
        i: function(e) {
            h || (xa(i.$$.fragment, e), xa(c.$$.fragment, e), xa(v), xa(p), xa(d.$$.fragment, e), h = !0);
        },
        o: function(e) {
            ka(i.$$.fragment, e), ka(c.$$.fragment, e), ka(v), ka(p), ka(d.$$.fragment, e), h = !1;
        },
        d: function(t) {
            t && (xi(o), xi(a), xi(s), xi(l), xi(u), xi(f)), Ra(i), Ra(c), e[84](null), v && v.d(t), p && p.d(t), Ra(d, t);
        }
    };
}
function yL(e) {
    var t, n, r, o, i = [
        kL,
        xL
    ], a = [];
    function s(e, t) {
        return "" === e[17] || void 0 === e[17] ? 0 : 1;
    }
    return t = s(e), n = a[t] = i[t](e), {
        c: function() {
            n.c(), r = _i();
        },
        m: function(e, n) {
            a[t].m(e, n), wi(e, r, n), o = !0;
        },
        p: function(e, o) {
            var c = t;
            (t = s(e)) === c ? a[t].p(e, o) : (ba(), ka(a[c], 1, 1, function() {
                a[c] = null;
            }), wa(), (n = a[t]) ? n.p(e, o) : (n = a[t] = i[t](e)).c(), xa(n, 1), n.m(r.parentNode, r));
        },
        i: function(e) {
            o || (xa(n), o = !0);
        },
        o: function(e) {
            ka(n), o = !1;
        },
        d: function(e) {
            e && xi(r), a[t].d(e);
        }
    };
}
function bL(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "info",
            message: "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text"),
            actions: [
                {
                    icon: uP,
                    text: "Paste as JSON instead",
                    title: "Replace the value with the pasted JSON",
                    onMouseDown: e[47]
                },
                {
                    text: "Leave as is",
                    title: "Keep the JSON embedded in the value",
                    onClick: e[48]
                }
            ]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            524288 & n[0] && (r.message = "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text")), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function wL(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "success",
            message: "The loaded JSON document was invalid but is successfully repaired.",
            actions: e[0] ? [] : [
                {
                    icon: PP,
                    text: "Ok",
                    title: "Accept the repaired document",
                    onClick: e[8]
                },
                {
                    icon: lP,
                    text: "Repair manually instead",
                    title: "Leave the document unchanged and repair it manually instead",
                    onClick: e[49]
                }
            ],
            onClose: e[9]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.actions = e[0] ? [] : [
                {
                    icon: PP,
                    text: "Ok",
                    title: "Accept the repaired document",
                    onClick: e[8]
                },
                {
                    icon: lP,
                    text: "Repair manually instead",
                    title: "Leave the document unchanged and repair it manually instead",
                    onClick: e[49]
                }
            ]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function xL(e) {
    var t, n, r, o;
    return t = new IN({
        props: {
            type: "error",
            message: "The loaded JSON document is invalid and could not be repaired automatically.",
            actions: e[0] ? [] : [
                {
                    icon: lP,
                    text: "Repair manually",
                    title: 'Open the document in "code" mode and repair it manually',
                    onClick: e[49]
                }
            ]
        }
    }), r = new uL({
        props: {
            text: e[17],
            json: e[11],
            indentation: e[5],
            parser: e[3]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment), n = $i(), Pa(r.$$.fragment);
        },
        m: function(e, i) {
            Ta(t, e, i), wi(e, n, i), Ta(r, e, i), o = !0;
        },
        p: function(e, n) {
            var o = {};
            1 & n[0] && (o.actions = e[0] ? [] : [
                {
                    icon: lP,
                    text: "Repair manually",
                    title: 'Open the document in "code" mode and repair it manually',
                    onClick: e[49]
                }
            ]), t.$set(o);
            var i = {};
            131072 & n[0] && (i.text = e[17]), 2048 & n[0] && (i.json = e[11]), 32 & n[0] && (i.indentation = e[5]), 8 & n[0] && (i.parser = e[3]), r.$set(i);
        },
        i: function(e) {
            o || (xa(t.$$.fragment, e), xa(r.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), ka(r.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(n), Ra(t, e), Ra(r, e);
        }
    };
}
function kL(e) {
    var t, n;
    return t = new Iq({
        props: {
            readOnly: e[0],
            onCreateObject: e[81],
            onCreateArray: e[82],
            onClick: e[83]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.readOnly = e[0]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function jL(e) {
    var t, n, r, o, i, a, s, c, l = e[1] && hL(e), u = e[2] && vL(e), f = [
        mL,
        pL
    ], d = [];
    return o = function(e, t) {
        return e[26] ? 1 : 0;
    }(e), i = d[o] = f[o](e), {
        c: function() {
            t = ji("div"), l && l.c(), n = $i(), u && u.c(), r = $i(), i.c(), Ai(t, "role", "tree"), Ai(t, "tabindex", "-1"), Ai(t, "class", "jse-tree-mode svelte-vx4hzc"), qi(t, "no-main-menu", !e[1]);
        },
        m: function(i, f) {
            wi(i, t, f), l && l.m(t, null), pi(t, n), u && u.m(t, null), pi(t, r), d[o].m(t, null), e[85](t), a = !0, s || (c = [
                Oi(fL, "mousedown", e[51]),
                Oi(t, "keydown", e[43]),
                Oi(t, "mousedown", e[44]),
                Oi(t, "contextmenu", e[45])
            ], s = !0);
        },
        p: function(e, o) {
            e[1] ? l ? (l.p(e, o), 2 & o[0] && xa(l, 1)) : ((l = hL(e)).c(), xa(l, 1), l.m(t, n)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()), e[2] ? u ? (u.p(e, o), 4 & o[0] && xa(u, 1)) : ((u = vL(e)).c(), xa(u, 1), u.m(t, r)) : u && (ba(), ka(u, 1, 1, function() {
                u = null;
            }), wa()), i.p(e, o), (!a || 2 & o[0]) && qi(t, "no-main-menu", !e[1]);
        },
        i: function(e) {
            a || (xa(l), xa(u), xa(i), a = !0);
        },
        o: function(e) {
            ka(l), ka(u), ka(i), a = !1;
        },
        d: function(n) {
            n && xi(t), l && l.d(), u && u.d(), d[o].d(), e[85](null), s = !1, Qo(c);
        }
    };
}
function SL(e, t, n) {
    var r, o = Da("jsoneditor:TreeMode"), i = "undefined" == typeof window;
    o("isSSR:", i);
    var a, s, c, l, u, f = Zi("simple-modal").open, d = A$(), h = A$(), v = Zi("absolute-popup"), p = v.openAbsolutePopup, m = v.closeAbsolutePopup, g = !1, y = bN(), b = t.readOnly, w = t.externalContent, x = t.externalSelection, k = t.mainMenuBar, j = t.navigationBar, S = t.escapeControlCharacters, C = t.escapeUnicodeCharacters, $ = t.parser, _ = t.parseMemoizeOne, O = t.validator, M = t.validationParser, E = t.pathParser, A = t.indentation, P = t.onError, T = t.onChange, R = t.onChangeMode, N = t.onSelect, I = t.onRenderValue, D = t.onRenderMenu, z = t.onRenderContextMenu, q = t.onClassName, B = t.onFocus, L = t.onBlur, F = t.onSortModal, V = t.onTransformModal, H = t.onJSONEditorModal, W = !1;
    ON({
        onMount: Gi,
        onDestroy: Qi,
        getWindow: function() {
            return SO(c);
        },
        hasFocus: function() {
            return W && document.hasFocus() || CO(c);
        },
        onFocus: function() {
            g = !0, B && B();
        },
        onBlur: function() {
            g = !1, L && L();
        }
    });
    var U = void 0;
    function J(e) {
        o("updateSelection", e);
        var t = "function" == typeof e ? e(X.selection) || null : e;
        Ox(t, X.selection) || (n(12, X = Ro(Ro({}, X), {}, {
            selection: t
        })), N(t));
    }
    var K, G, Q, Y = !1, X = BM(), Z = !1, ee = !1, te = !1, ne = "";
    function re(e) {
        return oe.apply(this, arguments);
    }
    function oe() {
        return oe = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return o("search text updated", t), n(78, ne = t), e.next = 4, ca();
                    case 4:
                        return e.next = 6, le();
                    case 6:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), oe.apply(this, arguments);
    }
    function ie() {
        return (ie = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return n(18, K = K ? pA(K) : void 0), e.next = 3, le();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function ae() {
        return (ae = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return n(18, K = K ? mA(K) : void 0), e.next = 3, le();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function se() {
        return (se = ko(wo().mark(function e(t, n) {
            var r, i, a, s, c;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (i = null === (r = K) || void 0 === r ? void 0 : r.activeItem, o("handleReplace", {
                            replacementText: n,
                            activeItem: i
                        }), i && void 0 !== l) {
                            e.next = 4;
                            break;
                        }
                        return e.abrupt("return");
                    case 4:
                        return a = xA(l, X, n, i, $), s = a.operations, c = a.newSelection, ot(s, function(e, t) {
                            return {
                                state: Ro(Ro({}, t), {}, {
                                    selection: c
                                })
                            };
                        }), e.next = 8, ca();
                    case 8:
                        return e.next = 10, le();
                    case 10:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function ce() {
        return ce = ko(wo().mark(function e(t, n) {
            var r, i, a;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return o("handleReplaceAll", {
                            text: t,
                            replacementText: n
                        }), r = kA(l, X, t, n, $), i = r.operations, a = r.newSelection, ot(i, function(e, t) {
                            return {
                                state: Ro(Ro({}, t), {}, {
                                    selection: a
                                })
                            };
                        }), e.next = 5, ca();
                    case 5:
                        return e.next = 7, le();
                    case 7:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), ce.apply(this, arguments);
    }
    function le() {
        return ue.apply(this, arguments);
    }
    function ue() {
        return (ue = ko(wo().mark(function e() {
            var t, r, i;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (r = null === (t = K) || void 0 === t ? void 0 : t.activeItem, o("focusActiveSearchResult", K), !r || void 0 === l) {
                            e.next = 9;
                            break;
                        }
                        return i = r.path, n(12, X = Ro(Ro({}, VM(l, X, i)), {}, {
                            selection: null
                        })), e.next = 7, ca();
                    case 7:
                        return e.next = 9, Ze(i);
                    case 9:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    var fe = kN({
        onChange: function(e) {
            n(23, de = e);
        }
    }), de = fe.getState();
    var he, ve, pe = UC(function(e, t) {
        if ("" === e) return o("clearing search result"), void (void 0 !== K && n(18, K = void 0));
        n(22, te = !0), setTimeout(function() {
            o("searching...", e);
            var r = gA(e, t, cs);
            n(18, K = function(e, t, n) {
                var r = null != n && n.activeItem ? jA(n.activeItem) : void 0, o = t.findIndex(function(e) {
                    return Ox(r, jA(e));
                }), i = -1 !== o ? o : void 0 !== (null == n ? void 0 : n.activeIndex) && (null == n ? void 0 : n.activeIndex) < t.length ? null == n ? void 0 : n.activeIndex : t.length > 0 ? 0 : -1, a = t.map(function(e, t) {
                    return Ro(Ro({}, e), {}, {
                        active: t === i
                    });
                }), s = a[i];
                return {
                    items: a,
                    itemsMap: Aw(a, function(e) {
                        return Zs(e.path);
                    }),
                    activeItem: s,
                    activeIndex: i
                };
            }(0, r, K)), n(22, te = !1);
        });
    }, 300), me = !1, ge = [], ye = EB(CN);
    function be(e, t, r, i) {
        jN(function() {
            var a;
            try {
                a = ye(e, t, r, i);
            } catch (e) {
                a = [
                    {
                        path: [],
                        message: "Failed to validate: " + e.message,
                        severity: Za.warning
                    }
                ];
            }
            Ox(a, ge) || (o("validationErrors changed:", a), n(13, ge = a));
        }, function(e) {
            return o("validationErrors updated in ".concat(e, " ms"));
        });
    }
    function we() {
        return o("validate"), U ? {
            parseError: U,
            isRepairable: !1
        } : (be(l, O, $, M), _x(ge) ? null : {
            validationErrors: ge
        });
    }
    function xe() {
        return l;
    }
    function ke() {
        return X;
    }
    function je(e) {
        K_(e) ? function(e) {
            if (void 0 === e) return;
            var t = !Ox(l, e);
            if (o("update external json", {
                isChanged: t,
                currentlyText: void 0 === l
            }), !t) return;
            var r = {
                json: l,
                text: u
            }, i = X, a = l, s = u, c = me;
            n(11, l = e), Se(l), n(17, u = void 0), n(24, me = !1), U = void 0, Ce(l), $e({
                previousJson: a,
                previousState: i,
                previousText: s,
                previousTextIsRepaired: c
            }), rt(r, null);
        }(e.json) : J_(e) && function(e) {
            if (void 0 === e || K_(w)) return;
            var t = e !== u;
            if (o("update external text", {
                isChanged: t
            }), !t) return;
            var r = {
                json: l,
                text: u
            }, i = l, a = X, s = u, c = me;
            try {
                n(11, l = _(e)), Se(l), n(17, u = e), n(24, me = !1), U = void 0;
            } catch (t) {
                try {
                    n(11, l = _(Hl(e))), Se(l), n(17, u = e), n(24, me = !0), U = void 0, Ce(l);
                } catch (e) {
                    n(11, l = void 0), n(17, u = w.text), n(24, me = !1), U = void 0 !== u && "" !== u ? H_(u, t.message || String(t)) : void 0;
                }
            }
            Ce(l), $e({
                previousJson: i,
                previousState: a,
                previousText: s,
                previousTextIsRepaired: c
            }), rt(r, null);
        }(e.text);
    }
    function Se(e) {
        Y || (Y = !0, n(12, X = HM(e, X, [], function(e) {
            return X_({
                json: e
            }, ms) ? uE : fE;
        }(e))));
    }
    function Ce(e) {
        X.selection && (Ys(e, KE(X.selection)) && Ys(e, JE(X.selection)) || (o("clearing selection: path does not exist anymore", X.selection), n(12, X = Ro(Ro({}, X), {}, {
            selection: $E(e, X)
        }))));
    }
    function $e(e) {
        var t = e.previousJson, n = e.previousState, r = e.previousText, o = e.previousTextIsRepaired;
        void 0 === t && void 0 === r || (void 0 !== l ? void 0 !== t ? fe.add({
            undo: {
                patch: [
                    {
                        op: "replace",
                        path: "",
                        value: t
                    }
                ],
                state: PE(n),
                json: void 0,
                text: r,
                textIsRepaired: o
            },
            redo: {
                patch: [
                    {
                        op: "replace",
                        path: "",
                        value: l
                    }
                ],
                state: PE(X),
                json: void 0,
                text: u,
                textIsRepaired: me
            }
        }) : fe.add({
            undo: {
                patch: void 0,
                json: void 0,
                text: r,
                state: PE(n),
                textIsRepaired: o
            },
            redo: {
                patch: void 0,
                json: l,
                state: PE(X),
                text: u,
                textIsRepaired: me
            }
        }) : void 0 !== t && fe.add({
            undo: {
                patch: void 0,
                json: t,
                state: PE(n),
                text: r,
                textIsRepaired: o
            },
            redo: {
                patch: void 0,
                json: void 0,
                text: u,
                textIsRepaired: me,
                state: PE(X)
            }
        }));
    }
    function _e(e, t) {
        if (o("patch", e, t), void 0 === l) throw new Error("Cannot apply patch: no JSON");
        var r = {
            json: l,
            text: u
        }, i = l, a = X, s = u, c = me, f = hA(l, e), d = JM(l, X, e), h = _E(l, e), v = function(e, t) {
            return t || !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? Ro(Ro({}, e), {}, {
                selection: t
            }) : e;
        }(d.documentState, h, !1);
        o("patch updatedSelection", h);
        var p = "function" == typeof t ? t(d.json, v) : void 0;
        n(11, l = p && void 0 !== p.json ? p.json : d.json);
        var m = p && void 0 !== p.state ? p.state : v;
        n(12, X = m), n(17, u = void 0), n(24, me = !1), n(19, Q = void 0), U = void 0, Ce(l), fe.add({
            undo: {
                patch: f,
                json: void 0,
                text: s,
                state: PE(a),
                textIsRepaired: c
            },
            redo: {
                patch: e,
                json: void 0,
                state: PE(m),
                text: u,
                textIsRepaired: me
            }
        });
        var g = {
            json: l,
            previousJson: i,
            undo: f,
            redo: e
        };
        return rt(r, g), g;
    }
    function Oe() {
        !b && X.selection && J(TE(JE(X.selection), !0));
    }
    function Me() {
        if (!b && X.selection) {
            var e = JE(X.selection), t = Ws(l, e);
            Ql(t) ? function(e, t) {
                o("openJSONEditorModal", {
                    path: e,
                    value: t
                }), W = !0, H({
                    content: {
                        json: t
                    },
                    path: e,
                    onPatch: ve.onPatch,
                    onClose: function() {
                        W = !1, vt();
                    }
                });
            }(e, t) : J(RE(e, !0));
        }
    }
    function Ee() {
        if (!b && pE(X.selection)) {
            var e = JE(X.selection), t = Zs(e), n = Ws(l, e), r = !oE(n, X.enforceStringMap, t, $), i = r ? String(n) : ru(String(n), $);
            o("handleToggleEnforceString", {
                enforceString: r,
                value: n,
                updatedValue: i
            }), ot([
                {
                    op: "replace",
                    path: t,
                    value: i
                }
            ], function(e, n) {
                return {
                    state: UM(n, t, r)
                };
            });
        }
    }
    function Ae() {
        return Pe.apply(this, arguments);
    }
    function Pe() {
        return Pe = ko(wo().mark(function e() {
            var t, n = arguments;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return t = !(n.length > 0 && void 0 !== n[0]) || n[0], e.next = 3, HB({
                            json: l,
                            documentState: X,
                            indentation: t ? A : void 0,
                            readOnly: b,
                            parser: $,
                            onPatch: ot
                        });
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), Pe.apply(this, arguments);
    }
    function Te() {
        return Re.apply(this, arguments);
    }
    function Re() {
        return Re = ko(wo().mark(function e() {
            var t, n = arguments;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (t = !(n.length > 0 && void 0 !== n[0]) || n[0], void 0 !== l) {
                            e.next = 3;
                            break;
                        }
                        return e.abrupt("return");
                    case 3:
                        return e.next = 5, UB({
                            json: l,
                            documentState: X,
                            indentation: t ? A : void 0,
                            parser: $
                        });
                    case 5:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), Re.apply(this, arguments);
    }
    function Ne() {
        f(nI, {}, Ro(Ro({}, gs), {}, {
            styleWindow: {
                width: "450px"
            }
        }), {
            onClose: function() {
                return vt();
            }
        });
    }
    function Ie(e, t) {
        f(UI, {
            text: e,
            onParse: function(e) {
                return L_(e, function(e) {
                    return q_(e, $);
                });
            },
            onRepair: F_,
            onApply: t
        }, Ro(Ro({}, gs), {}, {
            styleWindow: {
                width: "600px",
                height: "500px"
            },
            styleContent: {
                padding: 0,
                height: "100%"
            }
        }), {
            onClose: function() {
                return vt();
            }
        });
    }
    function De() {
        GB({
            json: l,
            text: u,
            documentState: X,
            keepSelection: !1,
            readOnly: b,
            onChange: T,
            onPatch: ot
        });
    }
    function ze() {
        !b && void 0 !== l && X.selection && BE(X.selection) && !_x(JE(X.selection)) && (o("duplicate", {
            selection: X.selection
        }), ot(sA(l, wE(l, X.selection))));
    }
    function qe() {
        if (!b && X.selection && (mE(X.selection) || pE(X.selection)) && !_x(JE(X.selection))) {
            o("extract", {
                selection: X.selection
            });
            var e = function(e, t) {
                if (pE(t)) return [
                    {
                        op: "move",
                        from: Zs(t.path),
                        path: ""
                    }
                ];
                if (!mE(t)) throw new Error("Cannot create extract operations: parent must be an Object or Array");
                var n = Ws(e, Qw(t.focusPath));
                if (Ts(n)) return [
                    {
                        op: "replace",
                        path: "",
                        value: wE(e, t).map(function(e) {
                            var t = Ul(vb(e));
                            return n[t];
                        })
                    }
                ];
                if (Rs(n)) {
                    var r = {};
                    return wE(e, t).forEach(function(e) {
                        var t = String(vb(e));
                        r[t] = n[t];
                    }), [
                        {
                            op: "replace",
                            path: "",
                            value: r
                        }
                    ];
                }
                throw new Error("Cannot extract: unsupported type of selection " + JSON.stringify(t));
            }(l, X.selection);
            ot(e, function(e, t) {
                if (Ql(e)) return {
                    state: lE(e, t, [])
                };
            });
        }
    }
    function Be(e) {
        void 0 !== l && eL({
            insertType: e,
            selectInside: !0,
            refJsonEditor: c,
            json: l,
            selection: X.selection,
            readOnly: b,
            parser: $,
            onPatch: ot,
            onReplaceJson: it
        });
    }
    function Le(e) {
        vE(X.selection) && J(RE(X.selection.path, !1)), X.selection || J($E(l, X)), Be(e);
    }
    function Fe(e) {
        if (!b && X.selection) {
            if (LE(X.selection)) try {
                var t = KE(X.selection), n = Ws(l, t), r = function(e, t, n) {
                    if ("array" === t) {
                        if (Array.isArray(e)) return e;
                        if (Gl(e)) return D_(e);
                        if ("string" == typeof e) try {
                            var r = n.parse(e);
                            if (Array.isArray(r)) return r;
                            if (Gl(r)) return D_(r);
                        } catch (t) {
                            return [
                                e
                            ];
                        }
                        return [
                            e
                        ];
                    }
                    if ("object" === t) {
                        if (Array.isArray(e)) return I_(e);
                        if (Gl(e)) return e;
                        if ("string" == typeof e) try {
                            var o = n.parse(e);
                            if (Gl(o)) return o;
                            if (Array.isArray(o)) return I_(o);
                        } catch (t) {
                            return {
                                value: e
                            };
                        }
                        return {
                            value: e
                        };
                    }
                    if ("value" === t) return Ql(e) ? n.stringify(e) : e;
                    throw new Error("Cannot convert ".concat(eu(e, n), " to ").concat(t));
                }(n, e, $);
                if (r === n) return;
                var i = [
                    {
                        op: "replace",
                        path: Zs(t),
                        value: r
                    }
                ];
                o("handleConvert", {
                    selection: X.selection,
                    path: t,
                    type: e,
                    operations: i
                }), ot(i, function(e, t) {
                    return {
                        state: X.selection ? lE(e, t, JE(X.selection)) : X
                    };
                });
            } catch (e) {
                P(e);
            }
            else P(new Error("Cannot convert current selection to ".concat(e)));
        }
    }
    function Ve() {
        if (X.selection) {
            var e = SE(l, X, !1), t = Qw(JE(X.selection));
            e && !_x(JE(e)) && Ox(t, Qw(JE(e))) ? J(IE(JE(e))) : J(NE(t)), o("insert before", {
                selection: X.selection,
                selectionBefore: e,
                parentPath: t
            }), ca().then(function() {
                return dt();
            });
        }
    }
    function He() {
        if (X.selection) {
            var e = jE(l, X.selection);
            o("insert after", e), J(IE(e)), ca().then(function() {
                return dt();
            });
        }
    }
    function We(e) {
        return Ue.apply(this, arguments);
    }
    function Ue() {
        return (Ue = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, tL({
                            char: t,
                            selectInside: !0,
                            refJsonEditor: c,
                            json: l,
                            selection: X.selection,
                            readOnly: b,
                            parser: $,
                            onPatch: ot,
                            onReplaceJson: it,
                            onSelect: J
                        });
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Je() {
        if (!b && fe.getState().canUndo) {
            var e = fe.undo();
            if (e) {
                var t = {
                    json: l,
                    text: u
                };
                n(11, l = e.undo.patch ? rc(l, e.undo.patch) : e.undo.json), n(12, X = e.undo.state), n(17, u = e.undo.text), n(24, me = e.undo.textIsRepaired), U = void 0, o("undo", {
                    item: e,
                    json: l,
                    documentState: X
                }), rt(t, e.undo.patch && e.redo.patch ? {
                    json: l,
                    previousJson: t.json,
                    redo: e.undo.patch,
                    undo: e.redo.patch
                } : null), vt(), X.selection && Ze(JE(X.selection), !1);
            }
        }
    }
    function Ke() {
        if (!b && fe.getState().canRedo) {
            var e = fe.redo();
            if (e) {
                var t = {
                    json: l,
                    text: u
                };
                n(11, l = e.redo.patch ? rc(l, e.redo.patch) : e.redo.json), n(12, X = e.redo.state), n(17, u = e.redo.text), n(24, me = e.redo.textIsRepaired), U = void 0, o("redo", {
                    item: e,
                    json: l,
                    documentState: X
                }), rt(t, e.undo.patch && e.redo.patch ? {
                    json: l,
                    previousJson: t.json,
                    redo: e.redo.patch,
                    undo: e.undo.patch
                } : null), vt(), X.selection && Ze(JE(X.selection), !1);
            }
        }
    }
    function Ge(e) {
        var t;
        b || void 0 === l || (W = !0, F({
            id: d,
            json: l,
            rootPath: e,
            onSort: (t = ko(wo().mark(function t(n) {
                var r;
                return wo().wrap(function(t) {
                    for(;;)switch(t.prev = t.next){
                        case 0:
                            r = n.operations, o("onSort", e, r), ot(r, function(t, n) {
                                return {
                                    state: Ro(Ro({}, lE(t, n, e)), {}, {
                                        selection: RE(e, !1)
                                    })
                                };
                            });
                        case 3:
                        case "end":
                            return t.stop();
                    }
                }, t);
            })), function(e) {
                return t.apply(this, arguments);
            }),
            onClose: function() {
                W = !1, vt();
            }
        }));
    }
    function Qe() {
        X.selection && Ge(EE(l, X.selection));
    }
    function Ye(e) {
        if (void 0 !== l) {
            var t = e.id, n = e.onTransform, r = e.onClose, i = e.rootPath || [];
            W = !0, V({
                id: t || h,
                json: l,
                rootPath: i,
                onTransform: function(e) {
                    n ? n({
                        operations: e,
                        json: l,
                        transformedJson: rc(l, e)
                    }) : (o("onTransform", i, e), ot(e, function(e, t) {
                        return {
                            state: Ro(Ro({}, lE(e, t, i)), {}, {
                                selection: RE(i, !1)
                            })
                        };
                    }));
                },
                onClose: function() {
                    W = !1, vt(), r && r();
                }
            });
        }
    }
    function Xe() {
        X.selection && Ye({
            rootPath: EE(l, X.selection)
        });
    }
    function Ze(e) {
        return et.apply(this, arguments);
    }
    function et() {
        return et = ko(wo().mark(function e(t) {
            var r, i, s, c, u, f = arguments;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return r = !(f.length > 1 && void 0 !== f[1]) || f[1], n(12, X = VM(l, X, t)), e.next = 4, ca();
                    case 4:
                        if (i = tt(t), o("scrollTo", {
                            path: t,
                            elem: i,
                            refContents: a
                        }), i && a) {
                            e.next = 8;
                            break;
                        }
                        return e.abrupt("return", Promise.resolve());
                    case 8:
                        if (s = a.getBoundingClientRect(), c = i.getBoundingClientRect(), r) {
                            e.next = 13;
                            break;
                        }
                        if (!(c.bottom > s.top && c.top < s.bottom)) {
                            e.next = 13;
                            break;
                        }
                        return e.abrupt("return", Promise.resolve());
                    case 13:
                        return u = -s.height / 4, e.abrupt("return", new Promise(function(e) {
                            y(i, {
                                container: a,
                                offset: u,
                                duration: 300,
                                callback: function() {
                                    return e();
                                }
                            });
                        }));
                    case 15:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), et.apply(this, arguments);
    }
    function tt(e) {
        return a ? a.querySelector('div[data-path="'.concat(OO(e), '"]')) : null;
    }
    function nt(e) {
        var t = tt(e);
        if (t && a) {
            var n = a.getBoundingClientRect(), r = t.getBoundingClientRect(), o = Ql(Ws(l, e)) ? 20 : r.height;
            r.top < n.top + 20 ? y(t, {
                container: a,
                offset: -20,
                duration: 0
            }) : r.top + o > n.bottom - 20 && y(t, {
                container: a,
                offset: -(n.height - o - 20),
                duration: 0
            });
        }
    }
    function rt(e, t) {
        var n;
        if (void 0 !== e.json || void 0 !== (null == e ? void 0 : e.text)) {
            if (void 0 !== u) null === (n = T) || void 0 === n || n({
                text: u,
                json: void 0
            }, e, {
                contentErrors: we(),
                patchResult: t
            });
            else if (void 0 !== l) {
                var r;
                null === (r = T) || void 0 === r || r({
                    text: void 0,
                    json: l
                }, e, {
                    contentErrors: we(),
                    patchResult: t
                });
            }
        }
    }
    function ot(e, t) {
        return b ? {
            json: l,
            previousJson: l,
            undo: [],
            redo: []
        } : (o("handlePatch", e, t), _e(e, t));
    }
    function it(e, t) {
        var r = X, o = l, i = u, a = {
            json: l,
            text: u
        }, s = me, c = HM(l, X, [], uE), f = "function" == typeof t ? t(e, c) : void 0;
        n(11, l = f && void 0 !== f.json ? f.json : e), n(12, X = f && void 0 !== f.state ? f.state : c), n(17, u = void 0), n(24, me = !1), U = void 0, Ce(l), $e({
            previousJson: o,
            previousState: r,
            previousText: i,
            previousTextIsRepaired: s
        });
        rt(a, null);
    }
    function at(e, t) {
        o("handleChangeText");
        var r = X, i = l, a = u, s = {
            json: l,
            text: u
        }, c = me;
        try {
            n(11, l = _(e)), n(12, X = HM(l, X, [], uE)), n(17, u = void 0), n(24, me = !1), U = void 0;
        } catch (t) {
            try {
                n(11, l = _(Hl(e))), n(12, X = HM(l, X, [], uE)), n(17, u = e), n(24, me = !0), U = void 0;
            } catch (r) {
                n(11, l = void 0), n(12, X = BM({
                    json: l,
                    expand: uE
                })), n(17, u = e), n(24, me = !1), U = "" !== u ? H_(u, t.message || String(t)) : void 0;
            }
        }
        if ("function" == typeof t) {
            var f = t(l, X);
            n(11, l = f && f.json ? f.json : l), n(12, X = f && f.state ? f.state : X);
        }
        Ce(l), $e({
            previousJson: i,
            previousState: r,
            previousText: a,
            previousTextIsRepaired: c
        });
        rt(s, null);
    }
    function st(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        o("expand", {
            path: e,
            expanded: t,
            recursive: r
        }), n(12, X = t ? r ? HM(l, X, e, fE) : function(e, t) {
            return Ro(Ro({}, e), {}, {
                expandedMap: Ro(Ro({}, e.expandedMap), {}, zo({}, Zs(t), !0))
            });
        }(X, e) : WM(X, e)), X.selection && !t && function(e, t) {
            return AE(JE(e), t) && (JE(e).length > t.length || hE(e));
        }(X.selection, e) && J(null), vt();
    }
    function ct(e) {
        o("openFind", {
            findAndReplace: e
        }), n(20, Z = !1), n(21, ee = !1), ca().then(function() {
            n(20, Z = !0), n(21, ee = e);
        });
    }
    function lt(e, t) {
        o("handleExpandSection", e, t);
        var r = Zs(e);
        n(12, X = function(e, t, n, r) {
            return Ro(Ro({}, t), {}, {
                visibleSectionsMap: Ro(Ro({}, t.visibleSectionsMap), {}, zo({}, n, IM(LM(t, n).concat(r))))
            });
        }(0, X, r, t));
    }
    function ut(e) {
        o("pasted json as text", e), n(19, Q = e);
    }
    function ft(e) {
        var t = e.anchor, n = e.left, r = e.top, o = e.width, i = e.height, a = e.offsetTop, s = e.offsetLeft, c = e.showTip;
        W = !0;
        var u = p(VD, {
            json: l,
            documentState: X,
            parser: $,
            showTip: c,
            onEditKey: Oe,
            onEditValue: Me,
            onToggleEnforceString: Ee,
            onCut: Ae,
            onCopy: Te,
            onPaste: Ne,
            onRemove: De,
            onDuplicate: ze,
            onExtract: qe,
            onInsertBefore: Ve,
            onInsert: Le,
            onConvert: Fe,
            onInsertAfter: He,
            onSort: Qe,
            onTransform: Xe,
            onRenderContextMenu: z,
            onCloseContextMenu: function() {
                m(u), vt();
            }
        }, {
            left: n,
            top: r,
            offsetTop: a,
            offsetLeft: s,
            width: o,
            height: i,
            anchor: t,
            closeOnOuterClick: !0,
            onClose: function() {
                W = !1, vt();
            }
        });
    }
    function dt(e) {
        if (!b && !qE(X.selection)) {
            if (e && (e.stopPropagation(), e.preventDefault()), e && "contextmenu" === e.type && e.target !== s) ft({
                left: e.clientX,
                top: e.clientY,
                width: Ms,
                height: Os,
                showTip: !1
            });
            else {
                var t, n = null === (t = a) || void 0 === t ? void 0 : t.querySelector(".jse-context-menu-pointer.jse-selected");
                if (n) ft({
                    anchor: n,
                    offsetTop: 2,
                    width: Ms,
                    height: Os,
                    showTip: !1
                });
                else {
                    var r, o = null === (r = a) || void 0 === r ? void 0 : r.getBoundingClientRect();
                    o && ft({
                        top: o.top + 2,
                        left: o.left + 2,
                        width: Ms,
                        height: Os,
                        showTip: !1
                    });
                }
            }
            return !1;
        }
    }
    function ht() {
        return (ht = ko(wo().mark(function e() {
            var t, r, i, s, c;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (o("apply pasted json", Q), Q) {
                            e.next = 3;
                            break;
                        }
                        return e.abrupt("return");
                    case 3:
                        i = (r = Q).path, s = r.contents, n(19, Q = void 0), AO(c = (null === (t = a) || void 0 === t ? void 0 : t.querySelector(".jse-editable-div")) || null) && c.cancel(), ot([
                            {
                                op: "replace",
                                path: Zs(i),
                                value: s
                            }
                        ], function(e, t) {
                            return {
                                state: lE(e, t, i)
                            };
                        }), setTimeout(vt);
                    case 10:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function vt() {
        o("focus"), s && (s.focus(), s.select());
    }
    function pt(e) {
        return function(e, t, n) {
            var r = Qw(n), o = [
                vb(n)
            ], i = Ws(e, r), a = i ? cE(i, t, o) : void 0;
            return a ? RE(r.concat(a), !1) : IE(n);
        }(l, X, e);
    }
    function mt(e) {
        r && r.onDrag(e);
    }
    function gt() {
        r && r.onDragEnd();
    }
    return e.$$set = function(e) {
        "readOnly" in e && n(0, b = e.readOnly), "externalContent" in e && n(52, w = e.externalContent), "externalSelection" in e && n(53, x = e.externalSelection), "mainMenuBar" in e && n(1, k = e.mainMenuBar), "navigationBar" in e && n(2, j = e.navigationBar), "escapeControlCharacters" in e && n(54, S = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(55, C = e.escapeUnicodeCharacters), "parser" in e && n(3, $ = e.parser), "parseMemoizeOne" in e && n(56, _ = e.parseMemoizeOne), "validator" in e && n(57, O = e.validator), "validationParser" in e && n(58, M = e.validationParser), "pathParser" in e && n(4, E = e.pathParser), "indentation" in e && n(5, A = e.indentation), "onError" in e && n(6, P = e.onError), "onChange" in e && n(59, T = e.onChange), "onChangeMode" in e && n(60, R = e.onChangeMode), "onSelect" in e && n(61, N = e.onSelect), "onRenderValue" in e && n(62, I = e.onRenderValue), "onRenderMenu" in e && n(7, D = e.onRenderMenu), "onRenderContextMenu" in e && n(63, z = e.onRenderContextMenu), "onClassName" in e && n(64, q = e.onClassName), "onFocus" in e && n(65, B = e.onFocus), "onBlur" in e && n(66, L = e.onBlur), "onSortModal" in e && n(67, F = e.onSortModal), "onTransformModal" in e && n(68, V = e.onTransformModal), "onJSONEditorModal" in e && n(69, H = e.onJSONEditorModal);
    }, e.$$.update = function() {
        25165824 & e.$$.dirty[1] && n(77, G = aO({
            escapeControlCharacters: S,
            escapeUnicodeCharacters: C
        })), 4096 & e.$$.dirty[0] && o("selection", X.selection), 2097152 & e.$$.dirty[1] && je(w), 4194304 & e.$$.dirty[1] && function(e) {
            Ox(X.selection, e) || (o("applyExternalSelection", e), (yE(e) || null === e) && J(e));
        }(x), 2048 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && pe(ne, l), 2056 & e.$$.dirty[0] | 201326592 & e.$$.dirty[1] && be(l, O, $, M), 8192 & e.$$.dirty[0] && n(25, he = function(e) {
            var t = {};
            return e.forEach(function(e) {
                t[Zs(e.path)] = e;
            }), e.forEach(function(e) {
                for(var n = e.path; n.length > 0;){
                    var r = Zs(n = Qw(n));
                    r in t || (t[r] = {
                        isChildError: !0,
                        path: n,
                        message: "Contains invalid data",
                        severity: Za.warning
                    });
                }
            }), t;
        }(ge)), 1024 & e.$$.dirty[0] && (r = a ? function(e) {
            var t, n;
            function r(e) {
                return e < 20 ? is : e < 50 ? as : ss;
            }
            function o() {
                if (e) {
                    var n = (t || 0) * (os / 1e3);
                    e.scrollTop += n;
                }
            }
            function i(e) {
                n && e === t || (a(), gN("startAutoScroll", e), t = e, n = setInterval(o, os));
            }
            function a() {
                n && (gN("stopAutoScroll"), clearInterval(n), n = void 0, t = void 0);
            }
            return gN("createAutoScrollHandler", e), {
                onDrag: function(t) {
                    if (e) {
                        var n = t.clientY, o = e.getBoundingClientRect(), s = o.top, c = o.bottom;
                        n < s ? i(-r(s - n)) : n > c ? i(r(n - c)) : a();
                    }
                },
                onDragEnd: function() {
                    a();
                }
            };
        }(a) : void 0), 9 & e.$$.dirty[0] | 32773 & e.$$.dirty[2] && n(14, ve = {
            readOnly: b,
            parser: $,
            normalization: G,
            getJson: xe,
            getDocumentState: ke,
            findElement: tt,
            findNextInside: pt,
            focus: vt,
            onPatch: ot,
            onInsert: Be,
            onExpand: st,
            onSelect: J,
            onFind: ct,
            onExpandSection: lt,
            onPasteJson: ut,
            onRenderValue: I,
            onContextMenu: ft,
            onClassName: q || function() {},
            onDrag: mt,
            onDragEnd: gt
        }), 16384 & e.$$.dirty[0] && o("context changed", ve);
    }, [
        b,
        k,
        j,
        $,
        E,
        A,
        P,
        D,
        function() {
            return me && void 0 !== l && it(l), void 0 !== l ? {
                json: l
            } : {
                text: u || ""
            };
        },
        vt,
        a,
        l,
        X,
        ge,
        ve,
        s,
        c,
        u,
        K,
        Q,
        Z,
        ee,
        te,
        de,
        me,
        he,
        i,
        re,
        function() {
            return ie.apply(this, arguments);
        },
        function() {
            return ae.apply(this, arguments);
        },
        function(e, t) {
            return se.apply(this, arguments);
        },
        function(e, t) {
            return ce.apply(this, arguments);
        },
        function() {
            n(20, Z = !1), n(21, ee = !1), re(""), vt();
        },
        function(e) {
            o("select validation error", e), J(RE(e.path, !1)), Ze(e.path);
        },
        Te,
        function(e) {
            var t;
            e.preventDefault();
            var n = null === (t = e.clipboardData) || void 0 === t ? void 0 : t.getData("text/plain");
            void 0 !== n && KB({
                clipboardText: n,
                json: l,
                selection: X.selection,
                readOnly: b,
                parser: $,
                onPatch: ot,
                onChangeText: at,
                openRepairModal: Ie
            });
        },
        We,
        Je,
        Ke,
        function() {
            Ge([]);
        },
        function() {
            Ye({
                rootPath: []
            });
        },
        function() {
            st([], !0, !0);
        },
        function() {
            st([], !1, !0);
        },
        function(e) {
            var t = PO(e), n = e.shiftKey;
            if (o("keydown", {
                combo: t,
                key: e.key
            }), "Ctrl+X" === t && (e.preventDefault(), Ae(!0)), "Ctrl+Shift+X" === t && (e.preventDefault(), Ae(!1)), "Ctrl+C" === t && (e.preventDefault(), Te(!0)), "Ctrl+Shift+C" === t && (e.preventDefault(), Te(!1)), "Ctrl+D" === t && (e.preventDefault(), ze()), "Delete" !== t && "Backspace" !== t || (e.preventDefault(), De()), "Insert" === t && (e.preventDefault(), Be("structure")), "Ctrl+A" === t && (e.preventDefault(), J(RE([], !1))), "Ctrl+Q" === t && dt(e), "ArrowUp" === t || "Shift+ArrowUp" === t) {
                e.preventDefault();
                var r = X.selection ? SE(l, X, n) || X.selection : $E(l, X);
                J(r), nt(JE(r));
            }
            if ("ArrowDown" === t || "Shift+ArrowDown" === t) {
                e.preventDefault();
                var i = X.selection ? function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = t.selection;
                    if (!r) return null;
                    var o = n ? JE(r) : jE(e, r), i = Ql(Ws(e, o)) ? WM(t, o) : t, a = cE(e, t, o), s = cE(e, i, o);
                    if (n) return hE(r) ? null !== a ? DE(a, a) : null : dE(r) ? null !== s ? DE(s, s) : null : null !== s ? DE(KE(r), s) : null;
                    if (dE(r)) return null !== s ? RE(s, !1) : null;
                    if (hE(r)) return null !== a ? RE(a, !1) : null;
                    if (pE(r)) return null !== a ? RE(a, !1) : null;
                    if (vE(r)) {
                        if (null === a || 0 === a.length) return null;
                        var c = Ws(e, Qw(a));
                        return Array.isArray(c) ? RE(a, !1) : TE(a, !1);
                    }
                    return mE(r) ? null !== s ? RE(s, !1) : null !== a ? RE(a, !1) : null : null;
                }(l, X, n) || X.selection : $E(l, X);
                J(i), nt(JE(i));
            }
            if ("ArrowLeft" === t || "Shift+ArrowLeft" === t) {
                e.preventDefault();
                var a = X.selection ? function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = t.selection;
                    if (!o) return null;
                    var i = CE(e, t, r), a = i.caret, s = i.previous;
                    if (n) return mE(o) ? null : DE(o.path, o.path);
                    if (a && s) return FE(s);
                    var c = Ws(e, Qw(JE(o)));
                    return pE(o) && Array.isArray(c) ? DE(o.path, o.path) : mE(o) && !Array.isArray(c) ? TE(o.focusPath, !1) : null;
                }(l, X, n, !b) || X.selection : $E(l, X);
                J(a), nt(JE(a));
            }
            if ("ArrowRight" === t || "Shift+ArrowRight" === t) {
                e.preventDefault();
                var s = X.selection && void 0 !== l ? function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = t.selection;
                    if (!o) return null;
                    var i = CE(e, t, r), a = i.caret, s = i.next;
                    return n ? mE(o) ? null : DE(o.path, o.path) : a && s ? FE(s) : mE(o) ? RE(o.focusPath, !1) : null;
                }(l, X, n, !b) || X.selection : $E(l, X);
                J(s), nt(JE(s));
            }
            if ("Enter" === t && X.selection) {
                if (gE(X.selection)) {
                    var c = X.selection.focusPath, u = Ws(l, Qw(c));
                    Array.isArray(u) && J(RE(c, !1));
                }
                if (vE(X.selection) && (e.preventDefault(), J(Ro(Ro({}, X.selection), {}, {
                    edit: !0
                }))), pE(X.selection)) e.preventDefault(), Ql(Ws(l, X.selection.path)) ? st(X.selection.path, !0) : J(Ro(Ro({}, X.selection), {}, {
                    edit: !0
                }));
            }
            if (1 === t.replace(/^Shift\+/, "").length && X.selection) return e.preventDefault(), void We(e.key);
            if ("Enter" === t && (dE(X.selection) || hE(X.selection))) return e.preventDefault(), void We("");
            if ("Ctrl+Enter" === t && pE(X.selection)) {
                var f = Ws(l, X.selection.path);
                nu(f) && window.open(String(f), "_blank");
            }
            "Escape" === t && X.selection && (e.preventDefault(), J(null)), "Ctrl+F" === t && (e.preventDefault(), ct(!1)), "Ctrl+H" === t && (e.preventDefault(), ct(!0)), "Ctrl+Z" === t && (e.preventDefault(), Je()), "Ctrl+Shift+Z" === t && (e.preventDefault(), Ke());
        },
        function(e) {
            o("handleMouseDown", e);
            var t = e.target;
            yO(t, "BUTTON") || t.isContentEditable || (vt(), X.selection || void 0 !== l || "" !== u && void 0 !== u || (o("createDefaultSelection"), n(12, X = Ro(Ro({}, X), {}, {
                selection: RE([], !1)
            }))));
        },
        dt,
        function(e) {
            b || ft({
                anchor: $O(e.target, "BUTTON"),
                offsetTop: 0,
                width: Ms,
                height: Os,
                showTip: !0
            });
        },
        function() {
            return ht.apply(this, arguments);
        },
        function() {
            o("clear pasted json"), n(19, Q = void 0), vt();
        },
        function() {
            R(Qa.text);
        },
        function(e) {
            J(e), vt(), Ze(JE(e));
        },
        function(e) {
            var t = !wO(e.target, function(e) {
                return e === c;
            });
            t && qE(X.selection) && (o("click outside the editor, stop edit mode"), J(function(e) {
                return vE(e) || pE(e) ? Ro(Ro({}, e), {}, {
                    edit: !1
                }) : e;
            }), g && s && (s.focus(), s.blur()), o("blur (outside editor)"), s && s.blur());
        },
        w,
        x,
        S,
        C,
        _,
        O,
        M,
        T,
        R,
        N,
        I,
        z,
        q,
        B,
        L,
        F,
        V,
        H,
        function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : fE;
            o("expand");
            var t = Ro(Ro({}, X), {}, {
                expandedMap: {},
                visibleSectionsMap: {}
            });
            n(12, X = HM(l, t, [], e));
        },
        we,
        xe,
        _e,
        Ye,
        Ze,
        tt,
        G,
        ne,
        function(e) {
            n(20, Z = e);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(15, s = e);
            });
        },
        function() {
            vt(), We("{");
        },
        function() {
            vt(), We("[");
        },
        function() {
            vt();
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(10, a = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(16, c = e);
            });
        }
    ];
}
var CL = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, SL, jL, Zo, {
            readOnly: 0,
            externalContent: 52,
            externalSelection: 53,
            mainMenuBar: 1,
            navigationBar: 2,
            escapeControlCharacters: 54,
            escapeUnicodeCharacters: 55,
            parser: 3,
            parseMemoizeOne: 56,
            validator: 57,
            validationParser: 58,
            pathParser: 4,
            indentation: 5,
            onError: 6,
            onChange: 59,
            onChangeMode: 60,
            onSelect: 61,
            onRenderValue: 62,
            onRenderMenu: 7,
            onRenderContextMenu: 63,
            onClassName: 64,
            onFocus: 65,
            onBlur: 66,
            onSortModal: 67,
            onTransformModal: 68,
            onJSONEditorModal: 69,
            expand: 70,
            validate: 71,
            getJson: 72,
            patch: 73,
            acceptAutoRepair: 8,
            openTransformModal: 74,
            scrollTo: 75,
            findElement: 76,
            focus: 9
        }, dL, [
            -1,
            -1,
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "expand",
            get: function() {
                return this.$$.ctx[70];
            }
        },
        {
            key: "validate",
            get: function() {
                return this.$$.ctx[71];
            }
        },
        {
            key: "getJson",
            get: function() {
                return this.$$.ctx[72];
            }
        },
        {
            key: "patch",
            get: function() {
                return this.$$.ctx[73];
            }
        },
        {
            key: "acceptAutoRepair",
            get: function() {
                return this.$$.ctx[8];
            }
        },
        {
            key: "openTransformModal",
            get: function() {
                return this.$$.ctx[74];
            }
        },
        {
            key: "scrollTo",
            get: function() {
                return this.$$.ctx[75];
            }
        },
        {
            key: "findElement",
            get: function() {
                return this.$$.ctx[76];
            }
        },
        {
            key: "focus",
            get: function() {
                return this.$$.ctx[9];
            }
        }
    ]), t;
}();
function $L(e) {
    var t;
    return "object" !== Ho(t = e) || null === t ? e : new Proxy(e, {
        get: function(e, t, n) {
            return $L(Reflect.get(e, t, n));
        },
        set: function() {
            return !1;
        },
        deleteProperty: function() {
            return !1;
        }
    });
}
function _L(e) {
    mi(e, "svelte-l4qqoi", '.jse-modal.svelte-l4qqoi.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-l4qqoi .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-l4qqoi .jse-modal-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions.svelte-l4qqoi{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents.svelte-l4qqoi{color:inherit;min-height:0;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents.svelte-l4qqoi{flex:1;display:flex;gap:calc(2 * var(--jse-padding, 10px));min-height:0;box-sizing:border-box;padding:0 calc(2 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p{margin:var(--jse-padding, 10px) 0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p:first-child{margin-top:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p:last-child{margin-bottom:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi code{background:var(--jse-modal-code-background, rgba(0, 0, 0, 0.05));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px)}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-l4qqoi{flex:1;outline:none;resize:vertical}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;gap:calc(2 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.jse-hide.svelte-l4qqoi{flex:none}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-preview-data.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.jse-hide-original-data.svelte-l4qqoi{flex-direction:column;gap:0;margin-bottom:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-actions.svelte-l4qqoi{padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px)) calc(2 * var(--jse-padding, 10px))}@media screen and (max-width: 1200px){.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents.svelte-l4qqoi{flex-direction:column;overflow:auto}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-l4qqoi{min-height:150px;flex:none}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-l4qqoi .jse-tree-mode{height:300px;flex:none}}.jse-modal.jse-transform.svelte-l4qqoi .jse-label.svelte-l4qqoi{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-label .jse-label-inner.svelte-l4qqoi{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-label .jse-label-inner button.svelte-l4qqoi{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-tree-mode{flex:1;background:var(--jse-input-background-readonly, transparent);box-shadow:none;box-sizing:border-box;--jse-main-border:var(--jse-input-border, 1px solid #d8dbdf)}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi:focus,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi:read-only,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-transform.svelte-l4qqoi .jse-preview.jse-error.svelte-l4qqoi{flex:1;background:var(--jse-input-background-readonly, transparent);border:var(--jse-input-border, 1px solid #d8dbdf);color:var(--jse-error-color, #ee5341);padding:calc(0.5 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-l4qqoi a{color:var(--jse-a-color, #156fc5)}.jse-modal.jse-transform.svelte-l4qqoi a:hover{color:var(--jse-a-color-highlight, #0f508d)}');
}
function OL(e) {
    var t, n, r, o, i, a = [
        EL,
        ML
    ], s = [];
    function c(e, n) {
        return 16384 & n[0] && (t = null), null == t && (t = !!Array.isArray(e[14])), t ? 0 : 1;
    }
    return n = c(e, [
        -1,
        -1
    ]), r = s[n] = a[n](e), {
        c: function() {
            r.c(), o = _i();
        },
        m: function(e, t) {
            s[n].m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, t) {
            var i = n;
            (n = c(e, t)) === i ? s[n].p(e, t) : (ba(), ka(s[i], 1, 1, function() {
                s[i] = null;
            }), wa(), (r = s[n]) ? r.p(e, t) : (r = s[n] = a[n](e)).c(), xa(r, 1), r.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(o), s[n].d(e);
        }
    };
}
function ML(e) {
    var t;
    return {
        c: function() {
            t = Ci("(Only available for arrays, not for objects)");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function EL(e) {
    var t, n;
    return t = new rN({
        props: {
            queryOptions: e[15],
            json: e[14],
            onChange: e[24]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            32768 & n[0] && (r.queryOptions = e[15]), 16384 & n[0] && (r.json = e[14]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function AL(e) {
    var t, n;
    return t = new CL({
        props: {
            externalContent: e[17],
            externalSelection: null,
            readOnly: !0,
            mainMenuBar: !1,
            navigationBar: !1,
            indentation: e[2],
            escapeControlCharacters: e[3],
            escapeUnicodeCharacters: e[4],
            parser: e[5],
            parseMemoizeOne: e[6],
            onRenderValue: e[10],
            onRenderMenu: e[11],
            onRenderContextMenu: e[12],
            onError: console.error,
            onChange: Mf,
            onChangeMode: Mf,
            onSelect: Mf,
            onFocus: Mf,
            onBlur: Mf,
            onSortModal: Mf,
            onTransformModal: Mf,
            onJSONEditorModal: Mf,
            onClassName: e[13],
            validator: null,
            validationParser: e[7],
            pathParser: e[8]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            131072 & n[0] && (r.externalContent = e[17]), 4 & n[0] && (r.indentation = e[2]), 8 & n[0] && (r.escapeControlCharacters = e[3]), 16 & n[0] && (r.escapeUnicodeCharacters = e[4]), 32 & n[0] && (r.parser = e[5]), 64 & n[0] && (r.parseMemoizeOne = e[6]), 1024 & n[0] && (r.onRenderValue = e[10]), 2048 & n[0] && (r.onRenderMenu = e[11]), 4096 & n[0] && (r.onRenderContextMenu = e[12]), 8192 & n[0] && (r.onClassName = e[13]), 128 & n[0] && (r.validationParser = e[7]), 256 & n[0] && (r.pathParser = e[8]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function PL(e) {
    var t, n;
    return {
        c: function() {
            t = ji("div"), n = Ci(e[20]), Ai(t, "class", "jse-preview jse-error svelte-l4qqoi");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            1048576 & t[0] && Ni(n, e[20]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function TL(e) {
    var t, n;
    return t = new CL({
        props: {
            externalContent: e[21],
            externalSelection: null,
            readOnly: !0,
            mainMenuBar: !1,
            navigationBar: !1,
            indentation: e[2],
            escapeControlCharacters: e[3],
            escapeUnicodeCharacters: e[4],
            parser: e[5],
            parseMemoizeOne: e[6],
            onRenderValue: e[10],
            onRenderMenu: e[11],
            onRenderContextMenu: e[12],
            onError: console.error,
            onChange: Mf,
            onChangeMode: Mf,
            onSelect: Mf,
            onFocus: Mf,
            onBlur: Mf,
            onSortModal: Mf,
            onTransformModal: Mf,
            onJSONEditorModal: Mf,
            onClassName: e[13],
            validator: null,
            validationParser: e[7],
            pathParser: e[8]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2097152 & n[0] && (r.externalContent = e[21]), 4 & n[0] && (r.indentation = e[2]), 8 & n[0] && (r.escapeControlCharacters = e[3]), 16 & n[0] && (r.escapeUnicodeCharacters = e[4]), 32 & n[0] && (r.parser = e[5]), 64 & n[0] && (r.parseMemoizeOne = e[6]), 1024 & n[0] && (r.onRenderValue = e[10]), 2048 & n[0] && (r.onRenderMenu = e[11]), 4096 & n[0] && (r.onRenderContextMenu = e[12]), 8192 & n[0] && (r.onClassName = e[13]), 128 & n[0] && (r.validationParser = e[7]), 256 & n[0] && (r.pathParser = e[8]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function RL(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M, E, A, P, T, R, N, I, D, z, q, B, L, F, V, H, W, U, J, K = e[23](e[0]).description + "";
    t = new mN({
        props: {
            queryLanguages: e[9],
            queryLanguageId: e[0],
            onChangeQueryLanguage: e[29]
        }
    }), y = new jM({
        props: {
            data: e[18] ? gP : YA
        }
    });
    var G = e[18] && OL(e);
    A = new jM({
        props: {
            data: e[19] ? gP : YA
        }
    });
    var Q = e[19] && AL(e), Y = [
        TL,
        PL
    ], X = [];
    function Z(e, t) {
        return e[20] ? 1 : 0;
    }
    return z = Z(e), q = X[z] = Y[z](e), {
        c: function() {
            Pa(t.$$.fragment), n = $i(), r = ji("div"), o = ji("div"), i = ji("div"), (a = ji("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Language</div>', s = $i(), c = ji("div"), l = $i(), (u = ji("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Path</div>', f = $i(), d = ji("input"), v = $i(), p = ji("div"), m = ji("div"), g = ji("button"), Pa(y.$$.fragment), b = Ci("\n                Wizard"), w = $i(), G && G.c(), x = $i(), (k = ji("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Query</div>', j = $i(), S = ji("textarea"), C = $i(), $ = ji("div"), _ = ji("div"), O = ji("div"), M = ji("div"), E = ji("button"), Pa(A.$$.fragment), P = Ci("\n                  Original"), T = $i(), Q && Q.c(), R = $i(), N = ji("div"), (I = ji("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Preview</div>', D = $i(), q.c(), B = $i(), L = ji("div"), F = ji("button"), V = Ci("Transform"), Ai(a, "class", "jse-label svelte-l4qqoi"), Ai(c, "class", "jse-description svelte-l4qqoi"), Ai(u, "class", "jse-label svelte-l4qqoi"), Ai(d, "class", "jse-path svelte-l4qqoi"), Ai(d, "type", "text"), d.readOnly = !0, Ai(d, "title", "Selected path"), d.value = h = _x(e[1]) ? "(document root)" : JO(e[1]), Ai(g, "type", "button"), Ai(g, "class", "svelte-l4qqoi"), Ai(m, "class", "jse-label-inner svelte-l4qqoi"), Ai(p, "class", "jse-label svelte-l4qqoi"), Ai(k, "class", "jse-label svelte-l4qqoi"), Ai(S, "class", "jse-query svelte-l4qqoi"), Ai(S, "spellcheck", "false"), S.value = e[16], Ai(i, "class", "jse-query-contents svelte-l4qqoi"), Ai(E, "type", "button"), Ai(E, "class", "svelte-l4qqoi"), Ai(M, "class", "jse-label-inner svelte-l4qqoi"), Ai(O, "class", "jse-label svelte-l4qqoi"), Ai(_, "class", "jse-original-data svelte-l4qqoi"), qi(_, "jse-hide", !e[19]), Ai(I, "class", "jse-label svelte-l4qqoi"), Ai(N, "class", "jse-preview-data svelte-l4qqoi"), Ai($, "class", "jse-data-contents svelte-l4qqoi"), qi($, "jse-hide-original-data", !e[19]), Ai(o, "class", "jse-main-contents svelte-l4qqoi"), Ai(F, "type", "button"), Ai(F, "class", "jse-primary svelte-l4qqoi"), F.disabled = H = !!e[20], Ai(L, "class", "jse-actions svelte-l4qqoi"), Ai(r, "class", "jse-modal-contents svelte-l4qqoi");
        },
        m: function(h, q) {
            Ta(t, h, q), wi(h, n, q), wi(h, r, q), pi(r, o), pi(o, i), pi(i, a), pi(i, s), pi(i, c), c.innerHTML = K, pi(i, l), pi(i, u), pi(i, f), pi(i, d), pi(i, v), pi(i, p), pi(p, m), pi(m, g), Ta(y, g, null), pi(g, b), pi(i, w), G && G.m(i, null), pi(i, x), pi(i, k), pi(i, j), pi(i, S), pi(o, C), pi(o, $), pi($, _), pi(_, O), pi(O, M), pi(M, E), Ta(A, E, null), pi(E, P), pi(_, T), Q && Q.m(_, null), pi($, R), pi($, N), pi(N, I), pi(N, D), X[z].m(N, null), pi(r, B), pi(r, L), pi(L, F), pi(F, V), W = !0, U || (J = [
                Oi(g, "click", e[27]),
                Oi(S, "input", e[25]),
                Oi(E, "click", e[28]),
                Oi(F, "click", e[26]),
                ci(IL.call(null, F))
            ], U = !0);
        },
        p: function(e, n) {
            var r = {};
            512 & n[0] && (r.queryLanguages = e[9]), 1 & n[0] && (r.queryLanguageId = e[0]), t.$set(r), (!W || 1 & n[0]) && K !== (K = e[23](e[0]).description + "") && (c.innerHTML = K), (!W || 2 & n[0] && h !== (h = _x(e[1]) ? "(document root)" : JO(e[1])) && d.value !== h) && (d.value = h);
            var o = {};
            262144 & n[0] && (o.data = e[18] ? gP : YA), y.$set(o), e[18] ? G ? (G.p(e, n), 262144 & n[0] && xa(G, 1)) : ((G = OL(e)).c(), xa(G, 1), G.m(i, x)) : G && (ba(), ka(G, 1, 1, function() {
                G = null;
            }), wa()), (!W || 65536 & n[0]) && (S.value = e[16]);
            var a = {};
            524288 & n[0] && (a.data = e[19] ? gP : YA), A.$set(a), e[19] ? Q ? (Q.p(e, n), 524288 & n[0] && xa(Q, 1)) : ((Q = AL(e)).c(), xa(Q, 1), Q.m(_, null)) : Q && (ba(), ka(Q, 1, 1, function() {
                Q = null;
            }), wa()), (!W || 524288 & n[0]) && qi(_, "jse-hide", !e[19]);
            var s = z;
            (z = Z(e)) === s ? X[z].p(e, n) : (ba(), ka(X[s], 1, 1, function() {
                X[s] = null;
            }), wa(), (q = X[z]) ? q.p(e, n) : (q = X[z] = Y[z](e)).c(), xa(q, 1), q.m(N, null)), (!W || 524288 & n[0]) && qi($, "jse-hide-original-data", !e[19]), (!W || 1048576 & n[0] && H !== (H = !!e[20])) && (F.disabled = H);
        },
        i: function(e) {
            W || (xa(t.$$.fragment, e), xa(y.$$.fragment, e), xa(G), xa(A.$$.fragment, e), xa(Q), xa(q), W = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), ka(y.$$.fragment, e), ka(G), ka(A.$$.fragment, e), ka(Q), ka(q), W = !1;
        },
        d: function(e) {
            e && (xi(n), xi(r)), Ra(t, e), Ra(y), G && G.d(), Ra(A), Q && Q.d(), X[z].d(), U = !1, Qo(J);
        }
    };
}
function NL(e) {
    var t, n, r, o, i;
    return n = new UO({
        props: {
            $$slots: {
                default: [
                    RL
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-modal jse-transform svelte-l4qqoi");
        },
        m: function(a, s) {
            wi(a, t, s), Ta(n, t, null), r = !0, o || (i = ci(FI.call(null, t, e[22])), o = !0);
        },
        p: function(e, t) {
            var r = {};
            4194303 & t[0] | 2048 & t[1] && (r.$$scope = {
                dirty: t,
                ctx: e
            }), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), o = !1, i();
        }
    };
}
function IL(e) {
    e.focus();
}
function DL(e, t, n) {
    var r, o, i = Da("jsoneditor:TransformModal"), a = t.id, s = void 0 === a ? "transform-modal-" + Ps() : a, c = t.json, l = t.rootPath, u = void 0 === l ? [] : l, f = t.indentation, d = t.escapeControlCharacters, h = t.escapeUnicodeCharacters, v = t.parser, p = t.parseMemoizeOne, m = t.validationParser, g = t.pathParser, y = t.queryLanguages, b = t.queryLanguageId, w = t.onChangeQueryLanguage, x = t.onRenderValue, k = t.onRenderMenu, j = t.onRenderContextMenu, S = t.onClassName, C = t.onTransform, $ = Zi("simple-modal").close, _ = "".concat(s, ":").concat(Zs(u)), O = RP[_] || {}, M = !1 !== NP.showWizard, E = !1 !== NP.showOriginal, A = O.queryOptions || {}, P = b === O.queryLanguageId && O.query ? O.query : I(b).createQuery(r, O.queryOptions || {}), T = O.isManual || !1, R = void 0, N = {
        text: ""
    };
    function I(e) {
        return y.find(function(t) {
            return t.id === e;
        }) || y[0];
    }
    var D = Vy(function(e, t) {
        if (void 0 === e) return n(21, N = {
            text: ""
        }), void n(20, R = "Error: No JSON");
        try {
            i("previewTransform", {
                query: t
            });
            var r = I(b).executeQuery(e, t, v);
            n(21, N = {
                json: r
            }), n(20, R = void 0);
        } catch (e) {
            n(21, N = {
                text: ""
            }), n(20, R = String(e));
        }
    }, 300);
    return e.$$set = function(e) {
        "id" in e && n(30, s = e.id), "json" in e && n(31, c = e.json), "rootPath" in e && n(1, u = e.rootPath), "indentation" in e && n(2, f = e.indentation), "escapeControlCharacters" in e && n(3, d = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(4, h = e.escapeUnicodeCharacters), "parser" in e && n(5, v = e.parser), "parseMemoizeOne" in e && n(6, p = e.parseMemoizeOne), "validationParser" in e && n(7, m = e.validationParser), "pathParser" in e && n(8, g = e.pathParser), "queryLanguages" in e && n(9, y = e.queryLanguages), "queryLanguageId" in e && n(0, b = e.queryLanguageId), "onChangeQueryLanguage" in e && n(32, w = e.onChangeQueryLanguage), "onRenderValue" in e && n(10, x = e.onRenderValue), "onRenderMenu" in e && n(11, k = e.onRenderMenu), "onRenderContextMenu" in e && n(12, j = e.onRenderContextMenu), "onClassName" in e && n(13, S = e.onClassName), "onTransform" in e && n(33, C = e.onTransform);
    }, e.$$.update = function() {
        2 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && n(14, r = $L(Ws(c, u))), 16384 & e.$$.dirty[0] && n(17, o = r ? {
            json: r
        } : {
            text: ""
        }), 81920 & e.$$.dirty[0] && D(r, P), 98305 & e.$$.dirty[0] | 24 & e.$$.dirty[1] && (n(34, RP[_] = {
            queryOptions: A,
            query: P,
            queryLanguageId: b,
            isManual: T
        }, RP), i("store state in memory", _, RP[_]));
    }, [
        b,
        u,
        f,
        d,
        h,
        v,
        p,
        m,
        g,
        y,
        x,
        k,
        j,
        S,
        r,
        A,
        P,
        o,
        M,
        E,
        R,
        N,
        $,
        I,
        function(e) {
            n(15, A = e), n(16, P = I(b).createQuery(r, e)), n(35, T = !1), i("updateQueryByWizard", {
                queryOptions: A,
                query: P,
                isManual: T
            });
        },
        function(e) {
            n(16, P = e.target.value), n(35, T = !0), i("handleChangeQuery", {
                query: P,
                isManual: T
            });
        },
        function() {
            if (void 0 === r) return n(21, N = {
                text: ""
            }), void n(20, R = "Error: No JSON");
            try {
                i("handleTransform", {
                    query: P
                });
                var e = I(b).executeQuery(r, P, v);
                C([
                    {
                        op: "replace",
                        path: Zs(u),
                        value: e
                    }
                ]), $();
            } catch (e) {
                console.error(e), n(21, N = {
                    text: ""
                }), n(20, R = String(e));
            }
        },
        function() {
            n(18, M = !M), NP.showWizard = M;
        },
        function() {
            n(19, E = !E), NP.showOriginal = E;
        },
        function(e) {
            i("handleChangeQueryLanguage", e), n(0, b = e), w(e);
            var t = I(b);
            n(16, P = t.createQuery(r, A)), n(35, T = !1);
        },
        s,
        c,
        w,
        C,
        RP,
        T
    ];
}
var zL = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, DL, NL, Zo, {
            id: 30,
            json: 31,
            rootPath: 1,
            indentation: 2,
            escapeControlCharacters: 3,
            escapeUnicodeCharacters: 4,
            parser: 5,
            parseMemoizeOne: 6,
            validationParser: 7,
            pathParser: 8,
            queryLanguages: 9,
            queryLanguageId: 0,
            onChangeQueryLanguage: 32,
            onRenderValue: 10,
            onRenderMenu: 11,
            onRenderContextMenu: 12,
            onClassName: 13,
            onTransform: 33
        }, _L, [
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t);
}(), qL = {};
function BL(e) {
    mi(e, "svelte-qjdk97", '.jse-modal.svelte-qjdk97.svelte-qjdk97{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-qjdk97 .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-qjdk97 .jse-modal-contents.svelte-qjdk97{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions.svelte-qjdk97{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-sort.svelte-qjdk97 table.svelte-qjdk97{width:100%;border-collapse:collapse;border-spacing:0}.jse-modal.jse-sort.svelte-qjdk97 table th.svelte-qjdk97,.jse-modal.jse-sort.svelte-qjdk97 table td.svelte-qjdk97{text-align:left;vertical-align:middle;font-weight:normal;padding-bottom:var(--jse-padding, 10px)}.jse-modal.jse-sort.svelte-qjdk97 table th input.jse-path.svelte-qjdk97,.jse-modal.jse-sort.svelte-qjdk97 table td input.jse-path.svelte-qjdk97{width:100%;box-sizing:border-box;padding:6px 16px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);font-family:inherit;font-size:inherit;background:inherit;color:inherit;outline:none}.jse-modal.jse-sort.svelte-qjdk97 table th input.jse-path.svelte-qjdk97:read-only,.jse-modal.jse-sort.svelte-qjdk97 table td input.jse-path.svelte-qjdk97:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-sort.svelte-qjdk97 table th.svelte-qjdk97 .svelte-select input,.jse-modal.jse-sort.svelte-qjdk97 table td.svelte-qjdk97 .svelte-select input{box-sizing:border-box}.jse-modal.jse-sort.svelte-qjdk97 .jse-space.svelte-qjdk97{height:200px}.jse-modal.jse-sort.svelte-qjdk97 .jse-space .jse-error.svelte-qjdk97{color:var(--jse-error-color, #ee5341)}');
}
function LL(e) {
    var t, n, r, o, i, a, s;
    function c(t) {
        e[14](t);
    }
    var l = {
        showChevron: !0,
        items: e[5]
    };
    return void 0 !== e[1] && (l.value = e[1]), i = new ZR({
        props: l
    }), na.push(function() {
        return Aa(i, "value", c);
    }), {
        c: function() {
            t = ji("tr"), (n = ji("th")).textContent = "Property", r = $i(), o = ji("td"), Pa(i.$$.fragment), Ai(n, "class", "svelte-qjdk97"), Ai(o, "class", "svelte-qjdk97");
        },
        m: function(e, a) {
            wi(e, t, a), pi(t, n), pi(t, r), pi(t, o), Ta(i, o, null), s = !0;
        },
        p: function(e, t) {
            var n = {};
            32 & t && (n.items = e[5]), !a && 2 & t && (a = !0, n.value = e[1], ua(function() {
                return a = !1;
            })), i.$set(n);
        },
        i: function(e) {
            s || (xa(i.$$.fragment, e), s = !0);
        },
        o: function(e) {
            ka(i.$$.fragment, e), s = !1;
        },
        d: function(e) {
            e && xi(t), Ra(i);
        }
    };
}
function FL(e) {
    var t, n;
    return {
        c: function() {
            t = ji("div"), n = Ci(e[4]), Ai(t, "class", "jse-error svelte-qjdk97");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            16 & t && Ni(n, e[4]);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function VL(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O, M, E, A, P, T;
    r = new XN({
        props: {
            title: e[3] ? "Sort array items" : "Sort object keys"
        }
    });
    var R = e[3] && (e[5] && (null === (t = e[5]) || void 0 === t ? void 0 : t.length) > 1 || void 0 === e[1]) && LL(e);
    function N(t) {
        e[15](t);
    }
    var I = {
        showChevron: !0,
        clearable: !1,
        items: e[7]
    };
    void 0 !== e[2] && (I.value = e[2]), k = new ZR({
        props: I
    }), na.push(function() {
        return Aa(k, "value", N);
    });
    var D = e[4] && FL(e);
    return {
        c: function() {
            var t;
            n = ji("div"), Pa(r.$$.fragment), o = $i(), i = ji("div"), a = ji("table"), (s = ji("colgroup")).innerHTML = '<col width="25%"/> <col width="75%"/>', c = $i(), l = ji("tbody"), u = ji("tr"), (f = ji("th")).textContent = "Path", d = $i(), h = ji("td"), v = ji("input"), m = $i(), R && R.c(), g = $i(), y = ji("tr"), (b = ji("th")).textContent = "Direction", w = $i(), x = ji("td"), Pa(k.$$.fragment), S = $i(), C = ji("div"), D && D.c(), $ = $i(), _ = ji("div"), O = ji("button"), M = Ci("Sort"), Ai(f, "class", "svelte-qjdk97"), Ai(v, "class", "jse-path svelte-qjdk97"), Ai(v, "type", "text"), v.readOnly = !0, Ai(v, "title", "Selected path"), v.value = p = _x(e[0]) ? "(document root)" : JO(e[0]), Ai(h, "class", "svelte-qjdk97"), Ai(b, "class", "svelte-qjdk97"), Ai(x, "class", "svelte-qjdk97"), Ai(a, "class", "svelte-qjdk97"), Ai(C, "class", "jse-space svelte-qjdk97"), Ai(O, "type", "button"), Ai(O, "class", "jse-primary svelte-qjdk97"), O.disabled = E = !!(e[3] && e[5] && (null === (t = e[5]) || void 0 === t ? void 0 : t.length) > 1) && !e[1], Ai(_, "class", "jse-actions svelte-qjdk97"), Ai(i, "class", "jse-modal-contents svelte-qjdk97"), Ai(n, "class", "jse-modal jse-sort svelte-qjdk97");
        },
        m: function(t, p) {
            wi(t, n, p), Ta(r, n, null), pi(n, o), pi(n, i), pi(i, a), pi(a, s), pi(a, c), pi(a, l), pi(l, u), pi(u, f), pi(u, d), pi(u, h), pi(h, v), pi(l, m), R && R.m(l, null), pi(l, g), pi(l, y), pi(y, b), pi(y, w), pi(y, x), Ta(k, x, null), pi(i, S), pi(i, C), D && D.m(C, null), pi(i, $), pi(i, _), pi(_, O), pi(O, M), A = !0, P || (T = [
                Oi(O, "click", e[8]),
                ci(HL.call(null, O)),
                ci(FI.call(null, n, e[6]))
            ], P = !0);
        },
        p: function(e, t) {
            var n, o, i = jo(t, 1)[0], a = {};
            8 & i && (a.title = e[3] ? "Sort array items" : "Sort object keys"), r.$set(a), (!A || 1 & i && p !== (p = _x(e[0]) ? "(document root)" : JO(e[0])) && v.value !== p) && (v.value = p), e[3] && (e[5] && (null === (n = e[5]) || void 0 === n ? void 0 : n.length) > 1 || void 0 === e[1]) ? R ? (R.p(e, i), 42 & i && xa(R, 1)) : ((R = LL(e)).c(), xa(R, 1), R.m(l, g)) : R && (ba(), ka(R, 1, 1, function() {
                R = null;
            }), wa());
            var s = {};
            !j && 4 & i && (j = !0, s.value = e[2], ua(function() {
                return j = !1;
            })), k.$set(s), e[4] ? D ? D.p(e, i) : ((D = FL(e)).c(), D.m(C, null)) : D && (D.d(1), D = null), (!A || 42 & i && E !== (E = !!(e[3] && e[5] && (null === (o = e[5]) || void 0 === o ? void 0 : o.length) > 1) && !e[1])) && (O.disabled = E);
        },
        i: function(e) {
            A || (xa(r.$$.fragment, e), xa(R), xa(k.$$.fragment, e), A = !0);
        },
        o: function(e) {
            ka(r.$$.fragment, e), ka(R), ka(k.$$.fragment, e), A = !1;
        },
        d: function(e) {
            e && xi(n), Ra(r), R && R.d(), Ra(k), D && D.d(), P = !1, Qo(T);
        }
    };
}
function HL(e) {
    e.focus();
}
function WL(e, t, n) {
    var r, o, i, a, s, c = Da("jsoneditor:SortModal"), l = t.id, u = t.json, f = t.rootPath, d = t.onSort, h = Zi("simple-modal").close, v = "".concat(l, ":").concat(Zs(f)), p = Ws(u, f), m = {
        value: 1,
        label: "ascending"
    }, g = [
        m,
        {
            value: -1,
            label: "descending"
        }
    ], y = null === (r = qL[v]) || void 0 === r ? void 0 : r.selectedProperty, b = (null === (o = qL[v]) || void 0 === o ? void 0 : o.selectedDirection) || m, w = void 0;
    return e.$$set = function(e) {
        "id" in e && n(9, l = e.id), "json" in e && n(10, u = e.json), "rootPath" in e && n(0, f = e.rootPath), "onSort" in e && n(11, d = e.onSort);
    }, e.$$.update = function() {
        8 & e.$$.dirty && n(13, a = i && void 0 !== p ? T_(p) : void 0), 8192 & e.$$.dirty && n(5, s = a ? a.map(GO) : void 0), 4102 & e.$$.dirty && (n(12, qL[v] = {
            selectedProperty: y,
            selectedDirection: b
        }, qL), c("store state in memory", v, qL[v]));
    }, n(3, i = Array.isArray(p)), [
        f,
        y,
        b,
        i,
        w,
        s,
        h,
        g,
        function() {
            try {
                var e, t, r;
                n(4, w = void 0);
                var o = (null === (e = y) || void 0 === e ? void 0 : e.value) || (null === (t = s) || void 0 === t || null === (t = t[0]) || void 0 === t ? void 0 : t.value) || [], i = null === (r = b) || void 0 === r ? void 0 : r.value, a = Lq(u, f, o, i);
                d({
                    operations: a,
                    rootPath: f,
                    itemPath: o,
                    direction: i
                }), h();
            } catch (e) {
                n(4, w = String(e));
            }
        },
        l,
        u,
        d,
        qL,
        a,
        function(e) {
            n(1, y = e);
        },
        function(e) {
            n(2, b = e);
        }
    ];
}
var UL = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, WL, VL, Zo, {
            id: 9,
            json: 10,
            rootPath: 0,
            onSort: 11
        }, BL), n;
    }
    return Ao(t, Ia), Do(t);
}();
function JL() {}
function KL(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3;
    if (e < .9 * t) return e.toFixed() + " B";
    var n = e / t;
    if (n < .9 * t) return n.toFixed(1) + " KB";
    var r = n / t;
    if (r < .9 * t) return r.toFixed(1) + " MB";
    var o = r / t;
    return o < .9 * t ? o.toFixed(1) + " GB" : (o / t).toFixed(1) + " TB";
}
function GL(e) {
    var t, n;
    return t = new PI({
        props: {
            items: e[0]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & jo(n, 1)[0] && (r.items = e[0]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function QL(e, t, n) {
    var r, o, i = t.readOnly, a = void 0 !== i && i, s = t.onFormat, c = t.onCompact, l = t.onSort, u = t.onTransform, f = t.onToggleSearch, d = t.onUndo, h = t.onRedo, v = t.canUndo, p = t.canRedo, m = t.canFormat, g = t.canCompact, y = t.canSort, b = t.canTransform, w = t.onRenderMenu, x = {
        type: "button",
        icon: jP,
        title: "Search (Ctrl+F)",
        className: "jse-search",
        onClick: f
    };
    return e.$$set = function(e) {
        "readOnly" in e && n(1, a = e.readOnly), "onFormat" in e && n(2, s = e.onFormat), "onCompact" in e && n(3, c = e.onCompact), "onSort" in e && n(4, l = e.onSort), "onTransform" in e && n(5, u = e.onTransform), "onToggleSearch" in e && n(6, f = e.onToggleSearch), "onUndo" in e && n(7, d = e.onUndo), "onRedo" in e && n(8, h = e.onRedo), "canUndo" in e && n(9, v = e.canUndo), "canRedo" in e && n(10, p = e.canRedo), "canFormat" in e && n(11, m = e.canFormat), "canCompact" in e && n(12, g = e.canCompact), "canSort" in e && n(13, y = e.canSort), "canTransform" in e && n(14, b = e.canTransform), "onRenderMenu" in e && n(15, w = e.onRenderMenu);
    }, e.$$.update = function() {
        32702 & e.$$.dirty && n(16, o = a ? [
            x,
            {
                type: "space"
            }
        ] : [
            {
                type: "button",
                icon: _q,
                title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
                className: "jse-format",
                onClick: s,
                disabled: a || !m
            },
            {
                type: "button",
                icon: Oq,
                title: "Compact JSON: remove all white spacing and new lines (Ctrl+Shift+I)",
                className: "jse-compact",
                onClick: c,
                disabled: a || !g
            },
            {
                type: "separator"
            },
            {
                type: "button",
                icon: wP,
                title: "Sort",
                className: "jse-sort",
                onClick: l,
                disabled: a || !y
            },
            {
                type: "button",
                icon: cP,
                title: "Transform contents (filter, sort, project)",
                className: "jse-transform",
                onClick: u,
                disabled: a || !b
            },
            x,
            {
                type: "separator"
            },
            {
                type: "button",
                icon: vP,
                title: "Undo (Ctrl+Z)",
                className: "jse-undo",
                onClick: d,
                disabled: !v
            },
            {
                type: "button",
                icon: hP,
                title: "Redo (Ctrl+Shift+Z)",
                className: "jse-redo",
                onClick: h,
                disabled: !p
            },
            {
                type: "space"
            }
        ]), 98304 & e.$$.dirty && n(0, r = w(o) || o);
    }, [
        r,
        a,
        s,
        c,
        l,
        u,
        f,
        d,
        h,
        v,
        p,
        m,
        g,
        y,
        b,
        w,
        o
    ];
}
var YL = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, QL, GL, Zo, {
            readOnly: 1,
            onFormat: 2,
            onCompact: 3,
            onSort: 4,
            onTransform: 5,
            onToggleSearch: 6,
            onUndo: 7,
            onRedo: 8,
            canUndo: 9,
            canRedo: 10,
            canFormat: 11,
            canCompact: 12,
            canSort: 13,
            canTransform: 14,
            onRenderMenu: 15
        }), n;
    }
    return Ao(t, Ia), Do(t);
}(), XL = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "lineAt",
            value: function(e) {
                if (e < 0 || e > this.length) throw new RangeError("Invalid position ".concat(e, " in document of length ").concat(this.length));
                return this.lineInner(e, !1, 1, 0);
            }
        },
        {
            key: "line",
            value: function(e) {
                if (e < 1 || e > this.lines) throw new RangeError("Invalid line number ".concat(e, " in ").concat(this.lines, "-line document"));
                return this.lineInner(e, !0, 1, 0);
            }
        },
        {
            key: "replace",
            value: function(e, t, n) {
                var r = jo(sF(this, e, t), 2);
                e = r[0], t = r[1];
                var o = [];
                return this.decompose(0, e, o, 2), n.length && n.decompose(0, n.length, o, 3), this.decompose(t, this.length, o, 1), eF.from(o, this.length - (t - e) + n.length);
            }
        },
        {
            key: "append",
            value: function(e) {
                return this.replace(this.length, this.length, e);
            }
        },
        {
            key: "slice",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length, n = jo(sF(this, e, t), 2);
                e = n[0], t = n[1];
                var r = [];
                return this.decompose(e, t, r, 0), eF.from(r, t - e);
            }
        },
        {
            key: "eq",
            value: function(e) {
                if (e == this) return !0;
                if (e.length != this.length || e.lines != this.lines) return !1;
                for(var t = this.scanIdentical(e, 1), n = this.length - this.scanIdentical(e, -1), r = new rF(this), o = new rF(e), i = t, a = t;;){
                    if (r.next(i), o.next(i), i = 0, r.lineBreak != o.lineBreak || r.done != o.done || r.value != o.value) return !1;
                    if (a += r.value.length, r.done || a >= n) return !0;
                }
            }
        },
        {
            key: "iter",
            value: function() {
                return new rF(this, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1);
            }
        },
        {
            key: "iterRange",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length;
                return new oF(this, e, t);
            }
        },
        {
            key: "iterLines",
            value: function(e, t) {
                var n;
                if (null == e) n = this.iter();
                else {
                    null == t && (t = this.lines + 1);
                    var r = this.line(e).from;
                    n = this.iterRange(r, Math.max(r, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to));
                }
                return new iF(n);
            }
        },
        {
            key: "toString",
            value: function() {
                return this.sliceString(0);
            }
        },
        {
            key: "toJSON",
            value: function() {
                var e = [];
                return this.flatten(e), e;
            }
        }
    ], [
        {
            key: "of",
            value: function(t) {
                if (0 == t.length) throw new RangeError("A document must have at least one line");
                return 1 != t.length || t[0] ? t.length <= 32 ? new ZL(t) : eF.from(ZL.split(t, [])) : e.empty;
            }
        }
    ]), e;
}(), ZL = function(e) {
    function t(e) {
        var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(e) {
            var t, n = -1, r = bo(e);
            try {
                for(r.s(); !(t = r.n()).done;)n += t.value.length + 1;
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
            return n;
        }(e);
        return No(this, t), (n = _o(this, t)).text = e, n.length = r, n;
    }
    return Ao(t, XL), Do(t, [
        {
            key: "lines",
            get: function() {
                return this.text.length;
            }
        },
        {
            key: "children",
            get: function() {
                return null;
            }
        },
        {
            key: "lineInner",
            value: function(e, t, n, r) {
                for(var o = 0;; o++){
                    var i = this.text[o], a = r + i.length;
                    if ((t ? n : a) >= e) return new aF(r, a, n, i);
                    r = a + 1, n++;
                }
            }
        },
        {
            key: "decompose",
            value: function(e, n, r, o) {
                var i = e <= 0 && n >= this.length ? this : new t(nF(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
                if (1 & o) {
                    var a = r.pop(), s = tF(i.text, a.text.slice(), 0, i.length);
                    if (s.length <= 32) r.push(new t(s, a.length + i.length));
                    else {
                        var c = s.length >> 1;
                        r.push(new t(s.slice(0, c)), new t(s.slice(c)));
                    }
                } else r.push(i);
            }
        },
        {
            key: "replace",
            value: function(e, n, r) {
                if (!(r instanceof t)) return go(Mo(t.prototype), "replace", this).call(this, e, n, r);
                var o = jo(sF(this, e, n), 2);
                e = o[0], n = o[1];
                var i = tF(this.text, tF(r.text, nF(this.text, 0, e)), n), a = this.length + r.length - (n - e);
                return i.length <= 32 ? new t(i, a) : eF.from(t.split(i, []), a);
            }
        },
        {
            key: "sliceString",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "\n", r = jo(sF(this, e, t), 2);
                e = r[0], t = r[1];
                for(var o = "", i = 0, a = 0; i <= t && a < this.text.length; a++){
                    var s = this.text[a], c = i + s.length;
                    i > e && a && (o += n), e < c && t > i && (o += s.slice(Math.max(0, e - i), t - i)), i = c + 1;
                }
                return o;
            }
        },
        {
            key: "flatten",
            value: function(e) {
                var t, n = bo(this.text);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        e.push(r);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "scanIdentical",
            value: function() {
                return 0;
            }
        }
    ], [
        {
            key: "split",
            value: function(e, n) {
                var r, o = [], i = -1, a = bo(e);
                try {
                    for(a.s(); !(r = a.n()).done;){
                        var s = r.value;
                        o.push(s), i += s.length + 1, 32 == o.length && (n.push(new t(o, i)), o = [], i = -1);
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return i > -1 && n.push(new t(o, i)), n;
            }
        }
    ]), t;
}(), eF = function(e) {
    function t(e, n) {
        var r;
        No(this, t), (r = _o(this, t)).children = e, r.length = n, r.lines = 0;
        var o, i = bo(e);
        try {
            for(i.s(); !(o = i.n()).done;){
                var a = o.value;
                r.lines += a.lines;
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        return r;
    }
    return Ao(t, XL), Do(t, [
        {
            key: "lineInner",
            value: function(e, t, n, r) {
                for(var o = 0;; o++){
                    var i = this.children[o], a = r + i.length, s = n + i.lines - 1;
                    if ((t ? s : a) >= e) return i.lineInner(e, t, n, r);
                    r = a + 1, n = s + 1;
                }
            }
        },
        {
            key: "decompose",
            value: function(e, t, n, r) {
                for(var o = 0, i = 0; i <= t && o < this.children.length; o++){
                    var a = this.children[o], s = i + a.length;
                    if (e <= s && t >= i) {
                        var c = r & ((i <= e ? 1 : 0) | (s >= t ? 2 : 0));
                        i >= e && s <= t && !c ? n.push(a) : a.decompose(e - i, t - i, n, c);
                    }
                    i = s + 1;
                }
            }
        },
        {
            key: "replace",
            value: function(e, n, r) {
                var o = jo(sF(this, e, n), 2);
                if (e = o[0], n = o[1], r.lines < this.lines) for(var i = 0, a = 0; i < this.children.length; i++){
                    var s = this.children[i], c = a + s.length;
                    if (e >= a && n <= c) {
                        var l = s.replace(e - a, n - a, r), u = this.lines - s.lines + l.lines;
                        if (l.lines < u >> 4 && l.lines > u >> 6) {
                            var f = this.children.slice();
                            return f[i] = l, new t(f, this.length - (n - e) + r.length);
                        }
                        return go(Mo(t.prototype), "replace", this).call(this, a, c, l);
                    }
                    a = c + 1;
                }
                return go(Mo(t.prototype), "replace", this).call(this, e, n, r);
            }
        },
        {
            key: "sliceString",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "\n", r = jo(sF(this, e, t), 2);
                e = r[0], t = r[1];
                for(var o = "", i = 0, a = 0; i < this.children.length && a <= t; i++){
                    var s = this.children[i], c = a + s.length;
                    a > e && i && (o += n), e < c && t > a && (o += s.sliceString(e - a, t - a, n)), a = c + 1;
                }
                return o;
            }
        },
        {
            key: "flatten",
            value: function(e) {
                var t, n = bo(this.children);
                try {
                    for(n.s(); !(t = n.n()).done;)t.value.flatten(e);
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "scanIdentical",
            value: function(e, n) {
                if (!(e instanceof t)) return 0;
                for(var r = 0, o = jo(n > 0 ? [
                    0,
                    0,
                    this.children.length,
                    e.children.length
                ] : [
                    this.children.length - 1,
                    e.children.length - 1,
                    -1,
                    -1
                ], 4), i = o[0], a = o[1], s = o[2], c = o[3];; i += n, a += n){
                    if (i == s || a == c) return r;
                    var l = this.children[i], u = e.children[a];
                    if (l != u) return r + l.scanIdentical(u, n);
                    r += l.length + 1;
                }
            }
        }
    ], [
        {
            key: "from",
            value: function(e) {
                var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.reduce(function(e, t) {
                    return e + t.length + 1;
                }, -1), o = 0, i = bo(e);
                try {
                    for(i.s(); !(n = i.n()).done;)o += n.value.lines;
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                if (o < 32) {
                    var a, s = [], c = bo(e);
                    try {
                        for(c.s(); !(a = c.n()).done;)a.value.flatten(s);
                    } catch (e) {
                        c.e(e);
                    } finally{
                        c.f();
                    }
                    return new ZL(s, r);
                }
                var l = Math.max(32, o >> 5), u = l << 1, f = l >> 1, d = [], h = 0, v = -1, p = [];
                function m(e) {
                    var n;
                    if (e.lines > u && e instanceof t) {
                        var r, o = bo(e.children);
                        try {
                            for(o.s(); !(r = o.n()).done;)m(r.value);
                        } catch (e) {
                            o.e(e);
                        } finally{
                            o.f();
                        }
                    } else e.lines > f && (h > f || !h) ? (g(), d.push(e)) : e instanceof ZL && h && (n = p[p.length - 1]) instanceof ZL && e.lines + n.lines <= 32 ? (h += e.lines, v += e.length + 1, p[p.length - 1] = new ZL(n.text.concat(e.text), n.length + 1 + e.length)) : (h + e.lines > l && g(), h += e.lines, v += e.length + 1, p.push(e));
                }
                function g() {
                    0 != h && (d.push(1 == p.length ? p[0] : t.from(p, v)), v = -1, h = p.length = 0);
                }
                var y, b = bo(e);
                try {
                    for(b.s(); !(y = b.n()).done;)m(y.value);
                } catch (e) {
                    b.e(e);
                } finally{
                    b.f();
                }
                return g(), 1 == d.length ? d[0] : new t(d, r);
            }
        }
    ]), t;
}();
function tF(e, t) {
    for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e9, o = 0, i = 0, a = !0; i < e.length && o <= r; i++){
        var s = e[i], c = o + s.length;
        c >= n && (c > r && (s = s.slice(0, r - o)), o < n && (s = s.slice(n - o)), a ? (t[t.length - 1] += s, a = !1) : t.push(s)), o = c + 1;
    }
    return t;
}
function nF(e, t, n) {
    return tF(e, [
        ""
    ], t, n);
}
XL.empty = new ZL([
    ""
], 0);
var rF = function() {
    function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        No(this, e), this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [
            t
        ], this.offsets = [
            n > 0 ? 1 : (t instanceof ZL ? t.text.length : t.children.length) << 1
        ];
    }
    return Do(e, [
        {
            key: "nextInner",
            value: function(e, t) {
                for(this.done = this.lineBreak = !1;;){
                    var n = this.nodes.length - 1, r = this.nodes[n], o = this.offsets[n], i = o >> 1, a = r instanceof ZL ? r.text.length : r.children.length;
                    if (i == (t > 0 ? a : 0)) {
                        if (0 == n) return this.done = !0, this.value = "", this;
                        t > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop();
                    } else if ((1 & o) == (t > 0 ? 0 : 1)) {
                        if (this.offsets[n] += t, 0 == e) return this.lineBreak = !0, this.value = "\n", this;
                        e--;
                    } else if (r instanceof ZL) {
                        var s = r.text[i + (t < 0 ? -1 : 0)];
                        if (this.offsets[n] += t, s.length > Math.max(0, e)) return this.value = 0 == e ? s : t > 0 ? s.slice(e) : s.slice(0, s.length - e), this;
                        e -= s.length;
                    } else {
                        var c = r.children[i + (t < 0 ? -1 : 0)];
                        e > c.length ? (e -= c.length, this.offsets[n] += t) : (t < 0 && this.offsets[n]--, this.nodes.push(c), this.offsets.push(t > 0 ? 1 : (c instanceof ZL ? c.text.length : c.children.length) << 1));
                    }
                }
            }
        },
        {
            key: "next",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
            }
        }
    ]), e;
}(), oF = function() {
    function e(t, n, r) {
        No(this, e), this.value = "", this.done = !1, this.cursor = new rF(t, n > r ? -1 : 1), this.pos = n > r ? t.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
    }
    return Do(e, [
        {
            key: "nextInner",
            value: function(e, t) {
                if (t < 0 ? this.pos <= this.from : this.pos >= this.to) return this.value = "", this.done = !0, this;
                e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
                var n = t < 0 ? this.pos - this.from : this.to - this.pos;
                e > n && (e = n), n -= e;
                var r = this.cursor.next(e).value;
                return this.pos += (r.length + e) * t, this.value = r.length <= n ? r : t < 0 ? r.slice(r.length - n) : r.slice(0, n), this.done = !this.value, this;
            }
        },
        {
            key: "next",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
            }
        },
        {
            key: "lineBreak",
            get: function() {
                return this.cursor.lineBreak && "" != this.value;
            }
        }
    ]), e;
}(), iF = function() {
    function e(t) {
        No(this, e), this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
    }
    return Do(e, [
        {
            key: "next",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = this.inner.next(e), n = t.done, r = t.lineBreak, o = t.value;
                return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = o, this.afterBreak = !1), this;
            }
        },
        {
            key: "lineBreak",
            get: function() {
                return !1;
            }
        }
    ]), e;
}();
"undefined" != typeof Symbol && (XL.prototype[Symbol.iterator] = function() {
    return this.iter();
}, rF.prototype[Symbol.iterator] = oF.prototype[Symbol.iterator] = iF.prototype[Symbol.iterator] = function() {
    return this;
});
var aF = function() {
    function e(t, n, r, o) {
        No(this, e), this.from = t, this.to = n, this.number = r, this.text = o;
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                return this.to - this.from;
            }
        }
    ]), e;
}();
function sF(e, t, n) {
    return [
        t = Math.max(0, Math.min(e.length, t)),
        Math.max(t, Math.min(e.length, n))
    ];
}
for(var cF = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map(function(e) {
    return e ? parseInt(e, 36) : 1;
}), lF = 1; lF < cF.length; lF++)cF[lF] += cF[lF - 1];
function uF(e) {
    for(var t = 1; t < cF.length; t += 2)if (cF[t] > e) return cF[t - 1] <= e;
    return !1;
}
function fF(e) {
    return e >= 127462 && e <= 127487;
}
var dF = 8205;
function hF(e, t) {
    return (!(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? vF : pF)(e, t, !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]);
}
function vF(e, t, n) {
    if (t == e.length) return t;
    t && mF(e.charCodeAt(t)) && gF(e.charCodeAt(t - 1)) && t--;
    var r = yF(e, t);
    for(t += wF(r); t < e.length;){
        var o = yF(e, t);
        if (r == dF || o == dF || n && uF(o)) t += wF(o), r = o;
        else {
            if (!fF(o)) break;
            for(var i = 0, a = t - 2; a >= 0 && fF(yF(e, a));)i++, a -= 2;
            if (i % 2 == 0) break;
            t += 2;
        }
    }
    return t;
}
function pF(e, t, n) {
    for(; t > 0;){
        var r = vF(e, t - 2, n);
        if (r < t) return r;
        t--;
    }
    return 0;
}
function mF(e) {
    return e >= 56320 && e < 57344;
}
function gF(e) {
    return e >= 55296 && e < 56320;
}
function yF(e, t) {
    var n = e.charCodeAt(t);
    if (!gF(n) || t + 1 == e.length) return n;
    var r = e.charCodeAt(t + 1);
    return mF(r) ? r - 56320 + (n - 55296 << 10) + 65536 : n;
}
function bF(e) {
    return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
function wF(e) {
    return e < 65536 ? 1 : 2;
}
var xF = /\r\n?|\n/, kF = function(e) {
    return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
}(kF || (kF = {})), jF = function() {
    function e(t) {
        No(this, e), this.sections = t;
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                for(var e = 0, t = 0; t < this.sections.length; t += 2)e += this.sections[t];
                return e;
            }
        },
        {
            key: "newLength",
            get: function() {
                for(var e = 0, t = 0; t < this.sections.length; t += 2){
                    var n = this.sections[t + 1];
                    e += n < 0 ? this.sections[t] : n;
                }
                return e;
            }
        },
        {
            key: "empty",
            get: function() {
                return 0 == this.sections.length || 2 == this.sections.length && this.sections[1] < 0;
            }
        },
        {
            key: "iterGaps",
            value: function(e) {
                for(var t = 0, n = 0, r = 0; t < this.sections.length;){
                    var o = this.sections[t++], i = this.sections[t++];
                    i < 0 ? (e(n, r, o), r += o) : r += i, n += o;
                }
            }
        },
        {
            key: "iterChangedRanges",
            value: function(e) {
                _F(this, e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1]);
            }
        },
        {
            key: "invertedDesc",
            get: function() {
                for(var t = [], n = 0; n < this.sections.length;){
                    var r = this.sections[n++], o = this.sections[n++];
                    o < 0 ? t.push(r, o) : t.push(o, r);
                }
                return new e(t);
            }
        },
        {
            key: "composeDesc",
            value: function(e) {
                return this.empty ? e : e.empty ? this : MF(this, e);
            }
        },
        {
            key: "mapDesc",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return e.empty ? this : OF(this, e, t);
            }
        },
        {
            key: "mapPos",
            value: function(e) {
                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : kF.Simple, r = 0, o = 0, i = 0; i < this.sections.length;){
                    var a = this.sections[i++], s = this.sections[i++], c = r + a;
                    if (s < 0) {
                        if (c > e) return o + (e - r);
                        o += a;
                    } else {
                        if (n != kF.Simple && c >= e && (n == kF.TrackDel && r < e && c > e || n == kF.TrackBefore && r < e || n == kF.TrackAfter && c > e)) return null;
                        if (c > e || c == e && t < 0 && !a) return e == r || t < 0 ? o : o + s;
                        o += s;
                    }
                    r = c;
                }
                if (e > r) throw new RangeError("Position ".concat(e, " is out of range for changeset of length ").concat(r));
                return o;
            }
        },
        {
            key: "touchesRange",
            value: function(e) {
                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e, n = 0, r = 0; n < this.sections.length && r <= t;){
                    var o = r + this.sections[n++];
                    if (this.sections[n++] >= 0 && r <= t && o >= e) return !(r < e && o > t) || "cover";
                    r = o;
                }
                return !1;
            }
        },
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.sections.length;){
                    var n = this.sections[t++], r = this.sections[t++];
                    e += (e ? " " : "") + n + (r >= 0 ? ":" + r : "");
                }
                return e;
            }
        },
        {
            key: "toJSON",
            value: function() {
                return this.sections;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(t) {
                if (!Array.isArray(t) || t.length % 2 || t.some(function(e) {
                    return "number" != typeof e;
                })) throw new RangeError("Invalid JSON representation of ChangeDesc");
                return new e(t);
            }
        },
        {
            key: "create",
            value: function(t) {
                return new e(t);
            }
        }
    ]), e;
}(), SF = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t, [
            e
        ])).inserted = n, r;
    }
    return Ao(t, jF), Do(t, [
        {
            key: "apply",
            value: function(e) {
                if (this.length != e.length) throw new RangeError("Applying change set to a document with the wrong length");
                return _F(this, function(t, n, r, o, i) {
                    return e = e.replace(r, r + (n - t), i);
                }, !1), e;
            }
        },
        {
            key: "mapDesc",
            value: function(e) {
                return OF(this, e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1], !0);
            }
        },
        {
            key: "invert",
            value: function(e) {
                for(var n = this.sections.slice(), r = [], o = 0, i = 0; o < n.length; o += 2){
                    var a = n[o], s = n[o + 1];
                    if (s >= 0) {
                        n[o] = s, n[o + 1] = a;
                        for(var c = o >> 1; r.length < c;)r.push(XL.empty);
                        r.push(a ? e.slice(i, i + a) : XL.empty);
                    }
                    i += a;
                }
                return new t(n, r);
            }
        },
        {
            key: "compose",
            value: function(e) {
                return this.empty ? e : e.empty ? this : MF(this, e, !0);
            }
        },
        {
            key: "map",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return e.empty ? this : OF(this, e, t, !0);
            }
        },
        {
            key: "iterChanges",
            value: function(e) {
                _F(this, e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1]);
            }
        },
        {
            key: "desc",
            get: function() {
                return jF.create(this.sections);
            }
        },
        {
            key: "filter",
            value: function(e) {
                var n = [], r = [], o = [], i = new EF(this);
                e: for(var a = 0, s = 0;;){
                    for(var c = a == e.length ? 1e9 : e[a++]; s < c || s == c && 0 == i.len;){
                        if (i.done) break e;
                        var l = Math.min(i.len, c - s);
                        CF(o, l, -1);
                        var u = -1 == i.ins ? -1 : 0 == i.off ? i.ins : 0;
                        CF(n, l, u), u > 0 && $F(r, n, i.text), i.forward(l), s += l;
                    }
                    for(var f = e[a++]; s < f;){
                        if (i.done) break e;
                        var d = Math.min(i.len, f - s);
                        CF(n, d, -1), CF(o, d, -1 == i.ins ? -1 : 0 == i.off ? i.ins : 0), i.forward(d), s += d;
                    }
                }
                return {
                    changes: new t(n, r),
                    filtered: jF.create(o)
                };
            }
        },
        {
            key: "toJSON",
            value: function() {
                for(var e = [], t = 0; t < this.sections.length; t += 2){
                    var n = this.sections[t], r = this.sections[t + 1];
                    r < 0 ? e.push(n) : 0 == r ? e.push([
                        n
                    ]) : e.push([
                        n
                    ].concat(this.inserted[t >> 1].toJSON()));
                }
                return e;
            }
        }
    ], [
        {
            key: "of",
            value: function(e, n, r) {
                var o = [], i = [], a = 0, s = null;
                function c() {
                    if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0] || o.length) {
                        a < n && CF(o, n - a, -1);
                        var e = new t(o, i);
                        s = s ? s.compose(e.map(s)) : e, o = [], i = [], a = 0;
                    }
                }
                return function e(l) {
                    if (Array.isArray(l)) {
                        var u, f = bo(l);
                        try {
                            for(f.s(); !(u = f.n()).done;)e(u.value);
                        } catch (e) {
                            f.e(e);
                        } finally{
                            f.f();
                        }
                    } else if (l instanceof t) {
                        if (l.length != n) throw new RangeError("Mismatched change set length (got ".concat(l.length, ", expected ").concat(n, ")"));
                        c(), s = s ? s.compose(l.map(s)) : l;
                    } else {
                        var d = l.from, h = l.to, v = void 0 === h ? d : h, p = l.insert;
                        if (d > v || d < 0 || v > n) throw new RangeError("Invalid change range ".concat(d, " to ").concat(v, " (in doc of length ").concat(n, ")"));
                        var m = p ? "string" == typeof p ? XL.of(p.split(r || xF)) : p : XL.empty, g = m.length;
                        if (d == v && 0 == g) return;
                        d < a && c(), d > a && CF(o, d - a, -1), CF(o, v - d, g), $F(i, o, m), a = v;
                    }
                }(e), c(!s), s;
            }
        },
        {
            key: "empty",
            value: function(e) {
                return new t(e ? [
                    e,
                    -1
                ] : [], []);
            }
        },
        {
            key: "fromJSON",
            value: function(e) {
                if (!Array.isArray(e)) throw new RangeError("Invalid JSON representation of ChangeSet");
                for(var n = [], r = [], o = 0; o < e.length; o++){
                    var i = e[o];
                    if ("number" == typeof i) n.push(i, -1);
                    else {
                        if (!Array.isArray(i) || "number" != typeof i[0] || i.some(function(e, t) {
                            return t && "string" != typeof e;
                        })) throw new RangeError("Invalid JSON representation of ChangeSet");
                        if (1 == i.length) n.push(i[0], 0);
                        else {
                            for(; r.length < o;)r.push(XL.empty);
                            r[o] = XL.of(i.slice(1)), n.push(i[0], r[o].length);
                        }
                    }
                }
                return new t(n, r);
            }
        },
        {
            key: "createSet",
            value: function(e, n) {
                return new t(e, n);
            }
        }
    ]), t;
}();
function CF(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (!(0 == t && n <= 0)) {
        var o = e.length - 2;
        o >= 0 && n <= 0 && n == e[o + 1] ? e[o] += t : 0 == t && 0 == e[o] ? e[o + 1] += n : r ? (e[o] += t, e[o + 1] += n) : e.push(t, n);
    }
}
function $F(e, t, n) {
    if (0 != n.length) {
        var r = t.length - 2 >> 1;
        if (r < e.length) e[e.length - 1] = e[e.length - 1].append(n);
        else {
            for(; e.length < r;)e.push(XL.empty);
            e.push(n);
        }
    }
}
function _F(e, t, n) {
    for(var r = e.inserted, o = 0, i = 0, a = 0; a < e.sections.length;){
        var s = e.sections[a++], c = e.sections[a++];
        if (c < 0) o += s, i += s;
        else {
            for(var l = o, u = i, f = XL.empty; l += s, u += c, c && r && (f = f.append(r[a - 2 >> 1])), !(n || a == e.sections.length || e.sections[a + 1] < 0);)s = e.sections[a++], c = e.sections[a++];
            t(o, l, i, u, f), o = l, i = u;
        }
    }
}
function OF(e, t, n) {
    for(var r = [], o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? [] : null, i = new EF(e), a = new EF(t), s = -1;;)if (-1 == i.ins && -1 == a.ins) {
        var c = Math.min(i.len, a.len);
        CF(r, c, -1), i.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (i.ins < 0 || s == i.i || 0 == i.off && (a.len < i.len || a.len == i.len && !n))) {
        var l = a.len;
        for(CF(r, a.ins, -1); l;){
            var u = Math.min(i.len, l);
            i.ins >= 0 && s < i.i && i.len <= u && (CF(r, 0, i.ins), o && $F(o, r, i.text), s = i.i), i.forward(u), l -= u;
        }
        a.next();
    } else {
        if (!(i.ins >= 0)) {
            if (i.done && a.done) return o ? SF.createSet(r, o) : jF.create(r);
            throw new Error("Mismatched change set lengths");
        }
        for(var f = 0, d = i.len; d;)if (-1 == a.ins) {
            var h = Math.min(d, a.len);
            f += h, d -= h, a.forward(h);
        } else {
            if (!(0 == a.ins && a.len < d)) break;
            d -= a.len, a.next();
        }
        CF(r, f, s < i.i ? i.ins : 0), o && s < i.i && $F(o, r, i.text), s = i.i, i.forward(i.len - d);
    }
}
function MF(e, t) {
    for(var n = [], r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? [] : null, o = new EF(e), i = new EF(t), a = !1;;){
        if (o.done && i.done) return r ? SF.createSet(n, r) : jF.create(n);
        if (0 == o.ins) CF(n, o.len, 0, a), o.next();
        else if (0 != i.len || i.done) {
            if (o.done || i.done) throw new Error("Mismatched change set lengths");
            var s = Math.min(o.len2, i.len), c = n.length;
            if (-1 == o.ins) {
                var l = -1 == i.ins ? -1 : i.off ? 0 : i.ins;
                CF(n, s, l, a), r && l && $F(r, n, i.text);
            } else -1 == i.ins ? (CF(n, o.off ? 0 : o.len, s, a), r && $F(r, n, o.textBit(s))) : (CF(n, o.off ? 0 : o.len, i.off ? 0 : i.ins, a), r && !i.off && $F(r, n, i.text));
            a = (o.ins > s || i.ins >= 0 && i.len > s) && (a || n.length > c), o.forward2(s), i.forward(s);
        } else CF(n, 0, i.ins, a), r && $F(r, n, i.text), i.next();
    }
}
var EF = function() {
    function e(t) {
        No(this, e), this.set = t, this.i = 0, this.next();
    }
    return Do(e, [
        {
            key: "next",
            value: function() {
                var e = this.set.sections;
                this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
            }
        },
        {
            key: "done",
            get: function() {
                return -2 == this.ins;
            }
        },
        {
            key: "len2",
            get: function() {
                return this.ins < 0 ? this.len : this.ins;
            }
        },
        {
            key: "text",
            get: function() {
                var e = this.set.inserted, t = this.i - 2 >> 1;
                return t >= e.length ? XL.empty : e[t];
            }
        },
        {
            key: "textBit",
            value: function(e) {
                var t = this.set.inserted, n = this.i - 2 >> 1;
                return n >= t.length && !e ? XL.empty : t[n].slice(this.off, null == e ? void 0 : this.off + e);
            }
        },
        {
            key: "forward",
            value: function(e) {
                e == this.len ? this.next() : (this.len -= e, this.off += e);
            }
        },
        {
            key: "forward2",
            value: function(e) {
                -1 == this.ins ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
            }
        }
    ]), e;
}(), AF = function() {
    function e(t, n, r) {
        No(this, e), this.from = t, this.to = n, this.flags = r;
    }
    return Do(e, [
        {
            key: "anchor",
            get: function() {
                return 32 & this.flags ? this.to : this.from;
            }
        },
        {
            key: "head",
            get: function() {
                return 32 & this.flags ? this.from : this.to;
            }
        },
        {
            key: "empty",
            get: function() {
                return this.from == this.to;
            }
        },
        {
            key: "assoc",
            get: function() {
                return 8 & this.flags ? -1 : 16 & this.flags ? 1 : 0;
            }
        },
        {
            key: "bidiLevel",
            get: function() {
                var e = 7 & this.flags;
                return 7 == e ? null : e;
            }
        },
        {
            key: "goalColumn",
            get: function() {
                var e = this.flags >> 6;
                return 16777215 == e ? void 0 : e;
            }
        },
        {
            key: "map",
            value: function(t) {
                var n, r, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                return this.empty ? n = r = t.mapPos(this.from, o) : (n = t.mapPos(this.from, 1), r = t.mapPos(this.to, -1)), n == this.from && r == this.to ? this : new e(n, r, this.flags);
            }
        },
        {
            key: "extend",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                if (e <= this.anchor && t >= this.anchor) return PF.range(e, t);
                var n = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
                return PF.range(this.anchor, n);
            }
        },
        {
            key: "eq",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return !(this.anchor != e.anchor || this.head != e.head || t && this.empty && this.assoc != e.assoc);
            }
        },
        {
            key: "toJSON",
            value: function() {
                return {
                    anchor: this.anchor,
                    head: this.head
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(e) {
                if (!e || "number" != typeof e.anchor || "number" != typeof e.head) throw new RangeError("Invalid JSON representation for SelectionRange");
                return PF.range(e.anchor, e.head);
            }
        },
        {
            key: "create",
            value: function(t, n, r) {
                return new e(t, n, r);
            }
        }
    ]), e;
}(), PF = function() {
    function e(t, n) {
        No(this, e), this.ranges = t, this.mainIndex = n;
    }
    return Do(e, [
        {
            key: "map",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                return t.empty ? this : e.create(this.ranges.map(function(e) {
                    return e.map(t, n);
                }), this.mainIndex);
            }
        },
        {
            key: "eq",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex) return !1;
                for(var n = 0; n < this.ranges.length; n++)if (!this.ranges[n].eq(e.ranges[n], t)) return !1;
                return !0;
            }
        },
        {
            key: "main",
            get: function() {
                return this.ranges[this.mainIndex];
            }
        },
        {
            key: "asSingle",
            value: function() {
                return 1 == this.ranges.length ? this : new e([
                    this.main
                ], 0);
            }
        },
        {
            key: "addRange",
            value: function(t) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return e.create([
                    t
                ].concat(this.ranges), n ? 0 : this.mainIndex + 1);
            }
        },
        {
            key: "replaceRange",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.mainIndex, r = this.ranges.slice();
                return r[n] = t, e.create(r, this.mainIndex);
            }
        },
        {
            key: "toJSON",
            value: function() {
                return {
                    ranges: this.ranges.map(function(e) {
                        return e.toJSON();
                    }),
                    main: this.mainIndex
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(t) {
                if (!t || !Array.isArray(t.ranges) || "number" != typeof t.main || t.main >= t.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
                return new e(t.ranges.map(function(e) {
                    return AF.fromJSON(e);
                }), t.main);
            }
        },
        {
            key: "single",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                return new e([
                    e.range(t, n)
                ], 0);
            }
        },
        {
            key: "create",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                if (0 == t.length) throw new RangeError("A selection needs at least one range");
                for(var r = 0, o = 0; o < t.length; o++){
                    var i = t[o];
                    if (i.empty ? i.from <= r : i.from < r) return e.normalized(t.slice(), n);
                    r = i.to;
                }
                return new e(t, n);
            }
        },
        {
            key: "cursor",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0;
                return AF.create(e, e, (0 == t ? 0 : t < 0 ? 8 : 16) | (null == n ? 7 : Math.min(6, n)) | (null != r ? r : 16777215) << 6);
            }
        },
        {
            key: "range",
            value: function(e, t, n, r) {
                var o = (null != n ? n : 16777215) << 6 | (null == r ? 7 : Math.min(6, r));
                return t < e ? AF.create(t, e, 48 | o) : AF.create(e, t, (t > e ? 8 : 0) | o);
            }
        },
        {
            key: "normalized",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r = t[n];
                t.sort(function(e, t) {
                    return e.from - t.from;
                }), n = t.indexOf(r);
                for(var o = 1; o < t.length; o++){
                    var i = t[o], a = t[o - 1];
                    if (i.empty ? i.from <= a.to : i.from < a.to) {
                        var s = a.from, c = Math.max(i.to, a.to);
                        o <= n && n--, t.splice(--o, 2, i.anchor > i.head ? e.range(c, s) : e.range(s, c));
                    }
                }
                return new e(t, n);
            }
        }
    ]), e;
}();
function TF(e, t) {
    var n, r = bo(e.ranges);
    try {
        for(r.s(); !(n = r.n()).done;){
            if (n.value.to > t) throw new RangeError("Selection points outside of document");
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
}
var RF = 0, NF = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.combine = t, this.compareInput = n, this.compare = r, this.isStatic = o, this.id = RF++, this.default = t([]), this.extensions = "function" == typeof i ? i(this) : i;
    }
    return Do(e, [
        {
            key: "reader",
            get: function() {
                return this;
            }
        },
        {
            key: "of",
            value: function(e) {
                return new DF([], this, 0, e);
            }
        },
        {
            key: "compute",
            value: function(e, t) {
                if (this.isStatic) throw new Error("Can't compute a static facet");
                return new DF(e, this, 1, t);
            }
        },
        {
            key: "computeN",
            value: function(e, t) {
                if (this.isStatic) throw new Error("Can't compute a static facet");
                return new DF(e, this, 2, t);
            }
        },
        {
            key: "from",
            value: function(e, t) {
                return t || (t = function(e) {
                    return e;
                }), this.compute([
                    e
                ], function(n) {
                    return t(n.field(e));
                });
            }
        }
    ], [
        {
            key: "define",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new e(t.combine || function(e) {
                    return e;
                }, t.compareInput || function(e, t) {
                    return e === t;
                }, t.compare || (t.combine ? function(e, t) {
                    return e === t;
                } : IF), !!t.static, t.enables);
            }
        }
    ]), e;
}();
function IF(e, t) {
    return e == t || e.length == t.length && e.every(function(e, n) {
        return e === t[n];
    });
}
var DF = function() {
    function e(t, n, r, o) {
        No(this, e), this.dependencies = t, this.facet = n, this.type = r, this.value = o, this.id = RF++;
    }
    return Do(e, [
        {
            key: "dynamicSlot",
            value: function(e) {
                var t, n, r = this, o = this.value, i = this.facet.compareInput, a = this.id, s = e[a] >> 1, c = 2 == this.type, l = !1, u = !1, f = [], d = bo(this.dependencies);
                try {
                    for(d.s(); !(n = d.n()).done;){
                        var h = n.value;
                        "doc" == h ? l = !0 : "selection" == h ? u = !0 : 0 == (1 & (null !== (t = e[h.id]) && void 0 !== t ? t : 1)) && f.push(e[h.id]);
                    }
                } catch (e) {
                    d.e(e);
                } finally{
                    d.f();
                }
                return {
                    create: function(e) {
                        return e.values[s] = o(e), 1;
                    },
                    update: function(e, t) {
                        if (l && t.docChanged || u && (t.docChanged || t.selection) || qF(e, f)) {
                            var n = o(e);
                            if (c ? !zF(n, e.values[s], i) : !i(n, e.values[s])) return e.values[s] = n, 1;
                        }
                        return 0;
                    },
                    reconfigure: function(e, t) {
                        var n, l = t.config.address[a];
                        if (null != l) {
                            var u = ZF(t, l);
                            if (r.dependencies.every(function(n) {
                                return n instanceof NF ? t.facet(n) === e.facet(n) : !(n instanceof LF) || t.field(n, !1) == e.field(n, !1);
                            }) || (c ? zF(n = o(e), u, i) : i(n = o(e), u))) return e.values[s] = u, 0;
                        } else n = o(e);
                        return e.values[s] = n, 1;
                    }
                };
            }
        }
    ]), e;
}();
function zF(e, t, n) {
    if (e.length != t.length) return !1;
    for(var r = 0; r < e.length; r++)if (!n(e[r], t[r])) return !1;
    return !0;
}
function qF(e, t) {
    var n, r = !1, o = bo(t);
    try {
        for(o.s(); !(n = o.n()).done;)1 & XF(e, n.value) && (r = !0);
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return r;
}
var BF = NF.define({
    static: !0
}), LF = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.id = t, this.createF = n, this.updateF = r, this.compareF = o, this.spec = i, this.provides = void 0;
    }
    return Do(e, [
        {
            key: "create",
            value: function(e) {
                var t = this, n = e.facet(BF).find(function(e) {
                    return e.field == t;
                });
                return ((null == n ? void 0 : n.create) || this.createF)(e);
            }
        },
        {
            key: "slot",
            value: function(e) {
                var t = this, n = e[this.id] >> 1;
                return {
                    create: function(e) {
                        return e.values[n] = t.create(e), 1;
                    },
                    update: function(e, r) {
                        var o = e.values[n], i = t.updateF(o, r);
                        return t.compareF(o, i) ? 0 : (e.values[n] = i, 1);
                    },
                    reconfigure: function(e, r) {
                        return null != r.config.address[t.id] ? (e.values[n] = r.field(t), 0) : (e.values[n] = t.create(e), 1);
                    }
                };
            }
        },
        {
            key: "init",
            value: function(e) {
                return [
                    this,
                    BF.of({
                        field: this,
                        create: e
                    })
                ];
            }
        },
        {
            key: "extension",
            get: function() {
                return this;
            }
        }
    ], [
        {
            key: "define",
            value: function(t) {
                var n = new e(RF++, t.create, t.update, t.compare || function(e, t) {
                    return e === t;
                }, t);
                return t.provide && (n.provides = t.provide(n)), n;
            }
        }
    ]), e;
}(), FF = 4, VF = 3, HF = 2, WF = 1;
function UF(e) {
    return function(t) {
        return new KF(t, e);
    };
}
var JF = {
    highest: UF(0),
    high: UF(WF),
    default: UF(HF),
    low: UF(VF),
    lowest: UF(FF)
}, KF = Do(function e(t, n) {
    No(this, e), this.inner = t, this.prec = n;
}), GF = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "of",
            value: function(e) {
                return new QF(this, e);
            }
        },
        {
            key: "reconfigure",
            value: function(t) {
                return e.reconfigure.of({
                    compartment: this,
                    extension: t
                });
            }
        },
        {
            key: "get",
            value: function(e) {
                return e.config.compartments.get(this);
            }
        }
    ]), e;
}(), QF = Do(function e(t, n) {
    No(this, e), this.compartment = t, this.inner = n;
}), YF = function() {
    function e(t, n, r, o, i, a) {
        for(No(this, e), this.base = t, this.compartments = n, this.dynamicSlots = r, this.address = o, this.staticValues = i, this.facets = a, this.statusTemplate = []; this.statusTemplate.length < r.length;)this.statusTemplate.push(0);
    }
    return Do(e, [
        {
            key: "staticFacet",
            value: function(e) {
                var t = this.address[e.id];
                return null == t ? e.default : this.staticValues[t >> 1];
            }
        }
    ], [
        {
            key: "resolve",
            value: function(t, n, r) {
                var o, i = [], a = Object.create(null), s = new Map, c = bo(function(e, t, n) {
                    var r = [
                        [],
                        [],
                        [],
                        [],
                        []
                    ], o = new Map;
                    function i(e, a) {
                        var s = o.get(e);
                        if (null != s) {
                            if (s <= a) return;
                            var c = r[s].indexOf(e);
                            c > -1 && r[s].splice(c, 1), e instanceof QF && n.delete(e.compartment);
                        }
                        if (o.set(e, a), Array.isArray(e)) {
                            var l, u = bo(e);
                            try {
                                for(u.s(); !(l = u.n()).done;)i(l.value, a);
                            } catch (e) {
                                u.e(e);
                            } finally{
                                u.f();
                            }
                        } else if (e instanceof QF) {
                            if (n.has(e.compartment)) throw new RangeError("Duplicate use of compartment in extensions");
                            var f = t.get(e.compartment) || e.inner;
                            n.set(e.compartment, f), i(f, a);
                        } else if (e instanceof KF) i(e.inner, e.prec);
                        else if (e instanceof LF) r[a].push(e), e.provides && i(e.provides, a);
                        else if (e instanceof DF) r[a].push(e), e.facet.extensions && i(e.facet.extensions, HF);
                        else {
                            var d = e.extension;
                            if (!d) throw new Error("Unrecognized extension value in extension set (".concat(e, "). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks."));
                            i(d, a);
                        }
                    }
                    return i(e, HF), r.reduce(function(e, t) {
                        return e.concat(t);
                    });
                }(t, n, s));
                try {
                    for(c.s(); !(o = c.n()).done;){
                        var l = o.value;
                        l instanceof LF ? i.push(l) : (a[l.facet.id] || (a[l.facet.id] = [])).push(l);
                    }
                } catch (e) {
                    c.e(e);
                } finally{
                    c.f();
                }
                for(var u = Object.create(null), f = [], d = [], h = function() {
                    var e = p[v];
                    u[e.id] = d.length << 1, d.push(function(t) {
                        return e.slot(t);
                    });
                }, v = 0, p = i; v < p.length; v++)h();
                var m = null == r ? void 0 : r.config.facets, g = function() {
                    var e = a[y], t = e[0].facet, n = m && m[y] || [];
                    if (e.every(function(e) {
                        return 0 == e.type;
                    })) {
                        if (u[t.id] = f.length << 1 | 1, IF(n, e)) f.push(r.facet(t));
                        else {
                            var o = t.combine(e.map(function(e) {
                                return e.value;
                            }));
                            f.push(r && t.compare(o, r.facet(t)) ? r.facet(t) : o);
                        }
                    } else {
                        var i, s = bo(e);
                        try {
                            var c = function() {
                                var e = i.value;
                                0 == e.type ? (u[e.id] = f.length << 1 | 1, f.push(e.value)) : (u[e.id] = d.length << 1, d.push(function(t) {
                                    return e.dynamicSlot(t);
                                }));
                            };
                            for(s.s(); !(i = s.n()).done;)c();
                        } catch (e) {
                            s.e(e);
                        } finally{
                            s.f();
                        }
                        u[t.id] = d.length << 1, d.push(function(n) {
                            return function(e, t, n) {
                                var r = n.map(function(t) {
                                    return e[t.id];
                                }), o = n.map(function(e) {
                                    return e.type;
                                }), i = r.filter(function(e) {
                                    return !(1 & e);
                                }), a = e[t.id] >> 1;
                                function s(e) {
                                    for(var n = [], i = 0; i < r.length; i++){
                                        var a = ZF(e, r[i]);
                                        if (2 == o[i]) {
                                            var s, c = bo(a);
                                            try {
                                                for(c.s(); !(s = c.n()).done;){
                                                    var l = s.value;
                                                    n.push(l);
                                                }
                                            } catch (e) {
                                                c.e(e);
                                            } finally{
                                                c.f();
                                            }
                                        } else n.push(a);
                                    }
                                    return t.combine(n);
                                }
                                return {
                                    create: function(e) {
                                        var t, n = bo(r);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)XF(e, t.value);
                                        } catch (e) {
                                            n.e(e);
                                        } finally{
                                            n.f();
                                        }
                                        return e.values[a] = s(e), 1;
                                    },
                                    update: function(e, n) {
                                        if (!qF(e, i)) return 0;
                                        var r = s(e);
                                        return t.compare(r, e.values[a]) ? 0 : (e.values[a] = r, 1);
                                    },
                                    reconfigure: function(e, o) {
                                        var i = qF(e, r), c = o.config.facets[t.id], l = o.facet(t);
                                        if (c && !i && IF(n, c)) return e.values[a] = l, 0;
                                        var u = s(e);
                                        return t.compare(u, l) ? (e.values[a] = l, 0) : (e.values[a] = u, 1);
                                    }
                                };
                            }(n, t, e);
                        });
                    }
                };
                for(var y in a)g();
                return new e(t, s, d.map(function(e) {
                    return e(u);
                }), u, f, a);
            }
        }
    ]), e;
}();
function XF(e, t) {
    if (1 & t) return 2;
    var n = t >> 1, r = e.status[n];
    if (4 == r) throw new Error("Cyclic dependency between fields and/or facets");
    if (2 & r) return r;
    e.status[n] = 4;
    var o = e.computeSlot(e, e.config.dynamicSlots[n]);
    return e.status[n] = 2 | o;
}
function ZF(e, t) {
    return 1 & t ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
var eV = NF.define(), tV = NF.define({
    combine: function(e) {
        return e.some(function(e) {
            return e;
        });
    },
    static: !0
}), nV = NF.define({
    combine: function(e) {
        return e.length ? e[0] : void 0;
    },
    static: !0
}), rV = NF.define(), oV = NF.define(), iV = NF.define(), aV = NF.define({
    combine: function(e) {
        return !!e.length && e[0];
    }
}), sV = function() {
    function e(t, n) {
        No(this, e), this.type = t, this.value = n;
    }
    return Do(e, null, [
        {
            key: "define",
            value: function() {
                return new cV;
            }
        }
    ]), e;
}(), cV = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "of",
            value: function(e) {
                return new sV(this, e);
            }
        }
    ]), e;
}(), lV = function() {
    function e(t) {
        No(this, e), this.map = t;
    }
    return Do(e, [
        {
            key: "of",
            value: function(e) {
                return new uV(this, e);
            }
        }
    ]), e;
}(), uV = function() {
    function e(t, n) {
        No(this, e), this.type = t, this.value = n;
    }
    return Do(e, [
        {
            key: "map",
            value: function(t) {
                var n = this.type.map(this.value, t);
                return void 0 === n ? void 0 : n == this.value ? this : new e(this.type, n);
            }
        },
        {
            key: "is",
            value: function(e) {
                return this.type == e;
            }
        }
    ], [
        {
            key: "define",
            value: function() {
                return new lV((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).map || function(e) {
                    return e;
                });
            }
        },
        {
            key: "mapEffects",
            value: function(e, t) {
                if (!e.length) return e;
                var n, r = [], o = bo(e);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i = n.value.map(t);
                        i && r.push(i);
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return r;
            }
        }
    ]), e;
}();
uV.reconfigure = uV.define(), uV.appendConfig = uV.define();
var fV = function() {
    function e(t, n, r, o, i, a) {
        No(this, e), this.startState = t, this.changes = n, this.selection = r, this.effects = o, this.annotations = i, this.scrollIntoView = a, this._doc = null, this._state = null, r && TF(r, n.newLength), i.some(function(t) {
            return t.type == e.time;
        }) || (this.annotations = i.concat(e.time.of(Date.now())));
    }
    return Do(e, [
        {
            key: "newDoc",
            get: function() {
                return this._doc || (this._doc = this.changes.apply(this.startState.doc));
            }
        },
        {
            key: "newSelection",
            get: function() {
                return this.selection || this.startState.selection.map(this.changes);
            }
        },
        {
            key: "state",
            get: function() {
                return this._state || this.startState.applyTransaction(this), this._state;
            }
        },
        {
            key: "annotation",
            value: function(e) {
                var t, n = bo(this.annotations);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        if (r.type == e) return r.value;
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "docChanged",
            get: function() {
                return !this.changes.empty;
            }
        },
        {
            key: "reconfigured",
            get: function() {
                return this.startState.config != this.state.config;
            }
        },
        {
            key: "isUserEvent",
            value: function(t) {
                var n = this.annotation(e.userEvent);
                return !(!n || !(n == t || n.length > t.length && n.slice(0, t.length) == t && "." == n[t.length]));
            }
        }
    ], [
        {
            key: "create",
            value: function(t, n, r, o, i, a) {
                return new e(t, n, r, o, i, a);
            }
        }
    ]), e;
}();
function dV(e, t) {
    for(var n = [], r = 0, o = 0;;){
        var i = void 0, a = void 0;
        if (r < e.length && (o == t.length || t[o] >= e[r])) i = e[r++], a = e[r++];
        else {
            if (!(o < t.length)) return n;
            i = t[o++], a = t[o++];
        }
        !n.length || n[n.length - 1] < i ? n.push(i, a) : n[n.length - 1] < a && (n[n.length - 1] = a);
    }
}
function hV(e, t, n) {
    var r, o, i, a;
    return n ? (o = t.changes, i = SF.empty(t.changes.length), a = e.changes.compose(t.changes)) : (o = t.changes.map(e.changes), i = e.changes.mapDesc(t.changes, !0), a = e.changes.compose(o)), {
        changes: a,
        selection: t.selection ? t.selection.map(i) : null === (r = e.selection) || void 0 === r ? void 0 : r.map(o),
        effects: uV.mapEffects(e.effects, o).concat(uV.mapEffects(t.effects, i)),
        annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
        scrollIntoView: e.scrollIntoView || t.scrollIntoView
    };
}
function vV(e, t, n) {
    var r = t.selection, o = gV(t.annotations);
    return t.userEvent && (o = o.concat(fV.userEvent.of(t.userEvent))), {
        changes: t.changes instanceof SF ? t.changes : SF.of(t.changes || [], n, e.facet(nV)),
        selection: r && (r instanceof PF ? r : PF.single(r.anchor, r.head)),
        effects: gV(t.effects),
        annotations: o,
        scrollIntoView: !!t.scrollIntoView
    };
}
function pV(e, t, n) {
    var r = vV(e, t.length ? t[0] : {}, e.doc.length);
    t.length && !1 === t[0].filter && (n = !1);
    for(var o = 1; o < t.length; o++){
        !1 === t[o].filter && (n = !1);
        var i = !!t[o].sequential;
        r = hV(r, vV(e, t[o], i ? r.changes.newLength : e.doc.length), i);
    }
    var a = fV.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
    return function(e) {
        for(var t = e.startState, n = t.facet(iV), r = e, o = n.length - 1; o >= 0; o--){
            var i = n[o](e);
            i && Object.keys(i).length && (r = hV(r, vV(t, i, e.changes.newLength), !0));
        }
        return r == e ? e : fV.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
    }(n ? function(e) {
        var t, n = e.startState, r = !0, o = bo(n.facet(rV));
        try {
            for(o.s(); !(t = o.n()).done;){
                var i = (0, t.value)(e);
                if (!1 === i) {
                    r = !1;
                    break;
                }
                Array.isArray(i) && (r = !0 === r ? i : dV(r, i));
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        if (!0 !== r) {
            var a, s;
            if (!1 === r) s = e.changes.invertedDesc, a = SF.empty(n.doc.length);
            else {
                var c = e.changes.filter(r);
                a = c.changes, s = c.filtered.mapDesc(c.changes).invertedDesc;
            }
            e = fV.create(n, a, e.selection && e.selection.map(s), uV.mapEffects(e.effects, s), e.annotations, e.scrollIntoView);
        }
        for(var l = n.facet(oV), u = l.length - 1; u >= 0; u--){
            var f = l[u](e);
            e = f instanceof fV ? f : Array.isArray(f) && 1 == f.length && f[0] instanceof fV ? f[0] : pV(n, gV(f), !1);
        }
        return e;
    }(a) : a);
}
fV.time = sV.define(), fV.userEvent = sV.define(), fV.addToHistory = sV.define(), fV.remote = sV.define();
var mV = [];
function gV(e) {
    return null == e ? mV : Array.isArray(e) ? e : [
        e
    ];
}
var yV, bV = function(e) {
    return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
}(bV || (bV = {})), wV = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
try {
    yV = new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (E_) {}
function xV(e) {
    return function(t) {
        if (!/\S/.test(t)) return bV.Space;
        if (function(e) {
            if (yV) return yV.test(e);
            for(var t = 0; t < e.length; t++){
                var n = e[t];
                if (/\w/.test(n) || n > "\x80" && (n.toUpperCase() != n.toLowerCase() || wV.test(n))) return !0;
            }
            return !1;
        }(t)) return bV.Word;
        for(var n = 0; n < e.length; n++)if (t.indexOf(e[n]) > -1) return bV.Word;
        return bV.Other;
    };
}
var kV = function() {
    function e(t, n, r, o, i, a) {
        No(this, e), this.config = t, this.doc = n, this.selection = r, this.values = o, this.status = t.statusTemplate.slice(), this.computeSlot = i, a && (a._state = this);
        for(var s = 0; s < this.config.dynamicSlots.length; s++)XF(this, s << 1);
        this.computeSlot = null;
    }
    return Do(e, [
        {
            key: "field",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = this.config.address[e.id];
                if (null != n) return XF(this, n), ZF(this, n);
                if (t) throw new RangeError("Field is not present in this state");
            }
        },
        {
            key: "update",
            value: function() {
                for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                return pV(this, t, !0);
            }
        },
        {
            key: "applyTransaction",
            value: function(t) {
                var n, r, o = this, i = this.config, a = i, s = a.base, c = a.compartments, l = bo(t.effects);
                try {
                    for(l.s(); !(n = l.n()).done;){
                        var u = n.value;
                        u.is(GF.reconfigure) ? (i && (c = new Map, i.compartments.forEach(function(e, t) {
                            return c.set(t, e);
                        }), i = null), c.set(u.value.compartment, u.value.extension)) : u.is(uV.reconfigure) ? (i = null, s = u.value) : u.is(uV.appendConfig) && (i = null, s = gV(s).concat(u.value));
                    }
                } catch (e) {
                    l.e(e);
                } finally{
                    l.f();
                }
                i ? r = t.startState.values.slice() : r = new e(i = YF.resolve(s, c, this), this.doc, this.selection, i.dynamicSlots.map(function() {
                    return null;
                }), function(e, t) {
                    return t.reconfigure(e, o);
                }, null).values;
                var f = t.startState.facet(tV) ? t.newSelection : t.newSelection.asSingle();
                new e(i, t.newDoc, f, r, function(e, n) {
                    return n.update(e, t);
                }, t);
            }
        },
        {
            key: "replaceSelection",
            value: function(e) {
                return "string" == typeof e && (e = this.toText(e)), this.changeByRange(function(t) {
                    return {
                        changes: {
                            from: t.from,
                            to: t.to,
                            insert: e
                        },
                        range: PF.cursor(t.from + e.length)
                    };
                });
            }
        },
        {
            key: "changeByRange",
            value: function(e) {
                for(var t = this.selection, n = e(t.ranges[0]), r = this.changes(n.changes), o = [
                    n.range
                ], i = gV(n.effects), a = 1; a < t.ranges.length; a++){
                    for(var s = e(t.ranges[a]), c = this.changes(s.changes), l = c.map(r), u = 0; u < a; u++)o[u] = o[u].map(l);
                    var f = r.mapDesc(c, !0);
                    o.push(s.range.map(f)), r = r.compose(l), i = uV.mapEffects(i, l).concat(uV.mapEffects(gV(s.effects), f));
                }
                return {
                    changes: r,
                    selection: PF.create(o, t.mainIndex),
                    effects: i
                };
            }
        },
        {
            key: "changes",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                return t instanceof SF ? t : SF.of(t, this.doc.length, this.facet(e.lineSeparator));
            }
        },
        {
            key: "toText",
            value: function(t) {
                return XL.of(t.split(this.facet(e.lineSeparator) || xF));
            }
        },
        {
            key: "sliceDoc",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.doc.length;
                return this.doc.sliceString(e, t, this.lineBreak);
            }
        },
        {
            key: "facet",
            value: function(e) {
                var t = this.config.address[e.id];
                return null == t ? e.default : (XF(this, t), ZF(this, t));
            }
        },
        {
            key: "toJSON",
            value: function(e) {
                var t = {
                    doc: this.sliceDoc(),
                    selection: this.selection.toJSON()
                };
                if (e) for(var n in e){
                    var r = e[n];
                    r instanceof LF && null != this.config.address[r.id] && (t[n] = r.spec.toJSON(this.field(e[n]), this));
                }
                return t;
            }
        },
        {
            key: "tabSize",
            get: function() {
                return this.facet(e.tabSize);
            }
        },
        {
            key: "lineBreak",
            get: function() {
                return this.facet(e.lineSeparator) || "\n";
            }
        },
        {
            key: "readOnly",
            get: function() {
                return this.facet(aV);
            }
        },
        {
            key: "phrase",
            value: function(t) {
                for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                var i, a = bo(this.facet(e.phrases));
                try {
                    for(a.s(); !(i = a.n()).done;){
                        var s = i.value;
                        if (Object.prototype.hasOwnProperty.call(s, t)) {
                            t = s[t];
                            break;
                        }
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return r.length && (t = t.replace(/\$(\$|\d*)/g, function(e, t) {
                    if ("$" == t) return "$";
                    var n = +(t || 1);
                    return !n || n > r.length ? e : r[n - 1];
                })), t;
            }
        },
        {
            key: "languageDataAt",
            value: function(e, t) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1, o = [], i = bo(this.facet(eV));
                try {
                    for(i.s(); !(n = i.n()).done;){
                        var a, s = bo((0, n.value)(this, t, r));
                        try {
                            for(s.s(); !(a = s.n()).done;){
                                var c = a.value;
                                Object.prototype.hasOwnProperty.call(c, e) && o.push(c[e]);
                            }
                        } catch (e) {
                            s.e(e);
                        } finally{
                            s.f();
                        }
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return o;
            }
        },
        {
            key: "charCategorizer",
            value: function(e) {
                return xV(this.languageDataAt("wordChars", e).join(""));
            }
        },
        {
            key: "wordAt",
            value: function(e) {
                for(var t = this.doc.lineAt(e), n = t.text, r = t.from, o = t.length, i = this.charCategorizer(e), a = e - r, s = e - r; a > 0;){
                    var c = hF(n, a, !1);
                    if (i(n.slice(c, a)) != bV.Word) break;
                    a = c;
                }
                for(; s < o;){
                    var l = hF(n, s);
                    if (i(n.slice(s, l)) != bV.Word) break;
                    s = l;
                }
                return a == s ? null : PF.range(a + r, s + r);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
                if (!t || "string" != typeof t.doc) throw new RangeError("Invalid JSON representation for EditorState");
                var o = [];
                if (r) {
                    var i = function() {
                        if (Object.prototype.hasOwnProperty.call(t, a)) {
                            var e = r[a], n = t[a];
                            o.push(e.init(function(t) {
                                return e.spec.fromJSON(n, t);
                            }));
                        }
                    };
                    for(var a in r)i();
                }
                return e.create({
                    doc: t.doc,
                    selection: PF.fromJSON(t.selection),
                    extensions: n.extensions ? o.concat([
                        n.extensions
                    ]) : o
                });
            }
        },
        {
            key: "create",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = YF.resolve(t.extensions || [], new Map), r = t.doc instanceof XL ? t.doc : XL.of((t.doc || "").split(n.staticFacet(e.lineSeparator) || xF)), o = t.selection ? t.selection instanceof PF ? t.selection : PF.single(t.selection.anchor, t.selection.head) : PF.single(0);
                return TF(o, r.length), n.staticFacet(tV) || (o = o.asSingle()), new e(n, r, o, n.dynamicSlots.map(function() {
                    return null;
                }), function(e, t) {
                    return t.create(e);
                }, null);
            }
        }
    ]), e;
}();
function jV(e, t) {
    var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = {}, i = bo(e);
    try {
        for(i.s(); !(n = i.n()).done;)for(var a = n.value, s = 0, c = Object.keys(a); s < c.length; s++){
            var l = c[s], u = a[l], f = o[l];
            if (void 0 === f) o[l] = u;
            else if (f === u || void 0 === u) ;
            else {
                if (!Object.hasOwnProperty.call(r, l)) throw new Error("Config merge conflict for field " + l);
                o[l] = r[l](f, u);
            }
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    for(var d in t)void 0 === o[d] && (o[d] = t[d]);
    return o;
}
kV.allowMultipleSelections = tV, kV.tabSize = NF.define({
    combine: function(e) {
        return e.length ? e[0] : 4;
    }
}), kV.lineSeparator = nV, kV.readOnly = aV, kV.phrases = NF.define({
    compare: function(e, t) {
        var n = Object.keys(e), r = Object.keys(t);
        return n.length == r.length && n.every(function(n) {
            return e[n] == t[n];
        });
    }
}), kV.languageData = eV, kV.changeFilter = rV, kV.transactionFilter = oV, kV.transactionExtender = iV, GF.reconfigure = uV.define();
var SV = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "eq",
            value: function(e) {
                return this == e;
            }
        },
        {
            key: "range",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                return CV.create(e, t, this);
            }
        }
    ]), e;
}();
SV.prototype.startSide = SV.prototype.endSide = 0, SV.prototype.point = !1, SV.prototype.mapMode = kF.TrackDel;
var CV = function() {
    function e(t, n, r) {
        No(this, e), this.from = t, this.to = n, this.value = r;
    }
    return Do(e, null, [
        {
            key: "create",
            value: function(t, n, r) {
                return new e(t, n, r);
            }
        }
    ]), e;
}();
function $V(e, t) {
    return e.from - t.from || e.value.startSide - t.value.startSide;
}
var _V = function() {
    function e(t, n, r, o) {
        No(this, e), this.from = t, this.to = n, this.value = r, this.maxPoint = o;
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                return this.to[this.to.length - 1];
            }
        },
        {
            key: "findIndex",
            value: function(e, t, n) {
                for(var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, o = n ? this.to : this.from, i = r, a = o.length;;){
                    if (i == a) return i;
                    var s = i + a >> 1, c = o[s] - e || (n ? this.value[s].endSide : this.value[s].startSide) - t;
                    if (s == i) return c >= 0 ? i : a;
                    c >= 0 ? a = s : i = s + 1;
                }
            }
        },
        {
            key: "between",
            value: function(e, t, n, r) {
                for(var o = this.findIndex(t, -1000000000, !0), i = this.findIndex(n, 1e9, !1, o); o < i; o++)if (!1 === r(this.from[o] + e, this.to[o] + e, this.value[o])) return !1;
            }
        },
        {
            key: "map",
            value: function(t, n) {
                for(var r = [], o = [], i = [], a = -1, s = -1, c = 0; c < this.value.length; c++){
                    var l = this.value[c], u = this.from[c] + t, f = this.to[c] + t, d = void 0, h = void 0;
                    if (u == f) {
                        var v = n.mapPos(u, l.startSide, l.mapMode);
                        if (null == v) continue;
                        if (d = h = v, l.startSide != l.endSide && (h = n.mapPos(u, l.endSide)) < d) continue;
                    } else if ((d = n.mapPos(u, l.startSide)) > (h = n.mapPos(f, l.endSide)) || d == h && l.startSide > 0 && l.endSide <= 0) continue;
                    (h - d || l.endSide - l.startSide) < 0 || (a < 0 && (a = d), l.point && (s = Math.max(s, h - d)), r.push(l), o.push(d - a), i.push(h - a));
                }
                return {
                    mapped: r.length ? new e(o, i, r, s) : null,
                    pos: a
                };
            }
        }
    ]), e;
}(), OV = function() {
    function e(t, n, r, o) {
        No(this, e), this.chunkPos = t, this.chunk = n, this.nextLayer = r, this.maxPoint = o;
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                var e = this.chunk.length - 1;
                return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
            }
        },
        {
            key: "size",
            get: function() {
                if (this.isEmpty) return 0;
                var e, t = this.nextLayer.size, n = bo(this.chunk);
                try {
                    for(n.s(); !(e = n.n()).done;)t += e.value.value.length;
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                return t;
            }
        },
        {
            key: "chunkEnd",
            value: function(e) {
                return this.chunkPos[e] + this.chunk[e].length;
            }
        },
        {
            key: "update",
            value: function(t) {
                var n = t.add, r = void 0 === n ? [] : n, o = t.sort, i = void 0 !== o && o, a = t.filterFrom, s = void 0 === a ? 0 : a, c = t.filterTo, l = void 0 === c ? this.length : c, u = t.filter;
                if (0 == r.length && !u) return this;
                if (i && (r = r.slice().sort($V)), this.isEmpty) return r.length ? e.of(r) : this;
                for(var f = new AV(this, null, -1).goto(0), d = 0, h = [], v = new MV; f.value || d < r.length;)if (d < r.length && (f.from - r[d].from || f.startSide - r[d].value.startSide) >= 0) {
                    var p = r[d++];
                    v.addInner(p.from, p.to, p.value) || h.push(p);
                } else 1 == f.rangeIndex && f.chunkIndex < this.chunk.length && (d == r.length || this.chunkEnd(f.chunkIndex) < r[d].from) && (!u || s > this.chunkEnd(f.chunkIndex) || l < this.chunkPos[f.chunkIndex]) && v.addChunk(this.chunkPos[f.chunkIndex], this.chunk[f.chunkIndex]) ? f.nextChunk() : ((!u || s > f.to || l < f.from || u(f.from, f.to, f.value)) && (v.addInner(f.from, f.to, f.value) || h.push(CV.create(f.from, f.to, f.value))), f.next());
                return v.finishInner(this.nextLayer.isEmpty && !h.length ? e.empty : this.nextLayer.update({
                    add: h,
                    filter: u,
                    filterFrom: s,
                    filterTo: l
                }));
            }
        },
        {
            key: "map",
            value: function(t) {
                if (t.empty || this.isEmpty) return this;
                for(var n = [], r = [], o = -1, i = 0; i < this.chunk.length; i++){
                    var a = this.chunkPos[i], s = this.chunk[i], c = t.touchesRange(a, a + s.length);
                    if (!1 === c) o = Math.max(o, s.maxPoint), n.push(s), r.push(t.mapPos(a));
                    else if (!0 === c) {
                        var l = s.map(a, t), u = l.mapped, f = l.pos;
                        u && (o = Math.max(o, u.maxPoint), n.push(u), r.push(f));
                    }
                }
                var d = this.nextLayer.map(t);
                return 0 == n.length ? d : new e(r, n, d || e.empty, o);
            }
        },
        {
            key: "between",
            value: function(e, t, n) {
                if (!this.isEmpty) {
                    for(var r = 0; r < this.chunk.length; r++){
                        var o = this.chunkPos[r], i = this.chunk[r];
                        if (t >= o && e <= o + i.length && !1 === i.between(o, e - o, t - o, n)) return;
                    }
                    this.nextLayer.between(e, t, n);
                }
            }
        },
        {
            key: "iter",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return PV.from([
                    this
                ]).goto(e);
            }
        },
        {
            key: "isEmpty",
            get: function() {
                return this.nextLayer == this;
            }
        }
    ], [
        {
            key: "create",
            value: function(t, n, r, o) {
                return new e(t, n, r, o);
            }
        },
        {
            key: "iter",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return PV.from(e).goto(t);
            }
        },
        {
            key: "compare",
            value: function(e, t, n, r) {
                var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : -1, i = e.filter(function(e) {
                    return e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= o;
                }), a = t.filter(function(e) {
                    return e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= o;
                }), s = EV(i, a, n), c = new RV(i, s, o), l = new RV(a, s, o);
                n.iterGaps(function(e, t, n) {
                    return NV(c, e, l, t, n, r);
                }), n.empty && 0 == n.length && NV(c, 0, l, 0, 0, r);
            }
        },
        {
            key: "eq",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 ? arguments[3] : void 0;
                null == r && (r = 999999999);
                var o = e.filter(function(e) {
                    return !e.isEmpty && t.indexOf(e) < 0;
                }), i = t.filter(function(t) {
                    return !t.isEmpty && e.indexOf(t) < 0;
                });
                if (o.length != i.length) return !1;
                if (!o.length) return !0;
                for(var a = EV(o, i), s = new RV(o, a, 0).goto(n), c = new RV(i, a, 0).goto(n);;){
                    if (s.to != c.to || !IV(s.active, c.active) || s.point && (!c.point || !s.point.eq(c.point))) return !1;
                    if (s.to > r) return !0;
                    s.next(), c.next();
                }
            }
        },
        {
            key: "spans",
            value: function(e, t, n, r) {
                for(var o = new RV(e, null, arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : -1).goto(t), i = t, a = o.openStart;;){
                    var s = Math.min(o.to, n);
                    if (o.point) {
                        var c = o.activeForPoint(o.to), l = o.pointFrom < t ? c.length + 1 : Math.min(c.length, a);
                        r.point(i, s, o.point, c, l, o.pointRank), a = Math.min(o.openEnd(s), c.length);
                    } else s > i && (r.span(i, s, o.active, a), a = o.openEnd(s));
                    if (o.to > n) return a + (o.point && o.to > n ? 1 : 0);
                    i = o.to, o.next();
                }
            }
        },
        {
            key: "of",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = new MV, o = bo(e instanceof CV ? [
                    e
                ] : n ? function(e) {
                    if (e.length > 1) for(var t = e[0], n = 1; n < e.length; n++){
                        var r = e[n];
                        if ($V(t, r) > 0) return e.slice().sort($V);
                        t = r;
                    }
                    return e;
                }(e) : e);
                try {
                    for(o.s(); !(t = o.n()).done;){
                        var i = t.value;
                        r.add(i.from, i.to, i.value);
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return r.finish();
            }
        },
        {
            key: "join",
            value: function(t) {
                if (!t.length) return e.empty;
                for(var n = t[t.length - 1], r = t.length - 2; r >= 0; r--)for(var o = t[r]; o != e.empty; o = o.nextLayer)n = new e(o.chunkPos, o.chunk, n, Math.max(o.maxPoint, n.maxPoint));
                return n;
            }
        }
    ]), e;
}();
OV.empty = new OV([], [], null, -1), OV.empty.nextLayer = OV.empty;
var MV = function() {
    function e() {
        No(this, e), this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1000000000, this.lastTo = -1000000000, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
    }
    return Do(e, [
        {
            key: "finishChunk",
            value: function(e) {
                this.chunks.push(new _V(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
            }
        },
        {
            key: "add",
            value: function(t, n, r) {
                this.addInner(t, n, r) || (this.nextLayer || (this.nextLayer = new e)).add(t, n, r);
            }
        },
        {
            key: "addInner",
            value: function(e, t, n) {
                var r = e - this.lastTo || n.startSide - this.last.endSide;
                if (r <= 0 && (e - this.lastFrom || n.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
                return !(r < 0) && (250 == this.from.length && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(t - this.chunkStart), this.last = n, this.lastFrom = e, this.lastTo = t, this.value.push(n), n.point && (this.maxPoint = Math.max(this.maxPoint, t - e)), !0);
            }
        },
        {
            key: "addChunk",
            value: function(e, t) {
                if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0) return !1;
                this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint), this.chunks.push(t), this.chunkPos.push(e);
                var n = t.value.length - 1;
                return this.last = t.value[n], this.lastFrom = t.from[n] + e, this.lastTo = t.to[n] + e, !0;
            }
        },
        {
            key: "finish",
            value: function() {
                return this.finishInner(OV.empty);
            }
        },
        {
            key: "finishInner",
            value: function(e) {
                if (this.from.length && this.finishChunk(!1), 0 == this.chunks.length) return e;
                var t = OV.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
                return this.from = null, t;
            }
        }
    ]), e;
}();
function EV(e, t, n) {
    var r, o = new Map, i = bo(e);
    try {
        for(i.s(); !(r = i.n()).done;)for(var a = r.value, s = 0; s < a.chunk.length; s++)a.chunk[s].maxPoint <= 0 && o.set(a.chunk[s], a.chunkPos[s]);
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    var c, l = new Set, u = bo(t);
    try {
        for(u.s(); !(c = u.n()).done;)for(var f = c.value, d = 0; d < f.chunk.length; d++){
            var h = o.get(f.chunk[d]);
            null == h || (n ? n.mapPos(h) : h) != f.chunkPos[d] || (null == n ? void 0 : n.touchesRange(h, h + f.chunk[d].length)) || l.add(f.chunk[d]);
        }
    } catch (e) {
        u.e(e);
    } finally{
        u.f();
    }
    return l;
}
var AV = function() {
    function e(t, n, r) {
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
        No(this, e), this.layer = t, this.skip = n, this.minPoint = r, this.rank = o;
    }
    return Do(e, [
        {
            key: "startSide",
            get: function() {
                return this.value ? this.value.startSide : 0;
            }
        },
        {
            key: "endSide",
            get: function() {
                return this.value ? this.value.endSide : 0;
            }
        },
        {
            key: "goto",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1000000000;
                return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, t, !1), this;
            }
        },
        {
            key: "gotoInner",
            value: function(e, t, n) {
                for(; this.chunkIndex < this.layer.chunk.length;){
                    var r = this.layer.chunk[this.chunkIndex];
                    if (!(this.skip && this.skip.has(r) || this.layer.chunkEnd(this.chunkIndex) < e || r.maxPoint < this.minPoint)) break;
                    this.chunkIndex++, n = !1;
                }
                if (this.chunkIndex < this.layer.chunk.length) {
                    var o = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], t, !0);
                    (!n || this.rangeIndex < o) && this.setRangeIndex(o);
                }
                this.next();
            }
        },
        {
            key: "forward",
            value: function(e, t) {
                (this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
            }
        },
        {
            key: "next",
            value: function() {
                for(;;){
                    if (this.chunkIndex == this.layer.chunk.length) {
                        this.from = this.to = 1e9, this.value = null;
                        break;
                    }
                    var e = this.layer.chunkPos[this.chunkIndex], t = this.layer.chunk[this.chunkIndex], n = e + t.from[this.rangeIndex];
                    if (this.from = n, this.to = e + t.to[this.rangeIndex], this.value = t.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
                }
            }
        },
        {
            key: "setRangeIndex",
            value: function(e) {
                if (e == this.layer.chunk[this.chunkIndex].value.length) {
                    if (this.chunkIndex++, this.skip) for(; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]);)this.chunkIndex++;
                    this.rangeIndex = 0;
                } else this.rangeIndex = e;
            }
        },
        {
            key: "nextChunk",
            value: function() {
                this.chunkIndex++, this.rangeIndex = 0, this.next();
            }
        },
        {
            key: "compare",
            value: function(e) {
                return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
            }
        }
    ]), e;
}(), PV = function() {
    function e(t) {
        No(this, e), this.heap = t;
    }
    return Do(e, [
        {
            key: "startSide",
            get: function() {
                return this.value ? this.value.startSide : 0;
            }
        },
        {
            key: "goto",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1000000000, r = bo(this.heap);
                try {
                    for(r.s(); !(t = r.n()).done;)t.value.goto(e, n);
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                for(var o = this.heap.length >> 1; o >= 0; o--)TV(this.heap, o);
                return this.next(), this;
            }
        },
        {
            key: "forward",
            value: function(e, t) {
                var n, r = bo(this.heap);
                try {
                    for(r.s(); !(n = r.n()).done;)n.value.forward(e, t);
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                for(var o = this.heap.length >> 1; o >= 0; o--)TV(this.heap, o);
                (this.to - e || this.value.endSide - t) < 0 && this.next();
            }
        },
        {
            key: "next",
            value: function() {
                if (0 == this.heap.length) this.from = this.to = 1e9, this.value = null, this.rank = -1;
                else {
                    var e = this.heap[0];
                    this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), TV(this.heap, 0);
                }
            }
        }
    ], [
        {
            key: "from",
            value: function(t) {
                for(var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1, o = [], i = 0; i < t.length; i++)for(var a = t[i]; !a.isEmpty; a = a.nextLayer)a.maxPoint >= r && o.push(new AV(a, n, r, i));
                return 1 == o.length ? o[0] : new e(o);
            }
        }
    ]), e;
}();
function TV(e, t) {
    for(var n = e[t];;){
        var r = 1 + (t << 1);
        if (r >= e.length) break;
        var o = e[r];
        if (r + 1 < e.length && o.compare(e[r + 1]) >= 0 && (o = e[r + 1], r++), n.compare(o) < 0) break;
        e[r] = n, e[t] = o, t = r;
    }
}
var RV = function() {
    function e(t, n, r) {
        No(this, e), this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1000000000, this.endSide = 0, this.openStart = -1, this.cursor = PV.from(t, n, r);
    }
    return Do(e, [
        {
            key: "goto",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1000000000;
                return this.cursor.goto(e, t), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = t, this.openStart = -1, this.next(), this;
            }
        },
        {
            key: "forward",
            value: function(e, t) {
                for(; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0;)this.removeActive(this.minActive);
                this.cursor.forward(e, t);
            }
        },
        {
            key: "removeActive",
            value: function(e) {
                DV(this.active, e), DV(this.activeTo, e), DV(this.activeRank, e), this.minActive = qV(this.active, this.activeTo);
            }
        },
        {
            key: "addActive",
            value: function(e) {
                for(var t = 0, n = this.cursor, r = n.value, o = n.to, i = n.rank; t < this.activeRank.length && (i - this.activeRank[t] || o - this.activeTo[t]) > 0;)t++;
                zV(this.active, t, r), zV(this.activeTo, t, o), zV(this.activeRank, t, i), e && zV(e, t, this.cursor.from), this.minActive = qV(this.active, this.activeTo);
            }
        },
        {
            key: "next",
            value: function() {
                var e = this.to, t = this.point;
                this.point = null;
                for(var n = this.openStart < 0 ? [] : null;;){
                    var r = this.minActive;
                    if (r > -1 && (this.activeTo[r] - this.cursor.from || this.active[r].endSide - this.cursor.startSide) < 0) {
                        if (this.activeTo[r] > e) {
                            this.to = this.activeTo[r], this.endSide = this.active[r].endSide;
                            break;
                        }
                        this.removeActive(r), n && DV(n, r);
                    } else {
                        if (!this.cursor.value) {
                            this.to = this.endSide = 1e9;
                            break;
                        }
                        if (this.cursor.from > e) {
                            this.to = this.cursor.from, this.endSide = this.cursor.startSide;
                            break;
                        }
                        var o = this.cursor.value;
                        if (o.point) {
                            if (!(t && this.cursor.to == this.to && this.cursor.from < this.cursor.to)) {
                                this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
                                break;
                            }
                            this.cursor.next();
                        } else this.addActive(n), this.cursor.next();
                    }
                }
                if (n) {
                    this.openStart = 0;
                    for(var i = n.length - 1; i >= 0 && n[i] < e; i--)this.openStart++;
                }
            }
        },
        {
            key: "activeForPoint",
            value: function(e) {
                if (!this.active.length) return this.active;
                for(var t = [], n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--)(this.activeTo[n] > e || this.activeTo[n] == e && this.active[n].endSide >= this.point.endSide) && t.push(this.active[n]);
                return t.reverse();
            }
        },
        {
            key: "openEnd",
            value: function(e) {
                for(var t = 0, n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > e; n--)t++;
                return t;
            }
        }
    ]), e;
}();
function NV(e, t, n, r, o, i) {
    e.goto(t), n.goto(r);
    for(var a = r + o, s = r, c = r - t;;){
        var l = e.to + c - n.to || e.endSide - n.endSide, u = l < 0 ? e.to + c : n.to, f = Math.min(u, a);
        if (e.point || n.point ? e.point && n.point && (e.point == n.point || e.point.eq(n.point)) && IV(e.activeForPoint(e.to), n.activeForPoint(n.to)) || i.comparePoint(s, f, e.point, n.point) : f > s && !IV(e.active, n.active) && i.compareRange(s, f, e.active, n.active), u > a) break;
        s = u, l <= 0 && e.next(), l >= 0 && n.next();
    }
}
function IV(e, t) {
    if (e.length != t.length) return !1;
    for(var n = 0; n < e.length; n++)if (e[n] != t[n] && !e[n].eq(t[n])) return !1;
    return !0;
}
function DV(e, t) {
    for(var n = t, r = e.length - 1; n < r; n++)e[n] = e[n + 1];
    e.pop();
}
function zV(e, t, n) {
    for(var r = e.length - 1; r >= t; r--)e[r + 1] = e[r];
    e[t] = n;
}
function qV(e, t) {
    for(var n = -1, r = 1e9, o = 0; o < t.length; o++)(t[o] - r || e[o].endSide - e[n].endSide) < 0 && (n = o, r = t[o]);
    return n;
}
function BV(e, t) {
    for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.length, r = 0, o = 0; o < n;)9 == e.charCodeAt(o) ? (r += t - r % t, o++) : (r++, o = hF(e, o));
    return r;
}
function LV(e, t, n, r) {
    for(var o = 0, i = 0;;){
        if (i >= t) return o;
        if (o == e.length) break;
        i += 9 == e.charCodeAt(o) ? n - i % n : 1, o = hF(e, o);
    }
    return !0 === r ? -1 : e.length;
}
for(var FV = "undefined" == typeof Symbol ? "__\u037C" : Symbol.for("\u037C"), VV = "undefined" == typeof Symbol ? "__styleSet" + Math.floor(1e8 * Math.random()) : Symbol("styleSet"), HV = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : {}, WV = function() {
    function e(t, n) {
        No(this, e), this.rules = [];
        var r = (n || {}).finish;
        function o(e) {
            return /^@/.test(e) ? [
                e
            ] : e.split(/,\s*/);
        }
        function i(e, t, n, a) {
            var s = [], c = /^@(\w+)\b/.exec(e[0]), l = c && "keyframes" == c[1];
            if (c && null == t) return n.push(e[0] + ";");
            for(var u in t){
                var f = t[u];
                if (/&/.test(u)) i(u.split(/,\s*/).map(function(t) {
                    return e.map(function(e) {
                        return t.replace(/&/, e);
                    });
                }).reduce(function(e, t) {
                    return e.concat(t);
                }), f, n);
                else if (f && "object" == Ho(f)) {
                    if (!c) throw new RangeError("The value of a property (" + u + ") should be a primitive value.");
                    i(o(u), f, s, l);
                } else null != f && s.push(u.replace(/_.*/, "").replace(/[A-Z]/g, function(e) {
                    return "-" + e.toLowerCase();
                }) + ": " + f + ";");
            }
            (s.length || l) && n.push((!r || c || a ? e : e.map(r)).join(", ") + " {" + s.join(" ") + "}");
        }
        for(var a in t)i(o(a), t[a], this.rules);
    }
    return Do(e, [
        {
            key: "getRules",
            value: function() {
                return this.rules.join("\n");
            }
        }
    ], [
        {
            key: "newName",
            value: function() {
                var e = HV[FV] || 1;
                return HV[FV] = e + 1, "\u037C" + e.toString(36);
            }
        },
        {
            key: "mount",
            value: function(e, t, n) {
                var r = e[VV], o = n && n.nonce;
                r ? o && r.setNonce(o) : r = new JV(e, o), r.mount(Array.isArray(t) ? t : [
                    t
                ]);
            }
        }
    ]), e;
}(), UV = new Map, JV = function() {
    function e(t, n) {
        No(this, e);
        var r = t.ownerDocument || t, o = r.defaultView;
        if (!t.head && t.adoptedStyleSheets && o.CSSStyleSheet) {
            var i = UV.get(r);
            if (i) return t.adoptedStyleSheets = [
                i.sheet
            ].concat(Bo(t.adoptedStyleSheets)), t[VV] = i;
            this.sheet = new o.CSSStyleSheet, t.adoptedStyleSheets = [
                this.sheet
            ].concat(Bo(t.adoptedStyleSheets)), UV.set(r, this);
        } else {
            this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
            var a = t.head || t;
            a.insertBefore(this.styleTag, a.firstChild);
        }
        this.modules = [], t[VV] = this;
    }
    return Do(e, [
        {
            key: "mount",
            value: function(e) {
                for(var t = this.sheet, n = 0, r = 0, o = 0; o < e.length; o++){
                    var i = e[o], a = this.modules.indexOf(i);
                    if (a < r && a > -1 && (this.modules.splice(a, 1), r--, a = -1), -1 == a) {
                        if (this.modules.splice(r++, 0, i), t) for(var s = 0; s < i.rules.length; s++)t.insertRule(i.rules[s], n++);
                    } else {
                        for(; r < a;)n += this.modules[r++].rules.length;
                        n += i.rules.length, r++;
                    }
                }
                if (!t) {
                    for(var c = "", l = 0; l < this.modules.length; l++)c += this.modules[l].getRules() + "\n";
                    this.styleTag.textContent = c;
                }
            }
        },
        {
            key: "setNonce",
            value: function(e) {
                this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
            }
        }
    ]), e;
}(), KV = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
}, GV = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
}, QV = "undefined" != typeof navigator && /Mac/.test(navigator.platform), YV = "undefined" != typeof navigator && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), XV = 0; XV < 10; XV++)KV[48 + XV] = KV[96 + XV] = String(XV);
for(XV = 1; XV <= 24; XV++)KV[XV + 111] = "F" + XV;
for(XV = 65; XV <= 90; XV++)KV[XV] = String.fromCharCode(XV + 32), GV[XV] = String.fromCharCode(XV);
for(var ZV in KV)GV.hasOwnProperty(ZV) || (GV[ZV] = KV[ZV]);
function eH(e) {
    return (11 == e.nodeType ? e.getSelection ? e : e.ownerDocument : e).getSelection();
}
function tH(e, t) {
    return !!t && (e == t || e.contains(1 != t.nodeType ? t.parentNode : t));
}
function nH(e, t) {
    if (!t.anchorNode) return !1;
    try {
        return tH(e, t.anchorNode);
    } catch (e) {
        return !1;
    }
}
function rH(e) {
    return 3 == e.nodeType ? pH(e, 0, e.nodeValue.length).getClientRects() : 1 == e.nodeType ? e.getClientRects() : [];
}
function oH(e, t, n, r) {
    return !!n && (aH(e, t, n, r, -1) || aH(e, t, n, r, 1));
}
function iH(e) {
    for(var t = 0;; t++)if (!(e = e.previousSibling)) return t;
}
function aH(e, t, n, r, o) {
    for(;;){
        if (e == n && t == r) return !0;
        if (t == (o < 0 ? 0 : sH(e))) {
            if ("DIV" == e.nodeName) return !1;
            var i = e.parentNode;
            if (!i || 1 != i.nodeType) return !1;
            t = iH(e) + (o < 0 ? 0 : 1), e = i;
        } else {
            if (1 != e.nodeType) return !1;
            if (1 == (e = e.childNodes[t + (o < 0 ? -1 : 0)]).nodeType && "false" == e.contentEditable) return !1;
            t = o < 0 ? sH(e) : 0;
        }
    }
}
function sH(e) {
    return 3 == e.nodeType ? e.nodeValue.length : e.childNodes.length;
}
function cH(e, t) {
    var n = t ? e.left : e.right;
    return {
        left: n,
        right: n,
        top: e.top,
        bottom: e.bottom
    };
}
function lH(e) {
    return {
        left: 0,
        right: e.innerWidth,
        top: 0,
        bottom: e.innerHeight
    };
}
function uH(e, t) {
    var n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
    return (n > .995 && n < 1.005 || !isFinite(n) || Math.abs(t.width - e.offsetWidth) < 1) && (n = 1), (r > .995 && r < 1.005 || !isFinite(r) || Math.abs(t.height - e.offsetHeight) < 1) && (r = 1), {
        scaleX: n,
        scaleY: r
    };
}
var fH, dH = function() {
    function e() {
        No(this, e), this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
    }
    return Do(e, [
        {
            key: "eq",
            value: function(e) {
                return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
            }
        },
        {
            key: "setRange",
            value: function(e) {
                var t = e.anchorNode, n = e.focusNode;
                this.set(t, Math.min(e.anchorOffset, t ? sH(t) : 0), n, Math.min(e.focusOffset, n ? sH(n) : 0));
            }
        },
        {
            key: "set",
            value: function(e, t, n, r) {
                this.anchorNode = e, this.anchorOffset = t, this.focusNode = n, this.focusOffset = r;
            }
        }
    ]), e;
}(), hH = null;
function vH(e) {
    if (e.setActive) return e.setActive();
    if (hH) return e.focus(hH);
    for(var t = [], n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode);
    if (e.focus(null == hH ? {
        get preventScroll () {
            return hH = {
                preventScroll: !0
            }, !0;
        }
    } : void 0), !hH) {
        hH = !1;
        for(var r = 0; r < t.length;){
            var o = t[r++], i = t[r++], a = t[r++];
            o.scrollTop != i && (o.scrollTop = i), o.scrollLeft != a && (o.scrollLeft = a);
        }
    }
}
function pH(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t, r = fH || (fH = document.createRange());
    return r.setEnd(e, n), r.setStart(e, t), r;
}
function mH(e, t, n) {
    var r = {
        key: t,
        code: t,
        keyCode: n,
        which: n,
        cancelable: !0
    }, o = new KeyboardEvent("keydown", r);
    o.synthetic = !0, e.dispatchEvent(o);
    var i = new KeyboardEvent("keyup", r);
    return i.synthetic = !0, e.dispatchEvent(i), o.defaultPrevented || i.defaultPrevented;
}
function gH(e) {
    for(; e.attributes.length;)e.removeAttributeNode(e.attributes[0]);
}
function yH(e) {
    return e.scrollTop > Math.max(1, e.scrollHeight - e.clientHeight - 4);
}
var bH = function() {
    function e(t, n) {
        var r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        No(this, e), this.node = t, this.offset = n, this.precise = r;
    }
    return Do(e, null, [
        {
            key: "before",
            value: function(t, n) {
                return new e(t.parentNode, iH(t), n);
            }
        },
        {
            key: "after",
            value: function(t, n) {
                return new e(t.parentNode, iH(t) + 1, n);
            }
        }
    ]), e;
}(), wH = [], xH = function() {
    function e() {
        No(this, e), this.parent = null, this.dom = null, this.flags = 2;
    }
    return Do(e, [
        {
            key: "overrideDOMText",
            get: function() {
                return null;
            }
        },
        {
            key: "posAtStart",
            get: function() {
                return this.parent ? this.parent.posBefore(this) : 0;
            }
        },
        {
            key: "posAtEnd",
            get: function() {
                return this.posAtStart + this.length;
            }
        },
        {
            key: "posBefore",
            value: function(e) {
                var t, n = this.posAtStart, r = bo(this.children);
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var o = t.value;
                        if (o == e) return n;
                        n += o.length + o.breakAfter;
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                throw new RangeError("Invalid child in posBefore");
            }
        },
        {
            key: "posAfter",
            value: function(e) {
                return this.posBefore(e) + e.length;
            }
        },
        {
            key: "sync",
            value: function(t, n) {
                if (2 & this.flags) {
                    var r, o, i = this.dom, a = null, s = bo(this.children);
                    try {
                        for(s.s(); !(o = s.n()).done;){
                            var c = o.value;
                            if (7 & c.flags) {
                                if (!c.dom && (r = a ? a.nextSibling : i.firstChild)) {
                                    var l = e.get(r);
                                    (!l || !l.parent && l.canReuseDOM(c)) && c.reuseDOM(r);
                                }
                                c.sync(t, n), c.flags &= -8;
                            }
                            if (r = a ? a.nextSibling : i.firstChild, n && !n.written && n.node == i && r != c.dom && (n.written = !0), c.dom.parentNode == i) for(; r && r != c.dom;)r = kH(r);
                            else i.insertBefore(c.dom, r);
                            a = c.dom;
                        }
                    } catch (e) {
                        s.e(e);
                    } finally{
                        s.f();
                    }
                    for((r = a ? a.nextSibling : i.firstChild) && n && n.node == i && (n.written = !0); r;)r = kH(r);
                } else if (1 & this.flags) {
                    var u, f = bo(this.children);
                    try {
                        for(f.s(); !(u = f.n()).done;){
                            var d = u.value;
                            7 & d.flags && (d.sync(t, n), d.flags &= -8);
                        }
                    } catch (e) {
                        f.e(e);
                    } finally{
                        f.f();
                    }
                }
            }
        },
        {
            key: "reuseDOM",
            value: function(e) {}
        },
        {
            key: "localPosFromDOM",
            value: function(t, n) {
                var r;
                if (t == this.dom) r = this.dom.childNodes[n];
                else {
                    for(var o = 0 == sH(t) ? 0 : 0 == n ? -1 : 1;;){
                        var i = t.parentNode;
                        if (i == this.dom) break;
                        0 == o && i.firstChild != i.lastChild && (o = t == i.firstChild ? -1 : 1), t = i;
                    }
                    r = o < 0 ? t : t.nextSibling;
                }
                if (r == this.dom.firstChild) return 0;
                for(; r && !e.get(r);)r = r.nextSibling;
                if (!r) return this.length;
                for(var a = 0, s = 0;; a++){
                    var c = this.children[a];
                    if (c.dom == r) return s;
                    s += c.length + c.breakAfter;
                }
            }
        },
        {
            key: "domBoundsAround",
            value: function(e, t) {
                for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = -1, o = -1, i = -1, a = -1, s = 0, c = n, l = n; s < this.children.length; s++){
                    var u = this.children[s], f = c + u.length;
                    if (c < e && f > t) return u.domBoundsAround(e, t, c);
                    if (f >= e && -1 == r && (r = s, o = c), c > t && u.dom.parentNode == this.dom) {
                        i = s, a = l;
                        break;
                    }
                    l = f, c = f + u.breakAfter;
                }
                return {
                    from: o,
                    to: a < 0 ? n + this.length : a,
                    startDOM: (r ? this.children[r - 1].dom.nextSibling : null) || this.dom.firstChild,
                    endDOM: i < this.children.length && i >= 0 ? this.children[i].dom : null
                };
            }
        },
        {
            key: "markDirty",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                this.flags |= 2, this.markParentsDirty(e);
            }
        },
        {
            key: "markParentsDirty",
            value: function(e) {
                for(var t = this.parent; t; t = t.parent){
                    if (e && (t.flags |= 2), 1 & t.flags) return;
                    t.flags |= 1, e = !1;
                }
            }
        },
        {
            key: "setParent",
            value: function(e) {
                this.parent != e && (this.parent = e, 7 & this.flags && this.markParentsDirty(!0));
            }
        },
        {
            key: "setDOM",
            value: function(e) {
                this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
            }
        },
        {
            key: "rootView",
            get: function() {
                for(var e = this;;){
                    var t = e.parent;
                    if (!t) return e;
                    e = t;
                }
            }
        },
        {
            key: "replaceChildren",
            value: function(e, t) {
                var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : wH;
                this.markDirty();
                for(var o = e; o < t; o++){
                    var i = this.children[o];
                    i.parent == this && r.indexOf(i) < 0 && i.destroy();
                }
                (n = this.children).splice.apply(n, [
                    e,
                    t - e
                ].concat(Bo(r)));
                for(var a = 0; a < r.length; a++)r[a].setParent(this);
            }
        },
        {
            key: "ignoreMutation",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "ignoreEvent",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "childCursor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.length;
                return new jH(this.children, e, this.children.length);
            }
        },
        {
            key: "childPos",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return this.childCursor().findPos(e, t);
            }
        },
        {
            key: "toString",
            value: function() {
                var e = this.constructor.name.replace("View", "");
                return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + ("Text" == e ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
            }
        },
        {
            key: "isEditable",
            get: function() {
                return !0;
            }
        },
        {
            key: "isWidget",
            get: function() {
                return !1;
            }
        },
        {
            key: "isHidden",
            get: function() {
                return !1;
            }
        },
        {
            key: "merge",
            value: function(e, t, n, r, o, i) {
                return !1;
            }
        },
        {
            key: "become",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "canReuseDOM",
            value: function(e) {
                return e.constructor == this.constructor && !(8 & (this.flags | e.flags));
            }
        },
        {
            key: "getSide",
            value: function() {
                return 0;
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t = bo(this.children);
                try {
                    for(t.s(); !(e = t.n()).done;){
                        var n = e.value;
                        n.parent == this && n.destroy();
                    }
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
                this.parent = null;
            }
        }
    ], [
        {
            key: "get",
            value: function(e) {
                return e.cmView;
            }
        }
    ]), e;
}();
function kH(e) {
    var t = e.nextSibling;
    return e.parentNode.removeChild(e), t;
}
xH.prototype.breakAfter = 0;
var jH = function() {
    function e(t, n, r) {
        No(this, e), this.children = t, this.pos = n, this.i = r, this.off = 0;
    }
    return Do(e, [
        {
            key: "findPos",
            value: function(e) {
                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;;){
                    if (e > this.pos || e == this.pos && (t > 0 || 0 == this.i || this.children[this.i - 1].breakAfter)) return this.off = e - this.pos, this;
                    var n = this.children[--this.i];
                    this.pos -= n.length + n.breakAfter;
                }
            }
        }
    ]), e;
}();
function SH(e, t, n, r, o, i, a, s, c) {
    var l = e.children, u = l.length ? l[t] : null, f = i.length ? i[i.length - 1] : null, d = f ? f.breakAfter : a;
    if (!(t == r && u && !a && !d && i.length < 2 && u.merge(n, o, i.length ? f : null, 0 == n, s, c))) {
        if (r < l.length) {
            var h = l[r];
            h && (o < h.length || h.breakAfter && (null == f ? void 0 : f.breakAfter)) ? (t == r && (h = h.split(o), o = 0), !d && f && h.merge(0, o, f, !0, 0, c) ? i[i.length - 1] = h : ((o || h.children.length && !h.children[0].length) && h.merge(0, o, null, !1, 0, c), i.push(h))) : (null == h ? void 0 : h.breakAfter) && (f ? f.breakAfter = 1 : a = 1), r++;
        }
        for(u && (u.breakAfter = a, n > 0 && (!a && i.length && u.merge(n, u.length, i[0], !1, s, 0) ? u.breakAfter = i.shift().breakAfter : (n < u.length || u.children.length && 0 == u.children[u.children.length - 1].length) && u.merge(n, u.length, null, !1, s, 0), t++)); t < r && i.length;)if (l[r - 1].become(i[i.length - 1])) r--, i.pop(), c = i.length ? 0 : s;
        else {
            if (!l[t].become(i[0])) break;
            t++, i.shift(), s = i.length ? 0 : c;
        }
        !i.length && t && r < l.length && !l[t - 1].breakAfter && l[r].merge(0, 0, l[t - 1], !1, s, c) && t--, (t < r || i.length) && e.replaceChildren(t, r, i);
    }
}
function CH(e, t, n, r, o, i) {
    var a, s = e.childCursor(), c = s.findPos(n, 1), l = c.i, u = c.off, f = s.findPos(t, -1), d = f.i, h = f.off, v = t - n, p = bo(r);
    try {
        for(p.s(); !(a = p.n()).done;)v += a.value.length;
    } catch (e) {
        p.e(e);
    } finally{
        p.f();
    }
    e.length += v, SH(e, d, h, l, u, r, 0, o, i);
}
var $H = "undefined" != typeof navigator ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
}, _H = "undefined" != typeof document ? document : {
    documentElement: {
        style: {}
    }
}, OH = /Edge\/(\d+)/.exec($H.userAgent), MH = /MSIE \d/.test($H.userAgent), EH = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($H.userAgent), AH = !!(MH || EH || OH), PH = !AH && /gecko\/(\d+)/i.test($H.userAgent), TH = !AH && /Chrome\/(\d+)/.exec($H.userAgent), RH = "webkitFontSmoothing" in _H.documentElement.style, NH = !AH && /Apple Computer/.test($H.vendor), IH = NH && (/Mobile\/\w+/.test($H.userAgent) || $H.maxTouchPoints > 2), DH = {
    mac: IH || /Mac/.test($H.platform),
    windows: /Win/.test($H.platform),
    linux: /Linux|X11/.test($H.platform),
    ie: AH,
    ie_version: MH ? _H.documentMode || 6 : EH ? +EH[1] : OH ? +OH[1] : 0,
    gecko: PH,
    gecko_version: PH ? +(/Firefox\/(\d+)/.exec($H.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!TH,
    chrome_version: TH ? +TH[1] : 0,
    ios: IH,
    android: /Android\b/.test($H.userAgent),
    webkit: RH,
    safari: NH,
    webkit_version: RH ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: null != _H.documentElement.style.tabSize ? "tab-size" : "-moz-tab-size"
}, zH = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).text = e, n;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "length",
            get: function() {
                return this.text.length;
            }
        },
        {
            key: "createDOM",
            value: function(e) {
                this.setDOM(e || document.createTextNode(this.text));
            }
        },
        {
            key: "sync",
            value: function(e, t) {
                this.dom || this.createDOM(), this.dom.nodeValue != this.text && (t && t.node == this.dom && (t.written = !0), this.dom.nodeValue = this.text);
            }
        },
        {
            key: "reuseDOM",
            value: function(e) {
                3 == e.nodeType && this.createDOM(e);
            }
        },
        {
            key: "merge",
            value: function(e, n, r) {
                return !(8 & this.flags || r && (!(r instanceof t) || this.length - (n - e) + r.length > 256 || 8 & r.flags)) && (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
            }
        },
        {
            key: "split",
            value: function(e) {
                var n = new t(this.text.slice(e));
                return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= 8 & this.flags, n;
            }
        },
        {
            key: "localPosFromDOM",
            value: function(e, t) {
                return e == this.dom ? t : t ? this.text.length : 0;
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return new bH(this.dom, e);
            }
        },
        {
            key: "domBoundsAround",
            value: function(e, t, n) {
                return {
                    from: n,
                    to: n + this.length,
                    startDOM: this.dom,
                    endDOM: this.dom.nextSibling
                };
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                return function(e, t, n) {
                    var r = e.nodeValue.length;
                    t > r && (t = r);
                    var o = t, i = t, a = 0;
                    0 == t && n < 0 || t == r && n >= 0 ? DH.chrome || DH.gecko || (t ? (o--, a = 1) : i < r && (i++, a = -1)) : n < 0 ? o-- : i < r && i++;
                    var s = pH(e, o, i).getClientRects();
                    if (!s.length) return null;
                    var c = s[(a ? a < 0 : n >= 0) ? 0 : s.length - 1];
                    DH.safari && !a && 0 == c.width && (c = Array.prototype.find.call(s, function(e) {
                        return e.width;
                    }) || c);
                    return a ? cH(c, a < 0) : c || null;
                }(this.dom, e, t);
            }
        }
    ]), t;
}(), qH = function(e) {
    function t(e) {
        var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        No(this, t), (n = _o(this, t)).mark = e, n.children = r, n.length = o;
        var i, a = bo(r);
        try {
            for(a.s(); !(i = a.n()).done;)i.value.setParent(Eo(n));
        } catch (e) {
            a.e(e);
        } finally{
            a.f();
        }
        return n;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "setAttrs",
            value: function(e) {
                if (gH(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs) for(var t in this.mark.attrs)e.setAttribute(t, this.mark.attrs[t]);
                return e;
            }
        },
        {
            key: "canReuseDOM",
            value: function(e) {
                return go(Mo(t.prototype), "canReuseDOM", this).call(this, e) && !(8 & (this.flags | e.flags));
            }
        },
        {
            key: "reuseDOM",
            value: function(e) {
                e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
            }
        },
        {
            key: "sync",
            value: function(e, n) {
                this.dom ? 4 & this.flags && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), go(Mo(t.prototype), "sync", this).call(this, e, n);
            }
        },
        {
            key: "merge",
            value: function(e, n, r, o, i, a) {
                return (!r || !(!(r instanceof t && r.mark.eq(this.mark)) || e && i <= 0 || n < this.length && a <= 0)) && (CH(this, e, n, r ? r.children.slice() : [], i - 1, a - 1), this.markDirty(), !0);
            }
        },
        {
            key: "split",
            value: function(e) {
                var n, r = [], o = 0, i = -1, a = 0, s = bo(this.children);
                try {
                    for(s.s(); !(n = s.n()).done;){
                        var c = n.value, l = o + c.length;
                        l > e && r.push(o < e ? c.split(e - o) : c), i < 0 && o >= e && (i = a), o = l, a++;
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                var u = this.length - e;
                return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new t(this.mark, r, u);
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return FH(this, e);
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                return HH(this, e, t);
            }
        }
    ]), t;
}();
var BH = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t)).widget = e, o.length = n, o.side = r, o.prevWidget = null, o;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "split",
            value: function(e) {
                var n = t.create(this.widget, this.length - e, this.side);
                return this.length -= e, n;
            }
        },
        {
            key: "sync",
            value: function(e) {
                this.dom && this.widget.updateDOM(this.dom, e) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
            }
        },
        {
            key: "getSide",
            value: function() {
                return this.side;
            }
        },
        {
            key: "merge",
            value: function(e, n, r, o, i, a) {
                return !(r && (!(r instanceof t && this.widget.compare(r.widget)) || e > 0 && i <= 0 || n < this.length && a <= 0)) && (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
            }
        },
        {
            key: "become",
            value: function(e) {
                return e instanceof t && e.side == this.side && this.widget.constructor == e.widget.constructor && (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0);
            }
        },
        {
            key: "ignoreMutation",
            value: function() {
                return !0;
            }
        },
        {
            key: "ignoreEvent",
            value: function(e) {
                return this.widget.ignoreEvent(e);
            }
        },
        {
            key: "overrideDOMText",
            get: function() {
                if (0 == this.length) return XL.empty;
                for(var e = this; e.parent;)e = e.parent;
                var t = e.view, n = t && t.state.doc, r = this.posAtStart;
                return n ? n.slice(r, r + this.length) : XL.empty;
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return (this.length ? 0 == e : this.side > 0) ? bH.before(this.dom) : bH.after(this.dom, e == this.length);
            }
        },
        {
            key: "domBoundsAround",
            value: function() {
                return null;
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                var n = this.widget.coordsAt(this.dom, e, t);
                if (n) return n;
                var r = this.dom.getClientRects(), o = null;
                if (!r.length) return null;
                for(var i = this.side ? this.side < 0 : e > 0, a = i ? r.length - 1 : 0; o = r[a], !(e > 0 ? 0 == a : a == r.length - 1 || o.top < o.bottom); a += i ? -1 : 1);
                return cH(o, !i);
            }
        },
        {
            key: "isEditable",
            get: function() {
                return !1;
            }
        },
        {
            key: "isWidget",
            get: function() {
                return !0;
            }
        },
        {
            key: "isHidden",
            get: function() {
                return this.widget.isHidden;
            }
        },
        {
            key: "destroy",
            value: function() {
                go(Mo(t.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
            }
        }
    ], [
        {
            key: "create",
            value: function(e, n, r) {
                return new t(e, n, r);
            }
        }
    ]), t;
}(), LH = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).side = e, n;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "length",
            get: function() {
                return 0;
            }
        },
        {
            key: "merge",
            value: function() {
                return !1;
            }
        },
        {
            key: "become",
            value: function(e) {
                return e instanceof t && e.side == this.side;
            }
        },
        {
            key: "split",
            value: function() {
                return new t(this.side);
            }
        },
        {
            key: "sync",
            value: function() {
                if (!this.dom) {
                    var e = document.createElement("img");
                    e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
                }
            }
        },
        {
            key: "getSide",
            value: function() {
                return this.side;
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return this.side > 0 ? bH.before(this.dom) : bH.after(this.dom);
            }
        },
        {
            key: "localPosFromDOM",
            value: function() {
                return 0;
            }
        },
        {
            key: "domBoundsAround",
            value: function() {
                return null;
            }
        },
        {
            key: "coordsAt",
            value: function(e) {
                return this.dom.getBoundingClientRect();
            }
        },
        {
            key: "overrideDOMText",
            get: function() {
                return XL.empty;
            }
        },
        {
            key: "isHidden",
            get: function() {
                return !0;
            }
        }
    ]), t;
}();
function FH(e, t) {
    for(var n = e.dom, r = e.children, o = 0, i = 0; o < r.length; o++){
        var a = r[o], s = i + a.length;
        if (!(s == i && a.getSide() <= 0)) {
            if (t > i && t < s && a.dom.parentNode == n) return a.domAtPos(t - i);
            if (t <= i) break;
            i = s;
        }
    }
    for(var c = o; c > 0; c--){
        var l = r[c - 1];
        if (l.dom.parentNode == n) return l.domAtPos(l.length);
    }
    for(var u = o; u < r.length; u++){
        var f = r[u];
        if (f.dom.parentNode == n) return f.domAtPos(0);
    }
    return new bH(n, 0);
}
function VH(e, t, n) {
    var r, o = e.children;
    n > 0 && t instanceof qH && o.length && (r = o[o.length - 1]) instanceof qH && r.mark.eq(t.mark) ? VH(r, t.children[0], n - 1) : (o.push(t), t.setParent(e)), e.length += t.length;
}
function HH(e, t, n) {
    var r = null, o = -1, i = null, a = -1;
    !function e(t, s) {
        for(var c = 0, l = 0; c < t.children.length && l <= s; c++){
            var u = t.children[c], f = l + u.length;
            f >= s && (u.children.length ? e(u, s - l) : (!i || i.isHidden && n > 0) && (f > s || l == f && u.getSide() > 0) ? (i = u, a = s - l) : (l < s || l == f && u.getSide() < 0 && !u.isHidden) && (r = u, o = s - l)), l = f;
        }
    }(e, t);
    var s = (n < 0 ? r : i) || r || i;
    return s ? s.coordsAt(Math.max(0, s == r ? o : a), n) : function(e) {
        var t = e.dom.lastChild;
        if (!t) return e.dom.getBoundingClientRect();
        var n = rH(t);
        return n[n.length - 1] || null;
    }(e);
}
function WH(e, t) {
    for(var n in e)"class" == n && t.class ? t.class += " " + e.class : "style" == n && t.style ? t.style += ";" + e.style : t[n] = e[n];
    return t;
}
zH.prototype.children = BH.prototype.children = LH.prototype.children = wH;
var UH = Object.create(null);
function JH(e, t, n) {
    if (e == t) return !0;
    e || (e = UH), t || (t = UH);
    var r = Object.keys(e), o = Object.keys(t);
    if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != o.length - (n && o.indexOf(n) > -1 ? 1 : 0)) return !1;
    for(var i = 0, a = r; i < a.length; i++){
        var s = a[i];
        if (s != n && (-1 == o.indexOf(s) || e[s] !== t[s])) return !1;
    }
    return !0;
}
function KH(e, t, n) {
    var r = !1;
    if (t) for(var o in t)n && o in n || (r = !0, "style" == o ? e.style.cssText = "" : e.removeAttribute(o));
    if (n) for(var i in n)t && t[i] == n[i] || (r = !0, "style" == i ? e.style.cssText = n[i] : e.setAttribute(i, n[i]));
    return r;
}
function GH(e) {
    for(var t = Object.create(null), n = 0; n < e.attributes.length; n++){
        var r = e.attributes[n];
        t[r.name] = r.value;
    }
    return t;
}
var QH = function(e) {
    function t() {
        var e;
        return No(this, t), (e = _o(this, t, arguments)).children = [], e.length = 0, e.prevAttrs = void 0, e.attrs = null, e.breakAfter = 0, e;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "merge",
            value: function(e, n, r, o, i, a) {
                if (r) {
                    if (!(r instanceof t)) return !1;
                    this.dom || r.transferDOM(this);
                }
                return o && this.setDeco(r ? r.attrs : null), CH(this, e, n, r ? r.children.slice() : [], i, a), !0;
            }
        },
        {
            key: "split",
            value: function(e) {
                var n = new t;
                if (n.breakAfter = this.breakAfter, 0 == this.length) return n;
                var r = this.childPos(e), o = r.i, i = r.off;
                i && (n.append(this.children[o].split(i), 0), this.children[o].merge(i, this.children[o].length, null, !1, 0, 0), o++);
                for(var a = o; a < this.children.length; a++)n.append(this.children[a], 0);
                for(; o > 0 && 0 == this.children[o - 1].length;)this.children[--o].destroy();
                return this.children.length = o, this.markDirty(), this.length = e, n;
            }
        },
        {
            key: "transferDOM",
            value: function(e) {
                this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = void 0 === this.prevAttrs ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
            }
        },
        {
            key: "setDeco",
            value: function(e) {
                JH(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
            }
        },
        {
            key: "append",
            value: function(e, t) {
                VH(this, e, t);
            }
        },
        {
            key: "addLineDeco",
            value: function(e) {
                var t = e.spec.attributes, n = e.spec.class;
                t && (this.attrs = WH(t, this.attrs || {})), n && (this.attrs = WH({
                    class: n
                }, this.attrs || {}));
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return FH(this, e);
            }
        },
        {
            key: "reuseDOM",
            value: function(e) {
                "DIV" == e.nodeName && (this.setDOM(e), this.flags |= 6);
            }
        },
        {
            key: "sync",
            value: function(e, n) {
                var r;
                this.dom ? 4 & this.flags && (gH(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), void 0 !== this.prevAttrs && (KH(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), go(Mo(t.prototype), "sync", this).call(this, e, n);
                for(var o = this.dom.lastChild; o && xH.get(o) instanceof qH;)o = o.lastChild;
                if (!(o && this.length && ("BR" == o.nodeName || 0 != (null === (r = xH.get(o)) || void 0 === r ? void 0 : r.isEditable) || DH.ios && this.children.some(function(e) {
                    return e instanceof zH;
                })))) {
                    var i = document.createElement("BR");
                    i.cmIgnore = !0, this.dom.appendChild(i);
                }
            }
        },
        {
            key: "measureTextSize",
            value: function() {
                if (0 == this.children.length || this.length > 20) return null;
                var e, t, n = 0, r = bo(this.children);
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var o = t.value;
                        if (!(o instanceof zH) || /[^ -~]/.test(o.text)) return null;
                        var i = rH(o.dom);
                        if (1 != i.length) return null;
                        n += i[0].width, e = i[0].height;
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                return n ? {
                    lineHeight: this.dom.getBoundingClientRect().height,
                    charWidth: n / this.length,
                    textHeight: e
                } : null;
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                var n = HH(this, e, t);
                if (!this.children.length && n && this.parent) {
                    var r = this.parent.view.viewState.heightOracle, o = n.bottom - n.top;
                    if (Math.abs(o - r.lineHeight) < 2 && r.textHeight < o) {
                        var i = (o - r.textHeight) / 2;
                        return {
                            top: n.top + i,
                            bottom: n.bottom - i,
                            left: n.left,
                            right: n.left
                        };
                    }
                }
                return n;
            }
        },
        {
            key: "become",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "covers",
            value: function() {
                return !0;
            }
        }
    ], [
        {
            key: "find",
            value: function(e, n) {
                for(var r = 0, o = 0; r < e.children.length; r++){
                    var i = e.children[r], a = o + i.length;
                    if (a >= n) {
                        if (i instanceof t) return i;
                        if (a > n) break;
                    }
                    o = a + i.breakAfter;
                }
                return null;
            }
        }
    ]), t;
}(), YH = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t)).widget = e, o.length = n, o.deco = r, o.breakAfter = 0, o.prevWidget = null, o;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "merge",
            value: function(e, n, r, o, i, a) {
                return !(r && (!(r instanceof t && this.widget.compare(r.widget)) || e > 0 && i <= 0 || n < this.length && a <= 0)) && (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return 0 == e ? bH.before(this.dom) : bH.after(this.dom, e == this.length);
            }
        },
        {
            key: "split",
            value: function(e) {
                var n = this.length - e;
                this.length = e;
                var r = new t(this.widget, n, this.deco);
                return r.breakAfter = this.breakAfter, r;
            }
        },
        {
            key: "children",
            get: function() {
                return wH;
            }
        },
        {
            key: "sync",
            value: function(e) {
                this.dom && this.widget.updateDOM(this.dom, e) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
            }
        },
        {
            key: "overrideDOMText",
            get: function() {
                return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : XL.empty;
            }
        },
        {
            key: "domBoundsAround",
            value: function() {
                return null;
            }
        },
        {
            key: "become",
            value: function(e) {
                return e instanceof t && e.widget.constructor == this.widget.constructor && (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0);
            }
        },
        {
            key: "ignoreMutation",
            value: function() {
                return !0;
            }
        },
        {
            key: "ignoreEvent",
            value: function(e) {
                return this.widget.ignoreEvent(e);
            }
        },
        {
            key: "isEditable",
            get: function() {
                return !1;
            }
        },
        {
            key: "isWidget",
            get: function() {
                return !0;
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                return this.widget.coordsAt(this.dom, e, t);
            }
        },
        {
            key: "destroy",
            value: function() {
                go(Mo(t.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
            }
        },
        {
            key: "covers",
            value: function(e) {
                var t = this.deco, n = t.startSide, r = t.endSide;
                return n != r && (e < 0 ? n < 0 : r > 0);
            }
        }
    ]), t;
}(), XH = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "eq",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "updateDOM",
            value: function(e, t) {
                return !1;
            }
        },
        {
            key: "compare",
            value: function(e) {
                return this == e || this.constructor == e.constructor && this.eq(e);
            }
        },
        {
            key: "estimatedHeight",
            get: function() {
                return -1;
            }
        },
        {
            key: "lineBreaks",
            get: function() {
                return 0;
            }
        },
        {
            key: "ignoreEvent",
            value: function(e) {
                return !0;
            }
        },
        {
            key: "coordsAt",
            value: function(e, t, n) {
                return null;
            }
        },
        {
            key: "isHidden",
            get: function() {
                return !1;
            }
        },
        {
            key: "editable",
            get: function() {
                return !1;
            }
        },
        {
            key: "destroy",
            value: function(e) {}
        }
    ]), e;
}(), ZH = function(e) {
    return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
}(ZH || (ZH = {})), eW = function(e) {
    function t(e, n, r, o) {
        var i;
        return No(this, t), (i = _o(this, t)).startSide = e, i.endSide = n, i.widget = r, i.spec = o, i;
    }
    return Ao(t, SV), Do(t, [
        {
            key: "heightRelevant",
            get: function() {
                return !1;
            }
        },
        {
            key: "hasHeight",
            value: function() {
                return !!this.widget && this.widget.estimatedHeight > -1;
            }
        }
    ], [
        {
            key: "mark",
            value: function(e) {
                return new tW(e);
            }
        },
        {
            key: "widget",
            value: function(e) {
                var t = Math.max(-10000, Math.min(1e4, e.side || 0)), n = !!e.block;
                return t += n && !e.inlineOrder ? t > 0 ? 3e8 : -400000000 : t > 0 ? 1e8 : -100000000, new rW(e, t, t, n, e.widget || null, !1);
            }
        },
        {
            key: "replace",
            value: function(e) {
                var t, n, r = !!e.block;
                if (e.isBlockGap) t = -500000000, n = 4e8;
                else {
                    var o = oW(e, r);
                    t = (o.start ? r ? -300000000 : -1 : 5e8) - 1, n = 1 + (o.end ? r ? 2e8 : 1 : -600000000);
                }
                return new rW(e, t, n, r, e.widget || null, !0);
            }
        },
        {
            key: "line",
            value: function(e) {
                return new nW(e);
            }
        },
        {
            key: "set",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return OV.of(e, t);
            }
        }
    ]), t;
}();
eW.none = OV.empty;
var tW = function(e) {
    function t(e) {
        var n;
        No(this, t);
        var r = oW(e);
        return (n = _o(this, t, [
            r.start ? -1 : 5e8,
            r.end ? 1 : -600000000,
            null,
            e
        ])).tagName = e.tagName || "span", n.class = e.class || "", n.attrs = e.attributes || null, n;
    }
    return Ao(t, eW), Do(t, [
        {
            key: "eq",
            value: function(e) {
                var n, r;
                return this == e || e instanceof t && this.tagName == e.tagName && (this.class || (null === (n = this.attrs) || void 0 === n ? void 0 : n.class)) == (e.class || (null === (r = e.attrs) || void 0 === r ? void 0 : r.class)) && JH(this.attrs, e.attrs, "class");
            }
        },
        {
            key: "range",
            value: function(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                if (e >= n) throw new RangeError("Mark decorations may not be empty");
                return go(Mo(t.prototype), "range", this).call(this, e, n);
            }
        }
    ]), t;
}();
tW.prototype.point = !1;
var nW = function(e) {
    function t(e) {
        return No(this, t), _o(this, t, [
            -200000000,
            -200000000,
            null,
            e
        ]);
    }
    return Ao(t, eW), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e instanceof t && this.spec.class == e.spec.class && JH(this.spec.attributes, e.spec.attributes);
            }
        },
        {
            key: "range",
            value: function(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                if (n != e) throw new RangeError("Line decoration ranges must be zero-length");
                return go(Mo(t.prototype), "range", this).call(this, e, n);
            }
        }
    ]), t;
}();
nW.prototype.mapMode = kF.TrackBefore, nW.prototype.point = !0;
var rW = function(e) {
    function t(e, n, r, o, i, a) {
        var s;
        return No(this, t), (s = _o(this, t, [
            n,
            r,
            i,
            e
        ])).block = o, s.isReplace = a, s.mapMode = o ? n <= 0 ? kF.TrackBefore : kF.TrackAfter : kF.TrackDel, s;
    }
    return Ao(t, eW), Do(t, [
        {
            key: "type",
            get: function() {
                return this.startSide != this.endSide ? ZH.WidgetRange : this.startSide <= 0 ? ZH.WidgetBefore : ZH.WidgetAfter;
            }
        },
        {
            key: "heightRelevant",
            get: function() {
                return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
            }
        },
        {
            key: "eq",
            value: function(e) {
                var n, r;
                return e instanceof t && (n = this.widget, r = e.widget, n == r || !!(n && r && n.compare(r))) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
            }
        },
        {
            key: "range",
            value: function(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
                if (!this.isReplace && n != e) throw new RangeError("Widget decorations can only have zero-length ranges");
                return go(Mo(t.prototype), "range", this).call(this, e, n);
            }
        }
    ]), t;
}();
function oW(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = e.inclusiveStart, r = e.inclusiveEnd;
    return null == n && (n = e.inclusive), null == r && (r = e.inclusive), {
        start: null != n ? n : t,
        end: null != r ? r : t
    };
}
function iW(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, o = n.length - 1;
    o >= 0 && n[o] + r >= e ? n[o] = Math.max(n[o], t) : n.push(e, t);
}
rW.prototype.point = !0;
var aW = function() {
    function e(t, n, r, o) {
        No(this, e), this.doc = t, this.pos = n, this.end = r, this.disallowBlockEffectsFor = o, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = n;
    }
    return Do(e, [
        {
            key: "posCovered",
            value: function() {
                if (0 == this.content.length) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
                var e = this.content[this.content.length - 1];
                return !(e.breakAfter || e instanceof YH && e.deco.endSide < 0);
            }
        },
        {
            key: "getLine",
            value: function() {
                return this.curLine || (this.content.push(this.curLine = new QH), this.atCursorPos = !0), this.curLine;
            }
        },
        {
            key: "flushBuffer",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.bufferMarks;
                this.pendingBuffer && (this.curLine.append(sW(new LH(-1), e), e.length), this.pendingBuffer = 0);
            }
        },
        {
            key: "addBlockWidget",
            value: function(e) {
                this.flushBuffer(), this.curLine = null, this.content.push(e);
            }
        },
        {
            key: "finish",
            value: function(e) {
                this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, this.posCovered() || e && this.content.length && this.content[this.content.length - 1] instanceof YH || this.getLine();
            }
        },
        {
            key: "buildText",
            value: function(e, t, n) {
                for(; e > 0;){
                    if (this.textOff == this.text.length) {
                        var r = this.cursor.next(this.skip), o = r.value, i = r.lineBreak, a = r.done;
                        if (this.skip = 0, a) throw new Error("Ran out of text content when drawing inline views");
                        if (i) {
                            this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
                            continue;
                        }
                        this.text = o, this.textOff = 0;
                    }
                    var s = Math.min(this.text.length - this.textOff, e, 512);
                    this.flushBuffer(t.slice(t.length - n)), this.getLine().append(sW(new zH(this.text.slice(this.textOff, this.textOff + s)), t), n), this.atCursorPos = !0, this.textOff += s, e -= s, n = 0;
                }
            }
        },
        {
            key: "span",
            value: function(e, t, n, r) {
                this.buildText(t - e, n, r), this.pos = t, this.openStart < 0 && (this.openStart = r);
            }
        },
        {
            key: "point",
            value: function(e, t, n, r, o, i) {
                if (this.disallowBlockEffectsFor[i] && n instanceof rW) {
                    if (n.block) throw new RangeError("Block decorations may not be specified via plugins");
                    if (t > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
                }
                var a = t - e;
                if (n instanceof rW) {
                    if (n.block) n.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new YH(n.widget || new cW("div"), a, n));
                    else {
                        var s = BH.create(n.widget || new cW("span"), a, a ? 0 : n.startSide), c = this.atCursorPos && !s.isEditable && o <= r.length && (e < t || n.startSide > 0), l = !s.isEditable && (e < t || o > r.length || n.startSide <= 0), u = this.getLine();
                        2 != this.pendingBuffer || c || s.isEditable || (this.pendingBuffer = 0), this.flushBuffer(r), c && (u.append(sW(new LH(1), r), o), o = r.length + Math.max(0, o - r.length)), u.append(sW(s, r), o), this.atCursorPos = l, this.pendingBuffer = l ? e < t || o > r.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = r.slice());
                    }
                } else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(n);
                a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = t), this.openStart < 0 && (this.openStart = o);
            }
        }
    ], [
        {
            key: "build",
            value: function(t, n, r, o, i) {
                var a = new e(t, n, r, i);
                return a.openEnd = OV.spans(o, n, r, a), a.openStart < 0 && (a.openStart = a.openEnd), a.finish(a.openEnd), a;
            }
        }
    ]), e;
}();
function sW(e, t) {
    var n, r = bo(t);
    try {
        for(r.s(); !(n = r.n()).done;){
            var o = n.value;
            e = new qH(o, [
                e
            ], e.length);
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    return e;
}
var cW = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).tag = e, n;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e.tag == this.tag;
            }
        },
        {
            key: "toDOM",
            value: function() {
                return document.createElement(this.tag);
            }
        },
        {
            key: "updateDOM",
            value: function(e) {
                return e.nodeName.toLowerCase() == this.tag;
            }
        },
        {
            key: "isHidden",
            get: function() {
                return !0;
            }
        }
    ]), t;
}(), lW = function(e) {
    return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
}(lW || (lW = {})), uW = lW.LTR, fW = lW.RTL;
function dW(e) {
    for(var t = [], n = 0; n < e.length; n++)t.push(1 << +e[n]);
    return t;
}
for(var hW = dW("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), vW = dW("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), pW = Object.create(null), mW = [], gW = 0, yW = [
    "()",
    "[]",
    "{}"
]; gW < yW.length; gW++){
    var bW = yW[gW], wW = bW.charCodeAt(0), xW = bW.charCodeAt(1);
    pW[wW] = xW, pW[xW] = -wW;
}
function kW(e) {
    return e <= 247 ? hW[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? vW[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8204 ? 256 : 64336 <= e && e <= 65023 ? 4 : 1;
}
var jW = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/, SW = function() {
    function e(t, n, r) {
        No(this, e), this.from = t, this.to = n, this.level = r;
    }
    return Do(e, [
        {
            key: "dir",
            get: function() {
                return this.level % 2 ? fW : uW;
            }
        },
        {
            key: "side",
            value: function(e, t) {
                return this.dir == t == e ? this.to : this.from;
            }
        },
        {
            key: "forward",
            value: function(e, t) {
                return e == (this.dir == t);
            }
        }
    ], [
        {
            key: "find",
            value: function(e, t, n, r) {
                for(var o = -1, i = 0; i < e.length; i++){
                    var a = e[i];
                    if (a.from <= t && a.to >= t) {
                        if (a.level == n) return i;
                        (o < 0 || (0 != r ? r < 0 ? a.from < t : a.to > t : e[o].level > a.level)) && (o = i);
                    }
                }
                if (o < 0) throw new RangeError("Index out of range");
                return o;
            }
        }
    ]), e;
}();
function CW(e, t) {
    if (e.length != t.length) return !1;
    for(var n = 0; n < e.length; n++){
        var r = e[n], o = t[n];
        if (r.from != o.from || r.to != o.to || r.direction != o.direction || !CW(r.inner, o.inner)) return !1;
    }
    return !0;
}
var $W = [];
function _W(e, t, n, r, o, i, a) {
    var s = r % 2 ? 2 : 1;
    if (r % 2 == o % 2) for(var c = t, l = 0; c < n;){
        var u = !0, f = !1;
        if (l == i.length || c < i[l].from) {
            var d = $W[c];
            d != s && (u = !1, f = 16 == d);
        }
        var h = u || 1 != s ? null : [], v = u ? r : r + 1, p = c;
        e: for(;;)if (l < i.length && p == i[l].from) {
            if (f) break e;
            var m = i[l];
            if (!u) for(var g = m.to, y = l + 1;;){
                if (g == n) break e;
                if (!(y < i.length && i[y].from == g)) {
                    if ($W[g] == s) break e;
                    break;
                }
                g = i[y++].to;
            }
            if (l++, h) h.push(m);
            else m.from > c && a.push(new SW(c, m.from, v)), OW(e, m.direction == uW != !(v % 2) ? r + 1 : r, o, m.inner, m.from, m.to, a), c = m.to;
            p = m.to;
        } else {
            if (p == n || (u ? $W[p] != s : $W[p] == s)) break;
            p++;
        }
        h ? _W(e, c, p, r + 1, o, h, a) : c < p && a.push(new SW(c, p, v)), c = p;
    }
    else for(var b = n, w = i.length; b > t;){
        var x = !0, k = !1;
        if (!w || b > i[w - 1].to) {
            var j = $W[b - 1];
            j != s && (x = !1, k = 16 == j);
        }
        var S = x || 1 != s ? null : [], C = x ? r : r + 1, $ = b;
        e: for(;;)if (w && $ == i[w - 1].to) {
            if (k) break e;
            var _ = i[--w];
            if (!x) for(var O = _.from, M = w;;){
                if (O == t) break e;
                if (!M || i[M - 1].to != O) {
                    if ($W[O - 1] == s) break e;
                    break;
                }
                O = i[--M].from;
            }
            if (S) S.push(_);
            else _.to < b && a.push(new SW(_.to, b, C)), OW(e, _.direction == uW != !(C % 2) ? r + 1 : r, o, _.inner, _.from, _.to, a), b = _.from;
            $ = _.from;
        } else {
            if ($ == t || (x ? $W[$ - 1] != s : $W[$ - 1] == s)) break;
            $--;
        }
        S ? _W(e, $, b, r + 1, o, S, a) : $ < b && a.push(new SW($, b, C)), b = $;
    }
}
function OW(e, t, n, r, o, i, a) {
    var s = t % 2 ? 2 : 1;
    !function(e, t, n, r, o) {
        for(var i = 0; i <= r.length; i++){
            for(var a = i ? r[i - 1].to : t, s = i < r.length ? r[i].from : n, c = i ? 256 : o, l = a, u = c, f = c; l < s; l++){
                var d = kW(e.charCodeAt(l));
                512 == d ? d = u : 8 == d && 4 == f && (d = 16), $W[l] = 4 == d ? 2 : d, 7 & d && (f = d), u = d;
            }
            for(var h = a, v = c, p = c; h < s; h++){
                var m = $W[h];
                if (128 == m) h < s - 1 && v == $W[h + 1] && 24 & v ? m = $W[h] = v : $W[h] = 256;
                else if (64 == m) {
                    for(var g = h + 1; g < s && 64 == $W[g];)g++;
                    for(var y = h && 8 == v || g < n && 8 == $W[g] ? 1 == p ? 1 : 8 : 256, b = h; b < g; b++)$W[b] = y;
                    h = g - 1;
                } else 8 == m && 1 == p && ($W[h] = 1);
                v = m, 7 & m && (p = m);
            }
        }
    }(e, o, i, r, s), function(e, t, n, r, o) {
        for(var i = 1 == o ? 2 : 1, a = 0, s = 0, c = 0; a <= r.length; a++)for(var l, u, f, d = a ? r[a - 1].to : t, h = a < r.length ? r[a].from : n, v = d; v < h; v++)if (u = pW[l = e.charCodeAt(v)]) {
            if (u < 0) {
                for(var p = s - 3; p >= 0; p -= 3)if (mW[p + 1] == -u) {
                    var m = mW[p + 2], g = 2 & m ? o : 4 & m ? 1 & m ? i : o : 0;
                    g && ($W[v] = $W[mW[p]] = g), s = p;
                    break;
                }
            } else {
                if (189 == mW.length) break;
                mW[s++] = v, mW[s++] = l, mW[s++] = c;
            }
        } else if (2 == (f = $W[v]) || 1 == f) {
            var y = f == o;
            c = y ? 0 : 1;
            for(var b = s - 3; b >= 0; b -= 3){
                var w = mW[b + 2];
                if (2 & w) break;
                if (y) mW[b + 2] |= 2;
                else {
                    if (4 & w) break;
                    mW[b + 2] |= 4;
                }
            }
        }
    }(e, o, i, r, s), function(e, t, n, r) {
        for(var o = 0, i = r; o <= n.length; o++)for(var a = o ? n[o - 1].to : e, s = o < n.length ? n[o].from : t, c = a; c < s;){
            var l = $W[c];
            if (256 == l) {
                for(var u = c + 1;;)if (u == s) {
                    if (o == n.length) break;
                    u = n[o++].to, s = o < n.length ? n[o].from : t;
                } else {
                    if (256 != $W[u]) break;
                    u++;
                }
                for(var f = 1 == i, d = f == (1 == (u < t ? $W[u] : r)) ? f ? 1 : 2 : r, h = u, v = o, p = v ? n[v - 1].to : e; h > c;)h == p && (h = n[--v].from, p = v ? n[v - 1].to : e), $W[--h] = d;
                c = u;
            } else i = l, c++;
        }
    }(o, i, r, s), _W(e, o, i, t, n, r, a);
}
function MW(e) {
    return [
        new SW(0, e, 0)
    ];
}
var EW = "";
function AW(e, t, n, r, o) {
    var i, a = r.head - e.from, s = SW.find(t, a, null !== (i = r.bidiLevel) && void 0 !== i ? i : -1, r.assoc), c = t[s], l = c.side(o, n);
    if (a == l) {
        var u = s += o ? 1 : -1;
        if (u < 0 || u >= t.length) return null;
        a = (c = t[s = u]).side(!o, n), l = c.side(o, n);
    }
    var f = hF(e.text, a, c.forward(o, n));
    (f < c.from || f > c.to) && (f = l), EW = e.text.slice(Math.min(a, f), Math.max(a, f));
    var d = s == (o ? t.length - 1 : 0) ? null : t[s + (o ? 1 : -1)];
    return d && f == l && d.level + (o ? 0 : 1) < c.level ? PF.cursor(d.side(!o, n) + e.from, d.forward(o, n) ? 1 : -1, d.level) : PF.cursor(f + e.from, c.forward(o, n) ? -1 : 1, c.level);
}
function PW(e, t, n) {
    for(var r = t; r < n; r++){
        var o = kW(e.charCodeAt(r));
        if (1 == o) return uW;
        if (2 == o || 4 == o) return fW;
    }
    return uW;
}
var TW = NF.define(), RW = NF.define(), NW = NF.define(), IW = NF.define(), DW = NF.define(), zW = NF.define(), qW = NF.define(), BW = NF.define({
    combine: function(e) {
        return e.some(function(e) {
            return e;
        });
    }
}), LW = NF.define({
    combine: function(e) {
        return e.some(function(e) {
            return e;
        });
    }
}), FW = function() {
    function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "nearest", r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "nearest", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 5, i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 5, a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        No(this, e), this.range = t, this.y = n, this.x = r, this.yMargin = o, this.xMargin = i, this.isSnapshot = a;
    }
    return Do(e, [
        {
            key: "map",
            value: function(t) {
                return t.empty ? this : new e(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
            }
        },
        {
            key: "clip",
            value: function(t) {
                return this.range.to <= t.doc.length ? this : new e(PF.cursor(t.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
            }
        }
    ]), e;
}(), VW = uV.define({
    map: function(e, t) {
        return e.map(t);
    }
});
function HW(e, t, n) {
    var r = e.facet(IW);
    r.length ? r[0](t) : window.onerror ? window.onerror(String(t), n, void 0, void 0, t) : n ? console.error(n + ":", t) : console.error(t);
}
var WW = NF.define({
    combine: function(e) {
        return !e.length || e[0];
    }
}), UW = 0, JW = NF.define(), KW = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.id = t, this.create = n, this.domEventHandlers = r, this.domEventObservers = o, this.extension = i(this);
    }
    return Do(e, null, [
        {
            key: "define",
            value: function(t, n) {
                var r = n || {}, o = r.eventHandlers, i = r.eventObservers, a = r.provide, s = r.decorations;
                return new e(UW++, t, o, i, function(e) {
                    var t = [
                        JW.of(e)
                    ];
                    return s && t.push(XW.of(function(t) {
                        var n = t.plugin(e);
                        return n ? s(n) : eW.none;
                    })), a && t.push(a(e)), t;
                });
            }
        },
        {
            key: "fromClass",
            value: function(t, n) {
                return e.define(function(e) {
                    return new t(e);
                }, n);
            }
        }
    ]), e;
}(), GW = function() {
    function e(t) {
        No(this, e), this.spec = t, this.mustUpdate = null, this.value = null;
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                if (this.value) {
                    if (this.mustUpdate) {
                        var t = this.mustUpdate;
                        if (this.mustUpdate = null, this.value.update) try {
                            this.value.update(t);
                        } catch (e) {
                            if (HW(t.state, e, "CodeMirror plugin crashed"), this.value.destroy) try {
                                this.value.destroy();
                            } catch (e) {}
                            this.deactivate();
                        }
                    }
                } else if (this.spec) try {
                    this.value = this.spec.create(e);
                } catch (t) {
                    HW(e.state, t, "CodeMirror plugin crashed"), this.deactivate();
                }
                return this;
            }
        },
        {
            key: "destroy",
            value: function(e) {
                var t;
                if (null === (t = this.value) || void 0 === t ? void 0 : t.destroy) try {
                    this.value.destroy();
                } catch (t) {
                    HW(e.state, t, "CodeMirror plugin crashed");
                }
            }
        },
        {
            key: "deactivate",
            value: function() {
                this.spec = this.value = null;
            }
        }
    ]), e;
}(), QW = NF.define(), YW = NF.define(), XW = NF.define(), ZW = NF.define(), eU = NF.define(), tU = NF.define();
function nU(e, t) {
    var n = e.state.facet(tU);
    if (!n.length) return n;
    var r = n.map(function(t) {
        return t instanceof Function ? t(e) : t;
    }), o = [];
    return OV.spans(r, t.from, t.to, {
        point: function() {},
        span: function(e, n, r, i) {
            for(var a = e - t.from, s = n - t.from, c = o, l = r.length - 1; l >= 0; l--, i--){
                var u = r[l].spec.bidiIsolate, f = void 0;
                if (null == u && (u = PW(t.text, a, s)), i > 0 && c.length && (f = c[c.length - 1]).to == a && f.direction == u) f.to = s, c = f.inner;
                else {
                    var d = {
                        from: a,
                        to: s,
                        direction: u,
                        inner: []
                    };
                    c.push(d), c = d.inner;
                }
            }
        }
    }), o;
}
var rU = NF.define();
function oU(e) {
    var t, n = 0, r = 0, o = 0, i = 0, a = bo(e.state.facet(rU));
    try {
        for(a.s(); !(t = a.n()).done;){
            var s = (0, t.value)(e);
            s && (null != s.left && (n = Math.max(n, s.left)), null != s.right && (r = Math.max(r, s.right)), null != s.top && (o = Math.max(o, s.top)), null != s.bottom && (i = Math.max(i, s.bottom)));
        }
    } catch (e) {
        a.e(e);
    } finally{
        a.f();
    }
    return {
        left: n,
        right: r,
        top: o,
        bottom: i
    };
}
var iU = NF.define(), aU = function() {
    function e(t, n, r, o) {
        No(this, e), this.fromA = t, this.toA = n, this.fromB = r, this.toB = o;
    }
    return Do(e, [
        {
            key: "join",
            value: function(t) {
                return new e(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
            }
        },
        {
            key: "addToSet",
            value: function(e) {
                for(var t = e.length, n = this; t > 0; t--){
                    var r = e[t - 1];
                    if (!(r.fromA > n.toA)) {
                        if (r.toA < n.fromA) break;
                        n = n.join(r), e.splice(t - 1, 1);
                    }
                }
                return e.splice(t, 0, n), e;
            }
        }
    ], [
        {
            key: "extendWithRanges",
            value: function(t, n) {
                if (0 == n.length) return t;
                for(var r = [], o = 0, i = 0, a = 0, s = 0;; o++){
                    for(var c = o == t.length ? null : t[o], l = a - s, u = c ? c.fromB : 1e9; i < n.length && n[i] < u;){
                        var f = n[i], d = n[i + 1], h = Math.max(s, f), v = Math.min(u, d);
                        if (h <= v && new e(h + l, v + l, h, v).addToSet(r), d > u) break;
                        i += 2;
                    }
                    if (!c) return r;
                    new e(c.fromA, c.toA, c.fromB, c.toB).addToSet(r), a = c.toA, s = c.toB;
                }
            }
        }
    ]), e;
}(), sU = function() {
    function e(t, n, r) {
        No(this, e), this.view = t, this.state = n, this.transactions = r, this.flags = 0, this.startState = t.state, this.changes = SF.empty(this.startState.doc.length);
        var o, i = bo(r);
        try {
            for(i.s(); !(o = i.n()).done;){
                var a = o.value;
                this.changes = this.changes.compose(a.changes);
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        var s = [];
        this.changes.iterChangedRanges(function(e, t, n, r) {
            return s.push(new aU(e, t, n, r));
        }), this.changedRanges = s;
    }
    return Do(e, [
        {
            key: "viewportChanged",
            get: function() {
                return (4 & this.flags) > 0;
            }
        },
        {
            key: "heightChanged",
            get: function() {
                return (2 & this.flags) > 0;
            }
        },
        {
            key: "geometryChanged",
            get: function() {
                return this.docChanged || (10 & this.flags) > 0;
            }
        },
        {
            key: "focusChanged",
            get: function() {
                return (1 & this.flags) > 0;
            }
        },
        {
            key: "docChanged",
            get: function() {
                return !this.changes.empty;
            }
        },
        {
            key: "selectionSet",
            get: function() {
                return this.transactions.some(function(e) {
                    return e.selection;
                });
            }
        },
        {
            key: "empty",
            get: function() {
                return 0 == this.flags && 0 == this.transactions.length;
            }
        }
    ], [
        {
            key: "create",
            value: function(t, n, r) {
                return new e(t, n, r);
            }
        }
    ]), e;
}(), cU = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).view = e, n.decorations = [], n.dynamicDecorationMap = [], n.domChanged = null, n.hasComposition = null, n.markedForComposition = new Set, n.minWidth = 0, n.minWidthFrom = 0, n.minWidthTo = 0, n.impreciseAnchor = null, n.impreciseHead = null, n.forceSelection = !1, n.lastUpdate = Date.now(), n.setDOM(e.contentDOM), n.children = [
            new QH
        ], n.children[0].setParent(Eo(n)), n.updateDeco(), n.updateInner([
            new aU(0, 0, 0, e.state.doc.length)
        ], 0, null), n;
    }
    return Ao(t, xH), Do(t, [
        {
            key: "length",
            get: function() {
                return this.view.state.doc.length;
            }
        },
        {
            key: "update",
            value: function(e) {
                var t, n = this, r = e.changedRanges;
                this.minWidth > 0 && r.length && (r.every(function(e) {
                    var t = e.fromA;
                    return e.toA < n.minWidthFrom || t > n.minWidthTo;
                }) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
                var o = -1;
                this.view.inputState.composing >= 0 && ((null === (t = this.domChanged) || void 0 === t ? void 0 : t.newSel) ? o = this.domChanged.newSel.head : function(e, t) {
                    var n = !1;
                    t && e.iterChangedRanges(function(e, r) {
                        e < t.to && r > t.from && (n = !0);
                    });
                    return n;
                }(e.changes, this.hasComposition) || e.selectionSet || (o = e.state.selection.main.head));
                var i = o > -1 ? function(e, t, n) {
                    var r = uU(e, n);
                    if (!r) return null;
                    var o = r.node, i = r.from, a = r.to, s = o.nodeValue;
                    if (/[\n\r]/.test(s)) return null;
                    if (e.state.doc.sliceString(r.from, r.to) != s) return null;
                    for(var c = t.invertedDesc, l = new aU(c.mapPos(i), c.mapPos(a), i, a), u = [], f = o.parentNode;; f = f.parentNode){
                        var d = xH.get(f);
                        if (d instanceof qH) u.push({
                            node: f,
                            deco: d.mark
                        });
                        else {
                            if (d instanceof QH || "DIV" == f.nodeName && f.parentNode == e.contentDOM) return {
                                range: l,
                                text: o,
                                marks: u,
                                line: f
                            };
                            if (f == e.contentDOM) return null;
                            u.push({
                                node: f,
                                deco: new tW({
                                    inclusive: !0,
                                    attributes: GH(f),
                                    tagName: f.tagName.toLowerCase()
                                })
                            });
                        }
                    }
                }(this.view, e.changes, o) : null;
                if (this.domChanged = null, this.hasComposition) {
                    this.markedForComposition.clear();
                    var a = this.hasComposition, s = a.from, c = a.to;
                    r = new aU(s, c, e.changes.mapPos(s, -1), e.changes.mapPos(c, 1)).addToSet(r.slice());
                }
                this.hasComposition = i ? {
                    from: i.range.fromB,
                    to: i.range.toB
                } : null, (DH.ie || DH.chrome) && !i && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
                var l, u, f, d, h = this.decorations, v = this.updateDeco(), p = (l = h, u = v, f = e.changes, d = new dU, OV.compare(l, u, f, d), d.changes);
                return r = aU.extendWithRanges(r, p), !!(7 & this.flags || 0 != r.length) && (this.updateInner(r, e.startState.doc.length, i), e.transactions.length && (this.lastUpdate = Date.now()), !0);
            }
        },
        {
            key: "updateInner",
            value: function(e, t, n) {
                var r = this;
                this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, t, n);
                var o = this.view.observer;
                o.ignore(function() {
                    r.dom.style.height = r.view.viewState.contentHeight / r.view.scaleY + "px", r.dom.style.flexBasis = r.minWidth ? r.minWidth + "px" : "";
                    var e = DH.chrome || DH.ios ? {
                        node: o.selectionRange.focusNode,
                        written: !1
                    } : void 0;
                    r.sync(r.view, e), r.flags &= -8, e && (e.written || o.selectionRange.focusNode != e.node) && (r.forceSelection = !0), r.dom.style.height = "";
                }), this.markedForComposition.forEach(function(e) {
                    return e.flags &= -9;
                });
                var i = [];
                if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
                    var a, s = bo(this.children);
                    try {
                        for(s.s(); !(a = s.n()).done;){
                            var c = a.value;
                            c instanceof YH && c.widget instanceof lU && i.push(c.dom);
                        }
                    } catch (e) {
                        s.e(e);
                    } finally{
                        s.f();
                    }
                }
                o.updateGaps(i);
            }
        },
        {
            key: "updateChildren",
            value: function(e, t, n) {
                for(var r = n ? n.range.addToSet(e.slice()) : e, o = this.childCursor(t), i = r.length - 1;; i--){
                    var a = i >= 0 ? r[i] : null;
                    if (!a) break;
                    var s = a.fromA, c = a.toA, l = a.fromB, u = a.toB, f = void 0, d = void 0, h = void 0, v = void 0;
                    if (n && n.range.fromB < u && n.range.toB > l) {
                        var p = aW.build(this.view.state.doc, l, n.range.fromB, this.decorations, this.dynamicDecorationMap), m = aW.build(this.view.state.doc, n.range.toB, u, this.decorations, this.dynamicDecorationMap);
                        d = p.breakAtStart, h = p.openStart, v = m.openEnd;
                        var g = this.compositionView(n);
                        m.breakAtStart ? g.breakAfter = 1 : m.content.length && g.merge(g.length, g.length, m.content[0], !1, m.openStart, 0) && (g.breakAfter = m.content[0].breakAfter, m.content.shift()), p.content.length && g.merge(0, 0, p.content[p.content.length - 1], !0, 0, p.openEnd) && p.content.pop(), f = p.content.concat(g).concat(m.content);
                    } else {
                        var y = aW.build(this.view.state.doc, l, u, this.decorations, this.dynamicDecorationMap);
                        f = y.content, d = y.breakAtStart, h = y.openStart, v = y.openEnd;
                    }
                    var b = o.findPos(c, 1), w = b.i, x = b.off, k = o.findPos(s, -1);
                    SH(this, k.i, k.off, w, x, f, d, h, v);
                }
                n && this.fixCompositionDOM(n);
            }
        },
        {
            key: "compositionView",
            value: function(e) {
                var t = new zH(e.text.nodeValue);
                t.flags |= 8;
                var n, r = bo(e.marks);
                try {
                    for(r.s(); !(n = r.n()).done;){
                        var o = n.value.deco;
                        t = new qH(o, [
                            t
                        ], t.length);
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                var i = new QH;
                return i.append(t, 0), i;
            }
        },
        {
            key: "fixCompositionDOM",
            value: function(e) {
                var t = this, n = function(e, n) {
                    n.flags |= 8 | (n.children.some(function(e) {
                        return 7 & e.flags;
                    }) ? 1 : 0), t.markedForComposition.add(n);
                    var r = xH.get(e);
                    r && r != n && (r.dom = null), n.setDOM(e);
                }, r = this.childPos(e.range.fromB, 1), o = this.children[r.i];
                n(e.line, o);
                for(var i = e.marks.length - 1; i >= -1; i--)r = o.childPos(r.off, 1), o = o.children[r.i], n(i >= 0 ? e.marks[i].node : e.text, o);
            }
        },
        {
            key: "updateSelection",
            value: function() {
                var e = this, t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                !(arguments.length > 0 && void 0 !== arguments[0] && arguments[0]) && this.view.observer.selectionRange.focusNode || this.view.observer.readSelectionRange();
                var n = this.view.root.activeElement, r = n == this.dom, o = !r && nH(this.dom, this.view.observer.selectionRange) && !(n && this.dom.contains(n));
                if (r || t || o) {
                    var i = this.forceSelection;
                    this.forceSelection = !1;
                    var a, s = this.view.state.selection.main, c = this.moveToLine(this.domAtPos(s.anchor)), l = s.empty ? c : this.moveToLine(this.domAtPos(s.head));
                    if (DH.gecko && s.empty && !this.hasComposition && 1 == (a = c).node.nodeType && a.node.firstChild && (0 == a.offset || "false" == a.node.childNodes[a.offset - 1].contentEditable) && (a.offset == a.node.childNodes.length || "false" == a.node.childNodes[a.offset].contentEditable)) {
                        var u = document.createTextNode("");
                        this.view.observer.ignore(function() {
                            return c.node.insertBefore(u, c.node.childNodes[c.offset] || null);
                        }), c = l = new bH(u, 0), i = !0;
                    }
                    var f = this.view.observer.selectionRange;
                    !i && f.focusNode && (oH(c.node, c.offset, f.anchorNode, f.anchorOffset) && oH(l.node, l.offset, f.focusNode, f.focusOffset) || this.suppressWidgetCursorChange(f, s)) || (this.view.observer.ignore(function() {
                        DH.android && DH.chrome && e.dom.contains(f.focusNode) && function(e, t) {
                            for(var n = e; n && n != t; n = n.assignedSlot || n.parentNode)if (1 == n.nodeType && "false" == n.contentEditable) return !0;
                            return !1;
                        }(f.focusNode, e.dom) && (e.dom.blur(), e.dom.focus({
                            preventScroll: !0
                        }));
                        var t = eH(e.view.root);
                        if (t) {
                            if (s.empty) {
                                if (DH.gecko) {
                                    var r = function(e, t) {
                                        return 1 != e.nodeType ? 0 : (t && "false" == e.childNodes[t - 1].contentEditable ? 1 : 0) | (t < e.childNodes.length && "false" == e.childNodes[t].contentEditable ? 2 : 0);
                                    }(c.node, c.offset);
                                    if (r && 3 != r) {
                                        var i = fU(c.node, c.offset, 1 == r ? 1 : -1);
                                        i && (c = new bH(i.node, i.offset));
                                    }
                                }
                                t.collapse(c.node, c.offset), null != s.bidiLevel && void 0 !== t.caretBidiLevel && (t.caretBidiLevel = s.bidiLevel);
                            } else if (t.extend) {
                                t.collapse(c.node, c.offset);
                                try {
                                    t.extend(l.node, l.offset);
                                } catch (e) {}
                            } else {
                                var a = document.createRange();
                                if (s.anchor > s.head) {
                                    var u = [
                                        l,
                                        c
                                    ];
                                    c = u[0], l = u[1];
                                }
                                a.setEnd(l.node, l.offset), a.setStart(c.node, c.offset), t.removeAllRanges(), t.addRange(a);
                            }
                        } else ;
                        o && e.view.root.activeElement == e.dom && (e.dom.blur(), n && n.focus());
                    }), this.view.observer.setSelectionRange(c, l)), this.impreciseAnchor = c.precise ? null : new bH(f.anchorNode, f.anchorOffset), this.impreciseHead = l.precise ? null : new bH(f.focusNode, f.focusOffset);
                }
            }
        },
        {
            key: "suppressWidgetCursorChange",
            value: function(e, t) {
                return this.hasComposition && t.empty && oH(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == t.head;
            }
        },
        {
            key: "enforceCursorAssoc",
            value: function() {
                if (!this.hasComposition) {
                    var e = this.view, t = e.state.selection.main, n = eH(e.root), r = e.observer.selectionRange, o = r.anchorNode, i = r.anchorOffset;
                    if (n && t.empty && t.assoc && n.modify) {
                        var a = QH.find(this, t.head);
                        if (a) {
                            var s = a.posAtStart;
                            if (t.head != s && t.head != s + a.length) {
                                var c = this.coordsAt(t.head, -1), l = this.coordsAt(t.head, 1);
                                if (c && l && !(c.bottom > l.top)) {
                                    var u = this.domAtPos(t.head + t.assoc);
                                    n.collapse(u.node, u.offset), n.modify("move", t.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
                                    var f = e.observer.selectionRange;
                                    e.docView.posFromDOM(f.anchorNode, f.anchorOffset) != t.from && n.collapse(o, i);
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            key: "moveToLine",
            value: function(e) {
                var t, n = this.dom;
                if (e.node != n) return e;
                for(var r = e.offset; !t && r < n.childNodes.length; r++){
                    var o = xH.get(n.childNodes[r]);
                    o instanceof QH && (t = o.domAtPos(0));
                }
                for(var i = e.offset - 1; !t && i >= 0; i--){
                    var a = xH.get(n.childNodes[i]);
                    a instanceof QH && (t = a.domAtPos(a.length));
                }
                return t ? new bH(t.node, t.offset, !0) : e;
            }
        },
        {
            key: "nearest",
            value: function(e) {
                for(var t = e; t;){
                    var n = xH.get(t);
                    if (n && n.rootView == this) return n;
                    t = t.parentNode;
                }
                return null;
            }
        },
        {
            key: "posFromDOM",
            value: function(e, t) {
                var n = this.nearest(e);
                if (!n) throw new RangeError("Trying to find position for a DOM position outside of the document");
                return n.localPosFromDOM(e, t) + n.posAtStart;
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                for(var t = this.childCursor().findPos(e, -1), n = t.i, r = t.off; n < this.children.length - 1;){
                    var o = this.children[n];
                    if (r < o.length || o instanceof QH) break;
                    n++, r = 0;
                }
                return this.children[n].domAtPos(r);
            }
        },
        {
            key: "coordsAt",
            value: function(e, t) {
                for(var n = null, r = 0, o = this.length, i = this.children.length - 1; i >= 0; i--){
                    var a = this.children[i], s = o - a.breakAfter, c = s - a.length;
                    if (s < e) break;
                    c <= e && (c < e || a.covers(-1)) && (s > e || a.covers(1)) && (!n || a instanceof QH && !(n instanceof QH && t >= 0)) && (n = a, r = c), o = c;
                }
                return n ? n.coordsAt(e - r, t) : null;
            }
        },
        {
            key: "coordsForChar",
            value: function(e) {
                var t = this.childPos(e, 1), n = t.i, r = t.off, o = this.children[n];
                if (!(o instanceof QH)) return null;
                for(; o.children.length;){
                    for(var i = o.childPos(r, 1), a = i.i, s = i.off;; a++){
                        if (a == o.children.length) return null;
                        if ((o = o.children[a]).length) break;
                    }
                    r = s;
                }
                if (!(o instanceof zH)) return null;
                var c = hF(o.text, r);
                if (c == r) return null;
                for(var l = pH(o.dom, r, c).getClientRects(), u = 0; u < l.length; u++){
                    var f = l[u];
                    if (u == l.length - 1 || f.top < f.bottom && f.left < f.right) return f;
                }
                return null;
            }
        },
        {
            key: "measureVisibleLineHeights",
            value: function(e) {
                for(var t = [], n = e.from, r = e.to, o = this.view.contentDOM.clientWidth, i = o > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, s = this.view.textDirection == lW.LTR, c = 0, l = 0; l < this.children.length; l++){
                    var u = this.children[l], f = c + u.length;
                    if (f > r) break;
                    if (c >= n) {
                        var d = u.dom.getBoundingClientRect();
                        if (t.push(d.height), i) {
                            var h = u.dom.lastChild, v = h ? rH(h) : [];
                            if (v.length) {
                                var p = v[v.length - 1], m = s ? p.right - d.left : d.right - p.left;
                                m > a && (a = m, this.minWidth = o, this.minWidthFrom = c, this.minWidthTo = f);
                            }
                        }
                    }
                    c = f + u.breakAfter;
                }
                return t;
            }
        },
        {
            key: "textDirectionAt",
            value: function(e) {
                var t = this.childPos(e, 1).i;
                return "rtl" == getComputedStyle(this.children[t].dom).direction ? lW.RTL : lW.LTR;
            }
        },
        {
            key: "measureTextSize",
            value: function() {
                var e, t = this, n = bo(this.children);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var r = e.value;
                        if (r instanceof QH) {
                            var o = r.measureTextSize();
                            if (o) return o;
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                var i, a, s, c = document.createElement("div");
                return c.className = "cm-line", c.style.width = "99999px", c.style.position = "absolute", c.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(function() {
                    t.dom.appendChild(c);
                    var e = rH(c.firstChild)[0];
                    i = c.getBoundingClientRect().height, a = e ? e.width / 27 : 7, s = e ? e.height : i, c.remove();
                }), {
                    lineHeight: i,
                    charWidth: a,
                    textHeight: s
                };
            }
        },
        {
            key: "childCursor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.length, t = this.children.length;
                return t && (e -= this.children[--t].length), new jH(this.children, e, t);
            }
        },
        {
            key: "computeBlockGapDeco",
            value: function() {
                for(var e = [], t = this.view.viewState, n = 0, r = 0;; r++){
                    var o = r == t.viewports.length ? null : t.viewports[r], i = o ? o.from - 1 : this.length;
                    if (i > n) {
                        var a = (t.lineBlockAt(i).bottom - t.lineBlockAt(n).top) / this.view.scaleY;
                        e.push(eW.replace({
                            widget: new lU(a),
                            block: !0,
                            inclusive: !0,
                            isBlockGap: !0
                        }).range(n, i));
                    }
                    if (!o) break;
                    n = o.to + 1;
                }
                return eW.set(e);
            }
        },
        {
            key: "updateDeco",
            value: function() {
                var e = this, t = this.view.state.facet(XW).map(function(t, n) {
                    return (e.dynamicDecorationMap[n] = "function" == typeof t) ? t(e.view) : t;
                }), n = !1, r = this.view.state.facet(ZW).map(function(t, r) {
                    var o = "function" == typeof t;
                    return o && (n = !0), o ? t(e.view) : t;
                });
                r.length && (this.dynamicDecorationMap[t.length] = n, t.push(OV.join(r)));
                for(var o = t.length; o < t.length + 3; o++)this.dynamicDecorationMap[o] = !1;
                return this.decorations = [].concat(Bo(t), [
                    this.computeBlockGapDeco(),
                    this.view.viewState.lineGapDeco
                ]);
            }
        },
        {
            key: "scrollIntoView",
            value: function(e) {
                if (e.isSnapshot) {
                    var t = this.view.viewState.lineBlockAt(e.range.head);
                    return this.view.scrollDOM.scrollTop = t.top - e.yMargin, void (this.view.scrollDOM.scrollLeft = e.xMargin);
                }
                var n, r = e.range, o = this.coordsAt(r.head, r.empty ? r.assoc : r.head > r.anchor ? -1 : 1);
                if (o) {
                    !r.empty && (n = this.coordsAt(r.anchor, r.anchor > r.head ? -1 : 1)) && (o = {
                        left: Math.min(o.left, n.left),
                        top: Math.min(o.top, n.top),
                        right: Math.max(o.right, n.right),
                        bottom: Math.max(o.bottom, n.bottom)
                    });
                    var i = oU(this.view), a = {
                        left: o.left - i.left,
                        top: o.top - i.top,
                        right: o.right + i.right,
                        bottom: o.bottom + i.bottom
                    }, s = this.view.scrollDOM, c = s.offsetWidth, l = s.offsetHeight;
                    !function(e, t, n, r, o, i, a, s) {
                        for(var c = e.ownerDocument, l = c.defaultView || window, u = e, f = !1; u && !f;)if (1 == u.nodeType) {
                            var d = void 0, h = u == c.body, v = 1, p = 1;
                            if (h) d = lH(l);
                            else {
                                if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (f = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
                                    u = u.assignedSlot || u.parentNode;
                                    continue;
                                }
                                var m = u.getBoundingClientRect(), g = uH(u, m);
                                v = g.scaleX, p = g.scaleY, d = {
                                    left: m.left,
                                    right: m.left + u.clientWidth * v,
                                    top: m.top,
                                    bottom: m.top + u.clientHeight * p
                                };
                            }
                            var y = 0, b = 0;
                            if ("nearest" == o) t.top < d.top ? (b = -(d.top - t.top + a), n > 0 && t.bottom > d.bottom + b && (b = t.bottom - d.bottom + b + a)) : t.bottom > d.bottom && (b = t.bottom - d.bottom + a, n < 0 && t.top - b < d.top && (b = -(d.top + b - t.top + a)));
                            else {
                                var w = t.bottom - t.top, x = d.bottom - d.top;
                                b = ("center" == o && w <= x ? t.top + w / 2 - x / 2 : "start" == o || "center" == o && n < 0 ? t.top - a : t.bottom - x + a) - d.top;
                            }
                            if ("nearest" == r ? t.left < d.left ? (y = -(d.left - t.left + i), n > 0 && t.right > d.right + y && (y = t.right - d.right + y + i)) : t.right > d.right && (y = t.right - d.right + i, n < 0 && t.left < d.left + y && (y = -(d.left + y - t.left + i))) : y = ("center" == r ? t.left + (t.right - t.left) / 2 - (d.right - d.left) / 2 : "start" == r == s ? t.left - i : t.right - (d.right - d.left) + i) - d.left, y || b) {
                                if (h) l.scrollBy(y, b);
                                else {
                                    var k = 0, j = 0;
                                    if (b) {
                                        var S = u.scrollTop;
                                        u.scrollTop += b / p, j = (u.scrollTop - S) * p;
                                    }
                                    if (y) {
                                        var C = u.scrollLeft;
                                        u.scrollLeft += y / v, k = (u.scrollLeft - C) * v;
                                    }
                                    t = {
                                        left: t.left - k,
                                        top: t.top - j,
                                        right: t.right - k,
                                        bottom: t.bottom - j
                                    }, k && Math.abs(k - y) < 1 && (r = "nearest"), j && Math.abs(j - b) < 1 && (o = "nearest");
                                }
                            }
                            if (h) break;
                            u = u.assignedSlot || u.parentNode;
                        } else {
                            if (11 != u.nodeType) break;
                            u = u.host;
                        }
                    }(this.view.scrollDOM, a, r.head < r.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, c), -c), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == lW.LTR);
                }
            }
        }
    ]), t;
}();
var lU = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).height = e, n;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "toDOM",
            value: function() {
                var e = document.createElement("div");
                return e.className = "cm-gap", this.updateDOM(e), e;
            }
        },
        {
            key: "eq",
            value: function(e) {
                return e.height == this.height;
            }
        },
        {
            key: "updateDOM",
            value: function(e) {
                return e.style.height = this.height + "px", !0;
            }
        },
        {
            key: "editable",
            get: function() {
                return !0;
            }
        },
        {
            key: "estimatedHeight",
            get: function() {
                return this.height;
            }
        },
        {
            key: "ignoreEvent",
            value: function() {
                return !1;
            }
        }
    ]), t;
}();
function uU(e, t) {
    var n = e.observer.selectionRange, r = n.focusNode && fU(n.focusNode, n.focusOffset, 0);
    if (!r) return null;
    var o = t - r.offset;
    return {
        from: o,
        to: o + r.node.nodeValue.length,
        node: r.node
    };
}
function fU(e, t, n) {
    if (n <= 0) for(var r = e, o = t;;){
        if (3 == r.nodeType) return {
            node: r,
            offset: o
        };
        if (!(1 == r.nodeType && o > 0)) break;
        o = sH(r = r.childNodes[o - 1]);
    }
    if (n >= 0) for(var i = e, a = t;;){
        if (3 == i.nodeType) return {
            node: i,
            offset: a
        };
        if (!(1 == i.nodeType && a < i.childNodes.length && n >= 0)) break;
        i = i.childNodes[a], a = 0;
    }
    return null;
}
var dU = function() {
    function e() {
        No(this, e), this.changes = [];
    }
    return Do(e, [
        {
            key: "compareRange",
            value: function(e, t) {
                iW(e, t, this.changes);
            }
        },
        {
            key: "comparePoint",
            value: function(e, t) {
                iW(e, t, this.changes);
            }
        }
    ]), e;
}();
function hU(e, t) {
    return t.left > e ? t.left - e : Math.max(0, e - t.right);
}
function vU(e, t) {
    return t.top > e ? t.top - e : Math.max(0, e - t.bottom);
}
function pU(e, t) {
    return e.top < t.bottom - 1 && e.bottom > t.top + 1;
}
function mU(e, t) {
    return t < e.top ? {
        top: t,
        left: e.left,
        right: e.right,
        bottom: e.bottom
    } : e;
}
function gU(e, t) {
    return t > e.bottom ? {
        top: e.top,
        left: e.left,
        right: e.right,
        bottom: t
    } : e;
}
function yU(e, t, n) {
    for(var r, o, i, a, s, c, l, u, f = !1, d = e.firstChild; d; d = d.nextSibling)for(var h = rH(d), v = 0; v < h.length; v++){
        var p = h[v];
        o && pU(o, p) && (p = mU(gU(p, o.bottom), o.top));
        var m = hU(t, p), g = vU(n, p);
        if (0 == m && 0 == g) return 3 == d.nodeType ? bU(d, t, n) : yU(d, t, n);
        if (!r || a > g || a == g && i > m) {
            r = d, o = p, i = m, a = g;
            var y = g ? n < p.top ? -1 : 1 : m ? t < p.left ? -1 : 1 : 0;
            f = !y || (y > 0 ? v < h.length - 1 : v > 0);
        }
        0 == m ? n > p.bottom && (!l || l.bottom < p.bottom) ? (s = d, l = p) : n < p.top && (!u || u.top > p.top) && (c = d, u = p) : l && pU(l, p) ? l = gU(l, p.bottom) : u && pU(u, p) && (u = mU(u, p.top));
    }
    if (l && l.bottom >= n ? (r = s, o = l) : u && u.top <= n && (r = c, o = u), !r) return {
        node: e,
        offset: 0
    };
    var b = Math.max(o.left, Math.min(o.right, t));
    return 3 == r.nodeType ? bU(r, b, n) : f && "false" != r.contentEditable ? yU(r, b, n) : {
        node: e,
        offset: Array.prototype.indexOf.call(e.childNodes, r) + (t >= (o.left + o.right) / 2 ? 1 : 0)
    };
}
function bU(e, t, n) {
    for(var r = e.nodeValue.length, o = -1, i = 1e9, a = 0, s = 0; s < r; s++)for(var c = pH(e, s, s + 1).getClientRects(), l = 0; l < c.length; l++){
        var u = c[l];
        if (u.top != u.bottom) {
            a || (a = t - u.left);
            var f = (u.top > n ? u.top - n : n - u.bottom) - 1;
            if (u.left - 1 <= t && u.right + 1 >= t && f < i) {
                var d = t >= (u.left + u.right) / 2, h = d;
                if (DH.chrome || DH.gecko) pH(e, s).getBoundingClientRect().left == u.right && (h = !d);
                if (f <= 0) return {
                    node: e,
                    offset: s + (h ? 1 : 0)
                };
                o = s + (h ? 1 : 0), i = f;
            }
        }
    }
    return {
        node: e,
        offset: o > -1 ? o : a > 0 ? e.nodeValue.length : 0
    };
}
function wU(e, t, n) {
    var r, o, i, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : -1, s = e.contentDOM.getBoundingClientRect(), c = s.top + e.viewState.paddingTop, l = e.viewState.docHeight, u = t.x, f = t.y, d = f - c;
    if (d < 0) return 0;
    if (d > l) return e.state.doc.length;
    for(var h = e.viewState.heightOracle.textHeight / 2, v = !1; (i = e.elementAtHeight(d)).type != ZH.Text;)for(; !((d = a > 0 ? i.bottom + h : i.top - h) >= 0 && d <= l);){
        if (v) return n ? null : 0;
        v = !0, a = -a;
    }
    f = c + d;
    var p = i.from;
    if (p < e.viewport.from) return 0 == e.viewport.from ? 0 : n ? null : xU(e, s, i, u, f);
    if (p > e.viewport.to) return e.viewport.to == e.state.doc.length ? e.state.doc.length : n ? null : xU(e, s, i, u, f);
    var m = e.dom.ownerDocument, g = e.root.elementFromPoint ? e.root : m, y = g.elementFromPoint(u, f);
    y && !e.contentDOM.contains(y) && (y = null), y || (u = Math.max(s.left + 1, Math.min(s.right - 1, u)), (y = g.elementFromPoint(u, f)) && !e.contentDOM.contains(y) && (y = null));
    var b, w = -1;
    if (y && 0 != (null === (r = e.docView.nearest(y)) || void 0 === r ? void 0 : r.isEditable)) {
        if (m.caretPositionFromPoint) {
            var x = m.caretPositionFromPoint(u, f);
            x && (b = x.offsetNode, w = x.offset);
        } else if (m.caretRangeFromPoint) {
            var k = m.caretRangeFromPoint(u, f);
            k && (b = k.startContainer, w = k.startOffset, (!e.contentDOM.contains(b) || DH.safari && function(e, t, n) {
                var r;
                if (3 != e.nodeType || t != (r = e.nodeValue.length)) return !1;
                for(var o = e.nextSibling; o; o = o.nextSibling)if (1 != o.nodeType || "BR" != o.nodeName) return !1;
                return pH(e, r - 1, r).getBoundingClientRect().left > n;
            }(b, w, u) || DH.chrome && function(e, t, n) {
                if (0 != t) return !1;
                for(var r = e;;){
                    var o = r.parentNode;
                    if (!o || 1 != o.nodeType || o.firstChild != r) return !1;
                    if (o.classList.contains("cm-line")) break;
                    r = o;
                }
                var i = 1 == e.nodeType ? e.getBoundingClientRect() : pH(e, 0, Math.max(e.nodeValue.length, 1)).getBoundingClientRect();
                return n - i.left > 5;
            }(b, w, u)) && (b = void 0));
        }
    }
    if (!b || !e.docView.dom.contains(b)) {
        var j = QH.find(e.docView, p);
        if (!j) return d > i.top + i.height / 2 ? i.to : i.from;
        var S = yU(j.dom, u, f);
        b = S.node, w = S.offset;
    }
    var C = e.docView.nearest(b);
    if (!C) return null;
    if (C.isWidget && 1 == (null === (o = C.dom) || void 0 === o ? void 0 : o.nodeType)) {
        var $ = C.dom.getBoundingClientRect();
        return t.y < $.top || t.y <= $.bottom && t.x <= ($.left + $.right) / 2 ? C.posAtStart : C.posAtEnd;
    }
    return C.localPosFromDOM(b, w) + C.posAtStart;
}
function xU(e, t, n, r, o) {
    var i = Math.round((r - t.left) * e.defaultCharacterWidth);
    if (e.lineWrapping && n.height > 1.5 * e.defaultLineHeight) {
        var a = e.viewState.heightOracle.textHeight;
        i += Math.floor((o - n.top - .5 * (e.defaultLineHeight - a)) / a) * e.viewState.heightOracle.lineLength;
    }
    var s = e.state.sliceDoc(n.from, n.to);
    return n.from + LV(s, i, e.state.tabSize);
}
function kU(e, t) {
    var n = e.lineBlockAt(t);
    if (Array.isArray(n.type)) {
        var r, o = bo(n.type);
        try {
            for(o.s(); !(r = o.n()).done;){
                var i = r.value;
                if (i.to > t || i.to == t && (i.to == n.to || i.type == ZH.Text)) return i;
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
    }
    return n;
}
function jU(e, t, n, r) {
    for(var o = e.state.doc.lineAt(t.head), i = e.bidiSpans(o), a = e.textDirectionAt(o.from), s = t, c = null;;){
        var l = AW(o, i, a, s, n), u = EW;
        if (!l) {
            if (o.number == (n ? e.state.doc.lines : 1)) return s;
            u = "\n", o = e.state.doc.line(o.number + (n ? 1 : -1)), i = e.bidiSpans(o), l = e.visualLineSide(o, !n);
        }
        if (c) {
            if (!c(u)) return s;
        } else {
            if (!r) return l;
            c = r(u);
        }
        s = l;
    }
}
function SU(e, t, n) {
    for(var r, o = function() {
        var r, o = 0, i = bo(e);
        try {
            for(i.s(); !(r = i.n()).done;)r.value.between(t - 1, t + 1, function(e, r, i) {
                if (t > e && t < r) {
                    var a = o || n || (t - e < r - t ? -1 : 1);
                    t = a < 0 ? e : r, o = a;
                }
            });
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        if (!o) return {
            v: t
        };
    };;)if (r = o()) return r.v;
}
function CU(e, t, n) {
    var r = SU(e.state.facet(eU).map(function(t) {
        return t(e);
    }), n.from, t.head > n.from ? -1 : 1);
    return r == n.from ? n : PF.cursor(r, r < n.from ? 1 : -1);
}
var $U = function() {
    function e(t) {
        No(this, e), this.view = t, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t.hasFocus, DH.safari && t.contentDOM.addEventListener("input", function() {
            return null;
        }), DH.gecko && function(e) {
            ZU.has(e) || (ZU.add(e), e.addEventListener("copy", function() {}), e.addEventListener("cut", function() {}));
        }(t.contentDOM.ownerDocument);
    }
    return Do(e, [
        {
            key: "setSelectionOrigin",
            value: function(e) {
                this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
            }
        },
        {
            key: "handleEvent",
            value: function(e) {
                (function(e, t) {
                    if (!t.bubbles) return !0;
                    if (t.defaultPrevented) return !1;
                    for(var n, r = t.target; r != e.contentDOM; r = r.parentNode)if (!r || 11 == r.nodeType || (n = xH.get(r)) && n.ignoreEvent(t)) return !1;
                    return !0;
                })(this.view, e) && !this.ignoreDuringComposition(e) && ("keydown" == e.type && this.keydown(e) || this.runHandlers(e.type, e));
            }
        },
        {
            key: "runHandlers",
            value: function(e, t) {
                var n = this.handlers[e];
                if (n) {
                    var r, o = bo(n.observers);
                    try {
                        for(o.s(); !(r = o.n()).done;)(0, r.value)(this.view, t);
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    var i, a = bo(n.handlers);
                    try {
                        for(a.s(); !(i = a.n()).done;){
                            var s = i.value;
                            if (t.defaultPrevented) break;
                            if (s(this.view, t)) {
                                t.preventDefault();
                                break;
                            }
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
            }
        },
        {
            key: "ensureHandlers",
            value: function(e) {
                var t = OU(e), n = this.handlers, r = this.view.contentDOM;
                for(var o in t)if ("scroll" != o) {
                    var i = !t[o].handlers.length, a = n[o];
                    a && i != !a.handlers.length && (r.removeEventListener(o, this.handleEvent), a = null), a || r.addEventListener(o, this.handleEvent, {
                        passive: i
                    });
                }
                for(var s in n)"scroll" == s || t[s] || r.removeEventListener(s, this.handleEvent);
                this.handlers = t;
            }
        },
        {
            key: "keydown",
            value: function(e) {
                var t, n = this;
                return this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), 9 == e.keyCode && Date.now() < this.lastEscPress + 2e3 || (27 != e.keyCode && AU.indexOf(e.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), !DH.android || !DH.chrome || e.synthetic || 13 != e.keyCode && 8 != e.keyCode ? !DH.ios || e.synthetic || e.altKey || e.metaKey || !((t = MU.find(function(t) {
                    return t.keyCode == e.keyCode;
                })) && !e.ctrlKey || EU.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (229 != e.keyCode && this.view.observer.forceFlush(), !1) : (this.pendingIOSKey = t || e, setTimeout(function() {
                    return n.flushIOSKey();
                }, 250), !0) : (this.view.observer.delayAndroidKey(e.key, e.keyCode), !0));
            }
        },
        {
            key: "flushIOSKey",
            value: function() {
                var e = this.pendingIOSKey;
                return !!e && (this.pendingIOSKey = void 0, mH(this.view.contentDOM, e.key, e.keyCode));
            }
        },
        {
            key: "ignoreDuringComposition",
            value: function(e) {
                return !!/^key/.test(e.type) && (this.composing > 0 || !!(DH.safari && !DH.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) && (this.compositionPendingKey = !1, !0));
            }
        },
        {
            key: "startMouseSelection",
            value: function(e) {
                this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
            }
        },
        {
            key: "update",
            value: function(e) {
                this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
            }
        },
        {
            key: "destroy",
            value: function() {
                this.mouseSelection && this.mouseSelection.destroy();
            }
        }
    ]), e;
}();
function _U(e, t) {
    return function(n, r) {
        try {
            return t.call(e, r, n);
        } catch (e) {
            HW(n.state, e);
        }
    };
}
function OU(e) {
    var t = Object.create(null);
    function n(e) {
        return t[e] || (t[e] = {
            observers: [],
            handlers: []
        });
    }
    var r, o = bo(e);
    try {
        for(o.s(); !(r = o.n()).done;){
            var i = r.value, a = i.spec;
            if (a && a.domEventHandlers) for(var s in a.domEventHandlers){
                var c = a.domEventHandlers[s];
                c && n(s).handlers.push(_U(i.value, c));
            }
            if (a && a.domEventObservers) for(var l in a.domEventObservers){
                var u = a.domEventObservers[l];
                u && n(l).observers.push(_U(i.value, u));
            }
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    for(var f in RU)n(f).handlers.push(RU[f]);
    for(var d in NU)n(d).observers.push(NU[d]);
    return t;
}
var MU = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
], EU = "dthko", AU = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
function PU(e) {
    return .7 * Math.max(0, e) + 8;
}
var TU = function() {
    function e(t, n, r, o) {
        No(this, e), this.view = t, this.startEvent = n, this.style = r, this.mustSelect = o, this.scrollSpeed = {
            x: 0,
            y: 0
        }, this.scrolling = -1, this.lastEvent = n, this.scrollParent = function(e) {
            for(var t = e.ownerDocument, n = e.parentNode; n && n != t.body;)if (1 == n.nodeType) {
                if (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth) return n;
                n = n.assignedSlot || n.parentNode;
            } else {
                if (11 != n.nodeType) break;
                n = n.host;
            }
            return null;
        }(t.contentDOM), this.atoms = t.state.facet(eU).map(function(e) {
            return e(t);
        });
        var i = t.contentDOM.ownerDocument;
        i.addEventListener("mousemove", this.move = this.move.bind(this)), i.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = t.state.facet(kV.allowMultipleSelections) && function(e, t) {
            var n = e.state.facet(TW);
            return n.length ? n[0](t) : DH.mac ? t.metaKey : t.ctrlKey;
        }(t, n), this.dragging = !(!function(e, t) {
            var n = e.state.selection.main;
            if (n.empty) return !1;
            var r = eH(e.root);
            if (!r || 0 == r.rangeCount) return !0;
            for(var o = r.getRangeAt(0).getClientRects(), i = 0; i < o.length; i++){
                var a = o[i];
                if (a.left <= t.clientX && a.right >= t.clientX && a.top <= t.clientY && a.bottom >= t.clientY) return !0;
            }
            return !1;
        }(t, n) || 1 != JU(n)) && null;
    }
    return Do(e, [
        {
            key: "start",
            value: function(e) {
                !1 === this.dragging && this.select(e);
            }
        },
        {
            key: "move",
            value: function(e) {
                var t;
                if (0 == e.buttons) return this.destroy();
                if (!(this.dragging || null == this.dragging && (n = this.startEvent, r = e, Math.max(Math.abs(n.clientX - r.clientX), Math.abs(n.clientY - r.clientY)) < 10))) {
                    var n, r;
                    this.select(this.lastEvent = e);
                    var o = 0, i = 0, a = (null === (t = this.scrollParent) || void 0 === t ? void 0 : t.getBoundingClientRect()) || {
                        left: 0,
                        top: 0,
                        right: this.view.win.innerWidth,
                        bottom: this.view.win.innerHeight
                    }, s = oU(this.view);
                    e.clientX - s.left <= a.left + 6 ? o = -PU(a.left - e.clientX) : e.clientX + s.right >= a.right - 6 && (o = PU(e.clientX - a.right)), e.clientY - s.top <= a.top + 6 ? i = -PU(a.top - e.clientY) : e.clientY + s.bottom >= a.bottom - 6 && (i = PU(e.clientY - a.bottom)), this.setScrollSpeed(o, i);
                }
            }
        },
        {
            key: "up",
            value: function(e) {
                null == this.dragging && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
            }
        },
        {
            key: "destroy",
            value: function() {
                this.setScrollSpeed(0, 0);
                var e = this.view.contentDOM.ownerDocument;
                e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
            }
        },
        {
            key: "setScrollSpeed",
            value: function(e, t) {
                var n = this;
                this.scrollSpeed = {
                    x: e,
                    y: t
                }, e || t ? this.scrolling < 0 && (this.scrolling = setInterval(function() {
                    return n.scroll();
                }, 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
            }
        },
        {
            key: "scroll",
            value: function() {
                this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), !1 === this.dragging && this.select(this.lastEvent);
            }
        },
        {
            key: "skipAtoms",
            value: function(e) {
                for(var t = null, n = 0; n < e.ranges.length; n++){
                    var r = e.ranges[n], o = null;
                    if (r.empty) {
                        var i = SU(this.atoms, r.from, 0);
                        i != r.from && (o = PF.cursor(i, -1));
                    } else {
                        var a = SU(this.atoms, r.from, -1), s = SU(this.atoms, r.to, 1);
                        a == r.from && s == r.to || (o = PF.range(r.from == r.anchor ? a : s, r.from == r.head ? a : s));
                    }
                    o && (t || (t = e.ranges.slice()), t[n] = o);
                }
                return t ? PF.create(t, e.mainIndex) : e;
            }
        },
        {
            key: "select",
            value: function(e) {
                var t = this.view, n = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
                !this.mustSelect && n.eq(t.state.selection, !1 === this.dragging) || this.view.dispatch({
                    selection: n,
                    userEvent: "select.pointer"
                }), this.mustSelect = !1;
            }
        },
        {
            key: "update",
            value: function(e) {
                var t = this;
                this.style.update(e) && setTimeout(function() {
                    return t.select(t.lastEvent);
                }, 20);
            }
        }
    ]), e;
}();
var RU = Object.create(null), NU = Object.create(null), IU = DH.ie && DH.ie_version < 15 || DH.ios && DH.webkit_version < 604;
function DU(e, t) {
    var n, r = e.state, o = 1, i = r.toText(t), a = i.lines == r.selection.ranges.length, s = null != GU && r.selection.ranges.every(function(e) {
        return e.empty;
    }) && GU == i.toString();
    if (s) {
        var c = -1;
        n = r.changeByRange(function(e) {
            var n = r.doc.lineAt(e.from);
            if (n.from == c) return {
                range: e
            };
            c = n.from;
            var s = r.toText((a ? i.line(o++).text : t) + r.lineBreak);
            return {
                changes: {
                    from: n.from,
                    insert: s
                },
                range: PF.cursor(e.from + s.length)
            };
        });
    } else n = a ? r.changeByRange(function(e) {
        var t = i.line(o++);
        return {
            changes: {
                from: e.from,
                to: e.to,
                insert: t.text
            },
            range: PF.cursor(e.from + t.length)
        };
    }) : r.replaceSelection(i);
    e.dispatch(n, {
        userEvent: "input.paste",
        scrollIntoView: !0
    });
}
function zU(e, t, n, r) {
    if (1 == r) return PF.cursor(t, n);
    if (2 == r) return function(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, r = e.charCategorizer(t), o = e.doc.lineAt(t), i = t - o.from;
        if (0 == o.length) return PF.cursor(t);
        0 == i ? n = 1 : i == o.length && (n = -1);
        var a = i, s = i;
        n < 0 ? a = hF(o.text, i, !1) : s = hF(o.text, i);
        for(var c = r(o.text.slice(a, s)); a > 0;){
            var l = hF(o.text, a, !1);
            if (r(o.text.slice(l, a)) != c) break;
            a = l;
        }
        for(; s < o.length;){
            var u = hF(o.text, s);
            if (r(o.text.slice(s, u)) != c) break;
            s = u;
        }
        return PF.range(a + o.from, s + o.from);
    }(e.state, t, n);
    var o = QH.find(e.docView, t), i = e.state.doc.lineAt(o ? o.posAtEnd : t), a = o ? o.posAtStart : i.from, s = o ? o.posAtEnd : i.to;
    return s < e.state.doc.length && s == i.to && s++, PF.range(a, s);
}
NU.scroll = function(e) {
    e.inputState.lastScrollTop = e.scrollDOM.scrollTop, e.inputState.lastScrollLeft = e.scrollDOM.scrollLeft;
}, RU.keydown = function(e, t) {
    return e.inputState.setSelectionOrigin("select"), 27 == t.keyCode && (e.inputState.lastEscPress = Date.now()), !1;
}, NU.touchstart = function(e, t) {
    e.inputState.lastTouchTime = Date.now(), e.inputState.setSelectionOrigin("select.pointer");
}, NU.touchmove = function(e) {
    e.inputState.setSelectionOrigin("select.pointer");
}, RU.mousedown = function(e, t) {
    if (e.observer.flush(), e.inputState.lastTouchTime > Date.now() - 2e3) return !1;
    var n, r = null, o = bo(e.state.facet(NW));
    try {
        for(o.s(); !(n = o.n()).done;){
            if (r = (0, n.value)(e, t)) break;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    if (r || 0 != t.button || (r = function(e, t) {
        var n = FU(e, t), r = JU(t), o = e.state.selection;
        return {
            update: function(e) {
                e.docChanged && (n.pos = e.changes.mapPos(n.pos), o = o.map(e.changes));
            },
            get: function(t, i, a) {
                var s, c = FU(e, t), l = zU(e, c.pos, c.bias, r);
                if (n.pos != c.pos && !i) {
                    var u = zU(e, n.pos, n.bias, r), f = Math.min(u.from, l.from), d = Math.max(u.to, l.to);
                    l = f < l.from ? PF.range(f, d) : PF.range(d, f);
                }
                return i ? o.replaceRange(o.main.extend(l.from, l.to)) : a && 1 == r && o.ranges.length > 1 && (s = function(e, t) {
                    for(var n = 0; n < e.ranges.length; n++){
                        var r = e.ranges[n], o = r.from, i = r.to;
                        if (o <= t && i >= t) return PF.create(e.ranges.slice(0, n).concat(e.ranges.slice(n + 1)), e.mainIndex == n ? 0 : e.mainIndex - (e.mainIndex > n ? 1 : 0));
                    }
                    return null;
                }(o, c.pos)) ? s : a ? o.addRange(l) : PF.create([
                    l
                ]);
            }
        };
    }(e, t)), r) {
        var i = !e.hasFocus;
        e.inputState.startMouseSelection(new TU(e, t, r, i)), i && e.observer.ignore(function() {
            return vH(e.contentDOM);
        });
        var a = e.inputState.mouseSelection;
        if (a) return a.start(t), !1 === a.dragging;
    }
    return !1;
};
var qU = function(e, t) {
    return e >= t.top && e <= t.bottom;
}, BU = function(e, t, n) {
    return qU(t, n) && e >= n.left && e <= n.right;
};
function LU(e, t, n, r) {
    var o = QH.find(e.docView, t);
    if (!o) return 1;
    var i = t - o.posAtStart;
    if (0 == i) return 1;
    if (i == o.length) return -1;
    var a = o.coordsAt(i, -1);
    if (a && BU(n, r, a)) return -1;
    var s = o.coordsAt(i, 1);
    return s && BU(n, r, s) ? 1 : a && qU(r, a) ? -1 : 1;
}
function FU(e, t) {
    var n = e.posAtCoords({
        x: t.clientX,
        y: t.clientY
    }, !1);
    return {
        pos: n,
        bias: LU(e, n, t.clientX, t.clientY)
    };
}
var VU = DH.ie && DH.ie_version <= 11, HU = null, WU = 0, UU = 0;
function JU(e) {
    if (!VU) return e.detail;
    var t = HU, n = UU;
    return HU = e, UU = Date.now(), WU = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (WU + 1) % 3 : 1;
}
function KU(e, t, n, r) {
    if (n) {
        var o = e.posAtCoords({
            x: t.clientX,
            y: t.clientY
        }, !1), i = e.inputState.draggedContent, a = r && i && function(e, t) {
            var n = e.state.facet(RW);
            return n.length ? n[0](t) : DH.mac ? !t.altKey : !t.ctrlKey;
        }(e, t) ? {
            from: i.from,
            to: i.to
        } : null, s = {
            from: o,
            insert: n
        }, c = e.state.changes(a ? [
            a,
            s
        ] : s);
        e.focus(), e.dispatch({
            changes: c,
            selection: {
                anchor: c.mapPos(o, -1),
                head: c.mapPos(o, 1)
            },
            userEvent: a ? "move.drop" : "input.drop"
        }), e.inputState.draggedContent = null;
    }
}
RU.dragstart = function(e, t) {
    var n = e.state.selection.main;
    if (t.target.draggable) {
        var r = e.docView.nearest(t.target);
        if (r && r.isWidget) {
            var o = r.posAtStart, i = o + r.length;
            (o >= n.to || i <= n.from) && (n = PF.range(o, i));
        }
    }
    var a = e.inputState;
    return a.mouseSelection && (a.mouseSelection.dragging = !0), a.draggedContent = n, t.dataTransfer && (t.dataTransfer.setData("Text", e.state.sliceDoc(n.from, n.to)), t.dataTransfer.effectAllowed = "copyMove"), !1;
}, RU.dragend = function(e) {
    return e.inputState.draggedContent = null, !1;
}, RU.drop = function(e, t) {
    if (!t.dataTransfer) return !1;
    if (e.state.readOnly) return !0;
    var n = t.dataTransfer.files;
    if (n && n.length) {
        for(var r = Array(n.length), o = 0, i = function() {
            ++o == n.length && KU(e, t, r.filter(function(e) {
                return null != e;
            }).join(e.state.lineBreak), !1);
        }, a = function(e) {
            var t = new FileReader;
            t.onerror = i, t.onload = function() {
                /[\x00-\x08\x0e-\x1f]{2}/.test(t.result) || (r[e] = t.result), i();
            }, t.readAsText(n[e]);
        }, s = 0; s < n.length; s++)a(s);
        return !0;
    }
    var c = t.dataTransfer.getData("Text");
    return !!c && (KU(e, t, c, !0), !0);
}, RU.paste = function(e, t) {
    if (e.state.readOnly) return !0;
    e.observer.flush();
    var n = IU ? null : t.clipboardData;
    return n ? (DU(e, n.getData("text/plain") || n.getData("text/uri-text")), !0) : (function(e) {
        var t = e.dom.parentNode;
        if (t) {
            var n = t.appendChild(document.createElement("textarea"));
            n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(function() {
                e.focus(), n.remove(), DU(e, n.value);
            }, 50);
        }
    }(e), !1);
};
var GU = null;
RU.copy = RU.cut = function(e, t) {
    var n = function(e) {
        var t, n = [], r = [], o = !1, i = bo(e.selection.ranges);
        try {
            for(i.s(); !(t = i.n()).done;){
                var a = t.value;
                a.empty || (n.push(e.sliceDoc(a.from, a.to)), r.push(a));
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        if (!n.length) {
            var s, c = -1, l = bo(e.selection.ranges);
            try {
                for(l.s(); !(s = l.n()).done;){
                    var u = s.value.from, f = e.doc.lineAt(u);
                    f.number > c && (n.push(f.text), r.push({
                        from: f.from,
                        to: Math.min(e.doc.length, f.to + 1)
                    })), c = f.number;
                }
            } catch (e) {
                l.e(e);
            } finally{
                l.f();
            }
            o = !0;
        }
        return {
            text: n.join(e.lineBreak),
            ranges: r,
            linewise: o
        };
    }(e.state), r = n.text, o = n.ranges, i = n.linewise;
    if (!r && !i) return !1;
    GU = i ? r : null, "cut" != t.type || e.state.readOnly || e.dispatch({
        changes: o,
        scrollIntoView: !0,
        userEvent: "delete.cut"
    });
    var a = IU ? null : t.clipboardData;
    return a ? (a.clearData(), a.setData("text/plain", r), !0) : (function(e, t) {
        var n = e.dom.parentNode;
        if (n) {
            var r = n.appendChild(document.createElement("textarea"));
            r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = t, r.focus(), r.selectionEnd = t.length, r.selectionStart = 0, setTimeout(function() {
                r.remove(), e.focus();
            }, 50);
        }
    }(e, r), !1);
};
var QU = sV.define();
function YU(e, t) {
    var n, r = [], o = bo(e.facet(qW));
    try {
        for(o.s(); !(n = o.n()).done;){
            var i = (0, n.value)(e, t);
            i && r.push(i);
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return r ? e.update({
        effects: r,
        annotations: QU.of(!0)
    }) : null;
}
function XU(e) {
    setTimeout(function() {
        var t = e.hasFocus;
        if (t != e.inputState.notifiedFocused) {
            var n = YU(e.state, t);
            n ? e.dispatch(n) : e.update([]);
        }
    }, 10);
}
NU.focus = function(e) {
    e.inputState.lastFocusTime = Date.now(), e.scrollDOM.scrollTop || !e.inputState.lastScrollTop && !e.inputState.lastScrollLeft || (e.scrollDOM.scrollTop = e.inputState.lastScrollTop, e.scrollDOM.scrollLeft = e.inputState.lastScrollLeft), XU(e);
}, NU.blur = function(e) {
    e.observer.clearSelectionRange(), XU(e);
}, NU.compositionstart = NU.compositionupdate = function(e) {
    null == e.inputState.compositionFirstChange && (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0);
}, NU.compositionend = function(e) {
    e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionPendingKey = !0, e.inputState.compositionPendingChange = e.observer.pendingRecords().length > 0, e.inputState.compositionFirstChange = null, DH.chrome && DH.android ? e.observer.flushSoon() : e.inputState.compositionPendingChange ? Promise.resolve().then(function() {
        return e.observer.flush();
    }) : setTimeout(function() {
        e.inputState.composing < 0 && e.docView.hasComposition && e.update([]);
    }, 50);
}, NU.contextmenu = function(e) {
    e.inputState.lastContextMenu = Date.now();
}, RU.beforeinput = function(e, t) {
    var n, r;
    if (DH.chrome && DH.android && (r = MU.find(function(e) {
        return e.inputType == t.inputType;
    })) && (e.observer.delayAndroidKey(r.key, r.keyCode), "Backspace" == r.key || "Delete" == r.key)) {
        var o = (null === (n = window.visualViewport) || void 0 === n ? void 0 : n.height) || 0;
        setTimeout(function() {
            var t;
            ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.height) || 0) > o + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
        }, 100);
    }
    return !1;
};
var ZU = new Set;
var eJ = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
], tJ = function() {
    function e(t) {
        No(this, e), this.lineWrapping = t, this.doc = XL.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
    }
    return Do(e, [
        {
            key: "heightForGap",
            value: function(e, t) {
                var n = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
                return this.lineWrapping && (n += Math.max(0, Math.ceil((t - e - n * this.lineLength * .5) / this.lineLength))), this.lineHeight * n;
            }
        },
        {
            key: "heightForLine",
            value: function(e) {
                return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
            }
        },
        {
            key: "setDoc",
            value: function(e) {
                return this.doc = e, this;
            }
        },
        {
            key: "mustRefreshForWrapping",
            value: function(e) {
                return eJ.indexOf(e) > -1 != this.lineWrapping;
            }
        },
        {
            key: "mustRefreshForHeights",
            value: function(e) {
                for(var t = !1, n = 0; n < e.length; n++){
                    var r = e[n];
                    r < 0 ? n++ : this.heightSamples[Math.floor(10 * r)] || (t = !0, this.heightSamples[Math.floor(10 * r)] = !0);
                }
                return t;
            }
        },
        {
            key: "refresh",
            value: function(e, t, n, r, o, i) {
                var a = eJ.indexOf(e) > -1, s = Math.round(t) != Math.round(this.lineHeight) || this.lineWrapping != a;
                if (this.lineWrapping = a, this.lineHeight = t, this.charWidth = n, this.textHeight = r, this.lineLength = o, s) {
                    this.heightSamples = {};
                    for(var c = 0; c < i.length; c++){
                        var l = i[c];
                        l < 0 ? c++ : this.heightSamples[Math.floor(10 * l)] = !0;
                    }
                }
                return s;
            }
        }
    ]), e;
}(), nJ = function() {
    function e(t, n) {
        No(this, e), this.from = t, this.heights = n, this.index = 0;
    }
    return Do(e, [
        {
            key: "more",
            get: function() {
                return this.index < this.heights.length;
            }
        }
    ]), e;
}(), rJ = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.from = t, this.length = n, this.top = r, this.height = o, this._content = i;
    }
    return Do(e, [
        {
            key: "type",
            get: function() {
                return "number" == typeof this._content ? ZH.Text : Array.isArray(this._content) ? this._content : this._content.type;
            }
        },
        {
            key: "to",
            get: function() {
                return this.from + this.length;
            }
        },
        {
            key: "bottom",
            get: function() {
                return this.top + this.height;
            }
        },
        {
            key: "widget",
            get: function() {
                return this._content instanceof rW ? this._content.widget : null;
            }
        },
        {
            key: "widgetLineBreaks",
            get: function() {
                return "number" == typeof this._content ? this._content : 0;
            }
        },
        {
            key: "join",
            value: function(t) {
                var n = (Array.isArray(this._content) ? this._content : [
                    this
                ]).concat(Array.isArray(t._content) ? t._content : [
                    t
                ]);
                return new e(this.from, this.length + t.length, this.top, this.height + t.height, n);
            }
        }
    ]), e;
}(), oJ = function(e) {
    return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
}(oJ || (oJ = {})), iJ = .001, aJ = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
        No(this, e), this.length = t, this.height = n, this.flags = r;
    }
    return Do(e, [
        {
            key: "outdated",
            get: function() {
                return (2 & this.flags) > 0;
            },
            set: function(e) {
                this.flags = (e ? 2 : 0) | -3 & this.flags;
            }
        },
        {
            key: "setHeight",
            value: function(e, t) {
                this.height != t && (Math.abs(this.height - t) > iJ && (e.heightChanged = !0), this.height = t);
            }
        },
        {
            key: "replace",
            value: function(t, n, r) {
                return e.of(r);
            }
        },
        {
            key: "decomposeLeft",
            value: function(e, t) {
                t.push(this);
            }
        },
        {
            key: "decomposeRight",
            value: function(e, t) {
                t.push(this);
            }
        },
        {
            key: "applyChanges",
            value: function(e, t, n, r) {
                for(var o = this, i = n.doc, a = r.length - 1; a >= 0; a--){
                    var s = r[a], c = s.fromA, l = s.toA, u = s.fromB, f = s.toB, d = o.lineAt(c, oJ.ByPosNoHeight, n.setDoc(t), 0, 0), h = d.to >= l ? d : o.lineAt(l, oJ.ByPosNoHeight, n, 0, 0);
                    for(f += h.to - l, l = h.to; a > 0 && d.from <= r[a - 1].toA;)c = r[a - 1].fromA, u = r[a - 1].fromB, a--, c < d.from && (d = o.lineAt(c, oJ.ByPosNoHeight, n, 0, 0));
                    u += d.from - c, c = d.from;
                    var v = dJ.build(n.setDoc(i), e, u, f);
                    o = o.replace(c, l, v);
                }
                return o.updateHeight(n, 0);
            }
        }
    ], [
        {
            key: "empty",
            value: function() {
                return new cJ(0, 0);
            }
        },
        {
            key: "of",
            value: function(t) {
                if (1 == t.length) return t[0];
                for(var n = 0, r = t.length, o = 0, i = 0;;)if (n == r) {
                    if (o > 2 * i) {
                        var a = t[n - 1];
                        a.break ? t.splice(--n, 1, a.left, null, a.right) : t.splice(--n, 1, a.left, a.right), r += 1 + a.break, o -= a.size;
                    } else {
                        if (!(i > 2 * o)) break;
                        var s = t[r];
                        s.break ? t.splice(r, 1, s.left, null, s.right) : t.splice(r, 1, s.left, s.right), r += 2 + s.break, i -= s.size;
                    }
                } else if (o < i) {
                    var c = t[n++];
                    c && (o += c.size);
                } else {
                    var l = t[--r];
                    l && (i += l.size);
                }
                var u = 0;
                return null == t[n - 1] ? (u = 1, n--) : null == t[n] && (u = 1, r++), new uJ(e.of(t.slice(0, n)), u, e.of(t.slice(r)));
            }
        }
    ]), e;
}();
aJ.prototype.size = 1;
var sJ = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t, [
            e,
            n
        ])).deco = r, o;
    }
    return Ao(t, aJ), Do(t, [
        {
            key: "blockAt",
            value: function(e, t, n, r) {
                return new rJ(r, this.length, n, this.height, this.deco || 0);
            }
        },
        {
            key: "lineAt",
            value: function(e, t, n, r, o) {
                return this.blockAt(0, n, r, o);
            }
        },
        {
            key: "forEachLine",
            value: function(e, t, n, r, o, i) {
                e <= o + this.length && t >= o && i(this.blockAt(0, n, r, o));
            }
        },
        {
            key: "updateHeight",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 3 ? arguments[3] : void 0;
                return n && n.from <= t && n.more && this.setHeight(e, n.heights[n.index++]), this.outdated = !1, this;
            }
        },
        {
            key: "toString",
            value: function() {
                return "block(".concat(this.length, ")");
            }
        }
    ]), t;
}(), cJ = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t, [
            e,
            n,
            null
        ])).collapsed = 0, r.widgetHeight = 0, r.breaks = 0, r;
    }
    return Ao(t, sJ), Do(t, [
        {
            key: "blockAt",
            value: function(e, t, n, r) {
                return new rJ(r, this.length, n, this.height, this.breaks);
            }
        },
        {
            key: "replace",
            value: function(e, n, r) {
                var o = r[0];
                return 1 == r.length && (o instanceof t || o instanceof lJ && 4 & o.flags) && Math.abs(this.length - o.length) < 10 ? (o instanceof lJ ? o = new t(o.length, this.height) : o.height = this.height, this.outdated || (o.outdated = !1), o) : aJ.of(r);
            }
        },
        {
            key: "updateHeight",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0;
                return r && r.from <= t && r.more ? this.setHeight(e, r.heights[r.index++]) : (n || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
            }
        },
        {
            key: "toString",
            value: function() {
                return "line(".concat(this.length).concat(this.collapsed ? -this.collapsed : "").concat(this.widgetHeight ? ":" + this.widgetHeight : "", ")");
            }
        }
    ]), t;
}(), lJ = function(e) {
    function t(e) {
        return No(this, t), _o(this, t, [
            e,
            0
        ]);
    }
    return Ao(t, aJ), Do(t, [
        {
            key: "heightMetrics",
            value: function(e, t) {
                var n, r = e.doc.lineAt(t).number, o = e.doc.lineAt(t + this.length).number, i = o - r + 1, a = 0;
                if (e.lineWrapping) {
                    var s = Math.min(this.height, e.lineHeight * i);
                    n = s / i, this.length > i + 1 && (a = (this.height - s) / (this.length - i - 1));
                } else n = this.height / i;
                return {
                    firstLine: r,
                    lastLine: o,
                    perLine: n,
                    perChar: a
                };
            }
        },
        {
            key: "blockAt",
            value: function(e, t, n, r) {
                var o = this.heightMetrics(t, r), i = o.firstLine, a = o.lastLine, s = o.perLine, c = o.perChar;
                if (t.lineWrapping) {
                    var l = r + Math.round(Math.max(0, Math.min(1, (e - n) / this.height)) * this.length), u = t.doc.lineAt(l), f = s + u.length * c, d = Math.max(n, e - f / 2);
                    return new rJ(u.from, u.length, d, f, 0);
                }
                var h = Math.max(0, Math.min(a - i, Math.floor((e - n) / s))), v = t.doc.line(i + h), p = v.from, m = v.length;
                return new rJ(p, m, n + s * h, s, 0);
            }
        },
        {
            key: "lineAt",
            value: function(e, t, n, r, o) {
                if (t == oJ.ByHeight) return this.blockAt(e, n, r, o);
                if (t == oJ.ByPosNoHeight) {
                    var i = n.doc.lineAt(e), a = i.from, s = i.to;
                    return new rJ(a, s - a, 0, 0, 0);
                }
                var c = this.heightMetrics(n, o), l = c.firstLine, u = c.perLine, f = c.perChar, d = n.doc.lineAt(e), h = u + d.length * f, v = d.number - l, p = r + u * v + f * (d.from - o - v);
                return new rJ(d.from, d.length, Math.max(r, Math.min(p, r + this.height - h)), h, 0);
            }
        },
        {
            key: "forEachLine",
            value: function(e, t, n, r, o, i) {
                e = Math.max(e, o), t = Math.min(t, o + this.length);
                for(var a = this.heightMetrics(n, o), s = a.firstLine, c = a.perLine, l = a.perChar, u = e, f = r; u <= t;){
                    var d = n.doc.lineAt(u);
                    if (u == e) {
                        var h = d.number - s;
                        f += c * h + l * (e - o - h);
                    }
                    var v = c + l * d.length;
                    i(new rJ(d.from, d.length, f, v, 0)), f += v, u = d.to + 1;
                }
            }
        },
        {
            key: "replace",
            value: function(e, n, r) {
                var o = this.length - n;
                if (o > 0) {
                    var i = r[r.length - 1];
                    i instanceof t ? r[r.length - 1] = new t(i.length + o) : r.push(null, new t(o - 1));
                }
                if (e > 0) {
                    var a = r[0];
                    a instanceof t ? r[0] = new t(e + a.length) : r.unshift(new t(e - 1), null);
                }
                return aJ.of(r);
            }
        },
        {
            key: "decomposeLeft",
            value: function(e, n) {
                n.push(new t(e - 1), null);
            }
        },
        {
            key: "decomposeRight",
            value: function(e, n) {
                n.push(null, new t(this.length - e - 1));
            }
        },
        {
            key: "updateHeight",
            value: function(e) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = arguments.length > 3 ? arguments[3] : void 0, i = n + this.length;
                if (o && o.from <= n + this.length && o.more) {
                    var a = [], s = Math.max(n, o.from), c = -1;
                    for(o.from > n && a.push(new t(o.from - n - 1).updateHeight(e, n)); s <= i && o.more;){
                        var l = e.doc.lineAt(s).length;
                        a.length && a.push(null);
                        var u = o.heights[o.index++];
                        -1 == c ? c = u : Math.abs(u - c) >= iJ && (c = -2);
                        var f = new cJ(l, u);
                        f.outdated = !1, a.push(f), s += l + 1;
                    }
                    s <= i && a.push(null, new t(i - s).updateHeight(e, s));
                    var d = aJ.of(a);
                    return (c < 0 || Math.abs(d.height - this.height) >= iJ || Math.abs(c - this.heightMetrics(e, n).perLine) >= iJ) && (e.heightChanged = !0), d;
                }
                return (r || this.outdated) && (this.setHeight(e, e.heightForGap(n, n + this.length)), this.outdated = !1), this;
            }
        },
        {
            key: "toString",
            value: function() {
                return "gap(".concat(this.length, ")");
            }
        }
    ]), t;
}(), uJ = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t, [
            e.length + n + r.length,
            e.height + r.height,
            n | (e.outdated || r.outdated ? 2 : 0)
        ])).left = e, o.right = r, o.size = e.size + r.size, o;
    }
    return Ao(t, aJ), Do(t, [
        {
            key: "break",
            get: function() {
                return 1 & this.flags;
            }
        },
        {
            key: "blockAt",
            value: function(e, t, n, r) {
                var o = n + this.left.height;
                return e < o ? this.left.blockAt(e, t, n, r) : this.right.blockAt(e, t, o, r + this.left.length + this.break);
            }
        },
        {
            key: "lineAt",
            value: function(e, t, n, r, o) {
                var i = r + this.left.height, a = o + this.left.length + this.break, s = t == oJ.ByHeight ? e < i : e < a, c = s ? this.left.lineAt(e, t, n, r, o) : this.right.lineAt(e, t, n, i, a);
                if (this.break || (s ? c.to < a : c.from > a)) return c;
                var l = t == oJ.ByPosNoHeight ? oJ.ByPosNoHeight : oJ.ByPos;
                return s ? c.join(this.right.lineAt(a, l, n, i, a)) : this.left.lineAt(a, l, n, r, o).join(c);
            }
        },
        {
            key: "forEachLine",
            value: function(e, t, n, r, o, i) {
                var a = r + this.left.height, s = o + this.left.length + this.break;
                if (this.break) e < s && this.left.forEachLine(e, t, n, r, o, i), t >= s && this.right.forEachLine(e, t, n, a, s, i);
                else {
                    var c = this.lineAt(s, oJ.ByPos, n, r, o);
                    e < c.from && this.left.forEachLine(e, c.from - 1, n, r, o, i), c.to >= e && c.from <= t && i(c), t > c.to && this.right.forEachLine(c.to + 1, t, n, a, s, i);
                }
            }
        },
        {
            key: "replace",
            value: function(e, t, n) {
                var r = this.left.length + this.break;
                if (t < r) return this.balanced(this.left.replace(e, t, n), this.right);
                if (e > this.left.length) return this.balanced(this.left, this.right.replace(e - r, t - r, n));
                var o = [];
                e > 0 && this.decomposeLeft(e, o);
                var i, a = o.length, s = bo(n);
                try {
                    for(s.s(); !(i = s.n()).done;){
                        var c = i.value;
                        o.push(c);
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                if (e > 0 && fJ(o, a - 1), t < this.length) {
                    var l = o.length;
                    this.decomposeRight(t, o), fJ(o, l);
                }
                return aJ.of(o);
            }
        },
        {
            key: "decomposeLeft",
            value: function(e, t) {
                var n = this.left.length;
                if (e <= n) return this.left.decomposeLeft(e, t);
                t.push(this.left), this.break && e >= ++n && t.push(null), e > n && this.right.decomposeLeft(e - n, t);
            }
        },
        {
            key: "decomposeRight",
            value: function(e, t) {
                var n = this.left.length, r = n + this.break;
                if (e >= r) return this.right.decomposeRight(e - r, t);
                e < n && this.left.decomposeRight(e, t), this.break && e < r && t.push(null), t.push(this.right);
            }
        },
        {
            key: "balanced",
            value: function(e, t) {
                return e.size > 2 * t.size || t.size > 2 * e.size ? aJ.of(this.break ? [
                    e,
                    null,
                    t
                ] : [
                    e,
                    t
                ]) : (this.left = e, this.right = t, this.height = e.height + t.height, this.outdated = e.outdated || t.outdated, this.size = e.size + t.size, this.length = e.length + this.break + t.length, this);
            }
        },
        {
            key: "updateHeight",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0, o = this.left, i = this.right, a = t + o.length + this.break, s = null;
                return r && r.from <= t + o.length && r.more ? s = o = o.updateHeight(e, t, n, r) : o.updateHeight(e, t, n), r && r.from <= a + i.length && r.more ? s = i = i.updateHeight(e, a, n, r) : i.updateHeight(e, a, n), s ? this.balanced(o, i) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
            }
        },
        {
            key: "toString",
            value: function() {
                return this.left + (this.break ? " " : "-") + this.right;
            }
        }
    ]), t;
}();
function fJ(e, t) {
    var n, r;
    null == e[t] && (n = e[t - 1]) instanceof lJ && (r = e[t + 1]) instanceof lJ && e.splice(t - 1, 3, new lJ(n.length + 1 + r.length));
}
var dJ = function() {
    function e(t, n) {
        No(this, e), this.pos = t, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
    }
    return Do(e, [
        {
            key: "isCovered",
            get: function() {
                return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
            }
        },
        {
            key: "span",
            value: function(e, t) {
                if (this.lineStart > -1) {
                    var n = Math.min(t, this.lineEnd), r = this.nodes[this.nodes.length - 1];
                    r instanceof cJ ? r.length += n - this.pos : (n > this.pos || !this.isCovered) && this.nodes.push(new cJ(n - this.pos, -1)), this.writtenTo = n, t > n && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
                }
                this.pos = t;
            }
        },
        {
            key: "point",
            value: function(e, t, n) {
                if (e < t || n.heightRelevant) {
                    var r = n.widget ? n.widget.estimatedHeight : 0, o = n.widget ? n.widget.lineBreaks : 0;
                    r < 0 && (r = this.oracle.lineHeight);
                    var i = t - e;
                    n.block ? this.addBlock(new sJ(i, r, n)) : (i || o || r >= 5) && this.addLineDeco(r, o, i);
                } else t > e && this.span(e, t);
                this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
            }
        },
        {
            key: "enterLine",
            value: function() {
                if (!(this.lineStart > -1)) {
                    var e = this.oracle.doc.lineAt(this.pos), t = e.from, n = e.to;
                    this.lineStart = t, this.lineEnd = n, this.writtenTo < t && ((this.writtenTo < t - 1 || null == this.nodes[this.nodes.length - 1]) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new cJ(this.pos - t, -1)), this.writtenTo = this.pos;
                }
            }
        },
        {
            key: "blankContent",
            value: function(e, t) {
                var n = new lJ(t - e);
                return this.oracle.doc.lineAt(e).to == t && (n.flags |= 4), n;
            }
        },
        {
            key: "ensureLine",
            value: function() {
                this.enterLine();
                var e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
                if (e instanceof cJ) return e;
                var t = new cJ(0, -1);
                return this.nodes.push(t), t;
            }
        },
        {
            key: "addBlock",
            value: function(e) {
                this.enterLine();
                var t = e.deco;
                t && t.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, t && t.endSide > 0 && (this.covering = e);
            }
        },
        {
            key: "addLineDeco",
            value: function(e, t, n) {
                var r = this.ensureLine();
                r.length += n, r.collapsed += n, r.widgetHeight = Math.max(r.widgetHeight, e), r.breaks += t, this.writtenTo = this.pos = this.pos + n;
            }
        },
        {
            key: "finish",
            value: function(e) {
                var t = 0 == this.nodes.length ? null : this.nodes[this.nodes.length - 1];
                !(this.lineStart > -1) || t instanceof cJ || this.isCovered ? (this.writtenTo < this.pos || null == t) && this.nodes.push(this.blankContent(this.writtenTo, this.pos)) : this.nodes.push(new cJ(0, -1));
                var n, r = e, o = bo(this.nodes);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i = n.value;
                        i instanceof cJ && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return this.nodes;
            }
        }
    ], [
        {
            key: "build",
            value: function(t, n, r, o) {
                var i = new e(r, t);
                return OV.spans(n, r, o, i, 0), i.finish(r);
            }
        }
    ]), e;
}();
var hJ = function() {
    function e() {
        No(this, e), this.changes = [];
    }
    return Do(e, [
        {
            key: "compareRange",
            value: function() {}
        },
        {
            key: "comparePoint",
            value: function(e, t, n, r) {
                (e < t || n && n.heightRelevant || r && r.heightRelevant) && iW(e, t, this.changes, 5);
            }
        }
    ]), e;
}();
function vJ(e, t) {
    for(var n = e.getBoundingClientRect(), r = e.ownerDocument, o = r.defaultView || window, i = Math.max(0, n.left), a = Math.min(o.innerWidth, n.right), s = Math.max(0, n.top), c = Math.min(o.innerHeight, n.bottom), l = e.parentNode; l && l != r.body;)if (1 == l.nodeType) {
        var u = l, f = window.getComputedStyle(u);
        if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && "visible" != f.overflow) {
            var d = u.getBoundingClientRect();
            i = Math.max(i, d.left), a = Math.min(a, d.right), s = Math.max(s, d.top), c = l == e.parentNode ? d.bottom : Math.min(c, d.bottom);
        }
        l = "absolute" == f.position || "fixed" == f.position ? u.offsetParent : u.parentNode;
    } else {
        if (11 != l.nodeType) break;
        l = l.host;
    }
    return {
        left: i - n.left,
        right: Math.max(i, a) - n.left,
        top: s - (n.top + t),
        bottom: Math.max(s, c) - (n.top + t)
    };
}
function pJ(e, t) {
    var n = e.getBoundingClientRect();
    return {
        left: 0,
        right: n.right - n.left,
        top: t,
        bottom: n.bottom - (n.top + t)
    };
}
var mJ = function() {
    function e(t, n, r) {
        No(this, e), this.from = t, this.to = n, this.size = r;
    }
    return Do(e, [
        {
            key: "draw",
            value: function(e, t) {
                return eW.replace({
                    widget: new gJ(this.size * (t ? e.scaleY : e.scaleX), t)
                }).range(this.from, this.to);
            }
        }
    ], [
        {
            key: "same",
            value: function(e, t) {
                if (e.length != t.length) return !1;
                for(var n = 0; n < e.length; n++){
                    var r = e[n], o = t[n];
                    if (r.from != o.from || r.to != o.to || r.size != o.size) return !1;
                }
                return !0;
            }
        }
    ]), e;
}(), gJ = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t)).size = e, r.vertical = n, r;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e.size == this.size && e.vertical == this.vertical;
            }
        },
        {
            key: "toDOM",
            value: function() {
                var e = document.createElement("div");
                return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
            }
        },
        {
            key: "estimatedHeight",
            get: function() {
                return this.vertical ? this.size : -1;
            }
        }
    ]), t;
}(), yJ = function() {
    function e(t) {
        var n = this;
        No(this, e), this.state = t, this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !0, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = jJ, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = lW.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
        var r = t.facet(YW).some(function(e) {
            return "function" != typeof e && "cm-lineWrapping" == e.class;
        });
        this.heightOracle = new tJ(r), this.stateDeco = t.facet(XW).filter(function(e) {
            return "function" != typeof e;
        }), this.heightMap = aJ.empty().applyChanges(this.stateDeco, XL.empty, this.heightOracle.setDoc(t.doc), [
            new aU(0, 0, 0, t.doc.length)
        ]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = eW.set(this.lineGaps.map(function(e) {
            return e.draw(n, !1);
        })), this.computeVisibleRanges();
    }
    return Do(e, [
        {
            key: "updateForViewport",
            value: function() {
                for(var e = this, t = [
                    this.viewport
                ], n = this.state.selection.main, r = function() {
                    var r = o ? n.head : n.anchor;
                    if (!t.some(function(e) {
                        var t = e.from, n = e.to;
                        return r >= t && r <= n;
                    })) {
                        var i = e.lineBlockAt(r), a = i.from, s = i.to;
                        t.push(new bJ(a, s));
                    }
                }, o = 0; o <= 1; o++)r();
                this.viewports = t.sort(function(e, t) {
                    return e.from - t.from;
                }), this.scaler = this.heightMap.height <= 7e6 ? jJ : new SJ(this.heightOracle, this.heightMap, this.viewports);
            }
        },
        {
            key: "updateViewportLines",
            value: function() {
                var e = this;
                this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, function(t) {
                    e.viewportLines.push(1 == e.scaler.scale ? t : CJ(t, e.scaler));
                });
            }
        },
        {
            key: "update",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.state = e.state;
                var n = this.stateDeco;
                this.stateDeco = this.state.facet(XW).filter(function(e) {
                    return "function" != typeof e;
                });
                var r, o, i, a, s = e.changedRanges, c = aU.extendWithRanges(s, (r = n, o = this.stateDeco, i = e ? e.changes : SF.empty(this.state.doc.length), a = new hJ, OV.compare(r, o, i, a, 0), a.changes)), l = this.heightMap.height, u = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
                this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), c), this.heightMap.height != l && (e.flags |= 2), u ? (this.scrollAnchorPos = e.changes.mapPos(u.from, -1), this.scrollAnchorHeight = u.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
                var f = c.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
                (t && (t.range.head < f.from || t.range.head > f.to) || !this.viewportIsAppropriate(f)) && (f = this.getViewport(0, t));
                var d = !e.changes.empty || 2 & e.flags || f.from != this.viewport.from || f.to != this.viewport.to;
                this.viewport = f, this.updateForViewport(), d && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), t && (this.scrollTarget = t), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(LW) && (this.mustEnforceCursorAssoc = !0);
            }
        },
        {
            key: "measure",
            value: function(e) {
                var t = e.contentDOM, n = window.getComputedStyle(t), r = this.heightOracle, o = n.whiteSpace;
                this.defaultTextDirection = "rtl" == n.direction ? lW.RTL : lW.LTR;
                var i = this.heightOracle.mustRefreshForWrapping(o), a = t.getBoundingClientRect(), s = i || this.mustMeasureContent || this.contentDOMHeight != a.height;
                this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
                var c = 0, l = 0;
                if (a.width && a.height) {
                    var u = uH(t, a), f = u.scaleX, d = u.scaleY;
                    this.scaleX == f && this.scaleY == d || (this.scaleX = f, this.scaleY = d, c |= 8, i = s = !0);
                }
                var h = (parseInt(n.paddingTop) || 0) * this.scaleY, v = (parseInt(n.paddingBottom) || 0) * this.scaleY;
                this.paddingTop == h && this.paddingBottom == v || (this.paddingTop = h, this.paddingBottom = v, c |= 10), this.editorWidth != e.scrollDOM.clientWidth && (r.lineWrapping && (s = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 8);
                var p = e.scrollDOM.scrollTop * this.scaleY;
                this.scrollTop != p && (this.scrollAnchorHeight = -1, this.scrollTop = p), this.scrolledToBottom = yH(e.scrollDOM);
                var m = (this.printing ? pJ : vJ)(t, this.paddingTop), g = m.top - this.pixelViewport.top, y = m.bottom - this.pixelViewport.bottom;
                this.pixelViewport = m;
                var b = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
                if (b != this.inView && (this.inView = b, b && (s = !0)), !this.inView && !this.scrollTarget) return 0;
                var w = a.width;
                if (this.contentDOMWidth == w && this.editorHeight == e.scrollDOM.clientHeight || (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 8), s) {
                    var x = e.docView.measureVisibleLineHeights(this.viewport);
                    if (r.mustRefreshForHeights(x) && (i = !0), i || r.lineWrapping && Math.abs(w - this.contentDOMWidth) > r.charWidth) {
                        var k = e.docView.measureTextSize(), j = k.lineHeight, S = k.charWidth, C = k.textHeight;
                        (i = j > 0 && r.refresh(o, j, S, C, w / S, x)) && (e.docView.minWidth = 0, c |= 8);
                    }
                    g > 0 && y > 0 ? l = Math.max(g, y) : g < 0 && y < 0 && (l = Math.min(g, y)), r.heightChanged = !1;
                    var $, _ = bo(this.viewports);
                    try {
                        for(_.s(); !($ = _.n()).done;){
                            var O = $.value, M = O.from == this.viewport.from ? x : e.docView.measureVisibleLineHeights(O);
                            this.heightMap = (i ? aJ.empty().applyChanges(this.stateDeco, XL.empty, this.heightOracle, [
                                new aU(0, 0, 0, e.state.doc.length)
                            ]) : this.heightMap).updateHeight(r, 0, i, new nJ(O.from, M));
                        }
                    } catch (e) {
                        _.e(e);
                    } finally{
                        _.f();
                    }
                    r.heightChanged && (c |= 2);
                }
                var E = !this.viewportIsAppropriate(this.viewport, l) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
                return E && (this.viewport = this.getViewport(l, this.scrollTarget)), this.updateForViewport(), (2 & c || E) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(i ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
            }
        },
        {
            key: "visibleTop",
            get: function() {
                return this.scaler.fromDOM(this.pixelViewport.top);
            }
        },
        {
            key: "visibleBottom",
            get: function() {
                return this.scaler.fromDOM(this.pixelViewport.bottom);
            }
        },
        {
            key: "getViewport",
            value: function(e, t) {
                var n = .5 - Math.max(-0.5, Math.min(.5, e / 1e3 / 2)), r = this.heightMap, o = this.heightOracle, i = this.visibleTop, a = this.visibleBottom, s = new bJ(r.lineAt(i - 1e3 * n, oJ.ByHeight, o, 0, 0).from, r.lineAt(a + 1e3 * (1 - n), oJ.ByHeight, o, 0, 0).to);
                if (t) {
                    var c = t.range.head;
                    if (c < s.from || c > s.to) {
                        var l, u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = r.lineAt(c, oJ.ByPos, o, 0, 0);
                        l = "center" == t.y ? (f.top + f.bottom) / 2 - u / 2 : "start" == t.y || "nearest" == t.y && c < s.from ? f.top : f.bottom - u, s = new bJ(r.lineAt(l - 500, oJ.ByHeight, o, 0, 0).from, r.lineAt(l + u + 500, oJ.ByHeight, o, 0, 0).to);
                    }
                }
                return s;
            }
        },
        {
            key: "mapViewport",
            value: function(e, t) {
                var n = t.mapPos(e.from, -1), r = t.mapPos(e.to, 1);
                return new bJ(this.heightMap.lineAt(n, oJ.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(r, oJ.ByPos, this.heightOracle, 0, 0).to);
            }
        },
        {
            key: "viewportIsAppropriate",
            value: function(e) {
                var t = e.from, n = e.to, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                if (!this.inView) return !0;
                var o = this.heightMap.lineAt(t, oJ.ByPos, this.heightOracle, 0, 0).top, i = this.heightMap.lineAt(n, oJ.ByPos, this.heightOracle, 0, 0).bottom, a = this.visibleTop, s = this.visibleBottom;
                return (0 == t || o <= a - Math.max(10, Math.min(-r, 250))) && (n == this.state.doc.length || i >= s + Math.max(10, Math.min(r, 250))) && o > a - 2e3 && i < s + 2e3;
            }
        },
        {
            key: "mapLineGaps",
            value: function(e, t) {
                if (!e.length || t.empty) return e;
                var n, r = [], o = bo(e);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i = n.value;
                        t.touchesRange(i.from, i.to) || r.push(new mJ(t.mapPos(i.from), t.mapPos(i.to), i.size));
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return r;
            }
        },
        {
            key: "ensureLineGaps",
            value: function(e, t) {
                var n = this, r = this.heightOracle.lineWrapping, o = r ? 1e4 : 2e3, i = o >> 1, a = o << 1;
                if (this.defaultTextDirection != lW.LTR && !r) return [];
                var s, c = [], l = function o(a, s, l, u) {
                    if (!(s - a < i)) {
                        var f = n.state.selection.main, d = [
                            f.from
                        ];
                        f.empty || d.push(f.to);
                        for(var h = 0, v = d; h < v.length; h++){
                            var p = v[h];
                            if (p > a && p < s) return o(a, p - 10, l, u), void o(p + 10, s, l, u);
                        }
                        var m = function(e, t) {
                            var n, r = bo(e);
                            try {
                                for(r.s(); !(n = r.n()).done;){
                                    var o = n.value;
                                    if (t(o)) return o;
                                }
                            } catch (e) {
                                r.e(e);
                            } finally{
                                r.f();
                            }
                            return;
                        }(e, function(e) {
                            return e.from >= l.from && e.to <= l.to && Math.abs(e.from - a) < i && Math.abs(e.to - s) < i && !d.some(function(t) {
                                return e.from < t && e.to > t;
                            });
                        });
                        if (!m) {
                            if (s < l.to && t && r && t.visibleRanges.some(function(e) {
                                return e.from <= s && e.to >= s;
                            })) {
                                var g = t.moveToLineBoundary(PF.cursor(s), !1, !0).head;
                                g > a && (s = g);
                            }
                            m = new mJ(a, s, n.gapSize(l, a, s, u));
                        }
                        c.push(m);
                    }
                }, u = bo(this.viewportLines);
                try {
                    for(u.s(); !(s = u.n()).done;){
                        var f = s.value;
                        if (!(f.length < a)) {
                            var d = wJ(f.from, f.to, this.stateDeco);
                            if (!(d.total < a)) {
                                var h = this.scrollTarget ? this.scrollTarget.range.head : null, v = void 0, p = void 0;
                                if (r) {
                                    var m = o / this.heightOracle.lineLength * this.heightOracle.lineHeight, g = void 0, y = void 0;
                                    if (null != h) {
                                        var b = kJ(d, h), w = ((this.visibleBottom - this.visibleTop) / 2 + m) / f.height;
                                        g = b - w, y = b + w;
                                    } else g = (this.visibleTop - f.top - m) / f.height, y = (this.visibleBottom - f.top + m) / f.height;
                                    v = xJ(d, g), p = xJ(d, y);
                                } else {
                                    var x = d.total * this.heightOracle.charWidth, k = o * this.heightOracle.charWidth, j = void 0, S = void 0;
                                    if (null != h) {
                                        var C = kJ(d, h), $ = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + k) / x;
                                        j = C - $, S = C + $;
                                    } else j = (this.pixelViewport.left - k) / x, S = (this.pixelViewport.right + k) / x;
                                    v = xJ(d, j), p = xJ(d, S);
                                }
                                v > f.from && l(f.from, v, f, d), p < f.to && l(p, f.to, f, d);
                            }
                        }
                    }
                } catch (e) {
                    u.e(e);
                } finally{
                    u.f();
                }
                return c;
            }
        },
        {
            key: "gapSize",
            value: function(e, t, n, r) {
                var o = kJ(r, n) - kJ(r, t);
                return this.heightOracle.lineWrapping ? e.height * o : r.total * this.heightOracle.charWidth * o;
            }
        },
        {
            key: "updateLineGaps",
            value: function(e) {
                var t = this;
                mJ.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = eW.set(e.map(function(e) {
                    return e.draw(t, t.heightOracle.lineWrapping);
                })));
            }
        },
        {
            key: "computeVisibleRanges",
            value: function() {
                var e = this.stateDeco;
                this.lineGaps.length && (e = e.concat(this.lineGapDeco));
                var t = [];
                OV.spans(e, this.viewport.from, this.viewport.to, {
                    span: function(e, n) {
                        t.push({
                            from: e,
                            to: n
                        });
                    },
                    point: function() {}
                }, 20);
                var n = t.length != this.visibleRanges.length || this.visibleRanges.some(function(e, n) {
                    return e.from != t[n].from || e.to != t[n].to;
                });
                return this.visibleRanges = t, n ? 4 : 0;
            }
        },
        {
            key: "lineBlockAt",
            value: function(e) {
                return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find(function(t) {
                    return t.from <= e && t.to >= e;
                }) || CJ(this.heightMap.lineAt(e, oJ.ByPos, this.heightOracle, 0, 0), this.scaler);
            }
        },
        {
            key: "lineBlockAtHeight",
            value: function(e) {
                return CJ(this.heightMap.lineAt(this.scaler.fromDOM(e), oJ.ByHeight, this.heightOracle, 0, 0), this.scaler);
            }
        },
        {
            key: "scrollAnchorAt",
            value: function(e) {
                var t = this.lineBlockAtHeight(e + 8);
                return t.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? t : this.viewportLines[0];
            }
        },
        {
            key: "elementAtHeight",
            value: function(e) {
                return CJ(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
            }
        },
        {
            key: "docHeight",
            get: function() {
                return this.scaler.toDOM(this.heightMap.height);
            }
        },
        {
            key: "contentHeight",
            get: function() {
                return this.docHeight + this.paddingTop + this.paddingBottom;
            }
        }
    ]), e;
}(), bJ = Do(function e(t, n) {
    No(this, e), this.from = t, this.to = n;
});
function wJ(e, t, n) {
    var r = [], o = e, i = 0;
    return OV.spans(n, e, t, {
        span: function() {},
        point: function(e, t) {
            e > o && (r.push({
                from: o,
                to: e
            }), i += e - o), o = t;
        }
    }, 20), o < t && (r.push({
        from: o,
        to: t
    }), i += t - o), {
        total: i,
        ranges: r
    };
}
function xJ(e, t) {
    var n = e.total, r = e.ranges;
    if (t <= 0) return r[0].from;
    if (t >= 1) return r[r.length - 1].to;
    for(var o = Math.floor(n * t), i = 0;; i++){
        var a = r[i], s = a.from, c = a.to - s;
        if (o <= c) return s + o;
        o -= c;
    }
}
function kJ(e, t) {
    var n, r = 0, o = bo(e.ranges);
    try {
        for(o.s(); !(n = o.n()).done;){
            var i = n.value, a = i.from, s = i.to;
            if (t <= s) {
                r += t - a;
                break;
            }
            r += s - a;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return r / e.total;
}
var jJ = {
    toDOM: function(e) {
        return e;
    },
    fromDOM: function(e) {
        return e;
    },
    scale: 1
}, SJ = function() {
    function e(t, n, r) {
        No(this, e);
        var o = 0, i = 0, a = 0;
        this.viewports = r.map(function(e) {
            var r = e.from, i = e.to, a = n.lineAt(r, oJ.ByPos, t, 0, 0).top, s = n.lineAt(i, oJ.ByPos, t, 0, 0).bottom;
            return o += s - a, {
                from: r,
                to: i,
                top: a,
                bottom: s,
                domTop: 0,
                domBottom: 0
            };
        }), this.scale = (7e6 - o) / (n.height - o);
        var s, c = bo(this.viewports);
        try {
            for(c.s(); !(s = c.n()).done;){
                var l = s.value;
                l.domTop = a + (l.top - i) * this.scale, a = l.domBottom = l.domTop + (l.bottom - l.top), i = l.bottom;
            }
        } catch (e) {
            c.e(e);
        } finally{
            c.f();
        }
    }
    return Do(e, [
        {
            key: "toDOM",
            value: function(e) {
                for(var t = 0, n = 0, r = 0;; t++){
                    var o = t < this.viewports.length ? this.viewports[t] : null;
                    if (!o || e < o.top) return r + (e - n) * this.scale;
                    if (e <= o.bottom) return o.domTop + (e - o.top);
                    n = o.bottom, r = o.domBottom;
                }
            }
        },
        {
            key: "fromDOM",
            value: function(e) {
                for(var t = 0, n = 0, r = 0;; t++){
                    var o = t < this.viewports.length ? this.viewports[t] : null;
                    if (!o || e < o.domTop) return n + (e - r) / this.scale;
                    if (e <= o.domBottom) return o.top + (e - o.domTop);
                    n = o.bottom, r = o.domBottom;
                }
            }
        }
    ]), e;
}();
function CJ(e, t) {
    if (1 == t.scale) return e;
    var n = t.toDOM(e.top), r = t.toDOM(e.bottom);
    return new rJ(e.from, e.length, n, r - n, Array.isArray(e._content) ? e._content.map(function(e) {
        return CJ(e, t);
    }) : e._content);
}
var $J = NF.define({
    combine: function(e) {
        return e.join(" ");
    }
}), _J = NF.define({
    combine: function(e) {
        return e.indexOf(!0) > -1;
    }
}), OJ = WV.newName(), MJ = WV.newName(), EJ = WV.newName(), AJ = {
    "&light": "." + MJ,
    "&dark": "." + EJ
};
function PJ(e, t, n) {
    return new WV(t, {
        finish: function(t) {
            return /&/.test(t) ? t.replace(/&\w*/, function(t) {
                if ("&" == t) return e;
                if (!n || !n[t]) throw new RangeError("Unsupported selector: ".concat(t));
                return n[t];
            }) : e + " " + t;
        }
    });
}
var TJ = PJ("." + OJ, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        insetInlineStart: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace:before": {
        content: "attr(data-display)",
        position: "absolute",
        pointerEvents: "none",
        color: "#888"
    },
    ".cm-highlightTab": {
        backgroundImage: 'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>\')',
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, AJ), RJ = "\uFFFF", NJ = function() {
    function e(t, n) {
        No(this, e), this.points = t, this.text = "", this.lineSeparator = n.facet(kV.lineSeparator);
    }
    return Do(e, [
        {
            key: "append",
            value: function(e) {
                this.text += e;
            }
        },
        {
            key: "lineBreak",
            value: function() {
                this.text += RJ;
            }
        },
        {
            key: "readRange",
            value: function(e, t) {
                if (!e) return this;
                for(var n = e.parentNode, r = e;;){
                    this.findPointBefore(n, r);
                    var o = this.text.length;
                    this.readNode(r);
                    var i = r.nextSibling;
                    if (i == t) break;
                    var a = xH.get(r), s = xH.get(i);
                    (a && s ? a.breakAfter : (a ? a.breakAfter : DJ(r)) || DJ(i) && ("BR" != r.nodeName || r.cmIgnore) && this.text.length > o) && this.lineBreak(), r = i;
                }
                return this.findPointBefore(n, t), this;
            }
        },
        {
            key: "readTextNode",
            value: function(e) {
                var t, n = e.nodeValue, r = bo(this.points);
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var o = t.value;
                        o.node == e && (o.pos = this.text.length + Math.min(o.offset, n.length));
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                for(var i = 0, a = this.lineSeparator ? null : /\r\n?|\n/g;;){
                    var s = -1, c = 1, l = void 0;
                    if (this.lineSeparator ? (s = n.indexOf(this.lineSeparator, i), c = this.lineSeparator.length) : (l = a.exec(n)) && (s = l.index, c = l[0].length), this.append(n.slice(i, s < 0 ? n.length : s)), s < 0) break;
                    if (this.lineBreak(), c > 1) {
                        var u, f = bo(this.points);
                        try {
                            for(f.s(); !(u = f.n()).done;){
                                var d = u.value;
                                d.node == e && d.pos > this.text.length && (d.pos -= c - 1);
                            }
                        } catch (e) {
                            f.e(e);
                        } finally{
                            f.f();
                        }
                    }
                    i = s + c;
                }
            }
        },
        {
            key: "readNode",
            value: function(e) {
                if (!e.cmIgnore) {
                    var t = xH.get(e), n = t && t.overrideDOMText;
                    if (null != n) {
                        this.findPointInside(e, n.length);
                        for(var r = n.iter(); !r.next().done;)r.lineBreak ? this.lineBreak() : this.append(r.value);
                    } else 3 == e.nodeType ? this.readTextNode(e) : "BR" == e.nodeName ? e.nextSibling && this.lineBreak() : 1 == e.nodeType && this.readRange(e.firstChild, null);
                }
            }
        },
        {
            key: "findPointBefore",
            value: function(e, t) {
                var n, r = bo(this.points);
                try {
                    for(r.s(); !(n = r.n()).done;){
                        var o = n.value;
                        o.node == e && e.childNodes[o.offset] == t && (o.pos = this.text.length);
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
            }
        },
        {
            key: "findPointInside",
            value: function(e, t) {
                var n, r = bo(this.points);
                try {
                    for(r.s(); !(n = r.n()).done;){
                        var o = n.value;
                        (3 == e.nodeType ? o.node == e : e.contains(o.node)) && (o.pos = this.text.length + (IJ(e, o.node, o.offset) ? t : 0));
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
            }
        }
    ]), e;
}();
function IJ(e, t, n) {
    for(;;){
        if (!t || n < sH(t)) return !1;
        if (t == e) return !0;
        n = iH(t) + 1, t = t.parentNode;
    }
}
function DJ(e) {
    return 1 == e.nodeType && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
var zJ = Do(function e(t, n) {
    No(this, e), this.node = t, this.offset = n, this.pos = -1;
}), qJ = Do(function e(t, n, r, o) {
    No(this, e), this.typeOver = o, this.bounds = null, this.text = "";
    var i = t.docView, a = i.impreciseHead, s = i.impreciseAnchor;
    if (t.state.readOnly && n > -1) this.newSel = null;
    else if (n > -1 && (this.bounds = t.docView.domBoundsAround(n, r, 0))) {
        var c = a || s ? [] : function(e) {
            var t = [];
            if (e.root.activeElement != e.contentDOM) return t;
            var n = e.observer.selectionRange, r = n.anchorNode, o = n.anchorOffset, i = n.focusNode, a = n.focusOffset;
            r && (t.push(new zJ(r, o)), i == r && a == o || t.push(new zJ(i, a)));
            return t;
        }(t), l = new NJ(c, t.state);
        l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = function(e, t) {
            if (0 == e.length) return null;
            var n = e[0].pos, r = 2 == e.length ? e[1].pos : n;
            return n > -1 && r > -1 ? PF.single(n + t, r + t) : null;
        }(c, this.bounds.from);
    } else {
        var u = t.observer.selectionRange, f = a && a.node == u.focusNode && a.offset == u.focusOffset || !tH(t.contentDOM, u.focusNode) ? t.state.selection.main.head : t.docView.posFromDOM(u.focusNode, u.focusOffset), d = s && s.node == u.anchorNode && s.offset == u.anchorOffset || !tH(t.contentDOM, u.anchorNode) ? t.state.selection.main.anchor : t.docView.posFromDOM(u.anchorNode, u.anchorOffset), h = t.viewport;
        if ((DH.ios || DH.chrome) && t.state.selection.main.empty && f != d && (h.from > 0 || h.to < t.state.doc.length)) {
            var v = Math.min(f, d), p = Math.max(f, d), m = h.from - v, g = h.to - p;
            0 != m && 1 != m && 0 != v || 0 != g && -1 != g && p != t.state.doc.length || (f = 0, d = t.state.doc.length);
        }
        this.newSel = PF.single(d, f);
    }
});
function BJ(e, t) {
    var n, r = t.newSel, o = e.state.selection.main, i = e.inputState.lastKeyTime > Date.now() - 100 ? e.inputState.lastKeyCode : -1;
    if (t.bounds) {
        var a = t.bounds, s = a.from, c = a.to, l = o.from, u = null;
        (8 === i || DH.android && t.text.length < c - s) && (l = o.to, u = "end");
        var f = function(e, t, n, r) {
            var o = Math.min(e.length, t.length), i = 0;
            for(; i < o && e.charCodeAt(i) == t.charCodeAt(i);)i++;
            if (i == o && e.length == t.length) return null;
            var a = e.length, s = t.length;
            for(; a > 0 && s > 0 && e.charCodeAt(a - 1) == t.charCodeAt(s - 1);)a--, s--;
            if ("end" == r) n -= a + Math.max(0, i - Math.min(a, s)) - i;
            if (a < i && e.length < t.length) s = (i -= n <= i && n >= a ? i - n : 0) + (s - a), a = i;
            else if (s < i) a = (i -= n <= i && n >= s ? i - n : 0) + (a - s), s = i;
            return {
                from: i,
                toA: a,
                toB: s
            };
        }(e.state.doc.sliceString(s, c, RJ), t.text, l - s, u);
        f && (DH.chrome && 13 == i && f.toB == f.from + 2 && t.text.slice(f.from, f.toB) == RJ + RJ && f.toB--, n = {
            from: s + f.from,
            to: s + f.toA,
            insert: XL.of(t.text.slice(f.from, f.toB).split(RJ))
        });
    } else r && (!e.hasFocus && e.state.facet(WW) || r.main.eq(o)) && (r = null);
    if (!n && !r) return !1;
    if (!n && t.typeOver && !o.empty && r && r.main.empty ? n = {
        from: o.from,
        to: o.to,
        insert: e.state.doc.slice(o.from, o.to)
    } : n && n.from >= o.from && n.to <= o.to && (n.from != o.from || n.to != o.to) && o.to - o.from - (n.to - n.from) <= 4 ? n = {
        from: o.from,
        to: o.to,
        insert: e.state.doc.slice(o.from, n.from).append(n.insert).append(e.state.doc.slice(n.to, o.to))
    } : (DH.mac || DH.android) && n && n.from == n.to && n.from == o.head - 1 && /^\. ?$/.test(n.insert.toString()) && "off" == e.contentDOM.getAttribute("autocorrect") ? (r && 2 == n.insert.length && (r = PF.single(r.main.anchor - 1, r.main.head - 1)), n = {
        from: o.from,
        to: o.to,
        insert: XL.of([
            " "
        ])
    }) : DH.chrome && n && n.from == n.to && n.from == o.head && "\n " == n.insert.toString() && e.lineWrapping && (r && (r = PF.single(r.main.anchor - 1, r.main.head - 1)), n = {
        from: o.from,
        to: o.to,
        insert: XL.of([
            " "
        ])
    }), n) {
        if (DH.ios && e.inputState.flushIOSKey()) return !0;
        if (DH.android && (n.from == o.from && n.to == o.to && 1 == n.insert.length && 2 == n.insert.lines && mH(e.contentDOM, "Enter", 13) || (n.from == o.from - 1 && n.to == o.to && 0 == n.insert.length || 8 == i && n.insert.length < n.to - n.from && n.to > o.head) && mH(e.contentDOM, "Backspace", 8) || n.from == o.from && n.to == o.to + 1 && 0 == n.insert.length && mH(e.contentDOM, "Delete", 46))) return !0;
        var d, h = n.insert.toString();
        e.inputState.composing >= 0 && e.inputState.composing++;
        var v = function() {
            return d || (d = function(e, t, n) {
                var r, o = e.state, i = o.selection.main;
                if (t.from >= i.from && t.to <= i.to && t.to - t.from >= (i.to - i.from) / 3 && (!n || n.main.empty && n.main.from == t.from + t.insert.length) && e.inputState.composing < 0) {
                    var a = i.from < t.from ? o.sliceDoc(i.from, t.from) : "", s = i.to > t.to ? o.sliceDoc(t.to, i.to) : "";
                    r = o.replaceSelection(e.state.toText(a + t.insert.sliceString(0, void 0, e.state.lineBreak) + s));
                } else {
                    var c = o.changes(t), l = n && n.main.to <= c.newLength ? n.main : void 0;
                    if (o.selection.ranges.length > 1 && e.inputState.composing >= 0 && t.to <= i.to && t.to >= i.to - 10) {
                        var u, f = e.state.sliceDoc(t.from, t.to), d = n && uU(e, n.main.head);
                        if (d) {
                            var h = t.insert.length - (t.to - t.from);
                            u = {
                                from: d.from,
                                to: d.to - h
                            };
                        } else u = e.state.doc.lineAt(i.head);
                        var v = i.to - t.to, p = i.to - i.from;
                        r = o.changeByRange(function(n) {
                            if (n.from == i.from && n.to == i.to) return {
                                changes: c,
                                range: l || n.map(c)
                            };
                            var r = n.to - v, a = r - f.length;
                            if (n.to - n.from != p || e.state.sliceDoc(a, r) != f || n.to >= u.from && n.from <= u.to) return {
                                range: n
                            };
                            var s = o.changes({
                                from: a,
                                to: r,
                                insert: t.insert
                            }), d = n.to - i.to;
                            return {
                                changes: s,
                                range: l ? PF.range(Math.max(0, l.anchor + d), Math.max(0, l.head + d)) : n.map(s)
                            };
                        });
                    } else r = {
                        changes: c,
                        selection: l && o.selection.replaceRange(l)
                    };
                }
                var m = "input.type";
                (e.composing || e.inputState.compositionPendingChange && e.inputState.compositionEndedAt > Date.now() - 50) && (e.inputState.compositionPendingChange = !1, m += ".compose", e.inputState.compositionFirstChange && (m += ".start", e.inputState.compositionFirstChange = !1));
                return o.update(r, {
                    userEvent: m,
                    scrollIntoView: !0
                });
            }(e, n, r));
        };
        return e.state.facet(zW).some(function(t) {
            return t(e, n.from, n.to, h, v);
        }) || e.dispatch(v()), !0;
    }
    if (r && !r.main.eq(o)) {
        var p = !1, m = "select";
        return e.inputState.lastSelectionTime > Date.now() - 50 && ("select" == e.inputState.lastSelectionOrigin && (p = !0), m = e.inputState.lastSelectionOrigin), e.dispatch({
            selection: r,
            scrollIntoView: p,
            userEvent: m
        }), !0;
    }
    return !1;
}
var LJ = {
    childList: !0,
    characterData: !0,
    subtree: !0,
    attributes: !0,
    characterDataOldValue: !0
}, FJ = DH.ie && DH.ie_version <= 11, VJ = function() {
    function e(t) {
        var n = this;
        No(this, e), this.view = t, this.active = !1, this.selectionRange = new dH, this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver(function(e) {
            var r, o = bo(e);
            try {
                for(o.s(); !(r = o.n()).done;){
                    var i = r.value;
                    n.queue.push(i);
                }
            } catch (e) {
                o.e(e);
            } finally{
                o.f();
            }
            (DH.ie && DH.ie_version <= 11 || DH.ios && t.composing) && e.some(function(e) {
                return "childList" == e.type && e.removedNodes.length || "characterData" == e.type && e.oldValue.length > e.target.nodeValue.length;
            }) ? n.flushSoon() : n.flush();
        }), FJ && (this.onCharData = function(e) {
            n.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            }), n.flushSoon();
        }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), "function" == typeof ResizeObserver && (this.resizeScroll = new ResizeObserver(function() {
            var e;
            (null === (e = n.view.docView) || void 0 === e ? void 0 : e.lastUpdate) < Date.now() - 75 && n.onResize();
        }), this.resizeScroll.observe(t.scrollDOM)), this.addWindowListeners(this.win = t.win), this.start(), "function" == typeof IntersectionObserver && (this.intersection = new IntersectionObserver(function(e) {
            n.parentCheck < 0 && (n.parentCheck = setTimeout(n.listenForScroll.bind(n), 1e3)), e.length > 0 && e[e.length - 1].intersectionRatio > 0 != n.intersecting && (n.intersecting = !n.intersecting, n.intersecting != n.view.inView && n.onScrollChanged(document.createEvent("Event")));
        }, {
            threshold: [
                0,
                .001
            ]
        }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver(function(e) {
            e.length > 0 && e[e.length - 1].intersectionRatio > 0 && n.onScrollChanged(document.createEvent("Event"));
        }, {})), this.listenForScroll(), this.readSelectionRange();
    }
    return Do(e, [
        {
            key: "onScrollChanged",
            value: function(e) {
                this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
            }
        },
        {
            key: "onScroll",
            value: function(e) {
                this.intersecting && this.flush(!1), this.onScrollChanged(e);
            }
        },
        {
            key: "onResize",
            value: function() {
                var e = this;
                this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(function() {
                    e.resizeTimeout = -1, e.view.requestMeasure();
                }, 50));
            }
        },
        {
            key: "onPrint",
            value: function() {
                var e = this;
                this.view.viewState.printing = !0, this.view.measure(), setTimeout(function() {
                    e.view.viewState.printing = !1, e.view.requestMeasure();
                }, 500);
            }
        },
        {
            key: "updateGaps",
            value: function(e) {
                if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some(function(t, n) {
                    return t != e[n];
                }))) {
                    this.gapIntersection.disconnect();
                    var t, n = bo(e);
                    try {
                        for(n.s(); !(t = n.n()).done;){
                            var r = t.value;
                            this.gapIntersection.observe(r);
                        }
                    } catch (e) {
                        n.e(e);
                    } finally{
                        n.f();
                    }
                    this.gaps = e;
                }
            }
        },
        {
            key: "onSelectionChange",
            value: function(e) {
                var t = this.selectionChanged;
                if (this.readSelectionRange() && !this.delayedAndroidKey) {
                    var n = this.view, r = this.selectionRange;
                    if (n.state.facet(WW) ? n.root.activeElement == this.dom : nH(n.dom, r)) {
                        var o = r.anchorNode && n.docView.nearest(r.anchorNode);
                        o && o.ignoreEvent(e) ? t || (this.selectionChanged = !1) : (DH.ie && DH.ie_version <= 11 || DH.android && DH.chrome) && !n.state.selection.main.empty && r.focusNode && oH(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset) ? this.flushSoon() : this.flush(!1);
                    }
                }
            }
        },
        {
            key: "readSelectionRange",
            value: function() {
                var e = this.view, t = DH.safari && 11 == e.root.nodeType && function(e) {
                    for(var t = e.activeElement; t && t.shadowRoot;)t = t.shadowRoot.activeElement;
                    return t;
                }(this.dom.ownerDocument) == this.dom && function(e) {
                    var t = null;
                    function n(e) {
                        e.preventDefault(), e.stopImmediatePropagation(), t = e.getTargetRanges()[0];
                    }
                    if (e.contentDOM.addEventListener("beforeinput", n, !0), e.dom.ownerDocument.execCommand("indent"), e.contentDOM.removeEventListener("beforeinput", n, !0), !t) return null;
                    var r = t.startContainer, o = t.startOffset, i = t.endContainer, a = t.endOffset, s = e.docView.domAtPos(e.state.selection.main.anchor);
                    if (oH(s.node, s.offset, i, a)) {
                        var c = [
                            i,
                            a,
                            r,
                            o
                        ];
                        r = c[0], o = c[1], i = c[2], a = c[3];
                    }
                    return {
                        anchorNode: r,
                        anchorOffset: o,
                        focusNode: i,
                        focusOffset: a
                    };
                }(this.view) || eH(e.root);
                if (!t || this.selectionRange.eq(t)) return !1;
                var n = nH(this.dom, t);
                return n && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && function(e, t) {
                    var n = t.focusNode, r = t.focusOffset;
                    if (!n || t.anchorNode != n || t.anchorOffset != r) return !1;
                    for(r = Math.min(r, sH(n));;)if (r) {
                        if (1 != n.nodeType) return !1;
                        var o = n.childNodes[r - 1];
                        "false" == o.contentEditable ? r-- : r = sH(n = o);
                    } else {
                        if (n == e) return !0;
                        r = iH(n), n = n.parentNode;
                    }
                }(this.dom, t) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(t), n && (this.selectionChanged = !0), !0);
            }
        },
        {
            key: "setSelectionRange",
            value: function(e, t) {
                this.selectionRange.set(e.node, e.offset, t.node, t.offset), this.selectionChanged = !1;
            }
        },
        {
            key: "clearSelectionRange",
            value: function() {
                this.selectionRange.set(null, 0, null, 0);
            }
        },
        {
            key: "listenForScroll",
            value: function() {
                this.parentCheck = -1;
                for(var e = 0, t = null, n = this.dom; n;)if (1 == n.nodeType) !t && e < this.scrollTargets.length && this.scrollTargets[e] == n ? e++ : t || (t = this.scrollTargets.slice(0, e)), t && t.push(n), n = n.assignedSlot || n.parentNode;
                else {
                    if (11 != n.nodeType) break;
                    n = n.host;
                }
                if (e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t) {
                    var r, o = bo(this.scrollTargets);
                    try {
                        for(o.s(); !(r = o.n()).done;)r.value.removeEventListener("scroll", this.onScroll);
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    var i, a = bo(this.scrollTargets = t);
                    try {
                        for(a.s(); !(i = a.n()).done;)i.value.addEventListener("scroll", this.onScroll);
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
            }
        },
        {
            key: "ignore",
            value: function(e) {
                if (!this.active) return e();
                try {
                    return this.stop(), e();
                } finally{
                    this.start(), this.clear();
                }
            }
        },
        {
            key: "start",
            value: function() {
                this.active || (this.observer.observe(this.dom, LJ), FJ && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
            }
        },
        {
            key: "stop",
            value: function() {
                this.active && (this.active = !1, this.observer.disconnect(), FJ && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
            }
        },
        {
            key: "clear",
            value: function() {
                this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
            }
        },
        {
            key: "delayAndroidKey",
            value: function(e, t) {
                var n, r = this;
                if (!this.delayedAndroidKey) this.flushingAndroidKey = this.view.win.requestAnimationFrame(function() {
                    var e = r.delayedAndroidKey;
                    e && (r.clearDelayedAndroidKey(), r.view.inputState.lastKeyCode = e.keyCode, r.view.inputState.lastKeyTime = Date.now(), !r.flush() && e.force && mH(r.dom, e.key, e.keyCode));
                });
                this.delayedAndroidKey && "Enter" != e || (this.delayedAndroidKey = {
                    key: e,
                    keyCode: t,
                    force: this.lastChange < Date.now() - 50 || !!(null === (n = this.delayedAndroidKey) || void 0 === n ? void 0 : n.force)
                });
            }
        },
        {
            key: "clearDelayedAndroidKey",
            value: function() {
                this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
            }
        },
        {
            key: "flushSoon",
            value: function() {
                var e = this;
                this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(function() {
                    e.delayedFlush = -1, e.flush();
                }));
            }
        },
        {
            key: "forceFlush",
            value: function() {
                this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
            }
        },
        {
            key: "pendingRecords",
            value: function() {
                var e, t = bo(this.observer.takeRecords());
                try {
                    for(t.s(); !(e = t.n()).done;){
                        var n = e.value;
                        this.queue.push(n);
                    }
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
                return this.queue;
            }
        },
        {
            key: "processRecords",
            value: function() {
                var e = this.pendingRecords();
                e.length && (this.queue = []);
                var t, n = -1, r = -1, o = !1, i = bo(e);
                try {
                    for(i.s(); !(t = i.n()).done;){
                        var a = t.value, s = this.readMutation(a);
                        s && (s.typeOver && (o = !0), -1 == n ? (n = s.from, r = s.to) : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return {
                    from: n,
                    to: r,
                    typeOver: o
                };
            }
        },
        {
            key: "readChange",
            value: function() {
                var e = this.processRecords(), t = e.from, n = e.to, r = e.typeOver, o = this.selectionChanged && nH(this.dom, this.selectionRange);
                if (t < 0 && !o) return null;
                t > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
                var i = new qJ(this.view, t, n, r);
                return this.view.docView.domChanged = {
                    newSel: i.newSel ? i.newSel.main : null
                }, i;
            }
        },
        {
            key: "flush",
            value: function() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                if (this.delayedFlush >= 0 || this.delayedAndroidKey) return !1;
                e && this.readSelectionRange();
                var t = this.readChange();
                if (!t) return this.view.requestMeasure(), !1;
                var n = this.view.state, r = BJ(this.view, t);
                return this.view.state == n && this.view.update([]), r;
            }
        },
        {
            key: "readMutation",
            value: function(e) {
                var t = this.view.docView.nearest(e.target);
                if (!t || t.ignoreMutation(e)) return null;
                if (t.markDirty("attributes" == e.type), "attributes" == e.type && (t.flags |= 4), "childList" == e.type) {
                    var n = HJ(t, e.previousSibling || e.target.previousSibling, -1), r = HJ(t, e.nextSibling || e.target.nextSibling, 1);
                    return {
                        from: n ? t.posAfter(n) : t.posAtStart,
                        to: r ? t.posBefore(r) : t.posAtEnd,
                        typeOver: !1
                    };
                }
                return "characterData" == e.type ? {
                    from: t.posAtStart,
                    to: t.posAtEnd,
                    typeOver: e.target.nodeValue == e.oldValue
                } : null;
            }
        },
        {
            key: "setWindow",
            value: function(e) {
                e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
            }
        },
        {
            key: "addWindowListeners",
            value: function(e) {
                e.addEventListener("resize", this.onResize), e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
            }
        },
        {
            key: "removeWindowListeners",
            value: function(e) {
                e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t, n;
                this.stop(), null === (e = this.intersection) || void 0 === e || e.disconnect(), null === (t = this.gapIntersection) || void 0 === t || t.disconnect(), null === (n = this.resizeScroll) || void 0 === n || n.disconnect();
                var r, o = bo(this.scrollTargets);
                try {
                    for(o.s(); !(r = o.n()).done;)r.value.removeEventListener("scroll", this.onScroll);
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
            }
        }
    ]), e;
}();
function HJ(e, t, n) {
    for(; t;){
        var r = xH.get(t);
        if (r && r.parent == e) return r;
        var o = t.parentNode;
        t = o != e.dom ? o : n > 0 ? t.nextSibling : t.previousSibling;
    }
    return null;
}
var WJ = function() {
    function e() {
        var t = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        No(this, e), this.plugins = [], this.pluginMap = new Map, this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), n.parent && n.parent.appendChild(this.dom);
        var r = n.dispatch;
        this.dispatchTransactions = n.dispatchTransactions || r && function(e) {
            return e.forEach(function(e) {
                return r(e, t);
            });
        } || function(e) {
            return t.update(e);
        }, this.dispatch = this.dispatch.bind(this), this._root = n.root || function(e) {
            for(; e;){
                if (e && (9 == e.nodeType || 11 == e.nodeType && e.host)) return e;
                e = e.assignedSlot || e.parentNode;
            }
            return null;
        }(n.parent) || document, this.viewState = new yJ(n.state || kV.create(n)), n.scrollTo && n.scrollTo.is(VW) && (this.viewState.scrollTarget = n.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(JW).map(function(e) {
            return new GW(e);
        });
        var o, i = bo(this.plugins);
        try {
            for(i.s(); !(o = i.n()).done;)o.value.update(this);
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        this.observer = new VJ(this), this.inputState = new $U(this), this.inputState.ensureHandlers(this.plugins), this.docView = new cU(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure();
    }
    return Do(e, [
        {
            key: "state",
            get: function() {
                return this.viewState.state;
            }
        },
        {
            key: "viewport",
            get: function() {
                return this.viewState.viewport;
            }
        },
        {
            key: "visibleRanges",
            get: function() {
                return this.viewState.visibleRanges;
            }
        },
        {
            key: "inView",
            get: function() {
                return this.viewState.inView;
            }
        },
        {
            key: "composing",
            get: function() {
                return this.inputState.composing > 0;
            }
        },
        {
            key: "compositionStarted",
            get: function() {
                return this.inputState.composing >= 0;
            }
        },
        {
            key: "root",
            get: function() {
                return this._root;
            }
        },
        {
            key: "win",
            get: function() {
                return this.dom.ownerDocument.defaultView || window;
            }
        },
        {
            key: "dispatch",
            value: function() {
                for(var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                var o = 1 == n.length && n[0] instanceof fV ? n : 1 == n.length && Array.isArray(n[0]) ? n[0] : [
                    (e = this.state).update.apply(e, n)
                ];
                this.dispatchTransactions(o, this);
            }
        },
        {
            key: "update",
            value: function(e) {
                var t = this;
                if (0 != this.updateState) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
                var n, r, o = !1, i = !1, a = this.state, s = bo(e);
                try {
                    for(s.s(); !(r = s.n()).done;){
                        var c = r.value;
                        if (c.startState != a) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
                        a = c.state;
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                if (this.destroyed) this.viewState.state = a;
                else {
                    var l = this.hasFocus, u = 0, f = null;
                    e.some(function(e) {
                        return e.annotation(QU);
                    }) ? (this.inputState.notifiedFocused = l, u = 1) : l != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = l, (f = YU(a, l)) || (u = 1));
                    var d = this.observer.delayedAndroidKey, h = null;
                    if (d ? (this.observer.clearDelayedAndroidKey(), ((h = this.observer.readChange()) && !this.state.doc.eq(a.doc) || !this.state.selection.eq(a.selection)) && (h = null)) : this.observer.clear(), a.facet(kV.phrases) != this.state.facet(kV.phrases)) return this.setState(a);
                    n = sU.create(this, a, e), n.flags |= u;
                    var v = this.viewState.scrollTarget;
                    try {
                        this.updateState = 2;
                        var p, m = bo(e);
                        try {
                            for(m.s(); !(p = m.n()).done;){
                                var g = p.value;
                                if (v && (v = v.map(g.changes)), g.scrollIntoView) {
                                    var y = g.state.selection.main;
                                    v = new FW(y.empty ? y : PF.cursor(y.head, y.head > y.anchor ? -1 : 1));
                                }
                                var b, w = bo(g.effects);
                                try {
                                    for(w.s(); !(b = w.n()).done;){
                                        var x = b.value;
                                        x.is(VW) && (v = x.value.clip(this.state));
                                    }
                                } catch (e) {
                                    w.e(e);
                                } finally{
                                    w.f();
                                }
                            }
                        } catch (e) {
                            m.e(e);
                        } finally{
                            m.f();
                        }
                        this.viewState.update(n, v), this.bidiCache = KJ.update(this.bidiCache, n.changes), n.empty || (this.updatePlugins(n), this.inputState.update(n)), o = this.docView.update(n), this.state.facet(iU) != this.styleModules && this.mountStyles(), i = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(o, e.some(function(e) {
                            return e.isUserEvent("select.pointer");
                        }));
                    } finally{
                        this.updateState = 0;
                    }
                    if (n.startState.facet($J) != n.state.facet($J) && (this.viewState.mustMeasureContent = !0), (o || i || v || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !n.empty) {
                        var k, j = bo(this.state.facet(DW));
                        try {
                            for(j.s(); !(k = j.n()).done;){
                                var S = k.value;
                                try {
                                    S(n);
                                } catch (x) {
                                    HW(this.state, x, "update listener");
                                }
                            }
                        } catch (e) {
                            j.e(e);
                        } finally{
                            j.f();
                        }
                    }
                    (f || h) && Promise.resolve().then(function() {
                        f && t.state == f.startState && t.dispatch(f), h && !BJ(t, h) && d.force && mH(t.contentDOM, d.key, d.keyCode);
                    });
                }
            }
        },
        {
            key: "setState",
            value: function(e) {
                if (0 != this.updateState) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
                if (this.destroyed) this.viewState.state = e;
                else {
                    this.updateState = 2;
                    var t = this.hasFocus;
                    try {
                        var n, r = bo(this.plugins);
                        try {
                            for(r.s(); !(n = r.n()).done;)n.value.destroy(this);
                        } catch (e) {
                            r.e(e);
                        } finally{
                            r.f();
                        }
                        this.viewState = new yJ(e), this.plugins = e.facet(JW).map(function(e) {
                            return new GW(e);
                        }), this.pluginMap.clear();
                        var o, i = bo(this.plugins);
                        try {
                            for(i.s(); !(o = i.n()).done;)o.value.update(this);
                        } catch (e) {
                            i.e(e);
                        } finally{
                            i.f();
                        }
                        this.docView.destroy(), this.docView = new cU(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
                    } finally{
                        this.updateState = 0;
                    }
                    t && this.focus(), this.requestMeasure();
                }
            }
        },
        {
            key: "updatePlugins",
            value: function(e) {
                var t = e.startState.facet(JW), n = e.state.facet(JW);
                if (t != n) {
                    var r, o = [], i = bo(n);
                    try {
                        for(i.s(); !(r = i.n()).done;){
                            var a = r.value, s = t.indexOf(a);
                            if (s < 0) o.push(new GW(a));
                            else {
                                var c = this.plugins[s];
                                c.mustUpdate = e, o.push(c);
                            }
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    var l, u = bo(this.plugins);
                    try {
                        for(u.s(); !(l = u.n()).done;){
                            var f = l.value;
                            f.mustUpdate != e && f.destroy(this);
                        }
                    } catch (e) {
                        u.e(e);
                    } finally{
                        u.f();
                    }
                    this.plugins = o, this.pluginMap.clear();
                } else {
                    var d, h = bo(this.plugins);
                    try {
                        for(h.s(); !(d = h.n()).done;)d.value.mustUpdate = e;
                    } catch (e) {
                        h.e(e);
                    } finally{
                        h.f();
                    }
                }
                for(var v = 0; v < this.plugins.length; v++)this.plugins[v].update(this);
                t != n && this.inputState.ensureHandlers(this.plugins);
            }
        },
        {
            key: "measure",
            value: function() {
                var e = this, t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                if (!this.destroyed) {
                    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) return this.measureScheduled = -1, void this.requestMeasure();
                    this.measureScheduled = 0, t && this.observer.forceFlush();
                    var n = null, r = this.scrollDOM, o = r.scrollTop * this.scaleY, i = this.viewState, a = i.scrollAnchorPos, s = i.scrollAnchorHeight;
                    Math.abs(o - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
                    try {
                        for(var c = 0;; c++){
                            if (s < 0) {
                                if (yH(r)) a = -1, s = this.viewState.heightMap.height;
                                else {
                                    var l = this.viewState.scrollAnchorAt(o);
                                    a = l.from, s = l.top;
                                }
                            }
                            this.updateState = 1;
                            var u = this.viewState.measure(this);
                            if (!u && !this.measureRequests.length && null == this.viewState.scrollTarget) break;
                            if (c > 5) {
                                console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                                break;
                            }
                            var f = [];
                            if (!(4 & u)) {
                                var d = [
                                    f,
                                    this.measureRequests
                                ];
                                this.measureRequests = d[0], f = d[1];
                            }
                            var h = f.map(function(t) {
                                try {
                                    return t.read(e);
                                } catch (t) {
                                    return HW(e.state, t), JJ;
                                }
                            }), v = sU.create(this, this.state, []), p = !1;
                            v.flags |= u, n ? n.flags |= u : n = v, this.updateState = 2, v.empty || (this.updatePlugins(v), this.inputState.update(v), this.updateAttrs(), p = this.docView.update(v));
                            for(var m = 0; m < f.length; m++)if (h[m] != JJ) try {
                                var g = f[m];
                                g.write && g.write(h[m], this);
                            } catch (e) {
                                HW(this.state, e);
                            }
                            if (p && this.docView.updateSelection(!0), !v.viewportChanged && 0 == this.measureRequests.length) {
                                if (this.viewState.editorHeight) {
                                    if (this.viewState.scrollTarget) {
                                        this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, s = -1;
                                        continue;
                                    }
                                    var y = (a < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(a).top) - s;
                                    if (y > 1 || y < -1) {
                                        o += y, r.scrollTop = o / this.scaleY, s = -1;
                                        continue;
                                    }
                                }
                                break;
                            }
                        }
                    } finally{
                        this.updateState = 0, this.measureScheduled = -1;
                    }
                    if (n && !n.empty) {
                        var b, w = bo(this.state.facet(DW));
                        try {
                            for(w.s(); !(b = w.n()).done;)(0, b.value)(n);
                        } catch (e) {
                            w.e(e);
                        } finally{
                            w.f();
                        }
                    }
                }
            }
        },
        {
            key: "themeClasses",
            get: function() {
                return OJ + " " + (this.state.facet(_J) ? EJ : MJ) + " " + this.state.facet($J);
            }
        },
        {
            key: "updateAttrs",
            value: function() {
                var e = this, t = GJ(this, QW, {
                    class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
                }), n = {
                    spellcheck: "false",
                    autocorrect: "off",
                    autocapitalize: "off",
                    translate: "no",
                    contenteditable: this.state.facet(WW) ? "true" : "false",
                    class: "cm-content",
                    style: "".concat(DH.tabSize, ": ").concat(this.state.tabSize),
                    role: "textbox",
                    "aria-multiline": "true"
                };
                this.state.readOnly && (n["aria-readonly"] = "true"), GJ(this, YW, n);
                var r = this.observer.ignore(function() {
                    var r = KH(e.contentDOM, e.contentAttrs, n), o = KH(e.dom, e.editorAttrs, t);
                    return r || o;
                });
                return this.editorAttrs = t, this.contentAttrs = n, r;
            }
        },
        {
            key: "showAnnouncements",
            value: function(t) {
                var n, r = !0, o = bo(t);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i, a = bo(n.value.effects);
                        try {
                            for(a.s(); !(i = a.n()).done;){
                                var s = i.value;
                                if (s.is(e.announce)) r && (this.announceDOM.textContent = ""), r = !1, this.announceDOM.appendChild(document.createElement("div")).textContent = s.value;
                            }
                        } catch (e) {
                            a.e(e);
                        } finally{
                            a.f();
                        }
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
            }
        },
        {
            key: "mountStyles",
            value: function() {
                this.styleModules = this.state.facet(iU);
                var t = this.state.facet(e.cspNonce);
                WV.mount(this.root, this.styleModules.concat(TJ).reverse(), t ? {
                    nonce: t
                } : void 0);
            }
        },
        {
            key: "readMeasured",
            value: function() {
                if (2 == this.updateState) throw new Error("Reading the editor layout isn't allowed during an update");
                0 == this.updateState && this.measureScheduled > -1 && this.measure(!1);
            }
        },
        {
            key: "requestMeasure",
            value: function(e) {
                var t = this;
                if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(function() {
                    return t.measure();
                })), e) {
                    if (this.measureRequests.indexOf(e) > -1) return;
                    if (null != e.key) {
                        for(var n = 0; n < this.measureRequests.length; n++)if (this.measureRequests[n].key === e.key) return void (this.measureRequests[n] = e);
                    }
                    this.measureRequests.push(e);
                }
            }
        },
        {
            key: "plugin",
            value: function(e) {
                var t = this.pluginMap.get(e);
                return (void 0 === t || t && t.spec != e) && this.pluginMap.set(e, t = this.plugins.find(function(t) {
                    return t.spec == e;
                }) || null), t && t.update(this).value;
            }
        },
        {
            key: "documentTop",
            get: function() {
                return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
            }
        },
        {
            key: "documentPadding",
            get: function() {
                return {
                    top: this.viewState.paddingTop,
                    bottom: this.viewState.paddingBottom
                };
            }
        },
        {
            key: "scaleX",
            get: function() {
                return this.viewState.scaleX;
            }
        },
        {
            key: "scaleY",
            get: function() {
                return this.viewState.scaleY;
            }
        },
        {
            key: "elementAtHeight",
            value: function(e) {
                return this.readMeasured(), this.viewState.elementAtHeight(e);
            }
        },
        {
            key: "lineBlockAtHeight",
            value: function(e) {
                return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
            }
        },
        {
            key: "viewportLineBlocks",
            get: function() {
                return this.viewState.viewportLines;
            }
        },
        {
            key: "lineBlockAt",
            value: function(e) {
                return this.viewState.lineBlockAt(e);
            }
        },
        {
            key: "contentHeight",
            get: function() {
                return this.viewState.contentHeight;
            }
        },
        {
            key: "moveByChar",
            value: function(e, t, n) {
                return CU(this, e, jU(this, e, t, n));
            }
        },
        {
            key: "moveByGroup",
            value: function(e, t) {
                var n = this;
                return CU(this, e, jU(this, e, t, function(t) {
                    return function(e, t, n) {
                        var r = e.state.charCategorizer(t), o = r(n);
                        return function(e) {
                            var t = r(e);
                            return o == bV.Space && (o = t), o == t;
                        };
                    }(n, e.head, t);
                }));
            }
        },
        {
            key: "visualLineSide",
            value: function(e, t) {
                var n = this.bidiSpans(e), r = this.textDirectionAt(e.from), o = n[t ? n.length - 1 : 0];
                return PF.cursor(o.side(t, r) + e.from, o.forward(!t, r) ? 1 : -1);
            }
        },
        {
            key: "moveToLineBoundary",
            value: function(e, t) {
                return function(e, t, n, r) {
                    var o = kU(e, t.head), i = r && o.type == ZH.Text && (e.lineWrapping || o.widgetLineBreaks) ? e.coordsAtPos(t.assoc < 0 && t.head > o.from ? t.head - 1 : t.head) : null;
                    if (i) {
                        var a = e.dom.getBoundingClientRect(), s = e.textDirectionAt(o.from), c = e.posAtCoords({
                            x: n == (s == lW.LTR) ? a.right - 1 : a.left + 1,
                            y: (i.top + i.bottom) / 2
                        });
                        if (null != c) return PF.cursor(c, n ? -1 : 1);
                    }
                    return PF.cursor(n ? o.to : o.from, n ? -1 : 1);
                }(this, e, t, !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]);
            }
        },
        {
            key: "moveVertically",
            value: function(e, t, n) {
                return CU(this, e, function(e, t, n, r) {
                    var o = t.head, i = n ? 1 : -1;
                    if (o == (n ? e.state.doc.length : 0)) return PF.cursor(o, t.assoc);
                    var a, s = t.goalColumn, c = e.contentDOM.getBoundingClientRect(), l = e.coordsAtPos(o, t.assoc || -1), u = e.documentTop;
                    if (l) null == s && (s = l.left - c.left), a = i < 0 ? l.top : l.bottom;
                    else {
                        var f = e.viewState.lineBlockAt(o);
                        null == s && (s = Math.min(c.right - c.left, e.defaultCharacterWidth * (o - f.from))), a = (i < 0 ? f.top : f.bottom) + u;
                    }
                    for(var d = c.left + s, h = null != r ? r : e.viewState.heightOracle.textHeight >> 1, v = 0;; v += 10){
                        var p = a + (h + v) * i, m = wU(e, {
                            x: d,
                            y: p
                        }, !1, i);
                        if (p < c.top || p > c.bottom || (i < 0 ? m < o : m > o)) {
                            var g = e.docView.coordsForChar(m), y = !g || p < g.top ? -1 : 1;
                            return PF.cursor(m, y, void 0, s);
                        }
                    }
                }(this, e, t, n));
            }
        },
        {
            key: "domAtPos",
            value: function(e) {
                return this.docView.domAtPos(e);
            }
        },
        {
            key: "posAtDOM",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.docView.posFromDOM(e, t);
            }
        },
        {
            key: "posAtCoords",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return this.readMeasured(), wU(this, e, t);
            }
        },
        {
            key: "coordsAtPos",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                this.readMeasured();
                var n = this.docView.coordsAt(e, t);
                if (!n || n.left == n.right) return n;
                var r = this.state.doc.lineAt(e), o = this.bidiSpans(r);
                return cH(n, o[SW.find(o, e - r.from, -1, t)].dir == lW.LTR == t > 0);
            }
        },
        {
            key: "coordsForChar",
            value: function(e) {
                return this.readMeasured(), this.docView.coordsForChar(e);
            }
        },
        {
            key: "defaultCharacterWidth",
            get: function() {
                return this.viewState.heightOracle.charWidth;
            }
        },
        {
            key: "defaultLineHeight",
            get: function() {
                return this.viewState.heightOracle.lineHeight;
            }
        },
        {
            key: "textDirection",
            get: function() {
                return this.viewState.defaultTextDirection;
            }
        },
        {
            key: "textDirectionAt",
            value: function(e) {
                return !this.state.facet(BW) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
            }
        },
        {
            key: "lineWrapping",
            get: function() {
                return this.viewState.heightOracle.lineWrapping;
            }
        },
        {
            key: "bidiSpans",
            value: function(e) {
                if (e.length > UJ) return MW(e.length);
                var t, n, r = this.textDirectionAt(e.from), o = bo(this.bidiCache);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i = n.value;
                        if (i.from == e.from && i.dir == r && (i.fresh || CW(i.isolates, t = nU(this, e)))) return i.order;
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                t || (t = nU(this, e));
                var a = function(e, t, n) {
                    if (!e) return [
                        new SW(0, 0, t == fW ? 1 : 0)
                    ];
                    if (t == uW && !n.length && !jW.test(e)) return MW(e.length);
                    if (n.length) for(; e.length > $W.length;)$W[$W.length] = 256;
                    var r = [], o = t == uW ? 0 : 1;
                    return OW(e, o, o, n, 0, e.length, r), r;
                }(e.text, r, t);
                return this.bidiCache.push(new KJ(e.from, e.to, r, t, !0, a)), a;
            }
        },
        {
            key: "hasFocus",
            get: function() {
                var e;
                return (this.dom.ownerDocument.hasFocus() || DH.safari && (null === (e = this.inputState) || void 0 === e ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
            }
        },
        {
            key: "focus",
            value: function() {
                var e = this;
                this.observer.ignore(function() {
                    vH(e.contentDOM), e.docView.updateSelection();
                });
            }
        },
        {
            key: "setRoot",
            value: function(e) {
                this._root != e && (this._root = e, this.observer.setWindow((9 == e.nodeType ? e : e.ownerDocument).defaultView || window), this.mountStyles());
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t = bo(this.plugins);
                try {
                    for(t.s(); !(e = t.n()).done;)e.value.destroy(this);
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
                this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
            }
        },
        {
            key: "scrollSnapshot",
            value: function() {
                var e = this.scrollDOM, t = e.scrollTop, n = e.scrollLeft, r = this.viewState.scrollAnchorAt(t);
                return VW.of(new FW(PF.cursor(r.from), "start", "start", r.top - t, n, !0));
            }
        }
    ], [
        {
            key: "scrollIntoView",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return VW.of(new FW("number" == typeof e ? PF.cursor(e) : e, t.y, t.x, t.yMargin, t.xMargin));
            }
        },
        {
            key: "domEventHandlers",
            value: function(e) {
                return KW.define(function() {
                    return {};
                }, {
                    eventHandlers: e
                });
            }
        },
        {
            key: "domEventObservers",
            value: function(e) {
                return KW.define(function() {
                    return {};
                }, {
                    eventObservers: e
                });
            }
        },
        {
            key: "theme",
            value: function(e, t) {
                var n = WV.newName(), r = [
                    $J.of(n),
                    iU.of(PJ(".".concat(n), e))
                ];
                return t && t.dark && r.push(_J.of(!0)), r;
            }
        },
        {
            key: "baseTheme",
            value: function(e) {
                return JF.lowest(iU.of(PJ("." + OJ, e, AJ)));
            }
        },
        {
            key: "findFromDOM",
            value: function(e) {
                var t, n = e.querySelector(".cm-content"), r = n && xH.get(n) || xH.get(e);
                return (null === (t = null == r ? void 0 : r.rootView) || void 0 === t ? void 0 : t.view) || null;
            }
        }
    ]), e;
}();
WJ.styleModule = iU, WJ.inputHandler = zW, WJ.focusChangeEffect = qW, WJ.perLineTextDirection = BW, WJ.exceptionSink = IW, WJ.updateListener = DW, WJ.editable = WW, WJ.mouseSelectionStyle = NW, WJ.dragMovesSelection = RW, WJ.clickAddsSelectionRange = TW, WJ.decorations = XW, WJ.outerDecorations = ZW, WJ.atomicRanges = eU, WJ.bidiIsolatedRanges = tU, WJ.scrollMargins = rU, WJ.darkTheme = _J, WJ.cspNonce = NF.define({
    combine: function(e) {
        return e.length ? e[0] : "";
    }
}), WJ.contentAttributes = YW, WJ.editorAttributes = QW, WJ.lineWrapping = WJ.contentAttributes.of({
    class: "cm-lineWrapping"
}), WJ.announce = uV.define();
var UJ = 4096, JJ = {}, KJ = function() {
    function e(t, n, r, o, i, a) {
        No(this, e), this.from = t, this.to = n, this.dir = r, this.isolates = o, this.fresh = i, this.order = a;
    }
    return Do(e, null, [
        {
            key: "update",
            value: function(t, n) {
                if (n.empty && !t.some(function(e) {
                    return e.fresh;
                })) return t;
                for(var r = [], o = t.length ? t[t.length - 1].dir : lW.LTR, i = Math.max(0, t.length - 10); i < t.length; i++){
                    var a = t[i];
                    a.dir != o || n.touchesRange(a.from, a.to) || r.push(new e(n.mapPos(a.from, 1), n.mapPos(a.to, -1), a.dir, a.isolates, !1, a.order));
                }
                return r;
            }
        }
    ]), e;
}();
function GJ(e, t, n) {
    for(var r = e.state.facet(t), o = r.length - 1; o >= 0; o--){
        var i = r[o], a = "function" == typeof i ? i(e) : i;
        a && WH(a, n);
    }
    return n;
}
var QJ = DH.mac ? "mac" : DH.windows ? "win" : DH.linux ? "linux" : "key";
function YJ(e, t, n) {
    return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), !1 !== n && t.shiftKey && (e = "Shift-" + e), e;
}
var XJ = JF.default(WJ.domEventHandlers({
    keydown: function(e, t) {
        return oK(tK(t.state), e, t, "editor");
    }
})), ZJ = NF.define({
    enables: XJ
}), eK = new WeakMap;
function tK(e) {
    var t = e.facet(ZJ), n = eK.get(t);
    return n || eK.set(t, n = function(e) {
        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : QJ, r = Object.create(null), o = Object.create(null), i = function(e, t) {
            var n = o[e];
            if (null == n) o[e] = t;
            else if (n != t) throw new Error("Key binding " + e + " is used both as a regular binding and as a multi-stroke prefix");
        }, a = function(e, t, o, a, s) {
            for(var c, l, u = r[e] || (r[e] = Object.create(null)), f = t.split(/ (?!$)/).map(function(e) {
                return function(e, t) {
                    var n, r, o, i, a = e.split(/-(?!$)/), s = a[a.length - 1];
                    "Space" == s && (s = " ");
                    for(var c = 0; c < a.length - 1; ++c){
                        var l = a[c];
                        if (/^(cmd|meta|m)$/i.test(l)) i = !0;
                        else if (/^a(lt)?$/i.test(l)) n = !0;
                        else if (/^(c|ctrl|control)$/i.test(l)) r = !0;
                        else if (/^s(hift)?$/i.test(l)) o = !0;
                        else {
                            if (!/^mod$/i.test(l)) throw new Error("Unrecognized modifier name: " + l);
                            "mac" == t ? i = !0 : r = !0;
                        }
                    }
                    return n && (s = "Alt-" + s), r && (s = "Ctrl-" + s), i && (s = "Meta-" + s), o && (s = "Shift-" + s), s;
                }(e, n);
            }), d = function() {
                var t = f.slice(0, h).join(" ");
                i(t, !0), u[t] || (u[t] = {
                    preventDefault: !0,
                    stopPropagation: !1,
                    run: [
                        function(n) {
                            var r = nK = {
                                view: n,
                                prefix: t,
                                scope: e
                            };
                            return setTimeout(function() {
                                nK == r && (nK = null);
                            }, rK), !0;
                        }
                    ]
                });
            }, h = 1; h < f.length; h++)d();
            var v = f.join(" ");
            i(v, !1);
            var p = u[v] || (u[v] = {
                preventDefault: !1,
                stopPropagation: !1,
                run: (null === (l = null === (c = u._any) || void 0 === c ? void 0 : c.run) || void 0 === l ? void 0 : l.slice()) || []
            });
            o && p.run.push(o), a && (p.preventDefault = !0), s && (p.stopPropagation = !0);
        }, s = bo(e);
        try {
            for(s.s(); !(t = s.n()).done;){
                var c = t.value, l = c.scope ? c.scope.split(" ") : [
                    "editor"
                ];
                if (c.any) {
                    var u, f = bo(l);
                    try {
                        for(f.s(); !(u = f.n()).done;){
                            var d = u.value, h = r[d] || (r[d] = Object.create(null));
                            for(var v in h._any || (h._any = {
                                preventDefault: !1,
                                stopPropagation: !1,
                                run: []
                            }), h)h[v].run.push(c.any);
                        }
                    } catch (e) {
                        f.e(e);
                    } finally{
                        f.f();
                    }
                }
                var p = c[n] || c.key;
                if (p) {
                    var m, g = bo(l);
                    try {
                        for(g.s(); !(m = g.n()).done;){
                            var y = m.value;
                            a(y, p, c.run, c.preventDefault, c.stopPropagation), c.shift && a(y, "Shift-" + p, c.shift, c.preventDefault, c.stopPropagation);
                        }
                    } catch (e) {
                        g.e(e);
                    } finally{
                        g.f();
                    }
                }
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
        return r;
    }(t.reduce(function(e, t) {
        return e.concat(t);
    }, []))), n;
}
var nK = null, rK = 4e3;
function oK(e, t, n, r) {
    var o = function(e) {
        var t = !(QV && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || YV && e.shiftKey && e.key && 1 == e.key.length || "Unidentified" == e.key) && e.key || (e.shiftKey ? GV : KV)[e.keyCode] || e.key || "Unidentified";
        return "Esc" == t && (t = "Escape"), "Del" == t && (t = "Delete"), "Left" == t && (t = "ArrowLeft"), "Up" == t && (t = "ArrowUp"), "Right" == t && (t = "ArrowRight"), "Down" == t && (t = "ArrowDown"), t;
    }(t), i = wF(yF(o, 0)) == o.length && " " != o, a = "", s = !1, c = !1, l = !1;
    nK && nK.view == n && nK.scope == r && (a = nK.prefix + " ", AU.indexOf(t.keyCode) < 0 && (c = !0, nK = null));
    var u, f, d = new Set, h = function(e) {
        if (e) {
            var r, o = bo(e.run);
            try {
                for(o.s(); !(r = o.n()).done;){
                    var i = r.value;
                    if (!d.has(i) && (d.add(i), i(n, t))) return e.stopPropagation && (l = !0), !0;
                }
            } catch (e) {
                o.e(e);
            } finally{
                o.f();
            }
            e.preventDefault && (e.stopPropagation && (l = !0), c = !0);
        }
        return !1;
    }, v = e[r];
    return v && (h(v[a + YJ(o, t, !i)]) ? s = !0 : i && (t.altKey || t.metaKey || t.ctrlKey) && !(DH.windows && t.ctrlKey && t.altKey) && (u = KV[t.keyCode]) && u != o ? (h(v[a + YJ(u, t, !0)]) || t.shiftKey && (f = GV[t.keyCode]) != o && f != u && h(v[a + YJ(f, t, !1)])) && (s = !0) : i && t.shiftKey && h(v[a + YJ(o, t, !0)]) && (s = !0), !s && h(v._any) && (s = !0)), c && (s = !0), s && l && t.stopPropagation(), s;
}
var iK = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.className = t, this.left = n, this.top = r, this.width = o, this.height = i;
    }
    return Do(e, [
        {
            key: "draw",
            value: function() {
                var e = document.createElement("div");
                return e.className = this.className, this.adjust(e), e;
            }
        },
        {
            key: "update",
            value: function(e, t) {
                return t.className == this.className && (this.adjust(e), !0);
            }
        },
        {
            key: "adjust",
            value: function(e) {
                e.style.left = this.left + "px", e.style.top = this.top + "px", null != this.width && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
            }
        },
        {
            key: "eq",
            value: function(e) {
                return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
            }
        }
    ], [
        {
            key: "forRange",
            value: function(t, n, r) {
                if (r.empty) {
                    var o = t.coordsAtPos(r.head, r.assoc || 1);
                    if (!o) return [];
                    var i = aK(t);
                    return [
                        new e(n, o.left - i.left, o.top - i.top, null, o.bottom - o.top)
                    ];
                }
                return cK(t, n, r);
            }
        }
    ]), e;
}();
function aK(e) {
    var t = e.scrollDOM.getBoundingClientRect();
    return {
        left: (e.textDirection == lW.LTR ? t.left : t.right - e.scrollDOM.clientWidth * e.scaleX) - e.scrollDOM.scrollLeft * e.scaleX,
        top: t.top - e.scrollDOM.scrollTop * e.scaleY
    };
}
function sK(e, t, n) {
    var r = PF.cursor(t);
    return {
        from: Math.max(n.from, e.moveToLineBoundary(r, !1, !0).from),
        to: Math.min(n.to, e.moveToLineBoundary(r, !0, !0).from),
        type: ZH.Text
    };
}
function cK(e, t, n) {
    if (n.to <= e.viewport.from || n.from >= e.viewport.to) return [];
    var r = Math.max(n.from, e.viewport.from), o = Math.min(n.to, e.viewport.to), i = e.textDirection == lW.LTR, a = e.contentDOM, s = a.getBoundingClientRect(), c = aK(e), l = a.querySelector(".cm-line"), u = l && window.getComputedStyle(l), f = s.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), d = s.right - (u ? parseInt(u.paddingRight) : 0), h = kU(e, r), v = kU(e, o), p = h.type == ZH.Text ? h : null, m = v.type == ZH.Text ? v : null;
    if (p && (e.lineWrapping || h.widgetLineBreaks) && (p = sK(e, r, p)), m && (e.lineWrapping || v.widgetLineBreaks) && (m = sK(e, o, m)), p && m && p.from == m.from) return x(k(n.from, n.to, p));
    var g = p ? k(n.from, null, p) : j(h, !1), y = m ? k(null, n.to, m) : j(v, !0), b = [];
    return (p || h).to < (m || v).from - (p && m ? 1 : 0) || h.widgetLineBreaks > 1 && g.bottom + e.defaultLineHeight / 2 < y.top ? b.push(w(f, g.bottom, d, y.top)) : g.bottom < y.top && e.elementAtHeight((g.bottom + y.top) / 2).type == ZH.Text && (g.bottom = y.top = (g.bottom + y.top) / 2), x(g).concat(b).concat(x(y));
    function w(e, n, r, o) {
        return new iK(t, e - c.left, n - c.top - .01, r - e, o - n + .01);
    }
    function x(e) {
        for(var t = e.top, n = e.bottom, r = e.horizontal, o = [], i = 0; i < r.length; i += 2)o.push(w(r[i], t, r[i + 1], n));
        return o;
    }
    function k(t, n, r) {
        var o = 1e9, a = -1000000000, s = [];
        function c(t, n, c, l, u) {
            var h = e.coordsAtPos(t, t == r.to ? -2 : 2), v = e.coordsAtPos(c, c == r.from ? 2 : -2);
            h && v && (o = Math.min(h.top, v.top, o), a = Math.max(h.bottom, v.bottom, a), u == lW.LTR ? s.push(i && n ? f : h.left, i && l ? d : v.right) : s.push(!i && l ? f : v.left, !i && n ? d : h.right));
        }
        var l, u = null != t ? t : r.from, h = null != n ? n : r.to, v = bo(e.visibleRanges);
        try {
            for(v.s(); !(l = v.n()).done;){
                var p = l.value;
                if (p.to > u && p.from < h) for(var m = Math.max(p.from, u), g = Math.min(p.to, h);;){
                    var y, b = e.state.doc.lineAt(m), w = bo(e.bidiSpans(b));
                    try {
                        for(w.s(); !(y = w.n()).done;){
                            var x = y.value, k = x.from + b.from, j = x.to + b.from;
                            if (k >= g) break;
                            j > m && c(Math.max(k, m), null == t && k <= u, Math.min(j, g), null == n && j >= h, x.dir);
                        }
                    } catch (e) {
                        w.e(e);
                    } finally{
                        w.f();
                    }
                    if ((m = b.to + 1) >= g) break;
                }
            }
        } catch (e) {
            v.e(e);
        } finally{
            v.f();
        }
        return 0 == s.length && c(u, null == t, h, null == n, e.textDirection), {
            top: o,
            bottom: a,
            horizontal: s
        };
    }
    function j(e, t) {
        var n = s.top + (t ? e.top : e.bottom);
        return {
            top: n,
            bottom: n,
            horizontal: []
        };
    }
}
var lK = function() {
    function e(t, n) {
        No(this, e), this.view = t, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        }, this.dom = t.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(t.state), t.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, t);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                e.startState.facet(uK) != e.state.facet(uK) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
            }
        },
        {
            key: "setOrder",
            value: function(e) {
                for(var t = 0, n = e.facet(uK); t < n.length && n[t] != this.layer;)t++;
                this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - t);
            }
        },
        {
            key: "measure",
            value: function() {
                return this.layer.markers(this.view);
            }
        },
        {
            key: "scale",
            value: function() {
                var e = this.view, t = e.scaleX, n = e.scaleY;
                t == this.scaleX && n == this.scaleY || (this.scaleX = t, this.scaleY = n, this.dom.style.transform = "scale(".concat(1 / t, ", ").concat(1 / n, ")"));
            }
        },
        {
            key: "draw",
            value: function(e) {
                var t = this;
                if (e.length != this.drawn.length || e.some(function(e, n) {
                    var r, o;
                    return r = e, o = t.drawn[n], !(r.constructor == o.constructor && r.eq(o));
                })) {
                    var n, r = this.dom.firstChild, o = 0, i = bo(e);
                    try {
                        for(i.s(); !(n = i.n()).done;){
                            var a = n.value;
                            a.update && r && a.constructor && this.drawn[o].constructor && a.update(r, this.drawn[o]) ? (r = r.nextSibling, o++) : this.dom.insertBefore(a.draw(), r);
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    for(; r;){
                        var s = r.nextSibling;
                        r.remove(), r = s;
                    }
                    this.drawn = e;
                }
            }
        },
        {
            key: "destroy",
            value: function() {
                this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
            }
        }
    ]), e;
}(), uK = NF.define();
function fK(e) {
    return [
        KW.define(function(t) {
            return new lK(t, e);
        }),
        uK.of(e)
    ];
}
var dK = !DH.ios, hK = NF.define({
    combine: function(e) {
        return jV(e, {
            cursorBlinkRate: 1200,
            drawRangeCursor: !0
        }, {
            cursorBlinkRate: function(e, t) {
                return Math.min(e, t);
            },
            drawRangeCursor: function(e, t) {
                return e || t;
            }
        });
    }
});
function vK() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        hK.of(e),
        mK,
        yK,
        wK,
        LW.of(!0)
    ];
}
function pK(e) {
    return e.startState.facet(hK) != e.state.facet(hK);
}
var mK = fK({
    above: !0,
    markers: function(e) {
        var t, n = e.state, r = n.facet(hK), o = [], i = bo(n.selection.ranges);
        try {
            for(i.s(); !(t = i.n()).done;){
                var a = t.value, s = a == n.selection.main;
                if (a.empty ? !s || dK : r.drawRangeCursor) {
                    var c, l = s ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", u = a.empty ? a : PF.cursor(a.head, a.head > a.anchor ? -1 : 1), f = bo(iK.forRange(e, l, u));
                    try {
                        for(f.s(); !(c = f.n()).done;){
                            var d = c.value;
                            o.push(d);
                        }
                    } catch (e) {
                        f.e(e);
                    } finally{
                        f.f();
                    }
                }
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        return o;
    },
    update: function(e, t) {
        e.transactions.some(function(e) {
            return e.selection;
        }) && (t.style.animationName = "cm-blink" == t.style.animationName ? "cm-blink2" : "cm-blink");
        var n = pK(e);
        return n && gK(e.state, t), e.docChanged || e.selectionSet || n;
    },
    mount: function(e, t) {
        gK(t.state, e);
    },
    class: "cm-cursorLayer"
});
function gK(e, t) {
    t.style.animationDuration = e.facet(hK).cursorBlinkRate + "ms";
}
var yK = fK({
    above: !1,
    markers: function(e) {
        return e.state.selection.ranges.map(function(t) {
            return t.empty ? [] : iK.forRange(e, "cm-selectionBackground", t);
        }).reduce(function(e, t) {
            return e.concat(t);
        });
    },
    update: function(e, t) {
        return e.docChanged || e.selectionSet || e.viewportChanged || pK(e);
    },
    class: "cm-selectionLayer"
}), bK = {
    ".cm-line": {
        "& ::selection": {
            backgroundColor: "transparent !important"
        },
        "&::selection": {
            backgroundColor: "transparent !important"
        }
    }
};
dK && (bK[".cm-line"].caretColor = "transparent !important", bK[".cm-content"] = {
    caretColor: "transparent !important"
});
var wK = JF.highest(WJ.theme(bK)), xK = uV.define({
    map: function(e, t) {
        return null == e ? null : t.mapPos(e);
    }
}), kK = LF.define({
    create: function() {
        return null;
    },
    update: function(e, t) {
        return null != e && (e = t.changes.mapPos(e)), t.effects.reduce(function(e, t) {
            return t.is(xK) ? t.value : e;
        }, e);
    }
}), jK = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.cursor = null, this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t, n = e.state.field(kK);
                null == n ? null != this.cursor && (null === (t = this.cursor) || void 0 === t || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (e.startState.field(kK) != n || e.docChanged || e.geometryChanged) && this.view.requestMeasure(this.measureReq));
            }
        },
        {
            key: "readPos",
            value: function() {
                var e = this.view, t = e.state.field(kK), n = null != t && e.coordsAtPos(t);
                if (!n) return null;
                var r = e.scrollDOM.getBoundingClientRect();
                return {
                    left: n.left - r.left + e.scrollDOM.scrollLeft * e.scaleX,
                    top: n.top - r.top + e.scrollDOM.scrollTop * e.scaleY,
                    height: n.bottom - n.top
                };
            }
        },
        {
            key: "drawCursor",
            value: function(e) {
                if (this.cursor) {
                    var t = this.view, n = t.scaleX, r = t.scaleY;
                    e ? (this.cursor.style.left = e.left / n + "px", this.cursor.style.top = e.top / r + "px", this.cursor.style.height = e.height / r + "px") : this.cursor.style.left = "-100000px";
                }
            }
        },
        {
            key: "destroy",
            value: function() {
                this.cursor && this.cursor.remove();
            }
        },
        {
            key: "setDropPos",
            value: function(e) {
                this.view.state.field(kK) != e && this.view.dispatch({
                    effects: xK.of(e)
                });
            }
        }
    ]), e;
}(), {
    eventObservers: {
        dragover: function(e) {
            this.setDropPos(this.view.posAtCoords({
                x: e.clientX,
                y: e.clientY
            }));
        },
        dragleave: function(e) {
            e.target != this.view.contentDOM && this.view.contentDOM.contains(e.relatedTarget) || this.setDropPos(null);
        },
        dragend: function() {
            this.setDropPos(null);
        },
        drop: function() {
            this.setDropPos(null);
        }
    }
});
function SK(e, t, n, r, o) {
    t.lastIndex = 0;
    for(var i, a = e.iterRange(n, r), s = n; !a.next().done; s += a.value.length)if (!a.lineBreak) for(; i = t.exec(a.value);)o(s + i.index, i);
}
var CK = function() {
    function e(t) {
        No(this, e);
        var n = t.regexp, r = t.decoration, o = t.decorate, i = t.boundary, a = t.maxLength, s = void 0 === a ? 1e3 : a;
        if (!n.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        if (this.regexp = n, o) this.addMatch = function(e, t, n, r) {
            return o(r, n, n + e[0].length, e, t);
        };
        else if ("function" == typeof r) this.addMatch = function(e, t, n, o) {
            var i = r(e, t, n);
            i && o(n, n + e[0].length, i);
        };
        else {
            if (!r) throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
            this.addMatch = function(e, t, n, o) {
                return o(n, n + e[0].length, r);
            };
        }
        this.boundary = i, this.maxLength = s;
    }
    return Do(e, [
        {
            key: "createDeco",
            value: function(e) {
                var t, n = this, r = new MV, o = r.add.bind(r), i = bo(function(e, t) {
                    var n = e.visibleRanges;
                    if (1 == n.length && n[0].from == e.viewport.from && n[0].to == e.viewport.to) return n;
                    var r, o = [], i = bo(n);
                    try {
                        for(i.s(); !(r = i.n()).done;){
                            var a = r.value, s = a.from, c = a.to;
                            s = Math.max(e.state.doc.lineAt(s).from, s - t), c = Math.min(e.state.doc.lineAt(c).to, c + t), o.length && o[o.length - 1].to >= s ? o[o.length - 1].to = c : o.push({
                                from: s,
                                to: c
                            });
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    return o;
                }(e, this.maxLength));
                try {
                    for(i.s(); !(t = i.n()).done;){
                        var a = t.value, s = a.from, c = a.to;
                        SK(e.state.doc, this.regexp, s, c, function(t, r) {
                            return n.addMatch(r, e, t, o);
                        });
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return r.finish();
            }
        },
        {
            key: "updateDeco",
            value: function(e, t) {
                var n = 1e9, r = -1;
                return e.docChanged && e.changes.iterChanges(function(t, o, i, a) {
                    a > e.view.viewport.from && i < e.view.viewport.to && (n = Math.min(i, n), r = Math.max(a, r));
                }), e.viewportChanged || r - n > 1e3 ? this.createDeco(e.view) : r > -1 ? this.updateRange(e.view, t.map(e.changes), n, r) : t;
            }
        },
        {
            key: "updateRange",
            value: function(e, t, n, r) {
                var o, i = this, a = bo(e.visibleRanges);
                try {
                    var s = function() {
                        var a = o.value, s = Math.max(a.from, n), c = Math.min(a.to, r);
                        if (c > s) {
                            var l = e.state.doc.lineAt(s), u = l.to < c ? e.state.doc.lineAt(c) : l, f = Math.max(a.from, l.from), d = Math.min(a.to, u.to);
                            if (i.boundary) {
                                for(; s > l.from; s--)if (i.boundary.test(l.text[s - 1 - l.from])) {
                                    f = s;
                                    break;
                                }
                                for(; c < u.to; c++)if (i.boundary.test(u.text[c - u.from])) {
                                    d = c;
                                    break;
                                }
                            }
                            var h, v = [], p = function(e, t, n) {
                                return v.push(n.range(e, t));
                            };
                            if (l == u) for(i.regexp.lastIndex = f - l.from; (h = i.regexp.exec(l.text)) && h.index < d - l.from;)i.addMatch(h, e, h.index + l.from, p);
                            else SK(e.state.doc, i.regexp, f, d, function(t, n) {
                                return i.addMatch(n, e, t, p);
                            });
                            t = t.update({
                                filterFrom: f,
                                filterTo: d,
                                filter: function(e, t) {
                                    return e < f || t > d;
                                },
                                add: v
                            });
                        }
                    };
                    for(a.s(); !(o = a.n()).done;)s();
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return t;
            }
        }
    ]), e;
}(), $K = null != /x/.unicode ? "gu" : "g", _K = new RegExp("[\x00-\b\n-\x1f\x7f-\x9f\xad\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\u2066\u2067\u2069\uFEFF\uFFF9-\uFFFC]", $K), OK = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
}, MK = null;
var EK = NF.define({
    combine: function(e) {
        var t = jV(e, {
            render: null,
            specialChars: _K,
            addSpecialChars: null
        });
        return (t.replaceTabs = !function() {
            var e;
            if (null == MK && "undefined" != typeof document && document.body) {
                var t = document.body.style;
                MK = null != (null !== (e = t.tabSize) && void 0 !== e ? e : t.MozTabSize);
            }
            return MK || !1;
        }()) && (t.specialChars = new RegExp("	|" + t.specialChars.source, $K)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, $K)), t;
    }
});
function AK() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        EK.of(e),
        PK || (PK = KW.fromClass(function() {
            function e(t) {
                No(this, e), this.view = t, this.decorations = eW.none, this.decorationCache = Object.create(null), this.decorator = this.makeDecorator(t.state.facet(EK)), this.decorations = this.decorator.createDeco(t);
            }
            return Do(e, [
                {
                    key: "makeDecorator",
                    value: function(e) {
                        var t = this;
                        return new CK({
                            regexp: e.specialChars,
                            decoration: function(n, r, o) {
                                var i = r.state.doc, a = yF(n[0], 0);
                                if (9 == a) {
                                    var s = i.lineAt(o), c = r.state.tabSize, l = BV(s.text, c, o - s.from);
                                    return eW.replace({
                                        widget: new RK((c - l % c) * t.view.defaultCharacterWidth / t.view.scaleX)
                                    });
                                }
                                return t.decorationCache[a] || (t.decorationCache[a] = eW.replace({
                                    widget: new TK(e, a)
                                }));
                            },
                            boundary: e.replaceTabs ? void 0 : /[^]/
                        });
                    }
                },
                {
                    key: "update",
                    value: function(e) {
                        var t = e.state.facet(EK);
                        e.startState.facet(EK) != t ? (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(e.view)) : this.decorations = this.decorator.updateDeco(e, this.decorations);
                    }
                }
            ]), e;
        }(), {
            decorations: function(e) {
                return e.decorations;
            }
        }))
    ];
}
var PK = null;
var TK = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t)).options = e, r.code = n, r;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e.code == this.code;
            }
        },
        {
            key: "toDOM",
            value: function(e) {
                var t = function(e) {
                    return e >= 32 ? "\u2022" : 10 == e ? "\u2424" : String.fromCharCode(9216 + e);
                }(this.code), n = e.state.phrase("Control character") + " " + (OK[this.code] || "0x" + this.code.toString(16)), r = this.options.render && this.options.render(this.code, n, t);
                if (r) return r;
                var o = document.createElement("span");
                return o.textContent = t, o.title = n, o.setAttribute("aria-label", n), o.className = "cm-specialChar", o;
            }
        },
        {
            key: "ignoreEvent",
            value: function() {
                return !1;
            }
        }
    ]), t;
}(), RK = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).width = e, n;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e.width == this.width;
            }
        },
        {
            key: "toDOM",
            value: function() {
                var e = document.createElement("span");
                return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
            }
        },
        {
            key: "ignoreEvent",
            value: function() {
                return !1;
            }
        }
    ]), t;
}();
var NK = eW.line({
    class: "cm-activeLine"
}), IK = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.decorations = this.getDeco(t);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                (e.docChanged || e.selectionSet) && (this.decorations = this.getDeco(e.view));
            }
        },
        {
            key: "getDeco",
            value: function(e) {
                var t, n = -1, r = [], o = bo(e.state.selection.ranges);
                try {
                    for(o.s(); !(t = o.n()).done;){
                        var i = t.value, a = e.lineBlockAt(i.head);
                        a.from > n && (r.push(NK.range(a.from)), n = a.from);
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return eW.set(r);
            }
        }
    ]), e;
}(), {
    decorations: function(e) {
        return e.decorations;
    }
}), DK = 2e3;
function zK(e, t) {
    var n = e.posAtCoords({
        x: t.clientX,
        y: t.clientY
    }, !1), r = e.state.doc.lineAt(n), o = n - r.from, i = o > DK ? -1 : o == r.length ? function(e, t) {
        var n = e.coordsAtPos(e.viewport.from);
        return n ? Math.round(Math.abs((n.left - t) / e.defaultCharacterWidth)) : -1;
    }(e, t.clientX) : BV(r.text, e.state.tabSize, n - r.from);
    return {
        line: r.number,
        col: i,
        off: o
    };
}
function qK(e, t) {
    var n = zK(e, t), r = e.state.selection;
    return n ? {
        update: function(e) {
            if (e.docChanged) {
                var t = e.changes.mapPos(e.startState.doc.line(n.line).from), o = e.state.doc.lineAt(t);
                n = {
                    line: o.number,
                    col: n.col,
                    off: Math.min(n.off, o.length)
                }, r = r.map(e.changes);
            }
        },
        get: function(t, o, i) {
            var a = zK(e, t);
            if (!a) return r;
            var s = function(e, t, n) {
                var r = Math.min(t.line, n.line), o = Math.max(t.line, n.line), i = [];
                if (t.off > DK || n.off > DK || t.col < 0 || n.col < 0) for(var a = Math.min(t.off, n.off), s = Math.max(t.off, n.off), c = r; c <= o; c++){
                    var l = e.doc.line(c);
                    l.length <= s && i.push(PF.range(l.from + a, l.to + s));
                }
                else for(var u = Math.min(t.col, n.col), f = Math.max(t.col, n.col), d = r; d <= o; d++){
                    var h = e.doc.line(d), v = LV(h.text, u, e.tabSize, !0);
                    if (v < 0) i.push(PF.cursor(h.to));
                    else {
                        var p = LV(h.text, f, e.tabSize);
                        i.push(PF.range(h.from + v, h.from + p));
                    }
                }
                return i;
            }(e.state, n, a);
            return s.length ? i ? PF.create(s.concat(r.ranges)) : PF.create(s) : r;
        }
    } : null;
}
function BK(e) {
    var t = (null == e ? void 0 : e.eventFilter) || function(e) {
        return e.altKey && 0 == e.button;
    };
    return WJ.mouseSelectionStyle.of(function(e, n) {
        return t(n) ? qK(e, n) : null;
    });
}
var LK = {
    Alt: [
        18,
        function(e) {
            return !!e.altKey;
        }
    ],
    Control: [
        17,
        function(e) {
            return !!e.ctrlKey;
        }
    ],
    Shift: [
        16,
        function(e) {
            return !!e.shiftKey;
        }
    ],
    Meta: [
        91,
        function(e) {
            return !!e.metaKey;
        }
    ]
}, FK = {
    style: "cursor: crosshair"
};
function VK() {
    var e = jo(LK[(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).key || "Alt"], 2), t = e[0], n = e[1], r = KW.fromClass(function() {
        function e(t) {
            No(this, e), this.view = t, this.isDown = !1;
        }
        return Do(e, [
            {
                key: "set",
                value: function(e) {
                    this.isDown != e && (this.isDown = e, this.view.update([]));
                }
            }
        ]), e;
    }(), {
        eventObservers: {
            keydown: function(e) {
                this.set(e.keyCode == t || n(e));
            },
            keyup: function(e) {
                e.keyCode != t && n(e) || this.set(!1);
            },
            mousemove: function(e) {
                this.set(n(e));
            }
        }
    });
    return [
        r,
        WJ.contentAttributes.of(function(e) {
            var t;
            return (null === (t = e.plugin(r)) || void 0 === t ? void 0 : t.isDown) ? FK : null;
        })
    ];
}
var HK = "-10000px", WK = function() {
    function e(t, n, r, o) {
        No(this, e), this.facet = n, this.createTooltipView = r, this.removeTooltipView = o, this.input = t.state.facet(n), this.tooltips = this.input.filter(function(e) {
            return e;
        });
        var i = null;
        this.tooltipViews = this.tooltips.map(function(e) {
            return i = r(e, i);
        });
    }
    return Do(e, [
        {
            key: "update",
            value: function(e, t) {
                var n, r = e.state.facet(this.facet), o = r.filter(function(e) {
                    return e;
                });
                if (r === this.input) {
                    var i, a = bo(this.tooltipViews);
                    try {
                        for(a.s(); !(i = a.n()).done;){
                            var s = i.value;
                            s.update && s.update(e);
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                    return !1;
                }
                for(var c = [], l = t ? [] : null, u = 0; u < o.length; u++){
                    var f = o[u], d = -1;
                    if (f) {
                        for(var h = 0; h < this.tooltips.length; h++){
                            var v = this.tooltips[h];
                            v && v.create == f.create && (d = h);
                        }
                        if (d < 0) c[u] = this.createTooltipView(f, u ? c[u - 1] : null), l && (l[u] = !!f.above);
                        else {
                            var p = c[u] = this.tooltipViews[d];
                            l && (l[u] = t[d]), p.update && p.update(e);
                        }
                    }
                }
                var m, g = bo(this.tooltipViews);
                try {
                    for(g.s(); !(m = g.n()).done;){
                        var y = m.value;
                        c.indexOf(y) < 0 && (this.removeTooltipView(y), null === (n = y.destroy) || void 0 === n || n.call(y));
                    }
                } catch (e) {
                    g.e(e);
                } finally{
                    g.f();
                }
                return t && (l.forEach(function(e, n) {
                    return t[n] = e;
                }), t.length = l.length), this.input = r, this.tooltips = o, this.tooltipViews = c, !0;
            }
        }
    ]), e;
}();
function UK(e) {
    var t = e.win;
    return {
        top: 0,
        left: 0,
        bottom: t.innerHeight,
        right: t.innerWidth
    };
}
var JK = NF.define({
    combine: function(e) {
        var t, n, r;
        return {
            position: DH.ios ? "absolute" : (null === (t = e.find(function(e) {
                return e.position;
            })) || void 0 === t ? void 0 : t.position) || "fixed",
            parent: (null === (n = e.find(function(e) {
                return e.parent;
            })) || void 0 === n ? void 0 : n.parent) || null,
            tooltipSpace: (null === (r = e.find(function(e) {
                return e.tooltipSpace;
            })) || void 0 === r ? void 0 : r.tooltipSpace) || UK
        };
    }
}), KK = new WeakMap, GK = KW.fromClass(function() {
    function e(t) {
        var n = this;
        No(this, e), this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
        var r = t.state.facet(JK);
        this.position = r.position, this.parent = r.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        }, this.resizeObserver = "function" == typeof ResizeObserver ? new ResizeObserver(function() {
            return n.measureSoon();
        }) : null, this.manager = new WK(t, XK, function(e, t) {
            return n.createTooltip(e, t);
        }, function(e) {
            n.resizeObserver && n.resizeObserver.unobserve(e.dom), e.dom.remove();
        }), this.above = this.manager.tooltips.map(function(e) {
            return !!e.above;
        }), this.intersectionObserver = "function" == typeof IntersectionObserver ? new IntersectionObserver(function(e) {
            Date.now() > n.lastTransaction - 50 && e.length > 0 && e[e.length - 1].intersectionRatio < 1 && n.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
    }
    return Do(e, [
        {
            key: "createContainer",
            value: function() {
                this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
            }
        },
        {
            key: "observeIntersection",
            value: function() {
                if (this.intersectionObserver) {
                    this.intersectionObserver.disconnect();
                    var e, t = bo(this.manager.tooltipViews);
                    try {
                        for(t.s(); !(e = t.n()).done;){
                            var n = e.value;
                            this.intersectionObserver.observe(n.dom);
                        }
                    } catch (e) {
                        t.e(e);
                    } finally{
                        t.f();
                    }
                }
            }
        },
        {
            key: "measureSoon",
            value: function() {
                var e = this;
                this.measureTimeout < 0 && (this.measureTimeout = setTimeout(function() {
                    e.measureTimeout = -1, e.maybeMeasure();
                }, 50));
            }
        },
        {
            key: "update",
            value: function(e) {
                e.transactions.length && (this.lastTransaction = Date.now());
                var t = this.manager.update(e, this.above);
                t && this.observeIntersection();
                var n = t || e.geometryChanged, r = e.state.facet(JK);
                if (r.position != this.position && !this.madeAbsolute) {
                    this.position = r.position;
                    var o, i = bo(this.manager.tooltipViews);
                    try {
                        for(i.s(); !(o = i.n()).done;)o.value.dom.style.position = this.position;
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    n = !0;
                }
                if (r.parent != this.parent) {
                    this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
                    var a, s = bo(this.manager.tooltipViews);
                    try {
                        for(s.s(); !(a = s.n()).done;){
                            var c = a.value;
                            this.container.appendChild(c.dom);
                        }
                    } catch (e) {
                        s.e(e);
                    } finally{
                        s.f();
                    }
                    n = !0;
                } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
                n && this.maybeMeasure();
            }
        },
        {
            key: "createTooltip",
            value: function(e, t) {
                var n = e.create(this.view), r = t ? t.dom : null;
                if (n.dom.classList.add("cm-tooltip"), e.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
                    var o = document.createElement("div");
                    o.className = "cm-tooltip-arrow", n.dom.insertBefore(o, r);
                }
                return n.dom.style.position = this.position, n.dom.style.top = HK, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t, n;
                this.view.win.removeEventListener("resize", this.measureSoon);
                var r, o = bo(this.manager.tooltipViews);
                try {
                    for(o.s(); !(r = o.n()).done;){
                        var i = r.value;
                        i.dom.remove(), null === (e = i.destroy) || void 0 === e || e.call(i);
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                this.parent && this.container.remove(), null === (t = this.resizeObserver) || void 0 === t || t.disconnect(), null === (n = this.intersectionObserver) || void 0 === n || n.disconnect(), clearTimeout(this.measureTimeout);
            }
        },
        {
            key: "readMeasure",
            value: function() {
                var e = this, t = this.view.dom.getBoundingClientRect(), n = 1, r = 1, o = !1;
                if ("fixed" == this.position && this.manager.tooltipViews.length) {
                    var i = this.manager.tooltipViews[0].dom;
                    if (DH.gecko) o = i.offsetParent != this.container.ownerDocument.body;
                    else if (i.style.top == HK && "0px" == i.style.left) {
                        var a = i.getBoundingClientRect();
                        o = Math.abs(a.top + 1e4) > 1 || Math.abs(a.left) > 1;
                    }
                }
                if (o || "absolute" == this.position) {
                    if (this.parent) {
                        var s = this.parent.getBoundingClientRect();
                        s.width && s.height && (n = s.width / this.parent.offsetWidth, r = s.height / this.parent.offsetHeight);
                    } else {
                        var c = this.view.viewState;
                        n = c.scaleX, r = c.scaleY;
                    }
                }
                return {
                    editor: t,
                    parent: this.parent ? this.container.getBoundingClientRect() : t,
                    pos: this.manager.tooltips.map(function(t, n) {
                        var r = e.manager.tooltipViews[n];
                        return r.getCoords ? r.getCoords(t.pos) : e.view.coordsAtPos(t.pos);
                    }),
                    size: this.manager.tooltipViews.map(function(e) {
                        return e.dom.getBoundingClientRect();
                    }),
                    space: this.view.state.facet(JK).tooltipSpace(this.view),
                    scaleX: n,
                    scaleY: r,
                    makeAbsolute: o
                };
            }
        },
        {
            key: "writeMeasure",
            value: function(e) {
                var t;
                if (e.makeAbsolute) {
                    this.madeAbsolute = !0, this.position = "absolute";
                    var n, r = bo(this.manager.tooltipViews);
                    try {
                        for(r.s(); !(n = r.n()).done;)n.value.dom.style.position = "absolute";
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
                for(var o = e.editor, i = e.space, a = e.scaleX, s = e.scaleY, c = [], l = 0; l < this.manager.tooltips.length; l++){
                    var u = this.manager.tooltips[l], f = this.manager.tooltipViews[l], d = f.dom, h = e.pos[l], v = e.size[l];
                    if (!h || h.bottom <= Math.max(o.top, i.top) || h.top >= Math.min(o.bottom, i.bottom) || h.right < Math.max(o.left, i.left) - .1 || h.left > Math.min(o.right, i.right) + .1) d.style.top = HK;
                    else {
                        var p = u.arrow ? f.dom.querySelector(".cm-tooltip-arrow") : null, m = p ? 7 : 0, g = v.right - v.left, y = null !== (t = KK.get(f)) && void 0 !== t ? t : v.bottom - v.top, b = f.offset || YK, w = this.view.textDirection == lW.LTR, x = v.width > i.right - i.left ? w ? i.left : i.right - v.width : w ? Math.min(h.left - (p ? 14 : 0) + b.x, i.right - g) : Math.max(i.left, h.left - g + (p ? 14 : 0) - b.x), k = this.above[l];
                        !u.strictSide && (k ? h.top - (v.bottom - v.top) - b.y < i.top : h.bottom + (v.bottom - v.top) + b.y > i.bottom) && k == i.bottom - h.bottom > h.top - i.top && (k = this.above[l] = !k);
                        var j = (k ? h.top - i.top : i.bottom - h.bottom) - m;
                        if (j < y && !1 !== f.resize) {
                            if (j < this.view.defaultLineHeight) {
                                d.style.top = HK;
                                continue;
                            }
                            KK.set(f, y), d.style.height = (y = j) / s + "px";
                        } else d.style.height && (d.style.height = "");
                        var S = k ? h.top - y - m - b.y : h.bottom + m + b.y, C = x + g;
                        if (!0 !== f.overlap) {
                            var $, _ = bo(c);
                            try {
                                for(_.s(); !($ = _.n()).done;){
                                    var O = $.value;
                                    O.left < C && O.right > x && O.top < S + y && O.bottom > S && (S = k ? O.top - y - 2 - m : O.bottom + m + 2);
                                }
                            } catch (e) {
                                _.e(e);
                            } finally{
                                _.f();
                            }
                        }
                        if ("absolute" == this.position ? (d.style.top = (S - e.parent.top) / s + "px", d.style.left = (x - e.parent.left) / a + "px") : (d.style.top = S / s + "px", d.style.left = x / a + "px"), p) {
                            var M = h.left + (w ? b.x : -b.x) - (x + 14 - 7);
                            p.style.left = M / a + "px";
                        }
                        !0 !== f.overlap && c.push({
                            left: x,
                            top: S,
                            right: C,
                            bottom: S + y
                        }), d.classList.toggle("cm-tooltip-above", k), d.classList.toggle("cm-tooltip-below", !k), f.positioned && f.positioned(e.space);
                    }
                }
            }
        },
        {
            key: "maybeMeasure",
            value: function() {
                if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) {
                    var e, t = bo(this.manager.tooltipViews);
                    try {
                        for(t.s(); !(e = t.n()).done;)e.value.dom.style.top = HK;
                    } catch (e) {
                        t.e(e);
                    } finally{
                        t.f();
                    }
                }
            }
        }
    ]), e;
}(), {
    eventObservers: {
        scroll: function() {
            this.maybeMeasure();
        }
    }
}), QK = WJ.baseTheme({
    ".cm-tooltip": {
        zIndex: 100,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: "".concat(7, "px"),
        width: "".concat(14, "px"),
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: "".concat(7, "px solid transparent"),
            borderRight: "".concat(7, "px solid transparent")
        },
        ".cm-tooltip-above &": {
            bottom: "-".concat(7, "px"),
            "&:before": {
                borderTop: "".concat(7, "px solid #bbb")
            },
            "&:after": {
                borderTop: "".concat(7, "px solid #f5f5f5"),
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: "-".concat(7, "px"),
            "&:before": {
                borderBottom: "".concat(7, "px solid #bbb")
            },
            "&:after": {
                borderBottom: "".concat(7, "px solid #f5f5f5"),
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
}), YK = {
    x: 0,
    y: 0
}, XK = NF.define({
    enables: [
        GK,
        QK
    ]
}), ZK = NF.define({
    combine: function(e) {
        return e.reduce(function(e, t) {
            return e.concat(t);
        }, []);
    }
}), eG = function() {
    function e(t) {
        var n = this;
        No(this, e), this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new WK(t, ZK, function(e, t) {
            return n.createHostedView(e, t);
        }, function(e) {
            return e.dom.remove();
        });
    }
    return Do(e, [
        {
            key: "createHostedView",
            value: function(e, t) {
                var n = e.create(this.view);
                return n.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(n.dom, t ? t.dom.nextSibling : this.dom.firstChild), this.mounted && n.mount && n.mount(this.view), n;
            }
        },
        {
            key: "mount",
            value: function(e) {
                var t, n = bo(this.manager.tooltipViews);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        r.mount && r.mount(e);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.mounted = !0;
            }
        },
        {
            key: "positioned",
            value: function(e) {
                var t, n = bo(this.manager.tooltipViews);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        r.positioned && r.positioned(e);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "update",
            value: function(e) {
                this.manager.update(e);
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t, n = bo(this.manager.tooltipViews);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        null === (e = r.destroy) || void 0 === e || e.call(r);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "passProp",
            value: function(e) {
                var t, n = void 0, r = bo(this.manager.tooltipViews);
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var o = t.value[e];
                        if (void 0 !== o) {
                            if (void 0 === n) n = o;
                            else if (n !== o) return;
                        }
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                return n;
            }
        },
        {
            key: "offset",
            get: function() {
                return this.passProp("offset");
            }
        },
        {
            key: "getCoords",
            get: function() {
                return this.passProp("getCoords");
            }
        },
        {
            key: "overlap",
            get: function() {
                return this.passProp("overlap");
            }
        },
        {
            key: "resize",
            get: function() {
                return this.passProp("resize");
            }
        }
    ], [
        {
            key: "create",
            value: function(t) {
                return new e(t);
            }
        }
    ]), e;
}(), tG = XK.compute([
    ZK
], function(e) {
    var t = e.facet(ZK);
    return 0 === t.length ? null : {
        pos: Math.min.apply(Math, Bo(t.map(function(e) {
            return e.pos;
        }))),
        end: Math.max.apply(Math, Bo(t.map(function(e) {
            var t;
            return null !== (t = e.end) && void 0 !== t ? t : e.pos;
        }))),
        create: eG.create,
        above: t[0].above,
        arrow: t.some(function(e) {
            return e.arrow;
        })
    };
}), nG = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.view = t, this.source = n, this.field = r, this.setHover = o, this.hoverTime = i, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = {
            x: 0,
            y: 0,
            target: t.dom,
            time: 0
        }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    return Do(e, [
        {
            key: "update",
            value: function() {
                var e = this;
                this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(function() {
                    return e.startHover();
                }, 20));
            }
        },
        {
            key: "active",
            get: function() {
                return this.view.state.field(this.field);
            }
        },
        {
            key: "checkHover",
            value: function() {
                if (this.hoverTimeout = -1, !this.active.length) {
                    var e = Date.now() - this.lastMove.time;
                    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
                }
            }
        },
        {
            key: "startHover",
            value: function() {
                var e = this;
                clearTimeout(this.restartTimeout);
                var t = this.view, n = this.lastMove, r = t.docView.nearest(n.target);
                if (r) {
                    var o, i = 1;
                    if (r instanceof BH) o = r.posAtStart;
                    else {
                        if (null == (o = t.posAtCoords(n))) return;
                        var a = t.coordsAtPos(o);
                        if (!a || n.y < a.top || n.y > a.bottom || n.x < a.left - t.defaultCharacterWidth || n.x > a.right + t.defaultCharacterWidth) return;
                        var s = t.bidiSpans(t.state.doc.lineAt(o)).find(function(e) {
                            return e.from <= o && e.to >= o;
                        }), c = s && s.dir == lW.RTL ? -1 : 1;
                        i = n.x < a.left ? -c : c;
                    }
                    var l = this.source(t, o, i);
                    if (null == l ? void 0 : l.then) {
                        var u = this.pending = {
                            pos: o
                        };
                        l.then(function(n) {
                            e.pending == u && (e.pending = null, !n || Array.isArray(n) && !n.length || t.dispatch({
                                effects: e.setHover.of(Array.isArray(n) ? n : [
                                    n
                                ])
                            }));
                        }, function(e) {
                            return HW(t.state, e, "hover tooltip");
                        });
                    } else !l || Array.isArray(l) && !l.length || t.dispatch({
                        effects: this.setHover.of(Array.isArray(l) ? l : [
                            l
                        ])
                    });
                }
            }
        },
        {
            key: "tooltip",
            get: function() {
                var e = this.view.plugin(GK), t = e ? e.manager.tooltips.findIndex(function(e) {
                    return e.create == eG.create;
                }) : -1;
                return t > -1 ? e.manager.tooltipViews[t] : null;
            }
        },
        {
            key: "mousemove",
            value: function(e) {
                var t, n;
                this.lastMove = {
                    x: e.clientX,
                    y: e.clientY,
                    target: e.target,
                    time: Date.now()
                }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
                var r = this.active, o = this.tooltip;
                if (r.length && o && !function(e, t) {
                    var n = e.getBoundingClientRect();
                    return t.clientX >= n.left - rG && t.clientX <= n.right + rG && t.clientY >= n.top - rG && t.clientY <= n.bottom + rG;
                }(o.dom, e) || this.pending) {
                    var i = (r[0] || this.pending).pos, a = null !== (n = null === (t = r[0]) || void 0 === t ? void 0 : t.end) && void 0 !== n ? n : i;
                    (i == a ? this.view.posAtCoords(this.lastMove) == i : function(e, t, n, r, o, i) {
                        var a = e.scrollDOM.getBoundingClientRect(), s = e.documentTop + e.documentPadding.top + e.contentHeight;
                        if (a.left > r || a.right < r || a.top > o || Math.min(a.bottom, s) < o) return !1;
                        var c = e.posAtCoords({
                            x: r,
                            y: o
                        }, !1);
                        return c >= t && c <= n;
                    }(this.view, i, a, e.clientX, e.clientY)) || (this.view.dispatch({
                        effects: this.setHover.of([])
                    }), this.pending = null);
                }
            }
        },
        {
            key: "mouseleave",
            value: function(e) {
                if (clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active.length) {
                    var t = this.tooltip;
                    t && t.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(t.dom) : this.view.dispatch({
                        effects: this.setHover.of([])
                    });
                }
            }
        },
        {
            key: "watchTooltipLeave",
            value: function(e) {
                var t = this;
                e.addEventListener("mouseleave", function n(r) {
                    e.removeEventListener("mouseleave", n), t.active.length && !t.view.dom.contains(r.relatedTarget) && t.view.dispatch({
                        effects: t.setHover.of([])
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
            }
        }
    ]), e;
}(), rG = 4;
function oG(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = uV.define(), r = LF.define({
        create: function() {
            return [];
        },
        update: function(e, r) {
            if (e.length && (t.hideOnChange && (r.docChanged || r.selection) ? e = [] : t.hideOn && (e = e.filter(function(e) {
                return !t.hideOn(r, e);
            })), r.docChanged)) {
                var o, i = bo(e);
                try {
                    for(i.s(); !(o = i.n()).done;){
                        var a = o.value, s = r.changes.mapPos(a.pos, -1, kF.TrackDel);
                        if (null != s) {
                            var c = Object.assign(Object.create(null), a);
                            c.pos = s, null != c.end && (c.end = r.changes.mapPos(c.end));
                        }
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
            }
            var l, u = bo(r.effects);
            try {
                for(u.s(); !(l = u.n()).done;){
                    var f = l.value;
                    f.is(n) && (e = f.value), f.is(aG) && (e = []);
                }
            } catch (e) {
                u.e(e);
            } finally{
                u.f();
            }
            return e;
        },
        provide: function(e) {
            return ZK.from(e);
        }
    });
    return [
        r,
        KW.define(function(o) {
            return new nG(o, e, r, n, t.hoverTime || 300);
        }),
        tG
    ];
}
function iG(e, t) {
    var n = e.plugin(GK);
    if (!n) return null;
    var r = n.manager.tooltips.indexOf(t);
    return r < 0 ? null : n.manager.tooltipViews[r];
}
var aG = uV.define(), sG = NF.define({
    combine: function(e) {
        var t, n, r, o = bo(e);
        try {
            for(o.s(); !(r = o.n()).done;){
                var i = r.value;
                t = t || i.topContainer, n = n || i.bottomContainer;
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        return {
            topContainer: t,
            bottomContainer: n
        };
    }
});
function cG(e, t) {
    var n = e.plugin(lG), r = n ? n.specs.indexOf(t) : -1;
    return r > -1 ? n.panels[r] : null;
}
var lG = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.input = t.state.facet(dG), this.specs = this.input.filter(function(e) {
            return e;
        }), this.panels = this.specs.map(function(e) {
            return e(t);
        });
        var n = t.state.facet(sG);
        this.top = new uG(t, !0, n.topContainer), this.bottom = new uG(t, !1, n.bottomContainer), this.top.sync(this.panels.filter(function(e) {
            return e.top;
        })), this.bottom.sync(this.panels.filter(function(e) {
            return !e.top;
        }));
        var r, o = bo(this.panels);
        try {
            for(o.s(); !(r = o.n()).done;){
                var i = r.value;
                i.dom.classList.add("cm-panel"), i.mount && i.mount();
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = e.state.facet(sG);
                this.top.container != t.topContainer && (this.top.sync([]), this.top = new uG(e.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new uG(e.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
                var n = e.state.facet(dG);
                if (n != this.input) {
                    var r, o = n.filter(function(e) {
                        return e;
                    }), i = [], a = [], s = [], c = [], l = bo(o);
                    try {
                        for(l.s(); !(r = l.n()).done;){
                            var u = r.value, f = this.specs.indexOf(u), d = void 0;
                            f < 0 ? (d = u(e.view), c.push(d)) : (d = this.panels[f]).update && d.update(e), i.push(d), (d.top ? a : s).push(d);
                        }
                    } catch (e) {
                        l.e(e);
                    } finally{
                        l.f();
                    }
                    this.specs = o, this.panels = i, this.top.sync(a), this.bottom.sync(s);
                    for(var h = 0, v = c; h < v.length; h++){
                        var p = v[h];
                        p.dom.classList.add("cm-panel"), p.mount && p.mount();
                    }
                } else {
                    var m, g = bo(this.panels);
                    try {
                        for(g.s(); !(m = g.n()).done;){
                            var y = m.value;
                            y.update && y.update(e);
                        }
                    } catch (e) {
                        g.e(e);
                    } finally{
                        g.f();
                    }
                }
            }
        },
        {
            key: "destroy",
            value: function() {
                this.top.sync([]), this.bottom.sync([]);
            }
        }
    ]), e;
}(), {
    provide: function(e) {
        return WJ.scrollMargins.of(function(t) {
            var n = t.plugin(e);
            return n && {
                top: n.top.scrollMargin(),
                bottom: n.bottom.scrollMargin()
            };
        });
    }
}), uG = function() {
    function e(t, n, r) {
        No(this, e), this.view = t, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
    }
    return Do(e, [
        {
            key: "sync",
            value: function(e) {
                var t, n = bo(this.panels);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        r.destroy && e.indexOf(r) < 0 && r.destroy();
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.panels = e, this.syncDOM();
            }
        },
        {
            key: "syncDOM",
            value: function() {
                if (0 != this.panels.length) {
                    if (!this.dom) {
                        this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
                        var e = this.container || this.view.dom;
                        e.insertBefore(this.dom, this.top ? e.firstChild : null);
                    }
                    var t, n = this.dom.firstChild, r = bo(this.panels);
                    try {
                        for(r.s(); !(t = r.n()).done;){
                            var o = t.value;
                            if (o.dom.parentNode == this.dom) {
                                for(; n != o.dom;)n = fG(n);
                                n = n.nextSibling;
                            } else this.dom.insertBefore(o.dom, n);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                    for(; n;)n = fG(n);
                } else this.dom && (this.dom.remove(), this.dom = void 0);
            }
        },
        {
            key: "scrollMargin",
            value: function() {
                return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
            }
        },
        {
            key: "syncClasses",
            value: function() {
                if (this.container && this.classes != this.view.themeClasses) {
                    var e, t = bo(this.classes.split(" "));
                    try {
                        for(t.s(); !(e = t.n()).done;){
                            var n = e.value;
                            n && this.container.classList.remove(n);
                        }
                    } catch (e) {
                        t.e(e);
                    } finally{
                        t.f();
                    }
                    var r, o = bo((this.classes = this.view.themeClasses).split(" "));
                    try {
                        for(o.s(); !(r = o.n()).done;){
                            var i = r.value;
                            i && this.container.classList.add(i);
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                }
            }
        }
    ]), e;
}();
function fG(e) {
    var t = e.nextSibling;
    return e.remove(), t;
}
var dG = NF.define({
    enables: lG
}), hG = function(e) {
    function t() {
        return No(this, t), _o(this, t, arguments);
    }
    return Ao(t, SV), Do(t, [
        {
            key: "compare",
            value: function(e) {
                return this == e || this.constructor == e.constructor && this.eq(e);
            }
        },
        {
            key: "eq",
            value: function(e) {
                return !1;
            }
        },
        {
            key: "destroy",
            value: function(e) {}
        }
    ]), t;
}();
hG.prototype.elementClass = "", hG.prototype.toDOM = void 0, hG.prototype.mapMode = kF.TrackBefore, hG.prototype.startSide = hG.prototype.endSide = -1, hG.prototype.point = !0;
var vG = NF.define(), pG = {
    class: "",
    renderEmptyElements: !1,
    elementStyle: "",
    markers: function() {
        return OV.empty;
    },
    lineMarker: function() {
        return null;
    },
    widgetMarker: function() {
        return null;
    },
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
}, mG = NF.define();
function gG(e) {
    return [
        bG(),
        mG.of(Object.assign(Object.assign({}, pG), e))
    ];
}
var yG = NF.define({
    combine: function(e) {
        return e.some(function(e) {
            return e;
        });
    }
});
function bG(e) {
    var t = [
        wG
    ];
    return e && !1 === e.fixed && t.push(yG.of(!0)), t;
}
var wG = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(mG).map(function(e) {
            return new SG(t, e);
        });
        var n, r = bo(this.gutters);
        try {
            for(r.s(); !(n = r.n()).done;){
                var o = n.value;
                this.dom.appendChild(o.dom);
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        this.fixed = !t.state.facet(yG), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                if (this.updateGutters(e)) {
                    var t = this.prevViewport, n = e.view.viewport, r = Math.min(t.to, n.to) - Math.max(t.from, n.from);
                    this.syncGutters(r < .8 * (n.to - n.from));
                }
                e.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(yG) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = e.view.viewport;
            }
        },
        {
            key: "syncGutters",
            value: function(e) {
                var t = this, n = this.dom.nextSibling;
                e && this.dom.remove();
                var r, o = OV.iter(this.view.state.facet(vG), this.view.viewport.from), i = [], a = this.gutters.map(function(e) {
                    return new jG(e, t.view.viewport, -t.view.documentPadding.top);
                }), s = bo(this.view.viewportLineBlocks);
                try {
                    for(s.s(); !(r = s.n()).done;){
                        var c = r.value;
                        if (i.length && (i = []), Array.isArray(c.type)) {
                            var l, u = !0, f = bo(c.type);
                            try {
                                for(f.s(); !(l = f.n()).done;){
                                    var d = l.value;
                                    if (d.type == ZH.Text && u) {
                                        kG(o, i, d.from);
                                        var h, v = bo(a);
                                        try {
                                            for(v.s(); !(h = v.n()).done;)h.value.line(this.view, d, i);
                                        } catch (e) {
                                            v.e(e);
                                        } finally{
                                            v.f();
                                        }
                                        u = !1;
                                    } else if (d.widget) {
                                        var p, m = bo(a);
                                        try {
                                            for(m.s(); !(p = m.n()).done;)p.value.widget(this.view, d);
                                        } catch (e) {
                                            m.e(e);
                                        } finally{
                                            m.f();
                                        }
                                    }
                                }
                            } catch (e) {
                                f.e(e);
                            } finally{
                                f.f();
                            }
                        } else if (c.type == ZH.Text) {
                            kG(o, i, c.from);
                            var g, y = bo(a);
                            try {
                                for(y.s(); !(g = y.n()).done;)g.value.line(this.view, c, i);
                            } catch (e) {
                                y.e(e);
                            } finally{
                                y.f();
                            }
                        } else if (c.widget) {
                            var b, w = bo(a);
                            try {
                                for(w.s(); !(b = w.n()).done;)b.value.widget(this.view, c);
                            } catch (e) {
                                w.e(e);
                            } finally{
                                w.f();
                            }
                        }
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                var x, k = bo(a);
                try {
                    for(k.s(); !(x = k.n()).done;)x.value.finish();
                } catch (e) {
                    k.e(e);
                } finally{
                    k.f();
                }
                e && this.view.scrollDOM.insertBefore(this.dom, n);
            }
        },
        {
            key: "updateGutters",
            value: function(e) {
                var t = e.startState.facet(mG), n = e.state.facet(mG), r = e.docChanged || e.heightChanged || e.viewportChanged || !OV.eq(e.startState.facet(vG), e.state.facet(vG), e.view.viewport.from, e.view.viewport.to);
                if (t == n) {
                    var o, i = bo(this.gutters);
                    try {
                        for(i.s(); !(o = i.n()).done;)o.value.update(e) && (r = !0);
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                } else {
                    r = !0;
                    var a, s = [], c = bo(n);
                    try {
                        for(c.s(); !(a = c.n()).done;){
                            var l = a.value, u = t.indexOf(l);
                            u < 0 ? s.push(new SG(this.view, l)) : (this.gutters[u].update(e), s.push(this.gutters[u]));
                        }
                    } catch (e) {
                        c.e(e);
                    } finally{
                        c.f();
                    }
                    var f, d = bo(this.gutters);
                    try {
                        for(d.s(); !(f = d.n()).done;){
                            var h = f.value;
                            h.dom.remove(), s.indexOf(h) < 0 && h.destroy();
                        }
                    } catch (e) {
                        d.e(e);
                    } finally{
                        d.f();
                    }
                    for(var v = 0, p = s; v < p.length; v++){
                        var m = p[v];
                        this.dom.appendChild(m.dom);
                    }
                    this.gutters = s;
                }
                return r;
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t = bo(this.gutters);
                try {
                    for(t.s(); !(e = t.n()).done;)e.value.destroy();
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
                this.dom.remove();
            }
        }
    ]), e;
}(), {
    provide: function(e) {
        return WJ.scrollMargins.of(function(t) {
            var n = t.plugin(e);
            return n && 0 != n.gutters.length && n.fixed ? t.textDirection == lW.LTR ? {
                left: n.dom.offsetWidth * t.scaleX
            } : {
                right: n.dom.offsetWidth * t.scaleX
            } : null;
        });
    }
});
function xG(e) {
    return Array.isArray(e) ? e : [
        e
    ];
}
function kG(e, t, n) {
    for(; e.value && e.from <= n;)e.from == n && t.push(e.value), e.next();
}
var jG = function() {
    function e(t, n, r) {
        No(this, e), this.gutter = t, this.height = r, this.i = 0, this.cursor = OV.iter(t.markers, n.from);
    }
    return Do(e, [
        {
            key: "addElement",
            value: function(e, t, n) {
                var r = this.gutter, o = (t.top - this.height) / e.scaleY, i = t.height / e.scaleY;
                if (this.i == r.elements.length) {
                    var a = new CG(e, i, o, n);
                    r.elements.push(a), r.dom.appendChild(a.dom);
                } else r.elements[this.i].update(e, i, o, n);
                this.height = t.bottom, this.i++;
            }
        },
        {
            key: "line",
            value: function(e, t, n) {
                var r = [];
                kG(this.cursor, r, t.from), n.length && (r = r.concat(n));
                var o = this.gutter.config.lineMarker(e, t, r);
                o && r.unshift(o);
                var i = this.gutter;
                (0 != r.length || i.config.renderEmptyElements) && this.addElement(e, t, r);
            }
        },
        {
            key: "widget",
            value: function(e, t) {
                var n = this.gutter.config.widgetMarker(e, t.widget, t);
                n && this.addElement(e, t, [
                    n
                ]);
            }
        },
        {
            key: "finish",
            value: function() {
                for(var e = this.gutter; e.elements.length > this.i;){
                    var t = e.elements.pop();
                    e.dom.removeChild(t.dom), t.destroy();
                }
            }
        }
    ]), e;
}(), SG = function() {
    function e(t, n) {
        var r = this;
        No(this, e), this.view = t, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        var o = function(e) {
            r.dom.addEventListener(e, function(o) {
                var i, a = o.target;
                if (a != r.dom && r.dom.contains(a)) {
                    for(; a.parentNode != r.dom;)a = a.parentNode;
                    var s = a.getBoundingClientRect();
                    i = (s.top + s.bottom) / 2;
                } else i = o.clientY;
                var c = t.lineBlockAtHeight(i - t.documentTop);
                n.domEventHandlers[e](t, c, o) && o.preventDefault();
            });
        };
        for(var i in n.domEventHandlers)o(i);
        this.markers = xG(n.markers(t)), n.initialSpacer && (this.spacer = new CG(t, 0, 0, [
            n.initialSpacer(t)
        ]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = this.markers;
                if (this.markers = xG(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
                    var n = this.config.updateSpacer(this.spacer.markers[0], e);
                    n != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [
                        n
                    ]);
                }
                var r = e.view.viewport;
                return !OV.eq(this.markers, t, r.from, r.to) || !!this.config.lineMarkerChange && this.config.lineMarkerChange(e);
            }
        },
        {
            key: "destroy",
            value: function() {
                var e, t = bo(this.elements);
                try {
                    for(t.s(); !(e = t.n()).done;)e.value.destroy();
                } catch (e) {
                    t.e(e);
                } finally{
                    t.f();
                }
            }
        }
    ]), e;
}(), CG = function() {
    function e(t, n, r, o) {
        No(this, e), this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, n, r, o);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e, t, n, r) {
                this.height != t && (this.height = t, this.dom.style.height = t + "px"), this.above != n && (this.dom.style.marginTop = (this.above = n) ? n + "px" : ""), function(e, t) {
                    if (e.length != t.length) return !1;
                    for(var n = 0; n < e.length; n++)if (!e[n].compare(t[n])) return !1;
                    return !0;
                }(this.markers, r) || this.setMarkers(e, r);
            }
        },
        {
            key: "setMarkers",
            value: function(e, t) {
                for(var n = "cm-gutterElement", r = this.dom.firstChild, o = 0, i = 0;;){
                    var a = i, s = o < t.length ? t[o++] : null, c = !1;
                    if (s) {
                        var l = s.elementClass;
                        l && (n += " " + l);
                        for(var u = i; u < this.markers.length; u++)if (this.markers[u].compare(s)) {
                            a = u, c = !0;
                            break;
                        }
                    } else a = this.markers.length;
                    for(; i < a;){
                        var f = this.markers[i++];
                        if (f.toDOM) {
                            f.destroy(r);
                            var d = r.nextSibling;
                            r.remove(), r = d;
                        }
                    }
                    if (!s) break;
                    s.toDOM && (c ? r = r.nextSibling : this.dom.insertBefore(s.toDOM(e), r)), c && i++;
                }
                this.dom.className = n, this.markers = t;
            }
        },
        {
            key: "destroy",
            value: function() {
                this.setMarkers(null, []);
            }
        }
    ]), e;
}();
var $G = NF.define(), _G = NF.define({
    combine: function(e) {
        return jV(e, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers: function(e, t) {
                var n = Object.assign({}, e), r = function() {
                    var e = n[o], r = t[o];
                    n[o] = e ? function(t, n, o) {
                        return e(t, n, o) || r(t, n, o);
                    } : r;
                };
                for(var o in t)r();
                return n;
            }
        });
    }
}), OG = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).number = e, n;
    }
    return Ao(t, hG), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return this.number == e.number;
            }
        },
        {
            key: "toDOM",
            value: function() {
                return document.createTextNode(this.number);
            }
        }
    ]), t;
}();
function MG(e, t) {
    return e.state.facet(_G).formatNumber(t, e.state);
}
var EG = mG.compute([
    _G
], function(e) {
    return {
        class: "cm-lineNumbers",
        renderEmptyElements: !1,
        markers: function(e) {
            return e.state.facet($G);
        },
        lineMarker: function(e, t, n) {
            return n.some(function(e) {
                return e.toDOM;
            }) ? null : new OG(MG(e, e.state.doc.lineAt(t.from).number));
        },
        widgetMarker: function() {
            return null;
        },
        lineMarkerChange: function(e) {
            return e.startState.facet(_G) != e.state.facet(_G);
        },
        initialSpacer: function(e) {
            return new OG(MG(e, PG(e.state.doc.lines)));
        },
        updateSpacer: function(e, t) {
            var n = MG(t.view, PG(t.view.state.doc.lines));
            return n == e.number ? e : new OG(n);
        },
        domEventHandlers: e.facet(_G).domEventHandlers
    };
});
function AG() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        _G.of(e),
        bG(),
        EG
    ];
}
function PG(e) {
    for(var t = 9; t < e;)t = 10 * t + 9;
    return t;
}
var TG = new (function(e) {
    function t() {
        var e;
        return No(this, t), (e = _o(this, t, arguments)).elementClass = "cm-activeLineGutter", e;
    }
    return Ao(t, hG), Do(t);
}()), RG = vG.compute([
    "selection"
], function(e) {
    var t, n = [], r = -1, o = bo(e.selection.ranges);
    try {
        for(o.s(); !(t = o.n()).done;){
            var i = t.value, a = e.doc.lineAt(i.head).from;
            a > r && (r = a, n.push(TG.range(a)));
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return OV.of(n);
});
var NG = 0, IG = Do(function e(t, n) {
    No(this, e), this.from = t, this.to = n;
}), DG = function() {
    function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        No(this, e), this.id = NG++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function() {
            throw new Error("This node type doesn't define a deserialize function");
        };
    }
    return Do(e, [
        {
            key: "add",
            value: function(e) {
                var t = this;
                if (this.perNode) throw new RangeError("Can't add per-node props to node types");
                return "function" != typeof e && (e = BG.match(e)), function(n) {
                    var r = e(n);
                    return void 0 === r ? null : [
                        t,
                        r
                    ];
                };
            }
        }
    ]), e;
}();
DG.closedBy = new DG({
    deserialize: function(e) {
        return e.split(" ");
    }
}), DG.openedBy = new DG({
    deserialize: function(e) {
        return e.split(" ");
    }
}), DG.group = new DG({
    deserialize: function(e) {
        return e.split(" ");
    }
}), DG.contextHash = new DG({
    perNode: !0
}), DG.lookAhead = new DG({
    perNode: !0
}), DG.mounted = new DG({
    perNode: !0
});
var zG = function() {
    function e(t, n, r) {
        No(this, e), this.tree = t, this.overlay = n, this.parser = r;
    }
    return Do(e, null, [
        {
            key: "get",
            value: function(e) {
                return e && e.props && e.props[DG.mounted.id];
            }
        }
    ]), e;
}(), qG = Object.create(null), BG = function() {
    function e(t, n, r) {
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
        No(this, e), this.name = t, this.props = n, this.id = r, this.flags = o;
    }
    return Do(e, [
        {
            key: "prop",
            value: function(e) {
                return this.props[e.id];
            }
        },
        {
            key: "isTop",
            get: function() {
                return (1 & this.flags) > 0;
            }
        },
        {
            key: "isSkipped",
            get: function() {
                return (2 & this.flags) > 0;
            }
        },
        {
            key: "isError",
            get: function() {
                return (4 & this.flags) > 0;
            }
        },
        {
            key: "isAnonymous",
            get: function() {
                return (8 & this.flags) > 0;
            }
        },
        {
            key: "is",
            value: function(e) {
                if ("string" == typeof e) {
                    if (this.name == e) return !0;
                    var t = this.prop(DG.group);
                    return !!t && t.indexOf(e) > -1;
                }
                return this.id == e;
            }
        }
    ], [
        {
            key: "define",
            value: function(t) {
                var n = t.props && t.props.length ? Object.create(null) : qG, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (null == t.name ? 8 : 0), o = new e(t.name || "", n, t.id, r);
                if (t.props) {
                    var i, a = bo(t.props);
                    try {
                        for(a.s(); !(i = a.n()).done;){
                            var s = i.value;
                            if (Array.isArray(s) || (s = s(o)), s) {
                                if (s[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                                n[s[0].id] = s[1];
                            }
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
                return o;
            }
        },
        {
            key: "match",
            value: function(e) {
                var t = Object.create(null);
                for(var n in e){
                    var r, o = bo(n.split(" "));
                    try {
                        for(o.s(); !(r = o.n()).done;){
                            var i = r.value;
                            t[i] = e[n];
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                }
                return function(e) {
                    for(var n = e.prop(DG.group), r = -1; r < (n ? n.length : 0); r++){
                        var o = t[r < 0 ? e.name : n[r]];
                        if (o) return o;
                    }
                };
            }
        }
    ]), e;
}();
BG.none = new BG("", Object.create(null), 0, 8);
var LG, FG = function() {
    function e(t) {
        No(this, e), this.types = t;
        for(var n = 0; n < t.length; n++)if (t[n].id != n) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    return Do(e, [
        {
            key: "extend",
            value: function() {
                for(var t = [], n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                var i, a = bo(this.types);
                try {
                    for(a.s(); !(i = a.n()).done;){
                        var s, c = i.value, l = null, u = bo(r);
                        try {
                            for(u.s(); !(s = u.n()).done;){
                                var f = (0, s.value)(c);
                                f && (l || (l = Object.assign({}, c.props)), l[f[0].id] = f[1]);
                            }
                        } catch (e) {
                            u.e(e);
                        } finally{
                            u.f();
                        }
                        t.push(l ? new BG(c.name, l, c.id, c.flags) : c);
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return new e(t);
            }
        }
    ]), e;
}(), VG = new WeakMap, HG = new WeakMap;
!function(e) {
    e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
}(LG || (LG = {}));
var WG = function() {
    function e(t, n, r, o, i) {
        if (No(this, e), this.type = t, this.children = n, this.positions = r, this.length = o, this.props = null, i && i.length) {
            this.props = Object.create(null);
            var a, s = bo(i);
            try {
                for(s.s(); !(a = s.n()).done;){
                    var c = jo(a.value, 2), l = c[0], u = c[1];
                    this.props["number" == typeof l ? l : l.id] = u;
                }
            } catch (e) {
                s.e(e);
            } finally{
                s.f();
            }
        }
    }
    return Do(e, [
        {
            key: "toString",
            value: function() {
                var e = zG.get(this);
                if (e && !e.overlay) return e.tree.toString();
                var t, n = "", r = bo(this.children);
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var o = t.value.toString();
                        o && (n && (n += ","), n += o);
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
            }
        },
        {
            key: "cursor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new oQ(this.topNode, e);
            }
        },
        {
            key: "cursorAt",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = VG.get(this) || this.topNode, r = new oQ(n);
                return r.moveTo(e, t), VG.set(this, r._tree), r;
            }
        },
        {
            key: "topNode",
            get: function() {
                return new YG(this, 0, 0, null);
            }
        },
        {
            key: "resolve",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = GG(VG.get(this) || this.topNode, e, t, !1);
                return VG.set(this, n), n;
            }
        },
        {
            key: "resolveInner",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = GG(HG.get(this) || this.topNode, e, t, !0);
                return HG.set(this, n), n;
            }
        },
        {
            key: "resolveStack",
            value: function(e) {
                return function(e, t, n) {
                    for(var r = e.resolveInner(t, n), o = null, i = r instanceof YG ? r : r.context.parent; i; i = i.parent)if (i.index < 0) {
                        var a = i.parent;
                        (o || (o = [
                            r
                        ])).push(a.resolve(t, n)), i = a;
                    } else {
                        var s = zG.get(i.tree);
                        if (s && s.overlay && s.overlay[0].from <= t && s.overlay[s.overlay.length - 1].to >= t) {
                            var c = new YG(s.tree, s.overlay[0].from + i.from, -1, i);
                            (o || (o = [
                                r
                            ])).push(GG(c, t, n, !1));
                        }
                    }
                    return o ? nQ(o) : r;
                }(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0);
            }
        },
        {
            key: "iterate",
            value: function(e) {
                for(var t = e.enter, n = e.leave, r = e.from, o = void 0 === r ? 0 : r, i = e.to, a = void 0 === i ? this.length : i, s = e.mode || 0, c = (s & LG.IncludeAnonymous) > 0, l = this.cursor(s | LG.IncludeAnonymous);;){
                    var u = !1;
                    if (l.from <= a && l.to >= o && (!c && l.type.isAnonymous || !1 !== t(l))) {
                        if (l.firstChild()) continue;
                        u = !0;
                    }
                    for(; u && n && (c || !l.type.isAnonymous) && n(l), !l.nextSibling();){
                        if (!l.parent()) return;
                        u = !0;
                    }
                }
            }
        },
        {
            key: "prop",
            value: function(e) {
                return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
            }
        },
        {
            key: "propValues",
            get: function() {
                var e = [];
                if (this.props) for(var t in this.props)e.push([
                    +t,
                    this.props[t]
                ]);
                return e;
            }
        },
        {
            key: "balance",
            value: function() {
                var t = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return this.children.length <= 8 ? this : lQ(BG.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(n, r, o) {
                    return new e(t.type, n, r, o, t.propValues);
                }, n.makeTree || function(t, n, r) {
                    return new e(BG.none, t, n, r);
                });
            }
        }
    ], [
        {
            key: "build",
            value: function(e) {
                return aQ(e);
            }
        }
    ]), e;
}();
WG.empty = new WG(BG.none, [], [], 0);
var UG = function() {
    function e(t, n) {
        No(this, e), this.buffer = t, this.index = n;
    }
    return Do(e, [
        {
            key: "id",
            get: function() {
                return this.buffer[this.index - 4];
            }
        },
        {
            key: "start",
            get: function() {
                return this.buffer[this.index - 3];
            }
        },
        {
            key: "end",
            get: function() {
                return this.buffer[this.index - 2];
            }
        },
        {
            key: "size",
            get: function() {
                return this.buffer[this.index - 1];
            }
        },
        {
            key: "pos",
            get: function() {
                return this.index;
            }
        },
        {
            key: "next",
            value: function() {
                this.index -= 4;
            }
        },
        {
            key: "fork",
            value: function() {
                return new e(this.buffer, this.index);
            }
        }
    ]), e;
}(), JG = function() {
    function e(t, n, r) {
        No(this, e), this.buffer = t, this.length = n, this.set = r;
    }
    return Do(e, [
        {
            key: "type",
            get: function() {
                return BG.none;
            }
        },
        {
            key: "toString",
            value: function() {
                for(var e = [], t = 0; t < this.buffer.length;)e.push(this.childString(t)), t = this.buffer[t + 3];
                return e.join(",");
            }
        },
        {
            key: "childString",
            value: function(e) {
                var t = this.buffer[e], n = this.buffer[e + 3], r = this.set.types[t], o = r.name;
                if (/\W/.test(o) && !r.isError && (o = JSON.stringify(o)), n == (e += 4)) return o;
                for(var i = []; e < n;)i.push(this.childString(e)), e = this.buffer[e + 3];
                return o + "(" + i.join(",") + ")";
            }
        },
        {
            key: "findChild",
            value: function(e, t, n, r, o) {
                for(var i = this.buffer, a = -1, s = e; s != t && !(KG(o, r, i[s + 1], i[s + 2]) && (a = s, n > 0)); s = i[s + 3]);
                return a;
            }
        },
        {
            key: "slice",
            value: function(t, n, r) {
                for(var o = this.buffer, i = new Uint16Array(n - t), a = 0, s = t, c = 0; s < n;){
                    i[c++] = o[s++], i[c++] = o[s++] - r;
                    var l = i[c++] = o[s++] - r;
                    i[c++] = o[s++] - t, a = Math.max(a, l);
                }
                return new e(i, a, this.set);
            }
        }
    ]), e;
}();
function KG(e, t, n, r) {
    switch(e){
        case -2:
            return n < t;
        case -1:
            return r >= t && n < t;
        case 0:
            return n < t && r > t;
        case 1:
            return n <= t && r > t;
        case 2:
            return r > t;
        case 4:
            return !0;
    }
}
function GG(e, t, n, r) {
    for(var o; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);){
        var i = !r && e instanceof YG && e.index < 0 ? null : e.parent;
        if (!i) return e;
        e = i;
    }
    var a = r ? 0 : LG.IgnoreOverlays;
    if (r) for(var s = e, c = s.parent; c; c = (s = c).parent)s instanceof YG && s.index < 0 && (null === (o = c.enter(t, n, a)) || void 0 === o ? void 0 : o.from) != s.from && (e = c);
    for(;;){
        var l = e.enter(t, n, a);
        if (!l) return e;
        e = l;
    }
}
var QG = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "cursor",
            value: function() {
                return new oQ(this, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0);
            }
        },
        {
            key: "getChild",
            value: function(e) {
                var t = XG(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null);
                return t.length ? t[0] : null;
            }
        },
        {
            key: "getChildren",
            value: function(e) {
                return XG(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null);
            }
        },
        {
            key: "resolve",
            value: function(e) {
                return GG(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, !1);
            }
        },
        {
            key: "resolveInner",
            value: function(e) {
                return GG(this, e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, !0);
            }
        },
        {
            key: "matchContext",
            value: function(e) {
                return ZG(this, e);
            }
        },
        {
            key: "enterUnfinishedNodesBefore",
            value: function(e) {
                for(var t = this.childBefore(e), n = this; t;){
                    var r = t.lastChild;
                    if (!r || r.to != t.to) break;
                    r.type.isError && r.from == r.to ? (n = t, t = r.prevSibling) : t = r;
                }
                return n;
            }
        },
        {
            key: "node",
            get: function() {
                return this;
            }
        },
        {
            key: "next",
            get: function() {
                return this.parent;
            }
        }
    ]), e;
}(), YG = function(e) {
    function t(e, n, r, o) {
        var i;
        return No(this, t), (i = _o(this, t))._tree = e, i.from = n, i.index = r, i._parent = o, i;
    }
    return Ao(t, QG), Do(t, [
        {
            key: "type",
            get: function() {
                return this._tree.type;
            }
        },
        {
            key: "name",
            get: function() {
                return this._tree.type.name;
            }
        },
        {
            key: "to",
            get: function() {
                return this.from + this._tree.length;
            }
        },
        {
            key: "nextChild",
            value: function(e, n, r, o) {
                for(var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = this;;){
                    for(var s = a._tree, c = s.children, l = s.positions, u = n > 0 ? c.length : -1; e != u; e += n){
                        var f = c[e], d = l[e] + a.from;
                        if (KG(o, r, d, d + f.length)) {
                            if (f instanceof JG) {
                                if (i & LG.ExcludeBuffers) continue;
                                var h = f.findChild(0, f.buffer.length, n, r - d, o);
                                if (h > -1) return new tQ(new eQ(a, f, e, d), null, h);
                            } else if (i & LG.IncludeAnonymous || !f.type.isAnonymous || iQ(f)) {
                                var v = void 0;
                                if (!(i & LG.IgnoreMounts) && (v = zG.get(f)) && !v.overlay) return new t(v.tree, d, e, a);
                                var p = new t(f, d, e, a);
                                return i & LG.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, o);
                            }
                        }
                    }
                    if (i & LG.IncludeAnonymous || !a.type.isAnonymous) return null;
                    if (e = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)) return null;
                }
            }
        },
        {
            key: "firstChild",
            get: function() {
                return this.nextChild(0, 1, 0, 4);
            }
        },
        {
            key: "lastChild",
            get: function() {
                return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
            }
        },
        {
            key: "childAfter",
            value: function(e) {
                return this.nextChild(0, 1, e, 2);
            }
        },
        {
            key: "childBefore",
            value: function(e) {
                return this.nextChild(this._tree.children.length - 1, -1, e, -2);
            }
        },
        {
            key: "enter",
            value: function(e, n) {
                var r, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                if (!(o & LG.IgnoreOverlays) && (r = zG.get(this._tree)) && r.overlay) {
                    var i, a = e - this.from, s = bo(r.overlay);
                    try {
                        for(s.s(); !(i = s.n()).done;){
                            var c = i.value, l = c.from, u = c.to;
                            if ((n > 0 ? l <= a : l < a) && (n < 0 ? u >= a : u > a)) return new t(r.tree, r.overlay[0].from + this.from, -1, this);
                        }
                    } catch (e) {
                        s.e(e);
                    } finally{
                        s.f();
                    }
                }
                return this.nextChild(0, 1, e, n, o);
            }
        },
        {
            key: "nextSignificantParent",
            value: function() {
                for(var e = this; e.type.isAnonymous && e._parent;)e = e._parent;
                return e;
            }
        },
        {
            key: "parent",
            get: function() {
                return this._parent ? this._parent.nextSignificantParent() : null;
            }
        },
        {
            key: "nextSibling",
            get: function() {
                return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
            }
        },
        {
            key: "prevSibling",
            get: function() {
                return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
            }
        },
        {
            key: "tree",
            get: function() {
                return this._tree;
            }
        },
        {
            key: "toTree",
            value: function() {
                return this._tree;
            }
        },
        {
            key: "toString",
            value: function() {
                return this._tree.toString();
            }
        }
    ]), t;
}();
function XG(e, t, n, r) {
    var o = e.cursor(), i = [];
    if (!o.firstChild()) return i;
    if (null != n) {
        for(; !o.type.is(n);)if (!o.nextSibling()) return i;
    }
    for(;;){
        if (null != r && o.type.is(r)) return i;
        if (o.type.is(t) && i.push(o.node), !o.nextSibling()) return null == r ? i : [];
    }
}
function ZG(e, t) {
    for(var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent){
        if (!r) return !1;
        if (!r.type.isAnonymous) {
            if (t[n] && t[n] != r.name) return !1;
            n--;
        }
    }
    return !0;
}
var eQ = Do(function e(t, n, r, o) {
    No(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = o;
}), tQ = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t)).context = e, o._parent = n, o.index = r, o.type = e.buffer.set.types[e.buffer.buffer[r]], o;
    }
    return Ao(t, QG), Do(t, [
        {
            key: "name",
            get: function() {
                return this.type.name;
            }
        },
        {
            key: "from",
            get: function() {
                return this.context.start + this.context.buffer.buffer[this.index + 1];
            }
        },
        {
            key: "to",
            get: function() {
                return this.context.start + this.context.buffer.buffer[this.index + 2];
            }
        },
        {
            key: "child",
            value: function(e, n, r) {
                var o = this.context.buffer, i = o.findChild(this.index + 4, o.buffer[this.index + 3], e, n - this.context.start, r);
                return i < 0 ? null : new t(this.context, this, i);
            }
        },
        {
            key: "firstChild",
            get: function() {
                return this.child(1, 0, 4);
            }
        },
        {
            key: "lastChild",
            get: function() {
                return this.child(-1, 0, 4);
            }
        },
        {
            key: "childAfter",
            value: function(e) {
                return this.child(1, e, 2);
            }
        },
        {
            key: "childBefore",
            value: function(e) {
                return this.child(-1, e, -2);
            }
        },
        {
            key: "enter",
            value: function(e, n) {
                if ((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0) & LG.ExcludeBuffers) return null;
                var r = this.context.buffer, o = r.findChild(this.index + 4, r.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
                return o < 0 ? null : new t(this.context, this, o);
            }
        },
        {
            key: "parent",
            get: function() {
                return this._parent || this.context.parent.nextSignificantParent();
            }
        },
        {
            key: "externalSibling",
            value: function(e) {
                return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
            }
        },
        {
            key: "nextSibling",
            get: function() {
                var e = this.context.buffer, n = e.buffer[this.index + 3];
                return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new t(this.context, this._parent, n) : this.externalSibling(1);
            }
        },
        {
            key: "prevSibling",
            get: function() {
                var e = this.context.buffer, n = this._parent ? this._parent.index + 4 : 0;
                return this.index == n ? this.externalSibling(-1) : new t(this.context, this._parent, e.findChild(n, this.index, -1, 0, 4));
            }
        },
        {
            key: "tree",
            get: function() {
                return null;
            }
        },
        {
            key: "toTree",
            value: function() {
                var e = [], t = [], n = this.context.buffer, r = this.index + 4, o = n.buffer[this.index + 3];
                if (o > r) {
                    var i = n.buffer[this.index + 1];
                    e.push(n.slice(r, o, i)), t.push(0);
                }
                return new WG(this.type, e, t, this.to - this.from);
            }
        },
        {
            key: "toString",
            value: function() {
                return this.context.buffer.childString(this.index);
            }
        }
    ]), t;
}();
function nQ(e) {
    if (!e.length) return null;
    for(var t = 0, n = e[0], r = 1; r < e.length; r++){
        var o = e[r];
        (o.from > n.from || o.to < n.to) && (n = o, t = r);
    }
    var i = n instanceof YG && n.index < 0 ? null : n.parent, a = e.slice();
    return i ? a[t] = i : a.splice(t, 1), new rQ(a, n);
}
var rQ = function() {
    function e(t, n) {
        No(this, e), this.heads = t, this.node = n;
    }
    return Do(e, [
        {
            key: "next",
            get: function() {
                return nQ(this.heads);
            }
        }
    ]), e;
}();
var oQ = function() {
    function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (No(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof YG) this.yieldNode(t);
        else {
            this._tree = t.context.parent, this.buffer = t.context;
            for(var r = t._parent; r; r = r._parent)this.stack.unshift(r.index);
            this.bufferNode = t, this.yieldBuf(t.index);
        }
    }
    return Do(e, [
        {
            key: "name",
            get: function() {
                return this.type.name;
            }
        },
        {
            key: "yieldNode",
            value: function(e) {
                return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
            }
        },
        {
            key: "yieldBuf",
            value: function(e, t) {
                this.index = e;
                var n = this.buffer, r = n.start, o = n.buffer;
                return this.type = t || o.set.types[o.buffer[e]], this.from = r + o.buffer[e + 1], this.to = r + o.buffer[e + 2], !0;
            }
        },
        {
            key: "yield",
            value: function(e) {
                return !!e && (e instanceof YG ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
            }
        },
        {
            key: "toString",
            value: function() {
                return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
            }
        },
        {
            key: "enterChild",
            value: function(e, t, n) {
                if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
                var r = this.buffer.buffer, o = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
                return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
            }
        },
        {
            key: "firstChild",
            value: function() {
                return this.enterChild(1, 0, 4);
            }
        },
        {
            key: "lastChild",
            value: function() {
                return this.enterChild(-1, 0, 4);
            }
        },
        {
            key: "childAfter",
            value: function(e) {
                return this.enterChild(1, e, 2);
            }
        },
        {
            key: "childBefore",
            value: function(e) {
                return this.enterChild(-1, e, -2);
            }
        },
        {
            key: "enter",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.mode;
                return this.buffer ? !(n & LG.ExcludeBuffers) && this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
            }
        },
        {
            key: "parent",
            value: function() {
                if (!this.buffer) return this.yieldNode(this.mode & LG.IncludeAnonymous ? this._tree._parent : this._tree.parent);
                if (this.stack.length) return this.yieldBuf(this.stack.pop());
                var e = this.mode & LG.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
                return this.buffer = null, this.yieldNode(e);
            }
        },
        {
            key: "sibling",
            value: function(e) {
                if (!this.buffer) return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
                var t = this.buffer.buffer, n = this.stack.length - 1;
                if (e < 0) {
                    var r = n < 0 ? 0 : this.stack[n] + 4;
                    if (this.index != r) return this.yieldBuf(t.findChild(r, this.index, -1, 0, 4));
                } else {
                    var o = t.buffer[this.index + 3];
                    if (o < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(o);
                }
                return n < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
            }
        },
        {
            key: "nextSibling",
            value: function() {
                return this.sibling(1);
            }
        },
        {
            key: "prevSibling",
            value: function() {
                return this.sibling(-1);
            }
        },
        {
            key: "atLastNode",
            value: function(e) {
                var t, n, r = this.buffer;
                if (r) {
                    if (e > 0) {
                        if (this.index < r.buffer.buffer.length) return !1;
                    } else for(var o = 0; o < this.index; o++)if (r.buffer.buffer[o + 3] < this.index) return !1;
                    t = r.index, n = r.parent;
                } else {
                    var i = this._tree;
                    t = i.index, n = i._parent;
                }
                for(; n; t = (a = n).index, n = a._parent, a){
                    var a;
                    if (t > -1) for(var s = t + e, c = e < 0 ? -1 : n._tree.children.length; s != c; s += e){
                        var l = n._tree.children[s];
                        if (this.mode & LG.IncludeAnonymous || l instanceof JG || !l.type.isAnonymous || iQ(l)) return !1;
                    }
                }
                return !0;
            }
        },
        {
            key: "move",
            value: function(e, t) {
                if (t && this.enterChild(e, 0, 4)) return !0;
                for(;;){
                    if (this.sibling(e)) return !0;
                    if (this.atLastNode(e) || !this.parent()) return !1;
                }
            }
        },
        {
            key: "next",
            value: function() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return this.move(1, e);
            }
        },
        {
            key: "prev",
            value: function() {
                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return this.move(-1, e);
            }
        },
        {
            key: "moveTo",
            value: function(e) {
                for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent(););
                for(; this.enterChild(1, e, t););
                return this;
            }
        },
        {
            key: "node",
            get: function() {
                if (!this.buffer) return this._tree;
                var e = this.bufferNode, t = null, n = 0;
                if (e && e.context == this.buffer) e: for(var r = this.index, o = this.stack.length; o >= 0;){
                    for(var i = e; i; i = i._parent)if (i.index == r) {
                        if (r == this.index) return i;
                        t = i, n = o + 1;
                        break e;
                    }
                    r = this.stack[--o];
                }
                for(var a = n; a < this.stack.length; a++)t = new tQ(this.buffer, t, this.stack[a]);
                return this.bufferNode = new tQ(this.buffer, t, this.index);
            }
        },
        {
            key: "tree",
            get: function() {
                return this.buffer ? null : this._tree._tree;
            }
        },
        {
            key: "iterate",
            value: function(e, t) {
                for(var n = 0;;){
                    var r = !1;
                    if (this.type.isAnonymous || !1 !== e(this)) {
                        if (this.firstChild()) {
                            n++;
                            continue;
                        }
                        this.type.isAnonymous || (r = !0);
                    }
                    for(; r && t && t(this), r = this.type.isAnonymous, !this.nextSibling();){
                        if (!n) return;
                        this.parent(), n--, r = !0;
                    }
                }
            }
        },
        {
            key: "matchContext",
            value: function(e) {
                if (!this.buffer) return ZG(this.node, e);
                for(var t = this.buffer.buffer, n = t.set.types, r = e.length - 1, o = this.stack.length - 1; r >= 0; o--){
                    if (o < 0) return ZG(this.node, e, r);
                    var i = n[t.buffer[this.stack[o]]];
                    if (!i.isAnonymous) {
                        if (e[r] && e[r] != i.name) return !1;
                        r--;
                    }
                }
                return !0;
            }
        }
    ]), e;
}();
function iQ(e) {
    return e.children.some(function(e) {
        return e instanceof JG || !e.type.isAnonymous || iQ(e);
    });
}
function aQ(e) {
    var t, n = e.buffer, r = e.nodeSet, o = e.maxBufferLength, i = void 0 === o ? 1024 : o, a = e.reused, s = void 0 === a ? [] : a, c = e.minRepeatType, l = void 0 === c ? r.types.length : c, u = Array.isArray(n) ? new UG(n, n.length) : n, f = r.types, d = 0, h = 0;
    function v(e, t, n, o, a, c) {
        for(var b = u.id, w = u.start, x = u.end, k = u.size, j = h; k < 0;){
            if (u.next(), -1 == k) {
                var S = s[b];
                return n.push(S), void o.push(w - e);
            }
            if (-3 == k) return void (d = b);
            if (-4 == k) return void (h = b);
            throw new RangeError("Unrecognized record size: ".concat(k));
        }
        var C, $, _ = f[b], O = w - e;
        if (x - w <= i && ($ = function(e, t) {
            var n = u.fork(), r = 0, o = 0, a = 0, s = n.end - i, c = {
                size: 0,
                start: 0,
                skip: 0
            };
            e: for(var f = n.pos - e; n.pos > f;){
                var d = n.size;
                if (n.id == t && d >= 0) c.size = r, c.start = o, c.skip = a, a += 4, r += 4, n.next();
                else {
                    var h = n.pos - d;
                    if (d < 0 || h < f || n.start < s) break;
                    var v = n.id >= l ? 4 : 0, p = n.start;
                    for(n.next(); n.pos > h;){
                        if (n.size < 0) {
                            if (-3 != n.size) break e;
                            v += 4;
                        } else n.id >= l && (v += 4);
                        n.next();
                    }
                    o = p, r += d, a += v;
                }
            }
            (t < 0 || r == e) && (c.size = r, c.start = o, c.skip = a);
            return c.size > 4 ? c : void 0;
        }(u.pos - t, a))) {
            for(var M = new Uint16Array($.size - $.skip), E = u.pos - $.size, A = M.length; u.pos > E;)A = y($.start, M, A);
            C = new JG(M, x - $.start, r), O = $.start - e;
        } else {
            var P = u.pos - k;
            u.next();
            for(var T = [], R = [], N = b >= l ? b : -1, I = 0, D = x; u.pos > P;)N >= 0 && u.id == N && u.size >= 0 ? (u.end <= D - i && (m(T, R, w, I, u.end, D, N, j), I = T.length, D = u.end), u.next()) : c > 2500 ? p(w, P, T, R) : v(w, P, T, R, N, c + 1);
            if (N >= 0 && I > 0 && I < T.length && m(T, R, w, I, w, D, N, j), T.reverse(), R.reverse(), N > -1 && I > 0) {
                var z = function(e) {
                    return function(t, n, r) {
                        var o, i, a = 0, s = t.length - 1;
                        if (s >= 0 && (o = t[s]) instanceof WG) {
                            if (!s && o.type == e && o.length == r) return o;
                            (i = o.prop(DG.lookAhead)) && (a = n[s] + o.length + i);
                        }
                        return g(e, t, n, r, a);
                    };
                }(_);
                C = lQ(_, T, R, 0, T.length, 0, x - w, z, z);
            } else C = g(_, T, R, x - w, j - x);
        }
        n.push(C), o.push(O);
    }
    function p(e, t, n, o) {
        for(var a = [], s = 0, c = -1; u.pos > t;){
            var l = u.id, f = u.start, d = u.end;
            if (u.size > 4) u.next();
            else {
                if (c > -1 && f < c) break;
                c < 0 && (c = d - i), a.push(l, f, d), s++, u.next();
            }
        }
        if (s) {
            for(var h = new Uint16Array(4 * s), v = a[a.length - 2], p = a.length - 3, m = 0; p >= 0; p -= 3)h[m++] = a[p], h[m++] = a[p + 1] - v, h[m++] = a[p + 2] - v, h[m++] = m;
            n.push(new JG(h, a[2] - v, r)), o.push(v - e);
        }
    }
    function m(e, t, n, o, i, a, s, c) {
        for(var l = [], u = []; e.length > o;)l.push(e.pop()), u.push(t.pop() + n - i);
        e.push(g(r.types[s], l, u, a - i, c - a)), t.push(i - n);
    }
    function g(e, t, n, r) {
        var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, i = arguments.length > 5 ? arguments[5] : void 0;
        if (d) {
            var a = [
                DG.contextHash,
                d
            ];
            i = i ? [
                a
            ].concat(i) : [
                a
            ];
        }
        if (o > 25) {
            var s = [
                DG.lookAhead,
                o
            ];
            i = i ? [
                s
            ].concat(i) : [
                s
            ];
        }
        return new WG(e, t, n, r, i);
    }
    function y(e, t, n) {
        var r = u.id, o = u.start, i = u.end, a = u.size;
        if (u.next(), a >= 0 && r < l) {
            var s = n;
            if (a > 4) for(var c = u.pos - (a - 4); u.pos > c;)n = y(e, t, n);
            t[--n] = s, t[--n] = i - e, t[--n] = o - e, t[--n] = r;
        } else -3 == a ? d = r : -4 == a && (h = r);
        return n;
    }
    for(var b = [], w = []; u.pos > 0;)v(e.start || 0, e.bufferStart || 0, b, w, -1, 0);
    var x = null !== (t = e.length) && void 0 !== t ? t : b.length ? w[0] + b[0].length : 0;
    return new WG(f[e.topID], b.reverse(), w.reverse(), x);
}
var sQ = new WeakMap;
function cQ(e, t) {
    if (!e.isAnonymous || t instanceof JG || t.type != e) return 1;
    var n = sQ.get(t);
    if (null == n) {
        n = 1;
        var r, o = bo(t.children);
        try {
            for(o.s(); !(r = o.n()).done;){
                var i = r.value;
                if (i.type != e || !(i instanceof WG)) {
                    n = 1;
                    break;
                }
                n += cQ(e, i);
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        sQ.set(t, n);
    }
    return n;
}
function lQ(e, t, n, r, o, i, a, s, c) {
    for(var l = 0, u = r; u < o; u++)l += cQ(e, t[u]);
    var f = Math.ceil(1.5 * l / 8), d = [], h = [];
    return function t(n, r, o, a, s) {
        for(var l = o; l < a;){
            var u = l, v = r[l], p = cQ(e, n[l]);
            for(l++; l < a; l++){
                var m = cQ(e, n[l]);
                if (p + m >= f) break;
                p += m;
            }
            if (l == u + 1) {
                if (p > f) {
                    var g = n[u];
                    t(g.children, g.positions, 0, g.children.length, r[u] + s);
                    continue;
                }
                d.push(n[u]);
            } else {
                var y = r[l - 1] + n[l - 1].length - v;
                d.push(lQ(e, n, r, u, l, v, y, null, c));
            }
            h.push(v + s - i);
        }
    }(t, n, r, o, 0), (s || c)(d, h, a);
}
var uQ = function() {
    function e(t, n, r, o) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
        No(this, e), this.from = t, this.to = n, this.tree = r, this.offset = o, this.open = (i ? 1 : 0) | (a ? 2 : 0);
    }
    return Do(e, [
        {
            key: "openStart",
            get: function() {
                return (1 & this.open) > 0;
            }
        },
        {
            key: "openEnd",
            get: function() {
                return (2 & this.open) > 0;
            }
        }
    ], [
        {
            key: "addTree",
            value: function(t) {
                var n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = [
                    new e(0, t.length, t, 0, !1, o)
                ], a = bo(r);
                try {
                    for(a.s(); !(n = a.n()).done;){
                        var s = n.value;
                        s.to > t.length && i.push(s);
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return i;
            }
        },
        {
            key: "applyChanges",
            value: function(t, n) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 128;
                if (!n.length) return t;
                for(var o = [], i = 1, a = t.length ? t[0] : null, s = 0, c = 0, l = 0;; s++){
                    var u = s < n.length ? n[s] : null, f = u ? u.fromA : 1e9;
                    if (f - c >= r) for(; a && a.from < f;){
                        var d = a;
                        if (c >= d.from || f <= d.to || l) {
                            var h = Math.max(d.from, c) - l, v = Math.min(d.to, f) - l;
                            d = h >= v ? null : new e(h, v, d.tree, d.offset + l, s > 0, !!u);
                        }
                        if (d && o.push(d), a.to > f) break;
                        a = i < t.length ? t[i++] : null;
                    }
                    if (!u) break;
                    c = u.toA, l = u.toA - u.toB;
                }
                return o;
            }
        }
    ]), e;
}(), fQ = function() {
    function e() {
        No(this, e);
    }
    return Do(e, [
        {
            key: "startParse",
            value: function(e, t, n) {
                return "string" == typeof e && (e = new dQ(e)), n = n ? n.length ? n.map(function(e) {
                    return new IG(e.from, e.to);
                }) : [
                    new IG(0, 0)
                ] : [
                    new IG(0, e.length)
                ], this.createParse(e, t || [], n);
            }
        },
        {
            key: "parse",
            value: function(e, t, n) {
                for(var r = this.startParse(e, t, n);;){
                    var o = r.advance();
                    if (o) return o;
                }
            }
        }
    ]), e;
}(), dQ = function() {
    function e(t) {
        No(this, e), this.string = t;
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                return this.string.length;
            }
        },
        {
            key: "chunk",
            value: function(e) {
                return this.string.slice(e);
            }
        },
        {
            key: "lineChunks",
            get: function() {
                return !1;
            }
        },
        {
            key: "read",
            value: function(e, t) {
                return this.string.slice(e, t);
            }
        }
    ]), e;
}();
new DG({
    perNode: !0
});
var hQ = 0, vQ = function() {
    function e(t, n, r) {
        No(this, e), this.set = t, this.base = n, this.modified = r, this.id = hQ++;
    }
    return Do(e, null, [
        {
            key: "define",
            value: function(t) {
                if (null == t ? void 0 : t.base) throw new Error("Can not derive from a modified tag");
                var n = new e([], null, []);
                if (n.set.push(n), t) {
                    var r, o = bo(t.set);
                    try {
                        for(o.s(); !(r = o.n()).done;){
                            var i = r.value;
                            n.set.push(i);
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                }
                return n;
            }
        },
        {
            key: "defineModifier",
            value: function() {
                var e = new mQ;
                return function(t) {
                    return t.modified.indexOf(e) > -1 ? t : mQ.get(t.base || t, t.modified.concat(e).sort(function(e, t) {
                        return e.id - t.id;
                    }));
                };
            }
        }
    ]), e;
}(), pQ = 0, mQ = function() {
    function e() {
        No(this, e), this.instances = [], this.id = pQ++;
    }
    return Do(e, null, [
        {
            key: "get",
            value: function(t, n) {
                if (!n.length) return t;
                var r = n[0].instances.find(function(e) {
                    var r, o;
                    return e.base == t && (r = n, o = e.modified, r.length == o.length && r.every(function(e, t) {
                        return e == o[t];
                    }));
                });
                if (r) return r;
                var o, i = [], a = new vQ(i, t, n), s = bo(n);
                try {
                    for(s.s(); !(o = s.n()).done;)o.value.instances.push(a);
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
                var c, l = function(e) {
                    for(var t = [
                        []
                    ], n = 0; n < e.length; n++)for(var r = 0, o = t.length; r < o; r++)t.push(t[r].concat(e[n]));
                    return t.sort(function(e, t) {
                        return t.length - e.length;
                    });
                }(n), u = bo(t.set);
                try {
                    for(u.s(); !(c = u.n()).done;){
                        var f = c.value;
                        if (!f.modified.length) {
                            var d, h = bo(l);
                            try {
                                for(h.s(); !(d = h.n()).done;){
                                    var v = d.value;
                                    i.push(e.get(f, v));
                                }
                            } catch (e) {
                                h.e(e);
                            } finally{
                                h.f();
                            }
                        }
                    }
                } catch (e) {
                    u.e(e);
                } finally{
                    u.f();
                }
                return a;
            }
        }
    ]), e;
}();
function gQ(e) {
    var t = Object.create(null);
    for(var n in e){
        var r = e[n];
        Array.isArray(r) || (r = [
            r
        ]);
        var o, i = bo(n.split(" "));
        try {
            for(i.s(); !(o = i.n()).done;){
                var a = o.value;
                if (a) {
                    for(var s = [], c = 2, l = a, u = 0;;){
                        if ("..." == l && u > 0 && u + 3 == a.length) {
                            c = 1;
                            break;
                        }
                        var f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(l);
                        if (!f) throw new RangeError("Invalid path: " + a);
                        if (s.push("*" == f[0] ? "" : '"' == f[0][0] ? JSON.parse(f[0]) : f[0]), (u += f[0].length) == a.length) break;
                        var d = a[u++];
                        if (u == a.length && "!" == d) {
                            c = 0;
                            break;
                        }
                        if ("/" != d) throw new RangeError("Invalid path: " + a);
                        l = a.slice(u);
                    }
                    var h = s.length - 1, v = s[h];
                    if (!v) throw new RangeError("Invalid path: " + a);
                    var p = new bQ(r, c, h > 0 ? s.slice(0, h) : null);
                    t[v] = p.sort(t[v]);
                }
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
    }
    return yQ.add(t);
}
var yQ = new DG, bQ = function() {
    function e(t, n, r, o) {
        No(this, e), this.tags = t, this.mode = n, this.context = r, this.next = o;
    }
    return Do(e, [
        {
            key: "opaque",
            get: function() {
                return 0 == this.mode;
            }
        },
        {
            key: "inherit",
            get: function() {
                return 1 == this.mode;
            }
        },
        {
            key: "sort",
            value: function(e) {
                return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
            }
        },
        {
            key: "depth",
            get: function() {
                return this.context ? this.context.length : 0;
            }
        }
    ]), e;
}();
function wQ(e, t) {
    var n, r = Object.create(null), o = bo(e);
    try {
        for(o.s(); !(n = o.n()).done;){
            var i = n.value;
            if (Array.isArray(i.tag)) {
                var a, s = bo(i.tag);
                try {
                    for(s.s(); !(a = s.n()).done;){
                        var c = a.value;
                        r[c.id] = i.class;
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            } else r[i.tag.id] = i.class;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    var l = t || {}, u = l.scope, f = l.all, d = void 0 === f ? null : f;
    return {
        style: function(e) {
            var t, n = d, o = bo(e);
            try {
                for(o.s(); !(t = o.n()).done;){
                    var i, a = bo(t.value.set);
                    try {
                        for(a.s(); !(i = a.n()).done;){
                            var s = i.value, c = r[s.id];
                            if (c) {
                                n = n ? n + " " + c : c;
                                break;
                            }
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
            } catch (e) {
                o.e(e);
            } finally{
                o.f();
            }
            return n;
        },
        scope: u
    };
}
function xQ(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : e.length, i = new kQ(r, Array.isArray(t) ? t : [
        t
    ], n);
    i.highlightRange(e.cursor(), r, o, "", i.highlighters), i.flush(o);
}
bQ.empty = new bQ([], 2, null);
var kQ = function() {
    function e(t, n, r) {
        No(this, e), this.at = t, this.highlighters = n, this.span = r, this.class = "";
    }
    return Do(e, [
        {
            key: "startSpan",
            value: function(e, t) {
                t != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = t);
            }
        },
        {
            key: "flush",
            value: function(e) {
                e > this.at && this.class && this.span(this.at, e, this.class);
            }
        },
        {
            key: "highlightRange",
            value: function(e, t, n, r, o) {
                var i = e.type, a = e.from, s = e.to;
                if (!(a >= n || s <= t)) {
                    i.isTop && (o = this.highlighters.filter(function(e) {
                        return !e.scope || e.scope(i);
                    }));
                    var c = r, l = function(e) {
                        var t = e.type.prop(yQ);
                        for(; t && t.context && !e.matchContext(t.context);)t = t.next;
                        return t || null;
                    }(e) || bQ.empty, u = function(e, t) {
                        var n, r = null, o = bo(e);
                        try {
                            for(o.s(); !(n = o.n()).done;){
                                var i = n.value.style(t);
                                i && (r = r ? r + " " + i : i);
                            }
                        } catch (e) {
                            o.e(e);
                        } finally{
                            o.f();
                        }
                        return r;
                    }(o, l.tags);
                    if (u && (c && (c += " "), c += u, 1 == l.mode && (r += (r ? " " : "") + u)), this.startSpan(Math.max(t, a), c), !l.opaque) {
                        var f = e.tree && e.tree.prop(DG.mounted);
                        if (f && f.overlay) {
                            for(var d = e.node.enter(f.overlay[0].from + a, 1), h = this.highlighters.filter(function(e) {
                                return !e.scope || e.scope(f.tree.type);
                            }), v = e.firstChild(), p = 0, m = a;; p++){
                                var g = p < f.overlay.length ? f.overlay[p] : null, y = g ? g.from + a : s, b = Math.max(t, m), w = Math.min(n, y);
                                if (b < w && v) for(; e.from < w && (this.highlightRange(e, b, w, r, o), this.startSpan(Math.min(w, e.to), c), !(e.to >= y) && e.nextSibling()););
                                if (!g || y > n) break;
                                (m = g.to + a) > t && (this.highlightRange(d.cursor(), Math.max(t, g.from + a), Math.min(n, m), "", h), this.startSpan(Math.min(n, m), c));
                            }
                            v && e.parent();
                        } else if (e.firstChild()) {
                            f && (r = "");
                            do if (!(e.to <= t)) {
                                if (e.from >= n) break;
                                this.highlightRange(e, t, n, r, o), this.startSpan(Math.min(n, e.to), c);
                            }
                            while (e.nextSibling());
                            e.parent();
                        }
                    }
                }
            }
        }
    ]), e;
}();
var jQ, SQ = vQ.define, CQ = SQ(), $Q = SQ(), _Q = SQ($Q), OQ = SQ($Q), MQ = SQ(), EQ = SQ(MQ), AQ = SQ(MQ), PQ = SQ(), TQ = SQ(PQ), RQ = SQ(), NQ = SQ(), IQ = SQ(), DQ = SQ(IQ), zQ = SQ(), qQ = {
    comment: CQ,
    lineComment: SQ(CQ),
    blockComment: SQ(CQ),
    docComment: SQ(CQ),
    name: $Q,
    variableName: SQ($Q),
    typeName: _Q,
    tagName: SQ(_Q),
    propertyName: OQ,
    attributeName: SQ(OQ),
    className: SQ($Q),
    labelName: SQ($Q),
    namespace: SQ($Q),
    macroName: SQ($Q),
    literal: MQ,
    string: EQ,
    docString: SQ(EQ),
    character: SQ(EQ),
    attributeValue: SQ(EQ),
    number: AQ,
    integer: SQ(AQ),
    float: SQ(AQ),
    bool: SQ(MQ),
    regexp: SQ(MQ),
    escape: SQ(MQ),
    color: SQ(MQ),
    url: SQ(MQ),
    keyword: RQ,
    self: SQ(RQ),
    null: SQ(RQ),
    atom: SQ(RQ),
    unit: SQ(RQ),
    modifier: SQ(RQ),
    operatorKeyword: SQ(RQ),
    controlKeyword: SQ(RQ),
    definitionKeyword: SQ(RQ),
    moduleKeyword: SQ(RQ),
    operator: NQ,
    derefOperator: SQ(NQ),
    arithmeticOperator: SQ(NQ),
    logicOperator: SQ(NQ),
    bitwiseOperator: SQ(NQ),
    compareOperator: SQ(NQ),
    updateOperator: SQ(NQ),
    definitionOperator: SQ(NQ),
    typeOperator: SQ(NQ),
    controlOperator: SQ(NQ),
    punctuation: IQ,
    separator: SQ(IQ),
    bracket: DQ,
    angleBracket: SQ(DQ),
    squareBracket: SQ(DQ),
    paren: SQ(DQ),
    brace: SQ(DQ),
    content: PQ,
    heading: TQ,
    heading1: SQ(TQ),
    heading2: SQ(TQ),
    heading3: SQ(TQ),
    heading4: SQ(TQ),
    heading5: SQ(TQ),
    heading6: SQ(TQ),
    contentSeparator: SQ(PQ),
    list: SQ(PQ),
    quote: SQ(PQ),
    emphasis: SQ(PQ),
    strong: SQ(PQ),
    link: SQ(PQ),
    monospace: SQ(PQ),
    strikethrough: SQ(PQ),
    inserted: SQ(),
    deleted: SQ(),
    changed: SQ(),
    invalid: SQ(),
    meta: zQ,
    documentMeta: SQ(zQ),
    annotation: SQ(zQ),
    processingInstruction: SQ(zQ),
    definition: vQ.defineModifier(),
    constant: vQ.defineModifier(),
    function: vQ.defineModifier(),
    standard: vQ.defineModifier(),
    local: vQ.defineModifier(),
    special: vQ.defineModifier()
};
wQ([
    {
        tag: qQ.link,
        class: "tok-link"
    },
    {
        tag: qQ.heading,
        class: "tok-heading"
    },
    {
        tag: qQ.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: qQ.strong,
        class: "tok-strong"
    },
    {
        tag: qQ.keyword,
        class: "tok-keyword"
    },
    {
        tag: qQ.atom,
        class: "tok-atom"
    },
    {
        tag: qQ.bool,
        class: "tok-bool"
    },
    {
        tag: qQ.url,
        class: "tok-url"
    },
    {
        tag: qQ.labelName,
        class: "tok-labelName"
    },
    {
        tag: qQ.inserted,
        class: "tok-inserted"
    },
    {
        tag: qQ.deleted,
        class: "tok-deleted"
    },
    {
        tag: qQ.literal,
        class: "tok-literal"
    },
    {
        tag: qQ.string,
        class: "tok-string"
    },
    {
        tag: qQ.number,
        class: "tok-number"
    },
    {
        tag: [
            qQ.regexp,
            qQ.escape,
            qQ.special(qQ.string)
        ],
        class: "tok-string2"
    },
    {
        tag: qQ.variableName,
        class: "tok-variableName"
    },
    {
        tag: qQ.local(qQ.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: qQ.definition(qQ.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: qQ.special(qQ.variableName),
        class: "tok-variableName2"
    },
    {
        tag: qQ.definition(qQ.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: qQ.typeName,
        class: "tok-typeName"
    },
    {
        tag: qQ.namespace,
        class: "tok-namespace"
    },
    {
        tag: qQ.className,
        class: "tok-className"
    },
    {
        tag: qQ.macroName,
        class: "tok-macroName"
    },
    {
        tag: qQ.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: qQ.operator,
        class: "tok-operator"
    },
    {
        tag: qQ.comment,
        class: "tok-comment"
    },
    {
        tag: qQ.meta,
        class: "tok-meta"
    },
    {
        tag: qQ.invalid,
        class: "tok-invalid"
    },
    {
        tag: qQ.punctuation,
        class: "tok-punctuation"
    }
]);
var BQ = new DG;
var LQ = new DG, FQ = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";
        No(this, e), this.data = t, this.name = o, kV.prototype.hasOwnProperty("tree") || Object.defineProperty(kV.prototype, "tree", {
            get: function() {
                return WQ(this);
            }
        }), this.parser = n, this.extension = [
            eY.of(this),
            kV.languageData.of(function(e, t, n) {
                var r = VQ(e, t, n), o = r.type.prop(BQ);
                if (!o) return [];
                var i = e.facet(o), a = r.type.prop(LQ);
                if (a) {
                    var s, c = r.resolve(t - r.from, n), l = bo(a);
                    try {
                        for(l.s(); !(s = l.n()).done;){
                            var u = s.value;
                            if (u.test(c, e)) {
                                var f = e.facet(u.facet);
                                return "replace" == u.type ? f : f.concat(i);
                            }
                        }
                    } catch (e) {
                        l.e(e);
                    } finally{
                        l.f();
                    }
                }
                return i;
            })
        ].concat(r);
    }
    return Do(e, [
        {
            key: "isActiveAt",
            value: function(e, t) {
                return VQ(e, t, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1).type.prop(BQ) == this.data;
            }
        },
        {
            key: "findRegions",
            value: function(e) {
                var t = this, n = e.facet(eY);
                if ((null == n ? void 0 : n.data) == this.data) return [
                    {
                        from: 0,
                        to: e.doc.length
                    }
                ];
                if (!n || !n.allowsNesting) return [];
                var r = [];
                return function e(n, o) {
                    if (n.prop(BQ) != t.data) {
                        var i = n.prop(DG.mounted);
                        if (i) {
                            if (i.tree.prop(BQ) == t.data) {
                                if (i.overlay) {
                                    var a, s = bo(i.overlay);
                                    try {
                                        for(s.s(); !(a = s.n()).done;){
                                            var c = a.value;
                                            r.push({
                                                from: c.from + o,
                                                to: c.to + o
                                            });
                                        }
                                    } catch (e) {
                                        s.e(e);
                                    } finally{
                                        s.f();
                                    }
                                } else r.push({
                                    from: o,
                                    to: o + n.length
                                });
                                return;
                            }
                            if (i.overlay) {
                                var l = r.length;
                                if (e(i.tree, i.overlay[0].from + o), r.length > l) return;
                            }
                        }
                        for(var u = 0; u < n.children.length; u++){
                            var f = n.children[u];
                            f instanceof WG && e(f, n.positions[u] + o);
                        }
                    } else r.push({
                        from: o,
                        to: o + n.length
                    });
                }(WQ(e), 0), r;
            }
        },
        {
            key: "allowsNesting",
            get: function() {
                return !0;
            }
        }
    ]), e;
}();
function VQ(e, t, n) {
    var r = e.facet(eY), o = WQ(e).topNode;
    if (!r || r.allowsNesting) for(var i = o; i; i = i.enter(t, n, LG.ExcludeBuffers))i.type.isTop && (o = i);
    return o;
}
FQ.setState = uV.define();
var HQ = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t, [
            e,
            n,
            [],
            r
        ])).parser = n, o;
    }
    return Ao(t, FQ), Do(t, [
        {
            key: "configure",
            value: function(e, n) {
                return new t(this.data, this.parser.configure(e), n || this.name);
            }
        },
        {
            key: "allowsNesting",
            get: function() {
                return this.parser.hasWrappers();
            }
        }
    ], [
        {
            key: "define",
            value: function(e) {
                var n, r = (n = e.languageData, NF.define({
                    combine: n ? function(e) {
                        return e.concat(n);
                    } : void 0
                }));
                return new t(r, e.parser.configure({
                    props: [
                        BQ.add(function(e) {
                            return e.isTop ? r : void 0;
                        })
                    ]
                }), e.name);
            }
        }
    ]), t;
}();
function WQ(e) {
    var t = e.field(FQ.state, !1);
    return t ? t.tree : WG.empty;
}
var UQ = function() {
    function e(t) {
        No(this, e), this.doc = t, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
    }
    return Do(e, [
        {
            key: "length",
            get: function() {
                return this.doc.length;
            }
        },
        {
            key: "syncTo",
            value: function(e) {
                return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
            }
        },
        {
            key: "chunk",
            value: function(e) {
                return this.syncTo(e), this.string;
            }
        },
        {
            key: "lineChunks",
            get: function() {
                return !0;
            }
        },
        {
            key: "read",
            value: function(e, t) {
                var n = this.cursorPos - this.string.length;
                return e < n || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - n, t - n);
            }
        }
    ]), e;
}(), JQ = null, KQ = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], o = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 ? arguments[6] : void 0, c = arguments.length > 7 ? arguments[7] : void 0;
        No(this, e), this.parser = t, this.state = n, this.fragments = r, this.tree = o, this.treeLen = i, this.viewport = a, this.skipped = s, this.scheduleOn = c, this.parse = null, this.tempSkipped = [];
    }
    return Do(e, [
        {
            key: "startParse",
            value: function() {
                return this.parser.startParse(new UQ(this.state.doc), this.fragments);
            }
        },
        {
            key: "work",
            value: function(e, t) {
                var n = this;
                return null != t && t >= this.state.doc.length && (t = void 0), this.tree != WG.empty && this.isDone(null != t ? t : this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(function() {
                    var r;
                    if ("number" == typeof e) {
                        var o = Date.now() + e;
                        e = function() {
                            return Date.now() > o;
                        };
                    }
                    for(n.parse || (n.parse = n.startParse()), null != t && (null == n.parse.stoppedAt || n.parse.stoppedAt > t) && t < n.state.doc.length && n.parse.stopAt(t);;){
                        var i = n.parse.advance();
                        if (i) {
                            if (n.fragments = n.withoutTempSkipped(uQ.addTree(i, n.fragments, null != n.parse.stoppedAt)), n.treeLen = null !== (r = n.parse.stoppedAt) && void 0 !== r ? r : n.state.doc.length, n.tree = i, n.parse = null, !(n.treeLen < (null != t ? t : n.state.doc.length))) return !0;
                            n.parse = n.startParse();
                        }
                        if (e()) return !1;
                    }
                });
            }
        },
        {
            key: "takeTree",
            value: function() {
                var e, t, n = this;
                this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((null == this.parse.stoppedAt || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(function() {
                    for(; !(t = n.parse.advance()););
                }), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(uQ.addTree(this.tree, this.fragments, !0)), this.parse = null);
            }
        },
        {
            key: "withContext",
            value: function(e) {
                var t = JQ;
                JQ = this;
                try {
                    return e();
                } finally{
                    JQ = t;
                }
            }
        },
        {
            key: "withoutTempSkipped",
            value: function(e) {
                for(var t; t = this.tempSkipped.pop();)e = GQ(e, t.from, t.to);
                return e;
            }
        },
        {
            key: "changes",
            value: function(t, n) {
                var r = this.fragments, o = this.tree, i = this.treeLen, a = this.viewport, s = this.skipped;
                if (this.takeTree(), !t.empty) {
                    var c = [];
                    if (t.iterChangedRanges(function(e, t, n, r) {
                        return c.push({
                            fromA: e,
                            toA: t,
                            fromB: n,
                            toB: r
                        });
                    }), r = uQ.applyChanges(r, c), o = WG.empty, i = 0, a = {
                        from: t.mapPos(a.from, -1),
                        to: t.mapPos(a.to, 1)
                    }, this.skipped.length) {
                        s = [];
                        var l, u = bo(this.skipped);
                        try {
                            for(u.s(); !(l = u.n()).done;){
                                var f = l.value, d = t.mapPos(f.from, 1), h = t.mapPos(f.to, -1);
                                d < h && s.push({
                                    from: d,
                                    to: h
                                });
                            }
                        } catch (e) {
                            u.e(e);
                        } finally{
                            u.f();
                        }
                    }
                }
                return new e(this.parser, n, r, o, i, a, s, this.scheduleOn);
            }
        },
        {
            key: "updateViewport",
            value: function(e) {
                if (this.viewport.from == e.from && this.viewport.to == e.to) return !1;
                this.viewport = e;
                for(var t = this.skipped.length, n = 0; n < this.skipped.length; n++){
                    var r = this.skipped[n], o = r.from, i = r.to;
                    o < e.to && i > e.from && (this.fragments = GQ(this.fragments, o, i), this.skipped.splice(n--, 1));
                }
                return !(this.skipped.length >= t) && (this.reset(), !0);
            }
        },
        {
            key: "reset",
            value: function() {
                this.parse && (this.takeTree(), this.parse = null);
            }
        },
        {
            key: "skipUntilInView",
            value: function(e, t) {
                this.skipped.push({
                    from: e,
                    to: t
                });
            }
        },
        {
            key: "isDone",
            value: function(e) {
                e = Math.min(e, this.state.doc.length);
                var t = this.fragments;
                return this.treeLen >= e && t.length && 0 == t[0].from && t[0].to >= e;
            }
        }
    ], [
        {
            key: "create",
            value: function(t, n, r) {
                return new e(t, n, [], WG.empty, 0, r, [], null);
            }
        },
        {
            key: "getSkippingParser",
            value: function(e) {
                return new (function(t) {
                    function n() {
                        return No(this, n), _o(this, n, arguments);
                    }
                    return Ao(n, fQ), Do(n, [
                        {
                            key: "createParse",
                            value: function(t, n, r) {
                                var o = r[0].from, i = r[r.length - 1].to;
                                return {
                                    parsedPos: o,
                                    advance: function() {
                                        var t = JQ;
                                        if (t) {
                                            var n, a = bo(r);
                                            try {
                                                for(a.s(); !(n = a.n()).done;){
                                                    var s = n.value;
                                                    t.tempSkipped.push(s);
                                                }
                                            } catch (e) {
                                                a.e(e);
                                            } finally{
                                                a.f();
                                            }
                                            e && (t.scheduleOn = t.scheduleOn ? Promise.all([
                                                t.scheduleOn,
                                                e
                                            ]) : e);
                                        }
                                        return this.parsedPos = i, new WG(BG.none, [], [], i - o);
                                    },
                                    stoppedAt: null,
                                    stopAt: function() {}
                                };
                            }
                        }
                    ]), n;
                }());
            }
        },
        {
            key: "get",
            value: function() {
                return JQ;
            }
        }
    ]), e;
}();
function GQ(e, t, n) {
    return uQ.applyChanges(e, [
        {
            fromA: t,
            toA: n,
            fromB: t,
            toB: n
        }
    ]);
}
var QQ = function() {
    function e(t) {
        No(this, e), this.context = t, this.tree = t.tree;
    }
    return Do(e, [
        {
            key: "apply",
            value: function(t) {
                if (!t.docChanged && this.tree == this.context.tree) return this;
                var n = this.context.changes(t.changes, t.state), r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
                return n.work(20, r) || n.takeTree(), new e(n);
            }
        }
    ], [
        {
            key: "init",
            value: function(t) {
                var n = Math.min(3e3, t.doc.length), r = KQ.create(t.facet(eY).parser, t, {
                    from: 0,
                    to: n
                });
                return r.work(20, n) || r.takeTree(), new e(r);
            }
        }
    ]), e;
}();
FQ.state = LF.define({
    create: QQ.init,
    update: function(e, t) {
        var n, r = bo(t.effects);
        try {
            for(r.s(); !(n = r.n()).done;){
                var o = n.value;
                if (o.is(FQ.setState)) return o.value;
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        return t.startState.facet(eY) != t.state.facet(eY) ? QQ.init(t.state) : e.apply(t);
    }
});
var YQ = function(e) {
    var t = setTimeout(function() {
        return e();
    }, 500);
    return function() {
        return clearTimeout(t);
    };
};
"undefined" != typeof requestIdleCallback && (YQ = function(e) {
    var t = -1, n = setTimeout(function() {
        t = requestIdleCallback(e, {
            timeout: 400
        });
    }, 100);
    return function() {
        return t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
    };
});
var XQ = "undefined" != typeof navigator && (null === (jQ = navigator.scheduling) || void 0 === jQ ? void 0 : jQ.isInputPending) ? function() {
    return navigator.scheduling.isInputPending();
} : null, ZQ = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = this.view.state.field(FQ.state).context;
                (t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
            }
        },
        {
            key: "scheduleWork",
            value: function() {
                if (!this.working) {
                    var e = this.view.state, t = e.field(FQ.state);
                    t.tree == t.context.tree && t.context.isDone(e.doc.length) || (this.working = YQ(this.work));
                }
            }
        },
        {
            key: "work",
            value: function(e) {
                this.working = null;
                var t = Date.now();
                if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), !(this.chunkBudget <= 0)) {
                    var n = this.view, r = n.state, o = n.viewport.to, i = r.field(FQ.state);
                    if (i.tree != i.context.tree || !i.context.isDone(o + 1e5)) {
                        var a = Date.now() + Math.min(this.chunkBudget, 100, e && !XQ ? Math.max(25, e.timeRemaining() - 5) : 1e9), s = i.context.treeLen < o && r.doc.length > o + 1e3, c = i.context.work(function() {
                            return XQ && XQ() || Date.now() > a;
                        }, o + (s ? 0 : 1e5));
                        this.chunkBudget -= Date.now() - t, (c || this.chunkBudget <= 0) && (i.context.takeTree(), this.view.dispatch({
                            effects: FQ.setState.of(new QQ(i.context))
                        })), this.chunkBudget > 0 && (!c || s) && this.scheduleWork(), this.checkAsyncSchedule(i.context);
                    }
                }
            }
        },
        {
            key: "checkAsyncSchedule",
            value: function(e) {
                var t = this;
                e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(function() {
                    return t.scheduleWork();
                }).catch(function(e) {
                    return HW(t.view.state, e);
                }).then(function() {
                    return t.workScheduled--;
                }), e.scheduleOn = null);
            }
        },
        {
            key: "destroy",
            value: function() {
                this.working && this.working();
            }
        },
        {
            key: "isWorking",
            value: function() {
                return !!(this.working || this.workScheduled > 0);
            }
        }
    ]), e;
}(), {
    eventHandlers: {
        focus: function() {
            this.scheduleWork();
        }
    }
}), eY = NF.define({
    combine: function(e) {
        return e.length ? e[0] : null;
    },
    enables: function(e) {
        return [
            FQ.state,
            ZQ,
            WJ.contentAttributes.compute([
                e
            ], function(t) {
                var n = t.facet(e);
                return n && n.name ? {
                    "data-language": n.name
                } : {};
            })
        ];
    }
}), tY = Do(function e(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    No(this, e), this.language = t, this.support = n, this.extension = [
        t,
        n
    ];
}), nY = NF.define(), rY = NF.define({
    combine: function(e) {
        if (!e.length) return "  ";
        var t = e[0];
        if (!t || /\S/.test(t) || Array.from(t).some(function(e) {
            return e != t[0];
        })) throw new Error("Invalid indent unit: " + JSON.stringify(e[0]));
        return t;
    }
});
function oY(e) {
    var t = e.facet(rY);
    return 9 == t.charCodeAt(0) ? e.tabSize * t.length : t.length;
}
function iY(e, t) {
    var n = "", r = e.tabSize, o = e.facet(rY)[0];
    if ("	" == o) {
        for(; t >= r;)n += "	", t -= r;
        o = " ";
    }
    for(var i = 0; i < t; i++)n += o;
    return n;
}
function aY(e, t) {
    e instanceof kV && (e = new sY(e));
    var n, r = bo(e.state.facet(nY));
    try {
        for(r.s(); !(n = r.n()).done;){
            var o = (0, n.value)(e, t);
            if (void 0 !== o) return o;
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    var i = WQ(e.state);
    return i.length >= t ? function(e, t, n) {
        var r = t.resolveStack(n), o = r.node.enterUnfinishedNodesBefore(n);
        if (o != r.node) {
            for(var i = [], a = o; a != r.node; a = a.parent)i.push(a);
            for(var s = i.length - 1; s >= 0; s--)r = {
                node: i[s],
                next: r
            };
        }
        return lY(r, e, n);
    }(e, i, t) : null;
}
var sY = function() {
    function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        No(this, e), this.state = t, this.options = n, this.unit = oY(t);
    }
    return Do(e, [
        {
            key: "lineAt",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = this.state.doc.lineAt(e), r = this.options, o = r.simulateBreak, i = r.simulateDoubleBreak;
                return null != o && o >= n.from && o <= n.to ? i && o == e ? {
                    text: "",
                    from: e
                } : (t < 0 ? o < e : o <= e) ? {
                    text: n.text.slice(o - n.from),
                    from: o
                } : {
                    text: n.text.slice(0, o - n.from),
                    from: n.from
                } : n;
            }
        },
        {
            key: "textAfterPos",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                if (this.options.simulateDoubleBreak && e == this.options.simulateBreak) return "";
                var n = this.lineAt(e, t), r = n.text, o = n.from;
                return r.slice(e - o, Math.min(r.length, e + 100 - o));
            }
        },
        {
            key: "column",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = this.lineAt(e, t), r = n.text, o = n.from, i = this.countColumn(r, e - o), a = this.options.overrideIndentation ? this.options.overrideIndentation(o) : -1;
                return a > -1 && (i += a - this.countColumn(r, r.search(/\S|$/))), i;
            }
        },
        {
            key: "countColumn",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.length;
                return BV(e, this.state.tabSize, t);
            }
        },
        {
            key: "lineIndent",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = this.lineAt(e, t), r = n.text, o = n.from, i = this.options.overrideIndentation;
                if (i) {
                    var a = i(o);
                    if (a > -1) return a;
                }
                return this.countColumn(r, r.search(/\S|$/));
            }
        },
        {
            key: "simulatedBreak",
            get: function() {
                return this.options.simulateBreak || null;
            }
        }
    ]), e;
}(), cY = new DG;
function lY(e, t, n) {
    for(var r = e; r; r = r.next){
        var o = uY(r.node);
        if (o) return o(dY.create(t, n, r));
    }
    return 0;
}
function uY(e) {
    var t = e.type.prop(cY);
    if (t) return t;
    var n, r = e.firstChild;
    if (r && (n = r.type.prop(DG.closedBy))) {
        var o = e.lastChild, i = o && n.indexOf(o.name) > -1;
        return function(e) {
            return function(e, t, n, r, o) {
                var i = e.textAfter, a = i.match(/^\s*/)[0].length, s = r && i.slice(a, a + r.length) == r || o == e.pos + a, c = t ? function(e) {
                    var t = e.node, n = t.childAfter(t.from), r = t.lastChild;
                    if (!n) return null;
                    for(var o = e.options.simulateBreak, i = e.state.doc.lineAt(n.from), a = null == o || o <= i.from ? i.to : Math.min(i.to, o), s = n.to;;){
                        var c = t.childAfter(s);
                        if (!c || c == r) return null;
                        if (!c.type.isSkipped) return c.from < a ? n : null;
                        s = c.to;
                    }
                }(e) : null;
                return c ? s ? e.column(c.from) : e.column(c.to) : e.baseIndent + (s ? 0 : e.unit * n);
            }(e, !0, 1, void 0, i && !function(e) {
                return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
            }(e) ? o.from : void 0);
        };
    }
    return null == e.parent ? fY : null;
}
function fY() {
    return 0;
}
var dY = function(e) {
    function t(e, n, r) {
        var o;
        return No(this, t), (o = _o(this, t, [
            e.state,
            e.options
        ])).base = e, o.pos = n, o.context = r, o;
    }
    return Ao(t, sY), Do(t, [
        {
            key: "node",
            get: function() {
                return this.context.node;
            }
        },
        {
            key: "textAfter",
            get: function() {
                return this.textAfterPos(this.pos);
            }
        },
        {
            key: "baseIndent",
            get: function() {
                return this.baseIndentFor(this.node);
            }
        },
        {
            key: "baseIndentFor",
            value: function(e) {
                for(var t = this.state.doc.lineAt(e.from);;){
                    for(var n = e.resolve(t.from); n.parent && n.parent.from == n.from;)n = n.parent;
                    if (hY(n, e)) break;
                    t = this.state.doc.lineAt(n.from);
                }
                return this.lineIndent(t.from);
            }
        },
        {
            key: "continue",
            value: function() {
                return lY(this.context.next, this.base, this.pos);
            }
        }
    ], [
        {
            key: "create",
            value: function(e, n, r) {
                return new t(e, n, r);
            }
        }
    ]), t;
}();
function hY(e, t) {
    for(var n = t; n; n = n.parent)if (e == n) return !0;
    return !1;
}
function vY() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.except, n = e.units, r = void 0 === n ? 1 : n;
    return function(e) {
        var n = t && t.test(e.textAfter);
        return e.baseIndent + (n ? 0 : r * e.unit);
    };
}
var pY = 200;
var mY = NF.define(), gY = new DG;
function yY(e, t, n) {
    var r, o = bo(e.facet(mY));
    try {
        for(o.s(); !(r = o.n()).done;){
            var i = (0, r.value)(e, t, n);
            if (i) return i;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return function(e, t, n) {
        var r = WQ(e);
        if (r.length < n) return null;
        for(var o, i, a = null, s = r.resolveStack(n, 1); s; s = s.next){
            var c = s.node;
            if (!(c.to <= n || c.from > n)) {
                if (a && c.from < t) break;
                var l = c.type.prop(gY);
                if (l && (c.to < r.length - 50 || r.length == e.doc.length || (i = void 0, !(i = (o = c).lastChild) || i.to != o.to || !i.type.isError))) {
                    var u = l(c, e);
                    u && u.from <= n && u.from >= t && u.to > n && (a = u);
                }
            }
        }
        return a;
    }(e, t, n);
}
function bY(e, t) {
    var n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
    return n >= r ? void 0 : {
        from: n,
        to: r
    };
}
var wY = uV.define({
    map: bY
}), xY = uV.define({
    map: bY
});
function kY(e) {
    var t, n = [], r = bo(e.state.selection.ranges);
    try {
        var o = function() {
            var r = t.value.head;
            if (n.some(function(e) {
                return e.from <= r && e.to >= r;
            })) return 1;
            n.push(e.lineBlockAt(r));
        };
        for(r.s(); !(t = r.n()).done;)o();
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    return n;
}
var jY = LF.define({
    create: function() {
        return eW.none;
    },
    update: function(e, t) {
        e = e.map(t.changes);
        var n, r = bo(t.effects);
        try {
            var o = function() {
                var r = n.value;
                if (r.is(wY) && !function(e, t, n) {
                    var r = !1;
                    return e.between(t, t, function(e, o) {
                        e == t && o == n && (r = !0);
                    }), r;
                }(e, r.value.from, r.value.to)) {
                    var o = t.state.facet(MY).preparePlaceholder, i = o ? eW.replace({
                        widget: new TY(o(t.state, r.value))
                    }) : PY;
                    e = e.update({
                        add: [
                            i.range(r.value.from, r.value.to)
                        ]
                    });
                } else r.is(xY) && (e = e.update({
                    filter: function(e, t) {
                        return r.value.from != e || r.value.to != t;
                    },
                    filterFrom: r.value.from,
                    filterTo: r.value.to
                }));
            };
            for(r.s(); !(n = r.n()).done;)o();
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        if (t.selection) {
            var i = !1, a = t.selection.main.head;
            e.between(a, a, function(e, t) {
                e < a && t > a && (i = !0);
            }), i && (e = e.update({
                filterFrom: a,
                filterTo: a,
                filter: function(e, t) {
                    return t <= a || e >= a;
                }
            }));
        }
        return e;
    },
    provide: function(e) {
        return WJ.decorations.from(e);
    },
    toJSON: function(e, t) {
        var n = [];
        return e.between(0, t.doc.length, function(e, t) {
            n.push(e, t);
        }), n;
    },
    fromJSON: function(e) {
        if (!Array.isArray(e) || e.length % 2) throw new RangeError("Invalid JSON for fold state");
        for(var t = [], n = 0; n < e.length;){
            var r = e[n++], o = e[n++];
            if ("number" != typeof r || "number" != typeof o) throw new RangeError("Invalid JSON for fold state");
            t.push(PY.range(r, o));
        }
        return eW.set(t, !0);
    }
});
function SY(e, t, n) {
    var r, o = null;
    return null === (r = e.field(jY, !1)) || void 0 === r || r.between(t, n, function(e, t) {
        (!o || o.from > e) && (o = {
            from: e,
            to: t
        });
    }), o;
}
function CY(e, t) {
    return e.field(jY, !1) ? t : t.concat(uV.appendConfig.of(EY()));
}
function $Y(e, t) {
    var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = e.state.doc.lineAt(t.from).number, o = e.state.doc.lineAt(t.to).number;
    return WJ.announce.of("".concat(e.state.phrase(n ? "Folded lines" : "Unfolded lines"), " ").concat(r, " ").concat(e.state.phrase("to"), " ").concat(o, "."));
}
var _Y = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: function(e) {
            var t, n = bo(kY(e));
            try {
                for(n.s(); !(t = n.n()).done;){
                    var r = t.value, o = yY(e.state, r.from, r.to);
                    if (o) return e.dispatch({
                        effects: CY(e.state, [
                            wY.of(o),
                            $Y(e, o)
                        ])
                    }), !0;
                }
            } catch (e) {
                n.e(e);
            } finally{
                n.f();
            }
            return !1;
        }
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: function(e) {
            if (!e.state.field(jY, !1)) return !1;
            var t, n = [], r = bo(kY(e));
            try {
                for(r.s(); !(t = r.n()).done;){
                    var o = t.value, i = SY(e.state, o.from, o.to);
                    i && n.push(xY.of(i), $Y(e, i, !1));
                }
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
            return n.length && e.dispatch({
                effects: n
            }), n.length > 0;
        }
    },
    {
        key: "Ctrl-Alt-[",
        run: function(e) {
            for(var t = e.state, n = [], r = 0; r < t.doc.length;){
                var o = e.lineBlockAt(r), i = yY(t, o.from, o.to);
                i && n.push(wY.of(i)), r = (i ? e.lineBlockAt(i.to) : o).to + 1;
            }
            return n.length && e.dispatch({
                effects: CY(e.state, n)
            }), !!n.length;
        }
    },
    {
        key: "Ctrl-Alt-]",
        run: function(e) {
            var t = e.state.field(jY, !1);
            if (!t || !t.size) return !1;
            var n = [];
            return t.between(0, e.state.doc.length, function(e, t) {
                n.push(xY.of({
                    from: e,
                    to: t
                }));
            }), e.dispatch({
                effects: n
            }), !0;
        }
    }
], OY = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
}, MY = NF.define({
    combine: function(e) {
        return jV(e, OY);
    }
});
function EY(e) {
    var t = [
        jY,
        DY
    ];
    return e && t.push(MY.of(e)), t;
}
function AY(e, t) {
    var n = e.state, r = n.facet(MY), o = function(t) {
        var n = e.lineBlockAt(e.posAtDOM(t.target)), r = SY(e.state, n.from, n.to);
        r && e.dispatch({
            effects: xY.of(r)
        }), t.preventDefault();
    };
    if (r.placeholderDOM) return r.placeholderDOM(e, o, t);
    var i = document.createElement("span");
    return i.textContent = r.placeholderText, i.setAttribute("aria-label", n.phrase("folded code")), i.title = n.phrase("unfold"), i.className = "cm-foldPlaceholder", i.onclick = o, i;
}
var PY = eW.replace({
    widget: new (function(e) {
        function t() {
            return No(this, t), _o(this, t, arguments);
        }
        return Ao(t, XH), Do(t, [
            {
                key: "toDOM",
                value: function(e) {
                    return AY(e, null);
                }
            }
        ]), t;
    }())
}), TY = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).value = e, n;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return this.value == e.value;
            }
        },
        {
            key: "toDOM",
            value: function(e) {
                return AY(e, this.value);
            }
        }
    ]), t;
}(), RY = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: function() {
        return !1;
    }
}, NY = function(e) {
    function t(e, n) {
        var r;
        return No(this, t), (r = _o(this, t)).config = e, r.open = n, r;
    }
    return Ao(t, hG), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return this.config == e.config && this.open == e.open;
            }
        },
        {
            key: "toDOM",
            value: function(e) {
                if (this.config.markerDOM) return this.config.markerDOM(this.open);
                var t = document.createElement("span");
                return t.textContent = this.open ? this.config.openText : this.config.closedText, t.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), t;
            }
        }
    ]), t;
}();
function IY() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign(Object.assign({}, RY), e), n = new NY(t, !0), r = new NY(t, !1), o = KW.fromClass(function() {
        function e(t) {
            No(this, e), this.from = t.viewport.from, this.markers = this.buildMarkers(t);
        }
        return Do(e, [
            {
                key: "update",
                value: function(e) {
                    (e.docChanged || e.viewportChanged || e.startState.facet(eY) != e.state.facet(eY) || e.startState.field(jY, !1) != e.state.field(jY, !1) || WQ(e.startState) != WQ(e.state) || t.foldingChanged(e)) && (this.markers = this.buildMarkers(e.view));
                }
            },
            {
                key: "buildMarkers",
                value: function(e) {
                    var t, o = new MV, i = bo(e.viewportLineBlocks);
                    try {
                        for(i.s(); !(t = i.n()).done;){
                            var a = t.value, s = SY(e.state, a.from, a.to) ? r : yY(e.state, a.from, a.to) ? n : null;
                            s && o.add(a.from, a.from, s);
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    return o.finish();
                }
            }
        ]), e;
    }()), i = t.domEventHandlers;
    return [
        o,
        gG({
            class: "cm-foldGutter",
            markers: function(e) {
                var t;
                return (null === (t = e.plugin(o)) || void 0 === t ? void 0 : t.markers) || OV.empty;
            },
            initialSpacer: function() {
                return new NY(t, !1);
            },
            domEventHandlers: Object.assign(Object.assign({}, i), {
                click: function(e, t, n) {
                    if (i.click && i.click(e, t, n)) return !0;
                    var r = SY(e.state, t.from, t.to);
                    if (r) return e.dispatch({
                        effects: xY.of(r)
                    }), !0;
                    var o = yY(e.state, t.from, t.to);
                    return !!o && (e.dispatch({
                        effects: wY.of(o)
                    }), !0);
                }
            })
        }),
        EY()
    ];
}
var DY = WJ.baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
}), zY = function() {
    function e(t, n) {
        var r;
        function o(e) {
            var t = WV.newName();
            return (r || (r = Object.create(null)))["." + t] = e, t;
        }
        No(this, e), this.specs = t;
        var i = "string" == typeof n.all ? n.all : n.all ? o(n.all) : void 0, a = n.scope;
        this.scope = a instanceof FQ ? function(e) {
            return e.prop(BQ) == a.data;
        } : a ? function(e) {
            return e == a;
        } : void 0, this.style = wQ(t.map(function(e) {
            return {
                tag: e.tag,
                class: e.class || o(Object.assign({}, e, {
                    tag: null
                }))
            };
        }), {
            all: i
        }).style, this.module = r ? new WV(r) : null, this.themeType = n.themeType;
    }
    return Do(e, null, [
        {
            key: "define",
            value: function(t, n) {
                return new e(t, n || {});
            }
        }
    ]), e;
}(), qY = NF.define(), BY = NF.define({
    combine: function(e) {
        return e.length ? [
            e[0]
        ] : null;
    }
});
function LY(e) {
    var t = e.facet(qY);
    return t.length ? t : e.facet(BY);
}
function FY(e, t) {
    var n, r = [
        HY
    ];
    return e instanceof zY && (e.module && r.push(WJ.styleModule.of(e.module)), n = e.themeType), (null == t ? void 0 : t.fallback) ? r.push(BY.of(e)) : n ? r.push(qY.computeN([
        WJ.darkTheme
    ], function(t) {
        return t.facet(WJ.darkTheme) == ("dark" == n) ? [
            e
        ] : [];
    })) : r.push(qY.of(e)), r;
}
var VY = function() {
    function e(t) {
        No(this, e), this.markCache = Object.create(null), this.tree = WQ(t.state), this.decorations = this.buildDeco(t, LY(t.state)), this.decoratedTo = t.viewport.to;
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = WQ(e.state), n = LY(e.state), r = n != LY(e.startState), o = e.view.viewport, i = e.changes.mapPos(this.decoratedTo, 1);
                t.length < o.to && !r && t.type == this.tree.type && i >= o.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = i) : (t != this.tree || e.viewportChanged || r) && (this.tree = t, this.decorations = this.buildDeco(e.view, n), this.decoratedTo = o.to);
            }
        },
        {
            key: "buildDeco",
            value: function(e, t) {
                var n = this;
                if (!t || !this.tree.length) return eW.none;
                var r, o = new MV, i = bo(e.visibleRanges);
                try {
                    for(i.s(); !(r = i.n()).done;){
                        var a = r.value, s = a.from, c = a.to;
                        xQ(this.tree, t, function(e, t, r) {
                            o.add(e, t, n.markCache[r] || (n.markCache[r] = eW.mark({
                                class: r
                            })));
                        }, s, c);
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return o.finish();
            }
        }
    ]), e;
}(), HY = JF.high(KW.fromClass(VY, {
    decorations: function(e) {
        return e.decorations;
    }
})), WY = zY.define([
    {
        tag: qQ.meta,
        color: "#404740"
    },
    {
        tag: qQ.link,
        textDecoration: "underline"
    },
    {
        tag: qQ.heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: qQ.emphasis,
        fontStyle: "italic"
    },
    {
        tag: qQ.strong,
        fontWeight: "bold"
    },
    {
        tag: qQ.strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: qQ.keyword,
        color: "#708"
    },
    {
        tag: [
            qQ.atom,
            qQ.bool,
            qQ.url,
            qQ.contentSeparator,
            qQ.labelName
        ],
        color: "#219"
    },
    {
        tag: [
            qQ.literal,
            qQ.inserted
        ],
        color: "#164"
    },
    {
        tag: [
            qQ.string,
            qQ.deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            qQ.regexp,
            qQ.escape,
            qQ.special(qQ.string)
        ],
        color: "#e40"
    },
    {
        tag: qQ.definition(qQ.variableName),
        color: "#00f"
    },
    {
        tag: qQ.local(qQ.variableName),
        color: "#30a"
    },
    {
        tag: [
            qQ.typeName,
            qQ.namespace
        ],
        color: "#085"
    },
    {
        tag: qQ.className,
        color: "#167"
    },
    {
        tag: [
            qQ.special(qQ.variableName),
            qQ.macroName
        ],
        color: "#256"
    },
    {
        tag: qQ.definition(qQ.propertyName),
        color: "#00c"
    },
    {
        tag: qQ.comment,
        color: "#940"
    },
    {
        tag: qQ.invalid,
        color: "#f00"
    }
]), UY = WJ.baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
}), JY = 1e4, KY = "()[]{}", GY = NF.define({
    combine: function(e) {
        return jV(e, {
            afterCursor: !0,
            brackets: KY,
            maxScanDistance: JY,
            renderMatch: XY
        });
    }
}), QY = eW.mark({
    class: "cm-matchingBracket"
}), YY = eW.mark({
    class: "cm-nonmatchingBracket"
});
function XY(e) {
    var t = [], n = e.matched ? QY : YY;
    return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
var ZY = LF.define({
    create: function() {
        return eW.none;
    },
    update: function(e, t) {
        if (!t.docChanged && !t.selection) return e;
        var n, r = [], o = t.state.facet(GY), i = bo(t.state.selection.ranges);
        try {
            for(i.s(); !(n = i.n()).done;){
                var a = n.value;
                if (a.empty) {
                    var s = iX(t.state, a.head, -1, o) || a.head > 0 && iX(t.state, a.head - 1, 1, o) || o.afterCursor && (iX(t.state, a.head, 1, o) || a.head < t.state.doc.length && iX(t.state, a.head + 1, -1, o));
                    s && (r = r.concat(o.renderMatch(s, t.state)));
                }
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        return eW.set(r, !0);
    },
    provide: function(e) {
        return WJ.decorations.from(e);
    }
}), eX = [
    ZY,
    UY
];
function tX() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        GY.of(e),
        eX
    ];
}
var nX = new DG;
function rX(e, t, n) {
    var r = e.prop(t < 0 ? DG.openedBy : DG.closedBy);
    if (r) return r;
    if (1 == e.name.length) {
        var o = n.indexOf(e.name);
        if (o > -1 && o % 2 == (t < 0 ? 1 : 0)) return [
            n[o + t]
        ];
    }
    return null;
}
function oX(e) {
    var t = e.type.prop(nX);
    return t ? t(e.node) : e;
}
function iX(e, t, n) {
    for(var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = r.maxScanDistance || JY, i = r.brackets || KY, a = WQ(e), s = a.resolveInner(t, n), c = s; c; c = c.parent){
        var l = rX(c.type, n, i);
        if (l && c.from < c.to) {
            var u = oX(c);
            if (u && (n > 0 ? t >= u.from && t < u.to : t > u.from && t <= u.to)) return aX(e, t, n, c, u, l, i);
        }
    }
    return function(e, t, n, r, o, i, a) {
        var s = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1), c = a.indexOf(s);
        if (c < 0 || c % 2 == 0 != n > 0) return null;
        for(var l = {
            from: n < 0 ? t - 1 : t,
            to: n > 0 ? t + 1 : t
        }, u = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), f = 0, d = 0; !u.next().done && d <= i;){
            var h = u.value;
            n < 0 && (d += h.length);
            for(var v = t + d * n, p = n > 0 ? 0 : h.length - 1, m = n > 0 ? h.length : -1; p != m; p += n){
                var g = a.indexOf(h[p]);
                if (!(g < 0 || r.resolveInner(v + p, 1).type != o)) {
                    if (g % 2 == 0 == n > 0) f++;
                    else {
                        if (1 == f) return {
                            start: l,
                            end: {
                                from: v + p,
                                to: v + p + 1
                            },
                            matched: g >> 1 == c >> 1
                        };
                        f--;
                    }
                }
            }
            n > 0 && (d += h.length);
        }
        return u.done ? {
            start: l,
            matched: !1
        } : null;
    }(e, t, n, a, s.type, o, i);
}
function aX(e, t, n, r, o, i, a) {
    var s = r.parent, c = {
        from: o.from,
        to: o.to
    }, l = 0, u = null == s ? void 0 : s.cursor();
    if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to))) do if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (0 == l && i.indexOf(u.type.name) > -1 && u.from < u.to) {
            var f = oX(u);
            return {
                start: c,
                end: f ? {
                    from: f.from,
                    to: f.to
                } : void 0,
                matched: !0
            };
        }
        if (rX(u.type, n, a)) l++;
        else if (rX(u.type, -n, a)) {
            if (0 == l) {
                var d = oX(u);
                return {
                    start: c,
                    end: d && d.from < d.to ? {
                        from: d.from,
                        to: d.to
                    } : void 0,
                    matched: !1
                };
            }
            l--;
        }
    }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
    return {
        start: c,
        matched: !1
    };
}
for(var sX = Object.create(null), cX = [
    BG.none
], lX = [], uX = Object.create(null), fX = Object.create(null), dX = 0, hX = [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
]; dX < hX.length; dX++){
    var vX = jo(hX[dX], 2), pX = vX[0], mX = vX[1];
    fX[pX] = yX(sX, mX);
}
function gX(e, t) {
    lX.indexOf(e) > -1 || (lX.push(e), console.warn(t));
}
function yX(e, t) {
    var n, r = [], o = bo(t.split(" "));
    try {
        for(o.s(); !(n = o.n()).done;){
            var i, a = n.value, s = [], c = bo(a.split("."));
            try {
                for(c.s(); !(i = c.n()).done;){
                    var l = i.value, u = e[l] || qQ[l];
                    u ? "function" == typeof u ? s.length ? s = s.map(u) : gX(l, "Modifier ".concat(l, " used at start of tag")) : s.length ? gX(l, "Tag ".concat(l, " used as modifier")) : s = Array.isArray(u) ? u : [
                        u
                    ] : gX(l, "Unknown highlighting tag ".concat(l));
                }
            } catch (e) {
                c.e(e);
            } finally{
                c.f();
            }
            var f, d = bo(s);
            try {
                for(d.s(); !(f = d.n()).done;){
                    var h = f.value;
                    r.push(h);
                }
            } catch (e) {
                d.e(e);
            } finally{
                d.f();
            }
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    if (!r.length) return 0;
    var v = t.replace(/ /g, "_"), p = v + " " + r.map(function(e) {
        return e.id;
    }), m = uX[p];
    if (m) return m.id;
    var g = uX[p] = BG.define({
        id: cX.length,
        name: v,
        props: [
            gQ(zo({}, v, r))
        ]
    });
    return cX.push(g), g.id;
}
lW.RTL, lW.LTR;
function bX(e, t) {
    return function(n) {
        var r = n.state, o = n.dispatch;
        if (r.readOnly) return !1;
        var i = e(t, r);
        return !!i && (o(r.update(i)), !0);
    };
}
var wX = bX($X, 0), xX = bX(CX, 0), kX = bX(function(e, t) {
    return CX(e, t, function(e) {
        var t, n = [], r = bo(e.selection.ranges);
        try {
            for(r.s(); !(t = r.n()).done;){
                var o = t.value, i = e.doc.lineAt(o.from), a = o.to <= i.to ? i : e.doc.lineAt(o.to), s = n.length - 1;
                s >= 0 && n[s].to > i.from ? n[s].to = a.to : n.push({
                    from: i.from + /^\s*/.exec(i.text)[0].length,
                    to: a.to
                });
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        return n;
    }(t));
}, 0);
function jX(e, t) {
    var n = e.languageDataAt("commentTokens", t);
    return n.length ? n[0] : {};
}
var SX = 50;
function CX(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.selection.ranges, r = n.map(function(e) {
        return jX(t, e.from).block;
    });
    if (!r.every(function(e) {
        return e;
    })) return null;
    var o = n.map(function(e, n) {
        return function(e, t, n, r) {
            var o, i, a = t.open, s = t.close, c = e.sliceDoc(n - SX, n), l = e.sliceDoc(r, r + SX), u = /\s*$/.exec(c)[0].length, f = /^\s*/.exec(l)[0].length, d = c.length - u;
            if (c.slice(d - a.length, d) == a && l.slice(f, f + s.length) == s) return {
                open: {
                    pos: n - u,
                    margin: u && 1
                },
                close: {
                    pos: r + f,
                    margin: f && 1
                }
            };
            r - n <= 2 * SX ? o = i = e.sliceDoc(n, r) : (o = e.sliceDoc(n, n + SX), i = e.sliceDoc(r - SX, r));
            var h = /^\s*/.exec(o)[0].length, v = /\s*$/.exec(i)[0].length, p = i.length - v - s.length;
            return o.slice(h, h + a.length) == a && i.slice(p, p + s.length) == s ? {
                open: {
                    pos: n + h + a.length,
                    margin: /\s/.test(o.charAt(h + a.length)) ? 1 : 0
                },
                close: {
                    pos: r - v - s.length,
                    margin: /\s/.test(i.charAt(p - 1)) ? 1 : 0
                }
            } : null;
        }(t, r[n], e.from, e.to);
    });
    if (2 != e && !o.every(function(e) {
        return e;
    })) return {
        changes: t.changes(n.map(function(e, t) {
            return o[t] ? [] : [
                {
                    from: e.from,
                    insert: r[t].open + " "
                },
                {
                    from: e.to,
                    insert: " " + r[t].close
                }
            ];
        }))
    };
    if (1 != e && o.some(function(e) {
        return e;
    })) {
        for(var i, a = [], s = 0; s < o.length; s++)if (i = o[s]) {
            var c = r[s], l = i, u = l.open, f = l.close;
            a.push({
                from: u.pos - c.open.length,
                to: u.pos + u.margin
            }, {
                from: f.pos - f.margin,
                to: f.pos + c.close.length
            });
        }
        return {
            changes: a
        };
    }
    return null;
}
function $X(e, t) {
    var n, r = [], o = -1, i = bo(arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.selection.ranges);
    try {
        for(i.s(); !(n = i.n()).done;){
            var a = n.value, s = a.from, c = a.to, l = r.length, u = 1e9, f = jX(t, s).line;
            if (f) {
                for(var d = s; d <= c;){
                    var h = t.doc.lineAt(d);
                    if (h.from > o && (s == c || c > h.from)) {
                        o = h.from;
                        var v = /^\s*/.exec(h.text)[0].length, p = v == h.length, m = h.text.slice(v, v + f.length) == f ? v : -1;
                        v < h.text.length && v < u && (u = v), r.push({
                            line: h,
                            comment: m,
                            token: f,
                            indent: v,
                            empty: p,
                            single: !1
                        });
                    }
                    d = h.to + 1;
                }
                if (u < 1e9) for(var g = l; g < r.length; g++)r[g].indent < r[g].line.text.length && (r[g].indent = u);
                r.length == l + 1 && (r[l].single = !0);
            }
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    if (2 != e && r.some(function(e) {
        return e.comment < 0 && (!e.empty || e.single);
    })) {
        var y, b = [], w = bo(r);
        try {
            for(w.s(); !(y = w.n()).done;){
                var x = y.value, k = x.line, j = x.token, S = x.indent, C = x.empty;
                !x.single && C || b.push({
                    from: k.from + S,
                    insert: j + " "
                });
            }
        } catch (e) {
            w.e(e);
        } finally{
            w.f();
        }
        var $ = t.changes(b);
        return {
            changes: $,
            selection: t.selection.map($, 1)
        };
    }
    if (1 != e && r.some(function(e) {
        return e.comment >= 0;
    })) {
        var _, O = [], M = bo(r);
        try {
            for(M.s(); !(_ = M.n()).done;){
                var E = _.value, A = E.line, P = E.comment, T = E.token;
                if (P >= 0) {
                    var R = A.from + P, N = R + T.length;
                    " " == A.text[N - A.from] && N++, O.push({
                        from: R,
                        to: N
                    });
                }
            }
        } catch (e) {
            M.e(e);
        } finally{
            M.f();
        }
        return {
            changes: O
        };
    }
    return null;
}
var _X = sV.define(), OX = sV.define(), MX = NF.define(), EX = NF.define({
    combine: function(e) {
        return jV(e, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: function(e, t) {
                return t;
            }
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: function(e, t) {
                return function(n, r) {
                    return e(n, r) || t(n, r);
                };
            }
        });
    }
}), AX = LF.define({
    create: function() {
        return YX.empty;
    },
    update: function(e, t) {
        var n = t.state.facet(EX), r = t.annotation(_X);
        if (r) {
            var o = LX.fromTransaction(t, r.selection), i = r.side, a = 0 == i ? e.undone : e.done;
            return a = o ? FX(a, a.length, n.minDepth, o) : UX(a, t.startState.selection), new YX(0 == i ? r.rest : a, 0 == i ? a : r.rest);
        }
        var s = t.annotation(OX);
        if ("full" != s && "before" != s || (e = e.isolate()), !1 === t.annotation(fV.addToHistory)) return t.changes.empty ? e : e.addMapping(t.changes.desc);
        var c = LX.fromTransaction(t), l = t.annotation(fV.time), u = t.annotation(fV.userEvent);
        return c ? e = e.addChanges(c, l, u, n, t) : t.selection && (e = e.addSelection(t.startState.selection, l, u, n.newGroupDelay)), "full" != s && "after" != s || (e = e.isolate()), e;
    },
    toJSON: function(e) {
        return {
            done: e.done.map(function(e) {
                return e.toJSON();
            }),
            undone: e.undone.map(function(e) {
                return e.toJSON();
            })
        };
    },
    fromJSON: function(e) {
        return new YX(e.done.map(LX.fromJSON), e.undone.map(LX.fromJSON));
    }
});
function PX() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        AX,
        EX.of(e),
        WJ.domEventHandlers({
            beforeinput: function(e, t) {
                var n = "historyUndo" == e.inputType ? RX : "historyRedo" == e.inputType ? NX : null;
                return !!n && (e.preventDefault(), n(t));
            }
        })
    ];
}
function TX(e, t) {
    return function(n) {
        var r = n.state, o = n.dispatch;
        if (!t && r.readOnly) return !1;
        var i = r.field(AX, !1);
        if (!i) return !1;
        var a = i.pop(e, r, t);
        return !!a && (o(a), !0);
    };
}
var RX = TX(0, !1), NX = TX(1, !1), IX = TX(0, !0), DX = TX(1, !0);
function zX(e) {
    return function(t) {
        var n = t.field(AX, !1);
        if (!n) return 0;
        var r = 0 == e ? n.done : n.undone;
        return r.length - (r.length && !r[0].changes ? 1 : 0);
    };
}
var qX = zX(0), BX = zX(1), LX = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.changes = t, this.effects = n, this.mapped = r, this.startSelection = o, this.selectionsAfter = i;
    }
    return Do(e, [
        {
            key: "setSelAfter",
            value: function(t) {
                return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
            }
        },
        {
            key: "toJSON",
            value: function() {
                var e, t, n;
                return {
                    changes: null === (e = this.changes) || void 0 === e ? void 0 : e.toJSON(),
                    mapped: null === (t = this.mapped) || void 0 === t ? void 0 : t.toJSON(),
                    startSelection: null === (n = this.startSelection) || void 0 === n ? void 0 : n.toJSON(),
                    selectionsAfter: this.selectionsAfter.map(function(e) {
                        return e.toJSON();
                    })
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(t) {
                return new e(t.changes && SF.fromJSON(t.changes), [], t.mapped && jF.fromJSON(t.mapped), t.startSelection && PF.fromJSON(t.startSelection), t.selectionsAfter.map(PF.fromJSON));
            }
        },
        {
            key: "fromTransaction",
            value: function(t, n) {
                var r, o = HX, i = bo(t.startState.facet(MX));
                try {
                    for(i.s(); !(r = i.n()).done;){
                        var a = (0, r.value)(t);
                        a.length && (o = o.concat(a));
                    }
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return !o.length && t.changes.empty ? null : new e(t.changes.invert(t.startState.doc), o, void 0, n || t.startState.selection, HX);
            }
        },
        {
            key: "selection",
            value: function(t) {
                return new e(void 0, HX, void 0, void 0, t);
            }
        }
    ]), e;
}();
function FX(e, t, n, r) {
    var o = t + 1 > n + 20 ? t - n - 1 : 0, i = e.slice(o, t);
    return i.push(r), i;
}
function VX(e, t) {
    return e.length ? t.length ? e.concat(t) : e : t;
}
var HX = [], WX = 200;
function UX(e, t) {
    if (e.length) {
        var n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - WX));
        return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), FX(e, e.length - 1, 1e9, n.setSelAfter(r)));
    }
    return [
        LX.selection([
            t
        ])
    ];
}
function JX(e) {
    var t = e[e.length - 1], n = e.slice();
    return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function KX(e, t) {
    if (!e.length) return e;
    for(var n = e.length, r = HX; n;){
        var o = GX(e[n - 1], t, r);
        if (o.changes && !o.changes.empty || o.effects.length) {
            var i = e.slice(0, n);
            return i[n - 1] = o, i;
        }
        t = o.mapped, n--, r = o.selectionsAfter;
    }
    return r.length ? [
        LX.selection(r)
    ] : HX;
}
function GX(e, t, n) {
    var r = VX(e.selectionsAfter.length ? e.selectionsAfter.map(function(e) {
        return e.map(t);
    }) : HX, n);
    if (!e.changes) return LX.selection(r);
    var o = e.changes.map(t), i = t.mapDesc(e.changes, !0), a = e.mapped ? e.mapped.composeDesc(i) : i;
    return new LX(o, uV.mapEffects(e.effects, t), a, e.startSelection.map(i), r);
}
var QX = /^(input\.type|delete)($|\.)/, YX = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : void 0;
        No(this, e), this.done = t, this.undone = n, this.prevTime = r, this.prevUserEvent = o;
    }
    return Do(e, [
        {
            key: "isolate",
            value: function() {
                return this.prevTime ? new e(this.done, this.undone) : this;
            }
        },
        {
            key: "addChanges",
            value: function(t, n, r, o, i) {
                var a = this.done, s = a[a.length - 1];
                return a = s && s.changes && !s.changes.empty && t.changes && (!r || QX.test(r)) && (!s.selectionsAfter.length && n - this.prevTime < o.newGroupDelay && o.joinToEvent(i, function(e, t) {
                    var n = [], r = !1;
                    return e.iterChangedRanges(function(e, t) {
                        return n.push(e, t);
                    }), t.iterChangedRanges(function(e, t, o, i) {
                        for(var a = 0; a < n.length;){
                            var s = n[a++], c = n[a++];
                            i >= s && o <= c && (r = !0);
                        }
                    }), r;
                }(s.changes, t.changes)) || "input.type.compose" == r) ? FX(a, a.length - 1, o.minDepth, new LX(t.changes.compose(s.changes), VX(t.effects, s.effects), s.mapped, s.startSelection, HX)) : FX(a, a.length, o.minDepth, t), new e(a, HX, n, r);
            }
        },
        {
            key: "addSelection",
            value: function(t, n, r, o) {
                var i, a, s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : HX;
                return s.length > 0 && n - this.prevTime < o && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && (i = s[s.length - 1], a = t, i.ranges.length == a.ranges.length && 0 === i.ranges.filter(function(e, t) {
                    return e.empty != a.ranges[t].empty;
                }).length) ? this : new e(UX(this.done, t), this.undone, n, r);
            }
        },
        {
            key: "addMapping",
            value: function(t) {
                return new e(KX(this.done, t), KX(this.undone, t), this.prevTime, this.prevUserEvent);
            }
        },
        {
            key: "pop",
            value: function(e, t, n) {
                var r = 0 == e ? this.done : this.undone;
                if (0 == r.length) return null;
                var o = r[r.length - 1], i = o.selectionsAfter[0] || t.selection;
                if (n && o.selectionsAfter.length) return t.update({
                    selection: o.selectionsAfter[o.selectionsAfter.length - 1],
                    annotations: _X.of({
                        side: e,
                        rest: JX(r),
                        selection: i
                    }),
                    userEvent: 0 == e ? "select.undo" : "select.redo",
                    scrollIntoView: !0
                });
                if (o.changes) {
                    var a = 1 == r.length ? HX : r.slice(0, r.length - 1);
                    return o.mapped && (a = KX(a, o.mapped)), t.update({
                        changes: o.changes,
                        selection: o.startSelection,
                        effects: o.effects,
                        annotations: _X.of({
                            side: e,
                            rest: a,
                            selection: i
                        }),
                        filter: !1,
                        userEvent: 0 == e ? "undo" : "redo",
                        scrollIntoView: !0
                    });
                }
                return null;
            }
        }
    ]), e;
}();
YX.empty = new YX(HX, HX);
var XX = [
    {
        key: "Mod-z",
        run: RX,
        preventDefault: !0
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: NX,
        preventDefault: !0
    },
    {
        linux: "Ctrl-Shift-z",
        run: NX,
        preventDefault: !0
    },
    {
        key: "Mod-u",
        run: IX,
        preventDefault: !0
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: DX,
        preventDefault: !0
    }
];
function ZX(e, t) {
    return PF.create(e.ranges.map(t), e.mainIndex);
}
function eZ(e, t) {
    return e.update({
        selection: t,
        scrollIntoView: !0,
        userEvent: "select"
    });
}
function tZ(e, t) {
    var n = e.state, r = e.dispatch, o = ZX(n.selection, t);
    return !o.eq(n.selection, !0) && (r(eZ(n, o)), !0);
}
function nZ(e, t) {
    return PF.cursor(t ? e.to : e.from);
}
function rZ(e, t) {
    return tZ(e, function(n) {
        return n.empty ? e.moveByChar(n, t) : nZ(n, t);
    });
}
function oZ(e) {
    return e.textDirectionAt(e.state.selection.main.head) == lW.LTR;
}
var iZ = function(e) {
    return rZ(e, !oZ(e));
}, aZ = function(e) {
    return rZ(e, oZ(e));
};
function sZ(e, t) {
    return tZ(e, function(n) {
        return n.empty ? e.moveByGroup(n, t) : nZ(n, t);
    });
}
function cZ(e, t, n) {
    if (t.type.prop(n)) return !0;
    var r = t.to - t.from;
    return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function lZ(e, t, n) {
    for(var r = WQ(e).resolveInner(t.head), o = n ? DG.closedBy : DG.openedBy, i = t.head;;){
        var a = n ? r.childAfter(i) : r.childBefore(i);
        if (!a) break;
        cZ(e, a, o) ? r = a : i = n ? a.to : a.from;
    }
    var s, c;
    return c = r.type.prop(o) && (s = n ? iX(e, r.from, 1) : iX(e, r.to, -1)) && s.matched ? n ? s.end.to : s.end.from : n ? r.to : r.from, PF.cursor(c, n ? -1 : 1);
}
function uZ(e, t) {
    return tZ(e, function(n) {
        if (!n.empty) return nZ(n, t);
        var r = e.moveVertically(n, t);
        return r.head != n.head ? r : e.moveToLineBoundary(n, t);
    });
}
var fZ = function(e) {
    return uZ(e, !1);
}, dZ = function(e) {
    return uZ(e, !0);
};
function hZ(e) {
    var t, n = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2, r = 0, o = 0;
    if (n) {
        var i, a = bo(e.state.facet(WJ.scrollMargins));
        try {
            for(a.s(); !(i = a.n()).done;){
                var s = (0, i.value)(e);
                (null == s ? void 0 : s.top) && (r = Math.max(null == s ? void 0 : s.top, r)), (null == s ? void 0 : s.bottom) && (o = Math.max(null == s ? void 0 : s.bottom, o));
            }
        } catch (e) {
            a.e(e);
        } finally{
            a.f();
        }
        t = e.scrollDOM.clientHeight - r - o;
    } else t = (e.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: r,
        marginBottom: o,
        selfScroll: n,
        height: Math.max(e.defaultLineHeight, t - 5)
    };
}
function vZ(e, t) {
    var n, r = hZ(e), o = e.state, i = ZX(o.selection, function(n) {
        return n.empty ? e.moveVertically(n, t, r.height) : nZ(n, t);
    });
    if (i.eq(o.selection)) return !1;
    if (r.selfScroll) {
        var a = e.coordsAtPos(o.selection.main.head), s = e.scrollDOM.getBoundingClientRect(), c = s.top + r.marginTop, l = s.bottom - r.marginBottom;
        a && a.top > c && a.bottom < l && (n = WJ.scrollIntoView(i.main.head, {
            y: "start",
            yMargin: a.top - c
        }));
    }
    return e.dispatch(eZ(o, i), {
        effects: n
    }), !0;
}
var pZ = function(e) {
    return vZ(e, !1);
}, mZ = function(e) {
    return vZ(e, !0);
};
function gZ(e, t, n) {
    var r = e.lineBlockAt(t.head), o = e.moveToLineBoundary(t, n);
    if (o.head == t.head && o.head != (n ? r.to : r.from) && (o = e.moveToLineBoundary(t, n, !1)), !n && o.head == r.from && r.length) {
        var i = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
        i && t.head != r.from + i && (o = PF.cursor(r.from + i));
    }
    return o;
}
function yZ(e, t) {
    var n = ZX(e.state.selection, function(e) {
        var n = t(e);
        return PF.range(e.anchor, n.head, n.goalColumn, n.bidiLevel || void 0);
    });
    return !n.eq(e.state.selection) && (e.dispatch(eZ(e.state, n)), !0);
}
function bZ(e, t) {
    return yZ(e, function(n) {
        return e.moveByChar(n, t);
    });
}
var wZ = function(e) {
    return bZ(e, !oZ(e));
}, xZ = function(e) {
    return bZ(e, oZ(e));
};
function kZ(e, t) {
    return yZ(e, function(n) {
        return e.moveByGroup(n, t);
    });
}
function jZ(e, t) {
    return yZ(e, function(n) {
        return e.moveVertically(n, t);
    });
}
var SZ = function(e) {
    return jZ(e, !1);
}, CZ = function(e) {
    return jZ(e, !0);
};
function $Z(e, t) {
    return yZ(e, function(n) {
        return e.moveVertically(n, t, hZ(e).height);
    });
}
var _Z = function(e) {
    return $Z(e, !1);
}, OZ = function(e) {
    return $Z(e, !0);
}, MZ = function(e) {
    var t = e.state;
    return (0, e.dispatch)(eZ(t, {
        anchor: 0
    })), !0;
}, EZ = function(e) {
    var t = e.state;
    return (0, e.dispatch)(eZ(t, {
        anchor: t.doc.length
    })), !0;
}, AZ = function(e) {
    var t = e.state;
    return (0, e.dispatch)(eZ(t, {
        anchor: t.selection.main.anchor,
        head: 0
    })), !0;
}, PZ = function(e) {
    var t = e.state;
    return (0, e.dispatch)(eZ(t, {
        anchor: t.selection.main.anchor,
        head: t.doc.length
    })), !0;
};
function TZ(e, t) {
    if (e.state.readOnly) return !1;
    var n = "delete.selection", r = e.state, o = r.changeByRange(function(r) {
        var o = r.from, i = r.to;
        if (o == i) {
            var a = t(r);
            a < o ? (n = "delete.backward", a = RZ(e, a, !1)) : a > o && (n = "delete.forward", a = RZ(e, a, !0)), o = Math.min(o, a), i = Math.max(i, a);
        } else o = RZ(e, o, !1), i = RZ(e, i, !0);
        return o == i ? {
            range: r
        } : {
            changes: {
                from: o,
                to: i
            },
            range: PF.cursor(o, o < r.head ? -1 : 1)
        };
    });
    return !o.changes.empty && (e.dispatch(r.update(o, {
        scrollIntoView: !0,
        userEvent: n,
        effects: "delete.selection" == n ? WJ.announce.of(r.phrase("Selection deleted")) : void 0
    })), !0);
}
function RZ(e, t, n) {
    if (e instanceof WJ) {
        var r, o = bo(e.state.facet(WJ.atomicRanges).map(function(t) {
            return t(e);
        }));
        try {
            for(o.s(); !(r = o.n()).done;)r.value.between(t, t, function(e, r) {
                e < t && r > t && (t = n ? r : e);
            });
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
    }
    return t;
}
var NZ = function(e, t) {
    return TZ(e, function(n) {
        var r, o, i = n.from, a = e.state, s = a.doc.lineAt(i);
        if (!t && i > s.from && i < s.from + 200 && !/[^ \t]/.test(r = s.text.slice(0, i - s.from))) {
            if ("	" == r[r.length - 1]) return i - 1;
            for(var c = BV(r, a.tabSize) % oY(a) || oY(a), l = 0; l < c && " " == r[r.length - 1 - l]; l++)i--;
            o = i;
        } else (o = hF(s.text, i - s.from, t, t) + s.from) == i && s.number != (t ? a.doc.lines : 1) ? o += t ? 1 : -1 : !t && /[\ufe00-\ufe0f]/.test(s.text.slice(o - s.from, i - s.from)) && (o = hF(s.text, o - s.from, !1, !1) + s.from);
        return o;
    });
}, IZ = function(e) {
    return NZ(e, !1);
}, DZ = function(e) {
    return NZ(e, !0);
}, zZ = function(e, t) {
    return TZ(e, function(n) {
        for(var r = n.head, o = e.state, i = o.doc.lineAt(r), a = o.charCategorizer(r), s = null;;){
            if (r == (t ? i.to : i.from)) {
                r == n.head && i.number != (t ? o.doc.lines : 1) && (r += t ? 1 : -1);
                break;
            }
            var c = hF(i.text, r - i.from, t) + i.from, l = i.text.slice(Math.min(r, c) - i.from, Math.max(r, c) - i.from), u = a(l);
            if (null != s && u != s) break;
            " " == l && r == n.head || (s = u), r = c;
        }
        return r;
    });
}, qZ = function(e) {
    return zZ(e, !1);
};
function BZ(e) {
    var t, n = [], r = -1, o = bo(e.selection.ranges);
    try {
        for(o.s(); !(t = o.n()).done;){
            var i = t.value, a = e.doc.lineAt(i.from), s = e.doc.lineAt(i.to);
            if (i.empty || i.to != s.from || (s = e.doc.lineAt(i.to - 1)), r >= a.number) {
                var c = n[n.length - 1];
                c.to = s.to, c.ranges.push(i);
            } else n.push({
                from: a.from,
                to: s.to,
                ranges: [
                    i
                ]
            });
            r = s.number + 1;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    return n;
}
function LZ(e, t, n) {
    if (e.readOnly) return !1;
    var r, o = [], i = [], a = bo(BZ(e));
    try {
        for(a.s(); !(r = a.n()).done;){
            var s = r.value;
            if (n ? s.to != e.doc.length : 0 != s.from) {
                var c = e.doc.lineAt(n ? s.to + 1 : s.from - 1), l = c.length + 1;
                if (n) {
                    o.push({
                        from: s.to,
                        to: c.to
                    }, {
                        from: s.from,
                        insert: c.text + e.lineBreak
                    });
                    var u, f = bo(s.ranges);
                    try {
                        for(f.s(); !(u = f.n()).done;){
                            var d = u.value;
                            i.push(PF.range(Math.min(e.doc.length, d.anchor + l), Math.min(e.doc.length, d.head + l)));
                        }
                    } catch (e) {
                        f.e(e);
                    } finally{
                        f.f();
                    }
                } else {
                    o.push({
                        from: c.from,
                        to: s.from
                    }, {
                        from: s.to,
                        insert: e.lineBreak + c.text
                    });
                    var h, v = bo(s.ranges);
                    try {
                        for(v.s(); !(h = v.n()).done;){
                            var p = h.value;
                            i.push(PF.range(p.anchor - l, p.head - l));
                        }
                    } catch (e) {
                        v.e(e);
                    } finally{
                        v.f();
                    }
                }
            }
        }
    } catch (e) {
        a.e(e);
    } finally{
        a.f();
    }
    return !!o.length && (t(e.update({
        changes: o,
        scrollIntoView: !0,
        selection: PF.create(i, e.selection.mainIndex),
        userEvent: "move.line"
    })), !0);
}
function FZ(e, t, n) {
    if (e.readOnly) return !1;
    var r, o = [], i = bo(BZ(e));
    try {
        for(i.s(); !(r = i.n()).done;){
            var a = r.value;
            n ? o.push({
                from: a.from,
                insert: e.doc.slice(a.from, a.to) + e.lineBreak
            }) : o.push({
                from: a.to,
                insert: e.lineBreak + e.doc.slice(a.from, a.to)
            });
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    return t(e.update({
        changes: o,
        scrollIntoView: !0,
        userEvent: "input.copyline"
    })), !0;
}
var VZ = WZ(!1), HZ = WZ(!0);
function WZ(e) {
    return function(t) {
        var n = t.state, r = t.dispatch;
        if (n.readOnly) return !1;
        var o = n.changeByRange(function(t) {
            var r = t.from, o = t.to, i = n.doc.lineAt(r), a = !e && r == o && function(e, t) {
                if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1))) return {
                    from: t,
                    to: t
                };
                var n, r = WQ(e).resolveInner(t), o = r.childBefore(t), i = r.childAfter(t);
                return o && i && o.to <= t && i.from >= t && (n = o.type.prop(DG.closedBy)) && n.indexOf(i.name) > -1 && e.doc.lineAt(o.to).from == e.doc.lineAt(i.from).from && !/\S/.test(e.sliceDoc(o.to, i.from)) ? {
                    from: o.to,
                    to: i.from
                } : null;
            }(n, r);
            e && (r = o = (o <= i.to ? i : n.doc.lineAt(o)).to);
            var s = new sY(n, {
                simulateBreak: r,
                simulateDoubleBreak: !!a
            }), c = aY(s, r);
            for(null == c && (c = BV(/^\s*/.exec(n.doc.lineAt(r).text)[0], n.tabSize)); o < i.to && /\s/.test(i.text[o - i.from]);)o++;
            a ? (r = a.from, o = a.to) : r > i.from && r < i.from + 100 && !/\S/.test(i.text.slice(0, r)) && (r = i.from);
            var l = [
                "",
                iY(n, c)
            ];
            return a && l.push(iY(n, s.lineIndent(i.from, -1))), {
                changes: {
                    from: r,
                    to: o,
                    insert: XL.of(l)
                },
                range: PF.cursor(r + 1 + l[1].length)
            };
        });
        return r(n.update(o, {
            scrollIntoView: !0,
            userEvent: "input"
        })), !0;
    };
}
function UZ(e, t) {
    var n = -1;
    return e.changeByRange(function(r) {
        for(var o = [], i = r.from; i <= r.to;){
            var a = e.doc.lineAt(i);
            a.number > n && (r.empty || r.to > a.from) && (t(a, o, r), n = a.number), i = a.to + 1;
        }
        var s = e.changes(o);
        return {
            changes: o,
            range: PF.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1))
        };
    });
}
var JZ = function(e) {
    var t = e.state, n = e.dispatch;
    return !t.readOnly && (n(t.update(UZ(t, function(e, n) {
        n.push({
            from: e.from,
            insert: t.facet(rY)
        });
    }), {
        userEvent: "input.indent"
    })), !0);
}, KZ = function(e) {
    var t = e.state, n = e.dispatch;
    return !t.readOnly && (n(t.update(UZ(t, function(e, n) {
        var r = /^\s*/.exec(e.text)[0];
        if (r) {
            for(var o = BV(r, t.tabSize), i = 0, a = iY(t, Math.max(0, o - oY(t))); i < r.length && i < a.length && r.charCodeAt(i) == a.charCodeAt(i);)i++;
            n.push({
                from: e.from + i,
                to: e.from + r.length,
                insert: a.slice(i)
            });
        }
    }), {
        userEvent: "delete.dedent"
    })), !0);
}, GZ = [
    {
        key: "Ctrl-b",
        run: iZ,
        shift: wZ,
        preventDefault: !0
    },
    {
        key: "Ctrl-f",
        run: aZ,
        shift: xZ
    },
    {
        key: "Ctrl-p",
        run: fZ,
        shift: SZ
    },
    {
        key: "Ctrl-n",
        run: dZ,
        shift: CZ
    },
    {
        key: "Ctrl-a",
        run: function(e) {
            return tZ(e, function(t) {
                return PF.cursor(e.lineBlockAt(t.head).from, 1);
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return PF.cursor(e.lineBlockAt(t.head).from);
            });
        }
    },
    {
        key: "Ctrl-e",
        run: function(e) {
            return tZ(e, function(t) {
                return PF.cursor(e.lineBlockAt(t.head).to, -1);
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return PF.cursor(e.lineBlockAt(t.head).to);
            });
        }
    },
    {
        key: "Ctrl-d",
        run: DZ
    },
    {
        key: "Ctrl-h",
        run: IZ
    },
    {
        key: "Ctrl-k",
        run: function(e) {
            return TZ(e, function(t) {
                var n = e.lineBlockAt(t.head).to;
                return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
            });
        }
    },
    {
        key: "Ctrl-Alt-h",
        run: qZ
    },
    {
        key: "Ctrl-o",
        run: function(e) {
            var t = e.state, n = e.dispatch;
            if (t.readOnly) return !1;
            var r = t.changeByRange(function(e) {
                return {
                    changes: {
                        from: e.from,
                        to: e.to,
                        insert: XL.of([
                            "",
                            ""
                        ])
                    },
                    range: PF.cursor(e.from)
                };
            });
            return n(t.update(r, {
                scrollIntoView: !0,
                userEvent: "input"
            })), !0;
        }
    },
    {
        key: "Ctrl-t",
        run: function(e) {
            var t = e.state, n = e.dispatch;
            if (t.readOnly) return !1;
            var r = t.changeByRange(function(e) {
                if (!e.empty || 0 == e.from || e.from == t.doc.length) return {
                    range: e
                };
                var n = e.from, r = t.doc.lineAt(n), o = n == r.from ? n - 1 : hF(r.text, n - r.from, !1) + r.from, i = n == r.to ? n + 1 : hF(r.text, n - r.from, !0) + r.from;
                return {
                    changes: {
                        from: o,
                        to: i,
                        insert: t.doc.slice(n, i).append(t.doc.slice(o, n))
                    },
                    range: PF.cursor(i)
                };
            });
            return !r.changes.empty && (n(t.update(r, {
                scrollIntoView: !0,
                userEvent: "move.character"
            })), !0);
        }
    },
    {
        key: "Ctrl-v",
        run: mZ
    }
], QZ = [
    {
        key: "ArrowLeft",
        run: iZ,
        shift: wZ,
        preventDefault: !0
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: function(e) {
            return sZ(e, !oZ(e));
        },
        shift: function(e) {
            return kZ(e, !oZ(e));
        },
        preventDefault: !0
    },
    {
        mac: "Cmd-ArrowLeft",
        run: function(e) {
            return tZ(e, function(t) {
                return gZ(e, t, !oZ(e));
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return gZ(e, t, !oZ(e));
            });
        },
        preventDefault: !0
    },
    {
        key: "ArrowRight",
        run: aZ,
        shift: xZ,
        preventDefault: !0
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: function(e) {
            return sZ(e, oZ(e));
        },
        shift: function(e) {
            return kZ(e, oZ(e));
        },
        preventDefault: !0
    },
    {
        mac: "Cmd-ArrowRight",
        run: function(e) {
            return tZ(e, function(t) {
                return gZ(e, t, oZ(e));
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return gZ(e, t, oZ(e));
            });
        },
        preventDefault: !0
    },
    {
        key: "ArrowUp",
        run: fZ,
        shift: SZ,
        preventDefault: !0
    },
    {
        mac: "Cmd-ArrowUp",
        run: MZ,
        shift: AZ
    },
    {
        mac: "Ctrl-ArrowUp",
        run: pZ,
        shift: _Z
    },
    {
        key: "ArrowDown",
        run: dZ,
        shift: CZ,
        preventDefault: !0
    },
    {
        mac: "Cmd-ArrowDown",
        run: EZ,
        shift: PZ
    },
    {
        mac: "Ctrl-ArrowDown",
        run: mZ,
        shift: OZ
    },
    {
        key: "PageUp",
        run: pZ,
        shift: _Z
    },
    {
        key: "PageDown",
        run: mZ,
        shift: OZ
    },
    {
        key: "Home",
        run: function(e) {
            return tZ(e, function(t) {
                return gZ(e, t, !1);
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return gZ(e, t, !1);
            });
        },
        preventDefault: !0
    },
    {
        key: "Mod-Home",
        run: MZ,
        shift: AZ
    },
    {
        key: "End",
        run: function(e) {
            return tZ(e, function(t) {
                return gZ(e, t, !0);
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return gZ(e, t, !0);
            });
        },
        preventDefault: !0
    },
    {
        key: "Mod-End",
        run: EZ,
        shift: PZ
    },
    {
        key: "Enter",
        run: VZ
    },
    {
        key: "Mod-a",
        run: function(e) {
            var t = e.state;
            return (0, e.dispatch)(t.update({
                selection: {
                    anchor: 0,
                    head: t.doc.length
                },
                userEvent: "select"
            })), !0;
        }
    },
    {
        key: "Backspace",
        run: IZ,
        shift: IZ
    },
    {
        key: "Delete",
        run: DZ
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: qZ
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: function(e) {
            return zZ(e, !0);
        }
    },
    {
        mac: "Mod-Backspace",
        run: function(e) {
            return TZ(e, function(t) {
                var n = e.moveToLineBoundary(t, !1).head;
                return t.head > n ? n : Math.max(0, t.head - 1);
            });
        }
    },
    {
        mac: "Mod-Delete",
        run: function(e) {
            return TZ(e, function(t) {
                var n = e.moveToLineBoundary(t, !0).head;
                return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
            });
        }
    }
].concat(GZ.map(function(e) {
    return {
        mac: e.key,
        run: e.run,
        shift: e.shift
    };
})), YZ = [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: function(e) {
            return tZ(e, function(t) {
                return lZ(e.state, t, !oZ(e));
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return lZ(e.state, t, !oZ(e));
            });
        }
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: function(e) {
            return tZ(e, function(t) {
                return lZ(e.state, t, oZ(e));
            });
        },
        shift: function(e) {
            return yZ(e, function(t) {
                return lZ(e.state, t, oZ(e));
            });
        }
    },
    {
        key: "Alt-ArrowUp",
        run: function(e) {
            return LZ(e.state, e.dispatch, !1);
        }
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: function(e) {
            return FZ(e.state, e.dispatch, !1);
        }
    },
    {
        key: "Alt-ArrowDown",
        run: function(e) {
            return LZ(e.state, e.dispatch, !0);
        }
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: function(e) {
            return FZ(e.state, e.dispatch, !0);
        }
    },
    {
        key: "Escape",
        run: function(e) {
            var t = e.state, n = e.dispatch, r = t.selection, o = null;
            return r.ranges.length > 1 ? o = PF.create([
                r.main
            ]) : r.main.empty || (o = PF.create([
                PF.cursor(r.main.head)
            ])), !!o && (n(eZ(t, o)), !0);
        }
    },
    {
        key: "Mod-Enter",
        run: HZ
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: function(e) {
            var t = e.state, n = e.dispatch, r = BZ(t).map(function(e) {
                var n = e.from, r = e.to;
                return PF.range(n, Math.min(r + 1, t.doc.length));
            });
            return n(t.update({
                selection: PF.create(r),
                userEvent: "select"
            })), !0;
        }
    },
    {
        key: "Mod-i",
        run: function(e) {
            var t = e.state, n = e.dispatch, r = ZX(t.selection, function(e) {
                for(var n, r = WQ(t).resolveStack(e.from, 1); r; r = r.next){
                    var o = r.node;
                    if ((o.from < e.from && o.to >= e.to || o.to > e.to && o.from <= e.from) && (null === (n = o.parent) || void 0 === n ? void 0 : n.parent)) return PF.range(o.to, o.from);
                }
                return e;
            });
            return n(eZ(t, r)), !0;
        },
        preventDefault: !0
    },
    {
        key: "Mod-[",
        run: KZ
    },
    {
        key: "Mod-]",
        run: JZ
    },
    {
        key: "Mod-Alt-\\",
        run: function(e) {
            var t = e.state, n = e.dispatch;
            if (t.readOnly) return !1;
            var r = Object.create(null), o = new sY(t, {
                overrideIndentation: function(e) {
                    var t = r[e];
                    return null == t ? -1 : t;
                }
            }), i = UZ(t, function(e, n, i) {
                var a = aY(o, e.from);
                if (null != a) {
                    /\S/.test(e.text) || (a = 0);
                    var s = /^\s*/.exec(e.text)[0], c = iY(t, a);
                    (s != c || i.from < e.from + s.length) && (r[e.from] = a, n.push({
                        from: e.from,
                        to: e.from + s.length,
                        insert: c
                    }));
                }
            });
            return i.changes.empty || n(t.update(i, {
                userEvent: "indent"
            })), !0;
        }
    },
    {
        key: "Shift-Mod-k",
        run: function(e) {
            if (e.state.readOnly) return !1;
            var t = e.state, n = t.changes(BZ(t).map(function(e) {
                var n = e.from, r = e.to;
                return n > 0 ? n-- : r < t.doc.length && r++, {
                    from: n,
                    to: r
                };
            })), r = ZX(t.selection, function(t) {
                return e.moveVertically(t, !0);
            }).map(n);
            return e.dispatch({
                changes: n,
                selection: r,
                scrollIntoView: !0,
                userEvent: "delete.line"
            }), !0;
        }
    },
    {
        key: "Shift-Mod-\\",
        run: function(e) {
            return function(e, t, n) {
                var r = !1, o = ZX(e.selection, function(t) {
                    var o = iX(e, t.head, -1) || iX(e, t.head, 1) || t.head > 0 && iX(e, t.head - 1, 1) || t.head < e.doc.length && iX(e, t.head + 1, -1);
                    if (!o || !o.end) return t;
                    r = !0;
                    var i = o.start.from == t.head ? o.end.to : o.end.from;
                    return n ? PF.range(t.anchor, i) : PF.cursor(i);
                });
                return !!r && (t(eZ(e, o)), !0);
            }(e.state, e.dispatch, !1);
        }
    },
    {
        key: "Mod-/",
        run: function(e) {
            var t = e.state, n = t.doc.lineAt(t.selection.main.from), r = jX(e.state, n.from);
            return r.line ? wX(e) : !!r.block && kX(e);
        }
    },
    {
        key: "Alt-A",
        run: xX
    }
].concat(QZ), XZ = {
    key: "Tab",
    run: JZ,
    shift: KZ
};
function ZZ() {
    var e = arguments[0];
    "string" == typeof e && (e = document.createElement(e));
    var t = 1, n = arguments[1];
    if (n && "object" == Ho(n) && null == n.nodeType && !Array.isArray(n)) {
        for(var r in n)if (Object.prototype.hasOwnProperty.call(n, r)) {
            var o = n[r];
            "string" == typeof o ? e.setAttribute(r, o) : null != o && (e[r] = o);
        }
        t++;
    }
    for(; t < arguments.length; t++)e0(e, arguments[t]);
    return e;
}
function e0(e, t) {
    if ("string" == typeof t) e.appendChild(document.createTextNode(t));
    else if (null == t) ;
    else if (null != t.nodeType) e.appendChild(t);
    else {
        if (!Array.isArray(t)) throw new RangeError("Unsupported child node: " + t);
        for(var n = 0; n < t.length; n++)e0(e, t[n]);
    }
}
var t0 = Do(function e(t, n, r) {
    No(this, e), this.from = t, this.to = n, this.diagnostic = r;
}), n0 = function() {
    function e(t, n, r) {
        No(this, e), this.diagnostics = t, this.panel = n, this.selected = r;
    }
    return Do(e, null, [
        {
            key: "init",
            value: function(t, n, r) {
                var o = t, i = r.facet(m0).markerFilter;
                i && (o = i(o, r));
                var a = eW.set(o.map(function(e) {
                    return e.from == e.to || e.from == e.to - 1 && r.doc.lineAt(e.from).to == e.from ? eW.widget({
                        widget: new b0(e),
                        diagnostic: e
                    }).range(e.from) : eW.mark({
                        attributes: {
                            class: "cm-lintRange cm-lintRange-" + e.severity + (e.markClass ? " " + e.markClass : "")
                        },
                        diagnostic: e,
                        inclusive: !0
                    }).range(e.from, e.to);
                }), !0);
                return new e(a, n, r0(a));
            }
        }
    ]), e;
}();
function r0(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = null;
    return e.between(n, 1e9, function(e, n, o) {
        var i = o.spec;
        if (!t || i.diagnostic == t) return r = new t0(e, n, i.diagnostic), !1;
    }), r;
}
function o0(e, t) {
    var n = e.startState.doc.lineAt(t.pos);
    return !(!e.effects.some(function(e) {
        return e.is(a0);
    }) && !e.changes.touchesRange(n.from, n.to));
}
function i0(e, t) {
    return e.field(l0, !1) ? t : t.concat(uV.appendConfig.of(T0));
}
var a0 = uV.define(), s0 = uV.define(), c0 = uV.define(), l0 = LF.define({
    create: function() {
        return new n0(eW.none, null, null);
    },
    update: function(e, t) {
        if (t.docChanged) {
            var n = e.diagnostics.map(t.changes), r = null;
            if (e.selected) {
                var o = t.changes.mapPos(e.selected.from, 1);
                r = r0(n, e.selected.diagnostic, o) || r0(n, null, o);
            }
            e = new n0(n, e.panel, r);
        }
        var i, a = bo(t.effects);
        try {
            for(a.s(); !(i = a.n()).done;){
                var s = i.value;
                s.is(a0) ? e = n0.init(s.value, e.panel, t.state) : s.is(s0) ? e = new n0(e.diagnostics, s.value ? x0.open : null, e.selected) : s.is(c0) && (e = new n0(e.diagnostics, e.panel, s.value));
            }
        } catch (e) {
            a.e(e);
        } finally{
            a.f();
        }
        return e;
    },
    provide: function(e) {
        return [
            dG.from(e, function(e) {
                return e.panel;
            }),
            WJ.decorations.from(e, function(e) {
                return e.diagnostics;
            })
        ];
    }
}), u0 = eW.mark({
    class: "cm-lintRange cm-lintRange-active",
    inclusive: !0
});
function f0(e, t, n) {
    var r = e.state.field(l0).diagnostics, o = [], i = 2e8, a = 0;
    r.between(t - (n < 0 ? 1 : 0), t + (n > 0 ? 1 : 0), function(e, r, s) {
        var c = s.spec;
        t >= e && t <= r && (e == r || (t > e || n > 0) && (t < r || n < 0)) && (o.push(c.diagnostic), i = Math.min(e, i), a = Math.max(r, a));
    });
    var s = e.state.facet(m0).tooltipFilter;
    return s && (o = s(o, e.state)), o.length ? {
        pos: i,
        end: a,
        above: e.state.doc.lineAt(i).to < a,
        create: function() {
            return {
                dom: d0(e, o)
            };
        }
    } : null;
}
function d0(e, t) {
    return ZZ("ul", {
        class: "cm-tooltip-lint"
    }, t.map(function(t) {
        return y0(e, t, !1);
    }));
}
var h0 = function(e) {
    var t = e.state.field(l0, !1);
    return !(!t || !t.panel) && (e.dispatch({
        effects: s0.of(!1)
    }), !0);
}, v0 = [
    {
        key: "Mod-Shift-m",
        run: function(e) {
            var t = e.state.field(l0, !1);
            t && t.panel || e.dispatch({
                effects: i0(e.state, [
                    s0.of(!0)
                ])
            });
            var n = cG(e, x0.open);
            return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
        },
        preventDefault: !0
    },
    {
        key: "F8",
        run: function(e) {
            var t = e.state.field(l0, !1);
            if (!t) return !1;
            var n = e.state.selection.main, r = t.diagnostics.iter(n.to + 1);
            return !(!r.value && (!(r = t.diagnostics.iter(0)).value || r.from == n.from && r.to == n.to)) && (e.dispatch({
                selection: {
                    anchor: r.from,
                    head: r.to
                },
                scrollIntoView: !0
            }), !0);
        }
    }
], p0 = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.timeout = -1, this.set = !0;
        var n = t.state.facet(m0).delay;
        this.lintTime = Date.now() + n, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, n);
    }
    return Do(e, [
        {
            key: "run",
            value: function() {
                var e = this, t = Date.now();
                if (t < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - t);
                else {
                    this.set = !1;
                    var n = this.view.state, r = n.facet(m0).sources;
                    r.length && Promise.all(r.map(function(t) {
                        return Promise.resolve(t(e.view));
                    })).then(function(t) {
                        var r = t.reduce(function(e, t) {
                            return e.concat(t);
                        });
                        e.view.state.doc == n.doc && e.view.dispatch(function(e, t) {
                            return {
                                effects: i0(e, [
                                    a0.of(t)
                                ])
                            };
                        }(e.view.state, r));
                    }, function(t) {
                        HW(e.view.state, t);
                    });
                }
            }
        },
        {
            key: "update",
            value: function(e) {
                var t = e.state.facet(m0);
                (e.docChanged || t != e.startState.facet(m0) || t.needsRefresh && t.needsRefresh(e)) && (this.lintTime = Date.now() + t.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, t.delay)));
            }
        },
        {
            key: "force",
            value: function() {
                this.set && (this.lintTime = Date.now(), this.run());
            }
        },
        {
            key: "destroy",
            value: function() {
                clearTimeout(this.timeout);
            }
        }
    ]), e;
}()), m0 = NF.define({
    combine: function(e) {
        return Object.assign({
            sources: e.map(function(e) {
                return e.source;
            }).filter(function(e) {
                return null != e;
            })
        }, jV(e.map(function(e) {
            return e.config;
        }), {
            delay: 750,
            markerFilter: null,
            tooltipFilter: null,
            needsRefresh: null
        }, {
            needsRefresh: function(e, t) {
                return e ? t ? function(n) {
                    return e(n) || t(n);
                } : e : t;
            }
        }));
    }
});
function g0(e) {
    var t = [];
    if (e) {
        var n, r = bo(e);
        try {
            e: for(r.s(); !(n = r.n()).done;){
                for(var o = n.value.name, i = function() {
                    var e = o[a];
                    if (/[a-zA-Z]/.test(e) && !t.some(function(t) {
                        return t.toLowerCase() == e.toLowerCase();
                    })) return t.push(e), 1;
                }, a = 0; a < o.length; a++)if (i()) continue e;
                t.push("");
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
    }
    return t;
}
function y0(e, t, n) {
    var r, o = n ? g0(t.actions) : [];
    return ZZ("li", {
        class: "cm-diagnostic cm-diagnostic-" + t.severity
    }, ZZ("span", {
        class: "cm-diagnosticText"
    }, t.renderMessage ? t.renderMessage() : t.message), null === (r = t.actions) || void 0 === r ? void 0 : r.map(function(n, r) {
        var i = !1, a = function(r) {
            if (r.preventDefault(), !i) {
                i = !0;
                var o = r0(e.state.field(l0).diagnostics, t);
                o && n.apply(e, o.from, o.to);
            }
        }, s = n.name, c = o[r] ? s.indexOf(o[r]) : -1, l = c < 0 ? s : [
            s.slice(0, c),
            ZZ("u", s.slice(c, c + 1)),
            s.slice(c + 1)
        ];
        return ZZ("button", {
            type: "button",
            class: "cm-diagnosticAction",
            onclick: a,
            onmousedown: a,
            "aria-label": " Action: ".concat(s).concat(c < 0 ? "" : ' (access key "'.concat(o[r], ')"'), ".")
        }, l);
    }), t.source && ZZ("div", {
        class: "cm-diagnosticSource"
    }, t.source));
}
var b0 = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).diagnostic = e, n;
    }
    return Ao(t, XH), Do(t, [
        {
            key: "eq",
            value: function(e) {
                return e.diagnostic == this.diagnostic;
            }
        },
        {
            key: "toDOM",
            value: function() {
                return ZZ("span", {
                    class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity
                });
            }
        }
    ]), t;
}(), w0 = Do(function e(t, n) {
    No(this, e), this.diagnostic = n, this.id = "item_" + Math.floor(4294967295 * Math.random()).toString(16), this.dom = y0(t, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
}), x0 = function() {
    function e(t) {
        var n = this;
        No(this, e), this.view = t, this.items = [];
        this.list = ZZ("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: function(e) {
                if (27 == e.keyCode) h0(n.view), n.view.focus();
                else if (38 == e.keyCode || 33 == e.keyCode) n.moveSelection((n.selectedIndex - 1 + n.items.length) % n.items.length);
                else if (40 == e.keyCode || 34 == e.keyCode) n.moveSelection((n.selectedIndex + 1) % n.items.length);
                else if (36 == e.keyCode) n.moveSelection(0);
                else if (35 == e.keyCode) n.moveSelection(n.items.length - 1);
                else if (13 == e.keyCode) n.view.focus();
                else {
                    if (!(e.keyCode >= 65 && e.keyCode <= 90 && n.selectedIndex >= 0)) return;
                    for(var r = n.items[n.selectedIndex].diagnostic, o = g0(r.actions), i = 0; i < o.length; i++)if (o[i].toUpperCase().charCodeAt(0) == e.keyCode) {
                        var a = r0(n.view.state.field(l0).diagnostics, r);
                        a && r.actions[i].apply(t, a.from, a.to);
                    }
                }
                e.preventDefault();
            },
            onclick: function(e) {
                for(var t = 0; t < n.items.length; t++)n.items[t].dom.contains(e.target) && n.moveSelection(t);
            }
        }), this.dom = ZZ("div", {
            class: "cm-panel-lint"
        }, this.list, ZZ("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: function() {
                return h0(n.view);
            }
        }, "\xd7")), this.update();
    }
    return Do(e, [
        {
            key: "selectedIndex",
            get: function() {
                var e = this.view.state.field(l0).selected;
                if (!e) return -1;
                for(var t = 0; t < this.items.length; t++)if (this.items[t].diagnostic == e.diagnostic) return t;
                return -1;
            }
        },
        {
            key: "update",
            value: function() {
                var e = this, t = this.view.state.field(l0), n = t.diagnostics, r = t.selected, o = 0, i = !1, a = null;
                for(n.between(0, this.view.state.doc.length, function(t, n, s) {
                    for(var c, l = s.spec, u = -1, f = o; f < e.items.length; f++)if (e.items[f].diagnostic == l.diagnostic) {
                        u = f;
                        break;
                    }
                    u < 0 ? (c = new w0(e.view, l.diagnostic), e.items.splice(o, 0, c), i = !0) : (c = e.items[u], u > o && (e.items.splice(o, u - o), i = !0)), r && c.diagnostic == r.diagnostic ? c.dom.hasAttribute("aria-selected") || (c.dom.setAttribute("aria-selected", "true"), a = c) : c.dom.hasAttribute("aria-selected") && c.dom.removeAttribute("aria-selected"), o++;
                }); o < this.items.length && !(1 == this.items.length && this.items[0].diagnostic.from < 0);)i = !0, this.items.pop();
                0 == this.items.length && (this.items.push(new w0(this.view, {
                    from: -1,
                    to: -1,
                    severity: "info",
                    message: this.view.state.phrase("No diagnostics")
                })), i = !0), a ? (this.list.setAttribute("aria-activedescendant", a.id), this.view.requestMeasure({
                    key: this,
                    read: function() {
                        return {
                            sel: a.dom.getBoundingClientRect(),
                            panel: e.list.getBoundingClientRect()
                        };
                    },
                    write: function(t) {
                        var n = t.sel, r = t.panel, o = r.height / e.list.offsetHeight;
                        n.top < r.top ? e.list.scrollTop -= (r.top - n.top) / o : n.bottom > r.bottom && (e.list.scrollTop += (n.bottom - r.bottom) / o);
                    }
                })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
            }
        },
        {
            key: "sync",
            value: function() {
                var e = this.list.firstChild;
                function t() {
                    var t = e;
                    e = t.nextSibling, t.remove();
                }
                var n, r = bo(this.items);
                try {
                    for(r.s(); !(n = r.n()).done;){
                        var o = n.value;
                        if (o.dom.parentNode == this.list) {
                            for(; e != o.dom;)t();
                            e = o.dom.nextSibling;
                        } else this.list.insertBefore(o.dom, e);
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
                for(; e;)t();
            }
        },
        {
            key: "moveSelection",
            value: function(e) {
                if (!(this.selectedIndex < 0)) {
                    var t = r0(this.view.state.field(l0).diagnostics, this.items[e].diagnostic);
                    t && this.view.dispatch({
                        selection: {
                            anchor: t.from,
                            head: t.to
                        },
                        scrollIntoView: !0,
                        effects: c0.of(t)
                    });
                }
            }
        }
    ], [
        {
            key: "open",
            value: function(t) {
                return new e(t);
            }
        }
    ]), e;
}();
function k0(e) {
    return 'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" '.concat(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'viewBox="0 0 40 40"', ">").concat(encodeURIComponent(e), "</svg>')");
}
function j0(e) {
    return k0('<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="'.concat(e, '" fill="none" stroke-width=".7"/>'), 'width="6" height="3"');
}
var S0 = WJ.baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: j0("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: j0("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: j0("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: j0("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function C0(e) {
    return "error" == e ? 4 : "warning" == e ? 3 : "info" == e ? 2 : 1;
}
var $0 = function(e) {
    function t(e) {
        var n;
        return No(this, t), (n = _o(this, t)).diagnostics = e, n.severity = e.reduce(function(e, t) {
            return C0(e) < C0(t.severity) ? t.severity : e;
        }, "hint"), n;
    }
    return Ao(t, hG), Do(t, [
        {
            key: "toDOM",
            value: function(e) {
                var t = document.createElement("div");
                t.className = "cm-lint-marker cm-lint-marker-" + this.severity;
                var n = this.diagnostics, r = e.state.facet(R0).tooltipFilter;
                return r && (n = r(n, e.state)), n.length && (t.onmouseover = function() {
                    return function(e, t, n) {
                        function r() {
                            var r = e.elementAtHeight(t.getBoundingClientRect().top + 5 - e.documentTop);
                            e.coordsAtPos(r.from) && e.dispatch({
                                effects: E0.of({
                                    pos: r.from,
                                    above: !1,
                                    create: function() {
                                        return {
                                            dom: d0(e, n),
                                            getCoords: function() {
                                                return t.getBoundingClientRect();
                                            }
                                        };
                                    }
                                })
                            }), t.onmouseout = t.onmousemove = null, function(e, t) {
                                var n = function n(r) {
                                    var o = t.getBoundingClientRect();
                                    if (!(r.clientX > o.left - 10 && r.clientX < o.right + 10 && r.clientY > o.top - 10 && r.clientY < o.bottom + 10)) {
                                        for(var i = r.target; i; i = i.parentNode)if (1 == i.nodeType && i.classList.contains("cm-tooltip-lint")) return;
                                        window.removeEventListener("mousemove", n), e.state.field(A0) && e.dispatch({
                                            effects: E0.of(null)
                                        });
                                    }
                                };
                                window.addEventListener("mousemove", n);
                            }(e, t);
                        }
                        var o = e.state.facet(R0), i = o.hoverTime, a = setTimeout(r, i);
                        t.onmouseout = function() {
                            clearTimeout(a), t.onmouseout = t.onmousemove = null;
                        }, t.onmousemove = function() {
                            clearTimeout(a), a = setTimeout(r, i);
                        };
                    }(e, t, n);
                }), t;
            }
        }
    ]), t;
}();
function _0(e, t) {
    var n, r = Object.create(null), o = bo(t);
    try {
        for(o.s(); !(n = o.n()).done;){
            var i = n.value, a = e.lineAt(i.from);
            (r[a.from] || (r[a.from] = [])).push(i);
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
    var s = [];
    for(var c in r)s.push(new $0(r[c]).range(+c));
    return OV.of(s, !0);
}
var O0 = gG({
    class: "cm-gutter-lint",
    markers: function(e) {
        return e.state.field(M0);
    }
}), M0 = LF.define({
    create: function() {
        return OV.empty;
    },
    update: function(e, t) {
        e = e.map(t.changes);
        var n, r = t.state.facet(R0).markerFilter, o = bo(t.effects);
        try {
            for(o.s(); !(n = o.n()).done;){
                var i = n.value;
                if (i.is(a0)) {
                    var a = i.value;
                    r && (a = r(a || [], t.state)), e = _0(t.state.doc, a.slice(0));
                }
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        return e;
    }
}), E0 = uV.define(), A0 = LF.define({
    create: function() {
        return null;
    },
    update: function(e, t) {
        return e && t.docChanged && (e = o0(t, e) ? null : Object.assign(Object.assign({}, e), {
            pos: t.changes.mapPos(e.pos)
        })), t.effects.reduce(function(e, t) {
            return t.is(E0) ? t.value : e;
        }, e);
    },
    provide: function(e) {
        return XK.from(e);
    }
}), P0 = WJ.baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: k0('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>')
    },
    ".cm-lint-marker-warning": {
        content: k0('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>')
    },
    ".cm-lint-marker-error": {
        content: k0('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>')
    }
}), T0 = [
    l0,
    WJ.decorations.compute([
        l0
    ], function(e) {
        var t = e.field(l0), n = t.selected, r = t.panel;
        return n && r && n.from != n.to ? eW.set([
            u0.range(n.from, n.to)
        ]) : eW.none;
    }),
    oG(f0, {
        hideOn: o0
    }),
    S0
], R0 = NF.define({
    combine: function(e) {
        return jV(e, {
            hoverTime: 300,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
function N0() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        R0.of(e),
        M0,
        O0,
        P0,
        A0
    ];
}
var I0 = function() {
    function e(t, n, r, o, i, a, s, c, l) {
        var u = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, f = arguments.length > 10 ? arguments[10] : void 0;
        No(this, e), this.p = t, this.stack = n, this.state = r, this.reducePos = o, this.pos = i, this.score = a, this.buffer = s, this.bufferBase = c, this.curContext = l, this.lookAhead = u, this.parent = f;
    }
    return Do(e, [
        {
            key: "toString",
            value: function() {
                return "[".concat(this.stack.filter(function(e, t) {
                    return t % 3 == 0;
                }).concat(this.state), "]@").concat(this.pos).concat(this.score ? "!" + this.score : "");
            }
        },
        {
            key: "context",
            get: function() {
                return this.curContext ? this.curContext.context : null;
            }
        },
        {
            key: "pushState",
            value: function(e, t) {
                this.stack.push(this.state, t, this.bufferBase + this.buffer.length), this.state = e;
            }
        },
        {
            key: "reduce",
            value: function(e) {
                var t, n = e >> 19, r = 65535 & e, o = this.p.parser, i = o.dynamicPrecedence(r);
                if (i && (this.score += i), 0 == n) return this.pushState(o.getGoto(this.state, r, !0), this.reducePos), r < o.minRepeatTerm && this.storeNode(r, this.reducePos, this.reducePos, 4, !0), void this.reduceContext(r, this.reducePos);
                var a = this.stack.length - 3 * (n - 1) - (262144 & e ? 6 : 0), s = a ? this.stack[a - 2] : this.p.ranges[0].from, c = this.reducePos - s;
                c >= 2e3 && !(null === (t = this.p.parser.nodeSet.types[r]) || void 0 === t ? void 0 : t.isAnonymous) && (s == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = c) : this.p.lastBigReductionSize < c && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = s, this.p.lastBigReductionSize = c));
                var l = a ? this.stack[a - 1] : 0, u = this.bufferBase + this.buffer.length - l;
                if (r < o.minRepeatTerm || 131072 & e) {
                    var f = o.stateFlag(this.state, 1) ? this.pos : this.reducePos;
                    this.storeNode(r, s, f, u + 4, !0);
                }
                if (262144 & e) this.state = this.stack[a];
                else {
                    var d = this.stack[a - 3];
                    this.state = o.getGoto(d, r, !0);
                }
                for(; this.stack.length > a;)this.stack.pop();
                this.reduceContext(r, s);
            }
        },
        {
            key: "storeNode",
            value: function(e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 4, o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                if (0 == e && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
                    var i = this, a = this.buffer.length;
                    if (0 == a && i.parent && (a = i.bufferBase - i.parent.bufferBase, i = i.parent), a > 0 && 0 == i.buffer[a - 4] && i.buffer[a - 1] > -1) {
                        if (t == n) return;
                        if (i.buffer[a - 2] >= t) return void (i.buffer[a - 2] = n);
                    }
                }
                if (o && this.pos != n) {
                    var s = this.buffer.length;
                    if (s > 0 && 0 != this.buffer[s - 4]) for(; s > 0 && this.buffer[s - 2] > n;)this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, r > 4 && (r -= 4);
                    this.buffer[s] = e, this.buffer[s + 1] = t, this.buffer[s + 2] = n, this.buffer[s + 3] = r;
                } else this.buffer.push(e, t, n, r);
            }
        },
        {
            key: "shift",
            value: function(e, t, n, r) {
                if (131072 & e) this.pushState(65535 & e, this.pos);
                else if (0 == (262144 & e)) {
                    var o = e, i = this.p.parser;
                    (r > this.pos || t <= i.maxNode) && (this.pos = r, i.stateFlag(o, 1) || (this.reducePos = r)), this.pushState(o, n), this.shiftContext(t, n), t <= i.maxNode && this.buffer.push(t, n, r, 4);
                } else this.pos = r, this.shiftContext(t, n), t <= this.p.parser.maxNode && this.buffer.push(t, n, r, 4);
            }
        },
        {
            key: "apply",
            value: function(e, t, n, r) {
                65536 & e ? this.reduce(e) : this.shift(e, t, n, r);
            }
        },
        {
            key: "useNode",
            value: function(e, t) {
                var n = this.p.reused.length - 1;
                (n < 0 || this.p.reused[n] != e) && (this.p.reused.push(e), n++);
                var r = this.pos;
                this.reducePos = this.pos = r + e.length, this.pushState(t, r), this.buffer.push(n, r, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
            }
        },
        {
            key: "split",
            value: function() {
                for(var t = this, n = t.buffer.length; n > 0 && t.buffer[n - 2] > t.reducePos;)n -= 4;
                for(var r = t.buffer.slice(n), o = t.bufferBase + n; t && o == t.bufferBase;)t = t.parent;
                return new e(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, o, this.curContext, this.lookAhead, t);
            }
        },
        {
            key: "recoverByDelete",
            value: function(e, t) {
                var n = e <= this.p.parser.maxNode;
                n && this.storeNode(e, this.pos, t, 4), this.storeNode(0, this.pos, t, n ? 8 : 4), this.pos = this.reducePos = t, this.score -= 190;
            }
        },
        {
            key: "canShift",
            value: function(e) {
                for(var t = new z0(this);;){
                    var n = this.p.parser.stateSlot(t.state, 4) || this.p.parser.hasAction(t.state, e);
                    if (0 == n) return !1;
                    if (0 == (65536 & n)) return !0;
                    t.reduce(n);
                }
            }
        },
        {
            key: "recoverByInsert",
            value: function(e) {
                if (this.stack.length >= 300) return [];
                var t = this.p.parser.nextStates(this.state);
                if (t.length > 8 || this.stack.length >= 120) {
                    for(var n, r = [], o = 0; o < t.length; o += 2)(n = t[o + 1]) != this.state && this.p.parser.hasAction(n, e) && r.push(t[o], n);
                    if (this.stack.length < 120) for(var i = function() {
                        var e = t[a + 1];
                        r.some(function(t, n) {
                            return 1 & n && t == e;
                        }) || r.push(t[a], e);
                    }, a = 0; r.length < 8 && a < t.length; a += 2)i();
                    t = r;
                }
                for(var s = [], c = 0; c < t.length && s.length < 4; c += 2){
                    var l = t[c + 1];
                    if (l != this.state) {
                        var u = this.split();
                        u.pushState(l, this.pos), u.storeNode(0, u.pos, u.pos, 4, !0), u.shiftContext(t[c], this.pos), u.reducePos = this.pos, u.score -= 200, s.push(u);
                    }
                }
                return s;
            }
        },
        {
            key: "forceReduce",
            value: function() {
                var e = this.p.parser, t = e.stateSlot(this.state, 5);
                if (0 == (65536 & t)) return !1;
                if (!e.validAction(this.state, t)) {
                    var n = t >> 19, r = 65535 & t, o = this.stack.length - 3 * n;
                    if (o < 0 || e.getGoto(this.stack[o], r, !1) < 0) {
                        var i = this.findForcedReduction();
                        if (null == i) return !1;
                        t = i;
                    }
                    this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
                }
                return this.reducePos = this.pos, this.reduce(t), !0;
            }
        },
        {
            key: "findForcedReduction",
            value: function() {
                var e = this, t = this.p.parser, n = [];
                return function r(o, i) {
                    if (!n.includes(o)) return n.push(o), t.allActions(o, function(n) {
                        if (393216 & n) ;
                        else if (65536 & n) {
                            var o = (n >> 19) - i;
                            if (o > 1) {
                                var a = 65535 & n, s = e.stack.length - 3 * o;
                                if (s >= 0 && t.getGoto(e.stack[s], a, !1) >= 0) return o << 19 | 65536 | a;
                            }
                        } else {
                            var c = r(n, i + 1);
                            if (null != c) return c;
                        }
                    });
                }(this.state, 0);
            }
        },
        {
            key: "forceAll",
            value: function() {
                for(; !this.p.parser.stateFlag(this.state, 2);)if (!this.forceReduce()) {
                    this.storeNode(0, this.pos, this.pos, 4, !0);
                    break;
                }
                return this;
            }
        },
        {
            key: "deadEnd",
            get: function() {
                if (3 != this.stack.length) return !1;
                var e = this.p.parser;
                return 65535 == e.data[e.stateSlot(this.state, 1)] && !e.stateSlot(this.state, 4);
            }
        },
        {
            key: "restart",
            value: function() {
                this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
            }
        },
        {
            key: "sameState",
            value: function(e) {
                if (this.state != e.state || this.stack.length != e.stack.length) return !1;
                for(var t = 0; t < this.stack.length; t += 3)if (this.stack[t] != e.stack[t]) return !1;
                return !0;
            }
        },
        {
            key: "parser",
            get: function() {
                return this.p.parser;
            }
        },
        {
            key: "dialectEnabled",
            value: function(e) {
                return this.p.parser.dialect.flags[e];
            }
        },
        {
            key: "shiftContext",
            value: function(e, t) {
                this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)));
            }
        },
        {
            key: "reduceContext",
            value: function(e, t) {
                this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)));
            }
        },
        {
            key: "emitContext",
            value: function() {
                var e = this.buffer.length - 1;
                (e < 0 || -3 != this.buffer[e]) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
            }
        },
        {
            key: "emitLookAhead",
            value: function() {
                var e = this.buffer.length - 1;
                (e < 0 || -4 != this.buffer[e]) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
            }
        },
        {
            key: "updateContext",
            value: function(e) {
                if (e != this.curContext.context) {
                    var t = new D0(this.curContext.tracker, e);
                    t.hash != this.curContext.hash && this.emitContext(), this.curContext = t;
                }
            }
        },
        {
            key: "setLookAhead",
            value: function(e) {
                e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
            }
        },
        {
            key: "close",
            value: function() {
                this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
            }
        }
    ], [
        {
            key: "start",
            value: function(t, n) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o = t.parser.context;
                return new e(t, [], n, r, r, 0, [], 0, o ? new D0(o, o.start) : null, 0, null);
            }
        }
    ]), e;
}(), D0 = Do(function e(t, n) {
    No(this, e), this.tracker = t, this.context = n, this.hash = t.strict ? t.hash(n) : 0;
}), z0 = function() {
    function e(t) {
        No(this, e), this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
    }
    return Do(e, [
        {
            key: "reduce",
            value: function(e) {
                var t = 65535 & e, n = e >> 19;
                0 == n ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= 3 * (n - 1);
                var r = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
                this.state = r;
            }
        }
    ]), e;
}(), q0 = function() {
    function e(t, n, r) {
        No(this, e), this.stack = t, this.pos = n, this.index = r, this.buffer = t.buffer, 0 == this.index && this.maybeNext();
    }
    return Do(e, [
        {
            key: "maybeNext",
            value: function() {
                var e = this.stack.parent;
                null != e && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
            }
        },
        {
            key: "id",
            get: function() {
                return this.buffer[this.index - 4];
            }
        },
        {
            key: "start",
            get: function() {
                return this.buffer[this.index - 3];
            }
        },
        {
            key: "end",
            get: function() {
                return this.buffer[this.index - 2];
            }
        },
        {
            key: "size",
            get: function() {
                return this.buffer[this.index - 1];
            }
        },
        {
            key: "next",
            value: function() {
                this.index -= 4, this.pos -= 4, 0 == this.index && this.maybeNext();
            }
        },
        {
            key: "fork",
            value: function() {
                return new e(this.stack, this.pos, this.index);
            }
        }
    ], [
        {
            key: "create",
            value: function(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.bufferBase + t.buffer.length;
                return new e(t, n, n - t.bufferBase);
            }
        }
    ]), e;
}();
function B0(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Uint16Array;
    if ("string" != typeof e) return e;
    for(var n = null, r = 0, o = 0; r < e.length;){
        for(var i = 0;;){
            var a = e.charCodeAt(r++), s = !1;
            if (126 == a) {
                i = 65535;
                break;
            }
            a >= 92 && a--, a >= 34 && a--;
            var c = a - 32;
            if (c >= 46 && (c -= 46, s = !0), i += c, s) break;
            i *= 46;
        }
        n ? n[o++] = i : n = new t(i);
    }
    return n;
}
var L0 = Do(function e() {
    No(this, e), this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
}), F0 = new L0, V0 = function() {
    function e(t, n) {
        No(this, e), this.input = t, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = F0, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
    }
    return Do(e, [
        {
            key: "resolveOffset",
            value: function(e, t) {
                for(var n = this.range, r = this.rangeIndex, o = this.pos + e; o < n.from;){
                    if (!r) return null;
                    var i = this.ranges[--r];
                    o -= n.from - i.to, n = i;
                }
                for(; t < 0 ? o > n.to : o >= n.to;){
                    if (r == this.ranges.length - 1) return null;
                    var a = this.ranges[++r];
                    o += a.from - n.to, n = a;
                }
                return o;
            }
        },
        {
            key: "clipPos",
            value: function(e) {
                if (e >= this.range.from && e < this.range.to) return e;
                var t, n = bo(this.ranges);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = t.value;
                        if (r.to > e) return Math.max(e, r.from);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                return this.end;
            }
        },
        {
            key: "peek",
            value: function(e) {
                var t, n, r = this.chunkOff + e;
                if (r >= 0 && r < this.chunk.length) t = this.pos + e, n = this.chunk.charCodeAt(r);
                else {
                    var o = this.resolveOffset(e, 1);
                    if (null == o) return -1;
                    if ((t = o) >= this.chunk2Pos && t < this.chunk2Pos + this.chunk2.length) n = this.chunk2.charCodeAt(t - this.chunk2Pos);
                    else {
                        for(var i = this.rangeIndex, a = this.range; a.to <= t;)a = this.ranges[++i];
                        this.chunk2 = this.input.chunk(this.chunk2Pos = t), t + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - t)), n = this.chunk2.charCodeAt(0);
                    }
                }
                return t >= this.token.lookAhead && (this.token.lookAhead = t + 1), n;
            }
        },
        {
            key: "acceptToken",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = t ? this.resolveOffset(t, -1) : this.pos;
                if (null == n || n < this.token.start) throw new RangeError("Token end out of bounds");
                this.token.value = e, this.token.end = n;
            }
        },
        {
            key: "getChunk",
            value: function() {
                if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
                    var e = this.chunk, t = this.chunkPos;
                    this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = t, this.chunkOff = this.pos - this.chunkPos;
                } else {
                    this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
                    var n = this.input.chunk(this.pos), r = this.pos + n.length;
                    this.chunk = r > this.range.to ? n.slice(0, this.range.to - this.pos) : n, this.chunkPos = this.pos, this.chunkOff = 0;
                }
            }
        },
        {
            key: "readNext",
            value: function() {
                return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
            }
        },
        {
            key: "advance",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                for(this.chunkOff += e; this.pos + e >= this.range.to;){
                    if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
                    e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
                }
                return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
            }
        },
        {
            key: "setDone",
            value: function() {
                return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
            }
        },
        {
            key: "reset",
            value: function(e, t) {
                if (t ? (this.token = t, t.start = e, t.lookAhead = e + 1, t.value = t.extended = -1) : this.token = F0, this.pos != e) {
                    if (this.pos = e, e == this.end) return this.setDone(), this;
                    for(; e < this.range.from;)this.range = this.ranges[--this.rangeIndex];
                    for(; e >= this.range.to;)this.range = this.ranges[++this.rangeIndex];
                    e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
                }
                return this;
            }
        },
        {
            key: "read",
            value: function(e, t) {
                if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length) return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
                if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
                if (e >= this.range.from && t <= this.range.to) return this.input.read(e, t);
                var n, r = "", o = bo(this.ranges);
                try {
                    for(o.s(); !(n = o.n()).done;){
                        var i = n.value;
                        if (i.from >= t) break;
                        i.to > e && (r += this.input.read(Math.max(i.from, e), Math.min(i.to, t)));
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return r;
            }
        }
    ]), e;
}(), H0 = function() {
    function e(t, n) {
        No(this, e), this.data = t, this.id = n;
    }
    return Do(e, [
        {
            key: "token",
            value: function(e, t) {
                var n = t.p.parser;
                !function(e, t, n, r, o, i) {
                    var a = 0, s = 1 << r, c = n.p.parser.dialect;
                    e: for(; 0 != (s & e[a]);){
                        for(var l = e[a + 1], u = a + 3; u < l; u += 2)if ((e[u + 1] & s) > 0) {
                            var f = e[u];
                            if (c.allows(f) && (-1 == t.token.value || t.token.value == f || U0(f, t.token.value, o, i))) {
                                t.acceptToken(f);
                                break;
                            }
                        }
                        var d = t.next, h = 0, v = e[a + 2];
                        if (!(t.next < 0 && v > h && 65535 == e[l + 3 * v - 3])) {
                            for(; h < v;){
                                var p = h + v >> 1, m = l + p + (p << 1), g = e[m], y = e[m + 1] || 65536;
                                if (d < g) v = p;
                                else {
                                    if (!(d >= y)) {
                                        a = e[m + 2], t.advance();
                                        continue e;
                                    }
                                    h = p + 1;
                                }
                            }
                            break;
                        }
                        a = e[l + 3 * v - 1];
                    }
                }(this.data, e, t, this.id, n.data, n.tokenPrecTable);
            }
        }
    ]), e;
}();
function W0(e, t, n) {
    for(var r, o = t; 65535 != (r = e[o]); o++)if (r == n) return o - t;
    return -1;
}
function U0(e, t, n, r) {
    var o = W0(n, r, t);
    return o < 0 || W0(n, r, e) < o;
}
H0.prototype.contextual = H0.prototype.fallback = H0.prototype.extend = !1, H0.prototype.fallback = H0.prototype.extend = !1;
var J0 = "undefined" != typeof $gbdt3 && $gbdt3.env && /\bparse\b/.test(undefined), K0 = null;
function G0(e, t, n) {
    var r = e.cursor(LG.IncludeAnonymous);
    for(r.moveTo(t);;)if (!(n < 0 ? r.childBefore(t) : r.childAfter(t))) for(;;){
        if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError) return n < 0 ? Math.max(0, Math.min(r.to - 1, t - 25)) : Math.min(e.length, Math.max(r.from + 1, t + 25));
        if (n < 0 ? r.prevSibling() : r.nextSibling()) break;
        if (!r.parent()) return n < 0 ? 0 : e.length;
    }
}
var Q0 = function() {
    function e(t, n) {
        No(this, e), this.fragments = t, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
    }
    return Do(e, [
        {
            key: "nextFragment",
            value: function() {
                var e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
                if (e) {
                    for(this.safeFrom = e.openStart ? G0(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? G0(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length;)this.trees.pop(), this.start.pop(), this.index.pop();
                    this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
                } else this.nextStart = 1e9;
            }
        },
        {
            key: "nodeAt",
            value: function(e) {
                if (e < this.nextStart) return null;
                for(; this.fragment && this.safeTo <= e;)this.nextFragment();
                if (!this.fragment) return null;
                for(;;){
                    var t = this.trees.length - 1;
                    if (t < 0) return this.nextFragment(), null;
                    var n = this.trees[t], r = this.index[t];
                    if (r != n.children.length) {
                        var o = n.children[r], i = this.start[t] + n.positions[r];
                        if (i > e) return this.nextStart = i, null;
                        if (o instanceof WG) {
                            if (i == e) {
                                if (i < this.safeFrom) return null;
                                var a = i + o.length;
                                if (a <= this.safeTo) {
                                    var s = o.prop(DG.lookAhead);
                                    if (!s || a + s < this.fragment.to) return o;
                                }
                            }
                            this.index[t]++, i + o.length >= Math.max(this.safeFrom, e) && (this.trees.push(o), this.start.push(i), this.index.push(0));
                        } else this.index[t]++, this.nextStart = i + o.length;
                    } else this.trees.pop(), this.start.pop(), this.index.pop();
                }
            }
        }
    ]), e;
}(), Y0 = function() {
    function e(t, n) {
        No(this, e), this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map(function(e) {
            return new L0;
        });
    }
    return Do(e, [
        {
            key: "getActions",
            value: function(e) {
                for(var t = 0, n = null, r = e.p.parser, o = r.tokenizers, i = r.stateSlot(e.state, 3), a = e.curContext ? e.curContext.hash : 0, s = 0, c = 0; c < o.length; c++)if (0 != (1 << c & i)) {
                    var l = o[c], u = this.tokens[c];
                    if ((!n || l.fallback) && ((l.contextual || u.start != e.pos || u.mask != i || u.context != a) && (this.updateCachedToken(u, l, e), u.mask = i, u.context = a), u.lookAhead > u.end + 25 && (s = Math.max(u.lookAhead, s)), 0 != u.value)) {
                        var f = t;
                        if (u.extended > -1 && (t = this.addActions(e, u.extended, u.end, t)), t = this.addActions(e, u.value, u.end, t), !l.extend && (n = u, t > f)) break;
                    }
                }
                for(; this.actions.length > t;)this.actions.pop();
                return s && e.setLookAhead(s), n || e.pos != this.stream.end || ((n = new L0).value = e.p.parser.eofTerm, n.start = n.end = e.pos, t = this.addActions(e, n.value, n.end, t)), this.mainToken = n, this.actions;
            }
        },
        {
            key: "getMainToken",
            value: function(e) {
                if (this.mainToken) return this.mainToken;
                var t = new L0, n = e.pos, r = e.p;
                return t.start = n, t.end = Math.min(n + 1, r.stream.end), t.value = n == r.stream.end ? r.parser.eofTerm : 0, t;
            }
        },
        {
            key: "updateCachedToken",
            value: function(e, t, n) {
                var r = this.stream.clipPos(n.pos);
                if (t.token(this.stream.reset(r, e), n), e.value > -1) {
                    for(var o = n.p.parser, i = 0; i < o.specialized.length; i++)if (o.specialized[i] == e.value) {
                        var a = o.specializers[i](this.stream.read(e.start, e.end), n);
                        if (a >= 0 && n.p.parser.dialect.allows(a >> 1)) {
                            0 == (1 & a) ? e.value = a >> 1 : e.extended = a >> 1;
                            break;
                        }
                    }
                } else e.value = 0, e.end = this.stream.clipPos(r + 1);
            }
        },
        {
            key: "putAction",
            value: function(e, t, n, r) {
                for(var o = 0; o < r; o += 3)if (this.actions[o] == e) return r;
                return this.actions[r++] = e, this.actions[r++] = t, this.actions[r++] = n, r;
            }
        },
        {
            key: "addActions",
            value: function(e, t, n, r) {
                for(var o = e.state, i = e.p.parser, a = i.data, s = 0; s < 2; s++)for(var c = i.stateSlot(o, s ? 2 : 1);; c += 3){
                    if (65535 == a[c]) {
                        if (1 != a[c + 1]) {
                            0 == r && 2 == a[c + 1] && (r = this.putAction(n1(a, c + 2), t, n, r));
                            break;
                        }
                        c = n1(a, c + 2);
                    }
                    a[c] == t && (r = this.putAction(n1(a, c + 1), t, n, r));
                }
                return r;
            }
        }
    ]), e;
}(), X0 = function() {
    function e(t, n, r, o) {
        No(this, e), this.parser = t, this.input = n, this.ranges = o, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new V0(n, o), this.tokens = new Y0(t, this.stream), this.topTerm = t.top[1];
        var i = o[0].from;
        this.stacks = [
            I0.start(this, t.top[0], i)
        ], this.fragments = r.length && this.stream.end - i > 4 * t.bufferLength ? new Q0(r, t.nodeSet) : null;
    }
    return Do(e, [
        {
            key: "parsedPos",
            get: function() {
                return this.minStackPos;
            }
        },
        {
            key: "advance",
            value: function() {
                var e, t, n = this.stacks, r = this.minStackPos, o = this.stacks = [];
                if (this.bigReductionCount > 300 && 1 == n.length) {
                    for(var i = jo(n, 1)[0]; i.forceReduce() && i.stack.length && i.stack[i.stack.length - 2] >= this.lastBigReductionStart;);
                    this.bigReductionCount = this.lastBigReductionSize = 0;
                }
                for(var a = 0; a < n.length; a++)for(var s = n[a];;){
                    if (this.tokens.mainToken = null, s.pos > r) o.push(s);
                    else {
                        if (this.advanceStack(s, o, n)) continue;
                        e || (e = [], t = []), e.push(s);
                        var c = this.tokens.getMainToken(s);
                        t.push(c.value, c.end);
                    }
                    break;
                }
                if (!o.length) {
                    var l = e && function(e) {
                        var t, n = null, r = bo(e);
                        try {
                            for(r.s(); !(t = r.n()).done;){
                                var o = t.value, i = o.p.stoppedAt;
                                (o.pos == o.p.stream.end || null != i && o.pos > i) && o.p.parser.stateFlag(o.state, 2) && (!n || n.score < o.score) && (n = o);
                            }
                        } catch (e) {
                            r.e(e);
                        } finally{
                            r.f();
                        }
                        return n;
                    }(e);
                    if (l) return J0 && console.log("Finish with " + this.stackID(l)), this.stackToTree(l);
                    if (this.parser.strict) throw J0 && e && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + r);
                    this.recovering || (this.recovering = 5);
                }
                if (this.recovering && e) {
                    var u = null != this.stoppedAt && e[0].pos > this.stoppedAt ? e[0] : this.runRecovery(e, t, o);
                    if (u) return J0 && console.log("Force-finish " + this.stackID(u)), this.stackToTree(u.forceAll());
                }
                if (this.recovering) {
                    var f = 1 == this.recovering ? 1 : 3 * this.recovering;
                    if (o.length > f) for(o.sort(function(e, t) {
                        return t.score - e.score;
                    }); o.length > f;)o.pop();
                    o.some(function(e) {
                        return e.reducePos > r;
                    }) && this.recovering--;
                } else if (o.length > 1) {
                    e: for(var d = 0; d < o.length - 1; d++)for(var h = o[d], v = d + 1; v < o.length; v++){
                        var p = o[v];
                        if (h.sameState(p) || h.buffer.length > 500 && p.buffer.length > 500) {
                            if (!((h.score - p.score || h.buffer.length - p.buffer.length) > 0)) {
                                o.splice(d--, 1);
                                continue e;
                            }
                            o.splice(v--, 1);
                        }
                    }
                    o.length > 12 && o.splice(12, o.length - 12);
                }
                this.minStackPos = o[0].pos;
                for(var m = 1; m < o.length; m++)o[m].pos < this.minStackPos && (this.minStackPos = o[m].pos);
                return null;
            }
        },
        {
            key: "stopAt",
            value: function(e) {
                if (null != this.stoppedAt && this.stoppedAt < e) throw new RangeError("Can't move stoppedAt forward");
                this.stoppedAt = e;
            }
        },
        {
            key: "advanceStack",
            value: function(e, t, n) {
                var r = e.pos, o = this.parser, i = J0 ? this.stackID(e) + " -> " : "";
                if (null != this.stoppedAt && r > this.stoppedAt) return e.forceReduce() ? e : null;
                if (this.fragments) for(var a = e.curContext && e.curContext.tracker.strict, s = a ? e.curContext.hash : 0, c = this.fragments.nodeAt(r); c;){
                    var l = this.parser.nodeSet.types[c.type.id] == c.type ? o.getGoto(e.state, c.type.id) : -1;
                    if (l > -1 && c.length && (!a || (c.prop(DG.contextHash) || 0) == s)) return e.useNode(c, l), J0 && console.log(i + this.stackID(e) + " (via reuse of ".concat(o.getName(c.type.id), ")")), !0;
                    if (!(c instanceof WG) || 0 == c.children.length || c.positions[0] > 0) break;
                    var u = c.children[0];
                    if (!(u instanceof WG && 0 == c.positions[0])) break;
                    c = u;
                }
                var f = o.stateSlot(e.state, 4);
                if (f > 0) return e.reduce(f), J0 && console.log(i + this.stackID(e) + " (via always-reduce ".concat(o.getName(65535 & f), ")")), !0;
                if (e.stack.length >= 8400) for(; e.stack.length > 6e3 && e.forceReduce(););
                for(var d = this.tokens.getActions(e), h = 0; h < d.length;){
                    var v = d[h++], p = d[h++], m = d[h++], g = h == d.length || !n, y = g ? e : e.split(), b = this.tokens.mainToken;
                    if (y.apply(v, p, b ? b.start : y.pos, m), J0 && console.log(i + this.stackID(y) + " (via ".concat(0 == (65536 & v) ? "shift" : "reduce of ".concat(o.getName(65535 & v)), " for ").concat(o.getName(p), " @ ").concat(r).concat(y == e ? "" : ", split", ")")), g) return !0;
                    y.pos > r ? t.push(y) : n.push(y);
                }
                return !1;
            }
        },
        {
            key: "advanceFully",
            value: function(e, t) {
                for(var n = e.pos;;){
                    if (!this.advanceStack(e, null, null)) return !1;
                    if (e.pos > n) return Z0(e, t), !0;
                }
            }
        },
        {
            key: "runRecovery",
            value: function(e, t, n) {
                for(var r = null, o = !1, i = 0; i < e.length; i++){
                    var a = e[i], s = t[i << 1], c = t[1 + (i << 1)], l = J0 ? this.stackID(a) + " -> " : "";
                    if (a.deadEnd) {
                        if (o) continue;
                        if (o = !0, a.restart(), J0 && console.log(l + this.stackID(a) + " (restarted)"), this.advanceFully(a, n)) continue;
                    }
                    for(var u = a.split(), f = l, d = 0; u.forceReduce() && d < 10; d++){
                        if (J0 && console.log(f + this.stackID(u) + " (via force-reduce)"), this.advanceFully(u, n)) break;
                        J0 && (f = this.stackID(u) + " -> ");
                    }
                    var h, v = bo(a.recoverByInsert(s));
                    try {
                        for(v.s(); !(h = v.n()).done;){
                            var p = h.value;
                            J0 && console.log(l + this.stackID(p) + " (via recover-insert)"), this.advanceFully(p, n);
                        }
                    } catch (e) {
                        v.e(e);
                    } finally{
                        v.f();
                    }
                    this.stream.end > a.pos ? (c == a.pos && (c++, s = 0), a.recoverByDelete(s, c), J0 && console.log(l + this.stackID(a) + " (via recover-delete ".concat(this.parser.getName(s), ")")), Z0(a, n)) : (!r || r.score < a.score) && (r = a);
                }
                return r;
            }
        },
        {
            key: "stackToTree",
            value: function(e) {
                return e.close(), WG.build({
                    buffer: q0.create(e),
                    nodeSet: this.parser.nodeSet,
                    topID: this.topTerm,
                    maxBufferLength: this.parser.bufferLength,
                    reused: this.reused,
                    start: this.ranges[0].from,
                    length: e.pos - this.ranges[0].from,
                    minRepeatType: this.parser.minRepeatTerm
                });
            }
        },
        {
            key: "stackID",
            value: function(e) {
                var t = (K0 || (K0 = new WeakMap)).get(e);
                return t || K0.set(e, t = String.fromCodePoint(this.nextStackID++)), t + e;
            }
        }
    ]), e;
}();
function Z0(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        if (r.pos == e.pos && r.sameState(e)) return void (t[n].score < e.score && (t[n] = e));
    }
    t.push(e);
}
var e1 = function() {
    function e(t, n, r) {
        No(this, e), this.source = t, this.flags = n, this.disabled = r;
    }
    return Do(e, [
        {
            key: "allows",
            value: function(e) {
                return !this.disabled || 0 == this.disabled[e];
            }
        }
    ]), e;
}(), t1 = function(e) {
    function t(e) {
        var n, r;
        if (No(this, t), (r = _o(this, t)).wrappers = [], 14 != e.version) throw new RangeError("Parser version (".concat(e.version, ") doesn't match runtime version (", 14, ")"));
        var o = e.nodeNames.split(" ");
        r.minRepeatTerm = o.length;
        for(var i = 0; i < e.repeatNodeCount; i++)o.push("");
        for(var a = Object.keys(e.topRules).map(function(t) {
            return e.topRules[t][1];
        }), s = [], c = 0; c < o.length; c++)s.push([]);
        function l(e, t, n) {
            s[e].push([
                t,
                t.deserialize(String(n))
            ]);
        }
        if (e.nodeProps) {
            var u, f = bo(e.nodeProps);
            try {
                for(f.s(); !(u = f.n()).done;){
                    var d = u.value, h = d[0];
                    "string" == typeof h && (h = DG[h]);
                    for(var v = 1; v < d.length;){
                        var p = d[v++];
                        if (p >= 0) l(p, h, d[v++]);
                        else {
                            for(var m = d[v + -p], g = -p; g > 0; g--)l(d[v++], h, m);
                            v++;
                        }
                    }
                }
            } catch (e) {
                f.e(e);
            } finally{
                f.f();
            }
        }
        r.nodeSet = new FG(o.map(function(t, n) {
            return BG.define({
                name: n >= r.minRepeatTerm ? void 0 : t,
                id: n,
                props: s[n],
                top: a.indexOf(n) > -1,
                error: 0 == n,
                skipped: e.skippedNodes && e.skippedNodes.indexOf(n) > -1
            });
        })), e.propSources && (r.nodeSet = (n = r.nodeSet).extend.apply(n, Bo(e.propSources))), r.strict = !1, r.bufferLength = 1024;
        var y = B0(e.tokenData);
        r.context = e.context, r.specializerSpecs = e.specialized || [], r.specialized = new Uint16Array(r.specializerSpecs.length);
        for(var b = 0; b < r.specializerSpecs.length; b++)r.specialized[b] = r.specializerSpecs[b].term;
        return r.specializers = r.specializerSpecs.map(r1), r.states = B0(e.states, Uint32Array), r.data = B0(e.stateData), r.goto = B0(e.goto), r.maxTerm = e.maxTerm, r.tokenizers = e.tokenizers.map(function(e) {
            return "number" == typeof e ? new H0(y, e) : e;
        }), r.topRules = e.topRules, r.dialects = e.dialects || {}, r.dynamicPrecedences = e.dynamicPrecedences || null, r.tokenPrecTable = e.tokenPrec, r.termNames = e.termNames || null, r.maxNode = r.nodeSet.types.length - 1, r.dialect = r.parseDialect(), r.top = r.topRules[Object.keys(r.topRules)[0]], r;
    }
    return Ao(t, fQ), Do(t, [
        {
            key: "createParse",
            value: function(e, t, n) {
                var r, o = new X0(this, e, t, n), i = bo(this.wrappers);
                try {
                    for(i.s(); !(r = i.n()).done;)o = (0, r.value)(o, e, t, n);
                } catch (e) {
                    i.e(e);
                } finally{
                    i.f();
                }
                return o;
            }
        },
        {
            key: "getGoto",
            value: function(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = this.goto;
                if (t >= r[0]) return -1;
                for(var o = r[t + 1];;){
                    var i = r[o++], a = 1 & i, s = r[o++];
                    if (a && n) return s;
                    for(var c = o + (i >> 1); o < c; o++)if (r[o] == e) return s;
                    if (a) return -1;
                }
            }
        },
        {
            key: "hasAction",
            value: function(e, t) {
                for(var n = this.data, r = 0; r < 2; r++)for(var o, i = this.stateSlot(e, r ? 2 : 1);; i += 3){
                    if (65535 == (o = n[i])) {
                        if (1 != n[i + 1]) {
                            if (2 == n[i + 1]) return n1(n, i + 2);
                            break;
                        }
                        o = n[i = n1(n, i + 2)];
                    }
                    if (o == t || 0 == o) return n1(n, i + 1);
                }
                return 0;
            }
        },
        {
            key: "stateSlot",
            value: function(e, t) {
                return this.states[6 * e + t];
            }
        },
        {
            key: "stateFlag",
            value: function(e, t) {
                return (this.stateSlot(e, 0) & t) > 0;
            }
        },
        {
            key: "validAction",
            value: function(e, t) {
                return !!this.allActions(e, function(e) {
                    return e == t || null;
                });
            }
        },
        {
            key: "allActions",
            value: function(e, t) {
                for(var n = this.stateSlot(e, 4), r = n ? t(n) : void 0, o = this.stateSlot(e, 1); null == r; o += 3){
                    if (65535 == this.data[o]) {
                        if (1 != this.data[o + 1]) break;
                        o = n1(this.data, o + 2);
                    }
                    r = t(n1(this.data, o + 1));
                }
                return r;
            }
        },
        {
            key: "nextStates",
            value: function(e) {
                for(var t = this, n = [], r = function(e) {
                    if (65535 == t.data[e]) {
                        if (1 != t.data[e + 1]) return o = e, 1;
                        e = n1(t.data, e + 2);
                    }
                    if (0 == (1 & t.data[e + 2])) {
                        var r = t.data[e + 1];
                        n.some(function(e, t) {
                            return 1 & t && e == r;
                        }) || n.push(t.data[e], r);
                    }
                    o = e;
                }, o = this.stateSlot(e, 1); !r(o); o += 3);
                return n;
            }
        },
        {
            key: "configure",
            value: function(e) {
                var n, r = Object.assign(Object.create(t.prototype), this);
                if (e.props && (r.nodeSet = (n = this.nodeSet).extend.apply(n, Bo(e.props))), e.top) {
                    var o = this.topRules[e.top];
                    if (!o) throw new RangeError("Invalid top rule name ".concat(e.top));
                    r.top = o;
                }
                return e.tokenizers && (r.tokenizers = this.tokenizers.map(function(t) {
                    var n = e.tokenizers.find(function(e) {
                        return e.from == t;
                    });
                    return n ? n.to : t;
                })), e.specializers && (r.specializers = this.specializers.slice(), r.specializerSpecs = this.specializerSpecs.map(function(t, n) {
                    var o = e.specializers.find(function(e) {
                        return e.from == t.external;
                    });
                    if (!o) return t;
                    var i = Object.assign(Object.assign({}, t), {
                        external: o.to
                    });
                    return r.specializers[n] = r1(i), i;
                })), e.contextTracker && (r.context = e.contextTracker), e.dialect && (r.dialect = this.parseDialect(e.dialect)), null != e.strict && (r.strict = e.strict), e.wrap && (r.wrappers = r.wrappers.concat(e.wrap)), null != e.bufferLength && (r.bufferLength = e.bufferLength), r;
            }
        },
        {
            key: "hasWrappers",
            value: function() {
                return this.wrappers.length > 0;
            }
        },
        {
            key: "getName",
            value: function(e) {
                return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
            }
        },
        {
            key: "eofTerm",
            get: function() {
                return this.maxNode + 1;
            }
        },
        {
            key: "topNode",
            get: function() {
                return this.nodeSet.types[this.top[1]];
            }
        },
        {
            key: "dynamicPrecedence",
            value: function(e) {
                var t = this.dynamicPrecedences;
                return null == t ? 0 : t[e] || 0;
            }
        },
        {
            key: "parseDialect",
            value: function(e) {
                var t = Object.keys(this.dialects), n = t.map(function() {
                    return !1;
                });
                if (e) {
                    var r, o = bo(e.split(" "));
                    try {
                        for(o.s(); !(r = o.n()).done;){
                            var i = r.value, a = t.indexOf(i);
                            a >= 0 && (n[a] = !0);
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                }
                for(var s = null, c = 0; c < t.length; c++)if (!n[c]) for(var l, u = this.dialects[t[c]]; 65535 != (l = this.data[u++]);)(s || (s = new Uint8Array(this.maxTerm + 1)))[l] = 1;
                return new e1(e, n, s);
            }
        }
    ], [
        {
            key: "deserialize",
            value: function(e) {
                return new t(e);
            }
        }
    ]), t;
}();
function n1(e, t) {
    return e[t] | e[t + 1] << 16;
}
function r1(e) {
    if (e.external) {
        var t = e.extend ? 1 : 0;
        return function(n, r) {
            return e.external(n, r) << 1 | t;
        };
    }
    return e.get;
}
var o1 = gQ({
    String: qQ.string,
    Number: qQ.number,
    "True False": qQ.bool,
    PropertyName: qQ.propertyName,
    Null: qQ.null,
    ",": qQ.separator,
    "[ ]": qQ.squareBracket,
    "{ }": qQ.brace
}), i1 = t1.deserialize({
    version: 14,
    states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j",
    stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O",
    goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
    nodeNames: "\u26A0 JsonText True False Null Number String } { Object Property PropertyName ] [ Array",
    maxTerm: 25,
    nodeProps: [
        [
            "openedBy",
            7,
            "{",
            12,
            "["
        ],
        [
            "closedBy",
            8,
            "}",
            13,
            "]"
        ]
    ],
    propSources: [
        o1
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 2,
    tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oc~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Oe~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zOh~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yOg~~'OO]~~'TO[~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
    tokenizers: [
        0
    ],
    topRules: {
        JsonText: [
            0,
            1
        ]
    },
    tokenPrec: 0
}), a1 = HQ.define({
    name: "json",
    parser: i1.configure({
        props: [
            cY.add({
                Object: vY({
                    except: /^\s*\}/
                }),
                Array: vY({
                    except: /^\s*\]/
                })
            }),
            gY.add({
                "Object Array": function(e) {
                    var t = e.firstChild, n = e.lastChild;
                    return t && t.to < n.from ? {
                        from: t.to,
                        to: n.type.isError ? e.to : n.from
                    } : null;
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "[",
                "{",
                '"'
            ]
        },
        indentOnInput: /^\s*[\}\]]$/
    }
});
var s1 = "function" == typeof String.prototype.normalize ? function(e) {
    return e.normalize("NFKD");
} : function(e) {
    return e;
}, c1 = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length, i = arguments.length > 4 ? arguments[4] : void 0, a = arguments.length > 5 ? arguments[5] : void 0;
        No(this, e), this.test = a, this.value = {
            from: 0,
            to: 0
        }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = t.iterRange(r, o), this.bufferStart = r, this.normalize = i ? function(e) {
            return i(s1(e));
        } : s1, this.query = this.normalize(n);
    }
    return Do(e, [
        {
            key: "peek",
            value: function() {
                if (this.bufferPos == this.buffer.length) {
                    if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done) return -1;
                    this.bufferPos = 0, this.buffer = this.iter.value;
                }
                return yF(this.buffer, this.bufferPos);
            }
        },
        {
            key: "next",
            value: function() {
                for(; this.matches.length;)this.matches.pop();
                return this.nextOverlapping();
            }
        },
        {
            key: "nextOverlapping",
            value: function() {
                for(;;){
                    var e = this.peek();
                    if (e < 0) return this.done = !0, this;
                    var t = bF(e), n = this.bufferStart + this.bufferPos;
                    this.bufferPos += wF(e);
                    for(var r = this.normalize(t), o = 0, i = n;; o++){
                        var a = r.charCodeAt(o), s = this.match(a, i, this.bufferPos + this.bufferStart);
                        if (o == r.length - 1) {
                            if (s) return this.value = s, this;
                            break;
                        }
                        i == n && o < t.length && t.charCodeAt(o) == a && i++;
                    }
                }
            }
        },
        {
            key: "match",
            value: function(e, t, n) {
                for(var r = null, o = 0; o < this.matches.length; o += 2){
                    var i = this.matches[o], a = !1;
                    this.query.charCodeAt(i) == e && (i == this.query.length - 1 ? r = {
                        from: this.matches[o + 1],
                        to: n
                    } : (this.matches[o]++, a = !0)), a || (this.matches.splice(o, 2), o -= 2);
                }
                return this.query.charCodeAt(0) == e && (1 == this.query.length ? r = {
                    from: t,
                    to: n
                } : this.matches.push(1, t)), r && this.test && !this.test(r.from, r.to, this.buffer, this.bufferStart) && (r = null), r;
            }
        }
    ]), e;
}();
"undefined" != typeof Symbol && (c1.prototype[Symbol.iterator] = function() {
    return this;
});
var l1 = {
    from: -1,
    to: -1,
    match: /.*/.exec("")
}, u1 = "gm" + (null == /x/.unicode ? "" : "u"), f1 = function() {
    function e(t, n, r) {
        var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : t.length;
        if (No(this, e), this.text = t, this.to = i, this.curLine = "", this.done = !1, this.value = l1, /\\[sWDnr]|\n|\r|\[\^/.test(n)) return new v1(t, n, r, o, i);
        this.re = new RegExp(n, u1 + ((null == r ? void 0 : r.ignoreCase) ? "i" : "")), this.test = null == r ? void 0 : r.test, this.iter = t.iter();
        var a = t.lineAt(o);
        this.curLineStart = a.from, this.matchPos = p1(t, o), this.getLine(this.curLineStart);
    }
    return Do(e, [
        {
            key: "getLine",
            value: function(e) {
                this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
            }
        },
        {
            key: "nextLine",
            value: function() {
                this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
            }
        },
        {
            key: "next",
            value: function() {
                for(var e = this.matchPos - this.curLineStart;;){
                    this.re.lastIndex = e;
                    var t = this.matchPos <= this.to && this.re.exec(this.curLine);
                    if (t) {
                        var n = this.curLineStart + t.index, r = n + t[0].length;
                        if (this.matchPos = p1(this.text, r + (n == r ? 1 : 0)), n == this.curLineStart + this.curLine.length && this.nextLine(), (n < r || n > this.value.to) && (!this.test || this.test(n, r, t))) return this.value = {
                            from: n,
                            to: r,
                            match: t
                        }, this;
                        e = this.matchPos - this.curLineStart;
                    } else {
                        if (!(this.curLineStart + this.curLine.length < this.to)) return this.done = !0, this;
                        this.nextLine(), e = 0;
                    }
                }
            }
        }
    ]), e;
}(), d1 = new WeakMap, h1 = function() {
    function e(t, n) {
        No(this, e), this.from = t, this.text = n;
    }
    return Do(e, [
        {
            key: "to",
            get: function() {
                return this.from + this.text.length;
            }
        }
    ], [
        {
            key: "get",
            value: function(t, n, r) {
                var o = d1.get(t);
                if (!o || o.from >= r || o.to <= n) {
                    var i = new e(n, t.sliceString(n, r));
                    return d1.set(t, i), i;
                }
                if (o.from == n && o.to == r) return o;
                var a = o.text, s = o.from;
                return s > n && (a = t.sliceString(n, s) + a, s = n), o.to < r && (a += t.sliceString(o.to, r)), d1.set(t, new e(s, a)), new e(n, a.slice(n - s, r - s));
            }
        }
    ]), e;
}(), v1 = function() {
    function e(t, n, r, o, i) {
        No(this, e), this.text = t, this.to = i, this.done = !1, this.value = l1, this.matchPos = p1(t, o), this.re = new RegExp(n, u1 + ((null == r ? void 0 : r.ignoreCase) ? "i" : "")), this.test = null == r ? void 0 : r.test, this.flat = h1.get(t, o, this.chunkEnd(o + 5e3));
    }
    return Do(e, [
        {
            key: "chunkEnd",
            value: function(e) {
                return e >= this.to ? this.to : this.text.lineAt(e).to;
            }
        },
        {
            key: "next",
            value: function() {
                for(;;){
                    var e = this.re.lastIndex = this.matchPos - this.flat.from, t = this.re.exec(this.flat.text);
                    if (t && !t[0] && t.index == e && (this.re.lastIndex = e + 1, t = this.re.exec(this.flat.text)), t) {
                        var n = this.flat.from + t.index, r = n + t[0].length;
                        if ((this.flat.to >= this.to || t.index + t[0].length <= this.flat.text.length - 10) && (!this.test || this.test(n, r, t))) return this.value = {
                            from: n,
                            to: r,
                            match: t
                        }, this.matchPos = p1(this.text, r + (n == r ? 1 : 0)), this;
                    }
                    if (this.flat.to == this.to) return this.done = !0, this;
                    this.flat = h1.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + 2 * this.flat.text.length));
                }
            }
        }
    ]), e;
}();
function p1(e, t) {
    if (t >= e.length) return t;
    for(var n, r = e.lineAt(t); t < r.to && (n = r.text.charCodeAt(t - r.from)) >= 56320 && n < 57344;)t++;
    return t;
}
function m1(e) {
    var t = ZZ("input", {
        class: "cm-textfield",
        name: "line",
        value: String(e.state.doc.lineAt(e.state.selection.main.head).number)
    });
    function n() {
        var n = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(t.value);
        if (n) {
            var r = e.state, o = r.doc.lineAt(r.selection.main.head), i = jo(n, 5), a = i[1], s = i[2], c = i[3], l = i[4], u = c ? +c.slice(1) : 0, f = s ? +s : o.number;
            if (s && l) {
                var d = f / 100;
                a && (d = d * ("-" == a ? -1 : 1) + o.number / r.doc.lines), f = Math.round(r.doc.lines * d);
            } else s && a && (f = f * ("-" == a ? -1 : 1) + o.number);
            var h = r.doc.line(Math.max(1, Math.min(r.doc.lines, f))), v = PF.cursor(h.from + Math.max(0, Math.min(u, h.length)));
            e.dispatch({
                effects: [
                    g1.of(!1),
                    WJ.scrollIntoView(v.from, {
                        y: "center"
                    })
                ],
                selection: v
            }), e.focus();
        }
    }
    return {
        dom: ZZ("form", {
            class: "cm-gotoLine",
            onkeydown: function(t) {
                27 == t.keyCode ? (t.preventDefault(), e.dispatch({
                    effects: g1.of(!1)
                }), e.focus()) : 13 == t.keyCode && (t.preventDefault(), n());
            },
            onsubmit: function(e) {
                e.preventDefault(), n();
            }
        }, ZZ("label", e.state.phrase("Go to line"), ": ", t), " ", ZZ("button", {
            class: "cm-button",
            type: "submit"
        }, e.state.phrase("go")))
    };
}
"undefined" != typeof Symbol && (f1.prototype[Symbol.iterator] = v1.prototype[Symbol.iterator] = function() {
    return this;
});
var g1 = uV.define(), y1 = LF.define({
    create: function() {
        return !0;
    },
    update: function(e, t) {
        var n, r = bo(t.effects);
        try {
            for(r.s(); !(n = r.n()).done;){
                var o = n.value;
                o.is(g1) && (e = o.value);
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        return e;
    },
    provide: function(e) {
        return dG.from(e, function(e) {
            return e ? m1 : null;
        });
    }
}), b1 = WJ.baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        "& label": {
            fontSize: "80%"
        }
    }
}), w1 = {
    highlightWordAroundCursor: !1,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: !1
}, x1 = NF.define({
    combine: function(e) {
        return jV(e, w1, {
            highlightWordAroundCursor: function(e, t) {
                return e || t;
            },
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
var k1 = eW.mark({
    class: "cm-selectionMatch"
}), j1 = eW.mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
function S1(e, t, n, r) {
    return !(0 != n && e(t.sliceDoc(n - 1, n)) == bV.Word || r != t.doc.length && e(t.sliceDoc(r, r + 1)) == bV.Word);
}
var C1 = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.decorations = this.getDeco(t);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                (e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
            }
        },
        {
            key: "getDeco",
            value: function(e) {
                var t = e.state.facet(x1), n = e.state, r = n.selection;
                if (r.ranges.length > 1) return eW.none;
                var o, i = r.main, a = null;
                if (i.empty) {
                    if (!t.highlightWordAroundCursor) return eW.none;
                    var s = n.wordAt(i.head);
                    if (!s) return eW.none;
                    a = n.charCategorizer(i.head), o = n.sliceDoc(s.from, s.to);
                } else {
                    var c = i.to - i.from;
                    if (c < t.minSelectionLength || c > 200) return eW.none;
                    if (t.wholeWords) {
                        if (o = n.sliceDoc(i.from, i.to), !S1(a = n.charCategorizer(i.head), n, i.from, i.to) || !function(e, t, n, r) {
                            return e(t.sliceDoc(n, n + 1)) == bV.Word && e(t.sliceDoc(r - 1, r)) == bV.Word;
                        }(a, n, i.from, i.to)) return eW.none;
                    } else if (!(o = n.sliceDoc(i.from, i.to))) return eW.none;
                }
                var l, u = [], f = bo(e.visibleRanges);
                try {
                    for(f.s(); !(l = f.n()).done;)for(var d = l.value, h = new c1(n.doc, o, d.from, d.to); !h.next().done;){
                        var v = h.value, p = v.from, m = v.to;
                        if ((!a || S1(a, n, p, m)) && (i.empty && p <= i.from && m >= i.to ? u.push(j1.range(p, m)) : (p >= i.to || m <= i.from) && u.push(k1.range(p, m)), u.length > t.maxMatches)) return eW.none;
                    }
                } catch (e) {
                    f.e(e);
                } finally{
                    f.f();
                }
                return eW.set(u);
            }
        }
    ]), e;
}(), {
    decorations: function(e) {
        return e.decorations;
    }
}), $1 = WJ.baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
var _1 = NF.define({
    combine: function(e) {
        return jV(e, {
            top: !1,
            caseSensitive: !1,
            literal: !1,
            regexp: !1,
            wholeWord: !1,
            createPanel: function(e) {
                return new r2(e);
            },
            scrollToMatch: function(e) {
                return WJ.scrollIntoView(e);
            }
        });
    }
});
function O1(e) {
    return e ? [
        _1.of(e),
        l2
    ] : l2;
}
var M1 = function() {
    function e(t) {
        No(this, e), this.search = t.search, this.caseSensitive = !!t.caseSensitive, this.literal = !!t.literal, this.regexp = !!t.regexp, this.replace = t.replace || "", this.valid = !!this.search && (!this.regexp || function(e) {
            try {
                return new RegExp(e, u1), !0;
            } catch (e) {
                return !1;
            }
        }(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!t.wholeWord;
    }
    return Do(e, [
        {
            key: "unquote",
            value: function(e) {
                return this.literal ? e : e.replace(/\\([nrt\\])/g, function(e, t) {
                    return "n" == t ? "\n" : "r" == t ? "\r" : "t" == t ? "	" : "\\";
                });
            }
        },
        {
            key: "eq",
            value: function(e) {
                return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
            }
        },
        {
            key: "create",
            value: function() {
                return this.regexp ? new I1(this) : new P1(this);
            }
        },
        {
            key: "getCursor",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 ? arguments[2] : void 0, r = e.doc ? e : kV.create({
                    doc: e
                });
                return null == n && (n = r.doc.length), this.regexp ? T1(this, r, t, n) : A1(this, r, t, n);
            }
        }
    ]), e;
}(), E1 = Do(function e(t) {
    No(this, e), this.spec = t;
});
function A1(e, t, n, r) {
    return new c1(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : function(e) {
        return e.toLowerCase();
    }, e.wholeWord ? function(e, t) {
        return function(n, r, o, i) {
            return (i > n || i + o.length < r) && (i = Math.max(0, n - 2), o = e.sliceString(i, Math.min(e.length, r + 2))), !(t(R1(o, n - i)) == bV.Word && t(N1(o, n - i)) == bV.Word || t(N1(o, r - i)) == bV.Word && t(R1(o, r - i)) == bV.Word);
        };
    }(t.doc, t.charCategorizer(t.selection.main.head)) : void 0);
}
var P1 = function(e) {
    function t(e) {
        return No(this, t), _o(this, t, [
            e
        ]);
    }
    return Ao(t, E1), Do(t, [
        {
            key: "nextMatch",
            value: function(e, t, n) {
                var r = A1(this.spec, e, n, e.doc.length).nextOverlapping();
                return r.done && (r = A1(this.spec, e, 0, t).nextOverlapping()), r.done ? null : r.value;
            }
        },
        {
            key: "prevMatchInRange",
            value: function(e, t, n) {
                for(var r = n;;){
                    for(var o = Math.max(t, r - 1e4 - this.spec.unquoted.length), i = A1(this.spec, e, o, r), a = null; !i.nextOverlapping().done;)a = i.value;
                    if (a) return a;
                    if (o == t) return null;
                    r -= 1e4;
                }
            }
        },
        {
            key: "prevMatch",
            value: function(e, t, n) {
                return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.doc.length);
            }
        },
        {
            key: "getReplacement",
            value: function(e) {
                return this.spec.unquote(this.spec.replace);
            }
        },
        {
            key: "matchAll",
            value: function(e, t) {
                for(var n = A1(this.spec, e, 0, e.doc.length), r = []; !n.next().done;){
                    if (r.length >= t) return null;
                    r.push(n.value);
                }
                return r;
            }
        },
        {
            key: "highlight",
            value: function(e, t, n, r) {
                for(var o = A1(this.spec, e, Math.max(0, t - this.spec.unquoted.length), Math.min(n + this.spec.unquoted.length, e.doc.length)); !o.next().done;)r(o.value.from, o.value.to);
            }
        }
    ]), t;
}();
function T1(e, t, n, r) {
    var o;
    return new f1(t.doc, e.search, {
        ignoreCase: !e.caseSensitive,
        test: e.wholeWord ? (o = t.charCategorizer(t.selection.main.head), function(e, t, n) {
            return !n[0].length || (o(R1(n.input, n.index)) != bV.Word || o(N1(n.input, n.index)) != bV.Word) && (o(N1(n.input, n.index + n[0].length)) != bV.Word || o(R1(n.input, n.index + n[0].length)) != bV.Word);
        }) : void 0
    }, n, r);
}
function R1(e, t) {
    return e.slice(hF(e, t, !1), t);
}
function N1(e, t) {
    return e.slice(t, hF(e, t));
}
var I1 = function(e) {
    function t() {
        return No(this, t), _o(this, t, arguments);
    }
    return Ao(t, E1), Do(t, [
        {
            key: "nextMatch",
            value: function(e, t, n) {
                var r = T1(this.spec, e, n, e.doc.length).next();
                return r.done && (r = T1(this.spec, e, 0, t).next()), r.done ? null : r.value;
            }
        },
        {
            key: "prevMatchInRange",
            value: function(e, t, n) {
                for(var r = 1;; r++){
                    for(var o = Math.max(t, n - 1e4 * r), i = T1(this.spec, e, o, n), a = null; !i.next().done;)a = i.value;
                    if (a && (o == t || a.from > o + 10)) return a;
                    if (o == t) return null;
                }
            }
        },
        {
            key: "prevMatch",
            value: function(e, t, n) {
                return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.doc.length);
            }
        },
        {
            key: "getReplacement",
            value: function(e) {
                return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, function(t, n) {
                    return "$" == n ? "$" : "&" == n ? e.match[0] : "0" != n && +n < e.match.length ? e.match[n] : t;
                });
            }
        },
        {
            key: "matchAll",
            value: function(e, t) {
                for(var n = T1(this.spec, e, 0, e.doc.length), r = []; !n.next().done;){
                    if (r.length >= t) return null;
                    r.push(n.value);
                }
                return r;
            }
        },
        {
            key: "highlight",
            value: function(e, t, n, r) {
                for(var o = T1(this.spec, e, Math.max(0, t - 250), Math.min(n + 250, e.doc.length)); !o.next().done;)r(o.value.from, o.value.to);
            }
        }
    ]), t;
}(), D1 = uV.define(), z1 = uV.define(), q1 = LF.define({
    create: function(e) {
        return new B1(Y1(e).create(), null);
    },
    update: function(e, t) {
        var n, r = bo(t.effects);
        try {
            for(r.s(); !(n = r.n()).done;){
                var o = n.value;
                o.is(D1) ? e = new B1(o.value.create(), e.panel) : o.is(z1) && (e = new B1(e.query, o.value ? Q1 : null));
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        return e;
    },
    provide: function(e) {
        return dG.from(e, function(e) {
            return e.panel;
        });
    }
}), B1 = Do(function e(t, n) {
    No(this, e), this.query = t, this.panel = n;
}), L1 = eW.mark({
    class: "cm-searchMatch"
}), F1 = eW.mark({
    class: "cm-searchMatch cm-searchMatch-selected"
}), V1 = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.decorations = this.highlight(t.state.field(q1));
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = e.state.field(q1);
                (t != e.startState.field(q1) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
            }
        },
        {
            key: "highlight",
            value: function(e) {
                var t = e.query;
                if (!e.panel || !t.spec.valid) return eW.none;
                for(var n = this.view, r = new MV, o = 0, i = n.visibleRanges, a = i.length; o < a; o++){
                    for(var s = i[o], c = s.from, l = s.to; o < a - 1 && l > i[o + 1].from - 500;)l = i[++o].to;
                    t.highlight(n.state, c, l, function(e, t) {
                        var o = n.state.selection.ranges.some(function(n) {
                            return n.from == e && n.to == t;
                        });
                        r.add(e, t, o ? F1 : L1);
                    });
                }
                return r.finish();
            }
        }
    ]), e;
}(), {
    decorations: function(e) {
        return e.decorations;
    }
});
function H1(e) {
    return function(t) {
        var n = t.state.field(q1, !1);
        return n && n.query.spec.valid ? e(t, n) : e2(t);
    };
}
var W1 = H1(function(e, t) {
    var n = t.query, r = e.state.selection.main.to, o = n.nextMatch(e.state, r, r);
    if (!o) return !1;
    var i = PF.single(o.from, o.to), a = e.state.facet(_1);
    return e.dispatch({
        selection: i,
        effects: [
            s2(e, o),
            a.scrollToMatch(i.main, e)
        ],
        userEvent: "select.search"
    }), Z1(e), !0;
}), U1 = H1(function(e, t) {
    var n = t.query, r = e.state, o = r.selection.main.from, i = n.prevMatch(r, o, o);
    if (!i) return !1;
    var a = PF.single(i.from, i.to), s = e.state.facet(_1);
    return e.dispatch({
        selection: a,
        effects: [
            s2(e, i),
            s.scrollToMatch(a.main, e)
        ],
        userEvent: "select.search"
    }), Z1(e), !0;
}), J1 = H1(function(e, t) {
    var n = t.query.matchAll(e.state, 1e3);
    return !(!n || !n.length) && (e.dispatch({
        selection: PF.create(n.map(function(e) {
            return PF.range(e.from, e.to);
        })),
        userEvent: "select.search.matches"
    }), !0);
}), K1 = H1(function(e, t) {
    var n = t.query, r = e.state, o = r.selection.main, i = o.from, a = o.to;
    if (r.readOnly) return !1;
    var s = n.nextMatch(r, i, i);
    if (!s) return !1;
    var c, l, u = [], f = [];
    if (s.from == i && s.to == a && (l = r.toText(n.getReplacement(s)), u.push({
        from: s.from,
        to: s.to,
        insert: l
    }), s = n.nextMatch(r, s.from, s.to), f.push(WJ.announce.of(r.phrase("replaced match on line $", r.doc.lineAt(i).number) + "."))), s) {
        var d = 0 == u.length || u[0].from >= s.to ? 0 : s.to - s.from - l.length;
        c = PF.single(s.from - d, s.to - d), f.push(s2(e, s)), f.push(r.facet(_1).scrollToMatch(c.main, e));
    }
    return e.dispatch({
        changes: u,
        selection: c,
        effects: f,
        userEvent: "input.replace"
    }), !0;
}), G1 = H1(function(e, t) {
    var n = t.query;
    if (e.state.readOnly) return !1;
    var r = n.matchAll(e.state, 1e9).map(function(e) {
        return {
            from: e.from,
            to: e.to,
            insert: n.getReplacement(e)
        };
    });
    if (!r.length) return !1;
    var o = e.state.phrase("replaced $ matches", r.length) + ".";
    return e.dispatch({
        changes: r,
        effects: WJ.announce.of(o),
        userEvent: "input.replace.all"
    }), !0;
});
function Q1(e) {
    return e.state.facet(_1).createPanel(e);
}
function Y1(e, t) {
    var n, r, o, i, a, s = e.selection.main, c = s.empty || s.to > s.from + 100 ? "" : e.sliceDoc(s.from, s.to);
    if (t && !c) return t;
    var l = e.facet(_1);
    return new M1({
        search: (null !== (n = null == t ? void 0 : t.literal) && void 0 !== n ? n : l.literal) ? c : c.replace(/\n/g, "\\n"),
        caseSensitive: null !== (r = null == t ? void 0 : t.caseSensitive) && void 0 !== r ? r : l.caseSensitive,
        literal: null !== (o = null == t ? void 0 : t.literal) && void 0 !== o ? o : l.literal,
        regexp: null !== (i = null == t ? void 0 : t.regexp) && void 0 !== i ? i : l.regexp,
        wholeWord: null !== (a = null == t ? void 0 : t.wholeWord) && void 0 !== a ? a : l.wholeWord
    });
}
function X1(e) {
    var t = cG(e, Q1);
    return t && t.dom.querySelector("[main-field]");
}
function Z1(e) {
    var t = X1(e);
    t && t == e.root.activeElement && t.select();
}
var e2 = function(e) {
    var t = e.state.field(q1, !1);
    if (t && t.panel) {
        var n = X1(e);
        if (n && n != e.root.activeElement) {
            var r = Y1(e.state, t.query.spec);
            r.valid && e.dispatch({
                effects: D1.of(r)
            }), n.focus(), n.select();
        }
    } else e.dispatch({
        effects: [
            z1.of(!0),
            t ? D1.of(Y1(e.state, t.query.spec)) : uV.appendConfig.of(l2)
        ]
    });
    return !0;
}, t2 = function(e) {
    var t = e.state.field(q1, !1);
    if (!t || !t.panel) return !1;
    var n = cG(e, Q1);
    return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({
        effects: z1.of(!1)
    }), !0;
}, n2 = [
    {
        key: "Mod-f",
        run: e2,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: W1,
        shift: U1,
        scope: "editor search-panel",
        preventDefault: !0
    },
    {
        key: "Mod-g",
        run: W1,
        shift: U1,
        scope: "editor search-panel",
        preventDefault: !0
    },
    {
        key: "Escape",
        run: t2,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: function(e) {
            var t = e.state, n = e.dispatch, r = t.selection;
            if (r.ranges.length > 1 || r.main.empty) return !1;
            for(var o = r.main, i = o.from, a = o.to, s = [], c = 0, l = new c1(t.doc, t.sliceDoc(i, a)); !l.next().done;){
                if (s.length > 1e3) return !1;
                l.value.from == i && (c = s.length), s.push(PF.range(l.value.from, l.value.to));
            }
            return n(t.update({
                selection: PF.create(s, c),
                userEvent: "select.search.matches"
            })), !0;
        }
    },
    {
        key: "Mod-Alt-g",
        run: function(e) {
            var t = cG(e, m1);
            if (!t) {
                var n = [
                    g1.of(!0)
                ];
                null == e.state.field(y1, !1) && n.push(uV.appendConfig.of([
                    y1,
                    b1
                ])), e.dispatch({
                    effects: n
                }), t = cG(e, m1);
            }
            return t && t.dom.querySelector("input").select(), !0;
        }
    },
    {
        key: "Mod-d",
        run: function(e) {
            var t = e.state, n = e.dispatch, r = t.selection.ranges;
            if (r.some(function(e) {
                return e.from === e.to;
            })) return function(e) {
                var t = e.state, n = e.dispatch, r = t.selection, o = PF.create(r.ranges.map(function(e) {
                    return t.wordAt(e.head) || PF.cursor(e.head);
                }), r.mainIndex);
                return !o.eq(r) && (n(t.update({
                    selection: o
                })), !0);
            }({
                state: t,
                dispatch: n
            });
            var o = t.sliceDoc(r[0].from, r[0].to);
            if (t.selection.ranges.some(function(e) {
                return t.sliceDoc(e.from, e.to) != o;
            })) return !1;
            var i = function(e, t) {
                for(var n, r = e.selection, o = r.main, i = r.ranges, a = e.wordAt(o.head), s = a && a.from == o.from && a.to == o.to, c = function(n, r) {
                    if (r.next(), !r.done) {
                        if (n && i.some(function(e) {
                            return e.from == r.value.from;
                        })) return l = n, u = r, 0;
                        if (s) {
                            var o = e.wordAt(r.value.from);
                            if (!o || o.from != r.value.from || o.to != r.value.to) return l = n, u = r, 0;
                        }
                        return {
                            v: r.value
                        };
                    }
                    if (n) return {
                        v: null
                    };
                    r = new c1(e.doc, t, 0, Math.max(0, i[i.length - 1].from - 1)), l = n = !0, u = r;
                }, l = !1, u = new c1(e.doc, t, i[i.length - 1].to);;)if (0 !== (n = c(l, u)) && n) return n.v;
            }(t, o);
            return !!i && (n(t.update({
                selection: t.selection.addRange(PF.range(i.from, i.to), !1),
                effects: WJ.scrollIntoView(i.to)
            })), !0);
        },
        preventDefault: !0
    }
], r2 = function() {
    function e(t) {
        var n = this;
        No(this, e), this.view = t;
        var r = this.query = t.state.field(q1).query.spec;
        function o(e, t, n) {
            return ZZ("button", {
                class: "cm-button",
                name: e,
                onclick: t,
                type: "button"
            }, n);
        }
        this.commit = this.commit.bind(this), this.searchField = ZZ("input", {
            value: r.search,
            placeholder: o2(t, "Find"),
            "aria-label": o2(t, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        }), this.replaceField = ZZ("input", {
            value: r.replace,
            placeholder: o2(t, "Replace"),
            "aria-label": o2(t, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        }), this.caseField = ZZ("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: r.caseSensitive,
            onchange: this.commit
        }), this.reField = ZZ("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: r.regexp,
            onchange: this.commit
        }), this.wordField = ZZ("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: r.wholeWord,
            onchange: this.commit
        }), this.dom = ZZ("div", {
            onkeydown: function(e) {
                return n.keydown(e);
            },
            class: "cm-search"
        }, [
            this.searchField,
            o("next", function() {
                return W1(t);
            }, [
                o2(t, "next")
            ]),
            o("prev", function() {
                return U1(t);
            }, [
                o2(t, "previous")
            ]),
            o("select", function() {
                return J1(t);
            }, [
                o2(t, "all")
            ]),
            ZZ("label", null, [
                this.caseField,
                o2(t, "match case")
            ]),
            ZZ("label", null, [
                this.reField,
                o2(t, "regexp")
            ]),
            ZZ("label", null, [
                this.wordField,
                o2(t, "by word")
            ])
        ].concat(Bo(t.state.readOnly ? [] : [
            ZZ("br"),
            this.replaceField,
            o("replace", function() {
                return K1(t);
            }, [
                o2(t, "replace")
            ]),
            o("replaceAll", function() {
                return G1(t);
            }, [
                o2(t, "replace all")
            ])
        ]), [
            ZZ("button", {
                name: "close",
                onclick: function() {
                    return t2(t);
                },
                "aria-label": o2(t, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]));
    }
    return Do(e, [
        {
            key: "commit",
            value: function() {
                var e = new M1({
                    search: this.searchField.value,
                    caseSensitive: this.caseField.checked,
                    regexp: this.reField.checked,
                    wholeWord: this.wordField.checked,
                    replace: this.replaceField.value
                });
                e.eq(this.query) || (this.query = e, this.view.dispatch({
                    effects: D1.of(e)
                }));
            }
        },
        {
            key: "keydown",
            value: function(e) {
                !function(e, t, n) {
                    return oK(tK(e.state), t, e, n);
                }(this.view, e, "search-panel") ? 13 == e.keyCode && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? U1 : W1)(this.view)) : 13 == e.keyCode && e.target == this.replaceField && (e.preventDefault(), K1(this.view)) : e.preventDefault();
            }
        },
        {
            key: "update",
            value: function(e) {
                var t, n = bo(e.transactions);
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r, o = bo(t.value.effects);
                        try {
                            for(o.s(); !(r = o.n()).done;){
                                var i = r.value;
                                i.is(D1) && !i.value.eq(this.query) && this.setQuery(i.value);
                            }
                        } catch (e) {
                            o.e(e);
                        } finally{
                            o.f();
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "setQuery",
            value: function(e) {
                this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
            }
        },
        {
            key: "mount",
            value: function() {
                this.searchField.select();
            }
        },
        {
            key: "pos",
            get: function() {
                return 80;
            }
        },
        {
            key: "top",
            get: function() {
                return this.view.state.facet(_1).top;
            }
        }
    ]), e;
}();
function o2(e, t) {
    return e.state.phrase(t);
}
var i2 = 30, a2 = /[\s\.,:;?!]/;
function s2(e, t) {
    var n = t.from, r = t.to, o = e.state.doc.lineAt(n), i = e.state.doc.lineAt(r).to, a = Math.max(o.from, n - i2), s = Math.min(i, r + i2), c = e.state.sliceDoc(a, s);
    if (a != o.from) {
        for(var l = 0; l < i2; l++)if (!a2.test(c[l + 1]) && a2.test(c[l])) {
            c = c.slice(l);
            break;
        }
    }
    if (s != i) {
        for(var u = c.length - 1; u > c.length - i2; u--)if (!a2.test(c[u - 1]) && a2.test(c[u])) {
            c = c.slice(0, u);
            break;
        }
    }
    return WJ.announce.of("".concat(e.state.phrase("current match"), ". ").concat(c, " ").concat(e.state.phrase("on line"), " ").concat(o.number, "."));
}
var c2 = WJ.baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
}), l2 = [
    q1,
    JF.low(V1),
    c2
], u2 = function() {
    function e(t, n, r) {
        No(this, e), this.state = t, this.pos = n, this.explicit = r, this.abortListeners = [];
    }
    return Do(e, [
        {
            key: "tokenBefore",
            value: function(e) {
                for(var t = WQ(this.state).resolveInner(this.pos, -1); t && e.indexOf(t.name) < 0;)t = t.parent;
                return t ? {
                    from: t.from,
                    to: this.pos,
                    text: this.state.sliceDoc(t.from, this.pos),
                    type: t.type
                } : null;
            }
        },
        {
            key: "matchBefore",
            value: function(e) {
                var t = this.state.doc.lineAt(this.pos), n = Math.max(t.from, this.pos - 250), r = t.text.slice(n - t.from, this.pos - t.from), o = r.search(p2(e, !1));
                return o < 0 ? null : {
                    from: n + o,
                    to: this.pos,
                    text: r.slice(o)
                };
            }
        },
        {
            key: "aborted",
            get: function() {
                return null == this.abortListeners;
            }
        },
        {
            key: "addEventListener",
            value: function(e, t) {
                "abort" == e && this.abortListeners && this.abortListeners.push(t);
            }
        }
    ]), e;
}();
function f2(e) {
    var t = Object.keys(e).join(""), n = /\w/.test(t);
    return n && (t = t.replace(/\w/g, "")), "[".concat(n ? "\\w" : "").concat(t.replace(/[^\w\s]/g, "\\$&"), "]");
}
function d2(e) {
    var t = e.map(function(e) {
        return "string" == typeof e ? {
            label: e
        } : e;
    }), n = t.every(function(e) {
        return /^\w+$/.test(e.label);
    }) ? [
        /\w*$/,
        /\w+$/
    ] : function(e) {
        var t, n = Object.create(null), r = Object.create(null), o = bo(e);
        try {
            for(o.s(); !(t = o.n()).done;){
                var i = t.value.label;
                n[i[0]] = !0;
                for(var a = 1; a < i.length; a++)r[i[a]] = !0;
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        var s = f2(n) + f2(r) + "*$";
        return [
            new RegExp("^" + s),
            new RegExp(s)
        ];
    }(t), r = jo(n, 2), o = r[0], i = r[1];
    return function(e) {
        var n = e.matchBefore(i);
        return n || e.explicit ? {
            from: n ? n.from : e.pos,
            options: t,
            validFor: o
        } : null;
    };
}
var h2 = Do(function e(t, n, r, o) {
    No(this, e), this.completion = t, this.source = n, this.match = r, this.score = o;
});
function v2(e) {
    return e.selection.main.from;
}
function p2(e, t) {
    var n, r = e.source, o = t && "^" != r[0], i = "$" != r[r.length - 1];
    return o || i ? new RegExp("".concat(o ? "^" : "", "(?:").concat(r, ")").concat(i ? "$" : ""), null !== (n = e.flags) && void 0 !== n ? n : e.ignoreCase ? "i" : "") : e;
}
var m2 = sV.define();
var g2 = new WeakMap;
function y2(e) {
    if (!Array.isArray(e)) return e;
    var t = g2.get(e);
    return t || g2.set(e, t = d2(e)), t;
}
var b2 = uV.define(), w2 = uV.define(), x2 = function() {
    function e(t) {
        No(this, e), this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
        for(var n = 0; n < t.length;){
            var r = yF(t, n), o = wF(r);
            this.chars.push(r);
            var i = t.slice(n, n + o), a = i.toUpperCase();
            this.folded.push(yF(a == i ? i.toLowerCase() : a, 0)), n += o;
        }
        this.astral = t.length != this.chars.length;
    }
    return Do(e, [
        {
            key: "ret",
            value: function(e, t) {
                return this.score = e, this.matched = t, !0;
            }
        },
        {
            key: "match",
            value: function(e) {
                if (0 == this.pattern.length) return this.ret(-100, []);
                if (e.length < this.pattern.length) return !1;
                var t = this.chars, n = this.folded, r = this.any, o = this.precise, i = this.byWord;
                if (1 == t.length) {
                    var a = yF(e, 0), s = wF(a), c = s == e.length ? 0 : -100;
                    if (a == t[0]) ;
                    else {
                        if (a != n[0]) return !1;
                        c += -200;
                    }
                    return this.ret(c, [
                        0,
                        s
                    ]);
                }
                var l = e.indexOf(this.pattern);
                if (0 == l) return this.ret(e.length == this.pattern.length ? 0 : -100, [
                    0,
                    this.pattern.length
                ]);
                var u = t.length, f = 0;
                if (l < 0) {
                    for(var d = 0, h = Math.min(e.length, 200); d < h && f < u;){
                        var v = yF(e, d);
                        v != t[f] && v != n[f] || (r[f++] = d), d += wF(v);
                    }
                    if (f < u) return !1;
                }
                for(var p = 0, m = 0, g = !1, y = 0, b = -1, w = -1, x = /[a-z]/.test(e), k = !0, j = 0, S = Math.min(e.length, 200), C = 0; j < S && m < u;){
                    var $ = yF(e, j);
                    l < 0 && (p < u && $ == t[p] && (o[p++] = j), y < u && ($ == t[y] || $ == n[y] ? (0 == y && (b = j), w = j + 1, y++) : y = 0));
                    var _ = void 0, O = $ < 255 ? $ >= 48 && $ <= 57 || $ >= 97 && $ <= 122 ? 2 : $ >= 65 && $ <= 90 ? 1 : 0 : (_ = bF($)) != _.toLowerCase() ? 1 : _ != _.toUpperCase() ? 2 : 0;
                    (!j || 1 == O && x || 0 == C && 0 != O) && (t[m] == $ || n[m] == $ && (g = !0) ? i[m++] = j : i.length && (k = !1)), C = O, j += wF($);
                }
                return m == u && 0 == i[0] && k ? this.result((g ? -200 : 0) - 100, i, e) : y == u && 0 == b ? this.ret(-200 - e.length + (w == e.length ? 0 : -100), [
                    0,
                    w
                ]) : l > -1 ? this.ret(-700 - e.length, [
                    l,
                    l + this.pattern.length
                ]) : y == u ? this.ret(-900 - e.length, [
                    b,
                    w
                ]) : m == u ? this.result((g ? -200 : 0) - 100 - 700 + (k ? 0 : -1100), i, e) : 2 != t.length && this.result((r[0] ? -700 : 0) - 200 - 1100, r, e);
            }
        },
        {
            key: "result",
            value: function(e, t, n) {
                var r, o = [], i = 0, a = bo(t);
                try {
                    for(a.s(); !(r = a.n()).done;){
                        var s = r.value, c = s + (this.astral ? wF(yF(n, s)) : 1);
                        i && o[i - 1] == s ? o[i - 1] = c : (o[i++] = s, o[i++] = c);
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return this.ret(e - n.length, o);
            }
        }
    ]), e;
}(), k2 = NF.define({
    combine: function(e) {
        return jV(e, {
            activateOnTyping: !0,
            activateOnTypingDelay: 100,
            selectOnOpen: !0,
            override: null,
            closeOnBlur: !0,
            maxRenderedOptions: 100,
            defaultKeymap: !0,
            tooltipClass: function() {
                return "";
            },
            optionClass: function() {
                return "";
            },
            aboveCursor: !1,
            icons: !0,
            addToOptions: [],
            positionInfo: S2,
            compareCompletions: function(e, t) {
                return e.label.localeCompare(t.label);
            },
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: function(e, t) {
                return e && t;
            },
            closeOnBlur: function(e, t) {
                return e && t;
            },
            icons: function(e, t) {
                return e && t;
            },
            tooltipClass: function(e, t) {
                return function(n) {
                    return j2(e(n), t(n));
                };
            },
            optionClass: function(e, t) {
                return function(n) {
                    return j2(e(n), t(n));
                };
            },
            addToOptions: function(e, t) {
                return e.concat(t);
            }
        });
    }
});
function j2(e, t) {
    return e ? t ? e + " " + t : e : t;
}
function S2(e, t, n, r, o, i) {
    var a, s, c = e.textDirection == lW.RTL, l = c, u = !1, f = "top", d = t.left - o.left, h = o.right - t.right, v = r.right - r.left, p = r.bottom - r.top;
    if (l && d < Math.min(v, h) ? l = !1 : !l && h < Math.min(v, d) && (l = !0), v <= (l ? d : h)) a = Math.max(o.top, Math.min(n.top, o.bottom - p)) - t.top, s = Math.min(400, l ? d : h);
    else {
        u = !0, s = Math.min(400, (c ? t.right : o.right - t.left) - 30);
        var m = o.bottom - t.bottom;
        m >= p || m > t.top ? a = n.bottom - t.top : (f = "bottom", a = t.bottom - n.top);
    }
    var g = (t.bottom - t.top) / i.offsetHeight, y = (t.right - t.left) / i.offsetWidth;
    return {
        style: "".concat(f, ": ").concat(a / g, "px; max-width: ").concat(s / y, "px"),
        class: "cm-completionInfo-" + (u ? c ? "left-narrow" : "right-narrow" : l ? "left" : "right")
    };
}
function C2(e, t, n) {
    if (e <= n) return {
        from: 0,
        to: e
    };
    if (t < 0 && (t = 0), t <= e >> 1) {
        var r = Math.floor(t / n);
        return {
            from: r * n,
            to: (r + 1) * n
        };
    }
    var o = Math.floor((e - t) / n);
    return {
        from: e - (o + 1) * n,
        to: e - o * n
    };
}
var $2 = function() {
    function e(t, n, r) {
        var o = this;
        No(this, e), this.view = t, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
            read: function() {
                return o.measureInfo();
            },
            write: function(e) {
                return o.placeInfo(e);
            },
            key: this
        }, this.space = null, this.currentClass = "";
        var i = t.state.field(n), a = i.open, s = a.options, c = a.selected, l = t.state.facet(k2);
        this.optionContent = function(e) {
            var t = e.addToOptions.slice();
            return e.icons && t.push({
                render: function(e) {
                    var t, n = document.createElement("div");
                    return n.classList.add("cm-completionIcon"), e.type && (t = n.classList).add.apply(t, Bo(e.type.split(/\s+/g).map(function(e) {
                        return "cm-completionIcon-" + e;
                    }))), n.setAttribute("aria-hidden", "true"), n;
                },
                position: 20
            }), t.push({
                render: function(e, t, n, r) {
                    var o = document.createElement("span");
                    o.className = "cm-completionLabel";
                    for(var i = e.displayLabel || e.label, a = 0, s = 0; s < r.length;){
                        var c = r[s++], l = r[s++];
                        c > a && o.appendChild(document.createTextNode(i.slice(a, c)));
                        var u = o.appendChild(document.createElement("span"));
                        u.appendChild(document.createTextNode(i.slice(c, l))), u.className = "cm-completionMatchedText", a = l;
                    }
                    return a < i.length && o.appendChild(document.createTextNode(i.slice(a))), o;
                },
                position: 50
            }, {
                render: function(e) {
                    if (!e.detail) return null;
                    var t = document.createElement("span");
                    return t.className = "cm-completionDetail", t.textContent = e.detail, t;
                },
                position: 80
            }), t.sort(function(e, t) {
                return e.position - t.position;
            }).map(function(e) {
                return e.render;
            });
        }(l), this.optionClass = l.optionClass, this.tooltipClass = l.tooltipClass, this.range = C2(s.length, c, l.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(t.state), this.dom.addEventListener("mousedown", function(e) {
            for(var r, i = t.state.field(n).open.options, a = e.target; a && a != o.dom; a = a.parentNode)if ("LI" == a.nodeName && (r = /-(\d+)$/.exec(a.id)) && +r[1] < i.length) return o.applyCompletion(t, i[+r[1]]), void e.preventDefault();
        }), this.dom.addEventListener("focusout", function(e) {
            var n = t.state.field(o.stateField, !1);
            n && n.tooltip && t.state.facet(k2).closeOnBlur && e.relatedTarget != t.contentDOM && t.dispatch({
                effects: w2.of(null)
            });
        }), this.showOptions(s, i.id);
    }
    return Do(e, [
        {
            key: "mount",
            value: function() {
                this.updateSel();
            }
        },
        {
            key: "showOptions",
            value: function(e, t) {
                var n = this;
                this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", function() {
                    n.info && n.view.requestMeasure(n.placeInfoReq);
                });
            }
        },
        {
            key: "update",
            value: function(e) {
                var t, n = e.state.field(this.stateField), r = e.startState.field(this.stateField);
                if (this.updateTooltipClass(e.state), n != r) {
                    var o = n.open, i = o.options, a = o.selected, s = o.disabled;
                    r.open && r.open.options == i || (this.range = C2(i.length, a, e.state.facet(k2).maxRenderedOptions), this.showOptions(i, n.id)), this.updateSel(), s != (null === (t = r.open) || void 0 === t ? void 0 : t.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!s);
                }
            }
        },
        {
            key: "updateTooltipClass",
            value: function(e) {
                var t = this.tooltipClass(e);
                if (t != this.currentClass) {
                    var n, r = bo(this.currentClass.split(" "));
                    try {
                        for(r.s(); !(n = r.n()).done;){
                            var o = n.value;
                            o && this.dom.classList.remove(o);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                    var i, a = bo(t.split(" "));
                    try {
                        for(a.s(); !(i = a.n()).done;){
                            var s = i.value;
                            s && this.dom.classList.add(s);
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                    this.currentClass = t;
                }
            }
        },
        {
            key: "positioned",
            value: function(e) {
                this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
            }
        },
        {
            key: "updateSel",
            value: function() {
                var e = this, t = this.view.state.field(this.stateField), n = t.open;
                if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = C2(n.options.length, n.selected, this.view.state.facet(k2).maxRenderedOptions), this.showOptions(n.options, t.id)), this.updateSelectedOption(n.selected)) {
                    this.destroyInfo();
                    var r = n.options[n.selected].completion, o = r.info;
                    if (!o) return;
                    var i = "string" == typeof o ? document.createTextNode(o) : o(r);
                    if (!i) return;
                    "then" in i ? i.then(function(n) {
                        n && e.view.state.field(e.stateField, !1) == t && e.addInfoPane(n, r);
                    }).catch(function(t) {
                        return HW(e.view.state, t, "completion info");
                    }) : this.addInfoPane(i, r);
                }
            }
        },
        {
            key: "addInfoPane",
            value: function(e, t) {
                this.destroyInfo();
                var n = this.info = document.createElement("div");
                if (n.className = "cm-tooltip cm-completionInfo", null != e.nodeType) n.appendChild(e), this.infoDestroy = null;
                else {
                    var r = e.dom, o = e.destroy;
                    n.appendChild(r), this.infoDestroy = o || null;
                }
                this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq);
            }
        },
        {
            key: "updateSelectedOption",
            value: function(e) {
                for(var t = null, n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++)"LI" == n.nodeName && n.id ? r == e ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), t = n) : n.hasAttribute("aria-selected") && n.removeAttribute("aria-selected") : r--;
                return t && function(e, t) {
                    var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = n.height / e.offsetHeight;
                    r.top < n.top ? e.scrollTop -= (n.top - r.top) / o : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / o);
                }(this.list, t), t;
            }
        },
        {
            key: "measureInfo",
            value: function() {
                var e = this.dom.querySelector("[aria-selected]");
                if (!e || !this.info) return null;
                var t = this.dom.getBoundingClientRect(), n = this.info.getBoundingClientRect(), r = e.getBoundingClientRect(), o = this.space;
                if (!o) {
                    var i = this.dom.ownerDocument.defaultView || window;
                    o = {
                        left: 0,
                        top: 0,
                        right: i.innerWidth,
                        bottom: i.innerHeight
                    };
                }
                return r.top > Math.min(o.bottom, t.bottom) - 10 || r.bottom < Math.max(o.top, t.top) + 10 ? null : this.view.state.facet(k2).positionInfo(this.view, t, r, n, o, this.dom);
            }
        },
        {
            key: "placeInfo",
            value: function(e) {
                this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
            }
        },
        {
            key: "createListBox",
            value: function(e, t, n) {
                var r = document.createElement("ul");
                r.id = t, r.setAttribute("role", "listbox"), r.setAttribute("aria-expanded", "true"), r.setAttribute("aria-label", this.view.state.phrase("Completions"));
                for(var o = null, i = n.from; i < n.to; i++){
                    var a = e[i], s = a.completion, c = a.match, l = s.section;
                    if (l) {
                        var u = "string" == typeof l ? l : l.name;
                        if (u != o && (i > n.from || 0 == n.from)) {
                            if (o = u, "string" != typeof l && l.header) r.appendChild(l.header(l));
                            else r.appendChild(document.createElement("completion-section")).textContent = u;
                        }
                    }
                    var f = r.appendChild(document.createElement("li"));
                    f.id = t + "-" + i, f.setAttribute("role", "option");
                    var d = this.optionClass(s);
                    d && (f.className = d);
                    var h, v = bo(this.optionContent);
                    try {
                        for(v.s(); !(h = v.n()).done;){
                            var p = (0, h.value)(s, this.view.state, this.view, c);
                            p && f.appendChild(p);
                        }
                    } catch (e) {
                        v.e(e);
                    } finally{
                        v.f();
                    }
                }
                return n.from && r.classList.add("cm-completionListIncompleteTop"), n.to < e.length && r.classList.add("cm-completionListIncompleteBottom"), r;
            }
        },
        {
            key: "destroyInfo",
            value: function() {
                this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
            }
        },
        {
            key: "destroy",
            value: function() {
                this.destroyInfo();
            }
        }
    ]), e;
}();
function _2(e, t) {
    return function(n) {
        return new $2(n, e, t);
    };
}
function O2(e) {
    return 100 * (e.boost || 0) + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + (e.type ? 1 : 0);
}
var M2 = function() {
    function e(t, n, r, o, i, a) {
        No(this, e), this.options = t, this.attrs = n, this.tooltip = r, this.timestamp = o, this.selected = i, this.disabled = a;
    }
    return Do(e, [
        {
            key: "setSelected",
            value: function(t, n) {
                return t == this.selected || t >= this.options.length ? this : new e(this.options, P2(n, t), this.tooltip, this.timestamp, t, this.disabled);
            }
        },
        {
            key: "map",
            value: function(t) {
                return new e(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
                    pos: t.mapPos(this.tooltip.pos)
                }), this.timestamp, this.selected, this.disabled);
            }
        }
    ], [
        {
            key: "build",
            value: function(t, n, r, o, i) {
                var a = function(e, t) {
                    var n, r = [], o = null, i = function(e) {
                        r.push(e);
                        var t = e.completion.section;
                        if (t) {
                            o || (o = []);
                            var n = "string" == typeof t ? t : t.name;
                            o.some(function(e) {
                                return e.name == n;
                            }) || o.push("string" == typeof t ? {
                                name: n
                            } : t);
                        }
                    }, a = bo(e);
                    try {
                        for(a.s(); !(n = a.n()).done;){
                            var s = n.value;
                            if (s.hasResult()) {
                                var c = s.result.getMatch;
                                if (!1 === s.result.filter) {
                                    var l, u = bo(s.result.options);
                                    try {
                                        for(u.s(); !(l = u.n()).done;){
                                            var f = l.value;
                                            i(new h2(f, s.source, c ? c(f) : [], 1e9 - r.length));
                                        }
                                    } catch (e) {
                                        u.e(e);
                                    } finally{
                                        u.f();
                                    }
                                } else {
                                    var d, h = new x2(t.sliceDoc(s.from, s.to)), v = bo(s.result.options);
                                    try {
                                        for(v.s(); !(d = v.n()).done;){
                                            var p = d.value;
                                            if (h.match(p.label)) {
                                                var m = p.displayLabel ? c ? c(p, h.matched) : [] : h.matched;
                                                i(new h2(p, s.source, m, h.score + (p.boost || 0)));
                                            }
                                        }
                                    } catch (e) {
                                        v.e(e);
                                    } finally{
                                        v.f();
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                    if (o) {
                        var g, y = Object.create(null), b = 0, w = bo(o.sort(function(e, t) {
                            var n, r;
                            return (null !== (n = e.rank) && void 0 !== n ? n : 1e9) - (null !== (r = t.rank) && void 0 !== r ? r : 1e9) || (e.name < t.name ? -1 : 1);
                        }));
                        try {
                            for(w.s(); !(g = w.n()).done;){
                                var x = g.value;
                                b -= 1e5, y[x.name] = b;
                            }
                        } catch (e) {
                            w.e(e);
                        } finally{
                            w.f();
                        }
                        var k, j = bo(r);
                        try {
                            for(j.s(); !(k = j.n()).done;){
                                var S = k.value, C = S.completion.section;
                                C && (S.score += y["string" == typeof C ? C : C.name]);
                            }
                        } catch (e) {
                            j.e(e);
                        } finally{
                            j.f();
                        }
                    }
                    var $, _ = [], O = null, M = t.facet(k2).compareCompletions, E = bo(r.sort(function(e, t) {
                        return t.score - e.score || M(e.completion, t.completion);
                    }));
                    try {
                        for(E.s(); !($ = E.n()).done;){
                            var A = $.value, P = A.completion;
                            !O || O.label != P.label || O.detail != P.detail || null != O.type && null != P.type && O.type != P.type || O.apply != P.apply || O.boost != P.boost ? _.push(A) : O2(A.completion) > O2(O) && (_[_.length - 1] = A), O = A.completion;
                        }
                    } catch (e) {
                        E.e(e);
                    } finally{
                        E.f();
                    }
                    return _;
                }(t, n);
                if (!a.length) return o && t.some(function(e) {
                    return 1 == e.state;
                }) ? new e(o.options, o.attrs, o.tooltip, o.timestamp, o.selected, !0) : null;
                var s = n.facet(k2).selectOnOpen ? 0 : -1;
                if (o && o.selected != s && -1 != o.selected) {
                    for(var c = o.options[o.selected].completion, l = 0; l < a.length; l++)if (a[l].completion == c) {
                        s = l;
                        break;
                    }
                }
                return new e(a, P2(r, s), {
                    pos: t.reduce(function(e, t) {
                        return t.hasResult() ? Math.min(e, t.from) : e;
                    }, 1e8),
                    create: L2,
                    above: i.aboveCursor
                }, o ? o.timestamp : Date.now(), s, !1);
            }
        }
    ]), e;
}(), E2 = function() {
    function e(t, n, r) {
        No(this, e), this.active = t, this.id = n, this.open = r;
    }
    return Do(e, [
        {
            key: "update",
            value: function(t) {
                var n = this, r = t.state, o = r.facet(k2), i = (o.override || r.languageDataAt("autocomplete", v2(r)).map(y2)).map(function(e) {
                    return (n.active.find(function(t) {
                        return t.source == e;
                    }) || new N2(e, n.active.some(function(e) {
                        return 0 != e.state;
                    }) ? 1 : 0)).update(t, o);
                });
                i.length == this.active.length && i.every(function(e, t) {
                    return e == n.active[t];
                }) && (i = this.active);
                var a = this.open;
                a && t.docChanged && (a = a.map(t.changes)), t.selection || i.some(function(e) {
                    return e.hasResult() && t.changes.touchesRange(e.from, e.to);
                }) || !function(e, t) {
                    if (e == t) return !0;
                    for(var n = 0, r = 0;;){
                        for(; n < e.length && !e[n].hasResult;)n++;
                        for(; r < t.length && !t[r].hasResult;)r++;
                        var o = n == e.length, i = r == t.length;
                        if (o || i) return o == i;
                        if (e[n++].result != t[r++].result) return !1;
                    }
                }(i, this.active) ? a = M2.build(i, r, this.id, a, o) : a && a.disabled && !i.some(function(e) {
                    return 1 == e.state;
                }) && (a = null), !a && i.every(function(e) {
                    return 1 != e.state;
                }) && i.some(function(e) {
                    return e.hasResult();
                }) && (i = i.map(function(e) {
                    return e.hasResult() ? new N2(e.source, 0) : e;
                }));
                var s, c = bo(t.effects);
                try {
                    for(c.s(); !(s = c.n()).done;){
                        var l = s.value;
                        l.is(z2) && (a = a && a.setSelected(l.value, this.id));
                    }
                } catch (e) {
                    c.e(e);
                } finally{
                    c.f();
                }
                return i == this.active && a == this.open ? this : new e(i, this.id, a);
            }
        },
        {
            key: "tooltip",
            get: function() {
                return this.open ? this.open.tooltip : null;
            }
        },
        {
            key: "attrs",
            get: function() {
                return this.open ? this.open.attrs : A2;
            }
        }
    ], [
        {
            key: "start",
            value: function() {
                return new e(T2, "cm-ac-" + Math.floor(2e6 * Math.random()).toString(36), null);
            }
        }
    ]), e;
}();
var A2 = {
    "aria-autocomplete": "list"
};
function P2(e, t) {
    var n = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": e
    };
    return t > -1 && (n["aria-activedescendant"] = e + "-" + t), n;
}
var T2 = [];
function R2(e) {
    return e.isUserEvent("input.type") ? "input" : e.isUserEvent("delete.backward") ? "delete" : null;
}
var N2 = function() {
    function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
        No(this, e), this.source = t, this.state = n, this.explicitPos = r;
    }
    return Do(e, [
        {
            key: "hasResult",
            value: function() {
                return !1;
            }
        },
        {
            key: "update",
            value: function(t, n) {
                var r = R2(t), o = this;
                r ? o = o.handleUserEvent(t, r, n) : t.docChanged ? o = o.handleChange(t) : t.selection && 0 != o.state && (o = new e(o.source, 0));
                var i, a = bo(t.effects);
                try {
                    for(a.s(); !(i = a.n()).done;){
                        var s = i.value;
                        if (s.is(b2)) o = new e(o.source, 1, s.value ? v2(t.state) : -1);
                        else if (s.is(w2)) o = new e(o.source, 0);
                        else if (s.is(D2)) {
                            var c, l = bo(s.value);
                            try {
                                for(l.s(); !(c = l.n()).done;){
                                    var u = c.value;
                                    u.source == o.source && (o = u);
                                }
                            } catch (e) {
                                l.e(e);
                            } finally{
                                l.f();
                            }
                        }
                    }
                } catch (e) {
                    a.e(e);
                } finally{
                    a.f();
                }
                return o;
            }
        },
        {
            key: "handleUserEvent",
            value: function(t, n, r) {
                return "delete" != n && r.activateOnTyping ? new e(this.source, 1) : this.map(t.changes);
            }
        },
        {
            key: "handleChange",
            value: function(t) {
                return t.changes.touchesRange(v2(t.startState)) ? new e(this.source, 0) : this.map(t.changes);
            }
        },
        {
            key: "map",
            value: function(t) {
                return t.empty || this.explicitPos < 0 ? this : new e(this.source, this.state, t.mapPos(this.explicitPos));
            }
        }
    ]), e;
}(), I2 = function(e) {
    function t(e, n, r, o, i) {
        var a;
        return No(this, t), (a = _o(this, t, [
            e,
            2,
            n
        ])).result = r, a.from = o, a.to = i, a;
    }
    return Ao(t, N2), Do(t, [
        {
            key: "hasResult",
            value: function() {
                return !0;
            }
        },
        {
            key: "handleUserEvent",
            value: function(e, n, r) {
                var o, i = e.changes.mapPos(this.from), a = e.changes.mapPos(this.to, 1), s = v2(e.state);
                if ((this.explicitPos < 0 ? s <= i : s < this.from) || s > a || "delete" == n && v2(e.startState) == this.from) return new N2(this.source, "input" == n && r.activateOnTyping ? 1 : 0);
                var c, l = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos);
                return function(e, t, n, r) {
                    if (!e) return !1;
                    var o = t.sliceDoc(n, r);
                    return "function" == typeof e ? e(o, n, r, t) : p2(e, !0).test(o);
                }(this.result.validFor, e.state, i, a) ? new t(this.source, l, this.result, i, a) : this.result.update && (c = this.result.update(this.result, i, a, new u2(e.state, s, l >= 0))) ? new t(this.source, l, c, c.from, null !== (o = c.to) && void 0 !== o ? o : v2(e.state)) : new N2(this.source, 1, l);
            }
        },
        {
            key: "handleChange",
            value: function(e) {
                return e.changes.touchesRange(this.from, this.to) ? new N2(this.source, 0) : this.map(e.changes);
            }
        },
        {
            key: "map",
            value: function(e) {
                return e.empty ? this : new t(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1));
            }
        }
    ]), t;
}();
var D2 = uV.define({
    map: function(e, t) {
        return e.map(function(e) {
            return e.map(t);
        });
    }
}), z2 = uV.define(), q2 = LF.define({
    create: function() {
        return E2.start();
    },
    update: function(e, t) {
        return e.update(t);
    },
    provide: function(e) {
        return [
            XK.from(e, function(e) {
                return e.tooltip;
            }),
            WJ.contentAttributes.from(e, function(e) {
                return e.attrs;
            })
        ];
    }
});
function B2(e, t) {
    var n = t.completion.apply || t.completion.label, r = e.state.field(q2).active.find(function(e) {
        return e.source == t.source;
    });
    return r instanceof I2 && ("string" == typeof n ? e.dispatch(Object.assign(Object.assign({}, function(e, t, n, r) {
        var o = e.selection.main, i = n - o.from, a = r - o.from;
        return Object.assign(Object.assign({}, e.changeByRange(function(s) {
            return s != o && n != r && e.sliceDoc(s.from + i, s.from + a) != e.sliceDoc(n, r) ? {
                range: s
            } : {
                changes: {
                    from: s.from + i,
                    to: r == o.from ? s.to : s.from + a,
                    insert: t
                },
                range: PF.cursor(s.from + i + t.length)
            };
        })), {
            scrollIntoView: !0,
            userEvent: "input.complete"
        });
    }(e.state, n, r.from, r.to)), {
        annotations: m2.of(t.completion)
    })) : n(e, t.completion, r.from, r.to), !0);
}
var L2 = _2(q2, B2);
function F2(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "option";
    return function(n) {
        var r = n.state.field(q2, !1);
        if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(k2).interactionDelay) return !1;
        var o, i = 1;
        "page" == t && (o = iG(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(o.dom.offsetHeight / o.dom.querySelector("li").offsetHeight) - 1));
        var a = r.open.options.length, s = r.open.selected > -1 ? r.open.selected + i * (e ? 1 : -1) : e ? 0 : a - 1;
        return s < 0 ? s = "page" == t ? 0 : a - 1 : s >= a && (s = "page" == t ? a - 1 : 0), n.dispatch({
            effects: z2.of(s)
        }), !0;
    };
}
var V2 = Do(function e(t, n) {
    No(this, e), this.active = t, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
}), H2 = KW.fromClass(function() {
    function e(t) {
        No(this, e), this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
        var n, r = bo(t.state.field(q2).active);
        try {
            for(r.s(); !(n = r.n()).done;){
                var o = n.value;
                1 == o.state && this.startQuery(o);
            }
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = this, n = e.state.field(q2);
                if (e.selectionSet || e.docChanged || e.startState.field(q2) != n) {
                    for(var r = e.transactions.some(function(e) {
                        return (e.selection || e.docChanged) && !R2(e);
                    }), o = 0; o < this.running.length; o++){
                        var i = this.running[o];
                        if (r || i.updates.length + e.transactions.length > 50 && Date.now() - i.time > 1e3) {
                            var a, s = bo(i.context.abortListeners);
                            try {
                                for(s.s(); !(a = s.n()).done;){
                                    var c = a.value;
                                    try {
                                        c();
                                    } catch (e) {
                                        HW(this.view.state, e);
                                    }
                                }
                            } catch (e) {
                                s.e(e);
                            } finally{
                                s.f();
                            }
                            i.context.abortListeners = null, this.running.splice(o--, 1);
                        } else {
                            var l;
                            (l = i.updates).push.apply(l, Bo(e.transactions));
                        }
                    }
                    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), e.transactions.some(function(e) {
                        return e.effects.some(function(e) {
                            return e.is(b2);
                        });
                    }) && (this.pendingStart = !0);
                    var u = this.pendingStart ? 50 : e.state.facet(k2).activateOnTypingDelay;
                    if (this.debounceUpdate = n.active.some(function(e) {
                        return 1 == e.state && !t.running.some(function(t) {
                            return t.active.source == e.source;
                        });
                    }) ? setTimeout(function() {
                        return t.startUpdate();
                    }, u) : -1, 0 != this.composing) {
                        var f, d = bo(e.transactions);
                        try {
                            for(d.s(); !(f = d.n()).done;){
                                var h = f.value;
                                "input" == R2(h) ? this.composing = 2 : 2 == this.composing && h.selection && (this.composing = 3);
                            }
                        } catch (e) {
                            d.e(e);
                        } finally{
                            d.f();
                        }
                    }
                }
            }
        },
        {
            key: "startUpdate",
            value: function() {
                var e = this;
                this.debounceUpdate = -1, this.pendingStart = !1;
                var t, n = bo(this.view.state.field(q2).active);
                try {
                    var r = function() {
                        var n = t.value;
                        1 != n.state || e.running.some(function(e) {
                            return e.active.source == n.source;
                        }) || e.startQuery(n);
                    };
                    for(n.s(); !(t = n.n()).done;)r();
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }
        },
        {
            key: "startQuery",
            value: function(e) {
                var t = this, n = this.view.state, r = v2(n), o = new u2(n, r, e.explicitPos == r), i = new V2(e, o);
                this.running.push(i), Promise.resolve(e.source(o)).then(function(e) {
                    i.context.aborted || (i.done = e || null, t.scheduleAccept());
                }, function(e) {
                    t.view.dispatch({
                        effects: w2.of(null)
                    }), HW(t.view.state, e);
                });
            }
        },
        {
            key: "scheduleAccept",
            value: function() {
                var e = this;
                this.running.every(function(e) {
                    return void 0 !== e.done;
                }) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(function() {
                    return e.accept();
                }, this.view.state.facet(k2).updateSyncTime));
            }
        },
        {
            key: "accept",
            value: function() {
                var e, t = this;
                this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
                for(var n = [], r = this.view.state.facet(k2), o = function(o) {
                    var a = t.running[o];
                    if (void 0 === a.done) return i = o, 0;
                    if (t.running.splice(o--, 1), a.done) {
                        var s, c = new I2(a.active.source, a.active.explicitPos, a.done, a.done.from, null !== (e = a.done.to) && void 0 !== e ? e : v2(a.updates.length ? a.updates[0].startState : t.view.state)), l = bo(a.updates);
                        try {
                            for(l.s(); !(s = l.n()).done;){
                                var u = s.value;
                                c = c.update(u, r);
                            }
                        } catch (e) {
                            l.e(e);
                        } finally{
                            l.f();
                        }
                        if (c.hasResult()) return n.push(c), i = o, 0;
                    }
                    var f = t.view.state.field(q2).active.find(function(e) {
                        return e.source == a.active.source;
                    });
                    if (f && 1 == f.state) {
                        if (null == a.done) {
                            var d, h = new N2(a.active.source, 0), v = bo(a.updates);
                            try {
                                for(v.s(); !(d = v.n()).done;){
                                    var p = d.value;
                                    h = h.update(p, r);
                                }
                            } catch (e) {
                                v.e(e);
                            } finally{
                                v.f();
                            }
                            1 != h.state && n.push(h);
                        } else t.startQuery(f);
                    }
                    i = o;
                }, i = 0; i < this.running.length; i++)o(i);
                n.length && this.view.dispatch({
                    effects: D2.of(n)
                });
            }
        }
    ]), e;
}(), {
    eventHandlers: {
        blur: function(e) {
            var t = this, n = this.view.state.field(q2, !1);
            if (n && n.tooltip && this.view.state.facet(k2).closeOnBlur) {
                var r = n.open && iG(this.view, n.open.tooltip);
                r && r.dom.contains(e.relatedTarget) || setTimeout(function() {
                    return t.view.dispatch({
                        effects: w2.of(null)
                    });
                }, 10);
            }
        },
        compositionstart: function() {
            this.composing = 1;
        },
        compositionend: function() {
            var e = this;
            3 == this.composing && setTimeout(function() {
                return e.view.dispatch({
                    effects: b2.of(!1)
                });
            }, 20), this.composing = 0;
        }
    }
}), W2 = WJ.baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: .7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: .5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: "".concat(400, "px"),
        boxSizing: "border-box"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: "".concat(30, "px")
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: "".concat(30, "px")
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        }
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
}), U2 = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
}, J2 = uV.define({
    map: function(e, t) {
        var n = t.mapPos(e, -1, kF.TrackAfter);
        return null == n ? void 0 : n;
    }
}), K2 = new (function(e) {
    function t() {
        return No(this, t), _o(this, t, arguments);
    }
    return Ao(t, SV), Do(t);
}());
K2.startSide = 1, K2.endSide = -1;
var G2 = LF.define({
    create: function() {
        return OV.empty;
    },
    update: function(e, t) {
        if (e = e.map(t.changes), t.selection) {
            var n = t.state.doc.lineAt(t.selection.main.head);
            e = e.update({
                filter: function(e) {
                    return e >= n.from && e <= n.to;
                }
            });
        }
        var r, o = bo(t.effects);
        try {
            for(o.s(); !(r = o.n()).done;){
                var i = r.value;
                i.is(J2) && (e = e.update({
                    add: [
                        K2.range(i.value, i.value + 1)
                    ]
                }));
            }
        } catch (e) {
            o.e(e);
        } finally{
            o.f();
        }
        return e;
    }
});
var Q2 = "()[]{}<>";
function Y2(e) {
    for(var t = 0; t < Q2.length; t += 2)if (Q2.charCodeAt(t) == e) return Q2.charAt(t + 1);
    return bF(e < 128 ? e : e + 1);
}
function X2(e, t) {
    return e.languageDataAt("closeBrackets", t)[0] || U2;
}
var Z2 = "object" == ("undefined" == typeof navigator ? "undefined" : Ho(navigator)) && /Android\b/.test(navigator.userAgent), e3 = WJ.inputHandler.of(function(e, t, n, r) {
    if ((Z2 ? e.composing : e.compositionStarted) || e.state.readOnly) return !1;
    var o = e.state.selection.main;
    if (r.length > 2 || 2 == r.length && 1 == wF(yF(r, 0)) || t != o.from || n != o.to) return !1;
    var i = function(e, t) {
        var n, r = X2(e, e.selection.main.head), o = r.brackets || U2.brackets, i = bo(o);
        try {
            for(i.s(); !(n = i.n()).done;){
                var a = n.value, s = Y2(yF(a, 0));
                if (t == a) return s == a ? a3(e, a, o.indexOf(a + a + a) > -1, r) : o3(e, a, s, r.before || U2.before);
                if (t == s && n3(e, e.selection.main.from)) return i3(e, a, s);
            }
        } catch (e) {
            i.e(e);
        } finally{
            i.f();
        }
        return null;
    }(e.state, r);
    return !!i && (e.dispatch(i), !0);
}), t3 = [
    {
        key: "Backspace",
        run: function(e) {
            var t = e.state, n = e.dispatch;
            if (t.readOnly) return !1;
            var r = X2(t, t.selection.main.head).brackets || U2.brackets, o = null, i = t.changeByRange(function(e) {
                if (e.empty) {
                    var n, i = function(e, t) {
                        var n = e.sliceString(t - 2, t);
                        return wF(yF(n, 0)) == n.length ? n : n.slice(1);
                    }(t.doc, e.head), a = bo(r);
                    try {
                        for(a.s(); !(n = a.n()).done;){
                            var s = n.value;
                            if (s == i && r3(t.doc, e.head) == Y2(yF(s, 0))) return {
                                changes: {
                                    from: e.head - s.length,
                                    to: e.head + s.length
                                },
                                range: PF.cursor(e.head - s.length)
                            };
                        }
                    } catch (e) {
                        a.e(e);
                    } finally{
                        a.f();
                    }
                }
                return {
                    range: o = e
                };
            });
            return o || n(t.update(i, {
                scrollIntoView: !0,
                userEvent: "delete.backward"
            })), !o;
        }
    }
];
function n3(e, t) {
    var n = !1;
    return e.field(G2).between(0, e.doc.length, function(e) {
        e == t && (n = !0);
    }), n;
}
function r3(e, t) {
    var n = e.sliceString(t, t + 2);
    return n.slice(0, wF(yF(n, 0)));
}
function o3(e, t, n, r) {
    var o = null, i = e.changeByRange(function(i) {
        if (!i.empty) return {
            changes: [
                {
                    insert: t,
                    from: i.from
                },
                {
                    insert: n,
                    from: i.to
                }
            ],
            effects: J2.of(i.to + t.length),
            range: PF.range(i.anchor + t.length, i.head + t.length)
        };
        var a = r3(e.doc, i.head);
        return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
            changes: {
                insert: t + n,
                from: i.head
            },
            effects: J2.of(i.head + t.length),
            range: PF.cursor(i.head + t.length)
        } : {
            range: o = i
        };
    });
    return o ? null : e.update(i, {
        scrollIntoView: !0,
        userEvent: "input.type"
    });
}
function i3(e, t, n) {
    var r = null, o = e.changeByRange(function(t) {
        return t.empty && r3(e.doc, t.head) == n ? {
            changes: {
                from: t.head,
                to: t.head + n.length,
                insert: n
            },
            range: PF.cursor(t.head + n.length)
        } : r = {
            range: t
        };
    });
    return r ? null : e.update(o, {
        scrollIntoView: !0,
        userEvent: "input.type"
    });
}
function a3(e, t, n, r) {
    var o = r.stringPrefixes || U2.stringPrefixes, i = null, a = e.changeByRange(function(r) {
        if (!r.empty) return {
            changes: [
                {
                    insert: t,
                    from: r.from
                },
                {
                    insert: t,
                    from: r.to
                }
            ],
            effects: J2.of(r.to + t.length),
            range: PF.range(r.anchor + t.length, r.head + t.length)
        };
        var a, s = r.head, c = r3(e.doc, s);
        if (c == t) {
            if (s3(e, s)) return {
                changes: {
                    insert: t + t,
                    from: s
                },
                effects: J2.of(s + t.length),
                range: PF.cursor(s + t.length)
            };
            if (n3(e, s)) {
                var l = n && e.sliceDoc(s, s + 3 * t.length) == t + t + t ? t + t + t : t;
                return {
                    changes: {
                        from: s,
                        to: s + l.length,
                        insert: l
                    },
                    range: PF.cursor(s + l.length)
                };
            }
        } else {
            if (n && e.sliceDoc(s - 2 * t.length, s) == t + t && (a = c3(e, s - 2 * t.length, o)) > -1 && s3(e, a)) return {
                changes: {
                    insert: t + t + t + t,
                    from: s
                },
                effects: J2.of(s + t.length),
                range: PF.cursor(s + t.length)
            };
            if (e.charCategorizer(s)(c) != bV.Word && c3(e, s, o) > -1 && !function(e, t, n, r) {
                for(var o = WQ(e).resolveInner(t, -1), i = r.reduce(function(e, t) {
                    return Math.max(e, t.length);
                }, 0), a = 0; a < 5; a++){
                    var s = e.sliceDoc(o.from, Math.min(o.to, o.from + n.length + i)), c = s.indexOf(n);
                    if (!c || c > -1 && r.indexOf(s.slice(0, c)) > -1) {
                        for(var l = o.firstChild; l && l.from == o.from && l.to - l.from > n.length + c;){
                            if (e.sliceDoc(l.to - n.length, l.to) == n) return !1;
                            l = l.firstChild;
                        }
                        return !0;
                    }
                    var u = o.to == t && o.parent;
                    if (!u) break;
                    o = u;
                }
                return !1;
            }(e, s, t, o)) return {
                changes: {
                    insert: t + t,
                    from: s
                },
                effects: J2.of(s + t.length),
                range: PF.cursor(s + t.length)
            };
        }
        return {
            range: i = r
        };
    });
    return i ? null : e.update(a, {
        scrollIntoView: !0,
        userEvent: "input.type"
    });
}
function s3(e, t) {
    var n = WQ(e).resolveInner(t + 1);
    return n.parent && n.from == t;
}
function c3(e, t, n) {
    var r = e.charCategorizer(t);
    if (r(e.sliceDoc(t - 1, t)) != bV.Word) return t;
    var o, i = bo(n);
    try {
        for(i.s(); !(o = i.n()).done;){
            var a = o.value, s = t - a.length;
            if (e.sliceDoc(s, t) == a && r(e.sliceDoc(s - 1, s)) != bV.Word) return s;
        }
    } catch (e) {
        i.e(e);
    } finally{
        i.f();
    }
    return -1;
}
function l3() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        q2,
        k2.of(e),
        H2,
        f3,
        W2
    ];
}
var u3 = [
    {
        key: "Ctrl-Space",
        run: function(e) {
            return !!e.state.field(q2, !1) && (e.dispatch({
                effects: b2.of(!0)
            }), !0);
        }
    },
    {
        key: "Escape",
        run: function(e) {
            var t = e.state.field(q2, !1);
            return !(!t || !t.active.some(function(e) {
                return 0 != e.state;
            })) && (e.dispatch({
                effects: w2.of(null)
            }), !0);
        }
    },
    {
        key: "ArrowDown",
        run: F2(!0)
    },
    {
        key: "ArrowUp",
        run: F2(!1)
    },
    {
        key: "PageDown",
        run: F2(!0, "page")
    },
    {
        key: "PageUp",
        run: F2(!1, "page")
    },
    {
        key: "Enter",
        run: function(e) {
            var t = e.state.field(q2, !1);
            return !(e.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < e.state.facet(k2).interactionDelay) && B2(e, t.open.options[t.open.selected]);
        }
    }
], f3 = JF.highest(ZJ.computeN([
    k2
], function(e) {
    return e.facet(k2).defaultKeymap ? [
        u3
    ] : [];
}));
function d3(e) {
    mi(e, "svelte-hhcn0f", '.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);margin:0;border-top:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);display:flex;gap:var(--jse-padding, 10px)}.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-status-bar.svelte-hhcn0f .jse-status-bar-info.svelte-hhcn0f{padding:2px}');
}
function h3(e) {
    var t, n, r;
    return {
        c: function() {
            t = ji("div"), n = Ci("Line: "), r = Ci(e[0]), Ai(t, "class", "jse-status-bar-info svelte-hhcn0f");
        },
        m: function(e, o) {
            wi(e, t, o), pi(t, n), pi(t, r);
        },
        p: function(e, t) {
            1 & t && Ni(r, e[0]);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function v3(e) {
    var t, n, r;
    return {
        c: function() {
            t = ji("div"), n = Ci("Column: "), r = Ci(e[1]), Ai(t, "class", "jse-status-bar-info svelte-hhcn0f");
        },
        m: function(e, o) {
            wi(e, t, o), pi(t, n), pi(t, r);
        },
        p: function(e, t) {
            2 & t && Ni(r, e[1]);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function p3(e) {
    var t, n, r, o;
    return {
        c: function() {
            t = ji("div"), n = Ci("Selection: "), r = Ci(e[2]), o = Ci(" characters"), Ai(t, "class", "jse-status-bar-info svelte-hhcn0f");
        },
        m: function(e, i) {
            wi(e, t, i), pi(t, n), pi(t, r), pi(t, o);
        },
        p: function(e, t) {
            4 & t && Ni(r, e[2]);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function m3(e) {
    var t, n, r, o = void 0 !== e[0] && h3(e), i = void 0 !== e[1] && v3(e), a = void 0 !== e[2] && e[2] > 0 && p3(e);
    return {
        c: function() {
            t = ji("div"), o && o.c(), n = $i(), i && i.c(), r = $i(), a && a.c(), Ai(t, "class", "jse-status-bar svelte-hhcn0f");
        },
        m: function(e, s) {
            wi(e, t, s), o && o.m(t, null), pi(t, n), i && i.m(t, null), pi(t, r), a && a.m(t, null);
        },
        p: function(e, s) {
            var c = jo(s, 1)[0];
            void 0 !== e[0] ? o ? o.p(e, c) : ((o = h3(e)).c(), o.m(t, n)) : o && (o.d(1), o = null), void 0 !== e[1] ? i ? i.p(e, c) : ((i = v3(e)).c(), i.m(t, r)) : i && (i.d(1), i = null), void 0 !== e[2] && e[2] > 0 ? a ? a.p(e, c) : ((a = p3(e)).c(), a.m(t, null)) : a && (a.d(1), a = null);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), o && o.d(), i && i.d(), a && a.d();
        }
    };
}
function g3(e, t, n) {
    var r, o, i, a, s, c = t.editorState;
    return e.$$set = function(e) {
        "editorState" in e && n(3, c = e.editorState);
    }, e.$$.update = function() {
        var t, l, u;
        8 & e.$$.dirty && n(4, r = null === (t = c) || void 0 === t || null === (t = t.selection) || void 0 === t || null === (t = t.main) || void 0 === t ? void 0 : t.head);
        24 & e.$$.dirty && n(5, o = r ? null === (l = c) || void 0 === l || null === (l = l.doc) || void 0 === l ? void 0 : l.lineAt(r) : void 0);
        (32 & e.$$.dirty && n(0, i = o ? o.number : void 0), 48 & e.$$.dirty && n(1, a = void 0 !== o && void 0 !== r ? r - o.from + 1 : void 0), 8 & e.$$.dirty) && n(2, s = null === (u = c) || void 0 === u || null === (u = u.selection) || void 0 === u || null === (u = u.ranges) || void 0 === u ? void 0 : u.reduce(function(e, t) {
            return e + t.to - t.from;
        }, 0));
    }, [
        i,
        a,
        s,
        c,
        r,
        o
    ];
}
var y3 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, g3, m3, Xo, {
            editorState: 3
        }, d3), n;
    }
    return Ao(t, Ia), Do(t);
}(), b3 = zY.define([
    {
        tag: qQ.propertyName,
        color: "var(--internal-key-color)"
    },
    {
        tag: qQ.number,
        color: "var(--internal-value-color-number)"
    },
    {
        tag: qQ.bool,
        color: "var(--internal-value-color-boolean)"
    },
    {
        tag: qQ.string,
        color: "var(--internal-value-color-string)"
    },
    {
        tag: qQ.keyword,
        color: "var(--internal-value-color-null)"
    }
]), w3 = FY(b3), x3 = b3.style;
function k3(e) {
    var t = e.selection.main.head;
    return e.doc.lineAt(t);
}
function j3(e, t) {
    var n = 0;
    e: for(var r = 0; r < e.length; r++)switch(e[r]){
        case " ":
            n += 1;
            continue e;
        case "	":
            n += t - n % t;
            continue e;
        case "\r":
            continue e;
        default:
            break e;
    }
    return n;
}
b3.style = function(e) {
    return x3(e || []);
};
var S3 = NF.define({
    combine: function(e) {
        return jV(e, {
            highlightActiveBlock: !0,
            hideFirstIndent: !1,
            markerType: "fullScope",
            thickness: 1
        });
    }
}), C3 = function() {
    function e(t, n, r, o) {
        No(this, e), this.lines = t, this.state = n, this.map = new Map, this.unitWidth = r, this.markerType = o;
        var i, a = bo(this.lines);
        try {
            for(a.s(); !(i = a.n()).done;){
                var s = i.value;
                this.add(s);
            }
        } catch (e) {
            a.e(e);
        } finally{
            a.f();
        }
        this.state.facet(S3).highlightActiveBlock && this.findAndSetActiveLines();
    }
    return Do(e, [
        {
            key: "has",
            value: function(e) {
                return this.map.has("number" == typeof e ? e : e.number);
            }
        },
        {
            key: "get",
            value: function(e) {
                var t = this.map.get("number" == typeof e ? e : e.number);
                if (!t) throw new Error("Line not found in indentation map");
                return t;
            }
        },
        {
            key: "set",
            value: function(e, t, n) {
                var r = !e.text.trim().length, o = {
                    line: e,
                    col: t,
                    level: n,
                    empty: r
                };
                return this.map.set(o.line.number, o), o;
            }
        },
        {
            key: "add",
            value: function(e) {
                if (this.has(e)) return this.get(e);
                if (!e.length || !e.text.trim().length) {
                    if (1 === e.number) return this.set(e, 0, 0);
                    if (e.number === this.state.doc.lines) {
                        var t = this.closestNonEmpty(e, -1);
                        return this.set(e, 0, t.level);
                    }
                    var n = this.closestNonEmpty(e, -1), r = this.closestNonEmpty(e, 1);
                    return n.level >= r.level && "codeOnly" !== this.markerType ? this.set(e, 0, n.level) : n.empty && 0 === n.level && 0 !== r.level ? this.set(e, 0, 0) : r.level > n.level ? this.set(e, 0, n.level + 1) : this.set(e, 0, r.level);
                }
                var o = j3(e.text, this.state.tabSize), i = Math.floor(o / this.unitWidth);
                return this.set(e, o, i);
            }
        },
        {
            key: "closestNonEmpty",
            value: function(e, t) {
                for(var n = e.number + t; -1 === t ? n >= 1 : n <= this.state.doc.lines;){
                    if (this.has(n)) {
                        var r = this.get(n);
                        if (!r.empty) return r;
                    }
                    var o = this.state.doc.line(n);
                    if (o.text.trim().length) {
                        var i = j3(o.text, this.state.tabSize), a = Math.floor(i / this.unitWidth);
                        return this.set(o, i, a);
                    }
                    n += t;
                }
                var s = this.state.doc.line(-1 === t ? 1 : this.state.doc.lines);
                return this.set(s, 0, 0);
            }
        },
        {
            key: "findAndSetActiveLines",
            value: function() {
                var e = k3(this.state);
                if (this.has(e)) {
                    var t = this.get(e);
                    if (this.has(t.line.number + 1)) {
                        var n = this.get(t.line.number + 1);
                        n.level > t.level && (t = n);
                    }
                    if (this.has(t.line.number - 1)) {
                        var r = this.get(t.line.number - 1);
                        r.level > t.level && (t = r);
                    }
                    if (0 !== t.level) {
                        var o, i;
                        for(t.active = t.level, o = t.line.number; o > 1; o--)if (this.has(o - 1)) {
                            var a = this.get(o - 1);
                            if (a.level < t.level) break;
                            a.active = t.level;
                        }
                        for(i = t.line.number; i < this.state.doc.lines; i++)if (this.has(i + 1)) {
                            var s = this.get(i + 1);
                            if (s.level < t.level) break;
                            s.active = t.level;
                        }
                    }
                }
            }
        }
    ]), e;
}();
function $3(e) {
    var t = {
        light: "#F0F1F2",
        dark: "#2B3245",
        activeLight: "#E4E5E6",
        activeDark: "#3C445C"
    }, n = t;
    return e && (n = Object.assign(Object.assign({}, t), e)), WJ.baseTheme({
        "&light": {
            "--indent-marker-bg-color": n.light,
            "--indent-marker-active-bg-color": n.activeLight
        },
        "&dark": {
            "--indent-marker-bg-color": n.dark,
            "--indent-marker-active-bg-color": n.activeDark
        },
        ".cm-line": {
            position: "relative"
        },
        ".cm-indent-markers::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "var(--indent-markers)",
            pointerEvents: "none",
            zIndex: "-1"
        }
    });
}
function _3(e, t, n, r, o) {
    var i = "repeating-linear-gradient(to right, var(".concat(e, ") 0 ").concat(t, "px, transparent ").concat(t, "px ").concat(n, "ch)");
    return "".concat(i, " ").concat(r * n, ".5ch/calc(").concat(n * o, "ch - 1px) no-repeat");
}
function O3(e, t, n, r) {
    var o = e.level, i = e.active;
    if (n && 0 === o) return [];
    var a = n ? 1 : 0, s = [];
    if (void 0 !== i) {
        var c = i - a - 1;
        c > 0 && s.push(_3("--indent-marker-bg-color", r, t, a, c)), s.push(_3("--indent-marker-active-bg-color", r, t, i - 1, 1)), i !== o && s.push(_3("--indent-marker-bg-color", r, t, i, o - i));
    } else s.push(_3("--indent-marker-bg-color", r, t, a, o - a));
    return s.join(",");
}
var M3 = function() {
    function e(t) {
        No(this, e), this.view = t, this.unitWidth = oY(t.state), this.currentLineNumber = k3(t.state).number, this.generate(t.state);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = oY(e.state), n = t !== this.unitWidth;
                n && (this.unitWidth = t);
                var r = k3(e.state).number, o = r !== this.currentLineNumber;
                this.currentLineNumber = r;
                var i = e.state.facet(S3).highlightActiveBlock && o;
                (e.docChanged || e.viewportChanged || n || i) && this.generate(e.state);
            }
        },
        {
            key: "generate",
            value: function(e) {
                var t, n = new MV, r = function(e) {
                    var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.state, r = new Set, o = bo(e.visibleRanges);
                    try {
                        for(o.s(); !(t = o.n()).done;)for(var i = t.value, a = i.from, s = i.to, c = a; c <= s;){
                            var l = n.doc.lineAt(c);
                            r.has(l) || r.add(l), c = l.to + 1;
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    return r;
                }(this.view, e), o = e.facet(S3), i = o.hideFirstIndent, a = o.markerType, s = o.thickness, c = new C3(r, e, this.unitWidth, a), l = bo(r);
                try {
                    for(l.s(); !(t = l.n()).done;){
                        var u = t.value, f = c.get(u.number);
                        if (null == f ? void 0 : f.level) {
                            var d = O3(f, this.unitWidth, i, s);
                            n.add(u.from, u.from, eW.line({
                                class: "cm-indent-markers",
                                attributes: {
                                    style: "--indent-markers: ".concat(d)
                                }
                            }));
                        }
                    }
                } catch (e) {
                    l.e(e);
                } finally{
                    l.f();
                }
                this.decorations = n.finish();
            }
        }
    ]), e;
}();
function E3() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return [
        S3.of(e),
        $3(e.colors),
        KW.fromClass(M3, {
            decorations: function(e) {
                return e.decorations;
            }
        })
    ];
}
var A3 = function() {
    function e(t) {
        No(this, e), this.view = t, this.indentUnit = oY(t.state), this.initialPaddingLeft = null, this.generate(t.state);
    }
    return Do(e, [
        {
            key: "update",
            value: function(e) {
                var t = oY(e.state);
                (t !== this.indentUnit || e.docChanged || e.viewportChanged) && (this.indentUnit = t, this.generate(e.state));
            }
        },
        {
            key: "generate",
            value: function(e) {
                var t = this, n = new MV;
                this.initialPaddingLeft ? this.addStyleToBuilder(n, e, this.initialPaddingLeft) : this.view.requestMeasure({
                    read: function(e) {
                        var r = e.contentDOM.querySelector(".cm-line");
                        r && (t.initialPaddingLeft = window.getComputedStyle(r).getPropertyValue("padding-left"), t.addStyleToBuilder(n, e.state, t.initialPaddingLeft)), t.decorations = n.finish();
                    }
                }), this.decorations = n.finish();
            }
        },
        {
            key: "addStyleToBuilder",
            value: function(e, t, n) {
                var r, o = bo(this.getVisibleLines(t));
                try {
                    for(o.s(); !(r = o.n()).done;){
                        var i = r.value, a = this.getIndentSize(i), s = "calc(".concat(a + this.indentUnit, "ch + ").concat(n, ")");
                        e.add(i.from, i.from, eW.line({
                            attributes: {
                                style: "padding-left: ".concat(s, "; text-indent: -").concat(a + this.indentUnit, "ch;")
                            }
                        }));
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
            }
        },
        {
            key: "getVisibleLines",
            value: function(e) {
                var t, n = new Set, r = null, o = bo(this.view.visibleRanges);
                try {
                    for(o.s(); !(t = o.n()).done;)for(var i = t.value, a = i.from, s = i.to, c = a; c <= s;){
                        var l = e.doc.lineAt(c);
                        r !== l && (n.add(l), r = l), c = l.to + 1;
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return n;
            }
        },
        {
            key: "getIndentSize",
            value: function(e) {
                return e.text.length - e.text.trimStart().length;
            }
        }
    ]), e;
}(), P3 = [
    KW.fromClass(A3, {
        decorations: function(e) {
            return e.decorations;
        }
    })
];
function T3(e) {
    mi(e, "svelte-a0poeb", '.jse-text-mode.svelte-a0poeb.svelte-a0poeb{--internal-key-color:var(--jse-key-color, #1a1a1a);--internal-value-color-number:var(--jse-value-color-number, #ee422e);--internal-value-color-boolean:var(--jse-value-color-boolean, #ff8c00);--internal-value-color-string:var(--jse-value-color-string, #008000);--internal-value-color-null:var(--jse-value-color-null, #004ed0);flex:1;box-sizing:border-box;display:flex;flex-direction:column;background:var(--jse-background-color, #fff)}.jse-text-mode.no-main-menu.svelte-a0poeb.svelte-a0poeb{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb{flex:1;display:flex;position:relative;flex-direction:column;overflow:hidden;min-width:0;min-height:0;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-hidden.svelte-a0poeb{visibility:hidden;position:absolute;top:0;left:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor{flex:1;overflow:hidden}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-scroller{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-gutters{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);border-right:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLine,.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLineGutter{background:var(--jse-active-line-background-color, rgba(0, 0, 0, 0.06))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionBackground{background:var(--jse-selection-background-color, #d3d3d3)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch.cm-searchMatch-selected{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionMatch{background-color:var(--jse-search-match-background-color, rgba(153, 255, 119, 0.5019607843))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-foldPlaceholder{background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));border:none;padding:0 var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-tooltip{font-size:var(--jse-font-size, 16px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tooltip-color, var(--jse-text-color, #4d4d4d));background:var(--jse-tooltip-background, var(--jse-modal-background, #f5f5f5));border:var(--jse-tooltip-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-diagnosticAction{background:var(--jse-tooltip-action-button-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tooltip-action-button-background, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-panels{border-bottom:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search input{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-input-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);background:var(--jse-input-background, var(--jse-background-color, #fff));margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent);border:none;cursor:pointer;text-transform:capitalize;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);margin:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);padding-left:var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label input{margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button[name="close"]{width:32px;height:32px;font-size:24px;line-height:24px;padding:0;right:0;top:-4px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-cursor-primary{border-color:var(--jse-text-color, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading-space.svelte-a0poeb{flex:1}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading.svelte-a0poeb{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-preview.svelte-a0poeb{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;word-break:break-word;padding:2px}');
}
function R3(e) {
    var t = e.slice(), n = 0 === t[11].length;
    return t[98] = n, t;
}
function N3(e) {
    var t, n;
    return t = new YL({
        props: {
            readOnly: e[1],
            onFormat: e[17],
            onCompact: e[18],
            onSort: e[19],
            onTransform: e[20],
            onToggleSearch: e[21],
            onUndo: e[22],
            onRedo: e[23],
            canFormat: !e[98],
            canCompact: !e[98],
            canSort: !e[98],
            canTransform: !e[98],
            canUndo: e[12],
            canRedo: e[13],
            onRenderMenu: e[4]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2 & n[0] && (r.readOnly = e[1]), 2048 & n[0] && (r.canFormat = !e[98]), 2048 & n[0] && (r.canCompact = !e[98]), 2048 & n[0] && (r.canSort = !e[98]), 2048 & n[0] && (r.canTransform = !e[98]), 4096 & n[0] && (r.canUndo = e[12]), 8192 & n[0] && (r.canRedo = e[13]), 16 & n[0] && (r.onRenderMenu = e[4]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function I3(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).innerHTML = '<div class="jse-loading-space svelte-a0poeb"></div> <div class="jse-loading svelte-a0poeb">loading...</div>', Ai(t, "class", "jse-contents svelte-a0poeb");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function D3(e) {
    var t, n, r, o, i, a = e[97] && z3(e), s = !e[97] && q3(e);
    return {
        c: function() {
            t = ji("div"), n = $i(), a && a.c(), r = $i(), s && s.c(), o = _i(), Ai(t, "class", "jse-contents svelte-a0poeb"), qi(t, "jse-hidden", e[97]);
        },
        m: function(c, l) {
            wi(c, t, l), e[52](t), wi(c, n, l), a && a.m(c, l), wi(c, r, l), s && s.m(c, l), wi(c, o, l), i = !0;
        },
        p: function(e, n) {
            (!i || 268438016 & n[0]) && qi(t, "jse-hidden", e[97]), e[97] ? a ? (a.p(e, n), 2560 & n[0] && xa(a, 1)) : ((a = z3(e)).c(), xa(a, 1), a.m(r.parentNode, r)) : a && (ba(), ka(a, 1, 1, function() {
                a = null;
            }), wa()), e[97] ? s && (ba(), ka(s, 1, 1, function() {
                s = null;
            }), wa()) : s ? (s.p(e, n), 2560 & n[0] && xa(s, 1)) : ((s = q3(e)).c(), xa(s, 1), s.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(a), xa(s), i = !0);
        },
        o: function(e) {
            ka(a), ka(s), i = !1;
        },
        d: function(i) {
            i && (xi(t), xi(n), xi(r), xi(o)), e[52](null), a && a.d(i), s && s.d(i);
        }
    };
}
function z3(e) {
    var t, n, r, o, i, a = tM(e[11] || "", fs) + "";
    return t = new IN({
        props: {
            icon: TP,
            type: "error",
            message: "The JSON document is larger than ".concat(KL(ps, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(KL(e[11].length, 1024), "."),
            actions: [
                {
                    text: "Open anyway",
                    title: "Open the document in text mode. This may freeze or crash your browser.",
                    onClick: e[24]
                },
                {
                    text: "Open in tree mode",
                    title: "Open the document in tree mode. Tree mode can handle large documents.",
                    onClick: e[25]
                },
                {
                    text: "Cancel",
                    title: "Cancel opening this large document.",
                    onClick: e[26]
                }
            ],
            onClose: e[5]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment), n = $i(), r = ji("div"), o = Ci(a), Ai(r, "class", "jse-contents jse-preview svelte-a0poeb");
        },
        m: function(e, a) {
            Ta(t, e, a), wi(e, n, a), wi(e, r, a), pi(r, o), i = !0;
        },
        p: function(e, n) {
            var r = {};
            2048 & n[0] && (r.message = "The JSON document is larger than ".concat(KL(ps, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(KL(e[11].length, 1024), ".")), t.$set(r), (!i || 2048 & n[0]) && a !== (a = tM(e[11] || "", fs) + "") && Ni(o, a);
        },
        i: function(e) {
            i || (xa(t.$$.fragment, e), i = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), i = !1;
        },
        d: function(e) {
            e && (xi(n), xi(r)), Ra(t, e);
        }
    };
}
function q3(e) {
    var t, n, r, o, i, a = !e[14] && e[0] && oO(e[11]), s = e[3] && B3(e), c = e[14] && L3(e), l = a && F3(e);
    return o = new JN({
        props: {
            validationErrors: e[10],
            selectError: e[27]
        }
    }), {
        c: function() {
            s && s.c(), t = $i(), c && c.c(), n = $i(), l && l.c(), r = $i(), Pa(o.$$.fragment);
        },
        m: function(e, a) {
            s && s.m(e, a), wi(e, t, a), c && c.m(e, a), wi(e, n, a), l && l.m(e, a), wi(e, r, a), Ta(o, e, a), i = !0;
        },
        p: function(e, i) {
            e[3] ? s ? (s.p(e, i), 8 & i[0] && xa(s, 1)) : ((s = B3(e)).c(), xa(s, 1), s.m(t.parentNode, t)) : s && (ba(), ka(s, 1, 1, function() {
                s = null;
            }), wa()), e[14] ? c ? (c.p(e, i), 16384 & i[0] && xa(c, 1)) : ((c = L3(e)).c(), xa(c, 1), c.m(n.parentNode, n)) : c && (ba(), ka(c, 1, 1, function() {
                c = null;
            }), wa()), 18433 & i[0] && (a = !e[14] && e[0] && oO(e[11])), a ? l ? (l.p(e, i), 18433 & i[0] && xa(l, 1)) : ((l = F3(e)).c(), xa(l, 1), l.m(r.parentNode, r)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa());
            var u = {};
            1024 & i[0] && (u.validationErrors = e[10]), o.$set(u);
        },
        i: function(e) {
            i || (xa(s), xa(c), xa(l), xa(o.$$.fragment, e), i = !0);
        },
        o: function(e) {
            ka(s), ka(c), ka(l), ka(o.$$.fragment, e), i = !1;
        },
        d: function(e) {
            e && (xi(t), xi(n), xi(r)), s && s.d(e), c && c.d(e), l && l.d(e), Ra(o, e);
        }
    };
}
function B3(e) {
    var t, n;
    return t = new y3({
        props: {
            editorState: e[8]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            256 & n[0] && (r.editorState = e[8]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function L3(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "error",
            icon: TP,
            message: e[14].message,
            actions: e[15],
            onClick: e[29],
            onClose: e[5]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            16384 & n[0] && (r.message = e[14].message), 32768 & n[0] && (r.actions = e[15]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function F3(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "success",
            message: "Do you want to format the JSON?",
            actions: [
                {
                    icon: _q,
                    text: "Format",
                    title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
                    onClick: e[17]
                },
                {
                    icon: MP,
                    text: "No thanks",
                    title: "Close this message",
                    onClick: e[53]
                }
            ],
            onClose: e[5]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.actions = [
                {
                    icon: _q,
                    text: "Format",
                    title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
                    onClick: e[17]
                },
                {
                    icon: MP,
                    text: "No thanks",
                    title: "Close this message",
                    onClick: e[53]
                }
            ]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function V3(e) {
    var t, n, r, o, i, a = e[2] && N3(R3(e)), s = [
        D3,
        I3
    ], c = [];
    function l(e, t) {
        return 0 === t ? function(e) {
            var t = e.slice(), n = t[28](t[11], t[9]);
            return t[97] = n, t;
        }(e) : e;
    }
    return r = function(e, t) {
        return e[16] ? 1 : 0;
    }(e), o = c[r] = s[r](l(e, r)), {
        c: function() {
            t = ji("div"), a && a.c(), n = $i(), o.c(), Ai(t, "class", "jse-text-mode svelte-a0poeb"), qi(t, "no-main-menu", !e[2]);
        },
        m: function(o, s) {
            wi(o, t, s), a && a.m(t, null), pi(t, n), c[r].m(t, null), e[54](t), i = !0;
        },
        p: function(e, s) {
            e[2] ? a ? (a.p(R3(e), s), 4 & s[0] && xa(a, 1)) : ((a = N3(R3(e))).c(), xa(a, 1), a.m(t, n)) : a && (ba(), ka(a, 1, 1, function() {
                a = null;
            }), wa()), o.p(l(e, r), s), (!i || 4 & s[0]) && qi(t, "no-main-menu", !e[2]);
        },
        i: function(e) {
            i || (xa(a), xa(o), i = !0);
        },
        o: function(e) {
            ka(a), ka(o), i = !1;
        },
        d: function(n) {
            n && xi(t), a && a.d(), c[r].d(), e[54](null);
        }
    };
}
function H3(e) {
    return {
        from: e.from || 0,
        to: e.to || 0,
        message: e.message || "",
        actions: e.actions,
        severity: e.severity
    };
}
function W3(e, t, n) {
    var r, o, i, a, s, c, l = t.readOnly, u = t.mainMenuBar, f = t.statusBar, d = t.askToFormat, h = t.externalContent, v = t.externalSelection, p = t.indentation, m = t.tabSize, g = t.escapeUnicodeCharacters, y = t.parser, b = t.validator, w = t.validationParser, x = t.onChange, k = t.onChangeMode, j = t.onSelect, S = t.onError, C = t.onFocus, $ = t.onBlur, _ = t.onRenderMenu, O = t.onSortModal, M = t.onTransformModal, E = Da("jsoneditor:TextMode"), A = {
        key: "Mod-i",
        run: Q,
        shift: Y,
        preventDefault: !0
    }, P = "undefined" == typeof window;
    E("isSSR:", P);
    var T = !1, R = [], N = new GF, I = new GF, D = new GF, z = new GF, q = new GF, B = h, L = Y_(B, p, y), F = g;
    Gi(ko(wo().mark(function e() {
        return wo().wrap(function(e) {
            for(;;)switch(e.prev = e.next){
                case 0:
                    if (!P) {
                        e.next = 2;
                        break;
                    }
                    return e.abrupt("return");
                case 2:
                    try {
                        s = re({
                            target: i,
                            initialText: be(L, T) ? "" : r.escapeValue(L),
                            readOnly: l,
                            indentation: p
                        });
                    } catch (e) {
                        console.error(e);
                    }
                case 3:
                case "end":
                    return e.stop();
            }
        }, e);
    }))), Qi(function() {
        s && (E("Destroy CodeMirror editor"), s.destroy());
    });
    var V = !1, H = !1, W = A$(), U = A$();
    function J() {
        s && (E("focus"), s.focus());
    }
    var K = !1;
    function G(e) {
        E("patch", e);
        var t = y.parse(L), n = rc(t, e), r = vc(t, e);
        return se({
            text: y.stringify(n, null, p)
        }), {
            json: n,
            previousJson: t,
            undo: r,
            redo: e
        };
    }
    function Q() {
        if (E("format"), l) return !1;
        try {
            var e = y.parse(L);
            return se({
                text: y.stringify(e, null, p)
            }), n(0, d = !0), !0;
        } catch (e) {
            S(e);
        }
        return !1;
    }
    function Y() {
        if (E("compact"), l) return !1;
        try {
            var e = y.parse(L);
            return se({
                text: y.stringify(e)
            }), n(0, d = !1), !0;
        } catch (e) {
            S(e);
        }
        return !1;
    }
    function X() {
        if (E("repair"), !l) try {
            se({
                text: Hl(L)
            }), n(51, we = $s), n(14, xe = null);
        } catch (e) {
            S(e);
        }
    }
    function Z(e) {
        var t = e.id, n = e.rootPath, r = e.onTransform, o = e.onClose;
        try {
            var i = y.parse(L);
            K = !0, M({
                id: t || U,
                json: i,
                rootPath: n || [],
                onTransform: function(e) {
                    r ? r({
                        operations: e,
                        json: i,
                        transformedJson: rc(i, e)
                    }) : (E("onTransform", e), G(e));
                },
                onClose: function() {
                    K = !1, J(), o && o();
                }
            });
        } catch (e) {
            S(e);
        }
    }
    function ee(e, t) {
        E("setSelection", {
            anchor: e,
            head: t
        }), s && s.dispatch(s.state.update({
            selection: {
                anchor: e,
                head: t
            },
            scrollIntoView: !0
        }));
    }
    function te(e, t) {
        if (1 === t.state.selection.ranges.length) {
            var n = t.state.selection.ranges[0], r = L.slice(n.from, n.to);
            if ("{" === r || "[" === r) {
                var o = bc.parse(L), i = Object.keys(o.pointers).find(function(e) {
                    var t;
                    return (null === (t = o.pointers[e].value) || void 0 === t ? void 0 : t.pos) === n.from;
                }), a = o.pointers[i];
                if (i && a && a.value && a.valueEnd) E("pointer found, selecting inner contents of path:", i, a), ee(a.value.pos + 1, a.valueEnd.pos - 1);
            }
        }
    }
    function ne() {
        return function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return [
                m0.of({
                    source: e,
                    config: t
                }),
                p0,
                T0
            ];
        }(ke, {
            delay: 300
        });
    }
    function re(e) {
        var t = e.target, r = e.initialText, o = e.readOnly, i = e.indentation;
        E("Create CodeMirror editor", {
            readOnly: o,
            indentation: i
        });
        var a, l, u = kV.create({
            doc: r,
            selection: ce(v),
            extensions: [
                ZJ.of([
                    XZ,
                    A
                ]),
                N.of(ne()),
                N0(),
                AG(),
                RG,
                AK(),
                PX(),
                IY(),
                vK(),
                [
                    kK,
                    jK
                ],
                kV.allowMultipleSelections.of(!0),
                kV.transactionFilter.of(function(e) {
                    if (!e.docChanged || !e.isUserEvent("input.type") && !e.isUserEvent("input.complete")) return e;
                    var t = e.startState.languageDataAt("indentOnInput", e.startState.selection.main.head);
                    if (!t.length) return e;
                    var n = e.newDoc, r = e.newSelection.main.head, o = n.lineAt(r);
                    if (r > o.from + pY) return e;
                    var i = n.sliceString(o.from, r);
                    if (!t.some(function(e) {
                        return e.test(i);
                    })) return e;
                    var a, s = e.state, c = -1, l = [], u = bo(s.selection.ranges);
                    try {
                        for(u.s(); !(a = u.n()).done;){
                            var f = a.value.head, d = s.doc.lineAt(f);
                            if (d.from != c) {
                                c = d.from;
                                var h = aY(s, d.from);
                                if (null != h) {
                                    var v = /^\s*/.exec(d.text)[0], p = iY(s, h);
                                    v != p && l.push({
                                        from: d.from,
                                        to: d.from + v.length,
                                        insert: p
                                    });
                                }
                            }
                        }
                    } catch (e) {
                        u.e(e);
                    } finally{
                        u.f();
                    }
                    return l.length ? [
                        e,
                        {
                            changes: l,
                            sequential: !0
                        }
                    ] : e;
                }),
                FY(WY, {
                    fallback: !0
                }),
                tX(),
                [
                    e3,
                    G2
                ],
                l3(),
                BK(),
                VK(),
                IK,
                (l = [
                    $1,
                    C1
                ], a && l.push(x1.of(a)), l),
                ZJ.of([].concat(t3, Bo(YZ), n2, XX, _Y, u3, v0)),
                w3,
                E3({
                    hideFirstIndent: !0
                }),
                WJ.domEventHandlers({
                    dblclick: te
                }),
                WJ.updateListener.of(function(e) {
                    n(8, c = e.state), e.docChanged ? pe() : e.selectionSet && ye();
                }),
                new tY(a1),
                O1({
                    top: !0
                }),
                I.of(kV.readOnly.of(o)),
                z.of(kV.tabSize.of(m)),
                D.of(he(i)),
                q.of(WJ.theme({}, {
                    dark: oe()
                })),
                WJ.lineWrapping,
                P3
            ]
        });
        return s = new WJ({
            state: u,
            parent: t
        });
    }
    function oe() {
        return !!i && getComputedStyle(i).getPropertyValue("--jse-theme").includes("dark");
    }
    function ie(e) {
        var t = e.path, n = e.message, o = function(e, t) {
            try {
                var n = bc.parse(e), r = Zs(t), o = n.pointers[r];
                if (o) return {
                    path: t,
                    line: o.key ? o.key.line : o.value ? o.value.line : 0,
                    column: o.key ? o.key.column : o.value ? o.value.column : 0,
                    from: o.key ? o.key.pos : o.value ? o.value.pos : 0,
                    to: o.keyEnd ? o.keyEnd.pos : o.valueEnd ? o.valueEnd.pos : 0
                };
            } catch (e) {
                console.error(e);
            }
            return {
                path: t,
                line: 0,
                column: 0,
                from: 0,
                to: 0
            };
        }(r.escapeValue(L), t);
        return {
            path: t,
            line: o.line,
            column: o.column,
            from: o.from,
            to: o.to,
            message: n,
            severity: Za.warning,
            actions: []
        };
    }
    function ae(e, t) {
        var n = e.line, r = e.column, o = e.position, i = e.message;
        return {
            path: [],
            line: n,
            column: r,
            from: o,
            to: o,
            severity: Za.error,
            message: i,
            actions: t && !l ? [
                {
                    name: "Auto repair",
                    apply: function() {
                        return X();
                    }
                }
            ] : null
        };
    }
    function se(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], o = Y_(e, p, y), i = !Ox(e, B), a = B;
        E("setCodeMirrorContent", {
            isChanged: i,
            forceUpdate: t
        }), s && (i || t) && (B = e, n(11, L = o), be(L, T) || s.dispatch({
            changes: {
                from: 0,
                to: s.state.doc.length,
                insert: r.escapeValue(L)
            }
        }), ve(), i && ge(B, a));
    }
    function ce(e) {
        return bE(e) ? PF.fromJSON(e) : void 0;
    }
    function le() {
        return (le = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return E("refresh"), e.next = 3, fe();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function ue() {
        if (s) {
            var e = s ? r.unescapeValue(s.state.doc.toString()) : "", t = e !== L;
            if (E("onChangeCodeMirrorValue", {
                isChanged: t
            }), t) {
                var o = B;
                n(11, L = e), B = {
                    text: L
                }, ve(), ge(B, o), ca().then(ye);
            }
        }
    }
    function fe() {
        return de.apply(this, arguments);
    }
    function de() {
        return (de = ko(wo().mark(function e() {
            var t;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, ca();
                    case 2:
                        s && (t = oe(), E("updateTheme", {
                            dark: t
                        }), s.dispatch({
                            effects: [
                                q.reconfigure(WJ.theme({}, {
                                    dark: t
                                }))
                            ]
                        }));
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function he(e) {
        return rY.of("number" == typeof e ? " ".repeat(e) : e);
    }
    function ve() {
        n(12, V = qX(s.state) > 0), n(13, H = BX(s.state) > 0), E({
            canUndo: V,
            canRedo: H
        });
    }
    Qi(function() {
        me();
    }), ON({
        onMount: Gi,
        onDestroy: Qi,
        getWindow: function() {
            return SO(a);
        },
        hasFocus: function() {
            return K && document.hasFocus() || CO(a);
        },
        onFocus: C,
        onBlur: function() {
            me(), $();
        }
    });
    var pe = Vy(ue, 300);
    function me() {
        pe.flush();
    }
    function ge(e, t) {
        x && x(e, t, {
            contentErrors: je(),
            patchResult: null
        });
    }
    function ye() {
        j(Ro({
            type: Ya.text
        }, c.selection.toJSON()));
    }
    function be(e, t) {
        return !!e && e.length > ps && !t;
    }
    var we = $s, xe = null;
    function ke() {
        if (be(L, T)) return [];
        var e = je();
        return uI(e) ? [
            H3(ae(e.parseError, e.isRepairable))
        ] : fI(e) ? e.validationErrors.map(ie).map(H3) : [];
    }
    function je() {
        E("validate:start"), me();
        var e = Se(r.escapeValue(L), b, y, w);
        return uI(e) ? (n(51, we = e.isRepairable ? _s : "invalid"), n(14, xe = e.parseError), n(10, R = [])) : (n(51, we = $s), n(14, xe = null), n(10, R = (null == e ? void 0 : e.validationErrors) || [])), E("validate:end"), e;
    }
    var Se = EB($N);
    function Ce() {
        xe && function(e) {
            E("select parse error", e);
            var t = ae(e, !1);
            ee(null != t.from ? t.from : 0, null != t.to ? t.to : 0), J();
        }(xe);
    }
    var $e = {
        icon: fP,
        text: "Show me",
        title: "Move to the parse error location",
        onClick: Ce
    };
    return e.$$set = function(e) {
        "readOnly" in e && n(1, l = e.readOnly), "mainMenuBar" in e && n(2, u = e.mainMenuBar), "statusBar" in e && n(3, f = e.statusBar), "askToFormat" in e && n(0, d = e.askToFormat), "externalContent" in e && n(30, h = e.externalContent), "externalSelection" in e && n(31, v = e.externalSelection), "indentation" in e && n(32, p = e.indentation), "tabSize" in e && n(33, m = e.tabSize), "escapeUnicodeCharacters" in e && n(34, g = e.escapeUnicodeCharacters), "parser" in e && n(35, y = e.parser), "validator" in e && n(36, b = e.validator), "validationParser" in e && n(37, w = e.validationParser), "onChange" in e && n(38, x = e.onChange), "onChangeMode" in e && n(39, k = e.onChangeMode), "onSelect" in e && n(40, j = e.onSelect), "onError" in e && n(41, S = e.onError), "onFocus" in e && n(42, C = e.onFocus), "onBlur" in e && n(43, $ = e.onBlur), "onRenderMenu" in e && n(4, _ = e.onRenderMenu), "onSortModal" in e && n(44, O = e.onSortModal), "onTransformModal" in e && n(45, M = e.onTransformModal);
    }, e.$$.update = function() {
        8 & e.$$.dirty[1] && (r = aO({
            escapeControlCharacters: !1,
            escapeUnicodeCharacters: g
        })), 1073741824 & e.$$.dirty[0] && se(h), 1 & e.$$.dirty[1] && function(e) {
            if (bE(e)) {
                var t = ce(e);
                !s || !t || c && c.selection.eq(t) || (E("applyExternalSelection", t), s.dispatch({
                    selection: t
                }));
            }
        }(v), 32 & e.$$.dirty[1] && function(e) {
            E("updateLinter", e), s && s.dispatch({
                effects: N.reconfigure(ne())
            });
        }(b), 2 & e.$$.dirty[1] && function(e) {
            s && (E("updateIndentation", e), s.dispatch({
                effects: D.reconfigure(he(e))
            }));
        }(p), 4 & e.$$.dirty[1] && function(e) {
            s && (E("updateTabSize", e), s.dispatch({
                effects: z.reconfigure(kV.tabSize.of(e))
            }));
        }(m), 2 & e.$$.dirty[0] && function(e) {
            s && (E("updateReadOnly", e), s.dispatch({
                effects: [
                    I.reconfigure(kV.readOnly.of(e))
                ]
            }));
        }(l), 524296 & e.$$.dirty[1] && F !== g && (n(50, F = g), E("forceUpdateText", {
            escapeUnicodeCharacters: g
        }), s && s.dispatch({
            changes: {
                from: 0,
                to: s.state.doc.length,
                insert: r.escapeValue(L)
            }
        })), 2 & e.$$.dirty[0] | 1048576 & e.$$.dirty[1] && n(15, o = we !== _s || l ? [
            $e
        ] : [
            {
                icon: uP,
                text: "Auto repair",
                title: "Automatically repair JSON",
                onClick: X
            },
            $e
        ]);
    }, [
        d,
        l,
        u,
        f,
        _,
        J,
        i,
        a,
        c,
        T,
        R,
        L,
        V,
        H,
        xe,
        o,
        P,
        Q,
        Y,
        function() {
            var e;
            if (!l) try {
                var t = y.parse(L);
                K = !0, O({
                    id: W,
                    json: t,
                    rootPath: [],
                    onSort: (e = ko(wo().mark(function e(t) {
                        var n;
                        return wo().wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    n = t.operations, E("onSort", n), G(n);
                                case 3:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    })), function(t) {
                        return e.apply(this, arguments);
                    }),
                    onClose: function() {
                        K = !1, J();
                    }
                });
            } catch (e) {
                S(e);
            }
        },
        function() {
            l || Z({
                rootPath: []
            });
        },
        function() {
            s && (i && i.querySelector(".cm-search") ? t2(s) : e2(s));
        },
        function() {
            l || s && (RX(s), J());
        },
        function() {
            l || s && (NX(s), J());
        },
        function() {
            n(9, T = !0), se(h, !0);
        },
        function() {
            k(Qa.tree);
        },
        function() {
            ue();
        },
        function(e) {
            E("select validation error", e);
            var t = ie(e), n = t.from, r = t.to;
            null !== n && null !== r && (ee(n, r), J());
        },
        be,
        Ce,
        h,
        v,
        p,
        m,
        g,
        y,
        b,
        w,
        x,
        k,
        j,
        S,
        C,
        $,
        O,
        M,
        G,
        Z,
        function() {
            return le.apply(this, arguments);
        },
        je,
        F,
        we,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(6, i = e);
            });
        },
        function() {
            return n(0, d = !1);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(7, a = e);
            });
        }
    ];
}
var U3 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, W3, V3, Zo, {
            readOnly: 1,
            mainMenuBar: 2,
            statusBar: 3,
            askToFormat: 0,
            externalContent: 30,
            externalSelection: 31,
            indentation: 32,
            tabSize: 33,
            escapeUnicodeCharacters: 34,
            parser: 35,
            validator: 36,
            validationParser: 37,
            onChange: 38,
            onChangeMode: 39,
            onSelect: 40,
            onError: 41,
            onFocus: 42,
            onBlur: 43,
            onRenderMenu: 4,
            onSortModal: 44,
            onTransformModal: 45,
            focus: 5,
            patch: 46,
            openTransformModal: 47,
            refresh: 48,
            validate: 49
        }, T3, [
            -1,
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "focus",
            get: function() {
                return this.$$.ctx[5];
            }
        },
        {
            key: "patch",
            get: function() {
                return this.$$.ctx[46];
            }
        },
        {
            key: "openTransformModal",
            get: function() {
                return this.$$.ctx[47];
            }
        },
        {
            key: "refresh",
            get: function() {
                return this.$$.ctx[48];
            }
        },
        {
            key: "validate",
            get: function() {
                return this.$$.ctx[49];
            }
        }
    ]), t;
}();
function J3(e) {
    var t, n;
    return t = new PI({
        props: {
            items: e[0]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & jo(n, 1)[0] && (r.items = e[0]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function K3(e, t, n) {
    var r, o, i = t.json, a = t.readOnly, s = t.historyState, c = t.onSort, l = t.onTransform, u = t.onContextMenu, f = t.onUndo, d = t.onRedo, h = t.onRenderMenu;
    return e.$$set = function(e) {
        "json" in e && n(1, i = e.json), "readOnly" in e && n(2, a = e.readOnly), "historyState" in e && n(3, s = e.historyState), "onSort" in e && n(4, c = e.onSort), "onTransform" in e && n(5, l = e.onTransform), "onContextMenu" in e && n(6, u = e.onContextMenu), "onUndo" in e && n(7, f = e.onUndo), "onRedo" in e && n(8, d = e.onRedo), "onRenderMenu" in e && n(9, h = e.onRenderMenu);
    }, e.$$.update = function() {
        510 & e.$$.dirty && n(10, r = a ? [
            {
                type: "space"
            }
        ] : [
            {
                type: "button",
                icon: wP,
                title: "Sort",
                className: "jse-sort",
                onClick: c,
                disabled: a || void 0 === i
            },
            {
                type: "button",
                icon: cP,
                title: "Transform contents (filter, sort, project)",
                className: "jse-transform",
                onClick: l,
                disabled: a || void 0 === i
            },
            {
                type: "button",
                icon: yP,
                title: ks,
                className: "jse-contextmenu",
                onClick: u
            },
            {
                type: "separator"
            },
            {
                type: "button",
                icon: vP,
                title: "Undo (Ctrl+Z)",
                className: "jse-undo",
                onClick: f,
                disabled: !s.canUndo
            },
            {
                type: "button",
                icon: hP,
                title: "Redo (Ctrl+Shift+Z)",
                className: "jse-redo",
                onClick: d,
                disabled: !s.canRedo
            },
            {
                type: "space"
            }
        ]), 1536 & e.$$.dirty && n(0, o = h(r));
    }, [
        o,
        i,
        a,
        s,
        c,
        l,
        u,
        f,
        d,
        h,
        r
    ];
}
var G3 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, K3, J3, Zo, {
            json: 1,
            readOnly: 2,
            historyState: 3,
            onSort: 4,
            onTransform: 5,
            onContextMenu: 6,
            onUndo: 7,
            onRedo: 8,
            onRenderMenu: 9
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function Q3(e, t, n) {
    var r = e.slice();
    return r[9] = t[n], r;
}
function Y3(e) {
    var t, n, r = e[9].component, o = Z3(e);
    return {
        c: function() {
            o.c(), t = _i();
        },
        m: function(e, r) {
            o.m(e, r), wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            1 & n && Zo(r, r = e[9].component) ? (ba(), ka(o, 1, 1, Wo), wa(), (o = Z3(e)).c(), xa(o, 1), o.m(t.parentNode, t)) : o.p(e, n);
        },
        i: function(e) {
            n || (xa(o), n = !0);
        },
        o: function(e) {
            ka(o), n = !1;
        },
        d: function(e) {
            e && xi(t), o.d(e);
        }
    };
}
function X3(e) {
    var t, n = e[9].action, r = e4(e);
    return {
        c: function() {
            r.c(), t = _i();
        },
        m: function(e, n) {
            r.m(e, n), wi(e, t, n);
        },
        p: function(e, o) {
            1 & o && Zo(n, n = e[9].action) ? (r.d(1), (r = e4(e)).c(), r.m(t.parentNode, t)) : r.p(e, o);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), r.d(e);
        }
    };
}
function Z3(e) {
    var t, n, r, o = [
        e[9].props
    ], i = e[9].component;
    function a(e, t) {
        var n = {};
        if (void 0 !== t && 1 & t) n = Ma(o, [
            Ea(e[9].props)
        ]);
        else for(var r = 0; r < o.length; r += 1)n = Jo(n, o[r]);
        return {
            props: n
        };
    }
    return i && (t = Li(i, a(e))), {
        c: function() {
            t && Pa(t.$$.fragment), n = _i();
        },
        m: function(e, o) {
            t && Ta(t, e, o), wi(e, n, o), r = !0;
        },
        p: function(e, r) {
            if (1 & r && i !== (i = e[9].component)) {
                if (t) {
                    ba();
                    var s = t;
                    ka(s.$$.fragment, 1, 0, function() {
                        Ra(s, 1);
                    }), wa();
                }
                i ? (Pa((t = Li(i, a(e, r))).$$.fragment), xa(t.$$.fragment, 1), Ta(t, n.parentNode, n)) : t = null;
            } else if (i) {
                var c = 1 & r ? Ma(o, [
                    Ea(e[9].props)
                ]) : {};
                t.$set(c);
            }
        },
        i: function(e) {
            r || (t && xa(t.$$.fragment, e), r = !0);
        },
        o: function(e) {
            t && ka(t.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(n), t && Ra(t, e);
        }
    };
}
function e4(e) {
    var t, n, r, o;
    return {
        c: function() {
            Ai(t = ji("div"), "role", "button"), Ai(t, "tabindex", "-1"), Ai(t, "class", "jse-value jse-readonly-password"), Ai(t, "data-type", "selectable-value");
        },
        m: function(i, a) {
            wi(i, t, a), r || (o = ci(n = e[12].call(null, t, e[9].props)), r = !0);
        },
        p: function(t, r) {
            e = t, n && Yo(n.update) && 1 & r && n.update.call(null, e[9].props);
        },
        d: function(e) {
            e && xi(t), r = !1, o();
        }
    };
}
function t4(e) {
    var t, n, r, o, i, a = [
        X3,
        Y3
    ], s = [];
    function c(e, n) {
        return 1 & n && (t = null), null == t && (t = !!pI(e[9])), t ? 0 : 1;
    }
    function l(e, t) {
        return 0 === t ? function(e) {
            var t = e.slice(), n = t[9].action;
            return t[12] = n, t;
        }(e) : e;
    }
    return n = c(e, -1), r = s[n] = a[n](l(e, n)), {
        c: function() {
            r.c(), o = _i();
        },
        m: function(e, t) {
            s[n].m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, t) {
            var i = n;
            (n = c(e, t)) === i ? s[n].p(l(e, n), t) : (ba(), ka(s[i], 1, 1, function() {
                s[i] = null;
            }), wa(), (r = s[n]) ? r.p(l(e, n), t) : (r = s[n] = a[n](l(e, n))).c(), xa(r, 1), r.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(o), s[n].d(e);
        }
    };
}
function n4(e) {
    for(var t, n, r = Ca(e[0]), o = [], i = 0; i < r.length; i += 1)o[i] = t4(Q3(e, r, i));
    var a = function(e) {
        return ka(o[e], 1, 1, function() {
            o[e] = null;
        });
    };
    return {
        c: function() {
            for(var e = 0; e < o.length; e += 1)o[e].c();
            t = _i();
        },
        m: function(e, r) {
            for(var i = 0; i < o.length; i += 1)o[i] && o[i].m(e, r);
            wi(e, t, r), n = !0;
        },
        p: function(e, n) {
            var i = jo(n, 1)[0];
            if (1 & i) {
                var s;
                for(r = Ca(e[0]), s = 0; s < r.length; s += 1){
                    var c = Q3(e, r, s);
                    o[s] ? (o[s].p(c, i), xa(o[s], 1)) : (o[s] = t4(c), o[s].c(), xa(o[s], 1), o[s].m(t.parentNode, t));
                }
                for(ba(), s = r.length; s < o.length; s += 1)a(s);
                wa();
            }
        },
        i: function(e) {
            if (!n) {
                for(var t = 0; t < r.length; t += 1)xa(o[t]);
                n = !0;
            }
        },
        o: function(e) {
            o = o.filter(Boolean);
            for(var t = 0; t < o.length; t += 1)ka(o[t]);
            n = !1;
        },
        d: function(e) {
            e && xi(t), ki(o, e);
        }
    };
}
function r4(e, t, n) {
    var r, o, i = t.path, a = t.value, s = t.context, c = t.enforceString, l = t.selection, u = t.searchResultItems;
    function f(e, t) {
        return s.onPatch(function(e, t) {
            return e.flatMap(function(e) {
                if (Ds(e)) {
                    var n = Xs(e.path);
                    if (n.length > 0) {
                        for(var r = [
                            e
                        ], o = Qw(n); o.length > 0 && !Ys(t, o);)r.unshift({
                            op: "add",
                            path: Zs(o),
                            value: {}
                        }), o = Qw(o);
                        return r;
                    }
                }
                return e;
            });
        }(e, s.getJson()), t);
    }
    return e.$$set = function(e) {
        "path" in e && n(1, i = e.path), "value" in e && n(2, a = e.value), "context" in e && n(3, s = e.context), "enforceString" in e && n(4, c = e.enforceString), "selection" in e && n(5, l = e.selection), "searchResultItems" in e && n(6, u = e.searchResultItems);
    }, e.$$.update = function() {
        40 & e.$$.dirty && n(7, r = !s.readOnly && pE(l) && qE(l)), 254 & e.$$.dirty && n(0, o = s.onRenderValue({
            path: i,
            value: a,
            readOnly: s.readOnly,
            enforceString: c,
            isEditing: r,
            parser: s.parser,
            normalization: s.normalization,
            selection: l,
            searchResultItems: u,
            onPatch: f,
            onPasteJson: s.onPasteJson,
            onSelect: s.onSelect,
            onFind: s.onFind,
            findNextInside: s.findNextInside,
            focus: s.focus
        }));
    }, [
        o,
        i,
        a,
        s,
        c,
        l,
        u,
        r
    ];
}
var o4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, r4, n4, Zo, {
            path: 1,
            value: 2,
            context: 3,
            enforceString: 4,
            selection: 5,
            searchResultItems: 6
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function i4(e) {
    mi(e, "svelte-1o4m3u7", '.jse-inline-value.svelte-1o4m3u7{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));border:none;padding:0 calc(0.5 * var(--jse-padding, 10px));background:transparent;color:inherit;cursor:pointer}.jse-inline-value.svelte-1o4m3u7:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-inline-value.jse-selected.svelte-1o4m3u7{background:var(--jse-selection-background-color, #d3d3d3)}');
}
function a4(e) {
    var t, n, r, o, i, a = tM(null !== (t = e[2].stringify(e[1])) && void 0 !== t ? t : "", 50) + "";
    return {
        c: function() {
            n = ji("button"), r = Ci(a), Ai(n, "type", "button"), Ai(n, "class", "jse-inline-value svelte-1o4m3u7"), qi(n, "jse-selected", e[3]);
        },
        m: function(t, a) {
            wi(t, n, a), pi(n, r), o || (i = Oi(n, "dblclick", e[5]), o = !0);
        },
        p: function(e, t) {
            var o, i = jo(t, 1)[0];
            6 & i && a !== (a = tM(null !== (o = e[2].stringify(e[1])) && void 0 !== o ? o : "", 50) + "") && Ni(r, a), 8 & i && qi(n, "jse-selected", e[3]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(n), o = !1, i();
        }
    };
}
function s4(e, t, n) {
    var r = t.path, o = t.value, i = t.parser, a = t.isSelected, s = t.onEdit;
    return e.$$set = function(e) {
        "path" in e && n(0, r = e.path), "value" in e && n(1, o = e.value), "parser" in e && n(2, i = e.parser), "isSelected" in e && n(3, a = e.isSelected), "onEdit" in e && n(4, s = e.onEdit);
    }, [
        r,
        o,
        i,
        a,
        s,
        function() {
            return s(r);
        }
    ];
}
var c4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, s4, a4, Zo, {
            path: 0,
            value: 1,
            parser: 2,
            isSelected: 3,
            onEdit: 4
        }, i4), n;
    }
    return Ao(t, Ia), Do(t);
}();
function l4(e) {
    mi(e, "svelte-2v0aqj", ".jse-column-header.svelte-2v0aqj.svelte-2v0aqj{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:not(.jse-column-header.jse-readonly){cursor:pointer}.jse-column-header.svelte-2v0aqj span.jse-column-sort-icon.svelte-2v0aqj{height:1em}");
}
function u4(e) {
    var t, n, r, o;
    return n = new jM({
        props: {
            data: e[1] === ts.asc ? gP : sP
        }
    }), {
        c: function() {
            t = ji("span"), Pa(n.$$.fragment), Ai(t, "class", "jse-column-sort-icon svelte-2v0aqj"), Ai(t, "title", r = "Currently sorted in ".concat(e[2], " order"));
        },
        m: function(e, r) {
            wi(e, t, r), Ta(n, t, null), o = !0;
        },
        p: function(e, i) {
            var a = {};
            2 & i && (a.data = e[1] === ts.asc ? gP : sP), n.$set(a), (!o || 4 & i && r !== (r = "Currently sorted in ".concat(e[2], " order"))) && Ai(t, "title", r);
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function f4(e) {
    var t, n, r, o, i, a, s, c, l = tM(e[3], 50) + "", u = void 0 !== e[1] && u4(e);
    return {
        c: function() {
            t = ji("button"), n = ji("span"), r = Ci(l), o = $i(), u && u.c(), Ai(n, "class", "jse-column-name"), Ai(t, "type", "button"), Ai(t, "class", "jse-column-header svelte-2v0aqj"), Ai(t, "title", i = e[0] ? e[3] : e[3] + " (Click to sort the data by this column)"), qi(t, "jse-readonly", e[0]);
        },
        m: function(i, l) {
            wi(i, t, l), pi(t, n), pi(n, r), pi(t, o), u && u.m(t, null), a = !0, s || (c = Oi(t, "click", e[4]), s = !0);
        },
        p: function(e, n) {
            var o = jo(n, 1)[0];
            (!a || 8 & o) && l !== (l = tM(e[3], 50) + "") && Ni(r, l), void 0 !== e[1] ? u ? (u.p(e, o), 2 & o && xa(u, 1)) : ((u = u4(e)).c(), xa(u, 1), u.m(t, null)) : u && (ba(), ka(u, 1, 1, function() {
                u = null;
            }), wa()), (!a || 9 & o && i !== (i = e[0] ? e[3] : e[3] + " (Click to sort the data by this column)")) && Ai(t, "title", i), (!a || 1 & o) && qi(t, "jse-readonly", e[0]);
        },
        i: function(e) {
            a || (xa(u), a = !0);
        },
        o: function(e) {
            ka(u), a = !1;
        },
        d: function(e) {
            e && xi(t), u && u.d(), s = !1, c();
        }
    };
}
function d4(e, t, n) {
    var r, o, i, a = t.path, s = t.sortedColumn, c = t.readOnly, l = t.onSort;
    return e.$$set = function(e) {
        "path" in e && n(5, a = e.path), "sortedColumn" in e && n(6, s = e.sortedColumn), "readOnly" in e && n(0, c = e.readOnly), "onSort" in e && n(7, l = e.onSort);
    }, e.$$.update = function() {
        var t;
        (32 & e.$$.dirty && n(3, r = _x(a) ? "values" : JO(a)), 96 & e.$$.dirty) && n(1, o = s && Ox(a, null === (t = s) || void 0 === t ? void 0 : t.path) ? s.sortDirection : void 0);
        2 & e.$$.dirty && n(2, i = o ? Es[o] : void 0);
    }, [
        c,
        o,
        i,
        r,
        function() {
            c || l({
                path: a,
                sortDirection: o === ts.asc ? ts.desc : ts.asc
            });
        },
        a,
        s,
        l
    ];
}
var h4, v4, p4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, d4, f4, Zo, {
            path: 5,
            sortedColumn: 6,
            readOnly: 0,
            onSort: 7
        }, l4), n;
    }
    return Ao(t, Ia), Do(t);
}();
function m4(e, t) {
    return h4 || (v4 = new WeakMap, h4 = new ResizeObserver(function(e) {
        var t, n = bo(e);
        try {
            for(n.s(); !(t = n.n()).done;){
                var r = t.value, o = v4.get(r.target);
                o && o(r.target);
            }
        } catch (e) {
            n.e(e);
        } finally{
            n.f();
        }
    })), v4.set(e, t), h4.observe(e), {
        destroy: function() {
            v4.delete(e), h4.unobserve(e);
        }
    };
}
function g4(e) {
    var t, n;
    return t = new BD({
        props: {
            items: e[2],
            onCloseContextMenu: e[1],
            tip: e[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = jo(n, 1)[0], o = {};
            4 & r && (o.items = e[2]), 2 & r && (o.onCloseContextMenu = e[1]), 1 & r && (o.tip = e[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0), t.$set(o);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function y4(e, t, n) {
    var r, o, i, a, s, c, l, u, f, d, h = t.json, v = t.documentState, p = t.parser, m = t.showTip, g = t.onCloseContextMenu, y = t.onRenderContextMenu, b = t.onEditValue, w = t.onEditRow, x = t.onToggleEnforceString, k = t.onCut, j = t.onCopy, S = t.onPaste, C = t.onRemove, $ = t.onDuplicateRow, _ = t.onInsertBeforeRow, O = t.onInsertAfterRow, M = t.onRemoveRow;
    return e.$$set = function(e) {
        "json" in e && n(3, h = e.json), "documentState" in e && n(4, v = e.documentState), "parser" in e && n(5, p = e.parser), "showTip" in e && n(0, m = e.showTip), "onCloseContextMenu" in e && n(1, g = e.onCloseContextMenu), "onRenderContextMenu" in e && n(6, y = e.onRenderContextMenu), "onEditValue" in e && n(7, b = e.onEditValue), "onEditRow" in e && n(8, w = e.onEditRow), "onToggleEnforceString" in e && n(9, x = e.onToggleEnforceString), "onCut" in e && n(10, k = e.onCut), "onCopy" in e && n(11, j = e.onCopy), "onPaste" in e && n(12, S = e.onPaste), "onRemove" in e && n(13, C = e.onRemove), "onDuplicateRow" in e && n(14, $ = e.onDuplicateRow), "onInsertBeforeRow" in e && n(15, _ = e.onInsertBeforeRow), "onInsertAfterRow" in e && n(16, O = e.onInsertAfterRow), "onRemoveRow" in e && n(17, M = e.onRemoveRow);
    }, e.$$.update = function() {
        16 & e.$$.dirty && n(24, r = v.selection), 8 & e.$$.dirty && n(26, o = void 0 !== h), 16777216 & e.$$.dirty && n(19, i = !!r), 16777224 & e.$$.dirty && n(25, a = void 0 !== h && r ? Ws(h, JE(r)) : void 0), 83886080 & e.$$.dirty && n(20, s = o && (mE(r) || vE(r) || pE(r))), 83886080 & e.$$.dirty && n(23, c = o && null != r && ME(r)), 41943040 & e.$$.dirty && n(21, l = c && !Ql(a)), 50331696 & e.$$.dirty && n(22, u = null != r && void 0 !== a && oE(a, v.enforceStringMap, Zs(JE(r)), p)), 16514944 & e.$$.dirty && n(18, d = [
            {
                type: "separator"
            },
            {
                type: "row",
                items: [
                    {
                        type: "column",
                        items: [
                            {
                                type: "label",
                                text: "Table cell:"
                            },
                            {
                                type: "dropdown-button",
                                main: {
                                    type: "button",
                                    onClick: function() {
                                        return b();
                                    },
                                    icon: dP,
                                    text: "Edit",
                                    title: "Edit the value (Double-click on the value)",
                                    disabled: !c
                                },
                                width: "11em",
                                items: [
                                    {
                                        type: "button",
                                        icon: dP,
                                        text: "Edit",
                                        title: "Edit the value (Double-click on the value)",
                                        onClick: function() {
                                            return b();
                                        },
                                        disabled: !c
                                    },
                                    {
                                        type: "button",
                                        icon: u ? iM : aM,
                                        text: "Enforce string",
                                        title: "Enforce keeping the value as string when it contains a numeric value",
                                        onClick: function() {
                                            return x();
                                        },
                                        disabled: !l
                                    }
                                ]
                            },
                            {
                                type: "dropdown-button",
                                main: {
                                    type: "button",
                                    onClick: function() {
                                        return k(!0);
                                    },
                                    icon: eP,
                                    text: "Cut",
                                    title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                                    disabled: !s
                                },
                                width: "10em",
                                items: [
                                    {
                                        type: "button",
                                        icon: eP,
                                        text: "Cut formatted",
                                        title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                                        onClick: function() {
                                            return k(!0);
                                        },
                                        disabled: !s
                                    },
                                    {
                                        type: "button",
                                        icon: eP,
                                        text: "Cut compacted",
                                        title: "Cut selected contents, without indentation (Ctrl+Shift+X)",
                                        onClick: function() {
                                            return k(!1);
                                        },
                                        disabled: !s
                                    }
                                ]
                            },
                            {
                                type: "dropdown-button",
                                main: {
                                    type: "button",
                                    onClick: function() {
                                        return j(!0);
                                    },
                                    icon: CP,
                                    text: "Copy",
                                    title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                                    disabled: !s
                                },
                                width: "12em",
                                items: [
                                    {
                                        type: "button",
                                        icon: CP,
                                        text: "Copy formatted",
                                        title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                                        onClick: function() {
                                            return j(!1);
                                        },
                                        disabled: !s
                                    },
                                    {
                                        type: "button",
                                        icon: CP,
                                        text: "Copy compacted",
                                        title: "Copy selected contents, without indentation (Ctrl+Shift+C)",
                                        onClick: function() {
                                            return j(!1);
                                        },
                                        disabled: !s
                                    }
                                ]
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return S();
                                },
                                icon: XA,
                                text: "Paste",
                                title: "Paste clipboard contents (Ctrl+V)",
                                disabled: !i
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return C();
                                },
                                icon: QA,
                                text: "Remove",
                                title: "Remove selected contents (Delete)",
                                disabled: !s
                            }
                        ]
                    },
                    {
                        type: "column",
                        items: [
                            {
                                type: "label",
                                text: "Table row:"
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return w();
                                },
                                icon: dP,
                                text: "Edit row",
                                title: "Edit the current row",
                                disabled: !s
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return $();
                                },
                                icon: AP,
                                text: "Duplicate row",
                                title: "Duplicate the current row",
                                disabled: !i
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return _();
                                },
                                icon: $P,
                                text: "Insert before",
                                title: "Insert a row before the current row",
                                disabled: !i
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return O();
                                },
                                icon: $P,
                                text: "Insert after",
                                title: "Insert a row after the current row",
                                disabled: !i
                            },
                            {
                                type: "button",
                                onClick: function() {
                                    return M();
                                },
                                icon: QA,
                                text: "Remove row",
                                title: "Remove current row",
                                disabled: !i
                            }
                        ]
                    }
                ]
            }
        ]), 262208 & e.$$.dirty && n(2, f = y(d));
    }, [
        m,
        g,
        f,
        h,
        v,
        p,
        y,
        b,
        w,
        x,
        k,
        j,
        S,
        C,
        $,
        _,
        O,
        M,
        d,
        i,
        s,
        l,
        u,
        c,
        r,
        a,
        o
    ];
}
var b4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, y4, g4, Zo, {
            json: 3,
            documentState: 4,
            parser: 5,
            showTip: 0,
            onCloseContextMenu: 1,
            onRenderContextMenu: 6,
            onEditValue: 7,
            onEditRow: 8,
            onToggleEnforceString: 9,
            onCut: 10,
            onCopy: 11,
            onPaste: 12,
            onRemove: 13,
            onDuplicateRow: 14,
            onInsertBeforeRow: 15,
            onInsertAfterRow: 16,
            onRemoveRow: 17
        }), n;
    }
    return Ao(t, Ia), Do(t);
}();
function w4(e) {
    mi(e, "svelte-fxr3ye", '.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye{flex:1;display:flex;flex-direction:column;overflow:auto;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-before.svelte-fxr3ye{flex:1}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays.svelte-fxr3ye{display:flex;flex-direction:column;gap:var(--jse-padding, 10px);max-width:300px;margin:2em var(--jse-padding, 10px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays .jse-nested-arrays-info.svelte-fxr3ye{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px;text-align:left}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action .jse-nested-array-count.svelte-fxr3ye{opacity:0.5;white-space:nowrap}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-after.svelte-fxr3ye{flex:2}');
}
function x4(e, t, n) {
    var r = e.slice();
    r[14] = t[n];
    var o = r[8](r[14]);
    return r[15] = o, r;
}
function k4(e) {
    var t, n;
    return {
        c: function() {
            t = Ci(e[6]), n = Ci(" cannot be opened in table mode.");
        },
        m: function(e, r) {
            wi(e, t, r), wi(e, n, r);
        },
        p: function(e, n) {
            64 & n && Ni(t, e[6]);
        },
        d: function(e) {
            e && (xi(t), xi(n));
        }
    };
}
function j4(e) {
    var t;
    return {
        c: function() {
            t = Ci("An object cannot be opened in table mode. You can open a nested array instead, or open the\n        document in tree mode.");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function S4(e) {
    var t;
    return {
        c: function() {
            t = Ci("You can open the document in tree mode instead.");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function C4(e) {
    var t, n, r;
    return {
        c: function() {
            t = Ci("You can open the document in tree mode instead, or paste a JSON Array using "), (n = ji("b")).textContent = "Ctrl+V", r = Ci(".");
        },
        m: function(e, o) {
            wi(e, t, o), wi(e, n, o), wi(e, r, o);
        },
        d: function(e) {
            e && (xi(t), xi(n), xi(r));
        }
    };
}
function $4(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v = JO(e[14]) + "", p = e[15] + "", m = 1 !== e[15] ? "items" : "item";
    function g() {
        return e[12](e[14]);
    }
    return {
        c: function() {
            t = ji("button"), n = Ci(e[7]), r = Ci(' "'), o = Ci(v), i = Ci('"\n        '), a = ji("span"), s = Ci("("), c = Ci(p), l = $i(), u = Ci(m), f = Ci(")"), Ai(a, "class", "jse-nested-array-count svelte-fxr3ye"), Ai(t, "type", "button"), Ai(t, "class", "jse-nested-array-action svelte-fxr3ye");
        },
        m: function(e, v) {
            wi(e, t, v), pi(t, n), pi(t, r), pi(t, o), pi(t, i), pi(t, a), pi(a, s), pi(a, c), pi(a, l), pi(a, u), pi(a, f), d || (h = Oi(t, "click", g), d = !0);
        },
        p: function(t, r) {
            e = t, 128 & r && Ni(n, e[7]), 8 & r && v !== (v = JO(e[14]) + "") && Ni(o, v), 8 & r && p !== (p = e[15] + "") && Ni(c, p), 8 & r && m !== (m = 1 !== e[15] ? "items" : "item") && Ni(u, m);
        },
        d: function(e) {
            e && xi(t), d = !1, h();
        }
    };
}
function _4(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y;
    function b(e, t) {
        return e[5] ? j4 : k4;
    }
    var w = b(e), x = w(e);
    function k(e, t) {
        return e[4] && !e[0] ? C4 : S4;
    }
    for(var j = k(e), S = j(e), C = Ca(e[3]), $ = [], _ = 0; _ < C.length; _ += 1)$[_] = $4(x4(e, C, _));
    return {
        c: function() {
            t = ji("div"), n = ji("div"), r = $i(), o = ji("div"), i = ji("div"), a = Ci(e[6]), s = $i(), c = ji("div"), x.c(), l = $i(), S.c(), u = $i();
            for(var g = 0; g < $.length; g += 1)$[g].c();
            f = $i(), d = ji("button"), h = Ci(e[7]), v = Ci(" in tree mode"), p = $i(), m = ji("div"), Ai(n, "class", "jse-space jse-before svelte-fxr3ye"), Ai(i, "class", "jse-nested-arrays-title"), Ai(c, "class", "jse-nested-arrays-info svelte-fxr3ye"), Ai(d, "type", "button"), Ai(d, "class", "jse-nested-array-action svelte-fxr3ye"), Ai(o, "class", "jse-nested-arrays svelte-fxr3ye"), Ai(m, "class", "jse-space jse-after svelte-fxr3ye"), Ai(t, "class", "jse-table-mode-welcome svelte-fxr3ye");
        },
        m: function(b, w) {
            wi(b, t, w), pi(t, n), pi(t, r), pi(t, o), pi(o, i), pi(i, a), pi(o, s), pi(o, c), x.m(c, null), pi(c, l), S.m(c, null), pi(o, u);
            for(var k = 0; k < $.length; k += 1)$[k] && $[k].m(o, null);
            pi(o, f), pi(o, d), pi(d, h), pi(d, v), pi(t, p), pi(t, m), g || (y = Oi(d, "click", e[13]), g = !0);
        },
        p: function(e, t) {
            var n = jo(t, 1)[0];
            if (64 & n && Ni(a, e[6]), w === (w = b(e)) && x ? x.p(e, n) : (x.d(1), (x = w(e)) && (x.c(), x.m(c, l))), j !== (j = k(e)) && (S.d(1), (S = j(e)) && (S.c(), S.m(c, null))), 394 & n) {
                var r;
                for(C = Ca(e[3]), r = 0; r < C.length; r += 1){
                    var i = x4(e, C, r);
                    $[r] ? $[r].p(i, n) : ($[r] = $4(i), $[r].c(), $[r].m(o, f));
                }
                for(; r < $.length; r += 1)$[r].d(1);
                $.length = C.length;
            }
            128 & n && Ni(h, e[7]);
        },
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t), x.d(), S.d(), ki($, e), g = !1, y();
        }
    };
}
function O4(e, t, n) {
    var r, o, i, a, s, c = t.text, l = t.json, u = t.readOnly, f = t.parser, d = t.openJSONEditorModal, h = t.onChangeMode;
    return e.$$set = function(e) {
        "text" in e && n(9, c = e.text), "json" in e && n(10, l = e.json), "readOnly" in e && n(0, u = e.readOnly), "parser" in e && n(11, f = e.parser), "openJSONEditorModal" in e && n(1, d = e.openJSONEditorModal), "onChangeMode" in e && n(2, h = e.onChangeMode);
    }, e.$$.update = function() {
        1 & e.$$.dirty && n(7, r = u ? "View" : "Edit"), 1024 & e.$$.dirty && n(3, s = l ? (function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2, n = [];
            return function e(r, o) {
                Rs(r) && o.length < t && Object.keys(r).forEach(function(t) {
                    e(r[t], o.concat(t));
                }), Ts(r) && n.push(o);
            }(e, []), n;
        })(l).slice(0, 99).filter(function(e) {
            return e.length > 0;
        }) : []), 8 & e.$$.dirty && n(5, o = !_x(s)), 1536 & e.$$.dirty && n(4, i = void 0 === l && ("" === c || void 0 === c)), 3120 & e.$$.dirty && n(6, a = o ? "Object with nested arrays" : i ? "An empty document" : Rs(l) ? "An object" : Ts(l) ? "An empty array" : "A ".concat(eu(l, f)));
    }, [
        u,
        d,
        h,
        s,
        i,
        o,
        a,
        r,
        function(e) {
            return Ws(l, e).length;
        },
        c,
        l,
        f,
        function(e) {
            return d(e);
        },
        function() {
            return h(Qa.tree);
        }
    ];
}
var M4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, O4, _4, Zo, {
            text: 9,
            json: 10,
            readOnly: 0,
            parser: 11,
            openJSONEditorModal: 1,
            onChangeMode: 2
        }, w4), n;
    }
    return Ao(t, Ia), Do(t);
}();
function E4(e) {
    mi(e, "svelte-1nml1r3", ".jse-column-header.svelte-1nml1r3{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-1nml1r3:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-1nml1r3:not(.jse-column-header.jse-readonly){cursor:pointer}");
}
function A4(e) {
    var t, n, r, o, i, a;
    return n = new jM({
        props: {
            data: EP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), Ai(t, "type", "button"), Ai(t, "class", "jse-column-header svelte-1nml1r3"), Ai(t, "title", r = "The Columns are created by sampling ".concat(e[1], " items out of ").concat(e[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.");
        },
        m: function(r, s) {
            wi(r, t, s), Ta(n, t, null), o = !0, i || (a = Oi(t, "click", e[3]), i = !0);
        },
        p: function(e, n) {
            var i = jo(n, 1)[0];
            (!o || 3 & i && r !== (r = "The Columns are created by sampling ".concat(e[1], " items out of ").concat(e[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.")) && Ai(t, "title", r);
        },
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, a();
        }
    };
}
function P4(e, t, n) {
    var r = t.count, o = t.maxSampleCount, i = t.onRefresh;
    return e.$$set = function(e) {
        "count" in e && n(0, r = e.count), "maxSampleCount" in e && n(1, o = e.maxSampleCount), "onRefresh" in e && n(2, i = e.onRefresh);
    }, [
        r,
        o,
        i,
        function() {
            return i();
        }
    ];
}
var T4 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, P4, A4, Zo, {
            count: 0,
            maxSampleCount: 1,
            onRefresh: 2
        }, E4), n;
    }
    return Ao(t, Ia), Do(t);
}();
function R4(e) {
    mi(e, "svelte-1jkzr9g", '.jse-table-mode.svelte-1jkzr9g.svelte-1jkzr9g{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.no-main-menu.svelte-1jkzr9g.svelte-1jkzr9g{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1jkzr9g .jse-hidden-input-label.svelte-1jkzr9g{position:fixed;right:0;top:0;width:0;height:0}.jse-table-mode.svelte-1jkzr9g .jse-hidden-input-label .jse-hidden-input.svelte-1jkzr9g{width:0;height:0;padding:0;border:0;outline:none}.jse-table-mode.svelte-1jkzr9g .jse-contents.svelte-1jkzr9g{flex:1;align-items:flex-start;flex-direction:column;display:flex;overflow:auto;overflow-anchor:none;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1jkzr9g .jse-contents.svelte-1jkzr9g:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main.svelte-1jkzr9g{border-collapse:collapse;border-spacing:0}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-invisible-start-section td.svelte-1jkzr9g,.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-1jkzr9g{margin:0;padding:0}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-1jkzr9g{padding-bottom:var(--jse-padding, 10px)}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row.svelte-1jkzr9g:hover{background-color:var(--jse-table-row-odd-background, rgba(0, 0, 0, 0.05))}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1jkzr9g{padding:0 var(--jse-padding, 10px) 0 0;vertical-align:top;white-space:nowrap;height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-1jkzr9g,.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-1jkzr9g{font-weight:normal;text-align:left;color:var(--jse-text-readonly, #8d8d8d);background:var(--jse-table-header-background, #f5f5f5)}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-1jkzr9g{padding:0;position:sticky;top:0}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header .jse-table-root-error.svelte-1jkzr9g{padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-1jkzr9g{padding:0 var(--jse-padding, 10px) 0 calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-selected-value.svelte-1jkzr9g>.jse-value{background:var(--jse-selection-background-color, #d3d3d3)}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1jkzr9g div{display:inline-flex}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1jkzr9g div.jse-value{overflow-wrap:normal;white-space:nowrap;vertical-align:top;display:inline-block}.jse-table-mode.svelte-1jkzr9g .jse-contents table.jse-table-main .jse-table-row .jse-table-cell .jse-context-menu-anchor.svelte-1jkzr9g{position:relative;vertical-align:top}.jse-table-mode.svelte-1jkzr9g .jse-contents.jse-contents-loading.svelte-1jkzr9g{align-items:unset}.jse-table-mode.svelte-1jkzr9g .jse-contents.jse-contents-loading .jse-loading-space.svelte-1jkzr9g{flex:1}.jse-table-mode.svelte-1jkzr9g .jse-contents.jse-contents-loading .jse-loading.svelte-1jkzr9g{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function N4(e, t, n) {
    var r, o = e.slice();
    o[123] = t[n], o[128] = n;
    var i = o[23].startIndex + o[128];
    o[124] = i;
    var a = o[22].rows[o[124]];
    o[125] = a;
    var s = BB([
        String(o[124])
    ], null === (r = o[125]) || void 0 === r ? void 0 : r.row);
    return o[126] = s, o;
}
function I4(e, t, n) {
    var r, o = e.slice();
    o[129] = t[n], o[135] = n;
    var i = [
        String(o[124])
    ].concat(o[129]);
    o[130] = i;
    var a = Ws(o[123], o[129]);
    o[131] = a;
    var s = pE(o[11].selection) && AE(o[11].selection.path, o[130]);
    o[132] = s;
    var c = null === (r = o[125]) || void 0 === r ? void 0 : r.columns[o[135]];
    o[133] = c;
    var l = BB(o[130], o[133]);
    return o[126] = l, o;
}
function D4(e, t, n) {
    var r = e.slice();
    return r[129] = t[n], r;
}
function z4(e) {
    var t, n = e.slice(), r = BB([], null === (t = n[22]) || void 0 === t ? void 0 : t.root);
    return n[126] = r, n;
}
function q4(e) {
    var t, n;
    return t = new G3({
        props: {
            json: e[8],
            readOnly: e[0],
            historyState: e[20],
            onSort: e[41],
            onTransform: e[42],
            onUndo: e[43],
            onRedo: e[44],
            onContextMenu: e[33],
            onRenderMenu: e[5]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            256 & n[0] && (r.json = e[8]), 1 & n[0] && (r.readOnly = e[0]), 1048576 & n[0] && (r.historyState = e[20]), 32 & n[0] && (r.onRenderMenu = e[5]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function B4(e) {
    var t;
    return {
        c: function() {
            (t = ji("div")).innerHTML = '<div class="jse-loading-space svelte-1jkzr9g"></div> <div class="jse-loading svelte-1jkzr9g">loading...</div>', Ai(t, "class", "jse-contents jse-contents-loading svelte-1jkzr9g");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        p: Wo,
        i: Wo,
        o: Wo,
        d: function(e) {
            e && xi(t);
        }
    };
}
function L4(e) {
    var t, n, r, o, i, a, s, c, l, u = [
        H4,
        V4,
        F4
    ], f = [];
    function d(e, t) {
        return e[25] ? 0 : e[17] && void 0 !== e[16] && "" !== e[16] ? 1 : 2;
    }
    return o = d(e), i = f[o] = u[o](e), {
        c: function() {
            t = ji("label"), n = ji("input"), r = $i(), i.c(), a = _i(), Ai(n, "type", "text"), n.readOnly = !0, Ai(n, "tabindex", "-1"), Ai(n, "class", "jse-hidden-input svelte-1jkzr9g"), Ai(t, "class", "jse-hidden-input-label svelte-1jkzr9g");
        },
        m: function(i, u) {
            wi(i, t, u), pi(t, n), e[73](n), wi(i, r, u), f[o].m(i, u), wi(i, a, u), s = !0, c || (l = Oi(n, "paste", e[38]), c = !0);
        },
        p: function(e, t) {
            var n = o;
            (o = d(e)) === n ? f[o].p(e, t) : (ba(), ka(f[n], 1, 1, function() {
                f[n] = null;
            }), wa(), (i = f[o]) ? i.p(e, t) : (i = f[o] = u[o](e)).c(), xa(i, 1), i.m(a.parentNode, a));
        },
        i: function(e) {
            s || (xa(i), s = !0);
        },
        o: function(e) {
            ka(i), s = !1;
        },
        d: function(n) {
            n && (xi(t), xi(r), xi(a)), e[73](null), f[o].d(n), c = !1, l();
        }
    };
}
function F4(e) {
    var t, n;
    return t = new M4({
        props: {
            text: e[16],
            json: e[8],
            readOnly: e[0],
            parser: e[2],
            openJSONEditorModal: e[40],
            onChangeMode: e[4]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            65536 & n[0] && (r.text = e[16]), 256 & n[0] && (r.json = e[8]), 1 & n[0] && (r.readOnly = e[0]), 4 & n[0] && (r.parser = e[2]), 16 & n[0] && (r.onChangeMode = e[4]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function V4(e) {
    var t, n, r, o;
    return t = new IN({
        props: {
            type: "error",
            message: "The loaded JSON document is invalid and could not be repaired automatically.",
            actions: e[0] ? [] : [
                {
                    icon: lP,
                    text: "Repair manually",
                    title: 'Open the document in "code" mode and repair it manually',
                    onClick: e[36]
                }
            ]
        }
    }), r = new uL({
        props: {
            text: e[16],
            json: e[8],
            indentation: e[3],
            parser: e[2]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment), n = $i(), Pa(r.$$.fragment);
        },
        m: function(e, i) {
            Ta(t, e, i), wi(e, n, i), Ta(r, e, i), o = !0;
        },
        p: function(e, n) {
            var o = {};
            1 & n[0] && (o.actions = e[0] ? [] : [
                {
                    icon: lP,
                    text: "Repair manually",
                    title: 'Open the document in "code" mode and repair it manually',
                    onClick: e[36]
                }
            ]), t.$set(o);
            var i = {};
            65536 & n[0] && (i.text = e[16]), 256 & n[0] && (i.json = e[8]), 8 & n[0] && (i.indentation = e[3]), 4 & n[0] && (i.parser = e[2]), r.$set(i);
        },
        i: function(e) {
            o || (xa(t.$$.fragment, e), xa(r.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), ka(r.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(n), Ra(t, e), Ra(r, e);
        }
    };
}
function H4(e) {
    for(var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b, w, x, k, j, S, C = !_x(null === (t = e[22]) || void 0 === t ? void 0 : t.root), $ = C && W4(z4(e)), _ = Ca(e[10]), O = [], M = 0; M < _.length; M += 1)O[M] = J4(D4(e, _, M));
    for(var E = function(e) {
        return ka(O[e], 1, 1, function() {
            O[e] = null;
        });
    }, A = e[24] && K4(e), P = Ca(e[23].visibleItems), T = [], R = 0; R < P.length; R += 1)T[R] = r6(N4(e, P, R));
    var N = function(e) {
        return ka(T[e], 1, 1, function() {
            T[e] = null;
        });
    }, I = e[18] && o6(e), D = e[19] && i6(e);
    return x = new JN({
        props: {
            validationErrors: e[12],
            selectError: e[39]
        }
    }), {
        c: function() {
            n = ji("div"), r = ji("table"), o = ji("tbody"), i = ji("tr"), a = ji("th"), $ && $.c(), s = $i();
            for(var t = 0; t < O.length; t += 1)O[t].c();
            c = $i(), A && A.c(), l = $i(), u = ji("tr"), f = ji("td"), h = $i();
            for(var k = 0; k < T.length; k += 1)T[k].c();
            v = $i(), p = ji("tr"), m = ji("td"), y = $i(), I && I.c(), b = $i(), D && D.c(), w = $i(), Pa(x.$$.fragment), Ai(a, "class", "jse-table-cell jse-table-cell-header svelte-1jkzr9g"), Ai(i, "class", "jse-table-row jse-table-row-header svelte-1jkzr9g"), Ai(f, "colspan", d = e[10].length), Ai(f, "class", "svelte-1jkzr9g"), Di(f, "height", e[23].startHeight + "px"), Ai(u, "class", "jse-table-invisible-start-section"), Ai(m, "colspan", g = e[10].length), Ai(m, "class", "svelte-1jkzr9g"), Di(m, "height", e[23].endHeight + "px"), Ai(p, "class", "jse-table-invisible-end-section"), Ai(r, "class", "jse-table-main svelte-1jkzr9g"), Ai(n, "class", "jse-contents svelte-1jkzr9g");
        },
        m: function(t, d) {
            wi(t, n, d), pi(n, r), pi(r, o), pi(o, i), pi(i, a), $ && $.m(a, null), pi(i, s);
            for(var g = 0; g < O.length; g += 1)O[g] && O[g].m(i, null);
            pi(i, c), A && A.m(i, null), pi(o, l), pi(o, u), pi(u, f), pi(o, h);
            for(var C = 0; C < T.length; C += 1)T[C] && T[C].m(o, null);
            pi(o, v), pi(o, p), pi(p, m), e[76](n), wi(t, y, d), I && I.m(t, d), wi(t, b, d), D && D.m(t, d), wi(t, w, d), Ta(x, t, d), k = !0, j || (S = [
                ci(m4.call(null, n, e[45])),
                Oi(n, "scroll", e[29])
            ], j = !0);
        },
        p: function(e, t) {
            var n;
            if (4194304 & t[0] && (C = !_x(null === (n = e[22]) || void 0 === n ? void 0 : n.root)), C ? $ ? ($.p(z4(e), t), 4194304 & t[0] && xa($, 1)) : (($ = W4(z4(e))).c(), xa($, 1), $.m(a, null)) : $ && (ba(), ka($, 1, 1, function() {
                $ = null;
            }), wa()), 268438529 & t[0]) {
                var r;
                for(_ = Ca(e[10]), r = 0; r < _.length; r += 1){
                    var s = D4(e, _, r);
                    O[r] ? (O[r].p(s, t), xa(O[r], 1)) : (O[r] = J4(s), O[r].c(), xa(O[r], 1), O[r].m(i, c));
                }
                for(ba(), r = _.length; r < O.length; r += 1)E(r);
                wa();
            }
            if (e[24] ? A ? (A.p(e, t), 16777216 & t[0] && xa(A, 1)) : ((A = K4(e)).c(), xa(A, 1), A.m(i, null)) : A && (ba(), ka(A, 1, 1, function() {
                A = null;
            }), wa()), (!k || 1024 & t[0] && d !== (d = e[10].length)) && Ai(f, "colspan", d), 8388608 & t[0] && Di(f, "height", e[23].startHeight + "px"), 165678085 & t[0] | 33281 & t[1]) {
                var l;
                for(P = Ca(e[23].visibleItems), l = 0; l < P.length; l += 1){
                    var u = N4(e, P, l);
                    T[l] ? (T[l].p(u, t), xa(T[l], 1)) : (T[l] = r6(u), T[l].c(), xa(T[l], 1), T[l].m(o, v));
                }
                for(ba(), l = P.length; l < T.length; l += 1)N(l);
                wa();
            }
            (!k || 1024 & t[0] && g !== (g = e[10].length)) && Ai(m, "colspan", g), 8388608 & t[0] && Di(m, "height", e[23].endHeight + "px"), e[18] ? I ? (I.p(e, t), 262144 & t[0] && xa(I, 1)) : ((I = o6(e)).c(), xa(I, 1), I.m(b.parentNode, b)) : I && (ba(), ka(I, 1, 1, function() {
                I = null;
            }), wa()), e[19] ? D ? (D.p(e, t), 524288 & t[0] && xa(D, 1)) : ((D = i6(e)).c(), xa(D, 1), D.m(w.parentNode, w)) : D && (ba(), ka(D, 1, 1, function() {
                D = null;
            }), wa());
            var h = {};
            4096 & t[0] && (h.validationErrors = e[12]), x.$set(h);
        },
        i: function(e) {
            if (!k) {
                xa($);
                for(var t = 0; t < _.length; t += 1)xa(O[t]);
                xa(A);
                for(var n = 0; n < P.length; n += 1)xa(T[n]);
                xa(I), xa(D), xa(x.$$.fragment, e), k = !0;
            }
        },
        o: function(e) {
            ka($), O = O.filter(Boolean);
            for(var t = 0; t < O.length; t += 1)ka(O[t]);
            ka(A), T = T.filter(Boolean);
            for(var n = 0; n < T.length; n += 1)ka(T[n]);
            ka(I), ka(D), ka(x.$$.fragment, e), k = !1;
        },
        d: function(t) {
            t && (xi(n), xi(y), xi(b), xi(w)), $ && $.d(), ki(O, t), A && A.d(), ki(T, t), e[76](null), I && I.d(t), D && D.d(t), Ra(x, t), j = !1, Qo(S);
        }
    };
}
function W4(e) {
    var t, n, r = e[126] && U4(e);
    return {
        c: function() {
            r && r.c(), t = _i();
        },
        m: function(e, o) {
            r && r.m(e, o), wi(e, t, o), n = !0;
        },
        p: function(e, n) {
            e[126] ? r ? (r.p(e, n), 4194304 & n[0] && xa(r, 1)) : ((r = U4(e)).c(), xa(r, 1), r.m(t.parentNode, t)) : r && (ba(), ka(r, 1, 1, function() {
                r = null;
            }), wa());
        },
        i: function(e) {
            n || (xa(r), n = !0);
        },
        o: function(e) {
            ka(r), n = !1;
        },
        d: function(e) {
            e && xi(t), r && r.d(e);
        }
    };
}
function U4(e) {
    var t, n, r;
    return n = new $z({
        props: {
            validationError: e[126],
            onExpand: JL
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), Ai(t, "class", "jse-table-root-error svelte-1jkzr9g");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            4194304 & t[0] && (r.validationError = e[126]), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function J4(e) {
    var t, n, r;
    return n = new p4({
        props: {
            path: e[129],
            sortedColumn: e[11].sortedColumn,
            readOnly: e[0],
            onSort: e[28]
        }
    }), {
        c: function() {
            t = ji("th"), Pa(n.$$.fragment), Ai(t, "class", "jse-table-cell jse-table-cell-header svelte-1jkzr9g");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            1024 & t[0] && (r.path = e[129]), 2048 & t[0] && (r.sortedColumn = e[11].sortedColumn), 1 & t[0] && (r.readOnly = e[0]), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function K4(e) {
    var t, n, r;
    return n = new T4({
        props: {
            count: Array.isArray(e[8]) ? e[8].length : 0,
            maxSampleCount: e[9],
            onRefresh: e[74]
        }
    }), {
        c: function() {
            t = ji("th"), Pa(n.$$.fragment), Ai(t, "class", "jse-table-cell jse-table-cell-header svelte-1jkzr9g");
        },
        m: function(e, o) {
            wi(e, t, o), Ta(n, t, null), r = !0;
        },
        p: function(e, t) {
            var r = {};
            256 & t[0] && (r.count = Array.isArray(e[8]) ? e[8].length : 0), 512 & t[0] && (r.maxSampleCount = e[9]), 512 & t[0] && (r.onRefresh = e[74]), n.$set(r);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n);
        }
    };
}
function G4(e) {
    var t, n;
    return t = new $z({
        props: {
            validationError: e[126],
            onExpand: JL
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            12582912 & n[0] && (r.validationError = e[126]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Q4(e) {
    var t, n, r, o, i, a, s, c = e[124] + "", l = e[126] && G4(e);
    function u() {
        for(var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
        return (t = e)[75].apply(t, [
            e[124]
        ].concat(r));
    }
    return {
        c: function() {
            t = ji("th"), n = Ci(c), r = $i(), l && l.c(), Ai(t, "class", "jse-table-cell jse-table-cell-gutter svelte-1jkzr9g");
        },
        m: function(e, c) {
            wi(e, t, c), pi(t, n), pi(t, r), l && l.m(t, null), i = !0, a || (s = ci(o = m4.call(null, t, u)), a = !0);
        },
        p: function(r, a) {
            e = r, (!i || 8388608 & a[0]) && c !== (c = e[124] + "") && Ni(n, c), e[126] ? l ? (l.p(e, a), 12582912 & a[0] && xa(l, 1)) : ((l = G4(e)).c(), xa(l, 1), l.m(t, null)) : l && (ba(), ka(l, 1, 1, function() {
                l = null;
            }), wa()), o && Yo(o.update) && 8388608 & a[0] && o.update.call(null, u);
        },
        i: function(e) {
            i || (xa(l), i = !0);
        },
        o: function(e) {
            ka(l), i = !1;
        },
        d: function(e) {
            e && xi(t), l && l.d(), a = !1, s();
        }
    };
}
function Y4(e) {
    var t, n;
    return t = new o4({
        props: {
            path: e[130],
            value: void 0 !== e[131] ? e[131] : "",
            enforceString: oE(e[131], e[11].enforceStringMap, Zs(e[130]), e[21].parser),
            selection: e[132] ? e[11].selection : null,
            searchResultItems: e[27],
            context: e[21]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            8389632 & n[0] && (r.path = e[130]), 8389632 & n[0] && (r.value = void 0 !== e[131] ? e[131] : ""), 10488832 & n[0] && (r.enforceString = oE(e[131], e[11].enforceStringMap, Zs(e[130]), e[21].parser)), 8391680 & n[0] && (r.selection = e[132] ? e[11].selection : null), 2097152 & n[0] && (r.context = e[21]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function X4(e) {
    var t, n;
    return t = new c4({
        props: {
            path: e[130],
            value: e[131],
            parser: e[2],
            isSelected: e[132],
            onEdit: e[40]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            8389632 & n[0] && (r.path = e[130]), 8389632 & n[0] && (r.value = e[131]), 4 & n[0] && (r.parser = e[2]), 8391680 & n[0] && (r.isSelected = e[132]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function Z4(e) {
    var t, n, r, o;
    return n = new ez({
        props: {
            selected: !0,
            onContextMenu: e[31]
        }
    }), {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), r = $i(), Ai(t, "class", "jse-context-menu-anchor svelte-1jkzr9g");
        },
        m: function(e, i) {
            wi(e, t, i), Ta(n, t, null), wi(e, r, i), o = !0;
        },
        p: Wo,
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && (xi(t), xi(r)), Ra(n);
        }
    };
}
function e6(e) {
    var t, n;
    return t = new $z({
        props: {
            validationError: e[126],
            onExpand: JL
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            12583936 & n[0] && (r.validationError = e[126]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function t6(e) {
    var t, n, r, o, i, a, s, c, l = !e[0] && e[132] && !qE(e[11].selection), u = [
        X4,
        Y4
    ], f = [];
    function d(e, t) {
        return 8389632 & t[0] && (n = null), null == n && (n = !!Ql(e[131])), n ? 0 : 1;
    }
    r = d(e, [
        -1,
        -1,
        -1,
        -1,
        -1
    ]), o = f[r] = u[r](e);
    var h = l && Z4(e), v = e[126] && e6(e);
    return {
        c: function() {
            t = ji("td"), o.c(), i = _i(), h && h.c(), a = _i(), v && v.c(), Ai(t, "class", "jse-table-cell svelte-1jkzr9g"), Ai(t, "data-path", s = OO(e[130])), qi(t, "jse-selected-value", e[132]);
        },
        m: function(e, n) {
            wi(e, t, n), f[r].m(t, null), pi(t, i), h && h.m(t, null), pi(t, a), v && v.m(t, null), c = !0;
        },
        p: function(e, n) {
            var p = r;
            (r = d(e, n)) === p ? f[r].p(e, n) : (ba(), ka(f[p], 1, 1, function() {
                f[p] = null;
            }), wa(), (o = f[r]) ? o.p(e, n) : (o = f[r] = u[r](e)).c(), xa(o, 1), o.m(t, i)), 8391681 & n[0] && (l = !e[0] && e[132] && !qE(e[11].selection)), l ? h ? (h.p(e, n), 8391681 & n[0] && xa(h, 1)) : ((h = Z4(e)).c(), xa(h, 1), h.m(t, a)) : h && (ba(), ka(h, 1, 1, function() {
                h = null;
            }), wa()), e[126] ? v ? (v.p(e, n), 12583936 & n[0] && xa(v, 1)) : ((v = e6(e)).c(), xa(v, 1), v.m(t, null)) : v && (ba(), ka(v, 1, 1, function() {
                v = null;
            }), wa()), (!c || 8389632 & n[0] && s !== (s = OO(e[130]))) && Ai(t, "data-path", s), (!c || 8391680 & n[0]) && qi(t, "jse-selected-value", e[132]);
        },
        i: function(e) {
            c || (xa(o), xa(h), xa(v), c = !0);
        },
        o: function(e) {
            ka(o), ka(h), ka(v), c = !1;
        },
        d: function(e) {
            e && xi(t), f[r].d(), h && h.d(), v && v.d();
        }
    };
}
function n6(e) {
    var t;
    return {
        c: function() {
            Ai(t = ji("td"), "class", "jse-table-cell svelte-1jkzr9g");
        },
        m: function(e, n) {
            wi(e, t, n);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function r6(e) {
    for(var t, n, r, o, i = e[124], a = Q4(e), s = Ca(e[10]), c = [], l = 0; l < s.length; l += 1)c[l] = t6(I4(e, s, l));
    var u = function(e) {
        return ka(c[e], 1, 1, function() {
            c[e] = null;
        });
    }, f = e[24] && n6();
    return {
        c: function() {
            t = ji("tr"), a.c(), n = $i();
            for(var e = 0; e < c.length; e += 1)c[e].c();
            r = $i(), f && f.c(), Ai(t, "class", "jse-table-row svelte-1jkzr9g");
        },
        m: function(e, i) {
            wi(e, t, i), a.m(t, null), pi(t, n);
            for(var s = 0; s < c.length; s += 1)c[s] && c[s].m(t, null);
            pi(t, r), f && f.m(t, null), o = !0;
        },
        p: function(e, o) {
            if (8388608 & o[0] && Zo(i, i = e[124]) ? (ba(), ka(a, 1, 1, Wo), wa(), (a = Q4(e)).c(), xa(a, 1), a.m(t, n)) : a.p(e, o), 148900869 & o[0] | 513 & o[1]) {
                var l;
                for(s = Ca(e[10]), l = 0; l < s.length; l += 1){
                    var d = I4(e, s, l);
                    c[l] ? (c[l].p(d, o), xa(c[l], 1)) : (c[l] = t6(d), c[l].c(), xa(c[l], 1), c[l].m(t, r));
                }
                for(ba(), l = s.length; l < c.length; l += 1)u(l);
                wa();
            }
            e[24] ? f || ((f = n6()).c(), f.m(t, null)) : f && (f.d(1), f = null);
        },
        i: function(e) {
            if (!o) {
                xa(a);
                for(var t = 0; t < s.length; t += 1)xa(c[t]);
                o = !0;
            }
        },
        o: function(e) {
            ka(a), c = c.filter(Boolean);
            for(var t = 0; t < c.length; t += 1)ka(c[t]);
            o = !1;
        },
        d: function(e) {
            e && xi(t), a.d(e), ki(c, e), f && f.d();
        }
    };
}
function o6(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "info",
            message: "You pasted a JSON ".concat(Array.isArray(e[18].contents) ? "array" : "object", " as text"),
            actions: [
                {
                    icon: uP,
                    text: "Paste as JSON instead",
                    title: "Paste the text as JSON instead of a single value",
                    onMouseDown: e[34]
                },
                {
                    text: "Leave as is",
                    title: "Keep the pasted content as a single value",
                    onClick: e[35]
                }
            ]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            262144 & n[0] && (r.message = "You pasted a JSON ".concat(Array.isArray(e[18].contents) ? "array" : "object", " as text")), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function i6(e) {
    var t, n;
    return t = new IN({
        props: {
            type: "success",
            message: "The loaded JSON document was invalid but is successfully repaired.",
            actions: e[0] ? [] : [
                {
                    icon: PP,
                    text: "Ok",
                    title: "Accept the repaired document",
                    onClick: e[7]
                },
                {
                    icon: lP,
                    text: "Repair manually instead",
                    title: "Leave the document unchanged and repair it manually instead",
                    onClick: e[36]
                }
            ],
            onClose: e[6]
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.actions = e[0] ? [] : [
                {
                    icon: PP,
                    text: "Ok",
                    title: "Accept the repaired document",
                    onClick: e[7]
                },
                {
                    icon: lP,
                    text: "Repair manually instead",
                    title: "Leave the document unchanged and repair it manually instead",
                    onClick: e[36]
                }
            ]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function a6(e) {
    var t, n, r, o, i, a, s, c = e[1] && q4(e), l = [
        L4,
        B4
    ], u = [];
    return r = function(e, t) {
        return e[26] ? 1 : 0;
    }(e), o = u[r] = l[r](e), {
        c: function() {
            t = ji("div"), c && c.c(), n = $i(), o.c(), Ai(t, "role", "table"), Ai(t, "class", "jse-table-mode svelte-1jkzr9g"), qi(t, "no-main-menu", !e[1]);
        },
        m: function(o, l) {
            wi(o, t, l), c && c.m(t, null), pi(t, n), u[r].m(t, null), e[77](t), i = !0, a || (s = [
                Oi(t, "mousedown", e[30]),
                Oi(t, "keydown", e[37]),
                Oi(t, "contextmenu", e[32])
            ], a = !0);
        },
        p: function(e, r) {
            e[1] ? c ? (c.p(e, r), 2 & r[0] && xa(c, 1)) : ((c = q4(e)).c(), xa(c, 1), c.m(t, n)) : c && (ba(), ka(c, 1, 1, function() {
                c = null;
            }), wa()), o.p(e, r), (!i || 2 & r[0]) && qi(t, "no-main-menu", !e[1]);
        },
        i: function(e) {
            i || (xa(c), xa(o), i = !0);
        },
        o: function(e) {
            ka(c), ka(o), i = !1;
        },
        d: function(n) {
            n && xi(t), c && c.d(), u[r].d(), e[77](null), a = !1, Qo(s);
        }
    };
}
var s6 = 18;
function c6(e, t, n) {
    var r, o, i, a, s = Da("jsoneditor:TableMode"), c = Zi("simple-modal").open, l = Zi("absolute-popup"), u = l.openAbsolutePopup, f = l.closeAbsolutePopup, d = bN(), h = A$(), v = A$(), p = "undefined" == typeof window;
    s("isSSR:", p);
    var m, g, y, b, w, x, k = t.readOnly, j = t.externalContent, S = t.externalSelection, C = t.mainMenuBar, $ = t.escapeControlCharacters, _ = t.escapeUnicodeCharacters, O = t.flattenColumns, M = t.parser, E = t.parseMemoizeOne, A = t.validator, P = t.validationParser, T = t.indentation, R = t.onChange, N = t.onChangeMode, I = t.onSelect, D = t.onRenderValue, z = t.onRenderMenu, q = t.onRenderContextMenu, B = t.onFocus, L = t.onBlur, F = t.onSortModal, V = t.onTransformModal, H = t.onJSONEditorModal;
    ON({
        onMount: Gi,
        onDestroy: Qi,
        getWindow: function() {
            return SO(g);
        },
        hasFocus: function() {
            return G && document.hasFocus() || CO(g);
        },
        onFocus: function() {
            B && B();
        },
        onBlur: function() {
            L && L();
        }
    });
    var W, U = void 0, J = 1e4, K = [], G = !1, Q = {}, Y = 600, X = 0;
    function Z(e) {
        s("updateSelection", e);
        var t = "function" == typeof e ? e(te.selection) || null : e;
        Ox(t, te.selection) || (n(11, te = Ro(Ro({}, te), {}, {
            selection: t
        })), I(t));
    }
    function ee(e) {
        te.selection && void 0 !== e && (Ys(e, KE(te.selection)) && Ys(e, JE(te.selection)) || (s("clearing selection: path does not exist anymore", te.selection), n(11, te = Ro(Ro({}, te), {}, {
            selection: null
        }))));
    }
    var te = BM(), ne = !1;
    var re, oe = kN({
        onChange: function(e) {
            n(20, ie = e);
        }
    }), ie = oe.getState();
    function ae(e) {
        var t = w, r = J_(e) ? e.text !== x : !Ox(t, e.json);
        if (s("update external content", {
            isChanged: r
        }), r) {
            var o = {
                json: w,
                text: x
            }, i = w, a = te, c = x, l = ne;
            if (J_(e)) try {
                n(8, w = E(e.text)), n(16, x = e.text), n(19, ne = !1), n(17, U = void 0);
            } catch (t) {
                try {
                    n(8, w = E(Hl(e.text))), n(16, x = e.text), n(19, ne = !0), n(17, U = void 0);
                } catch (r) {
                    n(8, w = void 0), n(16, x = e.text), n(19, ne = !1), n(17, U = "" !== x ? H_(x, t.message || String(t)) : void 0);
                }
            }
            else n(8, w = e.json), n(16, x = void 0), n(19, ne = !1), n(17, U = void 0);
            ee(w), te.sortedColumn && n(11, te = Ro(Ro({}, te), {}, {
                sortedColumn: null
            })), se({
                previousJson: i,
                previousState: a,
                previousText: c,
                previousTextIsRepaired: l
            });
            ve(o, null);
        }
    }
    function se(e) {
        var t = e.previousJson, n = e.previousState, r = e.previousText, o = e.previousTextIsRepaired;
        void 0 === t && void 0 === r || (void 0 !== w ? void 0 !== t ? oe.add({
            undo: {
                patch: [
                    {
                        op: "replace",
                        path: "",
                        value: t
                    }
                ],
                state: PE(n),
                json: void 0,
                text: r,
                textIsRepaired: o
            },
            redo: {
                patch: [
                    {
                        op: "replace",
                        path: "",
                        value: w
                    }
                ],
                state: PE(te),
                json: void 0,
                text: x,
                textIsRepaired: ne
            }
        }) : oe.add({
            undo: {
                patch: void 0,
                json: void 0,
                text: r,
                state: PE(n),
                textIsRepaired: o
            },
            redo: {
                patch: void 0,
                json: w,
                state: PE(te),
                text: x,
                textIsRepaired: ne
            }
        }) : void 0 !== t && oe.add({
            undo: {
                patch: void 0,
                json: t,
                state: PE(n),
                text: r,
                textIsRepaired: o
            },
            redo: {
                patch: void 0,
                json: void 0,
                text: x,
                textIsRepaired: ne,
                state: PE(te)
            }
        }));
    }
    var ce = [], le = EB(CN);
    function ue(e, t, r, o) {
        jN(function() {
            var i;
            try {
                i = le(e, t, r, o);
            } catch (e) {
                i = [
                    {
                        path: [],
                        message: "Failed to validate: " + e.message,
                        severity: Za.warning
                    }
                ];
            }
            Ox(i, ce) || (s("validationErrors changed:", i), n(12, ce = i));
        }, function(e) {
            return s("validationErrors updated in ".concat(e, " ms"));
        });
    }
    function fe() {
        return s("validate"), U ? {
            parseError: U,
            isRepairable: !1
        } : (ue(w, A, M, P), _x(ce) ? null : {
            validationErrors: ce
        });
    }
    function de(e, t) {
        if (s("patch", e, t), void 0 === w) throw new Error("Cannot apply patch: no JSON");
        var r = {
            json: w
        }, o = w, i = te, a = ne, c = hA(w, e), l = JM(w, te, e).json, u = FB(te, e, K), f = "function" == typeof t ? t(l, u) : void 0;
        n(8, w = f && void 0 !== f.json ? f.json : l);
        var d = f && void 0 !== f.state ? f.state : u;
        n(11, te = d), n(16, x = void 0), n(19, ne = !1), n(18, W = void 0), n(17, U = void 0), oe.add({
            undo: {
                patch: c,
                json: void 0,
                text: void 0,
                state: PE(i),
                textIsRepaired: a
            },
            redo: {
                patch: e,
                json: void 0,
                state: PE(d),
                text: void 0,
                textIsRepaired: ne
            }
        });
        var h = {
            json: w,
            previousJson: o,
            undo: c,
            redo: e
        };
        return ve(r, h), h;
    }
    function he(e, t) {
        return k ? {
            json: w,
            previousJson: w,
            redo: [],
            undo: []
        } : de(e, t);
    }
    function ve(e, t) {
        if ((void 0 !== e.json || void 0 !== (null == e ? void 0 : e.text)) && R) {
            if (void 0 !== x) R({
                text: x,
                json: void 0
            }, e, {
                contentErrors: fe(),
                patchResult: t
            });
            else if (void 0 !== w) R({
                text: void 0,
                json: w
            }, e, {
                contentErrors: fe(),
                patchResult: t
            });
        }
    }
    function pe(e) {
        s("handleFind", e);
    }
    function me(e) {
        s("pasted json as text", e), n(18, W = e);
    }
    function ge(e) {
        var t = parseInt(e[0], 10), n = [
            String(t + 1)
        ].concat(Bo(e.slice(1)));
        return Ys(w, n) ? RE(n, !1) : RE(e, !1);
    }
    function ye() {
        s("focus"), b && (b.focus(), b.select());
    }
    function be() {
        te.selection || Z(!Ts(w) || _x(w) || _x(K) ? null : RE([
            "0"
        ].concat(Bo(K[0])), !1));
    }
    function we(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = IB(e, K, Q, s6), r = n - X, o = je(e);
        if (s("scrollTo", {
            path: e,
            top: n,
            scrollTop: X,
            elem: o
        }), !y) return Promise.resolve();
        var i = y.getBoundingClientRect();
        if (o && !t) {
            var a = o.getBoundingClientRect();
            if (a.bottom > i.top && a.top < i.bottom) return Promise.resolve();
        }
        var c = -i.height / 4;
        return new Promise(o ? function(t) {
            d(o, {
                container: y,
                offset: c,
                duration: 300,
                callback: function() {
                    xe(e), t();
                }
            });
        } : function(o) {
            var i;
            d(r, {
                container: y,
                offset: c,
                duration: 300,
                callback: (i = ko(wo().mark(function r() {
                    return wo().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                return r.next = 2, ca();
                            case 2:
                                if (IB(e, K, Q, s6) === n) {
                                    r.next = 8;
                                    break;
                                }
                                return r.next = 6, we(e, t);
                            case 6:
                                r.next = 9;
                                break;
                            case 8:
                                xe(e);
                            case 9:
                                o();
                            case 10:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                })), function() {
                    return i.apply(this, arguments);
                })
            });
        });
    }
    function xe(e) {
        var t = je(e);
        if (t && y) {
            var r = y.getBoundingClientRect(), o = t.getBoundingClientRect();
            if (o.right > r.right) {
                var i = o.right - r.right;
                n(14, y.scrollLeft += i, y);
            }
            if (o.left < r.left) {
                var a = r.left - o.left;
                n(14, y.scrollLeft -= a, y);
            }
        }
    }
    function ke(e) {
        !function(e) {
            if (y) {
                var t = DB(e, K).rowIndex, r = IB(e, K, Q, s6), o = r + (Q[t] || s6), i = y.getBoundingClientRect(), a = X, s = X + i.height - 18;
                if (o > s) {
                    var c = o - s;
                    n(14, y.scrollTop += c, y);
                }
                if (r < a) {
                    var l = a - r;
                    n(14, y.scrollTop -= l, y);
                }
            }
        }(e), xe(e);
    }
    function je(e) {
        return y ? y.querySelector('td[data-path="'.concat(OO(e), '"]')) : null;
    }
    function Se(e) {
        var t = e.anchor, n = e.left, r = e.top, o = e.width, i = e.height, a = e.offsetTop, s = e.offsetLeft, c = e.showTip;
        G = !0;
        var l = u(b4, {
            json: w,
            documentState: te,
            parser: M,
            showTip: c,
            onEditValue: $e,
            onEditRow: _e,
            onToggleEnforceString: Oe,
            onCut: Ae,
            onCopy: Te,
            onPaste: Ee,
            onRemove: Ne,
            onDuplicateRow: Ie,
            onInsertBeforeRow: De,
            onInsertAfterRow: ze,
            onRemoveRow: qe,
            onRenderContextMenu: q,
            onCloseContextMenu: function() {
                f(l), ye();
            }
        }, {
            left: n,
            top: r,
            offsetTop: a,
            offsetLeft: s,
            width: o,
            height: i,
            anchor: t,
            closeOnOuterClick: !0,
            onClose: function() {
                G = !1, ye();
            }
        });
    }
    function Ce(e) {
        if (!k && !qE(te.selection)) {
            if (e && (e.stopPropagation(), e.preventDefault()), e && "contextmenu" === e.type && e.target !== b) Se({
                left: e.clientX,
                top: e.clientY,
                width: Ms,
                height: Os,
                showTip: !1
            });
            else {
                var t, n = null === (t = y) || void 0 === t ? void 0 : t.querySelector(".jse-table-cell.jse-selected-value");
                if (n) Se({
                    anchor: n,
                    offsetTop: 2,
                    width: Ms,
                    height: Os,
                    showTip: !1
                });
                else {
                    var r, o = null === (r = y) || void 0 === r ? void 0 : r.getBoundingClientRect();
                    o && Se({
                        top: o.top + 2,
                        left: o.left + 2,
                        width: Ms,
                        height: Os,
                        showTip: !1
                    });
                }
            }
            return !1;
        }
    }
    function $e() {
        if (!k && te.selection) {
            var e = JE(te.selection);
            Ql(Ws(w, e)) ? He(e) : Z(RE(e, !0));
        }
    }
    function _e() {
        !k && te.selection && He(JE(te.selection).slice(0, 1));
    }
    function Oe() {
        if (!k && pE(te.selection)) {
            var e = te.selection.path, t = Zs(e), n = Ws(w, e), r = !oE(n, te.enforceStringMap, t, M), o = r ? String(n) : ru(String(n), M);
            s("handleToggleEnforceString", {
                enforceString: r,
                value: n,
                updatedValue: o
            }), he([
                {
                    op: "replace",
                    path: t,
                    value: o
                }
            ], function(e, n) {
                return {
                    state: UM(n, t, r)
                };
            });
        }
    }
    function Me() {
        return (Me = ko(wo().mark(function e() {
            var t, n, r, o, i;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (s("apply pasted json", W), W) {
                            e.next = 3;
                            break;
                        }
                        return e.abrupt("return");
                    case 3:
                        r = (n = W).path, o = n.contents, AO(i = (null === (t = y) || void 0 === t ? void 0 : t.querySelector(".jse-editable-div")) || null) && i.cancel(), he([
                            {
                                op: "replace",
                                path: Zs(r),
                                value: o
                            }
                        ]), setTimeout(ye);
                    case 9:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Ee() {
        c(nI, {}, Ro(Ro({}, gs), {}, {
            styleWindow: {
                width: "450px"
            }
        }), {
            onClose: function() {
                return ye();
            }
        });
    }
    function Ae(e) {
        return Pe.apply(this, arguments);
    }
    function Pe() {
        return (Pe = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, HB({
                            json: w,
                            documentState: te,
                            indentation: t ? T : void 0,
                            readOnly: k,
                            parser: M,
                            onPatch: he
                        });
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Te() {
        return Re.apply(this, arguments);
    }
    function Re() {
        return Re = ko(wo().mark(function e() {
            var t, n = arguments;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (t = !(n.length > 0 && void 0 !== n[0]) || n[0], void 0 !== w) {
                            e.next = 3;
                            break;
                        }
                        return e.abrupt("return");
                    case 3:
                        return e.next = 5, UB({
                            json: w,
                            documentState: te,
                            indentation: t ? T : void 0,
                            parser: M
                        });
                    case 5:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), Re.apply(this, arguments);
    }
    function Ne() {
        GB({
            json: w,
            text: x,
            documentState: te,
            keepSelection: !0,
            readOnly: k,
            onChange: R,
            onPatch: he
        });
    }
    function Ie() {
        QB({
            json: w,
            documentState: te,
            columns: K,
            readOnly: k,
            onPatch: he
        });
    }
    function De() {
        YB({
            json: w,
            documentState: te,
            columns: K,
            readOnly: k,
            onPatch: he
        });
    }
    function ze() {
        XB({
            json: w,
            documentState: te,
            columns: K,
            readOnly: k,
            onPatch: he
        });
    }
    function qe() {
        ZB({
            json: w,
            documentState: te,
            columns: K,
            readOnly: k,
            onPatch: he
        });
    }
    function Be() {
        return (Be = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, tL({
                            char: t,
                            selectInside: !1,
                            refJsonEditor: g,
                            json: w,
                            selection: te.selection,
                            readOnly: k,
                            parser: M,
                            onPatch: he,
                            onReplaceJson: Le,
                            onSelect: Z
                        });
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Le(e, t) {
        var r = te, o = w, i = x, a = {
            json: w,
            text: x
        }, s = ne, c = HM(w, te, [], uE), l = "function" == typeof t ? t(e, c) : void 0;
        n(8, w = l && void 0 !== l.json ? l.json : e), n(11, te = l && void 0 !== l.state ? l.state : c), n(16, x = void 0), n(19, ne = !1), n(17, U = void 0), ee(w), se({
            previousJson: o,
            previousState: r,
            previousText: i,
            previousTextIsRepaired: s
        });
        ve(a, null);
    }
    function Fe(e, t) {
        s("handleChangeText");
        var r = te, o = w, i = x, a = {
            json: w,
            text: x
        }, c = ne;
        try {
            n(8, w = E(e)), n(11, te = HM(w, te, [], uE)), n(16, x = void 0), n(19, ne = !1), n(17, U = void 0);
        } catch (t) {
            try {
                n(8, w = E(Hl(e))), n(11, te = HM(w, te, [], uE)), n(16, x = e), n(19, ne = !0), n(17, U = void 0);
            } catch (r) {
                n(8, w = void 0), n(11, te = BM({
                    json: w,
                    expand: uE
                })), n(16, x = e), n(19, ne = !1), n(17, U = "" !== x ? H_(x, t.message || String(t)) : void 0);
            }
        }
        if ("function" == typeof t) {
            var l = t(w, te);
            n(8, w = l && l.json ? l.json : w), n(11, te = l && l.state ? l.state : te);
        }
        ee(w), se({
            previousJson: o,
            previousState: r,
            previousText: i,
            previousTextIsRepaired: c
        });
        ve(a, null);
    }
    function Ve(e) {
        if (void 0 !== w) {
            var t = e.id, n = e.onTransform, r = e.onClose, o = e.rootPath || [];
            G = !0, V({
                id: t || v,
                json: w,
                rootPath: o || [],
                onTransform: function(e) {
                    n ? n({
                        operations: e,
                        json: w,
                        transformedJson: rc(w, e)
                    }) : (s("onTransform", o, e), he(e));
                },
                onClose: function() {
                    G = !1, ye(), r && r();
                }
            });
        }
    }
    function He(e) {
        s("openJSONEditorModal", {
            path: e
        }), G = !0, H({
            content: {
                json: Ws(w, e)
            },
            path: e,
            onPatch: re.onPatch,
            onClose: function() {
                G = !1, ye();
            }
        });
    }
    function We(e, t) {
        c(UI, {
            text: e,
            onParse: function(e) {
                return L_(e, function(e) {
                    return q_(e, M);
                });
            },
            onRepair: F_,
            onApply: t
        }, Ro(Ro({}, gs), {}, {
            styleWindow: {
                width: "600px",
                height: "500px"
            },
            styleContent: {
                padding: 0,
                height: "100%"
            }
        }), {
            onClose: function() {
                return ye();
            }
        });
    }
    function Ue() {
        if (!k && oe.getState().canUndo) {
            var e = oe.undo();
            if (e) {
                var t = {
                    json: w,
                    text: x
                };
                n(8, w = e.undo.patch ? rc(w, e.undo.patch) : e.undo.json), n(11, te = e.undo.state), n(16, x = e.undo.text), n(19, ne = e.undo.textIsRepaired), n(17, U = void 0), s("undo", {
                    item: e,
                    json: w
                }), ve(t, e.undo.patch && e.redo.patch ? {
                    json: w,
                    previousJson: t.json,
                    redo: e.undo.patch,
                    undo: e.redo.patch
                } : null), ye(), te.selection && we(JE(te.selection), !1);
            }
        }
    }
    function Je() {
        if (!k && oe.getState().canRedo) {
            var e = oe.redo();
            if (e) {
                var t = {
                    json: w,
                    text: x
                };
                n(8, w = e.redo.patch ? rc(w, e.redo.patch) : e.redo.json), n(11, te = e.redo.state), n(16, x = e.redo.text), n(19, ne = e.redo.textIsRepaired), n(17, U = void 0), s("redo", {
                    item: e,
                    json: w
                }), ve(t, e.undo.patch && e.redo.patch ? {
                    json: w,
                    previousJson: t.json,
                    redo: e.redo.patch,
                    undo: e.undo.patch
                } : null), ye(), te.selection && we(JE(te.selection), !1);
            }
        }
    }
    function Ke(e, t) {
        n(70, Q[t] = e.getBoundingClientRect().height, Q);
    }
    return e.$$set = function(e) {
        "readOnly" in e && n(0, k = e.readOnly), "externalContent" in e && n(47, j = e.externalContent), "externalSelection" in e && n(48, S = e.externalSelection), "mainMenuBar" in e && n(1, C = e.mainMenuBar), "escapeControlCharacters" in e && n(49, $ = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(50, _ = e.escapeUnicodeCharacters), "flattenColumns" in e && n(51, O = e.flattenColumns), "parser" in e && n(2, M = e.parser), "parseMemoizeOne" in e && n(52, E = e.parseMemoizeOne), "validator" in e && n(53, A = e.validator), "validationParser" in e && n(54, P = e.validationParser), "indentation" in e && n(3, T = e.indentation), "onChange" in e && n(55, R = e.onChange), "onChangeMode" in e && n(4, N = e.onChangeMode), "onSelect" in e && n(56, I = e.onSelect), "onRenderValue" in e && n(57, D = e.onRenderValue), "onRenderMenu" in e && n(5, z = e.onRenderMenu), "onRenderContextMenu" in e && n(58, q = e.onRenderContextMenu), "onFocus" in e && n(59, B = e.onFocus), "onBlur" in e && n(60, L = e.onBlur), "onSortModal" in e && n(61, F = e.onSortModal), "onTransformModal" in e && n(62, V = e.onTransformModal), "onJSONEditorModal" in e && n(63, H = e.onJSONEditorModal);
    }, e.$$.update = function() {
        786432 & e.$$.dirty[1] && n(69, m = aO({
            escapeControlCharacters: $,
            escapeUnicodeCharacters: _
        })), 65536 & e.$$.dirty[1] && ae(j), 131072 & e.$$.dirty[1] && function(e) {
            Ox(te.selection, e) || (s("applyExternalSelection", e), (yE(e) || null === e) && Z(e));
        }(S), 1792 & e.$$.dirty[0] | 1048576 & e.$$.dirty[1] && n(10, K = Ts(w) ? function(e, t) {
            var n, r = new Set(t.map(Zs)), o = new Set(e.map(Zs)), i = bo(r);
            try {
                for(i.s(); !(n = i.n()).done;){
                    var a = n.value;
                    o.has(a) || r.delete(a);
                }
            } catch (e) {
                i.e(e);
            } finally{
                i.f();
            }
            var s, c = bo(o);
            try {
                for(c.s(); !(s = c.n()).done;){
                    var l = s.value;
                    r.has(l) || r.add(l);
                }
            } catch (e) {
                c.e(e);
            } finally{
                c.f();
            }
            return Bo(r).map(Xs);
        }(PB(w, O, J), K) : []), 1280 & e.$$.dirty[0] && n(25, r = w && !_x(K)), 768 & e.$$.dirty[0] && n(24, o = Array.isArray(w) && w.length > J), 256 & e.$$.dirty[0] | 1792 & e.$$.dirty[2] && n(23, i = NB(X, Y, w, Q, s6)), 256 & e.$$.dirty[0] && y && y.scrollTo({
            top: y.scrollTop,
            left: y.scrollLeft
        }), 2309 & e.$$.dirty[0] | 67108864 & e.$$.dirty[1] | 128 & e.$$.dirty[2] && n(21, re = {
            readOnly: k,
            parser: M,
            normalization: m,
            getJson: function() {
                return w;
            },
            getDocumentState: function() {
                return te;
            },
            findElement: je,
            findNextInside: ge,
            focus: ye,
            onPatch: he,
            onSelect: Z,
            onFind: pe,
            onPasteJson: me,
            onRenderValue: D
        }), 260 & e.$$.dirty[0] | 12582912 & e.$$.dirty[1] && ue(w, A, M, P), 5120 & e.$$.dirty[0] && n(22, a = qB(ce, K));
    }, [
        k,
        C,
        M,
        T,
        N,
        z,
        ye,
        function() {
            if (ne && void 0 !== w) {
                var e = te, t = w, r = x, o = {
                    json: w,
                    text: x
                }, i = ne;
                n(16, x = void 0), n(19, ne = !1), ee(w), se({
                    previousJson: t,
                    previousState: e,
                    previousText: r,
                    previousTextIsRepaired: i
                });
                ve(o, null);
            }
            return {
                json: w,
                text: x
            };
        },
        w,
        J,
        K,
        te,
        ce,
        g,
        y,
        b,
        x,
        U,
        W,
        ne,
        ie,
        re,
        a,
        i,
        o,
        r,
        p,
        undefined,
        function(e) {
            if (!k) {
                s("onSortByHeader", e);
                var t = e.sortDirection === ts.desc ? -1 : 1;
                he(Lq(w, [], e.path, t), function(t, n) {
                    return {
                        state: Ro(Ro({}, n), {}, {
                            sortedColumn: e
                        })
                    };
                });
            }
        },
        function(e) {
            n(72, X = e.target.scrollTop);
        },
        function(e) {
            var t = e.target, n = MO(t);
            if (n) {
                if (qE(te.selection) && WE(w, te.selection, n)) return;
                Z(RE(n, !1)), e.preventDefault();
            }
            yO(t, "BUTTON") || t.isContentEditable || ye();
        },
        Se,
        Ce,
        function(e) {
            k || Se({
                anchor: $O(e.target, "BUTTON"),
                offsetTop: 0,
                width: Ms,
                height: Os,
                showTip: !0
            });
        },
        function() {
            return Me.apply(this, arguments);
        },
        function() {
            s("clear pasted json"), n(18, W = void 0), ye();
        },
        function() {
            N(Qa.text);
        },
        function(e) {
            var t = PO(e);
            if (s("keydown", {
                combo: t,
                key: e.key
            }), "Ctrl+X" === t && (e.preventDefault(), Ae(!0)), "Ctrl+Shift+X" === t && (e.preventDefault(), Ae(!1)), "Ctrl+C" === t && (e.preventDefault(), Te(!0)), "Ctrl+Shift+C" === t && (e.preventDefault(), Te(!1)), "Ctrl+D" === t && e.preventDefault(), "Delete" !== t && "Backspace" !== t || (e.preventDefault(), Ne()), "Insert" === t && e.preventDefault(), "Ctrl+A" === t && e.preventDefault(), "Ctrl+Q" === t && Ce(e), "ArrowLeft" === t && (e.preventDefault(), be(), te.selection)) {
                var n = function(e, t) {
                    var n = DB(JE(t), e), r = n.rowIndex, o = n.columnIndex;
                    return o > 0 ? RE(zB({
                        rowIndex: r,
                        columnIndex: o - 1
                    }, e), !1) : t;
                }(K, te.selection);
                Z(n), ke(JE(n));
            }
            if ("ArrowRight" === t && (e.preventDefault(), be(), te.selection)) {
                var r = function(e, t) {
                    var n = DB(JE(t), e), r = n.rowIndex, o = n.columnIndex;
                    return o < e.length - 1 ? RE(zB({
                        rowIndex: r,
                        columnIndex: o + 1
                    }, e), !1) : t;
                }(K, te.selection);
                Z(r), ke(JE(r));
            }
            if ("ArrowUp" === t && (e.preventDefault(), be(), te.selection)) {
                var o = function(e, t) {
                    var n = DB(JE(t), e), r = n.rowIndex, o = n.columnIndex;
                    return r > 0 ? RE(zB({
                        rowIndex: r - 1,
                        columnIndex: o
                    }, e), !1) : t;
                }(K, te.selection);
                Z(o), ke(JE(o));
            }
            if ("ArrowDown" === t && (e.preventDefault(), be(), te.selection)) {
                var i = function(e, t, n) {
                    var r = DB(JE(n), t), o = r.rowIndex, i = r.columnIndex;
                    return o < e.length - 1 ? RE(zB({
                        rowIndex: o + 1,
                        columnIndex: i
                    }, t), !1) : n;
                }(w, K, te.selection);
                Z(i), ke(JE(i));
            }
            if ("Enter" === t && te.selection && pE(te.selection)) {
                e.preventDefault();
                var a = te.selection.path;
                Ql(Ws(w, a)) ? He(a) : k || Z(Ro(Ro({}, te.selection), {}, {
                    edit: !0
                }));
            }
            if (1 === t.replace(/^Shift\+/, "").length && te.selection) return e.preventDefault(), void function(e) {
                Be.apply(this, arguments);
            }(e.key);
            if ("Ctrl+Enter" === t && pE(te.selection)) {
                var c = Ws(w, te.selection.path);
                nu(c) && window.open(String(c), "_blank");
            }
            "Escape" === t && te.selection && (e.preventDefault(), Z(null)), "Ctrl+F" === t && e.preventDefault(), "Ctrl+H" === t && e.preventDefault(), "Ctrl+Z" === t && (e.preventDefault(), Ue()), "Ctrl+Shift+Z" === t && (e.preventDefault(), Je());
        },
        function(e) {
            var t;
            e.preventDefault();
            var n = null === (t = e.clipboardData) || void 0 === t ? void 0 : t.getData("text/plain");
            void 0 !== n && KB({
                clipboardText: n,
                json: w,
                selection: te.selection,
                readOnly: k,
                parser: M,
                onPatch: he,
                onChangeText: Fe,
                openRepairModal: We
            });
        },
        function(e) {
            s("select validation error", e), Z(RE(e.path, !1)), we(e.path);
        },
        He,
        function() {
            !function(e) {
                k || void 0 === w || (G = !0, F({
                    id: h,
                    json: w,
                    rootPath: e,
                    onSort: function(t) {
                        var n = t.operations, r = t.itemPath, o = t.direction;
                        s("onSort", n, e, r, o), he(n, function(e, t) {
                            return {
                                state: Ro(Ro({}, t), {}, {
                                    sortedColumn: {
                                        path: r,
                                        sortDirection: -1 === o ? ts.desc : ts.asc
                                    }
                                })
                            };
                        });
                    },
                    onClose: function() {
                        G = !1, ye();
                    }
                }));
            }([]);
        },
        function() {
            Ve({
                rootPath: []
            });
        },
        Ue,
        Je,
        function(e) {
            n(71, Y = e.getBoundingClientRect().height);
        },
        Ke,
        j,
        S,
        $,
        _,
        O,
        E,
        A,
        P,
        R,
        I,
        D,
        q,
        B,
        L,
        F,
        V,
        H,
        fe,
        de,
        we,
        je,
        Ve,
        m,
        Q,
        Y,
        X,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(15, b = e);
            });
        },
        function() {
            return n(9, J = 1 / 0);
        },
        function(e, t) {
            return Ke(t, e);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(14, y = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(13, g = e);
            });
        }
    ];
}
var l6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, c6, a6, Zo, {
            readOnly: 0,
            externalContent: 47,
            externalSelection: 48,
            mainMenuBar: 1,
            escapeControlCharacters: 49,
            escapeUnicodeCharacters: 50,
            flattenColumns: 51,
            parser: 2,
            parseMemoizeOne: 52,
            validator: 53,
            validationParser: 54,
            indentation: 3,
            onChange: 55,
            onChangeMode: 4,
            onSelect: 56,
            onRenderValue: 57,
            onRenderMenu: 5,
            onRenderContextMenu: 58,
            onFocus: 59,
            onBlur: 60,
            onSortModal: 61,
            onTransformModal: 62,
            onJSONEditorModal: 63,
            validate: 64,
            patch: 65,
            focus: 6,
            acceptAutoRepair: 7,
            scrollTo: 66,
            findElement: 67,
            openTransformModal: 68
        }, R4, [
            -1,
            -1,
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "validate",
            get: function() {
                return this.$$.ctx[64];
            }
        },
        {
            key: "patch",
            get: function() {
                return this.$$.ctx[65];
            }
        },
        {
            key: "focus",
            get: function() {
                return this.$$.ctx[6];
            }
        },
        {
            key: "acceptAutoRepair",
            get: function() {
                return this.$$.ctx[7];
            }
        },
        {
            key: "scrollTo",
            get: function() {
                return this.$$.ctx[66];
            }
        },
        {
            key: "findElement",
            get: function() {
                return this.$$.ctx[67];
            }
        },
        {
            key: "openTransformModal",
            get: function() {
                return this.$$.ctx[68];
            }
        }
    ]), t;
}();
function u6(e) {
    var t, n, r = {
        externalContent: e[0],
        externalSelection: e[1],
        readOnly: e[2],
        indentation: e[3],
        mainMenuBar: e[6],
        navigationBar: e[7],
        escapeControlCharacters: e[10],
        escapeUnicodeCharacters: e[11],
        parser: e[13],
        parseMemoizeOne: e[14],
        validator: e[15],
        validationParser: e[16],
        pathParser: e[17],
        onError: e[23],
        onChange: e[18],
        onChangeMode: e[19],
        onSelect: e[20],
        onRenderValue: e[21],
        onClassName: e[22],
        onFocus: e[24],
        onBlur: e[25],
        onRenderMenu: e[32],
        onRenderContextMenu: e[33],
        onSortModal: e[26],
        onTransformModal: e[27],
        onJSONEditorModal: e[28]
    };
    return t = new CL({
        props: r
    }), e[49](t), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.externalContent = e[0]), 2 & n[0] && (r.externalSelection = e[1]), 4 & n[0] && (r.readOnly = e[2]), 8 & n[0] && (r.indentation = e[3]), 64 & n[0] && (r.mainMenuBar = e[6]), 128 & n[0] && (r.navigationBar = e[7]), 1024 & n[0] && (r.escapeControlCharacters = e[10]), 2048 & n[0] && (r.escapeUnicodeCharacters = e[11]), 8192 & n[0] && (r.parser = e[13]), 16384 & n[0] && (r.parseMemoizeOne = e[14]), 32768 & n[0] && (r.validator = e[15]), 65536 & n[0] && (r.validationParser = e[16]), 131072 & n[0] && (r.pathParser = e[17]), 8388608 & n[0] && (r.onError = e[23]), 262144 & n[0] && (r.onChange = e[18]), 524288 & n[0] && (r.onChangeMode = e[19]), 1048576 & n[0] && (r.onSelect = e[20]), 2097152 & n[0] && (r.onRenderValue = e[21]), 4194304 & n[0] && (r.onClassName = e[22]), 16777216 & n[0] && (r.onFocus = e[24]), 33554432 & n[0] && (r.onBlur = e[25]), 2 & n[1] && (r.onRenderMenu = e[32]), 4 & n[1] && (r.onRenderContextMenu = e[33]), 67108864 & n[0] && (r.onSortModal = e[26]), 134217728 & n[0] && (r.onTransformModal = e[27]), 268435456 & n[0] && (r.onJSONEditorModal = e[28]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(n) {
            e[49](null), Ra(t, n);
        }
    };
}
function f6(e) {
    var t, n, r = {
        externalContent: e[0],
        externalSelection: e[1],
        readOnly: e[2],
        mainMenuBar: e[6],
        escapeControlCharacters: e[10],
        escapeUnicodeCharacters: e[11],
        flattenColumns: e[12],
        parser: e[13],
        parseMemoizeOne: e[14],
        validator: e[15],
        validationParser: e[16],
        indentation: e[3],
        onChange: e[18],
        onChangeMode: e[19],
        onSelect: e[20],
        onRenderValue: e[21],
        onFocus: e[24],
        onBlur: e[25],
        onRenderMenu: e[32],
        onRenderContextMenu: e[33],
        onSortModal: e[26],
        onTransformModal: e[27],
        onJSONEditorModal: e[28]
    };
    return t = new l6({
        props: r
    }), e[48](t), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.externalContent = e[0]), 2 & n[0] && (r.externalSelection = e[1]), 4 & n[0] && (r.readOnly = e[2]), 64 & n[0] && (r.mainMenuBar = e[6]), 1024 & n[0] && (r.escapeControlCharacters = e[10]), 2048 & n[0] && (r.escapeUnicodeCharacters = e[11]), 4096 & n[0] && (r.flattenColumns = e[12]), 8192 & n[0] && (r.parser = e[13]), 16384 & n[0] && (r.parseMemoizeOne = e[14]), 32768 & n[0] && (r.validator = e[15]), 65536 & n[0] && (r.validationParser = e[16]), 8 & n[0] && (r.indentation = e[3]), 262144 & n[0] && (r.onChange = e[18]), 524288 & n[0] && (r.onChangeMode = e[19]), 1048576 & n[0] && (r.onSelect = e[20]), 2097152 & n[0] && (r.onRenderValue = e[21]), 16777216 & n[0] && (r.onFocus = e[24]), 33554432 & n[0] && (r.onBlur = e[25]), 2 & n[1] && (r.onRenderMenu = e[32]), 4 & n[1] && (r.onRenderContextMenu = e[33]), 67108864 & n[0] && (r.onSortModal = e[26]), 134217728 & n[0] && (r.onTransformModal = e[27]), 268435456 & n[0] && (r.onJSONEditorModal = e[28]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(n) {
            e[48](null), Ra(t, n);
        }
    };
}
function d6(e) {
    var t, n, r = {
        externalContent: e[0],
        externalSelection: e[1],
        readOnly: e[2],
        indentation: e[3],
        tabSize: e[4],
        mainMenuBar: e[6],
        statusBar: e[8],
        askToFormat: e[9],
        escapeUnicodeCharacters: e[11],
        parser: e[13],
        validator: e[15],
        validationParser: e[16],
        onChange: e[18],
        onSelect: e[20],
        onChangeMode: e[19],
        onError: e[23],
        onFocus: e[24],
        onBlur: e[25],
        onRenderMenu: e[32],
        onSortModal: e[26],
        onTransformModal: e[27]
    };
    return t = new U3({
        props: r
    }), e[47](t), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            1 & n[0] && (r.externalContent = e[0]), 2 & n[0] && (r.externalSelection = e[1]), 4 & n[0] && (r.readOnly = e[2]), 8 & n[0] && (r.indentation = e[3]), 16 & n[0] && (r.tabSize = e[4]), 64 & n[0] && (r.mainMenuBar = e[6]), 256 & n[0] && (r.statusBar = e[8]), 512 & n[0] && (r.askToFormat = e[9]), 2048 & n[0] && (r.escapeUnicodeCharacters = e[11]), 8192 & n[0] && (r.parser = e[13]), 32768 & n[0] && (r.validator = e[15]), 65536 & n[0] && (r.validationParser = e[16]), 262144 & n[0] && (r.onChange = e[18]), 1048576 & n[0] && (r.onSelect = e[20]), 524288 & n[0] && (r.onChangeMode = e[19]), 8388608 & n[0] && (r.onError = e[23]), 16777216 & n[0] && (r.onFocus = e[24]), 33554432 & n[0] && (r.onBlur = e[25]), 2 & n[1] && (r.onRenderMenu = e[32]), 67108864 & n[0] && (r.onSortModal = e[26]), 134217728 & n[0] && (r.onTransformModal = e[27]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(n) {
            e[47](null), Ra(t, n);
        }
    };
}
function h6(e) {
    var t, n, r, o, i, a = [
        d6,
        f6,
        u6
    ], s = [];
    function c(e, n) {
        return 32 & n[0] && (t = null), null == t && (t = !(e[5] !== Qa.text && "code" !== String(e[5]))), t ? 0 : e[5] === Qa.table ? 1 : 2;
    }
    return n = c(e, [
        -1,
        -1
    ]), r = s[n] = a[n](e), {
        c: function() {
            r.c(), o = _i();
        },
        m: function(e, t) {
            s[n].m(e, t), wi(e, o, t), i = !0;
        },
        p: function(e, t) {
            var i = n;
            (n = c(e, t)) === i ? s[n].p(e, t) : (ba(), ka(s[i], 1, 1, function() {
                s[i] = null;
            }), wa(), (r = s[n]) ? r.p(e, t) : (r = s[n] = a[n](e)).c(), xa(r, 1), r.m(o.parentNode, o));
        },
        i: function(e) {
            i || (xa(r), i = !0);
        },
        o: function(e) {
            ka(r), i = !1;
        },
        d: function(e) {
            e && xi(o), s[n].d(e);
        }
    };
}
function v6(e, t, n) {
    var r, o, i, a, s, c, l = t.content, u = t.selection, f = t.readOnly, d = t.indentation, h = t.tabSize, v = t.mode, p = t.mainMenuBar, m = t.navigationBar, g = t.statusBar, y = t.askToFormat, b = t.escapeControlCharacters, w = t.escapeUnicodeCharacters, x = t.flattenColumns, k = t.parser, j = t.parseMemoizeOne, S = t.validator, C = t.validationParser, $ = t.pathParser, _ = t.insideModal, O = t.onChange, M = t.onChangeMode, E = t.onSelect, A = t.onRenderValue, P = t.onClassName, T = t.onRenderMenu, R = t.onRenderContextMenu, N = t.onError, I = t.onFocus, D = t.onBlur, z = t.onSortModal, q = t.onTransformModal, B = t.onJSONEditorModal, L = {
        type: "separator"
    };
    function F() {
        return (F = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (!i) {
                            e.next = 3;
                            break;
                        }
                        return e.next = 3, i.refresh();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    return e.$$set = function(e) {
        "content" in e && n(0, l = e.content), "selection" in e && n(1, u = e.selection), "readOnly" in e && n(2, f = e.readOnly), "indentation" in e && n(3, d = e.indentation), "tabSize" in e && n(4, h = e.tabSize), "mode" in e && n(5, v = e.mode), "mainMenuBar" in e && n(6, p = e.mainMenuBar), "navigationBar" in e && n(7, m = e.navigationBar), "statusBar" in e && n(8, g = e.statusBar), "askToFormat" in e && n(9, y = e.askToFormat), "escapeControlCharacters" in e && n(10, b = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(11, w = e.escapeUnicodeCharacters), "flattenColumns" in e && n(12, x = e.flattenColumns), "parser" in e && n(13, k = e.parser), "parseMemoizeOne" in e && n(14, j = e.parseMemoizeOne), "validator" in e && n(15, S = e.validator), "validationParser" in e && n(16, C = e.validationParser), "pathParser" in e && n(17, $ = e.pathParser), "insideModal" in e && n(34, _ = e.insideModal), "onChange" in e && n(18, O = e.onChange), "onChangeMode" in e && n(19, M = e.onChangeMode), "onSelect" in e && n(20, E = e.onSelect), "onRenderValue" in e && n(21, A = e.onRenderValue), "onClassName" in e && n(22, P = e.onClassName), "onRenderMenu" in e && n(35, T = e.onRenderMenu), "onRenderContextMenu" in e && n(36, R = e.onRenderContextMenu), "onError" in e && n(23, N = e.onError), "onFocus" in e && n(24, I = e.onFocus), "onBlur" in e && n(25, D = e.onBlur), "onSortModal" in e && n(26, z = e.onSortModal), "onTransformModal" in e && n(27, q = e.onTransformModal), "onJSONEditorModal" in e && n(28, B = e.onJSONEditorModal);
    }, e.$$.update = function() {
        524320 & e.$$.dirty[0] && n(46, a = [
            {
                type: "button",
                text: "text",
                title: "Switch to text mode (current mode: ".concat(v, ")"),
                className: "jse-group-button jse-first" + (v === Qa.text || "code" === v ? " jse-selected" : ""),
                onClick: function() {
                    return M(Qa.text);
                }
            },
            {
                type: "button",
                text: "tree",
                title: "Switch to tree mode (current mode: ".concat(v, ")"),
                className: "jse-group-button " + (v === Qa.tree ? " jse-selected" : ""),
                onClick: function() {
                    return M(Qa.tree);
                }
            },
            {
                type: "button",
                text: "table",
                title: "Switch to table mode (current mode: ".concat(v, ")"),
                className: "jse-group-button jse-last" + (v === Qa.table ? " jse-selected" : ""),
                onClick: function() {
                    return M(Qa.table);
                }
            }
        ]), 32 & e.$$.dirty[0] | 32792 & e.$$.dirty[1] && n(32, s = function(e) {
            var t = rI(e[0]) ? a.concat(e) : a.concat(L, e);
            return T(t, {
                mode: v,
                modal: _
            }) || t;
        }), 34 & e.$$.dirty[0] | 40 & e.$$.dirty[1] && n(33, c = function(e) {
            return R(e, {
                mode: v,
                modal: _,
                selection: u
            }) || e;
        });
    }, [
        l,
        u,
        f,
        d,
        h,
        v,
        p,
        m,
        g,
        y,
        b,
        w,
        x,
        k,
        j,
        S,
        C,
        $,
        O,
        M,
        E,
        A,
        P,
        N,
        I,
        D,
        z,
        q,
        B,
        r,
        o,
        i,
        s,
        c,
        _,
        T,
        R,
        function(e) {
            if (r) return r.patch(e);
            if (o) return o.patch(e);
            if (i) return i.patch(e);
            throw new Error('Method patch is not available in mode "'.concat(v, '"'));
        },
        function(e) {
            if (r) return r.expand(e);
            throw new Error('Method expand is not available in mode "'.concat(v, '"'));
        },
        function(e) {
            if (i) i.openTransformModal(e);
            else if (r) r.openTransformModal(e);
            else {
                if (!o) throw new Error('Method transform is not available in mode "'.concat(v, '"'));
                o.openTransformModal(e);
            }
        },
        function() {
            if (i) return i.validate();
            if (r) return r.validate();
            if (o) return o.validate();
            throw new Error('Method validate is not available in mode "'.concat(v, '"'));
        },
        function() {
            return r ? r.acceptAutoRepair() : l;
        },
        function(e) {
            if (r) return r.scrollTo(e);
            if (o) return o.scrollTo(e);
            throw new Error('Method scrollTo is not available in mode "'.concat(v, '"'));
        },
        function(e) {
            if (r) return r.findElement(e);
            if (o) return o.findElement(e);
            throw new Error('Method findElement is not available in mode "'.concat(v, '"'));
        },
        function() {
            i ? i.focus() : r ? r.focus() : o && o.focus();
        },
        function() {
            return F.apply(this, arguments);
        },
        a,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(31, i = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(30, o = e);
            });
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(29, r = e);
            });
        }
    ];
}
var p6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, v6, h6, Xo, {
            content: 0,
            selection: 1,
            readOnly: 2,
            indentation: 3,
            tabSize: 4,
            mode: 5,
            mainMenuBar: 6,
            navigationBar: 7,
            statusBar: 8,
            askToFormat: 9,
            escapeControlCharacters: 10,
            escapeUnicodeCharacters: 11,
            flattenColumns: 12,
            parser: 13,
            parseMemoizeOne: 14,
            validator: 15,
            validationParser: 16,
            pathParser: 17,
            insideModal: 34,
            onChange: 18,
            onChangeMode: 19,
            onSelect: 20,
            onRenderValue: 21,
            onClassName: 22,
            onRenderMenu: 35,
            onRenderContextMenu: 36,
            onError: 23,
            onFocus: 24,
            onBlur: 25,
            onSortModal: 26,
            onTransformModal: 27,
            onJSONEditorModal: 28,
            patch: 37,
            expand: 38,
            transform: 39,
            validate: 40,
            acceptAutoRepair: 41,
            scrollTo: 42,
            findElement: 43,
            focus: 44,
            refresh: 45
        }, null, [
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "patch",
            get: function() {
                return this.$$.ctx[37];
            }
        },
        {
            key: "expand",
            get: function() {
                return this.$$.ctx[38];
            }
        },
        {
            key: "transform",
            get: function() {
                return this.$$.ctx[39];
            }
        },
        {
            key: "validate",
            get: function() {
                return this.$$.ctx[40];
            }
        },
        {
            key: "acceptAutoRepair",
            get: function() {
                return this.$$.ctx[41];
            }
        },
        {
            key: "scrollTo",
            get: function() {
                return this.$$.ctx[42];
            }
        },
        {
            key: "findElement",
            get: function() {
                return this.$$.ctx[43];
            }
        },
        {
            key: "focus",
            get: function() {
                return this.$$.ctx[44];
            }
        },
        {
            key: "refresh",
            get: function() {
                return this.$$.ctx[45];
            }
        }
    ]), t;
}();
function m6(e) {
    mi(e, "svelte-1m3nfgb", '.jse-modal.svelte-1m3nfgb.svelte-1m3nfgb{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-1m3nfgb .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-1m3nfgb .jse-modal-contents.svelte-1m3nfgb{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions.svelte-1m3nfgb{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents.svelte-1m3nfgb{padding-top:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label.svelte-1m3nfgb{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label .jse-label-inner.svelte-1m3nfgb{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label .jse-label-inner button.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-modal-inline-editor.svelte-1m3nfgb{flex:1;min-height:150px;min-width:0;display:flex;--jse-theme-color:var(--jse-modal-editor-theme-color, var(--jse-modal-theme-color, #707070));--jse-theme-color-highlight:var(--jse-modal-editor-theme-color-highlight, var(--jse-modal-theme-color-highlight, #646464))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions.svelte-1m3nfgb{gap:var(--jse-padding, 10px);align-items:center}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions .jse-error.svelte-1m3nfgb{flex:1;color:var(--jse-error-color, #ee5341)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-secondary-background, #d3d3d3);color:var(--jse-button-secondary-color, var(--jse-text-color, #4d4d4d));padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb:hover{background:var(--jse-button-secondary-background-highlight, #e1e1e1)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb:disabled{background:var(--jse-button-secondary-background-disabled, #9d9d9d)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb:read-only{background:var(--jse-input-background-readonly, transparent)}');
}
function g6(e) {
    var t, n;
    return {
        c: function() {
            t = ji("div"), n = Ci(e[22]), Ai(t, "class", "jse-error svelte-1m3nfgb");
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, t) {
            4194304 & t[0] && Ni(n, e[22]);
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function y6(e) {
    var t, n, r, o, i, a;
    return n = new jM({
        props: {
            data: nP
        }
    }), {
        c: function() {
            t = ji("button"), Pa(n.$$.fragment), r = Ci(" Back"), Ai(t, "type", "button"), Ai(t, "class", "jse-secondary svelte-1m3nfgb");
        },
        m: function(s, c) {
            wi(s, t, c), Ta(n, t, null), pi(t, r), o = !0, i || (a = Oi(t, "click", e[27]), i = !0);
        },
        p: Wo,
        i: function(e) {
            o || (xa(n.$$.fragment, e), o = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), o = !1;
        },
        d: function(e) {
            e && xi(t), Ra(n), i = !1, a();
        }
    };
}
function b6(e) {
    var t, n, r;
    return {
        c: function() {
            (t = ji("button")).textContent = "Close", Ai(t, "type", "button"), Ai(t, "class", "jse-primary svelte-1m3nfgb");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = [
                Oi(t, "click", e[27]),
                ci(k6.call(null, t))
            ], n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, Qo(r);
        }
    };
}
function w6(e) {
    var t, n, r;
    return {
        c: function() {
            (t = ji("button")).textContent = "Apply", Ai(t, "type", "button"), Ai(t, "class", "jse-primary svelte-1m3nfgb");
        },
        m: function(o, i) {
            wi(o, t, i), n || (r = [
                Oi(t, "click", e[26]),
                ci(k6.call(null, t))
            ], n = !0);
        },
        p: Wo,
        d: function(e) {
            e && xi(t), n = !1, Qo(r);
        }
    };
}
function x6(e) {
    var t, n, r, o, i, a, s, c, l, u, f, d, h, v, p, m, g, y, b;
    n = new XN({
        props: {
            title: "Edit nested content " + (e[20].length > 1 ? " (".concat(e[20].length, ")") : ""),
            onClose: e[27]
        }
    });
    var w = {
        mode: e[23].mode,
        content: e[23].content,
        selection: e[23].selection,
        readOnly: e[0],
        indentation: e[1],
        tabSize: e[2],
        statusBar: e[5],
        askToFormat: e[6],
        mainMenuBar: e[3],
        navigationBar: e[4],
        escapeControlCharacters: e[7],
        escapeUnicodeCharacters: e[8],
        flattenColumns: e[9],
        parser: e[10],
        parseMemoizeOne: e[24],
        validator: e[11],
        validationParser: e[12],
        pathParser: e[13],
        insideModal: !0,
        onError: e[31],
        onChange: e[28],
        onChangeMode: e[30],
        onSelect: e[29],
        onRenderValue: e[14],
        onClassName: e[15],
        onFocus: JL,
        onBlur: JL,
        onRenderMenu: e[16],
        onRenderContextMenu: e[17],
        onSortModal: e[18],
        onTransformModal: e[19],
        onJSONEditorModal: e[32]
    };
    d = new p6({
        props: w
    }), e[37](d);
    var x = e[22] && g6(e), k = e[20].length > 1 && y6(e);
    function j(e, t) {
        return e[0] ? b6 : w6;
    }
    var S = j(e), C = S(e);
    return {
        c: function() {
            t = ji("div"), Pa(n.$$.fragment), r = $i(), o = ji("div"), (i = ji("div")).innerHTML = '<div class="jse-label-inner svelte-1m3nfgb">Path</div>', a = $i(), s = ji("input"), c = $i(), (l = ji("div")).innerHTML = '<div class="jse-label-inner svelte-1m3nfgb">Contents</div>', u = $i(), f = ji("div"), Pa(d.$$.fragment), h = $i(), v = ji("div"), x && x.c(), p = $i(), k && k.c(), m = $i(), C.c(), Ai(i, "class", "jse-label svelte-1m3nfgb"), Ai(s, "class", "jse-path svelte-1m3nfgb"), Ai(s, "type", "text"), s.readOnly = !0, Ai(s, "title", "Selected path"), s.value = e[25], Ai(l, "class", "jse-label svelte-1m3nfgb"), Ai(f, "class", "jse-modal-inline-editor svelte-1m3nfgb"), Ai(v, "class", "jse-actions svelte-1m3nfgb"), Ai(o, "class", "jse-modal-contents svelte-1m3nfgb"), Ai(t, "class", "jse-modal jse-jsoneditor-modal svelte-1m3nfgb");
        },
        m: function(w, j) {
            wi(w, t, j), Ta(n, t, null), pi(t, r), pi(t, o), pi(o, i), pi(o, a), pi(o, s), pi(o, c), pi(o, l), pi(o, u), pi(o, f), Ta(d, f, null), pi(o, h), pi(o, v), x && x.m(v, null), pi(v, p), k && k.m(v, null), pi(v, m), C.m(v, null), g = !0, y || (b = ci(FI.call(null, t, e[27])), y = !0);
        },
        p: function(e, t) {
            var r = {};
            1048576 & t[0] && (r.title = "Edit nested content " + (e[20].length > 1 ? " (".concat(e[20].length, ")") : "")), n.$set(r), (!g || 33554432 & t[0] && s.value !== e[25]) && (s.value = e[25]);
            var o = {};
            8388608 & t[0] && (o.mode = e[23].mode), 8388608 & t[0] && (o.content = e[23].content), 8388608 & t[0] && (o.selection = e[23].selection), 1 & t[0] && (o.readOnly = e[0]), 2 & t[0] && (o.indentation = e[1]), 4 & t[0] && (o.tabSize = e[2]), 32 & t[0] && (o.statusBar = e[5]), 64 & t[0] && (o.askToFormat = e[6]), 8 & t[0] && (o.mainMenuBar = e[3]), 16 & t[0] && (o.navigationBar = e[4]), 128 & t[0] && (o.escapeControlCharacters = e[7]), 256 & t[0] && (o.escapeUnicodeCharacters = e[8]), 512 & t[0] && (o.flattenColumns = e[9]), 1024 & t[0] && (o.parser = e[10]), 16777216 & t[0] && (o.parseMemoizeOne = e[24]), 2048 & t[0] && (o.validator = e[11]), 4096 & t[0] && (o.validationParser = e[12]), 8192 & t[0] && (o.pathParser = e[13]), 16384 & t[0] && (o.onRenderValue = e[14]), 32768 & t[0] && (o.onClassName = e[15]), 65536 & t[0] && (o.onRenderMenu = e[16]), 131072 & t[0] && (o.onRenderContextMenu = e[17]), 262144 & t[0] && (o.onSortModal = e[18]), 524288 & t[0] && (o.onTransformModal = e[19]), d.$set(o), e[22] ? x ? x.p(e, t) : ((x = g6(e)).c(), x.m(v, p)) : x && (x.d(1), x = null), e[20].length > 1 ? k ? (k.p(e, t), 1048576 & t[0] && xa(k, 1)) : ((k = y6(e)).c(), xa(k, 1), k.m(v, m)) : k && (ba(), ka(k, 1, 1, function() {
                k = null;
            }), wa()), S === (S = j(e)) && C ? C.p(e, t) : (C.d(1), (C = S(e)) && (C.c(), C.m(v, null)));
        },
        i: function(e) {
            g || (xa(n.$$.fragment, e), xa(d.$$.fragment, e), xa(k), g = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), ka(d.$$.fragment, e), ka(k), g = !1;
        },
        d: function(r) {
            r && xi(t), Ra(n), e[37](null), Ra(d), x && x.d(), k && k.d(), C.d(), y = !1, b();
        }
    };
}
function k6(e) {
    e.focus();
}
function j6(e, t, n) {
    var r, o, i, a, s, c = Da("jsoneditor:JSONEditorModal"), l = t.content, u = t.path, f = t.onPatch, d = t.readOnly, h = t.indentation, v = t.tabSize, p = t.mainMenuBar, m = t.navigationBar, g = t.statusBar, y = t.askToFormat, b = t.escapeControlCharacters, w = t.escapeUnicodeCharacters, x = t.flattenColumns, k = t.parser, j = t.validator, S = t.validationParser, C = t.pathParser, $ = t.onRenderValue, _ = t.onClassName, O = t.onRenderMenu, M = t.onRenderContextMenu, E = t.onSortModal, A = t.onTransformModal, P = Zi("simple-modal").close, T = {
        mode: I(l),
        content: l,
        selection: null,
        relativePath: u
    }, R = [
        T
    ], N = void 0;
    function I(e) {
        return K_(e) && Ts(e.json) ? Qa.table : Qa.tree;
    }
    function D() {
        var e, t = (null === (e = vb(R)) || void 0 === e ? void 0 : e.selection) || null;
        yE(t) && s.scrollTo(JE(t));
    }
    return e.$$set = function(e) {
        "content" in e && n(33, l = e.content), "path" in e && n(34, u = e.path), "onPatch" in e && n(35, f = e.onPatch), "readOnly" in e && n(0, d = e.readOnly), "indentation" in e && n(1, h = e.indentation), "tabSize" in e && n(2, v = e.tabSize), "mainMenuBar" in e && n(3, p = e.mainMenuBar), "navigationBar" in e && n(4, m = e.navigationBar), "statusBar" in e && n(5, g = e.statusBar), "askToFormat" in e && n(6, y = e.askToFormat), "escapeControlCharacters" in e && n(7, b = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(8, w = e.escapeUnicodeCharacters), "flattenColumns" in e && n(9, x = e.flattenColumns), "parser" in e && n(10, k = e.parser), "validator" in e && n(11, j = e.validator), "validationParser" in e && n(12, S = e.validationParser), "pathParser" in e && n(13, C = e.pathParser), "onRenderValue" in e && n(14, $ = e.onRenderValue), "onClassName" in e && n(15, _ = e.onClassName), "onRenderMenu" in e && n(16, O = e.onRenderMenu), "onRenderContextMenu" in e && n(17, M = e.onRenderContextMenu), "onSortModal" in e && n(18, E = e.onSortModal), "onTransformModal" in e && n(19, A = e.onTransformModal);
    }, e.$$.update = function() {
        1048576 & e.$$.dirty[0] && n(23, r = vb(R) || T), 1048576 & e.$$.dirty[0] && n(36, o = R.flatMap(function(e) {
            return e.relativePath;
        })), 32 & e.$$.dirty[1] && n(25, i = _x(o) ? "(document root)" : JO(o)), 1024 & e.$$.dirty[0] && n(24, a = EB(k.parse));
    }, [
        d,
        h,
        v,
        p,
        m,
        g,
        y,
        b,
        w,
        x,
        k,
        j,
        S,
        C,
        $,
        _,
        O,
        M,
        E,
        A,
        R,
        s,
        N,
        r,
        a,
        i,
        function() {
            if (c("handleApply"), !d) try {
                n(22, N = void 0);
                var e = r.relativePath, t = r.content, o = [
                    {
                        op: "replace",
                        path: Zs(e),
                        value: Q_(t, k).json
                    }
                ];
                if (R.length > 1) {
                    var i = {
                        json: rc(Q_(R[R.length - 2].content, k).json, o)
                    }, a = Ro(Ro({}, R[R.length - 2] || T), {}, {
                        content: i
                    });
                    n(20, R = [].concat(Bo(R.slice(0, R.length - 2)), [
                        a
                    ])), ca().then(D);
                } else f(o), P();
            } catch (e) {
                n(22, N = String(e));
            }
        },
        function() {
            c("handleClose"), R.length > 1 ? (n(20, R = Qw(R)), ca().then(D), n(22, N = void 0)) : P();
        },
        function(e) {
            c("handleChange", e);
            var t = Ro(Ro({}, r), {}, {
                content: e
            });
            n(20, R = [].concat(Bo(Qw(R)), [
                t
            ]));
        },
        function(e) {
            c("handleChangeSelection", e);
            var t = Ro(Ro({}, r), {}, {
                selection: e
            });
            n(20, R = [].concat(Bo(Qw(R)), [
                t
            ]));
        },
        function(e) {
            c("handleChangeMode", e);
            var t = Ro(Ro({}, r), {}, {
                mode: e
            });
            n(20, R = [].concat(Bo(Qw(R)), [
                t
            ]));
        },
        function(e) {
            n(22, N = e.toString()), console.error(e);
        },
        function(e) {
            var t = e.content, r = e.path;
            c("handleJSONEditorModal", {
                content: t,
                path: r
            });
            var o = {
                mode: I(t),
                content: t,
                selection: null,
                relativePath: r
            };
            n(20, R = [].concat(Bo(R), [
                o
            ]));
        },
        l,
        u,
        f,
        o,
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(21, s = e);
            });
        }
    ];
}
var S6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, j6, x6, Zo, {
            content: 33,
            path: 34,
            onPatch: 35,
            readOnly: 0,
            indentation: 1,
            tabSize: 2,
            mainMenuBar: 3,
            navigationBar: 4,
            statusBar: 5,
            askToFormat: 6,
            escapeControlCharacters: 7,
            escapeUnicodeCharacters: 8,
            flattenColumns: 9,
            parser: 10,
            validator: 11,
            validationParser: 12,
            pathParser: 13,
            onRenderValue: 14,
            onClassName: 15,
            onRenderMenu: 16,
            onRenderContextMenu: 17,
            onSortModal: 18,
            onTransformModal: 19
        }, m6, [
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t);
}();
function C6(e, t, n) {
    var r = Zi("simple-modal");
    return [
        r.open,
        r.close
    ];
}
var $6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, C6, null, Zo, {
            open: 0,
            close: 1
        }), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "open",
            get: function() {
                return this.$$.ctx[0];
            }
        },
        {
            key: "close",
            get: function() {
                return this.$$.ctx[1];
            }
        }
    ]), t;
}();
function _6(e) {
    mi(e, "svelte-ybuk0j", '.jse-main.svelte-ybuk0j{width:100%;height:100%;min-width:0;min-height:150px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;position:relative;display:flex;flex-direction:row}');
}
function O6(e) {
    var t, n, r = {
        mode: e[1],
        content: e[0],
        selection: e[2],
        readOnly: e[3],
        indentation: e[4],
        tabSize: e[5],
        statusBar: e[8],
        askToFormat: e[9],
        mainMenuBar: e[6],
        navigationBar: e[7],
        escapeControlCharacters: e[10],
        escapeUnicodeCharacters: e[11],
        flattenColumns: e[12],
        parser: e[13],
        parseMemoizeOne: e[27],
        validator: e[14],
        validationParser: e[15],
        pathParser: e[16],
        insideModal: !1,
        onError: e[21],
        onChange: e[28],
        onChangeMode: e[32],
        onSelect: e[29],
        onRenderValue: e[17],
        onClassName: e[18],
        onFocus: e[30],
        onBlur: e[31],
        onRenderMenu: e[19],
        onRenderContextMenu: e[20],
        onSortModal: e[34],
        onTransformModal: e[33],
        onJSONEditorModal: e[35]
    };
    return t = new p6({
        props: r
    }), e[62](t), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            2 & n[0] && (r.mode = e[1]), 1 & n[0] && (r.content = e[0]), 4 & n[0] && (r.selection = e[2]), 8 & n[0] && (r.readOnly = e[3]), 16 & n[0] && (r.indentation = e[4]), 32 & n[0] && (r.tabSize = e[5]), 256 & n[0] && (r.statusBar = e[8]), 512 & n[0] && (r.askToFormat = e[9]), 64 & n[0] && (r.mainMenuBar = e[6]), 128 & n[0] && (r.navigationBar = e[7]), 1024 & n[0] && (r.escapeControlCharacters = e[10]), 2048 & n[0] && (r.escapeUnicodeCharacters = e[11]), 4096 & n[0] && (r.flattenColumns = e[12]), 8192 & n[0] && (r.parser = e[13]), 134217728 & n[0] && (r.parseMemoizeOne = e[27]), 16384 & n[0] && (r.validator = e[14]), 32768 & n[0] && (r.validationParser = e[15]), 65536 & n[0] && (r.pathParser = e[16]), 2097152 & n[0] && (r.onError = e[21]), 131072 & n[0] && (r.onRenderValue = e[17]), 262144 & n[0] && (r.onClassName = e[18]), 524288 & n[0] && (r.onRenderMenu = e[19]), 1048576 & n[0] && (r.onRenderContextMenu = e[20]), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(n) {
            e[62](null), Ra(t, n);
        }
    };
}
function M6(e) {
    var t, n, r, o, i, a = e[22];
    function s(t) {
        e[61](t);
    }
    var c = {};
    void 0 !== e[25] && (c.open = e[25]), t = new $6({
        props: c
    }), na.push(function() {
        return Aa(t, "open", s);
    });
    var l = O6(e);
    return {
        c: function() {
            Pa(t.$$.fragment), r = $i(), o = ji("div"), l.c(), Ai(o, "class", "jse-main svelte-ybuk0j"), qi(o, "jse-focus", e[23]);
        },
        m: function(e, n) {
            Ta(t, e, n), wi(e, r, n), wi(e, o, n), l.m(o, null), i = !0;
        },
        p: function(e, r) {
            var s = {};
            !n && 33554432 & r[0] && (n = !0, s.open = e[25], ua(function() {
                return n = !1;
            })), t.$set(s), 4194304 & r[0] && Zo(a, a = e[22]) ? (ba(), ka(l, 1, 1, Wo), wa(), (l = O6(e)).c(), xa(l, 1), l.m(o, null)) : l.p(e, r), (!i || 8388608 & r[0]) && qi(o, "jse-focus", e[23]);
        },
        i: function(e) {
            i || (xa(t.$$.fragment, e), xa(l), i = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), ka(l), i = !1;
        },
        d: function(e) {
            e && (xi(r), xi(o)), Ra(t, e), l.d(e);
        }
    };
}
function E6(e) {
    var t, n;
    return t = new rs({
        props: {
            closeOnEsc: !1,
            $$slots: {
                default: [
                    M6
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            201326591 & n[0] | 8 & n[2] && (r.$$scope = {
                dirty: n,
                ctx: e
            }), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function A6(e) {
    for(var t, n, r, o = [
        {
            show: null === (t = e[26]) || void 0 === t ? void 0 : t.component
        },
        ws,
        {
            closeOnEsc: !1
        }
    ], i = {
        $$slots: {
            default: [
                E6
            ]
        },
        $$scope: {
            ctx: e
        }
    }, a = 0; a < o.length; a += 1)i = Jo(i, o[a]);
    return (n = new rs({
        props: i
    })).$on("close", e[36]), {
        c: function() {
            Pa(n.$$.fragment);
        },
        m: function(e, t) {
            Ta(n, e, t), r = !0;
        },
        p: function(e, t) {
            var r, i = 67108864 & t[0] ? Ma(o, [
                {
                    show: null === (r = e[26]) || void 0 === r ? void 0 : r.component
                },
                o[1],
                o[2]
            ]) : {};
            201326591 & t[0] | 8 & t[2] && (i.$$scope = {
                dirty: t,
                ctx: e
            }), n.$set(i);
        },
        i: function(e) {
            r || (xa(n.$$.fragment, e), r = !0);
        },
        o: function(e) {
            ka(n.$$.fragment, e), r = !1;
        },
        d: function(e) {
            Ra(n, e);
        }
    };
}
function P6(e) {
    var t, n;
    return t = new UO({
        props: {
            $$slots: {
                default: [
                    A6
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c: function() {
            Pa(t.$$.fragment);
        },
        m: function(e, r) {
            Ta(t, e, r), n = !0;
        },
        p: function(e, n) {
            var r = {};
            268435455 & n[0] | 8 & n[2] && (r.$$scope = {
                dirty: n,
                ctx: e
            }), t.$set(r);
        },
        i: function(e) {
            n || (xa(t.$$.fragment, e), n = !0);
        },
        o: function(e) {
            ka(t.$$.fragment, e), n = !1;
        },
        d: function(e) {
            Ra(t, e);
        }
    };
}
function T6(e, t, n) {
    var r, o, i, a = Da("jsoneditor:JSONEditor"), s = t.content, c = void 0 === s ? {
        text: ""
    } : s, l = t.selection, u = void 0 === l ? null : l, f = t.readOnly, d = void 0 !== f && f, h = t.indentation, v = void 0 === h ? 2 : h, p = t.tabSize, m = void 0 === p ? 4 : p, g = t.mode, y = void 0 === g ? Qa.tree : g, b = t.mainMenuBar, w = void 0 === b || b, x = t.navigationBar, k = void 0 === x || x, j = t.statusBar, S = void 0 === j || j, C = t.askToFormat, $ = void 0 === C || C, _ = t.escapeControlCharacters, O = void 0 !== _ && _, M = t.escapeUnicodeCharacters, E = void 0 !== M && M, A = t.flattenColumns, P = void 0 === A || A, T = t.parser, R = void 0 === T ? JSON : T, N = t.validator, I = void 0 === N ? null : N, D = t.validationParser, z = void 0 === D ? JSON : D, q = t.pathParser, B = void 0 === q ? {
        parse: KO,
        stringify: JO
    } : q, L = t.queryLanguages, F = void 0 === L ? [
        rM
    ] : L, V = t.queryLanguageId, H = void 0 === V ? F[0].id : V, W = t.onChangeQueryLanguage, U = void 0 === W ? JL : W, J = t.onChange, K = void 0 === J ? null : J, G = t.onSelect, Q = void 0 === G ? JL : G, Y = t.onRenderValue, X = void 0 === Y ? GA : Y, Z = t.onClassName, ee = void 0 === Z ? function() {} : Z, te = t.onRenderMenu, ne = void 0 === te ? JL : te, re = t.onRenderContextMenu, oe = void 0 === re ? JL : re, ie = t.onChangeMode, ae = void 0 === ie ? JL : ie, se = t.onError, ce = void 0 === se ? function(e) {
        console.error(e), alert(e.toString());
    } : se, le = t.onFocus, ue = void 0 === le ? JL : le, fe = t.onBlur, de = void 0 === fe ? JL : fe, he = Ps(), ve = !1, pe = null, me = R;
    function ge() {
        return (ge = ko(wo().mark(function e(t) {
            var r;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (a("set"), !(r = W_(t))) {
                            e.next = 4;
                            break;
                        }
                        throw new Error(r);
                    case 4:
                        n(22, he = Ps()), n(0, c = t);
                    case 6:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function ye() {
        return (ye = ko(wo().mark(function e(t) {
            var r;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (a("update"), !(r = W_(t))) {
                            e.next = 4;
                            break;
                        }
                        throw new Error(r);
                    case 4:
                        return n(0, c = t), e.next = 7, ca();
                    case 7:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function be() {
        return be = ko(wo().mark(function e(t) {
            var r;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (!J_(c)) {
                            e.next = 8;
                            break;
                        }
                        e.prev = 1, n(0, c = {
                            json: R.parse(c.text),
                            text: void 0
                        }), e.next = 8;
                        break;
                    case 5:
                        throw e.prev = 5, e.t0 = e.catch(1), new Error("Cannot apply patch: current document contains invalid JSON");
                    case 8:
                        return r = o.patch(t), e.next = 11, ca();
                    case 11:
                        return e.abrupt("return", r);
                    case 12:
                    case "end":
                        return e.stop();
                }
            }, e, null, [
                [
                    1,
                    5
                ]
            ]);
        })), be.apply(this, arguments);
    }
    function we() {
        return (we = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return n(2, u = t), e.next = 3, ca();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function xe() {
        return (xe = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return o.expand(t), e.next = 3, ca();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function ke() {
        return ke = ko(wo().mark(function e() {
            var t;
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return t = o.acceptAutoRepair(), e.next = 3, ca();
                    case 3:
                        return e.abrupt("return", t);
                    case 4:
                    case "end":
                        return e.stop();
                }
            }, e);
        })), ke.apply(this, arguments);
    }
    function je() {
        return (je = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, o.scrollTo(t);
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Se() {
        return Ce.apply(this, arguments);
    }
    function Ce() {
        return (Ce = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return o.focus(), e.next = 3, ca();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function $e() {
        return ($e = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return e.next = 2, o.refresh();
                    case 2:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function _e() {
        return (_e = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return this.$set(t), e.next = 3, ca();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        }))).apply(this, arguments);
    }
    function Oe() {
        return (Oe = ko(wo().mark(function e() {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        return this.$destroy(), e.next = 3, ca();
                    case 3:
                    case "end":
                        return e.stop();
                }
            }, e, this);
        }))).apply(this, arguments);
    }
    function Me() {
        return (Me = ko(wo().mark(function e(t) {
            return wo().wrap(function(e) {
                for(;;)switch(e.prev = e.next){
                    case 0:
                        if (y !== t) {
                            e.next = 2;
                            break;
                        }
                        return e.abrupt("return");
                    case 2:
                        return n(1, y = t), e.next = 5, ca();
                    case 5:
                        return e.next = 7, Se();
                    case 7:
                        ae(t);
                    case 8:
                    case "end":
                        return e.stop();
                }
            }, e);
        }))).apply(this, arguments);
    }
    function Ee(e) {
        a("handleChangeQueryLanguage", e), n(37, H = e), U(e);
    }
    function Ae(e) {
        var t = e.id, n = e.json, o = e.rootPath, a = e.onTransform, s = e.onClose;
        d || i(zL, {
            id: t,
            json: n,
            rootPath: o,
            indentation: v,
            escapeControlCharacters: O,
            escapeUnicodeCharacters: E,
            parser: R,
            parseMemoizeOne: r,
            validationParser: z,
            pathParser: B,
            queryLanguages: F,
            queryLanguageId: H,
            onChangeQueryLanguage: Ee,
            onRenderValue: X,
            onRenderMenu: ne,
            onRenderContextMenu: oe,
            onClassName: ee,
            onTransform: a
        }, bs, {
            onClose: s
        });
    }
    function Pe(e) {
        var t = e.id, n = e.json, r = e.rootPath, o = e.onSort, a = e.onClose;
        d || i(UL, {
            id: t,
            json: n,
            rootPath: r,
            onSort: o
        }, ys, {
            onClose: a
        });
    }
    return e.$$set = function(e) {
        "content" in e && n(0, c = e.content), "selection" in e && n(2, u = e.selection), "readOnly" in e && n(3, d = e.readOnly), "indentation" in e && n(4, v = e.indentation), "tabSize" in e && n(5, m = e.tabSize), "mode" in e && n(1, y = e.mode), "mainMenuBar" in e && n(6, w = e.mainMenuBar), "navigationBar" in e && n(7, k = e.navigationBar), "statusBar" in e && n(8, S = e.statusBar), "askToFormat" in e && n(9, $ = e.askToFormat), "escapeControlCharacters" in e && n(10, O = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(11, E = e.escapeUnicodeCharacters), "flattenColumns" in e && n(12, P = e.flattenColumns), "parser" in e && n(13, R = e.parser), "validator" in e && n(14, I = e.validator), "validationParser" in e && n(15, z = e.validationParser), "pathParser" in e && n(16, B = e.pathParser), "queryLanguages" in e && n(38, F = e.queryLanguages), "queryLanguageId" in e && n(37, H = e.queryLanguageId), "onChangeQueryLanguage" in e && n(39, U = e.onChangeQueryLanguage), "onChange" in e && n(40, K = e.onChange), "onSelect" in e && n(41, Q = e.onSelect), "onRenderValue" in e && n(17, X = e.onRenderValue), "onClassName" in e && n(18, ee = e.onClassName), "onRenderMenu" in e && n(19, ne = e.onRenderMenu), "onRenderContextMenu" in e && n(20, oe = e.onRenderContextMenu), "onChangeMode" in e && n(42, ae = e.onChangeMode), "onError" in e && n(21, ce = e.onError), "onFocus" in e && n(43, ue = e.onFocus), "onBlur" in e && n(44, de = e.onBlur);
    }, e.$$.update = function() {
        if (8193 & e.$$.dirty[0] | 536870912 & e.$$.dirty[1] && !rO(R, me)) {
            if (a("parser changed, recreate editor"), K_(c)) {
                var t = me.stringify(c.json);
                n(0, c = {
                    json: void 0 !== t ? R.parse(t) : void 0
                });
            }
            n(60, me = R), n(22, he = Ps());
        }
        if (1 & e.$$.dirty[0]) {
            var o = W_(c);
            o && console.error("Error: " + o);
        }
        8192 & e.$$.dirty[0] && n(27, r = EB(R.parse)), 2 & e.$$.dirty[0] && (a("mode changed to", y), "code" === y && console.warn('Deprecation warning: "code" mode is renamed to "text". Please use mode="text" instead.'));
    }, [
        c,
        y,
        u,
        d,
        v,
        m,
        w,
        k,
        S,
        $,
        O,
        E,
        P,
        R,
        I,
        z,
        B,
        X,
        ee,
        ne,
        oe,
        ce,
        he,
        ve,
        o,
        i,
        pe,
        r,
        function(e, t, r) {
            n(0, c = e), K && K(e, t, r);
        },
        function(e) {
            n(2, u = e), Q(e);
        },
        function() {
            n(23, ve = !0), ue && ue();
        },
        function() {
            n(23, ve = !1), de && de();
        },
        function(e) {
            return Me.apply(this, arguments);
        },
        Ae,
        Pe,
        function(e) {
            var t = e.content, r = e.path, o = e.onPatch, i = e.onClose;
            a("onJSONEditorModal", {
                content: t,
                path: r
            }), n(26, pe = {
                component: Ka(S6, {
                    content: t,
                    path: r,
                    onPatch: o,
                    readOnly: d,
                    indentation: v,
                    tabSize: m,
                    mainMenuBar: w,
                    navigationBar: k,
                    statusBar: S,
                    askToFormat: $,
                    escapeControlCharacters: O,
                    escapeUnicodeCharacters: E,
                    flattenColumns: P,
                    parser: R,
                    validator: void 0,
                    validationParser: z,
                    pathParser: B,
                    onRenderValue: X,
                    onClassName: ee,
                    onRenderMenu: ne,
                    onRenderContextMenu: oe,
                    onSortModal: Pe,
                    onTransformModal: Ae
                }),
                callbacks: {
                    onClose: i
                }
            });
        },
        function() {
            var e, t;
            null === (e = pe) || void 0 === e || null === (e = e.callbacks) || void 0 === e || null === (t = e.onClose) || void 0 === t || t.call(e), n(26, pe = null);
        },
        H,
        F,
        U,
        K,
        Q,
        ae,
        ue,
        de,
        function() {
            return c;
        },
        function(e) {
            return ge.apply(this, arguments);
        },
        function(e) {
            return ye.apply(this, arguments);
        },
        function(e) {
            return be.apply(this, arguments);
        },
        function(e) {
            return we.apply(this, arguments);
        },
        function(e) {
            return xe.apply(this, arguments);
        },
        function(e) {
            o.transform(e);
        },
        function() {
            return o.validate();
        },
        function() {
            return ke.apply(this, arguments);
        },
        function(e) {
            return je.apply(this, arguments);
        },
        function(e) {
            return o.findElement(e);
        },
        Se,
        function() {
            return $e.apply(this, arguments);
        },
        function(e) {
            return _e.apply(this, arguments);
        },
        function() {
            return Oe.apply(this, arguments);
        },
        me,
        function(e) {
            n(25, i = e);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(24, o = e);
            });
        }
    ];
}
var R6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, T6, P6, Zo, {
            content: 0,
            selection: 2,
            readOnly: 3,
            indentation: 4,
            tabSize: 5,
            mode: 1,
            mainMenuBar: 6,
            navigationBar: 7,
            statusBar: 8,
            askToFormat: 9,
            escapeControlCharacters: 10,
            escapeUnicodeCharacters: 11,
            flattenColumns: 12,
            parser: 13,
            validator: 14,
            validationParser: 15,
            pathParser: 16,
            queryLanguages: 38,
            queryLanguageId: 37,
            onChangeQueryLanguage: 39,
            onChange: 40,
            onSelect: 41,
            onRenderValue: 17,
            onClassName: 18,
            onRenderMenu: 19,
            onRenderContextMenu: 20,
            onChangeMode: 42,
            onError: 21,
            onFocus: 43,
            onBlur: 44,
            get: 45,
            set: 46,
            update: 47,
            patch: 48,
            select: 49,
            expand: 50,
            transform: 51,
            validate: 52,
            acceptAutoRepair: 53,
            scrollTo: 54,
            findElement: 55,
            focus: 56,
            refresh: 57,
            updateProps: 58,
            destroy: 59
        }, _6, [
            -1,
            -1,
            -1
        ]), n;
    }
    return Ao(t, Ia), Do(t, [
        {
            key: "get",
            get: function() {
                return this.$$.ctx[45];
            }
        },
        {
            key: "set",
            get: function() {
                return this.$$.ctx[46];
            }
        },
        {
            key: "update",
            get: function() {
                return this.$$.ctx[47];
            }
        },
        {
            key: "patch",
            get: function() {
                return this.$$.ctx[48];
            }
        },
        {
            key: "select",
            get: function() {
                return this.$$.ctx[49];
            }
        },
        {
            key: "expand",
            get: function() {
                return this.$$.ctx[50];
            }
        },
        {
            key: "transform",
            get: function() {
                return this.$$.ctx[51];
            }
        },
        {
            key: "validate",
            get: function() {
                return this.$$.ctx[52];
            }
        },
        {
            key: "acceptAutoRepair",
            get: function() {
                return this.$$.ctx[53];
            }
        },
        {
            key: "scrollTo",
            get: function() {
                return this.$$.ctx[54];
            }
        },
        {
            key: "findElement",
            get: function() {
                return this.$$.ctx[55];
            }
        },
        {
            key: "focus",
            get: function() {
                return this.$$.ctx[56];
            }
        },
        {
            key: "refresh",
            get: function() {
                return this.$$.ctx[57];
            }
        },
        {
            key: "updateProps",
            get: function() {
                return this.$$.ctx[58];
            }
        },
        {
            key: "destroy",
            get: function() {
                return this.$$.ctx[59];
            }
        }
    ]), t;
}();
function N6(e) {
    mi(e, "svelte-9wp3tj", ".jse-value.jse-string.svelte-9wp3tj{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-9wp3tj,.jse-value.jse-array.svelte-9wp3tj{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-9wp3tj{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-9wp3tj{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-9wp3tj{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-9wp3tj{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-9wp3tj{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-enum-value.svelte-9wp3tj{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06));border:none;padding:0;font-family:inherit;font-size:inherit;cursor:pointer;outline:none}.jse-enum-value.jse-selected.svelte-9wp3tj{background:var(--jse-selection-background-color, #d3d3d3);color:inherit}.jse-enum-value.jse-value.svelte-9wp3tj:focus{color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-selected .jse-enum-value.svelte-9wp3tj{background:transparent}");
}
function I6(e, t, n) {
    var r = e.slice();
    return r[13] = t[n], r;
}
function D6(e) {
    var t, n, r, o = e[13].text + "";
    return {
        c: function() {
            t = ji("option"), n = Ci(o), t.__value = r = e[13].value, Ii(t, t.__value);
        },
        m: function(e, r) {
            wi(e, t, r), pi(t, n);
        },
        p: function(e, i) {
            4 & i && o !== (o = e[13].text + "") && Ni(n, o), 4 & i && r !== (r = e[13].value) && (t.__value = r, Ii(t, t.__value));
        },
        d: function(e) {
            e && xi(t);
        }
    };
}
function z6(e) {
    for(var t, n, r, o, i = Ca(e[2]), a = [], s = 0; s < i.length; s += 1)a[s] = D6(I6(e, i, s));
    return {
        c: function() {
            t = ji("select");
            for(var r = 0; r < a.length; r += 1)a[r].c();
            Ai(t, "class", n = si("jse-enum-value ".concat(QE(e[4], e[0]))) + " svelte-9wp3tj"), void 0 === e[4] && la(function() {
                return e[10].call(t);
            }), qi(t, "jse-selected", pE(e[1]));
        },
        m: function(n, i) {
            wi(n, t, i);
            for(var s = 0; s < a.length; s += 1)a[s] && a[s].m(t, null);
            zi(t, e[4], !0), e[11](t), r || (o = [
                Oi(t, "change", e[10]),
                Oi(t, "change", e[5]),
                Oi(t, "mousedown", q6)
            ], r = !0);
        },
        p: function(e, r) {
            var o = jo(r, 1)[0];
            if (4 & o) {
                var s;
                for(i = Ca(e[2]), s = 0; s < i.length; s += 1){
                    var c = I6(e, i, s);
                    a[s] ? a[s].p(c, o) : (a[s] = D6(c), a[s].c(), a[s].m(t, null));
                }
                for(; s < a.length; s += 1)a[s].d(1);
                a.length = i.length;
            }
            17 & o && n !== (n = si("jse-enum-value ".concat(QE(e[4], e[0]))) + " svelte-9wp3tj") && Ai(t, "class", n), 16 & o && zi(t, e[4]), 19 & o && qi(t, "jse-selected", pE(e[1]));
        },
        i: Wo,
        o: Wo,
        d: function(n) {
            n && xi(t), ki(a, n), e[11](null), r = !1, Qo(o);
        }
    };
}
function q6(e) {
    e.stopPropagation();
}
function B6(e, t, n) {
    var r, o = t.path, i = t.value, a = t.parser, s = t.readOnly, c = t.selection, l = t.onPatch, u = t.options, f = i;
    return e.$$set = function(e) {
        "path" in e && n(6, o = e.path), "value" in e && n(7, i = e.value), "parser" in e && n(0, a = e.parser), "readOnly" in e && n(8, s = e.readOnly), "selection" in e && n(1, c = e.selection), "onPatch" in e && n(9, l = e.onPatch), "options" in e && n(2, u = e.options);
    }, e.$$.update = function() {
        128 & e.$$.dirty && n(4, f = i), 2 & e.$$.dirty && function(e) {
            e && r && r.focus();
        }(c);
    }, [
        a,
        c,
        u,
        r,
        f,
        function(e) {
            e.stopPropagation(), s || l([
                {
                    op: "replace",
                    path: Zs(o),
                    value: f
                }
            ]);
        },
        o,
        i,
        s,
        l,
        function() {
            var e;
            e = this.querySelector(":checked"), f = e && e.__value, n(4, f), n(7, i);
        },
        function(e) {
            na[e ? "unshift" : "push"](function() {
                n(3, r = e), n(2, u);
            });
        }
    ];
}
var L6 = function(e) {
    function t(e) {
        var n;
        return No(this, t), Na(Eo(n = _o(this, t)), e, B6, z6, Zo, {
            path: 6,
            value: 7,
            parser: 0,
            readOnly: 8,
            selection: 1,
            onPatch: 9,
            options: 2
        }, N6), n;
    }
    return Ao(t, Ia), Do(t);
}();
function F6(e, t, n) {
    var r = V6(e, t || {}, n);
    return r ? function(e) {
        if (Array.isArray(e.enum)) return e.enum;
        var t = e.oneOf || e.anyOf || e.allOf;
        if (Array.isArray(t)) {
            var n = t.filter(function(e) {
                return e.enum;
            });
            if (n.length > 0) return n[0].enum;
        }
        return null;
    }(r) : null;
}
function V6(e, t, n) {
    for(var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e, o = n.slice(1, n.length), i = n[0], a = [
        r
    ], s = 0, c = [
        r.oneOf,
        r.anyOf,
        r.allOf
    ]; s < c.length; s++){
        var l = c[s];
        Array.isArray(l) && (a = a.concat(l));
    }
    var u, f = bo(a);
    try {
        for(f.s(); !(u = f.n()).done;){
            if ("$ref" in (r = u.value) && "string" == typeof r.$ref) {
                var d, h = r.$ref;
                if (h in t) r = t[h];
                else {
                    if (!h.startsWith("#/")) {
                        if (1 === (null === (d = h.match(/#\//g)) || void 0 === d ? void 0 : d.length)) {
                            var v = jo(h.split("#/"), 2), p = v[0], m = v[1];
                            if (p in t) {
                                var g = t[p], y = {
                                    $ref: "#/".concat(m)
                                }, b = [];
                                return b.push(i), o.length > 0 && b.push.apply(b, Bo(o)), V6(g, t, b, y);
                            }
                            throw Error("Unable to resolve reference ".concat(h));
                        }
                        throw Error("Unable to resolve reference ".concat(h));
                    }
                    var w = h.substring(2).split("/");
                    r = e;
                    var x, k = bo(w);
                    try {
                        for(k.s(); !(x = k.n()).done;){
                            var j = x.value;
                            if (!(j in r)) throw Error("Unable to resolve reference ".concat(h));
                            r = r[j];
                        }
                    } catch (e) {
                        k.e(e);
                    } finally{
                        k.f();
                    }
                }
            }
            if (void 0 === i) return r;
            if ("object" === Ho(r.properties) && null !== r.properties && i in r.properties) return V6(e, t, o, r = r.properties[i]);
            if ("object" === Ho(r.patternProperties) && null !== r.patternProperties) {
                for(var S in r.patternProperties)if (i.match(S)) return V6(e, t, o, r = r.patternProperties[S]);
            }
            if ("object" === Ho(r.additionalProperties)) return V6(e, t, o, r = r.additionalProperties);
            if ("object" === Ho(r.items) && null !== r.items) return V6(e, t, o, r = r.items);
        }
    } catch (e) {
        f.e(e);
    } finally{
        f.f();
    }
    return null;
}
function H6(e, t, n) {
    var r = F6(t, n, e.path);
    if (r) {
        var o = e.value, i = e.path, a = e.selection, s = e.parser, c = e.readOnly, l = e.onPatch, u = r.map(function(e) {
            return {
                value: e,
                text: e
            };
        }), f = r.includes(e.value) ? u : [
            {
                value: o,
                text: o
            }
        ].concat(u);
        return [
            {
                component: L6,
                props: {
                    value: o,
                    path: i,
                    selection: a,
                    parser: s,
                    readOnly: c,
                    onPatch: l,
                    options: f
                }
            }
        ];
    }
    return null;
}
var W6, U6 = {
    exports: {}
}, J6 = {}, K6 = {}, G6 = {}, Q6 = {}, Y6 = {}, X6 = {};
function Z6() {
    return W6 || (W6 = 1, function(n) {
        Object.defineProperty(n, "__esModule", {
            value: !0
        }), n.regexpCode = n.getEsmExportName = n.getProperty = n.safeStringify = n.stringify = n.strConcat = n.addCodeArg = n.str = n._ = n.nil = n._Code = n.Name = n.IDENTIFIER = n._CodeOrName = void 0;
        var r = Do(function e() {
            No(this, e);
        });
        n._CodeOrName = r, n.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
        var o = function(e) {
            function t(e) {
                var r;
                if (No(this, t), r = _o(this, t), !n.IDENTIFIER.test(e)) throw new Error("CodeGen: name must be a valid identifier");
                return r.str = e, r;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "toString",
                    value: function() {
                        return this.str;
                    }
                },
                {
                    key: "emptyStr",
                    value: function() {
                        return !1;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return zo({}, this.str, 1);
                    }
                }
            ]), t;
        }(r);
        n.Name = o;
        var i = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t))._items = "string" == typeof e ? [
                    e
                ] : e, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "toString",
                    value: function() {
                        return this.str;
                    }
                },
                {
                    key: "emptyStr",
                    value: function() {
                        if (this._items.length > 1) return !1;
                        var e = this._items[0];
                        return "" === e || '""' === e;
                    }
                },
                {
                    key: "str",
                    get: function() {
                        var e;
                        return null !== (e = this._str) && void 0 !== e ? e : this._str = this._items.reduce(function(e, t) {
                            return "".concat(e).concat(t);
                        }, "");
                    }
                },
                {
                    key: "names",
                    get: function() {
                        var e;
                        return null !== (e = this._names) && void 0 !== e ? e : this._names = this._items.reduce(function(e, t) {
                            return t instanceof o && (e[t.str] = (e[t.str] || 0) + 1), e;
                        }, {});
                    }
                }
            ]), t;
        }(r);
        function a(e) {
            for(var t = [
                e[0]
            ], n = 0, r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)o[a - 1] = arguments[a];
            for(; n < o.length;)l(t, o[n]), t.push(e[++n]);
            return new i(t);
        }
        n._Code = i, n.nil = new i(""), n._ = a;
        var s = new i("+");
        function c(e) {
            for(var t = [
                f(e[0])
            ], n = 0, r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)o[a - 1] = arguments[a];
            for(; n < o.length;)t.push(s), l(t, o[n]), t.push(s, f(e[++n]));
            return function(e) {
                var t = 1;
                for(; t < e.length - 1;){
                    if (e[t] === s) {
                        var n = u(e[t - 1], e[t + 1]);
                        if (void 0 !== n) {
                            e.splice(t - 1, 3, n);
                            continue;
                        }
                        e[t++] = "+";
                    }
                    t++;
                }
            }(t), new i(t);
        }
        function l(e, t) {
            var n;
            t instanceof i ? e.push.apply(e, Bo(t._items)) : t instanceof o ? e.push(t) : e.push("number" == typeof (n = t) || "boolean" == typeof n || null === n ? n : f(Array.isArray(n) ? n.join(",") : n));
        }
        function u(e, t) {
            if ('""' === t) return e;
            if ('""' === e) return t;
            if ("string" == typeof e) {
                if (t instanceof o || '"' !== e[e.length - 1]) return;
                return "string" != typeof t ? "".concat(e.slice(0, -1)).concat(t, '"') : '"' === t[0] ? e.slice(0, -1) + t.slice(1) : void 0;
            }
            return "string" != typeof t || '"' !== t[0] || e instanceof o ? void 0 : '"'.concat(e).concat(t.slice(1));
        }
        function f(e) {
            return JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
        }
        n.str = c, n.addCodeArg = l, n.strConcat = function(t, n) {
            return n.emptyStr() ? t : t.emptyStr() ? n : c(e || (e = mo([
                "",
                "",
                ""
            ])), t, n);
        }, n.stringify = function(e) {
            return new i(f(e));
        }, n.safeStringify = f, n.getProperty = function(e) {
            return "string" == typeof e && n.IDENTIFIER.test(e) ? new i(".".concat(e)) : a(t || (t = mo([
                "[",
                "]"
            ])), e);
        }, n.getEsmExportName = function(e) {
            if ("string" == typeof e && n.IDENTIFIER.test(e)) return new i("".concat(e));
            throw new Error("CodeGen: invalid export name: ".concat(e, ", use explicit $id name mapping"));
        }, n.regexpCode = function(e) {
            return new i(e.toString());
        };
    }(X6)), X6;
}
var e8, t8, n8 = {};
function r8() {
    return e8 || (e8 = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.ValueScope = e.ValueScopeName = e.Scope = e.varKinds = e.UsedValueState = void 0;
        var t, s = Z6(), c = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t, [
                    'CodeGen: "code" for '.concat(e, " not defined")
                ])).value = e.value, n;
            }
            return Ao(t, $o(Error)), Do(t);
        }();
        !function(e) {
            e[e.Started = 0] = "Started", e[e.Completed = 1] = "Completed";
        }(t = e.UsedValueState || (e.UsedValueState = {})), e.varKinds = {
            const: new s.Name("const"),
            let: new s.Name("let"),
            var: new s.Name("var")
        };
        var l = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.prefixes, r = t.parent;
                No(this, e), this._names = {}, this._prefixes = n, this._parent = r;
            }
            return Do(e, [
                {
                    key: "toName",
                    value: function(e) {
                        return e instanceof s.Name ? e : this.name(e);
                    }
                },
                {
                    key: "name",
                    value: function(e) {
                        return new s.Name(this._newName(e));
                    }
                },
                {
                    key: "_newName",
                    value: function(e) {
                        var t = this._names[e] || this._nameGroup(e);
                        return "".concat(e).concat(t.index++);
                    }
                },
                {
                    key: "_nameGroup",
                    value: function(e) {
                        var t, n;
                        if ((null === (n = null === (t = this._parent) || void 0 === t ? void 0 : t._prefixes) || void 0 === n ? void 0 : n.has(e)) || this._prefixes && !this._prefixes.has(e)) throw new Error('CodeGen: prefix "'.concat(e, '" is not allowed in this scope'));
                        return this._names[e] = {
                            prefix: e,
                            index: 0
                        };
                    }
                }
            ]), e;
        }();
        e.Scope = l;
        var u = function(e) {
            function t(e, n) {
                var r;
                return No(this, t), (r = _o(this, t, [
                    n
                ])).prefix = e, r;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "setValue",
                    value: function(e, t) {
                        var r = t.property, o = t.itemIndex;
                        this.value = e, this.scopePath = (0, s._)(n || (n = mo([
                            ".",
                            "[",
                            "]"
                        ])), new s.Name(r), o);
                    }
                }
            ]), t;
        }(s.Name);
        e.ValueScopeName = u;
        var f = (0, s._)(r || (r = mo([
            "\n"
        ], [
            "\\n"
        ]))), d = function(n) {
            function r(e) {
                var t;
                return No(this, r), (t = _o(this, r, [
                    e
                ]))._values = {}, t._scope = e.scope, t.opts = Ro(Ro({}, e), {}, {
                    _n: e.lines ? f : s.nil
                }), t;
            }
            return Ao(r, n), Do(r, [
                {
                    key: "get",
                    value: function() {
                        return this._scope;
                    }
                },
                {
                    key: "name",
                    value: function(e) {
                        return new u(e, this._newName(e));
                    }
                },
                {
                    key: "value",
                    value: function(e, t) {
                        var n;
                        if (void 0 === t.ref) throw new Error("CodeGen: ref must be passed in value");
                        var r = this.toName(e), o = r.prefix, i = null !== (n = t.key) && void 0 !== n ? n : t.ref, a = this._values[o];
                        if (a) {
                            var s = a.get(i);
                            if (s) return s;
                        } else a = this._values[o] = new Map;
                        a.set(i, r);
                        var c = this._scope[o] || (this._scope[o] = []), l = c.length;
                        return c[l] = t.ref, r.setValue(t, {
                            property: o,
                            itemIndex: l
                        }), r;
                    }
                },
                {
                    key: "getValue",
                    value: function(e, t) {
                        var n = this._values[e];
                        if (n) return n.get(t);
                    }
                },
                {
                    key: "scopeRefs",
                    value: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._values;
                        return this._reduceValues(t, function(t) {
                            if (void 0 === t.scopePath) throw new Error('CodeGen: name "'.concat(t, '" has no value'));
                            return (0, s._)(o || (o = mo([
                                "",
                                "",
                                ""
                            ])), e, t.scopePath);
                        });
                    }
                },
                {
                    key: "scopeCode",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._values, t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0;
                        return this._reduceValues(e, function(e) {
                            if (void 0 === e.value) throw new Error('CodeGen: name "'.concat(e, '" has no value'));
                            return e.value.code;
                        }, t, n);
                    }
                },
                {
                    key: "_reduceValues",
                    value: function(n, r) {
                        var o = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, u = arguments.length > 3 ? arguments[3] : void 0, f = s.nil, d = function() {
                            var d = n[h];
                            if (!d) return 1;
                            var v = l[h] = l[h] || new Map;
                            d.forEach(function(n) {
                                if (!v.has(n)) {
                                    v.set(n, t.Started);
                                    var l = r(n);
                                    if (l) {
                                        var d = o.opts.es5 ? e.varKinds.var : e.varKinds.const;
                                        f = (0, s._)(i || (i = mo([
                                            "",
                                            "",
                                            " ",
                                            " = ",
                                            ";",
                                            ""
                                        ])), f, d, n, l, o.opts._n);
                                    } else {
                                        if (!(l = null == u ? void 0 : u(n))) throw new c(n);
                                        f = (0, s._)(a || (a = mo([
                                            "",
                                            "",
                                            "",
                                            ""
                                        ])), f, l, o.opts._n);
                                    }
                                    v.set(n, t.Completed);
                                }
                            });
                        };
                        for(var h in n)d();
                        return f;
                    }
                }
            ]), r;
        }(l);
        e.ValueScope = d;
    }(n8)), n8;
}
function o8() {
    return t8 || (t8 = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.or = e.and = e.not = e.CodeGen = e.operators = e.varKinds = e.ValueScopeName = e.ValueScope = e.Scope = e.Name = e.regexpCode = e.stringify = e.getProperty = e.nil = e.strConcat = e.str = e._ = void 0;
        var t = Z6(), n = r8(), r = Z6();
        Object.defineProperty(e, "_", {
            enumerable: !0,
            get: function() {
                return r._;
            }
        }), Object.defineProperty(e, "str", {
            enumerable: !0,
            get: function() {
                return r.str;
            }
        }), Object.defineProperty(e, "strConcat", {
            enumerable: !0,
            get: function() {
                return r.strConcat;
            }
        }), Object.defineProperty(e, "nil", {
            enumerable: !0,
            get: function() {
                return r.nil;
            }
        }), Object.defineProperty(e, "getProperty", {
            enumerable: !0,
            get: function() {
                return r.getProperty;
            }
        }), Object.defineProperty(e, "stringify", {
            enumerable: !0,
            get: function() {
                return r.stringify;
            }
        }), Object.defineProperty(e, "regexpCode", {
            enumerable: !0,
            get: function() {
                return r.regexpCode;
            }
        }), Object.defineProperty(e, "Name", {
            enumerable: !0,
            get: function() {
                return r.Name;
            }
        });
        var o = r8();
        Object.defineProperty(e, "Scope", {
            enumerable: !0,
            get: function() {
                return o.Scope;
            }
        }), Object.defineProperty(e, "ValueScope", {
            enumerable: !0,
            get: function() {
                return o.ValueScope;
            }
        }), Object.defineProperty(e, "ValueScopeName", {
            enumerable: !0,
            get: function() {
                return o.ValueScopeName;
            }
        }), Object.defineProperty(e, "varKinds", {
            enumerable: !0,
            get: function() {
                return o.varKinds;
            }
        }), e.operators = {
            GT: new t._Code(">"),
            GTE: new t._Code(">="),
            LT: new t._Code("<"),
            LTE: new t._Code("<="),
            EQ: new t._Code("==="),
            NEQ: new t._Code("!=="),
            NOT: new t._Code("!"),
            OR: new t._Code("||"),
            AND: new t._Code("&&"),
            ADD: new t._Code("+")
        };
        var i = function() {
            function e() {
                No(this, e);
            }
            return Do(e, [
                {
                    key: "optimizeNodes",
                    value: function() {
                        return this;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, t) {
                        return this;
                    }
                }
            ]), e;
        }(), a = function(e) {
            function r(e, t, n) {
                var o;
                return No(this, r), (o = _o(this, r)).varKind = e, o.name = t, o.rhs = n, o;
            }
            return Ao(r, e), Do(r, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e.es5, r = e._n, o = t ? n.varKinds.var : this.varKind, i = void 0 === this.rhs ? "" : " = ".concat(this.rhs);
                        return "".concat(o, " ").concat(this.name).concat(i, ";") + r;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, t) {
                        if (e[this.name.str]) return this.rhs && (this.rhs = I(this.rhs, e, t)), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return this.rhs instanceof t._CodeOrName ? this.rhs.names : {};
                    }
                }
            ]), r;
        }(i), h = function(e) {
            function n(e, t, r) {
                var o;
                return No(this, n), (o = _o(this, n)).lhs = e, o.rhs = t, o.sideEffects = r, o;
            }
            return Ao(n, e), Do(n, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n;
                        return "".concat(this.lhs, " = ").concat(this.rhs, ";") + t;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, n) {
                        if (!(this.lhs instanceof t.Name) || e[this.lhs.str] || this.sideEffects) return this.rhs = I(this.rhs, e, n), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return N(this.lhs instanceof t.Name ? {} : Ro({}, this.lhs.names), this.rhs);
                    }
                }
            ]), n;
        }(i), v = function(e) {
            function t(e, n, r, o) {
                var i;
                return No(this, t), (i = _o(this, t, [
                    e,
                    r,
                    o
                ])).op = n, i;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n;
                        return "".concat(this.lhs, " ").concat(this.op, "= ").concat(this.rhs, ";") + t;
                    }
                }
            ]), t;
        }(h), p = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t)).label = e, n.names = {}, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n;
                        return "".concat(this.label, ":") + t;
                    }
                }
            ]), t;
        }(i), m = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t)).label = e, n.names = {}, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n, n = this.label ? " ".concat(this.label) : "";
                        return "break".concat(n, ";") + t;
                    }
                }
            ]), t;
        }(i), g = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t)).error = e, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n;
                        return "throw ".concat(this.error, ";") + t;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return this.error.names;
                    }
                }
            ]), t;
        }(i), y = function(e) {
            function n(e) {
                var t;
                return No(this, n), (t = _o(this, n)).code = e, t;
            }
            return Ao(n, e), Do(n, [
                {
                    key: "render",
                    value: function(e) {
                        var t = e._n;
                        return "".concat(this.code, ";") + t;
                    }
                },
                {
                    key: "optimizeNodes",
                    value: function() {
                        return "".concat(this.code) ? this : void 0;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, t) {
                        return this.code = I(this.code, e, t), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return this.code instanceof t._CodeOrName ? this.code.names : {};
                    }
                }
            ]), n;
        }(i), b = function(e) {
            function t() {
                var e, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                return No(this, t), (e = _o(this, t)).nodes = n, e;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return this.nodes.reduce(function(t, n) {
                            return t + n.render(e);
                        }, "");
                    }
                },
                {
                    key: "optimizeNodes",
                    value: function() {
                        for(var e = this.nodes, t = e.length; t--;){
                            var n = e[t].optimizeNodes();
                            Array.isArray(n) ? e.splice.apply(e, [
                                t,
                                1
                            ].concat(Bo(n))) : n ? e[t] = n : e.splice(t, 1);
                        }
                        return e.length > 0 ? this : void 0;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, t) {
                        for(var n = this.nodes, r = n.length; r--;){
                            var o = n[r];
                            o.optimizeNames(e, t) || (D(e, o.names), n.splice(r, 1));
                        }
                        return n.length > 0 ? this : void 0;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return this.nodes.reduce(function(e, t) {
                            return R(e, t.names);
                        }, {});
                    }
                }
            ]), t;
        }(i), w = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "{" + e._n + go(Mo(t.prototype), "render", this).call(this, e) + "}" + e._n;
                    }
                }
            ]), t;
        }(b), x = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t);
        }(b), k = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t);
        }(w);
        k.kind = "else";
        var j = function(e) {
            function t(e, n) {
                var r;
                return No(this, t), (r = _o(this, t, [
                    n
                ])).condition = e, r;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var n = "if(".concat(this.condition, ")") + go(Mo(t.prototype), "render", this).call(this, e);
                        return this.else && (n += "else " + this.else.render(e)), n;
                    }
                },
                {
                    key: "optimizeNodes",
                    value: function() {
                        go(Mo(t.prototype), "optimizeNodes", this).call(this);
                        var e = this.condition;
                        if (!0 === e) return this.nodes;
                        var n = this.else;
                        if (n) {
                            var r = n.optimizeNodes();
                            n = this.else = Array.isArray(r) ? new k(r) : r;
                        }
                        return n ? !1 === e ? n instanceof t ? n : n.nodes : this.nodes.length ? this : new t(z(e), n instanceof t ? [
                            n
                        ] : n.nodes) : !1 !== e && this.nodes.length ? this : void 0;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, n) {
                        var r;
                        if (this.else = null === (r = this.else) || void 0 === r ? void 0 : r.optimizeNames(e, n), go(Mo(t.prototype), "optimizeNames", this).call(this, e, n) || this.else) return this.condition = I(this.condition, e, n), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        var e = go(Mo(t.prototype), "names", this);
                        return N(e, this.condition), this.else && R(e, this.else.names), e;
                    }
                }
            ]), t;
        }(w);
        j.kind = "if";
        var S = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t);
        }(w);
        S.kind = "for";
        var C = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t)).iteration = e, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "for(".concat(this.iteration, ")") + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, n) {
                        if (go(Mo(t.prototype), "optimizeNames", this).call(this, e, n)) return this.iteration = I(this.iteration, e, n), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return R(go(Mo(t.prototype), "names", this), this.iteration.names);
                    }
                }
            ]), t;
        }(S), $ = function(e) {
            function t(e, n, r, o) {
                var i;
                return No(this, t), (i = _o(this, t)).varKind = e, i.name = n, i.from = r, i.to = o, i;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var r = e.es5 ? n.varKinds.var : this.varKind, o = this.name, i = this.from, a = this.to;
                        return "for(".concat(r, " ").concat(o, "=").concat(i, "; ").concat(o, "<").concat(a, "; ").concat(o, "++)") + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                },
                {
                    key: "names",
                    get: function() {
                        var e = N(go(Mo(t.prototype), "names", this), this.from);
                        return N(e, this.to);
                    }
                }
            ]), t;
        }(S), _ = function(e) {
            function t(e, n, r, o) {
                var i;
                return No(this, t), (i = _o(this, t)).loop = e, i.varKind = n, i.name = r, i.iterable = o, i;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "for(".concat(this.varKind, " ").concat(this.name, " ").concat(this.loop, " ").concat(this.iterable, ")") + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, n) {
                        if (go(Mo(t.prototype), "optimizeNames", this).call(this, e, n)) return this.iterable = I(this.iterable, e, n), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        return R(go(Mo(t.prototype), "names", this), this.iterable.names);
                    }
                }
            ]), t;
        }(S), O = function(e) {
            function t(e, n, r) {
                var o;
                return No(this, t), (o = _o(this, t)).name = e, o.args = n, o.async = r, o;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var n = this.async ? "async " : "";
                        return "".concat(n, "function ").concat(this.name, "(").concat(this.args, ")") + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                }
            ]), t;
        }(w);
        O.kind = "func";
        var M = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "return " + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                }
            ]), t;
        }(b);
        M.kind = "return";
        var E = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        var n = "try" + go(Mo(t.prototype), "render", this).call(this, e);
                        return this.catch && (n += this.catch.render(e)), this.finally && (n += this.finally.render(e)), n;
                    }
                },
                {
                    key: "optimizeNodes",
                    value: function() {
                        var e, n;
                        return go(Mo(t.prototype), "optimizeNodes", this).call(this), null === (e = this.catch) || void 0 === e || e.optimizeNodes(), null === (n = this.finally) || void 0 === n || n.optimizeNodes(), this;
                    }
                },
                {
                    key: "optimizeNames",
                    value: function(e, n) {
                        var r, o;
                        return go(Mo(t.prototype), "optimizeNames", this).call(this, e, n), null === (r = this.catch) || void 0 === r || r.optimizeNames(e, n), null === (o = this.finally) || void 0 === o || o.optimizeNames(e, n), this;
                    }
                },
                {
                    key: "names",
                    get: function() {
                        var e = go(Mo(t.prototype), "names", this);
                        return this.catch && R(e, this.catch.names), this.finally && R(e, this.finally.names), e;
                    }
                }
            ]), t;
        }(w), A = function(e) {
            function t(e) {
                var n;
                return No(this, t), (n = _o(this, t)).error = e, n;
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "catch(".concat(this.error, ")") + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                }
            ]), t;
        }(w);
        A.kind = "catch";
        var P = function(e) {
            function t() {
                return No(this, t), _o(this, t, arguments);
            }
            return Ao(t, e), Do(t, [
                {
                    key: "render",
                    value: function(e) {
                        return "finally" + go(Mo(t.prototype), "render", this).call(this, e);
                    }
                }
            ]), t;
        }(w);
        P.kind = "finally";
        var T = function() {
            function r(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                No(this, r), this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = Ro(Ro({}, t), {}, {
                    _n: t.lines ? "\n" : ""
                }), this._extScope = e, this._scope = new n.Scope({
                    parent: e
                }), this._nodes = [
                    new x
                ];
            }
            return Do(r, [
                {
                    key: "toString",
                    value: function() {
                        return this._root.render(this.opts);
                    }
                },
                {
                    key: "name",
                    value: function(e) {
                        return this._scope.name(e);
                    }
                },
                {
                    key: "scopeName",
                    value: function(e) {
                        return this._extScope.name(e);
                    }
                },
                {
                    key: "scopeValue",
                    value: function(e, t) {
                        var n = this._extScope.value(e, t);
                        return (this._values[n.prefix] || (this._values[n.prefix] = new Set)).add(n), n;
                    }
                },
                {
                    key: "getScopeValue",
                    value: function(e, t) {
                        return this._extScope.getValue(e, t);
                    }
                },
                {
                    key: "scopeRefs",
                    value: function(e) {
                        return this._extScope.scopeRefs(e, this._values);
                    }
                },
                {
                    key: "scopeCode",
                    value: function() {
                        return this._extScope.scopeCode(this._values);
                    }
                },
                {
                    key: "_def",
                    value: function(e, t, n, r) {
                        var o = this._scope.toName(t);
                        return void 0 !== n && r && (this._constants[o.str] = n), this._leafNode(new a(e, o, n)), o;
                    }
                },
                {
                    key: "const",
                    value: function(e, t, r) {
                        return this._def(n.varKinds.const, e, t, r);
                    }
                },
                {
                    key: "let",
                    value: function(e, t, r) {
                        return this._def(n.varKinds.let, e, t, r);
                    }
                },
                {
                    key: "var",
                    value: function(e, t, r) {
                        return this._def(n.varKinds.var, e, t, r);
                    }
                },
                {
                    key: "assign",
                    value: function(e, t, n) {
                        return this._leafNode(new h(e, t, n));
                    }
                },
                {
                    key: "add",
                    value: function(t, n) {
                        return this._leafNode(new v(t, e.operators.ADD, n));
                    }
                },
                {
                    key: "code",
                    value: function(e) {
                        return "function" == typeof e ? e() : e !== t.nil && this._leafNode(new y(e)), this;
                    }
                },
                {
                    key: "object",
                    value: function() {
                        for(var e = [
                            "{"
                        ], n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                        for(var i = 0, a = r; i < a.length; i++){
                            var s = jo(a[i], 2), c = s[0], l = s[1];
                            e.length > 1 && e.push(","), e.push(c), (c !== l || this.opts.es5) && (e.push(":"), (0, t.addCodeArg)(e, l));
                        }
                        return e.push("}"), new t._Code(e);
                    }
                },
                {
                    key: "if",
                    value: function(e, t, n) {
                        if (this._blockNode(new j(e)), t && n) this.code(t).else().code(n).endIf();
                        else if (t) this.code(t).endIf();
                        else if (n) throw new Error('CodeGen: "else" body without "then" body');
                        return this;
                    }
                },
                {
                    key: "elseIf",
                    value: function(e) {
                        return this._elseNode(new j(e));
                    }
                },
                {
                    key: "else",
                    value: function() {
                        return this._elseNode(new k);
                    }
                },
                {
                    key: "endIf",
                    value: function() {
                        return this._endBlockNode(j, k);
                    }
                },
                {
                    key: "_for",
                    value: function(e, t) {
                        return this._blockNode(e), t && this.code(t).endFor(), this;
                    }
                },
                {
                    key: "for",
                    value: function(e, t) {
                        return this._for(new C(e), t);
                    }
                },
                {
                    key: "forRange",
                    value: function(e, t, r, o) {
                        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.opts.es5 ? n.varKinds.var : n.varKinds.let, a = this._scope.toName(e);
                        return this._for(new $(i, a, t, r), function() {
                            return o(a);
                        });
                    }
                },
                {
                    key: "forOf",
                    value: function(e, r, o) {
                        var i = this, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n.varKinds.const, l = this._scope.toName(e);
                        if (this.opts.es5) {
                            var u = r instanceof t.Name ? r : this.var("_arr", r);
                            return this.forRange("_i", 0, (0, t._)(s || (s = mo([
                                "",
                                ".length"
                            ])), u), function(e) {
                                i.var(l, (0, t._)(c || (c = mo([
                                    "",
                                    "[",
                                    "]"
                                ])), u, e)), o(l);
                            });
                        }
                        return this._for(new _("of", a, l, r), function() {
                            return o(l);
                        });
                    }
                },
                {
                    key: "forIn",
                    value: function(e, r, o) {
                        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.es5 ? n.varKinds.var : n.varKinds.const;
                        if (this.opts.ownProperties) return this.forOf(e, (0, t._)(l || (l = mo([
                            "Object.keys(",
                            ")"
                        ])), r), o);
                        var a = this._scope.toName(e);
                        return this._for(new _("in", i, a, r), function() {
                            return o(a);
                        });
                    }
                },
                {
                    key: "endFor",
                    value: function() {
                        return this._endBlockNode(S);
                    }
                },
                {
                    key: "label",
                    value: function(e) {
                        return this._leafNode(new p(e));
                    }
                },
                {
                    key: "break",
                    value: function(e) {
                        return this._leafNode(new m(e));
                    }
                },
                {
                    key: "return",
                    value: function(e) {
                        var t = new M;
                        if (this._blockNode(t), this.code(e), 1 !== t.nodes.length) throw new Error('CodeGen: "return" should have one node');
                        return this._endBlockNode(M);
                    }
                },
                {
                    key: "try",
                    value: function(e, t, n) {
                        if (!t && !n) throw new Error('CodeGen: "try" without "catch" and "finally"');
                        var r = new E;
                        if (this._blockNode(r), this.code(e), t) {
                            var o = this.name("e");
                            this._currNode = r.catch = new A(o), t(o);
                        }
                        return n && (this._currNode = r.finally = new P, this.code(n)), this._endBlockNode(A, P);
                    }
                },
                {
                    key: "throw",
                    value: function(e) {
                        return this._leafNode(new g(e));
                    }
                },
                {
                    key: "block",
                    value: function(e, t) {
                        return this._blockStarts.push(this._nodes.length), e && this.code(e).endBlock(t), this;
                    }
                },
                {
                    key: "endBlock",
                    value: function(e) {
                        var t = this._blockStarts.pop();
                        if (void 0 === t) throw new Error("CodeGen: not in self-balancing block");
                        var n = this._nodes.length - t;
                        if (n < 0 || void 0 !== e && n !== e) throw new Error("CodeGen: wrong number of nodes: ".concat(n, " vs ").concat(e, " expected"));
                        return this._nodes.length = t, this;
                    }
                },
                {
                    key: "func",
                    value: function(e) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.nil, r = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0;
                        return this._blockNode(new O(e, n, r)), o && this.code(o).endFunc(), this;
                    }
                },
                {
                    key: "endFunc",
                    value: function() {
                        return this._endBlockNode(O);
                    }
                },
                {
                    key: "optimize",
                    value: function() {
                        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1; e-- > 0;)this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
                    }
                },
                {
                    key: "_leafNode",
                    value: function(e) {
                        return this._currNode.nodes.push(e), this;
                    }
                },
                {
                    key: "_blockNode",
                    value: function(e) {
                        this._currNode.nodes.push(e), this._nodes.push(e);
                    }
                },
                {
                    key: "_endBlockNode",
                    value: function(e, t) {
                        var n = this._currNode;
                        if (n instanceof e || t && n instanceof t) return this._nodes.pop(), this;
                        throw new Error('CodeGen: not in block "'.concat(t ? "".concat(e.kind, "/").concat(t.kind) : e.kind, '"'));
                    }
                },
                {
                    key: "_elseNode",
                    value: function(e) {
                        var t = this._currNode;
                        if (!(t instanceof j)) throw new Error('CodeGen: "else" without "if"');
                        return this._currNode = t.else = e, this;
                    }
                },
                {
                    key: "_root",
                    get: function() {
                        return this._nodes[0];
                    }
                },
                {
                    key: "_currNode",
                    get: function() {
                        var e = this._nodes;
                        return e[e.length - 1];
                    },
                    set: function(e) {
                        var t = this._nodes;
                        t[t.length - 1] = e;
                    }
                }
            ]), r;
        }();
        function R(e, t) {
            for(var n in t)e[n] = (e[n] || 0) + (t[n] || 0);
            return e;
        }
        function N(e, n) {
            return n instanceof t._CodeOrName ? R(e, n.names) : e;
        }
        function I(e, n, r) {
            var o;
            return e instanceof t.Name ? i(e) : (o = e) instanceof t._Code && o._items.some(function(e) {
                return e instanceof t.Name && 1 === n[e.str] && void 0 !== r[e.str];
            }) ? new t._Code(e._items.reduce(function(e, n) {
                return n instanceof t.Name && (n = i(n)), n instanceof t._Code ? e.push.apply(e, Bo(n._items)) : e.push(n), e;
            }, [])) : e;
            function i(e) {
                var t = r[e.str];
                return void 0 === t || 1 !== n[e.str] ? e : (delete n[e.str], t);
            }
        }
        function D(e, t) {
            for(var n in t)e[n] = (e[n] || 0) - (t[n] || 0);
        }
        function z(e) {
            return "boolean" == typeof e || "number" == typeof e || null === e ? !e : (0, t._)(u || (u = mo([
                "!",
                ""
            ])), F(e));
        }
        e.CodeGen = T, e.not = z;
        var q = L(e.operators.AND);
        e.and = function() {
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            return t.reduce(q);
        };
        var B = L(e.operators.OR);
        function L(e) {
            return function(n, r) {
                return n === t.nil ? r : r === t.nil ? n : (0, t._)(f || (f = mo([
                    "",
                    " ",
                    " ",
                    ""
                ])), F(n), e, F(r));
            };
        }
        function F(e) {
            return e instanceof t.Name ? e : (0, t._)(d || (d = mo([
                "(",
                ")"
            ])), e);
        }
        e.or = function() {
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            return t.reduce(B);
        };
    }(Y6)), Y6;
}
var i8 = {};
!function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.checkStrictMode = e.getErrorPath = e.Type = e.useFunc = e.setEvaluated = e.evaluatedPropsToName = e.mergeEvaluated = e.eachItem = e.unescapeJsonPointer = e.escapeJsonPointer = e.escapeFragment = e.unescapeFragment = e.schemaRefOrVal = e.schemaHasRulesButRef = e.schemaHasRules = e.checkUnknownRules = e.alwaysValidSchema = e.toHash = void 0;
    var t = o8(), n = Z6();
    function r(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema, n = e.opts, r = e.self;
        if (n.strictSchema && "boolean" != typeof t) {
            var o = r.RULES.keywords;
            for(var i in t)o[i] || d(e, 'unknown keyword: "'.concat(i, '"'));
        }
    }
    function o(e, t) {
        if ("boolean" == typeof e) return !e;
        for(var n in e)if (t[n]) return !0;
        return !1;
    }
    function i(e) {
        return "number" == typeof e ? "".concat(e) : e.replace(/~/g, "~0").replace(/\//g, "~1");
    }
    function a(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
    }
    function s(e) {
        var n = e.mergeNames, r = e.mergeToName, o = e.mergeValues, i = e.resultToName;
        return function(e, a, s, c) {
            var l = void 0 === s ? a : s instanceof t.Name ? (a instanceof t.Name ? n(e, a, s) : r(e, a, s), s) : a instanceof t.Name ? (r(e, s, a), a) : o(a, s);
            return c !== t.Name || l instanceof t.Name ? l : i(e, l);
        };
    }
    function c(e, n) {
        if (!0 === n) return e.var("props", !0);
        var r = e.var("props", (0, t._)(C || (C = mo([
            "{}"
        ]))));
        return void 0 !== n && l(e, r, n), r;
    }
    function l(e, n, r) {
        Object.keys(r).forEach(function(r) {
            return e.assign((0, t._)($ || ($ = mo([
                "",
                "",
                ""
            ])), n, (0, t.getProperty)(r)), !0);
        });
    }
    e.toHash = function(e) {
        var t, n = {}, r = bo(e);
        try {
            for(r.s(); !(t = r.n()).done;)n[t.value] = !0;
        } catch (e) {
            r.e(e);
        } finally{
            r.f();
        }
        return n;
    }, e.alwaysValidSchema = function(e, t) {
        return "boolean" == typeof t ? t : 0 === Object.keys(t).length || (r(e, t), !o(t, e.self.RULES.all));
    }, e.checkUnknownRules = r, e.schemaHasRules = o, e.schemaHasRulesButRef = function(e, t) {
        if ("boolean" == typeof e) return !e;
        for(var n in e)if ("$ref" !== n && t.all[n]) return !0;
        return !1;
    }, e.schemaRefOrVal = function(e, n, r, o) {
        var i = e.topSchemaRef, a = e.schemaPath;
        if (!o) {
            if ("number" == typeof n || "boolean" == typeof n) return n;
            if ("string" == typeof n) return (0, t._)(h || (h = mo([
                "",
                ""
            ])), n);
        }
        return (0, t._)(v || (v = mo([
            "",
            "",
            "",
            ""
        ])), i, a, (0, t.getProperty)(r));
    }, e.unescapeFragment = function(e) {
        return a(decodeURIComponent(e));
    }, e.escapeFragment = function(e) {
        return encodeURIComponent(i(e));
    }, e.escapeJsonPointer = i, e.unescapeJsonPointer = a, e.eachItem = function(e, t) {
        if (Array.isArray(e)) {
            var n, r = bo(e);
            try {
                for(r.s(); !(n = r.n()).done;)t(n.value);
            } catch (e) {
                r.e(e);
            } finally{
                r.f();
            }
        } else t(e);
    }, e.mergeEvaluated = {
        props: s({
            mergeNames: function(e, n, r) {
                return e.if((0, t._)(p || (p = mo([
                    "",
                    " !== true && ",
                    " !== undefined"
                ])), r, n), function() {
                    e.if((0, t._)(m || (m = mo([
                        "",
                        " === true"
                    ])), n), function() {
                        return e.assign(r, !0);
                    }, function() {
                        return e.assign(r, (0, t._)(g || (g = mo([
                            "",
                            " || {}"
                        ])), r)).code((0, t._)(y || (y = mo([
                            "Object.assign(",
                            ", ",
                            ")"
                        ])), r, n));
                    });
                });
            },
            mergeToName: function(e, n, r) {
                return e.if((0, t._)(b || (b = mo([
                    "",
                    " !== true"
                ])), r), function() {
                    !0 === n ? e.assign(r, !0) : (e.assign(r, (0, t._)(w || (w = mo([
                        "",
                        " || {}"
                    ])), r)), l(e, r, n));
                });
            },
            mergeValues: function(e, t) {
                return !0 === e || Ro(Ro({}, e), t);
            },
            resultToName: c
        }),
        items: s({
            mergeNames: function(e, n, r) {
                return e.if((0, t._)(x || (x = mo([
                    "",
                    " !== true && ",
                    " !== undefined"
                ])), r, n), function() {
                    return e.assign(r, (0, t._)(k || (k = mo([
                        "",
                        " === true ? true : ",
                        " > ",
                        " ? ",
                        " : ",
                        ""
                    ])), n, r, n, r, n));
                });
            },
            mergeToName: function(e, n, r) {
                return e.if((0, t._)(j || (j = mo([
                    "",
                    " !== true"
                ])), r), function() {
                    return e.assign(r, !0 === n || (0, t._)(S || (S = mo([
                        "",
                        " > ",
                        " ? ",
                        " : ",
                        ""
                    ])), r, n, r, n));
                });
            },
            mergeValues: function(e, t) {
                return !0 === e || Math.max(e, t);
            },
            resultToName: function(e, t) {
                return e.var("items", t);
            }
        })
    }, e.evaluatedPropsToName = c, e.setEvaluated = l;
    var u, f = {};
    function d(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.opts.strictSchema;
        if (n) {
            if (t = "strict mode: ".concat(t), !0 === n) throw new Error(t);
            e.self.logger.warn(t);
        }
    }
    e.useFunc = function(e, t) {
        return e.scopeValue("func", {
            ref: t,
            code: f[t.code] || (f[t.code] = new n._Code(t.code))
        });
    }, function(e) {
        e[e.Num = 0] = "Num", e[e.Str = 1] = "Str";
    }(u = e.Type || (e.Type = {})), e.getErrorPath = function(e, n, r) {
        if (e instanceof t.Name) {
            var o = n === u.Num;
            return r ? o ? (0, t._)(_ || (_ = mo([
                '"[" + ',
                ' + "]"'
            ])), e) : (0, t._)(O || (O = mo([
                '"[\'" + ',
                ' + "\']"'
            ])), e) : o ? (0, t._)(M || (M = mo([
                '"/" + ',
                ""
            ])), e) : (0, t._)(E || (E = mo([
                '"/" + ',
                '.replace(/~/g, "~0").replace(/\\//g, "~1")'
            ], [
                '"/" + ',
                '.replace(/~/g, "~0").replace(/\\\\//g, "~1")'
            ])), e);
        }
        return r ? (0, t.getProperty)(e).toString() : "/" + i(e);
    }, e.checkStrictMode = d;
}(i8);
var a8, s8, c8, l8 = {};
function u8() {
    if (a8) return l8;
    a8 = 1, Object.defineProperty(l8, "__esModule", {
        value: !0
    });
    var e = o8(), t = {
        data: new e.Name("data"),
        valCxt: new e.Name("valCxt"),
        instancePath: new e.Name("instancePath"),
        parentData: new e.Name("parentData"),
        parentDataProperty: new e.Name("parentDataProperty"),
        rootData: new e.Name("rootData"),
        dynamicAnchors: new e.Name("dynamicAnchors"),
        vErrors: new e.Name("vErrors"),
        errors: new e.Name("errors"),
        this: new e.Name("this"),
        self: new e.Name("self"),
        scope: new e.Name("scope"),
        json: new e.Name("json"),
        jsonPos: new e.Name("jsonPos"),
        jsonLen: new e.Name("jsonLen"),
        jsonPart: new e.Name("jsonPart")
    };
    return l8.default = t, l8;
}
function f8() {
    return s8 || (s8 = 1, function(e) {
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.extendErrors = e.resetErrorsCount = e.reportExtraError = e.reportError = e.keyword$DataError = e.keywordError = void 0;
        var t = o8(), n = i8, r = u8();
        function o(e, n) {
            var o = e.const("err", n);
            e.if((0, t._)(H || (H = mo([
                "",
                " === null"
            ])), r.default.vErrors), function() {
                return e.assign(r.default.vErrors, (0, t._)(W || (W = mo([
                    "[",
                    "]"
                ])), o));
            }, (0, t._)(U || (U = mo([
                "",
                ".push(",
                ")"
            ])), r.default.vErrors, o)), e.code((0, t._)(J || (J = mo([
                "",
                "++"
            ])), r.default.errors));
        }
        function i(e, n) {
            var r = e.gen, o = e.validateName;
            e.schemaEnv.$async ? r.throw((0, t._)(K || (K = mo([
                "new ",
                "(",
                ")"
            ])), e.ValidationError, n)) : (r.assign((0, t._)(G || (G = mo([
                "",
                ".errors"
            ])), o), n), r.return(!1));
        }
        e.keywordError = {
            message: function(e) {
                var n = e.keyword;
                return (0, t.str)(A || (A = mo([
                    'must pass "',
                    '" keyword validation'
                ])), n);
            }
        }, e.keyword$DataError = {
            message: function(e) {
                var n = e.keyword, r = e.schemaType;
                return r ? (0, t.str)(P || (P = mo([
                    '"',
                    '" keyword must be ',
                    " ($data)"
                ])), n, r) : (0, t.str)(T || (T = mo([
                    '"',
                    '" keyword is invalid ($data)'
                ])), n);
            }
        }, e.reportError = function(n) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.keywordError, a = arguments.length > 2 ? arguments[2] : void 0, c = arguments.length > 3 ? arguments[3] : void 0, l = n.it, u = l.gen, f = l.compositeRule, d = l.allErrors, h = s(n, r, a);
            (null != c ? c : f || d) ? o(u, h) : i(l, (0, t._)(R || (R = mo([
                "[",
                "]"
            ])), h));
        }, e.reportExtraError = function(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.keywordError, a = arguments.length > 2 ? arguments[2] : void 0, c = t.it, l = c.gen, u = c.compositeRule, f = c.allErrors;
            o(l, s(t, n, a)), u || f || i(c, r.default.vErrors);
        }, e.resetErrorsCount = function(e, n) {
            e.assign(r.default.errors, n), e.if((0, t._)(N || (N = mo([
                "",
                " !== null"
            ])), r.default.vErrors), function() {
                return e.if(n, function() {
                    return e.assign((0, t._)(I || (I = mo([
                        "",
                        ".length"
                    ])), r.default.vErrors), n);
                }, function() {
                    return e.assign(r.default.vErrors, null);
                });
            });
        }, e.extendErrors = function(e) {
            var n = e.gen, o = e.keyword, i = e.schemaValue, a = e.data, s = e.errsCount, c = e.it;
            if (void 0 === s) throw new Error("ajv implementation error");
            var l = n.name("err");
            n.forRange("i", s, r.default.errors, function(e) {
                n.const(l, (0, t._)(D || (D = mo([
                    "",
                    "[",
                    "]"
                ])), r.default.vErrors, e)), n.if((0, t._)(z || (z = mo([
                    "",
                    ".instancePath === undefined"
                ])), l), function() {
                    return n.assign((0, t._)(q || (q = mo([
                        "",
                        ".instancePath"
                    ])), l), (0, t.strConcat)(r.default.instancePath, c.errorPath));
                }), n.assign((0, t._)(B || (B = mo([
                    "",
                    ".schemaPath"
                ])), l), (0, t.str)(L || (L = mo([
                    "",
                    "/",
                    ""
                ])), c.errSchemaPath, o)), c.opts.verbose && (n.assign((0, t._)(F || (F = mo([
                    "",
                    ".schema"
                ])), l), i), n.assign((0, t._)(V || (V = mo([
                    "",
                    ".data"
                ])), l), a));
            });
        };
        var a = {
            keyword: new t.Name("keyword"),
            schemaPath: new t.Name("schemaPath"),
            params: new t.Name("params"),
            propertyName: new t.Name("propertyName"),
            message: new t.Name("message"),
            schema: new t.Name("schema"),
            parentSchema: new t.Name("parentSchema")
        };
        function s(e, n, o) {
            return !1 === e.it.createErrors ? (0, t._)(Q || (Q = mo([
                "{}"
            ]))) : function(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = e.gen, s = e.it, u = [
                    c(s, o),
                    l(e, o)
                ];
                return function(e, n, o) {
                    var i = n.params, s = n.message, c = e.keyword, l = e.data, u = e.schemaValue, f = e.it, d = f.opts, h = f.propertyName, v = f.topSchemaRef, p = f.schemaPath;
                    o.push([
                        a.keyword,
                        c
                    ], [
                        a.params,
                        "function" == typeof i ? i(e) : i || (0, t._)(ee || (ee = mo([
                            "{}"
                        ])))
                    ]), d.messages && o.push([
                        a.message,
                        "function" == typeof s ? s(e) : s
                    ]);
                    d.verbose && o.push([
                        a.schema,
                        u
                    ], [
                        a.parentSchema,
                        (0, t._)(te || (te = mo([
                            "",
                            "",
                            ""
                        ])), v, p)
                    ], [
                        r.default.data,
                        l
                    ]);
                    h && o.push([
                        a.propertyName,
                        h
                    ]);
                }(e, n, u), i.object.apply(i, u);
            }(e, n, o);
        }
        function c(e, o) {
            var i = e.errorPath, a = o.instancePath, s = a ? (0, t.str)(Y || (Y = mo([
                "",
                "",
                ""
            ])), i, (0, n.getErrorPath)(a, n.Type.Str)) : i;
            return [
                r.default.instancePath,
                (0, t.strConcat)(r.default.instancePath, s)
            ];
        }
        function l(e, r) {
            var o = e.keyword, i = e.it.errSchemaPath, s = r.schemaPath, c = r.parentSchema ? i : (0, t.str)(X || (X = mo([
                "",
                "/",
                ""
            ])), i, o);
            return s && (c = (0, t.str)(Z || (Z = mo([
                "",
                "",
                ""
            ])), c, (0, n.getErrorPath)(s, n.Type.Str))), [
                a.schemaPath,
                c
            ];
        }
    }(Q6)), Q6;
}
var d8 = {}, h8 = {};
Object.defineProperty(h8, "__esModule", {
    value: !0
}), h8.getRules = h8.isJSONType = void 0;
var v8 = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
]);
h8.isJSONType = function(e) {
    return "string" == typeof e && v8.has(e);
}, h8.getRules = function() {
    var e = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: Ro(Ro({}, e), {}, {
            integer: !0,
            boolean: !0,
            null: !0
        }),
        rules: [
            {
                rules: []
            },
            e.number,
            e.string,
            e.array,
            e.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
};
var p8, m8 = {};
function g8() {
    if (p8) return m8;
    function e(e, n) {
        return n.rules.some(function(n) {
            return t(e, n);
        });
    }
    function t(e, t) {
        var n;
        return void 0 !== e[t.keyword] || (null === (n = t.definition.implements) || void 0 === n ? void 0 : n.some(function(t) {
            return void 0 !== e[t];
        }));
    }
    return p8 = 1, Object.defineProperty(m8, "__esModule", {
        value: !0
    }), m8.shouldUseRule = m8.shouldUseGroup = m8.schemaHasRulesForType = void 0, m8.schemaHasRulesForType = function(t, n) {
        var r = t.schema, o = t.self.RULES.types[n];
        return o && !0 !== o && e(r, o);
    }, m8.shouldUseGroup = e, m8.shouldUseRule = t, m8;
}
!function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.reportTypeError = e.checkDataTypes = e.checkDataType = e.coerceAndCheckDataType = e.getJSONTypes = e.getSchemaTypes = e.DataType = void 0;
    var t, n = h8, r = g8(), o = f8(), i = o8(), a = i8;
    function s(e) {
        var t = Array.isArray(e) ? e : e ? [
            e
        ] : [];
        if (t.every(n.isJSONType)) return t;
        throw new Error("type must be JSONType or JSONType[]: " + t.join(","));
    }
    !function(e) {
        e[e.Correct = 0] = "Correct", e[e.Wrong = 1] = "Wrong";
    }(t = e.DataType || (e.DataType = {})), e.getSchemaTypes = function(e) {
        var t = s(e.type);
        if (t.includes("null")) {
            if (!1 === e.nullable) throw new Error("type: null contradicts nullable: false");
        } else {
            if (!t.length && void 0 !== e.nullable) throw new Error('"nullable" cannot be used without "type"');
            !0 === e.nullable && t.push("null");
        }
        return t;
    }, e.getJSONTypes = s, e.coerceAndCheckDataType = function(e, n) {
        var o = e.gen, a = e.data, s = e.opts, l = function(e, t) {
            return t ? e.filter(function(e) {
                return c.has(e) || "array" === t && "array" === e;
            }) : [];
        }(n, s.coerceTypes), f = n.length > 0 && !(0 === l.length && 1 === n.length && (0, r.schemaHasRulesForType)(e, n[0]));
        if (f) {
            var h = u(n, a, s.strictNumbers, t.Wrong);
            o.if(h, function() {
                l.length ? function(e, t, n) {
                    var r = e.gen, o = e.data, a = e.opts, s = r.let("dataType", (0, i._)(re || (re = mo([
                        "typeof ",
                        ""
                    ])), o)), l = r.let("coerced", (0, i._)(oe || (oe = mo([
                        "undefined"
                    ]))));
                    "array" === a.coerceTypes && r.if((0, i._)(ie || (ie = mo([
                        "",
                        " == 'object' && Array.isArray(",
                        ") && ",
                        ".length == 1"
                    ])), s, o, o), function() {
                        return r.assign(o, (0, i._)(ae || (ae = mo([
                            "",
                            "[0]"
                        ])), o)).assign(s, (0, i._)(se || (se = mo([
                            "typeof ",
                            ""
                        ])), o)).if(u(t, o, a.strictNumbers), function() {
                            return r.assign(l, o);
                        });
                    });
                    r.if((0, i._)(ce || (ce = mo([
                        "",
                        " !== undefined"
                    ])), l));
                    var f, h = bo(n);
                    try {
                        for(h.s(); !(f = h.n()).done;){
                            var v = f.value;
                            (c.has(v) || "array" === v && "array" === a.coerceTypes) && p(v);
                        }
                    } catch (e) {
                        h.e(e);
                    } finally{
                        h.f();
                    }
                    function p(e) {
                        switch(e){
                            case "string":
                                return void r.elseIf((0, i._)(ue || (ue = mo([
                                    "",
                                    ' == "number" || ',
                                    ' == "boolean"'
                                ])), s, s)).assign(l, (0, i._)(fe || (fe = mo([
                                    '"" + ',
                                    ""
                                ])), o)).elseIf((0, i._)(de || (de = mo([
                                    "",
                                    " === null"
                                ])), o)).assign(l, (0, i._)(he || (he = mo([
                                    '""'
                                ]))));
                            case "number":
                                return void r.elseIf((0, i._)(ve || (ve = mo([
                                    "",
                                    ' == "boolean" || ',
                                    " === null\n              || (",
                                    ' == "string" && ',
                                    " && ",
                                    " == +",
                                    ")"
                                ])), s, o, s, o, o, o)).assign(l, (0, i._)(pe || (pe = mo([
                                    "+",
                                    ""
                                ])), o));
                            case "integer":
                                return void r.elseIf((0, i._)(me || (me = mo([
                                    "",
                                    ' === "boolean" || ',
                                    " === null\n              || (",
                                    ' === "string" && ',
                                    " && ",
                                    " == +",
                                    " && !(",
                                    " % 1))"
                                ])), s, o, s, o, o, o, o)).assign(l, (0, i._)(ge || (ge = mo([
                                    "+",
                                    ""
                                ])), o));
                            case "boolean":
                                return void r.elseIf((0, i._)(ye || (ye = mo([
                                    "",
                                    ' === "false" || ',
                                    " === 0 || ",
                                    " === null"
                                ])), o, o, o)).assign(l, !1).elseIf((0, i._)(be || (be = mo([
                                    "",
                                    ' === "true" || ',
                                    " === 1"
                                ])), o, o)).assign(l, !0);
                            case "null":
                                return r.elseIf((0, i._)(we || (we = mo([
                                    "",
                                    ' === "" || ',
                                    " === 0 || ",
                                    " === false"
                                ])), o, o, o)), void r.assign(l, null);
                            case "array":
                                r.elseIf((0, i._)(xe || (xe = mo([
                                    "",
                                    ' === "string" || ',
                                    ' === "number"\n              || ',
                                    ' === "boolean" || ',
                                    " === null"
                                ])), s, s, s, o)).assign(l, (0, i._)(ke || (ke = mo([
                                    "[",
                                    "]"
                                ])), o));
                        }
                    }
                    r.else(), d(e), r.endIf(), r.if((0, i._)(le || (le = mo([
                        "",
                        " !== undefined"
                    ])), l), function() {
                        r.assign(o, l), function(e, t) {
                            var n = e.gen, r = e.parentData, o = e.parentDataProperty;
                            n.if((0, i._)(je || (je = mo([
                                "",
                                " !== undefined"
                            ])), r), function() {
                                return n.assign((0, i._)(Se || (Se = mo([
                                    "",
                                    "[",
                                    "]"
                                ])), r, o), t);
                            });
                        }(e, l);
                    });
                }(e, n, l) : d(e);
            });
        }
        return f;
    };
    var c = new Set([
        "string",
        "number",
        "integer",
        "boolean",
        "null"
    ]);
    function l(e, n, r) {
        var o, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.Correct, s = a === t.Correct ? i.operators.EQ : i.operators.NEQ;
        switch(e){
            case "null":
                return (0, i._)(Ce || (Ce = mo([
                    "",
                    " ",
                    " null"
                ])), n, s);
            case "array":
                o = (0, i._)($e || ($e = mo([
                    "Array.isArray(",
                    ")"
                ])), n);
                break;
            case "object":
                o = (0, i._)(_e || (_e = mo([
                    "",
                    " && typeof ",
                    ' == "object" && !Array.isArray(',
                    ")"
                ])), n, n, n);
                break;
            case "integer":
                o = c((0, i._)(Oe || (Oe = mo([
                    "!(",
                    " % 1) && !isNaN(",
                    ")"
                ])), n, n));
                break;
            case "number":
                o = c();
                break;
            default:
                return (0, i._)(Me || (Me = mo([
                    "typeof ",
                    " ",
                    " ",
                    ""
                ])), n, s, e);
        }
        return a === t.Correct ? o : (0, i.not)(o);
        function c() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.nil;
            return (0, i.and)((0, i._)(Ee || (Ee = mo([
                "typeof ",
                ' == "number"'
            ])), n), e, r ? (0, i._)(Ae || (Ae = mo([
                "isFinite(",
                ")"
            ])), n) : i.nil);
        }
    }
    function u(e, t, n, r) {
        if (1 === e.length) return l(e[0], t, n, r);
        var o, s = (0, a.toHash)(e);
        if (s.array && s.object) {
            var c = (0, i._)(Pe || (Pe = mo([
                "typeof ",
                ' != "object"'
            ])), t);
            o = s.null ? c : (0, i._)(Te || (Te = mo([
                "!",
                " || ",
                ""
            ])), t, c), delete s.null, delete s.array, delete s.object;
        } else o = i.nil;
        for(var u in s.number && delete s.integer, s)o = (0, i.and)(o, l(u, t, n, r));
        return o;
    }
    e.checkDataType = l, e.checkDataTypes = u;
    var f = {
        message: function(e) {
            var t = e.schema;
            return "must be ".concat(t);
        },
        params: function(e) {
            var t = e.schema, n = e.schemaValue;
            return "string" == typeof t ? (0, i._)(Re || (Re = mo([
                "{type: ",
                "}"
            ])), t) : (0, i._)(Ne || (Ne = mo([
                "{type: ",
                "}"
            ])), n);
        }
    };
    function d(e) {
        var t = function(e) {
            var t = e.gen, n = e.data, r = e.schema, o = (0, a.schemaRefOrVal)(e, r, "type");
            return {
                gen: t,
                keyword: "type",
                data: n,
                schema: r.type,
                schemaCode: o,
                schemaValue: o,
                parentSchema: r,
                params: {},
                it: e
            };
        }(e);
        (0, o.reportError)(t, f);
    }
    e.reportTypeError = d;
}(d8);
var y8, b8 = {};
var w8, x8, k8 = {}, j8 = {};
function S8() {
    if (w8) return j8;
    w8 = 1, Object.defineProperty(j8, "__esModule", {
        value: !0
    }), j8.validateUnion = j8.validateArray = j8.usePattern = j8.callValidateCode = j8.schemaProperties = j8.allSchemaProperties = j8.noPropertyInData = j8.propertyInData = j8.isOwnProperty = j8.hasPropFunc = j8.reportMissingProp = j8.checkMissingProp = j8.checkReportMissingProp = void 0;
    var e = o8(), t = i8, n = u8(), r = i8;
    function o(t) {
        return t.scopeValue("func", {
            ref: Object.prototype.hasOwnProperty,
            code: (0, e._)(Fe || (Fe = mo([
                "Object.prototype.hasOwnProperty"
            ])))
        });
    }
    function i(t, n, r) {
        return (0, e._)(Ve || (Ve = mo([
            "",
            ".call(",
            ", ",
            ")"
        ])), o(t), n, r);
    }
    function a(t, n, r, o) {
        var a = (0, e._)(Ue || (Ue = mo([
            "",
            "",
            " === undefined"
        ])), n, (0, e.getProperty)(r));
        return o ? (0, e.or)(a, (0, e.not)(i(t, n, r))) : a;
    }
    function s(e) {
        return e ? Object.keys(e).filter(function(e) {
            return "__proto__" !== e;
        }) : [];
    }
    j8.checkReportMissingProp = function(t, n) {
        var r = t.gen, o = t.data, i = t.it;
        r.if(a(r, o, n, i.opts.ownProperties), function() {
            t.setParams({
                missingProperty: (0, e._)(Be || (Be = mo([
                    "",
                    ""
                ])), n)
            }, !0), t.error();
        });
    }, j8.checkMissingProp = function(t, n, r) {
        var o = t.gen, i = t.data, s = t.it.opts;
        return e.or.apply(void 0, Bo(n.map(function(t) {
            return (0, e.and)(a(o, i, t, s.ownProperties), (0, e._)(Le || (Le = mo([
                "",
                " = ",
                ""
            ])), r, t));
        })));
    }, j8.reportMissingProp = function(e, t) {
        e.setParams({
            missingProperty: t
        }, !0), e.error();
    }, j8.hasPropFunc = o, j8.isOwnProperty = i, j8.propertyInData = function(t, n, r, o) {
        var a = (0, e._)(He || (He = mo([
            "",
            "",
            " !== undefined"
        ])), n, (0, e.getProperty)(r));
        return o ? (0, e._)(We || (We = mo([
            "",
            " && ",
            ""
        ])), a, i(t, n, r)) : a;
    }, j8.noPropertyInData = a, j8.allSchemaProperties = s, j8.schemaProperties = function(e, n) {
        return s(n).filter(function(r) {
            return !(0, t.alwaysValidSchema)(e, n[r]);
        });
    }, j8.callValidateCode = function(t, r, o, i) {
        var a = t.schemaCode, s = t.data, c = t.it, l = c.gen, u = c.topSchemaRef, f = c.schemaPath, d = c.errorPath, h = t.it, v = i ? (0, e._)(Je || (Je = mo([
            "",
            ", ",
            ", ",
            "",
            ""
        ])), a, s, u, f) : s, p = [
            [
                n.default.instancePath,
                (0, e.strConcat)(n.default.instancePath, d)
            ],
            [
                n.default.parentData,
                h.parentData
            ],
            [
                n.default.parentDataProperty,
                h.parentDataProperty
            ],
            [
                n.default.rootData,
                n.default.rootData
            ]
        ];
        h.opts.dynamicRef && p.push([
            n.default.dynamicAnchors,
            n.default.dynamicAnchors
        ]);
        var m = (0, e._)(Ke || (Ke = mo([
            "",
            ", ",
            ""
        ])), v, l.object.apply(l, p));
        return o !== e.nil ? (0, e._)(Ge || (Ge = mo([
            "",
            ".call(",
            ", ",
            ")"
        ])), r, o, m) : (0, e._)(Qe || (Qe = mo([
            "",
            "(",
            ")"
        ])), r, m);
    };
    var c = (0, e._)(Ye || (Ye = mo([
        "new RegExp"
    ])));
    return j8.usePattern = function(t, n) {
        var o = t.gen, i = t.it.opts, a = i.unicodeRegExp ? "u" : "", s = i.code.regExp, l = s(n, a);
        return o.scopeValue("pattern", {
            key: l.toString(),
            ref: l,
            code: (0, e._)(Xe || (Xe = mo([
                "",
                "(",
                ", ",
                ")"
            ])), "new RegExp" === s.code ? c : (0, r.useFunc)(o, s), n, a)
        });
    }, j8.validateArray = function(n) {
        var r = n.gen, o = n.data, i = n.keyword, a = n.it, s = r.name("valid");
        if (a.allErrors) {
            var c = r.let("valid", !0);
            return l(function() {
                return r.assign(c, !1);
            }), c;
        }
        return r.var(s, !0), l(function() {
            return r.break();
        }), s;
        function l(a) {
            var c = r.const("len", (0, e._)(Ze || (Ze = mo([
                "",
                ".length"
            ])), o));
            r.forRange("i", 0, c, function(o) {
                n.subschema({
                    keyword: i,
                    dataProp: o,
                    dataPropType: t.Type.Num
                }, s), r.if((0, e.not)(s), a);
            });
        }
    }, j8.validateUnion = function(n) {
        var r = n.gen, o = n.schema, i = n.keyword, a = n.it;
        if (!Array.isArray(o)) throw new Error("ajv implementation error");
        if (!o.some(function(e) {
            return (0, t.alwaysValidSchema)(a, e);
        }) || a.opts.unevaluated) {
            var s = r.let("valid", !1), c = r.name("_valid");
            r.block(function() {
                return o.forEach(function(t, o) {
                    var a = n.subschema({
                        keyword: i,
                        schemaProp: o,
                        compositeRule: !0
                    }, c);
                    r.assign(s, (0, e._)(et || (et = mo([
                        "",
                        " || ",
                        ""
                    ])), s, c)), n.mergeValidEvaluated(a, c) || r.if((0, e.not)(s));
                });
            }), n.result(s, function() {
                return n.reset();
            }, function() {
                return n.error(!0);
            });
        }
    }, j8;
}
function C8() {
    if (x8) return k8;
    x8 = 1, Object.defineProperty(k8, "__esModule", {
        value: !0
    }), k8.validateKeywordUsage = k8.validSchemaType = k8.funcKeywordCode = k8.macroKeywordCode = void 0;
    var e = o8(), t = u8(), n = S8(), r = f8();
    function o(t) {
        var n = t.gen, r = t.data, o = t.it;
        n.if(o.parentData, function() {
            return n.assign(r, (0, e._)(st || (st = mo([
                "",
                "[",
                "]"
            ])), o.parentData, o.parentDataProperty));
        });
    }
    function i(t, n, r) {
        if (void 0 === r) throw new Error('keyword "'.concat(n, '" failed to compile'));
        return t.scopeValue("keyword", "function" == typeof r ? {
            ref: r
        } : {
            ref: r,
            code: (0, e.stringify)(r)
        });
    }
    return k8.macroKeywordCode = function(t, n) {
        var r = t.gen, o = t.keyword, a = t.schema, s = t.parentSchema, c = t.it, l = n.macro.call(c.self, a, s, c), u = i(r, o, l);
        !1 !== c.opts.validateSchema && c.self.validateSchema(l, !0);
        var f = r.name("valid");
        t.subschema({
            schema: l,
            schemaPath: e.nil,
            errSchemaPath: "".concat(c.errSchemaPath, "/").concat(o),
            topSchemaRef: u,
            compositeRule: !0
        }, f), t.pass(f, function() {
            return t.error(!0);
        });
    }, k8.funcKeywordCode = function(a, s) {
        var c, l = a.gen, u = a.keyword, f = a.schema, d = a.parentSchema, h = a.$data, v = a.it;
        !function(e, t) {
            var n = e.schemaEnv;
            if (t.async && !n.$async) throw new Error("async keyword in sync schema");
        }(v, s);
        var p = !h && s.compile ? s.compile.call(v.self, f, d, v) : s.validate, m = i(l, u, p), g = l.let("valid");
        function y() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s.async ? (0, e._)(it || (it = mo([
                "await "
            ]))) : e.nil, o = v.opts.passContext ? t.default.this : t.default.self, i = !("compile" in s && !h || !1 === s.schema);
            l.assign(g, (0, e._)(at || (at = mo([
                "",
                "",
                ""
            ])), r, (0, n.callValidateCode)(a, m, o, i)), s.modifying);
        }
        function b(t) {
            var n;
            l.if((0, e.not)(null !== (n = s.valid) && void 0 !== n ? n : g), t);
        }
        a.block$data(g, function() {
            if (!1 === s.errors) y(), s.modifying && o(a), b(function() {
                return a.error();
            });
            else {
                var n = s.async ? function() {
                    var t = l.let("ruleErrs", null);
                    return l.try(function() {
                        return y((0, e._)(tt || (tt = mo([
                            "await "
                        ]))));
                    }, function(n) {
                        return l.assign(g, !1).if((0, e._)(nt || (nt = mo([
                            "",
                            " instanceof ",
                            ""
                        ])), n, v.ValidationError), function() {
                            return l.assign(t, (0, e._)(rt || (rt = mo([
                                "",
                                ".errors"
                            ])), n));
                        }, function() {
                            return l.throw(n);
                        });
                    }), t;
                }() : (i = (0, e._)(ot || (ot = mo([
                    "",
                    ".errors"
                ])), m), l.assign(i, null), y(e.nil), i);
                s.modifying && o(a), b(function() {
                    return function(n, o) {
                        var i = n.gen;
                        i.if((0, e._)(ct || (ct = mo([
                            "Array.isArray(",
                            ")"
                        ])), o), function() {
                            i.assign(t.default.vErrors, (0, e._)(lt || (lt = mo([
                                "",
                                " === null ? ",
                                " : ",
                                ".concat(",
                                ")"
                            ])), t.default.vErrors, o, t.default.vErrors, o)).assign(t.default.errors, (0, e._)(ut || (ut = mo([
                                "",
                                ".length"
                            ])), t.default.vErrors)), (0, r.extendErrors)(n);
                        }, function() {
                            return n.error();
                        });
                    }(a, n);
                });
            }
            var i;
        }), a.ok(null !== (c = s.valid) && void 0 !== c ? c : g);
    }, k8.validSchemaType = function(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return !t.length || t.some(function(t) {
            return "array" === t ? Array.isArray(e) : "object" === t ? e && "object" == Ho(e) && !Array.isArray(e) : Ho(e) == t || n && void 0 === e;
        });
    }, k8.validateKeywordUsage = function(e, t, n) {
        var r = e.schema, o = e.opts, i = e.self, a = e.errSchemaPath;
        if (Array.isArray(t.keyword) ? !t.keyword.includes(n) : t.keyword !== n) throw new Error("ajv implementation error");
        var s = t.dependencies;
        if (null == s ? void 0 : s.some(function(e) {
            return !Object.prototype.hasOwnProperty.call(r, e);
        })) throw new Error("parent schema must have dependencies of ".concat(n, ": ").concat(s.join(",")));
        if (t.validateSchema && !t.validateSchema(r[n])) {
            var c = 'keyword "'.concat(n, '" value is invalid at path "').concat(a, '": ') + i.errorsText(t.validateSchema.errors);
            if ("log" !== o.validateSchema) throw new Error(c);
            i.logger.error(c);
        }
    }, k8;
}
var $8, _8 = {};
var O8 = {}, M8 = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == Ho(t) && "object" == Ho(n)) {
        if (t.constructor !== n.constructor) return !1;
        var r, o, i;
        if (Array.isArray(t)) {
            if ((r = t.length) != n.length) return !1;
            for(o = r; 0 != o--;)if (!e(t[o], n[o])) return !1;
            return !0;
        }
        if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
        if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
        if ((r = (i = Object.keys(t)).length) !== Object.keys(n).length) return !1;
        for(o = r; 0 != o--;)if (!Object.prototype.hasOwnProperty.call(n, i[o])) return !1;
        for(o = r; 0 != o--;){
            var a = i[o];
            if (!e(t[a], n[a])) return !1;
        }
        return !0;
    }
    return t != t && n != n;
}, E8 = {
    exports: {}
}, A8 = E8.exports = function(e, t, n) {
    "function" == typeof t && (n = t, t = {}), P8(t, "function" == typeof (n = t.cb || n) ? n : n.pre || function() {}, n.post || function() {}, e, "", e);
};
function P8(e, t, n, r, o, i, a, s, c, l) {
    if (r && "object" == Ho(r) && !Array.isArray(r)) {
        for(var u in t(r, o, i, a, s, c, l), r){
            var f = r[u];
            if (Array.isArray(f)) {
                if (u in A8.arrayKeywords) for(var d = 0; d < f.length; d++)P8(e, t, n, f[d], o + "/" + u + "/" + d, i, o, u, r, d);
            } else if (u in A8.propsKeywords) {
                if (f && "object" == Ho(f)) for(var h in f)P8(e, t, n, f[h], o + "/" + u + "/" + h.replace(/~/g, "~0").replace(/\//g, "~1"), i, o, u, r, h);
            } else (u in A8.keywords || e.allKeys && !(u in A8.skipKeywords)) && P8(e, t, n, f, o + "/" + u, i, o, u, r);
        }
        n(r, o, i, a, s, c, l);
    }
}
A8.keywords = {
    additionalItems: !0,
    items: !0,
    contains: !0,
    additionalProperties: !0,
    propertyNames: !0,
    not: !0,
    if: !0,
    then: !0,
    else: !0
}, A8.arrayKeywords = {
    items: !0,
    allOf: !0,
    anyOf: !0,
    oneOf: !0
}, A8.propsKeywords = {
    $defs: !0,
    definitions: !0,
    properties: !0,
    patternProperties: !0,
    dependencies: !0
}, A8.skipKeywords = {
    default: !0,
    enum: !0,
    const: !0,
    required: !0,
    maximum: !0,
    minimum: !0,
    exclusiveMaximum: !0,
    exclusiveMinimum: !0,
    multipleOf: !0,
    maxLength: !0,
    minLength: !0,
    pattern: !0,
    format: !0,
    maxItems: !0,
    minItems: !0,
    uniqueItems: !0,
    maxProperties: !0,
    minProperties: !0
};
var T8 = E8.exports;
Object.defineProperty(O8, "__esModule", {
    value: !0
}), O8.getSchemaRefs = O8.resolveUrl = O8.normalizeId = O8._getFullPath = O8.getFullPath = O8.inlineRef = void 0;
var R8 = i8, N8 = M8, I8 = T8, D8 = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
O8.inlineRef = function(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    return "boolean" == typeof e || (!0 === t ? !q8(e) : !!t && B8(e) <= t);
};
var z8 = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function q8(e) {
    for(var t in e){
        if (z8.has(t)) return !0;
        var n = e[t];
        if (Array.isArray(n) && n.some(q8)) return !0;
        if ("object" == Ho(n) && q8(n)) return !0;
    }
    return !1;
}
function B8(e) {
    var t = 0;
    for(var n in e){
        if ("$ref" === n) return 1 / 0;
        if (t++, !D8.has(n) && ("object" == Ho(e[n]) && (0, R8.eachItem)(e[n], function(e) {
            return t += B8(e);
        }), t === 1 / 0)) return 1 / 0;
    }
    return t;
}
function L8(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
    !1 !== (arguments.length > 2 ? arguments[2] : void 0) && (t = H8(t));
    var n = e.parse(t);
    return F8(e, n);
}
function F8(e, t) {
    return e.serialize(t).split("#")[0] + "#";
}
O8.getFullPath = L8, O8._getFullPath = F8;
var V8 = /#\/?$/;
function H8(e) {
    return e ? e.replace(V8, "") : "";
}
O8.normalizeId = H8, O8.resolveUrl = function(e, t, n) {
    return n = H8(n), e.resolve(t, n);
};
var W8, U8 = /^[a-z_][-a-z0-9._]*$/i;
function J8() {
    if (W8) return K6;
    W8 = 1, Object.defineProperty(K6, "__esModule", {
        value: !0
    }), K6.getData = K6.KeywordCxt = K6.validateFunctionCode = void 0;
    var e = function() {
        if (c8) return G6;
        c8 = 1, Object.defineProperty(G6, "__esModule", {
            value: !0
        }), G6.boolOrEmptySchema = G6.topBoolOrEmptySchema = void 0;
        var e = f8(), t = o8(), n = u8(), r = {
            message: "boolean schema is false"
        };
        function o(t, n) {
            var o = {
                gen: t.gen,
                keyword: "false schema",
                data: t.data,
                schema: !1,
                schemaCode: !1,
                schemaValue: !1,
                params: {},
                it: t
            };
            (0, e.reportError)(o, r, void 0, n);
        }
        return G6.topBoolOrEmptySchema = function(e) {
            var r = e.gen, i = e.schema, a = e.validateName;
            !1 === i ? o(e, !1) : "object" == Ho(i) && !0 === i.$async ? r.return(n.default.data) : (r.assign((0, t._)(ne || (ne = mo([
                "",
                ".errors"
            ])), a), null), r.return(!0));
        }, G6.boolOrEmptySchema = function(e, t) {
            var n = e.gen;
            !1 === e.schema ? (n.var(t, !1), o(e)) : n.var(t, !0);
        }, G6;
    }(), t = d8, n = g8(), r = d8, o = function() {
        if (y8) return b8;
        y8 = 1, Object.defineProperty(b8, "__esModule", {
            value: !0
        }), b8.assignDefaults = void 0;
        var e = o8(), t = i8;
        function n(n, r, o) {
            var i = n.gen, a = n.compositeRule, s = n.data, c = n.opts;
            if (void 0 !== o) {
                var l = (0, e._)(Ie || (Ie = mo([
                    "",
                    "",
                    ""
                ])), s, (0, e.getProperty)(r));
                if (a) (0, t.checkStrictMode)(n, "default is ignored for: ".concat(l));
                else {
                    var u = (0, e._)(De || (De = mo([
                        "",
                        " === undefined"
                    ])), l);
                    "empty" === c.useDefaults && (u = (0, e._)(ze || (ze = mo([
                        "",
                        " || ",
                        " === null || ",
                        ' === ""'
                    ])), u, l, l)), i.if(u, (0, e._)(qe || (qe = mo([
                        "",
                        " = ",
                        ""
                    ])), l, (0, e.stringify)(o)));
                }
            }
        }
        return b8.assignDefaults = function(e, t) {
            var r = e.schema, o = r.properties, i = r.items;
            if ("object" === t && o) for(var a in o)n(e, a, o[a].default);
            else "array" === t && Array.isArray(i) && i.forEach(function(t, r) {
                return n(e, r, t.default);
            });
        }, b8;
    }(), i = C8(), a = function() {
        if ($8) return _8;
        $8 = 1, Object.defineProperty(_8, "__esModule", {
            value: !0
        }), _8.extendSubschemaMode = _8.extendSubschemaData = _8.getSubschema = void 0;
        var e = o8(), t = i8;
        return _8.getSubschema = function(n, r) {
            var o = r.keyword, i = r.schemaProp, a = r.schema, s = r.schemaPath, c = r.errSchemaPath, l = r.topSchemaRef;
            if (void 0 !== o && void 0 !== a) throw new Error('both "keyword" and "schema" passed, only one allowed');
            if (void 0 !== o) {
                var u = n.schema[o];
                return void 0 === i ? {
                    schema: u,
                    schemaPath: (0, e._)(ft || (ft = mo([
                        "",
                        "",
                        ""
                    ])), n.schemaPath, (0, e.getProperty)(o)),
                    errSchemaPath: "".concat(n.errSchemaPath, "/").concat(o)
                } : {
                    schema: u[i],
                    schemaPath: (0, e._)(dt || (dt = mo([
                        "",
                        "",
                        "",
                        ""
                    ])), n.schemaPath, (0, e.getProperty)(o), (0, e.getProperty)(i)),
                    errSchemaPath: "".concat(n.errSchemaPath, "/").concat(o, "/").concat((0, t.escapeFragment)(i))
                };
            }
            if (void 0 !== a) {
                if (void 0 === s || void 0 === c || void 0 === l) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
                return {
                    schema: a,
                    schemaPath: s,
                    topSchemaRef: l,
                    errSchemaPath: c
                };
            }
            throw new Error('either "keyword" or "schema" must be passed');
        }, _8.extendSubschemaData = function(n, r, o) {
            var i = o.dataProp, a = o.dataPropType, s = o.data, c = o.dataTypes, l = o.propertyName;
            if (void 0 !== s && void 0 !== i) throw new Error('both "data" and "dataProp" passed, only one allowed');
            var u = r.gen;
            if (void 0 !== i) {
                var f = r.errorPath, d = r.dataPathArr, h = r.opts;
                v(u.let("data", (0, e._)(ht || (ht = mo([
                    "",
                    "",
                    ""
                ])), r.data, (0, e.getProperty)(i)), !0)), n.errorPath = (0, e.str)(vt || (vt = mo([
                    "",
                    "",
                    ""
                ])), f, (0, t.getErrorPath)(i, a, h.jsPropertySyntax)), n.parentDataProperty = (0, e._)(pt || (pt = mo([
                    "",
                    ""
                ])), i), n.dataPathArr = [].concat(Bo(d), [
                    n.parentDataProperty
                ]);
            }
            function v(e) {
                n.data = e, n.dataLevel = r.dataLevel + 1, n.dataTypes = [], r.definedProperties = new Set, n.parentData = r.data, n.dataNames = [].concat(Bo(r.dataNames), [
                    e
                ]);
            }
            void 0 !== s && (v(s instanceof e.Name ? s : u.let("data", s, !0)), void 0 !== l && (n.propertyName = l)), c && (n.dataTypes = c);
        }, _8.extendSubschemaMode = function(e, t) {
            var n = t.jtdDiscriminator, r = t.jtdMetadata, o = t.compositeRule, i = t.createErrors, a = t.allErrors;
            void 0 !== o && (e.compositeRule = o), void 0 !== i && (e.createErrors = i), void 0 !== a && (e.allErrors = a), e.jtdDiscriminator = n, e.jtdMetadata = r;
        }, _8;
    }(), s = o8(), c = u8(), l = O8, u = i8, f = f8();
    function d(e, t) {
        var n = e.gen, r = e.validateName, o = e.schema, i = e.schemaEnv, a = e.opts;
        a.code.es5 ? n.func(r, (0, s._)(mt || (mt = mo([
            "",
            ", ",
            ""
        ])), c.default.data, c.default.valCxt), i.$async, function() {
            n.code((0, s._)(gt || (gt = mo([
                '"use strict"; ',
                ""
            ])), h(o, a))), function(e, t) {
                e.if(c.default.valCxt, function() {
                    e.var(c.default.instancePath, (0, s._)(xt || (xt = mo([
                        "",
                        ".",
                        ""
                    ])), c.default.valCxt, c.default.instancePath)), e.var(c.default.parentData, (0, s._)(kt || (kt = mo([
                        "",
                        ".",
                        ""
                    ])), c.default.valCxt, c.default.parentData)), e.var(c.default.parentDataProperty, (0, s._)(jt || (jt = mo([
                        "",
                        ".",
                        ""
                    ])), c.default.valCxt, c.default.parentDataProperty)), e.var(c.default.rootData, (0, s._)(St || (St = mo([
                        "",
                        ".",
                        ""
                    ])), c.default.valCxt, c.default.rootData)), t.dynamicRef && e.var(c.default.dynamicAnchors, (0, s._)(Ct || (Ct = mo([
                        "",
                        ".",
                        ""
                    ])), c.default.valCxt, c.default.dynamicAnchors));
                }, function() {
                    e.var(c.default.instancePath, (0, s._)($t || ($t = mo([
                        '""'
                    ])))), e.var(c.default.parentData, (0, s._)(_t || (_t = mo([
                        "undefined"
                    ])))), e.var(c.default.parentDataProperty, (0, s._)(Ot || (Ot = mo([
                        "undefined"
                    ])))), e.var(c.default.rootData, c.default.data), t.dynamicRef && e.var(c.default.dynamicAnchors, (0, s._)(Mt || (Mt = mo([
                        "{}"
                    ]))));
                });
            }(n, a), n.code(t);
        }) : n.func(r, (0, s._)(yt || (yt = mo([
            "",
            ", ",
            ""
        ])), c.default.data, function(e) {
            return (0, s._)(bt || (bt = mo([
                "{",
                '="", ',
                ", ",
                ", ",
                "=",
                "",
                "}={}"
            ])), c.default.instancePath, c.default.parentData, c.default.parentDataProperty, c.default.rootData, c.default.data, e.dynamicRef ? (0, s._)(wt || (wt = mo([
                ", ",
                "={}"
            ])), c.default.dynamicAnchors) : s.nil);
        }(a)), i.$async, function() {
            return n.code(h(o, a)).code(t);
        });
    }
    function h(e, t) {
        var n = "object" == Ho(e) && e[t.schemaId];
        return n && (t.code.source || t.code.process) ? (0, s._)(Dt || (Dt = mo([
            "/*# sourceURL=",
            " */"
        ])), n) : s.nil;
    }
    function v(t, n) {
        m(t) && (g(t), p(t)) ? function(e, t) {
            var n = e.schema, r = e.gen, o = e.opts;
            o.$comment && n.$comment && b(e);
            (function(e) {
                var t = e.schema[e.opts.schemaId];
                t && (e.baseId = (0, l.resolveUrl)(e.opts.uriResolver, e.baseId, t));
            })(e), function(e) {
                if (e.schema.$async && !e.schemaEnv.$async) throw new Error("async schema in sync schema");
            }(e);
            var i = r.const("_errs", c.default.errors);
            y(e, i), r.var(t, (0, s._)(zt || (zt = mo([
                "",
                " === ",
                ""
            ])), i, c.default.errors));
        }(t, n) : (0, e.boolOrEmptySchema)(t, n);
    }
    function p(e) {
        var t = e.schema, n = e.self;
        if ("boolean" == typeof t) return !t;
        for(var r in t)if (n.RULES.all[r]) return !0;
        return !1;
    }
    function m(e) {
        return "boolean" != typeof e.schema;
    }
    function g(e) {
        (0, u.checkUnknownRules)(e), function(e) {
            var t = e.schema, n = e.errSchemaPath, r = e.opts, o = e.self;
            t.$ref && r.ignoreKeywordsWithRef && (0, u.schemaHasRulesButRef)(t, o.RULES) && o.logger.warn('$ref: keywords ignored in schema at path "'.concat(n, '"'));
        }(e);
    }
    function y(e, n) {
        if (e.opts.jtd) return w(e, [], !1, n);
        var r = (0, t.getSchemaTypes)(e.schema);
        w(e, r, !(0, t.coerceAndCheckDataType)(e, r), n);
    }
    function b(e) {
        var t = e.gen, n = e.schemaEnv, r = e.schema, o = e.errSchemaPath, i = e.opts, a = r.$comment;
        if (!0 === i.$comment) t.code((0, s._)(qt || (qt = mo([
            "",
            ".logger.log(",
            ")"
        ])), c.default.self, a));
        else if ("function" == typeof i.$comment) {
            var l = (0, s.str)(Bt || (Bt = mo([
                "",
                "/$comment"
            ])), o), u = t.scopeValue("root", {
                ref: n.root
            });
            t.code((0, s._)(Lt || (Lt = mo([
                "",
                ".opts.$comment(",
                ", ",
                ", ",
                ".schema)"
            ])), c.default.self, a, l, u));
        }
    }
    function w(e, t, o, i) {
        var a = e.gen, l = e.schema, f = e.data, d = e.allErrors, h = e.opts, v = e.self.RULES;
        function p(u) {
            (0, n.shouldUseGroup)(l, u) && (u.type ? (a.if((0, r.checkDataType)(u.type, f, h.strictNumbers)), x(e, u), 1 === t.length && t[0] === u.type && o && (a.else(), (0, r.reportTypeError)(e)), a.endIf()) : x(e, u), d || a.if((0, s._)(Kt || (Kt = mo([
                "",
                " === ",
                ""
            ])), c.default.errors, i || 0)));
        }
        !l.$ref || !h.ignoreKeywordsWithRef && (0, u.schemaHasRulesButRef)(l, v) ? (h.jtd || function(e, t) {
            if (e.schemaEnv.meta || !e.opts.strictTypes) return;
            (function(e, t) {
                if (!t.length) return;
                if (!e.dataTypes.length) return void (e.dataTypes = t);
                t.forEach(function(t) {
                    j(e.dataTypes, t) || S(e, 'type "'.concat(t, '" not allowed by context "').concat(e.dataTypes.join(","), '"'));
                }), function(e, t) {
                    var n, r = [], o = bo(e.dataTypes);
                    try {
                        for(o.s(); !(n = o.n()).done;){
                            var i = n.value;
                            j(t, i) ? r.push(i) : t.includes("integer") && "number" === i && r.push("integer");
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    e.dataTypes = r;
                }(e, t);
            })(e, t), e.opts.allowUnionTypes || function(e, t) {
                t.length > 1 && (2 !== t.length || !t.includes("null")) && S(e, "use allowUnionTypes to allow union type keyword");
            }(e, t);
            !function(e, t) {
                var r = e.self.RULES.all;
                for(var o in r){
                    var i = r[o];
                    if ("object" == Ho(i) && (0, n.shouldUseRule)(e.schema, i)) {
                        var a = i.definition.type;
                        a.length && !a.some(function(e) {
                            return k(t, e);
                        }) && S(e, 'missing type "'.concat(a.join(","), '" for keyword "').concat(o, '"'));
                    }
                }
            }(e, e.dataTypes);
        }(e, t), a.block(function() {
            var e, t = bo(v.rules);
            try {
                for(t.s(); !(e = t.n()).done;)p(e.value);
            } catch (e) {
                t.e(e);
            } finally{
                t.f();
            }
            p(v.post);
        })) : a.block(function() {
            return $(e, "$ref", v.all.$ref.definition);
        });
    }
    function x(e, t) {
        var r = e.gen, i = e.schema;
        e.opts.useDefaults && (0, o.assignDefaults)(e, t.type), r.block(function() {
            var r, o = bo(t.rules);
            try {
                for(o.s(); !(r = o.n()).done;){
                    var a = r.value;
                    (0, n.shouldUseRule)(i, a) && $(e, a.keyword, a.definition, t.type);
                }
            } catch (e) {
                o.e(e);
            } finally{
                o.f();
            }
        });
    }
    function k(e, t) {
        return e.includes(t) || "number" === t && e.includes("integer");
    }
    function j(e, t) {
        return e.includes(t) || "integer" === t && e.includes("number");
    }
    function S(e, t) {
        var n = e.schemaEnv.baseId + e.errSchemaPath;
        t += ' at "'.concat(n, '" (strictTypes)'), (0, u.checkStrictMode)(e, t, e.opts.strictTypes);
    }
    K6.validateFunctionCode = function(t) {
        m(t) && (g(t), p(t)) ? function(e) {
            var t = e.schema, n = e.opts, r = e.gen;
            d(e, function() {
                n.$comment && t.$comment && b(e), function(e) {
                    var t = e.schema, n = e.opts;
                    void 0 !== t.default && n.useDefaults && n.strictSchema && (0, u.checkStrictMode)(e, "default is ignored in the schema root");
                }(e), r.let(c.default.vErrors, null), r.let(c.default.errors, 0), n.unevaluated && function(e) {
                    var t = e.gen, n = e.validateName;
                    e.evaluated = t.const("evaluated", (0, s._)(Et || (Et = mo([
                        "",
                        ".evaluated"
                    ])), n)), t.if((0, s._)(At || (At = mo([
                        "",
                        ".dynamicProps"
                    ])), e.evaluated), function() {
                        return t.assign((0, s._)(Pt || (Pt = mo([
                            "",
                            ".props"
                        ])), e.evaluated), (0, s._)(Tt || (Tt = mo([
                            "undefined"
                        ]))));
                    }), t.if((0, s._)(Rt || (Rt = mo([
                        "",
                        ".dynamicItems"
                    ])), e.evaluated), function() {
                        return t.assign((0, s._)(Nt || (Nt = mo([
                            "",
                            ".items"
                        ])), e.evaluated), (0, s._)(It || (It = mo([
                            "undefined"
                        ]))));
                    });
                }(e), y(e), function(e) {
                    var t = e.gen, n = e.schemaEnv, r = e.validateName, o = e.ValidationError, i = e.opts;
                    n.$async ? t.if((0, s._)(Ft || (Ft = mo([
                        "",
                        " === 0"
                    ])), c.default.errors), function() {
                        return t.return(c.default.data);
                    }, function() {
                        return t.throw((0, s._)(Vt || (Vt = mo([
                            "new ",
                            "(",
                            ")"
                        ])), o, c.default.vErrors));
                    }) : (t.assign((0, s._)(Ht || (Ht = mo([
                        "",
                        ".errors"
                    ])), r), c.default.vErrors), i.unevaluated && function(e) {
                        var t = e.gen, n = e.evaluated, r = e.props, o = e.items;
                        r instanceof s.Name && t.assign((0, s._)(Ut || (Ut = mo([
                            "",
                            ".props"
                        ])), n), r);
                        o instanceof s.Name && t.assign((0, s._)(Jt || (Jt = mo([
                            "",
                            ".items"
                        ])), n), o);
                    }(e), t.return((0, s._)(Wt || (Wt = mo([
                        "",
                        " === 0"
                    ])), c.default.errors)));
                }(e);
            });
        }(t) : d(t, function() {
            return (0, e.topBoolOrEmptySchema)(t);
        });
    };
    var C = function() {
        function e(t, n, r) {
            if (No(this, e), (0, i.validateKeywordUsage)(t, n, r), this.gen = t.gen, this.allErrors = t.allErrors, this.keyword = r, this.data = t.data, this.schema = t.schema[r], this.$data = n.$data && t.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, u.schemaRefOrVal)(t, this.schema, r, this.$data), this.schemaType = n.schemaType, this.parentSchema = t.schema, this.params = {}, this.it = t, this.def = n, this.$data) this.schemaCode = t.gen.const("vSchema", M(this.$data, t));
            else if (this.schemaCode = this.schemaValue, !(0, i.validSchemaType)(this.schema, n.schemaType, n.allowUndefined)) throw new Error("".concat(r, " value must be ").concat(JSON.stringify(n.schemaType)));
            ("code" in n ? n.trackErrors : !1 !== n.errors) && (this.errsCount = t.gen.const("_errs", c.default.errors));
        }
        return Do(e, [
            {
                key: "result",
                value: function(e, t, n) {
                    this.failResult((0, s.not)(e), t, n);
                }
            },
            {
                key: "failResult",
                value: function(e, t, n) {
                    this.gen.if(e), n ? n() : this.error(), t ? (this.gen.else(), t(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
                }
            },
            {
                key: "pass",
                value: function(e, t) {
                    this.failResult((0, s.not)(e), void 0, t);
                }
            },
            {
                key: "fail",
                value: function(e) {
                    if (void 0 === e) return this.error(), void (this.allErrors || this.gen.if(!1));
                    this.gen.if(e), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
                }
            },
            {
                key: "fail$data",
                value: function(e) {
                    if (!this.$data) return this.fail(e);
                    var t = this.schemaCode;
                    this.fail((0, s._)(Gt || (Gt = mo([
                        "",
                        " !== undefined && (",
                        ")"
                    ])), t, (0, s.or)(this.invalid$data(), e)));
                }
            },
            {
                key: "error",
                value: function(e, t, n) {
                    if (t) return this.setParams(t), this._error(e, n), void this.setParams({});
                    this._error(e, n);
                }
            },
            {
                key: "_error",
                value: function(e, t) {
                    (e ? f.reportExtraError : f.reportError)(this, this.def.error, t);
                }
            },
            {
                key: "$dataError",
                value: function() {
                    (0, f.reportError)(this, this.def.$dataError || f.keyword$DataError);
                }
            },
            {
                key: "reset",
                value: function() {
                    if (void 0 === this.errsCount) throw new Error('add "trackErrors" to keyword definition');
                    (0, f.resetErrorsCount)(this.gen, this.errsCount);
                }
            },
            {
                key: "ok",
                value: function(e) {
                    this.allErrors || this.gen.if(e);
                }
            },
            {
                key: "setParams",
                value: function(e, t) {
                    t ? Object.assign(this.params, e) : this.params = e;
                }
            },
            {
                key: "block$data",
                value: function(e, t) {
                    var n = this, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.nil;
                    this.gen.block(function() {
                        n.check$data(e, r), t();
                    });
                }
            },
            {
                key: "check$data",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s.nil, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.nil;
                    if (this.$data) {
                        var n = this.gen, r = this.schemaCode, o = this.schemaType, i = this.def;
                        n.if((0, s.or)((0, s._)(Qt || (Qt = mo([
                            "",
                            " === undefined"
                        ])), r), t)), e !== s.nil && n.assign(e, !0), (o.length || i.validateSchema) && (n.elseIf(this.invalid$data()), this.$dataError(), e !== s.nil && n.assign(e, !1)), n.else();
                    }
                }
            },
            {
                key: "invalid$data",
                value: function() {
                    var e = this.gen, t = this.schemaCode, n = this.schemaType, o = this.def, i = this.it;
                    return (0, s.or)(function() {
                        if (n.length) {
                            if (!(t instanceof s.Name)) throw new Error("ajv implementation error");
                            var e = Array.isArray(n) ? n : [
                                n
                            ];
                            return (0, s._)(Yt || (Yt = mo([
                                "",
                                ""
                            ])), (0, r.checkDataTypes)(e, t, i.opts.strictNumbers, r.DataType.Wrong));
                        }
                        return s.nil;
                    }(), function() {
                        if (o.validateSchema) {
                            var n = e.scopeValue("validate$data", {
                                ref: o.validateSchema
                            });
                            return (0, s._)(Xt || (Xt = mo([
                                "!",
                                "(",
                                ")"
                            ])), n, t);
                        }
                        return s.nil;
                    }());
                }
            },
            {
                key: "subschema",
                value: function(e, t) {
                    var n = (0, a.getSubschema)(this.it, e);
                    (0, a.extendSubschemaData)(n, this.it, e), (0, a.extendSubschemaMode)(n, e);
                    var r = Ro(Ro(Ro({}, this.it), n), {}, {
                        items: void 0,
                        props: void 0
                    });
                    return v(r, t), r;
                }
            },
            {
                key: "mergeEvaluated",
                value: function(e, t) {
                    var n = this.it, r = this.gen;
                    n.opts.unevaluated && (!0 !== n.props && void 0 !== e.props && (n.props = u.mergeEvaluated.props(r, e.props, n.props, t)), !0 !== n.items && void 0 !== e.items && (n.items = u.mergeEvaluated.items(r, e.items, n.items, t)));
                }
            },
            {
                key: "mergeValidEvaluated",
                value: function(e, t) {
                    var n = this, r = this.it, o = this.gen;
                    if (r.opts.unevaluated && (!0 !== r.props || !0 !== r.items)) return o.if(t, function() {
                        return n.mergeEvaluated(e, s.Name);
                    }), !0;
                }
            }
        ]), e;
    }();
    function $(e, t, n, r) {
        var o = new C(e, n, t);
        "code" in n ? n.code(o, r) : o.$data && n.validate ? (0, i.funcKeywordCode)(o, n) : "macro" in n ? (0, i.macroKeywordCode)(o, n) : (n.compile || n.validate) && (0, i.funcKeywordCode)(o, n);
    }
    K6.KeywordCxt = C;
    var _ = /^\/(?:[^~]|~0|~1)*$/, O = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
    function M(e, t) {
        var n, r, o = t.dataLevel, i = t.dataNames, a = t.dataPathArr;
        if ("" === e) return c.default.rootData;
        if ("/" === e[0]) {
            if (!_.test(e)) throw new Error("Invalid JSON-pointer: ".concat(e));
            n = e, r = c.default.rootData;
        } else {
            var l = O.exec(e);
            if (!l) throw new Error("Invalid JSON-pointer: ".concat(e));
            var f = +l[1];
            if ("#" === (n = l[2])) {
                if (f >= o) throw new Error(m("property/index", f));
                return a[o - f];
            }
            if (f > o) throw new Error(m("data", f));
            if (r = i[o - f], !n) return r;
        }
        var d, h = r, v = bo(n.split("/"));
        try {
            for(v.s(); !(d = v.n()).done;){
                var p = d.value;
                p && (r = (0, s._)(Zt || (Zt = mo([
                    "",
                    "",
                    ""
                ])), r, (0, s.getProperty)((0, u.unescapeJsonPointer)(p))), h = (0, s._)(en || (en = mo([
                    "",
                    " && ",
                    ""
                ])), h, r));
            }
        } catch (e) {
            v.e(e);
        } finally{
            v.f();
        }
        return h;
        function m(e, t) {
            return "Cannot access ".concat(e, " ").concat(t, " levels up, current level is ").concat(o);
        }
    }
    return K6.getData = M, K6;
}
O8.getSchemaRefs = function(e, t) {
    var n = this;
    if ("boolean" == typeof e) return {};
    var r = this.opts, o = r.schemaId, i = r.uriResolver, a = H8(e[o] || t), s = {
        "": a
    }, c = L8(i, a, !1), l = {}, u = new Set;
    return I8(e, {
        allKeys: !0
    }, function(e, t, r, i) {
        if (void 0 !== i) {
            var a = c + t, h = s[i];
            "string" == typeof e[o] && (h = v.call(n, e[o])), p.call(n, e.$anchor), p.call(n, e.$dynamicAnchor), s[t] = h;
        }
        function v(t) {
            var n = this.opts.uriResolver.resolve;
            if (t = H8(h ? n(h, t) : t), u.has(t)) throw d(t);
            u.add(t);
            var r = this.refs[t];
            return "string" == typeof r && (r = this.refs[r]), "object" == Ho(r) ? f(e, r.schema, t) : t !== H8(a) && ("#" === t[0] ? (f(e, l[t], t), l[t] = e) : this.refs[t] = a), t;
        }
        function p(e) {
            if ("string" == typeof e) {
                if (!U8.test(e)) throw new Error('invalid anchor "'.concat(e, '"'));
                v.call(this, "#".concat(e));
            }
        }
    }), l;
    function f(e, t, n) {
        if (void 0 !== t && !N8(e, t)) throw d(n);
    }
    function d(e) {
        return new Error('reference "'.concat(e, '" resolves to more than one schema'));
    }
};
var K8, G8 = {};
function Q8() {
    if (K8) return G8;
    K8 = 1, Object.defineProperty(G8, "__esModule", {
        value: !0
    });
    var e = function(e) {
        function t(e) {
            var n;
            return No(this, t), (n = _o(this, t, [
                "validation failed"
            ])).errors = e, n.ajv = n.validation = !0, n;
        }
        return Ao(t, $o(Error)), Do(t);
    }();
    return G8.default = e, G8;
}
var Y8, X8 = {};
function Z8() {
    if (Y8) return X8;
    Y8 = 1, Object.defineProperty(X8, "__esModule", {
        value: !0
    });
    var e = O8, t = function(t) {
        function n(t, r, o, i) {
            var a;
            return No(this, n), (a = _o(this, n, [
                i || "can't resolve reference ".concat(o, " from id ").concat(r)
            ])).missingRef = (0, e.resolveUrl)(t, r, o), a.missingSchema = (0, e.normalizeId)((0, e.getFullPath)(t, a.missingRef)), a;
        }
        return Ao(n, $o(Error)), Do(n);
    }();
    return X8.default = t, X8;
}
var e5 = {};
Object.defineProperty(e5, "__esModule", {
    value: !0
}), e5.resolveSchema = e5.getCompilingSchema = e5.resolveRef = e5.compileSchema = e5.SchemaEnv = void 0;
var t5 = o8(), n5 = Q8(), r5 = u8(), o5 = O8, i5 = i8, a5 = J8(), s5 = Do(function e(t) {
    var n, r;
    No(this, e), this.refs = {}, this.dynamicAnchors = {}, "object" == Ho(t.schema) && (r = t.schema), this.schema = t.schema, this.schemaId = t.schemaId, this.root = t.root || this, this.baseId = null !== (n = t.baseId) && void 0 !== n ? n : (0, o5.normalizeId)(null == r ? void 0 : r[t.schemaId || "$id"]), this.schemaPath = t.schemaPath, this.localRefs = t.localRefs, this.meta = t.meta, this.$async = null == r ? void 0 : r.$async, this.refs = {};
});
function c5(e) {
    var t = u5.call(this, e);
    if (t) return t;
    var n, r = (0, o5.getFullPath)(this.opts.uriResolver, e.root.baseId), o = this.opts.code, i = o.es5, a = o.lines, s = this.opts.ownProperties, c = new t5.CodeGen(this.scope, {
        es5: i,
        lines: a,
        ownProperties: s
    });
    e.$async && (n = c.scopeValue("Error", {
        ref: n5.default,
        code: (0, t5._)(tn || (tn = mo([
            'require("ajv/dist/runtime/validation_error").default'
        ])))
    }));
    var l = c.scopeName("validate");
    e.validateName = l;
    var u, f = {
        gen: c,
        allErrors: this.opts.allErrors,
        data: r5.default.data,
        parentData: r5.default.parentData,
        parentDataProperty: r5.default.parentDataProperty,
        dataNames: [
            r5.default.data
        ],
        dataPathArr: [
            t5.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set,
        topSchemaRef: c.scopeValue("schema", !0 === this.opts.code.source ? {
            ref: e.schema,
            code: (0, t5.stringify)(e.schema)
        } : {
            ref: e.schema
        }),
        validateName: l,
        ValidationError: n,
        schema: e.schema,
        schemaEnv: e,
        rootId: r,
        baseId: e.baseId || r,
        schemaPath: t5.nil,
        errSchemaPath: e.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, t5._)(nn || (nn = mo([
            '""'
        ]))),
        opts: this.opts,
        self: this
    };
    try {
        this._compilations.add(e), (0, a5.validateFunctionCode)(f), c.optimize(this.opts.code.optimize);
        var d = c.toString();
        u = "".concat(c.scopeRefs(r5.default.scope), "return ").concat(d), this.opts.code.process && (u = this.opts.code.process(u, e));
        var h = new Function("".concat(r5.default.self), "".concat(r5.default.scope), u)(this, this.scope.get());
        if (this.scope.value(l, {
            ref: h
        }), h.errors = null, h.schema = e.schema, h.schemaEnv = e, e.$async && (h.$async = !0), !0 === this.opts.code.source && (h.source = {
            validateName: l,
            validateCode: d,
            scopeValues: c._values
        }), this.opts.unevaluated) {
            var v = f.props, p = f.items;
            h.evaluated = {
                props: v instanceof t5.Name ? void 0 : v,
                items: p instanceof t5.Name ? void 0 : p,
                dynamicProps: v instanceof t5.Name,
                dynamicItems: p instanceof t5.Name
            }, h.source && (h.source.evaluated = (0, t5.stringify)(h.evaluated));
        }
        return e.validate = h, e;
    } catch (t) {
        throw delete e.validate, delete e.validateName, u && this.logger.error("Error compiling schema, function code:", u), t;
    } finally{
        this._compilations.delete(e);
    }
}
function l5(e) {
    return (0, o5.inlineRef)(e.schema, this.opts.inlineRefs) ? e.schema : e.validate ? e : c5.call(this, e);
}
function u5(e) {
    var t, n, r, o = bo(this._compilations);
    try {
        for(o.s(); !(t = o.n()).done;){
            var i = t.value;
            if (r = e, (n = i).schema === r.schema && n.root === r.root && n.baseId === r.baseId) return i;
        }
    } catch (e) {
        o.e(e);
    } finally{
        o.f();
    }
}
function f5(e, t) {
    for(var n; "string" == typeof (n = this.refs[t]);)t = n;
    return n || this.schemas[t] || d5.call(this, e, t);
}
function d5(e, t) {
    var n = this.opts.uriResolver.parse(t), r = (0, o5._getFullPath)(this.opts.uriResolver, n), o = (0, o5.getFullPath)(this.opts.uriResolver, e.baseId, void 0);
    if (Object.keys(e.schema).length > 0 && r === o) return v5.call(this, n, e);
    var i = (0, o5.normalizeId)(r), a = this.refs[i] || this.schemas[i];
    if ("string" == typeof a) {
        var s = d5.call(this, e, a);
        if ("object" !== Ho(null == s ? void 0 : s.schema)) return;
        return v5.call(this, n, s);
    }
    if ("object" === Ho(null == a ? void 0 : a.schema)) {
        if (a.validate || c5.call(this, a), i === (0, o5.normalizeId)(t)) {
            var c = a.schema, l = this.opts.schemaId, u = c[l];
            return u && (o = (0, o5.resolveUrl)(this.opts.uriResolver, o, u)), new s5({
                schema: c,
                schemaId: l,
                root: e,
                baseId: o
            });
        }
        return v5.call(this, n, a);
    }
}
e5.SchemaEnv = s5, e5.compileSchema = c5, e5.resolveRef = function(e, t, n) {
    var r;
    n = (0, o5.resolveUrl)(this.opts.uriResolver, t, n);
    var o = e.refs[n];
    if (o) return o;
    var i = f5.call(this, e, n);
    if (void 0 === i) {
        var a = null === (r = e.localRefs) || void 0 === r ? void 0 : r[n], s = this.opts.schemaId;
        a && (i = new s5({
            schema: a,
            schemaId: s,
            root: e,
            baseId: t
        }));
    }
    return void 0 !== i ? e.refs[n] = l5.call(this, i) : void 0;
}, e5.getCompilingSchema = u5, e5.resolveSchema = d5;
var h5 = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function v5(e, t) {
    var n, r = t.baseId, o = t.schema, i = t.root;
    if ("/" === (null === (n = e.fragment) || void 0 === n ? void 0 : n[0])) {
        var a, s, c = bo(e.fragment.slice(1).split("/"));
        try {
            for(c.s(); !(a = c.n()).done;){
                var l = a.value;
                if ("boolean" == typeof o) return;
                var u = o[(0, i5.unescapeFragment)(l)];
                if (void 0 === u) return;
                var f = "object" === Ho(o = u) && o[this.opts.schemaId];
                !h5.has(l) && f && (r = (0, o5.resolveUrl)(this.opts.uriResolver, r, f));
            }
        } catch (e) {
            c.e(e);
        } finally{
            c.f();
        }
        if ("boolean" != typeof o && o.$ref && !(0, i5.schemaHasRulesButRef)(o, this.RULES)) {
            var d = (0, o5.resolveUrl)(this.opts.uriResolver, r, o.$ref);
            s = d5.call(this, i, d);
        }
        var h = this.opts.schemaId;
        return (s = s || new s5({
            schema: o,
            schemaId: h,
            root: i,
            baseId: r
        })).schema !== s.root.schema ? s : void 0;
    }
}
var p5 = {
    $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
    description: "Meta-schema for $data reference (JSON AnySchema extension proposal)",
    type: "object",
    required: [
        "$data"
    ],
    properties: {
        $data: {
            type: "string",
            anyOf: [
                {
                    format: "relative-json-pointer"
                },
                {
                    format: "json-pointer"
                }
            ]
        }
    },
    additionalProperties: !1
}, m5 = {}, g5 = {
    exports: {}
};
!function(e) {
    function t() {
        for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        if (t.length > 1) {
            t[0] = t[0].slice(0, -1);
            for(var r = t.length - 1, o = 1; o < r; ++o)t[o] = t[o].slice(1, -1);
            return t[r] = t[r].slice(1), t.join("");
        }
        return t[0];
    }
    function n(e) {
        return "(?:" + e + ")";
    }
    function r(e) {
        return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
    }
    function o(e) {
        return e.toUpperCase();
    }
    function i(e) {
        return null != e ? e instanceof Array ? e : "number" != typeof e.length || e.split || e.setInterval || e.call ? [
            e
        ] : Array.prototype.slice.call(e) : [];
    }
    function a(e, t) {
        var n = e;
        if (t) for(var r in t)n[r] = t[r];
        return n;
    }
    function s(e) {
        var r = "[A-Za-z]", o = "[0-9]", i = t(o, "[A-Fa-f]"), a = n(n("%[EFef]" + i + "%" + i + i + "%" + i + i) + "|" + n("%[89A-Fa-f]" + i + "%" + i + i) + "|" + n("%" + i + i)), s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", c = t("[\\:\\/\\?\\#\\[\\]\\@]", s), l = e ? "[\\uE000-\\uF8FF]" : "[]", u = t(r, o, "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
        n(r + t(r, o, "[\\+\\-\\.]") + "*"), n(n(a + "|" + t(u, s, "[\\:]")) + "*");
        var f = n(n("25[0-5]") + "|" + n("2[0-4]" + o) + "|" + n("1" + o + o) + "|" + n("0?[1-9]" + o) + "|0?0?" + o), d = n(f + "\\." + f + "\\." + f + "\\." + f), h = n(i + "{1,4}"), v = n(n(h + "\\:" + h) + "|" + d), p = n(n(h + "\\:") + "{6}" + v), m = n("\\:\\:" + n(h + "\\:") + "{5}" + v), g = n(n(h) + "?\\:\\:" + n(h + "\\:") + "{4}" + v), y = n(n(n(h + "\\:") + "{0,1}" + h) + "?\\:\\:" + n(h + "\\:") + "{3}" + v), b = n(n(n(h + "\\:") + "{0,2}" + h) + "?\\:\\:" + n(h + "\\:") + "{2}" + v), w = n(n(n(h + "\\:") + "{0,3}" + h) + "?\\:\\:" + h + "\\:" + v), x = n(n(n(h + "\\:") + "{0,4}" + h) + "?\\:\\:" + v), k = n(n(n(h + "\\:") + "{0,5}" + h) + "?\\:\\:" + h), j = n(n(n(h + "\\:") + "{0,6}" + h) + "?\\:\\:"), S = n([
            p,
            m,
            g,
            y,
            b,
            w,
            x,
            k,
            j
        ].join("|")), C = n(n(u + "|" + a) + "+");
        n("[vV]" + i + "+\\." + t(u, s, "[\\:]") + "+"), n(n(a + "|" + t(u, s)) + "*");
        var $ = n(a + "|" + t(u, s, "[\\:\\@]"));
        return n(n(a + "|" + t(u, s, "[\\@]")) + "+"), n(n($ + "|" + t("[\\/\\?]", l)) + "*"), {
            NOT_SCHEME: new RegExp(t("[^]", r, o, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(t("[^\\%\\:]", u, s), "g"),
            NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", u, s), "g"),
            NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", u, s), "g"),
            NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", u, s), "g"),
            NOT_QUERY: new RegExp(t("[^\\%]", u, s, "[\\:\\@\\/\\?]", l), "g"),
            NOT_FRAGMENT: new RegExp(t("[^\\%]", u, s, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(t("[^]", u, s), "g"),
            UNRESERVED: new RegExp(u, "g"),
            OTHER_CHARS: new RegExp(t("[^\\%]", u, c), "g"),
            PCT_ENCODED: new RegExp(a, "g"),
            IPV4ADDRESS: new RegExp("^(" + d + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + S + ")" + n(n("\\%25|\\%(?!" + i + "{2})") + "(" + C + ")") + "?\\]?$")
        };
    }
    var c = s(!1), l = s(!0), u = function() {
        function e(e, t) {
            var n = [], r = !0, o = !1, i = void 0;
            try {
                for(var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
                o = !0, i = e;
            } finally{
                try {
                    !r && s.return && s.return();
                } finally{
                    if (o) throw i;
                }
            }
            return n;
        }
        return function(t, n) {
            if (Array.isArray(t)) return t;
            if (Symbol.iterator in Object(t)) return e(t, n);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }(), f = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, n = Array(e.length); t < e.length; t++)n[t] = e[t];
            return n;
        }
        return Array.from(e);
    }, d = 2147483647, h = 36, v = 1, p = 26, m = 38, g = 700, y = 72, b = 128, w = "-", x = /^xn--/, k = /[^\0-\x7E]/, j = /[\x2E\u3002\uFF0E\uFF61]/g, S = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, C = h - v, $ = Math.floor, _ = String.fromCharCode;
    function O(e) {
        throw new RangeError(S[e]);
    }
    function M(e, t) {
        for(var n = [], r = e.length; r--;)n[r] = t(e[r]);
        return n;
    }
    function E(e, t) {
        var n = e.split("@"), r = "";
        return n.length > 1 && (r = n[0] + "@", e = n[1]), r + M((e = e.replace(j, ".")).split("."), t).join(".");
    }
    function A(e) {
        for(var t = [], n = 0, r = e.length; n < r;){
            var o = e.charCodeAt(n++);
            if (o >= 55296 && o <= 56319 && n < r) {
                var i = e.charCodeAt(n++);
                56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
            } else t.push(o);
        }
        return t;
    }
    var P = function(e) {
        return String.fromCodePoint.apply(String, f(e));
    }, T = function(e) {
        return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : h;
    }, R = function(e, t) {
        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
    }, N = function(e, t, n) {
        var r = 0;
        for(e = n ? $(e / g) : e >> 1, e += $(e / t); e > C * p >> 1; r += h)e = $(e / C);
        return $(r + (C + 1) * e / (e + m));
    }, I = function(e) {
        var t = [], n = e.length, r = 0, o = b, i = y, a = e.lastIndexOf(w);
        a < 0 && (a = 0);
        for(var s = 0; s < a; ++s)e.charCodeAt(s) >= 128 && O("not-basic"), t.push(e.charCodeAt(s));
        for(var c = a > 0 ? a + 1 : 0; c < n;){
            for(var l = r, u = 1, f = h;; f += h){
                c >= n && O("invalid-input");
                var m = T(e.charCodeAt(c++));
                (m >= h || m > $((d - r) / u)) && O("overflow"), r += m * u;
                var g = f <= i ? v : f >= i + p ? p : f - i;
                if (m < g) break;
                var x = h - g;
                u > $(d / x) && O("overflow"), u *= x;
            }
            var k = t.length + 1;
            i = N(r - l, k, 0 == l), $(r / k) > d - o && O("overflow"), o += $(r / k), r %= k, t.splice(r++, 0, o);
        }
        return String.fromCodePoint.apply(String, t);
    }, D = function(e) {
        var t = [], n = (e = A(e)).length, r = b, o = 0, i = y, a = !0, s = !1, c = void 0;
        try {
            for(var l, u = e[Symbol.iterator](); !(a = (l = u.next()).done); a = !0){
                var f = l.value;
                f < 128 && t.push(_(f));
            }
        } catch (e) {
            s = !0, c = e;
        } finally{
            try {
                !a && u.return && u.return();
            } finally{
                if (s) throw c;
            }
        }
        var m = t.length, g = m;
        for(m && t.push(w); g < n;){
            var x = d, k = !0, j = !1, S = void 0;
            try {
                for(var C, M = e[Symbol.iterator](); !(k = (C = M.next()).done); k = !0){
                    var E = C.value;
                    E >= r && E < x && (x = E);
                }
            } catch (e) {
                j = !0, S = e;
            } finally{
                try {
                    !k && M.return && M.return();
                } finally{
                    if (j) throw S;
                }
            }
            var P = g + 1;
            x - r > $((d - o) / P) && O("overflow"), o += (x - r) * P, r = x;
            var T = !0, I = !1, D = void 0;
            try {
                for(var z, q = e[Symbol.iterator](); !(T = (z = q.next()).done); T = !0){
                    var B = z.value;
                    if (B < r && ++o > d && O("overflow"), B == r) {
                        for(var L = o, F = h;; F += h){
                            var V = F <= i ? v : F >= i + p ? p : F - i;
                            if (L < V) break;
                            var H = L - V, W = h - V;
                            t.push(_(R(V + H % W, 0))), L = $(H / W);
                        }
                        t.push(_(R(L, 0))), i = N(o, P, g == m), o = 0, ++g;
                    }
                }
            } catch (e) {
                I = !0, D = e;
            } finally{
                try {
                    !T && q.return && q.return();
                } finally{
                    if (I) throw D;
                }
            }
            ++o, ++r;
        }
        return t.join("");
    }, z = function(e) {
        return E(e, function(e) {
            return x.test(e) ? I(e.slice(4).toLowerCase()) : e;
        });
    }, q = function(e) {
        return E(e, function(e) {
            return k.test(e) ? "xn--" + D(e) : e;
        });
    }, B = {
        version: "2.1.0",
        ucs2: {
            decode: A,
            encode: P
        },
        decode: I,
        encode: D,
        toASCII: q,
        toUnicode: z
    }, L = {};
    function F(e) {
        var t = e.charCodeAt(0);
        return t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase();
    }
    function V(e) {
        for(var t = "", n = 0, r = e.length; n < r;){
            var o = parseInt(e.substr(n + 1, 2), 16);
            if (o < 128) t += String.fromCharCode(o), n += 3;
            else if (o >= 194 && o < 224) {
                if (r - n >= 6) {
                    var i = parseInt(e.substr(n + 4, 2), 16);
                    t += String.fromCharCode((31 & o) << 6 | 63 & i);
                } else t += e.substr(n, 6);
                n += 6;
            } else if (o >= 224) {
                if (r - n >= 9) {
                    var a = parseInt(e.substr(n + 4, 2), 16), s = parseInt(e.substr(n + 7, 2), 16);
                    t += String.fromCharCode((15 & o) << 12 | (63 & a) << 6 | 63 & s);
                } else t += e.substr(n, 9);
                n += 9;
            } else t += e.substr(n, 3), n += 3;
        }
        return t;
    }
    function H(e, t) {
        function n(e) {
            var n = V(e);
            return n.match(t.UNRESERVED) ? n : e;
        }
        return e.scheme && (e.scheme = String(e.scheme).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(t.PCT_ENCODED, n).replace(t.NOT_USERINFO, F).replace(t.PCT_ENCODED, o)), void 0 !== e.host && (e.host = String(e.host).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_HOST, F).replace(t.PCT_ENCODED, o)), void 0 !== e.path && (e.path = String(e.path).replace(t.PCT_ENCODED, n).replace(e.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, F).replace(t.PCT_ENCODED, o)), void 0 !== e.query && (e.query = String(e.query).replace(t.PCT_ENCODED, n).replace(t.NOT_QUERY, F).replace(t.PCT_ENCODED, o)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(t.PCT_ENCODED, n).replace(t.NOT_FRAGMENT, F).replace(t.PCT_ENCODED, o)), e;
    }
    function W(e) {
        return e.replace(/^0*(.*)/, "$1") || "0";
    }
    function U(e, t) {
        var n = e.match(t.IPV4ADDRESS) || [], r = u(n, 2)[1];
        return r ? r.split(".").map(W).join(".") : e;
    }
    function J(e, t) {
        var n = e.match(t.IPV6ADDRESS) || [], r = u(n, 3), o = r[1], i = r[2];
        if (o) {
            for(var a = o.toLowerCase().split("::").reverse(), s = u(a, 2), c = s[0], l = s[1], f = l ? l.split(":").map(W) : [], d = c.split(":").map(W), h = t.IPV4ADDRESS.test(d[d.length - 1]), v = h ? 7 : 8, p = d.length - v, m = Array(v), g = 0; g < v; ++g)m[g] = f[g] || d[p + g] || "";
            h && (m[v - 1] = U(m[v - 1], t));
            var y = m.reduce(function(e, t, n) {
                if (!t || "0" === t) {
                    var r = e[e.length - 1];
                    r && r.index + r.length === n ? r.length++ : e.push({
                        index: n,
                        length: 1
                    });
                }
                return e;
            }, []).sort(function(e, t) {
                return t.length - e.length;
            })[0], b = void 0;
            if (y && y.length > 1) {
                var w = m.slice(0, y.index), x = m.slice(y.index + y.length);
                b = w.join(":") + "::" + x.join(":");
            } else b = m.join(":");
            return i && (b += "%" + i), b;
        }
        return e;
    }
    var K = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, G = void 0 === "".match(/(){0}/)[1];
    function Q(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {}, r = !1 !== t.iri ? l : c;
        "suffix" === t.reference && (e = (t.scheme ? t.scheme + ":" : "") + "//" + e);
        var o = e.match(K);
        if (o) {
            G ? (n.scheme = o[1], n.userinfo = o[3], n.host = o[4], n.port = parseInt(o[5], 10), n.path = o[6] || "", n.query = o[7], n.fragment = o[8], isNaN(n.port) && (n.port = o[5])) : (n.scheme = o[1] || void 0, n.userinfo = -1 !== e.indexOf("@") ? o[3] : void 0, n.host = -1 !== e.indexOf("//") ? o[4] : void 0, n.port = parseInt(o[5], 10), n.path = o[6] || "", n.query = -1 !== e.indexOf("?") ? o[7] : void 0, n.fragment = -1 !== e.indexOf("#") ? o[8] : void 0, isNaN(n.port) && (n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? o[4] : void 0)), n.host && (n.host = J(U(n.host, r), r)), void 0 !== n.scheme || void 0 !== n.userinfo || void 0 !== n.host || void 0 !== n.port || n.path || void 0 !== n.query ? void 0 === n.scheme ? n.reference = "relative" : void 0 === n.fragment ? n.reference = "absolute" : n.reference = "uri" : n.reference = "same-document", t.reference && "suffix" !== t.reference && t.reference !== n.reference && (n.error = n.error || "URI is not a " + t.reference + " reference.");
            var i = L[(t.scheme || n.scheme || "").toLowerCase()];
            if (t.unicodeSupport || i && i.unicodeSupport) H(n, r);
            else {
                if (n.host && (t.domainHost || i && i.domainHost)) try {
                    n.host = B.toASCII(n.host.replace(r.PCT_ENCODED, V).toLowerCase());
                } catch (e) {
                    n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                H(n, c);
            }
            i && i.parse && i.parse(n, t);
        } else n.error = n.error || "URI can not be parsed.";
        return n;
    }
    function Y(e, t) {
        var n = !1 !== t.iri ? l : c, r = [];
        return void 0 !== e.userinfo && (r.push(e.userinfo), r.push("@")), void 0 !== e.host && r.push(J(U(String(e.host), n), n).replace(n.IPV6ADDRESS, function(e, t, n) {
            return "[" + t + (n ? "%25" + n : "") + "]";
        })), "number" != typeof e.port && "string" != typeof e.port || (r.push(":"), r.push(String(e.port))), r.length ? r.join("") : void 0;
    }
    var X = /^\.\.?\//, Z = /^\/\.(\/|$)/, ee = /^\/\.\.(\/|$)/, te = /^\/?(?:.|\n)*?(?=\/|$)/;
    function ne(e) {
        for(var t = []; e.length;)if (e.match(X)) e = e.replace(X, "");
        else if (e.match(Z)) e = e.replace(Z, "/");
        else if (e.match(ee)) e = e.replace(ee, "/"), t.pop();
        else if ("." === e || ".." === e) e = "";
        else {
            var n = e.match(te);
            if (!n) throw new Error("Unexpected dot segment condition");
            var r = n[0];
            e = e.slice(r.length), t.push(r);
        }
        return t.join("");
    }
    function re(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.iri ? l : c, r = [], o = L[(t.scheme || e.scheme || "").toLowerCase()];
        if (o && o.serialize && o.serialize(e, t), e.host) {
            if (n.IPV6ADDRESS.test(e.host)) ;
            else if (t.domainHost || o && o.domainHost) try {
                e.host = t.iri ? B.toUnicode(e.host) : B.toASCII(e.host.replace(n.PCT_ENCODED, V).toLowerCase());
            } catch (n) {
                e.error = e.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + n;
            }
        }
        H(e, n), "suffix" !== t.reference && e.scheme && (r.push(e.scheme), r.push(":"));
        var i = Y(e, t);
        if (void 0 !== i && ("suffix" !== t.reference && r.push("//"), r.push(i), e.path && "/" !== e.path.charAt(0) && r.push("/")), void 0 !== e.path) {
            var a = e.path;
            t.absolutePath || o && o.absolutePath || (a = ne(a)), void 0 === i && (a = a.replace(/^\/\//, "/%2F")), r.push(a);
        }
        return void 0 !== e.query && (r.push("?"), r.push(e.query)), void 0 !== e.fragment && (r.push("#"), r.push(e.fragment)), r.join("");
    }
    function oe(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {};
        return arguments[3] || (e = Q(re(e, n), n), t = Q(re(t, n), n)), !(n = n || {}).tolerant && t.scheme ? (r.scheme = t.scheme, r.userinfo = t.userinfo, r.host = t.host, r.port = t.port, r.path = ne(t.path || ""), r.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (r.userinfo = t.userinfo, r.host = t.host, r.port = t.port, r.path = ne(t.path || ""), r.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? r.path = ne(t.path) : (void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? r.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : r.path = t.path : r.path = "/" + t.path, r.path = ne(r.path)), r.query = t.query) : (r.path = e.path, void 0 !== t.query ? r.query = t.query : r.query = e.query), r.userinfo = e.userinfo, r.host = e.host, r.port = e.port), r.scheme = e.scheme), r.fragment = t.fragment, r;
    }
    function ie(e, t, n) {
        var r = a({
            scheme: "null"
        }, n);
        return re(oe(Q(e, r), Q(t, r), r, !0), r);
    }
    function ae(e, t) {
        return "string" == typeof e ? e = re(Q(e, t), t) : "object" === r(e) && (e = Q(re(e, t), t)), e;
    }
    function se(e, t, n) {
        return "string" == typeof e ? e = re(Q(e, n), n) : "object" === r(e) && (e = re(e, n)), "string" == typeof t ? t = re(Q(t, n), n) : "object" === r(t) && (t = re(t, n)), e === t;
    }
    function ce(e, t) {
        return e && e.toString().replace(t && t.iri ? l.ESCAPE : c.ESCAPE, F);
    }
    function le(e, t) {
        return e && e.toString().replace(t && t.iri ? l.PCT_ENCODED : c.PCT_ENCODED, V);
    }
    var ue = {
        scheme: "http",
        domainHost: !0,
        parse: function(e, t) {
            return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
        },
        serialize: function(e, t) {
            var n = "https" === String(e.scheme).toLowerCase();
            return e.port !== (n ? 443 : 80) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
        }
    }, fe = {
        scheme: "https",
        domainHost: ue.domainHost,
        parse: ue.parse,
        serialize: ue.serialize
    };
    function de(e) {
        return "boolean" == typeof e.secure ? e.secure : "wss" === String(e.scheme).toLowerCase();
    }
    var he = {
        scheme: "ws",
        domainHost: !0,
        parse: function(e, t) {
            var n = e;
            return n.secure = de(n), n.resourceName = (n.path || "/") + (n.query ? "?" + n.query : ""), n.path = void 0, n.query = void 0, n;
        },
        serialize: function(e, t) {
            if (e.port !== (de(e) ? 443 : 80) && "" !== e.port || (e.port = void 0), "boolean" == typeof e.secure && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
                var n = e.resourceName.split("?"), r = u(n, 2), o = r[0], i = r[1];
                e.path = o && "/" !== o ? o : void 0, e.query = i, e.resourceName = void 0;
            }
            return e.fragment = void 0, e;
        }
    }, ve = {
        scheme: "wss",
        domainHost: he.domainHost,
        parse: he.parse,
        serialize: he.serialize
    }, pe = {}, me = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", ge = "[0-9A-Fa-f]", ye = n(n("%[EFef]" + ge + "%" + ge + ge + "%" + ge + ge) + "|" + n("%[89A-Fa-f]" + ge + "%" + ge + ge) + "|" + n("%" + ge + ge)), be = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", we = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), xe = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", ke = new RegExp(me, "g"), je = new RegExp(ye, "g"), Se = new RegExp(t("[^]", be, "[\\.]", '[\\"]', we), "g"), Ce = new RegExp(t("[^]", me, xe), "g"), $e = Ce;
    function _e(e) {
        var t = V(e);
        return t.match(ke) ? t : e;
    }
    var Oe = {
        scheme: "mailto",
        parse: function(e, t) {
            var n = e, r = n.to = n.path ? n.path.split(",") : [];
            if (n.path = void 0, n.query) {
                for(var o = !1, i = {}, a = n.query.split("&"), s = 0, c = a.length; s < c; ++s){
                    var l = a[s].split("=");
                    switch(l[0]){
                        case "to":
                            for(var u = l[1].split(","), f = 0, d = u.length; f < d; ++f)r.push(u[f]);
                            break;
                        case "subject":
                            n.subject = le(l[1], t);
                            break;
                        case "body":
                            n.body = le(l[1], t);
                            break;
                        default:
                            o = !0, i[le(l[0], t)] = le(l[1], t);
                    }
                }
                o && (n.headers = i);
            }
            n.query = void 0;
            for(var h = 0, v = r.length; h < v; ++h){
                var p = r[h].split("@");
                if (p[0] = le(p[0]), t.unicodeSupport) p[1] = le(p[1], t).toLowerCase();
                else try {
                    p[1] = B.toASCII(le(p[1], t).toLowerCase());
                } catch (e) {
                    n.error = n.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                r[h] = p.join("@");
            }
            return n;
        },
        serialize: function(e, t) {
            var n = e, r = i(e.to);
            if (r) {
                for(var a = 0, s = r.length; a < s; ++a){
                    var c = String(r[a]), l = c.lastIndexOf("@"), u = c.slice(0, l).replace(je, _e).replace(je, o).replace(Se, F), f = c.slice(l + 1);
                    try {
                        f = t.iri ? B.toUnicode(f) : B.toASCII(le(f, t).toLowerCase());
                    } catch (e) {
                        n.error = n.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
                    }
                    r[a] = u + "@" + f;
                }
                n.path = r.join(",");
            }
            var d = e.headers = e.headers || {};
            e.subject && (d.subject = e.subject), e.body && (d.body = e.body);
            var h = [];
            for(var v in d)d[v] !== pe[v] && h.push(v.replace(je, _e).replace(je, o).replace(Ce, F) + "=" + d[v].replace(je, _e).replace(je, o).replace($e, F));
            return h.length && (n.query = h.join("&")), n;
        }
    }, Me = /^([^\:]+)\:(.*)/, Ee = {
        scheme: "urn",
        parse: function(e, t) {
            var n = e.path && e.path.match(Me), r = e;
            if (n) {
                var o = t.scheme || r.scheme || "urn", i = n[1].toLowerCase(), a = n[2], s = o + ":" + (t.nid || i), c = L[s];
                r.nid = i, r.nss = a, r.path = void 0, c && (r = c.parse(r, t));
            } else r.error = r.error || "URN can not be parsed.";
            return r;
        },
        serialize: function(e, t) {
            var n = t.scheme || e.scheme || "urn", r = e.nid, o = n + ":" + (t.nid || r), i = L[o];
            i && (e = i.serialize(e, t));
            var a = e, s = e.nss;
            return a.path = (r || t.nid) + ":" + s, a;
        }
    }, Ae = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, Pe = {
        scheme: "urn:uuid",
        parse: function(e, t) {
            var n = e;
            return n.uuid = n.nss, n.nss = void 0, t.tolerant || n.uuid && n.uuid.match(Ae) || (n.error = n.error || "UUID is not valid."), n;
        },
        serialize: function(e, t) {
            var n = e;
            return n.nss = (e.uuid || "").toLowerCase(), n;
        }
    };
    L[ue.scheme] = ue, L[fe.scheme] = fe, L[he.scheme] = he, L[ve.scheme] = ve, L[Oe.scheme] = Oe, L[Ee.scheme] = Ee, L[Pe.scheme] = Pe, e.SCHEMES = L, e.pctEncChar = F, e.pctDecChars = V, e.parse = Q, e.removeDotSegments = ne, e.serialize = re, e.resolveComponents = oe, e.resolve = ie, e.normalize = ae, e.equal = se, e.escapeComponent = ce, e.unescapeComponent = le, Object.defineProperty(e, "__esModule", {
        value: !0
    });
}(g5.exports);
var y5 = g5.exports;
Object.defineProperty(m5, "__esModule", {
    value: !0
});
var b5 = y5;
b5.code = 'require("ajv/dist/runtime/uri").default', m5.default = b5, function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = void 0;
    var t = J8();
    Object.defineProperty(e, "KeywordCxt", {
        enumerable: !0,
        get: function() {
            return t.KeywordCxt;
        }
    });
    var n = o8();
    Object.defineProperty(e, "_", {
        enumerable: !0,
        get: function() {
            return n._;
        }
    }), Object.defineProperty(e, "str", {
        enumerable: !0,
        get: function() {
            return n.str;
        }
    }), Object.defineProperty(e, "stringify", {
        enumerable: !0,
        get: function() {
            return n.stringify;
        }
    }), Object.defineProperty(e, "nil", {
        enumerable: !0,
        get: function() {
            return n.nil;
        }
    }), Object.defineProperty(e, "Name", {
        enumerable: !0,
        get: function() {
            return n.Name;
        }
    }), Object.defineProperty(e, "CodeGen", {
        enumerable: !0,
        get: function() {
            return n.CodeGen;
        }
    });
    var r = Q8(), o = Z8(), i = h8, a = e5, s = o8(), c = O8, l = d8, u = i8, f = p5, d = m5, h = function(e, t) {
        return new RegExp(e, t);
    };
    h.code = "new RegExp";
    var v = [
        "removeAdditional",
        "useDefaults",
        "coerceTypes"
    ], p = new Set([
        "validate",
        "serialize",
        "parse",
        "wrapper",
        "root",
        "schema",
        "keyword",
        "pattern",
        "formats",
        "validate$data",
        "func",
        "obj",
        "Error"
    ]), m = {
        errorDataPath: "",
        format: "`validateFormats: false` can be used instead.",
        nullable: '"nullable" keyword is supported by default.',
        jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
        extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
        missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
        processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
        sourceCode: "Use option `code: {source: true}`",
        strictDefaults: "It is default now, see option `strict`.",
        strictKeywords: "It is default now, see option `strict`.",
        uniqueItems: '"uniqueItems" keyword is always validated.',
        unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
        cache: "Map is used as cache, schema object as key.",
        serialize: "Map is used as cache, schema object as key.",
        ajvErrors: "It is default now."
    }, g = {
        ignoreKeywordsWithRef: "",
        jsPropertySyntax: "",
        unicode: '"minLength"/"maxLength" account for unicode characters by default.'
    };
    var y = function() {
        function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            No(this, e), this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = new Set, this._loading = {}, this._cache = new Map, t = this.opts = Ro(Ro({}, t), function(e) {
                var t, n, r, o, i, a, s, c, l, u, f, v, p, m, g, y, b, w, x, k, j, S, C, $, _, O = e.strict, M = null === (t = e.code) || void 0 === t ? void 0 : t.optimize, E = !0 === M || void 0 === M ? 1 : M || 0, A = null !== (r = null === (n = e.code) || void 0 === n ? void 0 : n.regExp) && void 0 !== r ? r : h, P = null !== (o = e.uriResolver) && void 0 !== o ? o : d.default;
                return {
                    strictSchema: null === (a = null !== (i = e.strictSchema) && void 0 !== i ? i : O) || void 0 === a || a,
                    strictNumbers: null === (c = null !== (s = e.strictNumbers) && void 0 !== s ? s : O) || void 0 === c || c,
                    strictTypes: null !== (u = null !== (l = e.strictTypes) && void 0 !== l ? l : O) && void 0 !== u ? u : "log",
                    strictTuples: null !== (v = null !== (f = e.strictTuples) && void 0 !== f ? f : O) && void 0 !== v ? v : "log",
                    strictRequired: null !== (m = null !== (p = e.strictRequired) && void 0 !== p ? p : O) && void 0 !== m && m,
                    code: e.code ? Ro(Ro({}, e.code), {}, {
                        optimize: E,
                        regExp: A
                    }) : {
                        optimize: E,
                        regExp: A
                    },
                    loopRequired: null !== (g = e.loopRequired) && void 0 !== g ? g : 200,
                    loopEnum: null !== (y = e.loopEnum) && void 0 !== y ? y : 200,
                    meta: null === (b = e.meta) || void 0 === b || b,
                    messages: null === (w = e.messages) || void 0 === w || w,
                    inlineRefs: null === (x = e.inlineRefs) || void 0 === x || x,
                    schemaId: null !== (k = e.schemaId) && void 0 !== k ? k : "$id",
                    addUsedSchema: null === (j = e.addUsedSchema) || void 0 === j || j,
                    validateSchema: null === (S = e.validateSchema) || void 0 === S || S,
                    validateFormats: null === (C = e.validateFormats) || void 0 === C || C,
                    unicodeRegExp: null === ($ = e.unicodeRegExp) || void 0 === $ || $,
                    int32range: null === (_ = e.int32range) || void 0 === _ || _,
                    uriResolver: P
                };
            }(t));
            var n = this.opts.code, r = n.es5, o = n.lines;
            this.scope = new s.ValueScope({
                scope: {},
                prefixes: p,
                es5: r,
                lines: o
            }), this.logger = function(e) {
                if (!1 === e) return C;
                if (void 0 === e) return console;
                if (e.log && e.warn && e.error) return e;
                throw new Error("logger must implement log, warn and error methods");
            }(t.logger);
            var a = t.validateFormats;
            t.validateFormats = !1, this.RULES = (0, i.getRules)(), b.call(this, m, t, "NOT SUPPORTED"), b.call(this, g, t, "DEPRECATED", "warn"), this._metaOpts = S.call(this), t.formats && k.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), t.keywords && j.call(this, t.keywords), "object" == Ho(t.meta) && this.addMetaSchema(t.meta), x.call(this), t.validateFormats = a;
        }
        return Do(e, [
            {
                key: "_addVocabularies",
                value: function() {
                    this.addKeyword("$async");
                }
            },
            {
                key: "_addDefaultMetaSchema",
                value: function() {
                    var e = this.opts, t = e.$data, n = e.meta, r = e.schemaId, o = f;
                    "id" === r && ((o = Ro({}, f)).id = o.$id, delete o.$id), n && t && this.addMetaSchema(o, o[r], !1);
                }
            },
            {
                key: "defaultMeta",
                value: function() {
                    var e = this.opts, t = e.meta, n = e.schemaId;
                    return this.opts.defaultMeta = "object" == Ho(t) ? t[n] || t : void 0;
                }
            },
            {
                key: "validate",
                value: function(e, t) {
                    var n;
                    if ("string" == typeof e) {
                        if (!(n = this.getSchema(e))) throw new Error('no schema with key or ref "'.concat(e, '"'));
                    } else n = this.compile(e);
                    var r = n(t);
                    return "$async" in n || (this.errors = n.errors), r;
                }
            },
            {
                key: "compile",
                value: function(e, t) {
                    var n = this._addSchema(e, t);
                    return n.validate || this._compileSchemaEnv(n);
                }
            },
            {
                key: "compileAsync",
                value: function(e, t) {
                    if ("function" != typeof this.opts.loadSchema) throw new Error("options.loadSchema should be a function");
                    var n = this.opts.loadSchema;
                    return r.call(this, e, t);
                    function r(e, t) {
                        return i.apply(this, arguments);
                    }
                    function i() {
                        return (i = ko(wo().mark(function e(t, n) {
                            var r;
                            return wo().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, a.call(this, t.$schema);
                                    case 2:
                                        return r = this._addSchema(t, n), e.abrupt("return", r.validate || c.call(this, r));
                                    case 4:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        }))).apply(this, arguments);
                    }
                    function a(e) {
                        return s.apply(this, arguments);
                    }
                    function s() {
                        return (s = ko(wo().mark(function e(t) {
                            return wo().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        if (!t || this.getSchema(t)) {
                                            e.next = 3;
                                            break;
                                        }
                                        return e.next = 3, r.call(this, {
                                            $ref: t
                                        }, !0);
                                    case 3:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        }))).apply(this, arguments);
                    }
                    function c(e) {
                        return l.apply(this, arguments);
                    }
                    function l() {
                        return (l = ko(wo().mark(function e(t) {
                            return wo().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.prev = 0, e.abrupt("return", this._compileSchemaEnv(t));
                                    case 4:
                                        if (e.prev = 4, e.t0 = e.catch(0), e.t0 instanceof o.default) {
                                            e.next = 8;
                                            break;
                                        }
                                        throw e.t0;
                                    case 8:
                                        return u.call(this, e.t0), e.next = 11, f.call(this, e.t0.missingSchema);
                                    case 11:
                                        return e.abrupt("return", c.call(this, t));
                                    case 12:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this, [
                                [
                                    0,
                                    4
                                ]
                            ]);
                        }))).apply(this, arguments);
                    }
                    function u(e) {
                        var t = e.missingSchema, n = e.missingRef;
                        if (this.refs[t]) throw new Error("AnySchema ".concat(t, " is loaded but ").concat(n, " cannot be resolved"));
                    }
                    function f(e) {
                        return d.apply(this, arguments);
                    }
                    function d() {
                        return d = ko(wo().mark(function e(n) {
                            var r;
                            return wo().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return e.next = 2, h.call(this, n);
                                    case 2:
                                        if (r = e.sent, this.refs[n]) {
                                            e.next = 6;
                                            break;
                                        }
                                        return e.next = 6, a.call(this, r.$schema);
                                    case 6:
                                        this.refs[n] || this.addSchema(r, n, t);
                                    case 7:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this);
                        })), d.apply(this, arguments);
                    }
                    function h(e) {
                        return v.apply(this, arguments);
                    }
                    function v() {
                        return v = ko(wo().mark(function e(t) {
                            var r;
                            return wo().wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        if (!(r = this._loading[t])) {
                                            e.next = 3;
                                            break;
                                        }
                                        return e.abrupt("return", r);
                                    case 3:
                                        return e.prev = 3, e.next = 6, this._loading[t] = n(t);
                                    case 6:
                                        return e.abrupt("return", e.sent);
                                    case 7:
                                        return e.prev = 7, delete this._loading[t], e.finish(7);
                                    case 10:
                                    case "end":
                                        return e.stop();
                                }
                            }, e, this, [
                                [
                                    3,
                                    ,
                                    7,
                                    10
                                ]
                            ]);
                        })), v.apply(this, arguments);
                    }
                }
            },
            {
                key: "addSchema",
                value: function(e, t, n) {
                    var r, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.validateSchema;
                    if (Array.isArray(e)) {
                        var i, a = bo(e);
                        try {
                            for(a.s(); !(i = a.n()).done;){
                                var s = i.value;
                                this.addSchema(s, void 0, n, o);
                            }
                        } catch (e) {
                            a.e(e);
                        } finally{
                            a.f();
                        }
                        return this;
                    }
                    if ("object" === Ho(e)) {
                        var l = this.opts.schemaId;
                        if (void 0 !== (r = e[l]) && "string" != typeof r) throw new Error("schema ".concat(l, " must be string"));
                    }
                    return t = (0, c.normalizeId)(t || r), this._checkUnique(t), this.schemas[t] = this._addSchema(e, n, t, o, !0), this;
                }
            },
            {
                key: "addMetaSchema",
                value: function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.opts.validateSchema;
                    return this.addSchema(e, t, !0, n), this;
                }
            },
            {
                key: "validateSchema",
                value: function(e, t) {
                    if ("boolean" == typeof e) return !0;
                    var n;
                    if (void 0 !== (n = e.$schema) && "string" != typeof n) throw new Error("$schema must be a string");
                    if (!(n = n || this.opts.defaultMeta || this.defaultMeta())) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
                    var r = this.validate(n, e);
                    if (!r && t) {
                        var o = "schema is invalid: " + this.errorsText();
                        if ("log" !== this.opts.validateSchema) throw new Error(o);
                        this.logger.error(o);
                    }
                    return r;
                }
            },
            {
                key: "getSchema",
                value: function(e) {
                    for(var t; "string" == typeof (t = w.call(this, e));)e = t;
                    if (void 0 === t) {
                        var n = this.opts.schemaId, r = new a.SchemaEnv({
                            schema: {},
                            schemaId: n
                        });
                        if (!(t = a.resolveSchema.call(this, r, e))) return;
                        this.refs[e] = t;
                    }
                    return t.validate || this._compileSchemaEnv(t);
                }
            },
            {
                key: "removeSchema",
                value: function(e) {
                    if (e instanceof RegExp) return this._removeAllSchemas(this.schemas, e), this._removeAllSchemas(this.refs, e), this;
                    switch(Ho(e)){
                        case "undefined":
                            return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
                        case "string":
                            var t = w.call(this, e);
                            return "object" == Ho(t) && this._cache.delete(t.schema), delete this.schemas[e], delete this.refs[e], this;
                        case "object":
                            var n = e;
                            this._cache.delete(n);
                            var r = e[this.opts.schemaId];
                            return r && (r = (0, c.normalizeId)(r), delete this.schemas[r], delete this.refs[r]), this;
                        default:
                            throw new Error("ajv.removeSchema: invalid parameter");
                    }
                }
            },
            {
                key: "addVocabulary",
                value: function(e) {
                    var t, n = bo(e);
                    try {
                        for(n.s(); !(t = n.n()).done;){
                            var r = t.value;
                            this.addKeyword(r);
                        }
                    } catch (e) {
                        n.e(e);
                    } finally{
                        n.f();
                    }
                    return this;
                }
            },
            {
                key: "addKeyword",
                value: function(e, t) {
                    var n, r = this;
                    if ("string" == typeof e) n = e, "object" == Ho(t) && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), t.keyword = n);
                    else {
                        if ("object" != Ho(e) || void 0 !== t) throw new Error("invalid addKeywords parameters");
                        if (n = (t = e).keyword, Array.isArray(n) && !n.length) throw new Error("addKeywords: keyword must be string or non-empty array");
                    }
                    if (_.call(this, n, t), !t) return (0, u.eachItem)(n, function(e) {
                        return O.call(r, e);
                    }), this;
                    E.call(this, t);
                    var o = Ro(Ro({}, t), {}, {
                        type: (0, l.getJSONTypes)(t.type),
                        schemaType: (0, l.getJSONTypes)(t.schemaType)
                    });
                    return (0, u.eachItem)(n, 0 === o.type.length ? function(e) {
                        return O.call(r, e, o);
                    } : function(e) {
                        return o.type.forEach(function(t) {
                            return O.call(r, e, o, t);
                        });
                    }), this;
                }
            },
            {
                key: "getKeyword",
                value: function(e) {
                    var t = this.RULES.all[e];
                    return "object" == Ho(t) ? t.definition : !!t;
                }
            },
            {
                key: "removeKeyword",
                value: function(e) {
                    var t = this.RULES;
                    delete t.keywords[e], delete t.all[e];
                    var n, r = bo(t.rules);
                    try {
                        for(r.s(); !(n = r.n()).done;){
                            var o = n.value, i = o.rules.findIndex(function(t) {
                                return t.keyword === e;
                            });
                            i >= 0 && o.rules.splice(i, 1);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                    return this;
                }
            },
            {
                key: "addFormat",
                value: function(e, t) {
                    return "string" == typeof t && (t = new RegExp(t)), this.formats[e] = t, this;
                }
            },
            {
                key: "errorsText",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.errors, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = t.separator, r = void 0 === n ? ", " : n, o = t.dataVar, i = void 0 === o ? "data" : o;
                    return e && 0 !== e.length ? e.map(function(e) {
                        return "".concat(i).concat(e.instancePath, " ").concat(e.message);
                    }).reduce(function(e, t) {
                        return e + r + t;
                    }) : "No errors";
                }
            },
            {
                key: "$dataMetaSchema",
                value: function(e, t) {
                    var n = this.RULES.all;
                    e = JSON.parse(JSON.stringify(e));
                    var r, o = bo(t);
                    try {
                        for(o.s(); !(r = o.n()).done;){
                            var i, a = r.value.split("/").slice(1), s = e, c = bo(a);
                            try {
                                for(c.s(); !(i = c.n()).done;)s = s[i.value];
                            } catch (e) {
                                c.e(e);
                            } finally{
                                c.f();
                            }
                            for(var l in n){
                                var u = n[l];
                                if ("object" == Ho(u)) {
                                    var f = u.definition.$data, d = s[l];
                                    f && d && (s[l] = P(d));
                                }
                            }
                        }
                    } catch (e) {
                        o.e(e);
                    } finally{
                        o.f();
                    }
                    return e;
                }
            },
            {
                key: "_removeAllSchemas",
                value: function(e, t) {
                    for(var n in e){
                        var r = e[n];
                        t && !t.test(n) || ("string" == typeof r ? delete e[n] : r && !r.meta && (this._cache.delete(r.schema), delete e[n]));
                    }
                }
            },
            {
                key: "_addSchema",
                value: function(e, t, n) {
                    var r, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.validateSchema, i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.opts.addUsedSchema, s = this.opts.schemaId;
                    if ("object" == Ho(e)) r = e[s];
                    else {
                        if (this.opts.jtd) throw new Error("schema must be object");
                        if ("boolean" != typeof e) throw new Error("schema must be object or boolean");
                    }
                    var l = this._cache.get(e);
                    if (void 0 !== l) return l;
                    n = (0, c.normalizeId)(r || n);
                    var u = c.getSchemaRefs.call(this, e, n);
                    return l = new a.SchemaEnv({
                        schema: e,
                        schemaId: s,
                        meta: t,
                        baseId: n,
                        localRefs: u
                    }), this._cache.set(l.schema, l), i && !n.startsWith("#") && (n && this._checkUnique(n), this.refs[n] = l), o && this.validateSchema(e, !0), l;
                }
            },
            {
                key: "_checkUnique",
                value: function(e) {
                    if (this.schemas[e] || this.refs[e]) throw new Error('schema with key or id "'.concat(e, '" already exists'));
                }
            },
            {
                key: "_compileSchemaEnv",
                value: function(e) {
                    if (e.meta ? this._compileMetaSchema(e) : a.compileSchema.call(this, e), !e.validate) throw new Error("ajv implementation error");
                    return e.validate;
                }
            },
            {
                key: "_compileMetaSchema",
                value: function(e) {
                    var t = this.opts;
                    this.opts = this._metaOpts;
                    try {
                        a.compileSchema.call(this, e);
                    } finally{
                        this.opts = t;
                    }
                }
            }
        ]), e;
    }();
    function b(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "error";
        for(var o in e){
            var i = o;
            i in t && this.logger[r]("".concat(n, ": option ").concat(o, ". ").concat(e[i]));
        }
    }
    function w(e) {
        return e = (0, c.normalizeId)(e), this.schemas[e] || this.refs[e];
    }
    function x() {
        var e = this.opts.schemas;
        if (e) {
            if (Array.isArray(e)) this.addSchema(e);
            else for(var t in e)this.addSchema(e[t], t);
        }
    }
    function k() {
        for(var e in this.opts.formats){
            var t = this.opts.formats[e];
            t && this.addFormat(e, t);
        }
    }
    function j(e) {
        if (Array.isArray(e)) this.addVocabulary(e);
        else for(var t in this.logger.warn("keywords option as map is deprecated, pass array"), e){
            var n = e[t];
            n.keyword || (n.keyword = t), this.addKeyword(n);
        }
    }
    function S() {
        var e, t = Ro({}, this.opts), n = bo(v);
        try {
            for(n.s(); !(e = n.n()).done;)delete t[e.value];
        } catch (e) {
            n.e(e);
        } finally{
            n.f();
        }
        return t;
    }
    e.default = y, y.ValidationError = r.default, y.MissingRefError = o.default;
    var C = {
        log: function() {},
        warn: function() {},
        error: function() {}
    };
    var $ = /^[a-z_$][a-z0-9_$:-]*$/i;
    function _(e, t) {
        var n = this.RULES;
        if ((0, u.eachItem)(e, function(e) {
            if (n.keywords[e]) throw new Error("Keyword ".concat(e, " is already defined"));
            if (!$.test(e)) throw new Error("Keyword ".concat(e, " has invalid name"));
        }), t && t.$data && !("code" in t) && !("validate" in t)) throw new Error('$data keyword must have "code" or "validate" function');
    }
    function O(e, t, n) {
        var r, o = this, i = null == t ? void 0 : t.post;
        if (n && i) throw new Error('keyword with "post" flag cannot have "type"');
        var a = this.RULES, s = i ? a.post : a.rules.find(function(e) {
            return e.type === n;
        });
        if (s || (s = {
            type: n,
            rules: []
        }, a.rules.push(s)), a.keywords[e] = !0, t) {
            var c = {
                keyword: e,
                definition: Ro(Ro({}, t), {}, {
                    type: (0, l.getJSONTypes)(t.type),
                    schemaType: (0, l.getJSONTypes)(t.schemaType)
                })
            };
            t.before ? M.call(this, s, c, t.before) : s.rules.push(c), a.all[e] = c, null === (r = t.implements) || void 0 === r || r.forEach(function(e) {
                return o.addKeyword(e);
            });
        }
    }
    function M(e, t, n) {
        var r = e.rules.findIndex(function(e) {
            return e.keyword === n;
        });
        r >= 0 ? e.rules.splice(r, 0, t) : (e.rules.push(t), this.logger.warn("rule ".concat(n, " is not defined")));
    }
    function E(e) {
        var t = e.metaSchema;
        void 0 !== t && (e.$data && this.opts.$data && (t = P(t)), e.validateSchema = this.compile(t, !0));
    }
    var A = {
        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
    };
    function P(e) {
        return {
            anyOf: [
                e,
                A
            ]
        };
    }
}(J6);
var w5 = {}, x5 = {}, k5 = {};
Object.defineProperty(k5, "__esModule", {
    value: !0
});
var j5 = {
    keyword: "id",
    code: function() {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
k5.default = j5;
var S5 = {};
Object.defineProperty(S5, "__esModule", {
    value: !0
}), S5.callRef = S5.getValidate = void 0;
var C5 = Z8(), $5 = S8(), _5 = o8(), O5 = u8(), M5 = e5, E5 = i8, A5 = {
    keyword: "$ref",
    schemaType: "string",
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.it, o = r.baseId, i = r.schemaEnv, a = r.validateName, s = r.opts, c = r.self, l = i.root;
        if (("#" === n || "#/" === n) && o === l.baseId) return function() {
            if (i === l) return T5(e, a, i, i.$async);
            var n = t.scopeValue("root", {
                ref: l
            });
            return T5(e, (0, _5._)(rn || (rn = mo([
                "",
                ".validate"
            ])), n), l, l.$async);
        }();
        var u, f, d = M5.resolveRef.call(c, l, o, n);
        if (void 0 === d) throw new C5.default(r.opts.uriResolver, o, n);
        return d instanceof M5.SchemaEnv ? (f = P5(e, u = d), void T5(e, f, u, u.$async)) : function(r) {
            var o = t.scopeValue("schema", !0 === s.code.source ? {
                ref: r,
                code: (0, _5.stringify)(r)
            } : {
                ref: r
            }), i = t.name("valid"), a = e.subschema({
                schema: r,
                dataTypes: [],
                schemaPath: _5.nil,
                topSchemaRef: o,
                errSchemaPath: n
            }, i);
            e.mergeEvaluated(a), e.ok(i);
        }(d);
    }
};
function P5(e, t) {
    var n = e.gen;
    return t.validate ? n.scopeValue("validate", {
        ref: t.validate
    }) : (0, _5._)(on || (on = mo([
        "",
        ".validate"
    ])), n.scopeValue("wrapper", {
        ref: t
    }));
}
function T5(e, t, n, r) {
    var o = e.gen, i = e.it, a = i.allErrors, s = i.schemaEnv, c = i.opts.passContext ? O5.default.this : _5.nil;
    function l(e) {
        var t = (0, _5._)(cn || (cn = mo([
            "",
            ".errors"
        ])), e);
        o.assign(O5.default.vErrors, (0, _5._)(ln || (ln = mo([
            "",
            " === null ? ",
            " : ",
            ".concat(",
            ")"
        ])), O5.default.vErrors, t, O5.default.vErrors, t)), o.assign(O5.default.errors, (0, _5._)(un || (un = mo([
            "",
            ".length"
        ])), O5.default.vErrors));
    }
    function u(e) {
        var t;
        if (i.opts.unevaluated) {
            var r = null === (t = null == n ? void 0 : n.validate) || void 0 === t ? void 0 : t.evaluated;
            if (!0 !== i.props) {
                if (r && !r.dynamicProps) void 0 !== r.props && (i.props = E5.mergeEvaluated.props(o, r.props, i.props));
                else {
                    var a = o.var("props", (0, _5._)(fn || (fn = mo([
                        "",
                        ".evaluated.props"
                    ])), e));
                    i.props = E5.mergeEvaluated.props(o, a, i.props, _5.Name);
                }
            }
            if (!0 !== i.items) {
                if (r && !r.dynamicItems) void 0 !== r.items && (i.items = E5.mergeEvaluated.items(o, r.items, i.items));
                else {
                    var s = o.var("items", (0, _5._)(dn || (dn = mo([
                        "",
                        ".evaluated.items"
                    ])), e));
                    i.items = E5.mergeEvaluated.items(o, s, i.items, _5.Name);
                }
            }
        }
    }
    r ? function() {
        if (!s.$async) throw new Error("async schema referenced by sync schema");
        var n = o.let("valid");
        o.try(function() {
            o.code((0, _5._)(an || (an = mo([
                "await ",
                ""
            ])), (0, $5.callValidateCode)(e, t, c))), u(t), a || o.assign(n, !0);
        }, function(e) {
            o.if((0, _5._)(sn || (sn = mo([
                "!(",
                " instanceof ",
                ")"
            ])), e, i.ValidationError), function() {
                return o.throw(e);
            }), l(e), a || o.assign(n, !1);
        }), e.ok(n);
    }() : e.result((0, $5.callValidateCode)(e, t, c), function() {
        return u(t);
    }, function() {
        return l(t);
    });
}
S5.getValidate = P5, S5.callRef = T5, S5.default = A5, Object.defineProperty(x5, "__esModule", {
    value: !0
});
var R5 = S5, N5 = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    k5.default,
    R5.default
];
x5.default = N5;
var I5 = {}, D5 = {};
Object.defineProperty(D5, "__esModule", {
    value: !0
});
var z5 = o8(), q5 = z5.operators, B5 = {
    maximum: {
        okStr: "<=",
        ok: q5.LTE,
        fail: q5.GT
    },
    minimum: {
        okStr: ">=",
        ok: q5.GTE,
        fail: q5.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: q5.LT,
        fail: q5.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: q5.GT,
        fail: q5.LTE
    }
}, L5 = {
    message: function(e) {
        var t = e.keyword, n = e.schemaCode;
        return (0, z5.str)(hn || (hn = mo([
            "must be ",
            " ",
            ""
        ])), B5[t].okStr, n);
    },
    params: function(e) {
        var t = e.keyword, n = e.schemaCode;
        return (0, z5._)(vn || (vn = mo([
            "{comparison: ",
            ", limit: ",
            "}"
        ])), B5[t].okStr, n);
    }
}, F5 = {
    keyword: Object.keys(B5),
    type: "number",
    schemaType: "number",
    $data: !0,
    error: L5,
    code: function(e) {
        var t = e.keyword, n = e.data, r = e.schemaCode;
        e.fail$data((0, z5._)(pn || (pn = mo([
            "",
            " ",
            " ",
            " || isNaN(",
            ")"
        ])), n, B5[t].fail, r, n));
    }
};
D5.default = F5;
var V5 = {};
Object.defineProperty(V5, "__esModule", {
    value: !0
});
var H5 = o8(), W5 = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: !0,
    error: {
        message: function(e) {
            var t = e.schemaCode;
            return (0, H5.str)(mn || (mn = mo([
                "must be multiple of ",
                ""
            ])), t);
        },
        params: function(e) {
            var t = e.schemaCode;
            return (0, H5._)(gn || (gn = mo([
                "{multipleOf: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.data, r = e.schemaCode, o = e.it.opts.multipleOfPrecision, i = t.let("res"), a = o ? (0, H5._)(yn || (yn = mo([
            "Math.abs(Math.round(",
            ") - ",
            ") > 1e-",
            ""
        ])), i, i, o) : (0, H5._)(bn || (bn = mo([
            "",
            " !== parseInt(",
            ")"
        ])), i, i);
        e.fail$data((0, H5._)(wn || (wn = mo([
            "(",
            " === 0 || (",
            " = ",
            "/",
            ", ",
            "))"
        ])), r, i, n, r, a));
    }
};
V5.default = W5;
var U5 = {}, J5 = {};
function K5(e) {
    for(var t, n = e.length, r = 0, o = 0; o < n;)r++, (t = e.charCodeAt(o++)) >= 55296 && t <= 56319 && o < n && 56320 == (64512 & (t = e.charCodeAt(o))) && o++;
    return r;
}
Object.defineProperty(J5, "__esModule", {
    value: !0
}), J5.default = K5, K5.code = 'require("ajv/dist/runtime/ucs2length").default', Object.defineProperty(U5, "__esModule", {
    value: !0
});
var G5 = o8(), Q5 = i8, Y5 = J5, X5 = {
    message: function(e) {
        var t = e.keyword, n = e.schemaCode, r = "maxLength" === t ? "more" : "fewer";
        return (0, G5.str)(xn || (xn = mo([
            "must NOT have ",
            " than ",
            " characters"
        ])), r, n);
    },
    params: function(e) {
        var t = e.schemaCode;
        return (0, G5._)(kn || (kn = mo([
            "{limit: ",
            "}"
        ])), t);
    }
}, Z5 = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: !0,
    error: X5,
    code: function(e) {
        var t = e.keyword, n = e.data, r = e.schemaCode, o = e.it, i = "maxLength" === t ? G5.operators.GT : G5.operators.LT, a = !1 === o.opts.unicode ? (0, G5._)(jn || (jn = mo([
            "",
            ".length"
        ])), n) : (0, G5._)(Sn || (Sn = mo([
            "",
            "(",
            ")"
        ])), (0, Q5.useFunc)(e.gen, Y5.default), n);
        e.fail$data((0, G5._)(Cn || (Cn = mo([
            "",
            " ",
            " ",
            ""
        ])), a, i, r));
    }
};
U5.default = Z5;
var e7 = {};
Object.defineProperty(e7, "__esModule", {
    value: !0
});
var t7 = S8(), n7 = o8(), r7 = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: !0,
    error: {
        message: function(e) {
            var t = e.schemaCode;
            return (0, n7.str)($n || ($n = mo([
                'must match pattern "',
                '"'
            ])), t);
        },
        params: function(e) {
            var t = e.schemaCode;
            return (0, n7._)(_n || (_n = mo([
                "{pattern: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.data, n = e.$data, r = e.schema, o = e.schemaCode, i = e.it.opts.unicodeRegExp ? "u" : "", a = n ? (0, n7._)(On || (On = mo([
            "(new RegExp(",
            ", ",
            "))"
        ])), o, i) : (0, t7.usePattern)(e, r);
        e.fail$data((0, n7._)(Mn || (Mn = mo([
            "!",
            ".test(",
            ")"
        ])), a, t));
    }
};
e7.default = r7;
var o7 = {};
Object.defineProperty(o7, "__esModule", {
    value: !0
});
var i7 = o8(), a7 = {
    message: function(e) {
        var t = e.keyword, n = e.schemaCode, r = "maxProperties" === t ? "more" : "fewer";
        return (0, i7.str)(En || (En = mo([
            "must NOT have ",
            " than ",
            " properties"
        ])), r, n);
    },
    params: function(e) {
        var t = e.schemaCode;
        return (0, i7._)(An || (An = mo([
            "{limit: ",
            "}"
        ])), t);
    }
}, s7 = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: !0,
    error: a7,
    code: function(e) {
        var t = e.keyword, n = e.data, r = e.schemaCode, o = "maxProperties" === t ? i7.operators.GT : i7.operators.LT;
        e.fail$data((0, i7._)(Pn || (Pn = mo([
            "Object.keys(",
            ").length ",
            " ",
            ""
        ])), n, o, r));
    }
};
o7.default = s7;
var c7 = {};
Object.defineProperty(c7, "__esModule", {
    value: !0
});
var l7 = S8(), u7 = o8(), f7 = i8, d7 = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: !0,
    error: {
        message: function(e) {
            var t = e.params.missingProperty;
            return (0, u7.str)(Tn || (Tn = mo([
                "must have required property '",
                "'"
            ])), t);
        },
        params: function(e) {
            var t = e.params.missingProperty;
            return (0, u7._)(Rn || (Rn = mo([
                "{missingProperty: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.schemaCode, o = e.data, i = e.$data, a = e.it, s = a.opts;
        if (i || 0 !== n.length) {
            var c = n.length >= s.loopRequired;
            if (a.allErrors ? function() {
                if (c || i) e.block$data(u7.nil, m);
                else {
                    var t, r = bo(n);
                    try {
                        for(r.s(); !(t = r.n()).done;){
                            var o = t.value;
                            (0, l7.checkReportMissingProp)(e, o);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }() : function() {
                var a = t.let("missing");
                if (c || i) {
                    var l = t.let("valid", !0);
                    e.block$data(l, function() {
                        return function(n, i) {
                            e.setParams({
                                missingProperty: n
                            }), t.forOf(n, r, function() {
                                t.assign(i, (0, l7.propertyInData)(t, o, n, s.ownProperties)), t.if((0, u7.not)(i), function() {
                                    e.error(), t.break();
                                });
                            }, u7.nil);
                        }(a, l);
                    }), e.ok(l);
                } else t.if((0, l7.checkMissingProp)(e, n, a)), (0, l7.reportMissingProp)(e, a), t.else();
            }(), s.strictRequired) {
                var l, u = e.parentSchema.properties, f = e.it.definedProperties, d = bo(n);
                try {
                    for(d.s(); !(l = d.n()).done;){
                        var h = l.value;
                        if (void 0 === (null == u ? void 0 : u[h]) && !f.has(h)) {
                            var v = a.schemaEnv.baseId + a.errSchemaPath, p = 'required property "'.concat(h, '" is not defined at "').concat(v, '" (strictRequired)');
                            (0, f7.checkStrictMode)(a, p, a.opts.strictRequired);
                        }
                    }
                } catch (e) {
                    d.e(e);
                } finally{
                    d.f();
                }
            }
        }
        function m() {
            t.forOf("prop", r, function(n) {
                e.setParams({
                    missingProperty: n
                }), t.if((0, l7.noPropertyInData)(t, o, n, s.ownProperties), function() {
                    return e.error();
                });
            });
        }
    }
};
c7.default = d7;
var h7 = {};
Object.defineProperty(h7, "__esModule", {
    value: !0
});
var v7 = o8(), p7 = {
    message: function(e) {
        var t = e.keyword, n = e.schemaCode, r = "maxItems" === t ? "more" : "fewer";
        return (0, v7.str)(Nn || (Nn = mo([
            "must NOT have ",
            " than ",
            " items"
        ])), r, n);
    },
    params: function(e) {
        var t = e.schemaCode;
        return (0, v7._)(In || (In = mo([
            "{limit: ",
            "}"
        ])), t);
    }
}, m7 = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: !0,
    error: p7,
    code: function(e) {
        var t = e.keyword, n = e.data, r = e.schemaCode, o = "maxItems" === t ? v7.operators.GT : v7.operators.LT;
        e.fail$data((0, v7._)(Dn || (Dn = mo([
            "",
            ".length ",
            " ",
            ""
        ])), n, o, r));
    }
};
h7.default = m7;
var g7 = {}, y7 = {};
Object.defineProperty(y7, "__esModule", {
    value: !0
});
var b7 = M8;
b7.code = 'require("ajv/dist/runtime/equal").default', y7.default = b7, Object.defineProperty(g7, "__esModule", {
    value: !0
});
var w7 = d8, x7 = o8(), k7 = i8, j7 = y7, S7 = {
    message: function(e) {
        var t = e.params, n = t.i, r = t.j;
        return (0, x7.str)(zn || (zn = mo([
            "must NOT have duplicate items (items ## ",
            " and ",
            " are identical)"
        ])), r, n);
    },
    params: function(e) {
        var t = e.params, n = t.i, r = t.j;
        return (0, x7._)(qn || (qn = mo([
            "{i: ",
            ", j: ",
            "}"
        ])), n, r);
    }
}, C7 = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: !0,
    error: S7,
    code: function(e) {
        var t = e.gen, n = e.data, r = e.$data, o = e.schema, i = e.parentSchema, a = e.schemaCode, s = e.it;
        if (r || o) {
            var c = t.let("valid"), l = i.items ? (0, w7.getSchemaTypes)(i.items) : [];
            e.block$data(c, function() {
                var r = t.let("i", (0, x7._)(Ln || (Ln = mo([
                    "",
                    ".length"
                ])), n)), o = t.let("j");
                e.setParams({
                    i: r,
                    j: o
                }), t.assign(c, !0), t.if((0, x7._)(Fn || (Fn = mo([
                    "",
                    " > 1"
                ])), r), function() {
                    return (l.length > 0 && !l.some(function(e) {
                        return "object" === e || "array" === e;
                    }) ? u : f)(r, o);
                });
            }, (0, x7._)(Bn || (Bn = mo([
                "",
                " === false"
            ])), a)), e.ok(c);
        }
        function u(r, o) {
            var i = t.name("item"), a = (0, w7.checkDataTypes)(l, i, s.opts.strictNumbers, w7.DataType.Wrong), u = t.const("indices", (0, x7._)(Vn || (Vn = mo([
                "{}"
            ]))));
            t.for((0, x7._)(Hn || (Hn = mo([
                ";",
                "--;"
            ])), r), function() {
                t.let(i, (0, x7._)(Wn || (Wn = mo([
                    "",
                    "[",
                    "]"
                ])), n, r)), t.if(a, (0, x7._)(Un || (Un = mo([
                    "continue"
                ])))), l.length > 1 && t.if((0, x7._)(Jn || (Jn = mo([
                    "typeof ",
                    ' == "string"'
                ])), i), (0, x7._)(Kn || (Kn = mo([
                    "",
                    ' += "_"'
                ])), i)), t.if((0, x7._)(Gn || (Gn = mo([
                    "typeof ",
                    "[",
                    '] == "number"'
                ])), u, i), function() {
                    t.assign(o, (0, x7._)(Qn || (Qn = mo([
                        "",
                        "[",
                        "]"
                    ])), u, i)), e.error(), t.assign(c, !1).break();
                }).code((0, x7._)(Yn || (Yn = mo([
                    "",
                    "[",
                    "] = ",
                    ""
                ])), u, i, r));
            });
        }
        function f(r, o) {
            var i = (0, k7.useFunc)(t, j7.default), a = t.name("outer");
            t.label(a).for((0, x7._)(Xn || (Xn = mo([
                ";",
                "--;"
            ])), r), function() {
                return t.for((0, x7._)(Zn || (Zn = mo([
                    "",
                    " = ",
                    "; ",
                    "--;"
                ])), o, r, o), function() {
                    return t.if((0, x7._)(er || (er = mo([
                        "",
                        "(",
                        "[",
                        "], ",
                        "[",
                        "])"
                    ])), i, n, r, n, o), function() {
                        e.error(), t.assign(c, !1).break(a);
                    });
                });
            });
        }
    }
};
g7.default = C7;
var $7 = {};
Object.defineProperty($7, "__esModule", {
    value: !0
});
var _7 = o8(), O7 = i8, M7 = y7, E7 = {
    keyword: "const",
    $data: !0,
    error: {
        message: "must be equal to constant",
        params: function(e) {
            var t = e.schemaCode;
            return (0, _7._)(tr || (tr = mo([
                "{allowedValue: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.data, r = e.$data, o = e.schemaCode, i = e.schema;
        r || i && "object" == Ho(i) ? e.fail$data((0, _7._)(nr || (nr = mo([
            "!",
            "(",
            ", ",
            ")"
        ])), (0, O7.useFunc)(t, M7.default), n, o)) : e.fail((0, _7._)(rr || (rr = mo([
            "",
            " !== ",
            ""
        ])), i, n));
    }
};
$7.default = E7;
var A7 = {};
Object.defineProperty(A7, "__esModule", {
    value: !0
});
var P7 = o8(), T7 = i8, R7 = y7, N7 = {
    keyword: "enum",
    schemaType: "array",
    $data: !0,
    error: {
        message: "must be equal to one of the allowed values",
        params: function(e) {
            var t = e.schemaCode;
            return (0, P7._)(or || (or = mo([
                "{allowedValues: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.data, r = e.$data, o = e.schema, i = e.schemaCode, a = e.it;
        if (!r && 0 === o.length) throw new Error("enum must have non-empty array");
        var s, c, l = o.length >= a.opts.loopEnum, u = function() {
            return null != s ? s : s = (0, T7.useFunc)(t, R7.default);
        };
        if (l || r) c = t.let("valid"), e.block$data(c, function() {
            t.assign(c, !1), t.forOf("v", i, function(e) {
                return t.if((0, P7._)(ir || (ir = mo([
                    "",
                    "(",
                    ", ",
                    ")"
                ])), u(), n, e), function() {
                    return t.assign(c, !0).break();
                });
            });
        });
        else {
            if (!Array.isArray(o)) throw new Error("ajv implementation error");
            var f = t.const("vSchema", i);
            c = P7.or.apply(void 0, Bo(o.map(function(e, t) {
                return function(e, t) {
                    var r = o[t];
                    return "object" === Ho(r) && null !== r ? (0, P7._)(ar || (ar = mo([
                        "",
                        "(",
                        ", ",
                        "[",
                        "])"
                    ])), u(), n, e, t) : (0, P7._)(sr || (sr = mo([
                        "",
                        " === ",
                        ""
                    ])), n, r);
                }(f, t);
            })));
        }
        e.pass(c);
    }
};
A7.default = N7, Object.defineProperty(I5, "__esModule", {
    value: !0
});
var I7 = V5, D7 = U5, z7 = e7, q7 = o7, B7 = c7, L7 = h7, F7 = g7, V7 = $7, H7 = A7, W7 = [
    D5.default,
    I7.default,
    D7.default,
    z7.default,
    q7.default,
    B7.default,
    L7.default,
    F7.default,
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    V7.default,
    H7.default
];
I5.default = W7;
var U7 = {}, J7 = {};
Object.defineProperty(J7, "__esModule", {
    value: !0
}), J7.validateAdditionalItems = void 0;
var K7 = o8(), G7 = i8, Q7 = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: {
        message: function(e) {
            var t = e.params.len;
            return (0, K7.str)(cr || (cr = mo([
                "must NOT have more than ",
                " items"
            ])), t);
        },
        params: function(e) {
            var t = e.params.len;
            return (0, K7._)(lr || (lr = mo([
                "{limit: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.parentSchema, n = e.it, r = t.items;
        Array.isArray(r) ? Y7(e, r) : (0, G7.checkStrictMode)(n, '"additionalItems" is ignored when "items" is not an array of schemas');
    }
};
function Y7(e, t) {
    var n = e.gen, r = e.schema, o = e.data, i = e.keyword, a = e.it;
    a.items = !0;
    var s = n.const("len", (0, K7._)(ur || (ur = mo([
        "",
        ".length"
    ])), o));
    if (!1 === r) e.setParams({
        len: t.length
    }), e.pass((0, K7._)(fr || (fr = mo([
        "",
        " <= ",
        ""
    ])), s, t.length));
    else if ("object" == Ho(r) && !(0, G7.alwaysValidSchema)(a, r)) {
        var c = n.var("valid", (0, K7._)(dr || (dr = mo([
            "",
            " <= ",
            ""
        ])), s, t.length));
        n.if((0, K7.not)(c), function() {
            return function(r) {
                n.forRange("i", t.length, s, function(t) {
                    e.subschema({
                        keyword: i,
                        dataProp: t,
                        dataPropType: G7.Type.Num
                    }, r), a.allErrors || n.if((0, K7.not)(r), function() {
                        return n.break();
                    });
                });
            }(c);
        }), e.ok(c);
    }
}
J7.validateAdditionalItems = Y7, J7.default = Q7;
var X7 = {}, Z7 = {};
Object.defineProperty(Z7, "__esModule", {
    value: !0
}), Z7.validateTuple = void 0;
var e9 = o8(), t9 = i8, n9 = S8(), r9 = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code: function(e) {
        var t = e.schema, n = e.it;
        if (Array.isArray(t)) return o9(e, "additionalItems", t);
        n.items = !0, (0, t9.alwaysValidSchema)(n, t) || e.ok((0, n9.validateArray)(e));
    }
};
function o9(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.schema, r = e.gen, o = e.parentSchema, i = e.data, a = e.keyword, s = e.it;
    !function(e) {
        var r = s.opts, o = s.errSchemaPath, i = n.length, c = i === e.minItems && (i === e.maxItems || !1 === e[t]);
        if (r.strictTuples && !c) {
            var l = '"'.concat(a, '" is ').concat(i, "-tuple, but minItems or maxItems/").concat(t, ' are not specified or different at path "').concat(o, '"');
            (0, t9.checkStrictMode)(s, l, r.strictTuples);
        }
    }(o), s.opts.unevaluated && n.length && !0 !== s.items && (s.items = t9.mergeEvaluated.items(r, n.length, s.items));
    var c = r.name("valid"), l = r.const("len", (0, e9._)(hr || (hr = mo([
        "",
        ".length"
    ])), i));
    n.forEach(function(t, n) {
        (0, t9.alwaysValidSchema)(s, t) || (r.if((0, e9._)(vr || (vr = mo([
            "",
            " > ",
            ""
        ])), l, n), function() {
            return e.subschema({
                keyword: a,
                schemaProp: n,
                dataProp: n
            }, c);
        }), e.ok(c));
    });
}
Z7.validateTuple = o9, Z7.default = r9, Object.defineProperty(X7, "__esModule", {
    value: !0
});
var i9 = Z7, a9 = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: function(e) {
        return (0, i9.validateTuple)(e, "items");
    }
};
X7.default = a9;
var s9 = {};
Object.defineProperty(s9, "__esModule", {
    value: !0
});
var c9 = o8(), l9 = i8, u9 = S8(), f9 = J7, d9 = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: {
        message: function(e) {
            var t = e.params.len;
            return (0, c9.str)(pr || (pr = mo([
                "must NOT have more than ",
                " items"
            ])), t);
        },
        params: function(e) {
            var t = e.params.len;
            return (0, c9._)(mr || (mr = mo([
                "{limit: ",
                "}"
            ])), t);
        }
    },
    code: function(e) {
        var t = e.schema, n = e.parentSchema, r = e.it, o = n.prefixItems;
        r.items = !0, (0, l9.alwaysValidSchema)(r, t) || (o ? (0, f9.validateAdditionalItems)(e, o) : e.ok((0, u9.validateArray)(e)));
    }
};
s9.default = d9;
var h9 = {};
Object.defineProperty(h9, "__esModule", {
    value: !0
});
var v9 = o8(), p9 = i8, m9 = {
    message: function(e) {
        var t = e.params, n = t.min, r = t.max;
        return void 0 === r ? (0, v9.str)(gr || (gr = mo([
            "must contain at least ",
            " valid item(s)"
        ])), n) : (0, v9.str)(yr || (yr = mo([
            "must contain at least ",
            " and no more than ",
            " valid item(s)"
        ])), n, r);
    },
    params: function(e) {
        var t = e.params, n = t.min, r = t.max;
        return void 0 === r ? (0, v9._)(br || (br = mo([
            "{minContains: ",
            "}"
        ])), n) : (0, v9._)(wr || (wr = mo([
            "{minContains: ",
            ", maxContains: ",
            "}"
        ])), n, r);
    }
}, g9 = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: !0,
    error: m9,
    code: function(e) {
        var t, n, r = e.gen, o = e.schema, i = e.parentSchema, a = e.data, s = e.it, c = i.minContains, l = i.maxContains;
        s.opts.next ? (t = void 0 === c ? 1 : c, n = l) : t = 1;
        var u = r.const("len", (0, v9._)(xr || (xr = mo([
            "",
            ".length"
        ])), a));
        if (e.setParams({
            min: t,
            max: n
        }), void 0 !== n || 0 !== t) {
            if (void 0 !== n && t > n) return (0, p9.checkStrictMode)(s, '"minContains" > "maxContains" is always invalid'), void e.fail();
            if ((0, p9.alwaysValidSchema)(s, o)) {
                var f = (0, v9._)(kr || (kr = mo([
                    "",
                    " >= ",
                    ""
                ])), u, t);
                return void 0 !== n && (f = (0, v9._)(jr || (jr = mo([
                    "",
                    " && ",
                    " <= ",
                    ""
                ])), f, u, n)), void e.pass(f);
            }
            s.items = !0;
            var d = r.name("valid");
            void 0 === n && 1 === t ? v(d, function() {
                return r.if(d, function() {
                    return r.break();
                });
            }) : 0 === t ? (r.let(d, !0), void 0 !== n && r.if((0, v9._)(Sr || (Sr = mo([
                "",
                ".length > 0"
            ])), a), h)) : (r.let(d, !1), h()), e.result(d, function() {
                return e.reset();
            });
        } else (0, p9.checkStrictMode)(s, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
        function h() {
            var e = r.name("_valid"), o = r.let("count", 0);
            v(e, function() {
                return r.if(e, function() {
                    return function(e) {
                        r.code((0, v9._)(Cr || (Cr = mo([
                            "",
                            "++"
                        ])), e)), void 0 === n ? r.if((0, v9._)($r || ($r = mo([
                            "",
                            " >= ",
                            ""
                        ])), e, t), function() {
                            return r.assign(d, !0).break();
                        }) : (r.if((0, v9._)(_r || (_r = mo([
                            "",
                            " > ",
                            ""
                        ])), e, n), function() {
                            return r.assign(d, !1).break();
                        }), 1 === t ? r.assign(d, !0) : r.if((0, v9._)(Or || (Or = mo([
                            "",
                            " >= ",
                            ""
                        ])), e, t), function() {
                            return r.assign(d, !0);
                        }));
                    }(o);
                });
            });
        }
        function v(t, n) {
            r.forRange("i", 0, u, function(r) {
                e.subschema({
                    keyword: "contains",
                    dataProp: r,
                    dataPropType: p9.Type.Num,
                    compositeRule: !0
                }, t), n();
            });
        }
    }
};
h9.default = g9;
var y9 = {};
!function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.validateSchemaDeps = e.validatePropertyDeps = e.error = void 0;
    var t = o8(), n = i8, r = S8();
    e.error = {
        message: function(e) {
            var n = e.params, r = n.property, o = n.depsCount, i = n.deps, a = 1 === o ? "property" : "properties";
            return (0, t.str)(Mr || (Mr = mo([
                "must have ",
                " ",
                " when property ",
                " is present"
            ])), a, i, r);
        },
        params: function(e) {
            var n = e.params, r = n.property, o = n.depsCount, i = n.deps, a = n.missingProperty;
            return (0, t._)(Er || (Er = mo([
                "{property: ",
                ",\n    missingProperty: ",
                ",\n    depsCount: ",
                ",\n    deps: ",
                "}"
            ])), r, a, o, i);
        }
    };
    var o = {
        keyword: "dependencies",
        type: "object",
        schemaType: "object",
        error: e.error,
        code: function(e) {
            var t = jo(function(e) {
                var t = e.schema, n = {}, r = {};
                for(var o in t)if ("__proto__" !== o) (Array.isArray(t[o]) ? n : r)[o] = t[o];
                return [
                    n,
                    r
                ];
            }(e), 2), n = t[0], r = t[1];
            i(e, n), a(e, r);
        }
    };
    function i(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema, o = e.gen, i = e.data, a = e.it;
        if (0 !== Object.keys(n).length) {
            var s = o.let("missing"), c = function() {
                var c = n[l];
                if (0 === c.length) return 1;
                var u = (0, r.propertyInData)(o, i, l, a.opts.ownProperties);
                e.setParams({
                    property: l,
                    depsCount: c.length,
                    deps: c.join(", ")
                }), a.allErrors ? o.if(u, function() {
                    var t, n = bo(c);
                    try {
                        for(n.s(); !(t = n.n()).done;){
                            var o = t.value;
                            (0, r.checkReportMissingProp)(e, o);
                        }
                    } catch (e) {
                        n.e(e);
                    } finally{
                        n.f();
                    }
                }) : (o.if((0, t._)(Ar || (Ar = mo([
                    "",
                    " && (",
                    ")"
                ])), u, (0, r.checkMissingProp)(e, c, s))), (0, r.reportMissingProp)(e, s), o.else());
            };
            for(var l in n)c();
        }
    }
    function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema, o = e.gen, i = e.data, a = e.keyword, s = e.it, c = o.name("valid"), l = function(l) {
            if ((0, n.alwaysValidSchema)(s, t[l])) return 1;
            o.if((0, r.propertyInData)(o, i, l, s.opts.ownProperties), function() {
                var t = e.subschema({
                    keyword: a,
                    schemaProp: l
                }, c);
                e.mergeValidEvaluated(t, c);
            }, function() {
                return o.var(c, !0);
            }), e.ok(c);
        };
        for(var u in t)l(u);
    }
    e.validatePropertyDeps = i, e.validateSchemaDeps = a, e.default = o;
}(y9);
var b9 = {};
Object.defineProperty(b9, "__esModule", {
    value: !0
});
var w9 = o8(), x9 = i8, k9 = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: {
        message: "property name must be valid",
        params: function(e) {
            var t = e.params;
            return (0, w9._)(Pr || (Pr = mo([
                "{propertyName: ",
                "}"
            ])), t.propertyName);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.data, o = e.it;
        if (!(0, x9.alwaysValidSchema)(o, n)) {
            var i = t.name("valid");
            t.forIn("key", r, function(n) {
                e.setParams({
                    propertyName: n
                }), e.subschema({
                    keyword: "propertyNames",
                    data: n,
                    dataTypes: [
                        "string"
                    ],
                    propertyName: n,
                    compositeRule: !0
                }, i), t.if((0, w9.not)(i), function() {
                    e.error(!0), o.allErrors || t.break();
                });
            }), e.ok(i);
        }
    }
};
b9.default = k9;
var j9 = {};
Object.defineProperty(j9, "__esModule", {
    value: !0
});
var S9 = S8(), C9 = o8(), $9 = u8(), _9 = i8, O9 = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: !0,
    trackErrors: !0,
    error: {
        message: "must NOT have additional properties",
        params: function(e) {
            var t = e.params;
            return (0, C9._)(Tr || (Tr = mo([
                "{additionalProperty: ",
                "}"
            ])), t.additionalProperty);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.parentSchema, o = e.data, i = e.errsCount, a = e.it;
        if (!i) throw new Error("ajv implementation error");
        var s = a.allErrors, c = a.opts;
        if (a.props = !0, "all" === c.removeAdditional || !(0, _9.alwaysValidSchema)(a, n)) {
            var l = (0, S9.allSchemaProperties)(r.properties), u = (0, S9.allSchemaProperties)(r.patternProperties);
            t.forIn("key", o, function(n) {
                l.length || u.length ? t.if(function(n) {
                    var o;
                    if (l.length > 8) {
                        var i = (0, _9.schemaRefOrVal)(a, r.properties, "properties");
                        o = (0, S9.isOwnProperty)(t, i, n);
                    } else o = l.length ? C9.or.apply(void 0, Bo(l.map(function(e) {
                        return (0, C9._)(Nr || (Nr = mo([
                            "",
                            " === ",
                            ""
                        ])), n, e);
                    }))) : C9.nil;
                    return u.length && (o = C9.or.apply(void 0, [
                        o
                    ].concat(Bo(u.map(function(t) {
                        return (0, C9._)(Ir || (Ir = mo([
                            "",
                            ".test(",
                            ")"
                        ])), (0, S9.usePattern)(e, t), n);
                    }))))), (0, C9.not)(o);
                }(n), function() {
                    return d(n);
                }) : d(n);
            }), e.ok((0, C9._)(Rr || (Rr = mo([
                "",
                " === ",
                ""
            ])), i, $9.default.errors));
        }
        function f(e) {
            t.code((0, C9._)(Dr || (Dr = mo([
                "delete ",
                "[",
                "]"
            ])), o, e));
        }
        function d(r) {
            if ("all" === c.removeAdditional || c.removeAdditional && !1 === n) f(r);
            else {
                if (!1 === n) return e.setParams({
                    additionalProperty: r
                }), e.error(), void (s || t.break());
                if ("object" == Ho(n) && !(0, _9.alwaysValidSchema)(a, n)) {
                    var o = t.name("valid");
                    "failing" === c.removeAdditional ? (h(r, o, !1), t.if((0, C9.not)(o), function() {
                        e.reset(), f(r);
                    })) : (h(r, o), s || t.if((0, C9.not)(o), function() {
                        return t.break();
                    }));
                }
            }
        }
        function h(t, n, r) {
            var o = {
                keyword: "additionalProperties",
                dataProp: t,
                dataPropType: _9.Type.Str
            };
            !1 === r && Object.assign(o, {
                compositeRule: !0,
                createErrors: !1,
                allErrors: !1
            }), e.subschema(o, n);
        }
    }
};
j9.default = O9;
var M9 = {};
Object.defineProperty(M9, "__esModule", {
    value: !0
});
var E9 = J8(), A9 = S8(), P9 = i8, T9 = j9, R9 = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.parentSchema, o = e.data, i = e.it;
        "all" === i.opts.removeAdditional && void 0 === r.additionalProperties && T9.default.code(new E9.KeywordCxt(i, T9.default, "additionalProperties"));
        var a, s = (0, A9.allSchemaProperties)(n), c = bo(s);
        try {
            for(c.s(); !(a = c.n()).done;){
                var l = a.value;
                i.definedProperties.add(l);
            }
        } catch (e) {
            c.e(e);
        } finally{
            c.f();
        }
        i.opts.unevaluated && s.length && !0 !== i.props && (i.props = P9.mergeEvaluated.props(t, (0, P9.toHash)(s), i.props));
        var u = s.filter(function(e) {
            return !(0, P9.alwaysValidSchema)(i, n[e]);
        });
        if (0 !== u.length) {
            var f, d = t.name("valid"), h = bo(u);
            try {
                for(h.s(); !(f = h.n()).done;){
                    var v = f.value;
                    p(v) ? m(v) : (t.if((0, A9.propertyInData)(t, o, v, i.opts.ownProperties)), m(v), i.allErrors || t.else().var(d, !0), t.endIf()), e.it.definedProperties.add(v), e.ok(d);
                }
            } catch (e) {
                h.e(e);
            } finally{
                h.f();
            }
        }
        function p(e) {
            return i.opts.useDefaults && !i.compositeRule && void 0 !== n[e].default;
        }
        function m(t) {
            e.subschema({
                keyword: "properties",
                schemaProp: t,
                dataProp: t
            }, d);
        }
    }
};
M9.default = R9;
var N9 = {};
Object.defineProperty(N9, "__esModule", {
    value: !0
});
var I9 = S8(), D9 = o8(), z9 = i8, q9 = i8, B9 = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.data, o = e.parentSchema, i = e.it, a = i.opts, s = (0, I9.allSchemaProperties)(n), c = s.filter(function(e) {
            return (0, z9.alwaysValidSchema)(i, n[e]);
        });
        if (0 !== s.length && (c.length !== s.length || i.opts.unevaluated && !0 !== i.props)) {
            var l = a.strictSchema && !a.allowMatchingProperties && o.properties, u = t.name("valid");
            !0 === i.props || i.props instanceof D9.Name || (i.props = (0, q9.evaluatedPropsToName)(t, i.props));
            var f = i.props;
            !function() {
                var e, n = bo(s);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var r = e.value;
                        l && d(r), i.allErrors ? h(r) : (t.var(u, !0), h(r), t.if(u));
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
            }();
        }
        function d(e) {
            for(var t in l)new RegExp(e).test(t) && (0, z9.checkStrictMode)(i, "property ".concat(t, " matches pattern ").concat(e, " (use allowMatchingProperties)"));
        }
        function h(n) {
            t.forIn("key", r, function(r) {
                t.if((0, D9._)(zr || (zr = mo([
                    "",
                    ".test(",
                    ")"
                ])), (0, I9.usePattern)(e, n), r), function() {
                    var o = c.includes(n);
                    o || e.subschema({
                        keyword: "patternProperties",
                        schemaProp: n,
                        dataProp: r,
                        dataPropType: q9.Type.Str
                    }, u), i.opts.unevaluated && !0 !== f ? t.assign((0, D9._)(qr || (qr = mo([
                        "",
                        "[",
                        "]"
                    ])), f, r), !0) : o || i.allErrors || t.if((0, D9.not)(u), function() {
                        return t.break();
                    });
                });
            });
        }
    }
};
N9.default = B9;
var L9 = {};
Object.defineProperty(L9, "__esModule", {
    value: !0
});
var F9 = i8, V9 = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: !0,
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.it;
        if ((0, F9.alwaysValidSchema)(r, n)) e.fail();
        else {
            var o = t.name("valid");
            e.subschema({
                keyword: "not",
                compositeRule: !0,
                createErrors: !1,
                allErrors: !1
            }, o), e.failResult(o, function() {
                return e.reset();
            }, function() {
                return e.error();
            });
        }
    },
    error: {
        message: "must NOT be valid"
    }
};
L9.default = V9;
var H9 = {};
Object.defineProperty(H9, "__esModule", {
    value: !0
});
var W9 = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: !0,
    code: S8().validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
H9.default = W9;
var U9 = {};
Object.defineProperty(U9, "__esModule", {
    value: !0
});
var J9 = o8(), K9 = i8, G9 = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: !0,
    error: {
        message: "must match exactly one schema in oneOf",
        params: function(e) {
            var t = e.params;
            return (0, J9._)(Br || (Br = mo([
                "{passingSchemas: ",
                "}"
            ])), t.passing);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.parentSchema, o = e.it;
        if (!Array.isArray(n)) throw new Error("ajv implementation error");
        if (!o.opts.discriminator || !r.discriminator) {
            var i = n, a = t.let("valid", !1), s = t.let("passing", null), c = t.name("_valid");
            e.setParams({
                passing: s
            }), t.block(function() {
                i.forEach(function(n, r) {
                    var i;
                    (0, K9.alwaysValidSchema)(o, n) ? t.var(c, !0) : i = e.subschema({
                        keyword: "oneOf",
                        schemaProp: r,
                        compositeRule: !0
                    }, c), r > 0 && t.if((0, J9._)(Lr || (Lr = mo([
                        "",
                        " && ",
                        ""
                    ])), c, a)).assign(a, !1).assign(s, (0, J9._)(Fr || (Fr = mo([
                        "[",
                        ", ",
                        "]"
                    ])), s, r)).else(), t.if(c, function() {
                        t.assign(a, !0), t.assign(s, r), i && e.mergeEvaluated(i, J9.Name);
                    });
                });
            }), e.result(a, function() {
                return e.reset();
            }, function() {
                return e.error(!0);
            });
        }
    }
};
U9.default = G9;
var Q9 = {};
Object.defineProperty(Q9, "__esModule", {
    value: !0
});
var Y9 = i8, X9 = {
    keyword: "allOf",
    schemaType: "array",
    code: function(e) {
        var t = e.gen, n = e.schema, r = e.it;
        if (!Array.isArray(n)) throw new Error("ajv implementation error");
        var o = t.name("valid");
        n.forEach(function(t, n) {
            if (!(0, Y9.alwaysValidSchema)(r, t)) {
                var i = e.subschema({
                    keyword: "allOf",
                    schemaProp: n
                }, o);
                e.ok(o), e.mergeEvaluated(i);
            }
        });
    }
};
Q9.default = X9;
var Z9 = {};
Object.defineProperty(Z9, "__esModule", {
    value: !0
});
var eee = o8(), tee = i8, nee = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: !0,
    error: {
        message: function(e) {
            var t = e.params;
            return (0, eee.str)(Vr || (Vr = mo([
                'must match "',
                '" schema'
            ])), t.ifClause);
        },
        params: function(e) {
            var t = e.params;
            return (0, eee._)(Hr || (Hr = mo([
                "{failingKeyword: ",
                "}"
            ])), t.ifClause);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.parentSchema, r = e.it;
        void 0 === n.then && void 0 === n.else && (0, tee.checkStrictMode)(r, '"if" without "then" and "else" is ignored');
        var o = ree(r, "then"), i = ree(r, "else");
        if (o || i) {
            var a, s = t.let("valid", !0), c = t.name("_valid");
            if (a = e.subschema({
                keyword: "if",
                compositeRule: !0,
                createErrors: !1,
                allErrors: !1
            }, c), e.mergeEvaluated(a), e.reset(), o && i) {
                var l = t.let("ifClause");
                e.setParams({
                    ifClause: l
                }), t.if(c, u("then", l), u("else", l));
            } else o ? t.if(c, u("then")) : t.if((0, eee.not)(c), u("else"));
            e.pass(s, function() {
                return e.error(!0);
            });
        }
        function u(n, r) {
            return function() {
                var o = e.subschema({
                    keyword: n
                }, c);
                t.assign(s, c), e.mergeValidEvaluated(o, s), r ? t.assign(r, (0, eee._)(Wr || (Wr = mo([
                    "",
                    ""
                ])), n)) : e.setParams({
                    ifClause: n
                });
            };
        }
    }
};
function ree(e, t) {
    var n = e.schema[t];
    return void 0 !== n && !(0, tee.alwaysValidSchema)(e, n);
}
Z9.default = nee;
var oee = {};
Object.defineProperty(oee, "__esModule", {
    value: !0
});
var iee = i8, aee = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code: function(e) {
        var t = e.keyword, n = e.parentSchema, r = e.it;
        void 0 === n.if && (0, iee.checkStrictMode)(r, '"'.concat(t, '" without "if" is ignored'));
    }
};
oee.default = aee, Object.defineProperty(U7, "__esModule", {
    value: !0
});
var see = J7, cee = X7, lee = Z7, uee = s9, fee = h9, dee = y9, hee = b9, vee = j9, pee = M9, mee = N9, gee = L9, yee = H9, bee = U9, wee = Q9, xee = Z9, kee = oee;
U7.default = function() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = [
        gee.default,
        yee.default,
        bee.default,
        wee.default,
        xee.default,
        kee.default,
        hee.default,
        vee.default,
        dee.default,
        pee.default,
        mee.default
    ];
    return e ? t.push(cee.default, uee.default) : t.push(see.default, lee.default), t.push(fee.default), t;
};
var jee = {}, See = {};
Object.defineProperty(See, "__esModule", {
    value: !0
});
var Cee = o8(), $ee = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: !0,
    error: {
        message: function(e) {
            var t = e.schemaCode;
            return (0, Cee.str)(Ur || (Ur = mo([
                'must match format "',
                '"'
            ])), t);
        },
        params: function(e) {
            var t = e.schemaCode;
            return (0, Cee._)(Jr || (Jr = mo([
                "{format: ",
                "}"
            ])), t);
        }
    },
    code: function(e, t) {
        var n = e.gen, r = e.data, o = e.$data, i = e.schema, a = e.schemaCode, s = e.it, c = s.opts, l = s.errSchemaPath, u = s.schemaEnv, f = s.self;
        c.validateFormats && (o ? function() {
            var o = n.scopeValue("formats", {
                ref: f.formats,
                code: c.code.formats
            }), i = n.const("fDef", (0, Cee._)(Kr || (Kr = mo([
                "",
                "[",
                "]"
            ])), o, a)), s = n.let("fType"), l = n.let("format");
            n.if((0, Cee._)(Gr || (Gr = mo([
                "typeof ",
                ' == "object" && !(',
                " instanceof RegExp)"
            ])), i, i), function() {
                return n.assign(s, (0, Cee._)(Qr || (Qr = mo([
                    "",
                    '.type || "string"'
                ])), i)).assign(l, (0, Cee._)(Yr || (Yr = mo([
                    "",
                    ".validate"
                ])), i));
            }, function() {
                return n.assign(s, (0, Cee._)(Xr || (Xr = mo([
                    '"string"'
                ])))).assign(l, i);
            }), e.fail$data((0, Cee.or)(!1 === c.strictSchema ? Cee.nil : (0, Cee._)(Zr || (Zr = mo([
                "",
                " && !",
                ""
            ])), a, l), (d = u.$async ? (0, Cee._)(eo || (eo = mo([
                "(",
                ".async ? await ",
                "(",
                ") : ",
                "(",
                "))"
            ])), i, l, r, l, r) : (0, Cee._)(to || (to = mo([
                "",
                "(",
                ")"
            ])), l, r), h = (0, Cee._)(no || (no = mo([
                "(typeof ",
                ' == "function" ? ',
                " : ",
                ".test(",
                "))"
            ])), l, d, l, r), (0, Cee._)(ro || (ro = mo([
                "",
                " && ",
                " !== true && ",
                " === ",
                " && !",
                ""
            ])), l, l, s, t, h))));
            var d, h;
        }() : function() {
            var o = f.formats[i];
            if (!o) return void function() {
                if (!1 === c.strictSchema) return void f.logger.warn(e());
                throw new Error(e());
                function e() {
                    return 'unknown format "'.concat(i, '" ignored in schema at path "').concat(l, '"');
                }
            }();
            if (!0 === o) return;
            var a = jo(function(e) {
                var t = e instanceof RegExp ? (0, Cee.regexpCode)(e) : c.code.formats ? (0, Cee._)(oo || (oo = mo([
                    "",
                    "",
                    ""
                ])), c.code.formats, (0, Cee.getProperty)(i)) : void 0, r = n.scopeValue("formats", {
                    key: i,
                    ref: e,
                    code: t
                });
                if ("object" == Ho(e) && !(e instanceof RegExp)) return [
                    e.type || "string",
                    e.validate,
                    (0, Cee._)(io || (io = mo([
                        "",
                        ".validate"
                    ])), r)
                ];
                return [
                    "string",
                    e,
                    r
                ];
            }(o), 3), s = a[0], d = a[1], h = a[2];
            s === t && e.pass(function() {
                if ("object" == Ho(o) && !(o instanceof RegExp) && o.async) {
                    if (!u.$async) throw new Error("async format in sync schema");
                    return (0, Cee._)(ao || (ao = mo([
                        "await ",
                        "(",
                        ")"
                    ])), h, r);
                }
                return "function" == typeof d ? (0, Cee._)(so || (so = mo([
                    "",
                    "(",
                    ")"
                ])), h, r) : (0, Cee._)(co || (co = mo([
                    "",
                    ".test(",
                    ")"
                ])), h, r);
            }());
        }());
    }
};
See.default = $ee, Object.defineProperty(jee, "__esModule", {
    value: !0
});
var _ee = [
    See.default
];
jee.default = _ee;
var Oee = {};
Object.defineProperty(Oee, "__esModule", {
    value: !0
}), Oee.contentVocabulary = Oee.metadataVocabulary = void 0, Oee.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
], Oee.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
], Object.defineProperty(w5, "__esModule", {
    value: !0
});
var Mee = I5, Eee = U7, Aee = jee, Pee = Oee, Tee = [
    x5.default,
    Mee.default,
    (0, Eee.default)(),
    Aee.default,
    Pee.metadataVocabulary,
    Pee.contentVocabulary
];
w5.default = Tee;
var Ree = {}, Nee = {};
!function(e) {
    var t;
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.DiscrError = void 0, (t = e.DiscrError || (e.DiscrError = {})).Tag = "tag", t.Mapping = "mapping";
}(Nee), Object.defineProperty(Ree, "__esModule", {
    value: !0
});
var Iee = o8(), Dee = Nee, zee = e5, qee = i8, Bee = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: {
        message: function(e) {
            var t = e.params, n = t.discrError, r = t.tagName;
            return n === Dee.DiscrError.Tag ? 'tag "'.concat(r, '" must be string') : 'value of tag "'.concat(r, '" must be in oneOf');
        },
        params: function(e) {
            var t = e.params, n = t.discrError, r = t.tag, o = t.tagName;
            return (0, Iee._)(lo || (lo = mo([
                "{error: ",
                ", tag: ",
                ", tagValue: ",
                "}"
            ])), n, o, r);
        }
    },
    code: function(e) {
        var t = e.gen, n = e.data, r = e.schema, o = e.parentSchema, i = e.it, a = o.oneOf;
        if (!i.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        var s = r.propertyName;
        if ("string" != typeof s) throw new Error("discriminator: requires propertyName");
        if (r.mapping) throw new Error("discriminator: mapping is not supported");
        if (!a) throw new Error("discriminator: requires oneOf keyword");
        var c = t.let("valid", !1), l = t.const("tag", (0, Iee._)(uo || (uo = mo([
            "",
            "",
            ""
        ])), n, (0, Iee.getProperty)(s)));
        function u(n) {
            var r = t.name("valid"), o = e.subschema({
                keyword: "oneOf",
                schemaProp: n
            }, r);
            return e.mergeEvaluated(o, Iee.Name), r;
        }
        t.if((0, Iee._)(fo || (fo = mo([
            "typeof ",
            ' == "string"'
        ])), l), function() {
            return function() {
                var n = function() {
                    for(var e, t = {}, n = f(o), r = !0, c = 0; c < a.length; c++){
                        var l = a[c];
                        (null == l ? void 0 : l.$ref) && !(0, qee.schemaHasRulesButRef)(l, i.self.RULES) && (l = zee.resolveRef.call(i.self, i.schemaEnv.root, i.baseId, null == l ? void 0 : l.$ref)) instanceof zee.SchemaEnv && (l = l.schema);
                        var u = null === (e = null == l ? void 0 : l.properties) || void 0 === e ? void 0 : e[s];
                        if ("object" != Ho(u)) throw new Error('discriminator: oneOf subschemas (or referenced schemas) must have "properties/'.concat(s, '"'));
                        r = r && (n || f(l)), d(u, c);
                    }
                    if (!r) throw new Error('discriminator: "'.concat(s, '" must be required'));
                    return t;
                    function f(e) {
                        var t = e.required;
                        return Array.isArray(t) && t.includes(s);
                    }
                    function d(e, t) {
                        if (e.const) h(e.const, t);
                        else {
                            if (!e.enum) throw new Error('discriminator: "properties/'.concat(s, '" must have "const" or "enum"'));
                            var n, r = bo(e.enum);
                            try {
                                for(r.s(); !(n = r.n()).done;)h(n.value, t);
                            } catch (e) {
                                r.e(e);
                            } finally{
                                r.f();
                            }
                        }
                    }
                    function h(e, n) {
                        if ("string" != typeof e || e in t) throw new Error('discriminator: "'.concat(s, '" values must be unique strings'));
                        t[e] = n;
                    }
                }();
                for(var r in t.if(!1), n)t.elseIf((0, Iee._)(ho || (ho = mo([
                    "",
                    " === ",
                    ""
                ])), l, r)), t.assign(c, u(n[r]));
                t.else(), e.error(!1, {
                    discrError: Dee.DiscrError.Mapping,
                    tag: l,
                    tagName: s
                }), t.endIf();
            }();
        }, function() {
            return e.error(!1, {
                discrError: Dee.DiscrError.Tag,
                tag: l,
                tagName: s
            });
        }), e.ok(c);
    }
};
Ree.default = Bee;
var Lee = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "http://json-schema.org/draft-07/schema#",
    title: "Core schema meta-schema",
    definitions: {
        schemaArray: {
            type: "array",
            minItems: 1,
            items: {
                $ref: "#"
            }
        },
        nonNegativeInteger: {
            type: "integer",
            minimum: 0
        },
        nonNegativeIntegerDefault0: {
            allOf: [
                {
                    $ref: "#/definitions/nonNegativeInteger"
                },
                {
                    default: 0
                }
            ]
        },
        simpleTypes: {
            enum: [
                "array",
                "boolean",
                "integer",
                "null",
                "number",
                "object",
                "string"
            ]
        },
        stringArray: {
            type: "array",
            items: {
                type: "string"
            },
            uniqueItems: !0,
            default: []
        }
    },
    type: [
        "object",
        "boolean"
    ],
    properties: {
        $id: {
            type: "string",
            format: "uri-reference"
        },
        $schema: {
            type: "string",
            format: "uri"
        },
        $ref: {
            type: "string",
            format: "uri-reference"
        },
        $comment: {
            type: "string"
        },
        title: {
            type: "string"
        },
        description: {
            type: "string"
        },
        default: !0,
        readOnly: {
            type: "boolean",
            default: !1
        },
        examples: {
            type: "array",
            items: !0
        },
        multipleOf: {
            type: "number",
            exclusiveMinimum: 0
        },
        maximum: {
            type: "number"
        },
        exclusiveMaximum: {
            type: "number"
        },
        minimum: {
            type: "number"
        },
        exclusiveMinimum: {
            type: "number"
        },
        maxLength: {
            $ref: "#/definitions/nonNegativeInteger"
        },
        minLength: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
        },
        pattern: {
            type: "string",
            format: "regex"
        },
        additionalItems: {
            $ref: "#"
        },
        items: {
            anyOf: [
                {
                    $ref: "#"
                },
                {
                    $ref: "#/definitions/schemaArray"
                }
            ],
            default: !0
        },
        maxItems: {
            $ref: "#/definitions/nonNegativeInteger"
        },
        minItems: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
        },
        uniqueItems: {
            type: "boolean",
            default: !1
        },
        contains: {
            $ref: "#"
        },
        maxProperties: {
            $ref: "#/definitions/nonNegativeInteger"
        },
        minProperties: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
        },
        required: {
            $ref: "#/definitions/stringArray"
        },
        additionalProperties: {
            $ref: "#"
        },
        definitions: {
            type: "object",
            additionalProperties: {
                $ref: "#"
            },
            default: {}
        },
        properties: {
            type: "object",
            additionalProperties: {
                $ref: "#"
            },
            default: {}
        },
        patternProperties: {
            type: "object",
            additionalProperties: {
                $ref: "#"
            },
            propertyNames: {
                format: "regex"
            },
            default: {}
        },
        dependencies: {
            type: "object",
            additionalProperties: {
                anyOf: [
                    {
                        $ref: "#"
                    },
                    {
                        $ref: "#/definitions/stringArray"
                    }
                ]
            }
        },
        propertyNames: {
            $ref: "#"
        },
        const: !0,
        enum: {
            type: "array",
            items: !0,
            minItems: 1,
            uniqueItems: !0
        },
        type: {
            anyOf: [
                {
                    $ref: "#/definitions/simpleTypes"
                },
                {
                    type: "array",
                    items: {
                        $ref: "#/definitions/simpleTypes"
                    },
                    minItems: 1,
                    uniqueItems: !0
                }
            ]
        },
        format: {
            type: "string"
        },
        contentMediaType: {
            type: "string"
        },
        contentEncoding: {
            type: "string"
        },
        if: {
            $ref: "#"
        },
        then: {
            $ref: "#"
        },
        else: {
            $ref: "#"
        },
        allOf: {
            $ref: "#/definitions/schemaArray"
        },
        anyOf: {
            $ref: "#/definitions/schemaArray"
        },
        oneOf: {
            $ref: "#/definitions/schemaArray"
        },
        not: {
            $ref: "#"
        }
    },
    default: !0
};
!function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.MissingRefError = t.ValidationError = t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0;
    var n = w5, r = Ree, o = Lee, i = [
        "/properties"
    ], a = "http://json-schema.org/draft-07/schema", s = function(e) {
        function t() {
            return No(this, t), _o(this, t, arguments);
        }
        return Ao(t, e), Do(t, [
            {
                key: "_addVocabularies",
                value: function() {
                    var e = this;
                    go(Mo(t.prototype), "_addVocabularies", this).call(this), n.default.forEach(function(t) {
                        return e.addVocabulary(t);
                    }), this.opts.discriminator && this.addKeyword(r.default);
                }
            },
            {
                key: "_addDefaultMetaSchema",
                value: function() {
                    if (go(Mo(t.prototype), "_addDefaultMetaSchema", this).call(this), this.opts.meta) {
                        var e = this.opts.$data ? this.$dataMetaSchema(o, i) : o;
                        this.addMetaSchema(e, a, !1), this.refs["http://json-schema.org/schema"] = a;
                    }
                }
            },
            {
                key: "defaultMeta",
                value: function() {
                    return this.opts.defaultMeta = go(Mo(t.prototype), "defaultMeta", this).call(this) || (this.getSchema(a) ? a : void 0);
                }
            }
        ]), t;
    }(J6.default);
    e.exports = t = s, Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = s;
    var c = J8();
    Object.defineProperty(t, "KeywordCxt", {
        enumerable: !0,
        get: function() {
            return c.KeywordCxt;
        }
    });
    var l = o8();
    Object.defineProperty(t, "_", {
        enumerable: !0,
        get: function() {
            return l._;
        }
    }), Object.defineProperty(t, "str", {
        enumerable: !0,
        get: function() {
            return l.str;
        }
    }), Object.defineProperty(t, "stringify", {
        enumerable: !0,
        get: function() {
            return l.stringify;
        }
    }), Object.defineProperty(t, "nil", {
        enumerable: !0,
        get: function() {
            return l.nil;
        }
    }), Object.defineProperty(t, "Name", {
        enumerable: !0,
        get: function() {
            return l.Name;
        }
    }), Object.defineProperty(t, "CodeGen", {
        enumerable: !0,
        get: function() {
            return l.CodeGen;
        }
    });
    var u = Q8();
    Object.defineProperty(t, "ValidationError", {
        enumerable: !0,
        get: function() {
            return u.default;
        }
    });
    var f = Z8();
    Object.defineProperty(t, "MissingRefError", {
        enumerable: !0,
        get: function() {
            return f.default;
        }
    });
}(U6, U6.exports);
var Fee = yc(U6.exports);
function Vee(e) {
    if (void 0 === e.schema) throw new Error("Deprecation warning: the signature of createAjvValidator is changed from createAjvValidator(schema, schemaDefinitions, ajvOptions) to createAjvValidator({ schema, schemaDefinitions, ajvOptions }). Please pass the arguments as an object instead of unnamed arguments.");
    var t = function(e) {
        var t = e.schemaDefinitions, n = e.ajvOptions, r = new Fee(Ro({
            allErrors: !0,
            verbose: !0,
            $data: !0
        }, n));
        t && Object.keys(t).forEach(function(e) {
            r.addSchema(t[e], e);
        });
        return r;
    }(e);
    if (void 0 !== e.onCreateAjv && !1 === (t = e.onCreateAjv(t) || t).opts.verbose) throw new Error("Ajv must be configured with the option verbose=true");
    var n = t.compile(e.schema);
    if (n.errors) throw n.errors[0];
    return function(e) {
        return n(e), (n.errors || []).map(Hee).map(function(t) {
            return function(e, t) {
                return {
                    path: dc(e, t.instancePath),
                    message: t.message || "Unknown error",
                    severity: Za.warning
                };
            }(e, t);
        });
    };
}
function Hee(e) {
    if ("enum" === e.keyword && Array.isArray(e.schema)) {
        var t = e.schema;
        if (t) {
            if ((t = t.map(function(e) {
                return JSON.stringify(e);
            })).length > 5) {
                var n = [
                    "(" + (t.length - 5) + " more...)"
                ];
                (t = t.slice(0, 5)).push(n);
            }
            e.message = "should be equal to one of: " + t.join(", ");
        }
    }
    return "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
}
var Wee = {
    id: "lodash",
    name: "Lodash",
    description: '\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n  You can use <a href="https://lodash.com" target="_blank" rel="noopener noreferrer">Lodash</a>\n  functions like <code>_.map</code>, <code>_.filter</code>,\n  <code>_.orderBy</code>, <code>_.sortBy</code>, <code>_.groupBy</code>,\n  <code>_.pick</code>, <code>_.uniq</code>, <code>_.get</code>, etcetera.\n</p>\n',
    createQuery: function(e, t) {
        var n = t.filter, r = t.sort, o = t.projection, i = [
            "  return _.chain(data)\n"
        ];
        if (n && n.path && n.relation && n.value) {
            var a = "item => item".concat(YO(n.path)), s = nM(n.value), c = "string" == typeof s ? "'".concat(n.value, "'") : ou(n.value) && !Number.isSafeInteger(s) ? "".concat(n.value, "n") : n.value;
            i.push("    .filter(".concat(a, " ").concat(n.relation, " ").concat(c, ")\n"));
        }
        r && r.path && r.direction && i.push("    .orderBy([".concat(function(e) {
            return 0 === e.length ? "" : e.every(function(e) {
                return ZO.test(e) || XO.test(e);
            }) ? "'" + e.map(QO).join("").replace(/^\./, "") + "'" : JSON.stringify(e);
        }(r.path), "], ['").concat(r.direction, "'])\n"));
        if (o && o.paths) {
            if (o.paths.length > 1) {
                var l = o.paths.map(function(e) {
                    var t = vb(e) || "item";
                    return "      ".concat(JSON.stringify(t), ": item").concat(YO(e));
                });
                i.push("    .map(item => ({\n".concat(l.join(",\n"), "\n    }))\n"));
            } else {
                var u = o.paths[0];
                i.push("    .map(item => item".concat(YO(u), ")\n"));
            }
        }
        return i.push("    .value()\n"), "function query (data) {\n".concat(i.join(""), "}");
    },
    executeQuery: function(e, t) {
        !function(e) {
            var t, n, r = null === (t = e.match(/_\.chain\(/g)) || void 0 === t ? void 0 : t.length, o = null === (n = e.match(/\.value\(\)/g)) || void 0 === n ? void 0 : n.length;
            if (r !== o) throw new Error("Cannot execute query: Lodash _.chain(...) must end with .value()");
        }(t);
        var n = new Function("_", '"use strict";\n\n' + t + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')(E_)(e);
        return void 0 !== n ? n : null;
    }
};
var Uee = {};
!function(e) {
    function t(e) {
        return null !== e && "[object Array]" === Object.prototype.toString.call(e);
    }
    function n(e) {
        return null !== e && "[object Object]" === Object.prototype.toString.call(e);
    }
    function r(e, o) {
        if (e === o) return !0;
        if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(o)) return !1;
        if (!0 === t(e)) {
            if (e.length !== o.length) return !1;
            for(var i = 0; i < e.length; i++)if (!1 === r(e[i], o[i])) return !1;
            return !0;
        }
        if (!0 === n(e)) {
            var a = {};
            for(var s in e)if (hasOwnProperty.call(e, s)) {
                if (!1 === r(e[s], o[s])) return !1;
                a[s] = !0;
            }
            for(var c in o)if (hasOwnProperty.call(o, c) && !0 !== a[c]) return !1;
            return !0;
        }
        return !1;
    }
    function o(e) {
        if ("" === e || !1 === e || null === e) return !0;
        if (t(e) && 0 === e.length) return !0;
        if (n(e)) {
            for(var r in e)if (e.hasOwnProperty(r)) return !1;
            return !0;
        }
        return !1;
    }
    var i;
    i = "function" == typeof String.prototype.trimLeft ? function(e) {
        return e.trimLeft();
    } : function(e) {
        return e.match(/^\s*(.*)/)[1];
    };
    var a = 0, s = 1, c = 2, l = 3, u = 4, f = 6, d = 8, h = 9, v = {
        0: "number",
        1: "any",
        2: "string",
        3: "array",
        4: "object",
        5: "boolean",
        6: "expression",
        7: "null",
        8: "Array<number>",
        9: "Array<string>"
    }, p = "EOF", m = "UnquotedIdentifier", g = "QuotedIdentifier", y = "Rbracket", b = "Rparen", w = "Comma", x = "Colon", k = "Rbrace", j = "Number", S = "Current", C = "Expref", $ = "Pipe", _ = "Or", O = "And", M = "EQ", E = "GT", A = "LT", P = "GTE", T = "LTE", R = "NE", N = "Flatten", I = "Star", D = "Filter", z = "Dot", q = "Not", B = "Lbrace", L = "Lbracket", F = "Lparen", V = "Literal", H = {
        ".": z,
        "*": I,
        ",": w,
        ":": x,
        "{": B,
        "}": k,
        "]": y,
        "(": F,
        ")": b,
        "@": S
    }, W = {
        "<": !0,
        ">": !0,
        "=": !0,
        "!": !0
    }, U = {
        " ": !0,
        "	": !0,
        "\n": !0
    };
    function J(e) {
        return e >= "0" && e <= "9" || "-" === e;
    }
    function K() {}
    K.prototype = {
        tokenize: function(e) {
            var t, n, r, o, i = [];
            for(this._current = 0; this._current < e.length;)if ((o = e[this._current]) >= "a" && o <= "z" || o >= "A" && o <= "Z" || "_" === o) t = this._current, n = this._consumeUnquotedIdentifier(e), i.push({
                type: m,
                value: n,
                start: t
            });
            else if (void 0 !== H[e[this._current]]) i.push({
                type: H[e[this._current]],
                value: e[this._current],
                start: this._current
            }), this._current++;
            else if (J(e[this._current])) r = this._consumeNumber(e), i.push(r);
            else if ("[" === e[this._current]) r = this._consumeLBracket(e), i.push(r);
            else if ('"' === e[this._current]) t = this._current, n = this._consumeQuotedIdentifier(e), i.push({
                type: g,
                value: n,
                start: t
            });
            else if ("'" === e[this._current]) t = this._current, n = this._consumeRawStringLiteral(e), i.push({
                type: V,
                value: n,
                start: t
            });
            else if ("`" === e[this._current]) {
                t = this._current;
                var a = this._consumeLiteral(e);
                i.push({
                    type: V,
                    value: a,
                    start: t
                });
            } else if (void 0 !== W[e[this._current]]) i.push(this._consumeOperator(e));
            else if (void 0 !== U[e[this._current]]) this._current++;
            else if ("&" === e[this._current]) t = this._current, this._current++, "&" === e[this._current] ? (this._current++, i.push({
                type: O,
                value: "&&",
                start: t
            })) : i.push({
                type: C,
                value: "&",
                start: t
            });
            else {
                if ("|" !== e[this._current]) {
                    var s = new Error("Unknown character:" + e[this._current]);
                    throw s.name = "LexerError", s;
                }
                t = this._current, this._current++, "|" === e[this._current] ? (this._current++, i.push({
                    type: _,
                    value: "||",
                    start: t
                })) : i.push({
                    type: $,
                    value: "|",
                    start: t
                });
            }
            return i;
        },
        _consumeUnquotedIdentifier: function(e) {
            var t, n = this._current;
            for(this._current++; this._current < e.length && ((t = e[this._current]) >= "a" && t <= "z" || t >= "A" && t <= "Z" || t >= "0" && t <= "9" || "_" === t);)this._current++;
            return e.slice(n, this._current);
        },
        _consumeQuotedIdentifier: function(e) {
            var t = this._current;
            this._current++;
            for(var n = e.length; '"' !== e[this._current] && this._current < n;){
                var r = this._current;
                "\\" !== e[r] || "\\" !== e[r + 1] && '"' !== e[r + 1] ? r++ : r += 2, this._current = r;
            }
            return this._current++, JSON.parse(e.slice(t, this._current));
        },
        _consumeRawStringLiteral: function(e) {
            var t = this._current;
            this._current++;
            for(var n = e.length; "'" !== e[this._current] && this._current < n;){
                var r = this._current;
                "\\" !== e[r] || "\\" !== e[r + 1] && "'" !== e[r + 1] ? r++ : r += 2, this._current = r;
            }
            return this._current++, e.slice(t + 1, this._current - 1).replace("\\'", "'");
        },
        _consumeNumber: function(e) {
            var t = this._current;
            this._current++;
            for(var n = e.length; J(e[this._current]) && this._current < n;)this._current++;
            var r = parseInt(e.slice(t, this._current));
            return {
                type: j,
                value: r,
                start: t
            };
        },
        _consumeLBracket: function(e) {
            var t = this._current;
            return this._current++, "?" === e[this._current] ? (this._current++, {
                type: D,
                value: "[?",
                start: t
            }) : "]" === e[this._current] ? (this._current++, {
                type: N,
                value: "[]",
                start: t
            }) : {
                type: L,
                value: "[",
                start: t
            };
        },
        _consumeOperator: function(e) {
            var t = this._current, n = e[t];
            return this._current++, "!" === n ? "=" === e[this._current] ? (this._current++, {
                type: R,
                value: "!=",
                start: t
            }) : {
                type: q,
                value: "!",
                start: t
            } : "<" === n ? "=" === e[this._current] ? (this._current++, {
                type: T,
                value: "<=",
                start: t
            }) : {
                type: A,
                value: "<",
                start: t
            } : ">" === n ? "=" === e[this._current] ? (this._current++, {
                type: P,
                value: ">=",
                start: t
            }) : {
                type: E,
                value: ">",
                start: t
            } : "=" === n && "=" === e[this._current] ? (this._current++, {
                type: M,
                value: "==",
                start: t
            }) : void 0;
        },
        _consumeLiteral: function(e) {
            this._current++;
            for(var t, n = this._current, r = e.length; "`" !== e[this._current] && this._current < r;){
                var o = this._current;
                "\\" !== e[o] || "\\" !== e[o + 1] && "`" !== e[o + 1] ? o++ : o += 2, this._current = o;
            }
            var a = i(e.slice(n, this._current));
            return a = a.replace("\\`", "`"), t = this._looksLikeJSON(a) ? JSON.parse(a) : JSON.parse('"' + a + '"'), this._current++, t;
        },
        _looksLikeJSON: function(e) {
            if ("" === e) return !1;
            if ('[{"'.indexOf(e[0]) >= 0) return !0;
            if ([
                "true",
                "false",
                "null"
            ].indexOf(e) >= 0) return !0;
            if (!("-0123456789".indexOf(e[0]) >= 0)) return !1;
            try {
                return JSON.parse(e), !0;
            } catch (e) {
                return !1;
            }
        }
    };
    var G = {};
    function Q() {}
    function Y(e) {
        this.runtime = e;
    }
    function X(e) {
        this._interpreter = e, this.functionTable = {
            abs: {
                _func: this._functionAbs,
                _signature: [
                    {
                        types: [
                            a
                        ]
                    }
                ]
            },
            avg: {
                _func: this._functionAvg,
                _signature: [
                    {
                        types: [
                            d
                        ]
                    }
                ]
            },
            ceil: {
                _func: this._functionCeil,
                _signature: [
                    {
                        types: [
                            a
                        ]
                    }
                ]
            },
            contains: {
                _func: this._functionContains,
                _signature: [
                    {
                        types: [
                            c,
                            l
                        ]
                    },
                    {
                        types: [
                            s
                        ]
                    }
                ]
            },
            ends_with: {
                _func: this._functionEndsWith,
                _signature: [
                    {
                        types: [
                            c
                        ]
                    },
                    {
                        types: [
                            c
                        ]
                    }
                ]
            },
            floor: {
                _func: this._functionFloor,
                _signature: [
                    {
                        types: [
                            a
                        ]
                    }
                ]
            },
            length: {
                _func: this._functionLength,
                _signature: [
                    {
                        types: [
                            c,
                            l,
                            u
                        ]
                    }
                ]
            },
            map: {
                _func: this._functionMap,
                _signature: [
                    {
                        types: [
                            f
                        ]
                    },
                    {
                        types: [
                            l
                        ]
                    }
                ]
            },
            max: {
                _func: this._functionMax,
                _signature: [
                    {
                        types: [
                            d,
                            h
                        ]
                    }
                ]
            },
            merge: {
                _func: this._functionMerge,
                _signature: [
                    {
                        types: [
                            u
                        ],
                        variadic: !0
                    }
                ]
            },
            max_by: {
                _func: this._functionMaxBy,
                _signature: [
                    {
                        types: [
                            l
                        ]
                    },
                    {
                        types: [
                            f
                        ]
                    }
                ]
            },
            sum: {
                _func: this._functionSum,
                _signature: [
                    {
                        types: [
                            d
                        ]
                    }
                ]
            },
            starts_with: {
                _func: this._functionStartsWith,
                _signature: [
                    {
                        types: [
                            c
                        ]
                    },
                    {
                        types: [
                            c
                        ]
                    }
                ]
            },
            min: {
                _func: this._functionMin,
                _signature: [
                    {
                        types: [
                            d,
                            h
                        ]
                    }
                ]
            },
            min_by: {
                _func: this._functionMinBy,
                _signature: [
                    {
                        types: [
                            l
                        ]
                    },
                    {
                        types: [
                            f
                        ]
                    }
                ]
            },
            type: {
                _func: this._functionType,
                _signature: [
                    {
                        types: [
                            s
                        ]
                    }
                ]
            },
            keys: {
                _func: this._functionKeys,
                _signature: [
                    {
                        types: [
                            u
                        ]
                    }
                ]
            },
            values: {
                _func: this._functionValues,
                _signature: [
                    {
                        types: [
                            u
                        ]
                    }
                ]
            },
            sort: {
                _func: this._functionSort,
                _signature: [
                    {
                        types: [
                            h,
                            d
                        ]
                    }
                ]
            },
            sort_by: {
                _func: this._functionSortBy,
                _signature: [
                    {
                        types: [
                            l
                        ]
                    },
                    {
                        types: [
                            f
                        ]
                    }
                ]
            },
            join: {
                _func: this._functionJoin,
                _signature: [
                    {
                        types: [
                            c
                        ]
                    },
                    {
                        types: [
                            h
                        ]
                    }
                ]
            },
            reverse: {
                _func: this._functionReverse,
                _signature: [
                    {
                        types: [
                            c,
                            l
                        ]
                    }
                ]
            },
            to_array: {
                _func: this._functionToArray,
                _signature: [
                    {
                        types: [
                            s
                        ]
                    }
                ]
            },
            to_string: {
                _func: this._functionToString,
                _signature: [
                    {
                        types: [
                            s
                        ]
                    }
                ]
            },
            to_number: {
                _func: this._functionToNumber,
                _signature: [
                    {
                        types: [
                            s
                        ]
                    }
                ]
            },
            not_null: {
                _func: this._functionNotNull,
                _signature: [
                    {
                        types: [
                            s
                        ],
                        variadic: !0
                    }
                ]
            }
        };
    }
    G[p] = 0, G[m] = 0, G[g] = 0, G[y] = 0, G[b] = 0, G[w] = 0, G[k] = 0, G[j] = 0, G[S] = 0, G[C] = 0, G[$] = 1, G[_] = 2, G[O] = 3, G[M] = 5, G[E] = 5, G[A] = 5, G[P] = 5, G[T] = 5, G[R] = 5, G[N] = 9, G[I] = 20, G[D] = 21, G[z] = 40, G[q] = 45, G[B] = 50, G[L] = 55, G[F] = 60, Q.prototype = {
        parse: function(e) {
            this._loadTokens(e), this.index = 0;
            var t = this.expression(0);
            if (this._lookahead(0) !== p) {
                var n = this._lookaheadToken(0), r = new Error("Unexpected token type: " + n.type + ", value: " + n.value);
                throw r.name = "ParserError", r;
            }
            return t;
        },
        _loadTokens: function(e) {
            var t = (new K).tokenize(e);
            t.push({
                type: p,
                value: "",
                start: e.length
            }), this.tokens = t;
        },
        expression: function(e) {
            var t = this._lookaheadToken(0);
            this._advance();
            for(var n = this.nud(t), r = this._lookahead(0); e < G[r];)this._advance(), n = this.led(r, n), r = this._lookahead(0);
            return n;
        },
        _lookahead: function(e) {
            return this.tokens[this.index + e].type;
        },
        _lookaheadToken: function(e) {
            return this.tokens[this.index + e];
        },
        _advance: function() {
            this.index++;
        },
        nud: function(e) {
            var t, n;
            switch(e.type){
                case V:
                    return {
                        type: "Literal",
                        value: e.value
                    };
                case m:
                    return {
                        type: "Field",
                        name: e.value
                    };
                case g:
                    var r = {
                        type: "Field",
                        name: e.value
                    };
                    if (this._lookahead(0) === F) throw new Error("Quoted identifier not allowed for function names.");
                    return r;
                case q:
                    return {
                        type: "NotExpression",
                        children: [
                            t = this.expression(G.Not)
                        ]
                    };
                case I:
                    return t = null, {
                        type: "ValueProjection",
                        children: [
                            {
                                type: "Identity"
                            },
                            t = this._lookahead(0) === y ? {
                                type: "Identity"
                            } : this._parseProjectionRHS(G.Star)
                        ]
                    };
                case D:
                    return this.led(e.type, {
                        type: "Identity"
                    });
                case B:
                    return this._parseMultiselectHash();
                case N:
                    return {
                        type: "Projection",
                        children: [
                            {
                                type: N,
                                children: [
                                    {
                                        type: "Identity"
                                    }
                                ]
                            },
                            t = this._parseProjectionRHS(G.Flatten)
                        ]
                    };
                case L:
                    return this._lookahead(0) === j || this._lookahead(0) === x ? (t = this._parseIndexExpression(), this._projectIfSlice({
                        type: "Identity"
                    }, t)) : this._lookahead(0) === I && this._lookahead(1) === y ? (this._advance(), this._advance(), {
                        type: "Projection",
                        children: [
                            {
                                type: "Identity"
                            },
                            t = this._parseProjectionRHS(G.Star)
                        ]
                    }) : this._parseMultiselectList();
                case S:
                    return {
                        type: S
                    };
                case C:
                    return {
                        type: "ExpressionReference",
                        children: [
                            n = this.expression(G.Expref)
                        ]
                    };
                case F:
                    for(var o = []; this._lookahead(0) !== b;)this._lookahead(0) === S ? (n = {
                        type: S
                    }, this._advance()) : n = this.expression(0), o.push(n);
                    return this._match(b), o[0];
                default:
                    this._errorToken(e);
            }
        },
        led: function(e, t) {
            var n;
            switch(e){
                case z:
                    var r = G.Dot;
                    return this._lookahead(0) !== I ? {
                        type: "Subexpression",
                        children: [
                            t,
                            n = this._parseDotRHS(r)
                        ]
                    } : (this._advance(), {
                        type: "ValueProjection",
                        children: [
                            t,
                            n = this._parseProjectionRHS(r)
                        ]
                    });
                case $:
                    return n = this.expression(G.Pipe), {
                        type: $,
                        children: [
                            t,
                            n
                        ]
                    };
                case _:
                    return {
                        type: "OrExpression",
                        children: [
                            t,
                            n = this.expression(G.Or)
                        ]
                    };
                case O:
                    return {
                        type: "AndExpression",
                        children: [
                            t,
                            n = this.expression(G.And)
                        ]
                    };
                case F:
                    for(var o, i = t.name, a = []; this._lookahead(0) !== b;)this._lookahead(0) === S ? (o = {
                        type: S
                    }, this._advance()) : o = this.expression(0), this._lookahead(0) === w && this._match(w), a.push(o);
                    return this._match(b), {
                        type: "Function",
                        name: i,
                        children: a
                    };
                case D:
                    var s = this.expression(0);
                    return this._match(y), {
                        type: "FilterProjection",
                        children: [
                            t,
                            n = this._lookahead(0) === N ? {
                                type: "Identity"
                            } : this._parseProjectionRHS(G.Filter),
                            s
                        ]
                    };
                case N:
                    return {
                        type: "Projection",
                        children: [
                            {
                                type: N,
                                children: [
                                    t
                                ]
                            },
                            this._parseProjectionRHS(G.Flatten)
                        ]
                    };
                case M:
                case R:
                case E:
                case P:
                case A:
                case T:
                    return this._parseComparator(t, e);
                case L:
                    var c = this._lookaheadToken(0);
                    return c.type === j || c.type === x ? (n = this._parseIndexExpression(), this._projectIfSlice(t, n)) : (this._match(I), this._match(y), {
                        type: "Projection",
                        children: [
                            t,
                            n = this._parseProjectionRHS(G.Star)
                        ]
                    });
                default:
                    this._errorToken(this._lookaheadToken(0));
            }
        },
        _match: function(e) {
            if (this._lookahead(0) !== e) {
                var t = this._lookaheadToken(0), n = new Error("Expected " + e + ", got: " + t.type);
                throw n.name = "ParserError", n;
            }
            this._advance();
        },
        _errorToken: function(e) {
            var t = new Error("Invalid token (" + e.type + '): "' + e.value + '"');
            throw t.name = "ParserError", t;
        },
        _parseIndexExpression: function() {
            if (this._lookahead(0) === x || this._lookahead(1) === x) return this._parseSliceExpression();
            var e = {
                type: "Index",
                value: this._lookaheadToken(0).value
            };
            return this._advance(), this._match(y), e;
        },
        _projectIfSlice: function(e, t) {
            var n = {
                type: "IndexExpression",
                children: [
                    e,
                    t
                ]
            };
            return "Slice" === t.type ? {
                type: "Projection",
                children: [
                    n,
                    this._parseProjectionRHS(G.Star)
                ]
            } : n;
        },
        _parseSliceExpression: function() {
            for(var e = [
                null,
                null,
                null
            ], t = 0, n = this._lookahead(0); n !== y && t < 3;){
                if (n === x) t++, this._advance();
                else {
                    if (n !== j) {
                        var r = this._lookahead(0), o = new Error("Syntax error, unexpected token: " + r.value + "(" + r.type + ")");
                        throw o.name = "Parsererror", o;
                    }
                    e[t] = this._lookaheadToken(0).value, this._advance();
                }
                n = this._lookahead(0);
            }
            return this._match(y), {
                type: "Slice",
                children: e
            };
        },
        _parseComparator: function(e, t) {
            return {
                type: "Comparator",
                name: t,
                children: [
                    e,
                    this.expression(G[t])
                ]
            };
        },
        _parseDotRHS: function(e) {
            var t = this._lookahead(0);
            return [
                m,
                g,
                I
            ].indexOf(t) >= 0 ? this.expression(e) : t === L ? (this._match(L), this._parseMultiselectList()) : t === B ? (this._match(B), this._parseMultiselectHash()) : void 0;
        },
        _parseProjectionRHS: function(e) {
            var t;
            if (G[this._lookahead(0)] < 10) t = {
                type: "Identity"
            };
            else if (this._lookahead(0) === L) t = this.expression(e);
            else if (this._lookahead(0) === D) t = this.expression(e);
            else {
                if (this._lookahead(0) !== z) {
                    var n = this._lookaheadToken(0), r = new Error("Sytanx error, unexpected token: " + n.value + "(" + n.type + ")");
                    throw r.name = "ParserError", r;
                }
                this._match(z), t = this._parseDotRHS(e);
            }
            return t;
        },
        _parseMultiselectList: function() {
            for(var e = []; this._lookahead(0) !== y;){
                var t = this.expression(0);
                if (e.push(t), this._lookahead(0) === w && (this._match(w), this._lookahead(0) === y)) throw new Error("Unexpected token Rbracket");
            }
            return this._match(y), {
                type: "MultiSelectList",
                children: e
            };
        },
        _parseMultiselectHash: function() {
            for(var e, t, n, r = [], o = [
                m,
                g
            ];;){
                if (e = this._lookaheadToken(0), o.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
                if (t = e.value, this._advance(), this._match(x), n = {
                    type: "KeyValuePair",
                    name: t,
                    value: this.expression(0)
                }, r.push(n), this._lookahead(0) === w) this._match(w);
                else if (this._lookahead(0) === k) {
                    this._match(k);
                    break;
                }
            }
            return {
                type: "MultiSelectHash",
                children: r
            };
        }
    }, Y.prototype = {
        search: function(e, t) {
            return this.visit(e, t);
        },
        visit: function(e, i) {
            var a, s, c, l, u, f, d, h, v;
            switch(e.type){
                case "Field":
                    return null !== i && n(i) ? void 0 === (f = i[e.name]) ? null : f : null;
                case "Subexpression":
                    for(c = this.visit(e.children[0], i), v = 1; v < e.children.length; v++)if (null === (c = this.visit(e.children[1], c))) return null;
                    return c;
                case "IndexExpression":
                    return d = this.visit(e.children[0], i), this.visit(e.children[1], d);
                case "Index":
                    if (!t(i)) return null;
                    var p = e.value;
                    return p < 0 && (p = i.length + p), void 0 === (c = i[p]) && (c = null), c;
                case "Slice":
                    if (!t(i)) return null;
                    var m = e.children.slice(0), g = this.computeSliceParams(i.length, m), y = g[0], b = g[1], w = g[2];
                    if (c = [], w > 0) for(v = y; v < b; v += w)c.push(i[v]);
                    else for(v = y; v > b; v += w)c.push(i[v]);
                    return c;
                case "Projection":
                    var x = this.visit(e.children[0], i);
                    if (!t(x)) return null;
                    for(h = [], v = 0; v < x.length; v++)null !== (s = this.visit(e.children[1], x[v])) && h.push(s);
                    return h;
                case "ValueProjection":
                    if (!n(x = this.visit(e.children[0], i))) return null;
                    h = [];
                    var k = function(e) {
                        for(var t = Object.keys(e), n = [], r = 0; r < t.length; r++)n.push(e[t[r]]);
                        return n;
                    }(x);
                    for(v = 0; v < k.length; v++)null !== (s = this.visit(e.children[1], k[v])) && h.push(s);
                    return h;
                case "FilterProjection":
                    if (!t(x = this.visit(e.children[0], i))) return null;
                    var j = [], _ = [];
                    for(v = 0; v < x.length; v++)o(a = this.visit(e.children[2], x[v])) || j.push(x[v]);
                    for(var O = 0; O < j.length; O++)null !== (s = this.visit(e.children[1], j[O])) && _.push(s);
                    return _;
                case "Comparator":
                    switch(l = this.visit(e.children[0], i), u = this.visit(e.children[1], i), e.name){
                        case M:
                            c = r(l, u);
                            break;
                        case R:
                            c = !r(l, u);
                            break;
                        case E:
                            c = l > u;
                            break;
                        case P:
                            c = l >= u;
                            break;
                        case A:
                            c = l < u;
                            break;
                        case T:
                            c = l <= u;
                            break;
                        default:
                            throw new Error("Unknown comparator: " + e.name);
                    }
                    return c;
                case N:
                    var I = this.visit(e.children[0], i);
                    if (!t(I)) return null;
                    var D = [];
                    for(v = 0; v < I.length; v++)t(s = I[v]) ? D.push.apply(D, s) : D.push(s);
                    return D;
                case "Identity":
                    return i;
                case "MultiSelectList":
                    if (null === i) return null;
                    for(h = [], v = 0; v < e.children.length; v++)h.push(this.visit(e.children[v], i));
                    return h;
                case "MultiSelectHash":
                    if (null === i) return null;
                    var z;
                    for(h = {}, v = 0; v < e.children.length; v++)h[(z = e.children[v]).name] = this.visit(z.value, i);
                    return h;
                case "OrExpression":
                    return o(a = this.visit(e.children[0], i)) && (a = this.visit(e.children[1], i)), a;
                case "AndExpression":
                    return !0 === o(l = this.visit(e.children[0], i)) ? l : this.visit(e.children[1], i);
                case "NotExpression":
                    return o(l = this.visit(e.children[0], i));
                case "Literal":
                    return e.value;
                case $:
                    return d = this.visit(e.children[0], i), this.visit(e.children[1], d);
                case S:
                    return i;
                case "Function":
                    var q = [];
                    for(v = 0; v < e.children.length; v++)q.push(this.visit(e.children[v], i));
                    return this.runtime.callFunction(e.name, q);
                case "ExpressionReference":
                    var B = e.children[0];
                    return B.jmespathType = C, B;
                default:
                    throw new Error("Unknown node type: " + e.type);
            }
        },
        computeSliceParams: function(e, t) {
            var n = t[0], r = t[1], o = t[2], i = [
                null,
                null,
                null
            ];
            if (null === o) o = 1;
            else if (0 === o) {
                var a = new Error("Invalid slice, step cannot be 0");
                throw a.name = "RuntimeError", a;
            }
            var s = o < 0;
            return n = null === n ? s ? e - 1 : 0 : this.capSliceRange(e, n, o), r = null === r ? s ? -1 : e : this.capSliceRange(e, r, o), i[0] = n, i[1] = r, i[2] = o, i;
        },
        capSliceRange: function(e, t, n) {
            return t < 0 ? (t += e) < 0 && (t = n < 0 ? -1 : 0) : t >= e && (t = n < 0 ? e - 1 : e), t;
        }
    }, X.prototype = {
        callFunction: function(e, t) {
            var n = this.functionTable[e];
            if (void 0 === n) throw new Error("Unknown function: " + e + "()");
            return this._validateArgs(e, t, n._signature), n._func.call(this, t);
        },
        _validateArgs: function(e, t, n) {
            var r, o, i, a;
            if (n[n.length - 1].variadic) {
                if (t.length < n.length) throw r = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + n.length + r + " but received " + t.length);
            } else if (t.length !== n.length) throw r = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + n.length + r + " but received " + t.length);
            for(var s = 0; s < n.length; s++){
                a = !1, o = n[s].types, i = this._getTypeName(t[s]);
                for(var c = 0; c < o.length; c++)if (this._typeMatches(i, o[c], t[s])) {
                    a = !0;
                    break;
                }
                if (!a) {
                    var l = o.map(function(e) {
                        return v[e];
                    }).join(",");
                    throw new Error("TypeError: " + e + "() expected argument " + (s + 1) + " to be type " + l + " but received type " + v[i] + " instead.");
                }
            }
        },
        _typeMatches: function(e, t, n) {
            if (t === s) return !0;
            if (t !== h && t !== d && t !== l) return e === t;
            if (t === l) return e === l;
            if (e === l) {
                var r;
                t === d ? r = a : t === h && (r = c);
                for(var o = 0; o < n.length; o++)if (!this._typeMatches(this._getTypeName(n[o]), r, n[o])) return !1;
                return !0;
            }
        },
        _getTypeName: function(e) {
            switch(Object.prototype.toString.call(e)){
                case "[object String]":
                    return c;
                case "[object Number]":
                    return a;
                case "[object Array]":
                    return l;
                case "[object Boolean]":
                    return 5;
                case "[object Null]":
                    return 7;
                case "[object Object]":
                    return e.jmespathType === C ? f : u;
            }
        },
        _functionStartsWith: function(e) {
            return 0 === e[0].lastIndexOf(e[1]);
        },
        _functionEndsWith: function(e) {
            var t = e[0], n = e[1];
            return -1 !== t.indexOf(n, t.length - n.length);
        },
        _functionReverse: function(e) {
            if (this._getTypeName(e[0]) === c) {
                for(var t = e[0], n = "", r = t.length - 1; r >= 0; r--)n += t[r];
                return n;
            }
            var o = e[0].slice(0);
            return o.reverse(), o;
        },
        _functionAbs: function(e) {
            return Math.abs(e[0]);
        },
        _functionCeil: function(e) {
            return Math.ceil(e[0]);
        },
        _functionAvg: function(e) {
            for(var t = 0, n = e[0], r = 0; r < n.length; r++)t += n[r];
            return t / n.length;
        },
        _functionContains: function(e) {
            return e[0].indexOf(e[1]) >= 0;
        },
        _functionFloor: function(e) {
            return Math.floor(e[0]);
        },
        _functionLength: function(e) {
            return n(e[0]) ? Object.keys(e[0]).length : e[0].length;
        },
        _functionMap: function(e) {
            for(var t = [], n = this._interpreter, r = e[0], o = e[1], i = 0; i < o.length; i++)t.push(n.visit(r, o[i]));
            return t;
        },
        _functionMerge: function(e) {
            for(var t = {}, n = 0; n < e.length; n++){
                var r = e[n];
                for(var o in r)t[o] = r[o];
            }
            return t;
        },
        _functionMax: function(e) {
            if (e[0].length > 0) {
                if (this._getTypeName(e[0][0]) === a) return Math.max.apply(Math, e[0]);
                for(var t = e[0], n = t[0], r = 1; r < t.length; r++)n.localeCompare(t[r]) < 0 && (n = t[r]);
                return n;
            }
            return null;
        },
        _functionMin: function(e) {
            if (e[0].length > 0) {
                if (this._getTypeName(e[0][0]) === a) return Math.min.apply(Math, e[0]);
                for(var t = e[0], n = t[0], r = 1; r < t.length; r++)t[r].localeCompare(n) < 0 && (n = t[r]);
                return n;
            }
            return null;
        },
        _functionSum: function(e) {
            for(var t = 0, n = e[0], r = 0; r < n.length; r++)t += n[r];
            return t;
        },
        _functionType: function(e) {
            switch(this._getTypeName(e[0])){
                case a:
                    return "number";
                case c:
                    return "string";
                case l:
                    return "array";
                case u:
                    return "object";
                case 5:
                    return "boolean";
                case f:
                    return "expref";
                case 7:
                    return "null";
            }
        },
        _functionKeys: function(e) {
            return Object.keys(e[0]);
        },
        _functionValues: function(e) {
            for(var t = e[0], n = Object.keys(t), r = [], o = 0; o < n.length; o++)r.push(t[n[o]]);
            return r;
        },
        _functionJoin: function(e) {
            var t = e[0];
            return e[1].join(t);
        },
        _functionToArray: function(e) {
            return this._getTypeName(e[0]) === l ? e[0] : [
                e[0]
            ];
        },
        _functionToString: function(e) {
            return this._getTypeName(e[0]) === c ? e[0] : JSON.stringify(e[0]);
        },
        _functionToNumber: function(e) {
            var t, n = this._getTypeName(e[0]);
            return n === a ? e[0] : n !== c || (t = +e[0], isNaN(t)) ? null : t;
        },
        _functionNotNull: function(e) {
            for(var t = 0; t < e.length; t++)if (7 !== this._getTypeName(e[t])) return e[t];
            return null;
        },
        _functionSort: function(e) {
            var t = e[0].slice(0);
            return t.sort(), t;
        },
        _functionSortBy: function(e) {
            var t = e[0].slice(0);
            if (0 === t.length) return t;
            var n = this._interpreter, r = e[1], o = this._getTypeName(n.visit(r, t[0]));
            if ([
                a,
                c
            ].indexOf(o) < 0) throw new Error("TypeError");
            for(var i = this, s = [], l = 0; l < t.length; l++)s.push([
                l,
                t[l]
            ]);
            s.sort(function(e, t) {
                var a = n.visit(r, e[1]), s = n.visit(r, t[1]);
                if (i._getTypeName(a) !== o) throw new Error("TypeError: expected " + o + ", received " + i._getTypeName(a));
                if (i._getTypeName(s) !== o) throw new Error("TypeError: expected " + o + ", received " + i._getTypeName(s));
                return a > s ? 1 : a < s ? -1 : e[0] - t[0];
            });
            for(var u = 0; u < s.length; u++)t[u] = s[u][1];
            return t;
        },
        _functionMaxBy: function(e) {
            for(var t, n, r = e[1], o = e[0], i = this.createKeyFunction(r, [
                a,
                c
            ]), s = -1 / 0, l = 0; l < o.length; l++)(n = i(o[l])) > s && (s = n, t = o[l]);
            return t;
        },
        _functionMinBy: function(e) {
            for(var t, n, r = e[1], o = e[0], i = this.createKeyFunction(r, [
                a,
                c
            ]), s = 1 / 0, l = 0; l < o.length; l++)(n = i(o[l])) < s && (s = n, t = o[l]);
            return t;
        },
        createKeyFunction: function(e, t) {
            var n = this, r = this._interpreter;
            return function(o) {
                var i = r.visit(e, o);
                if (t.indexOf(n._getTypeName(i)) < 0) {
                    var a = "TypeError: expected one of " + t + ", received " + n._getTypeName(i);
                    throw new Error(a);
                }
                return i;
            };
        }
    }, e.tokenize = function(e) {
        return (new K).tokenize(e);
    }, e.compile = function(e) {
        return (new Q).parse(e);
    }, e.search = function(e, t) {
        var n = new Q, r = new X, o = new Y(r);
        r._interpreter = o;
        var i = n.parse(t);
        return o.search(i, e);
    }, e.strictDeepEqual = r;
}(Uee);
var Jee = yc(Uee), Kee = {
    id: "jmespath",
    name: "JMESPath",
    description: '\n<p>\n  Enter a <a href="https://jmespath.org" target="_blank" rel="noopener noreferrer">JMESPath</a> query \n  to filter, sort, or transform the JSON data.\n To learn JMESPath, go to <a href="https://jmespath.org/tutorial.html" target="_blank" rel="noopener noreferrer">the interactive tutorial</a>.\n</p>\n',
    createQuery: function(e, t) {
        var n = t.sort, r = t.filter, o = t.projection, i = "";
        if (r && r.path && r.relation && r.value) {
            var a = Ws(e, [
                "0"
            ].concat(r.path)), s = nM(r.value), c = "string" == typeof a && null != s ? '"'.concat(r.value, '"') : s;
            i += "[? " + Gee(r.path) + " " + r.relation + " `" + c + "`]";
        } else i += Array.isArray(e) ? "[*]" : "@";
        n && n.path && n.direction && ("desc" === n.direction ? i += " | reverse(sort_by(@, &" + Gee(n.path) + "))" : i += " | sort_by(@, &" + Gee(n.path) + ")");
        if (o && o.paths) {
            if ("]" !== i[i.length - 1] && (i += " | [*]"), 1 === o.paths.length) {
                var l = o.paths[0];
                i += 0 === l.length ? "" : "." + Gee(l);
            } else o.paths.length > 1 && (i += ".{" + o.paths.map(function(e) {
                return Qee(e[e.length - 1]) + ": " + Gee(e);
            }).join(", ") + "}");
        }
        return i;
    },
    executeQuery: function(e, t, n) {
        var r = rO(n, JSON) ? e : function(e) {
            var t = n.stringify(e);
            return void 0 !== t ? JSON.parse(t) : void 0;
        }(e);
        return Jee.search(r, t);
    }
};
function Gee(e) {
    if (0 === e.length) return "@";
    var t = e.map(function(e) {
        return "number" == typeof e ? "[" + e + "]" : "." + Qee(String(e));
    }).join("");
    return "." === t[0] ? t.slice(1) : t;
}
function Qee(e) {
    return e.match(/^[A-Za-z\d_$]+$/) ? e : JSON.stringify(e);
}
/*!
 * vanilla-picker v2.12.2
 * https://vanilla-picker.js.org
 *
 * Copyright 2017-2023 Andreas Borgen (https://github.com/Sphinxxxx), Adam Brooks (https://github.com/dissimulate)
 * Released under the ISC license.
 */ var Yee = function(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}, Xee = function() {
    function e(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
    }
    return function(t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
    };
}(), Zee = function(e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function(e, t) {
        var n = [], r = !0, o = !1, i = void 0;
        try {
            for(var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
        } catch (e) {
            o = !0, i = e;
        } finally{
            try {
                !r && s.return && s.return();
            } finally{
                if (o) throw i;
            }
        }
        return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
};
String.prototype.startsWith = String.prototype.startsWith || function(e) {
    return 0 === this.indexOf(e);
}, String.prototype.padStart = String.prototype.padStart || function(e, t) {
    for(var n = this; n.length < e;)n = t + n;
    return n;
};
var ete = {
    cb: "0f8ff",
    tqw: "aebd7",
    q: "-ffff",
    qmrn: "7fffd4",
    zr: "0ffff",
    bg: "5f5dc",
    bsq: "e4c4",
    bck: "---",
    nch: "ebcd",
    b: "--ff",
    bvt: "8a2be2",
    brwn: "a52a2a",
    brw: "deb887",
    ctb: "5f9ea0",
    hrt: "7fff-",
    chcT: "d2691e",
    cr: "7f50",
    rnw: "6495ed",
    crns: "8dc",
    crms: "dc143c",
    cn: "-ffff",
    Db: "--8b",
    Dcn: "-8b8b",
    Dgnr: "b8860b",
    Dgr: "a9a9a9",
    Dgrn: "-64-",
    Dkhk: "bdb76b",
    Dmgn: "8b-8b",
    Dvgr: "556b2f",
    Drng: "8c-",
    Drch: "9932cc",
    Dr: "8b--",
    Dsmn: "e9967a",
    Dsgr: "8fbc8f",
    DsTb: "483d8b",
    DsTg: "2f4f4f",
    Dtrq: "-ced1",
    Dvt: "94-d3",
    ppnk: "1493",
    pskb: "-bfff",
    mgr: "696969",
    grb: "1e90ff",
    rbrc: "b22222",
    rwht: "af0",
    stg: "228b22",
    chs: "-ff",
    gnsb: "dcdcdc",
    st: "8f8ff",
    g: "d7-",
    gnr: "daa520",
    gr: "808080",
    grn: "-8-0",
    grnw: "adff2f",
    hnw: "0fff0",
    htpn: "69b4",
    nnr: "cd5c5c",
    ng: "4b-82",
    vr: "0",
    khk: "0e68c",
    vnr: "e6e6fa",
    nrb: "0f5",
    wngr: "7cfc-",
    mnch: "acd",
    Lb: "add8e6",
    Lcr: "08080",
    Lcn: "e0ffff",
    Lgnr: "afad2",
    Lgr: "d3d3d3",
    Lgrn: "90ee90",
    Lpnk: "b6c1",
    Lsmn: "a07a",
    Lsgr: "20b2aa",
    Lskb: "87cefa",
    LsTg: "778899",
    Lstb: "b0c4de",
    Lw: "e0",
    m: "-ff-",
    mgrn: "32cd32",
    nn: "af0e6",
    mgnt: "-ff",
    mrn: "8--0",
    mqm: "66cdaa",
    mmb: "--cd",
    mmrc: "ba55d3",
    mmpr: "9370db",
    msg: "3cb371",
    mmsT: "7b68ee",
    "": "-fa9a",
    mtr: "48d1cc",
    mmvt: "c71585",
    mnLb: "191970",
    ntc: "5fffa",
    mstr: "e4e1",
    mccs: "e4b5",
    vjw: "dead",
    nv: "--80",
    c: "df5e6",
    v: "808-0",
    vrb: "6b8e23",
    rng: "a5-",
    rngr: "45-",
    rch: "da70d6",
    pgnr: "eee8aa",
    pgrn: "98fb98",
    ptrq: "afeeee",
    pvtr: "db7093",
    ppwh: "efd5",
    pchp: "dab9",
    pr: "cd853f",
    pnk: "c0cb",
    pm: "dda0dd",
    pwrb: "b0e0e6",
    prp: "8-080",
    cc: "663399",
    r: "--",
    sbr: "bc8f8f",
    rb: "4169e1",
    sbrw: "8b4513",
    smn: "a8072",
    nbr: "4a460",
    sgrn: "2e8b57",
    ssh: "5ee",
    snn: "a0522d",
    svr: "c0c0c0",
    skb: "87ceeb",
    sTb: "6a5acd",
    sTgr: "708090",
    snw: "afa",
    n: "-ff7f",
    stb: "4682b4",
    tn: "d2b48c",
    t: "-8080",
    thst: "d8bfd8",
    tmT: "6347",
    trqs: "40e0d0",
    vt: "ee82ee",
    whT: "5deb3",
    wht: "",
    hts: "5f5f5",
    w: "-",
    wgrn: "9acd32"
};
function tte(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
    return (t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString()) || "0";
}
var nte = function() {
    function e(t, n, r, o) {
        Yee(this, e);
        var i = this;
        if (void 0 === t) ;
        else if (Array.isArray(t)) this.rgba = t;
        else if (void 0 === r) {
            var a = t && "" + t;
            a && function(t) {
                if (t.startsWith("hsl")) {
                    var n = t.match(/([\-\d\.e]+)/g).map(Number), r = Zee(n, 4), o = r[0], a = r[1], s = r[2], c = r[3];
                    void 0 === c && (c = 1), o /= 360, a /= 100, s /= 100, i.hsla = [
                        o,
                        a,
                        s,
                        c
                    ];
                } else if (t.startsWith("rgb")) {
                    var l = t.match(/([\-\d\.e]+)/g).map(Number), u = Zee(l, 4), f = u[0], d = u[1], h = u[2], v = u[3];
                    void 0 === v && (v = 1), i.rgba = [
                        f,
                        d,
                        h,
                        v
                    ];
                } else t.startsWith("#") ? i.rgba = e.hexToRgb(t) : i.rgba = e.nameToRgb(t) || e.hexToRgb(t);
            }(a.toLowerCase());
        } else this.rgba = [
            t,
            n,
            r,
            void 0 === o ? 1 : o
        ];
    }
    return Xee(e, [
        {
            key: "printRGB",
            value: function(e) {
                var t = (e ? this.rgba : this.rgba.slice(0, 3)).map(function(e, t) {
                    return tte(e, 3 === t ? 3 : 0);
                });
                return e ? "rgba(" + t + ")" : "rgb(" + t + ")";
            }
        },
        {
            key: "printHSL",
            value: function(e) {
                var t = [
                    360,
                    100,
                    100,
                    1
                ], n = [
                    "",
                    "%",
                    "%",
                    ""
                ], r = (e ? this.hsla : this.hsla.slice(0, 3)).map(function(e, r) {
                    return tte(e * t[r], 3 === r ? 3 : 1) + n[r];
                });
                return e ? "hsla(" + r + ")" : "hsl(" + r + ")";
            }
        },
        {
            key: "printHex",
            value: function(e) {
                var t = this.hex;
                return e ? t : t.substring(0, 7);
            }
        },
        {
            key: "rgba",
            get: function() {
                if (this._rgba) return this._rgba;
                if (!this._hsla) throw new Error("No color is set");
                return this._rgba = e.hslToRgb(this._hsla);
            },
            set: function(e) {
                3 === e.length && (e[3] = 1), this._rgba = e, this._hsla = null;
            }
        },
        {
            key: "rgbString",
            get: function() {
                return this.printRGB();
            }
        },
        {
            key: "rgbaString",
            get: function() {
                return this.printRGB(!0);
            }
        },
        {
            key: "hsla",
            get: function() {
                if (this._hsla) return this._hsla;
                if (!this._rgba) throw new Error("No color is set");
                return this._hsla = e.rgbToHsl(this._rgba);
            },
            set: function(e) {
                3 === e.length && (e[3] = 1), this._hsla = e, this._rgba = null;
            }
        },
        {
            key: "hslString",
            get: function() {
                return this.printHSL();
            }
        },
        {
            key: "hslaString",
            get: function() {
                return this.printHSL(!0);
            }
        },
        {
            key: "hex",
            get: function() {
                var e = this.rgba.map(function(e, t) {
                    return t < 3 ? e.toString(16) : Math.round(255 * e).toString(16);
                });
                return "#" + e.map(function(e) {
                    return e.padStart(2, "0");
                }).join("");
            },
            set: function(t) {
                this.rgba = e.hexToRgb(t);
            }
        }
    ], [
        {
            key: "hexToRgb",
            value: function(e) {
                var t = (e.startsWith("#") ? e.slice(1) : e).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
                if (!t.match(/^([0-9a-fA-F]{8})$/)) throw new Error("Unknown hex color; " + e);
                var n = t.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function(e) {
                    return parseInt(e, 16);
                });
                return n[3] = n[3] / 255, n;
            }
        },
        {
            key: "nameToRgb",
            value: function(t) {
                var n = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4), r = ete[n];
                return void 0 === r ? r : e.hexToRgb(r.replace(/\-/g, "00").padStart(6, "f"));
            }
        },
        {
            key: "rgbToHsl",
            value: function(e) {
                var t = Zee(e, 4), n = t[0], r = t[1], o = t[2], i = t[3];
                n /= 255, r /= 255, o /= 255;
                var a = Math.max(n, r, o), s = Math.min(n, r, o), c = void 0, l = void 0, u = (a + s) / 2;
                if (a === s) c = l = 0;
                else {
                    var f = a - s;
                    switch(l = u > .5 ? f / (2 - a - s) : f / (a + s), a){
                        case n:
                            c = (r - o) / f + (r < o ? 6 : 0);
                            break;
                        case r:
                            c = (o - n) / f + 2;
                            break;
                        case o:
                            c = (n - r) / f + 4;
                    }
                    c /= 6;
                }
                return [
                    c,
                    l,
                    u,
                    i
                ];
            }
        },
        {
            key: "hslToRgb",
            value: function(e) {
                var t = Zee(e, 4), n = t[0], r = t[1], o = t[2], i = t[3], a = void 0, s = void 0, c = void 0;
                if (0 === r) a = s = c = o;
                else {
                    var l = function(e, t, n) {
                        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
                    }, u = o < .5 ? o * (1 + r) : o + r - o * r, f = 2 * o - u;
                    a = l(f, u, n + 1 / 3), s = l(f, u, n), c = l(f, u, n - 1 / 3);
                }
                var d = [
                    255 * a,
                    255 * s,
                    255 * c
                ].map(Math.round);
                return d[3] = i, d;
            }
        }
    ]), e;
}(), rte = function() {
    function e() {
        Yee(this, e), this._events = [];
    }
    return Xee(e, [
        {
            key: "add",
            value: function(e, t, n) {
                e.addEventListener(t, n, !1), this._events.push({
                    target: e,
                    type: t,
                    handler: n
                });
            }
        },
        {
            key: "remove",
            value: function(t, n, r) {
                this._events = this._events.filter(function(o) {
                    var i = !0;
                    return t && t !== o.target && (i = !1), n && n !== o.type && (i = !1), r && r !== o.handler && (i = !1), i && e._doRemove(o.target, o.type, o.handler), !i;
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this._events.forEach(function(t) {
                    return e._doRemove(t.target, t.type, t.handler);
                }), this._events = [];
            }
        }
    ], [
        {
            key: "_doRemove",
            value: function(e, t, n) {
                e.removeEventListener(t, n, !1);
            }
        }
    ]), e;
}();
function ote(e, t, n) {
    var r = !1;
    function o(e, t, n) {
        return Math.max(t, Math.min(e, n));
    }
    function i(e, i, a) {
        if (a && (r = !0), r) {
            e.preventDefault();
            var s = t.getBoundingClientRect(), c = s.width, l = s.height, u = i.clientX, f = i.clientY, d = o(u - s.left, 0, c), h = o(f - s.top, 0, l);
            n(d / c, h / l);
        }
    }
    function a(e, t) {
        1 === (void 0 === e.buttons ? e.which : e.buttons) ? i(e, e, t) : r = !1;
    }
    function s(e, t) {
        1 === e.touches.length ? i(e, e.touches[0], t) : r = !1;
    }
    e.add(t, "mousedown", function(e) {
        a(e, !0);
    }), e.add(t, "touchstart", function(e) {
        s(e, !0);
    }), e.add(window, "mousemove", a), e.add(t, "touchmove", s), e.add(window, "mouseup", function(e) {
        r = !1;
    }), e.add(t, "touchend", function(e) {
        r = !1;
    }), e.add(t, "touchcancel", function(e) {
        r = !1;
    });
}
var ite = "keydown", ate = "mousedown", ste = "focusin";
function cte(e, t) {
    return (t || document).querySelector(e);
}
function lte(e) {
    e.preventDefault(), e.stopPropagation();
}
function ute(e, t, n, r, o) {
    e.add(t, ite, function(e) {
        n.indexOf(e.key) >= 0 && (o && lte(e), r(e));
    });
}
var fte = function() {
    function e(t) {
        Yee(this, e), this.settings = {
            popup: "right",
            layout: "default",
            alpha: !0,
            editor: !0,
            editorFormat: "hex",
            cancelButton: !1,
            defaultColor: "#0cf"
        }, this._events = new rte, this.onChange = null, this.onDone = null, this.onOpen = null, this.onClose = null, this.setOptions(t);
    }
    return Xee(e, [
        {
            key: "setOptions",
            value: function(e) {
                var t = this;
                if (e) {
                    var n = this.settings;
                    if (e instanceof HTMLElement) n.parent = e;
                    else {
                        n.parent && e.parent && n.parent !== e.parent && (this._events.remove(n.parent), this._popupInited = !1), function(e, t, n) {
                            for(var r in e)n && n.indexOf(r) >= 0 || (t[r] = e[r]);
                        }(e, n), e.onChange && (this.onChange = e.onChange), e.onDone && (this.onDone = e.onDone), e.onOpen && (this.onOpen = e.onOpen), e.onClose && (this.onClose = e.onClose);
                        var r = e.color || e.colour;
                        r && this._setColor(r);
                    }
                    var o = n.parent;
                    if (o && n.popup && !this._popupInited) {
                        var i = function(e) {
                            return t.openHandler(e);
                        };
                        this._events.add(o, "click", i), ute(this._events, o, [
                            " ",
                            "Spacebar",
                            "Enter"
                        ], i), this._popupInited = !0;
                    } else e.parent && !n.popup && this.show();
                }
            }
        },
        {
            key: "openHandler",
            value: function(e) {
                if (this.show()) {
                    e && e.preventDefault(), this.settings.parent.style.pointerEvents = "none";
                    var t = e && e.type === ite ? this._domEdit : this.domElement;
                    setTimeout(function() {
                        return t.focus();
                    }, 100), this.onOpen && this.onOpen(this.colour);
                }
            }
        },
        {
            key: "closeHandler",
            value: function(e) {
                var t = e && e.type, n = !1;
                if (e) {
                    if (t === ate || t === ste) {
                        var r = (this.__containedEvent || 0) + 100;
                        e.timeStamp > r && (n = !0);
                    } else lte(e), n = !0;
                } else n = !0;
                n && this.hide() && (this.settings.parent.style.pointerEvents = "", t !== ate && this.settings.parent.focus(), this.onClose && this.onClose(this.colour));
            }
        },
        {
            key: "movePopup",
            value: function(e, t) {
                this.closeHandler(), this.setOptions(e), t && this.openHandler();
            }
        },
        {
            key: "setColor",
            value: function(e, t) {
                this._setColor(e, {
                    silent: t
                });
            }
        },
        {
            key: "_setColor",
            value: function(e, t) {
                if ("string" == typeof e && (e = e.trim()), e) {
                    t = t || {};
                    var n = void 0;
                    try {
                        n = new nte(e);
                    } catch (e) {
                        if (t.failSilently) return;
                        throw e;
                    }
                    if (!this.settings.alpha) {
                        var r = n.hsla;
                        r[3] = 1, n.hsla = r;
                    }
                    this.colour = this.color = n, this._setHSLA(null, null, null, null, t);
                }
            }
        },
        {
            key: "setColour",
            value: function(e, t) {
                this.setColor(e, t);
            }
        },
        {
            key: "show",
            value: function() {
                if (!this.settings.parent) return !1;
                if (this.domElement) {
                    var e = this._toggleDOM(!0);
                    return this._setPosition(), e;
                }
                var t, n, r = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>', o = (t = r, (n = document.createElement("div")).innerHTML = t, n.firstElementChild);
                return this.domElement = o, this._domH = cte(".picker_hue", o), this._domSL = cte(".picker_sl", o), this._domA = cte(".picker_alpha", o), this._domEdit = cte(".picker_editor input", o), this._domSample = cte(".picker_sample", o), this._domOkay = cte(".picker_done button", o), this._domCancel = cte(".picker_cancel button", o), o.classList.add("layout_" + this.settings.layout), this.settings.alpha || o.classList.add("no_alpha"), this.settings.editor || o.classList.add("no_editor"), this.settings.cancelButton || o.classList.add("no_cancel"), this._ifPopup(function() {
                    return o.classList.add("popup");
                }), this._setPosition(), this.colour ? this._updateUI() : this._setColor(this.settings.defaultColor), this._bindEvents(), !0;
            }
        },
        {
            key: "hide",
            value: function() {
                return this._toggleDOM(!1);
            }
        },
        {
            key: "destroy",
            value: function() {
                this._events.destroy(), this.domElement && this.settings.parent.removeChild(this.domElement);
            }
        },
        {
            key: "_bindEvents",
            value: function() {
                var e = this, t = this, n = this.domElement, r = this._events;
                function o(e, t, n) {
                    r.add(e, t, n);
                }
                o(n, "click", function(e) {
                    return e.preventDefault();
                }), ote(r, this._domH, function(e, n) {
                    return t._setHSLA(e);
                }), ote(r, this._domSL, function(e, n) {
                    return t._setHSLA(null, e, 1 - n);
                }), this.settings.alpha && ote(r, this._domA, function(e, n) {
                    return t._setHSLA(null, null, null, 1 - n);
                });
                var i = this._domEdit;
                o(i, "input", function(e) {
                    t._setColor(this.value, {
                        fromEditor: !0,
                        failSilently: !0
                    });
                }), o(i, "focus", function(e) {
                    var t = this;
                    t.selectionStart === t.selectionEnd && t.select();
                }), this._ifPopup(function() {
                    var t = function(t) {
                        return e.closeHandler(t);
                    };
                    o(window, ate, t), o(window, ste, t), ute(r, n, [
                        "Esc",
                        "Escape"
                    ], t);
                    var i = function(t) {
                        e.__containedEvent = t.timeStamp;
                    };
                    o(n, ate, i), o(n, ste, i), o(e._domCancel, "click", t);
                });
                var a = function(t) {
                    e._ifPopup(function() {
                        return e.closeHandler(t);
                    }), e.onDone && e.onDone(e.colour);
                };
                o(this._domOkay, "click", a), ute(r, n, [
                    "Enter"
                ], a);
            }
        },
        {
            key: "_setPosition",
            value: function() {
                var e = this.settings.parent, t = this.domElement;
                e !== t.parentNode && e.appendChild(t), this._ifPopup(function(n) {
                    "static" === getComputedStyle(e).position && (e.style.position = "relative");
                    var r = !0 === n ? "popup_right" : "popup_" + n;
                    [
                        "popup_top",
                        "popup_bottom",
                        "popup_left",
                        "popup_right"
                    ].forEach(function(e) {
                        e === r ? t.classList.add(e) : t.classList.remove(e);
                    }), t.classList.add(r);
                });
            }
        },
        {
            key: "_setHSLA",
            value: function(e, t, n, r, o) {
                o = o || {};
                var i = this.colour, a = i.hsla;
                [
                    e,
                    t,
                    n,
                    r
                ].forEach(function(e, t) {
                    (e || 0 === e) && (a[t] = e);
                }), i.hsla = a, this._updateUI(o), this.onChange && !o.silent && this.onChange(i);
            }
        },
        {
            key: "_updateUI",
            value: function(e) {
                if (this.domElement) {
                    e = e || {};
                    var t = this.colour, n = t.hsla, r = "hsl(" + 360 * n[0] + ", 100%, 50%)", o = t.hslString, i = t.hslaString, a = this._domH, s = this._domSL, c = this._domA, l = cte(".picker_selector", a), u = cte(".picker_selector", s), f = cte(".picker_selector", c);
                    y(0, l, n[0]), this._domSL.style.backgroundColor = this._domH.style.color = r, y(0, u, n[1]), b(0, u, 1 - n[2]), s.style.color = o, b(0, f, 1 - n[3]);
                    var d = o, h = d.replace("hsl", "hsla").replace(")", ", 0)"), v = "linear-gradient(" + [
                        d,
                        h
                    ] + ")";
                    if (this._domA.style.background = v + ", linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em", !e.fromEditor) {
                        var p = this.settings.editorFormat, m = this.settings.alpha, g = void 0;
                        switch(p){
                            case "rgb":
                                g = t.printRGB(m);
                                break;
                            case "hsl":
                                g = t.printHSL(m);
                                break;
                            default:
                                g = t.printHex(m);
                        }
                        this._domEdit.value = g;
                    }
                    this._domSample.style.color = i;
                }
                function y(e, t, n) {
                    t.style.left = 100 * n + "%";
                }
                function b(e, t, n) {
                    t.style.top = 100 * n + "%";
                }
            }
        },
        {
            key: "_ifPopup",
            value: function(e, t) {
                this.settings.parent && this.settings.popup ? e && e(this.settings.popup) : t && t();
            }
        },
        {
            key: "_toggleDOM",
            value: function(e) {
                var t = this.domElement;
                if (!t) return !1;
                var n = e ? "" : "none", r = t.style.display !== n;
                return r && (t.style.display = n), r;
            }
        }
    ]), e;
}(), dte = document.createElement("style");
dte.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}', document.documentElement.firstElementChild.appendChild(dte), fte.StyleElement = dte;
var hte = Object.freeze({
    __proto__: null,
    default: fte
});

});

parcelRegister("4cbVS", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7Ii5r.default;
    }
});

var $7Ii5r = parcelRequire("7Ii5r");

});
parcelRegister("7Ii5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $59daac1cceb559a2$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $cMinS = parcelRequire("cMinS");

var $cZGFG = parcelRequire("cZGFG");
"use client";
function $59daac1cceb559a2$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cMinS.default), (0, $3G4eg.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $cMinS.default).muiName;
    return /*#__PURE__*/ $dup7A.memo(/*#__PURE__*/ $dup7A.forwardRef(Component));
}

});
parcelRegister("3G4eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad89326f6f07287$export$2e2bcd8739ae039);
function $2ad89326f6f07287$export$2e2bcd8739ae039() {
    $2ad89326f6f07287$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ad89326f6f07287$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cMinS", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d83a72ffdc162b$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $4CYID = parcelRequire("4CYID");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $94d83a72ffdc162b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $94d83a72ffdc162b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $4y4xl.default)(color)}`,
            `fontSize${(0, $4y4xl.default)(fontSize)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $4CYID.getSvgIconUtilityClass), classes);
};
const $94d83a72ffdc162b$var$SvgIconRoot = (0, $jjHhy.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $4y4xl.default)(ownerState.color)}`],
            styles[`fontSize${(0, $4y4xl.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $94d83a72ffdc162b$var$SvgIcon = /*#__PURE__*/ $dup7A.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $bGxpK.default)(props, $94d83a72ffdc162b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $dup7A.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $94d83a72ffdc162b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($94d83a72ffdc162b$var$SvgIconRoot, (0, $3G4eg.default)({
        as: component,
        className: (0, $aJAJS.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $cZGFG.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$94d83a72ffdc162b$var$SvgIcon.muiName = "SvgIcon";
var $94d83a72ffdc162b$export$2e2bcd8739ae039 = $94d83a72ffdc162b$var$SvgIcon;

});
parcelRegister("bGxpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $881d8951ad829f2f$export$2e2bcd8739ae039);
function $881d8951ad829f2f$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("aJAJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $79002a25ea2eb8b6$export$2e2bcd8739ae039);
function $79002a25ea2eb8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $79002a25ea2eb8b6$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $79002a25ea2eb8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $79002a25ea2eb8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $79002a25ea2eb8b6$export$2e2bcd8739ae039 = $79002a25ea2eb8b6$export$4f5d2d50c9deca37;

});

parcelRegister("2wgr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d5b51a92550aa8e$export$2e2bcd8739ae039);
function $1d5b51a92550aa8e$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("4y4xl", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fddb4de47c893e$export$2e2bcd8739ae039);

var $8xa0D = parcelRequire("8xa0D");
var $34fddb4de47c893e$export$2e2bcd8739ae039 = (0, $8xa0D.default);

});
parcelRegister("8xa0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $63692b6dd879c169$export$2e2bcd8739ae039);

var $e50cx = parcelRequire("e50cx");
function $63692b6dd879c169$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $e50cx.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("e50cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a401b044c439cb7a$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a401b044c439cb7a$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("7ZufN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d15b2abad5fe707$export$2e2bcd8739ae039);

var $866st = parcelRequire("866st");

var $hddxs = parcelRequire("hddxs");

var $7wciM = parcelRequire("7wciM");
"use client";
function $5d15b2abad5fe707$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $866st.default)({
        props: props,
        name: name,
        defaultTheme: $hddxs.default,
        themeId: (0, $7wciM.default)
    });
}

});
parcelRegister("866st", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e53e4bd147a54df$export$2e2bcd8739ae039);

var $lk4Pv = parcelRequire("lk4Pv");

var $lcALP = parcelRequire("lcALP");
"use client";
function $5e53e4bd147a54df$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $lcALP.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $lk4Pv.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("lk4Pv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85f36578aaec818$export$2e2bcd8739ae039);

var $bNgkT = parcelRequire("bNgkT");
function $f85f36578aaec818$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $bNgkT.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("bNgkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8960f147a6668afd$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");
function $8960f147a6668afd$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $3G4eg.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $3G4eg.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $3G4eg.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $8960f147a6668afd$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("lcALP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f73dcf0438f5f4$export$2e2bcd8739ae039);

var $1kGZC = parcelRequire("1kGZC");

var $eVrzI = parcelRequire("eVrzI");
"use client";
const $f6f73dcf0438f5f4$export$35e57303dbd8a66 = (0, $1kGZC.default)();
function $f6f73dcf0438f5f4$var$useTheme(defaultTheme = $f6f73dcf0438f5f4$export$35e57303dbd8a66) {
    return (0, $eVrzI.default)(defaultTheme);
}
var $f6f73dcf0438f5f4$export$2e2bcd8739ae039 = $f6f73dcf0438f5f4$var$useTheme;

});
parcelRegister("1kGZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f89023530c93175$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $gmeoE = parcelRequire("gmeoE");

var $12PJy = parcelRequire("12PJy");

var $2mS2z = parcelRequire("2mS2z");

var $54nWl = parcelRequire("54nWl");

var $7eWjf = parcelRequire("7eWjf");

var $bDGwn = parcelRequire("bDGwn");

var $36jUO = parcelRequire("36jUO");
const $0f89023530c93175$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $0f89023530c93175$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $bGxpK.default)(options, $0f89023530c93175$var$_excluded);
    const breakpoints = (0, $12PJy.default)(breakpointsInput);
    const spacing = (0, $54nWl.default)(spacingInput);
    let muiTheme = (0, $gmeoE.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $3G4eg.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $3G4eg.default)({}, (0, $2mS2z.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $36jUO.default);
    muiTheme = args.reduce((acc, argument)=>(0, $gmeoE.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $3G4eg.default)({}, (0, $bDGwn.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $7eWjf.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $0f89023530c93175$export$2e2bcd8739ae039 = $0f89023530c93175$var$createTheme;

});
parcelRegister("gmeoE", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $be89de4dc4389e0c$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $be89de4dc4389e0c$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");
function $be89de4dc4389e0c$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $be89de4dc4389e0c$var$deepClone(source) {
    if (!$be89de4dc4389e0c$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $be89de4dc4389e0c$var$deepClone(source[key]);
    });
    return output;
}
function $be89de4dc4389e0c$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $3G4eg.default)({}, target) : target;
    if ($be89de4dc4389e0c$export$53b83ca8eaab0383(target) && $be89de4dc4389e0c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($be89de4dc4389e0c$export$53b83ca8eaab0383(source[key]) && key in target && $be89de4dc4389e0c$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $be89de4dc4389e0c$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $be89de4dc4389e0c$export$53b83ca8eaab0383(source[key]) ? $be89de4dc4389e0c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("12PJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2e1b96275f21a9$export$2e2bcd8739ae039);

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");
const $0c2e1b96275f21a9$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $0c2e1b96275f21a9$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $0c2e1b96275f21a9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $3G4eg.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $0c2e1b96275f21a9$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $bGxpK.default)(breakpoints, $0c2e1b96275f21a9$var$_excluded);
    const sortedValues = $0c2e1b96275f21a9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $3G4eg.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("2mS2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b978e26cf4e4dd4$export$2e2bcd8739ae039);
const $1b978e26cf4e4dd4$var$shape = {
    borderRadius: 4
};
var $1b978e26cf4e4dd4$export$2e2bcd8739ae039 = $1b978e26cf4e4dd4$var$shape;

});

parcelRegister("54nWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0fe57d7ceb38dd$export$2e2bcd8739ae039);

var $jXXjr = parcelRequire("jXXjr");
function $3b0fe57d7ceb38dd$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $jXXjr.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("jXXjr", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $e891893aca8062e0$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $e891893aca8062e0$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $e891893aca8062e0$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $e891893aca8062e0$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $e891893aca8062e0$export$6f98e8eaf0be1996);


var $b9Q9P = parcelRequire("b9Q9P");

var $5NdnQ = parcelRequire("5NdnQ");

var $1hxwZ = parcelRequire("1hxwZ");

var $V4nZc = parcelRequire("V4nZc");
const $e891893aca8062e0$var$properties = {
    m: "margin",
    p: "padding"
};
const $e891893aca8062e0$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $e891893aca8062e0$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $e891893aca8062e0$var$getCssProperties = (0, $V4nZc.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($e891893aca8062e0$var$aliases[prop]) prop = $e891893aca8062e0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $e891893aca8062e0$var$properties[a];
    const direction = $e891893aca8062e0$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $e891893aca8062e0$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $e891893aca8062e0$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $e891893aca8062e0$var$spacingKeys = [
    ...$e891893aca8062e0$export$aab52a0dde05ad8a,
    ...$e891893aca8062e0$export$f8397d44f03ab6ad
];
function $e891893aca8062e0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $5NdnQ.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $e891893aca8062e0$export$1def6f833384e3d1(theme) {
    return $e891893aca8062e0$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $e891893aca8062e0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $e891893aca8062e0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $e891893aca8062e0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $e891893aca8062e0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $e891893aca8062e0$var$getCssProperties(prop);
    const styleFromPropValue = $e891893aca8062e0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $b9Q9P.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $e891893aca8062e0$var$style(props, keys) {
    const transformer = $e891893aca8062e0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$e891893aca8062e0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $1hxwZ.default), {});
}
function $e891893aca8062e0$export$7ede87f9b603dd3c(props) {
    return $e891893aca8062e0$var$style(props, $e891893aca8062e0$export$aab52a0dde05ad8a);
}
$e891893aca8062e0$export$7ede87f9b603dd3c.propTypes = {};
$e891893aca8062e0$export$7ede87f9b603dd3c.filterProps = $e891893aca8062e0$export$aab52a0dde05ad8a;
function $e891893aca8062e0$export$6f98e8eaf0be1996(props) {
    return $e891893aca8062e0$var$style(props, $e891893aca8062e0$export$f8397d44f03ab6ad);
}
$e891893aca8062e0$export$6f98e8eaf0be1996.propTypes = {};
$e891893aca8062e0$export$6f98e8eaf0be1996.filterProps = $e891893aca8062e0$export$f8397d44f03ab6ad;
function $e891893aca8062e0$var$spacing(props) {
    return $e891893aca8062e0$var$style(props, $e891893aca8062e0$var$spacingKeys);
}
$e891893aca8062e0$var$spacing.propTypes = {};
$e891893aca8062e0$var$spacing.filterProps = $e891893aca8062e0$var$spacingKeys;
var $e891893aca8062e0$export$2e2bcd8739ae039 = $e891893aca8062e0$var$spacing;

});
parcelRegister("b9Q9P", function(module, exports) {

$parcel$export(module.exports, "values", () => $0218a943b3685d1d$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $0218a943b3685d1d$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $0218a943b3685d1d$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $0218a943b3685d1d$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $0218a943b3685d1d$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $0218a943b3685d1d$export$980e6a259d807490);

var $3G4eg = parcelRequire("3G4eg");


var $gmeoE = parcelRequire("gmeoE");

var $1hxwZ = parcelRequire("1hxwZ");
const $0218a943b3685d1d$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $0218a943b3685d1d$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$0218a943b3685d1d$export$68c286be0e7e55b7[key]}px)`
};
function $0218a943b3685d1d$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $0218a943b3685d1d$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $0218a943b3685d1d$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $0218a943b3685d1d$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $0218a943b3685d1d$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $0218a943b3685d1d$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $3G4eg.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $1hxwZ.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $0218a943b3685d1d$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $0218a943b3685d1d$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $0218a943b3685d1d$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $0218a943b3685d1d$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $gmeoE.default)(prev, next), {});
    return $0218a943b3685d1d$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $0218a943b3685d1d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $0218a943b3685d1d$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $0218a943b3685d1d$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $0218a943b3685d1d$export$2e2bcd8739ae039 = $0218a943b3685d1d$var$breakpoints;

});
parcelRegister("1hxwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef1638c06f346d4$export$2e2bcd8739ae039);

var $gmeoE = parcelRequire("gmeoE");
function $0ef1638c06f346d4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $gmeoE.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $0ef1638c06f346d4$export$2e2bcd8739ae039 = $0ef1638c06f346d4$var$merge;

});


parcelRegister("5NdnQ", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $437be90a71d3bbe5$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $437be90a71d3bbe5$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $437be90a71d3bbe5$export$2e2bcd8739ae039);

var $8xa0D = parcelRequire("8xa0D");


var $b9Q9P = parcelRequire("b9Q9P");
function $437be90a71d3bbe5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $437be90a71d3bbe5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $437be90a71d3bbe5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $437be90a71d3bbe5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $437be90a71d3bbe5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $437be90a71d3bbe5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $437be90a71d3bbe5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8xa0D.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $b9Q9P.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $437be90a71d3bbe5$export$2e2bcd8739ae039 = $437be90a71d3bbe5$var$style;

});

parcelRegister("V4nZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab8b9edd44cab1e$export$2e2bcd8739ae039);
function $0ab8b9edd44cab1e$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("7eWjf", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $54571239d5bdbb1a$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $54571239d5bdbb1a$export$2e2bcd8739ae039);

var $8xa0D = parcelRequire("8xa0D");

var $1hxwZ = parcelRequire("1hxwZ");

var $5NdnQ = parcelRequire("5NdnQ");

var $b9Q9P = parcelRequire("b9Q9P");

var $bDGwn = parcelRequire("bDGwn");
function $54571239d5bdbb1a$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $54571239d5bdbb1a$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $54571239d5bdbb1a$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $5NdnQ.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $5NdnQ.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $5NdnQ.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8xa0D.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $b9Q9P.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $bDGwn.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $b9Q9P.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $54571239d5bdbb1a$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $1hxwZ.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $b9Q9P.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($54571239d5bdbb1a$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $1hxwZ.default)(css, breakpointsValues);
                        }
                    } else css = (0, $1hxwZ.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $b9Q9P.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $54571239d5bdbb1a$var$styleFunctionSx = $54571239d5bdbb1a$export$7d53d8bf2911e013();
$54571239d5bdbb1a$var$styleFunctionSx.filterProps = [
    "sx"
];
var $54571239d5bdbb1a$export$2e2bcd8739ae039 = $54571239d5bdbb1a$var$styleFunctionSx;

});
parcelRegister("bDGwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $87945211a842edc3$export$2e2bcd8739ae039);

var $jXXjr = parcelRequire("jXXjr");

var $inmID = parcelRequire("inmID");

var $k3Cl7 = parcelRequire("k3Cl7");

var $hC06M = parcelRequire("hC06M");

var $jcIzO = parcelRequire("jcIzO");
const $87945211a842edc3$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $inmID.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $inmID.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $hC06M.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $hC06M.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $hC06M.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $jXXjr.padding)
    },
    pt: {
        style: (0, $jXXjr.padding)
    },
    pr: {
        style: (0, $jXXjr.padding)
    },
    pb: {
        style: (0, $jXXjr.padding)
    },
    pl: {
        style: (0, $jXXjr.padding)
    },
    px: {
        style: (0, $jXXjr.padding)
    },
    py: {
        style: (0, $jXXjr.padding)
    },
    padding: {
        style: (0, $jXXjr.padding)
    },
    paddingTop: {
        style: (0, $jXXjr.padding)
    },
    paddingRight: {
        style: (0, $jXXjr.padding)
    },
    paddingBottom: {
        style: (0, $jXXjr.padding)
    },
    paddingLeft: {
        style: (0, $jXXjr.padding)
    },
    paddingX: {
        style: (0, $jXXjr.padding)
    },
    paddingY: {
        style: (0, $jXXjr.padding)
    },
    paddingInline: {
        style: (0, $jXXjr.padding)
    },
    paddingInlineStart: {
        style: (0, $jXXjr.padding)
    },
    paddingInlineEnd: {
        style: (0, $jXXjr.padding)
    },
    paddingBlock: {
        style: (0, $jXXjr.padding)
    },
    paddingBlockStart: {
        style: (0, $jXXjr.padding)
    },
    paddingBlockEnd: {
        style: (0, $jXXjr.padding)
    },
    m: {
        style: (0, $jXXjr.margin)
    },
    mt: {
        style: (0, $jXXjr.margin)
    },
    mr: {
        style: (0, $jXXjr.margin)
    },
    mb: {
        style: (0, $jXXjr.margin)
    },
    ml: {
        style: (0, $jXXjr.margin)
    },
    mx: {
        style: (0, $jXXjr.margin)
    },
    my: {
        style: (0, $jXXjr.margin)
    },
    margin: {
        style: (0, $jXXjr.margin)
    },
    marginTop: {
        style: (0, $jXXjr.margin)
    },
    marginRight: {
        style: (0, $jXXjr.margin)
    },
    marginBottom: {
        style: (0, $jXXjr.margin)
    },
    marginLeft: {
        style: (0, $jXXjr.margin)
    },
    marginX: {
        style: (0, $jXXjr.margin)
    },
    marginY: {
        style: (0, $jXXjr.margin)
    },
    marginInline: {
        style: (0, $jXXjr.margin)
    },
    marginInlineStart: {
        style: (0, $jXXjr.margin)
    },
    marginInlineEnd: {
        style: (0, $jXXjr.margin)
    },
    marginBlock: {
        style: (0, $jXXjr.margin)
    },
    marginBlockStart: {
        style: (0, $jXXjr.margin)
    },
    marginBlockEnd: {
        style: (0, $jXXjr.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $k3Cl7.gap)
    },
    rowGap: {
        style: (0, $k3Cl7.rowGap)
    },
    columnGap: {
        style: (0, $k3Cl7.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $jcIzO.sizingTransform)
    },
    maxWidth: {
        style: (0, $jcIzO.maxWidth)
    },
    minWidth: {
        transform: (0, $jcIzO.sizingTransform)
    },
    height: {
        transform: (0, $jcIzO.sizingTransform)
    },
    maxHeight: {
        transform: (0, $jcIzO.sizingTransform)
    },
    minHeight: {
        transform: (0, $jcIzO.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $87945211a842edc3$export$2e2bcd8739ae039 = $87945211a842edc3$var$defaultSxConfig;

});
parcelRegister("inmID", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $d60bff781007d445$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $d60bff781007d445$export$7a57f79000377ca2);


var $5NdnQ = parcelRequire("5NdnQ");

var $9cxV6 = parcelRequire("9cxV6");

var $jXXjr = parcelRequire("jXXjr");

var $b9Q9P = parcelRequire("b9Q9P");
function $d60bff781007d445$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $d60bff781007d445$var$createBorderStyle(prop, transform) {
    return (0, $5NdnQ.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $d60bff781007d445$export$1edee58a52776cd9 = $d60bff781007d445$var$createBorderStyle("border", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$f9a7b6bd24892946 = $d60bff781007d445$var$createBorderStyle("borderTop", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$5abca33e6be905d2 = $d60bff781007d445$var$createBorderStyle("borderRight", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$e2ce9f12a980a822 = $d60bff781007d445$var$createBorderStyle("borderBottom", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$47658cca1a909427 = $d60bff781007d445$var$createBorderStyle("borderLeft", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$e7fb0694ba2404fc = $d60bff781007d445$var$createBorderStyle("borderColor");
const $d60bff781007d445$export$126a92c968acdb85 = $d60bff781007d445$var$createBorderStyle("borderTopColor");
const $d60bff781007d445$export$85cc51cb8fbb8c0e = $d60bff781007d445$var$createBorderStyle("borderRightColor");
const $d60bff781007d445$export$340b0327727f6d1a = $d60bff781007d445$var$createBorderStyle("borderBottomColor");
const $d60bff781007d445$export$60beef91a985b4bf = $d60bff781007d445$var$createBorderStyle("borderLeftColor");
const $d60bff781007d445$export$f9258c55612cbed7 = $d60bff781007d445$var$createBorderStyle("outline", $d60bff781007d445$export$34e2febe53ae29cc);
const $d60bff781007d445$export$621fe586efeb64b9 = $d60bff781007d445$var$createBorderStyle("outlineColor");
const $d60bff781007d445$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $jXXjr.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $jXXjr.getValue)(transformer, propValue)
            });
        return (0, $b9Q9P.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$d60bff781007d445$export$7a57f79000377ca2.propTypes = {};
$d60bff781007d445$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $d60bff781007d445$var$borders = (0, $9cxV6.default)($d60bff781007d445$export$1edee58a52776cd9, $d60bff781007d445$export$f9a7b6bd24892946, $d60bff781007d445$export$5abca33e6be905d2, $d60bff781007d445$export$e2ce9f12a980a822, $d60bff781007d445$export$47658cca1a909427, $d60bff781007d445$export$e7fb0694ba2404fc, $d60bff781007d445$export$126a92c968acdb85, $d60bff781007d445$export$85cc51cb8fbb8c0e, $d60bff781007d445$export$340b0327727f6d1a, $d60bff781007d445$export$60beef91a985b4bf, $d60bff781007d445$export$7a57f79000377ca2, $d60bff781007d445$export$f9258c55612cbed7, $d60bff781007d445$export$621fe586efeb64b9);
var $d60bff781007d445$export$2e2bcd8739ae039 = $d60bff781007d445$var$borders;

});
parcelRegister("9cxV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2f8be095748791$export$2e2bcd8739ae039);

var $1hxwZ = parcelRequire("1hxwZ");
function $6b2f8be095748791$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $1hxwZ.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $6b2f8be095748791$export$2e2bcd8739ae039 = $6b2f8be095748791$var$compose;

});


parcelRegister("k3Cl7", function(module, exports) {

$parcel$export(module.exports, "gap", () => $e9a1d3e9bc73c6fa$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $e9a1d3e9bc73c6fa$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $e9a1d3e9bc73c6fa$export$8a833ffa5f5dbeda);

var $5NdnQ = parcelRequire("5NdnQ");

var $9cxV6 = parcelRequire("9cxV6");

var $jXXjr = parcelRequire("jXXjr");

var $b9Q9P = parcelRequire("b9Q9P");

const $e9a1d3e9bc73c6fa$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $jXXjr.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $jXXjr.getValue)(transformer, propValue)
            });
        return (0, $b9Q9P.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$e9a1d3e9bc73c6fa$export$5df9adcb0db95e1e.propTypes = {};
$e9a1d3e9bc73c6fa$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $e9a1d3e9bc73c6fa$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $jXXjr.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $jXXjr.getValue)(transformer, propValue)
            });
        return (0, $b9Q9P.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$e9a1d3e9bc73c6fa$export$ec60d70ff941a580.propTypes = {};
$e9a1d3e9bc73c6fa$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $e9a1d3e9bc73c6fa$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $jXXjr.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $jXXjr.getValue)(transformer, propValue)
            });
        return (0, $b9Q9P.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$e9a1d3e9bc73c6fa$export$8a833ffa5f5dbeda.propTypes = {};
$e9a1d3e9bc73c6fa$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $e9a1d3e9bc73c6fa$export$baf44164ca3a34e8 = (0, $5NdnQ.default)({
    prop: "gridColumn"
});
const $e9a1d3e9bc73c6fa$export$8f7213a1cd01e832 = (0, $5NdnQ.default)({
    prop: "gridRow"
});
const $e9a1d3e9bc73c6fa$export$b0e0abbc49ba668 = (0, $5NdnQ.default)({
    prop: "gridAutoFlow"
});
const $e9a1d3e9bc73c6fa$export$bcd8b929d4b4142 = (0, $5NdnQ.default)({
    prop: "gridAutoColumns"
});
const $e9a1d3e9bc73c6fa$export$e5039a674e14c828 = (0, $5NdnQ.default)({
    prop: "gridAutoRows"
});
const $e9a1d3e9bc73c6fa$export$42bd9088661ffb03 = (0, $5NdnQ.default)({
    prop: "gridTemplateColumns"
});
const $e9a1d3e9bc73c6fa$export$920682ae05b999bc = (0, $5NdnQ.default)({
    prop: "gridTemplateRows"
});
const $e9a1d3e9bc73c6fa$export$1b88fbdd482fd33a = (0, $5NdnQ.default)({
    prop: "gridTemplateAreas"
});
const $e9a1d3e9bc73c6fa$export$bdb486e40d52d26f = (0, $5NdnQ.default)({
    prop: "gridArea"
});
const $e9a1d3e9bc73c6fa$var$grid = (0, $9cxV6.default)($e9a1d3e9bc73c6fa$export$5df9adcb0db95e1e, $e9a1d3e9bc73c6fa$export$ec60d70ff941a580, $e9a1d3e9bc73c6fa$export$8a833ffa5f5dbeda, $e9a1d3e9bc73c6fa$export$baf44164ca3a34e8, $e9a1d3e9bc73c6fa$export$8f7213a1cd01e832, $e9a1d3e9bc73c6fa$export$b0e0abbc49ba668, $e9a1d3e9bc73c6fa$export$bcd8b929d4b4142, $e9a1d3e9bc73c6fa$export$e5039a674e14c828, $e9a1d3e9bc73c6fa$export$42bd9088661ffb03, $e9a1d3e9bc73c6fa$export$920682ae05b999bc, $e9a1d3e9bc73c6fa$export$1b88fbdd482fd33a, $e9a1d3e9bc73c6fa$export$bdb486e40d52d26f);
var $e9a1d3e9bc73c6fa$export$2e2bcd8739ae039 = $e9a1d3e9bc73c6fa$var$grid;

});

parcelRegister("hC06M", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $cd2611ca47914da6$export$dbaffd4420ea0ac6);

var $5NdnQ = parcelRequire("5NdnQ");

var $9cxV6 = parcelRequire("9cxV6");
function $cd2611ca47914da6$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $cd2611ca47914da6$export$35e9368ef982300f = (0, $5NdnQ.default)({
    prop: "color",
    themeKey: "palette",
    transform: $cd2611ca47914da6$export$dbaffd4420ea0ac6
});
const $cd2611ca47914da6$export$2506f56c10355b33 = (0, $5NdnQ.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $cd2611ca47914da6$export$dbaffd4420ea0ac6
});
const $cd2611ca47914da6$export$8c5a050822fd698c = (0, $5NdnQ.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $cd2611ca47914da6$export$dbaffd4420ea0ac6
});
const $cd2611ca47914da6$var$palette = (0, $9cxV6.default)($cd2611ca47914da6$export$35e9368ef982300f, $cd2611ca47914da6$export$2506f56c10355b33, $cd2611ca47914da6$export$8c5a050822fd698c);
var $cd2611ca47914da6$export$2e2bcd8739ae039 = $cd2611ca47914da6$var$palette;

});

parcelRegister("jcIzO", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $dfb1b749c5a44856$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $dfb1b749c5a44856$export$488fda99655ff65a);

var $5NdnQ = parcelRequire("5NdnQ");

var $9cxV6 = parcelRequire("9cxV6");

var $b9Q9P = parcelRequire("b9Q9P");
function $dfb1b749c5a44856$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $dfb1b749c5a44856$export$7e3df82ee760448c = (0, $5NdnQ.default)({
    prop: "width",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $b9Q9P.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $dfb1b749c5a44856$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $b9Q9P.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$dfb1b749c5a44856$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $dfb1b749c5a44856$export$ee148fbbe8357dd2 = (0, $5NdnQ.default)({
    prop: "minWidth",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$ac607276a8fe9f0a = (0, $5NdnQ.default)({
    prop: "height",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$dc0d8bd0b94f8570 = (0, $5NdnQ.default)({
    prop: "maxHeight",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$a43cf604e12f3b17 = (0, $5NdnQ.default)({
    prop: "minHeight",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$ffed9f14fb65e276 = (0, $5NdnQ.default)({
    prop: "size",
    cssProperty: "width",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$905076ed6620e671 = (0, $5NdnQ.default)({
    prop: "size",
    cssProperty: "height",
    transform: $dfb1b749c5a44856$export$8afece71750ec241
});
const $dfb1b749c5a44856$export$6ccc93f785106a58 = (0, $5NdnQ.default)({
    prop: "boxSizing"
});
const $dfb1b749c5a44856$var$sizing = (0, $9cxV6.default)($dfb1b749c5a44856$export$7e3df82ee760448c, $dfb1b749c5a44856$export$488fda99655ff65a, $dfb1b749c5a44856$export$ee148fbbe8357dd2, $dfb1b749c5a44856$export$ac607276a8fe9f0a, $dfb1b749c5a44856$export$dc0d8bd0b94f8570, $dfb1b749c5a44856$export$a43cf604e12f3b17, $dfb1b749c5a44856$export$6ccc93f785106a58);
var $dfb1b749c5a44856$export$2e2bcd8739ae039 = $dfb1b749c5a44856$var$sizing;

});



parcelRegister("36jUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $242161648d851c0b$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $242161648d851c0b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("eVrzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $addbc7613f24b009$export$2e2bcd8739ae039);

var $dup7A = parcelRequire("dup7A");
parcelRequire("8eVik");
var $42TgP = parcelRequire("42TgP");
"use client";
function $addbc7613f24b009$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $addbc7613f24b009$var$useTheme(defaultTheme = null) {
    const contextTheme = $dup7A.useContext((0, $42TgP.T));
    return !contextTheme || $addbc7613f24b009$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $addbc7613f24b009$export$2e2bcd8739ae039 = $addbc7613f24b009$var$useTheme;

});
parcelRegister("8eVik", function(module, exports) {

$parcel$export(module.exports, "Global", () => $5ffc130becf0fa41$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $5ffc130becf0fa41$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $5ffc130becf0fa41$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("42TgP")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("42TgP")).w);

var $42TgP = parcelRequire("42TgP");

var $dup7A = parcelRequire("dup7A");

var $iTnfQ = parcelRequire("iTnfQ");

var $5OTva = parcelRequire("5OTva");

var $aTw1e = parcelRequire("aTw1e");
parcelRequire("kE7g8");
parcelRequire("d8FWH");
parcelRequire("1dMND");

parcelRequire("5gHVI");
var $5ffc130becf0fa41$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $5ffc130becf0fa41$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $42TgP.h).call(props, "css")) // $FlowFixMe
    return $dup7A.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $42TgP.E);
    createElementArgArray[1] = (0, $42TgP.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $dup7A.createElement.apply(null, createElementArgArray);
};
var $5ffc130becf0fa41$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $5ffc130becf0fa41$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $42TgP.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $aTw1e.serializeStyles)([
        styles
    ], undefined, $dup7A.useContext((0, $42TgP.T)));
    if (!(0, $42TgP.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $dup7A.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $dup7A.useRef();
    (0, $5OTva.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5OTva.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $iTnfQ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $5ffc130becf0fa41$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $aTw1e.serializeStyles)(args);
}
var $5ffc130becf0fa41$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $5ffc130becf0fa41$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $5ffc130becf0fa41$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $5ffc130becf0fa41$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $iTnfQ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $5ffc130becf0fa41$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $5OTva.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $iTnfQ.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $5ffc130becf0fa41$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $42TgP.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $aTw1e.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $iTnfQ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $5ffc130becf0fa41$var$merge(cache.registered, css, $5ffc130becf0fa41$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $dup7A.useContext((0, $42TgP.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement($5ffc130becf0fa41$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $5ffc130becf0fa41$var$isBrowser, $5ffc130becf0fa41$var$isTestEnv, $5ffc130becf0fa41$var$globalContext, $5ffc130becf0fa41$var$globalKey;

});
parcelRegister("42TgP", function(module, exports) {

$parcel$export(module.exports, "i", () => $2f2238e2e1d3174d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $2f2238e2e1d3174d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $2f2238e2e1d3174d$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $2f2238e2e1d3174d$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $2f2238e2e1d3174d$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $2f2238e2e1d3174d$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $2f2238e2e1d3174d$export$a9c23c6ac3fc3eca);

var $dup7A = parcelRequire("dup7A");

var $kE7g8 = parcelRequire("kE7g8");

var $3G4eg = parcelRequire("3G4eg");

var $1dMND = parcelRequire("1dMND");

var $koCl3 = parcelRequire("koCl3");

var $iTnfQ = parcelRequire("iTnfQ");

var $aTw1e = parcelRequire("aTw1e");

var $5OTva = parcelRequire("5OTva");
var $2f2238e2e1d3174d$export$23f2a1d2818174ef = true;
var $2f2238e2e1d3174d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $2f2238e2e1d3174d$var$EmotionCacheContext = /* #__PURE__ */ $dup7A.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $kE7g8.default)({
    key: "css"
}) : null);
var $2f2238e2e1d3174d$export$e7094788287c5e9b = $2f2238e2e1d3174d$var$EmotionCacheContext.Provider;
var $2f2238e2e1d3174d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $dup7A.useContext)($2f2238e2e1d3174d$var$EmotionCacheContext);
};
var $2f2238e2e1d3174d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $dup7A.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $dup7A.useContext)($2f2238e2e1d3174d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$2f2238e2e1d3174d$export$23f2a1d2818174ef) $2f2238e2e1d3174d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $dup7A.useContext)($2f2238e2e1d3174d$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $kE7g8.default)({
                key: "css"
            });
            return /*#__PURE__*/ $dup7A.createElement($2f2238e2e1d3174d$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $2f2238e2e1d3174d$export$971d5caa766a69d7 = /* #__PURE__ */ $dup7A.createContext({});
var $2f2238e2e1d3174d$export$3b14a55fb2447963 = function useTheme() {
    return $dup7A.useContext($2f2238e2e1d3174d$export$971d5caa766a69d7);
};
var $2f2238e2e1d3174d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $3G4eg.default)({}, outerTheme, theme);
};
var $2f2238e2e1d3174d$var$createCacheWithTheme = /* #__PURE__ */ (0, $1dMND.default)(function(outerTheme) {
    return (0, $1dMND.default)(function(theme) {
        return $2f2238e2e1d3174d$var$getTheme(outerTheme, theme);
    });
});
var $2f2238e2e1d3174d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $dup7A.useContext($2f2238e2e1d3174d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $2f2238e2e1d3174d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $dup7A.createElement($2f2238e2e1d3174d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $2f2238e2e1d3174d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $dup7A.useContext($2f2238e2e1d3174d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $dup7A.createElement(Component, (0, $3G4eg.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $dup7A.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $koCl3.default)(WithTheme, Component);
}
var $2f2238e2e1d3174d$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $2f2238e2e1d3174d$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $2f2238e2e1d3174d$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $2f2238e2e1d3174d$var$getLastPart(match[1]);
    return undefined;
};
var $2f2238e2e1d3174d$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $2f2238e2e1d3174d$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $2f2238e2e1d3174d$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $2f2238e2e1d3174d$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($2f2238e2e1d3174d$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $2f2238e2e1d3174d$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $2f2238e2e1d3174d$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $2f2238e2e1d3174d$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $2f2238e2e1d3174d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($2f2238e2e1d3174d$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$2f2238e2e1d3174d$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $2f2238e2e1d3174d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iTnfQ.registerStyles)(cache, serialized, isStringTag);
    (0, $5OTva.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iTnfQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2f2238e2e1d3174d$var$Emotion = /* #__PURE__ */ $2f2238e2e1d3174d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$2f2238e2e1d3174d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $iTnfQ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aTw1e.serializeStyles)(registeredStyles, undefined, $dup7A.useContext($2f2238e2e1d3174d$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($2f2238e2e1d3174d$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $2f2238e2e1d3174d$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement($2f2238e2e1d3174d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $dup7A.createElement(WrappedComponent, newProps));
});
var $2f2238e2e1d3174d$export$a9c23c6ac3fc3eca = $2f2238e2e1d3174d$var$Emotion;

});
parcelRegister("kE7g8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f07d2ca00febf4cb$export$2e2bcd8739ae039);

var $1fGPV = parcelRequire("1fGPV");

var $151in = parcelRequire("151in");
parcelRequire("1dMND");
parcelRequire("acqtA");
var $f07d2ca00febf4cb$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $151in.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $151in.token)(character)) break;
        (0, $151in.next)();
    }
    return (0, $151in.slice)(begin, (0, $151in.position));
};
var $f07d2ca00febf4cb$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $151in.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $151in.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f07d2ca00febf4cb$var$identifierWithPointTracking((0, $151in.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $151in.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $151in.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $151in.from)(character);
    }
    while (character = (0, $151in.next)());
    return parsed;
};
var $f07d2ca00febf4cb$var$getRules = function getRules(value, points) {
    return (0, $151in.dealloc)($f07d2ca00febf4cb$var$toRules((0, $151in.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f07d2ca00febf4cb$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f07d2ca00febf4cb$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f07d2ca00febf4cb$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f07d2ca00febf4cb$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f07d2ca00febf4cb$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f07d2ca00febf4cb$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $f07d2ca00febf4cb$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $f07d2ca00febf4cb$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($f07d2ca00febf4cb$var$ignoreFlag) > -1;
};
var $f07d2ca00febf4cb$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($f07d2ca00febf4cb$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $f07d2ca00febf4cb$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $f07d2ca00febf4cb$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$f07d2ca00febf4cb$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $f07d2ca00febf4cb$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $f07d2ca00febf4cb$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$f07d2ca00febf4cb$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $f07d2ca00febf4cb$var$nullifyElement(element);
    } else if ($f07d2ca00febf4cb$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $f07d2ca00febf4cb$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $f07d2ca00febf4cb$var$prefix(value, length) {
    switch((0, $151in.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $151in.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $151in.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $151in.WEBKIT) + value + (0, $151in.MOZ) + value + (0, $151in.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + value + value;
        // order
        case 6165:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $151in.WEBKIT) + value + (0, $151in.replace)(value, /(\w+).+(:[^]+)/, (0, $151in.WEBKIT) + "box-$1$2" + (0, $151in.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + "flex-item-" + (0, $151in.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + "flex-line-pack" + (0, $151in.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $151in.WEBKIT) + "box-" + (0, $151in.replace)(value, "-grow", "") + (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $151in.WEBKIT) + (0, $151in.replace)(value, /([^-])(transform)/g, "$1" + (0, $151in.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $151in.replace)((0, $151in.replace)((0, $151in.replace)(value, /(zoom-|grab)/, (0, $151in.WEBKIT) + "$1"), /(image-set)/, (0, $151in.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $151in.replace)(value, /(image-set\([^]*)/, (0, $151in.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $151in.replace)((0, $151in.replace)(value, /(.+:)(flex-)?(.*)/, (0, $151in.WEBKIT) + "box-pack:$3" + (0, $151in.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $151in.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $151in.replace)(value, /(.+)-inline(.+)/, (0, $151in.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $151in.strlen)(value) - 1 - length > 6) switch((0, $151in.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $151in.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $151in.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $151in.WEBKIT) + "$2-$3" + "$1" + (0, $151in.MOZ) + ((0, $151in.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $151in.indexof)(value, "stretch") ? $f07d2ca00febf4cb$var$prefix((0, $151in.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $151in.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $151in.charat)(value, (0, $151in.strlen)(value) - 3 - (~(0, $151in.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $151in.replace)(value, ":", ":" + (0, $151in.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $151in.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $151in.WEBKIT) + ((0, $151in.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $151in.WEBKIT) + "$2$3" + "$1" + (0, $151in.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $151in.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $151in.WEBKIT) + value + (0, $151in.MS) + (0, $151in.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $151in.WEBKIT) + value + (0, $151in.MS) + value + value;
    }
    return value;
}
var $f07d2ca00febf4cb$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $151in.DECLARATION:
                element["return"] = $f07d2ca00febf4cb$var$prefix(element.value, element.length);
                break;
            case 0, $151in.KEYFRAMES:
                return (0, $151in.serialize)([
                    (0, $151in.copy)(element, {
                        value: (0, $151in.replace)(element.value, "@", "@" + (0, $151in.WEBKIT))
                    })
                ], callback);
            case 0, $151in.RULESET:
                if (element.length) return (0, $151in.combine)(element.props, function(value) {
                    switch((0, $151in.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $151in.serialize)([
                                (0, $151in.copy)(element, {
                                    props: [
                                        (0, $151in.replace)(value, /:(read-\w+)/, ":" + (0, $151in.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $151in.serialize)([
                                (0, $151in.copy)(element, {
                                    props: [
                                        (0, $151in.replace)(value, /:(plac\w+)/, ":" + (0, $151in.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $151in.copy)(element, {
                                    props: [
                                        (0, $151in.replace)(value, /:(plac\w+)/, ":" + (0, $151in.MOZ) + "$1")
                                    ]
                                }),
                                (0, $151in.copy)(element, {
                                    props: [
                                        (0, $151in.replace)(value, /:(plac\w+)/, (0, $151in.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $f07d2ca00febf4cb$var$defaultStylisPlugins = [
    $f07d2ca00febf4cb$var$prefixer
];
var $f07d2ca00febf4cb$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $f07d2ca00febf4cb$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $f07d2ca00febf4cb$var$compat,
        $f07d2ca00febf4cb$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $151in.stringify),
        (0, $151in.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $151in.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $151in.serialize)((0, $151in.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $1fGPV.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("1fGPV", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $0e986b92e2ec1c67$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0e986b92e2ec1c67$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0e986b92e2ec1c67$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $0e986b92e2ec1c67$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($0e986b92e2ec1c67$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $0e986b92e2ec1c67$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("151in", function(module, exports) {

$parcel$export(module.exports, "MS", () => $40e9c10e9a6b2e50$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $40e9c10e9a6b2e50$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $40e9c10e9a6b2e50$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $40e9c10e9a6b2e50$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $40e9c10e9a6b2e50$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $40e9c10e9a6b2e50$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $40e9c10e9a6b2e50$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $40e9c10e9a6b2e50$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $40e9c10e9a6b2e50$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $40e9c10e9a6b2e50$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $40e9c10e9a6b2e50$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $40e9c10e9a6b2e50$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $40e9c10e9a6b2e50$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $40e9c10e9a6b2e50$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $40e9c10e9a6b2e50$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $40e9c10e9a6b2e50$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $40e9c10e9a6b2e50$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $40e9c10e9a6b2e50$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $40e9c10e9a6b2e50$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $40e9c10e9a6b2e50$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $40e9c10e9a6b2e50$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $40e9c10e9a6b2e50$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $40e9c10e9a6b2e50$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $40e9c10e9a6b2e50$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $40e9c10e9a6b2e50$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $40e9c10e9a6b2e50$export$38bcb760f1d4871c);
var $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 = "-ms-";
var $40e9c10e9a6b2e50$export$2c0f367103c8d01c = "-moz-";
var $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 = "-webkit-";
var $40e9c10e9a6b2e50$export$a29989082612d0d9 = "comm";
var $40e9c10e9a6b2e50$export$aa3a2e812ca8570d = "rule";
var $40e9c10e9a6b2e50$export$527d108ccf083c2b = "decl";
var $40e9c10e9a6b2e50$export$d3d35020fa5b54f0 = "@page";
var $40e9c10e9a6b2e50$export$500415a86c544f73 = "@media";
var $40e9c10e9a6b2e50$export$a763edbf796b780a = "@import";
var $40e9c10e9a6b2e50$export$2790aeb8b4e5c826 = "@charset";
var $40e9c10e9a6b2e50$export$1cc683e23b84b133 = "@viewport";
var $40e9c10e9a6b2e50$export$9447a5efea57e862 = "@supports";
var $40e9c10e9a6b2e50$export$ef011b4e114b1fba = "@document";
var $40e9c10e9a6b2e50$export$6aad947bda0f3f46 = "@namespace";
var $40e9c10e9a6b2e50$export$b44a8529a35fcb60 = "@keyframes";
var $40e9c10e9a6b2e50$export$2c16de31893252e6 = "@font-face";
var $40e9c10e9a6b2e50$export$3d846dd52e150c6f = "@counter-style";
var $40e9c10e9a6b2e50$export$22314bfbb57653fe = "@font-feature-values";
var $40e9c10e9a6b2e50$export$d773506282b3cfe6 = "@layer";
var $40e9c10e9a6b2e50$export$2335f513bbd82c6d = Math.abs;
var $40e9c10e9a6b2e50$export$6788812c4e6611e6 = String.fromCharCode;
var $40e9c10e9a6b2e50$export$e6e34fd1f2686227 = Object.assign;
function $40e9c10e9a6b2e50$export$d6af199866bfb566(e, r) {
    return $40e9c10e9a6b2e50$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $40e9c10e9a6b2e50$export$a9db5e087081082d(e, 0)) << 2 ^ $40e9c10e9a6b2e50$export$a9db5e087081082d(e, 1)) << 2 ^ $40e9c10e9a6b2e50$export$a9db5e087081082d(e, 2)) << 2 ^ $40e9c10e9a6b2e50$export$a9db5e087081082d(e, 3) : 0;
}
function $40e9c10e9a6b2e50$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $40e9c10e9a6b2e50$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $40e9c10e9a6b2e50$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $40e9c10e9a6b2e50$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $40e9c10e9a6b2e50$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $40e9c10e9a6b2e50$export$36776f635604f274(e) {
    return e.length;
}
function $40e9c10e9a6b2e50$export$f9084667e487ed46(e) {
    return e.length;
}
function $40e9c10e9a6b2e50$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $40e9c10e9a6b2e50$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $40e9c10e9a6b2e50$export$53f1d5ea8de3d7c = 1;
var $40e9c10e9a6b2e50$export$4e0c71f277ca26b3 = 1;
var $40e9c10e9a6b2e50$export$f24224f1c91d8156 = 0;
var $40e9c10e9a6b2e50$export$5880b8b5730aff45 = 0;
var $40e9c10e9a6b2e50$export$c0306caf338ac095 = 0;
var $40e9c10e9a6b2e50$export$30a86d91af8ff6e6 = "";
function $40e9c10e9a6b2e50$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $40e9c10e9a6b2e50$export$53f1d5ea8de3d7c,
        column: $40e9c10e9a6b2e50$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $40e9c10e9a6b2e50$export$784d13d8ee351f07(e, r) {
    return $40e9c10e9a6b2e50$export$e6e34fd1f2686227($40e9c10e9a6b2e50$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $40e9c10e9a6b2e50$export$eba6f6f03b0a92e7() {
    return $40e9c10e9a6b2e50$export$c0306caf338ac095;
}
function $40e9c10e9a6b2e50$export$232faf9add678146() {
    $40e9c10e9a6b2e50$export$c0306caf338ac095 = $40e9c10e9a6b2e50$export$5880b8b5730aff45 > 0 ? $40e9c10e9a6b2e50$export$a9db5e087081082d($40e9c10e9a6b2e50$export$30a86d91af8ff6e6, --$40e9c10e9a6b2e50$export$5880b8b5730aff45) : 0;
    if ($40e9c10e9a6b2e50$export$4e0c71f277ca26b3--, $40e9c10e9a6b2e50$export$c0306caf338ac095 === 10) $40e9c10e9a6b2e50$export$4e0c71f277ca26b3 = 1, $40e9c10e9a6b2e50$export$53f1d5ea8de3d7c--;
    return $40e9c10e9a6b2e50$export$c0306caf338ac095;
}
function $40e9c10e9a6b2e50$export$48cfd1e771a65c4f() {
    $40e9c10e9a6b2e50$export$c0306caf338ac095 = $40e9c10e9a6b2e50$export$5880b8b5730aff45 < $40e9c10e9a6b2e50$export$f24224f1c91d8156 ? $40e9c10e9a6b2e50$export$a9db5e087081082d($40e9c10e9a6b2e50$export$30a86d91af8ff6e6, $40e9c10e9a6b2e50$export$5880b8b5730aff45++) : 0;
    if ($40e9c10e9a6b2e50$export$4e0c71f277ca26b3++, $40e9c10e9a6b2e50$export$c0306caf338ac095 === 10) $40e9c10e9a6b2e50$export$4e0c71f277ca26b3 = 1, $40e9c10e9a6b2e50$export$53f1d5ea8de3d7c++;
    return $40e9c10e9a6b2e50$export$c0306caf338ac095;
}
function $40e9c10e9a6b2e50$export$4d3fb11e950abb9e() {
    return $40e9c10e9a6b2e50$export$a9db5e087081082d($40e9c10e9a6b2e50$export$30a86d91af8ff6e6, $40e9c10e9a6b2e50$export$5880b8b5730aff45);
}
function $40e9c10e9a6b2e50$export$e88cb2efb12ae807() {
    return $40e9c10e9a6b2e50$export$5880b8b5730aff45;
}
function $40e9c10e9a6b2e50$export$58adb3bec8346d0f(e, r) {
    return $40e9c10e9a6b2e50$export$2f35ab04d2335697($40e9c10e9a6b2e50$export$30a86d91af8ff6e6, e, r);
}
function $40e9c10e9a6b2e50$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $40e9c10e9a6b2e50$export$2de70f21292aac9e(e) {
    return $40e9c10e9a6b2e50$export$53f1d5ea8de3d7c = $40e9c10e9a6b2e50$export$4e0c71f277ca26b3 = 1, $40e9c10e9a6b2e50$export$f24224f1c91d8156 = $40e9c10e9a6b2e50$export$36776f635604f274($40e9c10e9a6b2e50$export$30a86d91af8ff6e6 = e), $40e9c10e9a6b2e50$export$5880b8b5730aff45 = 0, [];
}
function $40e9c10e9a6b2e50$export$45918ac1574455b1(e) {
    return $40e9c10e9a6b2e50$export$30a86d91af8ff6e6 = "", e;
}
function $40e9c10e9a6b2e50$export$410ac95b9ec204b8(e) {
    return $40e9c10e9a6b2e50$export$87c2784dc9fc4ab($40e9c10e9a6b2e50$export$58adb3bec8346d0f($40e9c10e9a6b2e50$export$5880b8b5730aff45 - 1, $40e9c10e9a6b2e50$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $40e9c10e9a6b2e50$export$660b2ee2d4fb4eff(e) {
    return $40e9c10e9a6b2e50$export$45918ac1574455b1($40e9c10e9a6b2e50$export$5f8c09e3ae6f64e1($40e9c10e9a6b2e50$export$2de70f21292aac9e(e)));
}
function $40e9c10e9a6b2e50$export$7af1228ff777d175(e) {
    while($40e9c10e9a6b2e50$export$c0306caf338ac095 = $40e9c10e9a6b2e50$export$4d3fb11e950abb9e())if ($40e9c10e9a6b2e50$export$c0306caf338ac095 < 33) $40e9c10e9a6b2e50$export$48cfd1e771a65c4f();
    else break;
    return $40e9c10e9a6b2e50$export$9e1725a4cfeada27(e) > 2 || $40e9c10e9a6b2e50$export$9e1725a4cfeada27($40e9c10e9a6b2e50$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $40e9c10e9a6b2e50$export$5f8c09e3ae6f64e1(e) {
    while($40e9c10e9a6b2e50$export$48cfd1e771a65c4f())switch($40e9c10e9a6b2e50$export$9e1725a4cfeada27($40e9c10e9a6b2e50$export$c0306caf338ac095)){
        case 0:
            $40e9c10e9a6b2e50$export$10d8903dec122b9d($40e9c10e9a6b2e50$export$c2ab62c7bf24634($40e9c10e9a6b2e50$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $40e9c10e9a6b2e50$export$10d8903dec122b9d($40e9c10e9a6b2e50$export$410ac95b9ec204b8($40e9c10e9a6b2e50$export$c0306caf338ac095), e);
            break;
        default:
            $40e9c10e9a6b2e50$export$10d8903dec122b9d($40e9c10e9a6b2e50$export$6788812c4e6611e6($40e9c10e9a6b2e50$export$c0306caf338ac095), e);
    }
    return e;
}
function $40e9c10e9a6b2e50$export$955ba06d119e085e(e, r) {
    while(--r && $40e9c10e9a6b2e50$export$48cfd1e771a65c4f())if ($40e9c10e9a6b2e50$export$c0306caf338ac095 < 48 || $40e9c10e9a6b2e50$export$c0306caf338ac095 > 102 || $40e9c10e9a6b2e50$export$c0306caf338ac095 > 57 && $40e9c10e9a6b2e50$export$c0306caf338ac095 < 65 || $40e9c10e9a6b2e50$export$c0306caf338ac095 > 70 && $40e9c10e9a6b2e50$export$c0306caf338ac095 < 97) break;
    return $40e9c10e9a6b2e50$export$58adb3bec8346d0f(e, $40e9c10e9a6b2e50$export$e88cb2efb12ae807() + (r < 6 && $40e9c10e9a6b2e50$export$4d3fb11e950abb9e() == 32 && $40e9c10e9a6b2e50$export$48cfd1e771a65c4f() == 32));
}
function $40e9c10e9a6b2e50$export$c889f2fcc19dbf12(e) {
    while($40e9c10e9a6b2e50$export$48cfd1e771a65c4f())switch($40e9c10e9a6b2e50$export$c0306caf338ac095){
        case e:
            return $40e9c10e9a6b2e50$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $40e9c10e9a6b2e50$export$c889f2fcc19dbf12($40e9c10e9a6b2e50$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $40e9c10e9a6b2e50$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $40e9c10e9a6b2e50$export$48cfd1e771a65c4f();
            break;
    }
    return $40e9c10e9a6b2e50$export$5880b8b5730aff45;
}
function $40e9c10e9a6b2e50$export$4254d4e2b3745c4c(e, r) {
    while($40e9c10e9a6b2e50$export$48cfd1e771a65c4f())if (e + $40e9c10e9a6b2e50$export$c0306caf338ac095 === 57) break;
    else if (e + $40e9c10e9a6b2e50$export$c0306caf338ac095 === 84 && $40e9c10e9a6b2e50$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $40e9c10e9a6b2e50$export$58adb3bec8346d0f(r, $40e9c10e9a6b2e50$export$5880b8b5730aff45 - 1) + "*" + $40e9c10e9a6b2e50$export$6788812c4e6611e6(e === 47 ? e : $40e9c10e9a6b2e50$export$48cfd1e771a65c4f());
}
function $40e9c10e9a6b2e50$export$c2ab62c7bf24634(e) {
    while(!$40e9c10e9a6b2e50$export$9e1725a4cfeada27($40e9c10e9a6b2e50$export$4d3fb11e950abb9e()))$40e9c10e9a6b2e50$export$48cfd1e771a65c4f();
    return $40e9c10e9a6b2e50$export$58adb3bec8346d0f(e, $40e9c10e9a6b2e50$export$5880b8b5730aff45);
}
function $40e9c10e9a6b2e50$export$ef7acd7185315e22(e) {
    return $40e9c10e9a6b2e50$export$45918ac1574455b1($40e9c10e9a6b2e50$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $40e9c10e9a6b2e50$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $40e9c10e9a6b2e50$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $40e9c10e9a6b2e50$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $40e9c10e9a6b2e50$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($40e9c10e9a6b2e50$export$f8e21b1e77979a08(j += $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed($40e9c10e9a6b2e50$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $40e9c10e9a6b2e50$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $40e9c10e9a6b2e50$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $40e9c10e9a6b2e50$export$955ba06d119e085e($40e9c10e9a6b2e50$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($40e9c10e9a6b2e50$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $40e9c10e9a6b2e50$export$10d8903dec122b9d($40e9c10e9a6b2e50$export$4a34f930e789283c($40e9c10e9a6b2e50$export$4254d4e2b3745c4c($40e9c10e9a6b2e50$export$48cfd1e771a65c4f(), $40e9c10e9a6b2e50$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $40e9c10e9a6b2e50$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $40e9c10e9a6b2e50$export$36776f635604f274(j) - l) $40e9c10e9a6b2e50$export$10d8903dec122b9d(p > 32 ? $40e9c10e9a6b2e50$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $40e9c10e9a6b2e50$export$f8483753829ec8f3($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $40e9c10e9a6b2e50$export$10d8903dec122b9d(y = $40e9c10e9a6b2e50$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $40e9c10e9a6b2e50$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $40e9c10e9a6b2e50$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $40e9c10e9a6b2e50$export$98e6a39c04603d36(e, y, y, n && $40e9c10e9a6b2e50$export$10d8903dec122b9d($40e9c10e9a6b2e50$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $40e9c10e9a6b2e50$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $40e9c10e9a6b2e50$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $40e9c10e9a6b2e50$export$232faf9add678146() == 125) continue;
            }
            switch(j += $40e9c10e9a6b2e50$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($40e9c10e9a6b2e50$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($40e9c10e9a6b2e50$export$4d3fb11e950abb9e() === 45) j += $40e9c10e9a6b2e50$export$410ac95b9ec204b8($40e9c10e9a6b2e50$export$48cfd1e771a65c4f());
                    v = $40e9c10e9a6b2e50$export$4d3fb11e950abb9e(), o = l = $40e9c10e9a6b2e50$export$36776f635604f274(g = j += $40e9c10e9a6b2e50$export$c2ab62c7bf24634($40e9c10e9a6b2e50$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $40e9c10e9a6b2e50$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $40e9c10e9a6b2e50$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $40e9c10e9a6b2e50$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $40e9c10e9a6b2e50$export$2f35ab04d2335697(e, v + 1, v = $40e9c10e9a6b2e50$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $40e9c10e9a6b2e50$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $40e9c10e9a6b2e50$export$35059013cd4a06db(e, r, a, s === 0 ? $40e9c10e9a6b2e50$export$aa3a2e812ca8570d : i, f, o, l);
}
function $40e9c10e9a6b2e50$export$4a34f930e789283c(e, r, a) {
    return $40e9c10e9a6b2e50$export$35059013cd4a06db(e, r, a, $40e9c10e9a6b2e50$export$a29989082612d0d9, $40e9c10e9a6b2e50$export$6788812c4e6611e6($40e9c10e9a6b2e50$export$eba6f6f03b0a92e7()), $40e9c10e9a6b2e50$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $40e9c10e9a6b2e50$export$f8483753829ec8f3(e, r, a, n) {
    return $40e9c10e9a6b2e50$export$35059013cd4a06db(e, r, a, $40e9c10e9a6b2e50$export$527d108ccf083c2b, $40e9c10e9a6b2e50$export$2f35ab04d2335697(e, 0, n), $40e9c10e9a6b2e50$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $40e9c10e9a6b2e50$export$82e9f45cca5ba907(n, c, s) {
    switch($40e9c10e9a6b2e50$export$d6af199866bfb566(n, c)){
        case 5103:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $40e9c10e9a6b2e50$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$2c0f367103c8d01c + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($40e9c10e9a6b2e50$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "box-$1$2" + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "flex-item-" + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$40e9c10e9a6b2e50$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "grid-row-" + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "flex-line-pack" + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "box-" + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "-grow", "") + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "box-pack:$3" + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$40e9c10e9a6b2e50$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "grid-column-align" + $40e9c10e9a6b2e50$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $40e9c10e9a6b2e50$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$40e9c10e9a6b2e50$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$40e9c10e9a6b2e50$export$f8e21b1e77979a08(s, "span") ? $40e9c10e9a6b2e50$export$4659b591c19bdf3d(s, /\d+/) : +$40e9c10e9a6b2e50$export$4659b591c19bdf3d(s, /\d+/) - +$40e9c10e9a6b2e50$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $40e9c10e9a6b2e50$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($40e9c10e9a6b2e50$export$36776f635604f274(n) - 1 - c > 6) switch($40e9c10e9a6b2e50$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($40e9c10e9a6b2e50$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $40e9c10e9a6b2e50$export$2c0f367103c8d01c + ($40e9c10e9a6b2e50$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$40e9c10e9a6b2e50$export$f8e21b1e77979a08(n, "stretch") ? $40e9c10e9a6b2e50$export$82e9f45cca5ba907($40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($40e9c10e9a6b2e50$export$a9db5e087081082d(n, c + 6) === 121) return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, ":", ":" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($40e9c10e9a6b2e50$export$a9db5e087081082d(n, $40e9c10e9a6b2e50$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + ($40e9c10e9a6b2e50$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, ":", ":" + $40e9c10e9a6b2e50$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $40e9c10e9a6b2e50$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $40e9c10e9a6b2e50$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $40e9c10e9a6b2e50$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $40e9c10e9a6b2e50$export$a763edbf796b780a:
        case $40e9c10e9a6b2e50$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $40e9c10e9a6b2e50$export$a29989082612d0d9:
            return "";
        case $40e9c10e9a6b2e50$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $40e9c10e9a6b2e50$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $40e9c10e9a6b2e50$export$36776f635604f274(a = $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $40e9c10e9a6b2e50$export$5a7767152ae0305f(e) {
    var r = $40e9c10e9a6b2e50$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $40e9c10e9a6b2e50$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $40e9c10e9a6b2e50$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $40e9c10e9a6b2e50$export$527d108ccf083c2b:
                n.return = $40e9c10e9a6b2e50$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $40e9c10e9a6b2e50$export$b44a8529a35fcb60:
                return $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb([
                    $40e9c10e9a6b2e50$export$784d13d8ee351f07(n, {
                        value: $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $40e9c10e9a6b2e50$export$aa3a2e812ca8570d:
                if (n.length) return $40e9c10e9a6b2e50$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($40e9c10e9a6b2e50$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb([
                                $40e9c10e9a6b2e50$export$784d13d8ee351f07(n, {
                                    props: [
                                        $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $40e9c10e9a6b2e50$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $40e9c10e9a6b2e50$export$dfdc1655ccc5b9cb([
                                $40e9c10e9a6b2e50$export$784d13d8ee351f07(n, {
                                    props: [
                                        $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $40e9c10e9a6b2e50$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $40e9c10e9a6b2e50$export$784d13d8ee351f07(n, {
                                    props: [
                                        $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $40e9c10e9a6b2e50$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $40e9c10e9a6b2e50$export$784d13d8ee351f07(n, {
                                    props: [
                                        $40e9c10e9a6b2e50$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $40e9c10e9a6b2e50$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $40e9c10e9a6b2e50$export$76a88f7de6507443(e) {
    switch(e.type){
        case $40e9c10e9a6b2e50$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $40e9c10e9a6b2e50$export$1be1fc439b849fdf($40e9c10e9a6b2e50$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($40e9c10e9a6b2e50$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $40e9c10e9a6b2e50$export$2f35ab04d2335697(r, 1, $40e9c10e9a6b2e50$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $40e9c10e9a6b2e50$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $40e9c10e9a6b2e50$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $40e9c10e9a6b2e50$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1dMND", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3cdbef861c1d4d$export$2e2bcd8739ae039);
var $0e3cdbef861c1d4d$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("acqtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $76cf8ffebe5a31cc$export$2e2bcd8739ae039);
function $76cf8ffebe5a31cc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("koCl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed93c9c8a2059b2a$export$2e2bcd8739ae039);

var $5gHVI = parcelRequire("5gHVI");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $ed93c9c8a2059b2a$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5gHVI)))(targetComponent, sourceComponent);
};

});
parcelRegister("5gHVI", function(module, exports) {
"use strict";

var $b7zlZ = parcelRequire("b7zlZ");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3d6085f04296be4e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3d6085f04296be4e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3d6085f04296be4e$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3d6085f04296be4e$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3d6085f04296be4e$var$TYPE_STATICS = {};
$3d6085f04296be4e$var$TYPE_STATICS[$b7zlZ.ForwardRef] = $3d6085f04296be4e$var$FORWARD_REF_STATICS;
$3d6085f04296be4e$var$TYPE_STATICS[$b7zlZ.Memo] = $3d6085f04296be4e$var$MEMO_STATICS;
function $3d6085f04296be4e$var$getStatics(component) {
    // React v16.11 and below
    if ($b7zlZ.isMemo(component)) return $3d6085f04296be4e$var$MEMO_STATICS;
     // React v16.12 and above
    return $3d6085f04296be4e$var$TYPE_STATICS[component["$$typeof"]] || $3d6085f04296be4e$var$REACT_STATICS;
}
var $3d6085f04296be4e$var$defineProperty = Object.defineProperty;
var $3d6085f04296be4e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3d6085f04296be4e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3d6085f04296be4e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3d6085f04296be4e$var$getPrototypeOf = Object.getPrototypeOf;
var $3d6085f04296be4e$var$objectPrototype = Object.prototype;
function $3d6085f04296be4e$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3d6085f04296be4e$var$objectPrototype) {
            var inheritedComponent = $3d6085f04296be4e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3d6085f04296be4e$var$objectPrototype) $3d6085f04296be4e$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3d6085f04296be4e$var$getOwnPropertyNames(sourceComponent);
        if ($3d6085f04296be4e$var$getOwnPropertySymbols) keys = keys.concat($3d6085f04296be4e$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3d6085f04296be4e$var$getStatics(targetComponent);
        var sourceStatics = $3d6085f04296be4e$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3d6085f04296be4e$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3d6085f04296be4e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3d6085f04296be4e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3d6085f04296be4e$var$hoistNonReactStatics;

});
parcelRegister("b7zlZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("19kfS"));

});



parcelRegister("iTnfQ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $dc0f66ee90982531$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $dc0f66ee90982531$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $dc0f66ee90982531$export$6f077d94b33a01aa);
var $dc0f66ee90982531$var$isBrowser = true;
function $dc0f66ee90982531$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $dc0f66ee90982531$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $dc0f66ee90982531$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $dc0f66ee90982531$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $dc0f66ee90982531$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("aTw1e", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $7ee7e0ba44544e65$export$6321afa313b251b5);

var $dKNdX = parcelRequire("dKNdX");

var $iJLBA = parcelRequire("iJLBA");

var $acqtA = parcelRequire("acqtA");
var $7ee7e0ba44544e65$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $7ee7e0ba44544e65$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $7ee7e0ba44544e65$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7ee7e0ba44544e65$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7ee7e0ba44544e65$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7ee7e0ba44544e65$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $7ee7e0ba44544e65$var$processStyleName = /* #__PURE__ */ (0, $acqtA.default)(function(styleName) {
    return $7ee7e0ba44544e65$var$isCustomProperty(styleName) ? styleName : styleName.replace($7ee7e0ba44544e65$var$hyphenateRegex, "-$&").toLowerCase();
});
var $7ee7e0ba44544e65$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($7ee7e0ba44544e65$var$animationRegex, function(match, p1, p2) {
                $7ee7e0ba44544e65$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7ee7e0ba44544e65$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iJLBA.default)[key] !== 1 && !$7ee7e0ba44544e65$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $7ee7e0ba44544e65$var$contentValuePattern, $7ee7e0ba44544e65$var$contentValues, $7ee7e0ba44544e65$var$oldProcessStyleValue, $7ee7e0ba44544e65$var$msPattern, $7ee7e0ba44544e65$var$hyphenPattern, $7ee7e0ba44544e65$var$hyphenatedCache;
var $7ee7e0ba44544e65$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $7ee7e0ba44544e65$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $7ee7e0ba44544e65$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7ee7e0ba44544e65$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7ee7e0ba44544e65$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $7ee7e0ba44544e65$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $7ee7e0ba44544e65$var$cursor;
                var result = interpolation(mergedProps);
                $7ee7e0ba44544e65$var$cursor = previousCursor;
                return $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $7ee7e0ba44544e65$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($7ee7e0ba44544e65$var$isProcessableValue(value)) string += $7ee7e0ba44544e65$var$processStyleName(_key) + ":" + $7ee7e0ba44544e65$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($7ee7e0ba44544e65$var$isProcessableValue(value[_i])) string += $7ee7e0ba44544e65$var$processStyleName(_key) + ":" + $7ee7e0ba44544e65$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $7ee7e0ba44544e65$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $7ee7e0ba44544e65$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $7ee7e0ba44544e65$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $7ee7e0ba44544e65$var$cursor;
var $7ee7e0ba44544e65$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $7ee7e0ba44544e65$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7ee7e0ba44544e65$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $7ee7e0ba44544e65$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7ee7e0ba44544e65$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $dKNdX.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7ee7e0ba44544e65$var$cursor
    };
};

});
parcelRegister("dKNdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a035c11c0c225db8$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $a035c11c0c225db8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("iJLBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $da415b5ee349f5fd$export$2e2bcd8739ae039);
var $da415b5ee349f5fd$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5OTva", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $43ccacbf0a229c67$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $43ccacbf0a229c67$export$811a713a7276cb9d);

var $dup7A = parcelRequire("dup7A");
var $43ccacbf0a229c67$var$syncFallback = function syncFallback(create) {
    return create();
};
var $43ccacbf0a229c67$var$useInsertionEffect = $dup7A.useInsertionEffect ? $dup7A.useInsertionEffect : false;
var $43ccacbf0a229c67$export$db21c7ffa21794e7 = $43ccacbf0a229c67$var$useInsertionEffect || $43ccacbf0a229c67$var$syncFallback;
var $43ccacbf0a229c67$export$811a713a7276cb9d = $43ccacbf0a229c67$var$useInsertionEffect || $dup7A.useLayoutEffect;

});


parcelRegister("d8FWH", function(module, exports) {
function $990c8f47e5dc2d74$var$_extends() {
    module.exports = $990c8f47e5dc2d74$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $990c8f47e5dc2d74$var$_extends.apply(this, arguments);
}
module.exports = $990c8f47e5dc2d74$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("hddxs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c87e270e6f6efa69$export$2e2bcd8739ae039);

var $9qP3P = parcelRequire("9qP3P");
"use client";
const $c87e270e6f6efa69$var$defaultTheme = (0, $9qP3P.default)();
var $c87e270e6f6efa69$export$2e2bcd8739ae039 = $c87e270e6f6efa69$var$defaultTheme;

});
parcelRegister("9qP3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dde2658c7f35aae$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $e50cx = parcelRequire("e50cx");

var $gmeoE = parcelRequire("gmeoE");

var $7eWjf = parcelRequire("7eWjf");
var $bDGwn = parcelRequire("bDGwn");

var $1kGZC = parcelRequire("1kGZC");


var $7B9m8 = parcelRequire("7B9m8");

var $d2tay = parcelRequire("d2tay");

var $5BGkM = parcelRequire("5BGkM");

var $8hdMC = parcelRequire("8hdMC");

var $lQ3HS = parcelRequire("lQ3HS");

var $b70e6 = parcelRequire("b70e6");
const $6dde2658c7f35aae$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $6dde2658c7f35aae$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $bGxpK.default)(options, $6dde2658c7f35aae$var$_excluded);
    if (options.vars) throw new Error((0, $e50cx.default)(18));
    const palette = (0, $d2tay.default)(paletteInput);
    const systemTheme = (0, $1kGZC.default)(options);
    let muiTheme = (0, $gmeoE.default)(systemTheme, {
        mixins: (0, $7B9m8.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $8hdMC.default).slice(),
        typography: (0, $5BGkM.default)(palette, typographyInput),
        transitions: (0, $lQ3HS.default)(transitionsInput),
        zIndex: (0, $3G4eg.default)({}, (0, $b70e6.default))
    });
    muiTheme = (0, $gmeoE.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $gmeoE.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $3G4eg.default)({}, (0, $bDGwn.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $7eWjf.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $6dde2658c7f35aae$var$warnedOnce = false;
function $6dde2658c7f35aae$export$c469355549431d9b(...args) {
    return $6dde2658c7f35aae$var$createTheme(...args);
}
var $6dde2658c7f35aae$export$2e2bcd8739ae039 = $6dde2658c7f35aae$var$createTheme;

});
parcelRegister("7B9m8", function(module, exports) {

$parcel$export(module.exports, "default", () => $58833f03d6f7a3e5$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");
function $58833f03d6f7a3e5$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $3G4eg.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("d2tay", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e216a958ba7785$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $e50cx = parcelRequire("e50cx");

var $gmeoE = parcelRequire("gmeoE");

var $emmvO = parcelRequire("emmvO");

var $ggEZq = parcelRequire("ggEZq");

var $agcLQ = parcelRequire("agcLQ");

var $ewDfS = parcelRequire("ewDfS");

var $dFMOT = parcelRequire("dFMOT");

var $5a0nF = parcelRequire("5a0nF");

var $hNihN = parcelRequire("hNihN");

var $ghSxK = parcelRequire("ghSxK");

var $9xrtn = parcelRequire("9xrtn");
const $97e216a958ba7785$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $97e216a958ba7785$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $ggEZq.default).white,
        default: (0, $ggEZq.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $97e216a958ba7785$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $ggEZq.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $ggEZq.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $97e216a958ba7785$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $emmvO.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $emmvO.darken)(intent.main, tonalOffsetDark);
    }
}
function $97e216a958ba7785$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hNihN.default)[200],
        light: (0, $hNihN.default)[50],
        dark: (0, $hNihN.default)[400]
    };
    return {
        main: (0, $hNihN.default)[700],
        light: (0, $hNihN.default)[400],
        dark: (0, $hNihN.default)[800]
    };
}
function $97e216a958ba7785$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ewDfS.default)[200],
        light: (0, $ewDfS.default)[50],
        dark: (0, $ewDfS.default)[400]
    };
    return {
        main: (0, $ewDfS.default)[500],
        light: (0, $ewDfS.default)[300],
        dark: (0, $ewDfS.default)[700]
    };
}
function $97e216a958ba7785$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dFMOT.default)[500],
        light: (0, $dFMOT.default)[300],
        dark: (0, $dFMOT.default)[700]
    };
    return {
        main: (0, $dFMOT.default)[700],
        light: (0, $dFMOT.default)[400],
        dark: (0, $dFMOT.default)[800]
    };
}
function $97e216a958ba7785$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ghSxK.default)[400],
        light: (0, $ghSxK.default)[300],
        dark: (0, $ghSxK.default)[700]
    };
    return {
        main: (0, $ghSxK.default)[700],
        light: (0, $ghSxK.default)[500],
        dark: (0, $ghSxK.default)[900]
    };
}
function $97e216a958ba7785$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9xrtn.default)[400],
        light: (0, $9xrtn.default)[300],
        dark: (0, $9xrtn.default)[700]
    };
    return {
        main: (0, $9xrtn.default)[800],
        light: (0, $9xrtn.default)[500],
        dark: (0, $9xrtn.default)[900]
    };
}
function $97e216a958ba7785$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5a0nF.default)[400],
        light: (0, $5a0nF.default)[300],
        dark: (0, $5a0nF.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $5a0nF.default)[500],
        dark: (0, $5a0nF.default)[900]
    };
}
function $97e216a958ba7785$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $bGxpK.default)(palette, $97e216a958ba7785$var$_excluded);
    const primary = palette.primary || $97e216a958ba7785$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $97e216a958ba7785$var$getDefaultSecondary(mode);
    const error = palette.error || $97e216a958ba7785$var$getDefaultError(mode);
    const info = palette.info || $97e216a958ba7785$var$getDefaultInfo(mode);
    const success = palette.success || $97e216a958ba7785$var$getDefaultSuccess(mode);
    const warning = palette.warning || $97e216a958ba7785$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $emmvO.getContrastRatio)(background, $97e216a958ba7785$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $97e216a958ba7785$export$55ce6f3a06c59543.text.primary : $97e216a958ba7785$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $3G4eg.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $e50cx.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $e50cx.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $97e216a958ba7785$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $97e216a958ba7785$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $97e216a958ba7785$export$55ce6f3a06c59543,
        light: $97e216a958ba7785$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $gmeoE.default)((0, $3G4eg.default)({
        // A collection of common colors.
        common: (0, $3G4eg.default)({}, (0, $ggEZq.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $agcLQ.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("emmvO", function(module, exports) {
"use strict";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $a744952f4cbaa411$var$alpha;
module.exports.blend = $a744952f4cbaa411$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $a744952f4cbaa411$var$darken;
module.exports.decomposeColor = $a744952f4cbaa411$var$decomposeColor;
module.exports.emphasize = $a744952f4cbaa411$var$emphasize;
module.exports.getContrastRatio = $a744952f4cbaa411$var$getContrastRatio;
module.exports.getLuminance = $a744952f4cbaa411$var$getLuminance;
module.exports.hexToRgb = $a744952f4cbaa411$var$hexToRgb;
module.exports.hslToRgb = $a744952f4cbaa411$var$hslToRgb;
module.exports.lighten = $a744952f4cbaa411$var$lighten;
module.exports.private_safeAlpha = $a744952f4cbaa411$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $a744952f4cbaa411$var$private_safeDarken;
module.exports.private_safeEmphasize = $a744952f4cbaa411$var$private_safeEmphasize;
module.exports.private_safeLighten = $a744952f4cbaa411$var$private_safeLighten;
module.exports.recomposeColor = $a744952f4cbaa411$var$recomposeColor;
module.exports.rgbToHex = $a744952f4cbaa411$var$rgbToHex;

var $a744952f4cbaa411$var$_formatMuiErrorMessage2 = $gQ6R7((parcelRequire("cLP46")));

var $a744952f4cbaa411$var$_clamp = $gQ6R7((parcelRequire("khD0r")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $a744952f4cbaa411$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $a744952f4cbaa411$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $a744952f4cbaa411$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $a744952f4cbaa411$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $a744952f4cbaa411$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $a744952f4cbaa411$var$decomposeColor($a744952f4cbaa411$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $a744952f4cbaa411$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $a744952f4cbaa411$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $a744952f4cbaa411$var$colorChannel = (color)=>{
    const decomposedColor = $a744952f4cbaa411$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $a744952f4cbaa411$var$colorChannel;
const $a744952f4cbaa411$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $a744952f4cbaa411$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $a744952f4cbaa411$var$private_safeColorChannel;
function $a744952f4cbaa411$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $a744952f4cbaa411$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $a744952f4cbaa411$var$decomposeColor(color);
    return `#${values.map((n, i)=>$a744952f4cbaa411$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $a744952f4cbaa411$var$hslToRgb(color) {
    color = $a744952f4cbaa411$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $a744952f4cbaa411$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $a744952f4cbaa411$var$getLuminance(color) {
    color = $a744952f4cbaa411$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $a744952f4cbaa411$var$decomposeColor($a744952f4cbaa411$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $a744952f4cbaa411$var$getContrastRatio(foreground, background) {
    const lumA = $a744952f4cbaa411$var$getLuminance(foreground);
    const lumB = $a744952f4cbaa411$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $a744952f4cbaa411$var$alpha(color, value) {
    color = $a744952f4cbaa411$var$decomposeColor(color);
    value = $a744952f4cbaa411$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $a744952f4cbaa411$var$recomposeColor(color);
}
function $a744952f4cbaa411$var$private_safeAlpha(color, value, warning) {
    try {
        return $a744952f4cbaa411$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $a744952f4cbaa411$var$darken(color, coefficient) {
    color = $a744952f4cbaa411$var$decomposeColor(color);
    coefficient = $a744952f4cbaa411$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $a744952f4cbaa411$var$recomposeColor(color);
}
function $a744952f4cbaa411$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $a744952f4cbaa411$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $a744952f4cbaa411$var$lighten(color, coefficient) {
    color = $a744952f4cbaa411$var$decomposeColor(color);
    coefficient = $a744952f4cbaa411$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $a744952f4cbaa411$var$recomposeColor(color);
}
function $a744952f4cbaa411$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $a744952f4cbaa411$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $a744952f4cbaa411$var$emphasize(color, coefficient = 0.15) {
    return $a744952f4cbaa411$var$getLuminance(color) > 0.5 ? $a744952f4cbaa411$var$darken(color, coefficient) : $a744952f4cbaa411$var$lighten(color, coefficient);
}
function $a744952f4cbaa411$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $a744952f4cbaa411$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $a744952f4cbaa411$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $a744952f4cbaa411$var$decomposeColor(background);
    const overlayColor = $a744952f4cbaa411$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $a744952f4cbaa411$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("gQ6R7", function(module, exports) {
function $c426d216be63f89c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $c426d216be63f89c$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cLP46", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("e50cx")).default);

var $e50cx = parcelRequire("e50cx");

});

parcelRegister("khD0r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5B1Jc")).default);

var $5B1Jc = parcelRequire("5B1Jc");

});
parcelRegister("5B1Jc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4131bf9c85073c0f$export$2e2bcd8739ae039);
function $4131bf9c85073c0f$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $4131bf9c85073c0f$export$2e2bcd8739ae039 = $4131bf9c85073c0f$var$clamp;

});



parcelRegister("ggEZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7defaec37a5910$export$2e2bcd8739ae039);
const $bd7defaec37a5910$var$common = {
    black: "#000",
    white: "#fff"
};
var $bd7defaec37a5910$export$2e2bcd8739ae039 = $bd7defaec37a5910$var$common;

});

parcelRegister("agcLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $77854e00287d4fbf$export$2e2bcd8739ae039);
const $77854e00287d4fbf$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $77854e00287d4fbf$export$2e2bcd8739ae039 = $77854e00287d4fbf$var$grey;

});

parcelRegister("ewDfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a932811859aa46af$export$2e2bcd8739ae039);
const $a932811859aa46af$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $a932811859aa46af$export$2e2bcd8739ae039 = $a932811859aa46af$var$purple;

});

parcelRegister("dFMOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f44f9485679ff96$export$2e2bcd8739ae039);
const $9f44f9485679ff96$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $9f44f9485679ff96$export$2e2bcd8739ae039 = $9f44f9485679ff96$var$red;

});

parcelRegister("5a0nF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c1e2e87e809b434$export$2e2bcd8739ae039);
const $3c1e2e87e809b434$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $3c1e2e87e809b434$export$2e2bcd8739ae039 = $3c1e2e87e809b434$var$orange;

});

parcelRegister("hNihN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf453282c4a01b74$export$2e2bcd8739ae039);
const $cf453282c4a01b74$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $cf453282c4a01b74$export$2e2bcd8739ae039 = $cf453282c4a01b74$var$blue;

});

parcelRegister("ghSxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb88b044314ab8b$export$2e2bcd8739ae039);
const $bdb88b044314ab8b$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $bdb88b044314ab8b$export$2e2bcd8739ae039 = $bdb88b044314ab8b$var$lightBlue;

});

parcelRegister("9xrtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1c81a3cbceafe6$export$2e2bcd8739ae039);
const $6f1c81a3cbceafe6$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $6f1c81a3cbceafe6$export$2e2bcd8739ae039 = $6f1c81a3cbceafe6$var$green;

});


parcelRegister("5BGkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $010db29127b8ff00$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $gmeoE = parcelRequire("gmeoE");
const $010db29127b8ff00$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $010db29127b8ff00$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $010db29127b8ff00$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $010db29127b8ff00$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $010db29127b8ff00$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $010db29127b8ff00$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $bGxpK.default)(_ref, $010db29127b8ff00$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $3G4eg.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $010db29127b8ff00$var$defaultFontFamily ? {
            letterSpacing: `${$010db29127b8ff00$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $010db29127b8ff00$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $010db29127b8ff00$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $gmeoE.default)((0, $3G4eg.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("8hdMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $606a9a4c9f599307$export$2e2bcd8739ae039);
const $606a9a4c9f599307$var$shadowKeyUmbraOpacity = 0.2;
const $606a9a4c9f599307$var$shadowKeyPenumbraOpacity = 0.14;
const $606a9a4c9f599307$var$shadowAmbientShadowOpacity = 0.12;
function $606a9a4c9f599307$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$606a9a4c9f599307$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$606a9a4c9f599307$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$606a9a4c9f599307$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $606a9a4c9f599307$var$shadows = [
    "none",
    $606a9a4c9f599307$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $606a9a4c9f599307$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $606a9a4c9f599307$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $606a9a4c9f599307$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $606a9a4c9f599307$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $606a9a4c9f599307$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $606a9a4c9f599307$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $606a9a4c9f599307$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $606a9a4c9f599307$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $606a9a4c9f599307$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $606a9a4c9f599307$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $606a9a4c9f599307$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $606a9a4c9f599307$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $606a9a4c9f599307$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $606a9a4c9f599307$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $606a9a4c9f599307$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $606a9a4c9f599307$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $606a9a4c9f599307$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $606a9a4c9f599307$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $606a9a4c9f599307$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $606a9a4c9f599307$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $606a9a4c9f599307$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $606a9a4c9f599307$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $606a9a4c9f599307$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $606a9a4c9f599307$export$2e2bcd8739ae039 = $606a9a4c9f599307$var$shadows;

});

parcelRegister("lQ3HS", function(module, exports) {

$parcel$export(module.exports, "duration", () => $fe61546345104560$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $fe61546345104560$export$2e2bcd8739ae039);

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");
const $fe61546345104560$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $fe61546345104560$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $fe61546345104560$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $fe61546345104560$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $fe61546345104560$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $fe61546345104560$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $3G4eg.default)({}, $fe61546345104560$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $3G4eg.default)({}, $fe61546345104560$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $bGxpK.default)(options, $fe61546345104560$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $fe61546345104560$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $fe61546345104560$var$formatMs(delay)}`).join(",");
    };
    return (0, $3G4eg.default)({
        getAutoHeightDuration: $fe61546345104560$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("b70e6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8170861f0bf3722a$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $8170861f0bf3722a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $8170861f0bf3722a$export$2e2bcd8739ae039 = $8170861f0bf3722a$var$zIndex;

});



parcelRegister("7wciM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5795107ac88b075d$export$2e2bcd8739ae039);
var $5795107ac88b075d$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("jjHhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1015d966aca3910$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("dDUuw")).default);

var $kKyKx = parcelRequire("kKyKx");

var $hddxs = parcelRequire("hddxs");

var $7wciM = parcelRequire("7wciM");

var $dDUuw = parcelRequire("dDUuw");

var $f199g = parcelRequire("f199g");
"use client";
const $e1015d966aca3910$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($kKyKx)))({
    themeId: (0, $7wciM.default),
    defaultTheme: $hddxs.default,
    rootShouldForwardProp: $dDUuw.default
});
var $e1015d966aca3910$export$2e2bcd8739ae039 = $e1015d966aca3910$var$styled;

});
parcelRegister("kKyKx", function(module, exports) {
"use strict";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1b30f151fffd4ce$var$createStyled;
module.exports.shouldForwardProp = $f1b30f151fffd4ce$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $f1b30f151fffd4ce$var$_extends2 = $gQ6R7((parcelRequire("d8FWH")));

var $f1b30f151fffd4ce$var$_objectWithoutPropertiesLoose2 = $gQ6R7((parcelRequire("deC7u")));

var $f1b30f151fffd4ce$var$_styledEngine = $f1b30f151fffd4ce$var$_interopRequireWildcard((parcelRequire("912Uw")));

var $gmeoE = parcelRequire("gmeoE");

var $f1b30f151fffd4ce$var$_capitalize = $gQ6R7((parcelRequire("g9DeL")));

var $f1b30f151fffd4ce$var$_getDisplayName = $gQ6R7((parcelRequire("1xc18")));

var $f1b30f151fffd4ce$var$_createTheme = $gQ6R7((parcelRequire("eFEr2")));

var $f1b30f151fffd4ce$var$_styleFunctionSx = $gQ6R7((parcelRequire("bVnA0")));
const $f1b30f151fffd4ce$var$_excluded = [
    "ownerState"
], $f1b30f151fffd4ce$var$_excluded2 = [
    "variants"
], $f1b30f151fffd4ce$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $f1b30f151fffd4ce$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f1b30f151fffd4ce$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f1b30f151fffd4ce$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f1b30f151fffd4ce$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f1b30f151fffd4ce$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f1b30f151fffd4ce$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $f1b30f151fffd4ce$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $f1b30f151fffd4ce$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $f1b30f151fffd4ce$var$_createTheme.default)();
const $f1b30f151fffd4ce$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $f1b30f151fffd4ce$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $f1b30f151fffd4ce$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $f1b30f151fffd4ce$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $f1b30f151fffd4ce$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $f1b30f151fffd4ce$var$_objectWithoutPropertiesLoose2.default)(_ref, $f1b30f151fffd4ce$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $f1b30f151fffd4ce$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$f1b30f151fffd4ce$var$processStyleArg(resolvedStyle, (0, $f1b30f151fffd4ce$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $f1b30f151fffd4ce$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $f1b30f151fffd4ce$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $f1b30f151fffd4ce$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $f1b30f151fffd4ce$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $f1b30f151fffd4ce$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $f1b30f151fffd4ce$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $f1b30f151fffd4ce$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $f1b30f151fffd4ce$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $f1b30f151fffd4ce$var$_styleFunctionSx.default)((0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
            theme: $f1b30f151fffd4ce$var$resolveTheme((0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $f1b30f151fffd4ce$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $f1b30f151fffd4ce$var$defaultOverridesResolver($f1b30f151fffd4ce$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $f1b30f151fffd4ce$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $f1b30f151fffd4ce$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $f1b30f151fffd4ce$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f1b30f151fffd4ce$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $f1b30f151fffd4ce$var$_styledEngine.default)(tag, (0, $f1b30f151fffd4ce$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $gmeoE.isPlainObject)(stylesArg)) return (props)=>$f1b30f151fffd4ce$var$processStyleArg(stylesArg, (0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                    theme: $f1b30f151fffd4ce$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $f1b30f151fffd4ce$var$resolveTheme((0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $f1b30f151fffd4ce$var$processStyleArg(slotStyle, (0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $f1b30f151fffd4ce$var$resolveTheme((0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $f1b30f151fffd4ce$var$processStyleArg({
                    variants: themeVariants
                }, (0, $f1b30f151fffd4ce$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("deC7u", function(module, exports) {
function $9a2a26f8737411d1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $9a2a26f8737411d1$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("912Uw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $01b1a714c28be114$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $01b1a714c28be114$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("42TgP")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("8eVik")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("8eVik")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("bb66H")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("eAHa0")).default);
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $i4zmL = parcelRequire("i4zmL");

var $8eVik = parcelRequire("8eVik");
var $42TgP = parcelRequire("42TgP");

var $bb66H = parcelRequire("bb66H");

var $eAHa0 = parcelRequire("eAHa0");
"use client";
function $01b1a714c28be114$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $i4zmL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $01b1a714c28be114$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("i4zmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28408b77e1a5bee$export$2e2bcd8739ae039);

var $kXaOf = parcelRequire("kXaOf");
parcelRequire("d8FWH");
parcelRequire("dup7A");
parcelRequire("24khb");

parcelRequire("iTnfQ");
parcelRequire("aTw1e");
parcelRequire("5OTva");
var $d28408b77e1a5bee$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $d28408b77e1a5bee$export$2e2bcd8739ae039 = (0, $kXaOf.default).bind();
$d28408b77e1a5bee$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $d28408b77e1a5bee$export$2e2bcd8739ae039[tagName] = $d28408b77e1a5bee$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("kXaOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f411b3e413327179$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $24khb = parcelRequire("24khb");
parcelRequire("8eVik");
var $42TgP = parcelRequire("42TgP");

var $iTnfQ = parcelRequire("iTnfQ");

var $aTw1e = parcelRequire("aTw1e");

var $5OTva = parcelRequire("5OTva");
var $f411b3e413327179$var$testOmitPropsOnStringTag = (0, $24khb.default);
var $f411b3e413327179$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $f411b3e413327179$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $f411b3e413327179$var$testOmitPropsOnStringTag : $f411b3e413327179$var$testOmitPropsOnComponent;
};
var $f411b3e413327179$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $f411b3e413327179$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $f411b3e413327179$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iTnfQ.registerStyles)(cache, serialized, isStringTag);
    (0, $5OTva.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iTnfQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $f411b3e413327179$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $f411b3e413327179$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $f411b3e413327179$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $42TgP.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $dup7A.useContext((0, $42TgP.T));
            }
            if (typeof props.className === "string") className = (0, $iTnfQ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $aTw1e.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $f411b3e413327179$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement($f411b3e413327179$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $dup7A.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $3G4eg.default)({}, options, nextOptions, {
                shouldForwardProp: $f411b3e413327179$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("24khb", function(module, exports) {

$parcel$export(module.exports, "default", () => $181baee5022e6156$export$2e2bcd8739ae039);

var $acqtA = parcelRequire("acqtA");
var $181baee5022e6156$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $181baee5022e6156$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $acqtA.default)(function(prop) {
    return $181baee5022e6156$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("bb66H", function(module, exports) {

$parcel$export(module.exports, "default", () => $82357589dd1fb982$export$2e2bcd8739ae039);
parcelRequire("dup7A");


var $42TgP = parcelRequire("42TgP");

var $kE7g8 = parcelRequire("kE7g8");

var $cZGFG = parcelRequire("cZGFG");
"use client";
let $82357589dd1fb982$var$cache;
if (typeof document === "object") $82357589dd1fb982$var$cache = (0, $kE7g8.default)({
    key: "css",
    prepend: true
});
function $82357589dd1fb982$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $82357589dd1fb982$var$cache ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $42TgP.C), {
        value: $82357589dd1fb982$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("cZGFG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fJAss"));

});


parcelRegister("eAHa0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f5e83f6140b55e$export$2e2bcd8739ae039);
parcelRequire("dup7A");


var $8eVik = parcelRequire("8eVik");

var $cZGFG = parcelRequire("cZGFG");
"use client";
function $a9f5e83f6140b55e$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $a9f5e83f6140b55e$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($a9f5e83f6140b55e$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8eVik.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("g9DeL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8xa0D")).default);

var $8xa0D = parcelRequire("8xa0D");

});

parcelRegister("1xc18", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5Jr49")).default);

var $5Jr49 = parcelRequire("5Jr49");
$parcel$exportWildcard(module.exports, $5Jr49);

});
parcelRegister("5Jr49", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $42c6266f81261240$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $42c6266f81261240$export$2e2bcd8739ae039);

var $8vAu6 = parcelRequire("8vAu6");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $42c6266f81261240$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $42c6266f81261240$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($42c6266f81261240$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $42c6266f81261240$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $42c6266f81261240$export$aad197c7121a6651(Component) || fallback;
}
function $42c6266f81261240$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $42c6266f81261240$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $42c6266f81261240$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $42c6266f81261240$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $8vAu6.ForwardRef:
            return $42c6266f81261240$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $8vAu6.Memo:
            return $42c6266f81261240$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("8vAu6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hFL7V"));

});



parcelRegister("eFEr2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1kGZC")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("12PJy")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("36jUO")).default);

var $1kGZC = parcelRequire("1kGZC");

var $12PJy = parcelRequire("12PJy");

var $36jUO = parcelRequire("36jUO");

});

parcelRegister("bVnA0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7eWjf")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("7eWjf")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("9qvqC")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("bDGwn")).default);

var $7eWjf = parcelRequire("7eWjf");

var $9qvqC = parcelRequire("9qvqC");

var $bDGwn = parcelRequire("bDGwn");

});
parcelRegister("9qvqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dceebcbfa26deb1$export$2e2bcd8739ae039);

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $gmeoE = parcelRequire("gmeoE");

var $bDGwn = parcelRequire("bDGwn");
const $6dceebcbfa26deb1$var$_excluded = [
    "sx"
];
const $6dceebcbfa26deb1$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $bDGwn.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $6dceebcbfa26deb1$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $bGxpK.default)(props, $6dceebcbfa26deb1$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $6dceebcbfa26deb1$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $gmeoE.isPlainObject)(result)) return systemProps;
        return (0, $3G4eg.default)({}, systemProps, result);
    };
    else finalSx = (0, $3G4eg.default)({}, systemProps, inSx);
    return (0, $3G4eg.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("dDUuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eeabcdf58cfd6ab$export$2e2bcd8739ae039);

var $f199g = parcelRequire("f199g");
const $9eeabcdf58cfd6ab$var$rootShouldForwardProp = (prop)=>(0, $f199g.default)(prop) && prop !== "classes";
var $9eeabcdf58cfd6ab$export$2e2bcd8739ae039 = $9eeabcdf58cfd6ab$var$rootShouldForwardProp;

});
parcelRegister("f199g", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeee0bad68b997b4$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $aeee0bad68b997b4$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $aeee0bad68b997b4$export$2e2bcd8739ae039 = $aeee0bad68b997b4$var$slotShouldForwardProp;

});



parcelRegister("4CYID", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $35e9cf913ca3223c$export$c7c50641356bdfa5);
$parcel$export(module.exports, "default", () => $35e9cf913ca3223c$export$2e2bcd8739ae039);

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $35e9cf913ca3223c$export$c7c50641356bdfa5(slot) {
    return (0, $8iNDC.default)("MuiSvgIcon", slot);
}
const $35e9cf913ca3223c$var$svgIconClasses = (0, $fc1pF.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $35e9cf913ca3223c$export$2e2bcd8739ae039 = $35e9cf913ca3223c$var$svgIconClasses;

});
parcelRegister("fc1pF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0f9129bbafc7263$export$2e2bcd8739ae039);

var $8iNDC = parcelRequire("8iNDC");
function $b0f9129bbafc7263$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $8iNDC.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("8iNDC", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", () => $60b6823ca2bb4fb7$export$9d6b9120de57c54);
$parcel$export(module.exports, "default", () => $60b6823ca2bb4fb7$export$2e2bcd8739ae039);

var $fjjjN = parcelRequire("fjjjN");
const $60b6823ca2bb4fb7$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $60b6823ca2bb4fb7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $60b6823ca2bb4fb7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $fjjjN.default).generate(componentName)}-${slot}`;
}
function $60b6823ca2bb4fb7$export$34c0130b1f3e8ae3(slot) {
    return $60b6823ca2bb4fb7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("fjjjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2579d942a97d604$export$2e2bcd8739ae039);
const $b2579d942a97d604$var$defaultGenerator = (componentName)=>componentName;
const $b2579d942a97d604$var$createClassNameGenerator = ()=>{
    let generate = $b2579d942a97d604$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $b2579d942a97d604$var$defaultGenerator;
        }
    };
};
const $b2579d942a97d604$var$ClassNameGenerator = $b2579d942a97d604$var$createClassNameGenerator();
var $b2579d942a97d604$export$2e2bcd8739ae039 = $b2579d942a97d604$var$ClassNameGenerator;

});







parcelRegister("2nfW6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $1baa17546c2c3b76$export$bf730a2d8bf68b42, (v) => $1baa17546c2c3b76$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1baa17546c2c3b76$export$bf730a2d8bf68b42;
"use strict";

var $dup7A = parcelRequire("dup7A");

var $18PxG = parcelRequire("18PxG");
function $1baa17546c2c3b76$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1baa17546c2c3b76$var$q = "function" === typeof Object.is ? Object.is : $1baa17546c2c3b76$var$p, $1baa17546c2c3b76$var$r = $18PxG.useSyncExternalStore, $1baa17546c2c3b76$var$t = $dup7A.useRef, $1baa17546c2c3b76$var$u = $dup7A.useEffect, $1baa17546c2c3b76$var$v = $dup7A.useMemo, $1baa17546c2c3b76$var$w = $dup7A.useDebugValue;
$1baa17546c2c3b76$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $1baa17546c2c3b76$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $1baa17546c2c3b76$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($1baa17546c2c3b76$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $1baa17546c2c3b76$var$r(a, c[0], c[1]);
    $1baa17546c2c3b76$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $1baa17546c2c3b76$var$w(d);
    return d;
};

});
parcelRegister("18PxG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("je7fA"));

});
parcelRegister("je7fA", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dff4f2ec624e0bea$export$306c0aa65ff9ec16, (v) => $dff4f2ec624e0bea$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dff4f2ec624e0bea$export$306c0aa65ff9ec16;
"use strict";

var $dup7A = parcelRequire("dup7A");
function $dff4f2ec624e0bea$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dff4f2ec624e0bea$var$k = "function" === typeof Object.is ? Object.is : $dff4f2ec624e0bea$var$h, $dff4f2ec624e0bea$var$l = $dup7A.useState, $dff4f2ec624e0bea$var$m = $dup7A.useEffect, $dff4f2ec624e0bea$var$n = $dup7A.useLayoutEffect, $dff4f2ec624e0bea$var$p = $dup7A.useDebugValue;
function $dff4f2ec624e0bea$var$q(a, b) {
    var d = b(), f = $dff4f2ec624e0bea$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dff4f2ec624e0bea$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dff4f2ec624e0bea$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dff4f2ec624e0bea$var$m(function() {
        $dff4f2ec624e0bea$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dff4f2ec624e0bea$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dff4f2ec624e0bea$var$p(d);
    return d;
}
function $dff4f2ec624e0bea$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dff4f2ec624e0bea$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dff4f2ec624e0bea$var$t(a, b) {
    return b();
}
var $dff4f2ec624e0bea$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dff4f2ec624e0bea$var$t : $dff4f2ec624e0bea$var$q;
$dff4f2ec624e0bea$export$306c0aa65ff9ec16 = void 0 !== $dup7A.useSyncExternalStore ? $dup7A.useSyncExternalStore : $dff4f2ec624e0bea$var$u;

});



parcelRegister("bMt2j", function(module, exports) {
"use strict";
var $893ab363482e0acb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $893ab363482e0acb$var$communication_1 = $893ab363482e0acb$var$__importDefault((parcelRequire("cGw52")));

var $gLr56 = parcelRequire("gLr56");

var $h5Ly4 = parcelRequire("h5Ly4");

var $5oi5i = parcelRequire("5oi5i");

var $gtlfI = parcelRequire("gtlfI");
class $893ab363482e0acb$var$SafeAppsSDK {
    constructor(opts = {}){
        const { allowedDomains: allowedDomains = null, debug: debug = false } = opts;
        this.communicator = new $893ab363482e0acb$var$communication_1.default(allowedDomains, debug);
        this.eth = new $h5Ly4.Eth(this.communicator);
        this.txs = new $gLr56.TXs(this.communicator);
        this.safe = new $5oi5i.Safe(this.communicator);
        this.wallet = new $gtlfI.Wallet(this.communicator);
    }
}
module.exports.default = $893ab363482e0acb$var$SafeAppsSDK;

});
parcelRegister("cGw52", function(module, exports) {
"use strict";
var $93c24abe4b5e872c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93c24abe4b5e872c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93c24abe4b5e872c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lu5V3 = parcelRequire("lu5V3");
class $93c24abe4b5e872c$var$PostMessageCommunicator {
    constructor(allowedOrigins = null, debugMode = false){
        this.allowedOrigins = null;
        this.callbacks = new Map();
        this.debugMode = false;
        this.isServer = typeof window === "undefined";
        this.isValidMessage = ({ origin: origin, data: data, source: source })=>{
            const emptyOrMalformed = !data;
            const sentFromParentEl = !this.isServer && source === window.parent;
            const majorVersionNumber = typeof data.version !== "undefined" && parseInt(data.version.split(".")[0]);
            const allowedSDKVersion = majorVersionNumber >= 1;
            let validOrigin = true;
            if (Array.isArray(this.allowedOrigins)) validOrigin = this.allowedOrigins.find((regExp)=>regExp.test(origin)) !== undefined;
            return !emptyOrMalformed && sentFromParentEl && allowedSDKVersion && validOrigin;
        };
        this.logIncomingMessage = (msg)=>{
            console.info(`Safe Apps SDK v1: A message was received from origin ${msg.origin}. `, msg.data);
        };
        this.onParentMessage = (msg)=>{
            if (this.isValidMessage(msg)) {
                this.debugMode && this.logIncomingMessage(msg);
                this.handleIncomingMessage(msg.data);
            }
        };
        this.handleIncomingMessage = (payload)=>{
            const { id: id } = payload;
            const cb = this.callbacks.get(id);
            if (cb) {
                cb(payload);
                this.callbacks.delete(id);
            }
        };
        this.send = (method, params)=>{
            const request = $lu5V3.MessageFormatter.makeRequest(method, params);
            if (this.isServer) throw new Error("Window doesn't exist");
            window.parent.postMessage(request, "*");
            return new Promise((resolve, reject)=>{
                this.callbacks.set(request.id, (response)=>{
                    if (!response.success) {
                        reject(new Error(response.error));
                        return;
                    }
                    resolve(response);
                });
            });
        };
        this.allowedOrigins = allowedOrigins;
        this.debugMode = debugMode;
        if (!this.isServer) window.addEventListener("message", this.onParentMessage);
    }
}
module.exports.default = $93c24abe4b5e872c$var$PostMessageCommunicator;

$93c24abe4b5e872c$var$__exportStar((parcelRequire("2XHGr")), module.exports);

});
parcelRegister("lu5V3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageFormatter = void 0;

var $4QxQm = parcelRequire("4QxQm");

var $epPOP = parcelRequire("epPOP");
class $fa40fdbf5d0fccb3$var$MessageFormatter {
}
module.exports.MessageFormatter = $fa40fdbf5d0fccb3$var$MessageFormatter;
$fa40fdbf5d0fccb3$var$MessageFormatter.makeRequest = (method, params)=>{
    const id = (0, $epPOP.generateRequestId)();
    return {
        id: id,
        method: method,
        params: params,
        env: {
            sdkVersion: (0, $4QxQm.getSDKVersion)()
        }
    };
};
$fa40fdbf5d0fccb3$var$MessageFormatter.makeResponse = (id, data, version)=>({
        id: id,
        success: true,
        version: version,
        data: data
    });
$fa40fdbf5d0fccb3$var$MessageFormatter.makeErrorResponse = (id, error, version)=>({
        id: id,
        success: false,
        error: error,
        version: version
    });

});
parcelRegister("4QxQm", function(module, exports) {
"use strict";
var $3876455a8fe61713$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSDKVersion = void 0;

const $3876455a8fe61713$var$package_json_1 = $3876455a8fe61713$var$__importDefault((parcelRequire("d9P0X")));
const $3876455a8fe61713$var$getSDKVersion = ()=>{
    // Strip out version tags like `beta.0` in `1.0.0-beta.0`
    return $3876455a8fe61713$var$package_json_1.default.version.split("-")[0];
};
module.exports.getSDKVersion = $3876455a8fe61713$var$getSDKVersion;

});
parcelRegister("d9P0X", function(module, exports) {
module.exports = JSON.parse('{"name":"@safe-global/safe-apps-sdk","version":"8.1.0","description":"SDK developed to integrate third-party apps with Safe app.","main":"dist/src/index.js","typings":"dist/src/index.d.ts","_files":["dist/**/*","src/**/*","CHANGELOG.md","README.md"],"sideEffects":false,"keywords":["Safe","sdk","apps"],"scripts":{"test":"jest","format-dist":"sed -i \'\' \'s/\\"files\\":/\\"_files\\":/\' dist/package.json","build":"yarn rimraf dist && tsc && yarn format-dist"},"author":"Safe (https://safe.global)","license":"MIT","dependencies":{"@safe-global/safe-gateway-typescript-sdk":"^3.5.3","viem":"^1.0.0"},"repository":{"type":"git","url":"git+https://github.com/safe-global/safe-apps-sdk.git"},"bugs":{"url":"https://github.com/safe-global/safe-apps-sdk/issues"},"homepage":"https://github.com/safe-global/safe-apps-sdk#readme","publishConfig":{"access":"public"}}');

});


parcelRegister("epPOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateRequestId = void 0;
// i.e. 0-255 -> '00'-'ff'
const $a7eb98a46adbb95b$var$dec2hex = (dec)=>dec.toString(16).padStart(2, "0");
const $a7eb98a46adbb95b$var$generateId = (len)=>{
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, $a7eb98a46adbb95b$var$dec2hex).join("");
};
const $a7eb98a46adbb95b$var$generateRequestId = ()=>{
    if (typeof window !== "undefined") return $a7eb98a46adbb95b$var$generateId(10);
    return new Date().getTime().toString(36);
};
module.exports.generateRequestId = $a7eb98a46adbb95b$var$generateRequestId;

});


parcelRegister("2XHGr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RestrictedMethods = module.exports.Methods = void 0;
var $2282fa1c1f40b5b9$var$Methods;
(function(Methods) {
    Methods["sendTransactions"] = "sendTransactions";
    Methods["rpcCall"] = "rpcCall";
    Methods["getChainInfo"] = "getChainInfo";
    Methods["getSafeInfo"] = "getSafeInfo";
    Methods["getTxBySafeTxHash"] = "getTxBySafeTxHash";
    Methods["getSafeBalances"] = "getSafeBalances";
    Methods["signMessage"] = "signMessage";
    Methods["signTypedMessage"] = "signTypedMessage";
    Methods["getEnvironmentInfo"] = "getEnvironmentInfo";
    Methods["getOffChainSignature"] = "getOffChainSignature";
    Methods["requestAddressBook"] = "requestAddressBook";
    Methods["wallet_getPermissions"] = "wallet_getPermissions";
    Methods["wallet_requestPermissions"] = "wallet_requestPermissions";
})($2282fa1c1f40b5b9$var$Methods = module.exports.Methods || (module.exports.Methods = {}));
var $2282fa1c1f40b5b9$var$RestrictedMethods;
(function(RestrictedMethods) {
    RestrictedMethods["requestAddressBook"] = "requestAddressBook";
})($2282fa1c1f40b5b9$var$RestrictedMethods = module.exports.RestrictedMethods || (module.exports.RestrictedMethods = {}));

});


parcelRegister("gLr56", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TXs = void 0;

var $2XHGr = parcelRequire("2XHGr");

var $dUSnl = parcelRequire("dUSnl");
class $c3460ae50302838f$var$TXs {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getBySafeTxHash(safeTxHash) {
        if (!safeTxHash) throw new Error("Invalid safeTxHash");
        const response = await this.communicator.send($2XHGr.Methods.getTxBySafeTxHash, {
            safeTxHash: safeTxHash
        });
        return response.data;
    }
    async signMessage(message) {
        const messagePayload = {
            message: message
        };
        const response = await this.communicator.send($2XHGr.Methods.signMessage, messagePayload);
        return response.data;
    }
    async signTypedMessage(typedData) {
        if (!(0, $dUSnl.isObjectEIP712TypedData)(typedData)) throw new Error("Invalid typed data");
        const response = await this.communicator.send($2XHGr.Methods.signTypedMessage, {
            typedData: typedData
        });
        return response.data;
    }
    async send({ txs: txs, params: params }) {
        if (!txs || !txs.length) throw new Error("No transactions were passed");
        const messagePayload = {
            txs: txs,
            params: params
        };
        const response = await this.communicator.send($2XHGr.Methods.sendTransactions, messagePayload);
        return response.data;
    }
}
module.exports.TXs = $c3460ae50302838f$var$TXs;

});
parcelRegister("dUSnl", function(module, exports) {
"use strict";
var $a21aaf2984069d48$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a21aaf2984069d48$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a21aaf2984069d48$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a21aaf2984069d48$var$__exportStar((parcelRequire("3LNw2")), module.exports);

$a21aaf2984069d48$var$__exportStar((parcelRequire("amfxx")), module.exports);

$a21aaf2984069d48$var$__exportStar((parcelRequire("da2u1")), module.exports);

$a21aaf2984069d48$var$__exportStar((parcelRequire("1yaPE")), module.exports);

});
parcelRegister("3LNw2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObjectEIP712TypedData = void 0;
const $2bec2bb4173852d9$var$isObjectEIP712TypedData = (obj)=>{
    return typeof obj === "object" && obj != null && "domain" in obj && "types" in obj && "message" in obj;
};
module.exports.isObjectEIP712TypedData = $2bec2bb4173852d9$var$isObjectEIP712TypedData;

});

parcelRegister("amfxx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("da2u1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.TokenType = module.exports.Operation = void 0;

var $7HNgX = parcelRequire("7HNgX");
Object.defineProperty(module.exports, "Operation", {
    enumerable: true,
    get: function() {
        return $7HNgX.Operation;
    }
});
Object.defineProperty(module.exports, "TokenType", {
    enumerable: true,
    get: function() {
        return $7HNgX.TokenType;
    }
});
Object.defineProperty(module.exports, "TransactionStatus", {
    enumerable: true,
    get: function() {
        return $7HNgX.TransactionStatus;
    }
});
Object.defineProperty(module.exports, "TransferDirection", {
    enumerable: true,
    get: function() {
        return $7HNgX.TransferDirection;
    }
});

});
parcelRegister("7HNgX", function(module, exports) {
"use strict";
var $59c2c50fee40be62$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59c2c50fee40be62$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $59c2c50fee40be62$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getContract = module.exports.getSafeOverviews = module.exports.unsubscribeAll = module.exports.unsubscribeSingle = module.exports.registerRecoveryModule = module.exports.deleteRegisteredEmail = module.exports.getRegisteredEmail = module.exports.verifyEmail = module.exports.resendEmailVerificationCode = module.exports.changeEmail = module.exports.registerEmail = module.exports.unregisterDevice = module.exports.unregisterSafe = module.exports.registerDevice = module.exports.getDelegates = module.exports.confirmSafeMessage = module.exports.proposeSafeMessage = module.exports.getSafeMessage = module.exports.getSafeMessages = module.exports.getDecodedData = module.exports.getMasterCopies = module.exports.getSafeApps = module.exports.getChainConfig = module.exports.getChainsConfig = module.exports.getConfirmationView = module.exports.proposeTransaction = module.exports.getNonces = module.exports.postSafeGasEstimation = module.exports.deleteTransaction = module.exports.getTransactionDetails = module.exports.getTransactionQueue = module.exports.getTransactionHistory = module.exports.getCollectiblesPage = module.exports.getCollectibles = module.exports.getAllOwnedSafes = module.exports.getOwnedSafes = module.exports.getFiatCurrencies = module.exports.getBalances = module.exports.getMultisigTransactions = module.exports.getModuleTransactions = module.exports.getIncomingTransfers = module.exports.getSafeInfo = module.exports.getRelayCount = module.exports.relayTransaction = module.exports.setBaseUrl = void 0;

var $5l9Ls = parcelRequire("5l9Ls");

var $8XN8P = parcelRequire("8XN8P");

$59c2c50fee40be62$var$__exportStar((parcelRequire("eAtVo")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("eCyp2")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("gVk8C")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("cDKVF")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("3KuTQ")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("dHx9i")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("dS903")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("cZ1eZ")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("dNRxO")), module.exports);

$59c2c50fee40be62$var$__exportStar((parcelRequire("fGz9t")), module.exports);
// Can be set externally to a different CGW host
let $59c2c50fee40be62$var$baseUrl = $8XN8P.DEFAULT_BASE_URL;
/**
 * Set the base CGW URL
 */ const $59c2c50fee40be62$var$setBaseUrl = (url)=>{
    $59c2c50fee40be62$var$baseUrl = url;
};
module.exports.setBaseUrl = $59c2c50fee40be62$var$setBaseUrl;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Relay a transaction from a Safe
 */ function $59c2c50fee40be62$var$relayTransaction(chainId, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/relay", {
        path: {
            chainId: chainId
        },
        body: body
    });
}
module.exports.relayTransaction = $59c2c50fee40be62$var$relayTransaction;
/**
 * Get the relay limit and number of remaining relays remaining
 */ function $59c2c50fee40be62$var$getRelayCount(chainId, address) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/relay/{address}", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getRelayCount = $59c2c50fee40be62$var$getRelayCount;
/**
 * Get basic information about a Safe. E.g. owners, modules, version etc
 */ function $59c2c50fee40be62$var$getSafeInfo(chainId, address) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getSafeInfo = $59c2c50fee40be62$var$getSafeInfo;
/**
 * Get filterable list of incoming transactions
 */ function $59c2c50fee40be62$var$getIncomingTransfers(chainId, address, query, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/incoming-transfers/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getIncomingTransfers = $59c2c50fee40be62$var$getIncomingTransfers;
/**
 * Get filterable list of module transactions
 */ function $59c2c50fee40be62$var$getModuleTransactions(chainId, address, query, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/module-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getModuleTransactions = $59c2c50fee40be62$var$getModuleTransactions;
/**
 * Get filterable list of multisig transactions
 */ function $59c2c50fee40be62$var$getMultisigTransactions(chainId, address, query, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/multisig-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getMultisigTransactions = $59c2c50fee40be62$var$getMultisigTransactions;
/**
 * Get the total balance and all assets stored in a Safe
 */ function $59c2c50fee40be62$var$getBalances(chainId, address, currency = "usd", query = {}) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/balances/{currency}", {
        path: {
            chainId: chainId,
            address: address,
            currency: currency
        },
        query: query
    });
}
module.exports.getBalances = $59c2c50fee40be62$var$getBalances;
/**
 * Get a list of supported fiat currencies (e.g. USD, EUR etc)
 */ function $59c2c50fee40be62$var$getFiatCurrencies() {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/balances/supported-fiat-codes");
}
module.exports.getFiatCurrencies = $59c2c50fee40be62$var$getFiatCurrencies;
/**
 * Get the addresses of all Safes belonging to an owner
 */ function $59c2c50fee40be62$var$getOwnedSafes(chainId, address) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/owners/{address}/safes", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getOwnedSafes = $59c2c50fee40be62$var$getOwnedSafes;
/**
 * Get the addresses of all Safes belonging to an owner on all chains
 */ function $59c2c50fee40be62$var$getAllOwnedSafes(address) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/owners/{address}/safes", {
        path: {
            address: address
        }
    });
}
module.exports.getAllOwnedSafes = $59c2c50fee40be62$var$getAllOwnedSafes;
/**
 * Get NFTs stored in a Safe
 */ function $59c2c50fee40be62$var$getCollectibles(chainId, address, query = {}) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    });
}
module.exports.getCollectibles = $59c2c50fee40be62$var$getCollectibles;
/**
 * Get NFTs stored in a Safe
 */ function $59c2c50fee40be62$var$getCollectiblesPage(chainId, address, query = {}, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v2/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getCollectiblesPage = $59c2c50fee40be62$var$getCollectiblesPage;
/**
 * Get a list of past Safe transactions
 */ function $59c2c50fee40be62$var$getTransactionHistory(chainId, address, query = {}, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/history", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getTransactionHistory = $59c2c50fee40be62$var$getTransactionHistory;
/**
 * Get the list of pending transactions
 */ function $59c2c50fee40be62$var$getTransactionQueue(chainId, address, query = {}, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/queued", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getTransactionQueue = $59c2c50fee40be62$var$getTransactionQueue;
/**
 * Get the details of an individual transaction by its id
 */ function $59c2c50fee40be62$var$getTransactionDetails(chainId, transactionId) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/transactions/{transactionId}", {
        path: {
            chainId: chainId,
            transactionId: transactionId
        }
    });
}
module.exports.getTransactionDetails = $59c2c50fee40be62$var$getTransactionDetails;
/**
 * Delete a transaction by its safeTxHash
 */ function $59c2c50fee40be62$var$deleteTransaction(chainId, safeTxHash, signature) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/transactions/{safeTxHash}", {
        path: {
            chainId: chainId,
            safeTxHash: safeTxHash
        },
        body: {
            signature: signature
        }
    });
}
module.exports.deleteTransaction = $59c2c50fee40be62$var$deleteTransaction;
/**
 * Request a gas estimate & recommmended tx nonce for a created transaction
 */ function $59c2c50fee40be62$var$postSafeGasEstimation(chainId, address, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v2/chains/{chainId}/safes/{safe_address}/multisig-transactions/estimations", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.postSafeGasEstimation = $59c2c50fee40be62$var$postSafeGasEstimation;
function $59c2c50fee40be62$var$getNonces(chainId, address) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/nonces", {
        path: {
            chainId: chainId,
            safe_address: address
        }
    });
}
module.exports.getNonces = $59c2c50fee40be62$var$getNonces;
/**
 * Propose a new transaction for other owners to sign/execute
 */ function $59c2c50fee40be62$var$proposeTransaction(chainId, address, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/transactions/{safe_address}/propose", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeTransaction = $59c2c50fee40be62$var$proposeTransaction;
/**
 * Returns decoded data
 */ function $59c2c50fee40be62$var$getConfirmationView(chainId, safeAddress, encodedData, to) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/views/transaction-confirmation", {
        path: {
            chainId: chainId,
            safe_address: safeAddress
        },
        body: {
            data: encodedData,
            to: to
        }
    });
}
module.exports.getConfirmationView = $59c2c50fee40be62$var$getConfirmationView;
/**
 * Returns all defined chain configs
 */ function $59c2c50fee40be62$var$getChainsConfig(query) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains", {
        query: query
    });
}
module.exports.getChainsConfig = $59c2c50fee40be62$var$getChainsConfig;
/**
 * Returns a chain config
 */ function $59c2c50fee40be62$var$getChainConfig(chainId) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getChainConfig = $59c2c50fee40be62$var$getChainConfig;
/**
 * Returns Safe Apps List
 */ function $59c2c50fee40be62$var$getSafeApps(chainId, query = {}) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safe-apps", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getSafeApps = $59c2c50fee40be62$var$getSafeApps;
/**
 * Returns list of Master Copies
 */ function $59c2c50fee40be62$var$getMasterCopies(chainId) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/about/master-copies", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getMasterCopies = $59c2c50fee40be62$var$getMasterCopies;
/**
 * Returns decoded data
 */ function $59c2c50fee40be62$var$getDecodedData(chainId, encodedData, to) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/data-decoder", {
        path: {
            chainId: chainId
        },
        body: {
            data: encodedData,
            to: to
        }
    });
}
module.exports.getDecodedData = $59c2c50fee40be62$var$getDecodedData;
/**
 * Returns list of `SafeMessage`s
 */ function $59c2c50fee40be62$var$getSafeMessages(chainId, address, pageUrl) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getSafeMessages = $59c2c50fee40be62$var$getSafeMessages;
/**
 * Returns a `SafeMessage`
 */ function $59c2c50fee40be62$var$getSafeMessage(chainId, messageHash) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        }
    });
}
module.exports.getSafeMessage = $59c2c50fee40be62$var$getSafeMessage;
/**
 * Propose a new `SafeMessage` for other owners to sign
 */ function $59c2c50fee40be62$var$proposeSafeMessage(chainId, address, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeSafeMessage = $59c2c50fee40be62$var$proposeSafeMessage;
/**
 * Add a confirmation to a `SafeMessage`
 */ function $59c2c50fee40be62$var$confirmSafeMessage(chainId, messageHash, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}/signatures", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        },
        body: body
    });
}
module.exports.confirmSafeMessage = $59c2c50fee40be62$var$confirmSafeMessage;
/**
 * Returns a list of delegates
 */ function $59c2c50fee40be62$var$getDelegates(chainId, query = {}) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/delegates", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getDelegates = $59c2c50fee40be62$var$getDelegates;
/**
 * Registers a device/Safe for notifications
 */ function $59c2c50fee40be62$var$registerDevice(body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/register/notifications", {
        body: body
    });
}
module.exports.registerDevice = $59c2c50fee40be62$var$registerDevice;
/**
 * Unregisters a Safe from notifications
 */ function $59c2c50fee40be62$var$unregisterSafe(chainId, address, uuid) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}/safes/{safe_address}", {
        path: {
            chainId: chainId,
            safe_address: address,
            uuid: uuid
        }
    });
}
module.exports.unregisterSafe = $59c2c50fee40be62$var$unregisterSafe;
/**
 * Unregisters a device from notifications
 */ function $59c2c50fee40be62$var$unregisterDevice(chainId, uuid) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}", {
        path: {
            chainId: chainId,
            uuid: uuid
        }
    });
}
module.exports.unregisterDevice = $59c2c50fee40be62$var$unregisterDevice;
/**
 * Registers a email address for a safe signer.
 *
 * The signer wallet has to sign a message of format: `email-register-{chainId}-{safeAddress}-{emailAddress}-{signer}-{timestamp}`
 * The signature is valid for 5 minutes.
 *
 * @param chainId
 * @param safeAddress
 * @param body Signer address and email address
 * @param headers Signature and Signature timestamp
 * @returns 200 if signature matches the data
 */ function $59c2c50fee40be62$var$registerEmail(chainId, safeAddress, body, headers) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails", {
        path: {
            chainId: chainId,
            safe_address: safeAddress
        },
        body: body,
        headers: headers
    });
}
module.exports.registerEmail = $59c2c50fee40be62$var$registerEmail;
/**
 * Changes an already registered email address for a safe signer. The new email address still needs to be verified.
 *
 * The signer wallet has to sign a message of format: `email-edit-{chainId}-{safeAddress}-{emailAddress}-{signer}-{timestamp}`
 * The signature is valid for 5 minutes.
 *
 * @param chainId
 * @param safeAddress
 * @param signerAddress
 * @param body New email address
 * @param headers Signature and Signature timestamp
 * @returns 202 if signature matches the data
 */ function $59c2c50fee40be62$var$changeEmail(chainId, safeAddress, signerAddress, body, headers) {
    return (0, $5l9Ls.putEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails/{signer}", {
        path: {
            chainId: chainId,
            safe_address: safeAddress,
            signer: signerAddress
        },
        body: body,
        headers: headers
    });
}
module.exports.changeEmail = $59c2c50fee40be62$var$changeEmail;
/**
 * Resends an email verification code.
 */ function $59c2c50fee40be62$var$resendEmailVerificationCode(chainId, safeAddress, signerAddress) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails/{signer}/verify-resend", {
        path: {
            chainId: chainId,
            safe_address: safeAddress,
            signer: signerAddress
        },
        body: ""
    });
}
module.exports.resendEmailVerificationCode = $59c2c50fee40be62$var$resendEmailVerificationCode;
/**
 * Verifies a pending email address registration.
 *
 * @param chainId
 * @param safeAddress
 * @param signerAddress address who signed the email registration
 * @param body Verification code
 */ function $59c2c50fee40be62$var$verifyEmail(chainId, safeAddress, signerAddress, body) {
    return (0, $5l9Ls.putEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails/{signer}/verify", {
        path: {
            chainId: chainId,
            safe_address: safeAddress,
            signer: signerAddress
        },
        body: body
    });
}
module.exports.verifyEmail = $59c2c50fee40be62$var$verifyEmail;
/**
 * Gets the registered email address of the signer
 *
 * The signer wallet will have to sign a message of format: `email-retrieval-{chainId}-{safe}-{signer}-{timestamp}`
 * The signature is valid for 5 minutes.
 *
 * @param chainId
 * @param safeAddress
 * @param signerAddress address of the owner of the Safe
 *
 * @returns email address and verified flag
 */ function $59c2c50fee40be62$var$getRegisteredEmail(chainId, safeAddress, signerAddress, headers) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails/{signer}", {
        path: {
            chainId: chainId,
            safe_address: safeAddress,
            signer: signerAddress
        },
        headers: headers
    });
}
module.exports.getRegisteredEmail = $59c2c50fee40be62$var$getRegisteredEmail;
/**
 * Delete a registered email address for the signer
 *
 * The signer wallet will have to sign a message of format: `email-delete-{chainId}-{safe}-{signer}-{timestamp}`
 * The signature is valid for 5 minutes.
 *
 * @param chainId
 * @param safeAddress
 * @param signerAddress
 * @param headers
 */ function $59c2c50fee40be62$var$deleteRegisteredEmail(chainId, safeAddress, signerAddress, headers) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/emails/{signer}", {
        path: {
            chainId: chainId,
            safe_address: safeAddress,
            signer: signerAddress
        },
        headers: headers
    });
}
module.exports.deleteRegisteredEmail = $59c2c50fee40be62$var$deleteRegisteredEmail;
/**
 * Register a recovery module for receiving alerts
 * @param chainId
 * @param safeAddress
 * @param body - { moduleAddress: string }
 */ function $59c2c50fee40be62$var$registerRecoveryModule(chainId, safeAddress, body) {
    return (0, $5l9Ls.postEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/recovery", {
        path: {
            chainId: chainId,
            safe_address: safeAddress
        },
        body: body
    });
}
module.exports.registerRecoveryModule = $59c2c50fee40be62$var$registerRecoveryModule;
/**
 * Delete email subscription for a single category
 * @param query
 */ function $59c2c50fee40be62$var$unsubscribeSingle(query) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/subscriptions", {
        query: query
    });
}
module.exports.unsubscribeSingle = $59c2c50fee40be62$var$unsubscribeSingle;
/**
 * Delete email subscription for all categories
 * @param query
 */ function $59c2c50fee40be62$var$unsubscribeAll(query) {
    return (0, $5l9Ls.deleteEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/subscriptions/all", {
        query: query
    });
}
module.exports.unsubscribeAll = $59c2c50fee40be62$var$unsubscribeAll;
/**
 * Get Safe overviews per address
 */ function $59c2c50fee40be62$var$getSafeOverviews(safes, query) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/safes", {
        query: Object.assign(Object.assign({}, query), {
            safes: safes.join(",")
        })
    });
}
module.exports.getSafeOverviews = $59c2c50fee40be62$var$getSafeOverviews;
function $59c2c50fee40be62$var$getContract(chainId, contractAddress) {
    return (0, $5l9Ls.getEndpoint)($59c2c50fee40be62$var$baseUrl, "/v1/chains/{chainId}/contracts/{contractAddress}", {
        path: {
            chainId: chainId,
            contractAddress: contractAddress
        }
    });
}
module.exports.getContract = $59c2c50fee40be62$var$getContract; /* eslint-enable @typescript-eslint/explicit-module-boundary-types */ 

});
parcelRegister("5l9Ls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEndpoint = module.exports.deleteEndpoint = module.exports.putEndpoint = module.exports.postEndpoint = void 0;

var $7JBVZ = parcelRequire("7JBVZ");
function $3e367cefdf7cfb2c$var$makeUrl(baseUrl, path, pathParams, query) {
    const pathname = (0, $7JBVZ.insertParams)(path, pathParams);
    const search = (0, $7JBVZ.stringifyQuery)(query);
    return `${baseUrl}${pathname}${search}`;
}
function $3e367cefdf7cfb2c$var$postEndpoint(baseUrl, path, params) {
    const url = $3e367cefdf7cfb2c$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $7JBVZ.fetchData)(url, "POST", params === null || params === void 0 ? void 0 : params.body, params === null || params === void 0 ? void 0 : params.headers);
}
module.exports.postEndpoint = $3e367cefdf7cfb2c$var$postEndpoint;
function $3e367cefdf7cfb2c$var$putEndpoint(baseUrl, path, params) {
    const url = $3e367cefdf7cfb2c$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $7JBVZ.fetchData)(url, "PUT", params === null || params === void 0 ? void 0 : params.body, params === null || params === void 0 ? void 0 : params.headers);
}
module.exports.putEndpoint = $3e367cefdf7cfb2c$var$putEndpoint;
function $3e367cefdf7cfb2c$var$deleteEndpoint(baseUrl, path, params) {
    const url = $3e367cefdf7cfb2c$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $7JBVZ.fetchData)(url, "DELETE", params === null || params === void 0 ? void 0 : params.body, params === null || params === void 0 ? void 0 : params.headers);
}
module.exports.deleteEndpoint = $3e367cefdf7cfb2c$var$deleteEndpoint;
function $3e367cefdf7cfb2c$var$getEndpoint(baseUrl, path, params, rawUrl) {
    if (rawUrl) return (0, $7JBVZ.getData)(rawUrl);
    const url = $3e367cefdf7cfb2c$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $7JBVZ.getData)(url, params === null || params === void 0 ? void 0 : params.headers);
}
module.exports.getEndpoint = $3e367cefdf7cfb2c$var$getEndpoint;

});
parcelRegister("7JBVZ", function(module, exports) {
"use strict";
var $5a1a295635d52188$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.fetchData = module.exports.stringifyQuery = module.exports.insertParams = void 0;
const $5a1a295635d52188$var$isErrorResponse = (data)=>{
    const isObject = typeof data === "object" && data !== null;
    return isObject && "code" in data && "message" in data;
};
function $5a1a295635d52188$var$replaceParam(str, key, value) {
    return str.replace(new RegExp(`\\{${key}\\}`, "g"), value);
}
function $5a1a295635d52188$var$insertParams(template, params) {
    return params ? Object.keys(params).reduce((result, key)=>{
        return $5a1a295635d52188$var$replaceParam(result, key, String(params[key]));
    }, template) : template;
}
module.exports.insertParams = $5a1a295635d52188$var$insertParams;
function $5a1a295635d52188$var$stringifyQuery(query) {
    if (!query) return "";
    const searchParams = new URLSearchParams();
    Object.keys(query).forEach((key)=>{
        if (query[key] != null) searchParams.append(key, String(query[key]));
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : "";
}
module.exports.stringifyQuery = $5a1a295635d52188$var$stringifyQuery;
function $5a1a295635d52188$var$parseResponse(resp) {
    return $5a1a295635d52188$var$__awaiter(this, void 0, void 0, function*() {
        let json;
        try {
            // An HTTP 204 - No Content response doesn't contain a body so trying to call .json() on it would throw
            json = resp.status === 204 ? {} : yield resp.json();
        } catch (_a) {
            if (resp.headers && resp.headers.get("content-length") !== "0") throw new Error(`Invalid response content: ${resp.statusText}`);
        }
        if (!resp.ok) {
            const errTxt = $5a1a295635d52188$var$isErrorResponse(json) ? `${json.code}: ${json.message}` : resp.statusText;
            throw new Error(errTxt);
        }
        return json;
    });
}
function $5a1a295635d52188$var$fetchData(url, method, body, headers) {
    return $5a1a295635d52188$var$__awaiter(this, void 0, void 0, function*() {
        const requestHeaders = Object.assign({
            "Content-Type": "application/json"
        }, headers);
        const options = {
            method: method !== null && method !== void 0 ? method : "POST",
            headers: requestHeaders
        };
        if (body != null) options.body = typeof body === "string" ? body : JSON.stringify(body);
        const resp = yield fetch(url, options);
        return $5a1a295635d52188$var$parseResponse(resp);
    });
}
module.exports.fetchData = $5a1a295635d52188$var$fetchData;
function $5a1a295635d52188$var$getData(url, headers) {
    return $5a1a295635d52188$var$__awaiter(this, void 0, void 0, function*() {
        const options = {
            method: "GET"
        };
        if (headers) options["headers"] = Object.assign(Object.assign({}, headers), {
            "Content-Type": "application/json"
        });
        const resp = yield fetch(url, options);
        return $5a1a295635d52188$var$parseResponse(resp);
    });
}
module.exports.getData = $5a1a295635d52188$var$getData;

});


parcelRegister("8XN8P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BASE_URL = void 0;
module.exports.DEFAULT_BASE_URL = "https://safe-client.safe.global";

});

parcelRegister("eAtVo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImplementationVersionState = void 0;
var $a9eba3ea099230b0$var$ImplementationVersionState;
(function(ImplementationVersionState) {
    ImplementationVersionState["UP_TO_DATE"] = "UP_TO_DATE";
    ImplementationVersionState["OUTDATED"] = "OUTDATED";
    ImplementationVersionState["UNKNOWN"] = "UNKNOWN";
})($a9eba3ea099230b0$var$ImplementationVersionState = module.exports.ImplementationVersionState || (module.exports.ImplementationVersionState = {}));

});

parcelRegister("eCyp2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppSocialPlatforms = module.exports.SafeAppFeatures = module.exports.SafeAppAccessPolicyTypes = void 0;
var $aa4f4cf8740d5837$var$SafeAppAccessPolicyTypes;
(function(SafeAppAccessPolicyTypes) {
    SafeAppAccessPolicyTypes["NoRestrictions"] = "NO_RESTRICTIONS";
    SafeAppAccessPolicyTypes["DomainAllowlist"] = "DOMAIN_ALLOWLIST";
})($aa4f4cf8740d5837$var$SafeAppAccessPolicyTypes = module.exports.SafeAppAccessPolicyTypes || (module.exports.SafeAppAccessPolicyTypes = {}));
var $aa4f4cf8740d5837$var$SafeAppFeatures;
(function(SafeAppFeatures) {
    SafeAppFeatures["BATCHED_TRANSACTIONS"] = "BATCHED_TRANSACTIONS";
})($aa4f4cf8740d5837$var$SafeAppFeatures = module.exports.SafeAppFeatures || (module.exports.SafeAppFeatures = {}));
var $aa4f4cf8740d5837$var$SafeAppSocialPlatforms;
(function(SafeAppSocialPlatforms) {
    SafeAppSocialPlatforms["TWITTER"] = "TWITTER";
    SafeAppSocialPlatforms["GITHUB"] = "GITHUB";
    SafeAppSocialPlatforms["DISCORD"] = "DISCORD";
})($aa4f4cf8740d5837$var$SafeAppSocialPlatforms = module.exports.SafeAppSocialPlatforms || (module.exports.SafeAppSocialPlatforms = {}));

});

parcelRegister("gVk8C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelValue = module.exports.DetailedExecutionInfoType = module.exports.TransactionListItemType = module.exports.ConflictType = module.exports.TransactionInfoType = module.exports.SettingsInfoType = module.exports.TransactionTokenType = module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.Operation = void 0;
var $c5219733432a36bc$var$Operation;
(function(Operation) {
    Operation[Operation["CALL"] = 0] = "CALL";
    Operation[Operation["DELEGATE"] = 1] = "DELEGATE";
})($c5219733432a36bc$var$Operation = module.exports.Operation || (module.exports.Operation = {}));
var $c5219733432a36bc$var$TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus["AWAITING_CONFIRMATIONS"] = "AWAITING_CONFIRMATIONS";
    TransactionStatus["AWAITING_EXECUTION"] = "AWAITING_EXECUTION";
    TransactionStatus["CANCELLED"] = "CANCELLED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["SUCCESS"] = "SUCCESS";
})($c5219733432a36bc$var$TransactionStatus = module.exports.TransactionStatus || (module.exports.TransactionStatus = {}));
var $c5219733432a36bc$var$TransferDirection;
(function(TransferDirection) {
    TransferDirection["INCOMING"] = "INCOMING";
    TransferDirection["OUTGOING"] = "OUTGOING";
    TransferDirection["UNKNOWN"] = "UNKNOWN";
})($c5219733432a36bc$var$TransferDirection = module.exports.TransferDirection || (module.exports.TransferDirection = {}));
var $c5219733432a36bc$var$TransactionTokenType;
(function(TransactionTokenType) {
    TransactionTokenType["ERC20"] = "ERC20";
    TransactionTokenType["ERC721"] = "ERC721";
    TransactionTokenType["NATIVE_COIN"] = "NATIVE_COIN";
})($c5219733432a36bc$var$TransactionTokenType = module.exports.TransactionTokenType || (module.exports.TransactionTokenType = {}));
var $c5219733432a36bc$var$SettingsInfoType;
(function(SettingsInfoType) {
    SettingsInfoType["SET_FALLBACK_HANDLER"] = "SET_FALLBACK_HANDLER";
    SettingsInfoType["ADD_OWNER"] = "ADD_OWNER";
    SettingsInfoType["REMOVE_OWNER"] = "REMOVE_OWNER";
    SettingsInfoType["SWAP_OWNER"] = "SWAP_OWNER";
    SettingsInfoType["CHANGE_THRESHOLD"] = "CHANGE_THRESHOLD";
    SettingsInfoType["CHANGE_IMPLEMENTATION"] = "CHANGE_IMPLEMENTATION";
    SettingsInfoType["ENABLE_MODULE"] = "ENABLE_MODULE";
    SettingsInfoType["DISABLE_MODULE"] = "DISABLE_MODULE";
    SettingsInfoType["SET_GUARD"] = "SET_GUARD";
    SettingsInfoType["DELETE_GUARD"] = "DELETE_GUARD";
})($c5219733432a36bc$var$SettingsInfoType = module.exports.SettingsInfoType || (module.exports.SettingsInfoType = {}));
var $c5219733432a36bc$var$TransactionInfoType;
(function(TransactionInfoType) {
    TransactionInfoType["TRANSFER"] = "Transfer";
    TransactionInfoType["SETTINGS_CHANGE"] = "SettingsChange";
    TransactionInfoType["CUSTOM"] = "Custom";
    TransactionInfoType["CREATION"] = "Creation";
    TransactionInfoType["SWAP_ORDER"] = "SwapOrder";
})($c5219733432a36bc$var$TransactionInfoType = module.exports.TransactionInfoType || (module.exports.TransactionInfoType = {}));
var $c5219733432a36bc$var$ConflictType;
(function(ConflictType) {
    ConflictType["NONE"] = "None";
    ConflictType["HAS_NEXT"] = "HasNext";
    ConflictType["END"] = "End";
})($c5219733432a36bc$var$ConflictType = module.exports.ConflictType || (module.exports.ConflictType = {}));
var $c5219733432a36bc$var$TransactionListItemType;
(function(TransactionListItemType) {
    TransactionListItemType["TRANSACTION"] = "TRANSACTION";
    TransactionListItemType["LABEL"] = "LABEL";
    TransactionListItemType["CONFLICT_HEADER"] = "CONFLICT_HEADER";
    TransactionListItemType["DATE_LABEL"] = "DATE_LABEL";
})($c5219733432a36bc$var$TransactionListItemType = module.exports.TransactionListItemType || (module.exports.TransactionListItemType = {}));
var $c5219733432a36bc$var$DetailedExecutionInfoType;
(function(DetailedExecutionInfoType) {
    DetailedExecutionInfoType["MULTISIG"] = "MULTISIG";
    DetailedExecutionInfoType["MODULE"] = "MODULE";
})($c5219733432a36bc$var$DetailedExecutionInfoType = module.exports.DetailedExecutionInfoType || (module.exports.DetailedExecutionInfoType = {}));
var $c5219733432a36bc$var$LabelValue;
(function(LabelValue) {
    LabelValue["Queued"] = "Queued";
    LabelValue["Next"] = "Next";
})($c5219733432a36bc$var$LabelValue = module.exports.LabelValue || (module.exports.LabelValue = {}));

});

parcelRegister("cDKVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FEATURES = module.exports.GAS_PRICE_TYPE = module.exports.RPC_AUTHENTICATION = void 0;
var $933d87af4ee7b4d3$var$RPC_AUTHENTICATION;
(function(RPC_AUTHENTICATION) {
    RPC_AUTHENTICATION["API_KEY_PATH"] = "API_KEY_PATH";
    RPC_AUTHENTICATION["NO_AUTHENTICATION"] = "NO_AUTHENTICATION";
    RPC_AUTHENTICATION["UNKNOWN"] = "UNKNOWN";
})($933d87af4ee7b4d3$var$RPC_AUTHENTICATION = module.exports.RPC_AUTHENTICATION || (module.exports.RPC_AUTHENTICATION = {}));
var $933d87af4ee7b4d3$var$GAS_PRICE_TYPE;
(function(GAS_PRICE_TYPE) {
    GAS_PRICE_TYPE["ORACLE"] = "ORACLE";
    GAS_PRICE_TYPE["FIXED"] = "FIXED";
    GAS_PRICE_TYPE["FIXED_1559"] = "FIXED1559";
    GAS_PRICE_TYPE["UNKNOWN"] = "UNKNOWN";
})($933d87af4ee7b4d3$var$GAS_PRICE_TYPE = module.exports.GAS_PRICE_TYPE || (module.exports.GAS_PRICE_TYPE = {}));
var $933d87af4ee7b4d3$var$FEATURES;
(function(FEATURES) {
    FEATURES["ERC721"] = "ERC721";
    FEATURES["SAFE_APPS"] = "SAFE_APPS";
    FEATURES["CONTRACT_INTERACTION"] = "CONTRACT_INTERACTION";
    FEATURES["DOMAIN_LOOKUP"] = "DOMAIN_LOOKUP";
    FEATURES["SPENDING_LIMIT"] = "SPENDING_LIMIT";
    FEATURES["EIP1559"] = "EIP1559";
    FEATURES["SAFE_TX_GAS_OPTIONAL"] = "SAFE_TX_GAS_OPTIONAL";
    FEATURES["TX_SIMULATION"] = "TX_SIMULATION";
    FEATURES["EIP1271"] = "EIP1271";
})($933d87af4ee7b4d3$var$FEATURES = module.exports.FEATURES || (module.exports.FEATURES = {}));

});

parcelRegister("3KuTQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenType = void 0;
var $2bada304734222a3$var$TokenType;
(function(TokenType) {
    TokenType["ERC20"] = "ERC20";
    TokenType["ERC721"] = "ERC721";
    TokenType["NATIVE_TOKEN"] = "NATIVE_TOKEN";
})($2bada304734222a3$var$TokenType = module.exports.TokenType || (module.exports.TokenType = {}));

});

parcelRegister("dHx9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dS903", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cZ1eZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeMessageStatus = module.exports.SafeMessageListItemType = void 0;
var $973c24ee19309130$var$SafeMessageListItemType;
(function(SafeMessageListItemType) {
    SafeMessageListItemType["DATE_LABEL"] = "DATE_LABEL";
    SafeMessageListItemType["MESSAGE"] = "MESSAGE";
})($973c24ee19309130$var$SafeMessageListItemType = module.exports.SafeMessageListItemType || (module.exports.SafeMessageListItemType = {}));
var $973c24ee19309130$var$SafeMessageStatus;
(function(SafeMessageStatus) {
    SafeMessageStatus["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    SafeMessageStatus["CONFIRMED"] = "CONFIRMED";
})($973c24ee19309130$var$SafeMessageStatus = module.exports.SafeMessageStatus || (module.exports.SafeMessageStatus = {}));

});

parcelRegister("dNRxO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeviceType = void 0;
var $a0c962c5e2be321e$var$DeviceType;
(function(DeviceType) {
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["IOS"] = "IOS";
    DeviceType["WEB"] = "WEB";
})($a0c962c5e2be321e$var$DeviceType = module.exports.DeviceType || (module.exports.DeviceType = {}));

});

parcelRegister("fGz9t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("1yaPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


});



parcelRegister("h5Ly4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Eth = void 0;

var $ljXIu = parcelRequire("ljXIu");

var $2XHGr = parcelRequire("2XHGr");
const $c717c972a9e80687$var$inputFormatters = {
    defaultBlockParam: (arg = "latest")=>arg,
    returnFullTxObjectParam: (arg = false)=>arg,
    blockNumberToHex: (arg)=>Number.isInteger(arg) ? `0x${arg.toString(16)}` : arg
};
class $c717c972a9e80687$var$Eth {
    constructor(communicator){
        this.communicator = communicator;
        this.call = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_call,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getBalance = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getBalance,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getCode = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getCode,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getStorageAt = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getStorageAt,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.blockNumberToHex,
                $c717c972a9e80687$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getPastLogs = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getLogs
        });
        this.getBlockByHash = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getBlockByHash,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getBlockByNumber = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getBlockByNumber,
            formatters: [
                $c717c972a9e80687$var$inputFormatters.blockNumberToHex,
                $c717c972a9e80687$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getTransactionByHash = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getTransactionByHash
        });
        this.getTransactionReceipt = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getTransactionReceipt
        });
        this.getTransactionCount = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_getTransactionCount,
            formatters: [
                null,
                $c717c972a9e80687$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getGasPrice = this.buildRequest({
            call: $ljXIu.RPC_CALLS.eth_gasPrice
        });
        this.getEstimateGas = (transaction)=>this.buildRequest({
                call: $ljXIu.RPC_CALLS.eth_estimateGas
            })([
                transaction
            ]);
        this.setSafeSettings = this.buildRequest({
            call: $ljXIu.RPC_CALLS.safe_setSettings
        });
    }
    buildRequest(args) {
        const { call: call, formatters: formatters } = args;
        return async (params)=>{
            if (formatters && Array.isArray(params)) formatters.forEach((formatter, i)=>{
                if (formatter) params[i] = formatter(params[i]);
            });
            const payload = {
                call: call,
                params: params || []
            };
            const response = await this.communicator.send($2XHGr.Methods.rpcCall, payload);
            return response.data;
        };
    }
}
module.exports.Eth = $c717c972a9e80687$var$Eth;

});
parcelRegister("ljXIu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RPC_CALLS = void 0;
module.exports.RPC_CALLS = {
    eth_call: "eth_call",
    eth_gasPrice: "eth_gasPrice",
    eth_getLogs: "eth_getLogs",
    eth_getBalance: "eth_getBalance",
    eth_getCode: "eth_getCode",
    eth_getBlockByHash: "eth_getBlockByHash",
    eth_getBlockByNumber: "eth_getBlockByNumber",
    eth_getStorageAt: "eth_getStorageAt",
    eth_getTransactionByHash: "eth_getTransactionByHash",
    eth_getTransactionReceipt: "eth_getTransactionReceipt",
    eth_getTransactionCount: "eth_getTransactionCount",
    eth_estimateGas: "eth_estimateGas",
    safe_setSettings: "safe_setSettings"
};

});


parcelRegister("5oi5i", function(module, exports) {
"use strict";
var $3ecd38d8a5268b80$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3ecd38d8a5268b80$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safe = void 0;

var $2tMbE = parcelRequire("2tMbE");
var $hJsPq = parcelRequire("hJsPq");
var $behyn = parcelRequire("behyn");

var $btmdr = parcelRequire("btmdr");

var $2XHGr = parcelRequire("2XHGr");

var $ljXIu = parcelRequire("ljXIu");

var $dUSnl = parcelRequire("dUSnl");

const $3ecd38d8a5268b80$var$requirePermissions_1 = $3ecd38d8a5268b80$var$__importDefault((parcelRequire("dowmi")));
class $3ecd38d8a5268b80$var$Safe {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getChainInfo() {
        const response = await this.communicator.send($2XHGr.Methods.getChainInfo, undefined);
        return response.data;
    }
    async getInfo() {
        const response = await this.communicator.send($2XHGr.Methods.getSafeInfo, undefined);
        return response.data;
    }
    // There is a possibility that this method will change because we may add pagination to the endpoint
    async experimental_getBalances({ currency: currency = "usd" } = {}) {
        const response = await this.communicator.send($2XHGr.Methods.getSafeBalances, {
            currency: currency
        });
        return response.data;
    }
    async check1271Signature(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $2tMbE.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: "_dataHash",
                            type: "bytes32"
                        },
                        {
                            name: "_signature",
                            type: "bytes"
                        }
                    ],
                    name: "isValidSignature",
                    outputs: [
                        {
                            name: "",
                            type: "bytes4"
                        }
                    ],
                    payable: false,
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ],
            functionName: "isValidSignature",
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: $ljXIu.RPC_CALLS.eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send($2XHGr.Methods.rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === $btmdr.MAGIC_VALUE;
        } catch (err) {
            return false;
        }
    }
    async check1271SignatureBytes(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $2tMbE.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: "_data",
                            type: "bytes"
                        },
                        {
                            name: "_signature",
                            type: "bytes"
                        }
                    ],
                    name: "isValidSignature",
                    outputs: [
                        {
                            name: "",
                            type: "bytes4"
                        }
                    ],
                    payable: false,
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ],
            functionName: "isValidSignature",
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: $ljXIu.RPC_CALLS.eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send($2XHGr.Methods.rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === $btmdr.MAGIC_VALUE_BYTES;
        } catch (err) {
            return false;
        }
    }
    calculateMessageHash(message) {
        return (0, $hJsPq.hashMessage)(message);
    }
    calculateTypedMessageHash(typedMessage) {
        const chainId = typeof typedMessage.domain.chainId === "object" ? typedMessage.domain.chainId.toNumber() : Number(typedMessage.domain.chainId);
        let primaryType = typedMessage.primaryType;
        if (!primaryType) {
            const fields = Object.values(typedMessage.types);
            // We try to infer primaryType (simplified ether's version)
            const primaryTypes = Object.keys(typedMessage.types).filter((typeName)=>fields.every((dataTypes)=>dataTypes.every(({ type: type })=>type.replace("[", "").replace("]", "") !== typeName)));
            if (primaryTypes.length === 0 || primaryTypes.length > 1) throw new Error("Please specify primaryType");
            primaryType = primaryTypes[0];
        }
        return (0, $behyn.hashTypedData)({
            message: typedMessage.message,
            domain: Object.assign(Object.assign({}, typedMessage.domain), {
                chainId: chainId,
                verifyingContract: typedMessage.domain.verifyingContract,
                salt: typedMessage.domain.salt
            }),
            types: typedMessage.types,
            primaryType: primaryType
        });
    }
    async getOffChainSignature(messageHash) {
        const response = await this.communicator.send($2XHGr.Methods.getOffChainSignature, messageHash);
        return response.data;
    }
    async isMessageSigned(message, signature = "0x") {
        let check;
        if (typeof message === "string") check = async ()=>{
            const messageHash = this.calculateMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if ((0, $dUSnl.isObjectEIP712TypedData)(message)) check = async ()=>{
            const messageHash = this.calculateTypedMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if (check) {
            const isValid = await check();
            return isValid;
        }
        throw new Error("Invalid message type");
    }
    async isMessageHashSigned(messageHash, signature = "0x") {
        const checks = [
            this.check1271Signature.bind(this),
            this.check1271SignatureBytes.bind(this)
        ];
        for (const check of checks){
            const isValid = await check(messageHash, signature);
            if (isValid) return true;
        }
        return false;
    }
    async getEnvironmentInfo() {
        const response = await this.communicator.send($2XHGr.Methods.getEnvironmentInfo, undefined);
        return response.data;
    }
    async requestAddressBook() {
        const response = await this.communicator.send($2XHGr.Methods.requestAddressBook, undefined);
        return response.data;
    }
}
$3ecd38d8a5268b80$var$__decorate([
    (0, $3ecd38d8a5268b80$var$requirePermissions_1.default)()
], $3ecd38d8a5268b80$var$Safe.prototype, "requestAddressBook", null);
module.exports.Safe = $3ecd38d8a5268b80$var$Safe;

});
parcelRegister("btmdr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAGIC_VALUE_BYTES = module.exports.MAGIC_VALUE = void 0;
const $0227ccf295181456$var$MAGIC_VALUE = "0x1626ba7e";
module.exports.MAGIC_VALUE = $0227ccf295181456$var$MAGIC_VALUE;
const $0227ccf295181456$var$MAGIC_VALUE_BYTES = "0x20c13b0b";
module.exports.MAGIC_VALUE_BYTES = $0227ccf295181456$var$MAGIC_VALUE_BYTES;

});

parcelRegister("dowmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gtlfI = parcelRequire("gtlfI");

var $6vZdP = parcelRequire("6vZdP");
const $9c069e00e7b6942c$var$hasPermission = (required, permissions)=>permissions.some((permission)=>permission.parentCapability === required);
const $9c069e00e7b6942c$var$requirePermission = ()=>(_, propertyKey, descriptor)=>{
        const originalMethod = descriptor.value;
        descriptor.value = async function() {
            // @ts-expect-error accessing private property from decorator. 'this' context is the class instance
            const wallet = new $gtlfI.Wallet(this.communicator);
            let currentPermissions = await wallet.getPermissions();
            if (!$9c069e00e7b6942c$var$hasPermission(propertyKey, currentPermissions)) currentPermissions = await wallet.requestPermissions([
                {
                    [propertyKey]: {}
                }
            ]);
            if (!$9c069e00e7b6942c$var$hasPermission(propertyKey, currentPermissions)) throw new $6vZdP.PermissionsError("Permissions rejected", $6vZdP.PERMISSIONS_REQUEST_REJECTED);
            return originalMethod.apply(this);
        };
        return descriptor;
    };
module.exports.default = $9c069e00e7b6942c$var$requirePermission;

});
parcelRegister("gtlfI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Wallet = void 0;

var $2XHGr = parcelRequire("2XHGr");

var $6vZdP = parcelRequire("6vZdP");
class $bfdfd71676c22786$var$Wallet {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getPermissions() {
        const response = await this.communicator.send($2XHGr.Methods.wallet_getPermissions, undefined);
        return response.data;
    }
    async requestPermissions(permissions) {
        if (!this.isPermissionRequestValid(permissions)) throw new $6vZdP.PermissionsError("Permissions request is invalid", $6vZdP.PERMISSIONS_REQUEST_REJECTED);
        try {
            const response = await this.communicator.send($2XHGr.Methods.wallet_requestPermissions, permissions);
            return response.data;
        } catch (_a) {
            throw new $6vZdP.PermissionsError("Permissions rejected", $6vZdP.PERMISSIONS_REQUEST_REJECTED);
        }
    }
    isPermissionRequestValid(permissions) {
        return permissions.every((pr)=>{
            if (typeof pr === "object") return Object.keys(pr).every((method)=>{
                if (Object.values($2XHGr.RestrictedMethods).includes(method)) return true;
                return false;
            });
            return false;
        });
    }
}
module.exports.Wallet = $bfdfd71676c22786$var$Wallet;

});
parcelRegister("6vZdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermissionsError = module.exports.PERMISSIONS_REQUEST_REJECTED = void 0;
module.exports.PERMISSIONS_REQUEST_REJECTED = 4001;
class $4be520bcaf87f352$var$PermissionsError extends Error {
    constructor(message, code, data){
        super(message);
        this.code = code;
        this.data = data;
        // Should adjust prototype manually because how TS handles the type extension compilation
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4be520bcaf87f352$var$PermissionsError.prototype);
    }
}
module.exports.PermissionsError = $4be520bcaf87f352$var$PermissionsError;

});





parcelRegister("6QZmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd732d63770d67b$export$8536778e426ddf92);

var $yaQUM = parcelRequire("yaQUM");

var $j9eXz = parcelRequire("j9eXz");

var $3zoS2 = parcelRequire("3zoS2");
function $4fd732d63770d67b$var$C(i) {
    return i;
}
const $4fd732d63770d67b$var$x = "idb-keyval";
var $4fd732d63770d67b$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $j9eXz.createStore)(i.dbName, i.storeName)), {
        name: $4fd732d63770d67b$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $j9eXz.get)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $j9eXz.get)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $j9eXz.set)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $j9eXz.del)(e(s), n);
        },
        getKeys () {
            return (0, $j9eXz.keys)(n);
        },
        clear () {
            return (0, $j9eXz.clear)(n);
        }
    };
};
const $4fd732d63770d67b$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $4fd732d63770d67b$var$E = "keyvaluestorage";
class $4fd732d63770d67b$var$_ {
    constructor(){
        this.indexedDb = (0, $yaQUM.createStorage)({
            driver: $4fd732d63770d67b$var$z({
                dbName: $4fd732d63770d67b$var$D,
                storeName: $4fd732d63770d67b$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $3zoS2.safeJsonStringify)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $4fd732d63770d67b$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $4fd732d63770d67b$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $4fd732d63770d67b$var$l < "u" && $4fd732d63770d67b$var$l.localStorage ? $4fd732d63770d67b$var$c.exports = $4fd732d63770d67b$var$l.localStorage : typeof window < "u" && window.localStorage ? $4fd732d63770d67b$var$c.exports = window.localStorage : $4fd732d63770d67b$var$c.exports = new t;
})();
function $4fd732d63770d67b$var$k(i) {
    var t;
    return [
        i[0],
        (0, $3zoS2.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
class $4fd732d63770d67b$var$K {
    constructor(){
        this.localStorage = $4fd732d63770d67b$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($4fd732d63770d67b$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $3zoS2.safeJsonParse)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $3zoS2.safeJsonStringify)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $4fd732d63770d67b$var$N = "wc_storage_version", $4fd732d63770d67b$var$y = 1, $4fd732d63770d67b$var$O = async (i, t, e)=>{
    const n = $4fd732d63770d67b$var$N, s = await t.getItem(n);
    if (s && s >= $4fd732d63770d67b$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $4fd732d63770d67b$var$y), e(t), $4fd732d63770d67b$var$j(i, m);
}, $4fd732d63770d67b$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $4fd732d63770d67b$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $4fd732d63770d67b$var$K;
        this.storage = t;
        try {
            const e = new $4fd732d63770d67b$var$_;
            $4fd732d63770d67b$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}

});
parcelRegister("yaQUM", function(module, exports) {

$parcel$export(module.exports, "createStorage", () => $7a4de6a0d21e56c8$export$d184a47a971dd4b9);

var $dadYX = parcelRequire("dadYX");

var $5Eeb8 = parcelRequire("5Eeb8");
function $7a4de6a0d21e56c8$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $7a4de6a0d21e56c8$var$DRIVER_NAME = "memory";
const $7a4de6a0d21e56c8$var$memory = $7a4de6a0d21e56c8$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $7a4de6a0d21e56c8$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $7a4de6a0d21e56c8$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $7a4de6a0d21e56c8$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $5Eeb8.a)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $7a4de6a0d21e56c8$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $5Eeb8.a)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $5Eeb8.b)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $5Eeb8.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $dadYX.default)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $5Eeb8.b)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $5Eeb8.j)(batch.base, item.key),
                            value: (0, $dadYX.default)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $5Eeb8.b)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $dadYX.default)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $5Eeb8.b)(driver.getItemRaw, relativeKey, opts);
            return (0, $5Eeb8.b)(driver.getItem, relativeKey, opts).then((value)=>(0, $5Eeb8.d)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $5Eeb8.b)(driver.setItem, relativeKey, (0, $5Eeb8.s)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, $5Eeb8.b)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $5Eeb8.s)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $5Eeb8.b)(batch.driver.setItem, item.relativeKey, (0, $5Eeb8.s)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $5Eeb8.b)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $5Eeb8.b)(driver.setItem, relativeKey, (0, $5Eeb8.c)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $5Eeb8.b)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $5Eeb8.b)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $5Eeb8.a)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $5Eeb8.b)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $5Eeb8.b)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $dadYX.default)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $5Eeb8.n)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $5Eeb8.b)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $5Eeb8.a)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $5Eeb8.n)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $5Eeb8.b)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$7a4de6a0d21e56c8$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $5Eeb8.n)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($7a4de6a0d21e56c8$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $5Eeb8.n)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $7a4de6a0d21e56c8$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $5Eeb8.a)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $5Eeb8.a)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $7a4de6a0d21e56c8$export$b8801ea43165ed7d(storage, base) {
    base = (0, $5Eeb8.n)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $7a4de6a0d21e56c8$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $5Eeb8.n)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $7a4de6a0d21e56c8$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $7a4de6a0d21e56c8$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $5Eeb8.b)(driver.dispose);
}
const $7a4de6a0d21e56c8$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};

});
parcelRegister("dadYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b83f8ec10073325e$export$2e2bcd8739ae039);
const $b83f8ec10073325e$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $b83f8ec10073325e$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $b83f8ec10073325e$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $b83f8ec10073325e$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $b83f8ec10073325e$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $b83f8ec10073325e$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $b83f8ec10073325e$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$b83f8ec10073325e$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($b83f8ec10073325e$var$suspectProtoRx.test(value) || $b83f8ec10073325e$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $b83f8ec10073325e$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $b83f8ec10073325e$export$4b2a7c187ff4b28c(value, options = {}) {
    return $b83f8ec10073325e$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}

});

parcelRegister("5Eeb8", function(module, exports) {

$parcel$export(module.exports, "b", () => $fc0f0ecfc87b4500$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "s", () => $fc0f0ecfc87b4500$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "c", () => $fc0f0ecfc87b4500$export$db3b6bfb95261072);
$parcel$export(module.exports, "d", () => $fc0f0ecfc87b4500$export$4368d992c4eafac0);
$parcel$export(module.exports, "n", () => $fc0f0ecfc87b4500$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "a", () => $fc0f0ecfc87b4500$export$407448d2b89b1813);
$parcel$export(module.exports, "j", () => $fc0f0ecfc87b4500$export$35e795649ee09318);

var $7ts9d = parcelRequire("7ts9d");
var $fc0f0ecfc87b4500$require$Buffer = $7ts9d.Buffer;
function $fc0f0ecfc87b4500$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $fc0f0ecfc87b4500$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $fc0f0ecfc87b4500$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $fc0f0ecfc87b4500$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $fc0f0ecfc87b4500$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $fc0f0ecfc87b4500$export$2408f22a0fab9ae5(value) {
    if ($fc0f0ecfc87b4500$var$isPrimitive(value)) return String(value);
    if ($fc0f0ecfc87b4500$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $fc0f0ecfc87b4500$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $fc0f0ecfc87b4500$var$checkBufferSupport() {}
const $fc0f0ecfc87b4500$var$BASE64_PREFIX = "base64:";
function $fc0f0ecfc87b4500$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $fc0f0ecfc87b4500$var$checkBufferSupport();
    const base64 = $fc0f0ecfc87b4500$require$Buffer.from(value).toString("base64");
    return $fc0f0ecfc87b4500$var$BASE64_PREFIX + base64;
}
function $fc0f0ecfc87b4500$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($fc0f0ecfc87b4500$var$BASE64_PREFIX)) return value;
    $fc0f0ecfc87b4500$var$checkBufferSupport();
    return $fc0f0ecfc87b4500$require$Buffer.from(value.slice($fc0f0ecfc87b4500$var$BASE64_PREFIX.length), "base64");
}
const $fc0f0ecfc87b4500$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $fc0f0ecfc87b4500$export$ffb5f4729a158638(storage, base) {
    base = $fc0f0ecfc87b4500$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $fc0f0ecfc87b4500$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $fc0f0ecfc87b4500$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $fc0f0ecfc87b4500$export$35e795649ee09318(...keys) {
    return $fc0f0ecfc87b4500$export$407448d2b89b1813(keys.join(":"));
}
function $fc0f0ecfc87b4500$export$7ccc53e8f1e7dfc5(base) {
    base = $fc0f0ecfc87b4500$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}

});


parcelRegister("j9eXz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $df0a764f2d127735$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $df0a764f2d127735$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $df0a764f2d127735$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "del", () => $df0a764f2d127735$export$1d2f21e549771e67);
$parcel$export(module.exports, "clear", () => $df0a764f2d127735$export$42ffd38884aecdac);
$parcel$export(module.exports, "keys", () => $df0a764f2d127735$export$ed97f33186d4b816);
function $df0a764f2d127735$var$_slicedToArray(arr, i) {
    return $df0a764f2d127735$var$_arrayWithHoles(arr) || $df0a764f2d127735$var$_iterableToArrayLimit(arr, i) || $df0a764f2d127735$var$_unsupportedIterableToArray(arr, i) || $df0a764f2d127735$var$_nonIterableRest();
}
function $df0a764f2d127735$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $df0a764f2d127735$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $df0a764f2d127735$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $df0a764f2d127735$var$_arrayLikeToArray(o, minLen);
}
function $df0a764f2d127735$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $df0a764f2d127735$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $df0a764f2d127735$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $df0a764f2d127735$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $df0a764f2d127735$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $df0a764f2d127735$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $df0a764f2d127735$var$defaultGetStoreFunc;
function $df0a764f2d127735$var$defaultGetStore() {
    if (!$df0a764f2d127735$var$defaultGetStoreFunc) $df0a764f2d127735$var$defaultGetStoreFunc = $df0a764f2d127735$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $df0a764f2d127735$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $df0a764f2d127735$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $df0a764f2d127735$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($df0a764f2d127735$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
    });
}
function $df0a764f2d127735$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $df0a764f2d127735$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $df0a764f2d127735$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $df0a764f2d127735$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $df0a764f2d127735$export$b327150396135fe7(store.getAll());
        var items = [];
        return $df0a764f2d127735$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $df0a764f2d127735$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $df0a764f2d127735$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $df0a764f2d127735$export$b327150396135fe7(store.getAllKeys()),
            $df0a764f2d127735$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $df0a764f2d127735$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $df0a764f2d127735$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}

});

parcelRegister("3zoS2", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", () => $2997eec4d0f20e22$export$84137bb44359aed5);
$parcel$export(module.exports, "safeJsonStringify", () => $2997eec4d0f20e22$export$abc3f407e87918a4);
const $2997eec4d0f20e22$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $2997eec4d0f20e22$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $2997eec4d0f20e22$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $2997eec4d0f20e22$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $2997eec4d0f20e22$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $2997eec4d0f20e22$var$JSONStringify(value) || "";
}

});


parcelRegister("fiZ0l", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("69EOo")).IEvents);
parcelRequire("69EOo");

});
parcelRegister("69EOo", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $47b33db424d356de$export$ab429ec7e240e546);
class $47b33db424d356de$export$ab429ec7e240e546 {
}

});


parcelRegister("c8Vuh", function(module, exports) {

$parcel$export(module.exports, "getDefaultLoggerOptions", () => $8d72d32fd749e5ab$export$bad2475df51c8ecc);
$parcel$export(module.exports, "getLoggerContext", () => $8d72d32fd749e5ab$export$a283a9a0054a3c25);
$parcel$export(module.exports, "generateChildLogger", () => $8d72d32fd749e5ab$export$4929e0372308a636);
$parcel$export(module.exports, "generatePlatformLogger", () => $8d72d32fd749e5ab$export$15eba7fb5aaf9303);
$parcel$export(module.exports, "pino", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("77JzN")))));

var $77JzN = parcelRequire("77JzN");

var $3zoS2 = parcelRequire("3zoS2");
const $8d72d32fd749e5ab$export$341ee22b43fe3f8e = {
    level: "info"
}, $8d72d32fd749e5ab$export$fdd446d41f74bf3a = "custom_context", $8d72d32fd749e5ab$export$64bef9d49cc9288f = 1024000;
class $8d72d32fd749e5ab$var$O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class $8d72d32fd749e5ab$var$d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new $8d72d32fd749e5ab$var$O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class $8d72d32fd749e5ab$var$L {
    constructor(e, t = $8d72d32fd749e5ab$export$64bef9d49cc9288f){
        this.level = e ?? "error", this.levelValue = (0, $77JzN.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $8d72d32fd749e5ab$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, $77JzN.levels).values.error ? console.error(e) : t === (0, $77JzN.levels).values.warn ? console.warn(e) : t === (0, $77JzN.levels).values.debug ? console.debug(e) : t === (0, $77JzN.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, $3zoS2.safeJsonStringify)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new $8d72d32fd749e5ab$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, $3zoS2.safeJsonStringify)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class $8d72d32fd749e5ab$var$m {
    constructor(e, t = $8d72d32fd749e5ab$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $8d72d32fd749e5ab$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class $8d72d32fd749e5ab$var$B {
    constructor(e, t = $8d72d32fd749e5ab$export$64bef9d49cc9288f){
        this.baseChunkLogger = new $8d72d32fd749e5ab$var$L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var $8d72d32fd749e5ab$var$x = Object.defineProperty, $8d72d32fd749e5ab$var$S = Object.defineProperties, $8d72d32fd749e5ab$var$_ = Object.getOwnPropertyDescriptors, $8d72d32fd749e5ab$var$p = Object.getOwnPropertySymbols, $8d72d32fd749e5ab$var$T = Object.prototype.hasOwnProperty, $8d72d32fd749e5ab$var$z = Object.prototype.propertyIsEnumerable, $8d72d32fd749e5ab$var$f = (r, e, t)=>e in r ? $8d72d32fd749e5ab$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $8d72d32fd749e5ab$var$i = (r, e)=>{
    for(var t in e || (e = {}))$8d72d32fd749e5ab$var$T.call(e, t) && $8d72d32fd749e5ab$var$f(r, t, e[t]);
    if ($8d72d32fd749e5ab$var$p) for (var t of $8d72d32fd749e5ab$var$p(e))$8d72d32fd749e5ab$var$z.call(e, t) && $8d72d32fd749e5ab$var$f(r, t, e[t]);
    return r;
}, $8d72d32fd749e5ab$var$g = (r, e)=>$8d72d32fd749e5ab$var$S(r, $8d72d32fd749e5ab$var$_(e));
function $8d72d32fd749e5ab$export$bad2475df51c8ecc(r) {
    return $8d72d32fd749e5ab$var$g($8d72d32fd749e5ab$var$i({}, r), {
        level: r?.level || $8d72d32fd749e5ab$export$341ee22b43fe3f8e.level
    });
}
function $8d72d32fd749e5ab$export$e8faae0482d84e9e(r, e = $8d72d32fd749e5ab$export$fdd446d41f74bf3a) {
    return r[e] || "";
}
function $8d72d32fd749e5ab$export$758f352b7265b00e(r, e, t = $8d72d32fd749e5ab$export$fdd446d41f74bf3a) {
    return r[t] = e, r;
}
function $8d72d32fd749e5ab$export$a283a9a0054a3c25(r, e = $8d72d32fd749e5ab$export$fdd446d41f74bf3a) {
    let t = "";
    return typeof r.bindings > "u" ? t = $8d72d32fd749e5ab$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $8d72d32fd749e5ab$export$307261146df20465(r, e, t = $8d72d32fd749e5ab$export$fdd446d41f74bf3a) {
    const o = $8d72d32fd749e5ab$export$a283a9a0054a3c25(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function $8d72d32fd749e5ab$export$4929e0372308a636(r, e, t = $8d72d32fd749e5ab$export$fdd446d41f74bf3a) {
    const o = $8d72d32fd749e5ab$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $8d72d32fd749e5ab$export$758f352b7265b00e(a, o, t);
}
function $8d72d32fd749e5ab$export$2ca1453636a43a7(r) {
    var e, t;
    const o = new $8d72d32fd749e5ab$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($77JzN)))($8d72d32fd749e5ab$var$g($8d72d32fd749e5ab$var$i({}, r.opts), {
            level: "trace",
            browser: $8d72d32fd749e5ab$var$g($8d72d32fd749e5ab$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function $8d72d32fd749e5ab$export$495ac2973e46cb97(r) {
    var e;
    const t = new $8d72d32fd749e5ab$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($77JzN)))($8d72d32fd749e5ab$var$g($8d72d32fd749e5ab$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $8d72d32fd749e5ab$export$15eba7fb5aaf9303(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? $8d72d32fd749e5ab$export$2ca1453636a43a7(r) : $8d72d32fd749e5ab$export$495ac2973e46cb97(r);
}

});
parcelRegister("77JzN", function(module, exports) {
"use strict";

var $lOF4L = parcelRequire("lOF4L");
module.exports = $52fc8a62b98df7a3$var$pino;
const $52fc8a62b98df7a3$var$_console = $52fc8a62b98df7a3$var$pfGlobalThisOrFallback().console || {};
const $52fc8a62b98df7a3$var$stdSerializers = {
    mapHttpRequest: $52fc8a62b98df7a3$var$mock,
    mapHttpResponse: $52fc8a62b98df7a3$var$mock,
    wrapRequestSerializer: $52fc8a62b98df7a3$var$passthrough,
    wrapResponseSerializer: $52fc8a62b98df7a3$var$passthrough,
    wrapErrorSerializer: $52fc8a62b98df7a3$var$passthrough,
    req: $52fc8a62b98df7a3$var$mock,
    res: $52fc8a62b98df7a3$var$mock,
    err: $52fc8a62b98df7a3$var$asErrValue
};
function $52fc8a62b98df7a3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $52fc8a62b98df7a3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $52fc8a62b98df7a3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $52fc8a62b98df7a3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $52fc8a62b98df7a3$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $52fc8a62b98df7a3$var$getTimeFunction(opts)
    };
    logger.levels = $52fc8a62b98df7a3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $52fc8a62b98df7a3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $52fc8a62b98df7a3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $52fc8a62b98df7a3$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $52fc8a62b98df7a3$var$set(setOpts, logger, "fatal", "error");
        $52fc8a62b98df7a3$var$set(setOpts, logger, "warn", "error");
        $52fc8a62b98df7a3$var$set(setOpts, logger, "info", "log");
        $52fc8a62b98df7a3$var$set(setOpts, logger, "debug", "log");
        $52fc8a62b98df7a3$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $52fc8a62b98df7a3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $52fc8a62b98df7a3$var$bind(parent, bindings, "error");
            this.fatal = $52fc8a62b98df7a3$var$bind(parent, bindings, "fatal");
            this.warn = $52fc8a62b98df7a3$var$bind(parent, bindings, "warn");
            this.info = $52fc8a62b98df7a3$var$bind(parent, bindings, "info");
            this.debug = $52fc8a62b98df7a3$var$bind(parent, bindings, "debug");
            this.trace = $52fc8a62b98df7a3$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $52fc8a62b98df7a3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$52fc8a62b98df7a3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$52fc8a62b98df7a3$var$pino.stdSerializers = $52fc8a62b98df7a3$var$stdSerializers;
$52fc8a62b98df7a3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $52fc8a62b98df7a3$var$nullTime,
    epochTime: $52fc8a62b98df7a3$var$epochTime,
    unixTime: $52fc8a62b98df7a3$var$unixTime,
    isoTime: $52fc8a62b98df7a3$var$isoTime
});
function $52fc8a62b98df7a3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $52fc8a62b98df7a3$var$noop : proto[level] ? proto[level] : $52fc8a62b98df7a3$var$_console[level] || $52fc8a62b98df7a3$var$_console[fallback] || $52fc8a62b98df7a3$var$noop;
    $52fc8a62b98df7a3$var$wrap(opts, logger, level);
}
function $52fc8a62b98df7a3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $52fc8a62b98df7a3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $52fc8a62b98df7a3$var$_console ? $52fc8a62b98df7a3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $52fc8a62b98df7a3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $52fc8a62b98df7a3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $52fc8a62b98df7a3$var$pino.levels.values[transmitLevel];
                const methodValue = $52fc8a62b98df7a3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $52fc8a62b98df7a3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $52fc8a62b98df7a3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $52fc8a62b98df7a3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $52fc8a62b98df7a3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $52fc8a62b98df7a3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $lOF4L(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $lOF4L(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $52fc8a62b98df7a3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $52fc8a62b98df7a3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $52fc8a62b98df7a3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $52fc8a62b98df7a3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $52fc8a62b98df7a3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $52fc8a62b98df7a3$var$createLogEventShape(bindings);
}
function $52fc8a62b98df7a3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $52fc8a62b98df7a3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $52fc8a62b98df7a3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $52fc8a62b98df7a3$var$nullTime;
    return $52fc8a62b98df7a3$var$epochTime;
}
function $52fc8a62b98df7a3$var$mock() {
    return {};
}
function $52fc8a62b98df7a3$var$passthrough(a) {
    return a;
}
function $52fc8a62b98df7a3$var$noop() {}
function $52fc8a62b98df7a3$var$nullTime() {
    return false;
}
function $52fc8a62b98df7a3$var$epochTime() {
    return Date.now();
}
function $52fc8a62b98df7a3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $52fc8a62b98df7a3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $52fc8a62b98df7a3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("lOF4L", function(module, exports) {
"use strict";
function $fe1e214fe8fab2ca$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $fe1e214fe8fab2ca$var$format;
function $fe1e214fe8fab2ca$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $fe1e214fe8fab2ca$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});



parcelRegister("k2pOm", function(module, exports) {
$parcel$export(module.exports, "generateKeyPair", () => (parcelRequire("lDjQh")).generateKeyPair);
$parcel$export(module.exports, "signJWT", () => (parcelRequire("lDjQh")).signJWT);
$parcel$export(module.exports, "encodeIss", () => (parcelRequire("4LcoU")).encodeIss);
parcelRequire("lDjQh");
parcelRequire("dT4aR");

var $h6KoW = parcelRequire("h6KoW");
parcelRequire("4LcoU");
$parcel$exportWildcard(module.exports, $h6KoW);

});
parcelRegister("lDjQh", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $fbfca1b9738d19ff$export$a949d36eab55b41f);
$parcel$export(module.exports, "signJWT", () => $fbfca1b9738d19ff$export$a8dda30659d36d45);

var $5IZIm = parcelRequire("5IZIm");

var $lYmee = parcelRequire("lYmee");

var $8Yg5s = parcelRequire("8Yg5s");

var $dT4aR = parcelRequire("dT4aR");

var $4LcoU = parcelRequire("4LcoU");
function $fbfca1b9738d19ff$export$a949d36eab55b41f(seed = (0, $lYmee.randomBytes)((0, $dT4aR.KEY_PAIR_SEED_LENGTH))) {
    return $5IZIm.generateKeyPairFromSeed(seed);
}
async function $fbfca1b9738d19ff$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $8Yg5s.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $dT4aR.JWT_IRIDIUM_ALG),
        typ: (0, $dT4aR.JWT_IRIDIUM_TYP)
    };
    const iss = (0, $4LcoU.encodeIss)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $4LcoU.encodeData)({
        header: header,
        payload: payload
    });
    const signature = $5IZIm.sign(keyPair.secretKey, data);
    return (0, $4LcoU.encodeJWT)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $fbfca1b9738d19ff$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $4LcoU.decodeJWT)(jwt);
    if (header.alg !== (0, $dT4aR.JWT_IRIDIUM_ALG) || header.typ !== (0, $dT4aR.JWT_IRIDIUM_TYP)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $4LcoU.decodeIss)(payload.iss);
    return $5IZIm.verify(publicKey, data, signature);
}

});
parcelRegister("5IZIm", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertSecretKeyToX25519 = module.exports.convertPublicKeyToX25519 = module.exports.verify = module.exports.sign = module.exports.extractPublicKeyFromSecretKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.SEED_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = module.exports.SIGNATURE_LENGTH = void 0;

var $lYmee = parcelRequire("lYmee");

var $16b1U = parcelRequire("16b1U");

var $7ks5V = parcelRequire("7ks5V");
module.exports.SIGNATURE_LENGTH = 64;
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 64;
module.exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $42b0ef01b4702b20$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $42b0ef01b4702b20$var$_9 = new Uint8Array(32);
$42b0ef01b4702b20$var$_9[0] = 9;
const $42b0ef01b4702b20$var$gf0 = $42b0ef01b4702b20$var$gf();
const $42b0ef01b4702b20$var$gf1 = $42b0ef01b4702b20$var$gf([
    1
]);
const $42b0ef01b4702b20$var$D = $42b0ef01b4702b20$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $42b0ef01b4702b20$var$D2 = $42b0ef01b4702b20$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $42b0ef01b4702b20$var$X = $42b0ef01b4702b20$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $42b0ef01b4702b20$var$Y = $42b0ef01b4702b20$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $42b0ef01b4702b20$var$I = $42b0ef01b4702b20$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $42b0ef01b4702b20$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $42b0ef01b4702b20$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $42b0ef01b4702b20$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $42b0ef01b4702b20$var$pack25519(o, n) {
    const m = $42b0ef01b4702b20$var$gf();
    const t = $42b0ef01b4702b20$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $42b0ef01b4702b20$var$car25519(t);
    $42b0ef01b4702b20$var$car25519(t);
    $42b0ef01b4702b20$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $42b0ef01b4702b20$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $42b0ef01b4702b20$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $42b0ef01b4702b20$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $42b0ef01b4702b20$var$pack25519(c, a);
    $42b0ef01b4702b20$var$pack25519(d, b);
    return $42b0ef01b4702b20$var$verify32(c, d);
}
function $42b0ef01b4702b20$var$par25519(a) {
    const d = new Uint8Array(32);
    $42b0ef01b4702b20$var$pack25519(d, a);
    return d[0] & 1;
}
function $42b0ef01b4702b20$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $42b0ef01b4702b20$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $42b0ef01b4702b20$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $42b0ef01b4702b20$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $42b0ef01b4702b20$var$square(o, a) {
    $42b0ef01b4702b20$var$mul(o, a, a);
}
function $42b0ef01b4702b20$var$inv25519(o, i) {
    const c = $42b0ef01b4702b20$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $42b0ef01b4702b20$var$square(c, c);
        if (a !== 2 && a !== 4) $42b0ef01b4702b20$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $42b0ef01b4702b20$var$pow2523(o, i) {
    const c = $42b0ef01b4702b20$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $42b0ef01b4702b20$var$square(c, c);
        if (a !== 1) $42b0ef01b4702b20$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $42b0ef01b4702b20$var$edadd(p, q) {
    const a = $42b0ef01b4702b20$var$gf(), b = $42b0ef01b4702b20$var$gf(), c = $42b0ef01b4702b20$var$gf(), d = $42b0ef01b4702b20$var$gf(), e = $42b0ef01b4702b20$var$gf(), f = $42b0ef01b4702b20$var$gf(), g = $42b0ef01b4702b20$var$gf(), h = $42b0ef01b4702b20$var$gf(), t = $42b0ef01b4702b20$var$gf();
    $42b0ef01b4702b20$var$sub(a, p[1], p[0]);
    $42b0ef01b4702b20$var$sub(t, q[1], q[0]);
    $42b0ef01b4702b20$var$mul(a, a, t);
    $42b0ef01b4702b20$var$add(b, p[0], p[1]);
    $42b0ef01b4702b20$var$add(t, q[0], q[1]);
    $42b0ef01b4702b20$var$mul(b, b, t);
    $42b0ef01b4702b20$var$mul(c, p[3], q[3]);
    $42b0ef01b4702b20$var$mul(c, c, $42b0ef01b4702b20$var$D2);
    $42b0ef01b4702b20$var$mul(d, p[2], q[2]);
    $42b0ef01b4702b20$var$add(d, d, d);
    $42b0ef01b4702b20$var$sub(e, b, a);
    $42b0ef01b4702b20$var$sub(f, d, c);
    $42b0ef01b4702b20$var$add(g, d, c);
    $42b0ef01b4702b20$var$add(h, b, a);
    $42b0ef01b4702b20$var$mul(p[0], e, f);
    $42b0ef01b4702b20$var$mul(p[1], h, g);
    $42b0ef01b4702b20$var$mul(p[2], g, f);
    $42b0ef01b4702b20$var$mul(p[3], e, h);
}
function $42b0ef01b4702b20$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$42b0ef01b4702b20$var$sel25519(p[i], q[i], b);
}
function $42b0ef01b4702b20$var$pack(r, p) {
    const tx = $42b0ef01b4702b20$var$gf(), ty = $42b0ef01b4702b20$var$gf(), zi = $42b0ef01b4702b20$var$gf();
    $42b0ef01b4702b20$var$inv25519(zi, p[2]);
    $42b0ef01b4702b20$var$mul(tx, p[0], zi);
    $42b0ef01b4702b20$var$mul(ty, p[1], zi);
    $42b0ef01b4702b20$var$pack25519(r, ty);
    r[31] ^= $42b0ef01b4702b20$var$par25519(tx) << 7;
}
function $42b0ef01b4702b20$var$scalarmult(p, q, s) {
    $42b0ef01b4702b20$var$set25519(p[0], $42b0ef01b4702b20$var$gf0);
    $42b0ef01b4702b20$var$set25519(p[1], $42b0ef01b4702b20$var$gf1);
    $42b0ef01b4702b20$var$set25519(p[2], $42b0ef01b4702b20$var$gf1);
    $42b0ef01b4702b20$var$set25519(p[3], $42b0ef01b4702b20$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $42b0ef01b4702b20$var$cswap(p, q, b);
        $42b0ef01b4702b20$var$edadd(q, p);
        $42b0ef01b4702b20$var$edadd(p, p);
        $42b0ef01b4702b20$var$cswap(p, q, b);
    }
}
function $42b0ef01b4702b20$var$scalarbase(p, s) {
    const q = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    $42b0ef01b4702b20$var$set25519(q[0], $42b0ef01b4702b20$var$X);
    $42b0ef01b4702b20$var$set25519(q[1], $42b0ef01b4702b20$var$Y);
    $42b0ef01b4702b20$var$set25519(q[2], $42b0ef01b4702b20$var$gf1);
    $42b0ef01b4702b20$var$mul(q[3], $42b0ef01b4702b20$var$X, $42b0ef01b4702b20$var$Y);
    $42b0ef01b4702b20$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $42b0ef01b4702b20$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${module.exports.SEED_LENGTH} bytes`);
    const d = (0, $16b1U.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    $42b0ef01b4702b20$var$scalarbase(p, d);
    $42b0ef01b4702b20$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $42b0ef01b4702b20$var$generateKeyPairFromSeed;
function $42b0ef01b4702b20$var$generateKeyPair(prng) {
    const seed = (0, $lYmee.randomBytes)(32, prng);
    const result = $42b0ef01b4702b20$var$generateKeyPairFromSeed(seed);
    (0, $7ks5V.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $42b0ef01b4702b20$var$generateKeyPair;
function $42b0ef01b4702b20$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
module.exports.extractPublicKeyFromSecretKey = $42b0ef01b4702b20$var$extractPublicKeyFromSecretKey;
const $42b0ef01b4702b20$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $42b0ef01b4702b20$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $42b0ef01b4702b20$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $42b0ef01b4702b20$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $42b0ef01b4702b20$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $42b0ef01b4702b20$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $42b0ef01b4702b20$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $42b0ef01b4702b20$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    const d = (0, $16b1U.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $16b1U.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $42b0ef01b4702b20$var$reduce(r);
    $42b0ef01b4702b20$var$scalarbase(p, r);
    $42b0ef01b4702b20$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $42b0ef01b4702b20$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $42b0ef01b4702b20$var$modL(signature.subarray(32), x);
    return signature;
}
module.exports.sign = $42b0ef01b4702b20$var$sign;
function $42b0ef01b4702b20$var$unpackneg(r, p) {
    const t = $42b0ef01b4702b20$var$gf(), chk = $42b0ef01b4702b20$var$gf(), num = $42b0ef01b4702b20$var$gf(), den = $42b0ef01b4702b20$var$gf(), den2 = $42b0ef01b4702b20$var$gf(), den4 = $42b0ef01b4702b20$var$gf(), den6 = $42b0ef01b4702b20$var$gf();
    $42b0ef01b4702b20$var$set25519(r[2], $42b0ef01b4702b20$var$gf1);
    $42b0ef01b4702b20$var$unpack25519(r[1], p);
    $42b0ef01b4702b20$var$square(num, r[1]);
    $42b0ef01b4702b20$var$mul(den, num, $42b0ef01b4702b20$var$D);
    $42b0ef01b4702b20$var$sub(num, num, r[2]);
    $42b0ef01b4702b20$var$add(den, r[2], den);
    $42b0ef01b4702b20$var$square(den2, den);
    $42b0ef01b4702b20$var$square(den4, den2);
    $42b0ef01b4702b20$var$mul(den6, den4, den2);
    $42b0ef01b4702b20$var$mul(t, den6, num);
    $42b0ef01b4702b20$var$mul(t, t, den);
    $42b0ef01b4702b20$var$pow2523(t, t);
    $42b0ef01b4702b20$var$mul(t, t, num);
    $42b0ef01b4702b20$var$mul(t, t, den);
    $42b0ef01b4702b20$var$mul(t, t, den);
    $42b0ef01b4702b20$var$mul(r[0], t, den);
    $42b0ef01b4702b20$var$square(chk, r[0]);
    $42b0ef01b4702b20$var$mul(chk, chk, den);
    if ($42b0ef01b4702b20$var$neq25519(chk, num)) $42b0ef01b4702b20$var$mul(r[0], r[0], $42b0ef01b4702b20$var$I);
    $42b0ef01b4702b20$var$square(chk, r[0]);
    $42b0ef01b4702b20$var$mul(chk, chk, den);
    if ($42b0ef01b4702b20$var$neq25519(chk, num)) return -1;
    if ($42b0ef01b4702b20$var$par25519(r[0]) === p[31] >> 7) $42b0ef01b4702b20$var$sub(r[0], $42b0ef01b4702b20$var$gf0, r[0]);
    $42b0ef01b4702b20$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $42b0ef01b4702b20$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    const q = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    if (signature.length !== module.exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${module.exports.SIGNATURE_LENGTH} bytes`);
    if ($42b0ef01b4702b20$var$unpackneg(q, publicKey)) return false;
    const hs = new $16b1U.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $42b0ef01b4702b20$var$reduce(h);
    $42b0ef01b4702b20$var$scalarmult(p, q, h);
    $42b0ef01b4702b20$var$scalarbase(q, signature.subarray(32));
    $42b0ef01b4702b20$var$edadd(p, q);
    $42b0ef01b4702b20$var$pack(t, p);
    if ($42b0ef01b4702b20$var$verify32(signature, t)) return false;
    return true;
}
module.exports.verify = $42b0ef01b4702b20$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $42b0ef01b4702b20$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf(),
        $42b0ef01b4702b20$var$gf()
    ];
    if ($42b0ef01b4702b20$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $42b0ef01b4702b20$var$gf();
    let b = $42b0ef01b4702b20$var$gf();
    let y = q[1];
    $42b0ef01b4702b20$var$add(a, $42b0ef01b4702b20$var$gf1, y);
    $42b0ef01b4702b20$var$sub(b, $42b0ef01b4702b20$var$gf1, y);
    $42b0ef01b4702b20$var$inv25519(b, b);
    $42b0ef01b4702b20$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $42b0ef01b4702b20$var$pack25519(z, a);
    return z;
}
module.exports.convertPublicKeyToX25519 = $42b0ef01b4702b20$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $42b0ef01b4702b20$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $16b1U.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $7ks5V.wipe)(d);
    return o;
}
module.exports.convertSecretKeyToX25519 = $42b0ef01b4702b20$var$convertSecretKeyToX25519;

});
parcelRegister("16b1U", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VxWR = parcelRequire("3VxWR");

var $7ks5V = parcelRequire("7ks5V");
module.exports.DIGEST_LENGTH = 64;
module.exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $0ccee84802bcf3da$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $7ks5V.wipe(this._buffer);
        $7ks5V.wipe(this._tempHi);
        $7ks5V.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < module.exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $0ccee84802bcf3da$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $0ccee84802bcf3da$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $3VxWR.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $3VxWR.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $0ccee84802bcf3da$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $3VxWR.writeUint32BE(this._stateHi[i], out, i * 8);
            $3VxWR.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $7ks5V.wipe(savedState.stateHi);
        $7ks5V.wipe(savedState.stateLo);
        if (savedState.buffer) $7ks5V.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
module.exports.SHA512 = $0ccee84802bcf3da$var$SHA512;
// Constants
var $0ccee84802bcf3da$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $0ccee84802bcf3da$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $3VxWR.readUint32BE(m, j);
            wl[i] = $3VxWR.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $0ccee84802bcf3da$var$K[i * 2];
            l = $0ccee84802bcf3da$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $0ccee84802bcf3da$var$hash(data) {
    var h = new $0ccee84802bcf3da$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $0ccee84802bcf3da$var$hash;

});


parcelRegister("dT4aR", function(module, exports) {

$parcel$export(module.exports, "JWT_IRIDIUM_ALG", () => $a1c3a650062a0414$export$51745f7832485c34);
$parcel$export(module.exports, "JWT_IRIDIUM_TYP", () => $a1c3a650062a0414$export$f51b45e220f2ba98);
$parcel$export(module.exports, "JWT_DELIMITER", () => $a1c3a650062a0414$export$a3e35a0f952eb3ef);
$parcel$export(module.exports, "JWT_ENCODING", () => $a1c3a650062a0414$export$d2e6fe38c55f8e23);
$parcel$export(module.exports, "JSON_ENCODING", () => $a1c3a650062a0414$export$c09c2801e10a2b95);
$parcel$export(module.exports, "DATA_ENCODING", () => $a1c3a650062a0414$export$1e9219c0b91a4257);
$parcel$export(module.exports, "DID_DELIMITER", () => $a1c3a650062a0414$export$d4057275de9d060b);
$parcel$export(module.exports, "DID_PREFIX", () => $a1c3a650062a0414$export$acf13c61a1a0ccf3);
$parcel$export(module.exports, "DID_METHOD", () => $a1c3a650062a0414$export$b908fe81ccf30934);
$parcel$export(module.exports, "MULTICODEC_ED25519_ENCODING", () => $a1c3a650062a0414$export$7bd18b7a7a4d0471);
$parcel$export(module.exports, "MULTICODEC_ED25519_BASE", () => $a1c3a650062a0414$export$6d6d3d2e39be8d68);
$parcel$export(module.exports, "MULTICODEC_ED25519_HEADER", () => $a1c3a650062a0414$export$9902a33a5776d1fc);
$parcel$export(module.exports, "MULTICODEC_ED25519_LENGTH", () => $a1c3a650062a0414$export$ca477e91394a742a);
$parcel$export(module.exports, "KEY_PAIR_SEED_LENGTH", () => $a1c3a650062a0414$export$f09ad228919f26fb);
const $a1c3a650062a0414$export$51745f7832485c34 = "EdDSA";
const $a1c3a650062a0414$export$f51b45e220f2ba98 = "JWT";
const $a1c3a650062a0414$export$a3e35a0f952eb3ef = ".";
const $a1c3a650062a0414$export$d2e6fe38c55f8e23 = "base64url";
const $a1c3a650062a0414$export$c09c2801e10a2b95 = "utf8";
const $a1c3a650062a0414$export$1e9219c0b91a4257 = "utf8";
const $a1c3a650062a0414$export$d4057275de9d060b = ":";
const $a1c3a650062a0414$export$acf13c61a1a0ccf3 = "did";
const $a1c3a650062a0414$export$b908fe81ccf30934 = "key";
const $a1c3a650062a0414$export$7bd18b7a7a4d0471 = "base58btc";
const $a1c3a650062a0414$export$6d6d3d2e39be8d68 = "z";
const $a1c3a650062a0414$export$9902a33a5776d1fc = "K36";
const $a1c3a650062a0414$export$ca477e91394a742a = 32;
const $a1c3a650062a0414$export$f09ad228919f26fb = 32;

});

parcelRegister("4LcoU", function(module, exports) {

$parcel$export(module.exports, "encodeIss", () => $37752bc4c83de693$export$1b29ef9371459e10);
$parcel$export(module.exports, "decodeIss", () => $37752bc4c83de693$export$86ac046d72244356);
$parcel$export(module.exports, "encodeData", () => $37752bc4c83de693$export$cfdd1f2478131e3d);
$parcel$export(module.exports, "encodeJWT", () => $37752bc4c83de693$export$1b70f4551c751d68);
$parcel$export(module.exports, "decodeJWT", () => $37752bc4c83de693$export$9a62e6c0a30e00bc);

var $3ly94 = parcelRequire("3ly94");

var $ez3MJ = parcelRequire("ez3MJ");

var $1Rhyp = parcelRequire("1Rhyp");

var $3zoS2 = parcelRequire("3zoS2");

var $dT4aR = parcelRequire("dT4aR");
function $37752bc4c83de693$export$2030d1af6cd0ef93(str) {
    return (0, $3zoS2.safeJsonParse)((0, $ez3MJ.toString)((0, $1Rhyp.fromString)(str, (0, $dT4aR.JWT_ENCODING)), (0, $dT4aR.JSON_ENCODING)));
}
function $37752bc4c83de693$export$84046f8082657cdf(val) {
    return (0, $ez3MJ.toString)((0, $1Rhyp.fromString)((0, $3zoS2.safeJsonStringify)(val), (0, $dT4aR.JSON_ENCODING)), (0, $dT4aR.JWT_ENCODING));
}
function $37752bc4c83de693$export$1b29ef9371459e10(publicKey) {
    const header = (0, $1Rhyp.fromString)((0, $dT4aR.MULTICODEC_ED25519_HEADER), (0, $dT4aR.MULTICODEC_ED25519_ENCODING));
    const multicodec = (0, $dT4aR.MULTICODEC_ED25519_BASE) + (0, $ez3MJ.toString)((0, $3ly94.concat)([
        header,
        publicKey
    ]), (0, $dT4aR.MULTICODEC_ED25519_ENCODING));
    return [
        (0, $dT4aR.DID_PREFIX),
        (0, $dT4aR.DID_METHOD),
        multicodec
    ].join((0, $dT4aR.DID_DELIMITER));
}
function $37752bc4c83de693$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $dT4aR.DID_DELIMITER));
    if (prefix !== (0, $dT4aR.DID_PREFIX) || method !== (0, $dT4aR.DID_METHOD)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $dT4aR.MULTICODEC_ED25519_BASE)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $1Rhyp.fromString)(multicodec.slice(1), (0, $dT4aR.MULTICODEC_ED25519_ENCODING));
    const type = (0, $ez3MJ.toString)(bytes.slice(0, 2), (0, $dT4aR.MULTICODEC_ED25519_ENCODING));
    if (type !== (0, $dT4aR.MULTICODEC_ED25519_HEADER)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $dT4aR.MULTICODEC_ED25519_LENGTH)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $37752bc4c83de693$export$d9746ef301b2089b(bytes) {
    return (0, $ez3MJ.toString)(bytes, (0, $dT4aR.JWT_ENCODING));
}
function $37752bc4c83de693$export$c37aeb372ac07c0e(encoded) {
    return (0, $1Rhyp.fromString)(encoded, (0, $dT4aR.JWT_ENCODING));
}
function $37752bc4c83de693$export$cfdd1f2478131e3d(params) {
    return (0, $1Rhyp.fromString)([
        $37752bc4c83de693$export$84046f8082657cdf(params.header),
        $37752bc4c83de693$export$84046f8082657cdf(params.payload)
    ].join((0, $dT4aR.JWT_DELIMITER)), (0, $dT4aR.DATA_ENCODING));
}
function $37752bc4c83de693$export$13923bea59211b58(data) {
    const params = (0, $ez3MJ.toString)(data, (0, $dT4aR.DATA_ENCODING)).split((0, $dT4aR.JWT_DELIMITER));
    const header = $37752bc4c83de693$export$2030d1af6cd0ef93(params[0]);
    const payload = $37752bc4c83de693$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $37752bc4c83de693$export$1b70f4551c751d68(params) {
    return [
        $37752bc4c83de693$export$84046f8082657cdf(params.header),
        $37752bc4c83de693$export$84046f8082657cdf(params.payload),
        $37752bc4c83de693$export$d9746ef301b2089b(params.signature)
    ].join((0, $dT4aR.JWT_DELIMITER));
}
function $37752bc4c83de693$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $dT4aR.JWT_DELIMITER));
    const header = $37752bc4c83de693$export$2030d1af6cd0ef93(params[0]);
    const payload = $37752bc4c83de693$export$2030d1af6cd0ef93(params[1]);
    const signature = $37752bc4c83de693$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $1Rhyp.fromString)(params.slice(0, 2).join((0, $dT4aR.JWT_DELIMITER)), (0, $dT4aR.DATA_ENCODING));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}

});


parcelRegister("h6KoW", function(module, exports) {

});


parcelRegister("5Do7R", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("9XiLT")).parseConnectionError);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("dVPQR")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("dVPQR")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("dVPQR")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("dVPQR")).getBigIntRpcId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("dVPQR")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("dVPQR")).isHttpUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("dVPQR")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("dVPQR")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("dVPQR")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("dVPQR")).isJsonRpcResult);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("dVPQR")).isLocalhostUrl);
$parcel$export(module.exports, "isReactNative", () => (parcelRequire("dVPQR")).isReactNative);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("dVPQR")).isWsUrl);
$parcel$export(module.exports, "parseConnectionError", () => (parcelRequire("dVPQR")).parseConnectionError);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("dVPQR")).payloadId);
$parcel$export(module.exports, "formatJsonRpcError", () => (parcelRequire("4seG3")).formatJsonRpcError);
$parcel$export(module.exports, "formatJsonRpcRequest", () => (parcelRequire("4seG3")).formatJsonRpcRequest);
$parcel$export(module.exports, "formatJsonRpcResult", () => (parcelRequire("4seG3")).formatJsonRpcResult);
$parcel$export(module.exports, "getBigIntRpcId", () => (parcelRequire("4seG3")).getBigIntRpcId);
$parcel$export(module.exports, "payloadId", () => (parcelRequire("4seG3")).payloadId);
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("dY7cQ")).IJsonRpcProvider);
$parcel$export(module.exports, "isHttpUrl", () => (parcelRequire("ixCVP")).isHttpUrl);
$parcel$export(module.exports, "isLocalhostUrl", () => (parcelRequire("ixCVP")).isLocalhostUrl);
$parcel$export(module.exports, "isWsUrl", () => (parcelRequire("ixCVP")).isWsUrl);
$parcel$export(module.exports, "isJsonRpcError", () => (parcelRequire("5h2x7")).isJsonRpcError);
$parcel$export(module.exports, "isJsonRpcRequest", () => (parcelRequire("5h2x7")).isJsonRpcRequest);
$parcel$export(module.exports, "isJsonRpcResponse", () => (parcelRequire("5h2x7")).isJsonRpcResponse);
$parcel$export(module.exports, "isJsonRpcResult", () => (parcelRequire("5h2x7")).isJsonRpcResult);
parcelRequire("kZzpN");
parcelRequire("9XiLT");
parcelRequire("k9Jde");
parcelRequire("4seG3");
parcelRequire("hf3Yy");
parcelRequire("inRFj");
parcelRequire("ixCVP");
parcelRequire("5h2x7");

});
parcelRegister("kZzpN", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", () => $f484f9d5151dc93c$export$f6e3abf3038d348f);
$parcel$export(module.exports, "SERVER_ERROR", () => $f484f9d5151dc93c$export$125ebd30471ac25c);
$parcel$export(module.exports, "RESERVED_ERROR_CODES", () => $f484f9d5151dc93c$export$af84821b5448ca78);
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", () => $f484f9d5151dc93c$export$fff5b44b15c75f69);
$parcel$export(module.exports, "STANDARD_ERROR_MAP", () => $f484f9d5151dc93c$export$cca5387ab287e1ae);
$parcel$export(module.exports, "DEFAULT_ERROR", () => $f484f9d5151dc93c$export$d166979eca925bce);
const $f484f9d5151dc93c$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $f484f9d5151dc93c$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $f484f9d5151dc93c$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $f484f9d5151dc93c$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $f484f9d5151dc93c$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $f484f9d5151dc93c$export$125ebd30471ac25c = "SERVER_ERROR";
const $f484f9d5151dc93c$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $f484f9d5151dc93c$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $f484f9d5151dc93c$export$cca5387ab287e1ae = {
    [$f484f9d5151dc93c$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$f484f9d5151dc93c$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$f484f9d5151dc93c$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$f484f9d5151dc93c$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$f484f9d5151dc93c$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$f484f9d5151dc93c$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $f484f9d5151dc93c$export$d166979eca925bce = $f484f9d5151dc93c$export$125ebd30471ac25c;

});

parcelRegister("9XiLT", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", () => $73f82f5ec425f0e0$export$2ae0ec6393ab16c3);
$parcel$export(module.exports, "getError", () => $73f82f5ec425f0e0$export$e1599abf47b5b568);
$parcel$export(module.exports, "getErrorByCode", () => $73f82f5ec425f0e0$export$60a3bac005957e12);
$parcel$export(module.exports, "parseConnectionError", () => $73f82f5ec425f0e0$export$f555d7d8f922e407);

var $kZzpN = parcelRequire("kZzpN");
function $73f82f5ec425f0e0$export$e463129eb4bc487f(code) {
    return code <= (0, $kZzpN.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $kZzpN.SERVER_ERROR_CODE_RANGE)[1];
}
function $73f82f5ec425f0e0$export$2ae0ec6393ab16c3(code) {
    return (0, $kZzpN.RESERVED_ERROR_CODES).includes(code);
}
function $73f82f5ec425f0e0$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $73f82f5ec425f0e0$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $kZzpN.STANDARD_ERROR_MAP)).includes(type)) return (0, $kZzpN.STANDARD_ERROR_MAP)[0, $kZzpN.DEFAULT_ERROR];
    return (0, $kZzpN.STANDARD_ERROR_MAP)[type];
}
function $73f82f5ec425f0e0$export$60a3bac005957e12(code) {
    const match = Object.values((0, $kZzpN.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, $kZzpN.STANDARD_ERROR_MAP)[0, $kZzpN.DEFAULT_ERROR];
    return match;
}
function $73f82f5ec425f0e0$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$73f82f5ec425f0e0$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($73f82f5ec425f0e0$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $73f82f5ec425f0e0$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $kZzpN.STANDARD_ERROR_MAP)[0, $kZzpN.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $73f82f5ec425f0e0$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

});

parcelRegister("k9Jde", function(module, exports) {

var $dVPQR = parcelRequire("dVPQR");
const $eac7b827c8e525a1$export$d1694901a048d7c8 = (0, $dVPQR.isNode);
$parcel$exportWildcard(module.exports, $dVPQR);

});
parcelRegister("dVPQR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4YZos = parcelRequire("4YZos");

$4YZos.__exportStar((parcelRequire("4YQpq")), module.exports);

$4YZos.__exportStar((parcelRequire("jNcDU")), module.exports);

});
parcelRegister("4YZos", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $3a0c637ffb525a77$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3a0c637ffb525a77$var$extendStatics = function(d, b) {
    $3a0c637ffb525a77$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3a0c637ffb525a77$var$extendStatics(d, b);
};
function $3a0c637ffb525a77$export$a8ba968b8961cb8a(d, b) {
    $3a0c637ffb525a77$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3a0c637ffb525a77$export$18ce0697a983be9b = function() {
    $3a0c637ffb525a77$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a0c637ffb525a77$export$18ce0697a983be9b.apply(this, arguments);
};
function $3a0c637ffb525a77$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3a0c637ffb525a77$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3a0c637ffb525a77$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3a0c637ffb525a77$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3a0c637ffb525a77$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3a0c637ffb525a77$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3a0c637ffb525a77$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3a0c637ffb525a77$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3a0c637ffb525a77$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3a0c637ffb525a77$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3a0c637ffb525a77$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3a0c637ffb525a77$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3a0c637ffb525a77$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3a0c637ffb525a77$export$10c90e4f7922046c(v) {
    return this instanceof $3a0c637ffb525a77$export$10c90e4f7922046c ? (this.v = v, this) : new $3a0c637ffb525a77$export$10c90e4f7922046c(v);
}
function $3a0c637ffb525a77$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3a0c637ffb525a77$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3a0c637ffb525a77$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3a0c637ffb525a77$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3a0c637ffb525a77$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3a0c637ffb525a77$export$19a8beecd37a4c45 === "function" ? $3a0c637ffb525a77$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3a0c637ffb525a77$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3a0c637ffb525a77$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3a0c637ffb525a77$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3a0c637ffb525a77$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3a0c637ffb525a77$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("4YQpq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $3a056b5c85b99494$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $3a056b5c85b99494$var$getBrowerCrypto;
function $3a056b5c85b99494$var$getSubtleCrypto() {
    const browserCrypto = $3a056b5c85b99494$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $3a056b5c85b99494$var$getSubtleCrypto;
function $3a056b5c85b99494$var$isBrowserCryptoAvailable() {
    return !!$3a056b5c85b99494$var$getBrowerCrypto() && !!$3a056b5c85b99494$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $3a056b5c85b99494$var$isBrowserCryptoAvailable;

});

parcelRegister("jNcDU", function(module, exports) {

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $e68c667d07bf7844$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $e68c667d07bf7844$var$isReactNative;
function $e68c667d07bf7844$var$isNode() {
    return typeof $gbdt3 !== "undefined" && typeof $gbdt3.versions !== "undefined" && typeof $gbdt3.versions.node !== "undefined";
}
module.exports.isNode = $e68c667d07bf7844$var$isNode;
function $e68c667d07bf7844$var$isBrowser() {
    return !$e68c667d07bf7844$var$isReactNative() && !$e68c667d07bf7844$var$isNode();
}
module.exports.isBrowser = $e68c667d07bf7844$var$isBrowser;

});



parcelRegister("4seG3", function(module, exports) {

$parcel$export(module.exports, "payloadId", () => $33e529887a9f047a$export$2f5364a5d4b80251);
$parcel$export(module.exports, "getBigIntRpcId", () => $33e529887a9f047a$export$799a3db5df197877);
$parcel$export(module.exports, "formatJsonRpcRequest", () => $33e529887a9f047a$export$11d081ebb32d4398);
$parcel$export(module.exports, "formatJsonRpcResult", () => $33e529887a9f047a$export$478fdea01c2a3198);
$parcel$export(module.exports, "formatJsonRpcError", () => $33e529887a9f047a$export$9f7302ae26c3f77);

var $9XiLT = parcelRequire("9XiLT");

var $kZzpN = parcelRequire("kZzpN");
function $33e529887a9f047a$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $33e529887a9f047a$export$799a3db5df197877(entropy = 6) {
    return BigInt($33e529887a9f047a$export$2f5364a5d4b80251(entropy));
}
function $33e529887a9f047a$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $33e529887a9f047a$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $33e529887a9f047a$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $33e529887a9f047a$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $33e529887a9f047a$export$5201d50a34753d71(error, data)
    };
}
function $33e529887a9f047a$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $9XiLT.getError)((0, $kZzpN.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $9XiLT.getError)((0, $kZzpN.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $9XiLT.isReservedErrorCode)(error.code)) error = (0, $9XiLT.getErrorByCode)(error.code);
    return error;
}

});

parcelRegister("hf3Yy", function(module, exports) {
function $c8d6ebe4beff0354$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $c8d6ebe4beff0354$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $c8d6ebe4beff0354$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $c8d6ebe4beff0354$export$8e8b9bea55b56df2(route) {
    if ($c8d6ebe4beff0354$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $c8d6ebe4beff0354$export$2d48faaafcc8fbdc(route) {
    return !$c8d6ebe4beff0354$export$c7e2040809cad2c4(route) && $c8d6ebe4beff0354$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $c8d6ebe4beff0354$export$be298a4710fab756(route) {
    return !$c8d6ebe4beff0354$export$c7e2040809cad2c4(route) && $c8d6ebe4beff0354$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRegister("inRFj", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", () => (parcelRequire("dY7cQ")).IJsonRpcProvider);
parcelRequire("dY7cQ");

});
parcelRegister("dY7cQ", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", () => $a2b677f9bf8983ed$export$46957420a688a16d);
class $a2b677f9bf8983ed$export$ab429ec7e240e546 {
}
class $a2b677f9bf8983ed$export$77d426dd89724fbe extends $a2b677f9bf8983ed$export$ab429ec7e240e546 {
    constructor(c){
        super();
    }
}
class $a2b677f9bf8983ed$export$cb916a2eed49af33 extends $a2b677f9bf8983ed$export$ab429ec7e240e546 {
    constructor(){
        super();
    }
}
class $a2b677f9bf8983ed$export$46957420a688a16d extends $a2b677f9bf8983ed$export$cb916a2eed49af33 {
    constructor(c){
        super();
    }
}

});


parcelRegister("ixCVP", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", () => $d7f982120f35c4f8$export$206c3129b8bb1b4f);
$parcel$export(module.exports, "isWsUrl", () => $d7f982120f35c4f8$export$4e4463e75eccf20c);
$parcel$export(module.exports, "isLocalhostUrl", () => $d7f982120f35c4f8$export$8eb4a0a481601f29);
const $d7f982120f35c4f8$var$HTTP_REGEX = "^https?:";
const $d7f982120f35c4f8$var$WS_REGEX = "^wss?:";
function $d7f982120f35c4f8$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $d7f982120f35c4f8$var$matchRegexProtocol(url, regex) {
    const protocol = $d7f982120f35c4f8$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $d7f982120f35c4f8$export$206c3129b8bb1b4f(url) {
    return $d7f982120f35c4f8$var$matchRegexProtocol(url, $d7f982120f35c4f8$var$HTTP_REGEX);
}
function $d7f982120f35c4f8$export$4e4463e75eccf20c(url) {
    return $d7f982120f35c4f8$var$matchRegexProtocol(url, $d7f982120f35c4f8$var$WS_REGEX);
}
function $d7f982120f35c4f8$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRegister("5h2x7", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", () => $3d7081549d78c194$export$f6e4034abe07d2a5);
$parcel$export(module.exports, "isJsonRpcResponse", () => $3d7081549d78c194$export$308ba927de2bcbe8);
$parcel$export(module.exports, "isJsonRpcResult", () => $3d7081549d78c194$export$cb3d3b20e3223d77);
$parcel$export(module.exports, "isJsonRpcError", () => $3d7081549d78c194$export$5662a1047b4d1d15);
function $3d7081549d78c194$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $3d7081549d78c194$export$f6e4034abe07d2a5(payload) {
    return $3d7081549d78c194$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $3d7081549d78c194$export$308ba927de2bcbe8(payload) {
    return $3d7081549d78c194$export$bf3617e9fafa893f(payload) && ($3d7081549d78c194$export$cb3d3b20e3223d77(payload) || $3d7081549d78c194$export$5662a1047b4d1d15(payload));
}
function $3d7081549d78c194$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $3d7081549d78c194$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $3d7081549d78c194$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});


parcelRegister("8jexD", function(module, exports) {

$parcel$export(module.exports, "default", () => $60cb60bad23720f0$export$ea0df116fa892998);

var $ej6Nm = parcelRequire("ej6Nm");

var $3zoS2 = parcelRequire("3zoS2");
parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
var $ixCVP = parcelRequire("ixCVP");
var $dVPQR = parcelRequire("dVPQR");
var $9XiLT = parcelRequire("9XiLT");

const $60cb60bad23720f0$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("bYK9E")), $60cb60bad23720f0$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $60cb60bad23720f0$var$a = (c)=>c.split("?")[0], $60cb60bad23720f0$var$h = 10, $60cb60bad23720f0$var$S = $60cb60bad23720f0$var$w();
class $60cb60bad23720f0$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $ej6Nm.EventEmitter), this.registering = !1, !(0, $ixCVP.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $3zoS2.safeJsonStringify)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $ixCVP.isWsUrl)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $dVPQR.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $ixCVP.isLocalhostUrl)(e)
            }, i = new $60cb60bad23720f0$var$S(e, [], s);
            $60cb60bad23720f0$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $3zoS2.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $4seG3.formatJsonRpcError)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $9XiLT.parseConnectionError)(e, $60cb60bad23720f0$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $60cb60bad23720f0$var$h && this.events.setMaxListeners($60cb60bad23720f0$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$60cb60bad23720f0$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}

});
parcelRegister("bYK9E", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});


parcelRegister("8ne5u", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("fdSc8", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("5tA2t")).default || (parcelRequire("5tA2t")));

});
parcelRegister("5tA2t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3fcb9dc7b4c843db$export$2e2bcd8739ae039);
function $3fcb9dc7b4c843db$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});


parcelRegister("itZgd", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", () => $d74a747f023c800b$export$13c1f9cf8a283575);
$parcel$export(module.exports, "default", () => $d74a747f023c800b$export$13c1f9cf8a283575);

var $ej6Nm = parcelRequire("ej6Nm");

var $aUQjb = parcelRequire("aUQjb");

var $3zoS2 = parcelRequire("3zoS2");
parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
var $ixCVP = parcelRequire("ixCVP");
var $9XiLT = parcelRequire("9XiLT");
var $d74a747f023c800b$var$P = Object.defineProperty, $d74a747f023c800b$var$w = Object.defineProperties, $d74a747f023c800b$var$E = Object.getOwnPropertyDescriptors, $d74a747f023c800b$var$c = Object.getOwnPropertySymbols, $d74a747f023c800b$var$L = Object.prototype.hasOwnProperty, $d74a747f023c800b$var$O = Object.prototype.propertyIsEnumerable, $d74a747f023c800b$var$l = (r, t, e)=>t in r ? $d74a747f023c800b$var$P(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e, $d74a747f023c800b$var$p = (r, t)=>{
    for(var e in t || (t = {}))$d74a747f023c800b$var$L.call(t, e) && $d74a747f023c800b$var$l(r, e, t[e]);
    if ($d74a747f023c800b$var$c) for (var e of $d74a747f023c800b$var$c(t))$d74a747f023c800b$var$O.call(t, e) && $d74a747f023c800b$var$l(r, e, t[e]);
    return r;
}, $d74a747f023c800b$var$v = (r, t)=>$d74a747f023c800b$var$w(r, $d74a747f023c800b$var$E(t));
const $d74a747f023c800b$var$j = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $d74a747f023c800b$var$T = "POST", $d74a747f023c800b$var$d = {
    headers: $d74a747f023c800b$var$j,
    method: $d74a747f023c800b$var$T
}, $d74a747f023c800b$var$g = 10;
class $d74a747f023c800b$export$13c1f9cf8a283575 {
    constructor(t, e = !1){
        if (this.url = t, this.disableProviderPing = e, this.events = new (0, $ej6Nm.EventEmitter), this.isAvailable = !1, this.registering = !1, !(0, $ixCVP.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        this.url = t, this.disableProviderPing = e;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async open(t = this.url) {
        await this.register(t);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(t) {
        this.isAvailable || await this.register();
        try {
            const e = (0, $3zoS2.safeJsonStringify)(t), s = await (await (0, (/*@__PURE__*/$parcel$interopDefault($aUQjb)))(this.url, $d74a747f023c800b$var$v($d74a747f023c800b$var$p({}, $d74a747f023c800b$var$d), {
                body: e
            }))).json();
            this.onPayload({
                data: s
            });
        } catch (e) {
            this.onError(t.id, e);
        }
    }
    async register(t = this.url) {
        if (!(0, $ixCVP.isHttpUrl)(t)) throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);
        if (this.registering) {
            const e = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= e || this.events.listenerCount("open") >= e) && this.events.setMaxListeners(e + 1), new Promise((s, i)=>{
                this.events.once("register_error", (n)=>{
                    this.resetMaxListeners(), i(n);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.isAvailable > "u") return i(new Error("HTTP connection is missing or invalid"));
                    s();
                });
            });
        }
        this.url = t, this.registering = !0;
        try {
            if (!this.disableProviderPing) {
                const e = (0, $3zoS2.safeJsonStringify)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($aUQjb)))(t, $d74a747f023c800b$var$v($d74a747f023c800b$var$p({}, $d74a747f023c800b$var$d), {
                    body: e
                }));
            }
            this.onOpen();
        } catch (e) {
            const s = this.parseError(e);
            throw this.events.emit("register_error", s), this.onClose(), s;
        }
    }
    onOpen() {
        this.isAvailable = !0, this.registering = !1, this.events.emit("open");
    }
    onClose() {
        this.isAvailable = !1, this.registering = !1, this.events.emit("close");
    }
    onPayload(t) {
        if (typeof t.data > "u") return;
        const e = typeof t.data == "string" ? (0, $3zoS2.safeJsonParse)(t.data) : t.data;
        this.events.emit("payload", e);
    }
    onError(t, e) {
        const s = this.parseError(e), i = s.message || s.toString(), n = (0, $4seG3.formatJsonRpcError)(t, i);
        this.events.emit("payload", n);
    }
    parseError(t, e = this.url) {
        return (0, $9XiLT.parseConnectionError)(t, e, "HTTP");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $d74a747f023c800b$var$g && this.events.setMaxListeners($d74a747f023c800b$var$g);
    }
}

});

parcelRegister("bMvqo", function(module, exports) {

var $sJXAr = parcelRequire("sJXAr");
module.exports = $sJXAr("jtxN9").then(()=>parcelRequire("722pG"));

});

parcelRegister("pfIJM", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("6AdSR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4cb0dfe46d0c49b6$var$ReactIs, $4cb0dfe46d0c49b6$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hWy5B"))();

});


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");
var $1c1c7e7d360f5af6$export$882461b6382ed46c;
var $1c1c7e7d360f5af6$export$757ceba2d55c277e;
"use strict";
var $e10f5070fc836746$exports = {};
"use strict";
function $e10f5070fc836746$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e10f5070fc836746$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e10f5070fc836746$var$checkDCE();

$e10f5070fc836746$exports = (parcelRequire("dpuiw"));


var $1c1c7e7d360f5af6$var$i;
$1c1c7e7d360f5af6$export$882461b6382ed46c = $e10f5070fc836746$exports.createRoot;
$1c1c7e7d360f5af6$export$757ceba2d55c277e = $e10f5070fc836746$exports.hydrateRoot;


var $939f14b26ca18529$exports = {};
"use strict";
Object.defineProperty($939f14b26ca18529$exports, "__esModule", {
    value: true
});
var $611c60e403e100c1$exports = {};
"use strict";
Object.defineProperty($611c60e403e100c1$exports, "__esModule", {
    value: true
});
$611c60e403e100c1$exports.bodyOpenClassName = $611c60e403e100c1$exports.portalClassName = undefined;
var $611c60e403e100c1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $611c60e403e100c1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dup7A = parcelRequire("dup7A");
var $611c60e403e100c1$var$_react2 = $611c60e403e100c1$var$_interopRequireDefault($dup7A);

var $611c60e403e100c1$var$_reactDom2 = $611c60e403e100c1$var$_interopRequireDefault($e10f5070fc836746$exports);

var $6AdSR = parcelRequire("6AdSR");
var $611c60e403e100c1$var$_propTypes2 = $611c60e403e100c1$var$_interopRequireDefault($6AdSR);
var $020adc43040d8b88$exports = {};
"use strict";
Object.defineProperty($020adc43040d8b88$exports, "__esModule", {
    value: true
});
var $020adc43040d8b88$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $020adc43040d8b88$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $020adc43040d8b88$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dup7A = parcelRequire("dup7A");

var $6AdSR = parcelRequire("6AdSR");
var $020adc43040d8b88$var$_propTypes2 = $020adc43040d8b88$var$_interopRequireDefault($6AdSR);
var $c72db3c939fbd97a$exports = {};
"use strict";
Object.defineProperty($c72db3c939fbd97a$exports, "__esModule", {
    value: true
});
$c72db3c939fbd97a$exports.resetState = $c72db3c939fbd97a$var$resetState;
$c72db3c939fbd97a$exports.log = $c72db3c939fbd97a$var$log;
$c72db3c939fbd97a$exports.handleBlur = $c72db3c939fbd97a$var$handleBlur;
$c72db3c939fbd97a$exports.handleFocus = $c72db3c939fbd97a$var$handleFocus;
$c72db3c939fbd97a$exports.markForFocusLater = $c72db3c939fbd97a$var$markForFocusLater;
$c72db3c939fbd97a$exports.returnFocus = $c72db3c939fbd97a$var$returnFocus;
$c72db3c939fbd97a$exports.popWithoutFocus = $c72db3c939fbd97a$var$popWithoutFocus;
$c72db3c939fbd97a$exports.setupScopedFocus = $c72db3c939fbd97a$var$setupScopedFocus;
$c72db3c939fbd97a$exports.teardownScopedFocus = $c72db3c939fbd97a$var$teardownScopedFocus;
var $447af1284c52dfc2$exports = {};
"use strict";
Object.defineProperty($447af1284c52dfc2$exports, "__esModule", {
    value: true
});
$447af1284c52dfc2$exports.default = $447af1284c52dfc2$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $447af1284c52dfc2$var$DISPLAY_NONE = "none";
var $447af1284c52dfc2$var$DISPLAY_CONTENTS = "contents";
var $447af1284c52dfc2$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $447af1284c52dfc2$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $447af1284c52dfc2$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $447af1284c52dfc2$var$DISPLAY_CONTENTS && $447af1284c52dfc2$var$isNotOverflowing(element, style) : displayValue === $447af1284c52dfc2$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $447af1284c52dfc2$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($447af1284c52dfc2$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $447af1284c52dfc2$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $447af1284c52dfc2$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $447af1284c52dfc2$var$visible(element);
}
function $447af1284c52dfc2$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $447af1284c52dfc2$var$focusable(element, !isTabIndexNaN);
}
function $447af1284c52dfc2$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $447af1284c52dfc2$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($447af1284c52dfc2$var$tabbable);
}
$447af1284c52dfc2$exports = $447af1284c52dfc2$exports["default"];


var $c72db3c939fbd97a$var$_tabbable2 = $c72db3c939fbd97a$var$_interopRequireDefault($447af1284c52dfc2$exports);
function $c72db3c939fbd97a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c72db3c939fbd97a$var$focusLaterElements = [];
var $c72db3c939fbd97a$var$modalElement = null;
var $c72db3c939fbd97a$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $c72db3c939fbd97a$var$resetState() {
    $c72db3c939fbd97a$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $c72db3c939fbd97a$var$log() {}
/* eslint-enable no-console */ function $c72db3c939fbd97a$var$handleBlur() {
    $c72db3c939fbd97a$var$needToFocus = true;
}
function $c72db3c939fbd97a$var$handleFocus() {
    if ($c72db3c939fbd97a$var$needToFocus) {
        $c72db3c939fbd97a$var$needToFocus = false;
        if (!$c72db3c939fbd97a$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($c72db3c939fbd97a$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $c72db3c939fbd97a$var$_tabbable2.default)($c72db3c939fbd97a$var$modalElement)[0] || $c72db3c939fbd97a$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $c72db3c939fbd97a$var$markForFocusLater() {
    $c72db3c939fbd97a$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $c72db3c939fbd97a$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($c72db3c939fbd97a$var$focusLaterElements.length !== 0) {
            toFocus = $c72db3c939fbd97a$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $c72db3c939fbd97a$var$popWithoutFocus() {
    $c72db3c939fbd97a$var$focusLaterElements.length > 0 && $c72db3c939fbd97a$var$focusLaterElements.pop();
}
function $c72db3c939fbd97a$var$setupScopedFocus(element) {
    $c72db3c939fbd97a$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $c72db3c939fbd97a$var$handleBlur, false);
        document.addEventListener("focus", $c72db3c939fbd97a$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $c72db3c939fbd97a$var$handleBlur);
        document.attachEvent("onFocus", $c72db3c939fbd97a$var$handleFocus);
    }
}
function $c72db3c939fbd97a$var$teardownScopedFocus() {
    $c72db3c939fbd97a$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $c72db3c939fbd97a$var$handleBlur);
        document.removeEventListener("focus", $c72db3c939fbd97a$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $c72db3c939fbd97a$var$handleBlur);
        document.detachEvent("onFocus", $c72db3c939fbd97a$var$handleFocus);
    }
}


var $020adc43040d8b88$var$focusManager = $020adc43040d8b88$var$_interopRequireWildcard($c72db3c939fbd97a$exports);
var $bd40bb89eb1b6cd0$exports = {};
"use strict";
Object.defineProperty($bd40bb89eb1b6cd0$exports, "__esModule", {
    value: true
});
$bd40bb89eb1b6cd0$exports.default = $bd40bb89eb1b6cd0$var$scopeTab;

var $bd40bb89eb1b6cd0$var$_tabbable2 = $bd40bb89eb1b6cd0$var$_interopRequireDefault($447af1284c52dfc2$exports);
function $bd40bb89eb1b6cd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd40bb89eb1b6cd0$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $bd40bb89eb1b6cd0$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $bd40bb89eb1b6cd0$var$scopeTab(node, event) {
    var tabbable = (0, $bd40bb89eb1b6cd0$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $bd40bb89eb1b6cd0$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$bd40bb89eb1b6cd0$exports = $bd40bb89eb1b6cd0$exports["default"];


var $020adc43040d8b88$var$_scopeTab2 = $020adc43040d8b88$var$_interopRequireDefault($bd40bb89eb1b6cd0$exports);
var $96e4f8b3f7d4805e$exports = {};
"use strict";
Object.defineProperty($96e4f8b3f7d4805e$exports, "__esModule", {
    value: true
});
$96e4f8b3f7d4805e$exports.resetState = $96e4f8b3f7d4805e$var$resetState;
$96e4f8b3f7d4805e$exports.log = $96e4f8b3f7d4805e$var$log;
$96e4f8b3f7d4805e$exports.assertNodeList = $96e4f8b3f7d4805e$var$assertNodeList;
$96e4f8b3f7d4805e$exports.setElement = $96e4f8b3f7d4805e$var$setElement;
$96e4f8b3f7d4805e$exports.validateElement = $96e4f8b3f7d4805e$var$validateElement;
$96e4f8b3f7d4805e$exports.hide = $96e4f8b3f7d4805e$var$hide;
$96e4f8b3f7d4805e$exports.show = $96e4f8b3f7d4805e$var$show;
$96e4f8b3f7d4805e$exports.documentNotReadyOrSSRTesting = $96e4f8b3f7d4805e$var$documentNotReadyOrSSRTesting;
var $db2e88b7d925b2d0$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $db2e88b7d925b2d0$var$__DEV__ = false;
var $db2e88b7d925b2d0$var$warning = function() {};
if ($db2e88b7d925b2d0$var$__DEV__) {
    var $db2e88b7d925b2d0$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $db2e88b7d925b2d0$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $db2e88b7d925b2d0$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$db2e88b7d925b2d0$exports = $db2e88b7d925b2d0$var$warning;


var $96e4f8b3f7d4805e$var$_warning2 = $96e4f8b3f7d4805e$var$_interopRequireDefault($db2e88b7d925b2d0$exports);
var $52cb980a881c1dff$exports = {};
"use strict";
Object.defineProperty($52cb980a881c1dff$exports, "__esModule", {
    value: true
});
$52cb980a881c1dff$exports.canUseDOM = $52cb980a881c1dff$exports.SafeNodeList = $52cb980a881c1dff$exports.SafeHTMLCollection = undefined;
var $4b747aff33c5a569$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $4b747aff33c5a569$exports) $4b747aff33c5a569$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $52cb980a881c1dff$var$_exenv2 = $52cb980a881c1dff$var$_interopRequireDefault($4b747aff33c5a569$exports);
function $52cb980a881c1dff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $52cb980a881c1dff$var$EE = $52cb980a881c1dff$var$_exenv2.default;
var $52cb980a881c1dff$var$SafeHTMLElement = $52cb980a881c1dff$var$EE.canUseDOM ? window.HTMLElement : {};
var $52cb980a881c1dff$var$SafeHTMLCollection = $52cb980a881c1dff$exports.SafeHTMLCollection = $52cb980a881c1dff$var$EE.canUseDOM ? window.HTMLCollection : {};
var $52cb980a881c1dff$var$SafeNodeList = $52cb980a881c1dff$exports.SafeNodeList = $52cb980a881c1dff$var$EE.canUseDOM ? window.NodeList : {};
var $52cb980a881c1dff$var$canUseDOM = $52cb980a881c1dff$exports.canUseDOM = $52cb980a881c1dff$var$EE.canUseDOM;
$52cb980a881c1dff$exports.default = $52cb980a881c1dff$var$SafeHTMLElement;


function $96e4f8b3f7d4805e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $96e4f8b3f7d4805e$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $96e4f8b3f7d4805e$var$resetState() {
    if ($96e4f8b3f7d4805e$var$globalElement) {
        if ($96e4f8b3f7d4805e$var$globalElement.removeAttribute) $96e4f8b3f7d4805e$var$globalElement.removeAttribute("aria-hidden");
        else if ($96e4f8b3f7d4805e$var$globalElement.length != null) $96e4f8b3f7d4805e$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($96e4f8b3f7d4805e$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $96e4f8b3f7d4805e$var$globalElement = null;
}
/* istanbul ignore next */ function $96e4f8b3f7d4805e$var$log() {
    var check;
}
/* eslint-enable no-console */ function $96e4f8b3f7d4805e$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $96e4f8b3f7d4805e$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $52cb980a881c1dff$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $96e4f8b3f7d4805e$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $96e4f8b3f7d4805e$var$globalElement = useElement || $96e4f8b3f7d4805e$var$globalElement;
    return $96e4f8b3f7d4805e$var$globalElement;
}
function $96e4f8b3f7d4805e$var$validateElement(appElement) {
    var el = appElement || $96e4f8b3f7d4805e$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $96e4f8b3f7d4805e$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $96e4f8b3f7d4805e$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $96e4f8b3f7d4805e$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $96e4f8b3f7d4805e$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $96e4f8b3f7d4805e$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $96e4f8b3f7d4805e$var$documentNotReadyOrSSRTesting() {
    $96e4f8b3f7d4805e$var$globalElement = null;
}


var $020adc43040d8b88$var$ariaAppHider = $020adc43040d8b88$var$_interopRequireWildcard($96e4f8b3f7d4805e$exports);
var $bac1457e97857658$exports = {};
"use strict";
Object.defineProperty($bac1457e97857658$exports, "__esModule", {
    value: true
});
$bac1457e97857658$exports.resetState = $bac1457e97857658$var$resetState;
$bac1457e97857658$exports.log = $bac1457e97857658$var$log;
var $bac1457e97857658$var$htmlClassList = {};
var $bac1457e97857658$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $bac1457e97857658$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $bac1457e97857658$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $bac1457e97857658$var$htmlClassList)$bac1457e97857658$var$removeClass(htmlElement, $bac1457e97857658$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $bac1457e97857658$var$docBodyClassList)$bac1457e97857658$var$removeClass(body, $bac1457e97857658$var$docBodyClassList[_cls]);
    $bac1457e97857658$var$htmlClassList = {};
    $bac1457e97857658$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $bac1457e97857658$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $bac1457e97857658$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $bac1457e97857658$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $bac1457e97857658$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $bac1457e97857658$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $bac1457e97857658$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $bac1457e97857658$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $bac1457e97857658$var$add = $bac1457e97857658$exports.add = function add(element, classString) {
    return $bac1457e97857658$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $bac1457e97857658$var$htmlClassList : $bac1457e97857658$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $bac1457e97857658$var$remove = $bac1457e97857658$exports.remove = function remove(element, classString) {
    return $bac1457e97857658$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $bac1457e97857658$var$htmlClassList : $bac1457e97857658$var$docBodyClassList, classString.split(" "));
};


var $020adc43040d8b88$var$classList = $020adc43040d8b88$var$_interopRequireWildcard($bac1457e97857658$exports);

var $020adc43040d8b88$var$_safeHTMLElement2 = $020adc43040d8b88$var$_interopRequireDefault($52cb980a881c1dff$exports);
var $6307f60b477a4020$exports = {};
"use strict";
Object.defineProperty($6307f60b477a4020$exports, "__esModule", {
    value: true
});
$6307f60b477a4020$exports.log = $6307f60b477a4020$var$log;
$6307f60b477a4020$exports.resetState = $6307f60b477a4020$var$resetState;
function $6307f60b477a4020$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $6307f60b477a4020$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $6307f60b477a4020$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $6307f60b477a4020$var$portalOpenInstances = new $6307f60b477a4020$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $6307f60b477a4020$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($6307f60b477a4020$var$portalOpenInstances.openInstances.length);
    $6307f60b477a4020$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $6307f60b477a4020$var$resetState() {
    $6307f60b477a4020$var$portalOpenInstances = new $6307f60b477a4020$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $6307f60b477a4020$exports.default = $6307f60b477a4020$var$portalOpenInstances;


var $020adc43040d8b88$var$_portalOpenInstances2 = $020adc43040d8b88$var$_interopRequireDefault($6307f60b477a4020$exports);
var $accaba67bfc2be99$exports = {};
"use strict";
Object.defineProperty($accaba67bfc2be99$exports, "__esModule", {
    value: true
});
$accaba67bfc2be99$exports.resetState = $accaba67bfc2be99$var$resetState;
$accaba67bfc2be99$exports.log = $accaba67bfc2be99$var$log;

var $accaba67bfc2be99$var$_portalOpenInstances2 = $accaba67bfc2be99$var$_interopRequireDefault($6307f60b477a4020$exports);
function $accaba67bfc2be99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $accaba67bfc2be99$var$before = void 0, $accaba67bfc2be99$var$after = void 0, $accaba67bfc2be99$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $accaba67bfc2be99$var$resetState() {
    var _arr = [
        $accaba67bfc2be99$var$before,
        $accaba67bfc2be99$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $accaba67bfc2be99$var$before = $accaba67bfc2be99$var$after = null;
    $accaba67bfc2be99$var$instances = [];
}
/* istanbul ignore next */ function $accaba67bfc2be99$var$log() {
    console.log("bodyTrap ----------");
    console.log($accaba67bfc2be99$var$instances.length);
    var _arr2 = [
        $accaba67bfc2be99$var$before,
        $accaba67bfc2be99$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $accaba67bfc2be99$var$focusContent() {
    if ($accaba67bfc2be99$var$instances.length === 0) return;
    $accaba67bfc2be99$var$instances[$accaba67bfc2be99$var$instances.length - 1].focusContent();
}
function $accaba67bfc2be99$var$bodyTrap(eventType, openInstances) {
    if (!$accaba67bfc2be99$var$before && !$accaba67bfc2be99$var$after) {
        $accaba67bfc2be99$var$before = document.createElement("div");
        $accaba67bfc2be99$var$before.setAttribute("data-react-modal-body-trap", "");
        $accaba67bfc2be99$var$before.style.position = "absolute";
        $accaba67bfc2be99$var$before.style.opacity = "0";
        $accaba67bfc2be99$var$before.setAttribute("tabindex", "0");
        $accaba67bfc2be99$var$before.addEventListener("focus", $accaba67bfc2be99$var$focusContent);
        $accaba67bfc2be99$var$after = $accaba67bfc2be99$var$before.cloneNode();
        $accaba67bfc2be99$var$after.addEventListener("focus", $accaba67bfc2be99$var$focusContent);
    }
    $accaba67bfc2be99$var$instances = openInstances;
    if ($accaba67bfc2be99$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $accaba67bfc2be99$var$before) document.body.insertBefore($accaba67bfc2be99$var$before, document.body.firstChild);
        if (document.body.lastChild !== $accaba67bfc2be99$var$after) document.body.appendChild($accaba67bfc2be99$var$after);
    } else {
        // Remove focus trap
        if ($accaba67bfc2be99$var$before.parentElement) $accaba67bfc2be99$var$before.parentElement.removeChild($accaba67bfc2be99$var$before);
        if ($accaba67bfc2be99$var$after.parentElement) $accaba67bfc2be99$var$after.parentElement.removeChild($accaba67bfc2be99$var$after);
    }
}
$accaba67bfc2be99$var$_portalOpenInstances2.default.subscribe($accaba67bfc2be99$var$bodyTrap);


function $020adc43040d8b88$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $020adc43040d8b88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $020adc43040d8b88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $020adc43040d8b88$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $020adc43040d8b88$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $020adc43040d8b88$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $020adc43040d8b88$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $020adc43040d8b88$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $020adc43040d8b88$var$ariaHiddenInstances = 0;
var $020adc43040d8b88$var$ModalPortal = function(_Component) {
    $020adc43040d8b88$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $020adc43040d8b88$var$_classCallCheck(this, ModalPortal);
        var _this = $020adc43040d8b88$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $020adc43040d8b88$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $020adc43040d8b88$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $020adc43040d8b88$var$ariaHiddenInstances > 0) {
                $020adc43040d8b88$var$ariaHiddenInstances -= 1;
                if ($020adc43040d8b88$var$ariaHiddenInstances === 0) $020adc43040d8b88$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $020adc43040d8b88$var$focusManager.returnFocus(_this.props.preventScroll);
                    $020adc43040d8b88$var$focusManager.teardownScopedFocus();
                } else $020adc43040d8b88$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $020adc43040d8b88$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $020adc43040d8b88$var$focusManager.setupScopedFocus(_this.node);
                    $020adc43040d8b88$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($020adc43040d8b88$var$isTabKey(event)) (0, $020adc43040d8b88$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $020adc43040d8b88$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $020adc43040d8b88$var$_typeof(additional)) === "object" ? additional : {
                base: $020adc43040d8b88$var$CLASS_NAMES[which],
                afterOpen: $020adc43040d8b88$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $020adc43040d8b88$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $020adc43040d8b88$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $020adc43040d8b88$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $020adc43040d8b88$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $020adc43040d8b88$var$ariaHiddenInstances += 1;
                    $020adc43040d8b88$var$ariaAppHider.hide(appElement);
                }
                $020adc43040d8b88$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $020adc43040d8b88$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $020adc43040d8b88$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $020adc43040d8b88$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $020adc43040d8b88$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($dup7A.Component);
$020adc43040d8b88$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$020adc43040d8b88$var$ModalPortal.propTypes = {
    isOpen: $020adc43040d8b88$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $020adc43040d8b88$var$_propTypes2.default.shape({
        content: $020adc43040d8b88$var$_propTypes2.default.object,
        overlay: $020adc43040d8b88$var$_propTypes2.default.object
    }),
    style: $020adc43040d8b88$var$_propTypes2.default.shape({
        content: $020adc43040d8b88$var$_propTypes2.default.object,
        overlay: $020adc43040d8b88$var$_propTypes2.default.object
    }),
    className: $020adc43040d8b88$var$_propTypes2.default.oneOfType([
        $020adc43040d8b88$var$_propTypes2.default.string,
        $020adc43040d8b88$var$_propTypes2.default.object
    ]),
    overlayClassName: $020adc43040d8b88$var$_propTypes2.default.oneOfType([
        $020adc43040d8b88$var$_propTypes2.default.string,
        $020adc43040d8b88$var$_propTypes2.default.object
    ]),
    parentSelector: $020adc43040d8b88$var$_propTypes2.default.func,
    bodyOpenClassName: $020adc43040d8b88$var$_propTypes2.default.string,
    htmlOpenClassName: $020adc43040d8b88$var$_propTypes2.default.string,
    ariaHideApp: $020adc43040d8b88$var$_propTypes2.default.bool,
    appElement: $020adc43040d8b88$var$_propTypes2.default.oneOfType([
        $020adc43040d8b88$var$_propTypes2.default.instanceOf($020adc43040d8b88$var$_safeHTMLElement2.default),
        $020adc43040d8b88$var$_propTypes2.default.instanceOf($52cb980a881c1dff$exports.SafeHTMLCollection),
        $020adc43040d8b88$var$_propTypes2.default.instanceOf($52cb980a881c1dff$exports.SafeNodeList),
        $020adc43040d8b88$var$_propTypes2.default.arrayOf($020adc43040d8b88$var$_propTypes2.default.instanceOf($020adc43040d8b88$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $020adc43040d8b88$var$_propTypes2.default.func,
    onAfterClose: $020adc43040d8b88$var$_propTypes2.default.func,
    onRequestClose: $020adc43040d8b88$var$_propTypes2.default.func,
    closeTimeoutMS: $020adc43040d8b88$var$_propTypes2.default.number,
    shouldFocusAfterRender: $020adc43040d8b88$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $020adc43040d8b88$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $020adc43040d8b88$var$_propTypes2.default.bool,
    preventScroll: $020adc43040d8b88$var$_propTypes2.default.bool,
    role: $020adc43040d8b88$var$_propTypes2.default.string,
    contentLabel: $020adc43040d8b88$var$_propTypes2.default.string,
    aria: $020adc43040d8b88$var$_propTypes2.default.object,
    data: $020adc43040d8b88$var$_propTypes2.default.object,
    children: $020adc43040d8b88$var$_propTypes2.default.node,
    shouldCloseOnEsc: $020adc43040d8b88$var$_propTypes2.default.bool,
    overlayRef: $020adc43040d8b88$var$_propTypes2.default.func,
    contentRef: $020adc43040d8b88$var$_propTypes2.default.func,
    id: $020adc43040d8b88$var$_propTypes2.default.string,
    overlayElement: $020adc43040d8b88$var$_propTypes2.default.func,
    contentElement: $020adc43040d8b88$var$_propTypes2.default.func,
    testId: $020adc43040d8b88$var$_propTypes2.default.string
};
$020adc43040d8b88$exports.default = $020adc43040d8b88$var$ModalPortal;
$020adc43040d8b88$exports = $020adc43040d8b88$exports["default"];


var $611c60e403e100c1$var$_ModalPortal2 = $611c60e403e100c1$var$_interopRequireDefault($020adc43040d8b88$exports);

var $611c60e403e100c1$var$ariaAppHider = $611c60e403e100c1$var$_interopRequireWildcard($96e4f8b3f7d4805e$exports);

var $611c60e403e100c1$var$_safeHTMLElement2 = $611c60e403e100c1$var$_interopRequireDefault($52cb980a881c1dff$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $302c0fae4d2031e7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $302c0fae4d2031e7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $302c0fae4d2031e7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$302c0fae4d2031e7$var$componentWillMount.__suppressDeprecationWarning = true;
$302c0fae4d2031e7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$302c0fae4d2031e7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $302c0fae4d2031e7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $302c0fae4d2031e7$var$componentWillMount;
        prototype.componentWillReceiveProps = $302c0fae4d2031e7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $302c0fae4d2031e7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $611c60e403e100c1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $611c60e403e100c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $611c60e403e100c1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $611c60e403e100c1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $611c60e403e100c1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $611c60e403e100c1$var$portalClassName = $611c60e403e100c1$exports.portalClassName = "ReactModalPortal";
var $611c60e403e100c1$var$bodyOpenClassName = $611c60e403e100c1$exports.bodyOpenClassName = "ReactModal__Body--open";
var $611c60e403e100c1$var$isReact16 = $52cb980a881c1dff$exports.canUseDOM && $611c60e403e100c1$var$_reactDom2.default.createPortal !== undefined;
var $611c60e403e100c1$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $611c60e403e100c1$var$getCreatePortal = function getCreatePortal() {
    return $611c60e403e100c1$var$isReact16 ? $611c60e403e100c1$var$_reactDom2.default.createPortal : $611c60e403e100c1$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $611c60e403e100c1$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $611c60e403e100c1$var$Modal = function(_Component) {
    $611c60e403e100c1$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $611c60e403e100c1$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $611c60e403e100c1$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$611c60e403e100c1$var$isReact16 && $611c60e403e100c1$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $611c60e403e100c1$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $611c60e403e100c1$var$getCreatePortal();
            var portal = createPortal(_this, $611c60e403e100c1$var$_react2.default.createElement($611c60e403e100c1$var$_ModalPortal2.default, $611c60e403e100c1$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $611c60e403e100c1$var$_possibleConstructorReturn(_this, _ret);
    }
    $611c60e403e100c1$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$52cb980a881c1dff$exports.canUseDOM) return;
                if (!$611c60e403e100c1$var$isReact16) this.node = $611c60e403e100c1$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $611c60e403e100c1$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$611c60e403e100c1$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $611c60e403e100c1$var$getParentElement(prevProps.parentSelector);
                var nextParent = $611c60e403e100c1$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$52cb980a881c1dff$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$611c60e403e100c1$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$52cb980a881c1dff$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$52cb980a881c1dff$exports.canUseDOM || !$611c60e403e100c1$var$isReact16) return null;
                if (!this.node && $611c60e403e100c1$var$isReact16) this.node = $611c60e403e100c1$var$createHTMLElement("div");
                var createPortal = $611c60e403e100c1$var$getCreatePortal();
                return createPortal($611c60e403e100c1$var$_react2.default.createElement($611c60e403e100c1$var$_ModalPortal2.default, $611c60e403e100c1$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $611c60e403e100c1$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($dup7A.Component);
$611c60e403e100c1$var$Modal.propTypes = {
    isOpen: $611c60e403e100c1$var$_propTypes2.default.bool.isRequired,
    style: $611c60e403e100c1$var$_propTypes2.default.shape({
        content: $611c60e403e100c1$var$_propTypes2.default.object,
        overlay: $611c60e403e100c1$var$_propTypes2.default.object
    }),
    portalClassName: $611c60e403e100c1$var$_propTypes2.default.string,
    bodyOpenClassName: $611c60e403e100c1$var$_propTypes2.default.string,
    htmlOpenClassName: $611c60e403e100c1$var$_propTypes2.default.string,
    className: $611c60e403e100c1$var$_propTypes2.default.oneOfType([
        $611c60e403e100c1$var$_propTypes2.default.string,
        $611c60e403e100c1$var$_propTypes2.default.shape({
            base: $611c60e403e100c1$var$_propTypes2.default.string.isRequired,
            afterOpen: $611c60e403e100c1$var$_propTypes2.default.string.isRequired,
            beforeClose: $611c60e403e100c1$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $611c60e403e100c1$var$_propTypes2.default.oneOfType([
        $611c60e403e100c1$var$_propTypes2.default.string,
        $611c60e403e100c1$var$_propTypes2.default.shape({
            base: $611c60e403e100c1$var$_propTypes2.default.string.isRequired,
            afterOpen: $611c60e403e100c1$var$_propTypes2.default.string.isRequired,
            beforeClose: $611c60e403e100c1$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $611c60e403e100c1$var$_propTypes2.default.oneOfType([
        $611c60e403e100c1$var$_propTypes2.default.instanceOf($611c60e403e100c1$var$_safeHTMLElement2.default),
        $611c60e403e100c1$var$_propTypes2.default.instanceOf($52cb980a881c1dff$exports.SafeHTMLCollection),
        $611c60e403e100c1$var$_propTypes2.default.instanceOf($52cb980a881c1dff$exports.SafeNodeList),
        $611c60e403e100c1$var$_propTypes2.default.arrayOf($611c60e403e100c1$var$_propTypes2.default.instanceOf($611c60e403e100c1$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $611c60e403e100c1$var$_propTypes2.default.func,
    onRequestClose: $611c60e403e100c1$var$_propTypes2.default.func,
    closeTimeoutMS: $611c60e403e100c1$var$_propTypes2.default.number,
    ariaHideApp: $611c60e403e100c1$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $611c60e403e100c1$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $611c60e403e100c1$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $611c60e403e100c1$var$_propTypes2.default.bool,
    preventScroll: $611c60e403e100c1$var$_propTypes2.default.bool,
    parentSelector: $611c60e403e100c1$var$_propTypes2.default.func,
    aria: $611c60e403e100c1$var$_propTypes2.default.object,
    data: $611c60e403e100c1$var$_propTypes2.default.object,
    role: $611c60e403e100c1$var$_propTypes2.default.string,
    contentLabel: $611c60e403e100c1$var$_propTypes2.default.string,
    shouldCloseOnEsc: $611c60e403e100c1$var$_propTypes2.default.bool,
    overlayRef: $611c60e403e100c1$var$_propTypes2.default.func,
    contentRef: $611c60e403e100c1$var$_propTypes2.default.func,
    id: $611c60e403e100c1$var$_propTypes2.default.string,
    overlayElement: $611c60e403e100c1$var$_propTypes2.default.func,
    contentElement: $611c60e403e100c1$var$_propTypes2.default.func
};
$611c60e403e100c1$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $611c60e403e100c1$var$portalClassName,
    bodyOpenClassName: $611c60e403e100c1$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $611c60e403e100c1$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $611c60e403e100c1$var$_react2.default.createElement("div", props, children);
    }
};
$611c60e403e100c1$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $302c0fae4d2031e7$export$cea1c58a6db52bca)($611c60e403e100c1$var$Modal);
$611c60e403e100c1$exports.default = $611c60e403e100c1$var$Modal;


var $939f14b26ca18529$var$_Modal2 = $939f14b26ca18529$var$_interopRequireDefault($611c60e403e100c1$exports);
function $939f14b26ca18529$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$939f14b26ca18529$exports.default = $939f14b26ca18529$var$_Modal2.default;
$939f14b26ca18529$exports = $939f14b26ca18529$exports["default"];


/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dup7A = parcelRequire("dup7A");

/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $812c9a0500c51f61$var$_extends() {
    $812c9a0500c51f61$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $812c9a0500c51f61$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $812c9a0500c51f61$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($812c9a0500c51f61$export$e19cd5f9376f8cee || ($812c9a0500c51f61$export$e19cd5f9376f8cee = {}));
const $812c9a0500c51f61$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $812c9a0500c51f61$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $812c9a0500c51f61$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $812c9a0500c51f61$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $812c9a0500c51f61$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $812c9a0500c51f61$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $812c9a0500c51f61$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $812c9a0500c51f61$export$fe53371bee54353d(to);
    }
    return $812c9a0500c51f61$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $812c9a0500c51f61$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $812c9a0500c51f61$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $812c9a0500c51f61$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $812c9a0500c51f61$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $812c9a0500c51f61$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $812c9a0500c51f61$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $812c9a0500c51f61$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $812c9a0500c51f61$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $812c9a0500c51f61$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $812c9a0500c51f61$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $812c9a0500c51f61$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $812c9a0500c51f61$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $812c9a0500c51f61$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $812c9a0500c51f61$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $812c9a0500c51f61$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $812c9a0500c51f61$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($812c9a0500c51f61$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Push;
        let location = $812c9a0500c51f61$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $812c9a0500c51f61$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace;
        let location = $812c9a0500c51f61$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $812c9a0500c51f61$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $812c9a0500c51f61$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $812c9a0500c51f61$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($812c9a0500c51f61$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($812c9a0500c51f61$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $812c9a0500c51f61$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($812c9a0500c51f61$var$ResultType || ($812c9a0500c51f61$var$ResultType = {}));
const $812c9a0500c51f61$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $812c9a0500c51f61$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $812c9a0500c51f61$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $812c9a0500c51f61$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $812c9a0500c51f61$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($812c9a0500c51f61$var$isIndexRoute(route)) {
            let indexRoute = $812c9a0500c51f61$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $812c9a0500c51f61$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $812c9a0500c51f61$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $812c9a0500c51f61$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $812c9a0500c51f61$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $812c9a0500c51f61$var$flattenRoutes(routes);
    $812c9a0500c51f61$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $812c9a0500c51f61$var$decodePath(pathname);
        matches = $812c9a0500c51f61$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $812c9a0500c51f61$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $812c9a0500c51f61$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $812c9a0500c51f61$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $812c9a0500c51f61$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $812c9a0500c51f61$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $812c9a0500c51f61$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $812c9a0500c51f61$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $812c9a0500c51f61$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $812c9a0500c51f61$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $812c9a0500c51f61$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $812c9a0500c51f61$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $812c9a0500c51f61$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $812c9a0500c51f61$var$paramRe = /^:[\w-]+$/;
const $812c9a0500c51f61$var$dynamicSegmentValue = 3;
const $812c9a0500c51f61$var$indexRouteValue = 2;
const $812c9a0500c51f61$var$emptySegmentValue = 1;
const $812c9a0500c51f61$var$staticSegmentValue = 10;
const $812c9a0500c51f61$var$splatPenalty = -2;
const $812c9a0500c51f61$var$isSplat = (s)=>s === "*";
function $812c9a0500c51f61$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($812c9a0500c51f61$var$isSplat)) initialScore += $812c9a0500c51f61$var$splatPenalty;
    if (index) initialScore += $812c9a0500c51f61$var$indexRouteValue;
    return segments.filter((s)=>!$812c9a0500c51f61$var$isSplat(s)).reduce((score, segment)=>score + ($812c9a0500c51f61$var$paramRe.test(segment) ? $812c9a0500c51f61$var$dynamicSegmentValue : segment === "" ? $812c9a0500c51f61$var$emptySegmentValue : $812c9a0500c51f61$var$staticSegmentValue), initialScore);
}
function $812c9a0500c51f61$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $812c9a0500c51f61$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $812c9a0500c51f61$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $812c9a0500c51f61$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $812c9a0500c51f61$export$a5c6d149b50c1d86($812c9a0500c51f61$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $812c9a0500c51f61$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $812c9a0500c51f61$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $812c9a0500c51f61$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $812c9a0500c51f61$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $812c9a0500c51f61$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $812c9a0500c51f61$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $812c9a0500c51f61$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $812c9a0500c51f61$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $812c9a0500c51f61$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $812c9a0500c51f61$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $812c9a0500c51f61$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $812c9a0500c51f61$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $812c9a0500c51f61$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $812c9a0500c51f61$var$normalizeSearch(search),
        hash: $812c9a0500c51f61$var$normalizeHash(hash)
    };
}
function $812c9a0500c51f61$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $812c9a0500c51f61$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $812c9a0500c51f61$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $812c9a0500c51f61$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $812c9a0500c51f61$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $812c9a0500c51f61$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $812c9a0500c51f61$export$8ccf933b0513f8d0(toArg);
    else {
        to = $812c9a0500c51f61$var$_extends({}, toArg);
        $812c9a0500c51f61$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $812c9a0500c51f61$var$getInvalidPathError("?", "pathname", "search", to));
        $812c9a0500c51f61$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $812c9a0500c51f61$var$getInvalidPathError("#", "pathname", "hash", to));
        $812c9a0500c51f61$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $812c9a0500c51f61$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $812c9a0500c51f61$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $812c9a0500c51f61$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $812c9a0500c51f61$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $812c9a0500c51f61$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $812c9a0500c51f61$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $812c9a0500c51f61$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $812c9a0500c51f61$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $812c9a0500c51f61$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $812c9a0500c51f61$export$42a99a7a4bc0e76a extends Error {
}
class $812c9a0500c51f61$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $812c9a0500c51f61$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $812c9a0500c51f61$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $812c9a0500c51f61$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $812c9a0500c51f61$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $812c9a0500c51f61$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $812c9a0500c51f61$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $812c9a0500c51f61$var$unwrapTrackedPromise(value) {
    if (!$812c9a0500c51f61$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $812c9a0500c51f61$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $812c9a0500c51f61$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $812c9a0500c51f61$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $812c9a0500c51f61$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $812c9a0500c51f61$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $812c9a0500c51f61$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $812c9a0500c51f61$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $812c9a0500c51f61$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $812c9a0500c51f61$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $812c9a0500c51f61$var$validMutationMethods = new Set($812c9a0500c51f61$var$validMutationMethodsArr);
const $812c9a0500c51f61$var$validRequestMethodsArr = [
    "get",
    ...$812c9a0500c51f61$var$validMutationMethodsArr
];
const $812c9a0500c51f61$var$validRequestMethods = new Set($812c9a0500c51f61$var$validRequestMethodsArr);
const $812c9a0500c51f61$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $812c9a0500c51f61$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $812c9a0500c51f61$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $812c9a0500c51f61$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $812c9a0500c51f61$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $812c9a0500c51f61$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $812c9a0500c51f61$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $812c9a0500c51f61$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $812c9a0500c51f61$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $812c9a0500c51f61$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $812c9a0500c51f61$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $812c9a0500c51f61$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $812c9a0500c51f61$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $812c9a0500c51f61$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $812c9a0500c51f61$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $812c9a0500c51f61$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $812c9a0500c51f61$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $812c9a0500c51f61$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $812c9a0500c51f61$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $812c9a0500c51f61$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $812c9a0500c51f61$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$812c9a0500c51f61$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($812c9a0500c51f61$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $812c9a0500c51f61$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $812c9a0500c51f61$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $812c9a0500c51f61$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $812c9a0500c51f61$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $812c9a0500c51f61$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $812c9a0500c51f61$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($812c9a0500c51f61$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $812c9a0500c51f61$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $812c9a0500c51f61$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $812c9a0500c51f61$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $812c9a0500c51f61$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $812c9a0500c51f61$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $812c9a0500c51f61$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $812c9a0500c51f61$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $812c9a0500c51f61$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $812c9a0500c51f61$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $812c9a0500c51f61$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $812c9a0500c51f61$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $812c9a0500c51f61$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $812c9a0500c51f61$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $812c9a0500c51f61$var$findNearestBoundary(matches).route.id,
            {
                type: $812c9a0500c51f61$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $812c9a0500c51f61$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $812c9a0500c51f61$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $812c9a0500c51f61$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $812c9a0500c51f61$var$_extends({
            matches: matches
        }, $812c9a0500c51f61$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $812c9a0500c51f61$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $812c9a0500c51f61$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $812c9a0500c51f61$var$ResultType.error,
            error: $812c9a0500c51f61$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($812c9a0500c51f61$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $812c9a0500c51f61$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($812c9a0500c51f61$var$isDeferredResult(result)) throw $812c9a0500c51f61$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($812c9a0500c51f61$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $812c9a0500c51f61$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $812c9a0500c51f61$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $812c9a0500c51f61$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $812c9a0500c51f61$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $812c9a0500c51f61$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $812c9a0500c51f61$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $812c9a0500c51f61$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $812c9a0500c51f61$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$812c9a0500c51f61$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($812c9a0500c51f61$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $812c9a0500c51f61$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $812c9a0500c51f61$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $812c9a0500c51f61$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $812c9a0500c51f61$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $812c9a0500c51f61$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $812c9a0500c51f61$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $812c9a0500c51f61$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $812c9a0500c51f61$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $812c9a0500c51f61$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $812c9a0500c51f61$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $812c9a0500c51f61$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $812c9a0500c51f61$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($812c9a0500c51f61$var$isRedirectResult(actionResult) || $812c9a0500c51f61$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $812c9a0500c51f61$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($812c9a0500c51f61$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $812c9a0500c51f61$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $812c9a0500c51f61$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($812c9a0500c51f61$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($812c9a0500c51f61$var$isDeferredResult(actionResult)) throw $812c9a0500c51f61$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $812c9a0500c51f61$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $812c9a0500c51f61$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $812c9a0500c51f61$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $812c9a0500c51f61$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $812c9a0500c51f61$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $812c9a0500c51f61$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $812c9a0500c51f61$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $812c9a0500c51f61$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $812c9a0500c51f61$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $812c9a0500c51f61$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $812c9a0500c51f61$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $812c9a0500c51f61$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $812c9a0500c51f61$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($812c9a0500c51f61$var$isDeferredResult(result)) result = await $812c9a0500c51f61$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $812c9a0500c51f61$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($812c9a0500c51f61$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $812c9a0500c51f61$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($812c9a0500c51f61$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $812c9a0500c51f61$export$3e9cee6b33872309(!$812c9a0500c51f61$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $812c9a0500c51f61$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $812c9a0500c51f61$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $812c9a0500c51f61$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $812c9a0500c51f61$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($812c9a0500c51f61$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $812c9a0500c51f61$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $812c9a0500c51f61$export$e19cd5f9376f8cee.Replace : $812c9a0500c51f61$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $812c9a0500c51f61$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($812c9a0500c51f61$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $812c9a0500c51f61$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $812c9a0500c51f61$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $812c9a0500c51f61$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $812c9a0500c51f61$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($812c9a0500c51f61$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $812c9a0500c51f61$var$ResultType.redirect,
                        response: $812c9a0500c51f61$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $812c9a0500c51f61$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $812c9a0500c51f61$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $812c9a0500c51f61$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $812c9a0500c51f61$var$ResultType.error,
                    error: $812c9a0500c51f61$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $812c9a0500c51f61$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $812c9a0500c51f61$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $812c9a0500c51f61$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $812c9a0500c51f61$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $812c9a0500c51f61$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $812c9a0500c51f61$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $812c9a0500c51f61$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $812c9a0500c51f61$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $812c9a0500c51f61$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $812c9a0500c51f61$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $812c9a0500c51f61$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $812c9a0500c51f61$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $812c9a0500c51f61$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$812c9a0500c51f61$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $812c9a0500c51f61$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $812c9a0500c51f61$export$4d0306f8f6a4585b = Symbol("deferred");
function $812c9a0500c51f61$export$3336b097a6fbc59a(routes, opts) {
    $812c9a0500c51f61$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $812c9a0500c51f61$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $812c9a0500c51f61$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $812c9a0500c51f61$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $812c9a0500c51f61$var$createLocation("", $812c9a0500c51f61$export$fe53371bee54353d(url), null, "default");
        let matches = $812c9a0500c51f61$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$812c9a0500c51f61$var$isValidMethod(method) && method !== "HEAD") {
            let error = $812c9a0500c51f61$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $812c9a0500c51f61$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $812c9a0500c51f61$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $812c9a0500c51f61$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($812c9a0500c51f61$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $812c9a0500c51f61$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $812c9a0500c51f61$var$createLocation("", $812c9a0500c51f61$export$fe53371bee54353d(url), null, "default");
        let matches = $812c9a0500c51f61$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$812c9a0500c51f61$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $812c9a0500c51f61$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $812c9a0500c51f61$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $812c9a0500c51f61$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $812c9a0500c51f61$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $812c9a0500c51f61$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($812c9a0500c51f61$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$812c9a0500c51f61$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $812c9a0500c51f61$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($812c9a0500c51f61$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $812c9a0500c51f61$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $812c9a0500c51f61$var$isResponse(result) ? result : $812c9a0500c51f61$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($812c9a0500c51f61$var$isHandlerResult(e) && $812c9a0500c51f61$var$isResponse(e.result)) {
                if (e.type === $812c9a0500c51f61$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($812c9a0500c51f61$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $812c9a0500c51f61$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $812c9a0500c51f61$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $812c9a0500c51f61$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($812c9a0500c51f61$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($812c9a0500c51f61$var$isDeferredResult(result)) {
            let error = $812c9a0500c51f61$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $812c9a0500c51f61$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($812c9a0500c51f61$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($812c9a0500c51f61$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $812c9a0500c51f61$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $812c9a0500c51f61$var$_extends({}, context, {
                statusCode: $812c9a0500c51f61$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $812c9a0500c51f61$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $812c9a0500c51f61$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $812c9a0500c51f61$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? $812c9a0500c51f61$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $812c9a0500c51f61$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $812c9a0500c51f61$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $812c9a0500c51f61$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $812c9a0500c51f61$var$callDataStrategyImpl(unstable_dataStrategy || $812c9a0500c51f61$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($812c9a0500c51f61$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $812c9a0500c51f61$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($812c9a0500c51f61$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $812c9a0500c51f61$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $812c9a0500c51f61$export$fec11da027c70692(routes, context, error) {
    let newContext = $812c9a0500c51f61$var$_extends({}, context, {
        statusCode: $812c9a0500c51f61$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $812c9a0500c51f61$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $812c9a0500c51f61$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $812c9a0500c51f61$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $812c9a0500c51f61$export$cae722b0cc860f13(to ? to : ".", $812c9a0500c51f61$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $812c9a0500c51f61$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$812c9a0500c51f61$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $812c9a0500c51f61$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $812c9a0500c51f61$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $812c9a0500c51f61$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$812c9a0500c51f61$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$812c9a0500c51f61$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $812c9a0500c51f61$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $812c9a0500c51f61$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $812c9a0500c51f61$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$812c9a0500c51f61$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$812c9a0500c51f61$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $812c9a0500c51f61$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $812c9a0500c51f61$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $812c9a0500c51f61$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $812c9a0500c51f61$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $812c9a0500c51f61$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($812c9a0500c51f61$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $812c9a0500c51f61$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $812c9a0500c51f61$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $812c9a0500c51f61$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $812c9a0500c51f61$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $812c9a0500c51f61$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $812c9a0500c51f61$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($812c9a0500c51f61$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $812c9a0500c51f61$var$shouldRevalidateLoader(match, $812c9a0500c51f61$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $812c9a0500c51f61$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $812c9a0500c51f61$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $812c9a0500c51f61$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $812c9a0500c51f61$var$shouldRevalidateLoader(fetcherMatch, $812c9a0500c51f61$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $812c9a0500c51f61$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $812c9a0500c51f61$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $812c9a0500c51f61$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $812c9a0500c51f61$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $812c9a0500c51f61$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $812c9a0500c51f61$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$812c9a0500c51f61$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $812c9a0500c51f61$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $812c9a0500c51f61$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $812c9a0500c51f61$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $812c9a0500c51f61$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $812c9a0500c51f61$var$ResultType.data,
                    result: undefined
                });
            };
            return $812c9a0500c51f61$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$812c9a0500c51f61$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $812c9a0500c51f61$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $812c9a0500c51f61$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $812c9a0500c51f61$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $812c9a0500c51f61$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $812c9a0500c51f61$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $812c9a0500c51f61$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $812c9a0500c51f61$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $812c9a0500c51f61$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $812c9a0500c51f61$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($812c9a0500c51f61$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $812c9a0500c51f61$var$ResultType.error,
                error: e
            };
        }
        if (type === $812c9a0500c51f61$var$ResultType.error) return {
            type: $812c9a0500c51f61$var$ResultType.error,
            error: new $812c9a0500c51f61$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $812c9a0500c51f61$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $812c9a0500c51f61$var$ResultType.error) return {
        type: $812c9a0500c51f61$var$ResultType.error,
        error: result,
        statusCode: $812c9a0500c51f61$export$972111febbeef05b(result) ? result.status : status
    };
    if ($812c9a0500c51f61$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $812c9a0500c51f61$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $812c9a0500c51f61$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $812c9a0500c51f61$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $812c9a0500c51f61$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$812c9a0500c51f61$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $812c9a0500c51f61$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $812c9a0500c51f61$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($812c9a0500c51f61$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $812c9a0500c51f61$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $812c9a0500c51f61$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($812c9a0500c51f61$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $812c9a0500c51f61$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $812c9a0500c51f61$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $812c9a0500c51f61$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $812c9a0500c51f61$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $812c9a0500c51f61$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $812c9a0500c51f61$export$3e9cee6b33872309(!$812c9a0500c51f61$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($812c9a0500c51f61$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $812c9a0500c51f61$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $812c9a0500c51f61$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($812c9a0500c51f61$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $812c9a0500c51f61$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $812c9a0500c51f61$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $812c9a0500c51f61$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($812c9a0500c51f61$var$isErrorResult(result)) {
            let boundaryMatch = $812c9a0500c51f61$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $812c9a0500c51f61$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($812c9a0500c51f61$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $812c9a0500c51f61$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($812c9a0500c51f61$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $812c9a0500c51f61$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $812c9a0500c51f61$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $812c9a0500c51f61$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $812c9a0500c51f61$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $812c9a0500c51f61$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $812c9a0500c51f61$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $812c9a0500c51f61$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $812c9a0500c51f61$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $812c9a0500c51f61$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $812c9a0500c51f61$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $812c9a0500c51f61$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($812c9a0500c51f61$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $812c9a0500c51f61$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(path) : path;
    return $812c9a0500c51f61$export$fe53371bee54353d($812c9a0500c51f61$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $812c9a0500c51f61$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $812c9a0500c51f61$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $812c9a0500c51f61$var$ResultType.data || result.type === $812c9a0500c51f61$var$ResultType.error);
}
function $812c9a0500c51f61$var$isRedirectHandlerResult(result) {
    return $812c9a0500c51f61$var$isResponse(result.result) && $812c9a0500c51f61$var$redirectStatusCodes.has(result.result.status);
}
function $812c9a0500c51f61$var$isDeferredResult(result) {
    return result.type === $812c9a0500c51f61$var$ResultType.deferred;
}
function $812c9a0500c51f61$var$isErrorResult(result) {
    return result.type === $812c9a0500c51f61$var$ResultType.error;
}
function $812c9a0500c51f61$var$isRedirectResult(result) {
    return (result && result.type) === $812c9a0500c51f61$var$ResultType.redirect;
}
function $812c9a0500c51f61$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $812c9a0500c51f61$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $812c9a0500c51f61$var$isRedirectResponse(result) {
    if (!$812c9a0500c51f61$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $812c9a0500c51f61$var$isValidMethod(method) {
    return $812c9a0500c51f61$var$validRequestMethods.has(method.toLowerCase());
}
function $812c9a0500c51f61$var$isMutationMethod(method) {
    return $812c9a0500c51f61$var$validMutationMethods.has(method.toLowerCase());
}
async function $812c9a0500c51f61$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$812c9a0500c51f61$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($812c9a0500c51f61$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $812c9a0500c51f61$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $812c9a0500c51f61$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $812c9a0500c51f61$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $812c9a0500c51f61$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $812c9a0500c51f61$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $812c9a0500c51f61$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $812c9a0500c51f61$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $812c9a0500c51f61$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $812c9a0500c51f61$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $812c9a0500c51f61$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $812c9a0500c51f61$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $812c9a0500c51f61$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $812c9a0500c51f61$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $812c9a0500c51f61$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $812c9a0500c51f61$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $812c9a0500c51f61$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $812c9a0500c51f61$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $812c9a0500c51f61$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($812c9a0500c51f61$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $812c9a0500c51f61$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($812c9a0500c51f61$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $812c9a0500c51f61$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dup7A = parcelRequire("dup7A");

function $5c6d50c15e61ec01$var$_extends() {
    $5c6d50c15e61ec01$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5c6d50c15e61ec01$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5c6d50c15e61ec01$export$3add0d5dce533e2e = /*#__PURE__*/ $dup7A.createContext(null);
const $5c6d50c15e61ec01$export$145dfa71566a64dc = /*#__PURE__*/ $dup7A.createContext(null);
const $5c6d50c15e61ec01$var$AwaitContext = /*#__PURE__*/ $dup7A.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5c6d50c15e61ec01$export$26749e8557646306 = /*#__PURE__*/ $dup7A.createContext(null);
const $5c6d50c15e61ec01$export$c7914228fb69b0f5 = /*#__PURE__*/ $dup7A.createContext(null);
const $5c6d50c15e61ec01$export$9072aa6dd1f93057 = /*#__PURE__*/ $dup7A.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5c6d50c15e61ec01$var$RouteErrorContext = /*#__PURE__*/ $dup7A.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $5c6d50c15e61ec01$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5c6d50c15e61ec01$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $812c9a0500c51f61$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $5c6d50c15e61ec01$export$9c954a9d03d32f4a() {
    return $dup7A.useContext($5c6d50c15e61ec01$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $5c6d50c15e61ec01$export$45d76561a5302f2b() {
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return $dup7A.useContext($5c6d50c15e61ec01$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $5c6d50c15e61ec01$export$1b3f31771c5d07c() {
    return $dup7A.useContext($5c6d50c15e61ec01$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $5c6d50c15e61ec01$export$6c330e8992e8a295(pattern) {
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $5c6d50c15e61ec01$export$45d76561a5302f2b();
    return $dup7A.useMemo(()=>(0, $812c9a0500c51f61$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5c6d50c15e61ec01$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5c6d50c15e61ec01$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dup7A.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $5c6d50c15e61ec01$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5c6d50c15e61ec01$var$useNavigateStable() : $5c6d50c15e61ec01$var$useNavigateUnstable();
}
function $5c6d50c15e61ec01$var$useNavigateUnstable() {
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let dataRouterContext = $dup7A.useContext($5c6d50c15e61ec01$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306);
    let { matches: matches } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c6d50c15e61ec01$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $812c9a0500c51f61$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $dup7A.useRef(false);
    $5c6d50c15e61ec01$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dup7A.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $812c9a0500c51f61$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $812c9a0500c51f61$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5c6d50c15e61ec01$var$OutletContext = /*#__PURE__*/ $dup7A.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $5c6d50c15e61ec01$export$4138103a3ae699cc() {
    return $dup7A.useContext($5c6d50c15e61ec01$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $5c6d50c15e61ec01$export$a3be3530d8e40d0b(context) {
    let outlet = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $5c6d50c15e61ec01$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $5c6d50c15e61ec01$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306);
    let { matches: matches } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c6d50c15e61ec01$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $812c9a0500c51f61$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $dup7A.useMemo(()=>(0, $812c9a0500c51f61$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $5c6d50c15e61ec01$export$5d3fca4a98652595(routes, locationArg) {
    return $5c6d50c15e61ec01$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5c6d50c15e61ec01$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306);
    let { matches: parentMatches } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5c6d50c15e61ec01$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $812c9a0500c51f61$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $812c9a0500c51f61$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5c6d50c15e61ec01$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $812c9a0500c51f61$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $812c9a0500c51f61$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5c6d50c15e61ec01$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $812c9a0500c51f61$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5c6d50c15e61ec01$var$DefaultErrorComponent() {
    let error = $5c6d50c15e61ec01$export$ed527bf60f6e05f2();
    let message = (0, $812c9a0500c51f61$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dup7A.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dup7A.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5c6d50c15e61ec01$var$defaultErrorElement = /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$DefaultErrorComponent, null);
class $5c6d50c15e61ec01$var$RenderErrorBoundary extends $dup7A.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5c6d50c15e61ec01$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dup7A.useContext($5c6d50c15e61ec01$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5c6d50c15e61ec01$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5c6d50c15e61ec01$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5c6d50c15e61ec01$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dup7A.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5c6d50c15e61ec01$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5c6d50c15e61ec01$var$DataRouterHook || {});
var $5c6d50c15e61ec01$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5c6d50c15e61ec01$var$DataRouterStateHook || {});
function $5c6d50c15e61ec01$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5c6d50c15e61ec01$var$useDataRouterContext(hookName) {
    let ctx = $dup7A.useContext($5c6d50c15e61ec01$export$3add0d5dce533e2e);
    !ctx && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5c6d50c15e61ec01$var$useDataRouterState(hookName) {
    let state = $dup7A.useContext($5c6d50c15e61ec01$export$145dfa71566a64dc);
    !state && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return state;
}
function $5c6d50c15e61ec01$var$useRouteContext(hookName) {
    let route = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    !route && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5c6d50c15e61ec01$var$useCurrentRouteId(hookName) {
    let route = $5c6d50c15e61ec01$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5c6d50c15e61ec01$export$5fc8298006ad9e58() {
    return $5c6d50c15e61ec01$var$useCurrentRouteId($5c6d50c15e61ec01$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5c6d50c15e61ec01$export$d0fd4b7106de2769() {
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5c6d50c15e61ec01$export$600dc272ed516c15() {
    let dataRouterContext = $5c6d50c15e61ec01$var$useDataRouterContext($5c6d50c15e61ec01$var$DataRouterHook.UseRevalidator);
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseRevalidator);
    return $dup7A.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5c6d50c15e61ec01$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseMatches);
    return $dup7A.useMemo(()=>matches.map((m)=>(0, $812c9a0500c51f61$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5c6d50c15e61ec01$export$1448a5050d252c4d() {
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5c6d50c15e61ec01$var$useCurrentRouteId($5c6d50c15e61ec01$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5c6d50c15e61ec01$export$fd5d37484eab868d(routeId) {
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5c6d50c15e61ec01$export$fdc00f3f26066d5e() {
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseActionData);
    let routeId = $5c6d50c15e61ec01$var$useCurrentRouteId($5c6d50c15e61ec01$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5c6d50c15e61ec01$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dup7A.useContext($5c6d50c15e61ec01$var$RouteErrorContext);
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseRouteError);
    let routeId = $5c6d50c15e61ec01$var$useCurrentRouteId($5c6d50c15e61ec01$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5c6d50c15e61ec01$export$78a72ddb39bdd145() {
    let value = $dup7A.useContext($5c6d50c15e61ec01$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5c6d50c15e61ec01$export$17f53340677d5831() {
    let value = $dup7A.useContext($5c6d50c15e61ec01$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5c6d50c15e61ec01$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5c6d50c15e61ec01$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5c6d50c15e61ec01$var$useDataRouterContext($5c6d50c15e61ec01$var$DataRouterHook.UseBlocker);
    let state = $5c6d50c15e61ec01$var$useDataRouterState($5c6d50c15e61ec01$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dup7A.useState("");
    let blockerFunction = $dup7A.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5c6d50c15e61ec01$var$_extends({}, currentLocation, {
                pathname: (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5c6d50c15e61ec01$var$_extends({}, nextLocation, {
                pathname: (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dup7A.useEffect(()=>{
        let key = String(++$5c6d50c15e61ec01$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dup7A.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $812c9a0500c51f61$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5c6d50c15e61ec01$var$useNavigateStable() {
    let { router: router } = $5c6d50c15e61ec01$var$useDataRouterContext($5c6d50c15e61ec01$var$DataRouterHook.UseNavigateStable);
    let id = $5c6d50c15e61ec01$var$useCurrentRouteId($5c6d50c15e61ec01$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dup7A.useRef(false);
    $5c6d50c15e61ec01$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dup7A.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5c6d50c15e61ec01$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5c6d50c15e61ec01$var$alreadyWarned = {};
function $5c6d50c15e61ec01$var$warningOnce(key, cond, message) {
    if (!cond && !$5c6d50c15e61ec01$var$alreadyWarned[key]) $5c6d50c15e61ec01$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5c6d50c15e61ec01$var$START_TRANSITION = "startTransition";
const $5c6d50c15e61ec01$var$startTransitionImpl = $dup7A[$5c6d50c15e61ec01$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5c6d50c15e61ec01$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dup7A.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dup7A.useCallback((newState)=>{
        if (v7_startTransition && $5c6d50c15e61ec01$var$startTransitionImpl) $5c6d50c15e61ec01$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dup7A.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dup7A.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dup7A.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dup7A.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5c6d50c15e61ec01$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5c6d50c15e61ec01$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $5c6d50c15e61ec01$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dup7A.useRef();
    if (historyRef.current == null) historyRef.current = (0, $812c9a0500c51f61$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dup7A.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dup7A.useCallback((newState)=>{
        v7_startTransition && $5c6d50c15e61ec01$var$startTransitionImpl ? $5c6d50c15e61ec01$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dup7A.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $5c6d50c15e61ec01$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $dup7A.useContext($5c6d50c15e61ec01$export$26749e8557646306);
    let { matches: matches } = $dup7A.useContext($5c6d50c15e61ec01$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5c6d50c15e61ec01$export$45d76561a5302f2b();
    let navigate = $5c6d50c15e61ec01$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $812c9a0500c51f61$export$cae722b0cc860f13)(to, (0, $812c9a0500c51f61$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dup7A.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $5c6d50c15e61ec01$export$910ae8079b2c2852(props) {
    return $5c6d50c15e61ec01$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $5c6d50c15e61ec01$export$e7b0ac011bb776c6(_props) {
    (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $5c6d50c15e61ec01$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $812c9a0500c51f61$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5c6d50c15e61ec01$export$9c954a9d03d32f4a() && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dup7A.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5c6d50c15e61ec01$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $812c9a0500c51f61$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dup7A.useMemo(()=>{
        let trailingPathname = (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $5c6d50c15e61ec01$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5c6d50c15e61ec01$export$5d3fca4a98652595($5c6d50c15e61ec01$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5c6d50c15e61ec01$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$ResolveAwait, null, children));
}
var $5c6d50c15e61ec01$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5c6d50c15e61ec01$var$AwaitRenderStatus || {});
const $5c6d50c15e61ec01$var$neverSettledPromise = new Promise(()=>{});
class $5c6d50c15e61ec01$var$AwaitErrorBoundary extends $dup7A.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5c6d50c15e61ec01$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5c6d50c15e61ec01$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5c6d50c15e61ec01$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5c6d50c15e61ec01$var$AwaitRenderStatus.error : "_data" in promise ? $5c6d50c15e61ec01$var$AwaitRenderStatus.success : $5c6d50c15e61ec01$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5c6d50c15e61ec01$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5c6d50c15e61ec01$var$AwaitRenderStatus.error && promise._error instanceof (0, $812c9a0500c51f61$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5c6d50c15e61ec01$var$neverSettledPromise;
        if (status === $5c6d50c15e61ec01$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5c6d50c15e61ec01$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5c6d50c15e61ec01$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dup7A.createElement($5c6d50c15e61ec01$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5c6d50c15e61ec01$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5c6d50c15e61ec01$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $5c6d50c15e61ec01$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dup7A.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dup7A.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dup7A.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5c6d50c15e61ec01$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5c6d50c15e61ec01$export$e7b0ac011bb776c6) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5c6d50c15e61ec01$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5c6d50c15e61ec01$export$daf73786167a7f72(matches) {
    return $5c6d50c15e61ec01$var$_renderMatches(matches);
}
function $5c6d50c15e61ec01$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dup7A.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dup7A.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dup7A.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5c6d50c15e61ec01$export$f30f7e456d254e83(routes, opts) {
    return (0, $812c9a0500c51f61$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5c6d50c15e61ec01$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $812c9a0500c51f61$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5c6d50c15e61ec01$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $1d2829c53a2521b2$var$_extends() {
    $1d2829c53a2521b2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d2829c53a2521b2$var$_extends.apply(this, arguments);
}
function $1d2829c53a2521b2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $1d2829c53a2521b2$var$defaultMethod = "get";
const $1d2829c53a2521b2$var$defaultEncType = "application/x-www-form-urlencoded";
function $1d2829c53a2521b2$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $1d2829c53a2521b2$var$isButtonElement(object) {
    return $1d2829c53a2521b2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $1d2829c53a2521b2$var$isFormElement(object) {
    return $1d2829c53a2521b2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $1d2829c53a2521b2$var$isInputElement(object) {
    return $1d2829c53a2521b2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $1d2829c53a2521b2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $1d2829c53a2521b2$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$1d2829c53a2521b2$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $1d2829c53a2521b2$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $1d2829c53a2521b2$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $1d2829c53a2521b2$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $1d2829c53a2521b2$var$_formDataSupportsSubmitter = null;
function $1d2829c53a2521b2$var$isFormDataSubmitterSupported() {
    if ($1d2829c53a2521b2$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $1d2829c53a2521b2$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $1d2829c53a2521b2$var$_formDataSupportsSubmitter = true;
    }
    return $1d2829c53a2521b2$var$_formDataSupportsSubmitter;
}
const $1d2829c53a2521b2$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $1d2829c53a2521b2$var$getFormEncType(encType) {
    if (encType != null && !$1d2829c53a2521b2$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $1d2829c53a2521b2$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($1d2829c53a2521b2$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $1d2829c53a2521b2$var$defaultMethod;
        encType = $1d2829c53a2521b2$var$getFormEncType(target.getAttribute("enctype")) || $1d2829c53a2521b2$var$defaultEncType;
        formData = new FormData(target);
    } else if ($1d2829c53a2521b2$var$isButtonElement(target) || $1d2829c53a2521b2$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $1d2829c53a2521b2$var$defaultMethod;
        encType = $1d2829c53a2521b2$var$getFormEncType(target.getAttribute("formenctype")) || $1d2829c53a2521b2$var$getFormEncType(form.getAttribute("enctype")) || $1d2829c53a2521b2$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$1d2829c53a2521b2$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($1d2829c53a2521b2$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $1d2829c53a2521b2$var$defaultMethod;
        action = null;
        encType = $1d2829c53a2521b2$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $1d2829c53a2521b2$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $1d2829c53a2521b2$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $1d2829c53a2521b2$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $1d2829c53a2521b2$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $1d2829c53a2521b2$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $1d2829c53a2521b2$export$1f3f55432a00e06d(routes, opts) {
    return (0, $812c9a0500c51f61$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $1d2829c53a2521b2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $812c9a0500c51f61$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $1d2829c53a2521b2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5c6d50c15e61ec01$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $1d2829c53a2521b2$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $812c9a0500c51f61$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $1d2829c53a2521b2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $812c9a0500c51f61$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $1d2829c53a2521b2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5c6d50c15e61ec01$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $1d2829c53a2521b2$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $1d2829c53a2521b2$var$_extends({}, state, {
        errors: $1d2829c53a2521b2$var$deserializeErrors(state.errors)
    });
    return state;
}
function $1d2829c53a2521b2$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $812c9a0500c51f61$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $1d2829c53a2521b2$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dup7A.createContext({
    isTransitioning: false
});
const $1d2829c53a2521b2$export$148fd98d095596d4 = /*#__PURE__*/ $dup7A.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $1d2829c53a2521b2$var$START_TRANSITION = "startTransition";
const $1d2829c53a2521b2$var$startTransitionImpl = $dup7A[$1d2829c53a2521b2$var$START_TRANSITION];
const $1d2829c53a2521b2$var$FLUSH_SYNC = "flushSync";
const $1d2829c53a2521b2$var$flushSyncImpl = $e10f5070fc836746$exports[$1d2829c53a2521b2$var$FLUSH_SYNC];
const $1d2829c53a2521b2$var$USE_ID = "useId";
const $1d2829c53a2521b2$var$useIdImpl = $dup7A[$1d2829c53a2521b2$var$USE_ID];
function $1d2829c53a2521b2$var$startTransitionSafe(cb) {
    if ($1d2829c53a2521b2$var$startTransitionImpl) $1d2829c53a2521b2$var$startTransitionImpl(cb);
    else cb();
}
function $1d2829c53a2521b2$var$flushSyncSafe(cb) {
    if ($1d2829c53a2521b2$var$flushSyncImpl) $1d2829c53a2521b2$var$flushSyncImpl(cb);
    else cb();
}
class $1d2829c53a2521b2$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $1d2829c53a2521b2$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dup7A.useState(router.state);
    let [pendingState, setPendingState] = $dup7A.useState();
    let [vtContext, setVtContext] = $dup7A.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dup7A.useState();
    let [transition, setTransition] = $dup7A.useState();
    let [interruption, setInterruption] = $dup7A.useState();
    let fetcherData = $dup7A.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dup7A.useCallback((cb)=>{
        if (v7_startTransition) $1d2829c53a2521b2$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dup7A.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $1d2829c53a2521b2$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $1d2829c53a2521b2$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $1d2829c53a2521b2$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $1d2829c53a2521b2$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $1d2829c53a2521b2$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dup7A.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dup7A.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1d2829c53a2521b2$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dup7A.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dup7A.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dup7A.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dup7A.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dup7A.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dup7A.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dup7A.createElement($dup7A.Fragment, null, /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dup7A.createElement($1d2829c53a2521b2$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dup7A.createElement($1d2829c53a2521b2$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dup7A.createElement($1d2829c53a2521b2$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $1d2829c53a2521b2$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5c6d50c15e61ec01$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $1d2829c53a2521b2$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dup7A.useRef();
    if (historyRef.current == null) historyRef.current = (0, $812c9a0500c51f61$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dup7A.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dup7A.useCallback((newState)=>{
        v7_startTransition && $1d2829c53a2521b2$var$startTransitionImpl ? $1d2829c53a2521b2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dup7A.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $1d2829c53a2521b2$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dup7A.useRef();
    if (historyRef.current == null) historyRef.current = (0, $812c9a0500c51f61$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dup7A.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dup7A.useCallback((newState)=>{
        v7_startTransition && $1d2829c53a2521b2$var$startTransitionImpl ? $1d2829c53a2521b2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dup7A.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $1d2829c53a2521b2$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dup7A.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dup7A.useCallback((newState)=>{
        v7_startTransition && $1d2829c53a2521b2$var$startTransitionImpl ? $1d2829c53a2521b2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dup7A.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $dup7A.createElement((0, $5c6d50c15e61ec01$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $1d2829c53a2521b2$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1d2829c53a2521b2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $1d2829c53a2521b2$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dup7A.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $1d2829c53a2521b2$var$_objectWithoutPropertiesLoose(_ref7, $1d2829c53a2521b2$var$_excluded);
    let { basename: basename } = $dup7A.useContext((0, $5c6d50c15e61ec01$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $1d2829c53a2521b2$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($1d2829c53a2521b2$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5c6d50c15e61ec01$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $1d2829c53a2521b2$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dup7A.createElement("a", $1d2829c53a2521b2$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $1d2829c53a2521b2$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dup7A.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $1d2829c53a2521b2$var$_objectWithoutPropertiesLoose(_ref8, $1d2829c53a2521b2$var$_excluded2);
    let path = (0, $5c6d50c15e61ec01$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    let routerState = $dup7A.useContext((0, $5c6d50c15e61ec01$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $dup7A.useContext((0, $5c6d50c15e61ec01$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1d2829c53a2521b2$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dup7A.createElement($1d2829c53a2521b2$export$a6c7ac8248d6e38a, $1d2829c53a2521b2$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $1d2829c53a2521b2$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dup7A.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $1d2829c53a2521b2$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $1d2829c53a2521b2$var$_objectWithoutPropertiesLoose(_ref9, $1d2829c53a2521b2$var$_excluded3);
    let submit = $1d2829c53a2521b2$export$47c85c6e3a081d3();
    let formAction = $1d2829c53a2521b2$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $dup7A.createElement("form", $1d2829c53a2521b2$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $1d2829c53a2521b2$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $1d2829c53a2521b2$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $1d2829c53a2521b2$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($1d2829c53a2521b2$var$DataRouterHook || ($1d2829c53a2521b2$var$DataRouterHook = {}));
var $1d2829c53a2521b2$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($1d2829c53a2521b2$var$DataRouterStateHook || ($1d2829c53a2521b2$var$DataRouterStateHook = {}));
// Internal hooks
function $1d2829c53a2521b2$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $1d2829c53a2521b2$var$useDataRouterContext(hookName) {
    let ctx = $dup7A.useContext((0, $5c6d50c15e61ec01$export$3add0d5dce533e2e));
    !ctx && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return ctx;
}
function $1d2829c53a2521b2$var$useDataRouterState(hookName) {
    let state = $dup7A.useContext((0, $5c6d50c15e61ec01$export$145dfa71566a64dc));
    !state && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $1d2829c53a2521b2$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    let location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    let path = (0, $5c6d50c15e61ec01$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dup7A.useCallback((event)=>{
        if ($1d2829c53a2521b2$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $812c9a0500c51f61$export$fe53371bee54353d)(location) === (0, $812c9a0500c51f61$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $1d2829c53a2521b2$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dup7A.useRef($1d2829c53a2521b2$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dup7A.useRef(false);
    let location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    let searchParams = $dup7A.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $1d2829c53a2521b2$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    let setSearchParams = $dup7A.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $1d2829c53a2521b2$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $1d2829c53a2521b2$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $1d2829c53a2521b2$var$fetcherId = 0;
let $1d2829c53a2521b2$var$getUniqueFetcherId = ()=>"__" + String(++$1d2829c53a2521b2$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $1d2829c53a2521b2$export$47c85c6e3a081d3() {
    let { router: router } = $1d2829c53a2521b2$var$useDataRouterContext($1d2829c53a2521b2$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dup7A.useContext((0, $5c6d50c15e61ec01$export$26749e8557646306));
    let currentRouteId = (0, $5c6d50c15e61ec01$export$5fc8298006ad9e58)();
    return $dup7A.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $1d2829c53a2521b2$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $1d2829c53a2521b2$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $1d2829c53a2521b2$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $1d2829c53a2521b2$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dup7A.useContext((0, $5c6d50c15e61ec01$export$26749e8557646306));
    let routeContext = $dup7A.useContext((0, $5c6d50c15e61ec01$export$9072aa6dd1f93057));
    !routeContext && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $1d2829c53a2521b2$var$_extends({}, (0, $5c6d50c15e61ec01$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $812c9a0500c51f61$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $812c9a0500c51f61$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $1d2829c53a2521b2$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $1d2829c53a2521b2$var$useDataRouterContext($1d2829c53a2521b2$var$DataRouterHook.UseFetcher);
    let state = $1d2829c53a2521b2$var$useDataRouterState($1d2829c53a2521b2$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dup7A.useContext($1d2829c53a2521b2$export$148fd98d095596d4);
    let route = $dup7A.useContext((0, $5c6d50c15e61ec01$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    !route && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $1d2829c53a2521b2$var$useIdImpl ? $1d2829c53a2521b2$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dup7A.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($1d2829c53a2521b2$var$getUniqueFetcherId());
    // Registration/cleanup
    $dup7A.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dup7A.useCallback((href, opts)=>{
        !routeId && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $1d2829c53a2521b2$export$47c85c6e3a081d3();
    let submit = $dup7A.useCallback((target, opts)=>{
        submitImpl(target, $1d2829c53a2521b2$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dup7A.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dup7A.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dup7A.createElement($1d2829c53a2521b2$export$a7fed597f4b8afd8, $1d2829c53a2521b2$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $812c9a0500c51f61$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dup7A.useMemo(()=>$1d2829c53a2521b2$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $1d2829c53a2521b2$export$fa996778a3a31087() {
    let state = $1d2829c53a2521b2$var$useDataRouterState($1d2829c53a2521b2$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $1d2829c53a2521b2$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $1d2829c53a2521b2$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $1d2829c53a2521b2$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $1d2829c53a2521b2$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $1d2829c53a2521b2$var$useDataRouterContext($1d2829c53a2521b2$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $1d2829c53a2521b2$var$useDataRouterState($1d2829c53a2521b2$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dup7A.useContext((0, $5c6d50c15e61ec01$export$26749e8557646306));
    let location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    let matches = (0, $5c6d50c15e61ec01$export$2378eb7f5ff86053)();
    let navigation = (0, $5c6d50c15e61ec01$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dup7A.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $1d2829c53a2521b2$var$usePageHide($dup7A.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $1d2829c53a2521b2$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $1d2829c53a2521b2$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($1d2829c53a2521b2$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dup7A.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $1d2829c53a2521b2$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $1d2829c53a2521b2$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dup7A.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($1d2829c53a2521b2$var$_extends({}, location, {
                    pathname: (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($1d2829c53a2521b2$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dup7A.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $1d2829c53a2521b2$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dup7A.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $1d2829c53a2521b2$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dup7A.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $1d2829c53a2521b2$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5c6d50c15e61ec01$export$b273b3273281a049)(when);
    $dup7A.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dup7A.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $1d2829c53a2521b2$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dup7A.useContext($1d2829c53a2521b2$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $812c9a0500c51f61$export$3e9cee6b33872309)(false);
    let { basename: basename } = $1d2829c53a2521b2$var$useDataRouterContext($1d2829c53a2521b2$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5c6d50c15e61ec01$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $812c9a0500c51f61$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $812c9a0500c51f61$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $812c9a0500c51f61$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");
/**
 * Create a new Deffered
 *
 * @generic T - value of the deffered
 * @returns Deferred<T>
 */ const $15d3da38e57f5139$export$b37aab7cecdd910a = ()=>{
    let resolve;
    let reject;
    const value = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {
        resolve: resolve,
        reject: reject,
        value: value
    };
};


/**
 * Create a batch manager for a given collection of a data type.
 * Will batch all .get calls given inside a scheduled time window into a singel request.
 *
 * @generic T - The type of the data.
 * @generic Q - item query type
 * @generic C - the context of the batcher passed to the fetcher function
 * @param config BatcherConfig<T, Q>
 * @returns Batcher<T, Q>
 */ const $31ec6e28bfb122fa$export$185802fd694ee1f5 = (config, memory)=>{
    const name = config.name ?? `batcher:${Math.random().toString(16).slice(2)})`;
    const scheduler = config.scheduler ?? $31ec6e28bfb122fa$export$8a8ab6d4dac9ddbd(10);
    const devtools = globalThis.__BATSHIT_DEVTOOLS__?.for(name);
    let mem = memory ?? {
        seq: 0,
        batch: new Set(),
        currentRequest: (0, $15d3da38e57f5139$export$b37aab7cecdd910a)(),
        timer: undefined,
        start: null,
        latest: null
    };
    devtools?.create({
        seq: mem.seq
    });
    const nextBatch = ()=>{
        mem.batch = new Set();
        mem.currentRequest = (0, $15d3da38e57f5139$export$b37aab7cecdd910a)();
        mem.timer = undefined;
        mem.start = null;
        mem.latest = null;
    };
    const fetch = (query)=>{
        if (!mem.start) mem.start = Date.now();
        mem.latest = Date.now();
        mem.batch.add(query);
        clearTimeout(mem.timer);
        const scheduled = scheduler(mem.start, mem.latest, mem.batch.size);
        devtools?.queue({
            seq: mem.seq,
            query: query,
            batch: [
                ...mem.batch
            ],
            scheduled: scheduled,
            latest: mem.latest,
            start: mem.start
        });
        const fetchBatch = ()=>{
            const currentSeq = mem.seq;
            const req = config.fetcher([
                ...mem.batch
            ]);
            const currentRequest = mem.currentRequest;
            devtools?.fetch({
                seq: currentSeq,
                batch: [
                    ...mem.batch
                ]
            });
            nextBatch();
            req.then((data)=>{
                devtools?.data({
                    seq: currentSeq,
                    data: data
                });
                currentRequest.resolve(data);
            }).catch((error)=>{
                devtools?.error({
                    seq: currentSeq,
                    error: error
                });
                currentRequest.reject(error);
            });
            mem.seq++;
            return req;
        };
        if (scheduled === "immediate") {
            const req = mem.currentRequest;
            fetchBatch();
            return req.value.then((items)=>config.resolver(items, query));
        } else if (scheduled === "never") return mem.currentRequest.value.then((items)=>config.resolver(items, query));
        else {
            mem.timer = setTimeout(fetchBatch, scheduled);
            return mem.currentRequest.value.then((items)=>config.resolver(items, query));
        }
    };
    return {
        fetch: fetch
    };
};
/**
 * Resolve by item field of items when response is an array.
 * Create a euquality check to check if the query matches a given key on the item data.
 *
 * @param key keyof T
 * @returns (item:T extends Array<A>, query: Q) => A
 */ const $31ec6e28bfb122fa$export$3cc90f807e36666d = (key)=>(items, query)=>items.find((item)=>item[key] == query);
/**
 * Resolve by record index when response is an object.
 * Create a euquality check to check if the query matches a given key on the item data.
 *
 * @returns (item:T extends Record<_, A>, query: Q) => A
 */ const $31ec6e28bfb122fa$export$ee3ee35fb4ea28ba = ()=>(itemsIndex, query)=>itemsIndex[query];
/**
 * Give a window in ms where all queued fetched made within the window will be batched into
 * one singler batch fetch call.
 *
 * @param ms number
 * @returns BatcherScheduler
 */ const $31ec6e28bfb122fa$export$8a8ab6d4dac9ddbd = (ms)=>(start, latest)=>{
        const spent = latest - start;
        return ms - spent;
    };
/**
 * Give a buffer time in ms. Will give another buffer window when queueing a fetch.
 *
 * @param ms number
 * @returns BatcherScheduler
 */ const $31ec6e28bfb122fa$export$72014dc9a1100d75 = (ms)=>()=>{
        return ms;
    };
/**
 * Same as windowScheduler, will batch calls made within a window of time OR when the max batch size is reached.
 *
 * @param config: {windowMs: number; maxBatchSize: number;}
 * @returns BatcherScheduler
 */ const $31ec6e28bfb122fa$export$c588696e674bc1bf = ({ windowMs: windowMs, maxBatchSize: maxBatchSize })=>(start, latest, batchSize)=>{
        if (batchSize >= maxBatchSize) return "immediate";
        const spent = latest - start;
        return windowMs - spent;
    };
/**
 * Will batch calls when the max batch size is reached.
 *
 * @param config: {maxBatchSize: number;}
 * @returns BatcherScheduler
 */ const $31ec6e28bfb122fa$export$28ce35332f632fd9 = ({ maxBatchSize: maxBatchSize })=>(_start, _latest, batchSize)=>{
        if (batchSize >= maxBatchSize) return "immediate";
        return "never";
    };


var $3ecb954f3d350801$exports = {};
"use strict";
var $3ecb954f3d350801$var$__createBinding = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3ecb954f3d350801$var$__setModuleDefault = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3ecb954f3d350801$var$__importStar = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3ecb954f3d350801$var$__createBinding(result, mod, k);
    }
    $3ecb954f3d350801$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3ecb954f3d350801$exports, "__esModule", {
    value: true
});
$3ecb954f3d350801$exports.request = $3ecb954f3d350801$exports.rawRequest = $3ecb954f3d350801$exports.GraphQLClient = $3ecb954f3d350801$exports.ClientError = $3ecb954f3d350801$exports.batchRequests = $3ecb954f3d350801$exports.resolveRequestDocument = $3ecb954f3d350801$exports.GraphQLWebSocketClient = $3ecb954f3d350801$exports.gql = void 0;
var $d98a2c3d80b8f921$exports = {};
"use strict";
Object.defineProperty($d98a2c3d80b8f921$exports, "__esModule", {
    value: true
});
$d98a2c3d80b8f921$exports.defaultJsonSerializer = void 0;
$d98a2c3d80b8f921$exports.defaultJsonSerializer = JSON;


var $bf4c7cf031dc9294$exports = {};
"use strict";
Object.defineProperty($bf4c7cf031dc9294$exports, "__esModule", {
    value: true
});
$bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject = $bf4c7cf031dc9294$exports.uppercase = void 0;
const $bf4c7cf031dc9294$var$uppercase = (str)=>str.toUpperCase();
$bf4c7cf031dc9294$exports.uppercase = $bf4c7cf031dc9294$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $bf4c7cf031dc9294$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject = $bf4c7cf031dc9294$var$HeadersInstanceToPlainObject;


var $7cb39c267daa5a82$exports = {};
"use strict";
Object.defineProperty($7cb39c267daa5a82$exports, "__esModule", {
    value: true
});
$7cb39c267daa5a82$exports.parseRawRequestExtendedArgs = $7cb39c267daa5a82$exports.parseRequestExtendedArgs = $7cb39c267daa5a82$exports.parseBatchRequestArgs = $7cb39c267daa5a82$exports.parseRawRequestArgs = $7cb39c267daa5a82$exports.parseRequestArgs = void 0;
const $7cb39c267daa5a82$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRequestArgs = $7cb39c267daa5a82$var$parseRequestArgs;
const $7cb39c267daa5a82$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRawRequestArgs = $7cb39c267daa5a82$var$parseRawRequestArgs;
const $7cb39c267daa5a82$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseBatchRequestArgs = $7cb39c267daa5a82$var$parseBatchRequestArgs;
const $7cb39c267daa5a82$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRequestExtendedArgs = $7cb39c267daa5a82$var$parseRequestExtendedArgs;
const $7cb39c267daa5a82$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRawRequestExtendedArgs = $7cb39c267daa5a82$var$parseRawRequestExtendedArgs;


var $70379170ad08a388$exports = {};
"use strict";
Object.defineProperty($70379170ad08a388$exports, "__esModule", {
    value: true
});
$70379170ad08a388$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $aa138920f9209e70$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $114305077f875ea3$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $518283d6324f0738$var$LineRegExp = /\r\n|[\n\r]/g;
function $518283d6324f0738$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($518283d6324f0738$var$LineRegExp)){
        typeof match.index === "number" || (0, $114305077f875ea3$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $442b76678fd98ce6$export$96a9681e539deed(location) {
    return $442b76678fd98ce6$export$867940333fd9f869(location.source, (0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $442b76678fd98ce6$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $442b76678fd98ce6$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $442b76678fd98ce6$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $442b76678fd98ce6$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $b9bb4b6875d2cb38$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $b9bb4b6875d2cb38$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $b9bb4b6875d2cb38$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $b9bb4b6875d2cb38$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $aa138920f9209e70$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $442b76678fd98ce6$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $442b76678fd98ce6$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $b9bb4b6875d2cb38$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $b9bb4b6875d2cb38$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $b9bb4b6875d2cb38$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $df0689dd60b7ce92$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $1aac86d3fd4247cf$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $1aac86d3fd4247cf$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $1aac86d3fd4247cf$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $1aac86d3fd4247cf$var$kindValues = new Set(Object.keys($1aac86d3fd4247cf$export$4fcd777a40ccf407));
function $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $1aac86d3fd4247cf$var$kindValues.has(maybeKind);
}
/** Name */ var $1aac86d3fd4247cf$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($1aac86d3fd4247cf$export$f58c50edb4aef9d4 || ($1aac86d3fd4247cf$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $fe45191b121d6c96$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($fe45191b121d6c96$export$b45ffd2948484c41 || ($fe45191b121d6c96$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $004e90072ac44791$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($004e90072ac44791$export$a84bdc57c5122798 || ($004e90072ac44791$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $b594b69ebba3d31f$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $b594b69ebba3d31f$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $b594b69ebba3d31f$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $b594b69ebba3d31f$export$45a677ea7cb6d5c8(code) {
    return $b594b69ebba3d31f$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $b594b69ebba3d31f$export$d3f406ff46035894(code) {
    return $b594b69ebba3d31f$export$79c5d5217943d6a7(code) || $b594b69ebba3d31f$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $1ce970437e2eeb43$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $1ce970437e2eeb43$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $1ce970437e2eeb43$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $1ce970437e2eeb43$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $1ce970437e2eeb43$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $34dd16813e0454d6$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($34dd16813e0454d6$export$8b9d26ab11394711 || ($34dd16813e0454d6$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $0c187fd033e6b576$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $1aac86d3fd4247cf$export$50792b0e93539fde)((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $0c187fd033e6b576$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $0c187fd033e6b576$export$59ac0f4da287406a(kind) {
    return kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).AT || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $0c187fd033e6b576$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $0c187fd033e6b576$var$isSupplementaryCodePoint(body, location) {
    return $0c187fd033e6b576$var$isLeadingSurrogate(body.charCodeAt(location)) && $0c187fd033e6b576$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $0c187fd033e6b576$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $0c187fd033e6b576$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $0c187fd033e6b576$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $0c187fd033e6b576$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $1aac86d3fd4247cf$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $0c187fd033e6b576$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $0c187fd033e6b576$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $0c187fd033e6b576$var$readBlockString(lexer, position);
                return $0c187fd033e6b576$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $0c187fd033e6b576$var$readNumber(lexer, position, code);
         // Name
        if ((0, $b594b69ebba3d31f$export$45a677ea7cb6d5c8)(code)) return $0c187fd033e6b576$var$readName(lexer, position);
        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $0c187fd033e6b576$var$isUnicodeScalarValue(code) || $0c187fd033e6b576$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $0c187fd033e6b576$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $0c187fd033e6b576$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(code)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $b594b69ebba3d31f$export$45a677ea7cb6d5c8)(code)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    return $0c187fd033e6b576$var$createToken(lexer, isFloat ? (0, $34dd16813e0454d6$export$8b9d26ab11394711).FLOAT : (0, $34dd16813e0454d6$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $0c187fd033e6b576$var$readDigits(lexer, start, firstCode) {
    if (!(0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(firstCode)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$0c187fd033e6b576$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $0c187fd033e6b576$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $0c187fd033e6b576$var$readEscapedUnicodeVariableWidth(lexer, position) : $0c187fd033e6b576$var$readEscapedUnicodeFixedWidth(lexer, position) : $0c187fd033e6b576$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $0c187fd033e6b576$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$0c187fd033e6b576$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $0c187fd033e6b576$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $0c187fd033e6b576$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $0c187fd033e6b576$var$read16BitHexCode(body, position + 2);
    if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($0c187fd033e6b576$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $0c187fd033e6b576$var$read16BitHexCode(body, position + 8);
            if ($0c187fd033e6b576$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $0c187fd033e6b576$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position)) << 12 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $0c187fd033e6b576$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $0c187fd033e6b576$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $0c187fd033e6b576$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $1ce970437e2eeb43$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $0c187fd033e6b576$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $b594b69ebba3d31f$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $f87670c0082d22dd$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $0a7d676629377c88$var$MAX_ARRAY_LENGTH = 10;
const $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH = 2;
function $0a7d676629377c88$export$9dec5d1b3b6a130d(value) {
    return $0a7d676629377c88$var$formatValue(value, []);
}
function $0a7d676629377c88$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $0a7d676629377c88$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0a7d676629377c88$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($0a7d676629377c88$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $0a7d676629377c88$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $0a7d676629377c88$var$formatArray(value, seenValues);
    return $0a7d676629377c88$var$formatObject(value, seenValues);
}
function $0a7d676629377c88$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $0a7d676629377c88$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH) return "[" + $0a7d676629377c88$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $0a7d676629377c88$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $0a7d676629377c88$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($0a7d676629377c88$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($0a7d676629377c88$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $0a7d676629377c88$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}



const $8853ab9b8a132e03$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $50492008785479b9$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $50492008785479b9$export$75135ee9ed6e435b(source) {
    return (0, $8853ab9b8a132e03$export$ca03416d6c9e029e)(source, $50492008785479b9$export$1d2df86270c81ecb);
}



function $57a14ff8f0fcf417$export$98e6a39c04603d36(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $57a14ff8f0fcf417$export$5303528d1070ff6f(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return value;
}
function $57a14ff8f0fcf417$export$e14c466bd0916f7a(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return value;
}
function $57a14ff8f0fcf417$export$28b8f402ccc88182(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return type;
}
class $57a14ff8f0fcf417$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $50492008785479b9$export$75135ee9ed6e435b)(source) ? source : new (0, $50492008785479b9$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $0c187fd033e6b576$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING:
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).LIST,
            values: this.any((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $004e90072ac44791$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING) || this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$57a14ff8f0fcf417$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $fe45191b121d6c96$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $1aac86d3fd4247cf$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$57a14ff8f0fcf417$var$getTokenKindDesc(kind)}, found ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $57a14ff8f0fcf417$var$getTokenDesc(token) {
    const value = token.value;
    return $57a14ff8f0fcf417$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $57a14ff8f0fcf417$var$getTokenKindDesc(kind) {
    return (0, $0c187fd033e6b576$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $48fd700e2bddeea1$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($48fd700e2bddeea1$var$escapedRegExp, $48fd700e2bddeea1$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $48fd700e2bddeea1$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $48fd700e2bddeea1$var$escapedReplacer(str) {
    return $48fd700e2bddeea1$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $48fd700e2bddeea1$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];






const $7c617355af910c01$export$a89c95c098ac2a58 = Object.freeze({});
function $7c617355af910c01$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $1aac86d3fd4247cf$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $004e90072ac44791$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $7c617355af910c01$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee)(node) || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $7c617355af910c01$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $7c617355af910c01$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $004e90072ac44791$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $7c617355af910c01$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $7c617355af910c01$export$a89c95c098ac2a58) skipping[i] = $7c617355af910c01$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $7c617355af910c01$export$a89c95c098ac2a58) skipping[i] = $7c617355af910c01$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $7c617355af910c01$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $7c617355af910c01$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $7c617355af910c01$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $6ecfe3fd0f5ba15e$export$c2d084dc44961371(ast) {
    return (0, $7c617355af910c01$export$bf638b60ea8b89b7)(ast, $6ecfe3fd0f5ba15e$var$printDocASTReducer);
}
const $6ecfe3fd0f5ba15e$var$MAX_LINE_LENGTH = 80;
const $6ecfe3fd0f5ba15e$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$6ecfe3fd0f5ba15e$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $6ecfe3fd0f5ba15e$var$join([
                node.operation,
                $6ecfe3fd0f5ba15e$var$join([
                    node.name,
                    varDefs
                ]),
                $6ecfe3fd0f5ba15e$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $6ecfe3fd0f5ba15e$var$wrap(" = ", defaultValue) + $6ecfe3fd0f5ba15e$var$wrap(" ", $6ecfe3fd0f5ba15e$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$6ecfe3fd0f5ba15e$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $6ecfe3fd0f5ba15e$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(args, ", "), ")");
            if (argsLine.length > $6ecfe3fd0f5ba15e$var$MAX_LINE_LENGTH) argsLine = prefix + $6ecfe3fd0f5ba15e$var$wrap("(\n", $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, "\n")), "\n)");
            return $6ecfe3fd0f5ba15e$var$join([
                argsLine,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $6ecfe3fd0f5ba15e$var$wrap(" ", $6ecfe3fd0f5ba15e$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$6ecfe3fd0f5ba15e$var$join([
                "...",
                $6ecfe3fd0f5ba15e$var$wrap("on ", typeCondition),
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$6ecfe3fd0f5ba15e$var$wrap("", $6ecfe3fd0f5ba15e$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $1ce970437e2eeb43$export$adb6ca997eeb1f45)(value) : (0, $48fd700e2bddeea1$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $6ecfe3fd0f5ba15e$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $6ecfe3fd0f5ba15e$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "schema",
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "scalar",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "type",
                name,
                $6ecfe3fd0f5ba15e$var$wrap("implements ", $6ecfe3fd0f5ba15e$var$join(interfaces, " & ")),
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + name + ($6ecfe3fd0f5ba15e$var$hasMultilineItems(args) ? $6ecfe3fd0f5ba15e$var$wrap("(\n", $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, "\n")), "\n)") : $6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(args, ", "), ")")) + ": " + type + $6ecfe3fd0f5ba15e$var$wrap(" ", $6ecfe3fd0f5ba15e$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                name + ": " + type,
                $6ecfe3fd0f5ba15e$var$wrap("= ", defaultValue),
                $6ecfe3fd0f5ba15e$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "interface",
                name,
                $6ecfe3fd0f5ba15e$var$wrap("implements ", $6ecfe3fd0f5ba15e$var$join(interfaces, " & ")),
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "union",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$wrap("= ", $6ecfe3fd0f5ba15e$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "enum",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + $6ecfe3fd0f5ba15e$var$join([
                "input",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$6ecfe3fd0f5ba15e$var$wrap("", description, "\n") + "directive @" + name + ($6ecfe3fd0f5ba15e$var$hasMultilineItems(args) ? $6ecfe3fd0f5ba15e$var$wrap("(\n", $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, "\n")), "\n)") : $6ecfe3fd0f5ba15e$var$wrap("(", $6ecfe3fd0f5ba15e$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $6ecfe3fd0f5ba15e$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$6ecfe3fd0f5ba15e$var$join([
                "extend schema",
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$join([
                "extend scalar",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                "extend type",
                name,
                $6ecfe3fd0f5ba15e$var$wrap("implements ", $6ecfe3fd0f5ba15e$var$join(interfaces, " & ")),
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                "extend interface",
                name,
                $6ecfe3fd0f5ba15e$var$wrap("implements ", $6ecfe3fd0f5ba15e$var$join(interfaces, " & ")),
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$6ecfe3fd0f5ba15e$var$join([
                "extend union",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$wrap("= ", $6ecfe3fd0f5ba15e$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$6ecfe3fd0f5ba15e$var$join([
                "extend enum",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                "extend input",
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, " "),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $6ecfe3fd0f5ba15e$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $6ecfe3fd0f5ba15e$var$block(array) {
    return $6ecfe3fd0f5ba15e$var$wrap("{\n", $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $6ecfe3fd0f5ba15e$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $6ecfe3fd0f5ba15e$var$indent(str) {
    return $6ecfe3fd0f5ba15e$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $6ecfe3fd0f5ba15e$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $70379170ad08a388$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $70379170ad08a388$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $57a14ff8f0fcf417$export$98e6a39c04603d36)(document);
            operationName = $70379170ad08a388$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $70379170ad08a388$var$extractOperationName(document);
    return {
        query: (0, $6ecfe3fd0f5ba15e$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$70379170ad08a388$exports.resolveRequestDocument = $70379170ad08a388$var$resolveRequestDocument;


var $2f9eee8a6b649b81$exports = {};
"use strict";
Object.defineProperty($2f9eee8a6b649b81$exports, "__esModule", {
    value: true
});
$2f9eee8a6b649b81$exports.ClientError = void 0;
class $2f9eee8a6b649b81$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$2f9eee8a6b649b81$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $2f9eee8a6b649b81$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $2f9eee8a6b649b81$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$2f9eee8a6b649b81$exports.ClientError = $2f9eee8a6b649b81$var$ClientError;


Object.defineProperty($3ecb954f3d350801$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $2f9eee8a6b649b81$exports.ClientError;
    }
});

const $3ecb954f3d350801$var$cross_fetch_1 = $3ecb954f3d350801$var$__importStar((parcelRequire("aUQjb"))), $3ecb954f3d350801$var$CrossFetch = $3ecb954f3d350801$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $3ecb954f3d350801$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $3ecb954f3d350801$var$CrossFetch && $3ecb954f3d350801$var$CrossFetch.Headers && headers instanceof $3ecb954f3d350801$var$CrossFetch.Headers) oHeaders = (0, $bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $3ecb954f3d350801$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $3ecb954f3d350801$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($3ecb954f3d350801$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $3ecb954f3d350801$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $3ecb954f3d350801$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $3ecb954f3d350801$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $3ecb954f3d350801$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $3ecb954f3d350801$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $7cb39c267daa5a82$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $3ecb954f3d350801$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $3ecb954f3d350801$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                    ...$3ecb954f3d350801$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $7cb39c267daa5a82$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $3ecb954f3d350801$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(requestOptions.document);
        return $3ecb954f3d350801$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                ...$3ecb954f3d350801$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $7cb39c267daa5a82$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $70379170ad08a388$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $3ecb954f3d350801$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                ...$3ecb954f3d350801$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $3ecb954f3d350801$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$3ecb954f3d350801$exports.GraphQLClient = $3ecb954f3d350801$var$GraphQLClient;
const $3ecb954f3d350801$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $3ecb954f3d350801$var$createHttpMethodFetcher((0, $bf4c7cf031dc9294$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $3ecb954f3d350801$var$getResult(response, fetchOptions.jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $2f9eee8a6b649b81$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $3ecb954f3d350801$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $7cb39c267daa5a82$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $3ecb954f3d350801$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$3ecb954f3d350801$exports.rawRequest = $3ecb954f3d350801$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $3ecb954f3d350801$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $7cb39c267daa5a82$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $3ecb954f3d350801$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$3ecb954f3d350801$exports.request = $3ecb954f3d350801$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $3ecb954f3d350801$var$batchRequests = async (...args)=>{
    const params = $3ecb954f3d350801$var$parseBatchRequestsArgsExtended(args);
    const client = new $3ecb954f3d350801$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$3ecb954f3d350801$exports.batchRequests = $3ecb954f3d350801$var$batchRequests;
const $3ecb954f3d350801$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $3ecb954f3d350801$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $3ecb954f3d350801$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $3ecb954f3d350801$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $3ecb954f3d350801$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$3ecb954f3d350801$exports.gql = $3ecb954f3d350801$var$gql;
var $b68213ba3fc67dce$exports = {};
"use strict";
Object.defineProperty($b68213ba3fc67dce$exports, "__esModule", {
    value: true
});
$b68213ba3fc67dce$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $b68213ba3fc67dce$var$CONNECTION_INIT = `connection_init`;
const $b68213ba3fc67dce$var$CONNECTION_ACK = `connection_ack`;
const $b68213ba3fc67dce$var$PING = `ping`;
const $b68213ba3fc67dce$var$PONG = `pong`;
const $b68213ba3fc67dce$var$SUBSCRIBE = `subscribe`;
const $b68213ba3fc67dce$var$NEXT = `next`;
const $b68213ba3fc67dce$var$ERROR = `error`;
const $b68213ba3fc67dce$var$COMPLETE = `complete`;
class $b68213ba3fc67dce$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b68213ba3fc67dce$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b68213ba3fc67dce$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b68213ba3fc67dce$var$parseMessage(e.data);
                switch(message.type){
                    case $b68213ba3fc67dce$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b68213ba3fc67dce$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b68213ba3fc67dce$var$Pong(r).text));
                        else socket.send($b68213ba3fc67dce$var$Pong(null).text);
                        return;
                    case $b68213ba3fc67dce$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b68213ba3fc67dce$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $2f9eee8a6b649b81$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b68213ba3fc67dce$var$ERROR:
                        subscriber.error && subscriber.error(new $2f9eee8a6b649b81$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b68213ba3fc67dce$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b68213ba3fc67dce$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b68213ba3fc67dce$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b68213ba3fc67dce$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b68213ba3fc67dce$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$b68213ba3fc67dce$exports.GraphQLWebSocketClient = $b68213ba3fc67dce$var$GraphQLWebSocketClient;
// Helper functions
function $b68213ba3fc67dce$var$parseMessage(data, f = (a)=>a) {
    const m = $b68213ba3fc67dce$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b68213ba3fc67dce$var$ConnectionInit(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$CONNECTION_INIT, payload);
}
function $b68213ba3fc67dce$var$Ping(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$PING, payload, undefined);
}
function $b68213ba3fc67dce$var$Pong(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$PONG, payload, undefined);
}
function $b68213ba3fc67dce$var$Subscribe(id, payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$SUBSCRIBE, payload, id);
}
function $b68213ba3fc67dce$var$Complete(id) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$COMPLETE, undefined, id);
}


Object.defineProperty($3ecb954f3d350801$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $b68213ba3fc67dce$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($3ecb954f3d350801$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $70379170ad08a388$exports.resolveRequestDocument;
    }
});
$3ecb954f3d350801$exports.default = $3ecb954f3d350801$var$request;



var $dup7A = parcelRequire("dup7A");
function $c34f8420d5e824f3$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c34f8420d5e824f3$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c34f8420d5e824f3$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c34f8420d5e824f3$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c34f8420d5e824f3$export$2e2bcd8739ae039 = $c34f8420d5e824f3$export$4f5d2d50c9deca37;


"use client";
const $b6ddc82ff82475c2$var$u = (t)=>"number" == typeof t && !isNaN(t), $b6ddc82ff82475c2$var$d = (t)=>"string" == typeof t, $b6ddc82ff82475c2$var$p = (t)=>"function" == typeof t, $b6ddc82ff82475c2$var$m = (t)=>$b6ddc82ff82475c2$var$d(t) || $b6ddc82ff82475c2$var$p(t) ? t : null, $b6ddc82ff82475c2$var$f = (t)=>(0, $dup7A.isValidElement)(t) || $b6ddc82ff82475c2$var$d(t) || $b6ddc82ff82475c2$var$p(t) || $b6ddc82ff82475c2$var$u(t);
function $b6ddc82ff82475c2$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $b6ddc82ff82475c2$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $dup7A.useRef)(0);
        return (0, $dup7A.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $dup7A.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $b6ddc82ff82475c2$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, null, u);
    };
}
function $b6ddc82ff82475c2$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $b6ddc82ff82475c2$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $b6ddc82ff82475c2$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $b6ddc82ff82475c2$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $b6ddc82ff82475c2$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $dup7A.useReducer)((t)=>t + 1, 0), [l, c] = (0, $dup7A.useState)([]), g = (0, $dup7A.useRef)(null), h = (0, $dup7A.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $dup7A.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$b6ddc82ff82475c2$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $b6ddc82ff82475c2$var$m(i.className || b.toastClassName),
            bodyClassName: $b6ddc82ff82475c2$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $b6ddc82ff82475c2$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $b6ddc82ff82475c2$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $b6ddc82ff82475c2$var$y(h.get(l), "removed");
                h.delete(l), $b6ddc82ff82475c2$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($b6ddc82ff82475c2$var$p(r) ? i = r(l) : (0, $dup7A.isValidElement)(r) ? i = (0, $dup7A.cloneElement)(r, l) : $b6ddc82ff82475c2$var$d(r) || $b6ddc82ff82475c2$var$u(r) ? i = r : s ? i = $b6ddc82ff82475c2$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $b6ddc82ff82475c2$export$4f13f83fd8bb1dac)(o) && (i = $b6ddc82ff82475c2$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $b6ddc82ff82475c2$var$p(i.onOpen) && (M.onOpen = i.onOpen), $b6ddc82ff82475c2$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $b6ddc82ff82475c2$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$b6ddc82ff82475c2$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $dup7A.isValidElement)(t) && !$b6ddc82ff82475c2$var$d(t.type) ? x = (0, $dup7A.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $b6ddc82ff82475c2$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $b6ddc82ff82475c2$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $b6ddc82ff82475c2$var$v.emit(4, $b6ddc82ff82475c2$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $dup7A.useEffect)(()=>(C.containerId = t.containerId, $b6ddc82ff82475c2$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $b6ddc82ff82475c2$var$v.emit(3, C);
        }), []), (0, $dup7A.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $b6ddc82ff82475c2$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $b6ddc82ff82475c2$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $b6ddc82ff82475c2$export$a407b657d3044108(t) {
    const [o, a] = (0, $dup7A.useState)(!1), [r, l] = (0, $dup7A.useState)(!1), c = (0, $dup7A.useRef)(null), u = (0, $dup7A.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $dup7A.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $b6ddc82ff82475c2$var$b(e.nativeEvent), u.y = $b6ddc82ff82475c2$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $b6ddc82ff82475c2$var$b(e), u.y = $b6ddc82ff82475c2$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $dup7A.useEffect)(()=>{
        d.current = t;
    }), (0, $dup7A.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $b6ddc82ff82475c2$var$p(t.onOpen) && t.onOpen((0, $dup7A.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $b6ddc82ff82475c2$var$p(t.onClose) && t.onClose((0, $dup7A.isValidElement)(t.children) && t.children.props);
        }), []), (0, $dup7A.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $b6ddc82ff82475c2$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b6ddc82ff82475c2$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $b6ddc82ff82475c2$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $b6ddc82ff82475c2$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $b6ddc82ff82475c2$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $b6ddc82ff82475c2$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $b6ddc82ff82475c2$var$p(l) ? l(q) : (0, $dup7A.isValidElement)(l) ? (0, $dup7A.cloneElement)(l, q) : $b6ddc82ff82475c2$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        ...P && {
            role: R
        },
        className: $b6ddc82ff82475c2$var$p(C) ? C({
            type: f
        }) : (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $b6ddc82ff82475c2$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $b6ddc82ff82475c2$export$d20e79fdc3899e95 = $b6ddc82ff82475c2$export$3ff7dc44d332d222($b6ddc82ff82475c2$var$M("bounce", !0)), $b6ddc82ff82475c2$export$d8dc01b5c85a37b9 = $b6ddc82ff82475c2$export$3ff7dc44d332d222($b6ddc82ff82475c2$var$M("slide", !0)), $b6ddc82ff82475c2$export$65cfd44a2050f99 = $b6ddc82ff82475c2$export$3ff7dc44d332d222($b6ddc82ff82475c2$var$M("zoom")), $b6ddc82ff82475c2$export$4d2fae537bd90431 = $b6ddc82ff82475c2$export$3ff7dc44d332d222($b6ddc82ff82475c2$var$M("flip")), $b6ddc82ff82475c2$export$f2815235e76a62b9 = (0, $dup7A.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $b6ddc82ff82475c2$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $b6ddc82ff82475c2$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $c34f8420d5e824f3$export$2e2bcd8739ae039)(e, $b6ddc82ff82475c2$var$m(i));
    }
    return (0, $dup7A.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($b6ddc82ff82475c2$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$b6ddc82ff82475c2$export$f2815235e76a62b9.displayName = "ToastContainer", $b6ddc82ff82475c2$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $b6ddc82ff82475c2$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $b6ddc82ff82475c2$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $b6ddc82ff82475c2$var$P, $b6ddc82ff82475c2$var$B = new Map, $b6ddc82ff82475c2$var$D = [], $b6ddc82ff82475c2$var$A = 1;
function $b6ddc82ff82475c2$var$z() {
    return "" + $b6ddc82ff82475c2$var$A++;
}
function $b6ddc82ff82475c2$var$F(t) {
    return t && ($b6ddc82ff82475c2$var$d(t.toastId) || $b6ddc82ff82475c2$var$u(t.toastId)) ? t.toastId : $b6ddc82ff82475c2$var$z();
}
function $b6ddc82ff82475c2$var$H(t, e) {
    return $b6ddc82ff82475c2$var$B.size > 0 ? $b6ddc82ff82475c2$var$v.emit(0, t, e) : $b6ddc82ff82475c2$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $b6ddc82ff82475c2$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $b6ddc82ff82475c2$var$F(e)
    };
}
function $b6ddc82ff82475c2$var$q(t) {
    return (e, n)=>$b6ddc82ff82475c2$var$H(e, $b6ddc82ff82475c2$var$S(t, n));
}
function $b6ddc82ff82475c2$export$b410431fab84fa58(t, e) {
    return $b6ddc82ff82475c2$var$H(t, $b6ddc82ff82475c2$var$S("default", e));
}
$b6ddc82ff82475c2$export$b410431fab84fa58.loading = (t, e)=>$b6ddc82ff82475c2$var$H(t, $b6ddc82ff82475c2$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $b6ddc82ff82475c2$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $b6ddc82ff82475c2$var$d(s) ? $b6ddc82ff82475c2$export$b410431fab84fa58.loading(s, n) : $b6ddc82ff82475c2$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $b6ddc82ff82475c2$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $b6ddc82ff82475c2$var$d(e) ? {
            render: e
        } : e;
        return o ? $b6ddc82ff82475c2$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $b6ddc82ff82475c2$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $b6ddc82ff82475c2$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $b6ddc82ff82475c2$export$b410431fab84fa58.success = $b6ddc82ff82475c2$var$q("success"), $b6ddc82ff82475c2$export$b410431fab84fa58.info = $b6ddc82ff82475c2$var$q("info"), $b6ddc82ff82475c2$export$b410431fab84fa58.error = $b6ddc82ff82475c2$var$q("error"), $b6ddc82ff82475c2$export$b410431fab84fa58.warning = $b6ddc82ff82475c2$var$q("warning"), $b6ddc82ff82475c2$export$b410431fab84fa58.warn = $b6ddc82ff82475c2$export$b410431fab84fa58.warning, $b6ddc82ff82475c2$export$b410431fab84fa58.dark = (t, e)=>$b6ddc82ff82475c2$var$H(t, $b6ddc82ff82475c2$var$S("default", {
        theme: "dark",
        ...e
    })), $b6ddc82ff82475c2$export$b410431fab84fa58.dismiss = (t)=>{
    $b6ddc82ff82475c2$var$B.size > 0 ? $b6ddc82ff82475c2$var$v.emit(1, t) : $b6ddc82ff82475c2$var$D = $b6ddc82ff82475c2$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $b6ddc82ff82475c2$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $b6ddc82ff82475c2$var$v.emit(5, t);
}, $b6ddc82ff82475c2$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $b6ddc82ff82475c2$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $b6ddc82ff82475c2$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $b6ddc82ff82475c2$var$B.get(n || $b6ddc82ff82475c2$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $b6ddc82ff82475c2$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $b6ddc82ff82475c2$var$H(r, a);
        }
    }, 0);
}, $b6ddc82ff82475c2$export$b410431fab84fa58.done = (t)=>{
    $b6ddc82ff82475c2$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $b6ddc82ff82475c2$export$b410431fab84fa58.onChange = (t)=>($b6ddc82ff82475c2$var$v.on(4, t), ()=>{
        $b6ddc82ff82475c2$var$v.off(4, t);
    }), $b6ddc82ff82475c2$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $b6ddc82ff82475c2$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $b6ddc82ff82475c2$var$v.on(2, (t)=>{
    $b6ddc82ff82475c2$var$P = t.containerId || t, $b6ddc82ff82475c2$var$B.set($b6ddc82ff82475c2$var$P, t), $b6ddc82ff82475c2$var$D.forEach((t)=>{
        $b6ddc82ff82475c2$var$v.emit(0, t.content, t.options);
    }), $b6ddc82ff82475c2$var$D = [];
}).on(3, (t)=>{
    $b6ddc82ff82475c2$var$B.delete(t.containerId || t), 0 === $b6ddc82ff82475c2$var$B.size && $b6ddc82ff82475c2$var$v.off(0).off(1).off(5);
});



const $0b0903738c0da810$export$8eb3892b442747bd = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
};
async function $0b0903738c0da810$export$27738200007bd40a(contractWrite, publicClient) {
    (0, $b6ddc82ff82475c2$export$b410431fab84fa58).info("Transaction initiated", $0b0903738c0da810$export$8eb3892b442747bd);
    return await contractWrite().then(async (hash)=>await publicClient.waitForTransactionReceipt({
            hash: hash,
            confirmations: 2
        }).then((res)=>{
            const status = res.status === "success";
            if (status) (0, $b6ddc82ff82475c2$export$b410431fab84fa58).success("Transaction mined!", $0b0903738c0da810$export$8eb3892b442747bd);
            else (0, $b6ddc82ff82475c2$export$b410431fab84fa58).error("Transaction reverted!", $0b0903738c0da810$export$8eb3892b442747bd);
            return {
                status: status,
                result: res
            };
        })).catch((error)=>{
        (0, $b6ddc82ff82475c2$export$b410431fab84fa58).error(error.shortMessage ?? error.message, $0b0903738c0da810$export$8eb3892b442747bd);
        return {
            status: false
        };
    });
}
async function $0b0903738c0da810$export$944c26d54e826586(promise) {
    return await promise.catch((error)=>(0, $b6ddc82ff82475c2$export$b410431fab84fa58).error(error.shortMessage ?? error.message, $0b0903738c0da810$export$8eb3892b442747bd));
}


let $074a4e3f371abdca$var$timeoutId;
const $074a4e3f371abdca$export$18f70d5facb50d50 = (msg)=>{
    if ($074a4e3f371abdca$var$timeoutId) clearTimeout($074a4e3f371abdca$var$timeoutId);
    $074a4e3f371abdca$var$timeoutId = setTimeout(()=>{
        (0, $b6ddc82ff82475c2$export$b410431fab84fa58).error(msg, (0, $0b0903738c0da810$export$8eb3892b442747bd));
    }, 5000);
};



var $lKw3B = parcelRequire("lKw3B");
const $7c10d207e8d5c39f$export$625cf84d855940d4 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 42161,
    name: "Arbitrum One",
    network: "arbitrum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://arb-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://arb-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://arbitrum-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://arbitrum-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        },
        public: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Arbiscan",
            url: "https://arbiscan.io"
        },
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});


var $lKw3B = parcelRequire("lKw3B");
const $7af05c235ad5da5f$export$21799e7ae6cc115 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 421614,
    name: "Arbitrum Sepolia",
    network: "arbitrum-sepolia",
    nativeCurrency: {
        name: "Arbitrum Sepolia Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://arb-sepolia.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://arb-sepolia.g.alchemy.com/v2"
            ]
        },
        default: {
            http: [
                "https://sepolia-rollup.arbitrum.io/rpc"
            ]
        },
        public: {
            http: [
                "https://sepolia-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Arbiscan",
            url: "https://sepolia.arbiscan.io"
        },
        default: {
            name: "Arbiscan",
            url: "https://sepolia.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 81930
        }
    },
    testnet: true
});



var $lKw3B = parcelRequire("lKw3B");
const $65c2c1915539d26a$export$7a430fb03087826a = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 10200,
    name: "Gnosis Chiado",
    network: "chiado",
    nativeCurrency: {
        decimals: 18,
        name: "Gnosis",
        symbol: "xDAI"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.chiadochain.net"
            ],
            webSocket: [
                "wss://rpc.chiadochain.net/wss"
            ]
        },
        public: {
            http: [
                "https://rpc.chiadochain.net"
            ],
            webSocket: [
                "wss://rpc.chiadochain.net/wss"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Blockscout",
            url: "https://blockscout.chiadochain.net"
        }
    },
    contracts: {
        multicall3: {
            address: "0xcA11bde05977b3631167028862bE2a173976CA11",
            blockCreated: 4967313
        }
    },
    testnet: true
});


var $01bb2f0dcb4cc338$exports = {};
$01bb2f0dcb4cc338$exports = JSON.parse('{"version":"0.2.0","gitCommitHash":"9417dcf2d2618eb5aab5728172ce5f7b159164bb","gitCommitShortHash":"9417dcf","gitBranch":"HEAD","gitTags":"","clean":true}');


var $203b613495c69c62$export$9106d0c469e874f6;
(function(ArbitratorTypes) {
    ArbitratorTypes[ArbitratorTypes["vanilla"] = 0] = "vanilla";
    ArbitratorTypes[ArbitratorTypes["university"] = 1] = "university";
    ArbitratorTypes[ArbitratorTypes["neo"] = 2] = "neo";
})($203b613495c69c62$export$9106d0c469e874f6 || ($203b613495c69c62$export$9106d0c469e874f6 = {}));
const $203b613495c69c62$export$ae4e5f23793d4e6f = 10000n;
const $203b613495c69c62$export$8c255d03248f12ab = "https://cdn.kleros.link";
const $203b613495c69c62$export$6f06317d9d415593 = "https://t.me/HermesTheKlerosV2MessengerBot";
const $203b613495c69c62$export$512554f3e5add99 = (0, $01bb2f0dcb4cc338$exports.gitBranch);
const $203b613495c69c62$export$ac95da7ac2645a99 = (0, $01bb2f0dcb4cc338$exports.gitTags);
const $203b613495c69c62$export$8439c9c045e5384d = (0, $01bb2f0dcb4cc338$exports.gitCommitShortHash);
const $203b613495c69c62$export$91f55afd4519d50b = (0, $01bb2f0dcb4cc338$exports.clean) ? "" : "-dirty";
const $203b613495c69c62$export$1c46d8639ab5b0b = `https://github.com/kleros/kleros-v2/tree/${(0, $01bb2f0dcb4cc338$exports.gitCommitHash)}/web`;
const $203b613495c69c62$export$f1af843f4d252578 = (0, $01bb2f0dcb4cc338$exports.version);
const $203b613495c69c62$export$7b7637218245c8a = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const $203b613495c69c62$export$6314dddca181ba3d = /^@\w{5,32}$/;
const $203b613495c69c62$export$8a608dfcf39ad5a = /^0x[a-fA-F0-9]{40}$/;
const $203b613495c69c62$export$339f64b97ec8e1cc = /^0x[a-fA-F0-9]{130}$/;
const $203b613495c69c62$export$9eecd5eb17097ec3 = ()=>false;
const $203b613495c69c62$export$db7c07d3ba55f3be = ()=>$203b613495c69c62$export$f308382ea47b5f34() === 1;
const $203b613495c69c62$export$f5f35021f302af6d = ()=>$203b613495c69c62$export$f308382ea47b5f34() === 2;
const $203b613495c69c62$export$f308382ea47b5f34 = ()=>$203b613495c69c62$export$9106d0c469e874f6["neo"?.toLowerCase() ?? "vanilla"];
const $203b613495c69c62$export$801be0cfa784af7b = BigInt("3084598" ?? 0);
const $203b613495c69c62$export$48d42bfafedbe671 = BigInt("190274403" ?? 0);
const $203b613495c69c62$export$ba58123e17d2a8a9 = ()=>$203b613495c69c62$export$9eecd5eb17097ec3() ? $203b613495c69c62$export$48d42bfafedbe671 : $203b613495c69c62$export$801be0cfa784af7b;
const $203b613495c69c62$export$7142fb39be536070 = `The dispute data is not valid, please vote "Refuse to arbitrate"`;
const $203b613495c69c62$export$adca62214545ea7b = `RPC Error: Unable to fetch dispute data. Please avoid voting.`;


const $32162005f9f3d1a7$export$8372812df8e8183f = (0, $203b613495c69c62$export$9eecd5eb17097ec3)() ? (0, $7c10d207e8d5c39f$export$625cf84d855940d4).id : (0, $7af05c235ad5da5f$export$21799e7ae6cc115).id;
const $32162005f9f3d1a7$export$7000f41a852f3e5 = {
    [(0, $7af05c235ad5da5f$export$21799e7ae6cc115).id]: (0, $7af05c235ad5da5f$export$21799e7ae6cc115),
    [(0, $7c10d207e8d5c39f$export$625cf84d855940d4).id]: (0, $7c10d207e8d5c39f$export$625cf84d855940d4)
};
const $32162005f9f3d1a7$export$6daed389df1cc9ff = Object.keys($32162005f9f3d1a7$export$7000f41a852f3e5);
const $32162005f9f3d1a7$export$cd6990c704c6a5af = {
    [(0, $65c2c1915539d26a$export$7a430fb03087826a).id]: (0, $65c2c1915539d26a$export$7a430fb03087826a)
};
const $32162005f9f3d1a7$export$fa9a510f72606304 = Object.keys($32162005f9f3d1a7$export$cd6990c704c6a5af);


const $861188ef5e13bfe8$var$CHAINID_TO_DISPUTE_TEMPLATE_SUBGRAPH = {
    [(0, $7af05c235ad5da5f$export$21799e7ae6cc115).id]: "https://api.studio.thegraph.com/query/61738/kleros-v2-drt-arbisep-devnet/version/latest" ?? "Environment variables REACT_APP_DRT_ARBSEPOLIA_SUBGRAPH not set.",
    [(0, $7c10d207e8d5c39f$export$625cf84d855940d4).id]: "" ?? "Environment variables REACT_APP_DRT_ARBMAINNET_SUBGRAPH not set."
};
const $861188ef5e13bfe8$export$c7a04534f7a88653 = (isDisputeTemplate = false, chainId = (0, $32162005f9f3d1a7$export$8372812df8e8183f))=>{
    const coreUrl = "https://api.studio.thegraph.com/query/61738/kleros-v2-coreneo-devnet/version/latest" ?? "Environment variables REACT_APP_CORE_SUBGRAPH not set.";
    return isDisputeTemplate ? $861188ef5e13bfe8$var$CHAINID_TO_DISPUTE_TEMPLATE_SUBGRAPH[chainId] : coreUrl;
};


const $e6e1be54a100c2c5$var$Context = /*#__PURE__*/ (0, $dup7A.createContext)(undefined);
const $e6e1be54a100c2c5$var$fetcher = async (queries)=>{
    const promises = queries.map(async ({ id: id, document: document, variables: variables, isDisputeTemplate: isDisputeTemplate, chainId: chainId })=>{
        const url = (0, $861188ef5e13bfe8$export$c7a04534f7a88653)(isDisputeTemplate ?? false, chainId);
        try {
            return (0, $3ecb954f3d350801$exports.request)(url, document, variables).then((result)=>({
                    id: id,
                    result: result
                }));
        } catch (error) {
            console.error("Graph error: ", {
                error: error
            });
            (0, $074a4e3f371abdca$export$18f70d5facb50d50)("Graph query error: failed to fetch data.");
            return {
                id: id,
                result: {}
            };
        }
    });
    const data = await Promise.all(promises);
    return data;
};
const $e6e1be54a100c2c5$var$GraphqlBatcherProvider = ({ children: children })=>{
    const graphqlBatcher = (0, $31ec6e28bfb122fa$export$185802fd694ee1f5)({
        fetcher: $e6e1be54a100c2c5$var$fetcher,
        resolver: (results, query)=>results.find((result)=>result.id === query.id)["result"],
        scheduler: (0, $31ec6e28bfb122fa$export$c588696e674bc1bf)({
            windowMs: 100,
            maxBatchSize: 5
        })
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($e6e1be54a100c2c5$var$Context.Provider, {
        value: (0, $dup7A.useMemo)(()=>({
                graphqlBatcher: graphqlBatcher
            }), [
            graphqlBatcher
        ]),
        children: children
    });
};
const $e6e1be54a100c2c5$export$45728877641088dc = ()=>{
    const context = (0, $dup7A.useContext)($e6e1be54a100c2c5$var$Context);
    if (!context) throw new Error("Context Provider not found.");
    return context;
};
var $e6e1be54a100c2c5$export$2e2bcd8739ae039 = $e6e1be54a100c2c5$var$GraphqlBatcherProvider;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $226407d615d776bb$export$8793edee2d425525 = function() {};
function $226407d615d776bb$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $226407d615d776bb$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $226407d615d776bb$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $226407d615d776bb$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $f8fde51e27a510f9$var$useLocalStorage = function(key, initialValue, options) {
    if (!(0, $226407d615d776bb$export$4e09c449d6c407f7)) return [
        initialValue,
        (0, $226407d615d776bb$export$8793edee2d425525),
        (0, $226407d615d776bb$export$8793edee2d425525)
    ];
    if (!key) throw new Error("useLocalStorage key may not be falsy");
    var deserializer = options ? options.raw ? function(value) {
        return value;
    } : options.deserializer : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0, $dup7A.useRef)(function(key) {
        try {
            var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0, $dup7A.useState)(function() {
        return initializer.current(key);
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dup7A.useLayoutEffect)(function() {
        return setState(initializer.current(key));
    }, [
        key
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0, $dup7A.useCallback)(function(valOrFunc) {
        try {
            var newState = typeof valOrFunc === "function" ? valOrFunc(state) : valOrFunc;
            if (typeof newState === "undefined") return;
            var value = void 0;
            if (options) {
                if (options.raw) {
                    if (typeof newState === "string") value = newState;
                    else value = JSON.stringify(newState);
                } else if (options.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [
        key,
        setState
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0, $dup7A.useCallback)(function() {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw.
        }
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
};
var $f8fde51e27a510f9$export$2e2bcd8739ae039 = $f8fde51e27a510f9$var$useLocalStorage;


var $dup7A = parcelRequire("dup7A");
var $8602f0178864630e$var$toggleReducer = function(state, nextValue) {
    return typeof nextValue === "boolean" ? nextValue : !state;
};
var $8602f0178864630e$var$useToggle = function(initialValue) {
    return (0, $dup7A.useReducer)($8602f0178864630e$var$toggleReducer, initialValue);
};
var $8602f0178864630e$export$2e2bcd8739ae039 = $8602f0178864630e$var$useToggle;


const $b73946e052a4abb0$var$Context = /*#__PURE__*/ (0, $dup7A.createContext)({
    isList: false,
    setIsList: ()=>{
    //
    }
});
const $b73946e052a4abb0$var$IsListProvider = ({ children: children })=>{
    const [isListStorage, setIsListStorage] = (0, $f8fde51e27a510f9$export$2e2bcd8739ae039)("isList", false);
    const [isList, setIsListState] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(isListStorage ?? false);
    const setIsList = (toggle)=>{
        setIsListState(toggle);
        setIsListStorage(toggle);
    };
    const value = {
        isList: isList,
        setIsList: setIsList
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)($b73946e052a4abb0$var$Context.Provider, {
        value: value,
        children: children
    });
};
const $b73946e052a4abb0$export$efcb02388d4a2108 = ()=>(0, $dup7A.useContext)($b73946e052a4abb0$var$Context);
var $b73946e052a4abb0$export$2e2bcd8739ae039 = $b73946e052a4abb0$var$IsListProvider;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
function $87eb39de431e3151$export$86e2cef2561044ac(keyName, defaultValue) {
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        try {
            const value = window.localStorage.getItem(keyName);
            return value ? JSON.parse(value) : defaultValue;
        } catch (err) {
            return defaultValue;
        }
    });
    const setValue = (newValue)=>{
        try {
            window.localStorage.setItem(keyName, JSON.stringify(newValue));
        } finally{
            setStoredValue(newValue);
        }
    };
    return [
        storedValue,
        setValue
    ];
}


const $2d857633ba67aa25$export$fce6876652108ab = (maybeObject)=>typeof maybeObject === "undefined" || maybeObject === null;


const $402e40eea0418fd8$var$initialDisputeData = {
    numberOfJurors: 3,
    title: "",
    description: "",
    question: "",
    answers: [
        {
            title: "",
            id: "1"
        },
        {
            title: "",
            id: "2"
        }
    ],
    aliases: [
        {
            name: "",
            address: "",
            id: "1"
        },
        {
            name: "",
            address: "",
            id: "2"
        }
    ]
};
const $402e40eea0418fd8$var$initialDisputeTemplate = $402e40eea0418fd8$var$initialDisputeData;
const $402e40eea0418fd8$var$NewDisputeContext = /*#__PURE__*/ (0, $dup7A.createContext)({
    disputeData: $402e40eea0418fd8$var$initialDisputeData,
    setDisputeData: ()=>{},
    disputeTemplate: $402e40eea0418fd8$var$initialDisputeTemplate,
    resetDisputeData: ()=>{},
    isSubmittingCase: false,
    setIsSubmittingCase: ()=>{},
    isPolicyUploading: false,
    setIsPolicyUploading: ()=>{}
});
const $402e40eea0418fd8$export$e980d1a1a195f0af = ()=>(0, $dup7A.useContext)($402e40eea0418fd8$var$NewDisputeContext);
const $402e40eea0418fd8$export$9b11d8be314cc86 = ({ children: children })=>{
    const [disputeData, setDisputeData] = (0, $87eb39de431e3151$export$86e2cef2561044ac)("disputeData", $402e40eea0418fd8$var$initialDisputeData);
    const [isSubmittingCase, setIsSubmittingCase] = (0, $dup7A.useState)(false);
    const [isPolicyUploading, setIsPolicyUploading] = (0, $dup7A.useState)(false);
    const disputeTemplate = (0, $dup7A.useMemo)(()=>$402e40eea0418fd8$var$constructDisputeTemplate(disputeData), [
        disputeData
    ]);
    const resetDisputeData = ()=>{
        setDisputeData($402e40eea0418fd8$var$initialDisputeData);
    };
    const contextValues = (0, $dup7A.useMemo)(()=>({
            disputeData: disputeData,
            setDisputeData: setDisputeData,
            disputeTemplate: disputeTemplate,
            resetDisputeData: resetDisputeData,
            isSubmittingCase: isSubmittingCase,
            setIsSubmittingCase: setIsSubmittingCase,
            isPolicyUploading: isPolicyUploading,
            setIsPolicyUploading: setIsPolicyUploading
        }), [
        disputeData,
        disputeTemplate,
        resetDisputeData,
        isSubmittingCase,
        isPolicyUploading
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($402e40eea0418fd8$var$NewDisputeContext.Provider, {
        value: contextValues,
        children: children
    });
};
const $402e40eea0418fd8$var$constructDisputeTemplate = (disputeData)=>{
    const baseTemplate = {
        ...disputeData
    };
    if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(baseTemplate.aliases)) {
        baseTemplate.aliases = baseTemplate.aliases.filter((item)=>item.address !== "" && item.isValid);
        if (baseTemplate.aliases.length === 0) delete baseTemplate.aliases;
    }
    if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(baseTemplate.policyURI) && baseTemplate.policyURI === "") delete baseTemplate.policyURI;
    return baseTemplate;
};



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
// TYPES
// UTILS
const $0dbdedbceaf62b7f$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $0dbdedbceaf62b7f$export$8793edee2d425525() {
    return undefined;
}
function $0dbdedbceaf62b7f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $0dbdedbceaf62b7f$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $0dbdedbceaf62b7f$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $0dbdedbceaf62b7f$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $0dbdedbceaf62b7f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$0dbdedbceaf62b7f$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $0dbdedbceaf62b7f$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($0dbdedbceaf62b7f$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $0dbdedbceaf62b7f$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $0dbdedbceaf62b7f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $0dbdedbceaf62b7f$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $0dbdedbceaf62b7f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $0dbdedbceaf62b7f$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($0dbdedbceaf62b7f$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $0dbdedbceaf62b7f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$0dbdedbceaf62b7f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $0dbdedbceaf62b7f$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($0dbdedbceaf62b7f$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($0dbdedbceaf62b7f$export$5fcb678681417b54(mutation.options.mutationKey) !== $0dbdedbceaf62b7f$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$0dbdedbceaf62b7f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $0dbdedbceaf62b7f$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $0dbdedbceaf62b7f$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $0dbdedbceaf62b7f$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$0dbdedbceaf62b7f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $0dbdedbceaf62b7f$export$2f07189bb9fa26a7(a, b) {
    return $0dbdedbceaf62b7f$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $0dbdedbceaf62b7f$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$0dbdedbceaf62b7f$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $0dbdedbceaf62b7f$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $0dbdedbceaf62b7f$export$7a8558113332b71e(a) && $0dbdedbceaf62b7f$export$7a8558113332b71e(b);
    if (array || $0dbdedbceaf62b7f$export$53b83ca8eaab0383(a) && $0dbdedbceaf62b7f$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $0dbdedbceaf62b7f$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $0dbdedbceaf62b7f$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $0dbdedbceaf62b7f$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $0dbdedbceaf62b7f$export$53b83ca8eaab0383(o) {
    if (!$0dbdedbceaf62b7f$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$0dbdedbceaf62b7f$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $0dbdedbceaf62b7f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $0dbdedbceaf62b7f$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $0dbdedbceaf62b7f$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $0dbdedbceaf62b7f$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $0dbdedbceaf62b7f$export$4304cb76768ca134(callback) {
    $0dbdedbceaf62b7f$export$e772c8ff12451969(0).then(callback);
}
function $0dbdedbceaf62b7f$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $0dbdedbceaf62b7f$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $0dbdedbceaf62b7f$export$77a71fc411098696(prevData, data);
    return data;
}




const $14c9069b82161625$export$1cf3d545f2d4635c = console;



function $68993055bb63f552$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $0dbdedbceaf62b7f$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $0dbdedbceaf62b7f$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $68993055bb63f552$export$520687f44db6e1ab = $68993055bb63f552$export$316a8efd03cd1458();


class $1e06462cf8f768aa$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $392c8a4d2470bdeb$export$86f1af424b2ca4de extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $0dbdedbceaf62b7f$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $392c8a4d2470bdeb$export$6bf54661be5b02cf = new $392c8a4d2470bdeb$export$86f1af424b2ca4de();




const $feb9ec7a67509d8b$var$onlineEvents = [
    "online",
    "offline"
];
class $feb9ec7a67509d8b$export$58774fb55d5ff7fc extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $0dbdedbceaf62b7f$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $feb9ec7a67509d8b$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $feb9ec7a67509d8b$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $feb9ec7a67509d8b$export$b113e788b2dd3fdc = new $feb9ec7a67509d8b$export$58774fb55d5ff7fc();



function $de7143f6b46e82a7$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $de7143f6b46e82a7$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $feb9ec7a67509d8b$export$b113e788b2dd3fdc).isOnline() : true;
}
class $de7143f6b46e82a7$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $de7143f6b46e82a7$export$986cc6445c1d323(value) {
    return value instanceof $de7143f6b46e82a7$export$a8430ed4188f35a9;
}
function $de7143f6b46e82a7$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $de7143f6b46e82a7$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $392c8a4d2470bdeb$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $feb9ec7a67509d8b$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $de7143f6b46e82a7$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $0dbdedbceaf62b7f$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($de7143f6b46e82a7$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}



class $9c2a4d5a4b23e143$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $0dbdedbceaf62b7f$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $0dbdedbceaf62b7f$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $1d4bd2cc314ddee0$export$62297b13309008b2 extends (0, $9c2a4d5a4b23e143$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $14c9069b82161625$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $1d4bd2cc314ddee0$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $0dbdedbceaf62b7f$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $0dbdedbceaf62b7f$export$8793edee2d425525)).catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $0dbdedbceaf62b7f$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $0dbdedbceaf62b7f$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $de7143f6b46e82a7$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $de7143f6b46e82a7$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $de7143f6b46e82a7$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $de7143f6b46e82a7$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $de7143f6b46e82a7$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $1d4bd2cc314ddee0$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $94f1c52370727825$export$5dde0cd941da8468 extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $0dbdedbceaf62b7f$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $1d4bd2cc314ddee0$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $0dbdedbceaf62b7f$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $0dbdedbceaf62b7f$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $c6c1480edaba5f5a$export$17b8b19c814bcf56 extends (0, $9c2a4d5a4b23e143$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $14c9069b82161625$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $c6c1480edaba5f5a$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $de7143f6b46e82a7$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $de7143f6b46e82a7$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $c6c1480edaba5f5a$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}




// CLASS
class $a57ce96d4ade0f90$export$1fcfd9a244434844 extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $c6c1480edaba5f5a$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $0dbdedbceaf62b7f$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $0dbdedbceaf62b7f$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $b9a95e9bda82715a$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $b9a95e9bda82715a$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $b9a95e9bda82715a$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $b9a95e9bda82715a$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $b9a95e9bda82715a$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $b9a95e9bda82715a$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $b9a95e9bda82715a$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $b9a95e9bda82715a$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $b9a95e9bda82715a$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $b9a95e9bda82715a$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $05b7f67ee565c164$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $94f1c52370727825$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $a57ce96d4ade0f90$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $14c9069b82161625$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $392c8a4d2470bdeb$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $392c8a4d2470bdeb$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $feb9ec7a67509d8b$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $feb9ec7a67509d8b$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $0dbdedbceaf62b7f$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $0dbdedbceaf62b7f$export$8793edee2d425525)).catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $0dbdedbceaf62b7f$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $0dbdedbceaf62b7f$export$8793edee2d425525)).catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $b9a95e9bda82715a$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $0dbdedbceaf62b7f$export$8793edee2d425525)).catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $0dbdedbceaf62b7f$export$5fcb678681417b54)(queryKey) === (0, $0dbdedbceaf62b7f$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $0dbdedbceaf62b7f$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $0dbdedbceaf62b7f$export$5fcb678681417b54)(mutationKey) === (0, $0dbdedbceaf62b7f$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $0dbdedbceaf62b7f$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $0dbdedbceaf62b7f$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $dup7A = parcelRequire("dup7A");
"use client";
const $838c1a6e5f3807de$export$2fba198b5b2e37fa = /*#__PURE__*/ $dup7A.createContext(undefined);
const $838c1a6e5f3807de$var$QueryClientSharingContext = /*#__PURE__*/ $dup7A.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $838c1a6e5f3807de$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $838c1a6e5f3807de$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $838c1a6e5f3807de$export$2fba198b5b2e37fa;
}
const $838c1a6e5f3807de$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $dup7A.useContext($838c1a6e5f3807de$var$getQueryClientContext(context, $dup7A.useContext($838c1a6e5f3807de$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $838c1a6e5f3807de$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $dup7A.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $838c1a6e5f3807de$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $dup7A.createElement($838c1a6e5f3807de$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $dup7A.createElement(Context.Provider, {
        value: client
    }, children));
};


const $4843a074f5ea24c4$var$queryClient = new (0, $05b7f67ee565c164$export$405d0624ed55a03f)();
const $4843a074f5ea24c4$var$QueryClientProvider = ({ children: children })=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $838c1a6e5f3807de$export$45604f0cc8ae667b), {
        client: $4843a074f5ea24c4$var$queryClient,
        children: children
    });
var $4843a074f5ea24c4$export$2e2bcd8739ae039 = $4843a074f5ea24c4$var$QueryClientProvider;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

function $9472772a4ddb9b7c$export$35561f995d4e487d({ storage: storage, key: key = "REACT_QUERY_OFFLINE_CACHE", throttleTime: throttleTime = 1000, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry }) {
    if (storage) {
        const trySave = (persistedClient)=>{
            try {
                storage.setItem(key, serialize(persistedClient));
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: $9472772a4ddb9b7c$var$throttle((persistedClient)=>{
                let client = persistedClient;
                let error = trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = retry == null ? void 0 : retry({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    });
                    if (client) error = trySave(client);
                }
            }, throttleTime),
            restoreClient: ()=>{
                const cacheString = storage.getItem(key);
                if (!cacheString) return;
                return deserialize(cacheString);
            },
            removeClient: ()=>{
                storage.removeItem(key);
            }
        };
    }
    return {
        persistClient: $9472772a4ddb9b7c$var$noop,
        restoreClient: ()=>undefined,
        removeClient: $9472772a4ddb9b7c$var$noop
    };
}
function $9472772a4ddb9b7c$var$throttle(func, wait = 100) {
    let timer = null;
    let params;
    return function(...args) {
        params = args;
        if (timer === null) timer = setTimeout(()=>{
            func(...params);
            timer = null;
        }, wait);
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $9472772a4ddb9b7c$var$noop() {}







class $195f43ad8a933b91$export$a06cf8c0066f0d4c extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($195f43ad8a933b91$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $195f43ad8a933b91$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $195f43ad8a933b91$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $0dbdedbceaf62b7f$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $195f43ad8a933b91$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($195f43ad8a933b91$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $0dbdedbceaf62b7f$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $0dbdedbceaf62b7f$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $0dbdedbceaf62b7f$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $0dbdedbceaf62b7f$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $0dbdedbceaf62b7f$export$6acf61af03e62db) || this.options.enabled === false || !(0, $0dbdedbceaf62b7f$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $392c8a4d2470bdeb$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $195f43ad8a933b91$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $195f43ad8a933b91$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $de7143f6b46e82a7$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $0dbdedbceaf62b7f$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $0dbdedbceaf62b7f$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $195f43ad8a933b91$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $0dbdedbceaf62b7f$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $de7143f6b46e82a7$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $195f43ad8a933b91$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $195f43ad8a933b91$var$shouldFetchOnMount(query, options) {
    return $195f43ad8a933b91$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $195f43ad8a933b91$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $195f43ad8a933b91$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $195f43ad8a933b91$var$isStale(query, options);
    }
    return false;
}
function $195f43ad8a933b91$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $195f43ad8a933b91$var$isStale(query, options);
}
function $195f43ad8a933b91$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $195f43ad8a933b91$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $0dbdedbceaf62b7f$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



class $b6de0072e23a8ce7$export$85d960eb3ab339c8 extends (0, $195f43ad8a933b91$export$a06cf8c0066f0d4c) {
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options, notifyOptions) {
        super.setOptions({
            ...options,
            behavior: (0, $b9a95e9bda82715a$export$84470d1367601e8d)()
        }, notifyOptions);
    }
    getOptimisticResult(options) {
        options.behavior = (0, $b9a95e9bda82715a$export$84470d1367601e8d)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "forward",
                    pageParam: pageParam
                }
            }
        });
    }
    fetchPreviousPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "backward",
                    pageParam: pageParam
                }
            }
        });
    }
    createResult(query, options) {
        var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;
        const { state: state } = query;
        const result = super.createResult(query, options);
        const { isFetching: isFetching, isRefetching: isRefetching } = result;
        const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === "forward";
        const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === "backward";
        return {
            ...result,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $b9a95e9bda82715a$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $b9a95e9bda82715a$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: isFetchingNextPage,
            isFetchingPreviousPage: isFetchingPreviousPage,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        };
    }
}


var $dup7A = parcelRequire("dup7A");
"use client";
const $d311ebbf0b97d2d5$var$IsRestoringContext = /*#__PURE__*/ $dup7A.createContext(false);
const $d311ebbf0b97d2d5$export$4da0178d6b5f553 = ()=>$dup7A.useContext($d311ebbf0b97d2d5$var$IsRestoringContext);
const $d311ebbf0b97d2d5$export$593807d4e94f9621 = $d311ebbf0b97d2d5$var$IsRestoringContext.Provider;


var $dup7A = parcelRequire("dup7A");




// CLASS
class $cd62fdc4dd08a564$export$d3c1860ee66f291a extends (0, $1e06462cf8f768aa$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $0dbdedbceaf62b7f$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $c6c1480edaba5f5a$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $68993055bb63f552$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}


var $bdc49dcdcb562520$exports = {};
"use strict";

$bdc49dcdcb562520$exports = (parcelRequire("bIVSC"));


"use client";
const $a055f72c1f0ab780$export$306c0aa65ff9ec16 = (0, $bdc49dcdcb562520$exports.useSyncExternalStore);



function $a257437a2bd3092d$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
function $fb112f8e80340db4$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $0dbdedbceaf62b7f$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $dup7A.useState(()=>new (0, $cd62fdc4dd08a564$export$d3c1860ee66f291a)(queryClient, options));
    $dup7A.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $a055f72c1f0ab780$export$306c0aa65ff9ec16)($dup7A.useCallback((onStoreChange)=>observer.subscribe((0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $dup7A.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($fb112f8e80340db4$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $a257437a2bd3092d$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $fb112f8e80340db4$var$noop() {}


var $dup7A = parcelRequire("dup7A");
"use client";
function $e8a4c4723d8eb8d0$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $e8a4c4723d8eb8d0$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $dup7A.createContext($e8a4c4723d8eb8d0$var$createValue()); // HOOK
const $e8a4c4723d8eb8d0$export$50dfac555130cafd = ()=>$dup7A.useContext($e8a4c4723d8eb8d0$var$QueryErrorResetBoundaryContext); // COMPONENT
const $e8a4c4723d8eb8d0$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $dup7A.useState(()=>$e8a4c4723d8eb8d0$var$createValue());
    return /*#__PURE__*/ $dup7A.createElement($e8a4c4723d8eb8d0$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};


// TYPES
// FUNCTIONS
function $6231dfc2db42068b$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function $6231dfc2db42068b$var$dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function $6231dfc2db42068b$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
function $6231dfc2db42068b$export$e71bc20295698fa1(query) {
    return query.state.status === "success";
}
function $6231dfc2db42068b$export$12aee8bb597e7dfe(client, options = {}) {
    const mutations = [];
    const queries = [];
    if (options.dehydrateMutations !== false) {
        const shouldDehydrateMutation = options.shouldDehydrateMutation || $6231dfc2db42068b$export$3aa4c2840e01e53;
        client.getMutationCache().getAll().forEach((mutation)=>{
            if (shouldDehydrateMutation(mutation)) mutations.push($6231dfc2db42068b$var$dehydrateMutation(mutation));
        });
    }
    if (options.dehydrateQueries !== false) {
        const shouldDehydrateQuery = options.shouldDehydrateQuery || $6231dfc2db42068b$export$e71bc20295698fa1;
        client.getQueryCache().getAll().forEach((query)=>{
            if (shouldDehydrateQuery(query)) queries.push($6231dfc2db42068b$var$dehydrateQuery(query));
        });
    }
    return {
        mutations: mutations,
        queries: queries
    };
}
function $6231dfc2db42068b$export$fa8d919ba61d84db(client, dehydratedState, options) {
    if (typeof dehydratedState !== "object" || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _options$defaultOptio;
        mutationCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations,
            mutationKey: dehydratedMutation.mutationKey
        }, dehydratedMutation.state);
    });
    queries.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash })=>{
        var _options$defaultOptio2;
        const query = queryCache.get(queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                // omit fetchStatus from dehydrated state
                // so that query stays in its current fetchStatus
                const { fetchStatus: _ignored, ...dehydratedQueryState } = state;
                query.setState(dehydratedQueryState);
            }
            return;
        } // Restore query
        queryCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries,
            queryKey: queryKey,
            queryHash: queryHash
        }, // query being stuck in fetching state upon hydration
        {
            ...state,
            fetchStatus: "idle"
        });
    });
}


/**
 * Checks if emitted event is about cache change and not about observers.
 * Useful for persist, where we only want to trigger save when cache is changed.
 */ const $008a9868cb5886d7$var$cacheableEventTypes = [
    "added",
    "removed",
    "updated"
];
function $008a9868cb5886d7$var$isCacheableEventType(eventType) {
    return $008a9868cb5886d7$var$cacheableEventTypes.includes(eventType);
}
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */ async function $008a9868cb5886d7$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 86400000, buster: buster = "", hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) persister.removeClient();
                else (0, $6231dfc2db42068b$export$fa8d919ba61d84db)(queryClient, persistedClient.clientState, hydrateOptions);
            } else persister.removeClient();
        }
    } catch (err) {
        persister.removeClient();
    }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */ async function $008a9868cb5886d7$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = "", dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $6231dfc2db42068b$export$12aee8bb597e7dfe)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */ function $008a9868cb5886d7$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($008a9868cb5886d7$var$isCacheableEventType(event.type)) $008a9868cb5886d7$export$8a3b4786a14f2528(props);
    });
    const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($008a9868cb5886d7$var$isCacheableEventType(event.type)) $008a9868cb5886d7$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unusbscribeMutationCache();
    };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */ function $008a9868cb5886d7$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe == null || persistQueryClientUnsubscribe();
    }; // Attempt restore
    const restorePromise = $008a9868cb5886d7$export$781eb0ebad7272a1(props).then(()=>{
        if (!hasUnsubscribed) // Subscribe to changes in the query cache to trigger the save
        persistQueryClientUnsubscribe = $008a9868cb5886d7$export$9fe01d80627be88c(props);
    });
    return [
        unsubscribe,
        restorePromise
    ];
}



var $eUiaP = parcelRequire("eUiaP");

var $dup7A = parcelRequire("dup7A");

var $fAYJg = parcelRequire("fAYJg");
var $f7ae890ec1ee400f$exports = {};
"use strict";

$f7ae890ec1ee400f$exports = (parcelRequire("8Gdy2"));



var $eUiaP = parcelRequire("eUiaP");

"use client";
function $1d657eb5d64e17dc$export$45a69314cf48a3eb({ queryClient: queryClient = new (0, $05b7f67ee565c164$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            cacheTime: 86400000,
            networkMode: "offlineFirst",
            refetchOnWindowFocus: false,
            retry: 0
        },
        mutations: {
            networkMode: "offlineFirst"
        }
    }
}), storage: storage = (0, $eUiaP.createStorage)({
    storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : (0, $eUiaP.noopStorage)
}), persister: persister = typeof window !== "undefined" ? (0, $9472772a4ddb9b7c$export$35561f995d4e487d)({
    key: "cache",
    storage: storage,
    serialize: (x)=>x,
    deserialize: (x)=>x
}) : void 0, ...args }) {
    const config = (0, $eUiaP.createConfig)({
        ...args,
        storage: storage
    });
    if (persister) (0, $008a9868cb5886d7$export$217ab42a80f50b3b)({
        queryClient: queryClient,
        persister: persister,
        dehydrateOptions: {
            shouldDehydrateQuery: (query)=>query.cacheTime !== 0 && query.queryKey[0].persist !== false
        }
    });
    return Object.assign(config, {
        queryClient: queryClient
    });
}
var $1d657eb5d64e17dc$export$841858b892ce1f4c = $dup7A.createContext(void 0);
var $1d657eb5d64e17dc$var$queryClientContext = $dup7A.createContext(void 0);
function $1d657eb5d64e17dc$export$c3a561dea2adc16c({ children: children, config: config }) {
    return $dup7A.createElement($1d657eb5d64e17dc$export$841858b892ce1f4c.Provider, {
        children: $dup7A.createElement((0, $838c1a6e5f3807de$export$45604f0cc8ae667b), {
            children: children,
            client: config.queryClient,
            context: $1d657eb5d64e17dc$var$queryClientContext
        }),
        value: config
    });
}
function $1d657eb5d64e17dc$export$b3611e87cd5ba6ce() {
    const config = $dup7A.useContext($1d657eb5d64e17dc$export$841858b892ce1f4c);
    if (!config) throw new Error([
        "`useConfig` must be used within `WagmiConfig`.\n",
        "Read more: https://wagmi.sh/react/WagmiConfig"
    ].join("\n"));
    return config;
}
var $1d657eb5d64e17dc$var$useSyncExternalStore2 = $fAYJg.useSyncExternalStore;
// src/hooks/utils/query/utils.ts
function $1d657eb5d64e17dc$var$isQueryKey(value) {
    return Array.isArray(value);
}
function $1d657eb5d64e17dc$var$isPlainObject(o) {
    if (!$1d657eb5d64e17dc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$1d657eb5d64e17dc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $1d657eb5d64e17dc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $1d657eb5d64e17dc$var$parseQueryArgs(arg1, arg2, arg3) {
    if (!$1d657eb5d64e17dc$var$isQueryKey(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $1d657eb5d64e17dc$var$queryKeyHashFn(queryKey17) {
    return JSON.stringify(queryKey17, (_, val)=>$1d657eb5d64e17dc$var$isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : typeof val === "bigint" ? val.toString() : val);
}
function $1d657eb5d64e17dc$var$shouldThrowError(_useErrorBoundary, params) {
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}
function $1d657eb5d64e17dc$var$trackResult(result, observer) {
    const trackedResult = {};
    Object.keys(result).forEach((key)=>{
        Object.defineProperty(trackedResult, key, {
            configurable: false,
            enumerable: true,
            get: ()=>{
                observer.trackedProps.add(key);
                return result[key];
            }
        });
    });
    return trackedResult;
}
// src/hooks/utils/query/useBaseQuery.ts
function $1d657eb5d64e17dc$var$useBaseQuery(options, Observer) {
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $d311ebbf0b97d2d5$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $e8a4c4723d8eb8d0$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions({
        ...options,
        queryKeyHashFn: $1d657eb5d64e17dc$var$queryKeyHashFn
    });
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    const [observer] = $dup7A.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $1d657eb5d64e17dc$var$useSyncExternalStore2($dup7A.useCallback((onStoreChange)=>isRestoring ? ()=>void 0 : observer.subscribe((0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $dup7A.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
    $dup7A.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if (defaultedOptions.suspense && result.isLoading && result.isFetching && !isRestoring) throw observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess?.(data);
        defaultedOptions.onSettled?.(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError?.(error);
        defaultedOptions.onSettled?.(void 0, error);
    });
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && $1d657eb5d64e17dc$var$shouldThrowError(defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
    const status = result.status === "loading" && result.fetchStatus === "idle" ? "idle" : result.status;
    const isIdle = status === "idle";
    const isLoading = status === "loading" && result.fetchStatus === "fetching";
    return {
        ...result,
        defaultedOptions: defaultedOptions,
        isIdle: isIdle,
        isLoading: isLoading,
        observer: observer,
        status: status
    };
}
function $1d657eb5d64e17dc$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    const parsedOptions = $1d657eb5d64e17dc$var$parseQueryArgs(arg1, arg2, arg3);
    const baseQuery = $1d657eb5d64e17dc$var$useBaseQuery({
        context: $1d657eb5d64e17dc$var$queryClientContext,
        ...parsedOptions
    }, (0, $b6de0072e23a8ce7$export$85d960eb3ab339c8));
    const result = {
        data: baseQuery.data,
        error: baseQuery.error,
        fetchNextPage: baseQuery.fetchNextPage,
        fetchStatus: baseQuery.fetchStatus,
        hasNextPage: baseQuery.hasNextPage,
        isError: baseQuery.isError,
        isFetched: baseQuery.isFetched,
        isFetchedAfterMount: baseQuery.isFetchedAfterMount,
        isFetching: baseQuery.isFetching,
        isFetchingNextPage: baseQuery.isFetchingNextPage,
        isIdle: baseQuery.isIdle,
        isLoading: baseQuery.isLoading,
        isRefetching: baseQuery.isRefetching,
        isSuccess: baseQuery.isSuccess,
        refetch: baseQuery.refetch,
        status: baseQuery.status,
        internal: {
            dataUpdatedAt: baseQuery.dataUpdatedAt,
            errorUpdatedAt: baseQuery.errorUpdatedAt,
            failureCount: baseQuery.failureCount,
            isFetchedAfterMount: baseQuery.isFetchedAfterMount,
            isLoadingError: baseQuery.isLoadingError,
            isPaused: baseQuery.isPaused,
            isPlaceholderData: baseQuery.isPlaceholderData,
            isPreviousData: baseQuery.isPreviousData,
            isRefetchError: baseQuery.isRefetchError,
            isStale: baseQuery.isStale,
            remove: baseQuery.remove
        }
    };
    return !baseQuery.defaultedOptions.notifyOnChangeProps ? $1d657eb5d64e17dc$var$trackResult(result, baseQuery.observer) : result;
}
function $1d657eb5d64e17dc$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $0dbdedbceaf62b7f$export$b646c531ea475334)(arg1, arg2, arg3);
    return (0, $fb112f8e80340db4$export$609860bf8b0084c)({
        context: $1d657eb5d64e17dc$var$queryClientContext,
        ...options
    });
}
function $1d657eb5d64e17dc$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = $1d657eb5d64e17dc$var$parseQueryArgs(arg1, arg2, arg3);
    const baseQuery = $1d657eb5d64e17dc$var$useBaseQuery({
        context: $1d657eb5d64e17dc$var$queryClientContext,
        ...parsedOptions
    }, (0, $195f43ad8a933b91$export$a06cf8c0066f0d4c));
    const result = {
        data: baseQuery.data,
        error: baseQuery.error,
        fetchStatus: baseQuery.fetchStatus,
        isError: baseQuery.isError,
        isFetched: baseQuery.isFetched,
        isFetchedAfterMount: baseQuery.isFetchedAfterMount,
        isFetching: baseQuery.isFetching,
        isIdle: baseQuery.isIdle,
        isLoading: baseQuery.isLoading,
        isRefetching: baseQuery.isRefetching,
        isSuccess: baseQuery.isSuccess,
        refetch: baseQuery.refetch,
        status: baseQuery.status,
        internal: {
            dataUpdatedAt: baseQuery.dataUpdatedAt,
            errorUpdatedAt: baseQuery.errorUpdatedAt,
            failureCount: baseQuery.failureCount,
            isFetchedAfterMount: baseQuery.isFetchedAfterMount,
            isLoadingError: baseQuery.isLoadingError,
            isPaused: baseQuery.isPaused,
            isPlaceholderData: baseQuery.isPlaceholderData,
            isPreviousData: baseQuery.isPreviousData,
            isRefetchError: baseQuery.isRefetchError,
            isStale: baseQuery.isStale,
            remove: baseQuery.remove
        }
    };
    return !baseQuery.defaultedOptions.notifyOnChangeProps ? $1d657eb5d64e17dc$var$trackResult(result, baseQuery.observer) : result;
}
var $1d657eb5d64e17dc$export$22e77b9572c4fded = ()=>(0, $838c1a6e5f3807de$export$22e77b9572c4fded)({
        context: $1d657eb5d64e17dc$var$queryClientContext
    });
function $1d657eb5d64e17dc$export$3ca3483c611a99c4({ chainId: chainId } = {}) {
    return (0, $f7ae890ec1ee400f$exports.useSyncExternalStoreWithSelector)((cb)=>(0, $eUiaP.watchPublicClient)({
            chainId: chainId
        }, cb), ()=>(0, $eUiaP.getPublicClient)({
            chainId: chainId
        }), ()=>(0, $eUiaP.getPublicClient)({
            chainId: chainId
        }), (x)=>x, (a, b)=>a.uid === b.uid);
}
function $1d657eb5d64e17dc$var$queryKey({ chainId: chainId }) {
    return [
        {
            entity: "walletClient",
            chainId: chainId,
            persist: false
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn({ queryKey: [{ chainId: chainId }] }) {
    return (0, $eUiaP.getWalletClient)({
        chainId: chainId
    });
}
function $1d657eb5d64e17dc$export$742c698ad1033029({ chainId: chainId_, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { connector: connector } = $1d657eb5d64e17dc$export$83a8e409853da004();
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const walletClientQuery = $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey({
        chainId: chainId
    }), $1d657eb5d64e17dc$var$queryFn, {
        cacheTime: 0,
        enabled: Boolean(connector),
        staleTime: Infinity,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const queryClient = $1d657eb5d64e17dc$export$22e77b9572c4fded();
    $dup7A.useEffect(()=>{
        const unwatch = (0, $eUiaP.watchWalletClient)({
            chainId: chainId
        }, (walletClient)=>{
            if (walletClient) queryClient.invalidateQueries($1d657eb5d64e17dc$var$queryKey({
                chainId: chainId
            }));
            else queryClient.removeQueries($1d657eb5d64e17dc$var$queryKey({
                chainId: chainId
            }));
        });
        return unwatch;
    }, [
        queryClient,
        chainId
    ]);
    return walletClientQuery;
}
function $1d657eb5d64e17dc$export$724f5280724585ed({ chainId: chainId } = {}) {
    return (0, $f7ae890ec1ee400f$exports.useSyncExternalStoreWithSelector)((cb)=>(0, $eUiaP.watchWebSocketPublicClient)({
            chainId: chainId
        }, cb), ()=>(0, $eUiaP.getWebSocketPublicClient)({
            chainId: chainId
        }), ()=>(0, $eUiaP.getWebSocketPublicClient)({
            chainId: chainId
        }), (x)=>x, (a, b)=>a?.uid === b?.uid);
}
// src/hooks/utils/useChainId.ts
function $1d657eb5d64e17dc$export$dc276622421ed31d({ chainId: chainId } = {}) {
    const publicClient = $1d657eb5d64e17dc$export$3ca3483c611a99c4({
        chainId: chainId
    });
    return publicClient.chain.id;
}
function $1d657eb5d64e17dc$var$useForceUpdate() {
    const [, forceUpdate] = $dup7A.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}
function $1d657eb5d64e17dc$var$queryKey2({ chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "blockNumber",
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn2({ queryKey: [{ chainId: chainId }] }) {
    return (0, $eUiaP.fetchBlockNumber)({
        chainId: chainId
    });
}
function $1d657eb5d64e17dc$export$8bf0355f69442463({ cacheTime: cacheTime = 0, chainId: chainId_, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, watch: watch = false, onBlock: onBlock, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const publicClient = $1d657eb5d64e17dc$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $1d657eb5d64e17dc$export$724f5280724585ed({
        chainId: chainId
    });
    const queryClient = $1d657eb5d64e17dc$export$22e77b9572c4fded();
    $dup7A.useEffect(()=>{
        if (!enabled) return;
        if (!watch && !onBlock) return;
        const publicClient_ = webSocketPublicClient ?? publicClient;
        const unwatch = publicClient_.watchBlockNumber({
            onBlockNumber: (blockNumber)=>{
                if (watch) queryClient.setQueryData($1d657eb5d64e17dc$var$queryKey2({
                    chainId: chainId,
                    scopeKey: scopeKey
                }), blockNumber);
                if (onBlock) onBlock(blockNumber);
            },
            emitOnBegin: true
        });
        return unwatch;
    }, [
        chainId,
        scopeKey,
        onBlock,
        publicClient,
        queryClient,
        watch,
        webSocketPublicClient,
        enabled
    ]);
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey2({
        scopeKey: scopeKey,
        chainId: chainId
    }), $1d657eb5d64e17dc$var$queryFn2, {
        cacheTime: cacheTime,
        enabled: enabled,
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey3({ chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey }) {
    return [
        {
            entity: "feeData",
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn3({ queryKey: [{ chainId: chainId, formatUnits: formatUnits }] }) {
    return (0, $eUiaP.fetchFeeData)({
        chainId: chainId,
        formatUnits: formatUnits
    });
}
function $1d657eb5d64e17dc$export$a72889bdc63e24a6({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, formatUnits: formatUnits = "gwei", scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, watch: watch, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const queryKey_ = $dup7A.useMemo(()=>$1d657eb5d64e17dc$var$queryKey3({
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }), [
        chainId,
        formatUnits,
        scopeKey
    ]);
    const feeDataQuery = $1d657eb5d64e17dc$export$dd0a697e1782aedd(queryKey_, $1d657eb5d64e17dc$var$queryFn3, {
        cacheTime: cacheTime,
        enabled: enabled,
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    $1d657eb5d64e17dc$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch),
        queryKey: queryKey_
    });
    return feeDataQuery;
}
// src/hooks/utils/useInvalidateOnBlock.ts
function $1d657eb5d64e17dc$var$useInvalidateOnBlock({ chainId: chainId, enabled: enabled, queryKey: queryKey17 }) {
    const queryClient = $1d657eb5d64e17dc$export$22e77b9572c4fded();
    const onBlock = $dup7A.useCallback(()=>queryClient.invalidateQueries({
            queryKey: queryKey17
        }, {
            cancelRefetch: false
        }), [
        queryClient,
        queryKey17
    ]);
    $1d657eb5d64e17dc$export$8bf0355f69442463({
        chainId: chainId,
        enabled: enabled,
        onBlock: enabled ? onBlock : void 0,
        scopeKey: enabled ? void 0 : "idle"
    });
}
var $1d657eb5d64e17dc$var$isPlainObject2 = (obj)=>typeof obj === "object" && !Array.isArray(obj);
function $1d657eb5d64e17dc$var$useSyncExternalStoreWithTracked(subscribe, getSnapshot, getServerSnapshot = getSnapshot, isEqual = (0, $eUiaP.deepEqual)) {
    const trackedKeys = $dup7A.useRef([]);
    const result = (0, $f7ae890ec1ee400f$exports.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getServerSnapshot, (x)=>x, (a, b)=>{
        if ($1d657eb5d64e17dc$var$isPlainObject2(a) && $1d657eb5d64e17dc$var$isPlainObject2(b) && trackedKeys.current.length) {
            for (const key of trackedKeys.current){
                const equal = isEqual(a[key], b[key]);
                if (!equal) return false;
            }
            return true;
        }
        return isEqual(a, b);
    });
    if ($1d657eb5d64e17dc$var$isPlainObject2(result)) {
        const trackedResult = {
            ...result
        };
        Object.defineProperties(trackedResult, Object.entries(trackedResult).reduce((res, [key, value])=>{
            return {
                ...res,
                [key]: {
                    configurable: false,
                    enumerable: true,
                    get: ()=>{
                        if (!trackedKeys.current.includes(key)) trackedKeys.current.push(key);
                        return value;
                    }
                }
            };
        }, {}));
        return trackedResult;
    }
    return result;
}
// src/hooks/accounts/useAccount.ts
function $1d657eb5d64e17dc$export$83a8e409853da004({ onConnect: onConnect, onDisconnect: onDisconnect } = {}) {
    const config = $1d657eb5d64e17dc$export$b3611e87cd5ba6ce();
    const watchAccount_ = $dup7A.useCallback((callback)=>(0, $eUiaP.watchAccount)(callback), [
        config
    ]);
    const account = $1d657eb5d64e17dc$var$useSyncExternalStoreWithTracked(watchAccount_, (0, $eUiaP.getAccount));
    const previousAccountRef = $dup7A.useRef();
    const previousAccount = previousAccountRef.current;
    $dup7A.useEffect(()=>{
        if (previousAccount?.status !== "connected" && account.status === "connected") onConnect?.({
            address: account.address,
            connector: account.connector,
            isReconnected: previousAccount?.status === "reconnecting" || previousAccount?.status === void 0
        });
        if (previousAccount?.status === "connected" && account.status === "disconnected") onDisconnect?.();
        previousAccountRef.current = account;
    }, [
        onConnect,
        onDisconnect,
        previousAccount,
        account
    ]);
    return account;
}
function $1d657eb5d64e17dc$var$queryKey4({ address: address, chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey, token: token }) {
    return [
        {
            entity: "balance",
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey,
            token: token
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn4({ queryKey: [{ address: address, chainId: chainId, formatUnits: formatUnits, token: token }] }) {
    if (!address) throw new Error("address is required");
    return (0, $eUiaP.fetchBalance)({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits,
        token: token
    });
}
function $1d657eb5d64e17dc$export$4f026b09e764c1f8({ address: address, cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, formatUnits: formatUnits, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, token: token, watch: watch, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const queryKey_ = $dup7A.useMemo(()=>$1d657eb5d64e17dc$var$queryKey4({
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey,
            token: token
        }), [
        address,
        chainId,
        formatUnits,
        scopeKey,
        token
    ]);
    const balanceQuery = $1d657eb5d64e17dc$export$dd0a697e1782aedd(queryKey_, $1d657eb5d64e17dc$var$queryFn4, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    $1d657eb5d64e17dc$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch && address),
        queryKey: queryKey_
    });
    return balanceQuery;
}
var $1d657eb5d64e17dc$var$mutationKey = (args)=>[
        {
            entity: "connect",
            ...args
        }
    ];
var $1d657eb5d64e17dc$var$mutationFn = (args)=>{
    const { connector: connector, chainId: chainId } = args;
    if (!connector) throw new Error("connector is required");
    return (0, $eUiaP.connect)({
        connector: connector,
        chainId: chainId
    });
};
function $1d657eb5d64e17dc$export$5daf65c1af3b369f({ chainId: chainId, connector: connector, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const config = $1d657eb5d64e17dc$export$b3611e87cd5ba6ce();
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey({
        connector: connector,
        chainId: chainId
    }), $1d657eb5d64e17dc$var$mutationFn, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const connect2 = $dup7A.useCallback((args)=>{
        return mutate({
            chainId: args?.chainId ?? chainId,
            connector: args?.connector ?? connector
        });
    }, [
        chainId,
        connector,
        mutate
    ]);
    const connectAsync = $dup7A.useCallback((args)=>{
        return mutateAsync({
            chainId: args?.chainId ?? chainId,
            connector: args?.connector ?? connector
        });
    }, [
        chainId,
        connector,
        mutateAsync
    ]);
    return {
        connect: connect2,
        connectAsync: connectAsync,
        connectors: config.connectors,
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        pendingConnector: variables?.connector,
        reset: reset,
        status: status,
        variables: variables
    };
}
var $1d657eb5d64e17dc$var$mutationKey2 = [
    {
        entity: "disconnect"
    }
];
var $1d657eb5d64e17dc$var$mutationFn2 = ()=>(0, $eUiaP.disconnect)();
function $1d657eb5d64e17dc$export$83bebf2fe7fead4e({ onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: disconnect2, mutateAsync: disconnectAsync, reset: reset, status: status } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey2, $1d657eb5d64e17dc$var$mutationFn2, {
        ...onError ? {
            onError (error2, _variables, context) {
                onError(error2, context);
            }
        } : {},
        onMutate: onMutate,
        ...onSettled ? {
            onSettled (_data, error2, _variables, context) {
                onSettled(error2, context);
            }
        } : {},
        ...onSuccess ? {
            onSuccess (_data, _variables, context) {
                onSuccess(context);
            }
        } : {}
    });
    return {
        disconnect: disconnect2,
        disconnectAsync: disconnectAsync,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        status: status
    };
}
function $1d657eb5d64e17dc$export$553aaf59afc1a2d8() {
    const config = $1d657eb5d64e17dc$export$b3611e87cd5ba6ce();
    const watchNetwork_ = (0, $dup7A.useCallback)((callback)=>(0, $eUiaP.watchNetwork)(callback), [
        config
    ]);
    return $1d657eb5d64e17dc$var$useSyncExternalStoreWithTracked(watchNetwork_, (0, $eUiaP.getNetwork));
}
var $1d657eb5d64e17dc$var$mutationKey3 = (args)=>[
        {
            entity: "signMessage",
            ...args
        }
    ];
var $1d657eb5d64e17dc$var$mutationFn3 = (args)=>{
    const { message: message } = args;
    if (!message) throw new Error("message is required");
    return (0, $eUiaP.signMessage)({
        message: message
    });
};
function $1d657eb5d64e17dc$export$2ec0271a2697cc5f({ message: message, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey3({
        message: message
    }), $1d657eb5d64e17dc$var$mutationFn3, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const signMessage2 = $dup7A.useCallback((args)=>mutate(args || {
            message: message
        }), [
        message,
        mutate
    ]);
    const signMessageAsync = $dup7A.useCallback((args)=>mutateAsync(args || {
            message: message
        }), [
        message,
        mutateAsync
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        signMessage: signMessage2,
        signMessageAsync: signMessageAsync,
        status: status,
        variables: variables
    };
}
function $1d657eb5d64e17dc$var$mutationKey4({ domain: domain, types: types, message: message, primaryType: primaryType }) {
    return [
        {
            entity: "signTypedData",
            domain: domain,
            types: types,
            message: message,
            primaryType: primaryType
        }
    ];
}
function $1d657eb5d64e17dc$var$mutationFn4(args) {
    const { domain: domain, types: types, primaryType: primaryType, message: message } = args;
    if (!domain) throw new Error("domain is required");
    if (!types) throw new Error("types is required");
    if (!primaryType) throw new Error("primaryType is required");
    if (!message) throw new Error("message is required");
    return (0, $eUiaP.signTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $1d657eb5d64e17dc$export$d9a762c0326d0ef4({ domain: domain, types: types, message: message, primaryType: primaryType, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey4({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    }), $1d657eb5d64e17dc$var$mutationFn4, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const signTypedData2 = $dup7A.useCallback((args)=>mutate({
            domain: args?.domain ?? domain,
            types: args?.types ?? types,
            message: args?.message ?? message,
            primaryType: args?.primaryType ?? primaryType
        }), [
        domain,
        types,
        primaryType,
        message,
        mutate
    ]);
    const signTypedDataAsync = $dup7A.useCallback((args)=>mutateAsync({
            domain: args?.domain ?? domain,
            types: args?.types ?? types,
            message: args?.message ?? message,
            primaryType: args?.primaryType ?? primaryType
        }), [
        domain,
        types,
        primaryType,
        message,
        mutateAsync
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        signTypedData: signTypedData2,
        signTypedDataAsync: signTypedDataAsync,
        status: status,
        variables: variables
    };
}
var $1d657eb5d64e17dc$var$mutationKey5 = (args)=>[
        {
            entity: "switchNetwork",
            ...args
        }
    ];
var $1d657eb5d64e17dc$var$mutationFn5 = (args)=>{
    const { chainId: chainId } = args;
    if (!chainId) throw new Error("chainId is required");
    return (0, $eUiaP.switchNetwork)({
        chainId: chainId
    });
};
function $1d657eb5d64e17dc$export$71b0470720f288c1({ chainId: chainId, throwForSwitchChainNotSupported: throwForSwitchChainNotSupported, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const config = $1d657eb5d64e17dc$export$b3611e87cd5ba6ce();
    const forceUpdate = $1d657eb5d64e17dc$var$useForceUpdate();
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey5({
        chainId: chainId
    }), $1d657eb5d64e17dc$var$mutationFn5, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const switchNetwork_ = $dup7A.useCallback((chainId_)=>mutate({
            chainId: chainId_ ?? chainId
        }), [
        chainId,
        mutate
    ]);
    const switchNetworkAsync_ = $dup7A.useCallback((chainId_)=>mutateAsync({
            chainId: chainId_ ?? chainId
        }), [
        chainId,
        mutateAsync
    ]);
    $dup7A.useEffect(()=>{
        const unwatch = config.subscribe(({ chains: chains, connector: connector })=>({
                chains: chains,
                connector: connector
            }), forceUpdate);
        return unwatch;
    }, [
        config,
        forceUpdate
    ]);
    let switchNetwork2;
    let switchNetworkAsync;
    const supportsSwitchChain = !!config.connector?.switchChain;
    if (throwForSwitchChainNotSupported || supportsSwitchChain) {
        switchNetwork2 = switchNetwork_;
        switchNetworkAsync = switchNetworkAsync_;
    }
    return {
        chains: config.chains ?? [],
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        pendingChainId: variables?.chainId,
        reset: reset,
        status: status,
        switchNetwork: switchNetwork2,
        switchNetworkAsync: switchNetworkAsync,
        variables: variables
    };
}
function $1d657eb5d64e17dc$export$fa3bb2588a62576e({ address: address, chainId: chainId, abi: abi, listener: listener, eventName: eventName } = {}) {
    const publicClient = $1d657eb5d64e17dc$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $1d657eb5d64e17dc$export$724f5280724585ed({
        chainId: chainId
    });
    const unwatch = $dup7A.useRef();
    $dup7A.useEffect(()=>{
        if (!abi || !address || !eventName) return;
        const publicClient_ = webSocketPublicClient || publicClient;
        unwatch.current = publicClient_.watchContractEvent({
            abi: abi,
            address: address,
            eventName: eventName,
            onLogs: listener
        });
        return unwatch.current;
    }, [
        abi,
        address,
        eventName,
        publicClient.uid,
        webSocketPublicClient?.uid
    ]);
    return unwatch.current;
}
function $1d657eb5d64e17dc$var$queryKey5({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, cacheKey: cacheKey, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContractsInfinite",
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            cacheKey: cacheKey,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn5({ contracts: contracts }) {
    return ({ queryKey: [{ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag }], pageParam: pageParam })=>{
        return (0, $eUiaP.readContracts)({
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            contracts: contracts(pageParam || void 0)
        });
    };
}
function $1d657eb5d64e17dc$export$22c281f017fd3229({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, cacheKey: cacheKey, cacheTime: cacheTime, contracts: contracts, enabled: enabled_ = true, getNextPageParam: getNextPageParam, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $eUiaP.deepEqual)(oldData, newData) ? oldData : (0, $0dbdedbceaf62b7f$export$77a71fc411098696)(oldData, newData), suspense: suspense }) {
    const queryKey_ = $dup7A.useMemo(()=>$1d657eb5d64e17dc$var$queryKey5({
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            cacheKey: cacheKey,
            scopeKey: scopeKey
        }), [
        allowFailure,
        blockNumber,
        blockTag,
        cacheKey,
        scopeKey
    ]);
    const enabled = $dup7A.useMemo(()=>{
        const enabled2 = Boolean(enabled_ && contracts);
        return enabled2;
    }, [
        contracts,
        enabled_
    ]);
    return $1d657eb5d64e17dc$export$bdc59d3c1a6569aa(queryKey_, $1d657eb5d64e17dc$var$queryFn5({
        contracts: contracts
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        getNextPageParam: getNextPageParam,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        select: select,
        staleTime: staleTime,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$export$ea82e4a36c28628e(fn, { perPage: perPage, start: start, direction: direction }) {
    const contracts = (page = 0)=>[
            ...Array(perPage).keys()
        ].map((index)=>{
            return direction === "increment" ? start + index + page * perPage : start - index - page * perPage;
        }).filter((index)=>index >= 0).flatMap(fn);
    return {
        contracts: contracts,
        getNextPageParam (lastPage, pages) {
            return lastPage?.length === perPage ? pages.length : void 0;
        }
    };
}
function $1d657eb5d64e17dc$var$queryKey6({ account: account, address: address, args: args, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, functionName: functionName, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContract",
            account: account,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            functionName: functionName,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn6({ abi: abi }) {
    return async ({ queryKey: [{ account: account, address: address, args: args, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, functionName: functionName }] })=>{
        if (!abi) throw new Error("abi is required");
        if (!address) throw new Error("address is required");
        return await (0, $eUiaP.readContract)({
            account: account,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            abi: abi,
            functionName: functionName
        }) ?? null;
    };
}
function $1d657eb5d64e17dc$export$6f78c1774963fe2d({ abi: abi, address: address, account: account, args: args, blockNumber: blockNumberOverride, blockTag: blockTag, cacheOnBlock: cacheOnBlock = false, cacheTime: cacheTime, chainId: chainId_, enabled: enabled_ = true, functionName: functionName, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $eUiaP.deepEqual)(oldData, newData) ? oldData : (0, $0dbdedbceaf62b7f$export$77a71fc411098696)(oldData, newData), suspense: suspense, watch: watch } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const { data: blockNumber_ } = $1d657eb5d64e17dc$export$8bf0355f69442463({
        chainId: chainId,
        enabled: watch || cacheOnBlock,
        scopeKey: watch || cacheOnBlock ? void 0 : "idle",
        watch: watch
    });
    const blockNumber = blockNumberOverride ?? blockNumber_;
    const queryKey_ = $dup7A.useMemo(()=>$1d657eb5d64e17dc$var$queryKey6({
            account: account,
            address: address,
            args: args,
            blockNumber: cacheOnBlock ? blockNumber : void 0,
            blockTag: blockTag,
            chainId: chainId,
            functionName: functionName,
            scopeKey: scopeKey
        }), [
        account,
        address,
        args,
        blockNumber,
        blockTag,
        cacheOnBlock,
        chainId,
        functionName,
        scopeKey
    ]);
    const enabled = $dup7A.useMemo(()=>{
        let enabled2 = Boolean(enabled_ && abi && address && functionName);
        if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
        return enabled2;
    }, [
        abi,
        address,
        blockNumber,
        cacheOnBlock,
        enabled_,
        functionName
    ]);
    $1d657eb5d64e17dc$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch && !cacheOnBlock),
        queryKey: queryKey_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd(queryKey_, $1d657eb5d64e17dc$var$queryFn6({
        abi: abi
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        select: select,
        staleTime: staleTime,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey7({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, contracts: contracts, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContracts",
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            scopeKey: scopeKey,
            contracts: (contracts ?? []).map(({ address: address, args: args, chainId: chainId2, functionName: functionName })=>({
                    address: address,
                    args: args,
                    chainId: chainId2,
                    functionName: functionName
                }))
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn7({ abis: abis }) {
    return ({ queryKey: [{ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, contracts: contracts_ }] })=>{
        const contracts = contracts_.map((contract, i)=>({
                ...contract,
                abi: abis[i]
            }));
        return (0, $eUiaP.readContracts)({
            allowFailure: allowFailure,
            contracts: contracts,
            blockNumber: blockNumber,
            blockTag: blockTag
        });
    };
}
function $1d657eb5d64e17dc$export$f36bb0f54b7a8d18({ allowFailure: allowFailure_, blockNumber: blockNumberOverride, blockTag: blockTag, cacheOnBlock: cacheOnBlock = false, cacheTime: cacheTime, contracts: contracts, enabled: enabled_ = true, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $eUiaP.deepEqual)(oldData, newData) ? oldData : (0, $0dbdedbceaf62b7f$export$77a71fc411098696)(oldData, newData), suspense: suspense, watch: watch } = {}) {
    const allowFailure = allowFailure_ ?? true;
    const { data: blockNumber_ } = $1d657eb5d64e17dc$export$8bf0355f69442463({
        enabled: watch || cacheOnBlock,
        watch: watch
    });
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d();
    const blockNumber = blockNumberOverride ?? blockNumber_;
    const queryKey_ = $dup7A.useMemo(()=>$1d657eb5d64e17dc$var$queryKey7({
            allowFailure: allowFailure,
            blockNumber: cacheOnBlock ? blockNumber : void 0,
            blockTag: blockTag,
            chainId: chainId,
            contracts: contracts,
            scopeKey: scopeKey
        }), [
        allowFailure,
        blockNumber,
        blockTag,
        cacheOnBlock,
        chainId,
        scopeKey,
        contracts
    ]);
    const enabled = $dup7A.useMemo(()=>{
        let enabled2 = Boolean(enabled_ && contracts?.every((x)=>x.abi && x.address && x.functionName));
        if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
        return enabled2;
    }, [
        blockNumber,
        cacheOnBlock,
        contracts,
        enabled_
    ]);
    $1d657eb5d64e17dc$var$useInvalidateOnBlock({
        enabled: Boolean(enabled && watch && !cacheOnBlock),
        queryKey: queryKey_
    });
    const abis = (contracts ?? []).map(({ abi: abi })=>abi);
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd(queryKey_, $1d657eb5d64e17dc$var$queryFn7({
        abis: abis
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        staleTime: staleTime,
        select: select,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$mutationKey6({ address: address, abi: abi, functionName: functionName, ...config }) {
    const { args: args, accessList: accessList, account: account, dataSuffix: dataSuffix, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, request: request, value: value } = config;
    return [
        {
            entity: "writeContract",
            address: address,
            args: args,
            abi: abi,
            accessList: accessList,
            account: account,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            request: request,
            value: value
        }
    ];
}
function $1d657eb5d64e17dc$var$mutationFn6(config) {
    if (config.mode === "prepared") {
        if (!config.request) throw new Error("request is required");
        return (0, $eUiaP.writeContract)({
            mode: "prepared",
            request: config.request
        });
    }
    if (!config.address) throw new Error("address is required");
    if (!config.abi) throw new Error("abi is required");
    if (!config.functionName) throw new Error("functionName is required");
    return (0, $eUiaP.writeContract)({
        address: config.address,
        args: config.args,
        chainId: config.chainId,
        abi: config.abi,
        functionName: config.functionName,
        accessList: config.accessList,
        account: config.account,
        dataSuffix: config.dataSuffix,
        gas: config.gas,
        gasPrice: config.gasPrice,
        maxFeePerGas: config.maxFeePerGas,
        maxPriorityFeePerGas: config.maxPriorityFeePerGas,
        nonce: config.nonce,
        value: config.value
    });
}
function $1d657eb5d64e17dc$export$f65fbf805a7dc8c5(config) {
    const { address: address, abi: abi, args: args, chainId: chainId, functionName: functionName, mode: mode, request: request, dataSuffix: dataSuffix } = config;
    const { accessList: accessList, account: account, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value } = (0, $eUiaP.getSendTransactionParameters)(config);
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey6({
        address: address,
        abi: abi,
        functionName: functionName,
        chainId: chainId,
        mode: mode,
        args: args,
        accessList: accessList,
        account: account,
        dataSuffix: dataSuffix,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        request: request,
        value: value
    }), $1d657eb5d64e17dc$var$mutationFn6, {
        onError: config.onError,
        onMutate: config.onMutate,
        onSettled: config.onSettled,
        onSuccess: config.onSuccess
    });
    const write = $dup7A.useMemo(()=>{
        if (config.mode === "prepared") {
            if (!request) return void 0;
            return ()=>mutate({
                    mode: "prepared",
                    request: config.request,
                    chainId: config.chainId
                });
        }
        return (overrideConfig)=>mutate({
                address: address,
                args: args,
                abi: abi,
                functionName: functionName,
                chainId: chainId,
                accessList: accessList,
                account: account,
                dataSuffix: dataSuffix,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                value: value,
                ...overrideConfig
            });
    }, [
        accessList,
        account,
        abi,
        address,
        args,
        chainId,
        config.chainId,
        config.mode,
        config.request,
        dataSuffix,
        functionName,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mutate,
        nonce,
        request,
        value
    ]);
    const writeAsync = $dup7A.useMemo(()=>{
        if (config.mode === "prepared") {
            if (!request) return void 0;
            return ()=>mutateAsync({
                    mode: "prepared",
                    request: config.request
                });
        }
        return (overrideConfig)=>mutateAsync({
                address: address,
                args: args,
                abi: abi,
                chainId: chainId,
                functionName: functionName,
                accessList: accessList,
                account: account,
                dataSuffix: dataSuffix,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                value: value,
                ...overrideConfig
            });
    }, [
        accessList,
        account,
        abi,
        address,
        args,
        chainId,
        config.mode,
        config.request,
        dataSuffix,
        functionName,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mutateAsync,
        nonce,
        request,
        value
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        status: status,
        variables: variables,
        write: write,
        writeAsync: writeAsync
    };
}
function $1d657eb5d64e17dc$var$queryKey8({ accessList: accessList, account: account, activeChainId: activeChainId, args: args, address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, dataSuffix: dataSuffix, functionName: functionName, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, scopeKey: scopeKey, walletClientAddress: walletClientAddress, value: value }) {
    return [
        {
            entity: "prepareContractTransaction",
            accessList: accessList,
            account: account,
            activeChainId: activeChainId,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            scopeKey: scopeKey,
            walletClientAddress: walletClientAddress,
            value: value
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn8({ abi: abi, walletClient: walletClient }) {
    return ({ queryKey: [{ accessList: accessList, account: account, args: args, address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, dataSuffix: dataSuffix, functionName: functionName, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value }] })=>{
        if (!abi) throw new Error("abi is required");
        if (!address) throw new Error("address is required");
        if (!functionName) throw new Error("functionName is required");
        return (0, $eUiaP.prepareWriteContract)({
            abi: abi,
            accessList: accessList,
            account: account,
            args: args,
            address: address,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            walletClient: walletClient,
            value: value
        });
    };
}
function $1d657eb5d64e17dc$export$f08fad0d21112083({ address: address, abi: abi, functionName: functionName, chainId: chainId, args: args, cacheTime: cacheTime, dataSuffix: dataSuffix, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess, ...config } = {}) {
    const { chain: activeChain } = $1d657eb5d64e17dc$export$553aaf59afc1a2d8();
    const { data: walletClient } = $1d657eb5d64e17dc$export$742c698ad1033029({
        chainId: chainId
    });
    const { accessList: accessList, account: account, blockNumber: blockNumber, blockTag: blockTag, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value } = (0, $eUiaP.getCallParameters)(config);
    const prepareContractWriteQuery = $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey8({
        accessList: accessList,
        account: account,
        activeChainId: activeChain?.id,
        address: address,
        args: args,
        blockNumber: blockNumber,
        blockTag: blockTag,
        chainId: chainId,
        dataSuffix: dataSuffix,
        functionName: functionName,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        scopeKey: scopeKey,
        walletClientAddress: walletClient?.account.address,
        value: value
    }), $1d657eb5d64e17dc$var$queryFn8({
        abi: abi,
        walletClient: walletClient
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && abi && address && functionName && walletClient),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    return Object.assign(prepareContractWriteQuery, {
        config: {
            chainId: chainId,
            mode: "prepared",
            request: void 0,
            ...prepareContractWriteQuery.data
        }
    });
}
function $1d657eb5d64e17dc$var$queryKey9({ address: address, chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey }) {
    return [
        {
            entity: "token",
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn9({ queryKey: [{ address: address, chainId: chainId, formatUnits: formatUnits }] }) {
    if (!address) throw new Error("address is required");
    return (0, $eUiaP.fetchToken)({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits
    });
}
function $1d657eb5d64e17dc$export$31dcd79391e423fe({ address: address, chainId: chainId_, formatUnits: formatUnits = "ether", cacheTime: cacheTime, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey9({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn9, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey10({ chainId: chainId, name: name, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensAddress",
            chainId: chainId,
            name: name,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn10({ queryKey: [{ chainId: chainId, name: name }] }) {
    if (!name) throw new Error("name is required");
    return (0, $eUiaP.fetchEnsAddress)({
        chainId: chainId,
        name: name
    });
}
function $1d657eb5d64e17dc$export$882e13b9ff368f82({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, name: name, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey10({
        chainId: chainId,
        name: name,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn10, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && chainId && name),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey11({ name: name, chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensAvatar",
            name: name,
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn11({ queryKey: [{ name: name, chainId: chainId }] }) {
    if (!name) throw new Error("name is required");
    return (0, $eUiaP.fetchEnsAvatar)({
        name: name,
        chainId: chainId
    });
}
function $1d657eb5d64e17dc$export$182f359dd9766fbb({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, name: name, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey11({
        name: name,
        chainId: chainId,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn11, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && name && chainId),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey12({ address: address, chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensName",
            address: address,
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn12({ queryKey: [{ address: address, chainId: chainId }] }) {
    if (!address) throw new Error("address is required");
    return (0, $eUiaP.fetchEnsName)({
        address: address,
        chainId: chainId
    });
}
function $1d657eb5d64e17dc$export$e7302f55b2684d23({ address: address, cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey12({
        address: address,
        chainId: chainId,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn12, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address && chainId),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey13({ chainId: chainId, name: name, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensResolver",
            chainId: chainId,
            name: name,
            scopeKey: scopeKey,
            persist: false
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn13({ queryKey: [{ chainId: chainId, name: name }] }) {
    if (!name) throw new Error("name is required");
    return (0, $eUiaP.fetchEnsResolver)({
        chainId: chainId,
        name: name
    });
}
function $1d657eb5d64e17dc$export$659f7b1a330aed84({ chainId: chainId_, name: name, enabled: enabled = true, scopeKey: scopeKey, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey13({
        chainId: chainId,
        name: name,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn13, {
        cacheTime: 0,
        enabled: Boolean(enabled && chainId && name),
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey14({ accessList: accessList, account: account, activeChainId: activeChainId, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, scopeKey: scopeKey, walletClientAddress: walletClientAddress }) {
    return [
        {
            entity: "prepareSendTransaction",
            activeChainId: activeChainId,
            accessList: accessList,
            account: account,
            chainId: chainId,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value,
            scopeKey: scopeKey,
            walletClientAddress: walletClientAddress
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn14({ walletClient: walletClient }) {
    return ({ queryKey: [{ accessList: accessList, account: account, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }] })=>{
        if (!to) throw new Error("to is required");
        return (0, $eUiaP.prepareSendTransaction)({
            accessList: accessList,
            account: account,
            chainId: chainId,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value,
            walletClient: walletClient
        });
    };
}
function $1d657eb5d64e17dc$export$f8ca5822352fabc7({ accessList: accessList, account: account, chainId: chainId, cacheTime: cacheTime, data: data, enabled: enabled = true, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, to: to, value: value, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { chain: activeChain } = $1d657eb5d64e17dc$export$553aaf59afc1a2d8();
    const { data: walletClient } = $1d657eb5d64e17dc$export$742c698ad1033029({
        chainId: chainId
    });
    const prepareSendTransactionQuery = $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey14({
        accessList: accessList,
        activeChainId: activeChain?.id,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        scopeKey: scopeKey,
        to: to,
        value: value,
        walletClientAddress: walletClient?.account.address
    }), $1d657eb5d64e17dc$var$queryFn14({
        walletClient: walletClient
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && walletClient && to),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    return Object.assign(prepareSendTransactionQuery, {
        config: {
            mode: "prepared",
            ...prepareSendTransactionQuery.isSuccess ? prepareSendTransactionQuery.data : void 0
        }
    });
}
var $1d657eb5d64e17dc$var$mutationKey7 = (args)=>[
        {
            entity: "sendTransaction",
            ...args
        }
    ];
var $1d657eb5d64e17dc$var$mutationFn7 = ({ accessList: accessList, account: account, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, mode: mode, nonce: nonce, to: to, value: value })=>{
    if (!to) throw new Error("to is required.");
    return (0, $eUiaP.sendTransaction)({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: mode,
        nonce: nonce,
        to: to,
        value: value
    });
};
function $1d657eb5d64e17dc$export$c4f10d35244ef225({ accessList: accessList, account: account, chainId: chainId, data: data_, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, mode: mode, nonce: nonce, to: to, value: value, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $1d657eb5d64e17dc$export$609860bf8b0084c($1d657eb5d64e17dc$var$mutationKey7({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data_,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: mode,
        nonce: nonce,
        to: to,
        value: value
    }), $1d657eb5d64e17dc$var$mutationFn7, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const sendTransaction2 = $dup7A.useCallback((args)=>mutate({
            chainId: chainId,
            mode: mode,
            ...args || {
                accessList: accessList,
                account: account,
                chainId: chainId,
                data: data_,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                mode: mode,
                nonce: nonce,
                value: value,
                to: to
            }
        }), [
        accessList,
        account,
        chainId,
        data_,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mode,
        mutate,
        nonce,
        to,
        value
    ]);
    const sendTransactionAsync = $dup7A.useCallback((args)=>mutateAsync({
            chainId: chainId,
            mode: mode,
            ...args || {
                accessList: accessList,
                account: account,
                chainId: chainId,
                data: data_,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                mode: mode,
                nonce: nonce,
                value: value,
                to: to
            }
        }), [
        accessList,
        account,
        chainId,
        data_,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mode,
        mutateAsync,
        nonce,
        to,
        value
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        sendTransaction: mode === "prepared" && !to ? void 0 : sendTransaction2,
        sendTransactionAsync: mode === "prepared" && !to ? void 0 : sendTransactionAsync,
        status: status,
        variables: variables
    };
}
function $1d657eb5d64e17dc$var$queryKey15({ chainId: chainId, hash: hash, scopeKey: scopeKey }) {
    return [
        {
            entity: "transaction",
            chainId: chainId,
            hash: hash,
            scopeKey: scopeKey
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn15({ queryKey: [{ chainId: chainId, hash: hash }] }) {
    if (!hash) throw new Error("hash is required");
    return (0, $eUiaP.fetchTransaction)({
        chainId: chainId,
        hash: hash
    });
}
function $1d657eb5d64e17dc$export$244eac3470cf24ad({ cacheTime: cacheTime = 0, chainId: chainId_, enabled: enabled = true, hash: hash, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey15({
        chainId: chainId,
        hash: hash,
        scopeKey: scopeKey
    }), $1d657eb5d64e17dc$var$queryFn15, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && hash),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$var$queryKey16({ confirmations: confirmations, chainId: chainId, hash: hash, scopeKey: scopeKey, timeout: timeout }) {
    return [
        {
            entity: "waitForTransaction",
            confirmations: confirmations,
            chainId: chainId,
            hash: hash,
            scopeKey: scopeKey,
            timeout: timeout
        }
    ];
}
function $1d657eb5d64e17dc$var$queryFn16({ onReplaced: onReplaced }) {
    return ({ queryKey: [{ chainId: chainId, confirmations: confirmations, hash: hash, timeout: timeout }] })=>{
        if (!hash) throw new Error("hash is required");
        return (0, $eUiaP.waitForTransaction)({
            chainId: chainId,
            confirmations: confirmations,
            hash: hash,
            onReplaced: onReplaced,
            timeout: timeout
        });
    };
}
function $1d657eb5d64e17dc$export$421837b4be863851({ chainId: chainId_, confirmations: confirmations, hash: hash, timeout: timeout, cacheTime: cacheTime, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onReplaced: onReplaced, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $1d657eb5d64e17dc$export$dd0a697e1782aedd($1d657eb5d64e17dc$var$queryKey16({
        chainId: chainId,
        confirmations: confirmations,
        hash: hash,
        scopeKey: scopeKey,
        timeout: timeout
    }), $1d657eb5d64e17dc$var$queryFn16({
        onReplaced: onReplaced
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && hash),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $1d657eb5d64e17dc$export$1225b17756115209({ chainId: chainId_, enabled: enabled = true, listener: listener }) {
    const chainId = $1d657eb5d64e17dc$export$dc276622421ed31d({
        chainId: chainId_
    });
    const publicClient = $1d657eb5d64e17dc$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $1d657eb5d64e17dc$export$724f5280724585ed({
        chainId: chainId
    });
    $dup7A.useEffect(()=>{
        if (!enabled) return;
        const publicClient_ = webSocketPublicClient ?? publicClient;
        return publicClient_.watchPendingTransactions({
            onTransactions: listener
        });
    }, [
        enabled,
        listener,
        publicClient,
        webSocketPublicClient
    ]);
}


const $eb4899630ce86774$var$useRefetchOnBlock = ()=>{
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)();
    const publicClient = (0, $1d657eb5d64e17dc$export$724f5280724585ed)();
    (0, $dup7A.useEffect)(()=>{
        const unwatch = publicClient?.watchBlocks({
            onBlock: (block)=>{
                if (block.number % BigInt(10) === BigInt(0)) queryClient.invalidateQueries([
                    "refetchOnBlock"
                ]);
            }
        });
        return ()=>unwatch?.();
    }, [
        publicClient,
        queryClient
    ]);
};
const $eb4899630ce86774$var$RefetchOnBlock = ()=>{
    $eb4899630ce86774$var$useRefetchOnBlock();
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {});
};
var $eb4899630ce86774$export$2e2bcd8739ae039 = $eb4899630ce86774$var$RefetchOnBlock;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
var $e9f8389e4f70b5af$exports = {};

$parcel$defineInteropFlag($e9f8389e4f70b5af$exports);

$parcel$export($e9f8389e4f70b5af$exports, "isStyledComponent", () => $e9f8389e4f70b5af$export$7ba318d8d2f06c76);
$parcel$export($e9f8389e4f70b5af$exports, "version", () => $e9f8389e4f70b5af$export$83d89fbfd8236492);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetContext", () => $e9f8389e4f70b5af$export$8c190ef828af4c86);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetConsumer", () => $e9f8389e4f70b5af$export$91317688fc694efa);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetManager", () => $e9f8389e4f70b5af$export$a473771da2f0ff7c);
$parcel$export($e9f8389e4f70b5af$exports, "css", () => $e9f8389e4f70b5af$export$dbf350e5966cf602);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeContext", () => $e9f8389e4f70b5af$export$2c657da244d00bd6);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeConsumer", () => $e9f8389e4f70b5af$export$b631efc24e9d5e2f);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeProvider", () => $e9f8389e4f70b5af$export$d8964aec282183a3);
$parcel$export($e9f8389e4f70b5af$exports, "createGlobalStyle", () => $e9f8389e4f70b5af$export$f0f03736edb61697);
$parcel$export($e9f8389e4f70b5af$exports, "keyframes", () => $e9f8389e4f70b5af$export$d25ddfdf17c3ad3e);
$parcel$export($e9f8389e4f70b5af$exports, "ServerStyleSheet", () => $e9f8389e4f70b5af$export$ae8c7d15c8b89a20);
$parcel$export($e9f8389e4f70b5af$exports, "withTheme", () => $e9f8389e4f70b5af$export$e8748c6a27b910dc);
$parcel$export($e9f8389e4f70b5af$exports, "useTheme", () => $e9f8389e4f70b5af$export$93d4e7f90805808f);
$parcel$export($e9f8389e4f70b5af$exports, "__PRIVATE__", () => $e9f8389e4f70b5af$export$5c87cfe6c475f500);
$parcel$export($e9f8389e4f70b5af$exports, "default", () => $e9f8389e4f70b5af$export$2e2bcd8739ae039);

var $8vAu6 = parcelRequire("8vAu6");

var $dup7A = parcelRequire("dup7A");
var $0a4832c5d1c5a3de$exports = {};
//
$0a4832c5d1c5a3de$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $aabbad6795e7f5aa$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $aabbad6795e7f5aa$export$2e2bcd8739ae039 = $aabbad6795e7f5aa$var$stylis_min;


var $49fcc9fac921cd3d$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $49fcc9fac921cd3d$export$2e2bcd8739ae039 = $49fcc9fac921cd3d$var$unitlessKeys;



var $24khb = parcelRequire("24khb");

var $5gHVI = parcelRequire("5gHVI");

var $gbdt3 = parcelRequire("gbdt3");
function $e9f8389e4f70b5af$var$y() {
    return ($e9f8389e4f70b5af$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $e9f8389e4f70b5af$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $e9f8389e4f70b5af$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $8vAu6.typeOf)(t);
}, $e9f8389e4f70b5af$var$S = Object.freeze([]), $e9f8389e4f70b5af$var$w = Object.freeze({});
function $e9f8389e4f70b5af$var$E(e) {
    return "function" == typeof e;
}
function $e9f8389e4f70b5af$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e9f8389e4f70b5af$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $e9f8389e4f70b5af$var$N = ("undefined" != typeof $gbdt3 && void 0 !== $gbdt3.env && undefined, "data-styled"), $e9f8389e4f70b5af$export$83d89fbfd8236492 = "5.3.11", $e9f8389e4f70b5af$var$C = "undefined" != typeof window && "HTMLElement" in window, $e9f8389e4f70b5af$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $gbdt3 && void 0 !== $gbdt3.env && false), $e9f8389e4f70b5af$var$P = {}, $e9f8389e4f70b5af$var$O = {};
function $e9f8389e4f70b5af$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $e9f8389e4f70b5af$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $e9f8389e4f70b5af$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $e9f8389e4f70b5af$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $e9f8389e4f70b5af$var$T = new Map, $e9f8389e4f70b5af$var$x = new Map, $e9f8389e4f70b5af$var$k = 1, $e9f8389e4f70b5af$var$V = function(e) {
    if ($e9f8389e4f70b5af$var$T.has(e)) return $e9f8389e4f70b5af$var$T.get(e);
    for(; $e9f8389e4f70b5af$var$x.has($e9f8389e4f70b5af$var$k);)$e9f8389e4f70b5af$var$k++;
    var t = $e9f8389e4f70b5af$var$k++;
    return $e9f8389e4f70b5af$var$T.set(e, t), $e9f8389e4f70b5af$var$x.set(t, e), t;
}, $e9f8389e4f70b5af$var$B = function(e) {
    return $e9f8389e4f70b5af$var$x.get(e);
}, $e9f8389e4f70b5af$var$z = function(e, t) {
    t >= $e9f8389e4f70b5af$var$k && ($e9f8389e4f70b5af$var$k = t + 1), $e9f8389e4f70b5af$var$T.set(e, t), $e9f8389e4f70b5af$var$x.set(t, e);
}, $e9f8389e4f70b5af$var$M = "style[" + $e9f8389e4f70b5af$var$N + '][data-styled-version="5.3.11"]', $e9f8389e4f70b5af$var$G = new RegExp("^" + $e9f8389e4f70b5af$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $e9f8389e4f70b5af$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $e9f8389e4f70b5af$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($e9f8389e4f70b5af$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($e9f8389e4f70b5af$var$z(u, c), $e9f8389e4f70b5af$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $e9f8389e4f70b5af$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $e9f8389e4f70b5af$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($e9f8389e4f70b5af$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($e9f8389e4f70b5af$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $e9f8389e4f70b5af$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $e9f8389e4f70b5af$var$H = function() {
    function e(e) {
        var t = this.element = $e9f8389e4f70b5af$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $e9f8389e4f70b5af$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $e9f8389e4f70b5af$var$$ = function() {
    function e(e) {
        var t = this.element = $e9f8389e4f70b5af$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e9f8389e4f70b5af$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e9f8389e4f70b5af$var$U = $e9f8389e4f70b5af$var$C, $e9f8389e4f70b5af$var$J = {
    isServer: !$e9f8389e4f70b5af$var$C,
    useCSSOMInjection: !$e9f8389e4f70b5af$var$I
}, $e9f8389e4f70b5af$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $e9f8389e4f70b5af$var$w), void 0 === t && (t = {}), this.options = $e9f8389e4f70b5af$var$y({}, $e9f8389e4f70b5af$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $e9f8389e4f70b5af$var$C && $e9f8389e4f70b5af$var$U && ($e9f8389e4f70b5af$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($e9f8389e4f70b5af$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($e9f8389e4f70b5af$var$N) && ($e9f8389e4f70b5af$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $e9f8389e4f70b5af$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($e9f8389e4f70b5af$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $e9f8389e4f70b5af$var$W(o) : r ? new $e9f8389e4f70b5af$var$H(o) : new $e9f8389e4f70b5af$var$$(o), new $e9f8389e4f70b5af$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($e9f8389e4f70b5af$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e9f8389e4f70b5af$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($e9f8389e4f70b5af$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $e9f8389e4f70b5af$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $e9f8389e4f70b5af$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $e9f8389e4f70b5af$var$Z = /(a)(d)/gi, $e9f8389e4f70b5af$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e9f8389e4f70b5af$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $e9f8389e4f70b5af$var$K(t % 52) + n;
    return ($e9f8389e4f70b5af$var$K(t % 52) + n).replace($e9f8389e4f70b5af$var$Z, "$1-$2");
}
var $e9f8389e4f70b5af$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e9f8389e4f70b5af$var$te = function(e) {
    return $e9f8389e4f70b5af$var$ee(5381, e);
};
function $e9f8389e4f70b5af$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e9f8389e4f70b5af$var$E(n) && !$e9f8389e4f70b5af$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e9f8389e4f70b5af$var$re = $e9f8389e4f70b5af$var$te("5.3.11"), $e9f8389e4f70b5af$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e9f8389e4f70b5af$var$ne(e), this.componentId = t, this.baseHash = $e9f8389e4f70b5af$var$ee($e9f8389e4f70b5af$var$re, t), this.baseStyle = n, $e9f8389e4f70b5af$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $e9f8389e4f70b5af$var$_e(this.rules, e, t, n).join(""), i = $e9f8389e4f70b5af$var$Q($e9f8389e4f70b5af$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $e9f8389e4f70b5af$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $e9f8389e4f70b5af$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $e9f8389e4f70b5af$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $e9f8389e4f70b5af$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $e9f8389e4f70b5af$var$se = /^\s*\/\/.*$/gm, $e9f8389e4f70b5af$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $e9f8389e4f70b5af$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $e9f8389e4f70b5af$var$w : e, i = s.options, a = void 0 === i ? $e9f8389e4f70b5af$var$w : i, c = s.plugins, u = void 0 === c ? $e9f8389e4f70b5af$var$S : c, l = new (0, $aabbad6795e7f5aa$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $e9f8389e4f70b5af$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($e9f8389e4f70b5af$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $e9f8389e4f70b5af$var$D(15), $e9f8389e4f70b5af$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $e9f8389e4f70b5af$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$export$91317688fc694efa = $e9f8389e4f70b5af$export$8c190ef828af4c86.Consumer, $e9f8389e4f70b5af$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$var$de = ($e9f8389e4f70b5af$var$le.Consumer, new $e9f8389e4f70b5af$var$X), $e9f8389e4f70b5af$var$he = $e9f8389e4f70b5af$var$ae();
function $e9f8389e4f70b5af$var$pe() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$export$8c190ef828af4c86) || $e9f8389e4f70b5af$var$de;
}
function $e9f8389e4f70b5af$var$fe() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$var$le) || $e9f8389e4f70b5af$var$he;
}
function $e9f8389e4f70b5af$export$a473771da2f0ff7c(e) {
    var t = (0, $dup7A.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $e9f8389e4f70b5af$var$pe(), u = (0, $dup7A.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $dup7A.useMemo)(function() {
        return $e9f8389e4f70b5af$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $dup7A.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($0a4832c5d1c5a3de$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $e9f8389e4f70b5af$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e9f8389e4f70b5af$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $e9f8389e4f70b5af$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e9f8389e4f70b5af$var$he), this.name + e.hash;
    }, e;
}(), $e9f8389e4f70b5af$var$ve = /([A-Z])/, $e9f8389e4f70b5af$var$ge = /([A-Z])/g, $e9f8389e4f70b5af$var$Se = /^ms-/, $e9f8389e4f70b5af$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $e9f8389e4f70b5af$var$Ee(e) {
    return $e9f8389e4f70b5af$var$ve.test(e) ? e.replace($e9f8389e4f70b5af$var$ge, $e9f8389e4f70b5af$var$we).replace($e9f8389e4f70b5af$var$Se, "-ms-") : e;
}
var $e9f8389e4f70b5af$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $e9f8389e4f70b5af$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $e9f8389e4f70b5af$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($e9f8389e4f70b5af$var$be(e)) return "";
    if ($e9f8389e4f70b5af$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($e9f8389e4f70b5af$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $e9f8389e4f70b5af$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $e9f8389e4f70b5af$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $e9f8389e4f70b5af$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$e9f8389e4f70b5af$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $e9f8389e4f70b5af$var$E(t[i]) ? s.push($e9f8389e4f70b5af$var$Ee(i) + ":", t[i], ";") : $e9f8389e4f70b5af$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($e9f8389e4f70b5af$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $49fcc9fac921cd3d$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $e9f8389e4f70b5af$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $e9f8389e4f70b5af$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $e9f8389e4f70b5af$var$E(e) || $e9f8389e4f70b5af$var$g(e) ? $e9f8389e4f70b5af$var$Ne($e9f8389e4f70b5af$var$_e($e9f8389e4f70b5af$var$v($e9f8389e4f70b5af$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $e9f8389e4f70b5af$var$Ne($e9f8389e4f70b5af$var$_e($e9f8389e4f70b5af$var$v(e, n)));
}
var $e9f8389e4f70b5af$var$Ce = /invalid hook call/i, $e9f8389e4f70b5af$var$Ie = new Set, $e9f8389e4f70b5af$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $e9f8389e4f70b5af$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $e9f8389e4f70b5af$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $e9f8389e4f70b5af$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e9f8389e4f70b5af$var$De = /(^-|-$)/g;
function $e9f8389e4f70b5af$var$je(e) {
    return e.replace($e9f8389e4f70b5af$var$Re, "-").replace($e9f8389e4f70b5af$var$De, "");
}
var $e9f8389e4f70b5af$var$Te = function(e) {
    return $e9f8389e4f70b5af$var$Q($e9f8389e4f70b5af$var$te(e) >>> 0);
};
function $e9f8389e4f70b5af$var$xe(e) {
    return "string" == typeof e && true;
}
var $e9f8389e4f70b5af$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $e9f8389e4f70b5af$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $e9f8389e4f70b5af$var$Be(e, t, n) {
    var r = e[n];
    $e9f8389e4f70b5af$var$ke(t) && $e9f8389e4f70b5af$var$ke(r) ? $e9f8389e4f70b5af$var$ze(r, t) : e[n] = t;
}
function $e9f8389e4f70b5af$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($e9f8389e4f70b5af$var$ke(i)) for(var a in i)$e9f8389e4f70b5af$var$Ve(a) && $e9f8389e4f70b5af$var$Be(e, i[a], a);
    }
    return e;
}
var $e9f8389e4f70b5af$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$export$b631efc24e9d5e2f = $e9f8389e4f70b5af$export$2c657da244d00bd6.Consumer;
function $e9f8389e4f70b5af$export$d8964aec282183a3(e) {
    var t = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), n = (0, $dup7A.useMemo)(function() {
        return function(e, t) {
            if (!e) return $e9f8389e4f70b5af$var$D(14);
            if ($e9f8389e4f70b5af$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $e9f8389e4f70b5af$var$D(8) : t ? $e9f8389e4f70b5af$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $e9f8389e4f70b5af$var$Fe = {};
function $e9f8389e4f70b5af$var$Ye(e, t, n) {
    var o = $e9f8389e4f70b5af$export$7ba318d8d2f06c76(e), i = !$e9f8389e4f70b5af$var$xe(e), a = t.attrs, c = void 0 === a ? $e9f8389e4f70b5af$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e9f8389e4f70b5af$var$je(e);
        $e9f8389e4f70b5af$var$Fe[n] = ($e9f8389e4f70b5af$var$Fe[n] || 0) + 1;
        var r = n + "-" + $e9f8389e4f70b5af$var$Te("5.3.11" + n + $e9f8389e4f70b5af$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $e9f8389e4f70b5af$var$xe(e) ? "styled." + e : "Styled(" + $e9f8389e4f70b5af$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $e9f8389e4f70b5af$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $e9f8389e4f70b5af$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $e9f8389e4f70b5af$var$w);
                var r = $e9f8389e4f70b5af$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $e9f8389e4f70b5af$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($e9f8389e4f70b5af$var$Oe(t, (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), a) || $e9f8389e4f70b5af$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $e9f8389e4f70b5af$var$pe(), s = $e9f8389e4f70b5af$var$fe(), i = t ? e.generateAndInjectStyles($e9f8389e4f70b5af$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $e9f8389e4f70b5af$var$xe(b), N = v !== t ? $e9f8389e4f70b5af$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $24khb.default), b) : !_ || (0, $24khb.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $e9f8389e4f70b5af$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $dup7A.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $e9f8389e4f70b5af$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($e9f8389e4f70b5af$var$xe(e) ? e : $e9f8389e4f70b5af$var$je($e9f8389e4f70b5af$var$b(e)));
        return $e9f8389e4f70b5af$var$Ye(e, $e9f8389e4f70b5af$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $e9f8389e4f70b5af$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($5gHVI)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $e9f8389e4f70b5af$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $e9f8389e4f70b5af$var$w), !(0, $8vAu6.isValidElementType)(r)) return $e9f8389e4f70b5af$var$D(1, String(r));
        var s = function() {
            return t(r, o, $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $e9f8389e4f70b5af$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $e9f8389e4f70b5af$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($e9f8389e4f70b5af$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $e9f8389e4f70b5af$var$qe[e] = $e9f8389e4f70b5af$var$qe(e);
});
var $e9f8389e4f70b5af$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e9f8389e4f70b5af$var$ne(e), $e9f8389e4f70b5af$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($e9f8389e4f70b5af$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $e9f8389e4f70b5af$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $e9f8389e4f70b5af$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $e9f8389e4f70b5af$var$Te(JSON.stringify(i)), u = new $e9f8389e4f70b5af$var$He(i, a);
    function d(e) {
        var t = $e9f8389e4f70b5af$var$pe(), n = $e9f8389e4f70b5af$var$fe(), o = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), d = (0, $dup7A.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $dup7A.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $e9f8389e4f70b5af$var$P, n, o);
        else {
            var s = $e9f8389e4f70b5af$var$y({}, t, {
                theme: $e9f8389e4f70b5af$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).memo(d);
}
function $e9f8389e4f70b5af$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $e9f8389e4f70b5af$var$Te(o);
    return new $e9f8389e4f70b5af$var$ye(s, o);
}
var $e9f8389e4f70b5af$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e9f8389e4f70b5af$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $e9f8389e4f70b5af$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $e9f8389e4f70b5af$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $e9f8389e4f70b5af$var$D(2);
            var n = ((t = {})[$e9f8389e4f70b5af$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $e9f8389e4f70b5af$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("style", $e9f8389e4f70b5af$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e9f8389e4f70b5af$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $e9f8389e4f70b5af$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $e9f8389e4f70b5af$var$D(3);
    }, e;
}(), $e9f8389e4f70b5af$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(function(t, n) {
        var o = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), i = e.defaultProps, a = $e9f8389e4f70b5af$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(e, $e9f8389e4f70b5af$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5gHVI)))(t, e), t.displayName = "WithTheme(" + $e9f8389e4f70b5af$var$b(e) + ")", t;
}, $e9f8389e4f70b5af$export$93d4e7f90805808f = function() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6);
}, $e9f8389e4f70b5af$export$5c87cfe6c475f500 = {
    StyleSheet: $e9f8389e4f70b5af$var$X,
    masterSheet: $e9f8389e4f70b5af$var$de
};
var $e9f8389e4f70b5af$export$2e2bcd8739ae039 = $e9f8389e4f70b5af$var$qe;




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");
const $56d2a25ae1caf5b4$var$Context = /*#__PURE__*/ (0, $dup7A.createContext)([
    "light",
    ()=>{
    // default empty-function
    }
]);
const $56d2a25ae1caf5b4$export$d3df7f168cf26f4 = ({ theme: theme, toggleTheme: toggleTheme, children: children })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($56d2a25ae1caf5b4$var$Context.Provider, {
        value: [
            theme,
            toggleTheme
        ],
        children: children
    });
};
const $56d2a25ae1caf5b4$export$c07acc0415d9f757 = ()=>{
    return (0, $dup7A.useContext)($56d2a25ae1caf5b4$var$Context);
};



const $b9c5312a558f850a$export$f05794e648629f6c = (0, $e9f8389e4f70b5af$export$f0f03736edb61697)`
  :root {
    --toastify-color-info: ${({ theme: theme })=>theme.primaryBlue};
    --toastify-color-success: ${({ theme: theme })=>theme.success};
    --toastify-color-warning: ${({ theme: theme })=>theme.warning};
    --toastify-color-error: ${({ theme: theme })=>theme.error};
  }

  .react-loading-skeleton {
    z-index: 0;
    --base-color: ${({ theme: theme })=>theme.skeletonBackground};
    --highlight-color: ${({ theme: theme })=>theme.skeletonHighlight};
  }

  body {
    font-family: "Open Sans", sans-serif;
    margin: 0px;
  }

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  *:focus {
    outline: none;
  }

  .ReactModal__Overlay {
    background-color: #1b003fcc !important;
  }

  h1 {
    margin: 0 0 16px 0;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  h2 {
    margin: 0 0 16px 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  h3 {
    margin: 0 0 16px 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  textarea {
    font-family: "Open Sans";
    font-size: 14px;
  }

  small {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  label {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.secondaryText};
  }

  a {
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
    color: ${({ theme: theme })=>theme.primaryBlue};
  }

  hr {
    opacity: 1;
    border: 1px solid ${({ theme: theme })=>theme.stroke};
  }

  svg, img {
    display: inline-block;
    vertical-align: middle;
  visibility: visible;

  }

  ul, ol {
    li {
      color: ${({ theme: theme })=>theme.primaryText};
    }
  }

  .os-theme-dark {
    --os-handle-bg: ${({ theme: theme })=>theme.violetPurple};
    --os-handle-bg-hover: ${({ theme: theme })=>theme.secondaryPurple};
    --os-handle-bg-active: ${({ theme: theme })=>theme.lavenderPurple};
  }
`;


var $43afcb05ca3681f6$exports = {};

var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
var $b550f30cec538bc8$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b550f30cec538bc8$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $b550f30cec538bc8$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $b550f30cec538bc8$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $b550f30cec538bc8$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $b550f30cec538bc8$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b550f30cec538bc8$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b550f30cec538bc8$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b550f30cec538bc8$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $b550f30cec538bc8$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b550f30cec538bc8$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b550f30cec538bc8$var$root = $b550f30cec538bc8$var$freeGlobal || $b550f30cec538bc8$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $b550f30cec538bc8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b550f30cec538bc8$var$objectToString = $b550f30cec538bc8$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b550f30cec538bc8$var$nativeMax = Math.max, $b550f30cec538bc8$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $b550f30cec538bc8$var$now = function() {
    return $b550f30cec538bc8$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $b550f30cec538bc8$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($b550f30cec538bc8$var$FUNC_ERROR_TEXT);
    wait = $b550f30cec538bc8$var$toNumber(wait) || 0;
    if ($b550f30cec538bc8$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $b550f30cec538bc8$var$nativeMax($b550f30cec538bc8$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $b550f30cec538bc8$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $b550f30cec538bc8$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($b550f30cec538bc8$var$now());
    }
    function debounced() {
        var time = $b550f30cec538bc8$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b550f30cec538bc8$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b550f30cec538bc8$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b550f30cec538bc8$var$isSymbol(value) {
    return typeof value == "symbol" || $b550f30cec538bc8$var$isObjectLike(value) && $b550f30cec538bc8$var$objectToString.call(value) == $b550f30cec538bc8$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b550f30cec538bc8$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b550f30cec538bc8$var$isSymbol(value)) return $b550f30cec538bc8$var$NAN;
    if ($b550f30cec538bc8$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $b550f30cec538bc8$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($b550f30cec538bc8$var$reTrim, "");
    var isBinary = $b550f30cec538bc8$var$reIsBinary.test(value);
    return isBinary || $b550f30cec538bc8$var$reIsOctal.test(value) ? $b550f30cec538bc8$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b550f30cec538bc8$var$reIsBadHex.test(value) ? $b550f30cec538bc8$var$NAN : +value;
}
$b550f30cec538bc8$exports = $b550f30cec538bc8$var$debounce;


// src/useBoolean/useBoolean.ts
function $554092f59a7e7485$export$c32275ecbd12948f(defaultValue) {
    const [value, setValue] = (0, $dup7A.useState)(!!defaultValue);
    const setTrue = (0, $dup7A.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $dup7A.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $dup7A.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $554092f59a7e7485$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dup7A.useLayoutEffect) : (0, $dup7A.useEffect);
// src/useEventListener/useEventListener.ts
function $554092f59a7e7485$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $dup7A.useRef)(handler);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $dup7A.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $554092f59a7e7485$export$5139c081cbc6c8bb(handler) {
    $554092f59a7e7485$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $554092f59a7e7485$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $dup7A.useState)(null);
    const copy = (0, $dup7A.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $554092f59a7e7485$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $dup7A.useState)(initialValue ?? 0);
    const increment = ()=>{
        setCount((x)=>x + 1);
    };
    const decrement = ()=>{
        setCount((x)=>x - 1);
    };
    const reset = ()=>{
        setCount(initialValue ?? 0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $554092f59a7e7485$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $dup7A.useRef)(callback);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $554092f59a7e7485$export$8103f7eb37e19f7b(countdownOptions) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOptions) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOptions.seconds;
        intervalMs = countdownOptions.interval;
        isIncrement = countdownOptions.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOptions);
    intervalMs = intervalMs ?? 1e3;
    isIncrement = isIncrement ?? false;
    countStop = countStop ?? 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $554092f59a7e7485$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $554092f59a7e7485$export$c32275ecbd12948f(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $dup7A.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $554092f59a7e7485$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $554092f59a7e7485$export$ee5b5d04074a389e(fn) {
    const ref = (0, $dup7A.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $dup7A.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $554092f59a7e7485$var$IS_SERVER = typeof window === "undefined";
function $554092f59a7e7485$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $dup7A.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($554092f59a7e7485$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $554092f59a7e7485$export$ee5b5d04074a389e((value)=>{
        if ($554092f59a7e7485$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $554092f59a7e7485$var$IS_SERVER2 = typeof window === "undefined";
function $554092f59a7e7485$export$32d5543ab307c01(query, options) {
    const defaultValue = typeof options === "boolean" ? options : (options == null ? void 0 : options.defaultValue) ?? false;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const getMatches = (query2)=>{
        if ($554092f59a7e7485$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $554092f59a7e7485$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $554092f59a7e7485$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $554092f59a7e7485$export$4673cbff94e146e2(options, localStorageKeyProps = $554092f59a7e7485$var$LOCAL_STORAGE_KEY) {
    const counter = (0, $dup7A.useRef)(0);
    counter.current++;
    const defaultValue = typeof options === "boolean" ? options : options == null ? void 0 : options.defaultValue;
    const localStorageKey = typeof options === "boolean" ? localStorageKeyProps ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY : (options == null ? void 0 : options.localStorageKey) ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $554092f59a7e7485$export$32d5543ab307c01($554092f59a7e7485$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $554092f59a7e7485$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $554092f59a7e7485$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $dup7A.useState)(value);
    (0, $dup7A.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay ?? 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
function $554092f59a7e7485$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $dup7A.useRef)(func);
    funcRef.current = func;
    (0, $dup7A.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $554092f59a7e7485$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $dup7A.useRef)();
    $554092f59a7e7485$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $dup7A.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $dup7A.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $554092f59a7e7485$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $dup7A.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $dup7A.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $554092f59a7e7485$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $554092f59a7e7485$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $dup7A.useRef)(null);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $554092f59a7e7485$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $554092f59a7e7485$export$b558662bb0641046(effect) {
    (0, $dup7A.useEffect)(effect, []);
}
function $554092f59a7e7485$export$2b86bedf890eab8(options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const [ref, setRef] = (0, $dup7A.useState)(null);
    const readValue = (0, $dup7A.useCallback)(()=>{
        return {
            width: (ref == null ? void 0 : ref.offsetWidth) ?? void 0,
            height: (ref == null ? void 0 : ref.offsetHeight) ?? void 0
        };
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const [size, setSize] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return {
            width: void 0,
            height: void 0
        };
    });
    const handleSize = (0, $dup7A.useCallback)(()=>{
        setSize(readValue());
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const result = [
        setRef,
        size
    ];
    result.ref = result[0];
    result.width = size.width;
    result.height = size.height;
    return result;
}
function $554092f59a7e7485$export$d852f5f778460fa4(url, options) {
    const cache = (0, $dup7A.useRef)({});
    const cancelRequest = (0, $dup7A.useRef)(false);
    const initialState = {
        error: void 0,
        data: void 0
    };
    const fetchReducer = (state2, action)=>{
        switch(action.type){
            case "loading":
                return {
                    ...initialState
                };
            case "fetched":
                return {
                    ...initialState,
                    data: action.payload
                };
            case "error":
                return {
                    ...initialState,
                    error: action.payload
                };
            default:
                return state2;
        }
    };
    const [state, dispatch] = (0, $dup7A.useReducer)(fetchReducer, initialState);
    (0, $dup7A.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = async ()=>{
            dispatch({
                type: "loading"
            });
            const currentCache = cache.current[url];
            if (currentCache) {
                dispatch({
                    type: "fetched",
                    payload: currentCache
                });
                return;
            }
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw new Error(response.statusText);
                const data = await response.json();
                cache.current[url] = data;
                if (cancelRequest.current) return;
                dispatch({
                    type: "fetched",
                    payload: data
                });
            } catch (error) {
                if (cancelRequest.current) return;
                dispatch({
                    type: "error",
                    payload: error
                });
            }
        };
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
function $554092f59a7e7485$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $dup7A.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $554092f59a7e7485$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $554092f59a7e7485$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $554092f59a7e7485$export$c822f44b98c8bbf2() {
    const [isLoaded, setIsLoaded] = (0, $dup7A.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        // Thumbnail style.
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        // Full image style.
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
function $554092f59a7e7485$export$a7395f9832c00176(optionsOrLegacyRef, legacyOptions) {
    var _a;
    const isLegacySignature = "current" in optionsOrLegacyRef;
    const options = isLegacySignature ? legacyOptions : optionsOrLegacyRef;
    const { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false } = options ?? {};
    const [newRef, setNewRef] = (0, $dup7A.useState)(null);
    const ref = isLegacySignature ? optionsOrLegacyRef.current : newRef;
    const [state, setState] = (0, $dup7A.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $dup7A.useRef)();
    callbackRef.current = options == null ? void 0 : options.onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $dup7A.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $dup7A.useRef)(null);
    (0, $dup7A.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    if (isLegacySignature) return state.entry;
    const result = [
        setNewRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $554092f59a7e7485$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $dup7A.useState)(false);
    (0, $dup7A.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $554092f59a7e7485$export$5964c316e853650f() {
    const isFirst = (0, $dup7A.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
function $554092f59a7e7485$export$80c2a3957bcb42ea() {
    const isMounted = (0, $dup7A.useRef)(false);
    (0, $dup7A.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $dup7A.useCallback)(()=>isMounted.current, []);
}
function $554092f59a7e7485$export$314db5846aaeae6e(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $dup7A.useState)(initialLocked);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
function $554092f59a7e7485$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $dup7A.useState)(new Map(initialState));
    const actions = {
        set: (0, $dup7A.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $dup7A.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $dup7A.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $dup7A.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $554092f59a7e7485$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown") {
    $554092f59a7e7485$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    });
}
var $554092f59a7e7485$var$IS_SERVER3 = typeof window === "undefined";
function $554092f59a7e7485$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        if ($554092f59a7e7485$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $554092f59a7e7485$var$initialSize = {
    width: void 0,
    height: void 0
};
function $554092f59a7e7485$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $dup7A.useState)($554092f59a7e7485$var$initialSize);
    const isMounted = $554092f59a7e7485$export$80c2a3957bcb42ea();
    const previousSize = (0, $dup7A.useRef)({
        ...$554092f59a7e7485$var$initialSize
    });
    const onResize = (0, $dup7A.useRef)(void 0);
    onResize.current = options == null ? void 0 : options.onResize;
    (0, $dup7A.useEffect)(()=>{
        if (!(ref == null ? void 0 : ref.current)) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $554092f59a7e7485$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $554092f59a7e7485$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize == null ? void 0 : onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $554092f59a7e7485$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $554092f59a7e7485$var$IS_SERVER4 = typeof window === "undefined";
function $554092f59a7e7485$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($554092f59a7e7485$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $554092f59a7e7485$export$40ae01be0011c1e6(setScreen, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $554092f59a7e7485$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $554092f59a7e7485$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $554092f59a7e7485$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $dup7A.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $554092f59a7e7485$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $dup7A.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $554092f59a7e7485$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $554092f59a7e7485$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $554092f59a7e7485$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $554092f59a7e7485$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $554092f59a7e7485$var$IS_SERVER5 = typeof window === "undefined";
function $554092f59a7e7485$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $dup7A.useState)(false);
    const target = (0, $dup7A.useRef)(null);
    const originalStyle = (0, $dup7A.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if ($554092f59a7e7485$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $554092f59a7e7485$var$IS_SERVER6 = typeof window === "undefined";
function $554092f59a7e7485$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $dup7A.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($554092f59a7e7485$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $554092f59a7e7485$export$ee5b5d04074a389e((value)=>{
        if ($554092f59a7e7485$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
// src/useSsr/useSsr.ts
function $554092f59a7e7485$export$f4eafc809f5e6ccc() {
    var _a;
    const isDOM = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    typeof window !== "undefined" && !!((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
function $554092f59a7e7485$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $dup7A.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $dup7A.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $dup7A.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $dup7A.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $dup7A.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $554092f59a7e7485$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $554092f59a7e7485$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $554092f59a7e7485$export$ec561688e440eda6(options) {
    const defaultValue = typeof options === "string" ? "system" : (options == null ? void 0 : options.defaultValue) ?? "system";
    const localStorageKey = typeof options === "string" ? options : (options == null ? void 0 : options.localStorageKey) ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY2;
    const initializeWithValue = typeof options === "string" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $554092f59a7e7485$export$32d5543ab307c01($554092f59a7e7485$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $554092f59a7e7485$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $554092f59a7e7485$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $dup7A.useRef)(callback);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $554092f59a7e7485$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $dup7A.useState)(!!defaultValue);
    const toggle = (0, $dup7A.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
function $554092f59a7e7485$export$496315a1608d9602(effect, deps) {
    const isFirst = $554092f59a7e7485$export$5964c316e853650f();
    (0, $dup7A.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $554092f59a7e7485$var$IS_SERVER7 = typeof window === "undefined";
function $554092f59a7e7485$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $554092f59a7e7485$export$40ae01be0011c1e6(setWindowSize, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


var $bbbd8fadaf5f7664$exports = {};

$parcel$defineInteropFlag($bbbd8fadaf5f7664$exports);

$parcel$export($bbbd8fadaf5f7664$exports, "default", () => $bbbd8fadaf5f7664$export$2e2bcd8739ae039);
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $dup7A = parcelRequire("dup7A");

var $6AdSR = parcelRequire("6AdSR");
/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ "use strict";
var $9fd0241d8f6d7609$exports = {};
"use strict";
var $0dab403686ae1e63$exports = {};
"use strict";
var $0dab403686ae1e63$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$0dab403686ae1e63$exports = // eslint-disable-next-line es/no-global-this -- safe
$0dab403686ae1e63$var$check(typeof globalThis == "object" && globalThis) || $0dab403686ae1e63$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$0dab403686ae1e63$var$check(typeof self == "object" && self) || $0dab403686ae1e63$var$check(typeof $parcel$global == "object" && $parcel$global) || $0dab403686ae1e63$var$check(typeof $0dab403686ae1e63$exports == "object" && $0dab403686ae1e63$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $677b298e8fc869eb$export$2d1720544b23b823;
"use strict";
var $cea8a7c76ccddf5d$exports = {};
"use strict";
var $1aa9995203de1dcd$exports = {};
"use strict";
$1aa9995203de1dcd$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$cea8a7c76ccddf5d$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $6e06bffcfb3013e2$exports = {};
"use strict";
var $e337c262a4702797$exports = {};
"use strict";

$e337c262a4702797$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $6e06bffcfb3013e2$var$call = Function.prototype.call;
$6e06bffcfb3013e2$exports = $e337c262a4702797$exports ? $6e06bffcfb3013e2$var$call.bind($6e06bffcfb3013e2$var$call) : function() {
    return $6e06bffcfb3013e2$var$call.apply($6e06bffcfb3013e2$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e07dffcb0f5b7ce$export$2d1720544b23b823;
"use strict";
var $1e07dffcb0f5b7ce$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e07dffcb0f5b7ce$var$NASHORN_BUG = $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor && !$1e07dffcb0f5b7ce$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e07dffcb0f5b7ce$export$2d1720544b23b823 = $1e07dffcb0f5b7ce$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e07dffcb0f5b7ce$var$$propertyIsEnumerable;


var $2159f71bcf7ac44a$exports = {};
"use strict";
$2159f71bcf7ac44a$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4115d950804b1b04$exports = {};
"use strict";
var $ef1b385171038d0e$exports = {};
"use strict";
var $3d3a3f96d04dfa01$exports = {};
"use strict";

var $3d3a3f96d04dfa01$var$FunctionPrototype = Function.prototype;
var $3d3a3f96d04dfa01$var$call = $3d3a3f96d04dfa01$var$FunctionPrototype.call;
var $3d3a3f96d04dfa01$var$uncurryThisWithBind = $e337c262a4702797$exports && $3d3a3f96d04dfa01$var$FunctionPrototype.bind.bind($3d3a3f96d04dfa01$var$call, $3d3a3f96d04dfa01$var$call);
$3d3a3f96d04dfa01$exports = $e337c262a4702797$exports ? $3d3a3f96d04dfa01$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $3d3a3f96d04dfa01$var$call.apply(fn, arguments);
    };
};



var $3a0f0fc82e93bd49$exports = {};
"use strict";

var $3a0f0fc82e93bd49$var$toString = $3d3a3f96d04dfa01$exports({}.toString);
var $3a0f0fc82e93bd49$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
$3a0f0fc82e93bd49$exports = function(it) {
    return $3a0f0fc82e93bd49$var$stringSlice($3a0f0fc82e93bd49$var$toString(it), 8, -1);
};


var $ef1b385171038d0e$var$$Object = Object;
var $ef1b385171038d0e$var$split = $3d3a3f96d04dfa01$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$ef1b385171038d0e$exports = $1aa9995203de1dcd$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$ef1b385171038d0e$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $3a0f0fc82e93bd49$exports(it) === "String" ? $ef1b385171038d0e$var$split(it, "") : $ef1b385171038d0e$var$$Object(it);
} : $ef1b385171038d0e$var$$Object;


var $938881b1bb81812d$exports = {};
"use strict";
var $c3e80151589b4ea3$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c3e80151589b4ea3$exports = function(it) {
    return it === null || it === undefined;
};


var $938881b1bb81812d$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$938881b1bb81812d$exports = function(it) {
    if ($c3e80151589b4ea3$exports(it)) throw new $938881b1bb81812d$var$$TypeError("Can't call method on " + it);
    return it;
};


$4115d950804b1b04$exports = function(it) {
    return $ef1b385171038d0e$exports($938881b1bb81812d$exports(it));
};


var $895a336d320ed309$exports = {};
"use strict";
var $a9b0addf205e517d$exports = {};
"use strict";

var $d1de49472bdc582c$exports = {};
"use strict";
var $e8bca5b64a857b1a$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $e8bca5b64a857b1a$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$e8bca5b64a857b1a$exports = typeof $e8bca5b64a857b1a$var$documentAll == "undefined" && $e8bca5b64a857b1a$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $e8bca5b64a857b1a$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$d1de49472bdc582c$exports = function(it) {
    return typeof it == "object" ? it !== null : $e8bca5b64a857b1a$exports(it);
};


var $955cd9ff3d5b5e2b$exports = {};
"use strict";
var $e5002032510f09f3$exports = {};
"use strict";


var $e5002032510f09f3$var$aFunction = function(argument) {
    return $e8bca5b64a857b1a$exports(argument) ? argument : undefined;
};
$e5002032510f09f3$exports = function(namespace, method) {
    return arguments.length < 2 ? $e5002032510f09f3$var$aFunction($0dab403686ae1e63$exports[namespace]) : $0dab403686ae1e63$exports[namespace] && $0dab403686ae1e63$exports[namespace][method];
};



var $13b911265f6ed62e$exports = {};
"use strict";

$13b911265f6ed62e$exports = $3d3a3f96d04dfa01$exports({}.isPrototypeOf);


var $ceb90b1122b4e599$exports = {};
"use strict";
var $07701a9f16daf6f5$exports = {};
"use strict";
var $b3c67eba05e0aaef$exports = {};
"use strict";

var $3cecab8e292da4a1$exports = {};
"use strict";
$3cecab8e292da4a1$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $b3c67eba05e0aaef$var$process = $0dab403686ae1e63$exports.process;
var $b3c67eba05e0aaef$var$Deno = $0dab403686ae1e63$exports.Deno;
var $b3c67eba05e0aaef$var$versions = $b3c67eba05e0aaef$var$process && $b3c67eba05e0aaef$var$process.versions || $b3c67eba05e0aaef$var$Deno && $b3c67eba05e0aaef$var$Deno.version;
var $b3c67eba05e0aaef$var$v8 = $b3c67eba05e0aaef$var$versions && $b3c67eba05e0aaef$var$versions.v8;
var $b3c67eba05e0aaef$var$match, $b3c67eba05e0aaef$var$version;
if ($b3c67eba05e0aaef$var$v8) {
    $b3c67eba05e0aaef$var$match = $b3c67eba05e0aaef$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b3c67eba05e0aaef$var$version = $b3c67eba05e0aaef$var$match[0] > 0 && $b3c67eba05e0aaef$var$match[0] < 4 ? 1 : +($b3c67eba05e0aaef$var$match[0] + $b3c67eba05e0aaef$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b3c67eba05e0aaef$var$version && $3cecab8e292da4a1$exports) {
    $b3c67eba05e0aaef$var$match = $3cecab8e292da4a1$exports.match(/Edge\/(\d+)/);
    if (!$b3c67eba05e0aaef$var$match || $b3c67eba05e0aaef$var$match[1] >= 74) {
        $b3c67eba05e0aaef$var$match = $3cecab8e292da4a1$exports.match(/Chrome\/(\d+)/);
        if ($b3c67eba05e0aaef$var$match) $b3c67eba05e0aaef$var$version = +$b3c67eba05e0aaef$var$match[1];
    }
}
$b3c67eba05e0aaef$exports = $b3c67eba05e0aaef$var$version;




var $07701a9f16daf6f5$var$$String = $0dab403686ae1e63$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$07701a9f16daf6f5$exports = !!Object.getOwnPropertySymbols && !$1aa9995203de1dcd$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$07701a9f16daf6f5$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b3c67eba05e0aaef$exports && $b3c67eba05e0aaef$exports < 41;
});


$ceb90b1122b4e599$exports = $07701a9f16daf6f5$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $955cd9ff3d5b5e2b$var$$Object = Object;
$955cd9ff3d5b5e2b$exports = $ceb90b1122b4e599$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $e5002032510f09f3$exports("Symbol");
    return $e8bca5b64a857b1a$exports($Symbol) && $13b911265f6ed62e$exports($Symbol.prototype, $955cd9ff3d5b5e2b$var$$Object(it));
};


var $af183ff3a7a0320f$exports = {};
"use strict";
var $5f7d5e7ccafe12e0$exports = {};
"use strict";

var $0ee3ded6653f158b$exports = {};
"use strict";
var $0ee3ded6653f158b$var$$String = String;
$0ee3ded6653f158b$exports = function(argument) {
    try {
        return $0ee3ded6653f158b$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $5f7d5e7ccafe12e0$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$5f7d5e7ccafe12e0$exports = function(argument) {
    if ($e8bca5b64a857b1a$exports(argument)) return argument;
    throw new $5f7d5e7ccafe12e0$var$$TypeError($0ee3ded6653f158b$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$af183ff3a7a0320f$exports = function(V, P) {
    var func = V[P];
    return $c3e80151589b4ea3$exports(func) ? undefined : $5f7d5e7ccafe12e0$exports(func);
};


var $9c2bdf28b02ea4f2$exports = {};
"use strict";



var $9c2bdf28b02ea4f2$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$9c2bdf28b02ea4f2$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $e8bca5b64a857b1a$exports(fn = input.toString) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    if ($e8bca5b64a857b1a$exports(fn = input.valueOf) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    if (pref !== "string" && $e8bca5b64a857b1a$exports(fn = input.toString) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    throw new $9c2bdf28b02ea4f2$var$$TypeError("Can't convert object to primitive value");
};


var $83f1bf79efdf35c6$exports = {};
"use strict";

var $3231f6153a88e373$exports = {};
"use strict";
var $9485ff83f3c32d3e$exports = {};
"use strict";
var $3d49ff5c72fb9ed5$exports = {};
"use strict";
$3d49ff5c72fb9ed5$exports = false;



var $305fdd2dd2be7f81$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $305fdd2dd2be7f81$var$defineProperty = Object.defineProperty;
$305fdd2dd2be7f81$exports = function(key, value) {
    try {
        $305fdd2dd2be7f81$var$defineProperty($0dab403686ae1e63$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $0dab403686ae1e63$exports[key] = value;
    }
    return value;
};


var $9485ff83f3c32d3e$var$SHARED = "__core-js_shared__";
var $9485ff83f3c32d3e$var$store = $9485ff83f3c32d3e$exports = $0dab403686ae1e63$exports[$9485ff83f3c32d3e$var$SHARED] || $305fdd2dd2be7f81$exports($9485ff83f3c32d3e$var$SHARED, {});
($9485ff83f3c32d3e$var$store.versions || ($9485ff83f3c32d3e$var$store.versions = [])).push({
    version: "3.37.0",
    mode: $3d49ff5c72fb9ed5$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$3231f6153a88e373$exports = function(key, value) {
    return $9485ff83f3c32d3e$exports[key] || ($9485ff83f3c32d3e$exports[key] = value || {});
};


var $6713471208f796ec$exports = {};
"use strict";

var $476d2ef928fdaf21$exports = {};
"use strict";

var $476d2ef928fdaf21$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$476d2ef928fdaf21$exports = function(argument) {
    return $476d2ef928fdaf21$var$$Object($938881b1bb81812d$exports(argument));
};


var $6713471208f796ec$var$hasOwnProperty = $3d3a3f96d04dfa01$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$6713471208f796ec$exports = Object.hasOwn || function hasOwn(it, key) {
    return $6713471208f796ec$var$hasOwnProperty($476d2ef928fdaf21$exports(it), key);
};


var $2ef1f447bc219aea$exports = {};
"use strict";

var $2ef1f447bc219aea$var$id = 0;
var $2ef1f447bc219aea$var$postfix = Math.random();
var $2ef1f447bc219aea$var$toString = $3d3a3f96d04dfa01$exports(1.0.toString);
$2ef1f447bc219aea$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $2ef1f447bc219aea$var$toString(++$2ef1f447bc219aea$var$id + $2ef1f447bc219aea$var$postfix, 36);
};




var $83f1bf79efdf35c6$var$Symbol = $0dab403686ae1e63$exports.Symbol;
var $83f1bf79efdf35c6$var$WellKnownSymbolsStore = $3231f6153a88e373$exports("wks");
var $83f1bf79efdf35c6$var$createWellKnownSymbol = $ceb90b1122b4e599$exports ? $83f1bf79efdf35c6$var$Symbol["for"] || $83f1bf79efdf35c6$var$Symbol : $83f1bf79efdf35c6$var$Symbol && $83f1bf79efdf35c6$var$Symbol.withoutSetter || $2ef1f447bc219aea$exports;
$83f1bf79efdf35c6$exports = function(name) {
    if (!$6713471208f796ec$exports($83f1bf79efdf35c6$var$WellKnownSymbolsStore, name)) $83f1bf79efdf35c6$var$WellKnownSymbolsStore[name] = $07701a9f16daf6f5$exports && $6713471208f796ec$exports($83f1bf79efdf35c6$var$Symbol, name) ? $83f1bf79efdf35c6$var$Symbol[name] : $83f1bf79efdf35c6$var$createWellKnownSymbol("Symbol." + name);
    return $83f1bf79efdf35c6$var$WellKnownSymbolsStore[name];
};


var $a9b0addf205e517d$var$$TypeError = TypeError;
var $a9b0addf205e517d$var$TO_PRIMITIVE = $83f1bf79efdf35c6$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$a9b0addf205e517d$exports = function(input, pref) {
    if (!$d1de49472bdc582c$exports(input) || $955cd9ff3d5b5e2b$exports(input)) return input;
    var exoticToPrim = $af183ff3a7a0320f$exports(input, $a9b0addf205e517d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $6e06bffcfb3013e2$exports(exoticToPrim, input, pref);
        if (!$d1de49472bdc582c$exports(result) || $955cd9ff3d5b5e2b$exports(result)) return result;
        throw new $a9b0addf205e517d$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $9c2bdf28b02ea4f2$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$895a336d320ed309$exports = function(argument) {
    var key = $a9b0addf205e517d$exports(argument, "string");
    return $955cd9ff3d5b5e2b$exports(key) ? key : key + "";
};



var $ef13e207d9d9012b$exports = {};
"use strict";


var $416f618c0bbd719b$exports = {};
"use strict";


var $416f618c0bbd719b$var$document = $0dab403686ae1e63$exports.document;
// typeof document.createElement is 'object' in old IE
var $416f618c0bbd719b$var$EXISTS = $d1de49472bdc582c$exports($416f618c0bbd719b$var$document) && $d1de49472bdc582c$exports($416f618c0bbd719b$var$document.createElement);
$416f618c0bbd719b$exports = function(it) {
    return $416f618c0bbd719b$var$EXISTS ? $416f618c0bbd719b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$ef13e207d9d9012b$exports = !$cea8a7c76ccddf5d$exports && !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($416f618c0bbd719b$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $677b298e8fc869eb$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$677b298e8fc869eb$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports ? $677b298e8fc869eb$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4115d950804b1b04$exports(O);
    P = $895a336d320ed309$exports(P);
    if ($ef13e207d9d9012b$exports) try {
        return $677b298e8fc869eb$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($6713471208f796ec$exports(O, P)) return $2159f71bcf7ac44a$exports(!$6e06bffcfb3013e2$exports($1e07dffcb0f5b7ce$export$2d1720544b23b823, O, P), O[P]);
};


var $9fd0241d8f6d7609$require$getOwnPropertyDescriptor = $677b298e8fc869eb$export$2d1720544b23b823;
var $d13e1e0ab68f4bd6$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $ec8f33e5c924d97f$export$2d1720544b23b823;
"use strict";


var $ac4e947f8a7d92c1$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$ac4e947f8a7d92c1$exports = $cea8a7c76ccddf5d$exports && $1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $2d94e296a4d81142$exports = {};
"use strict";

var $2d94e296a4d81142$var$$String = String;
var $2d94e296a4d81142$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$2d94e296a4d81142$exports = function(argument) {
    if ($d1de49472bdc582c$exports(argument)) return argument;
    throw new $2d94e296a4d81142$var$$TypeError($2d94e296a4d81142$var$$String(argument) + " is not an object");
};



var $ec8f33e5c924d97f$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $ec8f33e5c924d97f$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ec8f33e5c924d97f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ec8f33e5c924d97f$var$ENUMERABLE = "enumerable";
var $ec8f33e5c924d97f$var$CONFIGURABLE = "configurable";
var $ec8f33e5c924d97f$var$WRITABLE = "writable";
$ec8f33e5c924d97f$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports ? $ac4e947f8a7d92c1$exports ? function defineProperty(O, P, Attributes) {
    $2d94e296a4d81142$exports(O);
    P = $895a336d320ed309$exports(P);
    $2d94e296a4d81142$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $ec8f33e5c924d97f$var$WRITABLE in Attributes && !Attributes[$ec8f33e5c924d97f$var$WRITABLE]) {
        var current = $ec8f33e5c924d97f$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$ec8f33e5c924d97f$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $ec8f33e5c924d97f$var$CONFIGURABLE in Attributes ? Attributes[$ec8f33e5c924d97f$var$CONFIGURABLE] : current[$ec8f33e5c924d97f$var$CONFIGURABLE],
                enumerable: $ec8f33e5c924d97f$var$ENUMERABLE in Attributes ? Attributes[$ec8f33e5c924d97f$var$ENUMERABLE] : current[$ec8f33e5c924d97f$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $ec8f33e5c924d97f$var$$defineProperty(O, P, Attributes);
} : $ec8f33e5c924d97f$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $2d94e296a4d81142$exports(O);
    P = $895a336d320ed309$exports(P);
    $2d94e296a4d81142$exports(Attributes);
    if ($ef13e207d9d9012b$exports) try {
        return $ec8f33e5c924d97f$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $ec8f33e5c924d97f$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$d13e1e0ab68f4bd6$exports = $cea8a7c76ccddf5d$exports ? function(object, key, value) {
    return $ec8f33e5c924d97f$export$2d1720544b23b823(object, key, $2159f71bcf7ac44a$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $1f4601f39377b637$exports = {};
"use strict";


var $d745cb9bd2dfb659$exports = {};
"use strict";





var $775efe7ab5de3db4$exports = {};
"use strict";


var $775efe7ab5de3db4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $775efe7ab5de3db4$var$getDescriptor = $cea8a7c76ccddf5d$exports && Object.getOwnPropertyDescriptor;
var $775efe7ab5de3db4$var$EXISTS = $6713471208f796ec$exports($775efe7ab5de3db4$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $775efe7ab5de3db4$var$PROPER = $775efe7ab5de3db4$var$EXISTS && (function something() {}).name === "something";
var $775efe7ab5de3db4$var$CONFIGURABLE = $775efe7ab5de3db4$var$EXISTS && (!$cea8a7c76ccddf5d$exports || $cea8a7c76ccddf5d$exports && $775efe7ab5de3db4$var$getDescriptor($775efe7ab5de3db4$var$FunctionPrototype, "name").configurable);
$775efe7ab5de3db4$exports = {
    EXISTS: $775efe7ab5de3db4$var$EXISTS,
    PROPER: $775efe7ab5de3db4$var$PROPER,
    CONFIGURABLE: $775efe7ab5de3db4$var$CONFIGURABLE
};


var $d745cb9bd2dfb659$require$CONFIGURABLE_FUNCTION_NAME = $775efe7ab5de3db4$exports.CONFIGURABLE;
var $97cff4f00fd83461$exports = {};
"use strict";



var $97cff4f00fd83461$var$functionToString = $3d3a3f96d04dfa01$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$e8bca5b64a857b1a$exports($9485ff83f3c32d3e$exports.inspectSource)) $9485ff83f3c32d3e$exports.inspectSource = function(it) {
    return $97cff4f00fd83461$var$functionToString(it);
};
$97cff4f00fd83461$exports = $9485ff83f3c32d3e$exports.inspectSource;


var $7c2e321de999e766$exports = {};
"use strict";
var $734e17bc28988288$exports = {};
"use strict";


var $734e17bc28988288$var$WeakMap = $0dab403686ae1e63$exports.WeakMap;
$734e17bc28988288$exports = $e8bca5b64a857b1a$exports($734e17bc28988288$var$WeakMap) && /native code/.test(String($734e17bc28988288$var$WeakMap));







var $44039bd971d76cb8$exports = {};
"use strict";


var $44039bd971d76cb8$var$keys = $3231f6153a88e373$exports("keys");
$44039bd971d76cb8$exports = function(key) {
    return $44039bd971d76cb8$var$keys[key] || ($44039bd971d76cb8$var$keys[key] = $2ef1f447bc219aea$exports(key));
};


var $60b0be22ef1af955$exports = {};
"use strict";
$60b0be22ef1af955$exports = {};


var $7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $7c2e321de999e766$var$TypeError = $0dab403686ae1e63$exports.TypeError;
var $7c2e321de999e766$var$WeakMap = $0dab403686ae1e63$exports.WeakMap;
var $7c2e321de999e766$var$set, $7c2e321de999e766$var$get, $7c2e321de999e766$var$has;
var $7c2e321de999e766$var$enforce = function(it) {
    return $7c2e321de999e766$var$has(it) ? $7c2e321de999e766$var$get(it) : $7c2e321de999e766$var$set(it, {});
};
var $7c2e321de999e766$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$d1de49472bdc582c$exports(it) || (state = $7c2e321de999e766$var$get(it)).type !== TYPE) throw new $7c2e321de999e766$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($734e17bc28988288$exports || $9485ff83f3c32d3e$exports.state) {
    var $7c2e321de999e766$var$store = $9485ff83f3c32d3e$exports.state || ($9485ff83f3c32d3e$exports.state = new $7c2e321de999e766$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $7c2e321de999e766$var$store.get = $7c2e321de999e766$var$store.get;
    $7c2e321de999e766$var$store.has = $7c2e321de999e766$var$store.has;
    $7c2e321de999e766$var$store.set = $7c2e321de999e766$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $7c2e321de999e766$var$set = function(it, metadata) {
        if ($7c2e321de999e766$var$store.has(it)) throw new $7c2e321de999e766$var$TypeError($7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7c2e321de999e766$var$store.set(it, metadata);
        return metadata;
    };
    $7c2e321de999e766$var$get = function(it) {
        return $7c2e321de999e766$var$store.get(it) || {};
    };
    $7c2e321de999e766$var$has = function(it) {
        return $7c2e321de999e766$var$store.has(it);
    };
} else {
    var $7c2e321de999e766$var$STATE = $44039bd971d76cb8$exports("state");
    $60b0be22ef1af955$exports[$7c2e321de999e766$var$STATE] = true;
    $7c2e321de999e766$var$set = function(it, metadata) {
        if ($6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE)) throw new $7c2e321de999e766$var$TypeError($7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $d13e1e0ab68f4bd6$exports(it, $7c2e321de999e766$var$STATE, metadata);
        return metadata;
    };
    $7c2e321de999e766$var$get = function(it) {
        return $6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE) ? it[$7c2e321de999e766$var$STATE] : {};
    };
    $7c2e321de999e766$var$has = function(it) {
        return $6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE);
    };
}
$7c2e321de999e766$exports = {
    set: $7c2e321de999e766$var$set,
    get: $7c2e321de999e766$var$get,
    has: $7c2e321de999e766$var$has,
    enforce: $7c2e321de999e766$var$enforce,
    getterFor: $7c2e321de999e766$var$getterFor
};


var $d745cb9bd2dfb659$var$enforceInternalState = $7c2e321de999e766$exports.enforce;
var $d745cb9bd2dfb659$var$getInternalState = $7c2e321de999e766$exports.get;
var $d745cb9bd2dfb659$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $d745cb9bd2dfb659$var$defineProperty = Object.defineProperty;
var $d745cb9bd2dfb659$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
var $d745cb9bd2dfb659$var$replace = $3d3a3f96d04dfa01$exports("".replace);
var $d745cb9bd2dfb659$var$join = $3d3a3f96d04dfa01$exports([].join);
var $d745cb9bd2dfb659$var$CONFIGURABLE_LENGTH = $cea8a7c76ccddf5d$exports && !$1aa9995203de1dcd$exports(function() {
    return $d745cb9bd2dfb659$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $d745cb9bd2dfb659$var$TEMPLATE = String(String).split("String");
var $d745cb9bd2dfb659$var$makeBuiltIn = $d745cb9bd2dfb659$exports = function(value, name, options) {
    if ($d745cb9bd2dfb659$var$stringSlice($d745cb9bd2dfb659$var$$String(name), 0, 7) === "Symbol(") name = "[" + $d745cb9bd2dfb659$var$replace($d745cb9bd2dfb659$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$6713471208f796ec$exports(value, "name") || $d745cb9bd2dfb659$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($cea8a7c76ccddf5d$exports) $d745cb9bd2dfb659$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($d745cb9bd2dfb659$var$CONFIGURABLE_LENGTH && options && $6713471208f796ec$exports(options, "arity") && value.length !== options.arity) $d745cb9bd2dfb659$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $6713471208f796ec$exports(options, "constructor") && options.constructor) {
            if ($cea8a7c76ccddf5d$exports) $d745cb9bd2dfb659$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $d745cb9bd2dfb659$var$enforceInternalState(value);
    if (!$6713471208f796ec$exports(state, "source")) state.source = $d745cb9bd2dfb659$var$join($d745cb9bd2dfb659$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $d745cb9bd2dfb659$var$makeBuiltIn(function toString() {
    return $e8bca5b64a857b1a$exports(this) && $d745cb9bd2dfb659$var$getInternalState(this).source || $97cff4f00fd83461$exports(this);
}, "toString");



$1f4601f39377b637$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($e8bca5b64a857b1a$exports(value)) $d745cb9bd2dfb659$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $305fdd2dd2be7f81$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $ec8f33e5c924d97f$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ecce2f9545dca589$exports = {};
"use strict";

var $da5dee507eb1b7b3$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $eb3ab2cab8ae8671$export$2d1720544b23b823;
"use strict";
var $848c392f9af002ba$exports = {};
"use strict";



var $18ec349fe9b1dd94$exports = {};
"use strict";

var $6f5ab140d3847165$exports = {};
"use strict";
var $38b1b404f6b944d2$exports = {};
"use strict";
var $5491e71f2d18e0a5$exports = {};
"use strict";
var $5491e71f2d18e0a5$var$ceil = Math.ceil;
var $5491e71f2d18e0a5$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5491e71f2d18e0a5$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5491e71f2d18e0a5$var$floor : $5491e71f2d18e0a5$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$38b1b404f6b944d2$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5491e71f2d18e0a5$exports(number);
};


var $6f5ab140d3847165$var$max = Math.max;
var $6f5ab140d3847165$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$6f5ab140d3847165$exports = function(index, length) {
    var integer = $38b1b404f6b944d2$exports(index);
    return integer < 0 ? $6f5ab140d3847165$var$max(integer + length, 0) : $6f5ab140d3847165$var$min(integer, length);
};


var $b20a724496178f6b$exports = {};
"use strict";
var $eecf4269159770dc$exports = {};
"use strict";

var $eecf4269159770dc$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$eecf4269159770dc$exports = function(argument) {
    var len = $38b1b404f6b944d2$exports(argument);
    return len > 0 ? $eecf4269159770dc$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$b20a724496178f6b$exports = function(obj) {
    return $eecf4269159770dc$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $18ec349fe9b1dd94$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4115d950804b1b04$exports($this);
        var length = $b20a724496178f6b$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $6f5ab140d3847165$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$18ec349fe9b1dd94$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $18ec349fe9b1dd94$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $18ec349fe9b1dd94$var$createMethod(false)
};


var $848c392f9af002ba$require$indexOf = $18ec349fe9b1dd94$exports.indexOf;

var $848c392f9af002ba$var$push = $3d3a3f96d04dfa01$exports([].push);
$848c392f9af002ba$exports = function(object, names) {
    var O = $4115d950804b1b04$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$6713471208f796ec$exports($60b0be22ef1af955$exports, key) && $6713471208f796ec$exports(O, key) && $848c392f9af002ba$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6713471208f796ec$exports(O, key = names[i++])) ~$848c392f9af002ba$require$indexOf(result, key) || $848c392f9af002ba$var$push(result, key);
    return result;
};


var $05ce5ef981815c5d$exports = {};
"use strict";
// IE8- don't enum bug keys
$05ce5ef981815c5d$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $eb3ab2cab8ae8671$var$hiddenKeys = $05ce5ef981815c5d$exports.concat("length", "prototype");
$eb3ab2cab8ae8671$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $848c392f9af002ba$exports(O, $eb3ab2cab8ae8671$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $57496a63b7fc6acb$export$2d1720544b23b823;
"use strict";
$57496a63b7fc6acb$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $da5dee507eb1b7b3$var$concat = $3d3a3f96d04dfa01$exports([].concat);
// all object keys, includes non-enumerable and symbols
$da5dee507eb1b7b3$exports = $e5002032510f09f3$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $eb3ab2cab8ae8671$export$2d1720544b23b823($2d94e296a4d81142$exports(it));
    var getOwnPropertySymbols = $57496a63b7fc6acb$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $da5dee507eb1b7b3$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ecce2f9545dca589$exports = function(target, source, exceptions) {
    var keys = $da5dee507eb1b7b3$exports(source);
    var defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $677b298e8fc869eb$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$6713471208f796ec$exports(target, key) && !(exceptions && $6713471208f796ec$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $889e651c47b82e1d$exports = {};
"use strict";


var $889e651c47b82e1d$var$replacement = /#|\.prototype\./;
var $889e651c47b82e1d$var$isForced = function(feature, detection) {
    var value = $889e651c47b82e1d$var$data[$889e651c47b82e1d$var$normalize(feature)];
    return value === $889e651c47b82e1d$var$POLYFILL ? true : value === $889e651c47b82e1d$var$NATIVE ? false : $e8bca5b64a857b1a$exports(detection) ? $1aa9995203de1dcd$exports(detection) : !!detection;
};
var $889e651c47b82e1d$var$normalize = $889e651c47b82e1d$var$isForced.normalize = function(string) {
    return String(string).replace($889e651c47b82e1d$var$replacement, ".").toLowerCase();
};
var $889e651c47b82e1d$var$data = $889e651c47b82e1d$var$isForced.data = {};
var $889e651c47b82e1d$var$NATIVE = $889e651c47b82e1d$var$isForced.NATIVE = "N";
var $889e651c47b82e1d$var$POLYFILL = $889e651c47b82e1d$var$isForced.POLYFILL = "P";
$889e651c47b82e1d$exports = $889e651c47b82e1d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $9fd0241d8f6d7609$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $0dab403686ae1e63$exports;
    else if (STATIC) target = $0dab403686ae1e63$exports[TARGET] || $305fdd2dd2be7f81$exports(TARGET, {});
    else target = $0dab403686ae1e63$exports[TARGET] && $0dab403686ae1e63$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $9fd0241d8f6d7609$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $889e651c47b82e1d$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ecce2f9545dca589$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $d13e1e0ab68f4bd6$exports(sourceProperty, "sham", true);
        $1f4601f39377b637$exports(target, key, sourceProperty, options);
    }
};


var $2b3870675553b866$exports = {};
"use strict";



var $5f0738dcc48ec8db$exports = {};
"use strict";
var $7c3bd6d588abdd5b$exports = {};
"use strict";
var $cf9ad08c1dff0f40$exports = {};
"use strict";

var $cf9ad08c1dff0f40$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports("toStringTag");
var $cf9ad08c1dff0f40$var$test = {};
$cf9ad08c1dff0f40$var$test[$cf9ad08c1dff0f40$var$TO_STRING_TAG] = "z";
$cf9ad08c1dff0f40$exports = String($cf9ad08c1dff0f40$var$test) === "[object z]";





var $7c3bd6d588abdd5b$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports("toStringTag");
var $7c3bd6d588abdd5b$var$$Object = Object;
// ES3 wrong here
var $7c3bd6d588abdd5b$var$CORRECT_ARGUMENTS = $3a0f0fc82e93bd49$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $7c3bd6d588abdd5b$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$7c3bd6d588abdd5b$exports = $cf9ad08c1dff0f40$exports ? $3a0f0fc82e93bd49$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7c3bd6d588abdd5b$var$tryGet(O = $7c3bd6d588abdd5b$var$$Object(it), $7c3bd6d588abdd5b$var$TO_STRING_TAG)) == "string" ? tag : $7c3bd6d588abdd5b$var$CORRECT_ARGUMENTS ? $3a0f0fc82e93bd49$exports(O) : (result = $3a0f0fc82e93bd49$exports(O)) === "Object" && $e8bca5b64a857b1a$exports(O.callee) ? "Arguments" : result;
};


var $5f0738dcc48ec8db$var$$String = String;
$5f0738dcc48ec8db$exports = function(argument) {
    if ($7c3bd6d588abdd5b$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $5f0738dcc48ec8db$var$$String(argument);
};


var $400332d16a82a52a$exports = {};
"use strict";



var $7e951708847f20df$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$7e951708847f20df$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $400332d16a82a52a$var$replace = $3d3a3f96d04dfa01$exports("".replace);
var $400332d16a82a52a$var$ltrim = RegExp("^[" + $7e951708847f20df$exports + "]+");
var $400332d16a82a52a$var$rtrim = RegExp("(^|[^" + $7e951708847f20df$exports + "])[" + $7e951708847f20df$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $400332d16a82a52a$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $5f0738dcc48ec8db$exports($938881b1bb81812d$exports($this));
        if (TYPE & 1) string = $400332d16a82a52a$var$replace(string, $400332d16a82a52a$var$ltrim, "");
        if (TYPE & 2) string = $400332d16a82a52a$var$replace(string, $400332d16a82a52a$var$rtrim, "$1");
        return string;
    };
};
$400332d16a82a52a$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $400332d16a82a52a$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $400332d16a82a52a$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $400332d16a82a52a$var$createMethod(3)
};


var $2b3870675553b866$require$trim = $400332d16a82a52a$exports.trim;

var $2b3870675553b866$var$$parseInt = $0dab403686ae1e63$exports.parseInt;
var $2b3870675553b866$var$Symbol = $0dab403686ae1e63$exports.Symbol;
var $2b3870675553b866$var$ITERATOR = $2b3870675553b866$var$Symbol && $2b3870675553b866$var$Symbol.iterator;
var $2b3870675553b866$var$hex = /^[+-]?0x/i;
var $2b3870675553b866$var$exec = $3d3a3f96d04dfa01$exports($2b3870675553b866$var$hex.exec);
var $2b3870675553b866$var$FORCED = $2b3870675553b866$var$$parseInt($7e951708847f20df$exports + "08") !== 8 || $2b3870675553b866$var$$parseInt($7e951708847f20df$exports + "0x16") !== 22 || $2b3870675553b866$var$ITERATOR && !$1aa9995203de1dcd$exports(function() {
    $2b3870675553b866$var$$parseInt(Object($2b3870675553b866$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$2b3870675553b866$exports = $2b3870675553b866$var$FORCED ? function parseInt(string, radix) {
    var S = $2b3870675553b866$require$trim($5f0738dcc48ec8db$exports(string));
    return $2b3870675553b866$var$$parseInt(S, radix >>> 0 || ($2b3870675553b866$var$exec($2b3870675553b866$var$hex, S) ? 16 : 10));
} : $2b3870675553b866$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$9fd0241d8f6d7609$exports({
    global: true,
    forced: parseInt !== $2b3870675553b866$exports
}, {
    parseInt: $2b3870675553b866$exports
});


"use strict";

var $62ad98ebdf144868$exports = {};
"use strict";




var $d1e3b2f1ebb02e4a$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$d1e3b2f1ebb02e4a$exports = Object.keys || function keys(O) {
    return $848c392f9af002ba$exports(O, $05ce5ef981815c5d$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $62ad98ebdf144868$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $62ad98ebdf144868$var$defineProperty = Object.defineProperty;
var $62ad98ebdf144868$var$concat = $3d3a3f96d04dfa01$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$62ad98ebdf144868$exports = !$62ad98ebdf144868$var$$assign || $1aa9995203de1dcd$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($cea8a7c76ccddf5d$exports && $62ad98ebdf144868$var$$assign({
        b: 1
    }, $62ad98ebdf144868$var$$assign($62ad98ebdf144868$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $62ad98ebdf144868$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $62ad98ebdf144868$var$$assign({}, A)[symbol] !== 7 || $d1e3b2f1ebb02e4a$exports($62ad98ebdf144868$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $476d2ef928fdaf21$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $57496a63b7fc6acb$export$2d1720544b23b823;
    var propertyIsEnumerable = $1e07dffcb0f5b7ce$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $ef1b385171038d0e$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $62ad98ebdf144868$var$concat($d1e3b2f1ebb02e4a$exports(S), getOwnPropertySymbols(S)) : $d1e3b2f1ebb02e4a$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$cea8a7c76ccddf5d$exports || $6e06bffcfb3013e2$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $62ad98ebdf144868$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$9fd0241d8f6d7609$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $62ad98ebdf144868$exports
}, {
    assign: $62ad98ebdf144868$exports
});


"use strict";

var $f478770b94881111$exports = {};
"use strict";
var $54c9964c2c5636b3$exports = {};
"use strict";
var $928d634d7319e074$exports = {};
"use strict";


$928d634d7319e074$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($3a0f0fc82e93bd49$exports(fn) === "Function") return $3d3a3f96d04dfa01$exports(fn);
};




var $54c9964c2c5636b3$var$bind = $928d634d7319e074$exports($928d634d7319e074$exports.bind);
// optional / simple context binding
$54c9964c2c5636b3$exports = function(fn, that) {
    $5f7d5e7ccafe12e0$exports(fn);
    return that === undefined ? fn : $e337c262a4702797$exports ? $54c9964c2c5636b3$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $22872d6ed8de03fa$exports = {};
"use strict";
var $55a97a6fc42d0af6$exports = {};
"use strict";
var $9b96cfe148213656$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$9b96cfe148213656$exports = Array.isArray || function isArray(argument) {
    return $3a0f0fc82e93bd49$exports(argument) === "Array";
};


var $48cebf292a5ff3c8$exports = {};
"use strict";






var $48cebf292a5ff3c8$var$noop = function() {};
var $48cebf292a5ff3c8$var$construct = $e5002032510f09f3$exports("Reflect", "construct");
var $48cebf292a5ff3c8$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $48cebf292a5ff3c8$var$exec = $3d3a3f96d04dfa01$exports($48cebf292a5ff3c8$var$constructorRegExp.exec);
var $48cebf292a5ff3c8$var$INCORRECT_TO_STRING = !$48cebf292a5ff3c8$var$constructorRegExp.test($48cebf292a5ff3c8$var$noop);
var $48cebf292a5ff3c8$var$isConstructorModern = function isConstructor(argument) {
    if (!$e8bca5b64a857b1a$exports(argument)) return false;
    try {
        $48cebf292a5ff3c8$var$construct($48cebf292a5ff3c8$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $48cebf292a5ff3c8$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$e8bca5b64a857b1a$exports(argument)) return false;
    switch($7c3bd6d588abdd5b$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $48cebf292a5ff3c8$var$INCORRECT_TO_STRING || !!$48cebf292a5ff3c8$var$exec($48cebf292a5ff3c8$var$constructorRegExp, $97cff4f00fd83461$exports(argument));
    } catch (error) {
        return true;
    }
};
$48cebf292a5ff3c8$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$48cebf292a5ff3c8$exports = !$48cebf292a5ff3c8$var$construct || $1aa9995203de1dcd$exports(function() {
    var called;
    return $48cebf292a5ff3c8$var$isConstructorModern($48cebf292a5ff3c8$var$isConstructorModern.call) || !$48cebf292a5ff3c8$var$isConstructorModern(Object) || !$48cebf292a5ff3c8$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $48cebf292a5ff3c8$var$isConstructorLegacy : $48cebf292a5ff3c8$var$isConstructorModern;




var $55a97a6fc42d0af6$var$SPECIES = $83f1bf79efdf35c6$exports("species");
var $55a97a6fc42d0af6$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$55a97a6fc42d0af6$exports = function(originalArray) {
    var C;
    if ($9b96cfe148213656$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($48cebf292a5ff3c8$exports(C) && (C === $55a97a6fc42d0af6$var$$Array || $9b96cfe148213656$exports(C.prototype))) C = undefined;
        else if ($d1de49472bdc582c$exports(C)) {
            C = C[$55a97a6fc42d0af6$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $55a97a6fc42d0af6$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$22872d6ed8de03fa$exports = function(originalArray, length) {
    return new ($55a97a6fc42d0af6$exports(originalArray))(length === 0 ? 0 : length);
};


var $f478770b94881111$var$push = $3d3a3f96d04dfa01$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $f478770b94881111$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $476d2ef928fdaf21$exports($this);
        var self = $ef1b385171038d0e$exports(O);
        var length = $b20a724496178f6b$exports(self);
        var boundFunction = $54c9964c2c5636b3$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $22872d6ed8de03fa$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $f478770b94881111$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $f478770b94881111$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$f478770b94881111$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $f478770b94881111$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $f478770b94881111$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $f478770b94881111$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $f478770b94881111$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $f478770b94881111$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $f478770b94881111$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $f478770b94881111$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $f478770b94881111$var$createMethod(7)
};


var $6fee3eb7a9663fdc$require$$filter = $f478770b94881111$exports.filter;
var $9a28a86bebcf0bcb$exports = {};
"use strict";



var $9a28a86bebcf0bcb$var$SPECIES = $83f1bf79efdf35c6$exports("species");
$9a28a86bebcf0bcb$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $b3c67eba05e0aaef$exports >= 51 || !$1aa9995203de1dcd$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$9a28a86bebcf0bcb$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $6fee3eb7a9663fdc$var$HAS_SPECIES_SUPPORT = $9a28a86bebcf0bcb$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$9fd0241d8f6d7609$exports({
    target: "Array",
    proto: true,
    forced: !$6fee3eb7a9663fdc$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $6fee3eb7a9663fdc$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $19aa2a04413c8c38$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$19aa2a04413c8c38$exports = $cf9ad08c1dff0f40$exports ? ({}).toString : function toString() {
    return "[object " + $7c3bd6d588abdd5b$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$cf9ad08c1dff0f40$exports) $1f4601f39377b637$exports(Object.prototype, "toString", $19aa2a04413c8c38$exports, {
    unsafe: true
});


var $d5ae8eb900fc9661$exports = {};
"use strict";

var $fd89d156337cbe43$exports = {};
"use strict";

var $f1a832a591ec8b6f$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $2a7099cc2a66c61f$export$2d1720544b23b823;
"use strict";






$2a7099cc2a66c61f$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports && !$ac4e947f8a7d92c1$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $2d94e296a4d81142$exports(O);
    var props = $4115d950804b1b04$exports(Properties);
    var keys = $d1e3b2f1ebb02e4a$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$ec8f33e5c924d97f$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $6dc10d71896c9c9a$exports = {};
"use strict";

$6dc10d71896c9c9a$exports = $e5002032510f09f3$exports("document", "documentElement");




var $f1a832a591ec8b6f$var$GT = ">";
var $f1a832a591ec8b6f$var$LT = "<";
var $f1a832a591ec8b6f$var$PROTOTYPE = "prototype";
var $f1a832a591ec8b6f$var$SCRIPT = "script";
var $f1a832a591ec8b6f$var$IE_PROTO = $44039bd971d76cb8$exports("IE_PROTO");
var $f1a832a591ec8b6f$var$EmptyConstructor = function() {};
var $f1a832a591ec8b6f$var$scriptTag = function(content) {
    return $f1a832a591ec8b6f$var$LT + $f1a832a591ec8b6f$var$SCRIPT + $f1a832a591ec8b6f$var$GT + content + $f1a832a591ec8b6f$var$LT + "/" + $f1a832a591ec8b6f$var$SCRIPT + $f1a832a591ec8b6f$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($f1a832a591ec8b6f$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f1a832a591ec8b6f$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $416f618c0bbd719b$exports("iframe");
    var JS = "java" + $f1a832a591ec8b6f$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $6dc10d71896c9c9a$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($f1a832a591ec8b6f$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $f1a832a591ec8b6f$var$activeXDocument;
var $f1a832a591ec8b6f$var$NullProtoObject = function() {
    try {
        $f1a832a591ec8b6f$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $f1a832a591ec8b6f$var$NullProtoObject = typeof document != "undefined" ? document.domain && $f1a832a591ec8b6f$var$activeXDocument ? $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX($f1a832a591ec8b6f$var$activeXDocument) // old IE
     : $f1a832a591ec8b6f$var$NullProtoObjectViaIFrame() : $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX($f1a832a591ec8b6f$var$activeXDocument); // WSH
    var length = $05ce5ef981815c5d$exports.length;
    while(length--)delete $f1a832a591ec8b6f$var$NullProtoObject[$f1a832a591ec8b6f$var$PROTOTYPE][$05ce5ef981815c5d$exports[length]];
    return $f1a832a591ec8b6f$var$NullProtoObject();
};
$60b0be22ef1af955$exports[$f1a832a591ec8b6f$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$f1a832a591ec8b6f$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f1a832a591ec8b6f$var$EmptyConstructor[$f1a832a591ec8b6f$var$PROTOTYPE] = $2d94e296a4d81142$exports(O);
        result = new $f1a832a591ec8b6f$var$EmptyConstructor();
        $f1a832a591ec8b6f$var$EmptyConstructor[$f1a832a591ec8b6f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f1a832a591ec8b6f$var$IE_PROTO] = O;
    } else result = $f1a832a591ec8b6f$var$NullProtoObject();
    return Properties === undefined ? result : $2a7099cc2a66c61f$export$2d1720544b23b823(result, Properties);
};



var $fd89d156337cbe43$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
var $fd89d156337cbe43$var$UNSCOPABLES = $83f1bf79efdf35c6$exports("unscopables");
var $fd89d156337cbe43$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($fd89d156337cbe43$var$ArrayPrototype[$fd89d156337cbe43$var$UNSCOPABLES] === undefined) $fd89d156337cbe43$require$defineProperty($fd89d156337cbe43$var$ArrayPrototype, $fd89d156337cbe43$var$UNSCOPABLES, {
    configurable: true,
    value: $f1a832a591ec8b6f$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$fd89d156337cbe43$exports = function(key) {
    $fd89d156337cbe43$var$ArrayPrototype[$fd89d156337cbe43$var$UNSCOPABLES][key] = true;
};


var $909e1f74cd3e640b$exports = {};
"use strict";
$909e1f74cd3e640b$exports = {};




var $d5ae8eb900fc9661$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
var $02a0ce80172aaf1c$exports = {};
"use strict";





var $91064bc7473274b7$exports = {};
"use strict";
var $8682c88b31f9f06f$exports = {};
"use strict";




var $ecb1e81f5eeec8d6$exports = {};
"use strict";




var $e82868213ee2eaaf$exports = {};
"use strict";

$e82868213ee2eaaf$exports = !$1aa9995203de1dcd$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $ecb1e81f5eeec8d6$var$IE_PROTO = $44039bd971d76cb8$exports("IE_PROTO");
var $ecb1e81f5eeec8d6$var$$Object = Object;
var $ecb1e81f5eeec8d6$var$ObjectPrototype = $ecb1e81f5eeec8d6$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$ecb1e81f5eeec8d6$exports = $e82868213ee2eaaf$exports ? $ecb1e81f5eeec8d6$var$$Object.getPrototypeOf : function(O) {
    var object = $476d2ef928fdaf21$exports(O);
    if ($6713471208f796ec$exports(object, $ecb1e81f5eeec8d6$var$IE_PROTO)) return object[$ecb1e81f5eeec8d6$var$IE_PROTO];
    var constructor = object.constructor;
    if ($e8bca5b64a857b1a$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $ecb1e81f5eeec8d6$var$$Object ? $ecb1e81f5eeec8d6$var$ObjectPrototype : null;
};





var $8682c88b31f9f06f$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
var $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $8682c88b31f9f06f$var$IteratorPrototype, $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype, $8682c88b31f9f06f$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $8682c88b31f9f06f$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $8682c88b31f9f06f$var$arrayIterator)) $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype = $ecb1e81f5eeec8d6$exports($ecb1e81f5eeec8d6$exports($8682c88b31f9f06f$var$arrayIterator));
        if ($8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $8682c88b31f9f06f$var$IteratorPrototype = $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $8682c88b31f9f06f$var$NEW_ITERATOR_PROTOTYPE = !$d1de49472bdc582c$exports($8682c88b31f9f06f$var$IteratorPrototype) || $1aa9995203de1dcd$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $8682c88b31f9f06f$var$IteratorPrototype[$8682c88b31f9f06f$var$ITERATOR].call(test) !== test;
});
if ($8682c88b31f9f06f$var$NEW_ITERATOR_PROTOTYPE) $8682c88b31f9f06f$var$IteratorPrototype = {};
else if ($3d49ff5c72fb9ed5$exports) $8682c88b31f9f06f$var$IteratorPrototype = $f1a832a591ec8b6f$exports($8682c88b31f9f06f$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$e8bca5b64a857b1a$exports($8682c88b31f9f06f$var$IteratorPrototype[$8682c88b31f9f06f$var$ITERATOR])) $1f4601f39377b637$exports($8682c88b31f9f06f$var$IteratorPrototype, $8682c88b31f9f06f$var$ITERATOR, function() {
    return this;
});
$8682c88b31f9f06f$exports = {
    IteratorPrototype: $8682c88b31f9f06f$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS
};


var $91064bc7473274b7$require$IteratorPrototype = $8682c88b31f9f06f$exports.IteratorPrototype;


var $0b80283a96aa2f97$exports = {};
"use strict";

var $0b80283a96aa2f97$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;


var $0b80283a96aa2f97$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports("toStringTag");
$0b80283a96aa2f97$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$6713471208f796ec$exports(target, $0b80283a96aa2f97$var$TO_STRING_TAG)) $0b80283a96aa2f97$require$defineProperty(target, $0b80283a96aa2f97$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $91064bc7473274b7$var$returnThis = function() {
    return this;
};
$91064bc7473274b7$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $f1a832a591ec8b6f$exports($91064bc7473274b7$require$IteratorPrototype, {
        next: $2159f71bcf7ac44a$exports(+!ENUMERABLE_NEXT, next)
    });
    $0b80283a96aa2f97$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $909e1f74cd3e640b$exports[TO_STRING_TAG] = $91064bc7473274b7$var$returnThis;
    return IteratorConstructor;
};



var $ddc9e8d80ccd70f7$exports = {};
"use strict";
var $740ef81bf029da08$exports = {};
"use strict";


$740ef81bf029da08$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $3d3a3f96d04dfa01$exports($5f7d5e7ccafe12e0$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $7f8c1fa98367ca50$exports = {};
"use strict";
var $f9d74d6bdac10302$exports = {};
"use strict";

$f9d74d6bdac10302$exports = function(argument) {
    return $d1de49472bdc582c$exports(argument) || argument === null;
};


var $7f8c1fa98367ca50$var$$String = String;
var $7f8c1fa98367ca50$var$$TypeError = TypeError;
$7f8c1fa98367ca50$exports = function(argument) {
    if ($f9d74d6bdac10302$exports(argument)) return argument;
    throw new $7f8c1fa98367ca50$var$$TypeError("Can't set " + $7f8c1fa98367ca50$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$ddc9e8d80ccd70f7$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $740ef81bf029da08$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $938881b1bb81812d$exports(O);
        $7f8c1fa98367ca50$exports(proto);
        if (!$d1de49472bdc582c$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $02a0ce80172aaf1c$var$PROPER_FUNCTION_NAME = $775efe7ab5de3db4$exports.PROPER;
var $02a0ce80172aaf1c$var$CONFIGURABLE_FUNCTION_NAME = $775efe7ab5de3db4$exports.CONFIGURABLE;
var $02a0ce80172aaf1c$var$IteratorPrototype = $8682c88b31f9f06f$exports.IteratorPrototype;
var $02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS = $8682c88b31f9f06f$exports.BUGGY_SAFARI_ITERATORS;
var $02a0ce80172aaf1c$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
var $02a0ce80172aaf1c$var$KEYS = "keys";
var $02a0ce80172aaf1c$var$VALUES = "values";
var $02a0ce80172aaf1c$var$ENTRIES = "entries";
var $02a0ce80172aaf1c$var$returnThis = function() {
    return this;
};
$02a0ce80172aaf1c$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $91064bc7473274b7$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $02a0ce80172aaf1c$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $02a0ce80172aaf1c$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $02a0ce80172aaf1c$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$02a0ce80172aaf1c$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $ecb1e81f5eeec8d6$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$3d49ff5c72fb9ed5$exports && $ecb1e81f5eeec8d6$exports(CurrentIteratorPrototype) !== $02a0ce80172aaf1c$var$IteratorPrototype) {
                if ($ddc9e8d80ccd70f7$exports) $ddc9e8d80ccd70f7$exports(CurrentIteratorPrototype, $02a0ce80172aaf1c$var$IteratorPrototype);
                else if (!$e8bca5b64a857b1a$exports(CurrentIteratorPrototype[$02a0ce80172aaf1c$var$ITERATOR])) $1f4601f39377b637$exports(CurrentIteratorPrototype, $02a0ce80172aaf1c$var$ITERATOR, $02a0ce80172aaf1c$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $0b80283a96aa2f97$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($3d49ff5c72fb9ed5$exports) $909e1f74cd3e640b$exports[TO_STRING_TAG] = $02a0ce80172aaf1c$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($02a0ce80172aaf1c$var$PROPER_FUNCTION_NAME && DEFAULT === $02a0ce80172aaf1c$var$VALUES && nativeIterator && nativeIterator.name !== $02a0ce80172aaf1c$var$VALUES) {
        if (!$3d49ff5c72fb9ed5$exports && $02a0ce80172aaf1c$var$CONFIGURABLE_FUNCTION_NAME) $d13e1e0ab68f4bd6$exports(IterablePrototype, "name", $02a0ce80172aaf1c$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $6e06bffcfb3013e2$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($02a0ce80172aaf1c$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($02a0ce80172aaf1c$var$KEYS),
            entries: getIterationMethod($02a0ce80172aaf1c$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $1f4601f39377b637$exports(IterablePrototype, KEY, methods[KEY]);
        } else $9fd0241d8f6d7609$exports({
            target: NAME,
            proto: true,
            forced: $02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$3d49ff5c72fb9ed5$exports || FORCED) && IterablePrototype[$02a0ce80172aaf1c$var$ITERATOR] !== defaultIterator) $1f4601f39377b637$exports(IterablePrototype, $02a0ce80172aaf1c$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $909e1f74cd3e640b$exports[NAME] = defaultIterator;
    return methods;
};


var $3fa88b2bee851856$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$3fa88b2bee851856$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $d5ae8eb900fc9661$var$ARRAY_ITERATOR = "Array Iterator";
var $d5ae8eb900fc9661$var$setInternalState = $7c2e321de999e766$exports.set;
var $d5ae8eb900fc9661$var$getInternalState = $7c2e321de999e766$exports.getterFor($d5ae8eb900fc9661$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$d5ae8eb900fc9661$exports = $02a0ce80172aaf1c$exports(Array, "Array", function(iterated, kind) {
    $d5ae8eb900fc9661$var$setInternalState(this, {
        type: $d5ae8eb900fc9661$var$ARRAY_ITERATOR,
        target: $4115d950804b1b04$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $d5ae8eb900fc9661$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $3fa88b2bee851856$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $3fa88b2bee851856$exports(index, false);
        case "values":
            return $3fa88b2bee851856$exports(target[index], false);
    }
    return $3fa88b2bee851856$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $d5ae8eb900fc9661$var$values = $909e1f74cd3e640b$exports.Arguments = $909e1f74cd3e640b$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$fd89d156337cbe43$exports("keys");
$fd89d156337cbe43$exports("values");
$fd89d156337cbe43$exports("entries");
// V8 ~ Chrome 45- bug
if (!$3d49ff5c72fb9ed5$exports && $cea8a7c76ccddf5d$exports && $d5ae8eb900fc9661$var$values.name !== "values") try {
    $d5ae8eb900fc9661$require$defineProperty($d5ae8eb900fc9661$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $a971a7ca4b136214$exports = {};
"use strict";




var $a971a7ca4b136214$var$charAt = $3d3a3f96d04dfa01$exports("".charAt);
var $a971a7ca4b136214$var$charCodeAt = $3d3a3f96d04dfa01$exports("".charCodeAt);
var $a971a7ca4b136214$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
var $a971a7ca4b136214$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $5f0738dcc48ec8db$exports($938881b1bb81812d$exports($this));
        var position = $38b1b404f6b944d2$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $a971a7ca4b136214$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $a971a7ca4b136214$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $a971a7ca4b136214$var$charAt(S, position) : first : CONVERT_TO_STRING ? $a971a7ca4b136214$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$a971a7ca4b136214$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $a971a7ca4b136214$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $a971a7ca4b136214$var$createMethod(true)
};


var $958470b00cb61e9e$require$charAt = $a971a7ca4b136214$exports.charAt;




var $958470b00cb61e9e$var$STRING_ITERATOR = "String Iterator";
var $958470b00cb61e9e$var$setInternalState = $7c2e321de999e766$exports.set;
var $958470b00cb61e9e$var$getInternalState = $7c2e321de999e766$exports.getterFor($958470b00cb61e9e$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$02a0ce80172aaf1c$exports(String, "String", function(iterated) {
    $958470b00cb61e9e$var$setInternalState(this, {
        type: $958470b00cb61e9e$var$STRING_ITERATOR,
        string: $5f0738dcc48ec8db$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $958470b00cb61e9e$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $3fa88b2bee851856$exports(undefined, true);
    point = $958470b00cb61e9e$require$charAt(string, index);
    state.index += point.length;
    return $3fa88b2bee851856$exports(point, false);
});


"use strict";
"use strict";
var $9394318a06ff3af6$exports = {};
"use strict";

$9394318a06ff3af6$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $6355bfa194afe709$exports = {};
"use strict";

$6355bfa194afe709$exports = function(target, src, options) {
    for(var key in src)$1f4601f39377b637$exports(target, key, src[key], options);
    return target;
};


var $1bf0be5a866787b4$exports = {};
"use strict";






var $1bf0be5a866787b4$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $a4b9ceb207984515$export$2d1720544b23b823;
"use strict";



var $a4b9ceb207984515$require$$getOwnPropertyNames = $eb3ab2cab8ae8671$export$2d1720544b23b823;
var $29b3e2107a0a7d47$exports = {};
"use strict";

$29b3e2107a0a7d47$exports = $3d3a3f96d04dfa01$exports([].slice);


var $a4b9ceb207984515$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $a4b9ceb207984515$var$getWindowNames = function(it) {
    try {
        return $a4b9ceb207984515$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $29b3e2107a0a7d47$exports($a4b9ceb207984515$var$windowNames);
    }
};
$a4b9ceb207984515$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $a4b9ceb207984515$var$windowNames && $3a0f0fc82e93bd49$exports(it) === "Window" ? $a4b9ceb207984515$var$getWindowNames(it) : $a4b9ceb207984515$require$$getOwnPropertyNames($4115d950804b1b04$exports(it));
};


var $c10701267591785c$exports = {};
"use strict";



var $23173e6b22be4529$exports = {};
"use strict";

$23173e6b22be4529$exports = $1aa9995203de1dcd$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $c10701267591785c$var$$isExtensible = Object.isExtensible;
var $c10701267591785c$var$FAILS_ON_PRIMITIVES = $1aa9995203de1dcd$exports(function() {
    $c10701267591785c$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$c10701267591785c$exports = $c10701267591785c$var$FAILS_ON_PRIMITIVES || $23173e6b22be4529$exports ? function isExtensible(it) {
    if (!$d1de49472bdc582c$exports(it)) return false;
    if ($23173e6b22be4529$exports && $3a0f0fc82e93bd49$exports(it) === "ArrayBuffer") return false;
    return $c10701267591785c$var$$isExtensible ? $c10701267591785c$var$$isExtensible(it) : true;
} : $c10701267591785c$var$$isExtensible;




var $1bf0be5a866787b4$var$REQUIRED = false;
var $1bf0be5a866787b4$var$METADATA = $2ef1f447bc219aea$exports("meta");
var $1bf0be5a866787b4$var$id = 0;
var $1bf0be5a866787b4$var$setMetadata = function(it) {
    $1bf0be5a866787b4$require$defineProperty(it, $1bf0be5a866787b4$var$METADATA, {
        value: {
            objectID: "O" + $1bf0be5a866787b4$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $1bf0be5a866787b4$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$d1de49472bdc582c$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$c10701267591785c$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $1bf0be5a866787b4$var$setMetadata(it);
    // return object ID
    }
    return it[$1bf0be5a866787b4$var$METADATA].objectID;
};
var $1bf0be5a866787b4$var$getWeakData = function(it, create) {
    if (!$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$c10701267591785c$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $1bf0be5a866787b4$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$1bf0be5a866787b4$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $1bf0be5a866787b4$var$onFreeze = function(it) {
    if ($9394318a06ff3af6$exports && $1bf0be5a866787b4$var$REQUIRED && $c10701267591785c$exports(it) && !$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) $1bf0be5a866787b4$var$setMetadata(it);
    return it;
};
var $1bf0be5a866787b4$var$enable = function() {
    $1bf0be5a866787b4$var$meta.enable = function() {};
    $1bf0be5a866787b4$var$REQUIRED = true;
    var getOwnPropertyNames = $eb3ab2cab8ae8671$export$2d1720544b23b823;
    var splice = $3d3a3f96d04dfa01$exports([].splice);
    var test = {};
    test[$1bf0be5a866787b4$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $eb3ab2cab8ae8671$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $1bf0be5a866787b4$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $9fd0241d8f6d7609$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $a4b9ceb207984515$export$2d1720544b23b823
        });
    }
};
var $1bf0be5a866787b4$var$meta = $1bf0be5a866787b4$exports = {
    enable: $1bf0be5a866787b4$var$enable,
    fastKey: $1bf0be5a866787b4$var$fastKey,
    getWeakData: $1bf0be5a866787b4$var$getWeakData,
    onFreeze: $1bf0be5a866787b4$var$onFreeze
};
$60b0be22ef1af955$exports[$1bf0be5a866787b4$var$METADATA] = true;


var $3ea5d594f6193905$exports = {};
"use strict";






var $25ce5bb5ab438b46$exports = {};
"use strict";




var $eca502047a869f63$exports = {};
"use strict";


var $eca502047a869f63$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
var $eca502047a869f63$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$eca502047a869f63$exports = function(it) {
    return it !== undefined && ($909e1f74cd3e640b$exports.Array === it || $eca502047a869f63$var$ArrayPrototype[$eca502047a869f63$var$ITERATOR] === it);
};




var $78e90febc0eb3602$exports = {};
"use strict";




var $a94398be8324ce8e$exports = {};
"use strict";





var $a94398be8324ce8e$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
$a94398be8324ce8e$exports = function(it) {
    if (!$c3e80151589b4ea3$exports(it)) return $af183ff3a7a0320f$exports(it, $a94398be8324ce8e$var$ITERATOR) || $af183ff3a7a0320f$exports(it, "@@iterator") || $909e1f74cd3e640b$exports[$7c3bd6d588abdd5b$exports(it)];
};


var $78e90febc0eb3602$var$$TypeError = TypeError;
$78e90febc0eb3602$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $a94398be8324ce8e$exports(argument) : usingIterator;
    if ($5f7d5e7ccafe12e0$exports(iteratorMethod)) return $2d94e296a4d81142$exports($6e06bffcfb3013e2$exports(iteratorMethod, argument));
    throw new $78e90febc0eb3602$var$$TypeError($0ee3ded6653f158b$exports(argument) + " is not iterable");
};



var $f609df8a24e736f4$exports = {};
"use strict";



$f609df8a24e736f4$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $2d94e296a4d81142$exports(iterator);
    try {
        innerResult = $af183ff3a7a0320f$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $6e06bffcfb3013e2$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $2d94e296a4d81142$exports(innerResult);
    return value;
};


var $25ce5bb5ab438b46$var$$TypeError = TypeError;
var $25ce5bb5ab438b46$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $25ce5bb5ab438b46$var$ResultPrototype = $25ce5bb5ab438b46$var$Result.prototype;
$25ce5bb5ab438b46$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $54c9964c2c5636b3$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $f609df8a24e736f4$exports(iterator, "normal", condition);
        return new $25ce5bb5ab438b46$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $2d94e296a4d81142$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $a94398be8324ce8e$exports(iterable);
        if (!iterFn) throw new $25ce5bb5ab438b46$var$$TypeError($0ee3ded6653f158b$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($eca502047a869f63$exports(iterFn)) {
            for(index = 0, length = $b20a724496178f6b$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $13b911265f6ed62e$exports($25ce5bb5ab438b46$var$ResultPrototype, result)) return result;
            }
            return new $25ce5bb5ab438b46$var$Result(false);
        }
        iterator = $78e90febc0eb3602$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $6e06bffcfb3013e2$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $f609df8a24e736f4$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $13b911265f6ed62e$exports($25ce5bb5ab438b46$var$ResultPrototype, result)) return result;
    }
    return new $25ce5bb5ab438b46$var$Result(false);
};


var $b9104a2e89b56b2e$exports = {};
"use strict";

var $b9104a2e89b56b2e$var$$TypeError = TypeError;
$b9104a2e89b56b2e$exports = function(it, Prototype) {
    if ($13b911265f6ed62e$exports(Prototype, it)) return it;
    throw new $b9104a2e89b56b2e$var$$TypeError("Incorrect invocation");
};






var $3cf092bc463c3983$exports = {};
"use strict";

var $3cf092bc463c3983$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
var $3cf092bc463c3983$var$SAFE_CLOSING = false;
try {
    var $3cf092bc463c3983$var$called = 0;
    var $3cf092bc463c3983$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$3cf092bc463c3983$var$called++
            };
        },
        "return": function() {
            $3cf092bc463c3983$var$SAFE_CLOSING = true;
        }
    };
    $3cf092bc463c3983$var$iteratorWithReturn[$3cf092bc463c3983$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($3cf092bc463c3983$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$3cf092bc463c3983$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$3cf092bc463c3983$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$3cf092bc463c3983$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $89bbd203c6a5945a$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$89bbd203c6a5945a$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $ddc9e8d80ccd70f7$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $e8bca5b64a857b1a$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $d1de49472bdc582c$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $ddc9e8d80ccd70f7$exports($this, NewTargetPrototype);
    return $this;
};


$3ea5d594f6193905$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $0dab403686ae1e63$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $3d3a3f96d04dfa01$exports(NativePrototype[KEY]);
        $1f4601f39377b637$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $889e651c47b82e1d$exports(CONSTRUCTOR_NAME, !$e8bca5b64a857b1a$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1aa9995203de1dcd$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $1bf0be5a866787b4$exports.enable();
    } else if ($889e651c47b82e1d$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1aa9995203de1dcd$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $3cf092bc463c3983$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1aa9995203de1dcd$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $b9104a2e89b56b2e$exports(dummy, NativePrototype);
                var that = $89bbd203c6a5945a$exports(new NativeConstructor(), dummy, Constructor);
                if (!$c3e80151589b4ea3$exports(iterable)) $25ce5bb5ab438b46$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $9fd0241d8f6d7609$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $0b80283a96aa2f97$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $db789142ff971822$exports = {};
"use strict";



var $db789142ff971822$require$getWeakData = $1bf0be5a866787b4$exports.getWeakData;








var $db789142ff971822$var$setInternalState = $7c2e321de999e766$exports.set;
var $db789142ff971822$var$internalStateGetterFor = $7c2e321de999e766$exports.getterFor;
var $db789142ff971822$var$find = $f478770b94881111$exports.find;
var $db789142ff971822$var$findIndex = $f478770b94881111$exports.findIndex;
var $db789142ff971822$var$splice = $3d3a3f96d04dfa01$exports([].splice);
var $db789142ff971822$var$id = 0;
// fallback for uncaught frozen keys
var $db789142ff971822$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $db789142ff971822$var$UncaughtFrozenStore());
};
var $db789142ff971822$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $db789142ff971822$var$findUncaughtFrozen = function(store, key) {
    return $db789142ff971822$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$db789142ff971822$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $db789142ff971822$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$db789142ff971822$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $db789142ff971822$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $db789142ff971822$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $db789142ff971822$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$db789142ff971822$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $b9104a2e89b56b2e$exports(that, Prototype);
            $db789142ff971822$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $db789142ff971822$var$id++,
                frozen: undefined
            });
            if (!$c3e80151589b4ea3$exports(iterable)) $25ce5bb5ab438b46$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $db789142ff971822$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $db789142ff971822$require$getWeakData($2d94e296a4d81142$exports(key), true);
            if (data === true) $db789142ff971822$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $6355bfa194afe709$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$d1de49472bdc582c$exports(key)) return false;
                var data = $db789142ff971822$require$getWeakData(key);
                if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $6713471208f796ec$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$d1de49472bdc582c$exports(key)) return false;
                var data = $db789142ff971822$require$getWeakData(key);
                if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state).has(key);
                return data && $6713471208f796ec$exports(data, state.id);
            }
        });
        $6355bfa194afe709$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($d1de49472bdc582c$exports(key)) {
                    var data = $db789142ff971822$require$getWeakData(key);
                    if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $5bcf798a1bb9c1f7$require$enforceInternalState = $7c2e321de999e766$exports.enforce;


var $5bcf798a1bb9c1f7$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $5bcf798a1bb9c1f7$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $5bcf798a1bb9c1f7$var$isExtensible = $5bcf798a1bb9c1f7$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $5bcf798a1bb9c1f7$var$isFrozen = $5bcf798a1bb9c1f7$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $5bcf798a1bb9c1f7$var$isSealed = $5bcf798a1bb9c1f7$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $5bcf798a1bb9c1f7$var$freeze = $5bcf798a1bb9c1f7$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $5bcf798a1bb9c1f7$var$seal = $5bcf798a1bb9c1f7$var$$Object.seal;
var $5bcf798a1bb9c1f7$var$IS_IE11 = !$0dab403686ae1e63$exports.ActiveXObject && "ActiveXObject" in $0dab403686ae1e63$exports;
var $5bcf798a1bb9c1f7$var$InternalWeakMap;
var $5bcf798a1bb9c1f7$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $5bcf798a1bb9c1f7$var$$WeakMap = $3ea5d594f6193905$exports("WeakMap", $5bcf798a1bb9c1f7$var$wrapper, $db789142ff971822$exports);
var $5bcf798a1bb9c1f7$var$WeakMapPrototype = $5bcf798a1bb9c1f7$var$$WeakMap.prototype;
var $5bcf798a1bb9c1f7$var$nativeSet = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $5bcf798a1bb9c1f7$var$hasMSEdgeFreezingBug = function() {
    return $9394318a06ff3af6$exports && $1aa9995203de1dcd$exports(function() {
        var frozenArray = $5bcf798a1bb9c1f7$var$freeze([]);
        $5bcf798a1bb9c1f7$var$nativeSet(new $5bcf798a1bb9c1f7$var$$WeakMap(), frozenArray, 1);
        return !$5bcf798a1bb9c1f7$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($734e17bc28988288$exports) {
    if ($5bcf798a1bb9c1f7$var$IS_IE11) {
        $5bcf798a1bb9c1f7$var$InternalWeakMap = $db789142ff971822$exports.getConstructor($5bcf798a1bb9c1f7$var$wrapper, "WeakMap", true);
        $1bf0be5a866787b4$exports.enable();
        var $5bcf798a1bb9c1f7$var$nativeDelete = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype["delete"]);
        var $5bcf798a1bb9c1f7$var$nativeHas = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.has);
        var $5bcf798a1bb9c1f7$var$nativeGet = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.get);
        $6355bfa194afe709$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $5bcf798a1bb9c1f7$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $5bcf798a1bb9c1f7$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeHas(this, key) ? $5bcf798a1bb9c1f7$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $5bcf798a1bb9c1f7$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    $5bcf798a1bb9c1f7$var$nativeHas(this, key) ? $5bcf798a1bb9c1f7$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $5bcf798a1bb9c1f7$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($5bcf798a1bb9c1f7$var$hasMSEdgeFreezingBug()) $6355bfa194afe709$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($5bcf798a1bb9c1f7$var$isArray(key)) {
                if ($5bcf798a1bb9c1f7$var$isFrozen(key)) arrayIntegrityLevel = $5bcf798a1bb9c1f7$var$freeze;
                else if ($5bcf798a1bb9c1f7$var$isSealed(key)) arrayIntegrityLevel = $5bcf798a1bb9c1f7$var$seal;
            }
            $5bcf798a1bb9c1f7$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




"use strict";

var $23cbe3e76238b600$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$23cbe3e76238b600$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c2ab62217a756625$exports = {};
"use strict";

var $c2ab62217a756625$var$classList = $416f618c0bbd719b$exports("span").classList;
var $c2ab62217a756625$var$DOMTokenListPrototype = $c2ab62217a756625$var$classList && $c2ab62217a756625$var$classList.constructor && $c2ab62217a756625$var$classList.constructor.prototype;
$c2ab62217a756625$exports = $c2ab62217a756625$var$DOMTokenListPrototype === Object.prototype ? undefined : $c2ab62217a756625$var$DOMTokenListPrototype;






var $143156ca805ae7b0$var$ITERATOR = $83f1bf79efdf35c6$exports("iterator");
var $143156ca805ae7b0$var$ArrayValues = $d5ae8eb900fc9661$exports.values;
var $143156ca805ae7b0$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$143156ca805ae7b0$var$ITERATOR] !== $143156ca805ae7b0$var$ArrayValues) try {
            $d13e1e0ab68f4bd6$exports(CollectionPrototype, $143156ca805ae7b0$var$ITERATOR, $143156ca805ae7b0$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$143156ca805ae7b0$var$ITERATOR] = $143156ca805ae7b0$var$ArrayValues;
        }
        $0b80283a96aa2f97$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($23cbe3e76238b600$exports[COLLECTION_NAME]) for(var METHOD_NAME in $d5ae8eb900fc9661$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $d5ae8eb900fc9661$exports[METHOD_NAME]) try {
                $d13e1e0ab68f4bd6$exports(CollectionPrototype, METHOD_NAME, $d5ae8eb900fc9661$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $d5ae8eb900fc9661$exports[METHOD_NAME];
            }
        }
    }
};
for(var $143156ca805ae7b0$var$COLLECTION_NAME in $23cbe3e76238b600$exports)$143156ca805ae7b0$var$handlePrototype($0dab403686ae1e63$exports[$143156ca805ae7b0$var$COLLECTION_NAME] && $0dab403686ae1e63$exports[$143156ca805ae7b0$var$COLLECTION_NAME].prototype, $143156ca805ae7b0$var$COLLECTION_NAME);
$143156ca805ae7b0$var$handlePrototype($c2ab62217a756625$exports, "DOMTokenList");


var $0d7dfa4a4a0f0c8c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $0d7dfa4a4a0f0c8c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $0d7dfa4a4a0f0c8c$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $0d7dfa4a4a0f0c8c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $0d7dfa4a4a0f0c8c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0d7dfa4a4a0f0c8c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0d7dfa4a4a0f0c8c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0d7dfa4a4a0f0c8c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $0d7dfa4a4a0f0c8c$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $0d7dfa4a4a0f0c8c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0d7dfa4a4a0f0c8c$var$root = $0d7dfa4a4a0f0c8c$var$freeGlobal || $0d7dfa4a4a0f0c8c$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $0d7dfa4a4a0f0c8c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0d7dfa4a4a0f0c8c$var$objectToString = $0d7dfa4a4a0f0c8c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0d7dfa4a4a0f0c8c$var$nativeMax = Math.max, $0d7dfa4a4a0f0c8c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $0d7dfa4a4a0f0c8c$var$now = function() {
    return $0d7dfa4a4a0f0c8c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0d7dfa4a4a0f0c8c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT);
    wait = $0d7dfa4a4a0f0c8c$var$toNumber(wait) || 0;
    if ($0d7dfa4a4a0f0c8c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $0d7dfa4a4a0f0c8c$var$nativeMax($0d7dfa4a4a0f0c8c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $0d7dfa4a4a0f0c8c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $0d7dfa4a4a0f0c8c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($0d7dfa4a4a0f0c8c$var$now());
    }
    function debounced() {
        var time = $0d7dfa4a4a0f0c8c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $0d7dfa4a4a0f0c8c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT);
    if ($0d7dfa4a4a0f0c8c$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $0d7dfa4a4a0f0c8c$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isSymbol(value) {
    return typeof value == "symbol" || $0d7dfa4a4a0f0c8c$var$isObjectLike(value) && $0d7dfa4a4a0f0c8c$var$objectToString.call(value) == $0d7dfa4a4a0f0c8c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0d7dfa4a4a0f0c8c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($0d7dfa4a4a0f0c8c$var$isSymbol(value)) return $0d7dfa4a4a0f0c8c$var$NAN;
    if ($0d7dfa4a4a0f0c8c$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $0d7dfa4a4a0f0c8c$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($0d7dfa4a4a0f0c8c$var$reTrim, "");
    var isBinary = $0d7dfa4a4a0f0c8c$var$reIsBinary.test(value);
    return isBinary || $0d7dfa4a4a0f0c8c$var$reIsOctal.test(value) ? $0d7dfa4a4a0f0c8c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0d7dfa4a4a0f0c8c$var$reIsBadHex.test(value) ? $0d7dfa4a4a0f0c8c$var$NAN : +value;
}
$0d7dfa4a4a0f0c8c$exports = $0d7dfa4a4a0f0c8c$var$throttle;



var $cab391c968b6f1b1$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $cab391c968b6f1b1$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $cab391c968b6f1b1$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $cab391c968b6f1b1$var$funcTag = "[object Function]", $cab391c968b6f1b1$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $cab391c968b6f1b1$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $cab391c968b6f1b1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $cab391c968b6f1b1$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $cab391c968b6f1b1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cab391c968b6f1b1$var$root = $cab391c968b6f1b1$var$freeGlobal || $cab391c968b6f1b1$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $cab391c968b6f1b1$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $cab391c968b6f1b1$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $cab391c968b6f1b1$var$arrayProto = Array.prototype, $cab391c968b6f1b1$var$funcProto = Function.prototype, $cab391c968b6f1b1$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $cab391c968b6f1b1$var$coreJsData = $cab391c968b6f1b1$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $cab391c968b6f1b1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($cab391c968b6f1b1$var$coreJsData && $cab391c968b6f1b1$var$coreJsData.keys && $cab391c968b6f1b1$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $cab391c968b6f1b1$var$funcToString = $cab391c968b6f1b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $cab391c968b6f1b1$var$hasOwnProperty = $cab391c968b6f1b1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cab391c968b6f1b1$var$objectToString = $cab391c968b6f1b1$var$objectProto.toString;
/** Used to detect if a method is native. */ var $cab391c968b6f1b1$var$reIsNative = RegExp("^" + $cab391c968b6f1b1$var$funcToString.call($cab391c968b6f1b1$var$hasOwnProperty).replace($cab391c968b6f1b1$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $cab391c968b6f1b1$var$splice = $cab391c968b6f1b1$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $cab391c968b6f1b1$var$Map = $cab391c968b6f1b1$var$getNative($cab391c968b6f1b1$var$root, "Map"), $cab391c968b6f1b1$var$nativeCreate = $cab391c968b6f1b1$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $cab391c968b6f1b1$var$hashClear() {
    this.__data__ = $cab391c968b6f1b1$var$nativeCreate ? $cab391c968b6f1b1$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$hashGet(key) {
    var data = this.__data__;
    if ($cab391c968b6f1b1$var$nativeCreate) {
        var result = data[key];
        return result === $cab391c968b6f1b1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $cab391c968b6f1b1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$hashHas(key) {
    var data = this.__data__;
    return $cab391c968b6f1b1$var$nativeCreate ? data[key] !== undefined : $cab391c968b6f1b1$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $cab391c968b6f1b1$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $cab391c968b6f1b1$var$nativeCreate && value === undefined ? $cab391c968b6f1b1$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$cab391c968b6f1b1$var$Hash.prototype.clear = $cab391c968b6f1b1$var$hashClear;
$cab391c968b6f1b1$var$Hash.prototype["delete"] = $cab391c968b6f1b1$var$hashDelete;
$cab391c968b6f1b1$var$Hash.prototype.get = $cab391c968b6f1b1$var$hashGet;
$cab391c968b6f1b1$var$Hash.prototype.has = $cab391c968b6f1b1$var$hashHas;
$cab391c968b6f1b1$var$Hash.prototype.set = $cab391c968b6f1b1$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cab391c968b6f1b1$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$listCacheDelete(key) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $cab391c968b6f1b1$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$listCacheGet(key) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$listCacheHas(key) {
    return $cab391c968b6f1b1$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $cab391c968b6f1b1$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$cab391c968b6f1b1$var$ListCache.prototype.clear = $cab391c968b6f1b1$var$listCacheClear;
$cab391c968b6f1b1$var$ListCache.prototype["delete"] = $cab391c968b6f1b1$var$listCacheDelete;
$cab391c968b6f1b1$var$ListCache.prototype.get = $cab391c968b6f1b1$var$listCacheGet;
$cab391c968b6f1b1$var$ListCache.prototype.has = $cab391c968b6f1b1$var$listCacheHas;
$cab391c968b6f1b1$var$ListCache.prototype.set = $cab391c968b6f1b1$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $cab391c968b6f1b1$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $cab391c968b6f1b1$var$Hash,
        "map": new ($cab391c968b6f1b1$var$Map || $cab391c968b6f1b1$var$ListCache),
        "string": new $cab391c968b6f1b1$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$mapCacheDelete(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$mapCacheGet(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$mapCacheHas(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $cab391c968b6f1b1$var$mapCacheSet(key, value) {
    $cab391c968b6f1b1$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$cab391c968b6f1b1$var$MapCache.prototype.clear = $cab391c968b6f1b1$var$mapCacheClear;
$cab391c968b6f1b1$var$MapCache.prototype["delete"] = $cab391c968b6f1b1$var$mapCacheDelete;
$cab391c968b6f1b1$var$MapCache.prototype.get = $cab391c968b6f1b1$var$mapCacheGet;
$cab391c968b6f1b1$var$MapCache.prototype.has = $cab391c968b6f1b1$var$mapCacheHas;
$cab391c968b6f1b1$var$MapCache.prototype.set = $cab391c968b6f1b1$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cab391c968b6f1b1$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($cab391c968b6f1b1$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $cab391c968b6f1b1$var$baseIsNative(value) {
    if (!$cab391c968b6f1b1$var$isObject(value) || $cab391c968b6f1b1$var$isMasked(value)) return false;
    var pattern = $cab391c968b6f1b1$var$isFunction(value) || $cab391c968b6f1b1$var$isHostObject(value) ? $cab391c968b6f1b1$var$reIsNative : $cab391c968b6f1b1$var$reIsHostCtor;
    return pattern.test($cab391c968b6f1b1$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $cab391c968b6f1b1$var$getMapData(map, key) {
    var data = map.__data__;
    return $cab391c968b6f1b1$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $cab391c968b6f1b1$var$getNative(object, key) {
    var value = $cab391c968b6f1b1$var$getValue(object, key);
    return $cab391c968b6f1b1$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $cab391c968b6f1b1$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $cab391c968b6f1b1$var$isMasked(func) {
    return !!$cab391c968b6f1b1$var$maskSrcKey && $cab391c968b6f1b1$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $cab391c968b6f1b1$var$toSource(func) {
    if (func != null) {
        try {
            return $cab391c968b6f1b1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $cab391c968b6f1b1$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($cab391c968b6f1b1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($cab391c968b6f1b1$var$memoize.Cache || $cab391c968b6f1b1$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$cab391c968b6f1b1$var$memoize.Cache = $cab391c968b6f1b1$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $cab391c968b6f1b1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cab391c968b6f1b1$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $cab391c968b6f1b1$var$isObject(value) ? $cab391c968b6f1b1$var$objectToString.call(value) : "";
    return tag == $cab391c968b6f1b1$var$funcTag || tag == $cab391c968b6f1b1$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cab391c968b6f1b1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
$cab391c968b6f1b1$exports = $cab391c968b6f1b1$var$memoize;


var $0dacb699cf7bde6f$export$402e76927ebf6a24 = [];


var $c010ee072a42dfb7$export$63c81bd924f89474 = function() {
    return (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $df335e0168eb6cb4$export$8ca35300535e324d = function() {
    return (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $7fa42eef5f344cd5$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $7fa42eef5f344cd5$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $7fa42eef5f344cd5$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $7fa42eef5f344cd5$var$msg;
    }
    window.dispatchEvent(event);
};



var $cb5f134aaeef814d$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($cb5f134aaeef814d$export$416d111b83cd1483 || ($cb5f134aaeef814d$export$416d111b83cd1483 = {}));


var $4901de7e393b9d46$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $82141eaf453c4dc0$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4901de7e393b9d46$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $3e28b28a8ebee037$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4901de7e393b9d46$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $fe737ba065c58402$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $fe737ba065c58402$export$ee695c13482bb5dd = function(target) {
    if ($fe737ba065c58402$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $fe737ba065c58402$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $fe737ba065c58402$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $3cde5e4b96487237$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $4badd4e08dca187c$var$cache = new WeakMap();
var $4badd4e08dca187c$var$scrollRegexp = /auto|scroll/;
var $4badd4e08dca187c$var$verticalRegexp = /^tb|vertical/;
var $4badd4e08dca187c$var$IE = /msie|trident/i.test((0, $3cde5e4b96487237$export$90b4d2ff6acb88af).navigator && (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).navigator.userAgent);
var $4badd4e08dca187c$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $4badd4e08dca187c$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $82141eaf453c4dc0$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $4badd4e08dca187c$var$zeroBoxes = (0, $4901de7e393b9d46$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $4badd4e08dca187c$var$size(),
    borderBoxSize: $4badd4e08dca187c$var$size(),
    contentBoxSize: $4badd4e08dca187c$var$size(),
    contentRect: new (0, $3e28b28a8ebee037$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $4badd4e08dca187c$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($4badd4e08dca187c$var$cache.has(target) && !forceRecalculation) return $4badd4e08dca187c$var$cache.get(target);
    if ((0, $fe737ba065c58402$export$ee695c13482bb5dd)(target)) {
        $4badd4e08dca187c$var$cache.set(target, $4badd4e08dca187c$var$zeroBoxes);
        return $4badd4e08dca187c$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $fe737ba065c58402$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$4badd4e08dca187c$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $4badd4e08dca187c$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $4badd4e08dca187c$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $4badd4e08dca187c$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $4badd4e08dca187c$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $4badd4e08dca187c$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4901de7e393b9d46$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $4badd4e08dca187c$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $4badd4e08dca187c$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $4badd4e08dca187c$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $3e28b28a8ebee037$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $4badd4e08dca187c$var$cache.set(target, boxes);
    return boxes;
};
var $4badd4e08dca187c$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $4badd4e08dca187c$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $cb5f134aaeef814d$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $cb5f134aaeef814d$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $77fed51082b31934$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $4badd4e08dca187c$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $7cc19e521cfe268c$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $fe737ba065c58402$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $0f4f571233fdcf43$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $77fed51082b31934$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $7cc19e521cfe268c$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $4badd4e08dca187c$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $7fd6a7926b3b3b49$export$9c17b8913a2a3572 = function(depth) {
    (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $7cc19e521cfe268c$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $ca3e4246ee194a0b$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $7fd6a7926b3b3b49$export$9c17b8913a2a3572)(depth);
    while((0, $c010ee072a42dfb7$export$63c81bd924f89474)()){
        depth = (0, $0f4f571233fdcf43$export$9cac928141e5443b)();
        (0, $7fd6a7926b3b3b49$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $df335e0168eb6cb4$export$8ca35300535e324d)()) (0, $7fa42eef5f344cd5$export$888cb69481582149)();
    return depth > 0;
};



var $f766f5a76b58878e$var$trigger;
var $f766f5a76b58878e$var$callbacks = [];
var $f766f5a76b58878e$var$notify = function() {
    return $f766f5a76b58878e$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $f766f5a76b58878e$export$4c995d4933c4abb = function(callback) {
    if (!$f766f5a76b58878e$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $f766f5a76b58878e$var$notify();
        }).observe(el_1, config);
        $f766f5a76b58878e$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $f766f5a76b58878e$var$callbacks.push(callback);
    $f766f5a76b58878e$var$trigger();
};


var $0d378bbf225e6322$export$5755c7b572e34c6 = function(cb) {
    (0, $f766f5a76b58878e$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $a4a922d47d90bbfc$var$watching = 0;
var $a4a922d47d90bbfc$var$isWatching = function() {
    return !!$a4a922d47d90bbfc$var$watching;
};
var $a4a922d47d90bbfc$var$CATCH_PERIOD = 250;
var $a4a922d47d90bbfc$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $a4a922d47d90bbfc$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $a4a922d47d90bbfc$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $a4a922d47d90bbfc$var$scheduled = false;
var $a4a922d47d90bbfc$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $a4a922d47d90bbfc$var$CATCH_PERIOD;
        if ($a4a922d47d90bbfc$var$scheduled) return;
        $a4a922d47d90bbfc$var$scheduled = true;
        var until = $a4a922d47d90bbfc$var$time(timeout);
        (0, $0d378bbf225e6322$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $ca3e4246ee194a0b$export$e54fe5b0f43758f7)();
            } finally{
                $a4a922d47d90bbfc$var$scheduled = false;
                timeout = until - $a4a922d47d90bbfc$var$time();
                if (!$a4a922d47d90bbfc$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $a4a922d47d90bbfc$var$observerConfig);
        };
        document.body ? cb() : (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $a4a922d47d90bbfc$var$events.forEach(function(name) {
                return (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $a4a922d47d90bbfc$var$events.forEach(function(name) {
                return (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $a4a922d47d90bbfc$export$d30788f2c20241cd = new $a4a922d47d90bbfc$var$Scheduler();
var $a4a922d47d90bbfc$export$1f18a74d42722835 = function(n) {
    !$a4a922d47d90bbfc$var$watching && n > 0 && $a4a922d47d90bbfc$export$d30788f2c20241cd.start();
    $a4a922d47d90bbfc$var$watching += n;
    !$a4a922d47d90bbfc$var$watching && $a4a922d47d90bbfc$export$d30788f2c20241cd.stop();
};





var $7ed9adf7c892ac00$var$skipNotifyOnElement = function(target) {
    return !(0, $fe737ba065c58402$export$165b39ed277223c2)(target) && !(0, $fe737ba065c58402$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $7ed9adf7c892ac00$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $cb5f134aaeef814d$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $4badd4e08dca187c$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($7ed9adf7c892ac00$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $ac4ac616c0d885dd$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $ba1dd8e3d068b244$var$observerMap = new WeakMap();
var $ba1dd8e3d068b244$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $ba1dd8e3d068b244$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $ac4ac616c0d885dd$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $ba1dd8e3d068b244$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($ba1dd8e3d068b244$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $7ed9adf7c892ac00$export$fea412043713122)(target, options && options.box));
            (0, $a4a922d47d90bbfc$export$1f18a74d42722835)(1);
            (0, $a4a922d47d90bbfc$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        var index = $ba1dd8e3d068b244$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).splice((0, $0dacb699cf7bde6f$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $a4a922d47d90bbfc$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $16f0ad567ed11238$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $fe737ba065c58402$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $fe737ba065c58402$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






var $baf1d31a374e6aa9$exports = {};
var $baf1d31a374e6aa9$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$baf1d31a374e6aa9$exports = $baf1d31a374e6aa9$var$canUseDOM;


"use strict";

var $4cad6323f88545c7$exports = {};
"use strict";




var $4cad6323f88545c7$var$$TypeError = TypeError;
var $4cad6323f88545c7$var$REDUCE_EMPTY = "Reduce of empty array with no initial value";
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $4cad6323f88545c7$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $476d2ef928fdaf21$exports(that);
        var self = $ef1b385171038d0e$exports(O);
        var length = $b20a724496178f6b$exports(O);
        $5f7d5e7ccafe12e0$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $4cad6323f88545c7$var$$TypeError($4cad6323f88545c7$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $4cad6323f88545c7$var$$TypeError($4cad6323f88545c7$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$4cad6323f88545c7$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $4cad6323f88545c7$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $4cad6323f88545c7$var$createMethod(true)
};


var $ce8468cca1877a4c$require$$reduce = $4cad6323f88545c7$exports.left;
var $dbdccc15ba54ab31$exports = {};
"use strict";

$dbdccc15ba54ab31$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1aa9995203de1dcd$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $26deba2a00e46ecf$exports = {};
"use strict";


$26deba2a00e46ecf$exports = $3a0f0fc82e93bd49$exports($0dab403686ae1e63$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $ce8468cca1877a4c$var$CHROME_BUG = !$26deba2a00e46ecf$exports && $b3c67eba05e0aaef$exports > 79 && $b3c67eba05e0aaef$exports < 83;
var $ce8468cca1877a4c$var$FORCED = $ce8468cca1877a4c$var$CHROME_BUG || !$dbdccc15ba54ab31$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$9fd0241d8f6d7609$exports({
    target: "Array",
    proto: true,
    forced: $ce8468cca1877a4c$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $ce8468cca1877a4c$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $9f1c7421fb321906$exports = {};
"use strict";



var $984691af733d2c6d$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$984691af733d2c6d$exports = function() {
    var that = $2d94e296a4d81142$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $a314baf789497fdc$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $a314baf789497fdc$var$$RegExp = $0dab403686ae1e63$exports.RegExp;
var $a314baf789497fdc$var$UNSUPPORTED_Y = $1aa9995203de1dcd$exports(function() {
    var re = $a314baf789497fdc$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $a314baf789497fdc$var$MISSED_STICKY = $a314baf789497fdc$var$UNSUPPORTED_Y || $1aa9995203de1dcd$exports(function() {
    return !$a314baf789497fdc$var$$RegExp("a", "y").sticky;
});
var $a314baf789497fdc$var$BROKEN_CARET = $a314baf789497fdc$var$UNSUPPORTED_Y || $1aa9995203de1dcd$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $a314baf789497fdc$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$a314baf789497fdc$exports = {
    BROKEN_CARET: $a314baf789497fdc$var$BROKEN_CARET,
    MISSED_STICKY: $a314baf789497fdc$var$MISSED_STICKY,
    UNSUPPORTED_Y: $a314baf789497fdc$var$UNSUPPORTED_Y
};





var $9f1c7421fb321906$require$getInternalState = $7c2e321de999e766$exports.get;
var $5ee76d82519ecf67$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $5ee76d82519ecf67$var$$RegExp = $0dab403686ae1e63$exports.RegExp;
$5ee76d82519ecf67$exports = $1aa9995203de1dcd$exports(function() {
    var re = $5ee76d82519ecf67$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $c1a858f27af5c8fe$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $c1a858f27af5c8fe$var$$RegExp = $0dab403686ae1e63$exports.RegExp;
$c1a858f27af5c8fe$exports = $1aa9995203de1dcd$exports(function() {
    var re = $c1a858f27af5c8fe$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $9f1c7421fb321906$var$nativeReplace = $3231f6153a88e373$exports("native-string-replace", String.prototype.replace);
var $9f1c7421fb321906$var$nativeExec = RegExp.prototype.exec;
var $9f1c7421fb321906$var$patchedExec = $9f1c7421fb321906$var$nativeExec;
var $9f1c7421fb321906$var$charAt = $3d3a3f96d04dfa01$exports("".charAt);
var $9f1c7421fb321906$var$indexOf = $3d3a3f96d04dfa01$exports("".indexOf);
var $9f1c7421fb321906$var$replace = $3d3a3f96d04dfa01$exports("".replace);
var $9f1c7421fb321906$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
var $9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, re1, "a");
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $9f1c7421fb321906$var$UNSUPPORTED_Y = $a314baf789497fdc$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $9f1c7421fb321906$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $9f1c7421fb321906$var$PATCH = $9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG || $9f1c7421fb321906$var$NPCG_INCLUDED || $9f1c7421fb321906$var$UNSUPPORTED_Y || $5ee76d82519ecf67$exports || $c1a858f27af5c8fe$exports;
if ($9f1c7421fb321906$var$PATCH) $9f1c7421fb321906$var$patchedExec = function exec(string) {
    var re = this;
    var state = $9f1c7421fb321906$require$getInternalState(re);
    var str = $5f0738dcc48ec8db$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $9f1c7421fb321906$var$UNSUPPORTED_Y && re.sticky;
    var flags = $6e06bffcfb3013e2$exports($984691af733d2c6d$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $9f1c7421fb321906$var$replace(flags, "y", "");
        if ($9f1c7421fb321906$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $9f1c7421fb321906$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $9f1c7421fb321906$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($9f1c7421fb321906$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $9f1c7421fb321906$var$stringSlice(match.input, charsAdded);
            match[0] = $9f1c7421fb321906$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($9f1c7421fb321906$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $f1a832a591ec8b6f$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$9f1c7421fb321906$exports = $9f1c7421fb321906$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$9fd0241d8f6d7609$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $9f1c7421fb321906$exports
}, {
    exec: $9f1c7421fb321906$exports
});


"use strict";

var $c568811809202a18$exports = {};
"use strict";







var $c568811809202a18$var$SPECIES = $83f1bf79efdf35c6$exports("species");
var $c568811809202a18$var$RegExpPrototype = RegExp.prototype;
$c568811809202a18$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $83f1bf79efdf35c6$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1aa9995203de1dcd$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1aa9995203de1dcd$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$c568811809202a18$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $9f1c7421fb321906$exports || $exec === $c568811809202a18$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $6e06bffcfb3013e2$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $6e06bffcfb3013e2$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $1f4601f39377b637$exports(String.prototype, KEY, methods[0]);
        $1f4601f39377b637$exports($c568811809202a18$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $d13e1e0ab68f4bd6$exports($c568811809202a18$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $892bb45f63d4bd1d$exports = {};
"use strict";

var $892bb45f63d4bd1d$require$charAt = $a971a7ca4b136214$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$892bb45f63d4bd1d$exports = function(S, index, unicode) {
    return index + (unicode ? $892bb45f63d4bd1d$require$charAt(S, index).length : 1);
};


var $5d44a8180af9165c$exports = {};
"use strict";





var $5d44a8180af9165c$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$5d44a8180af9165c$exports = function(R, S) {
    var exec = R.exec;
    if ($e8bca5b64a857b1a$exports(exec)) {
        var result = $6e06bffcfb3013e2$exports(exec, R, S);
        if (result !== null) $2d94e296a4d81142$exports(result);
        return result;
    }
    if ($3a0f0fc82e93bd49$exports(R) === "RegExp") return $6e06bffcfb3013e2$exports($9f1c7421fb321906$exports, R, S);
    throw new $5d44a8180af9165c$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$c568811809202a18$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $938881b1bb81812d$exports(this);
            var matcher = $c3e80151589b4ea3$exports(regexp) ? undefined : $af183ff3a7a0320f$exports(regexp, MATCH);
            return matcher ? $6e06bffcfb3013e2$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($5f0738dcc48ec8db$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $2d94e296a4d81142$exports(this);
            var S = $5f0738dcc48ec8db$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $5d44a8180af9165c$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $5d44a8180af9165c$exports(rx, S)) !== null){
                var matchStr = $5f0738dcc48ec8db$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $892bb45f63d4bd1d$exports(S, $eecf4269159770dc$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";


var $5fade71c8f1274e5$require$FUNCTION_NAME_EXISTS = $775efe7ab5de3db4$exports.EXISTS;

var $23151cf1a26a9a7c$exports = {};
"use strict";


$23151cf1a26a9a7c$exports = function(target, name, descriptor) {
    if (descriptor.get) $d745cb9bd2dfb659$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $d745cb9bd2dfb659$exports(descriptor.set, name, {
        setter: true
    });
    return $ec8f33e5c924d97f$export$2d1720544b23b823(target, name, descriptor);
};


var $5fade71c8f1274e5$var$FunctionPrototype = Function.prototype;
var $5fade71c8f1274e5$var$functionToString = $3d3a3f96d04dfa01$exports($5fade71c8f1274e5$var$FunctionPrototype.toString);
var $5fade71c8f1274e5$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $5fade71c8f1274e5$var$regExpExec = $3d3a3f96d04dfa01$exports($5fade71c8f1274e5$var$nameRE.exec);
var $5fade71c8f1274e5$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($cea8a7c76ccddf5d$exports && !$5fade71c8f1274e5$require$FUNCTION_NAME_EXISTS) $23151cf1a26a9a7c$exports($5fade71c8f1274e5$var$FunctionPrototype, $5fade71c8f1274e5$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $5fade71c8f1274e5$var$regExpExec($5fade71c8f1274e5$var$nameRE, $5fade71c8f1274e5$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $38596fc07635f05a$exports = {};
"use strict";

var $38596fc07635f05a$var$FunctionPrototype = Function.prototype;
var $38596fc07635f05a$var$apply = $38596fc07635f05a$var$FunctionPrototype.apply;
var $38596fc07635f05a$var$call = $38596fc07635f05a$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$38596fc07635f05a$exports = typeof Reflect == "object" && Reflect.apply || ($e337c262a4702797$exports ? $38596fc07635f05a$var$call.bind($38596fc07635f05a$var$apply) : function() {
    return $38596fc07635f05a$var$call.apply($38596fc07635f05a$var$apply, arguments);
});















var $f07126f89ea86001$exports = {};
"use strict";


var $f07126f89ea86001$var$floor = Math.floor;
var $f07126f89ea86001$var$charAt = $3d3a3f96d04dfa01$exports("".charAt);
var $f07126f89ea86001$var$replace = $3d3a3f96d04dfa01$exports("".replace);
var $f07126f89ea86001$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$f07126f89ea86001$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $476d2ef928fdaf21$exports(namedCaptures);
        symbols = $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS;
    }
    return $f07126f89ea86001$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f07126f89ea86001$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $f07126f89ea86001$var$stringSlice(str, 0, position);
            case "'":
                return $f07126f89ea86001$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$f07126f89ea86001$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f07126f89ea86001$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f07126f89ea86001$var$charAt(ch, 1) : captures[f - 1] + $f07126f89ea86001$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $eb0d28d08e5ca469$var$REPLACE = $83f1bf79efdf35c6$exports("replace");
var $eb0d28d08e5ca469$var$max = Math.max;
var $eb0d28d08e5ca469$var$min = Math.min;
var $eb0d28d08e5ca469$var$concat = $3d3a3f96d04dfa01$exports([].concat);
var $eb0d28d08e5ca469$var$push = $3d3a3f96d04dfa01$exports([].push);
var $eb0d28d08e5ca469$var$stringIndexOf = $3d3a3f96d04dfa01$exports("".indexOf);
var $eb0d28d08e5ca469$var$stringSlice = $3d3a3f96d04dfa01$exports("".slice);
var $eb0d28d08e5ca469$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $eb0d28d08e5ca469$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$eb0d28d08e5ca469$var$REPLACE]) return /./[$eb0d28d08e5ca469$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $eb0d28d08e5ca469$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1aa9995203de1dcd$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$c568811809202a18$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $938881b1bb81812d$exports(this);
            var replacer = $c3e80151589b4ea3$exports(searchValue) ? undefined : $af183ff3a7a0320f$exports(searchValue, $eb0d28d08e5ca469$var$REPLACE);
            return replacer ? $6e06bffcfb3013e2$exports(replacer, searchValue, O, replaceValue) : $6e06bffcfb3013e2$exports(nativeReplace, $5f0738dcc48ec8db$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $2d94e296a4d81142$exports(this);
            var S = $5f0738dcc48ec8db$exports(string);
            if (typeof replaceValue == "string" && $eb0d28d08e5ca469$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $eb0d28d08e5ca469$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $e8bca5b64a857b1a$exports(replaceValue);
            if (!functionalReplace) replaceValue = $5f0738dcc48ec8db$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $5d44a8180af9165c$exports(rx, S);
                if (result === null) break;
                $eb0d28d08e5ca469$var$push(results, result);
                if (!global) break;
                var matchStr = $5f0738dcc48ec8db$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $892bb45f63d4bd1d$exports(S, $eecf4269159770dc$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $5f0738dcc48ec8db$exports(result[0]);
                var position = $eb0d28d08e5ca469$var$max($eb0d28d08e5ca469$var$min($38b1b404f6b944d2$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$eb0d28d08e5ca469$var$push(captures, $eb0d28d08e5ca469$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $eb0d28d08e5ca469$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $eb0d28d08e5ca469$var$push(replacerArgs, namedCaptures);
                    replacement = $5f0738dcc48ec8db$exports($38596fc07635f05a$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $f07126f89ea86001$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $eb0d28d08e5ca469$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $eb0d28d08e5ca469$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$eb0d28d08e5ca469$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$eb0d28d08e5ca469$var$REPLACE_KEEPS_$0 || $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $97c917368b9e49ce$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $97c917368b9e49ce$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $97c917368b9e49ce$var$cachedScrollbarWidth = null;
var $97c917368b9e49ce$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($baf1d31a374e6aa9$exports))) window.addEventListener("resize", function() {
    if ($97c917368b9e49ce$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $97c917368b9e49ce$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $97c917368b9e49ce$var$cachedScrollbarWidth = null;
    }
});
function $97c917368b9e49ce$var$scrollbarWidth(el) {
    if ($97c917368b9e49ce$var$cachedScrollbarWidth === null) {
        var document1 = $97c917368b9e49ce$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $97c917368b9e49ce$var$cachedScrollbarWidth = 0;
            return $97c917368b9e49ce$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $97c917368b9e49ce$var$cachedScrollbarWidth = width;
    }
    return $97c917368b9e49ce$var$cachedScrollbarWidth;
}
var $97c917368b9e49ce$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $97c917368b9e49ce$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $97c917368b9e49ce$var$getElementDocument(_this.el);
            var elWindow = $97c917368b9e49ce$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($0d7dfa4a4a0f0c8c$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($0d7dfa4a4a0f0c8c$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($cab391c968b6f1b1$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $97c917368b9e49ce$var$getElementDocument(el);
        var elWindow = $97c917368b9e49ce$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($baf1d31a374e6aa9$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $16f0ad567ed11238$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $97c917368b9e49ce$var$getElementDocument(this.el);
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $97c917368b9e49ce$var$scrollbarWidth(this.el);
        } catch (e) {
            return $97c917368b9e49ce$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$97c917368b9e49ce$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$97c917368b9e49ce$var$SimpleBar.instances = new WeakMap();
var $97c917368b9e49ce$export$2e2bcd8739ae039 = $97c917368b9e49ce$var$SimpleBar;


function $bbbd8fadaf5f7664$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbbd8fadaf5f7664$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbbd8fadaf5f7664$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbbd8fadaf5f7664$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbbd8fadaf5f7664$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbbd8fadaf5f7664$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbbd8fadaf5f7664$var$_extends() {
    $bbbd8fadaf5f7664$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbbd8fadaf5f7664$var$_extends.apply(this, arguments);
}
function $bbbd8fadaf5f7664$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bbbd8fadaf5f7664$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbbd8fadaf5f7664$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $bbbd8fadaf5f7664$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $bbbd8fadaf5f7664$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $bbbd8fadaf5f7664$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? "div" : _ref$tag, otherProps = $bbbd8fadaf5f7664$var$_objectWithoutProperties(_ref, $bbbd8fadaf5f7664$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $dup7A.useRef)();
    var elRef = (0, $dup7A.useRef)();
    var contentNodeRef = (0, $dup7A.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $97c917368b9e49ce$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== "data-simplebar-direction") deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' \u2014> 'autoHide=\"false\"'\n      ");
    (0, $dup7A.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $97c917368b9e49ce$export$2e2bcd8739ae039)(elRef.current, $bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2({}, $bbbd8fadaf5f7664$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === "function") ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === "function") ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(RootTag, $bbbd8fadaf5f7664$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === "function" ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", $bbbd8fadaf5f7664$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$bbbd8fadaf5f7664$var$SimpleBar.displayName = "SimpleBar";
$bbbd8fadaf5f7664$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string
};
var $bbbd8fadaf5f7664$export$2e2bcd8739ae039 = $bbbd8fadaf5f7664$var$SimpleBar;



var $0535cdc15230b38d$exports = {};

$parcel$defineInteropFlag($0535cdc15230b38d$exports);

$parcel$export($0535cdc15230b38d$exports, "default", () => $0535cdc15230b38d$export$2e2bcd8739ae039);
function $c2186ff521b340c0$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $c2186ff521b340c0$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $c2186ff521b340c0$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $c2186ff521b340c0$var$e(r.overflowY, n) || $c2186ff521b340c0$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $c2186ff521b340c0$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $c2186ff521b340c0$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$c2186ff521b340c0$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $c2186ff521b340c0$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $c2186ff521b340c0$var$n(m) && !$c2186ff521b340c0$var$n(document.documentElement) || null != m && $c2186ff521b340c0$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $c2186ff521b340c0$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $c2186ff521b340c0$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $c2186ff521b340c0$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $c2186ff521b340c0$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $ec6949d09184329a$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $ec6949d09184329a$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = "auto";
    var canSmoothScroll = "scrollBehavior" in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $ec6949d09184329a$var$getOptions(options) {
    if (options === false) return {
        block: "end",
        inline: "nearest"
    };
    if ($ec6949d09184329a$var$isOptionsObject(options)) return options;
    return {
        block: "start",
        inline: "nearest"
    };
}
function $ec6949d09184329a$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($ec6949d09184329a$var$isOptionsObject(options) && typeof options.behavior === "function") return options.behavior(isTargetAttached ? (0, $c2186ff521b340c0$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $ec6949d09184329a$var$getOptions(options);
    return $ec6949d09184329a$var$defaultBehavior((0, $c2186ff521b340c0$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $ec6949d09184329a$export$2e2bcd8739ae039 = $ec6949d09184329a$var$scrollIntoView;


var $0535cdc15230b38d$var$memoizedNow;
var $0535cdc15230b38d$var$now = function now() {
    if (!$0535cdc15230b38d$var$memoizedNow) $0535cdc15230b38d$var$memoizedNow = "performance" in window ? performance.now.bind(performance) : Date.now;
    return $0535cdc15230b38d$var$memoizedNow();
};
function $0535cdc15230b38d$var$step(context) {
    var time = $0535cdc15230b38d$var$now();
    var elapsed = Math.min((time - context.startTime) / context.duration, 1);
    var value = context.ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) requestAnimationFrame(function() {
        return $0535cdc15230b38d$var$step(context);
    });
    else context.cb();
}
function $0535cdc15230b38d$var$smoothScroll(el, x, y, duration, ease, cb) {
    if (duration === void 0) duration = 600;
    if (ease === void 0) ease = function ease(t) {
        return 1 + --t * t * t * t * t;
    };
    var scrollable;
    var startX;
    var startY;
    var method;
    scrollable = el;
    startX = el.scrollLeft;
    startY = el.scrollTop;
    method = function method(x, y) {
        el.scrollLeft = Math.ceil(x);
        el.scrollTop = Math.ceil(y);
    };
    $0535cdc15230b38d$var$step({
        scrollable: scrollable,
        method: method,
        startTime: $0535cdc15230b38d$var$now(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
    });
}
var $0535cdc15230b38d$var$shouldSmoothScroll = function shouldSmoothScroll(options) {
    return options && !options.behavior || options.behavior === "smooth";
};
function $0535cdc15230b38d$var$scroll(target, options) {
    var overrides = options || {};
    if ($0535cdc15230b38d$var$shouldSmoothScroll(overrides)) return (0, $ec6949d09184329a$export$2e2bcd8739ae039)(target, {
        block: overrides.block,
        inline: overrides.inline,
        scrollMode: overrides.scrollMode,
        boundary: overrides.boundary,
        behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function(results, _ref) {
                var el = _ref.el, left = _ref.left, top = _ref.top;
                var startLeft = el.scrollLeft;
                var startTop = el.scrollTop;
                if (startLeft === left && startTop === top) return results;
                return [].concat(results, [
                    new Promise(function(resolve) {
                        return $0535cdc15230b38d$var$smoothScroll(el, left, top, overrides.duration, overrides.ease, function() {
                            return resolve({
                                el: el,
                                left: [
                                    startLeft,
                                    left
                                ],
                                top: [
                                    startTop,
                                    top
                                ]
                            });
                        });
                    })
                ]);
            }, []));
        }
    });
    return Promise.resolve((0, $ec6949d09184329a$export$2e2bcd8739ae039)(target, options));
}
var $0535cdc15230b38d$var$smoothScrollIntoView = $0535cdc15230b38d$var$scroll;
var $0535cdc15230b38d$export$2e2bcd8739ae039 = $0535cdc15230b38d$var$smoothScrollIntoView;


var $53eb3904070cf0e9$exports = {};

$parcel$defineInteropFlag($53eb3904070cf0e9$exports);

$parcel$export($53eb3904070cf0e9$exports, "default", () => $53eb3904070cf0e9$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "Range", () => $51730a1a5a927869$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "Handle", () => $be7cb93b822a2be3$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "createSliderWithTooltip", () => $dadbd822db857fd1$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "SliderTooltip", () => $ee63ddd70979cae1$export$2e2bcd8739ae039);
function $d4e0dd4084a38c17$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d4e0dd4084a38c17$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d4e0dd4084a38c17$export$2e2bcd8739ae039(o);
}



function $6ab36d11786c9caa$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a589a0dff6ad512d$export$2e2bcd8739ae039(t) {
    var i = (0, $6ab36d11786c9caa$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $5e86d015ad96e244$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $a589a0dff6ad512d$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a24d5fade17372a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a24d5fade17372a9$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a24d5fade17372a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a24d5fade17372a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $3a625298bae21416$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $a874d781bdb225e2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $a589a0dff6ad512d$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $a874d781bdb225e2$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $a874d781bdb225e2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a874d781bdb225e2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $8355d769ce7c2a91$export$2e2bcd8739ae039(o, p) {
    $8355d769ce7c2a91$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8355d769ce7c2a91$export$2e2bcd8739ae039(o, p);
}


function $080b772b018ceec5$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $8355d769ce7c2a91$export$2e2bcd8739ae039)(subClass, superClass);
}


function $61e83c07e8369f96$export$2e2bcd8739ae039(o) {
    $61e83c07e8369f96$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $61e83c07e8369f96$export$2e2bcd8739ae039(o);
}


function $172b16760aa26608$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($172b16760aa26608$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $e3cc1c0a9f4b2276$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $d47c8bc3fef6940e$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(self);
}


function $b608e4f8b4c613fa$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $172b16760aa26608$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $d47c8bc3fef6940e$export$2e2bcd8739ae039)(this, result);
    };
}



var $dup7A = parcelRequire("dup7A");
/* eslint-disable no-console */ var $b4cde5d547cd3626$var$warned = {};
var $b4cde5d547cd3626$var$preWarningFns = [];
var $b4cde5d547cd3626$export$61616f168f0e5a05 = function preMessage(fn) {
    $b4cde5d547cd3626$var$preWarningFns.push(fn);
};
function $b4cde5d547cd3626$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $b4cde5d547cd3626$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $b4cde5d547cd3626$export$60eef1277fe463e4() {
    $b4cde5d547cd3626$var$warned = {};
}
function $b4cde5d547cd3626$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$b4cde5d547cd3626$var$warned[message]) {
        method(false, message);
        $b4cde5d547cd3626$var$warned[message] = true;
    }
}
function $b4cde5d547cd3626$export$82934adf09101657(valid, message) {
    $b4cde5d547cd3626$export$848feb93d8f32b9b($b4cde5d547cd3626$export$491112666e282270, valid, message);
}
function $b4cde5d547cd3626$export$89ff31684837bbbf(valid, message) {
    $b4cde5d547cd3626$export$848feb93d8f32b9b($b4cde5d547cd3626$export$a92e4c44d367d0af, valid, message);
}
$b4cde5d547cd3626$export$82934adf09101657.preMessage = $b4cde5d547cd3626$export$61616f168f0e5a05;
$b4cde5d547cd3626$export$82934adf09101657.resetWarned = $b4cde5d547cd3626$export$60eef1277fe463e4;
$b4cde5d547cd3626$export$82934adf09101657.noteOnce = $b4cde5d547cd3626$export$89ff31684837bbbf;
var $b4cde5d547cd3626$export$2e2bcd8739ae039 = $b4cde5d547cd3626$export$82934adf09101657;





var $dup7A = parcelRequire("dup7A");
var $f07294755a4ae8ec$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? "top" : "bottom", "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? "bottom" : "top", "auto"), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? "right" : "left", "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? "left" : "right", "auto"), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $f07294755a4ae8ec$export$2e2bcd8739ae039 = $f07294755a4ae8ec$var$Track;



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");
function $fa75eafa4826b919$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $bGxpK.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




function $16c689bb2fdde618$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $81b0cb243c7b4cf3$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(arr);
}


function $435b24fe7d07ab67$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $89db58488ac3ca79$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(o, minLen);
}


function $d07b6f6a0afb23c8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $39333a40da2a8fa5$export$2e2bcd8739ae039(arr) {
    return (0, $81b0cb243c7b4cf3$export$2e2bcd8739ae039)(arr) || (0, $435b24fe7d07ab67$export$2e2bcd8739ae039)(arr) || (0, $89db58488ac3ca79$export$2e2bcd8739ae039)(arr) || (0, $d07b6f6a0afb23c8$export$2e2bcd8739ae039)();
}





function $3d90446364da0005$export$2e2bcd8739ae039(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(object);
        if (object === null) break;
    }
    return object;
}


function $66e3be070267ec34$export$2e2bcd8739ae039() {
    if (typeof Reflect !== "undefined" && Reflect.get) $66e3be070267ec34$export$2e2bcd8739ae039 = Reflect.get.bind();
    else $66e3be070267ec34$export$2e2bcd8739ae039 = function _get(target, property, receiver) {
        var base = (0, $3d90446364da0005$export$2e2bcd8739ae039)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $66e3be070267ec34$export$2e2bcd8739ae039.apply(this, arguments);
}






var $dup7A = parcelRequire("dup7A");

function $d43892da47566d6b$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $10902e23ce058af7$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $10902e23ce058af7$exports) {
        classNames.default = classNames;
        $10902e23ce058af7$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $dup7A = parcelRequire("dup7A");


var $cd4751ba8c486af3$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(dots ? step > 0 : true, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $cd4751ba8c486af3$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $cd4751ba8c486af3$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, reverse ? "top" : "bottom", offset)) : (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, reverse ? "right" : "left", offset));
        if (isActived) style = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $cd4751ba8c486af3$export$2e2bcd8739ae039 = $cd4751ba8c486af3$var$Steps;






var $dup7A = parcelRequire("dup7A");

var $3350efbd2aeb48ae$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(markPoint) === "object" && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({
            marginBottom: "-50%"
        }, reverse ? "top" : "bottom", "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? "right" : "left", "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: className
    }, elements);
};
var $3350efbd2aeb48ae$export$2e2bcd8739ae039 = $3350efbd2aeb48ae$var$Marks;



var $3G4eg = parcelRequire("3G4eg");








var $dup7A = parcelRequire("dup7A");


var $be7cb93b822a2be3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(document, "mouseup", this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(this.props.className, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? "top" : "bottom", "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? "bottom" : "top", "auto"), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? "right" : "left", "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? "left" : "right", "auto"), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? "+" : "-", "50%)")), _ref2);
                var elStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", (0, $3G4eg.default)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $46d04450f94a049c$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $46d04450f94a049c$var$KeyCode.F1 && keyCode <= $46d04450f94a049c$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $46d04450f94a049c$var$KeyCode.ALT:
            case $46d04450f94a049c$var$KeyCode.CAPS_LOCK:
            case $46d04450f94a049c$var$KeyCode.CONTEXT_MENU:
            case $46d04450f94a049c$var$KeyCode.CTRL:
            case $46d04450f94a049c$var$KeyCode.DOWN:
            case $46d04450f94a049c$var$KeyCode.END:
            case $46d04450f94a049c$var$KeyCode.ESC:
            case $46d04450f94a049c$var$KeyCode.HOME:
            case $46d04450f94a049c$var$KeyCode.INSERT:
            case $46d04450f94a049c$var$KeyCode.LEFT:
            case $46d04450f94a049c$var$KeyCode.MAC_FF_META:
            case $46d04450f94a049c$var$KeyCode.META:
            case $46d04450f94a049c$var$KeyCode.NUMLOCK:
            case $46d04450f94a049c$var$KeyCode.NUM_CENTER:
            case $46d04450f94a049c$var$KeyCode.PAGE_DOWN:
            case $46d04450f94a049c$var$KeyCode.PAGE_UP:
            case $46d04450f94a049c$var$KeyCode.PAUSE:
            case $46d04450f94a049c$var$KeyCode.PRINT_SCREEN:
            case $46d04450f94a049c$var$KeyCode.RIGHT:
            case $46d04450f94a049c$var$KeyCode.SHIFT:
            case $46d04450f94a049c$var$KeyCode.UP:
            case $46d04450f94a049c$var$KeyCode.WIN_KEY:
            case $46d04450f94a049c$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $46d04450f94a049c$var$KeyCode.ZERO && keyCode <= $46d04450f94a049c$var$KeyCode.NINE) return true;
        if (keyCode >= $46d04450f94a049c$var$KeyCode.NUM_ZERO && keyCode <= $46d04450f94a049c$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $46d04450f94a049c$var$KeyCode.A && keyCode <= $46d04450f94a049c$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $46d04450f94a049c$var$KeyCode.SPACE:
            case $46d04450f94a049c$var$KeyCode.QUESTION_MARK:
            case $46d04450f94a049c$var$KeyCode.NUM_PLUS:
            case $46d04450f94a049c$var$KeyCode.NUM_MINUS:
            case $46d04450f94a049c$var$KeyCode.NUM_PERIOD:
            case $46d04450f94a049c$var$KeyCode.NUM_DIVISION:
            case $46d04450f94a049c$var$KeyCode.SEMICOLON:
            case $46d04450f94a049c$var$KeyCode.DASH:
            case $46d04450f94a049c$var$KeyCode.EQUALS:
            case $46d04450f94a049c$var$KeyCode.COMMA:
            case $46d04450f94a049c$var$KeyCode.PERIOD:
            case $46d04450f94a049c$var$KeyCode.SLASH:
            case $46d04450f94a049c$var$KeyCode.APOSTROPHE:
            case $46d04450f94a049c$var$KeyCode.SINGLE_QUOTE:
            case $46d04450f94a049c$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $46d04450f94a049c$var$KeyCode.BACKSLASH:
            case $46d04450f94a049c$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $46d04450f94a049c$export$2e2bcd8739ae039 = $46d04450f94a049c$var$KeyCode;


function $466699104c68908f$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $e10f5070fc836746$exports.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $466699104c68908f$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $466699104c68908f$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === "touchend" && e.touches.length > 0;
}
function $466699104c68908f$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $466699104c68908f$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(diffs)))];
}
function $466699104c68908f$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf(".") >= 0) precision = stepString.length - stepString.indexOf(".") - 1;
    return precision;
}
function $466699104c68908f$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $466699104c68908f$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $466699104c68908f$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $466699104c68908f$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $466699104c68908f$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($466699104c68908f$export$e3e031d5dec39373(val, props)) ? $466699104c68908f$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($466699104c68908f$export$e0c74b50bbd10f68(step)));
}
function $466699104c68908f$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $466699104c68908f$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = "increase";
    var decrease = "decrease";
    var method = increase;
    switch(e.keyCode){
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $466699104c68908f$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $8d0aebb38e624949$var$noop() {}
function $8d0aebb38e624949$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $466699104c68908f$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $466699104c68908f$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($466699104c68908f$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $466699104c68908f$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $466699104c68908f$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $466699104c68908f$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($466699104c68908f$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $466699104c68908f$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, "touchmove", this.onTouchMove);
                    this.onTouchUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, "touchend", this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, "mousemove", this.onMouseMove);
                    this.onMouseUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, "mouseup", this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, (_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $8d0aebb38e624949$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $8d0aebb38e624949$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $8d0aebb38e624949$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $8d0aebb38e624949$var$noop : this.onKeyDown,
                        onFocus: disabled ? $8d0aebb38e624949$var$noop : this.onFocus,
                        onBlur: disabled ? $8d0aebb38e624949$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $cd4751ba8c486af3$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $3350efbd2aeb48ae$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $8d0aebb38e624949$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: "rc-slider",
        className: "",
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $be7cb93b822a2be3$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $8d0aebb38e624949$var$noop,
        onChange: $8d0aebb38e624949$var$noop,
        onAfterChange: $8d0aebb38e624949$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $ceac921ac672c792$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!("minimumTrackStyle" in props), "minimumTrackStyle will be deprecated, please use trackStyle instead.");
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!("maximumTrackStyle" in props), "maximumTrackStyle will be deprecated, please use railStyle instead.");
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!("min" in this.props || "max" in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $466699104c68908f$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                var nextState = state.value > this.props.max ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $466699104c68908f$export$65e4339c6f9d8d24(v, mergedProps);
                return $466699104c68908f$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f07294755a4ae8ec$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
var $ceac921ac672c792$export$2e2bcd8739ae039 = (0, $8d0aebb38e624949$export$2e2bcd8739ae039)($ceac921ac672c792$var$Slider);










var $dup7A = parcelRequire("dup7A");




var $51730a1a5a927869$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $466699104c68908f$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $466699104c68908f$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $51730a1a5a927869$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = "defaultValue" in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $51730a1a5a927869$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!("min" in this.props || "max" in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $466699104c68908f$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $466699104c68908f$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        "handle",
                        "recent"
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $51730a1a5a927869$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $51730a1a5a927869$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f07294755a4ae8ec$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!("value" in props || "min" in props || "max" in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $51730a1a5a927869$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $51730a1a5a927869$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
/* eslint-enable */ $51730a1a5a927869$var$Range.displayName = "Range";
$51730a1a5a927869$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $51730a1a5a927869$export$2e2bcd8739ae039 = (0, $8d0aebb38e624949$export$2e2bcd8739ae039)($51730a1a5a927869$var$Range);




var $3G4eg = parcelRequire("3G4eg");








var $dup7A = parcelRequire("dup7A");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $3G4eg = parcelRequire("3G4eg");




var $dup7A = parcelRequire("dup7A");


var $3G4eg = parcelRequire("3G4eg");







var $dup7A = parcelRequire("dup7A");

var $5ae5867a877ffabb$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $5ae5867a877ffabb$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $5ae5867a877ffabb$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $5ae5867a877ffabb$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $5ae5867a877ffabb$var$rafUUID = 0;
var $5ae5867a877ffabb$var$rafIds = new Map();
function $5ae5867a877ffabb$var$cleanup(id) {
    $5ae5867a877ffabb$var$rafIds.delete(id);
}
var $5ae5867a877ffabb$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $5ae5867a877ffabb$var$rafUUID += 1;
    var id = $5ae5867a877ffabb$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $5ae5867a877ffabb$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $5ae5867a877ffabb$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $5ae5867a877ffabb$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$5ae5867a877ffabb$var$wrapperRaf.cancel = function(id) {
    var realId = $5ae5867a877ffabb$var$rafIds.get(id);
    $5ae5867a877ffabb$var$cleanup(id);
    return $5ae5867a877ffabb$var$caf(realId);
};
var $5ae5867a877ffabb$export$2e2bcd8739ae039 = $5ae5867a877ffabb$var$wrapperRaf;


function $01802a99afaa475f$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}



var $dup7A = parcelRequire("dup7A");

function $0b6fbe60488ddcee$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $0b6fbe60488ddcee$export$2e2bcd8739ae039(node) {
    if ($0b6fbe60488ddcee$export$41e30d8dd0ba7a50(node)) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode(node);
    return null;
}




var $dup7A = parcelRequire("dup7A");

var $8vAu6 = parcelRequire("8vAu6");

var $dup7A = parcelRequire("dup7A");
function $b1fb345e1a36d9ef$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $dup7A.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


var $c8cde685aa40b754$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
};
var $c8cde685aa40b754$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $c8cde685aa40b754$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $c8cde685aa40b754$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $b1fb345e1a36d9ef$export$2e2bcd8739ae039)(function() {
        return $c8cde685aa40b754$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $c8cde685aa40b754$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $8vAu6.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $8vAu6.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $8vAu6.ForwardRef)) return false;
    return true;
};
var $c8cde685aa40b754$export$b51ae67c7882a242 = function supportNodeRef(node) {
    if (!/*#__PURE__*/ (0, $dup7A.isValidElement)(node)) return false;
    if ((0, $8vAu6.isFragment)(node)) return false;
    return $c8cde685aa40b754$export$c1cec34af06bcf7(node);
};




var $dup7A = parcelRequire("dup7A");

function $f3764e1170c3ee8f$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


var $8397b35ed6f4f5c4$var$Portal = /*#__PURE__*/ (0, $dup7A.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $dup7A.useRef)();
    var containerRef = (0, $dup7A.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $dup7A.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $dup7A.useRef)(false);
    if (!initRef.current && (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $dup7A.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $dup7A.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).createPortal(children, containerRef.current) : null;
});
var $8397b35ed6f4f5c4$export$2e2bcd8739ae039 = $8397b35ed6f4f5c4$var$Portal;




function $a0e16b2c473f8d53$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $a0e16b2c473f8d53$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $a0e16b2c473f8d53$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($a0e16b2c473f8d53$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}



var $3G4eg = parcelRequire("3G4eg");

function $48106157825ba7ff$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $db1311aef62f1ccf$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $e9de5687f3ef30e0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e3c5c95746af2d29$export$2e2bcd8739ae039(arr, i) {
    return (0, $48106157825ba7ff$export$2e2bcd8739ae039)(arr) || (0, $db1311aef62f1ccf$export$2e2bcd8739ae039)(arr, i) || (0, $89db58488ac3ca79$export$2e2bcd8739ae039)(arr, i) || (0, $e9de5687f3ef30e0$export$2e2bcd8739ae039)();
}




var $dup7A = parcelRequire("dup7A");
var $cee396e5c47a9a3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $3G4eg = parcelRequire("3G4eg");


var $dup7A = parcelRequire("dup7A");









var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
var $f60a304f067cf82f$var$_excluded = [
    "children"
];
var $f60a304f067cf82f$export$841858b892ce1f4c = /*#__PURE__*/ $dup7A.createContext({});
function $f60a304f067cf82f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, $f60a304f067cf82f$var$_excluded);
    return /*#__PURE__*/ $dup7A.createElement($f60a304f067cf82f$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $dup7A = parcelRequire("dup7A");
var $eeeff6bdc66797b8$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($dup7A.Component);
var $eeeff6bdc66797b8$export$2e2bcd8739ae039 = $eeeff6bdc66797b8$var$DomWrapper;







var $dup7A = parcelRequire("dup7A");
function $c8504fa916dc6fc0$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $dup7A.useRef(false);
    var _React$useState = $dup7A.useState(defaultValue), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $dup7A.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}



var $dup7A = parcelRequire("dup7A");
var $7b9ba249efe2d2c5$export$de71442bbf2143da = "none";
var $7b9ba249efe2d2c5$export$4fc3521687bcacd2 = "appear";
var $7b9ba249efe2d2c5$export$5d6af549241fe2e8 = "enter";
var $7b9ba249efe2d2c5$export$59b1c493d29f68e4 = "leave";
var $7b9ba249efe2d2c5$export$40b34dd77d5522bf = "none";
var $7b9ba249efe2d2c5$export$1b792916a5fac4fc = "prepare";
var $7b9ba249efe2d2c5$export$9563153dd25a3ce8 = "start";
var $7b9ba249efe2d2c5$export$e205886172277ec6 = "active";
var $7b9ba249efe2d2c5$export$3a846c3d2fac10b8 = "end";
var $7b9ba249efe2d2c5$export$98351fa4e6b4f204 = "prepared";



var $dup7A = parcelRequire("dup7A");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $357e98e4510c7b52$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $357e98e4510c7b52$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $357e98e4510c7b52$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $357e98e4510c7b52$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $357e98e4510c7b52$var$vendorPrefixes = $357e98e4510c7b52$export$6e8b350b1a8958a0((0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $357e98e4510c7b52$var$style = {};
if ((0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)()) {
    var $357e98e4510c7b52$var$_document$createEleme = document.createElement("div");
    $357e98e4510c7b52$var$style = $357e98e4510c7b52$var$_document$createEleme.style;
}
var $357e98e4510c7b52$var$prefixedEventNames = {};
function $357e98e4510c7b52$export$a032e4f39350c1d8(eventName) {
    if ($357e98e4510c7b52$var$prefixedEventNames[eventName]) return $357e98e4510c7b52$var$prefixedEventNames[eventName];
    var prefixMap = $357e98e4510c7b52$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $357e98e4510c7b52$var$style) {
                $357e98e4510c7b52$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $357e98e4510c7b52$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $357e98e4510c7b52$var$internalAnimationEndName = $357e98e4510c7b52$export$a032e4f39350c1d8("animationend");
var $357e98e4510c7b52$var$internalTransitionEndName = $357e98e4510c7b52$export$a032e4f39350c1d8("transitionend");
var $357e98e4510c7b52$export$d28133ed3ad06c8b = !!($357e98e4510c7b52$var$internalAnimationEndName && $357e98e4510c7b52$var$internalTransitionEndName);
var $357e98e4510c7b52$export$760cc9769c51b738 = $357e98e4510c7b52$var$internalAnimationEndName || "animationend";
var $357e98e4510c7b52$export$44baea64b8602e3c = $357e98e4510c7b52$var$internalTransitionEndName || "transitionend";
function $357e98e4510c7b52$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $6ced532c298b0866$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $dup7A.useRef)();
    // Cache callback
    var callbackRef = (0, $dup7A.useRef)(callback);
    callbackRef.current = callback;
    // Internal motion event handler
    var onInternalMotionEnd = $dup7A.useCallback(function(event) {
        callbackRef.current(event);
    }, []);
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $357e98e4510c7b52$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $357e98e4510c7b52$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $357e98e4510c7b52$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $357e98e4510c7b52$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $dup7A.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $dup7A = parcelRequire("dup7A");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $ab571af64fd4c066$var$useIsomorphicLayoutEffect = (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)() ? (0, $dup7A.useLayoutEffect) : (0, $dup7A.useEffect);
var $ab571af64fd4c066$export$2e2bcd8739ae039 = $ab571af64fd4c066$var$useIsomorphicLayoutEffect;





var $dup7A = parcelRequire("dup7A");




var $dup7A = parcelRequire("dup7A");
var $dcc27c519e09e68d$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $dup7A.useRef(null);
    function cancelNextFrame() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $dup7A.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $c5db92e7a7f3a512$var$FULL_STEP_QUEUE = [
    (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc),
    (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8),
    (0, $7b9ba249efe2d2c5$export$e205886172277ec6),
    (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8)
];
var $c5db92e7a7f3a512$var$SIMPLE_STEP_QUEUE = [
    (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc),
    (0, $7b9ba249efe2d2c5$export$98351fa4e6b4f204)
];
var $c5db92e7a7f3a512$export$c2029bf6cfdbc28a = false;
var $c5db92e7a7f3a512$export$dbee1e282e8c4830 = true;
function $c5db92e7a7f3a512$export$39e04e72f972b885(step) {
    return step === (0, $7b9ba249efe2d2c5$export$e205886172277ec6) || step === (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8);
}
var $c5db92e7a7f3a512$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)((0, $7b9ba249efe2d2c5$export$40b34dd77d5522bf)), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dcc27c519e09e68d$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $c5db92e7a7f3a512$var$SIMPLE_STEP_QUEUE : $c5db92e7a7f3a512$var$FULL_STEP_QUEUE;
    (0, $ab571af64fd4c066$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $7b9ba249efe2d2c5$export$40b34dd77d5522bf) && step !== (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $c5db92e7a7f3a512$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $dup7A.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $0cc9b6c52f2ef3d8$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)((0, $7b9ba249efe2d2c5$export$de71442bbf2143da)), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(null), _useState6 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $dup7A.useRef)(false);
    var deadlineRef = (0, $dup7A.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $dup7A.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da), true);
        setStyle(null, true);
    }
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (status !== (0, $7b9ba249efe2d2c5$export$de71442bbf2143da) && currentActive && canEnd !== false) updateMotionEndStatus();
    }
    var _useDomMotionEvents = (0, $6ced532c298b0866$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        var _ref2, _ref3, _ref4;
        switch(targetStatus){
            case 0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2:
                return _ref2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onAppearPrepare), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onAppearStart), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onAppearActive), _ref2;
            case 0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8:
                return _ref3 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref3, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onEnterPrepare), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref3, (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onEnterStart), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref3, (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onEnterActive), _ref3;
            case 0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4:
                return _ref4 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref4, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onLeavePrepare), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref4, (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onLeaveStart), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref4, (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onLeaveActive), _ref4;
            default:
                return {};
        }
    };
    var eventHandlers = $dup7A.useMemo(function() {
        return getEventHandlers(status);
    }, [
        status
    ]);
    var _useStepQueue = (0, $c5db92e7a7f3a512$export$2e2bcd8739ae039)(status, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $c5db92e7a7f3a512$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $7b9ba249efe2d2c5$export$e205886172277ec6)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $7b9ba249efe2d2c5$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $c5db92e7a7f3a512$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $c5db92e7a7f3a512$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $ab571af64fd4c066$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $dup7A.useEffect)(function() {
        if (// Cancel appear
        status === (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        status === (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        status === (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $dup7A.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $dup7A.useRef(false);
    (0, $dup7A.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc] && step === (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8)) mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $ab4f312c3fa5df88$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $dup7A.useContext((0, $f60a304f067cf82f$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $dup7A.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $dup7A.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $0b6fbe60488ddcee$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $0cc9b6c52f2ef3d8$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $dup7A.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $dup7A.useCallback(function(node) {
            nodeRef.current = node;
            (0, $c8cde685aa40b754$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $c5db92e7a7f3a512$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8)) statusSuffix = "start";
            var motionCls = (0, $357e98e4510c7b52$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((0, $357e98e4510c7b52$export$27c72201b1d09951)(motionName, status), (_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, motionCls, motionCls && statusSuffix), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $dup7A.isValidElement(motionChildren) && (0, $c8cde685aa40b754$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $dup7A.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $dup7A.createElement((0, $eeeff6bdc66797b8$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $ab4f312c3fa5df88$export$2e2bcd8739ae039 = $ab4f312c3fa5df88$export$e265d52a86a9f199((0, $357e98e4510c7b52$export$d28133ed3ad06c8b));



var $3G4eg = parcelRequire("3G4eg");









var $dup7A = parcelRequire("dup7A");



var $f9cdc5c4cd9c3519$export$3904baa009bc026e = "add";
var $f9cdc5c4cd9c3519$export$851162f0adad2cbc = "keep";
var $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85 = "remove";
var $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a = "removed";
function $f9cdc5c4cd9c3519$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($f9cdc5c4cd9c3519$export$c47fd798e598c85c);
}
function $f9cdc5c4cd9c3519$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $f9cdc5c4cd9c3519$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $f9cdc5c4cd9c3519$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $f9cdc5c4cd9c3519$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $f9cdc5c4cd9c3519$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $73722d854feea6a1$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $73722d854feea6a1$var$_excluded2 = [
    "status"
];
var $73722d854feea6a1$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $73722d854feea6a1$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ab4f312c3fa5df88$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_this$props, $73722d854feea6a1$var$_excluded);
                    var Component = component || $dup7A.Fragment;
                    var motionProps = {};
                    $73722d854feea6a1$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $dup7A.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref2, $73722d854feea6a1$var$_excluded2);
                        var visible = status === (0, $f9cdc5c4cd9c3519$export$3904baa009bc026e) || status === (0, $f9cdc5c4cd9c3519$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $dup7A.createElement(CSSMotion, (0, $3G4eg.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $f9cdc5c4cd9c3519$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a) && entity.status === (0, $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($dup7A.Component);
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $73722d854feea6a1$export$2e2bcd8739ae039 = $73722d854feea6a1$export$fcfc62c1d33d5e2e((0, $357e98e4510c7b52$export$d28133ed3ad06c8b));



var $e2f8ecce9d0083b7$export$2e2bcd8739ae039 = (0, $ab4f312c3fa5df88$export$2e2bcd8739ae039);


function $19b9bb9355821eae$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $f81d310fac5ffb12$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $19b9bb9355821eae$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $dup7A.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $3G4eg = parcelRequire("3G4eg");



var $dup7A = parcelRequire("dup7A");
// export this package's api


function $ee01477f51c72f40$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ee01477f51c72f40$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ee01477f51c72f40$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ee01477f51c72f40$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ee01477f51c72f40$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ee01477f51c72f40$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ee01477f51c72f40$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ee01477f51c72f40$var$_typeof(obj);
}
function $ee01477f51c72f40$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ee01477f51c72f40$var$vendorPrefix;
var $ee01477f51c72f40$var$jsCssMap = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    // IE did it wrong again ...
    ms: "-ms-",
    O: "-o-"
};
function $ee01477f51c72f40$var$getVendorPrefix() {
    if ($ee01477f51c72f40$var$vendorPrefix !== undefined) return $ee01477f51c72f40$var$vendorPrefix;
    $ee01477f51c72f40$var$vendorPrefix = "";
    var style = document.createElement("p").style;
    var testProp = "Transform";
    for(var key in $ee01477f51c72f40$var$jsCssMap)if (key + testProp in style) $ee01477f51c72f40$var$vendorPrefix = key;
    return $ee01477f51c72f40$var$vendorPrefix;
}
function $ee01477f51c72f40$var$getTransitionName() {
    return $ee01477f51c72f40$var$getVendorPrefix() ? "".concat($ee01477f51c72f40$var$getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function $ee01477f51c72f40$var$getTransformName() {
    return $ee01477f51c72f40$var$getVendorPrefix() ? "".concat($ee01477f51c72f40$var$getVendorPrefix(), "Transform") : "transform";
}
function $ee01477f51c72f40$var$setTransitionProperty(node, value) {
    var name = $ee01477f51c72f40$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== "transitionProperty") node.style.transitionProperty = value;
    }
}
function $ee01477f51c72f40$var$setTransform(node, value) {
    var name = $ee01477f51c72f40$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== "transform") node.style.transform = value;
    }
}
function $ee01477f51c72f40$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$ee01477f51c72f40$var$getTransitionName()];
}
function $ee01477f51c72f40$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($ee01477f51c72f40$var$getTransformName());
    if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $ee01477f51c72f40$var$matrix2d = /matrix\((.*)\)/;
var $ee01477f51c72f40$var$matrix3d = /matrix3d\((.*)\)/;
function $ee01477f51c72f40$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($ee01477f51c72f40$var$getTransformName());
    if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match($ee01477f51c72f40$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $ee01477f51c72f40$var$setTransform(node, "matrix(".concat(arr.join(","), ")"));
        } else {
            var match3d = transform.match($ee01477f51c72f40$var$matrix3d)[1];
            arr = match3d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $ee01477f51c72f40$var$setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
        }
    } else $ee01477f51c72f40$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $ee01477f51c72f40$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $ee01477f51c72f40$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $ee01477f51c72f40$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = "none";
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $ee01477f51c72f40$var$css(el, name, v) {
    var value = v;
    if ($ee01477f51c72f40$var$_typeof(name) === "object") {
        for(var i in name)if (name.hasOwnProperty(i)) $ee01477f51c72f40$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== "undefined") {
        if (typeof value === "number") value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $ee01477f51c72f40$var$getComputedStyleX(el, name);
}
function $ee01477f51c72f40$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $ee01477f51c72f40$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== "number") // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $ee01477f51c72f40$var$getScrollLeft(w) {
    return $ee01477f51c72f40$var$getScroll(w);
}
function $ee01477f51c72f40$var$getScrollTop(w) {
    return $ee01477f51c72f40$var$getScroll(w, true);
}
function $ee01477f51c72f40$var$getOffset(el) {
    var pos = $ee01477f51c72f40$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $ee01477f51c72f40$var$getScrollLeft(w);
    pos.top += $ee01477f51c72f40$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $ee01477f51c72f40$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $ee01477f51c72f40$var$getDocument(node) {
    if ($ee01477f51c72f40$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $ee01477f51c72f40$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = "";
    var d = $ee01477f51c72f40$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $ee01477f51c72f40$var$_RE_NUM_NO_PX = new RegExp("^(".concat($ee01477f51c72f40$var$RE_NUM, ")(?!px)[a-z%]+$"), "i");
var $ee01477f51c72f40$var$RE_POS = /^(top|right|bottom|left)$/;
var $ee01477f51c72f40$var$CURRENT_STYLE = "currentStyle";
var $ee01477f51c72f40$var$RUNTIME_STYLE = "runtimeStyle";
var $ee01477f51c72f40$var$LEFT = "left";
var $ee01477f51c72f40$var$PX = "px";
function $ee01477f51c72f40$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$ee01477f51c72f40$var$CURRENT_STYLE] && elem[$ee01477f51c72f40$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($ee01477f51c72f40$var$_RE_NUM_NO_PX.test(ret) && !$ee01477f51c72f40$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$ee01477f51c72f40$var$LEFT];
        var rsLeft = elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT];
        // prevent flashing of content
        elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT] = elem[$ee01477f51c72f40$var$CURRENT_STYLE][$ee01477f51c72f40$var$LEFT];
        // Put in the new values to get a computed value out
        style[$ee01477f51c72f40$var$LEFT] = name === "fontSize" ? "1em" : ret || 0;
        ret = style.pixelLeft + $ee01477f51c72f40$var$PX;
        // Revert the changed values
        style[$ee01477f51c72f40$var$LEFT] = left;
        elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT] = rsLeft;
    }
    return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") $ee01477f51c72f40$var$getComputedStyleX = window.getComputedStyle ? $ee01477f51c72f40$var$_getComputedStyle : $ee01477f51c72f40$var$_getComputedStyleIE;
function $ee01477f51c72f40$var$getOffsetDirection(dir, option) {
    if (dir === "left") return option.useCssRight ? "right" : dir;
    return option.useCssBottom ? "bottom" : dir;
}
function $ee01477f51c72f40$var$oppositeOffsetDirection(dir) {
    if (dir === "left") return "right";
    else if (dir === "right") return "left";
    else if (dir === "top") return "bottom";
    else if (dir === "bottom") return "top";
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $ee01477f51c72f40$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($ee01477f51c72f40$var$css(elem, "position") === "static") elem.style.position = "relative";
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $ee01477f51c72f40$var$getOffsetDirection("left", option);
    var verticalProperty = $ee01477f51c72f40$var$getOffsetDirection("top", option);
    var oppositeHorizontalProperty = $ee01477f51c72f40$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $ee01477f51c72f40$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== "left") presetH = 999;
    if (verticalProperty !== "top") presetV = 999;
    var originalTransition = "";
    var originalOffset = $ee01477f51c72f40$var$getOffset(elem);
    if ("left" in offset || "top" in offset) {
        originalTransition = $ee01477f51c72f40$var$getTransitionProperty(elem) || "";
        $ee01477f51c72f40$var$setTransitionProperty(elem, "none");
    }
    if ("left" in offset) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ("top" in offset) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $ee01477f51c72f40$var$forceRelayout(elem);
    var old = $ee01477f51c72f40$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $ee01477f51c72f40$var$getOffsetDirection(key, option);
        var preset = key === "left" ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $ee01477f51c72f40$var$css(elem, originalStyle);
    // force relayout
    $ee01477f51c72f40$var$forceRelayout(elem);
    if ("left" in offset || "top" in offset) $ee01477f51c72f40$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $ee01477f51c72f40$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $ee01477f51c72f40$var$css(elem, ret);
}
function $ee01477f51c72f40$var$setTransform$1(elem, offset) {
    var originalOffset = $ee01477f51c72f40$var$getOffset(elem);
    var originalXY = $ee01477f51c72f40$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ("left" in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ("top" in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $ee01477f51c72f40$var$setTransformXY(elem, resultXY);
}
function $ee01477f51c72f40$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $ee01477f51c72f40$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $ee01477f51c72f40$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $ee01477f51c72f40$var$getTransformName() in document.body.style) $ee01477f51c72f40$var$setTransform$1(elem, offset);
    else $ee01477f51c72f40$var$setLeftTop(elem, offset, option);
}
function $ee01477f51c72f40$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $ee01477f51c72f40$var$isBorderBoxFn(elem) {
    return $ee01477f51c72f40$var$getComputedStyleX(elem, "boxSizing") === "border-box";
}
var $ee01477f51c72f40$var$BOX_MODELS = [
    "margin",
    "border",
    "padding"
];
var $ee01477f51c72f40$var$CONTENT_INDEX = -1;
var $ee01477f51c72f40$var$PADDING_INDEX = 2;
var $ee01477f51c72f40$var$BORDER_INDEX = 1;
var $ee01477f51c72f40$var$MARGIN_INDEX = 0;
function $ee01477f51c72f40$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $ee01477f51c72f40$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === "border") cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($ee01477f51c72f40$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $ee01477f51c72f40$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$ee01477f51c72f40$var$each([
    "Width",
    "Height"
], function(name) {
    $ee01477f51c72f40$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $ee01477f51c72f40$var$domUtils["viewport".concat(name)](d));
    };
    $ee01477f51c72f40$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $ee01477f51c72f40$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($ee01477f51c72f40$var$isWindow(elem)) return name === "width" ? $ee01477f51c72f40$var$domUtils.viewportWidth(elem) : $ee01477f51c72f40$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === "width" ? $ee01477f51c72f40$var$domUtils.docWidth(elem) : $ee01477f51c72f40$var$domUtils.docHeight(elem);
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $ee01477f51c72f40$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $ee01477f51c72f40$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $ee01477f51c72f40$var$BORDER_INDEX : $ee01477f51c72f40$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $ee01477f51c72f40$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $ee01477f51c72f40$var$getPBMWidth(elem, [
            "border",
            "padding"
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $ee01477f51c72f40$var$BORDER_INDEX) return val;
        return val + (extra === $ee01477f51c72f40$var$PADDING_INDEX ? -$ee01477f51c72f40$var$getPBMWidth(elem, [
            "border"
        ], which) : $ee01477f51c72f40$var$getPBMWidth(elem, [
            "margin"
        ], which));
    }
    return cssBoxValue + $ee01477f51c72f40$var$getPBMWidth(elem, $ee01477f51c72f40$var$BOX_MODELS.slice(extra), which);
}
var $ee01477f51c72f40$var$cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $ee01477f51c72f40$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $ee01477f51c72f40$var$getWH.apply(undefined, args);
    else $ee01477f51c72f40$var$swap(elem, $ee01477f51c72f40$var$cssShow, function() {
        val = $ee01477f51c72f40$var$getWH.apply(undefined, args);
    });
    return val;
}
$ee01477f51c72f40$var$each([
    "width",
    "height"
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $ee01477f51c72f40$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $ee01477f51c72f40$var$getWHIgnoreDisplay(el, name, includeMargin ? $ee01477f51c72f40$var$MARGIN_INDEX : $ee01477f51c72f40$var$BORDER_INDEX);
    };
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    $ee01477f51c72f40$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $ee01477f51c72f40$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $ee01477f51c72f40$var$getPBMWidth(elem, [
                    "padding",
                    "border"
                ], which);
                return $ee01477f51c72f40$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $ee01477f51c72f40$var$getWHIgnoreDisplay(elem, name, $ee01477f51c72f40$var$CONTENT_INDEX);
    };
});
function $ee01477f51c72f40$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $ee01477f51c72f40$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $ee01477f51c72f40$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== "undefined") $ee01477f51c72f40$var$setOffset(el, value, option || {});
        else return $ee01477f51c72f40$var$getOffset(el);
    },
    isWindow: $ee01477f51c72f40$var$isWindow,
    each: $ee01477f51c72f40$var$each,
    css: $ee01477f51c72f40$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $ee01477f51c72f40$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $ee01477f51c72f40$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $ee01477f51c72f40$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$ee01477f51c72f40$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$ee01477f51c72f40$var$mix($ee01477f51c72f40$var$utils, $ee01477f51c72f40$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $ee01477f51c72f40$var$getParent = $ee01477f51c72f40$var$utils.getParent;
function $ee01477f51c72f40$var$getOffsetParent(element) {
    if ($ee01477f51c72f40$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $ee01477f51c72f40$var$utils.css(element, "position");
    var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
    if (!skipStatic) return element.nodeName.toLowerCase() === "html" ? null : $ee01477f51c72f40$var$getParent(element);
    for(parent = $ee01477f51c72f40$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $ee01477f51c72f40$var$getParent(parent)){
        positionStyle = $ee01477f51c72f40$var$utils.css(parent, "position");
        if (positionStyle !== "static") return parent;
    }
    return null;
}
var $ee01477f51c72f40$var$getParent$1 = $ee01477f51c72f40$var$utils.getParent;
function $ee01477f51c72f40$var$isAncestorFixed(element) {
    if ($ee01477f51c72f40$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $ee01477f51c72f40$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $ee01477f51c72f40$var$getParent$1(parent)){
        var positionStyle = $ee01477f51c72f40$var$utils.css(parent, "position");
        if (positionStyle === "fixed") return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $ee01477f51c72f40$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $ee01477f51c72f40$var$getOffsetParent(element);
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $ee01477f51c72f40$var$utils.css(el, "overflow") !== "visible") {
            var pos = $ee01477f51c72f40$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $ee01477f51c72f40$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$ee01477f51c72f40$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $ee01477f51c72f40$var$utils.css(element, "position");
        if (position === "absolute") element.style.position = "fixed";
    }
    var scrollX = $ee01477f51c72f40$var$utils.getWindowScrollLeft(win);
    var scrollY = $ee01477f51c72f40$var$utils.getWindowScrollTop(win);
    var viewportWidth = $ee01477f51c72f40$var$utils.viewportWidth(win);
    var viewportHeight = $ee01477f51c72f40$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === "hidden") documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === "hidden") documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $ee01477f51c72f40$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $ee01477f51c72f40$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $ee01477f51c72f40$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $ee01477f51c72f40$var$utils.mix(pos, size);
}
function $ee01477f51c72f40$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$ee01477f51c72f40$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $ee01477f51c72f40$var$utils.offset(node);
        w = $ee01477f51c72f40$var$utils.outerWidth(node);
        h = $ee01477f51c72f40$var$utils.outerHeight(node);
    } else {
        var win = $ee01477f51c72f40$var$utils.getWindow(node);
        offset = {
            left: $ee01477f51c72f40$var$utils.getWindowScrollLeft(win),
            top: $ee01477f51c72f40$var$utils.getWindowScrollTop(win)
        };
        w = $ee01477f51c72f40$var$utils.viewportWidth(win);
        h = $ee01477f51c72f40$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $ee01477f51c72f40$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === "c") y += h / 2;
    else if (V === "b") y += h;
    if (H === "c") x += w / 2;
    else if (H === "r") x += w;
    return {
        left: x,
        top: y
    };
}
function $ee01477f51c72f40$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $ee01477f51c72f40$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $ee01477f51c72f40$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $ee01477f51c72f40$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $ee01477f51c72f40$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $ee01477f51c72f40$var$flip(points, reg, map) {
    var ret = [];
    $ee01477f51c72f40$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $ee01477f51c72f40$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $ee01477f51c72f40$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $ee01477f51c72f40$var$normalizeOffset(offset, el) {
    offset[0] = $ee01477f51c72f40$var$convertOffset(offset[0], el.width);
    offset[1] = $ee01477f51c72f40$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $ee01477f51c72f40$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $ee01477f51c72f40$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $ee01477f51c72f40$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $ee01477f51c72f40$var$normalizeOffset(offset, elRegion);
    $ee01477f51c72f40$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $ee01477f51c72f40$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $ee01477f51c72f40$var$flip(points, /[lr]/gi, {
                    l: "r",
                    r: "l"
                });
                // 偏移量也反下
                var newOffset = $ee01477f51c72f40$var$flipOffset(offset, 0);
                var newTargetOffset = $ee01477f51c72f40$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$ee01477f51c72f40$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $ee01477f51c72f40$var$flip(points, /[tb]/gi, {
                    t: "b",
                    b: "t"
                });
                // 偏移量也反下
                var _newOffset = $ee01477f51c72f40$var$flipOffset(offset, 1);
                var _newTargetOffset = $ee01477f51c72f40$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$ee01477f51c72f40$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $ee01477f51c72f40$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $ee01477f51c72f40$var$flip(points, /[lr]/gi, {
                l: "r",
                r: "l"
            });
            if (isStillFailY) _newPoints2 = $ee01477f51c72f40$var$flip(points, /[tb]/gi, {
                t: "b",
                b: "t"
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $ee01477f51c72f40$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $ee01477f51c72f40$var$utils.css(source, "width", $ee01477f51c72f40$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $ee01477f51c72f40$var$utils.css(source, "height", $ee01477f51c72f40$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $ee01477f51c72f40$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $ee01477f51c72f40$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $ee01477f51c72f40$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $ee01477f51c72f40$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $ee01477f51c72f40$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $ee01477f51c72f40$var$getRegion(target);
    var isTargetNotOutOfVisible = !$ee01477f51c72f40$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $ee01477f51c72f40$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$ee01477f51c72f40$export$ec21431d5ee6c534.__getOffsetParent = $ee01477f51c72f40$var$getOffsetParent;
$ee01477f51c72f40$export$ec21431d5ee6c534.__getVisibleRectForElement = $ee01477f51c72f40$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $ee01477f51c72f40$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $ee01477f51c72f40$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $ee01477f51c72f40$var$utils.getWindowScrollLeft(win);
    var scrollY = $ee01477f51c72f40$var$utils.getWindowScrollTop(win);
    var viewportWidth = $ee01477f51c72f40$var$utils.viewportWidth(win);
    var viewportHeight = $ee01477f51c72f40$var$utils.viewportHeight(win);
    if ("pageX" in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ("pageY" in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        "cc"
    ];
    return $ee01477f51c72f40$var$doAlign(el, tgtRegion, $ee01477f51c72f40$var$_objectSpread2($ee01477f51c72f40$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $ee01477f51c72f40$export$2e2bcd8739ae039 = $ee01477f51c72f40$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $b413b124a411084b$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(a) === "object" && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $b413b124a411084b$export$2e2bcd8739ae039 = $b413b124a411084b$var$isEqual;



var $bd5eba434ae00c04$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};



var $dup7A = parcelRequire("dup7A");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $37eabd4bcc9d6b73$var$useInternalLayoutEffect = (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)() ? $dup7A.useLayoutEffect : $dup7A.useEffect;
var $37eabd4bcc9d6b73$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $dup7A.useRef(true);
    $37eabd4bcc9d6b73$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $37eabd4bcc9d6b73$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $37eabd4bcc9d6b73$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $37eabd4bcc9d6b73$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $37eabd4bcc9d6b73$export$2e2bcd8739ae039 = $37eabd4bcc9d6b73$var$useLayoutEffect;




var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $cfd025d245abcd49$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $0dc404c2d121ea4e$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $0dc404c2d121ea4e$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $0dc404c2d121ea4e$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $0dc404c2d121ea4e$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($0dc404c2d121ea4e$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $0dc404c2d121ea4e$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $0dc404c2d121ea4e$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $0dc404c2d121ea4e$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $0dc404c2d121ea4e$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $0dc404c2d121ea4e$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $0dc404c2d121ea4e$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $0dc404c2d121ea4e$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $0dc404c2d121ea4e$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $0dc404c2d121ea4e$var$throttle(this.refresh.bind(this), $0dc404c2d121ea4e$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$0dc404c2d121ea4e$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($0dc404c2d121ea4e$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$0dc404c2d121ea4e$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $0dc404c2d121ea4e$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $0dc404c2d121ea4e$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $0dc404c2d121ea4e$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $0dc404c2d121ea4e$var$global$1;
};
// Placeholder of an empty content rectangle.
var $0dc404c2d121ea4e$var$emptyRect = $0dc404c2d121ea4e$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $0dc404c2d121ea4e$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $0dc404c2d121ea4e$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $0dc404c2d121ea4e$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $0dc404c2d121ea4e$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $0dc404c2d121ea4e$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $0dc404c2d121ea4e$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $0dc404c2d121ea4e$var$emptyRect;
    var styles = $0dc404c2d121ea4e$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $0dc404c2d121ea4e$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $0dc404c2d121ea4e$var$toFloat(styles.width), height = $0dc404c2d121ea4e$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $0dc404c2d121ea4e$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $0dc404c2d121ea4e$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$0dc404c2d121ea4e$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $0dc404c2d121ea4e$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $0dc404c2d121ea4e$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $0dc404c2d121ea4e$var$isDocumentElement(target) {
    return target === $0dc404c2d121ea4e$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getContentRect(target) {
    if (!$0dc404c2d121ea4e$var$isBrowser) return $0dc404c2d121ea4e$var$emptyRect;
    if ($0dc404c2d121ea4e$var$isSVGGraphicsElement(target)) return $0dc404c2d121ea4e$var$getSVGContentRect(target);
    return $0dc404c2d121ea4e$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $0dc404c2d121ea4e$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $0dc404c2d121ea4e$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $0dc404c2d121ea4e$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $0dc404c2d121ea4e$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $0dc404c2d121ea4e$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $0dc404c2d121ea4e$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $0dc404c2d121ea4e$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $0dc404c2d121ea4e$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $0dc404c2d121ea4e$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $0dc404c2d121ea4e$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $0dc404c2d121ea4e$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $0dc404c2d121ea4e$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $0dc404c2d121ea4e$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $0dc404c2d121ea4e$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $0dc404c2d121ea4e$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $0dc404c2d121ea4e$var$ResizeObserverController.getInstance();
        var observer = new $0dc404c2d121ea4e$var$ResizeObserverSPI(callback, controller, this);
        $0dc404c2d121ea4e$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $0dc404c2d121ea4e$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $0dc404c2d121ea4e$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $0dc404c2d121ea4e$var$index = function() {
    // Export existing implementation if available.
    if (typeof $0dc404c2d121ea4e$var$global$1.ResizeObserver !== "undefined") return $0dc404c2d121ea4e$var$global$1.ResizeObserver;
    return $0dc404c2d121ea4e$var$ResizeObserver;
}();
var $0dc404c2d121ea4e$export$2e2bcd8739ae039 = $0dc404c2d121ea4e$var$index;



function $e73c72d6f5cf5ab6$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ("pageX" in next && "pageY" in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ("clientX" in next && "clientY" in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $e73c72d6f5cf5ab6$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $01802a99afaa475f$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === "function") activeElement.focus();
}
function $e73c72d6f5cf5ab6$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $0dc404c2d121ea4e$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $fb481fd9c8236790$var$getElement(func) {
    if (typeof func !== "function") return null;
    return func();
}
function $fb481fd9c8236790$var$getPoint(point) {
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(point) !== "object" || !point) return null;
    return point;
}
var $fb481fd9c8236790$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $cfd025d245abcd49$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $fb481fd9c8236790$var$getElement(latestTarget);
            var _point = $fb481fd9c8236790$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $bd5eba434ae00c04$export$2e2bcd8739ae039)(_element)) _result = (0, $ee01477f51c72f40$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $ee01477f51c72f40$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $e73c72d6f5cf5ab6$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(), _React$useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        setElement($fb481fd9c8236790$var$getElement(target));
        setPoint($fb481fd9c8236790$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $e73c72d6f5cf5ab6$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $b413b124a411084b$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        var cancelFn = (0, $e73c72d6f5cf5ab6$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        var cancelFn = (0, $e73c72d6f5cf5ab6$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(window, "resize", _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).cloneElement(childNode, {
        ref: (0, $c8cde685aa40b754$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $fb481fd9c8236790$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef($fb481fd9c8236790$var$Align);
$fb481fd9c8236790$var$RcAlign.displayName = "Align";
var $fb481fd9c8236790$export$2e2bcd8739ae039 = $fb481fd9c8236790$var$RcAlign;


var $56c9493c97b907cd$export$2e2bcd8739ae039 = (0, $fb481fd9c8236790$export$2e2bcd8739ae039);






function $35ad2cb724adf131$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $35ad2cb724adf131$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $62a39180cabdbc6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $62a39180cabdbc6d$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $62a39180cabdbc6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $62a39180cabdbc6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var $dup7A = parcelRequire("dup7A");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $5dab434e4bd2d48a$var$StatusQueue = [
    "measure",
    "alignPre",
    "align",
    null,
    "motion"
];
var $5dab434e4bd2d48a$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(null), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $dup7A.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case "align":
                        return "motion";
                    case "motion":
                        return "stable";
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $dup7A.useEffect)(function() {
        setStatus("measure");
    }, [
        visible
    ]); // Go next status
    (0, $dup7A.useEffect)(function() {
        switch(status){
            case "measure":
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $62a39180cabdbc6d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $35ad2cb724adf131$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $35ad2cb724adf131$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $5dab434e4bd2d48a$var$StatusQueue.indexOf(status);
                        nextStatus = $5dab434e4bd2d48a$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $dup7A.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $dup7A = parcelRequire("dup7A");
var $bb943f37c44407d1$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $dup7A.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $dup7A.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf("height") !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf("minHeight") !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf("width") !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf("minWidth") !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $195532be8f53f650$var$PopupInner = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $dup7A.useRef)();
    var elementRef = (0, $dup7A.useRef)();
    var _useState = (0, $dup7A.useState)(), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $bb943f37c44407d1$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $5dab434e4bd2d48a$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $dup7A.useState)(0), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $dup7A.useRef)();
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        if (status === "alignPre") setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === "align") onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        if (status === "align") {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, (0, $19b9bb9355821eae$export$7b8936ddc277a29a)(props));
    [
        "onAppearEnd",
        "onEnterEnd",
        "onLeaveEnd"
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $dup7A.useEffect(function() {
        if (!motion.motionName && status === "motion") goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $dup7A.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === "motion" || status === "stable" || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== "stable" ? "none" : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === "align" || status === "stable")) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($dup7A.Children.count(children) > 1) childNode = /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $dup7A.createElement((0, $56c9493c97b907cd$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $dup7A.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$195532be8f53f650$var$PopupInner.displayName = "PopupInner";
var $195532be8f53f650$export$2e2bcd8739ae039 = $195532be8f53f650$var$PopupInner;



var $3G4eg = parcelRequire("3G4eg");


var $dup7A = parcelRequire("dup7A");


var $616659e41ceab681$var$MobilePopupInner = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $dup7A.useRef(); // ========================= Refs =========================
    $dup7A.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($dup7A.Children.count(children) > 1) childNode = /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $dup7A.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$616659e41ceab681$var$MobilePopupInner.displayName = "MobilePopupInner";
var $616659e41ceab681$export$2e2bcd8739ae039 = $616659e41ceab681$var$MobilePopupInner;


var $2a84774eafc6a0a8$var$_excluded = [
    "visible",
    "mobile"
];
var $2a84774eafc6a0a8$var$Popup = /*#__PURE__*/ $dup7A.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, $2a84774eafc6a0a8$var$_excluded);
    var _useState = (0, $dup7A.useState)(visible), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $dup7A.useState)(false), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $dup7A.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $cee396e5c47a9a3c$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $dup7A.createElement((0, $616659e41ceab681$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $dup7A.createElement((0, $195532be8f53f650$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $dup7A.createElement("div", null, /*#__PURE__*/ $dup7A.createElement((0, $f81d310fac5ffb12$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$2a84774eafc6a0a8$var$Popup.displayName = "Popup";
var $2a84774eafc6a0a8$export$2e2bcd8739ae039 = $2a84774eafc6a0a8$var$Popup;



var $dup7A = parcelRequire("dup7A");
var $740543d9906a47f1$var$TriggerContext = /*#__PURE__*/ $dup7A.createContext(null);
var $740543d9906a47f1$export$2e2bcd8739ae039 = $740543d9906a47f1$var$TriggerContext;


function $0f4334c3c513f32d$var$noop() {}
function $0f4334c3c513f32d$var$returnEmptyString() {
    return "";
}
function $0f4334c3c513f32d$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $0f4334c3c513f32d$var$ALL_HANDLERS = [
    "onClick",
    "onMouseDown",
    "onTouchStart",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onContextMenu"
];
function $0f4334c3c513f32d$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "popupRef", /*#__PURE__*/ $dup7A.createRef());
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "triggerRef", /*#__PURE__*/ $dup7A.createRef());
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "portalContainer", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "attachId", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "clickOutsideHandler", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "touchOutsideHandler", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "mouseDownTimeout", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "focusTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "preClickTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "preTouchTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "delayTimer", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "hasPopupMouseDown", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents("onMouseEnter", e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseMove", function(e) {
                _this.fireEvents("onMouseMove", e);
                _this.setPoint(e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
                _this.fireEvents("onMouseLeave", e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $01802a99afaa475f$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onFocus", function(e) {
                _this.fireEvents("onFocus", e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseDown", function(e) {
                _this.fireEvents("onMouseDown", e);
                _this.preClickTime = Date.now();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onTouchStart", function(e) {
                _this.fireEvents("onTouchStart", e);
                _this.preTouchTime = Date.now();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onBlur", function(e) {
                _this.fireEvents("onBlur", e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents("onContextMenu", e);
                _this.setPopupVisible(true, e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
                _this.fireEvents("onClick", event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $01802a99afaa475f$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $01802a99afaa475f$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $0b6fbe60488ddcee$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this));
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $a0e16b2c473f8d53$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(" ");
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $dup7A.createElement((0, $2a84774eafc6a0a8$export$2e2bcd8739ae039), (0, $3G4eg.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === "function" ? popup() : popup);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "attachParent", function(popupContainer) {
                (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement("div"); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = "absolute";
                    popupContainer.style.top = "0";
                    popupContainer.style.left = "0";
                    popupContainer.style.width = "100%";
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ("popupVisible" in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $0f4334c3c513f32d$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, "mousedown", this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, "touchstart", this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, "scroll", this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(window, "blur", this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $a0e16b2c473f8d53$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!("popupVisible" in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $dup7A.Children.only(children);
                    var newChildProps = {
                        key: "trigger"
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains("onClick");
                        newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
                        newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains("onFocus");
                        newChildProps.onBlur = this.createTwoChains("onBlur");
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $c8cde685aa40b754$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $c8cde685aa40b754$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $dup7A.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $dup7A.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $dup7A.createElement((0, $740543d9906a47f1$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($dup7A.Component);
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $740543d9906a47f1$export$2e2bcd8739ae039));
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: "rc-trigger-popup",
        getPopupClassNameFromAlign: $0f4334c3c513f32d$var$returnEmptyString,
        getDocument: $0f4334c3c513f32d$var$returnDocument,
        onPopupVisibleChange: $0f4334c3c513f32d$var$noop,
        afterPopupVisibleChange: $0f4334c3c513f32d$var$noop,
        onPopupAlign: $0f4334c3c513f32d$var$noop,
        popupClassName: "",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $0f4334c3c513f32d$export$2e2bcd8739ae039 = $0f4334c3c513f32d$export$55e99723d7f71b47((0, $8397b35ed6f4f5c4$export$2e2bcd8739ae039));


var $bee1cf246e25a401$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $bee1cf246e25a401$var$targetOffset = [
    0,
    0
];
var $bee1cf246e25a401$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    }
};
var $bee1cf246e25a401$export$2e2bcd8739ae039 = $bee1cf246e25a401$export$803cd8101b6c182b;



var $dup7A = parcelRequire("dup7A");

function $d8e60f7dfcdfa318$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $dup7A.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}


var $520e9651655308ca$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $520e9651655308ca$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(props, $520e9651655308ca$var$_excluded);
    var domRef = (0, $dup7A.useRef)(null);
    (0, $dup7A.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $dup7A.createElement((0, $d8e60f7dfcdfa318$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === "boolean") destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(destroyTooltipOnHide) === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $dup7A.createElement((0, $0f4334c3c513f32d$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $bee1cf246e25a401$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $520e9651655308ca$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dup7A.forwardRef)($520e9651655308ca$var$Tooltip);



var $b96c472b2580b6a4$export$2e2bcd8739ae039 = (0, $520e9651655308ca$export$2e2bcd8739ae039);




var $ee63ddd70979cae1$var$SliderTooltip = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $dup7A.useRef(null);
    var tooltipRef = (0, $c8cde685aa40b754$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $dup7A.useRef(null);
    function cancelKeepAlign() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $dup7A.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $dup7A.createElement((0, $b96c472b2580b6a4$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        ref: tooltipRef
    }, props));
});
var $ee63ddd70979cae1$export$2e2bcd8739ae039 = $ee63ddd70979cae1$var$SliderTooltip;



function $dadbd822db857fd1$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? "rc-slider-tooltip" : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? "top" : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $ee63ddd70979cae1$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $be7cb93b822a2be3$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, restProps, {
                    style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(Component, (0, $3G4eg.default)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $53eb3904070cf0e9$var$InternalSlider = (0, $ceac921ac672c792$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.Range = (0, $51730a1a5a927869$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.Handle = (0, $be7cb93b822a2be3$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.createSliderWithTooltip = (0, $dadbd822db857fd1$export$2e2bcd8739ae039);
var $53eb3904070cf0e9$export$2e2bcd8739ae039 = $53eb3904070cf0e9$var$InternalSlider;




var $dup7A = parcelRequire("dup7A");
var $48515c484bc5585a$var$a = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function $48515c484bc5585a$var$i(t) {
    return function(e) {
        var n = e || {}, r = n.width ? String(n.width) : t.defaultWidth;
        return t.formats[r] || t.formats[t.defaultWidth];
    };
}
var $48515c484bc5585a$var$o = {
    date: $48515c484bc5585a$var$i({
        formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
        },
        defaultWidth: "full"
    }),
    time: $48515c484bc5585a$var$i({
        formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
        },
        defaultWidth: "full"
    }),
    dateTime: $48515c484bc5585a$var$i({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
        },
        defaultWidth: "full"
    })
}, $48515c484bc5585a$var$u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function $48515c484bc5585a$var$s(t) {
    return function(e, n) {
        var r, a = n || {};
        if ("formatting" === (a.context ? String(a.context) : "standalone") && t.formattingValues) {
            var i = t.defaultFormattingWidth || t.defaultWidth, o = a.width ? String(a.width) : i;
            r = t.formattingValues[o] || t.formattingValues[i];
        } else {
            var u = t.defaultWidth, s = a.width ? String(a.width) : t.defaultWidth;
            r = t.values[s] || t.values[u];
        }
        return r[t.argumentCallback ? t.argumentCallback(e) : e];
    };
}
function $48515c484bc5585a$var$c(t) {
    return function(e, n) {
        var r = String(e), a = n || {}, i = a.width, o = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], u = r.match(o);
        if (!u) return null;
        var s, c = u[0], d = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth];
        return s = "[object Array]" === Object.prototype.toString.call(d) ? function(t, e) {
            for(var n = 0; n < t.length; n++)if (e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }) : function(t, e) {
            for(var n in t)if (t.hasOwnProperty(n) && e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }), s = t.valueCallback ? t.valueCallback(s) : s, {
            value: s = a.valueCallback ? a.valueCallback(s) : s,
            rest: r.slice(c.length)
        };
    };
}
var $48515c484bc5585a$var$d, $48515c484bc5585a$var$l = {
    code: "en-US",
    formatDistance: function(t, e, n) {
        var r;
        return n = n || {}, r = "string" == typeof $48515c484bc5585a$var$a[t] ? $48515c484bc5585a$var$a[t] : 1 === e ? $48515c484bc5585a$var$a[t].one : $48515c484bc5585a$var$a[t].other.replace("{{count}}", e), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
    },
    formatLong: $48515c484bc5585a$var$o,
    formatRelative: function(t, e, n, r) {
        return $48515c484bc5585a$var$u[t];
    },
    localize: {
        ordinalNumber: function(t, e) {
            var n = Number(t), r = n % 100;
            if (r > 20 || r < 10) switch(r % 10){
                case 1:
                    return n + "st";
                case 2:
                    return n + "nd";
                case 3:
                    return n + "rd";
            }
            return n + "th";
        },
        era: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    "B",
                    "A"
                ],
                abbreviated: [
                    "BC",
                    "AD"
                ],
                wide: [
                    "Before Christ",
                    "Anno Domini"
                ]
            },
            defaultWidth: "wide"
        }),
        quarter: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                abbreviated: [
                    "Q1",
                    "Q2",
                    "Q3",
                    "Q4"
                ],
                wide: [
                    "1st quarter",
                    "2nd quarter",
                    "3rd quarter",
                    "4th quarter"
                ]
            },
            defaultWidth: "wide",
            argumentCallback: function(t) {
                return Number(t) - 1;
            }
        }),
        month: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    "J",
                    "F",
                    "M",
                    "A",
                    "M",
                    "J",
                    "J",
                    "A",
                    "S",
                    "O",
                    "N",
                    "D"
                ],
                abbreviated: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                wide: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            defaultWidth: "wide"
        }),
        day: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    "S",
                    "M",
                    "T",
                    "W",
                    "T",
                    "F",
                    "S"
                ],
                short: [
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                abbreviated: [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                wide: [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ]
            },
            defaultWidth: "wide"
        }),
        dayPeriod: $48515c484bc5585a$var$s({
            values: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                }
            },
            defaultWidth: "wide",
            formattingValues: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                }
            },
            defaultFormattingWidth: "wide"
        })
    },
    match: {
        ordinalNumber: ($48515c484bc5585a$var$d = {
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function(t) {
                return parseInt(t, 10);
            }
        }, function(t, e) {
            var n = String(t), r = e || {}, a = n.match($48515c484bc5585a$var$d.matchPattern);
            if (!a) return null;
            var i = a[0], o = n.match($48515c484bc5585a$var$d.parsePattern);
            if (!o) return null;
            var u = $48515c484bc5585a$var$d.valueCallback ? $48515c484bc5585a$var$d.valueCallback(o[0]) : o[0];
            return {
                value: u = r.valueCallback ? r.valueCallback(u) : u,
                rest: n.slice(i.length)
            };
        }),
        era: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /^b/i,
                    /^(a|c)/i
                ]
            },
            defaultParseWidth: "any"
        }),
        quarter: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /1/i,
                    /2/i,
                    /3/i,
                    /4/i
                ]
            },
            defaultParseWidth: "any",
            valueCallback: function(t) {
                return t + 1;
            }
        }),
        month: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^j/i,
                    /^f/i,
                    /^m/i,
                    /^a/i,
                    /^m/i,
                    /^j/i,
                    /^j/i,
                    /^a/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ],
                any: [
                    /^ja/i,
                    /^f/i,
                    /^mar/i,
                    /^ap/i,
                    /^may/i,
                    /^jun/i,
                    /^jul/i,
                    /^au/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ]
            },
            defaultParseWidth: "any"
        }),
        day: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^s/i,
                    /^m/i,
                    /^t/i,
                    /^w/i,
                    /^t/i,
                    /^f/i,
                    /^s/i
                ],
                any: [
                    /^su/i,
                    /^m/i,
                    /^tu/i,
                    /^w/i,
                    /^th/i,
                    /^f/i,
                    /^sa/i
                ]
            },
            defaultParseWidth: "any"
        }),
        dayPeriod: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: "any",
            parsePatterns: {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            },
            defaultParseWidth: "any"
        })
    },
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function $48515c484bc5585a$var$f(t) {
    if (null === t || !0 === t || !1 === t) return NaN;
    var e = Number(t);
    return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function $48515c484bc5585a$var$h(t, e) {
    if (e.length < t) throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function $48515c484bc5585a$var$m(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = Object.prototype.toString.call(t);
    return t instanceof Date || "object" == typeof t && "[object Date]" === e ? new Date(t.getTime()) : "number" == typeof t || "[object Number]" === e ? new Date(t) : ("string" != typeof t && "[object String]" !== e || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function $48515c484bc5585a$var$w(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t).getTime(), r = $48515c484bc5585a$var$f(e);
    return new Date(n + r);
}
function $48515c484bc5585a$var$g(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$f(e);
    return $48515c484bc5585a$var$w(t, -n);
}
function $48515c484bc5585a$var$v(t, e) {
    if (null == t) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var n in e = e || {})e.hasOwnProperty(n) && (t[n] = e[n]);
    return t;
}
function $48515c484bc5585a$var$y(t, e) {
    switch(t){
        case "P":
            return e.date({
                width: "short"
            });
        case "PP":
            return e.date({
                width: "medium"
            });
        case "PPP":
            return e.date({
                width: "long"
            });
        case "PPPP":
        default:
            return e.date({
                width: "full"
            });
    }
}
function $48515c484bc5585a$var$b(t, e) {
    switch(t){
        case "p":
            return e.time({
                width: "short"
            });
        case "pp":
            return e.time({
                width: "medium"
            });
        case "ppp":
            return e.time({
                width: "long"
            });
        case "pppp":
        default:
            return e.time({
                width: "full"
            });
    }
}
var $48515c484bc5585a$var$D = {
    p: $48515c484bc5585a$var$b,
    P: function(t, e) {
        var n, r = t.match(/(P+)(p+)?/), a = r[1], i = r[2];
        if (!i) return $48515c484bc5585a$var$y(t, e);
        switch(a){
            case "P":
                n = e.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                n = e.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                n = e.dateTime({
                    width: "long"
                });
                break;
            case "PPPP":
            default:
                n = e.dateTime({
                    width: "full"
                });
        }
        return n.replace("{{date}}", $48515c484bc5585a$var$y(a, e)).replace("{{time}}", $48515c484bc5585a$var$b(i, e));
    }
};
function $48515c484bc5585a$var$T(t) {
    return t.getTime() % 6e4;
}
function $48515c484bc5585a$var$p(t) {
    var e = new Date(t.getTime()), n = Math.ceil(e.getTimezoneOffset());
    return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + $48515c484bc5585a$var$T(e)) % 6e4 : $48515c484bc5585a$var$T(e));
}
var $48515c484bc5585a$var$k = [
    "D",
    "DD"
], $48515c484bc5585a$var$x = [
    "YY",
    "YYYY"
];
function $48515c484bc5585a$var$C(t) {
    return -1 !== $48515c484bc5585a$var$k.indexOf(t);
}
function $48515c484bc5585a$var$M(t) {
    return -1 !== $48515c484bc5585a$var$x.indexOf(t);
}
function $48515c484bc5585a$var$U(t) {
    if ("YYYY" === t) throw new RangeError("Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr");
    if ("YY" === t) throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
    if ("D" === t) throw new RangeError("Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr");
    if ("DD" === t) throw new RangeError("Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr");
}
function $48515c484bc5585a$var$S(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $48515c484bc5585a$var$m(t), s = u.getUTCDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u;
}
function $48515c484bc5585a$var$P(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = $48515c484bc5585a$var$m(t, e), r = n.getUTCFullYear(), a = e || {}, i = a.locale, o = i && i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $48515c484bc5585a$var$f(o), s = null == a.firstWeekContainsDate ? u : $48515c484bc5585a$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var c = new Date(0);
    c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
    var d = $48515c484bc5585a$var$S(c, e), l = new Date(0);
    l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
    var w = $48515c484bc5585a$var$S(l, e);
    return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1;
}
function $48515c484bc5585a$var$E(t, e, n) {
    $48515c484bc5585a$var$h(2, arguments);
    var r = n || {}, a = r.locale, i = a && a.options && a.options.weekStartsOn, o = null == i ? 0 : $48515c484bc5585a$var$f(i), u = null == r.weekStartsOn ? o : $48515c484bc5585a$var$f(r.weekStartsOn);
    if (!(u >= 0 && u <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var s = $48515c484bc5585a$var$m(t), c = $48515c484bc5585a$var$f(e), d = s.getUTCDay(), l = c % 7, w = (l + 7) % 7, g = (w < u ? 7 : 0) + c - d;
    return s.setUTCDate(s.getUTCDate() + g), s;
}
function $48515c484bc5585a$var$Y(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = 1, n = $48515c484bc5585a$var$m(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
    return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $48515c484bc5585a$var$N(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t), n = e.getUTCFullYear(), r = new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var a = $48515c484bc5585a$var$Y(r), i = new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var o = $48515c484bc5585a$var$Y(i);
    return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function $48515c484bc5585a$var$q(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$N(t), n = new Date(0);
    n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
    var r = $48515c484bc5585a$var$Y(n);
    return r;
}
function $48515c484bc5585a$var$B(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t), n = $48515c484bc5585a$var$Y(e).getTime() - $48515c484bc5585a$var$q(e).getTime();
    return Math.round(n / 6048e5) + 1;
}
function $48515c484bc5585a$var$O(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.firstWeekContainsDate, i = null == a ? 1 : $48515c484bc5585a$var$f(a), o = null == n.firstWeekContainsDate ? i : $48515c484bc5585a$var$f(n.firstWeekContainsDate), u = $48515c484bc5585a$var$P(t, e), s = new Date(0);
    s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0);
    var c = $48515c484bc5585a$var$S(s, e);
    return c;
}
function $48515c484bc5585a$var$H(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$S(n, e).getTime() - $48515c484bc5585a$var$O(n, e).getTime();
    return Math.round(r / 6048e5) + 1;
}
var $48515c484bc5585a$var$L = /^(1[0-2]|0?\d)/, $48515c484bc5585a$var$W = /^(3[0-1]|[0-2]?\d)/, $48515c484bc5585a$var$F = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, $48515c484bc5585a$var$Q = /^(5[0-3]|[0-4]?\d)/, $48515c484bc5585a$var$R = /^(2[0-3]|[0-1]?\d)/, $48515c484bc5585a$var$I = /^(2[0-4]|[0-1]?\d)/, $48515c484bc5585a$var$X = /^(1[0-1]|0?\d)/, $48515c484bc5585a$var$G = /^(1[0-2]|0?\d)/, $48515c484bc5585a$var$A = /^[0-5]?\d/, $48515c484bc5585a$var$z = /^[0-5]?\d/, $48515c484bc5585a$var$j = /^\d/, $48515c484bc5585a$var$K = /^\d{1,2}/, $48515c484bc5585a$var$J = /^\d{1,3}/, $48515c484bc5585a$var$Z = /^\d{1,4}/, $48515c484bc5585a$var$_ = /^-?\d+/, $48515c484bc5585a$var$$ = /^-?\d/, $48515c484bc5585a$var$V = /^-?\d{1,2}/, $48515c484bc5585a$var$tt = /^-?\d{1,3}/, $48515c484bc5585a$var$et = /^-?\d{1,4}/, $48515c484bc5585a$var$nt = /^([+-])(\d{2})(\d{2})?|Z/, $48515c484bc5585a$var$rt = /^([+-])(\d{2})(\d{2})|Z/, $48515c484bc5585a$var$at = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, $48515c484bc5585a$var$it = /^([+-])(\d{2}):(\d{2})|Z/, $48515c484bc5585a$var$ot = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function $48515c484bc5585a$var$ut(t, e, n) {
    var r = e.match(t);
    if (!r) return null;
    var a = parseInt(r[0], 10);
    return {
        value: n ? n(a) : a,
        rest: e.slice(r[0].length)
    };
}
function $48515c484bc5585a$var$st(t, e) {
    var n = e.match(t);
    return n ? "Z" === n[0] ? {
        value: 0,
        rest: e.slice(1)
    } : {
        value: ("+" === n[1] ? 1 : -1) * (36e5 * (n[2] ? parseInt(n[2], 10) : 0) + 6e4 * (n[3] ? parseInt(n[3], 10) : 0) + 1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
        rest: e.slice(n[0].length)
    } : null;
}
function $48515c484bc5585a$var$ct(t, e) {
    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$_, t, e);
}
function $48515c484bc5585a$var$dt(t, e, n) {
    switch(t){
        case 1:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$j, e, n);
        case 2:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$K, e, n);
        case 3:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$J, e, n);
        case 4:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Z, e, n);
        default:
            return $48515c484bc5585a$var$ut(new RegExp("^\\d{1," + t + "}"), e, n);
    }
}
function $48515c484bc5585a$var$lt(t, e, n) {
    switch(t){
        case 1:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$$, e, n);
        case 2:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$V, e, n);
        case 3:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$tt, e, n);
        case 4:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$et, e, n);
        default:
            return $48515c484bc5585a$var$ut(new RegExp("^-?\\d{1," + t + "}"), e, n);
    }
}
function $48515c484bc5585a$var$ft(t) {
    switch(t){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $48515c484bc5585a$var$ht(t, e) {
    var n, r = e > 0, a = r ? e : 1 - e;
    if (a <= 50) n = t || 100;
    else {
        var i = a + 50;
        n = t + 100 * Math.floor(i / 100) - (t >= i % 100 ? 100 : 0);
    }
    return r ? n : 1 - n;
}
var $48515c484bc5585a$var$mt = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $48515c484bc5585a$var$wt = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $48515c484bc5585a$var$gt(t) {
    return t % 400 == 0 || t % 4 == 0 && t % 100 != 0;
}
var $48515c484bc5585a$var$vt = {
    G: {
        priority: 140,
        parse: function(t, e, n, r) {
            switch(e){
                case "G":
                case "GG":
                case "GGG":
                    return n.era(t, {
                        width: "abbreviated"
                    }) || n.era(t, {
                        width: "narrow"
                    });
                case "GGGGG":
                    return n.era(t, {
                        width: "narrow"
                    });
                case "GGGG":
                default:
                    return n.era(t, {
                        width: "wide"
                    }) || n.era(t, {
                        width: "abbreviated"
                    }) || n.era(t, {
                        width: "narrow"
                    });
            }
        },
        set: function(t, e, n, r) {
            return e.era = n, t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "R",
            "u",
            "t",
            "T"
        ]
    },
    y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: "yy" === e
                };
            };
            switch(e){
                case "y":
                    return $48515c484bc5585a$var$dt(4, t, a);
                case "yo":
                    return n.ordinalNumber(t, {
                        unit: "year",
                        valueCallback: a
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCFullYear();
            if (n.isTwoDigitYear) {
                var i = $48515c484bc5585a$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
            }
            var o = "era" in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    Y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: "YY" === e
                };
            };
            switch(e){
                case "Y":
                    return $48515c484bc5585a$var$dt(4, t, a);
                case "Yo":
                    return n.ordinalNumber(t, {
                        unit: "year",
                        valueCallback: a
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = $48515c484bc5585a$var$P(t, r);
            if (n.isTwoDigitYear) {
                var i = $48515c484bc5585a$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$S(t, r);
            }
            var o = "era" in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$S(t, r);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    R: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$lt("R" === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            var a = new Date(0);
            return a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$Y(a);
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    u: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$lt("u" === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    Q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case "Q":
                case "QQ":
                    return $48515c484bc5585a$var$dt(e.length, t);
                case "Qo":
                    return n.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "QQQ":
                    return n.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "QQQQQ":
                    return n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "QQQQ":
                default:
                    return n.quarter(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case "q":
                case "qq":
                    return $48515c484bc5585a$var$dt(e.length, t);
                case "qo":
                    return n.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "qqq":
                    return n.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "qqqqq":
                    return n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "qqqq":
                default:
                    return n.quarter(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    M: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case "M":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$L, t, a);
                case "MM":
                    return $48515c484bc5585a$var$dt(2, t, a);
                case "Mo":
                    return n.ordinalNumber(t, {
                        unit: "month",
                        valueCallback: a
                    });
                case "MMM":
                    return n.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "MMMMM":
                    return n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "MMMM":
                default:
                    return n.month(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    L: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case "L":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$L, t, a);
                case "LL":
                    return $48515c484bc5585a$var$dt(2, t, a);
                case "Lo":
                    return n.ordinalNumber(t, {
                        unit: "month",
                        valueCallback: a
                    });
                case "LLL":
                    return n.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "LLLLL":
                    return n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "LLLL":
                default:
                    return n.month(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    w: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case "w":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Q, t);
                case "wo":
                    return n.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $48515c484bc5585a$var$S(function(t, e, n) {
                $48515c484bc5585a$var$h(2, arguments);
                var r = $48515c484bc5585a$var$m(t), a = $48515c484bc5585a$var$f(e), i = $48515c484bc5585a$var$H(r, n) - a;
                return r.setUTCDate(r.getUTCDate() - 7 * i), r;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    I: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case "I":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Q, t);
                case "Io":
                    return n.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $48515c484bc5585a$var$Y(function(t, e) {
                $48515c484bc5585a$var$h(2, arguments);
                var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e), a = $48515c484bc5585a$var$B(n) - r;
                return n.setUTCDate(n.getUTCDate() - 7 * a), n;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    d: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "d":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$W, t);
                case "do":
                    return n.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            var r = $48515c484bc5585a$var$gt(t.getUTCFullYear()), a = t.getUTCMonth();
            return r ? e >= 1 && e <= $48515c484bc5585a$var$wt[a] : e >= 1 && e <= $48515c484bc5585a$var$mt[a];
        },
        set: function(t, e, n, r) {
            return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    D: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "D":
                case "DD":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$F, t);
                case "Do":
                    return n.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return $48515c484bc5585a$var$gt(t.getUTCFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    E: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "E":
                case "EE":
                case "EEE":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEE":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEEE":
                    return n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEE":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    e: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "e":
                case "ee":
                    return $48515c484bc5585a$var$dt(e.length, t, a);
                case "eo":
                    return n.ordinalNumber(t, {
                        unit: "day",
                        valueCallback: a
                    });
                case "eee":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeee":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeeee":
                    return n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeee":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]
    },
    c: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "c":
                case "cc":
                    return $48515c484bc5585a$var$dt(e.length, t, a);
                case "co":
                    return n.ordinalNumber(t, {
                        unit: "day",
                        valueCallback: a
                    });
                case "ccc":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "ccccc":
                    return n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "cccccc":
                    return n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "cccc":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]
    },
    i: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return 0 === t ? 7 : t;
            };
            switch(e){
                case "i":
                case "ii":
                    return $48515c484bc5585a$var$dt(e.length, t);
                case "io":
                    return n.ordinalNumber(t, {
                        unit: "day"
                    });
                case "iii":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiiii":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiiiii":
                    return n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiii":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 7;
        },
        set: function(t, e, n, r) {
            return (t = function(t, e) {
                $48515c484bc5585a$var$h(2, arguments);
                var n = $48515c484bc5585a$var$f(e);
                n % 7 == 0 && (n -= 7);
                var r = 1, a = $48515c484bc5585a$var$m(t), i = a.getUTCDay(), o = n % 7, u = (o + 7) % 7, s = (u < r ? 7 : 0) + n - i;
                return a.setUTCDate(a.getUTCDate() + s), a;
            }(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    a: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "a":
                case "aa":
                case "aaa":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaaa":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaa":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "b",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    b: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "b":
                case "bb":
                case "bbb":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbbb":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbb":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    B: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "B":
                case "BB":
                case "BBB":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBBB":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBB":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "t",
            "T"
        ]
    },
    h: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "h":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$G, t);
                case "ho":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 12;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCHours() >= 12;
            return a && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : a || 12 !== n ? t.setUTCHours(n, 0, 0, 0) : t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    H: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "H":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$R, t);
                case "Ho":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 23;
        },
        set: function(t, e, n, r) {
            return t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    K: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "K":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$X, t);
                case "Ko":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.getUTCHours() >= 12 && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    k: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "k":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$I, t);
                case "ko":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 24;
        },
        set: function(t, e, n, r) {
            var a = n <= 24 ? n % 24 : n;
            return t.setUTCHours(a, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]
    },
    m: {
        priority: 60,
        parse: function(t, e, n, r) {
            switch(e){
                case "m":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$A, t);
                case "mo":
                    return n.ordinalNumber(t, {
                        unit: "minute"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCMinutes(n, 0, 0), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    s: {
        priority: 50,
        parse: function(t, e, n, r) {
            switch(e){
                case "s":
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$z, t);
                case "so":
                    return n.ordinalNumber(t, {
                        unit: "second"
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCSeconds(n, 0), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    S: {
        priority: 30,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$dt(e.length, t, function(t) {
                return Math.floor(t * Math.pow(10, 3 - e.length));
            });
        },
        set: function(t, e, n, r) {
            return t.setUTCMilliseconds(n), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    X: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case "X":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$nt, t);
                case "XX":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$rt, t);
                case "XXXX":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$at, t);
                case "XXXXX":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$ot, t);
                case "XXX":
                default:
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            "t",
            "T",
            "x"
        ]
    },
    x: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case "x":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$nt, t);
                case "xx":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$rt, t);
                case "xxxx":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$at, t);
                case "xxxxx":
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$ot, t);
                case "xxx":
                default:
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            "t",
            "T",
            "X"
        ]
    },
    t: {
        priority: 40,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(1e3 * n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: "*"
    },
    T: {
        priority: 20,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: "*"
    }
}, $48515c484bc5585a$var$yt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$bt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Dt = /^'([^]*?)'?$/, $48515c484bc5585a$var$Tt = /''/g, $48515c484bc5585a$var$pt = /\S/, $48515c484bc5585a$var$kt = /[a-zA-Z]/;
function $48515c484bc5585a$export$6b862160d295c8e(t, e, n, r) {
    $48515c484bc5585a$var$h(3, arguments);
    var a = String(t), i = String(e), o = r || {}, u = o.locale || $48515c484bc5585a$var$l;
    if (!u.match) throw new RangeError("locale must contain match property");
    var s = u.options && u.options.firstWeekContainsDate, c = null == s ? 1 : $48515c484bc5585a$var$f(s), d = null == o.firstWeekContainsDate ? c : $48515c484bc5585a$var$f(o.firstWeekContainsDate);
    if (!(d >= 1 && d <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var w = u.options && u.options.weekStartsOn, y = null == w ? 0 : $48515c484bc5585a$var$f(w), b = null == o.weekStartsOn ? y : $48515c484bc5585a$var$f(o.weekStartsOn);
    if (!(b >= 0 && b <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if ("" === i) return "" === a ? $48515c484bc5585a$var$m(n) : new Date(NaN);
    var T, k = {
        firstWeekContainsDate: d,
        weekStartsOn: b,
        locale: u
    }, x = [
        {
            priority: 10,
            set: $48515c484bc5585a$var$Ct,
            index: 0
        }
    ], S = i.match($48515c484bc5585a$var$bt).map(function(t) {
        var e = t[0];
        return "p" === e || "P" === e ? (0, $48515c484bc5585a$var$D[e])(t, u.formatLong, k) : t;
    }).join("").match($48515c484bc5585a$var$yt), P = [];
    for(T = 0; T < S.length; T++){
        var E = S[T];
        !o.useAdditionalWeekYearTokens && $48515c484bc5585a$var$M(E) && $48515c484bc5585a$var$U(E), !o.useAdditionalDayOfYearTokens && $48515c484bc5585a$var$C(E) && $48515c484bc5585a$var$U(E);
        var Y = E[0], N = $48515c484bc5585a$var$vt[Y];
        if (N) {
            var q = N.incompatibleTokens;
            if (Array.isArray(q)) {
                for(var B = void 0, O = 0; O < P.length; O++){
                    var H = P[O].token;
                    if (-1 !== q.indexOf(H) || H === Y) {
                        B = P[O];
                        break;
                    }
                }
                if (B) throw new RangeError("The format string mustn't contain `".concat(B.fullToken, "` and `").concat(E, "` at the same time"));
            } else if ("*" === N.incompatibleTokens && P.length) throw new RangeError("The format string mustn't contain `".concat(E, "` and any other token at the same time"));
            P.push({
                token: Y,
                fullToken: E
            });
            var L = N.parse(a, E, u.match, k);
            if (!L) return new Date(NaN);
            x.push({
                priority: N.priority,
                set: N.set,
                validate: N.validate,
                value: L.value,
                index: x.length
            }), a = L.rest;
        } else {
            if (Y.match($48515c484bc5585a$var$kt)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
            if ("''" === E ? E = "'" : "'" === Y && (E = $48515c484bc5585a$var$Mt(E)), 0 !== a.indexOf(E)) return new Date(NaN);
            a = a.slice(E.length);
        }
    }
    if (a.length > 0 && $48515c484bc5585a$var$pt.test(a)) return new Date(NaN);
    var W = x.map(function(t) {
        return t.priority;
    }).sort(function(t, e) {
        return e - t;
    }).filter(function(t, e, n) {
        return n.indexOf(t) === e;
    }).map(function(t) {
        return x.filter(function(e) {
            return e.priority === t;
        }).reverse();
    }).map(function(t) {
        return t[0];
    }), F = $48515c484bc5585a$var$m(n);
    if (isNaN(F)) return new Date(NaN);
    var Q = $48515c484bc5585a$var$g(F, $48515c484bc5585a$var$p(F)), R = {};
    for(T = 0; T < W.length; T++){
        var I = W[T];
        if (I.validate && !I.validate(Q, I.value, k)) return new Date(NaN);
        var X = I.set(Q, R, I.value, k);
        X[0] ? (Q = X[0], $48515c484bc5585a$var$v(R, X[1])) : Q = X;
    }
    return Q;
}
function $48515c484bc5585a$var$Ct(t, e) {
    if (e.timestampIsSet) return t;
    var n = new Date(0);
    return n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), n;
}
function $48515c484bc5585a$var$Mt(t) {
    return t.match($48515c484bc5585a$var$Dt)[1].replace($48515c484bc5585a$var$Tt, "'");
}
function $48515c484bc5585a$var$Ut(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return !isNaN(e);
}
function $48515c484bc5585a$var$St(t, e) {
    for(var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e;)r = "0" + r;
    return n + r;
}
var $48515c484bc5585a$var$Pt = function(t, e) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return $48515c484bc5585a$var$St("yy" === e ? r % 100 : r, e.length);
}, $48515c484bc5585a$var$Et = function(t, e) {
    var n = t.getUTCMonth();
    return "M" === e ? String(n + 1) : $48515c484bc5585a$var$St(n + 1, 2);
}, $48515c484bc5585a$var$Yt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCDate(), e.length);
}, $48515c484bc5585a$var$Nt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCHours() % 12 || 12, e.length);
}, $48515c484bc5585a$var$qt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCHours(), e.length);
}, $48515c484bc5585a$var$Bt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCMinutes(), e.length);
}, $48515c484bc5585a$var$Ot = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCSeconds(), e.length);
}, $48515c484bc5585a$var$Ht = function(t, e) {
    var n = e.length, r = t.getUTCMilliseconds();
    return $48515c484bc5585a$var$St(Math.floor(r * Math.pow(10, n - 3)), e.length);
};
var $48515c484bc5585a$var$Lt = "midnight", $48515c484bc5585a$var$Wt = "noon", $48515c484bc5585a$var$Ft = "morning", $48515c484bc5585a$var$Qt = "afternoon", $48515c484bc5585a$var$Rt = "evening", $48515c484bc5585a$var$It = "night", $48515c484bc5585a$var$Xt = {
    G: function(t, e, n) {
        var r = t.getUTCFullYear() > 0 ? 1 : 0;
        switch(e){
            case "G":
            case "GG":
            case "GGG":
                return n.era(r, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return n.era(r, {
                    width: "narrow"
                });
            case "GGGG":
            default:
                return n.era(r, {
                    width: "wide"
                });
        }
    },
    y: function(t, e, n) {
        if ("yo" === e) {
            var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
            return n.ordinalNumber(a, {
                unit: "year"
            });
        }
        return $48515c484bc5585a$var$Pt(t, e);
    },
    Y: function(t, e, n, r) {
        var a = $48515c484bc5585a$var$P(t, r), i = a > 0 ? a : 1 - a;
        return "YY" === e ? $48515c484bc5585a$var$St(i % 100, 2) : "Yo" === e ? n.ordinalNumber(i, {
            unit: "year"
        }) : $48515c484bc5585a$var$St(i, e.length);
    },
    R: function(t, e) {
        return $48515c484bc5585a$var$St($48515c484bc5585a$var$N(t), e.length);
    },
    u: function(t, e) {
        return $48515c484bc5585a$var$St(t.getUTCFullYear(), e.length);
    },
    Q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case "Q":
                return String(r);
            case "QQ":
                return $48515c484bc5585a$var$St(r, 2);
            case "Qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "QQQ":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return n.quarter(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "QQQQ":
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case "q":
                return String(r);
            case "qq":
                return $48515c484bc5585a$var$St(r, 2);
            case "qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "qqq":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return n.quarter(r, {
                    width: "narrow",
                    context: "standalone"
                });
            case "qqqq":
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    M: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case "M":
            case "MM":
                return $48515c484bc5585a$var$Et(t, e);
            case "Mo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "MMM":
                return n.month(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return n.month(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "MMMM":
            default:
                return n.month(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    L: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case "L":
                return String(r + 1);
            case "LL":
                return $48515c484bc5585a$var$St(r + 1, 2);
            case "Lo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "LLL":
                return n.month(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return n.month(r, {
                    width: "narrow",
                    context: "standalone"
                });
            case "LLLL":
            default:
                return n.month(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    w: function(t, e, n, r) {
        var a = $48515c484bc5585a$var$H(t, r);
        return "wo" === e ? n.ordinalNumber(a, {
            unit: "week"
        }) : $48515c484bc5585a$var$St(a, e.length);
    },
    I: function(t, e, n) {
        var r = $48515c484bc5585a$var$B(t);
        return "Io" === e ? n.ordinalNumber(r, {
            unit: "week"
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    d: function(t, e, n) {
        return "do" === e ? n.ordinalNumber(t.getUTCDate(), {
            unit: "date"
        }) : $48515c484bc5585a$var$Yt(t, e);
    },
    D: function(t, e, n) {
        var r = function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getTime();
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            var r = e.getTime(), a = n - r;
            return Math.floor(a / 864e5) + 1;
        }(t);
        return "Do" === e ? n.ordinalNumber(r, {
            unit: "dayOfYear"
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    E: function(t, e, n) {
        var r = t.getUTCDay();
        switch(e){
            case "E":
            case "EE":
            case "EEE":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            case "EEEE":
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    e: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "e":
                return String(i);
            case "ee":
                return $48515c484bc5585a$var$St(i, 2);
            case "eo":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "eee":
                return n.day(a, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return n.day(a, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return n.day(a, {
                    width: "short",
                    context: "formatting"
                });
            case "eeee":
            default:
                return n.day(a, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    c: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "c":
                return String(i);
            case "cc":
                return $48515c484bc5585a$var$St(i, e.length);
            case "co":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "ccc":
                return n.day(a, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return n.day(a, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return n.day(a, {
                    width: "short",
                    context: "standalone"
                });
            case "cccc":
            default:
                return n.day(a, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    i: function(t, e, n) {
        var r = t.getUTCDay(), a = 0 === r ? 7 : r;
        switch(e){
            case "i":
                return String(a);
            case "ii":
                return $48515c484bc5585a$var$St(a, e.length);
            case "io":
                return n.ordinalNumber(a, {
                    unit: "day"
                });
            case "iii":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            case "iiii":
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    a: function(t, e, n) {
        var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(e){
            case "a":
            case "aa":
            case "aaa":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaaaa":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    b: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = 12 === a ? $48515c484bc5585a$var$Wt : 0 === a ? $48515c484bc5585a$var$Lt : a / 12 >= 1 ? "pm" : "am", e){
            case "b":
            case "bb":
            case "bbb":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbbbb":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    B: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = a >= 17 ? $48515c484bc5585a$var$Rt : a >= 12 ? $48515c484bc5585a$var$Qt : a >= 4 ? $48515c484bc5585a$var$Ft : $48515c484bc5585a$var$It, e){
            case "B":
            case "BB":
            case "BBB":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    h: function(t, e, n) {
        if ("ho" === e) {
            var r = t.getUTCHours() % 12;
            return 0 === r && (r = 12), n.ordinalNumber(r, {
                unit: "hour"
            });
        }
        return $48515c484bc5585a$var$Nt(t, e);
    },
    H: function(t, e, n) {
        return "Ho" === e ? n.ordinalNumber(t.getUTCHours(), {
            unit: "hour"
        }) : $48515c484bc5585a$var$qt(t, e);
    },
    K: function(t, e, n) {
        var r = t.getUTCHours() % 12;
        return "Ko" === e ? n.ordinalNumber(r, {
            unit: "hour"
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    k: function(t, e, n) {
        var r = t.getUTCHours();
        return 0 === r && (r = 24), "ko" === e ? n.ordinalNumber(r, {
            unit: "hour"
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    m: function(t, e, n) {
        return "mo" === e ? n.ordinalNumber(t.getUTCMinutes(), {
            unit: "minute"
        }) : $48515c484bc5585a$var$Bt(t, e);
    },
    s: function(t, e, n) {
        return "so" === e ? n.ordinalNumber(t.getUTCSeconds(), {
            unit: "second"
        }) : $48515c484bc5585a$var$Ot(t, e);
    },
    S: function(t, e) {
        return $48515c484bc5585a$var$Ht(t, e);
    },
    X: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        if (0 === a) return "Z";
        switch(e){
            case "X":
                return $48515c484bc5585a$var$At(a);
            case "XXXX":
            case "XX":
                return $48515c484bc5585a$var$zt(a);
            case "XXXXX":
            case "XXX":
            default:
                return $48515c484bc5585a$var$zt(a, ":");
        }
    },
    x: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "x":
                return $48515c484bc5585a$var$At(a);
            case "xxxx":
            case "xx":
                return $48515c484bc5585a$var$zt(a);
            case "xxxxx":
            case "xxx":
            default:
                return $48515c484bc5585a$var$zt(a, ":");
        }
    },
    O: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $48515c484bc5585a$var$Gt(a, ":");
            case "OOOO":
            default:
                return "GMT" + $48515c484bc5585a$var$zt(a, ":");
        }
    },
    z: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $48515c484bc5585a$var$Gt(a, ":");
            case "zzzz":
            default:
                return "GMT" + $48515c484bc5585a$var$zt(a, ":");
        }
    },
    t: function(t, e, n, r) {
        var a = r._originalDate || t;
        return $48515c484bc5585a$var$St(Math.floor(a.getTime() / 1e3), e.length);
    },
    T: function(t, e, n, r) {
        return $48515c484bc5585a$var$St((r._originalDate || t).getTime(), e.length);
    }
};
function $48515c484bc5585a$var$Gt(t, e) {
    var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
    if (0 === i) return n + String(a);
    var o = e || "";
    return n + String(a) + o + $48515c484bc5585a$var$St(i, 2);
}
function $48515c484bc5585a$var$At(t, e) {
    return t % 60 == 0 ? (t > 0 ? "-" : "+") + $48515c484bc5585a$var$St(Math.abs(t) / 60, 2) : $48515c484bc5585a$var$zt(t, e);
}
function $48515c484bc5585a$var$zt(t, e) {
    var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t);
    return r + $48515c484bc5585a$var$St(Math.floor(a / 60), 2) + n + $48515c484bc5585a$var$St(a % 60, 2);
}
var $48515c484bc5585a$var$jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Jt = /^'([^]*?)'?$/, $48515c484bc5585a$var$Zt = /''/g, $48515c484bc5585a$var$_t = /[a-zA-Z]/;
function $48515c484bc5585a$var$$t(t, e, n) {
    $48515c484bc5585a$var$h(2, arguments);
    var r = String(e), a = n || {}, i = a.locale || $48515c484bc5585a$var$l, o = i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $48515c484bc5585a$var$f(o), s = null == a.firstWeekContainsDate ? u : $48515c484bc5585a$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var c = i.options && i.options.weekStartsOn, d = null == c ? 0 : $48515c484bc5585a$var$f(c), w = null == a.weekStartsOn ? d : $48515c484bc5585a$var$f(a.weekStartsOn);
    if (!(w >= 0 && w <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!i.localize) throw new RangeError("locale must contain localize property");
    if (!i.formatLong) throw new RangeError("locale must contain formatLong property");
    var v = $48515c484bc5585a$var$m(t);
    if (!$48515c484bc5585a$var$Ut(v)) throw new RangeError("Invalid time value");
    var y = $48515c484bc5585a$var$p(v), b = $48515c484bc5585a$var$g(v, y), T = {
        firstWeekContainsDate: s,
        weekStartsOn: w,
        locale: i,
        _originalDate: v
    }, k = r.match($48515c484bc5585a$var$Kt).map(function(t) {
        var e = t[0];
        return "p" === e || "P" === e ? (0, $48515c484bc5585a$var$D[e])(t, i.formatLong, T) : t;
    }).join("").match($48515c484bc5585a$var$jt).map(function(t) {
        if ("''" === t) return "'";
        var e = t[0];
        if ("'" === e) return $48515c484bc5585a$var$Vt(t);
        var n = $48515c484bc5585a$var$Xt[e];
        if (n) return !a.useAdditionalWeekYearTokens && $48515c484bc5585a$var$M(t) && $48515c484bc5585a$var$U(t), !a.useAdditionalDayOfYearTokens && $48515c484bc5585a$var$C(t) && $48515c484bc5585a$var$U(t), n(b, t, i.localize, T);
        if (e.match($48515c484bc5585a$var$_t)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + e + "`");
        return t;
    }).join("");
    return k;
}
function $48515c484bc5585a$var$Vt(t) {
    return t.match($48515c484bc5585a$var$Jt)[1].replace($48515c484bc5585a$var$Zt, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $48515c484bc5585a$var$te(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e);
    return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}
function $48515c484bc5585a$var$ee(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = t || {}, r = $48515c484bc5585a$var$m(n.start), a = $48515c484bc5585a$var$m(n.end), i = a.getTime();
    if (!(r.getTime() <= i)) throw new RangeError("Invalid interval");
    var o = [], u = r;
    u.setHours(0, 0, 0, 0);
    var s = e && "step" in e ? Number(e.step) : 1;
    if (s < 1 || isNaN(s)) throw new RangeError("`options.step` must be a number greater than 1");
    for(; u.getTime() <= i;)o.push($48515c484bc5585a$var$m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0);
    return o;
}
function $48515c484bc5585a$var$ne(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $48515c484bc5585a$var$m(t), s = u.getDay(), c = 6 + (s < o ? -7 : 0) - (s - o);
    return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u;
}
function $48515c484bc5585a$var$re(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function $48515c484bc5585a$var$ae(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $48515c484bc5585a$var$m(t), s = u.getDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u;
}
function $48515c484bc5585a$export$fa1807b86c22c08c(t) {
    var e = void 0 === t ? {} : t, n = e.firstDayOfWeek, r = void 0 === n ? 1 : n, a = e.weekdayLabelFormat, i = void 0 === a ? function(t) {
        return $48515c484bc5585a$var$$t(t, "iiiiii");
    } : a, o = new Date();
    return $48515c484bc5585a$var$ee({
        start: $48515c484bc5585a$var$te($48515c484bc5585a$var$ae(o), r),
        end: $48515c484bc5585a$var$te($48515c484bc5585a$var$ne(o), r)
    }).reduce(function(t, e) {
        return t.push(i(e)), t;
    }, []);
}
function $48515c484bc5585a$export$5f84d4e06c0693c4(t) {
    var e = t.year, n = t.month, r = t.firstDayOfWeek, a = void 0 === r ? 1 : r, i = t.dayLabelFormat, o = void 0 === i ? function(t) {
        return $48515c484bc5585a$var$$t(t, "dd");
    } : i, u = new Date(e, n), s = $48515c484bc5585a$var$re(u), c = function(t) {
        $48515c484bc5585a$var$h(1, arguments);
        var e = $48515c484bc5585a$var$m(t), n = e.getDay();
        return n;
    }(s), d = function(t) {
        $48515c484bc5585a$var$h(1, arguments);
        var e = $48515c484bc5585a$var$m(t), n = e.getMonth();
        return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
    }(u);
    return function() {
        for(var t = 0, e = 0, n = arguments.length; e < n; e++)t += arguments[e].length;
        var r = Array(t), a = 0;
        for(e = 0; e < n; e++)for(var i = arguments[e], o = 0, u = i.length; o < u; o++, a++)r[a] = i[o];
        return r;
    }(Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0), $48515c484bc5585a$var$ee({
        start: s,
        end: d
    }).map(function(t) {
        return {
            date: t,
            dayLabel: o(t)
        };
    }));
}
var $48515c484bc5585a$export$ae8ce18f4c87a98d = function(t) {
    return $48515c484bc5585a$var$$t(t, "dd");
}, $48515c484bc5585a$export$c91a7ea1bd918f41 = function(t) {
    return $48515c484bc5585a$var$$t(t, "eeeeee");
}, $48515c484bc5585a$export$85e553ba2321487b = function(t) {
    return $48515c484bc5585a$var$$t(t, "MMMM yyyy");
};
function $48515c484bc5585a$export$41527c87dc759868(e) {
    var n = e.year, r = e.month, a = e.firstDayOfWeek, i = void 0 === a ? 1 : a, o = e.dayLabelFormat, u = void 0 === o ? $48515c484bc5585a$export$ae8ce18f4c87a98d : o, s = e.weekdayLabelFormat, c = void 0 === s ? $48515c484bc5585a$export$c91a7ea1bd918f41 : s, d = e.monthLabelFormat, l = void 0 === d ? $48515c484bc5585a$export$85e553ba2321487b : d;
    return {
        days: (0, $dup7A.useMemo)(function() {
            return $48515c484bc5585a$export$5f84d4e06c0693c4({
                year: n,
                month: r,
                firstDayOfWeek: i,
                dayLabelFormat: u
            });
        }, [
            n,
            r,
            i,
            u
        ]),
        weekdayLabels: (0, $dup7A.useMemo)(function() {
            return $48515c484bc5585a$export$fa1807b86c22c08c({
                firstDayOfWeek: i,
                weekdayLabelFormat: c
            });
        }, [
            i,
            c
        ]),
        monthLabel: l(new Date(n, r))
    };
}
function $48515c484bc5585a$var$le(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$m(e);
    return n.getTime() < r.getTime();
}
function $48515c484bc5585a$var$fe(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$m(e);
    return n.getTime() > r.getTime();
}
function $48515c484bc5585a$var$he(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = e || {}, r = $48515c484bc5585a$var$m(t).getTime(), a = $48515c484bc5585a$var$m(n.start).getTime(), i = $48515c484bc5585a$var$m(n.end).getTime();
    if (!(a <= i)) throw new RangeError("Invalid interval");
    return r >= a && r <= i;
}
function $48515c484bc5585a$var$me(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return e.setHours(0, 0, 0, 0), e;
}
function $48515c484bc5585a$var$we(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$me(t), r = $48515c484bc5585a$var$me(e);
    return n.getTime() === r.getTime();
}
function $48515c484bc5585a$var$ge(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e);
    if (isNaN(r)) return new Date(NaN);
    if (!r) return n;
    var a = n.getDate(), i = new Date(n.getTime());
    i.setMonth(n.getMonth() + r + 1, 0);
    var o = i.getDate();
    return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
var $48515c484bc5585a$var$ve = function(t, e) {
    return void 0 === t && (t = []), t.some(function(t) {
        return $48515c484bc5585a$var$we(e, t);
    });
};
function $48515c484bc5585a$export$b165a5bc4ad10935(t, e, n) {
    return !(!e || !n) && $48515c484bc5585a$var$he(t, {
        start: e,
        end: n
    });
}
function $48515c484bc5585a$export$8260647f4936851e(t, e, n) {
    return !!(e && $48515c484bc5585a$var$we(t, e) || n && $48515c484bc5585a$var$we(t, n));
}
function $48515c484bc5585a$export$c8db6e7f6335237c(t, e) {
    return !(!e || !$48515c484bc5585a$var$we(t, e));
}
function $48515c484bc5585a$export$b3c72c1338a4197(t, e) {
    return !(!e || !$48515c484bc5585a$var$we(t, e));
}
function $48515c484bc5585a$export$757515830049c710(t) {
    var e = t.date, n = t.minBookingDate, r = t.maxBookingDate, a = t.isDateBlockedFn, i = t.startDate, o = t.endDate, u = t.minBookingDays, s = void 0 === u ? 1 : u, c = t.unavailableDates, d = void 0 === c ? [] : c, l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n, f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
    return !!($48515c484bc5585a$var$ve(d, e) || l && $48515c484bc5585a$var$le(e, l) || f && $48515c484bc5585a$var$fe(e, f) || i && !o && s > 1 && $48515c484bc5585a$var$he(e, {
        start: i,
        end: $48515c484bc5585a$var$te(i, s - 2)
    }) || a && a(e));
}
function $48515c484bc5585a$export$3046c068c9f01601(t) {
    var e = $48515c484bc5585a$var$re(t);
    return {
        year: function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getFullYear();
            return n;
        }(e),
        month: function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getMonth();
            return n;
        }(e),
        date: e
    };
}
function $48515c484bc5585a$export$f446e9d44b503a48() {
    return $48515c484bc5585a$export$3046c068c9f01601($48515c484bc5585a$var$me(Date.now()));
}
function $48515c484bc5585a$export$6b0a3e73eaccfee4(t, e) {
    var n = e ? $48515c484bc5585a$export$3046c068c9f01601(e) : $48515c484bc5585a$export$f446e9d44b503a48(), r = n.date, a = [
        n
    ];
    return t > 1 && (a = Array.from(Array(t - 1).keys()).reduce(function(t) {
        return r = $48515c484bc5585a$var$ge(t[t.length - 1].date, 1), t.concat([
            $48515c484bc5585a$export$3046c068c9f01601(r)
        ]);
    }, a)), a;
}
function $48515c484bc5585a$var$Me(t, e, n, r) {
    var a = t[r ? n > 0 ? 0 : t.length - r : n > 0 ? t.length - 1 : 0].date;
    return Array.from(Array(e).keys()).reduce(function(t) {
        return a = 0 === t.length ? $48515c484bc5585a$var$ge(a, n) : $48515c484bc5585a$var$ge(a, n >= 0 ? 1 : -1), n > 0 ? t.concat([
            $48515c484bc5585a$export$3046c068c9f01601(a)
        ]) : [
            $48515c484bc5585a$export$3046c068c9f01601(a)
        ].concat(t);
    }, []);
}
function $48515c484bc5585a$export$c5e4b84d2ce61726(t, e, n) {
    return t && "string" == typeof e ? $48515c484bc5585a$var$$t(t, e) : t && "function" == typeof e ? e(t) : n;
}
function $48515c484bc5585a$var$Se(t) {
    var e = t.startDate, n = t.endDate, r = t.isDateBlocked, a = t.minBookingDays, i = t.exactMinBookingDays, o = t.minBookingDate, u = t.maxBookingDate, s = !o || !$48515c484bc5585a$var$le(e, $48515c484bc5585a$var$te(o, -1)), c = !u || !$48515c484bc5585a$var$fe($48515c484bc5585a$var$te(e, a - 1), u);
    return !(!e || 1 !== a || n || r(e)) || (e && a > 1 && !n && !i || e && a > 0 && i && s && c || e && a > 0 && i && !o && !u ? !$48515c484bc5585a$var$ee({
        start: e,
        end: $48515c484bc5585a$var$te(e, a - 1)
    }).some(function(t) {
        return r(t);
    }) : !(!e || !n || i) && !$48515c484bc5585a$var$le(n, $48515c484bc5585a$var$te(e, a - 1)) && !$48515c484bc5585a$var$ee({
        start: e,
        end: n
    }).some(function(t) {
        return r(t);
    }));
}
var $48515c484bc5585a$export$99a467bcc22b8df9 = "startDate", $48515c484bc5585a$export$1113b91e67d28ba7 = "endDate";
function $48515c484bc5585a$export$2d9bfdb55c82a287(t) {
    var a = t.startDate, i = t.endDate, o = t.focusedInput, u = t.minBookingDate, s = t.maxBookingDate, c = t.onDatesChange, d = t.initialVisibleMonth, l = t.exactMinBookingDays, f = void 0 !== l && l, h = t.minBookingDays, m = void 0 === h ? 1 : h, w = t.numberOfMonths, g = void 0 === w ? 2 : w, v = t.firstDayOfWeek, y = void 0 === v ? 1 : v, b = t.isDateBlocked, D = void 0 === b ? function() {
        return !1;
    } : b, T = t.unavailableDates, p = void 0 === T ? [] : T, k = t.changeActiveMonthOnSelect, x = void 0 === k || k, C = (0, $dup7A.useState)(function() {
        return $48515c484bc5585a$export$6b0a3e73eaccfee4(g, a || d || null);
    }), M = C[0], U = C[1], S = (0, $dup7A.useState)(null), P = S[0], E = S[1], Y = (0, $dup7A.useState)(a), N = Y[0], q = Y[1];
    (0, $dup7A.useEffect)(function() {
        return "undefined" != typeof window && window.addEventListener && window.addEventListener("keydown", L), function() {
            window.removeEventListener && window.removeEventListener("keydown", L);
        };
    });
    var B = function(t) {
        return $48515c484bc5585a$var$ve(p, t) || D(t);
    }, O = function(t) {
        q(t), (!N || N && !$48515c484bc5585a$var$we(t, N)) && U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t));
    }, H = function(t) {
        return $48515c484bc5585a$export$757515830049c710({
            date: t,
            minBookingDate: u,
            maxBookingDate: s,
            startDate: a,
            endDate: i,
            minBookingDays: m,
            isDateBlockedFn: B
        });
    };
    function L(t) {
        if (("ArrowRight" === t.key || "ArrowLeft" === t.key || "ArrowDown" === t.key || "ArrowUp" === t.key) && !N) {
            var e = M[0];
            O(e.date), U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, e.date));
        }
    }
    var W = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, -1)), q(null);
    }, [
        M,
        g
    ]), F = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, -1, 1)), q(null);
    }, [
        M,
        g
    ]), Q = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, 1)), q(null);
    }, [
        M,
        g
    ]), R = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, 1, 1)), q(null);
    }, [
        M,
        g
    ]), I = (0, $dup7A.useCallback)(function(t) {
        U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t)), q(null);
    }, [
        g
    ]), X = (0, $dup7A.useCallback)(function(t) {
        void 0 === t && (t = 1), U($48515c484bc5585a$var$Me(M, g, -(12 * t - g + 1))), q(null);
    }, [
        M,
        g
    ]), G = (0, $dup7A.useCallback)(function(t) {
        void 0 === t && (t = 1), U($48515c484bc5585a$var$Me(M, g, 12 * t - g + 1)), q(null);
    }, [
        M,
        g
    ]);
    return {
        firstDayOfWeek: y,
        activeMonths: M,
        isDateSelected: function(t) {
            return $48515c484bc5585a$export$b165a5bc4ad10935(t, a, i);
        },
        isDateHovered: function(t) {
            return function(t) {
                var e = t.date, n = t.startDate, r = t.endDate, a = t.isDateBlocked, i = t.hoveredDate, o = t.minBookingDays, u = t.exactMinBookingDays;
                return i && o > 1 && u && $48515c484bc5585a$var$he(e, {
                    start: i,
                    end: $48515c484bc5585a$var$te(i, o - 1)
                }) ? !$48515c484bc5585a$var$ee({
                    start: i,
                    end: $48515c484bc5585a$var$te(i, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : n && !r && i && $48515c484bc5585a$var$he(e, {
                    start: n,
                    end: $48515c484bc5585a$var$te(n, o - 1)
                }) && $48515c484bc5585a$var$we(n, i) && o > 1 ? !$48515c484bc5585a$var$ee({
                    start: n,
                    end: $48515c484bc5585a$var$te(n, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : !(!n || r || !i || $48515c484bc5585a$var$le(i, n) || !$48515c484bc5585a$var$he(e, {
                    start: n,
                    end: i
                })) && !$48515c484bc5585a$var$ee({
                    start: n,
                    end: i
                }).some(function(t) {
                    return a(t);
                });
            }({
                date: t,
                hoveredDate: P,
                startDate: a,
                endDate: i,
                minBookingDays: m,
                exactMinBookingDays: f,
                isDateBlocked: B
            });
        },
        isFirstOrLastSelectedDate: function(t) {
            return $48515c484bc5585a$export$8260647f4936851e(t, a, i);
        },
        isStartDate: function(t) {
            return $48515c484bc5585a$export$c8db6e7f6335237c(t, a);
        },
        isEndDate: function(t) {
            return $48515c484bc5585a$export$b3c72c1338a4197(t, i);
        },
        isDateBlocked: H,
        numberOfMonths: g,
        isDateFocused: function(t) {
            return !!N && $48515c484bc5585a$var$we(t, N);
        },
        focusedDate: N,
        hoveredDate: P,
        onResetDates: function() {
            c({
                startDate: null,
                endDate: null,
                focusedInput: "startDate"
            });
        },
        onDateHover: function(t) {
            if (t) {
                if (t) {
                    var e = !H(t) || a && $48515c484bc5585a$var$we(t, a), n = !u || !$48515c484bc5585a$var$le(t, $48515c484bc5585a$var$te(u, -1)), r = !s || !$48515c484bc5585a$var$fe(t, s), o = $48515c484bc5585a$var$te(t, m - 1), c = !u || !$48515c484bc5585a$var$le(o, u), d = !s || !$48515c484bc5585a$var$fe(o, s), l = f && m > 1 && n && r && c && d, h = a && !i && !f && n && r, w = !(m > 1 && a) || $48515c484bc5585a$var$he(t, {
                        start: a,
                        end: $48515c484bc5585a$var$te(a, m - 2)
                    }), g = a && $48515c484bc5585a$var$we(t, a) && w;
                    e && (l || h || g) ? E(t) : null !== P && E(null);
                }
            } else E(null);
        },
        onDateSelect: function(t) {
            ("endDate" === o || "startDate" === o) && m > 0 && f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                exactMinBookingDays: f,
                minBookingDate: u,
                maxBookingDate: s,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                startDate: t,
                endDate: $48515c484bc5585a$var$te(t, m - 1),
                focusedInput: null
            }) : ("endDate" === o && a && $48515c484bc5585a$var$le(t, a) || "startDate" === o && i && $48515c484bc5585a$var$fe(t, i)) && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: "endDate"
            }) : "startDate" === o && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: i,
                startDate: t
            }) ? c({
                endDate: i,
                startDate: t,
                focusedInput: "endDate"
            }) : "startDate" === o && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: null,
                startDate: t
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: "endDate"
            }) : "endDate" === o && a && !$48515c484bc5585a$var$le(t, a) && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: a,
                endDate: t
            }) && c({
                startDate: a,
                endDate: t,
                focusedInput: null
            }), "endDate" !== o && (!N || N && !$48515c484bc5585a$var$we(t, N)) && x && U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t));
        },
        onDateFocus: O,
        goToPreviousMonths: W,
        goToPreviousMonthsByOneMonth: F,
        goToNextMonths: Q,
        goToNextMonthsByOneMonth: R,
        goToDate: I,
        goToPreviousYear: X,
        goToNextYear: G
    };
}
function $48515c484bc5585a$export$1937086c6b64f72d(t) {
    var e = t.date, n = t.focusedDate, a = t.isDateSelected, i = t.isDateFocused, o = t.isFirstOrLastSelectedDate, u = t.isDateHovered, s = t.isDateBlocked, c = t.onDateSelect, d = t.onDateFocus, l = t.onDateHover, f = (0, $dup7A.useCallback)(function() {
        return c(e);
    }, [
        e,
        c
    ]), h = (0, $dup7A.useCallback)(function() {
        return l(e);
    }, [
        e,
        l
    ]), m = s(e) && !u(e);
    return {
        tabIndex: null === n || i(e) ? 0 : -1,
        isSelected: a(e),
        isSelectedStartOrEnd: o(e),
        isWithinHoverRange: u(e),
        disabledDate: m,
        onKeyDown: function(t) {
            "ArrowRight" === t.key ? d($48515c484bc5585a$var$te(e, 1)) : "ArrowLeft" === t.key ? d($48515c484bc5585a$var$te(e, -1)) : "ArrowUp" === t.key ? d($48515c484bc5585a$var$te(e, -7)) : "ArrowDown" === t.key && d($48515c484bc5585a$var$te(e, 7));
        },
        onClick: m ? function() {} : f,
        onMouseEnter: h
    };
}


function $43afcb05ca3681f6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $43afcb05ca3681f6$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Accordion", function() {
    return $43afcb05ca3681f6$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CustomAccordion", function() {
    return $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Button", function() {
    return $43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Card", function() {
    return $43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Box", function() {
    return $43afcb05ca3681f6$var$$476168fcb44518cc$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplayLarge", function() {
    return $43afcb05ca3681f6$var$$ec746cba4029e202$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplayIcon", function() {
    return $43afcb05ca3681f6$var$$e0180679e35f2273$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplaySmall", function() {
    return $43afcb05ca3681f6$var$$d98b0fa15808b520$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DropdownSelect", function() {
    return $43afcb05ca3681f6$var$$69ead81f7adc490a$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DropdownCascader", function() {
    return $43afcb05ca3681f6$var$$d8e895830981b43b$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Field", function() {
    return $43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Searchbar", function() {
    return $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Textarea", function() {
    return $43afcb05ca3681f6$var$$870ba58bccab6eec$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Slider", function() {
    return $43afcb05ca3681f6$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "FileUploader", function() {
    return $43afcb05ca3681f6$var$$eab617fde0d2a814$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Datepicker", function() {
    return $43afcb05ca3681f6$var$$1d445195934320ed$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Radio", function() {
    return $43afcb05ca3681f6$var$$86e1d79a67710eda$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Checkbox", function() {
    return $43afcb05ca3681f6$var$$b679852ecf8e9c02$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Switch", function() {
    return $43afcb05ca3681f6$var$$34871b0f15f7c161$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "AlertMessage", function() {
    return $43afcb05ca3681f6$var$$d963730b715e990c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "PushMessage", function() {
    return $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CompactPagination", function() {
    return $43afcb05ca3681f6$var$$831351fb15d68ad0$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "StandardPagination", function() {
    return $43afcb05ca3681f6$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tabs", function() {
    return $43afcb05ca3681f6$var$$35a1a5ac66949050$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Breadcrumb", function() {
    return $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "LinearProgress", function() {
    return $43afcb05ca3681f6$var$$8688d42e9f1d381a$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CircularProgress", function() {
    return $43afcb05ca3681f6$var$$e09296aea30ed10d$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Steps", function() {
    return $43afcb05ca3681f6$var$$250cfcb8116ed97e$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Timeline", function() {
    return $43afcb05ca3681f6$var$$c3e303edb7751c77$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CustomTimeline", function() {
    return $43afcb05ca3681f6$var$$a3f868921843a442$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tag", function() {
    return $43afcb05ca3681f6$var$$4c05722f1abfb34c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tooltip", function() {
    return $43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "ScrollbarContainer", function() {
    return $43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Copiable", function() {
    return $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "lightTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$f30cb9bc4f736419;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "darkTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$3e936a8db52a10a0;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "veaTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$a183395ddd946500;
});
function $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea(element, callback) {
    (0, $dup7A.useLayoutEffect)(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            callback(element, entries[0]);
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element
    ]);
}
var $43afcb05ca3681f6$var$$e1b614a35dc83093$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea;
function $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8() {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, $dup7A.useState)(null);
    const [size, setSize] = (0, $dup7A.useState)({
        width: 0,
        height: 0
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, $dup7A.useCallback)(()=>{
        setSize({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $554092f59a7e7485$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $554092f59a7e7485$export$700979bc83e7db82)(()=>{
        handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea(ref, handleSize);
    return [
        setRef,
        size
    ];
}
var $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8;
const $43afcb05ca3681f6$var$$f15a4f5132e5ea52$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z"
        })
    });
var $43afcb05ca3681f6$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$f15a4f5132e5ea52$var$SvgPlus;
const $43afcb05ca3681f6$var$$ed272acf889bf255$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M15.826.333H.174A.174.174 0 0 0 0 .507v1.305c0 .095.078.174.174.174h15.652A.174.174 0 0 0 16 1.812V.507a.174.174 0 0 0-.174-.174Z"
        })
    });
var $43afcb05ca3681f6$var$$ed272acf889bf255$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ed272acf889bf255$var$SvgMinus;
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30 = (styleFn)=>(0, $e9f8389e4f70b5af$exports.css)([
        "@media (max-width:900px){",
        "}"
    ], styleFn());
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:24px;font-weight:600;line-height:33px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:16px;font-weight:600;line-height:22px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:16px;font-weight:400;line-height:22px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:14px;font-weight:400;line-height:19px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b4adb3f464574dcf = (0, $e9f8389e4f70b5af$exports.css)([
    "opacity:1;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68 = (0, $e9f8389e4f70b5af$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$463b44d9bf3628be = (0, $e9f8389e4f70b5af$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;text-transform:none;-webkit-appearance:button;:hover:enabled{cursor:pointer;}"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b7e3ae3d7c15e42e = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b9d336f245a516e8 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$2e6c959c16ff56b8 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;text-transform:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$a3574df893ffa88d = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26 = (0, $e9f8389e4f70b5af$exports.css)([
    "box-sizing:border-box;*,*:before,*:after{box-sizing:border-box;}"
]);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$StyledDiv = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__StyledDiv",
    componentId: "sc-17yp2l-0"
})([
    "margin:8px 0px;.accordion-button{",
    " width:100%;background:",
    ";border-radius:3px;padding:11.5px 32px;display:flex;justify-content:space-between;align-items:center;.accordion-svg{",
    " height:16px;width:16px;fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsPrimaryPurple, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Collapsible = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__Collapsible",
    componentId: "sc-17yp2l-1"
})([
    "height:",
    "px;overflow:",
    ";transition:height ease ",
    ";"
], (props)=>props.expanded ? props.totalHeight.toString() : "0", (props)=>props.expanded ? "visible" : "hidden", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Body = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__Body",
    componentId: "sc-17yp2l-2"
})([
    "padding:32px;"
]);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$AccordionItem = ({ title: title, body: body, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const [ref, { height: height }] = $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("button", {
                className: "accordion-button",
                onClick: ()=>setExpanded(expanded ? -1 : index),
                children: [
                    title,
                    expanded ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$ed272acf889bf255$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Collapsible, {
                expanded: expanded,
                totalHeight: height,
                children: /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Body, {
                    ref: ref,
                    children: [
                        " ",
                        body,
                        " "
                    ]
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$AccordionItem;
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion__Wrapper",
    componentId: "sc-7o1u6g-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$AccordionTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "accordion__AccordionTitle",
    componentId: "sc-7o1u6g-1"
})([
    "",
    " width:fit-content;font-weight:600;text-align:center;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$DefaultTitle = ({ item: item })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($cZGFG.Fragment, {
        children: [
            item.icon ?? (item.Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(item.Icon, {})),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$AccordionTitle, {
                children: item.title
            })
        ]
    });
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Accordion = ({ items: items, defaultExpanded: defaultExpanded, ...props })=>{
    const [expanded, setExpanded] = (0, $dup7A.useState)(defaultExpanded ?? -1);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$DefaultTitle, {
                    item: item
                }),
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $43afcb05ca3681f6$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Accordion;
const $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-dc5dy3-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$CustomAccordion = ({ items: items, ...props })=>{
    const [expanded, setExpanded] = (0, $dup7A.useState)(-1);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: item.title,
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$CustomAccordion;
const $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$breathing = (0, $e9f8389e4f70b5af$exports.keyframes)([
    "0%{transform:scale(1);}50%{transform:scale(1.3);}100%{transform:scale(1);}"
]);
const $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$BaseButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "base__BaseButton",
    componentId: "sc-15fqe1k-0"
})([
    "",
    " ",
    " position:relative;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:",
    ";border-radius:3px;border:none;transition:background ease ",
    ";.button-text{",
    " ",
    " font-weight:600;text-align:center;white-space:pre;}.button-svg{",
    " ",
    " height:16px;width:16px;margin-right:8px;}.button-loading{position:absolute;height:22px;fill:",
    ";animation:",
    " 2s ease-out infinite normal;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>{
    if (props.small) return props.variant === "secondary" ? "5px 23px" : "6px 24px";
    return props.variant === "secondary" ? "10.5px 31px" : "11.5px 32px";
}, (props)=>props.theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$breathing);
var $43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$BaseButton;
const $43afcb05ca3681f6$var$$64030e1eefd54f6b$var$PrimaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "primary__PrimaryButton",
    componentId: "sc-1cfrthg-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsSecondaryBlue);
var $43afcb05ca3681f6$var$$64030e1eefd54f6b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$64030e1eefd54f6b$var$PrimaryButton;
const $43afcb05ca3681f6$var$$e015af9dc133eba5$var$SecondaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "secondary__SecondaryButton",
    componentId: "sc-urt0vi-0"
})([
    "background:",
    ";border:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? `1px solid ${props.theme.klerosUIComponentsStroke}` : `1px solid ${props.theme.klerosUIComponentsPrimaryBlue}`, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsMediumBlue);
var $43afcb05ca3681f6$var$$e015af9dc133eba5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e015af9dc133eba5$var$SecondaryButton;
const $43afcb05ca3681f6$var$$a028db5d769593a3$var$TertiaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "tertiary__TertiaryButton",
    componentId: "sc-jvmd2g-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryPurple, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsPrimaryPurple);
var $43afcb05ca3681f6$var$$a028db5d769593a3$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a028db5d769593a3$var$TertiaryButton;
const $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m14.545 3.992 21.06.94 8.526 18.92L32.1 41.143 10.929 39.79l-8.68-20.5L14.544 3.993Zm15.44 10.906-15.263 6.66L27.77 31.634l2.214-16.736Zm-1.768-3.337L16.02 6.316l-2.562 11.028 14.76-5.783Zm-3.091 22.608-13.257-9.454.321 12.81 12.936-3.356ZM42.013 23.81l-9.033-9.154-2.384 17.604 11.417-8.45Zm-13.78 12.418-11.18 2.918 13.148.84-1.967-3.758Zm12.015-8.264-9.786 7.28 1.944 3.796 7.842-11.076Zm-4.63-20.388-1.9 3.897 7.075 7.182-5.174-11.08ZM33.252 5.71l-12.424-.504 10.248 4.477 2.176-3.973ZM12.73 7.513 4.028 18.487l5.819 1.23L12.73 7.514ZM9.496 21.871 3.65 20.635l6.1 14.352-.254-13.116Z"
        })
    });
var $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$var$SvgKleros;
const $43afcb05ca3681f6$var$$2987665db72ba3c1$var$Button = ({ text: text, variant: variant, Icon: Icon, icon: icon, onClick: onClick, isLoading: isLoading, ...props })=>{
    let ButtonType = $43afcb05ca3681f6$var$$64030e1eefd54f6b$export$2e2bcd8739ae039;
    if (variant === "secondary") ButtonType = $43afcb05ca3681f6$var$$e015af9dc133eba5$export$2e2bcd8739ae039;
    if (variant === "tertiary") ButtonType = $43afcb05ca3681f6$var$$a028db5d769593a3$export$2e2bcd8739ae039;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)(ButtonType, {
        variant: variant,
        onClick: onClick,
        isLoading: isLoading,
        ...props,
        children: [
            isLoading && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039, {
                className: "button-loading"
            }),
            icon ?? (Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                className: "button-svg"
            })),
            /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                className: "button-text",
                children: text
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2987665db72ba3c1$var$Button;
const $43afcb05ca3681f6$var$$48087ec110ef8615$var$Card = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "card__Card",
    componentId: "sc-1g2jfm3-0"
})([
    "",
    " background:",
    ";border:1px solid ",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:",
    ";width:328px;height:200px;transition:box-shadow ease ",
    ";",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, ({ round: round })=>round ? "18px" : "3px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme, hover: hover })=>hover && `
      :hover {
        box-shadow: 0px 6px 9px ${theme.klerosUIComponentsHoveredShadow};
        cursor: pointer;
      }
  `);
var $43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$48087ec110ef8615$var$Card;
const $43afcb05ca3681f6$var$$476168fcb44518cc$var$Box = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "box__Box",
    componentId: "sc-1by74ub-0"
})([
    "",
    " background:",
    ";border-radius:18px;width:328px;height:200px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
var $43afcb05ca3681f6$var$$476168fcb44518cc$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$476168fcb44518cc$var$Box;
const $43afcb05ca3681f6$var$$ec746cba4029e202$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "large__StyledCard",
    componentId: "sc-1f0y32e-0"
})([
    "position:relative;height:80px;width:288px;padding:16px;display:flex;flex-direction:column;align-items:start;justify-content:center;.display-icon{",
    " position:absolute;top:16px;right:16px;max-height:16px;max-width:16px;}.display-text{",
    "}.display-label{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$ec746cba4029e202$var$DisplayLarge = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$ec746cba4029e202$var$StyledCard, {
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                className: "display-icon"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                className: "display-text",
                children: text
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                className: "display-label",
                children: label
            })
        ]
    });
var $43afcb05ca3681f6$var$$ec746cba4029e202$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ec746cba4029e202$var$DisplayLarge;
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__StyledCard",
    componentId: "sc-12ixf6j-0"
})([
    "height:80px;width:288px;padding:16px;display:flex;"
]);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$Text = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "icon__Text",
    componentId: "sc-12ixf6j-1"
})([
    "",
    " height:100%;width:auto;margin-left:16px;flex-direction:column;align-items:start;justify-content:center;.display-text{",
    "}.display-label{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$IconCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__IconCard",
    componentId: "sc-12ixf6j-2"
})([
    "height:48px;width:48px;display:flex;justify-content:center;align-items:center;.display-icon{",
    " max-height:32px;max-width:32px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$DisplayIcon = ({ text: text, Icon: Icon, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$e0180679e35f2273$var$StyledCard, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$e0180679e35f2273$var$IconCard, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                    className: "display-icon"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$e0180679e35f2273$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                        className: "display-text",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        className: "display-label",
                        children: label
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$e0180679e35f2273$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e0180679e35f2273$var$DisplayIcon;
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "small__Wrapper",
    componentId: "sc-ismyqd-0"
})([
    "",
    " width:217px;display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "small__StyledLabel",
    componentId: "sc-ismyqd-1"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "small__StyledCard",
    componentId: "sc-ismyqd-2"
})([
    "height:45px;width:100%;margin-top:16px;display:flex;align-items:center;padding:0px 16px;.display-icon{",
    " max-height:16px;max-width:16px;margin-right:8px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "small__StyledText",
    componentId: "sc-ismyqd-3"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$DisplaySmall = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledCard, {
                children: [
                    Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                        className: "display-icon"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledText, {
                        children: text
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$d98b0fa15808b520$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d98b0fa15808b520$var$DisplaySmall;
//! type
//eslint-disable-next-line @typescript-eslint/ban-types
function $43afcb05ca3681f6$var$$bfcc265ae6655ec9$var$useFocusOutside(ref, callback) {
    (0, $dup7A.useEffect)(()=>{
        function handleEvent(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener("focusin", handleEvent);
        document.addEventListener("mousedown", handleEvent);
        return ()=>{
            document.removeEventListener("focusin", handleEvent);
            document.removeEventListener("mousedown", handleEvent);
        };
    }, [
        ref,
        callback
    ]);
}
var $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$bfcc265ae6655ec9$var$useFocusOutside;
const $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 12 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M11.598.25H.402C.067.25-.121.605.087.847l5.598 6.49c.16.186.468.186.63 0l5.598-6.49c.208-.242.02-.597-.316-.597Z"
        })
    });
var $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$var$SvgArrow;
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "button__Container",
    componentId: "sc-wywpa8-0"
})([
    "",
    " ",
    " width:240px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:space-between;padding:0px 16px 0px 0px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)(({ ignoredIsOpen: ignoredIsOpen, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "button__StyledArrow",
    componentId: "sc-wywpa8-1"
})([
    "",
    " width:16px;height:16px;fill:",
    ";",
    " transition:transform ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ ignoredIsOpen: ignoredIsOpen })=>ignoredIsOpen && (0, $e9f8389e4f70b5af$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$DropdownButton = ({ node: node, isOpen: isOpen, setIsOpen: setIsOpen, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$43d9fcbe58645246$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            node,
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$43d9fcbe58645246$var$DropdownButton;
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "simple-button__Container",
    componentId: "sc-rpqfxz-0"
})([
    "",
    " ",
    " background:none;display:flex;align-items:center;padding:0px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledSmallText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "simple-button__StyledSmallText",
    componentId: "sc-rpqfxz-1"
})([
    "",
    " font-weight:600;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledBigText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h1.withConfig({
    displayName: "simple-button__StyledBigText",
    componentId: "sc-rpqfxz-2"
})([
    "",
    " font-weight:600;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)(({ ignoredIsOpen: ignoredIsOpen, ignoredSmall: ignoredSmall, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "simple-button__StyledArrow",
    componentId: "sc-rpqfxz-3"
})([
    "",
    " width:",
    "px;height:",
    "px;fill:",
    ";",
    " transition:transform ease ",
    ";margin-left:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ ignoredSmall: small })=>small ? "8" : "16", ({ ignoredSmall: small })=>small ? "8" : "16", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ ignoredIsOpen: isOpen })=>isOpen && (0, $e9f8389e4f70b5af$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$DropdownButton = ({ text: text, isOpen: isOpen, setIsOpen: setIsOpen, small: small, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            small ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledSmallText, {
                children: text
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledBigText, {
                children: text
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ignoredSmall: small,
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$83ebe14398e57e2d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$DropdownButton;
const $43afcb05ca3681f6$var$$b252c20c2dedb54c$var$CustomScrollbarContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$parcel$interopDefault($bbbd8fadaf5f7664$exports)).withConfig({
    displayName: "scrollbar__CustomScrollbarContainer",
    componentId: "sc-16x8nkv-0"
})([
    "",
    " .simplebar-scrollbar:before{background:",
    ";}.simplebar-scrollbar.simplebar-visible:before{opacity:1;}.simplebar-mask{background:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
var $43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b252c20c2dedb54c$var$CustomScrollbarContainer;
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "base-item-container__ItemContainer",
    componentId: "sc-1h7f57o-0"
})([
    "",
    " flex:1;width:238px;height:auto;background:",
    ";padding:16px 0px;display:grid;grid-template-rows:repeat(auto-fill,minmax(0,45px));"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item-container__StyledScrollbarContainer",
    componentId: "sc-1h7f57o-1"
})([
    "width:238px;max-height:350px;"
]);
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar = ({ children: children, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer, {
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainer, {
            children: children
        })
    });
var $43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar;
const $43afcb05ca3681f6$var$$66882cfb76c803d6$var$Dot = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dot__Dot",
    componentId: "sc-1v9nycp-0"
})([
    "",
    " background:",
    ";border-radius:50%;width:8px;height:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ color: color })=>color);
var $43afcb05ca3681f6$var$$66882cfb76c803d6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$66882cfb76c803d6$var$Dot;
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$Item = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "base-item__Item",
    componentId: "sc-1q4tyix-0"
})([
    "",
    " background:",
    ";padding:",
    ";display:flex;align-items:center;",
    " .item-icon{",
    " max-height:16px;max-width:16px;min-height:12px;min-width:12px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsMediumBlue : theme.klerosUIComponentsWhiteBackground, ({ current: current })=>current ? "10.5px 16px 10.5px 13px" : "11.5px 16px 11.5px 13px", (props)=>!props.current && (0, $e9f8389e4f70b5af$exports.css)([
        ":hover{background:",
        ";cursor:pointer;}"
    ], props.theme.klerosUIComponentsMediumBlue), $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "base-item__StyledText",
    componentId: "sc-1q4tyix-1"
})([
    "",
    " font-size:16px;user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledDot = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$66882cfb76c803d6$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item__StyledDot",
    componentId: "sc-1q4tyix-2"
})([
    "margin-right:8px;"
]);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$BaseItem = ({ text: text, Icon: Icon, icon: icon, dot: dot, onClick: onClick, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$Item, {
        onKeyPress: (e)=>onClick && e.key === "Enter" ? onClick() : undefined,
        onClick: onClick,
        ...props,
        children: [
            icon ?? (Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                className: "item-icon"
            })),
            dot && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledDot, {
                color: dot
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledText, {
                children: text
            })
        ]
    });
var $43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$eff5a32ef289d478$var$BaseItem;
const $43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledItem",
    componentId: "sc-b6y23n-0"
})([
    "border-left:3px solid ",
    ";",
    ""
], ({ theme: theme, selected: selected })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsWhiteBackground, ({ theme: theme, selected: selected, current: current })=>!current && (0, $e9f8389e4f70b5af$exports.css)([
        ":hover{border-left:3px solid ",
        ";}"
    ], selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsMediumBlue));
const $43afcb05ca3681f6$var$$bc9b74e06ed8f896$var$ItemContainer = ({ items: items, selected: selected, onChange: onChange })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        children: items.map(({ text: text, Icon: Icon, icon: icon, dot: dot, value: value }, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
                tabIndex: 0,
                selected: value === selected,
                onClick: ()=>onChange(value),
                text: text,
                dot: dot,
                Icon: Icon,
                icon: icon
            }, i))
    });
var $43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$bc9b74e06ed8f896$var$ItemContainer;
const $43afcb05ca3681f6$var$$2d381104713b6d5d$var$SelectButton = ({ item: item, simple: simple, small: small, isOpen: isOpen, setIsOpen: setIsOpen })=>simple ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$export$2e2bcd8739ae039, {
        text: item.text,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        small: small
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        node: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
            current: true,
            ...item
        })
    });
var $43afcb05ca3681f6$var$$2d381104713b6d5d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2d381104713b6d5d$var$SelectButton;
const $43afcb05ca3681f6$var$$dad9719307029a16$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown-container__Container",
    componentId: "sc-qkfxj5-0"
})([
    "",
    " ",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme, isOpen: isOpen, alignRight: alignRight })=>(0, $e9f8389e4f70b5af$exports.css)([
        "position:absolute;",
        " z-index:100;visibility:",
        ";transform:scaleY(",
        ");transform-origin:top;transition-property:transform,visibility;transition-duration:",
        ";transition-timing-function:ease;height:auto;background:transparent;box-shadow:0px 2px 3px ",
        ";overflow:hidden;"
    ], alignRight ? "right: 0px;" : "", isOpen ? "visible" : "hidden", isOpen ? "1" : "0", theme.klerosUIComponentsTransitionSpeed, theme.klerosUIComponentsDefaultShadow));
const $43afcb05ca3681f6$var$$dad9719307029a16$var$DropdownContainer = ({ children: children, isOpen: isOpen, alignRight: alignRight, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$dad9719307029a16$var$Container, {
        isOpen: isOpen,
        alignRight: alignRight,
        ...props,
        children: [
            " ",
            children,
            " "
        ]
    });
var $43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$dad9719307029a16$var$DropdownContainer;
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "select__Container",
    componentId: "sc-s4pei-0"
})([
    "position:relative;"
]);
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$DropdownContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "select__DropdownContainer",
    componentId: "sc-s4pei-1"
})([
    "",
    ""
], ({ theme: theme })=>(0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:1px solid ",
        ";border-radius:3px;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsStroke));
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Select = ({ items: items, callback: callback, simpleButton: simpleButton, smallButton: smallButton, defaultValue: defaultValue, placeholder: placeholder, alignRight: alignRight, ...props })=>{
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [selected, setSelected] = (0, $dup7A.useState)(defaultValue);
    const currentItem = items.find(({ value: value })=>value === selected);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$69ead81f7adc490a$var$Container, {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2d381104713b6d5d$export$2e2bcd8739ae039, {
                item: currentItem ? currentItem : placeholder ? placeholder : {
                    text: ""
                },
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                simple: simpleButton,
                small: smallButton
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$69ead81f7adc490a$var$DropdownContainer, {
                isOpen: isOpen,
                alignRight: alignRight,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039, {
                    items: items,
                    selected: selected,
                    onChange: (value)=>{
                        new Promise((resolve)=>resolve(callback(value))).then(()=>setSelected(value)).catch((error)=>console.error(error));
                    }
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$69ead81f7adc490a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Select;
const $43afcb05ca3681f6$var$$be261e7e6de1aa96$var$SvgLightLeft = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 7,
        height: 11,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M6.375 1.143V.107c0-.09-.103-.139-.173-.084L.165 4.739a.427.427 0 0 0 0 .673l6.037 4.716a.107.107 0 0 0 .173-.085V9.008a.217.217 0 0 0-.082-.168L1.472 5.075l4.821-3.765a.217.217 0 0 0 .082-.168Z"
        })
    });
var $43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$be261e7e6de1aa96$var$SvgLightLeft;
const $43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledBaseItem",
    componentId: "sc-gth5to-0"
})([
    "position:relative;.item-icon{position:absolute;transform:rotate(180deg);right:16px;fill:",
    ";}"
], ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2f29ff49e895ab7b$var$ItemContainer = ({ layer: layer, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        ...props,
        children: layer.items.map((item, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                tabIndex: 0,
                text: item.label,
                Icon: item.children && $43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039,
                onClick: ()=>onChange(item),
                selected: item.value === layer.selected
            }, i))
    });
var $43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2f29ff49e895ab7b$var$ItemContainer;
const $43afcb05ca3681f6$var$$3b159669545f46c0$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "selector__Wrapper",
    componentId: "sc-1nl16fm-0"
})([
    "",
    " border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:",
    ";padding:8px 16px;display:flex;",
    " justify-content:end;align-items:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "justify-content:center;"
    ])));
const $43afcb05ca3681f6$var$$3b159669545f46c0$var$Selector = ({ currentSelection: currentSelection, onSelect: onSelect, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b159669545f46c0$var$Wrapper, {
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
            onClick: ()=>onSelect(),
            text: currentSelection ? `Select\n${currentSelection}` : "No Selection",
            disabled: !currentSelection
        })
    });
var $43afcb05ca3681f6$var$$3b159669545f46c0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$3b159669545f46c0$var$Selector;
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "cascader__Wrapper",
    componentId: "sc-x4ug59-0"
})([
    "border:1px solid ",
    ";",
    " border-radius:3px;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "width:240px;"
    ])));
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "cascader__Container",
    componentId: "sc-x4ug59-1"
})([
    "",
    ""
], ({ theme: theme, path: path, isOpen: isOpen })=>(0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border-bottom:1px solid ",
        ";border-radius:3px;display:grid;grid-template-columns:repeat(",
        ",238px) 0px;grid-template-rows:max-content;gap:1px;",
        ""
    ], isOpen ? theme.klerosUIComponentsStroke : theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, path.length, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
            "overflow:auto;"
        ]))));
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Cascader = ({ items: items, onSelect: onSelect, placeholder: placeholder, value: value, ...props })=>{
    const [path, setPath] = (0, $dup7A.useState)([
        {
            items: items
        }
    ]);
    const [current, setCurrent] = (0, $dup7A.useState)();
    const [selected, setSelected] = (0, $dup7A.useState)();
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    const lastElementRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    (0, $dup7A.useEffect)(()=>{
        if (lastElementRef?.current && isOpen) $43afcb05ca3681f6$var$$parcel$interopDefault($0535cdc15230b38d$exports)(lastElementRef.current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        path
    ]);
    const label = (0, $dup7A.useMemo)(()=>value ? $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(items, value) : undefined, [
        items,
        value
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                node: selected ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: selected.label
                }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: label ?? placeholder
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d8e895830981b43b$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d8e895830981b43b$var$Container, {
                        path: path,
                        isOpen: isOpen,
                        children: [
                            path.map((layer, depth)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039, {
                                    layer: layer,
                                    onChange: (item)=>{
                                        let newPath;
                                        if (depth < path.length) newPath = path.slice(0, depth + 1);
                                        else newPath = path;
                                        newPath[depth].selected = item.value;
                                        if (item.children) newPath.push({
                                            items: item.children
                                        });
                                        setPath(newPath);
                                        setCurrent(item);
                                    }
                                }, depth)),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
                                ref: lastElementRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b159669545f46c0$export$2e2bcd8739ae039, {
                        onSelect: ()=>{
                            if (current) new Promise((resolve)=>resolve(onSelect(current.value))).then(()=>{
                                setSelected(current);
                                setIsOpen(false);
                            }).catch((error)=>console.error(error));
                        },
                        currentSelection: current?.label
                    })
                ]
            })
        ]
    });
};
/**
 * @param nodes the nodes
 * @param targetValue the value to search, can be string or number
 * @returns the label if the item is found, else returns undefined
 */ function $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(nodes, targetValue) {
    for (const node of nodes){
        if (node.value == targetValue) return node.label;
        if (node.children) {
            const result = $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(node.children, targetValue);
            if (result) return result;
        }
    }
    return undefined;
}
var $43afcb05ca3681f6$var$$d8e895830981b43b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d8e895830981b43b$var$Cascader;
const $43afcb05ca3681f6$var$$1fbc1df023618cf8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 10.6a.567.567 0 0 1-.923 0L4.545 7.516a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z"
        })
    });
var $43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1fbc1df023618cf8$var$SvgSuccess;
const $43afcb05ca3681f6$var$$773dfb225348757e$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037 3.749a.857.857 0 1 1 1.211-1.212.857.857 0 0 1-1.211 1.212Zm1.034-2.606h-.857A.143.143 0 0 1 7.428 9V4.143c0-.079.065-.143.143-.143h.857c.079 0 .143.064.143.143V9a.143.143 0 0 1-.143.143Z"
        })
    });
var $43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$773dfb225348757e$var$SvgWarning;
const $43afcb05ca3681f6$var$$1055d191a5da0897$var$SvgError = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z"
        })
    });
var $43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1055d191a5da0897$var$SvgError;
const $43afcb05ca3681f6$var$$3b81fb62e49a97d5$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z"
        })
    });
var $43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$3b81fb62e49a97d5$var$SvgInfo;
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "warning") return theme.klerosUIComponentsWarning;
    if (variant === "error") return theme.klerosUIComponentsError;
    if (variant === "success") return theme.klerosUIComponentsSuccess;
    return theme.klerosUIComponentsSecondaryText;
});
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "field__Wrapper",
    componentId: "sc-4pge1s-0"
})([
    "",
    " height:45px;width:278px;position:relative;color:red;.field-svg{",
    " height:16px;width:16px;position:absolute;top:14px;right:16px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSuccessIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledSuccessIcon",
    componentId: "sc-4pge1s-1"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsSuccess);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledWarningIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledWarningIcon",
    componentId: "sc-4pge1s-2"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsWarning);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledErrorIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledErrorIcon",
    componentId: "sc-4pge1s-3"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7 = (0, $e9f8389e4f70b5af$exports.css)([
    "height:100%;width:100%;background:",
    ";border:1px solid ",
    ";border-radius:3px;color:",
    ";:focus{outline:none;border:1px solid ",
    "40;box-shadow:0px 0px 6px ",
    ";border-radius:3px;}::placeholder{color:",
    ";opacity:0.5;}"
], (props)=>props.theme.klerosUIComponentsWhiteBackground, ({ variant: variant, theme: theme })=>variant ? $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 : theme.klerosUIComponentsStroke, (props)=>props.theme.klerosUIComponentsPrimaryText, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.withConfig({
    displayName: "field__StyledInput",
    componentId: "sc-4pge1s-4"
})([
    "padding-top:14px;padding-bottom:14px;padding-left:16px;padding-right:",
    ";",
    ""
], ({ Icon: Icon, variant: variant })=>{
    if (Icon) return "56px";
    if (variant) return "44px";
    return "16px";
}, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "field__StyledSVG",
    componentId: "sc-4pge1s-5"
})([
    ""
]);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "field__StyledMessage",
    componentId: "sc-4pge1s-6"
})([
    "margin-top:6px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "field__StyledSmall",
    componentId: "sc-4pge1s-7"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$IconContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "field__IconContainer",
    componentId: "sc-4pge1s-8"
})([
    "display:flex;width:44px;height:43px;position:absolute;top:1px;right:1px;align-items:center;justify-content:center;background:",
    ";border-left:1px solid ",
    ";"
], (props)=>props.theme.klerosUIComponentsLightBlue, (props)=>props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledIconSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "field__StyledIconSVG",
    componentId: "sc-4pge1s-9"
})([
    "width:24px;height:24px;"
]);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field = ({ variant: variant, message: message, Icon: Icon, className: className, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledInput, {
                variant: variant,
                Icon: Icon,
                ...props
            }),
            variant === "success" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSuccessIcon, {
                className: "field-svg"
            }),
            variant === "warning" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledWarningIcon, {
                className: "field-svg"
            }),
            variant === "error" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledErrorIcon, {
                className: "field-svg"
            }),
            Icon && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$IconContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledIconSVG, {
                    as: Icon
                })
            }),
            message && /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9, {
                variant: variant,
                children: [
                    variant === "info" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field.displayName = "Field";
var $43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field;
const $43afcb05ca3681f6$var$$619d93e693d921a0$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.468 6.468 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4Z"
        })
    });
var $43afcb05ca3681f6$var$$619d93e693d921a0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$619d93e693d921a0$var$SvgSearch;
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "searchbar__Wrapper",
    componentId: "sc-1lxp2tc-0"
})([
    "",
    " position:relative;width:278px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledField = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledField",
    componentId: "sc-1lxp2tc-1"
})([
    "height:100%;width:100%;input{padding:14px 16px 14px 40px;}"
]);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$619d93e693d921a0$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledSearchIcon",
    componentId: "sc-1lxp2tc-2"
})([
    "position:absolute;left:16px;top:50%;transform:translateY(-50%);width:16px;height:16px;max-width:16px;max-height:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Searchbar = ({ className: className, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledField, {
                placeholder: "Search",
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon, {})
        ]
    });
var $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Searchbar;
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "textarea__Wrapper",
    componentId: "sc-bi4jd2-0"
})([
    "",
    " height:115px;width:400px;position:relative;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledTextarea = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).textarea.withConfig({
    displayName: "textarea__StyledTextarea",
    componentId: "sc-bi4jd2-1"
})([
    "resize:none;padding:16px;display:block;font-family:inherit;",
    ""
], $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "textarea__StyledSVG",
    componentId: "sc-bi4jd2-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Message = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "textarea__Message",
    componentId: "sc-bi4jd2-3"
})([
    "margin-top:12px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "textarea__StyledSmall",
    componentId: "sc-bi4jd2-4"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea = ({ message: message, variant: variant, className: className, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledTextarea, {
                variant: variant,
                ...props
            }),
            message && /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea.displayName = "Textarea";
var $43afcb05ca3681f6$var$$870ba58bccab6eec$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea;
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "handle__Wrapper",
    componentId: "sc-no0w1x-0"
})([
    "",
    " display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:relative;top:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Label = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "handle__Label",
    componentId: "sc-no0w1x-1"
})([
    "position:relative;left:",
    "%;transform:translateX(-50%);bottom:44px;color:",
    ";"
], ({ offset: offset })=>offset, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$StyledHandle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($53eb3904070cf0e9$exports.Handle).withConfig({
    displayName: "handle__StyledHandle",
    componentId: "sc-no0w1x-2"
})([
    "width:30px;height:30px;margin-top:-19px;border:3px solid ",
    ";background-color:",
    ";:hover{cursor:pointer;border-color:",
    ";}:active{box-shadow:0 0 5px ",
    ";}"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Handle = ({ label: label, dragging: dragging, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Label, {
                offset: props.offset,
                children: label
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$StyledHandle, {
                dragging: dragging.toString(),
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$ba3b8df995d5886a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Handle;
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "slider__Wrapper",
    componentId: "sc-5b6ug3-0"
})([
    "",
    " width:500px;margin-top:30px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledSlider = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$parcel$interopDefault($53eb3904070cf0e9$exports)).withConfig({
    displayName: "slider__StyledSlider",
    componentId: "sc-5b6ug3-1"
})([
    "width:100%;.rc-slider-handle-click-focused:focus{border-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "slider__StyledLabel",
    componentId: "sc-5b6ug3-2"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Labels = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "slider__Labels",
    componentId: "sc-5b6ug3-3"
})([
    "width:100%;margin-top:16px;display:flex;align-items:center;justify-content:space-between;"
]);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider = ({ label: label, min: min, max: max, leftLabel: leftLabel, rightLabel: rightLabel, callback: callback, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledSlider, {
                handle: ({ ref: ignored, ...handleProps })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$export$2e2bcd8739ae039, {
                        label: label,
                        ...handleProps
                    }),
                railStyle: {
                    height: "8px",
                    backgroundColor: props.theme.klerosUIComponentsStroke,
                    borderRadius: "30px",
                    cursor: "pointer"
                },
                trackStyle: [
                    {
                        height: "8px",
                        backgroundColor: props.theme.klerosUIComponentsPrimaryBlue,
                        borderRadius: "30px",
                        cursor: "pointer"
                    }
                ],
                onChange: callback,
                min: min,
                max: max,
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Labels, {
                children: [
                    leftLabel && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: rightLabel
                    })
                ]
            })
        ]
    });
$43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider.displayName = "Slider";
var $43afcb05ca3681f6$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039 = (0, $e9f8389e4f70b5af$exports.withTheme)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider);
const $43afcb05ca3681f6$var$$a9ca8be356aca825$var$SvgUploadIcon = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M8.406 5.378h2.371V16.91c0 .15.116.273.257.273h1.925c.142 0 .257-.123.257-.273V5.378h2.378c.215 0 .333-.263.202-.44L12.202.105a.26.26 0 0 0-.09-.077.244.244 0 0 0-.224 0 .26.26 0 0 0-.09.077l-3.594 4.83c-.131.18-.013.443.202.443Zm15.337 10.51h-1.925c-.141 0-.257.122-.257.272v5.25H2.44v-5.25c0-.15-.116-.273-.257-.273H.257c-.141 0-.257.123-.257.273v6.75C0 23.511.459 24 1.027 24h21.946c.568 0 1.027-.488 1.027-1.09v-6.75c0-.15-.116-.273-.257-.273Z"
        })
    });
var $43afcb05ca3681f6$var$$a9ca8be356aca825$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a9ca8be356aca825$var$SvgUploadIcon;
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "file-uploader__Wrapper",
    componentId: "sc-18nhvs2-0"
})([
    "",
    " width:200px;height:64px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$DropZone = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "file-uploader__DropZone",
    componentId: "sc-18nhvs2-1"
})([
    "",
    " height:100%;width:100%;background:",
    ";border:1px dashed ",
    ";border-radius:3px;display:flex;justify-content:center;align-items:center;font-size:14px;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledUploadIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a9ca8be356aca825$export$2e2bcd8739ae039).withConfig({
    displayName: "file-uploader__StyledUploadIcon",
    componentId: "sc-18nhvs2-2"
})([
    "",
    " height:24px;width:24px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.withConfig({
    displayName: "file-uploader__FileInput",
    componentId: "sc-18nhvs2-3"
})([
    "display:none;"
]);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "file-uploader__StyledSmall",
    componentId: "sc-18nhvs2-4"
})([
    "",
    " position:relative;top:-1px;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "file-uploader__StyledSVG",
    componentId: "sc-18nhvs2-5"
})([
    ""
]);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$Message = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "file-uploader__Message",
    componentId: "sc-18nhvs2-6"
})([
    "margin-top:16px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileUploader = ({ callback: callback, msg: msg, variant: variant, className: className, ...props })=>{
    const fileInputRef = (0, $dup7A.useRef)(); //! type
    const [fileSelected, setFileSelected] = (0, $dup7A.useState)();
    const handleDragEnter = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        fileInputRef.current.files = event.dataTransfer?.files;
        setFileSelected(event.dataTransfer?.files[0]);
        callback(event.dataTransfer?.files[0]);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$DropZone, {
                onClick: ()=>fileInputRef?.current.click(),
                onDrop: (e)=>handleDrop(e),
                onDragOver: (e)=>handleDragOver(e),
                onDragEnter: (e)=>handleDragEnter(e),
                onDragLeave: (e)=>handleDragLeave(e),
                children: fileSelected ? fileSelected.name : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledUploadIcon, {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileInput, {
                ref: fileInputRef,
                type: "file",
                onChange: (event)=>{
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setFileSelected(event.target.files[0]);
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    callback(event.target.files[0]);
                },
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSmall, {
                        variant: variant,
                        children: msg
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$eab617fde0d2a814$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileUploader;
const $43afcb05ca3681f6$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue = {
    focusedDate: null,
    isDateFocused: ()=>false,
    isDateSelected: ()=>false,
    isDateHovered: ()=>false,
    isDateBlocked: ()=>false,
    isFirstOrLastSelectedDate: ()=>false,
    onDateFocus: ()=>{
    //do nothing
    },
    onDateHover: ()=>{
    //do nothing
    },
    onDateSelect: ()=>{
    //do nothing
    }
};
var $43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$parcel$interopDefault($dup7A).createContext($43afcb05ca3681f6$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue);
const $43afcb05ca3681f6$var$$8da322913a568d32$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M5.625 9h-1.25A.376.376 0 0 1 4 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 5.625 9ZM9 8.625v-1.25A.376.376 0 0 0 8.625 7h-1.25A.376.376 0 0 0 7 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 8.625Zm3 0v-1.25A.376.376 0 0 0 11.625 7h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 12 8.625Zm-3 3v-1.25A.376.376 0 0 0 8.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 11.625Zm-3 0v-1.25A.376.376 0 0 0 5.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 6 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM15 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 15 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
        })
    });
var $43afcb05ca3681f6$var$$8da322913a568d32$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$8da322913a568d32$var$SvgCalendar;
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "display-button__StyledButton",
    componentId: "sc-1n9stdw-0"
})([
    "",
    " height:45px;width:330px;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:0px 16px;display:flex;justify-content:flex-start;align-items:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledDate = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "display-button__StyledDate",
    componentId: "sc-1n9stdw-1"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledCalendar = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$8da322913a568d32$export$2e2bcd8739ae039).withConfig({
    displayName: "display-button__StyledCalendar",
    componentId: "sc-1n9stdw-2"
})([
    "position:absolute;right:16px;height:16px;width:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$02569186343496d4$var$DisplayButton = ({ onClick: onClick, date: date, time: time })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledDate, {
                children: [
                    date.toLocaleDateString(),
                    time && `, ${date.getHours().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })}:${date.getMinutes().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })} Local time`
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledCalendar, {})
        ]
    });
var $43afcb05ca3681f6$var$$02569186343496d4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$02569186343496d4$var$DisplayButton;
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "day__StyledDayNumber",
    componentId: "sc-1cckfjj-0"
})([
    "",
    " color:",
    " !important;font-weight:600;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.isSelected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "day__StyledButton",
    componentId: "sc-1cckfjj-1"
})([
    "",
    " height:24px;width:24px;border-radius:12px;background-color:",
    ";padding:0;display:flex;justify-content:center;align-items:center;:hover{background-color:",
    ";cursor:pointer;& ",
    "{color:",
    " !important;}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$Day = ({ date: date, dayLabel: dayLabel })=>{
    const dayRef = (0, $dup7A.useRef)(null);
    const { isSelected: isSelected, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, tabIndex: tabIndex } = (0, $48515c484bc5585a$export$1937086c6b64f72d)({
        dayRef: dayRef,
        date: date,
        ...(0, $dup7A.useContext)($43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039)
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledButton, {
        ref: dayRef,
        isSelected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber, {
            isSelected: isSelected,
            children: dayLabel
        })
    });
};
var $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$Day;
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$MonthContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__MonthContainer",
    componentId: "sc-1lt566d-0"
})([
    "width:330px;height:220px;padding-top:16px;display:flex;justify-content:center;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__StyledGridContainer",
    componentId: "sc-1lt566d-1"
})([
    "height:26px;width:32px;display:flex;justify-content:center;align-items:center;"
]);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledWeekDay = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "month__StyledWeekDay",
    componentId: "sc-1lt566d-2"
})([
    "",
    " color:",
    ";font-weight:600;user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledMonth = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__StyledMonth",
    componentId: "sc-1lt566d-3"
})([
    "width:fit-content;height:fit-content;display:grid;grid-template-columns:repeat(7,32px);"
]);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$Month = ({ days: days, weekdayLabels: weekdayLabels })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$MonthContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledMonth, {
            children: [
                weekdayLabels.map((dayLabel, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledWeekDay, {
                            children: dayLabel
                        })
                    }, i)),
                days.map((day, i)=>typeof day === "number" ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {}, i) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039, {
                            ...day
                        }, i)
                    }, i))
            ]
        })
    });
var $43afcb05ca3681f6$var$$b6c83c11430985d2$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b6c83c11430985d2$var$Month;
const $43afcb05ca3681f6$var$$51df4a6e8b413d48$var$SvgSimpleLeft = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m9.197 14.429-.793.786a.859.859 0 0 1-1.21 0L.252 8.335a.841.841 0 0 1 0-1.201L7.194.25a.859.859 0 0 1 1.21 0l.793.786a.846.846 0 0 1-.014 1.214L4.88 6.316h10.263c.475 0 .857.379.857.85v1.133c0 .471-.382.85-.857.85H4.88l4.303 4.065a.84.84 0 0 1 .014 1.215Z"
        })
    });
var $43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$51df4a6e8b413d48$var$SvgSimpleLeft;
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month-selector__Wrapper",
    componentId: "sc-1tkddgk-0"
})([
    "width:100%;height:64px;padding:24px;display:flex;justify-content:space-between;"
]);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "month-selector__StyledMonthTitle",
    componentId: "sc-1tkddgk-1"
})([
    "",
    " user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "month-selector__StyledArrow",
    componentId: "sc-1tkddgk-2"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";:hover{fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow).withConfig({
    displayName: "month-selector__RightArrow",
    componentId: "sc-1tkddgk-3"
})([
    "transform:rotate(180deg);"
]);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "month-selector__UnstyledButton",
    componentId: "sc-1tkddgk-4"
})([
    "",
    " background:none;padding:0;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$MonthSelector = ({ monthLabel: monthLabel, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToPreviousMonths,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle, {
                children: monthLabel
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToNextMonths,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$RightArrow, {})
            })
        ]
    });
var $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$MonthSelector;
const $43afcb05ca3681f6$var$$5b91024d35847b4a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "date-selector__Wrapper",
    componentId: "sc-dxn9nj-0"
})([
    "display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$5b91024d35847b4a$var$DateSelector = ({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>{
    const { days: days, weekdayLabels: weekdayLabels, monthLabel: monthLabel } = (0, $48515c484bc5585a$export$41527c87dc759868)({
        year: year,
        month: month,
        firstDayOfWeek: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$5b91024d35847b4a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039, {
                monthLabel: monthLabel,
                goToPreviousMonths: goToPreviousMonths,
                goToNextMonths: goToNextMonths
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$export$2e2bcd8739ae039, {
                days: days,
                weekdayLabels: weekdayLabels
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$5b91024d35847b4a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$5b91024d35847b4a$var$DateSelector;
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControl = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-controls__TimeControl",
    componentId: "sc-198k8z7-0"
})([
    "flex-grow:1;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";display:flex;flex-direction:column;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-controls__TimeDisplay",
    componentId: "sc-198k8z7-1"
})([
    "width:100%;height:64px;background-color:",
    ";padding:0px 24px;display:flex;justify-content:space-between;align-items:center;"
], ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "time-controls__StyledTime",
    componentId: "sc-198k8z7-2"
})([
    "",
    " font-weight:600;color:",
    ";user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay).withConfig({
    displayName: "time-controls__TimeButtons",
    componentId: "sc-198k8z7-3"
})([
    "flex-grow:1;background-color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "time-controls__StyledArrow",
    componentId: "sc-198k8z7-4"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__UpArrow",
    componentId: "sc-198k8z7-5"
})([
    "transform:rotate(90deg);"
]);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__DownArrow",
    componentId: "sc-198k8z7-6"
})([
    "transform:rotate(-90deg);"
]);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "time-controls__UnstyledButton",
    componentId: "sc-198k8z7-7"
})([
    "",
    " background:none;padding:0;:hover{& ",
    "{fill:",
    ";}}:disabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControls = ({ date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControl, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours + 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: hours === 23,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow, {})
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes + 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: minutes === 59,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: hours.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: minutes.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours - 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: hours === 0,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow, {})
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes - 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: minutes === 0,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow, {})
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$2dfb31ff65652603$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControls;
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-selector__Wrapper",
    componentId: "sc-1i0y3my-0"
})([
    "width:118px;height:284px;border-left:1px solid ",
    ";display:flex;flex-direction:column;",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "border:1px solid ",
        ";border-top:none;border-bottom:none;"
    ], ({ theme: theme })=>theme.klerosUIComponentsStroke)));
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$Header = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-selector__Header",
    componentId: "sc-1i0y3my-1"
})([
    "height:64px;display:flex;justify-content:center;align-items:center;"
]);
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "time-selector__StyledTitle",
    componentId: "sc-1i0y3my-2"
})([
    "",
    " user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$TimeSelector = (props)=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$Header, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$StyledTitle, {
                    children: "Time"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$export$2e2bcd8739ae039, {
                ...props
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$a1eb1518e9214887$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a1eb1518e9214887$var$TimeSelector;
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__Container",
    componentId: "sc-xqzukb-0"
})([
    "position:absolute;z-index:100;overflow:hidden;height:",
    ";width:",
    ";transition:height ease ",
    ";background:",
    ";",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:3px;",
    ""
], ({ isOpen: isOpen })=>isOpen ? "auto" : "0", ({ time: time })=>time ? "450px" : "330px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ isOpen: isOpen, theme: theme })=>isOpen ? `border: 1px solid ${theme.klerosUIComponentsStroke}` : "", ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "width:332px;position:static;margin:0;left:0;top:0;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Selectors = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__Selectors",
    componentId: "sc-xqzukb-1"
})([
    "display:flex;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "flex-direction:column;align-items:center;justify-content:flex-start;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$ButtonContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__ButtonContainer",
    componentId: "sc-xqzukb-2"
})([
    "width:100%;padding:16px 24px;display:flex;justify-content:flex-end;align-items:center;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "justify-content:center;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Dropdown = ({ onSelect: onSelect, isOpen: isOpen, time: time, date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes, ...dateSelectorProps })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$275ab796fce9757e$var$Container, {
        isOpen: isOpen,
        time: time,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$275ab796fce9757e$var$Selectors, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$5b91024d35847b4a$export$2e2bcd8739ae039, {
                        ...dateSelectorProps
                    }),
                    time && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$export$2e2bcd8739ae039, {
                        date: date,
                        hours: hours,
                        minutes: minutes,
                        setHours: setHours,
                        setMinutes: setMinutes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$275ab796fce9757e$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
                    small: true,
                    variant: "primary",
                    text: "Select",
                    onClick: onSelect
                })
            })
        ]
    });
var $43afcb05ca3681f6$var$$275ab796fce9757e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$275ab796fce9757e$var$Dropdown;
const $43afcb05ca3681f6$var$$1d445195934320ed$var$PositionedContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "datepicker__PositionedContainer",
    componentId: "sc-1gv6m20-0"
})([
    "",
    " position:relative;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$1d445195934320ed$var$DatePicker = ({ onSelect: onSelect, time: time })=>{
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [date, setDate] = (0, $dup7A.useState)(new Date());
    const [hours, setHours] = (0, $dup7A.useState)(date.getHours());
    const [minutes, setMinutes] = (0, $dup7A.useState)(date.getMinutes());
    const { firstDayOfWeek: firstDayOfWeek, activeMonths: activeMonths, isDateSelected: isDateSelected, isDateHovered: isDateHovered, isFirstOrLastSelectedDate: isFirstOrLastSelectedDate, isDateBlocked: isDateBlocked, isDateFocused: isDateFocused, focusedDate: focusedDate, onDateHover: onDateHover, onDateSelect: onDateSelect, onDateFocus: onDateFocus, goToPreviousMonths: goToPreviousMonths, goToNextMonths: goToNextMonths } = (0, $48515c484bc5585a$export$2d9bfdb55c82a287)({
        startDate: date,
        endDate: date,
        focusedInput: $48515c484bc5585a$export$99a467bcc22b8df9,
        onDatesChange: (date)=>{
            if (date.startDate) {
                date.startDate.setHours(hours, minutes);
                setDate(date.startDate);
            }
        },
        numberOfMonths: 1,
        minBookingDays: 1,
        exactMinBookingDays: true
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039.Provider, {
        value: {
            focusedDate: focusedDate,
            isDateFocused: isDateFocused,
            isDateSelected: isDateSelected,
            isDateHovered: isDateHovered,
            isDateBlocked: isDateBlocked,
            isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
            onDateSelect: onDateSelect,
            onDateFocus: onDateFocus,
            onDateHover: onDateHover
        },
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$1d445195934320ed$var$PositionedContainer, {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$02569186343496d4$export$2e2bcd8739ae039, {
                    date: date,
                    time: time,
                    onClick: ()=>setIsOpen(!isOpen)
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$275ab796fce9757e$export$2e2bcd8739ae039, {
                    ...activeMonths[0],
                    isOpen: isOpen,
                    time: time,
                    firstDayOfWeek: firstDayOfWeek,
                    goToNextMonths: goToNextMonths,
                    goToPreviousMonths: goToPreviousMonths,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    setHours: setHours,
                    setMinutes: setMinutes,
                    onSelect: ()=>{
                        date.setHours(hours, minutes);
                        onSelect(date);
                        setIsOpen(false);
                    }
                })
            ]
        })
    });
};
var $43afcb05ca3681f6$var$$1d445195934320ed$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1d445195934320ed$var$DatePicker;
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "radio__Wrapper",
    componentId: "sc-1jhzktg-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "radio"
}).withConfig({
    displayName: "radio__HiddenInput",
    componentId: "sc-1jhzktg-1"
})([
    "position:absolute;opacity:0;cursor:pointer;"
]);
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$StyledRadio = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "radio__StyledRadio",
    componentId: "sc-1jhzktg-2"
})([
    "position:absolute;top:0;left:0;border:1px solid ",
    ";border-radius:50%;",
    ' :after{content:"";position:absolute;display:none;border-radius:50%;background:',
    ";",
    "}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "width:16px;height:16px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "top:3px;left:3px;width:8px;height:8px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "top:5px;left:5px;width:12px;height:12px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:1px solid ",
        ";:after{display:block;}"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue));
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Radio = ({ small: small, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$StyledRadio, {
                small: small,
                checked: checked
            })
        ]
    });
var $43afcb05ca3681f6$var$$86e1d79a67710eda$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Radio;
const $43afcb05ca3681f6$var$$1d196f635349b3e7$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 15 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M14.416 0h-1.77c-.384 0-.75.185-.977.502L5.737 8.729 3.05 5a1.207 1.207 0 0 0-.978-.502H.302c-.245 0-.388.28-.245.48l4.702 6.52a1.2 1.2 0 0 0 1.951 0L14.658.48A.3.3 0 0 0 14.416 0Z",
            fill: "#fff"
        })
    });
var $43afcb05ca3681f6$var$$1d196f635349b3e7$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1d196f635349b3e7$var$SvgCheckmark;
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "checkbox__Wrapper",
    componentId: "sc-1qpo0fn-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "checkbox__HiddenInput",
    componentId: "sc-1qpo0fn-1"
})([
    "position:absolute;opacity:0;cursor:pointer;height:0;width:0;"
]);
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$StyledCheckmark = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1d196f635349b3e7$export$2e2bcd8739ae039).withConfig({
    displayName: "checkbox__StyledCheckmark",
    componentId: "sc-1qpo0fn-2"
})([
    "",
    " position:absolute;top:0;left:0;border-radius:3px;border:1px solid ",
    ";",
    " ",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ $small: $small })=>$small ? (0, $e9f8389e4f70b5af$exports.css)([
        "padding:0 3px;width:16px;height:16px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "padding:0 4px;width:24px;height:24px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:none;:after{display:block;}"
    ], theme.klerosUIComponentsPrimaryBlue));
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Checkbox = ({ small: small = false, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$StyledCheckmark, {
                $small: small,
                checked: checked
            })
        ]
    });
var $43afcb05ca3681f6$var$$b679852ecf8e9c02$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Checkbox;
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSwitch = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "switch__StyledSwitch",
    componentId: "sc-1or3qt0-0"
})([
    "",
    " position:relative;display:inline-block;height:",
    ";width:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "16px" : "24px", ({ small: small })=>small ? "32px" : "48px");
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "switch__HiddenInput",
    componentId: "sc-1or3qt0-1"
})([
    "opacity:0;width:0;height:0;"
]);
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSlider = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "switch__StyledSlider",
    componentId: "sc-1or3qt0-2"
})([
    "position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:",
    ';transition:0.4s;border-radius:34px;&:before{position:absolute;content:"";height:',
    ";width:",
    ";left:2px;bottom:2px;border-radius:50%;background-color:white;transition:0.4s;}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? "12px" : "20px", ({ small: small })=>small ? "12px" : "20px", ({ checked: checked, theme: theme, small: small })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background-color:",
        ";:before{transform:translateX(",
        ");}"
    ], theme.klerosUIComponentsPrimaryBlue, small ? "16px" : "24px"));
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$Switch = ({ small: small, checked: checked, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSwitch, {
        small: small,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSlider, {
                small: small,
                checked: checked
            })
        ]
    });
var $43afcb05ca3681f6$var$$34871b0f15f7c161$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$34871b0f15f7c161$var$Switch;
const $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ theme: theme, variant: variant })=>{
    switch(variant){
        case "success":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsSuccess);
        case "warning":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsWarning);
        case "error":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsError);
        case "info":
        default:
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsPrimaryBlue);
    }
});
const $43afcb05ca3681f6$var$$d963730b715e990c$var$borderColor = ({ theme: theme, variant: variant })=>{
    const colors = {
        success: theme.klerosUIComponentsSuccess,
        warning: theme.klerosUIComponentsWarning,
        error: theme.klerosUIComponentsError,
        info: theme.klerosUIComponentsPrimaryBlue
    };
    return colors[variant];
};
const $43afcb05ca3681f6$var$$d963730b715e990c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__Wrapper",
    componentId: "sc-rckqp0-0"
})([
    "display:grid;grid-template-columns:24px auto;gap:16px;align-items:center;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:16px 24px 20px 24px;"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme, variant: variant })=>$43afcb05ca3681f6$var$$d963730b715e990c$var$borderColor({
        theme: theme,
        variant: variant
    }));
const $43afcb05ca3681f6$var$$d963730b715e990c$var$IconWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__IconWrapper",
    componentId: "sc-rckqp0-1"
})([
    "",
    " height:24px;width:24px;svg{",
    " fill:currentColor;}"
], $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "alert__StyledTitle",
    componentId: "sc-rckqp0-2"
})([
    "",
    " font-size:16px;margin:0;font-weight:600;line-height:24px;"
], $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$TitleAndMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__TitleAndMessage",
    componentId: "sc-rckqp0-3"
})([
    "display:flex;flex-direction:column;",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "gap:8px;"
    ])));
const $43afcb05ca3681f6$var$$d963730b715e990c$var$StyledMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "alert__StyledMessage",
    componentId: "sc-rckqp0-4"
})([
    "color:",
    ";font-weight:400;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$Alert = ({ variant: variant, title: title, msg: msg })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$Wrapper, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$IconWrapper, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {}),
                    variant === "warning" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {}),
                    variant === "error" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {}),
                    variant === "info" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {})
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$TitleAndMessage, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d963730b715e990c$var$StyledTitle, {
                        variant: variant,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d963730b715e990c$var$StyledMessage, {
                        children: msg
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$d963730b715e990c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d963730b715e990c$var$Alert;
const $43afcb05ca3681f6$var$$296cff7698ec0f63$var$SvgSolidSuccess = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.136 1.136 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.785c.214-.297.557-.475.925-.475h1.675c.232 0 .367.264.232.453Z"
        })
    });
var $43afcb05ca3681f6$var$$296cff7698ec0f63$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$296cff7698ec0f63$var$SvgSolidSuccess;
const $43afcb05ca3681f6$var$$ff1548a205f71f6a$var$SvgSolidError = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm5.907 22.079-2.357-.011L16 17.836l-3.546 4.228-2.361.011a.284.284 0 0 1-.286-.286c0-.068.025-.132.068-.185l4.646-5.536-4.646-5.532a.287.287 0 0 1 .218-.471l2.36.01L16 14.307l3.546-4.228 2.358-.011c.157 0 .285.125.285.286a.297.297 0 0 1-.068.185l-4.639 5.532 4.643 5.536a.287.287 0 0 1-.218.472Z"
        })
    });
var $43afcb05ca3681f6$var$$ff1548a205f71f6a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ff1548a205f71f6a$var$SvgSolidError;
const $43afcb05ca3681f6$var$$d6917595109333d4$var$SvgSync = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M2.171 11.777a9.807 9.807 0 0 1 2.874-6.726 9.778 9.778 0 0 1 6.951-2.88c1.33 0 2.615.26 3.824.772a9.757 9.757 0 0 1 3.123 2.108c.283.283.548.583.794.898l-1.72 1.342a.229.229 0 0 0 .086.403l5.02 1.229a.23.23 0 0 0 .283-.22l.023-5.169c0-.191-.22-.3-.369-.18l-1.611 1.26A11.967 11.967 0 0 0 11.994 0C5.45 0 .123 5.246 0 11.766A.228.228 0 0 0 .23 12h1.714c.126 0 .226-.1.228-.223Zm21.6.223h-1.714c-.125 0-.226.1-.228.223a9.76 9.76 0 0 1-.769 3.6 9.778 9.778 0 0 1-2.106 3.126 9.786 9.786 0 0 1-6.951 2.88 9.779 9.779 0 0 1-6.949-2.88 9.853 9.853 0 0 1-.794-.898l1.72-1.342a.23.23 0 0 0 .024-.34.229.229 0 0 0-.11-.063l-5.02-1.229a.23.23 0 0 0-.282.22l-.02 5.172c0 .191.22.3.368.18l1.611-1.26A11.973 11.973 0 0 0 12.006 24C18.554 24 23.877 18.751 24 12.234a.229.229 0 0 0-.229-.234Z"
        })
    });
var $43afcb05ca3681f6$var$$d6917595109333d4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d6917595109333d4$var$SvgSync;
const $43afcb05ca3681f6$var$$88d96d829ac44aee$var$SvgClose = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 8 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M4.525 4 7.746.16A.098.098 0 0 0 7.671 0h-.979a.2.2 0 0 0-.15.07L3.884 3.237 1.228.07a.196.196 0 0 0-.15-.07h-.98a.098.098 0 0 0-.075.16L3.244 4 .024 7.84A.098.098 0 0 0 .097 8h.98a.2.2 0 0 0 .15-.07l2.657-3.167L6.54 7.93c.037.044.092.07.151.07h.98a.098.098 0 0 0 .074-.16L4.526 4Z"
        })
    });
var $43afcb05ca3681f6$var$$88d96d829ac44aee$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$88d96d829ac44aee$var$SvgClose;
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "push__StyledSVG",
    componentId: "sc-4wrqai-0"
})([
    ""
]);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "push__Wrapper",
    componentId: "sc-4wrqai-1"
})([
    "",
    " position:relative;height:",
    ";width:",
    ";background:",
    ";border-radius:3px;padding:",
    ";display:flex;align-items:center;& ",
    "{",
    " height:",
    ";width:",
    ";min-height:",
    ";min-width:",
    ";fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "48px" : "100px", ({ small: small })=>small ? "300px" : "422px", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? "12px 24px 12px 24px" : "16px 32px 16px 24px", $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "push__StyledTitle",
    componentId: "sc-4wrqai-2"
})([
    "",
    " color:inherit;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "push__StyledMessage",
    componentId: "sc-4wrqai-3"
})([
    "",
    " color:inherit;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Text = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "push__Text",
    componentId: "sc-4wrqai-4"
})([
    "margin-left:16px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$CloseButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "push__CloseButton",
    componentId: "sc-4wrqai-5"
})([
    "",
    " position:absolute;top:24px;right:24px;height:8px;width:8px;background:none;padding:0;display:inline-flex;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$88d96d829ac44aee$export$2e2bcd8739ae039).withConfig({
    displayName: "push__StyledCloseIcon",
    componentId: "sc-4wrqai-6"
})([
    "",
    " height:8px;width:8px;min-height:8px;min-width:8px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Push = ({ variant: variant, title: title, msg: msg, callback: callback, small: small, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Wrapper, {
        small: small,
        ...props,
        children: [
            variant === "success" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$296cff7698ec0f63$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "error" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "sync" && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$d6917595109333d4$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledTitle, {
                        children: title
                    }),
                    !small && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledMessage, {
                        children: msg
                    })
                ]
            }),
            !small && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$CloseButton, {
                onClick: ()=>callback(),
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon, {})
            })
        ]
    });
var $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Push;
const $43afcb05ca3681f6$var$$0ef3fc8611d56815$var$usePagination = (currentPage, numPages, callback, numNeighbors = 2)=>{
    const incrementPage = ()=>{
        const newPage = Math.min(numPages, currentPage + 1);
        callback(newPage);
    };
    const decrementPage = ()=>{
        const newPage = Math.max(1, currentPage - 1);
        callback(newPage);
    };
    const goToPage = (newPage)=>{
        callback(newPage);
    };
    const minPageReached = currentPage === 1;
    const maxPageReached = currentPage === numPages;
    const getPageRange = ()=>{
        const leftBoundary = Math.max(1, currentPage - numNeighbors - Math.max(0, numNeighbors - (numPages - currentPage)));
        const rightBoundary = Math.min(numPages, currentPage + numNeighbors + Math.max(0, numNeighbors - currentPage + 1));
        return [
            ...Array(rightBoundary - leftBoundary + 1).keys()
        ].map((i)=>i + leftBoundary);
    };
    return [
        {
            incrementPage: incrementPage,
            decrementPage: decrementPage,
            goToPage: goToPage,
            minPageReached: minPageReached,
            maxPageReached: maxPageReached,
            getPageRange: getPageRange
        }
    ];
};
var $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$0ef3fc8611d56815$var$usePagination;
const $43afcb05ca3681f6$var$$1edefcf4055fc9a6$var$SvgCircleLeft = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-.124 16.697.52-.527a.572.572 0 0 0-.009-.815L9.56 12.626h6.742a.565.565 0 0 0 .563-.57v-.76a.565.565 0 0 0-.563-.57H9.56l2.827-2.73a.576.576 0 0 0 .01-.814l-.521-.528a.556.556 0 0 0-.796 0l-4.56 4.62a.573.573 0 0 0 0 .806l4.56 4.617a.556.556 0 0 0 .796 0Z"
        })
    });
var $43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1edefcf4055fc9a6$var$SvgCircleLeft;
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "compact__Wrapper",
    componentId: "sc-1a5y08h-0"
})([
    "",
    " display:flex;align-items:center;justify-content:end;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "compact__StyledSVG",
    componentId: "sc-1a5y08h-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "compact__ArrowButton",
    componentId: "sc-1a5y08h-2"
})([
    "",
    " height:24px;width:24px;background:none;padding:0;border-radius:50%;& ",
    "{",
    " height:24px;width:24px;fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "compact__StyledLabel",
    componentId: "sc-1a5y08h-3"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$LeftArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__LeftArrow",
    componentId: "sc-1a5y08h-4"
})([
    "margin-left:16px;"
]);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__RightArrow",
    componentId: "sc-1a5y08h-5"
})([
    "margin-left:8px;& ",
    "{transform:rotate(180deg);}"
], $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$CompactPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, label: label, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, minPageReached: minPageReached, maxPageReached: maxPageReached }] = $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$831351fb15d68ad0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$831351fb15d68ad0$var$CompactPagination;
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "standard__Wrapper",
    componentId: "sc-n01q9o-0"
})([
    "",
    " display:flex;align-items:center;justify-content:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "standard__PageButton",
    componentId: "sc-n01q9o-1"
})([
    "",
    " height:32px;width:32px;margin:4px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:14px;color:",
    ";:hover:enabled{background:",
    ";border:1px solid ",
    ";color:",
    ";}:hover:disabled{cursor:default;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsLightBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsPrimaryText, (props)=>props.selected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsLightBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "standard__StyledArrow",
    componentId: "sc-n01q9o-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton).withConfig({
    displayName: "standard__ArrowButton",
    componentId: "sc-n01q9o-3"
})([
    "& ",
    "{",
    " fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryText, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$LeftArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__LeftArrow",
    componentId: "sc-n01q9o-4"
})([
    "& ",
    "{padding-right:1px;}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__RightArrow",
    componentId: "sc-n01q9o-5"
})([
    "& ",
    "{padding-left:1px;transform:rotate(180deg);}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StandardPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, disableNumbers: disableNumbers, hideNumbers: hideNumbers, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, goToPage: goToPage, minPageReached: minPageReached, maxPageReached: maxPageReached, getPageRange: getPageRange }] = $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            }),
            !hideNumbers && getPageRange().map((i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton, {
                    selected: currentPage === i,
                    onClick: ()=>goToPage(i),
                    disabled: disableNumbers,
                    children: i
                }, i)),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StandardPagination;
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "tabs__Wrapper",
    componentId: "sc-1dgmogo-0"
})([
    "",
    " height:fit-content;width:500px;display:flex;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "tabs__StyledSVG",
    componentId: "sc-1dgmogo-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledTab = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "tabs__StyledTab",
    componentId: "sc-1dgmogo-2"
})([
    "",
    " flex-grow:1;height:45px;background:none;border-bottom:3px solid ",
    ";display:flex;align-items:center;justify-content:center;color:",
    ";",
    " & ",
    "{",
    " height:16px;width:16px;margin-right:16px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
}, (props)=>!props.disabled && !props.selected ? `:hover {
            border-bottom: 3px solid
              ${props.theme.klerosUIComponentsSecondaryBlue};
          }` : "", $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
});
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Tabs = ({ items: items, ...props })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$35a1a5ac66949050$var$Wrapper, {
        ...props,
        children: items.map(({ Icon: Icon, icon: icon, text: text, value: value, disabled: disabled })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledTab, {
                disabled: disabled,
                selected: value === props.currentValue,
                onClick: ()=>props.callback(value),
                children: [
                    icon ?? (Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {
                        className: $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG.styledComponentId
                    })),
                    text
                ]
            }, value))
    });
};
var $43afcb05ca3681f6$var$$35a1a5ac66949050$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Tabs;
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "breadcrumb__Wrapper",
    componentId: "sc-2m5bd-0"
})([
    "",
    " display:flex;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Element = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "breadcrumb__Element",
    componentId: "sc-2m5bd-1"
})([
    "",
    " background:none;padding:0;:hover{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ clickable: clickable, theme: theme })=>clickable ? `small { color: ${theme.klerosUIComponentsPrimaryText}; }` : `cursor: text !important`);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "breadcrumb__Content",
    componentId: "sc-2m5bd-2"
})([
    "",
    " transition:color ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Separator = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__Separator",
    componentId: "sc-2m5bd-3"
})([
    "margin:0px 8px;"
]);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$ActiveElement = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__ActiveElement",
    componentId: "sc-2m5bd-4"
})([
    "color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Breadcrumb = ({ items: items, callback: callback, clickable: clickable, className: className })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Wrapper, {
        className: className,
        children: items.map(({ text: text, value: value }, i)=>i === items.length - 1 ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$ActiveElement, {
                children: text
            }, i) : /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$parcel$interopDefault($dup7A).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Element, {
                        onClick: ()=>callback ? callback(value) : null,
                        clickable: clickable,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content, {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Separator, {
                        children: "/"
                    })
                ]
            }, i))
    });
var $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Breadcrumb;
const $43afcb05ca3681f6$var$$d623bf354733f290$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 12,
        height: 15,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M1.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 10.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM3.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
        })
    });
var $43afcb05ca3681f6$var$$d623bf354733f290$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d623bf354733f290$var$SvgHourglass;
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$progressAnimation = (width)=>(0, $e9f8389e4f70b5af$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], width);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__Wrapper",
    componentId: "sc-bwbdj5-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;font-size:14px;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "linear__StyledText",
    componentId: "sc-bwbdj5-1"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$BarTimerWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__BarTimerWrapper",
    componentId: "sc-bwbdj5-2"
})([
    "display:flex;flex-direction:column;align-items:flex-start;"
]);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LinearChart = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "linear__LinearChart",
    componentId: "sc-bwbdj5-3"
})([
    "",
    " stroke:",
    ";display:block;margin:10px auto;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ width: width })=>width);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LineBackground = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "linear__LineBackground",
    componentId: "sc-bwbdj5-4"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "linear__Line",
    componentId: "sc-bwbdj5-5"
})([
    "stroke:",
    ";",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsSuccess, ({ animated: animated, width: width })=>animated && (0, $e9f8389e4f70b5af$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$progressAnimation(width)));
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledHourglass = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$d623bf354733f290$export$2e2bcd8739ae039).withConfig({
    displayName: "linear__StyledHourglass",
    componentId: "sc-bwbdj5-6"
})([
    "",
    " margin-right:9.75px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$TimerMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__TimerMessage",
    componentId: "sc-bwbdj5-7"
})([
    "margin-top:5px;display:flex;justify-content:center;align-items:center;color:",
    ";font-weight:600;line-height:1em;"
], ({ theme: theme })=>theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Linear = ({ text: text, progress: progress, width: width, timerText: timerText, animated: animated = true })=>{
    const sw = 8;
    const linePath = `M ${sw / 2} ${sw / 2} h ${width - sw}`;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Wrapper, {
        children: [
            text && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledText, {
                children: text
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$BarTimerWrapper, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LinearChart, {
                        width: width,
                        height: sw,
                        fill: "none",
                        strokeWidth: sw,
                        strokeLinecap: "round",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LineBackground, {
                                d: linePath
                            }),
                            progress && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Line, {
                                animated: animated,
                                width: width,
                                strokeDasharray: `${progress * width / 100} ${width}`,
                                d: linePath
                            })
                        ]
                    }),
                    timerText && /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$TimerMessage, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledHourglass, {}),
                            timerText
                        ]
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$8688d42e9f1d381a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Linear;
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$progressAnimation = (circ)=>(0, $e9f8389e4f70b5af$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], circ);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircularChart = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "circular__CircularChart",
    componentId: "sc-73w0na-0"
})([
    "",
    " ",
    " display:block;margin:10px auto;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircleBackground = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "circular__CircleBackground",
    componentId: "sc-73w0na-1"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "circular__Circle",
    componentId: "sc-73w0na-2"
})([
    "stroke:",
    ";",
    ""
], (props)=>props.progress < 100 ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSuccess, ({ animated: animated, circ: circ })=>animated && (0, $e9f8389e4f70b5af$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $43afcb05ca3681f6$var$$e09296aea30ed10d$var$progressAnimation(circ)));
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Percentage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).text.withConfig({
    displayName: "circular__Percentage",
    componentId: "sc-73w0na-3"
})([
    "fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circular = ({ progress: progress, small: small, animated: animated = true })=>{
    const width = small ? 80 : 120;
    const sw = width / 20; // stroke-width
    const rad = (width - sw) / 2 + 1;
    const dy = width - sw + 2;
    const circ = 2 * Math.PI * rad;
    const circlePath = `M ${(width + sw) / 2} ${sw / 2}
  a ${rad} ${rad} 0 0 1 0 ${dy}
  a ${rad} ${rad} 0 0 1 0 -${dy}`;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircularChart, {
        fill: "none",
        strokeWidth: sw,
        strokeLinecap: "round",
        width: width + sw,
        height: width + sw,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircleBackground, {
                d: circlePath
            }),
            progress && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circle, {
                strokeDasharray: `${circ * progress / 100} ${circ}`,
                progress: progress,
                d: circlePath,
                circ: circ,
                animated: animated
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$Percentage, {
                fontSize: small ? 16 : 24,
                fontWeight: 600,
                textAnchor: "middle",
                dominantBaseline: "middle",
                x: "50%",
                y: "50%",
                children: [
                    progress,
                    "%"
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$e09296aea30ed10d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circular;
const $43afcb05ca3681f6$var$$757595619553281c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Wrapper",
    componentId: "sc-1bvj53u-0"
})([
    "height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $43afcb05ca3681f6$var$$757595619553281c$var$StyledSuccess = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "bullet-circle__StyledSuccess",
    componentId: "sc-1bvj53u-1"
})([
    "height:24px;width:24px;flex-basis:auto;fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$757595619553281c$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Circle",
    componentId: "sc-1bvj53u-2"
})([
    "height:24px;width:24px;flex-basis:auto;background-color:",
    ";border-radius:12px;border:1px solid ",
    ";display:flex;justify-content:center;align-items:center;font-size:12px;color:",
    ";"
], (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.active ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$757595619553281c$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Line",
    componentId: "sc-1bvj53u-3"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";margin:8px 0px;"
], (props)=>props.completed ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$757595619553281c$var$BulletCircle = ({ active: active, completed: completed, line: line, index: index, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$757595619553281c$var$Wrapper, {
        ...props,
        children: [
            completed ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$757595619553281c$var$StyledSuccess, {}) : /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$757595619553281c$var$Circle, {
                active: active,
                children: [
                    " ",
                    index,
                    " "
                ]
            }),
            line && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$757595619553281c$var$Line, {
                completed: completed
            })
        ]
    });
var $43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$757595619553281c$var$BulletCircle;
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-1ly7f40-0"
})([
    "flex-basis:0;flex-grow:1;width:fit-content;display:flex;"
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-1ly7f40-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "bullet__StyledBody",
    componentId: "sc-1ly7f40-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$TextContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-1ly7f40-3"
})([
    "margin-left:16px;margin-top:2px;& ",
    "{",
    " font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " font-size:12px;line-height:16px;}"
], $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$SubitemsContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__SubitemsContainer",
    componentId: "sc-1ly7f40-4"
})([
    "display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Bullet = ({ title: title, subitems: subitems, index: index, active: active, completed: completed, line: line, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039, {
                index: index,
                active: active,
                completed: completed,
                line: line
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$TextContainer, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle, {
                        children: title
                    }),
                    subitems && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$SubitemsContainer, {
                        children: subitems.map((item, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody, {
                                children: item
                            }, i))
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Bullet;
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "vertical__Wrapper",
    componentId: "sc-1rvtpa4-0"
})([
    "height:100px;display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$BulletsContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "vertical__BulletsContainer",
    componentId: "sc-1rvtpa4-1"
})([
    "height:auto;display:flex;flex-direction:column;flex-grow:1;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039).withConfig({
    displayName: "vertical__LastBullet",
    componentId: "sc-1rvtpa4-2"
})([
    "flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Steps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$BulletsContainer, {
                children: items.slice(0, -1).map(({ title: title, subitems: subitems }, i)=>/*#__PURE__*/ (0, $dup7A.createElement)($43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039, {
                        title: title,
                        subitems: subitems,
                        completed: i < currentItemIndex,
                        active: i === currentItemIndex,
                        line: !(i + 1 === items.length),
                        index: i + 1,
                        key: i
                    }))
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$LastBullet, {
                title: lastItem.title,
                subitems: lastItem.subitems,
                completed: items.length - 1 < currentItemIndex,
                active: items.length - 1 === currentItemIndex,
                index: items.length
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$2f7d25ee5647072f$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Steps;
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal-bullet__Container",
    componentId: "sc-1tljr4r-0"
})([
    "position:relative;height:fit-content;display:flex;justify-content:center;align-items:start;",
    ""
], ({ theme: theme, last: last, completed: completed })=>last ? (0, $e9f8389e4f70b5af$exports.css)([
        "flex-grow:0;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        'flex-grow:1;:after{content:"";height:0px;width:auto;flex-grow:1;border-top:1px solid ',
        ";margin:12px 16px;}"
    ], completed ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke));
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$TextWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal-bullet__TextWrapper",
    componentId: "sc-1tljr4r-1"
})([
    "margin-left:8px;display:flex;flex-direction:column;align-items:start;> h2{",
    " font-size:14px;line-height:24px;color:",
    ";}> small{",
    " font-size:12px;line-height:16px;}",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "position:absolute;top:24px;left:0;margin-left:0px;transform:translateX(calc(-50% + 12px));align-items:center;text-align:center;> h2{line-height:19px;}"
    ])));
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$HorizontalBullet = ({ index: index, title: title, subitems: subitems, active: active, last: last, completed: completed, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$cf0f856d949d5193$var$Container, {
        active: active,
        completed: completed,
        last: last,
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039, {
                active: active,
                completed: completed,
                index: index
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$cf0f856d949d5193$var$TextWrapper, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("h2", {
                        children: title
                    }),
                    subitems && subitems.map((item, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                            children: item
                        }, i))
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$cf0f856d949d5193$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$cf0f856d949d5193$var$HorizontalBullet;
const $43afcb05ca3681f6$var$$4987b48a13ec5480$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal__Wrapper",
    componentId: "sc-12u32gl-0"
})([
    "",
    " width:250px;display:flex;justify-content:center;align-items:start;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$4987b48a13ec5480$var$HorizontalSteps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4987b48a13ec5480$var$Wrapper, {
        ...props,
        children: items.map((item, i)=>/*#__PURE__*/ (0, $dup7A.createElement)($43afcb05ca3681f6$var$$cf0f856d949d5193$export$2e2bcd8739ae039, {
                ...item,
                completed: i < currentItemIndex,
                active: i === currentItemIndex,
                last: i + 1 === items.length,
                index: i + 1,
                key: i
            }))
    });
var $43afcb05ca3681f6$var$$4987b48a13ec5480$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4987b48a13ec5480$var$HorizontalSteps;
const $43afcb05ca3681f6$var$$250cfcb8116ed97e$var$Steps = ({ horizontal: horizontal, ...props })=>horizontal ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4987b48a13ec5480$export$2e2bcd8739ae039, {
        ...props
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$export$2e2bcd8739ae039, {
        ...props
    });
var $43afcb05ca3681f6$var$$250cfcb8116ed97e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$250cfcb8116ed97e$var$Steps;
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Wrapper",
    componentId: "sc-1nqkm41-0"
})([
    "height:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$colorRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6 = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "accepted") return theme.klerosUIComponentsSuccess;
    if (variant === "refused") return theme.klerosUIComponentsError;
    if (variant && $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$colorRegex.test(variant)) return variant;
    return theme.klerosUIComponentsPrimaryBlue;
});
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Circle",
    componentId: "sc-1nqkm41-1"
})([
    "height:16px;width:16px;flex-basis:auto;background-color:",
    ";border-radius:8px;border:2px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Line",
    componentId: "sc-1nqkm41-2"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Spine = ({ variant: variant, line: line, Icon: Icon })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Wrapper, {
        children: [
            Icon ? /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {}) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Circle, {
                variant: variant
            }),
            line && /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Line, {})
        ]
    });
var $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Spine;
const $43afcb05ca3681f6$var$$febc15bff886858c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-6vrqo5-0"
})([
    "display:flex;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-6vrqo5-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "bullet__StyledParty",
    componentId: "sc-6vrqo5-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "bullet__StyledSubtitle",
    componentId: "sc-6vrqo5-3"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$TextContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-6vrqo5-4"
})([
    "margin-",
    ":20px;order:",
    ";display:flex;flex-direction:column;margin-bottom:",
    ";gap:2px;text-align:",
    ";@media (max-width:900px){margin-",
    ":16px;margin-bottom:",
    ";gap:4px;}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " align-self:flex-",
    ";font-size:12px;line-height:16px;}"
], ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? 1 : -1, ({ isLast: isLast })=>isLast ? "0" : "18px", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ isLast: isLast })=>isLast ? "0" : "16px", $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, ({ rightSided: rightSided })=>rightSided ? 1 : 2, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty, $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6, $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ rightSided: rightSided })=>rightSided ? "start" : "end");
const $43afcb05ca3681f6$var$$febc15bff886858c$var$PartyTitleContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__PartyTitleContainer",
    componentId: "sc-6vrqo5-5"
})([
    "display:flex;flex-direction:row;flex-wrap:wrap;gap:4px 8px;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $43afcb05ca3681f6$var$$febc15bff886858c$var$Bullet = (props)=>{
    const { title: title, party: party, subtitle: subtitle, ...restProps } = props;
    const { rightSided: rightSided, variant: variant, line: line, Icon: Icon, isLast: isLast, ...wrapperProps } = restProps;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$Wrapper, {
        rightSided: rightSided,
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$export$2e2bcd8739ae039, {
                variant: variant,
                line: line,
                Icon: Icon
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$TextContainer, {
                variant: variant,
                rightSided: rightSided,
                isLast: isLast,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$PartyTitleContainer, {
                        rightSided: rightSided,
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty, {
                                children: party
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$febc15bff886858c$var$Bullet;
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "timeline__Wrapper",
    componentId: "sc-rxkvqs-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "timeline__StyledBullet",
    componentId: "sc-rxkvqs-1"
})([
    "position:relative;transform:translateX( ",
    " );"
], ({ rightSided: rightSided })=>rightSided ? "calc(50% - 8px)" : "calc(-50% + 8px)");
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet).withConfig({
    displayName: "timeline__LastBullet",
    componentId: "sc-rxkvqs-2"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Timeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet, {
                    line: true,
                    ...item,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$LastBullet, {
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$c3e303edb7751c77$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Timeline;
const $43afcb05ca3681f6$var$$a3f868921843a442$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-k2o2ay-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$a3f868921843a442$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "custom__LastBullet",
    componentId: "sc-k2o2ay-1"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$a3f868921843a442$var$CustomTimeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$a3f868921843a442$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039, {
                    line: true,
                    ...item,
                    rightSided: true,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a3f868921843a442$var$LastBullet, {
                rightSided: true,
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$a3f868921843a442$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a3f868921843a442$var$CustomTimeline;
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$BaseTag = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "tag__BaseTag",
    componentId: "sc-19f0jzg-0"
})([
    "",
    " ",
    " height:32px;background:",
    ";border:",
    ";border-radius:300px;padding:0 16px;display:flex;justify-content:center;align-items:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme, active: active })=>active ? `1px solid ${theme.klerosUIComponentsPrimaryBlue}` : "none");
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "tag__StyledText",
    componentId: "sc-19f0jzg-1"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$Tag = ({ text: text, active: active, as: as, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4c05722f1abfb34c$var$BaseTag, {
        active: active,
        as: as,
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4c05722f1abfb34c$var$StyledText, {
            children: text
        })
    });
var $43afcb05ca3681f6$var$$4c05722f1abfb34c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$Tag;
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "tooltip__StyledText",
    componentId: "sc-2flh2z-0"
})([
    ""
]);
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "tooltip__StyledTooltip",
    componentId: "sc-2flh2z-1"
})([
    "",
    " ",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ place: place, theme: theme, small: small })=>(0, $e9f8389e4f70b5af$exports.css)([
        "visibility:hidden;position:absolute;z-index:1;width:max-content;max-width:240px;background:",
        ";border-radius:3px;padding:13px 16px;display:flex;justify-content:center;align-items:center;& ",
        "{",
        " font-weight:100;text-align:",
        ";color:",
        ';}::after{content:"";position:absolute;border-width:8px;border-style:solid;}',
        " ",
        " ",
        " ",
        ""
    ], theme.klerosUIComponentsPrimaryBlue, $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, small ? "center" : "left", theme.klerosUIComponentsWhiteBackground, place === "top" && (0, $e9f8389e4f70b5af$exports.css)([
        "bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{top:100%;left:50%;transform:translateX(-50%);border-color:",
        " transparent transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "right" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;left:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;right:100%;transform:translateY(-50%);border-color:transparent ",
        " transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "bottom" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{left:50%;bottom:100%;transform:translateX(-50%);border-color:transparent transparent ",
        " transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "left" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;right:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;left:100%;transform:translateY(-50%);border-color:transparent transparent transparent ",
        ";}"
    ], theme.klerosUIComponentsPrimaryBlue)));
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "tooltip__Wrapper",
    componentId: "sc-2flh2z-2"
})([
    "position:relative;display:inline-block;&:hover ",
    "{visibility:visible;}"
], $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip);
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tooltip = ({ place: place = "top", text: text, children: children, small: small, ...props })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip, {
                small: small,
                place: place,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText, {
                    children: text
                })
            })
        ]
    });
var $43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tooltip;
const $43afcb05ca3681f6$var$$a5329119b99a1727$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M13.776 2.06 12.129.44A1.536 1.536 0 0 0 11.05 0H5.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C.684 3 0 3.672 0 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.843 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06ZM8.444 14.5h-6.73a.192.192 0 0 1-.134-.055.186.186 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.192.192 0 0 1-.135.055Zm4.064-3h-6.73a.192.192 0 0 1-.135-.055.186.186 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.192.192 0 0 1-.135.055Zm.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.186.186 0 0 1 .055.133V3.5Z",
            fill: "#009AFF"
        })
    });
var $43afcb05ca3681f6$var$$a5329119b99a1727$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a5329119b99a1727$var$SvgCopy;
const $43afcb05ca3681f6$var$$24ee0e3ed5abf092$var$SvgCopied = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('#clip0_13289_179292')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#009AFF"
            })
        })
    });
var $43afcb05ca3681f6$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$24ee0e3ed5abf092$var$SvgCopied;
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "copiable__Wrapper",
    componentId: "sc-3t2xjv-0"
})([
    "position:relative;display:inline-flex;align-items:center;gap:8px;"
]);
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$StyledTooltip = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039).withConfig({
    displayName: "copiable__StyledTooltip",
    componentId: "sc-3t2xjv-1"
})([
    "> span{padding:8px;}"
]);
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$IconContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "copiable__IconContainer",
    componentId: "sc-3t2xjv-2"
})([
    "cursor:pointer;display:flex;align-items:center;width:16px;height:16px;"
]);
/**
 * @description Wraps a component to make it copiable.
 * @param copiableContent The text to be copied to user's clipboard
 * @param info Modify the message displayed in the copy button's tooltip
 * @param tooltipProps Copy button's tooltip props
 */ const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Copiable = ({ copiableContent: copiableContent, info: info, children: children, tooltipProps: tooltipProps, ...props })=>{
    const [isCopied, setIsCopied] = (0, $dup7A.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(copiableContent).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>setIsCopied(false));
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$StyledTooltip, {
                text: isCopied ? "Copied!" : `${info ?? "Copy"}`,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$IconContainer, {
                    className: "icon-container",
                    children: isCopied ? /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039, {
                        className: "copied-icon"
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($43afcb05ca3681f6$var$$a5329119b99a1727$export$2e2bcd8739ae039, {
                        className: "copy-icon",
                        onClick: handleCopy
                    })
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Copiable;
const $43afcb05ca3681f6$var$$18386f08588a981e$export$f30cb9bc4f736419 = {
    klerosUIComponentsPrimaryPurple: "#4D00B4",
    klerosUIComponentsSecondaryPurple: "#9013FE",
    klerosUIComponentsMediumPurple: "#F8F1FF",
    klerosUIComponentsLightPurple: "#FBF9FE",
    klerosUIComponentsPrimaryBlue: "#009AFF",
    klerosUIComponentsSecondaryBlue: "#7BCBFF",
    klerosUIComponentsMediumBlue: "#F0F9FF",
    klerosUIComponentsLightBlue: "#FCFEFF",
    klerosUIComponentsPrimaryText: "#333333",
    klerosUIComponentsSecondaryText: "#999999",
    klerosUIComponentsStroke: "#e5e5e5",
    klerosUIComponentsLightGrey: "#FAFAFA",
    klerosUIComponentsWhiteBackground: "#FFFFFF",
    klerosUIComponentsLightBackground: "#FAFBFC",
    klerosUIComponentsDefaultShadow: "#00000002",
    klerosUIComponentsHoveredShadow: "#00000002",
    klerosUIComponentsSuccess: "#00C42B",
    klerosUIComponentsSuccessLight: "#F0FBF2",
    klerosUIComponentsWarning: "#FF9900",
    klerosUIComponentsWarningLight: "#FFF9F0",
    klerosUIComponentsError: "#F60C36",
    klerosUIComponentsErrorLight: "#FEFF0F3",
    klerosUIComponentsTint: "#D14EFF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#F4F0FA",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $43afcb05ca3681f6$var$$18386f08588a981e$export$3e936a8db52a10a0 = {
    klerosUIComponentsPrimaryPurple: "#7E1BD4",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#6CC5FF",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#220050",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $43afcb05ca3681f6$var$$18386f08588a981e$export$a183395ddd946500 = {
    klerosUIComponentsPrimaryPurple: "#200F47",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#69C3FC",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#200F47",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};


const $96f092b373d3c556$export$f30cb9bc4f736419 = {
    ...(0, $43afcb05ca3681f6$exports.lightTheme),
    name: "light",
    white: "#FFFFFF",
    primaryPurple: "#4D00B4",
    secondaryPurple: "#9013FE",
    darkPurple: "#220050",
    mediumPurple: "#F8F1FF",
    lightPurple: "#FBF9FE",
    violetPurple: "#6A1DCD",
    lavenderPurple: "#BB72FF",
    primaryBlue: "#009AFF",
    secondaryBlue: "#7BCBFF",
    mediumBlue: "#F0F9FF",
    lightBlue: "#FCFEFF",
    primaryText: "#333333",
    secondaryText: "#999999",
    stroke: "#e5e5e5",
    lightGrey: "#F0F0F0",
    whiteBackground: "#FFFFFF",
    lightBackground: "#FAFBFC",
    defaultShadow: "#00000002",
    hoveredShadow: "#00000002",
    whiteLowOpacity: "#0000000d",
    blackLowOpacity: "#00000080",
    success: "#00C42B",
    successLight: "#F0FBF2",
    warning: "#FF9900",
    warningLight: "#FFF9F0",
    error: "#F60C36",
    errorLight: "#FEF0F3",
    tint: "#D14EFF",
    tintMedium: "#FCF4FF",
    tintPurple: "#F4F0FA",
    transitionSpeed: "0.25s",
    skeletonBackground: "#EBEBEB",
    skeletonHighlight: "#F5F5F5",
    paleCyan: "#ACFFFF",
    limeGreen: "#F3FFD9"
};
const $96f092b373d3c556$export$3e936a8db52a10a0 = {
    ...(0, $43afcb05ca3681f6$exports.darkTheme),
    name: "dark",
    white: "#FFFFFF",
    primaryPurple: "#7E1BD4",
    secondaryPurple: "#B45FFF",
    darkPurple: "#220050",
    mediumPurple: "#390F6C",
    lightPurple: "#FCFBFF",
    violetPurple: "#6A1DCD",
    lavenderPurple: "#BB72FF",
    primaryBlue: "#6CC5FF",
    secondaryBlue: "#A5DBFF",
    mediumBlue: "#2E206C",
    lightBlue: "#2A1260",
    primaryText: "#DAF0FF",
    secondaryText: "#BECCE5",
    stroke: "#42498F",
    lightGrey: "#2D1865",
    whiteBackground: "#220050",
    lightBackground: "#1B003F",
    defaultShadow: "#00000000",
    hoveredShadow: "#42498f80",
    whiteLowOpacity: "#FFFFFF0F",
    blackLowOpacity: "#00000080",
    success: "#65DC7F",
    successLight: "#32355B",
    warning: "#FFC46B",
    warningLight: "#451F54",
    error: "#FF5A78",
    errorLight: "#360652",
    tint: "#DDB6FF",
    tintMedium: "#401D6C",
    tintPurple: "#2F0960",
    transitionSpeed: "0.25s",
    skeletonBackground: "#3A2270",
    skeletonHighlight: "#3E307C",
    paleCyan: "#ACFFFF",
    limeGreen: "#F3FFD9"
};


const $27c7d505e83322db$var$StyledComponentsProvider = ({ children: children })=>{
    const [theme, setTheme] = (0, $87eb39de431e3151$export$86e2cef2561044ac)("theme", "dark");
    const toggleTheme = ()=>{
        if (theme === "light") setTheme("dark");
        else setTheme("light");
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e9f8389e4f70b5af$export$d8964aec282183a3), {
        theme: theme === "light" ? (0, $96f092b373d3c556$export$f30cb9bc4f736419) : (0, $96f092b373d3c556$export$3e936a8db52a10a0),
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $56d2a25ae1caf5b4$export$d3df7f168cf26f4), {
            theme: theme,
            toggleTheme: toggleTheme,
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b9c5312a558f850a$export$f05794e648629f6c), {}),
                children
            ]
        })
    });
};
var $27c7d505e83322db$export$2e2bcd8739ae039 = $27c7d505e83322db$var$StyledComponentsProvider;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


// src/providers/alchemy.ts
function $e7a1f5d08bc6bdce$export$da85a315824a4e0e({ apiKey: apiKey }) {
    return function(chain) {
        const baseHttpUrl = chain.rpcUrls.alchemy?.http[0];
        const baseWsUrl = chain.rpcUrls.alchemy?.webSocket?.[0];
        if (!baseHttpUrl) return null;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            `${baseHttpUrl}/${apiKey}`
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    `${baseHttpUrl}/${apiKey}`
                ],
                webSocket: [
                    `${baseWsUrl}/${apiKey}`
                ]
            }
        };
    };
}



var $eUiaP = parcelRequire("eUiaP");
var $12u0G = parcelRequire("12u0G");

var $kD2va = parcelRequire("kD2va");

var $g3kzz = parcelRequire("g3kzz");

var $bwGWz = parcelRequire("bwGWz");

var $lYmee = parcelRequire("lYmee");

var $5GkW9 = parcelRequire("5GkW9");

var $89Tbs = parcelRequire("89Tbs");

var $k1mEp = parcelRequire("k1mEp");

var $lbkR2 = parcelRequire("lbkR2");

var $8Yg5s = parcelRequire("8Yg5s");

var $28JPH = parcelRequire("28JPH");

var $81v59 = parcelRequire("81v59");

var $7GGtC = parcelRequire("7GGtC");

var $cZUWN = parcelRequire("cZUWN");

var $gbdt3 = parcelRequire("gbdt3");
const $0d634da287d4e964$var$K = ":";
function $0d634da287d4e964$export$4764229d78de4437(e) {
    const [n, t] = e.split($0d634da287d4e964$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $0d634da287d4e964$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($0d634da287d4e964$var$K);
}
function $0d634da287d4e964$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($0d634da287d4e964$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $0d634da287d4e964$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($0d634da287d4e964$var$K);
}
function $0d634da287d4e964$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $0d634da287d4e964$export$2806d446053abd1d(e) {
    const { address: n } = $0d634da287d4e964$export$276ab0158c66e3d(e);
    return n;
}
function $0d634da287d4e964$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $0d634da287d4e964$export$276ab0158c66e3d(e);
    return $0d634da287d4e964$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $0d634da287d4e964$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $0d634da287d4e964$export$4764229d78de4437(n);
    return $0d634da287d4e964$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $0d634da287d4e964$export$aa4a6b630dfcfa83(e) {
    return $0d634da287d4e964$export$d579bc26e95946b5(e, $0d634da287d4e964$export$2806d446053abd1d);
}
function $0d634da287d4e964$export$d5ee58c6b13696e9(e) {
    return $0d634da287d4e964$export$d579bc26e95946b5(e, $0d634da287d4e964$export$93512919ec2ab555);
}
function $0d634da287d4e964$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $0d634da287d4e964$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$0d634da287d4e964$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $0d634da287d4e964$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$0d634da287d4e964$export$376384387cd15b27(r, o));
    }), t;
}
function $0d634da287d4e964$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $0d634da287d4e964$export$a524ae552db7912 = (e)=>e?.split(":"), $0d634da287d4e964$export$85f23c05c80b194 = (e)=>{
    const n = e && $0d634da287d4e964$export$a524ae552db7912(e);
    if (n) return n[3];
}, $0d634da287d4e964$export$a8b149927aef7051 = (e)=>{
    const n = e && $0d634da287d4e964$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $0d634da287d4e964$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $0d634da287d4e964$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $0d634da287d4e964$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $0d634da287d4e964$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$0d634da287d4e964$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $0d634da287d4e964$export$f7403969428298bd = "base10", $0d634da287d4e964$export$49eb910ab2518105 = "base16", $0d634da287d4e964$export$9bff723d552e6bcf = "base64pad", $0d634da287d4e964$export$9560dad2a83e4f04 = "utf8", $0d634da287d4e964$export$3425bd336a9673d8 = 0, $0d634da287d4e964$export$406e97c329f0f3d4 = 1, $0d634da287d4e964$var$Dn = 0, $0d634da287d4e964$var$Pe = 1, $0d634da287d4e964$var$Z = 12, $0d634da287d4e964$var$X = 32;
function $0d634da287d4e964$export$a949d36eab55b41f() {
    const e = $89Tbs.generateKeyPair();
    return {
        privateKey: (0, $k1mEp.toString)(e.secretKey, $0d634da287d4e964$export$49eb910ab2518105),
        publicKey: (0, $k1mEp.toString)(e.publicKey, $0d634da287d4e964$export$49eb910ab2518105)
    };
}
function $0d634da287d4e964$export$d15a28e4f1821243() {
    const e = (0, $lYmee.randomBytes)($0d634da287d4e964$var$X);
    return (0, $k1mEp.toString)(e, $0d634da287d4e964$export$49eb910ab2518105);
}
function $0d634da287d4e964$export$f8378f68e053f5c6(e, n) {
    const t = $89Tbs.sharedKey((0, $k1mEp.fromString)(e, $0d634da287d4e964$export$49eb910ab2518105), (0, $k1mEp.fromString)(n, $0d634da287d4e964$export$49eb910ab2518105), !0), r = new (0, $bwGWz.HKDF)((0, $5GkW9.SHA256), t).expand($0d634da287d4e964$var$X);
    return (0, $k1mEp.toString)(r, $0d634da287d4e964$export$49eb910ab2518105);
}
function $0d634da287d4e964$export$1e87d19d4aab5805(e) {
    const n = (0, $5GkW9.hash)((0, $k1mEp.fromString)(e, $0d634da287d4e964$export$49eb910ab2518105));
    return (0, $k1mEp.toString)(n, $0d634da287d4e964$export$49eb910ab2518105);
}
function $0d634da287d4e964$export$d4c241cec96564c1(e) {
    const n = (0, $5GkW9.hash)((0, $k1mEp.fromString)(e, $0d634da287d4e964$export$9560dad2a83e4f04));
    return (0, $k1mEp.toString)(n, $0d634da287d4e964$export$49eb910ab2518105);
}
function $0d634da287d4e964$export$e9d2f9ba70428fb6(e) {
    return (0, $k1mEp.fromString)(`${e}`, $0d634da287d4e964$export$f7403969428298bd);
}
function $0d634da287d4e964$export$7547a514ee29b9d4(e) {
    return Number((0, $k1mEp.toString)(e, $0d634da287d4e964$export$f7403969428298bd));
}
function $0d634da287d4e964$export$5b0f6292f11d1d18(e) {
    const n = $0d634da287d4e964$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $0d634da287d4e964$export$3425bd336a9673d8);
    if ($0d634da287d4e964$export$7547a514ee29b9d4(n) === $0d634da287d4e964$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $k1mEp.fromString)(e.senderPublicKey, $0d634da287d4e964$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $k1mEp.fromString)(e.iv, $0d634da287d4e964$export$49eb910ab2518105) : (0, $lYmee.randomBytes)($0d634da287d4e964$var$Z), o = new (0, $g3kzz.ChaCha20Poly1305)((0, $k1mEp.fromString)(e.symKey, $0d634da287d4e964$export$49eb910ab2518105)).seal(r, (0, $k1mEp.fromString)(e.message, $0d634da287d4e964$export$9560dad2a83e4f04));
    return $0d634da287d4e964$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $0d634da287d4e964$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $g3kzz.ChaCha20Poly1305)((0, $k1mEp.fromString)(e.symKey, $0d634da287d4e964$export$49eb910ab2518105)), { sealed: t, iv: r } = $0d634da287d4e964$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $k1mEp.toString)(o, $0d634da287d4e964$export$9560dad2a83e4f04);
}
function $0d634da287d4e964$export$dfdc1655ccc5b9cb(e) {
    if ($0d634da287d4e964$export$7547a514ee29b9d4(e.type) === $0d634da287d4e964$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $k1mEp.toString)((0, $k1mEp.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $0d634da287d4e964$export$9bff723d552e6bcf);
    }
    return (0, $k1mEp.toString)((0, $k1mEp.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $0d634da287d4e964$export$9bff723d552e6bcf);
}
function $0d634da287d4e964$export$efcd34ab6248d3cd(e) {
    const n = (0, $k1mEp.fromString)(e, $0d634da287d4e964$export$9bff723d552e6bcf), t = n.slice($0d634da287d4e964$var$Dn, $0d634da287d4e964$var$Pe), r = $0d634da287d4e964$var$Pe;
    if ($0d634da287d4e964$export$7547a514ee29b9d4(t) === $0d634da287d4e964$export$406e97c329f0f3d4) {
        const d = r + $0d634da287d4e964$var$X, l = d + $0d634da287d4e964$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $0d634da287d4e964$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $0d634da287d4e964$export$177f3e316562333d(e, n) {
    const t = $0d634da287d4e964$export$efcd34ab6248d3cd(e);
    return $0d634da287d4e964$export$7949f60f2444aef2({
        type: $0d634da287d4e964$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $k1mEp.toString)(t.senderPublicKey, $0d634da287d4e964$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $0d634da287d4e964$export$7949f60f2444aef2(e) {
    const n = e?.type || $0d634da287d4e964$export$3425bd336a9673d8;
    if (n === $0d634da287d4e964$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $0d634da287d4e964$export$8c165704db2d5c15(e) {
    return e.type === $0d634da287d4e964$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $0d634da287d4e964$var$Bn = Object.defineProperty, $0d634da287d4e964$var$Ue = Object.getOwnPropertySymbols, $0d634da287d4e964$var$Gn = Object.prototype.hasOwnProperty, $0d634da287d4e964$var$Wn = Object.prototype.propertyIsEnumerable, $0d634da287d4e964$var$_e = (e, n, t)=>n in e ? $0d634da287d4e964$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $0d634da287d4e964$var$Ce = (e, n)=>{
    for(var t in n || (n = {}))$0d634da287d4e964$var$Gn.call(n, t) && $0d634da287d4e964$var$_e(e, t, n[t]);
    if ($0d634da287d4e964$var$Ue) for (var t of $0d634da287d4e964$var$Ue(n))$0d634da287d4e964$var$Wn.call(n, t) && $0d634da287d4e964$var$_e(e, t, n[t]);
    return e;
};
const $0d634da287d4e964$export$f12873d77424d47b = "ReactNative", $0d634da287d4e964$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $0d634da287d4e964$export$657dee6d5648750a = " ", $0d634da287d4e964$export$96c3628b3b9d2079 = ":", $0d634da287d4e964$export$98238152dfccf046 = "/", $0d634da287d4e964$export$7f882bb969de14a3 = 2, $0d634da287d4e964$export$77baccb4c6bd5852 = 1e3, $0d634da287d4e964$export$e08b61c98317d88c = "js";
function $0d634da287d4e964$export$8ee0fc9ee280b4ee() {
    return typeof $gbdt3 < "u" && typeof $gbdt3.versions < "u" && typeof $gbdt3.versions.node < "u";
}
function $0d634da287d4e964$export$f7a1e23e542d38e3() {
    return !(0, $28JPH.getDocument)() && !!(0, $28JPH.getNavigator)() && navigator.product === $0d634da287d4e964$export$f12873d77424d47b;
}
function $0d634da287d4e964$export$4e09c449d6c407f7() {
    return !$0d634da287d4e964$export$8ee0fc9ee280b4ee() && !!(0, $28JPH.getNavigator)() && !!(0, $28JPH.getDocument)();
}
function $0d634da287d4e964$export$57570b1603cf6adb() {
    return $0d634da287d4e964$export$f7a1e23e542d38e3() ? $0d634da287d4e964$export$86b1301a63b15dd9.reactNative : $0d634da287d4e964$export$8ee0fc9ee280b4ee() ? $0d634da287d4e964$export$86b1301a63b15dd9.node : $0d634da287d4e964$export$4e09c449d6c407f7() ? $0d634da287d4e964$export$86b1301a63b15dd9.browser : $0d634da287d4e964$export$86b1301a63b15dd9.unknown;
}
function $0d634da287d4e964$export$40a40f90174d197c() {
    var e;
    try {
        return $0d634da287d4e964$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $0d634da287d4e964$export$c4147c69f6845da(e, n) {
    let t = $7GGtC.parse(e);
    return t = $0d634da287d4e964$var$Ce($0d634da287d4e964$var$Ce({}, t), n), e = $7GGtC.stringify(t), e;
}
function $0d634da287d4e964$export$ba31e015127122bb() {
    return (0, $81v59.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $0d634da287d4e964$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $0d634da287d4e964$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $28JPH.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $0d634da287d4e964$export$20d4a3cb5829b8b6() {
    if ($0d634da287d4e964$export$57570b1603cf6adb() === $0d634da287d4e964$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $lbkR2.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $0d634da287d4e964$export$4389b0987726d52d() {
    var e;
    const n = $0d634da287d4e964$export$57570b1603cf6adb();
    return n === $0d634da287d4e964$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $28JPH.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $0d634da287d4e964$export$b55a4c6e272b719f(e, n, t) {
    const r = $0d634da287d4e964$export$20d4a3cb5829b8b6(), o = $0d634da287d4e964$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $0d634da287d4e964$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $0d634da287d4e964$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $0d634da287d4e964$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $0d634da287d4e964$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $0d634da287d4e964$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $0d634da287d4e964$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $0d634da287d4e964$export$1e21530e896c0b0b(e, n = $0d634da287d4e964$export$7f882bb969de14a3) {
    return $0d634da287d4e964$export$7f00885504704576(e.split($0d634da287d4e964$export$98238152dfccf046), n);
}
function $0d634da287d4e964$export$80bffd46c37a96f6(e) {
    return $0d634da287d4e964$export$1e21530e896c0b0b(e).join($0d634da287d4e964$export$657dee6d5648750a);
}
function $0d634da287d4e964$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $0d634da287d4e964$export$7f00885504704576(e, n = $0d634da287d4e964$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $0d634da287d4e964$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $0d634da287d4e964$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $0d634da287d4e964$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $0d634da287d4e964$export$85c927578394b28b = (e)=>e;
function $0d634da287d4e964$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $0d634da287d4e964$export$9a00dee1beb8f576(e) {
    return e.split($0d634da287d4e964$export$657dee6d5648750a).map((n)=>$0d634da287d4e964$export$e9f8fcacef3bca4b(n)).join($0d634da287d4e964$export$657dee6d5648750a);
}
function $0d634da287d4e964$export$cbf9e3cc9ffc85cb(e = (0, $8Yg5s.FIVE_MINUTES), n) {
    const t = (0, $8Yg5s.toMiliseconds)(e || (0, $8Yg5s.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $0d634da287d4e964$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $0d634da287d4e964$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $0d634da287d4e964$export$43ab92477f8713b9(e) {
    return $0d634da287d4e964$export$187ab6574b2ae23f("topic", e);
}
function $0d634da287d4e964$export$bd13103c2e5cc0c3(e) {
    return $0d634da287d4e964$export$187ab6574b2ae23f("id", e);
}
function $0d634da287d4e964$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $0d634da287d4e964$export$b136d03015bfc12(e, n) {
    return (0, $8Yg5s.fromMiliseconds)((n || Date.now()) + (0, $8Yg5s.toMiliseconds)(e));
}
function $0d634da287d4e964$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $8Yg5s.toMiliseconds)(e);
}
function $0d634da287d4e964$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $0d634da287d4e964$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $0d634da287d4e964$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $0d634da287d4e964$export$57570b1603cf6adb();
        i === $0d634da287d4e964$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $0d634da287d4e964$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $0d634da287d4e964$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($0d634da287d4e964$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $0d634da287d4e964$export$822d0bd1635d5360 = "irn";
function $0d634da287d4e964$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $0d634da287d4e964$export$822d0bd1635d5360
    };
}
function $0d634da287d4e964$export$604e3deb95e1b734(e) {
    const n = (0, $cZUWN.RELAY_JSONRPC)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $0d634da287d4e964$var$bt = Object.defineProperty, $0d634da287d4e964$var$qe = Object.getOwnPropertySymbols, $0d634da287d4e964$var$Nt = Object.prototype.hasOwnProperty, $0d634da287d4e964$var$Ot = Object.prototype.propertyIsEnumerable, $0d634da287d4e964$var$Be = (e, n, t)=>n in e ? $0d634da287d4e964$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $0d634da287d4e964$var$St = (e, n)=>{
    for(var t in n || (n = {}))$0d634da287d4e964$var$Nt.call(n, t) && $0d634da287d4e964$var$Be(e, t, n[t]);
    if ($0d634da287d4e964$var$qe) for (var t of $0d634da287d4e964$var$qe(n))$0d634da287d4e964$var$Ot.call(n, t) && $0d634da287d4e964$var$Be(e, t, n[t]);
    return e;
};
function $0d634da287d4e964$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $0d634da287d4e964$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $7GGtC.parse(s);
    return {
        protocol: r,
        topic: $0d634da287d4e964$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $0d634da287d4e964$export$3d24f408c2ac468a(i)
    };
}
function $0d634da287d4e964$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $0d634da287d4e964$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $0d634da287d4e964$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $7GGtC.stringify($0d634da287d4e964$var$St({
        symKey: e.symKey
    }, $0d634da287d4e964$export$65c55c7ccd19bb8f(e.relay)));
}
var $0d634da287d4e964$var$Pt = Object.defineProperty, $0d634da287d4e964$var$Rt = Object.defineProperties, $0d634da287d4e964$var$Tt = Object.getOwnPropertyDescriptors, $0d634da287d4e964$var$Ye = Object.getOwnPropertySymbols, $0d634da287d4e964$var$At = Object.prototype.hasOwnProperty, $0d634da287d4e964$var$Ut = Object.prototype.propertyIsEnumerable, $0d634da287d4e964$var$Je = (e, n, t)=>n in e ? $0d634da287d4e964$var$Pt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $0d634da287d4e964$var$_t = (e, n)=>{
    for(var t in n || (n = {}))$0d634da287d4e964$var$At.call(n, t) && $0d634da287d4e964$var$Je(e, t, n[t]);
    if ($0d634da287d4e964$var$Ye) for (var t of $0d634da287d4e964$var$Ye(n))$0d634da287d4e964$var$Ut.call(n, t) && $0d634da287d4e964$var$Je(e, t, n[t]);
    return e;
}, $0d634da287d4e964$var$Ct = (e, n)=>$0d634da287d4e964$var$Rt(e, $0d634da287d4e964$var$Tt(n));
function $0d634da287d4e964$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $0d634da287d4e964$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$0d634da287d4e964$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $0d634da287d4e964$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $0d634da287d4e964$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $0d634da287d4e964$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $0d634da287d4e964$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $0d634da287d4e964$export$a8daa26a7c60ef90(e, n) {
    const t = $0d634da287d4e964$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $0d634da287d4e964$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $0d634da287d4e964$export$2994550cda701c96(n), s = $0d634da287d4e964$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $0d634da287d4e964$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : g.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : g.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : g.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const g = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((P)=>r[c].chains.includes(P)), En = r[c].methods.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.methods) == null ? void 0 : j.includes(P);
        }), bn = r[c].events.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.events) == null ? void 0 : j.includes(P);
        }), Nn = g?.map((P)=>r[c].accounts.filter((R)=>R.includes(`${P}:`))).flat();
        l[c] = {
            chains: $0d634da287d4e964$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, g),
            methods: $0d634da287d4e964$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $0d634da287d4e964$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $0d634da287d4e964$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $0d634da287d4e964$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $0d634da287d4e964$export$dd404c96fbbb1ff8(e) {
    return $0d634da287d4e964$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $0d634da287d4e964$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$0d634da287d4e964$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $0d634da287d4e964$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $0d634da287d4e964$export$dd404c96fbbb1ff8(s);
        o[u] = $0d634da287d4e964$var$Ct($0d634da287d4e964$var$_t({}, o[u]), {
            chains: $0d634da287d4e964$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $0d634da287d4e964$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $0d634da287d4e964$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $0d634da287d4e964$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $0d634da287d4e964$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $0d634da287d4e964$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $0d634da287d4e964$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $0d634da287d4e964$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $0d634da287d4e964$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $0d634da287d4e964$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $0d634da287d4e964$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $0d634da287d4e964$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $0d634da287d4e964$export$ee898ca48ab56c74(e, n) {
    return n && $0d634da287d4e964$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $0d634da287d4e964$export$d6781b696a0576d1(e, n) {
    return n && $0d634da287d4e964$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $0d634da287d4e964$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $0d634da287d4e964$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $0d634da287d4e964$export$d46695d9c3664fe9(d), a = t[i];
        (!$0d634da287d4e964$export$1468a49de573f7f9($0d634da287d4e964$export$376384387cd15b27(i, a), u) || !$0d634da287d4e964$export$1468a49de573f7f9(a.methods, l) || !$0d634da287d4e964$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $0d634da287d4e964$export$e544b39f0a22e47a(e) {
    return $0d634da287d4e964$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $0d634da287d4e964$export$49e4a5b6862e3c71(e) {
    if ($0d634da287d4e964$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $0d634da287d4e964$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $0d634da287d4e964$export$bef94a5618bf18bf(e) {
    if ($0d634da287d4e964$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $0d634da287d4e964$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $0d634da287d4e964$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $0d634da287d4e964$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $0d634da287d4e964$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $0d634da287d4e964$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $0d634da287d4e964$export$c12fced8176774f3(e) {
    let n = !0;
    return $0d634da287d4e964$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$0d634da287d4e964$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $0d634da287d4e964$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $0d634da287d4e964$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $0d634da287d4e964$export$e544b39f0a22e47a(o) || (r = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $0d634da287d4e964$export$e544b39f0a22e47a(e) || (r = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $0d634da287d4e964$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $0d634da287d4e964$export$df46c123d7e298ce(o, $0d634da287d4e964$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $0d634da287d4e964$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $0d634da287d4e964$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $0d634da287d4e964$export$49e4a5b6862e3c71(r) || (t = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $0d634da287d4e964$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $0d634da287d4e964$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $0d634da287d4e964$export$b32541d63753af56(e, n) {
    let t = null;
    return $0d634da287d4e964$export$c12fced8176774f3(e?.methods) ? $0d634da287d4e964$export$c12fced8176774f3(e?.events) || (t = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $0d634da287d4e964$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $0d634da287d4e964$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $0d634da287d4e964$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $0d634da287d4e964$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $0d634da287d4e964$export$16a0268bc22b47b0(e)) {
        const o = $0d634da287d4e964$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $0d634da287d4e964$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $0d634da287d4e964$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $0d634da287d4e964$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $0d634da287d4e964$export$16a0268bc22b47b0(e)) {
        const r = $0d634da287d4e964$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $0d634da287d4e964$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $0d634da287d4e964$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $0d634da287d4e964$export$1b3fc298be8c9a7b(e) {
    return $0d634da287d4e964$export$ee898ca48ab56c74(e.protocol, !0);
}
function $0d634da287d4e964$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $0d634da287d4e964$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $0d634da287d4e964$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $0d634da287d4e964$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $0d634da287d4e964$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $0d634da287d4e964$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$0d634da287d4e964$export$d6781b696a0576d1(e.code, !1) || !e.message || !$0d634da287d4e964$export$ee898ca48ab56c74(e.message, !1));
}
function $0d634da287d4e964$export$1a2af3c017fb6d42(e) {
    return !($0d634da287d4e964$export$fce6876652108ab(e) || !$0d634da287d4e964$export$ee898ca48ab56c74(e.method, !1));
}
function $0d634da287d4e964$export$1ae38cf0a848f651(e) {
    return !($0d634da287d4e964$export$fce6876652108ab(e) || $0d634da287d4e964$export$fce6876652108ab(e.result) && $0d634da287d4e964$export$fce6876652108ab(e.error) || !$0d634da287d4e964$export$d6781b696a0576d1(e.id, !1) || !$0d634da287d4e964$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $0d634da287d4e964$export$cbe4cdc5960cfa11(e) {
    return !($0d634da287d4e964$export$fce6876652108ab(e) || !$0d634da287d4e964$export$ee898ca48ab56c74(e.name, !1));
}
function $0d634da287d4e964$export$144fc36610eb6522(e, n) {
    return !(!$0d634da287d4e964$export$e544b39f0a22e47a(n) || !$0d634da287d4e964$export$fb6db6038e742b14(e).includes(n));
}
function $0d634da287d4e964$export$8db4804e3a6de711(e, n, t) {
    return $0d634da287d4e964$export$ee898ca48ab56c74(t, !1) ? $0d634da287d4e964$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $0d634da287d4e964$export$df2c67ef8baad16b(e, n, t) {
    return $0d634da287d4e964$export$ee898ca48ab56c74(t, !1) ? $0d634da287d4e964$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $0d634da287d4e964$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $0d634da287d4e964$var$Qt(e), s = $0d634da287d4e964$var$Zt(n), i = Object.keys(o), d = Object.keys(s), l = $0d634da287d4e964$var$pn(Object.keys(e)), c = $0d634da287d4e964$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $0d634da287d4e964$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $0d634da287d4e964$export$1468a49de573f7f9(i, d) || (r = $0d634da287d4e964$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $0d634da287d4e964$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $0d634da287d4e964$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($0d634da287d4e964$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $0d634da287d4e964$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $0d634da287d4e964$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $0d634da287d4e964$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $0d634da287d4e964$var$Qt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $0d634da287d4e964$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $0d634da287d4e964$var$Zt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $0d634da287d4e964$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $0d634da287d4e964$export$59fba2af1ac782b(e, n) {
    return $0d634da287d4e964$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $0d634da287d4e964$export$53c2fd0173ad2b80() {
    const e = $0d634da287d4e964$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $0d634da287d4e964$export$86b1301a63b15dd9.browser:
                n($0d634da287d4e964$export$2f147c609a999e49());
                break;
            case $0d634da287d4e964$export$86b1301a63b15dd9.reactNative:
                n($0d634da287d4e964$export$1444c95b1570bd12());
                break;
            case $0d634da287d4e964$export$86b1301a63b15dd9.node:
                n($0d634da287d4e964$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $0d634da287d4e964$export$2f147c609a999e49() {
    return $0d634da287d4e964$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $0d634da287d4e964$export$1444c95b1570bd12() {
    if ($0d634da287d4e964$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $0d634da287d4e964$export$aec5b2d627eec500() {
    return !0;
}
function $0d634da287d4e964$export$600a1ee4bc680996(e) {
    switch($0d634da287d4e964$export$57570b1603cf6adb()){
        case $0d634da287d4e964$export$86b1301a63b15dd9.browser:
            $0d634da287d4e964$export$d32b24f18d96c5f2(e);
            break;
        case $0d634da287d4e964$export$86b1301a63b15dd9.reactNative:
            $0d634da287d4e964$export$904edb1c18ec91c7(e);
            break;
        case $0d634da287d4e964$export$86b1301a63b15dd9.node:
            break;
    }
}
function $0d634da287d4e964$export$d32b24f18d96c5f2(e) {
    !$0d634da287d4e964$export$f7a1e23e542d38e3() && $0d634da287d4e964$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $0d634da287d4e964$export$904edb1c18ec91c7(e) {
    $0d634da287d4e964$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $0d634da287d4e964$var$ae = {};
class $0d634da287d4e964$export$b72d712fed4d036d {
    static get(n) {
        return $0d634da287d4e964$var$ae[n];
    }
    static set(n, t) {
        $0d634da287d4e964$var$ae[n] = t;
    }
    static delete(n) {
        delete $0d634da287d4e964$var$ae[n];
    }
}



var $kSNL7 = parcelRequire("kSNL7");
var $bCHCD = parcelRequire("bCHCD");
var $aegFK = parcelRequire("aegFK");
var $7S6Nv = parcelRequire("7S6Nv");
var $cYDOa = parcelRequire("cYDOa");
var $88539ea25e891070$var$NAMESPACE = "eip155";
var $88539ea25e891070$var$STORE_KEY = "store";
var $88539ea25e891070$var$REQUESTED_CHAINS_KEY = "requestedChains";
var $88539ea25e891070$var$ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain";
var $88539ea25e891070$var$_provider, $88539ea25e891070$var$_initProviderPromise, $88539ea25e891070$var$_createProvider, $88539ea25e891070$var$createProvider_fn, $88539ea25e891070$var$_initProvider, $88539ea25e891070$var$initProvider_fn, $88539ea25e891070$var$_isChainsStale, $88539ea25e891070$var$isChainsStale_fn, $88539ea25e891070$var$_setupListeners, $88539ea25e891070$var$setupListeners_fn, $88539ea25e891070$var$_removeListeners, $88539ea25e891070$var$removeListeners_fn, $88539ea25e891070$var$_setRequestedChainsIds, $88539ea25e891070$var$setRequestedChainsIds_fn, $88539ea25e891070$var$_getRequestedChainsIds, $88539ea25e891070$var$getRequestedChainsIds_fn, $88539ea25e891070$var$_getNamespaceChainsIds, $88539ea25e891070$var$getNamespaceChainsIds_fn, $88539ea25e891070$var$_getNamespaceMethods, $88539ea25e891070$var$getNamespaceMethods_fn;
var $88539ea25e891070$export$c456b2d327ac201f = class extends (0, $kD2va.Connector) {
    constructor(config){
        super({
            ...config,
            options: {
                isNewChainsStale: true,
                ...config.options
            }
        });
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_createProvider);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_initProvider);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_isChainsStale);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_setupListeners);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_removeListeners);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_setRequestedChainsIds);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_getRequestedChainsIds);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_getNamespaceChainsIds);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_getNamespaceMethods);
        this.id = "walletConnect";
        this.name = "WalletConnect";
        this.ready = true;
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_provider, void 0);
        (0, $kD2va.__privateAdd)(this, $88539ea25e891070$var$_initProviderPromise, void 0);
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $aegFK.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = Number(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = ()=>{
            (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_setRequestedChainsIds, $88539ea25e891070$var$setRequestedChainsIds_fn).call(this, []);
            this.emit("disconnect");
        };
        this.onDisplayUri = (uri)=>{
            this.emit("message", {
                type: "display_uri",
                data: uri
            });
        };
        this.onConnect = ()=>{
            this.emit("connect", {});
        };
        (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_createProvider, $88539ea25e891070$var$createProvider_fn).call(this);
    }
    async connect({ chainId: chainId, pairingTopic: pairingTopic } = {}) {
        try {
            let targetChainId = chainId;
            if (!targetChainId) {
                const store = this.storage?.getItem($88539ea25e891070$var$STORE_KEY);
                const lastUsedChainId = store?.state?.data?.chain?.id;
                if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId)) targetChainId = lastUsedChainId;
                else targetChainId = this.chains[0]?.id;
            }
            if (!targetChainId) throw new Error("No chains found on connector.");
            const provider = await this.getProvider();
            (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_setupListeners, $88539ea25e891070$var$setupListeners_fn).call(this);
            const isChainsStale = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_isChainsStale, $88539ea25e891070$var$isChainsStale_fn).call(this);
            if (provider.session && isChainsStale) await provider.disconnect();
            if (!provider.session || isChainsStale) {
                const optionalChains = this.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                this.emit("message", {
                    type: "connecting"
                });
                await provider.connect({
                    pairingTopic: pairingTopic,
                    optionalChains: [
                        targetChainId,
                        ...optionalChains
                    ]
                });
                (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_setRequestedChainsIds, $88539ea25e891070$var$setRequestedChainsIds_fn).call(this, this.chains.map(({ id: id2 })=>id2));
            }
            const accounts = await provider.enable();
            const account = (0, $aegFK.getAddress)(accounts[0]);
            const id = await this.getChainId();
            const unsupported = this.isChainUnsupported(id);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (/user rejected/i.test(error?.message)) throw new (0, $cYDOa.UserRejectedRequestError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        try {
            await provider.disconnect();
        } catch (error) {
            if (!/No matching key/i.test(error.message)) throw error;
        } finally{
            (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_removeListeners, $88539ea25e891070$var$removeListeners_fn).call(this);
            (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_setRequestedChainsIds, $88539ea25e891070$var$setRequestedChainsIds_fn).call(this, []);
        }
    }
    async getAccount() {
        const { accounts: accounts } = await this.getProvider();
        return (0, $aegFK.getAddress)(accounts[0]);
    }
    async getChainId() {
        const { chainId: chainId } = await this.getProvider();
        return chainId;
    }
    async getProvider({ chainId: chainId } = {}) {
        if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider)) await (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_createProvider, $88539ea25e891070$var$createProvider_fn).call(this);
        if (chainId) await this.switchChain(chainId);
        return (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider({
                chainId: chainId
            }),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $kSNL7.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $bCHCD.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            const [account, provider] = await Promise.all([
                this.getAccount(),
                this.getProvider()
            ]);
            const isChainsStale = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_isChainsStale, $88539ea25e891070$var$isChainsStale_fn).call(this);
            if (!account) return false;
            if (isChainsStale && provider.session) {
                try {
                    await provider.disconnect();
                } catch  {}
                return false;
            }
            return true;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const chain = this.chains.find((chain2)=>chain2.id === chainId);
        if (!chain) throw new (0, $cYDOa.SwitchChainError)(new Error("chain not found on connector."));
        try {
            const provider = await this.getProvider();
            const namespaceChains = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getNamespaceChainsIds, $88539ea25e891070$var$getNamespaceChainsIds_fn).call(this);
            const namespaceMethods = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getNamespaceMethods, $88539ea25e891070$var$getNamespaceMethods_fn).call(this);
            const isChainApproved = namespaceChains.includes(chainId);
            if (!isChainApproved && namespaceMethods.includes($88539ea25e891070$var$ADD_ETH_CHAIN_METHOD)) {
                await provider.request({
                    method: $88539ea25e891070$var$ADD_ETH_CHAIN_METHOD,
                    params: [
                        {
                            chainId: (0, $7S6Nv.numberToHex)(chain.id),
                            blockExplorerUrls: [
                                chain.blockExplorers?.default?.url
                            ],
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                ...chain.rpcUrls.default.http
                            ]
                        }
                    ]
                });
                const requestedChains = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getRequestedChainsIds, $88539ea25e891070$var$getRequestedChainsIds_fn).call(this);
                requestedChains.push(chainId);
                (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_setRequestedChainsIds, $88539ea25e891070$var$setRequestedChainsIds_fn).call(this, requestedChains);
            }
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId: (0, $7S6Nv.numberToHex)(chainId)
                    }
                ]
            });
            return chain;
        } catch (error) {
            const message = typeof error === "string" ? error : error?.message;
            if (/user rejected request/i.test(message)) throw new (0, $cYDOa.UserRejectedRequestError)(error);
            throw new (0, $cYDOa.SwitchChainError)(error);
        }
    }
};
$88539ea25e891070$var$_provider = new WeakMap();
$88539ea25e891070$var$_initProviderPromise = new WeakMap();
$88539ea25e891070$var$_createProvider = new WeakSet();
$88539ea25e891070$var$createProvider_fn = async function() {
    if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_initProviderPromise) && typeof window !== "undefined") (0, $kD2va.__privateSet)(this, $88539ea25e891070$var$_initProviderPromise, (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_initProvider, $88539ea25e891070$var$initProvider_fn).call(this));
    return (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_initProviderPromise);
};
$88539ea25e891070$var$_initProvider = new WeakSet();

$88539ea25e891070$var$initProvider_fn = async function() {
    const { EthereumProvider: EthereumProvider } = await (parcelRequire("1WeUc"));
    const optionalChains = this.chains.map(({ id: id })=>id);
    if (optionalChains.length) {
        const { projectId: projectId, showQrModal: showQrModal = true, qrModalOptions: qrModalOptions, metadata: metadata, relayUrl: relayUrl } = this.options;
        (0, $kD2va.__privateSet)(this, $88539ea25e891070$var$_provider, await EthereumProvider.init({
            showQrModal: showQrModal,
            qrModalOptions: qrModalOptions,
            projectId: projectId,
            optionalChains: optionalChains,
            rpcMap: Object.fromEntries(this.chains.map((chain)=>[
                    chain.id,
                    chain.rpcUrls.default.http[0]
                ])),
            metadata: metadata,
            relayUrl: relayUrl
        }));
    }
};
$88539ea25e891070$var$_isChainsStale = new WeakSet();
$88539ea25e891070$var$isChainsStale_fn = function() {
    const namespaceMethods = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getNamespaceMethods, $88539ea25e891070$var$getNamespaceMethods_fn).call(this);
    if (namespaceMethods.includes($88539ea25e891070$var$ADD_ETH_CHAIN_METHOD)) return false;
    if (!this.options.isNewChainsStale) return false;
    const requestedChains = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getRequestedChainsIds, $88539ea25e891070$var$getRequestedChainsIds_fn).call(this);
    const connectorChains = this.chains.map(({ id: id })=>id);
    const namespaceChains = (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_getNamespaceChainsIds, $88539ea25e891070$var$getNamespaceChainsIds_fn).call(this);
    if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
    return !connectorChains.every((id)=>requestedChains.includes(id));
};
$88539ea25e891070$var$_setupListeners = new WeakSet();
$88539ea25e891070$var$setupListeners_fn = function() {
    if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider)) return;
    (0, $kD2va.__privateMethod)(this, $88539ea25e891070$var$_removeListeners, $88539ea25e891070$var$removeListeners_fn).call(this);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("accountsChanged", this.onAccountsChanged);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("chainChanged", this.onChainChanged);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("disconnect", this.onDisconnect);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("session_delete", this.onDisconnect);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("display_uri", this.onDisplayUri);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).on("connect", this.onConnect);
};
$88539ea25e891070$var$_removeListeners = new WeakSet();
$88539ea25e891070$var$removeListeners_fn = function() {
    if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider)) return;
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("accountsChanged", this.onAccountsChanged);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("chainChanged", this.onChainChanged);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("disconnect", this.onDisconnect);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("session_delete", this.onDisconnect);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("display_uri", this.onDisplayUri);
    (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).removeListener("connect", this.onConnect);
};
$88539ea25e891070$var$_setRequestedChainsIds = new WeakSet();
$88539ea25e891070$var$setRequestedChainsIds_fn = function(chains) {
    this.storage?.setItem($88539ea25e891070$var$REQUESTED_CHAINS_KEY, chains);
};
$88539ea25e891070$var$_getRequestedChainsIds = new WeakSet();
$88539ea25e891070$var$getRequestedChainsIds_fn = function() {
    return this.storage?.getItem($88539ea25e891070$var$REQUESTED_CHAINS_KEY) ?? [];
};
$88539ea25e891070$var$_getNamespaceChainsIds = new WeakSet();
$88539ea25e891070$var$getNamespaceChainsIds_fn = function() {
    if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider)) return [];
    const namespaces = (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $0d634da287d4e964$export$2994550cda701c96)(namespaces);
    const chainIds = normalizedNamespaces[$88539ea25e891070$var$NAMESPACE]?.chains?.map((chain)=>parseInt(chain.split(":")[1] || ""));
    return chainIds ?? [];
};
$88539ea25e891070$var$_getNamespaceMethods = new WeakSet();
$88539ea25e891070$var$getNamespaceMethods_fn = function() {
    if (!(0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider)) return [];
    const namespaces = (0, $kD2va.__privateGet)(this, $88539ea25e891070$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $0d634da287d4e964$export$2994550cda701c96)(namespaces);
    const methods = normalizedNamespaces[$88539ea25e891070$var$NAMESPACE]?.methods;
    return methods ?? [];
};



// src/providers/jsonRpc.ts
function $2e198a9315405204$export$2dc41f6df3d9d4cf({ rpc: rpc }) {
    return function(chain) {
        const rpcConfig = rpc(chain);
        if (!rpcConfig || rpcConfig.http === "") return null;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            rpcConfig.http
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    rpcConfig.http
                ],
                webSocket: rpcConfig.webSocket ? [
                    rpcConfig.webSocket
                ] : void 0
            }
        };
    };
}


const $74c11619874f859b$var$A = "wallet_addEthereumChain";
class $74c11619874f859b$export$de370d1517aed7bb {
    constructor(t, e){
        this.wagmi = {}, this.chains = [], this.namespace = "eip155", this.disconnect = (0, $eUiaP.disconnect), this.getAccount = (0, $eUiaP.getAccount), this.watchAccount = (0, $eUiaP.watchAccount), this.fetchBalance = (0, $eUiaP.fetchBalance), this.getNetwork = (0, $eUiaP.getNetwork), this.watchNetwork = (0, $eUiaP.watchNetwork), this.switchNetwork = (0, $eUiaP.switchNetwork), this.fetchEnsName = (0, $eUiaP.fetchEnsName), this.fetchEnsAvatar = (0, $eUiaP.fetchEnsAvatar), this.wagmi = t, this.chains = e;
    }
    getWalletConnectConnector() {
        const t = this.wagmi.connectors.find((e)=>e.id === "walletConnect");
        if (!t) throw new Error("WalletConnectConnector is required");
        return t;
    }
    async connectWalletConnectProvider(t, e) {
        return await t.getProvider(), new Promise((n)=>{
            t.once("message", (o)=>{
                o.type === "display_uri" && (e(o.data), n());
            });
        });
    }
    getConnectorById(t) {
        const e = this.wagmi.connectors.find((n)=>n.id === t);
        if (!e) throw new Error(`Connector for id ${t} was not found`);
        return e;
    }
    getConnectors() {
        return this.wagmi.connectors.filter((t)=>!t.id.includes("walletConnect"));
    }
    async connectWalletConnect(t, e) {
        const n = this.getWalletConnectConnector(), o = {
            connector: n
        };
        return e && (o.chainId = e), Promise.all([
            (0, $eUiaP.connect)(o),
            this.connectWalletConnectProvider(n, t)
        ]);
    }
    async connectConnector(t, e) {
        const n = {
            connector: this.getConnectorById(t)
        };
        return e && (n.chainId = e), await (0, $eUiaP.connect)(n);
    }
    isInjectedProviderInstalled() {
        return typeof window.ethereum < "u";
    }
    safeCheckInjectedProvider(t) {
        var e;
        try {
            const n = String(t);
            return Boolean((e = window.ethereum) == null ? void 0 : e[n]);
        } catch (n) {
            return console.error(n), !1;
        }
    }
    async getConnectedChainIds() {
        var t, e, n;
        const o = (e = (t = (await this.getWalletConnectConnector().getProvider()).signer) == null ? void 0 : t.session) == null ? void 0 : e.namespaces, s = (n = o?.[this.namespace]) == null ? void 0 : n.methods;
        if (s != null && s.includes($74c11619874f859b$var$A)) return "ALL";
        if (o) {
            const i = [];
            return Object.keys(o).forEach((r)=>{
                r.includes(this.namespace) && i.push(...o[r].accounts);
            }), i?.map((r)=>r.split(":")[1]);
        }
        return "ALL";
    }
}
const $74c11619874f859b$var$P = "eip155", $74c11619874f859b$var$y = "https://rpc.walletconnect.com";
function $74c11619874f859b$export$c6fada22b311e8ce({ projectId: c }) {
    return (0, $2e198a9315405204$export$2dc41f6df3d9d4cf)({
        rpc: (t)=>{
            var e;
            return [
                1,
                3,
                4,
                5,
                10,
                42,
                56,
                69,
                97,
                100,
                137,
                280,
                324,
                420,
                42161,
                42220,
                43114,
                80001,
                421611,
                421613,
                1313161554,
                1313161555
            ].includes(t.id) ? {
                http: `${$74c11619874f859b$var$y}/v1/?chainId=${$74c11619874f859b$var$P}:${t.id}&projectId=${c}`
            } : {
                http: t.rpcUrls.default.http[0],
                webSocket: (e = t.rpcUrls.default.webSocket) == null ? void 0 : e[0]
            };
        }
    });
}
function $74c11619874f859b$export$1fa55742dee269b2({ chains: c, projectId: t }) {
    return [
        new (0, $88539ea25e891070$export$c456b2d327ac201f)({
            chains: c,
            options: {
                projectId: t,
                showQrModal: !1
            }
        }),
        new (0, $12u0G.InjectedConnector)({
            chains: c,
            options: {
                shimDisconnect: !0
            }
        })
    ];
}



var $dup7A = parcelRequire("dup7A");

var $cXShh = parcelRequire("cXShh");
var $d8cd0db3ca41ed09$var$M = Object.defineProperty, $d8cd0db3ca41ed09$var$b = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$S = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$I = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$s = (t, e, r)=>e in t ? $d8cd0db3ca41ed09$var$M(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $d8cd0db3ca41ed09$var$W = (t, e)=>{
    for(var r in e || (e = {}))$d8cd0db3ca41ed09$var$S.call(e, r) && $d8cd0db3ca41ed09$var$s(t, r, e[r]);
    if ($d8cd0db3ca41ed09$var$b) for (var r of $d8cd0db3ca41ed09$var$b(e))$d8cd0db3ca41ed09$var$I.call(e, r) && $d8cd0db3ca41ed09$var$s(t, r, e[r]);
    return t;
};
function $d8cd0db3ca41ed09$export$26f4bb56b75cc260(t) {
    const { size: e } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        style: {
            width: e,
            height: e
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("w3m-qrcode", $d8cd0db3ca41ed09$var$W({}, t)));
}
var $d8cd0db3ca41ed09$var$T = Object.defineProperty, $d8cd0db3ca41ed09$var$p = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$V = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$k = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$u = (t, e, r)=>e in t ? $d8cd0db3ca41ed09$var$T(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $d8cd0db3ca41ed09$var$x = (t, e)=>{
    for(var r in e || (e = {}))$d8cd0db3ca41ed09$var$V.call(e, r) && $d8cd0db3ca41ed09$var$u(t, r, e[r]);
    if ($d8cd0db3ca41ed09$var$p) for (var r of $d8cd0db3ca41ed09$var$p(e))$d8cd0db3ca41ed09$var$k.call(e, r) && $d8cd0db3ca41ed09$var$u(t, r, e[r]);
    return t;
};
function $d8cd0db3ca41ed09$export$ed89f3ab37730d1a(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("w3m-core-button", $d8cd0db3ca41ed09$var$x({}, t));
}
var $d8cd0db3ca41ed09$var$q = Object.defineProperty, $d8cd0db3ca41ed09$var$f = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$z = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$B = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$m = (t, e, r)=>e in t ? $d8cd0db3ca41ed09$var$q(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $d8cd0db3ca41ed09$var$D = (t, e)=>{
    for(var r in e || (e = {}))$d8cd0db3ca41ed09$var$z.call(e, r) && $d8cd0db3ca41ed09$var$m(t, r, e[r]);
    if ($d8cd0db3ca41ed09$var$f) for (var r of $d8cd0db3ca41ed09$var$f(e))$d8cd0db3ca41ed09$var$B.call(e, r) && $d8cd0db3ca41ed09$var$m(t, r, e[r]);
    return t;
};
function $d8cd0db3ca41ed09$var$L(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("w3m-modal", $d8cd0db3ca41ed09$var$D({}, t));
}
var $d8cd0db3ca41ed09$var$v = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$N = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$Q = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$U = (t, e)=>{
    var r = {};
    for(var o in t)$d8cd0db3ca41ed09$var$N.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);
    if (t != null && $d8cd0db3ca41ed09$var$v) for (var o of $d8cd0db3ca41ed09$var$v(t))e.indexOf(o) < 0 && $d8cd0db3ca41ed09$var$Q.call(t, o) && (r[o] = t[o]);
    return r;
};

function $d8cd0db3ca41ed09$var$A(t) {
    var e = t, { ethereumClient: r } = e, o = $d8cd0db3ca41ed09$var$U(e, [
        "ethereumClient"
    ]);
    const i = (0, $dup7A.useCallback)(async ()=>{
        (0, $cXShh.ThemeCtrl).setThemeConfig(o), r && (0, $cXShh.ClientCtrl).setEthereumClient(r), (0, $cXShh.ConfigCtrl).setConfig(o), await (parcelRequire("b9mfO")), (0, $cXShh.OptionsCtrl).setIsUiLoaded(!0);
    }, [
        r,
        o
    ]);
    return (0, $dup7A.useEffect)(()=>{
        i();
    }, [
        i
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($d8cd0db3ca41ed09$var$L, null);
}
const $d8cd0db3ca41ed09$export$c03599cd5308d12b = (0, $dup7A.memo)($d8cd0db3ca41ed09$var$A);
var $d8cd0db3ca41ed09$var$F = Object.defineProperty, $d8cd0db3ca41ed09$var$y = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$G = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$H = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$O = (t, e, r)=>e in t ? $d8cd0db3ca41ed09$var$F(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $d8cd0db3ca41ed09$var$J = (t, e)=>{
    for(var r in e || (e = {}))$d8cd0db3ca41ed09$var$G.call(e, r) && $d8cd0db3ca41ed09$var$O(t, r, e[r]);
    if ($d8cd0db3ca41ed09$var$y) for (var r of $d8cd0db3ca41ed09$var$y(e))$d8cd0db3ca41ed09$var$H.call(e, r) && $d8cd0db3ca41ed09$var$O(t, r, e[r]);
    return t;
};
function $d8cd0db3ca41ed09$export$f4f967f17655ea54(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("w3m-network-switch", $d8cd0db3ca41ed09$var$J({}, t));
}
var $d8cd0db3ca41ed09$var$K = Object.defineProperty, $d8cd0db3ca41ed09$var$h = Object.getOwnPropertySymbols, $d8cd0db3ca41ed09$var$R = Object.prototype.hasOwnProperty, $d8cd0db3ca41ed09$var$X = Object.prototype.propertyIsEnumerable, $d8cd0db3ca41ed09$var$w = (t, e, r)=>e in t ? $d8cd0db3ca41ed09$var$K(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $d8cd0db3ca41ed09$var$Y = (t, e)=>{
    for(var r in e || (e = {}))$d8cd0db3ca41ed09$var$R.call(e, r) && $d8cd0db3ca41ed09$var$w(t, r, e[r]);
    if ($d8cd0db3ca41ed09$var$h) for (var r of $d8cd0db3ca41ed09$var$h(e))$d8cd0db3ca41ed09$var$X.call(e, r) && $d8cd0db3ca41ed09$var$w(t, r, e[r]);
    return t;
};
function $d8cd0db3ca41ed09$export$69804ca079d47f29() {
    const [t, e] = (0, $dup7A.useState)((0, $cXShh.ModalCtrl).state);
    return (0, $dup7A.useEffect)(()=>{
        const r = (0, $cXShh.ModalCtrl).subscribe((o)=>e($d8cd0db3ca41ed09$var$Y({}, o)));
        return ()=>{
            r();
        };
    }, []), {
        isOpen: t.open,
        open: (0, $cXShh.ModalCtrl).open,
        close: (0, $cXShh.ModalCtrl).close,
        setDefaultChain: (0, $cXShh.OptionsCtrl).setSelectedChain
    };
}
function $d8cd0db3ca41ed09$export$cd17534826f46144(t) {
    (0, $dup7A.useEffect)(()=>{
        const e = (0, $cXShh.EventsCtrl).subscribe(t);
        return ()=>{
            e();
        };
    }, []);
}
function $d8cd0db3ca41ed09$export$7cb034a59823159f() {
    const [t, e] = (0, $dup7A.useState)({
        themeMode: (0, $cXShh.ThemeCtrl).state.themeMode,
        themeVariables: (0, $cXShh.ThemeCtrl).state.themeVariables
    });
    return (0, $dup7A.useEffect)(()=>{
        const r = (0, $cXShh.ThemeCtrl).subscribe((o)=>e({
                themeMode: o.themeMode,
                themeVariables: o.themeVariables
            }));
        return ()=>{
            r();
        };
    }, []), {
        theme: t,
        setTheme: (0, $cXShh.ThemeCtrl).setThemeConfig
    };
}



var $eUiaP = parcelRequire("eUiaP");

var $5Lqmg = parcelRequire("5Lqmg");


const $b60072fbac509c49$var$chains = [
    (0, $7af05c235ad5da5f$export$21799e7ae6cc115),
    (0, $5Lqmg.mainnet),
    (0, $65c2c1915539d26a$export$7a430fb03087826a)
];
const $b60072fbac509c49$var$projectId = "6efaa26765fa742153baf9281e218217" ?? "6efaa26765fa742153baf9281e218217";
const $b60072fbac509c49$export$1078a9b7607c322d = "PR2J5GgbdIpL2YfAwXKLpm_B9IHLgaRI" ?? "";
const { publicClient: $b60072fbac509c49$var$publicClient, webSocketPublicClient: $b60072fbac509c49$var$webSocketPublicClient } = (0, $eUiaP.configureChains)($b60072fbac509c49$var$chains, [
    (0, $e7a1f5d08bc6bdce$export$da85a315824a4e0e)({
        apiKey: $b60072fbac509c49$export$1078a9b7607c322d
    }),
    (0, $2e198a9315405204$export$2dc41f6df3d9d4cf)({
        rpc: ()=>({
                http: `https://rpc.chiadochain.net`,
                webSocket: `wss://rpc.chiadochain.net/wss`
            })
    })
]);
const $b60072fbac509c49$var$wagmiConfig = (0, $1d657eb5d64e17dc$export$45a69314cf48a3eb)({
    autoConnect: true,
    connectors: (0, $74c11619874f859b$export$1fa55742dee269b2)({
        projectId: $b60072fbac509c49$var$projectId,
        version: 2,
        chains: $b60072fbac509c49$var$chains
    }),
    publicClient: $b60072fbac509c49$var$publicClient,
    webSocketPublicClient: $b60072fbac509c49$var$webSocketPublicClient
});
const $b60072fbac509c49$var$ethereumClient = new (0, $74c11619874f859b$export$de370d1517aed7bb)($b60072fbac509c49$var$wagmiConfig, $b60072fbac509c49$var$chains);
const $b60072fbac509c49$var$Web3Provider = ({ children: children })=>{
    const [themeToggle] = (0, $56d2a25ae1caf5b4$export$c07acc0415d9f757)();
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d8cd0db3ca41ed09$export$c03599cd5308d12b), {
                themeMode: themeToggle,
                themeVariables: {
                    "--w3m-accent-color": theme.primaryPurple,
                    "--w3m-background-color": theme.primaryPurple,
                    "--w3m-overlay-background-color": "rgba(0, 0, 0, 0.6)",
                    "--w3m-overlay-backdrop-filter": "blur(3px)",
                    "--w3m-logo-image-url": "https://github.com/kleros/kleros-v2/blob/dev/docs/kleros-logo-white.png?raw=true",
                    "--w3m-color-bg-1": theme.lightBackground
                },
                projectId: $b60072fbac509c49$var$projectId,
                ethereumClient: $b60072fbac509c49$var$ethereumClient
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $1d657eb5d64e17dc$export$c3a561dea2adc16c), {
                config: $b60072fbac509c49$var$wagmiConfig,
                children: [
                    " ",
                    children,
                    " "
                ]
            })
        ]
    });
};
var $b60072fbac509c49$export$2e2bcd8739ae039 = $b60072fbac509c49$var$Web3Provider;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");
/*!
 * OverlayScrollbars
 * Version: 2.8.0
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ const $a15216a7e7549bc8$var$createCache = (t, n)=>{
    const { o: o, i: s, u: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const l = t;
        const i = n || (s ? !s(o, l) : o !== l);
        if (i || e) {
            c = l;
            r = o;
        }
        return [
            c,
            i,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $a15216a7e7549bc8$var$t = typeof window !== "undefined" && typeof document !== "undefined";
const $a15216a7e7549bc8$var$n = $a15216a7e7549bc8$var$t ? window : {};
const $a15216a7e7549bc8$var$o = Math.max;
const $a15216a7e7549bc8$var$s = Math.min;
const $a15216a7e7549bc8$var$e = Math.round;
const $a15216a7e7549bc8$var$c = Math.abs;
const $a15216a7e7549bc8$var$r = Math.sign;
const $a15216a7e7549bc8$var$l = $a15216a7e7549bc8$var$n.cancelAnimationFrame;
const $a15216a7e7549bc8$var$i = $a15216a7e7549bc8$var$n.requestAnimationFrame;
const $a15216a7e7549bc8$var$a = $a15216a7e7549bc8$var$n.setTimeout;
const $a15216a7e7549bc8$var$u = $a15216a7e7549bc8$var$n.clearTimeout;
const $a15216a7e7549bc8$var$getApi = (t)=>typeof $a15216a7e7549bc8$var$n[t] !== "undefined" ? $a15216a7e7549bc8$var$n[t] : void 0;
const $a15216a7e7549bc8$var$d = $a15216a7e7549bc8$var$getApi("MutationObserver");
const $a15216a7e7549bc8$var$_ = $a15216a7e7549bc8$var$getApi("IntersectionObserver");
const $a15216a7e7549bc8$var$f = $a15216a7e7549bc8$var$getApi("ResizeObserver");
const $a15216a7e7549bc8$var$p = $a15216a7e7549bc8$var$getApi("ScrollTimeline");
const $a15216a7e7549bc8$var$v = $a15216a7e7549bc8$var$t && Node.ELEMENT_NODE;
const { toString: $a15216a7e7549bc8$var$h, hasOwnProperty: $a15216a7e7549bc8$var$g } = Object.prototype;
const $a15216a7e7549bc8$var$b = /^\[object (.+)\]$/;
const $a15216a7e7549bc8$var$isUndefined = (t)=>t === void 0;
const $a15216a7e7549bc8$var$isNull = (t)=>t === null;
const $a15216a7e7549bc8$var$type = (t)=>$a15216a7e7549bc8$var$isUndefined(t) || $a15216a7e7549bc8$var$isNull(t) ? `${t}` : $a15216a7e7549bc8$var$h.call(t).replace($a15216a7e7549bc8$var$b, "$1").toLowerCase();
const $a15216a7e7549bc8$var$isNumber = (t)=>typeof t === "number";
const $a15216a7e7549bc8$var$isString = (t)=>typeof t === "string";
const $a15216a7e7549bc8$var$isBoolean = (t)=>typeof t === "boolean";
const $a15216a7e7549bc8$var$isFunction = (t)=>typeof t === "function";
const $a15216a7e7549bc8$var$isArray = (t)=>Array.isArray(t);
const $a15216a7e7549bc8$var$isObject = (t)=>typeof t === "object" && !$a15216a7e7549bc8$var$isArray(t) && !$a15216a7e7549bc8$var$isNull(t);
const $a15216a7e7549bc8$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $a15216a7e7549bc8$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $a15216a7e7549bc8$var$isArray(t) || !$a15216a7e7549bc8$var$isFunction(t) && o ? n > 0 && $a15216a7e7549bc8$var$isObject(t) ? n - 1 in t : true : false;
};
const $a15216a7e7549bc8$var$isPlainObject = (t)=>{
    if (!t || !$a15216a7e7549bc8$var$isObject(t) || $a15216a7e7549bc8$var$type(t) !== "object") return false;
    let n;
    const o = "constructor";
    const s = t[o];
    const e = s && s.prototype;
    const c = $a15216a7e7549bc8$var$g.call(t, o);
    const r = e && $a15216a7e7549bc8$var$g.call(e, "isPrototypeOf");
    if (s && !c && !r) return false;
    for(n in t);
    return $a15216a7e7549bc8$var$isUndefined(n) || $a15216a7e7549bc8$var$g.call(t, n);
};
const $a15216a7e7549bc8$var$isHTMLElement = (t)=>{
    const n = HTMLElement;
    return t ? n ? t instanceof n : t.nodeType === $a15216a7e7549bc8$var$v : false;
};
const $a15216a7e7549bc8$var$isElement = (t)=>{
    const n = Element;
    return t ? n ? t instanceof n : t.nodeType === $a15216a7e7549bc8$var$v : false;
};
const $a15216a7e7549bc8$var$animationCurrentTime = ()=>performance.now();
const $a15216a7e7549bc8$var$animateNumber = (t, n, s, e, c)=>{
    let r = 0;
    const a = $a15216a7e7549bc8$var$animationCurrentTime();
    const u = $a15216a7e7549bc8$var$o(0, s);
    const frame = (s)=>{
        const l = $a15216a7e7549bc8$var$animationCurrentTime();
        const d = l - a;
        const _ = d >= u;
        const f = s ? 1 : 1 - ($a15216a7e7549bc8$var$o(0, a + u - l) / u || 0);
        const p = (n - t) * ($a15216a7e7549bc8$var$isFunction(c) ? c(f, f * u, 0, 1, u) : f) + t;
        const v = _ || f === 1;
        e && e(p, f, v);
        r = v ? 0 : $a15216a7e7549bc8$var$i(()=>frame());
    };
    frame();
    return (t)=>{
        $a15216a7e7549bc8$var$l(r);
        t && frame(t);
    };
};
function $a15216a7e7549bc8$var$each(t, n) {
    if ($a15216a7e7549bc8$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (n(t[o], o, t) === false) break;
    }
    else if (t) $a15216a7e7549bc8$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
const $a15216a7e7549bc8$var$inArray = (t, n)=>t.indexOf(n) >= 0;
const $a15216a7e7549bc8$var$concat = (t, n)=>t.concat(n);
const $a15216a7e7549bc8$var$push = (t, n, o)=>{
    !o && !$a15216a7e7549bc8$var$isString(n) && $a15216a7e7549bc8$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $a15216a7e7549bc8$var$from = (t)=>Array.from(t || []);
const $a15216a7e7549bc8$var$createOrKeepArray = (t)=>$a15216a7e7549bc8$var$isArray(t) ? t : [
        t
    ];
const $a15216a7e7549bc8$var$isEmptyArray = (t)=>!!t && !t.length;
const $a15216a7e7549bc8$var$deduplicateArray = (t)=>$a15216a7e7549bc8$var$from(new Set(t));
const $a15216a7e7549bc8$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t && t.apply(void 0, n || []);
    $a15216a7e7549bc8$var$each(t, runFn);
    !o && (t.length = 0);
};
const $a15216a7e7549bc8$var$w = "paddingTop";
const $a15216a7e7549bc8$var$y = "paddingRight";
const $a15216a7e7549bc8$var$S = "paddingLeft";
const $a15216a7e7549bc8$var$m = "paddingBottom";
const $a15216a7e7549bc8$var$O = "marginLeft";
const $a15216a7e7549bc8$var$$ = "marginRight";
const $a15216a7e7549bc8$var$C = "marginBottom";
const $a15216a7e7549bc8$var$x = "overflowX";
const $a15216a7e7549bc8$var$H = "overflowY";
const $a15216a7e7549bc8$var$E = "width";
const $a15216a7e7549bc8$var$z = "height";
const $a15216a7e7549bc8$var$A = "visible";
const $a15216a7e7549bc8$var$I = "hidden";
const $a15216a7e7549bc8$var$T = "scroll";
const $a15216a7e7549bc8$var$capitalizeFirstLetter = (t)=>{
    const n = String(t || "");
    return n ? n[0].toUpperCase() + n.slice(1) : "";
};
const $a15216a7e7549bc8$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $a15216a7e7549bc8$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $a15216a7e7549bc8$var$equalWH = (t, n)=>$a15216a7e7549bc8$var$equal(t, n, [
        "w",
        "h"
    ]);
const $a15216a7e7549bc8$var$equalXY = (t, n)=>$a15216a7e7549bc8$var$equal(t, n, [
        "x",
        "y"
    ]);
const $a15216a7e7549bc8$var$equalTRBL = (t, n)=>$a15216a7e7549bc8$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $a15216a7e7549bc8$var$noop = ()=>{};
const $a15216a7e7549bc8$var$bind = (t, ...n)=>t.bind(0, ...n);
const $a15216a7e7549bc8$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $a15216a7e7549bc8$var$a : $a15216a7e7549bc8$var$i;
    const s = t ? $a15216a7e7549bc8$var$u : $a15216a7e7549bc8$var$l;
    return [
        (e)=>{
            s(n);
            n = o(e, $a15216a7e7549bc8$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $a15216a7e7549bc8$var$debounce = (t, n)=>{
    let o;
    let s;
    let e;
    let c = $a15216a7e7549bc8$var$noop;
    const { _: r, p: d, v: _ } = n || {};
    const f = function invokeFunctionToDebounce(n) {
        c();
        $a15216a7e7549bc8$var$u(o);
        o = s = void 0;
        c = $a15216a7e7549bc8$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>_ && s ? _(s, t) : t;
    const flush = ()=>{
        if (c !== $a15216a7e7549bc8$var$noop) f(mergeParms(e) || e);
    };
    const p = function debouncedFn() {
        const t = $a15216a7e7549bc8$var$from(arguments);
        const n = $a15216a7e7549bc8$var$isFunction(r) ? r() : r;
        const _ = $a15216a7e7549bc8$var$isNumber(n) && n >= 0;
        if (_) {
            const r = $a15216a7e7549bc8$var$isFunction(d) ? d() : d;
            const _ = $a15216a7e7549bc8$var$isNumber(r) && r >= 0;
            const p = n > 0 ? $a15216a7e7549bc8$var$a : $a15216a7e7549bc8$var$i;
            const v = n > 0 ? $a15216a7e7549bc8$var$u : $a15216a7e7549bc8$var$l;
            const h = mergeParms(t);
            const g = h || t;
            const b = f.bind(0, g);
            c();
            const w = p(b, n);
            c = ()=>v(w);
            if (_ && !o) o = $a15216a7e7549bc8$var$a(flush, r);
            s = e = g;
        } else f(t);
    };
    p.S = flush;
    return p;
};
const $a15216a7e7549bc8$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $a15216a7e7549bc8$var$keys = (t)=>t ? Object.keys(t) : [];
const $a15216a7e7549bc8$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const l = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if ((typeof t !== "object" || $a15216a7e7549bc8$var$isNull(t)) && !$a15216a7e7549bc8$var$isFunction(t)) t = {};
    $a15216a7e7549bc8$var$each(l, (n)=>{
        $a15216a7e7549bc8$var$each(n, (o, s)=>{
            const e = n[s];
            if (t === e) return true;
            const c = $a15216a7e7549bc8$var$isArray(e);
            if (e && $a15216a7e7549bc8$var$isPlainObject(e)) {
                const n = t[s];
                let o = n;
                if (c && !$a15216a7e7549bc8$var$isArray(n)) o = [];
                else if (!c && !$a15216a7e7549bc8$var$isPlainObject(n)) o = {};
                t[s] = $a15216a7e7549bc8$var$assignDeep(o, e);
            } else t[s] = c ? e.slice() : e;
        });
    });
    return t;
};
const $a15216a7e7549bc8$var$removeUndefinedProperties = (t, n)=>$a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$assignDeep({}, t), (t, o, s)=>{
        if (t === void 0) delete s[o];
        else if (n && t && $a15216a7e7549bc8$var$isPlainObject(t)) s[o] = $a15216a7e7549bc8$var$removeUndefinedProperties(t, n);
    });
const $a15216a7e7549bc8$var$isEmptyObject = (t)=>{
    for(const n in t)return false;
    return true;
};
const $a15216a7e7549bc8$var$capNumber = (t, n, e)=>$a15216a7e7549bc8$var$o(t, $a15216a7e7549bc8$var$s(n, e));
const $a15216a7e7549bc8$var$getDomTokensArray = (t)=>$a15216a7e7549bc8$var$from(new Set(($a15216a7e7549bc8$var$isArray(t) ? t : (t || "").split(" ")).filter((t)=>t)));
const $a15216a7e7549bc8$var$getAttr = (t, n)=>t && t.getAttribute(n);
const $a15216a7e7549bc8$var$hasAttr = (t, n)=>t && t.hasAttribute(n);
const $a15216a7e7549bc8$var$setAttrs = (t, n, o)=>{
    $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$getDomTokensArray(n), (n)=>{
        t && t.setAttribute(n, String(o || ""));
    });
};
const $a15216a7e7549bc8$var$removeAttrs = (t, n)=>{
    $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$getDomTokensArray(n), (n)=>t && t.removeAttribute(n));
};
const $a15216a7e7549bc8$var$domTokenListAttr = (t, n)=>{
    const o = $a15216a7e7549bc8$var$getDomTokensArray($a15216a7e7549bc8$var$getAttr(t, n));
    const s = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$setAttrs, t, n);
    const domTokenListOperation = (t, n)=>{
        const s = new Set(o);
        $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$getDomTokensArray(t), (t)=>{
            s[n](t);
        });
        return $a15216a7e7549bc8$var$from(s).join(" ");
    };
    return {
        m: (t)=>s(domTokenListOperation(t, "delete")),
        O: (t)=>s(domTokenListOperation(t, "add")),
        $: (t)=>{
            const n = $a15216a7e7549bc8$var$getDomTokensArray(t);
            return n.reduce((t, n)=>t && o.includes(n), n.length > 0);
        }
    };
};
const $a15216a7e7549bc8$var$removeAttrClass = (t, n, o)=>{
    $a15216a7e7549bc8$var$domTokenListAttr(t, n).m(o);
    return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$addAttrClass, t, n, o);
};
const $a15216a7e7549bc8$var$addAttrClass = (t, n, o)=>{
    $a15216a7e7549bc8$var$domTokenListAttr(t, n).O(o);
    return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$removeAttrClass, t, n, o);
};
const $a15216a7e7549bc8$var$addRemoveAttrClass = (t, n, o, s)=>(s ? $a15216a7e7549bc8$var$addAttrClass : $a15216a7e7549bc8$var$removeAttrClass)(t, n, o);
const $a15216a7e7549bc8$var$hasAttrClass = (t, n, o)=>$a15216a7e7549bc8$var$domTokenListAttr(t, n).$(o);
const $a15216a7e7549bc8$var$createDomTokenListClass = (t)=>$a15216a7e7549bc8$var$domTokenListAttr(t, "class");
const $a15216a7e7549bc8$var$removeClass = (t, n)=>{
    $a15216a7e7549bc8$var$createDomTokenListClass(t).m(n);
};
const $a15216a7e7549bc8$var$addClass = (t, n)=>{
    $a15216a7e7549bc8$var$createDomTokenListClass(t).O(n);
    return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$removeClass, t, n);
};
const $a15216a7e7549bc8$var$find = (t, n)=>{
    const o = [];
    const s = n ? $a15216a7e7549bc8$var$isElement(n) && n : document;
    return s ? $a15216a7e7549bc8$var$push(o, s.querySelectorAll(t)) : o;
};
const $a15216a7e7549bc8$var$findFirst = (t, n)=>{
    const o = n ? $a15216a7e7549bc8$var$isElement(n) && n : document;
    return o ? o.querySelector(t) : null;
};
const $a15216a7e7549bc8$var$is = (t, n)=>{
    if ($a15216a7e7549bc8$var$isElement(t)) return t.matches(n);
    return false;
};
const $a15216a7e7549bc8$var$isBodyElement = (t)=>$a15216a7e7549bc8$var$is(t, "body");
const $a15216a7e7549bc8$var$contents = (t)=>t ? $a15216a7e7549bc8$var$from(t.childNodes) : [];
const $a15216a7e7549bc8$var$parent = (t)=>t && t.parentElement;
const $a15216a7e7549bc8$var$closest = (t, n)=>$a15216a7e7549bc8$var$isElement(t) && t.closest(n);
const $a15216a7e7549bc8$var$getFocusedElement = (t)=>(t || document).activeElement;
const $a15216a7e7549bc8$var$liesBetween = (t, n, o)=>{
    const s = $a15216a7e7549bc8$var$closest(t, n);
    const e = t && $a15216a7e7549bc8$var$findFirst(o, s);
    const c = $a15216a7e7549bc8$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $a15216a7e7549bc8$var$closest($a15216a7e7549bc8$var$closest(t, o), n) !== s : false;
};
const $a15216a7e7549bc8$var$removeElements = (t)=>{
    if ($a15216a7e7549bc8$var$isArrayLike(t)) $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$from(t), (t)=>$a15216a7e7549bc8$var$removeElements(t));
    else if (t) {
        const n = $a15216a7e7549bc8$var$parent(t);
        n && n.removeChild(t);
    }
};
const $a15216a7e7549bc8$var$before = (t, n, o)=>{
    if (o && t) {
        let s = n;
        let e;
        if ($a15216a7e7549bc8$var$isArrayLike(o)) {
            e = document.createDocumentFragment();
            $a15216a7e7549bc8$var$each(o, (t)=>{
                if (t === s) s = t.previousSibling;
                e.appendChild(t);
            });
        } else e = o;
        if (n) {
            if (!s) s = t.firstChild;
            else if (s !== n) s = s.nextSibling;
        }
        t.insertBefore(e, s || null);
        return ()=>$a15216a7e7549bc8$var$removeElements(o);
    }
    return $a15216a7e7549bc8$var$noop;
};
const $a15216a7e7549bc8$var$appendChildren = (t, n)=>$a15216a7e7549bc8$var$before(t, null, n);
const $a15216a7e7549bc8$var$insertAfter = (t, n)=>$a15216a7e7549bc8$var$before($a15216a7e7549bc8$var$parent(t), t && t.nextSibling, n);
const $a15216a7e7549bc8$var$createDiv = (t)=>{
    const n = document.createElement("div");
    $a15216a7e7549bc8$var$setAttrs(n, "class", t);
    return n;
};
const $a15216a7e7549bc8$var$createDOM = (t)=>{
    const n = $a15216a7e7549bc8$var$createDiv();
    n.innerHTML = t.trim();
    return $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$contents(n), (t)=>$a15216a7e7549bc8$var$removeElements(t));
};
const $a15216a7e7549bc8$var$D = /^--/;
const $a15216a7e7549bc8$var$getCSSVal = (t, n)=>t.getPropertyValue(n) || t[n] || "";
const $a15216a7e7549bc8$var$validFiniteNumber = (t)=>{
    const n = t || 0;
    return isFinite(n) ? n : 0;
};
const $a15216a7e7549bc8$var$parseToZeroOrNumber = (t)=>$a15216a7e7549bc8$var$validFiniteNumber(parseFloat(t || ""));
const $a15216a7e7549bc8$var$ratioToCssPercent = (t)=>`${($a15216a7e7549bc8$var$validFiniteNumber(t) * 100).toFixed(3)}%`;
const $a15216a7e7549bc8$var$numberToCssPx = (t)=>`${$a15216a7e7549bc8$var$validFiniteNumber(t)}px`;
function $a15216a7e7549bc8$var$setStyles(t, n) {
    t && n && $a15216a7e7549bc8$var$each(n, (n, o)=>{
        try {
            const s = t.style;
            const e = $a15216a7e7549bc8$var$isNumber(n) ? $a15216a7e7549bc8$var$numberToCssPx(n) : (n || "") + "";
            if ($a15216a7e7549bc8$var$D.test(o)) s.setProperty(o, e);
            else s[o] = e;
        } catch (s) {}
    });
}
function $a15216a7e7549bc8$var$getStyles(t, o, s) {
    const e = $a15216a7e7549bc8$var$isString(o);
    let c = e ? "" : {};
    if (t) {
        const r = $a15216a7e7549bc8$var$n.getComputedStyle(t, s) || t.style;
        c = e ? $a15216a7e7549bc8$var$getCSSVal(r, o) : $a15216a7e7549bc8$var$from(o).reduce((t, n)=>{
            t[n] = $a15216a7e7549bc8$var$getCSSVal(r, n);
            return t;
        }, c);
    }
    return c;
}
const $a15216a7e7549bc8$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const l = `${s}bottom${e}`;
    const i = `${s}left${e}`;
    const a = $a15216a7e7549bc8$var$getStyles(t, [
        c,
        r,
        l,
        i
    ]);
    return {
        t: $a15216a7e7549bc8$var$parseToZeroOrNumber(a[c]),
        r: $a15216a7e7549bc8$var$parseToZeroOrNumber(a[r]),
        b: $a15216a7e7549bc8$var$parseToZeroOrNumber(a[l]),
        l: $a15216a7e7549bc8$var$parseToZeroOrNumber(a[i])
    };
};
const $a15216a7e7549bc8$var$getTrasformTranslateValue = (t, n)=>`translate${$a15216a7e7549bc8$var$isObject(t) ? `(${t.x},${t.y})` : `${n ? "X" : "Y"}(${t})`}`;
const $a15216a7e7549bc8$var$elementHasDimensions = (t)=>!!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
const $a15216a7e7549bc8$var$k = {
    w: 0,
    h: 0
};
const $a15216a7e7549bc8$var$getElmWidthHeightProperty = (t, n)=>n ? {
        w: n[`${t}Width`],
        h: n[`${t}Height`]
    } : $a15216a7e7549bc8$var$k;
const $a15216a7e7549bc8$var$getWindowSize = (t)=>$a15216a7e7549bc8$var$getElmWidthHeightProperty("inner", t || $a15216a7e7549bc8$var$n);
const $a15216a7e7549bc8$var$R = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getElmWidthHeightProperty, "offset");
const $a15216a7e7549bc8$var$M = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getElmWidthHeightProperty, "client");
const $a15216a7e7549bc8$var$V = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getElmWidthHeightProperty, "scroll");
const $a15216a7e7549bc8$var$getFractionalSize = (t)=>{
    const n = parseFloat($a15216a7e7549bc8$var$getStyles(t, $a15216a7e7549bc8$var$E)) || 0;
    const o = parseFloat($a15216a7e7549bc8$var$getStyles(t, $a15216a7e7549bc8$var$z)) || 0;
    return {
        w: n - $a15216a7e7549bc8$var$e(n),
        h: o - $a15216a7e7549bc8$var$e(o)
    };
};
const $a15216a7e7549bc8$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
const $a15216a7e7549bc8$var$hasDimensions = (t)=>!!t && $a15216a7e7549bc8$var$elementHasDimensions(t);
const $a15216a7e7549bc8$var$domRectHasDimensions = (t)=>!!(t && (t[$a15216a7e7549bc8$var$z] || t[$a15216a7e7549bc8$var$E]));
const $a15216a7e7549bc8$var$domRectAppeared = (t, n)=>{
    const o = $a15216a7e7549bc8$var$domRectHasDimensions(t);
    const s = $a15216a7e7549bc8$var$domRectHasDimensions(n);
    return !s && o;
};
const $a15216a7e7549bc8$var$removeEventListener = (t, n, o, s)=>{
    $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$getDomTokensArray(n), (n)=>{
        t && t.removeEventListener(n, o, s);
    });
};
const $a15216a7e7549bc8$var$addEventListener = (t, n, o, s)=>{
    var e;
    const c = (e = s && s.C) != null ? e : true;
    const r = s && s.H || false;
    const l = s && s.A || false;
    const i = {
        passive: c,
        capture: r
    };
    return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, $a15216a7e7549bc8$var$getDomTokensArray(n).map((n)=>{
        const s = l ? (e)=>{
            $a15216a7e7549bc8$var$removeEventListener(t, n, s, r);
            o && o(e);
        } : o;
        t && t.addEventListener(n, s, i);
        return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$removeEventListener, t, n, s, r);
    }));
};
const $a15216a7e7549bc8$var$stopPropagation = (t)=>t.stopPropagation();
const $a15216a7e7549bc8$var$preventDefault = (t)=>t.preventDefault();
const $a15216a7e7549bc8$var$stopAndPrevent = (t)=>$a15216a7e7549bc8$var$stopPropagation(t) || $a15216a7e7549bc8$var$preventDefault(t);
const $a15216a7e7549bc8$var$scrollElementTo = (t, n)=>{
    const { x: o, y: s } = $a15216a7e7549bc8$var$isNumber(n) ? {
        x: n,
        y: n
    } : n || {};
    $a15216a7e7549bc8$var$isNumber(o) && (t.scrollLeft = o);
    $a15216a7e7549bc8$var$isNumber(s) && (t.scrollTop = s);
};
const $a15216a7e7549bc8$var$getElementScroll = (t)=>({
        x: t.scrollLeft,
        y: t.scrollTop
    });
const $a15216a7e7549bc8$var$getZeroScrollCoordinates = ()=>({
        I: {
            x: 0,
            y: 0
        },
        T: {
            x: 0,
            y: 0
        }
    });
const $a15216a7e7549bc8$var$sanatizeScrollCoordinates = (t, n)=>{
    const { I: o, T: s } = t;
    const { w: e, h: l } = n;
    const sanitizeAxis = (t, n, o)=>{
        let s = $a15216a7e7549bc8$var$r(t) * o;
        let e = $a15216a7e7549bc8$var$r(n) * o;
        if (s === e) {
            const o = $a15216a7e7549bc8$var$c(t);
            const r = $a15216a7e7549bc8$var$c(n);
            e = o > r ? 0 : e;
            s = o < r ? 0 : s;
        }
        return [
            s + 0,
            e + 0
        ];
    };
    const [i, a] = sanitizeAxis(o.x, s.x, e);
    const [u, d] = sanitizeAxis(o.y, s.y, l);
    return {
        I: {
            x: i,
            y: u
        },
        T: {
            x: a,
            y: d
        }
    };
};
const $a15216a7e7549bc8$var$isDefaultDirectionScrollCoordinates = ({ I: t, T: n })=>{
    const getAxis = (t, n)=>t === 0 && t <= n;
    return {
        x: getAxis(t.x, n.x),
        y: getAxis(t.y, n.y)
    };
};
const $a15216a7e7549bc8$var$getScrollCoordinatesPercent = ({ I: t, T: n }, o)=>{
    const getAxis = (t, n, o)=>$a15216a7e7549bc8$var$capNumber(0, 1, (t - o) / (t - n) || 0);
    return {
        x: getAxis(t.x, n.x, o.x),
        y: getAxis(t.y, n.y, o.y)
    };
};
const $a15216a7e7549bc8$var$manageListener = (t, n)=>{
    $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$createOrKeepArray(n), t);
};
const $a15216a7e7549bc8$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $a15216a7e7549bc8$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($a15216a7e7549bc8$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $a15216a7e7549bc8$var$manageListener((t)=>{
                $a15216a7e7549bc8$var$isFunction(t) && s.add(t);
            }, o);
            return $a15216a7e7549bc8$var$bind(removeEvent, t, o);
        }
        if ($a15216a7e7549bc8$var$isBoolean(o) && o) removeEvent();
        const s = $a15216a7e7549bc8$var$keys(t);
        const e = [];
        $a15216a7e7549bc8$var$each(s, (n)=>{
            const o = t[n];
            o && $a15216a7e7549bc8$var$push(e, addEvent(n, o));
        });
        return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, e);
    };
    const triggerEvent = (t, o)=>{
        $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$from(n.get(t)), (t)=>{
            if (o && !$a15216a7e7549bc8$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $a15216a7e7549bc8$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($a15216a7e7549bc8$var$isFunction(n)) throw 0;
        return n;
    });
const $a15216a7e7549bc8$var$getPropByPath = (t, n)=>t ? `${n}`.split(".").reduce((t, n)=>t && $a15216a7e7549bc8$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $a15216a7e7549bc8$var$L = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        autoHideSuspend: false,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $a15216a7e7549bc8$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $a15216a7e7549bc8$var$concat($a15216a7e7549bc8$var$keys(n), $a15216a7e7549bc8$var$keys(t));
    $a15216a7e7549bc8$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($a15216a7e7549bc8$var$isObject(e) && $a15216a7e7549bc8$var$isObject(c)) {
            $a15216a7e7549bc8$var$assignDeep(o[s] = {}, $a15216a7e7549bc8$var$getOptionsDiff(e, c));
            if ($a15216a7e7549bc8$var$isEmptyObject(o[s])) delete o[s];
        } else if ($a15216a7e7549bc8$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($a15216a7e7549bc8$var$isArray(e) || $a15216a7e7549bc8$var$isArray(c)) try {
                if ($a15216a7e7549bc8$var$opsStringify(e) === $a15216a7e7549bc8$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $a15216a7e7549bc8$var$createOptionCheck = (t, n, o)=>(s)=>[
            $a15216a7e7549bc8$var$getPropByPath(t, s),
            o || $a15216a7e7549bc8$var$getPropByPath(n, s) !== void 0
        ];
const $a15216a7e7549bc8$var$P = `data-overlayscrollbars`;
const $a15216a7e7549bc8$var$U = "os-environment";
const $a15216a7e7549bc8$var$N = `${$a15216a7e7549bc8$var$U}-scrollbar-hidden`;
const $a15216a7e7549bc8$var$j = `${$a15216a7e7549bc8$var$P}-initialize`;
const $a15216a7e7549bc8$var$q = "noClipping";
const $a15216a7e7549bc8$var$F = `${$a15216a7e7549bc8$var$P}-body`;
const $a15216a7e7549bc8$var$B = $a15216a7e7549bc8$var$P;
const $a15216a7e7549bc8$var$X = "host";
const $a15216a7e7549bc8$var$Y = `${$a15216a7e7549bc8$var$P}-viewport`;
const $a15216a7e7549bc8$var$W = $a15216a7e7549bc8$var$x;
const $a15216a7e7549bc8$var$J = $a15216a7e7549bc8$var$H;
const $a15216a7e7549bc8$var$K = "arrange";
const $a15216a7e7549bc8$var$G = "measuring";
const $a15216a7e7549bc8$var$Q = "scrollbarHidden";
const $a15216a7e7549bc8$var$Z = "scrollbarPressed";
const $a15216a7e7549bc8$var$tt = "noContent";
const $a15216a7e7549bc8$var$nt = `${$a15216a7e7549bc8$var$P}-padding`;
const $a15216a7e7549bc8$var$ot = `${$a15216a7e7549bc8$var$P}-content`;
const $a15216a7e7549bc8$var$st = "os-size-observer";
const $a15216a7e7549bc8$var$et = `${$a15216a7e7549bc8$var$st}-appear`;
const $a15216a7e7549bc8$var$ct = `${$a15216a7e7549bc8$var$st}-listener`;
const $a15216a7e7549bc8$var$rt = `${$a15216a7e7549bc8$var$ct}-scroll`;
const $a15216a7e7549bc8$var$lt = `${$a15216a7e7549bc8$var$ct}-item`;
const $a15216a7e7549bc8$var$it = `${$a15216a7e7549bc8$var$lt}-final`;
const $a15216a7e7549bc8$var$at = "os-trinsic-observer";
const $a15216a7e7549bc8$var$ut = "os-theme-none";
const $a15216a7e7549bc8$var$dt = "os-scrollbar";
const $a15216a7e7549bc8$var$_t = `${$a15216a7e7549bc8$var$dt}-rtl`;
const $a15216a7e7549bc8$var$ft = `${$a15216a7e7549bc8$var$dt}-horizontal`;
const $a15216a7e7549bc8$var$pt = `${$a15216a7e7549bc8$var$dt}-vertical`;
const $a15216a7e7549bc8$var$vt = `${$a15216a7e7549bc8$var$dt}-track`;
const $a15216a7e7549bc8$var$ht = `${$a15216a7e7549bc8$var$dt}-handle`;
const $a15216a7e7549bc8$var$gt = `${$a15216a7e7549bc8$var$dt}-visible`;
const $a15216a7e7549bc8$var$bt = `${$a15216a7e7549bc8$var$dt}-cornerless`;
const $a15216a7e7549bc8$var$wt = `${$a15216a7e7549bc8$var$dt}-interaction`;
const $a15216a7e7549bc8$var$yt = `${$a15216a7e7549bc8$var$dt}-unusable`;
const $a15216a7e7549bc8$var$St = `${$a15216a7e7549bc8$var$dt}-auto-hide`;
const $a15216a7e7549bc8$var$mt = `${$a15216a7e7549bc8$var$St}-hidden`;
const $a15216a7e7549bc8$var$Ot = `${$a15216a7e7549bc8$var$dt}-wheel`;
const $a15216a7e7549bc8$var$$t = `${$a15216a7e7549bc8$var$vt}-interactive`;
const $a15216a7e7549bc8$var$Ct = `${$a15216a7e7549bc8$var$ht}-interactive`;
let $a15216a7e7549bc8$var$xt;
const $a15216a7e7549bc8$var$createEnvironment = ()=>{
    const getNativeScrollbarSize = (t, n, o)=>{
        $a15216a7e7549bc8$var$appendChildren(document.body, t);
        $a15216a7e7549bc8$var$appendChildren(document.body, t);
        const s = $a15216a7e7549bc8$var$M(t);
        const e = $a15216a7e7549bc8$var$R(t);
        const c = $a15216a7e7549bc8$var$getFractionalSize(n);
        o && $a15216a7e7549bc8$var$removeElements(t);
        return {
            x: e.h - s.h + c.h,
            y: e.w - s.w + c.w
        };
    };
    const getNativeScrollbarsHiding = (t)=>{
        let n = false;
        const o = $a15216a7e7549bc8$var$addClass(t, $a15216a7e7549bc8$var$N);
        try {
            n = $a15216a7e7549bc8$var$getStyles(t, "scrollbar-width") === "none" || $a15216a7e7549bc8$var$getStyles(t, "display", "::-webkit-scrollbar") === "none";
        } catch (s) {}
        o();
        return n;
    };
    const t = `.${$a15216a7e7549bc8$var$U}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${$a15216a7e7549bc8$var$U} div{width:200%;height:200%;margin:10px 0}.${$a15216a7e7549bc8$var$N}{scrollbar-width:none!important}.${$a15216a7e7549bc8$var$N}::-webkit-scrollbar,.${$a15216a7e7549bc8$var$N}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`;
    const o = $a15216a7e7549bc8$var$createDOM(`<div class="${$a15216a7e7549bc8$var$U}"><div></div><style>${t}</style></div>`);
    const s = o[0];
    const e = s.firstChild;
    const [c, , r] = $a15216a7e7549bc8$var$createEventListenerHub();
    const [l, i] = $a15216a7e7549bc8$var$createCache({
        o: getNativeScrollbarSize(s, e),
        i: $a15216a7e7549bc8$var$equalXY
    }, $a15216a7e7549bc8$var$bind(getNativeScrollbarSize, s, e, true));
    const [a] = i();
    const u = getNativeScrollbarsHiding(s);
    const d = {
        x: a.x === 0,
        y: a.y === 0
    };
    const _ = {
        elements: {
            host: null,
            padding: !u,
            viewport: (t)=>u && $a15216a7e7549bc8$var$isBodyElement(t) && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const f = $a15216a7e7549bc8$var$assignDeep({}, $a15216a7e7549bc8$var$L);
    const v = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$assignDeep, {}, f);
    const h = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$assignDeep, {}, _);
    const g = {
        D: a,
        k: d,
        R: u,
        M: !!$a15216a7e7549bc8$var$p,
        V: $a15216a7e7549bc8$var$bind(c, "r"),
        L: h,
        P: (t)=>$a15216a7e7549bc8$var$assignDeep(_, t) && h(),
        U: v,
        N: (t)=>$a15216a7e7549bc8$var$assignDeep(f, t) && v(),
        j: $a15216a7e7549bc8$var$assignDeep({}, _),
        q: $a15216a7e7549bc8$var$assignDeep({}, f)
    };
    $a15216a7e7549bc8$var$removeAttrs(s, "style");
    $a15216a7e7549bc8$var$removeElements(s);
    $a15216a7e7549bc8$var$addEventListener($a15216a7e7549bc8$var$n, "resize", ()=>{
        r("r", []);
    });
    if ($a15216a7e7549bc8$var$isFunction($a15216a7e7549bc8$var$n.matchMedia) && !u && (!d.x || !d.y)) {
        const addZoomListener = (t)=>{
            const o = $a15216a7e7549bc8$var$n.matchMedia(`(resolution: ${$a15216a7e7549bc8$var$n.devicePixelRatio}dppx)`);
            $a15216a7e7549bc8$var$addEventListener(o, "change", ()=>{
                t();
                addZoomListener(t);
            }, {
                A: true
            });
        };
        addZoomListener(()=>{
            const [t, n] = l();
            $a15216a7e7549bc8$var$assignDeep(g.D, t);
            r("r", [
                n
            ]);
        });
    }
    return g;
};
const $a15216a7e7549bc8$var$getEnvironment = ()=>{
    if (!$a15216a7e7549bc8$var$xt) $a15216a7e7549bc8$var$xt = $a15216a7e7549bc8$var$createEnvironment();
    return $a15216a7e7549bc8$var$xt;
};
const $a15216a7e7549bc8$var$resolveInitialization = (t, n)=>$a15216a7e7549bc8$var$isFunction(n) ? n.apply(0, t) : n;
const $a15216a7e7549bc8$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $a15216a7e7549bc8$var$isUndefined(s) ? o : s;
    const c = $a15216a7e7549bc8$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $a15216a7e7549bc8$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $a15216a7e7549bc8$var$isUndefined(s) ? o : s;
    const c = $a15216a7e7549bc8$var$resolveInitialization(t, e);
    return !!c && ($a15216a7e7549bc8$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $a15216a7e7549bc8$var$cancelInitialization = (t, n)=>{
    const { nativeScrollbarsOverlaid: o, body: s } = n || {};
    const { k: e, R: c, L: r } = $a15216a7e7549bc8$var$getEnvironment();
    const { nativeScrollbarsOverlaid: l, body: i } = r().cancel;
    const a = o != null ? o : l;
    const u = $a15216a7e7549bc8$var$isUndefined(s) ? i : s;
    const d = (e.x || e.y) && a;
    const _ = t && ($a15216a7e7549bc8$var$isNull(u) ? !c : u);
    return !!d || !!_;
};
const $a15216a7e7549bc8$var$Ht = new WeakMap;
const $a15216a7e7549bc8$var$addInstance = (t, n)=>{
    $a15216a7e7549bc8$var$Ht.set(t, n);
};
const $a15216a7e7549bc8$var$removeInstance = (t)=>{
    $a15216a7e7549bc8$var$Ht.delete(t);
};
const $a15216a7e7549bc8$var$getInstance = (t)=>$a15216a7e7549bc8$var$Ht.get(t);
const $a15216a7e7549bc8$var$createEventContentChange = (t, n, o)=>{
    let s = false;
    const e = o ? new WeakMap : false;
    const destroy = ()=>{
        s = true;
    };
    const updateElements = (c)=>{
        if (e && o) {
            const r = o.map((n)=>{
                const [o, s] = n || [];
                const e = s && o ? (c || $a15216a7e7549bc8$var$find)(o, t) : [];
                return [
                    e,
                    s
                ];
            });
            $a15216a7e7549bc8$var$each(r, (o)=>$a15216a7e7549bc8$var$each(o[0], (c)=>{
                    const r = o[1];
                    const l = e.get(c) || [];
                    const i = t.contains(c);
                    if (i && r) {
                        const t = $a15216a7e7549bc8$var$addEventListener(c, r, (o)=>{
                            if (s) {
                                t();
                                e.delete(c);
                            } else n(o);
                        });
                        e.set(c, $a15216a7e7549bc8$var$push(l, t));
                    } else {
                        $a15216a7e7549bc8$var$runEachAndClear(l);
                        e.delete(c);
                    }
                }));
        }
    };
    updateElements();
    return [
        destroy,
        updateElements
    ];
};
const $a15216a7e7549bc8$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { F: c, B: r, X: l, Y: i, W: a, J: u } = s || {};
    const _ = $a15216a7e7549bc8$var$debounce(()=>e && o(true), {
        _: 33,
        p: 99
    });
    const [f, p] = $a15216a7e7549bc8$var$createEventContentChange(t, _, l);
    const v = c || [];
    const h = r || [];
    const g = $a15216a7e7549bc8$var$concat(v, h);
    const observerCallback = (e, c)=>{
        if (!$a15216a7e7549bc8$var$isEmptyArray(c)) {
            const r = a || $a15216a7e7549bc8$var$noop;
            const l = u || $a15216a7e7549bc8$var$noop;
            const d = [];
            const _ = [];
            let f = false;
            let v = false;
            $a15216a7e7549bc8$var$each(c, (o)=>{
                const { attributeName: e, target: c, type: a, oldValue: u, addedNodes: p, removedNodes: g } = o;
                const b = a === "attributes";
                const w = a === "childList";
                const y = t === c;
                const S = b && e;
                const m = S && $a15216a7e7549bc8$var$getAttr(c, e || "") || null;
                const O = S && u !== m;
                const $ = $a15216a7e7549bc8$var$inArray(h, e) && O;
                if (n && (w || !y)) {
                    const n = b && O;
                    const a = n && i && $a15216a7e7549bc8$var$is(c, i);
                    const _ = a ? !r(c, e, u, m) : !b || n;
                    const f = _ && !l(o, !!a, t, s);
                    $a15216a7e7549bc8$var$each(p, (t)=>$a15216a7e7549bc8$var$push(d, t));
                    $a15216a7e7549bc8$var$each(g, (t)=>$a15216a7e7549bc8$var$push(d, t));
                    v = v || f;
                }
                if (!n && y && O && !r(c, e, u, m)) {
                    $a15216a7e7549bc8$var$push(_, e);
                    f = f || $;
                }
            });
            p((t)=>$a15216a7e7549bc8$var$deduplicateArray(d).reduce((n, o)=>{
                    $a15216a7e7549bc8$var$push(n, $a15216a7e7549bc8$var$find(t, o));
                    return $a15216a7e7549bc8$var$is(o, t) ? $a15216a7e7549bc8$var$push(n, o) : n;
                }, []));
            if (n) {
                !e && v && o(false);
                return [
                    false
                ];
            }
            if (!$a15216a7e7549bc8$var$isEmptyArray(_) || f) {
                const t = [
                    $a15216a7e7549bc8$var$deduplicateArray(_),
                    f
                ];
                !e && o.apply(0, t);
                return t;
            }
        }
    };
    const b = new $a15216a7e7549bc8$var$d($a15216a7e7549bc8$var$bind(observerCallback, false));
    return [
        ()=>{
            b.observe(t, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: g,
                subtree: n,
                childList: n,
                characterData: n
            });
            e = true;
            return ()=>{
                if (e) {
                    f();
                    b.disconnect();
                    e = false;
                }
            };
        },
        ()=>{
            if (e) {
                _.S();
                return observerCallback(true, b.takeRecords());
            }
        }
    ];
};
const $a15216a7e7549bc8$var$Et = {};
const $a15216a7e7549bc8$var$zt = {};
const $a15216a7e7549bc8$var$addPlugins = (t)=>{
    $a15216a7e7549bc8$var$each(t, (t)=>$a15216a7e7549bc8$var$each(t, (n, o)=>{
            $a15216a7e7549bc8$var$Et[o] = t[o];
        }));
};
const $a15216a7e7549bc8$var$registerPluginModuleInstances = (t, n, o)=>$a15216a7e7549bc8$var$keys(t).map((s)=>{
        const { static: e, instance: c } = t[s];
        const [r, l, i] = o || [];
        const a = o ? c : e;
        if (a) {
            const t = o ? a(r, l, n) : a(n);
            return (i || $a15216a7e7549bc8$var$zt)[s] = t;
        }
    });
const $a15216a7e7549bc8$var$getStaticPluginModuleInstance = (t)=>$a15216a7e7549bc8$var$zt[t];
const $a15216a7e7549bc8$var$At = "__osOptionsValidationPlugin";
const $a15216a7e7549bc8$var$It = "__osSizeObserverPlugin";
const $a15216a7e7549bc8$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$a15216a7e7549bc8$var$It]: {
            static: ()=>(t, n, o)=>{
                    const s = 3333333;
                    const e = "scroll";
                    const c = $a15216a7e7549bc8$var$createDOM(`<div class="${$a15216a7e7549bc8$var$lt}" dir="ltr"><div class="${$a15216a7e7549bc8$var$lt}"><div class="${$a15216a7e7549bc8$var$it}"></div></div><div class="${$a15216a7e7549bc8$var$lt}"><div class="${$a15216a7e7549bc8$var$it}" style="width: 200%; height: 200%"></div></div></div>`);
                    const r = c[0];
                    const a = r.lastChild;
                    const u = r.firstChild;
                    const d = u == null ? void 0 : u.firstChild;
                    let _ = $a15216a7e7549bc8$var$R(r);
                    let f = _;
                    let p = false;
                    let v;
                    const reset = ()=>{
                        $a15216a7e7549bc8$var$scrollElementTo(u, s);
                        $a15216a7e7549bc8$var$scrollElementTo(a, s);
                    };
                    const onResized = (t)=>{
                        v = 0;
                        if (p) {
                            _ = f;
                            n(t === true);
                        }
                    };
                    const onScroll = (t)=>{
                        f = $a15216a7e7549bc8$var$R(r);
                        p = !t || !$a15216a7e7549bc8$var$equalWH(f, _);
                        if (t) {
                            $a15216a7e7549bc8$var$stopPropagation(t);
                            if (p && !v) {
                                $a15216a7e7549bc8$var$l(v);
                                v = $a15216a7e7549bc8$var$i(onResized);
                            }
                        } else onResized(t === false);
                        reset();
                    };
                    const h = [
                        $a15216a7e7549bc8$var$appendChildren(t, c),
                        $a15216a7e7549bc8$var$addEventListener(u, e, onScroll),
                        $a15216a7e7549bc8$var$addEventListener(a, e, onScroll)
                    ];
                    $a15216a7e7549bc8$var$addClass(t, $a15216a7e7549bc8$var$rt);
                    $a15216a7e7549bc8$var$setStyles(d, {
                        [$a15216a7e7549bc8$var$E]: s,
                        [$a15216a7e7549bc8$var$z]: s
                    });
                    $a15216a7e7549bc8$var$i(reset);
                    return [
                        o ? $a15216a7e7549bc8$var$bind(onScroll, false) : reset,
                        h
                    ];
                }
        }
    }))();
const $a15216a7e7549bc8$var$getShowNativeOverlaidScrollbars = (t, n)=>{
    const { k: o } = n;
    const [s, e] = t("showNativeOverlaidScrollbars");
    return [
        s && o.x && o.y,
        e
    ];
};
const $a15216a7e7549bc8$var$overflowIsVisible = (t)=>t.indexOf($a15216a7e7549bc8$var$A) === 0;
const $a15216a7e7549bc8$var$createViewportOverflowState = (t, n)=>{
    const getAxisOverflowStyle = (t, n, o, s)=>{
        const e = t === $a15216a7e7549bc8$var$A ? $a15216a7e7549bc8$var$I : t.replace(`${$a15216a7e7549bc8$var$A}-`, "");
        const c = $a15216a7e7549bc8$var$overflowIsVisible(t);
        const r = $a15216a7e7549bc8$var$overflowIsVisible(o);
        if (!n && !s) return $a15216a7e7549bc8$var$I;
        if (c && r) return $a15216a7e7549bc8$var$A;
        if (c) {
            const t = n ? $a15216a7e7549bc8$var$A : $a15216a7e7549bc8$var$I;
            return n && s ? e : t;
        }
        const l = r && s ? $a15216a7e7549bc8$var$A : $a15216a7e7549bc8$var$I;
        return n ? e : l;
    };
    const o = {
        x: getAxisOverflowStyle(n.x, t.x, n.y, t.y),
        y: getAxisOverflowStyle(n.y, t.y, n.x, t.x)
    };
    return {
        K: o,
        G: {
            x: o.x === $a15216a7e7549bc8$var$T,
            y: o.y === $a15216a7e7549bc8$var$T
        }
    };
};
const $a15216a7e7549bc8$var$Dt = "__osScrollbarsHidingPlugin";
const $a15216a7e7549bc8$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$a15216a7e7549bc8$var$Dt]: {
            static: ()=>({
                    Z: (t, n, o, s, e)=>{
                        const { tt: c, nt: r } = t;
                        const { R: l, k: i, D: a } = s;
                        const u = !c && !l && (i.x || i.y);
                        const [d] = $a15216a7e7549bc8$var$getShowNativeOverlaidScrollbars(e, s);
                        const readViewportOverflowState = ()=>{
                            const getStatePerAxis = (t)=>{
                                const n = $a15216a7e7549bc8$var$getStyles(r, t);
                                const o = n === $a15216a7e7549bc8$var$T;
                                return [
                                    n,
                                    o
                                ];
                            };
                            const [t, n] = getStatePerAxis($a15216a7e7549bc8$var$x);
                            const [o, s] = getStatePerAxis($a15216a7e7549bc8$var$H);
                            return {
                                K: {
                                    x: t,
                                    y: o
                                },
                                G: {
                                    x: n,
                                    y: s
                                }
                            };
                        };
                        const _getViewportOverflowHideOffset = (t)=>{
                            const { G: n } = t;
                            const o = l || d ? 0 : 42;
                            const getHideOffsetPerAxis = (t, n, s)=>{
                                const e = t ? o : s;
                                const c = n && !l ? e : 0;
                                const r = t && !!o;
                                return [
                                    c,
                                    r
                                ];
                            };
                            const [s, e] = getHideOffsetPerAxis(i.x, n.x, a.x);
                            const [c, r] = getHideOffsetPerAxis(i.y, n.y, a.y);
                            return {
                                ot: {
                                    x: s,
                                    y: c
                                },
                                st: {
                                    x: e,
                                    y: r
                                }
                            };
                        };
                        const _hideNativeScrollbars = (t, { et: o }, s)=>{
                            if (!c) {
                                const e = $a15216a7e7549bc8$var$assignDeep({}, {
                                    [$a15216a7e7549bc8$var$$]: 0,
                                    [$a15216a7e7549bc8$var$C]: 0,
                                    [$a15216a7e7549bc8$var$O]: 0
                                });
                                const { ot: c, st: r } = _getViewportOverflowHideOffset(t);
                                const { x: l, y: i } = r;
                                const { x: a, y: u } = c;
                                const { ct: d } = n;
                                const _ = o ? $a15216a7e7549bc8$var$O : $a15216a7e7549bc8$var$$;
                                const f = o ? $a15216a7e7549bc8$var$S : $a15216a7e7549bc8$var$y;
                                const p = d[_];
                                const v = d[$a15216a7e7549bc8$var$C];
                                const h = d[f];
                                const g = d[$a15216a7e7549bc8$var$m];
                                e[$a15216a7e7549bc8$var$E] = `calc(100% + ${u + p * -1}px)`;
                                e[_] = -u + p;
                                e[$a15216a7e7549bc8$var$C] = -a + v;
                                if (s) {
                                    e[f] = h + (i ? u : 0);
                                    e[$a15216a7e7549bc8$var$m] = g + (l ? a : 0);
                                }
                                return e;
                            }
                        };
                        const _arrangeViewport = (t, s, e)=>{
                            if (u) {
                                const { ct: c } = n;
                                const { ot: l, st: i } = _getViewportOverflowHideOffset(t);
                                const { x: a, y: u } = i;
                                const { x: d, y: _ } = l;
                                const { et: f } = o;
                                const p = f ? $a15216a7e7549bc8$var$y : $a15216a7e7549bc8$var$S;
                                const v = c[p];
                                const h = c.paddingTop;
                                const g = s.w + e.w;
                                const b = s.h + e.h;
                                const w = {
                                    w: _ && u ? `${_ + g - v}px` : "",
                                    h: d && a ? `${d + b - h}px` : ""
                                };
                                $a15216a7e7549bc8$var$setStyles(r, {
                                    "--os-vaw": w.w,
                                    "--os-vah": w.h
                                });
                            }
                            return u;
                        };
                        const _undoViewportArrange = (t)=>{
                            if (u) {
                                const s = t || readViewportOverflowState();
                                const { ct: e } = n;
                                const { st: c } = _getViewportOverflowHideOffset(s);
                                const { x: l, y: i } = c;
                                const a = {};
                                const assignProps = (t)=>$a15216a7e7549bc8$var$each(t, (t)=>{
                                        a[t] = e[t];
                                    });
                                if (l) assignProps([
                                    $a15216a7e7549bc8$var$C,
                                    $a15216a7e7549bc8$var$w,
                                    $a15216a7e7549bc8$var$m
                                ]);
                                if (i) assignProps([
                                    $a15216a7e7549bc8$var$O,
                                    $a15216a7e7549bc8$var$$,
                                    $a15216a7e7549bc8$var$S,
                                    $a15216a7e7549bc8$var$y
                                ]);
                                const d = $a15216a7e7549bc8$var$getStyles(r, $a15216a7e7549bc8$var$keys(a));
                                const _ = $a15216a7e7549bc8$var$removeAttrClass(r, $a15216a7e7549bc8$var$Y, $a15216a7e7549bc8$var$K);
                                $a15216a7e7549bc8$var$setStyles(r, a);
                                return [
                                    ()=>{
                                        $a15216a7e7549bc8$var$setStyles(r, $a15216a7e7549bc8$var$assignDeep({}, d, _hideNativeScrollbars(s, o, u)));
                                        _();
                                    },
                                    s
                                ];
                            }
                            return [
                                $a15216a7e7549bc8$var$noop
                            ];
                        };
                        return {
                            rt: _getViewportOverflowHideOffset,
                            lt: _arrangeViewport,
                            it: _undoViewportArrange,
                            ut: _hideNativeScrollbars
                        };
                    }
                })
        }
    }))();
const $a15216a7e7549bc8$var$Rt = "__osClickScrollPlugin";
const $a15216a7e7549bc8$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$a15216a7e7549bc8$var$Rt]: {
            static: ()=>(t, n, o, s, e)=>{
                    let c = 0;
                    let r = $a15216a7e7549bc8$var$noop;
                    const animateClickScroll = (l)=>{
                        r = $a15216a7e7549bc8$var$animateNumber(l, l + s * Math.sign(o), 133, (o, l, i)=>{
                            t(o);
                            const u = n();
                            const d = u + s;
                            const _ = e >= u && e <= d;
                            if (i && !_) {
                                if (c) animateClickScroll(o);
                                else {
                                    const t = $a15216a7e7549bc8$var$a(()=>{
                                        animateClickScroll(o);
                                    }, 222);
                                    r = ()=>{
                                        clearTimeout(t);
                                    };
                                }
                                c++;
                            }
                        });
                    };
                    animateClickScroll(0);
                    return ()=>r();
                }
        }
    }))();
const $a15216a7e7549bc8$var$createSizeObserver = (t, n, o)=>{
    const { dt: s } = o || {};
    const e = $a15216a7e7549bc8$var$getStaticPluginModuleInstance($a15216a7e7549bc8$var$It);
    const [c] = $a15216a7e7549bc8$var$createCache({
        o: false,
        u: true
    });
    return ()=>{
        const o = [];
        const r = $a15216a7e7549bc8$var$createDOM(`<div class="${$a15216a7e7549bc8$var$st}"><div class="${$a15216a7e7549bc8$var$ct}"></div></div>`);
        const l = r[0];
        const i = l.firstChild;
        const onSizeChangedCallbackProxy = (t)=>{
            const o = t instanceof ResizeObserverEntry;
            let s = false;
            let e = false;
            if (o) {
                const [n, , o] = c(t.contentRect);
                const r = $a15216a7e7549bc8$var$domRectHasDimensions(n);
                e = $a15216a7e7549bc8$var$domRectAppeared(n, o);
                s = !e && !r;
            } else e = t === true;
            if (!s) n({
                _t: true,
                dt: e
            });
        };
        if ($a15216a7e7549bc8$var$f) {
            const t = new $a15216a7e7549bc8$var$f((t)=>onSizeChangedCallbackProxy(t.pop()));
            t.observe(i);
            $a15216a7e7549bc8$var$push(o, ()=>{
                t.disconnect();
            });
        } else if (e) {
            const [t, n] = e(i, onSizeChangedCallbackProxy, s);
            $a15216a7e7549bc8$var$push(o, $a15216a7e7549bc8$var$concat([
                $a15216a7e7549bc8$var$addClass(l, $a15216a7e7549bc8$var$et),
                $a15216a7e7549bc8$var$addEventListener(l, "animationstart", t)
            ], n));
        } else return $a15216a7e7549bc8$var$noop;
        return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, $a15216a7e7549bc8$var$push(o, $a15216a7e7549bc8$var$appendChildren(t, l)));
    };
};
const $a15216a7e7549bc8$var$createTrinsicObserver = (t, n)=>{
    let o;
    const isHeightIntrinsic = (t)=>t.h === 0 || t.isIntersecting || t.intersectionRatio > 0;
    const s = $a15216a7e7549bc8$var$createDiv($a15216a7e7549bc8$var$at);
    const [e] = $a15216a7e7549bc8$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = e(isHeightIntrinsic(t));
            const [, c] = s;
            return c && !o && n(s) && [
                s
            ];
        }
    };
    const intersectionObserverCallback = (t, n)=>triggerOnTrinsicChangedCallback(n.pop(), t);
    return [
        ()=>{
            const n = [];
            if ($a15216a7e7549bc8$var$_) {
                o = new $a15216a7e7549bc8$var$_($a15216a7e7549bc8$var$bind(intersectionObserverCallback, false), {
                    root: t
                });
                o.observe(s);
                $a15216a7e7549bc8$var$push(n, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $a15216a7e7549bc8$var$R(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                $a15216a7e7549bc8$var$push(n, $a15216a7e7549bc8$var$createSizeObserver(s, onSizeChanged)());
                onSizeChanged();
            }
            return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, $a15216a7e7549bc8$var$push(n, $a15216a7e7549bc8$var$appendChildren(t, s)));
        },
        ()=>o && intersectionObserverCallback(true, o.takeRecords())
    ];
};
const $a15216a7e7549bc8$var$createObserversSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let l;
    let i;
    let a;
    const { R: u } = $a15216a7e7549bc8$var$getEnvironment();
    const d = `[${$a15216a7e7549bc8$var$B}]`;
    const _ = `[${$a15216a7e7549bc8$var$Y}]`;
    const p = [
        "tabindex"
    ];
    const v = [
        "wrap",
        "cols",
        "rows"
    ];
    const h = [
        "id",
        "class",
        "style",
        "open"
    ];
    const { ft: g, vt: b, nt: w, ht: y, gt: S, bt: m, tt: O, wt: $, yt: C } = t;
    const getDirectionIsRTL = (t)=>$a15216a7e7549bc8$var$getStyles(t, "direction") === "rtl";
    const x = {
        St: false,
        et: getDirectionIsRTL(g)
    };
    const H = $a15216a7e7549bc8$var$getEnvironment();
    const E = $a15216a7e7549bc8$var$getStaticPluginModuleInstance($a15216a7e7549bc8$var$Dt);
    const [z] = $a15216a7e7549bc8$var$createCache({
        i: $a15216a7e7549bc8$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const s = E && E.Z(t, n, x, H, o).it;
        const e = !O && $($a15216a7e7549bc8$var$K);
        const c = e && $a15216a7e7549bc8$var$getElementScroll(y);
        const r = C($a15216a7e7549bc8$var$G, true);
        const l = e && s && s()[0];
        const i = $a15216a7e7549bc8$var$V(S);
        const a = $a15216a7e7549bc8$var$V(w);
        const u = $a15216a7e7549bc8$var$getFractionalSize(w);
        l && l();
        $a15216a7e7549bc8$var$scrollElementTo(y, c);
        r();
        return {
            w: a.w + i.w + u.w,
            h: a.h + i.h + u.h
        };
    });
    const A = m ? v : $a15216a7e7549bc8$var$concat(h, v);
    const I = $a15216a7e7549bc8$var$debounce(s, {
        _: ()=>e,
        p: ()=>c,
        v (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $a15216a7e7549bc8$var$concat($a15216a7e7549bc8$var$keys(o), $a15216a7e7549bc8$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const setDirection = (t)=>{
        const n = getDirectionIsRTL(g);
        $a15216a7e7549bc8$var$assignDeep(t, {
            Ot: a !== n
        });
        $a15216a7e7549bc8$var$assignDeep(x, {
            et: n
        });
        a = n;
    };
    const updateViewportAttrsFromHost = (t)=>{
        $a15216a7e7549bc8$var$each(t || p, (t)=>{
            if ($a15216a7e7549bc8$var$inArray(p, t)) {
                const n = $a15216a7e7549bc8$var$getAttr(b, t);
                if ($a15216a7e7549bc8$var$isString(n)) $a15216a7e7549bc8$var$setAttrs(w, t, n);
                else $a15216a7e7549bc8$var$removeAttrs(w, t);
            }
        });
    };
    const onTrinsicChanged = (t, n)=>{
        const [o, e] = t;
        const c = {
            $t: e
        };
        $a15216a7e7549bc8$var$assignDeep(x, {
            St: o
        });
        !n && s(c);
        return c;
    };
    const onSizeChanged = ({ _t: t, dt: n })=>{
        const o = t && !n;
        const e = !o && u ? I : s;
        const c = {
            _t: t || n,
            dt: n
        };
        setDirection(c);
        e(c);
    };
    const onContentMutation = (t, n)=>{
        const [, o] = z();
        const e = {
            Ct: o
        };
        setDirection(e);
        const c = t ? s : I;
        o && !n && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            xt: n
        };
        setDirection(s);
        if (n && !o) I(s);
        else if (!O) updateViewportAttrsFromHost(t);
        return s;
    };
    const { V: T } = H;
    const [D, k] = S ? $a15216a7e7549bc8$var$createTrinsicObserver(b, onTrinsicChanged) : [];
    const R = !O && $a15216a7e7549bc8$var$createSizeObserver(b, onSizeChanged, {
        dt: true
    });
    const [M, L] = $a15216a7e7549bc8$var$createDOMObserver(b, false, onHostMutation, {
        B: h,
        F: $a15216a7e7549bc8$var$concat(h, p)
    });
    const P = O && $a15216a7e7549bc8$var$f && new $a15216a7e7549bc8$var$f((t)=>{
        const n = t[t.length - 1].contentRect;
        onSizeChanged({
            _t: true,
            dt: $a15216a7e7549bc8$var$domRectAppeared(n, i)
        });
        i = n;
    });
    return [
        ()=>{
            updateViewportAttrsFromHost();
            P && P.observe(b);
            const t = R && R();
            const n = D && D();
            const o = M();
            const s = T((t)=>{
                const [, n] = z();
                I({
                    Ht: t,
                    Ct: n
                });
            });
            return ()=>{
                P && P.disconnect();
                t && t();
                n && n();
                l && l();
                o();
                s();
            };
        },
        ({ Et: t, zt: n, At: o })=>{
            const s = {};
            const [i] = t("update.ignoreMutation");
            const [a, u] = t("update.attributes");
            const [f, p] = t("update.elementEvents");
            const [v, h] = t("update.debounce");
            const g = p || u;
            const b = n || o;
            const ignoreMutationFromOptions = (t)=>$a15216a7e7549bc8$var$isFunction(i) && i(t);
            if (g) {
                r && r();
                l && l();
                const [t, n] = $a15216a7e7549bc8$var$createDOMObserver(S || w, true, onContentMutation, {
                    F: $a15216a7e7549bc8$var$concat(A, a || []),
                    X: f,
                    Y: d,
                    J: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !O ? $a15216a7e7549bc8$var$liesBetween(o, d, _) : false;
                        return e || !!$a15216a7e7549bc8$var$closest(o, `.${$a15216a7e7549bc8$var$dt}`) || !!ignoreMutationFromOptions(t);
                    }
                });
                l = t();
                r = n;
            }
            if (h) {
                I.S();
                if ($a15216a7e7549bc8$var$isArray(v)) {
                    const t = v[0];
                    const n = v[1];
                    e = $a15216a7e7549bc8$var$isNumber(t) && t;
                    c = $a15216a7e7549bc8$var$isNumber(n) && n;
                } else if ($a15216a7e7549bc8$var$isNumber(v)) {
                    e = v;
                    c = false;
                } else {
                    e = false;
                    c = false;
                }
            }
            if (b) {
                const t = L();
                const n = k && k();
                const o = r && r();
                t && $a15216a7e7549bc8$var$assignDeep(s, onHostMutation(t[0], t[1], b));
                n && $a15216a7e7549bc8$var$assignDeep(s, onTrinsicChanged(n[0], b));
                o && $a15216a7e7549bc8$var$assignDeep(s, onContentMutation(o[0], b));
            }
            setDirection(s);
            return s;
        },
        x
    ];
};
const $a15216a7e7549bc8$var$createScrollbarsSetupElements = (t, n, o, s)=>{
    const { L: e } = $a15216a7e7549bc8$var$getEnvironment();
    const { scrollbars: c } = e();
    const { slot: r } = c;
    const { ft: l, vt: i, nt: a, It: u, ht: d, Tt: _, tt: f } = n;
    const { scrollbars: v } = u ? {} : t;
    const { slot: h } = v || {};
    const g = new Map;
    const initScrollTimeline = (t)=>$a15216a7e7549bc8$var$p && new $a15216a7e7549bc8$var$p({
            source: d,
            axis: t
        });
    const b = {
        x: initScrollTimeline("x"),
        y: initScrollTimeline("y")
    };
    const w = $a15216a7e7549bc8$var$dynamicInitializationElement([
        l,
        i,
        a
    ], ()=>f && _ ? l : i, r, h);
    const getScrollbarHandleLengthRatio = (t, n)=>{
        if (n) {
            const o = t ? $a15216a7e7549bc8$var$E : $a15216a7e7549bc8$var$z;
            const { Dt: s, kt: e } = n;
            const c = $a15216a7e7549bc8$var$getBoundingClientRect(e)[o];
            const r = $a15216a7e7549bc8$var$getBoundingClientRect(s)[o];
            return $a15216a7e7549bc8$var$capNumber(0, 1, c / r || 0);
        }
        const s = t ? "x" : "y";
        const { Rt: e, Mt: c } = o;
        const r = c[s];
        const l = e[s];
        return $a15216a7e7549bc8$var$capNumber(0, 1, r / (r + l) || 0);
    };
    const getScrollbarHandleOffsetRatio = (t, n, o)=>{
        const s = getScrollbarHandleLengthRatio(o, t);
        return 1 / s * (1 - s) * n;
    };
    const addDirectionRTLKeyframes = (t)=>$a15216a7e7549bc8$var$assignDeep(t, {
            clear: [
                "left"
            ]
        });
    const cancelElementAnimations = (t)=>{
        g.forEach((n, o)=>{
            const s = t ? $a15216a7e7549bc8$var$inArray($a15216a7e7549bc8$var$createOrKeepArray(t), o) : true;
            if (s) {
                $a15216a7e7549bc8$var$each(n || [], (t)=>{
                    t && t.cancel();
                });
                g.delete(o);
            }
        });
    };
    const setElementAnimation = (t, n, o, s)=>{
        const e = g.get(t) || [];
        const c = e.find((t)=>t && t.timeline === n);
        if (c) c.effect = new KeyframeEffect(t, o, {
            composite: s
        });
        else g.set(t, $a15216a7e7549bc8$var$concat(e, [
            t.animate(o, {
                timeline: n,
                composite: s
            })
        ]));
    };
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $a15216a7e7549bc8$var$addClass : $a15216a7e7549bc8$var$removeClass;
        $a15216a7e7549bc8$var$each(t, (t)=>{
            s(t.Vt, n);
        });
    };
    const scrollbarStyle = (t, n)=>{
        $a15216a7e7549bc8$var$each(t, (t)=>{
            const [o, s] = n(t);
            $a15216a7e7549bc8$var$setStyles(o, s);
        });
    };
    const scrollbarStructureRefreshHandleLength = (t, n)=>{
        scrollbarStyle(t, (t)=>{
            const { kt: o } = t;
            return [
                o,
                {
                    [n ? $a15216a7e7549bc8$var$E : $a15216a7e7549bc8$var$z]: $a15216a7e7549bc8$var$ratioToCssPercent(getScrollbarHandleLengthRatio(n))
                }
            ];
        });
    };
    const scrollbarStructureRefreshHandleOffset = (t, n)=>{
        const { Lt: s } = o;
        const e = n ? "x" : "y";
        const c = b[e];
        const r = $a15216a7e7549bc8$var$isDefaultDirectionScrollCoordinates(s)[e];
        const getAxisTransformValue = (t, o)=>$a15216a7e7549bc8$var$getTrasformTranslateValue($a15216a7e7549bc8$var$ratioToCssPercent(getScrollbarHandleOffsetRatio(t, r ? o : 1 - o, n)), n);
        if (c) $a15216a7e7549bc8$var$each(t, (t)=>{
            const { kt: n } = t;
            setElementAnimation(n, c, addDirectionRTLKeyframes({
                transform: [
                    0,
                    1
                ].map((n)=>getAxisTransformValue(t, n))
            }));
        });
        else scrollbarStyle(t, (t)=>[
                t.kt,
                {
                    transform: getAxisTransformValue(t, $a15216a7e7549bc8$var$getScrollCoordinatesPercent(s, $a15216a7e7549bc8$var$getElementScroll(d))[e])
                }
            ]);
    };
    const doRefreshScrollbarOffset = (t)=>f && !_ && $a15216a7e7549bc8$var$parent(t) === a;
    const y = [];
    const S = [];
    const m = [];
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $a15216a7e7549bc8$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(S, t, n);
        c && scrollbarStructureAddRemoveClass(m, t, n);
    };
    const refreshScrollbarsHandleLength = ()=>{
        scrollbarStructureRefreshHandleLength(S, true);
        scrollbarStructureRefreshHandleLength(m);
    };
    const refreshScrollbarsHandleOffset = ()=>{
        scrollbarStructureRefreshHandleOffset(S, true);
        scrollbarStructureRefreshHandleOffset(m);
    };
    const refreshScrollbarsScrollbarOffset = ()=>{
        if (f) {
            const { Rt: t, Lt: n } = o;
            const s = $a15216a7e7549bc8$var$isDefaultDirectionScrollCoordinates(n);
            const e = .5;
            if (b.x && b.y) $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$concat(m, S), ({ Vt: n })=>{
                if (doRefreshScrollbarOffset(n)) {
                    const setScrollbarElementAnimation = (o)=>setElementAnimation(n, b[o], addDirectionRTLKeyframes({
                            transform: [
                                0,
                                s[o] ? 1 : -1
                            ].map((n)=>$a15216a7e7549bc8$var$getTrasformTranslateValue($a15216a7e7549bc8$var$numberToCssPx(n * (t[o] - e)), o === "x"))
                        }), "add");
                    setScrollbarElementAnimation("x");
                    setScrollbarElementAnimation("y");
                } else cancelElementAnimations(n);
            });
            else {
                const o = $a15216a7e7549bc8$var$getScrollCoordinatesPercent(n, $a15216a7e7549bc8$var$getElementScroll(d));
                const styleScrollbarPosition = (n)=>{
                    const { Vt: e } = n;
                    const c = doRefreshScrollbarOffset(e) && e;
                    const getTranslateValue = (t, n, o)=>{
                        const s = n * t;
                        return $a15216a7e7549bc8$var$numberToCssPx(o ? s : -s);
                    };
                    return [
                        c,
                        c && {
                            transform: $a15216a7e7549bc8$var$getTrasformTranslateValue({
                                x: getTranslateValue(o.x, t.x, s.x),
                                y: getTranslateValue(o.y, t.y, s.y)
                            })
                        }
                    ];
                };
                scrollbarStyle(S, styleScrollbarPosition);
                scrollbarStyle(m, styleScrollbarPosition);
            }
        }
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? $a15216a7e7549bc8$var$ft : $a15216a7e7549bc8$var$pt;
        const o = $a15216a7e7549bc8$var$createDiv(`${$a15216a7e7549bc8$var$dt} ${n}`);
        const e = $a15216a7e7549bc8$var$createDiv($a15216a7e7549bc8$var$vt);
        const c = $a15216a7e7549bc8$var$createDiv($a15216a7e7549bc8$var$ht);
        const r = {
            Vt: o,
            Dt: e,
            kt: c
        };
        $a15216a7e7549bc8$var$push(t ? S : m, r);
        $a15216a7e7549bc8$var$push(y, [
            $a15216a7e7549bc8$var$appendChildren(o, e),
            $a15216a7e7549bc8$var$appendChildren(e, c),
            $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$removeElements, o),
            cancelElementAnimations,
            s(r, scrollbarsAddRemoveClass, scrollbarStructureRefreshHandleOffset, t)
        ]);
        return r;
    };
    const O = $a15216a7e7549bc8$var$bind(generateScrollbarDOM, true);
    const $ = $a15216a7e7549bc8$var$bind(generateScrollbarDOM, false);
    const appendElements = ()=>{
        $a15216a7e7549bc8$var$appendChildren(w, S[0].Vt);
        $a15216a7e7549bc8$var$appendChildren(w, m[0].Vt);
        return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, y);
    };
    O();
    $();
    return [
        {
            Pt: refreshScrollbarsHandleLength,
            Ut: refreshScrollbarsHandleOffset,
            Nt: refreshScrollbarsScrollbarOffset,
            jt: scrollbarsAddRemoveClass,
            qt: {
                M: b.x,
                Ft: S,
                Bt: O,
                Xt: $a15216a7e7549bc8$var$bind(scrollbarStyle, S)
            },
            Yt: {
                M: b.y,
                Ft: m,
                Bt: $,
                Xt: $a15216a7e7549bc8$var$bind(scrollbarStyle, m)
            }
        },
        appendElements
    ];
};
const $a15216a7e7549bc8$var$createScrollbarsSetupEvents = (t, n, o, s)=>(r, l, i, u)=>{
        const { vt: d, nt: _, tt: f, ht: p, Wt: v, yt: h } = n;
        const { Vt: g, Dt: b, kt: w } = r;
        const [y, S] = $a15216a7e7549bc8$var$selfClearTimeout(333);
        const [m, O] = $a15216a7e7549bc8$var$selfClearTimeout(444);
        const [$, C] = $a15216a7e7549bc8$var$selfClearTimeout();
        const x = $a15216a7e7549bc8$var$bind(i, [
            r
        ], u);
        const scrollOffsetElementScrollBy = (t)=>{
            $a15216a7e7549bc8$var$isFunction(p.scrollBy) && p.scrollBy({
                behavior: "smooth",
                left: t.x,
                top: t.y
            });
        };
        const H = u ? $a15216a7e7549bc8$var$E : $a15216a7e7549bc8$var$z;
        const createInteractiveScrollEvents = ()=>{
            const n = "pointerup pointercancel lostpointercapture";
            const s = `client${u ? "X" : "Y"}`;
            const r = u ? "left" : "top";
            const l = u ? "w" : "h";
            const i = u ? "x" : "y";
            const createRelativeHandleMove = (t, n)=>(s)=>{
                    const { Rt: e } = o;
                    const c = $a15216a7e7549bc8$var$R(b)[l] - $a15216a7e7549bc8$var$R(w)[l];
                    const r = n * s / c;
                    const a = r * e[i];
                    $a15216a7e7549bc8$var$scrollElementTo(p, {
                        [i]: t + a
                    });
                };
            return $a15216a7e7549bc8$var$addEventListener(b, "pointerdown", (o)=>{
                const a = $a15216a7e7549bc8$var$closest(o.target, `.${$a15216a7e7549bc8$var$ht}`) === w;
                const u = a ? w : b;
                const d = t.scrollbars;
                const { button: _, isPrimary: f, pointerType: g } = o;
                const { pointers: y } = d;
                const S = _ === 0 && f && d[a ? "dragScroll" : "clickScroll"] && (y || []).includes(g);
                if (S) {
                    O();
                    const t = !a && o.shiftKey;
                    const d = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getBoundingClientRect, w);
                    const _ = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getBoundingClientRect, b);
                    const getHandleOffset = (t, n)=>(t || d())[r] - (n || _())[r];
                    const f = $a15216a7e7549bc8$var$e($a15216a7e7549bc8$var$getBoundingClientRect(p)[H]) / $a15216a7e7549bc8$var$R(p)[l] || 1;
                    const g = createRelativeHandleMove($a15216a7e7549bc8$var$getElementScroll(p)[i], 1 / f);
                    const y = o[s];
                    const S = d();
                    const $ = _();
                    const C = S[H];
                    const x = getHandleOffset(S, $) + C / 2;
                    const E = y - $[r];
                    const z = a ? 0 : E - x;
                    const releasePointerCapture = (t)=>{
                        $a15216a7e7549bc8$var$runEachAndClear(I);
                        u.releasePointerCapture(t.pointerId);
                    };
                    const addScrollbarPressedClass = ()=>h($a15216a7e7549bc8$var$Z, true);
                    const A = addScrollbarPressedClass();
                    const I = [
                        ()=>{
                            const t = $a15216a7e7549bc8$var$getElementScroll(p);
                            A();
                            const n = $a15216a7e7549bc8$var$getElementScroll(p);
                            const o = {
                                x: n.x - t.x,
                                y: n.y - t.y
                            };
                            if ($a15216a7e7549bc8$var$c(o.x) > 3 || $a15216a7e7549bc8$var$c(o.y) > 3) {
                                addScrollbarPressedClass();
                                $a15216a7e7549bc8$var$scrollElementTo(p, t);
                                scrollOffsetElementScrollBy(o);
                                m(A);
                            }
                        },
                        $a15216a7e7549bc8$var$addEventListener(v, n, releasePointerCapture),
                        $a15216a7e7549bc8$var$addEventListener(v, "selectstart", (t)=>$a15216a7e7549bc8$var$preventDefault(t), {
                            C: false
                        }),
                        $a15216a7e7549bc8$var$addEventListener(b, n, releasePointerCapture),
                        $a15216a7e7549bc8$var$addEventListener(b, "pointermove", (n)=>{
                            const o = n[s] - y;
                            if (a || t) g(z + o);
                        })
                    ];
                    u.setPointerCapture(o.pointerId);
                    if (t) g(z);
                    else if (!a) {
                        const t = $a15216a7e7549bc8$var$getStaticPluginModuleInstance($a15216a7e7549bc8$var$Rt);
                        t && $a15216a7e7549bc8$var$push(I, t(g, getHandleOffset, z, C, E));
                    }
                }
            });
        };
        let A = true;
        const isAffectingTransition = (t)=>t.propertyName.indexOf(H) > -1;
        return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, [
            $a15216a7e7549bc8$var$addEventListener(w, "pointermove pointerleave", s),
            $a15216a7e7549bc8$var$addEventListener(g, "pointerenter", ()=>{
                l($a15216a7e7549bc8$var$wt, true);
            }),
            $a15216a7e7549bc8$var$addEventListener(g, "pointerleave pointercancel", ()=>{
                l($a15216a7e7549bc8$var$wt, false);
            }),
            !f && $a15216a7e7549bc8$var$addEventListener(g, "mousedown", ()=>{
                const t = $a15216a7e7549bc8$var$getFocusedElement();
                if ($a15216a7e7549bc8$var$hasAttr(t, $a15216a7e7549bc8$var$Y) || $a15216a7e7549bc8$var$hasAttr(t, $a15216a7e7549bc8$var$B) || t === document.body) $a15216a7e7549bc8$var$a(()=>{
                    _.focus({
                        preventScroll: true
                    });
                }, 25);
            }),
            $a15216a7e7549bc8$var$addEventListener(g, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: s } = t;
                if (A && s === 0 && $a15216a7e7549bc8$var$parent(g) === d) scrollOffsetElementScrollBy({
                    x: n,
                    y: o
                });
                A = false;
                l($a15216a7e7549bc8$var$Ot, true);
                y(()=>{
                    A = true;
                    l($a15216a7e7549bc8$var$Ot);
                });
                $a15216a7e7549bc8$var$preventDefault(t);
            }, {
                C: false,
                H: true
            }),
            $a15216a7e7549bc8$var$addEventListener(w, "transitionstart", (t)=>{
                if (isAffectingTransition(t)) {
                    const animateHandleOffset = ()=>{
                        x();
                        $(animateHandleOffset);
                    };
                    animateHandleOffset();
                }
            }),
            $a15216a7e7549bc8$var$addEventListener(w, "transitionend transitioncancel", (t)=>{
                if (isAffectingTransition(t)) {
                    C();
                    x();
                }
            }),
            $a15216a7e7549bc8$var$addEventListener(g, "pointerdown", $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$addEventListener, v, "click", $a15216a7e7549bc8$var$stopAndPrevent, {
                A: true,
                H: true,
                C: false
            }), {
                H: true
            }),
            createInteractiveScrollEvents(),
            S,
            O,
            C
        ]);
    };
const $a15216a7e7549bc8$var$createScrollbarsSetup = (t, n, o, s, e, c)=>{
    let r;
    let l;
    let i;
    let a;
    let u;
    let d = $a15216a7e7549bc8$var$noop;
    let _ = 0;
    const isHoverablePointerType = (t)=>t.pointerType === "mouse";
    const [f, p] = $a15216a7e7549bc8$var$selfClearTimeout();
    const [v, h] = $a15216a7e7549bc8$var$selfClearTimeout(100);
    const [g, b] = $a15216a7e7549bc8$var$selfClearTimeout(100);
    const [w, y] = $a15216a7e7549bc8$var$selfClearTimeout(()=>_);
    const [S, m] = $a15216a7e7549bc8$var$createScrollbarsSetupElements(t, e, s, $a15216a7e7549bc8$var$createScrollbarsSetupEvents(n, e, s, (t)=>isHoverablePointerType(t) && manageScrollbarsAutoHideInstantInteraction()));
    const { vt: O, Jt: $, Tt: C } = e;
    const { jt: x, Pt: H, Ut: E, Nt: z } = S;
    const manageScrollbarsAutoHide = (t, n)=>{
        y();
        if (t) x($a15216a7e7549bc8$var$mt);
        else {
            const t = $a15216a7e7549bc8$var$bind(x, $a15216a7e7549bc8$var$mt, true);
            if (_ > 0 && !n) w(t);
            else t();
        }
    };
    const manageScrollbarsAutoHideInstantInteraction = ()=>{
        if (i ? !r : !a) {
            manageScrollbarsAutoHide(true);
            v(()=>{
                manageScrollbarsAutoHide(false);
            });
        }
    };
    const manageAutoHideSuspension = (t)=>{
        x($a15216a7e7549bc8$var$St, t, true);
        x($a15216a7e7549bc8$var$St, t, false);
    };
    const onHostMouseEnter = (t)=>{
        if (isHoverablePointerType(t)) {
            r = i;
            i && manageScrollbarsAutoHide(true);
        }
    };
    const I = [
        y,
        h,
        b,
        p,
        ()=>d(),
        $a15216a7e7549bc8$var$addEventListener(O, "pointerover", onHostMouseEnter, {
            A: true
        }),
        $a15216a7e7549bc8$var$addEventListener(O, "pointerenter", onHostMouseEnter),
        $a15216a7e7549bc8$var$addEventListener(O, "pointerleave", (t)=>{
            if (isHoverablePointerType(t)) {
                r = false;
                i && manageScrollbarsAutoHide(false);
            }
        }),
        $a15216a7e7549bc8$var$addEventListener(O, "pointermove", (t)=>{
            isHoverablePointerType(t) && l && manageScrollbarsAutoHideInstantInteraction();
        }),
        $a15216a7e7549bc8$var$addEventListener($, "scroll", (t)=>{
            f(()=>{
                E();
                manageScrollbarsAutoHideInstantInteraction();
            });
            c(t);
            z();
        })
    ];
    return [
        ()=>$a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, $a15216a7e7549bc8$var$push(I, m())),
        ({ Et: t, At: n, Kt: e, Gt: c })=>{
            const { Qt: r, Zt: f, tn: p, nn: v } = c || {};
            const { Ot: h, dt: b } = e || {};
            const { et: w } = o;
            const { k: y } = $a15216a7e7549bc8$var$getEnvironment();
            const { K: S, sn: m } = s;
            const [O, I] = t("showNativeOverlaidScrollbars");
            const [D, k] = t("scrollbars.theme");
            const [R, M] = t("scrollbars.visibility");
            const [V, L] = t("scrollbars.autoHide");
            const [P, U] = t("scrollbars.autoHideSuspend");
            const [N] = t("scrollbars.autoHideDelay");
            const [j, q] = t("scrollbars.dragScroll");
            const [F, B] = t("scrollbars.clickScroll");
            const [X, Y] = t("overflow");
            const W = b && !n;
            const J = m.x || m.y;
            const K = r || f || v || h || n;
            const G = p || M || Y;
            const Q = O && y.x && y.y;
            const setScrollbarVisibility = (t, n, o)=>{
                const s = t.includes($a15216a7e7549bc8$var$T) && (R === $a15216a7e7549bc8$var$A || R === "auto" && n === $a15216a7e7549bc8$var$T);
                x($a15216a7e7549bc8$var$gt, s, o);
                return s;
            };
            _ = N;
            if (W) {
                if (P && J) {
                    manageAutoHideSuspension(false);
                    d();
                    g(()=>{
                        d = $a15216a7e7549bc8$var$addEventListener($, "scroll", $a15216a7e7549bc8$var$bind(manageAutoHideSuspension, true), {
                            A: true
                        });
                    });
                } else manageAutoHideSuspension(true);
            }
            if (I) x($a15216a7e7549bc8$var$ut, Q);
            if (k) {
                x(u);
                x(D, true);
                u = D;
            }
            if (U && !P) manageAutoHideSuspension(true);
            if (L) {
                l = V === "move";
                i = V === "leave";
                a = V === "never";
                manageScrollbarsAutoHide(a, true);
            }
            if (q) x($a15216a7e7549bc8$var$Ct, j);
            if (B) x($a15216a7e7549bc8$var$$t, F);
            if (G) {
                const t = setScrollbarVisibility(X.x, S.x, true);
                const n = setScrollbarVisibility(X.y, S.y, false);
                const o = t && n;
                x($a15216a7e7549bc8$var$bt, !o);
            }
            if (K) {
                H();
                E();
                z();
                x($a15216a7e7549bc8$var$yt, !m.x, true);
                x($a15216a7e7549bc8$var$yt, !m.y, false);
                x($a15216a7e7549bc8$var$_t, w && !C);
            }
        },
        {},
        S
    ];
};
const $a15216a7e7549bc8$var$createStructureSetupElements = (t)=>{
    const o = $a15216a7e7549bc8$var$getEnvironment();
    const { L: s, R: e } = o;
    const { elements: c } = s();
    const { host: r, padding: l, viewport: i, content: a } = c;
    const u = $a15216a7e7549bc8$var$isHTMLElement(t);
    const d = u ? {} : t;
    const { elements: _ } = d;
    const { host: f, padding: p, viewport: v, content: h } = _ || {};
    const g = u ? t : d.target;
    const b = $a15216a7e7549bc8$var$isBodyElement(g);
    const w = $a15216a7e7549bc8$var$is(g, "textarea");
    const y = g.ownerDocument;
    const S = y.documentElement;
    const getDocumentWindow = ()=>y.defaultView || $a15216a7e7549bc8$var$n;
    const focusElm = (t)=>{
        if (t && t.focus) t.focus({
            preventScroll: true
        });
    };
    const m = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$staticInitializationElement, [
        g
    ]);
    const O = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$dynamicInitializationElement, [
        g
    ]);
    const $ = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$createDiv, "");
    const C = $a15216a7e7549bc8$var$bind(m, $, i);
    const x = $a15216a7e7549bc8$var$bind(O, $, a);
    const H = C(v);
    const E = H === g;
    const z = E && b;
    const A = !E && x(h);
    const I = !E && H === A;
    const T = z ? S : H;
    const D = w ? m($, r, f) : g;
    const k = z ? T : D;
    const R = !E && O($, l, p);
    const M = !I && A;
    const V = [
        M,
        T,
        R,
        k
    ].map((t)=>$a15216a7e7549bc8$var$isHTMLElement(t) && !$a15216a7e7549bc8$var$parent(t) && t);
    const elementIsGenerated = (t)=>t && $a15216a7e7549bc8$var$inArray(V, t);
    const L = elementIsGenerated(T) ? g : T;
    const P = {
        ft: g,
        vt: k,
        nt: T,
        en: R,
        gt: M,
        ht: z ? S : T,
        Jt: z ? y : T,
        cn: b ? S : L,
        Wt: y,
        bt: w,
        Tt: b,
        It: u,
        tt: E,
        rn: getDocumentWindow,
        wt: (t)=>$a15216a7e7549bc8$var$hasAttrClass(T, $a15216a7e7549bc8$var$Y, t),
        yt: (t, n)=>$a15216a7e7549bc8$var$addRemoveAttrClass(T, $a15216a7e7549bc8$var$Y, t, n)
    };
    const { ft: U, vt: N, en: q, nt: W, gt: J } = P;
    const K = [
        ()=>{
            $a15216a7e7549bc8$var$removeAttrs(N, [
                $a15216a7e7549bc8$var$B,
                $a15216a7e7549bc8$var$j
            ]);
            $a15216a7e7549bc8$var$removeAttrs(U, $a15216a7e7549bc8$var$j);
            if (b) $a15216a7e7549bc8$var$removeAttrs(S, [
                $a15216a7e7549bc8$var$j,
                $a15216a7e7549bc8$var$B
            ]);
        }
    ];
    const G = w && elementIsGenerated(N);
    let Z = w ? U : $a15216a7e7549bc8$var$contents([
        J,
        W,
        q,
        N,
        U
    ].find((t)=>t && !elementIsGenerated(t)));
    const tt = z ? U : J || W;
    const st = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, K);
    const appendElements = ()=>{
        const t = getDocumentWindow();
        const n = $a15216a7e7549bc8$var$getFocusedElement();
        const unwrap = (t)=>{
            $a15216a7e7549bc8$var$appendChildren($a15216a7e7549bc8$var$parent(t), $a15216a7e7549bc8$var$contents(t));
            $a15216a7e7549bc8$var$removeElements(t);
        };
        const prepareWrapUnwrapFocus = (t)=>$a15216a7e7549bc8$var$addEventListener(t, "focusin focusout focus blur", $a15216a7e7549bc8$var$stopPropagation, {
                H: true
            });
        const o = "tabindex";
        const s = $a15216a7e7549bc8$var$getAttr(W, o);
        const c = prepareWrapUnwrapFocus(n);
        $a15216a7e7549bc8$var$setAttrs(N, $a15216a7e7549bc8$var$B, E ? "" : $a15216a7e7549bc8$var$X);
        $a15216a7e7549bc8$var$setAttrs(q, $a15216a7e7549bc8$var$nt, "");
        $a15216a7e7549bc8$var$setAttrs(W, $a15216a7e7549bc8$var$Y, "");
        $a15216a7e7549bc8$var$setAttrs(J, $a15216a7e7549bc8$var$ot, "");
        if (!E) {
            $a15216a7e7549bc8$var$setAttrs(W, o, s || "-1");
            b && $a15216a7e7549bc8$var$setAttrs(S, $a15216a7e7549bc8$var$F, "");
        }
        if (G) {
            $a15216a7e7549bc8$var$insertAfter(U, N);
            $a15216a7e7549bc8$var$push(K, ()=>{
                $a15216a7e7549bc8$var$insertAfter(N, U);
                $a15216a7e7549bc8$var$removeElements(N);
            });
        }
        $a15216a7e7549bc8$var$appendChildren(tt, Z);
        $a15216a7e7549bc8$var$appendChildren(N, q);
        $a15216a7e7549bc8$var$appendChildren(q || N, !E && W);
        $a15216a7e7549bc8$var$appendChildren(W, J);
        $a15216a7e7549bc8$var$push(K, [
            c,
            ()=>{
                const t = $a15216a7e7549bc8$var$getFocusedElement();
                const n = prepareWrapUnwrapFocus(t);
                $a15216a7e7549bc8$var$removeAttrs(q, $a15216a7e7549bc8$var$nt);
                $a15216a7e7549bc8$var$removeAttrs(J, $a15216a7e7549bc8$var$ot);
                $a15216a7e7549bc8$var$removeAttrs(W, $a15216a7e7549bc8$var$Y);
                b && $a15216a7e7549bc8$var$removeAttrs(S, $a15216a7e7549bc8$var$F);
                s ? $a15216a7e7549bc8$var$setAttrs(W, o, s) : $a15216a7e7549bc8$var$removeAttrs(W, o);
                elementIsGenerated(J) && unwrap(J);
                elementIsGenerated(W) && unwrap(W);
                elementIsGenerated(q) && unwrap(q);
                focusElm(t);
                n();
            }
        ]);
        if (e && !E) {
            $a15216a7e7549bc8$var$addAttrClass(W, $a15216a7e7549bc8$var$Y, $a15216a7e7549bc8$var$Q);
            $a15216a7e7549bc8$var$push(K, $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$removeAttrs, W, $a15216a7e7549bc8$var$Y));
        }
        focusElm(!E && n === g && t.top === t ? W : n);
        c();
        Z = 0;
        return st;
    };
    return [
        P,
        appendElements,
        st
    ];
};
const $a15216a7e7549bc8$var$createTrinsicUpdateSegment = ({ gt: t })=>({ Kt: n, ln: o, At: s })=>{
        const { $t: e } = n || {};
        const { St: c } = o;
        const r = t && (e || s);
        if (r) $a15216a7e7549bc8$var$setStyles(t, {
            [$a15216a7e7549bc8$var$z]: c && "100%"
        });
    };
const $a15216a7e7549bc8$var$createPaddingUpdateSegment = ({ vt: t, en: n, nt: o, tt: s }, e)=>{
    const [c, r] = $a15216a7e7549bc8$var$createCache({
        i: $a15216a7e7549bc8$var$equalTRBL,
        o: $a15216a7e7549bc8$var$topRightBottomLeft()
    }, $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$topRightBottomLeft, t, "padding", ""));
    return ({ Et: t, Kt: l, ln: i, At: a })=>{
        let [u, d] = r(a);
        const { R: _ } = $a15216a7e7549bc8$var$getEnvironment();
        const { _t: f, Ct: p, Ot: v } = l || {};
        const { et: h } = i;
        const [g, b] = t("paddingAbsolute");
        const x = a || p;
        if (f || d || x) [u, d] = c(a);
        const H = !s && (b || v || d);
        if (H) {
            const t = !g || !n && !_;
            const s = u.r + u.l;
            const c = u.t + u.b;
            const r = {
                [$a15216a7e7549bc8$var$$]: t && !h ? -s : 0,
                [$a15216a7e7549bc8$var$C]: t ? -c : 0,
                [$a15216a7e7549bc8$var$O]: t && h ? -s : 0,
                top: t ? -u.t : 0,
                right: t ? h ? -u.r : "auto" : 0,
                left: t ? h ? "auto" : -u.l : 0,
                [$a15216a7e7549bc8$var$E]: t && `calc(100% + ${s}px)`
            };
            const l = {
                [$a15216a7e7549bc8$var$w]: t ? u.t : 0,
                [$a15216a7e7549bc8$var$y]: t ? u.r : 0,
                [$a15216a7e7549bc8$var$m]: t ? u.b : 0,
                [$a15216a7e7549bc8$var$S]: t ? u.l : 0
            };
            $a15216a7e7549bc8$var$setStyles(n || o, r);
            $a15216a7e7549bc8$var$setStyles(o, l);
            $a15216a7e7549bc8$var$assignDeep(e, {
                en: u,
                an: !t,
                ct: n ? l : $a15216a7e7549bc8$var$assignDeep({}, r, l)
            });
        }
        return {
            un: H
        };
    };
};
const $a15216a7e7549bc8$var$createOverflowUpdateSegment = (t, s)=>{
    const e = $a15216a7e7549bc8$var$getEnvironment();
    const { vt: c, en: r, nt: l, tt: i, ht: a, Tt: u, yt: d, rn: _ } = t;
    const { R: f } = e;
    const p = u && i;
    const v = $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$o, 0);
    const h = [
        "display",
        "direction",
        "flexDirection",
        "writingMode"
    ];
    const g = {
        i: $a15216a7e7549bc8$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    };
    const b = {
        i: $a15216a7e7549bc8$var$equalXY,
        o: {}
    };
    const getOverflowAmount = (t, o)=>{
        const s = $a15216a7e7549bc8$var$n.devicePixelRatio % 1 !== 0 ? 1 : 0;
        const e = {
            w: v(t.w - o.w),
            h: v(t.h - o.h)
        };
        return {
            w: e.w > s ? e.w : 0,
            h: e.h > s ? e.h : 0
        };
    };
    const measureScrollCoordinates = ()=>{
        const t = $a15216a7e7549bc8$var$getElementScroll(a);
        const n = d($a15216a7e7549bc8$var$tt, true);
        const o = $a15216a7e7549bc8$var$addEventListener(a, $a15216a7e7549bc8$var$T, $a15216a7e7549bc8$var$stopPropagation, {
            H: true
        });
        $a15216a7e7549bc8$var$scrollElementTo(a, {
            x: 0,
            y: 0
        });
        n();
        const s = $a15216a7e7549bc8$var$getElementScroll(a);
        const e = $a15216a7e7549bc8$var$V(a);
        $a15216a7e7549bc8$var$scrollElementTo(a, {
            x: e.w,
            y: e.h
        });
        const c = $a15216a7e7549bc8$var$getElementScroll(a);
        $a15216a7e7549bc8$var$scrollElementTo(a, {
            x: c.x - s.x < 1 && -e.w,
            y: c.y - s.y < 1 && -e.h
        });
        const r = $a15216a7e7549bc8$var$getElementScroll(a);
        $a15216a7e7549bc8$var$scrollElementTo(a, t);
        o();
        return {
            I: s,
            T: r
        };
    };
    const getFlowDirectionStyles = ()=>$a15216a7e7549bc8$var$assignDeep({}, $a15216a7e7549bc8$var$hasDimensions(l) ? $a15216a7e7549bc8$var$getStyles(l, h) : {});
    const [w, y] = $a15216a7e7549bc8$var$createCache(g, $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$getFractionalSize, l));
    const [S, m] = $a15216a7e7549bc8$var$createCache(g, $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$V, l));
    const [O, $] = $a15216a7e7549bc8$var$createCache(g);
    const [C] = $a15216a7e7549bc8$var$createCache(b);
    const [x, H] = $a15216a7e7549bc8$var$createCache(g);
    const [E] = $a15216a7e7549bc8$var$createCache(b);
    const [z] = $a15216a7e7549bc8$var$createCache({
        i: (t, n)=>$a15216a7e7549bc8$var$equal(t, n, h),
        o: {}
    });
    const [D, k] = $a15216a7e7549bc8$var$createCache({
        i: (t, n)=>$a15216a7e7549bc8$var$equalXY(t.I, n.I) && $a15216a7e7549bc8$var$equalXY(t.T, n.T),
        o: $a15216a7e7549bc8$var$getZeroScrollCoordinates()
    });
    const R = $a15216a7e7549bc8$var$getStaticPluginModuleInstance($a15216a7e7549bc8$var$Dt);
    const createViewportOverflowStyleClassName = (t, n)=>{
        const o = n ? $a15216a7e7549bc8$var$W : $a15216a7e7549bc8$var$J;
        return `${o}${$a15216a7e7549bc8$var$capitalizeFirstLetter(t)}`;
    };
    const setViewportOverflow = (t)=>{
        const { K: n } = t;
        $a15216a7e7549bc8$var$each($a15216a7e7549bc8$var$keys(n), (t)=>{
            const o = t === "x";
            const s = [
                $a15216a7e7549bc8$var$A,
                $a15216a7e7549bc8$var$I,
                $a15216a7e7549bc8$var$T
            ].map((t)=>createViewportOverflowStyleClassName(t, o));
            d(s.join(" "));
            d(createViewportOverflowStyleClassName(n[t], o), true);
        });
    };
    return ({ Et: n, Kt: i, ln: a, At: u }, { un: h })=>{
        const { _t: g, Ct: b, Ot: A, dt: I, Ht: T } = i || {};
        const V = R && R.Z(t, s, a, e, n);
        const { lt: L, it: P, ut: U } = V || {};
        const [N, j] = $a15216a7e7549bc8$var$getShowNativeOverlaidScrollbars(n, e);
        const [F, X] = n("overflow");
        const Y = $a15216a7e7549bc8$var$overflowIsVisible(F.x);
        const W = $a15216a7e7549bc8$var$overflowIsVisible(F.y);
        const J = g || h || b || A || T || j;
        let K = y(u);
        let G = m(u);
        let Z = $(u);
        let tt = H(u);
        if (j && f) d($a15216a7e7549bc8$var$Q, !N);
        if (J) {
            const [t] = P ? P() : [];
            const [n] = K = w(u);
            const [s] = G = S(u);
            const e = $a15216a7e7549bc8$var$M(l);
            const c = s;
            const r = e;
            t && t();
            const i = $a15216a7e7549bc8$var$getWindowSize(_());
            const a = {
                w: v($a15216a7e7549bc8$var$o(s.w, c.w) + n.w),
                h: v($a15216a7e7549bc8$var$o(s.h, c.h) + n.h)
            };
            const d = {
                w: v((p ? i.w : r.w + v(e.w - s.w)) + n.w),
                h: v((p ? i.h : r.h + v(e.h - s.h)) + n.h)
            };
            tt = x(d);
            Z = O(getOverflowAmount(a, d), u);
        }
        const [ot, st] = tt;
        const [et, ct] = Z;
        const [rt, lt] = G;
        const [it, at] = K;
        const [ut, dt] = C({
            x: et.w > 0,
            y: et.h > 0
        });
        const _t = Y && W && (ut.x || ut.y) || Y && ut.x && !ut.y || W && ut.y && !ut.x;
        const ft = h || A || T || at || lt || st || ct || X || j || J;
        const pt = $a15216a7e7549bc8$var$createViewportOverflowState(ut, F);
        const [vt, ht] = E(pt.K);
        const [, gt] = z(getFlowDirectionStyles(), u);
        const bt = A || I || gt || dt || u;
        const [wt, yt] = bt ? D(measureScrollCoordinates(), u) : k();
        if (ft) {
            setViewportOverflow(pt);
            if (U && L) $a15216a7e7549bc8$var$setStyles(l, U(pt, a, L(pt, rt, it)));
        }
        $a15216a7e7549bc8$var$addRemoveAttrClass(c, $a15216a7e7549bc8$var$B, $a15216a7e7549bc8$var$q, _t);
        $a15216a7e7549bc8$var$addRemoveAttrClass(r, $a15216a7e7549bc8$var$nt, $a15216a7e7549bc8$var$q, _t);
        $a15216a7e7549bc8$var$assignDeep(s, {
            K: vt,
            Mt: {
                x: ot.w,
                y: ot.h
            },
            Rt: {
                x: et.w,
                y: et.h
            },
            sn: ut,
            Lt: $a15216a7e7549bc8$var$sanatizeScrollCoordinates(wt, et)
        });
        return {
            tn: ht,
            Qt: st,
            Zt: ct,
            nn: yt || ct
        };
    };
};
const $a15216a7e7549bc8$var$createStructureSetup = (t)=>{
    const [n, o, s] = $a15216a7e7549bc8$var$createStructureSetupElements(t);
    const e = {
        en: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
        },
        an: false,
        ct: {
            [$a15216a7e7549bc8$var$$]: 0,
            [$a15216a7e7549bc8$var$C]: 0,
            [$a15216a7e7549bc8$var$O]: 0,
            [$a15216a7e7549bc8$var$w]: 0,
            [$a15216a7e7549bc8$var$y]: 0,
            [$a15216a7e7549bc8$var$m]: 0,
            [$a15216a7e7549bc8$var$S]: 0
        },
        Mt: {
            x: 0,
            y: 0
        },
        Rt: {
            x: 0,
            y: 0
        },
        K: {
            x: $a15216a7e7549bc8$var$I,
            y: $a15216a7e7549bc8$var$I
        },
        sn: {
            x: false,
            y: false
        },
        Lt: $a15216a7e7549bc8$var$getZeroScrollCoordinates()
    };
    const { ft: c, ht: r, tt: l, yt: i } = n;
    const { R: a, k: u } = $a15216a7e7549bc8$var$getEnvironment();
    const d = !a && (u.x || u.y);
    const _ = [
        $a15216a7e7549bc8$var$createTrinsicUpdateSegment(n),
        $a15216a7e7549bc8$var$createPaddingUpdateSegment(n, e),
        $a15216a7e7549bc8$var$createOverflowUpdateSegment(n, e)
    ];
    return [
        o,
        (t)=>{
            const n = {};
            const o = d;
            const s = i($a15216a7e7549bc8$var$G, true);
            const e = o && $a15216a7e7549bc8$var$getElementScroll(r);
            $a15216a7e7549bc8$var$each(_, (o)=>{
                $a15216a7e7549bc8$var$assignDeep(n, o(t, n) || {});
            });
            $a15216a7e7549bc8$var$scrollElementTo(r, e);
            !l && $a15216a7e7549bc8$var$scrollElementTo(c, 0);
            s();
            return n;
        },
        e,
        n,
        s
    ];
};
const $a15216a7e7549bc8$var$createSetups = (t, n, o, s)=>{
    const e = $a15216a7e7549bc8$var$createOptionCheck(n, {});
    const [c, r, l, i, a] = $a15216a7e7549bc8$var$createStructureSetup(t);
    const [u, d, _] = $a15216a7e7549bc8$var$createObserversSetup(i, l, e, (t)=>{
        update({}, t);
    });
    const [f, p, , v] = $a15216a7e7549bc8$var$createScrollbarsSetup(t, n, _, l, i, s);
    const updateHintsAreTruthy = (t)=>$a15216a7e7549bc8$var$keys(t).some((n)=>!!t[n]);
    const update = (t, s)=>{
        const { dn: e, At: c, zt: l, _n: i } = t;
        const a = e || {};
        const u = !!c;
        const f = {
            Et: $a15216a7e7549bc8$var$createOptionCheck(n, a, u),
            dn: a,
            At: u
        };
        if (i) {
            p(f);
            return false;
        }
        const v = s || d($a15216a7e7549bc8$var$assignDeep({}, f, {
            zt: l
        }));
        const h = r($a15216a7e7549bc8$var$assignDeep({}, f, {
            ln: _,
            Kt: v
        }));
        p($a15216a7e7549bc8$var$assignDeep({}, f, {
            Kt: v,
            Gt: h
        }));
        const g = updateHintsAreTruthy(v);
        const b = updateHintsAreTruthy(h);
        const w = g || b || !$a15216a7e7549bc8$var$isEmptyObject(a) || u;
        w && o(t, {
            Kt: v,
            Gt: h
        });
        return w;
    };
    return [
        ()=>{
            const { cn: t, ht: n, yt: o } = i;
            const s = o($a15216a7e7549bc8$var$G, true);
            const e = $a15216a7e7549bc8$var$getElementScroll(t);
            const r = [
                u(),
                c(),
                f()
            ];
            $a15216a7e7549bc8$var$scrollElementTo(n, e);
            s();
            return $a15216a7e7549bc8$var$bind($a15216a7e7549bc8$var$runEachAndClear, r);
        },
        update,
        ()=>({
                fn: _,
                pn: l
            }),
        {
            vn: i,
            hn: v
        },
        a
    ];
};
const $a15216a7e7549bc8$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { U: s } = $a15216a7e7549bc8$var$getEnvironment();
    const e = $a15216a7e7549bc8$var$isHTMLElement(t);
    const c = e ? t : t.target;
    const r = $a15216a7e7549bc8$var$getInstance(c);
    if (n && !r) {
        let r = false;
        const l = [];
        const i = {};
        const validateOptions = (t)=>{
            const n = $a15216a7e7549bc8$var$removeUndefinedProperties(t, true);
            const o = $a15216a7e7549bc8$var$getStaticPluginModuleInstance($a15216a7e7549bc8$var$At);
            return o ? o(n, true) : n;
        };
        const a = $a15216a7e7549bc8$var$assignDeep({}, s(), validateOptions(n));
        const [u, d, _] = $a15216a7e7549bc8$var$createEventListenerHub();
        const [f, p, v] = $a15216a7e7549bc8$var$createEventListenerHub(o);
        const triggerEvent = (t, n)=>{
            v(t, n);
            _(t, n);
        };
        const [h, g, b, w, y] = $a15216a7e7549bc8$var$createSetups(t, a, ({ dn: t, At: n }, { Kt: o, Gt: s })=>{
            const { _t: e, Ot: c, $t: r, Ct: l, xt: i, dt: a } = o;
            const { Qt: u, Zt: d, tn: _, nn: f } = s;
            triggerEvent("updated", [
                S,
                {
                    updateHints: {
                        sizeChanged: !!e,
                        directionChanged: !!c,
                        heightIntrinsicChanged: !!r,
                        overflowEdgeChanged: !!u,
                        overflowAmountChanged: !!d,
                        overflowStyleChanged: !!_,
                        scrollCoordinatesChanged: !!f,
                        contentMutation: !!l,
                        hostMutation: !!i,
                        appear: !!a
                    },
                    changedOptions: t || {},
                    force: !!n
                }
            ]);
        }, (t)=>triggerEvent("scroll", [
                S,
                t
            ]));
        const destroy = (t)=>{
            $a15216a7e7549bc8$var$removeInstance(c);
            $a15216a7e7549bc8$var$runEachAndClear(l);
            r = true;
            triggerEvent("destroyed", [
                S,
                t
            ]);
            d();
            p();
        };
        const S = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $a15216a7e7549bc8$var$getOptionsDiff(a, $a15216a7e7549bc8$var$assignDeep(o, validateOptions(t)));
                    if (!$a15216a7e7549bc8$var$isEmptyObject(e)) {
                        $a15216a7e7549bc8$var$assignDeep(a, e);
                        g({
                            dn: e
                        });
                    }
                }
                return $a15216a7e7549bc8$var$assignDeep({}, a);
            },
            on: f,
            off: (t, n)=>{
                t && n && p(t, n);
            },
            state () {
                const { fn: t, pn: n } = b();
                const { et: o } = t;
                const { Mt: s, Rt: e, K: c, sn: l, en: i, an: a, Lt: u } = n;
                return $a15216a7e7549bc8$var$assignDeep({}, {
                    overflowEdge: s,
                    overflowAmount: e,
                    overflowStyle: c,
                    hasOverflow: l,
                    scrollCoordinates: {
                        start: u.I,
                        end: u.T
                    },
                    padding: i,
                    paddingAbsolute: a,
                    directionRTL: o,
                    destroyed: r
                });
            },
            elements () {
                const { ft: t, vt: n, en: o, nt: s, gt: e, ht: c, Jt: r } = w.vn;
                const { qt: l, Yt: i } = w.hn;
                const translateScrollbarStructure = (t)=>{
                    const { kt: n, Dt: o, Vt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Ft: n, Bt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $a15216a7e7549bc8$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            g({
                                _n: true
                            });
                            return t;
                        }
                    });
                };
                return $a15216a7e7549bc8$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(l),
                    scrollbarVertical: translateScrollbarsSetupElement(i)
                });
            },
            update: (t)=>g({
                    At: t,
                    zt: true
                }),
            destroy: $a15216a7e7549bc8$var$bind(destroy, false),
            plugin: (t)=>i[$a15216a7e7549bc8$var$keys(t)[0]]
        };
        $a15216a7e7549bc8$var$push(l, [
            y
        ]);
        $a15216a7e7549bc8$var$addInstance(c, S);
        $a15216a7e7549bc8$var$registerPluginModuleInstances($a15216a7e7549bc8$var$Et, $a15216a7e7549bc8$export$d08ab3fe303a3356, [
            S,
            u,
            i
        ]);
        if ($a15216a7e7549bc8$var$cancelInitialization(w.vn.Tt, !e && t.cancel)) {
            destroy(true);
            return S;
        }
        $a15216a7e7549bc8$var$push(l, h());
        triggerEvent("initialized", [
            S
        ]);
        S.update(true);
        return S;
    }
    return r;
};
$a15216a7e7549bc8$export$d08ab3fe303a3356.plugin = (t)=>{
    const n = $a15216a7e7549bc8$var$isArray(t);
    const o = n ? t : [
        t
    ];
    const s = o.map((t)=>$a15216a7e7549bc8$var$registerPluginModuleInstances(t, $a15216a7e7549bc8$export$d08ab3fe303a3356)[0]);
    $a15216a7e7549bc8$var$addPlugins(o);
    return n ? s : s[0];
};
$a15216a7e7549bc8$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $a15216a7e7549bc8$var$isFunction(n) && n();
    return $a15216a7e7549bc8$var$isPlainObject(o) && !!$a15216a7e7549bc8$var$getInstance(o.target);
};
$a15216a7e7549bc8$export$d08ab3fe303a3356.env = ()=>{
    const { D: t, k: n, R: o, M: s, j: e, q: c, L: r, P: l, U: i, N: a } = $a15216a7e7549bc8$var$getEnvironment();
    return $a15216a7e7549bc8$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        scrollTimeline: s,
        staticDefaultInitialization: e,
        staticDefaultOptions: c,
        getDefaultInitialization: r,
        setDefaultInitialization: l,
        getDefaultOptions: i,
        setDefaultOptions: a
    });
};


const $c3bc3d47cbe0dd24$var$S = ()=>{
    if (typeof window > "u") {
        const n = ()=>{};
        return [
            n,
            n
        ];
    }
    let l, o;
    const t = window, c = typeof t.requestIdleCallback == "function", a = t.requestAnimationFrame, i = t.cancelAnimationFrame, r = c ? t.requestIdleCallback : a, u = c ? t.cancelIdleCallback : i, s = ()=>{
        u(l), i(o);
    };
    return [
        (n, e)=>{
            s(), l = r(c ? ()=>{
                s(), o = a(n);
            } : n, typeof e == "object" ? e : {
                timeout: 2233
            });
        },
        s
    ];
}, $c3bc3d47cbe0dd24$export$98c834f87b3a8a6f = (l)=>{
    const { options: o, events: t, defer: c } = l || {}, [a, i] = (0, $dup7A.useMemo)($c3bc3d47cbe0dd24$var$S, []), r = (0, $dup7A.useRef)(null), u = (0, $dup7A.useRef)(c), s = (0, $dup7A.useRef)(o), n = (0, $dup7A.useRef)(t);
    return (0, $dup7A.useEffect)(()=>{
        u.current = c;
    }, [
        c
    ]), (0, $dup7A.useEffect)(()=>{
        const { current: e } = r;
        s.current = o, (0, $a15216a7e7549bc8$export$d08ab3fe303a3356).valid(e) && e.options(o || {}, !0);
    }, [
        o
    ]), (0, $dup7A.useEffect)(()=>{
        const { current: e } = r;
        n.current = t, (0, $a15216a7e7549bc8$export$d08ab3fe303a3356).valid(e) && e.on(t || {}, !0);
    }, [
        t
    ]), (0, $dup7A.useEffect)(()=>()=>{
            var e;
            i(), (e = r.current) == null || e.destroy();
        }, []), (0, $dup7A.useMemo)(()=>[
            (e)=>{
                const v = r.current;
                if ((0, $a15216a7e7549bc8$export$d08ab3fe303a3356).valid(v)) return;
                const f = u.current, y = s.current || {}, b = n.current || {}, m = ()=>r.current = (0, $a15216a7e7549bc8$export$d08ab3fe303a3356)(e, y, b);
                f ? a(m, f) : m();
            },
            ()=>r.current
        ], []);
}, $c3bc3d47cbe0dd24$var$q = (l, o)=>{
    const { element: t = "div", options: c, events: a, defer: i, children: r, ...u } = l, s = t, n = (0, $dup7A.useRef)(null), e = (0, $dup7A.useRef)(null), [v, f] = $c3bc3d47cbe0dd24$export$98c834f87b3a8a6f({
        options: c,
        events: a,
        defer: i
    });
    return (0, $dup7A.useEffect)(()=>{
        const { current: y } = n, { current: b } = e;
        if (!y) return;
        const m = y;
        return v(t === "body" ? {
            target: m,
            cancel: {
                body: null
            }
        } : {
            target: m,
            elements: {
                viewport: b,
                content: b
            }
        }), ()=>{
            var R;
            return (R = f()) == null ? void 0 : R.destroy();
        };
    }, [
        v,
        t
    ]), (0, $dup7A.useImperativeHandle)(o, ()=>({
            osInstance: f,
            getElement: ()=>n.current
        }), []), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(s, {
        "data-overlayscrollbars-initialize": "",
        ref: n,
        ...u
    }, t === "body" ? r : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        "data-overlayscrollbars-contents": "",
        ref: e
    }, r));
}, $c3bc3d47cbe0dd24$export$5c3912403b9b36ce = (0, $dup7A.forwardRef)($c3bc3d47cbe0dd24$var$q);





var $dup7A = parcelRequire("dup7A");
const $5312253935e6facb$export$20b5a34f45062e8b = /*#__PURE__*/ (0, $dup7A.createContext)(null);



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $802b5b112dfd8881$var$SvgSecuredByKleros = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 179,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('ce4a5e5c410b2e21')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fff",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M5.598 13.86c0 .779-.281 1.39-.844 1.833-.562.443-1.337.664-2.326.664-.989 0-1.798-.153-2.428-.46v-1.354c.399.188.821.336 1.268.443.45.108.869.162 1.256.162.566 0 .982-.108 1.25-.323.27-.216.406-.505.406-.869 0-.327-.123-.604-.37-.832-.248-.227-.758-.497-1.531-.808-.798-.324-1.36-.693-1.687-1.108-.327-.415-.49-.914-.49-1.497 0-.73.259-1.305.777-1.724.518-.42 1.214-.63 2.087-.63.838 0 1.67.185 2.5.552l-.454 1.167c-.778-.327-1.472-.49-2.082-.49-.462 0-.813.101-1.052.305a.985.985 0 0 0-.359.796c0 .228.048.423.144.587.095.16.253.311.472.455.22.144.614.333 1.184.569.642.267 1.112.517 1.411.748a2.2 2.2 0 0 1 .658.785c.14.291.21.634.21 1.03Zm6.638 2.378H7.29V7.484h4.946v1.21H8.72v2.383h3.295v1.197H8.72v2.749h3.516v1.215Zm3.679-6.778c.47-.583 1.116-.875 1.937-.875.363 0 .708.054 1.035.162.33.104.644.226.939.365l.514-1.191a5.5 5.5 0 0 0-2.476-.563c-.85 0-1.588.182-2.219.545a3.584 3.584 0 0 0-1.447 1.569c-.33.682-.496 1.479-.496 2.389 0 1.445.343 2.556 1.028 3.335.686.774 1.669 1.161 2.949 1.161.869 0 1.646-.13 2.332-.389v-1.227c-.375.116-.735.211-1.082.287a5.299 5.299 0 0 1-1.077.108c-.857 0-1.513-.276-1.967-.826-.45-.551-.676-1.364-.676-2.437 0-1.026.235-1.83.706-2.413ZM28.75 7.484v5.665c0 .646-.14 1.213-.42 1.7a2.773 2.773 0 0 1-1.201 1.12c-.523.26-1.149.389-1.878.389-1.085 0-1.928-.288-2.53-.862-.602-.575-.903-1.366-.903-2.372v-5.64h1.435v5.539c0 .722.168 1.255.503 1.598.335.344.849.515 1.543.515 1.347 0 2.021-.708 2.021-2.125V7.484h1.43Zm4.656 4.072h-.992V8.694h.944c.65 0 1.137.107 1.46.323.323.216.484.57.484 1.066 0 .487-.15.854-.448 1.101-.3.248-.782.372-1.448.372Zm-.992 4.682v-3.497h1.411l2.093 3.497h1.627l-2.47-3.874c1.132-.463 1.698-1.24 1.698-2.33 0-.853-.27-1.492-.813-1.915-.542-.423-1.377-.635-2.506-.635h-2.47v8.754h1.43Zm11.35 0h-4.946V7.484h4.945v1.21h-3.516v2.383h3.295v1.197h-3.295v2.749h3.516v1.215Zm7.806-1.144c.801-.766 1.202-1.872 1.202-3.317 0-1.36-.387-2.417-1.16-3.167-.773-.75-1.856-1.126-3.247-1.126H45.66v8.754h2.446c1.507 0 2.662-.381 3.463-1.144ZM48.33 8.682c1.957 0 2.936 1.048 2.936 3.143 0 2.14-1.053 3.21-3.158 3.21h-1.016V8.682h1.238Zm9.555-1.198h2.47c1.16 0 1.999.174 2.517.521.518.347.778.896.778 1.647 0 .519-.146.948-.437 1.287-.287.335-.708.553-1.262.653v.06c1.328.227 1.992.926 1.992 2.095 0 .783-.266 1.393-.796 1.832-.526.44-1.264.66-2.212.66h-3.05V7.483Zm1.016 3.748h1.675c.717 0 1.234-.111 1.549-.335.315-.228.472-.609.472-1.144 0-.49-.175-.844-.526-1.06-.351-.219-.91-.329-1.675-.329H58.9v2.868Zm0 .863v3.275h1.824c.706 0 1.236-.136 1.591-.407.359-.276.538-.705.538-1.288 0-.543-.183-.942-.55-1.197-.363-.256-.917-.383-1.662-.383H58.9Zm11.482-4.61L68.05 11.86l-2.314-4.377h-1.113l2.913 5.407v3.347h1.028v-3.395l2.919-5.359h-1.1ZM91.387 0l13.567.607 5.494 12.223-7.75 11.17-13.641-.875-5.593-13.243L91.387 0Zm9.947 7.045-9.833 4.303 8.406 6.508 1.427-10.81Zm-1.138-2.156-7.858-3.388-1.651 7.124 9.509-3.736Zm-1.992 14.605-8.54-6.107.206 8.276 8.334-2.169Zm10.88-6.691-5.82-5.914-1.537 11.372 7.357-5.458Zm-8.878 8.021-7.202 1.886 8.47.543-1.268-2.428Zm7.74-5.338-6.304 4.703 1.253 2.452 5.051-7.155Zm-2.982-13.171-1.225 2.518 4.558 4.64-3.333-7.158Zm-1.525-1.205L95.434.785l6.603 2.892 1.402-2.567Zm-13.22 1.164-5.607 7.09 3.748.795 1.858-7.885Zm-2.085 9.276-3.766-.799 3.93 9.272-.164-8.473ZM119.791 11.154h-.456V7.095h-1.22v9.525h1.22v-4.46h.42l3.843 4.698.928-.786-3.697-4.48 3.151-4.003-.929-.731-3.26 4.296Zm10.619-4.059h-1.221v9.525h6.192v-1.097h-4.971V7.095Zm9.469 0h5.919v1.097h-4.699v2.852h3.879v1.097h-3.879v3.382h4.699v1.097h-5.919V7.095Zm14.005 0h-3.224v9.525h1.221v-4.077h1.767l2.421 4.315 1.056-.64-2.33-3.858c1.146-.347 1.929-1.499 1.929-2.669 0-1.846-1.256-2.596-2.84-2.596Zm1.565 2.596c0 1.08-.783 1.755-1.965 1.755h-1.603V8.192h1.965c1.094 0 1.603.64 1.603 1.5Zm12.259 2.175c0 .768-.055 4.918-3.37 4.918-1.53 0-3.369-1.096-3.369-4.918 0-3.802 1.804-4.936 3.369-4.936 1.512 0 3.37 1.097 3.37 4.936Zm-5.464 0c0 1.39.255 3.767 2.094 3.767 1.84 0 2.095-2.377 2.095-3.767 0-1.407-.255-3.784-2.095-3.784-1.839 0-2.094 2.377-2.094 3.784Zm13.113 3.767c-1.275 0-1.84-.86-2.077-2.03l-1.092.348c.292 1.7 1.402 2.833 3.169 2.833 1.748 0 3.006-1.024 3.006-2.833 0-.988-.457-1.756-1.312-2.23l-2.022-.897c-.728-.329-1.275-.585-1.275-1.48 0-.86.765-1.262 1.548-1.262 1.039 0 1.53.658 1.749 1.59l1.166-.347c-.383-1.48-1.312-2.395-2.897-2.395-1.493 0-2.786.896-2.786 2.505 0 1.634 1.091 2.082 2.333 2.592l.362.15c.076.032.153.062.229.093.855.345 1.683.68 1.683 1.754 0 1.06-.782 1.609-1.784 1.609Z"
            })
        })
    });
var $802b5b112dfd8881$export$2e2bcd8739ae039 = $802b5b112dfd8881$var$SvgSecuredByKleros;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $0a7067313c1e6c49$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('383ab3de53be5b37')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M14.162 3.011a.04.04 0 0 0-.021-.018A13.375 13.375 0 0 0 10.884 2a.05.05 0 0 0-.052.024c-.15.266-.285.539-.406.818a12.405 12.405 0 0 0-3.657 0 8.214 8.214 0 0 0-.412-.818.051.051 0 0 0-.053-.024c-1.124.19-2.22.524-3.257.992a.046.046 0 0 0-.021.018C.952 6.053.384 9.02.662 11.95a.053.053 0 0 0 .021.037 13.366 13.366 0 0 0 3.995 1.983.053.053 0 0 0 .057-.018 9.28 9.28 0 0 0 .817-1.306.049.049 0 0 0-.01-.058.052.052 0 0 0-.018-.01 8.804 8.804 0 0 1-1.248-.585.051.051 0 0 1-.025-.04.05.05 0 0 1 .02-.043c.084-.062.168-.126.248-.191a.05.05 0 0 1 .052-.007c2.618 1.174 5.453 1.174 8.04 0a.05.05 0 0 1 .053.006c.08.065.164.13.248.192a.049.049 0 0 1 .016.019.049.049 0 0 1-.003.047.05.05 0 0 1-.017.017 8.265 8.265 0 0 1-1.249.584.051.051 0 0 0-.03.029.049.049 0 0 0 .003.04c.24.454.512.89.817 1.305a.05.05 0 0 0 .056.019 13.32 13.32 0 0 0 4.001-1.983.05.05 0 0 0 .021-.036c.334-3.388-.558-6.332-2.365-8.94Zm-8.22 7.156c-.787 0-1.437-.71-1.437-1.583S5.142 7 5.943 7c.807 0 1.45.717 1.438 1.584 0 .872-.637 1.583-1.438 1.583Zm5.317 0c-.788 0-1.438-.71-1.438-1.583S10.46 7 11.26 7c.808 0 1.45.717 1.438 1.584 0 .872-.63 1.583-1.438 1.583Z"
            })
        })
    });
var $0a7067313c1e6c49$export$2e2bcd8739ae039 = $0a7067313c1e6c49$var$SvgDiscord;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $b6bee18c471e20c7$var$SvgEtherscan = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('0d4e72a6f91ae4dc')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M3.973 7.358a.679.679 0 0 0-.052.26v4.24a.566.566 0 0 1-.5.562c-.318.037-.584.064-.798.082a1.011 1.011 0 0 1-.965-.5A7.977 7.977 0 0 1 .596 8.002c0-4.438 3.665-8.06 8.1-8a7.982 7.982 0 0 1 7.443 5.394 1.14 1.14 0 0 1-.173 1.064c-.79 1.03-1.784 1.885-2.765 2.596V4.226a.68.68 0 0 0-.679-.679H11.39a.678.678 0 0 0-.679.68v5.863a.567.567 0 0 1-.346.522c-.276.117-.559.231-.559.231V5.925a.68.68 0 0 0-.679-.68H7.995a.679.679 0 0 0-.679.68v5.3a.566.566 0 0 1-.436.55 8.952 8.952 0 0 0-.469.12V7.623a.68.68 0 0 0-.679-.68l-1.13-.003a.678.678 0 0 0-.629.418Zm-.076 7.112Zm0 0a7.994 7.994 0 0 0 12.678-7.017C13.654 11.812 8.26 13.85 3.897 14.47Z"
            })
        })
    });
var $b6bee18c471e20c7$export$2e2bcd8739ae039 = $b6bee18c471e20c7$var$SvgEtherscan;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $1d4c7219f7d40cfc$var$SvgGhostBlog = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('b8168e7a58aa30ec')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M.596 1.5a1.5 1.5 0 0 1 1.5-1.5h6.412a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5H2.096a1.5 1.5 0 0 1-1.5-1.5V1.5Zm12.706.001a1.5 1.5 0 0 1 1.5-1.5h.294a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5h-.294a1.5 1.5 0 0 1-1.5-1.5v-.294Zm-1.794 11.205a1.5 1.5 0 0 0-1.5 1.5v.294a1.5 1.5 0 0 0 1.5 1.5h3.588a1.5 1.5 0 0 0 1.5-1.5v-.294a1.5 1.5 0 0 0-1.5-1.5h-3.588Zm-10.912 1.5a1.5 1.5 0 0 1 1.5-1.5h3.588a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5H2.096a1.5 1.5 0 0 1-1.5-1.5v-.294Zm1.5-8.088a1.5 1.5 0 0 0-1.5 1.5v.294a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-.294a1.5 1.5 0 0 0-1.5-1.5h-13Z"
            })
        })
    });
var $1d4c7219f7d40cfc$export$2e2bcd8739ae039 = $1d4c7219f7d40cfc$var$SvgGhostBlog;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $666495bcf97150e4$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('8455de95ebb69c72')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M5.948 12.964c0 .062-.074.111-.168.111-.106.01-.18-.04-.18-.11 0-.062.074-.111.167-.111.097-.01.18.04.18.11Zm-1.003-.138c-.023.062.042.132.138.15.084.031.18 0 .2-.06.02-.062-.042-.133-.138-.16-.084-.022-.178.009-.2.07Zm1.425-.052c-.093.022-.158.08-.148.15.01.062.094.102.19.08.094-.021.158-.08.149-.14-.01-.06-.097-.1-.19-.09ZM8.493 1C4.019 1 .596 4.235.596 8.497c0 3.408 2.252 6.323 5.468 7.35.413.07.558-.172.558-.372 0-.19-.01-1.242-.01-1.887 0 0-2.258.461-2.732-.915 0 0-.368-.895-.897-1.125 0 0-.738-.482.052-.473 0 0 .803.061 1.245.793.707 1.186 1.89.845 2.352.642.074-.492.284-.833.516-1.036-1.803-.19-3.623-.439-3.623-3.395 0-.845.245-1.269.762-1.81-.084-.2-.359-1.023.083-2.086.675-.2 2.226.83 2.226.83a7.934 7.934 0 0 1 2.026-.261c.687 0 1.38.089 2.026.26 0 0 1.551-1.032 2.226-.829.441 1.066.167 1.887.083 2.087.517.543.833.967.833 1.81 0 2.964-1.9 3.2-3.704 3.394.297.243.549.704.549 1.426 0 1.035-.01 2.317-.01 2.569 0 .2.149.442.558.371 3.226-1.02 5.413-3.935 5.413-7.343C16.596 4.235 12.967 1 8.493 1ZM3.732 11.597c-.042.031-.033.102.022.16.052.05.126.07.168.03.042-.03.032-.1-.023-.159-.051-.05-.125-.07-.167-.03Zm-.349-.249c-.022.04.01.09.074.12.052.03.117.022.14-.021.022-.04-.01-.09-.075-.12-.065-.019-.116-.01-.139.021Zm1.045 1.094c-.051.04-.032.132.042.19.075.071.168.08.21.031.042-.04.023-.132-.042-.19-.07-.07-.168-.08-.21-.03Zm-.367-.451c-.052.03-.052.11 0 .18.051.072.138.102.18.072.052-.04.052-.12 0-.191-.045-.07-.129-.101-.18-.061Z"
            })
        })
    });
var $666495bcf97150e4$export$2e2bcd8739ae039 = $666495bcf97150e4$var$SvgGithub;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $10fcc302603f5d2f$var$SvgLinkedin = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('7e29a86965abff20')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M4.165 16H.86V5.318h3.305V16ZM2.511 3.86C1.454 3.86.596 2.983.596 1.923.596.86 1.454 0 2.511 0c1.056 0 1.914.86 1.914 1.922 0 1.06-.858 1.939-1.914 1.939ZM16.538 16h-3.299v-5.2c0-1.24-.025-2.828-1.719-2.828-1.718 0-1.982 1.346-1.982 2.739V16H6.236V5.317h3.17v1.457h.047c.441-.84 1.52-1.725 3.128-1.725 3.345 0 3.96 2.21 3.96 5.082V16h-.003Z"
            })
        })
    });
var $10fcc302603f5d2f$export$2e2bcd8739ae039 = $10fcc302603f5d2f$var$SvgLinkedin;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $0073eeb943c3ed99$var$SvgReddit = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('35f7c61e8a8a7205')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M14.812 5.787c-.506 0-.951.21-1.278.536-1.204-.833-2.826-1.369-4.623-1.426L9.845.688l2.974.668c0 .728.593 1.322 1.322 1.322.742 0 1.339-.61 1.339-1.34C15.48.612 14.886 0 14.14 0c-.518 0-.967.314-1.19.742L9.666.014C9.5-.03 9.339.088 9.295.253L8.27 4.893c-1.784.075-3.39.61-4.597 1.444-.327-.34-.789-.55-1.295-.55-1.875 0-2.488 2.516-.772 3.376-.06.266-.088.55-.088.833 0 2.826 3.184 5.115 7.092 5.115 3.926 0 7.11-2.29 7.11-5.115 0-.284-.031-.58-.105-.847 1.682-.863 1.062-3.362-.803-3.362ZM4.328 9.341c0-.742.593-1.338 1.338-1.338.729 0 1.322.593 1.322 1.338 0 .729-.593 1.322-1.322 1.322a1.328 1.328 0 0 1-1.338-1.322Zm7.226 3.154c-1.227 1.227-4.69 1.227-5.918 0-.135-.118-.135-.328 0-.462a.324.324 0 0 1 .445 0c.938.96 4.047.977 5.025 0a.324.324 0 0 1 .445 0c.138.134.138.344.003.462Zm-.027-1.828a1.324 1.324 0 0 1-1.321-1.322 1.33 1.33 0 1 1 1.321 1.322Z"
            })
        })
    });
var $0073eeb943c3ed99$export$2e2bcd8739ae039 = $0073eeb943c3ed99$var$SvgReddit;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $67b3b144fed31a86$var$SvgSnapshot = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('eeaf5d8a973a2661')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M1.734 8.646 11.604.1c.332-.288.816.098.61.486L8.99 6.633h5.601c.369 0 .538.459.258.698l-10.012 8.57c-.332.285-.812-.098-.61-.484l3.178-6.074H1.993a.396.396 0 0 1-.26-.697Z"
            })
        })
    });
var $67b3b144fed31a86$export$2e2bcd8739ae039 = $67b3b144fed31a86$var$SvgSnapshot;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $e5e17f601f1fb0e1$var$SvgTelegram = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('e5c5a431076d9f73')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m16.55 2.197-2.414 11.16c-.182.787-.657.983-1.332.612l-3.68-2.657-1.774 1.673c-.197.193-.361.354-.74.354l.265-3.672 6.818-6.038c.297-.26-.064-.403-.46-.144l-8.43 5.202-3.629-1.113c-.79-.242-.803-.774.165-1.145L15.533 1.07c.657-.241 1.232.144 1.018 1.127Z"
            })
        })
    });
var $e5e17f601f1fb0e1$export$2e2bcd8739ae039 = $e5e17f601f1fb0e1$var$SvgTelegram;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $373e5657daec75d9$var$SvgX = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 17,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M12.92 2h2.207l-4.819 5.506L15.977 15h-4.438l-3.478-4.544L4.086 15h-2.21L7.03 9.11 1.596 2h4.55l3.14 4.153L12.921 2Zm-.774 11.681h1.222L5.48 3.251H4.168l7.978 10.43Z"
        })
    });
var $373e5657daec75d9$export$2e2bcd8739ae039 = $373e5657daec75d9$var$SvgX;


const $2c64bbf124b97cec$export$53b9549b1f2be1ec = {
    etherscan: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b6bee18c471e20c7$export$2e2bcd8739ae039), {}),
        url: ""
    },
    github: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $666495bcf97150e4$export$2e2bcd8739ae039), {}),
        url: "https://github.com/kleros"
    },
    snapshot: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $67b3b144fed31a86$export$2e2bcd8739ae039), {}),
        url: "https://snapshot.org/#/kleros.eth"
    },
    discord: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0a7067313c1e6c49$export$2e2bcd8739ae039), {}),
        url: "https://discord.com/invite/MhXQGCyHd9"
    },
    x: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $373e5657daec75d9$export$2e2bcd8739ae039), {}),
        url: "https://x.com/kleros_io"
    },
    reddit: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0073eeb943c3ed99$export$2e2bcd8739ae039), {}),
        url: "https://www.reddit.com/r/Kleros/"
    },
    telegram: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e5e17f601f1fb0e1$export$2e2bcd8739ae039), {}),
        url: "https://t.me/kleros"
    },
    ghost: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1d4c7219f7d40cfc$export$2e2bcd8739ae039), {}),
        url: "https://blog.kleros.io/"
    },
    linkedin: {
        icon: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $10fcc302603f5d2f$export$2e2bcd8739ae039), {}),
        url: "https://www.linkedin.com/company/kleros/"
    }
};



const $1a81a644a2506b99$export$4cf8c0e020b1f8b2 = 900;
const $1a81a644a2506b99$export$7432a1a850ec2b36 = (styleFn)=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
  @media (min-width: ${$1a81a644a2506b99$export$4cf8c0e020b1f8b2}px) {
    ${()=>styleFn()}
  }
`;


const $20c9cb43ec92a0da$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 122px;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.primaryPurple};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 32px 8px 32px;
  gap: 24px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      height: 64px;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 0;
    `)}

  .secured-by-kleros {
    min-height: 24px;
  }

  .socialmedia {
    display: flex;
    gap: 16px;
    justify-content: center;

    a {
      display: inline-block;
      svg {
        height: 16px;
        width: 16px;
        max-heigth: 16px;
        max-width: 16px;
        fill: white;
      }
    }
  }
`;
const $20c9cb43ec92a0da$var$SecuredByKleros = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)("a", {
        className: "secured-by-kleros",
        href: "https://kleros.io",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $802b5b112dfd8881$export$2e2bcd8739ae039), {})
    });
const $20c9cb43ec92a0da$var$SocialMedia = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)("div", {
        className: "socialmedia",
        children: Object.values((0, $2c64bbf124b97cec$export$53b9549b1f2be1ec)).map((site, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)("a", {
                href: site.url,
                target: "_blank",
                rel: "noreferrer",
                children: site.icon
            }, i))
    });
const $20c9cb43ec92a0da$var$Footer = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)($20c9cb43ec92a0da$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($20c9cb43ec92a0da$var$SecuredByKleros, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($20c9cb43ec92a0da$var$SocialMedia, {})
        ]
    });
var $20c9cb43ec92a0da$export$2e2bcd8739ae039 = $20c9cb43ec92a0da$var$Footer;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $dbcb5f29e9c29744$var$SvgKlerosSolutions = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 14,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8-12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        })
    });
var $dbcb5f29e9c29744$export$2e2bcd8739ae039 = $dbcb5f29e9c29744$var$SvgKlerosSolutions;



var $dup7A = parcelRequire("dup7A");

const $bafdb2a6661c2921$export$eb909a3d9177a60d = (shouldLock)=>{
    const osInstanceRef = (0, $dup7A.useContext)((0, $5312253935e6facb$export$20b5a34f45062e8b));
    const lockScroll = (0, $dup7A.useCallback)(()=>{
        const osInstance = osInstanceRef?.current?.osInstance();
        if (osInstance) osInstance.options({
            overflow: {
                x: "hidden",
                y: "hidden"
            }
        });
    }, [
        osInstanceRef
    ]);
    const unlockScroll = (0, $dup7A.useCallback)(()=>{
        const osInstance = osInstanceRef?.current?.osInstance();
        if (osInstance) osInstance.options({
            overflow: {
                x: "scroll",
                y: "scroll"
            }
        });
    }, [
        osInstanceRef
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (shouldLock) lockScroll();
        else unlockScroll();
    }, [
        shouldLock,
        lockScroll,
        unlockScroll
    ]);
};



/**
 * @description this func applies repsonsiveness to a css property, the value will range from minSize to maxSize
 * @param minSize the minimum value of the property
 * @param maxSize max value of the property
 * @param minScreen the min screen width at which the property will be at minSize
 * @param maxScreen the max screen width at which the property will be at maxSize
 *
 */ const $72173f5a1c3efd56$export$1b3e91ab3ce1a831 = (minSize, maxSize, minScreen = 375, maxScreen = 1250)=>`calc(${minSize}px + (${maxSize} - ${minSize}) * (min(max(100vw, ${minScreen}px), ${maxScreen}px) - ${minScreen}px) / (${maxScreen - minScreen}))`;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $0851f7d91966eb7d$exports = {};

$0851f7d91966eb7d$exports = function(t) {
    var e = {};
    function n(r) {
        if (e[r]) return e[r].exports;
        var u = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(u.exports, u, u.exports, n), u.l = !0, u.exports;
    }
    return n.m = t, n.c = e, n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var u in t)n.d(r, u, (function(e) {
            return t[e];
        }).bind(null, u));
        return r;
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(e, "a", e), e;
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
}([
    function(t, e, n) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var r = n(1), u = i(r), o = i(n(2)), c = i(n(3));
        function i(t) {
            return t && t.__esModule ? t : {
                default: t
            };
        }
        var f = function(t) {
            var e = t.fg, n = t.bg, i = t.count, f = t.palette, l = t.string, a = t.size, d = t.getColor, s = t.padding, g = t.className, p = (0, r.useRef)(null);
            (0, r.useEffect)(function() {
                h(t);
            });
            var h = function() {
                var t = (0, o.default)(l), r = Math.floor(a / i), u = t.slice(0, 6);
                if (f && f.length) {
                    var g = Math.floor((0, c.default)(parseInt(t.slice(-3), 16), 0, 4095, 0, f.length));
                    e = f[g];
                }
                d && d(e || u);
                var h = s;
                p.current.width = r * i + h, p.current.height = r * i + h;
                var v = t.split("").map(function(t) {
                    return (t = parseInt(t, 16)) < 8 ? 0 : 1;
                }), b = [];
                b[0] = b[4] = v.slice(0, 5), b[1] = b[3] = v.slice(5, 10), b[2] = v.slice(10, 15);
                var y = p.current.getContext("2d");
                y.imageSmoothingEnabled = !1, y.clearRect(0, 0, p.current.width, p.current.height), b.forEach(function(t, o) {
                    t.forEach(function(t, c) {
                        t ? (y.fillStyle = e || "#" + u, y.fillRect(r * o + h, r * c + h, r - h, r - h)) : (y.fillStyle = n, y.fillRect(r * o + h, r * c + h, r - h, r - h));
                    });
                });
            };
            return u.default.createElement("canvas", {
                ref: p,
                className: g,
                style: {
                    width: a,
                    height: a
                }
            });
        };
        f.defaultProps = {
            className: "identicon",
            bg: "transparent",
            count: 5,
            palette: null,
            fg: null,
            padding: 0,
            size: 400,
            getColor: null,
            string: ""
        }, e.default = f;
    },
    function(t, e) {
        t.exports = (parcelRequire("dup7A"));
    },
    function(t, e, n) {
        "use strict";
        var r;
        "function" == typeof Symbol && Symbol.iterator;
        !function(u) {
            function o(t, e) {
                var n = (65535 & t) + (65535 & e);
                return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
            }
            function c(t, e, n, r, u, c) {
                return o(function(t, e) {
                    return t << e | t >>> 32 - e;
                }(o(o(e, t), o(r, c)), u), n);
            }
            function i(t, e, n, r, u, o, i) {
                return c(e & n | ~e & r, t, e, u, o, i);
            }
            function f(t, e, n, r, u, o, i) {
                return c(e & r | n & ~r, t, e, u, o, i);
            }
            function l(t, e, n, r, u, o, i) {
                return c(e ^ n ^ r, t, e, u, o, i);
            }
            function a(t, e, n, r, u, o, i) {
                return c(n ^ (e | ~r), t, e, u, o, i);
            }
            function d(t, e) {
                t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e;
                var n, r, u, c, d, s = 1732584193, g = -271733879, p = -1732584194, h = 271733878;
                for(n = 0; n < t.length; n += 16)r = s, u = g, c = p, d = h, g = a(g = a(g = a(g = a(g = l(g = l(g = l(g = l(g = f(g = f(g = f(g = f(g = i(g = i(g = i(g = i(g, p = i(p, h = i(h, s = i(s, g, p, h, t[n], 7, -680876936), g, p, t[n + 1], 12, -389564586), s, g, t[n + 2], 17, 606105819), h, s, t[n + 3], 22, -1044525330), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 4], 7, -176418897), g, p, t[n + 5], 12, 1200080426), s, g, t[n + 6], 17, -1473231341), h, s, t[n + 7], 22, -45705983), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 8], 7, 1770035416), g, p, t[n + 9], 12, -1958414417), s, g, t[n + 10], 17, -42063), h, s, t[n + 11], 22, -1990404162), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 12], 7, 1804603682), g, p, t[n + 13], 12, -40341101), s, g, t[n + 14], 17, -1502002290), h, s, t[n + 15], 22, 1236535329), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 1], 5, -165796510), g, p, t[n + 6], 9, -1069501632), s, g, t[n + 11], 14, 643717713), h, s, t[n], 20, -373897302), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 5], 5, -701558691), g, p, t[n + 10], 9, 38016083), s, g, t[n + 15], 14, -660478335), h, s, t[n + 4], 20, -405537848), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 9], 5, 568446438), g, p, t[n + 14], 9, -1019803690), s, g, t[n + 3], 14, -187363961), h, s, t[n + 8], 20, 1163531501), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 13], 5, -1444681467), g, p, t[n + 2], 9, -51403784), s, g, t[n + 7], 14, 1735328473), h, s, t[n + 12], 20, -1926607734), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 5], 4, -378558), g, p, t[n + 8], 11, -2022574463), s, g, t[n + 11], 16, 1839030562), h, s, t[n + 14], 23, -35309556), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 1], 4, -1530992060), g, p, t[n + 4], 11, 1272893353), s, g, t[n + 7], 16, -155497632), h, s, t[n + 10], 23, -1094730640), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 13], 4, 681279174), g, p, t[n], 11, -358537222), s, g, t[n + 3], 16, -722521979), h, s, t[n + 6], 23, 76029189), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 9], 4, -640364487), g, p, t[n + 12], 11, -421815835), s, g, t[n + 15], 16, 530742520), h, s, t[n + 2], 23, -995338651), p = a(p, h = a(h, s = a(s, g, p, h, t[n], 6, -198630844), g, p, t[n + 7], 10, 1126891415), s, g, t[n + 14], 15, -1416354905), h, s, t[n + 5], 21, -57434055), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 12], 6, 1700485571), g, p, t[n + 3], 10, -1894986606), s, g, t[n + 10], 15, -1051523), h, s, t[n + 1], 21, -2054922799), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 8], 6, 1873313359), g, p, t[n + 15], 10, -30611744), s, g, t[n + 6], 15, -1560198380), h, s, t[n + 13], 21, 1309151649), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 4], 6, -145523070), g, p, t[n + 11], 10, -1120210379), s, g, t[n + 2], 15, 718787259), h, s, t[n + 9], 21, -343485551), s = o(s, r), g = o(g, u), p = o(p, c), h = o(h, d);
                return [
                    s,
                    g,
                    p,
                    h
                ];
            }
            function s(t) {
                var e, n = "", r = 32 * t.length;
                for(e = 0; e < r; e += 8)n += String.fromCharCode(t[e >> 5] >>> e % 32 & 255);
                return n;
            }
            function g(t) {
                var e, n = [];
                for(n[(t.length >> 2) - 1] = void 0, e = 0; e < n.length; e += 1)n[e] = 0;
                var r = 8 * t.length;
                for(e = 0; e < r; e += 8)n[e >> 5] |= (255 & t.charCodeAt(e / 8)) << e % 32;
                return n;
            }
            function p(t) {
                var e, n, r = "";
                for(n = 0; n < t.length; n += 1)e = t.charCodeAt(n), r += "0123456789abcdef".charAt(e >>> 4 & 15) + "0123456789abcdef".charAt(15 & e);
                return r;
            }
            function h(t) {
                return unescape(encodeURIComponent(t));
            }
            function v(t) {
                return function(t) {
                    return s(d(g(t), 8 * t.length));
                }(h(t));
            }
            function b(t, e) {
                return function(t, e) {
                    var n, r, u = g(t), o = [], c = [];
                    for(o[15] = c[15] = void 0, u.length > 16 && (u = d(u, 8 * t.length)), n = 0; n < 16; n += 1)o[n] = 909522486 ^ u[n], c[n] = 1549556828 ^ u[n];
                    return r = d(o.concat(g(e)), 512 + 8 * e.length), s(d(c.concat(r), 640));
                }(h(t), h(e));
            }
            function y(t, e, n) {
                return e ? n ? b(e, t) : function(t, e) {
                    return p(b(t, e));
                }(e, t) : n ? v(t) : function(t) {
                    return p(v(t));
                }(t);
            }
            void 0 === (r = (function() {
                return y;
            }).call(e, n, e, t)) || (t.exports = r);
        }();
    },
    function(t, e, n) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        e.default = function(t, e, n, r, u) {
            return (t - e) * (u - r) / (n - e) + r;
        };
    }
]);



var $gg0RY = parcelRequire("gg0RY");


var $aegFK = parcelRequire("aegFK");
function $db69162b86dec792$export$e6e2bc9967bf256c(address) {
    try {
        const formattedAddress = (0, $aegFK.getAddress)(address);
        return formattedAddress.substring(0, 6) + "..." + formattedAddress.substring(formattedAddress.length - 4);
    } catch  {
        throw new TypeError("Invalid input, address can't be parsed");
    }
}



const $c4fa15e9af440105$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  align-items: flex-start;
  gap: 8px;
  align-items: center;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  padding: 0px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      background-color: ${({ theme: theme })=>theme.whiteLowOpacity};
      flex-direction: row;
      align-content: center;
      border-radius: 300px;
      gap: 0px;
      padding: 0 12px;
    `)}
`;
const $c4fa15e9af440105$var$AccountContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  min-height: 32px;
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 8px;

  > label {
    font-size: 16px;
    font-weight: 600;
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 12px;
      > label {
        color: ${({ theme: theme })=>theme.primaryText};
        font-weight: 400;
        font-size: 14px;
      }
    `)}
`;
const $c4fa15e9af440105$var$ChainConnectionContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  width: fit-content;
  min-height: 32px;
  align-items: center;
  padding-left: 0px;
  > label {
    color: ${({ theme: theme })=>theme.success};
    font-size: 16px;

    font-weight: 500;
  }

  :before {
    content: "";
    width: 8px;
    height: 8px;
    margin: 0px 13px 0px 3px;
    border-radius: 50%;
    background-color: ${({ theme: theme })=>theme.success};
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $c4fa15e9af440105$var$StyledIdenticon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($0851f7d91966eb7d$exports))))`
  align-items: center;
  svg {
    width: ${({ size: size })=>size + "px"};
    height: ${({ size: size })=>size + "px"};
  }
`;
const $c4fa15e9af440105$var$StyledAvatar = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).img`
  align-items: center;
  object-fit: cover;
  border-radius: 50%;
  width: ${({ size: size })=>size + "px"};
  height: ${({ size: size })=>size + "px"};
`;
const $c4fa15e9af440105$export$f8b4f9182cfa7b1d = ({ size: size = "16", address: propAddress })=>{
    const { address: defaultAddress } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const address = propAddress || defaultAddress;
    const { data: name } = (0, $1d657eb5d64e17dc$export$e7302f55b2684d23)({
        address: address,
        chainId: 1
    });
    const { data: avatar } = (0, $1d657eb5d64e17dc$export$182f359dd9766fbb)({
        name: name,
        chainId: 1
    });
    return avatar ? /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$var$StyledAvatar, {
        src: avatar,
        alt: "avatar",
        size: size
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$var$StyledIdenticon, {
        size: size,
        string: address
    });
};
const $c4fa15e9af440105$export$6cdabdfc8e8da8af = ({ address: propAddress })=>{
    const { address: defaultAddress } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const address = propAddress || defaultAddress;
    const { data: data } = (0, $1d657eb5d64e17dc$export$e7302f55b2684d23)({
        address: address,
        chainId: 1
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
        children: data ?? ((0, $gg0RY.isAddress)(address) ? (0, $db69162b86dec792$export$e6e2bc9967bf256c)(address) : address)
    });
};
const $c4fa15e9af440105$export$97063c1c513ee59f = ()=>{
    const { chain: chain } = (0, $1d657eb5d64e17dc$export$553aaf59afc1a2d8)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
        children: chain?.name
    });
};
const $c4fa15e9af440105$var$AccountDisplay = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($c4fa15e9af440105$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($c4fa15e9af440105$var$AccountContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$export$f8b4f9182cfa7b1d, {
                        size: "32"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$export$6cdabdfc8e8da8af, {})
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$var$ChainConnectionContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($c4fa15e9af440105$export$97063c1c513ee59f, {})
            })
        ]
    });
};
var $c4fa15e9af440105$export$2e2bcd8739ae039 = $c4fa15e9af440105$var$AccountDisplay;


const $5fd7f782fb0a380f$export$87dd1b4aceb12c0e = ({ className: className })=>{
    const { switchNetwork: switchNetwork, isLoading: isLoading } = (0, $1d657eb5d64e17dc$export$71b0470720f288c1)();
    const handleSwitch = ()=>{
        if (!switchNetwork) {
            console.error("Cannot switch network. Please do it manually.");
            return;
        }
        try {
            switchNetwork((0, $32162005f9f3d1a7$export$8372812df8e8183f));
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
        className: className,
        isLoading: isLoading,
        disabled: isLoading,
        text: `Switch to ${(0, $32162005f9f3d1a7$export$7000f41a852f3e5)[0, $32162005f9f3d1a7$export$8372812df8e8183f].name}`,
        onClick: handleSwitch
    });
};
const $5fd7f782fb0a380f$var$ConnectButton = ({ className: className })=>{
    const { open: open, isOpen: isOpen } = (0, $d8cd0db3ca41ed09$export$69804ca079d47f29)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
        className: className,
        disabled: isOpen,
        small: true,
        text: "Connect",
        onClick: async ()=>open({
                route: "ConnectWallet"
            })
    });
};
const $5fd7f782fb0a380f$var$ConnectWallet = ({ className: className })=>{
    const { chain: chain } = (0, $1d657eb5d64e17dc$export$553aaf59afc1a2d8)();
    const { isConnected: isConnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    if (isConnected) {
        if (chain && chain.id !== (0, $32162005f9f3d1a7$export$8372812df8e8183f)) return /*#__PURE__*/ (0, $cZGFG.jsx)($5fd7f782fb0a380f$export$87dd1b4aceb12c0e, {
            className: className
        });
        else return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$2e2bcd8739ae039), {});
    } else return /*#__PURE__*/ (0, $cZGFG.jsx)($5fd7f782fb0a380f$var$ConnectButton, {
        className: className
    });
};
var $5fd7f782fb0a380f$export$2e2bcd8739ae039 = $5fd7f782fb0a380f$var$ConnectWallet;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $d86601acd95afa87$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  background-color: transparent;
  padding-left: 0;
  .button-text {
    color: ${({ theme: theme })=>theme.primaryText};
    font-weight: 400;
  }
  .button-svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  :focus,
  :hover {
    background-color: transparent;
  }
`;
const $d86601acd95afa87$var$LightButton = ({ text: text, Icon: Icon, onClick: onClick, disabled: disabled, className: className })=>/*#__PURE__*/ (0, $cZGFG.jsx)($d86601acd95afa87$var$StyledButton, {
        variant: "primary",
        small: true,
        text: text,
        Icon: Icon,
        onClick: onClick,
        disabled: disabled,
        className: className
    });
var $d86601acd95afa87$export$2e2bcd8739ae039 = $d86601acd95afa87$var$LightButton;



const $c9df7c59319b4252$export$c6fdb837b070b4ff = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme: theme })=>theme.blackLowOpacity};
  z-index: 1;
`;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $6b474b5d67cef2b9$var$SvgKlerosCourt = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 148,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('800b76cec7911b1f')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fff",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M66.813 24.41h-.628v-5.596h-1.682v13.13h1.682v-6.149h.578l5.298 6.477 1.28-1.084-5.097-6.174 4.344-5.519-1.28-1.008-4.495 5.923Zm14.64-5.596H79.77v13.13h8.537v-1.512h-6.855V18.814Zm13.057 0h8.16v1.512h-6.478v3.932h5.348v1.512h-5.348v4.662h6.478v1.512h-8.16v-13.13Zm19.309 0h-4.444v13.13h1.682v-5.62h2.436l3.339 5.948 1.457-.882-3.214-5.318c1.582-.479 2.661-2.066 2.661-3.68 0-2.545-1.732-3.578-3.917-3.578Zm2.159 3.579c0 1.486-1.079 2.419-2.711 2.419h-2.21v-4.486h2.712c1.507 0 2.209.882 2.209 2.067Zm16.9 2.999c0 1.058-.076 6.78-4.646 6.78-2.109 0-4.645-1.513-4.645-6.78 0-5.242 2.486-6.804 4.645-6.804 2.084 0 4.646 1.512 4.646 6.804Zm-7.533 0c0 1.915.351 5.191 2.887 5.191 2.537 0 2.888-3.276 2.888-5.191 0-1.94-.352-5.217-2.888-5.217s-2.887 3.276-2.887 5.217Zm18.079 5.191c-1.758 0-2.536-1.184-2.862-2.797l-1.507.479c.402 2.343 1.934 3.906 4.369 3.906 2.411 0 4.143-1.411 4.143-3.906 0-1.361-.627-2.42-1.808-3.075l-2.787-1.235c-1.004-.453-1.757-.806-1.757-2.04 0-1.185 1.054-1.74 2.134-1.74 1.431 0 2.109.907 2.41 2.193l1.607-.479c-.527-2.041-1.807-3.301-3.992-3.301-2.059 0-3.842 1.234-3.842 3.452 0 2.253 1.504 2.87 3.217 3.573.165.068.332.136.499.207l.315.128c1.179.476 2.322.937 2.322 2.418 0 1.461-1.08 2.217-2.461 2.217ZM15.636 1 42.41 2.197l10.84 24.091-15.293 22.018-26.921-1.725L0 20.48 15.636 1Zm19.63 13.887-19.406 8.48 16.59 12.83 2.816-21.31Zm-2.247-4.25L17.51 3.96 14.253 18l18.766-7.364Zm-3.93 28.788L12.233 27.387l.408 16.312 16.446-4.274Zm21.47-13.19L39.074 14.578l-3.031 22.416 14.516-10.76ZM33.04 42.046l-14.213 3.716 16.715 1.07-2.501-4.786Zm15.276-10.522-12.443 9.27 2.473 4.833 9.97-14.103ZM42.429 5.563l-2.416 4.962 8.995 9.146-6.579-14.108Zm-3.01-2.375-15.797-.64 13.03 5.7 2.766-5.06Zm-26.09 2.295L2.265 19.457l7.397 1.567 3.667-15.54ZM9.216 23.765l-7.433-1.574L9.54 40.466l-.323-16.7Z"
            })
        })
    });
var $6b474b5d67cef2b9$export$2e2bcd8739ae039 = $6b474b5d67cef2b9$var$SvgKlerosCourt;




const $f09e80dfb6891fe0$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
const $f09e80dfb6891fe0$var$StyledLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $1d2829c53a2521b2$export$a6c7ac8248d6e38a))`
  min-height: 48px;
`;
const $f09e80dfb6891fe0$var$BadgeContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  transform: skewX(-15deg);
  background-color: ${({ theme: theme, backgroundColor: backgroundColor })=>theme[backgroundColor]};
  border-radius: 3px;
  padding: 1px 8px;
  height: fit-content;
`;
const $f09e80dfb6891fe0$var$BadgeText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.darkPurple};
`;
const $f09e80dfb6891fe0$var$CourtBadge = ()=>{
    const { text: text, color: color } = (0, $dup7A.useMemo)(()=>{
        switch((0, $203b613495c69c62$export$f308382ea47b5f34)()){
            case (0, $203b613495c69c62$export$9106d0c469e874f6).neo:
                return {
                    text: "Neo",
                    color: "paleCyan"
                };
            case (0, $203b613495c69c62$export$9106d0c469e874f6).university:
                return {
                    text: "Uni",
                    color: "limeGreen"
                };
        }
        return {};
    }, []);
    return !(0, $2d857633ba67aa25$export$fce6876652108ab)(color) ? /*#__PURE__*/ (0, $cZGFG.jsx)($f09e80dfb6891fe0$var$BadgeContainer, {
        backgroundColor: color,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($f09e80dfb6891fe0$var$BadgeText, {
            children: text
        })
    }) : null;
};
const $f09e80dfb6891fe0$var$Logo = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)($f09e80dfb6891fe0$var$Container, {
        children: [
            " ",
            /*#__PURE__*/ (0, $cZGFG.jsx)($f09e80dfb6891fe0$var$StyledLink, {
                to: "/",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6b474b5d67cef2b9$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($f09e80dfb6891fe0$var$CourtBadge, {})
        ]
    });
var $f09e80dfb6891fe0$export$2e2bcd8739ae039 = $f09e80dfb6891fe0$var$Logo;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");

var $4b2c45c637e46ca6$var$defaultEvents = [
    "mousedown",
    "touchstart"
];
var $4b2c45c637e46ca6$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $4b2c45c637e46ca6$var$defaultEvents;
    var savedCallback = (0, $dup7A.useRef)(onClickAway);
    (0, $dup7A.useEffect)(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    (0, $dup7A.useEffect)(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            (0, $226407d615d776bb$export$af631764ddc44097)(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                (0, $226407d615d776bb$export$8c8705df4a2dcec9)(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
var $4b2c45c637e46ca6$export$2e2bcd8739ae039 = $4b2c45c637e46ca6$var$useClickAway;


var $72e592d8fb227650$exports = {};
$72e592d8fb227650$exports = new URL("curate-image.d1f1c2c8.png", import.meta.url).toString();



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $6f166477f0696511$var$SvgDisputeResolver = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
            clipPath: "url('8444310ad60bbd10')",
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M47.953 23.909c0 13.228-10.746 23.943-23.99 23.943C10.716 47.852-.03 37.137-.03 23.909c0-13.228 10.746-23.943 23.991-23.943S47.953 10.681 47.953 23.91Zm-2.3 0c0 11.953-9.711 21.643-21.69 21.643-11.98 0-21.692-9.69-21.692-21.643 0-11.953 9.712-21.643 21.691-21.643 11.98 0 21.691 9.69 21.691 21.643Z",
                    fill: "#9013FE"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M23.962 45.551c11.98 0 21.691-9.69 21.691-21.642 0-11.953-9.711-21.643-21.69-21.643-11.98 0-21.692 9.69-21.692 21.643 0 11.953 9.712 21.642 21.691 21.642Z",
                    fill: "#1E075F"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m21.668 19 6.281.277 2.543 5.578-3.588 5.098-6.315-.399L18 23.51 21.668 19Zm4.037 9.474-3.332.855 3.918.247-.587-1.102Zm3.58-2.424-2.917 2.135.58 1.113 2.337-3.248Zm-8.457-.952.096 3.756 3.854-.984-3.95-2.772Zm-2.45-1.197 1.818 4.209-.075-3.846-1.742-.363Zm8.74-1.753-.71 5.162 3.403-2.477-2.692-2.685Zm-.892.071-4.548 1.953 3.888 2.954.66-4.907Zm-5.141-2.165-2.594 3.218 1.734.36.86-3.578Zm6.82.018-.566 1.143 2.108 2.106-1.542-3.249Zm-5.84-.37-.764 3.234 4.399-1.695-3.635-1.538Zm1.432-.324 3.054 1.312.649-1.165-3.703-.147Z",
                    fill: "#9013FE"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43.533 31.575c0 1.718-3.398 3.11-7.59 3.11-4.193 0-7.591-1.392-7.591-3.11 0-1.719 15.181-1.719 15.181 0Zm-.53.015c0 .355-3.17.643-7.079.643-3.91 0-7.078-.288-7.078-.643 0-.354 3.169-.642 7.078-.642 3.91 0 7.08.288 7.08.642Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M35.924 32.233c3.91 0 7.08-.288 7.08-.643 0-.354-3.17-.642-7.08-.642s-7.078.288-7.078.642c0 .355 3.169.643 7.078.643Z",
                    fill: "#009AFF"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.533 31.575c0 1.718-3.399 3.11-7.59 3.11-4.193 0-7.591-1.392-7.591-3.11 0-1.719 15.18-1.719 15.18 0Zm-.53.015c0 .355-3.17.643-7.079.643-3.91 0-7.079-.288-7.079-.643 0-.354 3.17-.642 7.08-.642 3.909 0 7.078.288 7.078.642Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M11.924 32.233c3.91 0 7.079-.288 7.079-.643 0-.354-3.17-.642-7.079-.642-3.91 0-7.079.288-7.079.642 0 .355 3.17.643 7.08.643Z",
                    fill: "#009AFF"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.098 20.85c0 .792-.644 1.435-1.439 1.435a1.437 1.437 0 0 1-1.438-1.436c0-.792.644-1.435 1.438-1.435.795 0 1.439.643 1.439 1.435Zm-.606 0a.832.832 0 1 1-1.664-.002.832.832 0 0 1 1.664.002ZM37.93 20.85c0 .792-.643 1.435-1.438 1.435a1.437 1.437 0 0 1-1.438-1.436c0-.792.644-1.435 1.438-1.435.795 0 1.439.643 1.439 1.435Zm-.605 0a.832.832 0 1 1-1.664-.002.832.832 0 0 1 1.664.002Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m24.151 11.528.038-8.762a.265.265 0 0 0-.53-.003l-.038 8.763c0 .034.007.067.018.097l-2.188 2.182c-3.219.64-6.29 2.557-9.206 5.733.36.16.641.463.772.837 3.461-3.797 7.08-5.675 10.87-5.675 3.789 0 7.537 1.879 11.248 5.673.131-.372.412-.674.77-.834-3.126-3.184-6.323-5.102-9.588-5.737l-2.183-2.18a.266.266 0 0 0 .017-.094Zm13.716 8.9a1.43 1.43 0 0 1-.125 1.133h2.1a.567.567 0 1 0 0-1.134h-1.974Zm-.92 1.783a1.437 1.437 0 0 1-.403.073l5.452 8.475c.194.042.374.087.536.134l-5.585-8.682Zm-8.464 9.942a1.158 1.158 0 0 1-.015-.034l-.026.034h.041Zm.916-1.273a8.17 8.17 0 0 1 .578-.14l6.36-8.464a1.435 1.435 0 0 1-.397-.1l-6.541 8.704ZM8.289 20.427h1.995a1.43 1.43 0 0 0 .125 1.134H8.29a.567.567 0 1 1 0-1.134Zm-3.82 11.726.008-.012.006.012h-.014Zm1.366-1.383c-.2.045-.383.092-.547.143l5.78-8.755c.118.053.246.091.38.111L5.834 30.77Zm12.586.092a8.672 8.672 0 0 0-.567-.133l-6.203-8.444h.008c.145 0 .285-.022.416-.061l6.346 8.638Zm6.287-17.269-.784-.782-.779.777a12.594 12.594 0 0 1 1.563.005Z",
                    fill: "#E1BEFF"
                })
            ]
        })
    });
var $6f166477f0696511$export$2e2bcd8739ae039 = $6f166477f0696511$var$SvgDisputeResolver;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $38dab3c6fe494658$var$SvgEscrow = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 11.998 23.805 0 44.55 11.999v.593c0 15.157-6.854 26.885-20.435 35.093l-.522.315-.527-.306c-13.334-7.737-20.04-19.482-20.064-35.1L3 11.998Zm40.52.595c0 14.774-6.646 26.177-19.938 34.21C10.57 39.255 4.053 27.852 4.03 12.594L23.804 1.189 43.52 12.592Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.599 43.752C35.099 36.71 40.863 26.81 40.95 14.01L23.803 4.094l-17.2 9.915c.104 13.232 5.76 23.125 16.996 29.743ZM6.088 13.712c.02 13.665 5.859 23.878 17.516 30.64 11.908-7.195 17.862-17.408 17.862-30.64L23.803 3.5 6.088 13.713Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m18.639 12.763 11.799.52 4.777 10.487-6.74 9.585-11.863-.751-4.864-11.362 6.89-8.48Zm7.63 17.897-6.25 1.611 7.35.464-1.1-2.075Zm6.716-4.562-5.47 4.02 1.086 2.094 4.384-6.114Zm-15.864-1.793.179 7.071 7.231-1.853-7.41-5.218Zm-4.596-2.252 3.41 7.922-.142-7.24-3.268-.682Zm16.397-3.3-1.333 9.717 6.383-4.664-5.05-5.054Zm-1.675.133-8.532 3.676 7.295 5.562 1.237-9.238Zm-9.645-4.076-4.865 6.057 3.253.68 1.612-6.738Zm12.795.034-1.062 2.151 3.955 3.965-2.893-6.116Zm-10.956-.695-1.433 6.087 8.252-3.192-6.82-2.895Zm2.687-.612 5.729 2.47 1.216-2.192-6.945-.278Z",
                fill: "#9013FE"
            })
        ]
    });
var $38dab3c6fe494658$export$2e2bcd8739ae039 = $38dab3c6fe494658$var$SvgEscrow;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $1fcfcf3c6fbc93f1$var$SvgGovernor = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M23.204 47.778a1.658 1.658 0 0 0 1.659 0l19.375-11.174a1.655 1.655 0 0 0 .83-1.433V12.828a1.653 1.653 0 0 0-.83-1.434L24.863.222a1.658 1.658 0 0 0-1.659 0L3.83 11.395A1.653 1.653 0 0 0 3 12.828v22.344a1.653 1.653 0 0 0 .829 1.433l19.375 11.173Zm.829-1.434L4.657 35.172V12.828L24.033 1.654l19.376 11.174v22.344L24.033 46.344Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m40.406 13.786-15.7-9.051a1.351 1.351 0 0 0-1.347 0l-15.7 9.05a1.34 1.34 0 0 0-.671 1.161v18.102a1.342 1.342 0 0 0 .671 1.162l15.7 9.05a1.34 1.34 0 0 0 1.346 0l15.7-9.05a1.342 1.342 0 0 0 .672-1.162V14.946a1.34 1.34 0 0 0-.671-1.16Zm-.13 18.843a1.274 1.274 0 0 1-.64 1.104l-14.963 8.63a1.293 1.293 0 0 1-1.278 0l-14.962-8.63a1.276 1.276 0 0 1-.64-1.107V15.372a1.281 1.281 0 0 1 .64-1.107L23.4 5.64a1.272 1.272 0 0 1 1.278 0l14.964 8.626a1.278 1.278 0 0 1 .633 1.106v17.257Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m21.392 14.61 2.263-2.264a.109.109 0 0 1 .154 0l5.575 5.575a.109.109 0 0 1 0 .154l-2.263 2.263a.109.109 0 0 1-.154 0l-5.575-5.575a.109.109 0 0 1 0-.153Zm-5.286 6.86 5.343-5.344a.5.5 0 0 1 .707 0l3.45 3.45a.5.5 0 0 1 0 .707l-5.343 5.344a.5.5 0 0 1-.707 0l-3.45-3.45a.5.5 0 0 1 0-.707Zm-1.547-.026-2.264 2.264a.109.109 0 0 0 0 .154l5.575 5.575a.109.109 0 0 0 .154 0l2.264-2.264a.109.109 0 0 0 0-.154l-5.575-5.575a.109.109 0 0 0-.154 0Zm8.167 2.037 8.78 9.76c.214.24.724.09 1.13-.334.41-.422.552-.952.322-1.176l-9.386-9.13-.846.88Z",
                fill: "#9021FE"
            })
        ]
    });
var $1fcfcf3c6fbc93f1$export$2e2bcd8739ae039 = $1fcfcf3c6fbc93f1$var$SvgGovernor;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $c62dc91ec117256f$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m14.094 3 24.135 1.079L48 25.794 34.215 45.641 9.948 44.086 0 20.558 14.094 3Zm17.694 12.517-17.492 7.644L29.25 34.726l2.538-19.209Zm-2.025-3.83-13.979-6.02-2.936 12.657 16.915-6.637ZM26.22 37.635l-15.192-10.85.367 14.703 14.825-3.853Zm19.353-11.889L35.221 15.24l-2.733 20.205 13.085-9.698ZM29.782 40l-12.813 3.35 15.067.964L29.782 40Zm13.768-9.485L32.335 38.87l2.228 4.356 8.987-12.712ZM38.245 7.113l-2.178 4.473 8.108 8.244-5.93-12.717Zm-2.714-2.14-14.238-.578 11.745 5.138 2.493-4.56ZM12.014 7.04 2.042 19.637l6.667 1.412 3.306-14.008Zm-3.707 16.48-6.7-1.42 6.991 16.473-.29-15.054Z",
            fill: "#9013FE"
        })
    });
var $c62dc91ec117256f$export$2e2bcd8739ae039 = $c62dc91ec117256f$var$SvgKleros;


var $7f2e8e1f9165ead5$exports = {};
$7f2e8e1f9165ead5$exports = new URL("poh-image.0ff250c0.png", import.meta.url).toString();



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $1206cf082369d573$var$SvgVea = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M1.297 16.605h14.086L8.34 31.937 1.297 16.605ZM8.34 30.039l5.82-12.636H2.542L8.34 30.04ZM19.081 16.626h10.522v.798h-9.727v6.081h8.46v.798h-8.46v6.534h9.727v.798H19.081V16.626ZM47.173 31.635H33.087l7.043-15.332 7.043 15.332Zm-12.841-.798h11.595L40.13 18.201l-5.798 12.636Z",
            fill: "#9013FE"
        })
    });
var $1206cf082369d573$export$2e2bcd8739ae039 = $1206cf082369d573$var$SvgVea;





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $49880716436ea8c4$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 8px 35px 8px;
  max-width: 100px;
  border-radius: 3px;
  :hover {
    transform: scale(1.05);
    transition: 350ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  gap: 8px;
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(100, 130)};

  background-color: ${({ theme: theme })=>theme.lightBackground};
`;
const $49880716436ea8c4$var$StyledIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  width: 48px;
  height: 48px;
`;
const $49880716436ea8c4$var$StyledImg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).img`
  width: 48px;
  height: 48px;
`;
const $49880716436ea8c4$var$StyledSmall = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  display: flex;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
`;
const $49880716436ea8c4$var$Product = ({ text: text, url: url, Icon: Icon })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($49880716436ea8c4$var$Container, {
        href: url,
        target: "_blank",
        children: [
            typeof Icon === "string" ? /*#__PURE__*/ (0, $cZGFG.jsx)($49880716436ea8c4$var$StyledImg, {
                alt: Icon,
                src: Icon
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)($49880716436ea8c4$var$StyledIcon, {
                as: Icon
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($49880716436ea8c4$var$StyledSmall, {
                children: text
            })
        ]
    });
};
var $49880716436ea8c4$export$2e2bcd8739ae039 = $49880716436ea8c4$var$Product;


const $fd49b2724862d581$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  padding-top: 32px;
  padding-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.68px;
`;
const $fd49b2724862d581$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  max-height: 340px;
  top: 5%;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
  flex-direction: column;
  align-items: center;

  width: 86vw;
  max-width: 480px;
  min-width: 300px;
  border-radius: 3px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);

  svg {
    visibility: visible;
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-top: 64px;
      top: 0;
      left: 0;
      right: auto;
      transform: none;
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(300, 480)};
      max-height: 80vh;
    `)}
`;
const $fd49b2724862d581$var$ItemsDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: grid;
  overflow-y: auto;
  padding: 16px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24, 480)};
  row-gap: 8px;
  column-gap: 2px;
  justify-items: center;
  max-width: 480px;
  min-width: 300px;
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(300, 480)};
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
`;
const $fd49b2724862d581$var$ITEMS = [
    {
        text: "Court V2",
        Icon: (0, $c62dc91ec117256f$export$2e2bcd8739ae039),
        url: "https://v2.kleros.builders/"
    },
    {
        text: "Curate V2",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($72e592d8fb227650$exports))),
        url: "https://curate-v2.netlify.app/"
    },
    {
        text: "Resolver V2",
        Icon: (0, $6f166477f0696511$export$2e2bcd8739ae039),
        url: "https://v2.kleros.builders/#/resolver"
    },
    {
        text: "Escrow V2",
        Icon: (0, $38dab3c6fe494658$export$2e2bcd8739ae039),
        url: "https://escrow-v2.kleros.builders/"
    },
    {
        text: "Court V1",
        Icon: (0, $c62dc91ec117256f$export$2e2bcd8739ae039),
        url: "https://court.kleros.io/"
    },
    {
        text: "Curate V1",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($72e592d8fb227650$exports))),
        url: "https://curate.kleros.io"
    },
    {
        text: "Resolver V1",
        Icon: (0, $6f166477f0696511$export$2e2bcd8739ae039),
        url: "https://resolve.kleros.io"
    },
    {
        text: "Escrow V1",
        Icon: (0, $38dab3c6fe494658$export$2e2bcd8739ae039),
        url: "https://escrow.kleros.io"
    },
    {
        text: "Vea",
        Icon: (0, $1206cf082369d573$export$2e2bcd8739ae039),
        url: "https://veascan.io"
    },
    {
        text: "Kleros Scout",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($72e592d8fb227650$exports))),
        url: "https://klerosscout.eth.limo"
    },
    {
        text: "POH V1",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7f2e8e1f9165ead5$exports))),
        url: "https://app.proofofhumanity.id"
    },
    {
        text: "Governor",
        Icon: (0, $1fcfcf3c6fbc93f1$export$2e2bcd8739ae039),
        url: "https://governor.kleros.io"
    }
];
const $fd49b2724862d581$var$DappList = ({ toggleIsDappListOpen: toggleIsDappListOpen })=>{
    const containerRef = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsDappListOpen());
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($fd49b2724862d581$var$Container, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($fd49b2724862d581$var$Header, {
                children: "Kleros Solutions"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($fd49b2724862d581$var$ItemsDiv, {
                children: $fd49b2724862d581$var$ITEMS.map((item)=>{
                    return /*#__PURE__*/ (0, $dup7A.createElement)((0, $49880716436ea8c4$export$2e2bcd8739ae039), {
                        ...item,
                        key: item.text
                    });
                })
            })
        ]
    });
};
var $fd49b2724862d581$export$2e2bcd8739ae039 = $fd49b2724862d581$var$DappList;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $9b95a0ecb98a3f27$var$SvgHamburger = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M.571 3.292H15.43A.577.577 0 0 0 16 2.708V1.25a.577.577 0 0 0-.571-.583H.57A.577.577 0 0 0 0 1.25v1.458c0 .323.256.584.571.584Zm0 5.833H15.43A.577.577 0 0 0 16 8.542V7.083a.577.577 0 0 0-.571-.583H.57A.577.577 0 0 0 0 7.083v1.459c0 .322.256.583.571.583Zm0 5.833H15.43a.577.577 0 0 0 .571-.583v-1.458a.577.577 0 0 0-.571-.584H.57a.577.577 0 0 0-.571.584v1.458c0 .322.256.583.571.583Z"
        })
    });
var $9b95a0ecb98a3f27$export$2e2bcd8739ae039 = $9b95a0ecb98a3f27$var$SvgHamburger;






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");












var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $42dcea694e535d6b$var$SvgDarkMode = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 15,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M8 16a7.985 7.985 0 0 0 6.214-2.962.375.375 0 0 0-.361-.605c-3.881.74-7.446-2.237-7.446-6.155A6.264 6.264 0 0 1 9.58.828a.375.375 0 0 0-.117-.694A8 8 0 0 0 0 8a8 8 0 0 0 8 8Z"
        })
    });
var $42dcea694e535d6b$export$2e2bcd8739ae039 = $42dcea694e535d6b$var$SvgDarkMode;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $1265c0970d93b919$var$SvgHelp = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M8 0a8.001 8.001 0 0 0 0 16A8.001 8.001 0 0 0 8 0Zm0 14.452A6.448 6.448 0 0 1 1.548 8 6.45 6.45 0 0 1 8 1.548 6.45 6.45 0 0 1 14.452 8 6.448 6.448 0 0 1 8 14.452Zm3.46-8.233c0 2.163-2.337 2.197-2.337 2.996v.204a.387.387 0 0 1-.387.387H7.264a.387.387 0 0 1-.387-.387V9.14c0-1.153.874-1.614 1.534-1.984.567-.318.914-.534.914-.955 0-.556-.71-.925-1.283-.925-.748 0-1.094.354-1.579.967a.387.387 0 0 1-.538.068l-.897-.68a.388.388 0 0 1-.085-.528c.762-1.12 1.732-1.748 3.244-1.748 1.583 0 3.273 1.235 3.273 2.864Zm-2.105 5.394c0 .747-.608 1.355-1.355 1.355a1.356 1.356 0 0 1-1.355-1.355c0-.747.608-1.355 1.355-1.355s1.355.608 1.355 1.355Z"
        })
    });
var $1265c0970d93b919$export$2e2bcd8739ae039 = $1265c0970d93b919$var$SvgHelp;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $f20ea3b89e32b614$var$SvgLightMode = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 17,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M8.769 5c-1.654 0-3 1.347-3 3s1.346 3 3 3c1.653 0 3-1.347 3-3s-1.347-3-3-3Zm7.7 2.516-2.96-1.479L14.556 2.9a.54.54 0 0 0-.684-.684l-3.138 1.046L9.253.3c-.2-.4-.769-.4-.969 0L6.806 3.26l-3.14-1.047a.54.54 0 0 0-.685.684l1.047 3.137-2.96 1.482c-.4.2-.4.768 0 .968l2.96 1.479-1.047 3.14a.54.54 0 0 0 .684.684l3.138-1.046L8.28 15.7c.2.4.769.4.969 0l1.478-2.96 3.137 1.047a.54.54 0 0 0 .685-.684l-1.047-3.137 2.96-1.478a.542.542 0 0 0 .006-.972Zm-4.872 3.312a4.004 4.004 0 0 1-5.657 0 4.004 4.004 0 0 1 0-5.656 4.004 4.004 0 0 1 5.657 0 4.004 4.004 0 0 1 0 5.656Z"
        })
    });
var $f20ea3b89e32b614$export$2e2bcd8739ae039 = $f20ea3b89e32b614$var$SvgLightMode;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $bf1c88efb279c348$var$SvgNotifications = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 14,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M13.68 11.322c-.6-.65-1.726-1.625-1.726-4.822 0-2.428-1.697-4.372-3.984-4.849V1c0-.552-.446-1-.996-1a.998.998 0 0 0-.995 1v.651C3.69 2.128 1.995 4.071 1.995 6.5c0 3.197-1.125 4.173-1.727 4.822A1 1 0 0 0 1 13h11.95a.999.999 0 0 0 .732-1.678ZM2.104 11.5c.66-.874 1.383-2.323 1.386-4.982L3.487 6.5c0-1.933 1.561-3.5 3.487-3.5a3.493 3.493 0 0 1 3.488 3.5l-.002.018c.003 2.66.725 4.108 1.386 4.982H2.103ZM6.974 16c1.1 0 1.992-.895 1.992-2H4.983c0 1.105.892 2 1.991 2Z"
        })
    });
var $bf1c88efb279c348$export$2e2bcd8739ae039 = $bf1c88efb279c348$var$SvgNotifications;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $3dcdc748314733a0$var$SvgSettings = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m15.121 9.923-1.374-.794a6.214 6.214 0 0 0 0-2.264l1.374-.794a.39.39 0 0 0 .178-.452 8.033 8.033 0 0 0-1.765-3.051.388.388 0 0 0-.477-.074l-1.375.793a6.087 6.087 0 0 0-1.96-1.132V.57a.386.386 0 0 0-.304-.377 8.11 8.11 0 0 0-3.523 0 .386.386 0 0 0-.303.377v1.587A6.28 6.28 0 0 0 3.631 3.29L2.26 2.497a.383.383 0 0 0-.478.074A7.986 7.986 0 0 0 .018 5.623a.386.386 0 0 0 .177.451l1.375.794a6.214 6.214 0 0 0 0 2.264l-1.375.794a.39.39 0 0 0-.177.451 8.034 8.034 0 0 0 1.764 3.052.388.388 0 0 0 .478.074l1.374-.793c.577.496 1.242.88 1.961 1.132v1.587c0 .18.126.339.304.377a8.11 8.11 0 0 0 3.522 0 .386.386 0 0 0 .303-.377v-1.587a6.28 6.28 0 0 0 1.962-1.132l1.374.793c.158.09.355.062.477-.074a7.985 7.985 0 0 0 1.765-3.052.398.398 0 0 0-.18-.454Zm-7.464.654a2.584 2.584 0 0 1-2.581-2.58 2.584 2.584 0 0 1 2.58-2.58 2.584 2.584 0 0 1 2.581 2.58 2.584 2.584 0 0 1-2.58 2.58Z"
        })
    });
var $3dcdc748314733a0$export$2e2bcd8739ae039 = $3dcdc748314733a0$var$SvgSettings;





const $07046d9cbcd57953$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;

  flex-direction: column;
  gap: 0px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      gap: 8px;
    `)}
`;
const $07046d9cbcd57953$var$ButtonContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  min-height: 32px;
  display: flex;
  align-items: center;

  button {
    padding: 0px;
  }

  .button-text {
    display: block;
  }

  .button-svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      .button-svg {
        fill: ${({ theme: theme })=>theme.white};
      }
      .button-text {
        display: none;
      }
    `)}
`;
const $07046d9cbcd57953$var$Menu = ({ toggleIsHelpOpen: toggleIsHelpOpen, toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [theme, toggleTheme] = (0, $56d2a25ae1caf5b4$export$c07acc0415d9f757)();
    const isLightTheme = theme === "light";
    const buttons = [
        {
            text: "Notifications",
            Icon: (0, $bf1c88efb279c348$export$2e2bcd8739ae039)
        },
        {
            text: "Settings",
            Icon: (0, $3dcdc748314733a0$export$2e2bcd8739ae039),
            onClick: ()=>toggleIsSettingsOpen()
        },
        {
            text: "Help",
            Icon: (0, $1265c0970d93b919$export$2e2bcd8739ae039),
            onClick: ()=>{
                toggleIsHelpOpen();
            }
        },
        {
            text: `${isLightTheme ? "Dark" : "Light"} Mode`,
            Icon: isLightTheme ? (0, $42dcea694e535d6b$export$2e2bcd8739ae039) : (0, $f20ea3b89e32b614$export$2e2bcd8739ae039),
            onClick: ()=>toggleTheme()
        }
    ];
    return /*#__PURE__*/ (0, $cZGFG.jsx)($07046d9cbcd57953$var$Container, {
        children: buttons.map(({ text: text, Icon: Icon, onClick: onClick })=>/*#__PURE__*/ (0, $cZGFG.jsx)($07046d9cbcd57953$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d86601acd95afa87$export$2e2bcd8739ae039), {
                    text: text,
                    onClick: onClick,
                    Icon: Icon
                })
            }, Icon))
    });
};
var $07046d9cbcd57953$export$2e2bcd8739ae039 = $07046d9cbcd57953$var$Menu;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $479b94db725a216f$var$SvgBookOpen = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M15.062 2.002c-1.523.087-4.548.405-6.416 1.563a.434.434 0 0 0-.202.37V14.17c0 .325.351.53.647.38 1.921-.98 4.7-1.247 6.075-1.32a.872.872 0 0 0 .834-.862V2.865a.875.875 0 0 0-.938-.863ZM7.354 3.565C5.486 2.407 2.46 2.089.938 2.002A.876.876 0 0 0 0 2.865v9.502c0 .457.365.838.834.862 1.375.073 4.155.34 6.077 1.32.295.151.645-.054.645-.378V3.931a.425.425 0 0 0-.202-.366Z",
            fill: "#9013FE"
        })
    });
var $479b94db725a216f$export$2e2bcd8739ae039 = $479b94db725a216f$var$SvgBookOpen;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $65c4ca3a896442f8$var$SvgBook = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M14.838 11.25V.75c0-.416-.33-.75-.741-.75H3.965C2.328 0 1 1.344 1 3v10c0 1.656 1.328 3 2.965 3h10.132c.41 0 .74-.334.74-.75v-.5a.76.76 0 0 0-.274-.584c-.13-.482-.13-1.854 0-2.335a.748.748 0 0 0 .275-.581ZM4.954 4.187c0-.103.083-.187.185-.187h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.188v-.625Zm0 2c0-.103.083-.187.185-.187h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.188v-.625ZM12.78 14H3.965a.993.993 0 0 1-.988-1c0-.55.445-1 .988-1h8.816a11.38 11.38 0 0 0 0 2Z"
        })
    });
var $65c4ca3a896442f8$export$2e2bcd8739ae039 = $65c4ca3a896442f8$var$SvgBook;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $49273a0aaa543c8e$var$SvgBug = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('1e6d34a1a39ad85c')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M16 9.028a1.013 1.013 0 0 1-1.02.972h-1.73v.5c0 .683-.153 1.33-.425 1.91l1.882 1.883a1 1 0 0 1-1.414 1.414l-1.71-1.71A4.48 4.48 0 0 1 8.75 15V7.375A.375.375 0 0 0 8.375 7h-.75a.375.375 0 0 0-.375.375V15a4.48 4.48 0 0 1-2.832-1.003l-1.71 1.71a1 1 0 0 1-1.415-1.414l1.882-1.882A4.483 4.483 0 0 1 2.75 10.5V10H1.02A1.014 1.014 0 0 1 0 9.028 1 1 0 0 1 1 8h1.75V6.164L1.293 4.707a1 1 0 0 1 1.414-1.414L4.414 5h7.172l1.707-1.707a1 1 0 0 1 1.414 1.414L13.25 6.164V8H15a1 1 0 0 1 1 1.028ZM8.03 0a3.5 3.5 0 0 0-3.5 3.5h7a3.5 3.5 0 0 0-3.5-3.5Z"
            })
        })
    });
var $49273a0aaa543c8e$export$2e2bcd8739ae039 = $49273a0aaa543c8e$var$SvgBug;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $ef68e50e48a94340$var$SvgEth = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m12.445 8.15-4.72 2.9L3 8.15 7.724 0l4.721 8.15Zm-4.72 3.831L3 9.081 7.724 16l4.725-6.919-4.725 2.9Z",
            fill: "#9013FE"
        })
    });
var $ef68e50e48a94340$export$2e2bcd8739ae039 = $ef68e50e48a94340$var$SvgEth;






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $cd219089a705fca1$var$SvgBookOpen = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M15.062 2.002c-1.523.087-4.548.405-6.416 1.563a.434.434 0 0 0-.202.37V14.17c0 .325.351.53.647.38 1.921-.98 4.7-1.247 6.075-1.32a.872.872 0 0 0 .834-.862V2.865a.875.875 0 0 0-.938-.863ZM7.354 3.565C5.486 2.407 2.46 2.089.938 2.002A.876.876 0 0 0 0 2.865v9.502c0 .457.365.838.834.862 1.375.073 4.155.34 6.077 1.32.295.151.645-.054.645-.378V3.931a.425.425 0 0 0-.202-.366Z",
            fill: "#9013FE"
        })
    });
var $cd219089a705fca1$export$2e2bcd8739ae039 = $cd219089a705fca1$var$SvgBookOpen;






const $9db2adaee1ed50ba$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: ${({ isVisible: isVisible })=>isVisible ? "flex" : "none"};
  margin: 0 auto;
  z-index: 10;
  position: fixed;
  width: 86vw;
  flex-direction: column;

  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 80vh;
  overflow-y: auto;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      overflow-y: hidden;
      top: 50%;
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(700, 900)};
      flex-direction: row;
      height: 500px;
    `)}
`;
const $9db2adaee1ed50ba$var$LeftContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: 86vw;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 32)};
  padding-bottom: 32px;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      overflow-y: hidden;
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(350, 450)};
      height: 500px;
    `)}
`;
const $9db2adaee1ed50ba$var$LeftContainerHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const $9db2adaee1ed50ba$var$HowItWorks = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 64)};

  label {
    color: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $9db2adaee1ed50ba$var$MobileCompactPagination = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.CompactPagination))`
  display: flex;
  align-items: flex-start;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $9db2adaee1ed50ba$var$DesktopCompactPagination = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.CompactPagination))`
  display: none;
  align-self: end;
  justify-self: end;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: block;
    `)}
`;
const $9db2adaee1ed50ba$var$Close = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: none;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: flex;
      position: absolute;
      top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 32)};
      right: 17px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      cursor: pointer;
      z-index: 11;

      &:hover {
        text-decoration: underline;
      }

      color: ${({ theme: theme })=>theme.primaryBlue};
    `)}
`;
const $9db2adaee1ed50ba$var$RightContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 86vw;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 32)} 17px;
  background-color: ${({ theme: theme })=>theme.mediumBlue};
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      overflow-y: hidden;
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(350, 450)};
      height: 500px;
    `)}
`;
const $9db2adaee1ed50ba$var$Template = ({ onClose: onClose, LeftContent: LeftContent, RightContent: RightContent, currentPage: currentPage, setCurrentPage: setCurrentPage, numPages: numPages, isOnboarding: isOnboarding, canClose: canClose, isVisible: isVisible })=>{
    const containerRef = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(containerRef, ()=>{
        if (canClose) onClose();
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($9db2adaee1ed50ba$var$Container, {
                ref: containerRef,
                isVisible: isVisible,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($9db2adaee1ed50ba$var$LeftContainer, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($9db2adaee1ed50ba$var$LeftContainerHeader, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsxs)($9db2adaee1ed50ba$var$HowItWorks, {
                                        children: [
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cd219089a705fca1$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                                                children: [
                                                    " ",
                                                    isOnboarding ? "Onboarding" : "How it works",
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($9db2adaee1ed50ba$var$MobileCompactPagination, {
                                        currentPage: currentPage,
                                        callback: setCurrentPage,
                                        numPages: numPages,
                                        label: `${currentPage}/${numPages}`
                                    })
                                ]
                            }),
                            LeftContent,
                            /*#__PURE__*/ (0, $cZGFG.jsx)($9db2adaee1ed50ba$var$DesktopCompactPagination, {
                                currentPage: currentPage,
                                callback: setCurrentPage,
                                numPages: numPages,
                                label: `${currentPage}/${numPages}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($9db2adaee1ed50ba$var$RightContainer, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($9db2adaee1ed50ba$var$Close, {
                                onClick: onClose,
                                children: "Close"
                            }),
                            RightContent
                        ]
                    })
                ]
            })
        ]
    });
};
var $9db2adaee1ed50ba$export$2e2bcd8739ae039 = $9db2adaee1ed50ba$var$Template;


const $8aa581884201f03c$export$4ba4e35c90a816bf = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 18px;
  flex-direction: column;
`;
const $8aa581884201f03c$export$f99233281efd08a0 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: 0;
`;
const $8aa581884201f03c$export$a9defefbe3aca701 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 18px;
  flex-direction: column;
`;
const $8aa581884201f03c$export$7722b1870d9eec03 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(260, 460)};
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: 389px;
    `)}
`;
const $8aa581884201f03c$var$LinksContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $8aa581884201f03c$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryBlue};
  margin: 0;
  cursor: pointer;
`;
const $8aa581884201f03c$var$extractGuideName = (linkText)=>linkText.split(". ")[1];
const $8aa581884201f03c$var$LeftContent = ({ currentPage: currentPage, leftPageContents: leftPageContents, toggleSubMiniGuide: toggleSubMiniGuide })=>{
    const { title: title, paragraphs: paragraphs, links: links } = leftPageContents[currentPage - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($8aa581884201f03c$export$a9defefbe3aca701, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$export$f99233281efd08a0, {
                children: title
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$export$4ba4e35c90a816bf, {
                children: paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: paragraph
                    }, index))
            }),
            links && links.length > 0 && toggleSubMiniGuide ? /*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$var$LinksContainer, {
                children: links.map((link, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$var$StyledLabel, {
                        onClick: ()=>toggleSubMiniGuide($8aa581884201f03c$var$extractGuideName(link)),
                        children: link
                    }, index))
            }) : null
        ]
    });
};
const $8aa581884201f03c$var$RightContent = ({ currentPage: currentPage, rightPageComponents: rightPageComponents })=>{
    const RightPageComponent = rightPageComponents[currentPage - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsx)(RightPageComponent, {});
};
const $8aa581884201f03c$var$PageContentsTemplate = ({ toggleMiniGuide: toggleMiniGuide, toggleSubMiniGuide: toggleSubMiniGuide, leftPageContents: leftPageContents, rightPageComponents: rightPageComponents, canClose: canClose, isVisible: isVisible, isOnboarding: isOnboarding })=>{
    const [currentPage, setCurrentPage] = (0, $dup7A.useState)(1);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9db2adaee1ed50ba$export$2e2bcd8739ae039), {
        LeftContent: /*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$var$LeftContent, {
            currentPage: currentPage,
            leftPageContents: leftPageContents,
            toggleSubMiniGuide: toggleSubMiniGuide
        }),
        RightContent: /*#__PURE__*/ (0, $cZGFG.jsx)($8aa581884201f03c$var$RightContent, {
            currentPage: currentPage,
            rightPageComponents: rightPageComponents
        }),
        onClose: toggleMiniGuide,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        numPages: leftPageContents.length,
        isOnboarding: isOnboarding,
        canClose: canClose,
        isVisible: isVisible
    });
};
var $8aa581884201f03c$export$2e2bcd8739ae039 = $8aa581884201f03c$var$PageContentsTemplate;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $9930f08bd73a09be$var$SvgCrowdfundAppeal = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 373 255",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 0.412,
                y: 0.412,
                width: 372.177,
                height: 253.607,
                rx: 2.058,
                className: "crowdfund-appeal_svg__rect-bg"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M34.213 35.016c-1.325 0-2.367.47-3.126 1.409-.76.939-1.139 2.235-1.139 3.888 0 1.73.363 3.04 1.09 3.928.734.887 1.792 1.331 3.175 1.331a8.55 8.55 0 0 0 1.737-.174c.56-.122 1.142-.276 1.746-.463v1.978c-1.106.419-2.36.628-3.763.628-2.065 0-3.65-.624-4.757-1.872-1.106-1.255-1.66-3.046-1.66-5.375 0-1.467.267-2.75.801-3.85.54-1.1 1.319-1.943 2.335-2.528 1.017-.585 2.21-.878 3.58-.878 1.441 0 2.773.302 3.995.907l-.83 1.92a11.746 11.746 0 0 0-1.515-.589 5.303 5.303 0 0 0-1.669-.26Zm11.695 1.467c.457 0 .833.032 1.129.096l-.222 2.113a4.286 4.286 0 0 0-1.004-.115c-.907 0-1.643.295-2.21.887-.559.592-.839 1.36-.839 2.306v5.578h-2.267V36.676h1.775l.3 1.881h.115a4.245 4.245 0 0 1 1.38-1.515 3.315 3.315 0 0 1 1.843-.56Zm12.582 5.51c0 1.743-.447 3.103-1.34 4.081-.895.978-2.14 1.467-3.735 1.467-.997 0-1.879-.225-2.644-.676-.766-.45-1.354-1.097-1.766-1.94-.412-.842-.617-1.82-.617-2.933 0-1.73.444-3.081 1.331-4.052.888-.972 2.14-1.457 3.754-1.457 1.544 0 2.766.498 3.666 1.495.901.99 1.351 2.329 1.351 4.014Zm-7.767 0c0 2.463.91 3.695 2.73 3.695 1.802 0 2.702-1.232 2.702-3.696 0-2.438-.907-3.657-2.72-3.657-.953 0-1.644.316-2.075.946-.425.63-.637 1.534-.637 2.711Zm19.134 5.355-1.38-4.98c-.167-.527-.47-1.752-.907-3.676h-.086c-.374 1.737-.67 2.97-.888 3.696l-1.419 4.96h-2.509l-2.99-10.672h2.315l1.36 5.258c.31 1.3.528 2.413.657 3.34h.058c.064-.47.16-1.008.29-1.612.134-.611.25-1.068.346-1.37l1.622-5.616h2.49l1.572 5.615c.096.316.215.798.357 1.448.148.65.235 1.155.26 1.515h.078c.096-.791.321-1.898.675-3.32l1.38-5.258h2.277l-3.01 10.672h-2.548Zm11 .193c-1.331 0-2.37-.483-3.116-1.448-.747-.965-1.12-2.319-1.12-4.062 0-1.75.377-3.11 1.13-4.082.758-.977 1.807-1.466 3.145-1.466 1.402 0 2.47.518 3.203 1.553h.116c-.11-.765-.164-1.37-.164-1.814v-3.889h2.277v15.015h-1.775l-.396-1.4h-.106c-.727 1.062-1.791 1.593-3.194 1.593Zm.608-1.834c.933 0 1.612-.26 2.036-.781.425-.528.643-1.38.656-2.557v-.319c0-1.344-.218-2.3-.656-2.866-.437-.566-1.122-.849-2.055-.849-.798 0-1.412.325-1.843.975-.431.643-.647 1.563-.647 2.76 0 1.183.21 2.087.628 2.711.418.617 1.045.926 1.881.926Zm13.46-7.314h-2.604v8.955h-2.278v-8.955h-1.756v-1.061l1.756-.695v-.695c0-1.26.296-2.193.888-2.798.592-.611 1.496-.917 2.712-.917.797 0 1.582.132 2.354.396l-.598 1.718a5.228 5.228 0 0 0-1.602-.27c-.515 0-.891.16-1.13.482-.23.315-.346.791-.346 1.428v.695h2.605v1.717Zm9.351 8.955-.318-1.4h-.116c-.315.496-.766.885-1.351 1.168-.579.283-1.242.425-1.988.425-1.293 0-2.258-.322-2.895-.965-.636-.644-.955-1.618-.955-2.924v-6.976h2.287v6.58c0 .817.167 1.432.502 1.843.334.406.858.608 1.572.608.953 0 1.651-.283 2.094-.849.451-.572.676-1.528.676-2.866v-5.316h2.277v10.672h-1.785Zm14.406 0h-2.277v-6.562c0-.823-.167-1.438-.502-1.843-.328-.405-.852-.608-1.573-.608-.958 0-1.659.283-2.103.85-.444.566-.666 1.514-.666 2.846v5.317h-2.267V36.676h1.775l.318 1.399h.116c.322-.508.779-.9 1.37-1.177a4.592 4.592 0 0 1 1.969-.415c2.56 0 3.84 1.302 3.84 3.908v6.957Zm6.755.193c-1.332 0-2.371-.483-3.117-1.448s-1.119-2.319-1.119-4.062c0-1.75.376-3.11 1.129-4.082.759-.977 1.807-1.466 3.145-1.466 1.403 0 2.47.518 3.204 1.553h.116c-.11-.765-.164-1.37-.164-1.814v-3.889h2.277v15.015h-1.776l-.395-1.4h-.106c-.727 1.062-1.792 1.593-3.194 1.593Zm.608-1.834c.932 0 1.611-.26 2.036-.781.424-.528.643-1.38.656-2.557v-.319c0-1.344-.219-2.3-.656-2.866-.438-.566-1.123-.849-2.056-.849-.797 0-1.412.325-1.843.975-.431.643-.646 1.563-.646 2.76 0 1.183.209 2.087.627 2.711.418.617 1.045.926 1.882.926Zm10.372 1.64h-2.267V36.677h2.267v10.672Zm-2.402-13.499c0-.405.109-.717.328-.936.225-.218.543-.328.955-.328.399 0 .708.11.926.328.226.22.338.531.338.936 0 .386-.112.692-.338.917-.218.219-.527.328-.926.328-.412 0-.73-.11-.955-.328-.219-.225-.328-.53-.328-.917Zm15.043 13.5h-2.277v-6.562c0-.823-.168-1.438-.502-1.843-.328-.405-.852-.608-1.573-.608-.958 0-1.66.283-2.103.85-.444.566-.666 1.514-.666 2.846v5.317h-2.268V36.676h1.776l.318 1.399h.116c.322-.508.778-.9 1.37-1.177a4.592 4.592 0 0 1 1.969-.415c2.56 0 3.84 1.302 3.84 3.908v6.957Zm12.168-10.672v1.244l-1.824.338c.167.225.305.502.415.83.109.328.164.675.164 1.042 0 1.1-.38 1.965-1.139 2.596-.759.63-1.804.945-3.136.945a5.08 5.08 0 0 1-.926-.077c-.489.303-.733.656-.733 1.062a.59.59 0 0 0 .337.55c.232.122.653.183 1.264.183h1.863c1.177 0 2.071.25 2.682.752.611.502.917 1.226.917 2.172 0 1.209-.499 2.142-1.496 2.798-.997.656-2.438.984-4.323.984-1.453 0-2.563-.257-3.329-.772-.765-.514-1.148-1.248-1.148-2.2 0-.656.206-1.21.618-1.66.418-.443 1-.752 1.746-.926a1.743 1.743 0 0 1-.752-.617 1.612 1.612 0 0 1-.29-.907c0-.4.113-.737.338-1.014.225-.276.559-.55 1.003-.82a3.014 3.014 0 0 1-1.351-1.158c-.341-.54-.511-1.17-.511-1.891 0-1.158.363-2.055 1.09-2.692.734-.637 1.776-.955 3.127-.955.302 0 .617.022.945.067.335.039.586.08.753.126h3.696Zm-8.386 12.331c0 .49.219.866.657 1.13.443.263 1.064.395 1.862.395 1.235 0 2.155-.177 2.76-.53.604-.355.907-.824.907-1.41 0-.463-.168-.794-.502-.993-.328-.193-.943-.29-1.843-.29h-1.718c-.649 0-1.167.151-1.553.454-.38.308-.57.723-.57 1.244Zm.975-8.877c0 .67.17 1.184.511 1.544.348.36.843.54 1.486.54 1.313 0 1.969-.7 1.969-2.103 0-.695-.164-1.229-.492-1.602-.322-.38-.814-.57-1.477-.57-.656 0-1.154.187-1.495.56-.335.373-.502.917-.502 1.631Zm18.507 5.577a5.52 5.52 0 0 0 1.66-.26v1.708c-.251.109-.576.2-.975.27a6.332 6.332 0 0 1-1.225.116c-2.149 0-3.223-1.133-3.223-3.397v-5.75h-1.457V37.39l1.563-.83.772-2.258h1.399v2.374h3.04v1.717h-3.04v5.712c0 .547.135.953.405 1.216.277.258.637.386 1.081.386Zm13.191 1.64h-2.278v-6.56c0-.824-.167-1.438-.501-1.844-.328-.405-.853-.608-1.573-.608-.952 0-1.653.287-2.104.86-.444.565-.665 1.517-.665 2.855v5.298h-2.268V32.334h2.268v3.81c0 .612-.039 1.265-.116 1.96h.144a3.158 3.158 0 0 1 1.284-1.197c.553-.283 1.196-.424 1.93-.424 2.586 0 3.879 1.302 3.879 3.908v6.957Zm7.816.194c-1.66 0-2.96-.483-3.899-1.448-.933-.971-1.399-2.306-1.399-4.004 0-1.743.434-3.114 1.303-4.11.868-.998 2.061-1.496 3.58-1.496 1.408 0 2.521.427 3.338 1.283.817.856 1.226 2.033 1.226 3.532v1.225h-7.112c.032 1.036.312 1.833.84 2.393.527.553 1.27.83 2.229.83.63 0 1.215-.058 1.756-.174a9.448 9.448 0 0 0 1.756-.598v1.843a6.96 6.96 0 0 1-1.679.56c-.566.109-1.213.164-1.939.164Zm-.415-9.34c-.721 0-1.3.228-1.737.684-.431.457-.689 1.123-.772 1.998h4.844c-.013-.882-.225-1.547-.637-1.998-.412-.456-.978-.685-1.698-.685Zm21.266 9.147-1.408-3.918h-5.394l-1.38 3.918h-2.432l5.278-14.165h2.509l5.278 14.165h-2.451Zm-2.016-5.906-1.322-3.84a24.72 24.72 0 0 1-.405-1.216 29.21 29.21 0 0 1-.348-1.216 21.585 21.585 0 0 1-.762 2.596l-1.274 3.676h4.111Zm11.502 6.099c-1.351 0-2.4-.486-3.146-1.457h-.135c.09.9.135 1.447.135 1.64v4.371h-2.268v-15.42h1.834c.051.2.157.676.318 1.429h.116c.708-1.081 1.769-1.621 3.184-1.621 1.332 0 2.368.482 3.107 1.447.747.965 1.12 2.32 1.12 4.062 0 1.744-.38 3.104-1.139 4.082-.753.978-1.795 1.467-3.126 1.467Zm-.55-9.206c-.901 0-1.56.264-1.978.791-.412.528-.618 1.37-.618 2.529v.337c0 1.3.206 2.242.618 2.828.411.578 1.083.868 2.016.868.785 0 1.39-.322 1.814-.965.425-.643.637-1.56.637-2.75 0-1.197-.212-2.1-.637-2.711-.418-.618-1.035-.927-1.852-.927Zm12.862 9.206c-1.351 0-2.399-.486-3.146-1.457h-.135c.09.9.135 1.447.135 1.64v4.371h-2.267v-15.42h1.833c.052.2.158.676.319 1.429h.115c.708-1.081 1.769-1.621 3.185-1.621 1.331 0 2.367.482 3.107 1.447.746.965 1.119 2.32 1.119 4.062 0 1.744-.38 3.104-1.139 4.082-.752.978-1.794 1.467-3.126 1.467Zm-.55-9.206c-.901 0-1.56.264-1.978.791-.412.528-.618 1.37-.618 2.529v.337c0 1.3.206 2.242.618 2.828.412.578 1.084.868 2.017.868.784 0 1.389-.322 1.814-.965.424-.643.637-1.56.637-2.75 0-1.197-.213-2.1-.637-2.711-.418-.618-1.036-.927-1.853-.927Zm12.11 9.206c-1.66 0-2.959-.483-3.898-1.448-.933-.971-1.4-2.306-1.4-4.004 0-1.743.435-3.114 1.303-4.11.868-.998 2.062-1.496 3.58-1.496 1.409 0 2.522.427 3.339 1.283.816.856 1.225 2.033 1.225 3.532v1.225h-7.111c.032 1.036.312 1.833.839 2.393.527.553 1.27.83 2.229.83.63 0 1.216-.058 1.756-.174a9.448 9.448 0 0 0 1.756-.598v1.843a6.96 6.96 0 0 1-1.679.56c-.566.109-1.212.164-1.939.164Zm-.415-9.34c-.721 0-1.3.228-1.737.684-.431.457-.688 1.123-.772 1.998h4.844c-.013-.882-.225-1.547-.637-1.998-.412-.456-.978-.685-1.698-.685Zm13.818 9.147-.454-1.486h-.077c-.515.65-1.033 1.093-1.554 1.331-.521.232-1.19.348-2.007.348-1.048 0-1.868-.283-2.46-.85-.586-.566-.878-1.367-.878-2.402 0-1.1.408-1.93 1.225-2.49.817-.56 2.062-.865 3.734-.916l1.843-.058v-.57c0-.681-.16-1.19-.482-1.524-.315-.341-.807-.512-1.476-.512-.547 0-1.071.08-1.573.242-.502.16-.984.35-1.448.569l-.733-1.621a7.755 7.755 0 0 1 1.901-.685 8.58 8.58 0 0 1 1.949-.241c1.357 0 2.38.296 3.069.887.694.592 1.042 1.522 1.042 2.789v7.189h-1.621Zm-3.378-1.544c.824 0 1.483-.229 1.978-.685.502-.463.753-1.11.753-1.94v-.926l-1.37.058c-1.068.038-1.846.218-2.335.54-.483.315-.724.801-.724 1.457 0 .476.142.846.425 1.11.283.257.707.386 1.273.386Zm10.431 1.544h-2.267V32.334h2.267v15.014Z",
                className: "crowdfund-appeal_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 26.753,
                y: 191.783,
                width: 319.844,
                height: 35.538,
                rx: 2.019,
                className: "crowdfund-appeal_svg__rect-fg"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M46.4 208.543c0 1.625-.258 2.839-.772 3.641-.51.801-1.293 1.202-2.348 1.202-1.012 0-1.782-.409-2.31-1.228-.527-.824-.79-2.029-.79-3.615 0-1.639.254-2.854.765-3.648.51-.793 1.288-1.19 2.335-1.19 1.02 0 1.794.414 2.322 1.242.532.827.798 2.026.798 3.596Zm-5.14 0c0 1.368.16 2.365.482 2.991.322.622.834.933 1.538.933.712 0 1.226-.316 1.544-.946.321-.635.482-1.628.482-2.978 0-1.351-.16-2.34-.482-2.966-.318-.63-.832-.946-1.544-.946-.704 0-1.216.311-1.538.933-.321.618-.482 1.611-.482 2.979Zm6.78 4.033c0-.287.064-.504.193-.65.133-.15.322-.225.566-.225.249 0 .442.075.579.225.142.146.212.363.212.65 0 .279-.07.493-.212.643-.142.15-.334.225-.579.225a.78.78 0 0 1-.547-.199c-.141-.137-.212-.36-.212-.669Zm9.411-4.033c0 1.625-.257 2.839-.772 3.641-.51.801-1.293 1.202-2.348 1.202-1.012 0-1.782-.409-2.31-1.228-.527-.824-.79-2.029-.79-3.615 0-1.639.255-2.854.765-3.648.51-.793 1.289-1.19 2.335-1.19 1.02 0 1.795.414 2.322 1.242.532.827.798 2.026.798 3.596Zm-5.14 0c0 1.368.161 2.365.483 2.991.322.622.834.933 1.537.933.712 0 1.227-.316 1.544-.946.322-.635.483-1.628.483-2.978 0-1.351-.161-2.34-.483-2.966-.317-.63-.832-.946-1.544-.946-.703 0-1.216.311-1.537.933-.322.618-.483 1.611-.483 2.979Zm12.68 0c0 1.625-.258 2.839-.772 3.641-.51.801-1.293 1.202-2.348 1.202-1.013 0-1.782-.409-2.31-1.228-.527-.824-.791-2.029-.791-3.615 0-1.639.255-2.854.765-3.648.51-.793 1.29-1.19 2.336-1.19 1.02 0 1.794.414 2.322 1.242.532.827.797 2.026.797 3.596Zm-5.14 0c0 1.368.16 2.365.482 2.991.322.622.834.933 1.538.933.711 0 1.226-.316 1.543-.946.322-.635.483-1.628.483-2.978 0-1.351-.161-2.34-.483-2.966-.317-.63-.832-.946-1.544-.946-.703 0-1.215.311-1.537.933-.322.618-.482 1.611-.482 2.979Zm13.071 2.553h-1.396v2.162h-1.023v-2.162H65.93v-.932l4.464-6.362h1.132v6.323h1.396v.971Zm-2.419-.971v-3.126c0-.614.022-1.306.065-2.078h-.052a9.618 9.618 0 0 1-.579 1.023l-2.94 4.181h3.506Zm12.647 3.133h-5.243v-9.405h5.243v.971h-4.149v3.03H82.9v.965h-3.898v3.461h4.15v.978Zm4.986 0h-1.094v-8.434h-2.978v-.971h7.05v.971h-2.978v8.434Zm11.54 0h-1.093v-4.426h-4.954v4.426h-1.093v-9.405h1.093v4.001h4.954v-4.001h1.093v9.405Z",
                className: "crowdfund-appeal_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M33.728 177.5h-.957v-3.873h-4.334v3.873h-.957v-8.229h.957v3.501h4.334v-3.501h.957v8.229Zm7.447-3.09c0 1.006-.254 1.792-.76 2.358-.507.563-1.207.845-2.1.845a2.78 2.78 0 0 1-1.469-.389 2.563 2.563 0 0 1-.99-1.114c-.233-.484-.35-1.051-.35-1.7 0-1.006.252-1.788.755-2.347.503-.563 1.2-.845 2.094-.845.863 0 1.548.287 2.054.862.51.574.766 1.35.766 2.33Zm-4.7 0c0 .788.157 1.388.472 1.801.316.413.78.619 1.39.619.612 0 1.076-.204 1.391-.613.319-.413.478-1.015.478-1.807 0-.784-.159-1.379-.478-1.784-.315-.409-.782-.614-1.401-.614-.612 0-1.074.201-1.385.602-.312.402-.467 1-.467 1.796Zm11.38 3.09-1.13-3.619a30.644 30.644 0 0 1-.4-1.509h-.045c-.15.657-.282 1.164-.394 1.52L44.72 177.5H43.64l-1.683-6.169h.98c.397 1.55.7 2.73.906 3.54.21.811.33 1.357.36 1.638h.045a14.868 14.868 0 0 1 .44-1.638l1.13-3.54h1.014l1.103 3.54c.21.646.352 1.188.427 1.627h.045c.016-.135.055-.343.119-.625a608.1 608.1 0 0 1 1.176-4.542h.968l-1.705 6.169h-1.11Zm14.793 0v-4.013c0-.492-.105-.86-.315-1.103-.21-.248-.537-.372-.98-.372-.581 0-1.01.167-1.288.501-.278.334-.417.848-.417 1.542v3.445h-.934v-4.013c0-.492-.105-.86-.316-1.103-.21-.248-.538-.372-.985-.372-.585 0-1.015.176-1.288.529-.27.349-.406.923-.406 1.722v3.237h-.934v-6.169h.76l.152.844h.045c.176-.3.424-.534.743-.703a2.294 2.294 0 0 1 1.08-.254c.965 0 1.595.349 1.892 1.047h.045c.184-.322.45-.578.799-.765a2.476 2.476 0 0 1 1.193-.282c.698 0 1.22.18 1.565.541.349.356.524.928.524 1.716v4.025h-.935Zm3.743-6.169v4.002c0 .503.115.878.344 1.126.228.247.587.371 1.075.371.645 0 1.116-.176 1.412-.529.3-.353.45-.929.45-1.728v-3.242h.935v6.169h-.771l-.135-.827h-.05a1.863 1.863 0 0 1-.8.698 2.663 2.663 0 0 1-1.16.242c-.75 0-1.313-.179-1.688-.535-.372-.357-.557-.927-.557-1.711v-4.036h.945Zm8.668 6.282c-.893 0-1.585-.274-2.076-.822-.488-.552-.732-1.33-.732-2.336 0-1.032.247-1.829.743-2.392.499-.563 1.208-.845 2.127-.845.297 0 .593.032.89.096.296.064.529.139.698.225l-.287.794a4.199 4.199 0 0 0-.676-.203 2.935 2.935 0 0 0-.647-.084c-1.254 0-1.88.799-1.88 2.398 0 .758.152 1.339.456 1.745.308.405.762.607 1.362.607.514 0 1.041-.11 1.582-.332v.828c-.413.214-.933.321-1.56.321Zm7.25-.113v-3.991c0-.503-.114-.878-.343-1.125-.229-.248-.587-.372-1.075-.372-.65 0-1.124.176-1.424.529-.297.353-.445.931-.445 1.734v3.225h-.934v-8.758h.934v2.651c0 .319-.015.583-.045.793h.056c.184-.296.445-.529.783-.697.341-.173.73-.259 1.165-.259.754 0 1.319.18 1.694.54.38.356.569.925.569 1.705v4.025h-.935Zm10.053-.827h-.05c-.432.626-1.078.94-1.937.94-.807 0-1.435-.276-1.885-.828-.447-.551-.67-1.336-.67-2.353 0-1.017.225-1.806.675-2.369.45-.563 1.077-.845 1.88-.845.837 0 1.479.304 1.925.912h.073l-.039-.444-.023-.434v-2.51h.935v8.758h-.76l-.124-.827Zm-1.869.157c.638 0 1.1-.172 1.385-.518.289-.349.433-.91.433-1.683v-.197c0-.874-.146-1.497-.439-1.868-.288-.376-.752-.563-1.39-.563-.548 0-.968.214-1.26.641-.29.424-.434 1.025-.434 1.802 0 .788.144 1.382.433 1.784.29.401.713.602 1.272.602Zm10.065-2.42c0 1.006-.254 1.792-.76 2.358-.507.563-1.207.845-2.1.845a2.78 2.78 0 0 1-1.469-.389 2.563 2.563 0 0 1-.99-1.114c-.233-.484-.35-1.051-.35-1.7 0-1.006.252-1.788.755-2.347.502-.563 1.2-.845 2.093-.845.864 0 1.548.287 2.055.862.51.574.766 1.35.766 2.33Zm-4.7 0c0 .788.157 1.388.472 1.801.316.413.779.619 1.39.619.612 0 1.076-.204 1.39-.613.32-.413.48-1.015.48-1.807 0-.784-.16-1.379-.48-1.784-.314-.409-.781-.614-1.4-.614-.612 0-1.074.201-1.385.602-.312.402-.467 1-.467 1.796Zm8.358-3.079h1.002l1.351 3.518c.296.803.48 1.383.552 1.739h.045c.048-.191.15-.518.304-.979.157-.466.668-1.891 1.531-4.278h1.001l-2.651 7.025c-.262.694-.57 1.185-.923 1.474-.349.293-.778.439-1.289.439-.285 0-.566-.032-.844-.095v-.749c.206.045.437.068.692.068.642 0 1.1-.361 1.374-1.081l.343-.878-2.488-6.203Zm12.113 3.079c0 1.006-.253 1.792-.76 2.358-.506.563-1.206.845-2.099.845-.552 0-1.042-.13-1.469-.389a2.564 2.564 0 0 1-.991-1.114c-.233-.484-.349-1.051-.349-1.7 0-1.006.251-1.788.754-2.347.503-.563 1.201-.845 2.094-.845.863 0 1.548.287 2.055.862.51.574.765 1.35.765 2.33Zm-4.7 0c0 .788.158 1.388.473 1.801.315.413.779.619 1.39.619.612 0 1.075-.204 1.391-.613.319-.413.478-1.015.478-1.807 0-.784-.159-1.379-.478-1.784-.316-.409-.783-.614-1.402-.614-.612 0-1.073.201-1.385.602-.311.402-.467 1-.467 1.796Zm7.222-3.079v4.002c0 .503.114.878.343 1.126.229.247.587.371 1.075.371.646 0 1.117-.176 1.413-.529.3-.353.45-.929.45-1.728v-3.242h.935v6.169h-.771l-.135-.827h-.051a1.869 1.869 0 0 1-.799.698 2.667 2.667 0 0 1-1.16.242c-.75 0-1.313-.179-1.689-.535-.371-.357-.557-.927-.557-1.711v-4.036h.946Zm14.235 6.169-1.132-3.619a31.2 31.2 0 0 1-.399-1.509h-.045c-.15.657-.282 1.164-.394 1.52l-1.165 3.608h-1.081l-1.683-6.169h.979l.907 3.54c.21.811.33 1.357.36 1.638h.045a14.704 14.704 0 0 1 .439-1.638l1.131-3.54h1.013l1.104 3.54c.21.646.352 1.188.427 1.627h.045c.015-.135.055-.343.119-.625.067-.281.459-1.795 1.176-4.542h.968l-1.705 6.169h-1.109Zm7.728 0-.186-.878h-.045c-.307.386-.615.649-.923.788-.304.135-.685.203-1.142.203-.612 0-1.092-.158-1.441-.473-.346-.315-.518-.764-.518-1.345 0-1.246.996-1.899 2.989-1.959l1.047-.034v-.383c0-.484-.106-.84-.316-1.069-.206-.233-.538-.349-.996-.349-.514 0-1.096.157-1.745.473l-.287-.715a4.42 4.42 0 0 1 2.088-.529c.736 0 1.28.163 1.633.489.356.327.534.85.534 1.571v4.21h-.692Zm-2.111-.659c.582 0 1.038-.159 1.368-.478.334-.319.501-.766.501-1.34v-.557l-.934.04c-.743.026-1.28.142-1.61.349-.327.202-.49.519-.49.951 0 .337.101.595.304.771.206.176.494.264.861.264Zm8.956.659v-3.991c0-.503-.115-.878-.344-1.125-.229-.248-.587-.372-1.075-.372-.645 0-1.118.174-1.418.523-.301.349-.451.925-.451 1.728v3.237h-.934v-6.169h.76l.152.844h.045c.191-.304.46-.538.805-.703a2.59 2.59 0 0 1 1.154-.254c.743 0 1.302.18 1.677.541.375.356.563.928.563 1.716v4.025h-.934Zm4.851-.659c.166 0 .325-.011.479-.033.154-.027.276-.053.366-.079v.715a1.7 1.7 0 0 1-.45.118 3.124 3.124 0 0 1-.53.051c-1.193 0-1.79-.629-1.79-1.886v-3.67h-.883v-.45l.883-.389.394-1.317h.541v1.43h1.79v.726h-1.79v3.631c0 .371.088.656.264.855.177.199.419.298.726.298Zm7.07 0c.165 0 .325-.011.479-.033.153-.027.275-.053.365-.079v.715a1.679 1.679 0 0 1-.45.118 3.104 3.104 0 0 1-.529.051c-1.193 0-1.79-.629-1.79-1.886v-3.67h-.884v-.45l.884-.389.394-1.317h.541v1.43h1.789v.726h-1.789v3.631c0 .371.088.656.264.855.176.199.418.298.726.298Zm7.408-2.431c0 1.006-.254 1.792-.76 2.358-.507.563-1.207.845-2.1.845-.551 0-1.041-.13-1.469-.389a2.564 2.564 0 0 1-.991-1.114c-.232-.484-.349-1.051-.349-1.7 0-1.006.252-1.788.755-2.347.503-.563 1.2-.845 2.094-.845.863 0 1.547.287 2.054.862.51.574.766 1.35.766 2.33Zm-4.7 0c0 .788.157 1.388.472 1.801.316.413.779.619 1.391.619.611 0 1.075-.204 1.39-.613.319-.413.478-1.015.478-1.807 0-.784-.159-1.379-.478-1.784-.315-.409-.782-.614-1.402-.614-.611 0-1.073.201-1.384.602-.312.402-.467 1-.467 1.796Zm12.118-2.353h-1.57v5.443h-.935v-5.443h-1.103v-.422l1.103-.338v-.343c0-1.516.663-2.274 1.987-2.274.327 0 .71.065 1.149.197l-.242.748c-.361-.116-.668-.174-.924-.174-.352 0-.613.118-.782.355-.169.232-.253.607-.253 1.125v.4h1.57v.726Zm2.004-.726v4.002c0 .503.114.878.343 1.126.229.247.588.371 1.075.371.646 0 1.117-.176 1.413-.529.3-.353.451-.929.451-1.728v-3.242h.934v6.169h-.771l-.135-.827h-.051a1.863 1.863 0 0 1-.799.698 2.664 2.664 0 0 1-1.16.242c-.75 0-1.313-.179-1.688-.535-.372-.357-.558-.927-.558-1.711v-4.036h.946Zm10.424 6.169v-3.991c0-.503-.114-.878-.343-1.125-.229-.248-.587-.372-1.075-.372-.645 0-1.118.174-1.419.523-.3.349-.45.925-.45 1.728v3.237h-.934v-6.169h.76l.152.844h.045a1.88 1.88 0 0 1 .805-.703 2.586 2.586 0 0 1 1.154-.254c.742 0 1.302.18 1.677.541.375.356.563.928.563 1.716v4.025h-.935Zm7.059-.827h-.051c-.431.626-1.077.94-1.936.94-.807 0-1.435-.276-1.886-.828-.446-.551-.67-1.336-.67-2.353 0-1.017.226-1.806.676-2.369.45-.563 1.077-.845 1.88-.845.837 0 1.478.304 1.925.912h.073l-.039-.444-.023-.434v-2.51h.934v8.758h-.759l-.124-.827Zm-1.869.157c.638 0 1.1-.172 1.385-.518.289-.349.433-.91.433-1.683v-.197c0-.874-.146-1.497-.439-1.868-.289-.376-.752-.563-1.39-.563-.548 0-.968.214-1.261.641-.289.424-.433 1.025-.433 1.802 0 .788.144 1.382.433 1.784.289.401.713.602 1.272.602Zm5.375-1.598v-.304c0-.439.068-.8.203-1.081.135-.285.387-.585.754-.901.511-.431.832-.756.963-.973.135-.218.202-.481.202-.788 0-.383-.123-.678-.371-.884-.244-.21-.597-.315-1.058-.315-.297 0-.586.035-.867.107a4.54 4.54 0 0 0-.968.377l-.332-.76a4.721 4.721 0 0 1 2.223-.557c.717 0 1.274.176 1.672.529.398.352.596.85.596 1.491 0 .274-.037.516-.112.726a2.084 2.084 0 0 1-.321.591c-.143.184-.45.483-.923.895-.379.323-.63.591-.754.805-.12.214-.18.499-.18.856v.186h-.727Zm-.275 1.671c0-.51.225-.765.675-.765.218 0 .385.066.501.197.12.131.18.321.18.568 0 .241-.06.428-.18.563-.12.132-.287.197-.501.197a.693.693 0 0 1-.484-.174c-.128-.12-.191-.315-.191-.586Zm7.058-2.561c0-.994.145-1.925.433-2.792a6.99 6.99 0 0 1 1.261-2.279h.912a8 8 0 0 0-1.221 2.386 8.94 8.94 0 0 0-.406 2.674c0 .901.139 1.781.417 2.64a8.209 8.209 0 0 0 1.199 2.353h-.901a6.646 6.646 0 0 1-1.261-2.235 8.521 8.521 0 0 1-.433-2.747Zm8.668 3.158h-4.587v-8.229h4.587v.85h-3.63v2.651h3.411v.844h-3.411v3.028h3.63v.856Zm4.363 0h-.957v-7.379h-2.606v-.85h6.169v.85h-2.606v7.379Zm10.097 0h-.956v-3.873h-4.335v3.873h-.956v-8.229h.956v3.501h4.335v-3.501h.956v8.229Zm4.081-3.158a8.42 8.42 0 0 1-.439 2.758 6.565 6.565 0 0 1-1.255 2.224h-.901a8.099 8.099 0 0 0 1.199-2.347 8.583 8.583 0 0 0 .417-2.646 8.82 8.82 0 0 0-.411-2.674 7.894 7.894 0 0 0-1.216-2.386h.912c.552.657.972 1.42 1.261 2.291.289.867.433 1.793.433 2.78Z",
                className: "crowdfund-appeal_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 262.541,
                y: 191.023,
                width: 84.698,
                height: 37.053,
                rx: 2.47,
                className: "crowdfund-appeal_svg__rect-accent"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M291.683 214.551h-1.525v-9.405h5.307v1.299h-3.782v2.94h3.544v1.306h-3.544v3.86Zm10.344 0-.212-.933h-.078c-.21.33-.51.59-.9.778a2.976 2.976 0 0 1-1.325.283c-.862 0-1.506-.214-1.93-.643-.425-.429-.637-1.078-.637-1.949v-4.651h1.524v4.387c0 .545.112.954.335 1.229.223.27.572.405 1.049.405.634 0 1.1-.188 1.395-.566.301-.382.451-1.018.451-1.91v-3.545h1.518v7.115h-1.19Zm9.604 0h-1.518v-4.375c0-.548-.112-.958-.335-1.228-.218-.27-.568-.405-1.048-.405-.639 0-1.107.188-1.403.566-.295.377-.443 1.01-.443 1.897v3.545h-1.512v-7.115h1.184l.212.933h.077a2.1 2.1 0 0 1 .913-.785 3.07 3.07 0 0 1 1.313-.277c1.707 0 2.56.869 2.56 2.606v4.638Zm4.503.128c-.888 0-1.58-.321-2.078-.964-.497-.644-.746-1.547-.746-2.709 0-1.166.251-2.073.753-2.721.506-.652 1.205-.978 2.097-.978.935 0 1.646.346 2.135 1.036h.078a9.056 9.056 0 0 1-.11-1.209v-2.593h1.518v10.01h-1.183l-.264-.933h-.071c-.484.708-1.194 1.061-2.129 1.061Zm.405-1.222c.622 0 1.075-.173 1.358-.521.283-.352.428-.92.437-1.705v-.212c0-.896-.146-1.533-.437-1.91-.292-.378-.749-.566-1.371-.566-.531 0-.941.216-1.228.649-.288.429-.431 1.042-.431 1.84 0 .789.139 1.392.418 1.808.279.411.697.617 1.254.617Z",
                className: "crowdfund-appeal_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M30.537 87.281h-1.094v-8.433h-2.978v-.972h7.05v.972h-2.978v8.433Zm9.063 0v-4.56c0-.575-.13-1.004-.392-1.287-.261-.283-.671-.425-1.229-.425-.742 0-1.284.202-1.627.605-.339.403-.508 1.063-.508 1.981v3.686h-1.068v-10.01h1.068v3.03c0 .365-.017.668-.052.908h.065a2.16 2.16 0 0 1 .894-.798 2.91 2.91 0 0 1 1.331-.296c.862 0 1.508.206 1.937.618.433.407.65 1.057.65 1.949v4.6H39.6Zm6.247.129c-1.042 0-1.866-.317-2.47-.952-.6-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.4.429.959.643 1.68.643.758 0 1.509-.159 2.25-.476v.952a5.462 5.462 0 0 1-1.074.347c-.334.074-.74.11-1.215.11Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.3-.36-.73-.54-1.287-.54Zm7.276 9.45c-.408 0-.738-.053-.99-.16v-.87c.295.087.587.13.874.13.334 0 .579-.093.733-.277.159-.18.238-.457.238-.83v-8.208h1.068v8.131c0 1.39-.641 2.084-1.923 2.084Zm.765-12.126c0-.244.06-.422.18-.534a.623.623 0 0 1 .45-.173c.172 0 .32.058.444.173.125.116.187.294.187.534 0 .24-.062.42-.187.54a.629.629 0 0 1-.443.174.623.623 0 0 1-.45-.173c-.12-.12-.18-.3-.18-.54Zm4.426 1.91v4.575c0 .574.13 1.003.392 1.286.262.283.672.425 1.23.425.737 0 1.275-.202 1.614-.605.343-.403.514-1.061.514-1.975v-3.705h1.068v7.05h-.881l-.154-.945h-.058a2.125 2.125 0 0 1-.914.797 3.039 3.039 0 0 1-1.325.277c-.858 0-1.501-.204-1.93-.611-.424-.408-.637-1.06-.637-1.956v-4.612h1.081Zm10.305-.128c.314 0 .594.026.843.077l-.148.991a3.639 3.639 0 0 0-.772-.096c-.57 0-1.06.231-1.466.694-.404.463-.605 1.04-.605 1.73v3.783h-1.068v-7.05h.881l.123 1.306h.051c.262-.46.577-.813.946-1.062a2.129 2.129 0 0 1 1.215-.373Zm1.043.129h1.144l1.544 4.02c.34.918.55 1.58.63 1.988h.052c.056-.219.172-.592.348-1.12.18-.531.763-2.16 1.75-4.888h1.144l-3.03 8.028c-.3.793-.651 1.355-1.054 1.685-.4.335-.89.502-1.474.502-.325 0-.647-.036-.964-.11v-.855c.235.052.5.078.79.078.734 0 1.257-.412 1.57-1.236l.393-1.003-2.844-7.09Zm15.979 6.105h-.058c-.494.716-1.231 1.074-2.213 1.074-.922 0-1.64-.315-2.155-.946-.51-.63-.766-1.526-.766-2.689 0-1.162.258-2.065.772-2.708.515-.643 1.231-.965 2.149-.965.956 0 1.69.348 2.2 1.042h.084l-.046-.508-.025-.495v-2.87h1.068v10.01h-.869l-.141-.945Zm-2.136.18c.729 0 1.257-.198 1.582-.592.33-.399.496-1.04.496-1.924v-.225c0-.999-.168-1.71-.502-2.135-.33-.43-.86-.644-1.589-.644-.626 0-1.106.245-1.44.734-.331.484-.496 1.17-.496 2.058 0 .9.165 1.58.495 2.04.33.458.815.688 1.454.688Zm8.395.894c-1.042 0-1.866-.317-2.47-.952-.6-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.4.429.959.643 1.68.643.758 0 1.509-.159 2.25-.476v.952a5.462 5.462 0 0 1-1.073.347c-.335.074-.74.11-1.216.11Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.3-.36-.73-.54-1.287-.54Zm7.527 6.414c-1.021 0-1.812-.313-2.374-.94-.558-.63-.836-1.52-.836-2.669 0-1.18.283-2.09.849-2.734.57-.643 1.38-.965 2.431-.965.34 0 .678.037 1.017.11.339.072.604.158.797.257l-.328.907a4.775 4.775 0 0 0-.772-.232 3.338 3.338 0 0 0-.74-.096c-1.432 0-2.148.913-2.148 2.74 0 .867.174 1.531.521 1.994.352.464.87.695 1.557.695.587 0 1.19-.126 1.808-.38v.946c-.472.245-1.066.367-1.782.367Zm4.528-.129h-1.068v-7.05h1.068v7.05Zm-1.158-8.96c0-.245.06-.423.181-.535a.622.622 0 0 1 .45-.173c.171 0 .319.058.444.173.124.116.186.294.186.534 0 .24-.062.42-.186.54a.631.631 0 0 1-.444.174.622.622 0 0 1-.45-.173c-.121-.12-.181-.3-.181-.54Zm7.971 7.037c0 .656-.245 1.162-.734 1.518-.489.356-1.175.534-2.058.534-.935 0-1.664-.148-2.187-.444v-.99c.338.17.701.306 1.087.405.39.098.765.148 1.126.148.557 0 .986-.088 1.286-.264.3-.18.45-.453.45-.817 0-.275-.12-.508-.36-.701-.236-.198-.699-.43-1.389-.695-.656-.245-1.124-.457-1.403-.637a1.984 1.984 0 0 1-.617-.624 1.639 1.639 0 0 1-.2-.83c0-.574.234-1.027.702-1.357.467-.335 1.108-.502 1.923-.502a5.63 5.63 0 0 1 2.226.463l-.38.869c-.707-.292-1.349-.438-1.923-.438-.506 0-.888.08-1.145.238-.258.16-.386.378-.386.657 0 .188.047.35.141.482.099.133.255.26.47.38.214.12.626.293 1.235.52.836.305 1.4.612 1.692.92.296.31.444.697.444 1.165Zm2.811 1.923h-1.068v-7.05h1.068v7.05Zm-1.158-8.96c0-.245.06-.423.18-.535a.622.622 0 0 1 .45-.173c.172 0 .32.058.444.173.125.116.187.294.187.534 0 .24-.062.42-.187.54a.628.628 0 0 1-.444.174.622.622 0 0 1-.45-.173c-.12-.12-.18-.3-.18-.54Zm9.508 5.429c0 1.149-.29 2.047-.869 2.695-.579.643-1.379.965-2.399.965-.631 0-1.19-.148-1.679-.444a2.923 2.923 0 0 1-1.132-1.274c-.266-.553-.399-1.2-.399-1.942 0-1.15.287-2.044.862-2.683.574-.643 1.372-.965 2.393-.965.986 0 1.769.328 2.348.984.583.657.875 1.544.875 2.664Zm-5.372 0c0 .9.18 1.586.541 2.058.36.472.889.708 1.588.708.7 0 1.229-.234 1.589-.701.365-.472.547-1.16.547-2.065 0-.897-.182-1.576-.547-2.04-.36-.467-.894-.7-1.601-.7-.699 0-1.227.229-1.583.688-.356.458-.534 1.143-.534 2.052Zm12.075 3.531v-4.56c0-.575-.131-1.004-.393-1.287-.261-.283-.671-.425-1.228-.425-.738 0-1.278.2-1.622.599-.343.398-.514 1.057-.514 1.974v3.7h-1.068V80.23h.868l.174.965h.052c.218-.348.525-.616.919-.804.395-.193.835-.29 1.319-.29.849 0 1.488.206 1.917.618.429.407.643 1.061.643 1.962v4.6h-1.067Zm7.758 0h-1.068v-7.05h1.068v7.05Zm-1.158-8.96c0-.245.06-.423.18-.535a.622.622 0 0 1 .45-.173c.172 0 .32.058.444.173.124.116.186.294.186.534 0 .24-.062.42-.186.54a.628.628 0 0 1-.444.174.622.622 0 0 1-.45-.173c-.12-.12-.18-.3-.18-.54Zm7.97 7.037c0 .656-.245 1.162-.733 1.518-.489.356-1.175.534-2.059.534-.935 0-1.664-.148-2.187-.444v-.99c.339.17.701.306 1.087.405.39.098.766.148 1.126.148.557 0 .986-.088 1.286-.264.301-.18.451-.453.451-.817 0-.275-.12-.508-.361-.701-.235-.198-.699-.43-1.389-.695-.656-.245-1.124-.457-1.402-.637a1.978 1.978 0 0 1-.618-.624 1.639 1.639 0 0 1-.199-.83c0-.574.233-1.027.701-1.357.467-.335 1.108-.502 1.923-.502a5.63 5.63 0 0 1 2.226.463l-.38.869c-.707-.292-1.348-.438-1.923-.438-.506 0-.888.08-1.145.238-.257.16-.386.378-.386.657 0 .188.047.35.142.482.098.133.255.26.469.38.215.12.626.293 1.235.52.836.305 1.4.612 1.692.92.296.31.444.697.444 1.165Zm9.501 1.923-.212-1.003h-.052c-.351.441-.703.742-1.055.9-.347.155-.782.232-1.305.232-.699 0-1.248-.18-1.647-.54-.395-.36-.592-.873-.592-1.538 0-1.424 1.139-2.17 3.416-2.238l1.196-.04v-.436c0-.554-.12-.961-.36-1.223-.236-.266-.615-.399-1.139-.399-.587 0-1.252.18-1.994.54l-.328-.816a5.04 5.04 0 0 1 1.139-.444c.416-.107.832-.16 1.248-.16.84 0 1.462.186 1.865.559.408.373.611.971.611 1.794v4.812h-.791Zm-2.412-.752c.665 0 1.186-.183 1.563-.547.382-.365.573-.875.573-1.531v-.637l-1.068.045c-.849.03-1.463.163-1.84.399-.373.231-.56.594-.56 1.087 0 .386.116.68.348.881.236.202.564.303.984.303Zm8.691.88c-.459 0-.88-.083-1.261-.25a2.39 2.39 0 0 1-.952-.785h-.077c.051.412.077.802.077 1.171v2.901h-1.068V80.231h.868l.148.965h.052c.274-.386.594-.665.958-.837a2.918 2.918 0 0 1 1.255-.257c.934 0 1.655.32 2.161.959.51.639.766 1.535.766 2.689 0 1.157-.26 2.058-.779 2.701-.514.64-1.231.959-2.148.959Zm-.155-6.4c-.72 0-1.241.2-1.563.599-.322.398-.487 1.033-.495 1.904v.238c0 .99.165 1.7.495 2.129.33.424.86.637 1.589.637.609 0 1.085-.247 1.428-.74.347-.493.521-1.173.521-2.04 0-.878-.174-1.552-.521-2.02-.343-.47-.828-.707-1.454-.707Zm8.234 6.4c-.459 0-.879-.083-1.261-.25a2.403 2.403 0 0 1-.952-.785h-.077c.052.412.077.802.077 1.171v2.901H163.2V80.231h.869l.148.965h.051c.275-.386.594-.665.959-.837a2.91 2.91 0 0 1 1.254-.257c.935 0 1.656.32 2.162.959.51.639.765 1.535.765 2.689 0 1.157-.259 2.058-.778 2.701-.515.64-1.231.959-2.149.959Zm-.154-6.4c-.721 0-1.242.2-1.563.599-.322.398-.487 1.033-.496 1.904v.238c0 .99.165 1.7.496 2.129.33.424.859.637 1.589.637.609 0 1.085-.247 1.428-.74.347-.493.521-1.173.521-2.04 0-.878-.174-1.552-.521-2.02-.343-.47-.828-.707-1.454-.707Zm7.931 6.4c-1.042 0-1.865-.316-2.47-.951-.6-.635-.9-1.516-.9-2.644 0-1.136.278-2.04.836-2.708.562-.67 1.314-1.004 2.258-1.004.883 0 1.582.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.399.429.959.643 1.679.643a5.68 5.68 0 0 0 2.252-.476v.952a5.476 5.476 0 0 1-1.075.347c-.334.074-.74.11-1.216.11Zm-.289-6.413c-.566 0-1.019.185-1.357.554-.335.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.301-.36-.729-.54-1.287-.54Zm9.045 6.285-.213-1.003h-.051c-.352.441-.704.742-1.055.9-.348.155-.783.232-1.306.232-.699 0-1.248-.18-1.647-.54-.394-.36-.592-.873-.592-1.538 0-1.424 1.139-2.17 3.416-2.238l1.197-.04v-.436c0-.554-.12-.961-.361-1.223-.235-.266-.615-.399-1.138-.399-.588 0-1.252.18-1.994.54l-.328-.816a5.013 5.013 0 0 1 1.138-.444c.416-.107.832-.16 1.248-.16.841 0 1.463.186 1.866.559.407.373.611.971.611 1.794v4.812h-.791Zm-2.413-.752c.665 0 1.186-.183 1.563-.547.382-.365.573-.875.573-1.531v-.637l-1.068.045c-.849.03-1.462.163-1.84.399-.373.231-.559.594-.559 1.087 0 .386.115.68.347.881.236.202.564.303.984.303Zm6.478.752h-1.068v-10.01h1.068v10.01Zm5.243.129c-1.042 0-1.866-.317-2.47-.952-.601-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.399.429.959.643 1.679.643a5.68 5.68 0 0 0 2.252-.476v.952a5.49 5.49 0 0 1-1.074.347 5.8 5.8 0 0 1-1.216.11Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.3-.36-.729-.54-1.287-.54Zm9.508 5.34h-.058c-.493.716-1.231 1.074-2.213 1.074-.922 0-1.64-.315-2.155-.946-.51-.63-.765-1.526-.765-2.689 0-1.162.257-2.065.772-2.708.514-.643 1.23-.965 2.148-.965.957 0 1.69.348 2.2 1.042h.084l-.045-.508-.026-.495v-2.87h1.068v10.01h-.868l-.142-.945Zm-2.136.18c.729 0 1.257-.198 1.583-.592.33-.399.495-1.04.495-1.924v-.225c0-.999-.167-1.71-.502-2.135-.33-.43-.859-.644-1.589-.644-.626 0-1.106.245-1.44.734-.331.484-.496 1.17-.496 2.058 0 .9.165 1.58.496 2.04.33.458.814.688 1.453.688ZM214 87.28l-1.293-4.136a36.003 36.003 0 0 1-.456-1.724h-.052a23.16 23.16 0 0 1-.45 1.737l-1.332 4.123h-1.235l-1.923-7.05h1.119c.455 1.771.8 3.12 1.036 4.046.24.927.377 1.55.411 1.872h.052c.047-.244.122-.56.225-.945.107-.39.199-.7.277-.927l1.293-4.046h1.158l1.26 4.046c.241.738.404 1.358.489 1.86h.052c.017-.155.062-.393.135-.715.077-.322.525-2.052 1.344-5.191h1.107l-1.949 7.05H214Zm9.321 0v-4.56c0-.575-.13-1.004-.392-1.287-.262-.283-.671-.425-1.229-.425-.741 0-1.284.202-1.627.605-.339.403-.508 1.063-.508 1.981v3.686h-1.068v-10.01h1.068v3.03c0 .365-.017.668-.052.908h.065a2.16 2.16 0 0 1 .894-.798c.39-.197.834-.296 1.331-.296.862 0 1.508.206 1.937.618.433.407.649 1.057.649 1.949v4.6h-1.068Zm6.247.129c-1.042 0-1.866-.317-2.47-.952-.601-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.399.429.959.643 1.679.643a5.68 5.68 0 0 0 2.252-.476v.952a5.49 5.49 0 0 1-1.074.347 5.8 5.8 0 0 1-1.216.11Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.3-.36-.729-.54-1.287-.54Zm9.534 6.285v-4.56c0-.575-.131-1.004-.393-1.287-.261-.283-.671-.425-1.228-.425-.738 0-1.278.2-1.621.599-.344.398-.515 1.057-.515 1.974v3.7h-1.068V80.23h.869l.173.965h.052c.218-.348.525-.616.92-.804.394-.193.834-.29 1.318-.29.849 0 1.488.206 1.917.618.429.407.644 1.061.644 1.962v4.6h-1.068Zm11.238-1.923c0 .656-.245 1.162-.734 1.518-.488.356-1.175.534-2.058.534-.935 0-1.664-.148-2.187-.444v-.99c.339.17.701.306 1.087.405.39.098.765.148 1.126.148.557 0 .986-.088 1.286-.264.3-.18.451-.453.451-.817 0-.275-.12-.508-.361-.701-.236-.198-.699-.43-1.389-.695-.656-.245-1.124-.457-1.402-.637a1.978 1.978 0 0 1-.618-.624 1.639 1.639 0 0 1-.199-.83c0-.574.233-1.027.701-1.357.467-.335 1.108-.502 1.923-.502a5.63 5.63 0 0 1 2.226.463l-.38.869c-.707-.292-1.348-.438-1.923-.438-.506 0-.888.08-1.145.238-.257.16-.386.378-.386.657 0 .188.047.35.141.482.099.133.256.26.47.38.214.12.626.293 1.235.52.836.305 1.4.612 1.692.92.296.31.444.697.444 1.165Zm4.02 1.17c.189 0 .371-.012.547-.038.176-.03.315-.06.418-.09v.817a1.89 1.89 0 0 1-.514.135 3.581 3.581 0 0 1-.605.058c-1.364 0-2.046-.718-2.046-2.155V81.06h-1.01v-.515l1.01-.444.451-1.505h.617v1.634h2.046v.83h-2.046v4.149c0 .425.101.75.302.978.202.227.479.34.83.34Zm6.716.753-.212-1.003h-.052c-.351.441-.703.742-1.055.9-.347.155-.782.232-1.305.232-.699 0-1.248-.18-1.647-.54-.395-.36-.592-.873-.592-1.538 0-1.424 1.139-2.17 3.416-2.238l1.196-.04v-.436c0-.554-.12-.961-.36-1.223-.236-.266-.615-.399-1.139-.399-.587 0-1.252.18-1.994.54l-.328-.816a5.04 5.04 0 0 1 1.139-.444c.416-.107.832-.16 1.248-.16.84 0 1.462.186 1.865.559.408.373.611.971.611 1.794v4.812h-.791Zm-2.412-.752c.665 0 1.186-.183 1.563-.547.382-.365.573-.875.573-1.531v-.637l-1.068.045c-.849.03-1.463.163-1.84.399-.373.231-.56.594-.56 1.087 0 .386.116.68.348.881.236.202.564.303.984.303Zm11.18-6.298v.675l-1.306.155c.12.15.228.347.322.591.094.24.141.513.141.817 0 .691-.235 1.242-.707 1.654-.472.411-1.12.617-1.943.617-.21 0-.407-.017-.592-.051-.454.24-.682.542-.682.907 0 .193.08.337.238.43.159.09.431.136.817.136h1.248c.764 0 1.349.16 1.756.482.412.322.618.79.618 1.403 0 .78-.313 1.374-.939 1.782-.626.411-1.54.617-2.741.617-.922 0-1.633-.171-2.135-.514-.498-.344-.746-.828-.746-1.454 0-.43.137-.8.411-1.113.275-.313.661-.525 1.158-.637a1.146 1.146 0 0 1-.457-.38 1.017 1.017 0 0 1-.18-.598c0-.257.069-.482.206-.675.137-.193.354-.38.65-.56a1.916 1.916 0 0 1-.894-.765 2.26 2.26 0 0 1-.341-1.236c0-.771.231-1.365.695-1.781.463-.42 1.119-.63 1.968-.63.369 0 .701.042.997.128h2.438Zm-5.622 8.234c0 .382.161.671.482.868.322.198.783.296 1.383.296.897 0 1.559-.135 1.988-.405.433-.266.65-.628.65-1.087 0-.382-.118-.648-.354-.798-.236-.146-.68-.219-1.332-.219h-1.28c-.484 0-.862.116-1.132.348-.27.231-.405.564-.405.997Zm.579-5.976c0 .493.139.866.418 1.12.279.252.667.379 1.164.379 1.042 0 1.563-.506 1.563-1.519 0-1.059-.527-1.588-1.582-1.588-.502 0-.888.135-1.158.405-.27.27-.405.671-.405 1.203Zm9.469 4.92c-1.042 0-1.866-.316-2.47-.951-.601-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.856c.021.828.229 1.456.624 1.885.398.429.958.643 1.678.643.76 0 1.51-.159 2.252-.476v.952a5.468 5.468 0 0 1-1.074.347 5.8 5.8 0 0 1-1.216.11Zm-.29-6.413c-.566 0-1.018.185-1.357.554-.334.368-.532.879-.592 1.53h3.686c0-.673-.15-1.187-.45-1.543-.3-.36-.729-.54-1.287-.54Zm9.257 4.362c0 .656-.244 1.162-.733 1.518-.489.356-1.175.534-2.059.534-.935 0-1.664-.148-2.187-.444v-.99c.339.17.701.306 1.087.405a4.6 4.6 0 0 0 1.126.148c.558 0 .986-.088 1.287-.264.3-.18.45-.453.45-.817 0-.275-.12-.508-.36-.701-.236-.198-.699-.43-1.39-.695-.656-.245-1.123-.457-1.402-.637a1.988 1.988 0 0 1-.618-.624 1.639 1.639 0 0 1-.199-.83c0-.574.234-1.027.701-1.357.468-.335 1.109-.502 1.924-.502.759 0 1.5.155 2.225.463l-.379.869c-.708-.292-1.349-.438-1.924-.438-.506 0-.887.08-1.145.238-.257.16-.386.378-.386.657 0 .188.047.35.142.482.098.133.255.26.469.38.215.12.627.293 1.236.52.836.305 1.4.612 1.691.92.296.31.444.697.444 1.165Zm8.633 1.923h-1.042v-6.703c0-.557.017-1.085.051-1.582-.09.09-.19.184-.302.283-.111.099-.622.517-1.531 1.254l-.566-.733 2.489-1.924h.901v9.405Zm11.83 0-.212-1.003h-.052c-.351.441-.703.742-1.055.9-.347.155-.782.232-1.306.232-.699 0-1.248-.18-1.646-.54-.395-.36-.592-.873-.592-1.538 0-1.424 1.138-2.17 3.416-2.238l1.196-.04v-.436c0-.554-.12-.961-.36-1.223-.236-.266-.616-.399-1.139-.399-.587 0-1.252.18-1.994.54l-.328-.816a5.021 5.021 0 0 1 1.139-.444c.416-.107.832-.16 1.248-.16.84 0 1.462.186 1.865.559.407.373.611.971.611 1.794v4.812h-.791Zm-2.412-.752c.664 0 1.185-.183 1.563-.547.382-.365.572-.875.572-1.531v-.637l-1.067.045c-.85.03-1.463.163-1.84.399-.373.231-.56.594-.56 1.087 0 .386.116.68.347.881.236.202.564.303.985.303Zm10.234.752v-4.56c0-.575-.131-1.004-.392-1.287-.262-.283-.671-.425-1.229-.425-.737 0-1.278.2-1.621.599-.343.398-.514 1.057-.514 1.974v3.7h-1.068V80.23h.868l.174.965h.051c.219-.348.526-.616.92-.804.395-.193.834-.29 1.319-.29.849 0 1.488.206 1.917.618.429.407.643 1.061.643 1.962v4.6h-1.068Zm8.067-.945h-.058c-.493.716-1.231 1.074-2.213 1.074-.922 0-1.64-.315-2.155-.946-.51-.63-.765-1.526-.765-2.689 0-1.162.257-2.065.772-2.708.514-.643 1.231-.965 2.148-.965.957 0 1.69.348 2.2 1.042h.084l-.045-.508-.026-.495v-2.87h1.068v10.01h-.868l-.142-.945Zm-2.136.18c.729 0 1.257-.198 1.583-.592.33-.399.495-1.04.495-1.924v-.225c0-.999-.167-1.71-.502-2.135-.33-.43-.859-.644-1.589-.644-.626 0-1.106.245-1.44.734-.331.484-.496 1.17-.496 2.058 0 .9.165 1.58.496 2.04.33.458.814.688 1.453.688Zm14.532.765h-6.182v-.92l2.477-2.49c.755-.762 1.252-1.307 1.492-1.633.24-.326.42-.643.541-.952.12-.309.18-.641.18-.997 0-.502-.153-.899-.457-1.19-.305-.296-.727-.444-1.267-.444a3.21 3.21 0 0 0-1.113.193c-.348.129-.736.362-1.165.701l-.566-.727c.867-.72 1.81-1.08 2.831-1.08.883 0 1.576.227 2.078.681.501.45.752 1.057.752 1.82 0 .597-.167 1.187-.502 1.77-.334.583-.96 1.32-1.878 2.213l-2.058 2.013v.052h4.837v.99Zm-299.878 18-.212-1.003h-.052c-.352.441-.703.742-1.055.9-.347.155-.783.232-1.306.232-.699 0-1.248-.18-1.647-.54-.394-.361-.591-.873-.591-1.538 0-1.424 1.138-2.17 3.415-2.239l1.197-.038v-.438c0-.553-.12-.96-.36-1.222-.236-.266-.616-.399-1.139-.399-.587 0-1.252.18-1.994.54l-.328-.816a5.03 5.03 0 0 1 1.138-.444c.416-.107.832-.16 1.248-.16.84 0 1.463.186 1.866.559.407.373.611.971.611 1.795v4.811h-.791Zm-2.413-.752c.665 0 1.186-.183 1.564-.547.381-.365.572-.875.572-1.531v-.637l-1.068.045c-.849.03-1.462.163-1.84.399-.373.231-.56.594-.56 1.087 0 .386.117.68.348.881.236.202.564.303.984.303Zm8.627-6.427c.313 0 .594.026.843.077l-.148.991a3.639 3.639 0 0 0-.772-.096c-.57 0-1.06.231-1.467.694-.403.463-.605 1.04-.605 1.731v3.782h-1.067v-7.05h.88l.123 1.306h.051c.262-.46.577-.813.946-1.062a2.129 2.129 0 0 1 1.216-.373Zm5.14 7.308c-1.042 0-1.866-.317-2.47-.952-.6-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.4.429.959.643 1.68.643.758 0 1.509-.159 2.25-.476v.952a5.487 5.487 0 0 1-1.074.348c-.334.072-.74.109-1.215.109Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.531h3.686c0-.674-.15-1.188-.45-1.544-.3-.36-.73-.54-1.287-.54Zm11.31.065h-1.796v6.22h-1.068v-6.22h-1.26v-.483l1.26-.386V97.8c0-1.733.757-2.599 2.271-2.599.373 0 .81.075 1.313.225l-.277.856c-.412-.133-.763-.2-1.055-.2-.403 0-.701.135-.894.406-.193.266-.29.694-.29 1.286v.457h1.795v.83Zm2.29-.83v4.574c0 .574.13 1.003.392 1.286.261.283.67.425 1.228.425.738 0 1.276-.202 1.615-.605.343-.403.514-1.061.514-1.975v-3.705h1.068v7.05h-.881l-.154-.945h-.058a2.123 2.123 0 0 1-.914.797 3.03 3.03 0 0 1-1.325.277c-.858 0-1.5-.204-1.93-.611-.424-.408-.637-1.059-.637-1.956v-4.612h1.081Zm8.156 7.05h-1.068v-10.01h1.068v10.01Zm3.332 0h-1.068v-10.01h1.068v10.01Zm1.145-7.05h1.145l1.544 4.02c.339.918.549 1.581.63 1.988h.052c.056-.219.171-.592.347-1.119.18-.532.764-2.162 1.75-4.89h1.145l-3.03 8.029c-.3.793-.652 1.355-1.055 1.685-.398.335-.89.502-1.473.502a4.29 4.29 0 0 1-.965-.109v-.856c.236.052.5.077.792.077.733 0 1.256-.411 1.57-1.235l.391-1.003-2.843-7.09Zm14.358.83h-1.794v6.22H80.61v-6.22h-1.261v-.483l1.26-.386V97.8c0-1.733.758-2.599 2.271-2.599.374 0 .81.075 1.313.225l-.277.856c-.412-.133-.763-.2-1.055-.2-.403 0-.701.135-.894.406-.193.266-.29.694-.29 1.286v.457h1.795v.83Zm2.29-.83v4.574c0 .574.131 1.003.393 1.286.261.283.67.425 1.228.425.738 0 1.276-.202 1.615-.605.343-.403.515-1.061.515-1.975v-3.705h1.067v7.05h-.88l-.155-.945h-.058a2.123 2.123 0 0 1-.914.797 3.03 3.03 0 0 1-1.325.277c-.857 0-1.5-.204-1.93-.611-.424-.408-.636-1.059-.636-1.956v-4.612h1.08Zm11.914 7.05v-4.561c0-.574-.13-1.003-.392-1.286-.262-.283-.672-.425-1.23-.425-.737 0-1.277.2-1.62.599-.343.398-.515 1.057-.515 1.974v3.699h-1.068v-7.05h.869l.173.965h.052a2.16 2.16 0 0 1 .92-.804c.394-.193.834-.29 1.319-.29.849 0 1.488.206 1.916.618.43.407.644 1.061.644 1.962v4.599h-1.068Zm8.067-.945h-.058c-.493.716-1.231 1.074-2.213 1.074-.922 0-1.641-.315-2.155-.946-.51-.63-.766-1.526-.766-2.689 0-1.162.258-2.065.772-2.708.515-.643 1.231-.965 2.149-.965.956 0 1.69.348 2.2 1.042h.083l-.045-.508-.025-.495v-2.87h1.068v10.01h-.869l-.141-.945Zm-2.136.18c.729 0 1.256-.198 1.582-.592.331-.399.496-1.04.496-1.923v-.226c0-.999-.168-1.711-.502-2.135-.33-.43-.86-.644-1.589-.644-.626 0-1.106.245-1.441.734-.33.484-.495 1.171-.495 2.058 0 .901.165 1.581.495 2.039.33.459.815.689 1.454.689Zm8.395.894c-1.042 0-1.866-.317-2.47-.952-.601-.635-.901-1.516-.901-2.644 0-1.136.279-2.04.836-2.708.562-.67 1.315-1.004 2.258-1.004.884 0 1.583.292 2.097.875.515.579.772 1.345.772 2.297v.675h-4.857c.022.828.23 1.456.624 1.885.399.429.959.643 1.679.643.759 0 1.51-.159 2.252-.476v.952a5.515 5.515 0 0 1-1.074.348 5.87 5.87 0 0 1-1.216.109Zm-.29-6.414c-.566 0-1.018.185-1.357.554-.335.368-.532.879-.592 1.531h3.686c0-.674-.15-1.188-.45-1.544-.3-.36-.729-.54-1.287-.54Zm9.508 5.34h-.058c-.493.716-1.231 1.074-2.213 1.074-.922 0-1.64-.315-2.155-.946-.51-.63-.765-1.526-.765-2.689 0-1.162.257-2.065.772-2.708.514-.643 1.23-.965 2.148-.965.957 0 1.69.348 2.2 1.042h.084l-.045-.508-.026-.495v-2.87h1.068v10.01h-.869l-.141-.945Zm-2.136.18c.729 0 1.257-.198 1.583-.592.33-.399.495-1.04.495-1.923v-.226c0-.999-.167-1.711-.502-2.135-.33-.43-.86-.644-1.589-.644-.626 0-1.106.245-1.441.734-.33.484-.495 1.171-.495 2.058 0 .901.165 1.581.495 2.039.331.459.815.689 1.454.689Zm5.262.083c0-.287.065-.504.193-.649.133-.15.322-.225.566-.225.249 0 .442.075.579.225.142.145.213.362.213.649 0 .279-.071.494-.213.644-.141.15-.334.225-.579.225a.779.779 0 0 1-.546-.2c-.142-.137-.213-.36-.213-.669Z",
                className: "crowdfund-appeal_svg__path-5"
            })
        ]
    });
var $9930f08bd73a09be$export$2e2bcd8739ae039 = $9930f08bd73a09be$var$SvgCrowdfundAppeal;



const $e0b125c079f587a0$var$StyledCrowdfundAppealSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $9930f08bd73a09be$export$2e2bcd8739ae039))`
  [class$="rect-bg"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="path-1"],
  [class$="path-2"],
  [class$="path-3"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="rect-fg"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-accent"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-4"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }
`;
const $e0b125c079f587a0$var$CrowdfundAppeal = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $e0b125c079f587a0$var$StyledCrowdfundAppealSvg
    });
var $e0b125c079f587a0$export$2e2bcd8739ae039 = $e0b125c079f587a0$var$CrowdfundAppeal;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $2f14ca94ee5a0052$var$SvgPayoffSimulator = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 332 346",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M.365 2.189c0-1.007.817-1.824 1.824-1.824h327.622c1.007 0 1.824.817 1.824 1.824v341.486a1.824 1.824 0 0 1-1.824 1.824H2.189a1.824 1.824 0 0 1-1.824-1.824V2.189Z",
                className: "payoff-simulator_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 191.174,
                cy: 313.032,
                r: 17.512,
                className: "payoff-simulator_svg__circle-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#payoff-simulator_svg__a)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M187.827 309.727a2.573 2.573 0 0 0 0-3.612 2.51 2.51 0 0 0-3.575 0 2.573 2.573 0 0 0 0 3.612 2.51 2.51 0 0 0 3.575 0Zm10.11 6.604a2.507 2.507 0 0 0-3.574 0 2.572 2.572 0 0 0 0 3.611 2.507 2.507 0 0 0 3.574 0 2.572 2.572 0 0 0 0-3.611Zm-.077-9.235-.893-.903a1.254 1.254 0 0 0-1.787 0l-10.851 10.964a1.286 1.286 0 0 0 0 1.805l.894.903a1.254 1.254 0 0 0 1.787 0l10.85-10.964a1.284 1.284 0 0 0 0-1.805Z",
                    className: "payoff-simulator_svg__path-2"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 36.483,
                cy: 313.032,
                r: 17.512,
                className: "payoff-simulator_svg__circle-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#payoff-simulator_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m40.618 313.172-4.475 2.778-4.477-2.778 4.477-7.805 4.475 7.805Zm-4.475 3.67-4.477-2.778 4.477 6.626 4.478-6.626-4.478 2.778Z",
                    className: "payoff-simulator_svg__path-3"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.833 313.106c0 1.448-.234 2.524-.701 3.227-.464.703-1.175 1.054-2.133 1.054-.927 0-1.63-.362-2.109-1.088-.478-.726-.718-1.79-.718-3.193 0-1.47.232-2.554.696-3.249.467-.699 1.178-1.049 2.132-1.049.93 0 1.636.365 2.114 1.095.48.729.719 1.797.719 3.203Zm-4.304 0c0 1.137.116 1.948.347 2.434.236.487.61.73 1.123.73.514 0 .888-.247 1.124-.741.239-.494.359-1.302.359-2.423 0-1.117-.12-1.925-.36-2.422-.235-.502-.61-.753-1.123-.753-.512 0-.887.245-1.123.736-.231.49-.347 1.303-.347 2.439Zm5.57 3.455c0-.278.071-.49.216-.639.144-.148.353-.222.627-.222.277 0 .488.078.633.234.144.152.216.361.216.627 0 .27-.074.484-.222.644-.144.156-.353.234-.627.234s-.483-.078-.627-.234c-.145-.156-.217-.371-.217-.644Zm8.618-3.455c0 1.448-.233 2.524-.7 3.227-.464.703-1.175 1.054-2.133 1.054-.927 0-1.63-.362-2.109-1.088-.479-.726-.718-1.79-.718-3.193 0-1.47.232-2.554.695-3.249.468-.699 1.178-1.049 2.132-1.049.931 0 1.636.365 2.115 1.095.479.729.719 1.797.719 3.203Zm-4.303 0c0 1.137.115 1.948.347 2.434.236.487.61.73 1.123.73s.888-.247 1.123-.741c.24-.494.36-1.302.36-2.423 0-1.117-.12-1.925-.36-2.422-.235-.502-.61-.753-1.123-.753s-.887.245-1.123.736c-.231.49-.347 1.303-.347 2.439Zm9.257 4.167h-1.34v-5.381c0-.642.016-1.151.046-1.528a4.48 4.48 0 0 1-.325.303c-.125.11-.55.459-1.277 1.048l-.672-.849 2.45-1.927h1.118v8.334Zm2.76-3.551c0-3.261 1.328-4.891 3.984-4.891.418 0 .771.032 1.06.097v1.117a3.644 3.644 0 0 0-1.003-.125c-.893 0-1.564.239-2.012.718-.449.479-.692 1.247-.73 2.303h.068a1.82 1.82 0 0 1 .753-.713c.323-.171.703-.256 1.14-.256.756 0 1.345.232 1.767.695.422.464.633 1.093.633 1.887 0 .874-.245 1.566-.735 2.075-.487.506-1.152.758-1.996.758-.596 0-1.115-.142-1.556-.427-.44-.289-.78-.707-1.02-1.254-.236-.551-.354-1.213-.354-1.984Zm2.907 2.56c.46 0 .813-.149 1.06-.445.25-.297.376-.72.376-1.271 0-.479-.118-.855-.353-1.129-.232-.274-.582-.41-1.05-.41-.288 0-.554.062-.797.188-.243.121-.435.29-.576.507-.14.213-.211.431-.211.656 0 .535.144.988.433 1.356.293.365.665.548 1.118.548Zm12.073.991h-4.714v-8.334h4.714v1.152h-3.352v2.269h3.141v1.14h-3.141v2.616h3.352v1.157Zm4.686 0h-1.362v-7.165h-2.451v-1.169h6.264v1.169h-2.451v7.165Zm10.307 0h-1.368v-3.756h-3.843v3.756h-1.362v-8.334h1.362v3.409h3.843v-3.409h1.368v8.334Z",
                className: "payoff-simulator_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M224.807 317.273h-1.34v-5.381c0-.642.016-1.151.046-1.528a4.442 4.442 0 0 1-.325.303c-.125.11-.551.459-1.277 1.048l-.673-.849 2.452-1.927h1.117v8.334Zm8.386-4.167c0 1.448-.234 2.524-.702 3.227-.463.703-1.174 1.054-2.132 1.054-.927 0-1.63-.362-2.109-1.088-.479-.726-.718-1.79-.718-3.193 0-1.47.232-2.554.695-3.249.468-.699 1.178-1.049 2.132-1.049.931 0 1.636.365 2.115 1.095.479.729.719 1.797.719 3.203Zm-4.304 0c0 1.137.116 1.948.347 2.434.236.487.61.73 1.123.73s.888-.247 1.123-.741c.24-.494.36-1.302.36-2.423 0-1.117-.12-1.925-.36-2.422-.235-.502-.61-.753-1.123-.753s-.887.245-1.123.736c-.231.49-.347 1.303-.347 2.439Zm10.973 0c0 1.448-.234 2.524-.701 3.227-.464.703-1.174 1.054-2.132 1.054-.927 0-1.63-.362-2.109-1.088-.479-.726-.718-1.79-.718-3.193 0-1.47.231-2.554.695-3.249.467-.699 1.178-1.049 2.132-1.049.931 0 1.636.365 2.115 1.095.479.729.718 1.797.718 3.203Zm-4.304 0c0 1.137.116 1.948.348 2.434.236.487.61.73 1.123.73s.887-.247 1.123-.741c.239-.494.359-1.302.359-2.423 0-1.117-.12-1.925-.359-2.422-.236-.502-.61-.753-1.123-.753s-.887.245-1.123.736c-.232.49-.348 1.303-.348 2.439Zm6.402-1.67c0 .566.055.988.165 1.266.111.277.291.416.542.416.501 0 .752-.561.752-1.682s-.251-1.682-.752-1.682c-.251 0-.431.139-.542.417-.11.277-.165.699-.165 1.265Zm2.565-.011c0 .874-.157 1.531-.473 1.972-.312.437-.773.656-1.385.656-.578 0-1.026-.226-1.345-.679-.316-.456-.474-1.106-.474-1.949 0-1.737.607-2.605 1.819-2.605.597 0 1.054.226 1.374.678.323.448.484 1.091.484 1.927Zm2.862 3.34c0 .566.055.99.165 1.271.114.282.297.422.547.422.498 0 .747-.564.747-1.693 0-1.113-.249-1.67-.747-1.67-.25 0-.433.137-.547.41-.11.274-.165.694-.165 1.26Zm2.565 0c0 .874-.158 1.53-.473 1.967-.315.437-.775.655-1.38.655-.577 0-1.026-.224-1.345-.672-.319-.452-.479-1.102-.479-1.95 0-1.737.608-2.605 1.824-2.605.586 0 1.04.224 1.363.673.327.448.49 1.092.49 1.932Zm-1.693-5.826-4.623 8.334h-1.106l4.623-8.334h1.106Zm7.673 3.877h.946c.635 0 1.095-.118 1.38-.354.285-.235.427-.585.427-1.049 0-.471-.154-.809-.461-1.014-.308-.206-.772-.308-1.391-.308h-.901v2.725Zm0 1.128v3.329h-1.362v-8.334h2.354c1.075 0 1.872.202 2.388.604.517.403.776 1.011.776 1.825 0 1.037-.54 1.776-1.619 2.217l2.354 3.688h-1.55l-1.996-3.329h-1.345Zm13.505-.849c0 1.357-.341 2.411-1.021 3.164-.676.752-1.636 1.128-2.879 1.128-1.257 0-2.225-.372-2.901-1.117-.673-.749-1.009-1.811-1.009-3.186 0-1.376.338-2.433 1.015-3.17.68-.737 1.649-1.106 2.907-1.106 1.239 0 2.196.374 2.873 1.123.676.749 1.015 1.803 1.015 3.164Zm-6.362 0c0 1.026.207 1.805.621 2.337.414.528 1.028.793 1.841.793.81 0 1.42-.263 1.83-.787.415-.525.622-1.306.622-2.343 0-1.022-.206-1.798-.616-2.326-.407-.528-1.015-.792-1.824-.792-.817 0-1.435.264-1.853.792-.414.528-.621 1.304-.621 2.326Zm8.152 4.178v-8.334h1.362v8.334h-1.362Z",
                className: "payoff-simulator_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M20.822 269.92v3.033h-.848v-7.292h2c.895 0 1.555.171 1.98.513.43.343.644.858.644 1.547 0 .964-.489 1.616-1.467 1.955l1.98 3.277H24.11l-1.766-3.033h-1.521Zm0-.728h1.162c.599 0 1.038-.118 1.317-.354.28-.239.419-.597.419-1.072 0-.483-.143-.83-.429-1.043-.283-.213-.738-.319-1.367-.319h-1.102v2.788Zm7.652 3.861c-.808 0-1.447-.246-1.916-.738-.465-.492-.698-1.176-.698-2.05 0-.882.216-1.582.648-2.1.436-.519 1.02-.778 1.751-.778.685 0 1.227.226 1.626.678.4.449.599 1.042.599 1.781v.523h-3.766c.016.642.178 1.129.484 1.462.309.332.743.499 1.301.499.589 0 1.171-.123 1.746-.369v.738c-.292.126-.57.216-.833.269-.26.057-.573.085-.942.085Zm-.225-4.973c-.439 0-.79.143-1.052.429-.26.286-.413.682-.46 1.187h2.859c0-.522-.117-.921-.35-1.197-.232-.279-.565-.419-.997-.419Zm5.417 4.29c.146 0 .288-.01.424-.03a3.3 3.3 0 0 0 .324-.07v.633a1.49 1.49 0 0 1-.399.105c-.173.03-.329.045-.469.045-1.057 0-1.586-.557-1.586-1.671v-3.252h-.783v-.399l.783-.344.35-1.168h.478v1.267h1.586v.644h-1.586v3.217c0 .329.078.582.235.758.156.176.37.265.643.265Zm2.624-4.884v3.547c0 .445.101.778.304.997.203.22.52.33.953.33.572 0 .989-.157 1.252-.469.266-.313.399-.823.399-1.532v-2.873h.828v5.467h-.684l-.12-.733h-.044c-.17.269-.406.475-.709.618-.299.143-.641.215-1.027.215-.665 0-1.164-.158-1.496-.474-.33-.316-.494-.821-.494-1.516v-3.577h.838Zm7.99-.099c.243 0 .461.019.654.059l-.115.769a2.815 2.815 0 0 0-.598-.075c-.443 0-.822.179-1.138.538-.312.36-.468.807-.468 1.342v2.933h-.829v-5.467h.684l.095 1.013h.04c.202-.356.447-.63.733-.823.286-.193.6-.289.943-.289Zm5.417 5.566v-3.536c0-.446-.101-.778-.304-.998-.203-.219-.52-.329-.953-.329-.572 0-.99.154-1.256.464-.267.309-.4.819-.4 1.531v2.868h-.828v-5.467h.674l.134.748h.04c.17-.269.408-.477.714-.623a2.29 2.29 0 0 1 1.022-.224c.659 0 1.154.159 1.487.478.332.316.498.823.498 1.522v3.566h-.828Zm9.906-2.738c0 .891-.224 1.588-.673 2.09-.449.498-1.069.748-1.86.748-.49 0-.923-.115-1.302-.344a2.276 2.276 0 0 1-.878-.988c-.206-.429-.31-.931-.31-1.506 0-.891.223-1.585.669-2.08.446-.499 1.064-.748 1.855-.748.765 0 1.372.254 1.821.763.452.508.678 1.197.678 2.065Zm-4.164 0c0 .698.14 1.23.419 1.596.279.366.69.549 1.232.549s.952-.182 1.232-.544c.282-.366.424-.9.424-1.601 0-.695-.142-1.222-.424-1.581-.28-.363-.694-.544-1.242-.544-.542 0-.951.178-1.227.534-.276.355-.414.886-.414 1.591Zm8.085-2.085h-1.392v4.823h-.828v-4.823h-.977v-.374l.977-.3v-.304c0-1.343.587-2.015 1.761-2.015.29 0 .629.058 1.018.175l-.215.663c-.319-.103-.592-.155-.818-.155-.312 0-.543.105-.693.315-.15.206-.225.538-.225.997v.354h1.392v.644Z",
                className: "payoff-simulator_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 19.336,
                y: 206.134,
                width: 293.327,
                height: 32.105,
                rx: 1.824,
                className: "payoff-simulator_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 143.745,
                y: 206.5,
                width: 168.554,
                height: 31.376,
                rx: 2.189,
                className: "payoff-simulator_svg__rect-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M173.828 223.058c0 1.018-.256 1.815-.769 2.388-.513.57-1.222.856-2.127.856a2.817 2.817 0 0 1-1.487-.394 2.59 2.59 0 0 1-1.004-1.129c-.235-.49-.353-1.064-.353-1.721 0-1.019.254-1.811.764-2.377.509-.57 1.216-.855 2.12-.855.874 0 1.568.29 2.081.872.517.581.775 1.368.775 2.36Zm-4.76 0c0 .798.16 1.406.479 1.824.319.418.789.627 1.408.627.62 0 1.089-.207 1.408-.621.323-.418.485-1.028.485-1.83 0-.794-.162-1.397-.485-1.807-.319-.414-.792-.622-1.419-.622-.62 0-1.087.204-1.403.61-.315.407-.473 1.013-.473 1.819Zm7.314-3.118v4.053c0 .509.116.889.348 1.14.232.251.595.376 1.089.376.653 0 1.13-.178 1.43-.536.305-.357.457-.94.457-1.75v-3.283h.946v6.248h-.781l-.137-.838h-.051a1.885 1.885 0 0 1-.81.706 2.682 2.682 0 0 1-1.174.246c-.76 0-1.33-.181-1.71-.542-.376-.361-.565-.939-.565-1.733v-4.087h.958Zm8.3 5.581c.167 0 .329-.012.485-.035.155-.026.279-.053.37-.079v.723c-.102.05-.254.09-.456.12a3.19 3.19 0 0 1-.536.052c-1.208 0-1.812-.637-1.812-1.91v-3.717h-.895v-.456l.895-.393.399-1.334h.547v1.448h1.813v.735h-1.813v3.677c0 .376.089.665.268.866.178.202.423.303.735.303Zm10.535-2.463c0 1.018-.257 1.815-.77 2.388-.513.57-1.222.856-2.126.856a2.818 2.818 0 0 1-1.488-.394 2.588 2.588 0 0 1-1.003-1.129c-.236-.49-.354-1.064-.354-1.721 0-1.019.255-1.811.764-2.377.509-.57 1.216-.855 2.121-.855.874 0 1.567.29 2.08.872.517.581.776 1.368.776 2.36Zm-4.76 0c0 .798.159 1.406.479 1.824.319.418.788.627 1.408.627.619 0 1.088-.207 1.408-.621.323-.418.484-1.028.484-1.83 0-.794-.161-1.397-.484-1.807-.32-.414-.793-.622-1.42-.622-.619 0-1.087.204-1.402.61-.316.407-.473 1.013-.473 1.819Zm9.24-2.383h-1.59v5.513h-.946v-5.513h-1.118v-.427l1.118-.343v-.347c0-1.536.67-2.303 2.012-2.303.331 0 .718.066 1.163.199l-.245.758c-.365-.117-.677-.176-.935-.176-.357 0-.622.119-.793.359-.171.235-.256.616-.256 1.14v.405h1.59v.735Zm9.264 1.334c0 1.44-.228 2.516-.684 3.227-.453.71-1.146 1.066-2.081 1.066-.897 0-1.579-.363-2.047-1.089-.467-.73-.701-1.798-.701-3.204 0-1.452.226-2.529.679-3.232.452-.703 1.142-1.055 2.069-1.055.904 0 1.59.367 2.058 1.1.471.734.707 1.796.707 3.187Zm-4.555 0c0 1.212.143 2.096.428 2.651.285.551.739.826 1.362.826.631 0 1.087-.279 1.368-.838.285-.562.428-1.442.428-2.639 0-1.197-.143-2.073-.428-2.628-.281-.559-.737-.838-1.368-.838-.623 0-1.077.276-1.362.827-.285.547-.428 1.427-.428 2.639Zm6.008 3.574c0-.254.057-.446.171-.576.118-.133.285-.199.502-.199.22 0 .392.066.513.199.126.13.188.322.188.576 0 .247-.062.437-.188.57-.125.133-.296.2-.513.2a.69.69 0 0 1-.484-.177c-.126-.122-.189-.319-.189-.593Zm8.34-3.574c0 1.44-.228 2.516-.684 3.227-.452.71-1.146 1.066-2.08 1.066-.897 0-1.58-.363-2.047-1.089-.467-.73-.701-1.798-.701-3.204 0-1.452.226-2.529.678-3.232.452-.703 1.142-1.055 2.07-1.055.904 0 1.59.367 2.057 1.1.472.734.707 1.796.707 3.187Zm-4.554 0c0 1.212.142 2.096.427 2.651.285.551.739.826 1.363.826.63 0 1.086-.279 1.368-.838.285-.562.427-1.442.427-2.639 0-1.197-.142-2.073-.427-2.628-.282-.559-.738-.838-1.368-.838-.624 0-1.078.276-1.363.827-.285.547-.427 1.427-.427 2.639Zm9.217 4.179h-.923v-5.94c0-.495.015-.962.045-1.403a5.65 5.65 0 0 1-.267.251c-.099.087-.552.458-1.357 1.112l-.502-.65 2.206-1.705h.798v8.335Zm11.43 0h-4.646v-8.335h4.646v.861h-3.677v2.685h3.455v.855h-3.455v3.067h3.677v.867Zm4.418 0h-.969v-7.474h-2.64v-.861h6.248v.861h-2.639v7.474Zm10.227 0h-.969v-3.922h-4.39v3.922h-.969v-8.335h.969v3.546h4.39v-3.546h.969v8.335Zm8.032-6.362c.277 0 .526.022.747.068l-.132.878a3.22 3.22 0 0 0-.684-.086c-.505 0-.938.206-1.299.616-.358.411-.536.922-.536 1.534v3.352h-.947v-6.248h.781l.109 1.157h.045c.232-.407.512-.72.838-.941a1.89 1.89 0 0 1 1.078-.33Zm4.554 6.476c-.923 0-1.653-.282-2.189-.844-.532-.563-.798-1.344-.798-2.343 0-1.007.247-1.807.741-2.4.498-.593 1.165-.889 2.001-.889.783 0 1.403.258 1.859.775.456.513.684 1.191.684 2.035v.599h-4.304c.019.733.203 1.29.553 1.67.353.38.849.57 1.488.57a5.04 5.04 0 0 0 1.995-.422v.844a4.897 4.897 0 0 1-.952.308 5.19 5.19 0 0 1-1.078.097Zm-.256-5.684c-.502 0-.903.163-1.203.49-.296.327-.471.779-.524 1.357h3.266c0-.597-.133-1.053-.399-1.368-.266-.319-.646-.479-1.14-.479Zm6.533 4.891c.631 0 1.09-.169 1.379-.507.289-.338.443-.909.462-1.71v-.211c0-.874-.148-1.503-.445-1.887-.296-.384-.765-.576-1.408-.576-.554 0-.98.217-1.277.65-.292.429-.438 1.037-.438 1.824 0 .787.144 1.387.433 1.801.292.411.724.616 1.294.616Zm-.143.793c-.805 0-1.434-.284-1.887-.85-.452-.566-.678-1.357-.678-2.371 0-1.023.228-1.821.684-2.395.456-.573 1.091-.86 1.904-.86.855 0 1.513.323 1.972.969h.052l.137-.855h.746v9.052h-.946v-2.673c0-.38.021-.703.063-.969h-.074c-.437.634-1.095.952-1.973.952Zm5.832-6.362v4.053c0 .509.116.889.348 1.14.231.251.594.376 1.088.376.654 0 1.131-.178 1.431-.536.304-.357.456-.94.456-1.75v-3.283h.947v6.248h-.781l-.137-.838h-.051a1.885 1.885 0 0 1-.81.706 2.682 2.682 0 0 1-1.174.246c-.76 0-1.33-.181-1.71-.542-.377-.361-.565-.939-.565-1.733v-4.087h.958Zm7.228 6.248h-.946v-6.248h.946v6.248Zm-1.026-7.941c0-.217.053-.375.16-.474a.552.552 0 0 1 .399-.153c.152 0 .283.051.393.153.11.103.165.261.165.474 0 .212-.055.372-.165.478a.555.555 0 0 1-.393.154.55.55 0 0 1-.399-.154c-.107-.106-.16-.266-.16-.478Zm5.883 1.579c.278 0 .526.022.747.068l-.131.878a3.236 3.236 0 0 0-.684-.086c-.506 0-.939.206-1.3.616-.357.411-.536.922-.536 1.534v3.352h-.946v-6.248h.781l.108 1.157h.046c.232-.407.511-.72.838-.941a1.89 1.89 0 0 1 1.077-.33Zm4.555 6.476c-.924 0-1.653-.282-2.189-.844-.532-.563-.798-1.344-.798-2.343 0-1.007.247-1.807.741-2.4.498-.593 1.165-.889 2.001-.889.783 0 1.402.258 1.858.775.456.513.684 1.191.684 2.035v.599h-4.304c.019.733.204 1.29.553 1.67.354.38.85.57 1.488.57.673 0 1.338-.141 1.995-.422v.844a4.875 4.875 0 0 1-.952.308 5.172 5.172 0 0 1-1.077.097Zm-.257-5.684c-.501 0-.902.163-1.202.49-.297.327-.472.779-.525 1.357h3.266c0-.597-.133-1.053-.399-1.368-.266-.319-.646-.479-1.14-.479Zm8.426 4.732h-.052c-.437.634-1.09.952-1.961.952-.817 0-1.453-.28-1.909-.838-.452-.559-.679-1.353-.679-2.383s.228-1.83.684-2.4c.456-.57 1.091-.855 1.904-.855.848 0 1.498.308 1.95.923h.074l-.04-.45-.023-.439v-2.543h.947v8.871h-.77l-.125-.838Zm-1.893.159c.646 0 1.114-.175 1.402-.524.293-.354.439-.922.439-1.705v-.199c0-.886-.148-1.517-.444-1.893-.293-.38-.762-.57-1.408-.57-.555 0-.981.217-1.277.65-.293.429-.439 1.037-.439 1.824 0 .798.146 1.401.439 1.807.292.407.722.61 1.288.61Z",
                className: "payoff-simulator_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M36.74 221.884c0 1.44-.228 2.516-.684 3.227-.452.71-1.146 1.066-2.08 1.066-.898 0-1.58-.363-2.047-1.089-.468-.73-.701-1.798-.701-3.204 0-1.452.226-2.529.678-3.232.452-.703 1.142-1.055 2.07-1.055.904 0 1.59.367 2.057 1.1.471.734.707 1.796.707 3.187Zm-4.555 0c0 1.212.143 2.096.428 2.651.285.551.74.826 1.362.826.631 0 1.087-.279 1.368-.838.285-.562.428-1.442.428-2.639 0-1.197-.142-2.073-.428-2.628-.28-.559-.737-.838-1.368-.838-.623 0-1.077.276-1.362.827-.285.547-.428 1.427-.428 2.639Zm6.009 3.574c0-.254.057-.446.17-.576.119-.133.286-.199.502-.199.22 0 .392.066.514.199.125.13.188.322.188.576 0 .247-.063.437-.188.57-.126.133-.297.2-.514.2a.691.691 0 0 1-.484-.177c-.125-.122-.188-.319-.188-.593Zm8.34-3.574c0 1.44-.228 2.516-.684 3.227-.453.71-1.146 1.066-2.081 1.066-.897 0-1.58-.363-2.047-1.089-.467-.73-.7-1.798-.7-3.204 0-1.452.225-2.529.678-3.232.452-.703 1.142-1.055 2.069-1.055.904 0 1.59.367 2.058 1.1.471.734.707 1.796.707 3.187Zm-4.555 0c0 1.212.142 2.096.428 2.651.285.551.739.826 1.362.826.63 0 1.087-.279 1.368-.838.285-.562.428-1.442.428-2.639 0-1.197-.143-2.073-.428-2.628-.281-.559-.737-.838-1.368-.838-.623 0-1.078.276-1.362.827-.286.547-.428 1.427-.428 2.639Zm11.236 0c0 1.44-.228 2.516-.684 3.227-.453.71-1.146 1.066-2.081 1.066-.897 0-1.58-.363-2.047-1.089-.467-.73-.7-1.798-.7-3.204 0-1.452.225-2.529.678-3.232.452-.703 1.142-1.055 2.069-1.055.904 0 1.59.367 2.058 1.1.471.734.707 1.796.707 3.187Zm-4.555 0c0 1.212.143 2.096.428 2.651.285.551.739.826 1.362.826.63 0 1.087-.279 1.368-.838.285-.562.428-1.442.428-2.639 0-1.197-.143-2.073-.428-2.628-.281-.559-.737-.838-1.368-.838-.623 0-1.078.276-1.363.827-.285.547-.427 1.427-.427 2.639Zm8.471-4.275c.76 0 1.362.176 1.807.53.445.353.667.842.667 1.465 0 .41-.127.785-.382 1.123-.255.338-.661.646-1.22.923.677.323 1.157.663 1.442 1.021.285.353.428.764.428 1.231 0 .692-.241 1.245-.724 1.659-.483.41-1.144.616-1.984.616-.89 0-1.573-.194-2.052-.582-.479-.391-.718-.944-.718-1.659 0-.954.581-1.697 1.744-2.229-.524-.296-.9-.615-1.129-.957a2.059 2.059 0 0 1-.342-1.158c0-.604.223-1.085.667-1.442.449-.361 1.047-.541 1.796-.541Zm-1.801 6.35c0 .456.157.811.473 1.066.319.255.766.382 1.34.382.566 0 1.007-.133 1.322-.399.315-.266.473-.631.473-1.095 0-.368-.148-.695-.445-.98-.296-.289-.813-.568-1.55-.838-.566.243-.977.513-1.231.809a1.554 1.554 0 0 0-.382 1.055Zm1.79-5.581c-.475 0-.848.114-1.118.342-.27.228-.405.532-.405.912 0 .35.113.65.337.901.224.251.638.502 1.243.752.543-.228.927-.473 1.151-.735.228-.262.342-.568.342-.918 0-.384-.139-.688-.416-.912-.274-.228-.652-.342-1.134-.342Zm12.187 7.684h-4.646v-8.334h4.646v.861H65.63v2.685h3.455v.855h-3.454v3.067h3.676v.866Zm4.418 0h-.969v-7.473h-2.64v-.861h6.249v.861h-2.64v7.473Zm10.227 0h-.969v-3.921h-4.39v3.921h-.969v-8.334h.97v3.546h4.389v-3.546h.97v8.334Z",
                className: "payoff-simulator_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m24.558 194.148-.908-2.319h-2.923l-.898 2.319h-.858l2.884-7.322h.713l2.868 7.322h-.878Zm-1.172-3.082-.848-2.26c-.11-.286-.223-.636-.34-1.052-.073.319-.177.67-.314 1.052l-.858 2.26h2.36Zm9.896 3.082v-3.556c0-.436-.093-.761-.28-.978-.186-.219-.475-.329-.867-.329-.516 0-.896.148-1.142.444-.247.296-.37.752-.37 1.367v3.052h-.828v-3.556c0-.436-.093-.761-.279-.978-.186-.219-.477-.329-.873-.329-.519 0-.9.156-1.142.469-.24.309-.36.818-.36 1.526v2.868h-.827v-5.466h.673l.135.748h.04c.156-.266.376-.474.658-.624.286-.149.605-.224.958-.224.854 0 1.413.309 1.676.928h.04c.163-.286.399-.512.708-.679a2.2 2.2 0 0 1 1.057-.249c.619 0 1.081.159 1.387.479.31.316.464.823.464 1.521v3.566h-.828Zm7.258-2.738c0 .891-.225 1.588-.674 2.09-.449.499-1.069.748-1.86.748-.49 0-.923-.115-1.302-.344a2.27 2.27 0 0 1-.878-.988c-.206-.429-.31-.931-.31-1.506 0-.891.223-1.584.669-2.08.446-.499 1.064-.748 1.855-.748.765 0 1.372.254 1.821.763.452.509.678 1.197.678 2.065Zm-4.166 0c0 .698.14 1.23.42 1.596.279.366.69.549 1.232.549.541 0 .952-.181 1.232-.544.282-.366.423-.899.423-1.601 0-.695-.14-1.222-.423-1.581-.28-.363-.694-.544-1.242-.544-.542 0-.951.178-1.227.534-.276.356-.415.886-.415 1.591Zm6.4-2.728v3.546c0 .446.102.778.304.998.203.219.52.329.953.329.572 0 .99-.156 1.252-.469.266-.313.4-.823.4-1.531v-2.873h.827v5.466h-.683l-.12-.733h-.045c-.17.27-.406.476-.708.619-.3.143-.642.214-1.028.214-.665 0-1.164-.158-1.496-.474-.33-.316-.494-.821-.494-1.516v-3.576h.838Zm9.238 5.466v-3.536c0-.446-.102-.778-.304-.998-.203-.219-.52-.329-.953-.329-.572 0-.991.155-1.257.464-.266.309-.4.82-.4 1.531v2.868h-.827v-5.466h.673l.135.748h.04c.17-.27.407-.477.713-.624a2.304 2.304 0 0 1 1.023-.224c.658 0 1.154.159 1.486.479.333.316.499.823.499 1.521v3.566h-.828Zm4.3-.583c.146 0 .287-.01.423-.03.137-.023.245-.047.325-.07v.634c-.09.043-.223.078-.4.104-.172.03-.329.045-.468.045-1.058 0-1.586-.557-1.586-1.671v-3.252h-.784v-.399l.784-.344.349-1.167h.479v1.267h1.586v.643h-1.586v3.217c0 .33.078.582.234.758.156.177.37.265.644.265Zm6.963-4.24h-1.392v4.823h-.828v-4.823h-.978v-.374l.978-.299v-.305c0-1.343.587-2.015 1.76-2.015.29 0 .63.058 1.018.175l-.214.663a2.74 2.74 0 0 0-.818-.154c-.313 0-.544.104-.694.314-.15.206-.224.539-.224.997v.355h1.392v.643Zm1.775-.643v3.546c0 .446.102.778.305.998.203.219.52.329.952.329.572 0 .99-.156 1.252-.469.266-.313.4-.823.4-1.531v-2.873h.827v5.466h-.683l-.12-.733h-.045c-.17.27-.405.476-.708.619-.3.143-.642.214-1.027.214-.665 0-1.164-.158-1.497-.474-.329-.316-.494-.821-.494-1.516v-3.576h.838Zm9.238 5.466v-3.536c0-.446-.101-.778-.304-.998-.203-.219-.52-.329-.953-.329-.572 0-.99.155-1.257.464-.266.309-.399.82-.399 1.531v2.868h-.828v-5.466h.674l.134.748h.04c.17-.27.407-.477.713-.624a2.304 2.304 0 0 1 1.023-.224c.658 0 1.154.159 1.486.479.333.316.5.823.5 1.521v3.566h-.829Zm6.255-.733h-.045c-.382.556-.954.833-1.716.833-.715 0-1.272-.244-1.67-.733-.396-.489-.594-1.184-.594-2.085s.2-1.601.598-2.1c.4-.499.955-.748 1.666-.748.742 0 1.31.269 1.706.808h.065l-.035-.394-.02-.384v-2.225h.828v7.761h-.673l-.11-.733Zm-1.656.14c.565 0 .974-.153 1.227-.459.256-.309.384-.806.384-1.491v-.175c0-.775-.13-1.327-.389-1.656-.256-.333-.667-.499-1.232-.499-.485 0-.858.19-1.117.569-.256.376-.384.908-.384 1.596 0 .698.128 1.225.384 1.581.256.356.632.534 1.127.534Zm6.51.693c-.809 0-1.447-.246-1.916-.738-.466-.492-.698-1.176-.698-2.05 0-.881.216-1.581.648-2.1.436-.519 1.02-.778 1.75-.778.686 0 1.228.226 1.627.678.399.449.598 1.043.598 1.781v.524h-3.765c.016.641.177 1.129.483 1.461.31.333.744.499 1.302.499.589 0 1.17-.123 1.746-.369v.738a4.24 4.24 0 0 1-.833.269c-.26.057-.573.085-.943.085Zm-.225-4.973c-.439 0-.79.143-1.052.429-.26.286-.413.682-.46 1.187h2.859c0-.522-.117-.921-.35-1.197-.232-.279-.565-.419-.997-.419Zm7.372 4.14H92.5c-.382.556-.954.833-1.716.833-.715 0-1.272-.244-1.67-.733-.396-.489-.594-1.184-.594-2.085s.2-1.601.598-2.1c.4-.499.955-.748 1.666-.748.742 0 1.31.269 1.706.808h.065l-.035-.394-.02-.384v-2.225h.828v7.761h-.673l-.11-.733Zm-1.656.14c.565 0 .974-.153 1.227-.459.256-.309.384-.806.384-1.491v-.175c0-.775-.13-1.327-.389-1.656-.256-.333-.666-.499-1.232-.499-.485 0-.858.19-1.117.569-.256.376-.384.908-.384 1.596 0 .698.128 1.225.384 1.581.256.356.632.534 1.127.534Z",
                className: "payoff-simulator_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "payoff-simulator_svg__line-1",
                d: "M18.971 158.702h294.058"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M48.112 114.635c0 .761-.25 1.345-.748 1.751-.5.405-1.21.608-2.13.608h-.758v2.729h-1.193v-7.293h2.1c.912 0 1.593.186 2.045.559.456.372.684.921.684 1.646Zm-3.636 1.357h.633c.612 0 1.06-.107 1.347-.32.286-.212.429-.545.429-.997 0-.419-.128-.732-.384-.938-.256-.206-.655-.309-1.197-.309h-.828v2.564Zm8.42 3.731-.235-.768h-.04c-.266.335-.534.565-.803.688-.27.12-.615.179-1.038.179-.542 0-.966-.146-1.272-.439-.302-.292-.453-.706-.453-1.242 0-.568.21-.997.633-1.286.422-.29 1.066-.448 1.93-.474l.953-.03v-.295c0-.352-.083-.615-.25-.788-.162-.176-.417-.264-.762-.264-.283 0-.554.042-.813.125a6.12 6.12 0 0 0-.749.294l-.379-.838c.3-.156.627-.274.983-.354a4.446 4.446 0 0 1 1.007-.125c.702 0 1.23.153 1.587.459.359.306.538.787.538 1.442v3.716h-.838Zm-1.746-.798c.425 0 .766-.118 1.022-.355.26-.239.39-.573.39-1.002v-.479l-.71.03c-.551.02-.953.113-1.206.279-.25.163-.374.414-.374.753 0 .247.073.438.22.574.145.133.365.2.658.2Zm3.381-4.719h1.277l1.123 3.127c.17.446.282.865.339 1.257h.04c.03-.183.084-.404.164-.663.08-.263.502-1.503 1.267-3.721h1.267l-2.36 6.25c-.428 1.147-1.143 1.721-2.144 1.721-.26 0-.512-.029-.758-.085v-.928c.176.04.377.06.603.06.566 0 .963-.328 1.193-.983l.204-.518-2.215-5.517Zm13.523 5.517H63.11v-.888l1.88-1.891c.555-.568.923-.971 1.103-1.207.182-.239.315-.464.399-.673.083-.21.124-.434.124-.673 0-.33-.1-.589-.299-.779-.196-.189-.469-.284-.818-.284-.28 0-.55.052-.813.155-.26.103-.56.289-.903.558l-.633-.773c.405-.342.8-.585 1.182-.728a3.46 3.46 0 0 1 1.222-.215c.678 0 1.222.178 1.63.534.41.353.614.828.614 1.427 0 .329-.06.642-.18.937a3.745 3.745 0 0 1-.543.918c-.243.313-.648.737-1.217 1.272l-1.267 1.227v.05h3.462v1.033Zm5.561-5.617c0 .462-.134.848-.404 1.157-.269.306-.648.513-1.137.619v.04c.585.073 1.024.256 1.317.548.293.29.439.676.439 1.158 0 .701-.248 1.243-.743 1.626-.496.379-1.2.568-2.115.568-.808 0-1.49-.131-2.045-.394v-1.042a4.66 4.66 0 0 0 1.98.479c.565 0 .987-.105 1.267-.315.28-.209.419-.533.419-.972 0-.389-.155-.675-.464-.858-.31-.183-.795-.274-1.457-.274h-.633v-.953h.644c1.163 0 1.745-.403 1.745-1.207 0-.313-.101-.554-.304-.723-.203-.17-.502-.255-.898-.255-.276 0-.542.04-.798.12-.256.076-.559.228-.908.454l-.573-.818c.668-.492 1.444-.739 2.329-.739.735 0 1.309.158 1.72.474.413.316.62.752.62 1.307Zm6.11 1.97c0 1.267-.204 2.208-.613 2.824-.405.615-1.027.922-1.865.922-.812 0-1.427-.317-1.846-.952-.419-.635-.628-1.567-.628-2.794 0-1.286.202-2.234.608-2.843.41-.612 1.031-.917 1.866-.917.814 0 1.431.319 1.85.957.42.639.629 1.573.629 2.803Zm-3.765 0c0 .995.101 1.705.304 2.13.206.426.534.639.983.639.449 0 .776-.216.982-.649.21-.432.314-1.139.314-2.12 0-.977-.104-1.684-.314-2.119-.206-.439-.533-.659-.982-.659-.45 0-.777.215-.983.644-.203.429-.304 1.14-.304 2.134Zm13.757-.069c0 1.203-.335 2.124-1.003 2.763-.668.635-1.631.953-2.888.953h-2.04v-7.293h2.254c1.161 0 2.064.313 2.709.938s.968 1.505.968 2.639Zm-1.257.04c0-1.746-.817-2.619-2.45-2.619h-1.032v5.292h.848c1.756 0 2.634-.891 2.634-2.673Zm7.352 3.676-.728-2.025h-2.789l-.713 2.025h-1.257l2.729-7.323h1.296l2.729 7.323h-1.267Zm-1.043-3.053-.683-1.985a15.124 15.124 0 0 1-.39-1.257c-.089.409-.22.856-.393 1.342l-.659 1.9h2.125Zm3.272 3.053v-7.293h1.193v7.293h-1.192Z",
                className: "payoff-simulator_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 18.971,
                y: 107.266,
                width: 17.512,
                height: 17.512,
                rx: 2.189,
                className: "payoff-simulator_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M33.14 111.645h-1.292a.875.875 0 0 0-.713.366l-4.33 6.003-1.96-2.721a.882.882 0 0 0-.713-.366H22.84c-.178 0-.283.204-.178.35l3.43 4.758a.88.88 0 0 0 .712.366.883.883 0 0 0 .712-.366l5.8-8.041a.219.219 0 0 0-.177-.349Z",
                className: "payoff-simulator_svg__path-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M147.347 114.635c0 .761-.249 1.345-.748 1.751-.499.405-1.209.608-2.13.608h-.758v2.729h-1.192v-7.293h2.1c.911 0 1.592.186 2.045.559.455.372.683.921.683 1.646Zm-3.636 1.357h.633c.612 0 1.061-.107 1.347-.32.286-.212.429-.545.429-.997 0-.419-.128-.732-.384-.938-.256-.206-.655-.309-1.197-.309h-.828v2.564Zm8.419 3.731-.234-.768h-.04c-.266.335-.534.565-.803.688-.269.12-.615.179-1.037.179-.543 0-.966-.146-1.272-.439-.303-.292-.454-.706-.454-1.242 0-.568.211-.997.633-1.286.422-.29 1.066-.448 1.931-.474l.952-.03v-.295c0-.352-.083-.615-.249-.788-.163-.176-.418-.264-.763-.264-.283 0-.554.042-.813.125-.26.083-.509.181-.749.294l-.379-.838c.3-.156.627-.274.983-.354a4.449 4.449 0 0 1 1.008-.125c.701 0 1.23.153 1.586.459.359.306.538.787.538 1.442v3.716h-.838Zm-1.745-.798c.425 0 .766-.118 1.022-.355.26-.239.389-.573.389-1.002v-.479l-.708.03c-.552.02-.954.113-1.207.279-.25.163-.374.414-.374.753 0 .247.073.438.219.574.147.133.366.2.659.2Zm3.381-4.719h1.277l1.123 3.127c.169.446.282.865.339 1.257h.04c.03-.183.085-.404.164-.663.08-.263.503-1.503 1.267-3.721h1.267l-2.359 6.25c-.429 1.147-1.144 1.721-2.145 1.721-.259 0-.512-.029-.758-.085v-.928c.176.04.377.06.604.06.565 0 .962-.328 1.192-.983l.204-.518-2.215-5.517Zm12.022 5.517h-1.173v-4.709c0-.562.014-1.008.04-1.337-.076.08-.171.168-.284.265-.11.096-.482.402-1.117.917l-.589-.743 2.145-1.686h.978v7.293Zm7.327-4.18c0 1.436-.289 2.509-.868 3.217-.579.708-1.45 1.062-2.614 1.062-.442 0-.76-.026-.952-.079v-.983c.296.083.593.125.892.125.792 0 1.382-.213 1.771-.639.389-.425.602-1.094.639-2.005h-.06a1.759 1.759 0 0 1-.714.648c-.276.133-.6.2-.972.2-.645 0-1.152-.201-1.522-.604-.369-.402-.553-.954-.553-1.656 0-.761.213-1.366.638-1.815.429-.452 1.013-.679 1.751-.679.519 0 .971.127 1.357.38.386.252.683.62.893 1.102.209.479.314 1.054.314 1.726Zm-2.544-2.235c-.406 0-.717.133-.933.399-.216.263-.324.634-.324 1.112 0 .416.1.744.299.983.203.236.509.354.918.354.396 0 .728-.118.998-.354.269-.236.404-.512.404-.828 0-.296-.058-.572-.175-.828a1.456 1.456 0 0 0-.479-.613 1.172 1.172 0 0 0-.708-.225Zm8.39 2.768c0 1.267-.205 2.208-.614 2.824-.405.615-1.027.922-1.865.922-.812 0-1.427-.317-1.846-.952-.419-.635-.628-1.567-.628-2.794 0-1.286.203-2.234.608-2.843.409-.612 1.031-.917 1.866-.917.814 0 1.431.319 1.85.957.419.639.629 1.573.629 2.803Zm-3.766 0c0 .995.101 1.705.304 2.13.206.426.534.639.983.639.449 0 .776-.216.982-.649.21-.432.315-1.139.315-2.12 0-.977-.105-1.684-.315-2.119-.206-.439-.533-.659-.982-.659-.449 0-.777.215-.983.644-.203.429-.304 1.14-.304 2.134Zm13.757-.069c0 1.203-.334 2.124-1.003 2.763-.668.635-1.631.953-2.888.953h-2.04v-7.293h2.255c1.16 0 2.063.313 2.708.938s.968 1.505.968 2.639Zm-1.257.04c0-1.746-.817-2.619-2.449-2.619h-1.033v5.292h.848c1.756 0 2.634-.891 2.634-2.673Zm7.352 3.676-.728-2.025h-2.789l-.713 2.025h-1.257l2.729-7.323h1.297l2.728 7.323h-1.267Zm-1.042-3.053-.684-1.985c-.05-.133-.12-.343-.209-.629a14.083 14.083 0 0 1-.18-.628c-.09.409-.221.856-.394 1.342l-.658 1.9h2.125Zm3.272 3.053v-7.293h1.192v7.293h-1.192Z",
                className: "payoff-simulator_svg__path-12"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 118.207,
                y: 107.266,
                width: 17.512,
                height: 17.512,
                rx: 2.189,
                className: "payoff-simulator_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M132.374 111.645h-1.291a.874.874 0 0 0-.713.366l-4.329 6.003-1.961-2.721a.88.88 0 0 0-.713-.366h-1.291a.221.221 0 0 0-.179.35l3.431 4.758a.885.885 0 0 0 1.112.269.885.885 0 0 0 .311-.269l5.8-8.041a.22.22 0 0 0-.177-.349Z",
                className: "payoff-simulator_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M246.582 114.635c0 .761-.249 1.345-.748 1.751-.499.405-1.209.608-2.13.608h-.758v2.729h-1.192v-7.293h2.1c.911 0 1.593.186 2.045.559.456.372.683.921.683 1.646Zm-3.636 1.357h.634c.611 0 1.06-.107 1.346-.32.286-.212.429-.545.429-.997 0-.419-.128-.732-.384-.938-.256-.206-.655-.309-1.197-.309h-.828v2.564Zm8.42 3.731-.235-.768h-.04c-.266.335-.533.565-.803.688-.269.12-.615.179-1.037.179-.542 0-.966-.146-1.272-.439-.303-.292-.454-.706-.454-1.242 0-.568.211-.997.634-1.286.422-.29 1.065-.448 1.93-.474l.953-.03v-.295c0-.352-.084-.615-.25-.788-.163-.176-.417-.264-.763-.264-.283 0-.554.042-.813.125a6.117 6.117 0 0 0-.748.294l-.379-.838c.299-.156.626-.274.982-.354a4.449 4.449 0 0 1 1.008-.125c.702 0 1.23.153 1.586.459.359.306.539.787.539 1.442v3.716h-.838Zm-1.746-.798c.426 0 .766-.118 1.023-.355.259-.239.389-.573.389-1.002v-.479l-.709.03c-.552.02-.954.113-1.207.279-.249.163-.374.414-.374.753 0 .247.073.438.22.574.146.133.365.2.658.2Zm3.382-4.719h1.277l1.122 3.127c.17.446.283.865.339 1.257h.04c.03-.183.085-.404.165-.663.08-.263.502-1.503 1.267-3.721h1.267l-2.36 6.25c-.429 1.147-1.144 1.721-2.145 1.721-.259 0-.512-.029-.758-.085v-.928c.177.04.378.06.604.06.565 0 .963-.328 1.192-.983l.205-.518-2.215-5.517Zm12.021 5.517h-1.172v-4.709c0-.562.013-1.008.04-1.337-.077.08-.172.168-.285.265-.109.096-.482.402-1.117.917l-.589-.743 2.145-1.686h.978v7.293Zm4.868-4.554c.735 0 1.317.194 1.746.583.429.389.643.92.643 1.591 0 .779-.244 1.387-.733 1.826-.485.436-1.177.653-2.075.653-.815 0-1.455-.131-1.92-.394v-1.062a3.5 3.5 0 0 0 .928.354c.349.083.673.125.972.125.529 0 .931-.118 1.207-.354s.414-.582.414-1.038c0-.871-.555-1.307-1.666-1.307-.156 0-.349.017-.578.05-.23.03-.431.065-.604.105l-.524-.309.28-3.562h3.791v1.043h-2.759l-.164 1.805c.116-.02.257-.043.424-.069.169-.027.375-.04.618-.04Zm8.305.907c0 1.267-.204 2.208-.613 2.824-.406.615-1.028.922-1.866.922-.811 0-1.426-.317-1.845-.952-.419-.635-.629-1.567-.629-2.794 0-1.286.203-2.234.609-2.843.409-.612 1.03-.917 1.865-.917.815 0 1.432.319 1.851.957.419.639.628 1.573.628 2.803Zm-3.766 0c0 .995.102 1.705.304 2.13.207.426.534.639.983.639.449 0 .777-.216.983-.649.209-.432.314-1.139.314-2.12 0-.977-.105-1.684-.314-2.119-.206-.439-.534-.659-.983-.659-.449 0-.776.215-.983.644-.202.429-.304 1.14-.304 2.134Zm13.757-.069c0 1.203-.334 2.124-1.003 2.763-.668.635-1.631.953-2.888.953h-2.04v-7.293h2.255c1.16 0 2.063.313 2.708.938s.968 1.505.968 2.639Zm-1.257.04c0-1.746-.816-2.619-2.449-2.619h-1.033v5.292h.848c1.756 0 2.634-.891 2.634-2.673Zm7.352 3.676-.728-2.025h-2.788l-.713 2.025h-1.257l2.728-7.323h1.297l2.728 7.323h-1.267Zm-1.042-3.053-.683-1.985c-.05-.133-.12-.343-.21-.629a17.544 17.544 0 0 1-.18-.628 11.05 11.05 0 0 1-.394 1.342l-.658 1.9h2.125Zm3.272 3.053v-7.293h1.192v7.293h-1.192Z",
                className: "payoff-simulator_svg__path-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 217.807,
                y: 107.63,
                width: 16.782,
                height: 16.782,
                rx: 1.824,
                className: "payoff-simulator_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M26.304 77.39c0 1.168-.296 2.086-.888 2.754-.589.668-1.408 1.003-2.46 1.003-1.073 0-1.903-.328-2.488-.983-.582-.658-.873-1.586-.873-2.783 0-1.187.293-2.107.878-2.759.585-.655 1.416-.982 2.494-.982 1.047 0 1.865.332 2.454.997.588.665.883 1.583.883 2.754Zm-5.811 0c0 .988.21 1.738.628 2.25.423.509 1.034.763 1.836.763.808 0 1.418-.254 1.83-.763.413-.508.619-1.258.619-2.25 0-.98-.206-1.724-.619-2.229-.409-.509-1.015-.763-1.82-.763-.808 0-1.423.256-1.846.768-.419.509-.628 1.25-.628 2.225Zm9.861 3.757c-.356 0-.682-.065-.978-.195a1.859 1.859 0 0 1-.738-.608h-.06c.04.319.06.621.06.907v2.25h-.828V75.58h.674l.114.748h.04c.213-.299.46-.515.743-.648s.607-.2.973-.2c.725 0 1.284.248 1.676.743.396.496.593 1.191.593 2.085 0 .898-.2 1.597-.603 2.095-.399.496-.954.744-1.666.744Zm-.12-4.963c-.558 0-.962.154-1.212.463-.25.31-.377.802-.384 1.477v.184c0 .769.128 1.319.384 1.651.256.33.667.494 1.232.494.472 0 .842-.19 1.108-.573.269-.383.404-.91.404-1.581 0-.682-.135-1.204-.404-1.567-.266-.365-.642-.548-1.128-.548Zm5.607 4.28c.146 0 .287-.01.424-.03.136-.024.244-.047.324-.07v.633a1.47 1.47 0 0 1-.4.105c-.172.03-.328.045-.468.045-1.057 0-1.586-.557-1.586-1.671v-3.252h-.783v-.4l.783-.344.35-1.167h.478v1.267h1.586v.644h-1.586v3.217c0 .329.078.582.234.758.157.176.371.264.644.264Zm2.673.583h-.828V75.58h.828v5.467Zm-.898-6.948c0-.19.047-.328.14-.414a.483.483 0 0 1 .35-.135c.132 0 .247.045.343.135.097.09.145.227.145.414 0 .186-.048.325-.145.419a.488.488 0 0 1-.344.134.483.483 0 0 1-.349-.134c-.093-.094-.14-.233-.14-.42Zm7.373 4.21c0 .89-.225 1.587-.674 2.09-.449.498-1.069.748-1.86.748-.489 0-.923-.115-1.302-.345a2.272 2.272 0 0 1-.878-.987c-.206-.43-.31-.931-.31-1.507 0-.89.224-1.584.67-2.08.445-.498 1.063-.748 1.855-.748.765 0 1.371.255 1.82.763.453.51.679 1.198.679 2.066Zm-4.165 0c0 .698.14 1.23.419 1.596.28.365.69.548 1.232.548s.953-.18 1.232-.543c.282-.366.424-.9.424-1.602 0-.695-.142-1.222-.424-1.58-.28-.363-.694-.544-1.242-.544-.542 0-.951.178-1.227.533-.276.356-.414.886-.414 1.591Zm9.362 2.738V77.51c0-.445-.101-.778-.304-.997-.203-.22-.52-.33-.953-.33-.572 0-.99.155-1.257.464-.266.31-.399.82-.399 1.532v2.868h-.828V75.58h.674l.134.748h.04c.17-.27.407-.477.714-.623.305-.15.646-.225 1.022-.225.658 0 1.154.16 1.486.48.333.315.5.822.5 1.52v3.567h-.829Zm6.06-1.492c0 .51-.189.902-.568 1.178-.38.276-.911.414-1.596.414-.725 0-1.29-.115-1.696-.345v-.768c.263.133.544.238.843.315.303.076.593.114.873.114.432 0 .765-.068.997-.204a.69.69 0 0 0 .35-.634c0-.213-.094-.394-.28-.543-.183-.153-.542-.333-1.077-.54-.509-.189-.871-.353-1.088-.493a1.54 1.54 0 0 1-.478-.484 1.272 1.272 0 0 1-.155-.643c0-.446.181-.797.544-1.053.362-.259.86-.389 1.491-.389.589 0 1.164.12 1.726.36l-.294.673c-.55-.226-1.046-.34-1.492-.34-.392 0-.688.062-.888.185-.2.123-.299.293-.299.509 0 .146.037.271.11.374.076.103.198.201.364.294.166.093.485.228.958.404.648.237 1.085.474 1.311.714.23.24.345.54.345.902Zm6.47-3.332h-1.392v4.824h-.828v-4.823h-.977v-.375l.977-.299v-.304c0-1.344.587-2.015 1.761-2.015.29 0 .629.058 1.018.174l-.215.664a2.738 2.738 0 0 0-.818-.155c-.312 0-.543.105-.693.314-.15.207-.225.539-.225.998v.354h1.392v.644Zm1.776-.643v3.546c0 .446.101.779.304.998.203.22.52.33.953.33.572 0 .989-.157 1.252-.47.266-.312.399-.823.399-1.53V75.58h.828v5.467h-.684l-.12-.733h-.044c-.17.269-.406.475-.709.618-.299.143-.641.215-1.027.215-.665 0-1.164-.158-1.496-.474-.33-.316-.494-.822-.494-1.517V75.58h.838Zm9.237 5.467V77.51c0-.445-.1-.778-.304-.997-.203-.22-.52-.33-.953-.33-.571 0-.99.155-1.256.464-.266.31-.4.82-.4 1.532v2.868h-.828V75.58h.674l.135.748h.04c.17-.27.407-.477.713-.623.306-.15.647-.225 1.022-.225.659 0 1.154.16 1.487.48.332.315.499.822.499 1.52v3.567h-.829Zm6.255-.733h-.044c-.383.555-.955.833-1.716.833-.715 0-1.272-.245-1.671-.734-.396-.488-.594-1.183-.594-2.085 0-.9.2-1.6.599-2.1.399-.498.954-.748 1.666-.748.741 0 1.31.27 1.706.808h.064l-.034-.394-.02-.384v-2.224h.828v7.76h-.674l-.11-.732Zm-1.656.14c.566 0 .975-.154 1.227-.46.256-.309.384-.806.384-1.491v-.175c0-.774-.13-1.326-.388-1.656-.257-.332-.667-.498-1.233-.498-.485 0-.858.19-1.117.568-.256.376-.384.908-.384 1.596 0 .699.128 1.226.384 1.582.256.355.632.533 1.127.533Zm6.51.693c-.808 0-1.447-.246-1.916-.739-.465-.492-.698-1.175-.698-2.05 0-.88.216-1.58.648-2.1.436-.518 1.02-.778 1.751-.778.685 0 1.227.226 1.626.679.4.449.599 1.042.599 1.78v.524h-3.766c.017.642.178 1.129.484 1.462.309.332.743.498 1.302.498.588 0 1.17-.123 1.745-.369v.739c-.292.126-.57.216-.832.269-.26.056-.574.085-.943.085Zm-.225-4.973c-.439 0-.79.143-1.052.429-.26.286-.413.681-.46 1.187h2.859c0-.522-.116-.921-.35-1.197-.232-.28-.564-.42-.997-.42Zm7.373 4.14h-.045c-.383.555-.955.833-1.716.833-.715 0-1.272-.245-1.671-.734-.396-.488-.594-1.183-.594-2.085 0-.9.2-1.6.599-2.1.399-.498.954-.748 1.666-.748.741 0 1.31.27 1.706.808h.065l-.035-.394-.02-.384v-2.224h.828v7.76h-.674l-.11-.732Zm-1.657.14c.566 0 .975-.154 1.228-.46.256-.309.384-.806.384-1.491v-.175c0-.774-.13-1.326-.39-1.656-.255-.332-.666-.498-1.231-.498-.486 0-.858.19-1.118.568-.256.376-.384.908-.384 1.596 0 .699.128 1.226.384 1.582.256.355.632.533 1.127.533Z",
                className: "payoff-simulator_svg__path-15"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "payoff-simulator_svg__line-2",
                d: "M18.971 46.334h294.058"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#payoff-simulator_svg__c)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m26.917 23.512-3.014 1.852-3.016-1.852 3.016-5.203 3.014 5.203Zm-3.014 2.446-3.016-1.851 3.016 4.417 3.016-4.417-3.016 1.851Z",
                    className: "payoff-simulator_svg__path-16"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M40.142 25.478c0 .641-.233 1.142-.699 1.501-.465.36-1.097.539-1.895.539-.864 0-1.53-.112-1.995-.335v-.817c.3.126.625.226.978.299.352.073.701.11 1.047.11.565 0 .991-.107 1.277-.32.286-.216.429-.515.429-.897 0-.253-.052-.46-.155-.62-.1-.162-.27-.312-.508-.448-.237-.136-.597-.29-1.083-.464-.678-.243-1.164-.53-1.456-.863-.29-.332-.434-.766-.434-1.302 0-.562.21-1.009.633-1.341.422-.333.981-.5 1.676-.5a4.94 4.94 0 0 1 2 .4l-.264.738c-.602-.253-1.187-.379-1.756-.379-.449 0-.8.096-1.052.29-.253.192-.38.46-.38.802 0 .253.047.46.14.624.093.16.25.307.47.444.222.133.561.28 1.017.444.765.272 1.29.565 1.576.878.29.312.434.718.434 1.217Zm3.676 2.04c-.808 0-1.447-.246-1.915-.739-.466-.492-.699-1.175-.699-2.05 0-.88.216-1.58.649-2.1.435-.518 1.019-.778 1.75-.778.685 0 1.227.227 1.627.679.399.449.598 1.042.598 1.78v.524h-3.766c.017.642.178 1.13.484 1.462.31.332.743.498 1.302.498.589 0 1.17-.123 1.746-.369v.739c-.293.126-.57.216-.833.269-.26.056-.574.085-.943.085Zm-.224-4.973c-.44 0-.79.143-1.053.429-.26.286-.412.681-.459 1.187h2.858c0-.522-.116-.921-.349-1.197-.233-.28-.565-.42-.998-.42Zm5.96 4.973c-.808 0-1.446-.246-1.915-.739-.466-.492-.699-1.175-.699-2.05 0-.88.217-1.58.649-2.1.436-.518 1.02-.778 1.75-.778.686 0 1.228.227 1.627.679.399.449.598 1.042.598 1.78v.524h-3.766c.017.642.178 1.13.484 1.462.31.332.743.498 1.302.498.589 0 1.17-.123 1.746-.369v.739c-.293.126-.57.216-.833.269-.26.056-.574.085-.943.085Zm-.224-4.973c-.44 0-.79.143-1.053.429-.26.286-.412.681-.459 1.187h2.858c0-.522-.116-.921-.349-1.197-.233-.28-.565-.42-.997-.42Zm10.046 4.873v-3.537c0-.445-.102-.778-.305-.997-.203-.22-.52-.33-.953-.33-.575 0-.995.157-1.261.47-.263.312-.395.824-.395 1.536v2.858h-.828v-7.761h.828v2.349c0 .283-.013.517-.04.703h.05c.163-.262.395-.469.694-.618.302-.153.647-.23 1.032-.23.669 0 1.17.16 1.502.48.336.315.503.819.503 1.51v3.567h-.828Zm7.252-2.738c0 .89-.224 1.587-.673 2.09-.45.498-1.07.748-1.86.748-.49 0-.924-.115-1.303-.344a2.271 2.271 0 0 1-.878-.988c-.206-.429-.309-.931-.309-1.506 0-.892.223-1.585.669-2.08.445-.5 1.064-.749 1.855-.749.765 0 1.372.255 1.82.764.453.508.679 1.197.679 2.065Zm-4.165 0c0 .698.14 1.23.419 1.596.28.366.69.548 1.232.548s.953-.18 1.232-.543c.283-.366.424-.9.424-1.601 0-.695-.141-1.223-.424-1.582-.28-.362-.693-.543-1.242-.543-.542 0-.95.178-1.227.533-.276.356-.414.887-.414 1.592Zm10.086 2.738-1.003-3.207a27.116 27.116 0 0 1-.354-1.337h-.04a18.32 18.32 0 0 1-.349 1.347l-1.033 3.197h-.957l-1.492-5.467h.868c.353 1.373.62 2.42.803 3.138.186.718.293 1.202.32 1.451h.04a13.38 13.38 0 0 1 .389-1.451l1.002-3.138h.898l.978 3.138c.186.572.312 1.052.379 1.441h.04c.013-.12.048-.304.104-.554.06-.249.408-1.59 1.043-4.025h.858l-1.512 5.467h-.982Zm13.108 0v-3.556c0-.436-.093-.762-.28-.978-.185-.22-.475-.33-.867-.33-.516 0-.896.149-1.142.445-.246.296-.37.751-.37 1.366v3.053h-.827v-3.556c0-.436-.094-.762-.28-.978-.186-.22-.477-.33-.873-.33-.518 0-.9.157-1.142.47-.24.309-.359.818-.359 1.526v2.868h-.828v-5.467h.673l.135.748h.04c.156-.266.376-.474.658-.623.286-.15.606-.225.958-.225.855 0 1.413.31 1.676.928h.04c.163-.286.399-.512.708-.678.31-.166.662-.25 1.058-.25.618 0 1.08.16 1.386.48.31.315.464.822.464 1.52v3.567h-.828Zm3.317-5.467v3.547c0 .445.102.778.304.997.203.22.52.33.953.33.572 0 .99-.157 1.252-.47.266-.312.4-.823.4-1.53V21.95h.827v5.467h-.683l-.12-.733h-.045c-.17.27-.405.475-.708.618-.3.143-.642.215-1.028.215-.665 0-1.163-.158-1.496-.474-.33-.316-.494-.822-.494-1.517v-3.576h.838Zm7.682 5.567c-.792 0-1.405-.243-1.84-.729-.433-.488-.65-1.178-.65-2.07 0-.914.22-1.62.66-2.12.441-.498 1.07-.748 1.885-.748.262 0 .525.029.788.085.262.057.469.123.618.2l-.254.703a3.721 3.721 0 0 0-.599-.18 2.593 2.593 0 0 0-.573-.074c-1.111 0-1.666.708-1.666 2.124 0 .672.134 1.188.404 1.547.272.359.675.538 1.207.538.455 0 .922-.098 1.401-.294v.733c-.366.19-.826.285-1.381.285Zm6.424-.1v-3.537c0-.445-.101-.778-.304-.997-.203-.22-.521-.33-.953-.33-.575 0-.996.157-1.262.47-.262.312-.394.824-.394 1.536v2.858h-.828v-7.761h.828v2.349c0 .283-.013.517-.04.703h.05c.163-.262.394-.469.694-.618.302-.153.646-.23 1.032-.23.668 0 1.169.16 1.501.48.336.315.504.819.504 1.51v3.567h-.828Zm4.32-5.467h.888l1.197 3.118c.262.711.425 1.225.489 1.54h.039c.044-.169.133-.458.27-.867.139-.412.592-1.676 1.357-3.79h.887l-2.349 6.224c-.233.615-.505 1.05-.818 1.307-.309.26-.69.39-1.142.39-.253 0-.502-.03-.748-.086v-.663c.182.04.387.06.613.06.569 0 .974-.32 1.217-.958l.304-.778-2.204-5.497Zm10.734 2.729c0 .89-.225 1.587-.673 2.09-.449.498-1.07.748-1.861.748-.489 0-.923-.115-1.302-.344a2.272 2.272 0 0 1-.878-.988c-.206-.429-.309-.931-.309-1.506 0-.892.223-1.585.668-2.08.446-.5 1.065-.749 1.856-.749.765 0 1.372.255 1.821.764.452.508.678 1.197.678 2.065Zm-4.165 0c0 .698.14 1.23.419 1.596.279.366.69.548 1.232.548s.953-.18 1.232-.543c.283-.366.424-.9.424-1.601 0-.695-.141-1.223-.424-1.582-.279-.362-.693-.543-1.242-.543-.542 0-.951.178-1.227.533-.276.356-.414.887-.414 1.592Zm6.4-2.729v3.547c0 .445.101.778.304.997.203.22.52.33.952.33.572 0 .99-.157 1.252-.47.266-.312.4-.823.4-1.53V21.95h.828v5.467h-.684l-.12-.733h-.044c-.17.27-.406.475-.709.618a2.355 2.355 0 0 1-1.027.215c-.665 0-1.164-.158-1.497-.474-.329-.316-.493-.822-.493-1.517v-3.576h.838Zm10.335 5.567c-.792 0-1.405-.243-1.841-.729-.432-.488-.648-1.178-.648-2.07 0-.914.219-1.62.658-2.12.442-.498 1.071-.748 1.885-.748.263 0 .526.029.789.085.262.057.468.123.618.2l-.254.703a3.732 3.732 0 0 0-.599-.18 2.588 2.588 0 0 0-.573-.074c-1.111 0-1.666.708-1.666 2.124 0 .672.134 1.188.404 1.547.272.359.675.538 1.207.538.455 0 .922-.098 1.401-.294v.733c-.365.19-.826.285-1.381.285Zm6.045-.1-.165-.778h-.039c-.273.342-.546.575-.818.698-.27.12-.607.18-1.013.18-.542 0-.968-.14-1.277-.42-.306-.279-.459-.676-.459-1.191 0-1.104.883-1.683 2.649-1.736l.928-.03v-.34c0-.428-.094-.744-.28-.947-.183-.206-.477-.31-.883-.31-.455 0-.971.14-1.546.42l-.254-.634a3.88 3.88 0 0 1 .883-.344c.322-.083.645-.125.967-.125.652 0 1.134.145 1.447.434.316.29.474.753.474 1.392v3.731h-.614Zm-1.87-.584c.515 0 .919-.141 1.212-.424.296-.282.444-.678.444-1.187v-.494l-.828.035c-.659.024-1.134.127-1.427.31-.289.18-.434.46-.434.843 0 .299.09.527.269.683.183.156.438.234.764.234Zm7.935.584v-3.537c0-.445-.101-.778-.304-.997-.203-.22-.52-.33-.953-.33-.571 0-.99.155-1.257.465-.266.309-.399.82-.399 1.53v2.869h-.828v-5.467h.674l.135.748h.039c.17-.269.408-.477.714-.623.306-.15.646-.225 1.022-.225.659 0 1.154.16 1.487.48.332.315.498.822.498 1.52v3.567h-.828Zm7.497.1c-.808 0-1.446-.246-1.915-.739-.466-.492-.698-1.175-.698-2.05 0-.88.216-1.58.648-2.1.436-.518 1.019-.778 1.751-.778.685 0 1.227.227 1.626.679.399.449.599 1.042.599 1.78v.524h-3.766c.016.642.178 1.13.483 1.462.31.332.744.498 1.302.498.589 0 1.171-.123 1.746-.369v.739c-.293.126-.57.216-.833.269a4.494 4.494 0 0 1-.943.085Zm-.224-4.973c-.439 0-.79.143-1.053.429-.259.286-.412.681-.458 1.187h2.858c0-.522-.117-.921-.349-1.197-.233-.28-.566-.42-.998-.42Zm7.013 4.873-.165-.778h-.039c-.273.342-.546.575-.819.698-.269.12-.606.18-1.012.18-.542 0-.968-.14-1.277-.42-.306-.279-.459-.676-.459-1.191 0-1.104.883-1.683 2.649-1.736l.927-.03v-.34c0-.428-.093-.744-.279-.947-.183-.206-.477-.31-.883-.31-.455 0-.971.14-1.546.42l-.254-.634a3.89 3.89 0 0 1 .882-.344c.323-.083.646-.125.968-.125.652 0 1.134.145 1.447.434.316.29.474.753.474 1.392v3.731h-.614Zm-1.87-.584c.515 0 .919-.141 1.212-.424.296-.282.444-.678.444-1.187v-.494l-.828.035c-.659.024-1.134.127-1.427.31-.289.18-.434.46-.434.843 0 .299.09.527.269.683.183.156.438.234.764.234Zm6.688-4.983c.243 0 .461.02.654.06l-.115.768a2.82 2.82 0 0 0-.598-.074c-.443 0-.822.18-1.138.538-.312.36-.469.807-.469 1.342v2.933h-.828v-5.467h.684l.095 1.013h.039c.203-.356.448-.63.734-.823.286-.193.6-.29.942-.29Zm5.417 5.567v-3.537c0-.445-.101-.778-.304-.997-.203-.22-.52-.33-.953-.33-.572 0-.991.155-1.257.465-.266.309-.399.82-.399 1.53v2.869h-.828v-5.467h.674l.134.748h.04c.17-.269.408-.477.714-.623.306-.15.646-.225 1.022-.225.659 0 1.154.16 1.487.48.332.315.498.822.498 1.52v3.567h-.828Zm7.732-5.557c.718 0 1.275.246 1.671.739.399.488.598 1.182.598 2.08 0 .897-.201 1.596-.603 2.095-.399.495-.955.743-1.666.743a2.41 2.41 0 0 1-.978-.195 1.852 1.852 0 0 1-.738-.608h-.06l-.175.703h-.593v-7.761h.828v1.885c0 .422-.013.801-.04 1.137h.04c.386-.545.958-.818 1.716-.818Zm-.12.694c-.565 0-.973.163-1.222.489-.249.322-.374.867-.374 1.636 0 .768.128 1.318.384 1.65.256.33.667.494 1.232.494.509 0 .888-.184 1.137-.553.25-.373.374-.906.374-1.601 0-.712-.124-1.242-.374-1.592-.249-.349-.635-.523-1.157-.523Zm2.973-.604h.888l1.197 3.118c.263.711.425 1.225.489 1.54h.04c.043-.169.133-.458.269-.867.14-.412.592-1.676 1.357-3.79h.887l-2.349 6.224c-.233.615-.505 1.05-.818 1.307-.309.26-.69.39-1.142.39-.253 0-.502-.03-.748-.086v-.663c.183.04.387.06.613.06.569 0 .975-.32 1.217-.958l.305-.778-2.205-5.497Zm11.133.644h-1.392v4.823h-.828v-4.823h-.977v-.374l.977-.3v-.304c0-1.344.587-2.015 1.761-2.015.289 0 .629.058 1.018.174l-.215.664a2.738 2.738 0 0 0-.818-.155c-.312 0-.544.105-.693.314-.15.207-.225.54-.225.998v.354h1.392v.644Zm1.776-.644v3.547c0 .445.101.778.304.997.203.22.52.33.953.33.572 0 .989-.157 1.252-.47.266-.312.399-.823.399-1.53V21.95h.828v5.467h-.684l-.119-.733h-.045c-.17.27-.406.475-.709.618a2.352 2.352 0 0 1-1.027.215c-.665 0-1.164-.158-1.496-.474-.33-.316-.494-.822-.494-1.517v-3.576h.838Zm9.237 5.467v-3.537c0-.445-.101-.778-.304-.997-.203-.22-.52-.33-.952-.33-.572 0-.991.155-1.257.465-.266.309-.4.82-.4 1.53v2.869h-.828v-5.467h.674l.135.748h.039c.17-.269.408-.477.714-.623.306-.15.646-.225 1.022-.225.659 0 1.154.16 1.487.48.332.315.498.822.498 1.52v3.567h-.828Zm6.255-.733h-.044c-.383.555-.955.833-1.716.833-.715 0-1.272-.245-1.671-.733-.396-.49-.594-1.184-.594-2.085 0-.902.2-1.602.599-2.1.399-.5.954-.749 1.666-.749.741 0 1.31.27 1.706.808h.064l-.035-.394-.019-.384v-2.224h.828v7.761h-.674l-.11-.733Zm-1.656.14c.566 0 .975-.154 1.227-.46.256-.309.385-.806.385-1.49V24.7c0-.775-.13-1.327-.39-1.656-.256-.333-.666-.5-1.232-.5-.485 0-.858.19-1.117.57-.256.375-.384.907-.384 1.595 0 .699.128 1.226.384 1.582.256.355.632.533 1.127.533Zm5.028.593h-.828v-5.467h.828v5.467Zm-.898-6.948c0-.19.047-.328.14-.414a.484.484 0 0 1 .349-.135c.133 0 .248.045.344.135.097.09.145.227.145.414 0 .186-.048.326-.145.419a.487.487 0 0 1-.344.134.484.484 0 0 1-.349-.134c-.093-.093-.14-.233-.14-.42Zm6.395 6.948v-3.537c0-.445-.101-.778-.304-.997-.203-.22-.521-.33-.953-.33-.572 0-.991.155-1.257.465-.266.309-.399.82-.399 1.53v2.869h-.828v-5.467h.673l.135.748h.04c.17-.269.407-.477.713-.623.306-.15.647-.225 1.023-.225.658 0 1.154.16 1.486.48.333.315.499.822.499 1.52v3.567h-.828Zm7.008-5.467v.524l-1.012.12c.093.116.176.269.249.459.073.186.11.397.11.633 0 .535-.183.963-.549 1.282-.366.32-.868.479-1.506.479a2.51 2.51 0 0 1-.459-.04c-.353.186-.529.42-.529.703 0 .15.062.261.185.334.123.07.334.105.633.105h.968c.592 0 1.046.125 1.361.374.32.25.479.612.479 1.088 0 .605-.242 1.065-.728 1.381-.485.32-1.194.48-2.125.48-.715 0-1.267-.134-1.656-.4-.386-.266-.578-.642-.578-1.127 0-.333.106-.62.319-.863.213-.243.512-.407.898-.494a.888.888 0 0 1-.355-.294.789.789 0 0 1-.139-.464c0-.2.053-.374.159-.524.107-.15.275-.294.504-.434a1.49 1.49 0 0 1-.693-.593 1.759 1.759 0 0 1-.264-.958c0-.599.179-1.06.538-1.382.359-.326.868-.489 1.527-.489.286 0 .543.034.773.1h1.89Zm-4.359 6.385c0 .296.124.52.374.673.249.153.607.23 1.072.23.695 0 1.209-.105 1.541-.315.336-.206.504-.487.504-.843 0-.296-.091-.502-.274-.618-.183-.113-.527-.17-1.033-.17h-.992c-.376 0-.669.09-.878.27-.21.18-.314.437-.314.773Zm.449-4.634c0 .382.108.672.324.868.216.196.517.294.903.294.808 0 1.212-.392 1.212-1.177 0-.821-.409-1.232-1.227-1.232-.389 0-.689.105-.898.314-.21.21-.314.52-.314.933Zm11.048 3.716-.165-.778h-.04c-.272.342-.545.575-.818.698-.269.12-.606.18-1.012.18-.542 0-.968-.14-1.277-.42-.306-.279-.459-.676-.459-1.191 0-1.104.883-1.683 2.649-1.736l.927-.03v-.34c0-.428-.093-.744-.279-.947-.183-.206-.477-.31-.883-.31-.455 0-.971.14-1.546.42l-.254-.634a3.89 3.89 0 0 1 .882-.344c.323-.083.646-.125.968-.125.652 0 1.134.145 1.447.434.316.29.473.753.473 1.392v3.731h-.613Zm-1.871-.584c.516 0 .92-.141 1.213-.424.295-.282.443-.678.443-1.187v-.494l-.828.035c-.658.024-1.133.127-1.426.31-.289.18-.434.46-.434.843 0 .299.09.527.269.683.183.156.438.234.763.234Zm6.739.684c-.356 0-.681-.065-.977-.195a1.861 1.861 0 0 1-.739-.608h-.06c.04.319.06.622.06.907v2.25h-.828v-7.92h.674l.114.747h.04c.213-.299.461-.515.744-.648.282-.133.606-.2.972-.2.725 0 1.284.248 1.676.744.396.495.594 1.19.594 2.085 0 .897-.201 1.596-.604 2.095-.399.495-.954.743-1.666.743Zm-.12-4.963c-.558 0-.962.154-1.212.464-.249.309-.377.801-.384 1.476v.185c0 .768.128 1.318.384 1.65.256.33.667.494 1.232.494.473 0 .842-.19 1.108-.573.269-.383.404-.91.404-1.581 0-.682-.135-1.204-.404-1.567-.266-.365-.642-.548-1.128-.548Zm6.385 4.963a2.41 2.41 0 0 1-.978-.195 1.865 1.865 0 0 1-.738-.608h-.06c.04.319.06.622.06.907v2.25h-.828v-7.92h.674l.114.747h.04c.213-.299.461-.515.743-.648.283-.133.607-.2.973-.2.725 0 1.284.248 1.676.744.396.495.594 1.19.594 2.085 0 .897-.202 1.596-.604 2.095-.399.495-.954.743-1.666.743Zm-.12-4.963c-.558 0-.962.154-1.212.464-.249.309-.377.801-.384 1.476v.185c0 .768.128 1.318.384 1.65.256.33.667.494 1.232.494.473 0 .842-.19 1.108-.573.269-.383.404-.91.404-1.581 0-.682-.135-1.204-.404-1.567-.266-.365-.642-.548-1.128-.548Zm6.151 4.963c-.808 0-1.447-.246-1.916-.739-.465-.492-.698-1.175-.698-2.05 0-.88.216-1.58.648-2.1.436-.518 1.02-.778 1.751-.778.685 0 1.227.227 1.626.679.399.449.599 1.042.599 1.78v.524h-3.766c.016.642.178 1.13.484 1.462.309.332.743.498 1.302.498.588 0 1.17-.123 1.745-.369v.739c-.292.126-.57.216-.833.269a4.484 4.484 0 0 1-.942.085Zm-.225-4.973c-.439 0-.79.143-1.052.429-.26.286-.413.681-.459 1.187h2.858c0-.522-.116-.921-.349-1.197-.233-.28-.566-.42-.998-.42Zm7.013 4.873-.164-.778h-.04c-.273.342-.546.575-.818.698-.27.12-.607.18-1.013.18-.542 0-.968-.14-1.277-.42-.306-.279-.459-.676-.459-1.191 0-1.104.883-1.683 2.649-1.736l.928-.03v-.34c0-.428-.093-.744-.28-.947-.183-.206-.477-.31-.883-.31-.455 0-.97.14-1.546.42l-.254-.634a3.88 3.88 0 0 1 .883-.344c.322-.083.645-.125.967-.125.652 0 1.134.145 1.447.434.316.29.474.753.474 1.392v3.731h-.614Zm-1.87-.584c.515 0 .919-.141 1.212-.424.296-.282.444-.678.444-1.187v-.494l-.828.035c-.659.024-1.134.127-1.427.31-.289.18-.434.46-.434.843 0 .299.09.527.27.683.182.156.437.234.763.234Zm5.023.584h-.828v-7.761h.828v7.761Zm5.282-1.491c0 .508-.19.9-.569 1.177-.379.276-.911.414-1.596.414-.725 0-1.29-.115-1.696-.344v-.769c.263.133.544.238.843.315.303.076.594.114.873.114.432 0 .765-.068.998-.204a.692.692 0 0 0 .349-.634c0-.212-.093-.394-.28-.543-.182-.153-.542-.333-1.077-.539-.509-.19-.871-.354-1.087-.494a1.534 1.534 0 0 1-.479-.484 1.273 1.273 0 0 1-.155-.643c0-.446.181-.796.544-1.053.362-.259.86-.389 1.491-.389.589 0 1.164.12 1.726.36l-.294.673c-.549-.226-1.046-.34-1.492-.34-.392 0-.688.062-.887.185-.2.123-.3.293-.3.509a.63.63 0 0 0 .11.374c.077.103.198.201.364.294.166.094.486.228.958.405.648.236 1.086.473 1.312.713.229.24.344.54.344.903Zm1.232.962c0-.223.05-.39.15-.503.103-.117.249-.175.439-.175.192 0 .342.058.448.175.11.113.165.28.165.503 0 .216-.055.383-.165.499a.585.585 0 0 1-.448.175.605.605 0 0 1-.424-.155c-.11-.106-.165-.28-.165-.519Z",
                className: "payoff-simulator_svg__path-17"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "payoff-simulator_svg__a",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(183.512 305.367)",
                            className: "payoff-simulator_svg__rect-6",
                            d: "M0 0h15.165v15.323H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "payoff-simulator_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(28.822 305.367)",
                            className: "payoff-simulator_svg__rect-7",
                            d: "M0 0h15.165v15.323H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "payoff-simulator_svg__c",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(18.971 18.309)",
                            className: "payoff-simulator_svg__rect-8",
                            d: "M0 0h10.215v10.215H0z"
                        })
                    })
                ]
            })
        ]
    });
var $2f14ca94ee5a0052$export$2e2bcd8739ae039 = $2f14ca94ee5a0052$var$SvgPayoffSimulator;



const $94b3d001fa86c851$var$StyledPayoffSimulatorSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $2f14ca94ee5a0052$export$2e2bcd8739ae039))`
  [class$="circle-1"] {
    fill: ${({ theme: theme })=>theme.successLight};
  }

  [class$="rect-2"] {
    fill: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="circle-2"] {
    fill: ${({ theme: theme })=>theme.mediumPurple};
  }

  [class$="rect-1"],
  [class$="rect-5"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-6"],
  [class$="rect-7"],
  [class$="rect-8"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="path-2"] {
    fill: ${({ theme: theme })=>theme.success};
  }

  [class$="path-3"],
  [class$="path-16"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  [class$="path-11"],
  [class$="path-13"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="path-4"],
  [class$="path-5"],
  [class$="path-6"],
  [class$="path-7"],
  [class$="path-8"],
  [class$="path-9"],
  [class$="path-10"],
  [class$="path-12"],
  [class$="path-14"],
  [class$="path-15"],
  [class$="path-17"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="rect-3"],
  [class$="rect-4"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="line-1"],
  [class$="line-2"],
  [class$="path-1"] {
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="path-1"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
  }
`;
const $94b3d001fa86c851$var$PayoffSimulator = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $94b3d001fa86c851$var$StyledPayoffSimulatorSvg
    });
var $94b3d001fa86c851$export$2e2bcd8739ae039 = $94b3d001fa86c851$var$PayoffSimulator;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $bb5fbca7120e22d8$var$SvgStageOne = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 335 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                width: 335,
                height: 339,
                rx: 3,
                className: "stage-one_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#stage-one_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 13,
                        y: 88,
                        width: 308,
                        height: 113.099,
                        rx: 2.134,
                        className: "stage-one_svg__rect-2"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 13.356,
                        y: 88.356,
                        width: 307.289,
                        height: 112.388,
                        rx: 1.778,
                        className: "stage-one_svg__rect-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.072,
                y: 178.336,
                width: 273.857,
                height: 5.691,
                rx: 2.845,
                className: "stage-one_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.072,
                y: 178.336,
                width: 164.314,
                height: 5.691,
                rx: 2.845,
                className: "stage-one_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M91.175 160.877c0 1.229-.195 2.146-.584 2.752-.385.607-.977.91-1.775.91-.765 0-1.347-.31-1.745-.929-.399-.622-.598-1.533-.598-2.733 0-1.238.193-2.157.578-2.757.386-.6.974-.899 1.765-.899.772 0 1.357.312 1.756.938.402.626.603 1.532.603 2.718Zm-3.885 0c0 1.034.121 1.788.364 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.714.243-.48.365-1.231.365-2.252 0-1.021-.121-1.768-.365-2.241-.24-.477-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.364 1.217-.364 2.251Zm5.125 3.049c0-.217.048-.381.146-.491.1-.114.243-.17.427-.17.189 0 .334.056.438.17.107.11.16.274.16.491 0 .211-.053.373-.16.486a.57.57 0 0 1-.438.17.592.592 0 0 1-.413-.15c-.107-.104-.16-.273-.16-.506Zm7.113-3.049c0 1.229-.194 2.146-.583 2.752-.386.607-.977.91-1.775.91-.765 0-1.347-.31-1.745-.929-.4-.622-.599-1.533-.599-2.733 0-1.238.193-2.157.58-2.757.385-.6.973-.899 1.764-.899.772 0 1.357.312 1.756.938.401.626.602 1.532.602 2.718Zm-3.885 0c0 1.034.122 1.788.365 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.714.243-.48.365-1.231.365-2.252 0-1.021-.122-1.768-.365-2.241-.24-.477-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.365 1.217-.365 2.251Zm9.584 0c0 1.229-.194 2.146-.583 2.752-.386.607-.977.91-1.775.91-.765 0-1.347-.31-1.746-.929-.398-.622-.598-1.533-.598-2.733 0-1.238.193-2.157.579-2.757.386-.6.974-.899 1.765-.899.772 0 1.357.312 1.755.938.402.626.603 1.532.603 2.718Zm-3.885 0c0 1.034.122 1.788.365 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.714.243-.48.365-1.231.365-2.252 0-1.021-.122-1.768-.365-2.241-.24-.477-.629-.715-1.167-.715-.532 0-.919.235-1.162.705-.243.467-.365 1.217-.365 2.251Zm9.881 1.931h-1.055v1.633h-.773v-1.633h-3.458v-.705l3.375-4.809h.856v4.779h1.055v.735Zm-1.828-.735v-2.363c0-.463.016-.987.048-1.57h-.039a7.23 7.23 0 0 1-.437.773l-2.222 3.16h2.65Zm9.559 2.368h-3.963v-7.109h3.963v.735h-3.136v2.29h2.947v.729h-2.947v2.616h3.136v.739Zm3.769 0h-.827v-6.374h-2.251v-.735h5.329v.735h-2.251v6.374Zm8.723 0h-.827v-3.345h-3.744v3.345h-.826v-7.109h.826v3.025h3.744v-3.025h.827v7.109Zm9.02-2.669c0 .869-.219 1.548-.656 2.037-.438.487-1.043.73-1.814.73-.477 0-.9-.112-1.269-.336a2.21 2.21 0 0 1-.856-.963c-.201-.418-.302-.907-.302-1.468 0-.869.218-1.545.652-2.028.434-.486 1.037-.729 1.809-.729.746 0 1.337.248 1.775.744.441.496.661 1.167.661 2.013Zm-4.06 0c0 .681.136 1.199.408 1.556.273.356.673.535 1.201.535.529 0 .929-.177 1.201-.53.276-.357.414-.877.414-1.561 0-.678-.138-1.191-.414-1.542-.272-.353-.676-.53-1.21-.53-.529 0-.928.174-1.197.521-.269.347-.403.864-.403 1.551Zm6.238-2.66v3.457c0 .435.099.759.297.973.198.214.507.321.929.321.557 0 .964-.153 1.22-.457.26-.305.389-.803.389-1.493v-2.801h.807v5.329h-.666l-.116-.714h-.044a1.613 1.613 0 0 1-.691.603 2.297 2.297 0 0 1-1.001.209c-.649 0-1.135-.154-1.459-.462-.321-.308-.481-.801-.481-1.478v-3.487h.816Zm7.08 4.76c.143 0 .281-.009.414-.029.132-.022.238-.045.316-.068v.618a1.453 1.453 0 0 1-.389.102 2.73 2.73 0 0 1-.457.044c-1.031 0-1.547-.543-1.547-1.629v-3.171h-.763v-.389l.763-.335.341-1.138h.466v1.235h1.547v.627h-1.547v3.137c0 .321.077.567.229.739.152.172.361.257.627.257Zm8.986-2.1c0 .869-.219 1.548-.656 2.037-.438.487-1.042.73-1.814.73a2.4 2.4 0 0 1-1.269-.336 2.21 2.21 0 0 1-.856-.963c-.201-.418-.301-.907-.301-1.468 0-.869.217-1.545.651-2.028.435-.486 1.038-.729 1.809-.729.746 0 1.337.248 1.775.744.441.496.661 1.167.661 2.013Zm-4.06 0c0 .681.136 1.199.408 1.556.273.356.673.535 1.201.535.529 0 .929-.177 1.202-.53.275-.357.413-.877.413-1.561 0-.678-.138-1.191-.413-1.542-.273-.353-.676-.53-1.211-.53-.529 0-.927.174-1.196.521-.269.347-.404.864-.404 1.551Zm7.882-2.033h-1.357v4.702h-.807v-4.702h-.953v-.364l.953-.292v-.297c0-1.309.572-1.964 1.717-1.964.282 0 .612.057.992.17l-.209.647a2.66 2.66 0 0 0-.798-.151c-.305 0-.53.102-.676.306-.146.201-.219.526-.219.973v.345h1.357v.627Zm7.902 1.138c0 1.229-.195 2.146-.584 2.752-.386.607-.977.91-1.775.91-.765 0-1.347-.31-1.745-.929-.399-.622-.598-1.533-.598-2.733 0-1.238.193-2.157.578-2.757.386-.6.974-.899 1.765-.899.772 0 1.357.312 1.756.938.402.626.603 1.532.603 2.718Zm-3.885 0c0 1.034.121 1.788.364 2.261.243.47.631.705 1.162.705.539 0 .928-.238 1.167-.714.244-.48.365-1.231.365-2.252 0-1.021-.121-1.768-.365-2.241-.239-.477-.628-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.364 1.217-.364 2.251Zm5.125 3.049c0-.217.048-.381.146-.491.1-.114.243-.17.427-.17.188 0 .334.056.438.17.107.11.161.274.161.491 0 .211-.054.373-.161.486a.571.571 0 0 1-.438.17.591.591 0 0 1-.413-.15c-.107-.104-.16-.273-.16-.506Zm7.114-3.049c0 1.229-.195 2.146-.584 2.752-.386.607-.977.91-1.775.91-.765 0-1.347-.31-1.745-.929-.399-.622-.599-1.533-.599-2.733 0-1.238.193-2.157.579-2.757.386-.6.974-.899 1.765-.899.772 0 1.357.312 1.756.938.402.626.603 1.532.603 2.718Zm-3.886 0c0 1.034.122 1.788.365 2.261.243.47.631.705 1.162.705.538 0 .927-.238 1.167-.714.243-.48.365-1.231.365-2.252 0-1.021-.122-1.768-.365-2.241-.24-.477-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.365 1.217-.365 2.251Zm7.863 3.564h-.788v-5.066c0-.422.013-.82.039-1.197-.068.069-.144.14-.228.214-.085.075-.47.391-1.158.949l-.427-.555 1.881-1.454h.681v7.109Zm9.749 0h-3.963v-7.109h3.963v.735h-3.136v2.29h2.947v.729h-2.947v2.616h3.136v.739Zm3.769 0h-.827v-6.374h-2.251v-.735h5.329v.735h-2.251v6.374Zm8.723 0h-.826v-3.345h-3.745v3.345h-.826v-7.109h.826v3.025h3.745v-3.025h.826v7.109Zm6.851-5.426c.237 0 .449.019.637.058l-.111.749a2.731 2.731 0 0 0-.584-.073c-.431 0-.801.175-1.109.525-.304.35-.457.786-.457 1.308v2.859h-.807v-5.329h.666l.093.987h.039c.197-.347.436-.614.714-.802.279-.188.586-.282.919-.282Zm3.886 5.524c-.788 0-1.41-.24-1.868-.72-.453-.48-.68-1.146-.68-1.998 0-.86.21-1.542.632-2.048.424-.505.993-.758 1.707-.758.667 0 1.196.22 1.585.661.389.438.583 1.016.583 1.736v.511h-3.671c.016.625.173 1.1.472 1.424.301.325.724.487 1.269.487.574 0 1.141-.12 1.702-.36v.719a4.101 4.101 0 0 1-.812.263c-.253.055-.56.083-.919.083Zm-.219-4.848c-.428 0-.77.139-1.026.418-.253.279-.402.664-.448 1.157h2.787c0-.509-.114-.898-.341-1.167-.227-.272-.551-.408-.972-.408Zm5.572 4.172c.538 0 .931-.144 1.177-.433.246-.289.378-.775.394-1.459v-.18c0-.745-.127-1.282-.379-1.609-.253-.328-.654-.491-1.201-.491-.474 0-.837.185-1.09.554-.249.366-.374.885-.374 1.556s.123 1.183.369 1.537c.25.35.618.525 1.104.525Zm-.121.676c-.688 0-1.224-.242-1.61-.725-.386-.483-.578-1.157-.578-2.023 0-.872.194-1.552.583-2.042.389-.489.93-.734 1.624-.734.73 0 1.29.275 1.683.826h.043l.117-.729h.637v7.722h-.807v-2.281c0-.324.018-.599.053-.826h-.063c-.373.541-.933.812-1.682.812Zm4.974-5.427v3.457c0 .435.099.759.297.973.197.214.507.321.928.321.558 0 .965-.153 1.221-.457.259-.305.389-.803.389-1.493v-2.801h.807v5.329h-.666l-.117-.714h-.044a1.61 1.61 0 0 1-.69.603 2.304 2.304 0 0 1-1.002.209c-.648 0-1.134-.154-1.458-.462-.321-.308-.482-.801-.482-1.478v-3.487h.817Zm6.166 5.329h-.807v-5.329h.807v5.329Zm-.876-6.773c0-.185.046-.319.137-.404a.47.47 0 0 1 .34-.131c.13 0 .241.044.335.131.094.088.142.222.142.404 0 .181-.048.318-.142.408a.472.472 0 0 1-.335.132.468.468 0 0 1-.34-.132c-.091-.09-.137-.227-.137-.408Zm5.019 1.347c.236 0 .449.019.637.058l-.112.749a2.731 2.731 0 0 0-.584-.073c-.431 0-.8.175-1.108.525-.305.35-.458.786-.458 1.308v2.859h-.807v-5.329h.666l.093.987h.039a2.34 2.34 0 0 1 .715-.802c.278-.188.585-.282.919-.282Zm3.885 5.524c-.788 0-1.41-.24-1.867-.72-.454-.48-.681-1.146-.681-1.998 0-.86.21-1.542.632-2.048.425-.505.993-.758 1.707-.758.667 0 1.196.22 1.585.661.389.438.583 1.016.583 1.736v.511h-3.671c.016.625.174 1.1.472 1.424.301.325.724.487 1.269.487.574 0 1.141-.12 1.702-.36v.719a4.08 4.08 0 0 1-.812.263 4.39 4.39 0 0 1-.919.083Zm-.219-4.848c-.428 0-.77.139-1.026.418-.253.279-.402.664-.447 1.157h2.786c0-.509-.114-.898-.341-1.167-.226-.272-.551-.408-.972-.408Zm7.187 4.036h-.044c-.373.541-.93.812-1.673.812-.697 0-1.24-.239-1.629-.715-.385-.477-.578-1.154-.578-2.033 0-.878.194-1.561.583-2.047.389-.486.931-.729 1.624-.729.723 0 1.277.262 1.663.788h.063l-.034-.385-.019-.374v-2.169h.807v7.566h-.656l-.107-.714Zm-1.615.136c.551 0 .95-.149 1.197-.448.249-.301.374-.786.374-1.453v-.171c0-.755-.126-1.293-.379-1.614-.25-.324-.65-.486-1.201-.486-.474 0-.837.185-1.09.554-.249.366-.374.885-.374 1.556 0 .681.125 1.195.374 1.541.25.347.616.521 1.099.521Z",
                className: "stage-one_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M35.717 111.111c0 .742-.243 1.311-.73 1.706-.486.396-1.178.594-2.076.594h-.739v2.659H31.01v-7.109h2.047c.888 0 1.553.182 1.994.545.444.363.666.898.666 1.605Zm-3.545 1.322h.618c.596 0 1.034-.104 1.313-.311.278-.208.418-.532.418-.973 0-.408-.125-.713-.375-.914-.25-.201-.638-.301-1.167-.301h-.807v2.499Zm8.208 3.637-.229-.749h-.038c-.26.328-.52.552-.783.672-.263.116-.6.175-1.012.175-.528 0-.941-.143-1.24-.428-.295-.286-.442-.689-.442-1.211 0-.554.206-.973.617-1.255.412-.282 1.04-.436 1.882-.462l.929-.029v-.287c0-.343-.081-.599-.243-.768-.159-.172-.407-.258-.744-.258-.276 0-.54.041-.793.122a6.014 6.014 0 0 0-.73.287l-.369-.817c.292-.152.611-.268.958-.345.347-.081.675-.122.983-.122.684 0 1.199.149 1.546.447.35.299.525.767.525 1.406v3.622h-.817Zm-1.702-.778c.415 0 .747-.115.997-.345.253-.233.38-.559.38-.977v-.467l-.691.029c-.538.02-.93.11-1.177.272-.243.159-.365.404-.365.735 0 .24.072.426.214.559.143.129.357.194.642.194Zm3.297-4.6h1.245l1.094 3.049c.165.435.275.843.33 1.226h.04c.029-.179.082-.394.16-.647.078-.256.49-1.465 1.235-3.628h1.235l-2.3 6.093c-.418 1.118-1.115 1.678-2.09 1.678-.254 0-.5-.028-.74-.083v-.904c.172.038.368.058.588.058.552 0 .939-.319 1.163-.958l.199-.506-2.159-5.378Zm13.182 5.378H50.34v-.865l1.833-1.843c.541-.554.9-.947 1.074-1.177.179-.233.308-.452.39-.656.08-.205.12-.423.12-.657 0-.321-.096-.573-.29-.758-.192-.185-.458-.277-.798-.277-.273 0-.537.05-.793.15-.253.101-.546.282-.88.545l-.618-.754c.396-.334.78-.57 1.153-.71.373-.139.77-.209 1.191-.209.661 0 1.191.174 1.59.52.399.344.598.808.598 1.391 0 .321-.058.626-.175.914-.113.289-.29.587-.53.895-.236.305-.632.718-1.186 1.24l-1.235 1.196v.049h3.374v1.006Zm5.422-5.475c0 .451-.131.827-.394 1.128-.263.298-.632.499-1.109.603v.039c.571.071.999.25 1.284.535.285.282.428.658.428 1.128 0 .684-.241 1.212-.724 1.585-.483.37-1.17.555-2.062.555-.788 0-1.453-.128-1.994-.385v-1.016a4.558 4.558 0 0 0 1.93.467c.552 0 .963-.102 1.236-.306.272-.205.408-.521.408-.949 0-.379-.15-.658-.452-.836-.302-.178-.775-.267-1.42-.267h-.617v-.929h.627c1.134 0 1.702-.392 1.702-1.177 0-.305-.1-.54-.297-.705-.198-.165-.49-.248-.875-.248-.27 0-.529.039-.778.117-.25.074-.545.222-.885.442l-.56-.797c.652-.48 1.41-.72 2.271-.72.717 0 1.276.154 1.678.462.402.308.603.733.603 1.274Zm5.956 1.921c0 1.235-.199 2.152-.598 2.752-.395.6-1.001.9-1.818.9-.791 0-1.39-.31-1.8-.929-.408-.619-.612-1.527-.612-2.723 0-1.255.198-2.179.593-2.772.399-.596 1.005-.895 1.819-.895.794 0 1.395.312 1.804.934.408.622.612 1.533.612 2.733Zm-3.67 0c0 .969.098 1.661.296 2.076.2.415.52.623.958.623.438 0 .757-.211.958-.633.204-.421.306-1.11.306-2.066 0-.953-.102-1.642-.306-2.067-.201-.428-.52-.642-.958-.642-.438 0-.757.209-.958.628-.198.418-.297 1.112-.297 2.081Zm13.41-.068c0 1.173-.326 2.071-.977 2.694-.652.619-1.59.928-2.816.928h-1.988v-7.109h2.198c1.13 0 2.01.305 2.64.914.629.61.943 1.467.943 2.573Zm-1.225.039c0-1.702-.796-2.553-2.388-2.553h-1.006v5.159h.826c1.712 0 2.568-.869 2.568-2.606Zm7.167 3.583-.71-1.974H78.79l-.695 1.974h-1.226l2.66-7.138h1.264l2.66 7.138h-1.235Zm-1.016-2.976-.666-1.935a14.636 14.636 0 0 1-.38-1.225c-.087.399-.215.835-.384 1.308l-.642 1.852h2.072Zm3.19 2.976v-7.109h1.162v7.109H84.39Z",
                className: "stage-one_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 295.393,
                cy: 113.606,
                r: 8.18,
                className: "stage-one_svg__circle-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#stage-one_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m38.49 125.062-.377-.377a.399.399 0 0 0-.566 0l-.094.094-1.886-1.886.094-.094a.4.4 0 0 0 0-.566l-.377-.378a.4.4 0 0 0-.566 0l-2.075 2.075a.4.4 0 0 0 0 .566l.377.377c.156.157.41.157.566 0l.094-.094.66.66-1.35 1.351-.095-.094a.534.534 0 0 0-.754 0l-1.913 1.913a.533.533 0 0 0 0 .754l.754.755a.534.534 0 0 0 .755 0l1.913-1.913a.534.534 0 0 0 0-.755l-.095-.094 1.351-1.351.66.66-.094.094a.4.4 0 0 0 0 .566l.377.378a.4.4 0 0 0 .566 0l2.075-2.075a.4.4 0 0 0 0-.566Z",
                    className: "stage-one_svg__path-3"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M41.97 130.612c-.262 0-.468-.037-.617-.112v-.604c.197.055.402.083.616.083.275 0 .484-.083.625-.25.145-.167.217-.407.217-.721v-6.094h.709v6.035c0 .528-.134.937-.4 1.226-.267.292-.65.437-1.15.437Zm3.717-6.172v2.963c0 .373.085.65.254.834.17.183.435.275.796.275.478 0 .827-.131 1.046-.392.223-.261.334-.688.334-1.279v-2.401h.692v4.568h-.571l-.1-.613H48.1a1.38 1.38 0 0 1-.592.517c-.25.119-.536.179-.858.179-.556 0-.973-.132-1.25-.396-.276-.264-.413-.686-.413-1.267v-2.988h.7Zm6.677-.084c.203 0 .385.017.546.05l-.096.642a2.397 2.397 0 0 0-.5-.062c-.37 0-.686.15-.95.45-.261.3-.392.674-.392 1.121v2.451h-.692v-4.568h.571l.08.846h.033a2.01 2.01 0 0 1 .612-.688 1.38 1.38 0 0 1 .788-.242Zm.675.084h.742l1 2.605c.22.594.356 1.024.409 1.288h.033c.036-.142.111-.384.225-.726.117-.344.495-1.4 1.134-3.167h.742l-1.963 5.201c-.195.514-.423.878-.684 1.092-.258.217-.576.325-.954.325-.211 0-.42-.023-.625-.07v-.555c.152.034.323.05.512.05.475 0 .814-.267 1.017-.8l.254-.65-1.842-4.593Zm10.353 3.955h-.037c-.32.464-.798.696-1.434.696-.597 0-1.063-.204-1.396-.613-.331-.408-.496-.989-.496-1.742s.166-1.338.5-1.754c.333-.417.797-.626 1.392-.626.62 0 1.095.226 1.425.676h.055l-.03-.33-.016-.321v-1.858h.691v6.485h-.562l-.092-.613Zm-1.384.117c.473 0 .815-.128 1.026-.384.214-.258.32-.673.32-1.246v-.146c0-.647-.108-1.108-.324-1.383-.214-.278-.558-.417-1.03-.417-.406 0-.717.158-.934.475-.213.314-.32.758-.32 1.334 0 .583.107 1.024.32 1.321.215.297.528.446.942.446Zm5.44.579c-.676 0-1.21-.205-1.6-.617-.39-.411-.584-.982-.584-1.713 0-.736.18-1.321.541-1.754.364-.434.852-.651 1.463-.651.573 0 1.026.189 1.359.567.334.375.5.871.5 1.488v.438H65.98c.014.536.15.943.405 1.221.258.278.62.417 1.087.417.492 0 .979-.103 1.46-.309v.617a3.48 3.48 0 0 1-.697.225c-.216.048-.479.071-.787.071Zm-.188-4.155c-.367 0-.66.119-.88.358-.216.239-.344.57-.383.992h2.388c0-.436-.097-.769-.291-1-.195-.233-.473-.35-.834-.35Zm4.876 4.155c-.66 0-1.174-.203-1.538-.608-.36-.409-.541-.985-.541-1.73 0-.764.183-1.355.55-1.771.37-.417.894-.626 1.575-.626.22 0 .44.024.659.071a2.2 2.2 0 0 1 .517.167l-.213.588a3.13 3.13 0 0 0-.5-.15 2.147 2.147 0 0 0-.48-.063c-.928 0-1.392.592-1.392 1.776 0 .561.113.992.338 1.292.228.3.564.45 1.009.45.38 0 .77-.082 1.17-.246v.613c-.305.158-.69.237-1.154.237Zm2.935-.083h-.692v-4.568h.692v4.568Zm-.75-5.806c0-.158.038-.274.116-.346a.403.403 0 0 1 .292-.112c.11 0 .207.037.287.112.081.075.121.19.121.346 0 .156-.04.272-.12.35a.408.408 0 0 1-.288.113.404.404 0 0 1-.292-.113c-.078-.078-.117-.194-.117-.35Zm5.163 4.56c0 .425-.158.753-.475.983-.317.231-.761.346-1.334.346-.605 0-1.078-.096-1.417-.287v-.642c.22.111.455.198.705.262.253.064.496.096.73.096.36 0 .638-.057.833-.171a.576.576 0 0 0 .291-.529.564.564 0 0 0-.233-.454c-.153-.128-.453-.278-.9-.45-.425-.159-.728-.296-.909-.413a1.29 1.29 0 0 1-.4-.404c-.086-.15-.13-.33-.13-.538 0-.372.152-.665.455-.879.303-.217.718-.326 1.246-.326.492 0 .973.1 1.442.301l-.245.562c-.459-.189-.874-.283-1.247-.283-.328 0-.575.051-.742.154a.478.478 0 0 0-.25.425c0 .122.031.227.092.313a.955.955 0 0 0 .304.246c.14.077.406.19.8.337.542.198.908.396 1.097.596.191.2.287.452.287.755Zm1.822 1.246h-.692v-4.568h.692v4.568Zm-.75-5.806c0-.158.038-.274.116-.346a.403.403 0 0 1 .292-.112c.111 0 .207.037.287.112.081.075.121.19.121.346 0 .156-.04.272-.12.35a.408.408 0 0 1-.288.113.404.404 0 0 1-.292-.113c-.078-.078-.117-.194-.117-.35Zm6.16 3.518c0 .744-.188 1.326-.563 1.746-.375.417-.893.625-1.555.625-.408 0-.77-.096-1.088-.287a1.898 1.898 0 0 1-.733-.826c-.172-.358-.258-.778-.258-1.258 0-.745.186-1.324.558-1.738.372-.417.89-.626 1.55-.626.64 0 1.147.213 1.522.638.378.425.567 1 .567 1.726Zm-3.48 0c0 .583.116 1.028.35 1.333.233.306.576.459 1.029.459.453 0 .796-.152 1.03-.454.236-.306.354-.752.354-1.338 0-.581-.118-1.021-.355-1.322-.233-.302-.579-.454-1.037-.454-.453 0-.795.149-1.026.446-.23.297-.346.741-.346 1.33Zm7.822 2.288v-2.955c0-.373-.084-.65-.254-.834-.17-.183-.435-.275-.796-.275-.478 0-.828.129-1.05.388-.222.258-.334.685-.334 1.279v2.397h-.691v-4.568h.562l.113.625h.033c.142-.225.34-.399.596-.521.256-.125.54-.188.855-.188.55 0 .964.134 1.242.401.277.264.416.687.416 1.271v2.98h-.692Zm3.952-1.972v-.633h2.046v.633H95.01Zm10.774 1.972h-.701l-1.229-4.081c-.058-.18-.124-.408-.196-.683a4.108 4.108 0 0 1-.113-.496 9.496 9.496 0 0 1-.291 1.204l-1.192 4.056h-.701l-1.62-6.094h.749l.963 3.764c.134.528.231 1.006.292 1.434.075-.509.186-1.006.333-1.492l1.092-3.706h.751l1.146 3.739c.133.431.246.917.337 1.459.053-.395.153-.876.3-1.442l.959-3.756h.75l-1.629 6.094Zm3.171 0h-.692v-4.568h.692v4.568Zm-.75-5.806c0-.158.039-.274.117-.346a.404.404 0 0 1 .292-.112c.111 0 .207.037.287.112.081.075.121.19.121.346 0 .156-.04.272-.121.35a.406.406 0 0 1-.287.113.405.405 0 0 1-.292-.113c-.078-.078-.117-.194-.117-.35Zm5.343 5.806v-2.955c0-.373-.084-.65-.254-.834-.169-.183-.435-.275-.796-.275-.478 0-.828.129-1.05.388-.223.258-.334.685-.334 1.279v2.397h-.692v-4.568h.563l.113.625h.033c.142-.225.34-.399.596-.521.256-.125.54-.188.854-.188.551 0 .965.134 1.242.401.278.264.417.687.417 1.271v2.98h-.692Zm5.244 0v-2.955c0-.373-.085-.65-.255-.834-.169-.183-.435-.275-.796-.275-.478 0-.828.129-1.05.388-.222.258-.334.685-.334 1.279v2.397h-.691v-4.568h.562l.113.625h.033c.142-.225.341-.399.596-.521.256-.125.541-.188.855-.188.55 0 .964.134 1.242.401.277.264.416.687.416 1.271v2.98h-.691Zm4.047.083c-.676 0-1.209-.205-1.601-.617-.389-.411-.583-.982-.583-1.713 0-.736.18-1.321.541-1.754.364-.434.852-.651 1.463-.651.573 0 1.026.189 1.359.567.333.375.5.871.5 1.488v.438h-3.147c.014.536.149.943.405 1.221.258.278.621.417 1.088.417a3.67 3.67 0 0 0 1.458-.309v.617a3.459 3.459 0 0 1-.696.225 3.697 3.697 0 0 1-.787.071Zm-.188-4.155c-.367 0-.66.119-.879.358-.217.239-.345.57-.384.992h2.388c0-.436-.097-.769-.291-1-.195-.233-.473-.35-.834-.35Zm5.135-.58c.203 0 .385.017.546.05l-.096.642a2.4 2.4 0 0 0-.5-.062c-.37 0-.687.15-.951.45-.261.3-.391.674-.391 1.121v2.451h-.692v-4.568h.571l.079.846h.033c.17-.297.374-.527.613-.688.239-.161.502-.242.788-.242Z",
                className: "stage-one_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#stage-one_svg__c)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 13,
                        y: 210.348,
                        width: 308,
                        height: 113.099,
                        rx: 2.134,
                        className: "stage-one_svg__rect-6"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 13.356,
                        y: 210.703,
                        width: 307.289,
                        height: 112.388,
                        rx: 1.778,
                        className: "stage-one_svg__rect-7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.072,
                y: 300.684,
                width: 273.857,
                height: 5.691,
                rx: 2.845,
                className: "stage-one_svg__rect-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.072,
                y: 300.684,
                width: 164.314,
                height: 5.691,
                rx: 2.845,
                className: "stage-one_svg__rect-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M91.175 283.225c0 1.228-.195 2.146-.584 2.752-.385.606-.977.909-1.775.909-.765 0-1.347-.309-1.745-.928-.399-.623-.598-1.534-.598-2.733 0-1.238.193-2.157.578-2.757.386-.6.974-.9 1.765-.9.772 0 1.357.313 1.756.939.402.625.603 1.531.603 2.718Zm-3.885 0c0 1.034.121 1.788.364 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.715.243-.48.365-1.23.365-2.251s-.121-1.768-.365-2.242c-.24-.476-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.364 1.218-.364 2.252Zm5.125 3.049c0-.218.048-.381.146-.491.1-.114.243-.171.427-.171.189 0 .334.057.438.171.107.11.16.273.16.491 0 .21-.053.372-.16.486a.574.574 0 0 1-.438.17.588.588 0 0 1-.413-.151c-.107-.103-.16-.272-.16-.505Zm7.113-3.049c0 1.228-.194 2.146-.583 2.752-.386.606-.977.909-1.775.909-.765 0-1.347-.309-1.745-.928-.4-.623-.599-1.534-.599-2.733 0-1.238.193-2.157.58-2.757.385-.6.973-.9 1.764-.9.772 0 1.357.313 1.756.939.401.625.602 1.531.602 2.718Zm-3.885 0c0 1.034.122 1.788.365 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.715.243-.48.365-1.23.365-2.251s-.122-1.768-.365-2.242c-.24-.476-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.365 1.218-.365 2.252Zm9.584 0c0 1.228-.194 2.146-.583 2.752-.386.606-.977.909-1.775.909-.765 0-1.347-.309-1.746-.928-.398-.623-.598-1.534-.598-2.733 0-1.238.193-2.157.579-2.757.386-.6.974-.9 1.765-.9.772 0 1.357.313 1.755.939.402.625.603 1.531.603 2.718Zm-3.885 0c0 1.034.122 1.788.365 2.261.243.47.63.705 1.162.705.538 0 .927-.238 1.167-.715.243-.48.365-1.23.365-2.251s-.122-1.768-.365-2.242c-.24-.476-.629-.715-1.167-.715-.532 0-.919.235-1.162.705-.243.467-.365 1.218-.365 2.252Zm9.881 1.93h-1.055v1.634h-.773v-1.634h-3.458v-.705l3.375-4.809h.856v4.78h1.055v.734Zm-1.828-.734v-2.363c0-.464.016-.987.048-1.571h-.039a7.23 7.23 0 0 1-.437.773l-2.222 3.161h2.65Zm9.559 2.368h-3.963v-7.109h3.963v.734h-3.136v2.291h2.947v.729h-2.947v2.616h3.136v.739Zm3.769 0h-.827v-6.375h-2.251v-.734h5.329v.734h-2.251v6.375Zm8.723 0h-.827v-3.345h-3.744v3.345h-.826v-7.109h.826v3.025h3.744v-3.025h.827v7.109Zm9.02-2.669c0 .868-.219 1.547-.656 2.037-.438.486-1.043.729-1.814.729-.477 0-.9-.112-1.269-.335a2.215 2.215 0 0 1-.856-.963c-.201-.418-.302-.908-.302-1.468 0-.869.218-1.545.652-2.028.434-.486 1.037-.73 1.809-.73.746 0 1.337.248 1.775.744.441.496.661 1.167.661 2.014Zm-4.06 0c0 .68.136 1.199.408 1.556.273.356.673.534 1.201.534.529 0 .929-.176 1.201-.53.276-.356.414-.876.414-1.56 0-.678-.138-1.192-.414-1.542-.272-.353-.676-.53-1.21-.53-.529 0-.928.174-1.197.52-.269.347-.403.864-.403 1.552Zm6.238-2.66v3.457c0 .434.099.759.297.972.198.214.507.321.929.321.557 0 .964-.152 1.22-.457.26-.304.389-.802.389-1.492v-2.801h.807v5.329h-.666l-.116-.715h-.044a1.6 1.6 0 0 1-.691.603c-.291.14-.625.209-1.001.209-.649 0-1.135-.154-1.459-.462-.321-.308-.481-.8-.481-1.478v-3.486h.816Zm7.08 4.76c.143 0 .281-.01.414-.029.132-.023.238-.045.316-.068v.617a1.411 1.411 0 0 1-.389.103 2.72 2.72 0 0 1-.457.043c-1.031 0-1.547-.543-1.547-1.629v-3.17h-.763v-.389l.763-.336.341-1.137h.466v1.235h1.547v.627h-1.547v3.136c0 .321.077.568.229.739.152.172.361.258.627.258Zm8.986-2.1c0 .868-.219 1.547-.656 2.037-.438.486-1.042.729-1.814.729-.476 0-.9-.112-1.269-.335a2.215 2.215 0 0 1-.856-.963c-.201-.418-.301-.908-.301-1.468 0-.869.217-1.545.651-2.028.435-.486 1.038-.73 1.809-.73.746 0 1.337.248 1.775.744.441.496.661 1.167.661 2.014Zm-4.06 0c0 .68.136 1.199.408 1.556.273.356.673.534 1.201.534.529 0 .929-.176 1.202-.53.275-.356.413-.876.413-1.56 0-.678-.138-1.192-.413-1.542-.273-.353-.676-.53-1.211-.53-.529 0-.927.174-1.196.52-.269.347-.404.864-.404 1.552Zm7.882-2.033h-1.357v4.702h-.807v-4.702h-.953v-.365l.953-.291v-.297c0-1.31.572-1.964 1.717-1.964.282 0 .612.056.992.17l-.209.646c-.312-.1-.577-.15-.798-.15-.305 0-.53.102-.676.306-.146.201-.219.525-.219.973v.345h1.357v.627Zm7.902 1.138c0 1.228-.195 2.146-.584 2.752-.386.606-.977.909-1.775.909-.765 0-1.347-.309-1.745-.928-.399-.623-.598-1.534-.598-2.733 0-1.238.193-2.157.578-2.757.386-.6.974-.9 1.765-.9.772 0 1.357.313 1.756.939.402.625.603 1.531.603 2.718Zm-3.885 0c0 1.034.121 1.788.364 2.261.243.47.631.705 1.162.705.539 0 .928-.238 1.167-.715.244-.48.365-1.23.365-2.251s-.121-1.768-.365-2.242c-.239-.476-.628-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.364 1.218-.364 2.252Zm5.125 3.049c0-.218.048-.381.146-.491.1-.114.243-.171.427-.171.188 0 .334.057.438.171.107.11.161.273.161.491 0 .21-.054.372-.161.486a.575.575 0 0 1-.438.17.588.588 0 0 1-.413-.151c-.107-.103-.16-.272-.16-.505Zm7.114-3.049c0 1.228-.195 2.146-.584 2.752-.386.606-.977.909-1.775.909-.765 0-1.347-.309-1.745-.928-.399-.623-.599-1.534-.599-2.733 0-1.238.193-2.157.579-2.757.386-.6.974-.9 1.765-.9.772 0 1.357.313 1.756.939.402.625.603 1.531.603 2.718Zm-3.886 0c0 1.034.122 1.788.365 2.261.243.47.631.705 1.162.705.538 0 .927-.238 1.167-.715.243-.48.365-1.23.365-2.251s-.122-1.768-.365-2.242c-.24-.476-.629-.715-1.167-.715-.531 0-.919.235-1.162.705-.243.467-.365 1.218-.365 2.252Zm7.863 3.564h-.788v-5.067c0-.421.013-.82.039-1.196-.068.068-.144.14-.228.214-.085.075-.47.391-1.158.948l-.427-.554 1.881-1.454h.681v7.109Zm9.749 0h-3.963v-7.109h3.963v.734h-3.136v2.291h2.947v.729h-2.947v2.616h3.136v.739Zm3.769 0h-.827v-6.375h-2.251v-.734h5.329v.734h-2.251v6.375Zm8.723 0h-.826v-3.345h-3.745v3.345h-.826v-7.109h.826v3.025h3.745v-3.025h.826v7.109Zm6.851-5.427c.237 0 .449.02.637.059l-.111.749a2.731 2.731 0 0 0-.584-.073c-.431 0-.801.175-1.109.525-.304.35-.457.786-.457 1.308v2.859h-.807v-5.329h.666l.093.987h.039c.197-.347.436-.614.714-.802.279-.188.586-.283.919-.283Zm3.886 5.524c-.788 0-1.41-.24-1.868-.719-.453-.48-.68-1.146-.68-1.999 0-.859.21-1.541.632-2.047.424-.506.993-.759 1.707-.759.667 0 1.196.221 1.585.662.389.437.583 1.016.583 1.736v.51h-3.671c.016.626.173 1.101.472 1.425.301.324.724.486 1.269.486.574 0 1.141-.12 1.702-.36v.72a4.168 4.168 0 0 1-.812.263c-.253.055-.56.082-.919.082Zm-.219-4.848c-.428 0-.77.14-1.026.419-.253.278-.402.664-.448 1.157h2.787c0-.509-.114-.898-.341-1.167-.227-.272-.551-.409-.972-.409Zm5.572 4.172c.538 0 .931-.144 1.177-.432.246-.289.378-.775.394-1.459v-.18c0-.746-.127-1.282-.379-1.61-.253-.327-.654-.491-1.201-.491-.474 0-.837.185-1.09.555-.249.366-.374.885-.374 1.556s.123 1.183.369 1.536c.25.35.618.525 1.104.525Zm-.121.676c-.688 0-1.224-.241-1.61-.724-.386-.483-.578-1.157-.578-2.023 0-.872.194-1.553.583-2.042.389-.49.93-.735 1.624-.735.73 0 1.29.276 1.683.827h.043l.117-.729h.637v7.721h-.807v-2.28c0-.324.018-.6.053-.827h-.063c-.373.542-.933.812-1.682.812Zm4.974-5.426v3.457c0 .434.099.759.297.972.197.214.507.321.928.321.558 0 .965-.152 1.221-.457.259-.304.389-.802.389-1.492v-2.801h.807v5.329h-.666l-.117-.715h-.044a1.598 1.598 0 0 1-.69.603 2.29 2.29 0 0 1-1.002.209c-.648 0-1.134-.154-1.458-.462-.321-.308-.482-.8-.482-1.478v-3.486h.817Zm6.166 5.329h-.807v-5.329h.807v5.329Zm-.876-6.773c0-.185.046-.32.137-.404a.467.467 0 0 1 .34-.131c.13 0 .241.043.335.131.094.088.142.222.142.404 0 .181-.048.317-.142.408a.471.471 0 0 1-.335.131.467.467 0 0 1-.34-.131c-.091-.091-.137-.227-.137-.408Zm5.019 1.346c.236 0 .449.02.637.059l-.112.749a2.731 2.731 0 0 0-.584-.073c-.431 0-.8.175-1.108.525-.305.35-.458.786-.458 1.308v2.859h-.807v-5.329h.666l.093.987h.039a2.34 2.34 0 0 1 .715-.802c.278-.188.585-.283.919-.283Zm3.885 5.524c-.788 0-1.41-.24-1.867-.719-.454-.48-.681-1.146-.681-1.999 0-.859.21-1.541.632-2.047.425-.506.993-.759 1.707-.759.667 0 1.196.221 1.585.662.389.437.583 1.016.583 1.736v.51h-3.671c.016.626.174 1.101.472 1.425.301.324.724.486 1.269.486.574 0 1.141-.12 1.702-.36v.72a4.147 4.147 0 0 1-.812.263 4.396 4.396 0 0 1-.919.082Zm-.219-4.848c-.428 0-.77.14-1.026.419-.253.278-.402.664-.447 1.157h2.786c0-.509-.114-.898-.341-1.167-.226-.272-.551-.409-.972-.409Zm7.187 4.036h-.044c-.373.542-.93.812-1.673.812-.697 0-1.24-.238-1.629-.714-.385-.477-.578-1.155-.578-2.033 0-.879.194-1.561.583-2.047.389-.486.931-.73 1.624-.73.723 0 1.277.263 1.663.788h.063l-.034-.384-.019-.374v-2.169h.807v7.566h-.656l-.107-.715Zm-1.615.136c.551 0 .95-.149 1.197-.447.249-.301.374-.786.374-1.454v-.17c0-.755-.126-1.293-.379-1.614-.25-.325-.65-.487-1.201-.487-.474 0-.837.185-1.09.555-.249.366-.374.885-.374 1.556 0 .68.125 1.194.374 1.541.25.347.616.52 1.099.52Z",
                className: "stage-one_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M35.717 233.458c0 .743-.243 1.311-.73 1.707-.486.395-1.178.593-2.076.593h-.739v2.66H31.01v-7.109h2.047c.888 0 1.553.182 1.994.545.444.363.666.898.666 1.604Zm-3.545 1.323h.618c.596 0 1.034-.104 1.313-.311.278-.208.418-.532.418-.973 0-.408-.125-.713-.375-.914-.25-.201-.638-.302-1.167-.302h-.807v2.5Zm8.208 3.637-.229-.749h-.038c-.26.328-.52.551-.783.671-.263.117-.6.175-1.012.175-.528 0-.941-.142-1.24-.428-.295-.285-.442-.689-.442-1.21 0-.555.206-.973.617-1.255.412-.282 1.04-.436 1.882-.462l.929-.029v-.287c0-.344-.081-.6-.243-.768-.159-.172-.407-.258-.744-.258-.276 0-.54.041-.793.122a6.01 6.01 0 0 0-.73.286l-.369-.816c.292-.153.611-.268.958-.346.347-.081.675-.121.983-.121.684 0 1.199.149 1.546.447.35.298.525.767.525 1.405v3.623h-.817Zm-1.702-.778c.415 0 .747-.115.997-.345.253-.234.38-.559.38-.978v-.466l-.691.029c-.538.019-.93.11-1.177.272-.243.159-.365.404-.365.734 0 .24.072.427.214.559.143.13.357.195.642.195Zm3.297-4.6h1.245l1.094 3.049c.165.434.275.843.33 1.225h.04c.029-.178.082-.394.16-.647.078-.256.49-1.465 1.235-3.627h1.235l-2.3 6.093c-.418 1.118-1.115 1.677-2.09 1.677-.254 0-.5-.027-.74-.082v-.905c.172.039.368.059.588.059.552 0 .939-.32 1.163-.958l.199-.506-2.159-5.378Zm13.182 5.378H50.34v-.866l1.833-1.842c.541-.555.9-.947 1.074-1.177a2.82 2.82 0 0 0 .39-.657c.08-.204.12-.423.12-.656 0-.321-.096-.574-.29-.759-.192-.184-.458-.277-.798-.277-.273 0-.537.05-.793.151-.253.1-.546.282-.88.545l-.618-.754c.396-.334.78-.571 1.153-.71s.77-.209 1.191-.209c.661 0 1.191.173 1.59.52.399.344.598.807.598 1.391 0 .321-.058.625-.175.914-.113.288-.29.587-.53.895-.236.304-.632.718-1.186 1.24l-1.235 1.196v.048h3.374v1.007Zm3.282-4.44c.717 0 1.284.19 1.702.569.419.38.628.897.628 1.552 0 .758-.239 1.351-.715 1.779-.474.425-1.148.637-2.023.637-.794 0-1.418-.128-1.872-.384v-1.036c.263.149.564.265.904.346.34.081.657.121.948.121.516 0 .908-.115 1.177-.345.27-.23.404-.567.404-1.011 0-.85-.541-1.274-1.624-1.274a4.1 4.1 0 0 0-.564.048 6.14 6.14 0 0 0-.589.102l-.51-.301.272-3.472h3.696v1.016h-2.69l-.16 1.76.413-.068c.166-.026.367-.039.603-.039Zm8.096.885c0 1.236-.199 2.153-.598 2.753-.395.599-1.001.899-1.818.899-.791 0-1.39-.309-1.8-.929-.408-.619-.612-1.526-.612-2.723 0-1.254.198-2.178.593-2.771.399-.597 1.005-.895 1.819-.895.794 0 1.395.311 1.804.934.408.622.612 1.533.612 2.732Zm-3.67 0c0 .97.098 1.662.296 2.077.2.415.52.622.958.622.438 0 .757-.211.958-.632.204-.421.306-1.11.306-2.067 0-.953-.102-1.641-.306-2.066-.201-.428-.52-.642-.958-.642-.438 0-.757.209-.958.627-.198.418-.297 1.112-.297 2.081Zm13.41-.068c0 1.174-.326 2.072-.977 2.694-.652.619-1.59.929-2.816.929h-1.988v-7.109h2.198c1.13 0 2.01.305 2.64.914.629.61.943 1.467.943 2.572Zm-1.225.039c0-1.702-.796-2.553-2.388-2.553h-1.006v5.16h.826c1.712 0 2.568-.869 2.568-2.607Zm7.167 3.584-.71-1.974H78.79l-.695 1.974h-1.226l2.66-7.138h1.264l2.66 7.138h-1.235Zm-1.016-2.976-.666-1.935a14.57 14.57 0 0 1-.38-1.226c-.087.399-.215.835-.384 1.308l-.642 1.853h2.072Zm3.19 2.976v-7.109h1.162v7.109H84.39Z",
                className: "stage-one_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 295.393,
                cy: 235.954,
                r: 8.18,
                className: "stage-one_svg__circle-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 295.393,
                cy: 235.957,
                r: 4.043,
                className: "stage-one_svg__circle-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#stage-one_svg__d)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m38.49 247.41-.377-.378a.4.4 0 0 0-.566 0l-.094.095-1.886-1.886.094-.095a.4.4 0 0 0 0-.566l-.377-.377a.4.4 0 0 0-.566 0l-2.075 2.075a.4.4 0 0 0 0 .566l.377.377a.4.4 0 0 0 .566 0l.094-.094.66.66-1.35 1.351-.095-.094a.532.532 0 0 0-.754 0l-1.913 1.913a.533.533 0 0 0 0 .754l.754.754a.532.532 0 0 0 .755 0l1.913-1.912a.534.534 0 0 0 0-.755l-.095-.094 1.351-1.351.66.66-.094.094a.4.4 0 0 0 0 .566l.377.377a.4.4 0 0 0 .566 0l2.075-2.075a.399.399 0 0 0 0-.565Z",
                    className: "stage-one_svg__path-7"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M42.342 251.355v-6.093h.709v5.452h2.688v.641h-3.397Zm8.274-2.288c0 .745-.188 1.327-.563 1.747-.375.416-.893.625-1.555.625-.408 0-.77-.096-1.087-.288a1.895 1.895 0 0 1-.734-.825c-.172-.358-.258-.778-.258-1.259 0-.744.186-1.324.558-1.738.372-.416.89-.625 1.55-.625.64 0 1.147.213 1.522.638.378.425.567 1 .567 1.725Zm-3.48 0c0 .584.116 1.028.35 1.334.233.306.576.458 1.029.458.453 0 .796-.151 1.03-.454.236-.305.354-.751.354-1.338 0-.58-.118-1.021-.355-1.321-.233-.303-.579-.454-1.037-.454-.453 0-.795.148-1.026.446-.23.297-.346.74-.346 1.329Zm7.643 1.042c0 .425-.158.753-.475.984-.317.231-.761.346-1.334.346-.605 0-1.078-.096-1.417-.288v-.642c.22.112.455.199.705.263.253.064.496.096.73.096.36 0 .638-.057.833-.171a.577.577 0 0 0 .291-.529.566.566 0 0 0-.233-.455c-.153-.127-.453-.278-.9-.45-.425-.158-.728-.296-.909-.412a1.293 1.293 0 0 1-.4-.405 1.06 1.06 0 0 1-.13-.537c0-.373.152-.666.455-.88.303-.217.718-.325 1.246-.325.492 0 .973.1 1.442.3l-.245.563c-.459-.189-.874-.284-1.247-.284-.328 0-.575.052-.742.155a.475.475 0 0 0-.25.425c0 .122.031.226.092.312a.943.943 0 0 0 .304.246c.14.078.406.191.8.338.542.197.908.396 1.097.596.191.2.287.451.287.754Zm3.06 1.33c-.676 0-1.21-.206-1.6-.617-.39-.411-.584-.982-.584-1.713 0-.736.18-1.321.541-1.755.364-.433.852-.65 1.463-.65.573 0 1.026.189 1.359.567.334.375.5.871.5 1.488v.438h-3.147c.014.536.15.943.405 1.221.258.278.62.416 1.087.416.492 0 .979-.102 1.46-.308v.617a3.543 3.543 0 0 1-.697.225c-.216.047-.48.071-.787.071Zm-.188-4.156c-.367 0-.66.12-.88.359-.216.239-.344.57-.383.992h2.388c0-.436-.097-.77-.292-1-.194-.234-.472-.351-.833-.351Zm5.135-.579c.203 0 .385.017.546.05l-.096.642a2.34 2.34 0 0 0-.5-.063c-.37 0-.686.151-.95.451-.262.3-.392.673-.392 1.121v2.45h-.692v-4.568h.57l.08.847h.033c.17-.298.374-.527.613-.688a1.38 1.38 0 0 1 .788-.242Z",
                className: "stage-one_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 13.5,
                y: 14.766,
                width: 59,
                height: 56.736,
                rx: 1.198,
                className: "stage-one_svg__rect-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M44.212 53.605h-1.559v-6.261c0-.748.018-1.34.053-1.778a5.209 5.209 0 0 1-.378.351c-.146.129-.641.536-1.486 1.221l-.783-.988 2.853-2.242h1.3v9.697Z",
                className: "stage-one_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M36.254 31.35c0 .504-.182.898-.545 1.185-.364.286-.866.43-1.506.43s-1.163-.1-1.57-.299v-.874c.257.12.53.216.82.286.291.07.562.104.812.104.367 0 .636-.07.809-.209a.68.68 0 0 0 .263-.56c0-.212-.08-.391-.24-.538-.16-.147-.49-.322-.99-.523-.516-.209-.88-.447-1.092-.716a1.514 1.514 0 0 1-.317-.967c0-.472.168-.843.503-1.114.335-.271.786-.407 1.35-.407.542 0 1.081.12 1.618.356l-.294.755c-.503-.212-.952-.317-1.347-.317-.299 0-.526.065-.68.197a.636.636 0 0 0-.233.515c0 .147.031.273.093.379a.958.958 0 0 0 .306.294c.142.093.397.215.766.367.415.173.72.335.913.484.194.15.335.319.426.507.09.188.135.41.135.666Zm2.593.879c.221 0 .443-.035.665-.105v.685c-.1.044-.23.08-.39.109-.158.03-.322.046-.492.046-.862 0-1.293-.454-1.293-1.362v-2.306h-.584v-.402l.627-.333.31-.906h.56v.952h1.22v.689h-1.22v2.29c0 .22.055.382.163.488a.61.61 0 0 0 .434.155Zm4.202.658-.182-.596h-.031c-.206.26-.414.438-.623.534-.209.093-.477.14-.805.14-.42 0-.75-.114-.987-.341-.234-.227-.352-.549-.352-.964 0-.441.164-.774.492-.998.327-.225.827-.347 1.497-.368l.74-.023v-.228c0-.274-.065-.477-.194-.612-.127-.136-.324-.205-.592-.205-.22 0-.43.033-.631.097a4.76 4.76 0 0 0-.58.228l-.294-.65a3.11 3.11 0 0 1 .762-.274 3.44 3.44 0 0 1 .781-.097c.545 0 .955.118 1.23.356.28.237.419.61.419 1.118v2.883h-.65Zm-1.355-.62c.33 0 .595-.091.794-.274.2-.186.301-.445.301-.778v-.371l-.549.023c-.428.015-.74.088-.936.217-.194.126-.29.32-.29.584 0 .19.056.34.17.445.113.103.283.155.51.155Zm6.888-3.66v.5l-.731.135a1.312 1.312 0 0 1 .232.75c0 .441-.152.788-.457 1.041-.304.253-.723.38-1.257.38-.137 0-.26-.01-.372-.032-.196.122-.294.264-.294.426 0 .098.045.172.136.22.092.05.261.074.506.074h.747c.472 0 .83.1 1.076.302.245.201.367.492.367.87 0 .486-.2.86-.6 1.123-.4.263-.977.395-1.733.395-.583 0-1.028-.104-1.335-.31-.307-.206-.46-.5-.46-.882a.95.95 0 0 1 .248-.666c.167-.178.4-.302.7-.371a.699.699 0 0 1-.302-.248.646.646 0 0 1-.116-.364c0-.16.045-.295.135-.406.09-.11.225-.22.403-.329a1.206 1.206 0 0 1-.542-.464 1.391 1.391 0 0 1-.205-.759c0-.464.146-.824.437-1.08.294-.255.712-.382 1.254-.382.121 0 .248.009.38.027.133.015.234.032.301.05h1.482Zm-3.363 4.945a.5.5 0 0 0 .264.453c.178.106.427.159.746.159.496 0 .864-.071 1.107-.213.242-.142.364-.33.364-.565 0-.186-.067-.319-.202-.399-.131-.077-.377-.116-.738-.116h-.69c-.26 0-.468.06-.622.182a.61.61 0 0 0-.229.5Zm.391-3.56c0 .269.069.475.205.62.14.144.338.216.596.216.526 0 .79-.281.79-.843 0-.279-.066-.493-.198-.643-.129-.152-.326-.228-.592-.228-.263 0-.463.075-.6.224-.134.15-.2.368-.2.654Zm5.638 2.972c-.666 0-1.187-.193-1.563-.58-.374-.39-.561-.925-.561-1.606 0-.7.174-1.249.522-1.648.348-.4.827-.6 1.436-.6.565 0 1.01.171 1.338.514.328.343.492.816.492 1.417v.491H50.06c.013.415.125.735.337.96.211.221.51.332.894.332.252 0 .487-.023.704-.07.219-.048.454-.128.704-.24v.74c-.222.106-.446.18-.673.224a4.124 4.124 0 0 1-.778.066Zm-.166-3.745c-.29 0-.522.091-.697.274-.173.183-.276.45-.31.801h1.943c-.005-.353-.09-.62-.255-.8-.166-.184-.392-.276-.681-.276Z",
                className: "stage-one_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "stage-one_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            className: "stage-one_svg__rect-11",
                            transform: "translate(30.072 121.738)",
                            d: "M0 0h8.536v8.536H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "stage-one_svg__d",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(30.072 244.086)",
                            className: "stage-one_svg__rect-12",
                            d: "M0 0h8.536v8.536H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "stage-one_svg__a",
                        x: 10,
                        y: 87,
                        width: 314,
                        height: 119.098,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.5
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14063_183957"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14063_183957",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "stage-one_svg__c",
                        x: 10,
                        y: 209.348,
                        width: 314,
                        height: 119.098,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.5
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14063_183957"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14063_183957",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $bb5fbca7120e22d8$export$2e2bcd8739ae039 = $bb5fbca7120e22d8$var$SvgStageOne;



const $710233ccf646df8b$var$StyledStageOneSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $bb5fbca7120e22d8$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="rect-2"],
  [class$="rect-6"],
  [class$="circle-1"],
  [class$="circle-2"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-4"],
  [class$="rect-8"] {
    fill: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-5"],
  [class$="path-9"],
  [class$="path-10"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  [class$="rect-9"],
  [class$="circle-3"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="rect-10"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="rect-11"],
  [class$="rect-12"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="path-2"],
  [class$="path-6"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-1"],
  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-3"],
  [class$="path-4"] {
    fill: ${({ theme: theme })=>theme.success};
  }

  [class$="path-7"],
  [class$="path-8"] {
    fill: ${({ theme: theme })=>theme.warning};
  }

  [class$="rect-3"],
  [class$="rect-7"],
  [class$="circle-1"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="circle-2"] {
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }
`;
const $710233ccf646df8b$var$StageOne = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $710233ccf646df8b$var$StyledStageOneSvg
    });
var $710233ccf646df8b$export$2e2bcd8739ae039 = $710233ccf646df8b$var$StageOne;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $227b302f45d04901$var$SvgStageTwo = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 415 217",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                width: 415,
                height: 217,
                rx: 3,
                className: "stage-two_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 13.442,
                y: 88.442,
                width: 388.116,
                height: 112.116,
                rx: 2.211,
                className: "stage-two_svg__rect-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "stage-two_svg__line-1",
                d: "M23 144.558h368"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 304.722,
                y: 113.648,
                width: 75.171,
                height: 7.075,
                rx: 3.537,
                className: "stage-two_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M41.123 105.447c0 .923-.302 1.63-.906 2.122-.605.492-1.465.737-2.582.737h-.919v3.307h-1.445v-8.838h2.545c1.105 0 1.931.225 2.48.677.551.451.827 1.116.827 1.995Zm-4.407 1.644h.768c.741 0 1.286-.129 1.632-.387.347-.258.52-.661.52-1.209 0-.508-.155-.886-.465-1.136-.31-.25-.794-.375-1.451-.375h-1.004v3.107Zm10.205 4.522-.284-.931h-.048c-.323.407-.647.685-.974.835-.326.145-.745.217-1.257.217-.657 0-1.171-.177-1.542-.532-.367-.354-.55-.856-.55-1.505 0-.689.256-1.209.768-1.56s1.291-.542 2.34-.574l1.154-.036v-.357c0-.427-.1-.746-.302-.955-.198-.214-.506-.321-.925-.321-.343 0-.671.051-.986.151-.314.101-.616.22-.907.357l-.459-1.016c.363-.189.76-.332 1.191-.429a5.363 5.363 0 0 1 1.221-.151c.85 0 1.491.185 1.923.556.435.371.653.953.653 1.747v4.504H46.92Zm-2.116-.967c.516 0 .929-.143 1.24-.429.314-.29.47-.695.47-1.215v-.581l-.858.037c-.669.024-1.156.137-1.463.338-.302.198-.453.502-.453.913 0 .298.089.53.266.695.177.161.443.242.798.242Zm4.099-5.719h1.547l1.36 3.79c.206.541.343 1.048.412 1.524h.048c.036-.222.103-.49.2-.804.097-.318.608-1.822 1.535-4.51h1.536l-2.86 7.575c-.52 1.39-1.386 2.086-2.6 2.086-.314 0-.62-.035-.918-.103v-1.125c.213.049.457.073.731.073.685 0 1.167-.397 1.445-1.191l.248-.629-2.684-6.686Zm16.39 6.686h-5.992v-1.076l2.28-2.291c.672-.689 1.118-1.177 1.335-1.463.222-.29.383-.562.484-.816.1-.254.151-.526.151-.816 0-.399-.12-.714-.363-.943-.237-.23-.568-.345-.991-.345-.339 0-.667.062-.986.187-.314.125-.679.351-1.094.677l-.768-.937c.492-.415.97-.709 1.433-.882.464-.174.957-.26 1.481-.26.823 0 1.482.215 1.977.647.496.427.744 1.003.744 1.729 0 .399-.073.778-.218 1.136a4.54 4.54 0 0 1-.659 1.113c-.294.378-.786.892-1.475 1.541l-1.535 1.487v.061h4.195v1.251Zm4.08-5.519c.89 0 1.596.236 2.116.707.52.472.78 1.114.78 1.929 0 .943-.296 1.68-.889 2.212-.588.528-1.427.792-2.515.792-.987 0-1.763-.159-2.327-.477v-1.288a4.29 4.29 0 0 0 1.124.429c.423.101.816.151 1.179.151.64 0 1.129-.143 1.463-.429.334-.286.502-.705.502-1.257 0-1.056-.673-1.584-2.02-1.584-.189 0-.423.02-.7.06a7.77 7.77 0 0 0-.732.127l-.635-.375.338-4.316h4.595v1.263H68.31l-.2 2.189c.141-.024.313-.053.514-.085.206-.032.456-.048.75-.048Zm10.066 1.1c0 1.536-.248 2.676-.744 3.422-.492.745-1.245 1.118-2.26 1.118-.984 0-1.73-.385-2.238-1.155-.507-.769-.761-1.898-.761-3.385 0-1.56.245-2.708.737-3.446.496-.742 1.25-1.112 2.261-1.112.987 0 1.735.387 2.243 1.16.508.774.762 1.907.762 3.398Zm-4.565 0c0 1.205.123 2.066.37 2.581.249.516.646.774 1.19.774.544 0 .941-.262 1.191-.786.254-.524.38-1.38.38-2.569 0-1.185-.126-2.041-.38-2.569-.25-.532-.647-.798-1.19-.798-.545 0-.942.26-1.192.78-.246.519-.369 1.382-.369 2.587Zm16.674-.085c0 1.459-.405 2.576-1.215 3.35-.81.769-1.977 1.154-3.5 1.154H84.36v-8.838h2.732c1.407 0 2.501.379 3.283 1.136.782.758 1.173 1.824 1.173 3.198Zm-1.524.049c0-2.116-.989-3.174-2.968-3.174h-1.251v6.414h1.027c2.128 0 3.192-1.08 3.192-3.24Zm8.911 4.455-.882-2.454h-3.38l-.864 2.454h-1.524l3.307-8.875h1.572l3.307 8.875h-1.535Zm-1.263-3.7-.828-2.406a18.462 18.462 0 0 1-.472-1.523 13.501 13.501 0 0 1-.477 1.626l-.798 2.303h2.575Zm3.966 3.7v-8.838h1.445v8.838h-1.445Z",
                className: "stage-two_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#stage-two_svg__a)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "M34.105 124.685a5.307 5.307 0 1 1 10.613.001 5.307 5.307 0 0 1-10.614-.001Zm.9 0a4.407 4.407 0 1 0 8.813-.001 4.407 4.407 0 0 0-8.813.001Zm6.065-1.883h.556c.077 0 .122.088.075.151l-2.494 3.458a.372.372 0 0 1-.306.158.381.381 0 0 1-.306-.158l-1.476-2.046a.095.095 0 0 1 .077-.151h.555c.122 0 .236.059.307.158l.843 1.17 1.862-2.582a.376.376 0 0 1 .307-.158Z",
                    className: "stage-two_svg__path-2"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M56.267 124.385c0 1.213-.308 2.166-.923 2.861-.611.694-1.463 1.041-2.555 1.041-1.115 0-1.977-.34-2.585-1.021-.605-.684-.907-1.647-.907-2.891 0-1.233.304-2.189.912-2.866.608-.68 1.472-1.02 2.59-1.02 1.089 0 1.939.345 2.55 1.036.612.691.918 1.644.918 2.86Zm-6.037 0c0 1.026.217 1.805.653 2.337.438.529 1.074.793 1.906.793.84 0 1.474-.264 1.902-.793.429-.528.643-1.307.643-2.337 0-1.019-.214-1.791-.643-2.316-.425-.529-1.055-.793-1.891-.793-.84 0-1.479.266-1.917.798-.436.529-.653 1.299-.653 2.311Zm10.244 3.902a2.5 2.5 0 0 1-1.015-.202 1.93 1.93 0 0 1-.767-.632h-.063c.042.332.063.646.063.943v2.337h-.86v-8.229h.699l.12.778h.04c.222-.311.48-.536.773-.674a2.35 2.35 0 0 1 1.01-.207c.753 0 1.334.257 1.741.772.411.514.617 1.236.617 2.166 0 .932-.21 1.658-.627 2.176-.415.515-.991.772-1.73.772Zm-.124-5.156c-.58 0-1 .161-1.26.482-.259.321-.392.833-.398 1.534v.192c0 .798.133 1.369.399 1.715.266.342.692.513 1.28.513.49 0 .874-.199 1.15-.596.28-.397.42-.945.42-1.643 0-.708-.14-1.25-.42-1.627-.276-.38-.667-.57-1.171-.57Zm5.824 4.446c.152 0 .3-.01.44-.031.142-.024.255-.048.337-.072v.658a1.534 1.534 0 0 1-.414.109c-.18.031-.342.046-.487.046-1.099 0-1.648-.578-1.648-1.736v-3.378h-.813v-.415l.813-.357.363-1.213h.497v1.316h1.648v.669h-1.648v3.342c0 .342.081.605.244.788.162.183.385.274.668.274Zm2.778.607h-.86v-5.68h.86v5.68Zm-.933-7.219c0-.197.048-.34.145-.43a.503.503 0 0 1 .363-.14c.138 0 .257.047.357.14.1.093.15.237.15.43 0 .194-.05.339-.15.436a.507.507 0 0 1-.357.139.502.502 0 0 1-.363-.139c-.097-.097-.145-.242-.145-.436Zm7.659 4.374c0 .926-.233 1.649-.7 2.171-.466.518-1.11.777-1.933.777-.507 0-.958-.119-1.352-.357a2.367 2.367 0 0 1-.912-1.026c-.214-.446-.321-.968-.321-1.565 0-.926.231-1.646.694-2.161.463-.518 1.106-.777 1.928-.777.794 0 1.425.264 1.891.792.47.529.705 1.244.705 2.146Zm-4.327 0c0 .725.145 1.278.435 1.658.29.38.717.57 1.28.57.563 0 .99-.188 1.28-.565.294-.38.44-.934.44-1.663 0-.722-.146-1.27-.44-1.643-.29-.376-.72-.565-1.29-.565-.563 0-.988.185-1.275.555-.287.369-.43.92-.43 1.653Zm9.726 2.845v-3.674c0-.463-.105-.809-.316-1.037-.21-.228-.54-.342-.99-.342-.594 0-1.029.161-1.305.482-.277.321-.415.852-.415 1.591v2.98h-.86v-5.68h.7l.14.778h.04c.177-.28.424-.496.742-.648a2.378 2.378 0 0 1 1.062-.233c.684 0 1.199.165 1.544.497.346.328.519.855.519 1.581v3.705h-.86Zm7.95-5.011H87.58v5.011h-.86v-5.011h-1.015v-.389l1.015-.311v-.316c0-1.396.61-2.093 1.83-2.093.3 0 .652.06 1.057.181l-.223.689c-.332-.107-.615-.16-.85-.16-.325 0-.565.108-.72.326-.156.214-.233.56-.233 1.036v.368h1.445v.669Zm1.844-.669v3.685c0 .462.105.808.316 1.036.21.228.54.342.99.342.594 0 1.028-.162 1.3-.487.277-.325.415-.855.415-1.591v-2.985h.86v5.68h-.71l-.124-.762h-.047c-.176.28-.421.494-.736.642-.31.149-.666.223-1.067.223-.69 0-1.21-.164-1.555-.492-.342-.328-.513-.853-.513-1.575v-3.716h.871Zm6.57 5.68h-.86v-8.063h.86v8.063Zm2.685 0h-.86v-8.063h.86v8.063Zm.922-5.68h.923l1.243 3.239c.273.739.442 1.273.508 1.601h.041c.045-.176.139-.477.28-.902.145-.428.615-1.741 1.41-3.938h.922l-2.441 6.467c-.241.639-.525 1.092-.849 1.358-.322.269-.717.404-1.187.404-.263 0-.522-.029-.777-.088v-.689c.19.041.402.062.637.062.591 0 1.012-.332 1.264-.995l.317-.808-2.291-5.711Zm11.566.669h-1.446v5.011h-.86v-5.011h-1.015v-.389l1.015-.311v-.316c0-1.396.61-2.093 1.829-2.093.301 0 .653.06 1.057.181l-.222.689c-.332-.107-.615-.16-.85-.16-.325 0-.565.108-.72.326-.156.214-.234.56-.234 1.036v.368h1.446v.669Zm1.845-.669v3.685c0 .462.105.808.316 1.036.211.228.541.342.99.342.594 0 1.027-.162 1.3-.487.277-.325.415-.855.415-1.591v-2.985h.86v5.68h-.71l-.124-.762h-.047c-.176.28-.421.494-.736.642a2.438 2.438 0 0 1-1.067.223c-.691 0-1.209-.164-1.555-.492-.342-.328-.513-.853-.513-1.575v-3.716h.871Zm9.597 5.68v-3.674c0-.463-.106-.809-.316-1.037-.211-.228-.541-.342-.99-.342-.594 0-1.03.161-1.306.482-.276.321-.415.852-.415 1.591v2.98h-.86v-5.68h.7l.14.778h.041c.176-.28.423-.496.741-.648a2.378 2.378 0 0 1 1.062-.233c.684 0 1.199.165 1.545.497.345.328.518.855.518 1.581v3.705h-.86Zm6.498-.762h-.047c-.397.577-.991.865-1.783.865-.742 0-1.321-.254-1.735-.762-.412-.507-.617-1.229-.617-2.166 0-.936.207-1.663.622-2.181.414-.518.991-.777 1.73-.777.771 0 1.362.279 1.773.839h.067l-.036-.409-.021-.399v-2.311h.86v8.063h-.699l-.114-.762Zm-1.721.145c.588 0 1.012-.159 1.275-.477.266-.321.399-.838.399-1.549v-.182c0-.804-.135-1.378-.404-1.72-.266-.345-.693-.518-1.28-.518-.504 0-.891.197-1.161.591-.266.39-.399.943-.399 1.658 0 .725.133 1.273.399 1.642.266.37.657.555 1.171.555Zm6.763.72c-.84 0-1.503-.255-1.99-.767-.484-.511-.726-1.221-.726-2.129 0-.916.225-1.643.674-2.182.453-.539 1.059-.808 1.819-.808.711 0 1.275.235 1.689.704.415.467.622 1.083.622 1.85v.544h-3.912c.017.667.184 1.173.502 1.519.322.345.772.518 1.353.518.611 0 1.216-.128 1.813-.384v.767a4.329 4.329 0 0 1-.865.28 4.65 4.65 0 0 1-.979.088Zm-.234-5.166c-.456 0-.82.148-1.093.446-.269.297-.428.708-.477 1.233h2.97c0-.543-.121-.957-.363-1.244-.242-.29-.587-.435-1.037-.435Zm7.659 4.301h-.046c-.398.577-.992.865-1.783.865-.743 0-1.321-.254-1.736-.762-.411-.507-.617-1.229-.617-2.166 0-.936.208-1.663.622-2.181.415-.518.992-.777 1.731-.777.77 0 1.361.279 1.772.839h.068l-.037-.409-.02-.399v-2.311h.86v8.063h-.7l-.114-.762Zm-1.72.145c.587 0 1.012-.159 1.275-.477.266-.321.399-.838.399-1.549v-.182c0-.804-.135-1.378-.405-1.72-.266-.345-.692-.518-1.28-.518-.504 0-.891.197-1.16.591-.266.39-.399.943-.399 1.658 0 .725.133 1.273.399 1.642.266.37.656.555 1.171.555Zm10.612.617-.171-.809h-.041c-.283.356-.567.598-.85.726-.28.124-.63.186-1.052.186-.563 0-1.005-.145-1.326-.435-.318-.29-.477-.703-.477-1.239 0-1.146.917-1.748 2.751-1.803l.964-.031v-.352c0-.446-.097-.774-.29-.985-.19-.214-.496-.321-.917-.321-.473 0-1.009.145-1.607.435l-.264-.658c.28-.152.586-.271.917-.357.335-.087.671-.13 1.006-.13.677 0 1.178.15 1.502.451.329.3.493.782.493 1.446v3.876h-.638Zm-1.943-.607c.536 0 .955-.147 1.259-.44.308-.294.461-.705.461-1.233v-.513l-.86.036c-.684.024-1.178.131-1.482.321-.3.187-.451.479-.451.876 0 .311.094.547.28.71.19.162.455.243.793.243Zm6.192 0c.152 0 .299-.01.441-.031.142-.024.254-.048.337-.072v.658a1.547 1.547 0 0 1-.415.109 2.88 2.88 0 0 1-.487.046c-1.098 0-1.648-.578-1.648-1.736v-3.378h-.813v-.415l.813-.357.363-1.213h.497v1.316h1.648v.669h-1.648v3.342c0 .342.082.605.244.788.162.183.385.274.668.274Zm8.338-.943c0 .529-.197.936-.591 1.223-.394.287-.946.43-1.658.43-.753 0-1.34-.119-1.762-.357v-.798c.273.138.565.247.876.326.314.08.617.119.907.119.449 0 .794-.071 1.036-.212a.717.717 0 0 0 .363-.658c0-.221-.097-.41-.29-.565-.19-.159-.563-.346-1.12-.56-.528-.197-.905-.368-1.129-.513a1.605 1.605 0 0 1-.498-.502 1.325 1.325 0 0 1-.16-.669c0-.463.188-.827.565-1.093.376-.27.893-.404 1.549-.404.611 0 1.209.124 1.793.373l-.306.699c-.57-.235-1.086-.352-1.549-.352-.408 0-.715.064-.923.192-.207.127-.311.304-.311.528 0 .152.038.282.114.389.08.107.206.209.379.306.172.096.504.236.995.419.673.246 1.128.493 1.363.741.238.249.357.562.357.938Zm3.239.943c.152 0 .299-.01.44-.031.142-.024.254-.048.337-.072v.658a1.526 1.526 0 0 1-.415.109 2.88 2.88 0 0 1-.487.046c-1.098 0-1.647-.578-1.647-1.736v-3.378h-.814v-.415l.814-.357.362-1.213h.498v1.316h1.648v.669h-1.648v3.342c0 .342.081.605.243.788.163.183.385.274.669.274Zm5.41.607-.171-.809h-.042c-.283.356-.566.598-.85.726-.28.124-.63.186-1.052.186-.563 0-1.005-.145-1.326-.435-.318-.29-.477-.703-.477-1.239 0-1.146.917-1.748 2.752-1.803l.963-.031v-.352c0-.446-.096-.774-.29-.985-.19-.214-.495-.321-.917-.321-.473 0-1.009.145-1.606.435l-.265-.658c.28-.152.586-.271.918-.357.335-.087.67-.13 1.005-.13.677 0 1.178.15 1.503.451.328.3.492.782.492 1.446v3.876h-.637Zm-1.944-.607c.536 0 .956-.147 1.26-.44.307-.294.461-.705.461-1.233v-.513l-.86.036c-.684.024-1.178.131-1.482.321-.301.187-.451.479-.451.876 0 .311.093.547.28.71.19.162.454.243.792.243Zm9.006-5.073v.544l-1.051.125c.096.121.183.28.259.476.076.194.114.413.114.659 0 .556-.19 1-.57 1.331-.38.332-.902.498-1.565.498-.17 0-.328-.014-.477-.042-.366.194-.549.437-.549.731 0 .155.064.271.191.347.128.073.348.109.659.109h1.005c.615 0 1.086.129 1.414.389.332.259.498.635.498 1.129 0 .629-.252 1.107-.757 1.436-.504.331-1.24.497-2.207.497-.743 0-1.316-.138-1.72-.414-.401-.277-.602-.667-.602-1.172 0-.345.111-.644.332-.896.221-.252.532-.423.933-.513a.923.923 0 0 1-.368-.306.817.817 0 0 1-.145-.482c0-.207.055-.388.166-.544.11-.155.285-.306.523-.451a1.543 1.543 0 0 1-.72-.616 1.826 1.826 0 0 1-.275-.995c0-.622.187-1.1.56-1.436.373-.338.901-.507 1.585-.507.297 0 .565.034.804.103h1.963Zm-4.528 6.633a.77.77 0 0 0 .388.7c.259.159.631.238 1.114.238.722 0 1.256-.109 1.601-.326.349-.215.524-.507.524-.876 0-.308-.095-.522-.285-.643-.19-.117-.548-.176-1.073-.176h-1.031c-.39 0-.694.093-.912.28-.218.186-.326.454-.326.803Zm.466-4.814c0 .397.112.698.337.902.224.204.537.305.938.305.839 0 1.259-.407 1.259-1.222 0-.854-.425-1.28-1.275-1.28-.404 0-.715.108-.933.326-.217.218-.326.541-.326.969Zm7.628 3.964c-.84 0-1.503-.255-1.99-.767-.484-.511-.726-1.221-.726-2.129 0-.916.225-1.643.674-2.182.452-.539 1.059-.808 1.819-.808.711 0 1.274.235 1.689.704.415.467.622 1.083.622 1.85v.544h-3.912c.017.667.184 1.173.502 1.519.321.345.772.518 1.353.518.611 0 1.216-.128 1.813-.384v.767a4.329 4.329 0 0 1-.865.28c-.27.059-.596.088-.979.088Zm-.234-5.166c-.456 0-.82.148-1.093.446-.269.297-.428.708-.477 1.233h2.969c0-.543-.12-.957-.362-1.244-.242-.29-.588-.435-1.037-.435Zm9.343 5.063h-.839v-5.4c0-.449.014-.874.041-1.275a4.655 4.655 0 0 1-.243.228c-.09.08-.501.417-1.234 1.011l-.456-.591 2.006-1.549h.725v7.576Z",
                className: "stage-two_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M39.644 179.217c0 1.31-.207 2.287-.622 2.933-.411.646-1.041.969-1.891.969-.816 0-1.436-.33-1.86-.989-.425-.664-.638-1.634-.638-2.913 0-1.319.206-2.299.617-2.938.41-.639 1.038-.958 1.88-.958.823 0 1.446.333 1.871 1 .429.666.643 1.632.643 2.896Zm-4.14 0c0 1.102.13 1.906.388 2.41.26.501.672.751 1.239.751.573 0 .988-.254 1.243-.761.26-.512.389-1.311.389-2.4 0-1.088-.13-1.884-.389-2.389-.255-.507-.67-.761-1.243-.761-.567 0-.98.25-1.239.751-.259.498-.388 1.297-.388 2.399Zm5.461 3.249c0-.231.052-.406.156-.523.107-.121.259-.181.456-.181.2 0 .356.06.466.181.114.117.171.292.171.523 0 .225-.057.398-.17.519a.613.613 0 0 1-.467.181.63.63 0 0 1-.44-.161c-.115-.11-.172-.29-.172-.539Zm7.581-3.249c0 1.31-.207 2.287-.621 2.933-.412.646-1.042.969-1.892.969-.815 0-1.435-.33-1.86-.989-.425-.664-.638-1.634-.638-2.913 0-1.319.206-2.299.617-2.938.411-.639 1.038-.958 1.881-.958.822 0 1.446.333 1.87 1 .43.666.643 1.632.643 2.896Zm-4.14 0c0 1.102.13 1.906.389 2.41.259.501.672.751 1.238.751.574 0 .988-.254 1.244-.761.259-.512.388-1.311.388-2.4 0-1.088-.13-1.884-.388-2.389-.256-.507-.67-.761-1.244-.761-.566 0-.98.25-1.238.751-.26.498-.389 1.297-.389 2.399Zm10.214 0c0 1.31-.208 2.287-.622 2.933-.411.646-1.042.969-1.892.969-.815 0-1.435-.33-1.86-.989-.425-.664-.637-1.634-.637-2.913 0-1.319.205-2.299.616-2.938.411-.639 1.038-.958 1.881-.958.822 0 1.446.333 1.87 1 .43.666.644 1.632.644 2.896Zm-4.14 0c0 1.102.129 1.906.388 2.41.259.501.672.751 1.238.751.574 0 .988-.254 1.244-.761.259-.512.389-1.311.389-2.4 0-1.088-.13-1.884-.39-2.389-.255-.507-.67-.761-1.243-.761-.566 0-.98.25-1.238.751-.26.498-.389 1.297-.389 2.399Zm7.56-.829c.797 0 1.425.199 1.88.596.46.394.69.935.69 1.622 0 .784-.25 1.399-.752 1.845-.497.445-1.185.668-2.062.668-.853 0-1.505-.136-1.954-.409v-.829c.242.155.543.278.902.368.36.086.713.129 1.062.129.608 0 1.08-.143 1.415-.43.339-.287.508-.701.508-1.243 0-1.058-.648-1.586-1.943-1.586-.329 0-.767.05-1.317.15l-.445-.285.285-3.544h3.767v.793h-3.031l-.192 2.274a6.071 6.071 0 0 1 1.186-.119Zm3.793 1.389c0-1.489.288-2.601.865-3.337.58-.739 1.437-1.109 2.57-1.109.39 0 .698.033.923.098v.741a2.962 2.962 0 0 0-.912-.129c-.812 0-1.432.254-1.86.762-.43.504-.664 1.298-.705 2.383h.062c.38-.594.98-.891 1.803-.891.68 0 1.216.205 1.606.617.394.411.591.969.591 1.673 0 .788-.216 1.408-.648 1.861-.428.449-1.008.673-1.74.673-.785 0-1.407-.293-1.866-.881-.46-.59-.69-1.411-.69-2.461Zm2.544 2.612c.49 0 .87-.154 1.14-.462.273-.31.41-.758.41-1.342 0-.501-.127-.894-.379-1.181-.252-.287-.629-.43-1.13-.43-.31 0-.596.064-.855.192a1.6 1.6 0 0 0-.622.528 1.233 1.233 0 0 0-.227.7c0 .355.069.687.207.995.138.307.333.551.585.73.256.18.546.27.87.27Zm10.944.627h-4.223v-7.576h4.223v.782h-3.342v2.441h3.14v.777h-3.14v2.788h3.342v.788Zm4.016 0h-.881v-6.794h-2.4v-.782h5.68v.782h-2.399v6.794Zm9.296 0h-.88v-3.565h-3.99v3.565h-.882v-7.576h.881v3.223h3.99v-3.223h.881v7.576Zm9.613-2.845c0 .926-.234 1.649-.7 2.171-.466.518-1.11.777-1.933.777-.508 0-.959-.119-1.352-.357a2.367 2.367 0 0 1-.912-1.026c-.215-.446-.322-.968-.322-1.565 0-.926.232-1.646.695-2.161.463-.518 1.105-.777 1.928-.777.794 0 1.424.264 1.89.792.47.529.706 1.244.706 2.146Zm-4.327 0c0 .725.145 1.278.435 1.658.29.38.717.57 1.28.57.563 0 .99-.188 1.28-.565.293-.38.44-.934.44-1.663 0-.722-.147-1.27-.44-1.643-.29-.376-.72-.565-1.29-.565-.564 0-.989.185-1.275.555-.287.369-.43.92-.43 1.653Zm6.648-2.835v3.685c0 .463.105.808.316 1.036.211.228.541.342.99.342.594 0 1.028-.162 1.301-.487.276-.325.414-.855.414-1.591v-2.985h.86v5.68h-.71l-.124-.762h-.047c-.176.28-.421.494-.735.642a2.443 2.443 0 0 1-1.068.223c-.691 0-1.209-.164-1.555-.492-.341-.328-.513-.853-.513-1.575v-3.716h.871Zm7.545 5.073c.152 0 .299-.01.44-.031.142-.024.254-.048.337-.072v.658a1.527 1.527 0 0 1-.414.109 2.89 2.89 0 0 1-.488.046c-1.098 0-1.647-.578-1.647-1.736v-3.378h-.814v-.415l.814-.357.362-1.213h.498v1.316h1.648v.669H107.2v3.342c0 .342.081.605.243.788.163.183.386.274.669.274Zm9.576-2.238c0 .926-.233 1.649-.7 2.171-.466.518-1.11.777-1.932.777-.508 0-.959-.119-1.353-.357a2.365 2.365 0 0 1-.912-1.026c-.214-.446-.321-.968-.321-1.565 0-.926.231-1.646.694-2.161.463-.518 1.106-.777 1.928-.777.794 0 1.425.264 1.891.792.47.529.705 1.244.705 2.146Zm-4.327 0c0 .725.145 1.278.435 1.658.291.38.717.57 1.28.57.563 0 .99-.188 1.28-.565.294-.38.441-.934.441-1.663 0-.722-.147-1.27-.441-1.643-.29-.376-.72-.565-1.29-.565-.563 0-.988.185-1.275.555-.287.369-.43.92-.43 1.653Zm8.4-2.166h-1.446v5.011h-.86v-5.011h-1.016v-.389l1.016-.311v-.316c0-1.396.61-2.093 1.829-2.093.301 0 .653.06 1.057.181l-.223.689a2.842 2.842 0 0 0-.849-.16c-.325 0-.565.108-.721.326-.155.214-.233.56-.233 1.036v.368h1.446v.669Zm8.42 1.212c0 1.31-.207 2.287-.621 2.933-.412.646-1.042.969-1.892.969-.815 0-1.435-.33-1.86-.989-.425-.664-.637-1.634-.637-2.913 0-1.319.205-2.299.616-2.938.411-.639 1.038-.958 1.881-.958.822 0 1.446.333 1.871 1 .428.666.642 1.632.642 2.896Zm-4.14 0c0 1.102.13 1.906.389 2.41.259.501.672.751 1.238.751.574 0 .988-.254 1.244-.761.259-.512.388-1.311.388-2.4 0-1.088-.129-1.884-.388-2.389-.256-.507-.67-.761-1.244-.761-.566 0-.979.25-1.238.751-.259.498-.389 1.297-.389 2.399Zm5.462 3.249c0-.231.052-.406.155-.523.107-.121.259-.181.456-.181.201 0 .356.06.467.181.114.117.171.292.171.523 0 .225-.057.398-.171.519a.615.615 0 0 1-.467.181.628.628 0 0 1-.44-.161c-.114-.11-.171-.29-.171-.539Zm7.581-3.249c0 1.31-.207 2.287-.622 2.933-.411.646-1.042.969-1.891.969-.816 0-1.436-.33-1.861-.989-.425-.664-.637-1.634-.637-2.913 0-1.319.206-2.299.617-2.938.411-.639 1.038-.958 1.881-.958.822 0 1.445.333 1.87 1 .429.666.643 1.632.643 2.896Zm-4.14 0c0 1.102.129 1.906.388 2.41.259.501.672.751 1.239.751.573 0 .988-.254 1.243-.761.259-.512.389-1.311.389-2.4 0-1.088-.13-1.884-.389-2.389-.255-.507-.67-.761-1.243-.761-.567 0-.98.25-1.239.751-.259.498-.388 1.297-.388 2.399Zm8.379 3.799h-.84v-5.4c0-.449.014-.874.042-1.275a5.141 5.141 0 0 1-.244.228c-.09.08-.501.417-1.233 1.011l-.456-.591 2.005-1.549h.726v7.576Zm10.389 0h-4.223v-7.576h4.223v.782h-3.342v2.441h3.14v.777h-3.14v2.788h3.342v.788Zm4.016 0h-.881v-6.794h-2.399v-.782h5.679v.782h-2.399v6.794Zm9.296 0h-.881v-3.565h-3.99v3.565h-.88v-7.576h.88v3.223h3.99v-3.223h.881v7.576Zm7.302-5.783c.252 0 .478.02.678.062l-.119.798a2.92 2.92 0 0 0-.622-.078c-.459 0-.853.187-1.181.56-.325.373-.487.838-.487 1.394v3.047h-.86v-5.68h.71l.098 1.052h.042a2.5 2.5 0 0 1 .761-.855c.297-.2.624-.3.98-.3Zm4.14 5.886c-.839 0-1.503-.255-1.99-.767-.484-.511-.725-1.221-.725-2.129 0-.916.224-1.643.673-2.182.453-.539 1.059-.808 1.819-.808.712 0 1.275.235 1.689.704.415.467.622 1.083.622 1.85v.544h-3.912c.017.667.185 1.173.503 1.519.321.345.772.518 1.352.518a4.57 4.57 0 0 0 1.814-.384v.767a4.336 4.336 0 0 1-.866.28 4.65 4.65 0 0 1-.979.088Zm-.233-5.166c-.456 0-.821.148-1.094.446-.269.297-.428.708-.476 1.233h2.969c0-.542-.121-.957-.363-1.244-.242-.29-.587-.435-1.036-.435Zm5.938 4.446c.574 0 .992-.154 1.254-.461.263-.308.403-.826.42-1.555v-.191c0-.795-.135-1.367-.404-1.716-.27-.349-.696-.523-1.28-.523-.505 0-.891.197-1.161.591-.266.39-.399.943-.399 1.658s.131 1.261.394 1.637c.266.373.658.56 1.176.56Zm-.129.72c-.733 0-1.304-.257-1.716-.772-.411-.515-.616-1.233-.616-2.155 0-.93.207-1.655.622-2.177.414-.522.991-.782 1.73-.782.778 0 1.375.293 1.793.881h.047l.124-.778h.679v8.229h-.86v-2.43c0-.346.019-.639.057-.881h-.067c-.398.577-.995.865-1.793.865Zm5.301-5.783v3.685c0 .463.105.808.316 1.036.211.228.54.342.99.342.594 0 1.027-.162 1.3-.487.277-.325.415-.855.415-1.591v-2.985h.86v5.68h-.71l-.124-.762h-.047c-.176.28-.421.494-.736.642a2.441 2.441 0 0 1-1.067.223c-.691 0-1.209-.164-1.555-.492-.342-.328-.513-.853-.513-1.575v-3.716h.871Zm6.57 5.68h-.86v-5.68h.86v5.68Zm-.932-7.219c0-.197.048-.34.145-.43a.5.5 0 0 1 .362-.14c.139 0 .258.047.358.14.1.093.15.237.15.43 0 .194-.05.339-.15.436a.507.507 0 0 1-.358.139.5.5 0 0 1-.362-.139c-.097-.097-.145-.242-.145-.436Zm5.347 1.436c.252 0 .479.02.679.062l-.119.798a2.92 2.92 0 0 0-.622-.078c-.459 0-.853.187-1.181.56-.325.373-.488.838-.488 1.394v3.047h-.86v-5.68h.71l.099 1.052h.041c.211-.369.465-.654.762-.855.297-.2.623-.3.979-.3Zm4.141 5.886c-.84 0-1.503-.255-1.99-.767-.484-.511-.726-1.221-.726-2.129 0-.916.225-1.643.674-2.182.452-.539 1.059-.808 1.819-.808.711 0 1.274.235 1.689.704.415.467.622 1.083.622 1.85v.544h-3.912c.017.667.184 1.173.502 1.519.321.345.772.518 1.353.518.611 0 1.216-.128 1.813-.384v.767a4.329 4.329 0 0 1-.865.28c-.27.059-.596.088-.979.088Zm-.234-5.166c-.456 0-.82.148-1.093.446-.269.297-.428.708-.477 1.233h2.969c0-.542-.12-.957-.362-1.244-.242-.29-.588-.435-1.037-.435Zm7.659 4.301h-.046c-.398.577-.992.865-1.783.865-.743 0-1.321-.254-1.736-.761-.411-.508-.617-1.23-.617-2.166 0-.937.208-1.664.622-2.182.415-.518.992-.777 1.731-.777.77 0 1.361.279 1.772.839h.068l-.037-.409-.02-.399v-2.311h.86v8.063h-.7l-.114-.762Zm-1.72.145c.587 0 1.012-.159 1.275-.477.266-.321.399-.837.399-1.549v-.181c0-.805-.135-1.379-.405-1.721-.266-.345-.692-.518-1.28-.518-.504 0-.891.197-1.16.591-.266.39-.399.943-.399 1.658 0 .725.133 1.273.399 1.643.266.369.656.554 1.171.554Z",
                className: "stage-two_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M43.118 162.014c0 1.439-.36 2.557-1.082 3.355-.717.798-1.735 1.197-3.053 1.197-1.334 0-2.36-.395-3.077-1.185-.713-.794-1.07-1.92-1.07-3.379s.359-2.58 1.076-3.361c.721-.782 1.75-1.173 3.083-1.173 1.314 0 2.33.397 3.047 1.191.718.794 1.076 1.912 1.076 3.355Zm-6.746 0c0 1.088.22 1.914.659 2.479.439.56 1.09.84 1.952.84.859 0 1.506-.278 1.94-.834.44-.557.66-1.385.66-2.485 0-1.084-.218-1.906-.653-2.467-.431-.56-1.076-.84-1.935-.84-.866 0-1.521.28-1.964.84-.44.561-.66 1.383-.66 2.467Zm10.984 3.404a3.45 3.45 0 0 0 1.04-.164v1.07c-.157.069-.36.125-.61.17a4 4 0 0 1-.768.072c-1.346 0-2.02-.709-2.02-2.128v-3.603h-.912v-.629l.979-.52.484-1.414h.876v1.487h1.905v1.076h-1.905v3.579c0 .343.085.597.254.762.173.161.4.242.677.242Zm8.264 1.027h-1.426v-4.111c0-.516-.105-.9-.315-1.154-.205-.254-.534-.381-.985-.381-.597 0-1.036.179-1.318.538-.278.355-.417.951-.417 1.789v3.319h-1.42v-9.406h1.42v2.387c0 .383-.024.792-.073 1.228h.091c.194-.323.462-.573.804-.75.347-.177.75-.266 1.21-.266 1.62 0 2.43.816 2.43 2.449v4.358Zm4.897.121c-1.04 0-1.854-.302-2.442-.907-.585-.608-.877-1.444-.877-2.508 0-1.093.272-1.951.816-2.576.545-.625 1.292-.937 2.243-.937.883 0 1.58.268 2.092.804s.768 1.274.768 2.213v.768H58.66c.02.648.196 1.148.526 1.499.33.346.796.52 1.397.52.395 0 .761-.037 1.1-.109.343-.077.71-.202 1.1-.375v1.155a4.348 4.348 0 0 1-1.052.35c-.354.069-.76.103-1.215.103Zm-.26-5.852c-.451 0-.814.143-1.088.429-.27.287-.431.704-.483 1.252h3.034c-.008-.552-.14-.969-.399-1.252-.258-.286-.612-.429-1.064-.429Zm7.866-1.076c.286 0 .521.02.707.061l-.14 1.323a2.704 2.704 0 0 0-.628-.072c-.568 0-1.03.185-1.384.556-.351.371-.526.853-.526 1.445v3.494H64.73v-6.686h1.112l.188 1.179h.072c.222-.399.51-.716.865-.949a2.075 2.075 0 0 1 1.154-.351Zm11.1 3.452c0 1.092-.281 1.945-.841 2.557-.56.613-1.34.919-2.34.919-.624 0-1.177-.141-1.656-.423a2.792 2.792 0 0 1-1.107-1.215c-.258-.528-.387-1.141-.387-1.838 0-1.084.279-1.93.835-2.539.556-.609 1.34-.913 2.351-.913.968 0 1.733.312 2.298.937.564.621.846 1.459.846 2.515Zm-4.867 0c0 1.544.57 2.315 1.71 2.315 1.129 0 1.693-.771 1.693-2.315 0-1.527-.568-2.291-1.705-2.291-.596 0-1.03.197-1.3.592-.266.395-.398.962-.398 1.699Zm9.896 3.476c-.846 0-1.503-.304-1.97-.913h-.085c.056.565.084.907.084 1.028v2.739h-1.42v-9.661h1.148c.032.125.099.423.2.895h.072c.444-.677 1.108-1.016 1.995-1.016.834 0 1.483.302 1.947.907.467.604.701 1.453.701 2.545 0 1.092-.238 1.945-.713 2.557-.472.613-1.125.919-1.959.919Zm-.345-5.767c-.564 0-.977.165-1.239.496-.258.33-.387.858-.387 1.583v.212c0 .814.13 1.405.387 1.771.258.363.68.544 1.263.544.492 0 .871-.201 1.137-.604.266-.403.4-.977.4-1.723 0-.75-.134-1.316-.4-1.699-.262-.387-.649-.58-1.16-.58Zm7.158 4.619a3.45 3.45 0 0 0 1.04-.164v1.07c-.157.069-.36.125-.61.17a4 4 0 0 1-.768.072c-1.346 0-2.02-.709-2.02-2.128v-3.603h-.912v-.629l.979-.52.484-1.414h.876v1.487h1.905v1.076h-1.905v3.579c0 .343.085.597.254.762.173.161.4.242.677.242Zm3.803 1.027h-1.42v-6.686h1.42v6.686Zm-1.505-8.457c0-.254.068-.45.205-.587.141-.137.34-.205.599-.205.25 0 .443.068.58.205.141.137.212.333.212.587 0 .241-.071.433-.212.574-.137.137-.33.206-.58.206-.258 0-.458-.069-.599-.206-.137-.141-.206-.333-.206-.574Zm9.473 5.102c0 1.092-.28 1.945-.84 2.557-.561.613-1.341.919-2.34.919-.625 0-1.177-.141-1.657-.423a2.792 2.792 0 0 1-1.106-1.215c-.258-.528-.387-1.141-.387-1.838 0-1.084.278-1.93.835-2.539.556-.609 1.34-.913 2.351-.913.967 0 1.733.312 2.297.937.565.621.847 1.459.847 2.515Zm-4.867 0c0 1.544.57 2.315 1.711 2.315 1.129 0 1.693-.771 1.693-2.315 0-1.527-.568-2.291-1.705-2.291-.597 0-1.03.197-1.3.592-.266.395-.399.962-.399 1.699Zm12.387 3.355h-1.426v-4.111c0-.516-.105-.9-.315-1.154-.205-.254-.534-.381-.985-.381-.601 0-1.04.177-1.318.532-.278.354-.417.949-.417 1.783v3.331h-1.421v-6.686h1.113l.199.877h.073c.201-.319.487-.565.858-.738.371-.173.782-.26 1.233-.26 1.604 0 2.406.816 2.406 2.449v4.358Zm6.469-1.904c0 .653-.238 1.155-.713 1.505-.476.347-1.157.52-2.044.52-.89 0-1.606-.135-2.146-.405v-1.227c.786.363 1.518.544 2.195.544.874 0 1.312-.264 1.312-.792a.631.631 0 0 0-.145-.423c-.097-.113-.256-.23-.478-.351a8.203 8.203 0 0 0-.925-.411c-.77-.298-1.292-.596-1.566-.895-.27-.298-.405-.685-.405-1.16 0-.573.23-1.016.689-1.33.464-.319 1.093-.478 1.887-.478.785 0 1.529.159 2.23.478l-.459 1.07c-.722-.299-1.328-.448-1.82-.448-.749 0-1.124.214-1.124.641 0 .21.096.387.29.532.197.145.625.345 1.282.599.552.213.953.409 1.203.586.249.177.435.383.556.617.121.229.181.506.181.828Zm2.733-6.934-.248 3.192h-.907l-.248-3.192h1.403Zm9.527 6.934c0 .653-.237 1.155-.713 1.505-.476.347-1.157.52-2.043.52-.891 0-1.606-.135-2.146-.405v-1.227c.785.363 1.517.544 2.194.544.875 0 1.312-.264 1.312-.792a.626.626 0 0 0-.145-.423c-.097-.113-.256-.23-.478-.351a8.121 8.121 0 0 0-.925-.411c-.77-.298-1.291-.596-1.566-.895-.27-.298-.405-.685-.405-1.16 0-.573.23-1.016.69-1.33.463-.319 1.092-.478 1.886-.478.786 0 1.529.159 2.231.478l-.46 1.07c-.721-.299-1.328-.448-1.82-.448-.749 0-1.124.214-1.124.641 0 .21.097.387.29.532.198.145.625.345 1.282.599.552.213.953.409 1.203.586.25.177.435.383.556.617.121.229.181.506.181.828Zm6.258 1.904-.2-.876h-.073c-.197.31-.479.554-.846.731a2.792 2.792 0 0 1-1.245.266c-.81 0-1.415-.201-1.814-.604-.399-.403-.598-1.014-.598-1.832v-4.371h1.432v4.123c0 .512.105.897.315 1.155.209.254.538.381.985.381.597 0 1.034-.178 1.312-.532.282-.359.423-.958.423-1.796v-3.331h1.427v6.686h-1.118Zm8.778 0h-1.427v-4.123c0-.512-.097-.892-.29-1.142-.194-.254-.496-.381-.907-.381-.548 0-.951.179-1.209.538-.254.355-.381.947-.381 1.777v3.331h-1.421v-6.686h1.113l.199.877h.073c.185-.319.453-.565.804-.738a2.62 2.62 0 0 1 1.166-.26c1.028 0 1.709.351 2.044 1.052h.097a2.04 2.04 0 0 1 .834-.774c.359-.185.77-.278 1.233-.278.798 0 1.378.202 1.741.605.367.403.55 1.017.55 1.844v4.358h-1.42v-4.123c0-.512-.099-.892-.297-1.142-.193-.254-.495-.381-.906-.381-.553 0-.958.173-1.216.52-.253.342-.38.87-.38 1.584v3.542Zm15.349-3.355c0 1.092-.28 1.945-.84 2.557-.56.613-1.34.919-2.34.919-.625 0-1.177-.141-1.656-.423a2.792 2.792 0 0 1-1.107-1.215c-.258-.528-.387-1.141-.387-1.838 0-1.084.279-1.93.835-2.539.556-.609 1.34-.913 2.351-.913.968 0 1.734.312 2.298.937.564.621.846 1.459.846 2.515Zm-4.867 0c0 1.544.571 2.315 1.711 2.315 1.129 0 1.693-.771 1.693-2.315 0-1.527-.568-2.291-1.705-2.291-.596 0-1.029.197-1.3.592-.266.395-.399.962-.399 1.699Zm9.861-2.255h-1.633v5.61h-1.426v-5.61h-1.101v-.665l1.101-.435v-.435c0-.79.185-1.375.556-1.754.371-.383.937-.574 1.699-.574.499 0 .991.083 1.475.248l-.375 1.076a3.271 3.271 0 0 0-1.004-.169c-.322 0-.558.1-.707.302-.145.197-.218.496-.218.895v.435h1.633v1.076Zm7.714 0h-1.633v5.61h-1.426v-5.61h-1.101v-.665l1.101-.435v-.435c0-.79.185-1.375.556-1.754.371-.383.937-.574 1.699-.574.499 0 .991.083 1.475.248l-.375 1.076a3.271 3.271 0 0 0-1.004-.169c-.322 0-.558.1-.707.302-.145.197-.218.496-.218.895v.435h1.633v1.076Zm5.858 5.61-.2-.876h-.072c-.198.31-.48.554-.847.731a2.786 2.786 0 0 1-1.245.266c-.81 0-1.415-.201-1.814-.604-.399-.403-.598-1.014-.598-1.832v-4.371h1.433v4.123c0 .512.104.897.314 1.155.21.254.538.381.985.381.597 0 1.034-.178 1.312-.532.282-.359.424-.958.424-1.796v-3.331h1.426v6.686h-1.118Zm9.026 0h-1.427v-4.111c0-.516-.105-.9-.314-1.154-.206-.254-.534-.381-.986-.381-.6 0-1.04.177-1.318.532-.278.354-.417.949-.417 1.783v3.331h-1.42v-6.686h1.112l.199.877h.073c.201-.319.488-.565.858-.738.371-.173.782-.26 1.234-.26 1.604 0 2.406.816 2.406 2.449v4.358Zm4.232.121c-.835 0-1.486-.302-1.953-.907-.468-.604-.701-1.453-.701-2.545 0-1.096.235-1.948.707-2.557.476-.613 1.133-.919 1.971-.919.878 0 1.547.325 2.007.973h.072a8.565 8.565 0 0 1-.102-1.136v-2.436h1.426v9.406h-1.112l-.248-.876h-.066c-.456.665-1.123.997-2.001.997Zm.381-1.148c.584 0 1.009-.164 1.275-.49.266-.331.403-.865.411-1.602v-.2c0-.842-.137-1.441-.411-1.795-.274-.355-.703-.532-1.288-.532-.499 0-.884.203-1.154.61-.27.403-.405.98-.405 1.729 0 .742.131 1.308.393 1.699.262.387.655.581 1.179.581Zm9.57-.877c0 .653-.238 1.155-.714 1.505-.475.347-1.157.52-2.043.52-.891 0-1.606-.135-2.146-.405v-1.227c.786.363 1.517.544 2.194.544.875 0 1.312-.264 1.312-.792a.626.626 0 0 0-.145-.423c-.097-.113-.256-.23-.478-.351a8.121 8.121 0 0 0-.925-.411c-.769-.298-1.291-.596-1.565-.895-.27-.298-.405-.685-.405-1.16 0-.573.229-1.016.689-1.33.463-.319 1.092-.478 1.886-.478.786 0 1.529.159 2.231.478l-.46 1.07c-.721-.299-1.328-.448-1.819-.448-.75 0-1.125.214-1.125.641 0 .21.097.387.29.532.198.145.625.345 1.282.599.552.213.953.409 1.203.586.25.177.435.383.556.617.121.229.182.506.182.828Z",
                className: "stage-two_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M269.814 170.773c.931 0 1.662.232 2.194.695.536.46.804 1.091.804 1.893 0 .915-.292 1.632-.876 2.152-.581.52-1.383.78-2.406.78-.996 0-1.756-.159-2.28-.478v-.967c.283.181.633.324 1.052.429.42.101.833.151 1.24.151.709 0 1.259-.167 1.65-.501.395-.335.593-.819.593-1.451 0-1.234-.756-1.85-2.267-1.85-.383 0-.895.058-1.536.175l-.52-.333.333-4.135h4.395v.925h-3.537l-.224 2.654a7.103 7.103 0 0 1 1.385-.139Zm4.425 1.62c0-1.737.337-3.034 1.01-3.893.677-.862 1.676-1.294 2.998-1.294.456 0 .814.039 1.076.115v.865a3.434 3.434 0 0 0-1.064-.151c-.947 0-1.67.296-2.17.888-.5.589-.774 1.516-.822 2.781h.072c.444-.693 1.145-1.04 2.104-1.04.794 0 1.419.24 1.874.72.46.479.689 1.13.689 1.953 0 .918-.251 1.642-.755 2.17-.5.524-1.177.786-2.031.786-.915 0-1.641-.343-2.177-1.028-.536-.689-.804-1.646-.804-2.872Zm2.968 3.047c.573 0 1.016-.179 1.33-.538.319-.362.478-.884.478-1.565 0-.585-.147-1.044-.441-1.379-.295-.334-.734-.502-1.318-.502-.363 0-.695.075-.998.224a1.867 1.867 0 0 0-.725.617 1.431 1.431 0 0 0-.266.816c0 .415.08.802.242 1.161.161.358.389.642.683.852.298.21.637.314 1.015.314Zm4.873-5.471c0 .685.075 1.199.224 1.542.149.342.391.514.725.514.661 0 .992-.685.992-2.056 0-1.362-.331-2.043-.992-2.043-.334 0-.576.169-.725.508-.149.338-.224.85-.224 1.535Zm2.769 0c0 .919-.155 1.614-.466 2.086-.306.467-.757.701-1.354.701-.564 0-1.003-.24-1.318-.719-.31-.48-.465-1.169-.465-2.068 0-.915.149-1.604.447-2.067.302-.464.748-.696 1.336-.696.585 0 1.034.24 1.348.72.315.479.472 1.161.472 2.043Zm2.551 3.543c0 .689.075 1.205.224 1.548.149.338.393.507.731.507.339 0 .589-.167.75-.501.161-.339.242-.857.242-1.554 0-.689-.081-1.199-.242-1.53-.161-.334-.411-.501-.75-.501-.338 0-.582.167-.731.501-.149.331-.224.841-.224 1.53Zm2.775 0c0 .915-.155 1.608-.465 2.08-.307.467-.758.701-1.355.701-.572 0-1.013-.24-1.324-.72-.306-.479-.459-1.166-.459-2.061 0-.915.149-1.604.447-2.068.303-.463.748-.695 1.336-.695.573 0 1.018.238 1.336.713.323.472.484 1.155.484 2.05Zm-1.56-6.179-4.903 8.839h-.888l4.903-8.839h.888Z",
                className: "stage-two_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 304.722,
                y: 169.359,
                width: 75.171,
                height: 7.075,
                rx: 3.537,
                className: "stage-two_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 304.722,
                y: 169.359,
                width: 51.69,
                height: 7.075,
                rx: 3.537,
                className: "stage-two_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 13.5,
                y: 14.766,
                width: 59,
                height: 56.736,
                rx: 1.198,
                fill: "#2A1260",
                className: "stage-two_svg__rect-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M46.208 53.605h-6.573v-1.18l2.5-2.514c.74-.756 1.228-1.291 1.467-1.605.243-.319.42-.617.53-.896.11-.279.166-.577.166-.895 0-.438-.133-.783-.398-1.035-.26-.252-.623-.378-1.088-.378-.371 0-.732.068-1.081.205-.345.137-.745.385-1.2.743l-.843-1.028c.54-.455 1.063-.778 1.572-.968a4.6 4.6 0 0 1 1.625-.286c.902 0 1.625.237 2.17.71.543.469.815 1.101.815 1.897 0 .438-.08.854-.239 1.247-.154.394-.395.8-.723 1.22-.322.416-.862.98-1.618 1.692l-1.685 1.632v.066h4.603v1.373Z",
                className: "stage-two_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M36.254 31.35c0 .504-.182.898-.545 1.185-.364.286-.866.43-1.506.43s-1.163-.1-1.57-.299v-.874c.257.12.53.216.82.286.291.07.562.104.812.104.367 0 .636-.07.809-.209a.68.68 0 0 0 .263-.56c0-.212-.08-.391-.24-.538-.16-.147-.49-.322-.99-.523-.516-.209-.88-.447-1.092-.716a1.514 1.514 0 0 1-.317-.967c0-.472.168-.843.503-1.114.335-.271.786-.407 1.35-.407.542 0 1.081.12 1.618.356l-.294.755c-.503-.212-.952-.317-1.347-.317-.299 0-.526.065-.68.197a.636.636 0 0 0-.233.515c0 .147.031.273.093.379a.958.958 0 0 0 .306.294c.142.093.397.215.766.367.415.173.72.335.913.484.194.15.335.319.426.507.09.188.135.41.135.666Zm2.593.879c.221 0 .443-.035.665-.105v.685c-.1.044-.23.08-.39.109-.158.03-.322.046-.492.046-.862 0-1.293-.454-1.293-1.362v-2.306h-.584v-.402l.627-.333.31-.906h.56v.952h1.22v.689h-1.22v2.29c0 .22.055.382.163.488a.61.61 0 0 0 .434.155Zm4.202.658-.182-.596h-.031c-.206.26-.414.438-.623.534-.209.093-.477.14-.805.14-.42 0-.75-.114-.987-.341-.234-.227-.352-.549-.352-.964 0-.441.164-.774.492-.998.327-.225.827-.347 1.497-.368l.74-.023v-.228c0-.274-.065-.477-.194-.612-.127-.136-.324-.205-.592-.205-.22 0-.43.033-.631.097a4.76 4.76 0 0 0-.58.228l-.294-.65a3.11 3.11 0 0 1 .762-.274 3.44 3.44 0 0 1 .781-.097c.545 0 .955.118 1.23.356.28.237.419.61.419 1.118v2.883h-.65Zm-1.355-.62c.33 0 .595-.091.794-.274.2-.186.301-.445.301-.778v-.371l-.549.023c-.428.015-.74.088-.936.217-.194.126-.29.32-.29.584 0 .19.056.34.17.445.113.103.283.155.51.155Zm6.888-3.66v.5l-.731.135a1.312 1.312 0 0 1 .232.75c0 .441-.152.788-.457 1.041-.304.253-.723.38-1.257.38-.137 0-.26-.01-.372-.032-.196.122-.294.264-.294.426 0 .098.045.172.136.22.092.05.261.074.506.074h.747c.472 0 .83.1 1.076.302.245.201.367.492.367.87 0 .486-.2.86-.6 1.123-.4.263-.977.395-1.733.395-.583 0-1.028-.104-1.335-.31-.307-.206-.46-.5-.46-.882a.95.95 0 0 1 .248-.666c.167-.178.4-.302.7-.371a.699.699 0 0 1-.302-.248.646.646 0 0 1-.116-.364c0-.16.045-.295.135-.406.09-.11.225-.22.403-.329a1.206 1.206 0 0 1-.542-.464 1.391 1.391 0 0 1-.205-.759c0-.464.146-.824.437-1.08.294-.255.712-.382 1.254-.382.121 0 .248.009.38.027.133.015.234.032.301.05h1.482Zm-3.363 4.945a.5.5 0 0 0 .264.453c.178.106.427.159.746.159.496 0 .864-.071 1.107-.213.242-.142.364-.33.364-.565 0-.186-.067-.319-.202-.399-.131-.077-.377-.116-.738-.116h-.69c-.26 0-.468.06-.622.182a.61.61 0 0 0-.229.5Zm.391-3.56c0 .269.069.475.205.62.14.144.338.216.596.216.526 0 .79-.281.79-.843 0-.279-.066-.493-.198-.643-.129-.152-.326-.228-.592-.228-.263 0-.463.075-.6.224-.134.15-.2.368-.2.654Zm5.638 2.972c-.666 0-1.187-.193-1.563-.58-.374-.39-.561-.925-.561-1.606 0-.7.174-1.249.522-1.648.348-.4.827-.6 1.436-.6.565 0 1.01.171 1.338.514.328.343.492.816.492 1.417v.491H50.06c.013.415.125.735.337.96.211.221.51.332.894.332.252 0 .487-.023.704-.07.219-.048.454-.128.704-.24v.74c-.222.106-.446.18-.673.224a4.124 4.124 0 0 1-.778.066Zm-.166-3.745c-.29 0-.522.091-.697.274-.173.183-.276.45-.31.801h1.943c-.005-.353-.09-.62-.255-.8-.166-.184-.392-.276-.681-.276Z",
                className: "stage-two_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "stage-two_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        transform: "translate(34.105 119.379)",
                        className: "stage-two_svg__rect-7",
                        d: "M0 0h10.613v10.613H0z"
                    })
                })
            })
        ]
    });
var $227b302f45d04901$export$2e2bcd8739ae039 = $227b302f45d04901$var$SvgStageTwo;



const $f6ee9a2b7d570c07$var$StyledStageTwoSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $227b302f45d04901$export$2e2bcd8739ae039))`
  [class$="rect-1"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"],
  [class$="rect-6"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="rect-3"],
  [class$="path-2"],
  [class$="path-3"] {
    fill: ${({ theme: theme })=>theme.success};
  }

  [class$="rect-4"] {
    fill: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-5"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="rect-7"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="rect-6"],
  [class$="line-1"] {
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="path-1"],
  [class$="path-4"],
  [class$="path-5"],
  [class$="path-6"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-7"],
  [class$="path-8"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $f6ee9a2b7d570c07$var$StageTwo = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $f6ee9a2b7d570c07$var$StyledStageTwoSvg
    });
var $f6ee9a2b7d570c07$export$2e2bcd8739ae039 = $f6ee9a2b7d570c07$var$StageTwo;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $88283d724cf43731$var$SvgWhoWinsRewards = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 332,
        height: 268,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M.365 2.189c0-1.007.817-1.824 1.824-1.824h327.622c1.007 0 1.824.817 1.824 1.824v263.622a1.824 1.824 0 0 1-1.824 1.824H2.189a1.824 1.824 0 0 1-1.824-1.824V2.189Z",
                className: "who-wins-rewards_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M56.993 32.901c-1.098 0-1.966.367-2.604 1.101-.634.73-.95 1.73-.95 3 0 1.309.305 2.32.916 3.036.615.711 1.49 1.067 2.625 1.067.697 0 1.492-.126 2.385-.377v1.02c-.693.259-1.547.389-2.563.389-1.472 0-2.61-.447-3.411-1.34-.798-.893-1.197-2.163-1.197-3.808 0-1.03.192-1.932.575-2.707a4.174 4.174 0 0 1 1.668-1.79c.729-.42 1.586-.63 2.57-.63 1.048 0 1.964.192 2.748.575l-.492.998c-.757-.356-1.513-.534-2.27-.534Zm7.8 1.47c.333 0 .631.027.895.082l-.157 1.053a3.862 3.862 0 0 0-.82-.103c-.606 0-1.126.246-1.559.739-.428.492-.642 1.105-.642 1.838V42h-1.135v-7.492h.937l.13 1.387h.054c.278-.487.613-.863 1.005-1.127a2.262 2.262 0 0 1 1.292-.397Zm8.764 3.876c0 1.221-.308 2.176-.923 2.864-.615.684-1.465 1.026-2.55 1.026-.67 0-1.265-.157-1.784-.472a3.112 3.112 0 0 1-1.203-1.353c-.283-.588-.424-1.276-.424-2.065 0-1.221.305-2.172.916-2.85.61-.684 1.458-1.026 2.543-1.026 1.048 0 1.88.349 2.495 1.046.62.697.93 1.64.93 2.83Zm-5.708 0c0 .957.191 1.686.574 2.188.383.5.945.752 1.688.752s1.306-.249 1.689-.746c.387-.5.58-1.232.58-2.194 0-.952-.193-1.675-.58-2.167-.383-.497-.95-.745-1.702-.745-.743 0-1.304.244-1.682.731-.378.488-.567 1.215-.567 2.181ZM81.67 42l-1.374-4.395c-.087-.27-.248-.88-.486-1.832h-.054a25.087 25.087 0 0 1-.479 1.845L77.863 42h-1.312l-2.044-7.492h1.19c.482 1.882.85 3.315 1.1 4.3.255.984.4 1.647.437 1.989h.055a18.248 18.248 0 0 1 .533-1.99l1.374-4.3h1.23l1.34 4.3c.256.785.429 1.443.52 1.976h.055a7.63 7.63 0 0 1 .143-.759c.082-.341.559-2.18 1.43-5.516h1.175L83.018 42H81.67Zm9.878-1.005h-.062c-.524.761-1.308 1.142-2.351 1.142-.98 0-1.743-.335-2.29-1.005-.543-.67-.814-1.623-.814-2.858s.274-2.194.82-2.877c.547-.684 1.308-1.026 2.284-1.026 1.016 0 1.795.37 2.338 1.107h.088l-.047-.54-.028-.526v-3.049h1.135V42H91.7l-.15-1.005Zm-2.27.192c.775 0 1.336-.21 1.682-.63.35-.423.526-1.105.526-2.043v-.24c0-1.061-.177-1.818-.533-2.27-.35-.455-.914-.683-1.688-.683-.666 0-1.176.26-1.532.78-.35.515-.526 1.244-.526 2.187 0 .957.175 1.68.526 2.167.351.488.866.732 1.545.732Zm9.133-5.797h-1.907V42H95.37v-6.61h-1.34v-.513l1.34-.41v-.417c0-1.841.804-2.762 2.413-2.762.397 0 .861.08 1.395.24l-.294.909c-.438-.142-.811-.212-1.121-.212-.429 0-.745.143-.95.43-.206.283-.308.739-.308 1.367v.486h1.907v.882Zm2.434-.882v4.86c0 .61.139 1.067.417 1.367.278.301.713.452 1.305.452.784 0 1.356-.215 1.716-.643.365-.428.547-1.128.547-2.099v-3.937h1.135V42h-.937l-.164-1.005h-.061a2.26 2.26 0 0 1-.971.848c-.41.196-.88.294-1.408.294-.912 0-1.595-.217-2.051-.65-.451-.433-.677-1.125-.677-2.078v-4.901h1.149ZM113.506 42v-4.847c0-.61-.139-1.066-.417-1.367-.278-.3-.713-.451-1.306-.451-.784 0-1.358.212-1.722.636-.365.424-.547 1.123-.547 2.098V42h-1.135v-7.492h.923l.184 1.025h.055a2.29 2.29 0 0 1 .978-.854 3.144 3.144 0 0 1 1.401-.308c.902 0 1.581.219 2.037.656.456.433.684 1.128.684 2.085V42h-1.135Zm8.572-1.005h-.061c-.524.761-1.308 1.142-2.352 1.142-.98 0-1.743-.335-2.29-1.005-.542-.67-.813-1.623-.813-2.858s.273-2.194.82-2.877c.547-.684 1.308-1.026 2.283-1.026 1.016 0 1.796.37 2.338 1.107h.089l-.048-.54-.027-.526v-3.049h1.134V42h-.922l-.151-1.005Zm-2.269.192c.774 0 1.335-.21 1.681-.63.351-.423.527-1.105.527-2.043v-.24c0-1.061-.178-1.818-.534-2.27-.351-.455-.913-.683-1.688-.683-.665 0-1.176.26-1.531.78-.351.515-.527 1.244-.527 2.187 0 .957.176 1.68.527 2.167.351.488.866.732 1.545.732Zm6.89.813h-1.135v-7.492h1.135V42Zm-1.23-9.523c0-.26.064-.448.191-.567a.663.663 0 0 1 .479-.184c.182 0 .339.061.471.184.133.123.199.312.199.567 0 .256-.066.447-.199.575a.667.667 0 0 1-.471.184.663.663 0 0 1-.479-.184c-.127-.128-.191-.32-.191-.575ZM134.232 42v-4.847c0-.61-.139-1.066-.417-1.367-.278-.3-.713-.451-1.305-.451-.784 0-1.358.212-1.723.636-.364.424-.547 1.123-.547 2.098V42h-1.135v-7.492h.923l.185 1.025h.055c.232-.369.558-.654.977-.854a3.147 3.147 0 0 1 1.401-.308c.903 0 1.582.219 2.038.656.455.433.683 1.128.683 2.085V42h-1.135Zm9.605-7.492v.718l-1.388.164c.128.16.242.369.342.629.1.255.15.544.15.868 0 .733-.25 1.32-.752 1.757-.501.437-1.189.656-2.064.656-.223 0-.433-.018-.629-.055-.483.255-.725.577-.725.964 0 .205.085.358.253.458.169.096.458.143.869.143h1.326c.811 0 1.433.171 1.866.513.437.342.656.839.656 1.49 0 .83-.332 1.461-.998 1.894-.665.438-1.636.656-2.912.656-.98 0-1.736-.182-2.269-.547-.529-.364-.793-.88-.793-1.544 0-.456.145-.85.437-1.183.292-.333.702-.558 1.231-.677a1.208 1.208 0 0 1-.486-.403 1.085 1.085 0 0 1-.191-.636c0-.273.073-.513.219-.718.145-.205.375-.403.69-.595a2.043 2.043 0 0 1-.95-.813 2.404 2.404 0 0 1-.363-1.312c0-.82.247-1.452.739-1.894.492-.447 1.189-.67 2.092-.67.391 0 .745.046 1.059.137h2.591Zm-5.975 8.75c0 .405.171.713.513.923.342.21.832.314 1.47.314.952 0 1.656-.143 2.112-.43.46-.283.69-.668.69-1.156 0-.405-.125-.688-.376-.847-.25-.155-.722-.233-1.415-.233h-1.36c-.515 0-.916.123-1.203.37-.287.245-.431.599-.431 1.059Zm.616-6.35c0 .523.148.92.444 1.189.296.269.709.403 1.237.403 1.108 0 1.661-.538 1.661-1.613 0-1.126-.56-1.689-1.681-1.689-.534 0-.944.144-1.231.43-.287.288-.43.714-.43 1.28Zm11.867.936V42h-1.162v-9.994h2.741c1.226 0 2.13.235 2.714.704.588.47.882 1.176.882 2.12 0 1.32-.67 2.214-2.01 2.679L156.224 42h-1.374l-2.42-4.156h-2.085Zm0-.998h1.593c.82 0 1.421-.162 1.804-.486.383-.328.574-.818.574-1.47 0-.66-.196-1.136-.587-1.428-.388-.292-1.012-.438-1.874-.438h-1.51v3.822Zm10.486 5.29c-1.107 0-1.982-.337-2.625-1.011-.638-.675-.957-1.611-.957-2.81 0-1.207.296-2.167.889-2.877.597-.711 1.397-1.067 2.399-1.067.939 0 1.682.31 2.229.93.546.615.82 1.428.82 2.44v.718h-5.161c.023.88.244 1.547.663 2.003.424.456 1.018.683 1.784.683.807 0 1.604-.168 2.393-.505v1.011a5.808 5.808 0 0 1-1.142.37 6.158 6.158 0 0 1-1.292.116Zm-.308-6.815c-.601 0-1.082.196-1.442.588-.355.392-.565.934-.629 1.627h3.917c0-.715-.159-1.262-.478-1.64-.319-.383-.775-.575-1.368-.575ZM171.646 42l-1.375-4.395c-.086-.27-.248-.88-.485-1.832h-.055a24.828 24.828 0 0 1-.478 1.845L167.838 42h-1.313l-2.044-7.492h1.19c.483 1.882.85 3.315 1.1 4.3.256.984.402 1.647.438 1.989h.055a18.34 18.34 0 0 1 .533-1.99l1.374-4.3h1.23l1.34 4.3c.255.785.429 1.443.52 1.976h.054c.019-.164.067-.417.144-.759.082-.341.558-2.18 1.429-5.516h1.175L172.992 42h-1.346Zm9.385 0-.225-1.066h-.055c-.374.469-.747.788-1.121.957-.369.164-.832.246-1.388.246-.743 0-1.326-.192-1.75-.575-.419-.382-.629-.927-.629-1.633 0-1.513 1.21-2.306 3.63-2.38l1.272-.04v-.465c0-.588-.128-1.02-.383-1.299-.251-.282-.654-.424-1.21-.424-.624 0-1.331.192-2.119.575l-.349-.869c.369-.2.773-.357 1.21-.471a5.29 5.29 0 0 1 1.326-.171c.893 0 1.554.198 1.983.595.433.396.649 1.032.649 1.907V42h-.841Zm-2.563-.8c.706 0 1.26-.194 1.661-.58.406-.388.608-.93.608-1.628v-.677l-1.134.048c-.903.032-1.554.173-1.956.424-.396.246-.594.631-.594 1.155 0 .41.123.723.369.937.251.214.599.321 1.046.321Zm9.167-6.829c.332 0 .631.027.895.082l-.157 1.053a3.861 3.861 0 0 0-.82-.103c-.606 0-1.126.246-1.559.739-.428.492-.642 1.105-.642 1.838V42h-1.135v-7.492h.936l.13 1.387h.055c.278-.487.613-.863 1.005-1.127a2.261 2.261 0 0 1 1.292-.397Zm7.396 6.624h-.061c-.524.761-1.308 1.142-2.352 1.142-.98 0-1.743-.335-2.29-1.005-.542-.67-.813-1.623-.813-2.858s.273-2.194.82-2.877c.547-.684 1.308-1.026 2.283-1.026 1.016 0 1.796.37 2.338 1.107h.089l-.048-.54-.027-.526v-3.049h1.134V42h-.922l-.151-1.005Zm-2.269.192c.774 0 1.335-.21 1.681-.63.351-.423.527-1.105.527-2.043v-.24c0-1.061-.178-1.818-.533-2.27-.351-.455-.914-.683-1.689-.683-.665 0-1.176.26-1.531.78-.351.515-.527 1.244-.527 2.187 0 .957.176 1.68.527 2.167.351.488.866.732 1.545.732Zm10.589-1.23c0 .696-.26 1.234-.78 1.612-.519.379-1.248.568-2.187.568-.994 0-1.768-.157-2.324-.472v-1.053c.36.183.745.326 1.155.431.415.105.813.157 1.196.157.593 0 1.048-.093 1.367-.28.319-.192.479-.48.479-.868 0-.292-.128-.54-.383-.745-.251-.21-.743-.456-1.477-.739-.697-.26-1.194-.485-1.49-.676a2.117 2.117 0 0 1-.656-.664 1.745 1.745 0 0 1-.212-.881c0-.611.248-1.092.745-1.443.497-.355 1.178-.533 2.044-.533.807 0 1.595.164 2.365.492l-.403.923c-.752-.31-1.433-.465-2.044-.465-.538 0-.943.085-1.217.253-.273.169-.41.401-.41.698 0 .2.05.37.151.512.104.142.271.276.499.404.227.127.665.312 1.312.553.889.324 1.488.65 1.798.978.314.328.472.74.472 1.237Z",
                className: "who-wins-rewards_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "who-wins-rewards_svg__line-1",
                d: "M19 61.635h294.057"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M114.016 94v-8.566h.996V94h-.996Zm11.567 0-1.178-3.768c-.074-.23-.213-.754-.416-1.57h-.047c-.156.684-.293 1.211-.41 1.582L122.319 94h-1.125l-1.752-6.422h1.02c.414 1.613.728 2.842.943 3.686.219.843.344 1.412.375 1.705h.047a16.255 16.255 0 0 1 .457-1.705l1.178-3.686h1.054l1.149 3.686c.219.672.367 1.236.445 1.693h.047c.016-.14.057-.357.123-.65.07-.293.479-1.87 1.225-4.729h1.007L126.737 94h-1.154Zm9.638-3.217c0 1.047-.263 1.865-.791 2.455-.527.586-1.255.88-2.185.88-.574 0-1.084-.136-1.529-.405a2.67 2.67 0 0 1-1.032-1.16c-.242-.504-.363-1.094-.363-1.77 0-1.047.262-1.861.785-2.443.524-.586 1.25-.88 2.18-.88.898 0 1.611.3 2.139.897.531.598.796 1.407.796 2.426Zm-4.892 0c0 .82.164 1.445.492 1.875.328.43.811.645 1.447.645.637 0 1.119-.213 1.448-.639.332-.43.498-1.057.498-1.88 0-.817-.166-1.436-.498-1.858-.329-.426-.815-.639-1.459-.639-.637 0-1.118.21-1.442.627-.324.418-.486 1.041-.486 1.87ZM141.327 94v-4.154c0-.524-.119-.914-.358-1.172-.238-.258-.611-.387-1.119-.387-.672 0-1.164.182-1.476.545-.313.363-.469.963-.469 1.799V94h-.973v-6.422h.791l.159.879h.046c.2-.316.479-.56.838-.732a2.7 2.7 0 0 1 1.202-.264c.773 0 1.355.187 1.746.562.39.371.586.967.586 1.788V94h-.973Zm2.836-.621c0-.262.058-.46.176-.592.121-.137.293-.205.515-.205.227 0 .403.068.528.205.128.133.193.33.193.592 0 .254-.065.45-.193.586-.129.137-.305.205-.528.205a.712.712 0 0 1-.498-.182c-.129-.125-.193-.328-.193-.61Zm0-5.174c0-.527.23-.79.691-.79.481 0 .721.263.721.79 0 .254-.065.45-.193.586-.129.137-.305.205-.528.205a.712.712 0 0 1-.498-.181c-.129-.126-.193-.329-.193-.61Z",
                className: "who-wins-rewards_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 19,
                y: 113,
                width: 85,
                height: 22,
                rx: 11,
                className: "who-wins-rewards_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M30.33 118.75h-.535c-.047 0-.071.023-.071.068v2.671h-2.653c-.047 0-.071.023-.071.068v.511c0 .045.024.068.071.068h2.653v2.671c0 .045.024.068.071.068h.534c.048 0 .072-.023.072-.068v-2.671h2.653c.047 0 .071-.023.071-.068v-.511c0-.045-.024-.068-.071-.068H30.4v-2.671c0-.045-.024-.068-.072-.068Z",
                className: "who-wins-rewards_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M40.5 123.889c.298.173.5.492.5.861a.995.995 0 0 1-.5.861V128c0 .144-.11.5-.5.5a.5.5 0 0 1-.312-.11l-1.329-1.063A3.794 3.794 0 0 0 36 126.5h-.439c-.043.16-.069.326-.069.5 0 .454.153.874.409 1.21.247.324.002.79-.405.79h-1.16a.49.49 0 0 1-.444-.267 3.955 3.955 0 0 1-.365-2.233H33a1 1 0 0 1-1-1V124a1 1 0 0 1 1-1h3c.854 0 1.692-.294 2.36-.827l1.328-1.063A.496.496 0 0 1 40 121c.39 0 .5.363.5.5v2.389Zm-1.516 2.658.516.413v-4.42l-.516.413A4.794 4.794 0 0 1 36 124v1.5c1.08 0 2.14.372 2.984 1.047Z",
                className: "who-wins-rewards_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M50.178 128.5v-8.566h.996v8.566h-.996Zm9.217-5.666H57.76v5.666h-.973v-5.666H55.64v-.439l1.148-.352v-.357c0-1.579.69-2.368 2.069-2.368.34 0 .738.069 1.195.205l-.252.78c-.375-.121-.696-.182-.961-.182-.367 0-.639.123-.815.369-.175.242-.263.633-.263 1.172v.416h1.635v.756Zm2.085-.756v4.166c0 .524.12.914.358 1.172.238.258.611.387 1.119.387.672 0 1.162-.184 1.47-.551.313-.367.47-.967.47-1.799v-3.375h.972v6.422h-.803l-.14-.861h-.053c-.2.316-.477.558-.832.726a2.767 2.767 0 0 1-1.207.252c-.781 0-1.367-.185-1.758-.556-.386-.372-.58-.965-.58-1.782v-4.201h.984Zm10.852 6.422v-4.154c0-.524-.12-.914-.357-1.172-.239-.258-.612-.387-1.12-.387-.671 0-1.164.182-1.476.545-.313.363-.469.963-.469 1.799v3.369h-.972v-6.422h.79l.159.879h.047c.199-.316.478-.561.838-.732.359-.176.76-.264 1.2-.264.774 0 1.356.187 1.747.562.39.372.586.967.586 1.788v4.189h-.973Zm7.348-.861h-.053c-.45.652-1.121.978-2.016.978-.84 0-1.494-.287-1.963-.861-.464-.574-.697-1.391-.697-2.449 0-1.059.235-1.881.703-2.467.469-.586 1.121-.879 1.957-.879.871 0 1.54.316 2.004.949h.076l-.04-.463-.024-.451v-2.613h.973v9.117h-.791l-.13-.861Zm-1.946.164c.664 0 1.145-.18 1.442-.539.3-.364.451-.948.451-1.752v-.205c0-.911-.152-1.559-.457-1.946-.3-.39-.783-.586-1.447-.586-.57 0-1.008.223-1.313.668-.3.442-.451 1.067-.451 1.875 0 .821.15 1.44.451 1.858.3.418.742.627 1.324.627Zm7.647.814c-.95 0-1.7-.289-2.25-.867-.547-.578-.82-1.381-.82-2.408 0-1.035.253-1.858.761-2.467.512-.609 1.197-.914 2.057-.914.805 0 1.441.266 1.91.797.469.527.703 1.224.703 2.092v.615h-4.424c.02.754.21 1.326.569 1.717.363.39.873.586 1.529.586.691 0 1.375-.145 2.05-.434v.867c-.343.149-.67.254-.978.317a5.315 5.315 0 0 1-1.107.099Zm-.264-5.842c-.515 0-.928.168-1.236.504-.305.336-.484.801-.54 1.395H86.7c0-.613-.136-1.082-.41-1.406-.273-.329-.664-.493-1.172-.493Zm8.66 4.864h-.052c-.45.652-1.121.978-2.016.978-.84 0-1.494-.287-1.963-.861-.465-.574-.697-1.391-.697-2.449 0-1.059.234-1.881.703-2.467.469-.586 1.121-.879 1.957-.879.871 0 1.539.316 2.004.949h.076l-.041-.463-.023-.451v-2.613h.972v9.117h-.79l-.13-.861Zm-1.945.164c.664 0 1.145-.18 1.441-.539.301-.364.452-.948.452-1.752v-.205c0-.911-.153-1.559-.457-1.946-.301-.39-.784-.586-1.448-.586-.57 0-1.007.223-1.312.668-.301.442-.451 1.067-.451 1.875 0 .821.15 1.44.45 1.858.302.418.743.627 1.325.627Z",
                className: "who-wins-rewards_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M116.291 124.365h2.414v.809h-2.414v2.496h-.814v-2.496h-2.403v-.809h2.403v-2.508h.814v2.508Zm9.305.34c0 1.481-.235 2.586-.703 3.316-.465.731-1.178 1.096-2.139 1.096-.922 0-1.623-.373-2.104-1.119-.48-.75-.72-1.848-.72-3.293 0-1.492.232-2.6.697-3.322.465-.723 1.174-1.084 2.127-1.084.93 0 1.635.377 2.115 1.131.485.754.727 1.845.727 3.275Zm-4.682 0c0 1.246.147 2.154.44 2.725.292.566.759.849 1.4.849.648 0 1.117-.287 1.406-.861.293-.578.44-1.482.44-2.713 0-1.23-.147-2.131-.44-2.701-.289-.574-.758-.861-1.406-.861-.641 0-1.108.283-1.4.849-.293.563-.44 1.467-.44 2.713Zm6.176 3.674c0-.262.058-.459.176-.592.121-.137.293-.205.515-.205.227 0 .403.068.528.205.129.133.193.33.193.592 0 .254-.064.449-.193.586-.129.137-.305.205-.528.205a.713.713 0 0 1-.498-.182c-.129-.125-.193-.328-.193-.609Zm8.572-3.674c0 1.481-.234 2.586-.703 3.316-.465.731-1.178 1.096-2.139 1.096-.922 0-1.623-.373-2.103-1.119-.481-.75-.721-1.848-.721-3.293 0-1.492.233-2.6.697-3.322.465-.723 1.174-1.084 2.127-1.084.93 0 1.635.377 2.116 1.131.484.754.726 1.845.726 3.275Zm-4.682 0c0 1.246.147 2.154.44 2.725.293.566.76.849 1.4.849.649 0 1.118-.287 1.407-.861.293-.578.439-1.482.439-2.713 0-1.23-.146-2.131-.439-2.701-.289-.574-.758-.861-1.407-.861-.64 0-1.107.283-1.4.849-.293.563-.44 1.467-.44 2.713Zm11.549 0c0 1.481-.234 2.586-.703 3.316-.465.731-1.178 1.096-2.138 1.096-.922 0-1.624-.373-2.104-1.119-.48-.75-.721-1.848-.721-3.293 0-1.492.233-2.6.698-3.322.464-.723 1.173-1.084 2.127-1.084.929 0 1.634.377 2.115 1.131.484.754.726 1.845.726 3.275Zm-4.681 0c0 1.246.146 2.154.439 2.725.293.566.76.849 1.401.849.648 0 1.117-.287 1.406-.861.293-.578.439-1.482.439-2.713 0-1.23-.146-2.131-.439-2.701-.289-.574-.758-.861-1.406-.861-.641 0-1.108.283-1.401.849-.293.563-.439 1.467-.439 2.713Zm9.474 4.295h-.949v-6.105c0-.508.016-.989.047-1.442a6.606 6.606 0 0 1-.275.258c-.102.09-.567.471-1.395 1.143l-.516-.668 2.268-1.752h.82V129Z",
                className: "who-wins-rewards_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m163.334 124.112-3.541 2.176-3.543-2.176 3.543-6.112 3.541 6.112Zm-3.541 2.874-3.543-2.175 3.543 5.189 3.543-5.189-3.543 2.175Z",
                className: "who-wins-rewards_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M174.291 124.365h2.414v.809h-2.414v2.496h-.814v-2.496h-2.403v-.809h2.403v-2.508h.814v2.508Zm9.258 4.635h-5.631v-.838l2.256-2.267c.687-.696 1.14-1.192 1.359-1.489a3.78 3.78 0 0 0 .492-.867 2.47 2.47 0 0 0 .164-.908c0-.457-.138-.819-.416-1.084-.277-.27-.662-.404-1.154-.404-.355 0-.693.058-1.014.175-.316.118-.669.33-1.06.639l-.516-.662c.789-.656 1.649-.984 2.578-.984.805 0 1.436.207 1.893.621.457.41.686.963.686 1.658 0 .543-.153 1.08-.457 1.611-.305.531-.875 1.203-1.711 2.016l-1.875 1.834v.047h4.406V129Zm1.336-3.662c0-1.684.326-2.942.978-3.774.657-.835 1.625-1.253 2.907-1.253.441 0 .789.037 1.042.111v.838a3.32 3.32 0 0 0-1.031-.147c-.918 0-1.619.287-2.103.862-.485.57-.75 1.468-.797 2.695h.07c.43-.672 1.11-1.008 2.039-1.008.77 0 1.375.233 1.817.697.445.465.668 1.096.668 1.893 0 .891-.245 1.592-.733 2.103-.484.508-1.14.762-1.969.762-.886 0-1.589-.332-2.109-.996-.519-.668-.779-1.596-.779-2.783Zm2.877 2.953c.554 0 .984-.174 1.289-.521.308-.352.463-.858.463-1.518 0-.566-.143-1.012-.428-1.336-.285-.324-.711-.486-1.277-.486-.352 0-.674.072-.967.216a1.81 1.81 0 0 0-.703.598 1.392 1.392 0 0 0-.258.791c0 .403.078.777.234 1.125.156.348.377.623.662.826.289.203.618.305.985.305Zm9.521.709h-5.631v-.838l2.256-2.267c.688-.696 1.141-1.192 1.36-1.489.218-.297.382-.586.492-.867a2.49 2.49 0 0 0 .164-.908c0-.457-.139-.819-.416-1.084-.278-.27-.662-.404-1.154-.404a2.93 2.93 0 0 0-1.014.175c-.317.118-.67.33-1.061.639l-.515-.662c.789-.656 1.648-.984 2.578-.984.804 0 1.435.207 1.892.621.457.41.686.963.686 1.658 0 .543-.152 1.08-.457 1.611-.305.531-.875 1.203-1.711 2.016l-1.875 1.834v.047h4.406V129Zm1.541-.621c0-.262.059-.459.176-.592.121-.137.293-.205.516-.205.226 0 .402.068.527.205.129.133.193.33.193.592 0 .254-.064.449-.193.586-.129.137-.305.205-.527.205a.71.71 0 0 1-.498-.182c-.129-.125-.194-.328-.194-.609Zm5.572-4.611c.903 0 1.612.224 2.127.673.52.446.78 1.057.78 1.834 0 .887-.283 1.582-.85 2.086-.562.504-1.34.756-2.332.756-.965 0-1.701-.154-2.209-.463v-.937c.274.176.613.314 1.02.416.406.097.806.146 1.201.146.687 0 1.221-.162 1.599-.486.383-.324.575-.793.575-1.406 0-1.196-.733-1.793-2.198-1.793-.371 0-.867.056-1.488.17l-.504-.323.322-4.007h4.26v.896h-3.428l-.216 2.572c.449-.09.896-.134 1.341-.134Z",
                className: "who-wins-rewards_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#who-wins-rewards_svg__a)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m215.523 118.75 6.034.27 2.443 5.429-3.446 4.961-6.067-.388-2.487-5.883 3.523-4.389Zm4.424 3.129-4.373 1.911 3.739 2.891.634-4.802Zm-.506-.957-3.495-1.505-.734 3.164 4.229-1.659Zm-.886 6.487-3.798-2.713.092 3.676 3.706-.963Zm4.838-2.972-2.588-2.627-.683 5.051 3.271-2.424ZM219.445 128l-3.203.837 3.767.241-.564-1.078Zm3.443-2.372-2.804 2.09.557 1.089 2.247-3.179Zm-1.327-5.85-.544 1.118 2.027 2.061-1.483-3.179Zm-.678-.535-3.56-.144 2.936 1.284.624-1.14Zm-5.879.517-2.494 3.149 1.667.353.827-3.502Zm-.927 4.12-1.675-.355 1.748 4.119-.073-3.764Z",
                    className: "who-wins-rewards_svg__path-10"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "who-wins-rewards_svg__line-2",
                d: "M19 150.635h294.057"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M115.719 183v-8.566h.997V183h-.997Zm7.295 0h-.972v-9.117h.972V183Zm7.606-3.217c0 1.047-.264 1.865-.791 2.455-.527.586-1.256.879-2.186.879-.574 0-1.084-.135-1.529-.404a2.67 2.67 0 0 1-1.031-1.16c-.242-.504-.364-1.094-.364-1.77 0-1.047.262-1.861.786-2.443.523-.586 1.25-.879 2.179-.879.899 0 1.612.299 2.139.896.531.598.797 1.407.797 2.426Zm-4.893 0c0 .821.164 1.446.492 1.875.329.43.811.645 1.448.645.636 0 1.119-.213 1.447-.639.332-.43.498-1.057.498-1.881 0-.816-.166-1.435-.498-1.857-.328-.426-.814-.639-1.459-.639-.637 0-1.117.209-1.441.627-.325.418-.487 1.041-.487 1.869Zm10.746 1.465c0 .598-.222 1.059-.668 1.383-.445.324-1.07.486-1.875.486-.851 0-1.515-.135-1.992-.404v-.902c.309.156.639.279.99.369.356.09.698.134 1.026.134.508 0 .898-.08 1.172-.24.273-.164.41-.412.41-.744 0-.25-.109-.463-.328-.639-.215-.179-.637-.39-1.266-.632-.598-.223-1.023-.416-1.277-.58a1.81 1.81 0 0 1-.563-.569 1.495 1.495 0 0 1-.181-.756c0-.523.213-.935.638-1.236.426-.305 1.01-.457 1.752-.457.692 0 1.367.141 2.028.422l-.346.791c-.645-.266-1.229-.399-1.752-.399-.461 0-.809.073-1.043.217-.234.145-.352.344-.352.598 0 .172.043.318.129.439.09.121.233.237.428.346.195.109.57.268 1.125.475.762.277 1.275.556 1.541.838.27.281.404.634.404 1.06Zm3.662 1.066c.172 0 .338-.011.499-.035.16-.027.287-.054.38-.082v.744a1.697 1.697 0 0 1-.468.123 3.177 3.177 0 0 1-.551.053c-1.242 0-1.863-.654-1.863-1.963v-3.82h-.92v-.469l.92-.404.41-1.371h.562v1.488h1.864v.756h-1.864v3.779c0 .387.092.684.276.891.183.207.435.31.755.31Zm2.028.065c0-.262.058-.459.176-.592.121-.137.293-.205.515-.205.227 0 .403.068.528.205.128.133.193.33.193.592 0 .254-.065.449-.193.586-.129.137-.305.205-.528.205a.713.713 0 0 1-.498-.182c-.129-.125-.193-.328-.193-.609Zm0-5.174c0-.527.23-.791.691-.791.481 0 .721.264.721.791 0 .254-.065.449-.193.586-.129.137-.305.205-.528.205a.708.708 0 0 1-.498-.182c-.129-.125-.193-.328-.193-.609Z",
                className: "who-wins-rewards_svg__path-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 19,
                y: 202,
                width: 85,
                height: 22,
                rx: 11,
                className: "who-wins-rewards_svg__rect-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M30.33 207.75h-.535c-.047 0-.071.023-.071.068v2.671h-2.653c-.047 0-.071.023-.071.068v.511c0 .045.024.068.071.068h2.653v2.671c0 .045.024.068.071.068h.534c.048 0 .072-.023.072-.068v-2.671h2.653c.047 0 .071-.023.071-.068v-.511c0-.045-.024-.068-.071-.068H30.4v-2.671c0-.045-.024-.068-.072-.068Z",
                className: "who-wins-rewards_svg__path-12"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M40.5 212.889c.298.173.5.492.5.861a.995.995 0 0 1-.5.861V217c0 .144-.11.5-.5.5a.5.5 0 0 1-.312-.11l-1.329-1.063A3.794 3.794 0 0 0 36 215.5h-.439c-.043.16-.069.326-.069.5 0 .454.153.874.409 1.21.247.324.002.79-.405.79h-1.16a.49.49 0 0 1-.444-.267 3.955 3.955 0 0 1-.365-2.233H33a1 1 0 0 1-1-1V213a1 1 0 0 1 1-1h3c.854 0 1.692-.294 2.36-.827l1.328-1.063A.496.496 0 0 1 40 210c.39 0 .5.363.5.5v2.389Zm-1.516 2.658.516.413v-4.42l-.516.413A4.794 4.794 0 0 1 36 213v1.5c1.08 0 2.14.372 2.984 1.047Z",
                className: "who-wins-rewards_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M50.178 217.5v-8.566h.996v8.566h-.996Zm9.217-5.666H57.76v5.666h-.973v-5.666H55.64v-.439l1.148-.352v-.357c0-1.579.69-2.368 2.069-2.368.34 0 .738.069 1.195.205l-.252.78c-.375-.121-.696-.182-.961-.182-.367 0-.639.123-.815.369-.175.242-.263.633-.263 1.172v.416h1.635v.756Zm2.085-.756v4.166c0 .524.12.914.358 1.172.238.258.611.387 1.119.387.672 0 1.162-.184 1.47-.551.313-.367.47-.967.47-1.799v-3.375h.972v6.422h-.803l-.14-.861h-.053c-.2.316-.477.558-.832.726a2.767 2.767 0 0 1-1.207.252c-.781 0-1.367-.185-1.758-.556-.386-.372-.58-.965-.58-1.782v-4.201h.984Zm10.852 6.422v-4.154c0-.524-.12-.914-.357-1.172-.239-.258-.612-.387-1.12-.387-.671 0-1.164.182-1.476.545-.313.363-.469.963-.469 1.799v3.369h-.972v-6.422h.79l.159.879h.047c.199-.316.478-.561.838-.732.359-.176.76-.264 1.2-.264.774 0 1.356.187 1.747.562.39.372.586.967.586 1.788v4.189h-.973Zm7.348-.861h-.053c-.45.652-1.121.978-2.016.978-.84 0-1.494-.287-1.963-.861-.464-.574-.697-1.391-.697-2.449 0-1.059.235-1.881.703-2.467.469-.586 1.121-.879 1.957-.879.871 0 1.54.316 2.004.949h.076l-.04-.463-.024-.451v-2.613h.973v9.117h-.791l-.13-.861Zm-1.946.164c.664 0 1.145-.18 1.442-.539.3-.364.451-.948.451-1.752v-.205c0-.911-.152-1.559-.457-1.946-.3-.39-.783-.586-1.447-.586-.57 0-1.008.223-1.313.668-.3.442-.451 1.067-.451 1.875 0 .821.15 1.44.451 1.858.3.418.742.627 1.324.627Zm7.647.814c-.95 0-1.7-.289-2.25-.867-.547-.578-.82-1.381-.82-2.408 0-1.035.253-1.858.761-2.467.512-.609 1.197-.914 2.057-.914.805 0 1.441.266 1.91.797.469.527.703 1.224.703 2.092v.615h-4.424c.02.754.21 1.326.569 1.717.363.39.873.586 1.529.586.691 0 1.375-.145 2.05-.434v.867c-.343.149-.67.254-.978.317a5.315 5.315 0 0 1-1.107.099Zm-.264-5.842c-.515 0-.928.168-1.236.504-.305.336-.484.801-.54 1.395H86.7c0-.613-.136-1.082-.41-1.406-.273-.329-.664-.493-1.172-.493Zm8.66 4.864h-.052c-.45.652-1.121.978-2.016.978-.84 0-1.494-.287-1.963-.861-.465-.574-.697-1.391-.697-2.449 0-1.059.234-1.881.703-2.467.469-.586 1.121-.879 1.957-.879.871 0 1.539.316 2.004.949h.076l-.041-.463-.023-.451v-2.613h.972v9.117h-.79l-.13-.861Zm-1.945.164c.664 0 1.145-.18 1.441-.539.301-.364.452-.948.452-1.752v-.205c0-.911-.153-1.559-.457-1.946-.301-.39-.784-.586-1.448-.586-.57 0-1.007.223-1.312.668-.301.442-.451 1.067-.451 1.875 0 .821.15 1.44.45 1.858.302.418.743.627 1.325.627Z",
                className: "who-wins-rewards_svg__path-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M116.291 213.365h2.414v.809h-2.414v2.496h-.814v-2.496h-2.403v-.809h2.403v-2.508h.814v2.508Zm9.305.34c0 1.481-.235 2.586-.703 3.316-.465.731-1.178 1.096-2.139 1.096-.922 0-1.623-.373-2.104-1.119-.48-.75-.72-1.848-.72-3.293 0-1.492.232-2.6.697-3.322.465-.723 1.174-1.084 2.127-1.084.93 0 1.635.377 2.115 1.131.485.754.727 1.845.727 3.275Zm-4.682 0c0 1.246.147 2.154.44 2.725.292.566.759.849 1.4.849.648 0 1.117-.287 1.406-.861.293-.578.44-1.482.44-2.713 0-1.23-.147-2.131-.44-2.701-.289-.574-.758-.861-1.406-.861-.641 0-1.108.283-1.4.849-.293.563-.44 1.467-.44 2.713Zm6.176 3.674c0-.262.058-.459.176-.592.121-.137.293-.205.515-.205.227 0 .403.068.528.205.129.133.193.33.193.592 0 .254-.064.449-.193.586-.129.137-.305.205-.528.205a.713.713 0 0 1-.498-.182c-.129-.125-.193-.328-.193-.609Zm8.572-3.674c0 1.481-.234 2.586-.703 3.316-.465.731-1.178 1.096-2.139 1.096-.922 0-1.623-.373-2.103-1.119-.481-.75-.721-1.848-.721-3.293 0-1.492.233-2.6.697-3.322.465-.723 1.174-1.084 2.127-1.084.93 0 1.635.377 2.116 1.131.484.754.726 1.845.726 3.275Zm-4.682 0c0 1.246.147 2.154.44 2.725.293.566.76.849 1.4.849.649 0 1.118-.287 1.407-.861.293-.578.439-1.482.439-2.713 0-1.23-.146-2.131-.439-2.701-.289-.574-.758-.861-1.407-.861-.64 0-1.107.283-1.4.849-.293.563-.44 1.467-.44 2.713Zm11.549 0c0 1.481-.234 2.586-.703 3.316-.465.731-1.178 1.096-2.138 1.096-.922 0-1.624-.373-2.104-1.119-.48-.75-.721-1.848-.721-3.293 0-1.492.233-2.6.698-3.322.464-.723 1.173-1.084 2.127-1.084.929 0 1.634.377 2.115 1.131.484.754.726 1.845.726 3.275Zm-4.681 0c0 1.246.146 2.154.439 2.725.293.566.76.849 1.401.849.648 0 1.117-.287 1.406-.861.293-.578.439-1.482.439-2.713 0-1.23-.146-2.131-.439-2.701-.289-.574-.758-.861-1.406-.861-.641 0-1.108.283-1.401.849-.293.563-.439 1.467-.439 2.713Zm9.474 4.295h-.949v-6.105c0-.508.016-.989.047-1.442a6.606 6.606 0 0 1-.275.258c-.102.09-.567.471-1.395 1.143l-.516-.668 2.268-1.752h.82V218Z",
                className: "who-wins-rewards_svg__path-15"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m163.334 213.112-3.541 2.176-3.543-2.176 3.543-6.112 3.541 6.112Zm-3.541 2.874-3.543-2.175 3.543 5.189 3.543-5.189-3.543 2.175Z",
                className: "who-wins-rewards_svg__path-16"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M174.291 213.365h2.414v.809h-2.414v2.496h-.814v-2.496h-2.403v-.809h2.403v-2.508h.814v2.508Zm9.258 4.635h-5.631v-.838l2.256-2.267c.687-.696 1.14-1.192 1.359-1.489a3.78 3.78 0 0 0 .492-.867 2.47 2.47 0 0 0 .164-.908c0-.457-.138-.819-.416-1.084-.277-.27-.662-.404-1.154-.404-.355 0-.693.058-1.014.175-.316.118-.669.33-1.06.639l-.516-.662c.789-.656 1.649-.984 2.578-.984.805 0 1.436.207 1.893.621.457.41.686.963.686 1.658 0 .543-.153 1.08-.457 1.611-.305.531-.875 1.203-1.711 2.016l-1.875 1.834v.047h4.406V218Zm1.336-3.662c0-1.684.326-2.942.978-3.774.657-.835 1.625-1.253 2.907-1.253.441 0 .789.037 1.042.111v.838a3.32 3.32 0 0 0-1.031-.147c-.918 0-1.619.287-2.103.862-.485.57-.75 1.468-.797 2.695h.07c.43-.672 1.11-1.008 2.039-1.008.77 0 1.375.233 1.817.697.445.465.668 1.096.668 1.893 0 .891-.245 1.592-.733 2.103-.484.508-1.14.762-1.969.762-.886 0-1.589-.332-2.109-.996-.519-.668-.779-1.596-.779-2.783Zm2.877 2.953c.554 0 .984-.174 1.289-.521.308-.352.463-.858.463-1.518 0-.566-.143-1.012-.428-1.336-.285-.324-.711-.486-1.277-.486-.352 0-.674.072-.967.216a1.81 1.81 0 0 0-.703.598 1.392 1.392 0 0 0-.258.791c0 .403.078.777.234 1.125.156.348.377.623.662.826.289.203.618.305.985.305Zm9.521.709h-5.631v-.838l2.256-2.267c.688-.696 1.141-1.192 1.36-1.489.218-.297.382-.586.492-.867a2.49 2.49 0 0 0 .164-.908c0-.457-.139-.819-.416-1.084-.278-.27-.662-.404-1.154-.404a2.93 2.93 0 0 0-1.014.175c-.317.118-.67.33-1.061.639l-.515-.662c.789-.656 1.648-.984 2.578-.984.804 0 1.435.207 1.892.621.457.41.686.963.686 1.658 0 .543-.152 1.08-.457 1.611-.305.531-.875 1.203-1.711 2.016l-1.875 1.834v.047h4.406V218Zm1.541-.621c0-.262.059-.459.176-.592.121-.137.293-.205.516-.205.226 0 .402.068.527.205.129.133.193.33.193.592 0 .254-.064.449-.193.586-.129.137-.305.205-.527.205a.71.71 0 0 1-.498-.182c-.129-.125-.194-.328-.194-.609Zm5.572-4.611c.903 0 1.612.224 2.127.673.52.446.78 1.057.78 1.834 0 .887-.283 1.582-.85 2.086-.562.504-1.34.756-2.332.756-.965 0-1.701-.154-2.209-.463v-.937c.274.176.613.314 1.02.416.406.097.806.146 1.201.146.687 0 1.221-.162 1.599-.486.383-.324.575-.793.575-1.406 0-1.196-.733-1.793-2.198-1.793-.371 0-.867.056-1.488.17l-.504-.323.322-4.007h4.26v.896h-3.428l-.216 2.572c.449-.09.896-.134 1.341-.134Z",
                className: "who-wins-rewards_svg__path-17"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#who-wins-rewards_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m215.523 207.75 6.034.27 2.443 5.429-3.446 4.961-6.067-.388-2.487-5.883 3.523-4.389Zm4.424 3.129-4.373 1.911 3.739 2.891.634-4.802Zm-.506-.957-3.495-1.505-.734 3.164 4.229-1.659Zm-.886 6.487-3.798-2.713.092 3.676 3.706-.963Zm4.838-2.972-2.588-2.627-.683 5.051 3.271-2.424ZM219.445 217l-3.203.837 3.767.241-.564-1.078Zm3.443-2.372-2.804 2.09.557 1.089 2.247-3.179Zm-1.327-5.85-.544 1.118 2.027 2.061-1.483-3.179Zm-.678-.535-3.56-.144 2.936 1.284.624-1.14Zm-5.879.517-2.494 3.149 1.667.353.827-3.502Zm-.927 4.12-1.675-.355 1.748 4.119-.073-3.764Z",
                    className: "who-wins-rewards_svg__path-18"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M24.707 28h-.915c-.082 0-.122.039-.122.117v4.579h-4.548c-.081 0-.122.039-.122.116v.875c0 .078.04.117.122.117h4.548v4.58c0 .077.04.116.122.116h.915c.082 0 .123-.039.123-.117v-4.579h4.548c.081 0 .122-.039.122-.117v-.875c0-.077-.04-.116-.122-.116H24.83v-4.58c0-.077-.041-.116-.122-.116Z",
                className: "who-wins-rewards_svg__path-19"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M42.143 36.81c.51.296.857.843.857 1.476s-.347 1.18-.857 1.476v4.095c0 .247-.19.857-.858.857a.858.858 0 0 1-.535-.188l-2.277-1.822a6.5 6.5 0 0 0-4.044-1.418h-.753c-.074.273-.118.56-.118.857 0 .779.261 1.498.7 2.074.424.555.005 1.354-.693 1.354h-1.99a.84.84 0 0 1-.76-.456 6.786 6.786 0 0 1-.685-2.972c0-.291.021-.577.058-.857h-.902a1.714 1.714 0 0 1-1.715-1.715V37c0-.947.768-1.714 1.715-1.714h5.143a6.5 6.5 0 0 0 4.044-1.419l2.278-1.822a.855.855 0 0 1 .535-.188c.67 0 .857.623.857.858v4.094Zm-2.6 4.555.886.709v-7.576l-.886.708A8.218 8.218 0 0 1 34.43 37v2.571c1.851 0 3.668.637 5.114 1.794Z",
                className: "who-wins-rewards_svg__path-20"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "who-wins-rewards_svg__a",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(212 118)",
                            d: "M0 0h12v12H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "who-wins-rewards_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(212 207)",
                            d: "M0 0h12v12H0z"
                        })
                    })
                ]
            })
        ]
    });
var $88283d724cf43731$export$2e2bcd8739ae039 = $88283d724cf43731$var$SvgWhoWinsRewards;



const $0187da569521f7f8$var$StyledWhoWinsRewardsSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $88283d724cf43731$export$2e2bcd8739ae039))`
  [class$="path-1"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }
  [class$="path-2"],
  [class$="path-19"],
  [class$="path-20"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }
  [class$="path-3"],
  [class$="path-7"],
  [class$="path-8"],
  [class$="path-9"],
  [class$="path-10"] {
    fill: ${({ theme: theme })=>theme.success};
  }
  [class$="path-4"],
  [class$="path-5"],
  [class$="path-6"],
  [class$="path-12"],
  [class$="path-13"],
  [class$="path-14"] {
    fill: ${({ theme: theme })=>theme.tint};
  }
  [class$="path-11"],
  [class$="path-15"],
  [class$="path-16"],
  [class$="path-17"],
  [class$="path-18"] {
    fill: ${({ theme: theme })=>theme.error};
  }
  [class$="line-1"],
  [class$="line-2"] {
    stroke: ${({ theme: theme })=>theme.mediumBlue};
  }
  [class$="rect-1"],
  [class$="rect-2"] {
    fill: ${({ theme: theme })=>theme.tintMedium};
  }
`;
const $0187da569521f7f8$var$WhoWinsRewards = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $0187da569521f7f8$var$StyledWhoWinsRewardsSvg
    });
var $0187da569521f7f8$export$2e2bcd8739ae039 = $0187da569521f7f8$var$WhoWinsRewards;


const $b1c183e8436a370c$var$leftPageContents = [
    {
        title: "Appeal",
        paragraphs: [
            "If after the jury has reached a decision, a party is not satisfied (because she thinks the result was unfair), she can appeal and have the dispute ruled again.",
            "Every time the case is appealed a new round starts with all the voting options available for voting again. The results of the previous rounds are irrelevant in terms of what the final result will be.",
            "Each new appeal instance will have twice the previous number of jurors plus one."
        ]
    },
    {
        title: "Appeal: Stage 1",
        paragraphs: [
            "The jury decision is appealed when stages 1 and 2 are fully funded. In stage 1, one of the losing options must be fully funded. If no option is fully funded in time the jury decision is maintained."
        ]
    },
    {
        title: "Appeal: Stage 2",
        paragraphs: [
            "Now, options compete together against the option fully funded at stage 1. The sum of funds must reach 100%. If it's not fully funded in time the option fully funded at stage 1 is declared the winner of the case. "
        ]
    },
    {
        title: "Crowdfunding Rewards",
        paragraphs: [
            "Anyone can contribute to the crowdfunding of the appeal fees. Crowdfunders can win rewards in case the option they fund wins. See how much you can earn by funding appeals, at the payoff simulator."
        ]
    },
    {
        title: "Who wins the rewards?",
        paragraphs: [
            "After the final decision (when no more appeals are possible), anyone who contributed to the winning option receive the crowdfunding rewards.",
            "In case the winning option was not funded by anyone, contributors to the other options are partially reimbursed (Amount funded minus arbitration cost to pay the jurors).",
            "In case no one votes on the new round, 'Refuse to arbitrate' is the chosen option."
        ]
    }
];
const $b1c183e8436a370c$var$rightPageComponents = [
    (0, $e0b125c079f587a0$export$2e2bcd8739ae039),
    (0, $710233ccf646df8b$export$2e2bcd8739ae039),
    (0, $f6ee9a2b7d570c07$export$2e2bcd8739ae039),
    (0, $94b3d001fa86c851$export$2e2bcd8739ae039),
    (0, $0187da569521f7f8$export$2e2bcd8739ae039)
];
const $b1c183e8436a370c$var$Appeal = ({ toggleMiniGuide: toggleMiniGuide })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$2e2bcd8739ae039), {
        toggleMiniGuide: toggleMiniGuide,
        leftPageContents: $b1c183e8436a370c$var$leftPageContents,
        rightPageComponents: $b1c183e8436a370c$var$rightPageComponents,
        isOnboarding: false,
        canClose: true,
        isVisible: true
    });
};
var $b1c183e8436a370c$export$2e2bcd8739ae039 = $b1c183e8436a370c$var$Appeal;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $5ab1184b6d930481$var$SvgJurorRewards = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 404 201",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#juror-rewards_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        y: 1,
                        width: 404,
                        height: 195,
                        rx: 2.478,
                        className: "juror-rewards_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 0.413,
                        y: 1.413,
                        width: 403.174,
                        height: 194.174,
                        rx: 2.065,
                        className: "juror-rewards_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#juror-rewards_svg__b)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                        clipPath: "url(#juror-rewards_svg__c)",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("mask", {
                                id: "juror-rewards_svg__d",
                                className: "juror-rewards_svg__mask-1",
                                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                    d: "M129.282 110.481c0 21.893-17.748 39.641-39.641 39.641-21.894 0-39.642-17.748-39.642-39.641C50 88.588 67.748 70.84 89.642 70.84c21.893 0 39.641 17.748 39.641 39.641Zm-75.318 0c0 19.704 15.973 35.677 35.677 35.677 19.703 0 35.676-15.973 35.676-35.677s-15.973-35.677-35.676-35.677c-19.704 0-35.677 15.973-35.677 35.677Z",
                                    className: "juror-rewards_svg__path-1"
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M129.282 110.481c0 21.893-17.748 39.641-39.641 39.641-21.894 0-39.642-17.748-39.642-39.641C50 88.588 67.748 70.84 89.642 70.84c21.893 0 39.641 17.748 39.641 39.641Zm-75.318 0c0 19.704 15.973 35.677 35.677 35.677 19.703 0 35.676-15.973 35.676-35.677s-15.973-35.677-35.676-35.677c-19.704 0-35.677 15.973-35.677 35.677Z",
                                mask: "url(#juror-rewards_svg__d)",
                                className: "juror-rewards_svg__path-2"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M89.64 72.822c0-1.095.889-1.987 1.982-1.933a39.643 39.643 0 0 1 36.898 47.325 39.643 39.643 0 0 1-54.05 28.89 39.638 39.638 0 0 1-24.421-34.642c-.055-1.093.838-1.981 1.933-1.981 1.094 0 1.976.888 2.037 1.981a35.68 35.68 0 0 0 42.582 33.01 35.673 35.673 0 0 0 28.031-28.031 35.675 35.675 0 0 0-33.01-42.582c-1.093-.06-1.981-.942-1.981-2.037Z",
                                className: "juror-rewards_svg__path-3"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M122.158 91.486c.945-.553 2.164-.236 2.668.736a39.643 39.643 0 0 1-45.25 56.601 39.639 39.639 0 0 1-29.21-32.968 39.641 39.641 0 0 1 17.594-38.56c.916-.6 2.133-.277 2.685.668.553.946.23 2.155-.683 2.759a35.677 35.677 0 1 0 51.436 13.502c-.499-.975-.185-2.186.76-2.738Z",
                                fill: "url(#juror-rewards_svg__e)",
                                className: "juror-rewards_svg__path-4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "M80.394 108.503c0 2.787-.561 4.868-1.684 6.242-1.123 1.375-2.813 2.062-5.071 2.062-.858 0-1.475-.052-1.849-.155v-1.907a6.351 6.351 0 0 0 1.733.242c1.535 0 2.68-.413 3.435-1.238.755-.826 1.168-2.123 1.239-3.891h-.116c-.38.581-.842 1-1.384 1.258-.536.258-1.165.387-1.887.387-1.252 0-2.236-.39-2.952-1.171-.716-.78-1.074-1.851-1.074-3.213 0-1.477.413-2.652 1.238-3.523.833-.877 1.965-1.316 3.397-1.316 1.007 0 1.884.245 2.633.736.748.49 1.326 1.203 1.732 2.139.407.929.61 2.045.61 3.348Zm-4.936-4.336c-.787 0-1.39.258-1.81.775-.419.509-.629 1.229-.629 2.158 0 .806.194 1.442.581 1.906.394.458.987.688 1.78.688.769 0 1.414-.23 1.936-.688.523-.458.784-.993.784-1.606 0-.574-.113-1.11-.338-1.607-.22-.503-.53-.9-.93-1.19-.4-.29-.858-.436-1.374-.436Zm16.279 5.372c0 2.458-.397 4.284-1.19 5.477-.788 1.194-1.995 1.791-3.62 1.791-1.575 0-2.768-.616-3.581-1.849-.813-1.232-1.22-3.039-1.22-5.419 0-2.497.394-4.336 1.181-5.517.794-1.187 2-1.781 3.62-1.781 1.58 0 2.777.62 3.59 1.859.813 1.238 1.22 3.051 1.22 5.439Zm-7.307 0c0 1.929.196 3.306.59 4.132.4.826 1.036 1.239 1.907 1.239.87 0 1.506-.419 1.906-1.258.407-.839.61-2.21.61-4.113 0-1.897-.203-3.268-.61-4.113-.4-.852-1.035-1.278-1.906-1.278s-1.507.416-1.907 1.248c-.394.833-.59 2.214-.59 4.143Zm10.868-2.836c0 .961.094 1.678.28 2.149.188.471.494.706.92.706.852 0 1.278-.952 1.278-2.855s-.426-2.855-1.278-2.855c-.426 0-.732.236-.92.707-.186.471-.28 1.187-.28 2.148Zm4.355-.019c0 1.484-.268 2.6-.803 3.348-.53.742-1.313 1.113-2.352 1.113-.98 0-1.742-.384-2.284-1.151-.535-.775-.803-1.878-.803-3.31 0-2.949 1.029-4.423 3.087-4.423 1.013 0 1.79.384 2.332 1.152.549.761.823 1.851.823 3.271Zm4.858 5.671c0 .961.094 1.681.281 2.158.194.478.503.716.929.716.845 0 1.268-.958 1.268-2.874 0-1.89-.423-2.836-1.268-2.836-.426 0-.735.233-.929.697-.187.465-.281 1.178-.281 2.139Zm4.356 0c0 1.484-.268 2.597-.804 3.339-.535.742-1.316 1.113-2.342 1.113-.98 0-1.742-.381-2.284-1.142-.542-.768-.813-1.871-.813-3.31 0-2.949 1.033-4.423 3.097-4.423.994 0 1.765.381 2.313 1.142.555.761.833 1.855.833 3.281Zm-2.875-9.891-7.849 14.149h-1.877l7.849-14.149h1.877Z",
                        className: "juror-rewards_svg__path-5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m68.727 41-.999-2.775h-3.82L62.93 41h-1.723l3.74-10.035h1.777L70.463 41h-1.736Zm-1.43-4.184-.936-2.72a20.685 20.685 0 0 1-.533-1.723c-.123.56-.303 1.173-.54 1.839l-.902 2.604h2.912Zm8.15-3.513c.323 0 .59.023.8.068l-.158 1.497a3.036 3.036 0 0 0-.711-.082c-.643 0-1.165.21-1.566.629-.396.42-.594.964-.594 1.634V41H71.61v-7.56h1.258l.212 1.333h.082c.25-.452.577-.81.978-1.074.405-.264.84-.396 1.305-.396ZM79.26 41h-1.607v-7.56h1.607V41Zm-1.702-9.564c0-.287.077-.508.232-.663.16-.154.385-.232.677-.232.282 0 .501.078.656.232.16.155.24.376.24.663 0 .274-.08.49-.24.65-.155.155-.374.232-.656.232-.292 0-.517-.077-.677-.232-.155-.16-.232-.376-.232-.65Zm9.085 7.41c0 .739-.27 1.306-.807 1.703-.538.392-1.308.588-2.31.588-1.008 0-1.817-.153-2.427-.458V39.29c.888.41 1.715.615 2.481.615.989 0 1.483-.298 1.483-.895a.71.71 0 0 0-.164-.479c-.109-.127-.289-.26-.54-.396-.25-.137-.599-.292-1.046-.465-.87-.337-1.46-.675-1.77-1.012-.305-.337-.458-.775-.458-1.312 0-.648.26-1.149.78-1.504.523-.36 1.234-.54 2.132-.54.889 0 1.73.18 2.522.54l-.519 1.21c-.816-.337-1.502-.506-2.058-.506-.847 0-1.271.241-1.271.725 0 .236.11.437.328.601.223.164.706.39 1.45.677.624.241 1.077.462 1.36.663.282.2.492.433.629.697.136.26.205.572.205.937Zm4.56.992c.391 0 .783-.062 1.175-.185v1.21a3.125 3.125 0 0 1-.69.192 4.488 4.488 0 0 1-.869.082c-1.522 0-2.283-.802-2.283-2.407v-4.074h-1.032v-.71l1.107-.589.547-1.6h.991v1.683h2.154v1.216H90.15v4.047c0 .387.096.675.287.861.197.183.452.274.766.274Zm9.399-2.632c0 1.235-.317 2.199-.95 2.892-.634.692-1.516 1.039-2.646 1.039-.707 0-1.33-.16-1.873-.479a3.16 3.16 0 0 1-1.251-1.374c-.292-.597-.438-1.29-.438-2.078 0-1.226.315-2.183.944-2.871.629-.688 1.515-1.032 2.659-1.032 1.094 0 1.96.353 2.597 1.06.639.701.958 1.649.958 2.843Zm-5.503 0c0 1.745.645 2.618 1.934 2.618 1.276 0 1.914-.872 1.914-2.618 0-1.727-.642-2.59-1.927-2.59-.675 0-1.165.223-1.47.67-.301.446-.451 1.086-.451 1.92Zm10.171 2.632c.392 0 .784-.062 1.176-.185v1.21a3.118 3.118 0 0 1-.69.192 4.492 4.492 0 0 1-.868.082c-1.522 0-2.284-.802-2.284-2.407v-4.074h-1.032v-.71l1.108-.589.547-1.6h.991v1.683h2.153v1.216h-2.153v4.047c0 .387.095.675.287.861.196.183.451.274.765.274Zm4.3 1.162h-1.606V30.363h1.606V41Zm5.606.137c-1.176 0-2.097-.342-2.762-1.026-.661-.688-.991-1.633-.991-2.837 0-1.235.307-2.205.923-2.912.615-.706 1.46-1.06 2.536-1.06.998 0 1.786.304 2.365.91.579.606.868 1.44.868 2.502v.868h-5.038c.023.734.221 1.299.595 1.695.374.392.9.588 1.579.588.447 0 .861-.04 1.244-.123a6.715 6.715 0 0 0 1.244-.424v1.306a4.93 4.93 0 0 1-1.189.396 7.29 7.29 0 0 1-1.374.117Zm-.294-6.617c-.511 0-.921.161-1.231.485-.305.323-.487.795-.547 1.415h3.432c-.009-.624-.159-1.096-.451-1.415-.292-.324-.693-.486-1.203-.486Z",
                className: "juror-rewards_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M68.774 58v-9.994h1.162v8.941h4.41V58h-5.572Zm10.268.137c-1.107 0-1.982-.337-2.625-1.012-.638-.675-.957-1.611-.957-2.81 0-1.207.296-2.167.889-2.877.597-.711 1.396-1.067 2.399-1.067.939 0 1.682.31 2.229.93.546.615.82 1.428.82 2.44v.718h-5.161c.023.88.244 1.547.663 2.003.424.456 1.018.683 1.784.683.807 0 1.604-.168 2.393-.505v1.011a5.807 5.807 0 0 1-1.142.37 6.162 6.162 0 0 1-1.292.116Zm-.308-6.816c-.601 0-1.082.196-1.442.588-.356.392-.565.934-.629 1.627h3.917c0-.715-.16-1.262-.478-1.64-.32-.383-.775-.575-1.368-.575ZM85.38 58l-2.844-7.492h1.217l1.613 4.443c.365 1.04.579 1.714.643 2.024h.055c.05-.242.207-.741.471-1.498.27-.76.868-2.417 1.798-4.97h1.217L86.705 58H85.38Zm8.538.137c-1.107 0-1.982-.337-2.625-1.012-.638-.675-.957-1.611-.957-2.81 0-1.207.296-2.167.889-2.877.597-.711 1.396-1.067 2.399-1.067.939 0 1.682.31 2.229.93.546.615.82 1.428.82 2.44v.718H91.51c.023.88.244 1.547.663 2.003.424.456 1.018.683 1.784.683.807 0 1.604-.168 2.393-.505v1.011a5.807 5.807 0 0 1-1.142.37 6.162 6.162 0 0 1-1.292.116Zm-.308-6.816c-.601 0-1.082.196-1.442.588-.356.392-.565.934-.629 1.627h3.917c0-.715-.16-1.262-.478-1.64-.32-.383-.775-.575-1.368-.575ZM99.748 58h-1.135V47.363h1.135V58Zm12.564-2.297h-1.483V58h-1.087v-2.297h-4.86v-.991l4.744-6.76h1.203v6.719h1.483v1.032Zm-2.57-1.032v-3.322c0-.652.023-1.388.069-2.208h-.055c-.219.437-.424.8-.615 1.087l-3.124 4.443h3.725Z",
                className: "juror-rewards_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M26.468 162.65c-.907 0-1.624.303-2.15.909-.524.602-.786 1.428-.786 2.478 0 1.08.253 1.916.757 2.507.508.587 1.23.881 2.168.881.576 0 1.232-.104 1.97-.311v.841c-.572.215-1.278.322-2.117.322-1.216 0-2.155-.369-2.817-1.107-.659-.737-.988-1.785-.988-3.144 0-.851.158-1.596.474-2.236.32-.64.78-1.133 1.378-1.479.602-.346 1.31-.519 2.122-.519.866 0 1.623.158 2.27.474l-.407.824a4.382 4.382 0 0 0-1.874-.44Zm8.96 4.415c0 1.008-.255 1.797-.763 2.365-.508.565-1.21.847-2.105.847-.554 0-1.045-.13-1.474-.39a2.568 2.568 0 0 1-.993-1.117c-.234-.486-.35-1.054-.35-1.705 0-1.009.252-1.794.756-2.354.504-.565 1.204-.847 2.1-.847.866 0 1.553.288 2.06.863.513.576.769 1.355.769 2.338Zm-4.714 0c0 .79.158 1.392.474 1.806.316.414.78.621 1.394.621.614 0 1.078-.205 1.395-.615.32-.414.48-1.018.48-1.812 0-.787-.16-1.383-.48-1.79-.316-.41-.785-.615-1.406-.615-.614 0-1.076.201-1.389.604-.312.402-.468 1.003-.468 1.801Zm10.596 3.099v-4.003c0-.504-.115-.88-.344-1.129-.23-.248-.59-.372-1.078-.372-.652 0-1.128.177-1.429.53-.297.354-.446.934-.446 1.739v3.235h-.937v-8.784h.937v2.659c0 .32-.015.585-.045.796h.056c.185-.298.447-.531.785-.7.343-.173.732-.26 1.169-.26.756 0 1.323.181 1.7.542.38.357.57.928.57 1.711v4.036h-.938Zm5.482.113c-.915 0-1.637-.279-2.168-.836-.527-.557-.79-1.33-.79-2.32 0-.997.244-1.789.734-2.377.493-.587 1.153-.88 1.981-.88.776 0 1.389.256 1.84.767.452.509.678 1.18.678 2.016v.593h-4.262c.019.726.201 1.277.547 1.654.35.376.842.564 1.474.564.666 0 1.325-.139 1.976-.417v.835a4.78 4.78 0 0 1-.943.305c-.294.064-.65.096-1.067.096Zm-.254-5.629c-.497 0-.894.162-1.191.486-.294.324-.467.771-.52 1.344h3.235c0-.591-.132-1.043-.395-1.355-.264-.317-.64-.475-1.13-.475Zm6.955-.784c.275 0 .521.022.74.067l-.13.87a3.159 3.159 0 0 0-.678-.085c-.5 0-.93.203-1.287.61-.354.406-.53.913-.53 1.519v3.319h-.938v-6.187h.774l.107 1.146h.045c.23-.403.506-.714.83-.932a1.87 1.87 0 0 1 1.067-.327Zm4.51 6.413c-.914 0-1.636-.279-2.167-.836-.527-.557-.79-1.33-.79-2.32 0-.997.244-1.789.733-2.377.494-.587 1.154-.88 1.982-.88.775 0 1.389.256 1.84.767.452.509.678 1.18.678 2.016v.593h-4.262c.018.726.201 1.277.547 1.654.35.376.841.564 1.474.564.666 0 1.325-.139 1.976-.417v.835a4.78 4.78 0 0 1-.943.305 5.09 5.09 0 0 1-1.067.096Zm-.253-5.629c-.497 0-.894.162-1.191.486-.294.324-.467.771-.52 1.344h3.235c0-.591-.132-1.043-.395-1.355-.264-.317-.64-.475-1.13-.475Zm8.366 5.516v-4.003c0-.504-.114-.88-.344-1.129-.23-.248-.589-.372-1.078-.372-.648 0-1.122.175-1.423.525-.301.35-.452.927-.452 1.733v3.246h-.937v-6.187h.763l.152.846h.045c.192-.304.461-.54.807-.705a2.59 2.59 0 0 1 1.158-.254c.745 0 1.306.18 1.682.542.376.357.565.931.565 1.722v4.036h-.938Zm4.867-.66c.165 0 .325-.012.48-.034a3.71 3.71 0 0 0 .367-.079v.717a1.658 1.658 0 0 1-.452.118 3.128 3.128 0 0 1-.53.051c-1.198 0-1.796-.63-1.796-1.891v-3.681h-.886v-.452l.886-.389.395-1.321h.542v1.434h1.795v.728H69.99v3.641c0 .373.089.659.266.858.177.2.42.3.728.3Zm9.947-7.594h1.033l-2.975 8.254h-.948l-2.959-8.254h1.017l1.897 5.341c.218.613.391 1.21.519 1.79.135-.61.312-1.218.53-1.824l1.886-5.307Zm7.373 5.155c0 1.008-.254 1.797-.762 2.365-.508.565-1.21.847-2.106.847-.553 0-1.044-.13-1.473-.39a2.568 2.568 0 0 1-.994-1.117c-.233-.486-.35-1.054-.35-1.705 0-1.009.252-1.794.757-2.354.504-.565 1.204-.847 2.1-.847.866 0 1.552.288 2.06.863.512.576.768 1.355.768 2.338Zm-4.714 0c0 .79.158 1.392.475 1.806.316.414.78.621 1.394.621.613 0 1.078-.205 1.394-.615.32-.414.48-1.018.48-1.812 0-.787-.16-1.383-.48-1.79-.316-.41-.784-.615-1.405-.615-.614 0-1.077.201-1.39.604-.312.402-.468 1.003-.468 1.801Zm8.361 2.439c.166 0 .326-.012.48-.034.154-.027.277-.053.367-.079v.717a1.657 1.657 0 0 1-.452.118 3.128 3.128 0 0 1-.53.051c-1.197 0-1.796-.63-1.796-1.891v-3.681h-.886v-.452l.886-.389.396-1.321h.542v1.434h1.795v.728h-1.795v3.641c0 .373.088.659.265.858.177.2.42.3.728.3Zm4.703.773c-.915 0-1.637-.279-2.168-.836-.527-.557-.79-1.33-.79-2.32 0-.997.244-1.789.734-2.377.493-.587 1.153-.88 1.981-.88.776 0 1.389.256 1.84.767.452.509.678 1.18.678 2.016v.593h-4.262c.019.726.201 1.277.547 1.654.35.376.842.564 1.474.564.666 0 1.325-.139 1.976-.417v.835a4.78 4.78 0 0 1-.943.305c-.294.064-.65.096-1.067.096Zm-.254-5.629c-.497 0-.894.162-1.191.486-.294.324-.467.771-.52 1.344h3.235c0-.591-.132-1.043-.395-1.355-.264-.317-.64-.475-1.13-.475Zm8.124 3.828c0 .576-.215 1.02-.644 1.332-.429.313-1.031.469-1.806.469-.821 0-1.461-.13-1.92-.39v-.869c.297.151.615.269.954.356.343.086.672.13.988.13.489 0 .866-.078 1.129-.232.264-.158.395-.397.395-.717 0-.241-.105-.446-.316-.615-.207-.173-.613-.377-1.219-.61-.576-.215-.986-.401-1.231-.559a1.749 1.749 0 0 1-.542-.547 1.449 1.449 0 0 1-.175-.729c0-.504.205-.901.616-1.191.41-.294.972-.44 1.688-.44.666 0 1.317.135 1.953.406l-.333.762c-.621-.256-1.184-.384-1.688-.384-.444 0-.779.07-1.005.209-.226.14-.339.332-.339.576a.72.72 0 0 0 .124.424c.087.116.224.227.412.333.189.105.55.257 1.084.457.734.267 1.229.536 1.485.807.26.271.39.612.39 1.022Zm1.394 1.09c0-.253.057-.443.17-.571.116-.131.282-.197.496-.197.219 0 .388.066.508.197.125.128.187.318.187.571 0 .244-.062.432-.187.564-.124.132-.293.198-.508.198a.689.689 0 0 1-.48-.175c-.124-.121-.186-.316-.186-.587Zm0-4.985c0-.508.222-.762.666-.762.463 0 .695.254.695.762 0 .244-.062.432-.187.564-.124.132-.293.198-.508.198a.689.689 0 0 1-.48-.175c-.124-.121-.186-.316-.186-.587Z",
                className: "juror-rewards_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M121.498 165.433c0 1.626-.328 2.84-.983 3.641-.654.802-1.641 1.203-2.958 1.203-.5 0-.86-.03-1.078-.09v-1.113c.335.095.672.142 1.01.142.896 0 1.564-.241 2.005-.723.44-.482.681-1.238.722-2.269h-.068c-.222.338-.491.583-.807.733-.312.151-.679.226-1.101.226-.73 0-1.304-.227-1.722-.683-.417-.455-.626-1.08-.626-1.874 0-.862.241-1.547.722-2.055.486-.512 1.146-.768 1.982-.768.587 0 1.099.143 1.536.429.436.286.773.702 1.01 1.248.237.542.356 1.193.356 1.953Zm-2.879-2.529c-.46 0-.812.151-1.056.452-.245.297-.367.717-.367 1.259 0 .47.113.841.339 1.112.229.267.575.401 1.038.401.448 0 .825-.134 1.129-.401.305-.268.458-.58.458-.937 0-.335-.066-.648-.198-.938a1.646 1.646 0 0 0-.542-.694 1.33 1.33 0 0 0-.801-.254Zm7.807-.994-3.071 8.254h-1.253l3.077-8.254h1.247Zm4.505 8.254h-1.326v-5.329c0-.636.015-1.141.045-1.513-.087.09-.194.19-.322.299-.124.109-.546.455-1.265 1.039l-.666-.841 2.428-1.909h1.106v8.254Zm8.305-4.127c0 1.434-.232 2.499-.695 3.196-.459.696-1.162 1.044-2.111 1.044-.918 0-1.615-.359-2.089-1.078-.474-.719-.711-1.773-.711-3.162 0-1.456.229-2.529.689-3.218.463-.692 1.166-1.038 2.111-1.038.922 0 1.62.361 2.095 1.083.474.723.711 1.781.711 3.173Zm-4.262 0c0 1.126.114 1.929.344 2.411.233.482.604.722 1.112.722.508 0 .879-.244 1.112-.733.237-.49.356-1.29.356-2.4 0-1.106-.119-1.906-.356-2.399-.233-.497-.604-.745-1.112-.745-.508 0-.879.242-1.112.728-.23.485-.344 1.291-.344 2.416Z",
                className: "juror-rewards_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#juror-rewards_svg__f)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M152.794 160.383a5.781 5.781 0 1 0 0 11.563 5.781 5.781 0 0 0 0-11.563Zm0 10.443a4.66 4.66 0 0 1-4.662-4.662 4.66 4.66 0 0 1 4.662-4.662 4.66 4.66 0 0 1 4.662 4.662 4.66 4.66 0 0 1-4.662 4.662Zm2.5-5.949c0 1.563-1.688 1.587-1.688 2.165v.147a.28.28 0 0 1-.28.28h-1.064a.28.28 0 0 1-.28-.28v-.201c0-.834.632-1.167 1.109-1.434.41-.23.66-.386.66-.69 0-.402-.512-.669-.927-.669-.54 0-.79.256-1.141.699a.28.28 0 0 1-.388.049l-.649-.491a.28.28 0 0 1-.061-.382c.55-.809 1.252-1.263 2.344-1.263 1.144 0 2.365.893 2.365 2.07Zm-1.521 3.898a.98.98 0 0 1-.979.979.98.98 0 1 1 .979-.979Z",
                    className: "juror-rewards_svg__path-10"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M221.236 42.154c-.354 0-.633-.05-.836-.152v-.819c.267.075.546.113.836.113.372 0 .655-.113.847-.339.195-.226.293-.551.293-.977v-8.253h.96V39.9c0 .715-.181 1.269-.542 1.66-.361.395-.881.593-1.558.593Zm5.036-8.361v4.014c0 .504.114.88.344 1.13.229.248.589.372 1.078.372.648 0 1.12-.177 1.417-.531.301-.354.452-.931.452-1.733v-3.252h.937v6.188h-.773l-.136-.83h-.051a1.866 1.866 0 0 1-.801.7 2.668 2.668 0 0 1-1.163.242c-.753 0-1.318-.178-1.694-.536-.373-.358-.559-.93-.559-1.716v-4.048h.949Zm9.044-.113c.274 0 .521.023.739.068l-.13.87a3.184 3.184 0 0 0-.677-.085c-.501 0-.93.203-1.287.61-.354.406-.531.912-.531 1.518v3.32h-.937v-6.188h.773l.108 1.146h.045c.229-.403.506-.713.83-.931a1.866 1.866 0 0 1 1.067-.328Zm7.237 3.201c0 1.009-.254 1.797-.762 2.366-.508.564-1.21.846-2.106.846-.553 0-1.044-.13-1.473-.39a2.57 2.57 0 0 1-.994-1.117c-.233-.486-.35-1.054-.35-1.705 0-1.009.252-1.793.757-2.354.504-.565 1.204-.847 2.1-.847.865 0 1.552.288 2.06.864.512.576.768 1.355.768 2.337Zm-4.714 0c0 .79.158 1.393.474 1.807.316.414.781.62 1.395.62.613 0 1.078-.205 1.394-.615.32-.414.48-1.018.48-1.812 0-.787-.16-1.383-.48-1.79-.316-.41-.785-.615-1.406-.615-.613 0-1.076.202-1.388.604-.313.403-.469 1.003-.469 1.801Zm9.185-3.2c.275 0 .522.022.74.067l-.13.87a3.192 3.192 0 0 0-.677-.085c-.501 0-.93.203-1.288.61-.353.406-.53.912-.53 1.518v3.32h-.937v-6.188h.773l.107 1.146h.045c.23-.403.507-.713.83-.931a1.87 1.87 0 0 1 1.067-.328Zm6.001 2.867v3.432h-.959v-8.253h2.264c1.012 0 1.759.194 2.241.581.485.388.728.971.728 1.75 0 1.092-.553 1.83-1.66 2.213l2.242 3.71h-1.135l-1.999-3.433h-1.722Zm0-.824h1.316c.677 0 1.174-.134 1.49-.401.316-.271.475-.676.475-1.214 0-.546-.162-.939-.486-1.18-.32-.24-.836-.361-1.547-.361h-1.248v3.156Zm8.661 4.37c-.915 0-1.638-.28-2.168-.836-.527-.557-.791-1.33-.791-2.32 0-.998.245-1.79.734-2.377.493-.587 1.154-.88 1.982-.88.775 0 1.389.255 1.84.767.452.508.678 1.18.678 2.015v.593h-4.263c.019.727.202 1.278.548 1.654.35.377.841.565 1.474.565a4.98 4.98 0 0 0 1.975-.418v.836a4.781 4.781 0 0 1-.942.304c-.294.064-.65.096-1.067.096Zm-.254-5.63c-.497 0-.894.163-1.192.486-.293.324-.466.772-.519 1.344h3.235c0-.59-.132-1.043-.395-1.355-.264-.316-.64-.474-1.129-.474Zm9.185 5.517-1.135-3.63a31.666 31.666 0 0 1-.401-1.514h-.045a20.38 20.38 0 0 1-.395 1.525l-1.169 3.618h-1.084l-1.688-6.187h.983c.399 1.554.702 2.738.909 3.551.21.813.331 1.36.361 1.643h.045a15.816 15.816 0 0 1 .44-1.643l1.135-3.551h1.016l1.107 3.551c.211.647.354 1.191.429 1.632h.045c.015-.136.055-.345.119-.627.067-.282.461-1.801 1.18-4.556h.971l-1.711 6.188h-1.112Zm7.751 0-.186-.881h-.045c-.309.387-.618.65-.926.79-.305.136-.687.203-1.146.203-.614 0-1.095-.158-1.445-.474-.347-.316-.52-.766-.52-1.35 0-1.249.999-1.904 2.998-1.964l1.05-.034v-.383c0-.486-.105-.844-.316-1.073-.207-.233-.54-.35-.999-.35-.516 0-1.099.158-1.751.474l-.287-.717c.304-.166.637-.295.999-.39a4.37 4.37 0 0 1 1.095-.14c.738 0 1.283.163 1.637.49.358.328.537.853.537 1.576v4.222h-.695Zm-2.117-.661c.583 0 1.041-.16 1.372-.48.335-.32.502-.768.502-1.344v-.559l-.937.04c-.745.026-1.283.143-1.614.35-.328.203-.492.521-.492.954 0 .339.102.597.305.774.207.176.495.265.864.265Zm7.571-5.64c.274 0 .521.023.739.068l-.13.87a3.184 3.184 0 0 0-.677-.085c-.501 0-.93.203-1.287.61-.354.406-.531.912-.531 1.518v3.32h-.937v-6.188h.773l.108 1.146h.045c.229-.403.506-.713.83-.931a1.866 1.866 0 0 1 1.067-.328Zm6.108 5.47h-.051c-.433.63-1.08.943-1.942.943-.809 0-1.439-.276-1.891-.83-.448-.553-.672-1.34-.672-2.36 0-1.02.226-1.811.678-2.376.451-.565 1.08-.847 1.885-.847.84 0 1.483.305 1.931.915h.073l-.039-.446-.023-.435v-2.518h.937v8.784h-.762l-.124-.83Zm-1.874.159c.64 0 1.103-.173 1.389-.52.289-.35.434-.912.434-1.688v-.197c0-.877-.147-1.502-.44-1.875-.29-.376-.755-.564-1.395-.564-.549 0-.971.214-1.264.643-.29.426-.435 1.028-.435 1.807 0 .79.145 1.387.435 1.79.29.402.715.604 1.276.604Zm8.745-1.017c0 .576-.215 1.02-.644 1.333-.429.312-1.031.468-1.806.468-.821 0-1.461-.13-1.92-.39v-.869c.297.151.615.27.954.356.343.087.672.13.988.13.489 0 .866-.077 1.129-.231.264-.159.395-.398.395-.718 0-.24-.105-.446-.316-.615-.207-.173-.613-.376-1.219-.61-.576-.214-.986-.4-1.231-.559a1.745 1.745 0 0 1-.542-.547 1.436 1.436 0 0 1-.175-.728c0-.505.205-.902.615-1.192.411-.293.973-.44 1.688-.44.667 0 1.318.136 1.954.407l-.333.762c-.621-.256-1.184-.384-1.688-.384-.444 0-.779.07-1.005.209-.226.139-.339.33-.339.575 0 .166.041.307.124.424.087.117.224.228.412.333.189.105.55.258 1.084.457.734.267 1.229.537 1.485.808.26.27.39.611.39 1.021Z",
                className: "juror-rewards_svg__path-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#juror-rewards_svg__g)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M310.691 30.2a5.782 5.782 0 0 0 0 11.561 5.78 5.78 0 1 0 0-11.562Zm0 10.442a4.66 4.66 0 0 1-4.662-4.662 4.66 4.66 0 0 1 4.662-4.662 4.66 4.66 0 0 1 4.662 4.662 4.659 4.659 0 0 1-4.662 4.662Zm2.5-5.949c0 1.564-1.688 1.588-1.688 2.165v.148a.28.28 0 0 1-.28.28h-1.064a.28.28 0 0 1-.279-.28v-.202c0-.833.631-1.166 1.109-1.434.409-.23.66-.386.66-.69 0-.401-.513-.668-.927-.668-.541 0-.791.256-1.141.698a.28.28 0 0 1-.389.05l-.648-.492a.28.28 0 0 1-.062-.381c.551-.81 1.252-1.264 2.344-1.264 1.144 0 2.365.893 2.365 2.07Zm-1.521 3.898a.98.98 0 0 1-1.958 0 .98.98 0 0 1 1.958 0Z",
                    className: "juror-rewards_svg__path-12"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M270.455 141.726c1.426 0 2.555.378 3.387 1.133.832.755 1.248 1.784 1.248 3.087 0 1.51-.474 2.691-1.422 3.542-.942.845-2.284 1.268-4.026 1.268-1.581 0-2.823-.255-3.726-.765v-2.061a6.798 6.798 0 0 0 1.8.687 8.137 8.137 0 0 0 1.887.242c1.026 0 1.807-.229 2.342-.687.536-.458.803-1.129.803-2.013 0-1.69-1.077-2.536-3.232-2.536-.303 0-.678.033-1.123.097-.445.058-.835.126-1.171.203l-1.016-.6.542-6.91h7.355v2.023h-5.352l-.319 3.503.823-.135a7.842 7.842 0 0 1 1.2-.078Zm6.561 2.807c0-5.536 2.255-8.304 6.765-8.304.71 0 1.31.055 1.8.165v1.897c-.49-.142-1.058-.213-1.703-.213-1.516 0-2.655.406-3.416 1.219-.762.813-1.175 2.117-1.239 3.91h.116a3.083 3.083 0 0 1 1.278-1.21c.548-.29 1.193-.435 1.935-.435 1.284 0 2.284.394 3 1.181.717.787 1.075 1.855 1.075 3.203 0 1.484-.417 2.658-1.249 3.523-.826.858-1.955 1.287-3.387 1.287-1.013 0-1.894-.242-2.642-.726-.749-.49-1.326-1.2-1.733-2.129-.4-.935-.6-2.058-.6-3.368Zm4.936 4.346c.781 0 1.381-.252 1.8-.755.426-.504.639-1.223.639-2.159 0-.812-.2-1.451-.6-1.916-.394-.464-.987-.697-1.781-.697-.49 0-.942.107-1.355.32a2.433 2.433 0 0 0-.977.861c-.239.361-.358.732-.358 1.113 0 .91.245 1.678.735 2.303.497.62 1.129.93 1.897.93Zm9.465-.397c-.309 1.2-.877 2.745-1.703 4.635h-1.674c.445-1.742.777-3.361.996-4.858h2.236l.145.223Zm11.778-4.994c0 2.458-.396 4.284-1.19 5.478-.787 1.193-1.994 1.79-3.62 1.79-1.574 0-2.768-.616-3.58-1.848-.813-1.233-1.22-3.039-1.22-5.42 0-2.497.394-4.336 1.181-5.517.793-1.187 2-1.78 3.619-1.78 1.581 0 2.778.619 3.591 1.858.813 1.239 1.219 3.052 1.219 5.439Zm-7.307 0c0 1.929.197 3.307.591 4.132.4.826 1.035 1.239 1.906 1.239s1.507-.419 1.907-1.258c.406-.839.61-2.21.61-4.113 0-1.897-.204-3.268-.61-4.113-.4-.852-1.036-1.278-1.907-1.278s-1.506.416-1.906 1.249c-.394.832-.591 2.213-.591 4.142Zm18.631 0c0 2.458-.397 4.284-1.191 5.478-.787 1.193-1.993 1.79-3.619 1.79-1.575 0-2.768-.616-3.581-1.848-.813-1.233-1.22-3.039-1.22-5.42 0-2.497.394-4.336 1.181-5.517.794-1.187 2-1.78 3.62-1.78 1.58 0 2.777.619 3.59 1.858.813 1.239 1.22 3.052 1.22 5.439Zm-7.307 0c0 1.929.197 3.307.59 4.132.4.826 1.036 1.239 1.907 1.239s1.506-.419 1.906-1.258c.407-.839.61-2.21.61-4.113 0-1.897-.203-3.268-.61-4.113-.4-.852-1.035-1.278-1.906-1.278s-1.507.416-1.907 1.249c-.393.832-.59 2.213-.59 4.142Zm18.63 0c0 2.458-.397 4.284-1.191 5.478-.787 1.193-1.993 1.79-3.619 1.79-1.574 0-2.768-.616-3.581-1.848-.813-1.233-1.219-3.039-1.219-5.42 0-2.497.393-4.336 1.18-5.517.794-1.187 2-1.78 3.62-1.78 1.581 0 2.777.619 3.59 1.858.813 1.239 1.22 3.052 1.22 5.439Zm-7.307 0c0 1.929.197 3.307.59 4.132.4.826 1.036 1.239 1.907 1.239s1.506-.419 1.906-1.258c.407-.839.61-2.21.61-4.113 0-1.897-.203-3.268-.61-4.113-.4-.852-1.035-1.278-1.906-1.278s-1.507.416-1.907 1.249c-.393.832-.59 2.213-.59 4.142Zm24.553-2.797c0 1.477-.484 2.61-1.452 3.397-.967.787-2.345 1.181-4.132 1.181h-1.471v5.293h-2.313v-14.149h4.074c1.768 0 3.091.362 3.968 1.084.884.723 1.326 1.787 1.326 3.194Zm-7.055 2.632h1.229c1.187 0 2.058-.206 2.613-.619.555-.413.832-1.058.832-1.936 0-.813-.248-1.419-.745-1.819-.497-.4-1.271-.6-2.323-.6h-1.606v4.974Zm21.669 7.239h-2.836l-6.958-11.274h-.078l.049.629c.09 1.2.135 2.297.135 3.29v7.355h-2.1v-14.149h2.807l6.939 11.217h.058a64.886 64.886 0 0 1-.078-1.616 57.877 57.877 0 0 1-.058-2.187v-7.414h2.12v14.149Zm14.536 0h-2.681l-4.442-6.406-1.364 1.113v5.293h-2.314v-14.149h2.314v6.756a85.257 85.257 0 0 1 1.887-2.236l3.823-4.52h2.632a881.833 881.833 0 0 1-5.313 6.204l5.458 7.945Z",
                className: "juror-rewards_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M274.418 86.81c0 .896-.262 1.645-.784 2.245-.523.593-1.258.993-2.207 1.2v.077c1.136.142 1.987.497 2.555 1.065.568.561.852 1.31.852 2.245 0 1.362-.481 2.413-1.442 3.155-.961.736-2.329 1.104-4.104 1.104-1.567 0-2.89-.255-3.968-.765v-2.023c.6.297 1.236.526 1.907.688a8.277 8.277 0 0 0 1.936.241c1.096 0 1.916-.203 2.458-.61.542-.406.813-1.035.813-1.886 0-.755-.3-1.31-.9-1.665-.6-.355-1.542-.532-2.826-.532h-1.229V89.5h1.248c2.258 0 3.387-.78 3.387-2.342 0-.606-.196-1.074-.59-1.403-.394-.33-.974-.494-1.742-.494-.536 0-1.052.078-1.548.232-.497.149-1.084.442-1.762.881l-1.113-1.587c1.297-.955 2.804-1.432 4.52-1.432 1.426 0 2.539.306 3.339.919.8.613 1.2 1.458 1.2 2.536Zm2.681 9.687c0-.47.122-.832.367-1.084.246-.251.6-.377 1.065-.377.471 0 .829.132 1.074.397.245.258.368.613.368 1.064 0 .458-.126.823-.378 1.094-.245.264-.6.397-1.064.397-.465 0-.819-.133-1.065-.397-.245-.265-.367-.63-.367-1.094Zm5.081-4.82c0-5.535 2.254-8.303 6.764-8.303.71 0 1.31.055 1.801.165v1.896c-.491-.142-1.059-.213-1.704-.213-1.516 0-2.655.407-3.416 1.22-.761.813-1.174 2.116-1.239 3.91h.116a3.078 3.078 0 0 1 1.278-1.21c.548-.29 1.193-.435 1.935-.435 1.284 0 2.284.393 3 1.18.717.787 1.075 1.855 1.075 3.204 0 1.484-.416 2.658-1.249 3.522-.826.859-1.955 1.288-3.387 1.288-1.013 0-1.894-.242-2.642-.726-.749-.49-1.326-1.2-1.732-2.13-.4-.935-.6-2.058-.6-3.367Zm4.935 4.346c.781 0 1.381-.252 1.8-.755.426-.503.639-1.222.639-2.158 0-.813-.2-1.452-.6-1.916-.393-.465-.987-.697-1.781-.697-.49 0-.942.106-1.355.32a2.447 2.447 0 0 0-.977.86c-.239.362-.358.733-.358 1.114 0 .91.245 1.677.735 2.303.497.62 1.13.93 1.897.93Zm6.388-4.345c0-5.536 2.255-8.304 6.765-8.304.709 0 1.309.055 1.8.165v1.896c-.491-.142-1.058-.213-1.704-.213-1.516 0-2.655.407-3.416 1.22-.761.813-1.174 2.116-1.239 3.91h.116a3.09 3.09 0 0 1 1.278-1.21c.548-.29 1.194-.435 1.936-.435 1.284 0 2.284.393 3 1.18.716.787 1.074 1.855 1.074 3.204 0 1.484-.416 2.658-1.248 3.522-.826.859-1.955 1.288-3.388 1.288-1.013 0-1.893-.242-2.642-.726-.748-.49-1.326-1.2-1.732-2.13-.4-.935-.6-2.058-.6-3.367Zm4.936 4.345c.78 0 1.38-.252 1.8-.755.425-.503.638-1.222.638-2.158 0-.813-.2-1.452-.6-1.916-.393-.465-.987-.697-1.78-.697-.491 0-.942.106-1.355.32a2.443 2.443 0 0 0-.978.86c-.239.362-.358.733-.358 1.114 0 .91.245 1.677.736 2.303.496.62 1.129.93 1.897.93Zm20.498 1.684h-8.004v-14.15h8.004v1.956h-5.691v3.852h5.332V91.3h-5.332v4.442h5.691v1.965Zm7.955 0h-2.313V85.542h-4.162v-1.984h10.636v1.984h-4.161v12.165Zm17.498 0h-2.323v-6.378h-6.523v6.378h-2.313v-14.15h2.313v5.788h6.523v-5.787h2.323v14.149Z",
                className: "juror-rewards_svg__path-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#juror-rewards_svg__h)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m237.029 100.786.108.066.108-.066 10.882-6.68-10.99 16.095-10.989-16.094 10.881 6.679Zm.108-29.448 11.418 19.71-11.418 7.013-11.425-7.014 11.425-19.71Z",
                    stroke: "url(#juror-rewards_svg__i)",
                    strokeWidth: 0.413,
                    className: "juror-rewards_svg__path-15"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m230.978 128.738 16.475 1.075 6.809 15.051-9.309 13.605-16.846-.717-6.804-16.472 9.675-12.542Zm.419.854-2.57 12.528 15.098-7.067-12.528-5.461Zm12.945 6.038-15.321 7.171 13.039 9.78 2.282-16.951Zm-2.779 17.452-12.868-9.651v13.512l12.868-3.861Zm-13.567 2.569v-12.636l-5.716-1.203 5.716 13.839Zm-5.675-14.545 5.752 1.211 2.422-11.808-8.174 10.597Zm8.111 16.045 13.764.586-2.05-4.1-11.714 3.514Zm12.34-3.825 2.049 4.098 7.609-11.122-9.658 7.024Zm9.889-10.305-5.456-12.06-2.01 4.02 7.466 8.04Zm-8.052-8.432-11.494-5.011 13.558.884-2.064 4.127Zm.412 1.233-2.239 16.632 10.556-7.676-8.317-8.956Z",
                fill: "url(#juror-rewards_svg__j)",
                className: "juror-rewards_svg__path-16"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "juror-rewards_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(50 70.84)",
                            className: "juror-rewards_svg__rect-3",
                            d: "M0 0h79.282v79.282H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "juror-rewards_svg__c",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(50 70.84)",
                            className: "juror-rewards_svg__rect-4",
                            d: "M0 0h79.282v79.282H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "juror-rewards_svg__f",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(147.013 160.383)",
                            className: "juror-rewards_svg__rect-5",
                            d: "M0 0h11.562v11.562H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "juror-rewards_svg__g",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(304.91 30.2)",
                            className: "juror-rewards_svg__rect-6",
                            d: "M0 0h11.562v11.562H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "juror-rewards_svg__h",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(218 70.926)",
                            className: "juror-rewards_svg__rect-7",
                            d: "M0 0h39.641v39.641H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "juror-rewards_svg__e",
                        x1: 59.91,
                        y1: 131.491,
                        x2: 123.335,
                        y2: 103.742,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                className: "juror-rewards_svg__stop-1"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                className: "juror-rewards_svg__stop-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "juror-rewards_svg__i",
                        x1: 237.137,
                        y1: 70.926,
                        x2: 237.137,
                        y2: 110.567,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                className: "juror-rewards_svg__stop-3"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                className: "juror-rewards_svg__stop-4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "juror-rewards_svg__j",
                        x1: 237.783,
                        y1: 128.738,
                        x2: 237.783,
                        y2: 158.469,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                className: "juror-rewards_svg__stop-5"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                className: "juror-rewards_svg__stop-6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "juror-rewards_svg__a",
                        x: -2.478,
                        y: 0.174,
                        width: 408.955,
                        height: 199.955,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.652
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.239
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13904_184784"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13904_184784",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $5ab1184b6d930481$export$2e2bcd8739ae039 = $5ab1184b6d930481$var$SvgJurorRewards;



const $0df4c11bca39010b$var$StyledJurorRewardsSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $5ab1184b6d930481$export$2e2bcd8739ae039))`
  [class$="rect-1"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }
  [class$="rect-2"],
  [class$="path-2"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }
  [class$="rect-3"],
  [class$="rect-4"],
  [class$="rect-5"],
  [class$="rect-6"],
  [class$="rect-7"],
  [class$="mask-1"] {
    fill: ${({ theme: theme })=>theme.white};
  }
  [class$="stop-1"],
  [class$="stop-4"],
  [class$="stop-6"] {
    stop-color: ${({ theme: theme })=>theme.secondaryPurple};
  }
  [class$="stop-2"],
  [class$="stop-3"],
  [class$="stop-5"] {
    stop-color: ${({ theme: theme })=>theme.primaryBlue};
  }
  [class$="path-3"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }
  [class$="path-5"],
  [class$="path-6"],
  [class$="path-9"],
  [class$="path-13"],
  [class$="path-14"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }
  [class$="path-7"],
  [class$="path-8"],
  [class$="path-10"],
  [class$="path-11"],
  [class$="path-12"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }
`;
const $0df4c11bca39010b$var$JurorRewards = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $0df4c11bca39010b$var$StyledJurorRewardsSvg
    });
var $0df4c11bca39010b$export$2e2bcd8739ae039 = $0df4c11bca39010b$var$JurorRewards;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $d8c4f0cce5764fc3$var$SvgPrivateVoting = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 384,
        height: 301,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 0.5,
                y: 0.5,
                width: 383,
                height: 300,
                rx: 2.5,
                className: "private-voting_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M83.96 195.602c-1.254 0-2.246.419-2.976 1.257-.724.834-1.086 1.977-1.086 3.43 0 1.495.35 2.651 1.047 3.469.703.812 1.703 1.219 3 1.219.797 0 1.706-.144 2.727-.43v1.164c-.792.297-1.768.445-2.93.445-1.682 0-2.982-.51-3.898-1.531-.912-1.021-1.367-2.471-1.367-4.352 0-1.177.218-2.208.656-3.093a4.766 4.766 0 0 1 1.906-2.047c.833-.479 1.813-.719 2.938-.719 1.197 0 2.244.219 3.14.656l-.562 1.141c-.865-.406-1.73-.609-2.594-.609Zm12.4 6.109c0 1.396-.352 2.487-1.055 3.273-.703.782-1.675 1.172-2.914 1.172-.766 0-1.446-.179-2.04-.539-.593-.359-1.052-.875-1.374-1.547-.323-.672-.485-1.458-.485-2.359 0-1.396.35-2.482 1.047-3.258.698-.781 1.667-1.172 2.906-1.172 1.198 0 2.149.399 2.852 1.196.708.796 1.062 1.875 1.062 3.234Zm-6.524 0c0 1.094.219 1.927.656 2.5.438.573 1.08.859 1.93.859.849 0 1.492-.284 1.93-.851.442-.573.664-1.409.664-2.508 0-1.089-.222-1.914-.664-2.477-.438-.567-1.086-.851-1.946-.851-.849 0-1.49.278-1.922.836-.432.557-.648 1.388-.648 2.492Zm10.023-4.273v5.554c0 .698.159 1.219.477 1.563.318.343.815.515 1.492.515.896 0 1.55-.244 1.961-.734.417-.49.625-1.289.625-2.398v-4.5h1.297V206h-1.07l-.188-1.148h-.07a2.588 2.588 0 0 1-1.11.968c-.468.224-1.005.336-1.609.336-1.042 0-1.823-.247-2.344-.742-.515-.495-.773-1.286-.773-2.375v-5.601h1.312Zm12.516-.157c.38 0 .721.031 1.023.094l-.179 1.203a4.426 4.426 0 0 0-.938-.117c-.692 0-1.286.281-1.781.844-.49.562-.734 1.263-.734 2.101V206h-1.297v-8.562h1.07l.149 1.585h.062c.318-.557.701-.987 1.148-1.289a2.588 2.588 0 0 1 1.477-.453Zm5.391 7.805c.229 0 .45-.016.664-.047a4.86 4.86 0 0 0 .508-.109v.992c-.141.068-.349.122-.626.164-.27.047-.515.07-.734.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.985h2.484v1.007h-2.484v5.039c0 .516.122.912.367 1.188.245.276.581.414 1.008.414Zm8.414-1.422c0 .797-.297 1.412-.891 1.844-.594.432-1.427.648-2.5.648-1.135 0-2.021-.179-2.656-.539v-1.203c.411.208.851.372 1.32.492.474.12.93.18 1.367.18.677 0 1.198-.107 1.563-.32.364-.219.547-.55.547-.993 0-.333-.146-.617-.438-.851-.286-.24-.849-.521-1.687-.844-.797-.297-1.365-.555-1.703-.773-.334-.224-.584-.477-.75-.758-.162-.281-.243-.617-.243-1.008 0-.698.284-1.247.852-1.648.568-.407 1.346-.61 2.336-.61.922 0 1.823.188 2.703.563l-.461 1.054c-.859-.354-1.638-.531-2.336-.531-.614 0-1.078.097-1.391.289-.312.193-.468.459-.468.797 0 .229.057.425.172.586.119.162.31.315.57.461.26.146.76.357 1.5.633 1.016.37 1.7.742 2.055 1.117.359.375.539.846.539 1.414ZM139.445 206l-1.57-5.023c-.099-.308-.284-1.006-.555-2.094h-.062a29.178 29.178 0 0 1-.547 2.109L135.094 206h-1.5l-2.336-8.562h1.359c.552 2.151.972 3.789 1.258 4.914.292 1.125.458 1.882.5 2.273h.063c.057-.297.148-.68.273-1.148.13-.474.242-.849.336-1.125l1.57-4.914h1.406l1.532 4.914c.291.895.489 1.648.593 2.257h.063c.021-.187.075-.476.164-.867.094-.39.638-2.492 1.633-6.304h1.344L140.984 206h-1.539Zm6.758 0h-1.297v-8.562h1.297V206Zm-1.406-10.883c0-.297.073-.513.219-.648a.753.753 0 0 1 .546-.211c.209 0 .389.07.54.211.151.14.226.357.226.648 0 .292-.075.511-.226.656a.764.764 0 0 1-.54.211.753.753 0 0 1-.546-.211c-.146-.145-.219-.364-.219-.656Zm6.922 9.969c.229 0 .45-.016.664-.047.213-.036.383-.073.508-.109v.992c-.141.068-.349.122-.625.164-.271.047-.516.07-.735.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.985h2.484v1.007h-2.484v5.039c0 .516.122.912.367 1.188.245.276.581.414 1.008.414Zm8.75.914v-5.539c0-.698-.159-1.219-.477-1.563-.318-.343-.815-.515-1.492-.515-.901 0-1.56.245-1.977.734-.411.49-.617 1.292-.617 2.406V206h-1.297v-12.156h1.297v3.679c0 .443-.021.81-.062 1.102h.078a2.63 2.63 0 0 1 1.086-.969c.474-.239 1.013-.359 1.617-.359 1.047 0 1.831.25 2.352.75.526.495.789 1.284.789 2.367V206h-1.297Zm11.547.156c-1.24 0-2.201-.38-2.883-1.14-.677-.766-1.016-1.847-1.016-3.243 0-1.432.344-2.539 1.031-3.32.693-.781 1.678-1.172 2.954-1.172.411 0 .822.045 1.234.133.411.089.734.193.969.313l-.399 1.101a5.89 5.89 0 0 0-.937-.281 4.063 4.063 0 0 0-.899-.117c-1.739 0-2.609 1.109-2.609 3.328 0 1.052.211 1.859.633 2.422.427.562 1.057.843 1.89.843.714 0 1.446-.153 2.196-.461v1.149c-.573.297-1.295.445-2.164.445Zm11.593-4.445c0 1.396-.351 2.487-1.054 3.273-.703.782-1.675 1.172-2.914 1.172-.766 0-1.446-.179-2.039-.539-.594-.359-1.053-.875-1.375-1.547-.323-.672-.485-1.458-.485-2.359 0-1.396.349-2.482 1.047-3.258.698-.781 1.667-1.172 2.906-1.172 1.198 0 2.149.399 2.852 1.196.708.796 1.062 1.875 1.062 3.234Zm-6.523 0c0 1.094.219 1.927.656 2.5.438.573 1.081.859 1.93.859s1.492-.284 1.93-.851c.442-.573.664-1.409.664-2.508 0-1.089-.222-1.914-.664-2.477-.438-.567-1.086-.851-1.946-.851-.849 0-1.489.278-1.922.836-.432.557-.648 1.388-.648 2.492ZM196.805 206v-5.57c0-.683-.146-1.193-.438-1.532-.291-.343-.745-.515-1.359-.515-.807 0-1.404.232-1.789.695-.386.464-.578 1.177-.578 2.141V206h-1.297v-5.57c0-.683-.146-1.193-.438-1.532-.291-.343-.747-.515-1.367-.515-.812 0-1.409.245-1.789.734-.375.485-.562 1.281-.562 2.391V206h-1.297v-8.562h1.054l.211 1.171h.063a2.554 2.554 0 0 1 1.031-.976 3.179 3.179 0 0 1 1.5-.352c1.339 0 2.214.485 2.625 1.453h.063a2.72 2.72 0 0 1 1.109-1.062c.484-.261 1.036-.391 1.656-.391.969 0 1.693.25 2.172.75.484.495.727 1.289.727 2.383V206h-1.297Zm14.89 0v-5.57c0-.683-.146-1.193-.437-1.532-.292-.343-.745-.515-1.36-.515-.807 0-1.403.232-1.789.695-.385.464-.578 1.177-.578 2.141V206h-1.297v-5.57c0-.683-.145-1.193-.437-1.532-.292-.343-.748-.515-1.367-.515-.813 0-1.409.245-1.789.734-.375.485-.563 1.281-.563 2.391V206h-1.297v-8.562h1.055l.211 1.171h.062a2.557 2.557 0 0 1 1.032-.976 3.179 3.179 0 0 1 1.5-.352c1.338 0 2.213.485 2.625 1.453h.062a2.723 2.723 0 0 1 1.11-1.062c.484-.261 1.036-.391 1.656-.391.968 0 1.692.25 2.172.75.484.495.726 1.289.726 2.383V206h-1.297Zm5.274 0h-1.297v-8.562h1.297V206Zm-1.407-10.883c0-.297.073-.513.219-.648a.755.755 0 0 1 .547-.211c.208 0 .388.07.539.211.151.14.227.357.227.648 0 .292-.076.511-.227.656a.763.763 0 0 1-.539.211.755.755 0 0 1-.547-.211c-.146-.145-.219-.364-.219-.656Zm6.922 9.969c.23 0 .451-.016.664-.047.214-.036.383-.073.508-.109v.992c-.14.068-.349.122-.625.164-.271.047-.515.07-.734.07-1.656 0-2.485-.872-2.485-2.617v-5.094h-1.226v-.625l1.226-.539.547-1.828h.75v1.985h2.485v1.007h-2.485v5.039c0 .516.123.912.368 1.188.244.276.58.414 1.007.414Zm12.313.914-.258-1.219h-.062c-.428.537-.855.901-1.282 1.094-.422.187-.95.281-1.586.281-.849 0-1.515-.218-2-.656-.479-.438-.718-1.06-.718-1.867 0-1.729 1.382-2.636 4.148-2.719l1.453-.047v-.531c0-.672-.146-1.167-.437-1.484-.287-.323-.748-.485-1.383-.485-.714 0-1.521.219-2.422.656l-.398-.992a6.085 6.085 0 0 1 1.382-.539 6.07 6.07 0 0 1 1.516-.195c1.021 0 1.776.226 2.266.68.494.453.742 1.179.742 2.179V206h-.961Zm-2.93-.914c.807 0 1.44-.221 1.899-.664.463-.443.695-1.063.695-1.86v-.773l-1.297.055c-1.031.036-1.776.198-2.234.484-.453.281-.68.721-.68 1.32 0 .469.141.826.422 1.071.286.245.685.367 1.195.367Zm12.43.914v-5.539c0-.698-.159-1.219-.477-1.563-.317-.343-.815-.515-1.492-.515-.896 0-1.552.242-1.969.726-.416.485-.625 1.284-.625 2.399V206h-1.296v-8.562h1.054l.211 1.171h.063a2.623 2.623 0 0 1 1.117-.976 3.587 3.587 0 0 1 1.601-.352c1.032 0 1.808.25 2.328.75.521.495.782 1.289.782 2.383V206h-1.297Zm9.797-1.148h-.071c-.599.869-1.494 1.304-2.687 1.304-1.12 0-1.992-.383-2.617-1.148-.62-.766-.93-1.854-.93-3.266 0-1.411.313-2.508.938-3.289.625-.781 1.494-1.172 2.609-1.172 1.161 0 2.052.422 2.672 1.266h.101l-.054-.617-.032-.602v-3.484h1.297V206h-1.054l-.172-1.148Zm-2.594.218c.885 0 1.526-.239 1.922-.718.401-.485.601-1.263.601-2.336v-.274c0-1.213-.203-2.078-.609-2.594-.401-.52-1.044-.781-1.93-.781-.76 0-1.343.297-1.75.891-.401.588-.601 1.422-.601 2.5 0 1.094.2 1.919.601 2.476.401.558.99.836 1.766.836Zm14.641-7.789c.38 0 .721.031 1.023.094l-.18 1.203a4.418 4.418 0 0 0-.937-.117c-.693 0-1.287.281-1.781.844-.49.562-.735 1.263-.735 2.101V206h-1.297v-8.562h1.071l.148 1.585h.063c.317-.557.7-.987 1.148-1.289.448-.302.94-.453 1.477-.453Zm6.242 8.875c-1.266 0-2.266-.385-3-1.156-.729-.771-1.094-1.841-1.094-3.211 0-1.38.339-2.477 1.016-3.289.682-.812 1.596-1.219 2.742-1.219 1.073 0 1.922.354 2.547 1.063.625.703.937 1.633.937 2.789v.82h-5.898c.026 1.005.278 1.768.758 2.289.484.521 1.164.781 2.039.781.922 0 1.833-.192 2.734-.578v1.157a6.647 6.647 0 0 1-1.305.421c-.406.089-.898.133-1.476.133Zm-.352-7.789c-.687 0-1.237.224-1.648.672-.406.448-.646 1.068-.719 1.859h4.477c0-.817-.183-1.442-.547-1.875-.365-.437-.886-.656-1.563-.656Zm7.594 7.633-3.25-8.562h1.391l1.843 5.078c.417 1.187.662 1.958.735 2.312h.062c.058-.276.237-.846.539-1.711.308-.87.993-2.763 2.055-5.679h1.391l-3.25 8.562h-1.516Zm9.758.156c-1.266 0-2.266-.385-3-1.156-.729-.771-1.094-1.841-1.094-3.211 0-1.38.339-2.477 1.016-3.289.682-.812 1.596-1.219 2.742-1.219 1.073 0 1.922.354 2.547 1.063.625.703.937 1.633.937 2.789v.82h-5.898c.026 1.005.278 1.768.758 2.289.484.521 1.164.781 2.039.781.922 0 1.833-.192 2.734-.578v1.157a6.647 6.647 0 0 1-1.305.421c-.406.089-.898.133-1.476.133Zm-.352-7.789c-.687 0-1.237.224-1.648.672-.406.448-.646 1.068-.719 1.859h4.477c0-.817-.183-1.442-.547-1.875-.365-.437-.886-.656-1.563-.656ZM300.016 206l-.258-1.219h-.063c-.427.537-.854.901-1.281 1.094-.422.187-.95.281-1.586.281-.849 0-1.516-.218-2-.656-.479-.438-.719-1.06-.719-1.867 0-1.729 1.383-2.636 4.149-2.719l1.453-.047v-.531c0-.672-.146-1.167-.438-1.484-.286-.323-.747-.485-1.382-.485-.714 0-1.521.219-2.422.656l-.399-.992a6.112 6.112 0 0 1 1.383-.539 6.064 6.064 0 0 1 1.516-.195c1.021 0 1.776.226 2.265.68.495.453.743 1.179.743 2.179V206h-.961Zm-2.93-.914c.807 0 1.44-.221 1.898-.664.464-.443.696-1.063.696-1.86v-.773l-1.297.055c-1.031.036-1.776.198-2.235.484-.453.281-.679.721-.679 1.32 0 .469.14.826.422 1.071.286.245.685.367 1.195.367Zm7.867.914h-1.297v-12.156h1.297V206Z",
                className: "private-voting_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 43,
                cy: 247,
                r: 11.5,
                className: "private-voting_svg__circle-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M45.906 251H40.1v-1.043l2.209-2.221c.652-.668 1.084-1.14 1.294-1.418.215-.281.372-.545.47-.791.097-.246.146-.509.146-.791 0-.386-.117-.691-.352-.914-.23-.222-.55-.334-.96-.334-.329 0-.647.061-.956.182-.304.121-.658.34-1.06.656l-.744-.908c.476-.402.939-.688 1.388-.856.45-.167.928-.251 1.436-.251.797 0 1.435.209 1.916.627.48.414.72.972.72 1.675 0 .387-.07.754-.21 1.102a4.41 4.41 0 0 1-.64 1.078c-.284.367-.76.865-1.429 1.494l-1.488 1.442v.058h4.066V251Z",
                className: "private-voting_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M68.571 243.764c-.939 0-1.677.332-2.215.998-.537.665-.806 1.583-.806 2.755 0 1.226.257 2.153.772 2.782.52.629 1.27.943 2.25.943.423 0 .833-.041 1.23-.123.396-.086.809-.196 1.237-.328v1.401c-.784.297-1.672.445-2.666.445-1.463 0-2.586-.442-3.37-1.326-.784-.889-1.176-2.158-1.176-3.808 0-1.039.19-1.948.567-2.728a4.098 4.098 0 0 1 1.655-1.791c.72-.414 1.565-.622 2.536-.622 1.02 0 1.964.214 2.83.643l-.588 1.36a8.478 8.478 0 0 0-1.073-.417 3.758 3.758 0 0 0-1.183-.184Zm11.157 4.942c0 1.235-.317 2.199-.95 2.892-.634.692-1.516 1.039-2.646 1.039-.707 0-1.33-.16-1.873-.479a3.16 3.16 0 0 1-1.251-1.374c-.292-.597-.438-1.29-.438-2.078 0-1.226.315-2.183.944-2.871.629-.688 1.515-1.032 2.659-1.032 1.094 0 1.96.353 2.597 1.059.639.702.958 1.65.958 2.844Zm-5.503 0c0 1.745.645 2.618 1.934 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.642-2.591-1.927-2.591-.675 0-1.165.224-1.47.67-.301.447-.451 1.087-.451 1.921ZM87.95 252.5h-1.613v-4.662c0-.579-.11-1.01-.328-1.292-.219-.287-.56-.431-1.026-.431-.62 0-1.075.203-1.367.609-.287.401-.43 1.071-.43 2.009v3.767H81.58v-7.561h1.258l.226.992h.082c.21-.36.512-.638.909-.834.4-.196.84-.294 1.319-.294 1.162 0 1.932.396 2.31 1.189h.11c.223-.374.538-.665.943-.875.406-.209.87-.314 1.395-.314.902 0 1.558.228 1.969.683.414.456.622 1.151.622 2.085v4.929h-1.607v-4.662c0-.579-.111-1.01-.335-1.292-.219-.287-.56-.431-1.025-.431-.624 0-1.082.196-1.374.588-.287.387-.43.985-.43 1.791v4.006Zm13.385 0h-1.613v-4.662c0-.579-.11-1.01-.329-1.292-.218-.287-.56-.431-1.025-.431-.62 0-1.075.203-1.367.609-.287.401-.43 1.071-.43 2.009v3.767h-1.607v-7.561h1.258l.225.992h.082c.21-.36.513-.638.91-.834.4-.196.84-.294 1.319-.294 1.162 0 1.932.396 2.31 1.189h.11a2.3 2.3 0 0 1 .943-.875c.406-.209.871-.314 1.395-.314.902 0 1.558.228 1.968.683.415.456.622 1.151.622 2.085v4.929h-1.606v-4.662c0-.579-.112-1.01-.335-1.292-.219-.287-.561-.431-1.025-.431-.625 0-1.083.196-1.374.588-.288.387-.431.985-.431 1.791v4.006Zm8.62 0h-1.606v-7.561h1.606v7.561Zm-1.702-9.563c0-.288.077-.509.232-.664.16-.155.385-.232.677-.232.283 0 .501.077.656.232.16.155.24.376.24.664 0 .273-.08.489-.24.649-.155.155-.373.232-.656.232-.292 0-.517-.077-.677-.232-.155-.16-.232-.376-.232-.649Zm6.822 8.401a3.91 3.91 0 0 0 1.176-.185v1.21a3.098 3.098 0 0 1-.69.192 4.55 4.55 0 0 1-.869.082c-1.522 0-2.283-.802-2.283-2.407v-4.074h-1.032v-.711l1.107-.588.547-1.599h.991v1.681h2.154v1.217h-2.154v4.047c0 .387.096.675.288.861.196.183.451.274.765.274Zm13.118-5.811c0 1.044-.341 1.844-1.025 2.4-.684.556-1.657.834-2.919.834h-1.039v3.739h-1.634v-9.994h2.878c1.249 0 2.183.255 2.803.765.624.511.936 1.263.936 2.256Zm-4.983 1.86h.868c.839 0 1.454-.146 1.846-.438.392-.291.588-.747.588-1.367 0-.574-.176-1.003-.527-1.285-.351-.283-.897-.424-1.64-.424h-1.135v3.514Zm10.11 5.25c-1.175 0-2.096-.342-2.761-1.026-.661-.688-.992-1.633-.992-2.837 0-1.235.308-2.205.923-2.912.615-.706 1.461-1.059 2.536-1.059.998 0 1.787.303 2.366.909.578.606.868 1.44.868 2.502v.868h-5.038c.022.734.221 1.299.594 1.695.374.392.9.588 1.579.588.447 0 .862-.041 1.245-.123a6.666 6.666 0 0 0 1.244-.424v1.306a4.956 4.956 0 0 1-1.19.397 7.334 7.334 0 0 1-1.374.116Zm-.294-6.617c-.51 0-.92.161-1.23.485-.305.323-.488.795-.547 1.415h3.432c-.009-.624-.16-1.096-.452-1.415-.291-.324-.692-.485-1.203-.485Zm8.894-1.217c.323 0 .59.023.8.068l-.158 1.497a3.007 3.007 0 0 0-.71-.082c-.643 0-1.165.21-1.566.629-.396.419-.595.964-.595 1.634v3.951h-1.606v-7.561h1.258l.212 1.333h.082c.25-.451.576-.808.977-1.073a2.352 2.352 0 0 1 1.306-.396Zm3.814 7.697h-1.606v-7.561h1.606v7.561Zm-1.702-9.563c0-.288.078-.509.233-.664.159-.155.385-.232.676-.232.283 0 .502.077.657.232.159.155.239.376.239.664 0 .273-.08.489-.239.649-.155.155-.374.232-.657.232-.291 0-.517-.077-.676-.232-.155-.16-.233-.376-.233-.649Zm10.712 5.769c0 1.235-.317 2.199-.95 2.892-.634.692-1.515 1.039-2.646 1.039-.706 0-1.33-.16-1.873-.479a3.163 3.163 0 0 1-1.251-1.374c-.291-.597-.437-1.29-.437-2.078 0-1.226.314-2.183.943-2.871.629-.688 1.516-1.032 2.659-1.032 1.094 0 1.96.353 2.598 1.059.638.702.957 1.65.957 2.844Zm-5.503 0c0 1.745.645 2.618 1.935 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.643-2.591-1.928-2.591-.674 0-1.164.224-1.47.67-.3.447-.451 1.087-.451 1.921Zm9.905 3.931c-.943 0-1.679-.342-2.208-1.026-.528-.683-.793-1.643-.793-2.878 0-1.239.267-2.203.8-2.891.538-.693 1.281-1.039 2.229-1.039.993 0 1.75.367 2.269 1.1h.082a9.69 9.69 0 0 1-.116-1.285v-2.755h1.613V252.5h-1.257l-.281-.991h-.075c-.515.752-1.269 1.128-2.263 1.128Zm.431-1.299c.661 0 1.142-.185 1.443-.554.3-.374.455-.977.464-1.811v-.226c0-.952-.155-1.629-.464-2.03-.31-.401-.796-.602-1.457-.602-.565 0-1 .23-1.305.691-.306.455-.458 1.107-.458 1.955 0 .838.148 1.479.444 1.921.296.437.741.656 1.333.656Z",
                className: "private-voting_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M181 247h33",
                className: "private-voting_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 242,
                cy: 247,
                r: 11.5,
                className: "private-voting_svg__circle-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M244.584 244.402c0 .543-.158.996-.475 1.36-.316.359-.761.601-1.336.726v.047c.688.086 1.204.301 1.547.645.344.34.516.793.516 1.359 0 .824-.291 1.461-.873 1.91-.582.446-1.41.668-2.484.668-.95 0-1.75-.154-2.403-.463v-1.224c.363.179.748.318 1.154.416.407.097.797.146 1.172.146.664 0 1.16-.123 1.489-.369.328-.246.492-.627.492-1.143 0-.457-.182-.792-.545-1.007-.363-.215-.934-.323-1.711-.323h-.744v-1.119h.756c1.367 0 2.05-.472 2.05-1.418 0-.367-.119-.65-.357-.849-.238-.2-.59-.299-1.055-.299-.324 0-.636.047-.937.14-.301.09-.656.268-1.067.534l-.673-.961c.785-.578 1.697-.867 2.736-.867.863 0 1.537.185 2.021.556.485.371.727.883.727 1.535Z",
                className: "private-voting_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M269.014 242.506h1.695l-3.5 9.994h-1.723L262 242.506h1.682l2.085 6.214c.109.296.225.679.348 1.148.123.465.203.811.239 1.039.06-.346.151-.747.274-1.203.123-.456.223-.793.301-1.012l2.085-6.186Zm9.549 6.2c0 1.235-.316 2.199-.95 2.892-.633.692-1.515 1.039-2.645 1.039-.707 0-1.331-.16-1.873-.479a3.151 3.151 0 0 1-1.251-1.374c-.292-.597-.438-1.29-.438-2.078 0-1.226.315-2.183.944-2.871.629-.688 1.515-1.032 2.659-1.032 1.094 0 1.959.353 2.597 1.059.638.702.957 1.65.957 2.844Zm-5.502 0c0 1.745.644 2.618 1.934 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.642-2.591-1.928-2.591-.674 0-1.164.224-1.469.67-.301.447-.451 1.087-.451 1.921Zm10.171 2.632a3.91 3.91 0 0 0 1.176-.185v1.21a3.098 3.098 0 0 1-.69.192 4.548 4.548 0 0 1-.868.082c-1.523 0-2.284-.802-2.284-2.407v-4.074h-1.032v-.711l1.108-.588.546-1.599h.992v1.681h2.153v1.217h-2.153v4.047c0 .387.095.675.287.861.196.183.451.274.765.274Zm4.3 1.162h-1.606v-7.561h1.606v7.561Zm-1.702-9.563c0-.288.078-.509.232-.664.16-.155.386-.232.677-.232.283 0 .502.077.657.232.159.155.239.376.239.664 0 .273-.08.489-.239.649-.155.155-.374.232-.657.232-.291 0-.517-.077-.677-.232-.154-.16-.232-.376-.232-.649Zm10.657 9.563h-1.613v-4.648c0-.584-.118-1.019-.355-1.306-.233-.287-.604-.431-1.115-.431-.679 0-1.175.201-1.49.602-.314.401-.472 1.073-.472 2.016v3.767h-1.606v-7.561h1.258l.225.992h.082a2.24 2.24 0 0 1 .971-.834 3.252 3.252 0 0 1 1.395-.294c1.813 0 2.72.923 2.72 2.768v4.929Zm8.62-7.561v.882l-1.292.24a2.311 2.311 0 0 1 .411 1.326c0 .779-.269 1.392-.807 1.839-.538.446-1.278.67-2.222.67-.241 0-.46-.019-.656-.055-.346.214-.52.465-.52.752 0 .173.08.303.24.389.164.087.462.13.895.13h1.32c.834 0 1.467.178 1.9.534.433.355.649.868.649 1.538 0 .856-.353 1.517-1.059 1.982-.707.465-1.727.697-3.063.697-1.03 0-1.816-.182-2.358-.547-.542-.364-.814-.884-.814-1.558 0-.465.146-.857.438-1.176.296-.314.709-.533 1.237-.656a1.232 1.232 0 0 1-.533-.438 1.138 1.138 0 0 1-.205-.642c0-.283.08-.522.239-.718.16-.196.397-.39.711-.581a2.134 2.134 0 0 1-.957-.82c-.241-.383-.362-.83-.362-1.34 0-.821.257-1.456.772-1.908.52-.451 1.258-.676 2.215-.676.214 0 .438.016.67.048.237.027.415.057.533.088h2.618Zm-5.94 8.737c0 .346.155.613.465.8.314.186.754.28 1.319.28.875 0 1.527-.125 1.955-.376.429-.251.643-.583.643-.998 0-.328-.119-.563-.356-.704-.232-.137-.667-.205-1.305-.205h-1.217c-.46 0-.827.107-1.101.321-.269.219-.403.513-.403.882Zm.69-6.289c0 .474.121.838.363 1.093.246.256.597.383 1.052.383.93 0 1.395-.496 1.395-1.49 0-.492-.116-.87-.349-1.135-.228-.269-.576-.403-1.046-.403-.464 0-.818.132-1.059.396-.237.265-.356.65-.356 1.156Zm17.083-1.86c0 1.044-.341 1.844-1.025 2.4-.684.556-1.657.834-2.919.834h-1.039v3.739h-1.634v-9.994h2.878c1.249 0 2.183.255 2.803.765.624.511.936 1.263.936 2.256Zm-4.983 1.86h.868c.839 0 1.454-.146 1.846-.438.392-.291.588-.747.588-1.367 0-.574-.176-1.003-.527-1.285-.35-.283-.897-.424-1.64-.424h-1.135v3.514Zm10.11 5.25c-1.175 0-2.096-.342-2.761-1.026-.661-.688-.992-1.633-.992-2.837 0-1.235.308-2.205.923-2.912.616-.706 1.461-1.059 2.536-1.059.998 0 1.787.303 2.366.909.578.606.868 1.44.868 2.502v.868h-5.038c.023.734.221 1.299.594 1.695.374.392.901.588 1.58.588.446 0 .861-.041 1.244-.123a6.666 6.666 0 0 0 1.244-.424v1.306a4.956 4.956 0 0 1-1.19.397 7.334 7.334 0 0 1-1.374.116Zm-.294-6.617c-.51 0-.92.161-1.23.485-.305.323-.488.795-.547 1.415h3.432c-.009-.624-.16-1.096-.451-1.415-.292-.324-.693-.485-1.204-.485Zm8.894-1.217c.324 0 .59.023.8.068l-.157 1.497a3.022 3.022 0 0 0-.711-.082c-.643 0-1.165.21-1.566.629-.396.419-.595.964-.595 1.634v3.951h-1.606v-7.561h1.258l.212 1.333h.082c.25-.451.576-.808.977-1.073a2.352 2.352 0 0 1 1.306-.396Zm3.814 7.697h-1.606v-7.561h1.606v7.561Zm-1.702-9.563c0-.288.078-.509.233-.664.159-.155.385-.232.676-.232.283 0 .502.077.657.232.159.155.239.376.239.664 0 .273-.08.489-.239.649-.155.155-.374.232-.657.232-.291 0-.517-.077-.676-.232-.155-.16-.233-.376-.233-.649Zm10.712 5.769c0 1.235-.317 2.199-.95 2.892-.633.692-1.515 1.039-2.645 1.039-.707 0-1.331-.16-1.874-.479a3.163 3.163 0 0 1-1.251-1.374c-.291-.597-.437-1.29-.437-2.078 0-1.226.314-2.183.943-2.871.629-.688 1.516-1.032 2.66-1.032 1.093 0 1.959.353 2.597 1.059.638.702.957 1.65.957 2.844Zm-5.503 0c0 1.745.645 2.618 1.935 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.643-2.591-1.928-2.591-.674 0-1.164.224-1.47.67-.3.447-.451 1.087-.451 1.921Zm9.906 3.931c-.944 0-1.68-.342-2.208-1.026-.529-.683-.793-1.643-.793-2.878 0-1.239.266-2.203.799-2.891.538-.693 1.281-1.039 2.229-1.039.993 0 1.75.367 2.269 1.1h.082a9.69 9.69 0 0 1-.116-1.285v-2.755h1.614V252.5h-1.258l-.281-.991h-.075c-.515.752-1.269 1.128-2.262 1.128Zm.43-1.299c.661 0 1.142-.185 1.443-.554.3-.374.455-.977.464-1.811v-.226c0-.952-.155-1.629-.464-2.03-.31-.401-.796-.602-1.456-.602-.566 0-1.001.23-1.306.691-.305.455-.458 1.107-.458 1.955 0 .838.148 1.479.444 1.921.296.437.741.656 1.333.656Z",
                className: "private-voting_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.46 48.602c-1.254 0-2.246.419-2.976 1.257-.724.834-1.086 1.977-1.086 3.43 0 1.495.35 2.651 1.047 3.469.703.812 1.703 1.219 3 1.219.797 0 1.706-.144 2.727-.43v1.164c-.792.297-1.768.445-2.93.445-1.682 0-2.982-.51-3.898-1.531-.912-1.02-1.367-2.471-1.367-4.352 0-1.177.218-2.208.656-3.093a4.77 4.77 0 0 1 1.906-2.047c.833-.48 1.813-.719 2.938-.719 1.197 0 2.244.219 3.14.656l-.562 1.14c-.865-.405-1.73-.608-2.594-.608Zm12.4 6.109c0 1.396-.352 2.487-1.055 3.273-.703.782-1.675 1.172-2.914 1.172-.766 0-1.446-.18-2.04-.539-.593-.36-1.052-.875-1.374-1.547-.323-.672-.485-1.458-.485-2.36 0-1.395.35-2.48 1.047-3.257.698-.781 1.667-1.172 2.906-1.172 1.198 0 2.149.399 2.852 1.196.708.796 1.062 1.875 1.062 3.234Zm-6.524 0c0 1.094.219 1.927.656 2.5.438.573 1.08.86 1.93.86.849 0 1.492-.285 1.93-.852.442-.573.664-1.41.664-2.508 0-1.089-.222-1.914-.664-2.477-.438-.567-1.086-.851-1.946-.851-.849 0-1.49.278-1.922.836-.432.557-.648 1.388-.648 2.492Zm10.023-4.273v5.554c0 .698.16 1.219.477 1.563.318.343.815.515 1.492.515.896 0 1.55-.245 1.961-.734.417-.49.625-1.29.625-2.398v-4.5h1.297V59h-1.07l-.188-1.148h-.07a2.58 2.58 0 0 1-1.11.968c-.468.224-1.005.336-1.609.336-1.042 0-1.823-.247-2.344-.742-.515-.495-.773-1.286-.773-2.375v-5.602h1.312Zm12.516-.157c.38 0 .721.032 1.023.094l-.179 1.203a4.42 4.42 0 0 0-.938-.117c-.693 0-1.286.281-1.781.844-.49.562-.734 1.263-.734 2.101V59h-1.297v-8.563h1.07l.148 1.586h.063c.318-.557.7-.987 1.148-1.289.448-.302.94-.453 1.477-.453Zm5.391 7.805c.229 0 .45-.016.664-.047a4.87 4.87 0 0 0 .508-.11v.993c-.141.068-.349.122-.626.164-.27.047-.515.07-.734.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.984h2.484v1.008h-2.484v5.04c0 .515.122.91.367 1.187.245.276.581.414 1.008.414Zm8.414-1.422c0 .797-.297 1.411-.891 1.844-.594.432-1.427.648-2.5.648-1.135 0-2.021-.18-2.656-.539v-1.203c.411.208.851.372 1.32.492.474.12.93.18 1.367.18.677 0 1.198-.107 1.563-.32.364-.22.547-.55.547-.993 0-.333-.146-.617-.438-.851-.286-.24-.849-.521-1.687-.844-.797-.297-1.365-.555-1.703-.773-.334-.224-.584-.477-.75-.758-.162-.281-.243-.617-.243-1.008 0-.698.284-1.247.852-1.648.568-.407 1.346-.61 2.336-.61.922 0 1.823.188 2.703.563l-.461 1.054c-.859-.354-1.638-.53-2.336-.53-.614 0-1.078.096-1.391.288-.312.193-.468.459-.468.797 0 .23.057.425.172.586.119.161.31.315.57.461.26.146.76.357 1.5.633 1.016.37 1.7.742 2.055 1.117.359.375.539.846.539 1.414ZM126.945 59l-1.57-5.023c-.099-.308-.284-1.006-.555-2.094h-.062a29.101 29.101 0 0 1-.547 2.11L122.594 59h-1.5l-2.336-8.563h1.359c.552 2.152.972 3.79 1.258 4.915.292 1.125.458 1.882.5 2.273h.063c.057-.297.148-.68.273-1.148.13-.474.242-.85.336-1.125l1.57-4.914h1.406l1.532 4.914c.291.895.489 1.648.593 2.257h.063c.021-.187.075-.476.164-.867.094-.39.638-2.492 1.633-6.304h1.344L128.484 59h-1.539Zm6.758 0h-1.297v-8.563h1.297V59Zm-1.406-10.883c0-.297.073-.513.219-.648a.754.754 0 0 1 .546-.211c.209 0 .389.07.54.21.151.141.226.357.226.65 0 .29-.075.51-.226.655a.765.765 0 0 1-.54.211.754.754 0 0 1-.546-.21c-.146-.146-.219-.365-.219-.657Zm6.922 9.969c.229 0 .45-.016.664-.047.213-.036.383-.073.508-.11v.993c-.141.068-.349.122-.625.164-.271.047-.516.07-.735.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.984h2.484v1.008h-2.484v5.04c0 .515.122.91.367 1.187.245.276.581.414 1.008.414Zm8.75.914v-5.54c0-.697-.159-1.218-.477-1.562-.318-.343-.815-.515-1.492-.515-.901 0-1.56.245-1.977.734-.411.49-.617 1.292-.617 2.406V59h-1.297V46.844h1.297v3.68c0 .442-.021.81-.062 1.101h.078a2.621 2.621 0 0 1 1.086-.969c.474-.24 1.013-.36 1.617-.36 1.047 0 1.831.25 2.352.75.526.496.789 1.285.789 2.368V59h-1.297Zm11.359-4.29c0 1.397-.351 2.488-1.055 3.274-.703.782-1.674 1.172-2.914 1.172-.765 0-1.445-.18-2.039-.539-.593-.36-1.052-.875-1.375-1.547-.323-.672-.484-1.458-.484-2.36 0-1.395.349-2.48 1.047-3.257.698-.781 1.666-1.172 2.906-1.172 1.198 0 2.148.399 2.852 1.196.708.796 1.062 1.875 1.062 3.234Zm-6.523 0c0 1.095.218 1.928.656 2.5.437.574 1.081.86 1.93.86s1.492-.284 1.929-.851c.443-.573.664-1.41.664-2.508 0-1.089-.221-1.914-.664-2.477-.437-.567-1.086-.851-1.945-.851-.849 0-1.49.278-1.922.836-.432.557-.648 1.388-.648 2.492Zm10.023-4.273v5.555c0 .698.159 1.219.477 1.563.317.343.815.515 1.492.515.896 0 1.549-.245 1.961-.734.416-.49.625-1.29.625-2.398v-4.5h1.297V59h-1.071l-.187-1.148h-.07a2.584 2.584 0 0 1-1.11.968c-.469.224-1.005.336-1.609.336-1.042 0-1.823-.247-2.344-.742-.516-.495-.773-1.286-.773-2.375v-5.602h1.312Zm11.375 7.649c.229 0 .451-.016.664-.047.214-.036.383-.073.508-.11v.993c-.141.068-.349.122-.625.164-.271.047-.516.07-.734.07-1.657 0-2.485-.872-2.485-2.617v-5.094h-1.226v-.625l1.226-.539.547-1.828h.75v1.984h2.484v1.008h-2.484v5.04c0 .515.123.91.367 1.187.245.276.581.414 1.008.414Zm10.469 1.07c-1.24 0-2.201-.38-2.883-1.14-.677-.766-1.016-1.847-1.016-3.243 0-1.432.344-2.539 1.032-3.32.692-.781 1.677-1.172 2.953-1.172.411 0 .823.044 1.234.133.412.089.735.193.969.313l-.399 1.101a5.787 5.787 0 0 0-.937-.281 4.058 4.058 0 0 0-.898-.117c-1.74 0-2.61 1.11-2.61 3.328 0 1.052.211 1.86.633 2.422.427.562 1.057.843 1.891.843.713 0 1.445-.153 2.195-.46v1.148c-.573.297-1.294.445-2.164.445Zm11.594-4.445c0 1.396-.352 2.487-1.055 3.273-.703.782-1.675 1.172-2.914 1.172-.766 0-1.445-.18-2.039-.539-.594-.36-1.052-.875-1.375-1.547-.323-.672-.485-1.458-.485-2.36 0-1.395.349-2.48 1.047-3.257.698-.781 1.667-1.172 2.907-1.172 1.197 0 2.148.399 2.851 1.196.708.796 1.063 1.875 1.063 3.234Zm-6.524 0c0 1.094.219 1.927.656 2.5.438.573 1.081.86 1.93.86s1.492-.285 1.93-.852c.443-.573.664-1.41.664-2.508 0-1.089-.221-1.914-.664-2.477-.438-.567-1.086-.851-1.946-.851-.848 0-1.489.278-1.921.836-.433.557-.649 1.388-.649 2.492ZM209.461 59v-5.57c0-.683-.146-1.193-.438-1.532-.291-.343-.744-.515-1.359-.515-.807 0-1.404.232-1.789.695-.385.464-.578 1.177-.578 2.14V59H204v-5.57c0-.683-.146-1.193-.438-1.532-.291-.343-.747-.515-1.367-.515-.812 0-1.409.245-1.789.734-.375.485-.562 1.281-.562 2.39V59h-1.297v-8.563h1.055l.21 1.172h.063a2.56 2.56 0 0 1 1.031-.976 3.186 3.186 0 0 1 1.5-.352c1.339 0 2.214.485 2.625 1.453h.063a2.73 2.73 0 0 1 1.109-1.062c.485-.26 1.037-.39 1.656-.39.969 0 1.693.25 2.172.75.485.494.727 1.288.727 2.382V59h-1.297Zm14.891 0v-5.57c0-.683-.146-1.193-.438-1.532-.292-.343-.745-.515-1.359-.515-.808 0-1.404.232-1.789.695-.386.464-.578 1.177-.578 2.14V59h-1.297v-5.57c0-.683-.146-1.193-.438-1.532-.292-.343-.747-.515-1.367-.515-.813 0-1.409.245-1.789.734-.375.485-.563 1.281-.563 2.39V59h-1.296v-8.563h1.054l.211 1.172h.063a2.547 2.547 0 0 1 1.031-.976 3.186 3.186 0 0 1 1.5-.352c1.338 0 2.213.485 2.625 1.453h.062a2.733 2.733 0 0 1 1.11-1.062c.484-.26 1.036-.39 1.656-.39.969 0 1.693.25 2.172.75.484.494.726 1.288.726 2.382V59h-1.296Zm5.273 0h-1.297v-8.563h1.297V59Zm-1.406-10.883c0-.297.073-.513.219-.648a.754.754 0 0 1 .546-.211c.209 0 .388.07.539.21.151.141.227.357.227.65 0 .29-.076.51-.227.655a.762.762 0 0 1-.539.211.754.754 0 0 1-.546-.21c-.146-.146-.219-.365-.219-.657Zm6.922 9.969c.229 0 .45-.016.664-.047a4.73 4.73 0 0 0 .507-.11v.993c-.14.068-.348.122-.624.164-.271.047-.516.07-.735.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.984h2.484v1.008h-2.484v5.04c0 .515.122.91.367 1.187.245.276.581.414 1.008.414Zm12.312.914-.258-1.219h-.062c-.427.537-.854.901-1.281 1.094-.422.188-.951.281-1.586.281-.849 0-1.516-.218-2-.656-.48-.438-.719-1.06-.719-1.867 0-1.73 1.383-2.636 4.148-2.719l1.453-.047v-.531c0-.672-.145-1.167-.437-1.484-.287-.323-.747-.485-1.383-.485-.713 0-1.521.219-2.422.656l-.398-.992c.422-.229.883-.409 1.383-.539a6.047 6.047 0 0 1 1.515-.195c1.021 0 1.776.226 2.266.68.495.453.742 1.18.742 2.18V59h-.961Zm-2.93-.914c.808 0 1.441-.221 1.899-.664.463-.443.695-1.063.695-1.86v-.773l-1.297.055c-1.031.036-1.776.198-2.234.484-.453.281-.68.721-.68 1.32 0 .47.141.826.422 1.07.287.245.685.368 1.195.368Zm12.43.914v-5.54c0-.697-.159-1.218-.476-1.562-.318-.343-.816-.515-1.493-.515-.895 0-1.552.242-1.968.726-.417.485-.625 1.284-.625 2.399V59h-1.297v-8.563h1.054l.211 1.172h.063a2.625 2.625 0 0 1 1.117-.976 3.596 3.596 0 0 1 1.602-.352c1.031 0 1.807.25 2.328.75.521.495.781 1.29.781 2.383V59h-1.297Zm9.797-1.148h-.07c-.599.87-1.495 1.304-2.688 1.304-1.12 0-1.992-.383-2.617-1.148-.62-.766-.93-1.854-.93-3.266 0-1.411.313-2.508.938-3.289.625-.781 1.495-1.172 2.609-1.172 1.162 0 2.052.422 2.672 1.266h.102l-.055-.617-.031-.602v-3.484h1.297V59h-1.055l-.172-1.148Zm-2.594.218c.886 0 1.526-.24 1.922-.718.401-.485.602-1.263.602-2.336v-.274c0-1.213-.203-2.078-.61-2.594-.401-.52-1.044-.78-1.929-.78-.761 0-1.344.296-1.75.89-.401.588-.602 1.422-.602 2.5 0 1.094.201 1.92.602 2.476.401.558.989.836 1.765.836Zm14.641-7.789c.38 0 .721.032 1.023.094l-.179 1.203a4.429 4.429 0 0 0-.938-.117c-.693 0-1.286.281-1.781.844-.49.562-.734 1.263-.734 2.101V59h-1.297v-8.563h1.07l.148 1.586h.063c.318-.557.7-.987 1.148-1.289.448-.302.94-.453 1.477-.453Zm6.242 8.875c-1.266 0-2.266-.385-3-1.156-.729-.77-1.094-1.841-1.094-3.21 0-1.381.339-2.477 1.016-3.29.682-.813 1.596-1.219 2.742-1.219 1.073 0 1.922.354 2.547 1.063.625.703.938 1.633.938 2.789v.82h-5.899c.026 1.005.279 1.768.758 2.29.484.52 1.164.78 2.039.78.922 0 1.833-.192 2.734-.578v1.157a6.626 6.626 0 0 1-1.304.421 7.05 7.05 0 0 1-1.477.133Zm-.351-7.789c-.688 0-1.237.224-1.649.672-.406.448-.646 1.068-.719 1.86h4.477c0-.818-.182-1.443-.547-1.876-.365-.437-.885-.656-1.562-.656ZM292.281 59l-3.25-8.563h1.391l1.844 5.079c.416 1.187.661 1.958.734 2.312h.062c.058-.276.237-.846.54-1.71.307-.87.992-2.764 2.054-5.68h1.391L293.797 59h-1.516Zm9.758.156c-1.266 0-2.266-.385-3-1.156-.729-.77-1.094-1.841-1.094-3.21 0-1.381.339-2.477 1.016-3.29.682-.813 1.596-1.219 2.742-1.219 1.073 0 1.922.354 2.547 1.063.625.703.938 1.633.938 2.789v.82h-5.899c.026 1.005.279 1.768.758 2.29.484.52 1.164.78 2.039.78.922 0 1.833-.192 2.734-.578v1.157a6.626 6.626 0 0 1-1.304.421 7.05 7.05 0 0 1-1.477.133Zm-.351-7.789c-.688 0-1.237.224-1.649.672-.406.448-.646 1.068-.719 1.86h4.477c0-.818-.182-1.443-.547-1.876-.365-.437-.885-.656-1.562-.656ZM312.672 59l-.258-1.219h-.062c-.428.537-.855.901-1.282 1.094-.422.188-.95.281-1.586.281-.849 0-1.515-.218-2-.656-.479-.438-.718-1.06-.718-1.867 0-1.73 1.382-2.636 4.148-2.719l1.453-.047v-.531c0-.672-.146-1.167-.437-1.484-.287-.323-.748-.485-1.383-.485-.714 0-1.521.219-2.422.656l-.398-.992a6.09 6.09 0 0 1 1.382-.539 6.06 6.06 0 0 1 1.516-.195c1.021 0 1.776.226 2.266.68.494.453.742 1.18.742 2.18V59h-.961Zm-2.93-.914c.807 0 1.44-.221 1.899-.664.463-.443.695-1.063.695-1.86v-.773l-1.297.055c-1.031.036-1.776.198-2.234.484-.453.281-.68.721-.68 1.32 0 .47.141.826.422 1.07.286.245.685.368 1.195.368Zm7.867.914h-1.297V46.844h1.297V59Z",
                className: "private-voting_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M81.5 100h33",
                className: "private-voting_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 142.5,
                cy: 100,
                r: 11.5,
                className: "private-voting_svg__circle-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M145.406 104H139.6v-1.043l2.209-2.221c.652-.668 1.084-1.14 1.295-1.418a3.4 3.4 0 0 0 .468-.79c.098-.247.147-.51.147-.792 0-.386-.117-.691-.352-.914-.23-.222-.551-.334-.961-.334-.328 0-.646.06-.955.182-.305.121-.658.34-1.06.656l-.745-.908c.477-.402.94-.688 1.389-.856a4.065 4.065 0 0 1 1.436-.251c.797 0 1.435.208 1.916.626.48.415.72.973.72 1.676 0 .387-.07.754-.211 1.102a4.376 4.376 0 0 1-.638 1.078c-.285.367-.762.865-1.43 1.494l-1.488 1.442v.058h4.066V104Z",
                className: "private-voting_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M169.514 95.506h1.695l-3.5 9.994h-1.723l-3.486-9.994h1.682l2.085 6.214c.109.296.225.679.348 1.148.123.465.203.811.239 1.039.06-.346.151-.747.274-1.203.123-.456.223-.793.301-1.012l2.085-6.186Zm9.549 6.2c0 1.235-.316 2.199-.95 2.892-.633.692-1.515 1.039-2.645 1.039-.707 0-1.331-.16-1.873-.479a3.151 3.151 0 0 1-1.251-1.374c-.292-.597-.438-1.29-.438-2.078 0-1.226.315-2.183.944-2.871.629-.688 1.515-1.032 2.659-1.032 1.094 0 1.959.353 2.597 1.06.638.701.957 1.649.957 2.843Zm-5.502 0c0 1.745.644 2.618 1.934 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.642-2.59-1.928-2.59-.674 0-1.164.222-1.469.67-.301.446-.451 1.086-.451 1.92Zm10.171 2.632a3.91 3.91 0 0 0 1.176-.185v1.21a3.098 3.098 0 0 1-.69.192 4.548 4.548 0 0 1-.868.082c-1.523 0-2.284-.802-2.284-2.407v-4.074h-1.032v-.71l1.108-.589.546-1.6h.992v1.682h2.153v1.217h-2.153v4.047c0 .387.095.675.287.861.196.183.451.274.765.274Zm4.3 1.162h-1.606v-7.56h1.606v7.56Zm-1.702-9.564c0-.287.078-.508.232-.663.16-.154.386-.232.677-.232.283 0 .502.078.657.232.159.155.239.376.239.663 0 .274-.08.49-.239.65-.155.155-.374.232-.657.232-.291 0-.517-.077-.677-.232-.154-.16-.232-.376-.232-.65Zm10.657 9.564h-1.613v-4.648c0-.584-.118-1.019-.355-1.306-.233-.287-.604-.43-1.115-.43-.679 0-1.175.2-1.49.6-.314.402-.472 1.074-.472 2.017v3.767h-1.606v-7.56h1.258l.225.99h.082c.228-.36.552-.637.971-.833a3.252 3.252 0 0 1 1.395-.294c1.813 0 2.72.923 2.72 2.768v4.929Zm8.62-7.56v.881l-1.292.24a2.306 2.306 0 0 1 .411 1.326c0 .779-.269 1.392-.807 1.839-.538.446-1.278.67-2.222.67-.241 0-.46-.019-.656-.055-.346.214-.52.465-.52.752 0 .173.08.303.24.389.164.087.462.13.895.13h1.32c.834 0 1.467.178 1.9.534.433.355.649.868.649 1.538 0 .856-.353 1.517-1.059 1.982-.707.465-1.727.697-3.063.697-1.03 0-1.816-.182-2.358-.547-.542-.364-.814-.884-.814-1.558 0-.465.146-.857.438-1.176.296-.314.709-.533 1.237-.656a1.232 1.232 0 0 1-.533-.438 1.138 1.138 0 0 1-.205-.642c0-.283.08-.522.239-.718.16-.196.397-.39.711-.581a2.134 2.134 0 0 1-.957-.82c-.241-.383-.362-.83-.362-1.34 0-.82.257-1.456.772-1.907.52-.452 1.258-.677 2.215-.677.214 0 .438.016.67.048.237.027.415.057.533.088h2.618Zm-5.94 8.736c0 .346.155.613.465.8.314.186.754.28 1.319.28.875 0 1.527-.125 1.955-.376.429-.251.643-.583.643-.998 0-.328-.119-.563-.356-.704-.232-.137-.667-.205-1.305-.205h-1.217c-.46 0-.827.107-1.101.321-.269.219-.403.513-.403.882Zm.69-6.289c0 .474.121.838.363 1.093.246.256.597.383 1.052.383.93 0 1.395-.496 1.395-1.49 0-.492-.116-.87-.349-1.135-.228-.269-.576-.403-1.046-.403-.464 0-.818.132-1.059.396-.237.265-.356.65-.356 1.156Zm17.083-1.86c0 1.044-.341 1.844-1.025 2.4-.684.556-1.657.834-2.919.834h-1.039v3.739h-1.634v-9.994h2.878c1.249 0 2.183.255 2.803.766.624.51.936 1.262.936 2.255Zm-4.983 1.86h.868c.839 0 1.454-.146 1.846-.438.392-.291.588-.747.588-1.367 0-.574-.176-1.003-.527-1.285-.35-.283-.897-.424-1.64-.424h-1.135v3.514Zm10.11 5.25c-1.175 0-2.096-.342-2.761-1.026-.661-.688-.992-1.633-.992-2.837 0-1.235.308-2.205.923-2.912.616-.706 1.461-1.06 2.536-1.06.998 0 1.787.304 2.366.91.578.606.868 1.44.868 2.502v.868h-5.038c.023.734.221 1.299.594 1.695.374.392.901.588 1.58.588.446 0 .861-.041 1.244-.123a6.666 6.666 0 0 0 1.244-.424v1.306a4.956 4.956 0 0 1-1.19.397 7.334 7.334 0 0 1-1.374.116Zm-.294-6.618c-.51 0-.92.162-1.23.486-.305.324-.488.795-.547 1.415h3.432c-.009-.624-.16-1.096-.451-1.415-.292-.324-.693-.486-1.204-.486Zm8.894-1.216c.324 0 .59.023.8.068l-.157 1.497a3.037 3.037 0 0 0-.711-.082c-.643 0-1.165.21-1.566.629-.396.419-.595.964-.595 1.634v3.951h-1.606v-7.56h1.258l.212 1.332h.082a3 3 0 0 1 .977-1.073 2.35 2.35 0 0 1 1.306-.396Zm3.814 7.697h-1.606v-7.56h1.606v7.56Zm-1.702-9.564c0-.287.078-.508.233-.663.159-.154.385-.232.676-.232.283 0 .502.078.657.232.159.155.239.376.239.663 0 .274-.08.49-.239.65-.155.155-.374.232-.657.232-.291 0-.517-.077-.676-.232-.155-.16-.233-.376-.233-.65Zm10.712 5.77c0 1.235-.317 2.199-.95 2.892-.633.692-1.515 1.039-2.645 1.039-.707 0-1.331-.16-1.874-.479a3.163 3.163 0 0 1-1.251-1.374c-.291-.597-.437-1.29-.437-2.078 0-1.226.314-2.183.943-2.871.629-.688 1.516-1.032 2.66-1.032 1.093 0 1.959.353 2.597 1.06.638.701.957 1.649.957 2.843Zm-5.503 0c0 1.745.645 2.618 1.935 2.618 1.276 0 1.914-.873 1.914-2.618 0-1.727-.643-2.59-1.928-2.59-.674 0-1.164.222-1.47.67-.3.446-.451 1.086-.451 1.92Zm9.906 3.931c-.944 0-1.68-.342-2.208-1.026-.529-.683-.793-1.643-.793-2.878 0-1.239.266-2.203.799-2.891.538-.693 1.281-1.04 2.229-1.04.993 0 1.75.368 2.269 1.101h.082a9.703 9.703 0 0 1-.116-1.285v-2.755h1.614V105.5h-1.258l-.281-.991h-.075c-.515.752-1.269 1.128-2.262 1.128Zm.43-1.299c.661 0 1.142-.185 1.443-.554.3-.374.455-.977.464-1.811v-.226c0-.952-.155-1.629-.464-2.03-.31-.401-.796-.602-1.456-.602-.566 0-1.001.23-1.306.69-.305.456-.458 1.108-.458 1.956 0 .838.148 1.479.444 1.921.296.437.741.656 1.333.656Z",
                className: "private-voting_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M269.5 100h33",
                className: "private-voting_svg__path-11"
            })
        ]
    });
var $d8c4f0cce5764fc3$export$2e2bcd8739ae039 = $d8c4f0cce5764fc3$var$SvgPrivateVoting;



const $1017cf6192755936$var$StyledPrivateVotingSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d8c4f0cce5764fc3$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="circle-2"],
  [class$="path-2"],
  [class$="path-9"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }
  [class$="circle-1"],
  [class$="circle-3"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }
  [class$="rect-1"],
  [class$="circle-2"],
  [class$="path-4"],
  [class$="path-8"],
  [class$="path-11"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }
  [class$="path-1"],
  [class$="path-7"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }
  [class$="path-3"],
  [class$="path-6"],
  [class$="path-10"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }
  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.stroke};
  }
`;
const $1017cf6192755936$var$PrivateVoting = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $1017cf6192755936$var$StyledPrivateVotingSvg
    });
var $1017cf6192755936$export$2e2bcd8739ae039 = $1017cf6192755936$var$PrivateVoting;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $da101e3af3bfbbe3$var$SvgVotingModule = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 384 301",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 0.5,
                y: 0.5,
                width: 383,
                height: 300,
                rx: 2.5,
                className: "voting-module_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 25,
                y: 98.746,
                width: 155,
                height: 45,
                rx: 3,
                className: "voting-module_svg__rect-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M66.242 119.277c0 1.193-.39 2.107-1.172 2.743-.78.635-1.893.953-3.336.953h-1.187v4.273H58.68v-11.422h3.289c1.427 0 2.494.292 3.203.875.713.584 1.07 1.443 1.07 2.578Zm-5.695 2.125h.992c.958 0 1.661-.166 2.11-.5.447-.333.671-.854.671-1.562 0-.656-.2-1.146-.601-1.469-.401-.323-1.026-.484-1.875-.484h-1.297v4.015Zm13.187 5.844-.367-1.203h-.062c-.417.526-.836.885-1.258 1.078-.422.188-.964.281-1.625.281-.85 0-1.513-.229-1.992-.687-.474-.458-.711-1.107-.711-1.945 0-.891.33-1.563.992-2.016.661-.453 1.67-.701 3.023-.742l1.493-.047v-.461c0-.552-.13-.964-.391-1.234-.255-.277-.654-.415-1.195-.415-.443 0-.868.066-1.274.196s-.797.284-1.172.461l-.593-1.313a6.265 6.265 0 0 1 1.539-.554 6.907 6.907 0 0 1 1.578-.196c1.099 0 1.927.24 2.484.719.563.479.844 1.232.844 2.258v5.82h-1.313ZM71 125.996c.667 0 1.2-.185 1.602-.555.406-.375.609-.898.609-1.57v-.75l-1.11.047c-.864.031-1.494.177-1.89.437-.39.256-.586.649-.586 1.18 0 .386.115.685.344.899.229.208.573.312 1.031.312Zm5.297-7.391h2l1.758 4.899a9.29 9.29 0 0 1 .53 1.969h.063a8.04 8.04 0 0 1 .258-1.039c.125-.412.787-2.355 1.985-5.829h1.984l-3.695 9.79c-.672 1.796-1.792 2.695-3.36 2.695a5.26 5.26 0 0 1-1.187-.133v-1.453c.276.062.591.094.945.094.885 0 1.508-.513 1.867-1.539l.32-.813-3.468-8.641Zm21.18 8.641h-7.743v-1.391l2.946-2.96c.87-.891 1.445-1.521 1.726-1.891.287-.375.495-.727.625-1.055.13-.328.196-.679.196-1.054 0-.516-.157-.922-.47-1.219-.306-.297-.734-.446-1.28-.446-.438 0-.862.081-1.274.243-.406.161-.877.453-1.414.875l-.992-1.211c.635-.537 1.252-.917 1.851-1.141a5.42 5.42 0 0 1 1.915-.336c1.062 0 1.914.279 2.554.836.64.552.961 1.297.961 2.234 0 .516-.094 1.006-.281 1.469-.182.464-.466.943-.852 1.438-.38.489-1.015 1.153-1.906 1.992l-1.984 1.922v.078h5.422v1.617Zm5.273-7.133c1.151 0 2.062.305 2.734.914.672.61 1.008 1.44 1.008 2.493 0 1.218-.383 2.171-1.148 2.859-.761.682-1.844 1.023-3.25 1.023-1.276 0-2.279-.205-3.008-.617v-1.664c.422.24.906.425 1.453.555.547.13 1.055.195 1.523.195.829 0 1.459-.185 1.891-.555.432-.369.649-.911.649-1.625 0-1.364-.87-2.046-2.61-2.046-.245 0-.547.026-.906.078a9.86 9.86 0 0 0-.945.164l-.82-.485.437-5.578h5.937v1.633h-4.32l-.258 2.828c.182-.031.404-.068.664-.109.266-.042.589-.063.969-.063Zm13.008 1.422c0 1.985-.32 3.458-.961 4.422-.636.964-1.609 1.445-2.922 1.445-1.271 0-2.234-.497-2.891-1.492-.656-.995-.984-2.453-.984-4.375 0-2.015.318-3.5.953-4.453.641-.958 1.615-1.437 2.922-1.437 1.276 0 2.242.5 2.898 1.5.657 1 .985 2.463.985 4.39Zm-5.899 0c0 1.557.159 2.669.477 3.336.323.667.836 1 1.539 1s1.216-.338 1.539-1.016c.328-.677.492-1.783.492-3.32 0-1.531-.164-2.638-.492-3.32-.323-.688-.836-1.031-1.539-1.031s-1.216.336-1.539 1.007c-.318.672-.477 1.787-.477 3.344Zm21.547-.109c0 1.885-.523 3.328-1.57 4.328-1.047.995-2.555 1.492-4.524 1.492h-3.195v-11.422h3.531c1.818 0 3.232.49 4.243 1.469 1.01.979 1.515 2.357 1.515 4.133Zm-1.968.062c0-2.734-1.279-4.101-3.836-4.101h-1.618v8.289h1.328c2.75 0 4.126-1.396 4.126-4.188Zm11.515 5.758-1.141-3.172h-4.367l-1.117 3.172h-1.969l4.274-11.469h2.031l4.274 11.469h-1.985Zm-1.633-4.781-1.07-3.11a20.333 20.333 0 0 1-.328-.984 22.667 22.667 0 0 1-.281-.984c-.141.64-.347 1.341-.618 2.101l-1.031 2.977h3.328Zm5.125 4.781v-11.422h1.867v11.422h-1.867Z",
                className: "voting-module_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 204,
                y: 98.746,
                width: 155,
                height: 45,
                rx: 3,
                className: "voting-module_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M245.242 119.277c0 1.193-.39 2.107-1.172 2.743-.781.635-1.893.953-3.336.953h-1.187v4.273h-1.867v-11.422h3.289c1.427 0 2.495.292 3.203.875.713.584 1.07 1.443 1.07 2.578Zm-5.695 2.125h.992c.958 0 1.662-.166 2.109-.5.448-.333.672-.854.672-1.562 0-.656-.2-1.146-.601-1.469-.401-.323-1.026-.484-1.875-.484h-1.297v4.015Zm13.187 5.844-.367-1.203h-.062c-.417.526-.836.885-1.258 1.078-.422.188-.964.281-1.625.281-.849 0-1.513-.229-1.992-.687-.474-.458-.711-1.107-.711-1.945 0-.891.33-1.563.992-2.016.661-.453 1.669-.701 3.023-.742l1.493-.047v-.461c0-.552-.131-.964-.391-1.234-.255-.277-.654-.415-1.195-.415-.443 0-.868.066-1.274.196s-.797.284-1.172.461l-.593-1.313a6.244 6.244 0 0 1 1.539-.554 6.902 6.902 0 0 1 1.578-.196c1.099 0 1.927.24 2.484.719.563.479.844 1.232.844 2.258v5.82h-1.313Zm-2.734-1.25c.667 0 1.201-.185 1.602-.555.406-.375.609-.898.609-1.57v-.75l-1.109.047c-.865.031-1.495.177-1.891.437-.391.256-.586.649-.586 1.18 0 .386.115.685.344.899.229.208.573.312 1.031.312Zm5.297-7.391h2l1.758 4.899c.265.698.442 1.354.531 1.969h.062c.047-.287.133-.633.258-1.039.125-.412.787-2.355 1.985-5.829h1.984l-3.695 9.79c-.672 1.796-1.792 2.695-3.36 2.695-.406 0-.802-.044-1.187-.133v-1.453c.276.062.591.094.945.094.886 0 1.508-.513 1.867-1.539l.321-.813-3.469-8.641Zm18.828 8.641h-1.836v-7.375c0-.88.021-1.578.063-2.094-.12.125-.269.263-.446.414-.172.151-.755.631-1.75 1.438l-.922-1.164 3.36-2.641h1.531v11.422Zm7.625-7.133c1.151 0 2.062.305 2.734.914.672.61 1.008 1.44 1.008 2.493 0 1.218-.383 2.171-1.148 2.859-.761.682-1.844 1.023-3.25 1.023-1.276 0-2.279-.205-3.008-.617v-1.664c.422.24.906.425 1.453.555.547.13 1.055.195 1.523.195.829 0 1.459-.185 1.891-.555.432-.369.649-.911.649-1.625 0-1.364-.87-2.046-2.61-2.046-.245 0-.547.026-.906.078a9.86 9.86 0 0 0-.945.164l-.821-.485.438-5.578h5.937v1.633h-4.32l-.258 2.828c.182-.031.404-.068.664-.109.266-.042.589-.063.969-.063Zm13.008 1.422c0 1.985-.32 3.458-.961 4.422-.636.964-1.609 1.445-2.922 1.445-1.271 0-2.234-.497-2.891-1.492-.656-.995-.984-2.453-.984-4.375 0-2.015.318-3.5.953-4.453.641-.958 1.615-1.437 2.922-1.437 1.276 0 2.242.5 2.898 1.5.657 1 .985 2.463.985 4.39Zm-5.899 0c0 1.557.159 2.669.477 3.336.323.667.836 1 1.539 1s1.216-.338 1.539-1.016c.328-.677.492-1.783.492-3.32 0-1.531-.164-2.638-.492-3.32-.323-.688-.836-1.031-1.539-1.031s-1.216.336-1.539 1.007c-.318.672-.477 1.787-.477 3.344Zm21.547-.109c0 1.885-.523 3.328-1.57 4.328-1.047.995-2.555 1.492-4.524 1.492h-3.195v-11.422h3.531c1.818 0 3.232.49 4.243 1.469 1.01.979 1.515 2.357 1.515 4.133Zm-1.968.062c0-2.734-1.279-4.101-3.836-4.101h-1.618v8.289h1.328c2.75 0 4.126-1.396 4.126-4.188Zm11.515 5.758-1.141-3.172h-4.367l-1.117 3.172h-1.969l4.274-11.469h2.031l4.274 11.469h-1.985Zm-1.633-4.781-1.07-3.11a20.333 20.333 0 0 1-.328-.984 22.667 22.667 0 0 1-.281-.984c-.141.64-.347 1.341-.618 2.101l-1.031 2.977h3.328Zm5.125 4.781v-11.422h1.867v11.422h-1.867Z",
                className: "voting-module_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M1 192h382v106a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V192Z",
                className: "voting-module_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 87.5,
                y: 224.246,
                width: 210,
                height: 44,
                rx: 2.5,
                className: "voting-module_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M122.5 246.137h1.297c.87 0 1.5-.162 1.891-.485.39-.323.585-.802.585-1.437 0-.646-.211-1.11-.632-1.391-.422-.281-1.058-.422-1.907-.422H122.5v3.735Zm0 1.547v4.562h-1.867v-11.422h3.226c1.474 0 2.565.276 3.274.828.708.552 1.062 1.386 1.062 2.5 0 1.422-.739 2.435-2.218 3.039l3.226 5.055h-2.125l-2.734-4.562H122.5Zm11.945 4.718c-1.343 0-2.396-.39-3.156-1.172-.755-.786-1.133-1.867-1.133-3.242 0-1.411.352-2.521 1.055-3.328.703-.807 1.669-1.211 2.898-1.211 1.141 0 2.042.347 2.703 1.039.662.693.993 1.646.993 2.86v.992h-5.758c.026.838.252 1.484.68 1.937.427.448 1.028.672 1.804.672a6.83 6.83 0 0 0 1.422-.14 7.655 7.655 0 0 0 1.422-.485v1.492a5.643 5.643 0 0 1-1.359.454 8.395 8.395 0 0 1-1.571.132Zm-.336-7.562c-.583 0-1.052.185-1.406.555-.349.369-.557.908-.625 1.617H136c-.01-.714-.182-1.253-.516-1.617-.333-.37-.791-.555-1.375-.555Zm10.118.156h-2.11v7.25h-1.844v-7.25h-1.421v-.859l1.421-.563v-.562c0-1.021.24-1.776.719-2.266.479-.495 1.211-.742 2.196-.742.645 0 1.281.107 1.906.32l-.485 1.391a4.226 4.226 0 0 0-1.297-.219c-.416 0-.721.13-.914.391-.187.255-.281.64-.281 1.156v.562h2.11v1.391Zm7.57 7.25-.258-1.133h-.094c-.255.401-.619.716-1.093.946-.469.229-1.006.343-1.61.343-1.047 0-1.828-.26-2.344-.781-.515-.521-.773-1.31-.773-2.367v-5.649h1.852v5.329c0 .661.135 1.158.406 1.492.271.328.695.492 1.273.492.771 0 1.336-.229 1.696-.688.364-.463.546-1.237.546-2.32v-4.305h1.844v8.641h-1.445Zm9.867-2.461c0 .844-.307 1.492-.922 1.945-.614.448-1.495.672-2.64.672-1.151 0-2.076-.174-2.774-.523v-1.586c1.016.469 1.961.703 2.836.703 1.13 0 1.695-.341 1.695-1.023a.81.81 0 0 0-.187-.547c-.125-.146-.331-.297-.617-.453a10.5 10.5 0 0 0-1.196-.532c-.994-.385-1.669-.77-2.023-1.156-.349-.385-.524-.885-.524-1.5 0-.739.297-1.312.891-1.719.599-.411 1.412-.617 2.438-.617 1.015 0 1.976.206 2.882.617l-.593 1.383c-.933-.385-1.716-.578-2.352-.578-.969 0-1.453.276-1.453.828 0 .271.125.5.375.688.255.187.807.445 1.656.773.714.276 1.232.529 1.555.758.323.229.562.495.719.797.156.297.234.653.234 1.07Zm5.766 2.617c-1.344 0-2.396-.39-3.157-1.172-.755-.786-1.132-1.867-1.132-3.242 0-1.411.351-2.521 1.054-3.328.703-.807 1.67-1.211 2.899-1.211 1.14 0 2.041.347 2.703 1.039.661.693.992 1.646.992 2.86v.992h-5.758c.026.838.253 1.484.68 1.937.427.448 1.029.672 1.805.672.51 0 .984-.047 1.422-.14a7.672 7.672 0 0 0 1.421-.485v1.492a5.643 5.643 0 0 1-1.359.454 8.384 8.384 0 0 1-1.57.132Zm-.336-7.562c-.584 0-1.052.185-1.406.555-.349.369-.558.908-.626 1.617h3.922c-.01-.714-.182-1.253-.515-1.617-.334-.37-.792-.555-1.375-.555Zm13.156 6.078c.448 0 .896-.07 1.344-.211v1.383a3.64 3.64 0 0 1-.789.219 5.18 5.18 0 0 1-.993.093c-1.739 0-2.609-.916-2.609-2.75v-4.656h-1.18v-.812l1.266-.672.625-1.828h1.133v1.921h2.461v1.391h-2.461v4.625c0 .443.109.771.328.984.224.209.516.313.875.313Zm10.742-3.008c0 1.412-.362 2.513-1.086 3.305-.724.792-1.732 1.187-3.023 1.187-.807 0-1.521-.182-2.141-.547-.62-.364-1.096-.888-1.43-1.57-.333-.682-.5-1.474-.5-2.375 0-1.401.36-2.495 1.079-3.281.718-.787 1.731-1.18 3.039-1.18 1.25 0 2.239.404 2.968 1.211.73.802 1.094 1.886 1.094 3.25Zm-6.289 0c0 1.995.737 2.992 2.211 2.992 1.458 0 2.188-.997 2.188-2.992 0-1.974-.735-2.961-2.204-2.961-.77 0-1.33.255-1.679.766-.344.51-.516 1.242-.516 2.195Zm19.844 4.336-1.141-3.172h-4.367l-1.117 3.172h-1.969l4.274-11.469h2.031l4.273 11.469h-1.984Zm-1.633-4.781-1.07-3.11a20.333 20.333 0 0 1-.328-.984c-.136-.448-.23-.776-.282-.984-.14.64-.346 1.341-.617 2.101l-1.031 2.977h3.328Zm9.313-4.016c.369 0 .674.026.914.078l-.18 1.711a3.494 3.494 0 0 0-.813-.093c-.734 0-1.33.239-1.789.718-.453.479-.679 1.102-.679 1.867v4.516h-1.836v-8.641h1.437l.242 1.524h.094a3.442 3.442 0 0 1 1.117-1.227 2.686 2.686 0 0 1 1.493-.453Zm6.937 0c1.078 0 1.917.391 2.516 1.172.604.781.906 1.878.906 3.289 0 1.417-.305 2.521-.914 3.313-.61.786-1.456 1.179-2.539 1.179-1.094 0-1.943-.393-2.547-1.179h-.125l-.336 1.023h-1.375V240.09h1.836v2.89c0 .214-.01.532-.031.954-.021.421-.037.69-.047.804h.078c.583-.859 1.443-1.289 2.578-1.289Zm-.476 1.5c-.74 0-1.274.219-1.602.656-.323.433-.49 1.159-.5 2.18v.125c0 1.052.167 1.815.5 2.289.333.469.878.703 1.633.703.651 0 1.143-.257 1.476-.773.339-.516.508-1.261.508-2.234 0-1.964-.672-2.946-2.015-2.946Zm7.867 7.297h-1.836v-8.641h1.836v8.641Zm-1.946-10.93c0-.328.089-.58.266-.757.182-.177.44-.266.773-.266.323 0 .573.089.75.266.183.177.274.429.274.757 0 .313-.091.56-.274.743-.177.177-.427.265-.75.265-.333 0-.591-.088-.773-.265-.177-.183-.266-.43-.266-.743Zm7.797 9.602c.448 0 .896-.07 1.344-.211v1.383a3.64 3.64 0 0 1-.789.219 5.176 5.176 0 0 1-.992.093c-1.74 0-2.61-.916-2.61-2.75v-4.656h-1.179v-.812l1.265-.672.625-1.828h1.133v1.921h2.461v1.391h-2.461v4.625c0 .443.109.771.328.984.224.209.516.313.875.313Zm7.461-7.469c.37 0 .675.026.914.078l-.179 1.711a3.506 3.506 0 0 0-.813-.093c-.734 0-1.331.239-1.789.718-.453.479-.68 1.102-.68 1.867v4.516h-1.836v-8.641h1.438l.242 1.524h.094a3.433 3.433 0 0 1 1.117-1.227 2.685 2.685 0 0 1 1.492-.453Zm7.93 8.797-.367-1.203h-.063c-.416.526-.836.885-1.258 1.078-.421.188-.963.281-1.625.281-.849 0-1.513-.229-1.992-.687-.474-.458-.711-1.107-.711-1.945 0-.891.331-1.563.992-2.016.662-.453 1.67-.701 3.024-.742l1.492-.047v-.461c0-.552-.13-.964-.391-1.234-.255-.277-.653-.415-1.195-.415-.443 0-.867.066-1.273.196-.407.13-.797.284-1.172.461l-.594-1.313a6.273 6.273 0 0 1 1.539-.554 6.902 6.902 0 0 1 1.578-.196c1.099 0 1.927.24 2.485.719.562.479.843 1.232.843 2.258v5.82h-1.312Zm-2.735-1.25c.667 0 1.201-.185 1.602-.555.406-.375.609-.898.609-1.57v-.75l-1.109.047c-.865.031-1.495.177-1.891.437-.39.256-.585.649-.585 1.18 0 .386.114.685.343.899.229.208.573.312 1.031.312Zm9.829-.078c.448 0 .895-.07 1.343-.211v1.383a3.64 3.64 0 0 1-.789.219 5.161 5.161 0 0 1-.992.093c-1.739 0-2.609-.916-2.609-2.75v-4.656h-1.18v-.812l1.266-.672.625-1.828h1.133v1.921h2.46v1.391h-2.46v4.625c0 .443.109.771.328.984.224.209.515.313.875.313Zm6.851 1.484c-1.344 0-2.396-.39-3.156-1.172-.755-.786-1.133-1.867-1.133-3.242 0-1.411.352-2.521 1.055-3.328.703-.807 1.669-1.211 2.898-1.211 1.141 0 2.042.347 2.703 1.039.662.693.993 1.646.993 2.86v.992h-5.758c.026.838.252 1.484.679 1.937.428.448 1.029.672 1.805.672.511 0 .984-.047 1.422-.14a7.655 7.655 0 0 0 1.422-.485v1.492a5.636 5.636 0 0 1-1.36.454 8.376 8.376 0 0 1-1.57.132Zm-.336-7.562c-.583 0-1.052.185-1.406.555-.349.369-.557.908-.625 1.617h3.922c-.011-.714-.182-1.253-.516-1.617-.333-.37-.791-.555-1.375-.555Z",
                className: "voting-module_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 87.5,
                y: 224.246,
                width: 210,
                height: 44,
                rx: 2.5,
                className: "voting-module_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M146.094 50.324h1.429l-4.117 11.422h-1.312L138 50.324h1.406l2.625 7.39c.302.85.542 1.675.719 2.477.188-.843.432-1.684.734-2.523l2.61-7.344Zm10.203 7.133c0 1.396-.352 2.487-1.055 3.273-.703.782-1.674 1.172-2.914 1.172-.766 0-1.445-.18-2.039-.539-.594-.36-1.052-.875-1.375-1.547-.323-.672-.484-1.458-.484-2.359 0-1.396.349-2.482 1.047-3.258.697-.781 1.666-1.172 2.906-1.172 1.198 0 2.148.399 2.851 1.196.709.797 1.063 1.875 1.063 3.234Zm-6.524 0c0 1.094.219 1.927.657 2.5.437.573 1.08.86 1.929.86s1.493-.284 1.93-.852c.443-.573.664-1.409.664-2.508 0-1.089-.221-1.914-.664-2.477-.437-.567-1.086-.851-1.945-.851-.849 0-1.49.279-1.922.836-.432.557-.649 1.388-.649 2.492Zm11.571 3.375c.229 0 .45-.016.664-.047.213-.036.383-.073.508-.11v.993c-.141.068-.349.122-.625.164-.271.047-.516.07-.735.07-1.656 0-2.484-.872-2.484-2.617v-5.094h-1.227v-.625l1.227-.539.547-1.828h.75v1.985h2.484v1.007h-2.484v5.04c0 .515.122.91.367 1.187.245.276.581.414 1.008.414Zm4.187.914h-1.297v-8.562h1.297v8.562Zm-1.406-10.883c0-.297.073-.513.219-.648a.757.757 0 0 1 .547-.211c.208 0 .388.07.539.21.151.142.226.358.226.65 0 .29-.075.51-.226.656a.764.764 0 0 1-.539.21.756.756 0 0 1-.547-.21c-.146-.146-.219-.365-.219-.657Zm10.016 10.883v-5.539c0-.698-.159-1.219-.477-1.563-.318-.343-.815-.515-1.492-.515-.896 0-1.552.242-1.969.727-.417.484-.625 1.283-.625 2.398v4.492h-1.297v-8.562h1.055l.211 1.172h.062a2.622 2.622 0 0 1 1.118-.977 3.594 3.594 0 0 1 1.601-.352c1.031 0 1.807.25 2.328.75.521.495.782 1.29.782 2.383v5.586h-1.297Zm10.976-8.562v.82l-1.586.187c.146.183.276.422.391.72.114.29.172.622.172.991 0 .839-.287 1.508-.86 2.008s-1.359.75-2.359.75a3.94 3.94 0 0 1-.719-.062c-.552.291-.828.659-.828 1.101 0 .235.096.41.289.524.193.109.524.164.992.164h1.516c.927 0 1.638.195 2.133.586.5.39.75.958.75 1.703 0 .948-.38 1.67-1.141 2.164-.76.5-1.87.75-3.328.75-1.12 0-1.984-.209-2.594-.625-.604-.417-.906-1.005-.906-1.766 0-.52.167-.971.5-1.351.333-.38.802-.638 1.406-.774a1.387 1.387 0 0 1-.554-.46 1.234 1.234 0 0 1-.219-.727c0-.313.083-.586.25-.82.167-.235.43-.462.789-.68a2.332 2.332 0 0 1-1.086-.93 2.751 2.751 0 0 1-.414-1.5c0-.938.281-1.659.844-2.164.562-.51 1.359-.766 2.39-.766.448 0 .852.052 1.211.157h2.961Zm-6.828 10c0 .463.195.815.586 1.054.391.24.951.36 1.68.36 1.088 0 1.893-.164 2.414-.492.526-.323.789-.764.789-1.32 0-.464-.143-.787-.43-.97-.286-.177-.825-.265-1.617-.265h-1.555c-.588 0-1.047.14-1.375.422-.328.28-.492.685-.492 1.21Zm.703-7.258c0 .599.169 1.052.508 1.36.339.306.81.46 1.414.46 1.266 0 1.898-.614 1.898-1.844 0-1.286-.64-1.93-1.921-1.93-.61 0-1.079.165-1.407.493-.328.328-.492.815-.492 1.46Zm19.43 1.531c0 1.396-.352 2.487-1.055 3.273-.703.782-1.674 1.172-2.914 1.172-.765 0-1.445-.18-2.039-.539-.594-.36-1.052-.875-1.375-1.547-.323-.672-.484-1.458-.484-2.359 0-1.396.349-2.482 1.047-3.258.697-.781 1.666-1.172 2.906-1.172 1.198 0 2.148.399 2.851 1.196.709.797 1.063 1.875 1.063 3.234Zm-6.524 0c0 1.094.219 1.927.657 2.5.437.573 1.08.86 1.929.86s1.493-.284 1.93-.852c.443-.573.664-1.409.664-2.508 0-1.089-.221-1.914-.664-2.477-.437-.567-1.086-.851-1.945-.851-.849 0-1.49.279-1.922.836-.432.557-.649 1.388-.649 2.492Zm12.79 4.445a3.777 3.777 0 0 1-1.532-.304 2.909 2.909 0 0 1-1.156-.953h-.094c.063.5.094.973.094 1.421v3.524h-1.297V53.184h1.055l.18 1.172H202c.333-.47.721-.808 1.164-1.016.443-.209.951-.313 1.524-.313 1.135 0 2.01.388 2.624 1.164.62.776.93 1.865.93 3.266 0 1.406-.315 2.5-.945 3.281-.625.776-1.495 1.164-2.609 1.164Zm-.188-7.773c-.875 0-1.508.242-1.898.727-.391.484-.592 1.255-.602 2.312v.289c0 1.203.201 2.065.602 2.586.401.516 1.044.773 1.929.773.74 0 1.318-.3 1.735-.898.422-.599.632-1.425.632-2.477 0-1.067-.21-1.885-.632-2.453-.417-.573-1.006-.86-1.766-.86Zm8.781 6.703c.229 0 .451-.016.664-.047.214-.036.383-.073.508-.11v.993c-.141.068-.349.122-.625.164-.271.047-.516.07-.734.07-1.656 0-2.485-.872-2.485-2.617v-5.094h-1.226v-.625l1.226-.539.547-1.828h.75v1.985h2.485v1.007h-2.485v5.04c0 .515.123.91.367 1.187.245.276.581.414 1.008.414Zm4.188.914h-1.297v-8.562h1.297v8.562Zm-1.407-10.883c0-.297.073-.513.219-.648a.757.757 0 0 1 .547-.211c.208 0 .388.07.539.21.151.142.227.358.227.65 0 .29-.076.51-.227.656a.764.764 0 0 1-.539.21.756.756 0 0 1-.547-.21c-.146-.146-.219-.365-.219-.657Zm11.547 6.594c0 1.396-.351 2.487-1.054 3.273-.703.782-1.675 1.172-2.914 1.172-.766 0-1.446-.18-2.039-.539-.594-.36-1.053-.875-1.375-1.547-.323-.672-.485-1.458-.485-2.359 0-1.396.349-2.482 1.047-3.258.698-.781 1.667-1.172 2.906-1.172 1.198 0 2.149.399 2.852 1.196.708.797 1.062 1.875 1.062 3.234Zm-6.523 0c0 1.094.219 1.927.656 2.5.438.573 1.081.86 1.93.86s1.492-.284 1.93-.852c.442-.573.664-1.409.664-2.508 0-1.089-.222-1.914-.664-2.477-.438-.567-1.086-.851-1.946-.851-.849 0-1.489.279-1.922.836-.432.557-.648 1.388-.648 2.492Zm14.664 4.29v-5.54c0-.698-.159-1.219-.477-1.563-.317-.343-.815-.515-1.492-.515-.896 0-1.552.242-1.969.727-.416.484-.624 1.283-.624 2.398v4.492h-1.297v-8.562h1.054l.211 1.172h.063a2.62 2.62 0 0 1 1.117-.977 3.596 3.596 0 0 1 1.602-.352c1.031 0 1.807.25 2.328.75.52.495.781 1.29.781 2.383v5.586h-1.297Zm9.492-2.337c0 .797-.297 1.412-.89 1.844-.594.432-1.428.648-2.5.648-1.136 0-2.021-.18-2.657-.539V60.16c.412.209.852.373 1.321.492.474.12.929.18 1.367.18.677 0 1.198-.107 1.562-.32.365-.219.547-.55.547-.992 0-.334-.146-.618-.437-.852-.287-.24-.849-.52-1.688-.844-.797-.297-1.364-.554-1.703-.773-.333-.224-.583-.477-.75-.758-.161-.281-.242-.617-.242-1.008 0-.698.284-1.247.851-1.648.568-.407 1.347-.61 2.336-.61.922 0 1.823.188 2.703.563l-.46 1.054c-.86-.354-1.638-.53-2.336-.53-.615 0-1.078.096-1.391.288-.313.193-.469.459-.469.797 0 .23.058.425.172.586.12.162.31.315.57.461.261.146.761.357 1.5.633 1.016.37 1.701.742 2.055 1.117.359.375.539.846.539 1.414Z",
                className: "voting-module_svg__path-5"
            })
        ]
    });
var $da101e3af3bfbbe3$export$2e2bcd8739ae039 = $da101e3af3bfbbe3$var$SvgVotingModule;



const $76975e5c9a67ab3b$var$StyledVotingModuleSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $da101e3af3bfbbe3$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="rect-4"],
  [class$="path-1"],
  [class$="path-2"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"],
  [class$="rect-3"],
  [class$="path-4"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-3"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
  }

  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="rect-1"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-5"] {
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }
`;
const $76975e5c9a67ab3b$var$VotingModule = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $76975e5c9a67ab3b$var$StyledVotingModuleSvg
    });
var $76975e5c9a67ab3b$export$2e2bcd8739ae039 = $76975e5c9a67ab3b$var$VotingModule;


const $1458f55cef0c306d$var$leftPageContents = [
    {
        title: "Binary Voting",
        paragraphs: [
            "Jurors choose one option to vote. The option which receives the majority of votes is considered the winner.",
            "Refuse to Arbitrate is used when a dispute has been posted in the wrong court, has no clear outcome, or evidence is immoral and/or illegal. In case the majority decides to Refuse to Arbitrate, that option is considered the winner."
        ]
    },
    {
        title: "Private Voting",
        paragraphs: [
            "This feature introduces the commit and reveal mechanism, enhancing the secrecy and integrity of votes.",
            "What\u2019s different? In courts with private voting, jurors cast their votes in two parts: Firstly, they vote on a chosen option. The vote is kept secret from other jurors. (Commit period). Finally, they reveal their votes adding a justification (Voting Period).",
            "Note that jurors who miss the Commit period, cannot progress to the Voting period, not being able to conclude the voting. Make sure not to miss the Commit, and the Voting periods."
        ]
    },
    {
        title: "Juror Rewards",
        paragraphs: [
            "Jurors whose vote is coherent with the final jury decision (after all the appeal instances) receive the Juror Rewards composed of arbitration fees (ETH) + PNK redistribution between jurors. Jurors whose vote is not coherent with the final jury decision, lose their locked PNK."
        ]
    }
];
const $1458f55cef0c306d$var$rightPageComponents = [
    (0, $76975e5c9a67ab3b$export$2e2bcd8739ae039),
    (0, $1017cf6192755936$export$2e2bcd8739ae039),
    (0, $0df4c11bca39010b$export$2e2bcd8739ae039)
];
const $1458f55cef0c306d$var$BinaryVoting = ({ toggleMiniGuide: toggleMiniGuide })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$2e2bcd8739ae039), {
        toggleMiniGuide: toggleMiniGuide,
        leftPageContents: $1458f55cef0c306d$var$leftPageContents,
        rightPageComponents: $1458f55cef0c306d$var$rightPageComponents,
        isOnboarding: false,
        canClose: true,
        isVisible: true
    });
};
var $1458f55cef0c306d$export$2e2bcd8739ae039 = $1458f55cef0c306d$var$BinaryVoting;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $30a2dcec41d4503b$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $30a2dcec41d4503b$var$HelpIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $1265c0970d93b919$export$2e2bcd8739ae039))`
  display: flex;
  align-items: center;
  height: 12px;
  width: 12px;
  fill: ${({ theme: theme })=>theme.secondaryText};
  margin: 0 0 0 8px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      height: 14px;
      width: 14px;
    `)}
`;
const $30a2dcec41d4503b$var$WithHelpTooltip = ({ tooltipMsg: tooltipMsg, children: children, place: place })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($30a2dcec41d4503b$var$Container, {
        children: [
            children,
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Tooltip), {
                small: true,
                text: tooltipMsg,
                place: place,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($30a2dcec41d4503b$var$HelpIcon, {})
            })
        ]
    });
var $30a2dcec41d4503b$export$2e2bcd8739ae039 = $30a2dcec41d4503b$var$WithHelpTooltip;


const $e7f4f99826629822$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 0;
    `)}
`;
const $e7f4f99826629822$var$tooltipMsg = "A Coherent Vote is a vote coherent with the final jury decision (after all the appeal instances). If the juror vote is the same as  the majority of jurors it's considered a Coherent Vote.";
const $e7f4f99826629822$var$Coherency = ({ userLevelData: userLevelData, totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes, isMiniGuide: isMiniGuide })=>{
    const votesContent = /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
        children: [
            "Coherent Votes:",
            /*#__PURE__*/ (0, $cZGFG.jsxs)("small", {
                children: [
                    " ",
                    totalCoherent,
                    "/",
                    totalResolvedDisputes,
                    " "
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($e7f4f99826629822$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                children: userLevelData.title
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    "Level ",
                    userLevelData.level
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.CircularProgress), {
                progress: parseFloat((totalCoherent / Math.max(totalResolvedDisputes, 1) * 100).toFixed(2))
            }),
            !isMiniGuide ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $30a2dcec41d4503b$export$2e2bcd8739ae039), {
                place: "left",
                tooltipMsg: $e7f4f99826629822$var$tooltipMsg,
                children: votesContent
            }) : votesContent
        ]
    });
};
var $e7f4f99826629822$export$2e2bcd8739ae039 = $e7f4f99826629822$var$Coherency;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
"use client";
/**
 * @internal
 */ const $33a9103a3e154719$var$SkeletonThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext({});
/* eslint-disable react/no-array-index-key */ const $33a9103a3e154719$var$defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function $33a9103a3e154719$var$styleOptionsToCssProperties({ baseColor: baseColor, highlightColor: highlightColor, width: width, height: height, borderRadius: borderRadius, circle: circle, direction: direction, duration: duration, enableAnimation: enableAnimation = $33a9103a3e154719$var$defaultEnableAnimation }) {
    const style = {};
    if (direction === "rtl") style["--animation-direction"] = "reverse";
    if (typeof duration === "number") style["--animation-duration"] = `${duration}s`;
    if (!enableAnimation) style["--pseudo-element-display"] = "none";
    if (typeof width === "string" || typeof width === "number") style.width = width;
    if (typeof height === "string" || typeof height === "number") style.height = height;
    if (typeof borderRadius === "string" || typeof borderRadius === "number") style.borderRadius = borderRadius;
    if (circle) style.borderRadius = "50%";
    if (typeof baseColor !== "undefined") style["--base-color"] = baseColor;
    if (typeof highlightColor !== "undefined") style["--highlight-color"] = highlightColor;
    return style;
}
function $33a9103a3e154719$export$2e2bcd8739ae039({ count: count = 1, wrapper: Wrapper, className: customClassName, containerClassName: containerClassName, containerTestId: containerTestId, circle: circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useContext($33a9103a3e154719$var$SkeletonThemeContext);
    const propsStyleOptions = {
        ...originalPropsStyleOptions
    };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions))if (typeof value === "undefined") delete propsStyleOptions[key];
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle: circle
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...$33a9103a3e154719$var$styleOptionsToCssProperties(styleOptions)
    };
    let className = "react-loading-skeleton";
    if (customClassName) className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for(let i = 0; i < countCeil; i++){
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : "100%"; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === "number" ? width * fractionalPart : `calc(${width} * ${fractionalPart})`;
            thisStyle = {
                ...thisStyle,
                width: fractionalWidth
            };
        }
        const skeletonSpan = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
            className: className,
            style: thisStyle,
            key: i
        }, "\u200C");
        if (inline) elements.push(skeletonSpan);
        else // Without the <br />, the skeleton lines will all run together if
        // `width` is specified
        elements.push((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, {
            key: i
        }, skeletonSpan, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("br", null)));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
        className: containerClassName,
        "data-testid": containerTestId,
        "aria-live": "polite",
        "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : $33a9103a3e154719$var$defaultEnableAnimation
    }, Wrapper ? elements.map((el, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(Wrapper, {
            key: i
        }, el)) : elements);
}
function $33a9103a3e154719$export$978f2619783614a7({ children: children, ...styleOptions }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($33a9103a3e154719$var$SkeletonThemeContext.Provider, {
        value: styleOptions
    }, children);
}


var $e3fc2d928bdcfc65$exports = {};
$e3fc2d928bdcfc65$exports = new URL("aristoteles.0c0b5b4e.png", import.meta.url).toString();


var $8351c19a7672a426$exports = {};
$8351c19a7672a426$exports = new URL("diogenes.842f2256.png", import.meta.url).toString();


var $22cd707990571e2c$exports = {};
$22cd707990571e2c$exports = new URL("plato.bc1c213d.png", import.meta.url).toString();


var $9ccfe19179e7ce15$exports = {};
$9ccfe19179e7ce15$exports = new URL("pythagoras.458b2b18.png", import.meta.url).toString();


var $05d3e1bbc76853f1$exports = {};
$05d3e1bbc76853f1$exports = new URL("socrates.fb416e7c.png", import.meta.url).toString();


const $b9a21c2e2f7668df$var$StyledImage = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).img`
  width: ${({ width: width })=>width};
  height: ${({ height: height })=>height};
  display: ${({ show: show })=>show ? "block" : "none"};
`;
const $b9a21c2e2f7668df$var$StyledSkeleton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $33a9103a3e154719$export$2e2bcd8739ae039))`
  width: ${({ width: width })=>width};
  height: ${({ height: height })=>height};
`;
const $b9a21c2e2f7668df$var$images = [
    (0, (/*@__PURE__*/$parcel$interopDefault($8351c19a7672a426$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9ccfe19179e7ce15$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($05d3e1bbc76853f1$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($22cd707990571e2c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e3fc2d928bdcfc65$exports)))
];
const $b9a21c2e2f7668df$var$PixelArt = ({ level: level, width: width, height: height })=>{
    const [imageLoaded, setImageLoaded] = (0, $dup7A.useState)(false);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            !imageLoaded && /*#__PURE__*/ (0, $cZGFG.jsx)($b9a21c2e2f7668df$var$StyledSkeleton, {
                width: width,
                height: height
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($b9a21c2e2f7668df$var$StyledImage, {
                src: $b9a21c2e2f7668df$var$images[level],
                alt: "Pixel Art per Level",
                onLoad: ()=>setImageLoaded(true),
                show: imageLoaded,
                width: width,
                height: height
            })
        ]
    });
};
var $b9a21c2e2f7668df$export$2e2bcd8739ae039 = $b9a21c2e2f7668df$var$PixelArt;




const $3641426bdc544c85$var$Card = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 234px;
  height: 100%;
  gap: 28px;

  padding: 24px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      width: 100%;
      height: 236px;
    `)}
`;
const $3641426bdc544c85$var$leftPageContents = [
    {
        title: "Juror Level 1: Phytagoras",
        paragraphs: [
            "Jurors are classified into distinct levels according to their performance starting from Level 1.",
            "Level 1: Jurors with 0 cases arbitrated, OR Jurors with \u2265 1 case arbitrated with 0-70% of coherent votes."
        ]
    },
    {
        title: "Juror Level 2: Socrates",
        paragraphs: [
            "Level 2: Jurors with \u2265 3 cases arbitrated with 70%-80% of coherent votes."
        ]
    },
    {
        title: "Juror Level 3: Plato",
        paragraphs: [
            "Level 3: Jurors with \u2265 7 cases arbitrated with 80%-90% of coherent votes."
        ]
    },
    {
        title: "Juror Level 4: Aristotle",
        paragraphs: [
            "Level 4: Jurors with \u2265 10 cases arbitrated with more than 90% of coherent votes."
        ]
    },
    {
        title: "Juror Level 0: Diogenes",
        paragraphs: [
            "There's a level for the low-performance/lazy jurors. Level 0: Jurors with \u2265 3 cases arbitrated with less than 50% of coherent votes."
        ]
    }
];
const $3641426bdc544c85$var$userLevelData = [
    {
        level: 1,
        title: "Phytagoras",
        totalCoherent: 6,
        totalResolvedDisputes: 10
    },
    {
        level: 2,
        title: "Socrates",
        totalCoherent: 7,
        totalResolvedDisputes: 10
    },
    {
        level: 3,
        title: "Plato",
        totalCoherent: 8,
        totalResolvedDisputes: 10
    },
    {
        level: 4,
        title: "Aristotle",
        totalCoherent: 9,
        totalResolvedDisputes: 10
    },
    {
        level: 0,
        title: "Diogenes",
        totalCoherent: 3,
        totalResolvedDisputes: 10
    }
];
const $3641426bdc544c85$var$LeftContent = ({ currentPage: currentPage })=>{
    const { title: title, paragraphs: paragraphs } = $3641426bdc544c85$var$leftPageContents[currentPage - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $8aa581884201f03c$export$a9defefbe3aca701), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$f99233281efd08a0), {
                children: title
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$4ba4e35c90a816bf), {
                children: paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: paragraph
                    }, index))
            })
        ]
    });
};
const $3641426bdc544c85$var$RightContent = ({ currentPage: currentPage })=>{
    const userData = $3641426bdc544c85$var$userLevelData[currentPage - 1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($3641426bdc544c85$var$Card, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b9a21c2e2f7668df$export$2e2bcd8739ae039), {
                level: userData.level,
                width: "189px",
                height: "189px"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e7f4f99826629822$export$2e2bcd8739ae039), {
                userLevelData: userData,
                totalCoherent: userData.totalCoherent,
                totalResolvedDisputes: userData.totalResolvedDisputes,
                isMiniGuide: true
            })
        ]
    });
};
const $3641426bdc544c85$var$JurorLevels = ({ toggleMiniGuide: toggleMiniGuide })=>{
    const [currentPage, setCurrentPage] = (0, $dup7A.useState)(1);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9db2adaee1ed50ba$export$2e2bcd8739ae039), {
        LeftContent: /*#__PURE__*/ (0, $cZGFG.jsx)($3641426bdc544c85$var$LeftContent, {
            currentPage: currentPage
        }),
        RightContent: /*#__PURE__*/ (0, $cZGFG.jsx)($3641426bdc544c85$var$RightContent, {
            currentPage: currentPage
        }),
        onClose: toggleMiniGuide,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        numPages: $3641426bdc544c85$var$leftPageContents.length,
        isOnboarding: false,
        canClose: true,
        isVisible: true
    });
};
var $3641426bdc544c85$export$2e2bcd8739ae039 = $3641426bdc544c85$var$JurorLevels;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $19a45ef3f13fe42e$var$SvgVotingModule = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 385 319",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 0.363,
                y: 0.363,
                width: 384.273,
                height: 318.273,
                rx: 1.817,
                className: "voting-module_svg__rect-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#voting-module_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24,
                        y: 25,
                        width: 335.802,
                        height: 32.699,
                        rx: 2.18,
                        className: "voting-module_svg__rect-2"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24.363,
                        y: 25.363,
                        width: 335.075,
                        height: 31.973,
                        rx: 1.817,
                        className: "voting-module_svg__rect-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M24.727 27.18c0-.803.65-1.453 1.453-1.453h106.091v31.246H26.18c-.803 0-1.453-.651-1.453-1.454V27.18Z",
                className: "voting-module_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M150.301 40.11c0 .841-.288 1.488-.863 1.942-.571.45-1.391.676-2.458.676h-.976v3.264h-.965v-8.3h2.151c2.074 0 3.111.807 3.111 2.419Zm-4.297 1.79h.868c.856 0 1.474-.139 1.857-.415.382-.277.573-.72.573-1.329 0-.548-.18-.957-.539-1.226-.36-.269-.92-.403-1.681-.403h-1.078v3.372Zm9.724 4.092-.187-.885h-.046c-.31.39-.62.654-.931.794-.306.137-.69.205-1.152.205-.617 0-1.101-.16-1.453-.477-.348-.318-.523-.77-.523-1.357 0-1.256 1.005-1.915 3.015-1.975l1.056-.035v-.386c0-.488-.106-.847-.318-1.078-.208-.235-.543-.352-1.005-.352-.518 0-1.105.159-1.76.477l-.289-.721a4.42 4.42 0 0 1 1.005-.392 4.396 4.396 0 0 1 1.101-.142c.742 0 1.29.165 1.646.494.36.33.54.857.54 1.584v4.246h-.699Zm-2.129-.664c.587 0 1.047-.16 1.38-.483.337-.321.505-.772.505-1.35v-.563l-.942.04c-.75.026-1.291.144-1.624.352-.329.204-.494.524-.494.96 0 .34.102.6.307.777.208.178.497.267.868.267Zm3.787-5.558h1.01l1.363 3.548c.299.81.484 1.395.556 1.755h.046c.049-.194.151-.523.306-.988.159-.47.674-1.908 1.544-4.315h1.011l-2.674 7.085c-.265.7-.575 1.196-.931 1.488-.352.295-.785.442-1.3.442-.288 0-.572-.032-.852-.096v-.755c.209.045.441.068.699.068.647 0 1.109-.364 1.385-1.09l.346-.886-2.509-6.256Zm14.891 6.222h-5.456v-.812l2.186-2.197c.666-.673 1.105-1.154 1.317-1.442.212-.287.371-.567.477-.84.106-.272.159-.566.159-.88 0-.442-.135-.793-.404-1.05-.268-.261-.641-.392-1.118-.392-.344 0-.672.057-.982.17-.307.114-.649.32-1.028.62l-.499-.642c.764-.636 1.597-.954 2.498-.954.779 0 1.391.2 1.833.602.443.397.665.933.665 1.607 0 .526-.148 1.046-.443 1.56-.295.516-.848 1.166-1.658 1.954l-1.816 1.776v.046h4.269v.874Zm3.792-5.07c.874 0 1.561.218 2.061.654.503.431.755 1.023.755 1.776 0 .86-.275 1.533-.824 2.021-.545.489-1.298.733-2.259.733-.935 0-1.648-.15-2.14-.449v-.908a3.3 3.3 0 0 0 .988.403 4.96 4.96 0 0 0 1.163.142c.666 0 1.183-.157 1.55-.471.371-.314.557-.769.557-1.363 0-1.158-.71-1.737-2.129-1.737-.36 0-.841.055-1.442.165l-.489-.313.313-3.883h4.127v.869h-3.321l-.21 2.492c.435-.087.868-.13 1.3-.13Zm9.56.909c0 1.434-.227 2.505-.681 3.213-.451.708-1.141 1.062-2.072 1.062-.894 0-1.573-.362-2.039-1.085-.465-.726-.698-1.79-.698-3.19 0-1.446.225-2.519.676-3.219.45-.7 1.137-1.05 2.061-1.05.9 0 1.583.365 2.049 1.096.469.73.704 1.788.704 3.173Zm-4.536 0c0 1.207.142 2.087.426 2.64.284.549.736.823 1.357.823.628 0 1.082-.278 1.362-.835.284-.56.426-1.436.426-2.628 0-1.192-.142-2.065-.426-2.617-.28-.556-.734-.835-1.362-.835-.621 0-1.073.275-1.357.824-.284.544-.426 1.42-.426 2.628ZM197 41.763c0 1.37-.373 2.418-1.119 3.145-.741.723-1.811 1.084-3.207 1.084h-2.299v-8.3h2.543c1.291 0 2.294.358 3.009 1.073.715.716 1.073 1.715 1.073 2.998Zm-1.022.034c0-1.082-.273-1.898-.818-2.447-.541-.549-1.347-.823-2.418-.823h-1.402v6.63h1.175c1.151 0 2.015-.281 2.594-.845.579-.568.869-1.406.869-2.515Zm8.095 4.195-1.033-2.64h-3.327l-1.021 2.64h-.977l3.281-8.334h.812l3.264 8.334h-.999Zm-1.334-3.508-.965-2.572a13.927 13.927 0 0 1-.386-1.198c-.083.364-.202.763-.358 1.198l-.976 2.572h2.685Zm3.475 3.508v-8.3h.965v8.3h-.965Z",
                className: "voting-module_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M63.307 45.992h-1.334v-5.359c0-.64.016-1.147.046-1.521-.087.09-.195.19-.324.3-.125.11-.549.459-1.272 1.045l-.67-.846 2.442-1.918h1.112v8.3Zm7.386-1.788c0 .613-.223 1.084-.67 1.413-.446.326-1.086.489-1.918.489-.837 0-1.509-.127-2.016-.38v-1.153c.738.34 1.425.51 2.06.51.822 0 1.233-.247 1.233-.743a.589.589 0 0 0-.136-.397c-.091-.106-.24-.216-.449-.33a7.727 7.727 0 0 0-.868-.386c-.723-.28-1.213-.56-1.47-.84-.254-.28-.381-.643-.381-1.09 0-.537.215-.953.647-1.249.435-.299 1.026-.448 1.771-.448.738 0 1.436.15 2.095.448l-.431 1.005c-.678-.28-1.248-.42-1.71-.42-.703 0-1.055.2-1.055.602 0 .197.09.363.272.5.186.136.587.323 1.204.562.518.2.895.384 1.13.55.234.167.408.36.522.58.113.215.17.474.17.777Zm3.787.823c.325 0 .65-.051.976-.153v1.005a2.593 2.593 0 0 1-.573.159 3.73 3.73 0 0 1-.721.068c-1.264 0-1.896-.666-1.896-1.999v-3.383h-.858v-.59l.92-.489.454-1.328h.823v1.397h1.789v1.01h-1.789v3.36c0 .322.08.56.239.716.163.151.375.227.636.227Z",
                className: "voting-module_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M40.76 41.712a1.476 1.476 0 1 0-2.954 0 1.476 1.476 0 1 0 2.954 0Zm-1.477-2.134a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm5.837-5.086a1.476 1.476 0 1 0-2.954 0 1.476 1.476 0 1 0 2.954 0Zm-1.477-2.134a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Z",
                className: "voting-module_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#voting-module_svg__b)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24,
                        y: 69.625,
                        width: 335.802,
                        height: 32.699,
                        rx: 2.18,
                        className: "voting-module_svg__rect-4"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24.363,
                        y: 69.988,
                        width: 335.075,
                        height: 31.973,
                        rx: 1.817,
                        className: "voting-module_svg__rect-5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M24.727 71.805c0-.803.65-1.453 1.453-1.453h106.091v31.246H26.18a1.454 1.454 0 0 1-1.453-1.454v-28.34Z",
                className: "voting-module_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M150.301 84.736c0 .84-.288 1.487-.863 1.941-.571.45-1.391.676-2.458.676h-.976v3.264h-.965v-8.3h2.151c2.074 0 3.111.807 3.111 2.419Zm-4.297 1.788h.868c.856 0 1.474-.138 1.857-.414.382-.277.573-.72.573-1.329 0-.549-.18-.957-.539-1.226-.36-.269-.92-.403-1.681-.403h-1.078v3.372Zm9.724 4.093-.187-.885h-.046c-.31.39-.62.654-.931.794-.306.137-.69.205-1.152.205-.617 0-1.101-.16-1.453-.477-.348-.318-.523-.77-.523-1.357 0-1.256 1.005-1.915 3.015-1.976l1.056-.034v-.386c0-.488-.106-.847-.318-1.078-.208-.235-.543-.352-1.005-.352-.518 0-1.105.159-1.76.477l-.289-.721a4.42 4.42 0 0 1 1.005-.392 4.396 4.396 0 0 1 1.101-.142c.742 0 1.29.165 1.646.494.36.33.54.857.54 1.584v4.246h-.699Zm-2.129-.664c.587 0 1.047-.16 1.38-.483.337-.321.505-.772.505-1.35v-.563l-.942.04c-.75.027-1.291.144-1.624.352-.329.204-.494.524-.494.96 0 .34.102.6.307.777.208.178.497.267.868.267Zm3.787-5.558h1.01l1.363 3.548c.299.81.484 1.395.556 1.755h.046c.049-.194.151-.523.306-.988.159-.47.674-1.908 1.544-4.315h1.011l-2.674 7.085c-.265.7-.575 1.196-.931 1.487-.352.296-.785.443-1.3.443-.288 0-.572-.032-.852-.096v-.755c.209.045.441.068.699.068.647 0 1.109-.364 1.385-1.09l.346-.886-2.509-6.256Zm12.926 6.222h-.919v-5.915c0-.492.015-.958.045-1.397-.079.08-.168.163-.267.25-.098.087-.548.456-1.351 1.107l-.499-.647 2.197-1.698h.794v8.3Zm8.618-4.757c0 3.247-1.256 4.87-3.769 4.87-.44 0-.788-.037-1.045-.113v-.812c.303.099.647.148 1.033.148.908 0 1.593-.28 2.055-.84.466-.564.719-1.427.761-2.589h-.068a2.044 2.044 0 0 1-.829.721 2.69 2.69 0 0 1-1.164.244c-.734 0-1.317-.22-1.748-.658-.432-.44-.647-1.053-.647-1.84 0-.863.24-1.544.72-2.043.485-.5 1.121-.75 1.908-.75.564 0 1.056.146 1.476.437.424.288.749.71.976 1.266.227.553.341 1.206.341 1.959Zm-2.793-2.856c-.541 0-.959.174-1.255.523-.295.348-.442.832-.442 1.453 0 .545.136.974.408 1.289.273.31.687.465 1.244.465.344 0 .66-.07.948-.21.291-.14.52-.331.686-.573a1.32 1.32 0 0 0 .25-.761c0-.397-.077-.764-.232-1.101a1.919 1.919 0 0 0-.653-.795 1.628 1.628 0 0 0-.954-.29Zm9.492 3.452c0 1.434-.227 2.505-.681 3.213-.451.708-1.141 1.062-2.072 1.062-.894 0-1.573-.362-2.039-1.085-.465-.726-.698-1.79-.698-3.19 0-1.446.225-2.519.676-3.219.45-.7 1.137-1.05 2.061-1.05.9 0 1.583.365 2.049 1.096.469.73.704 1.788.704 3.173Zm-4.536 0c0 1.207.142 2.087.426 2.64.284.548.736.823 1.357.823.628 0 1.082-.278 1.362-.835.284-.56.426-1.436.426-2.628 0-1.192-.142-2.065-.426-2.617-.28-.556-.734-.835-1.362-.835-.621 0-1.073.275-1.357.823-.284.546-.426 1.422-.426 2.629ZM197 86.388c0 1.37-.373 2.418-1.119 3.145-.741.723-1.811 1.084-3.207 1.084h-2.299v-8.3h2.543c1.291 0 2.294.358 3.009 1.073.715.716 1.073 1.715 1.073 2.998Zm-1.022.034c0-1.082-.273-1.898-.818-2.447-.541-.549-1.347-.823-2.418-.823h-1.402v6.63h1.175c1.151 0 2.015-.281 2.594-.845.579-.568.869-1.406.869-2.515Zm8.095 4.195-1.033-2.64h-3.327l-1.021 2.64h-.977l3.281-8.334h.812l3.264 8.334h-.999Zm-1.334-3.508-.965-2.572a13.927 13.927 0 0 1-.386-1.198c-.083.364-.202.763-.358 1.198l-.976 2.572h2.685Zm3.475 3.508v-8.3h.965v8.3h-.965Z",
                className: "voting-module_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M65.016 90.617H59.39v-1.01l2.14-2.152c.633-.647 1.05-1.105 1.255-1.374a3.29 3.29 0 0 0 .454-.766c.095-.239.142-.494.142-.766 0-.375-.113-.67-.34-.886-.224-.216-.534-.324-.931-.324-.318 0-.627.059-.926.176-.295.118-.637.33-1.027.636l-.721-.88c.462-.39.91-.666 1.345-.829a3.937 3.937 0 0 1 1.391-.244c.772 0 1.39.203 1.856.608.466.4.699.942.699 1.623 0 .375-.069.73-.205 1.068a4.264 4.264 0 0 1-.619 1.044c-.276.356-.737.838-1.385 1.448l-1.442 1.396v.057h3.94v1.175Zm6.983 0h-1.34v-3.86c0-.485-.098-.846-.295-1.084-.193-.239-.502-.358-.925-.358-.564 0-.977.166-1.238.5-.261.332-.392.89-.392 1.674v3.128h-1.334v-6.279h1.045l.187.824h.068c.19-.3.458-.53.806-.693a2.702 2.702 0 0 1 1.158-.244c1.507 0 2.26.766 2.26 2.3v4.092Zm3.974.114c-.784 0-1.395-.284-1.834-.852-.439-.568-.658-1.364-.658-2.39 0-1.03.22-1.83.664-2.401.446-.575 1.063-.863 1.85-.863.825 0 1.454.305 1.885.914h.068a8.003 8.003 0 0 1-.096-1.067v-2.288h1.34v8.833h-1.045l-.233-.823h-.062c-.428.624-1.054.937-1.88.937Zm.357-1.079c.55 0 .948-.153 1.198-.46.25-.31.379-.811.386-1.504V87.5c0-.79-.128-1.353-.386-1.686-.257-.333-.66-.5-1.209-.5-.47 0-.83.192-1.084.574-.254.379-.38.92-.38 1.624 0 .696.122 1.228.368 1.595.246.363.615.545 1.107.545Z",
                className: "voting-module_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M40.76 86.34a1.476 1.476 0 1 0-2.953 0 1.476 1.476 0 1 0 2.953 0Zm-1.477-2.133a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.954 1.476 1.476 0 1 1 0 2.954Zm5.837-5.087a1.476 1.476 0 1 0-2.954 0 1.476 1.476 0 1 0 2.954 0Zm-1.477-2.133a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Z",
                className: "voting-module_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 12.363,
                y: 13.363,
                width: 359.273,
                height: 99.273,
                rx: 1.817,
                className: "voting-module_svg__rect-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M150.828 148.954v5.371c0 .946-.286 1.689-.857 2.231-.572.541-1.357.811-2.356.811-.999 0-1.773-.272-2.322-.817-.545-.545-.817-1.294-.817-2.248v-5.348h.965v5.416c0 .693.189 1.224.567 1.595.379.371.935.557 1.669.557.701 0 1.24-.186 1.618-.557.379-.374.568-.91.568-1.606v-5.405h.965Zm6.319 8.3v-4.025c0-.507-.116-.886-.347-1.135-.231-.25-.592-.375-1.084-.375-.651 0-1.128.176-1.431.528-.302.352-.454.933-.454 1.743v3.264h-.942v-6.222h.766l.153.851h.046c.193-.306.464-.543.812-.709.348-.17.736-.256 1.163-.256.75 0 1.314.182 1.692.545.379.36.568.937.568 1.732v4.059h-.942Zm5.722-6.336c.276 0 .524.023.744.069l-.131.874a3.188 3.188 0 0 0-.681-.085c-.504 0-.935.204-1.295.613-.355.408-.533.918-.533 1.527v3.338h-.943v-6.222h.778l.108 1.152h.045c.231-.405.509-.717.835-.936.325-.22.683-.33 1.073-.33Zm5.734 6.336-.188-.886h-.045c-.31.39-.621.655-.931.795-.307.136-.691.204-1.153.204-.616 0-1.101-.159-1.453-.476-.348-.318-.522-.771-.522-1.357 0-1.257 1.005-1.915 3.014-1.976l1.056-.034v-.386c0-.488-.106-.848-.318-1.079-.208-.234-.543-.351-1.004-.351-.519 0-1.106.158-1.76.476l-.29-.721a4.45 4.45 0 0 1 1.005-.391 4.377 4.377 0 0 1 1.101-.142c.742 0 1.291.164 1.647.494.359.329.539.857.539 1.584v4.246h-.698Zm-2.129-.664c.586 0 1.046-.161 1.379-.483.337-.322.506-.772.506-1.351v-.562l-.943.04c-.749.026-1.29.144-1.623.352-.33.204-.494.524-.494.959 0 .341.102.6.306.778.208.178.498.267.869.267Zm9.032.664v-4.025c0-.507-.116-.886-.346-1.135-.231-.25-.593-.375-1.085-.375-.651 0-1.128.176-1.43.528-.303.352-.455.933-.455 1.743v3.264h-.942v-6.222h.767l.153.851h.045c.193-.306.464-.543.812-.709.348-.17.736-.256 1.164-.256.749 0 1.313.182 1.692.545.378.36.567.937.567 1.732v4.059h-.942Zm3.815-3.185c.163-.231.41-.534.743-.908l2.01-2.129h1.118l-2.52 2.651 2.696 3.571h-1.141l-2.197-2.941-.709.613v2.328h-.931v-8.833h.931v4.683c0 .208-.015.53-.046.965h.046Zm7.806 3.298c-.92 0-1.647-.28-2.18-.84-.53-.56-.795-1.338-.795-2.333 0-1.003.246-1.8.738-2.39.496-.59 1.16-.886 1.992-.886.78 0 1.397.258 1.851.772.454.511.681 1.187.681 2.027v.596h-4.286c.019.731.203 1.285.551 1.664.352.378.846.567 1.482.567.67 0 1.332-.14 1.987-.42v.84a4.836 4.836 0 0 1-.948.307 5.152 5.152 0 0 1-1.073.096Zm-.256-5.659c-.499 0-.899.162-1.198.488-.295.325-.469.776-.522 1.351h3.253c0-.594-.133-1.048-.397-1.363-.265-.318-.644-.476-1.136-.476Zm8.391 4.711h-.051c-.436.632-1.087.948-1.953.948-.814 0-1.448-.278-1.902-.834-.45-.556-.676-1.347-.676-2.373 0-1.026.227-1.822.682-2.39.454-.568 1.086-.852 1.896-.852.844 0 1.491.307 1.941.92h.074l-.04-.448-.022-.438v-2.531h.942v8.833h-.766l-.125-.835Zm-1.885.159c.643 0 1.109-.174 1.396-.522.292-.352.438-.918.438-1.697v-.199c0-.882-.148-1.51-.443-1.885-.292-.378-.759-.567-1.402-.567-.553 0-.977.215-1.272.647-.291.427-.437 1.033-.437 1.816 0 .795.146 1.395.437 1.8.291.405.719.607 1.283.607Zm13.17-2.441c0 1.015-.255 1.807-.766 2.379-.511.568-1.217.851-2.117.851-.557 0-1.051-.13-1.482-.391a2.578 2.578 0 0 1-.999-1.124c-.235-.489-.352-1.06-.352-1.715 0-1.014.253-1.803.76-2.367.508-.568 1.212-.852 2.112-.852.871 0 1.561.29 2.072.869.515.579.772 1.362.772 2.35Zm-4.74 0c0 .795.159 1.401.477 1.817.318.416.785.624 1.402.624.617 0 1.085-.206 1.403-.618.321-.417.482-1.024.482-1.823 0-.791-.161-1.391-.482-1.799-.318-.413-.79-.619-1.414-.619-.617 0-1.082.202-1.397.607-.314.405-.471 1.009-.471 1.811Zm9.293 3.23c-.405 0-.775-.073-1.112-.221a2.106 2.106 0 0 1-.84-.693h-.069c.046.364.069.708.069 1.034v2.56h-.943v-9.015h.767l.13.851h.046c.242-.34.524-.586.845-.738a2.579 2.579 0 0 1 1.107-.227c.825 0 1.461.282 1.908.846.45.564.675 1.355.675 2.373 0 1.022-.229 1.817-.686 2.385-.455.563-1.087.845-1.897.845Zm-.136-5.648c-.636 0-1.095.176-1.379.528-.284.352-.43.912-.437 1.68v.21c0 .875.145 1.501.437 1.879.291.375.758.562 1.402.562.537 0 .957-.217 1.26-.653.307-.435.46-1.035.46-1.799 0-.776-.153-1.37-.46-1.783-.303-.416-.73-.624-1.283-.624Zm6.381 4.871c.167 0 .327-.012.483-.034.155-.027.278-.053.369-.08v.721a1.68 1.68 0 0 1-.455.119 3.147 3.147 0 0 1-.533.051c-1.204 0-1.805-.633-1.805-1.901v-3.702h-.892v-.454l.892-.392.397-1.328h.545v1.442h1.805v.732h-1.805v3.662c0 .375.089.662.267.863.178.2.422.301.732.301Zm3.043.664h-.942v-6.222h.942v6.222Zm-1.022-7.908c0-.216.053-.373.159-.471a.55.55 0 0 1 .397-.154c.152 0 .282.052.392.154.11.102.165.259.165.471 0 .212-.055.371-.165.477a.556.556 0 0 1-.392.153.55.55 0 0 1-.397-.153c-.106-.106-.159-.265-.159-.477Zm8.391 4.791c0 1.015-.256 1.807-.767 2.379-.511.568-1.217.851-2.117.851-.557 0-1.05-.13-1.482-.391a2.59 2.59 0 0 1-.999-1.124c-.235-.489-.352-1.06-.352-1.715 0-1.014.254-1.803.761-2.367.507-.568 1.211-.852 2.111-.852.871 0 1.562.29 2.073.869.514.579.772 1.362.772 2.35Zm-4.741 0c0 .795.159 1.401.477 1.817.318.416.786.624 1.402.624.617 0 1.085-.206 1.403-.618.321-.417.482-1.024.482-1.823 0-.791-.161-1.391-.482-1.799-.318-.413-.789-.619-1.414-.619-.617 0-1.082.202-1.396.607-.315.405-.472 1.009-.472 1.811Zm10.656 3.117v-4.025c0-.507-.115-.886-.346-1.135-.231-.25-.593-.375-1.085-.375-.651 0-1.127.176-1.43.528-.303.352-.454.933-.454 1.743v3.264h-.943v-6.222h.767l.153.851h.045c.193-.306.464-.543.812-.709.348-.17.736-.256 1.164-.256.749 0 1.313.182 1.692.545.378.36.567.937.567 1.732v4.059h-.942Zm6.898-1.698c0 .58-.216 1.026-.648 1.34-.431.314-1.037.471-1.816.471-.825 0-1.469-.13-1.93-.391v-.875c.299.152.618.271.959.358.344.087.676.131.993.131.492 0 .871-.078 1.136-.233.265-.159.397-.399.397-.721 0-.242-.106-.449-.318-.619-.208-.174-.617-.378-1.226-.613-.579-.216-.991-.403-1.237-.562a1.739 1.739 0 0 1-.545-.551 1.438 1.438 0 0 1-.176-.732c0-.507.206-.906.618-1.198.413-.295.979-.443 1.698-.443.67 0 1.324.137 1.964.409l-.335.767c-.624-.258-1.19-.386-1.697-.386-.447 0-.784.07-1.011.21-.227.14-.341.333-.341.579 0 .166.042.308.125.425.087.118.226.229.415.335.189.106.552.26 1.09.46.738.269 1.235.539 1.493.812.261.272.392.615.392 1.027Z",
                className: "voting-module_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 12.363,
                y: 124.988,
                width: 359.273,
                height: 56.273,
                rx: 1.817,
                className: "voting-module_svg__rect-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#voting-module_svg__c)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24,
                        y: 205,
                        width: 334.529,
                        height: 32.699,
                        rx: 2.18,
                        className: "voting-module_svg__rect-8"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 24.363,
                        y: 205.363,
                        width: 333.802,
                        height: 31.973,
                        rx: 1.817,
                        className: "voting-module_svg__rect-9"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M24.727 207.18c0-.803.65-1.453 1.453-1.453h106.091v31.246H26.18a1.454 1.454 0 0 1-1.453-1.454V207.18Z",
                className: "voting-module_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M150.301 220.115c0 .84-.288 1.487-.863 1.941-.571.451-1.391.676-2.458.676h-.976v3.264h-.965v-8.3h2.151c2.074 0 3.111.807 3.111 2.419Zm-4.297 1.788h.868c.856 0 1.474-.138 1.857-.414.382-.277.573-.719.573-1.329 0-.549-.18-.957-.539-1.226-.36-.269-.92-.403-1.681-.403h-1.078v3.372Zm9.724 4.093-.187-.886h-.046c-.31.39-.62.655-.931.795-.306.137-.69.205-1.152.205-.617 0-1.101-.159-1.453-.477-.348-.318-.523-.77-.523-1.357 0-1.257 1.005-1.915 3.015-1.976l1.056-.034v-.386c0-.488-.106-.847-.318-1.078-.208-.235-.543-.352-1.005-.352-.518 0-1.105.159-1.76.477l-.289-.721a4.37 4.37 0 0 1 1.005-.392 4.377 4.377 0 0 1 1.101-.142c.742 0 1.29.165 1.646.494.36.329.54.857.54 1.584v4.246h-.699Zm-2.129-.664c.587 0 1.047-.161 1.38-.483.337-.321.505-.772.505-1.351v-.562l-.942.04c-.75.026-1.291.144-1.624.352-.329.204-.494.524-.494.959 0 .341.102.6.307.778.208.178.497.267.868.267Zm3.787-5.558h1.01l1.363 3.548c.299.81.484 1.395.556 1.754h.046c.049-.193.151-.522.306-.987.159-.47.674-1.908 1.544-4.315h1.011l-2.674 7.085c-.265.7-.575 1.196-.931 1.487-.352.296-.785.443-1.3.443-.288 0-.572-.032-.852-.096v-.755c.209.045.441.068.699.068.647 0 1.109-.364 1.385-1.09l.346-.886-2.509-6.256Zm12.926 6.222h-.919v-5.915c0-.492.015-.958.045-1.397-.079.08-.168.163-.267.25-.098.087-.548.456-1.351 1.107l-.499-.647 2.197-1.698h.794v8.3Zm5.757-5.069c.874 0 1.561.217 2.061.652.503.432.755 1.024.755 1.777 0 .859-.275 1.533-.824 2.021-.545.489-1.298.733-2.259.733-.935 0-1.648-.15-2.14-.449v-.908c.265.17.594.305.988.403.393.095.781.142 1.163.142.666 0 1.183-.157 1.55-.471.371-.314.557-.769.557-1.363 0-1.158-.71-1.737-2.129-1.737-.36 0-.841.055-1.442.165l-.489-.313.313-3.883h4.127v.869h-3.321l-.21 2.492c.435-.087.868-.13 1.3-.13Zm9.56.908c0 1.434-.227 2.505-.681 3.213-.451.708-1.141 1.062-2.072 1.062-.894 0-1.573-.362-2.039-1.085-.465-.726-.698-1.79-.698-3.19 0-1.446.225-2.519.676-3.219.45-.7 1.137-1.05 2.061-1.05.9 0 1.583.365 2.049 1.095.469.731.704 1.789.704 3.174Zm-4.536 0c0 1.207.142 2.087.426 2.64.284.548.736.823 1.357.823.628 0 1.082-.278 1.362-.835.284-.56.426-1.436.426-2.628 0-1.192-.142-2.065-.426-2.617-.28-.557-.734-.835-1.362-.835-.621 0-1.073.275-1.357.823-.284.545-.426 1.422-.426 2.629Zm15.907-.068c0 1.37-.373 2.418-1.119 3.145-.741.723-1.811 1.084-3.207 1.084h-2.299v-8.3h2.543c1.291 0 2.294.358 3.009 1.073.715.716 1.073 1.715 1.073 2.998Zm-1.022.034c0-1.083-.273-1.898-.818-2.447-.541-.549-1.347-.823-2.418-.823h-1.402v6.631h1.175c1.151 0 2.015-.282 2.594-.846.579-.568.869-1.406.869-2.515Zm8.095 4.195-1.033-2.64h-3.327l-1.021 2.64h-.977l3.281-8.334h.812l3.264 8.334h-.999Zm-1.334-3.508-.965-2.572a13.885 13.885 0 0 1-.386-1.198c-.083.364-.202.763-.358 1.198l-.976 2.572h2.685Zm3.475 3.508v-8.3h.965v8.3h-.965Z",
                className: "voting-module_svg__path-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M61.332 221.557h.942c.632 0 1.09-.118 1.374-.352.284-.235.426-.583.426-1.045 0-.469-.154-.806-.46-1.01-.307-.205-.768-.307-1.385-.307h-.897v2.714Zm0 1.124v3.315h-1.357v-8.3h2.345c1.07 0 1.864.201 2.378.602.515.401.772 1.007.772 1.817 0 1.033-.537 1.769-1.612 2.208l2.345 3.673h-1.544l-1.987-3.315h-1.34Zm8.68 3.429c-.977 0-1.741-.284-2.294-.852-.548-.571-.823-1.357-.823-2.356 0-1.025.256-1.832.767-2.418.51-.587 1.213-.88 2.106-.88.829 0 1.483.252 1.964.755.48.503.721 1.196.721 2.078v.721h-4.184c.019.609.184 1.078.494 1.407.31.326.747.489 1.311.489.371 0 .716-.034 1.034-.102.321-.072.666-.19 1.033-.352v1.084a4.089 4.089 0 0 1-.988.329 6.083 6.083 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.765.135-1.022.403-.254.269-.405.661-.454 1.176h2.85c-.008-.519-.133-.911-.375-1.176-.242-.268-.575-.403-1-.403Zm3.56 8.175c-.402 0-.735-.047-1-.142v-1.056c.257.068.52.103.79.103.567 0 .85-.322.85-.966v-7.011h1.335v7.102c0 .647-.17 1.138-.511 1.471-.337.333-.825.499-1.465.499Zm.561-10.735c0-.238.065-.422.193-.551.133-.128.32-.193.562-.193.235 0 .417.065.545.193.133.129.199.313.199.551 0 .227-.066.407-.199.539-.128.129-.31.193-.545.193-.242 0-.43-.064-.562-.193-.128-.132-.193-.312-.193-.539Zm6.069 8.056c-.977 0-1.741-.284-2.293-.852-.55-.571-.824-1.357-.824-2.356 0-1.025.256-1.832.767-2.418.51-.587 1.213-.88 2.106-.88.829 0 1.483.252 1.964.755.48.503.721 1.196.721 2.078v.721h-4.184c.02.609.184 1.078.494 1.407.31.326.748.489 1.311.489.371 0 .716-.034 1.034-.102.321-.072.666-.19 1.033-.352v1.084a4.088 4.088 0 0 1-.988.329 6.082 6.082 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.765.135-1.022.403-.254.269-.405.661-.454 1.176h2.85c-.008-.519-.133-.911-.375-1.176-.242-.268-.575-.403-1-.403Zm6.733 5.496c-.95 0-1.673-.277-2.169-.829-.492-.557-.738-1.353-.738-2.39 0-1.056.257-1.868.772-2.436.519-.567 1.266-.851 2.243-.851.662 0 1.258.123 1.788.369l-.403 1.073c-.564-.22-1.03-.329-1.397-.329-1.086 0-1.629.72-1.629 2.162 0 .704.134 1.234.403 1.59.273.352.67.528 1.192.528.594 0 1.156-.148 1.686-.443v1.164c-.238.14-.494.24-.766.301-.269.06-.596.091-.982.091Zm5.563-1.079c.326 0 .651-.051.977-.153v1.005a2.637 2.637 0 0 1-.574.159 3.76 3.76 0 0 1-.72.068c-1.265 0-1.897-.666-1.897-1.999v-3.383h-.857v-.591l.92-.488.454-1.328h.823v1.396h1.788v1.011h-1.788v3.361c0 .321.08.56.238.715.163.151.375.227.636.227Z",
                className: "voting-module_svg__path-12"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M40.76 221.712a1.476 1.476 0 1 0-2.954 0c0 .816.66 1.476 1.477 1.476.816 0 1.477-.66 1.477-1.476Zm-1.477-2.134a1.475 1.475 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.953 1.475 1.475 0 1 1 0 2.953Zm5.837-5.086a1.476 1.476 0 1 0-2.954 0c0 .816.66 1.476 1.477 1.476.816 0 1.477-.66 1.477-1.476Zm-1.477-2.134a1.475 1.475 0 1 1 0-2.953 1.476 1.476 0 1 1 0 2.953Zm0 7.22a1.476 1.476 0 1 1 0-2.953 1.475 1.475 0 1 1 0 2.953Z",
                className: "voting-module_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 12.363,
                y: 193.617,
                width: 359.273,
                height: 55.273,
                rx: 1.817,
                className: "voting-module_svg__rect-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 1,
                y: 260,
                width: 383,
                height: 58,
                rx: 2.18,
                className: "voting-module_svg__rect-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 299.078,
                y: 272.684,
                width: 72.506,
                height: 32.699,
                rx: 2.18,
                className: "voting-module_svg__rect-12"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M328.348 284.735h1.408l-2.906 8.3h-1.431l-2.895-8.3h1.396l1.732 5.161c.091.246.187.564.289.954.102.386.169.673.199.862.049-.287.125-.62.227-.999.102-.378.185-.658.25-.84l1.731-5.138Zm7.931 5.149c0 1.026-.263 1.827-.789 2.402-.526.575-1.259.863-2.197.863-.587 0-1.105-.133-1.556-.398a2.622 2.622 0 0 1-1.038-1.141c-.243-.496-.364-1.071-.364-1.726 0-1.018.261-1.812.784-2.384.522-.571 1.258-.857 2.208-.857.908 0 1.627.293 2.157.88.53.583.795 1.37.795 2.361Zm-4.57 0c0 1.45.536 2.175 1.607 2.175 1.059 0 1.589-.725 1.589-2.175 0-1.434-.533-2.151-1.601-2.151-.56 0-.967.185-1.22.556-.25.371-.375.903-.375 1.595Zm8.447 2.186c.326 0 .651-.051.977-.153v1.005a2.645 2.645 0 0 1-.574.159c-.23.045-.471.068-.721.068-1.264 0-1.896-.666-1.896-1.999v-3.383h-.857v-.59l.92-.489.454-1.328h.823v1.396h1.788v1.011h-1.788v3.361c0 .321.08.56.239.715.162.151.374.227.635.227Zm4.979 1.079c-.976 0-1.741-.284-2.293-.852-.549-.571-.824-1.357-.824-2.356 0-1.025.256-1.832.767-2.418.511-.587 1.213-.88 2.106-.88.829 0 1.484.252 1.964.755.481.503.721 1.196.721 2.078v.721h-4.184c.019.609.184 1.078.494 1.408.31.325.748.488 1.311.488.371 0 .716-.034 1.034-.102.321-.072.666-.19 1.033-.352v1.084a4.098 4.098 0 0 1-.988.329 5.996 5.996 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.765.135-1.022.403-.253.269-.405.661-.454 1.176h2.85c-.008-.519-.133-.911-.375-1.176-.242-.268-.575-.403-.999-.403Z",
                className: "voting-module_svg__path-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 129.363,
                y: 273.047,
                width: 152.779,
                height: 31.973,
                rx: 1.817,
                className: "voting-module_svg__rect-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M154.887 288.596h.943c.632 0 1.09-.118 1.373-.352.284-.235.426-.583.426-1.045 0-.469-.153-.806-.46-1.01-.306-.205-.768-.307-1.385-.307h-.897v2.714Zm0 1.124v3.315h-1.357v-8.3h2.345c1.071 0 1.864.201 2.379.602.514.401.772 1.007.772 1.817 0 1.033-.538 1.769-1.613 2.208l2.345 3.673h-1.544l-1.987-3.315h-1.34Zm8.68 3.429c-.976 0-1.741-.284-2.293-.852-.549-.571-.823-1.357-.823-2.356 0-1.025.255-1.832.766-2.418.511-.587 1.213-.88 2.106-.88.829 0 1.484.252 1.964.755.481.503.721 1.196.721 2.078v.721h-4.184c.019.609.184 1.078.494 1.408.311.325.748.488 1.312.488.371 0 .715-.034 1.033-.102.322-.072.666-.19 1.033-.352v1.084a4.083 4.083 0 0 1-.988.329 5.996 5.996 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.764.135-1.022.403-.253.269-.405.661-.454 1.176h2.85c-.008-.519-.132-.911-.375-1.176-.242-.268-.575-.403-.999-.403Zm7.352.114h-1.533v5.268h-1.34v-5.268h-1.033v-.625l1.033-.408v-.409c0-.742.174-1.291.523-1.646.348-.36.88-.54 1.595-.54.469 0 .931.078 1.385.233l-.352 1.011a3.071 3.071 0 0 0-.942-.159c-.303 0-.525.094-.665.284-.136.185-.204.465-.204.84v.408h1.533v1.011Zm5.501 5.268-.188-.823h-.068c-.185.291-.45.52-.794.687a2.64 2.64 0 0 1-1.17.25c-.761 0-1.328-.19-1.703-.568-.375-.378-.562-.952-.562-1.72v-4.105h1.345v3.872c0 .481.099.842.296 1.084.196.239.505.358.925.358.56 0 .971-.166 1.232-.5.265-.336.397-.898.397-1.686v-3.128h1.34v6.279h-1.05Zm7.17-1.788c0 .613-.223 1.084-.67 1.413-.447.326-1.086.489-1.919.489-.836 0-1.508-.127-2.015-.381v-1.152c.738.341 1.425.511 2.061.511.821 0 1.231-.248 1.231-.744a.587.587 0 0 0-.136-.397 1.603 1.603 0 0 0-.448-.329 7.635 7.635 0 0 0-.869-.387c-.723-.28-1.213-.56-1.47-.84-.254-.28-.381-.643-.381-1.09 0-.537.216-.953.648-1.249.435-.299 1.025-.448 1.771-.448a5.01 5.01 0 0 1 2.095.448l-.432 1.005c-.677-.28-1.247-.42-1.709-.42-.704 0-1.055.201-1.055.602 0 .197.09.363.272.499.185.137.587.324 1.204.562.518.201.895.385 1.129.551.235.167.409.36.523.579.113.216.17.475.17.778Zm4.189 1.902c-.976 0-1.741-.284-2.293-.852-.549-.571-.823-1.357-.823-2.356 0-1.025.255-1.832.766-2.418.511-.587 1.213-.88 2.106-.88.829 0 1.484.252 1.965.755.48.503.721 1.196.721 2.078v.721h-4.184c.019.609.183 1.078.493 1.408.311.325.748.488 1.312.488.371 0 .715-.034 1.033-.102.322-.072.666-.19 1.033-.352v1.084a4.069 4.069 0 0 1-.988.329 5.996 5.996 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.764.135-1.022.403-.253.269-.404.661-.454 1.176h2.85c-.007-.519-.132-.911-.375-1.176-.242-.268-.575-.403-.999-.403Zm9.56 4.417c.326 0 .651-.051.977-.153v1.005a2.645 2.645 0 0 1-.574.159c-.23.045-.471.068-.721.068-1.264 0-1.896-.666-1.896-1.999v-3.383h-.857v-.59l.92-.489.454-1.328h.823v1.396h1.788v1.011h-1.788v3.361c0 .321.08.56.239.715.162.151.374.227.635.227Zm7.806-2.186c0 1.026-.263 1.827-.789 2.402-.526.575-1.258.863-2.197.863-.587 0-1.105-.133-1.555-.398a2.618 2.618 0 0 1-1.039-1.141c-.243-.496-.364-1.071-.364-1.726 0-1.018.262-1.812.784-2.384.522-.571 1.258-.857 2.208-.857.908 0 1.628.293 2.157.88.53.583.795 1.37.795 2.361Zm-4.57 0c0 1.45.536 2.175 1.607 2.175 1.059 0 1.589-.725 1.589-2.175 0-1.434-.533-2.151-1.601-2.151-.56 0-.967.185-1.22.556-.25.371-.375.903-.375 1.595Zm14.42 3.151-.829-2.305h-3.174l-.811 2.305h-1.431l3.105-8.334h1.476l3.106 8.334h-1.442Zm-1.187-3.474-.778-2.26a16.297 16.297 0 0 1-.442-1.43c-.103.465-.252.974-.449 1.527l-.749 2.163h2.418Zm6.767-2.918c.269 0 .49.019.664.057l-.13 1.243a2.543 2.543 0 0 0-.591-.068c-.533 0-.967.174-1.3.522-.329.348-.494.801-.494 1.357v3.281h-1.334v-6.279h1.045l.176 1.107h.068c.208-.374.479-.671.812-.891a1.953 1.953 0 0 1 1.084-.329Zm5.041 0c.784 0 1.393.284 1.828.851.439.568.659 1.365.659 2.39 0 1.03-.222 1.832-.664 2.407-.443.572-1.058.858-1.845.858-.795 0-1.412-.286-1.851-.858h-.091l-.244.744h-.999v-8.833h1.334v2.1c0 .155-.008.386-.023.693-.015.306-.026.501-.034.585h.057c.424-.625 1.048-.937 1.873-.937Zm-.346 1.09c-.537 0-.925.159-1.164.477-.234.314-.356.842-.363 1.584v.09c0 .765.121 1.319.363 1.664.242.34.638.511 1.187.511.473 0 .83-.188 1.073-.562.246-.375.369-.916.369-1.624 0-1.427-.489-2.14-1.465-2.14Zm5.717 5.302h-1.334v-6.279h1.334v6.279Zm-1.414-7.942c0-.238.064-.422.193-.551.133-.128.32-.193.562-.193.235 0 .416.065.545.193.133.129.199.313.199.551 0 .227-.066.407-.199.539-.129.129-.31.193-.545.193-.242 0-.429-.064-.562-.193-.129-.132-.193-.312-.193-.539Zm5.666 6.977c.325 0 .651-.051.976-.153v1.005a2.634 2.634 0 0 1-.573.159 3.76 3.76 0 0 1-.721.068c-1.264 0-1.896-.666-1.896-1.999v-3.383h-.857v-.59l.919-.489.454-1.328h.823v1.396h1.789v1.011h-1.789v3.361c0 .321.08.56.239.715.163.151.375.227.636.227Zm5.421-5.427c.269 0 .49.019.664.057l-.13 1.243a2.543 2.543 0 0 0-.591-.068c-.533 0-.967.174-1.3.522-.329.348-.493.801-.493 1.357v3.281h-1.335v-6.279h1.045l.176 1.107h.068c.208-.374.479-.671.812-.891a1.953 1.953 0 0 1 1.084-.329Zm5.762 6.392-.266-.874h-.046c-.303.382-.607.643-.914.783-.306.137-.7.205-1.181.205-.617 0-1.099-.167-1.447-.5-.345-.333-.517-.804-.517-1.413 0-.648.24-1.136.721-1.465.481-.329 1.213-.509 2.197-.539l1.084-.034v-.335c0-.402-.094-.701-.283-.897-.186-.201-.475-.301-.869-.301-.322 0-.63.047-.925.142a6.823 6.823 0 0 0-.852.335l-.431-.954a4.55 4.55 0 0 1 1.118-.403 5.027 5.027 0 0 1 1.147-.142c.798 0 1.4.174 1.805.522.409.348.613.895.613 1.641v4.229h-.954Zm-1.987-.908c.485 0 .873-.135 1.164-.403.295-.273.443-.653.443-1.141v-.545l-.806.034c-.628.022-1.086.128-1.374.318-.284.185-.426.471-.426.857 0 .28.084.498.25.653.167.151.416.227.749.227Zm7.142-.057c.326 0 .651-.051.976-.153v1.005a2.618 2.618 0 0 1-.573.159 3.76 3.76 0 0 1-.721.068c-1.264 0-1.896-.666-1.896-1.999v-3.383h-.857v-.59l.919-.489.455-1.328h.823v1.396h1.788v1.011h-1.788v3.361c0 .321.079.56.238.715.163.151.375.227.636.227Zm4.979 1.079c-.977 0-1.741-.284-2.294-.852-.549-.571-.823-1.357-.823-2.356 0-1.025.256-1.832.766-2.418.511-.587 1.213-.88 2.107-.88.828 0 1.483.252 1.964.755.481.503.721 1.196.721 2.078v.721h-4.184c.019.609.183 1.078.494 1.408.31.325.747.488 1.311.488.371 0 .715-.034 1.033-.102a5.65 5.65 0 0 0 1.034-.352v1.084a4.098 4.098 0 0 1-.988.329 6.004 6.004 0 0 1-1.141.097Zm-.244-5.496c-.424 0-.765.135-1.022.403-.254.269-.405.661-.454 1.176h2.849c-.007-.519-.132-.911-.374-1.176-.242-.268-.575-.403-.999-.403Z",
                className: "voting-module_svg__path-15"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 129.363,
                y: 273.047,
                width: 152.779,
                height: 31.973,
                rx: 1.817,
                className: "voting-module_svg__rect-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "voting-module_svg__a",
                        x: 21.82,
                        y: 24.273,
                        width: 340.162,
                        height: 37.059,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.453
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.09
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210955"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210955",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "voting-module_svg__b",
                        x: 21.82,
                        y: 68.898,
                        width: 340.162,
                        height: 37.059,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.453
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.09
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210955"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210955",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "voting-module_svg__c",
                        x: 21.82,
                        y: 204.273,
                        width: 338.888,
                        height: 37.059,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.453
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.09
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210955"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210955",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $19a45ef3f13fe42e$export$2e2bcd8739ae039 = $19a45ef3f13fe42e$var$SvgVotingModule;



const $3edd5b843c70ace1$var$StyledVotingModuleSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $19a45ef3f13fe42e$export$2e2bcd8739ae039))`
  [class$="path-1"],
  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.success};
  }
  [class$="rect-1"],
  [class$="rect-2"],
  [class$="rect-4"],
  [class$="rect-8"],
  [class$="rect-13"],
  [class$="path-3"],
  [class$="path-4"],
  [class$="path-7"],
  [class$="path-8"],
  [class$="path-13"],
  [class$="path-12"],
  [class$="path-14"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-1"],
  [class$="rect-3"],
  [class$="rect-5"],
  [class$="rect-7"],
  [class$="rect-9"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-6"] {
    stroke: ${({ theme: theme })=>theme.success};
  }
  [class$="rect-10"] {
    stroke: ${({ theme: theme })=>theme.error};
  }
  [class$="rect-14"] {
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="rect-11"] {
    fill: ${({ theme: theme })=>theme.lightBlue};
  }

  [class$="rect-12"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-11"],
  [class$="path-2"],
  [class$="path-6"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-9"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-10"] {
    fill: ${({ theme: theme })=>theme.error};
  }

  [class$="path-15"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }
`;
const $3edd5b843c70ace1$var$VotingModule = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $3edd5b843c70ace1$var$StyledVotingModuleSvg
    });
var $3edd5b843c70ace1$export$2e2bcd8739ae039 = $3edd5b843c70ace1$var$VotingModule;


const $3c906036f2372473$var$leftPageContents = [
    {
        title: "Ranked Voting",
        paragraphs: [
            "Jurors rank the options in order of preference. The number of options you rank doesn\u2019t affect the rewards you may win as long as you rank the winning option. Note it\u2019s also possible to reject some options you consider inadequate.",
            "Refuse to Arbitrate is used when a dispute has been posted in the wrong court, has no clear outcome, or evidence is immoral and/or illegal. In case the majority decides to Refuse to Arbitrate, that option is considered the winner."
        ]
    },
    {
        title: "Private Voting",
        paragraphs: [
            "This feature introduces the commit and reveal mechanism, enhancing the secrecy and integrity of votes.",
            "What\u2019s different? In courts with private voting, jurors cast their votes in two parts: Firstly, they vote on a chosen option. The vote is kept secret from other jurors. (Commit period). Finally, they reveal their votes adding a justification (Voting Period).",
            "Note that jurors who miss the Commit period, cannot progress to the Voting period, not being able to conclude the voting. Make sure not to miss the Commit, and the Voting periods."
        ]
    },
    {
        title: "Juror Rewards",
        paragraphs: [
            "Jurors whose vote is coherent with the final jury decision (after all the appeal instances) receive the Juror Rewards composed of arbitration fees (ETH) + PNK redistribution between jurors. Jurors whose vote is not coherent with the final jury decision, lose their locked PNK."
        ]
    }
];
const $3c906036f2372473$var$rightPageComponents = [
    (0, $3edd5b843c70ace1$export$2e2bcd8739ae039),
    (0, $1017cf6192755936$export$2e2bcd8739ae039),
    (0, $0df4c11bca39010b$export$2e2bcd8739ae039)
];
const $3c906036f2372473$var$RankedVoting = ({ toggleMiniGuide: toggleMiniGuide })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$2e2bcd8739ae039), {
        toggleMiniGuide: toggleMiniGuide,
        leftPageContents: $3c906036f2372473$var$leftPageContents,
        rightPageComponents: $3c906036f2372473$var$rightPageComponents,
        isOnboarding: false,
        canClose: true,
        isVisible: true
    });
};
var $3c906036f2372473$export$2e2bcd8739ae039 = $3c906036f2372473$var$RankedVoting;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $ca69b41e5d0a1d7c$var$SvgCourtHeader = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 389 369",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#court-header_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 2,
                        y: 1,
                        width: 385,
                        height: 364.929,
                        rx: 1.825,
                        className: "court-header_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 2.304,
                        y: 1.304,
                        width: 384.392,
                        height: 364.321,
                        rx: 1.521,
                        className: "court-header_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 21.767,
                y: 287.773,
                width: 239.392,
                height: 26.762,
                rx: 1.521,
                className: "court-header_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M31.75 300.581c0-1.365.265-2.385.794-3.06.532-.678 1.318-1.017 2.357-1.017.358 0 .64.03.845.09v.68a2.71 2.71 0 0 0-.836-.119c-.744 0-1.313.233-1.706.699-.392.462-.608 1.191-.646 2.185h.057c.349-.545.9-.817 1.654-.817.624 0 1.115.188 1.473.565.36.377.541.889.541 1.535 0 .722-.198 1.291-.594 1.706-.392.412-.925.618-1.596.618-.72 0-1.29-.269-1.71-.808-.422-.542-.633-1.294-.633-2.257Zm2.333 2.395c.45 0 .799-.141 1.046-.423.25-.285.375-.695.375-1.231 0-.459-.115-.82-.347-1.083-.231-.263-.576-.395-1.036-.395a1.75 1.75 0 0 0-.784.176 1.469 1.469 0 0 0-.57.485 1.13 1.13 0 0 0-.209.641c0 .327.063.631.19.913.127.282.306.505.537.67.235.164.5.247.798.247Zm7.722.575h-4.566v-.68l1.829-1.839c.557-.563.925-.966 1.102-1.207.178-.24.31-.475.4-.703a2.01 2.01 0 0 0 .132-.736c0-.371-.112-.664-.337-.879-.225-.219-.537-.328-.936-.328-.288 0-.562.047-.822.142-.257.095-.543.268-.86.518l-.418-.537c.64-.532 1.337-.798 2.09-.798.653 0 1.165.168 1.535.504.37.332.556.781.556 1.344 0 .441-.123.876-.37 1.307-.248.431-.71.976-1.388 1.635l-1.52 1.487v.038h3.573v.732Zm5.607-3.483c0 1.2-.19 2.097-.57 2.689-.377.593-.956.889-1.735.889-.747 0-1.316-.303-1.706-.908-.39-.608-.584-1.498-.584-2.67 0-1.21.188-2.108.565-2.694.377-.586.952-.879 1.725-.879.754 0 1.326.305 1.716.917.392.611.589 1.496.589 2.656Zm-3.797 0c0 1.01.119 1.747.357 2.209.237.46.616.689 1.135.689.526 0 .906-.233 1.14-.698.238-.469.357-1.202.357-2.2 0-.998-.119-1.728-.356-2.191-.235-.465-.615-.698-1.14-.698-.52 0-.899.229-1.136.689-.238.456-.357 1.189-.357 2.2Zm12.174-1.44c0 .703-.24 1.245-.722 1.625-.479.377-1.164.566-2.058.566h-.817v2.732h-.808v-6.947h1.801c1.736 0 2.604.675 2.604 2.024Zm-3.597 1.497h.727c.716 0 1.234-.116 1.554-.347.32-.231.48-.602.48-1.112 0-.459-.15-.801-.452-1.026-.3-.225-.77-.338-1.406-.338h-.903v2.823Zm10.482 3.426h-.922l-3.796-5.831h-.038c.05.685.076 1.312.076 1.882v3.949h-.746v-6.947h.912l3.787 5.806h.038c-.006-.085-.02-.359-.043-.822-.022-.465-.03-.798-.023-.998v-3.986h.755v6.947Zm6.928 0h-.95l-2.533-3.369-.727.646v2.723h-.808v-6.947h.808v3.445l3.15-3.445h.956l-2.794 3.017 2.898 3.93Z",
                className: "court-header_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 196.021,
                y: 287.469,
                width: 65.926,
                height: 27.989,
                rx: 1.825,
                className: "court-header_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M220.906 302.578c0 .618-.224 1.103-.67 1.454-.447.352-1.063.528-1.849.528-.785 0-1.429-.122-1.929-.366v-1.074c.317.149.653.266 1.007.352.358.085.691.128.998.128.45 0 .781-.085.993-.257a.832.832 0 0 0 .323-.689.865.865 0 0 0-.294-.66c-.197-.181-.602-.394-1.217-.642-.633-.256-1.08-.549-1.34-.879-.259-.329-.389-.725-.389-1.187 0-.58.206-1.036.617-1.369.412-.333.965-.499 1.659-.499a4.88 4.88 0 0 1 1.986.437l-.361.927c-.618-.26-1.169-.39-1.654-.39-.367 0-.646.081-.836.243a.78.78 0 0 0-.285.632c0 .18.038.335.114.465.076.127.201.247.375.361.175.114.488.265.941.452.51.212.884.41 1.122.594.237.183.411.391.522.622.111.231.167.504.167.817Zm3.183 1.079c.273 0 .545-.043.817-.128v.841a2.163 2.163 0 0 1-.479.133 3.133 3.133 0 0 1-.604.057c-1.058 0-1.587-.558-1.587-1.673v-2.832h-.717v-.494l.769-.409.38-1.111h.689v1.168h1.497v.846h-1.497v2.813c0 .27.067.469.2.599.136.127.314.19.532.19Zm5.16.808-.223-.732h-.038c-.253.32-.508.539-.765.656-.256.114-.586.171-.988.171-.517 0-.92-.14-1.212-.418-.288-.279-.432-.673-.432-1.183 0-.542.201-.951.603-1.226.402-.276 1.015-.426 1.839-.452l.908-.028v-.281c0-.335-.08-.586-.238-.75-.155-.168-.398-.252-.727-.252-.269 0-.527.039-.774.119a5.708 5.708 0 0 0-.713.28l-.361-.798a3.81 3.81 0 0 1 .936-.338c.339-.079.659-.119.96-.119.668 0 1.172.146 1.511.438.342.291.513.749.513 1.373v3.54h-.799Zm-1.663-.76c.406 0 .731-.113.974-.338.248-.228.371-.546.371-.955v-.456l-.675.028c-.525.019-.909.108-1.15.267-.237.155-.356.394-.356.717 0 .234.07.417.209.547.14.126.349.19.627.19Zm5.099-2.015.632-.789 1.587-1.692h1.288l-2.115 2.258 2.248 2.998h-1.312l-1.687-2.305-.613.504v1.801h-1.107v-7.394h1.107v3.607l-.057 1.012h.029Zm6.785 2.87c-.817 0-1.457-.238-1.919-.713-.46-.478-.689-1.136-.689-1.972 0-.858.214-1.533.641-2.024.428-.491 1.015-.737 1.763-.737.694 0 1.242.211 1.644.632.402.422.604 1.001.604 1.74v.603h-3.502c.015.51.153.903.413 1.178.26.273.626.409 1.098.409.31 0 .598-.028.864-.085.27-.061.558-.159.865-.295v.908a3.463 3.463 0 0 1-.827.275 5.05 5.05 0 0 1-.955.081Zm-.204-4.6c-.355 0-.64.113-.855.338-.213.225-.339.552-.38.983h2.385c-.006-.434-.111-.762-.314-.983-.202-.225-.481-.338-.836-.338Z",
                className: "court-header_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 276.001,
                y: 287.773,
                width: 91.317,
                height: 26.762,
                rx: 1.521,
                className: "court-header_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M301.821 297.205v4.495c0 .514-.11.963-.332 1.35a2.213 2.213 0 0 1-.955.889c-.415.205-.913.308-1.492.308-.862 0-1.532-.228-2.01-.684-.479-.456-.718-1.083-.718-1.882v-4.476h1.141v4.396c0 .573.133.996.399 1.268.266.273.674.409 1.226.409 1.07 0 1.606-.562 1.606-1.687v-4.386h1.135Zm6.282 6.947h-1.121v-3.231c0-.405-.083-.708-.247-.907-.162-.2-.42-.3-.775-.3-.472 0-.817.14-1.036.418-.218.279-.328.746-.328 1.402v2.618h-1.116v-5.255h.874l.157.689h.057a1.55 1.55 0 0 1 .675-.58 2.26 2.26 0 0 1 .969-.204c1.261 0 1.891.641 1.891 1.924v3.426Zm5.084-1.496c0 .513-.186.907-.56 1.183-.374.272-.909.408-1.606.408-.7 0-1.263-.106-1.687-.318v-.965c.618.286 1.192.428 1.725.428.687 0 1.031-.207 1.031-.622a.495.495 0 0 0-.114-.333 1.335 1.335 0 0 0-.376-.276 6.518 6.518 0 0 0-.727-.323c-.605-.234-1.015-.469-1.23-.703-.213-.234-.319-.538-.319-.912 0-.45.181-.799.542-1.046.364-.25.858-.375 1.483-.375.617 0 1.202.125 1.753.375l-.361.841c-.567-.234-1.044-.351-1.43-.351-.59 0-.884.168-.884.503a.51.51 0 0 0 .228.419c.155.114.491.27 1.007.47.434.168.749.322.946.461.196.139.342.301.437.485.095.18.142.397.142.651Zm3.17.689a2.7 2.7 0 0 0 .817-.129v.841a2.105 2.105 0 0 1-.48.133 3.115 3.115 0 0 1-.603.057c-1.058 0-1.587-.557-1.587-1.672v-2.832h-.718v-.494l.77-.409.38-1.112h.689v1.169h1.497v.846h-1.497v2.813c0 .269.067.469.2.598a.748.748 0 0 0 .532.191Zm5.16.807-.223-.731h-.038c-.254.32-.509.538-.765.655-.257.114-.586.171-.989.171-.516 0-.92-.139-1.211-.418-.289-.279-.433-.673-.433-1.183 0-.542.201-.95.604-1.226.402-.275 1.015-.426 1.839-.451l.907-.029v-.28c0-.336-.079-.586-.237-.751-.156-.168-.398-.252-.727-.252-.27 0-.528.04-.775.119a5.931 5.931 0 0 0-.713.28l-.361-.798c.285-.149.597-.261.936-.337.339-.079.659-.119.96-.119.669 0 1.172.146 1.511.437.342.292.513.749.513 1.373v3.54h-.798Zm-1.663-.76c.406 0 .73-.112.974-.337.247-.228.371-.547.371-.955v-.457l-.675.029c-.526.019-.909.108-1.15.266-.237.155-.356.394-.356.718 0 .234.069.416.209.546.139.127.348.19.627.19Zm5.099-2.015.632-.788 1.587-1.692h1.287l-2.114 2.257 2.247 2.998h-1.311l-1.687-2.304-.613.503v1.801h-1.107v-7.393h1.107v3.606l-.057 1.012h.029Zm6.785 2.87c-.817 0-1.457-.237-1.92-.712-.459-.479-.689-1.136-.689-1.972 0-.859.214-1.534.642-2.025.427-.491 1.015-.736 1.763-.736.693 0 1.241.211 1.644.632.402.421.603 1.001.603 1.739v.604h-3.502c.016.51.154.902.414 1.178.259.272.625.409 1.097.409.311 0 .599-.029.865-.086.269-.06.558-.158.865-.295v.908c-.273.13-.548.222-.827.276-.279.053-.597.08-.955.08Zm-.204-4.599c-.355 0-.64.112-.856.337-.212.225-.339.553-.38.984h2.386c-.007-.434-.111-.762-.314-.984-.203-.225-.482-.337-.836-.337Zm9.332 4.504-.223-.731h-.038c-.254.32-.509.538-.765.655-.257.114-.586.171-.989.171-.516 0-.92-.139-1.211-.418-.289-.279-.433-.673-.433-1.183 0-.542.201-.95.604-1.226.402-.275 1.015-.426 1.839-.451l.907-.029v-.28c0-.336-.079-.586-.237-.751-.156-.168-.398-.252-.727-.252-.27 0-.528.04-.775.119a5.931 5.931 0 0 0-.713.28l-.361-.798c.285-.149.597-.261.936-.337.339-.079.659-.119.96-.119.668 0 1.172.146 1.511.437.342.292.513.749.513 1.373v3.54h-.798Zm-1.663-.76c.405 0 .73-.112.974-.337.247-.228.371-.547.371-.955v-.457l-.675.029c-.526.019-.909.108-1.15.266-.238.155-.356.394-.356.718 0 .234.069.416.209.546.139.127.348.19.627.19Zm5.136.76h-1.116v-7.393h1.116v7.393Zm2.718 0h-1.116v-7.393h1.116v7.393Z",
                className: "court-header_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 276.001,
                y: 287.773,
                width: 91.317,
                height: 26.762,
                rx: 1.521,
                className: "court-header_svg__rect-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M26.386 262.739c0 .617-.224 1.102-.67 1.454-.447.351-1.063.527-1.849.527-.785 0-1.428-.122-1.929-.366v-1.074a5.28 5.28 0 0 0 1.007.352c.358.085.691.128.998.128.45 0 .781-.085.993-.256a.835.835 0 0 0 .323-.689c0-.26-.098-.48-.294-.661-.197-.18-.602-.394-1.217-.641-.633-.257-1.08-.55-1.34-.879-.26-.33-.39-.726-.39-1.188 0-.58.207-1.036.619-1.369.411-.332.964-.499 1.658-.499a4.88 4.88 0 0 1 1.986.437l-.361.927c-.618-.26-1.169-.39-1.654-.39-.367 0-.646.081-.836.243a.78.78 0 0 0-.285.632c0 .18.038.335.114.465.076.127.201.247.375.361.175.114.488.265.941.452.51.212.884.41 1.122.594.237.184.411.391.522.622.111.232.167.504.167.818Zm3.183 1.078c.273 0 .545-.043.818-.128v.841a2.174 2.174 0 0 1-.48.133 3.121 3.121 0 0 1-.604.057c-1.058 0-1.587-.557-1.587-1.673v-2.832H27v-.494l.77-.408.38-1.112h.688v1.169h1.497v.845h-1.497v2.813c0 .27.067.469.2.599.136.127.314.19.532.19Zm5.16.808-.223-.732h-.038c-.253.32-.508.539-.765.656-.256.114-.586.171-.988.171-.517 0-.92-.139-1.212-.418-.288-.279-.432-.673-.432-1.183 0-.542.2-.951.603-1.226.403-.276 1.016-.426 1.84-.452l.907-.028v-.28c0-.336-.08-.587-.238-.751-.155-.168-.397-.252-.727-.252-.27 0-.527.04-.774.119a5.759 5.759 0 0 0-.713.28l-.361-.798c.285-.149.597-.262.936-.338.339-.079.659-.118.96-.118.668 0 1.172.145 1.51.437.343.291.514.749.514 1.373v3.54h-.798Zm-1.663-.76c.406 0 .73-.113.975-.338.247-.228.37-.546.37-.955v-.456l-.675.029c-.525.019-.909.107-1.15.266-.237.155-.356.394-.356.717 0 .235.07.417.21.547.139.126.348.19.627.19Zm5.099-2.015.632-.789 1.587-1.691h1.288l-2.115 2.257 2.248 2.998h-1.312l-1.687-2.305-.612.504v1.801h-1.108v-7.394h1.108v3.607l-.058 1.012h.029Zm6.785 2.87c-.817 0-1.457-.238-1.92-.713-.459-.478-.688-1.135-.688-1.972 0-.858.214-1.533.641-2.024.428-.491 1.016-.736 1.763-.736.694 0 1.242.21 1.644.632.402.421.604 1.001.604 1.739v.603h-3.502c.016.51.153.903.413 1.179.26.272.626.408 1.098.408.31 0 .598-.028.864-.085.27-.06.558-.159.865-.295v.908c-.272.13-.548.221-.826.275a5.056 5.056 0 0 1-.956.081Zm-.204-4.6c-.355 0-.64.113-.855.338-.212.225-.34.553-.38.983h2.385c-.006-.434-.11-.761-.314-.983-.202-.225-.481-.338-.836-.338Zm10.763-.342c0 .726-.238 1.282-.713 1.668-.475.387-1.152.58-2.03.58h-.721v2.599h-1.136v-6.947h2c.869 0 1.518.177 1.949.532.434.355.65.878.65 1.568Zm-3.464 1.293h.603c.583 0 1.01-.102 1.283-.304.273-.203.409-.52.409-.951 0-.399-.122-.697-.366-.893-.244-.196-.624-.295-1.14-.295h-.79v2.443Zm10.639 3.554h-1.392l-3.417-5.536h-.038l.024.309c.044.589.066 1.128.066 1.616v3.611h-1.03v-6.947h1.377l3.407 5.507h.029a32.334 32.334 0 0 1-.038-.793c-.02-.46-.029-.818-.029-1.074v-3.64h1.04v6.947Zm7.137 0h-1.317l-2.18-3.146-.67.547v2.599h-1.136v-6.947h1.135v3.317c.31-.38.62-.746.927-1.098l1.877-2.219h1.292a431.383 431.383 0 0 1-2.608 3.046l2.68 3.901Z",
                className: "court-header_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M75.071 264.069c.14 0 .274-.009.404-.028.13-.023.233-.045.31-.067v.603a1.355 1.355 0 0 1-.381.1 2.594 2.594 0 0 1-.447.043c-1.007 0-1.51-.531-1.51-1.592v-3.098H72.7v-.38l.746-.328.333-1.112h.456v1.207h1.511v.613h-1.51v3.065c0 .314.073.554.222.722.15.168.354.252.613.252Zm6.254-2.053c0 .849-.214 1.513-.642 1.991-.428.475-1.018.713-1.772.713-.466 0-.88-.109-1.24-.328a2.16 2.16 0 0 1-.837-.941c-.196-.408-.294-.887-.294-1.435 0-.849.212-1.509.636-1.981.425-.475 1.014-.713 1.768-.713.729 0 1.307.242 1.734.727.431.485.647 1.141.647 1.967Zm-3.968 0c0 .666.133 1.172.4 1.521.265.348.656.523 1.173.523.516 0 .907-.173 1.173-.518.27-.349.404-.857.404-1.526 0-.662-.134-1.164-.404-1.506-.266-.345-.66-.518-1.183-.518-.516 0-.906.17-1.169.509-.263.338-.394.844-.394 1.515Zm7.251 4.947c-.301 0-.545-.04-.732-.119v-.641c.219.063.434.095.646.095.247 0 .428-.069.542-.205.117-.133.176-.337.176-.613v-6.063h.789v6.006c0 1.027-.474 1.54-1.421 1.54Zm.565-8.957c0-.181.045-.312.133-.394a.459.459 0 0 1 .333-.129c.127 0 .236.043.328.129.092.085.138.217.138.394 0 .177-.046.31-.138.399a.463.463 0 0 1-.328.128.458.458 0 0 1-.332-.128c-.09-.089-.134-.222-.134-.399Zm7.023 4.01c0 .849-.213 1.513-.641 1.991-.428.475-1.019.713-1.772.713-.466 0-.88-.109-1.24-.328a2.159 2.159 0 0 1-.837-.941c-.196-.408-.294-.887-.294-1.435 0-.849.212-1.509.636-1.981.425-.475 1.014-.713 1.768-.713.728 0 1.306.242 1.734.727.431.485.646 1.141.646 1.967Zm-3.967 0c0 .666.133 1.172.399 1.521.266.348.657.523 1.174.523.516 0 .907-.173 1.173-.518.27-.349.404-.857.404-1.526 0-.662-.135-1.164-.404-1.506-.266-.345-.66-.518-1.183-.518-.516 0-.906.17-1.169.509-.263.338-.394.844-.394 1.515Zm6.144 2.609h-.79v-5.208h.79v5.208Zm-.856-6.619c0-.181.045-.312.133-.394a.459.459 0 0 1 .333-.129c.127 0 .236.043.328.129.092.085.138.217.138.394 0 .177-.046.31-.138.399a.462.462 0 0 1-.328.128.458.458 0 0 1-.333-.128c-.088-.089-.133-.222-.133-.399Zm6.092 6.619v-3.369c0-.424-.097-.741-.29-.95-.193-.209-.496-.314-.907-.314-.545 0-.944.147-1.198.442-.253.295-.38.781-.38 1.459v2.732h-.789v-5.208h.642l.128.713h.038a1.59 1.59 0 0 1 .68-.594 2.18 2.18 0 0 1 .974-.214c.627 0 1.099.152 1.416.456.316.301.475.784.475 1.45v3.397h-.789Zm6.624-.556c.139 0 .274-.009.404-.028.13-.023.233-.045.309-.067v.603a1.367 1.367 0 0 1-.381.1 2.581 2.581 0 0 1-.446.043c-1.008 0-1.511-.531-1.511-1.592v-3.098h-.746v-.38l.746-.328.332-1.112h.457v1.207h1.511v.613h-1.511v3.065c0 .314.074.554.223.722.149.168.353.252.613.252Zm5.322.556v-3.369c0-.424-.097-.741-.29-.95-.193-.209-.496-.314-.908-.314-.548 0-.948.149-1.202.447-.25.298-.375.785-.375 1.463v2.723h-.789v-7.394h.789v2.238c0 .27-.013.493-.038.67h.047c.156-.25.376-.446.661-.589.288-.146.616-.218.983-.218.637 0 1.114.152 1.431.456.32.301.48.781.48 1.44v3.397h-.789Zm4.614.095c-.77 0-1.378-.234-1.825-.703-.443-.469-.665-1.12-.665-1.953 0-.84.206-1.506.617-2.001.415-.494.971-.741 1.668-.741.653 0 1.169.216 1.549.646.38.428.571.993.571 1.697v.499h-3.588c.016.611.17 1.075.461 1.392.295.317.708.475 1.24.475.561 0 1.115-.117 1.663-.352v.704c-.279.12-.543.206-.793.256a4.276 4.276 0 0 1-.898.081Zm-.214-4.737c-.418 0-.753.136-1.003.408-.247.273-.393.65-.437 1.131h2.723c0-.497-.111-.877-.333-1.14-.222-.266-.538-.399-.95-.399Zm8.263 4.642h-.808v-6.229h-2.2v-.718h5.208v.718h-2.2v6.229Zm7.626-2.609c0 .849-.213 1.513-.641 1.991-.428.475-1.018.713-1.772.713-.466 0-.879-.109-1.241-.328a2.157 2.157 0 0 1-.836-.941c-.196-.408-.295-.887-.295-1.435 0-.849.213-1.509.637-1.981.425-.475 1.014-.713 1.768-.713.728 0 1.307.242 1.734.727.431.485.646 1.141.646 1.967Zm-3.967 0c0 .666.133 1.172.399 1.521.266.348.657.523 1.174.523.516 0 .907-.173 1.173-.518.27-.349.404-.857.404-1.526 0-.662-.134-1.164-.404-1.506-.266-.345-.66-.518-1.183-.518-.516 0-.906.17-1.169.509-.263.338-.394.844-.394 1.515Zm6.134-.057a9.32 9.32 0 0 1 .623-.76l1.682-1.782h.936l-2.11 2.219 2.257 2.989h-.955l-1.839-2.461-.594.513v1.948h-.779v-7.394h.779v3.921c0 .174-.012.443-.038.807h.038Zm6.534 2.761c-.77 0-1.378-.234-1.825-.703-.443-.469-.665-1.12-.665-1.953 0-.84.206-1.506.618-2.001.415-.494.971-.741 1.667-.741.653 0 1.169.216 1.549.646.381.428.571.993.571 1.697v.499h-3.588c.016.611.17 1.075.461 1.392.295.317.708.475 1.24.475.561 0 1.115-.117 1.663-.352v.704c-.278.12-.543.206-.793.256a4.276 4.276 0 0 1-.898.081Zm-.214-4.737c-.418 0-.752.136-1.003.408-.247.273-.392.65-.437 1.131h2.723c0-.497-.111-.877-.333-1.14-.221-.266-.538-.399-.95-.399Zm7.042 4.642v-3.369c0-.424-.097-.741-.29-.95-.193-.209-.496-.314-.908-.314-.544 0-.944.147-1.197.442-.253.295-.38.781-.38 1.459v2.732h-.789v-5.208h.642l.128.713h.038c.161-.257.388-.455.679-.594.292-.143.617-.214.975-.214.627 0 1.099.152 1.416.456.316.301.475.784.475 1.45v3.397h-.789Zm5.06 0v-6.947h.808v6.215h3.065v.732h-3.873Zm5.726 0h-.789v-5.208h.789v5.208Zm-.855-6.619c0-.181.044-.312.133-.394a.46.46 0 0 1 .333-.129c.126 0 .236.043.327.129.092.085.138.217.138.394 0 .177-.046.31-.138.399a.46.46 0 0 1-.327.128.46.46 0 0 1-.333-.128c-.089-.089-.133-.222-.133-.399Zm5.887 5.198c0 .485-.18.859-.541 1.122-.362.263-.868.394-1.521.394-.691 0-1.229-.109-1.616-.328v-.732c.251.127.518.227.803.3.289.073.566.109.832.109.412 0 .729-.065.95-.195a.657.657 0 0 0 .333-.603.644.644 0 0 0-.266-.518c-.174-.146-.516-.317-1.026-.513-.485-.181-.83-.338-1.036-.471a1.471 1.471 0 0 1-.457-.461 1.212 1.212 0 0 1-.147-.613c0-.424.173-.758.518-1.002.345-.247.819-.371 1.421-.371.561 0 1.109.114 1.644.342l-.28.642c-.523-.216-.997-.323-1.421-.323-.374 0-.656.058-.846.175-.19.118-.285.279-.285.485 0 .139.035.258.104.356.073.099.189.192.347.281.159.089.463.217.913.385.617.225 1.034.451 1.249.679.219.228.328.515.328.86Zm2.97.865c.139 0 .274-.009.404-.028.13-.023.233-.045.309-.067v.603a1.359 1.359 0 0 1-.38.1 2.601 2.601 0 0 1-.447.043c-1.007 0-1.511-.531-1.511-1.592v-3.098h-.746v-.38l.746-.328.333-1.112h.456v1.207h1.511v.613h-1.511v3.065c0 .314.074.554.223.722.149.168.353.252.613.252Zm2.547.556h-.789v-5.208h.789v5.208Zm-.855-6.619c0-.181.044-.312.133-.394a.456.456 0 0 1 .332-.129c.127 0 .236.043.328.129.092.085.138.217.138.394 0 .177-.046.31-.138.399a.463.463 0 0 1-.328.128.456.456 0 0 1-.332-.128c-.089-.089-.133-.222-.133-.399Zm6.091 6.619v-3.369c0-.424-.096-.741-.29-.95-.193-.209-.495-.314-.907-.314-.545 0-.944.147-1.198.442-.253.295-.38.781-.38 1.459v2.732h-.788v-5.208h.641l.128.713h.038a1.59 1.59 0 0 1 .68-.594 2.18 2.18 0 0 1 .974-.214c.627 0 1.099.152 1.416.456.317.301.475.784.475 1.45v3.397h-.789Zm6.676-5.208v.499l-.964.114c.089.111.168.257.237.437.07.178.105.379.105.604 0 .51-.174.917-.523 1.221-.348.304-.827.456-1.435.456-.155 0-.301-.013-.437-.038-.336.177-.504.401-.504.67 0 .143.059.249.176.318.117.067.319.1.604.1h.922c.563 0 .996.119 1.297.357.304.237.456.582.456 1.035 0 .577-.231 1.016-.694 1.317-.462.304-1.137.456-2.024.456-.681 0-1.207-.127-1.578-.38-.367-.254-.551-.612-.551-1.074 0-.317.102-.591.304-.822.203-.231.488-.388.856-.471a.84.84 0 0 1-.338-.28.757.757 0 0 1-.133-.442c0-.19.051-.356.152-.499a1.62 1.62 0 0 1 .48-.413 1.422 1.422 0 0 1-.66-.566 1.671 1.671 0 0 1-.252-.912c0-.57.171-1.009.513-1.316.342-.311.827-.466 1.454-.466.272 0 .518.032.737.095h1.8Zm-4.153 6.082c0 .282.119.496.357.642.237.146.578.218 1.021.218.662 0 1.152-.099 1.469-.299.32-.196.48-.464.48-.803 0-.282-.088-.478-.262-.589-.174-.108-.502-.162-.983-.162h-.946c-.358 0-.637.086-.836.257-.2.171-.3.416-.3.736Zm.428-4.414c0 .364.103.64.309.827.206.187.493.28.86.28.77 0 1.155-.374 1.155-1.121 0-.783-.39-1.174-1.169-1.174-.371 0-.656.1-.856.299-.199.2-.299.496-.299.889Zm9.404 3.635c-.754 0-1.339-.231-1.754-.694-.412-.465-.617-1.123-.617-1.972 0-.871.209-1.544.627-2.019.421-.475 1.02-.713 1.796-.713.25 0 .5.027.751.081.25.054.446.117.589.19l-.242.67a3.507 3.507 0 0 0-.571-.171 2.435 2.435 0 0 0-.546-.071c-1.058 0-1.587.674-1.587 2.024 0 .64.128 1.131.385 1.473.26.342.643.513 1.15.513.434 0 .879-.093 1.335-.28v.698c-.349.181-.787.271-1.316.271Zm7.051-2.704c0 .849-.214 1.513-.641 1.991-.428.475-1.019.713-1.773.713-.465 0-.879-.109-1.24-.328a2.157 2.157 0 0 1-.836-.941c-.197-.408-.295-.887-.295-1.435 0-.849.212-1.509.637-1.981.424-.475 1.014-.713 1.768-.713.728 0 1.306.242 1.734.727.431.485.646 1.141.646 1.967Zm-3.967 0c0 .666.133 1.172.399 1.521.266.348.657.523 1.173.523.517 0 .908-.173 1.174-.518.269-.349.404-.857.404-1.526 0-.662-.135-1.164-.404-1.506-.266-.345-.661-.518-1.183-.518-.517 0-.906.17-1.169.509-.263.338-.394.844-.394 1.515Zm6.096-2.599v3.379c0 .424.097.741.29.95.193.209.496.314.907.314.545 0 .943-.149 1.193-.447.253-.298.38-.784.38-1.459v-2.737h.789v5.208h-.651l-.114-.698h-.043a1.571 1.571 0 0 1-.675.589 2.245 2.245 0 0 1-.978.204c-.634 0-1.109-.15-1.426-.451-.314-.301-.47-.783-.47-1.445v-3.407h.798Zm7.612-.095c.231 0 .439.019.623.057l-.11.732a2.647 2.647 0 0 0-.57-.071c-.421 0-.782.171-1.083.513-.298.342-.447.768-.447 1.278v2.794h-.789v-5.208h.651l.091.965h.038c.193-.339.426-.601.698-.784a1.57 1.57 0 0 1 .898-.276Zm3.279 4.747c.139 0 .274-.009.404-.028.13-.023.232-.045.309-.067v.603a1.367 1.367 0 0 1-.381.1 2.581 2.581 0 0 1-.446.043c-1.008 0-1.511-.531-1.511-1.592v-3.098h-.746v-.38l.746-.328.332-1.112h.456v1.207h1.511v.613h-1.511v3.065c0 .314.075.554.224.722.149.168.353.252.613.252Z",
                className: "court-header_svg__path-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m23.963 336.738 4.281.192 1.734 3.852-2.446 3.521-4.304-.276-1.765-4.174 2.5-3.115Zm3.139 2.221-3.103 1.356 2.653 2.051.45-3.407Zm-.36-.68-2.48-1.068-.52 2.246 3-1.178Zm-.628 4.603-2.695-1.924.065 2.608 2.63-.684Zm3.433-2.109-1.836-1.864-.485 3.585 2.321-1.721Zm-2.801 2.529-2.273.594 2.673.171-.4-.765Zm2.443-1.683-1.99 1.483.395.772 1.595-2.255Zm-.942-4.151-.386.793 1.438 1.463-1.052-2.256Zm-.481-.38-2.526-.102 2.084.911.442-.809Zm-4.172.367-1.769 2.235 1.183.25.586-2.485Zm-.657 2.923-1.189-.251 1.24 2.922-.051-2.671Z",
                    className: "court-header_svg__path-6"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m38.37 343.465-2.063-5.389h-.033c.039.427.058.935.058 1.522v3.867h-.653v-6.079h1.065l1.925 5.014h.033l1.942-5.014H41.7v6.079h-.707v-3.917c0-.449.02-.937.058-1.463h-.033l-2.08 5.38h-.569Zm4.174-4.557h.74l.998 2.599c.219.593.354 1.021.407 1.284h.033c.036-.141.111-.382.225-.723.116-.344.493-1.397 1.13-3.16h.74l-1.958 5.189c-.194.513-.42.876-.681 1.089-.258.216-.576.324-.953.324-.21 0-.418-.023-.623-.07v-.553c.152.033.323.05.511.05.474 0 .812-.266 1.015-.799l.253-.648-1.837-4.582Zm10.76 2.939c0 .535-.194.953-.582 1.252-.388.299-.915.449-1.58.449-.72 0-1.275-.093-1.663-.279v-.681c.25.105.52.188.815.249.293.061.584.091.873.091.47 0 .826-.088 1.064-.266.238-.18.358-.429.358-.748a.938.938 0 0 0-.13-.516c-.082-.135-.224-.26-.423-.374a5.892 5.892 0 0 0-.903-.386c-.565-.203-.97-.443-1.214-.72-.24-.277-.361-.639-.361-1.085 0-.468.176-.841.528-1.118.352-.277.817-.416 1.397-.416.604 0 1.16.111 1.667.333l-.22.615a3.762 3.762 0 0 0-1.464-.316c-.374 0-.667.08-.877.241a.795.795 0 0 0-.316.669c0 .211.039.384.116.52.078.133.208.257.391.37.186.111.468.234.848.37.638.228 1.076.471 1.314.732.241.261.362.599.362 1.014Zm2.61 1.131a2.387 2.387 0 0 0 .624-.083v.528a1.253 1.253 0 0 1-.332.088 2.303 2.303 0 0 1-.391.037c-.881 0-1.322-.464-1.322-1.393v-2.711h-.653v-.332l.653-.287.29-.973h.4v1.056h1.322v.536h-1.322v2.682c0 .274.065.485.196.632.13.147.309.22.536.22Zm4.341.487-.137-.649h-.033c-.227.286-.455.48-.682.582-.224.1-.506.15-.844.15-.452 0-.806-.116-1.064-.349-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.773-.025v-.283c0-.357-.077-.62-.233-.789-.152-.172-.397-.258-.735-.258-.38 0-.81.116-1.29.349l-.211-.528c.224-.122.47-.218.736-.287.268-.069.537-.104.806-.104.543 0 .945.121 1.206.362.263.241.395.628.395 1.16v3.11h-.512Zm-1.559-.487c.43 0 .767-.117 1.01-.353.247-.236.37-.565.37-.99v-.411l-.69.029c-.548.019-.945.105-1.189.258-.24.149-.361.384-.361.702 0 .25.075.44.224.57.153.13.365.195.636.195Zm4.179-1.846c.119-.169.3-.39.544-.665l1.472-1.559h.82l-1.847 1.942 1.975 2.615h-.835l-1.61-2.154-.52.449v1.705h-.681v-6.47h.682v3.431c0 .152-.011.388-.033.706h.033Zm5.717 2.416c-.674 0-1.206-.205-1.597-.615-.388-.411-.582-.98-.582-1.709 0-.735.18-1.318.54-1.751.364-.432.85-.648 1.46-.648.57 0 1.023.188 1.355.565.333.374.5.869.5 1.485v.436h-3.14c.014.535.148.941.403 1.218.258.278.62.416 1.086.416.49 0 .975-.102 1.455-.308v.616c-.244.105-.475.18-.695.224a3.755 3.755 0 0 1-.785.071Zm-.187-4.145c-.366 0-.659.119-.878.357-.216.239-.343.569-.382.99h2.382c0-.435-.097-.768-.29-.998-.195-.233-.472-.349-.832-.349Zm2.943 3.621c0-.186.042-.326.125-.42.086-.097.208-.145.366-.145.16 0 .285.048.374.145.092.094.137.234.137.42 0 .18-.045.319-.137.416a.49.49 0 0 1-.374.145.508.508 0 0 1-.353-.128c-.092-.089-.138-.233-.138-.433Zm0-3.671c0-.374.164-.561.49-.561.342 0 .512.187.512.561 0 .18-.045.319-.137.416a.49.49 0 0 1-.374.145.504.504 0 0 1-.353-.129c-.092-.088-.138-.233-.138-.432Z",
                className: "court-header_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M82.785 343.465h-.977v-3.925c0-.468.011-.84.033-1.114-.064.066-.143.14-.237.22-.091.08-.402.335-.931.765l-.49-.619 1.787-1.406h.815v6.079Zm6.116-3.039c0 1.056-.17 1.84-.511 2.353-.339.513-.857.769-1.555.769-.677 0-1.19-.265-1.539-.794-.349-.53-.524-1.306-.524-2.328 0-1.073.17-1.863.508-2.37.34-.51.859-.765 1.555-.765.679 0 1.193.266 1.542.798.35.532.524 1.311.524 2.337Zm-3.14 0c0 .828.085 1.42.255 1.775.171.355.444.532.819.532.374 0 .647-.18.819-.54.174-.361.262-.95.262-1.767 0-.815-.088-1.404-.262-1.767-.172-.366-.445-.549-.82-.549-.374 0-.647.178-.819.536-.169.358-.253.951-.253 1.78Zm5.223 2.145c-.133.515-.377 1.179-.732 1.991h-.72c.192-.748.335-1.444.43-2.087h.96l.062.096Zm5.06-2.145c0 1.056-.17 1.84-.511 2.353-.339.513-.857.769-1.555.769-.677 0-1.19-.265-1.539-.794-.35-.53-.524-1.306-.524-2.328 0-1.073.17-1.863.507-2.37.341-.51.86-.765 1.556-.765.679 0 1.193.266 1.542.798.35.532.524 1.311.524 2.337Zm-3.14 0c0 .828.085 1.42.254 1.775.172.355.445.532.82.532.374 0 .647-.18.819-.54.174-.361.261-.95.261-1.767 0-.815-.087-1.404-.261-1.767-.172-.366-.445-.549-.82-.549-.374 0-.647.178-.819.536-.169.358-.253.951-.253 1.78Zm8.004 0c0 1.056-.17 1.84-.511 2.353-.338.513-.857.769-1.555.769-.676 0-1.19-.265-1.538-.794-.35-.53-.524-1.306-.524-2.328 0-1.073.169-1.863.507-2.37.341-.51.86-.765 1.555-.765.68 0 1.193.266 1.543.798.349.532.523 1.311.523 2.337Zm-3.139 0c0 .828.085 1.42.254 1.775.172.355.445.532.82.532.373 0 .646-.18.818-.54.175-.361.262-.95.262-1.767 0-.815-.087-1.404-.262-1.767-.172-.366-.445-.549-.819-.549-.374 0-.647.178-.819.536-.17.358-.254.951-.254 1.78Zm8.004 0c0 1.056-.17 1.84-.511 2.353-.339.513-.857.769-1.555.769-.677 0-1.19-.265-1.539-.794-.349-.53-.524-1.306-.524-2.328 0-1.073.169-1.863.508-2.37.341-.51.859-.765 1.555-.765.679 0 1.193.266 1.542.798s.524 1.311.524 2.337Zm-3.139 0c0 .828.084 1.42.254 1.775.171.355.444.532.819.532.374 0 .647-.18.819-.54.174-.361.262-.95.262-1.767 0-.815-.088-1.404-.262-1.767-.172-.366-.445-.549-.819-.549-.375 0-.648.178-.819.536-.17.358-.254.951-.254 1.78Zm10.548-1.202c0 .635-.208 1.121-.624 1.459-.415.338-1.007.508-1.775.508h-.632v2.274h-.994v-6.079h1.751c.759 0 1.327.155 1.704.466.38.31.57.768.57 1.372Zm-3.031 1.131h.528c.51 0 .884-.089 1.123-.266.238-.178.357-.455.357-.832 0-.349-.106-.61-.32-.781-.213-.172-.546-.258-.998-.258h-.69v2.137Zm9.309 3.11h-1.218l-2.989-4.844h-.034l.021.27c.039.516.058.987.058 1.414v3.16h-.902v-6.079h1.206l2.981 4.819h.025a23.615 23.615 0 0 1-.033-.694 23.508 23.508 0 0 1-.025-.94v-3.185h.91v6.079Zm6.245 0h-1.152l-1.908-2.753-.586.479v2.274h-.994v-6.079h.994v2.902c.271-.332.542-.652.811-.96l1.642-1.942h1.131a372.195 372.195 0 0 1-2.283 2.665l2.345 3.414Z",
                className: "court-header_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__c)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M152.293 339.932h-.395v-1.197c0-1.394-1.123-2.528-2.504-2.528-1.38 0-2.504 1.134-2.504 2.528v1.197h-.395a.796.796 0 0 0-.791.799v3.193c0 .44.355.798.791.798h5.798a.795.795 0 0 0 .791-.798v-3.193a.795.795 0 0 0-.791-.799Zm-1.713 0h-2.372v-1.197c0-.66.532-1.197 1.186-1.197.654 0 1.186.537 1.186 1.197v1.197Z",
                    className: "court-header_svg__path-9"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M159.388 343.465v-6.079h.707v5.439h2.682v.64h-3.389Zm8.254-2.283c0 .743-.188 1.324-.562 1.742-.374.416-.891.624-1.551.624-.407 0-.769-.096-1.085-.287a1.896 1.896 0 0 1-.732-.823c-.171-.358-.257-.776-.257-1.256 0-.743.185-1.321.557-1.734.371-.415.887-.623 1.546-.623.638 0 1.144.212 1.518.636.377.424.566.998.566 1.721Zm-3.472 0c0 .582.116 1.026.349 1.331.233.305.575.457 1.027.457.452 0 .794-.151 1.027-.453.236-.305.353-.75.353-1.335 0-.579-.117-1.018-.353-1.318-.233-.302-.578-.453-1.035-.453-.452 0-.793.148-1.023.445-.23.297-.345.739-.345 1.326Zm6.507 2.366c-.66 0-1.171-.202-1.535-.607-.36-.407-.54-.983-.54-1.725 0-.763.183-1.352.549-1.768.368-.415.892-.623 1.571-.623.219 0 .438.023.657.071.219.047.391.102.516.166l-.212.586a3.14 3.14 0 0 0-.499-.15 2.191 2.191 0 0 0-.478-.062c-.926 0-1.389.59-1.389 1.771 0 .56.112.99.337 1.289.227.299.563.449 1.006.449.38 0 .769-.082 1.168-.245v.611c-.305.158-.688.237-1.151.237Zm2.918-2.416c.12-.169.301-.39.545-.665l1.472-1.559h.819l-1.846 1.942 1.975 2.615h-.836l-1.609-2.154-.52.449v1.705h-.682v-6.47h.682v3.431c0 .152-.011.388-.033.706h.033Zm5.717 2.416c-.673 0-1.206-.205-1.596-.615-.388-.411-.582-.98-.582-1.709 0-.735.18-1.318.54-1.751.363-.432.85-.648 1.459-.648.571 0 1.023.188 1.356.565.332.374.499.869.499 1.485v.436h-3.139c.014.535.148.941.403 1.218.258.278.62.416 1.085.416.491 0 .976-.102 1.455-.308v.616c-.244.105-.475.18-.694.224a3.753 3.753 0 0 1-.786.071Zm-.187-4.145c-.366 0-.658.119-.877.357-.216.239-.344.569-.383.99h2.383c0-.435-.097-.768-.291-.998-.194-.233-.472-.349-.832-.349Zm6.145 3.451h-.037c-.319.463-.796.694-1.43.694-.596 0-1.061-.204-1.393-.611-.33-.408-.495-.987-.495-1.738s.166-1.335.499-1.751c.332-.415.795-.623 1.389-.623.618 0 1.092.224 1.421.673h.055l-.03-.328-.016-.32v-1.855h.69v6.47h-.561l-.092-.611Zm-1.38.116c.471 0 .812-.127 1.023-.382.213-.258.32-.673.32-1.244v-.145c0-.646-.108-1.106-.324-1.38-.214-.278-.556-.416-1.027-.416-.405 0-.716.158-.932.474-.213.313-.32.756-.32 1.33 0 .582.107 1.022.32 1.318.214.297.527.445.94.445Zm9.247-1.123c0 .535-.194.953-.582 1.252-.388.299-.915.449-1.58.449-.721 0-1.275-.093-1.663-.279v-.681c.249.105.521.188.814.249.294.061.585.091.874.091.471 0 .826-.088 1.064-.266.238-.18.358-.429.358-.748a.938.938 0 0 0-.129-.516c-.084-.135-.225-.26-.424-.374a5.902 5.902 0 0 0-.903-.386c-.565-.203-.97-.443-1.214-.72-.241-.277-.361-.639-.361-1.085 0-.468.176-.841.528-1.118.352-.277.817-.416 1.397-.416.604 0 1.16.111 1.667.333l-.221.615a3.757 3.757 0 0 0-1.463-.316c-.374 0-.667.08-.877.241a.794.794 0 0 0-.316.669c0 .211.038.384.116.52.078.133.208.257.391.37.186.111.468.234.848.37.638.228 1.076.471 1.314.732.241.261.362.599.362 1.014Zm2.611 1.131a2.385 2.385 0 0 0 .623-.083v.528a1.237 1.237 0 0 1-.332.088 2.307 2.307 0 0 1-.391.037c-.882 0-1.322-.464-1.322-1.393v-2.711h-.653v-.332l.653-.287.291-.973h.399v1.056h1.322v.536h-1.322v2.682c0 .274.065.485.195.632.131.147.309.22.537.22Zm4.34.487-.137-.649h-.033c-.227.286-.455.48-.682.582-.225.1-.506.15-.844.15-.452 0-.807-.116-1.064-.349-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.773-.025v-.283c0-.357-.077-.62-.233-.789-.152-.172-.397-.258-.736-.258-.379 0-.809.116-1.288.349l-.212-.528c.224-.122.469-.218.735-.287.269-.069.538-.104.807-.104.543 0 .945.121 1.206.362.263.241.395.628.395 1.16v3.11h-.512Zm-1.559-.487c.43 0 .767-.117 1.011-.353.246-.236.37-.565.37-.99v-.411l-.691.029c-.548.019-.945.105-1.189.258-.241.149-.361.384-.361.702 0 .25.074.44.224.57.153.13.365.195.636.195Zm4.179-1.846c.119-.169.3-.39.544-.665l1.472-1.559h.819l-1.846 1.942 1.975 2.615h-.836l-1.609-2.154-.519.449v1.705h-.682v-6.47h.682v3.431c0 .152-.011.388-.034.706h.034Zm5.717 2.416c-.674 0-1.206-.205-1.597-.615-.388-.411-.582-.98-.582-1.709 0-.735.18-1.318.54-1.751.364-.432.85-.648 1.46-.648.571 0 1.023.188 1.355.565.333.374.499.869.499 1.485v.436h-3.139c.014.535.148.941.403 1.218.258.278.62.416 1.086.416.49 0 .975-.102 1.455-.308v.616a3.53 3.53 0 0 1-.695.224 3.75 3.75 0 0 1-.785.071Zm-.188-4.145c-.365 0-.658.119-.877.357-.216.239-.344.569-.382.99h2.382c0-.435-.097-.768-.291-.998-.194-.233-.471-.349-.832-.349Zm2.944 3.621c0-.186.042-.326.125-.42.086-.097.208-.145.366-.145a.48.48 0 0 1 .374.145c.091.094.137.234.137.42 0 .18-.046.319-.137.416a.49.49 0 0 1-.374.145.51.51 0 0 1-.354-.128c-.091-.089-.137-.233-.137-.433Zm0-3.671c0-.374.164-.561.491-.561.341 0 .511.187.511.561 0 .18-.046.319-.137.416a.49.49 0 0 1-.374.145.506.506 0 0 1-.354-.129c-.091-.088-.137-.233-.137-.432Z",
                className: "court-header_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M222.359 343.465h-.977v-3.925c0-.468.011-.84.033-1.114-.064.066-.143.14-.237.22-.092.08-.402.335-.931.765l-.491-.619 1.788-1.406h.815v6.079Zm3.334-.894c-.133.515-.377 1.179-.732 1.991h-.719a20.44 20.44 0 0 0 .428-2.087h.961l.062.096Zm3.809.894h-.977v-3.925c0-.468.011-.84.033-1.114-.064.066-.143.14-.237.22-.092.08-.402.335-.931.765l-.491-.619 1.788-1.406h.815v6.079Zm6.116-3.039c0 1.056-.171 1.84-.512 2.353-.338.513-.856.769-1.555.769-.676 0-1.189-.265-1.538-.794-.349-.53-.524-1.306-.524-2.328 0-1.073.169-1.863.507-2.37.341-.51.86-.765 1.555-.765.679 0 1.194.266 1.543.798s.524 1.311.524 2.337Zm-3.139 0c0 .828.084 1.42.253 1.775.172.355.445.532.819.532.374 0 .647-.18.819-.54.175-.361.262-.95.262-1.767 0-.815-.087-1.404-.262-1.767-.172-.366-.445-.549-.819-.549-.374 0-.647.178-.819.536-.169.358-.253.951-.253 1.78Zm8.003 0c0 1.056-.17 1.84-.511 2.353-.338.513-.857.769-1.555.769-.677 0-1.189-.265-1.539-.794-.349-.53-.523-1.306-.523-2.328 0-1.073.169-1.863.507-2.37.341-.51.859-.765 1.555-.765.679 0 1.193.266 1.542.798.35.532.524 1.311.524 2.337Zm-3.139 0c0 .828.085 1.42.254 1.775.172.355.445.532.819.532.374 0 .647-.18.819-.54.175-.361.262-.95.262-1.767 0-.815-.087-1.404-.262-1.767-.172-.366-.445-.549-.819-.549-.374 0-.647.178-.819.536-.169.358-.254.951-.254 1.78Zm10.548-1.202c0 .635-.208 1.121-.623 1.459-.416.338-1.008.508-1.776.508h-.632v2.274h-.993v-6.079h1.75c.759 0 1.328.155 1.705.466.379.31.569.768.569 1.372Zm-3.031 1.131h.528c.51 0 .885-.089 1.123-.266.238-.178.357-.455.357-.832 0-.349-.106-.61-.32-.781-.213-.172-.546-.258-.998-.258h-.69v2.137Zm9.309 3.11h-1.218l-2.989-4.844h-.033l.02.27c.039.516.059.987.059 1.414v3.16h-.903v-6.079h1.206l2.981 4.819h.025a28.403 28.403 0 0 1-.033-.694 23.508 23.508 0 0 1-.025-.94v-3.185h.91v6.079Zm6.245 0h-1.151l-1.909-2.753-.586.479v2.274h-.994v-6.079h.994v2.902c.272-.332.542-.652.811-.96l1.642-1.942h1.131a372.195 372.195 0 0 1-2.283 2.665l2.345 3.414Z",
                className: "court-header_svg__path-11"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__d)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M287.049 336.738h-5.529c-.612 0-1.106.476-1.106 1.065v5.322c0 .588.494 1.064 1.106 1.064h5.529c.611 0 1.106-.476 1.106-1.064v-5.322c0-.589-.494-1.065-1.106-1.065Zm-4.423 2.661a.544.544 0 0 1-.553-.532c0-.293.248-.532.553-.532.304 0 .552.239.552.532a.543.543 0 0 1-.552.532Zm3.317 3.193a.544.544 0 0 1-.553-.532c0-.293.249-.532.553-.532.304 0 .553.239.553.532a.544.544 0 0 1-.553.532Z",
                    className: "court-header_svg__path-12"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M293.212 345.066c-.26 0-.465-.038-.615-.113v-.603c.197.056.402.084.615.084.275 0 .483-.084.624-.25.144-.166.216-.406.216-.719v-6.079h.707v6.021c0 .526-.133.934-.399 1.222-.266.291-.649.437-1.148.437Zm3.709-6.158v2.956c0 .372.085.649.254.832.169.183.433.274.794.274.476 0 .824-.13 1.043-.391.222-.26.333-.686.333-1.276v-2.395h.69v4.557h-.569l-.1-.611h-.038a1.372 1.372 0 0 1-.59.515c-.25.119-.535.179-.857.179-.554 0-.97-.132-1.247-.395-.274-.263-.411-.685-.411-1.264v-2.981h.698Zm6.661-.083c.202 0 .384.016.544.05l-.095.64a2.327 2.327 0 0 0-.499-.062c-.369 0-.685.149-.948.449-.261.299-.391.672-.391 1.118v2.445h-.69v-4.557h.569l.079.844h.034c.169-.297.372-.525.611-.686.238-.161.5-.241.786-.241Zm5.33 2.357c0 .743-.187 1.324-.561 1.742-.375.416-.892.624-1.551.624-.408 0-.769-.096-1.085-.287a1.896 1.896 0 0 1-.732-.823c-.172-.358-.258-.776-.258-1.256 0-.743.186-1.321.557-1.734.372-.415.887-.623 1.547-.623.637 0 1.143.212 1.517.636.377.424.566.998.566 1.721Zm-3.472 0c0 .582.117 1.026.349 1.331.233.305.576.457 1.027.457.452 0 .794-.151 1.027-.453.236-.305.354-.75.354-1.335 0-.579-.118-1.018-.354-1.318-.233-.302-.578-.453-1.035-.453-.452 0-.793.148-1.023.445-.23.297-.345.739-.345 1.326Zm6.765-2.357c.202 0 .384.016.544.05l-.095.64a2.327 2.327 0 0 0-.499-.062c-.369 0-.685.149-.948.449-.261.299-.391.672-.391 1.118v2.445h-.69v-4.557h.57l.079.844h.033c.169-.297.373-.525.611-.686.238-.161.5-.241.786-.241Zm8.989 1.592c0 .973-.247 1.738-.74 2.295-.491.557-1.174.836-2.05.836-.895 0-1.587-.273-2.075-.819-.485-.549-.727-1.322-.727-2.32 0-.99.244-1.756.731-2.299.488-.546 1.181-.819 2.079-.819.873 0 1.555.277 2.046.831.49.555.736 1.32.736 2.295Zm-4.844 0c0 .823.175 1.449.524 1.875.352.424.862.636 1.53.636.673 0 1.182-.212 1.526-.636.344-.424.515-1.049.515-1.875 0-.817-.171-1.437-.515-1.858-.341-.424-.847-.636-1.518-.636-.673 0-1.186.213-1.538.64-.349.424-.524 1.042-.524 1.854Zm9.201 2.437h-.037c-.319.463-.796.694-1.431.694-.596 0-1.06-.204-1.392-.611-.33-.408-.495-.987-.495-1.738s.166-1.335.499-1.751c.332-.415.795-.623 1.388-.623.618 0 1.092.224 1.422.673h.054l-.029-.328-.016-.32v-1.855h.69v6.47h-.561l-.092-.611Zm-1.38.116c.471 0 .812-.127 1.022-.382.214-.258.321-.673.321-1.244v-.145c0-.646-.108-1.106-.325-1.38-.213-.278-.555-.416-1.027-.416-.404 0-.715.158-.931.474-.213.313-.32.756-.32 1.33 0 .582.107 1.022.32 1.318.213.297.527.445.94.445Zm6.602-.116h-.037c-.319.463-.796.694-1.431.694-.595 0-1.06-.204-1.392-.611-.33-.408-.495-.987-.495-1.738s.166-1.335.499-1.751c.332-.415.795-.623 1.388-.623.619 0 1.093.224 1.422.673h.054l-.029-.328-.016-.32v-1.855h.69v6.47h-.561l-.092-.611Zm-1.38.116c.471 0 .812-.127 1.023-.382.213-.258.32-.673.32-1.244v-.145c0-.646-.108-1.106-.325-1.38-.213-.278-.555-.416-1.027-.416-.404 0-.715.158-.931.474-.213.313-.32.756-.32 1.33 0 .582.107 1.022.32 1.318.214.297.527.445.94.445Zm6.44-.748c0 .424-.158.751-.474.981-.316.23-.759.345-1.33.345-.605 0-1.076-.096-1.414-.287v-.64c.219.111.453.198.703.262.252.064.494.095.727.095.361 0 .638-.056.832-.17a.575.575 0 0 0 .291-.528.562.562 0 0 0-.233-.453c-.152-.128-.452-.277-.898-.449-.424-.158-.726-.296-.906-.412a1.287 1.287 0 0 1-.4-.403 1.072 1.072 0 0 1-.128-.537c0-.371.151-.663.453-.877.302-.216.716-.324 1.243-.324.491 0 .97.1 1.438.299l-.245.561c-.457-.188-.872-.282-1.243-.282-.327 0-.574.051-.74.154a.476.476 0 0 0-.25.424c0 .122.031.226.092.312a.974.974 0 0 0 .303.245c.139.077.405.19.799.337.54.196.905.395 1.093.594.191.2.287.451.287.753Zm1.027.802c0-.186.042-.326.125-.42.086-.097.208-.145.366-.145.16 0 .285.048.374.145.091.094.137.234.137.42 0 .18-.046.319-.137.416a.49.49 0 0 1-.374.145.508.508 0 0 1-.354-.128c-.091-.089-.137-.233-.137-.433Zm0-3.671c0-.374.164-.561.491-.561.341 0 .511.187.511.561 0 .18-.046.319-.137.416a.49.49 0 0 1-.374.145.504.504 0 0 1-.354-.129c-.091-.088-.137-.233-.137-.432Z",
                className: "court-header_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m345.911 343.465 2.403-5.21h-3.159v-.86h4.203v.681l-2.391 5.389h-1.056Zm4.353-.52c0-.202.053-.357.158-.466.106-.108.258-.162.458-.162.202 0 .356.057.461.171.106.111.158.263.158.457 0 .197-.054.354-.162.47-.105.114-.258.17-.457.17-.2 0-.352-.056-.458-.17-.105-.114-.158-.27-.158-.47Zm4.22-5.638c.577 0 1.033.133 1.368.399.336.264.503.617.503 1.061 0 .623-.374 1.119-1.122 1.488.477.238.815.489 1.014.753.203.263.304.557.304.881 0 .502-.184.904-.553 1.206-.369.302-.868.453-1.497.453-.66 0-1.171-.141-1.534-.424-.363-.283-.545-.683-.545-1.202 0-.338.094-.641.283-.91.191-.272.503-.513.935-.724-.371-.221-.636-.456-.794-.702a1.51 1.51 0 0 1-.237-.832c0-.441.174-.791.52-1.052.347-.263.798-.395 1.355-.395Zm-1.126 4.582c0 .288.101.513.303.674.203.158.477.237.823.237.358 0 .635-.082.832-.246.2-.166.299-.391.299-.673 0-.225-.091-.43-.274-.616-.183-.185-.46-.357-.832-.515l-.12-.054c-.366.161-.629.338-.79.532a.996.996 0 0 0-.241.661Zm1.118-3.829c-.277 0-.5.069-.669.208a.676.676 0 0 0-.254.557.8.8 0 0 0 .092.386c.061.114.149.218.266.312.116.092.313.203.59.333.333-.147.567-.301.703-.462a.855.855 0 0 0 .208-.569.67.67 0 0 0-.258-.557c-.169-.139-.395-.208-.678-.208Zm6.939 2.366c0 1.056-.17 1.84-.511 2.353-.338.513-.857.769-1.555.769-.676 0-1.189-.265-1.538-.794-.35-.53-.524-1.306-.524-2.328 0-1.073.169-1.863.507-2.37.341-.51.859-.765 1.555-.765.679 0 1.193.266 1.542.798.35.532.524 1.311.524 2.337Zm-3.139 0c0 .828.085 1.42.254 1.775.172.355.445.532.819.532.374 0 .647-.18.819-.54.175-.361.262-.95.262-1.767 0-.815-.087-1.404-.262-1.767-.172-.366-.445-.549-.819-.549-.374 0-.647.178-.819.536-.169.358-.254.951-.254 1.78Zm4.669-1.219c0 .413.041.721.121.923.08.203.212.304.395.304.366 0 .549-.409.549-1.227 0-.817-.183-1.226-.549-1.226-.183 0-.315.101-.395.303-.08.203-.121.51-.121.923Zm1.871-.008c0 .638-.115 1.117-.345 1.439-.227.318-.564.478-1.01.478-.421 0-.748-.165-.981-.495-.23-.333-.345-.807-.345-1.422 0-1.267.442-1.9 1.326-1.9.435 0 .769.165 1.002.495.236.327.353.795.353 1.405Zm2.088 2.436c0 .413.04.723.12.928.083.205.216.307.399.307.363 0 .545-.411.545-1.235 0-.812-.182-1.218-.545-1.218-.183 0-.316.1-.399.3-.08.199-.12.505-.12.918Zm1.871 0c0 .638-.116 1.116-.346 1.435-.23.319-.565.478-1.006.478-.421 0-.748-.164-.981-.491-.233-.329-.349-.803-.349-1.422 0-1.266.443-1.9 1.33-1.9.427 0 .758.164.994.491.238.327.358.797.358 1.409Zm-1.235-4.249-3.372 6.079h-.807l3.372-6.079h.807Z",
                className: "court-header_svg__path-14"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "court-header_svg__line-1",
                d: "M21.463 85.844h346.074"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "court-header_svg__line-2",
                d: "M21.463 234.86h346.074"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M24.972 65.811h2.066v2.956c-.321.103-.648.18-.98.233a7.48 7.48 0 0 1-1.157.08c-.92 0-1.636-.274-2.15-.82-.512-.549-.768-1.316-.768-2.303 0-.632.126-1.185.378-1.66a2.57 2.57 0 0 1 1.098-1.088c.476-.253 1.035-.379 1.675-.379.649 0 1.253.12 1.813.358l-.274.623c-.55-.232-1.077-.349-1.585-.349-.74 0-1.318.22-1.733.661-.416.441-.624 1.052-.624 1.834 0 .82.2 1.443.599 1.867.402.424.99.636 1.767.636.421 0 .833-.049 1.235-.146v-1.87h-1.36v-.633Zm5.351 3.268c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.364-.433.85-.649 1.46-.649.571 0 1.023.189 1.356.566.332.374.498.868.498 1.484v.436H28.86c.014.535.149.941.404 1.219.257.277.62.415 1.085.415.49 0 .976-.102 1.455-.307v.615c-.244.105-.475.18-.694.225a3.75 3.75 0 0 1-.786.07Zm-.187-4.145c-.366 0-.658.12-.877.358-.217.238-.344.568-.383.99h2.383c0-.436-.098-.769-.292-.999-.194-.233-.47-.349-.831-.349Zm6.162 4.062v-2.948c0-.371-.085-.648-.254-.831-.17-.183-.434-.275-.794-.275-.477 0-.826.13-1.048.387-.222.258-.332.683-.332 1.276v2.391h-.69V64.44h.56l.113.624h.033c.142-.225.34-.398.595-.52.255-.125.539-.187.852-.187.549 0 .962.133 1.239.4.277.263.416.685.416 1.267v2.973h-.69Zm4.037.083c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.364-.433.85-.649 1.46-.649.571 0 1.023.189 1.355.566.333.374.5.868.5 1.484v.436h-3.14c.014.535.149.941.404 1.219.257.277.62.415 1.085.415.49 0 .975-.102 1.455-.307v.615c-.244.105-.475.18-.694.225-.217.047-.479.07-.786.07Zm-.187-4.145c-.366 0-.659.12-.878.358-.216.238-.343.568-.382.99h2.382c0-.436-.097-.769-.29-.999-.195-.233-.472-.349-.832-.349Zm5.122-.578c.202 0 .384.017.545.05l-.096.64a2.35 2.35 0 0 0-.499-.062c-.369 0-.684.15-.948.449-.26.3-.39.672-.39 1.118v2.445h-.69V64.44h.569l.079.844h.033c.17-.296.373-.525.611-.686.239-.16.5-.24.786-.24Zm4.2 4.64-.138-.648H49.3c-.227.285-.455.479-.682.582-.225.1-.506.15-.844.15-.452 0-.807-.117-1.064-.35-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.773-.025v-.282c0-.358-.078-.621-.233-.79-.152-.172-.398-.258-.736-.258-.38 0-.809.116-1.288.35l-.213-.529c.225-.122.47-.217.736-.287a3.22 3.22 0 0 1 .807-.104c.543 0 .945.121 1.206.362.263.241.395.628.395 1.16v3.11h-.512Zm-1.56-.486c.43 0 .767-.118 1.01-.354.247-.235.37-.565.37-.99v-.41l-.69.028c-.549.02-.945.105-1.189.258-.24.15-.361.384-.361.703 0 .25.074.439.224.57.152.13.364.195.636.195Zm4.187.486h-.69v-6.47h.69v6.47Zm6.382-5.534c-.668 0-1.196.223-1.584.67-.385.443-.578 1.051-.578 1.825 0 .795.186 1.41.557 1.846.374.432.907.648 1.597.648.424 0 .908-.076 1.45-.228v.62c-.42.157-.94.236-1.558.236-.896 0-1.587-.271-2.075-.815-.485-.543-.728-1.315-.728-2.316 0-.626.117-1.175.35-1.646a2.539 2.539 0 0 1 1.014-1.09c.444-.254.965-.382 1.563-.382.638 0 1.195.117 1.672.35l-.3.606a3.221 3.221 0 0 0-1.38-.324Zm6.598 3.251c0 .743-.187 1.324-.56 1.743-.375.415-.892.623-1.552.623-.407 0-.769-.095-1.085-.287a1.894 1.894 0 0 1-.732-.823c-.172-.357-.258-.776-.258-1.255 0-.743.186-1.321.558-1.734.371-.416.887-.624 1.546-.624.638 0 1.144.212 1.518.636.377.424.565.998.565 1.721Zm-3.471 0c0 .583.116 1.026.349 1.331.233.305.575.457 1.027.457.452 0 .794-.15 1.027-.453.235-.305.353-.75.353-1.335 0-.579-.118-1.018-.353-1.317-.233-.303-.578-.454-1.035-.454-.452 0-.793.149-1.023.445-.23.297-.345.739-.345 1.326Zm5.334-2.274v2.956c0 .372.085.649.254.832.169.183.433.274.794.274.477 0 .824-.13 1.043-.39.222-.261.333-.687.333-1.277V64.44h.69v4.557h-.57l-.1-.611h-.037a1.373 1.373 0 0 1-.59.515c-.25.12-.535.18-.857.18-.554 0-.97-.132-1.247-.396-.274-.263-.412-.684-.412-1.264v-2.98h.699Zm6.66-.083c.203 0 .385.017.545.05l-.095.64a2.35 2.35 0 0 0-.5-.062c-.368 0-.684.15-.947.449-.26.3-.391.672-.391 1.118v2.445h-.69V64.44h.57l.078.844h.034c.169-.296.373-.525.61-.686.24-.16.501-.24.787-.24Zm2.87 4.154c.121 0 .24-.009.353-.025.114-.02.204-.04.27-.058v.527a1.219 1.219 0 0 1-.333.088 2.306 2.306 0 0 1-.39.037c-.882 0-1.322-.464-1.322-1.393v-2.71h-.653v-.333l.653-.287.29-.973h.4v1.056h1.322v.537h-1.322v2.681c0 .275.065.485.195.632.13.147.31.22.536.22Z",
                className: "court-header_svg__path-15"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m85.368 62.917-2.266 6.08h-.69l2.266-6.08h.69Z",
                className: "court-header_svg__path-16"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M92.03 62.917h1.717c.807 0 1.39.121 1.75.362.36.241.541.622.541 1.144 0 .36-.101.658-.303.894-.2.232-.492.383-.878.453v.041c.923.158 1.385.643 1.385 1.455 0 .544-.184.968-.553 1.273-.366.305-.879.457-1.538.457H92.03v-6.078Zm.707 2.603H93.9c.499 0 .858-.077 1.077-.233.219-.158.328-.422.328-.794 0-.34-.122-.586-.366-.736-.243-.152-.632-.228-1.164-.228h-1.04v1.991Zm0 .599v2.274h1.268c.49 0 .86-.094 1.106-.282.25-.192.374-.49.374-.894 0-.377-.127-.655-.382-.832-.253-.177-.638-.266-1.156-.266h-1.21Zm5.4 2.877h-.69v-6.47h.69v6.47Zm5.397-2.282c0 .742-.187 1.323-.561 1.742-.374.415-.891.623-1.551.623-.407 0-.769-.095-1.085-.287a1.894 1.894 0 0 1-.732-.823c-.172-.357-.257-.776-.257-1.255 0-.743.185-1.321.557-1.734.371-.416.887-.624 1.546-.624.638 0 1.144.212 1.518.636.377.424.565.998.565 1.721Zm-3.471 0c0 .582.116 1.025.349 1.33.233.305.575.457 1.027.457.452 0 .794-.15 1.027-.453.236-.305.353-.75.353-1.335 0-.579-.117-1.018-.353-1.317-.233-.303-.578-.454-1.035-.454-.452 0-.793.149-1.023.445-.23.297-.345.739-.345 1.326Zm6.507 2.365c-.66 0-1.172-.202-1.535-.607-.36-.407-.54-.982-.54-1.725 0-.763.183-1.352.549-1.767.368-.416.892-.624 1.571-.624.219 0 .438.024.657.07.219.048.391.103.516.167l-.212.586a3.12 3.12 0 0 0-.499-.15 2.163 2.163 0 0 0-.478-.062c-.926 0-1.389.59-1.389 1.772 0 .56.112.989.337 1.288.227.3.562.45 1.006.45.38 0 .769-.082 1.168-.246v.611c-.305.158-.689.237-1.151.237Zm2.918-2.415c.119-.17.301-.391.545-.666l1.472-1.559h.819l-1.846 1.942 1.975 2.615h-.836l-1.609-2.154-.52.45v1.704h-.682v-6.47h.682v3.43c0 .153-.011.389-.033.708h.033Zm5.613 2.415c-.659 0-1.171-.202-1.534-.607-.36-.407-.54-.982-.54-1.725 0-.763.182-1.352.548-1.767.369-.416.893-.624 1.572-.624.219 0 .438.024.657.07.219.048.391.103.515.167l-.212.586a3.06 3.06 0 0 0-.499-.15 2.156 2.156 0 0 0-.478-.062c-.925 0-1.388.59-1.388 1.772 0 .56.112.989.336 1.288.228.3.563.45 1.007.45.379 0 .769-.082 1.168-.246v.611c-.305.158-.689.237-1.152.237Zm5.355-.083v-2.948c0-.371-.084-.648-.253-.831-.169-.183-.434-.275-.794-.275-.48 0-.831.13-1.052.391-.219.26-.329.688-.329 1.28v2.383h-.69v-6.47h.69v1.959a4.3 4.3 0 0 1-.033.586h.042c.135-.219.328-.39.577-.515.253-.128.54-.192.861-.192.557 0 .974.133 1.252.4.28.263.42.683.42 1.26v2.972h-.691Zm4.915 0-.137-.648h-.034c-.227.285-.454.479-.682.582-.224.1-.505.15-.844.15-.451 0-.806-.117-1.064-.35-.255-.233-.382-.564-.382-.994 0-.92.735-1.402 2.207-1.447l.774-.025v-.282c0-.358-.078-.621-.233-.79-.153-.172-.398-.258-.736-.258-.38 0-.809.116-1.289.35l-.212-.529c.224-.122.47-.217.736-.287.269-.069.538-.104.806-.104.544 0 .946.121 1.206.362.264.241.395.628.395 1.16v3.11h-.511Zm-1.559-.486c.429 0 .766-.118 1.01-.354.247-.235.37-.565.37-.99v-.41l-.69.028c-.549.02-.945.105-1.189.258-.241.15-.362.384-.362.703 0 .25.075.439.225.57.152.13.364.195.636.195Zm4.186.486h-.69V64.44h.69v4.557Zm-.748-5.792c0-.158.039-.273.116-.345a.405.405 0 0 1 .292-.112c.11 0 .206.038.286.112.081.075.121.19.121.345 0 .156-.04.272-.121.35a.405.405 0 0 1-.286.112.404.404 0 0 1-.292-.112c-.077-.078-.116-.194-.116-.35Zm5.33 5.792v-2.948c0-.371-.084-.648-.253-.831-.169-.183-.434-.275-.794-.275-.477 0-.826.13-1.048.387-.222.258-.333.683-.333 1.276v2.391h-.69V64.44h.561l.113.624h.033c.141-.225.339-.398.594-.52.255-.125.539-.187.853-.187.548 0 .961.133 1.239.4.277.263.415.685.415 1.267v2.973h-.69Z",
                className: "court-header_svg__path-17"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m142.099 62.917-2.266 6.08h-.69l2.266-6.08h.69Z",
                className: "court-header_svg__path-18"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M153.51 68.996h-.807l-3.322-5.101h-.033c.044.598.066 1.147.066 1.646v3.455h-.653v-6.078h.799l3.313 5.08h.034a44.573 44.573 0 0 1-.038-.719 12.418 12.418 0 0 1-.02-.873v-3.489h.661v6.08Zm5.5-2.282c0 .742-.187 1.323-.561 1.742-.374.415-.891.623-1.551.623-.407 0-.769-.095-1.085-.287a1.895 1.895 0 0 1-.732-.823c-.172-.357-.258-.776-.258-1.255 0-.743.186-1.321.558-1.734.371-.416.887-.624 1.546-.624.638 0 1.144.212 1.518.636.377.424.565.998.565 1.721Zm-3.471 0c0 .582.116 1.025.349 1.33.233.305.575.457 1.027.457.452 0 .794-.15 1.027-.453.235-.305.353-.75.353-1.335 0-.579-.118-1.018-.353-1.317-.233-.303-.578-.454-1.036-.454-.451 0-.792.149-1.022.445-.23.297-.345.739-.345 1.326Zm7.804 2.282v-2.948c0-.371-.085-.648-.254-.831-.169-.183-.434-.275-.794-.275-.477 0-.826.13-1.048.387-.222.258-.333.683-.333 1.276v2.391h-.69V64.44h.562l.112.624h.033c.141-.225.34-.398.595-.52.255-.125.539-.187.852-.187.549 0 .962.133 1.239.4.277.263.416.685.416 1.267v2.973h-.69Zm1.729-1.966v-.633h2.042v.632h-2.042Zm5.102 1.966h-.707v-5.45h-1.925v-.629h4.557v.628h-1.925v5.451Zm4.665.083c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.541-1.75.363-.433.849-.649 1.459-.649.571 0 1.023.189 1.355.566.333.374.499.868.499 1.484v.436h-3.139c.014.535.148.941.403 1.219.258.277.62.415 1.086.415.49 0 .975-.102 1.455-.307v.615c-.244.105-.476.18-.694.225-.217.047-.479.07-.786.07Zm-.187-4.145c-.366 0-.659.12-.878.358-.216.238-.343.568-.382.99h2.382c0-.436-.097-.769-.291-.999-.194-.233-.471-.349-.831-.349Zm4.864 4.145c-.66 0-1.171-.202-1.534-.607-.36-.407-.541-.982-.541-1.725 0-.763.183-1.352.549-1.767.369-.416.893-.624 1.572-.624.219 0 .438.024.657.07.219.048.391.103.515.167l-.212.586a3.06 3.06 0 0 0-.499-.15 2.156 2.156 0 0 0-.478-.062c-.926 0-1.388.59-1.388 1.772 0 .56.112.989.336 1.288.228.3.563.45 1.006.45.38 0 .77-.082 1.169-.246v.611c-.305.158-.689.237-1.152.237Zm5.355-.083v-2.948c0-.371-.084-.648-.253-.831-.169-.183-.434-.275-.794-.275-.48 0-.831.13-1.052.391-.219.26-.329.688-.329 1.28v2.383h-.69v-6.47h.69v1.959a4.3 4.3 0 0 1-.033.586h.041a1.4 1.4 0 0 1 .578-.515c.253-.128.54-.192.861-.192.557 0 .974.133 1.252.4.279.263.419.683.419 1.26v2.972h-.69Zm5.231 0v-2.948c0-.371-.085-.648-.254-.831-.169-.183-.434-.275-.794-.275-.477 0-.826.13-1.048.387-.222.258-.332.683-.332 1.276v2.391h-.691V64.44h.562l.112.624h.033a1.4 1.4 0 0 1 .595-.52c.255-.125.539-.187.852-.187.549 0 .962.133 1.239.4.277.263.416.685.416 1.267v2.973h-.69Zm2.802 0h-.69V64.44h.69v4.557Zm-.748-5.792c0-.158.038-.273.116-.345a.404.404 0 0 1 .291-.112c.111 0 .207.038.287.112.08.075.121.19.121.345 0 .156-.041.272-.121.35a.406.406 0 0 1-.287.112.404.404 0 0 1-.291-.112c-.078-.078-.116-.194-.116-.35Zm4.033 5.875c-.66 0-1.172-.202-1.535-.607-.36-.407-.54-.982-.54-1.725 0-.763.183-1.352.549-1.767.368-.416.892-.624 1.571-.624.219 0 .438.024.657.07.219.048.391.103.516.167l-.212.586a3.12 3.12 0 0 0-.499-.15 2.163 2.163 0 0 0-.478-.062c-.926 0-1.389.59-1.389 1.772 0 .56.112.989.337 1.288.227.3.562.45 1.006.45.38 0 .769-.082 1.168-.246v.611c-.305.158-.689.237-1.151.237Zm5.039-.083-.137-.648h-.034c-.227.285-.454.479-.682.582-.224.1-.505.15-.844.15-.451 0-.806-.117-1.064-.35-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.774-.025v-.282c0-.358-.078-.621-.233-.79-.153-.172-.398-.258-.736-.258-.38 0-.81.116-1.289.35l-.212-.529c.224-.122.47-.217.736-.287.269-.069.538-.104.806-.104.544 0 .946.121 1.206.362.263.241.395.628.395 1.16v3.11h-.511Zm-1.559-.486c.429 0 .766-.118 1.01-.354.247-.235.37-.565.37-.99v-.41l-.69.028c-.549.02-.945.105-1.189.258-.241.15-.362.384-.362.703 0 .25.075.439.224.57.153.13.365.195.637.195Zm4.186.486h-.69v-6.47h.69v6.47Z",
                className: "court-header_svg__path-19"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m212.831 62.917-2.266 6.08h-.69l2.266-6.08h.69Z",
                className: "court-header_svg__path-20"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M221.559 68.996h-.993V63.77h-1.788v-.853h4.569v.853h-1.788v5.226Zm6.698-2.307c0 .75-.192 1.337-.578 1.758-.385.422-.921.632-1.609.632-.429 0-.809-.097-1.139-.29a1.924 1.924 0 0 1-.761-.837c-.177-.363-.266-.784-.266-1.263 0-.746.192-1.328.574-1.747.383-.418.922-.627 1.617-.627.666 0 1.192.214 1.58.644.388.427.582 1.003.582 1.73Zm-3.347 0c0 1.061.393 1.592 1.177 1.592.776 0 1.164-.53 1.164-1.592 0-1.051-.391-1.576-1.172-1.576-.41 0-.708.136-.894.407-.183.272-.275.661-.275 1.169Zm5.418-.121.553-.69 1.389-1.48h1.126l-1.85 1.975 1.967 2.623h-1.148l-1.476-2.016-.536.44v1.576h-.969v-6.47h.969v3.156l-.05.886h.025Zm5.937 2.511c-.715 0-1.275-.208-1.68-.623-.401-.419-.602-.994-.602-1.726 0-.751.187-1.341.561-1.771.374-.43.888-.645 1.542-.645.607 0 1.087.185 1.439.554.352.368.528.875.528 1.521v.528h-3.064c.014.447.134.79.361 1.031.228.239.548.358.961.358.272 0 .524-.025.757-.075.235-.053.487-.138.756-.258v.794a2.991 2.991 0 0 1-.723.242c-.244.047-.523.07-.836.07Zm-.179-4.024c-.31 0-.56.098-.748.295-.186.197-.297.484-.333.86h2.088c-.006-.38-.097-.666-.275-.86-.177-.197-.421-.295-.732-.295Zm7.123 3.941h-.982V66.17c0-.355-.072-.62-.216-.794-.141-.175-.367-.262-.678-.262-.413 0-.715.122-.906.366-.191.244-.287.652-.287 1.226v2.291h-.977v-4.598h.765l.137.603h.05c.139-.22.336-.389.591-.508.255-.119.537-.178.848-.178 1.103 0 1.655.56 1.655 1.683v2.998Zm3.675 0v-6.078h.994v5.226h2.573v.852h-3.567Zm5.488 0h-.977v-4.598h.977v4.598Zm-1.035-5.817c0-.174.047-.309.141-.403.097-.094.234-.141.412-.141.172 0 .305.047.399.141.097.094.146.229.146.403a.534.534 0 0 1-.146.395c-.094.095-.227.142-.399.142-.178 0-.315-.047-.412-.142a.543.543 0 0 1-.141-.395Zm5.526 4.507c0 .45-.164.794-.491 1.036-.327.238-.796.357-1.405.357-.613 0-1.105-.093-1.476-.278v-.844c.54.25 1.043.374 1.509.374.601 0 .902-.182.902-.545a.43.43 0 0 0-.1-.29 1.176 1.176 0 0 0-.328-.242 5.754 5.754 0 0 0-.636-.283c-.53-.205-.889-.41-1.077-.615-.186-.205-.279-.471-.279-.798 0-.394.158-.699.474-.915.319-.219.751-.329 1.297-.329.541 0 1.052.11 1.535.329l-.316.736c-.496-.205-.914-.308-1.252-.308-.515 0-.773.147-.773.44 0 .145.066.267.199.367.136.1.43.237.882.411.38.147.655.282.827.404.172.122.3.263.383.424.083.158.125.348.125.57Zm2.773.603c.238 0 .476-.037.715-.112v.736a1.895 1.895 0 0 1-.42.116c-.169.034-.345.05-.528.05-.926 0-1.389-.488-1.389-1.463v-2.478h-.628v-.433l.674-.357.333-.973h.602v1.023h1.31v.74h-1.31v2.461c0 .236.059.41.175.524.119.11.274.166.466.166Zm2.615.707h-.977v-4.598h.977v4.598Zm-1.035-5.817c0-.174.047-.309.141-.403.097-.094.234-.141.412-.141.171 0 .305.047.399.141.097.094.145.229.145.403a.533.533 0 0 1-.145.395c-.094.095-.228.142-.399.142-.178 0-.315-.047-.412-.142a.543.543 0 0 1-.141-.395Zm6.482 5.817h-.982V66.17c0-.355-.072-.62-.216-.794-.141-.175-.367-.262-.678-.262-.413 0-.715.122-.906.366-.191.244-.287.652-.287 1.226v2.291h-.977v-4.598h.765l.137.603h.05c.139-.22.336-.389.591-.508.255-.119.537-.178.848-.178 1.103 0 1.655.56 1.655 1.683v2.998Zm5.242-4.598v.536l-.785.145a1.414 1.414 0 0 1 .249.807c0 .474-.163.847-.491 1.118-.327.272-.777.408-1.351.408-.147 0-.28-.011-.399-.033-.211.13-.316.282-.316.457 0 .105.049.184.146.237.099.053.281.08.544.08h.803c.507 0 .892.107 1.156.323.263.217.395.528.395.936 0 .521-.215.923-.645 1.206-.43.282-1.05.424-1.863.424-.626 0-1.104-.111-1.434-.333-.33-.222-.495-.538-.495-.948 0-.283.089-.521.266-.715.18-.191.431-.324.753-.4a.748.748 0 0 1-.324-.265.689.689 0 0 1-.125-.391c0-.172.048-.317.145-.437a1.67 1.67 0 0 1 .433-.353 1.29 1.29 0 0 1-.582-.499 1.494 1.494 0 0 1-.221-.815c0-.499.157-.885.47-1.16.316-.274.765-.412 1.347-.412.131 0 .266.01.408.03a2.4 2.4 0 0 1 .324.054h1.592Zm-3.613 5.313c0 .21.095.373.283.487.191.113.459.17.803.17.532 0 .928-.076 1.189-.228.26-.153.39-.355.39-.608 0-.2-.072-.342-.216-.428-.141-.083-.406-.124-.794-.124h-.74c-.28 0-.503.065-.669.195a.655.655 0 0 0-.246.536Zm.42-3.825c0 .288.074.51.221.665.149.156.363.233.64.233.565 0 .848-.302.848-.906 0-.3-.071-.53-.212-.69-.139-.164-.351-.246-.636-.246-.283 0-.498.08-.645.242-.144.16-.216.394-.216.702Z",
                className: "court-header_svg__path-21"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M26.438 36.46h-1.704v-8.958H21.67V26.04h7.833v1.46h-3.065v8.96Zm11.482-3.955c0 1.288-.33 2.293-.99 3.015-.66.722-1.58 1.083-2.759 1.083-.736 0-1.387-.166-1.953-.498-.565-.333-1-.81-1.304-1.433-.304-.622-.456-1.345-.456-2.167 0-1.278.328-2.276.983-2.993.656-.718 1.58-1.077 2.773-1.077 1.14 0 2.043.369 2.709 1.105.665.732.997 1.72.997 2.965Zm-5.737 0c0 1.82.672 2.73 2.017 2.73 1.33 0 1.995-.91 1.995-2.73 0-1.8-.67-2.701-2.01-2.701-.703 0-1.214.233-1.532.698-.313.466-.47 1.134-.47 2.003Zm9.287-.207.948-1.183 2.38-2.537h1.932l-3.172 3.386 3.371 4.497h-1.967l-2.53-3.457-.92.756v2.7h-1.66V25.37h1.66v5.41l-.085 1.518h.043Zm10.178 4.305c-1.226 0-2.186-.356-2.88-1.069-.689-.717-1.033-1.703-1.033-2.958 0-1.287.32-2.3.962-3.036.642-.736 1.523-1.105 2.644-1.105 1.041 0 1.863.316 2.467.948.603.632.905 1.502.905 2.609v.905H49.46c.023.765.23 1.354.62 1.768.39.408.938.613 1.646.613.466 0 .898-.043 1.297-.128.404-.09.837-.238 1.298-.442v1.36a5.144 5.144 0 0 1-1.24.414c-.419.081-.896.121-1.433.121Zm-.307-6.899c-.532 0-.96.169-1.282.506-.319.337-.509.83-.57 1.476h3.577c-.01-.651-.166-1.143-.47-1.476-.304-.337-.722-.506-1.255-.506Zm12.21 6.757h-1.682v-4.847c0-.608-.124-1.062-.37-1.361-.243-.3-.63-.45-1.163-.45-.708 0-1.226.21-1.553.628-.328.418-.492 1.12-.492 2.103v3.927h-1.675v-7.883h1.311l.236 1.033h.085a2.333 2.333 0 0 1 1.012-.87 3.392 3.392 0 0 1 1.454-.306c1.891 0 2.837.963 2.837 2.887v5.139Zm6.3 0V26.04h1.704V35h4.412v1.46h-6.115Zm9.409 0h-1.675v-7.883h1.675v7.883Zm-1.775-9.971c0-.3.081-.53.243-.692.166-.161.401-.242.705-.242.295 0 .523.08.684.242.167.162.25.392.25.692 0 .285-.083.51-.25.677-.161.161-.39.242-.684.242-.304 0-.54-.08-.706-.242-.161-.167-.242-.392-.242-.678Zm9.473 7.726c0 .77-.28 1.361-.841 1.774-.561.41-1.364.613-2.41.613-1.05 0-1.893-.159-2.53-.477v-1.447c.927.428 1.79.642 2.587.642 1.032 0 1.547-.312 1.547-.934a.74.74 0 0 0-.17-.5c-.115-.132-.303-.27-.564-.413a9.71 9.71 0 0 0-1.09-.484c-.908-.352-1.523-.703-1.846-1.055-.319-.352-.478-.808-.478-1.368 0-.675.27-1.198.813-1.569.546-.375 1.287-.563 2.223-.563.927 0 1.804.188 2.63.563l-.541 1.262c-.85-.352-1.566-.527-2.146-.527-.883 0-1.325.251-1.325.755 0 .247.114.456.342.627.232.171.736.407 1.51.706.652.252 1.124.482 1.42.691.294.21.512.452.655.727.142.271.214.597.214.977Zm4.754 1.033c.408 0 .817-.064 1.226-.192v1.261c-.186.081-.426.148-.72.2-.29.057-.592.085-.905.085-1.588 0-2.381-.836-2.381-2.508v-4.248h-1.076v-.742l1.154-.613.57-1.668h1.034v1.754h2.245v1.269h-2.245v4.22c0 .403.1.702.3.897.204.19.47.285.798.285Zm4.483 1.212H94.52v-7.883h1.675v7.883ZM94.42 26.49c0-.3.08-.53.242-.692.167-.161.402-.242.706-.242.295 0 .523.08.684.242.167.162.25.392.25.692 0 .285-.083.51-.25.677-.161.161-.39.242-.684.242-.304 0-.54-.08-.706-.242-.161-.167-.242-.392-.242-.678Zm11.112 9.97h-1.682v-4.846c0-.608-.124-1.062-.371-1.361-.242-.3-.629-.45-1.162-.45-.708 0-1.225.21-1.553.628-.328.418-.492 1.12-.492 2.103v3.927h-1.675v-7.883h1.311l.236 1.033h.085a2.335 2.335 0 0 1 1.012-.87 3.392 3.392 0 0 1 1.454-.306c1.891 0 2.837.963 2.837 2.887v5.139Zm8.988-7.882v.92l-1.347.249a2.412 2.412 0 0 1 .427 1.383c0 .812-.28 1.451-.841 1.917-.56.466-1.333.698-2.316.698-.252 0-.48-.019-.684-.057-.362.224-.542.485-.542.784 0 .18.083.316.249.407.171.09.483.135.934.135h1.376c.869 0 1.53.185 1.981.556.452.37.677.905.677 1.604 0 .893-.368 1.582-1.105 2.067-.736.484-1.8.727-3.193.727-1.074 0-1.893-.19-2.459-.57-.565-.38-.848-.922-.848-1.626 0-.484.152-.893.456-1.225.309-.328.739-.556 1.29-.685a1.295 1.295 0 0 1-.556-.456 1.194 1.194 0 0 1-.213-.67c0-.294.083-.544.249-.748.166-.205.413-.407.741-.606a2.22 2.22 0 0 1-.997-.855c-.252-.4-.378-.865-.378-1.397 0-.856.268-1.519.805-1.989.542-.47 1.312-.706 2.309-.706.224 0 .457.017.699.05.247.029.432.06.556.093h2.73Zm-6.194 9.109c0 .361.162.639.485.834.327.195.786.292 1.375.292.913 0 1.592-.13 2.039-.392.446-.261.67-.608.67-1.04 0-.343-.124-.587-.371-.735-.242-.142-.696-.214-1.361-.214h-1.269c-.48 0-.862.112-1.148.335-.28.228-.42.535-.42.92Zm.72-6.557c0 .494.126.874.378 1.14.256.266.622.4 1.097.4.97 0 1.454-.519 1.454-1.555 0-.513-.121-.907-.363-1.183-.238-.28-.601-.42-1.091-.42-.484 0-.853.137-1.105.413-.247.276-.37.677-.37 1.205Z",
                className: "court-header_svg__path-22"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M244.763 190.949h-1.675v-6.728c0-.803.019-1.44.057-1.91-.109.114-.244.24-.406.377-.157.138-.689.575-1.596 1.312l-.842-1.062 3.065-2.409h1.397v10.42Zm10.093-8.025c0 .66-.193 1.211-.577 1.653-.385.437-.927.732-1.626.884v.057c.837.105 1.464.366 1.882.784.418.413.627.965.627 1.654 0 1.002-.354 1.777-1.062 2.323-.708.542-1.715.813-3.022.813-1.154 0-2.128-.188-2.922-.563v-1.49c.442.219.91.387 1.404.506.494.119.969.178 1.426.178.807 0 1.411-.149 1.81-.449.399-.299.599-.762.599-1.39 0-.556-.221-.964-.663-1.226-.442-.261-1.136-.392-2.081-.392h-.906v-1.361h.92c1.663 0 2.495-.575 2.495-1.725 0-.446-.145-.791-.435-1.033-.29-.243-.718-.364-1.283-.364-.395 0-.775.057-1.141.171-.365.11-.798.326-1.297.649l-.819-1.169c.955-.703 2.064-1.055 3.328-1.055 1.05 0 1.87.226 2.459.677.589.452.884 1.074.884 1.868Zm1.696 3.585c0-4.077 1.661-6.116 4.982-6.116.523 0 .965.041 1.326.122v1.397a4.505 4.505 0 0 0-1.254-.157c-1.117 0-1.956.299-2.516.898-.561.598-.865 1.558-.913 2.879h.086c.223-.385.537-.682.941-.891.404-.213.879-.32 1.425-.32.946 0 1.682.289 2.21.869.527.58.791 1.366.791 2.359 0 1.093-.307 1.958-.92 2.595-.608.632-1.439.948-2.494.948-.746 0-1.395-.178-1.946-.535-.551-.361-.977-.884-1.276-1.568-.294-.689-.442-1.516-.442-2.48Zm3.635 3.2c.575 0 1.017-.185 1.326-.556.314-.371.47-.9.47-1.589 0-.599-.147-1.069-.442-1.412-.289-.342-.727-.513-1.311-.513-.361 0-.694.079-.998.235a1.799 1.799 0 0 0-.72.635 1.466 1.466 0 0 0-.263.819c0 .67.18 1.236.541 1.697.366.456.832.684 1.397.684Zm6.971-.292c-.228.884-.646 2.022-1.254 3.414h-1.234c.328-1.283.573-2.476.735-3.578h1.646l.107.164Zm6.529 1.532h-1.675v-6.728c0-.803.019-1.44.057-1.91-.109.114-.245.24-.406.377a90.06 90.06 0 0 1-1.597 1.312l-.841-1.062 3.065-2.409h1.397v10.42Zm10.092-8.025c0 .66-.192 1.211-.577 1.653-.385.437-.927.732-1.625.884v.057c.836.105 1.463.366 1.882.784.418.413.627.965.627 1.654 0 1.002-.354 1.777-1.062 2.323-.708.542-1.716.813-3.022.813-1.155 0-2.129-.188-2.923-.563v-1.49c.442.219.91.387 1.405.506a6.08 6.08 0 0 0 1.425.178c.808 0 1.411-.149 1.811-.449.399-.299.598-.762.598-1.39 0-.556-.221-.964-.663-1.226-.442-.261-1.135-.392-2.081-.392h-.905v-1.361h.919c1.663 0 2.495-.575 2.495-1.725 0-.446-.145-.791-.435-1.033-.29-.243-.717-.364-1.283-.364-.394 0-.774.057-1.14.171-.366.11-.798.326-1.297.649l-.82-1.169c.955-.703 2.065-1.055 3.329-1.055 1.05 0 1.869.226 2.459.677.589.452.883 1.074.883 1.868Zm8.732 2.815c0 1.81-.293 3.155-.877 4.034-.58.879-1.468 1.319-2.666 1.319-1.159 0-2.038-.454-2.637-1.362-.599-.907-.898-2.238-.898-3.991 0-1.839.29-3.193.869-4.063.585-.874 1.474-1.311 2.666-1.311 1.164 0 2.046.456 2.644 1.368.599.913.899 2.248.899 4.006Zm-5.382 0c0 1.421.145 2.435.435 3.043.295.609.763.913 1.404.913.642 0 1.11-.309 1.404-.927.3-.618.449-1.627.449-3.029 0-1.397-.149-2.407-.449-3.029-.294-.627-.762-.941-1.404-.941-.641 0-1.109.306-1.404.919-.29.613-.435 1.63-.435 3.051Zm8.952 3.678c-.228.884-.646 2.022-1.254 3.414h-1.233c.328-1.283.573-2.476.734-3.578h1.647l.106.164Zm8.675-3.678c0 1.81-.293 3.155-.877 4.034-.58.879-1.468 1.319-2.666 1.319-1.159 0-2.038-.454-2.637-1.362-.599-.907-.898-2.238-.898-3.991 0-1.839.29-3.193.87-4.063.584-.874 1.473-1.311 2.665-1.311 1.164 0 2.046.456 2.645 1.368.598.913.898 2.248.898 4.006Zm-5.382 0c0 1.421.145 2.435.435 3.043.295.609.763.913 1.404.913.642 0 1.11-.309 1.404-.927.3-.618.449-1.627.449-3.029 0-1.397-.149-2.407-.449-3.029-.294-.627-.762-.941-1.404-.941-.641 0-1.109.306-1.404.919-.29.613-.435 1.63-.435 3.051Zm13.721 0c0 1.81-.292 3.155-.877 4.034-.58.879-1.468 1.319-2.666 1.319-1.159 0-2.038-.454-2.637-1.362-.598-.907-.898-2.238-.898-3.991 0-1.839.29-3.193.87-4.063.584-.874 1.473-1.311 2.665-1.311 1.165 0 2.046.456 2.645 1.368.598.913.898 2.248.898 4.006Zm-5.381 0c0 1.421.144 2.435.434 3.043.295.609.763.913 1.404.913.642 0 1.11-.309 1.405-.927.299-.618.449-1.627.449-3.029 0-1.397-.15-2.407-.449-3.029-.295-.627-.763-.941-1.405-.941-.641 0-1.109.306-1.404.919-.29.613-.434 1.63-.434 3.051Zm13.72 0c0 1.81-.292 3.155-.877 4.034-.579.879-1.468 1.319-2.665 1.319-1.16 0-2.039-.454-2.638-1.362-.598-.907-.898-2.238-.898-3.991 0-1.839.29-3.193.87-4.063.584-.874 1.473-1.311 2.666-1.311 1.164 0 2.045.456 2.644 1.368.599.913.898 2.248.898 4.006Zm-5.381 0c0 1.421.145 2.435.435 3.043.294.609.762.913 1.404.913.641 0 1.109-.309 1.404-.927.299-.618.449-1.627.449-3.029 0-1.397-.15-2.407-.449-3.029-.295-.627-.763-.941-1.404-.941-.642 0-1.11.306-1.404.919-.29.613-.435 1.63-.435 3.051Z",
                className: "court-header_svg__path-23"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M243.286 167.478c0 .615-.211 1.089-.632 1.422-.419.33-1.019.494-1.801.494h-.715v2.391h-.707v-6.078h1.576c1.519 0 2.279.59 2.279 1.771Zm-3.148 1.309h.636c.627 0 1.08-.101 1.36-.303.28-.202.42-.527.42-.973 0-.402-.132-.701-.395-.898-.263-.197-.674-.295-1.231-.295h-.79v2.469Zm9.172 2.998h-.806l-3.322-5.101h-.034c.045.598.067 1.147.067 1.646v3.455h-.653v-6.078h.798l3.314 5.08h.033a51.15 51.15 0 0 1-.037-.719c-.02-.407-.026-.698-.021-.873v-3.488h.661v6.078Zm6.062 0h-.831l-2.217-2.948-.636.566v2.382h-.706v-6.078h.706v3.014l2.757-3.014h.836l-2.445 2.64 2.536 3.438Zm5.887-1.243c0 .424-.158.751-.474.981-.316.23-.759.345-1.33.345-.604 0-1.075-.095-1.414-.287v-.64c.219.111.454.198.703.262.252.064.495.096.728.096.36 0 .637-.057.831-.171a.574.574 0 0 0 .291-.528.562.562 0 0 0-.233-.453c-.152-.127-.451-.277-.898-.449-.424-.158-.726-.295-.906-.412a1.273 1.273 0 0 1-.399-.403 1.058 1.058 0 0 1-.129-.536c0-.372.151-.664.453-.878.302-.216.717-.324 1.243-.324.491 0 .97.1 1.439.299l-.246.562c-.457-.189-.871-.283-1.243-.283-.327 0-.573.051-.74.154a.475.475 0 0 0-.249.424c0 .122.03.226.091.312a.94.94 0 0 0 .304.245c.138.078.404.19.798.337.541.197.905.395 1.094.594.191.2.286.451.286.753Zm2.599.757c.122 0 .24-.009.353-.025.114-.02.204-.039.271-.058v.528a1.224 1.224 0 0 1-.333.087 2.298 2.298 0 0 1-.391.037c-.881 0-1.322-.464-1.322-1.393v-2.71h-.653v-.333l.653-.287.291-.973h.399v1.056h1.322v.537h-1.322v2.681c0 .275.065.485.196.632.13.147.309.221.536.221Zm4.341.486-.138-.648h-.033c-.227.285-.454.479-.682.582-.224.099-.506.149-.844.149-.451 0-.806-.116-1.064-.349-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.774-.024v-.283c0-.358-.078-.621-.233-.79-.153-.172-.398-.258-.736-.258-.38 0-.81.116-1.289.349l-.212-.528a3.276 3.276 0 0 1 1.542-.391c.544 0 .946.121 1.206.362.263.241.395.628.395 1.16v3.11h-.511Zm-1.559-.486c.429 0 .766-.118 1.01-.354.247-.235.37-.565.37-.989v-.412l-.69.029c-.549.02-.945.106-1.189.258-.242.15-.362.384-.362.703 0 .249.075.439.224.569.153.131.365.196.637.196Zm4.178-1.846c.119-.169.301-.391.545-.666l1.472-1.559h.819l-1.846 1.942 1.974 2.615h-.835l-1.609-2.154-.52.449v1.705h-.682v-6.469h.682v3.43c0 .152-.011.388-.033.707h.033Zm5.717 2.415c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.541-1.75.363-.433.849-.649 1.459-.649.571 0 1.023.189 1.356.566.332.374.498.869.498 1.484v.436h-3.139c.014.535.149.941.404 1.219.257.277.619.415 1.085.415.49 0 .976-.102 1.455-.307v.615c-.244.105-.475.18-.694.225-.217.047-.478.07-.786.07Zm-.187-4.145c-.366 0-.659.119-.877.358-.217.238-.344.568-.383.989h2.382c0-.435-.097-.768-.291-.998-.194-.233-.471-.349-.831-.349Zm6.145 3.451h-.038c-.318.463-.795.694-1.43.694-.596 0-1.06-.203-1.393-.611-.329-.407-.494-.987-.494-1.738s.166-1.334.499-1.75c.332-.416.795-.624 1.388-.624.618 0 1.092.225 1.422.674h.054l-.029-.329-.017-.32v-1.854h.691v6.469h-.562l-.091-.611Zm-1.38.116c.471 0 .812-.127 1.022-.382.214-.258.32-.672.32-1.243v-.146c0-.646-.108-1.106-.324-1.38-.213-.277-.556-.416-1.027-.416-.404 0-.715.158-.931.474-.214.313-.32.757-.32 1.331 0 .582.106 1.021.32 1.318.213.296.527.444.94.444Z",
                className: "court-header_svg__path-24"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M244.112 201.419c0 .324-.121.591-.363.802-.242.209-.581.341-1.016.396v.827h-.459v-.795c-.267 0-.524-.02-.774-.061a2.477 2.477 0 0 1-.613-.174v-.556c.197.088.424.16.681.217.259.055.494.082.706.082v-1.568c-.487-.154-.83-.334-1.027-.538-.195-.204-.292-.468-.292-.791 0-.311.12-.567.36-.766.242-.2.562-.321.959-.364v-.649h.459v.642c.437.012.859.1 1.265.264l-.185.466a3.62 3.62 0 0 0-1.08-.249v1.547c.373.118.652.235.838.349.185.112.322.241.41.388.088.145.131.322.131.531Zm-.605.047a.554.554 0 0 0-.161-.414c-.104-.107-.309-.212-.613-.317v1.386c.516-.071.774-.289.774-.655Zm-1.95-2.213c0 .18.054.325.161.434.107.11.292.213.556.31v-1.379c-.236.038-.414.113-.535.225a.53.53 0 0 0-.182.41Zm8.521-.218c0 .333-.094.605-.281.816-.186.212-.449.353-.791.424v.029c.418.052.728.185.93.399.202.214.303.494.303.841 0 .497-.173.879-.517 1.148-.345.266-.834.399-1.468.399-.276 0-.529-.022-.76-.064a2.548 2.548 0 0 1-.666-.218v-.563a3.347 3.347 0 0 0 1.447.342c.9 0 1.351-.352 1.351-1.058 0-.632-.497-.948-1.49-.948h-.513v-.51h.52c.406 0 .728-.089.966-.267a.89.89 0 0 0 .356-.748c0-.255-.088-.454-.263-.599-.174-.145-.41-.217-.71-.217-.228 0-.443.03-.645.092a2.904 2.904 0 0 0-.691.342l-.299-.399c.213-.169.459-.3.737-.395.281-.098.575-.147.884-.147.506 0 .899.117 1.18.35.28.23.42.547.42.951Zm1.839 3.136.054.082a8.583 8.583 0 0 1-.268.827c-.116.316-.237.61-.363.88h-.446c.064-.247.135-.552.211-.916.078-.363.133-.654.163-.873h.649Zm4.351-1.764c0 .901-.142 1.573-.427 2.017-.283.445-.717.667-1.301.667-.561 0-.987-.227-1.279-.681-.293-.456-.439-1.124-.439-2.003 0-.907.142-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.287.688.294.459.441 1.123.441 1.992Zm-2.847 0c0 .758.089 1.311.267 1.657.178.345.462.517.852.517.394 0 .68-.174.855-.524.179-.351.268-.901.268-1.65 0-.748-.089-1.296-.268-1.643-.175-.349-.461-.523-.855-.523-.39 0-.674.172-.852.516-.178.342-.267.892-.267 1.65Zm7.024 0c0 .901-.142 1.573-.427 2.017-.283.445-.717.667-1.301.667-.561 0-.987-.227-1.28-.681-.292-.456-.438-1.124-.438-2.003 0-.907.141-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.286.688.295.459.442 1.123.442 1.992Zm-2.847 0c0 .758.089 1.311.267 1.657.178.345.462.517.852.517.394 0 .679-.174.855-.524.178-.351.267-.901.267-1.65 0-.748-.089-1.296-.267-1.643-.176-.349-.461-.523-.855-.523-.39 0-.674.172-.852.516-.178.342-.267.892-.267 1.65Zm7.024 0c0 .901-.143 1.573-.428 2.017-.282.445-.716.667-1.301.667-.56 0-.987-.227-1.279-.681-.292-.456-.438-1.124-.438-2.003 0-.907.141-1.581.424-2.02.283-.44.714-.66 1.293-.66.566 0 .995.23 1.287.688.295.459.442 1.123.442 1.992Zm-2.848 0c0 .758.09 1.311.268 1.657.178.345.462.517.851.517.395 0 .68-.174.856-.524.178-.351.267-.901.267-1.65 0-.748-.089-1.296-.267-1.643-.176-.349-.461-.523-.856-.523-.389 0-.673.172-.851.516-.178.342-.268.892-.268 1.65Zm4.462 1.764.054.082a8.583 8.583 0 0 1-.268.827c-.116.316-.237.61-.363.88h-.446c.065-.247.135-.552.211-.916.078-.363.133-.654.164-.873h.648Zm4.352-1.764c0 .901-.143 1.573-.428 2.017-.283.445-.716.667-1.301.667-.56 0-.987-.227-1.279-.681-.292-.456-.439-1.124-.439-2.003 0-.907.142-1.581.425-2.02.282-.44.714-.66 1.293-.66.566 0 .994.23 1.287.688.294.459.442 1.123.442 1.992Zm-2.848 0c0 .758.089 1.311.267 1.657a.895.895 0 0 0 .852.517c.395 0 .68-.174.856-.524.178-.351.267-.901.267-1.65 0-.748-.089-1.296-.267-1.643-.176-.349-.461-.523-.856-.523-.389 0-.673.172-.852.516-.178.342-.267.892-.267 1.65Zm7.024 0c0 .901-.142 1.573-.427 2.017-.283.445-.717.667-1.301.667-.561 0-.987-.227-1.279-.681-.293-.456-.439-1.124-.439-2.003 0-.907.142-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.286.688.295.459.442 1.123.442 1.992Zm-2.847 0c0 .758.089 1.311.267 1.657.178.345.462.517.852.517.394 0 .679-.174.855-.524.178-.351.268-.901.268-1.65 0-.748-.09-1.296-.268-1.643-.176-.349-.461-.523-.855-.523-.39 0-.674.172-.852.516-.178.342-.267.892-.267 1.65Zm7.024 0c0 .901-.142 1.573-.428 2.017-.282.445-.716.667-1.3.667-.561 0-.988-.227-1.28-.681-.292-.456-.438-1.124-.438-2.003 0-.907.141-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.286.688.295.459.442 1.123.442 1.992Zm-2.847 0c0 .758.089 1.311.267 1.657.178.345.462.517.852.517.394 0 .679-.174.855-.524.178-.351.267-.901.267-1.65 0-.748-.089-1.296-.267-1.643-.176-.349-.461-.523-.855-.523-.39 0-.674.172-.852.516-.178.342-.267.892-.267 1.65Z",
                className: "court-header_svg__path-25"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M56.801 186.509c0-4.077 1.66-6.116 4.982-6.116.523 0 .965.041 1.326.122v1.397a4.507 4.507 0 0 0-1.255-.157c-1.116 0-1.955.299-2.515.898-.561.598-.865 1.558-.913 2.879h.086c.223-.385.537-.682.94-.891.404-.213.88-.32 1.426-.32.946 0 1.682.289 2.21.869.527.58.79 1.366.79 2.359 0 1.093-.306 1.958-.919 2.595-.608.632-1.44.948-2.494.948-.746 0-1.395-.178-1.946-.535-.551-.361-.977-.884-1.276-1.568-.295-.689-.442-1.516-.442-2.48Zm3.635 3.2c.575 0 1.017-.185 1.326-.556.313-.371.47-.9.47-1.589 0-.599-.147-1.069-.442-1.412-.29-.342-.727-.513-1.311-.513-.361 0-.694.079-.998.235a1.796 1.796 0 0 0-.72.635 1.468 1.468 0 0 0-.264.819c0 .67.181 1.236.542 1.697.366.456.832.684 1.397.684Zm11.74 1.24h-7.064v-1.268l2.687-2.702c.793-.812 1.318-1.387 1.575-1.725.261-.342.451-.663.57-.962.119-.299.178-.62.178-.962 0-.471-.142-.841-.427-1.112-.28-.271-.67-.406-1.17-.406-.398 0-.785.073-1.16.221-.372.147-.802.413-1.291.798l-.905-1.105c.58-.489 1.143-.836 1.689-1.04a4.93 4.93 0 0 1 1.746-.307c.97 0 1.746.254 2.331.763.584.503.877 1.183.877 2.038 0 .471-.086.917-.257 1.34-.166.423-.425.86-.777 1.312-.347.446-.926 1.052-1.739 1.817l-1.81 1.754v.071h4.946v1.475Zm8.338-5.21c0 1.81-.292 3.155-.876 4.034-.58.879-1.469 1.319-2.666 1.319-1.16 0-2.038-.454-2.637-1.362-.599-.907-.898-2.238-.898-3.991 0-1.839.29-3.193.87-4.063.584-.874 1.472-1.311 2.665-1.311 1.164 0 2.046.456 2.644 1.368.599.913.898 2.248.898 4.006Zm-5.38 0c0 1.421.144 2.435.434 3.043.294.609.763.913 1.404.913.641 0 1.11-.309 1.404-.927.3-.618.45-1.627.45-3.029 0-1.397-.15-2.407-.45-3.029-.294-.627-.763-.941-1.404-.941-.641 0-1.11.306-1.404.919-.29.613-.435 1.63-.435 3.051Zm14.06.364c0 .725-.238 1.281-.713 1.667-.476.387-1.152.58-2.03.58h-.722v2.599h-1.135v-6.947h2c.868 0 1.518.178 1.948.532.434.355.651.878.651 1.569Zm-3.465 1.292h.604c.583 0 1.01-.101 1.283-.304.272-.203.408-.52.408-.95 0-.4-.122-.697-.365-.894-.244-.196-.625-.294-1.14-.294h-.79v2.442Zm10.64 3.554h-1.393l-3.416-5.535h-.038l.023.308c.045.59.067 1.128.067 1.616v3.611H90.58v-6.947h1.378l3.407 5.507h.028a32.037 32.037 0 0 1-.038-.793 27.658 27.658 0 0 1-.028-1.074v-3.64h1.04v6.947Zm7.136 0h-1.316l-2.181-3.145-.67.546v2.599h-1.135v-6.947h1.135v3.317c.31-.38.62-.746.927-1.098l1.877-2.219h1.292a417.964 417.964 0 0 1-2.609 3.046l2.68 3.901Z",
                className: "court-header_svg__path-26"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M59.83 165.707h.761l-2.19 6.078h-.7l-2.178-6.078h.748l1.397 3.933c.161.452.289.891.383 1.318.1-.449.23-.897.39-1.343l1.39-3.908Zm5.43 3.796c0 .742-.187 1.323-.561 1.742-.374.415-.891.623-1.55.623-.408 0-.77-.095-1.086-.287a1.89 1.89 0 0 1-.732-.823c-.172-.357-.258-.776-.258-1.255 0-.743.186-1.321.558-1.734.371-.416.887-.624 1.546-.624.638 0 1.144.212 1.518.636.377.424.565.998.565 1.722Zm-3.471 0c0 .582.116 1.025.349 1.33.233.305.575.457 1.027.457.452 0 .794-.151 1.027-.453.235-.305.353-.75.353-1.334 0-.58-.118-1.019-.353-1.318-.233-.303-.578-.454-1.035-.454-.452 0-.793.149-1.023.445-.23.297-.345.739-.345 1.327Zm6.157 1.796c.122 0 .24-.009.354-.025.113-.02.203-.039.27-.058v.528a1.22 1.22 0 0 1-.333.087 2.304 2.304 0 0 1-.39.037c-.882 0-1.323-.464-1.323-1.393v-2.71h-.653v-.333l.653-.287.291-.973h.4v1.056h1.322v.537h-1.323v2.681c0 .275.066.485.196.632.13.147.309.221.536.221Zm3.464.569c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.364-.433.85-.649 1.46-.649.57 0 1.023.189 1.355.566.333.374.5.869.5 1.484v.436h-3.14c.014.535.148.941.403 1.219.258.277.62.415 1.085.415.491 0 .976-.102 1.456-.307v.615c-.244.105-.476.18-.695.225-.216.047-.478.07-.785.07Zm-.188-4.145c-.365 0-.658.119-.877.358-.216.238-.344.568-.382.989h2.382c0-.435-.097-.768-.291-.998-.194-.233-.471-.349-.832-.349Zm8.79 2.445c0 .535-.194.952-.582 1.251-.388.3-.915.449-1.58.449-.72 0-1.275-.093-1.663-.278v-.682c.25.105.52.188.815.249.294.061.585.092.873.092.471 0 .826-.089 1.064-.266.239-.18.358-.43.358-.749a.935.935 0 0 0-.13-.515c-.082-.136-.224-.261-.423-.374-.197-.114-.498-.243-.902-.387-.566-.202-.97-.442-1.215-.719-.24-.278-.361-.639-.361-1.086 0-.468.176-.841.528-1.118.352-.277.818-.416 1.397-.416.604 0 1.16.111 1.667.333l-.22.615a3.78 3.78 0 0 0-1.464-.316c-.374 0-.666.081-.877.241a.796.796 0 0 0-.316.67c0 .21.039.384.116.519.078.134.208.257.391.371.186.11.469.234.848.37.638.227 1.076.471 1.314.731.241.261.362.599.362 1.015Zm2.611 1.131c.122 0 .24-.009.353-.025.114-.02.204-.039.27-.058v.528a1.22 1.22 0 0 1-.332.087 2.302 2.302 0 0 1-.39.037c-.882 0-1.323-.464-1.323-1.393v-2.71h-.653v-.333l.653-.287.291-.973h.4v1.056h1.321v.537h-1.322v2.681c0 .275.065.485.196.632.13.147.309.221.536.221Zm4.34.486-.137-.648h-.033c-.227.285-.454.479-.682.582-.224.099-.506.149-.844.149-.451 0-.806-.116-1.064-.349-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.447l.773-.024v-.283c0-.358-.077-.621-.232-.79-.153-.172-.398-.258-.736-.258-.38 0-.81.116-1.29.349l-.211-.528a3.283 3.283 0 0 1 1.542-.391c.544 0 .946.121 1.206.362.263.241.395.628.395 1.16v3.11h-.511Zm-1.558-.486c.43 0 .766-.118 1.01-.354.246-.235.37-.565.37-.989v-.412l-.69.029c-.55.02-.945.106-1.19.258-.24.15-.361.384-.361.703 0 .249.075.439.224.569.153.131.365.196.636.196Zm4.178-1.846c.12-.169.3-.391.545-.666l1.472-1.559h.819l-1.846 1.942 1.974 2.615h-.835l-1.61-2.154-.519.449v1.705h-.682v-6.469h.682v3.43c0 .152-.011.388-.033.707h.033Zm5.717 2.415c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.364-.433.85-.649 1.46-.649.571 0 1.023.189 1.356.566.332.374.498.869.498 1.484v.436h-3.139c.014.535.149.941.404 1.219.257.277.62.415 1.085.415.49 0 .975-.102 1.455-.307v.615c-.244.105-.475.18-.694.225-.216.047-.478.07-.786.07Zm-.187-4.145c-.366 0-.659.119-.877.358-.217.238-.344.568-.383.989h2.382c0-.435-.097-.768-.29-.998-.195-.233-.472-.349-.832-.349Z",
                className: "court-header_svg__path-27"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M61.04 201.419c0 .324-.121.591-.364.802-.242.209-.58.341-1.016.396v.827h-.46v-.795c-.265 0-.523-.02-.773-.061a2.474 2.474 0 0 1-.612-.174v-.556c.197.088.424.16.68.217.26.055.494.082.706.082v-1.568c-.487-.154-.83-.334-1.027-.538-.194-.204-.292-.468-.292-.791 0-.311.12-.567.36-.766.242-.2.562-.321.959-.364v-.649h.46v.642c.437.012.858.1 1.265.264l-.186.466a3.62 3.62 0 0 0-1.08-.249v1.547c.373.118.653.235.838.349.185.112.322.241.41.388.088.145.132.322.132.531Zm-.606.047a.554.554 0 0 0-.16-.414c-.105-.107-.31-.212-.614-.317v1.386c.516-.071.774-.289.774-.655Zm-1.95-2.213c0 .18.054.325.16.434.108.11.293.213.557.31v-1.379c-.235.038-.414.113-.535.225a.529.529 0 0 0-.181.41Zm7.484 3.767h-.577v-3.714c0-.309.01-.601.029-.877-.05.05-.106.103-.168.157-.062.055-.344.287-.848.695l-.314-.406 1.38-1.066h.498v5.211Zm5.439-2.613c0 .901-.143 1.573-.428 2.017-.283.445-.716.667-1.3.667-.561 0-.988-.227-1.28-.681-.292-.456-.439-1.124-.439-2.003 0-.907.142-1.581.425-2.02.282-.44.714-.66 1.293-.66.566 0 .995.23 1.287.688.294.459.442 1.123.442 1.992Zm-2.848 0c0 .758.09 1.311.267 1.657.179.345.463.517.852.517.395 0 .68-.174.856-.524.178-.351.267-.901.267-1.65 0-.748-.09-1.296-.267-1.643-.176-.349-.461-.523-.856-.523-.39 0-.673.172-.852.516-.178.342-.267.892-.267 1.65Zm7.024 0c0 .901-.142 1.573-.427 2.017-.283.445-.717.667-1.301.667-.56 0-.987-.227-1.28-.681-.292-.456-.438-1.124-.438-2.003 0-.907.142-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.286.688.295.459.442 1.123.442 1.992Zm-2.847 0c0 .758.09 1.311.267 1.657.178.345.462.517.852.517.394 0 .68-.174.855-.524.178-.351.268-.901.268-1.65 0-.748-.09-1.296-.268-1.643-.175-.349-.46-.523-.855-.523-.39 0-.674.172-.852.516-.178.342-.267.892-.267 1.65Z",
                className: "court-header_svg__path-28"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M56.801 129.337c0-4.077 1.66-6.116 4.982-6.116.523 0 .965.041 1.326.122v1.397a4.507 4.507 0 0 0-1.255-.157c-1.116 0-1.955.299-2.515.898-.561.599-.865 1.558-.913 2.879h.086a2.28 2.28 0 0 1 .94-.891c.404-.213.88-.32 1.426-.32.946 0 1.682.29 2.21.869.527.58.79 1.366.79 2.36 0 1.092-.306 1.957-.919 2.594-.608.632-1.44.948-2.494.948-.746 0-1.395-.178-1.946-.535-.551-.361-.977-.883-1.276-1.568-.295-.689-.442-1.516-.442-2.48Zm3.635 3.2c.575 0 1.017-.185 1.326-.556.313-.37.47-.9.47-1.589 0-.599-.147-1.069-.442-1.411-.29-.343-.727-.514-1.311-.514-.361 0-.694.079-.998.236a1.794 1.794 0 0 0-.72.634 1.468 1.468 0 0 0-.264.82c0 .67.181 1.235.542 1.696.366.456.832.684 1.397.684Zm11.74 1.24h-7.064v-1.268l2.687-2.702c.793-.812 1.318-1.387 1.575-1.725.261-.342.451-.662.57-.962.119-.299.178-.62.178-.962 0-.47-.142-.841-.427-1.112-.28-.271-.67-.406-1.17-.406-.398 0-.785.074-1.16.221-.372.147-.802.413-1.291.798l-.905-1.105c.58-.489 1.143-.836 1.689-1.04a4.93 4.93 0 0 1 1.746-.307c.97 0 1.746.254 2.331.763.584.504.877 1.183.877 2.038 0 .471-.086.917-.257 1.34-.166.423-.425.86-.777 1.312-.347.446-.926 1.052-1.739 1.817l-1.81 1.754v.071h4.946v1.475Zm8.338-5.21c0 1.811-.292 3.155-.876 4.034-.58.879-1.469 1.319-2.666 1.319-1.16 0-2.038-.454-2.637-1.361-.599-.908-.898-2.239-.898-3.992 0-1.839.29-3.193.87-4.063.584-.874 1.472-1.311 2.665-1.311 1.164 0 2.046.456 2.644 1.368.599.913.898 2.248.898 4.006Zm-5.38 0c0 1.421.144 2.435.434 3.044.294.608.763.912 1.404.912.641 0 1.11-.309 1.404-.927.3-.617.45-1.627.45-3.029 0-1.397-.15-2.407-.45-3.029-.294-.627-.763-.941-1.404-.941-.641 0-1.11.307-1.404.92-.29.613-.435 1.629-.435 3.05Zm14.06.364c0 .725-.238 1.281-.713 1.667-.476.387-1.152.58-2.03.58h-.722v2.599h-1.135v-6.947h2c.868 0 1.518.178 1.948.533.434.354.651.877.651 1.568Zm-3.465 1.292h.604c.583 0 1.01-.101 1.283-.304.272-.203.408-.52.408-.95 0-.399-.122-.697-.365-.894-.244-.196-.625-.294-1.14-.294h-.79v2.442Zm10.64 3.554h-1.393l-3.416-5.535h-.038l.023.308c.045.59.067 1.128.067 1.616v3.611H90.58v-6.947h1.378l3.407 5.508h.028a32.56 32.56 0 0 1-.038-.794 27.658 27.658 0 0 1-.028-1.074v-3.64h1.04v6.947Zm7.136 0h-1.316l-2.181-3.145-.67.546v2.599h-1.135v-6.947h1.135v3.317c.31-.38.62-.746.927-1.098l1.877-2.219h1.292a417.964 417.964 0 0 1-2.609 3.046l2.68 3.901Z",
                className: "court-header_svg__path-29"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m59.049 114.613-2.063-5.388h-.033c.039.427.058.934.058 1.522v3.866h-.652v-6.078h1.064l1.925 5.014h.033l1.942-5.014h1.056v6.078h-.707v-3.916c0-.449.02-.937.058-1.464h-.033l-2.079 5.38h-.57Zm5.588 0h-.69v-4.557h.69v4.557Zm-.749-5.791c0-.158.04-.273.117-.346a.406.406 0 0 1 .29-.112.41.41 0 0 1 .288.112c.08.075.12.19.12.346 0 .155-.04.271-.12.349a.406.406 0 0 1-.287.112.402.402 0 0 1-.291-.112c-.078-.078-.117-.194-.117-.349Zm5.33 5.791v-2.948c0-.371-.084-.648-.253-.831-.17-.183-.434-.274-.794-.274-.477 0-.826.128-1.048.386-.222.258-.333.683-.333 1.277v2.39h-.69v-4.557h.562l.112.624h.033a1.4 1.4 0 0 1 .595-.52c.255-.124.539-.187.852-.187.549 0 .962.133 1.239.399.277.264.416.686.416 1.269v2.972h-.69Zm7.859-1.617c0 .535-.195.952-.582 1.251-.389.3-.915.449-1.58.449-.721 0-1.276-.092-1.664-.278v-.682c.25.105.522.188.815.249.294.061.585.092.873.092.472 0 .827-.089 1.065-.266.238-.18.357-.43.357-.749a.934.934 0 0 0-.129-.515c-.083-.136-.224-.261-.424-.374-.196-.114-.497-.243-.902-.387-.565-.202-.97-.442-1.214-.719-.241-.277-.361-.639-.361-1.085 0-.469.175-.842.528-1.119.352-.277.817-.416 1.397-.416.604 0 1.16.111 1.667.333l-.22.615a3.78 3.78 0 0 0-1.464-.316c-.374 0-.667.081-.877.242-.211.16-.316.383-.316.669 0 .211.038.384.116.52.078.133.208.256.39.37.186.111.47.234.849.37.638.227 1.076.471 1.314.731.241.261.362.599.362 1.015Zm2.61 1.131a2.387 2.387 0 0 0 .624-.083v.528a1.22 1.22 0 0 1-.332.087 2.304 2.304 0 0 1-.391.037c-.882 0-1.322-.464-1.322-1.392v-2.711h-.653v-.333l.653-.287.29-.973h.4v1.056h1.322v.537h-1.322v2.681c0 .275.065.486.195.632.13.147.31.221.537.221Zm4.341.486-.137-.648h-.033c-.228.285-.455.479-.682.582-.225.1-.506.149-.844.149-.452 0-.807-.116-1.064-.349-.255-.233-.383-.564-.383-.994 0-.92.736-1.402 2.208-1.446l.773-.025v-.283c0-.358-.078-.621-.233-.79-.152-.172-.397-.258-.736-.258-.38 0-.809.117-1.288.349l-.213-.528c.225-.122.47-.217.736-.286a3.19 3.19 0 0 1 .807-.104c.543 0 .945.12 1.206.361.263.241.395.628.395 1.16v3.11h-.512Zm-1.559-.486c.43 0 .767-.118 1.01-.354.247-.235.37-.565.37-.989v-.412l-.69.029c-.549.02-.945.106-1.189.258-.241.15-.361.384-.361.703 0 .249.074.439.224.569.152.131.365.196.636.196Zm4.179-1.846c.119-.169.3-.391.544-.665l1.472-1.56h.82l-1.847 1.942 1.975 2.615h-.836l-1.609-2.153-.52.449v1.704h-.681v-6.469h.682v3.43c0 .152-.011.388-.034.707h.034Zm5.717 2.415c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.364-.433.85-.649 1.46-.649.57 0 1.022.189 1.355.566.333.374.5.869.5 1.484v.437H90.9c.014.535.148.941.403 1.218.258.277.62.416 1.085.416.491 0 .976-.103 1.456-.308v.615a3.53 3.53 0 0 1-.695.225c-.216.047-.478.07-.785.07Zm-.188-4.145c-.366 0-.658.119-.877.358-.216.238-.344.568-.382.989H93.3c0-.435-.097-.768-.291-.998-.194-.232-.471-.349-.832-.349Z",
                className: "court-header_svg__path-30"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M61.04 144.248c0 .323-.121.59-.364.801-.242.209-.58.341-1.016.396v.827h-.46v-.795c-.265 0-.523-.02-.773-.061a2.474 2.474 0 0 1-.612-.174v-.556c.197.088.424.16.68.217.26.055.494.082.706.082v-1.568c-.487-.154-.83-.334-1.027-.538-.194-.204-.292-.468-.292-.791 0-.311.12-.567.36-.766.242-.2.562-.321.959-.364v-.648h.46v.641c.437.012.858.1 1.265.264l-.186.467a3.591 3.591 0 0 0-1.08-.25v1.547c.373.119.653.235.838.349.185.112.322.241.41.389.088.144.132.321.132.531Zm-.606.046a.554.554 0 0 0-.16-.414c-.105-.106-.31-.212-.614-.317v1.387c.516-.072.774-.29.774-.656Zm-1.95-2.213c0 .18.054.325.16.435.108.109.293.212.557.31v-1.38c-.235.038-.414.113-.535.225a.529.529 0 0 0-.181.41Zm7.484 3.767h-.577v-3.714c0-.309.01-.601.029-.876-.05.049-.106.102-.168.156-.062.055-.344.287-.848.695l-.314-.406 1.38-1.066h.498v5.211Zm5.439-2.613c0 .901-.143 1.573-.428 2.018-.283.444-.716.666-1.3.666-.561 0-.988-.227-1.28-.681-.292-.456-.439-1.124-.439-2.003 0-.907.142-1.581.425-2.02.282-.44.714-.66 1.293-.66.566 0 .995.23 1.287.688.294.459.442 1.123.442 1.992Zm-2.848 0c0 .758.09 1.311.267 1.658.179.344.463.516.852.516.395 0 .68-.174.856-.524.178-.351.267-.901.267-1.65 0-.748-.09-1.296-.267-1.642-.176-.35-.461-.524-.856-.524-.39 0-.673.172-.852.516-.178.343-.267.893-.267 1.65Zm7.024 0c0 .901-.142 1.573-.427 2.018-.283.444-.717.666-1.301.666-.56 0-.987-.227-1.28-.681-.292-.456-.438-1.124-.438-2.003 0-.907.142-1.581.424-2.02.283-.44.714-.66 1.294-.66.565 0 .994.23 1.286.688.295.459.442 1.123.442 1.992Zm-2.847 0c0 .758.09 1.311.267 1.658.178.344.462.516.852.516.394 0 .68-.174.855-.524.178-.351.268-.901.268-1.65 0-.748-.09-1.296-.268-1.642-.175-.35-.46-.524-.855-.524-.39 0-.674.172-.852.516-.178.343-.267.893-.267 1.65Z",
                className: "court-header_svg__path-31"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M243.381 127.27c1.05 0 1.881.278 2.494.834.613.556.92 1.314.92 2.274 0 1.111-.35 1.981-1.048 2.608-.694.623-1.682.934-2.965.934-1.164 0-2.079-.188-2.744-.563v-1.518c.385.218.827.387 1.325.506a6.02 6.02 0 0 0 1.39.178c.756 0 1.331-.169 1.725-.506.395-.338.592-.832.592-1.483 0-1.245-.794-1.867-2.381-1.867-.223 0-.499.024-.827.071a9.242 9.242 0 0 0-.862.15l-.748-.442.399-5.089h5.417v1.49h-3.942l-.235 2.58c.166-.029.368-.062.606-.1a5.82 5.82 0 0 1 .884-.057Zm11.853.534c0 2.053-.414 3.586-1.241 4.598-.826 1.012-2.071 1.518-3.734 1.518-.632 0-1.086-.038-1.362-.114v-1.404a4.69 4.69 0 0 0 1.276.178c1.131 0 1.974-.304 2.53-.912.556-.609.86-1.564.913-2.866h-.086c-.28.428-.62.737-1.019.927-.394.19-.858.285-1.39.285-.922 0-1.646-.287-2.174-.862-.527-.575-.791-1.364-.791-2.367 0-1.088.304-1.953.912-2.594.613-.646 1.447-.97 2.502-.97.741 0 1.388.181 1.939.542.551.361.976.886 1.276 1.575.299.685.449 1.507.449 2.466Zm-3.635-3.193c-.58 0-1.024.19-1.333.571-.309.375-.464.905-.464 1.589 0 .594.143 1.062.428 1.404.29.337.727.506 1.312.506.565 0 1.04-.169 1.425-.506.385-.337.577-.732.577-1.183 0-.423-.083-.817-.249-1.183a2.091 2.091 0 0 0-.684-.877 1.679 1.679 0 0 0-1.012-.321Z",
                className: "court-header_svg__path-32"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m243.252 114.613-.756-1.933h-2.437l-.748 1.933h-.715l2.403-6.103h.594l2.391 6.103h-.732Zm-.977-2.569-.707-1.884c-.091-.238-.185-.53-.282-.877a7.977 7.977 0 0 1-.262.877l-.715 1.884h1.966Zm4.262 2.652c-.66 0-1.171-.202-1.534-.607-.361-.407-.541-.982-.541-1.725 0-.762.183-1.351.549-1.767.369-.416.893-.624 1.572-.624.219 0 .438.024.657.071.219.047.39.103.515.166l-.212.586a3.216 3.216 0 0 0-.499-.149 2.131 2.131 0 0 0-.478-.063c-.926 0-1.389.591-1.389 1.772 0 .56.113.989.337 1.289.227.299.563.449 1.006.449.38 0 .769-.082 1.169-.246v.611c-.305.158-.689.237-1.152.237Zm3.709-.569a2.385 2.385 0 0 0 .623-.083v.528a1.215 1.215 0 0 1-.332.087 2.307 2.307 0 0 1-.391.037c-.882 0-1.322-.464-1.322-1.392v-2.711h-.653v-.333l.653-.287.291-.973h.399v1.056h1.322v.537h-1.322v2.681c0 .275.065.486.195.632.131.147.309.221.537.221Zm2.228.486h-.69v-4.557h.69v4.557Zm-.748-5.791c0-.158.039-.273.116-.346a.407.407 0 0 1 .291-.112.41.41 0 0 1 .287.112c.081.075.121.19.121.346 0 .155-.04.271-.121.349a.405.405 0 0 1-.287.112.403.403 0 0 1-.291-.112c-.077-.078-.116-.194-.116-.349Zm3.21 5.791-1.73-4.557h.74l.981 2.703c.222.632.352 1.042.391 1.231h.033c.031-.147.126-.451.287-.911.164-.463.528-1.47 1.094-3.023h.74l-1.73 4.557h-.806Zm5.193.083c-.674 0-1.206-.205-1.597-.615-.388-.41-.582-.98-.582-1.709 0-.734.18-1.318.54-1.75.363-.433.85-.649 1.46-.649.571 0 1.023.189 1.355.566.333.374.499.869.499 1.484v.437h-3.139c.014.535.148.941.403 1.218.258.277.62.416 1.085.416.491 0 .976-.103 1.456-.308v.615c-.244.106-.476.18-.695.225-.216.047-.478.07-.785.07Zm-.188-4.145c-.365 0-.658.119-.877.358-.216.238-.344.568-.382.989h2.382c0-.435-.097-.768-.291-.998-.194-.232-.471-.349-.832-.349Zm4.474 5.663c-.26 0-.466-.037-.615-.112v-.603c.197.055.402.083.615.083.275 0 .482-.083.624-.249.144-.167.216-.407.216-.72v-6.078h.707v6.02c0 .527-.133.934-.399 1.222-.266.291-.649.437-1.148.437Zm3.709-6.158v2.957c0 .371.084.648.253.831.17.183.434.275.795.275.476 0 .824-.131 1.043-.391.222-.261.333-.686.333-1.277v-2.395h.69v4.557h-.57l-.099-.611h-.038a1.375 1.375 0 0 1-.59.516c-.25.119-.535.178-.857.178-.554 0-.97-.131-1.247-.395-.274-.263-.412-.684-.412-1.263v-2.982h.699Zm6.66-.083c.203 0 .384.017.545.05l-.095.64a2.392 2.392 0 0 0-.499-.062c-.369 0-.685.15-.948.449-.261.299-.391.672-.391 1.119v2.444h-.69v-4.557h.569l.079.844h.033c.17-.296.373-.525.612-.686.238-.16.5-.241.785-.241Zm5.331 2.358c0 .743-.187 1.323-.562 1.742-.374.416-.891.623-1.55.623-.408 0-.77-.095-1.086-.286a1.89 1.89 0 0 1-.731-.824c-.172-.357-.258-.776-.258-1.255 0-.743.186-1.321.557-1.734.371-.416.887-.624 1.547-.624.637 0 1.143.212 1.517.636.377.424.566.998.566 1.722Zm-3.472 0c0 .582.116 1.025.349 1.33.233.305.575.458 1.027.458.452 0 .794-.152 1.027-.454.236-.305.354-.749.354-1.334 0-.58-.118-1.019-.354-1.318-.233-.302-.578-.453-1.035-.453-.452 0-.793.148-1.023.444-.23.297-.345.739-.345 1.327Zm6.765-2.358c.202 0 .383.017.544.05l-.095.64a2.392 2.392 0 0 0-.499-.062c-.369 0-.685.15-.948.449-.261.299-.391.672-.391 1.119v2.444h-.69v-4.557h.569l.079.844h.034c.169-.296.372-.525.611-.686.238-.16.5-.241.786-.241Zm4.336 3.397c0 .424-.158.751-.474.981-.316.23-.759.345-1.33.345-.605 0-1.076-.095-1.414-.286v-.641c.219.111.453.198.703.262.252.064.494.096.727.096.361 0 .638-.057.832-.171a.574.574 0 0 0 .291-.528.565.565 0 0 0-.233-.453c-.152-.127-.452-.277-.898-.449-.424-.158-.726-.295-.906-.412a1.277 1.277 0 0 1-.4-.403 1.066 1.066 0 0 1-.128-.536c0-.372.151-.664.453-.877.302-.217.716-.325 1.243-.325.491 0 .97.1 1.438.3l-.245.561c-.457-.189-.872-.283-1.243-.283-.327 0-.574.051-.74.154a.477.477 0 0 0-.25.424c0 .122.031.226.092.312a.946.946 0 0 0 .303.245c.139.078.405.19.799.337.54.197.905.395 1.093.595.191.199.287.45.287.752Z",
                className: "court-header_svg__path-33"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M242.405 142.665c.549 0 .98.137 1.294.41.316.271.474.643.474 1.116 0 .539-.172.962-.517 1.268-.342.307-.815.46-1.418.46-.587 0-1.035-.094-1.344-.282v-.57c.167.107.373.191.62.253.248.06.491.089.731.089.418 0 .743-.098.973-.295.233-.198.349-.483.349-.856 0-.727-.445-1.09-1.336-1.09a5.29 5.29 0 0 0-.905.103l-.307-.196.196-2.438h2.591v.546h-2.085l-.132 1.564c.274-.054.546-.082.816-.082Zm6.002.57c0 .901-.143 1.573-.428 2.018-.283.444-.716.666-1.301.666-.56 0-.987-.227-1.279-.681-.292-.456-.438-1.124-.438-2.003 0-.907.141-1.581.424-2.02.282-.44.714-.66 1.293-.66.566 0 .995.23 1.287.688.294.459.442 1.123.442 1.992Zm-2.848 0c0 .758.089 1.311.268 1.658.178.344.462.516.851.516.395 0 .68-.174.856-.524.178-.351.267-.901.267-1.65 0-.748-.089-1.296-.267-1.642-.176-.35-.461-.524-.856-.524-.389 0-.673.172-.851.516-.179.343-.268.893-.268 1.65Zm9.986-.042c0 .86-.234 1.518-.702 1.974-.466.454-1.137.681-2.014.681h-1.443v-5.211h1.597c.81 0 1.439.225 1.888.674.449.449.674 1.076.674 1.882Zm-.641.021c0-.679-.172-1.191-.514-1.536-.339-.344-.845-.517-1.518-.517h-.88v4.163h.738c.722 0 1.265-.177 1.628-.531.364-.357.546-.883.546-1.579Zm3.499-1.343c.174 0 .329.014.467.042l-.082.549a1.991 1.991 0 0 0-.428-.053c-.316 0-.586.128-.812.385-.223.256-.335.576-.335.958v2.096h-.592v-3.906h.488l.068.723h.029c.145-.254.319-.45.524-.588.204-.138.428-.206.673-.206Zm3.6 3.977-.118-.556h-.029c-.194.244-.389.411-.584.499a1.793 1.793 0 0 1-.723.128c-.388 0-.692-.1-.913-.299-.218-.2-.328-.484-.328-.852 0-.789.631-1.202 1.893-1.24l.663-.022v-.242c0-.307-.067-.532-.2-.677-.131-.147-.341-.221-.631-.221-.325 0-.694.1-1.105.299l-.181-.452c.192-.105.402-.187.63-.246.231-.06.461-.089.692-.089.465 0 .81.103 1.033.31.226.206.339.538.339.994v2.666h-.438Zm-1.337-.417c.368 0 .657-.101.866-.303.212-.202.317-.485.317-.848v-.353l-.591.025c-.471.016-.81.09-1.02.221-.206.128-.31.329-.31.602 0 .214.065.377.193.488.131.112.312.168.545.168Zm6.187.417-.717-2.292c-.045-.14-.129-.458-.253-.955h-.028c-.095.416-.178.737-.25.962l-.737 2.285h-.684l-1.066-3.906h.62l.574 2.241c.133.514.209.859.228 1.037h.028c.027-.135.068-.31.125-.523.06-.217.111-.388.153-.514l.717-2.241h.641l.699 2.241c.133.409.223.752.271 1.03h.028c.01-.085.035-.217.075-.395.043-.178.291-1.137.745-2.876h.613l-1.08 3.906h-.702Zm5.164 0v-2.527c0-.318-.073-.556-.218-.713-.145-.157-.372-.235-.68-.235-.409 0-.708.11-.898.331-.191.221-.286.586-.286 1.094v2.05h-.591v-3.906h.481l.096.534h.029c.121-.192.291-.341.509-.445a1.64 1.64 0 0 1 .731-.16c.47 0 .824.114 1.062.342.237.225.356.588.356 1.087v2.548h-.591Z",
                className: "court-header_svg__path-34"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 219.133,
                cy: 128.117,
                r: 14.597,
                className: "court-header_svg__circle-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__e)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M219.067 128.915c1.963 0 3.555-1.609 3.555-3.592s-1.592-3.593-3.555-3.593-3.555 1.61-3.555 3.593c0 1.983 1.592 3.592 3.555 3.592Zm3.16.798h-1.36a4.257 4.257 0 0 1-3.6 0h-1.36c-1.746 0-3.161 1.43-3.161 3.193v.4c0 .661.531 1.197 1.185 1.197h10.271c.654 0 1.185-.536 1.185-1.197v-.4c0-1.763-1.414-3.193-3.16-3.193Z",
                    className: "court-header_svg__path-35"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 219.133,
                cy: 187.113,
                r: 14.597,
                className: "court-header_svg__circle-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__f)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m216.458 181.523 6.356.288 2.573 5.778-3.63 5.281-6.391-.414-2.62-6.261 3.712-4.672Zm4.66 3.331-4.607 2.034 3.939 3.077.668-5.111Zm-.534-1.019-3.681-1.602-.773 3.368 4.454-1.766Zm-.933 6.905-4-2.887.096 3.912 3.904-1.025Zm5.097-3.164-2.726-2.796-.72 5.377 3.446-2.581Zm-4.159 3.793-3.374.891 3.968.257-.594-1.148Zm3.626-2.524-2.953 2.223.587 1.159 2.366-3.382Zm-1.397-6.227-.573 1.19 2.135 2.194-1.562-3.384Zm-.714-.57-3.75-.153 3.093 1.367.657-1.214Zm-6.194.551-2.626 3.351 1.756.376.87-3.727Zm-.976 4.385-1.764-.378 1.841 4.384-.077-4.006Z",
                    className: "court-header_svg__path-36"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 36.06,
                cy: 187.113,
                r: 14.597,
                className: "court-header_svg__circle-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__g)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m33.386 178.18 6.355.287 2.574 5.778-3.63 5.281-6.391-.413-2.62-6.261 3.712-4.672Zm4.66 3.33-4.607 2.034 3.938 3.078.668-5.112Zm-.534-1.019-3.681-1.602-.774 3.368 4.455-1.766Zm-.933 6.905-4.001-2.887.097 3.912 3.904-1.025Zm5.097-3.164-2.727-2.796-.72 5.377 3.447-2.581Zm-4.16 3.793-3.373.891 3.968.257-.594-1.148Zm3.627-2.524-2.954 2.224.587 1.159 2.367-3.383Zm-1.397-6.227-.574 1.19 2.136 2.194-1.562-3.384Zm-.715-.569-3.75-.154 3.093 1.367.657-1.213Zm-6.193.55-2.627 3.352 1.756.376.87-3.728Zm-.976 4.385-1.765-.378 1.841 4.384-.076-4.006Z",
                    className: "court-header_svg__path-37"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M32.466 191.427h.6l-1.24 3.545h-.612l-1.236-3.545h.596l.74 2.204c.039.105.08.241.123.407.044.165.072.288.085.369.021-.123.054-.265.097-.427.044-.161.08-.281.107-.359l.74-2.194Z",
                className: "court-header_svg__path-38"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M36.682 193.195c0 .577-.144 1.025-.434 1.345-.287.32-.696.48-1.224.48-.535 0-.947-.158-1.235-.475-.286-.318-.429-.77-.429-1.355 0-.586.144-1.035.432-1.348.29-.314.701-.471 1.237-.471.527 0 .934.159 1.222.478.287.318.431.767.431 1.346Zm-2.706 0c0 .436.088.767.264.994.177.224.438.337.784.337.344 0 .603-.112.778-.335.176-.223.264-.555.264-.996 0-.435-.087-.765-.262-.99-.172-.224-.431-.337-.775-.337-.348 0-.61.113-.789.337-.176.225-.264.555-.264.99Z",
                className: "court-header_svg__path-39"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M38.668 194.972h-.58v-3.048h-1.042v-.497h2.665v.497h-1.043v3.048Z",
                className: "court-header_svg__path-40"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M42.262 194.972h-2.006v-3.545h2.006v.49h-1.426v.965h1.336v.485h-1.336v1.113h1.426v.492Z",
                className: "court-header_svg__path-41"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 36.06,
                cy: 128.117,
                r: 14.597,
                className: "court-header_svg__circle-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#court-header_svg__h)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m33.386 119.184 6.355.287 2.574 5.778-3.63 5.281-6.391-.414-2.62-6.26 3.712-4.672Zm4.66 3.33-4.607 2.034 3.938 3.078.668-5.112Zm-.534-1.019-3.681-1.602-.774 3.368 4.455-1.766Zm-.933 6.905-4.001-2.887.097 3.912 3.904-1.025Zm5.097-3.164-2.727-2.796-.72 5.377 3.447-2.581Zm-4.16 3.793-3.373.891 3.968.257-.594-1.148Zm3.627-2.524-2.954 2.223.587 1.16 2.367-3.383Zm-1.397-6.227-.574 1.19 2.136 2.194-1.562-3.384Zm-.715-.57-3.75-.153 3.093 1.367.657-1.214Zm-6.193.551-2.627 3.352 1.756.375.87-3.727Zm-.976 4.385-1.765-.378 1.841 4.384-.076-4.006Z",
                    className: "court-header_svg__path-42"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m32.772 136.024-1.058-3.047h-.02c.028.452.042.877.042 1.273v1.774h-.542v-3.649h.841l1.014 2.903h.015l1.043-2.903h.844v3.649h-.574v-1.804c0-.182.004-.418.012-.709.01-.291.019-.468.025-.529h-.02l-1.096 3.042h-.526Z",
                className: "court-header_svg__path-43"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M35.912 136.024v-3.649h.596v3.649h-.596Z",
                className: "court-header_svg__path-44"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M40.515 136.024h-.732l-1.794-2.908h-.02l.012.163c.023.309.035.592.035.848v1.897h-.541v-3.649h.723l1.79 2.893h.015c-.003-.038-.01-.177-.02-.417-.01-.241-.015-.429-.015-.564v-1.912h.547v3.649Z",
                className: "court-header_svg__path-45"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(21.463 336.207)",
                            className: "court-header_svg__rect-7",
                            d: "M0 0h8.515v8.515H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__c",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(145.172 336.207)",
                            className: "court-header_svg__rect-8",
                            d: "M0 0h8.515v8.515H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__d",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(279.882 336.207)",
                            className: "court-header_svg__rect-9",
                            d: "M0 0h8.515v8.515H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__e",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(212.746 121.73)",
                            className: "court-header_svg__rect-10",
                            d: "M0 0h12.641v12.773H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__f",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(212.746 180.727)",
                            className: "court-header_svg__rect-11",
                            d: "M0 0h12.641v12.773H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__g",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(29.674 177.383)",
                            className: "court-header_svg__rect-12",
                            d: "M0 0h12.641v12.773H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "court-header_svg__h",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(29.674 118.387)",
                            className: "court-header_svg__rect-13",
                            d: "M0 0h12.641v12.773H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "court-header_svg__a",
                        x: 0.175,
                        y: 0.392,
                        width: 388.649,
                        height: 368.579,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.216
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 0.912
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210808"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210808",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $ca69b41e5d0a1d7c$export$2e2bcd8739ae039 = $ca69b41e5d0a1d7c$var$SvgCourtHeader;



const $a3ba75527637001d$var$StyledCourtHeaderSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $ca69b41e5d0a1d7c$export$2e2bcd8739ae039))`
  [class$="circle-1"] {
    fill: ${({ theme: theme })=>theme.successLight};
  }

  [class$="circle-2"],
  [class$="circle-3"],
  [class$="circle-4"] {
    fill: ${({ theme: theme })=>theme.mediumPurple};
  }

  [class$="line-1"],
  [class$="line-2"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-1"],
  [class$="rect-5"],
  [class$="path-2"],
  [class$="rect-3"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"],
  [class$="rect-3"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-4"],
  [class$="path-3"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="rect-7"],
  [class$="rect-8"],
  [class$="rect-9"],
  [class$="rect-10"],
  [class$="rect-11"],
  [class$="rect-12"],
  [class$="rect-13"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="rect-6"] {
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-4"],
  [class$="path-5"],
  [class$="path-8"],
  [class$="path-11"],
  [class$="path-14"],
  [class$="path-21"],
  [class$="path-22"],
  [class$="path-23"],
  [class$="path-26"],
  [class$="path-29"],
  [class$="path-32"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-1"],
  [class$="path-7"],
  [class$="path-10"],
  [class$="path-13"],
  [class$="path-15"],
  [class$="path-16"],
  [class$="path-17"],
  [class$="path-18"],
  [class$="path-19"],
  [class$="path-20"],
  [class$="path-24"],
  [class$="path-25"],
  [class$="path-27"],
  [class$="path-28"],
  [class$="path-30"],
  [class$="path-31"],
  [class$="path-33"],
  [class$="path-34"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-6"],
  [class$="path-9"],
  [class$="path-12"],
  [class$="path-36"],
  [class$="path-37"],
  [class$="path-38"],
  [class$="path-39"],
  [class$="path-40"],
  [class$="path-41"],
  [class$="path-42"],
  [class$="path-43"],
  [class$="path-44"],
  [class$="path-45"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  [class$="path-35"] {
    fill: ${({ theme: theme })=>theme.success};
  }
`;
const $a3ba75527637001d$var$CourtHeader = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $a3ba75527637001d$var$StyledCourtHeaderSvg
    });
var $a3ba75527637001d$export$2e2bcd8739ae039 = $a3ba75527637001d$var$CourtHeader;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $27115e40143d7c20$var$SvgNotifications = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 391 354",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#notifications_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3,
                        y: 1,
                        width: 385,
                        height: 348,
                        rx: 2.522,
                        className: "notifications_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3.42,
                        y: 1.42,
                        width: 384.159,
                        height: 347.159,
                        rx: 2.102,
                        className: "notifications_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.42,
                y: 278.799,
                width: 330.159,
                height: 36.987,
                rx: 2.102,
                className: "notifications_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M43.463 293.587h1.169l1.576 4.105c.346.937.56 1.613.644 2.029h.052c.057-.223.175-.604.355-1.142.184-.543.779-2.207 1.786-4.992h1.169l-3.093 8.196c-.307.81-.666 1.384-1.077 1.721-.407.342-.909.512-1.504.512a4.41 4.41 0 0 1-.985-.111v-.874c.24.053.51.079.808.079.748 0 1.282-.42 1.602-1.261l.4-1.024-2.902-7.238Zm14.133 3.593c0 1.173-.296 2.09-.887 2.751-.591.657-1.408.986-2.45.986-.643 0-1.215-.152-1.714-.454a2.989 2.989 0 0 1-1.156-1.3c-.27-.565-.407-1.226-.407-1.983 0-1.174.294-2.086.88-2.739.587-.657 1.401-.985 2.443-.985 1.007 0 1.806.335 2.398 1.005.595.67.893 1.576.893 2.719Zm-5.484 0c0 .919.184 1.62.552 2.101.367.482.908.723 1.622.723.713 0 1.254-.239 1.622-.716.372-.482.558-1.184.558-2.108 0-.915-.186-1.609-.558-2.082-.368-.477-.913-.716-1.635-.716-.714 0-1.253.234-1.616.703-.363.468-.545 1.167-.545 2.095Zm8.426-3.593v4.67c0 .586.133 1.024.4 1.313.267.289.685.434 1.255.434.753 0 1.302-.206 1.648-.618.35-.411.526-1.083.526-2.016v-3.783h1.09v7.198h-.9l-.158-.965h-.059a2.17 2.17 0 0 1-.932.814 3.106 3.106 0 0 1-1.353.283c-.876 0-1.533-.208-1.97-.624-.434-.416-.65-1.082-.65-1.997v-4.709h1.103Zm10.52-.131c.32 0 .607.026.86.079l-.15 1.011a3.754 3.754 0 0 0-.788-.098c-.583 0-1.082.236-1.498.709-.411.473-.617 1.062-.617 1.767v3.861h-1.09v-7.198h.9l.124 1.334h.053c.267-.469.589-.83.965-1.084.377-.254.79-.381 1.242-.381Zm5.248 7.461c-1.064 0-1.905-.324-2.522-.972-.613-.648-.92-1.548-.92-2.7 0-1.16.285-2.081.854-2.764.574-.683 1.342-1.025 2.305-1.025.902 0 1.616.298 2.141.893.526.591.788 1.373.788 2.345v.689h-4.958c.022.845.234 1.487.637 1.925.407.437.979.656 1.714.656.775 0 1.541-.162 2.299-.486v.972c-.386.167-.751.285-1.097.355a5.948 5.948 0 0 1-1.241.112Zm-.296-6.548c-.578 0-1.04.188-1.385.565-.342.376-.543.897-.605 1.563h3.763c0-.688-.153-1.213-.46-1.576-.306-.368-.744-.552-1.313-.552Zm13.982 6.416v-4.682c0-.574-.123-1.003-.368-1.287-.245-.289-.626-.434-1.142-.434-.68 0-1.18.195-1.504.585-.324.389-.486.989-.486 1.799v4.019h-1.09v-4.682c0-.574-.123-1.003-.368-1.287-.246-.289-.629-.434-1.15-.434-.683 0-1.184.206-1.504.617-.315.408-.472 1.077-.472 2.01v3.776h-1.09v-7.198h.886l.177.986h.053c.206-.351.495-.624.867-.821a2.679 2.679 0 0 1 1.26-.296c1.126 0 1.861.407 2.207 1.222h.053c.214-.377.525-.675.932-.894a2.904 2.904 0 0 1 1.393-.328c.814 0 1.423.21 1.825.631.408.415.611 1.083.611 2.003v4.695h-1.09Zm7.77 0-.218-1.024h-.052c-.36.451-.718.757-1.077.919-.355.158-.8.237-1.333.237-.714 0-1.274-.184-1.682-.552-.402-.368-.604-.891-.604-1.57 0-1.453 1.163-2.215 3.487-2.285l1.222-.04v-.446c0-.565-.123-.981-.368-1.248-.24-.271-.628-.407-1.162-.407-.6 0-1.279.184-2.036.552l-.335-.834a5.146 5.146 0 0 1 1.162-.454c.425-.109.85-.164 1.274-.164.859 0 1.493.191 1.905.572.416.38.624.991.624 1.832v4.912h-.808Zm-2.464-.768c.679 0 1.21-.186 1.596-.558.39-.373.585-.894.585-1.563v-.651l-1.09.046c-.867.031-1.493.167-1.879.408-.38.236-.571.606-.571 1.109 0 .394.118.694.355.9.24.206.575.309 1.004.309Zm6.614.768h-1.091v-7.198h1.091v7.198Zm-1.183-9.148c0-.25.062-.431.184-.545a.638.638 0 0 1 .46-.177c.175 0 .326.059.453.177s.191.3.191.545c0 .245-.064.429-.191.552a.643.643 0 0 1-.453.177.638.638 0 0 1-.46-.177c-.122-.123-.184-.307-.184-.552Zm4.584 9.148h-1.09v-10.219h1.09v10.219Zm12.452-4.787c0 .621-.096 1.19-.289 1.707-.193.517-.464.917-.814 1.202a1.867 1.867 0 0 1-1.209.427 1.375 1.375 0 0 1-1.412-1.215h-.052a2.076 2.076 0 0 1-.755.893c-.324.215-.71.322-1.156.322-.657 0-1.171-.223-1.544-.67-.367-.451-.551-1.062-.551-1.832 0-.893.258-1.618.775-2.174.516-.561 1.195-.841 2.036-.841.297 0 .634.029 1.011.086.376.052.716.127 1.018.223l-.164 3.087v.144c0 .779.291 1.169.873 1.169.399 0 .723-.234.972-.703.25-.473.374-1.085.374-1.839 0-.792-.162-1.486-.486-2.081a3.321 3.321 0 0 0-1.385-1.373c-.596-.324-1.281-.486-2.056-.486-.976 0-1.826.204-2.548.611a4.014 4.014 0 0 0-1.655 1.734c-.381.748-.571 1.615-.571 2.6 0 1.336.352 2.362 1.057 3.08s1.721 1.077 3.047 1.077c.92 0 1.874-.188 2.864-.564v.873c-.841.368-1.795.552-2.864.552-1.589 0-2.824-.436-3.704-1.307-.875-.876-1.313-2.097-1.313-3.665 0-1.138.234-2.152.703-3.04a4.967 4.967 0 0 1 2.003-2.063c.867-.49 1.86-.735 2.981-.735.941 0 1.778.199 2.509.598a4.11 4.11 0 0 1 1.701 1.687c.403.727.604 1.566.604 2.516Zm-6.791.86c0 1.112.427 1.668 1.281 1.668.906 0 1.399-.685 1.478-2.056l.092-1.714a3.87 3.87 0 0 0-1.031-.131c-.57 0-1.016.197-1.34.591-.32.394-.48.941-.48 1.642Zm11.789 4.059c-1.064 0-1.905-.324-2.522-.972-.613-.648-.92-1.548-.92-2.7 0-1.16.285-2.081.854-2.764.574-.683 1.342-1.025 2.305-1.025.902 0 1.616.298 2.141.893.526.591.788 1.373.788 2.345v.689h-4.958c.022.845.234 1.487.637 1.925.407.437.979.656 1.714.656.775 0 1.541-.162 2.299-.486v.972a5.545 5.545 0 0 1-1.097.355 5.95 5.95 0 0 1-1.241.112Zm-.296-6.548c-.578 0-1.04.188-1.386.565-.341.376-.542.897-.604 1.563h3.763c0-.688-.153-1.213-.459-1.576-.307-.368-.745-.552-1.314-.552Zm13.982 6.416v-4.682c0-.574-.123-1.003-.368-1.287-.245-.289-.626-.434-1.143-.434-.678 0-1.179.195-1.503.585-.324.389-.486.989-.486 1.799v4.019h-1.091v-4.682c0-.574-.122-1.003-.367-1.287-.246-.289-.629-.434-1.15-.434-.683 0-1.184.206-1.504.617-.315.408-.472 1.077-.472 2.01v3.776h-1.091v-7.198h.887l.177.986h.053c.206-.351.495-.624.867-.821a2.678 2.678 0 0 1 1.261-.296c1.125 0 1.86.407 2.206 1.222h.053a2.29 2.29 0 0 1 .932-.894 2.91 2.91 0 0 1 1.393-.328c.814 0 1.423.21 1.825.631.407.415.611 1.083.611 2.003v4.695h-1.09Zm7.769 0-.217-1.024h-.052c-.359.451-.718.757-1.077.919-.355.158-.799.237-1.333.237-.714 0-1.275-.184-1.682-.552-.402-.368-.604-.891-.604-1.57 0-1.453 1.163-2.215 3.487-2.285l1.222-.04v-.446c0-.565-.123-.981-.368-1.248-.241-.271-.628-.407-1.162-.407-.6 0-1.279.184-2.036.552l-.335-.834a5.156 5.156 0 0 1 2.436-.618c.858 0 1.493.191 1.905.572.416.38.624.991.624 1.832v4.912h-.808Zm-2.463-.768c.679 0 1.211-.186 1.596-.558.39-.373.585-.894.585-1.563v-.651l-1.091.046c-.866.031-1.493.167-1.878.408-.381.236-.571.606-.571 1.109 0 .394.118.694.354.9.241.206.576.309 1.005.309Zm6.614.768h-1.091v-7.198h1.091v7.198Zm-1.183-9.148c0-.25.062-.431.184-.545a.638.638 0 0 1 .46-.177c.175 0 .326.059.453.177s.191.3.191.545c0 .245-.064.429-.191.552a.643.643 0 0 1-.453.177.638.638 0 0 1-.46-.177c-.122-.123-.184-.307-.184-.552Zm4.584 9.148h-1.09v-10.219h1.09v10.219Zm2.154-.696c0-.293.066-.514.197-.663.136-.154.329-.23.578-.23.254 0 .451.076.591.23.145.149.217.37.217.663 0 .285-.072.504-.217.657-.144.153-.341.23-.591.23a.796.796 0 0 1-.558-.204c-.144-.14-.217-.368-.217-.683Zm6.62.828c-1.042 0-1.85-.32-2.423-.959-.569-.644-.854-1.552-.854-2.726 0-1.204.289-2.134.867-2.791.582-.657 1.41-.985 2.482-.985.346 0 .692.037 1.038.112.346.074.617.162.814.262l-.334.926a4.904 4.904 0 0 0-.789-.236 3.385 3.385 0 0 0-.755-.099c-1.462 0-2.193.933-2.193 2.798 0 .885.177 1.563.532 2.036.359.473.888.709 1.589.709.6 0 1.215-.129 1.845-.387v.965c-.481.25-1.088.375-1.819.375Zm9.746-3.737c0 1.173-.295 2.09-.887 2.751-.591.657-1.407.986-2.449.986-.644 0-1.215-.152-1.714-.454a2.986 2.986 0 0 1-1.156-1.3c-.271-.565-.407-1.226-.407-1.983 0-1.174.293-2.086.88-2.739.587-.657 1.401-.985 2.443-.985 1.007 0 1.806.335 2.397 1.005.595.67.893 1.576.893 2.719Zm-5.484 0c0 .919.184 1.62.552 2.101.368.482.909.723 1.622.723.714 0 1.255-.239 1.622-.716.372-.482.559-1.184.559-2.108 0-.915-.187-1.609-.559-2.082-.367-.477-.913-.716-1.635-.716-.714 0-1.252.234-1.616.703-.363.468-.545 1.167-.545 2.095Zm16.576 3.605v-4.682c0-.574-.122-1.003-.368-1.287-.245-.289-.626-.434-1.142-.434-.679 0-1.18.195-1.504.585-.324.389-.486.989-.486 1.799v4.019h-1.09v-4.682c0-.574-.123-1.003-.368-1.287-.245-.289-.628-.434-1.149-.434-.683 0-1.185.206-1.504.617-.315.408-.473 1.077-.473 2.01v3.776h-1.09v-7.198h.886l.178.986h.052c.206-.351.495-.624.867-.821a2.68 2.68 0 0 1 1.261-.296c1.125 0 1.861.407 2.207 1.222h.052c.215-.377.525-.675.933-.894a2.902 2.902 0 0 1 1.392-.328c.814 0 1.423.21 1.826.631.407.415.61 1.083.61 2.003v4.695h-1.09Z",
                className: "notifications_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M65.287 184.645h-.966l-1.695-5.626c-.08-.249-.17-.563-.27-.943-.1-.379-.151-.607-.155-.683a13.088 13.088 0 0 1-.403 1.66l-1.643 5.592h-.965l-2.236-8.402h1.035l1.327 5.189c.184.728.318 1.387.402 1.977.104-.701.257-1.387.46-2.057l1.506-5.109h1.034l1.58 5.155c.184.594.34 1.264.465 2.011.073-.544.211-1.207.414-1.988l1.322-5.178h1.034l-2.246 8.402Zm7.728 0v-4.075c0-.513-.117-.896-.35-1.149-.234-.253-.6-.379-1.098-.379-.662 0-1.147.18-1.454.54-.302.36-.454.95-.454 1.77v3.293h-.954v-8.942h.954v2.707c0 .325-.015.595-.046.81h.058c.188-.303.454-.54.799-.713a2.603 2.603 0 0 1 1.19-.264c.77 0 1.346.184 1.729.552.387.364.58.944.58 1.741v4.109h-.954Zm5.58.114c-.93 0-1.666-.283-2.207-.85-.536-.567-.804-1.354-.804-2.362 0-1.015.249-1.821.747-2.419.502-.598 1.174-.896 2.017-.896.79 0 1.414.26 1.873.781.46.517.69 1.201.69 2.052v.603h-4.339c.02.739.205 1.301.558 1.684.356.383.856.574 1.5.574a5.08 5.08 0 0 0 2.01-.425v.85a4.9 4.9 0 0 1-.959.311c-.299.065-.66.097-1.086.097Zm-.258-5.729c-.506 0-.91.165-1.213.495-.299.329-.475.785-.529 1.367h3.293c0-.601-.134-1.061-.402-1.379-.268-.322-.651-.483-1.15-.483Zm8.516 5.615v-4.075c0-.513-.117-.896-.351-1.149-.234-.253-.6-.379-1.097-.379-.66 0-1.142.178-1.449.534-.306.357-.46.945-.46 1.764v3.305h-.953v-6.298h.776l.155.861h.046c.195-.31.469-.549.821-.718a2.65 2.65 0 0 1 1.178-.258c.759 0 1.33.183 1.713.551.383.364.575.948.575 1.753v4.109h-.954Zm7.493-3.224-2.19-3.074h1.087l1.66 2.413 1.655-2.413h1.075l-2.19 3.074 2.305 3.224h-1.08l-1.765-2.552-1.781 2.552h-1.08l2.304-3.224Zm4.516 2.614c0-.256.058-.45.173-.58.119-.134.287-.201.505-.201.223 0 .395.067.518.201.126.13.189.324.189.58 0 .249-.063.441-.189.575-.127.134-.3.201-.518.201a.696.696 0 0 1-.488-.178c-.126-.123-.19-.322-.19-.598Z",
                className: "notifications_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M65.287 214.906h-.966l-1.695-5.625c-.08-.249-.17-.564-.27-.943s-.151-.607-.155-.684a13.06 13.06 0 0 1-.403 1.661l-1.643 5.591h-.965l-2.236-8.401h1.035l1.327 5.189c.184.728.318 1.387.402 1.977.104-.701.257-1.387.46-2.057l1.506-5.109h1.034l1.58 5.155c.184.593.34 1.264.465 2.011.073-.544.211-1.207.414-1.988l1.322-5.178h1.034l-2.246 8.401Zm7.728 0v-4.074c0-.513-.117-.896-.35-1.149-.234-.253-.6-.379-1.098-.379-.662 0-1.147.18-1.454.54-.302.36-.454.95-.454 1.77v3.292h-.954v-8.941h.954v2.706c0 .326-.015.596-.046.811h.058c.188-.303.454-.54.799-.713a2.603 2.603 0 0 1 1.19-.264c.77 0 1.346.184 1.729.551.387.364.58.945.58 1.742v4.108h-.954Zm5.58.115c-.93 0-1.666-.283-2.207-.85-.536-.567-.804-1.355-.804-2.362 0-1.015.249-1.822.747-2.419.502-.598 1.174-.897 2.017-.897.79 0 1.414.261 1.873.782.46.517.69 1.201.69 2.051v.604h-4.339c.02.739.205 1.3.558 1.683.356.383.856.575 1.5.575a5.08 5.08 0 0 0 2.01-.425v.85a4.827 4.827 0 0 1-.959.31c-.299.066-.66.098-1.086.098Zm-.258-5.729c-.506 0-.91.165-1.213.494-.299.33-.475.786-.529 1.368h3.293c0-.602-.134-1.061-.402-1.379-.268-.322-.651-.483-1.15-.483Zm8.516 5.614v-4.074c0-.513-.117-.896-.351-1.149-.234-.253-.6-.379-1.097-.379-.66 0-1.142.178-1.449.534-.306.356-.46.944-.46 1.764v3.304h-.953v-6.298h.776l.155.862h.046c.195-.31.469-.55.821-.718a2.65 2.65 0 0 1 1.178-.259c.759 0 1.33.184 1.713.552.383.364.575.948.575 1.753v4.108h-.954Zm4.976-6.298h1.023l1.379 3.592c.303.82.49 1.411.563 1.775h.046c.05-.195.153-.528.31-1 .161-.475.682-1.93 1.563-4.367h1.023l-2.706 7.172c-.269.708-.583 1.21-.943 1.505-.356.299-.795.448-1.316.448-.29 0-.578-.032-.862-.097v-.764c.211.045.447.068.707.068.655 0 1.123-.367 1.402-1.103l.35-.896-2.54-6.333Zm6.792 5.689c0-.257.058-.45.172-.58.12-.134.288-.201.506-.201.222 0 .395.067.517.201.127.13.19.323.19.58 0 .249-.063.441-.19.575-.126.134-.298.201-.517.201a.696.696 0 0 1-.488-.178c-.127-.123-.19-.322-.19-.598Z",
                className: "notifications_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M65.287 245.168h-.966l-1.695-5.626c-.08-.249-.17-.563-.27-.942s-.151-.607-.155-.684a13.1 13.1 0 0 1-.403 1.661l-1.643 5.591h-.965l-2.236-8.401h1.035l1.327 5.189c.184.728.318 1.387.402 1.976.104-.701.257-1.386.46-2.057l1.506-5.108h1.034l1.58 5.154c.184.594.34 1.264.465 2.011.073-.543.211-1.206.414-1.988l1.322-5.177h1.034l-2.246 8.401Zm7.728 0v-4.074c0-.514-.117-.897-.35-1.149-.234-.253-.6-.38-1.098-.38-.662 0-1.147.18-1.454.54-.302.361-.454.95-.454 1.77v3.293h-.954v-8.941h.954v2.706c0 .326-.015.596-.046.81h.058a1.93 1.93 0 0 1 .799-.712 2.603 2.603 0 0 1 1.19-.264c.77 0 1.346.183 1.729.551.387.364.58.944.58 1.741v4.109h-.954Zm5.58.115c-.93 0-1.666-.284-2.207-.851-.536-.567-.804-1.354-.804-2.361 0-1.016.249-1.822.747-2.42.502-.597 1.174-.896 2.017-.896.79 0 1.414.261 1.873.782.46.517.69 1.201.69 2.051v.603h-4.339c.02.74.205 1.301.558 1.684.356.383.856.575 1.5.575.678 0 1.348-.142 2.01-.426v.851a4.893 4.893 0 0 1-.959.31c-.299.065-.66.098-1.086.098Zm-.258-5.729c-.506 0-.91.164-1.213.494-.299.329-.475.785-.529 1.368h3.293c0-.602-.134-1.062-.402-1.38-.268-.321-.651-.482-1.15-.482Zm8.516 5.614v-4.074c0-.514-.117-.897-.351-1.149-.234-.253-.6-.38-1.097-.38-.66 0-1.142.178-1.449.535-.306.356-.46.944-.46 1.764v3.304h-.953v-6.298h.776l.155.862h.046c.195-.31.469-.55.821-.718a2.637 2.637 0 0 1 1.178-.259c.759 0 1.33.184 1.713.552.383.364.575.948.575 1.752v4.109h-.954Zm10.004 0h-4.568v-.649l3.436-4.908h-3.224v-.741h4.27v.741l-3.39 4.816h3.476v.741Zm1.339-.609c0-.257.057-.45.172-.581.119-.134.288-.201.506-.201.222 0 .395.067.517.201.127.131.19.324.19.581 0 .249-.063.44-.19.574-.126.135-.299.202-.517.202a.697.697 0 0 1-.489-.179c-.126-.122-.19-.321-.19-.597Z",
                className: "notifications_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#notifications_svg__b)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 29.9,
                        y: 173.324,
                        width: 13.45,
                        height: 13.45,
                        rx: 2.522,
                        className: "notifications_svg__rect-4"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "M40.78 176.688h-.991a.673.673 0 0 0-.548.281l-3.324 4.61-1.506-2.089a.676.676 0 0 0-.548-.282h-.992a.17.17 0 0 0-.137.269l2.635 3.655a.68.68 0 0 0 .547.28.67.67 0 0 0 .546-.28l4.454-6.176a.168.168 0 0 0-.135-.268Z",
                        className: "notifications_svg__path-5"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 30.32,
                        y: 204.006,
                        width: 12.609,
                        height: 12.609,
                        rx: 2.102,
                        className: "notifications_svg__rect-5"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 30.32,
                        y: 234.268,
                        width: 12.609,
                        height: 12.609,
                        rx: 2.102,
                        className: "notifications_svg__rect-6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M131.332 138.483c0 .853-.308 1.523-.926 2.009-.617.486-1.469.729-2.554.729-1.086 0-1.975-.168-2.667-.505v-1.485c.438.206.902.368 1.393.486.494.118.954.178 1.379.178.621 0 1.079-.119 1.372-.355.298-.236.447-.554.447-.952 0-.359-.136-.664-.407-.913-.272-.25-.832-.545-1.682-.887-.875-.354-1.493-.759-1.852-1.215-.359-.455-.538-1.002-.538-1.641 0-.802.284-1.432.854-1.892.569-.46 1.333-.689 2.292-.689.919 0 1.834.201 2.745.604l-.499 1.28c-.854-.359-1.616-.538-2.286-.538-.508 0-.893.112-1.156.335-.262.219-.394.51-.394.873 0 .25.053.464.158.644.105.175.278.341.519.499.241.158.674.366 1.3.624.705.293 1.222.567 1.55.821.328.254.569.54.722.86.154.32.23.696.23 1.13Zm4.867 2.738c-1.13 0-2.014-.328-2.654-.985-.634-.661-.952-1.569-.952-2.725 0-1.187.296-2.119.887-2.798.591-.679 1.403-1.018 2.436-1.018.959 0 1.716.291 2.272.874.557.582.835 1.383.835 2.403v.834h-4.841c.022.705.213 1.248.572 1.629.359.376.864.565 1.517.565.429 0 .827-.04 1.195-.119a6.356 6.356 0 0 0 1.195-.407v1.255a4.778 4.778 0 0 1-1.142.381 7.057 7.057 0 0 1-1.32.111Zm-.283-6.357c-.49 0-.884.155-1.182.466-.293.311-.468.764-.525 1.36h3.296c-.008-.6-.153-1.053-.433-1.36-.28-.311-.665-.466-1.156-.466Zm11.25 6.226h-1.55v-4.466c0-.56-.114-.978-.341-1.254-.224-.276-.581-.414-1.071-.414-.652 0-1.129.193-1.432.578-.302.385-.453 1.031-.453 1.937v3.619h-1.543v-7.264h1.208l.217.953h.079c.219-.346.53-.613.932-.802.403-.188.85-.282 1.34-.282 1.743 0 2.614.887 2.614 2.66v4.735Zm4.597.131c-.906 0-1.613-.328-2.121-.985s-.762-1.578-.762-2.765c0-1.191.256-2.117.768-2.778.517-.665 1.231-.998 2.141-.998.955 0 1.682.353 2.181 1.057h.078a9.297 9.297 0 0 1-.111-1.234v-2.647h1.55v10.219h-1.209l-.269-.952h-.072c-.495.722-1.22 1.083-2.174 1.083Zm.414-1.248c.635 0 1.097-.177 1.385-.532.289-.359.438-.939.447-1.74v-.217c0-.915-.149-1.565-.447-1.95-.297-.385-.764-.578-1.398-.578-.543 0-.961.221-1.255.663-.293.438-.44 1.064-.44 1.879 0 .805.143 1.42.427 1.845.285.42.712.63 1.281.63Zm13.325 1.117-2.785-8.019h-.052c.074 1.191.111 2.308.111 3.35v4.669h-1.425v-9.602h2.213l2.667 7.638h.039l2.745-7.638h2.22v9.602h-1.51v-4.748c0-.478.01-1.099.032-1.865.027-.767.049-1.231.066-1.393h-.052l-2.884 8.006h-1.385Zm11.269.131c-1.129 0-2.014-.328-2.653-.985-.635-.661-.952-1.569-.952-2.725 0-1.187.295-2.119.886-2.798.591-.679 1.404-1.018 2.437-1.018.959 0 1.716.291 2.272.874.556.582.834 1.383.834 2.403v.834h-4.84c.022.705.212 1.248.571 1.629.359.376.865.565 1.517.565.43 0 .828-.04 1.196-.119a6.38 6.38 0 0 0 1.195-.407v1.255a4.785 4.785 0 0 1-1.143.381 7.042 7.042 0 0 1-1.32.111Zm-.282-6.357c-.491 0-.885.155-1.182.466-.294.311-.469.764-.526 1.36h3.297c-.009-.6-.153-1.053-.433-1.36-.281-.311-.666-.466-1.156-.466Zm16.517 6.226h-1.925l-4.722-7.651h-.052l.033.427c.061.814.092 1.558.092 2.233v4.991h-1.425v-9.602h1.904l4.709 7.612h.039a43.055 43.055 0 0 1-.052-1.097 37.022 37.022 0 0 1-.04-1.484v-5.031h1.439v9.602Zm8.813-3.645c0 1.186-.304 2.112-.913 2.778-.609.665-1.456.998-2.542.998-.678 0-1.278-.153-1.799-.46a3.029 3.029 0 0 1-1.202-1.32c-.28-.573-.42-1.239-.42-1.996 0-1.178.302-2.097.906-2.758.604-.661 1.456-.992 2.555-.992 1.051 0 1.882.339 2.495 1.018.613.674.92 1.585.92 2.732Zm-5.287 0c0 1.677.62 2.515 1.859 2.515 1.226 0 1.839-.838 1.839-2.515 0-1.659-.618-2.489-1.852-2.489-.648 0-1.119.215-1.412.644-.289.429-.434 1.044-.434 1.845Zm9.772 2.528c.377 0 .753-.059 1.13-.177v1.162a2.973 2.973 0 0 1-.663.184 4.293 4.293 0 0 1-.835.079c-1.462 0-2.193-.77-2.193-2.311v-3.915h-.992v-.683l1.064-.564.526-1.537h.952v1.615h2.069v1.169h-2.069v3.888c0 .372.092.648.276.828.188.175.433.262.735.262Zm4.131 1.117h-1.543v-7.264h1.543v7.264Zm-1.635-9.188c0-.276.074-.488.223-.637.153-.149.37-.223.65-.223.272 0 .482.074.631.223.153.149.23.361.23.637 0 .263-.077.471-.23.624-.149.149-.359.223-.631.223-.28 0-.497-.074-.65-.223-.149-.153-.223-.361-.223-.624Zm7.493 3.093h-1.773v6.095h-1.55v-6.095h-1.195v-.722l1.195-.473v-.473c0-.858.201-1.493.604-1.904.403-.416 1.018-.624 1.846-.624.543 0 1.077.09 1.602.269l-.407 1.169a3.575 3.575 0 0 0-1.09-.184c-.351 0-.607.11-.769.329-.157.214-.236.538-.236.972v.472h1.773v1.169Zm2.778 6.095h-1.543v-7.264h1.543v7.264Zm-1.635-9.188c0-.276.074-.488.223-.637.153-.149.37-.223.65-.223.272 0 .482.074.631.223.153.149.23.361.23.637 0 .263-.077.471-.23.624-.149.149-.359.223-.631.223-.28 0-.497-.074-.65-.223-.149-.153-.223-.361-.223-.624Zm6.784 9.319c-1.099 0-1.935-.319-2.509-.959-.569-.643-.854-1.565-.854-2.764 0-1.222.298-2.161.893-2.818.6-.657 1.465-.985 2.595-.985.766 0 1.455.142 2.068.427l-.466 1.241c-.652-.254-1.191-.381-1.616-.381-1.256 0-1.884.834-1.884 2.502 0 .815.155 1.428.466 1.839.315.407.775.611 1.379.611.687 0 1.338-.171 1.951-.512v1.346a3.048 3.048 0 0 1-.887.348 5.26 5.26 0 0 1-1.136.105Zm8.275-.131-.309-1.012h-.053c-.35.443-.702.745-1.057.907-.355.157-.81.236-1.366.236-.714 0-1.272-.192-1.675-.578-.398-.385-.597-.93-.597-1.635 0-.749.278-1.313.834-1.694.556-.381 1.403-.589 2.541-.624l1.255-.04v-.387c0-.464-.11-.81-.329-1.038-.214-.232-.549-.348-1.004-.348-.373 0-.729.055-1.071.164-.341.11-.67.239-.985.388l-.499-1.103a5.257 5.257 0 0 1 1.294-.467c.468-.109.91-.164 1.326-.164.924 0 1.62.201 2.089.604.472.403.709 1.036.709 1.898v4.893h-1.103Zm-2.299-1.051c.56 0 1.009-.155 1.346-.466.342-.315.513-.755.513-1.32v-.631l-.933.04c-.727.026-1.257.149-1.589.367-.329.215-.493.546-.493.992 0 .324.097.576.289.755.193.176.482.263.867.263Zm8.262-.066c.376 0 .753-.059 1.129-.177v1.162a2.973 2.973 0 0 1-.663.184 4.275 4.275 0 0 1-.834.079c-1.462 0-2.194-.77-2.194-2.311v-3.915h-.991v-.683l1.064-.564.525-1.537h.952v1.615h2.069v1.169h-2.069v3.888c0 .372.092.648.276.828.188.175.434.262.736.262Zm4.13 1.117h-1.543v-7.264h1.543v7.264Zm-1.635-9.188c0-.276.075-.488.223-.637.154-.149.37-.223.651-.223.271 0 .481.074.63.223.153.149.23.361.23.637 0 .263-.077.471-.23.624-.149.149-.359.223-.63.223-.281 0-.497-.074-.651-.223-.148-.153-.223-.361-.223-.624Zm10.291 5.543c0 1.186-.304 2.112-.913 2.778-.608.665-1.455.998-2.541.998-.679 0-1.279-.153-1.8-.46a3.027 3.027 0 0 1-1.201-1.32c-.281-.573-.421-1.239-.421-1.996 0-1.178.302-2.097.906-2.758.605-.661 1.456-.992 2.555-.992 1.051 0 1.883.339 2.496 1.018.613.674.919 1.585.919 2.732Zm-5.287 0c0 1.677.62 2.515 1.859 2.515 1.226 0 1.839-.838 1.839-2.515 0-1.659-.617-2.489-1.852-2.489-.648 0-1.119.215-1.412.644-.289.429-.434 1.044-.434 1.845Zm13.457 3.645h-1.55v-4.466c0-.56-.114-.978-.342-1.254-.223-.276-.58-.414-1.07-.414-.652 0-1.13.193-1.432.578-.302.385-.453 1.031-.453 1.937v3.619h-1.543v-7.264h1.208l.217.953h.079c.219-.346.53-.613.932-.802.403-.188.85-.282 1.34-.282 1.743 0 2.614.887 2.614 2.66v4.735Zm7.027-2.069c0 .709-.259 1.255-.775 1.635-.517.377-1.257.565-2.22.565-.967 0-1.745-.146-2.331-.44v-1.333c.853.394 1.648.591 2.384.591.95 0 1.425-.287 1.425-.86a.683.683 0 0 0-.158-.46c-.105-.123-.278-.249-.519-.381a8.854 8.854 0 0 0-1.004-.446c-.837-.324-1.404-.648-1.701-.972-.294-.324-.44-.745-.44-1.261 0-.622.249-1.104.748-1.445.504-.346 1.187-.519 2.049-.519.854 0 1.662.173 2.424.519l-.5 1.162c-.783-.324-1.442-.486-1.976-.486-.815 0-1.222.232-1.222.696 0 .228.105.421.315.578.215.158.679.375 1.393.651.6.232 1.035.444 1.307.637.271.192.472.416.604.669.131.25.197.55.197.9Z",
                className: "notifications_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M264.396 82.09h-1.684l-4.132-6.695h-.046l.029.374c.054.712.081 1.364.081 1.954v4.367h-1.247v-8.401h1.666l4.12 6.66h.035a37.078 37.078 0 0 1-.046-.96 33.648 33.648 0 0 1-.035-1.299V73.69h1.259v8.4Zm7.711-3.19c0 1.039-.266 1.849-.798 2.431-.533.583-1.274.874-2.224.874-.594 0-1.119-.134-1.575-.403a2.652 2.652 0 0 1-1.051-1.155c-.246-.501-.368-1.084-.368-1.746 0-1.03.264-1.835.793-2.414.528-.578 1.274-.868 2.235-.868.92 0 1.647.297 2.184.891.536.59.804 1.387.804 2.39Zm-4.626 0c0 1.468.543 2.201 1.627 2.201 1.072 0 1.609-.733 1.609-2.2 0-1.452-.541-2.178-1.621-2.178-.567 0-.979.188-1.235.563-.253.375-.38.914-.38 1.615Zm8.551 2.213c.329 0 .659-.052.988-.155v1.017a2.61 2.61 0 0 1-.58.16 3.775 3.775 0 0 1-.73.07c-1.279 0-1.919-.674-1.919-2.023v-3.425h-.868v-.597l.931-.495.46-1.344h.833v1.413h1.81v1.023h-1.81v3.402c0 .326.081.567.241.724.165.153.38.23.644.23Zm3.614.977h-1.35v-6.356h1.35v6.356Zm-1.43-8.04c0-.24.065-.426.195-.557.134-.13.324-.195.569-.195.237 0 .421.065.552.195.134.13.201.316.201.558 0 .23-.067.412-.201.546-.131.13-.315.195-.552.195-.245 0-.435-.065-.569-.195-.13-.134-.195-.316-.195-.546Zm6.556 2.707h-1.551v5.333h-1.356v-5.333h-1.046v-.632l1.046-.414v-.413c0-.751.176-1.307.528-1.667.353-.364.891-.546 1.615-.546.475 0 .942.079 1.402.236l-.356 1.023a3.113 3.113 0 0 0-.954-.161c-.307 0-.531.096-.672.287-.138.188-.207.471-.207.85v.414h1.551v1.023Zm2.431 5.333h-1.35v-6.356h1.35v6.356Zm-1.431-8.04c0-.24.065-.426.196-.557.134-.13.323-.195.568-.195.238 0 .422.065.552.195.134.13.201.316.201.558 0 .23-.067.412-.201.546-.13.13-.314.195-.552.195-.245 0-.434-.065-.568-.195-.131-.134-.196-.316-.196-.546Zm5.936 8.155c-.961 0-1.693-.28-2.195-.84-.498-.562-.747-1.369-.747-2.418 0-1.07.26-1.891.781-2.466.525-.574 1.282-.862 2.27-.862.671 0 1.274.125 1.81.374l-.408 1.086c-.57-.222-1.042-.333-1.413-.333-1.1 0-1.649.73-1.649 2.19 0 .712.136 1.248.408 1.608.275.356.678.535 1.206.535.602 0 1.171-.15 1.707-.449v1.178a2.66 2.66 0 0 1-.776.305 4.594 4.594 0 0 1-.994.092Zm7.241-.115-.271-.885h-.046c-.306.387-.614.651-.925.793-.31.138-.708.207-1.195.207-.624 0-1.113-.169-1.465-.506-.349-.337-.523-.814-.523-1.43 0-.656.243-1.15.73-1.483.486-.334 1.227-.516 2.223-.546l1.098-.035v-.339c0-.406-.096-.709-.287-.908-.188-.203-.481-.304-.879-.304-.326 0-.638.048-.937.143a7.065 7.065 0 0 0-.862.34l-.437-.966c.345-.18.722-.316 1.132-.408.41-.096.797-.144 1.161-.144.808 0 1.417.177 1.827.53.414.352.621.905.621 1.66v4.28h-.965Zm-2.012-.92c.491 0 .883-.136 1.178-.408.299-.275.449-.66.449-1.155v-.551l-.816.034c-.636.023-1.1.13-1.391.322-.287.188-.431.477-.431.868 0 .283.084.504.253.66.168.154.421.23.758.23Zm7.229-.057c.33 0 .659-.052.989-.155v1.017c-.15.065-.343.119-.581.16a3.767 3.767 0 0 1-.73.07c-1.279 0-1.919-.674-1.919-2.023v-3.425h-.868v-.597l.931-.495.46-1.344h.833v1.413h1.81v1.023h-1.81v3.402c0 .326.081.567.242.724.164.153.379.23.643.23Zm3.615.977h-1.351v-6.356h1.351v6.356Zm-1.431-8.04c0-.24.065-.426.195-.557.134-.13.324-.195.569-.195.238 0 .422.065.552.195.134.13.201.316.201.558 0 .23-.067.412-.201.546-.13.13-.314.195-.552.195-.245 0-.435-.065-.569-.195-.13-.134-.195-.316-.195-.546Zm9.004 4.85c0 1.039-.266 1.849-.798 2.431-.533.583-1.274.874-2.224.874-.594 0-1.119-.134-1.575-.403a2.652 2.652 0 0 1-1.051-1.155c-.245-.501-.368-1.084-.368-1.746 0-1.03.264-1.835.793-2.414.529-.578 1.274-.868 2.235-.868.92 0 1.648.297 2.184.891.536.59.804 1.387.804 2.39Zm-4.625 0c0 1.468.542 2.201 1.626 2.201 1.072 0 1.609-.733 1.609-2.2 0-1.452-.54-2.178-1.621-2.178-.567 0-.978.188-1.235.563-.253.375-.379.914-.379 1.615Zm11.774 3.19h-1.356v-3.908c0-.49-.1-.856-.299-1.097-.195-.242-.508-.362-.937-.362-.571 0-.988.168-1.252.505-.265.338-.397.903-.397 1.696v3.166h-1.35v-6.356h1.057l.19.834h.069c.191-.303.463-.537.816-.701a2.733 2.733 0 0 1 1.172-.248c1.525 0 2.287.776 2.287 2.328v4.143Zm6.149-1.81c0 .62-.227 1.097-.679 1.43-.452.33-1.099.495-1.942.495-.846 0-1.526-.129-2.04-.385v-1.167c.747.345 1.443.517 2.086.517.831 0 1.247-.25 1.247-.752a.596.596 0 0 0-.138-.403c-.092-.107-.243-.218-.454-.333a7.777 7.777 0 0 0-.879-.39c-.732-.284-1.228-.568-1.488-.851-.257-.284-.385-.651-.385-1.103 0-.544.218-.966.655-1.265.44-.302 1.038-.454 1.793-.454a5.07 5.07 0 0 1 2.12.454l-.437 1.018c-.685-.284-1.262-.426-1.729-.426-.713 0-1.069.203-1.069.61 0 .199.092.367.276.505.187.138.593.328 1.218.569.525.203.906.389 1.143.557.238.169.414.364.529.587.115.218.173.48.173.787Z",
                className: "notifications_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M99.2 77.533h3.092v4.218a8.924 8.924 0 0 1-1.46.35c-.463.07-.965.104-1.505.104-1.272 0-2.253-.376-2.942-1.126-.69-.755-1.035-1.818-1.035-3.19 0-1.352.39-2.41 1.167-3.172.778-.766 1.848-1.149 3.212-1.149.877 0 1.709.169 2.494.506l-.483 1.143a4.85 4.85 0 0 0-2.045-.471c-.897 0-1.605.282-2.126.845-.522.563-.782 1.333-.782 2.31 0 1.026.234 1.808.701 2.344.471.533 1.147.799 2.028.799.445 0 .92-.055 1.426-.167v-2.166h-1.741v-1.178Zm7.747 4.672c-.989 0-1.763-.287-2.322-.862-.555-.579-.833-1.374-.833-2.385 0-1.038.258-1.854.776-2.448.517-.594 1.227-.89 2.131-.89.839 0 1.502.254 1.989.764.486.51.73 1.21.73 2.103v.73h-4.236c.02.616.186 1.091.5 1.425.314.33.757.494 1.328.494.375 0 .724-.034 1.046-.103a5.625 5.625 0 0 0 1.045-.357v1.098a4.133 4.133 0 0 1-.999.333 6.146 6.146 0 0 1-1.155.098Zm-.248-5.563c-.429 0-.773.136-1.034.408-.257.272-.41.669-.46 1.19h2.885c-.008-.525-.134-.922-.379-1.19-.245-.272-.582-.408-1.012-.408Zm9.844 5.448h-1.356v-3.908c0-.49-.1-.856-.299-1.097-.195-.242-.508-.362-.937-.362-.57 0-.988.168-1.252.505-.265.338-.397.903-.397 1.696v3.166h-1.35v-6.356h1.057l.19.834h.069c.191-.303.463-.537.816-.701a2.733 2.733 0 0 1 1.172-.248c1.525 0 2.287.776 2.287 2.328v4.143Zm4.655.115c-.989 0-1.763-.287-2.322-.862-.555-.579-.833-1.374-.833-2.385 0-1.038.258-1.854.776-2.448.517-.594 1.227-.89 2.131-.89.839 0 1.502.254 1.989.764.486.51.729 1.21.729 2.103v.73h-4.235c.02.616.186 1.091.5 1.425.314.33.757.494 1.328.494.375 0 .724-.034 1.046-.103a5.625 5.625 0 0 0 1.045-.357v1.098a4.133 4.133 0 0 1-.999.333 6.146 6.146 0 0 1-1.155.098Zm-.248-5.563c-.429 0-.773.136-1.034.408-.257.272-.41.669-.46 1.19h2.885c-.008-.525-.134-.922-.379-1.19-.245-.272-.582-.408-1.012-.408Zm7.476-1.023c.272 0 .497.02.673.058l-.132 1.258a2.556 2.556 0 0 0-.598-.069c-.54 0-.979.177-1.316.53-.333.352-.5.81-.5 1.372v3.322h-1.35v-6.356h1.057l.178 1.12h.069c.211-.378.485-.68.822-.901a1.974 1.974 0 0 1 1.097-.334Zm5.833 6.47-.27-.884h-.046c-.306.387-.615.651-.925.793-.31.138-.709.207-1.195.207-.625 0-1.113-.169-1.466-.506-.348-.337-.523-.814-.523-1.43 0-.656.244-1.15.73-1.483.487-.334 1.228-.516 2.224-.546l1.098-.035v-.339c0-.406-.096-.709-.288-.908-.188-.203-.481-.304-.879-.304-.326 0-.638.048-.937.143a7.13 7.13 0 0 0-.862.34l-.436-.966c.344-.18.722-.316 1.132-.408a5.11 5.11 0 0 1 1.16-.144c.809 0 1.418.177 1.828.53.414.352.62.905.62 1.66v4.28h-.965Zm-2.011-.919c.49 0 .883-.136 1.178-.408.299-.275.448-.66.448-1.155v-.551l-.816.034c-.636.023-1.099.13-1.391.322-.287.188-.431.477-.431.868 0 .283.085.504.253.66.169.154.422.23.759.23Zm6.212.92h-1.351v-8.942h1.351v8.942Z",
                className: "notifications_svg__path-8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "notifications_svg__line-1",
                d: "M30 98.931h329.52"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                className: "notifications_svg__line-2",
                d: "M204.847 98.091h156.354"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M166.931 45.988c0 1.28-.463 2.285-1.389 3.014-.926.729-2.204 1.093-3.832 1.093-1.629 0-2.962-.252-4-.758V47.11c.657.308 1.353.551 2.088.729a8.947 8.947 0 0 0 2.069.266c.933 0 1.619-.178 2.059-.532.447-.355.67-.831.67-1.429a1.79 1.79 0 0 0-.611-1.369c-.407-.374-1.248-.818-2.522-1.33-1.313-.532-2.239-1.14-2.778-1.822-.538-.683-.807-1.504-.807-2.463 0-1.202.426-2.148 1.28-2.837.854-.69 2-1.035 3.438-1.035 1.379 0 2.752.303 4.118.907l-.749 1.92c-1.28-.538-2.423-.807-3.428-.807-.762 0-1.34.167-1.734.502-.394.329-.591.766-.591 1.31 0 .375.079.697.237.966.157.263.417.512.778.749.361.236 1.011.548 1.95.935 1.058.44 1.833.85 2.325 1.232.493.38.854.81 1.084 1.29.23.48.345 1.044.345 1.695Zm7.299 4.108c-1.694 0-3.021-.493-3.98-1.478-.952-.992-1.428-2.355-1.428-4.088 0-1.78.443-3.179 1.33-4.197.886-1.018 2.105-1.527 3.654-1.527 1.439 0 2.575.437 3.409 1.31.834.874 1.251 2.076 1.251 3.606v1.251h-7.26c.033 1.057.318 1.872.857 2.443.538.565 1.297.847 2.275.847a8.55 8.55 0 0 0 1.793-.177 9.643 9.643 0 0 0 1.793-.61v1.88a7.11 7.11 0 0 1-1.714.572c-.578.112-1.238.168-1.98.168Zm-.424-9.536c-.735 0-1.326.233-1.773.7-.44.465-.702 1.145-.788 2.038h4.945c-.013-.9-.229-1.58-.65-2.039-.42-.466-.998-.7-1.734-.7Zm11.349 7.664c.565 0 1.129-.089 1.694-.266V49.7a4.504 4.504 0 0 1-.995.276c-.4.08-.817.119-1.251.119-2.193 0-3.29-1.156-3.29-3.468v-5.871h-1.488v-1.025l1.596-.847.788-2.305h1.429v2.423h3.103v1.754h-3.103v5.832c0 .558.138.971.413 1.24.283.263.651.395 1.104.395Zm7.94 0c.564 0 1.129-.089 1.694-.266V49.7a4.504 4.504 0 0 1-.995.276 6.467 6.467 0 0 1-1.251.119c-2.194 0-3.29-1.156-3.29-3.468v-5.871h-1.488v-1.025l1.596-.847.788-2.305h1.429v2.423h3.103v1.754h-3.103v5.832c0 .558.137.971.413 1.24.283.263.65.395 1.104.395Zm6.196 1.674h-2.315V39.003h2.315v10.895Zm-2.453-13.781c0-.414.112-.732.335-.956.23-.223.555-.334.975-.334.407 0 .722.111.946.334.23.224.345.542.345.956 0 .394-.115.706-.345.936-.224.223-.539.335-.946.335-.42 0-.745-.112-.975-.335-.223-.23-.335-.542-.335-.936Zm15.357 13.781h-2.324V43.2c0-.84-.171-1.468-.513-1.882-.335-.413-.87-.62-1.605-.62-.979 0-1.695.289-2.148.867-.453.578-.679 1.546-.679 2.906v5.427h-2.315V39.003h1.812l.325 1.429h.118c.329-.52.795-.92 1.399-1.202a4.687 4.687 0 0 1 2.01-.424c2.614 0 3.92 1.33 3.92 3.99v7.102Zm12.422-10.895v1.271l-1.861.345c.17.23.312.512.423.847.112.335.168.69.168 1.064 0 1.123-.388 2.006-1.163 2.65-.775.643-1.842.965-3.201.965-.348 0-.664-.026-.946-.079-.499.31-.749.67-.749 1.084 0 .25.115.437.345.562.237.124.667.187 1.291.187h1.901c1.202 0 2.115.256 2.738.768.624.512.936 1.251.936 2.216 0 1.235-.509 2.187-1.527 2.857-1.018.67-2.489 1.005-4.413 1.005-1.484 0-2.617-.263-3.398-.788-.782-.525-1.173-1.274-1.173-2.246 0-.67.211-1.235.631-1.694.427-.454 1.021-.769 1.783-.946a1.784 1.784 0 0 1-.769-.63 1.644 1.644 0 0 1-.295-.927c0-.407.115-.751.345-1.034.23-.282.571-.561 1.024-.837a3.072 3.072 0 0 1-1.379-1.182c-.348-.552-.522-1.195-.522-1.931 0-1.182.371-2.098 1.113-2.748.749-.65 1.813-.976 3.192-.976.308 0 .63.023.965.07.342.039.598.081.769.127h3.772Zm-8.56 12.59c0 .499.223.883.67 1.152.453.27 1.087.404 1.901.404 1.261 0 2.2-.18 2.817-.542.618-.36.926-.84.926-1.438 0-.473-.17-.81-.512-1.014-.335-.197-.962-.296-1.881-.296h-1.754c-.663 0-1.192.154-1.586.463-.387.315-.581.739-.581 1.27Zm.995-9.063c0 .683.174 1.208.522 1.576.355.368.86.552 1.517.552 1.34 0 2.01-.716 2.01-2.148 0-.709-.168-1.254-.503-1.635-.328-.388-.83-.581-1.507-.581-.67 0-1.179.19-1.527.571-.341.381-.512.936-.512 1.665Zm16.914 4.265c0 1.064-.387 1.882-1.162 2.453-.775.565-1.885.848-3.33.848-1.451 0-2.617-.22-3.497-.66v-2c1.281.59 2.472.886 3.576.886 1.425 0 2.137-.43 2.137-1.29a1.02 1.02 0 0 0-.236-.69c-.158-.184-.417-.374-.778-.571-.361-.197-.864-.42-1.507-.67-1.255-.486-2.105-.972-2.552-1.458-.44-.486-.66-1.116-.66-1.891 0-.933.375-1.655 1.123-2.168.755-.518 1.78-.778 3.074-.778 1.28 0 2.492.26 3.635.779l-.749 1.743c-1.176-.486-2.164-.729-2.965-.729-1.222 0-1.832.348-1.832 1.044 0 .342.157.63.472.867.322.237 1.018.562 2.089.976.9.348 1.553.666 1.96.955.407.289.709.624.906 1.005.197.374.296.824.296 1.35Z",
                className: "notifications_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "notifications_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(29.9 173.324)",
                            className: "notifications_svg__rect-7",
                            d: "M0 0h13.45v73.974H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "notifications_svg__a",
                        x: 0,
                        y: 0,
                        width: 391,
                        height: 354,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.5
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210930"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210930",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $27115e40143d7c20$export$2e2bcd8739ae039 = $27115e40143d7c20$var$SvgNotifications;



const $fb7ce8d9571a15e1$var$StyledNotificationsSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $27115e40143d7c20$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="rect-5"],
  [class$="rect-6"],
  [class$="path-5"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"],
  [class$="line-1"],
  [class$="rect-3"],
  [class$="rect-5"],
  [class$="rect-6"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-4"],
  [class$="rect-7"],
  [class$="path-7"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="line-2"] {
    stroke: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-1"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-2"],
  [class$="path-3"],
  [class$="path-4"],
  [class$="path-6"],
  [class$="path-8"],
  [class$="path-9"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }
`;
const $fb7ce8d9571a15e1$var$Notifications = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $fb7ce8d9571a15e1$var$StyledNotificationsSvg
    });
var $fb7ce8d9571a15e1$export$2e2bcd8739ae039 = $fb7ce8d9571a15e1$var$Notifications;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $a8b1e0ff638e08ba$var$SvgStakingSection = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 391 194",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#staking-section_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3,
                        y: 1,
                        width: 385,
                        height: 188.78,
                        rx: 2.505,
                        className: "staking-section_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3.417,
                        y: 1.417,
                        width: 384.165,
                        height: 187.945,
                        rx: 2.087,
                        className: "staking-section_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 30.136,
                y: 82.496,
                width: 325.165,
                height: 36.737,
                rx: 2.087,
                className: "staking-section_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M43.84 100.349c0-1.874.363-3.275 1.09-4.2.73-.931 1.808-1.397 3.235-1.397.491 0 .878.042 1.16.124v.933a3.716 3.716 0 0 0-1.147-.163c-1.022 0-1.803.32-2.342.959-.54.635-.835 1.635-.887 3h.078c.479-.748 1.235-1.122 2.27-1.122.857 0 1.531.26 2.022.777.496.517.744 1.219.744 2.107 0 .991-.272 1.772-.815 2.341-.54.566-1.27.848-2.192.848-.987 0-1.77-.369-2.348-1.109-.579-.743-.868-1.776-.868-3.098Zm3.203 3.288c.617 0 1.096-.194 1.435-.581.343-.391.515-.955.515-1.689 0-.631-.159-1.127-.476-1.488-.317-.36-.791-.541-1.422-.541a2.4 2.4 0 0 0-1.076.241c-.326.161-.587.383-.783.666a1.547 1.547 0 0 0-.287.88c0 .448.087.866.26 1.253.175.387.42.693.738.919.322.226.687.34 1.096.34Zm10.6.789h-6.269v-.933l2.511-2.524c.766-.774 1.27-1.327 1.514-1.657.243-.33.426-.653.548-.966.121-.313.182-.65.182-1.01 0-.51-.154-.912-.463-1.207-.309-.3-.737-.45-1.285-.45a3.26 3.26 0 0 0-1.128.195c-.353.13-.746.368-1.181.711l-.574-.737c.878-.73 1.835-1.096 2.87-1.096.896 0 1.598.23 2.107.692.509.456.763 1.072.763 1.846 0 .604-.17 1.202-.509 1.793-.339.592-.974 1.34-1.904 2.244l-2.088 2.042v.052h4.906v1.005Zm7.697-4.782c0 1.649-.261 2.879-.783 3.692-.518.814-1.311 1.22-2.381 1.22-1.026 0-1.807-.415-2.342-1.246-.535-.835-.802-2.057-.802-3.666 0-1.66.259-2.894.776-3.698.518-.805 1.307-1.207 2.368-1.207 1.035 0 1.82.42 2.355 1.26.539.838.809 2.054.809 3.645Zm-5.212 0c0 1.388.163 2.399.49 3.034.325.63.845.945 1.558.945.722 0 1.244-.319 1.566-.958.326-.644.489-1.651.489-3.02 0-1.37-.163-2.373-.49-3.008-.321-.639-.843-.959-1.565-.959-.713 0-1.233.316-1.559.946-.326.627-.49 1.633-.49 3.02Zm16.712-1.976c0 .965-.33 1.709-.992 2.23-.656.518-1.598.777-2.824.777h-1.122v3.751h-1.11v-9.537h2.473c2.383 0 3.575.927 3.575 2.779Zm-4.938 2.055h.998c.982 0 1.694-.159 2.133-.476.439-.318.659-.827.659-1.527 0-.63-.207-1.1-.62-1.409-.413-.309-1.057-.463-1.93-.463h-1.24v3.875Zm14.39 4.703h-1.266l-5.212-8.004h-.052c.07.94.104 1.8.104 2.583v5.421h-1.024v-9.537h1.252l5.2 7.971h.052a71.42 71.42 0 0 1-.06-1.128 19.704 19.704 0 0 1-.032-1.37v-5.473h1.037v9.537Zm9.51 0h-1.305l-3.477-4.625-.998.887v3.738h-1.109v-9.537h1.11v4.73l4.324-4.73h1.311l-3.835 4.142 3.979 5.395Z",
                className: "staking-section_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 268.697,
                y: 82.074,
                width: 89.436,
                height: 38.203,
                rx: 2.505,
                className: "staking-section_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M302.326 103.086c0 .848-.306 1.513-.919 1.996-.614.483-1.459.724-2.538.724-1.078 0-1.961-.167-2.648-.502v-1.474a7.22 7.22 0 0 0 1.383.482c.491.118.948.177 1.37.177.617 0 1.071-.118 1.363-.353.296-.234.443-.55.443-.945 0-.357-.134-.659-.404-.907s-.826-.542-1.67-.881c-.87-.352-1.483-.754-1.839-1.206-.357-.453-.535-.996-.535-1.631 0-.796.282-1.422.848-1.879.565-.456 1.324-.685 2.276-.685.913 0 1.822.2 2.727.6l-.496 1.272c-.848-.356-1.605-.534-2.27-.534-.504 0-.887.11-1.148.332-.261.218-.391.507-.391.868 0 .248.052.46.156.639.105.174.276.34.516.496.239.156.669.363 1.291.619.7.292 1.213.564 1.539.816.327.252.566.537.718.854.152.318.228.692.228 1.122Zm4.371 1.481a3.74 3.74 0 0 0 1.122-.176v1.154c-.17.074-.39.135-.659.183a4.302 4.302 0 0 1-.829.078c-1.452 0-2.178-.765-2.178-2.296v-3.888h-.985v-.678l1.056-.56.522-1.527h.946v1.604h2.055v1.162h-2.055v3.861c0 .37.091.644.274.822.187.174.431.261.731.261Zm7.084 1.109-.307-1.005h-.052c-.348.439-.698.74-1.05.9-.353.157-.805.235-1.357.235-.709 0-1.263-.191-1.664-.574-.395-.382-.593-.924-.593-1.624 0-.744.276-1.305.828-1.683.553-.378 1.394-.585 2.525-.62l1.246-.039v-.385c0-.461-.109-.804-.327-1.03-.213-.23-.545-.346-.998-.346a3.46 3.46 0 0 0-1.063.163 8.029 8.029 0 0 0-.978.385l-.496-1.096a5.24 5.24 0 0 1 1.285-.463 5.804 5.804 0 0 1 1.318-.163c.917 0 1.609.2 2.074.6.47.4.704 1.029.704 1.885v4.86h-1.095Zm-2.283-1.044c.556 0 1.002-.154 1.337-.463.339-.313.509-.75.509-1.311v-.626l-.927.039c-.722.026-1.248.148-1.578.365-.326.213-.489.541-.489.985 0 .322.095.572.287.75.191.174.478.261.861.261Zm6.999-2.766.867-1.082 2.179-2.323h1.768l-2.903 3.099 3.085 4.116h-1.8l-2.316-3.164-.841.692v2.472h-1.52v-10.15h1.52v4.951l-.078 1.389h.039Zm9.314 3.94c-1.122 0-2-.326-2.635-.978-.63-.657-.946-1.559-.946-2.707 0-1.179.294-2.105.881-2.779.587-.674 1.394-1.011 2.42-1.011.952 0 1.705.29 2.257.867.552.579.828 1.375.828 2.388v.828h-4.807c.022.7.211 1.24.567 1.618.357.374.859.561 1.507.561.426 0 .822-.039 1.187-.117.37-.083.766-.218 1.187-.405v1.246a4.703 4.703 0 0 1-1.135.378 6.942 6.942 0 0 1-1.311.111Zm-.28-6.314c-.487 0-.879.154-1.174.463-.292.309-.466.759-.522 1.35h3.274c-.008-.595-.152-1.045-.43-1.35-.278-.309-.661-.463-1.148-.463Z",
                className: "staking-section_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M36.475 48.395c0 .848-.306 1.513-.92 1.996-.612.483-1.458.724-2.537.724-1.078 0-1.96-.168-2.648-.502v-1.475c.435.205.896.366 1.383.483.491.117.948.176 1.37.176.617 0 1.072-.117 1.363-.352.296-.235.444-.55.444-.946 0-.356-.135-.659-.405-.907-.27-.247-.826-.541-1.67-.88-.87-.352-1.483-.755-1.84-1.207-.356-.452-.534-.996-.534-1.63 0-.796.283-1.423.848-1.88.565-.456 1.324-.684 2.276-.684.914 0 1.823.2 2.727.6l-.496 1.272c-.848-.357-1.604-.535-2.27-.535-.504 0-.887.111-1.148.333-.26.217-.391.506-.391.867 0 .248.052.461.156.64.105.173.277.339.516.495.239.157.67.363 1.291.62.7.291 1.214.563 1.54.815.326.252.565.537.717.855.152.317.228.691.228 1.122Zm4.37 1.48c.375 0 .749-.058 1.123-.176v1.155a2.99 2.99 0 0 1-.659.183 4.29 4.29 0 0 1-.828.078c-1.453 0-2.18-.766-2.18-2.296V44.93h-.984v-.678l1.057-.561.521-1.527h.946v1.605h2.055v1.161h-2.055v3.862c0 .37.092.643.274.822.187.173.43.26.73.26Zm7.085 1.11-.307-1.005h-.052c-.348.44-.698.74-1.05.9-.352.157-.805.235-1.357.235-.709 0-1.263-.192-1.663-.574-.396-.383-.594-.924-.594-1.624 0-.744.276-1.305.829-1.683.552-.379 1.393-.585 2.524-.62l1.246-.04v-.384c0-.46-.109-.804-.326-1.03-.213-.231-.546-.346-.998-.346-.37 0-.724.054-1.064.163-.339.109-.665.237-.978.385l-.496-1.096a5.24 5.24 0 0 1 1.285-.463 5.802 5.802 0 0 1 1.318-.163c.917 0 1.609.2 2.074.6.47.4.705 1.028.705 1.885v4.86H47.93Zm-2.283-1.044c.556 0 1.002-.155 1.337-.463.34-.314.509-.75.509-1.312v-.626l-.927.04c-.721.026-1.248.147-1.578.365-.326.213-.49.541-.49.985 0 .322.096.572.288.75.191.174.478.26.86.26Zm6.999-2.766.867-1.083 2.18-2.322h1.767l-2.903 3.098 3.085 4.116h-1.8l-2.316-3.163-.841.691v2.472h-1.52v-10.15h1.52v4.952l-.078 1.389h.039Zm9.315 3.94c-1.122 0-2-.326-2.636-.979-.63-.656-.946-1.559-.946-2.707 0-1.178.294-2.104.881-2.778.587-.674 1.394-1.011 2.42-1.011.953 0 1.705.289 2.257.867.552.579.829 1.374.829 2.388v.828h-4.808c.022.7.211 1.24.568 1.618.356.374.858.56 1.506.56.427 0 .822-.039 1.188-.117a6.4 6.4 0 0 0 1.187-.404v1.246a4.705 4.705 0 0 1-1.135.378c-.383.074-.82.11-1.311.11Zm-.28-6.314c-.488 0-.88.154-1.175.463-.291.308-.465.759-.522 1.35h3.275c-.009-.596-.153-1.046-.43-1.35-.28-.309-.662-.463-1.149-.463Zm14.774-.47c0 .996-.327 1.759-.979 2.29-.652.53-1.58.795-2.785.795h-.992v3.568H70.14v-9.536h2.746c1.192 0 2.084.243 2.675.73.596.488.894 1.205.894 2.153Zm-4.756 1.774h.829c.8 0 1.387-.139 1.76-.417.375-.279.562-.713.562-1.305 0-.548-.167-.957-.502-1.226-.335-.27-.857-.405-1.566-.405H71.7v3.353Zm14.605 4.88h-1.911l-4.69-7.6h-.052l.032.424c.061.809.092 1.548.092 2.218v4.957h-1.416v-9.536h1.892l4.677 7.56h.039c-.009-.1-.026-.463-.052-1.09-.026-.63-.04-1.121-.04-1.474v-4.996h1.43v9.536Zm9.798 0h-1.807L91.3 46.665l-.92.75v3.568h-1.559v-9.536h1.559V46c.426-.522.85-1.024 1.272-1.507l2.576-3.046h1.775a609.058 609.058 0 0 1-3.581 4.181l3.679 5.355Z",
                className: "staking-section_svg__path-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M103.309 50.221c.192 0 .377-.013.555-.039.178-.03.32-.06.424-.091v.828a1.92 1.92 0 0 1-.522.137c-.226.04-.43.059-.613.059-1.383 0-2.074-.729-2.074-2.185v-4.253h-1.024v-.522l1.024-.45.456-1.527h.626v1.657h2.075v.842h-2.075v4.207c0 .43.103.761.307.992.204.23.485.345.841.345Zm8.585-2.818c0 1.166-.294 2.077-.881 2.733-.587.653-1.398.979-2.433.979-.639 0-1.207-.15-1.703-.45-.495-.3-.878-.73-1.148-1.292-.269-.56-.404-1.217-.404-1.97 0-1.165.291-2.072.874-2.72.583-.652 1.392-.978 2.427-.978 1 0 1.793.333 2.381.998.591.665.887 1.565.887 2.7Zm-5.447 0c0 .913.183 1.61.548 2.088.365.478.902.717 1.611.717s1.246-.237 1.611-.71c.37-.48.555-1.177.555-2.095 0-.909-.185-1.598-.555-2.067-.365-.474-.906-.712-1.624-.712-.709 0-1.244.233-1.605.698-.361.466-.541 1.16-.541 2.081Zm9.954 6.79c-.413 0-.748-.054-1.005-.162v-.881c.3.087.596.13.888.13.339 0 .587-.093.743-.28.161-.183.242-.463.242-.842v-8.323h1.082v8.245c0 1.41-.65 2.114-1.95 2.114Zm.776-12.295c0-.248.061-.428.183-.542a.632.632 0 0 1 .456-.176c.174 0 .324.06.451.176.126.118.189.298.189.542 0 .243-.063.426-.189.548a.642.642 0 0 1-.451.176.632.632 0 0 1-.456-.176c-.122-.122-.183-.304-.183-.548Zm9.641 5.505c0 1.166-.293 2.077-.881 2.733-.587.653-1.398.979-2.433.979-.639 0-1.206-.15-1.702-.45-.496-.3-.878-.73-1.148-1.292-.27-.56-.405-1.217-.405-1.97 0-1.165.292-2.072.875-2.72.582-.652 1.391-.978 2.426-.978 1 0 1.794.333 2.381.998.591.665.887 1.565.887 2.7Zm-5.447 0c0 .913.183 1.61.548 2.088.366.478.903.717 1.612.717.708 0 1.245-.237 1.611-.71.369-.48.554-1.177.554-2.095 0-.909-.185-1.598-.554-2.067-.366-.474-.907-.712-1.625-.712-.708 0-1.243.233-1.604.698-.361.466-.542 1.16-.542 2.081Zm8.435 3.581h-1.083v-7.149h1.083v7.15Zm-1.175-9.086c0-.248.061-.428.183-.542a.632.632 0 0 1 .457-.176c.174 0 .324.06.45.176.126.118.189.298.189.542 0 .243-.063.426-.189.548a.638.638 0 0 1-.45.176.632.632 0 0 1-.457-.176c-.122-.122-.183-.304-.183-.548Zm8.363 9.086V46.36c0-.583-.133-1.018-.398-1.305-.265-.287-.681-.43-1.246-.43-.748 0-1.296.202-1.644.606-.348.405-.522 1.072-.522 2.003v3.75h-1.082v-7.149h.88l.176.979h.053c.221-.353.532-.624.932-.816.4-.195.846-.293 1.338-.293.861 0 1.509.209 1.943.626.435.413.653 1.076.653 1.99v4.663h-1.083Zm9.093-.763c.191 0 .376-.013.554-.039.179-.03.32-.06.424-.091v.828a1.91 1.91 0 0 1-.522.137c-.226.04-.43.059-.613.059-1.383 0-2.074-.729-2.074-2.185v-4.253h-1.024v-.522l1.024-.45.457-1.527h.626v1.657h2.074v.842h-2.074v4.207c0 .43.102.761.306.992.205.23.485.345.842.345Zm7.305.763V46.36c0-.583-.132-1.018-.397-1.305-.266-.287-.681-.43-1.246-.43-.753 0-1.303.204-1.651.613-.343.408-.515 1.078-.515 2.009v3.737H148.5v-10.15h1.083v3.073c0 .37-.017.676-.052.92h.065c.213-.344.515-.613.907-.81.396-.2.846-.3 1.35-.3.874 0 1.529.21 1.963.627.44.413.659 1.072.659 1.977v4.663h-1.083Zm6.334.13c-1.056 0-1.891-.321-2.505-.965-.608-.643-.913-1.537-.913-2.68 0-1.153.283-2.068.848-2.747.57-.678 1.333-1.017 2.29-1.017.896 0 1.604.296 2.126.887.522.587.783 1.363.783 2.329v.684h-4.925c.022.84.233 1.477.633 1.912.404.435.972.652 1.702.652.77 0 1.531-.16 2.283-.483v.966a5.5 5.5 0 0 1-1.089.352c-.339.074-.75.11-1.233.11Zm-.293-6.502c-.574 0-1.033.186-1.377.56-.339.374-.539.892-.6 1.553h3.738c0-.683-.152-1.205-.457-1.566-.304-.365-.739-.547-1.304-.547Zm11.343 6.372h-1.109v-8.551h-3.02v-.985h7.149v.985h-3.02v8.551Zm10.469-3.58c0 1.165-.293 2.076-.88 2.732-.587.653-1.398.979-2.433.979-.639 0-1.207-.15-1.703-.45-.495-.3-.878-.73-1.148-1.292-.269-.56-.404-1.217-.404-1.97 0-1.165.291-2.072.874-2.72.583-.652 1.391-.978 2.426-.978 1.001 0 1.794.333 2.381.998.592.665.887 1.565.887 2.7Zm-5.446 0c0 .912.182 1.608.548 2.087.365.478.902.717 1.611.717s1.246-.237 1.611-.71c.37-.48.554-1.177.554-2.095 0-.909-.184-1.598-.554-2.067-.365-.474-.907-.712-1.624-.712-.709 0-1.244.233-1.605.698-.361.466-.541 1.16-.541 2.081Zm8.421-.079c.187-.265.472-.613.854-1.044l2.309-2.446h1.285l-2.896 3.047 3.099 4.102h-1.311l-2.525-3.379-.815.705v2.674h-1.07v-10.15h1.07v5.382c0 .24-.018.609-.052 1.109h.052Zm8.969 3.79c-1.057 0-1.892-.322-2.505-.966-.609-.643-.913-1.537-.913-2.68 0-1.153.283-2.068.848-2.747.57-.678 1.333-1.017 2.289-1.017.896 0 1.605.296 2.127.887.522.587.783 1.363.783 2.329v.684h-4.925c.022.84.232 1.477.633 1.912.404.435.971.652 1.702.652.77 0 1.531-.16 2.283-.483v.966a5.542 5.542 0 0 1-1.089.352c-.339.074-.75.11-1.233.11Zm-.294-6.504c-.574 0-1.032.188-1.376.561-.339.374-.539.892-.6 1.553h3.738c0-.683-.153-1.205-.457-1.566-.304-.365-.739-.547-1.305-.547Zm9.667 6.373V46.36c0-.583-.132-1.018-.398-1.305-.265-.287-.68-.43-1.245-.43-.748 0-1.296.202-1.644.606-.348.405-.522 1.072-.522 2.003v3.75h-1.083v-7.149h.881l.176.979h.052c.222-.353.533-.624.933-.816.4-.195.846-.293 1.337-.293.861 0 1.509.209 1.944.626.435.413.652 1.076.652 1.99v4.663h-1.083Zm6.947 0v-9.536h1.109v8.532h4.207v1.004h-5.316Zm7.86 0h-1.082v-7.149h1.082v7.15Zm-1.174-9.086c0-.248.061-.428.183-.542a.632.632 0 0 1 .457-.176c.173 0 .323.06.45.176.126.118.189.298.189.542 0 .243-.063.426-.189.548a.641.641 0 0 1-.45.176.632.632 0 0 1-.457-.176c-.122-.122-.183-.304-.183-.548Zm8.082 7.136c0 .665-.248 1.178-.743 1.54-.496.36-1.192.54-2.088.54-.948 0-1.687-.15-2.218-.45V49.66c.344.174.711.311 1.103.411.396.1.776.15 1.141.15.566 0 1-.089 1.305-.267.304-.183.456-.459.456-.829 0-.278-.121-.515-.365-.71-.239-.2-.709-.435-1.409-.705-.665-.248-1.139-.463-1.422-.646a2.013 2.013 0 0 1-.626-.633 1.66 1.66 0 0 1-.202-.841c0-.583.237-1.042.711-1.376.474-.34 1.124-.51 1.95-.51.77 0 1.522.157 2.257.47l-.385.881c-.717-.296-1.367-.444-1.95-.444-.513 0-.9.08-1.161.242-.261.16-.392.383-.392.665 0 .191.048.355.144.49.1.134.259.262.476.384.218.122.635.298 1.253.529.848.308 1.419.62 1.715.932.3.313.45.707.45 1.181Zm4.077 1.187c.191 0 .376-.013.554-.039.179-.03.32-.06.424-.091v.828a1.91 1.91 0 0 1-.521.137c-.227.04-.431.059-.614.059-1.382 0-2.074-.729-2.074-2.185v-4.253h-1.024v-.522l1.024-.45.457-1.527h.626v1.657h2.074v.842h-2.074v4.207c0 .43.102.761.307.992.204.23.484.345.841.345Zm3.496.763h-1.083v-7.149h1.083v7.15Zm-1.174-9.086c0-.248.061-.428.183-.542a.632.632 0 0 1 .456-.176c.174 0 .324.06.45.176.127.118.19.298.19.542 0 .243-.063.426-.19.548a.638.638 0 0 1-.45.176.632.632 0 0 1-.456-.176c-.122-.122-.183-.304-.183-.548Zm8.363 9.086V46.36c0-.583-.133-1.018-.398-1.305-.266-.287-.681-.43-1.246-.43-.748 0-1.296.202-1.644.606-.348.405-.522 1.072-.522 2.003v3.75h-1.083v-7.149h.881l.176.979h.052c.222-.353.533-.624.933-.816.4-.195.846-.293 1.337-.293.861 0 1.509.209 1.944.626.435.413.652 1.076.652 1.99v4.663h-1.082Zm9.164-7.149v.685l-1.324.157c.122.152.231.352.326.6.096.243.144.52.144.828 0 .7-.239 1.26-.718 1.677-.478.417-1.135.626-1.97.626-.213 0-.413-.018-.6-.052-.461.243-.691.55-.691.92 0 .195.08.34.241.436.161.092.437.137.829.137h1.265c.774 0 1.368.164 1.781.49.417.326.626.8.626 1.422 0 .791-.318 1.393-.952 1.806-.635.418-1.562.627-2.779.627-.935 0-1.657-.174-2.166-.522-.504-.348-.756-.84-.756-1.474 0-.435.139-.811.417-1.129.278-.317.67-.533 1.174-.646a1.16 1.16 0 0 1-.463-.384 1.03 1.03 0 0 1-.183-.607c0-.261.07-.49.209-.685.139-.196.359-.385.659-.568a1.948 1.948 0 0 1-.907-.776 2.3 2.3 0 0 1-.345-1.252c0-.783.234-1.385.704-1.807.47-.426 1.135-.64 1.996-.64.374 0 .711.044 1.011.131h2.472Zm-5.701 8.35c0 .387.163.68.489.88.327.2.794.3 1.403.3.909 0 1.581-.137 2.015-.41.44-.27.659-.638.659-1.103 0-.387-.119-.657-.358-.809-.24-.148-.69-.222-1.351-.222h-1.298c-.491 0-.874.118-1.148.352-.274.235-.411.572-.411 1.012Zm.587-6.06c0 .5.142.878.424 1.135.283.256.676.385 1.181.385 1.057 0 1.585-.514 1.585-1.54 0-1.074-.535-1.61-1.605-1.61-.508 0-.9.136-1.174.41-.274.274-.411.68-.411 1.22Zm12.909 4.99c-1.035 0-1.837-.318-2.407-.953-.565-.639-.848-1.541-.848-2.706 0-1.196.287-2.12.861-2.773.579-.652 1.401-.978 2.466-.978.343 0 .687.037 1.031.11.343.075.613.162.808.262l-.332.92a4.86 4.86 0 0 0-.783-.236 3.39 3.39 0 0 0-.75-.097c-1.453 0-2.179.926-2.179 2.778 0 .879.176 1.553.529 2.023.356.47.882.704 1.578.704.596 0 1.207-.128 1.833-.385v.959c-.478.248-1.081.372-1.807.372Zm9.68-3.712c0 1.166-.293 2.077-.88 2.733-.587.653-1.398.979-2.433.979-.64 0-1.207-.15-1.703-.45-.496-.3-.878-.73-1.148-1.292-.27-.56-.404-1.217-.404-1.97 0-1.165.291-2.072.874-2.72.582-.652 1.391-.978 2.426-.978 1 0 1.794.333 2.381.998.591.665.887 1.565.887 2.7Zm-5.446 0c0 .913.182 1.61.547 2.088.366.478.903.717 1.612.717.708 0 1.246-.237 1.611-.71.369-.48.554-1.177.554-2.095 0-.909-.185-1.598-.554-2.067-.365-.474-.907-.712-1.624-.712-.709 0-1.244.233-1.605.698-.361.466-.541 1.16-.541 2.081Zm8.368-3.568v4.638c0 .583.133 1.018.398 1.305.266.287.681.43 1.246.43.748 0 1.294-.204 1.638-.613.347-.409.521-1.076.521-2.002v-3.758h1.083v7.15h-.893l-.157-.96h-.059c-.222.353-.53.622-.926.81-.391.186-.839.28-1.344.28-.869 0-1.522-.207-1.957-.62-.43-.413-.645-1.074-.645-1.983v-4.677h1.095Zm10.45-.13c.318 0 .602.026.855.078l-.15 1.005a3.696 3.696 0 0 0-.783-.098c-.578 0-1.074.235-1.487.704-.409.47-.613 1.055-.613 1.755v3.835h-1.083v-7.149h.893l.124 1.324h.052c.266-.465.585-.824.959-1.076a2.159 2.159 0 0 1 1.233-.378Zm4.501 6.516c.191 0 .376-.013.554-.039.179-.03.32-.06.424-.091v.828a1.91 1.91 0 0 1-.521.137c-.226.04-.431.059-.614.059-1.382 0-2.074-.729-2.074-2.185v-4.253h-1.024v-.522l1.024-.45.457-1.527h.626v1.657h2.074v.842h-2.074v4.207c0 .43.102.761.307.992.204.23.484.345.841.345Z",
                className: "staking-section_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#staking-section_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m33.15 149.949 5.878.263 2.38 5.288-3.358 4.833-5.91-.378-2.422-5.73 3.432-4.276Zm4.31 3.048-4.26 1.862 3.641 2.816.618-4.678Zm-.494-.932-3.404-1.466-.715 3.082 4.119-1.616Zm-.863 6.319-3.7-2.643.09 3.581 3.61-.938Zm4.713-2.896-2.52-2.558-.666 4.92 3.186-2.362Zm-3.846 3.471-3.12.816 3.67.235-.55-1.051Zm3.354-2.31-2.732 2.035.543 1.061 2.189-3.096Zm-1.292-5.698-.53 1.089 1.974 2.008-1.444-3.097Zm-.661-.521-3.468-.141 2.86 1.251.608-1.11Zm-5.727.503-2.429 3.068 1.624.344.805-3.412Zm-.903 4.013-1.632-.345 1.703 4.011-.071-3.666Z",
                    className: "staking-section_svg__path-5"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m52.927 160.062-2.831-7.397h-.046c.053.586.08 1.283.08 2.089v5.308h-.896v-8.344h1.461l2.643 6.883h.045l2.666-6.883h1.45v8.344h-.97v-5.376c0-.616.026-1.286.08-2.009h-.047l-2.853 7.385h-.782Zm5.73-6.255h1.016l1.37 3.567c.3.815.487 1.402.56 1.764h.045a16.8 16.8 0 0 1 .308-.993 367 367 0 0 1 1.552-4.338h1.017l-2.689 7.123c-.266.704-.578 1.202-.936 1.495-.354.297-.79.446-1.307.446-.29 0-.574-.033-.856-.097v-.76c.21.046.443.069.702.069.65 0 1.115-.365 1.393-1.096l.348-.89-2.523-6.29Zm14.771 4.035c0 .735-.266 1.307-.799 1.718-.532.411-1.255.617-2.169.617-.989 0-1.75-.128-2.283-.383v-.936a6 6 0 0 0 1.119.343c.403.083.803.125 1.199.125.646 0 1.133-.122 1.46-.365.328-.247.492-.59.492-1.027 0-.29-.06-.526-.177-.708-.114-.187-.309-.358-.583-.514-.27-.156-.683-.333-1.238-.531-.776-.277-1.332-.607-1.667-.987-.33-.381-.496-.877-.496-1.49 0-.643.241-1.155.725-1.535.483-.381 1.122-.571 1.917-.571.83 0 1.593.152 2.29.457l-.303.845c-.69-.29-1.359-.434-2.01-.434-.513 0-.915.11-1.204.331-.289.22-.434.527-.434.919 0 .289.054.527.16.713.107.183.286.352.537.508.255.152.643.322 1.164.508.875.312 1.477.647 1.804 1.005.33.357.496.822.496 1.392Zm3.585 1.553c.167 0 .329-.012.485-.035.156-.026.28-.053.37-.079v.724c-.102.05-.254.09-.456.12a3.103 3.103 0 0 1-.536.052c-1.21 0-1.815-.638-1.815-1.912v-3.722h-.897v-.456l.897-.394.4-1.336h.547v1.45h1.815v.736h-1.815v3.682c0 .376.09.666.268.867.18.202.425.303.737.303Zm5.958.667-.188-.89h-.046c-.312.392-.624.658-.936.799-.308.137-.694.206-1.158.206-.62 0-1.108-.16-1.462-.48-.35-.319-.525-.774-.525-1.364 0-1.263 1.01-1.925 3.031-1.986l1.062-.034v-.388c0-.491-.107-.853-.32-1.085-.21-.236-.546-.354-1.01-.354-.522 0-1.111.16-1.77.48l-.29-.725a4.432 4.432 0 0 1 1.01-.394c.369-.095.738-.143 1.107-.143.746 0 1.297.166 1.655.497.362.331.542.862.542 1.592v4.269h-.702Zm-2.14-.667c.59 0 1.052-.162 1.387-.485.338-.324.508-.777.508-1.359v-.565l-.948.04c-.753.027-1.297.145-1.632.354-.331.205-.496.527-.496.965 0 .342.102.603.308.781.209.179.5.269.873.269Zm5.736-2.534c.164-.233.413-.537.748-.914l2.02-2.14h1.125l-2.534 2.665 2.71 3.59H89.49l-2.209-2.956-.713.616v2.34h-.936v-8.88h.936v4.708c0 .21-.015.533-.046.971h.046Zm7.848 3.316c-.925 0-1.655-.282-2.192-.845-.532-.563-.799-1.345-.799-2.346 0-1.008.247-1.809.742-2.403.499-.593 1.166-.89 2.004-.89.783 0 1.404.259 1.86.776.457.514.685 1.193.685 2.038v.599h-4.31c.02.734.204 1.292.555 1.672.353.381.85.571 1.49.571.673 0 1.339-.141 1.997-.422v.844a4.831 4.831 0 0 1-.953.309 5.193 5.193 0 0 1-1.079.097Zm-.257-5.691c-.502 0-.904.164-1.204.491-.297.327-.472.78-.525 1.358h3.27c0-.597-.133-1.054-.4-1.369-.266-.32-.646-.48-1.14-.48Zm4.041 4.971c0-.254.057-.447.171-.576.118-.133.286-.2.503-.2.22 0 .391.067.513.2.126.129.189.322.189.576 0 .248-.063.438-.189.571-.125.133-.296.2-.513.2a.693.693 0 0 1-.486-.177c-.125-.122-.188-.32-.188-.594Zm0-5.039c0-.514.225-.771.674-.771.468 0 .702.257.702.771 0 .247-.063.437-.189.57-.125.134-.296.2-.513.2a.693.693 0 0 1-.486-.177c-.125-.121-.188-.319-.188-.593Z",
                className: "staking-section_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M112.841 160.062H111.5v-5.387c0-.643.015-1.153.046-1.53a4.486 4.486 0 0 1-.326.302c-.125.111-.551.461-1.278 1.051l-.674-.851 2.455-1.929h1.118v8.344Zm8.396-4.172c0 1.45-.234 2.527-.702 3.231-.464.704-1.176 1.056-2.135 1.056-.928 0-1.632-.364-2.111-1.09-.48-.727-.72-1.793-.72-3.197 0-1.472.233-2.557.697-3.253.468-.7 1.179-1.05 2.134-1.05.933 0 1.638.365 2.118 1.096.479.73.719 1.799.719 3.207Zm-4.309 0c0 1.138.116 1.95.348 2.437.236.487.611.731 1.124.731.514 0 .889-.247 1.125-.742.24-.495.359-1.303.359-2.426 0-1.118-.119-1.927-.359-2.425-.236-.503-.611-.754-1.125-.754-.513 0-.888.246-1.124.736-.232.491-.348 1.306-.348 2.443Zm7.169 2.945c-.183.708-.518 1.619-1.005 2.734h-.987c.262-1.027.458-1.982.587-2.865h1.319l.086.131Zm6.946-2.945c0 1.45-.234 2.527-.702 3.231-.465.704-1.176 1.056-2.135 1.056-.928 0-1.632-.364-2.112-1.09-.479-.727-.719-1.793-.719-3.197 0-1.472.232-2.557.696-3.253.468-.7 1.18-1.05 2.135-1.05.932 0 1.638.365 2.118 1.096.479.73.719 1.799.719 3.207Zm-4.31 0c0 1.138.116 1.95.349 2.437.236.487.61.731 1.124.731.514 0 .888-.247 1.124-.742.24-.495.36-1.303.36-2.426 0-1.118-.12-1.927-.36-2.425-.236-.503-.61-.754-1.124-.754-.514 0-.888.246-1.124.736-.233.491-.349 1.306-.349 2.443Zm10.988 0c0 1.45-.235 2.527-.703 3.231-.464.704-1.175 1.056-2.134 1.056-.929 0-1.633-.364-2.112-1.09-.479-.727-.719-1.793-.719-3.197 0-1.472.232-2.557.696-3.253.468-.7 1.18-1.05 2.135-1.05.932 0 1.638.365 2.117 1.096.48.73.72 1.799.72 3.207Zm-4.31 0c0 1.138.116 1.95.348 2.437.236.487.611.731 1.125.731s.888-.247 1.124-.742c.24-.495.36-1.303.36-2.426 0-1.118-.12-1.927-.36-2.425-.236-.503-.61-.754-1.124-.754-.514 0-.889.246-1.125.736-.232.491-.348 1.306-.348 2.443Zm10.987 0c0 1.45-.234 2.527-.702 3.231-.464.704-1.175 1.056-2.134 1.056-.929 0-1.633-.364-2.112-1.09-.48-.727-.719-1.793-.719-3.197 0-1.472.232-2.557.696-3.253.468-.7 1.18-1.05 2.135-1.05.932 0 1.638.365 2.117 1.096.48.73.719 1.799.719 3.207Zm-4.309 0c0 1.138.116 1.95.348 2.437.236.487.611.731 1.125.731.513 0 .888-.247 1.124-.742.24-.495.36-1.303.36-2.426 0-1.118-.12-1.927-.36-2.425-.236-.503-.611-.754-1.124-.754-.514 0-.889.246-1.125.736-.232.491-.348 1.306-.348 2.443Zm14.48-1.649c0 .871-.285 1.539-.856 2.003-.571.464-1.383.696-2.437.696h-.868v3.122h-1.364v-8.344h2.403c1.043 0 1.823.213 2.34.639.522.426.782 1.054.782 1.884Zm-4.161 1.552h.725c.7 0 1.214-.122 1.541-.365.328-.244.491-.624.491-1.142 0-.479-.146-.837-.439-1.073-.293-.235-.75-.353-1.37-.353h-.948v2.933Zm12.78 4.269h-1.673l-4.103-6.649h-.046l.028.371c.054.708.08 1.355.08 1.941v4.337h-1.238v-8.344h1.655l4.092 6.615h.035a36.388 36.388 0 0 1-.046-.953 32.84 32.84 0 0 1-.034-1.29v-4.372h1.25v8.344Zm8.572 0h-1.581l-2.619-3.778-.805.656v3.122h-1.364v-8.344h1.364v3.984c.373-.457.744-.896 1.113-1.319l2.254-2.665h1.553a553.405 553.405 0 0 1-3.134 3.659l3.219 4.685Z",
                className: "staking-section_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#staking-section_svg__c)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M208.259 154.333h-.542v-1.644c0-1.913-1.542-3.47-3.437-3.47-1.895 0-3.438 1.557-3.438 3.47v1.644h-.542c-.599 0-1.086.491-1.086 1.096v4.383c0 .605.487 1.096 1.086 1.096h7.959c.6 0 1.086-.491 1.086-1.096v-4.383c0-.605-.486-1.096-1.086-1.096Zm-2.351 0h-3.256v-1.644c0-.906.73-1.644 1.628-1.644.897 0 1.628.738 1.628 1.644v1.644Z",
                    className: "staking-section_svg__path-8"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M218 160.062v-8.344h.97v7.466h3.681v.878H218Zm11.329-3.133c0 1.02-.257 1.817-.77 2.392-.514.57-1.224.856-2.129.856-.56 0-1.056-.132-1.49-.394a2.599 2.599 0 0 1-1.004-1.13c-.236-.491-.354-1.066-.354-1.724 0-1.02.255-1.813.765-2.38.509-.571 1.217-.856 2.123-.856.875 0 1.569.291 2.083.873.518.582.776 1.37.776 2.363Zm-4.766 0c0 .799.16 1.408.48 1.826.32.419.789.628 1.41.628.62 0 1.09-.207 1.409-.622.324-.418.486-1.029.486-1.832 0-.795-.162-1.398-.486-1.809-.319-.415-.793-.622-1.421-.622-.62 0-1.088.203-1.404.61-.316.407-.474 1.014-.474 1.821Zm8.933 3.248c-.906 0-1.608-.278-2.106-.834-.495-.559-.742-1.349-.742-2.368 0-1.047.251-1.855.753-2.426.506-.571 1.225-.856 2.158-.856.3 0 .601.032.901.097.301.065.537.141.708.228l-.291.805a4.303 4.303 0 0 0-.685-.206 2.958 2.958 0 0 0-.656-.085c-1.271 0-1.907.81-1.907 2.431 0 .769.155 1.359.463 1.77.312.411.772.616 1.381.616.521 0 1.056-.112 1.604-.337v.839c-.419.217-.946.326-1.581.326Zm4.007-3.316c.163-.233.412-.537.747-.914l2.021-2.14h1.124l-2.534 2.665 2.711 3.59h-1.147l-2.209-2.956-.713.616v2.34h-.937v-8.88h.937v4.708c0 .21-.016.533-.046.971h.046Zm7.847 3.316c-.924 0-1.655-.282-2.191-.845-.533-.563-.799-1.345-.799-2.346 0-1.008.247-1.809.742-2.403.498-.593 1.166-.89 2.003-.89.784 0 1.404.259 1.861.776.456.514.685 1.193.685 2.038v.599h-4.31c.019.734.204 1.292.554 1.672.354.381.85.571 1.49.571.673 0 1.339-.141 1.997-.422v.844a4.823 4.823 0 0 1-.953.309 5.193 5.193 0 0 1-1.079.097Zm-.256-5.691c-.503 0-.904.164-1.205.491-.297.327-.472.78-.525 1.358h3.271c0-.597-.134-1.054-.4-1.369-.266-.32-.647-.48-1.141-.48Zm8.435 4.737h-.051c-.438.636-1.092.954-1.963.954-.819 0-1.456-.28-1.912-.839-.453-.56-.68-1.355-.68-2.386 0-1.031.229-1.832.685-2.403.457-.571 1.092-.856 1.907-.856.848 0 1.499.308 1.952.924h.074l-.04-.45-.023-.44v-2.545h.947v8.88h-.77l-.126-.839Zm-1.895.16c.647 0 1.115-.175 1.404-.525.293-.354.44-.923.44-1.706v-.2c0-.887-.148-1.518-.445-1.895-.293-.381-.763-.571-1.41-.571-.556 0-.982.217-1.278.651-.293.43-.44 1.039-.44 1.826 0 .799.147 1.402.44 1.81.293.407.722.61 1.289.61Zm12.694-1.541c0 .735-.266 1.307-.799 1.718-.533.411-1.256.617-2.169.617-.989 0-1.75-.128-2.283-.383v-.936c.343.145.715.259 1.119.343.403.083.803.125 1.198.125.647 0 1.134-.122 1.461-.365.328-.247.491-.59.491-1.027 0-.29-.059-.526-.177-.708-.114-.187-.308-.358-.582-.514-.27-.156-.683-.333-1.238-.531-.777-.277-1.332-.607-1.667-.987-.331-.381-.496-.877-.496-1.49 0-.643.241-1.155.724-1.535.484-.381 1.123-.571 1.918-.571.83 0 1.593.152 2.289.457l-.303.845c-.688-.29-1.358-.434-2.009-.434-.513 0-.915.11-1.204.331-.289.22-.434.527-.434.919 0 .289.054.527.16.713.107.183.285.352.537.508.254.152.643.322 1.164.508.875.312 1.476.647 1.803 1.005.332.357.497.822.497 1.392Zm3.584 1.553c.168 0 .33-.012.486-.035.156-.026.279-.053.371-.079v.724c-.103.05-.255.09-.457.12a3.108 3.108 0 0 1-.537.052c-1.21 0-1.815-.638-1.815-1.912v-3.722h-.896v-.456l.896-.394.4-1.336h.548v1.45h1.815v.736h-1.815v3.682c0 .376.089.666.268.867.179.202.424.303.736.303Zm5.959.667-.188-.89h-.046c-.312.392-.624.658-.936.799-.308.137-.694.206-1.159.206-.62 0-1.107-.16-1.461-.48-.35-.319-.525-.774-.525-1.364 0-1.263 1.01-1.925 3.031-1.986l1.061-.034v-.388c0-.491-.106-.853-.319-1.085-.209-.236-.546-.354-1.01-.354-.522 0-1.111.16-1.77.48l-.291-.725a4.43 4.43 0 0 1 1.01-.394c.37-.095.739-.143 1.108-.143.745 0 1.297.166 1.655.497.361.331.542.862.542 1.592v4.269h-.702Zm-2.14-.667c.59 0 1.052-.162 1.387-.485.338-.324.508-.777.508-1.359v-.565l-.948.04c-.753.027-1.297.145-1.632.354-.331.205-.497.527-.497.965 0 .342.103.603.309.781.209.179.5.269.873.269Zm5.736-2.534c.163-.233.413-.537.748-.914l2.02-2.14h1.124l-2.534 2.665 2.711 3.59h-1.147l-2.209-2.956-.713.616v2.34h-.936v-8.88h.936v4.708c0 .21-.015.533-.046.971h.046Zm7.848 3.316c-.925 0-1.655-.282-2.192-.845-.533-.563-.799-1.345-.799-2.346 0-1.008.247-1.809.742-2.403.498-.593 1.166-.89 2.003-.89.784 0 1.404.259 1.861.776.457.514.685 1.193.685 2.038v.599h-4.309c.019.734.203 1.292.553 1.672.354.381.851.571 1.49.571.673 0 1.339-.141 1.998-.422v.844a4.831 4.831 0 0 1-.954.309 5.183 5.183 0 0 1-1.078.097Zm-.257-5.691c-.502 0-.904.164-1.204.491-.297.327-.472.78-.525 1.358h3.27c0-.597-.133-1.054-.4-1.369-.266-.32-.646-.48-1.141-.48Zm4.041 4.971c0-.254.057-.447.171-.576.118-.133.285-.2.502-.2.221 0 .392.067.514.2.126.129.188.322.188.576 0 .248-.062.438-.188.571-.126.133-.297.2-.514.2a.694.694 0 0 1-.485-.177c-.125-.122-.188-.32-.188-.594Zm0-5.039c0-.514.224-.771.673-.771.468 0 .702.257.702.771 0 .247-.062.437-.188.57-.126.134-.297.2-.514.2a.694.694 0 0 1-.485-.177c-.125-.121-.188-.319-.188-.593Z",
                className: "staking-section_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M304.495 153.636c0 .529-.154.97-.463 1.324-.308.35-.742.586-1.301.708v.045c.67.084 1.172.293 1.507.628.335.331.502.773.502 1.324 0 .803-.283 1.423-.85 1.861-.567.434-1.374.651-2.42.651-.925 0-1.705-.151-2.341-.451v-1.193a5.341 5.341 0 0 0 2.266.548c.647 0 1.13-.12 1.45-.36.32-.239.48-.61.48-1.113 0-.445-.177-.772-.531-.981-.354-.21-.91-.314-1.667-.314h-.725v-1.091h.737c1.331 0 1.997-.46 1.997-1.381 0-.357-.116-.633-.348-.827-.232-.194-.575-.291-1.027-.291-.316 0-.621.045-.914.137-.293.087-.639.26-1.038.519l-.657-.936c.765-.563 1.654-.845 2.666-.845.841 0 1.497.181 1.969.542.472.362.708.86.708 1.496Zm6.991 2.254c0 1.45-.234 2.527-.702 3.231-.464.704-1.175 1.056-2.134 1.056-.929 0-1.633-.364-2.112-1.09-.48-.727-.719-1.793-.719-3.197 0-1.472.232-2.557.696-3.253.468-.7 1.18-1.05 2.135-1.05.932 0 1.638.365 2.117 1.096.48.73.719 1.799.719 3.207Zm-4.309 0c0 1.138.116 1.95.348 2.437.236.487.611.731 1.125.731.513 0 .888-.247 1.124-.742.24-.495.36-1.303.36-2.426 0-1.118-.12-1.927-.36-2.425-.236-.503-.611-.754-1.124-.754-.514 0-.889.246-1.125.736-.232.491-.348 1.306-.348 2.443Zm10.987 0c0 1.45-.234 2.527-.702 3.231-.464.704-1.176 1.056-2.134 1.056-.929 0-1.633-.364-2.112-1.09-.48-.727-.719-1.793-.719-3.197 0-1.472.232-2.557.696-3.253.468-.7 1.179-1.05 2.135-1.05.932 0 1.638.365 2.117 1.096.48.73.719 1.799.719 3.207Zm-4.309 0c0 1.138.116 1.95.348 2.437.236.487.611.731 1.125.731.513 0 .888-.247 1.124-.742.24-.495.36-1.303.36-2.426 0-1.118-.12-1.927-.36-2.425-.236-.503-.611-.754-1.124-.754-.514 0-.889.246-1.125.736-.232.491-.348 1.306-.348 2.443Zm14.48-1.649c0 .871-.285 1.539-.856 2.003-.571.464-1.383.696-2.437.696h-.868v3.122h-1.364v-8.344h2.403c1.043 0 1.823.213 2.34.639.521.426.782 1.054.782 1.884Zm-4.161 1.552h.725c.7 0 1.214-.122 1.541-.365.327-.244.491-.624.491-1.142 0-.479-.146-.837-.439-1.073-.293-.235-.75-.353-1.37-.353h-.948v2.933Zm12.78 4.269h-1.673l-4.104-6.649h-.045l.028.371c.054.708.08 1.355.08 1.941v4.337h-1.238v-8.344h1.655l4.092 6.615h.034a45.738 45.738 0 0 1-.045-.953 32.84 32.84 0 0 1-.034-1.29v-4.372h1.25v8.344Zm8.572 0h-1.581l-2.619-3.778-.805.656v3.122h-1.364v-8.344h1.364v3.984c.373-.457.744-.896 1.113-1.319l2.254-2.665h1.553a553.405 553.405 0 0 1-3.134 3.659l3.219 4.685Z",
                className: "staking-section_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "staking-section_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(29.718 149.219)",
                            className: "staking-section_svg__rect-5",
                            d: "M0 0h11.689v11.689H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "staking-section_svg__c",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(198.484 149.219)",
                            className: "staking-section_svg__rect-6",
                            d: "M0 0h11.689v11.689H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "staking-section_svg__a",
                        x: 0.495,
                        y: 0.165,
                        width: 390.01,
                        height: 193.791,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.67
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.252
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210903"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210903",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $a8b1e0ff638e08ba$export$2e2bcd8739ae039 = $a8b1e0ff638e08ba$var$SvgStakingSection;



const $4e4b4ea6267126cf$var$StyledStakingSectionSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $a8b1e0ff638e08ba$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="path-2"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"],
  [class$="rect-3"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-3"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-4"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="rect-5"],
  [class$="rect-6"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="path-1"],
  [class$="path-6"],
  [class$="path-9"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-3"],
  [class$="path-4"],
  [class$="path-7"],
  [class$="path-10"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-5"],
  [class$="path-8"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $4e4b4ea6267126cf$var$StakingSection = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $4e4b4ea6267126cf$var$StyledStakingSectionSvg
    });
var $4e4b4ea6267126cf$export$2e2bcd8739ae039 = $4e4b4ea6267126cf$var$StakingSection;


const $ac6168883415b9aa$var$leftPageContents = [
    {
        title: "Joining a court",
        paragraphs: [
            "Candidates self-select to serve as jurors by staking PNK tokens. The probability of being drawn as a juror for a specific dispute is proportional to the amount of tokens a juror stakes. Check the \u2018Juror Odds\u2019 for an estimation of your chances to be drawn. Note that staking PNK in a court automatically stakes in its parent courts (Branch). You can stake in a maximum of 4 court branches."
        ]
    },
    {
        title: "Jury selection",
        paragraphs: [
            "The final selection of jurors is done randomly. When a juror is selected to arbitrate a case part of his stake (PNK) is locked until the case is resolved. Jurors whose vote is coherent with the final jury decision have their locked stake released. Jurors whose vote is not coherent with the final jury decision, lose their locked stake. The locked stake of incoherent jurors is redistributed as incentives for the coherent jurors."
        ]
    },
    {
        title: "Juror Rewards",
        paragraphs: [
            "Users have an economic interest in serving as jurors in Kleros: collecting the Juror Rewards in exchange for their work. Each juror who is coherent with the final ruling receive the Juror Rewards composed of arbitration fees (ETH) + PNK redistribution between jurors."
        ]
    },
    {
        title: "Subscribe to Notifications",
        paragraphs: [
            "After staking your PNK to join a court, we advise you to subscribe to receive email notifications. This guarantees you will be notified when drawn to arbitrate a case and won't miss the deadlines."
        ]
    }
];
const $ac6168883415b9aa$var$rightPageComponents = [
    (0, $a3ba75527637001d$export$2e2bcd8739ae039),
    (0, $4e4b4ea6267126cf$export$2e2bcd8739ae039),
    (0, $0df4c11bca39010b$export$2e2bcd8739ae039),
    (0, $fb7ce8d9571a15e1$export$2e2bcd8739ae039)
];
const $ac6168883415b9aa$var$Staking = ({ toggleMiniGuide: toggleMiniGuide })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$2e2bcd8739ae039), {
        toggleMiniGuide: toggleMiniGuide,
        leftPageContents: $ac6168883415b9aa$var$leftPageContents,
        rightPageComponents: $ac6168883415b9aa$var$rightPageComponents,
        isOnboarding: false,
        canClose: true,
        isVisible: true
    });
};
var $ac6168883415b9aa$export$2e2bcd8739ae039 = $ac6168883415b9aa$var$Staking;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $4bab6a0a8f5b1205$var$SvgHowItWorks = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 385 297",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#how-it-works_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3,
                        y: 1,
                        width: 379,
                        height: 291,
                        rx: 3,
                        className: "how-it-works_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3.5,
                        y: 1.5,
                        width: 378,
                        height: 290,
                        rx: 2.5,
                        stroke: "#42498F",
                        className: "how-it-works_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#how-it-works_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M98.672 123.445c-3.605.207-10.77.961-15.194 3.703a1.028 1.028 0 0 0-.479.877v24.238c0 .77.831 1.256 1.532.899 4.551-2.32 11.133-2.952 14.388-3.126 1.111-.059 1.975-.961 1.975-2.042V125.49c.001-1.18-1.01-2.114-2.222-2.045Zm-18.256 3.703c-4.423-2.742-11.588-3.495-15.194-3.703-1.212-.069-2.222.865-2.222 2.045v22.505c0 1.082.864 1.984 1.975 2.042 3.256.173 9.841.807 14.393 3.128.698.356 1.527-.13 1.527-.897v-24.255c0-.352-.173-.675-.479-.865Z",
                    className: "how-it-works_svg__path-1"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M142.076 150.152h-2.752v-11.139h-12.467v11.139h-2.752v-23.67h2.752v10.07h12.467v-10.07h2.752v23.67Zm21.42-8.888c0 2.893-.729 5.154-2.186 6.784-1.457 1.619-3.47 2.428-6.039 2.428-1.586 0-2.995-.372-4.225-1.117-1.231-.745-2.181-1.813-2.85-3.206-.669-1.392-1.004-3.022-1.004-4.889 0-2.893.723-5.143 2.17-6.752 1.446-1.619 3.454-2.428 6.023-2.428 2.482 0 4.452.826 5.909 2.477 1.468 1.651 2.202 3.886 2.202 6.703Zm-13.519 0c0 2.266.453 3.993 1.36 5.181.907 1.187 2.24 1.781 3.999 1.781s3.092-.589 3.999-1.765c.918-1.187 1.376-2.92 1.376-5.197 0-2.256-.458-3.967-1.376-5.133-.907-1.176-2.25-1.764-4.031-1.764-1.76 0-3.087.577-3.983 1.732-.896 1.155-1.344 2.877-1.344 5.165Zm32.737 8.888-3.254-10.41c-.205-.637-.589-2.083-1.15-4.339h-.129c-.432 1.889-.81 3.346-1.134 4.371l-3.351 10.378h-3.109l-4.841-17.744h2.818c1.144 4.457 2.013 7.852 2.606 10.183.605 2.332.95 3.902 1.036 4.712h.13c.119-.615.308-1.409.567-2.38.269-.982.502-1.76.696-2.332l3.254-10.183h2.914l3.174 10.183c.604 1.857 1.014 3.417 1.23 4.679h.13c.043-.388.156-.987.34-1.797.194-.809 1.322-5.164 3.383-13.065h2.785l-4.906 17.744h-3.189Zm22.618 0h-2.688v-17.744h2.688v17.744Zm-2.914-22.553c0-.615.151-1.063.453-1.344.302-.291.68-.437 1.133-.437.432 0 .804.146 1.117.437.313.292.47.74.47 1.344 0 .605-.157 1.058-.47 1.36a1.58 1.58 0 0 1-1.117.437c-.453 0-.831-.145-1.133-.437-.302-.302-.453-.755-.453-1.36Zm14.344 20.659c.475 0 .934-.032 1.377-.097a9.854 9.854 0 0 0 1.052-.227v2.056c-.292.141-.723.254-1.295.34a8.929 8.929 0 0 1-1.522.146c-3.433 0-5.149-1.808-5.149-5.424v-10.556h-2.542v-1.295l2.542-1.117 1.134-3.789h1.554v4.113h5.148v2.088h-5.148v10.443c0 1.069.253 1.889.761 2.461.507.572 1.203.858 2.088.858Zm29.094 1.894-3.254-10.41c-.205-.637-.588-2.083-1.149-4.339h-.13c-.432 1.889-.809 3.346-1.133 4.371l-3.352 10.378h-3.108l-4.841-17.744h2.817c1.144 4.457 2.013 7.852 2.607 10.183.604 2.332.95 3.902 1.036 4.712h.129c.119-.615.308-1.409.567-2.38.27-.982.502-1.76.696-2.332l3.255-10.183h2.914l3.173 10.183c.605 1.857 1.015 3.417 1.231 4.679h.129c.043-.388.157-.987.34-1.797.194-.809 1.322-5.164 3.384-13.065h2.785l-4.906 17.744h-3.19Zm26.634-8.888c0 2.893-.729 5.154-2.186 6.784-1.457 1.619-3.47 2.428-6.039 2.428-1.587 0-2.995-.372-4.226-1.117-1.23-.745-2.18-1.813-2.849-3.206-.669-1.392-1.004-3.022-1.004-4.889 0-2.893.723-5.143 2.169-6.752 1.447-1.619 3.454-2.428 6.023-2.428 2.483 0 4.453.826 5.91 2.477 1.468 1.651 2.202 3.886 2.202 6.703Zm-13.519 0c0 2.266.453 3.993 1.36 5.181.906 1.187 2.239 1.781 3.999 1.781 1.759 0 3.092-.589 3.999-1.765.917-1.187 1.376-2.92 1.376-5.197 0-2.256-.459-3.967-1.376-5.133-.907-1.176-2.251-1.764-4.032-1.764-1.759 0-3.087.577-3.983 1.732-.895 1.155-1.343 2.877-1.343 5.165Zm26.341-9.18c.788 0 1.495.065 2.121.194l-.372 2.493c-.734-.161-1.382-.242-1.943-.242-1.435 0-2.666.582-3.691 1.748-1.015 1.166-1.522 2.618-1.522 4.355v9.52h-2.688v-17.744h2.218l.308 3.286h.129c.659-1.155 1.452-2.045 2.38-2.671a5.361 5.361 0 0 1 3.06-.939Zm8.096 8.986c.464-.659 1.171-1.522 2.121-2.591l5.731-6.071h3.189l-7.188 7.561 7.69 10.183h-3.254l-6.266-8.386-2.023 1.748v6.638h-2.656V124.96h2.656v13.357c0 .594-.044 1.511-.13 2.753h.13Zm26.212 4.241c0 1.652-.615 2.925-1.846 3.821-1.23.896-2.957 1.344-5.181 1.344-2.353 0-4.188-.372-5.505-1.117v-2.493c.853.431 1.765.771 2.737 1.02a11.56 11.56 0 0 0 2.833.372c1.403 0 2.482-.221 3.238-.664.756-.453 1.133-1.138 1.133-2.056 0-.691-.302-1.279-.906-1.765-.594-.496-1.76-1.079-3.497-1.748-1.652-.615-2.828-1.15-3.53-1.603-.691-.464-1.209-.988-1.554-1.571-.335-.582-.502-1.279-.502-2.088 0-1.446.588-2.585 1.765-3.416 1.176-.842 2.79-1.263 4.841-1.263 1.91 0 3.777.388 5.601 1.166l-.955 2.185c-1.781-.734-3.394-1.101-4.841-1.101-1.273 0-2.234.2-2.882.599-.647.4-.971.95-.971 1.652 0 .475.119.879.356 1.214.248.335.642.653 1.182.955.54.303 1.576.74 3.109 1.312 2.104.766 3.524 1.538 4.258 2.315.744.777 1.117 1.754 1.117 2.93Z",
                className: "how-it-works_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M176 196.24h32v-32h-32v32Z",
                fill: "url(#how-it-works_svg__c)"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "how-it-works_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(63 118.703)",
                            className: "how-it-works_svg__rect-3",
                            d: "M0 0h37.895v37.895H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("pattern", {
                        id: "how-it-works_svg__c",
                        patternContentUnits: "objectBoundingBox",
                        width: 1,
                        height: 1,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("use", {
                            xlinkHref: "#how-it-works_svg__d",
                            transform: "scale(.00625)"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "how-it-works_svg__a",
                        x: 0,
                        y: 0,
                        width: 385,
                        height: 297,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.5
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13917_210783"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13917_210783",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("image", {
                        id: "how-it-works_svg__d",
                        width: 160,
                        height: 160,
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
var $4bab6a0a8f5b1205$export$2e2bcd8739ae039 = $4bab6a0a8f5b1205$var$SvgHowItWorks;



const $1a59f7092a425f89$var$StyledHowItWorksSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $4bab6a0a8f5b1205$export$2e2bcd8739ae039))`
  [class$="rect-1"],
  [class$="rect-3"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="path-1"],
  [class$="path-2"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  [class$="rect-2"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }
`;
const $1a59f7092a425f89$var$HowItWorks = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $1a59f7092a425f89$var$StyledHowItWorksSvg
    });
var $1a59f7092a425f89$export$2e2bcd8739ae039 = $1a59f7092a425f89$var$HowItWorks;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $0c8f4a94f5a75464$var$SvgPnk = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 280 254",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m82.195 0 139.959 9.15L280 137.338 200.916 253.21l-143.113-6.105L0 106.814 82.195 0Zm3.558 7.27L63.92 113.968 192.185 53.78 85.753 7.27Zm109.974 51.422L65.562 119.77l110.778 83.29 19.387-144.37ZM172.12 207.33 62.793 125.131V240.21l109.327-32.88ZM56.854 229.206V121.593L8.292 111.344l48.562 117.862ZM8.64 105.333l48.873 10.314L78.092 15.08 8.641 105.333Zm68.91 136.655 116.934 4.988-17.416-34.918-99.518 29.93Zm104.838-32.576 17.406 34.897 64.648-94.721-82.054 59.824Zm84.011-87.766L220.049 18.93l-17.077 34.24 63.428 68.476Zm-68.401-71.82L100.348 7.152l115.179 7.53-17.528 35.142Zm3.5 10.503-19.021 141.656 89.674-65.38-70.653-76.276Z",
                fill: "url(#pnk_svg__a)"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                    id: "pnk_svg__a",
                    x1: 140,
                    y1: 0,
                    x2: 140,
                    y2: 253.21,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                            className: "pnk_svg__stop-1"
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                            offset: 1,
                            className: "pnk_svg__stop-2"
                        })
                    ]
                })
            })
        ]
    });
var $0c8f4a94f5a75464$export$2e2bcd8739ae039 = $0c8f4a94f5a75464$var$SvgPnk;



const $6dca6073254c48cd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  align-items: center;
`;
const $6dca6073254c48cd$var$StyledPnkIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $0c8f4a94f5a75464$export$2e2bcd8739ae039))`
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(220, 280)};
  height: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(220, 252)};
  [class$="stop-1"] {
    stop-color: ${({ theme: theme })=>theme.primaryBlue};
  }
  [class$="stop-2"] {
    stop-color: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $6dca6073254c48cd$var$StyledCourtLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 24px;
  background: linear-gradient(
    90deg,
    ${({ theme: theme })=>theme.secondaryPurple} 0%,
    ${({ theme: theme })=>theme.primaryBlue} 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const $6dca6073254c48cd$var$PnkLogoAndTitle = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($6dca6073254c48cd$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($6dca6073254c48cd$var$StyledPnkIcon, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($6dca6073254c48cd$var$StyledCourtLabel, {
                children: "Court v.2"
            })
        ]
    });
};
var $6dca6073254c48cd$export$2e2bcd8739ae039 = $6dca6073254c48cd$var$PnkLogoAndTitle;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $82b8a4b7f29e274a$var$SvgWhatDoINeed = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 299,
        height: 348,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                filter: "url(#what-do-i-need_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3,
                        y: 1,
                        width: 293.559,
                        height: 343,
                        rx: 2.318,
                        className: "what-do-i-need_svg__rect-1"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                        x: 3.386,
                        y: 1.386,
                        width: 292.786,
                        height: 342.227,
                        rx: 1.931,
                        className: "what-do-i-need_svg__rect-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M34.868 51.995c-.345 0-.633-.045-.866-.133v-1.061c.296.074.553.11.771.11.69 0 1.035-.436 1.035-1.309V42.12h1.268v7.441c0 .789-.189 1.39-.565 1.806-.373.419-.92.629-1.643.629Zm8.196-2.155-.174-.766h-.063a1.758 1.758 0 0 1-.74.64c-.317.154-.68.232-1.088.232-.707 0-1.235-.177-1.584-.529-.348-.352-.523-.885-.523-1.6V44h1.252v3.602c0 .447.092.783.275 1.008.183.222.47.333.86.333.521 0 .903-.155 1.146-.465.247-.313.37-.836.37-1.568v-2.91h1.246v5.84h-.977Zm5.709-5.947c.25 0 .456.018.618.053l-.122 1.157a2.342 2.342 0 0 0-.549-.064c-.496 0-.9.162-1.21.486-.305.324-.459.745-.459 1.263v3.052h-1.24V44h.971l.164 1.029h.063c.194-.349.446-.625.755-.83.314-.203.65-.305 1.009-.305Zm6.886 3.016c0 .954-.244 1.699-.734 2.234-.49.535-1.17.803-2.043.803-.546 0-1.029-.124-1.447-.37a2.44 2.44 0 0 1-.967-1.062c-.225-.46-.338-.996-.338-1.605 0-.947.243-1.686.729-2.218s1.17-.797 2.054-.797c.845 0 1.514.272 2.007.818.493.542.74 1.274.74 2.197Zm-4.25 0c0 1.348.497 2.023 1.494 2.023.986 0 1.478-.675 1.478-2.023 0-1.334-.496-2.002-1.489-2.002-.52 0-.9.173-1.135.518-.233.345-.349.84-.349 1.484Zm8.644-3.015c.25 0 .456.017.618.052l-.121 1.157a2.344 2.344 0 0 0-.55-.064c-.496 0-.9.162-1.21.486-.305.324-.459.745-.459 1.263v3.052h-1.24V44h.971l.164 1.029h.063c.194-.349.446-.625.755-.83.314-.203.65-.305 1.009-.305Zm5.63 4.282c0 .57-.208 1.009-.624 1.315-.415.303-1.01.455-1.785.455-.778 0-1.403-.118-1.874-.354V48.52c.686.316 1.325.475 1.917.475.764 0 1.146-.23 1.146-.692a.548.548 0 0 0-.127-.37 1.504 1.504 0 0 0-.417-.306 7.194 7.194 0 0 0-.808-.359c-.673-.26-1.129-.521-1.368-.782-.236-.26-.354-.598-.354-1.014 0-.5.2-.887.602-1.161.405-.278.954-.417 1.648-.417.686 0 1.336.139 1.948.417l-.4.934c-.631-.26-1.16-.39-1.59-.39-.655 0-.983.186-.983.56 0 .182.085.337.254.464.172.127.545.301 1.12.523.482.187.832.357 1.05.512.219.155.38.335.486.539.106.2.159.442.159.723Z",
                className: "what-do-i-need_svg__path-1"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M77.896 49.84v-3.744c0-.472-.107-.824-.322-1.056-.215-.233-.55-.349-1.008-.349-.606 0-1.05.164-1.331.491-.282.328-.423.868-.423 1.621v3.037h-.876v-5.788h.713l.142.792h.043c.179-.285.43-.505.755-.66a2.43 2.43 0 0 1 1.082-.238c.697 0 1.222.17 1.574.507.352.335.528.872.528 1.611v3.776h-.877Zm5.128.105c-.855 0-1.531-.26-2.028-.781-.493-.521-.739-1.245-.739-2.17 0-.934.229-1.675.686-2.224.462-.55 1.08-.824 1.854-.824.725 0 1.3.24 1.722.718.422.476.633 1.104.633 1.886v.554h-3.987c.018.68.189 1.196.513 1.548.327.352.786.528 1.378.528.623 0 1.24-.13 1.848-.391v.782c-.31.133-.604.228-.882.285-.274.06-.607.09-.998.09Zm-.237-5.265c-.465 0-.837.152-1.115.455-.274.302-.436.721-.486 1.256h3.026c0-.552-.123-.975-.37-1.267-.246-.296-.598-.444-1.055-.444Zm6.31 5.266c-.855 0-1.531-.261-2.028-.782-.493-.521-.739-1.245-.739-2.17 0-.934.229-1.675.687-2.224.46-.55 1.079-.824 1.853-.824.725 0 1.3.24 1.722.718.422.476.633 1.104.633 1.886v.554h-3.987c.018.68.189 1.196.513 1.548.327.352.786.528 1.378.528.623 0 1.24-.13 1.848-.391v.782c-.31.133-.603.228-.882.285-.274.06-.607.09-.998.09Zm-.237-5.266c-.465 0-.837.152-1.115.455-.274.302-.436.721-.486 1.256h3.026c0-.552-.123-.975-.37-1.267-.246-.296-.598-.444-1.055-.444Zm7.805 4.383h-.048c-.405.588-1.01.883-1.816.883-.757 0-1.347-.26-1.77-.777-.418-.517-.628-1.253-.628-2.207s.211-1.695.634-2.224c.422-.528 1.01-.792 1.764-.792.785 0 1.387.285 1.806.856h.068l-.037-.417-.02-.407v-2.355h.876v8.217h-.713l-.116-.777Zm-1.754.148c.599 0 1.032-.161 1.3-.485.27-.328.406-.854.406-1.58v-.184c0-.82-.137-1.405-.412-1.754-.27-.352-.706-.528-1.304-.528-.514 0-.908.201-1.183.602-.271.398-.407.962-.407 1.69 0 .74.136 1.298.407 1.674.271.377.669.565 1.194.565Zm10.816.629-.174-.824h-.043c-.288.363-.577.61-.866.74-.285.126-.642.19-1.072.19-.574 0-1.024-.148-1.352-.444-.324-.296-.486-.717-.486-1.262 0-1.17.935-1.782 2.805-1.838l.982-.032v-.359c0-.454-.099-.788-.296-1.003-.193-.219-.505-.328-.935-.328-.482 0-1.028.148-1.637.444l-.269-.67c.285-.156.597-.277.935-.365a4.087 4.087 0 0 1 1.024-.132c.69 0 1.201.153 1.532.46.334.306.501.797.501 1.473v3.95h-.649Zm-1.981-.618c.546 0 .974-.15 1.284-.449.313-.3.47-.718.47-1.257v-.523l-.877.037c-.697.025-1.2.134-1.51.328-.307.19-.46.487-.46.892 0 .317.095.558.286.724.193.165.462.248.807.248Zm11.978.618-1.062-3.396c-.067-.208-.192-.68-.375-1.415h-.042a19.234 19.234 0 0 1-.37 1.426l-1.093 3.385h-1.014l-1.579-5.788h.919c.373 1.454.657 2.561.85 3.322.197.76.31 1.272.338 1.536h.043a14.394 14.394 0 0 1 .411-1.537l1.062-3.321h.95l1.036 3.322c.197.605.33 1.114.401 1.526h.042c.014-.127.051-.322.111-.586.063-.264.431-1.685 1.104-4.262h.908l-1.6 5.788h-1.04Zm7.25 0-.174-.824h-.042c-.289.363-.578.61-.866.74-.285.126-.643.19-1.072.19-.574 0-1.025-.148-1.352-.444-.324-.296-.486-.717-.486-1.262 0-1.17.935-1.782 2.804-1.838l.982-.032v-.359c0-.454-.098-.788-.295-1.003-.194-.219-.506-.328-.935-.328-.482 0-1.028.148-1.637.444l-.27-.67c.286-.156.597-.277.935-.365a4.095 4.095 0 0 1 1.025-.132c.69 0 1.2.153 1.531.46.335.306.502.797.502 1.473v3.95h-.65Zm-1.98-.618c.546 0 .973-.15 1.283-.449.314-.3.47-.718.47-1.257v-.523l-.876.037c-.697.025-1.201.134-1.511.328-.306.19-.459.487-.459.892 0 .317.095.558.285.724.194.165.463.248.808.248Zm5.318.618h-.877v-8.217h.877v8.217Zm2.735 0h-.876v-8.217h.876v8.217Zm4.304.105c-.855 0-1.531-.26-2.028-.781-.492-.521-.739-1.245-.739-2.17 0-.934.229-1.675.687-2.224.461-.55 1.079-.824 1.853-.824.725 0 1.299.24 1.722.718.422.476.634 1.104.634 1.886v.554h-3.988c.018.68.189 1.196.513 1.548.327.352.787.528 1.378.528a4.66 4.66 0 0 0 1.848-.391v.782a4.444 4.444 0 0 1-.882.285c-.274.06-.607.09-.998.09Zm-.237-5.265c-.465 0-.836.152-1.115.455-.274.302-.436.721-.485 1.256h3.026c0-.552-.124-.975-.37-1.267-.247-.296-.599-.444-1.056-.444Zm5.735 4.542c.155 0 .304-.01.449-.032a3.28 3.28 0 0 0 .343-.074v.671a1.55 1.55 0 0 1-.423.11 2.93 2.93 0 0 1-.496.049c-1.12 0-1.679-.59-1.679-1.77v-3.443h-.829v-.422l.829-.365.369-1.235h.507v1.341h1.68v.681h-1.68v3.406c0 .349.083.616.249.803.165.187.392.28.681.28Z",
                className: "what-do-i-need_svg__path-2"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__b)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M157.002 39.934a.772.772 0 1 1 0 1.545h-8.884a.386.386 0 0 0 0 .772h8.884c.852 0 1.545.693 1.545 1.545v5.408c0 .852-.693 1.545-1.545 1.545h-9.27a1.546 1.546 0 0 1-1.546-1.545v-7.725c0-.854.692-1.545 1.546-1.545h9.27Zm-.773 7.339a.772.772 0 1 0 .003-1.544.772.772 0 0 0-.003 1.544Z",
                    className: "what-do-i-need_svg__path-3"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m170.383 49.84-1.062-3.396c-.067-.208-.191-.68-.375-1.415h-.042a19.847 19.847 0 0 1-.369 1.426l-1.094 3.385h-1.014l-1.579-5.788h.919c.374 1.454.657 2.561.851 3.322.197.76.309 1.272.338 1.536h.042c.039-.2.1-.459.185-.776.088-.32.163-.574.227-.76l1.061-3.322h.951l1.035 3.322c.197.605.331 1.114.401 1.526h.042c.014-.127.051-.322.111-.586.064-.264.432-1.685 1.104-4.262h.908l-1.6 5.788h-1.04Zm4.568 0h-.877v-5.788h.877v5.788ZM174 42.483c0-.2.05-.346.148-.438a.513.513 0 0 1 .37-.142c.141 0 .262.047.364.142.102.095.153.241.153.438 0 .198-.051.346-.153.444a.515.515 0 0 1-.364.143.513.513 0 0 1-.37-.143c-.098-.099-.148-.246-.148-.444Zm4.679 6.739c.155 0 .305-.01.449-.032.144-.024.259-.049.343-.074v.671a1.552 1.552 0 0 1-.422.11 2.94 2.94 0 0 1-.497.049c-1.119 0-1.679-.59-1.679-1.77v-3.443h-.829v-.422l.829-.365.37-1.235h.507v1.341h1.679v.681h-1.679v3.406c0 .349.082.616.248.803.165.187.392.28.681.28Zm5.915.618v-3.744c0-.472-.108-.824-.322-1.056-.215-.233-.551-.349-1.009-.349-.609 0-1.054.165-1.336.496-.278.331-.417.873-.417 1.627v3.026h-.877v-8.217h.877v2.487c0 .3-.014.547-.043.745h.053c.173-.278.417-.497.734-.655a2.393 2.393 0 0 1 1.093-.243c.708 0 1.238.169 1.59.507.356.334.533.868.533 1.6v3.776h-.876Zm2.556-.56c0-.236.053-.414.158-.533.109-.123.264-.185.465-.185.204 0 .363.062.475.185.116.12.174.297.174.533 0 .229-.058.405-.174.528a.62.62 0 0 1-.475.185.641.641 0 0 1-.449-.164c-.116-.112-.174-.295-.174-.549Zm0-4.663c0-.475.207-.713.623-.713.433 0 .649.238.649.713 0 .229-.058.405-.174.528a.62.62 0 0 1-.475.185.64.64 0 0 1-.449-.164c-.116-.112-.174-.295-.174-.549Z",
                className: "what-do-i-need_svg__path-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 35,
                y: 94.621,
                width: 63.261,
                height: 25.815,
                rx: 12.908,
                className: "what-do-i-need_svg__rect-3"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__c)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m56.975 107.644-3.647 2.24-3.65-2.24 3.65-6.296 3.647 6.296Zm-3.647 2.959-3.65-2.24 3.65 5.345 3.65-5.345-3.65 2.24Z",
                    className: "what-do-i-need_svg__path-5"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.266 112.027h-4.304v-7.72h4.304v.797H67.86v2.487h3.2v.793h-3.2v2.841h3.406v.802Zm4.093 0h-.898v-6.923h-2.445v-.797h5.788v.797H75.36v6.923Zm9.474 0h-.898v-3.633H79.87v3.633h-.898v-7.72h.898v3.284h4.066v-3.284h.898v7.72Z",
                className: "what-do-i-need_svg__path-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M103.984 112.689c-.202 0-.385-.03-.549-.092v-.619c.188.064.352.096.492.096a.58.58 0 0 0 .514-.272c.121-.182.217-.441.291-.778l.997-4.755h-.848l.057-.294.905-.29.101-.44c.135-.586.321-.999.559-1.239.24-.243.594-.365 1.063-.365.117 0 .261.018.431.053.17.032.301.069.395.11l-.189.567a1.707 1.707 0 0 0-.602-.128c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.042l-1.019 4.825c-.114.554-.29.958-.528 1.213-.237.255-.549.382-.936.382Zm6.104-7.04c.557 0 .997.166 1.319.497.322.328.483.781.483 1.358 0 .551-.105 1.071-.316 1.56-.211.489-.497.867-.857 1.134-.36.266-.768.4-1.222.4-.562 0-1.003-.166-1.323-.497-.319-.331-.479-.784-.479-1.358 0-.556.107-1.079.321-1.569.214-.492.503-.868.866-1.129a2.007 2.007 0 0 1 1.208-.396Zm1.038 1.754c0-.337-.093-.61-.277-.818-.182-.21-.43-.316-.743-.316-.319 0-.606.108-.861.325-.252.217-.449.519-.589.906a3.766 3.766 0 0 0-.207 1.283c0 .384.093.681.277.892.188.208.456.312.804.312.305 0 .579-.107.822-.321.243-.214.432-.517.567-.91.138-.395.207-.846.207-1.353Zm4.495-1.78a2 2 0 0 1 .527.062l-.158.659a1.933 1.933 0 0 0-.461-.057c-.267 0-.517.088-.752.263a2.342 2.342 0 0 0-.61.734 3.735 3.735 0 0 0-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044a4.19 4.19 0 0 1 .523-.598 1.61 1.61 0 0 1 .431-.281c.152-.067.321-.101.505-.101Zm7.436.088-.11.47-.927.106c.12.181.18.413.18.694 0 .56-.172 1.006-.514 1.34-.34.331-.796.497-1.367.497-.161 0-.284-.012-.369-.035-.407.155-.611.347-.611.575 0 .121.048.201.145.242.097.038.237.069.422.092l.514.062c.53.064.914.193 1.151.387.241.193.361.477.361.852 0 .539-.214.957-.642 1.253-.428.296-1.03.443-1.806.443-.568 0-1.014-.108-1.336-.325a1.029 1.029 0 0 1-.483-.909c0-.308.105-.575.316-.8.211-.226.552-.418 1.024-.576-.229-.12-.343-.297-.343-.532 0-.202.075-.375.224-.518.15-.147.358-.283.624-.409a1.155 1.155 0 0 1-.452-.413 1.165 1.165 0 0 1-.176-.642c0-.568.174-1.034.523-1.397.351-.363.8-.545 1.345-.545.228 0 .454.029.676.088h1.631Zm-4.68 5.673c0 .226.095.405.285.536.191.132.473.198.848.198.534 0 .95-.094 1.248-.281.302-.185.453-.447.453-.787a.492.492 0 0 0-.237-.43c-.159-.106-.428-.179-.809-.22l-.699-.07c-.351.073-.621.202-.808.386a.903.903 0 0 0-.281.668Zm1.221-3.845c0 .249.066.44.198.571.132.129.315.194.549.194.232 0 .434-.062.607-.185s.304-.291.395-.505c.094-.217.141-.451.141-.703 0-.241-.065-.424-.194-.55-.128-.126-.313-.189-.553-.189-.229 0-.429.06-.602.181a1.17 1.17 0 0 0-.4.496 1.676 1.676 0 0 0-.141.69Zm5.942-1.916c.269 0 .509.073.72.22a1.4 1.4 0 0 1 .493.624h.048l.294-.756h.558l-1.024 4.816h-.584l.114-.918h-.035c-.524.671-1.077 1.006-1.657 1.006-.407 0-.726-.145-.958-.435-.231-.29-.347-.687-.347-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.93.862-1.226a1.872 1.872 0 0 1 1.204-.444Zm-.835 4.381c.284 0 .567-.134.848-.404.281-.272.51-.625.685-1.059.176-.437.264-.873.264-1.31 0-.301-.082-.542-.246-.72a.834.834 0 0 0-.646-.268c-.305 0-.589.126-.853.378-.26.252-.465.593-.615 1.024a4.13 4.13 0 0 0-.224 1.362c0 .334.069.584.207.751.137.164.331.246.58.246Zm6.345-.843c0 .457-.162.814-.487 1.072-.323.255-.778.382-1.367.382a2.92 2.92 0 0 1-1.34-.303v-.694c.205.123.426.218.663.285.237.068.457.101.659.101.369 0 .648-.073.835-.219a.683.683 0 0 0 .281-.563.612.612 0 0 0-.153-.422c-.103-.114-.324-.271-.664-.47-.381-.214-.65-.423-.808-.628a1.157 1.157 0 0 1-.238-.73c0-.404.148-.729.444-.975.296-.249.686-.374 1.169-.374.501 0 .984.108 1.45.325l-.237.602-.246-.11a2.442 2.442 0 0 0-.967-.189c-.272 0-.486.065-.642.194a.605.605 0 0 0-.233.492c0 .164.052.305.154.422.106.117.321.268.646.453.314.175.538.326.673.452.137.126.24.262.307.409.068.143.101.306.101.488Zm2.51 3.528c-.203 0-.386-.03-.55-.092v-.619c.188.064.352.096.493.096a.582.582 0 0 0 .514-.272c.12-.182.216-.441.29-.778l.997-4.755h-.848l.057-.294.906-.29.101-.44c.134-.586.32-.999.558-1.239.24-.243.594-.365 1.063-.365.117 0 .261.018.431.053.17.032.302.069.395.11l-.189.567a1.707 1.707 0 0 0-.602-.128c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.041l-1.02 4.825c-.114.554-.29.958-.527 1.213-.238.255-.55.382-.936.382Zm5.44-2.074c-.539 0-.962-.159-1.27-.479-.308-.319-.461-.761-.461-1.327 0-.551.108-1.078.325-1.582.22-.507.51-.901.87-1.182.36-.281.757-.422 1.191-.422.448 0 .785.098 1.011.294.225.194.338.465.338.813 0 .528-.243.942-.73 1.244-.486.299-1.182.448-2.087.448h-.145l-.018.352c0 .384.09.684.269.901.181.214.461.321.839.321.184 0 .373-.027.567-.079.196-.053.439-.15.729-.291v.642a3.845 3.845 0 0 1-.729.268 2.87 2.87 0 0 1-.699.079Zm.611-4.364c-.302 0-.586.138-.853.414-.263.275-.465.657-.606 1.147h.053c.668 0 1.179-.087 1.533-.26.358-.176.536-.429.536-.76a.513.513 0 0 0-.162-.387c-.106-.102-.273-.154-.501-.154Zm3.828 4.364c-.54 0-.963-.159-1.27-.479-.308-.319-.462-.761-.462-1.327 0-.551.108-1.078.325-1.582.22-.507.51-.901.87-1.182a1.896 1.896 0 0 1 1.191-.422c.449 0 .785.098 1.011.294.226.194.338.465.338.813 0 .528-.243.942-.729 1.244-.486.299-1.182.448-2.087.448h-.145l-.018.352c0 .384.089.684.268.901.182.214.461.321.839.321.185 0 .374-.027.567-.079.197-.053.44-.15.73-.291v.642a3.876 3.876 0 0 1-.73.268 2.867 2.867 0 0 1-.698.079Zm.61-4.364c-.301 0-.586.138-.852.414-.264.275-.466.657-.607 1.147h.053c.668 0 1.179-.087 1.534-.26.357-.176.536-.429.536-.76a.51.51 0 0 0-.163-.387c-.105-.102-.272-.154-.501-.154Zm4.896 2.91c0 .457-.163.814-.488 1.072-.322.255-.778.382-1.367.382a2.92 2.92 0 0 1-1.34-.303v-.694c.205.123.426.218.664.285.237.068.457.101.659.101.369 0 .647-.073.835-.219a.685.685 0 0 0 .281-.563.608.608 0 0 0-.154-.422c-.102-.114-.324-.271-.663-.47-.381-.214-.651-.423-.809-.628a1.162 1.162 0 0 1-.237-.73c0-.404.148-.729.444-.975.295-.249.685-.374 1.169-.374.501 0 .984.108 1.45.325l-.238.602-.246-.11a2.44 2.44 0 0 0-.966-.189c-.273 0-.487.065-.642.194a.605.605 0 0 0-.233.492c0 .164.051.305.154.422.105.117.321.268.646.453.313.175.537.326.672.452.138.126.24.262.308.409.067.143.101.306.101.488Z",
                className: "what-do-i-need_svg__path-7"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 35,
                y: 187.844,
                width: 63.261,
                height: 25.815,
                rx: 12.908,
                className: "what-do-i-need_svg__rect-4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__d)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m56.975 200.866-3.647 2.241-3.65-2.241 3.65-6.296 3.647 6.296Zm-3.647 2.96-3.65-2.24 3.65 5.345 3.65-5.345-3.65 2.24Z",
                    className: "what-do-i-need_svg__path-8"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.266 205.25h-4.304v-7.721h4.304v.798H67.86v2.487h3.2v.792h-3.2v2.841h3.406v.803Zm4.093 0h-.898v-6.923h-2.445v-.798h5.788v.798H75.36v6.923Zm9.474 0h-.898v-3.633H79.87v3.633h-.898v-7.721h.898v3.285h4.066v-3.285h.898v7.721Z",
                className: "what-do-i-need_svg__path-9"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M103.984 205.912c-.202 0-.385-.031-.549-.092v-.62c.188.065.352.097.492.097a.58.58 0 0 0 .514-.273c.121-.181.217-.441.291-.777l.997-4.755h-.848l.057-.295.905-.29.101-.439c.135-.586.321-.999.559-1.239.24-.244.594-.365 1.063-.365.117 0 .261.017.431.053.17.032.301.068.395.109l-.189.567a1.703 1.703 0 0 0-.602-.127c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.042l-1.019 4.825c-.114.554-.29.958-.528 1.213-.237.255-.549.382-.936.382Zm6.104-7.04c.557 0 .997.166 1.319.497.322.328.483.78.483 1.358 0 .55-.105 1.07-.316 1.56-.211.489-.497.867-.857 1.133a2 2 0 0 1-1.222.4c-.562 0-1.003-.165-1.323-.496-.319-.331-.479-.784-.479-1.358 0-.557.107-1.08.321-1.569.214-.492.503-.869.866-1.129a2.007 2.007 0 0 1 1.208-.396Zm1.038 1.753c0-.336-.093-.609-.277-.817-.182-.211-.43-.316-.743-.316-.319 0-.606.108-.861.325-.252.217-.449.518-.589.905a3.774 3.774 0 0 0-.207 1.283c0 .384.093.682.277.892.188.208.456.312.804.312.305 0 .579-.106.822-.32.243-.214.432-.517.567-.91.138-.396.207-.847.207-1.354Zm4.495-1.779c.202 0 .378.02.527.061l-.158.659a1.933 1.933 0 0 0-.461-.057 1.23 1.23 0 0 0-.752.264 2.33 2.33 0 0 0-.61.734c-.173.31-.301.656-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044c.211-.279.385-.478.523-.598.138-.123.281-.217.431-.281.152-.068.321-.101.505-.101Zm2.145 7.066a1.57 1.57 0 0 1-.55-.092v-.62c.188.065.352.097.493.097a.58.58 0 0 0 .514-.273c.12-.181.217-.441.29-.777l.997-4.755h-.848l.057-.295.906-.29.101-.439c.134-.586.32-.999.558-1.239.24-.244.594-.365 1.063-.365.117 0 .261.017.431.053.17.032.302.068.395.109l-.189.567a1.703 1.703 0 0 0-.602-.127c-.254 0-.451.072-.588.215-.135.141-.245.4-.33.778l-.11.475h1.046l-.11.558h-1.041l-1.02 4.825c-.114.554-.29.958-.527 1.213-.238.255-.55.382-.936.382Zm5.26-6.978-.659 3.054a3.27 3.27 0 0 0-.079.611c0 .419.215.628.646.628.257 0 .511-.088.76-.264.249-.175.469-.427.659-.755.191-.329.336-.724.435-1.187l.44-2.087h.729l-1.015 4.816h-.611l.097-.892h-.053c-.287.366-.561.621-.822.765-.26.143-.53.215-.808.215-.375 0-.67-.101-.884-.303-.213-.205-.32-.497-.32-.875 0-.181.032-.433.096-.756l.642-2.97h.747Zm6.416 4.816.65-3.041c.059-.305.088-.516.088-.633a.619.619 0 0 0-.158-.444c-.103-.111-.268-.167-.497-.167-.26 0-.515.088-.764.264a2.38 2.38 0 0 0-.655.751c-.187.326-.33.72-.426 1.183l-.444 2.087h-.738l1.028-4.816h.611l-.097.892h.044c.281-.358.552-.61.813-.756.264-.15.536-.224.817-.224.372 0 .665.102.879.307.217.202.326.487.326.853 0 .231-.034.495-.102.791l-.628 2.953h-.747Zm4.799-4.896c.568 0 .98.279 1.235.835h.044c.049-.454.115-.855.197-1.204l.343-1.573h.73l-1.451 6.838h-.61l.096-.918h-.035c-.296.366-.573.625-.83.777a1.548 1.548 0 0 1-.8.229c-.407 0-.725-.144-.954-.431-.228-.287-.343-.685-.343-1.195 0-.627.106-1.201.317-1.723.211-.521.495-.924.852-1.208a1.906 1.906 0 0 1 1.209-.427Zm-.835 4.373c.275 0 .559-.136.852-.409.293-.275.525-.625.695-1.05.173-.428.259-.863.259-1.305 0-.325-.079-.573-.237-.743-.159-.17-.389-.255-.69-.255-.296 0-.572.122-.826.365-.252.24-.456.58-.611 1.02a4.135 4.135 0 0 0-.229 1.379c0 .666.262.998.787.998Zm4.219.523h-.739l1.029-4.816h.738l-1.028 4.816Zm.496-6.047a.57.57 0 0 1 .141-.4.467.467 0 0 1 .365-.158c.257 0 .386.132.386.396 0 .161-.05.297-.149.408a.436.436 0 0 1-.339.167.414.414 0 0 1-.29-.105.407.407 0 0 1-.114-.308Zm3.995 6.047.65-3.041c.059-.305.088-.516.088-.633a.623.623 0 0 0-.158-.444c-.103-.111-.268-.167-.497-.167-.26 0-.515.088-.764.264a2.38 2.38 0 0 0-.655.751c-.188.326-.33.72-.426 1.183l-.444 2.087h-.739l1.029-4.816h.611l-.097.892h.044c.281-.358.552-.61.813-.756.264-.15.536-.224.817-.224.372 0 .665.102.879.307.217.202.325.487.325.853 0 .231-.033.495-.101.791l-.628 2.953h-.747Zm6.824-4.816-.109.47-.928.105c.12.182.181.413.181.695 0 .559-.172 1.006-.515 1.34-.339.331-.795.497-1.366.497a1.44 1.44 0 0 1-.369-.036c-.408.156-.611.348-.611.576 0 .12.048.201.145.242.096.038.237.069.422.092l.514.062c.53.064.914.193 1.151.386.24.194.36.478.36.853 0 .539-.213.956-.641 1.252-.428.296-1.03.444-1.806.444-.569 0-1.014-.108-1.336-.325a1.03 1.03 0 0 1-.484-.91c0-.307.106-.574.317-.8.211-.225.552-.417 1.024-.575-.229-.12-.343-.298-.343-.532 0-.202.075-.375.224-.519.149-.146.358-.282.624-.408a1.172 1.172 0 0 1-.453-.413 1.175 1.175 0 0 1-.175-.642c0-.568.174-1.034.523-1.397.351-.364.799-.545 1.344-.545.229 0 .454.029.677.088h1.63Zm-4.68 5.673a.62.62 0 0 0 .286.536c.19.132.473.198.848.198.533 0 .949-.094 1.248-.281.302-.185.453-.447.453-.787a.492.492 0 0 0-.238-.431c-.158-.105-.427-.178-.808-.219l-.699-.071c-.351.073-.621.202-.808.387a.902.902 0 0 0-.282.668Zm1.222-3.845c0 .249.066.439.198.571.132.129.315.193.549.193.232 0 .434-.061.607-.184.172-.123.304-.292.395-.506.094-.216.141-.451.141-.703 0-.24-.065-.423-.194-.549-.129-.126-.313-.189-.553-.189-.229 0-.43.06-.602.18-.17.117-.304.283-.4.497a1.676 1.676 0 0 0-.141.69Zm8.279-1.916c.27 0 .51.073.721.219.211.144.375.352.492.624h.049l.294-.755h.558l-1.024 4.816h-.584l.114-.918h-.035c-.525.67-1.077 1.006-1.657 1.006-.407 0-.727-.145-.958-.435-.231-.29-.347-.687-.347-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.931.861-1.226a1.874 1.874 0 0 1 1.204-.444Zm-.835 4.381c.285 0 .567-.135.848-.404.282-.273.51-.626.686-1.059.176-.437.264-.873.264-1.31 0-.302-.082-.542-.246-.721a.839.839 0 0 0-.646-.268c-.305 0-.589.126-.853.378-.261.252-.466.594-.615 1.024-.15.431-.224.885-.224 1.362 0 .334.069.585.206.752.138.164.331.246.58.246Zm6.32.523.65-3.041c.059-.305.088-.516.088-.633a.623.623 0 0 0-.158-.444c-.103-.111-.268-.167-.497-.167-.261 0-.515.088-.764.264a2.368 2.368 0 0 0-.655.751c-.188.326-.33.72-.427 1.183l-.443 2.087h-.739l1.029-4.816h.61l-.096.892h.044c.281-.358.552-.61.813-.756.263-.15.536-.224.817-.224.372 0 .665.102.879.307.217.202.325.487.325.853 0 .231-.033.495-.101.791l-.628 2.953h-.747Zm7.136-4.904c.27 0 .51.073.721.219.211.144.375.352.492.624h.049l.294-.755h.558l-1.024 4.816h-.584l.114-.918h-.035c-.525.67-1.077 1.006-1.657 1.006-.407 0-.726-.145-.958-.435-.231-.29-.347-.687-.347-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.931.861-1.226a1.874 1.874 0 0 1 1.204-.444Zm-.835 4.381c.285 0 .567-.135.849-.404.281-.273.509-.626.685-1.059.176-.437.264-.873.264-1.31 0-.302-.082-.542-.246-.721a.839.839 0 0 0-.646-.268c-.305 0-.589.126-.853.378-.261.252-.466.594-.615 1.024a4.14 4.14 0 0 0-.224 1.362c0 .334.069.585.206.752.138.164.331.246.58.246Zm5.511.611c-.284 0-.533-.073-.747-.22a1.418 1.418 0 0 1-.496-.615h-.044l-.018.167a6.678 6.678 0 0 1-.048.308c-.021.131-.188.943-.501 2.434h-.73l1.477-6.978h.611l-.115.918h.035c.525-.665 1.07-.998 1.635-.998.402 0 .718.144.949.431.232.284.348.684.348 1.2 0 .621-.101 1.191-.304 1.709-.202.519-.482.923-.839 1.213a1.886 1.886 0 0 1-1.213.431Zm.818-4.373c-.282 0-.569.139-.862.418-.29.278-.521.628-.694 1.05a3.44 3.44 0 0 0-.255 1.296c0 .323.081.57.242.743.164.17.4.255.707.255.29 0 .56-.119.809-.356.252-.237.454-.574.606-1.011.153-.439.229-.905.229-1.397 0-.665-.261-.998-.782-.998Zm4.377 4.373c-.285 0-.534-.073-.748-.22a1.425 1.425 0 0 1-.496-.615h-.044l-.018.167a5.528 5.528 0 0 1-.048.308c-.021.131-.188.943-.501 2.434h-.729l1.476-6.978h.611l-.114.918h.035c.524-.665 1.069-.998 1.635-.998.401 0 .717.144.949.431.231.284.347.684.347 1.2 0 .621-.101 1.191-.303 1.709-.202.519-.482.923-.84 1.213a1.884 1.884 0 0 1-1.212.431Zm.817-4.373c-.281 0-.568.139-.861.418-.29.278-.522.628-.695 1.05a3.44 3.44 0 0 0-.255 1.296c0 .323.081.57.242.743.164.17.4.255.708.255.29 0 .559-.119.808-.356.252-.237.454-.574.607-1.011.152-.439.228-.905.228-1.397 0-.665-.261-.998-.782-.998Zm4.144 4.373c-.539 0-.962-.16-1.27-.479-.308-.319-.462-.762-.462-1.327 0-.551.109-1.078.326-1.582.219-.507.509-.901.87-1.182.36-.282.757-.422 1.191-.422.448 0 .785.098 1.01.294.226.193.339.464.339.813 0 .527-.243.942-.73 1.244-.486.299-1.182.448-2.087.448h-.145l-.018.352c0 .383.09.684.268.9.182.214.462.321.84.321.184 0 .373-.026.567-.079.196-.053.439-.149.729-.29v.642a3.845 3.845 0 0 1-.729.268 2.87 2.87 0 0 1-.699.079Zm.611-4.364c-.302 0-.586.138-.853.413-.263.276-.466.658-.606 1.147h.053c.667 0 1.179-.086 1.533-.259.358-.176.536-.429.536-.76a.51.51 0 0 0-.162-.387c-.106-.103-.273-.154-.501-.154Zm4.473-.628c.27 0 .51.073.721.219.211.144.375.352.492.624h.049l.294-.755h.558l-1.024 4.816h-.584l.114-.918h-.035c-.525.67-1.077 1.006-1.657 1.006-.407 0-.726-.145-.958-.435-.231-.29-.347-.687-.347-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.931.861-1.226a1.876 1.876 0 0 1 1.204-.444Zm-.835 4.381c.285 0 .567-.135.849-.404.281-.273.509-.626.685-1.059.176-.437.264-.873.264-1.31 0-.302-.082-.542-.246-.721a.839.839 0 0 0-.646-.268c-.305 0-.589.126-.853.378-.261.252-.466.594-.615 1.024a4.14 4.14 0 0 0-.224 1.362c0 .334.069.585.206.752.138.164.331.246.58.246Zm4.105.523h-.738l1.459-6.838h.738l-1.459 6.838Zm6.442-4.904c.27 0 .51.073.721.219.211.144.375.352.492.624h.049l.294-.755h.558l-1.024 4.816h-.584l.114-.918h-.035c-.525.67-1.077 1.006-1.657 1.006-.407 0-.727-.145-.958-.435-.231-.29-.347-.687-.347-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.931.861-1.226a1.874 1.874 0 0 1 1.204-.444Zm-.835 4.381c.285 0 .567-.135.848-.404.282-.273.51-.626.686-1.059.176-.437.264-.873.264-1.31 0-.302-.082-.542-.246-.721a.839.839 0 0 0-.646-.268c-.305 0-.589.126-.853.378-.261.252-.466.594-.615 1.024-.15.431-.224.885-.224 1.362 0 .334.069.585.206.752.138.164.331.246.58.246Zm6.32.523.65-3.041c.059-.305.088-.516.088-.633a.623.623 0 0 0-.158-.444c-.103-.111-.268-.167-.497-.167-.261 0-.515.088-.764.264a2.368 2.368 0 0 0-.655.751c-.188.326-.33.72-.427 1.183l-.443 2.087h-.739l1.029-4.816h.611l-.097.892h.044c.281-.358.552-.61.813-.756.263-.15.536-.224.817-.224.372 0 .665.102.879.307.217.202.325.487.325.853 0 .231-.033.495-.101.791l-.628 2.953h-.747Zm4.799-4.896c.568 0 .979.279 1.234.835h.044c.05-.454.116-.855.198-1.204l.343-1.573h.729l-1.45 6.838h-.611l.097-.918h-.035c-.296.366-.573.625-.831.777a1.546 1.546 0 0 1-.8.229c-.407 0-.725-.144-.953-.431-.229-.287-.343-.685-.343-1.195 0-.627.106-1.201.316-1.723.211-.521.496-.924.853-1.208.36-.284.763-.427 1.209-.427Zm-.835 4.373c.275 0 .559-.136.852-.409.293-.275.525-.625.694-1.05.173-.428.26-.863.26-1.305 0-.325-.079-.573-.238-.743-.158-.17-.388-.255-.69-.255-.295 0-.571.122-.826.365-.252.24-.455.58-.611 1.02a4.16 4.16 0 0 0-.228 1.379c0 .666.262.998.787.998Zm5.102 2.685c-.203 0-.386-.031-.55-.092v-.62c.188.065.352.097.492.097a.58.58 0 0 0 .515-.273c.12-.181.216-.441.29-.777l.997-4.755h-.848l.057-.295.905-.29.102-.439c.134-.586.32-.999.558-1.239.24-.244.594-.365 1.063-.365.117 0 .261.017.431.053.17.032.302.068.395.109l-.189.567a1.703 1.703 0 0 0-.602-.127c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.041l-1.02 4.825c-.114.554-.29.958-.527 1.213-.238.255-.55.382-.936.382Zm6.104-7.04c.556 0 .996.166 1.318.497.322.328.483.78.483 1.358 0 .55-.105 1.07-.316 1.56-.211.489-.497.867-.857 1.133a2 2 0 0 1-1.222.4c-.562 0-1.003-.165-1.322-.496-.32-.331-.479-.784-.479-1.358 0-.557.107-1.08.32-1.569.214-.492.503-.869.866-1.129a2.008 2.008 0 0 1 1.209-.396Zm1.037 1.753c0-.336-.093-.609-.277-.817-.182-.211-.429-.316-.743-.316-.319 0-.606.108-.861.325-.252.217-.448.518-.589.905a3.774 3.774 0 0 0-.207 1.283c0 .384.093.682.277.892.188.208.456.312.805.312.304 0 .578-.106.821-.32.243-.214.432-.517.567-.91.138-.396.207-.847.207-1.354Zm4.495-1.779c.202 0 .378.02.528.061l-.159.659a1.933 1.933 0 0 0-.461-.057c-.267 0-.517.088-.751.264-.232.176-.435.42-.611.734-.173.31-.301.656-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044c.211-.279.386-.478.523-.598a1.6 1.6 0 0 1 .431-.281c.152-.068.321-.101.505-.101Zm7.436.088-.11.47-.927.105c.12.182.18.413.18.695 0 .559-.171 1.006-.514 1.34-.34.331-.796.497-1.367.497a1.44 1.44 0 0 1-.369-.036c-.407.156-.611.348-.611.576 0 .12.048.201.145.242.097.038.237.069.422.092l.514.062c.53.064.914.193 1.152.386.24.194.36.478.36.853 0 .539-.214.956-.642 1.252-.427.296-1.03.444-1.806.444-.568 0-1.014-.108-1.336-.325a1.03 1.03 0 0 1-.483-.91c0-.307.105-.574.316-.8.211-.225.552-.417 1.024-.575-.228-.12-.343-.298-.343-.532 0-.202.075-.375.224-.519.15-.146.358-.282.624-.408a1.162 1.162 0 0 1-.452-.413 1.176 1.176 0 0 1-.176-.642c0-.568.174-1.034.523-1.397.352-.364.8-.545 1.345-.545.228 0 .454.029.677.088h1.63Zm-4.68 5.673a.62.62 0 0 0 .285.536c.191.132.473.198.848.198.534 0 .95-.094 1.249-.281.301-.185.452-.447.452-.787a.493.493 0 0 0-.237-.431c-.158-.105-.428-.178-.809-.219l-.698-.071c-.352.073-.622.202-.809.387a.901.901 0 0 0-.281.668Zm1.221-3.845c0 .249.066.439.198.571.132.129.315.193.549.193.232 0 .434-.061.607-.184s.305-.292.395-.506c.094-.216.141-.451.141-.703 0-.24-.064-.423-.193-.549-.129-.126-.314-.189-.554-.189-.229 0-.429.06-.602.18-.17.117-.303.283-.4.497a1.676 1.676 0 0 0-.141.69Zm5.942-1.916c.269 0 .51.073.72.219.211.144.375.352.493.624h.048l.294-.755h.559l-1.024 4.816h-.585l.114-.918h-.035c-.524.67-1.076 1.006-1.656 1.006-.408 0-.727-.145-.958-.435-.232-.29-.348-.687-.348-1.191 0-.609.104-1.175.312-1.696.208-.522.495-.931.862-1.226a1.872 1.872 0 0 1 1.204-.444Zm-.835 4.381c.284 0 .567-.135.848-.404.281-.273.51-.626.686-1.059a3.5 3.5 0 0 0 .263-1.31c0-.302-.082-.542-.246-.721a.837.837 0 0 0-.646-.268c-.305 0-.589.126-.852.378-.261.252-.466.594-.616 1.024a4.14 4.14 0 0 0-.224 1.362c0 .334.069.585.207.752.137.164.331.246.58.246Zm6.346-.844c0 .457-.163.815-.488 1.073-.323.254-.778.382-1.367.382a2.92 2.92 0 0 1-1.34-.303v-.695c.205.123.426.219.663.286.238.067.457.101.659.101.37 0 .648-.073.835-.22a.682.682 0 0 0 .282-.562.611.611 0 0 0-.154-.422c-.103-.114-.324-.271-.664-.47-.381-.214-.65-.424-.808-.629a1.154 1.154 0 0 1-.238-.729c0-.404.148-.73.444-.976.296-.249.686-.373 1.169-.373.501 0 .985.108 1.45.325l-.237.602-.246-.11a2.442 2.442 0 0 0-.967-.189c-.272 0-.486.065-.641.193a.604.604 0 0 0-.233.493c0 .164.051.304.153.422.106.117.321.268.646.452.314.176.538.327.673.453.138.126.24.262.307.409.068.143.102.306.102.487Zm2.509 3.529c-.202 0-.385-.031-.55-.092v-.62c.188.065.352.097.493.097a.58.58 0 0 0 .514-.273c.12-.181.217-.441.29-.777l.997-4.755h-.848l.057-.295.906-.29.101-.439c.135-.586.321-.999.558-1.239.24-.244.595-.365 1.063-.365.118 0 .261.017.431.053.17.032.302.068.396.109l-.189.567a1.712 1.712 0 0 0-.602-.127c-.255 0-.452.072-.589.215-.135.141-.245.4-.33.778l-.11.475h1.046l-.11.558h-1.041l-1.02 4.825c-.114.554-.29.958-.527 1.213-.237.255-.549.382-.936.382Zm5.44-2.074c-.539 0-.962-.16-1.27-.479-.307-.319-.461-.762-.461-1.327 0-.551.108-1.078.325-1.582.22-.507.51-.901.87-1.182.36-.282.757-.422 1.191-.422.448 0 .785.098 1.011.294.225.193.338.464.338.813 0 .527-.243.942-.729 1.244-.487.299-1.182.448-2.088.448h-.145l-.017.352c0 .383.089.684.268.9.181.214.461.321.839.321.185 0 .374-.026.567-.079.196-.053.439-.149.729-.29v.642a3.845 3.845 0 0 1-.729.268 2.87 2.87 0 0 1-.699.079Zm.611-4.364c-.302 0-.586.138-.852.413-.264.276-.466.658-.607 1.147h.053c.668 0 1.179-.086 1.534-.259.357-.176.536-.429.536-.76a.51.51 0 0 0-.163-.387c-.105-.103-.272-.154-.501-.154Zm3.828 4.364c-.539 0-.963-.16-1.27-.479-.308-.319-.462-.762-.462-1.327 0-.551.109-1.078.325-1.582.22-.507.51-.901.871-1.182.36-.282.757-.422 1.19-.422.449 0 .786.098 1.011.294.226.193.339.464.339.813 0 .527-.244.942-.73 1.244-.486.299-1.182.448-2.087.448h-.145l-.018.352c0 .383.089.684.268.9.182.214.462.321.84.321.184 0 .373-.026.566-.079.197-.053.44-.149.73-.29v.642a3.851 3.851 0 0 1-.73.268c-.21.053-.443.079-.698.079Zm.611-4.364c-.302 0-.586.138-.853.413-.264.276-.466.658-.606 1.147h.052c.668 0 1.179-.086 1.534-.259.357-.176.536-.429.536-.76a.51.51 0 0 0-.162-.387c-.106-.103-.273-.154-.501-.154Zm4.895 2.909c0 .457-.163.815-.488 1.073-.322.254-.778.382-1.366.382-.496 0-.942-.101-1.341-.303v-.695c.205.123.427.219.664.286.237.067.457.101.659.101.369 0 .647-.073.835-.22a.683.683 0 0 0 .281-.562.607.607 0 0 0-.154-.422c-.102-.114-.323-.271-.663-.47-.381-.214-.651-.424-.809-.629a1.16 1.16 0 0 1-.237-.729c0-.404.148-.73.444-.976.296-.249.685-.373 1.169-.373.501 0 .984.108 1.45.325l-.237.602-.246-.11a2.446 2.446 0 0 0-.967-.189c-.273 0-.487.065-.642.193a.607.607 0 0 0-.233.493c0 .164.051.304.154.422.105.117.321.268.646.452.313.176.538.327.672.453.138.126.241.262.308.409.067.143.101.306.101.487Z",
                className: "what-do-i-need_svg__path-10"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 35,
                y: 281.457,
                width: 63.261,
                height: 25.815,
                rx: 12.908,
                className: "what-do-i-need_svg__rect-5"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__e)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m56.975 294.48-3.647 2.24-3.65-2.24 3.65-6.296 3.647 6.296Zm-3.647 2.959-3.65-2.24 3.65 5.345 3.65-5.345-3.65 2.24Z",
                    className: "what-do-i-need_svg__path-11"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.266 298.863h-4.304v-7.72h4.304v.797H67.86v2.487h3.2v.792h-3.2v2.842h3.406v.802Zm4.093 0h-.898v-6.923h-2.445v-.797h5.788v.797H75.36v6.923Zm9.474 0h-.898v-3.633H79.87v3.633h-.898v-7.72h.898v3.284h4.066v-3.284h.898v7.72Z",
                className: "what-do-i-need_svg__path-12"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M103.984 299.525c-.202 0-.385-.03-.549-.092v-.62c.188.065.352.097.492.097a.58.58 0 0 0 .514-.272c.121-.182.217-.441.291-.778l.997-4.755h-.848l.057-.294.905-.29.101-.44c.135-.586.321-.999.559-1.239.24-.243.594-.365 1.063-.365.117 0 .261.018.431.053.17.032.301.069.395.11l-.189.567a1.707 1.707 0 0 0-.602-.128c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.042l-1.019 4.825c-.114.554-.29.958-.528 1.213-.237.255-.549.382-.936.382Zm6.104-7.04c.557 0 .997.166 1.319.497.322.328.483.781.483 1.358 0 .551-.105 1.071-.316 1.56-.211.489-.497.867-.857 1.134-.36.266-.768.4-1.222.4-.562 0-1.003-.166-1.323-.497-.319-.331-.479-.784-.479-1.358 0-.557.107-1.079.321-1.569.214-.492.503-.868.866-1.129a2.007 2.007 0 0 1 1.208-.396Zm1.038 1.754c0-.337-.093-.61-.277-.818-.182-.211-.43-.316-.743-.316-.319 0-.606.108-.861.325-.252.217-.449.519-.589.905a3.776 3.776 0 0 0-.207 1.284c0 .383.093.681.277.892.188.208.456.312.804.312.305 0 .579-.107.822-.321.243-.214.432-.517.567-.91.138-.395.207-.846.207-1.353Zm4.495-1.78c.202 0 .378.02.527.062l-.158.659a1.933 1.933 0 0 0-.461-.057 1.23 1.23 0 0 0-.752.263 2.342 2.342 0 0 0-.61.734 3.735 3.735 0 0 0-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044a4.19 4.19 0 0 1 .523-.598 1.61 1.61 0 0 1 .431-.281c.152-.067.321-.101.505-.101Zm5.41 0c.269 0 .51.073.721.22.21.143.375.351.492.624h.048l.294-.756h.559l-1.024 4.816h-.585l.114-.918h-.035c-.524.671-1.076 1.006-1.656 1.006-.408 0-.727-.145-.958-.435-.232-.29-.348-.687-.348-1.191 0-.609.104-1.175.312-1.696.208-.522.496-.93.862-1.226a1.872 1.872 0 0 1 1.204-.444Zm-.835 4.381c.284 0 .567-.134.848-.404.281-.272.51-.625.686-1.059a3.5 3.5 0 0 0 .263-1.31c0-.301-.082-.542-.246-.72a.834.834 0 0 0-.646-.268c-.305 0-.589.126-.852.378-.261.251-.466.593-.616 1.023a4.14 4.14 0 0 0-.224 1.363c0 .334.069.584.207.751.137.164.331.246.58.246Zm6.42-4.381c.202 0 .378.02.528.062l-.159.659a1.933 1.933 0 0 0-.461-.057c-.267 0-.517.087-.751.263a2.33 2.33 0 0 0-.611.734 3.735 3.735 0 0 0-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044c.211-.278.386-.478.523-.598a1.61 1.61 0 0 1 .431-.281c.152-.067.321-.101.505-.101Zm2.659 4.992c-.284 0-.535-.075-.752-.224a1.376 1.376 0 0 1-.483-.611h-.044l-.307.747h-.55l1.45-6.838h.739c-.15.709-.265 1.253-.347 1.631-.08.375-.189.814-.33 1.318h.039c.273-.346.541-.599.805-.76.266-.164.54-.246.821-.246.414 0 .736.145.967.435.232.29.347.688.347 1.195 0 .612-.101 1.179-.303 1.701-.199.518-.479.924-.839 1.217-.358.29-.762.435-1.213.435Zm.817-4.372c-.281 0-.568.139-.861.417-.29.278-.521.629-.694 1.05a3.44 3.44 0 0 0-.255 1.297c0 .322.08.57.241.742.165.17.4.255.708.255.29 0 .56-.118.809-.356.252-.237.454-.574.606-1.01.152-.44.229-.906.229-1.398 0-.665-.261-.997-.783-.997Zm2.98 4.284h-.738l1.028-4.816h.738l-1.028 4.816Zm.496-6.047c0-.164.047-.297.141-.399a.464.464 0 0 1 .365-.159c.258 0 .387.132.387.396 0 .161-.05.297-.15.408a.434.434 0 0 1-.338.167.412.412 0 0 1-.29-.105.408.408 0 0 1-.115-.308Zm2.527 5.533c.161 0 .372-.038.633-.114v.567c-.1.041-.223.076-.369.105a1.84 1.84 0 0 1-.352.044c-.366 0-.647-.086-.843-.259-.194-.176-.29-.437-.29-.782 0-.194.026-.413.079-.66l.558-2.645h-.756l.061-.321.813-.343.55-1.002h.43l-.241 1.108h1.204l-.114.558h-1.2l-.567 2.654a3.11 3.11 0 0 0-.079.58c0 .164.042.29.127.378a.472.472 0 0 0 .356.132Zm4.487-4.39c.202 0 .378.02.527.062l-.158.659a1.933 1.933 0 0 0-.461-.057 1.23 1.23 0 0 0-.752.263 2.342 2.342 0 0 0-.61.734 3.735 3.735 0 0 0-.383 1.037l-.47 2.206h-.738l1.028-4.816h.611l-.097.892h.044a4.19 4.19 0 0 1 .523-.598 1.61 1.61 0 0 1 .431-.281c.152-.067.321-.101.505-.101Zm3.072 0c.269 0 .51.073.721.22.211.143.375.351.492.624h.048l.295-.756h.558l-1.024 4.816h-.585l.114-.918h-.035c-.524.671-1.076 1.006-1.656 1.006-.408 0-.727-.145-.958-.435-.232-.29-.348-.687-.348-1.191 0-.609.104-1.175.312-1.696.208-.522.496-.93.862-1.226a1.872 1.872 0 0 1 1.204-.444Zm-.835 4.381c.284 0 .567-.134.848-.404.281-.272.51-.625.686-1.059a3.5 3.5 0 0 0 .263-1.31c0-.301-.082-.542-.246-.72a.834.834 0 0 0-.646-.268c-.305 0-.589.126-.852.378-.261.251-.466.593-.616 1.023a4.14 4.14 0 0 0-.224 1.363c0 .334.069.584.207.751.138.164.331.246.58.246Zm4.851.009c.162 0 .373-.038.633-.114v.567a1.979 1.979 0 0 1-.369.105c-.146.03-.264.044-.351.044-.367 0-.648-.086-.844-.259-.194-.176-.29-.437-.29-.782 0-.194.026-.413.079-.66l.558-2.645h-.756l.062-.321.813-.343.549-1.002h.431l-.242 1.108h1.204l-.114.558h-1.2l-.567 2.654a3.11 3.11 0 0 0-.079.58c0 .164.043.29.128.378a.468.468 0 0 0 .355.132Zm2.18.514h-.738l1.028-4.816h.738l-1.028 4.816Zm.497-6.047a.57.57 0 0 1 .14-.399.466.466 0 0 1 .365-.159c.258 0 .387.132.387.396 0 .161-.05.297-.15.408a.433.433 0 0 1-.338.167.412.412 0 0 1-.29-.105.407.407 0 0 1-.114-.308Zm3.616 1.169c.557 0 .997.166 1.319.497.322.328.483.781.483 1.358 0 .551-.105 1.071-.316 1.56-.211.489-.497.867-.857 1.134-.36.266-.768.4-1.222.4-.562 0-1.003-.166-1.323-.497-.319-.331-.479-.784-.479-1.358 0-.557.107-1.079.321-1.569.214-.492.503-.868.866-1.129a2.007 2.007 0 0 1 1.208-.396Zm1.038 1.754c0-.337-.093-.61-.277-.818-.182-.211-.43-.316-.743-.316-.319 0-.606.108-.861.325-.252.217-.449.519-.589.905a3.776 3.776 0 0 0-.207 1.284c0 .383.093.681.277.892.188.208.456.312.804.312.305 0 .579-.107.822-.321.243-.214.432-.517.567-.91.138-.395.207-.846.207-1.353Zm4.394 3.124.65-3.041c.059-.304.088-.515.088-.633a.615.615 0 0 0-.158-.443c-.102-.112-.268-.167-.496-.167-.261 0-.516.088-.765.263a2.398 2.398 0 0 0-.655.752 4.014 4.014 0 0 0-.426 1.182l-.444 2.087h-.738l1.028-4.816h.611l-.097.892h.044c.281-.357.552-.609.813-.756.264-.149.536-.224.818-.224.372 0 .665.103.878.308.217.202.326.486.326.852 0 .232-.034.495-.101.791l-.629 2.953h-.747Zm3.872 2.162c-.202 0-.386-.03-.55-.092v-.62c.188.065.352.097.493.097a.582.582 0 0 0 .514-.272c.12-.182.216-.441.29-.778l.997-4.755h-.848l.057-.294.906-.29.101-.44c.134-.586.32-.999.558-1.239.24-.243.594-.365 1.063-.365.117 0 .261.018.431.053.17.032.302.069.395.11l-.189.567a1.707 1.707 0 0 0-.602-.128c-.255 0-.451.072-.589.215-.134.141-.244.4-.329.778l-.11.475h1.046l-.11.558h-1.041l-1.02 4.825c-.114.554-.29.958-.527 1.213-.238.255-.55.382-.936.382Zm5.44-2.074c-.539 0-.962-.159-1.27-.479-.308-.319-.461-.762-.461-1.327 0-.551.108-1.078.325-1.582.22-.507.51-.901.87-1.182.36-.281.757-.422 1.191-.422.448 0 .785.098 1.011.294.225.194.338.465.338.813 0 .528-.243.942-.729 1.244-.487.299-1.183.448-2.088.448h-.145l-.017.352c0 .384.089.684.268.901.181.214.461.321.839.321.184 0 .373-.027.567-.08.196-.052.439-.149.729-.29v.642a3.845 3.845 0 0 1-.729.268 2.87 2.87 0 0 1-.699.079Zm.611-4.364c-.302 0-.586.138-.853.413-.263.276-.465.658-.606 1.147h.053c.668 0 1.179-.086 1.533-.259.358-.176.537-.429.537-.76a.513.513 0 0 0-.163-.387c-.106-.102-.273-.154-.501-.154Zm3.828 4.364c-.539 0-.963-.159-1.27-.479-.308-.319-.462-.762-.462-1.327 0-.551.109-1.078.325-1.582.22-.507.51-.901.87-1.182a1.896 1.896 0 0 1 1.191-.422c.449 0 .786.098 1.011.294.226.194.338.465.338.813 0 .528-.243.942-.729 1.244-.486.299-1.182.448-2.087.448h-.145l-.018.352c0 .384.089.684.268.901.182.214.461.321.839.321.185 0 .374-.027.567-.08.197-.052.44-.149.73-.29v.642a3.876 3.876 0 0 1-.73.268 2.867 2.867 0 0 1-.698.079Zm.61-4.364c-.301 0-.586.138-.852.413-.264.276-.466.658-.607 1.147h.053c.668 0 1.179-.086 1.534-.259.357-.176.536-.429.536-.76a.51.51 0 0 0-.163-.387c-.105-.102-.272-.154-.501-.154Zm4.896 2.91c0 .457-.163.814-.488 1.072-.322.255-.778.382-1.367.382-.495 0-.941-.101-1.34-.303v-.694c.205.123.426.218.664.285.237.068.457.101.659.101.369 0 .647-.073.835-.219a.685.685 0 0 0 .281-.563.607.607 0 0 0-.154-.422c-.102-.114-.323-.271-.663-.47-.381-.214-.651-.423-.809-.628a1.162 1.162 0 0 1-.237-.73c0-.404.148-.729.444-.975.296-.25.685-.374 1.169-.374.501 0 .984.108 1.45.325l-.238.602-.246-.11a2.44 2.44 0 0 0-.966-.189c-.273 0-.487.065-.642.194a.605.605 0 0 0-.233.492c0 .164.051.305.154.422.105.117.321.268.646.452.313.176.537.327.672.453.138.126.24.262.308.409.067.143.101.306.101.488Z",
                className: "what-do-i-need_svg__path-13"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("rect", {
                x: 35,
                y: 64.106,
                width: 65.261,
                height: 25.815,
                rx: 12.908,
                className: "what-do-i-need_svg__rect-6"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__f)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m50.99 71.606 6.215.277 2.516 5.592-3.55 5.11-6.249-.4-2.562-6.058 3.63-4.521Zm4.556 3.223-4.504 1.968 3.85 2.978.654-4.946Zm-.521-.987-3.6-1.55-.756 3.26 4.356-1.71Zm-.913 6.682L50.2 77.73l.095 3.786 3.817-.992Zm4.984-3.061-2.666-2.706-.704 5.203 3.37-2.497Zm-4.067 3.67-3.299.862 3.88.249-.58-1.111Zm3.546-2.443-2.888 2.152.574 1.122 2.314-3.274Zm-1.366-6.025-.561 1.151 2.088 2.123-1.527-3.274Zm-.7-.552-3.666-.148 3.025 1.323.642-1.175Zm-6.055.533-2.568 3.244 1.717.363.851-3.607ZM49.5 76.89l-1.725-.366 1.8 4.242-.075-3.876Z",
                    className: "what-do-i-need_svg__path-14"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M71.858 76.04c0 .782-.268 1.384-.803 1.807-.532.419-1.294.628-2.287.628h-.908v3.037h-.898V73.79h2.002c1.93 0 2.894.75 2.894 2.25Zm-3.998 1.664h.808c.796 0 1.371-.128 1.727-.385.356-.257.533-.67.533-1.236 0-.51-.167-.89-.501-1.14-.335-.25-.856-.376-1.564-.376H67.86v3.137Zm11.65 3.808h-1.025l-4.22-6.48h-.041c.056.76.084 1.458.084 2.091v4.389h-.829V73.79h1.014l4.209 6.453h.042c-.007-.095-.023-.4-.047-.913a16.04 16.04 0 0 1-.027-1.11v-4.43h.84v7.72Zm7.7 0h-1.057l-2.815-3.745-.807.719v3.026h-.898V73.79h.898v3.829l3.5-3.829h1.062l-3.105 3.353 3.221 4.368Z",
                className: "what-do-i-need_svg__path-15"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M105.984 82.174c-.202 0-.385-.03-.549-.093v-.62c.188.065.352.098.492.098a.58.58 0 0 0 .514-.273c.121-.181.217-.44.291-.778l.997-4.755h-.848l.057-.294.905-.29.101-.44c.135-.585.321-.998.559-1.239.24-.243.594-.364 1.063-.364.117 0 .261.017.431.052.17.032.301.07.395.11l-.189.567a1.705 1.705 0 0 0-.602-.127c-.255 0-.451.071-.589.215-.134.14-.244.4-.329.778l-.11.474h1.046l-.11.558h-1.042l-1.019 4.826c-.114.553-.29.958-.528 1.213-.237.254-.549.382-.936.382Zm6.104-7.04c.557 0 .997.165 1.319.496.322.329.483.781.483 1.358 0 .551-.105 1.071-.316 1.56-.211.49-.497.867-.857 1.134-.36.267-.768.4-1.222.4-.562 0-1.003-.165-1.323-.497-.319-.33-.479-.783-.479-1.357 0-.557.107-1.08.321-1.57.214-.492.503-.868.866-1.129a2.009 2.009 0 0 1 1.208-.395Zm1.038 1.753c0-.337-.093-.61-.277-.817-.182-.211-.43-.317-.743-.317-.319 0-.606.109-.861.326-.252.216-.449.518-.589.905a3.771 3.771 0 0 0-.207 1.283c0 .384.093.681.277.892.188.208.456.312.804.312.305 0 .579-.107.822-.32.243-.215.432-.518.567-.91.138-.396.207-.847.207-1.354Zm4.495-1.78c.202 0 .378.02.527.062l-.158.66a1.928 1.928 0 0 0-.461-.058c-.267 0-.517.088-.752.264-.231.175-.435.42-.61.734a3.73 3.73 0 0 0-.383 1.037l-.47 2.206h-.738l1.028-4.817h.611l-.097.892h.044a4.18 4.18 0 0 1 .523-.597c.138-.123.281-.217.431-.281.152-.068.321-.102.505-.102Zm5.832 3.538c0 .457-.163.815-.488 1.072-.322.255-.778.383-1.367.383-.495 0-.942-.101-1.34-.304v-.694c.205.123.426.218.663.286.238.067.457.1.66.1.369 0 .647-.073.835-.219a.684.684 0 0 0 .281-.563.607.607 0 0 0-.154-.421c-.103-.115-.324-.271-.664-.47-.38-.214-.65-.424-.808-.629a1.16 1.16 0 0 1-.237-.73c0-.404.148-.729.443-.975.296-.25.686-.374 1.169-.374.501 0 .985.109 1.451.326l-.238.602-.246-.11a2.442 2.442 0 0 0-.967-.19c-.272 0-.486.065-.641.194a.602.602 0 0 0-.233.492c0 .164.051.305.154.422.105.117.32.268.646.453.313.176.537.327.672.453.138.126.24.262.308.408.067.144.101.306.101.488Zm2.364.853c.161 0 .372-.038.633-.115v.567c-.1.041-.223.076-.369.106-.147.029-.264.044-.352.044-.366 0-.647-.087-.844-.26-.193-.175-.29-.436-.29-.782 0-.193.027-.413.079-.66l.558-2.645h-.755l.061-.32.813-.343.549-1.002h.431l-.242 1.107h1.205l-.115.558h-1.199l-.567 2.655a3.102 3.102 0 0 0-.079.58c0 .164.042.29.127.378a.473.473 0 0 0 .356.132Zm3.99-4.39c.27 0 .51.073.721.22.211.143.375.35.492.623h.048l.295-.756h.558l-1.024 4.817h-.584l.114-.919h-.035c-.525.671-1.077 1.007-1.657 1.007-.407 0-.727-.145-.958-.435-.232-.29-.347-.688-.347-1.191 0-.61.104-1.175.312-1.697.208-.521.495-.93.861-1.226a1.874 1.874 0 0 1 1.204-.444Zm-.835 4.38c.284 0 .567-.134.848-.403.282-.273.51-.626.686-1.06a3.48 3.48 0 0 0 .264-1.31c0-.3-.082-.541-.247-.72a.834.834 0 0 0-.645-.268c-.305 0-.589.126-.853.378-.261.252-.466.593-.615 1.024-.15.43-.224.885-.224 1.362 0 .334.068.585.206.752.138.164.331.246.58.246Zm4.566-1.933 2.312-2.36h.883l-2.061 2.053 1.296 2.764h-.821l-1.033-2.303-.668.54-.36 1.763h-.748l1.451-6.838h.747l-.567 2.645c-.167.78-.317 1.358-.448 1.736h.017Zm3.942 2.457h-.738l1.028-4.817h.738l-1.028 4.817Zm.497-6.047c0-.164.046-.297.14-.4a.467.467 0 0 1 .365-.158c.258 0 .387.132.387.395a.59.59 0 0 1-.15.409.435.435 0 0 1-.338.167.41.41 0 0 1-.29-.106.407.407 0 0 1-.114-.307Zm3.994 6.047.651-3.041c.058-.305.088-.516.088-.633a.617.617 0 0 0-.159-.444c-.102-.111-.268-.167-.496-.167-.261 0-.516.088-.765.264a2.391 2.391 0 0 0-.655.751c-.187.325-.329.72-.426 1.182l-.444 2.088h-.738l1.028-4.817h.611l-.097.892h.044c.282-.357.553-.609.813-.755.264-.15.536-.225.818-.225.372 0 .665.103.879.308.216.202.325.486.325.853 0 .231-.034.495-.101.79l-.629 2.954h-.747Zm6.825-4.817-.11.47-.927.106c.12.182.18.413.18.694 0 .56-.171 1.007-.514 1.34-.34.332-.796.497-1.367.497-.161 0-.284-.012-.369-.035-.407.155-.611.347-.611.576 0 .12.049.2.145.242.097.038.238.068.422.092l.514.061c.531.065.914.194 1.152.387.24.193.36.478.36.853 0 .539-.214.956-.642 1.252-.427.296-1.029.444-1.806.444-.568 0-1.013-.109-1.336-.325a1.03 1.03 0 0 1-.483-.91c0-.308.105-.574.316-.8.211-.225.553-.417 1.024-.575-.228-.12-.343-.298-.343-.532 0-.202.075-.375.225-.519.149-.146.357-.282.624-.409a1.152 1.152 0 0 1-.453-.413 1.173 1.173 0 0 1-.176-.641c0-.569.174-1.034.523-1.398.352-.363.8-.545 1.345-.545.228 0 .454.03.677.088h1.63Zm-4.68 5.674a.62.62 0 0 0 .285.536c.191.132.474.198.849.198.533 0 .949-.094 1.248-.282.301-.184.452-.447.452-.786a.493.493 0 0 0-.237-.431c-.158-.105-.428-.179-.809-.22l-.698-.07c-.352.073-.621.202-.809.387a.905.905 0 0 0-.281.668Zm1.221-3.846c0 .25.066.44.198.572.132.129.315.193.55.193.231 0 .433-.061.606-.184s.305-.292.395-.506c.094-.217.141-.451.141-.703 0-.24-.064-.423-.193-.55-.129-.125-.314-.188-.554-.188-.228 0-.429.06-.602.18-.17.117-.303.283-.4.496-.094.211-.141.441-.141.69Z",
                className: "what-do-i-need_svg__path-16"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M159.07 77.335h2.176v.728h-2.176v2.25h-.734v-2.25h-2.165v-.728h2.165v-2.26h.734v2.26Z",
                className: "what-do-i-need_svg__path-17"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M38.977 166.22c-.725 0-1.295.257-1.71.771-.416.514-.624 1.223-.624 2.128 0 .947.2 1.663.597 2.149.401.486.98.729 1.737.729.328 0 .645-.032.951-.095.306-.067.625-.151.956-.253v1.082c-.606.229-1.292.343-2.06.343-1.13 0-1.998-.341-2.603-1.024-.606-.687-.908-1.667-.908-2.942 0-.802.146-1.505.438-2.107a3.16 3.16 0 0 1 1.278-1.383c.556-.321 1.21-.481 1.959-.481.789 0 1.517.166 2.186.497l-.454 1.05a6.537 6.537 0 0 0-.829-.322 2.904 2.904 0 0 0-.914-.142Zm8.619 3.818c0 .954-.245 1.699-.734 2.234-.49.535-1.17.802-2.044.802-.546 0-1.028-.123-1.447-.369a2.446 2.446 0 0 1-.966-1.062c-.226-.461-.338-.996-.338-1.605 0-.947.243-1.687.728-2.218.486-.532 1.171-.798 2.055-.798.845 0 1.514.273 2.006.819.493.542.74 1.274.74 2.197Zm-4.251 0c0 1.348.498 2.022 1.494 2.022.986 0 1.479-.674 1.479-2.022 0-1.334-.496-2.002-1.49-2.002-.52 0-.899.173-1.135.518-.232.345-.348.84-.348 1.484Zm10.82 2.931H52.92v-3.591c0-.451-.091-.787-.275-1.009-.18-.222-.466-.333-.86-.333-.525 0-.909.155-1.152.465-.242.31-.364.829-.364 1.558v2.91h-1.241v-5.841h.972l.174.766h.063c.176-.278.426-.493.75-.644a2.504 2.504 0 0 1 1.078-.228c1.4 0 2.101.713 2.101 2.139v3.808Zm3.903-.898c.303 0 .605-.048.908-.143v.935c-.137.06-.315.109-.533.148a3.489 3.489 0 0 1-.67.063c-1.177 0-1.765-.619-1.765-1.859v-3.147h-.797v-.549l.855-.454.423-1.236h.766v1.299h1.663v.94h-1.663v3.126c0 .3.074.521.221.666.152.141.349.211.592.211Zm5.043-5.049a3 3 0 0 1 .618.053l-.121 1.157a2.359 2.359 0 0 0-.55-.064c-.496 0-.9.162-1.209.486-.306.324-.46.745-.46 1.262v3.053h-1.24v-5.841h.971l.164 1.03h.063c.194-.349.446-.625.755-.829.314-.204.65-.307 1.01-.307Zm2.947 5.947h-1.241v-5.841h1.24v5.841Zm-1.315-7.388c0-.222.06-.393.18-.512.123-.12.297-.18.522-.18.219 0 .388.06.507.18.124.119.185.29.185.512 0 .211-.061.378-.185.501-.12.12-.288.18-.507.18-.225 0-.4-.06-.522-.18-.12-.123-.18-.29-.18-.501Zm6.078 1.441c.73 0 1.296.264 1.7.793.41.528.613 1.269.613 2.223 0 .957-.206 1.704-.618 2.239-.411.532-.984.797-1.716.797-.74 0-1.313-.265-1.721-.797h-.085l-.227.692h-.93v-8.217h1.242v1.954c0 .144-.007.359-.021.644-.015.285-.025.466-.032.544h.053c.394-.581.975-.872 1.742-.872Zm-.322 1.014c-.5 0-.86.148-1.082.444-.219.292-.331.783-.338 1.473v.085c0 .711.112 1.227.338 1.547.225.317.593.475 1.103.475.44 0 .773-.174.998-.522.23-.349.344-.852.344-1.511 0-1.327-.454-1.991-1.363-1.991Zm8.196 4.933-.174-.766h-.064a1.759 1.759 0 0 1-.739.639c-.317.155-.68.232-1.088.232-.707 0-1.235-.176-1.584-.528-.349-.352-.523-.885-.523-1.6v-3.818h1.252v3.602c0 .447.091.783.274 1.008.183.222.47.333.861.333.521 0 .903-.155 1.146-.465.247-.313.37-.836.37-1.568v-2.91h1.246v5.841h-.977Zm4.922-.898c.303 0 .605-.048.908-.143v.935c-.137.06-.315.109-.533.148a3.487 3.487 0 0 1-.67.063c-1.177 0-1.765-.619-1.765-1.859v-3.147h-.797v-.549l.855-.454.423-1.236h.766v1.299h1.663v.94h-1.663v3.126c0 .3.074.521.221.666.152.141.35.211.592.211Zm7.261-2.033c0 .954-.244 1.699-.734 2.234-.49.535-1.17.802-2.044.802-.545 0-1.027-.123-1.447-.369a2.446 2.446 0 0 1-.966-1.062c-.225-.461-.338-.996-.338-1.605 0-.947.243-1.687.729-2.218.486-.532 1.17-.798 2.054-.798.845 0 1.514.273 2.007.819.493.542.74 1.274.74 2.197Zm-4.25 0c0 1.348.497 2.022 1.494 2.022.985 0 1.478-.674 1.478-2.022 0-1.334-.496-2.002-1.489-2.002-.521 0-.9.173-1.135.518-.233.345-.349.84-.349 1.484Zm8.644-3.016a3 3 0 0 1 .618.053l-.122 1.157a2.36 2.36 0 0 0-.549-.064c-.496 0-.9.162-1.21.486-.305.324-.459.745-.459 1.262v3.053h-1.24v-5.841h.971l.164 1.03h.063c.194-.349.446-.625.755-.829.314-.204.65-.307 1.009-.307Zm5.629 4.283c0 .571-.207 1.009-.623 1.315-.415.303-1.01.454-1.785.454-.778 0-1.403-.118-1.874-.353v-1.072c.686.316 1.325.475 1.917.475.763 0 1.145-.231 1.145-.692a.55.55 0 0 0-.126-.37 1.52 1.52 0 0 0-.417-.306 7.151 7.151 0 0 0-.808-.359c-.673-.261-1.129-.521-1.368-.782-.236-.26-.354-.598-.354-1.014 0-.499.2-.887.602-1.161.405-.278.954-.418 1.648-.418.686 0 1.336.14 1.948.418l-.401.934c-.63-.26-1.16-.39-1.59-.39-.654 0-.982.186-.982.559 0 .183.085.338.254.465.172.127.545.301 1.12.523.482.186.832.357 1.05.512.218.155.38.335.486.539.106.2.158.442.158.723Z",
                className: "what-do-i-need_svg__path-18"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M112.744 172.969v-3.744c0-.472-.108-.824-.322-1.057-.215-.232-.551-.348-1.009-.348-.606 0-1.049.164-1.331.491-.281.327-.422.868-.422 1.621v3.037h-.877v-5.788h.713l.143.792h.042a1.77 1.77 0 0 1 .755-.66 2.425 2.425 0 0 1 1.083-.238c.697 0 1.221.169 1.573.507.352.335.528.872.528 1.611v3.776h-.876Zm5.128.105c-.856 0-1.532-.26-2.028-.781-.493-.521-.74-1.245-.74-2.171 0-.933.229-1.674.687-2.223.461-.549 1.079-.824 1.853-.824.726 0 1.3.24 1.722.718.423.476.634 1.104.634 1.886v.554h-3.987c.017.68.188 1.195.512 1.548.327.352.787.528 1.378.528.623 0 1.239-.131 1.849-.391v.781c-.31.134-.604.229-.882.286a4.832 4.832 0 0 1-.998.089Zm-.238-5.265c-.465 0-.836.152-1.114.454-.275.303-.437.722-.486 1.257h3.026c0-.552-.123-.975-.37-1.267-.246-.296-.598-.444-1.056-.444Zm6.311 5.265c-.856 0-1.532-.26-2.028-.781-.493-.521-.74-1.245-.74-2.171 0-.933.229-1.674.687-2.223.461-.549 1.079-.824 1.854-.824.725 0 1.299.24 1.721.718.423.476.634 1.104.634 1.886v.554h-3.987c.017.68.188 1.195.512 1.548.327.352.787.528 1.378.528.623 0 1.24-.131 1.849-.391v.781c-.31.134-.604.229-.882.286a4.832 4.832 0 0 1-.998.089Zm-.238-5.265c-.465 0-.836.152-1.114.454-.275.303-.437.722-.486 1.257h3.026c0-.552-.123-.975-.37-1.267-.246-.296-.598-.444-1.056-.444Zm7.805 4.383h-.047c-.405.588-1.011.882-1.817.882-.757 0-1.347-.258-1.769-.776-.419-.517-.629-1.253-.629-2.207s.212-1.696.634-2.224c.423-.528 1.011-.792 1.764-.792.785 0 1.387.285 1.806.856h.069l-.037-.417-.021-.407v-2.355h.876v8.217h-.713l-.116-.777Zm-1.753.148c.598 0 1.031-.162 1.299-.486.271-.327.407-.853.407-1.579v-.184c0-.821-.138-1.405-.412-1.754-.271-.352-.706-.528-1.305-.528-.514 0-.908.201-1.183.602-.271.398-.406.961-.406 1.69 0 .74.135 1.298.406 1.674.271.377.669.565 1.194.565Zm10.815.629-.174-.824h-.042c-.289.363-.578.609-.866.739-.286.127-.643.19-1.072.19-.574 0-1.025-.147-1.352-.443-.324-.296-.486-.717-.486-1.262 0-1.169.935-1.782 2.804-1.838l.982-.032v-.359c0-.454-.098-.789-.295-1.003-.194-.219-.506-.328-.935-.328-.483 0-1.028.148-1.637.444l-.27-.671c.286-.155.597-.276.935-.364a4.095 4.095 0 0 1 1.025-.132c.69 0 1.2.153 1.531.459.335.307.502.798.502 1.474v3.95h-.65Zm-1.98-.618c.546 0 .973-.15 1.283-.449.313-.299.47-.718.47-1.257v-.523l-.877.037c-.697.025-1.2.134-1.51.328-.306.19-.459.487-.459.892 0 .317.095.558.285.724.194.165.463.248.808.248Zm11.977.618-1.061-3.396a28.52 28.52 0 0 1-.375-1.415h-.043a19.938 19.938 0 0 1-.369 1.426l-1.094 3.385h-1.013l-1.579-5.788h.918c.374 1.454.657 2.561.851 3.322.197.76.309 1.272.338 1.536h.042c.039-.2.1-.459.185-.776.088-.32.163-.574.227-.76l1.061-3.322h.951l1.035 3.322c.197.605.331 1.114.401 1.526h.042c.015-.127.052-.322.111-.586.064-.264.432-1.685 1.104-4.262h.908l-1.6 5.788h-1.04Zm7.251 0-.175-.824h-.042c-.289.363-.577.609-.866.739-.285.127-.642.19-1.072.19-.574 0-1.024-.147-1.352-.443-.324-.296-.486-.717-.486-1.262 0-1.169.935-1.782 2.804-1.838l.983-.032v-.359c0-.454-.099-.789-.296-1.003-.194-.219-.505-.328-.935-.328-.482 0-1.028.148-1.637.444l-.269-.671c.285-.155.597-.276.935-.364a4.087 4.087 0 0 1 1.024-.132c.69 0 1.201.153 1.532.459.334.307.501.798.501 1.474v3.95h-.649Zm-1.981-.618c.546 0 .974-.15 1.284-.449.313-.299.47-.718.47-1.257v-.523l-.877.037c-.697.025-1.201.134-1.51.328-.307.19-.46.487-.46.892 0 .317.095.558.285.724.194.165.463.248.808.248Zm5.318.618h-.876v-8.217h.876v8.217Zm2.736 0h-.877v-8.217h.877v8.217Zm4.304.105c-.856 0-1.532-.26-2.028-.781-.493-.521-.74-1.245-.74-2.171 0-.933.229-1.674.687-2.223.461-.549 1.079-.824 1.854-.824.725 0 1.299.24 1.721.718.423.476.634 1.104.634 1.886v.554h-3.987c.017.68.188 1.195.512 1.548.327.352.787.528 1.378.528.623 0 1.24-.131 1.849-.391v.781c-.31.134-.604.229-.882.286a4.832 4.832 0 0 1-.998.089Zm-.238-5.265c-.465 0-.836.152-1.114.454-.275.303-.437.722-.486 1.257h3.026c0-.552-.123-.975-.37-1.267-.246-.296-.598-.444-1.056-.444Zm5.735 4.542c.155 0 .305-.011.449-.032.144-.024.259-.049.343-.074v.671a1.54 1.54 0 0 1-.422.111 2.904 2.904 0 0 1-.497.047c-1.119 0-1.679-.589-1.679-1.769v-3.443h-.829v-.422l.829-.365.37-1.235h.507v1.341h1.679v.681h-1.679v3.406c0 .349.082.616.248.803.165.187.392.28.681.28Z",
                className: "what-do-i-need_svg__path-19"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__g)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M191.849 163.062a.773.773 0 1 1 0 1.546h-8.884a.386.386 0 0 0 0 .772h8.884c.852 0 1.545.693 1.545 1.545v5.408c0 .852-.693 1.545-1.545 1.545h-9.27a1.545 1.545 0 0 1-1.545-1.545v-7.725c0-.854.691-1.546 1.545-1.546h9.27Zm-.772 7.339a.772.772 0 1 0 0-1.546.772.772 0 0 0 0 1.546Z",
                    className: "what-do-i-need_svg__path-20"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m205.23 172.969-1.061-3.396a28.52 28.52 0 0 1-.375-1.415h-.042a19.842 19.842 0 0 1-.37 1.426l-1.093 3.385h-1.014l-1.579-5.788h.919l.85 3.322c.197.76.31 1.272.338 1.536h.042a14.331 14.331 0 0 1 .412-1.536l1.062-3.322h.95l1.035 3.322c.197.605.331 1.114.401 1.526h.043c.014-.127.051-.322.111-.586.063-.264.431-1.685 1.103-4.262h.909l-1.6 5.788h-1.041Zm4.568 0h-.876v-5.788h.876v5.788Zm-.95-7.357c0-.2.049-.346.147-.438a.512.512 0 0 1 .37-.142c.141 0 .262.047.365.142.102.095.153.241.153.438 0 .198-.051.345-.153.444a.52.52 0 0 1-.365.143.513.513 0 0 1-.37-.143c-.098-.099-.147-.246-.147-.444Zm4.679 6.739c.154 0 .304-.011.448-.032.145-.024.259-.049.344-.074v.671a1.54 1.54 0 0 1-.423.111 2.894 2.894 0 0 1-.496.047c-1.12 0-1.68-.589-1.68-1.769v-3.443h-.829v-.422l.829-.365.37-1.235h.507v1.341h1.679v.681h-1.679v3.406c0 .349.083.616.248.803.166.187.393.28.682.28Zm5.914.618v-3.744c0-.472-.107-.824-.322-1.057-.215-.232-.551-.348-1.009-.348-.609 0-1.054.165-1.336.496-.278.331-.417.873-.417 1.627v3.026h-.877v-8.217h.877v2.487c0 .299-.014.547-.042.745h.053c.172-.279.417-.497.734-.655.32-.162.684-.243 1.093-.243.707 0 1.237.169 1.589.507.356.334.534.868.534 1.6v3.776h-.877Z",
                className: "what-do-i-need_svg__path-21"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M38.977 259.833c-.725 0-1.295.257-1.71.771-.416.514-.624 1.223-.624 2.128 0 .947.2 1.664.597 2.15.401.485.98.728 1.737.728.328 0 .645-.031.951-.095.306-.067.625-.151.956-.253v1.082c-.606.229-1.292.344-2.06.344-1.13 0-1.998-.342-2.603-1.025-.606-.686-.908-1.667-.908-2.941 0-.803.146-1.505.438-2.107a3.162 3.162 0 0 1 1.278-1.384c.556-.32 1.21-.481 1.959-.481.789 0 1.517.166 2.186.497l-.454 1.051a6.39 6.39 0 0 0-.829-.322 2.904 2.904 0 0 0-.914-.143Zm7.093 6.749-.248-.813h-.043c-.281.355-.565.598-.85.729-.285.126-.651.19-1.098.19-.574 0-1.023-.155-1.347-.465-.32-.31-.48-.748-.48-1.315 0-.602.223-1.056.67-1.362.447-.307 1.128-.474 2.044-.502l1.008-.032v-.311c0-.374-.088-.652-.264-.835-.172-.186-.442-.28-.808-.28-.299 0-.586.044-.86.132a6.442 6.442 0 0 0-.792.312l-.402-.887a4.202 4.202 0 0 1 1.04-.375 4.697 4.697 0 0 1 1.067-.132c.743 0 1.303.162 1.68.486.38.323.57.832.57 1.526v3.934h-.887Zm-1.849-.845c.451 0 .812-.125 1.083-.375.275-.253.412-.607.412-1.061v-.507l-.75.031c-.584.022-1.01.12-1.278.296-.264.173-.396.438-.396.798 0 .26.077.463.232.607.155.141.387.211.697.211Zm8.392-.818c0 .57-.208 1.008-.623 1.314-.416.303-1.01.455-1.785.455-.778 0-1.403-.118-1.875-.354v-1.072c.686.317 1.325.475 1.917.475.764 0 1.146-.231 1.146-.692a.545.545 0 0 0-.127-.369 1.5 1.5 0 0 0-.417-.307 7.337 7.337 0 0 0-.808-.359c-.672-.26-1.128-.521-1.368-.781-.236-.261-.354-.599-.354-1.014 0-.5.201-.887.602-1.162.405-.278.955-.417 1.648-.417.686 0 1.336.139 1.949.417l-.402.935c-.63-.261-1.16-.391-1.59-.391-.654 0-.982.186-.982.56 0 .183.085.338.254.464.172.127.546.301 1.12.523.482.187.832.357 1.05.512.219.155.38.335.486.539.106.201.159.442.159.724Zm3.897 1.769c-.908 0-1.62-.264-2.133-.792-.51-.532-.766-1.263-.766-2.192 0-.954.238-1.704.713-2.25.475-.545 1.128-.818 1.959-.818.771 0 1.38.234 1.827.702.447.468.67 1.113.67 1.933v.671H54.89c.017.566.17 1.003.46 1.309.288.303.695.454 1.22.454.344 0 .664-.031.96-.095.3-.067.62-.176.961-.327v1.009c-.302.144-.609.246-.919.306-.31.06-.663.09-1.061.09Zm-.227-5.112c-.394 0-.711.125-.95.375-.236.25-.377.614-.423 1.093h2.651c-.007-.483-.123-.847-.349-1.093-.225-.25-.535-.375-.929-.375Zm10.641 3.343c0 .57-.208 1.008-.623 1.314-.416.303-1.01.455-1.785.455-.778 0-1.403-.118-1.875-.354v-1.072c.687.317 1.326.475 1.917.475.764 0 1.146-.231 1.146-.692a.545.545 0 0 0-.127-.369 1.5 1.5 0 0 0-.417-.307 7.337 7.337 0 0 0-.808-.359c-.672-.26-1.128-.521-1.368-.781-.235-.261-.353-.599-.353-1.014 0-.5.2-.887.602-1.162.405-.278.954-.417 1.647-.417.687 0 1.336.139 1.949.417l-.401.935c-.63-.261-1.16-.391-1.59-.391-.655 0-.982.186-.982.56 0 .183.084.338.253.464.173.127.546.301 1.12.523.482.187.832.357 1.05.512.219.155.381.335.487.539.105.201.158.442.158.724Zm5.466 1.663-.174-.766h-.064a1.759 1.759 0 0 1-.74.639c-.316.155-.679.233-1.087.233-.708 0-1.236-.176-1.584-.528-.349-.353-.523-.886-.523-1.601v-3.818h1.251v3.602c0 .447.092.783.275 1.009.183.221.47.332.86.332.522 0 .904-.155 1.147-.464.246-.314.37-.837.37-1.569v-2.91h1.246v5.841h-.977Zm5.73-5.946c.728 0 1.295.264 1.7.792.408.528.613 1.269.613 2.223 0 .958-.206 1.704-.618 2.239-.412.532-.984.798-1.717.798-.739 0-1.313-.266-1.721-.798h-.085l-.227.692h-.93v-8.217h1.242v1.954c0 .144-.007.359-.021.644-.014.285-.025.467-.032.544h.053c.394-.581.975-.871 1.743-.871Zm-.323 1.014c-.5 0-.86.148-1.082.443-.218.292-.331.784-.338 1.474v.084c0 .711.113 1.227.338 1.547.225.317.593.476 1.103.476.44 0 .773-.175.999-.523.229-.349.343-.852.343-1.51 0-1.328-.454-1.991-1.363-1.991Zm9 4.932H85.55v-3.602c0-.447-.085-.779-.254-.998-.169-.221-.433-.332-.792-.332-.479 0-.83.156-1.056.47-.222.309-.333.827-.333 1.552v2.91h-1.24v-5.841h.971l.174.766h.064a1.62 1.62 0 0 1 .702-.644c.31-.152.65-.227 1.02-.227.897 0 1.492.306 1.784.919h.085a1.78 1.78 0 0 1 .728-.676 2.312 2.312 0 0 1 1.078-.243c.697 0 1.204.176 1.52.528.321.352.481.889.481 1.61v3.808h-1.24v-3.602c0-.447-.087-.779-.26-.998-.169-.221-.433-.332-.792-.332-.482 0-.836.151-1.061.454-.222.299-.333.76-.333 1.383v3.095Zm6.658 0h-1.24v-5.841h1.24v5.841Zm-1.315-7.388c0-.222.06-.393.18-.512.123-.12.297-.18.523-.18.218 0 .387.06.507.18.123.119.184.29.184.512 0 .211-.061.378-.184.502-.12.119-.289.179-.507.179-.226 0-.4-.06-.523-.179-.12-.124-.18-.291-.18-.502Zm5.27 6.49c.303 0 .606-.047.91-.142v.934c-.138.06-.316.11-.534.148a3.41 3.41 0 0 1-.671.064c-1.176 0-1.764-.62-1.764-1.859v-3.148h-.797v-.549l.855-.454.423-1.236h.766v1.299h1.663v.94h-1.663v3.127c0 .299.073.521.221.665.152.141.349.211.592.211Zm4.257 0c.303 0 .606-.047.908-.142v.934c-.137.06-.315.11-.533.148a3.41 3.41 0 0 1-.671.064c-1.175 0-1.763-.62-1.763-1.859v-3.148h-.798v-.549l.856-.454.422-1.236h.766v1.299h1.663v.94h-1.663v3.127c0 .299.074.521.222.665.151.141.348.211.591.211Zm4.632 1.004c-.909 0-1.62-.264-2.134-.792-.51-.532-.766-1.263-.766-2.192 0-.954.238-1.704.713-2.25.476-.545 1.129-.818 1.959-.818.771 0 1.381.234 1.828.702.447.468.67 1.113.67 1.933v.671h-3.892c.018.566.171 1.003.46 1.309.288.303.695.454 1.22.454.345 0 .665-.031.961-.095a5.23 5.23 0 0 0 .961-.327v1.009a3.832 3.832 0 0 1-.919.306c-.31.06-.664.09-1.061.09Zm-.228-5.112c-.394 0-.711.125-.95.375-.236.25-.377.614-.423 1.093h2.651c-.007-.483-.123-.847-.348-1.093-.225-.25-.535-.375-.93-.375Zm6.871-.94c.25 0 .456.017.618.053l-.122 1.156a2.357 2.357 0 0 0-.549-.063c-.496 0-.899.162-1.209.486-.307.323-.46.744-.46 1.262v3.052h-1.241v-5.841h.972l.164 1.03h.063c.194-.348.445-.625.755-.829.314-.204.65-.306 1.009-.306Z",
                className: "what-do-i-need_svg__path-22"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M125.744 266.582v-3.744c0-.472-.108-.824-.322-1.056-.215-.233-.551-.349-1.009-.349-.606 0-1.049.164-1.331.491-.281.328-.422.868-.422 1.622v3.036h-.877v-5.788h.713l.143.792h.042a1.77 1.77 0 0 1 .755-.66 2.438 2.438 0 0 1 1.083-.237c.697 0 1.221.169 1.573.506.352.335.528.872.528 1.611v3.776h-.876Zm5.128.106c-.856 0-1.532-.261-2.028-.782-.493-.521-.74-1.244-.74-2.17 0-.933.229-1.674.687-2.224.461-.549 1.079-.823 1.853-.823.726 0 1.3.239 1.722.718.423.475.634 1.103.634 1.885v.555h-3.987c.017.679.188 1.195.512 1.547.327.352.787.528 1.378.528.623 0 1.239-.13 1.849-.391v.782c-.31.133-.604.229-.882.285-.275.06-.608.09-.998.09Zm-.238-5.265c-.465 0-.836.151-1.114.454-.275.303-.437.721-.486 1.257h3.026c0-.553-.123-.976-.37-1.268-.246-.296-.598-.443-1.056-.443Zm6.311 5.265c-.856 0-1.532-.261-2.028-.782-.493-.521-.74-1.244-.74-2.17 0-.933.229-1.674.687-2.224.461-.549 1.079-.823 1.854-.823.725 0 1.299.239 1.721.718.423.475.634 1.103.634 1.885v.555h-3.987c.017.679.188 1.195.512 1.547.327.352.787.528 1.378.528.623 0 1.24-.13 1.849-.391v.782c-.31.133-.604.229-.882.285-.275.06-.608.09-.998.09Zm-.238-5.265c-.465 0-.836.151-1.114.454-.275.303-.437.721-.486 1.257h3.026c0-.553-.123-.976-.37-1.268-.246-.296-.598-.443-1.056-.443Zm7.805 4.383h-.047c-.405.588-1.011.882-1.817.882-.757 0-1.347-.259-1.769-.777-.419-.517-.629-1.253-.629-2.207s.212-1.695.634-2.223c.423-.528 1.011-.792 1.764-.792.785 0 1.387.285 1.806.855h.069l-.037-.417-.021-.407v-2.355h.876v8.217h-.713l-.116-.776Zm-1.753.148c.598 0 1.031-.162 1.299-.486.271-.328.407-.854.407-1.579v-.185c0-.82-.138-1.405-.412-1.753-.271-.352-.706-.528-1.305-.528-.514 0-.908.2-1.183.602-.271.397-.406.961-.406 1.689 0 .74.135 1.298.406 1.675.271.376.669.565 1.194.565Zm8.18-.951c0 .539-.201.954-.602 1.246-.401.293-.965.439-1.69.439-.767 0-1.366-.122-1.795-.365v-.813c.278.141.575.252.892.333.32.081.628.121.924.121.458 0 .81-.072 1.056-.216.247-.148.37-.372.37-.671 0-.225-.099-.417-.296-.576-.193-.162-.574-.352-1.14-.57-.539-.201-.923-.375-1.152-.523a1.633 1.633 0 0 1-.507-.512 1.346 1.346 0 0 1-.163-.681c0-.472.192-.843.575-1.115.384-.274.91-.411 1.579-.411.624 0 1.233.126 1.828.38l-.312.713c-.581-.24-1.107-.359-1.579-.359-.415 0-.729.065-.94.195-.211.13-.317.31-.317.539 0 .155.039.287.116.396.081.109.21.213.386.311.176.099.514.241 1.014.428.686.25 1.149.502 1.389.755.243.254.364.572.364.956Zm7.8 1.579-.174-.824h-.043c-.288.363-.577.609-.866.74-.285.126-.642.19-1.072.19-.574 0-1.024-.148-1.352-.444-.323-.296-.485-.716-.485-1.262 0-1.169.934-1.782 2.804-1.838l.982-.032v-.359c0-.454-.099-.788-.296-1.003-.193-.218-.505-.327-.934-.327-.483 0-1.029.147-1.638.443l-.269-.671a4.17 4.17 0 0 1 1.959-.496c.69 0 1.201.153 1.532.46.334.306.501.797.501 1.473v3.95h-.649Zm-1.98-.618c.545 0 .973-.149 1.283-.449.313-.299.47-.718.47-1.257v-.522l-.877.037c-.697.024-1.2.133-1.51.327-.306.19-.46.488-.46.892 0 .317.095.558.286.724.193.165.463.248.808.248Zm11.977.618-1.062-3.396a28.2 28.2 0 0 1-.375-1.415h-.042a19.186 19.186 0 0 1-.37 1.426l-1.093 3.385h-1.014l-1.579-5.788h.919c.373 1.454.657 2.561.85 3.322.198.76.31 1.273.338 1.537h.043a13.307 13.307 0 0 1 .412-1.537l1.061-3.322h.951l1.035 3.322c.197.605.331 1.114.401 1.526h.042c.014-.127.051-.322.111-.586.063-.264.431-1.685 1.104-4.262h.908l-1.6 5.788h-1.04Zm7.25 0-.174-.824h-.042c-.289.363-.577.609-.866.74-.285.126-.643.19-1.072.19-.574 0-1.025-.148-1.352-.444-.324-.296-.486-.716-.486-1.262 0-1.169.935-1.782 2.804-1.838l.982-.032v-.359c0-.454-.098-.788-.295-1.003-.194-.218-.505-.327-.935-.327-.482 0-1.028.147-1.637.443l-.269-.671a4.162 4.162 0 0 1 1.959-.496c.69 0 1.2.153 1.531.46.335.306.502.797.502 1.473v3.95h-.65Zm-1.98-.618c.546 0 .974-.149 1.283-.449.314-.299.47-.718.47-1.257v-.522l-.876.037c-.697.024-1.201.133-1.511.327-.306.19-.459.488-.459.892 0 .317.095.558.285.724.194.165.463.248.808.248Zm5.318.618h-.877v-8.217h.877v8.217Zm2.735 0h-.876v-8.217h.876v8.217Zm4.304.106c-.855 0-1.531-.261-2.027-.782-.493-.521-.74-1.244-.74-2.17 0-.933.229-1.674.687-2.224.461-.549 1.079-.823 1.853-.823.726 0 1.299.239 1.722.718.422.475.634 1.103.634 1.885v.555h-3.987c.017.679.188 1.195.512 1.547.327.352.787.528 1.378.528.623 0 1.239-.13 1.848-.391v.782a4.476 4.476 0 0 1-.882.285c-.274.06-.607.09-.998.09Zm-.237-5.265c-.465 0-.836.151-1.115.454-.274.303-.436.721-.485 1.257h3.026c0-.553-.124-.976-.37-1.268-.247-.296-.599-.443-1.056-.443Zm5.735 4.541a2.985 2.985 0 0 0 .792-.105v.67a1.54 1.54 0 0 1-.423.111 2.902 2.902 0 0 1-.496.048c-1.119 0-1.679-.59-1.679-1.769v-3.444h-.829v-.422l.829-.364.369-1.236h.507v1.341h1.68v.681h-1.68v3.407c0 .348.083.616.249.802.165.187.392.28.681.28Z",
                className: "what-do-i-need_svg__path-23"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#what-do-i-need_svg__h)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "M210.849 256.676a.773.773 0 1 1 0 1.545h-8.884a.387.387 0 0 0 0 .772h8.884c.852 0 1.545.693 1.545 1.545v5.408c0 .852-.693 1.545-1.545 1.545h-9.27a1.545 1.545 0 0 1-1.545-1.545v-7.725c0-.854.691-1.545 1.545-1.545h9.27Zm-.772 7.339a.771.771 0 1 0 0-1.545.771.771 0 1 0 0 1.545Z",
                    className: "what-do-i-need_svg__path-24"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m224.23 266.582-1.061-3.396a28.2 28.2 0 0 1-.375-1.415h-.042a19.7 19.7 0 0 1-.37 1.426l-1.093 3.385h-1.014l-1.579-5.788h.919l.85 3.322c.197.76.31 1.273.338 1.537h.042a14.331 14.331 0 0 1 .412-1.537l1.062-3.322h.95l1.035 3.322c.197.605.331 1.114.401 1.526h.043c.014-.127.051-.322.111-.586.063-.264.431-1.685 1.103-4.262h.909l-1.6 5.788h-1.041Zm4.568 0h-.876v-5.788h.876v5.788Zm-.95-7.356c0-.201.049-.347.147-.439a.512.512 0 0 1 .37-.142c.141 0 .262.047.365.142.102.095.153.242.153.439s-.051.345-.153.443a.52.52 0 0 1-.365.143.513.513 0 0 1-.37-.143c-.098-.098-.147-.246-.147-.443Zm4.679 6.738a2.972 2.972 0 0 0 .792-.105v.67a1.54 1.54 0 0 1-.423.111 2.902 2.902 0 0 1-.496.048c-1.12 0-1.68-.59-1.68-1.769v-3.444h-.829v-.422l.829-.364.37-1.236h.507v1.341h1.679v.681h-1.679v3.407c0 .348.083.616.248.802.166.187.393.28.682.28Zm5.914.618v-3.744c0-.472-.107-.824-.322-1.056-.215-.233-.551-.349-1.009-.349-.609 0-1.054.166-1.336.497-.278.33-.417.873-.417 1.626v3.026h-.877v-8.217h.877v2.487c0 .299-.014.548-.042.745h.053c.172-.278.417-.497.734-.655.32-.162.684-.243 1.093-.243.707 0 1.237.169 1.589.507.356.335.534.868.534 1.6v3.776h-.877Z",
                className: "what-do-i-need_svg__path-25"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(146.186 39.16)",
                            className: "what-do-i-need_svg__rect-7",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__c",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(47.36 101.348)",
                            className: "what-do-i-need_svg__rect-8",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__d",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(47.36 194.57)",
                            className: "what-do-i-need_svg__rect-9",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__e",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(47.36 288.184)",
                            className: "what-do-i-need_svg__rect-10",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__f",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(47.36 70.832)",
                            className: "what-do-i-need_svg__rect-11",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__g",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(181.034 162.289)",
                            className: "what-do-i-need_svg__rect-12",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "what-do-i-need_svg__h",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            transform: "translate(200.034 255.902)",
                            className: "what-do-i-need_svg__rect-13",
                            d: "M0 0h12.36v12.36H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("filter", {
                        id: "what-do-i-need_svg__a",
                        x: 0.682,
                        y: 0.227,
                        width: 298.194,
                        height: 347.635,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feOffset", {
                                dy: 1.545
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feGaussianBlur", {
                                stdDeviation: 1.159
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14063_184039"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14063_184039",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $82b8a4b7f29e274a$export$2e2bcd8739ae039 = $82b8a4b7f29e274a$var$SvgWhatDoINeed;



const $5d25e3bbfb185f64$var$StyledWhatDoINeedSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $82b8a4b7f29e274a$export$2e2bcd8739ae039))`
  [class$="rect-1"] {
    fill: ${({ theme: theme })=>theme.whiteBackground};
  }

  [class$="rect-2"] {
    stroke: ${({ theme: theme })=>theme.stroke};
  }

  [class$="rect-3"],
  [class$="rect-4"],
  [class$="rect-5"] {
    fill: ${({ theme: theme })=>theme.mediumBlue};
  }

  [class$="rect-6"] {
    fill: ${({ theme: theme })=>theme.mediumPurple};
  }

  [class$="rect-7"],
  [class$="rect-8"],
  [class$="rect-9"],
  [class$="rect-10"],
  [class$="rect-11"],
  [class$="rect-12"],
  [class$="rect-13"] {
    fill: ${({ theme: theme })=>theme.white};
  }

  [class$="path-1"],
  [class$="path-18"],
  [class$="path-22"] {
    fill: ${({ theme: theme })=>theme.primaryText};
  }

  [class$="path-2"],
  [class$="path-3"],
  [class$="path-4"],
  [class$="path-7"],
  [class$="path-10"],
  [class$="path-13"],
  [class$="path-16"],
  [class$="path-17"],
  [class$="path-19"],
  [class$="path-20"],
  [class$="path-21"],
  [class$="path-23"],
  [class$="path-24"],
  [class$="path-25"] {
    fill: ${({ theme: theme })=>theme.secondaryText};
  }

  [class$="path-5"],
  [class$="path-6"],
  [class$="path-8"],
  [class$="path-9"],
  [class$="path-11"],
  [class$="path-12"] {
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }

  [class$="path-14"],
  [class$="path-15"] {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $5d25e3bbfb185f64$var$WhatDoINeed = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$7722b1870d9eec03), {
        as: $5d25e3bbfb185f64$var$StyledWhatDoINeedSvg
    });
var $5d25e3bbfb185f64$export$2e2bcd8739ae039 = $5d25e3bbfb185f64$var$WhatDoINeed;


const $160529238ec58480$var$leftPageContents = [
    {
        title: "Welcome to Kleros Court",
        paragraphs: [
            "The decentralized arbitration service for the disputes of the new economy.",
            "Learn what\u2019s new"
        ],
        links: []
    },
    {
        title: "What do I need to start?",
        paragraphs: [
            "Do you want to be a juror? If yes, you will need PNK tokens for staking on courts, and ETH for gas fees.",
            "I don't want to be a juror. Can I still participate in the Court? Yes, sure. Users can also participate as contributors by helping fund appeal fees in exchange for rewards, or by submitting evidence. In this case, you will need ETH.",
            "I have a case that needs resolution? What do I do? It's simple. Send your case to Kleros and receive the resolution. You will need a few minutes to fill up the details of your case, and ETH to pay for Arbitration fees (It's used to pay jurors for their work)."
        ],
        links: []
    },
    {
        title: "Access the Mini Guides",
        paragraphs: [],
        links: [
            "1. Staking",
            "2. Binary Voting",
            "3. Ranked Voting",
            "4. Appeal",
            "5. Juror Levels"
        ]
    }
];
const $160529238ec58480$var$rightPageComponents = [
    (0, $6dca6073254c48cd$export$2e2bcd8739ae039),
    (0, $5d25e3bbfb185f64$export$2e2bcd8739ae039),
    (0, $1a59f7092a425f89$export$2e2bcd8739ae039)
];
const $160529238ec58480$var$Onboarding = ({ toggleMiniGuide: toggleMiniGuide })=>{
    const [isStakingMiniGuideOpen, toggleStakingMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isBinaryVotingMiniGuideOpen, toggleBinaryVotingMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isRankedVotingMiniGuideOpen, toggleRankedVotingMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isAppealMiniGuideOpen, toggleAppealMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isJurorLevelsMiniGuideOpen, toggleJurorLevelsMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const isAnyMiniGuideOpen = isStakingMiniGuideOpen || isBinaryVotingMiniGuideOpen || isRankedVotingMiniGuideOpen || isAppealMiniGuideOpen || isJurorLevelsMiniGuideOpen;
    const canCloseOnboarding = !isStakingMiniGuideOpen && !isBinaryVotingMiniGuideOpen && !isRankedVotingMiniGuideOpen && !isAppealMiniGuideOpen && !isJurorLevelsMiniGuideOpen;
    const toggleSubMiniGuide = (guideName)=>{
        if (guideName === "Staking") toggleStakingMiniGuide();
        else if (guideName === "Binary Voting") toggleBinaryVotingMiniGuide();
        else if (guideName === "Ranked Voting") toggleRankedVotingMiniGuide();
        else if (guideName === "Appeal") toggleAppealMiniGuide();
        else if (guideName === "Juror Levels") toggleJurorLevelsMiniGuide();
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8aa581884201f03c$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleMiniGuide,
                leftPageContents: $160529238ec58480$var$leftPageContents,
                rightPageComponents: $160529238ec58480$var$rightPageComponents,
                isOnboarding: true,
                canClose: canCloseOnboarding,
                isVisible: !isAnyMiniGuideOpen,
                toggleSubMiniGuide: toggleSubMiniGuide
            }),
            isStakingMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ac6168883415b9aa$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleStakingMiniGuide
            }),
            isBinaryVotingMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1458f55cef0c306d$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleBinaryVotingMiniGuide
            }),
            isRankedVotingMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3c906036f2372473$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleRankedVotingMiniGuide
            }),
            isAppealMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b1c183e8436a370c$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleAppealMiniGuide
            }),
            isJurorLevelsMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3641426bdc544c85$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleJurorLevelsMiniGuide
            })
        ]
    });
};
var $160529238ec58480$export$2e2bcd8739ae039 = $160529238ec58480$var$Onboarding;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $eUiaP = parcelRequire("eUiaP");
const $f9a008fec395d7ff$export$2a729c04c0770003 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            },
            {
                name: "_weth",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_action",
                internalType: "string",
                type: "string",
                indexed: true
            }
        ],
        name: "Action"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitrator",
        outputs: [
            {
                name: "",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitratorExtraData",
        outputs: [
            {
                name: "",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ],
        name: "changeArbitrator",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "changeArbitratorExtraData",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "changeDisputeTemplate",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ],
        name: "changeTemplateRegistry",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_action",
                internalType: "string",
                type: "string"
            },
            {
                name: "_feeInWeth",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDispute",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_action",
                internalType: "string",
                type: "string"
            }
        ],
        name: "createDispute",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputes",
        outputs: [
            {
                name: "isRuled",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "ruling",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "numberOfRulingOptions",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "externalIDtoLocalID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateId",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateRegistry",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "weth",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$b1c3f271a5b03251 = {
    421614: "0xe48488AE09022a4F32c528d7EbfF92870225AcBf"
};
const $f9a008fec395d7ff$export$7c21e73de0d6c738 = {
    address: $f9a008fec395d7ff$export$b1c3f271a5b03251,
    abi: $f9a008fec395d7ff$export$2a729c04c0770003
};
const $f9a008fec395d7ff$export$f0e1c8caa817fcf0 = [
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "randomNumbers",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_block",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "receiveRandomness",
        outputs: [
            {
                name: "randomNumber",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_block",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "requestRandomness",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$88d5a6a2ba9a9127 = {
    421614: "0x56d6d65Fe202232714794B5D5e4ed9894466Ee01"
};
const $f9a008fec395d7ff$export$a0fb1fd510ea2c1d = {
    address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127,
    abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0
};
const $f9a008fec395d7ff$export$527864715988df1d = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_name",
                internalType: "string",
                type: "string"
            },
            {
                name: "_symbol",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "spender",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Approval"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "to",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Transfer"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            },
            {
                name: "spender",
                internalType: "address",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                internalType: "uint8",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "subtractedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "addedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$62d6202aafa1805 = {
    421614: "0x593e89704D285B0c3fbF157c7CF2537456CE64b5"
};
const $f9a008fec395d7ff$export$93fdfcef6b42ad68 = {
    address: $f9a008fec395d7ff$export$62d6202aafa1805,
    abi: $f9a008fec395d7ff$export$527864715988df1d
};
const $f9a008fec395d7ff$export$8172254fb3ff28dc = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "amount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "balance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeAmount",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "request",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "token",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "withdraw",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "withdrewAlready",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$c4fe804a77f96bba = {
    421614: "0xB5b39A1bcD2D7097A8824B3cC18Ebd2dFb0D9B5E"
};
const $f9a008fec395d7ff$export$67b22b57e038c0b1 = {
    address: $f9a008fec395d7ff$export$c4fe804a77f96bba,
    abi: $f9a008fec395d7ff$export$8172254fb3ff28dc
};
const $f9a008fec395d7ff$export$9d92e3a5576cce40 = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            }
        ],
        name: "ChoiceFunded"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_juror",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_voteIDs",
                internalType: "uint256[]",
                type: "uint256[]",
                indexed: false
            },
            {
                name: "_commit",
                internalType: "bytes32",
                type: "bytes32",
                indexed: false
            }
        ],
        name: "CommitCast"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_contributor",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Contribution"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_numberOfChoices",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes",
                indexed: false
            }
        ],
        name: "DisputeCreation"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_juror",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_voteIDs",
                internalType: "uint256[]",
                type: "uint256[]",
                indexed: false
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_justification",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "VoteCast"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_contributor",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Withdrawal"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "LOSER_APPEAL_PERIOD_MULTIPLIER",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "LOSER_STAKE_MULTIPLIER",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "ONE_BASIS_POINT",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "WINNER_STAKE_MULTIPLIER",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "areCommitsAllCast",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "areVotesAllCast",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_voteIDs",
                internalType: "uint256[]",
                type: "uint256[]"
            },
            {
                name: "_commit",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "castCommit",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_voteIDs",
                internalType: "uint256[]",
                type: "uint256[]"
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_salt",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_justification",
                internalType: "string",
                type: "string"
            }
        ],
        name: "castVote",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_core",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeCore",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address payable",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "core",
        outputs: [
            {
                name: "",
                internalType: "contract KlerosCore",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "coreDisputeIDToLocal",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_numberOfChoices",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_nbVotes",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDispute",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "currentRuling",
        outputs: [
            {
                name: "ruling",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "tied",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "overridden",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputes",
        outputs: [
            {
                name: "numberOfChoices",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "jumped",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "extraData",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_nonce",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "draw",
        outputs: [
            {
                name: "drawnAddress",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_destination",
                internalType: "address",
                type: "address"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "executeGovernorProposal",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "fundAppeal",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getCoherentCount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_voteID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getDegreeOfCoherence",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getFundedChoices",
        outputs: [
            {
                name: "fundedChoices",
                internalType: "uint256[]",
                type: "uint256[]"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getRoundInfo",
        outputs: [
            {
                name: "winningChoice",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "tied",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "totalVoted",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "totalCommited",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "nbVoters",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "choiceCount",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_voteID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getVoteInfo",
        outputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            },
            {
                name: "commit",
                internalType: "bytes32",
                type: "bytes32"
            },
            {
                name: "choice",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "voted",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            },
            {
                name: "_core",
                internalType: "contract KlerosCore",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_voteID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "isVoteActive",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_beneficiary",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "_coreRoundID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_choice",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "withdrawFeesAndRewards",
        outputs: [
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$50ec6c3f9ccece46 = {
    421614: "0xd40aA608801a639E292e10C235B90488D04070b1"
};
const $f9a008fec395d7ff$export$971d3369f03b488b = {
    address: $f9a008fec395d7ff$export$50ec6c3f9ccece46,
    abi: $f9a008fec395d7ff$export$9d92e3a5576cce40
};
const $f9a008fec395d7ff$export$bcabc9035c41728d = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            },
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitrator",
        outputs: [
            {
                name: "",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "arbitratorDisputeIDToLocalID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ],
        name: "changeArbitrator",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ],
        name: "changeTemplateRegistry",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_disputeTemplate",
                internalType: "string",
                type: "string"
            },
            {
                name: "_disputeTemplateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "_numberOfRulingOptions",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDisputeForTemplate",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_disputeTemplateUri",
                internalType: "string",
                type: "string"
            },
            {
                name: "_numberOfRulingOptions",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDisputeForTemplateUri",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputes",
        outputs: [
            {
                name: "arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "isRuled",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "ruling",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "numberOfRulingOptions",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateRegistry",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$6f9cc1e72fe3b948 = {
    421614: "0xaBC213522c01354DC0Db2B3E89bDe0FCF44Acac6"
};
const $f9a008fec395d7ff$export$2e7fe97b6183325c = {
    address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948,
    abi: $f9a008fec395d7ff$export$bcabc9035c41728d
};
const $f9a008fec395d7ff$export$d1e10d5f7b143922 = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_templateTag",
                internalType: "string",
                type: "string",
                indexed: true
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeTemplate"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateTag",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "setDisputeTemplate",
        outputs: [
            {
                name: "templateId",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templates",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$627e9d8b31980128 = {
    421614: "0x596D3B09E684D62217682216e9b7a0De75933391"
};
const $f9a008fec395d7ff$export$1aea09c7d625a98e = {
    address: $f9a008fec395d7ff$export$627e9d8b31980128,
    abi: $f9a008fec395d7ff$export$d1e10d5f7b143922
};
const $f9a008fec395d7ff$export$21d9c3f0deb225ff = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_templateTag",
                internalType: "string",
                type: "string",
                indexed: true
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeTemplate"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateTag",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "setDisputeTemplate",
        outputs: [
            {
                name: "templateId",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templates",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$56ddab1233a38980 = {
    421614: "0xc53b813ed94AaEb6F5518D60bf6a8109954bE3f6"
};
const $f9a008fec395d7ff$export$3cce64d909a4c1ac = {
    address: $f9a008fec395d7ff$export$56ddab1233a38980,
    abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff
};
const $f9a008fec395d7ff$export$314f357ca361fd22 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $f9a008fec395d7ff$export$5247f0db3dae2260 = {
    421614: "0x596D3B09E684D62217682216e9b7a0De75933391"
};
const $f9a008fec395d7ff$export$53891cd8c1dbbdb6 = {
    address: $f9a008fec395d7ff$export$5247f0db3dae2260,
    abi: $f9a008fec395d7ff$export$314f357ca361fd22
};
const $f9a008fec395d7ff$export$68d04ee65bd7e0a = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_evidence",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "Evidence"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_evidence",
                internalType: "string",
                type: "string"
            }
        ],
        name: "submitEvidence",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$a553812daab5b0cd = {
    421614: "0x57fd453FB0d16f8ca174E7386102D7170E17Be09"
};
const $f9a008fec395d7ff$export$1d528678723c236f = {
    address: $f9a008fec395d7ff$export$a553812daab5b0cd,
    abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a
};
const $f9a008fec395d7ff$export$805f4356e8f2695d = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_evidence",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "Evidence"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_evidence",
                internalType: "string",
                type: "string"
            }
        ],
        name: "submitEvidence",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2 = {
    421614: "0x05AD81f245209b7f91885fd96e57c9da90554824"
};
const $f9a008fec395d7ff$export$93a818cb7a0526b2 = {
    address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2,
    abi: $f9a008fec395d7ff$export$805f4356e8f2695d
};
const $f9a008fec395d7ff$export$29750e468c88861c = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $f9a008fec395d7ff$export$134c483d74ac3e8b = {
    421614: "0x57fd453FB0d16f8ca174E7386102D7170E17Be09"
};
const $f9a008fec395d7ff$export$fa023f00ac174c53 = {
    address: $f9a008fec395d7ff$export$134c483d74ac3e8b,
    abi: $f9a008fec395d7ff$export$29750e468c88861c
};
const $f9a008fec395d7ff$export$ee81f679a1a6e4b5 = [
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$2f0cf58b4951e73a = [
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: false
            },
            {
                name: "_arbitrableChainId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_arbitrable",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_arbitratorDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "CrossChainDisputeIncoming"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeHash",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "disputeHashToHomeID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "feeToken",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "foreignChainID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "foreignGateway",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "receiverGateway",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_params",
                internalType: "struct IHomeGateway.RelayCreateDisputeParams",
                type: "tuple",
                components: [
                    {
                        name: "foreignBlockHash",
                        internalType: "bytes32",
                        type: "bytes32"
                    },
                    {
                        name: "foreignChainID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "foreignArbitrable",
                        internalType: "address",
                        type: "address"
                    },
                    {
                        name: "foreignDisputeID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "externalDisputeID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "templateId",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "templateUri",
                        internalType: "string",
                        type: "string"
                    },
                    {
                        name: "choices",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "extraData",
                        internalType: "bytes",
                        type: "bytes"
                    }
                ]
            },
            {
                name: "_feeAmount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "relayCreateDispute",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_params",
                internalType: "struct IHomeGateway.RelayCreateDisputeParams",
                type: "tuple",
                components: [
                    {
                        name: "foreignBlockHash",
                        internalType: "bytes32",
                        type: "bytes32"
                    },
                    {
                        name: "foreignChainID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "foreignArbitrable",
                        internalType: "address",
                        type: "address"
                    },
                    {
                        name: "foreignDisputeID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "externalDisputeID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "templateId",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "templateUri",
                        internalType: "string",
                        type: "string"
                    },
                    {
                        name: "choices",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "extraData",
                        internalType: "bytes",
                        type: "bytes"
                    }
                ]
            }
        ],
        name: "relayCreateDispute",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "veaInbox",
        outputs: [
            {
                name: "",
                internalType: "contract IVeaInbox",
                type: "address"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$6b6e38efde31b17e = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "AppealFeesNotEnough"
    },
    {
        type: "error",
        inputs: [],
        name: "AppealPeriodNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "ArbitrableNotWhitelisted"
    },
    {
        type: "error",
        inputs: [],
        name: "ArbitrationFeesNotEnough"
    },
    {
        type: "error",
        inputs: [],
        name: "ArraysLengthMismatch"
    },
    {
        type: "error",
        inputs: [],
        name: "CannotDisableClassicDK"
    },
    {
        type: "error",
        inputs: [],
        name: "CommitPeriodNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "DepthLevelMax"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeKitNotSupportedByCourt"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeKitOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeNotAppealable"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputePeriodIsFinal"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeStillDrawing"
    },
    {
        type: "error",
        inputs: [],
        name: "EvidenceNotPassedAndNotAppeal"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [],
        name: "GovernorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "GuardianOrGovernorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "InvalidDisputKitParent"
    },
    {
        type: "error",
        inputs: [],
        name: "InvalidForkingCourtAsParent"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "MinStakeLowerThanParentCourt"
    },
    {
        type: "error",
        inputs: [],
        name: "MustSupportDisputeKitClassic"
    },
    {
        type: "error",
        inputs: [],
        name: "NotEligibleForStaking"
    },
    {
        type: "error",
        inputs: [],
        name: "NotEvidencePeriod"
    },
    {
        type: "error",
        inputs: [],
        name: "NotExecutionPeriod"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "RulingAlreadyExecuted"
    },
    {
        type: "error",
        inputs: [],
        name: "SortitionModuleOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingInTooManyCourts"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingLessThanCourtMinStake"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingMoreThanMaxStakePerJuror"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingMoreThanMaxTotalStaked"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingNotPossibeInThisCourt"
    },
    {
        type: "error",
        inputs: [],
        name: "StakingTransferFailed"
    },
    {
        type: "error",
        inputs: [],
        name: "TokenNotAccepted"
    },
    {
        type: "error",
        inputs: [],
        name: "TransferFailed"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "error",
        inputs: [],
        name: "UnstakingTransferFailed"
    },
    {
        type: "error",
        inputs: [],
        name: "UnsuccessfulCall"
    },
    {
        type: "error",
        inputs: [],
        name: "UnsupportedDisputeKit"
    },
    {
        type: "error",
        inputs: [],
        name: "VotePeriodNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "WhenNotPausedOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "WhenPausedOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "WrongDisputeKitIndex"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address",
                indexed: true
            },
            {
                name: "_accepted",
                internalType: "bool",
                type: "bool",
                indexed: true
            }
        ],
        name: "AcceptedFeeToken"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_arbitrable",
                internalType: "contract IArbitrableV2",
                type: "address",
                indexed: true
            }
        ],
        name: "AppealDecision"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_arbitrable",
                internalType: "contract IArbitrableV2",
                type: "address",
                indexed: true
            }
        ],
        name: "AppealPossible"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_parent",
                internalType: "uint96",
                type: "uint96",
                indexed: true
            },
            {
                name: "_hiddenVotes",
                internalType: "bool",
                type: "bool",
                indexed: false
            },
            {
                name: "_minStake",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_alpha",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_feeForJuror",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_jurorsForCourtJump",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]",
                indexed: false
            },
            {
                name: "_supportedDisputeKits",
                internalType: "uint256[]",
                type: "uint256[]",
                indexed: false
            }
        ],
        name: "CourtCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_roundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_fromCourtID",
                internalType: "uint96",
                type: "uint96",
                indexed: true
            },
            {
                name: "_toCourtID",
                internalType: "uint96",
                type: "uint96",
                indexed: false
            }
        ],
        name: "CourtJump"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96",
                indexed: true
            },
            {
                name: "_hiddenVotes",
                internalType: "bool",
                type: "bool",
                indexed: false
            },
            {
                name: "_minStake",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_alpha",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_feeForJuror",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_jurorsForCourtJump",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]",
                indexed: false
            }
        ],
        name: "CourtModified"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_arbitrable",
                internalType: "contract IArbitrableV2",
                type: "address",
                indexed: true
            }
        ],
        name: "DisputeCreation"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeKitID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_disputeKitAddress",
                internalType: "contract IDisputeKit",
                type: "address",
                indexed: true
            }
        ],
        name: "DisputeKitCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96",
                indexed: true
            },
            {
                name: "_disputeKitID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_enable",
                internalType: "bool",
                type: "bool",
                indexed: true
            }
        ],
        name: "DisputeKitEnabled"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_roundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_fromDisputeKitID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_toDisputeKitID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "DisputeKitJump"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_roundID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_voteID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Draw"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_roundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_pnkAmount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_feeAmount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address",
                indexed: false
            }
        ],
        name: "LeftoverRewardSent"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address",
                indexed: true
            },
            {
                name: "_rateInEth",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            },
            {
                name: "_rateDecimals",
                internalType: "uint8",
                type: "uint8",
                indexed: false
            }
        ],
        name: "NewCurrencyRate"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_period",
                internalType: "enum KlerosCoreBase.Period",
                type: "uint8",
                indexed: false
            }
        ],
        name: "NewPeriod"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [],
        name: "Paused"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrable",
                internalType: "contract IArbitrableV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_roundID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_degreeOfCoherency",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_pnkAmount",
                internalType: "int256",
                type: "int256",
                indexed: false
            },
            {
                name: "_feeAmount",
                internalType: "int256",
                type: "int256",
                indexed: false
            },
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address",
                indexed: false
            }
        ],
        name: "TokenAndETHShift"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [],
        name: "Unpaused"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeKitAddress",
                internalType: "contract IDisputeKit",
                type: "address"
            }
        ],
        name: "addNewDisputeKit",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_numberOfChoices",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "appeal",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "appealCost",
        outputs: [
            {
                name: "cost",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "appealPeriod",
        outputs: [
            {
                name: "start",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "end",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "arbitrableWhitelist",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address"
            }
        ],
        name: "arbitrationCost",
        outputs: [
            {
                name: "cost",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "arbitrationCost",
        outputs: [
            {
                name: "cost",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_accepted",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "changeAcceptedFeeTokens",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrable",
                internalType: "address",
                type: "address"
            },
            {
                name: "_allowed",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "changeArbitrableWhitelist",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_hiddenVotes",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "_minStake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_alpha",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_feeForJuror",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_jurorsForCourtJump",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]"
            }
        ],
        name: "changeCourtParameters",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_rateInEth",
                internalType: "uint64",
                type: "uint64"
            },
            {
                name: "_rateDecimals",
                internalType: "uint8",
                type: "uint8"
            }
        ],
        name: "changeCurrencyRates",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address payable",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_guardian",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGuardian",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_jurorNft",
                internalType: "contract IERC721",
                type: "address"
            }
        ],
        name: "changeJurorNft",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_jurorProsecutionModule",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeJurorProsecutionModule",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_pinakion",
                internalType: "contract IERC20",
                type: "address"
            }
        ],
        name: "changePinakion",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_sortitionModule",
                internalType: "contract ISortitionModule",
                type: "address"
            }
        ],
        name: "changeSortitionModule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_toToken",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_amountInEth",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "convertEthToTokenAmount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "courts",
        outputs: [
            {
                name: "parent",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "hiddenVotes",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "minStake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "alpha",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "feeForJuror",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "jurorsForCourtJump",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "disabled",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_parent",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_hiddenVotes",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "_minStake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_alpha",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_feeForJuror",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_jurorsForCourtJump",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]"
            },
            {
                name: "_sortitionExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_supportedDisputeKits",
                internalType: "uint256[]",
                type: "uint256[]"
            }
        ],
        name: "createCourt",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_numberOfChoices",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "createDispute",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_numberOfChoices",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_feeToken",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_feeAmount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDispute",
        outputs: [
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ],
        name: "currencyRates",
        outputs: [
            {
                name: "feePaymentAccepted",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "rateInEth",
                internalType: "uint64",
                type: "uint64"
            },
            {
                name: "rateDecimals",
                internalType: "uint8",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "currentRuling",
        outputs: [
            {
                name: "ruling",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "tied",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "overridden",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputeKits",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeKit",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputes",
        outputs: [
            {
                name: "courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "arbitrated",
                internalType: "contract IArbitrableV2",
                type: "address"
            },
            {
                name: "period",
                internalType: "enum KlerosCoreBase.Period",
                type: "uint8"
            },
            {
                name: "ruled",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "lastPeriodChange",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_iterations",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "draw",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_disputeKitIDs",
                internalType: "uint256[]",
                type: "uint256[]"
            },
            {
                name: "_enable",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "enableDisputeKits",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_round",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_iterations",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "execute",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_destination",
                internalType: "address",
                type: "address"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "executeGovernorProposal",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "executeRuling",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "getDisputeKitsLength",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getNumberOfRounds",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getNumberOfVotes",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_round",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getRoundInfo",
        outputs: [
            {
                name: "",
                internalType: "struct KlerosCoreBase.Round",
                type: "tuple",
                components: [
                    {
                        name: "disputeKitID",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "pnkAtStakePerJuror",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "totalFeesForJurors",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "nbVotes",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "repartitions",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "pnkPenalties",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "drawnJurors",
                        internalType: "address[]",
                        type: "address[]"
                    },
                    {
                        name: "sumFeeRewardPaid",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "sumPnkRewardPaid",
                        internalType: "uint256",
                        type: "uint256"
                    },
                    {
                        name: "feeToken",
                        internalType: "contract IERC20",
                        type: "address"
                    },
                    {
                        name: "drawIterations",
                        internalType: "uint256",
                        type: "uint256"
                    }
                ]
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            }
        ],
        name: "getTimesPerPeriod",
        outputs: [
            {
                name: "timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "guardian",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            },
            {
                name: "_guardian",
                internalType: "address",
                type: "address"
            },
            {
                name: "_pinakion",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_jurorProsecutionModule",
                internalType: "address",
                type: "address"
            },
            {
                name: "_disputeKit",
                internalType: "contract IDisputeKit",
                type: "address"
            },
            {
                name: "_hiddenVotes",
                internalType: "bool",
                type: "bool"
            },
            {
                name: "_courtParameters",
                internalType: "uint256[4]",
                type: "uint256[4]"
            },
            {
                name: "_timesPerPeriod",
                internalType: "uint256[4]",
                type: "uint256[4]"
            },
            {
                name: "_sortitionExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_sortitionModuleAddress",
                internalType: "contract ISortitionModule",
                type: "address"
            },
            {
                name: "_jurorNft",
                internalType: "contract IERC721",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "isDisputeKitJumping",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_disputeKitID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "isSupported",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "jurorNft",
        outputs: [
            {
                name: "",
                internalType: "contract IERC721",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "jurorProsecutionModule",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "passPeriod",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "pause",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "paused",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "pinakion",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_newStake",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "setStake",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            },
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_newStake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_alreadyTransferred",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "setStakeBySortitionModule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "sortitionModule",
        outputs: [
            {
                name: "",
                internalType: "contract ISortitionModule",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "unpause",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$5145390c9c1a56dc = {
    421614: "0x26bf077037550e437605F07e25EfcAd510715C3A"
};
const $f9a008fec395d7ff$export$a50fcec8e34ca62b = {
    address: $f9a008fec395d7ff$export$5145390c9c1a56dc,
    abi: $f9a008fec395d7ff$export$6b6e38efde31b17e
};
const $f9a008fec395d7ff$export$c074b75d6cecd21e = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_name",
                internalType: "string",
                type: "string"
            },
            {
                name: "_symbol",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "approved",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            }
        ],
        name: "Approval"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "operator",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "approved",
                internalType: "bool",
                type: "bool",
                indexed: false
            }
        ],
        name: "ApprovalForAll"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "to",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            }
        ],
        name: "Transfer"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_newOwner",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeOwner",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            },
            {
                name: "operator",
                internalType: "address",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "owner",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            }
        ],
        name: "safeMint",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "operator",
                internalType: "address",
                type: "address"
            },
            {
                name: "approved",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "interfaceId",
                internalType: "bytes4",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "tokenId",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$c1400aa8011edd44 = {
    421614: "0x0d60Ff8bbCF49Bc5352328E7E28e141834d7750F"
};
const $f9a008fec395d7ff$export$15de9bf9db757669 = {
    address: $f9a008fec395d7ff$export$c1400aa8011edd44,
    abi: $f9a008fec395d7ff$export$c074b75d6cecd21e
};
const $f9a008fec395d7ff$export$3dde6bb809ea3570 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "spender",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Approval"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "to",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Transfer"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            },
            {
                name: "spender",
                internalType: "address",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                internalType: "uint8",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "subtractedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "addedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$1c8e2910270b6c57 = {
    421614: "0x34B944D42cAcfC8266955D07A80181D2054aa225"
};
const $f9a008fec395d7ff$export$f59e5012cb92f099 = {
    address: $f9a008fec395d7ff$export$1c8e2910270b6c57,
    abi: $f9a008fec395d7ff$export$3dde6bb809ea3570
};
const $f9a008fec395d7ff$export$db30be73c7bdbbc8 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "amount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "balance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeAmount",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "request",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "token",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "withdraw",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "withdrewAlready",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$970296fc1189410d = {
    421614: "0x7EFE468003Ad6A858b5350CDE0A67bBED58739dD"
};
const $f9a008fec395d7ff$export$c73bca0e31f4ff32 = {
    address: $f9a008fec395d7ff$export$970296fc1189410d,
    abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8
};
const $f9a008fec395d7ff$export$4030a337ba3b0f2c = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "spender",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Approval"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "to",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Transfer"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            },
            {
                name: "spender",
                internalType: "address",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                internalType: "uint8",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "subtractedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "addedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$1fbe0966f612778b = {
    421614: "0x34B944D42cAcfC8266955D07A80181D2054aa225"
};
const $f9a008fec395d7ff$export$ef5b4ce4ac5e417c = {
    address: $f9a008fec395d7ff$export$1fbe0966f612778b,
    abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c
};
const $f9a008fec395d7ff$export$a1b769c2e116c47a = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_courtName",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_policy",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "PolicyUpdate"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "policies",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_courtName",
                internalType: "string",
                type: "string"
            },
            {
                name: "_policy",
                internalType: "string",
                type: "string"
            }
        ],
        name: "setPolicy",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$d8b41a349669c712 = {
    421614: "0x2AC2EdFD336732bc6963f1AD03ED98B22dB949da"
};
const $f9a008fec395d7ff$export$cbdbf85196ba3af3 = {
    address: $f9a008fec395d7ff$export$d8b41a349669c712,
    abi: $f9a008fec395d7ff$export$a1b769c2e116c47a
};
const $f9a008fec395d7ff$export$c28ad79f11f8bc64 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_courtName",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_policy",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "PolicyUpdate"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "policies",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_courtName",
                internalType: "string",
                type: "string"
            },
            {
                name: "_policy",
                internalType: "string",
                type: "string"
            }
        ],
        name: "setPolicy",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$6849cbec8eff493e = {
    421614: "0xAA637C9E2831614158d7eB193D03af4a7223C56E"
};
const $f9a008fec395d7ff$export$aaa7707646210a8a = {
    address: $f9a008fec395d7ff$export$6849cbec8eff493e,
    abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64
};
const $f9a008fec395d7ff$export$9d566d587e85c9f2 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $f9a008fec395d7ff$export$7c9f54d01b14188e = {
    421614: "0x2AC2EdFD336732bc6963f1AD03ED98B22dB949da"
};
const $f9a008fec395d7ff$export$6629d9063c3f8709 = {
    address: $f9a008fec395d7ff$export$7c9f54d01b14188e,
    abi: $f9a008fec395d7ff$export$9d566d587e85c9f2
};
const $f9a008fec395d7ff$export$8882b387808251bf = [];
const $f9a008fec395d7ff$export$e6c42df816cd4259 = {
    421614: "0xE775D7fde1d0D09ae627C0131040012ccBcC4b9b"
};
const $f9a008fec395d7ff$export$d967f8083aa176e0 = {
    address: $f9a008fec395d7ff$export$e6c42df816cd4259,
    abi: $f9a008fec395d7ff$export$8882b387808251bf
};
const $f9a008fec395d7ff$export$df1930c12a28053e = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "callbackGasLimit",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_randomizer",
                internalType: "contract IRandomizer",
                type: "address"
            },
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "randomNumbers",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "randomizer",
        outputs: [
            {
                name: "",
                internalType: "contract IRandomizer",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_id",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_value",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "randomizerCallback",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "randomizerWithdraw",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "receiveRandomness",
        outputs: [
            {
                name: "randomNumber",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "requestRandomness",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "requesterToID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_callbackGasLimit",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "setCallbackGasLimit",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_randomizer",
                internalType: "address",
                type: "address"
            }
        ],
        name: "setRandomizer",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$f192064499d2682e = {
    421614: "0xA995C172d286f8F4eE137CC662e2844E59Cf4836"
};
const $f9a008fec395d7ff$export$30f164246e26ad74 = {
    address: $f9a008fec395d7ff$export$f192064499d2682e,
    abi: $f9a008fec395d7ff$export$df1930c12a28053e
};
const $f9a008fec395d7ff$export$ceaad6fc42916c20 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: []
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "callbackGasLimit",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_randomizer",
                internalType: "contract IRandomizer",
                type: "address"
            },
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "randomNumbers",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "randomizer",
        outputs: [
            {
                name: "",
                internalType: "contract IRandomizer",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_id",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_value",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "randomizerCallback",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "randomizerWithdraw",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "receiveRandomness",
        outputs: [
            {
                name: "randomNumber",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "requestRandomness",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "requesterToID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_callbackGasLimit",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "setCallbackGasLimit",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_randomizer",
                internalType: "address",
                type: "address"
            }
        ],
        name: "setRandomizer",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    }
];
const $f9a008fec395d7ff$export$127f249ce66d8696 = {
    421614: "0xe62B776498F48061ef9425fCEf30F3d1370DB005"
};
const $f9a008fec395d7ff$export$9778d10127d02f7d = {
    address: $f9a008fec395d7ff$export$127f249ce66d8696,
    abi: $f9a008fec395d7ff$export$ceaad6fc42916c20
};
const $f9a008fec395d7ff$export$8c32c4aa051093d9 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
const $f9a008fec395d7ff$export$23101ae2e06b0b9b = {
    421614: "0xA995C172d286f8F4eE137CC662e2844E59Cf4836"
};
const $f9a008fec395d7ff$export$c39c45e850a7adb9 = {
    address: $f9a008fec395d7ff$export$23101ae2e06b0b9b,
    abi: $f9a008fec395d7ff$export$8c32c4aa051093d9
};
const $f9a008fec395d7ff$export$e9a148b942b5cada = [
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
    {
        type: "error",
        inputs: [],
        name: "AlreadyInitialized"
    },
    {
        type: "error",
        inputs: [],
        name: "FailedDelegateCall"
    },
    {
        type: "error",
        inputs: [
            {
                name: "implementation",
                internalType: "address",
                type: "address"
            }
        ],
        name: "InvalidImplementation"
    },
    {
        type: "error",
        inputs: [],
        name: "NotInitializing"
    },
    {
        type: "error",
        inputs: [],
        name: "UUPSUnauthorizedCallContext"
    },
    {
        type: "error",
        inputs: [
            {
                name: "slot",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "UUPSUnsupportedProxiableUUID"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "version",
                internalType: "uint64",
                type: "uint64",
                indexed: false
            }
        ],
        name: "Initialized"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_phase",
                internalType: "enum ISortitionModule.Phase",
                type: "uint8",
                indexed: false
            }
        ],
        name: "NewPhase"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "StakeDelayedAlreadyTransferred"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "StakeDelayedAlreadyTransferredWithdrawn"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "StakeDelayedNotTransferred"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_relativeAmount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_unlock",
                internalType: "bool",
                type: "bool",
                indexed: false
            }
        ],
        name: "StakeLocked"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_address",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_courtID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "StakeSet"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address",
                indexed: true
            }
        ],
        name: "Upgraded"
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_maxDrawingTime",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeMaxDrawingTime",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_maxStakePerJuror",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeMaxStakePerJuror",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_maxTotalStaked",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeMaxTotalStaked",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_minStakingTime",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeMinStakingTime",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_rng",
                internalType: "contract RNG",
                type: "address"
            },
            {
                name: "_rngLookahead",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeRandomNumberGenerator",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "core",
        outputs: [
            {
                name: "",
                internalType: "contract KlerosCore",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "createDisputeHook",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_key",
                internalType: "bytes32",
                type: "bytes32"
            },
            {
                name: "_extraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "createTree",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "delayedStakeReadIndex",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "delayedStakeWriteIndex",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "delayedStakes",
        outputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            },
            {
                name: "courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "stake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "alreadyTransferred",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "disputesWithoutJurors",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_key",
                internalType: "bytes32",
                type: "bytes32"
            },
            {
                name: "_coreDisputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_nonce",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "draw",
        outputs: [
            {
                name: "drawnAddress",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_iterations",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "executeDelayedStakes",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_juror",
                internalType: "address",
                type: "address"
            },
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            }
        ],
        name: "getJurorBalance",
        outputs: [
            {
                name: "totalStaked",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "totalLocked",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "stakedInCourt",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "nbCourts",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_juror",
                internalType: "address",
                type: "address"
            }
        ],
        name: "getJurorCourtIDs",
        outputs: [
            {
                name: "",
                internalType: "uint96[]",
                type: "uint96[]"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            },
            {
                name: "_core",
                internalType: "contract KlerosCore",
                type: "address"
            },
            {
                name: "_minStakingTime",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_maxDrawingTime",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_rng",
                internalType: "contract RNG",
                type: "address"
            },
            {
                name: "_rngLookahead",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_maxStakePerJuror",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_maxTotalStaked",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "initialize",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_juror",
                internalType: "address",
                type: "address"
            }
        ],
        name: "isJurorStaked",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "jurors",
        outputs: [
            {
                name: "stakedPnk",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "lockedPnk",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "lastPhaseChange",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            },
            {
                name: "",
                internalType: "uint96",
                type: "uint96"
            }
        ],
        name: "latestDelayedStakeIndex",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            },
            {
                name: "_relativeAmount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "lockStake",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "maxDrawingTime",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "maxStakePerJuror",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "maxTotalStaked",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "minStakingTime",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_randomNumber",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "notifyRandomNumber",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "passPhase",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            },
            {
                name: "_relativeAmount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "penalizeStake",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "phase",
        outputs: [
            {
                name: "",
                internalType: "enum ISortitionModule.Phase",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "postDrawHook",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                name: "",
                internalType: "bytes32",
                type: "bytes32"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "randomNumber",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "randomNumberRequestBlock",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "rng",
        outputs: [
            {
                name: "",
                internalType: "contract RNG",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "rngLookahead",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            }
        ],
        name: "setJurorInactive",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            },
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            },
            {
                name: "_newStake",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_alreadyTransferred",
                internalType: "bool",
                type: "bool"
            }
        ],
        name: "setStake",
        outputs: [
            {
                name: "pnkDeposit",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "pnkWithdrawal",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "stakingResult",
                internalType: "enum StakingResult",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_key",
                internalType: "bytes32",
                type: "bytes32"
            },
            {
                name: "_ID",
                internalType: "bytes32",
                type: "bytes32"
            }
        ],
        name: "stakeOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "_juror",
                internalType: "address",
                type: "address"
            },
            {
                name: "_courtID",
                internalType: "uint96",
                type: "uint96"
            }
        ],
        name: "stakeOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "totalStaked",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_account",
                internalType: "address",
                type: "address"
            },
            {
                name: "_relativeAmount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "unlockStake",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "newImplementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "data",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_implementation",
                internalType: "address",
                type: "address"
            },
            {
                name: "_data",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$c593fe1244035095 = {
    421614: "0x809533c303c10915BB5c0585f2d8D738e2a4fB64"
};
const $f9a008fec395d7ff$export$f0400990833d92b0 = {
    address: $f9a008fec395d7ff$export$c593fe1244035095,
    abi: $f9a008fec395d7ff$export$e9a148b942b5cada
};
const $f9a008fec395d7ff$export$4b0ccc96b6d839ce = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_name",
                internalType: "string",
                type: "string"
            },
            {
                name: "_symbol",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "spender",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Approval"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "to",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "value",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Transfer"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "owner",
                internalType: "address",
                type: "address"
            },
            {
                name: "spender",
                internalType: "address",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "account",
                internalType: "address",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                internalType: "uint8",
                type: "uint8"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "subtractedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "spender",
                internalType: "address",
                type: "address"
            },
            {
                name: "addedValue",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "increaseAllowance",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                internalType: "string",
                type: "string"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "from",
                internalType: "address",
                type: "address"
            },
            {
                name: "to",
                internalType: "address",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$ce878659290aa7e4 = {
    421614: "0x3829A2486d53ee984a0ca2D76552715726b77138"
};
const $f9a008fec395d7ff$export$e80d2475f87572de = {
    address: $f9a008fec395d7ff$export$ce878659290aa7e4,
    abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce
};
const $f9a008fec395d7ff$export$dc501b985d178688 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "amount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "balance",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeAmount",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "request",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "token",
        outputs: [
            {
                name: "",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [],
        name: "withdraw",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ],
        name: "withdrewAlready",
        outputs: [
            {
                name: "",
                internalType: "bool",
                type: "bool"
            }
        ]
    }
];
const $f9a008fec395d7ff$export$c7443d37daeed2d9 = {
    421614: "0x6F8C10E0030aDf5B8030a5E282F026ADdB6525fd"
};
const $f9a008fec395d7ff$export$3fdc5de6d72ecc55 = {
    address: $f9a008fec395d7ff$export$c7443d37daeed2d9,
    abi: $f9a008fec395d7ff$export$dc501b985d178688
};
function $f9a008fec395d7ff$export$b1d73e6ef12616cb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d195298df0b40602(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "arbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$6051d34b17959d83(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "arbitratorExtraData",
        ...config
    });
}
function $f9a008fec395d7ff$export$13df6210f365dd23(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "disputes",
        ...config
    });
}
function $f9a008fec395d7ff$export$7763e6531fd37bd3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "externalIDtoLocalID",
        ...config
    });
}
function $f9a008fec395d7ff$export$42005aa87dbd1d77(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$3283038a5237fb1a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "templateId",
        ...config
    });
}
function $f9a008fec395d7ff$export$7ed3aa7a667c6054(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "templateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$1319b47404ba147b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "weth",
        ...config
    });
}
function $f9a008fec395d7ff$export$885e5f2b35dbdf91(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bbeaaced149cfa27(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$dc9ea8439cfd4809(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $f9a008fec395d7ff$export$5a5bcf3d0ad18044(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$2abcf819e5bd3e7d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$3913f3b18285ab78(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$f1833bc5b238b938(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$23207160514e9955(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$1f79e2291045ded8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$337815300c062acc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $f9a008fec395d7ff$export$bf5f6ff4b664abc5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$a1c8a399518e1797(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$16e98ba337996ce1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$8fcb6b9552567910(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$9d6cd71bcdd572c9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a9837304212189a4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        eventName: "Action",
        ...config
    });
}
function $f9a008fec395d7ff$export$f66452ca779a540b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        eventName: "DisputeRequest",
        ...config
    });
}
function $f9a008fec395d7ff$export$b0aff9f84c8eac81(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        eventName: "Ruling",
        ...config
    });
}
function $f9a008fec395d7ff$export$4d6eacf7ecdc6d28(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$48b1307eebe7bfc1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        functionName: "randomNumbers",
        ...config
    });
}
function $f9a008fec395d7ff$export$77b783a0f293ac3c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$8da21601fb0dbf6e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        functionName: "receiveRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$54658dfe7c4edba8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$9d47c4e457e44ca(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$be457759cdd1356d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        functionName: "receiveRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$26a6d5d10a7d50fd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$e7c6d1983528b1a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5a094e80ef981fd6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "allowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$7d2707cb8de3c015(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "balanceOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$973a2ad16e790978(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "decimals",
        ...config
    });
}
function $f9a008fec395d7ff$export$e65912c10523055f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "name",
        ...config
    });
}
function $f9a008fec395d7ff$export$732460528f6c7a12(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "symbol",
        ...config
    });
}
function $f9a008fec395d7ff$export$d03b356b7a8fec40(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "totalSupply",
        ...config
    });
}
function $f9a008fec395d7ff$export$61010d5a0c72a261(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$304a3cde37c1e981(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$3f1ec2eb65af80e6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$43c98eed1f1e5633(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$ad32881ac14e85(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$26b3ae3024f63799(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$4a0f8547c51c904d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ba171756402569f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$13c04f6346c357df(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$be77761c1dd96796(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$edd57757df02855d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$2287ecd324577b67(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$7b03ccd2cb0606b2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$30f538e75424349c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        eventName: "Approval",
        ...config
    });
}
function $f9a008fec395d7ff$export$46b7538bc0c9c12e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        eventName: "Transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$459cf5135b04762d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$103e8ed5fca76c56(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "amount",
        ...config
    });
}
function $f9a008fec395d7ff$export$d14ba63ab7bd918f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "balance",
        ...config
    });
}
function $f9a008fec395d7ff$export$6d54128ede9f6ad(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$5e3e248a6f73ea26(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "token",
        ...config
    });
}
function $f9a008fec395d7ff$export$c0e57f405c39af3f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "withdrewAlready",
        ...config
    });
}
function $f9a008fec395d7ff$export$ac42555f20d9372e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f95343be9e3ab8d5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$cdf3dc9feee51d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$2f35e640f072398d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$f2bdf2606fc29203(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$6f247e4758326e6a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$cc3b4ef4758d07c6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$e244071a1264c9d6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$e8113744600e415a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$b37fc88f3ad9c79f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$146351856b31b328(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$eec1afbbbb37e5b1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "LOSER_APPEAL_PERIOD_MULTIPLIER",
        ...config
    });
}
function $f9a008fec395d7ff$export$8388ed52d239dd42(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "LOSER_STAKE_MULTIPLIER",
        ...config
    });
}
function $f9a008fec395d7ff$export$556fb308bdbcdc0b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "ONE_BASIS_POINT",
        ...config
    });
}
function $f9a008fec395d7ff$export$be24bf3e2a8abb52(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "WINNER_STAKE_MULTIPLIER",
        ...config
    });
}
function $f9a008fec395d7ff$export$f6edcd92759b84bb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "areCommitsAllCast",
        ...config
    });
}
function $f9a008fec395d7ff$export$65b0059b9ca4ff7c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "areVotesAllCast",
        ...config
    });
}
function $f9a008fec395d7ff$export$9f55ba605f123ea1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "core",
        ...config
    });
}
function $f9a008fec395d7ff$export$425b782a13428bc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "coreDisputeIDToLocal",
        ...config
    });
}
function $f9a008fec395d7ff$export$ec7939331a4255f4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "currentRuling",
        ...config
    });
}
function $f9a008fec395d7ff$export$3dcc252f334c8d62(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "disputes",
        ...config
    });
}
function $f9a008fec395d7ff$export$8281170a0f3d4d86(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "getCoherentCount",
        ...config
    });
}
function $f9a008fec395d7ff$export$c4f41fe01900fcc2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "getDegreeOfCoherence",
        ...config
    });
}
function $f9a008fec395d7ff$export$37af77822e6fb5b0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "getFundedChoices",
        ...config
    });
}
function $f9a008fec395d7ff$export$b6479e7ded0398c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "getRoundInfo",
        ...config
    });
}
function $f9a008fec395d7ff$export$c9da3260fc9f5149(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "getVoteInfo",
        ...config
    });
}
function $f9a008fec395d7ff$export$12850e544d228311(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$b74721cc744bc7e0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "isVoteActive",
        ...config
    });
}
function $f9a008fec395d7ff$export$493938267ca45f87(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$b9964d56a94f0909(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$15897bbcd867730(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "castCommit",
        ...config
    });
}
function $f9a008fec395d7ff$export$32027dac1363bde3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "castVote",
        ...config
    });
}
function $f9a008fec395d7ff$export$9bbfebde9e9add40(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "changeCore",
        ...config
    });
}
function $f9a008fec395d7ff$export$ec4bddd0d423ce13(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$67c5f29d6a44e9ce(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$57dc1c50d4628ece(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$eb4dbac765accad9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "executeGovernorProposal",
        ...config
    });
}
function $f9a008fec395d7ff$export$165014b1149627d7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "fundAppeal",
        ...config
    });
}
function $f9a008fec395d7ff$export$8aedb8886e869568(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$8ff51f62838ff45f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$cc6566e1058895e9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "withdrawFeesAndRewards",
        ...config
    });
}
function $f9a008fec395d7ff$export$c3f2a15ef0dced11(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5d97a7c126fca4b8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "castCommit",
        ...config
    });
}
function $f9a008fec395d7ff$export$e54d1057d19fb99(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "castVote",
        ...config
    });
}
function $f9a008fec395d7ff$export$5d9d8516ccc70f2f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "changeCore",
        ...config
    });
}
function $f9a008fec395d7ff$export$4eeb2f444abab2f6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$4c659c3924d620c7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$a24c4bed8dbc1e61(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$fba1f2ef225b2696(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "executeGovernorProposal",
        ...config
    });
}
function $f9a008fec395d7ff$export$e73431a594544793(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "fundAppeal",
        ...config
    });
}
function $f9a008fec395d7ff$export$c8f6bcd8db803111(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$f2b7e645ab317065(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$b290b9f96f8fea92(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        functionName: "withdrawFeesAndRewards",
        ...config
    });
}
function $f9a008fec395d7ff$export$c7a20d982486f6e1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$dd16597fe0e279b4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "ChoiceFunded",
        ...config
    });
}
function $f9a008fec395d7ff$export$2b1e976eba29a6c3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "CommitCast",
        ...config
    });
}
function $f9a008fec395d7ff$export$26f56e7cfad16ce1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "Contribution",
        ...config
    });
}
function $f9a008fec395d7ff$export$51ea20320cf7910c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "DisputeCreation",
        ...config
    });
}
function $f9a008fec395d7ff$export$f9b92e1887ea5350(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$784a09b06ece9e67(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$da87314227ffe1d4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "VoteCast",
        ...config
    });
}
function $f9a008fec395d7ff$export$12b6f0c522673565(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        eventName: "Withdrawal",
        ...config
    });
}
function $f9a008fec395d7ff$export$30b9de6fce36c843(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6282fd2883bf93e2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "arbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$f5a12ad035e70e0e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "arbitratorDisputeIDToLocalID",
        ...config
    });
}
function $f9a008fec395d7ff$export$8b88fbb4d4939baf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "disputes",
        ...config
    });
}
function $f9a008fec395d7ff$export$532033dc645cb0da(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$d451aa6ce86bb8ee(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "templateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$864c630419879dde(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$2e77af7b088c0f39(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$d44ab16aa80d5165(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$8e37a491fdb85976(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$220083d52cb8c725(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "createDisputeForTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$8a802a4f11722385(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "createDisputeForTemplateUri",
        ...config
    });
}
function $f9a008fec395d7ff$export$b8600080edacfb0e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$9682785ca24c5810(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6eaa6546707a5457(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $f9a008fec395d7ff$export$6d3275468dcb71fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$fb3aaef0b288d46(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $f9a008fec395d7ff$export$15e236dbfac1fe67(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "createDisputeForTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$e7ceb40f2a06fb6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "createDisputeForTemplateUri",
        ...config
    });
}
function $f9a008fec395d7ff$export$eb8fada256eaa780(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$b3dd913990330fde(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$fefc49909f3efc23(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        eventName: "DisputeRequest",
        ...config
    });
}
function $f9a008fec395d7ff$export$edf8475f9b4faaf1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        eventName: "Ruling",
        ...config
    });
}
function $f9a008fec395d7ff$export$33d1a9dbcf45224f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d6f4fc69ceedd619(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$f7810701a05a79e5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$810d5292246efc5d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "templates",
        ...config
    });
}
function $f9a008fec395d7ff$export$a011dcafbc3d3e06(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6e29a15a08a50b22(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$5822ebd4d5550611(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$1886b5be36c5796f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "setDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$94a6c447d875f0c6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$4e0fc92a91615a34(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b3f93d031a7899ae(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$5c121371d9236b95(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$97970eca38b6ea14(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "setDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$5e293d257eb619cf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$4c5ce836b1a2120f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$aaea921bf2f86511(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        eventName: "DisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$fdb5e0754f7a8835(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$78650f8e2e9d192c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$4a0d65336f447814(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6bab9a21ca6831ad(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$9e31b302b3485769(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$ffdeef6f690d21dd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "templates",
        ...config
    });
}
function $f9a008fec395d7ff$export$a189c6887b2e4fbd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9911b85af8c5658(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$fe82c01ee92c4dc7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$d3e7f20ae2b7d7fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "setDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$92ef28f603602197(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$cf4c02d436cb38d6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bc95870b3e53f70b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$321959f3ce3e673b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$2d62d8e4c488dd08(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "setDisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$2828fc268146494d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$e8f60279d4fdb255(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$915ad6741acdf7b6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        eventName: "DisputeTemplate",
        ...config
    });
}
function $f9a008fec395d7ff$export$207af0d24b96b0fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$ede57209e0a5ef5c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$341c817f47571179(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$8dad3dc8c92c3205(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$4e916a265e54d21(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$4d0df0c104fa435f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$28006fa97cac5166(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$5726f19f64e6d12b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "submitEvidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$9055b6f8493ef663(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$8c9b6813f92a5fea(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$757dd45d0d2ddde7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$a9e2ceb087d59e46(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "submitEvidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$f06e07682cb876e9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$eb7b480a323008bc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$26e15473f0943071(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        eventName: "Evidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$9bf7781ca2f32c87(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$21ceb5f70d3d4df2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$5addebe897bc7e17(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9d295b468acc2c90(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$321e9e8b35219398(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$581a6f8a28b9da1e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$42a37403c7c7e6ae(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$ace6c67b31a23198(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "submitEvidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$cb1aa73faacb4fe6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$13d50045143803b5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c0f25c732d582092(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$fd8dc108e2747e4a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "submitEvidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$2e9dc801d71e24c0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$b0d1c3b43bd9b0d5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ba85236785d3dbd8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        eventName: "Evidence",
        ...config
    });
}
function $f9a008fec395d7ff$export$84705cd7b9e2f9c8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$fa563ab1022d8998(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$f0ffdb1ae8dd8600(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$1be5212cb8a30621(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$150a3ead6e63cc4a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$1a39667a26ddface(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$1821e4e0460c3b6d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$6e3979b703024471(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        eventName: "DisputeRequest",
        ...config
    });
}
function $f9a008fec395d7ff$export$67eaf0fcc1cda36f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        eventName: "Ruling",
        ...config
    });
}
function $f9a008fec395d7ff$export$b4cbfffdae65843(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$dd5c91fefe80bcd6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "disputeHashToHomeID",
        ...config
    });
}
function $f9a008fec395d7ff$export$2d5ce4c73f1b7a6a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "feeToken",
        ...config
    });
}
function $f9a008fec395d7ff$export$f35c96cd4677909b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "foreignChainID",
        ...config
    });
}
function $f9a008fec395d7ff$export$c65d1ff200025fa1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "foreignGateway",
        ...config
    });
}
function $f9a008fec395d7ff$export$4099dfbfa5e6b131(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "receiverGateway",
        ...config
    });
}
function $f9a008fec395d7ff$export$66dcfc702f57906a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "veaInbox",
        ...config
    });
}
function $f9a008fec395d7ff$export$f2e0c2f108a5f22d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$ebb7cb51b0bf4ef9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "relayCreateDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$415f36ed9963705e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$88bd3480106535b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$efbfa712c61f2a4e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "relayCreateDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$8ae888af84521eb0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        functionName: "rule",
        ...config
    });
}
function $f9a008fec395d7ff$export$4b460fca8eee60a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$3dc2ac5285d7a546(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        eventName: "CrossChainDisputeIncoming",
        ...config
    });
}
function $f9a008fec395d7ff$export$56d1ef069bf56ef7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        eventName: "DisputeRequest",
        ...config
    });
}
function $f9a008fec395d7ff$export$583131e553b9a047(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        eventName: "Ruling",
        ...config
    });
}
function $f9a008fec395d7ff$export$5ed4d776c44c3f9e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e04d943ee22254eb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "appealCost",
        ...config
    });
}
function $f9a008fec395d7ff$export$66fa7f9adb5362b7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "appealPeriod",
        ...config
    });
}
function $f9a008fec395d7ff$export$bb90b8d973d58547(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "arbitrableWhitelist",
        ...config
    });
}
function $f9a008fec395d7ff$export$f8738efad6e9d34f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "arbitrationCost",
        ...config
    });
}
function $f9a008fec395d7ff$export$b607e9ad1cf91920(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "convertEthToTokenAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$614bcad78a516523(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "courts",
        ...config
    });
}
function $f9a008fec395d7ff$export$805cc9a281a7d287(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "currencyRates",
        ...config
    });
}
function $f9a008fec395d7ff$export$85e714ff5a370b37(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "currentRuling",
        ...config
    });
}
function $f9a008fec395d7ff$export$b650ea4f1f0eb591(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "disputeKits",
        ...config
    });
}
function $f9a008fec395d7ff$export$6ec9110316b1eed2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "disputes",
        ...config
    });
}
function $f9a008fec395d7ff$export$22777fadeadbc833(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "getDisputeKitsLength",
        ...config
    });
}
function $f9a008fec395d7ff$export$b8a8e20eb83cf74f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "getNumberOfRounds",
        ...config
    });
}
function $f9a008fec395d7ff$export$c1c62c2434d03430(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "getNumberOfVotes",
        ...config
    });
}
function $f9a008fec395d7ff$export$c02c219f7c4d423e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "getRoundInfo",
        ...config
    });
}
function $f9a008fec395d7ff$export$a9b4e08ac49c7795(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "getTimesPerPeriod",
        ...config
    });
}
function $f9a008fec395d7ff$export$aa825583adfcf144(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$40b5a1e030ba122f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "guardian",
        ...config
    });
}
function $f9a008fec395d7ff$export$37d6d0a34e7b778f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "isDisputeKitJumping",
        ...config
    });
}
function $f9a008fec395d7ff$export$914dfba60227dc2e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "isSupported",
        ...config
    });
}
function $f9a008fec395d7ff$export$142e0d3d2f7ebc02(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "jurorNft",
        ...config
    });
}
function $f9a008fec395d7ff$export$595520c32b476f28(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "jurorProsecutionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$38f50389d94aaf3f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "paused",
        ...config
    });
}
function $f9a008fec395d7ff$export$c6d9b595c789af8f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "pinakion",
        ...config
    });
}
function $f9a008fec395d7ff$export$2c75b295c7542865(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$545da6cea7d983f5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "sortitionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$ad608ebb8ba9816a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$20e4f45851a664a4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "addNewDisputeKit",
        ...config
    });
}
function $f9a008fec395d7ff$export$602ce3f43c5d91af(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "appeal",
        ...config
    });
}
function $f9a008fec395d7ff$export$bac7853624a60f4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeAcceptedFeeTokens",
        ...config
    });
}
function $f9a008fec395d7ff$export$117209e5705cb2a3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeArbitrableWhitelist",
        ...config
    });
}
function $f9a008fec395d7ff$export$1c20ce604a347ef7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeCourtParameters",
        ...config
    });
}
function $f9a008fec395d7ff$export$5bcdb304aa89d21f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeCurrencyRates",
        ...config
    });
}
function $f9a008fec395d7ff$export$60ffd08707122cb9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$56c83982c78016d9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeGuardian",
        ...config
    });
}
function $f9a008fec395d7ff$export$3eb5839e06f3ac80(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeJurorNft",
        ...config
    });
}
function $f9a008fec395d7ff$export$8b9d6b6492105b2e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeJurorProsecutionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$c5b49952651a3c5d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changePinakion",
        ...config
    });
}
function $f9a008fec395d7ff$export$8fe8f6738fb11912(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeSortitionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$d0e0c34e4bbe5e1d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "createCourt",
        ...config
    });
}
function $f9a008fec395d7ff$export$1c3456d9e74b25d5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$76e3f53c15ffd63a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$813a4f72e7e58a19(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "enableDisputeKits",
        ...config
    });
}
function $f9a008fec395d7ff$export$4820fc0fbb39d85d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "execute",
        ...config
    });
}
function $f9a008fec395d7ff$export$fc865b3cc5357fa4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "executeGovernorProposal",
        ...config
    });
}
function $f9a008fec395d7ff$export$8fdbe35e46319868(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "executeRuling",
        ...config
    });
}
function $f9a008fec395d7ff$export$df2ea7c2e4749172(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$cef2c7319d075d82(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "passPeriod",
        ...config
    });
}
function $f9a008fec395d7ff$export$5c8b8e787d408be9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "pause",
        ...config
    });
}
function $f9a008fec395d7ff$export$be3ca3469e8da431(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "setStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$1d37de2a7a3c2a69(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "setStakeBySortitionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$7c77ad30f6ba0090(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "unpause",
        ...config
    });
}
function $f9a008fec395d7ff$export$c4ec7da10e75645a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$dc14f5df4ea3642b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$49942598cfda452a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "addNewDisputeKit",
        ...config
    });
}
function $f9a008fec395d7ff$export$b706801f2407ce18(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "appeal",
        ...config
    });
}
function $f9a008fec395d7ff$export$bc224af5ca242727(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeAcceptedFeeTokens",
        ...config
    });
}
function $f9a008fec395d7ff$export$38e8bebc621a0a6a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeArbitrableWhitelist",
        ...config
    });
}
function $f9a008fec395d7ff$export$13d19c41637759cd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeCourtParameters",
        ...config
    });
}
function $f9a008fec395d7ff$export$99b7ff5807f4982b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeCurrencyRates",
        ...config
    });
}
function $f9a008fec395d7ff$export$41a1b04c0c39bff2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$40f46be7f471bdec(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeGuardian",
        ...config
    });
}
function $f9a008fec395d7ff$export$f445258bedf4dedc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeJurorNft",
        ...config
    });
}
function $f9a008fec395d7ff$export$b72cd8dde6bebbf9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeJurorProsecutionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$456368d369b4df19(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changePinakion",
        ...config
    });
}
function $f9a008fec395d7ff$export$131ba89ba5abdd08(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "changeSortitionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$797f0b75aa88dcfd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "createCourt",
        ...config
    });
}
function $f9a008fec395d7ff$export$92bfe8608bbf8780(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "createDispute",
        ...config
    });
}
function $f9a008fec395d7ff$export$a0cf0fad3aec024c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$c3fc01bef14babec(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "enableDisputeKits",
        ...config
    });
}
function $f9a008fec395d7ff$export$15ab5eeef152e2c6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "execute",
        ...config
    });
}
function $f9a008fec395d7ff$export$4a30331ba271f28e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "executeGovernorProposal",
        ...config
    });
}
function $f9a008fec395d7ff$export$b7d1074aeebe7902(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "executeRuling",
        ...config
    });
}
function $f9a008fec395d7ff$export$5cc2b7f6816af758(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$fff7041b9fef82f9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "passPeriod",
        ...config
    });
}
function $f9a008fec395d7ff$export$9ebd9b0d3986356c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "pause",
        ...config
    });
}
function $f9a008fec395d7ff$export$c1a272f3da30c17(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "setStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$6fd398f7a4125095(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "setStakeBySortitionModule",
        ...config
    });
}
function $f9a008fec395d7ff$export$6c177b58c72a62bf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "unpause",
        ...config
    });
}
function $f9a008fec395d7ff$export$d49374738dace7b5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$bae80e3b110df02b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$22b461c59d65334f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "AcceptedFeeToken",
        ...config
    });
}
function $f9a008fec395d7ff$export$755c6beebdc9a5ca(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "AppealDecision",
        ...config
    });
}
function $f9a008fec395d7ff$export$9800c2b28c4e81f4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "AppealPossible",
        ...config
    });
}
function $f9a008fec395d7ff$export$35276b2a36330444(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "CourtCreated",
        ...config
    });
}
function $f9a008fec395d7ff$export$4349dfb494e22de5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "CourtJump",
        ...config
    });
}
function $f9a008fec395d7ff$export$fe96288f7ffce70a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "CourtModified",
        ...config
    });
}
function $f9a008fec395d7ff$export$c402aa24669f3c4d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "DisputeCreation",
        ...config
    });
}
function $f9a008fec395d7ff$export$d17c1b49f52dc447(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "DisputeKitCreated",
        ...config
    });
}
function $f9a008fec395d7ff$export$e20a1defdb3c8e09(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "DisputeKitEnabled",
        ...config
    });
}
function $f9a008fec395d7ff$export$897b6eb78bde6602(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "DisputeKitJump",
        ...config
    });
}
function $f9a008fec395d7ff$export$37598190d68ef8c4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$fa813c82d6ab4aa4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$40ec25d786f7efd2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "LeftoverRewardSent",
        ...config
    });
}
function $f9a008fec395d7ff$export$24689818ab4a6566(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "NewCurrencyRate",
        ...config
    });
}
function $f9a008fec395d7ff$export$63aa1283daf39b0e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "NewPeriod",
        ...config
    });
}
function $f9a008fec395d7ff$export$5d9dd119b165e72a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Paused",
        ...config
    });
}
function $f9a008fec395d7ff$export$c962e9ed390fe12a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Ruling",
        ...config
    });
}
function $f9a008fec395d7ff$export$19bef2c687497e6b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "TokenAndETHShift",
        ...config
    });
}
function $f9a008fec395d7ff$export$4ce3df64917f054c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Unpaused",
        ...config
    });
}
function $f9a008fec395d7ff$export$3128b89b22340bb9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$7dc7db155bc231d3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c6343a916f5917fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "balanceOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$8d3bcd8345538dd5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "getApproved",
        ...config
    });
}
function $f9a008fec395d7ff$export$e08f27ec742bdbd4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "isApprovedForAll",
        ...config
    });
}
function $f9a008fec395d7ff$export$a3bce0b5d577e63(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "name",
        ...config
    });
}
function $f9a008fec395d7ff$export$14f3c0fea87c050(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "owner",
        ...config
    });
}
function $f9a008fec395d7ff$export$3f0a6d331fdb3b01(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "ownerOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$49441c27f30b7fe4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "supportsInterface",
        ...config
    });
}
function $f9a008fec395d7ff$export$3d02fc1294f40a3c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "symbol",
        ...config
    });
}
function $f9a008fec395d7ff$export$9a2f3426ced65642(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "tokenURI",
        ...config
    });
}
function $f9a008fec395d7ff$export$d5322ccc77339302(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a4e030734134c17b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$85f4d9b7114faf0e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "changeOwner",
        ...config
    });
}
function $f9a008fec395d7ff$export$d772c51faaf6bc1c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "safeMint",
        ...config
    });
}
function $f9a008fec395d7ff$export$b932d611c9780afb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "safeTransferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$b0e7658b79c350fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "setApprovalForAll",
        ...config
    });
}
function $f9a008fec395d7ff$export$acef3d4f34076606(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$10e47b4a9c96cfaf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5aaad14ed2644ca2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$1f12bf2f56d6ae49(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "changeOwner",
        ...config
    });
}
function $f9a008fec395d7ff$export$4bf2c3c6afa4e422(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "safeMint",
        ...config
    });
}
function $f9a008fec395d7ff$export$73b4cafa05a5553a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "safeTransferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$847d10739ba35417(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "setApprovalForAll",
        ...config
    });
}
function $f9a008fec395d7ff$export$596c01142a6a9fc8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$7ba54e5e29f7a13d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7a283432e4a113aa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        eventName: "Approval",
        ...config
    });
}
function $f9a008fec395d7ff$export$7e5e059dcc1bcb0c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        eventName: "ApprovalForAll",
        ...config
    });
}
function $f9a008fec395d7ff$export$fae762132c0aa62(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        eventName: "Transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$af6bccb1ced613ea(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6accc9716eb907c3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "allowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$a795cb8115233541(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "balanceOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$bab1b49d32e17ce9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "decimals",
        ...config
    });
}
function $f9a008fec395d7ff$export$bae92d1abd75205e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "name",
        ...config
    });
}
function $f9a008fec395d7ff$export$2151874058dc4baa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "symbol",
        ...config
    });
}
function $f9a008fec395d7ff$export$7c90796cf02f7a5b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "totalSupply",
        ...config
    });
}
function $f9a008fec395d7ff$export$915e162a2c43e5b1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e5c457a8897e36cd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$37b2530515a3c9d5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$ce0bb0eb43140aa0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$12d2be8681b500e3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$816cd351b28e4f15(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$498c797f6616c7e1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$91772ba76a961247(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$f2cd6c224897d651(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$c2064b08c6a85a2c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$ba7a1e48a2a5f5f9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$1ce4ebdfe83ec40e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$1b578a9541af0124(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$2c2ec1e624ee18f5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        eventName: "Approval",
        ...config
    });
}
function $f9a008fec395d7ff$export$a5870e8241b71562(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        eventName: "Transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$842a6cc0b3a2949e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$da74f019da0902b2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "amount",
        ...config
    });
}
function $f9a008fec395d7ff$export$2b827d8af9035e92(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "balance",
        ...config
    });
}
function $f9a008fec395d7ff$export$b2fa1c9ce04d9fc1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$54d76f0a2273fc79(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "token",
        ...config
    });
}
function $f9a008fec395d7ff$export$9825f67e3513975b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "withdrewAlready",
        ...config
    });
}
function $f9a008fec395d7ff$export$35ed75b0a7bb8c53(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e59729a735b42655(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$600281dc408eb6df(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$551cb030bac3cdcc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$76d337906c46a160(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$9d1cce10f1aea87f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$4bc487f86bfa0537(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$bd0c58e388022a15(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$2e045d90ff219d42(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$3d535d5b5a46b30c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$6c3a809d0438fa87(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9bc04eb343b1197e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "allowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$b8e8ff04566a9e9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "balanceOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$7f9dca3896ae77d3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "decimals",
        ...config
    });
}
function $f9a008fec395d7ff$export$6c833c8090b9b59(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "name",
        ...config
    });
}
function $f9a008fec395d7ff$export$d02f1a75577c16c1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "symbol",
        ...config
    });
}
function $f9a008fec395d7ff$export$f77dfad5687564f6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "totalSupply",
        ...config
    });
}
function $f9a008fec395d7ff$export$34de516d80db675b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b670c81bf9b7fd03(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$e529a0ae3cf912a2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$b6f4cb0533844c82(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$977415522036b2ee(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$24fa8e8bf845809f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$48df74a06759464c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e045d45a571e6762(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$5bc60387937bd326(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$6a6fd98f3f9dc317(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$1f40574678c9d89f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$cdf226513d8320a9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$1f9a51565222960a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$53d97a5b4fbc4f1e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        eventName: "Approval",
        ...config
    });
}
function $f9a008fec395d7ff$export$beca772a848c4703(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        eventName: "Transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$6dbc818ab6a47112(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c8b27d751ccca8cd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$d9e57ad74f3a8629(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "policies",
        ...config
    });
}
function $f9a008fec395d7ff$export$d1348a35b34cfa20(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$d043d701f4baf48e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$71c8250cd636d15f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$cc4c26f15ee719eb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$a885eb5a75781b4f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "setPolicy",
        ...config
    });
}
function $f9a008fec395d7ff$export$d68437d557787f84(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$6d550f200760eaca(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e4b2aff792e0089c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$3d1a4c8e7b79e5d1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$6750cd832d9b4f23(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "setPolicy",
        ...config
    });
}
function $f9a008fec395d7ff$export$943a4d2aa4021ac4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$f125aeee1d215c04(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d59553e716d291bf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$1163c87b6218a12f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        eventName: "PolicyUpdate",
        ...config
    });
}
function $f9a008fec395d7ff$export$ef51c38f606893ec(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$e959445c7e81ce03(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3a00794eae5e4d69(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$4aaff2a8be24eb47(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "policies",
        ...config
    });
}
function $f9a008fec395d7ff$export$94d76e58851d80a9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$7abb9b2f668197b4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$62a6469cbed5007a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$797365eef08ac6b1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$acb7fe3eba19ba6d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "setPolicy",
        ...config
    });
}
function $f9a008fec395d7ff$export$7fe4fc96e7b3db84(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$3090d5ba374ed303(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c2c2e0eaa95fd942(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$c10c6e9503ac2c05(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$e49246c0283623c7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "setPolicy",
        ...config
    });
}
function $f9a008fec395d7ff$export$47a1776144e7d425(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$cef879351255ab38(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bfb3693f102d9748(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$ab72120a459a4904(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        eventName: "PolicyUpdate",
        ...config
    });
}
function $f9a008fec395d7ff$export$b20321fa3c85d33b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$86e644608486833c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f184324e62a15c9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "callbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$3de081d5f21445fc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$f491559ab605954(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$84f4cb5bc6e3878c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomNumbers",
        ...config
    });
}
function $f9a008fec395d7ff$export$78bfef6cb3811179(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$4a76e3507047eb75(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "receiveRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$e66feeafb766a532(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "requesterToID",
        ...config
    });
}
function $f9a008fec395d7ff$export$b594e324c2e391ed(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bba9cf95c2fcd563(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$521374446e26ab92(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$76ecb8a9a86ec3d1(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomizerCallback",
        ...config
    });
}
function $f9a008fec395d7ff$export$181916de2a67d346(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomizerWithdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$6ace74bc4d042df8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$a0be443dcbac2ef4(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "setCallbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$8d92019d8188e0c7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "setRandomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$8e7946d0c567feb0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$fdddac27bdf0b61b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bfbb58895306d873(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$581d34755d7fec23(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$4461ba5a9582fda9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomizerCallback",
        ...config
    });
}
function $f9a008fec395d7ff$export$f9668b3b06307a5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "randomizerWithdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$6c7794175ea1b0df(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$f0dc6e65bec6bde2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "setCallbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$833e46eea4fe7a34(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "setRandomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$ac4dfa58730c34aa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$5058bfcc627754(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$50688e7c36866d3d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$36789af718cbe0b8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$4e82434bdde47723(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$de93781c77e6a29a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "callbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$4343be1487b7b859(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$9aaf354b041df373(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$eb18f54434c687d6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomNumbers",
        ...config
    });
}
function $f9a008fec395d7ff$export$140dac13e6973a3f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$c367c7f2363322ac(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "receiveRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$cc71d6817f4dac3a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "requesterToID",
        ...config
    });
}
function $f9a008fec395d7ff$export$d03ca2ae37ac01e3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b1929972bd58c4be(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$ea40a17ac486c126(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$2232bcac4917b932(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomizerCallback",
        ...config
    });
}
function $f9a008fec395d7ff$export$7f5c6acbf17de36f(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomizerWithdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$51a1284a17e9646d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$1b3ed116e052d0a0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "setCallbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$45efb94cb683624e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "setRandomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$75470481fd40ae95(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$f677a43d63c55184(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6eb31c01d0025f3d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$cf92a61a4f85d717(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$c3d96cd97327b24(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomizerCallback",
        ...config
    });
}
function $f9a008fec395d7ff$export$39bdcdfdabdbf6be(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "randomizerWithdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$30a62b792065be51(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "requestRandomness",
        ...config
    });
}
function $f9a008fec395d7ff$export$7cc566225f921aa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "setCallbackGasLimit",
        ...config
    });
}
function $f9a008fec395d7ff$export$e55b1b42b411c346(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "setRandomizer",
        ...config
    });
}
function $f9a008fec395d7ff$export$186649e24b88a59a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$27c15221a998bd2b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6994b0dca547c31c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$5beef96e26ef02f7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$fef797c7f3468b5c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5f15c248bdf84505(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "core",
        ...config
    });
}
function $f9a008fec395d7ff$export$e758bdd83d776ef3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "delayedStakeReadIndex",
        ...config
    });
}
function $f9a008fec395d7ff$export$c722dbf539ae77b3(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "delayedStakeWriteIndex",
        ...config
    });
}
function $f9a008fec395d7ff$export$134fa1b54e26d1fa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "delayedStakes",
        ...config
    });
}
function $f9a008fec395d7ff$export$f75c9c14df8abcba(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "disputesWithoutJurors",
        ...config
    });
}
function $f9a008fec395d7ff$export$a29b2c8c0a532d1c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "draw",
        ...config
    });
}
function $f9a008fec395d7ff$export$95ba38bd72119500(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "getJurorBalance",
        ...config
    });
}
function $f9a008fec395d7ff$export$9d184f80790c1bfd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "getJurorCourtIDs",
        ...config
    });
}
function $f9a008fec395d7ff$export$d9ca331f5b5cbd14(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$158bfe1b9bbc3172(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "isJurorStaked",
        ...config
    });
}
function $f9a008fec395d7ff$export$9a4d23a80e82def9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "jurors",
        ...config
    });
}
function $f9a008fec395d7ff$export$ae4a244e109e6877(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "lastPhaseChange",
        ...config
    });
}
function $f9a008fec395d7ff$export$b3c2912d9752ffad(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "latestDelayedStakeIndex",
        ...config
    });
}
function $f9a008fec395d7ff$export$84c3ab904d8a0fec(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "maxDrawingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$d430ea2d6023b687(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "maxStakePerJuror",
        ...config
    });
}
function $f9a008fec395d7ff$export$153f532fa6dc1ee6(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "maxTotalStaked",
        ...config
    });
}
function $f9a008fec395d7ff$export$950ea7eb9fdd5f36(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "minStakingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$75f3587ab03a4584(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "phase",
        ...config
    });
}
function $f9a008fec395d7ff$export$ed34b95500d63056(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "proxiableUUID",
        ...config
    });
}
function $f9a008fec395d7ff$export$ea4dc024a0d50dc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "randomNumber",
        ...config
    });
}
function $f9a008fec395d7ff$export$e0bfbb068d6a2ed0(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "randomNumberRequestBlock",
        ...config
    });
}
function $f9a008fec395d7ff$export$bce3236db4eee434(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "rng",
        ...config
    });
}
function $f9a008fec395d7ff$export$299431ec25309fe5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "rngLookahead",
        ...config
    });
}
function $f9a008fec395d7ff$export$7a4fd22da132f43b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "stakeOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$5bac77093d9a6dc(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "totalStaked",
        ...config
    });
}
function $f9a008fec395d7ff$export$ecc11a41479b2582(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$486e0e31cbdac516(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxDrawingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$84a3216aeeb30596(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxStakePerJuror",
        ...config
    });
}
function $f9a008fec395d7ff$export$5e3f4a7dff57bebe(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxTotalStaked",
        ...config
    });
}
function $f9a008fec395d7ff$export$bf6b472b064e8d33(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMinStakingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$407e62c9a236671(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeRandomNumberGenerator",
        ...config
    });
}
function $f9a008fec395d7ff$export$5ada55bc8b1cc16b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "createDisputeHook",
        ...config
    });
}
function $f9a008fec395d7ff$export$52cbb34f4c6f0ae8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "createTree",
        ...config
    });
}
function $f9a008fec395d7ff$export$45250f407f6f2006(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "executeDelayedStakes",
        ...config
    });
}
function $f9a008fec395d7ff$export$932804525c6781bb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$3479b71e068340a9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "lockStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$10a86a8fdb31841c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "notifyRandomNumber",
        ...config
    });
}
function $f9a008fec395d7ff$export$95bbc13bbf370671(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "passPhase",
        ...config
    });
}
function $f9a008fec395d7ff$export$64479ab417935e83(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "penalizeStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$5600b0c60358c9e8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "postDrawHook",
        ...config
    });
}
function $f9a008fec395d7ff$export$2d16d5bc1e46a131(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "setJurorInactive",
        ...config
    });
}
function $f9a008fec395d7ff$export$ecc837095b1eee4b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "setStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$d7d90bfc361be5dd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "unlockStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$d53999f213fc05a5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$ef248b7d68900349(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ad3ad8c4b224f193(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxDrawingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$befd791c6efa8b4b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxStakePerJuror",
        ...config
    });
}
function $f9a008fec395d7ff$export$c436cdaed74ece76(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMaxTotalStaked",
        ...config
    });
}
function $f9a008fec395d7ff$export$a423d8221a568872(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeMinStakingTime",
        ...config
    });
}
function $f9a008fec395d7ff$export$eadcab9d3512108b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "changeRandomNumberGenerator",
        ...config
    });
}
function $f9a008fec395d7ff$export$eebb84db89efe04e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "createDisputeHook",
        ...config
    });
}
function $f9a008fec395d7ff$export$92607737f369955d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "createTree",
        ...config
    });
}
function $f9a008fec395d7ff$export$159c7bc9491c8127(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "executeDelayedStakes",
        ...config
    });
}
function $f9a008fec395d7ff$export$e8f724ec5a8a29c2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "initialize",
        ...config
    });
}
function $f9a008fec395d7ff$export$eec7e91308748c53(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "lockStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$b3d72fd71b4013df(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "notifyRandomNumber",
        ...config
    });
}
function $f9a008fec395d7ff$export$37e557da6342c2bb(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "passPhase",
        ...config
    });
}
function $f9a008fec395d7ff$export$9d0c595cad47d724(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "penalizeStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$60a8dcf625093a7b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "postDrawHook",
        ...config
    });
}
function $f9a008fec395d7ff$export$4c495fa93ff49e5a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "setJurorInactive",
        ...config
    });
}
function $f9a008fec395d7ff$export$6d6456468dc9ca0b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "setStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$e7f6d432fe049edf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "unlockStake",
        ...config
    });
}
function $f9a008fec395d7ff$export$5c62650213442bd8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        functionName: "upgradeToAndCall",
        ...config
    });
}
function $f9a008fec395d7ff$export$44fbc9434545ba8a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$48fc408d7eef9f95(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "Initialized",
        ...config
    });
}
function $f9a008fec395d7ff$export$6b0db805e8e1fae8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "NewPhase",
        ...config
    });
}
function $f9a008fec395d7ff$export$8b7960032f42ca28(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "StakeDelayedAlreadyTransferred",
        ...config
    });
}
function $f9a008fec395d7ff$export$24dad3f4b1e7eef8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "StakeDelayedAlreadyTransferredWithdrawn",
        ...config
    });
}
function $f9a008fec395d7ff$export$56dff9a771066728(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "StakeDelayedNotTransferred",
        ...config
    });
}
function $f9a008fec395d7ff$export$41cbf6e58ec3df2b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "StakeLocked",
        ...config
    });
}
function $f9a008fec395d7ff$export$45d240b30f55d93(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "StakeSet",
        ...config
    });
}
function $f9a008fec395d7ff$export$5a0fbd1f882ed0a9(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        eventName: "Upgraded",
        ...config
    });
}
function $f9a008fec395d7ff$export$af8814903c49d07a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$4afe77085e61823a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "allowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$f8e7086deb12c166(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "balanceOf",
        ...config
    });
}
function $f9a008fec395d7ff$export$f64aea0e53858d2d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "decimals",
        ...config
    });
}
function $f9a008fec395d7ff$export$20a4e44195fe143c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "name",
        ...config
    });
}
function $f9a008fec395d7ff$export$74623b0131234a2d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "symbol",
        ...config
    });
}
function $f9a008fec395d7ff$export$26c219e3f4dd776(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "totalSupply",
        ...config
    });
}
function $f9a008fec395d7ff$export$1d144ba17cab57dd(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f4c0caeef01e6f52(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$4c71c846b98378d5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$c52340b45568b02a(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$8bddc351cc4d470d(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$de3a16d06fb85cb5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$c08d9c750ef3fd39(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b5a74f2eb4dfa088(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "approve",
        ...config
    });
}
function $f9a008fec395d7ff$export$1c0856f9b0e3cd06(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "decreaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$353c85ea07474751(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "increaseAllowance",
        ...config
    });
}
function $f9a008fec395d7ff$export$5bd9cbcc037e8311(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$e84444748768b305(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        functionName: "transferFrom",
        ...config
    });
}
function $f9a008fec395d7ff$export$7b0575bf664f5be2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e2a4869d112782cf(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        eventName: "Approval",
        ...config
    });
}
function $f9a008fec395d7ff$export$315792e0ef34fcaa(config = {}) {
    return (0, $1d657eb5d64e17dc$export$fa3bb2588a62576e)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        eventName: "Transfer",
        ...config
    });
}
function $f9a008fec395d7ff$export$8b57825ace21e086(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$adb7c7a048fef7d2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "amount",
        ...config
    });
}
function $f9a008fec395d7ff$export$492f41c6ffceac16(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "balance",
        ...config
    });
}
function $f9a008fec395d7ff$export$a6465929e8d3d51c(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "governor",
        ...config
    });
}
function $f9a008fec395d7ff$export$846353b8f003b3b2(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "token",
        ...config
    });
}
function $f9a008fec395d7ff$export$a1fac01fedce0e69(config = {}) {
    return (0, $1d657eb5d64e17dc$export$6f78c1774963fe2d)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "withdrewAlready",
        ...config
    });
}
function $f9a008fec395d7ff$export$af96215df02306a7(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3ed0b5f9a6a4cb72(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$1ba12d02c1be12b(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$f15f83a72f7b9051(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$97383adcf3a6f3e(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f65fbf805a7dc8c5)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$4e1950a45911488(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7d75fa7481c987e8(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "changeAmount",
        ...config
    });
}
function $f9a008fec395d7ff$export$89419b318695f126(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $f9a008fec395d7ff$export$203edbf889e22556(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "request",
        ...config
    });
}
function $f9a008fec395d7ff$export$acecbebaaf8fef5(config = {}) {
    return (0, $1d657eb5d64e17dc$export$f08fad0d21112083)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        functionName: "withdraw",
        ...config
    });
}
function $f9a008fec395d7ff$export$dc4499d20178eb66(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bbaf188fc410ff77(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$be9fcbbb5d56a263(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5cefcd0e8f969e20(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$fc0bd2998c4536b1(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$2a729c04c0770003,
        address: $f9a008fec395d7ff$export$b1c3f271a5b03251[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$f9f2c550b6b6f735(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$caf164283a9090ab(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6cec658e9b2365c9(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a18e472766b447f5(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$f0e1c8caa817fcf0,
        address: $f9a008fec395d7ff$export$88d5a6a2ba9a9127[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$daf276edc0b404e(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a109eb7560cc90d3(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7beae231933ff388(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$66da1c722d038079(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$19d867a0665cc7e2(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$527864715988df1d,
        address: $f9a008fec395d7ff$export$62d6202aafa1805[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$181379257af38a9(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$4a5b9a538c0cf6bc(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9f2ae102ca7ba5ba(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3bcee3e204e6e19e(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$8172254fb3ff28dc,
        address: $f9a008fec395d7ff$export$c4fe804a77f96bba[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d0cf73d1ca7d3b33(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c612f1b251749a9a(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$dc603e39ccd6a616(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c468de00f7a9e817(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$cbec6ee84f4c8bed(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$9d92e3a5576cce40,
        address: $f9a008fec395d7ff$export$50ec6c3f9ccece46[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$4d6959ac852be5e9(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7f655ec7cc8afbf0(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$725bfa641ad74cc5(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e01b5ffb37570c39(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$513d97e8ff20a20f(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$bcabc9035c41728d,
        address: $f9a008fec395d7ff$export$6f9cc1e72fe3b948[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$ca9e0bb2ad0f983c(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$56cd5456c2533aeb(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f87f3f5858e6b636(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$69a48805eca6ad16(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$eaddb652a7e4656a(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$d1e10d5f7b143922,
        address: $f9a008fec395d7ff$export$627e9d8b31980128[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$a9610b781c948387(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5c8a56e9cf821efc(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$2b005960b0d8c58f(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$508afa50e53916bf(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6342a148ecab7b0e(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$21d9c3f0deb225ff,
        address: $f9a008fec395d7ff$export$56ddab1233a38980[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$7cc689f0d04100a(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$314f357ca361fd22,
        address: $f9a008fec395d7ff$export$5247f0db3dae2260[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$20a06e981a454731(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7b157d4b4208efdf(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$1b54730822e9f1f3(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ab6b51e2bc748ef6(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$584ed967f3a2b7cd(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$68d04ee65bd7e0a,
        address: $f9a008fec395d7ff$export$a553812daab5b0cd[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$7e769065c053f834(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c23b99f07331aefb(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5399354853ee2a68(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5138c98f42123583(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9266f6eb81c882da(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$805f4356e8f2695d,
        address: $f9a008fec395d7ff$export$dc8fc3ebdd2d63b2[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$2b05a8938b8251d1(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$29750e468c88861c,
        address: $f9a008fec395d7ff$export$134c483d74ac3e8b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$67ef5ffb4cf48435(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$5120be9d894d7556(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$4fd37319ab06d2e5(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    });
}
function $f9a008fec395d7ff$export$505e4bb1ccb82d55(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$ee81f679a1a6e4b5,
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$94eedb953922a6a9(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$348fe6a3c3127257(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$738d71b9aa7f9545(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$7bb319ebc439c3c5(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    });
}
function $f9a008fec395d7ff$export$be4cf3ed6591d167(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$2f0cf58b4951e73a,
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$b545a82fd08a2b5f(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3c1ddf6484163efe(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$1f73ff500253db6d(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3663e1e8b38475a9(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5dd8d78fec1c8934(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$6b6e38efde31b17e,
        address: $f9a008fec395d7ff$export$5145390c9c1a56dc[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$9cca3f225803099a(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$bdf7a1a6d576363b(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f5c08674844af06c(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d6ef20d1f27ef80f(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$7638261934eb229a(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$c074b75d6cecd21e,
        address: $f9a008fec395d7ff$export$c1400aa8011edd44[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$212eea540589e65f(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a48862d276ddf71b(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c6e9845e551ae11b(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b81872fce786fd6c(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d4b1c082ef051790(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$3dde6bb809ea3570,
        address: $f9a008fec395d7ff$export$1c8e2910270b6c57[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$be79f9ce44da224f(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$4ae8e128c533d8b9(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$60288840474ced(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$37d10d37681627fb(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$db30be73c7bdbbc8,
        address: $f9a008fec395d7ff$export$970296fc1189410d[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a4a30acb68cda4a6(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ad53f065731a02da(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$b7a1ac480da56297(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$3327cced5d53a32(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c159b3d47035eb3c(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$4030a337ba3b0f2c,
        address: $f9a008fec395d7ff$export$1fbe0966f612778b[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$ee0ce4b11e41c5ed(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$32de081ef603a73f(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$baca785c2534d6a4(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$a330cd6987046e9b(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$1be8b63928d946f2(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$a1b769c2e116c47a,
        address: $f9a008fec395d7ff$export$d8b41a349669c712[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$965d3ccfcdb66d75(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$d7db146f9ca83a29(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$2bc35b7979a46737(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$64843badee6fafb8(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$5d2d9f0085e94215(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$c28ad79f11f8bc64,
        address: $f9a008fec395d7ff$export$6849cbec8eff493e[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$ede885451f6fae91(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$9d566d587e85c9f2,
        address: $f9a008fec395d7ff$export$7c9f54d01b14188e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$47aed6f22d449252(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$8882b387808251bf,
        address: $f9a008fec395d7ff$export$e6c42df816cd4259[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$da09824d9af403ea(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$20657784b3b3e9ed(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$1205d08ba2d4c51b(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$8837081dc85e49f0(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$30848ba500879c64(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$df1930c12a28053e,
        address: $f9a008fec395d7ff$export$f192064499d2682e[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$43da76c48b758013(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$925e76948343b908(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$31954b655d40851c(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$81f996c7e398438d(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e12f9ed2b639cee3(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$ceaad6fc42916c20,
        address: $f9a008fec395d7ff$export$127f249ce66d8696[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$98b43bf9878f7d5c(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$8c32c4aa051093d9,
        address: $f9a008fec395d7ff$export$23101ae2e06b0b9b[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$6fdc36534b400082(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$c875ad91802ede02(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$9bec613c8fc2eea2(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$57aeb1563fa95bf1(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$ef152947333a0950(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$e9a148b942b5cada,
        address: $f9a008fec395d7ff$export$c593fe1244035095[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$15bab5d8b9fc2384(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$328c26dfada4680a(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$e6204bf128dc437d(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$f485a2ec72f4383f(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$dbf75b62ac6f68d3(config, callback) {
    return (0, $eUiaP.watchContractEvent)({
        abi: $f9a008fec395d7ff$export$4b0ccc96b6d839ce,
        address: $f9a008fec395d7ff$export$ce878659290aa7e4[421614],
        ...config
    }, callback);
}
function $f9a008fec395d7ff$export$3950fe020925c33d(config) {
    return (0, $eUiaP.getContract)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$4c23205ff6e7e895(config) {
    return (0, $eUiaP.readContract)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$316fbdda2b4fd9fe(config) {
    return (0, $eUiaP.writeContract)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}
function $f9a008fec395d7ff$export$2443914b724df244(config) {
    return (0, $eUiaP.prepareWriteContract)({
        abi: $f9a008fec395d7ff$export$dc501b985d178688,
        address: $f9a008fec395d7ff$export$c7443d37daeed2d9[421614],
        ...config
    });
}


const $ec06a9cc6215563d$export$75f3587ab03a4584 = ()=>{
    // eslint-disable-next-line
    // @ts-ignore
    return (0, $f9a008fec395d7ff$export$fef797c7f3468b5c)({
        functionName: "phase",
        watch: true
    });
};




const $44ae019c61a73e7d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0px 3px;

  label,
  a {
    font-family: "Roboto Mono", monospace;
    line-height: 10px;
    font-size: 10px;
    color: ${({ theme: theme })=>theme.stroke};
  }
`;
const $44ae019c61a73e7d$var$StyledIframe = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).iframe`
  border: none;
  width: 100%;
  height: 30px;
  border-radius: 3px;
`;
const $44ae019c61a73e7d$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  padding-left: 8px;
`;
const $44ae019c61a73e7d$var$Version = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)($44ae019c61a73e7d$var$StyledLabel, {
        children: [
            "v",
            (0, $203b613495c69c62$export$f1af843f4d252578),
            " ",
            /*#__PURE__*/ (0, $cZGFG.jsxs)("a", {
                href: (0, $203b613495c69c62$export$1c46d8639ab5b0b),
                target: "_blank",
                rel: "noreferrer",
                children: [
                    "#",
                    (0, $203b613495c69c62$export$8439c9c045e5384d)
                ]
            }),
            (0, $203b613495c69c62$export$512554f3e5add99) && (0, $203b613495c69c62$export$512554f3e5add99) !== "HEAD" && ` ${0, $203b613495c69c62$export$512554f3e5add99}`,
            (0, $203b613495c69c62$export$ac95da7ac2645a99) && ` ${0, $203b613495c69c62$export$ac95da7ac2645a99}`,
            (0, $203b613495c69c62$export$91f55afd4519d50b) && ` dirty`
        ]
    });
const $44ae019c61a73e7d$var$ServicesStatus = ()=>{
    const [theme] = (0, $56d2a25ae1caf5b4$export$c07acc0415d9f757)();
    const statusUrlParameters = (0, $dup7A.useMemo)(()=>theme === "light" ? "?theme=light" : "?theme=dark", [
        theme
    ]);
    const statusUrl = "https://kleros-v2-devnet.betteruptime.com/badge";
    return /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
        children: (0, $2d857633ba67aa25$export$fce6876652108ab)(statusUrl) ? null : /*#__PURE__*/ (0, $cZGFG.jsx)($44ae019c61a73e7d$var$StyledIframe, {
            src: `${statusUrl + statusUrlParameters}`
        })
    });
};
var $44ae019c61a73e7d$var$Phases;
(function(Phases) {
    Phases[Phases["staking"] = 0] = "staking";
    Phases[Phases["generating"] = 1] = "generating";
    Phases[Phases["drawing"] = 2] = "drawing";
})($44ae019c61a73e7d$var$Phases || ($44ae019c61a73e7d$var$Phases = {}));
const $44ae019c61a73e7d$var$Phase = ()=>{
    const { data: phase } = (0, $ec06a9cc6215563d$export$75f3587ab03a4584)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: (0, $2d857633ba67aa25$export$fce6876652108ab)(phase) ? null : /*#__PURE__*/ (0, $cZGFG.jsxs)($44ae019c61a73e7d$var$StyledLabel, {
            children: [
                "Phase: ",
                $44ae019c61a73e7d$var$Phases[phase]
            ]
        })
    });
};
const $44ae019c61a73e7d$var$Debug = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($44ae019c61a73e7d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($44ae019c61a73e7d$var$ServicesStatus, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($44ae019c61a73e7d$var$Version, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($44ae019c61a73e7d$var$Phase, {})
        ]
    });
};
var $44ae019c61a73e7d$export$2e2bcd8739ae039 = $44ae019c61a73e7d$var$Debug;


const $1942bfdad6e7bb9d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
  width: 86vw;
  max-width: 444px;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  padding: 27px 10px;
  gap: 23px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border-radius: 3px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-top: 64px;
      width: 260px;
      top: 0;
      right: 0;
      left: auto;
      transform: none;
    `)}
`;
const $1942bfdad6e7bb9d$var$ListItem = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  gap: 8px;
  padding: 0px 8px;
  cursor: pointer;
  :hover {
    transform: scale(1.02) translateZ(0);
    transition: 200ms;
    transition-timing-function: cubic-bezier(0.3, 0, 0.2, 1);
    backface-visibility: hidden;
  }

  small {
    font-size: 16px;
    font-weight: 400;
  }
`;
const $1942bfdad6e7bb9d$var$Icon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  display: inline-block;
  width: 16px;
  height: 16px;
  fill: ${({ theme: theme })=>theme.secondaryPurple};
`;
const $1942bfdad6e7bb9d$var$ITEMS = [
    {
        text: "Onboarding",
        Icon: (0, $479b94db725a216f$export$2e2bcd8739ae039)
    },
    {
        text: "Get Help",
        Icon: (0, $e5e17f601f1fb0e1$export$2e2bcd8739ae039),
        url: "https://t.me/kleros"
    },
    {
        text: "Report a Bug",
        Icon: (0, $49273a0aaa543c8e$export$2e2bcd8739ae039),
        url: "https://github.com/kleros/kleros-v2/issues"
    },
    {
        text: "DApp Guide",
        Icon: (0, $65c4ca3a896442f8$export$2e2bcd8739ae039),
        url: "https://docs.kleros.io/products/court-v2"
    },
    {
        text: "Crypto Beginner's Guide",
        Icon: (0, $ef68e50e48a94340$export$2e2bcd8739ae039),
        url: "https://ethereum.org/en/wallets/"
    },
    {
        text: "FAQ",
        Icon: (0, $1265c0970d93b919$export$2e2bcd8739ae039),
        url: "https://docs.kleros.io/kleros-faq"
    }
];
const $1942bfdad6e7bb9d$var$Help = ({ toggleIsHelpOpen: toggleIsHelpOpen })=>{
    const [isOnboardingMiniGuidesOpen, toggleIsOnboardingMiniGuidesOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(containerRef, ()=>{
        if (!isOnboardingMiniGuidesOpen) toggleIsHelpOpen();
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1942bfdad6e7bb9d$var$Container, {
                ref: containerRef,
                children: [
                    $1942bfdad6e7bb9d$var$ITEMS.map((item, index)=>/*#__PURE__*/ (0, $cZGFG.jsxs)($1942bfdad6e7bb9d$var$ListItem, {
                            href: item.url,
                            target: "_blank",
                            onClick: index === 0 ? ()=>toggleIsOnboardingMiniGuidesOpen() : undefined,
                            children: [
                                /*#__PURE__*/ (0, $cZGFG.jsx)($1942bfdad6e7bb9d$var$Icon, {
                                    as: item.Icon
                                }),
                                /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                                    children: item.text
                                })
                            ]
                        }, item.text)),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $44ae019c61a73e7d$export$2e2bcd8739ae039), {})
                ]
            }),
            isOnboardingMiniGuidesOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $160529238ec58480$export$2e2bcd8739ae039), {
                toggleMiniGuide: toggleIsOnboardingMiniGuidesOpen
            })
        ]
    });
};
var $1942bfdad6e7bb9d$export$2e2bcd8739ae039 = $1942bfdad6e7bb9d$var$Help;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $57a33e957f4dc1ed$export$c640ece8678a7df5 = ({ children: children, className: className })=>{
    const { chain: chain } = (0, $1d657eb5d64e17dc$export$553aaf59afc1a2d8)();
    return chain && chain.id === (0, $32162005f9f3d1a7$export$8372812df8e8183f) ? children : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5fd7f782fb0a380f$export$2e2bcd8739ae039), {
        className: className
    });
};


const $c524301795922ce0$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 12px;
`;
const $c524301795922ce0$var$StyledChainContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  height: 34px;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  :before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme: theme })=>theme.success};
  }
  > label {
    color: ${({ theme: theme })=>theme.success};
  }
`;
const $c524301795922ce0$var$StyledAddressContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  > label {
    color: ${({ theme: theme })=>theme.primaryText};
    font-size: 16px;
    font-weight: 600;
  }
`;
const $c524301795922ce0$var$StyledAvatarContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;
const $c524301795922ce0$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;
const $c524301795922ce0$var$EnsureChainContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding: 16px;
`;
const $c524301795922ce0$var$UserContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $c524301795922ce0$export$c604e936fdf27a02 = ()=>{
    const { disconnect: disconnect } = (0, $1d657eb5d64e17dc$export$83bebf2fe7fead4e)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
        text: `Disconnect`,
        onClick: ()=>disconnect()
    });
};
const $c524301795922ce0$var$General = ()=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$EnsureChainContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
            children: /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$Container, {
                children: address && /*#__PURE__*/ (0, $cZGFG.jsxs)($c524301795922ce0$var$UserContainer, {
                    children: [
                        /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$StyledAvatarContainer, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$f8b4f9182cfa7b1d), {
                                size: "48"
                            })
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$StyledAddressContainer, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$6cdabdfc8e8da8af), {})
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$StyledChainContainer, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$97063c1c513ee59f), {})
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$var$StyledButton, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)($c524301795922ce0$export$c604e936fdf27a02, {})
                        })
                    ]
                })
            })
        })
    });
};
var $c524301795922ce0$export$2e2bcd8739ae039 = $c524301795922ce0$var$General;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");
var $8a919c84a5c9d8b4$export$2e2bcd8739ae039 = crypto;
const $8a919c84a5c9d8b4$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $336c72c186be4719$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $336c72c186be4719$export$2e2bcd8739ae039 = $336c72c186be4719$var$digest;


const $b00077c9fa30e5cf$export$5486af06137bf21a = new TextEncoder();
const $b00077c9fa30e5cf$export$124c96e6ce37090b = new TextDecoder();
const $b00077c9fa30e5cf$var$MAX_INT32 = 2 ** 32;
function $b00077c9fa30e5cf$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $b00077c9fa30e5cf$export$256d3ca12372f112(alg, p2sInput) {
    return $b00077c9fa30e5cf$export$ee1b3e54f0441b22($b00077c9fa30e5cf$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $b00077c9fa30e5cf$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $b00077c9fa30e5cf$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$b00077c9fa30e5cf$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $b00077c9fa30e5cf$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $b00077c9fa30e5cf$var$MAX_INT32);
    const low = value % $b00077c9fa30e5cf$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $b00077c9fa30e5cf$var$writeUInt32BE(buf, high, 0);
    $b00077c9fa30e5cf$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $b00077c9fa30e5cf$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $b00077c9fa30e5cf$var$writeUInt32BE(buf, value);
    return buf;
}
function $b00077c9fa30e5cf$export$c1498c4a3718d967(input) {
    return $b00077c9fa30e5cf$export$ee1b3e54f0441b22($b00077c9fa30e5cf$export$74c16dba6c885532(input.length), input);
}
async function $b00077c9fa30e5cf$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($b00077c9fa30e5cf$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $336c72c186be4719$export$2e2bcd8739ae039)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $4c62bd8bbcc8e16f$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $4c62bd8bbcc8e16f$export$c564cdbbe6da493 = (input)=>{
    return $4c62bd8bbcc8e16f$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $4c62bd8bbcc8e16f$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $4c62bd8bbcc8e16f$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $4c62bd8bbcc8e16f$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};



class $e8cadc15024149aa$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $e8cadc15024149aa$export$f1e14efb908196e9 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $e8cadc15024149aa$export$4b386bf852b7863d extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $e8cadc15024149aa$export$d51fd7fedeccc338 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $e8cadc15024149aa$export$19ddbcbf2016ab28 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $e8cadc15024149aa$export$1a57512ad9773b2a extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $e8cadc15024149aa$export$19f281f2275f6a15 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $e8cadc15024149aa$export$e838de724af3d116 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $e8cadc15024149aa$export$936b39ada0bbfceb extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $e8cadc15024149aa$export$b3992e0f88fb07e3 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $e8cadc15024149aa$export$9b22c2a1e2403b8e extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $e8cadc15024149aa$export$3d5ed1a538bed04e extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $e8cadc15024149aa$export$dc036de401a5c284 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $e8cadc15024149aa$export$3f30acebf25c04e6 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $e8cadc15024149aa$export$c67a0218e7c50378 extends $e8cadc15024149aa$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}




var $82bfd1bdcc7654f2$export$2e2bcd8739ae039 = (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).getRandomValues.bind((0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039));


function $ace90ca042532feb$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $ace90ca042532feb$export$2e2bcd8739ae039 = (alg)=>(0, $82bfd1bdcc7654f2$export$2e2bcd8739ae039)(new Uint8Array($ace90ca042532feb$export$db433e85ac514a95(alg) >> 3));


const $8fd4bdb438544232$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $ace90ca042532feb$export$db433e85ac514a95)(enc)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Invalid Initialization Vector length");
};
var $8fd4bdb438544232$export$2e2bcd8739ae039 = $8fd4bdb438544232$var$checkIvLength;



const $8065f314b493b15a$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $8065f314b493b15a$export$2e2bcd8739ae039 = $8065f314b493b15a$var$checkCekLength;


const $faf11861d0c6568c$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $faf11861d0c6568c$export$2e2bcd8739ae039 = $faf11861d0c6568c$var$timingSafeEqual;




function $aa6e5f59c2d8fea1$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $aa6e5f59c2d8fea1$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $aa6e5f59c2d8fea1$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $aa6e5f59c2d8fea1$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $aa6e5f59c2d8fea1$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $aa6e5f59c2d8fea1$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "HMAC")) throw $aa6e5f59c2d8fea1$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $aa6e5f59c2d8fea1$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $aa6e5f59c2d8fea1$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $aa6e5f59c2d8fea1$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $aa6e5f59c2d8fea1$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $aa6e5f59c2d8fea1$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $aa6e5f59c2d8fea1$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "ECDSA")) throw $aa6e5f59c2d8fea1$var$unusable("ECDSA");
                const expected = $aa6e5f59c2d8fea1$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $aa6e5f59c2d8fea1$var$checkUsage(key, usages);
}
function $aa6e5f59c2d8fea1$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $aa6e5f59c2d8fea1$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "AES-KW")) throw $aa6e5f59c2d8fea1$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $aa6e5f59c2d8fea1$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $aa6e5f59c2d8fea1$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$aa6e5f59c2d8fea1$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $aa6e5f59c2d8fea1$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $aa6e5f59c2d8fea1$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $aa6e5f59c2d8fea1$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $aa6e5f59c2d8fea1$var$checkUsage(key, usages);
}


function $7698688ddb8f3ffb$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $7698688ddb8f3ffb$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $7698688ddb8f3ffb$var$message("Key must be ", actual, ...types);
};
function $7698688ddb8f3ffb$export$e94f758d09bc1828(alg, actual, ...types) {
    return $7698688ddb8f3ffb$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $55449e07a74f6a9c$export$2e2bcd8739ae039 = (key)=>{
    return (0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key);
};
const $55449e07a74f6a9c$export$b14ad400b1d09e0f = [
    "CryptoKey"
];


async function $5f6578b1eabc355c$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $b00077c9fa30e5cf$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $faf11861d0c6568c$export$2e2bcd8739ae039)(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $e8cadc15024149aa$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $e8cadc15024149aa$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $5f6578b1eabc355c$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch  {
        throw new (0, $e8cadc15024149aa$export$1a57512ad9773b2a)();
    }
}
const $5f6578b1eabc355c$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(cek, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!iv) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Initialization Vector missing");
    if (!tag) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Authentication Tag missing");
    (0, $8fd4bdb438544232$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $8065f314b493b15a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $5f6578b1eabc355c$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $8065f314b493b15a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $5f6578b1eabc355c$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $5f6578b1eabc355c$export$2e2bcd8739ae039 = $5f6578b1eabc355c$var$decrypt;



const $aa1f2b3d081451ec$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $aa1f2b3d081451ec$export$2e2bcd8739ae039 = $aa1f2b3d081451ec$var$isDisjoint;


function $c1b61ad1fc4d17cc$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $c1b61ad1fc4d17cc$export$2e2bcd8739ae039(input) {
    if (!$c1b61ad1fc4d17cc$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


const $c05b95a57ce4a353$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $c05b95a57ce4a353$export$2e2bcd8739ae039 = $c05b95a57ce4a353$var$bogusWebCrypto;






function $32529596dbbc1d26$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $32529596dbbc1d26$var$getCryptoKey(key, alg, usage) {
    if ((0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) {
        (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
}
const $32529596dbbc1d26$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $32529596dbbc1d26$var$getCryptoKey(key, alg, "wrapKey");
    $32529596dbbc1d26$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $c05b95a57ce4a353$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $32529596dbbc1d26$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $32529596dbbc1d26$var$getCryptoKey(key, alg, "unwrapKey");
    $32529596dbbc1d26$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $c05b95a57ce4a353$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
};







async function $62f5c170df979fc9$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(publicKey)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(publicKey, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(publicKey, "ECDH");
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(privateKey)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(privateKey, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(privateKey, "ECDH", "deriveBits");
    const value = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)((0, $b00077c9fa30e5cf$export$c1498c4a3718d967)((0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(algorithm)), (0, $b00077c9fa30e5cf$export$c1498c4a3718d967)(apu), (0, $b00077c9fa30e5cf$export$c1498c4a3718d967)(apv), (0, $b00077c9fa30e5cf$export$74c16dba6c885532)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $b00077c9fa30e5cf$export$67163693c21af44f)(sharedSecret, keyLength, value);
}
async function $62f5c170df979fc9$export$1338dee8c889e310(key) {
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $62f5c170df979fc9$export$f28ab77d793719b2(key) {
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}







function $f553dc2949e04f72$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("PBES2 Salt Input must be 8 or more octets");
}






function $2ff235c4fedd5cf2$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) {
        (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
}
async function $2ff235c4fedd5cf2$var$deriveKey(p2s, alg, p2c, key) {
    (0, $f553dc2949e04f72$export$2e2bcd8739ae039)(p2s);
    const salt = (0, $b00077c9fa30e5cf$export$256d3ca12372f112)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $2ff235c4fedd5cf2$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $2ff235c4fedd5cf2$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $82bfd1bdcc7654f2$export$2e2bcd8739ae039)(new Uint8Array(16)))=>{
    const derived = await $2ff235c4fedd5cf2$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $32529596dbbc1d26$export$4997ffc0176396a6)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(p2s)
    };
};
const $2ff235c4fedd5cf2$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $2ff235c4fedd5cf2$var$deriveKey(p2s, alg, p2c, key);
    return (0, $32529596dbbc1d26$export$debb760848ca95a)(alg.slice(-6), derived, encryptedKey);
};



function $c61bd501f6fcbcc0$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}





var $fe8023ed70d09b05$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};




const $2c2a60d328c28cdb$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(key, alg, "encrypt", "wrapKey");
    (0, $fe8023ed70d09b05$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.encrypt((0, $c61bd501f6fcbcc0$export$2e2bcd8739ae039)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $c05b95a57ce4a353$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $c61bd501f6fcbcc0$export$2e2bcd8739ae039)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $2c2a60d328c28cdb$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(key, alg, "decrypt", "unwrapKey");
    (0, $fe8023ed70d09b05$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.decrypt((0, $c61bd501f6fcbcc0$export$2e2bcd8739ae039)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, key, (0, $c61bd501f6fcbcc0$export$2e2bcd8739ae039)(alg), ...(0, $c05b95a57ce4a353$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};






function $bd8968759404367f$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $bd8968759404367f$export$2e2bcd8739ae039 = (alg)=>(0, $82bfd1bdcc7654f2$export$2e2bcd8739ae039)(new Uint8Array($bd8968759404367f$export$db433e85ac514a95(alg) >> 3));






var $80344e10340af670$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




const $b7f21195dfae7da9$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $80344e10340af670$export$2e2bcd8739ae039)((0, $4c62bd8bbcc8e16f$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b7f21195dfae7da9$export$cfba7e924fe414ca = (key)=>{
    return $b7f21195dfae7da9$var$genericExport("public", "spki", key);
};
const $b7f21195dfae7da9$export$cac76a78a90b914d = (key)=>{
    return $b7f21195dfae7da9$var$genericExport("private", "pkcs8", key);
};
const $b7f21195dfae7da9$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b7f21195dfae7da9$var$findOid(keyData, oid, i + 1);
};
const $b7f21195dfae7da9$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $b7f21195dfae7da9$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $b7f21195dfae7da9$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $b7f21195dfae7da9$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $b7f21195dfae7da9$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $b7f21195dfae7da9$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b7f21195dfae7da9$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $b7f21195dfae7da9$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b7f21195dfae7da9$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $b7f21195dfae7da9$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $b7f21195dfae7da9$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b7f21195dfae7da9$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b7f21195dfae7da9$var$spkiFromX509(buf) {
    const tbsCertificate = $b7f21195dfae7da9$var$getElement($b7f21195dfae7da9$var$getElement($b7f21195dfae7da9$var$parseElement(buf).contents)[0].contents);
    return (0, $4c62bd8bbcc8e16f$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b7f21195dfae7da9$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $4c62bd8bbcc8e16f$export$94fdf11bafc8de6b)(pem);
    return (0, $80344e10340af670$export$2e2bcd8739ae039)($b7f21195dfae7da9$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $b7f21195dfae7da9$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b7f21195dfae7da9$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $b7f21195dfae7da9$export$f9a3505cdaa1fb3e(spki, alg, options);
};




function $882aacade8bc24fc$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $882aacade8bc24fc$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $882aacade8bc24fc$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
};
var $882aacade8bc24fc$export$2e2bcd8739ae039 = $882aacade8bc24fc$var$parse;




async function $1d8c89fcf5aec791$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $b7f21195dfae7da9$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $1d8c89fcf5aec791$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $b7f21195dfae7da9$export$ed788b6a8533858f)(x509, alg, options);
}
async function $1d8c89fcf5aec791$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $b7f21195dfae7da9$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $1d8c89fcf5aec791$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $882aacade8bc24fc$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




const $d599dfcae79000ca$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $55449e07a74f6a9c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$e94f758d09bc1828)(alg, key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $d599dfcae79000ca$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $55449e07a74f6a9c$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$e94f758d09bc1828)(alg, key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
    if (key.type === "secret") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $d599dfcae79000ca$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $d599dfcae79000ca$var$symmetricTypeCheck(alg, key);
    else $d599dfcae79000ca$var$asymmetricTypeCheck(alg, key, usage);
};
var $d599dfcae79000ca$export$2e2bcd8739ae039 = $d599dfcae79000ca$var$checkKeyType;












async function $2134257012c7e1de$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $b00077c9fa30e5cf$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
async function $2134257012c7e1de$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $aa6e5f59c2d8fea1$export$41a67f89f6678b35)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
const $2134257012c7e1de$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(cek, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (iv) (0, $8fd4bdb438544232$export$2e2bcd8739ae039)(enc, iv);
    else iv = (0, $ace90ca042532feb$export$2e2bcd8739ae039)(enc);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $8065f314b493b15a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $2134257012c7e1de$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $8065f314b493b15a$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $2134257012c7e1de$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $2134257012c7e1de$export$2e2bcd8739ae039 = $2134257012c7e1de$var$encrypt;




async function $b31172ec8be50d67$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    const wrapped = await (0, $2134257012c7e1de$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: wrapped.ciphertext,
        iv: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(wrapped.iv),
        tag: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(wrapped.tag)
    };
}
async function $b31172ec8be50d67$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $5f6578b1eabc355c$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}


async function $3f402babb093328d$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $d599dfcae79000ca$export$2e2bcd8739ae039)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$62f5c170df979fc9$export$f28ab77d793719b2(key)) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $1d8c89fcf5aec791$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(joseHeader.apu);
                    } catch  {
                        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(joseHeader.apv);
                    } catch  {
                        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $62f5c170df979fc9$export$87770b6b245073b5(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $bd8968759404367f$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                return (0, $32529596dbbc1d26$export$debb760848ca95a)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $2c2a60d328c28cdb$export$e85a0c9a1067c5d3)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(joseHeader.p2s);
                } catch  {
                    throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the p2s");
                }
                return (0, $2ff235c4fedd5cf2$export$e85a0c9a1067c5d3)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $32529596dbbc1d26$export$debb760848ca95a)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(joseHeader.iv);
                } catch  {
                    throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(joseHeader.tag);
                } catch  {
                    throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the tag");
                }
                return (0, $b31172ec8be50d67$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $3f402babb093328d$export$2e2bcd8739ae039 = $3f402babb093328d$var$decryptKeyManagement;





function $513be064dcfa7c05$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $513be064dcfa7c05$export$2e2bcd8739ae039 = $513be064dcfa7c05$var$validateCrit;


const $47b752a4b6b7202b$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $47b752a4b6b7202b$export$2e2bcd8739ae039 = $47b752a4b6b7202b$var$validateAlgorithms;


async function $5296cd847e3aea31$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwe)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JOSE Header missing");
    if (jwe.iv !== undefined && typeof jwe.iv !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Initialization Vector incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Ciphertext missing or incorrect type");
    if (jwe.tag !== undefined && typeof jwe.tag !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Authentication Tag incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Protected Header is invalid");
    }
    if (!(0, $aa1f2b3d081451ec$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $513be064dcfa7c05$export$2e2bcd8739ae039)((0, $e8cadc15024149aa$export$19f281f2275f6a15), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $47b752a4b6b7202b$export$2e2bcd8739ae039)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $47b752a4b6b7202b$export$2e2bcd8739ae039)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith("PBES2")) throw new (0, $e8cadc15024149aa$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $e8cadc15024149aa$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.encrypted_key);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $3f402babb093328d$export$2e2bcd8739ae039)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $e8cadc15024149aa$export$19f281f2275f6a15) || err instanceof (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
    }
    let iv;
    let tag;
    if (jwe.iv !== undefined) try {
        iv = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.iv);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the iv");
    }
    if (jwe.tag !== undefined) try {
        tag = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.tag);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(jwe.protected ?? "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(protectedHeader, (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("."), (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.ciphertext);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the ciphertext");
    }
    const plaintext = await (0, $5f6578b1eabc355c$export$2e2bcd8739ae039)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jwe.aad);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $cca17c965c08a9cc$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("Invalid Compact JWE");
    const decrypted = await (0, $5296cd847e3aea31$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}






async function $874760f9040323c1$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwe)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039))) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $5296cd847e3aea31$export$b75cd12892ae94d2)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch  {}
    throw new (0, $e8cadc15024149aa$export$1a57512ad9773b2a)();
}
















const $0cba403967ee81b8$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(key)
    };
    if (!(0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.exportKey("jwk", key);
    return jwk;
};
var $0cba403967ee81b8$export$2e2bcd8739ae039 = $0cba403967ee81b8$var$keyToJWK;


async function $7ab6bce7884b98a6$export$7f687badbeed246d(key) {
    return (0, $b7f21195dfae7da9$export$cfba7e924fe414ca)(key);
}
async function $7ab6bce7884b98a6$export$ba4a7192ac1a47fe(key) {
    return (0, $b7f21195dfae7da9$export$cac76a78a90b914d)(key);
}
async function $7ab6bce7884b98a6$export$ffb510cfd482ce82(key) {
    return (0, $0cba403967ee81b8$export$2e2bcd8739ae039)(key);
}




async function $eb71a98dbbb253a2$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $d599dfcae79000ca$export$2e2bcd8739ae039)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$62f5c170df979fc9$export$f28ab77d793719b2(key)) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $62f5c170df979fc9$export$1338dee8c889e310(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $7ab6bce7884b98a6$export$ffb510cfd482ce82)(ephemeralKey);
                const sharedSecret = await $62f5c170df979fc9$export$87770b6b245073b5(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $bd8968759404367f$export$db433e85ac514a95)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(apu);
                if (apv) parameters.apv = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $32529596dbbc1d26$export$4997ffc0176396a6)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $2c2a60d328c28cdb$export$5b0f6292f11d1d18)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $2ff235c4fedd5cf2$export$5b0f6292f11d1d18)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $32529596dbbc1d26$export$4997ffc0176396a6)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $b31172ec8be50d67$export$4997ffc0176396a6)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $eb71a98dbbb253a2$export$2e2bcd8739ae039 = $eb71a98dbbb253a2$var$encryptKeyManagement;






const $9398d2f45a6cd83b$export$39c45cb77eaf132 = Symbol();
class $9398d2f45a6cd83b$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $aa1f2b3d081451ec$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $513be064dcfa7c05$export$2e2bcd8739ae039)((0, $e8cadc15024149aa$export$19f281f2275f6a15), new Map(), options?.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (this._cek && (alg === "dir" || alg === "ECDH-ES")) throw new TypeError(`setContentEncryptionKey cannot be called with JWE "alg" (Algorithm) Header ${alg}`);
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $eb71a98dbbb253a2$export$2e2bcd8739ae039)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $9398d2f45a6cd83b$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode((0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("");
        if (this._aad) {
            aadMember = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(this._aad);
            additionalData = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(protectedHeader, (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("."), (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(aadMember));
        } else additionalData = protectedHeader;
        const { ciphertext: ciphertext, tag: tag, iv: iv } = await (0, $2134257012c7e1de$export$2e2bcd8739ae039)(enc, this._plaintext, cek, this._iv, additionalData);
        const jwe = {
            ciphertext: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(ciphertext)
        };
        if (iv) jwe.iv = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(iv);
        if (tag) jwe.tag = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(tag);
        if (encryptedKey) jwe.encrypted_key = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}








class $ffff45fb84f8f0a1$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $ffff45fb84f8f0a1$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $ffff45fb84f8f0a1$var$IndividualRecipient(this, key, {
            crit: options?.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt() {
        if (!this._recipients.length) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("at least one recipient must be added");
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $9398d2f45a6cd83b$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options
            });
            const jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $aa1f2b3d081451ec$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $e8cadc15024149aa$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $513be064dcfa7c05$export$2e2bcd8739ae039)((0, $e8cadc15024149aa$export$19f281f2275f6a15), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        }
        const cek = (0, $bd8968759404367f$export$2e2bcd8739ae039)(enc);
        const jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $9398d2f45a6cd83b$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    [(0, $9398d2f45a6cd83b$export$39c45cb77eaf132)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $eb71a98dbbb253a2$export$2e2bcd8739ae039)(recipient.unprotectedHeader?.alg || this._protectedHeader?.alg || this._unprotectedHeader?.alg, enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}




function $2d3fc6112b07fd71$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}








function $2fd330191edafa99$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $8a919c84a5c9d8b4$export$600b5603bbac4c6)(key)) {
        (0, $aa6e5f59c2d8fea1$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f)));
        return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $7698688ddb8f3ffb$export$2e2bcd8739ae039)(key, ...(0, $55449e07a74f6a9c$export$b14ad400b1d09e0f), "Uint8Array"));
}


const $68e978f782ac3360$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $2fd330191edafa99$export$2e2bcd8739ae039)(alg, key, "verify");
    (0, $fe8023ed70d09b05$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $2d3fc6112b07fd71$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $68e978f782ac3360$export$2e2bcd8739ae039 = $68e978f782ac3360$var$verify;









async function $74e060487a04fbb6$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jws)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jws.header)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Protected Header is invalid");
    }
    if (!(0, $aa1f2b3d081451ec$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $513be064dcfa7c05$export$2e2bcd8739ae039)((0, $e8cadc15024149aa$export$e838de724af3d116), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $47b752a4b6b7202b$export$2e2bcd8739ae039)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $e8cadc15024149aa$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $d599dfcae79000ca$export$2e2bcd8739ae039)(alg, key, "verify");
    const data = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)((0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(jws.protected ?? ""), (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("."), typeof jws.payload === "string" ? (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jws.signature);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("Failed to base64url decode the signature");
    }
    const verified = await (0, $68e978f782ac3360$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $e8cadc15024149aa$export$c67a0218e7c50378)();
    let payload;
    if (b64) try {
        payload = (0, $4c62bd8bbcc8e16f$export$2f872c0f2117be69)(jws.payload);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $6e04fa502063062f$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== "string") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("Invalid Compact JWS");
    const verified = await (0, $74e060487a04fbb6$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}






async function $49e122d09ec581ce$export$45b643129436bc63(jws, key, options) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jws)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039))) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $74e060487a04fbb6$export$b2614975507c40c9)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch  {}
    throw new (0, $e8cadc15024149aa$export$c67a0218e7c50378)();
}





var $8969cceaf4ea7016$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $b43586f7765bd98c$var$minute = 60;
const $b43586f7765bd98c$var$hour = $b43586f7765bd98c$var$minute * 60;
const $b43586f7765bd98c$var$day = $b43586f7765bd98c$var$hour * 24;
const $b43586f7765bd98c$var$week = $b43586f7765bd98c$var$day * 7;
const $b43586f7765bd98c$var$year = $b43586f7765bd98c$var$day * 365.25;
const $b43586f7765bd98c$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $b43586f7765bd98c$export$2e2bcd8739ae039 = (str)=>{
    const matched = $b43586f7765bd98c$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            numericDate = Math.round(value);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            numericDate = Math.round(value * $b43586f7765bd98c$var$minute);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            numericDate = Math.round(value * $b43586f7765bd98c$var$hour);
            break;
        case "day":
        case "days":
        case "d":
            numericDate = Math.round(value * $b43586f7765bd98c$var$day);
            break;
        case "week":
        case "weeks":
        case "w":
            numericDate = Math.round(value * $b43586f7765bd98c$var$week);
            break;
        default:
            numericDate = Math.round(value * $b43586f7765bd98c$var$year);
            break;
    }
    if (matched[1] === "-" || matched[4] === "ago") return -numericDate;
    return numericDate;
};



const $393f7e07f7497b50$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $393f7e07f7497b50$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $393f7e07f7497b50$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $393f7e07f7497b50$var$normalizeTyp(protectedHeader.typ) !== $393f7e07f7497b50$var$normalizeTyp(typ))) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(encodedPayload));
    } catch  {}
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(payload)) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push("iat");
    if (audience !== undefined) presenceCheck.push("aud");
    if (subject !== undefined) presenceCheck.push("sub");
    if (issuer !== undefined) presenceCheck.push("iss");
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$393f7e07f7497b50$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $b43586f7765bd98c$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $e8cadc15024149aa$export$4b386bf852b7863d)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $b43586f7765bd98c$export$2e2bcd8739ae039)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $e8cadc15024149aa$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};



async function $17e33c80d309bdd1$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $6e04fa502063062f$export$996150e72a8992e)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $393f7e07f7497b50$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}





async function $da680575cee59cd7$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $cca17c965c08a9cc$export$c9a8efe6bfd872ce)(jwt, key, options);
    const payload = (0, $393f7e07f7497b50$export$2e2bcd8739ae039)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $e8cadc15024149aa$export$f1e14efb908196e9)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}



class $db050f98e6d87bbd$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $9398d2f45a6cd83b$export$eec23736d3c24809)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}








const $a5e51a6a4d1797da$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $2fd330191edafa99$export$2e2bcd8739ae039)(alg, key, "sign");
    (0, $fe8023ed70d09b05$export$2e2bcd8739ae039)(alg, cryptoKey);
    const signature = await (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.sign((0, $2d3fc6112b07fd71$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $a5e51a6a4d1797da$export$2e2bcd8739ae039 = $a5e51a6a4d1797da$var$sign;







class $852bd52ff5c8a685$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $aa1f2b3d081451ec$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $513be064dcfa7c05$export$2e2bcd8739ae039)((0, $e8cadc15024149aa$export$e838de724af3d116), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $d599dfcae79000ca$export$2e2bcd8739ae039)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode((0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode((0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("");
        const data = (0, $b00077c9fa30e5cf$export$ee1b3e54f0441b22)(protectedHeader, (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode("."), payload);
        const signature = await (0, $a5e51a6a4d1797da$export$2e2bcd8739ae039)(alg, key, data);
        const jws = {
            signature: (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(protectedHeader);
        return jws;
    }
}


class $77315e5b63e180df$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $852bd52ff5c8a685$export$9a8af5200da5ddb1)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}





class $9578b904928bdfb0$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $9578b904928bdfb0$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $9578b904928bdfb0$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $852bd52ff5c8a685$export$9a8af5200da5ddb1)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}








function $49c3bb91fbca28b3$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $49c3bb91fbca28b3$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $49c3bb91fbca28b3$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $49c3bb91fbca28b3$var$validateInput("setNotBefore", (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(new Date()) + (0, $b43586f7765bd98c$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $49c3bb91fbca28b3$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $49c3bb91fbca28b3$var$validateInput("setExpirationTime", (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(new Date()) + (0, $b43586f7765bd98c$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $49c3bb91fbca28b3$var$validateInput("setIssuedAt", (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(input))
        };
        else if (typeof input === "string") this._payload = {
            ...this._payload,
            iat: $49c3bb91fbca28b3$var$validateInput("setIssuedAt", (0, $8969cceaf4ea7016$export$2e2bcd8739ae039)(new Date()) + (0, $b43586f7765bd98c$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $49c3bb91fbca28b3$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}


class $7290a86fd802b08e$export$88d4e5d23fbe6c84 extends (0, $49c3bb91fbca28b3$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $77315e5b63e180df$export$b6738d8e70498d17)((0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}





class $e7c96212b8e66a46$export$28c9f8d29aec6f3d extends (0, $49c3bb91fbca28b3$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $db050f98e6d87bbd$export$965e4de9938e070e)((0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}







const $38a1bef3fd733faf$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $e8cadc15024149aa$export$b3992e0f88fb07e3)(`${description} missing or invalid`);
};
async function $38a1bef3fd733faf$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $38a1bef3fd733faf$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $38a1bef3fd733faf$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $38a1bef3fd733faf$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $38a1bef3fd733faf$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $38a1bef3fd733faf$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $38a1bef3fd733faf$var$check(jwk.e, '"e" (Exponent) Parameter');
            $38a1bef3fd733faf$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $38a1bef3fd733faf$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $b00077c9fa30e5cf$export$5486af06137bf21a).encode(JSON.stringify(components));
    return (0, $4c62bd8bbcc8e16f$export$c564cdbbe6da493)(await (0, $336c72c186be4719$export$2e2bcd8739ae039)(digestAlgorithm, data));
}
async function $38a1bef3fd733faf$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    const thumbprint = await $38a1bef3fd733faf$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}





async function $67b674b94ae3f2dd$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token?.header
    };
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(joseHeader.jwk)) throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $1d8c89fcf5aec791$export$2b70d37b4d0b888b)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $e8cadc15024149aa$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}





function $95923c29db054d34$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $95923c29db054d34$var$isJWKSLike(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($95923c29db054d34$var$isJWKLike);
}
function $95923c29db054d34$var$isJWKLike(key) {
    return (0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(key);
}
function $95923c29db054d34$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $95923c29db054d34$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$95923c29db054d34$var$isJWKSLike(jwks)) throw new (0, $e8cadc15024149aa$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
        this._jwks = $95923c29db054d34$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $95923c29db054d34$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $e8cadc15024149aa$export$3d5ed1a538bed04e)();
        if (length !== 1) {
            const error = new (0, $e8cadc15024149aa$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $95923c29db054d34$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {}
            };
            throw error;
        }
        return $95923c29db054d34$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $95923c29db054d34$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $1d8c89fcf5aec791$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $e8cadc15024149aa$export$9b22c2a1e2403b8e)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $95923c29db054d34$export$4892abc640e5f80e(jwks) {
    const set = new $95923c29db054d34$export$cfeaec9a672ea12b(jwks);
    const localJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(localJWKSet, {
        jwks: {
            value: ()=>$95923c29db054d34$var$clone(set._jwks),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return localJWKSet;
}



const $0602bb48065a93c2$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $e8cadc15024149aa$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $e8cadc15024149aa$export$f754d6850d76bf87)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch  {
        throw new (0, $e8cadc15024149aa$export$f754d6850d76bf87)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $0602bb48065a93c2$export$2e2bcd8739ae039 = $0602bb48065a93c2$var$fetchJwks;




function $c77541037d104f00$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
let $c77541037d104f00$var$USER_AGENT;
if (typeof navigator === "undefined" || !navigator.userAgent?.startsWith?.("Mozilla/5.0 ")) {
    const NAME = "jose";
    const VERSION = "v5.3.0";
    $c77541037d104f00$var$USER_AGENT = `${NAME}/${VERSION}`;
}
class $c77541037d104f00$var$RemoteJWKSet {
    constructor(url, options){
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._local || !this.fresh()) await this.reload();
        try {
            return await this._local(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $e8cadc15024149aa$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return this._local(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $c77541037d104f00$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        const headers = new Headers(this._options.headers);
        if ($c77541037d104f00$var$USER_AGENT && !headers.has("User-Agent")) {
            headers.set("User-Agent", $c77541037d104f00$var$USER_AGENT);
            this._options.headers = Object.fromEntries(headers.entries());
        }
        this._pendingFetch || (this._pendingFetch = (0, $0602bb48065a93c2$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            this._local = (0, $95923c29db054d34$export$4892abc640e5f80e)(json);
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $c77541037d104f00$export$78ce35c2df51c333(url, options) {
    const set = new $c77541037d104f00$var$RemoteJWKSet(url, options);
    const remoteJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(remoteJWKSet, {
        coolingDown: {
            get: ()=>set.coolingDown(),
            enumerable: true,
            configurable: false
        },
        fresh: {
            get: ()=>set.fresh(),
            enumerable: true,
            configurable: false
        },
        reload: {
            value: ()=>set.reload(),
            enumerable: true,
            configurable: false,
            writable: false
        },
        reloading: {
            get: ()=>!!set._pendingFetch,
            enumerable: true,
            configurable: false
        },
        jwks: {
            value: ()=>set._local?.jwks(),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return remoteJWKSet;
}







class $0e65ae50b1e8bdd8$export$6404fb90f16d8733 extends (0, $49c3bb91fbca28b3$export$2ef1b74b7c7e6eb3) {
    encode() {
        const header = $4c62bd8bbcc8e16f$export$c564cdbbe6da493(JSON.stringify({
            alg: "none"
        }));
        const payload = $4c62bd8bbcc8e16f$export$c564cdbbe6da493(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode($4c62bd8bbcc8e16f$export$2f872c0f2117be69(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch  {
            throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        }
        const payload = (0, $393f7e07f7497b50$export$2e2bcd8739ae039)(header, $4c62bd8bbcc8e16f$export$2f872c0f2117be69(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}





const $e92d546b438fe294$export$c564cdbbe6da493 = $4c62bd8bbcc8e16f$export$c564cdbbe6da493;
const $e92d546b438fe294$export$2f872c0f2117be69 = $4c62bd8bbcc8e16f$export$2f872c0f2117be69;




function $f15c098ab21146c7$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode((0, $e92d546b438fe294$export$2f872c0f2117be69)(protectedB64u)));
        if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(result)) throw new Error();
        return result;
    } catch  {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}






function $8429b239a0ac2236$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Invalid JWT");
    if (!payload) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $e92d546b438fe294$export$2f872c0f2117be69)(payload);
    } catch  {
        throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $b00077c9fa30e5cf$export$124c96e6ce37090b).decode(decoded));
    } catch  {
        throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $c1b61ad1fc4d17cc$export$2e2bcd8739ae039)(result)) throw new (0, $e8cadc15024149aa$export$936b39ada0bbfceb)("Invalid JWT Claims Set");
    return result;
}






async function $cf5375481deb971d$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $82bfd1bdcc7654f2$export$2e2bcd8739ae039)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $cf5375481deb971d$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $cf5375481deb971d$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $cf5375481deb971d$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $cf5375481deb971d$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $cf5375481deb971d$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            {
                keyUsages = [
                    "sign",
                    "verify"
                ];
                const crv = options?.crv ?? "Ed25519";
                switch(crv){
                    case "Ed25519":
                    case "Ed448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided");
                }
                break;
            }
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $e8cadc15024149aa$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $8a919c84a5c9d8b4$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}


async function $f7c615bf18223da1$export$a949d36eab55b41f(alg, options) {
    return (0, $cf5375481deb971d$export$a949d36eab55b41f)(alg, options);
}



async function $7d4897b0183ec701$export$25395fe8d170ad7(alg, options) {
    return (0, $cf5375481deb971d$export$25395fe8d170ad7)(alg, options);
}



var $7d9a773bf50098af$export$2e2bcd8739ae039 = "WebCryptoAPI";


var $4483913346318e83$export$2e2bcd8739ae039 = (0, $7d9a773bf50098af$export$2e2bcd8739ae039);




var $52d2a486fd332ffd$exports = {};
"use strict";
var $52d2a486fd332ffd$var$__createBinding = $52d2a486fd332ffd$exports && $52d2a486fd332ffd$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $52d2a486fd332ffd$var$__exportStar = $52d2a486fd332ffd$exports && $52d2a486fd332ffd$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $52d2a486fd332ffd$var$__createBinding(exports1, m, p);
};
Object.defineProperty($52d2a486fd332ffd$exports, "__esModule", {
    value: true
});

$52d2a486fd332ffd$var$__exportStar((parcelRequire("6wIS6")), $52d2a486fd332ffd$exports);

$52d2a486fd332ffd$var$__exportStar((parcelRequire("5omI5")), $52d2a486fd332ffd$exports);

$52d2a486fd332ffd$var$__exportStar((parcelRequire("53zBN")), $52d2a486fd332ffd$exports);






var $dup7A = parcelRequire("dup7A");
function $4e4c0c15f79f3221$export$864b6828bd07eda6(keyName, defaultValue) {
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        try {
            const value = window.localStorage.getItem(keyName);
            return value ? JSON.parse(value) : defaultValue;
        } catch (err) {
            return defaultValue;
        }
    });
    const setValue = (newValue)=>{
        try {
            window.sessionStorage.setItem(keyName, JSON.stringify(newValue));
        } finally{
            setStoredValue(newValue);
        }
    };
    return [
        storedValue,
        setValue
    ];
}




function $ff9f3bf8d42d4b72$export$573a18d76ffbd3e3(authData) {
    return (0, $b6ddc82ff82475c2$export$b410431fab84fa58).promise(fetch(`/.netlify/functions/authUser`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(authData)
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error signing in"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        pending: `Signing in User...`,
        success: "Signed In successfully!",
        error: {
            render ({ data: error }) {
                return `Sign-In failed: ${error?.message}`;
            }
        }
    }, (0, $0b0903738c0da810$export$8eb3892b442747bd));
}
function $ff9f3bf8d42d4b72$export$2b85b721e524d74b(address) {
    return (0, $b6ddc82ff82475c2$export$b410431fab84fa58).promise(fetch(`/.netlify/functions/getNonce?address=${address}`, {
        method: "GET"
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error getting nonce"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        error: {
            render ({ data: error }) {
                return `${error?.message}`;
            }
        }
    }, (0, $0b0903738c0da810$export$8eb3892b442747bd));
}


const $18c9b64d09375aef$export$997aa44fa3e3c31 = ({ children: children, className: className })=>{
    const localToken = window.sessionStorage.getItem("auth-token");
    const [isLoading, setIsLoading] = (0, $dup7A.useState)(false);
    const [authToken, setAuthToken] = (0, $4e4c0c15f79f3221$export$864b6828bd07eda6)("auth-token", localToken);
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { chain: chain } = (0, $1d657eb5d64e17dc$export$553aaf59afc1a2d8)();
    const { signMessageAsync: signMessageAsync } = (0, $1d657eb5d64e17dc$export$2ec0271a2697cc5f)();
    const isVerified = (0, $dup7A.useMemo)(()=>{
        if (!authToken || !address) return false;
        const payload = $8429b239a0ac2236$export$dcef71b8fb9a6794(authToken);
        if (payload?.id.toLowerCase() !== address.toLowerCase()) return false;
        if (payload.exp && payload.exp < Date.now() / 1000) return false;
        return true;
    }, [
        authToken,
        address
    ]);
    const handleSignIn = async ()=>{
        try {
            setIsLoading(true);
            if (!address) return;
            const message = await $18c9b64d09375aef$var$createSiweMessage(address, "Sign In to Kleros with Ethereum.", chain?.id);
            const signature = await signMessageAsync({
                message: message
            });
            if (!signature) return;
            (0, $ff9f3bf8d42d4b72$export$573a18d76ffbd3e3)({
                address: address,
                signature: signature,
                message: message
            }).then(async (res)=>{
                const response = await res.json();
                setAuthToken(response["token"]);
            }).catch((err)=>console.log({
                    err: err
                })).finally(()=>setIsLoading(false));
        } catch (err) {
            setIsLoading(false);
            console.log({
                err: err
            });
        }
    };
    return isVerified ? children : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
        text: "Sign In",
        onClick: handleSignIn,
        disabled: isLoading,
        isLoading: isLoading,
        className: className
    });
};
async function $18c9b64d09375aef$var$createSiweMessage(address, statement, chainId = (0, $32162005f9f3d1a7$export$8372812df8e8183f)) {
    const domain = window.location.host;
    const origin = window.location.origin;
    const response = await (0, $ff9f3bf8d42d4b72$export$2b85b721e524d74b)(address);
    const nonce = (await response.json()).nonce;
    // signature is valid only for 10 mins
    const expirationTime = new Date(Date.now() + 600000).toISOString();
    const message = new (0, $52d2a486fd332ffd$exports.SiweMessage)({
        domain: domain,
        address: address,
        statement: statement,
        uri: origin,
        version: "1",
        chainId: chainId,
        nonce: nonce,
        expirationTime: expirationTime
    });
    return message.prepareMessage();
}




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





function $a69c2028ff0d4d85$export$925226e2a01c2566(formData) {
    // storing token in storage adds double quotes to it, so when its passed as header it becomes `"token"`, so we remove double quotes
    const authToken = sessionStorage.getItem("auth-token")?.replace(/"/g, "");
    return (0, $b6ddc82ff82475c2$export$b410431fab84fa58).promise(fetch("/.netlify/functions/update-settings", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-auth-token": authToken ?? ""
        },
        body: JSON.stringify(formData)
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error uploading to Supabase"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        pending: "Saving...",
        success: "Saved successfully!",
        error: {
            render ({ data: error }) {
                return `Upload failed: ${error?.message}`;
            }
        }
    }, (0, $0b0903738c0da810$export$8eb3892b442747bd));
}



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


const $772bd86fac049795$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
const $772bd86fac049795$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const $772bd86fac049795$var$FormContact = ({ contactLabel: contactLabel, contactPlaceholder: contactPlaceholder, contactInput: contactInput, contactIsValid: contactIsValid, setContactInput: setContactInput, setContactIsValid: setContactIsValid, validator: validator, isEditing: isEditing })=>{
    (0, $dup7A.useEffect)(()=>{
        setContactIsValid(contactInput === "" ? true : validator.test(contactInput));
    }, [
        contactInput,
        setContactIsValid,
        validator
    ]);
    const handleInputChange = (event)=>{
        event.preventDefault();
        setContactInput(event.target.value);
    };
    const fieldVariant = (0, $dup7A.useMemo)(()=>{
        if (contactInput === "" || !isEditing) return undefined;
        return contactIsValid ? "success" : "error";
    }, [
        contactInput,
        contactIsValid
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($772bd86fac049795$var$StyledLabel, {
                children: contactLabel
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($772bd86fac049795$var$StyledField, {
                variant: fieldVariant,
                value: contactInput,
                onChange: handleInputChange,
                placeholder: contactPlaceholder
            })
        ]
    });
};
var $772bd86fac049795$export$2e2bcd8739ae039 = $772bd86fac049795$var$FormContact;






var $dup7A = parcelRequire("dup7A");






var $dup7A = parcelRequire("dup7A");

"use client";
const $b29bae8089492eae$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $b29bae8089492eae$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $dup7A.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $b29bae8089492eae$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a257437a2bd3092d$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $7f3bffedf8f082c1$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $7f3bffedf8f082c1$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $7f3bffedf8f082c1$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $7f3bffedf8f082c1$export$e0a3f29513afe430(result, isRestoring);
const $7f3bffedf8f082c1$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $3b006b6e9697f55b$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $d311ebbf0b97d2d5$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $e8a4c4723d8eb8d0$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $7f3bffedf8f082c1$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $b29bae8089492eae$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $b29bae8089492eae$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $dup7A.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $a055f72c1f0ab780$export$306c0aa65ff9ec16)($dup7A.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $68993055bb63f552$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $dup7A.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $7f3bffedf8f082c1$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $7f3bffedf8f082c1$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $b29bae8089492eae$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $b2d37ce55e9ca513$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $0dbdedbceaf62b7f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $3b006b6e9697f55b$export$fff0865807e996c5)(parsedOptions, (0, $195f43ad8a933b91$export$a06cf8c0066f0d4c));
}



const $100726c206bb614c$export$8b4f00ca24c1e68e = ()=>{
    const authToken = sessionStorage.getItem("auth-token")?.replace(/"/g, "");
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(authToken);
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `UserSettings`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            try {
                if (!authToken) return;
                const res = await fetch(`/.netlify/functions/fetch-settings`, {
                    method: "POST",
                    headers: {
                        "x-auth-token": authToken
                    }
                });
                return (await res.json())?.data;
            } catch  {
                return {};
            }
        }
    });
};


const $b1b0333a3c71e1c1$var$FormContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).form`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 32, 300)};
  padding-bottom: 16px;
`;
const $b1b0333a3c71e1c1$var$ButtonContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
`;
const $b1b0333a3c71e1c1$var$FormContactContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const $b1b0333a3c71e1c1$var$FormContactDetails = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [telegramInput, setTelegramInput] = (0, $dup7A.useState)("");
    const [emailInput, setEmailInput] = (0, $dup7A.useState)("");
    const [telegramIsValid, setTelegramIsValid] = (0, $dup7A.useState)(false);
    const [emailIsValid, setEmailIsValid] = (0, $dup7A.useState)(false);
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: userSettings, refetch: refetchUserSettings } = (0, $100726c206bb614c$export$8b4f00ca24c1e68e)();
    const isEditingEmail = (0, $dup7A.useMemo)(()=>{
        if (!userSettings?.email && emailInput === "") return false;
        return userSettings?.email !== emailInput;
    }, [
        userSettings,
        emailInput
    ]);
    const isEditingTelegram = (0, $dup7A.useMemo)(()=>{
        if (!userSettings?.telegram && telegramInput === "") return false;
        return userSettings?.telegram !== telegramInput;
    }, [
        userSettings,
        telegramInput
    ]);
    (0, $dup7A.useEffect)(()=>{
        refetchUserSettings();
    }, [
        address
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!userSettings) return;
        setEmailInput(userSettings.email ?? "");
        setTelegramInput(userSettings.telegram ?? "");
    }, [
        userSettings
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!address) throw new Error("Missing address");
        const data = {
            email: emailInput,
            telegram: telegramInput,
            address: address
        };
        (0, $a69c2028ff0d4d85$export$925226e2a01c2566)(data).then(async (res)=>{
            if (res.ok) {
                toggleIsSettingsOpen();
                refetchUserSettings();
            }
        }).catch((err)=>console.log(err));
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($b1b0333a3c71e1c1$var$FormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($b1b0333a3c71e1c1$var$FormContactContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $772bd86fac049795$export$2e2bcd8739ae039), {
                    contactLabel: "Email",
                    contactPlaceholder: "your.email@email.com",
                    contactInput: emailInput,
                    contactIsValid: emailIsValid,
                    setContactInput: setEmailInput,
                    setContactIsValid: setEmailIsValid,
                    validator: (0, $203b613495c69c62$export$7b7637218245c8a),
                    isEditing: isEditingEmail
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($b1b0333a3c71e1c1$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                    text: "Save",
                    disabled: !isEditingEmail || !emailIsValid
                })
            })
        ]
    });
};
var $b1b0333a3c71e1c1$export$2e2bcd8739ae039 = $b1b0333a3c71e1c1$var$FormContactDetails;


const $db9a8437da140008$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const $db9a8437da140008$var$HeaderContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
  margin-top: 16px;
  margin-bottom: 12px;
`;
const $db9a8437da140008$var$HeaderNotifs = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($db9a8437da140008$var$HeaderContainer, {
        children: "Contact Details"
    });
};
const $db9a8437da140008$var$EnsureChainContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 16px;
`;
const $db9a8437da140008$var$StyledSvg = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  display: inline-block;
  width: 18px;
  height: 18px;
  fill: ${({ theme: theme })=>theme.primaryBlue};
`;
const $db9a8437da140008$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 90px;
  margin-bottom: 110px;
  font-size: 16px;

  &:hover {
    text-decoration: underline;
  }
`;
const $db9a8437da140008$var$NotificationSettings = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($db9a8437da140008$var$EnsureChainContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
            children: /*#__PURE__*/ (0, $cZGFG.jsx)($db9a8437da140008$var$Container, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $18c9b64d09375aef$export$997aa44fa3e3c31), {
                    children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($db9a8437da140008$var$HeaderNotifs, {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b1b0333a3c71e1c1$export$2e2bcd8739ae039), {
                                toggleIsSettingsOpen: toggleIsSettingsOpen
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $db9a8437da140008$export$2e2bcd8739ae039 = $db9a8437da140008$var$NotificationSettings;


const $8160ddd521d199d2$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  flex-direction: column;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  border-radius: 3px;
  overflow-y: auto;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-top: 64px;
      top: 0;
      right: 0;
      left: auto;
      transform: none;
    `)}
`;
const $8160ddd521d199d2$var$StyledSettingsText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  font-size: 24px;
  color: ${({ theme: theme })=>theme.primaryText};
  margin-top: 24px;
`;
const $8160ddd521d199d2$var$StyledTabs = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Tabs))`
  padding: 0 ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32, 300)};
  width: 86vw;
  max-width: 660px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(300, 424, 300)};
    `)}
`;
const $8160ddd521d199d2$var$TABS = [
    {
        text: "General",
        value: 0
    },
    {
        text: "Notifications",
        value: 1
    }
];
const $8160ddd521d199d2$var$Settings = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [currentTab, setCurrentTab] = (0, $dup7A.useState)(0);
    const containerRef = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsSettingsOpen());
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($8160ddd521d199d2$var$Container, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($8160ddd521d199d2$var$StyledSettingsText, {
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($8160ddd521d199d2$var$StyledTabs, {
                        currentValue: currentTab,
                        items: $8160ddd521d199d2$var$TABS,
                        callback: (n)=>{
                            setCurrentTab(n);
                        }
                    }),
                    currentTab === 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c524301795922ce0$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $db9a8437da140008$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $8160ddd521d199d2$export$2e2bcd8739ae039 = $8160ddd521d199d2$var$Settings;



const $ffbdbf6fdfa3a6a1$var$Wrapper = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  visibility: ${({ isOpen: isOpen })=>isOpen ? "visible" : "hidden"};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
`;
const $ffbdbf6fdfa3a6a1$var$StyledOverlay = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff))`
  top: unset;
`;
const $ffbdbf6fdfa3a6a1$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  box-shadow: 0px 2px 3px ${({ theme: theme })=>theme.defaultShadow};
  transform-origin: top;
  transform: scaleY(${({ isOpen: isOpen })=>isOpen ? "1" : "0"});
  visibility: ${({ isOpen: isOpen })=>isOpen ? "visible" : "hidden"};
  transition-property: transform, visibility;
  transition-duration: ${({ theme: theme })=>theme.transitionSpeed};
  transition-timing-function: ease;
  padding: 24px;

  hr {
    margin: 24px 0;
  }
`;
const $ffbdbf6fdfa3a6a1$var$WalletContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const $ffbdbf6fdfa3a6a1$var$DisconnectWalletButtonContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $ffbdbf6fdfa3a6a1$var$PopupContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
`;
const $ffbdbf6fdfa3a6a1$var$NavBar = ()=>{
    const { isConnected: isConnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const [isDappListOpen, toggleIsDappListOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isHelpOpen, toggleIsHelpOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isSettingsOpen, toggleIsSettingsOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const { isOpen: isOpen } = (0, $7495bbc29e373f9c$export$25b6956486120489)();
    (0, $bafdb2a6661c2921$export$eb909a3d9177a60d)(isOpen);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($ffbdbf6fdfa3a6a1$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($ffbdbf6fdfa3a6a1$var$StyledOverlay, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($ffbdbf6fdfa3a6a1$var$Container, {
                        isOpen: isOpen,
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d86601acd95afa87$export$2e2bcd8739ae039), {
                                text: "Kleros Solutions",
                                onClick: ()=>{
                                    toggleIsDappListOpen();
                                },
                                Icon: (0, $dbcb5f29e9c29744$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ce3b1daf6de7e26f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($ffbdbf6fdfa3a6a1$var$WalletContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5fd7f782fb0a380f$export$2e2bcd8739ae039), {}),
                                    isConnected && /*#__PURE__*/ (0, $cZGFG.jsx)($ffbdbf6fdfa3a6a1$var$DisconnectWalletButtonContainer, {
                                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c524301795922ce0$export$c604e936fdf27a02), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $07046d9cbcd57953$export$2e2bcd8739ae039), {
                                toggleIsHelpOpen: toggleIsHelpOpen,
                                toggleIsSettingsOpen: toggleIsSettingsOpen
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("br", {})
                        ]
                    })
                ]
            }),
            (isDappListOpen || isHelpOpen || isSettingsOpen) && /*#__PURE__*/ (0, $cZGFG.jsxs)($ffbdbf6fdfa3a6a1$var$PopupContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff), {}),
                    isDappListOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fd49b2724862d581$export$2e2bcd8739ae039), {
                        toggleIsDappListOpen: toggleIsDappListOpen
                    }),
                    isHelpOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1942bfdad6e7bb9d$export$2e2bcd8739ae039), {
                        toggleIsHelpOpen: toggleIsHelpOpen
                    }),
                    isSettingsOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8160ddd521d199d2$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $ffbdbf6fdfa3a6a1$export$2e2bcd8739ae039 = $ffbdbf6fdfa3a6a1$var$NavBar;


const $7495bbc29e373f9c$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $7495bbc29e373f9c$var$StyledLightButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d86601acd95afa87$export$2e2bcd8739ae039))`
  padding: 0;

  .button-svg {
    margin-right: 0px;
    fill: white;
  }
  .button-text {
    display: none;
  }
`;
const $7495bbc29e373f9c$var$OpenContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext({
    isOpen: false,
    toggleIsOpen: ()=>{
    // Placeholder
    }
});
function $7495bbc29e373f9c$export$25b6956486120489() {
    return (0, $dup7A.useContext)($7495bbc29e373f9c$var$OpenContext);
}
const $7495bbc29e373f9c$var$MobileHeader = ()=>{
    const [isOpen, toggleIsOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsOpen(false));
    const memoizedContext = (0, $dup7A.useMemo)(()=>({
            isOpen: isOpen,
            toggleIsOpen: toggleIsOpen
        }), [
        isOpen,
        toggleIsOpen
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($7495bbc29e373f9c$var$Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($7495bbc29e373f9c$var$OpenContext.Provider, {
            value: memoizedContext,
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f09e80dfb6891fe0$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ffbdbf6fdfa3a6a1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)($7495bbc29e373f9c$var$StyledLightButton, {
                    text: "",
                    Icon: (0, $9b95a0ecb98a3f27$export$2e2bcd8739ae039),
                    onClick: toggleIsOpen
                })
            ]
        })
    });
};
var $7495bbc29e373f9c$export$2e2bcd8739ae039 = $7495bbc29e373f9c$var$MobileHeader;


const $ce3b1daf6de7e26f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 0px;
  flex-direction: column;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(4, 16)};
    `)};
`;
const $ce3b1daf6de7e26f$var$LinkContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  min-height: 32px;
  align-items: center;
`;
const $ce3b1daf6de7e26f$var$Title = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  display: block;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)};
`;
const $ce3b1daf6de7e26f$var$StyledLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $1d2829c53a2521b2$export$a6c7ac8248d6e38a))`
  color: ${({ theme: theme })=>theme.primaryText};
  text-decoration: none;
  font-size: 16px;

  font-weight: ${({ isActive: isActive })=>isActive ? "600" : "normal"};

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      color: ${({ theme: theme })=>theme.white};
    `)};
`;
const $ce3b1daf6de7e26f$var$HiddenLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)($ce3b1daf6de7e26f$var$StyledLink)`
  color: ${({ isActive: isActive, theme: theme })=>isActive ? theme.primaryText : "transparent"};
`;
const $ce3b1daf6de7e26f$var$links = [
    {
        to: "/",
        text: "Home"
    },
    {
        to: "/cases/display/1/desc/all",
        text: "Cases"
    },
    {
        to: "/courts",
        text: "Courts"
    },
    {
        to: "/dashboard/1/desc/all",
        text: "Dashboard"
    },
    {
        to: "/get-pnk",
        text: "Get PNK"
    }
];
const $ce3b1daf6de7e26f$var$Explore = ()=>{
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const { isOpen: isOpen, toggleIsOpen: toggleIsOpen } = (0, $7495bbc29e373f9c$export$25b6956486120489)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($ce3b1daf6de7e26f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($ce3b1daf6de7e26f$var$Title, {
                children: "Explore"
            }),
            $ce3b1daf6de7e26f$var$links.map(({ to: to, text: text })=>/*#__PURE__*/ (0, $cZGFG.jsx)($ce3b1daf6de7e26f$var$LinkContainer, {
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)($ce3b1daf6de7e26f$var$StyledLink, {
                        to: to,
                        onClick: toggleIsOpen,
                        isActive: to === "/" ? location.pathname === "/" : location.pathname.startsWith(to),
                        children: text
                    })
                }, text)),
            !isOpen && /*#__PURE__*/ (0, $cZGFG.jsx)($ce3b1daf6de7e26f$var$LinkContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($ce3b1daf6de7e26f$var$HiddenLink, {
                    to: "/dispute-template",
                    onClick: toggleIsOpen,
                    isActive: location.pathname.startsWith("/dispute-template"),
                    children: "Dev"
                })
            })
        ]
    });
};
var $ce3b1daf6de7e26f$export$2e2bcd8739ae039 = $ce3b1daf6de7e26f$var$Explore;





const $82b300ce533c255f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: none;
  position: absolute;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      position: relative;
    `)};
`;
const $82b300ce533c255f$var$LeftSide = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $82b300ce533c255f$var$MiddleSide = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme: theme })=>theme.white} !important;
`;
const $82b300ce533c255f$var$RightSide = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 16, 300, 1024)};

  margin-left: 8px;
  canvas {
    width: 20px;
  }
`;
const $82b300ce533c255f$var$LightButtonContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 16px;
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(4, 8)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 16)};
`;
const $82b300ce533c255f$var$StyledKlerosSolutionsIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $dbcb5f29e9c29744$export$2e2bcd8739ae039))`
  fill: ${({ theme: theme })=>theme.white} !important;
`;
const $82b300ce533c255f$var$ConnectWalletContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  label {
    color: ${({ theme: theme })=>theme.white};
  }
`;
const $82b300ce533c255f$var$PopupContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
`;
const $82b300ce533c255f$var$DesktopHeader = ()=>{
    const [isDappListOpen, toggleIsDappListOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isHelpOpen, toggleIsHelpOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const [isSettingsOpen, toggleIsSettingsOpen] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    (0, $bafdb2a6661c2921$export$eb909a3d9177a60d)(isDappListOpen || isHelpOpen || isSettingsOpen);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($82b300ce533c255f$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($82b300ce533c255f$var$LeftSide, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($82b300ce533c255f$var$LightButtonContainer, {
                                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d86601acd95afa87$export$2e2bcd8739ae039), {
                                    text: "",
                                    onClick: ()=>{
                                        toggleIsDappListOpen();
                                    },
                                    Icon: $82b300ce533c255f$var$StyledKlerosSolutionsIcon
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f09e80dfb6891fe0$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($82b300ce533c255f$var$MiddleSide, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ce3b1daf6de7e26f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($82b300ce533c255f$var$RightSide, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($82b300ce533c255f$var$ConnectWalletContainer, {
                                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5fd7f782fb0a380f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $07046d9cbcd57953$export$2e2bcd8739ae039), {
                                toggleIsHelpOpen: toggleIsHelpOpen,
                                toggleIsSettingsOpen: toggleIsSettingsOpen
                            })
                        ]
                    })
                ]
            }),
            (isDappListOpen || isHelpOpen || isSettingsOpen) && /*#__PURE__*/ (0, $cZGFG.jsxs)($82b300ce533c255f$var$PopupContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff), {}),
                    isDappListOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fd49b2724862d581$export$2e2bcd8739ae039), {
                        toggleIsDappListOpen: toggleIsDappListOpen,
                        isDappListOpen: isDappListOpen
                    }),
                    isHelpOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1942bfdad6e7bb9d$export$2e2bcd8739ae039), {
                        toggleIsHelpOpen: toggleIsHelpOpen,
                        isHelpOpen: isHelpOpen
                    }),
                    isSettingsOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8160ddd521d199d2$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen,
                        isSettingsOpen: isSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $82b300ce533c255f$export$2e2bcd8739ae039 = $82b300ce533c255f$var$DesktopHeader;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $a021427df3170817$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  position: sticky;
  top: 0;
  background-color: ${({ theme: theme })=>theme.tintPurple};
  color: ${({ theme: theme })=>theme.primaryText};

  padding: 5px 2px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      padding: 5px 10px;
    `)}
`;
const $a021427df3170817$var$StyledP = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).p`
  font-size: 14px;
  text-align: center;
  margin: 0;
`;
const $a021427df3170817$export$7fe3ed9c31042b5d = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($a021427df3170817$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($a021427df3170817$var$StyledP, {
            children: [
                "Thanks for trying Kleros V2! This a testnet release: work is still in progress and some features are missing. More info",
                " ",
                /*#__PURE__*/ (0, $cZGFG.jsx)("a", {
                    href: "https://docs.kleros.io/products/court-v2",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "here"
                }),
                "."
            ]
        })
    });
};


const $3b7d8b547a3953e3$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: sticky;
  z-index: 1;
  top: 0;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.primaryPurple};

  display: flex;
  flex-wrap: wrap;
`;
const $3b7d8b547a3953e3$var$HeaderContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 4px 24px 8px;
`;
const $3b7d8b547a3953e3$var$Header = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($3b7d8b547a3953e3$var$Container, {
        children: [
            !(0, $203b613495c69c62$export$9eecd5eb17097ec3)() ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $a021427df3170817$export$7fe3ed9c31042b5d), {}) : null,
            /*#__PURE__*/ (0, $cZGFG.jsxs)($3b7d8b547a3953e3$var$HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $82b300ce533c255f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $7495bbc29e373f9c$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $3b7d8b547a3953e3$export$2e2bcd8739ae039 = $3b7d8b547a3953e3$var$Header;


const $68d9f874bacaa090$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
`;
const $68d9f874bacaa090$var$StyledOverlayScrollbarsComponent = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $c3bc3d47cbe0dd24$export$5c3912403b9b36ce))`
  height: 100vh;
  width: 100vw;
`;
const $68d9f874bacaa090$var$StyledToastContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $b6ddc82ff82475c2$export$f2815235e76a62b9))`
  padding: 16px;
  padding-top: 70px;
`;
const $68d9f874bacaa090$var$OutletContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  flex: 1;
  background-color: ${({ theme: theme })=>theme.lightBackground};
`;
const $68d9f874bacaa090$var$Layout = ()=>{
    const containerRef = (0, $dup7A.useRef)(null);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5312253935e6facb$export$20b5a34f45062e8b).Provider, {
        value: containerRef,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($68d9f874bacaa090$var$StyledOverlayScrollbarsComponent, {
            ref: containerRef,
            options: {
                showNativeOverlaidScrollbars: true
            },
            children: /*#__PURE__*/ (0, $cZGFG.jsxs)($68d9f874bacaa090$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3b7d8b547a3953e3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($68d9f874bacaa090$var$StyledToastContainer, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($68d9f874bacaa090$var$OutletContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$910ae8079b2c2852), {})
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $20c9cb43ec92a0da$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $68d9f874bacaa090$export$2e2bcd8739ae039 = $68d9f874bacaa090$var$Layout;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $2b4339c8418e3b6b$export$2be98a1249103ab1;
(function(Periods) {
    Periods[Periods["evidence"] = 0] = "evidence";
    Periods[Periods["commit"] = 1] = "commit";
    Periods[Periods["vote"] = 2] = "vote";
    Periods[Periods["appeal"] = 3] = "appeal";
    Periods[Periods["execution"] = 4] = "execution";
})($2b4339c8418e3b6b$export$2be98a1249103ab1 || ($2b4339c8418e3b6b$export$2be98a1249103ab1 = {}));



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");






/* eslint-disable */ function $6eecb591d23edb01$export$130bc0efb3cce789(_documentNode, fragmentType) {
    return fragmentType;
}
function $6eecb591d23edb01$export$4659cb8f146075(data, _fragment) {
    return data;
}
function $6eecb591d23edb01$export$dbf91005d32bdf6a(queryNode, fragmentNode, data) {
    const deferredFields = queryNode.__meta__?.deferredFields;
    if (!deferredFields) return true;
    const fragDef = fragmentNode.definitions[0];
    const fragName = fragDef?.name?.value;
    const fields = fragName && deferredFields[fragName] || [];
    return fields.length > 0 && fields.every((field)=>data && field in data);
}


/* eslint-disable */ /* eslint-disable */ var $29ccfa76e4432aad$export$72a9f2d0d5047c2c;
(function(Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
})($29ccfa76e4432aad$export$72a9f2d0d5047c2c || ($29ccfa76e4432aad$export$72a9f2d0d5047c2c = {}));
var $29ccfa76e4432aad$export$7a5d411bd783623;
(function(Arbitrable_OrderBy) {
    Arbitrable_OrderBy["Disputes"] = "disputes";
    Arbitrable_OrderBy["Id"] = "id";
    Arbitrable_OrderBy["TotalDisputes"] = "totalDisputes";
})($29ccfa76e4432aad$export$7a5d411bd783623 || ($29ccfa76e4432aad$export$7a5d411bd783623 = {}));
var $29ccfa76e4432aad$export$11c42793bf5f00c7;
(function(ClassicContribution_OrderBy) {
    ClassicContribution_OrderBy["Amount"] = "amount";
    ClassicContribution_OrderBy["Choice"] = "choice";
    ClassicContribution_OrderBy["Contributor"] = "contributor";
    ClassicContribution_OrderBy["ContributorActiveDisputes"] = "contributor__activeDisputes";
    ClassicContribution_OrderBy["ContributorCoherenceScore"] = "contributor__coherenceScore";
    ClassicContribution_OrderBy["ContributorId"] = "contributor__id";
    ClassicContribution_OrderBy["ContributorTotalAppealingDisputes"] = "contributor__totalAppealingDisputes";
    ClassicContribution_OrderBy["ContributorTotalCoherent"] = "contributor__totalCoherent";
    ClassicContribution_OrderBy["ContributorTotalDelayed"] = "contributor__totalDelayed";
    ClassicContribution_OrderBy["ContributorTotalDisputes"] = "contributor__totalDisputes";
    ClassicContribution_OrderBy["ContributorTotalResolvedDisputes"] = "contributor__totalResolvedDisputes";
    ClassicContribution_OrderBy["ContributorTotalStake"] = "contributor__totalStake";
    ClassicContribution_OrderBy["CoreDispute"] = "coreDispute";
    ClassicContribution_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    ClassicContribution_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    ClassicContribution_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    ClassicContribution_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    ClassicContribution_OrderBy["CoreDisputeId"] = "coreDispute__id";
    ClassicContribution_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    ClassicContribution_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    ClassicContribution_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    ClassicContribution_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    ClassicContribution_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    ClassicContribution_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    ClassicContribution_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    ClassicContribution_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    ClassicContribution_OrderBy["Id"] = "id";
    ClassicContribution_OrderBy["LocalRound"] = "localRound";
    ClassicContribution_OrderBy["LocalRoundFeeRewards"] = "localRound__feeRewards";
    ClassicContribution_OrderBy["LocalRoundId"] = "localRound__id";
    ClassicContribution_OrderBy["LocalRoundTied"] = "localRound__tied";
    ClassicContribution_OrderBy["LocalRoundTotalCommited"] = "localRound__totalCommited";
    ClassicContribution_OrderBy["LocalRoundTotalVoted"] = "localRound__totalVoted";
    ClassicContribution_OrderBy["LocalRoundWinningChoice"] = "localRound__winningChoice";
    ClassicContribution_OrderBy["RewardAmount"] = "rewardAmount";
    ClassicContribution_OrderBy["RewardWithdrawn"] = "rewardWithdrawn";
})($29ccfa76e4432aad$export$11c42793bf5f00c7 || ($29ccfa76e4432aad$export$11c42793bf5f00c7 = {}));
var $29ccfa76e4432aad$export$4d6d22cf868ad590;
(function(ClassicDispute_OrderBy) {
    ClassicDispute_OrderBy["CoreDispute"] = "coreDispute";
    ClassicDispute_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    ClassicDispute_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    ClassicDispute_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    ClassicDispute_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    ClassicDispute_OrderBy["CoreDisputeId"] = "coreDispute__id";
    ClassicDispute_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    ClassicDispute_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    ClassicDispute_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    ClassicDispute_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    ClassicDispute_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    ClassicDispute_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    ClassicDispute_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    ClassicDispute_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    ClassicDispute_OrderBy["CurrentLocalRoundIndex"] = "currentLocalRoundIndex";
    ClassicDispute_OrderBy["ExtraData"] = "extraData";
    ClassicDispute_OrderBy["Id"] = "id";
    ClassicDispute_OrderBy["LocalRounds"] = "localRounds";
    ClassicDispute_OrderBy["NumberOfChoices"] = "numberOfChoices";
    ClassicDispute_OrderBy["Timestamp"] = "timestamp";
})($29ccfa76e4432aad$export$4d6d22cf868ad590 || ($29ccfa76e4432aad$export$4d6d22cf868ad590 = {}));
var $29ccfa76e4432aad$export$584d1e9faaf05316;
(function(ClassicEvidenceGroup_OrderBy) {
    ClassicEvidenceGroup_OrderBy["Evidences"] = "evidences";
    ClassicEvidenceGroup_OrderBy["Id"] = "id";
    ClassicEvidenceGroup_OrderBy["NextEvidenceIndex"] = "nextEvidenceIndex";
})($29ccfa76e4432aad$export$584d1e9faaf05316 || ($29ccfa76e4432aad$export$584d1e9faaf05316 = {}));
var $29ccfa76e4432aad$export$27ed41b918d907ef;
(function(ClassicEvidence_OrderBy) {
    ClassicEvidence_OrderBy["Evidence"] = "evidence";
    ClassicEvidence_OrderBy["EvidenceGroup"] = "evidenceGroup";
    ClassicEvidence_OrderBy["EvidenceGroupId"] = "evidenceGroup__id";
    ClassicEvidence_OrderBy["EvidenceGroupNextEvidenceIndex"] = "evidenceGroup__nextEvidenceIndex";
    ClassicEvidence_OrderBy["Id"] = "id";
    ClassicEvidence_OrderBy["Sender"] = "sender";
    ClassicEvidence_OrderBy["SenderActiveDisputes"] = "sender__activeDisputes";
    ClassicEvidence_OrderBy["SenderCoherenceScore"] = "sender__coherenceScore";
    ClassicEvidence_OrderBy["SenderId"] = "sender__id";
    ClassicEvidence_OrderBy["SenderTotalAppealingDisputes"] = "sender__totalAppealingDisputes";
    ClassicEvidence_OrderBy["SenderTotalCoherent"] = "sender__totalCoherent";
    ClassicEvidence_OrderBy["SenderTotalDelayed"] = "sender__totalDelayed";
    ClassicEvidence_OrderBy["SenderTotalDisputes"] = "sender__totalDisputes";
    ClassicEvidence_OrderBy["SenderTotalResolvedDisputes"] = "sender__totalResolvedDisputes";
    ClassicEvidence_OrderBy["SenderTotalStake"] = "sender__totalStake";
})($29ccfa76e4432aad$export$27ed41b918d907ef || ($29ccfa76e4432aad$export$27ed41b918d907ef = {}));
var $29ccfa76e4432aad$export$7aab3c6e38d56209;
(function(ClassicJustification_OrderBy) {
    ClassicJustification_OrderBy["Choice"] = "choice";
    ClassicJustification_OrderBy["CoreDispute"] = "coreDispute";
    ClassicJustification_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    ClassicJustification_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    ClassicJustification_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    ClassicJustification_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    ClassicJustification_OrderBy["CoreDisputeId"] = "coreDispute__id";
    ClassicJustification_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    ClassicJustification_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    ClassicJustification_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    ClassicJustification_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    ClassicJustification_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    ClassicJustification_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    ClassicJustification_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    ClassicJustification_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    ClassicJustification_OrderBy["Id"] = "id";
    ClassicJustification_OrderBy["Juror"] = "juror";
    ClassicJustification_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    ClassicJustification_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    ClassicJustification_OrderBy["JurorId"] = "juror__id";
    ClassicJustification_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    ClassicJustification_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    ClassicJustification_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    ClassicJustification_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    ClassicJustification_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    ClassicJustification_OrderBy["JurorTotalStake"] = "juror__totalStake";
    ClassicJustification_OrderBy["LocalRound"] = "localRound";
    ClassicJustification_OrderBy["LocalRoundFeeRewards"] = "localRound__feeRewards";
    ClassicJustification_OrderBy["LocalRoundId"] = "localRound__id";
    ClassicJustification_OrderBy["LocalRoundTied"] = "localRound__tied";
    ClassicJustification_OrderBy["LocalRoundTotalCommited"] = "localRound__totalCommited";
    ClassicJustification_OrderBy["LocalRoundTotalVoted"] = "localRound__totalVoted";
    ClassicJustification_OrderBy["LocalRoundWinningChoice"] = "localRound__winningChoice";
    ClassicJustification_OrderBy["Reference"] = "reference";
    ClassicJustification_OrderBy["Votes"] = "votes";
})($29ccfa76e4432aad$export$7aab3c6e38d56209 || ($29ccfa76e4432aad$export$7aab3c6e38d56209 = {}));
var $29ccfa76e4432aad$export$25c0724374695152;
(function(ClassicRound_OrderBy) {
    ClassicRound_OrderBy["Contributions"] = "contributions";
    ClassicRound_OrderBy["Counts"] = "counts";
    ClassicRound_OrderBy["FeeRewards"] = "feeRewards";
    ClassicRound_OrderBy["FundedChoices"] = "fundedChoices";
    ClassicRound_OrderBy["Id"] = "id";
    ClassicRound_OrderBy["Justifications"] = "justifications";
    ClassicRound_OrderBy["LocalDispute"] = "localDispute";
    ClassicRound_OrderBy["LocalDisputeCurrentLocalRoundIndex"] = "localDispute__currentLocalRoundIndex";
    ClassicRound_OrderBy["LocalDisputeId"] = "localDispute__id";
    ClassicRound_OrderBy["LocalDisputeTimestamp"] = "localDispute__timestamp";
    ClassicRound_OrderBy["PaidFees"] = "paidFees";
    ClassicRound_OrderBy["Tied"] = "tied";
    ClassicRound_OrderBy["TotalCommited"] = "totalCommited";
    ClassicRound_OrderBy["TotalVoted"] = "totalVoted";
    ClassicRound_OrderBy["Votes"] = "votes";
    ClassicRound_OrderBy["WinningChoice"] = "winningChoice";
})($29ccfa76e4432aad$export$25c0724374695152 || ($29ccfa76e4432aad$export$25c0724374695152 = {}));
var $29ccfa76e4432aad$export$5389272c24daa45c;
(function(ClassicVote_OrderBy) {
    ClassicVote_OrderBy["Choice"] = "choice";
    ClassicVote_OrderBy["Commit"] = "commit";
    ClassicVote_OrderBy["Commited"] = "commited";
    ClassicVote_OrderBy["CoreDispute"] = "coreDispute";
    ClassicVote_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    ClassicVote_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    ClassicVote_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    ClassicVote_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    ClassicVote_OrderBy["CoreDisputeId"] = "coreDispute__id";
    ClassicVote_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    ClassicVote_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    ClassicVote_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    ClassicVote_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    ClassicVote_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    ClassicVote_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    ClassicVote_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    ClassicVote_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    ClassicVote_OrderBy["Draw"] = "draw";
    ClassicVote_OrderBy["DrawBlockNumber"] = "draw__blockNumber";
    ClassicVote_OrderBy["DrawDrawNotificationIndex"] = "draw__drawNotificationIndex";
    ClassicVote_OrderBy["DrawId"] = "draw__id";
    ClassicVote_OrderBy["DrawVoteIdNum"] = "draw__voteIDNum";
    ClassicVote_OrderBy["Id"] = "id";
    ClassicVote_OrderBy["Juror"] = "juror";
    ClassicVote_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    ClassicVote_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    ClassicVote_OrderBy["JurorId"] = "juror__id";
    ClassicVote_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    ClassicVote_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    ClassicVote_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    ClassicVote_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    ClassicVote_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    ClassicVote_OrderBy["JurorTotalStake"] = "juror__totalStake";
    ClassicVote_OrderBy["Justification"] = "justification";
    ClassicVote_OrderBy["JustificationChoice"] = "justification__choice";
    ClassicVote_OrderBy["JustificationId"] = "justification__id";
    ClassicVote_OrderBy["JustificationReference"] = "justification__reference";
    ClassicVote_OrderBy["LocalRound"] = "localRound";
    ClassicVote_OrderBy["LocalRoundId"] = "localRound__id";
    ClassicVote_OrderBy["Voted"] = "voted";
})($29ccfa76e4432aad$export$5389272c24daa45c || ($29ccfa76e4432aad$export$5389272c24daa45c = {}));
var $29ccfa76e4432aad$export$c2ae227b33735a25;
(function(Contribution_OrderBy) {
    Contribution_OrderBy["Contributor"] = "contributor";
    Contribution_OrderBy["ContributorActiveDisputes"] = "contributor__activeDisputes";
    Contribution_OrderBy["ContributorCoherenceScore"] = "contributor__coherenceScore";
    Contribution_OrderBy["ContributorId"] = "contributor__id";
    Contribution_OrderBy["ContributorTotalAppealingDisputes"] = "contributor__totalAppealingDisputes";
    Contribution_OrderBy["ContributorTotalCoherent"] = "contributor__totalCoherent";
    Contribution_OrderBy["ContributorTotalDelayed"] = "contributor__totalDelayed";
    Contribution_OrderBy["ContributorTotalDisputes"] = "contributor__totalDisputes";
    Contribution_OrderBy["ContributorTotalResolvedDisputes"] = "contributor__totalResolvedDisputes";
    Contribution_OrderBy["ContributorTotalStake"] = "contributor__totalStake";
    Contribution_OrderBy["CoreDispute"] = "coreDispute";
    Contribution_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    Contribution_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    Contribution_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    Contribution_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    Contribution_OrderBy["CoreDisputeId"] = "coreDispute__id";
    Contribution_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    Contribution_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    Contribution_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    Contribution_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    Contribution_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    Contribution_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    Contribution_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    Contribution_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    Contribution_OrderBy["Id"] = "id";
})($29ccfa76e4432aad$export$c2ae227b33735a25 || ($29ccfa76e4432aad$export$c2ae227b33735a25 = {}));
var $29ccfa76e4432aad$export$40ce28599522af1;
(function(Counter_OrderBy) {
    Counter_OrderBy["ActiveJurors"] = "activeJurors";
    Counter_OrderBy["Cases"] = "cases";
    Counter_OrderBy["CasesAppealing"] = "casesAppealing";
    Counter_OrderBy["CasesRuled"] = "casesRuled";
    Counter_OrderBy["CasesVoting"] = "casesVoting";
    Counter_OrderBy["Id"] = "id";
    Counter_OrderBy["PaidEth"] = "paidETH";
    Counter_OrderBy["RedistributedPnk"] = "redistributedPNK";
    Counter_OrderBy["StakedPnk"] = "stakedPNK";
})($29ccfa76e4432aad$export$40ce28599522af1 || ($29ccfa76e4432aad$export$40ce28599522af1 = {}));
var $29ccfa76e4432aad$export$a99f84711f1b824e;
(function(Court_OrderBy) {
    Court_OrderBy["Alpha"] = "alpha";
    Court_OrderBy["Children"] = "children";
    Court_OrderBy["DelayedStake"] = "delayedStake";
    Court_OrderBy["Disputes"] = "disputes";
    Court_OrderBy["FeeForJuror"] = "feeForJuror";
    Court_OrderBy["HiddenVotes"] = "hiddenVotes";
    Court_OrderBy["Id"] = "id";
    Court_OrderBy["JurorsForCourtJump"] = "jurorsForCourtJump";
    Court_OrderBy["MinStake"] = "minStake";
    Court_OrderBy["Name"] = "name";
    Court_OrderBy["NumberAppealingDisputes"] = "numberAppealingDisputes";
    Court_OrderBy["NumberClosedDisputes"] = "numberClosedDisputes";
    Court_OrderBy["NumberDisputes"] = "numberDisputes";
    Court_OrderBy["NumberStakedJurors"] = "numberStakedJurors";
    Court_OrderBy["NumberVotingDisputes"] = "numberVotingDisputes";
    Court_OrderBy["PaidEth"] = "paidETH";
    Court_OrderBy["PaidPnk"] = "paidPNK";
    Court_OrderBy["Parent"] = "parent";
    Court_OrderBy["ParentAlpha"] = "parent__alpha";
    Court_OrderBy["ParentDelayedStake"] = "parent__delayedStake";
    Court_OrderBy["ParentFeeForJuror"] = "parent__feeForJuror";
    Court_OrderBy["ParentHiddenVotes"] = "parent__hiddenVotes";
    Court_OrderBy["ParentId"] = "parent__id";
    Court_OrderBy["ParentJurorsForCourtJump"] = "parent__jurorsForCourtJump";
    Court_OrderBy["ParentMinStake"] = "parent__minStake";
    Court_OrderBy["ParentName"] = "parent__name";
    Court_OrderBy["ParentNumberAppealingDisputes"] = "parent__numberAppealingDisputes";
    Court_OrderBy["ParentNumberClosedDisputes"] = "parent__numberClosedDisputes";
    Court_OrderBy["ParentNumberDisputes"] = "parent__numberDisputes";
    Court_OrderBy["ParentNumberStakedJurors"] = "parent__numberStakedJurors";
    Court_OrderBy["ParentNumberVotingDisputes"] = "parent__numberVotingDisputes";
    Court_OrderBy["ParentPaidEth"] = "parent__paidETH";
    Court_OrderBy["ParentPaidPnk"] = "parent__paidPNK";
    Court_OrderBy["ParentPolicy"] = "parent__policy";
    Court_OrderBy["ParentStake"] = "parent__stake";
    Court_OrderBy["Policy"] = "policy";
    Court_OrderBy["Stake"] = "stake";
    Court_OrderBy["StakedJurors"] = "stakedJurors";
    Court_OrderBy["SupportedDisputeKits"] = "supportedDisputeKits";
    Court_OrderBy["TimesPerPeriod"] = "timesPerPeriod";
})($29ccfa76e4432aad$export$a99f84711f1b824e || ($29ccfa76e4432aad$export$a99f84711f1b824e = {}));
var $29ccfa76e4432aad$export$5f90f697691f195f;
(function(DisputeKitDispute_OrderBy) {
    DisputeKitDispute_OrderBy["CoreDispute"] = "coreDispute";
    DisputeKitDispute_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    DisputeKitDispute_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    DisputeKitDispute_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    DisputeKitDispute_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    DisputeKitDispute_OrderBy["CoreDisputeId"] = "coreDispute__id";
    DisputeKitDispute_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    DisputeKitDispute_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    DisputeKitDispute_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    DisputeKitDispute_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    DisputeKitDispute_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    DisputeKitDispute_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    DisputeKitDispute_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    DisputeKitDispute_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    DisputeKitDispute_OrderBy["CurrentLocalRoundIndex"] = "currentLocalRoundIndex";
    DisputeKitDispute_OrderBy["Id"] = "id";
    DisputeKitDispute_OrderBy["LocalRounds"] = "localRounds";
    DisputeKitDispute_OrderBy["Timestamp"] = "timestamp";
})($29ccfa76e4432aad$export$5f90f697691f195f || ($29ccfa76e4432aad$export$5f90f697691f195f = {}));
var $29ccfa76e4432aad$export$435d377506afb9d0;
(function(DisputeKitRound_OrderBy) {
    DisputeKitRound_OrderBy["Id"] = "id";
    DisputeKitRound_OrderBy["LocalDispute"] = "localDispute";
    DisputeKitRound_OrderBy["LocalDisputeCurrentLocalRoundIndex"] = "localDispute__currentLocalRoundIndex";
    DisputeKitRound_OrderBy["LocalDisputeId"] = "localDispute__id";
    DisputeKitRound_OrderBy["LocalDisputeTimestamp"] = "localDispute__timestamp";
    DisputeKitRound_OrderBy["Votes"] = "votes";
})($29ccfa76e4432aad$export$435d377506afb9d0 || ($29ccfa76e4432aad$export$435d377506afb9d0 = {}));
var $29ccfa76e4432aad$export$b30bd42f1b9291f7;
(function(DisputeKit_OrderBy) {
    DisputeKit_OrderBy["Address"] = "address";
    DisputeKit_OrderBy["Courts"] = "courts";
    DisputeKit_OrderBy["Id"] = "id";
    DisputeKit_OrderBy["NeedsFreezing"] = "needsFreezing";
    DisputeKit_OrderBy["Rounds"] = "rounds";
})($29ccfa76e4432aad$export$b30bd42f1b9291f7 || ($29ccfa76e4432aad$export$b30bd42f1b9291f7 = {}));
var $29ccfa76e4432aad$export$c77e7861548a789f;
(function(DisputeTemplate_OrderBy) {
    DisputeTemplate_OrderBy["Id"] = "id";
    DisputeTemplate_OrderBy["TemplateData"] = "templateData";
    DisputeTemplate_OrderBy["TemplateDataMappings"] = "templateDataMappings";
    DisputeTemplate_OrderBy["TemplateTag"] = "templateTag";
})($29ccfa76e4432aad$export$c77e7861548a789f || ($29ccfa76e4432aad$export$c77e7861548a789f = {}));
var $29ccfa76e4432aad$export$37347338dc637279;
(function(Dispute_OrderBy) {
    Dispute_OrderBy["Arbitrated"] = "arbitrated";
    Dispute_OrderBy["ArbitratedId"] = "arbitrated__id";
    Dispute_OrderBy["ArbitratedTotalDisputes"] = "arbitrated__totalDisputes";
    Dispute_OrderBy["Court"] = "court";
    Dispute_OrderBy["CourtAlpha"] = "court__alpha";
    Dispute_OrderBy["CourtDelayedStake"] = "court__delayedStake";
    Dispute_OrderBy["CourtFeeForJuror"] = "court__feeForJuror";
    Dispute_OrderBy["CourtHiddenVotes"] = "court__hiddenVotes";
    Dispute_OrderBy["CourtId"] = "court__id";
    Dispute_OrderBy["CourtJurorsForCourtJump"] = "court__jurorsForCourtJump";
    Dispute_OrderBy["CourtMinStake"] = "court__minStake";
    Dispute_OrderBy["CourtName"] = "court__name";
    Dispute_OrderBy["CourtNumberAppealingDisputes"] = "court__numberAppealingDisputes";
    Dispute_OrderBy["CourtNumberClosedDisputes"] = "court__numberClosedDisputes";
    Dispute_OrderBy["CourtNumberDisputes"] = "court__numberDisputes";
    Dispute_OrderBy["CourtNumberStakedJurors"] = "court__numberStakedJurors";
    Dispute_OrderBy["CourtNumberVotingDisputes"] = "court__numberVotingDisputes";
    Dispute_OrderBy["CourtPaidEth"] = "court__paidETH";
    Dispute_OrderBy["CourtPaidPnk"] = "court__paidPNK";
    Dispute_OrderBy["CourtPolicy"] = "court__policy";
    Dispute_OrderBy["CourtStake"] = "court__stake";
    Dispute_OrderBy["CreatedAt"] = "createdAt";
    Dispute_OrderBy["CurrentRound"] = "currentRound";
    Dispute_OrderBy["CurrentRoundIndex"] = "currentRoundIndex";
    Dispute_OrderBy["CurrentRoundId"] = "currentRound__id";
    Dispute_OrderBy["CurrentRoundIsCurrentRound"] = "currentRound__isCurrentRound";
    Dispute_OrderBy["CurrentRoundNbVotes"] = "currentRound__nbVotes";
    Dispute_OrderBy["CurrentRoundPenalties"] = "currentRound__penalties";
    Dispute_OrderBy["CurrentRoundRepartitions"] = "currentRound__repartitions";
    Dispute_OrderBy["CurrentRoundTokensAtStakePerJuror"] = "currentRound__tokensAtStakePerJuror";
    Dispute_OrderBy["CurrentRoundTotalFeesForJurors"] = "currentRound__totalFeesForJurors";
    Dispute_OrderBy["CurrentRuling"] = "currentRuling";
    Dispute_OrderBy["DisputeId"] = "disputeID";
    Dispute_OrderBy["DisputeKitDispute"] = "disputeKitDispute";
    Dispute_OrderBy["Id"] = "id";
    Dispute_OrderBy["Jurors"] = "jurors";
    Dispute_OrderBy["LastPeriodChange"] = "lastPeriodChange";
    Dispute_OrderBy["LastPeriodChangeBlockNumber"] = "lastPeriodChangeBlockNumber";
    Dispute_OrderBy["Overridden"] = "overridden";
    Dispute_OrderBy["Period"] = "period";
    Dispute_OrderBy["PeriodDeadline"] = "periodDeadline";
    Dispute_OrderBy["PeriodNotificationIndex"] = "periodNotificationIndex";
    Dispute_OrderBy["Rounds"] = "rounds";
    Dispute_OrderBy["Ruled"] = "ruled";
    Dispute_OrderBy["Shifts"] = "shifts";
    Dispute_OrderBy["Tied"] = "tied";
})($29ccfa76e4432aad$export$37347338dc637279 || ($29ccfa76e4432aad$export$37347338dc637279 = {}));
var $29ccfa76e4432aad$export$587f35f5ff6a325b;
(function(Draw_OrderBy) {
    Draw_OrderBy["BlockNumber"] = "blockNumber";
    Draw_OrderBy["Dispute"] = "dispute";
    Draw_OrderBy["DisputeCreatedAt"] = "dispute__createdAt";
    Draw_OrderBy["DisputeCurrentRoundIndex"] = "dispute__currentRoundIndex";
    Draw_OrderBy["DisputeCurrentRuling"] = "dispute__currentRuling";
    Draw_OrderBy["DisputeDisputeId"] = "dispute__disputeID";
    Draw_OrderBy["DisputeId"] = "dispute__id";
    Draw_OrderBy["DisputeLastPeriodChange"] = "dispute__lastPeriodChange";
    Draw_OrderBy["DisputeLastPeriodChangeBlockNumber"] = "dispute__lastPeriodChangeBlockNumber";
    Draw_OrderBy["DisputeOverridden"] = "dispute__overridden";
    Draw_OrderBy["DisputePeriod"] = "dispute__period";
    Draw_OrderBy["DisputePeriodDeadline"] = "dispute__periodDeadline";
    Draw_OrderBy["DisputePeriodNotificationIndex"] = "dispute__periodNotificationIndex";
    Draw_OrderBy["DisputeRuled"] = "dispute__ruled";
    Draw_OrderBy["DisputeTied"] = "dispute__tied";
    Draw_OrderBy["DrawNotificationIndex"] = "drawNotificationIndex";
    Draw_OrderBy["Id"] = "id";
    Draw_OrderBy["Juror"] = "juror";
    Draw_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    Draw_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    Draw_OrderBy["JurorId"] = "juror__id";
    Draw_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    Draw_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    Draw_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    Draw_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    Draw_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    Draw_OrderBy["JurorTotalStake"] = "juror__totalStake";
    Draw_OrderBy["Round"] = "round";
    Draw_OrderBy["RoundId"] = "round__id";
    Draw_OrderBy["RoundIsCurrentRound"] = "round__isCurrentRound";
    Draw_OrderBy["RoundNbVotes"] = "round__nbVotes";
    Draw_OrderBy["RoundPenalties"] = "round__penalties";
    Draw_OrderBy["RoundRepartitions"] = "round__repartitions";
    Draw_OrderBy["RoundTokensAtStakePerJuror"] = "round__tokensAtStakePerJuror";
    Draw_OrderBy["RoundTotalFeesForJurors"] = "round__totalFeesForJurors";
    Draw_OrderBy["Vote"] = "vote";
    Draw_OrderBy["VoteIdNum"] = "voteIDNum";
    Draw_OrderBy["VoteId"] = "vote__id";
})($29ccfa76e4432aad$export$587f35f5ff6a325b || ($29ccfa76e4432aad$export$587f35f5ff6a325b = {}));
var $29ccfa76e4432aad$export$5fd9477f090af7b6;
(function(EvidenceGroup_OrderBy) {
    EvidenceGroup_OrderBy["Evidences"] = "evidences";
    EvidenceGroup_OrderBy["Id"] = "id";
    EvidenceGroup_OrderBy["NextEvidenceIndex"] = "nextEvidenceIndex";
})($29ccfa76e4432aad$export$5fd9477f090af7b6 || ($29ccfa76e4432aad$export$5fd9477f090af7b6 = {}));
var $29ccfa76e4432aad$export$f5f4c257fd10627;
(function(Evidence_OrderBy) {
    Evidence_OrderBy["Evidence"] = "evidence";
    Evidence_OrderBy["EvidenceGroup"] = "evidenceGroup";
    Evidence_OrderBy["EvidenceGroupId"] = "evidenceGroup__id";
    Evidence_OrderBy["EvidenceGroupNextEvidenceIndex"] = "evidenceGroup__nextEvidenceIndex";
    Evidence_OrderBy["Id"] = "id";
    Evidence_OrderBy["Sender"] = "sender";
    Evidence_OrderBy["SenderActiveDisputes"] = "sender__activeDisputes";
    Evidence_OrderBy["SenderCoherenceScore"] = "sender__coherenceScore";
    Evidence_OrderBy["SenderId"] = "sender__id";
    Evidence_OrderBy["SenderTotalAppealingDisputes"] = "sender__totalAppealingDisputes";
    Evidence_OrderBy["SenderTotalCoherent"] = "sender__totalCoherent";
    Evidence_OrderBy["SenderTotalDelayed"] = "sender__totalDelayed";
    Evidence_OrderBy["SenderTotalDisputes"] = "sender__totalDisputes";
    Evidence_OrderBy["SenderTotalResolvedDisputes"] = "sender__totalResolvedDisputes";
    Evidence_OrderBy["SenderTotalStake"] = "sender__totalStake";
})($29ccfa76e4432aad$export$f5f4c257fd10627 || ($29ccfa76e4432aad$export$f5f4c257fd10627 = {}));
var $29ccfa76e4432aad$export$66cb23f436c84ff1;
(function(FeeToken_OrderBy) {
    FeeToken_OrderBy["Accepted"] = "accepted";
    FeeToken_OrderBy["Id"] = "id";
    FeeToken_OrderBy["RateDecimals"] = "rateDecimals";
    FeeToken_OrderBy["RateInEth"] = "rateInEth";
    FeeToken_OrderBy["Rounds"] = "rounds";
    FeeToken_OrderBy["TokenAndEthShift"] = "tokenAndETHShift";
    FeeToken_OrderBy["TotalPaid"] = "totalPaid";
    FeeToken_OrderBy["TotalPaidInEth"] = "totalPaidInETH";
})($29ccfa76e4432aad$export$66cb23f436c84ff1 || ($29ccfa76e4432aad$export$66cb23f436c84ff1 = {}));
var $29ccfa76e4432aad$export$177f357963b5190a;
(function(JurorTokensPerCourt_OrderBy) {
    JurorTokensPerCourt_OrderBy["Court"] = "court";
    JurorTokensPerCourt_OrderBy["CourtAlpha"] = "court__alpha";
    JurorTokensPerCourt_OrderBy["CourtDelayedStake"] = "court__delayedStake";
    JurorTokensPerCourt_OrderBy["CourtFeeForJuror"] = "court__feeForJuror";
    JurorTokensPerCourt_OrderBy["CourtHiddenVotes"] = "court__hiddenVotes";
    JurorTokensPerCourt_OrderBy["CourtId"] = "court__id";
    JurorTokensPerCourt_OrderBy["CourtJurorsForCourtJump"] = "court__jurorsForCourtJump";
    JurorTokensPerCourt_OrderBy["CourtMinStake"] = "court__minStake";
    JurorTokensPerCourt_OrderBy["CourtName"] = "court__name";
    JurorTokensPerCourt_OrderBy["CourtNumberAppealingDisputes"] = "court__numberAppealingDisputes";
    JurorTokensPerCourt_OrderBy["CourtNumberClosedDisputes"] = "court__numberClosedDisputes";
    JurorTokensPerCourt_OrderBy["CourtNumberDisputes"] = "court__numberDisputes";
    JurorTokensPerCourt_OrderBy["CourtNumberStakedJurors"] = "court__numberStakedJurors";
    JurorTokensPerCourt_OrderBy["CourtNumberVotingDisputes"] = "court__numberVotingDisputes";
    JurorTokensPerCourt_OrderBy["CourtPaidEth"] = "court__paidETH";
    JurorTokensPerCourt_OrderBy["CourtPaidPnk"] = "court__paidPNK";
    JurorTokensPerCourt_OrderBy["CourtPolicy"] = "court__policy";
    JurorTokensPerCourt_OrderBy["CourtStake"] = "court__stake";
    JurorTokensPerCourt_OrderBy["Delayed"] = "delayed";
    JurorTokensPerCourt_OrderBy["Id"] = "id";
    JurorTokensPerCourt_OrderBy["Juror"] = "juror";
    JurorTokensPerCourt_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    JurorTokensPerCourt_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    JurorTokensPerCourt_OrderBy["JurorId"] = "juror__id";
    JurorTokensPerCourt_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    JurorTokensPerCourt_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    JurorTokensPerCourt_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    JurorTokensPerCourt_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    JurorTokensPerCourt_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    JurorTokensPerCourt_OrderBy["JurorTotalStake"] = "juror__totalStake";
    JurorTokensPerCourt_OrderBy["Locked"] = "locked";
    JurorTokensPerCourt_OrderBy["Staked"] = "staked";
})($29ccfa76e4432aad$export$177f357963b5190a || ($29ccfa76e4432aad$export$177f357963b5190a = {}));
var $29ccfa76e4432aad$export$6576b9de878968d6;
(function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})($29ccfa76e4432aad$export$6576b9de878968d6 || ($29ccfa76e4432aad$export$6576b9de878968d6 = {}));
var $29ccfa76e4432aad$export$f08c34d6584ea1e6;
(function(Penalty_OrderBy) {
    Penalty_OrderBy["Amount"] = "amount";
    Penalty_OrderBy["DegreeOfCoherency"] = "degreeOfCoherency";
    Penalty_OrderBy["Dispute"] = "dispute";
    Penalty_OrderBy["DisputeCreatedAt"] = "dispute__createdAt";
    Penalty_OrderBy["DisputeCurrentRoundIndex"] = "dispute__currentRoundIndex";
    Penalty_OrderBy["DisputeCurrentRuling"] = "dispute__currentRuling";
    Penalty_OrderBy["DisputeDisputeId"] = "dispute__disputeID";
    Penalty_OrderBy["DisputeId"] = "dispute__id";
    Penalty_OrderBy["DisputeLastPeriodChange"] = "dispute__lastPeriodChange";
    Penalty_OrderBy["DisputeLastPeriodChangeBlockNumber"] = "dispute__lastPeriodChangeBlockNumber";
    Penalty_OrderBy["DisputeOverridden"] = "dispute__overridden";
    Penalty_OrderBy["DisputePeriod"] = "dispute__period";
    Penalty_OrderBy["DisputePeriodDeadline"] = "dispute__periodDeadline";
    Penalty_OrderBy["DisputePeriodNotificationIndex"] = "dispute__periodNotificationIndex";
    Penalty_OrderBy["DisputeRuled"] = "dispute__ruled";
    Penalty_OrderBy["DisputeTied"] = "dispute__tied";
    Penalty_OrderBy["Id"] = "id";
    Penalty_OrderBy["Juror"] = "juror";
    Penalty_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    Penalty_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    Penalty_OrderBy["JurorId"] = "juror__id";
    Penalty_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    Penalty_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    Penalty_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    Penalty_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    Penalty_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    Penalty_OrderBy["JurorTotalStake"] = "juror__totalStake";
    Penalty_OrderBy["NumberDraws"] = "numberDraws";
    Penalty_OrderBy["Round"] = "round";
    Penalty_OrderBy["RoundId"] = "round__id";
    Penalty_OrderBy["RoundIsCurrentRound"] = "round__isCurrentRound";
    Penalty_OrderBy["RoundNbVotes"] = "round__nbVotes";
    Penalty_OrderBy["RoundPenalties"] = "round__penalties";
    Penalty_OrderBy["RoundRepartitions"] = "round__repartitions";
    Penalty_OrderBy["RoundTokensAtStakePerJuror"] = "round__tokensAtStakePerJuror";
    Penalty_OrderBy["RoundTotalFeesForJurors"] = "round__totalFeesForJurors";
})($29ccfa76e4432aad$export$f08c34d6584ea1e6 || ($29ccfa76e4432aad$export$f08c34d6584ea1e6 = {}));
var $29ccfa76e4432aad$export$67186dcd8fa4f92f;
(function(Period) {
    Period["Appeal"] = "appeal";
    Period["Commit"] = "commit";
    Period["Evidence"] = "evidence";
    Period["Execution"] = "execution";
    Period["Vote"] = "vote";
})($29ccfa76e4432aad$export$67186dcd8fa4f92f || ($29ccfa76e4432aad$export$67186dcd8fa4f92f = {}));
var $29ccfa76e4432aad$export$b90ce3cd5a2f8f9d;
(function(PeriodIndexCounter_OrderBy) {
    PeriodIndexCounter_OrderBy["Counter"] = "counter";
    PeriodIndexCounter_OrderBy["Id"] = "id";
})($29ccfa76e4432aad$export$b90ce3cd5a2f8f9d || ($29ccfa76e4432aad$export$b90ce3cd5a2f8f9d = {}));
var $29ccfa76e4432aad$export$6504ff334d5850dc;
(function(Round_OrderBy) {
    Round_OrderBy["Court"] = "court";
    Round_OrderBy["CourtAlpha"] = "court__alpha";
    Round_OrderBy["CourtDelayedStake"] = "court__delayedStake";
    Round_OrderBy["CourtFeeForJuror"] = "court__feeForJuror";
    Round_OrderBy["CourtHiddenVotes"] = "court__hiddenVotes";
    Round_OrderBy["CourtId"] = "court__id";
    Round_OrderBy["CourtJurorsForCourtJump"] = "court__jurorsForCourtJump";
    Round_OrderBy["CourtMinStake"] = "court__minStake";
    Round_OrderBy["CourtName"] = "court__name";
    Round_OrderBy["CourtNumberAppealingDisputes"] = "court__numberAppealingDisputes";
    Round_OrderBy["CourtNumberClosedDisputes"] = "court__numberClosedDisputes";
    Round_OrderBy["CourtNumberDisputes"] = "court__numberDisputes";
    Round_OrderBy["CourtNumberStakedJurors"] = "court__numberStakedJurors";
    Round_OrderBy["CourtNumberVotingDisputes"] = "court__numberVotingDisputes";
    Round_OrderBy["CourtPaidEth"] = "court__paidETH";
    Round_OrderBy["CourtPaidPnk"] = "court__paidPNK";
    Round_OrderBy["CourtPolicy"] = "court__policy";
    Round_OrderBy["CourtStake"] = "court__stake";
    Round_OrderBy["Dispute"] = "dispute";
    Round_OrderBy["DisputeKit"] = "disputeKit";
    Round_OrderBy["DisputeKitAddress"] = "disputeKit__address";
    Round_OrderBy["DisputeKitId"] = "disputeKit__id";
    Round_OrderBy["DisputeKitNeedsFreezing"] = "disputeKit__needsFreezing";
    Round_OrderBy["DisputeCreatedAt"] = "dispute__createdAt";
    Round_OrderBy["DisputeCurrentRoundIndex"] = "dispute__currentRoundIndex";
    Round_OrderBy["DisputeCurrentRuling"] = "dispute__currentRuling";
    Round_OrderBy["DisputeDisputeId"] = "dispute__disputeID";
    Round_OrderBy["DisputeId"] = "dispute__id";
    Round_OrderBy["DisputeLastPeriodChange"] = "dispute__lastPeriodChange";
    Round_OrderBy["DisputeLastPeriodChangeBlockNumber"] = "dispute__lastPeriodChangeBlockNumber";
    Round_OrderBy["DisputeOverridden"] = "dispute__overridden";
    Round_OrderBy["DisputePeriod"] = "dispute__period";
    Round_OrderBy["DisputePeriodDeadline"] = "dispute__periodDeadline";
    Round_OrderBy["DisputePeriodNotificationIndex"] = "dispute__periodNotificationIndex";
    Round_OrderBy["DisputeRuled"] = "dispute__ruled";
    Round_OrderBy["DisputeTied"] = "dispute__tied";
    Round_OrderBy["DrawnJurors"] = "drawnJurors";
    Round_OrderBy["FeeToken"] = "feeToken";
    Round_OrderBy["FeeTokenAccepted"] = "feeToken__accepted";
    Round_OrderBy["FeeTokenId"] = "feeToken__id";
    Round_OrderBy["FeeTokenRateDecimals"] = "feeToken__rateDecimals";
    Round_OrderBy["FeeTokenRateInEth"] = "feeToken__rateInEth";
    Round_OrderBy["FeeTokenTotalPaid"] = "feeToken__totalPaid";
    Round_OrderBy["FeeTokenTotalPaidInEth"] = "feeToken__totalPaidInETH";
    Round_OrderBy["Id"] = "id";
    Round_OrderBy["IsCurrentRound"] = "isCurrentRound";
    Round_OrderBy["NbVotes"] = "nbVotes";
    Round_OrderBy["Penalties"] = "penalties";
    Round_OrderBy["Repartitions"] = "repartitions";
    Round_OrderBy["Timeline"] = "timeline";
    Round_OrderBy["TokensAtStakePerJuror"] = "tokensAtStakePerJuror";
    Round_OrderBy["TotalFeesForJurors"] = "totalFeesForJurors";
})($29ccfa76e4432aad$export$6504ff334d5850dc || ($29ccfa76e4432aad$export$6504ff334d5850dc = {}));
var $29ccfa76e4432aad$export$5744346d8c07f3c0;
(function(TokenAndEthShift_OrderBy) {
    TokenAndEthShift_OrderBy["Dispute"] = "dispute";
    TokenAndEthShift_OrderBy["DisputeCreatedAt"] = "dispute__createdAt";
    TokenAndEthShift_OrderBy["DisputeCurrentRoundIndex"] = "dispute__currentRoundIndex";
    TokenAndEthShift_OrderBy["DisputeCurrentRuling"] = "dispute__currentRuling";
    TokenAndEthShift_OrderBy["DisputeDisputeId"] = "dispute__disputeID";
    TokenAndEthShift_OrderBy["DisputeId"] = "dispute__id";
    TokenAndEthShift_OrderBy["DisputeLastPeriodChange"] = "dispute__lastPeriodChange";
    TokenAndEthShift_OrderBy["DisputeLastPeriodChangeBlockNumber"] = "dispute__lastPeriodChangeBlockNumber";
    TokenAndEthShift_OrderBy["DisputeOverridden"] = "dispute__overridden";
    TokenAndEthShift_OrderBy["DisputePeriod"] = "dispute__period";
    TokenAndEthShift_OrderBy["DisputePeriodDeadline"] = "dispute__periodDeadline";
    TokenAndEthShift_OrderBy["DisputePeriodNotificationIndex"] = "dispute__periodNotificationIndex";
    TokenAndEthShift_OrderBy["DisputeRuled"] = "dispute__ruled";
    TokenAndEthShift_OrderBy["DisputeTied"] = "dispute__tied";
    TokenAndEthShift_OrderBy["EthAmount"] = "ethAmount";
    TokenAndEthShift_OrderBy["FeeToken"] = "feeToken";
    TokenAndEthShift_OrderBy["FeeTokenAmount"] = "feeTokenAmount";
    TokenAndEthShift_OrderBy["FeeTokenAccepted"] = "feeToken__accepted";
    TokenAndEthShift_OrderBy["FeeTokenId"] = "feeToken__id";
    TokenAndEthShift_OrderBy["FeeTokenRateDecimals"] = "feeToken__rateDecimals";
    TokenAndEthShift_OrderBy["FeeTokenRateInEth"] = "feeToken__rateInEth";
    TokenAndEthShift_OrderBy["FeeTokenTotalPaid"] = "feeToken__totalPaid";
    TokenAndEthShift_OrderBy["FeeTokenTotalPaidInEth"] = "feeToken__totalPaidInETH";
    TokenAndEthShift_OrderBy["Id"] = "id";
    TokenAndEthShift_OrderBy["IsNativeCurrency"] = "isNativeCurrency";
    TokenAndEthShift_OrderBy["Juror"] = "juror";
    TokenAndEthShift_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    TokenAndEthShift_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    TokenAndEthShift_OrderBy["JurorId"] = "juror__id";
    TokenAndEthShift_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    TokenAndEthShift_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    TokenAndEthShift_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    TokenAndEthShift_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    TokenAndEthShift_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    TokenAndEthShift_OrderBy["JurorTotalStake"] = "juror__totalStake";
    TokenAndEthShift_OrderBy["PnkAmount"] = "pnkAmount";
})($29ccfa76e4432aad$export$5744346d8c07f3c0 || ($29ccfa76e4432aad$export$5744346d8c07f3c0 = {}));
var $29ccfa76e4432aad$export$8ad01fc113ebd6d0;
(function(User_OrderBy) {
    User_OrderBy["ActiveDisputes"] = "activeDisputes";
    User_OrderBy["CoherenceScore"] = "coherenceScore";
    User_OrderBy["Contributions"] = "contributions";
    User_OrderBy["Disputes"] = "disputes";
    User_OrderBy["Draws"] = "draws";
    User_OrderBy["Evidences"] = "evidences";
    User_OrderBy["Id"] = "id";
    User_OrderBy["Penalties"] = "penalties";
    User_OrderBy["ResolvedDisputes"] = "resolvedDisputes";
    User_OrderBy["Rounds"] = "rounds";
    User_OrderBy["Shifts"] = "shifts";
    User_OrderBy["Tokens"] = "tokens";
    User_OrderBy["TotalAppealingDisputes"] = "totalAppealingDisputes";
    User_OrderBy["TotalCoherent"] = "totalCoherent";
    User_OrderBy["TotalDelayed"] = "totalDelayed";
    User_OrderBy["TotalDisputes"] = "totalDisputes";
    User_OrderBy["TotalResolvedDisputes"] = "totalResolvedDisputes";
    User_OrderBy["TotalStake"] = "totalStake";
    User_OrderBy["Votes"] = "votes";
})($29ccfa76e4432aad$export$8ad01fc113ebd6d0 || ($29ccfa76e4432aad$export$8ad01fc113ebd6d0 = {}));
var $29ccfa76e4432aad$export$45925727316cfdb6;
(function(Vote_OrderBy) {
    Vote_OrderBy["CoreDispute"] = "coreDispute";
    Vote_OrderBy["CoreDisputeCreatedAt"] = "coreDispute__createdAt";
    Vote_OrderBy["CoreDisputeCurrentRoundIndex"] = "coreDispute__currentRoundIndex";
    Vote_OrderBy["CoreDisputeCurrentRuling"] = "coreDispute__currentRuling";
    Vote_OrderBy["CoreDisputeDisputeId"] = "coreDispute__disputeID";
    Vote_OrderBy["CoreDisputeId"] = "coreDispute__id";
    Vote_OrderBy["CoreDisputeLastPeriodChange"] = "coreDispute__lastPeriodChange";
    Vote_OrderBy["CoreDisputeLastPeriodChangeBlockNumber"] = "coreDispute__lastPeriodChangeBlockNumber";
    Vote_OrderBy["CoreDisputeOverridden"] = "coreDispute__overridden";
    Vote_OrderBy["CoreDisputePeriod"] = "coreDispute__period";
    Vote_OrderBy["CoreDisputePeriodDeadline"] = "coreDispute__periodDeadline";
    Vote_OrderBy["CoreDisputePeriodNotificationIndex"] = "coreDispute__periodNotificationIndex";
    Vote_OrderBy["CoreDisputeRuled"] = "coreDispute__ruled";
    Vote_OrderBy["CoreDisputeTied"] = "coreDispute__tied";
    Vote_OrderBy["Draw"] = "draw";
    Vote_OrderBy["DrawBlockNumber"] = "draw__blockNumber";
    Vote_OrderBy["DrawDrawNotificationIndex"] = "draw__drawNotificationIndex";
    Vote_OrderBy["DrawId"] = "draw__id";
    Vote_OrderBy["DrawVoteIdNum"] = "draw__voteIDNum";
    Vote_OrderBy["Id"] = "id";
    Vote_OrderBy["Juror"] = "juror";
    Vote_OrderBy["JurorActiveDisputes"] = "juror__activeDisputes";
    Vote_OrderBy["JurorCoherenceScore"] = "juror__coherenceScore";
    Vote_OrderBy["JurorId"] = "juror__id";
    Vote_OrderBy["JurorTotalAppealingDisputes"] = "juror__totalAppealingDisputes";
    Vote_OrderBy["JurorTotalCoherent"] = "juror__totalCoherent";
    Vote_OrderBy["JurorTotalDelayed"] = "juror__totalDelayed";
    Vote_OrderBy["JurorTotalDisputes"] = "juror__totalDisputes";
    Vote_OrderBy["JurorTotalResolvedDisputes"] = "juror__totalResolvedDisputes";
    Vote_OrderBy["JurorTotalStake"] = "juror__totalStake";
    Vote_OrderBy["LocalRound"] = "localRound";
    Vote_OrderBy["LocalRoundId"] = "localRound__id";
})($29ccfa76e4432aad$export$45925727316cfdb6 || ($29ccfa76e4432aad$export$45925727316cfdb6 = {}));
var $29ccfa76e4432aad$export$ac48b316845cbda1;
(function(_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */ _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */ _SubgraphErrorPolicy_["Deny"] = "deny";
})($29ccfa76e4432aad$export$ac48b316845cbda1 || ($29ccfa76e4432aad$export$ac48b316845cbda1 = {}));
const $29ccfa76e4432aad$export$75b51748b47f28f5 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Dispute"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "arbitrated"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentRoundIndex"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeForJuror"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "period"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastPeriodChange"
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$b2dbb4d61e0c0725 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UserDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "User"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalResolvedDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalAppealingDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalCoherent"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coherenceScore"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokens"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shifts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pnkAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ethAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$61a7f2ed87625e6c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AllCases"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "counter"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "IntValue",
                                    "value": "0"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cases"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "casesRuled"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$e3b4a86dd2dcb796 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CasesPageWhere"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Dispute_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "lastPeriodChange"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "where"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "DisputeDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Dispute"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "arbitrated"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentRoundIndex"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeForJuror"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "period"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastPeriodChange"
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$ee1a540c66d4fa55 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CasesPage"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "lastPeriodChange"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "DisputeDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Dispute"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "arbitrated"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentRoundIndex"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeForJuror"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "period"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastPeriodChange"
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$6306573f66fa2dc9 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "MyCases"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputes"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "first"
                                            },
                                            "value": {
                                                "kind": "IntValue",
                                                "value": "3"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "skip"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "skip"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "lastPeriodChange"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderDirection"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "orderDirection"
                                                }
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "DisputeDetails"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Dispute"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "arbitrated"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentRoundIndex"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeForJuror"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "period"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastPeriodChange"
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$30b6e8045c42a87b = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "myCasesPageWhere"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Int"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Dispute_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputes"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "first"
                                            },
                                            "value": {
                                                "kind": "IntValue",
                                                "value": "3"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "skip"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "skip"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "lastPeriodChange"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderDirection"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "orderDirection"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "where"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "where"
                                                }
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "DisputeDetails"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Dispute"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "arbitrated"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentRoundIndex"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeForJuror"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "period"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastPeriodChange"
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$f20c7225f33560b0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ClassicAppeal"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "disputeID"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "DisputeKitDispute_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dispute"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeID"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "period"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timesPerPeriod"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "arbitrated"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastPeriodChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeKitDispute"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "orderBy"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderDirection"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "orderDirection"
                                                }
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currentLocalRoundIndex"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "localRounds"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "typeCondition": {
                                                                "kind": "NamedType",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "ClassicRound"
                                                                }
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "winningChoice"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "paidFees"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "fundedChoices"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$50f212ba6deff8f1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Counter"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "counter"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "StringValue",
                                    "value": "0",
                                    "block": false
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cases"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "casesRuled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "casesVoting"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "casesAppealing"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stakedPNK"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "redistributedPNK"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "paidETH"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeJurors"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$f9dd1d91f0b74032 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CourtDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "minStake"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "alpha"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "numberDisputes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "numberClosedDisputes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "numberAppealingDisputes"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "numberStakedJurors"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stake"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "paidETH"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "paidPNK"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timesPerPeriod"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$c1e945355c415f1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CourtPolicyURI"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "courtID"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "courtID"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "policy"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$4e217371325410b1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CourtTree"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "court"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "StringValue",
                                    "value": "1",
                                    "block": false
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "children"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "name"
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "children"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "children"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "children"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "name"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "children"
                                                                                    },
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "name"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "id"
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$2f1a1a679504b6b6 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "DisputeDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "disputeID"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dispute"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeID"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timesPerPeriod"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "hiddenVotes"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "feeForJuror"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "arbitrated"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "period"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ruled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastPeriodChange"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currentRuling"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "overridden"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tied"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currentRound"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currentRoundIndex"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$de0c57b607e9a74e = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "DisputeTemplate"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputeTemplate"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "templateTag"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "templateData"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "templateDataMappings"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$391defa5fc8e169c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Draw"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "address"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "disputeID"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "roundID"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "draws"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "IntValue",
                                    "value": "1000"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "dispute"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "disputeID"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "juror"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "address"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "round"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "roundID"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "voteIDNum"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "vote"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ClassicVote"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "commit"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "commited"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$19cdb1500b30a807 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Evidences"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "evidenceGroupID"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "evidences"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "evidenceGroup"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "evidenceGroupID"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "id"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "asc"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "evidence"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "sender"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$bdf89eeed9df817d = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "HomePage"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "timeframe"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "ID"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputes"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "IntValue",
                                    "value": "3"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "counters"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "id_gt"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timeframe"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "stakedPNK"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "paidETH"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "redistributedPNK"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "activeJurors"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cases"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$43b132a328acab0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "JurorStakeDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "jurorTokensPerCourts"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "juror"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "userId"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "staked"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "locked"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$1aad28a71dc897ce = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "LabelInfo"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "address"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "disputeID"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dispute"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeID"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "period"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "shifts"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "where"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "juror"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "address"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "ethAmount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pnkAmount"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rounds"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "drawnJurors"
                                                },
                                                "arguments": [
                                                    {
                                                        "kind": "Argument",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "where"
                                                        },
                                                        "value": {
                                                            "kind": "ObjectValue",
                                                            "fields": [
                                                                {
                                                                    "kind": "ObjectField",
                                                                    "name": {
                                                                        "kind": "Name",
                                                                        "value": "juror"
                                                                    },
                                                                    "value": {
                                                                        "kind": "Variable",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "address"
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        "kind": "Argument",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "first"
                                                        },
                                                        "value": {
                                                            "kind": "IntValue",
                                                            "value": "1"
                                                        }
                                                    }
                                                ],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "vote"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "typeCondition": {
                                                                            "kind": "NamedType",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "ClassicVote"
                                                                            }
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "choice"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeKitDispute"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "localRounds"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "typeCondition": {
                                                                "kind": "NamedType",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "ClassicRound"
                                                                }
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "contributions"
                                                                        },
                                                                        "arguments": [
                                                                            {
                                                                                "kind": "Argument",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "where"
                                                                                },
                                                                                "value": {
                                                                                    "kind": "ObjectValue",
                                                                                    "fields": [
                                                                                        {
                                                                                            "kind": "ObjectField",
                                                                                            "name": {
                                                                                                "kind": "Name",
                                                                                                "value": "contributor"
                                                                                            },
                                                                                            "value": {
                                                                                                "kind": "Variable",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "address"
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            }
                                                                        ],
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "amount"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "rewardAmount"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$5867f9f74196cc6c = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TopUsersByCoherenceScore"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderBy"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "User_orderBy"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "users"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderBy"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "coherenceScore"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalCoherent"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalResolvedDisputes"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$5b3636afbb1882d3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "User"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "address"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "address"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputes"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "lastPeriodChange"
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UserDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UserDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "User"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalResolvedDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalAppealingDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalCoherent"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coherenceScore"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokens"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shifts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pnkAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ethAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$e1a68caa7c18f09f = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "UserDisputeFilter"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "address"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Dispute_filter"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "address"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputes"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "orderBy"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "lastPeriodChange"
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "where"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "where"
                                                }
                                            }
                                        }
                                    ],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "UserDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "UserDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "User"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalResolvedDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalAppealingDisputes"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "totalCoherent"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coherenceScore"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tokens"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "court"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shifts"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pnkAmount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ethAmount"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $29ccfa76e4432aad$export$8ed9ce7dde6e16b0 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "VotingHistory"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "disputeID"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dispute"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeID"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "createdAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "rounds"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "nbVotes"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "court"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "timeline"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "drawnJurors"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "juror"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "vote"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "typeCondition": {
                                                                            "kind": "NamedType",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "ClassicVote"
                                                                            }
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "justification"
                                                                                    },
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "choice"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "reference"
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "disputeKitDispute"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "localRounds"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "typeCondition": {
                                                                "kind": "NamedType",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "ClassicRound"
                                                                }
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "winningChoice"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "totalVoted"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */ const $172f779258b16045$var$documents = {
    "\n  query AllCases {\n    counter(id: 0) {\n      cases\n      casesRuled\n    }\n  }\n": $29ccfa76e4432aad$export$61a7f2ed87625e6c,
    "\n  fragment DisputeDetails on Dispute {\n    id\n    arbitrated {\n      id\n    }\n    currentRoundIndex\n    court {\n      id\n      policy\n      feeForJuror\n      timesPerPeriod\n    }\n    period\n    lastPeriodChange\n  }\n": $29ccfa76e4432aad$export$75b51748b47f28f5,
    "\n  query CasesPageWhere($skip: Int, $where: Dispute_filter, $orderDirection: OrderDirection, $first: Int) {\n    disputes(first: $first, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection, where: $where) {\n      ...DisputeDetails\n    }\n  }\n": $29ccfa76e4432aad$export$e3b4a86dd2dcb796,
    "\n  query CasesPage($skip: Int, $orderDirection: OrderDirection, $first: Int) {\n    disputes(first: $first, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection) {\n      ...DisputeDetails\n    }\n  }\n": $29ccfa76e4432aad$export$ee1a540c66d4fa55,
    "\n  query MyCases($id: ID!, $skip: Int, $orderDirection: OrderDirection) {\n    user(id: $id) {\n      disputes(first: 3, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection) {\n        ...DisputeDetails\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$6306573f66fa2dc9,
    "\n  query myCasesPageWhere($id: ID!, $skip: Int, $where: Dispute_filter, $orderDirection: OrderDirection) {\n    user(id: $id) {\n      disputes(first: 3, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection, where: $where) {\n        ...DisputeDetails\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$30b6e8045c42a87b,
    "\n  query ClassicAppeal($disputeID: ID!, $orderBy: DisputeKitDispute_orderBy, $orderDirection: OrderDirection) {\n    dispute(id: $disputeID) {\n      period\n      court {\n        id\n        timesPerPeriod\n      }\n      arbitrated {\n        id\n      }\n      lastPeriodChange\n      disputeKitDispute(orderBy: $orderBy, orderDirection: $orderDirection) {\n        id\n        currentLocalRoundIndex\n        localRounds {\n          ... on ClassicRound {\n            winningChoice\n            paidFees\n            fundedChoices\n          }\n        }\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$f20c7225f33560b0,
    '\n  query Counter {\n    counter(id: "0") {\n      id\n      cases\n      casesRuled\n      casesVoting\n      casesAppealing\n      stakedPNK\n      redistributedPNK\n      paidETH\n      activeJurors\n    }\n  }\n': $29ccfa76e4432aad$export$50f212ba6deff8f1,
    "\n  query CourtDetails($id: ID!) {\n    court(id: $id) {\n      policy\n      minStake\n      alpha\n      numberDisputes\n      numberClosedDisputes\n      numberAppealingDisputes\n      numberStakedJurors\n      stake\n      paidETH\n      paidPNK\n      timesPerPeriod\n    }\n  }\n": $29ccfa76e4432aad$export$f9dd1d91f0b74032,
    "\n  query CourtPolicyURI($courtID: ID!) {\n    court(id: $courtID) {\n      policy\n    }\n  }\n": $29ccfa76e4432aad$export$c1e945355c415f1,
    '\n  query CourtTree {\n    court(id: "1") {\n      name\n      id\n      children(orderBy: name) {\n        name\n        id\n        children {\n          name\n          id\n          children {\n            name\n            id\n            children {\n              name\n              id\n              children {\n                name\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': $29ccfa76e4432aad$export$4e217371325410b1,
    "\n  query DisputeDetails($disputeID: ID!) {\n    dispute(id: $disputeID) {\n      court {\n        id\n        timesPerPeriod\n        hiddenVotes\n        feeForJuror\n      }\n      arbitrated {\n        id\n      }\n      period\n      ruled\n      lastPeriodChange\n      currentRuling\n      overridden\n      tied\n      currentRound {\n        id\n      }\n      currentRoundIndex\n    }\n  }\n": $29ccfa76e4432aad$export$2f1a1a679504b6b6,
    "\n  query DisputeTemplate($id: ID!) {\n    disputeTemplate(id: $id) {\n      id\n      templateTag\n      templateData\n      templateDataMappings\n    }\n  }\n": $29ccfa76e4432aad$export$de0c57b607e9a74e,
    "\n  query Draw($address: String, $disputeID: String, $roundID: String) {\n    draws(first: 1000, where: { dispute: $disputeID, juror: $address, round: $roundID }) {\n      voteIDNum\n      vote {\n        ... on ClassicVote {\n          commit\n          commited\n        }\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$391defa5fc8e169c,
    "\n  query Evidences($evidenceGroupID: String) {\n    evidences(where: { evidenceGroup: $evidenceGroupID }, orderBy: id, orderDirection: asc) {\n      id\n      evidence\n      sender {\n        id\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$19cdb1500b30a807,
    "\n  query HomePage($timeframe: ID) {\n    disputes(first: 3) {\n      id\n    }\n    counters(where: { id_gt: $timeframe }) {\n      id\n      stakedPNK\n      paidETH\n      redistributedPNK\n      activeJurors\n      cases\n    }\n  }\n": $29ccfa76e4432aad$export$bdf89eeed9df817d,
    "\n  query JurorStakeDetails($userId: String) {\n    jurorTokensPerCourts(where: { juror: $userId }) {\n      court {\n        id\n        name\n      }\n      staked\n      locked\n    }\n  }\n": $29ccfa76e4432aad$export$43b132a328acab0,
    "\n  query LabelInfo($address: String, $disputeID: ID!) {\n    dispute(id: $disputeID) {\n      period\n\n      shifts(where: { juror: $address }) {\n        ethAmount\n        pnkAmount\n      }\n      rounds {\n        drawnJurors(where: { juror: $address }, first: 1) {\n          vote {\n            ... on ClassicVote {\n              choice\n            }\n          }\n        }\n      }\n      disputeKitDispute {\n        localRounds {\n          ... on ClassicRound {\n            contributions(where: { contributor: $address }) {\n              amount\n              rewardAmount\n            }\n          }\n        }\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$1aad28a71dc897ce,
    "\n  query TopUsersByCoherenceScore($first: Int!, $orderBy: User_orderBy, $orderDirection: OrderDirection) {\n    users(first: $first, orderBy: $orderBy, orderDirection: $orderDirection) {\n      id\n      coherenceScore\n      totalCoherent\n      totalResolvedDisputes\n    }\n  }\n": $29ccfa76e4432aad$export$5867f9f74196cc6c,
    "\n  fragment UserDetails on User {\n    totalDisputes\n    totalResolvedDisputes\n    totalAppealingDisputes\n    totalCoherent\n    coherenceScore\n    tokens {\n      court {\n        id\n        name\n      }\n    }\n    shifts {\n      pnkAmount\n      ethAmount\n    }\n  }\n": $29ccfa76e4432aad$export$b2dbb4d61e0c0725,
    "\n  query User($address: ID!) {\n    user(id: $address) {\n      disputes(orderBy: lastPeriodChange) {\n        id\n      }\n      ...UserDetails\n    }\n  }\n": $29ccfa76e4432aad$export$5b3636afbb1882d3,
    "\n  query UserDisputeFilter($address: ID!, $where: Dispute_filter) {\n    user(id: $address) {\n      disputes(orderBy: lastPeriodChange, where: $where) {\n        id\n      }\n      ...UserDetails\n    }\n  }\n": $29ccfa76e4432aad$export$e1a68caa7c18f09f,
    "\n  query VotingHistory($disputeID: ID!) {\n    dispute(id: $disputeID) {\n      id\n      createdAt\n      rounds {\n        nbVotes\n        court {\n          id\n          name\n        }\n        timeline\n        drawnJurors {\n          juror {\n            id\n          }\n          vote {\n            ... on ClassicVote {\n              justification {\n                choice\n                reference\n              }\n            }\n          }\n        }\n      }\n      disputeKitDispute {\n        localRounds {\n          ... on ClassicRound {\n            winningChoice\n            totalVoted\n          }\n        }\n      }\n    }\n  }\n": $29ccfa76e4432aad$export$8ed9ce7dde6e16b0
};
function $172f779258b16045$export$1eb4e7c0ed67b035(source) {
    return $172f779258b16045$var$documents[source] ?? {};
}




const $73ef236f67d137a4$var$disputeDetailsQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query DisputeDetails($disputeID: ID!) {
    dispute(id: $disputeID) {
      court {
        id
        timesPerPeriod
        hiddenVotes
        feeForJuror
      }
      arbitrated {
        id
      }
      period
      ruled
      lastPeriodChange
      currentRuling
      overridden
      tied
      currentRound {
        id
      }
      currentRoundIndex
    }
  }
`);
const $73ef236f67d137a4$export$6b05b6ec027513e2 = (id)=>{
    const isEnabled = id !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `disputeDetailsQuery${id}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $73ef236f67d137a4$var$disputeDetailsQuery,
                variables: {
                    disputeID: id?.toString()
                }
            })
    });
};





const $c2948331a6ec3f41$var$drawQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query Draw($address: String, $disputeID: String, $roundID: String) {
    draws(first: 1000, where: { dispute: $disputeID, juror: $address, round: $roundID }) {
      voteIDNum
      vote {
        ... on ClassicVote {
          commit
          commited
        }
      }
    }
  }
`);
const $c2948331a6ec3f41$export$14dcb2ec2dc2058f = (address, disputeID, roundID)=>{
    const isEnabled = !!(address && disputeID && roundID);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `drawQuery${[
                address,
                disputeID,
                roundID
            ]}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $c2948331a6ec3f41$var$drawQuery,
                variables: {
                    address: address,
                    disputeID: disputeID,
                    roundID: roundID
                }
            })
    });
};


const $bb547b3a0533538e$var$VotingContext = /*#__PURE__*/ (0, $dup7A.createContext)({
    wasDrawn: false,
    hasVoted: false,
    isLoading: false,
    isHiddenVotes: false,
    isCommitPeriod: false,
    isVotingPeriod: false
});
const $bb547b3a0533538e$export$25b3cbfdadc7108e = ({ children: children })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { data: drawData, isLoading: isLoading } = (0, $c2948331a6ec3f41$export$14dcb2ec2dc2058f)(address?.toLowerCase(), id, disputeData?.dispute?.currentRound.id);
    const roundId = disputeData?.dispute?.currentRoundIndex;
    const voteId = drawData?.draws?.[0]?.voteIDNum;
    const { data: hasVoted } = (0, $f9a008fec395d7ff$export$b74721cc744bc7e0)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(roundId) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(voteId),
        args: [
            BigInt(id ?? 0),
            roundId,
            voteId
        ],
        watch: true
    });
    const wasDrawn = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(drawData) && drawData.draws.length > 0, [
        drawData
    ]);
    const isHiddenVotes = (0, $dup7A.useMemo)(()=>disputeData?.dispute?.court.hiddenVotes, [
        disputeData
    ]);
    const isCommitPeriod = (0, $dup7A.useMemo)(()=>disputeData?.dispute?.period === "commit", [
        disputeData
    ]);
    const isVotingPeriod = (0, $dup7A.useMemo)(()=>disputeData?.dispute?.period === "vote", [
        disputeData
    ]);
    const commited = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(drawData) && drawData?.draws?.[0]?.vote?.commited, [
        drawData
    ]);
    const commit = (0, $dup7A.useMemo)(()=>drawData?.draws?.[0]?.vote?.commit, [
        drawData
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($bb547b3a0533538e$var$VotingContext.Provider, {
        value: (0, $dup7A.useMemo)(()=>({
                wasDrawn: wasDrawn,
                hasVoted: hasVoted,
                isLoading: isLoading,
                isHiddenVotes: isHiddenVotes,
                isCommitPeriod: isCommitPeriod,
                isVotingPeriod: isVotingPeriod,
                commited: commited,
                commit: commit
            }), [
            wasDrawn,
            hasVoted,
            isLoading,
            isHiddenVotes,
            isCommitPeriod,
            isVotingPeriod,
            commit,
            commited
        ]),
        children: children
    });
};
const $bb547b3a0533538e$export$332cfb3c10dd1fd7 = ()=>(0, $dup7A.useContext)($bb547b3a0533538e$var$VotingContext);





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $klW82 = parcelRequire("klW82");
var $cYDOa = parcelRequire("cYDOa");

const $5dffde4cf84e5bf4$export$83d89fbfd8236492 = "0.9.8";


class $ec67bb65b81fa90b$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $ec67bb65b81fa90b$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $ec67bb65b81fa90b$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $5dffde4cf84e5bf4$export$83d89fbfd8236492)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}


class $24c419cd8c535ea1$export$a4e0854b60f599b6 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human.html#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $24c419cd8c535ea1$export$9e77a92da3bcd5ca extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $24c419cd8c535ea1$export$5a36348a2ac471a3 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}



var $7E0Rr = parcelRequire("7E0Rr");
const $a0fc1ac174d3ebdd$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $a0fc1ac174d3ebdd$export$33be303020ecaff5(signature) {
    return $a0fc1ac174d3ebdd$var$errorSignatureRegex.test(signature);
}
function $a0fc1ac174d3ebdd$export$a8b67e842e5c116d(signature) {
    return (0, $7E0Rr.execTyped)($a0fc1ac174d3ebdd$var$errorSignatureRegex, signature);
}
const $a0fc1ac174d3ebdd$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $a0fc1ac174d3ebdd$export$7912f33b3b4526ca(signature) {
    return $a0fc1ac174d3ebdd$var$eventSignatureRegex.test(signature);
}
function $a0fc1ac174d3ebdd$export$87d5ec49338ff6f(signature) {
    return (0, $7E0Rr.execTyped)($a0fc1ac174d3ebdd$var$eventSignatureRegex, signature);
}
const $a0fc1ac174d3ebdd$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $a0fc1ac174d3ebdd$export$fa8ae1a8bca33200(signature) {
    return $a0fc1ac174d3ebdd$var$functionSignatureRegex.test(signature);
}
function $a0fc1ac174d3ebdd$export$8a14253893829398(signature) {
    return (0, $7E0Rr.execTyped)($a0fc1ac174d3ebdd$var$functionSignatureRegex, signature);
}
const $a0fc1ac174d3ebdd$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $a0fc1ac174d3ebdd$export$130f77ea18c25fb8(signature) {
    return $a0fc1ac174d3ebdd$var$structSignatureRegex.test(signature);
}
function $a0fc1ac174d3ebdd$export$432f3b6c467d7b70(signature) {
    return (0, $7E0Rr.execTyped)($a0fc1ac174d3ebdd$var$structSignatureRegex, signature);
}
const $a0fc1ac174d3ebdd$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $a0fc1ac174d3ebdd$export$7ec9623fe58e8638(signature) {
    return $a0fc1ac174d3ebdd$var$constructorSignatureRegex.test(signature);
}
function $a0fc1ac174d3ebdd$export$4713f9c79c855460(signature) {
    return (0, $7E0Rr.execTyped)($a0fc1ac174d3ebdd$var$constructorSignatureRegex, signature);
}
const $a0fc1ac174d3ebdd$var$fallbackSignatureRegex = /^fallback\(\)$/;
function $a0fc1ac174d3ebdd$export$f99ebae7027f9f2f(signature) {
    return $a0fc1ac174d3ebdd$var$fallbackSignatureRegex.test(signature);
}
const $a0fc1ac174d3ebdd$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $a0fc1ac174d3ebdd$export$555d9bfe0f07ab3d(signature) {
    return $a0fc1ac174d3ebdd$var$receiveSignatureRegex.test(signature);
}
const $a0fc1ac174d3ebdd$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $a0fc1ac174d3ebdd$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $a0fc1ac174d3ebdd$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);



var $7E0Rr = parcelRequire("7E0Rr");


class $0ff10ef6f655fb2a$export$bdcd4054531f5b35 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human.html#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $0ff10ef6f655fb2a$export$f35df31806e96ff extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human.html#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $0ff10ef6f655fb2a$export$e569b97a5d46005c extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $0ff10ef6f655fb2a$export$58697cc8f790f211 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $0ff10ef6f655fb2a$export$f837e6b0dee0e468 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $0ff10ef6f655fb2a$export$7afd0f25b8fdbbd8 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $0ff10ef6f655fb2a$export$b5451545b6c52dc8 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}



class $cdd51d4ed0bca6eb$export$ccc2f68ef106615a extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $cdd51d4ed0bca6eb$export$3727c00c40963d37 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $cdd51d4ed0bca6eb$export$769955518e5ea753 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}



class $52eb9b7311974131$export$3b7cb2315fb6b103 extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}




var $7E0Rr = parcelRequire("7E0Rr");




class $298fc7bbc6e541b7$export$a13d6673dbe1ad6e extends (0, $ec67bb65b81fa90b$export$a490eb03cb7a0a5e) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}


function $80d141297b5b757a$export$516f1eedf0355404(param, type) {
    if (type) return `${type}:${param}`;
    return param;
}
const $80d141297b5b757a$export$da1654d628010643 = new Map([
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);



function $05865b6588c71d5d$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $a0fc1ac174d3ebdd$export$fa8ae1a8bca33200)(signature)) {
        const match = (0, $a0fc1ac174d3ebdd$export$8a14253893829398)(signature);
        if (!match) throw new (0, $cdd51d4ed0bca6eb$export$ccc2f68ef106615a)({
            signature: signature,
            type: "function"
        });
        const inputParams = $05865b6588c71d5d$export$8350908b11ff5aef(match.parameters);
        const inputs = [];
        const inputLength = inputParams.length;
        for(let i = 0; i < inputLength; i++)inputs.push($05865b6588c71d5d$export$357229f9e2d85552(inputParams[i], {
            modifiers: (0, $a0fc1ac174d3ebdd$export$d304f1652f422b6b),
            structs: structs,
            type: "function"
        }));
        const outputs = [];
        if (match.returns) {
            const outputParams = $05865b6588c71d5d$export$8350908b11ff5aef(match.returns);
            const outputLength = outputParams.length;
            for(let i = 0; i < outputLength; i++)outputs.push($05865b6588c71d5d$export$357229f9e2d85552(outputParams[i], {
                modifiers: (0, $a0fc1ac174d3ebdd$export$d304f1652f422b6b),
                structs: structs,
                type: "function"
            }));
        }
        return {
            name: match.name,
            type: "function",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: inputs,
            outputs: outputs
        };
    }
    if ((0, $a0fc1ac174d3ebdd$export$7912f33b3b4526ca)(signature)) {
        const match = (0, $a0fc1ac174d3ebdd$export$87d5ec49338ff6f)(signature);
        if (!match) throw new (0, $cdd51d4ed0bca6eb$export$ccc2f68ef106615a)({
            signature: signature,
            type: "event"
        });
        const params = $05865b6588c71d5d$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($05865b6588c71d5d$export$357229f9e2d85552(params[i], {
            modifiers: (0, $a0fc1ac174d3ebdd$export$e4045f69b6b17e16),
            structs: structs,
            type: "event"
        }));
        return {
            name: match.name,
            type: "event",
            inputs: abiParameters
        };
    }
    if ((0, $a0fc1ac174d3ebdd$export$33be303020ecaff5)(signature)) {
        const match = (0, $a0fc1ac174d3ebdd$export$a8b67e842e5c116d)(signature);
        if (!match) throw new (0, $cdd51d4ed0bca6eb$export$ccc2f68ef106615a)({
            signature: signature,
            type: "error"
        });
        const params = $05865b6588c71d5d$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($05865b6588c71d5d$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "error"
        }));
        return {
            name: match.name,
            type: "error",
            inputs: abiParameters
        };
    }
    if ((0, $a0fc1ac174d3ebdd$export$7ec9623fe58e8638)(signature)) {
        const match = (0, $a0fc1ac174d3ebdd$export$4713f9c79c855460)(signature);
        if (!match) throw new (0, $cdd51d4ed0bca6eb$export$ccc2f68ef106615a)({
            signature: signature,
            type: "constructor"
        });
        const params = $05865b6588c71d5d$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($05865b6588c71d5d$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "constructor"
        }));
        return {
            type: "constructor",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: abiParameters
        };
    }
    if ((0, $a0fc1ac174d3ebdd$export$f99ebae7027f9f2f)(signature)) return {
        type: "fallback"
    };
    if ((0, $a0fc1ac174d3ebdd$export$555d9bfe0f07ab3d)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $cdd51d4ed0bca6eb$export$3727c00c40963d37)({
        signature: signature
    });
}
const $05865b6588c71d5d$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $05865b6588c71d5d$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $05865b6588c71d5d$var$dynamicIntegerRegex = /^u?int$/;
function $05865b6588c71d5d$export$357229f9e2d85552(param, options) {
    const parameterCacheKey = (0, $80d141297b5b757a$export$516f1eedf0355404)(param, options?.type);
    if ((0, $80d141297b5b757a$export$da1654d628010643).has(parameterCacheKey)) return (0, $80d141297b5b757a$export$da1654d628010643).get(parameterCacheKey);
    const isTuple = (0, $7E0Rr.isTupleRegex).test(param);
    const match = (0, $7E0Rr.execTyped)(isTuple ? $05865b6588c71d5d$var$abiParameterWithTupleRegex : $05865b6588c71d5d$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $0ff10ef6f655fb2a$export$e569b97a5d46005c)({
        param: param
    });
    if (match.name && $05865b6588c71d5d$export$d83e1b8970d84409(match.name)) throw new (0, $0ff10ef6f655fb2a$export$58697cc8f790f211)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $05865b6588c71d5d$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)components_.push($05865b6588c71d5d$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($05865b6588c71d5d$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$05865b6588c71d5d$export$640ecc6f40db6417(type)) throw new (0, $24c419cd8c535ea1$export$5a36348a2ac471a3)({
            type: type
        });
    }
    if (match.modifier) {
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $0ff10ef6f655fb2a$export$f837e6b0dee0e468)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        if ((0, $a0fc1ac174d3ebdd$export$d304f1652f422b6b).has(match.modifier) && !$05865b6588c71d5d$export$7265528696368a9(type, !!match.array)) throw new (0, $0ff10ef6f655fb2a$export$7afd0f25b8fdbbd8)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $80d141297b5b757a$export$da1654d628010643).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $05865b6588c71d5d$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    if (params === "") {
        if (current === "") return result;
        if (depth !== 0) throw new (0, $298fc7bbc6e541b7$export$a13d6673dbe1ad6e)({
            current: current,
            depth: depth
        });
        result.push(current.trim());
        return result;
    }
    const length = params.length;
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $05865b6588c71d5d$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $05865b6588c71d5d$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $05865b6588c71d5d$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $05865b6588c71d5d$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $05865b6588c71d5d$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    return [];
}
function $05865b6588c71d5d$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $7E0Rr.bytesRegex).test(type) || (0, $7E0Rr.integerRegex).test(type);
}
const $05865b6588c71d5d$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $05865b6588c71d5d$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $7E0Rr.bytesRegex).test(name) || (0, $7E0Rr.integerRegex).test(name) || $05865b6588c71d5d$var$protectedKeywordsRegex.test(name);
}
function $05865b6588c71d5d$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}


function $4bb6460923149a59$export$6e5e6f927c48b857(signatures) {
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $a0fc1ac174d3ebdd$export$130f77ea18c25fb8)(signature)) continue;
        const match = (0, $a0fc1ac174d3ebdd$export$432f3b6c467d7b70)(signature);
        if (!match) throw new (0, $cdd51d4ed0bca6eb$export$ccc2f68ef106615a)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $05865b6588c71d5d$export$357229f9e2d85552)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $cdd51d4ed0bca6eb$export$769955518e5ea753)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $4bb6460923149a59$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $4bb6460923149a59$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $4bb6460923149a59$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $7E0Rr.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $7E0Rr.execTyped)($4bb6460923149a59$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $0ff10ef6f655fb2a$export$b5451545b6c52dc8)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $52eb9b7311974131$export$3b7cb2315fb6b103)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $4bb6460923149a59$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $05865b6588c71d5d$export$640ecc6f40db6417)(type)) components.push(abiParameter);
                else throw new (0, $24c419cd8c535ea1$export$9e77a92da3bcd5ca)({
                    type: type
                });
            }
        }
    }
    return components;
}



function $5cf9da70a625977f$export$1e31c38713b34060(signature) {
    let abiItem;
    if (typeof signature === "string") abiItem = (0, $05865b6588c71d5d$export$dc1dc22ccf24efef)(signature);
    else {
        const structs = (0, $4bb6460923149a59$export$6e5e6f927c48b857)(signature);
        const length = signature.length;
        for(let i = 0; i < length; i++){
            const signature_ = signature[i];
            if ((0, $a0fc1ac174d3ebdd$export$130f77ea18c25fb8)(signature_)) continue;
            abiItem = (0, $05865b6588c71d5d$export$dc1dc22ccf24efef)(signature_, structs);
            break;
        }
    }
    if (!abiItem) throw new (0, $24c419cd8c535ea1$export$a4e0854b60f599b6)({
        signature: signature
    });
    return abiItem;
}


// Can this be replaced by Mustache ?
const $871146b375cd045a$export$ed8cdbe5f817cd2 = (sourceData, seek, populate)=>{
    const result = {};
    seek.forEach((key, idx)=>{
        let foundValue = sourceData;
        if (key.includes(".")) {
            const keyParts = key.split(".");
            for (const part of keyParts)if (foundValue[part] !== undefined) foundValue = foundValue[part];
            else {
                foundValue = undefined;
                break;
            }
        } else if (typeof sourceData !== "object" || key === "0") foundValue = sourceData;
        else foundValue = sourceData[key];
        console.log(`Seek key: ${key}, Found value:`, foundValue);
        if (foundValue !== undefined) {
            result[populate[idx]] = foundValue;
            console.log(`Populate key: ${populate[idx]}, Value to add:`, foundValue);
        }
    });
    console.log("Result object:", result);
    return result;
};



var $8H2x6 = parcelRequire("8H2x6");
var $ioTPL = parcelRequire("ioTPL");

var $dfb57e09fccde0eb$exports = {};

var $gbdt3 = parcelRequire("gbdt3");

var $7ts9d = parcelRequire("7ts9d");
var $dfb57e09fccde0eb$require$Buffer = $7ts9d.Buffer;

var $ejAqS = parcelRequire("ejAqS");
var $7fff0281cef3754e$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
function $7fff0281cef3754e$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $7fff0281cef3754e$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $7fff0281cef3754e$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $7fff0281cef3754e$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $gbdt3.cwd();
                path = cwd;
            }
            $7fff0281cef3754e$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $7fff0281cef3754e$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $7fff0281cef3754e$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $7fff0281cef3754e$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $7fff0281cef3754e$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $7fff0281cef3754e$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $7fff0281cef3754e$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $7fff0281cef3754e$var$assertPath(from);
        $7fff0281cef3754e$var$assertPath(to);
        if (from === to) return "";
        from = $7fff0281cef3754e$var$posix.resolve(from);
        to = $7fff0281cef3754e$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $7fff0281cef3754e$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $7fff0281cef3754e$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $7fff0281cef3754e$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $7fff0281cef3754e$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $7fff0281cef3754e$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$7fff0281cef3754e$var$posix.posix = $7fff0281cef3754e$var$posix;
$7fff0281cef3754e$exports = $7fff0281cef3754e$var$posix;


var $7c676dab8a1ad1b3$export$edf525f30916fbb8;
var $7c676dab8a1ad1b3$export$640106f6dc7d2706;
var $7c676dab8a1ad1b3$export$3ea386628068cf62;
var $7c676dab8a1ad1b3$export$749d472264fad440;
var $7c676dab8a1ad1b3$export$8b931a48d9488767;
var $7c676dab8a1ad1b3$export$9123f37609399513;
var $7c676dab8a1ad1b3$export$9b60beb643db4d69;
var $7c676dab8a1ad1b3$export$bf9fb029d174d554;
var $7c676dab8a1ad1b3$export$23d3fad09dc44362;
var $7c676dab8a1ad1b3$export$d2f3c2f7e0c7dcf5;
var $7c676dab8a1ad1b3$export$3bf7c33313eba0fe;
var $7c676dab8a1ad1b3$export$7925d89f138dad5b;
var $7c676dab8a1ad1b3$export$722a64dea1b767dc;
var $7c676dab8a1ad1b3$export$9e6c06a7d47f9af7;
var $7c676dab8a1ad1b3$export$6b76988456c0292f;
var $7c676dab8a1ad1b3$export$266d3b9babd1fc45;
var $7c676dab8a1ad1b3$export$c1d46b5ea6262c0b;
$7c676dab8a1ad1b3$export$edf525f30916fbb8 = function() {
    return "LE";
};
$7c676dab8a1ad1b3$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$7c676dab8a1ad1b3$export$3ea386628068cf62 = function() {
    return [];
};
$7c676dab8a1ad1b3$export$749d472264fad440 = function() {
    return 0;
};
$7c676dab8a1ad1b3$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$7c676dab8a1ad1b3$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$7c676dab8a1ad1b3$export$9b60beb643db4d69 = function() {
    return [];
};
$7c676dab8a1ad1b3$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$7c676dab8a1ad1b3$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$7c676dab8a1ad1b3$export$d2f3c2f7e0c7dcf5 = $7c676dab8a1ad1b3$export$3bf7c33313eba0fe = function() {
    return {};
};
$7c676dab8a1ad1b3$export$7925d89f138dad5b = function() {
    return "javascript";
};
$7c676dab8a1ad1b3$export$722a64dea1b767dc = function() {
    return "browser";
};
$7c676dab8a1ad1b3$export$9e6c06a7d47f9af7 = $7c676dab8a1ad1b3$export$6b76988456c0292f = function() {
    return "/tmp";
};
$7c676dab8a1ad1b3$export$266d3b9babd1fc45 = "\n";
$7c676dab8a1ad1b3$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $fbc4b77939e59d16$export$5f828d93ff035aa8;
var $fbc4b77939e59d16$export$cd94982b18c6332c;
var $fbc4b77939e59d16$export$1d518568e4f529b0;
var $fbc4b77939e59d16$export$5285b6d41c912b41;
var $fbc4b77939e59d16$export$2fb37efbf6ae0c0e;
var $fbc4b77939e59d16$export$ab85ecd77ce6a5cd;
var $fbc4b77939e59d16$export$da39cf97e1eb7c91;
var $fbc4b77939e59d16$export$52a9039d7177394f;
var $fbc4b77939e59d16$export$f7201db400317331;
var $fbc4b77939e59d16$export$448fa22aedc9dbca;
var $fbc4b77939e59d16$export$b80c7ba289c8fa56;
var $fbc4b77939e59d16$export$26e5786e8ac8e530;
var $fbc4b77939e59d16$export$bdd223f16383713e;
var $fbc4b77939e59d16$export$20533d26f07f1ee0;
var $fbc4b77939e59d16$export$2f64596b8cbf08b4;
var $fbc4b77939e59d16$export$2ce6d8d0e8b04e1a;
var $fbc4b77939e59d16$export$12ada9414fbc594c;
var $fbc4b77939e59d16$export$f5e7e39d57cd9700;
var $fbc4b77939e59d16$export$36b6d6ef312eab39;
var $fbc4b77939e59d16$export$58a258485f1e49f6;
var $fbc4b77939e59d16$export$dedd8dc3dc62b370;
var $fbc4b77939e59d16$export$971862a2fcb1bb40;
var $fbc4b77939e59d16$export$c6ff6a88acbeaf40;
var $fbc4b77939e59d16$export$fdc27893e98845cc;
var $fbc4b77939e59d16$export$6671fb9a1323bed;
var $fbc4b77939e59d16$export$d74daf141a551db;
var $fbc4b77939e59d16$export$45df7cae684751af;
var $fbc4b77939e59d16$export$1db683ad541682f6;
var $fbc4b77939e59d16$export$6f65485f87568e37;
var $fbc4b77939e59d16$export$91a8e56769aeb334;
var $fbc4b77939e59d16$export$2d4117e99c2179e4;
var $fbc4b77939e59d16$export$512823e338ddb1b7;
var $fbc4b77939e59d16$export$9d0e0c0c4a8d30f3;
var $fbc4b77939e59d16$export$b9d55ff329113abd;
var $fbc4b77939e59d16$export$7efb24e2fddf99b9;
var $fbc4b77939e59d16$export$bb1abf2ce84fc7e8;
var $fbc4b77939e59d16$export$2f7171e78e524d5e;
var $fbc4b77939e59d16$export$e1d879b482f37d98;
var $fbc4b77939e59d16$export$1a988e7317c65621;
"use strict";

$fbc4b77939e59d16$export$5f828d93ff035aa8 = $fbc4b77939e59d16$export$cd94982b18c6332c = $fbc4b77939e59d16$export$1d518568e4f529b0 = $fbc4b77939e59d16$export$5285b6d41c912b41 = (parcelRequire("fxidi"));

$fbc4b77939e59d16$export$2fb37efbf6ae0c0e = $fbc4b77939e59d16$export$ab85ecd77ce6a5cd = (parcelRequire("lNfZR"));

$fbc4b77939e59d16$export$da39cf97e1eb7c91 = $fbc4b77939e59d16$export$52a9039d7177394f = (parcelRequire("igtGq"));
var $c1b047f2c7898dbb$exports = {};
"use strict";

$c1b047f2c7898dbb$exports = (parcelRequire("ePMUh"));


var $fbc4b77939e59d16$var$algoKeys = Object.keys($c1b047f2c7898dbb$exports);
var $fbc4b77939e59d16$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($fbc4b77939e59d16$var$algoKeys);
$fbc4b77939e59d16$export$f7201db400317331 = function() {
    return $fbc4b77939e59d16$var$hashes;
};

var $32phK = parcelRequire("32phK");
$fbc4b77939e59d16$export$448fa22aedc9dbca = $32phK.pbkdf2;
$fbc4b77939e59d16$export$b80c7ba289c8fa56 = $32phK.pbkdf2Sync;
var $fc75d9df73a82201$export$bdd223f16383713e;
var $fc75d9df73a82201$export$26e5786e8ac8e530;
var $fc75d9df73a82201$export$2f64596b8cbf08b4;
var $fc75d9df73a82201$export$20533d26f07f1ee0;
var $fc75d9df73a82201$export$12ada9414fbc594c;
var $fc75d9df73a82201$export$2ce6d8d0e8b04e1a;
var $fc75d9df73a82201$export$36b6d6ef312eab39;
var $fc75d9df73a82201$export$f5e7e39d57cd9700;
var $fc75d9df73a82201$export$dedd8dc3dc62b370;
var $fc75d9df73a82201$export$58a258485f1e49f6;
var $edace48d1a7043d3$exports = {};

var $f2cqU = parcelRequire("f2cqU");
var $16a30d9f9e1e261c$export$eab97d15b1788b8d;
var $16a30d9f9e1e261c$export$26e5786e8ac8e530;
var $16a30d9f9e1e261c$export$cc8859615686b300;
var $16a30d9f9e1e261c$export$8ad3f227af08fcc5;
var $16a30d9f9e1e261c$export$947646e34766044f;
"use strict";

$16a30d9f9e1e261c$export$eab97d15b1788b8d = (parcelRequire("6SEVy"));

$16a30d9f9e1e261c$export$26e5786e8ac8e530 = (parcelRequire("1tVy1"));

$16a30d9f9e1e261c$export$cc8859615686b300 = (parcelRequire("1Ee2k"));

$16a30d9f9e1e261c$export$8ad3f227af08fcc5 = (parcelRequire("6s3Uk"));

$16a30d9f9e1e261c$export$947646e34766044f = (parcelRequire("lKBFy"));



var $lfl9G = parcelRequire("lfl9G");

var $ZavwZ = parcelRequire("ZavwZ");
var $edace48d1a7043d3$require$Buffer = $ZavwZ.Buffer;
var $edace48d1a7043d3$var$modes = {
    "des-ede3-cbc": $16a30d9f9e1e261c$export$8ad3f227af08fcc5.instantiate($16a30d9f9e1e261c$export$947646e34766044f),
    "des-ede3": $16a30d9f9e1e261c$export$947646e34766044f,
    "des-ede-cbc": $16a30d9f9e1e261c$export$8ad3f227af08fcc5.instantiate($16a30d9f9e1e261c$export$947646e34766044f),
    "des-ede": $16a30d9f9e1e261c$export$947646e34766044f,
    "des-cbc": $16a30d9f9e1e261c$export$8ad3f227af08fcc5.instantiate($16a30d9f9e1e261c$export$cc8859615686b300),
    "des-ecb": $16a30d9f9e1e261c$export$cc8859615686b300
};
$edace48d1a7043d3$var$modes.des = $edace48d1a7043d3$var$modes["des-cbc"];
$edace48d1a7043d3$var$modes.des3 = $edace48d1a7043d3$var$modes["des-ede3-cbc"];
$edace48d1a7043d3$exports = $edace48d1a7043d3$var$DES;
$lfl9G($edace48d1a7043d3$var$DES, $f2cqU);
function $edace48d1a7043d3$var$DES(opts) {
    $f2cqU.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $edace48d1a7043d3$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$edace48d1a7043d3$require$Buffer.isBuffer(key)) key = $edace48d1a7043d3$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $edace48d1a7043d3$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$edace48d1a7043d3$require$Buffer.isBuffer(iv)) iv = $edace48d1a7043d3$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$edace48d1a7043d3$var$DES.prototype._update = function(data) {
    return $edace48d1a7043d3$require$Buffer.from(this._des.update(data));
};
$edace48d1a7043d3$var$DES.prototype._final = function() {
    return $edace48d1a7043d3$require$Buffer.from(this._des.final());
};



var $lOfc7 = parcelRequire("lOfc7");

var $gkdoN = parcelRequire("gkdoN");
var $e43b1ca07b938e39$exports = {};

$parcel$export($e43b1ca07b938e39$exports, "des-ecb", () => $e43b1ca07b938e39$export$116f8a5cee447347, (v) => $e43b1ca07b938e39$export$116f8a5cee447347 = v);
$parcel$export($e43b1ca07b938e39$exports, "des-cbc", () => $e43b1ca07b938e39$export$7483c4066bfb7ae9, (v) => $e43b1ca07b938e39$export$7483c4066bfb7ae9 = v);
$parcel$export($e43b1ca07b938e39$exports, "des", () => $e43b1ca07b938e39$export$e7a565d2e588bb06, (v) => $e43b1ca07b938e39$export$e7a565d2e588bb06 = v);
$parcel$export($e43b1ca07b938e39$exports, "des-ede3-cbc", () => $e43b1ca07b938e39$export$aaa2f54a426f3eb8, (v) => $e43b1ca07b938e39$export$aaa2f54a426f3eb8 = v);
$parcel$export($e43b1ca07b938e39$exports, "des3", () => $e43b1ca07b938e39$export$eba20568dde4ada, (v) => $e43b1ca07b938e39$export$eba20568dde4ada = v);
$parcel$export($e43b1ca07b938e39$exports, "des-ede3", () => $e43b1ca07b938e39$export$d3b5e5996938f5ae, (v) => $e43b1ca07b938e39$export$d3b5e5996938f5ae = v);
$parcel$export($e43b1ca07b938e39$exports, "des-ede-cbc", () => $e43b1ca07b938e39$export$57c08356130bc99b, (v) => $e43b1ca07b938e39$export$57c08356130bc99b = v);
$parcel$export($e43b1ca07b938e39$exports, "des-ede", () => $e43b1ca07b938e39$export$c7169791d5c1e65d, (v) => $e43b1ca07b938e39$export$c7169791d5c1e65d = v);
var $e43b1ca07b938e39$export$116f8a5cee447347;
var $e43b1ca07b938e39$export$7483c4066bfb7ae9;
var $e43b1ca07b938e39$export$e7a565d2e588bb06;
var $e43b1ca07b938e39$export$aaa2f54a426f3eb8;
var $e43b1ca07b938e39$export$eba20568dde4ada;
var $e43b1ca07b938e39$export$d3b5e5996938f5ae;
var $e43b1ca07b938e39$export$57c08356130bc99b;
var $e43b1ca07b938e39$export$c7169791d5c1e65d;
$e43b1ca07b938e39$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$e43b1ca07b938e39$export$7483c4066bfb7ae9 = $e43b1ca07b938e39$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$e43b1ca07b938e39$export$aaa2f54a426f3eb8 = $e43b1ca07b938e39$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$e43b1ca07b938e39$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$e43b1ca07b938e39$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$e43b1ca07b938e39$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $jAdOp = parcelRequire("jAdOp");
function $fc75d9df73a82201$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gkdoN[suite]) {
        keyLen = $gkdoN[suite].key;
        ivLen = $gkdoN[suite].iv;
    } else if ($e43b1ca07b938e39$exports[suite]) {
        keyLen = $e43b1ca07b938e39$exports[suite].key * 8;
        ivLen = $e43b1ca07b938e39$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $jAdOp(password, false, keyLen, ivLen);
    return $fc75d9df73a82201$var$createCipheriv(suite, keys.key, keys.iv);
}
function $fc75d9df73a82201$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gkdoN[suite]) {
        keyLen = $gkdoN[suite].key;
        ivLen = $gkdoN[suite].iv;
    } else if ($e43b1ca07b938e39$exports[suite]) {
        keyLen = $e43b1ca07b938e39$exports[suite].key * 8;
        ivLen = $e43b1ca07b938e39$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $jAdOp(password, false, keyLen, ivLen);
    return $fc75d9df73a82201$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $fc75d9df73a82201$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gkdoN[suite]) return $lOfc7.createCipheriv(suite, key, iv);
    if ($e43b1ca07b938e39$exports[suite]) return new $edace48d1a7043d3$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $fc75d9df73a82201$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gkdoN[suite]) return $lOfc7.createDecipheriv(suite, key, iv);
    if ($e43b1ca07b938e39$exports[suite]) return new $edace48d1a7043d3$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $fc75d9df73a82201$var$getCiphers() {
    return Object.keys($e43b1ca07b938e39$exports).concat($lOfc7.getCiphers());
}
$fc75d9df73a82201$export$bdd223f16383713e = $fc75d9df73a82201$export$26e5786e8ac8e530 = $fc75d9df73a82201$var$createCipher;
$fc75d9df73a82201$export$2f64596b8cbf08b4 = $fc75d9df73a82201$export$20533d26f07f1ee0 = $fc75d9df73a82201$var$createCipheriv;
$fc75d9df73a82201$export$12ada9414fbc594c = $fc75d9df73a82201$export$2ce6d8d0e8b04e1a = $fc75d9df73a82201$var$createDecipher;
$fc75d9df73a82201$export$36b6d6ef312eab39 = $fc75d9df73a82201$export$f5e7e39d57cd9700 = $fc75d9df73a82201$var$createDecipheriv;
$fc75d9df73a82201$export$dedd8dc3dc62b370 = $fc75d9df73a82201$export$58a258485f1e49f6 = $fc75d9df73a82201$var$getCiphers;


$fbc4b77939e59d16$export$26e5786e8ac8e530 = $fc75d9df73a82201$export$26e5786e8ac8e530;
$fbc4b77939e59d16$export$bdd223f16383713e = $fc75d9df73a82201$export$bdd223f16383713e;
$fbc4b77939e59d16$export$20533d26f07f1ee0 = $fc75d9df73a82201$export$20533d26f07f1ee0;
$fbc4b77939e59d16$export$2f64596b8cbf08b4 = $fc75d9df73a82201$export$2f64596b8cbf08b4;
$fbc4b77939e59d16$export$2ce6d8d0e8b04e1a = $fc75d9df73a82201$export$2ce6d8d0e8b04e1a;
$fbc4b77939e59d16$export$12ada9414fbc594c = $fc75d9df73a82201$export$12ada9414fbc594c;
$fbc4b77939e59d16$export$f5e7e39d57cd9700 = $fc75d9df73a82201$export$f5e7e39d57cd9700;
$fbc4b77939e59d16$export$36b6d6ef312eab39 = $fc75d9df73a82201$export$36b6d6ef312eab39;
$fbc4b77939e59d16$export$58a258485f1e49f6 = $fc75d9df73a82201$export$58a258485f1e49f6;
$fbc4b77939e59d16$export$dedd8dc3dc62b370 = $fc75d9df73a82201$export$dedd8dc3dc62b370;
var $d184babbe0e76fb8$export$971862a2fcb1bb40;
var $d184babbe0e76fb8$export$c6ff6a88acbeaf40;
var $d184babbe0e76fb8$export$fdc27893e98845cc;
var $d184babbe0e76fb8$export$6671fb9a1323bed;
var $d184babbe0e76fb8$export$d74daf141a551db;

var $7ts9d = parcelRequire("7ts9d");
var $d184babbe0e76fb8$require$Buffer = $7ts9d.Buffer;
var $1c3a7e841a7b91e7$exports = {};

var $fxidi = parcelRequire("fxidi");
$1c3a7e841a7b91e7$exports = $1c3a7e841a7b91e7$var$findPrime;
$1c3a7e841a7b91e7$var$findPrime.simpleSieve = $1c3a7e841a7b91e7$var$simpleSieve;
$1c3a7e841a7b91e7$var$findPrime.fermatTest = $1c3a7e841a7b91e7$var$fermatTest;

var $7rVdb = parcelRequire("7rVdb");
var $1c3a7e841a7b91e7$var$TWENTYFOUR = new $7rVdb(24);
var $b39324bcda1b29b2$exports = {};

var $7rVdb = parcelRequire("7rVdb");

var $4Lrhy = parcelRequire("4Lrhy");
function $b39324bcda1b29b2$var$MillerRabin(rand) {
    this.rand = rand || new $4Lrhy.Rand();
}
$b39324bcda1b29b2$exports = $b39324bcda1b29b2$var$MillerRabin;
$b39324bcda1b29b2$var$MillerRabin.create = function create(rand) {
    return new $b39324bcda1b29b2$var$MillerRabin(rand);
};
$b39324bcda1b29b2$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7rVdb(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$b39324bcda1b29b2$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$b39324bcda1b29b2$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7rVdb.mont(n);
    var rone = new $7rVdb(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7rVdb(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$b39324bcda1b29b2$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7rVdb.mont(n);
    var rone = new $7rVdb(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7rVdb(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $1c3a7e841a7b91e7$var$millerRabin = new $b39324bcda1b29b2$exports();
var $1c3a7e841a7b91e7$var$ONE = new $7rVdb(1);
var $1c3a7e841a7b91e7$var$TWO = new $7rVdb(2);
var $1c3a7e841a7b91e7$var$FIVE = new $7rVdb(5);
var $1c3a7e841a7b91e7$var$SIXTEEN = new $7rVdb(16);
var $1c3a7e841a7b91e7$var$EIGHT = new $7rVdb(8);
var $1c3a7e841a7b91e7$var$TEN = new $7rVdb(10);
var $1c3a7e841a7b91e7$var$THREE = new $7rVdb(3);
var $1c3a7e841a7b91e7$var$SEVEN = new $7rVdb(7);
var $1c3a7e841a7b91e7$var$ELEVEN = new $7rVdb(11);
var $1c3a7e841a7b91e7$var$FOUR = new $7rVdb(4);
var $1c3a7e841a7b91e7$var$TWELVE = new $7rVdb(12);
var $1c3a7e841a7b91e7$var$primes = null;
function $1c3a7e841a7b91e7$var$_getPrimes() {
    if ($1c3a7e841a7b91e7$var$primes !== null) return $1c3a7e841a7b91e7$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $1c3a7e841a7b91e7$var$primes = res;
    return res;
}
function $1c3a7e841a7b91e7$var$simpleSieve(p) {
    var primes = $1c3a7e841a7b91e7$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $1c3a7e841a7b91e7$var$fermatTest(p) {
    var red = $7rVdb.mont(p);
    return $1c3a7e841a7b91e7$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $1c3a7e841a7b91e7$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $7rVdb([
            0x8c,
            0x7b
        ]);
        else return new $7rVdb([
            0x8c,
            0x27
        ]);
    }
    gen = new $7rVdb(gen);
    var num, n2;
    while(true){
        num = new $7rVdb($fxidi(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($1c3a7e841a7b91e7$var$ONE);
        if (!num.testn(1)) num.iadd($1c3a7e841a7b91e7$var$TWO);
        if (!gen.cmp($1c3a7e841a7b91e7$var$TWO)) while(num.mod($1c3a7e841a7b91e7$var$TWENTYFOUR).cmp($1c3a7e841a7b91e7$var$ELEVEN))num.iadd($1c3a7e841a7b91e7$var$FOUR);
        else if (!gen.cmp($1c3a7e841a7b91e7$var$FIVE)) while(num.mod($1c3a7e841a7b91e7$var$TEN).cmp($1c3a7e841a7b91e7$var$THREE))num.iadd($1c3a7e841a7b91e7$var$FOUR);
        n2 = num.shrn(1);
        if ($1c3a7e841a7b91e7$var$simpleSieve(n2) && $1c3a7e841a7b91e7$var$simpleSieve(num) && $1c3a7e841a7b91e7$var$fermatTest(n2) && $1c3a7e841a7b91e7$var$fermatTest(num) && $1c3a7e841a7b91e7$var$millerRabin.test(n2) && $1c3a7e841a7b91e7$var$millerRabin.test(num)) return num;
    }
}


var $61dd517abdd37a39$exports = {};
$61dd517abdd37a39$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $226195dc41c5fc40$exports = {};

var $7ts9d = parcelRequire("7ts9d");
var $226195dc41c5fc40$require$Buffer = $7ts9d.Buffer;

var $7rVdb = parcelRequire("7rVdb");

var $226195dc41c5fc40$var$millerRabin = new $b39324bcda1b29b2$exports();
var $226195dc41c5fc40$var$TWENTYFOUR = new $7rVdb(24);
var $226195dc41c5fc40$var$ELEVEN = new $7rVdb(11);
var $226195dc41c5fc40$var$TEN = new $7rVdb(10);
var $226195dc41c5fc40$var$THREE = new $7rVdb(3);
var $226195dc41c5fc40$var$SEVEN = new $7rVdb(7);


var $fxidi = parcelRequire("fxidi");
$226195dc41c5fc40$exports = $226195dc41c5fc40$var$DH;
function $226195dc41c5fc40$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$226195dc41c5fc40$require$Buffer.isBuffer(pub)) pub = new $226195dc41c5fc40$require$Buffer(pub, enc);
    this._pub = new $7rVdb(pub);
    return this;
}
function $226195dc41c5fc40$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$226195dc41c5fc40$require$Buffer.isBuffer(priv)) priv = new $226195dc41c5fc40$require$Buffer(priv, enc);
    this._priv = new $7rVdb(priv);
    return this;
}
var $226195dc41c5fc40$var$primeCache = {};
function $226195dc41c5fc40$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $226195dc41c5fc40$var$primeCache) return $226195dc41c5fc40$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$1c3a7e841a7b91e7$exports.simpleSieve || !$1c3a7e841a7b91e7$exports.fermatTest(prime) || !$226195dc41c5fc40$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $226195dc41c5fc40$var$primeCache[hex] = error;
        return error;
    }
    if (!$226195dc41c5fc40$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($226195dc41c5fc40$var$TWENTYFOUR).cmp($226195dc41c5fc40$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($226195dc41c5fc40$var$TEN);
            if (rem.cmp($226195dc41c5fc40$var$THREE) && rem.cmp($226195dc41c5fc40$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $226195dc41c5fc40$var$primeCache[hex] = error;
    return error;
}
function $226195dc41c5fc40$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $7rVdb(prime);
    this._prime = $7rVdb.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $226195dc41c5fc40$var$setPublicKey;
        this.setPrivateKey = $226195dc41c5fc40$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($226195dc41c5fc40$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $226195dc41c5fc40$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$226195dc41c5fc40$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $7rVdb($fxidi(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$226195dc41c5fc40$var$DH.prototype.computeSecret = function(other) {
    other = new $7rVdb(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $226195dc41c5fc40$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $226195dc41c5fc40$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $226195dc41c5fc40$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$226195dc41c5fc40$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $226195dc41c5fc40$var$formatReturnValue(this._pub, enc);
};
$226195dc41c5fc40$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $226195dc41c5fc40$var$formatReturnValue(this._priv, enc);
};
$226195dc41c5fc40$var$DH.prototype.getPrime = function(enc) {
    return $226195dc41c5fc40$var$formatReturnValue(this.__prime, enc);
};
$226195dc41c5fc40$var$DH.prototype.getGenerator = function(enc) {
    return $226195dc41c5fc40$var$formatReturnValue(this._gen, enc);
};
$226195dc41c5fc40$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$226195dc41c5fc40$require$Buffer.isBuffer(gen)) gen = new $226195dc41c5fc40$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $7rVdb(gen);
    return this;
};
function $226195dc41c5fc40$var$formatReturnValue(bn, enc) {
    var buf = new $226195dc41c5fc40$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $d184babbe0e76fb8$var$getDiffieHellman(mod) {
    var prime = new $d184babbe0e76fb8$require$Buffer($61dd517abdd37a39$exports[mod].prime, "hex");
    var gen = new $d184babbe0e76fb8$require$Buffer($61dd517abdd37a39$exports[mod].gen, "hex");
    return new $226195dc41c5fc40$exports(prime, gen);
}
var $d184babbe0e76fb8$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $d184babbe0e76fb8$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($d184babbe0e76fb8$require$Buffer.isBuffer(enc) || $d184babbe0e76fb8$var$ENCODINGS[enc] === undefined) return $d184babbe0e76fb8$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $d184babbe0e76fb8$require$Buffer([
        2
    ]);
    if (!$d184babbe0e76fb8$require$Buffer.isBuffer(generator)) generator = new $d184babbe0e76fb8$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $226195dc41c5fc40$exports($1c3a7e841a7b91e7$exports(prime, generator), generator, true);
    if (!$d184babbe0e76fb8$require$Buffer.isBuffer(prime)) prime = new $d184babbe0e76fb8$require$Buffer(prime, enc);
    return new $226195dc41c5fc40$exports(prime, generator, true);
}
$d184babbe0e76fb8$export$971862a2fcb1bb40 = $d184babbe0e76fb8$export$c6ff6a88acbeaf40 = $d184babbe0e76fb8$export$fdc27893e98845cc = $d184babbe0e76fb8$var$getDiffieHellman;
$d184babbe0e76fb8$export$6671fb9a1323bed = $d184babbe0e76fb8$export$d74daf141a551db = $d184babbe0e76fb8$var$createDiffieHellman;


$fbc4b77939e59d16$export$971862a2fcb1bb40 = $d184babbe0e76fb8$export$971862a2fcb1bb40;
$fbc4b77939e59d16$export$c6ff6a88acbeaf40 = $d184babbe0e76fb8$export$c6ff6a88acbeaf40;
$fbc4b77939e59d16$export$fdc27893e98845cc = $d184babbe0e76fb8$export$fdc27893e98845cc;
$fbc4b77939e59d16$export$6671fb9a1323bed = $d184babbe0e76fb8$export$6671fb9a1323bed;
$fbc4b77939e59d16$export$d74daf141a551db = $d184babbe0e76fb8$export$d74daf141a551db;
var $c59d295cd1d077ff$exports = {};
"use strict";

var $ZavwZ = parcelRequire("ZavwZ");
var $c59d295cd1d077ff$require$Buffer = $ZavwZ.Buffer;

var $lNfZR = parcelRequire("lNfZR");

var $2r1bn = parcelRequire("2r1bn");

var $lfl9G = parcelRequire("lfl9G");
var $132bc3180d94f330$exports = {};
"use strict";

var $ZavwZ = parcelRequire("ZavwZ");
var $132bc3180d94f330$require$Buffer = $ZavwZ.Buffer;

var $igtGq = parcelRequire("igtGq");

var $dnOLj = parcelRequire("dnOLj");

var $2jcP0 = parcelRequire("2jcP0");
var $132bc3180d94f330$require$EC = $2jcP0.ec;

var $ePKtE = parcelRequire("ePKtE");

var $70L5t = parcelRequire("70L5t");
var $93be1d67f901e001$exports = {};
$93be1d67f901e001$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $132bc3180d94f330$var$RSA_PKCS1_PADDING = 1;
function $132bc3180d94f330$var$sign(hash, key, hashType, signType, tag) {
    var priv = $70L5t(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $132bc3180d94f330$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $132bc3180d94f330$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $132bc3180d94f330$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $132bc3180d94f330$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $dnOLj(pad, priv);
    return out;
}
function $132bc3180d94f330$var$ecSign(hash, priv) {
    var curveId = $93be1d67f901e001$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $132bc3180d94f330$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $132bc3180d94f330$require$Buffer.from(out.toDER());
}
function $132bc3180d94f330$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $ePKtE(0);
    var k;
    var H = $132bc3180d94f330$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $132bc3180d94f330$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $132bc3180d94f330$var$makeKey(q, kv, algo);
        r = $132bc3180d94f330$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $ePKtE(0);
        }
    }
    return $132bc3180d94f330$var$toDER(r, s);
}
function $132bc3180d94f330$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $132bc3180d94f330$require$Buffer.from(res);
}
function $132bc3180d94f330$var$getKey(x, q, hash, algo) {
    x = $132bc3180d94f330$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $132bc3180d94f330$require$Buffer.alloc(q.byteLength() - x.length);
        x = $132bc3180d94f330$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $132bc3180d94f330$var$bits2octets(hash, q);
    var v = $132bc3180d94f330$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $132bc3180d94f330$require$Buffer.alloc(hlen);
    k = $igtGq(algo, k).update(v).update($132bc3180d94f330$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $igtGq(algo, k).update(v).digest();
    k = $igtGq(algo, k).update(v).update($132bc3180d94f330$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $igtGq(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $132bc3180d94f330$var$bits2int(obits, q) {
    var bits = new $ePKtE(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $132bc3180d94f330$var$bits2octets(bits, q) {
    bits = $132bc3180d94f330$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $132bc3180d94f330$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $132bc3180d94f330$require$Buffer.alloc(q.byteLength() - out.length);
        out = $132bc3180d94f330$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $132bc3180d94f330$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $132bc3180d94f330$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $igtGq(algo, kv.k).update(kv.v).digest();
            t = $132bc3180d94f330$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $132bc3180d94f330$var$bits2int(t, q);
        kv.k = $igtGq(algo, kv.k).update(kv.v).update($132bc3180d94f330$require$Buffer.from([
            0
        ])).digest();
        kv.v = $igtGq(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $132bc3180d94f330$var$makeR(g, k, p, q) {
    return g.toRed($ePKtE.mont(p)).redPow(k).fromRed().mod(q);
}
$132bc3180d94f330$exports = $132bc3180d94f330$var$sign;
$132bc3180d94f330$exports.getKey = $132bc3180d94f330$var$getKey;
$132bc3180d94f330$exports.makeKey = $132bc3180d94f330$var$makeKey;


var $ae9a51d50bcc729d$exports = {};
"use strict";

var $ZavwZ = parcelRequire("ZavwZ");
var $ae9a51d50bcc729d$require$Buffer = $ZavwZ.Buffer;

var $ePKtE = parcelRequire("ePKtE");

var $2jcP0 = parcelRequire("2jcP0");
var $ae9a51d50bcc729d$require$EC = $2jcP0.ec;

var $70L5t = parcelRequire("70L5t");

function $ae9a51d50bcc729d$var$verify(sig, hash, key, signType, tag) {
    var pub = $70L5t(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $ae9a51d50bcc729d$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $ae9a51d50bcc729d$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $ae9a51d50bcc729d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $ae9a51d50bcc729d$require$Buffer.from(pad);
    var red = $ePKtE.mont(pub.modulus);
    sig = new $ePKtE(sig).toRed(red);
    sig = sig.redPow(new $ePKtE(pub.publicExponent));
    sig = $ae9a51d50bcc729d$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $ae9a51d50bcc729d$var$ecVerify(sig, hash, pub) {
    var curveId = $93be1d67f901e001$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $ae9a51d50bcc729d$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $ae9a51d50bcc729d$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $70L5t.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $ae9a51d50bcc729d$var$checkValue(s, q);
    $ae9a51d50bcc729d$var$checkValue(r, q);
    var montp = $ePKtE.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $ePKtE(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $ae9a51d50bcc729d$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$ae9a51d50bcc729d$exports = $ae9a51d50bcc729d$var$verify;



var $ePMUh = parcelRequire("ePMUh");
Object.keys($ePMUh).forEach(function(key) {
    $ePMUh[key].id = $c59d295cd1d077ff$require$Buffer.from($ePMUh[key].id, "hex");
    $ePMUh[key.toLowerCase()] = $ePMUh[key];
});
function $c59d295cd1d077ff$var$Sign(algorithm) {
    $2r1bn.Writable.call(this);
    var data = $ePMUh[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $lNfZR(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lfl9G($c59d295cd1d077ff$var$Sign, $2r1bn.Writable);
$c59d295cd1d077ff$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$c59d295cd1d077ff$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $c59d295cd1d077ff$require$Buffer.from(data, enc) : data);
    return this;
};
$c59d295cd1d077ff$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $132bc3180d94f330$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $c59d295cd1d077ff$var$Verify(algorithm) {
    $2r1bn.Writable.call(this);
    var data = $ePMUh[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $lNfZR(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lfl9G($c59d295cd1d077ff$var$Verify, $2r1bn.Writable);
$c59d295cd1d077ff$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$c59d295cd1d077ff$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $c59d295cd1d077ff$require$Buffer.from(data, enc) : data);
    return this;
};
$c59d295cd1d077ff$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $c59d295cd1d077ff$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $ae9a51d50bcc729d$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $c59d295cd1d077ff$var$createSign(algorithm) {
    return new $c59d295cd1d077ff$var$Sign(algorithm);
}
function $c59d295cd1d077ff$var$createVerify(algorithm) {
    return new $c59d295cd1d077ff$var$Verify(algorithm);
}
$c59d295cd1d077ff$exports = {
    Sign: $c59d295cd1d077ff$var$createSign,
    Verify: $c59d295cd1d077ff$var$createVerify,
    createSign: $c59d295cd1d077ff$var$createSign,
    createVerify: $c59d295cd1d077ff$var$createVerify
};


$fbc4b77939e59d16$export$45df7cae684751af = $c59d295cd1d077ff$exports.createSign;
$fbc4b77939e59d16$export$1db683ad541682f6 = $c59d295cd1d077ff$exports.Sign;
$fbc4b77939e59d16$export$6f65485f87568e37 = $c59d295cd1d077ff$exports.createVerify;
$fbc4b77939e59d16$export$91a8e56769aeb334 = $c59d295cd1d077ff$exports.Verify;

$fbc4b77939e59d16$export$2d4117e99c2179e4 = (parcelRequire("kvGFf"));
var $36ab25309bb518ba$export$512823e338ddb1b7;
var $36ab25309bb518ba$export$7efb24e2fddf99b9;
var $36ab25309bb518ba$export$9d0e0c0c4a8d30f3;
var $36ab25309bb518ba$export$b9d55ff329113abd;

$36ab25309bb518ba$export$512823e338ddb1b7 = (parcelRequire("4Mmcf"));

$36ab25309bb518ba$export$7efb24e2fddf99b9 = (parcelRequire("aDFYT"));
$36ab25309bb518ba$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $36ab25309bb518ba$export$512823e338ddb1b7(key, buf, true);
};
$36ab25309bb518ba$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $36ab25309bb518ba$export$7efb24e2fddf99b9(key, buf, true);
};


$fbc4b77939e59d16$export$512823e338ddb1b7 = $36ab25309bb518ba$export$512823e338ddb1b7;
$fbc4b77939e59d16$export$9d0e0c0c4a8d30f3 = $36ab25309bb518ba$export$9d0e0c0c4a8d30f3;
$fbc4b77939e59d16$export$b9d55ff329113abd = $36ab25309bb518ba$export$b9d55ff329113abd;
$fbc4b77939e59d16$export$7efb24e2fddf99b9 = $36ab25309bb518ba$export$7efb24e2fddf99b9;
var $cb54cf8fd8766117$export$bb1abf2ce84fc7e8;
var $cb54cf8fd8766117$export$2f7171e78e524d5e;

var $gbdt3 = parcelRequire("gbdt3");
"use strict";
function $cb54cf8fd8766117$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $ZavwZ = parcelRequire("ZavwZ");

var $fxidi = parcelRequire("fxidi");
var $cb54cf8fd8766117$var$Buffer = $ZavwZ.Buffer;
var $cb54cf8fd8766117$var$kBufferMaxLength = $ZavwZ.kMaxLength;
var $cb54cf8fd8766117$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $cb54cf8fd8766117$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $cb54cf8fd8766117$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $cb54cf8fd8766117$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $cb54cf8fd8766117$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $cb54cf8fd8766117$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $cb54cf8fd8766117$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $cb54cf8fd8766117$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($cb54cf8fd8766117$var$crypto && $cb54cf8fd8766117$var$crypto.getRandomValues || false) {
    $cb54cf8fd8766117$export$bb1abf2ce84fc7e8 = $cb54cf8fd8766117$var$randomFill;
    $cb54cf8fd8766117$export$2f7171e78e524d5e = $cb54cf8fd8766117$var$randomFillSync;
} else {
    $cb54cf8fd8766117$export$bb1abf2ce84fc7e8 = $cb54cf8fd8766117$var$oldBrowser;
    $cb54cf8fd8766117$export$2f7171e78e524d5e = $cb54cf8fd8766117$var$oldBrowser;
}
function $cb54cf8fd8766117$var$randomFill(buf, offset, size, cb) {
    if (!$cb54cf8fd8766117$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $cb54cf8fd8766117$var$assertOffset(offset, buf.length);
    $cb54cf8fd8766117$var$assertSize(size, offset, buf.length);
    return $cb54cf8fd8766117$var$actualFill(buf, offset, size, cb);
}
function $cb54cf8fd8766117$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $cb54cf8fd8766117$var$crypto.getRandomValues(uint);
    if (cb) {
        $gbdt3.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $fxidi(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $fxidi(size);
    bytes.copy(buf, offset);
    return buf;
}
function $cb54cf8fd8766117$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$cb54cf8fd8766117$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $cb54cf8fd8766117$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $cb54cf8fd8766117$var$assertSize(size, offset, buf.length);
    return $cb54cf8fd8766117$var$actualFill(buf, offset, size);
}


$fbc4b77939e59d16$export$bb1abf2ce84fc7e8 = $cb54cf8fd8766117$export$bb1abf2ce84fc7e8;
$fbc4b77939e59d16$export$2f7171e78e524d5e = $cb54cf8fd8766117$export$2f7171e78e524d5e;
$fbc4b77939e59d16$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$fbc4b77939e59d16$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


var $15b2d611ab9ac74f$exports = {};
$15b2d611ab9ac74f$exports = JSON.parse('{"name":"dotenv","version":"16.4.5","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","test:coverage":"tap --coverage-report=lcov","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://dotenvx.com","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');


const $dfb57e09fccde0eb$var$version = $15b2d611ab9ac74f$exports.version;
const $dfb57e09fccde0eb$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $dfb57e09fccde0eb$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $dfb57e09fccde0eb$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $dfb57e09fccde0eb$var$_parseVault(options) {
    const vaultPath = $dfb57e09fccde0eb$var$_vaultPath(options);
    // Parse .env.vault
    const result = $dfb57e09fccde0eb$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) {
        const err = new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
        err.code = "MISSING_DATA";
        throw err;
    }
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenvx.com/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenvx.com/vault/.env.vault?environment=prod"
    const keys = $dfb57e09fccde0eb$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $dfb57e09fccde0eb$var$_instructions(result, key);
        // Decrypt
        decrypted = $dfb57e09fccde0eb$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $dfb57e09fccde0eb$var$DotenvModule.parse(decrypted);
}
function $dfb57e09fccde0eb$var$_log(message) {
    console.log(`[dotenv@${$dfb57e09fccde0eb$var$version}][INFO] ${message}`);
}
function $dfb57e09fccde0eb$var$_warn(message) {
    console.log(`[dotenv@${$dfb57e09fccde0eb$var$version}][WARN] ${message}`);
}
function $dfb57e09fccde0eb$var$_debug(message) {
    console.log(`[dotenv@${$dfb57e09fccde0eb$var$version}][DEBUG] ${message}`);
}
function $dfb57e09fccde0eb$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $dfb57e09fccde0eb$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") {
            const err = new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenvx.com/vault/.env.vault?environment=development");
            err.code = "INVALID_DOTENV_KEY";
            throw err;
        }
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) {
        const err = new Error("INVALID_DOTENV_KEY: Missing key part");
        err.code = "INVALID_DOTENV_KEY";
        throw err;
    }
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) {
        const err = new Error("INVALID_DOTENV_KEY: Missing environment part");
        err.code = "INVALID_DOTENV_KEY";
        throw err;
    }
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) {
        const err = new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
        err.code = "NOT_FOUND_DOTENV_ENVIRONMENT";
        throw err;
    }
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $dfb57e09fccde0eb$var$_vaultPath(options) {
    let possibleVaultPath = null;
    if (options && options.path && options.path.length > 0) {
        if (Array.isArray(options.path)) {
            for (const filepath of options.path)if ($ejAqS.existsSync(filepath)) possibleVaultPath = filepath.endsWith(".vault") ? filepath : `${filepath}.vault`;
        } else possibleVaultPath = options.path.endsWith(".vault") ? options.path : `${options.path}.vault`;
    } else possibleVaultPath = $7fff0281cef3754e$exports.resolve($gbdt3.cwd(), ".env.vault");
    if ($ejAqS.existsSync(possibleVaultPath)) return possibleVaultPath;
    return null;
}
function $dfb57e09fccde0eb$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $7fff0281cef3754e$exports.join($7c676dab8a1ad1b3$export$c1d46b5ea6262c0b(), envPath.slice(1)) : envPath;
}
function $dfb57e09fccde0eb$var$_configVault(options) {
    $dfb57e09fccde0eb$var$_log("Loading env from encrypted .env.vault");
    const parsed = $dfb57e09fccde0eb$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $dfb57e09fccde0eb$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $dfb57e09fccde0eb$var$configDotenv(options) {
    const dotenvPath = $7fff0281cef3754e$exports.resolve($gbdt3.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options && options.encoding) encoding = options.encoding;
    else if (debug) $dfb57e09fccde0eb$var$_debug("No encoding is specified. UTF-8 is used by default");
    let optionPaths = [
        dotenvPath
    ] // default, look for .env
    ;
    if (options && options.path) {
        if (!Array.isArray(options.path)) optionPaths = [
            $dfb57e09fccde0eb$var$_resolveHome(options.path)
        ];
        else {
            optionPaths = [] // reset default
            ;
            for (const filepath of options.path)optionPaths.push($dfb57e09fccde0eb$var$_resolveHome(filepath));
        }
    }
    // Build the parsed data in a temporary object (because we need to return it).  Once we have the final
    // parsed data, we will combine it with process.env (or options.processEnv if provided).
    let lastError;
    const parsedAll = {};
    for (const path of optionPaths)try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $dfb57e09fccde0eb$var$DotenvModule.parse($ejAqS.readFileSync(path, {
            encoding: encoding
        }));
        $dfb57e09fccde0eb$var$DotenvModule.populate(parsedAll, parsed, options);
    } catch (e) {
        if (debug) $dfb57e09fccde0eb$var$_debug(`Failed to load ${path} ${e.message}`);
        lastError = e;
    }
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $dfb57e09fccde0eb$var$DotenvModule.populate(processEnv, parsedAll, options);
    if (lastError) return {
        parsed: parsedAll,
        error: lastError
    };
    else return {
        parsed: parsedAll
    };
}
// Populates process.env from .env file
function $dfb57e09fccde0eb$var$config(options) {
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($dfb57e09fccde0eb$var$_dotenvKey(options).length === 0) return $dfb57e09fccde0eb$var$DotenvModule.configDotenv(options);
    const vaultPath = $dfb57e09fccde0eb$var$_vaultPath(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!vaultPath) {
        $dfb57e09fccde0eb$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $dfb57e09fccde0eb$var$DotenvModule.configDotenv(options);
    }
    return $dfb57e09fccde0eb$var$DotenvModule._configVault(options);
}
function $dfb57e09fccde0eb$var$decrypt(encrypted, keyStr) {
    const key = $dfb57e09fccde0eb$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $dfb57e09fccde0eb$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.subarray(0, 12);
    const authTag = ciphertext.subarray(-16);
    ciphertext = ciphertext.subarray(12, -16);
    try {
        const aesgcm = $fbc4b77939e59d16$export$36b6d6ef312eab39("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const err = new Error("INVALID_DOTENV_KEY: It must be 64 characters long (or more)");
            err.code = "INVALID_DOTENV_KEY";
            throw err;
        } else if (decryptionFailed) {
            const err = new Error("DECRYPTION_FAILED: Please check your DOTENV_KEY");
            err.code = "DECRYPTION_FAILED";
            throw err;
        } else throw error;
    }
}
// Populate process.env with parsed values
function $dfb57e09fccde0eb$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") {
        const err = new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
        err.code = "OBJECT_REQUIRED";
        throw err;
    }
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $dfb57e09fccde0eb$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $dfb57e09fccde0eb$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $dfb57e09fccde0eb$var$DotenvModule = {
    configDotenv: $dfb57e09fccde0eb$var$configDotenv,
    _configVault: $dfb57e09fccde0eb$var$_configVault,
    _parseVault: $dfb57e09fccde0eb$var$_parseVault,
    config: $dfb57e09fccde0eb$var$config,
    decrypt: $dfb57e09fccde0eb$var$decrypt,
    parse: $dfb57e09fccde0eb$var$parse,
    populate: $dfb57e09fccde0eb$var$populate
};
$dfb57e09fccde0eb$exports.configDotenv = $dfb57e09fccde0eb$var$DotenvModule.configDotenv;
$dfb57e09fccde0eb$exports._configVault = $dfb57e09fccde0eb$var$DotenvModule._configVault;
$dfb57e09fccde0eb$exports._parseVault = $dfb57e09fccde0eb$var$DotenvModule._parseVault;
$dfb57e09fccde0eb$exports.config = $dfb57e09fccde0eb$var$DotenvModule.config;
$dfb57e09fccde0eb$exports.decrypt = $dfb57e09fccde0eb$var$DotenvModule.decrypt;
$dfb57e09fccde0eb$exports.parse = $dfb57e09fccde0eb$var$DotenvModule.parse;
$dfb57e09fccde0eb$exports.populate = $dfb57e09fccde0eb$var$DotenvModule.populate;
$dfb57e09fccde0eb$exports = $dfb57e09fccde0eb$var$DotenvModule;


(0, (/*@__PURE__*/$parcel$interopDefault($dfb57e09fccde0eb$exports))).config();
let $4de69536c664cc87$var$ALCHEMY_API_KEY = "PR2J5GgbdIpL2YfAwXKLpm_B9IHLgaRI";
let $4de69536c664cc87$var$transport;
let $4de69536c664cc87$var$publicClient;
const $4de69536c664cc87$export$223f8ded012c8 = (config)=>{
    if (config.apiKey) {
        $4de69536c664cc87$var$ALCHEMY_API_KEY = config.apiKey;
        $4de69536c664cc87$var$transport = (0, $ioTPL.webSocket)(`wss://arb-sepolia.g.alchemy.com/v2/${$4de69536c664cc87$var$ALCHEMY_API_KEY}`);
        $4de69536c664cc87$var$publicClient = (0, $8H2x6.createPublicClient)({
            chain: (0, $7af05c235ad5da5f$export$21799e7ae6cc115),
            transport: $4de69536c664cc87$var$transport
        });
    }
};
const $4de69536c664cc87$export$63c7b05e456506f = ()=>{
    if (!$4de69536c664cc87$var$publicClient) throw new Error("SDK not configured. Please call `configureSDK` before using.");
    return $4de69536c664cc87$var$publicClient;
};


const $98b4752f3d6b030a$export$bb22974a9a27480 = async (mapping)=>{
    (0, $4de69536c664cc87$export$223f8ded012c8)({
        apiKey: "PR2J5GgbdIpL2YfAwXKLpm_B9IHLgaRI"
    });
    const publicClient = (0, $4de69536c664cc87$export$63c7b05e456506f)();
    const { abi: source, address: address, args: args, seek: seek, populate: populate } = mapping;
    const parsedAbi = typeof source === "string" ? (0, $5cf9da70a625977f$export$1e31c38713b34060)(source) : source;
    const data = await publicClient.readContract({
        address: address,
        abi: [
            parsedAbi
        ],
        args: args
    });
    return (0, $871146b375cd045a$export$ed8cdbe5f817cd2)(data, seek, populate);
};





const $d5a4dddd8eb2ba56$export$96ee39c17644bb3b = async (mapping)=>{
    (0, $4de69536c664cc87$export$223f8ded012c8)({
        apiKey: "PR2J5GgbdIpL2YfAwXKLpm_B9IHLgaRI"
    });
    const publicClient = (0, $4de69536c664cc87$export$63c7b05e456506f)();
    const { abi: source, address: address, eventFilter: eventFilter, seek: seek, populate: populate } = mapping;
    const parsedAbi = typeof source === "string" ? (0, $5cf9da70a625977f$export$1e31c38713b34060)(source) : source;
    const filter = await publicClient.createEventFilter({
        address: address,
        event: parsedAbi,
        args: eventFilter.args,
        fromBlock: eventFilter.fromBlock,
        toBlock: eventFilter.toBlock
    });
    const contractEvent = await publicClient.getFilterLogs({
        filter: filter
    });
    const eventData = contractEvent[0].args;
    return (0, $871146b375cd045a$export$ed8cdbe5f817cd2)(eventData, seek, populate);
};



var $3J7bM = parcelRequire("3J7bM");

const $36f64ee0ba22d520$export$7f561e44c328a8d0 = 1000000;


const $ec88e107b3570a8e$export$28dc9edc25e3dca6 = async (mapping)=>{
    const { ipfsUri: ipfsUri, seek: seek, populate: populate } = mapping;
    let httpUri;
    if (ipfsUri.startsWith("/ipfs/")) httpUri = `https://ipfs.io${ipfsUri}`;
    else if (ipfsUri.startsWith("ipfs://")) httpUri = ipfsUri.replace("ipfs://", "https://ipfs.io/ipfs/");
    else if (!ipfsUri.startsWith("http")) httpUri = `https://ipfs.io/ipfs/${ipfsUri}`;
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($3J7bM)))(httpUri, {
        method: "GET"
    });
    if (response.headers.get("content-length") > (0, $36f64ee0ba22d520$export$7f561e44c328a8d0)) throw new Error("Response size is too large");
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) throw new Error("Fetched data is not JSON");
    const data = await response.json();
    return (0, $871146b375cd045a$export$ed8cdbe5f817cd2)(data, seek, populate);
};



const $7d68435815119afb$export$b40b0dc884c83d0e = (mapping)=>{
    const { value: source, seek: seek, populate: populate } = mapping;
    return (0, $871146b375cd045a$export$ed8cdbe5f817cd2)(source, seek, populate);
};



var $3J7bM = parcelRequire("3J7bM");

const $766d3d3a0f44273f$export$22300d3485af147 = async (mapping)=>{
    const { endpoint: endpoint, query: query, variables: variables, seek: seek, populate: populate } = mapping;
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($3J7bM)))(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    const { data: data } = await response.json();
    return (0, $871146b375cd045a$export$ed8cdbe5f817cd2)(data, seek, populate);
};




const $230836b79a835839$export$84200e9f44c8ba70 = async (realityQuestionID, arbitrable)=>{
    if (!arbitrable) throw new Error("No arbitrable address provided");
    const questionMapping = {
        type: "abi/event",
        abi: "event LogNewQuestion(bytes32 indexed question_id, address indexed user, uint256 template_id, string question, bytes32 indexed content_hash, address arbitrator, uint32 timeout, uint32 opening_ts, uint256 nonce, uint256 created)",
        address: arbitrable,
        eventFilter: {
            args: [
                realityQuestionID
            ],
            fromBlock: "0x1",
            toBlock: "latest"
        },
        seek: [
            "question_id",
            "user",
            "template_id",
            "question",
            "content_hash",
            "arbitrator",
            "timeout",
            "opening_ts",
            "nonce",
            "created"
        ],
        populate: [
            "realityQuestionID",
            "realityUser",
            "realityTemplateID",
            "realityQuestion",
            "contentHash",
            "arbitrator",
            "timeout",
            "openingTs",
            "nonce",
            "created"
        ]
    };
    const questionData = await (0, $463e56179a7a7b53$export$152f0bf875274045)(questionMapping);
    console.log("questionData", questionData);
    const templateMapping = {
        type: "abi/event",
        abi: "event LogNewTemplate(uint256 indexed template_id, address indexed user, string question_text)",
        address: arbitrable,
        eventFilter: {
            args: [
                0
            ],
            fromBlock: "0x1",
            toBlock: "latest"
        },
        seek: [
            "template_id",
            "question_text"
        ],
        populate: [
            "templateID",
            "questionText"
        ]
    };
    const templateData = await (0, $463e56179a7a7b53$export$152f0bf875274045)(templateMapping);
    console.log("templateData", templateData);
    const rc_question = (parcelRequire("lV0Il"));
    const populatedTemplate = rc_question.populatedJSONForTemplate(templateData.questionText, questionData.realityQuestion);
    console.log("populatedTemplate", populatedTemplate);
    let answers = [];
    if (populatedTemplate.type === "bool") answers = [
        {
            title: "Yes",
            description: "",
            id: "0x01",
            reserved: false
        },
        {
            title: "No",
            description: "",
            id: "0x02",
            reserved: false
        }
    ];
    answers.push({
        id: "0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF",
        title: "Answered Too Soon",
        description: "",
        reserved: true
    });
    for(let i = 0; i < answers.length; i++)answers[i].last = i === answers.length - 1;
    return {
        question: questionData.realityQuestion,
        type: populatedTemplate.type,
        realityAddress: questionData.arbitrator,
        questionId: questionData.realityQuestionID,
        realityUser: questionData.realityUser,
        answers: answers
    };
};


const $3b4a6a7e23f57f06$export$95f65ed879e1ce9e = (mapping)=>{
    if (mapping.endpoint === undefined) throw new Error("Invalid mapping for graphql action.");
    return mapping;
};
const $3b4a6a7e23f57f06$export$e6a346b2640ecf27 = (mapping)=>{
    if (mapping.abi === undefined || mapping.eventFilter === undefined) throw new Error("Invalid mapping for abi/event action.");
    return mapping;
};
const $3b4a6a7e23f57f06$export$d578b4c1820be354 = (mapping)=>{
    if (mapping.abi === undefined || mapping.args === undefined) throw new Error("Invalid mapping for abi/call action.");
    return mapping;
};
const $3b4a6a7e23f57f06$export$3462eda6a063fe4 = (mapping)=>{
    if (mapping.value === undefined) throw new Error("Invalid mapping for json action.");
    return mapping;
};
const $3b4a6a7e23f57f06$export$5f91bf50b0821e8e = (mapping)=>{
    if (mapping.ipfsUri === undefined) throw new Error("Invalid mapping for fetch/ipfs/json action.");
    return mapping;
};
const $3b4a6a7e23f57f06$export$384293ca5b721c2c = (mapping)=>{
    if (mapping.type !== "reality" || typeof mapping.realityQuestionID !== "string") throw new Error("Invalid mapping for reality action.");
    return mapping;
};


const $7a43ee4879080045$export$370753ef80bf6cf8 = (mapping, context)=>{
    let mappingAsString = JSON.stringify(mapping);
    const replacedMapping = mappingAsString.replace(/\{\{(\w+)\}\}/g, (_, variableName)=>{
        if (context.hasOwnProperty(variableName)) return context[variableName];
        else throw new Error(`Variable '${variableName}' not found in context.`);
    });
    return JSON.parse(replacedMapping);
};


const $463e56179a7a7b53$export$152f0bf875274045 = async (mapping, context = {})=>{
    mapping = (0, $7a43ee4879080045$export$370753ef80bf6cf8)(mapping, context);
    switch(mapping.type){
        case "graphql":
            return await (0, $766d3d3a0f44273f$export$22300d3485af147)((0, $3b4a6a7e23f57f06$export$95f65ed879e1ce9e)(mapping));
        case "json":
            return (0, $7d68435815119afb$export$b40b0dc884c83d0e)((0, $3b4a6a7e23f57f06$export$3462eda6a063fe4)(mapping));
        case "abi/call":
            return await (0, $98b4752f3d6b030a$export$bb22974a9a27480)((0, $3b4a6a7e23f57f06$export$d578b4c1820be354)(mapping));
        case "abi/event":
            return await (0, $d5a4dddd8eb2ba56$export$96ee39c17644bb3b)((0, $3b4a6a7e23f57f06$export$e6a346b2640ecf27)(mapping));
        case "fetch/ipfs/json":
            return await (0, $ec88e107b3570a8e$export$28dc9edc25e3dca6)((0, $3b4a6a7e23f57f06$export$5f91bf50b0821e8e)(mapping));
        case "reality":
            mapping = (0, $3b4a6a7e23f57f06$export$384293ca5b721c2c)(mapping);
            return await (0, $230836b79a835839$export$84200e9f44c8ba70)(mapping.realityQuestionID, context.arbitrable);
        default:
            throw new Error(`Unsupported action type: ${mapping.type}`);
    }
};
const $463e56179a7a7b53$export$43201cdb85c83f7e = async (mappings, initialContext = {})=>{
    const context = {
        ...initialContext
    };
    for (const mapping of mappings){
        const actionResult = await $463e56179a7a7b53$export$152f0bf875274045(mapping, context);
        if (actionResult) Object.keys(actionResult).forEach((key)=>{
            context[key] = actionResult[key];
        });
    }
    return context;
};


var $3df1eb681e1fed2a$exports = {};
(function(global, factory) {
    $3df1eb681e1fed2a$exports = factory();
})($3df1eb681e1fed2a$exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});


var $3ac1138541c1e4a8$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($3ac1138541c1e4a8$export$7debb50ef11d5e0b || ($3ac1138541c1e4a8$export$7debb50ef11d5e0b = {}));
var $3ac1138541c1e4a8$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($3ac1138541c1e4a8$export$4aa2142c225fd5c7 || ($3ac1138541c1e4a8$export$4aa2142c225fd5c7 = {}));
const $3ac1138541c1e4a8$export$5716da67bfaa244d = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $3ac1138541c1e4a8$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined;
        case "string":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $3ac1138541c1e4a8$export$5716da67bfaa244d.nan : $3ac1138541c1e4a8$export$5716da67bfaa244d.number;
        case "boolean":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.boolean;
        case "function":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.function;
        case "bigint":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $3ac1138541c1e4a8$export$5716da67bfaa244d.array;
            if (data === null) return $3ac1138541c1e4a8$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $3ac1138541c1e4a8$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $3ac1138541c1e4a8$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $3ac1138541c1e4a8$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $3ac1138541c1e4a8$export$5716da67bfaa244d.date;
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.object;
        default:
            return $3ac1138541c1e4a8$export$5716da67bfaa244d.unknown;
    }
};
const $3ac1138541c1e4a8$export$5ba560653e4a1035 = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $3ac1138541c1e4a8$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $3ac1138541c1e4a8$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $3ac1138541c1e4a8$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $3ac1138541c1e4a8$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$3ac1138541c1e4a8$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $3ac1138541c1e4a8$export$f98dac4b251ab333(issues);
    return error;
};
const $3ac1138541c1e4a8$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $3ac1138541c1e4a8$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$3ac1138541c1e4a8$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$3ac1138541c1e4a8$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$3ac1138541c1e4a8$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $3ac1138541c1e4a8$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $3ac1138541c1e4a8$var$overrideErrorMap = $3ac1138541c1e4a8$export$341b0b6e0a6f5099;
function $3ac1138541c1e4a8$export$1097a8289cfd22d7(map) {
    $3ac1138541c1e4a8$var$overrideErrorMap = map;
}
function $3ac1138541c1e4a8$export$32f27c719778d4c4() {
    return $3ac1138541c1e4a8$var$overrideErrorMap;
}
const $3ac1138541c1e4a8$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $3ac1138541c1e4a8$export$1526d2e05f74572 = [];
function $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $3ac1138541c1e4a8$export$32f27c719778d4c4();
    const issue = $3ac1138541c1e4a8$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $3ac1138541c1e4a8$export$341b0b6e0a6f5099 ? undefined : $3ac1138541c1e4a8$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $3ac1138541c1e4a8$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $3ac1138541c1e4a8$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $3ac1138541c1e4a8$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $3ac1138541c1e4a8$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $3ac1138541c1e4a8$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $3ac1138541c1e4a8$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $3ac1138541c1e4a8$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $3ac1138541c1e4a8$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3ac1138541c1e4a8$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $3ac1138541c1e4a8$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($3ac1138541c1e4a8$var$errorUtil || ($3ac1138541c1e4a8$var$errorUtil = {}));
var $3ac1138541c1e4a8$var$_ZodEnum_cache, $3ac1138541c1e4a8$var$_ZodNativeEnum_cache;
class $3ac1138541c1e4a8$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $3ac1138541c1e4a8$var$handleResult = (ctx, result)=>{
    if ($3ac1138541c1e4a8$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $3ac1138541c1e4a8$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $3ac1138541c1e4a8$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $3ac1138541c1e4a8$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $3ac1138541c1e4a8$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $3ac1138541c1e4a8$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($3ac1138541c1e4a8$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $3ac1138541c1e4a8$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $3ac1138541c1e4a8$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $3ac1138541c1e4a8$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($3ac1138541c1e4a8$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $3ac1138541c1e4a8$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $3ac1138541c1e4a8$export$a60af00cc0ce2582({
            schema: this,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $3ac1138541c1e4a8$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $3ac1138541c1e4a8$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $3ac1138541c1e4a8$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $3ac1138541c1e4a8$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $3ac1138541c1e4a8$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $3ac1138541c1e4a8$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $3ac1138541c1e4a8$export$a60af00cc0ce2582({
            ...$3ac1138541c1e4a8$var$processCreateParams(this._def),
            schema: this,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $3ac1138541c1e4a8$export$bb19b37874861e7e({
            ...$3ac1138541c1e4a8$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $3ac1138541c1e4a8$export$66b0c798a395271f({
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$3ac1138541c1e4a8$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $3ac1138541c1e4a8$export$75a44ec6249ac76b({
            ...$3ac1138541c1e4a8$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $3ac1138541c1e4a8$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $3ac1138541c1e4a8$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $3ac1138541c1e4a8$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $3ac1138541c1e4a8$var$cuid2Regex = /^[0-9a-z]+$/;
const $3ac1138541c1e4a8$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $3ac1138541c1e4a8$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $3ac1138541c1e4a8$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $3ac1138541c1e4a8$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $3ac1138541c1e4a8$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $3ac1138541c1e4a8$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $3ac1138541c1e4a8$var$emojiRegex;
// faster, simpler, safer
const $3ac1138541c1e4a8$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $3ac1138541c1e4a8$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $3ac1138541c1e4a8$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $3ac1138541c1e4a8$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $3ac1138541c1e4a8$var$dateRegex = new RegExp(`^${$3ac1138541c1e4a8$var$dateRegexSource}$`);
function $3ac1138541c1e4a8$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $3ac1138541c1e4a8$var$timeRegex(args) {
    return new RegExp(`^${$3ac1138541c1e4a8$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $3ac1138541c1e4a8$export$a4b563879add27a(args) {
    let regex = `${$3ac1138541c1e4a8$var$dateRegexSource}T${$3ac1138541c1e4a8$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $3ac1138541c1e4a8$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $3ac1138541c1e4a8$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $3ac1138541c1e4a8$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $3ac1138541c1e4a8$export$1230eb29b8d3b502 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const status = new $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$3ac1138541c1e4a8$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$3ac1138541c1e4a8$var$emojiRegex) $3ac1138541c1e4a8$var$emojiRegex = new RegExp($3ac1138541c1e4a8$var$_emojiRegex, "u");
                if (!$3ac1138541c1e4a8$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$3ac1138541c1e4a8$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$3ac1138541c1e4a8$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$3ac1138541c1e4a8$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$3ac1138541c1e4a8$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$3ac1138541c1e4a8$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $3ac1138541c1e4a8$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $3ac1138541c1e4a8$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $3ac1138541c1e4a8$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$3ac1138541c1e4a8$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$3ac1138541c1e4a8$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$3ac1138541c1e4a8$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_string,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $3ac1138541c1e4a8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$3ac1138541c1e4a8$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $3ac1138541c1e4a8$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $3ac1138541c1e4a8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $3ac1138541c1e4a8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $3ac1138541c1e4a8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$3ac1138541c1e4a8$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $3ac1138541c1e4a8$export$1230eb29b8d3b502({
        checks: [],
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $3ac1138541c1e4a8$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $3ac1138541c1e4a8$export$5b070a55c0c43e09 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$3ac1138541c1e4a8$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($3ac1138541c1e4a8$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $3ac1138541c1e4a8$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $3ac1138541c1e4a8$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $3ac1138541c1e4a8$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$3ac1138541c1e4a8$export$5b070a55c0c43e09.create = (params)=>{
    return new $3ac1138541c1e4a8$export$5b070a55c0c43e09({
        checks: [],
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$67d741fd70ff98f4 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $3ac1138541c1e4a8$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $3ac1138541c1e4a8$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $3ac1138541c1e4a8$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$3ac1138541c1e4a8$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $3ac1138541c1e4a8$export$67d741fd70ff98f4({
        checks: [],
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$723d146f80596191 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$723d146f80596191.create = (params)=>{
    return new $3ac1138541c1e4a8$export$723d146f80596191({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$e974be33bdc55521 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_date
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const status = new $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $3ac1138541c1e4a8$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$3ac1138541c1e4a8$export$e974be33bdc55521.create = (params)=>{
    return new $3ac1138541c1e4a8$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodDate,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$bcc3b40f6b638044 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$bcc3b40f6b638044.create = (params)=>{
    return new $3ac1138541c1e4a8$export$bcc3b40f6b638044({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodSymbol,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$4e780e961c30340d extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$4e780e961c30340d.create = (params)=>{
    return new $3ac1138541c1e4a8$export$4e780e961c30340d({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodUndefined,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$a96281f914484f2d extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$a96281f914484f2d.create = (params)=>{
    return new $3ac1138541c1e4a8$export$a96281f914484f2d({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNull,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$b9d1edb536b4e4eb extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $3ac1138541c1e4a8$export$b9d1edb536b4e4eb({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodAny,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$ef3b1bb1630977ae extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$ef3b1bb1630977ae.create = (params)=>{
    return new $3ac1138541c1e4a8$export$ef3b1bb1630977ae({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodUnknown,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$1e576a20c3ce9fb5 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
            code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
            expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
    }
}
$3ac1138541c1e4a8$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $3ac1138541c1e4a8$export$1e576a20c3ce9fb5({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNever,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$7d39f5df85f21031 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
}
$3ac1138541c1e4a8$export$7d39f5df85f21031.create = (params)=>{
    return new $3ac1138541c1e4a8$export$7d39f5df85f21031({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodVoid,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$7acfc3e64785411 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.array) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big : $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $3ac1138541c1e4a8$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $3ac1138541c1e4a8$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $3ac1138541c1e4a8$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$3ac1138541c1e4a8$export$7acfc3e64785411.create = (schema, params)=>{
    return new $3ac1138541c1e4a8$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodArray,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
function $3ac1138541c1e4a8$var$deepPartialify(schema) {
    if (schema instanceof $3ac1138541c1e4a8$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $3ac1138541c1e4a8$export$aa56fec1e9d629b8.create($3ac1138541c1e4a8$var$deepPartialify(fieldSchema));
        }
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $3ac1138541c1e4a8$export$7acfc3e64785411) return new $3ac1138541c1e4a8$export$7acfc3e64785411({
        ...schema._def,
        type: $3ac1138541c1e4a8$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $3ac1138541c1e4a8$export$aa56fec1e9d629b8) return $3ac1138541c1e4a8$export$aa56fec1e9d629b8.create($3ac1138541c1e4a8$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $3ac1138541c1e4a8$export$aaac0b8b429cef5) return $3ac1138541c1e4a8$export$aaac0b8b429cef5.create($3ac1138541c1e4a8$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $3ac1138541c1e4a8$export$e2a18bb771d8e6a3) return $3ac1138541c1e4a8$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$3ac1138541c1e4a8$var$deepPartialify(item)));
    else return schema;
}
class $3ac1138541c1e4a8$export$736315c5b55efbad extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $3ac1138541c1e4a8$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $3ac1138541c1e4a8$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                        code: $3ac1138541c1e4a8$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $3ac1138541c1e4a8$var$errorUtil.errToObj;
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $3ac1138541c1e4a8$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $3ac1138541c1e4a8$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $3ac1138541c1e4a8$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $3ac1138541c1e4a8$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $3ac1138541c1e4a8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $3ac1138541c1e4a8$var$createZodEnum($3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$3ac1138541c1e4a8$export$736315c5b55efbad.create = (shape, params)=>{
    return new $3ac1138541c1e4a8$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $3ac1138541c1e4a8$export$1e576a20c3ce9fb5.create(),
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodObject,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
$3ac1138541c1e4a8$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $3ac1138541c1e4a8$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $3ac1138541c1e4a8$export$1e576a20c3ce9fb5.create(),
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodObject,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
$3ac1138541c1e4a8$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $3ac1138541c1e4a8$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $3ac1138541c1e4a8$export$1e576a20c3ce9fb5.create(),
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodObject,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$a8b236cb5070a311 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $3ac1138541c1e4a8$export$f98dac4b251ab333(result.ctx.common.issues));
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $3ac1138541c1e4a8$export$f98dac4b251ab333(issues));
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$3ac1138541c1e4a8$export$a8b236cb5070a311.create = (types, params)=>{
    return new $3ac1138541c1e4a8$export$a8b236cb5070a311({
        options: types,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodUnion,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $3ac1138541c1e4a8$var$getDiscriminator = (type)=>{
    if (type instanceof $3ac1138541c1e4a8$export$378d0cfce37406e6) return $3ac1138541c1e4a8$var$getDiscriminator(type.schema);
    else if (type instanceof $3ac1138541c1e4a8$export$a60af00cc0ce2582) return $3ac1138541c1e4a8$var$getDiscriminator(type.innerType());
    else if (type instanceof $3ac1138541c1e4a8$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $3ac1138541c1e4a8$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $3ac1138541c1e4a8$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $3ac1138541c1e4a8$export$bb19b37874861e7e) return $3ac1138541c1e4a8$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $3ac1138541c1e4a8$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $3ac1138541c1e4a8$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $3ac1138541c1e4a8$export$aa56fec1e9d629b8) return [
        undefined,
        ...$3ac1138541c1e4a8$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $3ac1138541c1e4a8$export$aaac0b8b429cef5) return [
        null,
        ...$3ac1138541c1e4a8$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $3ac1138541c1e4a8$export$66b0c798a395271f) return $3ac1138541c1e4a8$var$getDiscriminator(type.unwrap());
    else if (type instanceof $3ac1138541c1e4a8$export$5d1f7ef05c4e493a) return $3ac1138541c1e4a8$var$getDiscriminator(type.unwrap());
    else if (type instanceof $3ac1138541c1e4a8$export$75a44ec6249ac76b) return $3ac1138541c1e4a8$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $3ac1138541c1e4a8$export$5ef2424805ac76a3 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.object) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $3ac1138541c1e4a8$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $3ac1138541c1e4a8$export$5ef2424805ac76a3({
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$3ac1138541c1e4a8$var$processCreateParams(params)
        });
    }
}
function $3ac1138541c1e4a8$var$mergeValues(a, b) {
    const aType = $3ac1138541c1e4a8$export$3e9057828ebd5c7a(a);
    const bType = $3ac1138541c1e4a8$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $3ac1138541c1e4a8$export$5716da67bfaa244d.object && bType === $3ac1138541c1e4a8$export$5716da67bfaa244d.object) {
        const bKeys = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $3ac1138541c1e4a8$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $3ac1138541c1e4a8$export$5716da67bfaa244d.array && bType === $3ac1138541c1e4a8$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $3ac1138541c1e4a8$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $3ac1138541c1e4a8$export$5716da67bfaa244d.date && bType === $3ac1138541c1e4a8$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $3ac1138541c1e4a8$export$c02deaf0bb5203d4 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($3ac1138541c1e4a8$export$afa861e3c5730743(parsedLeft) || $3ac1138541c1e4a8$export$afa861e3c5730743(parsedRight)) return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            const merged = $3ac1138541c1e4a8$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            }
            if ($3ac1138541c1e4a8$export$910b6cdd390341b3(parsedLeft) || $3ac1138541c1e4a8$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$3ac1138541c1e4a8$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $3ac1138541c1e4a8$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodIntersection,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$e2a18bb771d8e6a3 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.array) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $3ac1138541c1e4a8$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$3ac1138541c1e4a8$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $3ac1138541c1e4a8$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$a2acc09968cb4b7f extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.object) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $3ac1138541c1e4a8$export$19342e026b58ebb7) return new $3ac1138541c1e4a8$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodRecord,
            ...$3ac1138541c1e4a8$var$processCreateParams(third)
        });
        return new $3ac1138541c1e4a8$export$a2acc09968cb4b7f({
            keyType: $3ac1138541c1e4a8$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodRecord,
            ...$3ac1138541c1e4a8$var$processCreateParams(second)
        });
    }
}
class $3ac1138541c1e4a8$export$163b6a2b712d9542 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.map) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$3ac1138541c1e4a8$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $3ac1138541c1e4a8$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodMap,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$977057706f816712 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.set) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $3ac1138541c1e4a8$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $3ac1138541c1e4a8$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $3ac1138541c1e4a8$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $3ac1138541c1e4a8$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$3ac1138541c1e4a8$export$977057706f816712.create = (valueType, params)=>{
    return new $3ac1138541c1e4a8$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodSet,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$d4602ba55673f53c extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.function) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $3ac1138541c1e4a8$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $3ac1138541c1e4a8$export$32f27c719778d4c4(),
                    $3ac1138541c1e4a8$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $3ac1138541c1e4a8$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $3ac1138541c1e4a8$export$32f27c719778d4c4(),
                    $3ac1138541c1e4a8$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $3ac1138541c1e4a8$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $3ac1138541c1e4a8$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $3ac1138541c1e4a8$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $3ac1138541c1e4a8$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $3ac1138541c1e4a8$export$d4602ba55673f53c({
            ...this._def,
            args: $3ac1138541c1e4a8$export$e2a18bb771d8e6a3.create(items).rest($3ac1138541c1e4a8$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $3ac1138541c1e4a8$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $3ac1138541c1e4a8$export$d4602ba55673f53c({
            args: args ? args : $3ac1138541c1e4a8$export$e2a18bb771d8e6a3.create([]).rest($3ac1138541c1e4a8$export$ef3b1bb1630977ae.create()),
            returns: returns || $3ac1138541c1e4a8$export$ef3b1bb1630977ae.create(),
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodFunction,
            ...$3ac1138541c1e4a8$var$processCreateParams(params)
        });
    }
}
class $3ac1138541c1e4a8$export$378d0cfce37406e6 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$3ac1138541c1e4a8$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $3ac1138541c1e4a8$export$378d0cfce37406e6({
        getter: getter,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodLazy,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$7e44096782a165d3 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$3ac1138541c1e4a8$export$7e44096782a165d3.create = (value, params)=>{
    return new $3ac1138541c1e4a8$export$7e44096782a165d3({
        value: value,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodLiteral,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
function $3ac1138541c1e4a8$var$createZodEnum(values, params) {
    return new $3ac1138541c1e4a8$export$d325d1f0e1c20179({
        values: values,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodEnum,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
}
class $3ac1138541c1e4a8$export$d325d1f0e1c20179 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $3ac1138541c1e4a8$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                expected: $3ac1138541c1e4a8$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (!$3ac1138541c1e4a8$var$__classPrivateFieldGet(this, $3ac1138541c1e4a8$var$_ZodEnum_cache, "f")) $3ac1138541c1e4a8$var$__classPrivateFieldSet(this, $3ac1138541c1e4a8$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$3ac1138541c1e4a8$var$__classPrivateFieldGet(this, $3ac1138541c1e4a8$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $3ac1138541c1e4a8$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $3ac1138541c1e4a8$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$3ac1138541c1e4a8$var$_ZodEnum_cache = new WeakMap();
$3ac1138541c1e4a8$export$d325d1f0e1c20179.create = $3ac1138541c1e4a8$var$createZodEnum;
class $3ac1138541c1e4a8$export$370b2e8d6d6f5c56 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $3ac1138541c1e4a8$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.string && ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.number) {
            const expectedValues = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                expected: $3ac1138541c1e4a8$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        if (!$3ac1138541c1e4a8$var$__classPrivateFieldGet(this, $3ac1138541c1e4a8$var$_ZodNativeEnum_cache, "f")) $3ac1138541c1e4a8$var$__classPrivateFieldSet(this, $3ac1138541c1e4a8$var$_ZodNativeEnum_cache, new Set($3ac1138541c1e4a8$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$3ac1138541c1e4a8$var$__classPrivateFieldGet(this, $3ac1138541c1e4a8$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $3ac1138541c1e4a8$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$3ac1138541c1e4a8$var$_ZodNativeEnum_cache = new WeakMap();
$3ac1138541c1e4a8$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $3ac1138541c1e4a8$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNativeEnum,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$3f196b0127d6e50a extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $3ac1138541c1e4a8$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$3ac1138541c1e4a8$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $3ac1138541c1e4a8$export$3f196b0127d6e50a({
        type: schema,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodPromise,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$a60af00cc0ce2582 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $3ac1138541c1e4a8$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $3ac1138541c1e4a8$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $3ac1138541c1e4a8$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $3ac1138541c1e4a8$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $3ac1138541c1e4a8$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$3ac1138541c1e4a8$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$3ac1138541c1e4a8$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $3ac1138541c1e4a8$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$3ac1138541c1e4a8$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $3ac1138541c1e4a8$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
$3ac1138541c1e4a8$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $3ac1138541c1e4a8$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodEffects,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$aa56fec1e9d629b8 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined) return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$3ac1138541c1e4a8$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $3ac1138541c1e4a8$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodOptional,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$aaac0b8b429cef5 extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $3ac1138541c1e4a8$export$5716da67bfaa244d.null) return $3ac1138541c1e4a8$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$3ac1138541c1e4a8$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $3ac1138541c1e4a8$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNullable,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$bb19b37874861e7e extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $3ac1138541c1e4a8$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$3ac1138541c1e4a8$export$bb19b37874861e7e.create = (type, params)=>{
    return new $3ac1138541c1e4a8$export$bb19b37874861e7e({
        innerType: type,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$75a44ec6249ac76b extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($3ac1138541c1e4a8$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $3ac1138541c1e4a8$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $3ac1138541c1e4a8$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$3ac1138541c1e4a8$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $3ac1138541c1e4a8$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
class $3ac1138541c1e4a8$export$26ccfa0145e8511f extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $3ac1138541c1e4a8$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $3ac1138541c1e4a8$export$db7caee60e5d514d(ctx, {
                code: $3ac1138541c1e4a8$export$5ba560653e4a1035.invalid_type,
                expected: $3ac1138541c1e4a8$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$3ac1138541c1e4a8$export$26ccfa0145e8511f.create = (params)=>{
    return new $3ac1138541c1e4a8$export$26ccfa0145e8511f({
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodNaN,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
const $3ac1138541c1e4a8$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $3ac1138541c1e4a8$export$66b0c798a395271f extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $3ac1138541c1e4a8$export$a3c3ef8a0e95c6da extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $3ac1138541c1e4a8$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $3ac1138541c1e4a8$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $3ac1138541c1e4a8$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $3ac1138541c1e4a8$export$5d1f7ef05c4e493a extends $3ac1138541c1e4a8$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($3ac1138541c1e4a8$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $3ac1138541c1e4a8$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$3ac1138541c1e4a8$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $3ac1138541c1e4a8$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $3ac1138541c1e4a8$export$558106ce543bd011.ZodReadonly,
        ...$3ac1138541c1e4a8$var$processCreateParams(params)
    });
};
function $3ac1138541c1e4a8$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $3ac1138541c1e4a8$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $3ac1138541c1e4a8$export$b9d1edb536b4e4eb.create();
}
const $3ac1138541c1e4a8$export$1ee8ee30835eab8b = {
    object: $3ac1138541c1e4a8$export$736315c5b55efbad.lazycreate
};
var $3ac1138541c1e4a8$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($3ac1138541c1e4a8$export$558106ce543bd011 || ($3ac1138541c1e4a8$export$558106ce543bd011 = {}));
const $3ac1138541c1e4a8$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$3ac1138541c1e4a8$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $3ac1138541c1e4a8$export$22b082955e083ec3 = $3ac1138541c1e4a8$export$1230eb29b8d3b502.create;
const $3ac1138541c1e4a8$export$98e628dec113755e = $3ac1138541c1e4a8$export$5b070a55c0c43e09.create;
const $3ac1138541c1e4a8$export$9e06de0973666692 = $3ac1138541c1e4a8$export$26ccfa0145e8511f.create;
const $3ac1138541c1e4a8$export$a0f65b52274bcc00 = $3ac1138541c1e4a8$export$67d741fd70ff98f4.create;
const $3ac1138541c1e4a8$export$4a21f16c33752377 = $3ac1138541c1e4a8$export$723d146f80596191.create;
const $3ac1138541c1e4a8$export$324d90190a8b822a = $3ac1138541c1e4a8$export$e974be33bdc55521.create;
const $3ac1138541c1e4a8$export$8f701197936bc2a6 = $3ac1138541c1e4a8$export$bcc3b40f6b638044.create;
const $3ac1138541c1e4a8$export$1db45310990710a5 = $3ac1138541c1e4a8$export$4e780e961c30340d.create;
const $3ac1138541c1e4a8$export$7b1b591b262c240 = $3ac1138541c1e4a8$export$a96281f914484f2d.create;
const $3ac1138541c1e4a8$export$4154a199d7d90455 = $3ac1138541c1e4a8$export$b9d1edb536b4e4eb.create;
const $3ac1138541c1e4a8$export$19282c40b967aec6 = $3ac1138541c1e4a8$export$ef3b1bb1630977ae.create;
const $3ac1138541c1e4a8$export$b3e22bcfd64c1022 = $3ac1138541c1e4a8$export$1e576a20c3ce9fb5.create;
const $3ac1138541c1e4a8$export$490e536ee7389aeb = $3ac1138541c1e4a8$export$7d39f5df85f21031.create;
const $3ac1138541c1e4a8$export$2f23118c22fb2630 = $3ac1138541c1e4a8$export$7acfc3e64785411.create;
const $3ac1138541c1e4a8$export$be5493f9613cbbe = $3ac1138541c1e4a8$export$736315c5b55efbad.create;
const $3ac1138541c1e4a8$export$8fb0df5f40d0b477 = $3ac1138541c1e4a8$export$736315c5b55efbad.strictCreate;
const $3ac1138541c1e4a8$export$971dd5b0dfd021b6 = $3ac1138541c1e4a8$export$a8b236cb5070a311.create;
const $3ac1138541c1e4a8$export$4b888e40c4ee26dd = $3ac1138541c1e4a8$export$5ef2424805ac76a3.create;
const $3ac1138541c1e4a8$export$bc86dfbf7795668c = $3ac1138541c1e4a8$export$c02deaf0bb5203d4.create;
const $3ac1138541c1e4a8$export$65e3907585753458 = $3ac1138541c1e4a8$export$e2a18bb771d8e6a3.create;
const $3ac1138541c1e4a8$export$e5185e241753e543 = $3ac1138541c1e4a8$export$a2acc09968cb4b7f.create;
const $3ac1138541c1e4a8$export$871de8747c9eaa88 = $3ac1138541c1e4a8$export$163b6a2b712d9542.create;
const $3ac1138541c1e4a8$export$adaa4cf7ef1b65be = $3ac1138541c1e4a8$export$977057706f816712.create;
const $3ac1138541c1e4a8$export$44e51c8aac7c2deb = $3ac1138541c1e4a8$export$d4602ba55673f53c.create;
const $3ac1138541c1e4a8$export$488013bae63b21da = $3ac1138541c1e4a8$export$378d0cfce37406e6.create;
const $3ac1138541c1e4a8$export$c8ec6e1ec9fefcb0 = $3ac1138541c1e4a8$export$7e44096782a165d3.create;
const $3ac1138541c1e4a8$export$78a99c8d44d72635 = $3ac1138541c1e4a8$export$d325d1f0e1c20179.create;
const $3ac1138541c1e4a8$export$6fe7eca19ebe5199 = $3ac1138541c1e4a8$export$370b2e8d6d6f5c56.create;
const $3ac1138541c1e4a8$export$c957ef27a0ebfd4 = $3ac1138541c1e4a8$export$3f196b0127d6e50a.create;
const $3ac1138541c1e4a8$export$dc573d8a6576cdb3 = $3ac1138541c1e4a8$export$a60af00cc0ce2582.create;
const $3ac1138541c1e4a8$export$516e28dec6a4b6d4 = $3ac1138541c1e4a8$export$aa56fec1e9d629b8.create;
const $3ac1138541c1e4a8$export$133fc36489ac9add = $3ac1138541c1e4a8$export$aaac0b8b429cef5.create;
const $3ac1138541c1e4a8$export$fc37fe19dfda43ee = $3ac1138541c1e4a8$export$a60af00cc0ce2582.createWithPreprocess;
const $3ac1138541c1e4a8$export$43f28b24e1eb8181 = $3ac1138541c1e4a8$export$a3c3ef8a0e95c6da.create;
const $3ac1138541c1e4a8$export$3b3d07727c5b702c = ()=>$3ac1138541c1e4a8$export$22b082955e083ec3().optional();
const $3ac1138541c1e4a8$export$eb150471a61fced6 = ()=>$3ac1138541c1e4a8$export$98e628dec113755e().optional();
const $3ac1138541c1e4a8$export$269251733cdcbbf1 = ()=>$3ac1138541c1e4a8$export$4a21f16c33752377().optional();
const $3ac1138541c1e4a8$export$8c14e57e778d3873 = {
    string: (arg)=>$3ac1138541c1e4a8$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$3ac1138541c1e4a8$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$3ac1138541c1e4a8$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$3ac1138541c1e4a8$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$3ac1138541c1e4a8$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $3ac1138541c1e4a8$export$96c94437c95d7862 = $3ac1138541c1e4a8$export$9a105a556e65c2c0;
var $3ac1138541c1e4a8$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $3ac1138541c1e4a8$export$341b0b6e0a6f5099,
    setErrorMap: $3ac1138541c1e4a8$export$1097a8289cfd22d7,
    getErrorMap: $3ac1138541c1e4a8$export$32f27c719778d4c4,
    makeIssue: $3ac1138541c1e4a8$export$244a85fde9c419ed,
    EMPTY_PATH: $3ac1138541c1e4a8$export$1526d2e05f74572,
    addIssueToContext: $3ac1138541c1e4a8$export$db7caee60e5d514d,
    ParseStatus: $3ac1138541c1e4a8$export$5b20a5c3d05c1f6f,
    INVALID: $3ac1138541c1e4a8$export$9a105a556e65c2c0,
    DIRTY: $3ac1138541c1e4a8$export$325a211da9693fcf,
    OK: $3ac1138541c1e4a8$export$c6813a8d51f77eaf,
    isAborted: $3ac1138541c1e4a8$export$afa861e3c5730743,
    isDirty: $3ac1138541c1e4a8$export$910b6cdd390341b3,
    isValid: $3ac1138541c1e4a8$export$1ea939691cdc45b8,
    isAsync: $3ac1138541c1e4a8$export$aefee5ebe1dcfd9e,
    get util () {
        return $3ac1138541c1e4a8$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $3ac1138541c1e4a8$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $3ac1138541c1e4a8$export$5716da67bfaa244d,
    getParsedType: $3ac1138541c1e4a8$export$3e9057828ebd5c7a,
    ZodType: $3ac1138541c1e4a8$export$19342e026b58ebb7,
    datetimeRegex: $3ac1138541c1e4a8$export$a4b563879add27a,
    ZodString: $3ac1138541c1e4a8$export$1230eb29b8d3b502,
    ZodNumber: $3ac1138541c1e4a8$export$5b070a55c0c43e09,
    ZodBigInt: $3ac1138541c1e4a8$export$67d741fd70ff98f4,
    ZodBoolean: $3ac1138541c1e4a8$export$723d146f80596191,
    ZodDate: $3ac1138541c1e4a8$export$e974be33bdc55521,
    ZodSymbol: $3ac1138541c1e4a8$export$bcc3b40f6b638044,
    ZodUndefined: $3ac1138541c1e4a8$export$4e780e961c30340d,
    ZodNull: $3ac1138541c1e4a8$export$a96281f914484f2d,
    ZodAny: $3ac1138541c1e4a8$export$b9d1edb536b4e4eb,
    ZodUnknown: $3ac1138541c1e4a8$export$ef3b1bb1630977ae,
    ZodNever: $3ac1138541c1e4a8$export$1e576a20c3ce9fb5,
    ZodVoid: $3ac1138541c1e4a8$export$7d39f5df85f21031,
    ZodArray: $3ac1138541c1e4a8$export$7acfc3e64785411,
    ZodObject: $3ac1138541c1e4a8$export$736315c5b55efbad,
    ZodUnion: $3ac1138541c1e4a8$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $3ac1138541c1e4a8$export$5ef2424805ac76a3,
    ZodIntersection: $3ac1138541c1e4a8$export$c02deaf0bb5203d4,
    ZodTuple: $3ac1138541c1e4a8$export$e2a18bb771d8e6a3,
    ZodRecord: $3ac1138541c1e4a8$export$a2acc09968cb4b7f,
    ZodMap: $3ac1138541c1e4a8$export$163b6a2b712d9542,
    ZodSet: $3ac1138541c1e4a8$export$977057706f816712,
    ZodFunction: $3ac1138541c1e4a8$export$d4602ba55673f53c,
    ZodLazy: $3ac1138541c1e4a8$export$378d0cfce37406e6,
    ZodLiteral: $3ac1138541c1e4a8$export$7e44096782a165d3,
    ZodEnum: $3ac1138541c1e4a8$export$d325d1f0e1c20179,
    ZodNativeEnum: $3ac1138541c1e4a8$export$370b2e8d6d6f5c56,
    ZodPromise: $3ac1138541c1e4a8$export$3f196b0127d6e50a,
    ZodEffects: $3ac1138541c1e4a8$export$a60af00cc0ce2582,
    ZodTransformer: $3ac1138541c1e4a8$export$a60af00cc0ce2582,
    ZodOptional: $3ac1138541c1e4a8$export$aa56fec1e9d629b8,
    ZodNullable: $3ac1138541c1e4a8$export$aaac0b8b429cef5,
    ZodDefault: $3ac1138541c1e4a8$export$bb19b37874861e7e,
    ZodCatch: $3ac1138541c1e4a8$export$75a44ec6249ac76b,
    ZodNaN: $3ac1138541c1e4a8$export$26ccfa0145e8511f,
    BRAND: $3ac1138541c1e4a8$export$cf2deea74cde46b4,
    ZodBranded: $3ac1138541c1e4a8$export$66b0c798a395271f,
    ZodPipeline: $3ac1138541c1e4a8$export$a3c3ef8a0e95c6da,
    ZodReadonly: $3ac1138541c1e4a8$export$5d1f7ef05c4e493a,
    custom: $3ac1138541c1e4a8$export$4c00f665f0d4b443,
    Schema: $3ac1138541c1e4a8$export$19342e026b58ebb7,
    ZodSchema: $3ac1138541c1e4a8$export$19342e026b58ebb7,
    late: $3ac1138541c1e4a8$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $3ac1138541c1e4a8$export$558106ce543bd011;
    },
    coerce: $3ac1138541c1e4a8$export$8c14e57e778d3873,
    any: $3ac1138541c1e4a8$export$4154a199d7d90455,
    array: $3ac1138541c1e4a8$export$2f23118c22fb2630,
    bigint: $3ac1138541c1e4a8$export$a0f65b52274bcc00,
    boolean: $3ac1138541c1e4a8$export$4a21f16c33752377,
    date: $3ac1138541c1e4a8$export$324d90190a8b822a,
    discriminatedUnion: $3ac1138541c1e4a8$export$4b888e40c4ee26dd,
    effect: $3ac1138541c1e4a8$export$dc573d8a6576cdb3,
    "enum": $3ac1138541c1e4a8$export$78a99c8d44d72635,
    "function": $3ac1138541c1e4a8$export$44e51c8aac7c2deb,
    "instanceof": $3ac1138541c1e4a8$export$3d916e7c22dbd8b5,
    intersection: $3ac1138541c1e4a8$export$bc86dfbf7795668c,
    lazy: $3ac1138541c1e4a8$export$488013bae63b21da,
    literal: $3ac1138541c1e4a8$export$c8ec6e1ec9fefcb0,
    map: $3ac1138541c1e4a8$export$871de8747c9eaa88,
    nan: $3ac1138541c1e4a8$export$9e06de0973666692,
    nativeEnum: $3ac1138541c1e4a8$export$6fe7eca19ebe5199,
    never: $3ac1138541c1e4a8$export$b3e22bcfd64c1022,
    "null": $3ac1138541c1e4a8$export$7b1b591b262c240,
    nullable: $3ac1138541c1e4a8$export$133fc36489ac9add,
    number: $3ac1138541c1e4a8$export$98e628dec113755e,
    object: $3ac1138541c1e4a8$export$be5493f9613cbbe,
    oboolean: $3ac1138541c1e4a8$export$269251733cdcbbf1,
    onumber: $3ac1138541c1e4a8$export$eb150471a61fced6,
    optional: $3ac1138541c1e4a8$export$516e28dec6a4b6d4,
    ostring: $3ac1138541c1e4a8$export$3b3d07727c5b702c,
    pipeline: $3ac1138541c1e4a8$export$43f28b24e1eb8181,
    preprocess: $3ac1138541c1e4a8$export$fc37fe19dfda43ee,
    promise: $3ac1138541c1e4a8$export$c957ef27a0ebfd4,
    record: $3ac1138541c1e4a8$export$e5185e241753e543,
    set: $3ac1138541c1e4a8$export$adaa4cf7ef1b65be,
    strictObject: $3ac1138541c1e4a8$export$8fb0df5f40d0b477,
    string: $3ac1138541c1e4a8$export$22b082955e083ec3,
    symbol: $3ac1138541c1e4a8$export$8f701197936bc2a6,
    transformer: $3ac1138541c1e4a8$export$dc573d8a6576cdb3,
    tuple: $3ac1138541c1e4a8$export$65e3907585753458,
    "undefined": $3ac1138541c1e4a8$export$1db45310990710a5,
    union: $3ac1138541c1e4a8$export$971dd5b0dfd021b6,
    unknown: $3ac1138541c1e4a8$export$19282c40b967aec6,
    "void": $3ac1138541c1e4a8$export$490e536ee7389aeb,
    NEVER: $3ac1138541c1e4a8$export$96c94437c95d7862,
    ZodIssueCode: $3ac1138541c1e4a8$export$5ba560653e4a1035,
    quotelessJson: $3ac1138541c1e4a8$export$913eddeaf297cfea,
    ZodError: $3ac1138541c1e4a8$export$f98dac4b251ab333
});



var $gg0RY = parcelRequire("gg0RY");

var $lIeXU = parcelRequire("lIeXU");
const $127bdb6fa7571319$export$da23c760e8c3f755 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string().refine((value)=>(0, $gg0RY.isAddress)(value), {
    message: "Provided address is invalid."
});
const $127bdb6fa7571319$export$f10e648d9c9a3733 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string().refine((value)=>typeof (0, $lIeXU.normalize)(value) === "string" && value.endsWith(".eth"), {
    message: "Provided ENS name is invalid."
});
const $127bdb6fa7571319$export$989de960f8002cd0 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).union([
    $127bdb6fa7571319$export$da23c760e8c3f755,
    $127bdb6fa7571319$export$f10e648d9c9a3733
], {
    errorMap: ()=>({
            message: "Provided address or ENS name is invalid."
        })
});
var $127bdb6fa7571319$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["Bool"] = "bool";
    QuestionType["Datetime"] = "datetime";
    QuestionType["MultipleSelect"] = "multiple-select";
    QuestionType["SingleSelect"] = "single-select";
    QuestionType["Uint"] = "uint";
})($127bdb6fa7571319$export$51940fbbacba35d4 || ($127bdb6fa7571319$export$51940fbbacba35d4 = {}));
const $127bdb6fa7571319$export$8e820d60aff46da4 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).nativeEnum($127bdb6fa7571319$export$51940fbbacba35d4);
const $127bdb6fa7571319$export$155c9f408edfebb7 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).object({
    id: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string().regex(/^0x[0-9a-fA-F]+$/),
    title: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    description: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    reserved: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).boolean()
});
const $127bdb6fa7571319$export$1db2b41f01ccd47f = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).object({
    label: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    uri: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string()
});
const $127bdb6fa7571319$export$29ed9bdadd430dd3 = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).object({
    id: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string().optional(),
    name: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    address: $127bdb6fa7571319$export$989de960f8002cd0
});
const $127bdb6fa7571319$var$DisputeDetailsSchema = (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).object({
    title: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    description: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    question: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    type: $127bdb6fa7571319$export$8e820d60aff46da4,
    answers: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).array($127bdb6fa7571319$export$155c9f408edfebb7),
    policyURI: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    attachment: $127bdb6fa7571319$export$1db2b41f01ccd47f,
    frontendUrl: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    arbitrableChainID: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    arbitrableAddress: $127bdb6fa7571319$export$da23c760e8c3f755,
    arbitratorChainID: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    arbitratorAddress: $127bdb6fa7571319$export$da23c760e8c3f755,
    category: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    lang: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    specification: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string(),
    aliases: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).array($127bdb6fa7571319$export$29ed9bdadd430dd3).optional(),
    version: (0, $3ac1138541c1e4a8$export$2e2bcd8739ae039).string()
});
var $127bdb6fa7571319$export$2e2bcd8739ae039 = $127bdb6fa7571319$var$DisputeDetailsSchema;




const $fcf47cdff2645f12$var$isHexAddress = (str)=>/^0x[a-fA-F0-9]{40}$/.test(str);
const $fcf47cdff2645f12$var$isHexId = (str)=>/^0x[a-fA-F0-9]{1,64}$/.test(str);
const $fcf47cdff2645f12$export$a22775fa5e2eebd9 = (data)=>{
    return typeof data.title === "string" && typeof data.description === "string" && typeof data.question === "string" && Object.values((0, $127bdb6fa7571319$export$51940fbbacba35d4)).includes(data.type) && Array.isArray(data.answers) && data.answers.every((answer)=>typeof answer.title === "string" && typeof answer.description === "string" && $fcf47cdff2645f12$var$isHexId(answer.id) && typeof answer.reserved === "boolean") && typeof data.policyURI === "string" && typeof data.frontendUrl === "string" && typeof data.arbitrableChainID === "string" && $fcf47cdff2645f12$var$isHexAddress(data.arbitrableAddress) && typeof data.arbitratorChainID === "string" && $fcf47cdff2645f12$var$isHexAddress(data.arbitratorAddress) && typeof data.category === "string" && typeof data.lang === "string" && typeof data.specification === "string" && typeof data.version === "string";
};


const $494ad55946d84593$export$8ca9e0624083b7f1 = (mustacheTemplate, data)=>{
    const render = (0, (/*@__PURE__*/$parcel$interopDefault($3df1eb681e1fed2a$exports))).render(mustacheTemplate, data);
    console.log("MUSTACHE RENDER: ", render);
    const dispute = JSON.parse(render);
    // TODO: the validation below is too strict, it should be fixed, disabled for now, FIXME
    (0, $fcf47cdff2645f12$export$a22775fa5e2eebd9)(dispute);
    return dispute;
};










var $klW82 = parcelRequire("klW82");
var $cYDOa = parcelRequire("cYDOa");





const $677a6bae28c02395$export$446c261da684383 = (disputeID, arbitrableAddress)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(arbitrableAddress) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeID);
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `IsCrossChainDispute${disputeID}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (isEnabled) try {
                const arbitrable = (0, $f9a008fec395d7ff$export$94eedb953922a6a9)({
                    address: arbitrableAddress
                });
                const crossChainDisputeFilter = await arbitrable.createEventFilter.CrossChainDisputeIncoming({
                    _arbitratorDisputeID: BigInt(disputeID)
                }, {
                    fromBlock: (0, $203b613495c69c62$export$801be0cfa784af7b),
                    toBlock: "latest"
                });
                const crossChainDisputeEvents = await publicClient.getFilterLogs({
                    filter: crossChainDisputeFilter
                });
                if (crossChainDisputeEvents.length > 0) return {
                    isCrossChainDispute: true,
                    crossChainId: crossChainDisputeEvents[0].args._arbitrableChainId ?? 0n,
                    crossChainTemplateId: crossChainDisputeEvents[0].args._templateId ?? 0n,
                    crossChainArbitrableAddress: crossChainDisputeEvents[0].args._arbitrable ?? "0x"
                };
                else return {
                    isCrossChainDispute: false,
                    crossChainId: 0n,
                    crossChainTemplateId: 0n,
                    crossChainArbitrableAddress: "0x"
                };
            } catch (error) {
                if (error instanceof (0, $klW82.HttpRequestError) || error instanceof (0, $cYDOa.RpcError)) (0, $074a4e3f371abdca$export$18f70d5facb50d50)("RPC failed!, Please avoid voting.");
                throw Error;
            }
            else throw Error;
        }
    });
};


const $16b4cf141ce6646e$var$disputeTemplateQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query DisputeTemplate($id: ID!) {
    disputeTemplate(id: $id) {
      id
      templateTag
      templateData
      templateDataMappings
    }
  }
`);
const $16b4cf141ce6646e$export$731762ca72fd57e0 = (disputeID, arbitrableAddress)=>{
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const { data: crossChainData, isError: isError } = (0, $677a6bae28c02395$export$446c261da684383)(disputeID, arbitrableAddress);
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeID) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(crossChainData) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(arbitrableAddress);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `DisputeTemplate${disputeID}${arbitrableAddress}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (isEnabled && !isError) try {
                const { isCrossChainDispute: isCrossChainDispute, crossChainTemplateId: crossChainTemplateId } = crossChainData;
                const templateId = isCrossChainDispute ? crossChainTemplateId : await $16b4cf141ce6646e$var$getTemplateId(arbitrableAddress, disputeID, publicClient);
                const { disputeTemplate: disputeTemplate } = await graphqlBatcher.fetch({
                    id: crypto.randomUUID(),
                    document: $16b4cf141ce6646e$var$disputeTemplateQuery,
                    variables: {
                        id: templateId.toString()
                    },
                    isDisputeTemplate: true
                });
                const templateData = disputeTemplate?.templateData;
                const dataMappings = disputeTemplate?.templateDataMappings;
                const initialContext = {
                    disputeID: disputeID,
                    arbitrable: arbitrableAddress
                };
                const data = dataMappings ? await (0, $463e56179a7a7b53$export$43201cdb85c83f7e)(JSON.parse(dataMappings), initialContext) : {};
                const disputeDetails = (0, $494ad55946d84593$export$8ca9e0624083b7f1)(templateData, data);
                return disputeDetails;
            } catch (error) {
                if (error instanceof (0, $klW82.HttpRequestError) || error instanceof (0, $cYDOa.RpcError)) {
                    (0, $074a4e3f371abdca$export$18f70d5facb50d50)("RPC failed!, Please avoid voting.");
                    throw Error;
                }
                return {};
            }
            else throw Error;
        }
    });
};
const $16b4cf141ce6646e$var$getTemplateId = async (arbitrableAddress, disputeID, publicClient)=>{
    const arbitrable = (0, $f9a008fec395d7ff$export$67ef5ffb4cf48435)({
        address: arbitrableAddress
    });
    const disputeFilter = await arbitrable.createEventFilter.DisputeRequest({
        _arbitrableDisputeID: BigInt(disputeID)
    }, {
        fromBlock: (0, $203b613495c69c62$export$801be0cfa784af7b),
        toBlock: "latest"
    });
    const disputeEvents = await publicClient.getFilterLogs({
        filter: disputeFilter
    });
    return disputeEvents[0].args._templateId ?? 0n;
};



var $dup7A = parcelRequire("dup7A");
function $fee5256da5a38783$export$a86190deb5c4a8d0() {
    return Math.floor(Date.now() / 1000);
}
function $fee5256da5a38783$export$1d31b713ad66ffd4(deadline) {
    const currentTime = $fee5256da5a38783$export$a86190deb5c4a8d0();
    return Math.max(deadline - currentTime, 0);
}
function $fee5256da5a38783$export$727166c461d46c36(seconds) {
    const d = Math.floor(seconds / 86400);
    const h = Math.floor(seconds % 86400 / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${s}s`;
}
function $fee5256da5a38783$export$38a99e5511b052ac() {
    const currentTime = new Date().getTime() / 1000;
    return currentTime - 31536000; // One year in seconds
}
function $fee5256da5a38783$export$3ae94a2503e890a1(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    const options = {
        month: "long",
        day: "2-digit",
        year: "numeric"
    };
    return date.toLocaleDateString("en-US", options);
}



function $dde99d611beb8e78$export$8103f7eb37e19f7b(deadline) {
    const [counter, setCounter] = (0, $dup7A.useState)();
    (0, $dup7A.useEffect)(()=>{
        if (typeof deadline !== "undefined") {
            const timeLeft = (0, $fee5256da5a38783$export$1d31b713ad66ffd4)(deadline);
            setCounter(timeLeft);
        }
    }, [
        deadline
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(counter) && counter > 0) {
            const timeout = setTimeout(()=>setCounter(counter - 1), 1000);
            return ()=>clearTimeout(timeout);
        } else return;
    }, [
        counter
    ]);
    return counter;
}


const $efff76ebc0b7019d$export$7d08afb1cf7781e8 = (disputeKitDisputes)=>{
    return disputeKitDisputes?.reduce((acc, { localRounds: localRounds })=>acc.concat(localRounds), []);
};





const $b6510298c52fe164$export$7188bdcf89640f6b = (disputeID)=>{
    const klerosCore = (0, $f9a008fec395d7ff$export$b545a82fd08a2b5f)({});
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(klerosCore) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeID);
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `AppealCost${disputeID}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (!klerosCore || typeof disputeID === "undefined") return;
            return await klerosCore.read.appealCost([
                BigInt(disputeID)
            ]);
        }
    });
};





const $b8f2274cdcf8fc30$var$classicAppealQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query ClassicAppeal($disputeID: ID!, $orderBy: DisputeKitDispute_orderBy, $orderDirection: OrderDirection) {
    dispute(id: $disputeID) {
      period
      court {
        id
        timesPerPeriod
      }
      arbitrated {
        id
      }
      lastPeriodChange
      disputeKitDispute(orderBy: $orderBy, orderDirection: $orderDirection) {
        id
        currentLocalRoundIndex
        localRounds {
          ... on ClassicRound {
            winningChoice
            paidFees
            fundedChoices
          }
        }
      }
    }
  }
`);
const $b8f2274cdcf8fc30$export$3ab7625d2b199ebf = (id)=>{
    const isEnabled = id !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `classicAppealQuery${id}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>isEnabled ? await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $b8f2274cdcf8fc30$var$classicAppealQuery,
                variables: {
                    disputeID: id?.toString(),
                    orderBy: "timestamp",
                    orderDirection: "asc"
                }
            }) : undefined
    });
};





const $74939ad7f61ceffe$export$a599fe4be544eebc = ()=>{
    const disputeKitClassic = (0, $f9a008fec395d7ff$export$d0cf73d1ca7d3b33)({});
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeKitClassic);
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `DisputeKitClassicMultipliers`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (!disputeKitClassic) return;
            const winner_stake_multiplier = await disputeKitClassic.read.WINNER_STAKE_MULTIPLIER();
            const loser_stake_multiplier = await disputeKitClassic.read.LOSER_STAKE_MULTIPLIER();
            const loser_appeal_period_multiplier = await disputeKitClassic.read.LOSER_APPEAL_PERIOD_MULTIPLIER();
            return {
                winner_stake_multiplier: winner_stake_multiplier,
                loser_stake_multiplier: loser_stake_multiplier,
                loser_appeal_period_multiplier: loser_appeal_period_multiplier
            };
        }
    });
};


const $2d23f57cc17492cb$var$CountdownContext = /*#__PURE__*/ (0, $dup7A.createContext)({});
const $2d23f57cc17492cb$var$OptionsContext = /*#__PURE__*/ (0, $dup7A.createContext)(undefined);
const $2d23f57cc17492cb$var$SelectedOptionContext = /*#__PURE__*/ (0, $dup7A.createContext)({
    selectedOption: undefined,
    //eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedOption: ()=>{}
});
const $2d23f57cc17492cb$var$FundingContext = /*#__PURE__*/ (0, $dup7A.createContext)({
    winningChoice: undefined,
    paidFees: undefined,
    loserRequiredFunding: undefined,
    winnerRequiredFunding: undefined,
    fundedChoices: undefined
});
const $2d23f57cc17492cb$export$fe08c78aa7757dfb = ({ children: children })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $b8f2274cdcf8fc30$export$3ab7625d2b199ebf)(id);
    const dispute = data?.dispute;
    const paidFees = $2d23f57cc17492cb$var$getPaidFees(data?.dispute);
    const winningChoice = $2d23f57cc17492cb$var$getWinningChoice(data?.dispute);
    const { data: appealCost } = (0, $b6510298c52fe164$export$7188bdcf89640f6b)(id);
    const arbitrable = data?.dispute?.arbitrated.id;
    const { data: disputeDetails } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const { data: multipliers } = (0, $74939ad7f61ceffe$export$a599fe4be544eebc)();
    const options = [
        "Refuse to Arbitrate"
    ].concat(disputeDetails?.answers?.map((answer)=>{
        return answer.title;
    }));
    const loserSideCountdown = $2d23f57cc17492cb$var$useLoserSideCountdown(dispute?.lastPeriodChange, dispute?.court.timesPerPeriod[(0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal], multipliers?.loser_appeal_period_multiplier.toString());
    const winnerSideCountdown = $2d23f57cc17492cb$var$useWinnerSideCountdown(dispute?.lastPeriodChange, dispute?.court.timesPerPeriod[(0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal]);
    const { loserRequiredFunding: loserRequiredFunding, winnerRequiredFunding: winnerRequiredFunding } = (0, $dup7A.useMemo)(()=>({
            loserRequiredFunding: $2d23f57cc17492cb$export$fe4e86a62905e6e6(appealCost, multipliers?.loser_stake_multiplier),
            winnerRequiredFunding: $2d23f57cc17492cb$export$fe4e86a62905e6e6(appealCost, multipliers?.winner_stake_multiplier)
        }), [
        appealCost,
        multipliers
    ]);
    const fundedChoices = $2d23f57cc17492cb$var$getFundedChoices(data?.dispute);
    const [selectedOption, setSelectedOption] = (0, $dup7A.useState)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)($2d23f57cc17492cb$var$CountdownContext.Provider, {
        value: (0, $dup7A.useMemo)(()=>({
                loserSideCountdown: loserSideCountdown,
                winnerSideCountdown: winnerSideCountdown
            }), [
            loserSideCountdown,
            winnerSideCountdown
        ]),
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($2d23f57cc17492cb$var$SelectedOptionContext.Provider, {
            value: (0, $dup7A.useMemo)(()=>({
                    selectedOption: selectedOption,
                    setSelectedOption: setSelectedOption
                }), [
                selectedOption,
                setSelectedOption
            ]),
            children: /*#__PURE__*/ (0, $cZGFG.jsx)($2d23f57cc17492cb$var$FundingContext.Provider, {
                value: (0, $dup7A.useMemo)(()=>({
                        winningChoice: winningChoice,
                        paidFees: paidFees,
                        loserRequiredFunding: loserRequiredFunding,
                        winnerRequiredFunding: winnerRequiredFunding,
                        fundedChoices: fundedChoices
                    }), [
                    winningChoice,
                    paidFees,
                    loserRequiredFunding,
                    winnerRequiredFunding,
                    fundedChoices
                ]),
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($2d23f57cc17492cb$var$OptionsContext.Provider, {
                    value: options,
                    children: children
                })
            })
        })
    });
};
const $2d23f57cc17492cb$export$80f7497360a8ec61 = ()=>(0, $dup7A.useContext)($2d23f57cc17492cb$var$CountdownContext);
const $2d23f57cc17492cb$export$f1a5e4bb35f3011c = ()=>(0, $dup7A.useContext)($2d23f57cc17492cb$var$SelectedOptionContext);
const $2d23f57cc17492cb$export$ee36d0186d4ab735 = ()=>(0, $dup7A.useContext)($2d23f57cc17492cb$var$FundingContext);
const $2d23f57cc17492cb$export$47309e171cbac7d = ()=>(0, $dup7A.useContext)($2d23f57cc17492cb$var$OptionsContext);
const $2d23f57cc17492cb$var$getCurrentLocalRound = (dispute)=>{
    if (!dispute) return undefined;
    const period = dispute.period;
    const currentLocalRoundIndex = dispute.disputeKitDispute.at(-1)?.currentLocalRoundIndex;
    const adjustedRoundIndex = [
        "appeal",
        "execution"
    ].includes(period) ? currentLocalRoundIndex : currentLocalRoundIndex - 1;
    return (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(dispute.disputeKitDispute)[adjustedRoundIndex];
};
const $2d23f57cc17492cb$var$getPaidFees = (dispute)=>{
    const currentLocalRound = $2d23f57cc17492cb$var$getCurrentLocalRound(dispute);
    return currentLocalRound?.paidFees.map((amount)=>BigInt(amount));
};
const $2d23f57cc17492cb$var$getFundedChoices = (dispute)=>{
    const currentLocalRound = $2d23f57cc17492cb$var$getCurrentLocalRound(dispute);
    return currentLocalRound?.fundedChoices;
};
const $2d23f57cc17492cb$var$getWinningChoice = (dispute)=>{
    const currentLocalRound = $2d23f57cc17492cb$var$getCurrentLocalRound(dispute);
    return currentLocalRound?.winningChoice;
};
const $2d23f57cc17492cb$export$fe4e86a62905e6e6 = (appealCost = 0n, stake_multiplier = 0n)=>appealCost + stake_multiplier * appealCost / (0, $203b613495c69c62$export$ae4e5f23793d4e6f);
function $2d23f57cc17492cb$var$useLoserSideCountdown(lastPeriodChange = "0", appealPeriodDuration = "0", loserTimeMultiplier = "0") {
    const deadline = (0, $dup7A.useMemo)(()=>$2d23f57cc17492cb$var$getDeadline(lastPeriodChange, appealPeriodDuration, loserTimeMultiplier), [
        lastPeriodChange,
        appealPeriodDuration,
        loserTimeMultiplier
    ]);
    return (0, $dde99d611beb8e78$export$8103f7eb37e19f7b)(deadline);
}
function $2d23f57cc17492cb$var$useWinnerSideCountdown(lastPeriodChange = "0", appealPeriodDuration = "0") {
    const deadline = (0, $dup7A.useMemo)(()=>Number(BigInt(lastPeriodChange) + BigInt(appealPeriodDuration)), [
        lastPeriodChange,
        appealPeriodDuration
    ]);
    return (0, $dde99d611beb8e78$export$8103f7eb37e19f7b)(deadline);
}
const $2d23f57cc17492cb$var$getDeadline = (lastPeriodChange, appealPeriodDuration, loserTimeMultiplier)=>{
    const parsedLastPeriodChange = BigInt(lastPeriodChange);
    const parsedAppealPeriodDuration = BigInt(appealPeriodDuration);
    const parsedLoserTimeMultiplier = BigInt(loserTimeMultiplier);
    const loserAppealPeriodDuration = parsedAppealPeriodDuration * parsedLoserTimeMultiplier / (0, $203b613495c69c62$export$ae4e5f23793d4e6f);
    return Number(loserAppealPeriodDuration + parsedLastPeriodChange);
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $caf7f2a3b06f5c4a$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme: theme })=>theme.primaryBlue};

  &,
  & * {
    cursor: pointer;
  }

  &:hover {
    text-decoration: underline;
  }

  svg {
    path {
      fill: ${({ theme: theme })=>theme.primaryBlue};
    }
  }
`;
const $caf7f2a3b06f5c4a$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryBlue};
`;
const $caf7f2a3b06f5c4a$var$HowItWorks = ({ isMiniGuideOpen: isMiniGuideOpen, toggleMiniGuide: toggleMiniGuide, MiniGuideComponent: MiniGuideComponent })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($caf7f2a3b06f5c4a$var$Container, {
                onClick: toggleMiniGuide,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cd219089a705fca1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($caf7f2a3b06f5c4a$var$StyledLabel, {
                        children: " How it works "
                    })
                ]
            }),
            isMiniGuideOpen && /*#__PURE__*/ (0, $cZGFG.jsx)(MiniGuideComponent, {
                toggleMiniGuide: toggleMiniGuide
            })
        ]
    });
};
var $caf7f2a3b06f5c4a$export$2e2bcd8739ae039 = $caf7f2a3b06f5c4a$var$HowItWorks;




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

var $93ea86fa2a6263ff$var$useIsomorphicLayoutEffect = (0, $226407d615d776bb$export$4e09c449d6c407f7) ? (0, $dup7A.useLayoutEffect) : (0, $dup7A.useEffect);
var $93ea86fa2a6263ff$export$2e2bcd8739ae039 = $93ea86fa2a6263ff$var$useIsomorphicLayoutEffect;



var $e04315e4fe952dbf$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $e04315e4fe952dbf$var$useMeasure() {
    var _a = (0, $dup7A.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0, $dup7A.useState)($e04315e4fe952dbf$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0, $dup7A.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, $93ea86fa2a6263ff$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
var $e04315e4fe952dbf$export$2e2bcd8739ae039 = (0, $226407d615d776bb$export$4e09c449d6c407f7) && typeof window.ResizeObserver !== "undefined" ? $e04315e4fe952dbf$var$useMeasure : function() {
    return [
        (0, $226407d615d776bb$export$8793edee2d425525),
        $e04315e4fe952dbf$var$defaultState
    ];
};



var $3Szoa = parcelRequire("3Szoa");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $55843eac53582e9c$var$SvgGavel = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m11.835 5.173-.53-.53a.562.562 0 0 0-.796 0l-.132.132-2.652-2.652.133-.132a.562.562 0 0 0 0-.796l-.53-.53a.562.562 0 0 0-.796 0L3.615 3.582a.562.562 0 0 0 0 .795l.53.53c.22.22.576.22.796 0l.133-.132.928.928-1.9 1.9-.132-.133a.75.75 0 0 0-1.061 0l-2.69 2.689a.75.75 0 0 0 0 1.06L1.28 12.28a.75.75 0 0 0 1.061 0l2.69-2.689a.75.75 0 0 0 0-1.06l-.133-.133 1.9-1.9.927.928-.132.133a.562.562 0 0 0 0 .796l.53.53c.22.22.576.22.795 0l2.917-2.917a.562.562 0 0 0 0-.795Z"
        })
    });
var $55843eac53582e9c$export$2e2bcd8739ae039 = $55843eac53582e9c$var$SvgGavel;



const $d680dc0e2fb89895$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  padding: 24px;
  &:hover {
    cursor: pointer;
  }
`;
const $d680dc0e2fb89895$var$WinnerLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme, winner: winner })=>winner ? theme.success : theme.warning};
  svg {
    width: 12px;
    margin-right: 8px;
    fill: ${({ theme: theme, winner: winner })=>winner ? theme.success : theme.warning};
  }
`;
const $d680dc0e2fb89895$var$StyledRadio = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Radio))`
  padding-left: 24px;
  > input {
    display: none;
  }
`;
const $d680dc0e2fb89895$var$TopContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  height: 50%;
  .block {
    display: block;
  }
`;
const $d680dc0e2fb89895$var$LabelContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const $d680dc0e2fb89895$var$OptionCard = ({ text: text, funding: funding, required: required, winner: winner, selected: selected, canBeSelected: canBeSelected = true, ...props })=>{
    const [ref, { width: width }] = (0, $e04315e4fe952dbf$export$2e2bcd8739ae039)();
    const [fundingLabel, progress] = (0, $dup7A.useMemo)(()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(required)) {
            if (funding >= required) return [
                "Fully funded!",
                100
            ];
            else return [
                `${(0, $3Szoa.formatEther)(funding)} out of ${(0, $3Szoa.formatEther)(required)} ETH required.`,
                Number(funding * 100n / required)
            ];
        } else if (funding > 0n) return [
            `Funded with ${(0, $3Szoa.formatEther)(funding)} ETH.`,
            30
        ];
        else return [
            "0 ETH contributed to this option",
            0
        ];
    }, [
        funding,
        required
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($d680dc0e2fb89895$var$StyledCard, {
        ref: ref,
        hover: true,
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($d680dc0e2fb89895$var$TopContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                                className: "block",
                                children: text
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($d680dc0e2fb89895$var$WinnerLabel, {
                                winner: winner ? true : false,
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $55843eac53582e9c$export$2e2bcd8739ae039), {}),
                                    "Jury decision - ",
                                    winner ? "Winner" : "Loser"
                                ]
                            })
                        ]
                    }),
                    canBeSelected && /*#__PURE__*/ (0, $cZGFG.jsx)($d680dc0e2fb89895$var$StyledRadio, {
                        label: "",
                        checked: selected
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($d680dc0e2fb89895$var$LabelContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                    children: fundingLabel
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.LinearProgress), {
                progress: progress,
                width: width
            })
        ]
    });
};
var $d680dc0e2fb89895$export$2e2bcd8739ae039 = $d680dc0e2fb89895$var$OptionCard;



const $9f4d34c1daa7ab6d$var$OptionsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 12px;
`;
const $9f4d34c1daa7ab6d$var$AppealHistory = ({ isAppealMiniGuideOpen: isAppealMiniGuideOpen, toggleAppealMiniGuide: toggleAppealMiniGuide })=>{
    const options = (0, $2d23f57cc17492cb$export$47309e171cbac7d)();
    const { winningChoice: winningChoice, paidFees: paidFees, fundedChoices: fundedChoices } = (0, $2d23f57cc17492cb$export$ee36d0186d4ab735)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $722961e830929345$export$e741d7929ebaa468), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $722961e830929345$export$48331a7adc9a636b), {
                        children: "Appeal Results - Last Round"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                        isMiniGuideOpen: isAppealMiniGuideOpen,
                        toggleMiniGuide: toggleAppealMiniGuide,
                        MiniGuideComponent: (0, $b1c183e8436a370c$export$2e2bcd8739ae039)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($9f4d34c1daa7ab6d$var$OptionsContainer, {
                children: options ? options.map((option, index)=>{
                    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d680dc0e2fb89895$export$2e2bcd8739ae039), {
                        text: option,
                        winner: index.toString() === winningChoice,
                        funding: BigInt(paidFees?.[index] ?? "0"),
                        required: fundedChoices?.includes(index.toString()) ? BigInt(paidFees?.[index] ?? "0") : undefined,
                        canBeSelected: false
                    }, option + index);
                }) : /*#__PURE__*/ (0, $cZGFG.jsx)("h2", {
                    children: "Not in appeal period"
                })
            })
        ]
    });
};
var $9f4d34c1daa7ab6d$export$2e2bcd8739ae039 = $9f4d34c1daa7ab6d$var$AppealHistory;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $f532bf5525802986$var$SvgAppeal = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 350 350",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M326.109 87.5 174.554 0 23 87.5v175L174.554 350l151.555-87.5v-175Zm-18.468 10.473L174.435 21.066 41.228 97.973v153.813l133.207 76.907 133.206-76.907V97.973Z",
                fill: "#F0F9FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m174.435 21.066 133.206 76.907v153.813l-133.206 76.907-133.207-76.907V97.973l133.207-76.907Z",
                fill: "#7E1BD4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m290.662 261.589-116.227 67.104-115.989-66.966v-47.706h232.216v47.568Z",
                fill: "#973AE8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M139.093 254.796h-9.272l-2.412 5.26h-3.521l10.716-23.019 10.339 23.019h-3.577l-2.273-5.26Zm-1.332-3.072-3.213-7.365-3.366 7.365h6.579Zm13.157-.463v8.795h-3.268v-21.658h3.703c1.814 0 3.184.126 4.11.378.935.253 1.758.73 2.469 1.431 1.244 1.216 1.865 2.75 1.865 4.601 0 1.983-.664 3.554-1.991 4.713-1.328 1.16-3.119 1.74-5.373 1.74h-1.515Zm0-3.03h1.221c3.001 0 4.502-1.155 4.502-3.465 0-2.235-1.547-3.352-4.643-3.352h-1.08v6.817Zm15.514 3.03v8.795h-3.268v-21.658h3.703c1.814 0 3.184.126 4.11.378.935.253 1.758.73 2.469 1.431 1.244 1.216 1.866 2.75 1.866 4.601 0 1.983-.664 3.554-1.992 4.713-1.328 1.16-3.119 1.74-5.373 1.74h-1.515Zm0-3.03h1.221c3.002 0 4.502-1.155 4.502-3.465 0-2.235-1.547-3.352-4.643-3.352h-1.08v6.817Zm24.197-6.761h-8.683v5.204h8.431v3.072h-8.431v7.238h8.683v3.072h-11.951v-21.658h11.951v3.072Zm17.015 13.326h-9.272l-2.412 5.26h-3.521l10.717-23.019 10.338 23.019h-3.577l-2.273-5.26Zm-1.332-3.072-3.213-7.365-3.366 7.365h6.579Zm13.157-13.326v18.586h6.369v3.072h-9.637v-21.658h3.268Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M117.316 90.398c-3.93 0-6.988.84-9.171 2.519-2.111 1.606-3.167 4.344-3.167 8.214 0 1.752.364 3.248 1.092 4.49a11.467 11.467 0 0 0 2.73 3.175 17.048 17.048 0 0 0 3.931 2.191c1.528.511 3.057.949 4.585 1.314V90.398Zm-13.975 46.434c-.073 4.818.982 8.615 3.166 11.389 2.184 2.775 5.787 4.235 10.809 4.381V126.1a106.263 106.263 0 0 1-8.953-2.848c-2.911-1.168-5.568-2.628-7.97-4.38-2.33-1.826-4.222-4.089-5.678-6.79-1.456-2.701-2.184-6.06-2.184-10.075 0-3.505.656-6.571 1.966-9.2 1.383-2.7 3.203-4.928 5.459-6.68 2.329-1.825 4.986-3.212 7.97-4.161 2.985-.95 6.115-1.424 9.39-1.424V72h4.695v8.542c3.276 0 6.369.438 9.281 1.314 2.911.876 5.423 2.19 7.533 3.943 2.184 1.752 3.895 3.979 5.132 6.68 1.31 2.701 1.965 5.84 1.965 9.418h-12.447c-.145-3.723-1.128-6.57-2.948-8.542-1.746-1.971-4.585-2.957-8.516-2.957v23.108c3.276.876 6.478 1.898 9.608 3.066 3.13 1.168 5.896 2.665 8.298 4.49 2.402 1.825 4.331 4.088 5.787 6.79 1.456 2.701 2.184 6.023 2.184 9.965 0 4.089-.692 7.666-2.075 10.733-1.31 2.993-3.13 5.512-5.459 7.556-2.329 1.971-5.059 3.468-8.189 4.49-3.13 1.095-6.514 1.716-10.154 1.862V171h-4.695v-8.542c-3.93-.073-7.533-.694-10.809-1.862-3.275-1.168-6.078-2.811-8.407-4.928-2.33-2.19-4.15-4.855-5.46-7.994-1.237-3.14-1.819-6.754-1.746-10.842h12.447Zm18.67 15.77c3.931-.292 7.133-1.424 9.608-3.395 2.548-2.044 3.822-5.257 3.822-9.637 0-2.045-.401-3.76-1.201-5.147a10.051 10.051 0 0 0-3.057-3.505c-1.238-.949-2.657-1.716-4.259-2.3a54.83 54.83 0 0 0-4.913-1.533v25.517ZM228.316 133.398c-3.93 0-6.988.84-9.171 2.519-2.111 1.606-3.167 4.344-3.167 8.214 0 1.752.364 3.248 1.092 4.49a11.467 11.467 0 0 0 2.73 3.175 17.048 17.048 0 0 0 3.931 2.191c1.528.511 3.057.949 4.585 1.314v-21.903Zm-13.975 46.434c-.073 4.818.982 8.615 3.166 11.389 2.184 2.775 5.787 4.235 10.809 4.381V169.1a106.263 106.263 0 0 1-8.953-2.848c-2.911-1.168-5.568-2.628-7.97-4.38-2.33-1.826-4.222-4.089-5.678-6.79-1.456-2.701-2.183-6.06-2.183-10.075 0-3.505.655-6.571 1.965-9.199 1.383-2.702 3.203-4.929 5.459-6.681 2.329-1.825 4.986-3.212 7.97-4.161 2.985-.949 6.115-1.424 9.39-1.424V115h4.695v8.542c3.276 0 6.369.438 9.281 1.314 2.911.876 5.423 2.19 7.533 3.943 2.184 1.752 3.895 3.979 5.132 6.68 1.31 2.701 1.965 5.841 1.965 9.418h-12.447c-.145-3.723-1.128-6.571-2.948-8.542-1.746-1.971-4.585-2.957-8.516-2.957v23.108c3.276.876 6.478 1.898 9.608 3.066 3.13 1.168 5.896 2.665 8.298 4.49 2.402 1.825 4.331 4.088 5.787 6.79 1.456 2.701 2.184 6.023 2.184 9.965 0 4.089-.692 7.666-2.075 10.733-1.31 2.993-3.13 5.512-5.459 7.556-2.329 1.971-5.059 3.468-8.189 4.49-3.13 1.095-6.514 1.716-10.154 1.862V214h-4.695v-8.542c-3.93-.073-7.533-.694-10.809-1.862-3.275-1.168-6.078-2.811-8.407-4.928-2.329-2.19-4.149-4.855-5.459-7.994-1.238-3.14-1.82-6.754-1.747-10.842h12.447Zm18.67 15.77c3.931-.292 7.133-1.424 9.608-3.395 2.548-2.044 3.822-5.257 3.822-9.637 0-2.045-.401-3.76-1.201-5.147a10.051 10.051 0 0 0-3.057-3.505c-1.238-.949-2.657-1.716-4.259-2.3a54.83 54.83 0 0 0-4.913-1.533v25.517Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M121.888 172.91v8.84c0 7.308 17.636 13.25 39.375 13.25 21.738 0 39.375-5.942 39.375-13.25v-8.84c-8.47 6.024-23.953 8.84-39.375 8.84s-30.906-2.816-39.375-8.84Zm65.625-57.41c21.738 0 39.375-5.942 39.375-13.25S209.251 89 187.513 89c-21.739 0-39.375 5.942-39.375 13.25s17.636 13.25 39.375 13.25Zm-65.625 35.692v10.683c0 7.308 17.636 13.25 39.375 13.25 21.738 0 39.375-5.942 39.375-13.25v-10.683c-8.47 7.039-23.974 10.683-39.375 10.683-15.402 0-30.906-3.644-39.375-10.683Zm85.312 2.278c11.751-2.299 19.688-6.563 19.688-11.47v-8.84c-4.758 3.395-11.751 5.714-19.688 7.142v13.168Zm-45.937-31.345c-21.739 0-39.375 7.412-39.375 16.563 0 9.15 17.636 16.562 39.375 16.562 21.738 0 39.375-7.412 39.375-16.562 0-9.151-17.637-16.563-39.375-16.563Zm44.973 11.656c12.305-2.236 20.652-6.625 20.652-11.656v-8.84c-7.281 5.196-19.79 7.991-32.956 8.654 6.049 2.96 10.5 6.935 12.304 11.842Z",
                fill: "#fff"
            })
        ]
    });
var $f532bf5525802986$export$2e2bcd8739ae039 = $f532bf5525802986$var$SvgAppeal;






var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $4e6021079d8dfe2c$var$SvgClose = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M12.903 11.066 9.226 7.389l3.637-3.636a1.15 1.15 0 0 0-.009-1.625l-.817-.817a1.15 1.15 0 0 0-1.625-.01L6.775 4.939 3.1 1.262a1.15 1.15 0 0 0-1.625-.01l-.808.809a1.15 1.15 0 0 0 .009 1.625L4.35 7.363.714 10.999a1.15 1.15 0 0 0 .01 1.625l.816.817a1.15 1.15 0 0 0 1.626.01l3.636-3.637 3.677 3.676a1.15 1.15 0 0 0 1.625.009l.808-.808a1.15 1.15 0 0 0-.01-1.625Z"
        })
    });
var $4e6021079d8dfe2c$export$2e2bcd8739ae039 = $4e6021079d8dfe2c$var$SvgClose;






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $eeab06c27b99c840$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $eeab06c27b99c840$var$StyledAmountFunded = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
`;
const $eeab06c27b99c840$var$StyledOptionFunded = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32, 300)};
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
`;
const $eeab06c27b99c840$var$AmountContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $eeab06c27b99c840$var$OptionContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $eeab06c27b99c840$var$Appeal = ({ amount: amount, option: option })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($eeab06c27b99c840$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($eeab06c27b99c840$var$StyledAmountFunded, {
                children: [
                    "You have funded: \xa0",
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($eeab06c27b99c840$var$AmountContainer, {
                        children: [
                            amount,
                            " ETH"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($eeab06c27b99c840$var$StyledOptionFunded, {
                children: [
                    "Option funded: \xa0",
                    /*#__PURE__*/ (0, $cZGFG.jsx)($eeab06c27b99c840$var$OptionContainer, {
                        children: option
                    })
                ]
            })
        ]
    });
};
var $eeab06c27b99c840$export$2e2bcd8739ae039 = $eeab06c27b99c840$var$Appeal;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





const $6c35bcc70e144cdf$var$courtDetailsQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query CourtDetails($id: ID!) {
    court(id: $id) {
      policy
      minStake
      alpha
      numberDisputes
      numberClosedDisputes
      numberAppealingDisputes
      numberStakedJurors
      stake
      paidETH
      paidPNK
      timesPerPeriod
    }
  }
`);
const $6c35bcc70e144cdf$export$cac3085b56a3ca27 = (id)=>{
    const isEnabled = id !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `courtDetails${id}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $6c35bcc70e144cdf$var$courtDetailsQuery,
                variables: {
                    id: id
                }
            })
    });
};





const $e82cdc6ebfd19ca7$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const $e82cdc6ebfd19ca7$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
`;
const $e82cdc6ebfd19ca7$var$StyledDateContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).span`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $e82cdc6ebfd19ca7$var$StyledSubtitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)($e82cdc6ebfd19ca7$var$StyledTitle)`
  margin-top: 24px;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $e82cdc6ebfd19ca7$var$DisputeCreated = ({ courtId: courtId })=>{
    const { data: courtDetails } = (0, $6c35bcc70e144cdf$export$cac3085b56a3ca27)(courtId);
    const date = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(courtDetails?.court?.timesPerPeriod) ? $e82cdc6ebfd19ca7$var$calculateMinResolveTime(courtDetails?.court.timesPerPeriod) : undefined, [
        courtDetails
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($e82cdc6ebfd19ca7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($e82cdc6ebfd19ca7$var$StyledTitle, {
                children: [
                    "\uD83C\uDF89 Your case was successfully submitted to Kleros. A pool of jurors will be drawn to evaluate the case and vote at most",
                    " ",
                    (0, $2d857633ba67aa25$export$fce6876652108ab)(date) ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                        width: 60,
                        height: 20
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($e82cdc6ebfd19ca7$var$StyledDateContainer, {
                        children: (0, $fee5256da5a38783$export$3ae94a2503e890a1)(date)
                    }),
                    ". \uD83C\uDF89"
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($e82cdc6ebfd19ca7$var$StyledSubtitle, {
                children: "Now, it\u2019s time to submit evidence to support the case."
            })
        ]
    });
};
const $e82cdc6ebfd19ca7$var$calculateMinResolveTime = (timesPerPeriod)=>timesPerPeriod.reduce((acc, val)=>acc + parseInt(val), 0) + (0, $fee5256da5a38783$export$a86190deb5c4a8d0)();
var $e82cdc6ebfd19ca7$export$2e2bcd8739ae039 = $e82cdc6ebfd19ca7$var$DisputeCreated;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $64f6a7931e9828e8$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m14.094 3 24.135 1.079L48 25.794 34.215 45.641 9.948 44.086 0 20.558 14.094 3Zm17.694 12.517-17.492 7.644L29.25 34.726l2.538-19.209Zm-2.025-3.83-13.979-6.02-2.936 12.657 16.915-6.637ZM26.22 37.635l-15.192-10.85.367 14.703 14.825-3.853Zm19.353-11.889L35.221 15.24l-2.733 20.205 13.085-9.698ZM29.782 40l-12.813 3.35 15.067.964L29.782 40Zm13.768-9.485L32.335 38.87l2.228 4.356 8.987-12.712ZM38.245 7.113l-2.178 4.473 8.108 8.244-5.93-12.717Zm-2.714-2.14-14.238-.578 11.745 5.138 2.493-4.56ZM12.014 7.04 2.042 19.637l6.667 1.412 3.306-14.008Zm-3.707 16.48-6.7-1.42 6.991 16.473-.29-15.054Z",
            fill: "#9013FE"
        })
    });
var $64f6a7931e9828e8$export$2e2bcd8739ae039 = $64f6a7931e9828e8$var$SvgKleros;



var $lTCHO = parcelRequire("lTCHO");




const $a46e5de0f000eb48$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $a46e5de0f000eb48$var$StyledKlerosLogo = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $64f6a7931e9828e8$export$2e2bcd8739ae039))`
  width: 14px;
  height: 14px;
`;
const $a46e5de0f000eb48$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32, 300)};
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
`;
const $a46e5de0f000eb48$var$AmountStakedOrWithdrawnContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.secondaryPurple};
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(0, 4, 300)};
`;
const $a46e5de0f000eb48$var$TotalStakeContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32, 300)};
`;
const $a46e5de0f000eb48$var$MyStakeContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin: 0px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(4, 8, 300)};
  color: ${({ theme: theme })=>theme.secondaryText};
`;
const $a46e5de0f000eb48$var$AmountContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $a46e5de0f000eb48$var$AmountStakedOrWithdrawn = ({ pnkStaked: pnkStaked, isStake: isStake })=>{
    return isStake ? /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            "+ ",
            pnkStaked,
            " PNK"
        ]
    }) : /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            "- ",
            pnkStaked,
            " PNK"
        ]
    });
};
const $a46e5de0f000eb48$var$StakeWithdraw = ({ pnkStaked: pnkStaked, courtName: courtName, isStake: isStake, courtId: courtId })=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: jurorBalance } = (0, $f9a008fec395d7ff$export$95ba38bd72119500)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(courtId),
        args: [
            address,
            BigInt(courtId)
        ],
        watch: true
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($a46e5de0f000eb48$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($a46e5de0f000eb48$var$StyledTitle, {
                children: [
                    "\uD83C\uDF89 Your ",
                    isStake ? "stake" : "unstake",
                    " in the ",
                    courtName,
                    " court was successful! \uD83C\uDF89"
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($a46e5de0f000eb48$var$AmountStakedOrWithdrawnContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($a46e5de0f000eb48$var$AmountStakedOrWithdrawn, {
                    pnkStaked: pnkStaked,
                    isStake: isStake
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($a46e5de0f000eb48$var$TotalStakeContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($a46e5de0f000eb48$var$StyledKlerosLogo, {}),
                    " ",
                    /*#__PURE__*/ (0, $cZGFG.jsx)($a46e5de0f000eb48$var$MyStakeContainer, {
                        children: "My Stake:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($a46e5de0f000eb48$var$AmountContainer, {
                        children: [
                            `${(0, $lTCHO.formatUnits)(jurorBalance?.[2] ?? BigInt(0), 18)} PNK`,
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
var $a46e5de0f000eb48$export$2e2bcd8739ae039 = $a46e5de0f000eb48$var$StakeWithdraw;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $10816031b51eb42d$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#arrow_svg__a)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m6.516 1.803.792-.784a.86.86 0 0 1 1.211 0l6.942 6.863a.838.838 0 0 1 0 1.197L8.52 15.946a.86.86 0 0 1-1.21 0l-.793-.784a.842.842 0 0 1 .014-1.212l4.303-4.055H.57a.85.85 0 0 1-.857-.848v-1.13a.85.85 0 0 1 .857-.848h10.263L6.53 3.014a.836.836 0 0 1-.014-1.211Z",
                    fill: "#009AFF"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "arrow_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .482)",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $10816031b51eb42d$export$2e2bcd8739ae039 = $10816031b51eb42d$var$SvgArrow;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $1c6ccabd2857ef46$var$SvgPnk = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('da56905891301d06')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m8.904 5.438 7.543.337L19.5 12.56l-4.308 6.202-7.583-.486L4.5 10.924l4.404-5.486Zm5.53 3.911-5.466 2.389 4.673 3.614.793-6.003ZM13.8 8.152 9.433 6.271l-.918 3.955L13.8 8.152Zm-1.107 8.11L7.946 12.87l.115 4.595 4.633-1.204Zm6.048-3.716-3.236-3.284-.853 6.314 4.089-3.03ZM13.807 17l-4.004 1.046 4.708.302L13.807 17Zm4.303-2.964-3.505 2.61.696 1.362 2.809-3.972Zm-1.658-7.313L15.77 8.12l2.534 2.576-1.853-3.974Zm-.849-.669-4.449-.18 3.67 1.605.78-1.425ZM8.256 6.7l-3.117 3.936 2.084.442L8.255 6.7Zm-1.159 5.15-2.094-.443 2.185 5.147-.091-4.704Z",
                    fill: "#fff"
                })
            })
        ]
    });
var $1c6ccabd2857ef46$export$2e2bcd8739ae039 = $1c6ccabd2857ef46$var$SvgPnk;




const $8dd8bb4d6b71400d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 32px;
  gap: 24px;
`;
const $8dd8bb4d6b71400d$var$AmountContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  height: fit-content;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $8dd8bb4d6b71400d$var$SVGContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(30, 50)};
  height: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(30, 50)};
`;
const $8dd8bb4d6b71400d$var$Amount = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  color: ${({ theme: theme })=>theme.secondaryPurple};
  font-size: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 64)};
  margin: 0px;
`;
const $8dd8bb4d6b71400d$var$Subtitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
`;
const $8dd8bb4d6b71400d$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d86601acd95afa87$export$2e2bcd8739ae039))`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  > .button-text {
    color: ${({ theme: theme })=>theme.primaryBlue};
  }
  padding-top: 0px;
`;
const $8dd8bb4d6b71400d$var$Divider = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).hr`
  width: 100%;
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 64)} 0px 0px;
`;
const $8dd8bb4d6b71400d$var$SwapSuccess = ({ hash: hash, amount: amount, isClaim: isClaim, from: from, to: to })=>{
    const baseUrl = `https://sepolia.arbiscan.io/tx/${hash}`;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($8dd8bb4d6b71400d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($8dd8bb4d6b71400d$var$AmountContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($8dd8bb4d6b71400d$var$Amount, {
                        children: [
                            amount,
                            " PNK"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($8dd8bb4d6b71400d$var$SVGContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1c6ccabd2857ef46$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            isClaim ? /*#__PURE__*/ (0, $cZGFG.jsxs)($8dd8bb4d6b71400d$var$Subtitle, {
                children: [
                    "Claimed: ",
                    amount,
                    " PNK (Testnet)"
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($8dd8bb4d6b71400d$var$Subtitle, {
                children: [
                    "Bridge from \xa0",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: "Ethereum"
                    }),
                    "\xa0 to \xa0",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: "Arbitrum"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($8dd8bb4d6b71400d$var$Divider, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($8dd8bb4d6b71400d$var$StyledButton, {
                onClick: ()=>window.open(baseUrl, "_blank", "rel=noopener noreferrer"),
                text: "View transaction on Etherscan",
                Icon: (0, $10816031b51eb42d$export$2e2bcd8739ae039)
            })
        ]
    });
};
var $8dd8bb4d6b71400d$export$2e2bcd8739ae039 = $8dd8bb4d6b71400d$var$SwapSuccess;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $72d12359378c3fe5$var$VoteWithCommit = ({ date: date })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            "Your vote is confirmed. It's kept secret until all jurors have cast their votes.",
            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $6d5b5828a9c61872$export$5b577f77a1607573), {
                children: [
                    "You'll need to justify and reveal your vote on ",
                    date
                ]
            })
        ]
    });
};
var $72d12359378c3fe5$export$2e2bcd8739ae039 = $72d12359378c3fe5$var$VoteWithCommit;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $1c500df907cc6bb1$var$VoteWithoutCommit = ({ date: date })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            "The decision date is ",
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$5b577f77a1607573), {
                children: date
            }),
            " with the possibility for appeals. After that time you will be informed about the jury decision."
        ]
    });
};
var $1c500df907cc6bb1$export$2e2bcd8739ae039 = $1c500df907cc6bb1$var$VoteWithoutCommit;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $93359eba1a140767$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
`;
const $93359eba1a140767$var$DisputeCreatedExtraInfo = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($93359eba1a140767$var$Container, {
        children: "In order to better track the case progress, we recommend you to subscribe to notifications: Settings > Notifications"
    });
};
var $93359eba1a140767$export$2e2bcd8739ae039 = $93359eba1a140767$var$DisputeCreatedExtraInfo;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $3e6992c85b7b56be$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24, 300)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 44, 300)};
`;
const $3e6992c85b7b56be$var$StakeWithdrawExtraInfo = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3e6992c85b7b56be$var$Container, {
        children: "In order not to miss when you're drawn for cases, make sure to subscribe to notifications: Settings > Notifications"
    });
};
var $3e6992c85b7b56be$export$2e2bcd8739ae039 = $3e6992c85b7b56be$var$StakeWithdrawExtraInfo;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $e39f04ba9ee6a9f1$var$SvgInfoCircle = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url(#info-circle_svg__a)",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z",
                    fill: "#6CC5FF"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "info-circle_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $e39f04ba9ee6a9f1$export$2e2bcd8739ae039 = $e39f04ba9ee6a9f1$var$SvgInfoCircle;



const $83d1c59f988e57d7$var$InfoContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 16px auto;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(6, 8, 300)};
  align-items: center;
  justify-items: start;
  text-align: start;
  color: ${({ theme: theme })=>theme.secondaryText};
`;
const $83d1c59f988e57d7$var$InfoCard = ({ msg: msg, className: className })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($83d1c59f988e57d7$var$InfoContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e39f04ba9ee6a9f1$export$2e2bcd8739ae039), {}),
            msg
        ]
    });
};
var $83d1c59f988e57d7$export$2e2bcd8739ae039 = $83d1c59f988e57d7$var$InfoCard;


const $f6be6417fb572142$var$StyledInfoCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $83d1c59f988e57d7$export$2e2bcd8739ae039))`
  margin: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24, 300)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32, 300)} 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
`;
const $f6be6417fb572142$var$VoteWithCommitExtraInfo = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($f6be6417fb572142$var$StyledInfoCard, {
        msg: "Subscribe to receive notifications to be reminded when the reveal time comes."
    });
};
var $f6be6417fb572142$export$2e2bcd8739ae039 = $f6be6417fb572142$var$VoteWithCommitExtraInfo;


const $6d5b5828a9c61872$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  display: flex;
  margin: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 32)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 12)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 24)};
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.68px;
`;
const $6d5b5828a9c61872$var$IconContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(150, 228)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: inline-block;
    width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(150, 228)};
    height: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(150, 228)};
  }
`;
const $6d5b5828a9c61872$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  margin: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $6d5b5828a9c61872$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 80vh;
  overflow-y: auto;

  z-index: 10;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 86vw;
  max-width: 600px;
  border-radius: 3px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);

  svg {
    visibility: visible;
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      overflow-y: hidden;
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(300, 600)};
    `)}
`;
const $6d5b5828a9c61872$var$VoteDescriptionContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  margin-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32)};
  margin-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32)};
  color: ${({ theme: theme })=>theme.secondaryText};
  text-align: center;
  line-height: 21.8px;
`;
const $6d5b5828a9c61872$var$SVGContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  cursor: pointer;
  position: absolute;
  top: 18px;
  right: 24px;
  svg {
    width: 18px;
    height: 18px;
    fill: ${({ theme: theme })=>theme.stroke};
  }
`;
const $6d5b5828a9c61872$export$5b577f77a1607573 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).span`
  font-size: 16px;
  font-weight: 400;
  line-height: 21.8px;
  color: ${({ theme: theme })=>theme.primaryText};
`;
var $6d5b5828a9c61872$export$9656cfe2bd6e411f;
(function(PopupType) {
    PopupType["STAKE_WITHDRAW"] = "STAKE_WITHDRAW";
    PopupType["APPEAL"] = "APPEAL";
    PopupType["VOTE_WITHOUT_COMMIT"] = "VOTE_WITHOUT_COMMIT";
    PopupType["VOTE_WITH_COMMIT"] = "VOTE_WITH_COMMIT";
    PopupType["DISPUTE_CREATED"] = "DISPUTE_CREATED";
    PopupType["SWAP_SUCCESS"] = "SWAP_SUCCESS";
})($6d5b5828a9c61872$export$9656cfe2bd6e411f || ($6d5b5828a9c61872$export$9656cfe2bd6e411f = {}));
const $6d5b5828a9c61872$var$Popup = ({ title: title, icon: Icon, popupType: popupType, setIsOpen: setIsOpen, setAmount: setAmount, isCommit: isCommit, ...props })=>{
    const containerRef = (0, $dup7A.useRef)(null);
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const resetValue = ()=>{
        if (setAmount) setAmount("");
    };
    let PopupComponent = null;
    switch(popupType){
        case "STAKE_WITHDRAW":
            {
                const { pnkStaked: pnkStaked, courtName: courtName, isStake: isStake, courtId: courtId } = props;
                PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $a46e5de0f000eb48$export$2e2bcd8739ae039), {
                    pnkStaked: pnkStaked,
                    courtName: courtName,
                    isStake: isStake,
                    courtId: courtId
                });
                break;
            }
        case "VOTE_WITHOUT_COMMIT":
            {
                const { date: date } = props;
                PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$VoteDescriptionContainer, {
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1c500df907cc6bb1$export$2e2bcd8739ae039), {
                        date: date
                    })
                });
                break;
            }
        case "VOTE_WITH_COMMIT":
            {
                const { date: date } = props;
                PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$VoteDescriptionContainer, {
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $72d12359378c3fe5$export$2e2bcd8739ae039), {
                        date: date
                    })
                });
                break;
            }
        case "APPEAL":
            {
                const { amount: amount, option: option } = props;
                PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eeab06c27b99c840$export$2e2bcd8739ae039), {
                    amount: amount,
                    option: option
                });
                break;
            }
        case "DISPUTE_CREATED":
            {
                const { courtId: courtId } = props;
                PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e82cdc6ebfd19ca7$export$2e2bcd8739ae039), {
                    courtId: courtId
                });
                break;
            }
        case "SWAP_SUCCESS":
            PopupComponent = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8dd8bb4d6b71400d$export$2e2bcd8739ae039), {
                ...props
            });
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c9df7c59319b4252$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($6d5b5828a9c61872$var$Container, {
                ref: containerRef,
                children: [
                    popupType === "SWAP_SUCCESS" && /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$SVGContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $4e6021079d8dfe2c$export$2e2bcd8739ae039), {
                            onClick: ()=>setIsOpen(false)
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$Header, {
                        children: title
                    }),
                    PopupComponent,
                    Icon && /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {})
                    }),
                    popupType === "STAKE_WITHDRAW" && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3e6992c85b7b56be$export$2e2bcd8739ae039), {}),
                    popupType === "VOTE_WITH_COMMIT" && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f6be6417fb572142$export$2e2bcd8739ae039), {}),
                    popupType === "DISPUTE_CREATED" && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $93359eba1a140767$export$2e2bcd8739ae039), {}),
                    popupType !== "SWAP_SUCCESS" && /*#__PURE__*/ (0, $cZGFG.jsx)($6d5b5828a9c61872$var$StyledButton, {
                        variant: "secondary",
                        text: popupType === "DISPUTE_CREATED" ? "Check the case" : "Close",
                        onClick: ()=>{
                            setIsOpen(false);
                            resetValue();
                            if (popupType === "DISPUTE_CREATED") {
                                const { disputeId: disputeId } = props;
                                navigate(`/cases/${disputeId}`);
                            }
                        }
                    })
                ]
            })
        ]
    });
};
var $6d5b5828a9c61872$export$2e2bcd8739ae039 = $6d5b5828a9c61872$var$Popup;





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
function $ee36ba41d59c459d$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $dup7A.useRef)(false);
    var timeout = (0, $dup7A.useRef)();
    var callback = (0, $dup7A.useRef)(fn);
    var isReady = (0, $dup7A.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $dup7A.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $dup7A.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $dup7A.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $dup7A.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}


function $3ba985b3701f9241$export$2e2bcd8739ae039(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, $ee36ba41d59c459d$export$2e2bcd8739ae039)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, $dup7A.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}







var $dup7A = parcelRequire("dup7A");

var $gxJ5d = parcelRequire("gxJ5d");
function $10de1c6562b78ee0$export$8556e87f337547cd(amount) {
    return (0, $dup7A.useMemo)(()=>(0, $gxJ5d.parseUnits)(amount, 18), [
        amount
    ]);
}





const $3639d67a435affd5$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const $3639d67a435affd5$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 100%;
  & > input {
    text-align: center;
  }
  &:before {
    position: absolute;
    content: "ETH";
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme: theme })=>theme.primaryText};
  }
`;
const $3639d67a435affd5$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  margin: auto;
  margin-top: 4px;
`;
const $3639d67a435affd5$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  align-self: flex-start;
`;
const $3639d67a435affd5$var$useNeedFund = ()=>{
    const { loserSideCountdown: loserSideCountdown } = (0, $2d23f57cc17492cb$export$80f7497360a8ec61)();
    const { fundedChoices: fundedChoices, winningChoice: winningChoice } = (0, $2d23f57cc17492cb$export$ee36d0186d4ab735)();
    const needFund = (loserSideCountdown ?? 0) > 0 || !(0, $2d857633ba67aa25$export$fce6876652108ab)(fundedChoices) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(winningChoice) && fundedChoices.length > 0 && !fundedChoices.includes(winningChoice);
    return needFund;
};
const $3639d67a435affd5$var$useFundAppeal = (parsedAmount)=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { selectedOption: selectedOption } = (0, $2d23f57cc17492cb$export$f1a5e4bb35f3011c)();
    const { config: fundAppealConfig, isError: isError } = (0, $f9a008fec395d7ff$export$e73431a594544793)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(id) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(selectedOption),
        args: [
            BigInt(id ?? 0),
            BigInt(selectedOption ?? 0)
        ],
        value: parsedAmount
    });
    const { writeAsync: fundAppeal } = (0, $f9a008fec395d7ff$export$165014b1149627d7)(fundAppealConfig);
    return {
        fundAppeal: fundAppeal,
        isError: isError
    };
};
const $3639d67a435affd5$var$Fund = ({ amount: amount, setAmount: setAmount, setIsOpen: setIsOpen })=>{
    const needFund = $3639d67a435affd5$var$useNeedFund();
    const { address: address, isDisconnected: isDisconnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: balance } = (0, $1d657eb5d64e17dc$export$4f026b09e764c1f8)({
        address: address,
        watch: true
    });
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const [debouncedAmount, setDebouncedAmount] = (0, $dup7A.useState)("");
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>setDebouncedAmount(amount), 500, [
        amount
    ]);
    const parsedAmount = (0, $10de1c6562b78ee0$export$8556e87f337547cd)(debouncedAmount);
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const { fundAppeal: fundAppeal, isError: isError } = $3639d67a435affd5$var$useFundAppeal(parsedAmount);
    const isFundDisabled = (0, $dup7A.useMemo)(()=>isDisconnected || isSending || !balance || parsedAmount > balance.value || Number(parsedAmount) <= 0 || isError, [
        isDisconnected,
        isSending,
        balance,
        parsedAmount,
        isError
    ]);
    return needFund ? /*#__PURE__*/ (0, $cZGFG.jsxs)($3639d67a435affd5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($3639d67a435affd5$var$StyledLabel, {
                children: "How much ETH do you want to contribute?"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($3639d67a435affd5$var$StyledField, {
                type: "number",
                value: amount,
                onChange: (e)=>{
                    setAmount(e.target.value);
                },
                placeholder: "Amount to fund"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($3639d67a435affd5$var$StyledButton, {
                    disabled: isFundDisabled,
                    isLoading: isSending,
                    text: isDisconnected ? "Connect to Fund" : "Fund",
                    onClick: ()=>{
                        if (fundAppeal) {
                            setIsSending(true);
                            (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await fundAppeal().then((response)=>response.hash), publicClient).then((res)=>{
                                res.status && setIsOpen(true);
                            }).finally(()=>{
                                setIsSending(false);
                            });
                        }
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {});
};
var $3639d67a435affd5$export$2e2bcd8739ae039 = $3639d67a435affd5$var$Fund;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $eae6e90bb146718b$export$e4ecddc59e33f387 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $33a9103a3e154719$export$2e2bcd8739ae039))`
  z-index: 0;
`;
const $eae6e90bb146718b$var$SkeletonDisputeCardContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $eae6e90bb146718b$var$StyledSkeletonDisputeCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $33a9103a3e154719$export$2e2bcd8739ae039))`
  height: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(270, 296)};
`;
const $eae6e90bb146718b$var$StyledSkeletonDisputeListItem = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $33a9103a3e154719$export$2e2bcd8739ae039))`
  height: 62px;
`;
const $eae6e90bb146718b$var$StyledSkeletonEvidenceContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  span {
    width: 100%;
    height: 146px;
    display: flex;
  }
`;
const $eae6e90bb146718b$export$84f3ad5c22cc3642 = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($eae6e90bb146718b$var$SkeletonDisputeCardContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($eae6e90bb146718b$var$StyledSkeletonDisputeCard, {})
    });
const $eae6e90bb146718b$export$7cd623403cfd4f66 = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($eae6e90bb146718b$var$StyledSkeletonDisputeListItem, {});
const $eae6e90bb146718b$export$f88686ad1229433d = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($eae6e90bb146718b$var$StyledSkeletonEvidenceContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {})
    });



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $3Szoa = parcelRequire("3Szoa");
var $lTCHO = parcelRequire("lTCHO");
function $9932208e3bd3cfac$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") return value.toString();
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    if (suffix === ".0") suffix = "";
    return negative + formatted.join(",") + suffix;
}
function $9932208e3bd3cfac$export$44b9d1d1a3173788(value) {
    return value.replace(/,/g, "");
}


const $fccd0e08af927011$export$f78533b8f2581318 = (value, fractionDigits = 0)=>{
    const factor = 10 ** fractionDigits;
    return Math.floor(value * factor) / factor;
};
const $fccd0e08af927011$export$4adf19926ad5efb5 = (value)=>(0, $lTCHO.formatUnits)(value, 18);
const $fccd0e08af927011$export$7c4d25c0c3217d8c = (value, fractionDigits, roundDown)=>{
    let units = Number(value);
    if (roundDown) units = $fccd0e08af927011$export$f78533b8f2581318(units, fractionDigits);
    return (0, $9932208e3bd3cfac$export$de1294767e6ef661)(units.toFixed(fractionDigits));
};
const $fccd0e08af927011$export$fe0dbb825775d15c = (value, fractionDigits = 0, roundDown = false)=>$fccd0e08af927011$export$7c4d25c0c3217d8c($fccd0e08af927011$export$4adf19926ad5efb5(value), fractionDigits, roundDown);
const $fccd0e08af927011$export$81d0e33f8b79c8db = (value, fractionDigits = 4, roundDown = false)=>$fccd0e08af927011$export$7c4d25c0c3217d8c((0, $3Szoa.formatEther)(value), fractionDigits, roundDown);
const $fccd0e08af927011$export$700d496f06f3d38f = (value, fractionDigits = 2)=>"$" + (0, $9932208e3bd3cfac$export$de1294767e6ef661)(Number(value).toFixed(fractionDigits));





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $baa851a3e705497f$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('3d438deb93c3df54')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M2.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 11.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM4.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
            })
        })
    });
var $baa851a3e705497f$export$2e2bcd8739ae039 = $baa851a3e705497f$var$SvgHourglass;





const $13c085a3dc79bef5$var$StyledBox = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Box))`
  border-radius: 3px;
  margin: 24px 0;
  height: auto;
  width: 100%;
  padding: 16px 24px;
  & > div > label {
    display: block;
    margin-bottom: 4px;
  }
`;
const $13c085a3dc79bef5$var$CountdownLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.secondaryPurple};
  color: ${({ theme: theme })=>theme.primaryText};
  gap: 8px;
  & > svg {
    width: 14px;
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $13c085a3dc79bef5$var$StageOneExplanation = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            " ",
            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    "Losing options can only be funded ",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: "before"
                    }),
                    " the deadline."
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    "If no losing option is ",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: "fully funded"
                    }),
                    " in time, the jury decision is maintained."
                ]
            })
        ]
    });
const $13c085a3dc79bef5$var$StageTwoExplanation = ()=>{
    const { fundedChoices: fundedChoices } = (0, $2d23f57cc17492cb$export$ee36d0186d4ab735)();
    const options = (0, $2d23f57cc17492cb$export$47309e171cbac7d)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    "Loser deadline has ",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: "finalized"
                    }),
                    ", you can only fund the current winner."
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: "If the current winner is not fully funded in time, the option funded during the previous stage will be declared as the final winner."
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    " ",
                    "Following choice was funded in the stage 1 :",
                    " ",
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: !(0, $2d857633ba67aa25$export$fce6876652108ab)(fundedChoices) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(options) ? fundedChoices.map((choice)=>(0, $2d857633ba67aa25$export$fce6876652108ab)(options[choice]) ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                                width: 50,
                                height: 18
                            }, choice) : options[choice]) : null
                    })
                ]
            })
        ]
    });
};
const $13c085a3dc79bef5$var$StageExplainer = ({ countdown: countdown, stage: stage })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($13c085a3dc79bef5$var$StyledBox, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($13c085a3dc79bef5$var$CountdownLabel, {
                children: !(0, $2d857633ba67aa25$export$fce6876652108ab)(countdown) ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $baa851a3e705497f$export$2e2bcd8739ae039), {}),
                        countdown > 0 ? (0, $fee5256da5a38783$export$727166c461d46c36)(countdown) : /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                            children: "Time's up"
                        })
                    ]
                }) : null
            }),
            stage === 1 ? /*#__PURE__*/ (0, $cZGFG.jsx)($13c085a3dc79bef5$var$StageOneExplanation, {}) : /*#__PURE__*/ (0, $cZGFG.jsx)($13c085a3dc79bef5$var$StageTwoExplanation, {})
        ]
    });
};
var $13c085a3dc79bef5$export$2e2bcd8739ae039 = $13c085a3dc79bef5$var$StageExplainer;


const $7c8af75d408dc1e5$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin: 24px 0;
`;
const $7c8af75d408dc1e5$var$OptionsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 12px;
`;
const $7c8af75d408dc1e5$var$StageOne = ({ setAmount: setAmount })=>{
    const { paidFees: paidFees, winningChoice: winningChoice, loserRequiredFunding: loserRequiredFunding, winnerRequiredFunding: winnerRequiredFunding, fundedChoices: fundedChoices } = (0, $2d23f57cc17492cb$export$ee36d0186d4ab735)();
    const options = (0, $2d23f57cc17492cb$export$47309e171cbac7d)();
    const { loserSideCountdown: loserSideCountdown } = (0, $2d23f57cc17492cb$export$80f7497360a8ec61)();
    const { selectedOption: selectedOption, setSelectedOption: setSelectedOption } = (0, $2d23f57cc17492cb$export$f1a5e4bb35f3011c)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($7c8af75d408dc1e5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $13c085a3dc79bef5$export$2e2bcd8739ae039), {
                countdown: loserSideCountdown,
                stage: 1
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: " Which option do you want to fund? "
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($7c8af75d408dc1e5$var$OptionsContainer, {
                children: !(0, $2d857633ba67aa25$export$fce6876652108ab)(paidFees) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(winnerRequiredFunding) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(loserRequiredFunding) && options?.map((answer, i)=>{
                    const requiredFunding = i.toString() === winningChoice ? winnerRequiredFunding : loserRequiredFunding;
                    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d680dc0e2fb89895$export$2e2bcd8739ae039), {
                        text: answer,
                        selected: i === selectedOption,
                        winner: i.toString() === winningChoice,
                        funding: paidFees[i] ? BigInt(paidFees[i]) : 0n,
                        required: requiredFunding,
                        canBeSelected: !fundedChoices?.includes(i.toString()),
                        onClick: ()=>{
                            setSelectedOption(i);
                            setAmount((0, $fccd0e08af927011$export$4adf19926ad5efb5)(requiredFunding));
                        }
                    }, answer);
                })
            })
        ]
    });
};
var $7c8af75d408dc1e5$export$2e2bcd8739ae039 = $7c8af75d408dc1e5$var$StageOne;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







const $dba912bbc305d6aa$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin: 24px 0;
`;
const $dba912bbc305d6aa$var$OptionsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 12px;
`;
const $dba912bbc305d6aa$var$StageTwo = ({ setAmount: setAmount })=>{
    const { paidFees: paidFees, winningChoice: winningChoice, winnerRequiredFunding: winnerRequiredFunding, fundedChoices: fundedChoices } = (0, $2d23f57cc17492cb$export$ee36d0186d4ab735)();
    const { winnerSideCountdown: winnerSideCountdown } = (0, $2d23f57cc17492cb$export$80f7497360a8ec61)();
    const options = (0, $2d23f57cc17492cb$export$47309e171cbac7d)();
    const { selectedOption: selectedOption, setSelectedOption: setSelectedOption } = (0, $2d23f57cc17492cb$export$f1a5e4bb35f3011c)();
    (0, $dup7A.useEffect)(()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(winningChoice)) setSelectedOption(parseInt(winningChoice));
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(winnerRequiredFunding)) setAmount((0, $fccd0e08af927011$export$4adf19926ad5efb5)(winnerRequiredFunding));
    }, [
        winnerRequiredFunding,
        winningChoice
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dba912bbc305d6aa$var$Container, {
        children: !(0, $2d857633ba67aa25$export$fce6876652108ab)(winningChoice) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(fundedChoices) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(paidFees) ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
            children: fundedChoices.length > 0 && !fundedChoices.includes(winningChoice) ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $13c085a3dc79bef5$export$2e2bcd8739ae039), {
                        stage: 2,
                        countdown: winnerSideCountdown
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($dba912bbc305d6aa$var$OptionsContainer, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d680dc0e2fb89895$export$2e2bcd8739ae039), {
                            text: options[winningChoice],
                            selected: parseInt(winningChoice) === selectedOption,
                            winner: true,
                            funding: paidFees[winningChoice] ? BigInt(paidFees[winningChoice]) : 0n,
                            required: winnerRequiredFunding,
                            canBeSelected: false,
                            onClick: ()=>setSelectedOption(parseInt(winningChoice, 10))
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: "No losing option has been funded in time, winner is maintained."
            })
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
            height: 140
        })
    });
};
var $dba912bbc305d6aa$export$2e2bcd8739ae039 = $dba912bbc305d6aa$var$StageTwo;


const $08f5fb4334b667af$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin: 24px 0;
`;
const $08f5fb4334b667af$var$Options = ({ setAmount: setAmount })=>{
    const { loserSideCountdown: loserSideCountdown } = (0, $2d23f57cc17492cb$export$80f7497360a8ec61)();
    return !(0, $2d857633ba67aa25$export$fce6876652108ab)(loserSideCountdown) ? /*#__PURE__*/ (0, $cZGFG.jsx)($08f5fb4334b667af$var$Container, {
        children: loserSideCountdown > 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $7c8af75d408dc1e5$export$2e2bcd8739ae039), {
            setAmount: setAmount
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dba912bbc305d6aa$export$2e2bcd8739ae039), {
            setAmount: setAmount
        })
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {});
};
var $08f5fb4334b667af$export$2e2bcd8739ae039 = $08f5fb4334b667af$var$Options;


const $9e3a032d19021d81$var$Classic = ({ isAppealMiniGuideOpen: isAppealMiniGuideOpen, toggleAppealMiniGuide: toggleAppealMiniGuide })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $dup7A.useState)(false);
    const [amount, setAmount] = (0, $dup7A.useState)("");
    const { selectedOption: selectedOption } = (0, $2d23f57cc17492cb$export$f1a5e4bb35f3011c)();
    const options = (0, $2d23f57cc17492cb$export$47309e171cbac7d)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            isPopupOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$2e2bcd8739ae039), {
                title: "Thanks for Funding the Appeal",
                icon: (0, $f532bf5525802986$export$2e2bcd8739ae039),
                popupType: (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).APPEAL,
                setIsOpen: setIsPopupOpen,
                setAmount: setAmount,
                option: !(0, $2d857633ba67aa25$export$fce6876652108ab)(options) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(selectedOption) ? options[selectedOption] : "",
                amount: amount
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $722961e830929345$export$e741d7929ebaa468), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $722961e830929345$export$48331a7adc9a636b), {
                        children: "Appeal crowdfunding"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                        isMiniGuideOpen: isAppealMiniGuideOpen,
                        toggleMiniGuide: toggleAppealMiniGuide,
                        MiniGuideComponent: (0, $b1c183e8436a370c$export$2e2bcd8739ae039)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: " The jury decision is appealed when two options are fully funded. "
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $08f5fb4334b667af$export$2e2bcd8739ae039), {
                setAmount: setAmount
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3639d67a435affd5$export$2e2bcd8739ae039), {
                amount: amount,
                setAmount: setAmount,
                setIsOpen: setIsPopupOpen
            })
        ]
    });
};
var $9e3a032d19021d81$export$2e2bcd8739ae039 = $9e3a032d19021d81$var$Classic;


const $722961e830929345$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $722961e830929345$export$e741d7929ebaa468 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 12px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
    `)}
`;
const $722961e830929345$export$48331a7adc9a636b = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin: 0;
`;
const $722961e830929345$var$Appeal = ({ currentPeriodIndex: currentPeriodIndex })=>{
    const [isAppealMiniGuideOpen, toggleAppealMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2d23f57cc17492cb$export$fe08c78aa7757dfb), {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($722961e830929345$var$Container, {
            children: (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal === currentPeriodIndex ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9e3a032d19021d81$export$2e2bcd8739ae039), {
                isAppealMiniGuideOpen: isAppealMiniGuideOpen,
                toggleAppealMiniGuide: toggleAppealMiniGuide
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9f4d34c1daa7ab6d$export$2e2bcd8739ae039), {
                isAppealMiniGuideOpen: isAppealMiniGuideOpen,
                toggleAppealMiniGuide: toggleAppealMiniGuide
            })
        })
    });
};
var $722961e830929345$export$2e2bcd8739ae039 = $722961e830929345$var$Appeal;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");










const $7ac8277a9f4b9fc9$export$bc31b01ff23f8317 = (disputeID, arbitrableAddress)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(arbitrableAddress);
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `EvidenceGroup${disputeID}${arbitrableAddress}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (arbitrableAddress && !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeID)) {
                const arbitrable = (0, $f9a008fec395d7ff$export$67ef5ffb4cf48435)({
                    address: arbitrableAddress
                });
                const disputeFilter = await arbitrable.createEventFilter.DisputeRequest({
                    _arbitrableDisputeID: BigInt(disputeID)
                }, {
                    fromBlock: (0, $203b613495c69c62$export$801be0cfa784af7b),
                    toBlock: "latest"
                });
                const disputeEvents = await publicClient.getFilterLogs({
                    filter: disputeFilter
                });
                return disputeEvents[0].args._externalDisputeID;
            } else throw Error;
        }
    });
};





const $32270f0df5294a3e$var$evidencesQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query Evidences($evidenceGroupID: String) {
    evidences(where: { evidenceGroup: $evidenceGroupID }, orderBy: id, orderDirection: asc) {
      id
      evidence
      sender {
        id
      }
    }
  }
`);
const $32270f0df5294a3e$export$4be38494736f2d5d = (evidenceGroup)=>{
    const isEnabled = evidenceGroup !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `evidencesQuery${evidenceGroup}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $32270f0df5294a3e$var$evidencesQuery,
                variables: {
                    evidenceGroupID: evidenceGroup?.toString()
                }
            })
    });
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $0e8b16bd5cd97a93$var$SvgAttachment = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('9ccf687bb897afa8')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M2.091 12.746C.448 11.097.48 8.44 2.131 6.796L8.03.93a3.21 3.21 0 0 1 4.519 0 3.12 3.12 0 0 1 0 4.437l-5.143 5.11a2.14 2.14 0 0 1-3.037-.028 2.077 2.077 0 0 1 .04-2.925L8.454 3.51a.46.46 0 0 1 .636-.006l.643.612c.178.169.18.446.007.618L5.696 8.748c-.138.138-.147.367-.018.5a.306.306 0 0 0 .441.005l5.143-5.11a1.404 1.404 0 0 0 0-1.99 1.376 1.376 0 0 0-1.945 0l-5.9 5.867c-.978.972-.993 2.546-.033 3.508.956.96 2.502.961 3.46.008l4.84-4.812a.46.46 0 0 1 .636-.007l.644.611c.177.17.18.446.007.619l-4.84 4.812a4.28 4.28 0 0 1-6.04-.013Z"
            })
        })
    });
var $0e8b16bd5cd97a93$export$2e2bcd8739ae039 = $0e8b16bd5cd97a93$var$SvgAttachment;




const $862ad37af5a70e26$export$99de037bb933f932 = (url)=>{
    const formatedIPFSPath = $862ad37af5a70e26$export$2ccc1cfd45796abd(url);
    return `${0, $203b613495c69c62$export$8c255d03248f12ab}${formatedIPFSPath}`;
};
const $862ad37af5a70e26$export$2ccc1cfd45796abd = (url)=>{
    if (url.startsWith("/ipfs/")) return url;
    else if (url.startsWith("ipfs/")) return "/" + url;
    else if (url.startsWith("ipfs://")) return url.replace("ipfs://", "/ipfs/");
    return url;
};



const $72662f327cdad4a4$export$fb338452f010103f = (ipfsPath)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(ipfsPath);
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `IPFS${ipfsPath}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>{
            if (isEnabled) return fetch((0, $862ad37af5a70e26$export$99de037bb933f932)(ipfsPath)).then(async (res)=>await res.json());
            return undefined;
        }
    });
};






const $e59ee8c8cc089ab9$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  height: auto;
`;
const $e59ee8c8cc089ab9$var$TextContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24)};
  > * {
    overflow-wrap: break-word;
    margin: 0;
  }
  > h3 {
    display: inline-block;
    margin: 0px 4px;
  }
`;
const $e59ee8c8cc089ab9$var$Index = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).p`
  display: inline-block;
`;
const $e59ee8c8cc089ab9$var$BottomShade = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.lightBlue};
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24)};
  > * {
    flex-basis: 1;
    flex-shrink: 0;
    margin: 0;
  }
`;
const $e59ee8c8cc089ab9$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  margin-left: auto;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(5, 6)};
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      > svg {
        width: 16px;
        fill: ${({ theme: theme })=>theme.primaryBlue};
      }
    `)}
`;
const $e59ee8c8cc089ab9$var$AccountContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  canvas {
    width: 24px;
    height: 24px;
  }

  > * {
    flex-basis: 1;
    flex-shrink: 0;
    margin: 0;
  }
`;
const $e59ee8c8cc089ab9$var$DesktopText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).span`
  display: none;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: inline;
    `)}
`;
const $e59ee8c8cc089ab9$var$MobileText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).span`
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $e59ee8c8cc089ab9$var$AttachedFileText = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($e59ee8c8cc089ab9$var$DesktopText, {
                children: "View attached file"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($e59ee8c8cc089ab9$var$MobileText, {
                children: "File"
            })
        ]
    });
const $e59ee8c8cc089ab9$var$EvidenceCard = ({ evidence: evidence, sender: sender, index: index })=>{
    const { data: data } = (0, $72662f327cdad4a4$export$fb338452f010103f)(evidence);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$StyledCard, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$TextContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$Index, {
                        children: [
                            "#",
                            index,
                            ":"
                        ]
                    }),
                    data ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
                                children: data.name
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                                children: data.description
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                        children: evidence
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$BottomShade, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$AccountContainer, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0851f7d91966eb7d$exports))), {
                                size: "24",
                                string: sender
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                                children: (0, $db69162b86dec792$export$e6e2bc9967bf256c)(sender)
                            })
                        ]
                    }),
                    data && typeof data.fileURI !== "undefined" && /*#__PURE__*/ (0, $cZGFG.jsxs)($e59ee8c8cc089ab9$var$StyledA, {
                        href: (0, $862ad37af5a70e26$export$99de037bb933f932)(data.fileURI),
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0e8b16bd5cd97a93$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)($e59ee8c8cc089ab9$var$AttachedFileText, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $e59ee8c8cc089ab9$export$2e2bcd8739ae039 = $e59ee8c8cc089ab9$var$EvidenceCard;




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");








function $859309432da1acd9$export$8a748dfc8dae7a64(formData, operation = "evidence") {
    return (0, $b6ddc82ff82475c2$export$b410431fab84fa58).promise(fetch(`/.netlify/functions/uploadToIPFS?key=kleros-v2&operation=${operation}`, {
        method: "POST",
        body: formData
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error uploading to IPFS"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        pending: `Uploading ${operation} to IPFS...`,
        success: "Uploaded successfully!",
        error: {
            render ({ data: error }) {
                return `Upload failed: ${error?.message}`;
            }
        }
    }, (0, $0b0903738c0da810$export$8eb3892b442747bd));
}




const $db787949572db8c5$var$StyledModal = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($939f14b26ca18529$exports))))`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 80%;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  border-radius: 3px;
  background-color: ${({ theme: theme })=>theme.whiteBackground};

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 16px;
`;
const $db787949572db8c5$var$StyledTextArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Textarea))`
  width: 100%;
  height: 200px;
`;
const $db787949572db8c5$var$StyledFileUploader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.FileUploader))`
  width: 100%;
`;
const $db787949572db8c5$var$ButtonArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const $db787949572db8c5$var$SubmitEvidenceModal = ({ isOpen: isOpen, evidenceGroup: evidenceGroup, close: close })=>{
    const { data: walletClient } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const [message, setMessage] = (0, $dup7A.useState)("");
    const [file, setFile] = (0, $dup7A.useState)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($db787949572db8c5$var$StyledModal, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                children: "Submit New Evidence"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($db787949572db8c5$var$StyledTextArea, {
                value: message,
                onChange: (e)=>setMessage(e.target.value),
                placeholder: "Your Arguments"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($db787949572db8c5$var$StyledFileUploader, {
                callback: (file)=>setFile(file)
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($db787949572db8c5$var$ButtonArea, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                        variant: "secondary",
                        disabled: isSending,
                        text: "Return",
                        onClick: close
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                            text: "Submit",
                            isLoading: isSending,
                            disabled: isSending,
                            onClick: async ()=>{
                                setIsSending(true);
                                (0, $b6ddc82ff82475c2$export$b410431fab84fa58).info("Uploading to IPFS", (0, $0b0903738c0da810$export$8eb3892b442747bd));
                                const formData = await $db787949572db8c5$var$constructEvidence(message, file);
                                (0, $859309432da1acd9$export$8a748dfc8dae7a64)(formData).then(async (res)=>{
                                    const response = await res.json();
                                    if (res.status === 200 && walletClient) {
                                        const cid = response["cids"][0];
                                        const { request: request } = await (0, $f9a008fec395d7ff$export$ab6b51e2bc748ef6)({
                                            functionName: "submitEvidence",
                                            args: [
                                                BigInt(evidenceGroup),
                                                cid
                                            ]
                                        });
                                        await (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await walletClient.writeContract(request), publicClient).then(()=>{
                                            setMessage("");
                                            close();
                                        });
                                    }
                                }).catch().finally(()=>setIsSending(false));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $db787949572db8c5$var$constructEvidence = async (msg, file)=>{
    let fileURI = undefined;
    if (file) {
        const fileFormData = new FormData();
        fileFormData.append("data", file, file.name);
        fileURI = await (0, $859309432da1acd9$export$8a748dfc8dae7a64)(fileFormData).then(async (res)=>{
            const response = await res.json();
            return response["cids"][0];
        });
    }
    const formData = new FormData();
    const evidenceFile = new File([
        JSON.stringify({
            name: "Evidence",
            description: msg,
            fileURI: fileURI
        })
    ], "evidence.json", {
        type: "text/plain"
    });
    formData.append("data", evidenceFile, evidenceFile.name);
    return formData;
};
var $db787949572db8c5$export$2e2bcd8739ae039 = $db787949572db8c5$var$SubmitEvidenceModal;


const $04452cdeb639f166$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  align-items: center;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $04452cdeb639f166$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  align-self: flex-end;
`;
const $04452cdeb639f166$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
  margin-top: 16px;
  font-size: 16px;
`;
const $04452cdeb639f166$var$Evidence = ({ arbitrable: arbitrable })=>{
    const [isModalOpen, setIsModalOpen] = (0, $dup7A.useState)(false);
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: evidenceGroup } = (0, $7ac8277a9f4b9fc9$export$bc31b01ff23f8317)(id, arbitrable);
    const { data: data } = (0, $32270f0df5294a3e$export$4be38494736f2d5d)(evidenceGroup?.toString());
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($04452cdeb639f166$var$Container, {
        children: [
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(evidenceGroup) && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $db787949572db8c5$export$2e2bcd8739ae039), {
                isOpen: isModalOpen,
                close: ()=>setIsModalOpen(false),
                evidenceGroup: evidenceGroup
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Searchbar), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($04452cdeb639f166$var$StyledButton, {
                    small: true,
                    text: "Submit Evidence",
                    disabled: typeof address === "undefined" || isModalOpen,
                    isLoading: isModalOpen,
                    onClick: ()=>setIsModalOpen(true)
                })
            }),
            data ? data.evidences.map(({ key: key, evidence: evidence, sender: sender }, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $e59ee8c8cc089ab9$export$2e2bcd8739ae039), {
                    index: i + 1,
                    sender: sender?.id,
                    evidence: evidence
                }, key)) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$f88686ad1229433d), {}),
            data && data.evidences.length === 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)($04452cdeb639f166$var$StyledLabel, {
                children: "There is no evidence submitted yet"
            }) : null
        ]
    });
};
var $04452cdeb639f166$export$2e2bcd8739ae039 = $04452cdeb639f166$var$Evidence;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $3Szoa = parcelRequire("3Szoa");




const $2110a062d830c408$var$votingHistoryQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query VotingHistory($disputeID: ID!) {
    dispute(id: $disputeID) {
      id
      createdAt
      rounds {
        nbVotes
        court {
          id
          name
        }
        timeline
        drawnJurors {
          juror {
            id
          }
          vote {
            ... on ClassicVote {
              justification {
                choice
                reference
              }
            }
          }
        }
      }
      disputeKitDispute {
        localRounds {
          ... on ClassicRound {
            winningChoice
            totalVoted
          }
        }
      }
    }
  }
`);
const $2110a062d830c408$export$2d10fa524a206015 = (disputeID)=>{
    const isEnabled = disputeID !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `VotingHistory${disputeID}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $2110a062d830c408$var$votingHistoryQuery,
                variables: {
                    disputeID: disputeID
                }
            })
    });
};







const $65ce4981691f71af$var$courtPolicyURIQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query CourtPolicyURI($courtID: ID!) {
    court(id: $courtID) {
      policy
    }
  }
`);
const $65ce4981691f71af$export$e2fb8ac4bc0c90d3 = (id)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(id);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `CourtPolicyURI${id}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>isEnabled ? await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $65ce4981691f71af$var$courtPolicyURIQuery,
                variables: {
                    courtID: id.toString()
                }
            }) : undefined
    });
};



const $3043cbfb1ed10cf4$export$e0985f714b0d92d6 = (courtID)=>{
    const { data: policyURI } = (0, $65ce4981691f71af$export$e2fb8ac4bc0c90d3)(courtID);
    return (0, $72662f327cdad4a4$export$fb338452f010103f)(policyURI?.court?.policy ?? "");
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $dup7A = parcelRequire("dup7A");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $a44131253ed98691$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $a44131253ed98691$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $4d5d7b88bd4b26a7$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $4d5d7b88bd4b26a7$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $4d5d7b88bd4b26a7$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $4d5d7b88bd4b26a7$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $4d5d7b88bd4b26a7$var$point(point) {
    return $4d5d7b88bd4b26a7$var$index(point && point.line) + ":" + $4d5d7b88bd4b26a7$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $4d5d7b88bd4b26a7$var$position(pos) {
    return $4d5d7b88bd4b26a7$var$point(pos && pos.start) + "-" + $4d5d7b88bd4b26a7$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $4d5d7b88bd4b26a7$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $226359305ef5be90$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $4d5d7b88bd4b26a7$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$226359305ef5be90$export$752e5c445fe834ef.prototype.file = "";
$226359305ef5be90$export$752e5c445fe834ef.prototype.name = "";
$226359305ef5be90$export$752e5c445fe834ef.prototype.reason = "";
$226359305ef5be90$export$752e5c445fe834ef.prototype.message = "";
$226359305ef5be90$export$752e5c445fe834ef.prototype.stack = "";
$226359305ef5be90$export$752e5c445fe834ef.prototype.fatal = null;
$226359305ef5be90$export$752e5c445fe834ef.prototype.column = null;
$226359305ef5be90$export$752e5c445fe834ef.prototype.line = null;
$226359305ef5be90$export$752e5c445fe834ef.prototype.source = null;
$226359305ef5be90$export$752e5c445fe834ef.prototype.ruleId = null;
$226359305ef5be90$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $ffe045678725f712$export$bb654e07daaf8c3a = {
    basename: $ffe045678725f712$var$basename,
    dirname: $ffe045678725f712$var$dirname,
    extname: $ffe045678725f712$var$extname,
    join: $ffe045678725f712$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $ffe045678725f712$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $ffe045678725f712$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $ffe045678725f712$var$dirname(path) {
    $ffe045678725f712$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $ffe045678725f712$var$extname(path) {
    $ffe045678725f712$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $ffe045678725f712$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $ffe045678725f712$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $ffe045678725f712$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $ffe045678725f712$var$normalize(path) {
    $ffe045678725f712$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $ffe045678725f712$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $ffe045678725f712$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $ffe045678725f712$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $6572cd233ca987c5$export$97a5aaf482767187 = {
    cwd: $6572cd233ca987c5$var$cwd
};
function $6572cd233ca987c5$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $d080defa56fc05d4$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $f89f1b9f38f9cfa3$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $d080defa56fc05d4$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $f89f1b9f38f9cfa3$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $f89f1b9f38f9cfa3$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $91ce9774873ed85e$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $91ce9774873ed85e$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $91ce9774873ed85e$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $d080defa56fc05d4$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $6572cd233ca987c5$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $91ce9774873ed85e$var$order.length){
            const prop = $91ce9774873ed85e$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$91ce9774873ed85e$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $d080defa56fc05d4$export$8304a22d431f958)(path)) path = (0, $f89f1b9f38f9cfa3$export$9b2b676c902de799)(path);
        $91ce9774873ed85e$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $ffe045678725f712$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $91ce9774873ed85e$var$assertPath(this.basename, "dirname");
        this.path = (0, $ffe045678725f712$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $ffe045678725f712$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $91ce9774873ed85e$var$assertNonEmpty(basename, "basename");
        $91ce9774873ed85e$var$assertPart(basename, "basename");
        this.path = (0, $ffe045678725f712$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $ffe045678725f712$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $91ce9774873ed85e$var$assertPart(extname, "extname");
        $91ce9774873ed85e$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $ffe045678725f712$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $ffe045678725f712$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $91ce9774873ed85e$var$assertNonEmpty(stem, "stem");
        $91ce9774873ed85e$var$assertPart(stem, "stem");
        this.path = (0, $ffe045678725f712$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $226359305ef5be90$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $91ce9774873ed85e$var$assertPart(part, name) {
    if (part && part.includes((0, $ffe045678725f712$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $ffe045678725f712$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $91ce9774873ed85e$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $91ce9774873ed85e$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $91ce9774873ed85e$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a44131253ed98691$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $f607db9409258842$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $618af181b859cfc9$exports = {};
"use strict";
var $618af181b859cfc9$var$hasOwn = Object.prototype.hasOwnProperty;
var $618af181b859cfc9$var$toStr = Object.prototype.toString;
var $618af181b859cfc9$var$defineProperty = Object.defineProperty;
var $618af181b859cfc9$var$gOPD = Object.getOwnPropertyDescriptor;
var $618af181b859cfc9$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $618af181b859cfc9$var$toStr.call(arr) === "[object Array]";
};
var $618af181b859cfc9$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $618af181b859cfc9$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $618af181b859cfc9$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $618af181b859cfc9$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $618af181b859cfc9$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $618af181b859cfc9$var$setProperty = function setProperty(target, options) {
    if ($618af181b859cfc9$var$defineProperty && options.name === "__proto__") $618af181b859cfc9$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $618af181b859cfc9$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$618af181b859cfc9$var$hasOwn.call(obj, name)) return void 0;
        else if ($618af181b859cfc9$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $618af181b859cfc9$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$618af181b859cfc9$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $618af181b859cfc9$var$getProperty(target, name);
            copy = $618af181b859cfc9$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($618af181b859cfc9$var$isPlainObject(copy) || (copyIsArray = $618af181b859cfc9$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $618af181b859cfc9$var$isArray(src) ? src : [];
                    } else clone = src && $618af181b859cfc9$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $618af181b859cfc9$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $618af181b859cfc9$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $2bbf5ef76ea0bff1$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $b9d1abe78c62fdb4$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $b9d1abe78c62fdb4$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $b9d1abe78c62fdb4$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $47a139d5bce6fa91$export$7cc1b2fe10c52bb = $47a139d5bce6fa91$var$base().freeze();
const $47a139d5bce6fa91$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $47a139d5bce6fa91$var$base() {
    const transformers = (0, $b9d1abe78c62fdb4$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $47a139d5bce6fa91$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($618af181b859cfc9$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $47a139d5bce6fa91$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $47a139d5bce6fa91$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $47a139d5bce6fa91$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $47a139d5bce6fa91$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $2bbf5ef76ea0bff1$export$2e2bcd8739ae039)(entry[1]) && (0, $2bbf5ef76ea0bff1$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($618af181b859cfc9$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $47a139d5bce6fa91$var$vfile(doc);
        const Parser = processor.Parser;
        $47a139d5bce6fa91$var$assertParser("parse", Parser);
        if ($47a139d5bce6fa91$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $47a139d5bce6fa91$var$vfile(doc);
        const Compiler = processor.Compiler;
        $47a139d5bce6fa91$var$assertCompiler("stringify", Compiler);
        $47a139d5bce6fa91$var$assertNode(node);
        if ($47a139d5bce6fa91$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $47a139d5bce6fa91$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $47a139d5bce6fa91$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $47a139d5bce6fa91$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $f607db9409258842$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $47a139d5bce6fa91$var$assertParser("process", processor.Parser);
        $47a139d5bce6fa91$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $47a139d5bce6fa91$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($47a139d5bce6fa91$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $47a139d5bce6fa91$var$assertParser("processSync", processor.Parser);
        $47a139d5bce6fa91$var$assertCompiler("processSync", processor.Compiler);
        const file = $47a139d5bce6fa91$var$vfile(doc);
        processor.process(file, done);
        $47a139d5bce6fa91$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $f607db9409258842$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $47a139d5bce6fa91$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($47a139d5bce6fa91$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $47a139d5bce6fa91$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($47a139d5bce6fa91$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $47a139d5bce6fa91$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $47a139d5bce6fa91$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $47a139d5bce6fa91$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $47a139d5bce6fa91$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $2bbf5ef76ea0bff1$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $47a139d5bce6fa91$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $47a139d5bce6fa91$var$vfile(value) {
    return $47a139d5bce6fa91$var$looksLikeAVFile(value) ? value : new (0, $91ce9774873ed85e$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $47a139d5bce6fa91$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $47a139d5bce6fa91$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($a44131253ed98691$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $688fadfd085fa436$var$emptyOptions = {};
function $688fadfd085fa436$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $688fadfd085fa436$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $688fadfd085fa436$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $688fadfd085fa436$var$one(value, includeImageAlt, includeHtml) {
    if ($688fadfd085fa436$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $688fadfd085fa436$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $688fadfd085fa436$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $688fadfd085fa436$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $688fadfd085fa436$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $688fadfd085fa436$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $b142ce28f127b38c$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $b142ce28f127b38c$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $b142ce28f127b38c$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $da94f2637cfcde08$var$hasOwnProperty = {}.hasOwnProperty;
function $da94f2637cfcde08$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$da94f2637cfcde08$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $da94f2637cfcde08$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $da94f2637cfcde08$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$da94f2637cfcde08$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $da94f2637cfcde08$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $da94f2637cfcde08$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $b142ce28f127b38c$export$869882364835d202)(existing, 0, 0, before);
}
function $da94f2637cfcde08$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$da94f2637cfcde08$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $da94f2637cfcde08$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $da94f2637cfcde08$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $af1165ad8d447c57$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $296a6c1b4677472f$export$d65d6b62c24d5436 = $296a6c1b4677472f$var$regexCheck(/[A-Za-z]/);
const $296a6c1b4677472f$export$75c76db11865a9f4 = $296a6c1b4677472f$var$regexCheck(/[\dA-Za-z]/);
const $296a6c1b4677472f$export$4397998b34fe597d = $296a6c1b4677472f$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $296a6c1b4677472f$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $296a6c1b4677472f$export$ca8b5b1a6c320e6e = $296a6c1b4677472f$var$regexCheck(/\d/);
const $296a6c1b4677472f$export$eca2752363989806 = $296a6c1b4677472f$var$regexCheck(/[\dA-Fa-f]/);
const $296a6c1b4677472f$export$35794a7d1db99380 = $296a6c1b4677472f$var$regexCheck(/[!-/:-@[-`{-~]/);
function $296a6c1b4677472f$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $296a6c1b4677472f$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $296a6c1b4677472f$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $296a6c1b4677472f$export$aa04114dd888a7a0 = $296a6c1b4677472f$var$regexCheck((0, $af1165ad8d447c57$export$85b5101f24802e8c));
const $296a6c1b4677472f$export$a0ff789c034ffdf4 = $296a6c1b4677472f$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $296a6c1b4677472f$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $2f841c3aeb378892$export$a7db06668cad9adb = {
    tokenize: $2f841c3aeb378892$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $2f841c3aeb378892$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $f389ec61e4042960$export$5a7bfc01df82fcd1 = {
    tokenize: $f389ec61e4042960$var$initializeDocument
};
/** @type {Construct} */ const $f389ec61e4042960$var$containerConstruct = {
    tokenize: $f389ec61e4042960$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $f389ec61e4042960$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $b142ce28f127b38c$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($f389ec61e4042960$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($f389ec61e4042960$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $b142ce28f127b38c$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f389ec61e4042960$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $673f67134454d2b9$export$d50d28ce3ab2a612 = {
    tokenize: $673f67134454d2b9$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $673f67134454d2b9$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $abc0b51163aa224e$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $abc0b51163aa224e$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $b142ce28f127b38c$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $abc0b51163aa224e$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $b142ce28f127b38c$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $59f0160cf25905e8$export$a7db06668cad9adb = {
    tokenize: $59f0160cf25905e8$var$tokenizeContent,
    resolve: $59f0160cf25905e8$var$resolveContent
};
/** @type {Construct} */ const $59f0160cf25905e8$var$continuationConstruct = {
    tokenize: $59f0160cf25905e8$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $59f0160cf25905e8$var$resolveContent(events) {
    (0, $abc0b51163aa224e$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $59f0160cf25905e8$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return effects.check($59f0160cf25905e8$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $59f0160cf25905e8$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $98e516f9bde13e32$export$ccc7b0636abaffc3 = {
    tokenize: $98e516f9bde13e32$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $98e516f9bde13e32$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $673f67134454d2b9$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $59f0160cf25905e8$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $51e7efd62ec4434a$export$50397835cbfdbc24 = {
    resolveAll: $51e7efd62ec4434a$var$createResolver()
};
const $51e7efd62ec4434a$export$22b082955e083ec3 = $51e7efd62ec4434a$var$initializeFactory("string");
const $51e7efd62ec4434a$export$6f093cfa640b7166 = $51e7efd62ec4434a$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $51e7efd62ec4434a$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $51e7efd62ec4434a$var$createResolver(field === "text" ? $51e7efd62ec4434a$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $51e7efd62ec4434a$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $51e7efd62ec4434a$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $6aa6db6f9342b9cb$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $fb4aa273259315a1$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $b142ce28f127b38c$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $6aa6db6f9342b9cb$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $fb4aa273259315a1$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $fb4aa273259315a1$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $b142ce28f127b38c$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $fb4aa273259315a1$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $fb4aa273259315a1$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $419927f7d8e7627f$exports = {};

$parcel$export($419927f7d8e7627f$exports, "document", () => $419927f7d8e7627f$export$5a7bfc01df82fcd1);
$parcel$export($419927f7d8e7627f$exports, "contentInitial", () => $419927f7d8e7627f$export$5a2181fb44b58173);
$parcel$export($419927f7d8e7627f$exports, "flowInitial", () => $419927f7d8e7627f$export$cf8bead395eff824);
$parcel$export($419927f7d8e7627f$exports, "flow", () => $419927f7d8e7627f$export$ccc7b0636abaffc3);
$parcel$export($419927f7d8e7627f$exports, "string", () => $419927f7d8e7627f$export$22b082955e083ec3);
$parcel$export($419927f7d8e7627f$exports, "text", () => $419927f7d8e7627f$export$6f093cfa640b7166);
$parcel$export($419927f7d8e7627f$exports, "insideSpan", () => $419927f7d8e7627f$export$d44f260a3f9b69f5);
$parcel$export($419927f7d8e7627f$exports, "attentionMarkers", () => $419927f7d8e7627f$export$b9c0b60d74426aea);
$parcel$export($419927f7d8e7627f$exports, "disable", () => $419927f7d8e7627f$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $29278eb21b71f12d$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) || (0, $296a6c1b4677472f$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $296a6c1b4677472f$export$aa04114dd888a7a0)(code)) return 2;
}



const $f19a9c3655bf3498$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $f19a9c3655bf3498$var$tokenizeAttention,
    resolveAll: $f19a9c3655bf3498$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $f19a9c3655bf3498$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $f19a9c3655bf3498$var$movePoint(start, -use);
            $f19a9c3655bf3498$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $b142ce28f127b38c$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $b142ce28f127b38c$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $b142ce28f127b38c$export$4cbf152802aa238)(nextEvents, (0, $6aa6db6f9342b9cb$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $b142ce28f127b38c$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $b142ce28f127b38c$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $b142ce28f127b38c$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f19a9c3655bf3498$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $29278eb21b71f12d$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $29278eb21b71f12d$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $f19a9c3655bf3498$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $b565e34650d07945$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $b565e34650d07945$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b565e34650d07945$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $296a6c1b4677472f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $296a6c1b4677472f$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $e38b1ec839deb091$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $e38b1ec839deb091$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $e38b1ec839deb091$var$tokenizeBlockQuoteContinuation
    },
    exit: $e38b1ec839deb091$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e38b1ec839deb091$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e38b1ec839deb091$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($e38b1ec839deb091$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $e38b1ec839deb091$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $55a4e534916e0573$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $55a4e534916e0573$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $55a4e534916e0573$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $296a6c1b4677472f$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $83093ef6e7d84cc9$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $fb10727878916b2f$var$own = {}.hasOwnProperty;
function $fb10727878916b2f$export$289b6a6320f709b4(value) {
    return $fb10727878916b2f$var$own.call((0, $83093ef6e7d84cc9$export$ec810d1aafce79a7), value) ? (0, $83093ef6e7d84cc9$export$ec810d1aafce79a7)[value] : false;
}



const $5d306e71056731e7$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $5d306e71056731e7$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5d306e71056731e7$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $296a6c1b4677472f$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $296a6c1b4677472f$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $296a6c1b4677472f$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $296a6c1b4677472f$export$75c76db11865a9f4) && !(0, $fb10727878916b2f$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $1dfa1eafc0dbc437$var$nonLazyContinuation = {
    tokenize: $1dfa1eafc0dbc437$var$tokenizeNonLazyContinuation,
    partial: true
};
const $1dfa1eafc0dbc437$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $1dfa1eafc0dbc437$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dfa1eafc0dbc437$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($1dfa1eafc0dbc437$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return effects.check($1dfa1eafc0dbc437$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1dfa1eafc0dbc437$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $cc322b40b4f04d8d$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $cc322b40b4f04d8d$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $cc322b40b4f04d8d$var$furtherStart = {
    tokenize: $cc322b40b4f04d8d$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cc322b40b4f04d8d$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return effects.attempt($cc322b40b4f04d8d$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $cc322b40b4f04d8d$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $b44ca4592096d54a$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $b44ca4592096d54a$var$tokenizeCodeText,
    resolve: $b44ca4592096d54a$var$resolveCodeText,
    previous: $b44ca4592096d54a$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $b44ca4592096d54a$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $b44ca4592096d54a$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b44ca4592096d54a$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $633104c52ba0e8bd$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $296a6c1b4677472f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $296a6c1b4677472f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $ea9adbb31fe6a035$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $54f7fd98c0aedfed$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $547cb2f90730c7ae$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $79d3b69b720e1f6a$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $8b63a35dd6a7b3c3$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $8b63a35dd6a7b3c3$var$tokenizeDefinition
};
/** @type {Construct} */ const $8b63a35dd6a7b3c3$var$titleBefore = {
    tokenize: $8b63a35dd6a7b3c3$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8b63a35dd6a7b3c3$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $ea9adbb31fe6a035$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) ? (0, $547cb2f90730c7ae$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $633104c52ba0e8bd$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($8b63a35dd6a7b3c3$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8b63a35dd6a7b3c3$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) ? (0, $547cb2f90730c7ae$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $54f7fd98c0aedfed$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $09b99882ac890b6f$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $09b99882ac890b6f$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $09b99882ac890b6f$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $6f8a30d2d0a7cd52$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $6f8a30d2d0a7cd52$var$tokenizeHeadingAtx,
    resolve: $6f8a30d2d0a7cd52$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $6f8a30d2d0a7cd52$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $b142ce28f127b38c$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6f8a30d2d0a7cd52$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $9d28fda47b8a14a7$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $9d28fda47b8a14a7$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $731e586e5bcf30a3$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $731e586e5bcf30a3$var$tokenizeHtmlFlow,
    resolveTo: $731e586e5bcf30a3$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $731e586e5bcf30a3$var$blankLineBefore = {
    tokenize: $731e586e5bcf30a3$var$tokenizeBlankLineBefore,
    partial: true
};
const $731e586e5bcf30a3$var$nonLazyContinuationStart = {
    tokenize: $731e586e5bcf30a3$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $731e586e5bcf30a3$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $731e586e5bcf30a3$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $9d28fda47b8a14a7$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $9d28fda47b8a14a7$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($731e586e5bcf30a3$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($731e586e5bcf30a3$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $9d28fda47b8a14a7$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $731e586e5bcf30a3$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $731e586e5bcf30a3$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $673f67134454d2b9$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $2df4d08b68988a6b$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $2df4d08b68988a6b$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2df4d08b68988a6b$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $296a6c1b4677472f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $296a6c1b4677472f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $296a6c1b4677472f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $67c08f5291e02161$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $67c08f5291e02161$var$tokenizeLabelEnd,
    resolveTo: $67c08f5291e02161$var$resolveToLabelEnd,
    resolveAll: $67c08f5291e02161$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $67c08f5291e02161$var$resourceConstruct = {
    tokenize: $67c08f5291e02161$var$tokenizeResource
};
/** @type {Construct} */ const $67c08f5291e02161$var$referenceFullConstruct = {
    tokenize: $67c08f5291e02161$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $67c08f5291e02161$var$referenceCollapsedConstruct = {
    tokenize: $67c08f5291e02161$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $67c08f5291e02161$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $67c08f5291e02161$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, (0, $6aa6db6f9342b9cb$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $b142ce28f127b38c$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $b142ce28f127b38c$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67c08f5291e02161$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($67c08f5291e02161$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($67c08f5291e02161$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($67c08f5291e02161$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67c08f5291e02161$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) ? (0, $547cb2f90730c7ae$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $633104c52ba0e8bd$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) ? (0, $547cb2f90730c7ae$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $54f7fd98c0aedfed$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $296a6c1b4677472f$export$a30284361b3814b7)(code) ? (0, $547cb2f90730c7ae$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67c08f5291e02161$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $ea9adbb31fe6a035$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $67c08f5291e02161$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $8b2a1645ba91c5e0$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $8b2a1645ba91c5e0$var$tokenizeLabelStartImage,
    resolveAll: (0, $67c08f5291e02161$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8b2a1645ba91c5e0$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $ab2ba2b1115628c7$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $ab2ba2b1115628c7$var$tokenizeLabelStartLink,
    resolveAll: (0, $67c08f5291e02161$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ab2ba2b1115628c7$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $0ce23e47fbb02ec4$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $0ce23e47fbb02ec4$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0ce23e47fbb02ec4$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $91a2cccb94820ceb$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $91a2cccb94820ceb$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $91a2cccb94820ceb$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $f3a52bfd0cb49b07$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $f3a52bfd0cb49b07$var$tokenizeListStart,
    continuation: {
        tokenize: $f3a52bfd0cb49b07$var$tokenizeListContinuation
    },
    exit: $f3a52bfd0cb49b07$var$tokenizeListEnd
};
/** @type {Construct} */ const $f3a52bfd0cb49b07$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $f3a52bfd0cb49b07$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $f3a52bfd0cb49b07$var$indentConstruct = {
    tokenize: $f3a52bfd0cb49b07$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $f3a52bfd0cb49b07$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $296a6c1b4677472f$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $91a2cccb94820ceb$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $296a6c1b4677472f$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $673f67134454d2b9$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($f3a52bfd0cb49b07$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $f3a52bfd0cb49b07$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $673f67134454d2b9$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($f3a52bfd0cb49b07$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, effects.attempt($f3a52bfd0cb49b07$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $f3a52bfd0cb49b07$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $f3a52bfd0cb49b07$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $f3a52bfd0cb49b07$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ffef4df98f04b016$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $ffef4df98f04b016$var$tokenizeSetextUnderline,
    resolveTo: $ffef4df98f04b016$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $ffef4df98f04b016$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ffef4df98f04b016$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $296a6c1b4677472f$export$2c6cf65c1127992a)(code) ? (0, $a1dd5f9ab5ac0d2e$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $296a6c1b4677472f$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $419927f7d8e7627f$export$5a7bfc01df82fcd1 = {
    [42]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [43]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [45]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [48]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [49]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [50]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [51]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [52]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [53]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [54]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [55]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [56]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [57]: (0, $f3a52bfd0cb49b07$export$8837f4fc672e936d),
    [62]: (0, $e38b1ec839deb091$export$200dcd0a5903c968)
};
const $419927f7d8e7627f$export$5a2181fb44b58173 = {
    [91]: (0, $8b63a35dd6a7b3c3$export$69f215ed977cdb73)
};
const $419927f7d8e7627f$export$cf8bead395eff824 = {
    [-2]: (0, $cc322b40b4f04d8d$export$47910b7ab28d1853),
    [-1]: (0, $cc322b40b4f04d8d$export$47910b7ab28d1853),
    [32]: (0, $cc322b40b4f04d8d$export$47910b7ab28d1853)
};
const $419927f7d8e7627f$export$ccc7b0636abaffc3 = {
    [35]: (0, $6f8a30d2d0a7cd52$export$3871e9deb360695c),
    [42]: (0, $91a2cccb94820ceb$export$ba7b13e047416c03),
    [45]: [
        (0, $ffef4df98f04b016$export$e104e2de391dfde9),
        (0, $91a2cccb94820ceb$export$ba7b13e047416c03)
    ],
    [60]: (0, $731e586e5bcf30a3$export$476ac411cb7d0d8f),
    [61]: (0, $ffef4df98f04b016$export$e104e2de391dfde9),
    [95]: (0, $91a2cccb94820ceb$export$ba7b13e047416c03),
    [96]: (0, $1dfa1eafc0dbc437$export$c23e4921f8d87e7c),
    [126]: (0, $1dfa1eafc0dbc437$export$c23e4921f8d87e7c)
};
const $419927f7d8e7627f$export$22b082955e083ec3 = {
    [38]: (0, $5d306e71056731e7$export$e31905600aaf3d8e),
    [92]: (0, $55a4e534916e0573$export$2005478564e78d96)
};
const $419927f7d8e7627f$export$6f093cfa640b7166 = {
    [-5]: (0, $0ce23e47fbb02ec4$export$8e62e0ad51c97b2),
    [-4]: (0, $0ce23e47fbb02ec4$export$8e62e0ad51c97b2),
    [-3]: (0, $0ce23e47fbb02ec4$export$8e62e0ad51c97b2),
    [33]: (0, $8b2a1645ba91c5e0$export$3d754936e25aa5f5),
    [38]: (0, $5d306e71056731e7$export$e31905600aaf3d8e),
    [42]: (0, $f19a9c3655bf3498$export$45b92471da762af7),
    [60]: [
        (0, $b565e34650d07945$export$17ddf85e4c916ad6),
        (0, $2df4d08b68988a6b$export$398af27f284914fe)
    ],
    [91]: (0, $ab2ba2b1115628c7$export$5c0cee0701a3b584),
    [92]: [
        (0, $09b99882ac890b6f$export$86c573ab9e06f418),
        (0, $55a4e534916e0573$export$2005478564e78d96)
    ],
    [93]: (0, $67c08f5291e02161$export$470a5dafbbf62654),
    [95]: (0, $f19a9c3655bf3498$export$45b92471da762af7),
    [96]: (0, $b44ca4592096d54a$export$d24f93e715f9df88)
};
const $419927f7d8e7627f$export$d44f260a3f9b69f5 = {
    null: [
        (0, $f19a9c3655bf3498$export$45b92471da762af7),
        (0, $51e7efd62ec4434a$export$50397835cbfdbc24)
    ]
};
const $419927f7d8e7627f$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $419927f7d8e7627f$export$e20fbacbb41798b = {
    null: []
};


function $ca43773336a74170$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $da94f2637cfcde08$export$86a865d89ef3c690)([
        $419927f7d8e7627f$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $2f841c3aeb378892$export$a7db06668cad9adb)),
        document: create((0, $f389ec61e4042960$export$5a7bfc01df82fcd1)),
        flow: create((0, $98e516f9bde13e32$export$ccc7b0636abaffc3)),
        string: create((0, $51e7efd62ec4434a$export$22b082955e083ec3)),
        text: create((0, $51e7efd62ec4434a$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $fb4aa273259315a1$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $721b8caefa14d620$var$search = /[\0\t\n\r]/g;
function $721b8caefa14d620$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $721b8caefa14d620$var$search.lastIndex = startPosition;
            match = $721b8caefa14d620$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $c0b9dc47f33a90ac$export$bd0e6e1378a871d7(events) {
    while(!(0, $abc0b51163aa224e$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $bcceb843a828de40$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}




const $50b4542018d2a46c$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $50b4542018d2a46c$export$a0fb664af7d0cc44(value) {
    return value.replace($50b4542018d2a46c$var$characterEscapeOrReference, $50b4542018d2a46c$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $50b4542018d2a46c$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $bcceb843a828de40$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $fb10727878916b2f$export$289b6a6320f709b4)($2) || $0;
}





const $66a35ea728a06b6c$var$own = {}.hasOwnProperty;
const $66a35ea728a06b6c$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $66a35ea728a06b6c$var$compiler(options)((0, $c0b9dc47f33a90ac$export$bd0e6e1378a871d7)((0, $ca43773336a74170$export$98e6a39c04603d36)(options).document().write((0, $721b8caefa14d620$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $66a35ea728a06b6c$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $66a35ea728a06b6c$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($66a35ea728a06b6c$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $66a35ea728a06b6c$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $66a35ea728a06b6c$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $66a35ea728a06b6c$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $66a35ea728a06b6c$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $4d5d7b88bd4b26a7$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $66a35ea728a06b6c$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $66a35ea728a06b6c$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $688fadfd085fa436$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $66a35ea728a06b6c$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $66a35ea728a06b6c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $66a35ea728a06b6c$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $50b4542018d2a46c$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $79d3b69b720e1f6a$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $bcceb843a828de40$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $fb10727878916b2f$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $66a35ea728a06b6c$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $66a35ea728a06b6c$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $66a35ea728a06b6c$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $66a35ea728a06b6c$var$configure(combined, value);
        else $66a35ea728a06b6c$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $66a35ea728a06b6c$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($66a35ea728a06b6c$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $66a35ea728a06b6c$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $4d5d7b88bd4b26a7$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $4d5d7b88bd4b26a7$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $4d5d7b88bd4b26a7$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $ee86d2f4f04519cc$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $66a35ea728a06b6c$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $6a91dd76d192c868$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $6a91dd76d192c868$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $6a91dd76d192c868$var$characterReferences[value] + ";";
    }
}


function $c354d2b47a6291e5$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $6a91dd76d192c868$export$c564cdbbe6da493)($c354d2b47a6291e5$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $c354d2b47a6291e5$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $296a6c1b4677472f$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $296a6c1b4677472f$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


function $f35d595356c275b6$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $bb0e5e121f837789$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $bb0e5e121f837789$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $bb0e5e121f837789$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $bb0e5e121f837789$var$ok;
    if (typeof test === "string") return $bb0e5e121f837789$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $bb0e5e121f837789$var$anyFactory(test) : $bb0e5e121f837789$var$propsFactory(test);
    if (typeof test === "function") return $bb0e5e121f837789$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $bb0e5e121f837789$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $bb0e5e121f837789$export$9c68d69a4c5bbcf9(tests[index]);
    return $bb0e5e121f837789$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $bb0e5e121f837789$var$propsFactory(check) {
    return $bb0e5e121f837789$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $bb0e5e121f837789$var$typeFactory(check) {
    return $bb0e5e121f837789$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $bb0e5e121f837789$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $bb0e5e121f837789$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $cd5cc65756d9b8ba$export$35e9368ef982300f(d) {
    return d;
}


const $6c8a96bce6c83b7b$export$f4d8133c446fe484 = true;
const $6c8a96bce6c83b7b$export$7f100f842f565dc9 = false;
const $6c8a96bce6c83b7b$export$8773f85c2fb2c116 = "skip";
const $6c8a96bce6c83b7b$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $bb0e5e121f837789$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $cd5cc65756d9b8ba$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $6c8a96bce6c83b7b$var$toResult(visitor(node, parents));
                if (result[0] === $6c8a96bce6c83b7b$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $6c8a96bce6c83b7b$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $6c8a96bce6c83b7b$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $6c8a96bce6c83b7b$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $6c8a96bce6c83b7b$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $8e1a3a54e94d526c$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $6c8a96bce6c83b7b$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $656b21b3e157fda0$export$771bf3e4949bfbee = $656b21b3e157fda0$var$point("start");
const $656b21b3e157fda0$export$da309cdce9dc2a25 = $656b21b3e157fda0$var$point("end");
function $656b21b3e157fda0$export$5880b8b5730aff45(node) {
    return {
        start: $656b21b3e157fda0$export$771bf3e4949bfbee(node),
        end: $656b21b3e157fda0$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $656b21b3e157fda0$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $4f05c6a2c7921080$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $79cf4c2461f65aa9$var$own = {}.hasOwnProperty;
function $79cf4c2461f65aa9$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $8e1a3a54e94d526c$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $79cf4c2461f65aa9$var$clean(definition.identifier);
        if (id && !$79cf4c2461f65aa9$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $79cf4c2461f65aa9$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $79cf4c2461f65aa9$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $79cf4c2461f65aa9$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $0acad4c2a494d905$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $8f29b0fe3d85a77f$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ea6cc32f84280d7a$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4613cca6c725e1c8$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4a04f4629a10aaa8$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $4b1d40853c9b2865$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $8628ef93816e158a$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $4b1d40853c9b2865$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $136c5d19b1634ce1$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $51f85773b13aac27$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $7d4bd40839e37311$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $4e46a7f41de241c5$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $7d4bd40839e37311$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $7b9963e3389ce8f0$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6ee316dec270d9a4$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $ca7faa938f525ad9$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $7d4bd40839e37311$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $7da24fdc7518533d$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $c354d2b47a6291e5$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $f025147613b14175$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $f025147613b14175$var$listLoose(parent) : $f025147613b14175$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $f025147613b14175$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $f025147613b14175$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $f025147613b14175$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e6b8f43d7952082c$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4f6bcc6c7402cbd1$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $09191433ecb10d78$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $55afe614960389e9$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $6c4a71f2c398e394$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $656b21b3e157fda0$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $656b21b3e157fda0$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $274b711de3ab6419$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $de183e95d7116e7b$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $9914770dbde729b3$var$tab = 9 /* `\t` */ ;
const $9914770dbde729b3$var$space = 32 /* ` ` */ ;
function $9914770dbde729b3$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($9914770dbde729b3$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($9914770dbde729b3$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $9914770dbde729b3$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $9914770dbde729b3$var$tab || code === $9914770dbde729b3$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $9914770dbde729b3$var$tab || code === $9914770dbde729b3$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $11d7fe2588b374a9$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $9914770dbde729b3$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7260d3a000b12665$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $a8ebd62eba84ceb2$export$455ce229eb3d2472 = {
    blockquote: $0acad4c2a494d905$export$67dc04e652a298ca,
    break: (0, $8f29b0fe3d85a77f$export$371da9dd35aba193),
    code: $ea6cc32f84280d7a$export$6565f9f03506010b,
    delete: (0, $4613cca6c725e1c8$export$19426ff118fe8be),
    emphasis: $4a04f4629a10aaa8$export$bef81ba411953b51,
    footnoteReference: $4b1d40853c9b2865$export$7f87ee744075c1ba,
    footnote: $8628ef93816e158a$export$3b6a720baa2c20ec,
    heading: $136c5d19b1634ce1$export$46e4a324ac90507f,
    html: $51f85773b13aac27$export$c0bb0b647f701bb5,
    imageReference: $4e46a7f41de241c5$export$f281796f6bc3b8db,
    image: $7b9963e3389ce8f0$export$5c452ff88e35e47d,
    inlineCode: $6ee316dec270d9a4$export$91b9bee19a0d8569,
    linkReference: $ca7faa938f525ad9$export$e6c469b1b7b2bc6a,
    link: $7da24fdc7518533d$export$9c30223ca0a664fb,
    listItem: $f025147613b14175$export$76c7e83ecc9cdf05,
    list: $e6b8f43d7952082c$export$8837f4fc672e936d,
    paragraph: $4f6bcc6c7402cbd1$export$9c206ddddb32a9b,
    root: $09191433ecb10d78$export$e8e78c978b129247,
    strong: $55afe614960389e9$export$59ae2c325a998f89,
    table: $6c4a71f2c398e394$export$9852986a3ec5f6a0,
    tableCell: $de183e95d7116e7b$export$e1e720e5f4603e6a,
    tableRow: $274b711de3ab6419$export$ce666bf02318c957,
    text: $11d7fe2588b374a9$export$6f093cfa640b7166,
    thematicBreak: $7260d3a000b12665$export$ba7b13e047416c03,
    toml: $a8ebd62eba84ceb2$var$ignore,
    yaml: $a8ebd62eba84ceb2$var$ignore,
    definition: $a8ebd62eba84ceb2$var$ignore,
    footnoteDefinition: $a8ebd62eba84ceb2$var$ignore
};
// Return nothing for nodes that are ignored.
function $a8ebd62eba84ceb2$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $926ed36763b1c5fd$var$own = {}.hasOwnProperty;
function $926ed36763b1c5fd$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $a8ebd62eba84ceb2$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $79cf4c2461f65aa9$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $926ed36763b1c5fd$var$patch;
    state.applyData = $926ed36763b1c5fd$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $926ed36763b1c5fd$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $8e1a3a54e94d526c$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$926ed36763b1c5fd$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $4f05c6a2c7921080$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $656b21b3e157fda0$export$771bf3e4949bfbee)(ctx),
                end: (0, $656b21b3e157fda0$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $926ed36763b1c5fd$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $926ed36763b1c5fd$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $926ed36763b1c5fd$var$patch(from, to) {
    if (from.position) to.position = (0, $656b21b3e157fda0$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $926ed36763b1c5fd$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $926ed36763b1c5fd$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($926ed36763b1c5fd$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $926ed36763b1c5fd$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $926ed36763b1c5fd$var$defaultUnknownHandler(state, node);
}
function $926ed36763b1c5fd$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $926ed36763b1c5fd$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $926ed36763b1c5fd$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($926ed36763b1c5fd$var$own.call(data, "hProperties") || $926ed36763b1c5fd$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $926ed36763b1c5fd$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $926ed36763b1c5fd$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $f7f34b97ab79a6dc$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $926ed36763b1c5fd$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $f35d595356c275b6$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $b6c7dda15a418ae4$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $b6c7dda15a418ae4$var$bridge(destination, options) : $b6c7dda15a418ae4$var$mutate(destination || options);
};
var $b6c7dda15a418ae4$export$2e2bcd8739ae039 = $b6c7dda15a418ae4$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $b6c7dda15a418ae4$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $f7f34b97ab79a6dc$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $b6c7dda15a418ae4$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $f7f34b97ab79a6dc$export$c0e4c5cf07538633)(node, options);
}



var $6AdSR = parcelRequire("6AdSR");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $2e47e82a4e35f735$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $2e47e82a4e35f735$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $2e47e82a4e35f735$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $2e47e82a4e35f735$export$19342e026b58ebb7.prototype.space = null;


function $7010a526fcec334c$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $2e47e82a4e35f735$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $4ddc2ee1527219c5$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $ee84812c4b57762c$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $ee84812c4b57762c$export$c4868e4a24d48fad.prototype.space = null;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.boolean = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.booleanish = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.number = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$ee84812c4b57762c$export$c4868e4a24d48fad.prototype.defined = false;


var $e61400f77959f270$exports = {};

$parcel$export($e61400f77959f270$exports, "boolean", () => $e61400f77959f270$export$4a21f16c33752377);
$parcel$export($e61400f77959f270$exports, "booleanish", () => $e61400f77959f270$export$55e9e1fbc638dc8f);
$parcel$export($e61400f77959f270$exports, "overloadedBoolean", () => $e61400f77959f270$export$242ac3d3042558aa);
$parcel$export($e61400f77959f270$exports, "number", () => $e61400f77959f270$export$98e628dec113755e);
$parcel$export($e61400f77959f270$exports, "spaceSeparated", () => $e61400f77959f270$export$ab8645c862eb5a3e);
$parcel$export($e61400f77959f270$exports, "commaSeparated", () => $e61400f77959f270$export$9c8d678629b3d3);
$parcel$export($e61400f77959f270$exports, "commaOrSpaceSeparated", () => $e61400f77959f270$export$2ad25cfebf36cacd);
let $e61400f77959f270$var$powers = 0;
const $e61400f77959f270$export$4a21f16c33752377 = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$55e9e1fbc638dc8f = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$242ac3d3042558aa = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$98e628dec113755e = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$ab8645c862eb5a3e = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$9c8d678629b3d3 = $e61400f77959f270$var$increment();
const $e61400f77959f270$export$2ad25cfebf36cacd = $e61400f77959f270$var$increment();
function $e61400f77959f270$var$increment() {
    return 2 ** ++$e61400f77959f270$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $213862faecd40948$var$checks = Object.keys($e61400f77959f270$exports);
class $213862faecd40948$export$ea6b9f0064e88c9b extends (0, $ee84812c4b57762c$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $213862faecd40948$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $213862faecd40948$var$checks.length){
            const check = $213862faecd40948$var$checks[index];
            $213862faecd40948$var$mark(this, $213862faecd40948$var$checks[index], (mask & $e61400f77959f270$exports[check]) === $e61400f77959f270$exports[check]);
        }
    }
}
$213862faecd40948$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $213862faecd40948$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $486b824ab631baf2$var$own = {}.hasOwnProperty;
function $486b824ab631baf2$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($486b824ab631baf2$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $213862faecd40948$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $4ddc2ee1527219c5$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $4ddc2ee1527219c5$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $2e47e82a4e35f735$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $ea6e8467d3b7ac4d$export$2bd1230ec7600845 = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $213f1dbd09b13ce0$export$f2913fe8983302e = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $9f0270561024b106$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $308b9199756be8c6$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $9f0270561024b106$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $8da4310ba6a52d36$export$e20c24a128671213 = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $308b9199756be8c6$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $2c839196e38cff28$export$4d2d26490572750a = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaColIndex: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaColSpan: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaControls: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaLevel: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaPressed: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaRowIndex: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaRowSpan: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaSelected: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaValueMin: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaValueNow: (0, $e61400f77959f270$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $dc1298ac708bc804$export$c0bb0b647f701bb5 = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $308b9199756be8c6$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $e61400f77959f270$export$9c8d678629b3d3),
        acceptCharset: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        accessKey: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $e61400f77959f270$export$4a21f16c33752377),
        allowPaymentRequest: (0, $e61400f77959f270$export$4a21f16c33752377),
        allowUserMedia: (0, $e61400f77959f270$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $e61400f77959f270$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        autoFocus: (0, $e61400f77959f270$export$4a21f16c33752377),
        autoPlay: (0, $e61400f77959f270$export$4a21f16c33752377),
        blocking: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $e61400f77959f270$export$4a21f16c33752377),
        cite: null,
        className: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        cols: (0, $e61400f77959f270$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        controls: (0, $e61400f77959f270$export$4a21f16c33752377),
        controlsList: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        coords: (0, $e61400f77959f270$export$98e628dec113755e) | (0, $e61400f77959f270$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $e61400f77959f270$export$4a21f16c33752377),
        defer: (0, $e61400f77959f270$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $e61400f77959f270$export$4a21f16c33752377),
        download: (0, $e61400f77959f270$export$242ac3d3042558aa),
        draggable: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $e61400f77959f270$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        height: (0, $e61400f77959f270$export$98e628dec113755e),
        hidden: (0, $e61400f77959f270$export$4a21f16c33752377),
        high: (0, $e61400f77959f270$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        httpEquiv: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $e61400f77959f270$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $e61400f77959f270$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        itemRef: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        itemScope: (0, $e61400f77959f270$export$4a21f16c33752377),
        itemType: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $e61400f77959f270$export$4a21f16c33752377),
        low: (0, $e61400f77959f270$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $e61400f77959f270$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $e61400f77959f270$export$98e628dec113755e),
        multiple: (0, $e61400f77959f270$export$4a21f16c33752377),
        muted: (0, $e61400f77959f270$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $e61400f77959f270$export$4a21f16c33752377),
        noValidate: (0, $e61400f77959f270$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $e61400f77959f270$export$4a21f16c33752377),
        optimum: (0, $e61400f77959f270$export$98e628dec113755e),
        pattern: null,
        ping: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $e61400f77959f270$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $e61400f77959f270$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        required: (0, $e61400f77959f270$export$4a21f16c33752377),
        reversed: (0, $e61400f77959f270$export$4a21f16c33752377),
        rows: (0, $e61400f77959f270$export$98e628dec113755e),
        rowSpan: (0, $e61400f77959f270$export$98e628dec113755e),
        sandbox: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $e61400f77959f270$export$4a21f16c33752377),
        seamless: (0, $e61400f77959f270$export$4a21f16c33752377),
        selected: (0, $e61400f77959f270$export$4a21f16c33752377),
        shadowRootClonable: (0, $e61400f77959f270$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $e61400f77959f270$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $e61400f77959f270$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $e61400f77959f270$export$98e628dec113755e),
        spellCheck: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $e61400f77959f270$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $e61400f77959f270$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $e61400f77959f270$export$4a21f16c33752377),
        useMap: null,
        value: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        width: (0, $e61400f77959f270$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $e61400f77959f270$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $e61400f77959f270$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $e61400f77959f270$export$4a21f16c33752377),
        declare: (0, $e61400f77959f270$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $e61400f77959f270$export$98e628dec113755e),
        leftMargin: (0, $e61400f77959f270$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $e61400f77959f270$export$98e628dec113755e),
        marginWidth: (0, $e61400f77959f270$export$98e628dec113755e),
        noResize: (0, $e61400f77959f270$export$4a21f16c33752377),
        noHref: (0, $e61400f77959f270$export$4a21f16c33752377),
        noShade: (0, $e61400f77959f270$export$4a21f16c33752377),
        noWrap: (0, $e61400f77959f270$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $e61400f77959f270$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $e61400f77959f270$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $e61400f77959f270$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $e61400f77959f270$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $e61400f77959f270$export$4a21f16c33752377),
        disableRemotePlayback: (0, $e61400f77959f270$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $e61400f77959f270$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $686fce8db277c4c6$export$7ed1367e7fa1ad68 = (0, $486b824ab631baf2$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $9f0270561024b106$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        accentHeight: (0, $e61400f77959f270$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $e61400f77959f270$export$98e628dec113755e),
        amplitude: (0, $e61400f77959f270$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $e61400f77959f270$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $e61400f77959f270$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $e61400f77959f270$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $e61400f77959f270$export$98e628dec113755e),
        className: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $e61400f77959f270$export$98e628dec113755e),
        diffuseConstant: (0, $e61400f77959f270$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $e61400f77959f270$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $e61400f77959f270$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $e61400f77959f270$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $e61400f77959f270$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $e61400f77959f270$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $e61400f77959f270$export$9c8d678629b3d3),
        g2: (0, $e61400f77959f270$export$9c8d678629b3d3),
        glyphName: (0, $e61400f77959f270$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $e61400f77959f270$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $e61400f77959f270$export$98e628dec113755e),
        horizOriginX: (0, $e61400f77959f270$export$98e628dec113755e),
        horizOriginY: (0, $e61400f77959f270$export$98e628dec113755e),
        id: null,
        ideographic: (0, $e61400f77959f270$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $e61400f77959f270$export$98e628dec113755e),
        k: (0, $e61400f77959f270$export$98e628dec113755e),
        k1: (0, $e61400f77959f270$export$98e628dec113755e),
        k2: (0, $e61400f77959f270$export$98e628dec113755e),
        k3: (0, $e61400f77959f270$export$98e628dec113755e),
        k4: (0, $e61400f77959f270$export$98e628dec113755e),
        kernelMatrix: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $e61400f77959f270$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $e61400f77959f270$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $e61400f77959f270$export$98e628dec113755e),
        overlineThickness: (0, $e61400f77959f270$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $e61400f77959f270$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $e61400f77959f270$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $e61400f77959f270$export$98e628dec113755e),
        pointsAtY: (0, $e61400f77959f270$export$98e628dec113755e),
        pointsAtZ: (0, $e61400f77959f270$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        rev: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        requiredFonts: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        requiredFormats: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $e61400f77959f270$export$98e628dec113755e),
        specularExponent: (0, $e61400f77959f270$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $e61400f77959f270$export$98e628dec113755e),
        strikethroughThickness: (0, $e61400f77959f270$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $e61400f77959f270$export$98e628dec113755e),
        strokeOpacity: (0, $e61400f77959f270$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $e61400f77959f270$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        tabIndex: (0, $e61400f77959f270$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $e61400f77959f270$export$98e628dec113755e),
        targetY: (0, $e61400f77959f270$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $e61400f77959f270$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $e61400f77959f270$export$98e628dec113755e),
        underlineThickness: (0, $e61400f77959f270$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $e61400f77959f270$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $e61400f77959f270$export$98e628dec113755e),
        vMathematical: (0, $e61400f77959f270$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $e61400f77959f270$export$98e628dec113755e),
        vIdeographic: (0, $e61400f77959f270$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $e61400f77959f270$export$98e628dec113755e),
        vertOriginX: (0, $e61400f77959f270$export$98e628dec113755e),
        vertOriginY: (0, $e61400f77959f270$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $e61400f77959f270$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $b5cc7c84b7ddf5c0$var$valid = /^data[-\w.:]+$/i;
const $b5cc7c84b7ddf5c0$var$dash = /-[a-z]/g;
const $b5cc7c84b7ddf5c0$var$cap = /[A-Z]/g;
function $b5cc7c84b7ddf5c0$export$71aa6c912b956294(schema, value) {
    const normal = (0, $4ddc2ee1527219c5$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $ee84812c4b57762c$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $b5cc7c84b7ddf5c0$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($b5cc7c84b7ddf5c0$var$dash, $b5cc7c84b7ddf5c0$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$b5cc7c84b7ddf5c0$var$dash.test(rest)) {
                let dashes = rest.replace($b5cc7c84b7ddf5c0$var$cap, $b5cc7c84b7ddf5c0$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $213862faecd40948$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $b5cc7c84b7ddf5c0$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $b5cc7c84b7ddf5c0$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d57fc87dcd48d155$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $c73db355e4ce9bb7$export$c0bb0b647f701bb5 = (0, $7010a526fcec334c$export$4950aa0f605343fb)([
    (0, $213f1dbd09b13ce0$export$f2913fe8983302e),
    (0, $ea6e8467d3b7ac4d$export$2bd1230ec7600845),
    (0, $8da4310ba6a52d36$export$e20c24a128671213),
    (0, $2c839196e38cff28$export$4d2d26490572750a),
    (0, $dc1298ac708bc804$export$c0bb0b647f701bb5)
], "html");
const $c73db355e4ce9bb7$export$7ed1367e7fa1ad68 = (0, $7010a526fcec334c$export$4950aa0f605343fb)([
    (0, $213f1dbd09b13ce0$export$f2913fe8983302e),
    (0, $ea6e8467d3b7ac4d$export$2bd1230ec7600845),
    (0, $8da4310ba6a52d36$export$e20c24a128671213),
    (0, $2c839196e38cff28$export$4d2d26490572750a),
    (0, $686fce8db277c4c6$export$7ed1367e7fa1ad68)
], "svg");



function $67ba0f3c809cdfa8$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $8e1a3a54e94d526c$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $dup7A = parcelRequire("dup7A");

var $8vAu6 = parcelRequire("8vAu6");
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $22285467c5323342$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $2a35dea620178340$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $2a35dea620178340$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $cc35b1d249883c9f$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $cc35b1d249883c9f$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $75a2dfa71760c7a8$exports = {};
var $adbdf5791a9cc101$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $adbdf5791a9cc101$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $adbdf5791a9cc101$var$NEWLINE_REGEX = /\n/g;
var $adbdf5791a9cc101$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $adbdf5791a9cc101$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $adbdf5791a9cc101$var$COLON_REGEX = /^:\s*/;
var $adbdf5791a9cc101$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $adbdf5791a9cc101$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $adbdf5791a9cc101$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $adbdf5791a9cc101$var$NEWLINE = "\n";
var $adbdf5791a9cc101$var$FORWARD_SLASH = "/";
var $adbdf5791a9cc101$var$ASTERISK = "*";
var $adbdf5791a9cc101$var$EMPTY_STRING = "";
// types
var $adbdf5791a9cc101$var$TYPE_COMMENT = "comment";
var $adbdf5791a9cc101$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $adbdf5791a9cc101$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($adbdf5791a9cc101$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($adbdf5791a9cc101$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($adbdf5791a9cc101$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($adbdf5791a9cc101$var$FORWARD_SLASH != style.charAt(0) || $adbdf5791a9cc101$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($adbdf5791a9cc101$var$EMPTY_STRING != style.charAt(i) && ($adbdf5791a9cc101$var$ASTERISK != style.charAt(i) || $adbdf5791a9cc101$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($adbdf5791a9cc101$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $adbdf5791a9cc101$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($adbdf5791a9cc101$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($adbdf5791a9cc101$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($adbdf5791a9cc101$var$VALUE_REGEX);
        var ret = pos({
            type: $adbdf5791a9cc101$var$TYPE_DECLARATION,
            property: $adbdf5791a9cc101$var$trim(prop[0].replace($adbdf5791a9cc101$var$COMMENT_REGEX, $adbdf5791a9cc101$var$EMPTY_STRING)),
            value: val ? $adbdf5791a9cc101$var$trim(val[0].replace($adbdf5791a9cc101$var$COMMENT_REGEX, $adbdf5791a9cc101$var$EMPTY_STRING)) : $adbdf5791a9cc101$var$EMPTY_STRING
        });
        // ;
        match($adbdf5791a9cc101$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $adbdf5791a9cc101$var$trim(str) {
    return str ? str.replace($adbdf5791a9cc101$var$TRIM_REGEX, $adbdf5791a9cc101$var$EMPTY_STRING) : $adbdf5791a9cc101$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $75a2dfa71760c7a8$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $adbdf5791a9cc101$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$75a2dfa71760c7a8$exports = $75a2dfa71760c7a8$var$StyleToObject;
$75a2dfa71760c7a8$exports.default = $75a2dfa71760c7a8$var$StyleToObject; // ESM support


var $165a8ab15ae01777$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($75a2dfa71760c7a8$exports)));


const $56a4232369f25c3e$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $56a4232369f25c3e$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $56a4232369f25c3e$var$protocols.length){
        const protocol = $56a4232369f25c3e$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $73117b2b2b6d800a$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $73117b2b2b6d800a$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $73117b2b2b6d800a$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($73117b2b2b6d800a$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$73117b2b2b6d800a$var$tableElements.has(node.tagName) || !(0, $22285467c5323342$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $73117b2b2b6d800a$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $56a4232369f25c3e$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $c73db355e4ce9bb7$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($73117b2b2b6d800a$var$own.call(node.properties, property)) $73117b2b2b6d800a$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $73117b2b2b6d800a$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $73117b2b2b6d800a$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8vAu6))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $73117b2b2b6d800a$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $73117b2b2b6d800a$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $73117b2b2b6d800a$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $73117b2b2b6d800a$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $73117b2b2b6d800a$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $73117b2b2b6d800a$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $73117b2b2b6d800a$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $73117b2b2b6d800a$var$addProperty(props, prop, value, ctx) {
    const info = (0, $b5cc7c84b7ddf5c0$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $cc35b1d249883c9f$export$fac44ee5b035f737)(result) : (0, $2a35dea620178340$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $73117b2b2b6d800a$var$parseStyle(result);
    if (info.space && info.property) props[$73117b2b2b6d800a$var$own.call((0, $d57fc87dcd48d155$export$d8abd7e5fb6871f9), info.property) ? (0, $d57fc87dcd48d155$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $73117b2b2b6d800a$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $165a8ab15ae01777$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $73117b2b2b6d800a$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $73117b2b2b6d800a$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $73117b2b2b6d800a$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $d9f9dbcfca8039a4$var$own = {}.hasOwnProperty;
const $d9f9dbcfca8039a4$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $d9f9dbcfca8039a4$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $d9f9dbcfca8039a4$export$83ef7ab426386201(options) {
    for(const key in $d9f9dbcfca8039a4$var$deprecated)if ($d9f9dbcfca8039a4$var$own.call($d9f9dbcfca8039a4$var$deprecated, key) && $d9f9dbcfca8039a4$var$own.call(options, key)) {
        const deprecation = $d9f9dbcfca8039a4$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$d9f9dbcfca8039a4$var$changelog}#${deprecation.id}> for more info)`);
        delete $d9f9dbcfca8039a4$var$deprecated[key];
    }
    const processor = (0, $47a139d5bce6fa91$export$7cc1b2fe10c52bb)().use((0, $ee86d2f4f04519cc$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $b6c7dda15a418ae4$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $67ba0f3c809cdfa8$export$2e2bcd8739ae039), options);
    const file = new (0, $91ce9774873ed85e$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, {}, (0, $73117b2b2b6d800a$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $c73db355e4ce9bb7$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$d9f9dbcfca8039a4$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($6AdSR))).object
};


const $66a2c9a2e00e09e7$var$StyledMarkdown = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201))`
  font-size: 16px;
  *,
  ** {
    font-size: 16px;
  }
`;
const $66a2c9a2e00e09e7$var$ReactMarkdown = ({ children: children })=>/*#__PURE__*/ (0, $cZGFG.jsx)($66a2c9a2e00e09e7$var$StyledMarkdown, {
        children: children
    });
var $66a2c9a2e00e09e7$export$2e2bcd8739ae039 = $66a2c9a2e00e09e7$var$ReactMarkdown;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $gg0RY = parcelRequire("gg0RY");



const $e31266a9472b8e30$var$AliasContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  min-height: 32px;
  display: flex;
  gap: 8px;
  align-items: center;
`;
const $e31266a9472b8e30$var$TextContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  > label {
    color: ${({ theme: theme })=>theme.primaryText};
    font-size: 14px;
  }
`;
const $e31266a9472b8e30$var$AliasDisplay = ({ alias: alias })=>{
    const { data: addressFromENS, isLoading: isLoading } = (0, $1d657eb5d64e17dc$export$882e13b9ff368f82)({
        enabled: !(0, $gg0RY.isAddress)(alias.address),
        name: alias.address,
        chainId: 1
    });
    // try fetching ens name, else go with address
    const address = addressFromENS ?? alias.address;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($e31266a9472b8e30$var$AliasContainer, {
        children: [
            isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                width: 30,
                height: 24
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$f8b4f9182cfa7b1d), {
                address: address,
                size: "24"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($e31266a9472b8e30$var$TextContainer, {
                children: [
                    isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                        width: 30,
                        height: 24
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$6cdabdfc8e8da8af), {
                        address: address
                    }),
                    "\xa0",
                    !(0, $2d857633ba67aa25$export$fce6876652108ab)(alias.name) && alias.name !== "" ? /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                        children: [
                            "(",
                            alias.name,
                            ")"
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var $e31266a9472b8e30$export$2e2bcd8739ae039 = $e31266a9472b8e30$var$AliasDisplay;


const $829f76996267db48$var$StyledH1 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin: 0;
`;
const $829f76996267db48$var$QuestionAndDescription = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  div:first-child p:first-of-type {
    font-size: 16px;
    font-weight: 600;
  }
`;
const $829f76996267db48$var$StyledReactMarkDown = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $66a2c9a2e00e09e7$export$2e2bcd8739ae039))`
  margin: 0px;
`;
const $829f76996267db48$var$VotingOptions = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)($829f76996267db48$var$QuestionAndDescription)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $829f76996267db48$var$AnswersContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $829f76996267db48$var$Answer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(2, 8)};
`;
const $829f76996267db48$var$AliasesContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 20)};
`;
const $829f76996267db48$var$Divider = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).hr`
  width: 100%;
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: 0;
`;
const $829f76996267db48$export$e7a634c764273922 = ({ disputeDetails: disputeDetails, isRpcError: isRpcError = false })=>{
    const errMsg = isRpcError ? (0, $203b613495c69c62$export$adca62214545ea7b) : (0, $203b613495c69c62$export$7142fb39be536070);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$StyledH1, {
                children: (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails) ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {}) : disputeDetails?.title ?? errMsg
            }),
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails) && /*#__PURE__*/ (0, $cZGFG.jsxs)($829f76996267db48$var$QuestionAndDescription, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$StyledReactMarkDown, {
                        children: disputeDetails?.question
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$StyledReactMarkDown, {
                        children: disputeDetails?.description
                    })
                ]
            }),
            (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails?.frontendUrl) ? null : /*#__PURE__*/ (0, $cZGFG.jsx)("a", {
                href: disputeDetails?.frontendUrl,
                target: "_blank",
                rel: "noreferrer",
                children: "Go to arbitrable"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($829f76996267db48$var$VotingOptions, {
                children: [
                    (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails) ? null : /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
                        children: "Voting Options"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$AnswersContainer, {
                        children: disputeDetails?.answers?.map((answer, i)=>/*#__PURE__*/ (0, $cZGFG.jsxs)($829f76996267db48$var$Answer, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsxs)("small", {
                                        children: [
                                            "Option ",
                                            i + 1,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                                        children: [
                                            answer.title,
                                            answer.description ? ` - ${answer.description}` : null
                                        ]
                                    })
                                ]
                            }, answer.title))
                    })
                ]
            }),
            (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails?.aliases) ? null : /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$Divider, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($829f76996267db48$var$AliasesContainer, {
                        children: disputeDetails.aliases.map((alias)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $e31266a9472b8e30$export$2e2bcd8739ae039), {
                                alias: alias
                            }, alias.address))
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $d5d63e5380b02bd0$var$SvgPaperclip = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 373.482 373.482",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M355.488 84.873c-2.401-22.768-13.499-43.217-31.249-57.579l-10.213-8.266C298.863 6.757 279.765 0 260.246 0c-26.031 0-50.317 11.563-66.632 31.726L36.583 225.781c-14.386 17.773-20.989 40.088-18.591 62.831 2.398 22.741 13.51 43.188 31.288 57.576l10.213 8.266c15.161 12.271 34.258 19.028 53.772 19.028 3.013 0 6.061-.161 9.059-.479 22.604-2.383 42.957-13.367 57.251-30.859.048-.056.076-.089 105.94-130.895 18.854-23.303 15.236-57.602-8.063-76.458l-5.353-4.329a54.453 54.453 0 0 0-34.149-12.083c-16.527 0-31.947 7.343-42.307 20.145L89.902 269.192c-6.909 8.54-5.584 21.11 2.956 28.021a19.973 19.973 0 0 0 12.521 4.434 19.852 19.852 0 0 0 15.5-7.389L226.618 163.59c2.766-3.417 6.886-5.377 11.302-5.377 3.356 0 6.507 1.115 9.113 3.224l5.354 4.334a14.412 14.412 0 0 1 5.295 9.762c.406 3.862-.709 7.645-3.144 10.651L148.92 316.704c-8.721 10.77-21.703 16.945-35.618 16.946a45.824 45.824 0 0 1-28.744-10.171l-10.213-8.264c-9.504-7.693-15.445-18.625-16.726-30.781-1.282-12.157 2.247-24.088 9.938-33.59L224.589 56.791c8.721-10.776 21.707-16.957 35.628-16.957a45.828 45.828 0 0 1 28.744 10.169l10.212 8.264c19.619 15.877 22.664 44.754 6.789 64.372a19.794 19.794 0 0 0-4.326 14.623 19.798 19.798 0 0 0 7.28 13.397 19.974 19.974 0 0 0 12.522 4.436 19.85 19.85 0 0 0 15.498-7.39c14.365-17.75 20.954-40.065 18.552-62.832z"
        })
    });
var $d5d63e5380b02bd0$export$2e2bcd8739ae039 = $d5d63e5380b02bd0$var$SvgPaperclip;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $9b3ea26762e25e53$var$SvgPolicy = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M12.5 2H10c0-1.103-.897-2-2-2S6 .897 6 2H3.5A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 12.5 2ZM8 1.25c.416 0 .75.334.75.75s-.334.75-.75.75A.748.748 0 0 1 7.25 2c0-.416.334-.75.75-.75Zm3.787 7.244L7.32 12.925a.375.375 0 0 1-.532-.003l-2.58-2.603a.375.375 0 0 1 .002-.532l.888-.88a.375.375 0 0 1 .531.002l1.438 1.45 3.312-3.287a.375.375 0 0 1 .531.003l.882.888a.375.375 0 0 1-.004.53Z"
        })
    });
var $9b3ea26762e25e53$export$2e2bcd8739ae039 = $9b3ea26762e25e53$var$SvgPolicy;






const $80e9b305c1fae669$var$ShadeArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 20)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  margin-top: 16px;
  background-color: ${({ theme: theme })=>theme.mediumBlue};

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      justify-content: space-between;
    `)};
`;
const $80e9b305c1fae669$var$StyledP = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).p`
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 16px;
  color: ${({ theme: theme })=>theme.primaryBlue};
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-bottom: 0;
    `)};
`;
const $80e9b305c1fae669$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  align-items: center;
  gap: 4px;
`;
const $80e9b305c1fae669$var$StyledPolicyIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $9b3ea26762e25e53$export$2e2bcd8739ae039))`
  width: 16px;
  fill: ${({ theme: theme })=>theme.primaryBlue};
`;
const $80e9b305c1fae669$var$StyledPaperclipIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d5d63e5380b02bd0$export$2e2bcd8739ae039))`
  width: 16px;
  fill: ${({ theme: theme })=>theme.primaryBlue};
`;
const $80e9b305c1fae669$var$LinkContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 24)};
  flex-wrap: wrap;
`;
const $80e9b305c1fae669$export$e9859ad90648930b = ({ disputePolicyURI: disputePolicyURI, courtId: courtId, attachment: attachment })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($80e9b305c1fae669$var$ShadeArea, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($80e9b305c1fae669$var$StyledP, {
                children: "Make sure you read and understand the Policies"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($80e9b305c1fae669$var$LinkContainer, {
                children: [
                    !(0, $2d857633ba67aa25$export$fce6876652108ab)(attachment) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(attachment.uri) ? /*#__PURE__*/ (0, $cZGFG.jsxs)($80e9b305c1fae669$var$StyledA, {
                        href: (0, $862ad37af5a70e26$export$99de037bb933f932)(attachment.uri),
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($80e9b305c1fae669$var$StyledPaperclipIcon, {}),
                            attachment.label ?? "Attachment"
                        ]
                    }) : null,
                    (0, $2d857633ba67aa25$export$fce6876652108ab)(disputePolicyURI) ? null : /*#__PURE__*/ (0, $cZGFG.jsxs)($80e9b305c1fae669$var$StyledA, {
                        href: (0, $862ad37af5a70e26$export$99de037bb933f932)(disputePolicyURI),
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($80e9b305c1fae669$var$StyledPolicyIcon, {}),
                            "Dispute Policy"
                        ]
                    }),
                    (0, $2d857633ba67aa25$export$fce6876652108ab)(courtId) ? null : /*#__PURE__*/ (0, $cZGFG.jsxs)($80e9b305c1fae669$var$StyledA, {
                        href: `#/courts/${courtId}/purpose?section=description`,
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($80e9b305c1fae669$var$StyledPolicyIcon, {}),
                            "Court Policy"
                        ]
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $d15fda946aef10b5$var$SvgBookmark = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('b1bd6d0660c8244f')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M11.173.5H3.096c-.743 0-1.346.588-1.346 1.313V14.5l5.385-3.063 5.384 3.063V1.812c0-.724-.603-1.312-1.346-1.312Zm0 11.715L7.135 9.918l-4.039 2.297V1.977c0-.044.018-.086.05-.116a.17.17 0 0 1 .118-.048h7.74c.094 0 .17.073.17.163v10.239Z"
            })
        })
    });
var $d15fda946aef10b5$export$2e2bcd8739ae039 = $d15fda946aef10b5$var$SvgBookmark;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $a1a18341232cf359$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('4bc23d2052dd4461')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M4.922 8.375H3.828a.33.33 0 0 1-.328-.328V6.953a.33.33 0 0 1 .328-.328h1.094a.33.33 0 0 1 .328.328v1.094a.33.33 0 0 1-.328.328Zm2.953-.328V6.953a.33.33 0 0 0-.328-.328H6.453a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm2.625 0V6.953a.33.33 0 0 0-.328-.328H9.078a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm-2.625 2.625V9.578a.33.33 0 0 0-.328-.328H6.453a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm-2.625 0V9.578a.33.33 0 0 0-.328-.328H3.828a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm5.25 0V9.578a.33.33 0 0 0-.328-.328H9.078a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm2.625-7.11v9.626c0 .724-.588 1.312-1.313 1.312H2.188a1.313 1.313 0 0 1-1.313-1.313V3.563c0-.725.588-1.313 1.313-1.313H3.5V.828A.33.33 0 0 1 3.828.5h1.094a.33.33 0 0 1 .328.328V2.25h3.5V.828A.33.33 0 0 1 9.078.5h1.094a.33.33 0 0 1 .328.328V2.25h1.313c.724 0 1.312.588 1.312 1.313Zm-1.313 9.461V4.875H2.188v8.148c0 .09.073.165.164.165h9.296c.09 0 .165-.074.165-.165Z"
            })
        })
    });
var $a1a18341232cf359$export$2e2bcd8739ae039 = $a1a18341232cf359$var$SvgCalendar;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $6ffbdc979e08a453$var$SvgLawBalance = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('e6262d172f9d5d9d')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.792 3.151c0 .375-.085.59-.222.712l3.777 1.127a.589.589 0 1 1 .635.977l1.322 3.803c.419.066.696.165.696.295 0 .533-1.045.966-2.333.966-1.289 0-2.334-.433-2.334-.966 0-.139.313-.241.777-.308l1.326-3.815a.59.59 0 0 1-.261-.319c-.045-.185-.149-.301-.311-.35-.195-.058-.385-.065-.598-.072-.269-.01-.573-.02-.966-.137l-1.919-.572v3.91a.586.586 0 0 1 .132.827.79.79 0 0 1-.132 1.351v.817c.872.045 1.536.28 1.536.563v.014c1.406.122 2.377.38 2.377.679l.007.417c0 .415-1.871.749-4.184.749-2.312 0-4.184-.34-4.184-.756l-.013-.41c0-.294.94-.549 2.31-.673a.184.184 0 0 1 0-.02c0-.278.642-.51 1.492-.56v-.807a.793.793 0 0 1-.158-1.364.583.583 0 0 1 .158-.845v-4.09l-2.188-.652c-.146-.044-.359-.159-.587-.282-.261-.142-.542-.294-.761-.36-.153-.045-.309-.012-.47.1a.592.592 0 0 1-.1.065l1.32 3.795c.438.066.73.167.73.3 0 .534-1.044.966-2.333.966C1.045 8.226 0 7.794 0 7.26c0-.13.275-.228.692-.294l1.33-3.828a.587.587 0 0 1 .321-1.082.59.59 0 0 1 .564.415L6.3 3.483a1.714 1.714 0 0 1-.028-.332c0-.5.253-1.093.76-1.776.507.683.76 1.275.76 1.776Zm4.073 2.856 1.301 3.743c-.82-.11-2.071-.114-2.919-.01l1.303-3.747a.59.59 0 0 0 .315.014ZM.83 6.946l1.304-3.752a.59.59 0 0 0 .367.016l1.297 3.73c-.85-.109-2.133-.107-2.968.006Z"
            })
        })
    });
var $6ffbdc979e08a453$export$2e2bcd8739ae039 = $6ffbdc979e08a453$var$SvgLawBalance;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $5bfc193d5c8f814b$var$SvgPileCoins = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('5569cc008889bbaa')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M0 11.582v1.168c0 .965 2.352 1.75 5.25 1.75s5.25-.785 5.25-1.75v-1.168c-1.13.796-3.194 1.168-5.25 1.168S1.13 12.378 0 11.582ZM8.75 4C11.648 4 14 3.215 14 2.25S11.648.5 8.75.5 3.5 1.285 3.5 2.25 5.852 4 8.75 4ZM0 8.714v1.411c0 .965 2.352 1.75 5.25 1.75s5.25-.785 5.25-1.75v-1.41c-1.13.929-3.196 1.41-5.25 1.41S1.13 9.644 0 8.715Zm11.375.3C12.942 8.712 14 8.149 14 7.5V6.332c-.634.449-1.567.755-2.625.944v1.739ZM5.25 4.876C2.352 4.875 0 5.854 0 7.063 0 8.27 2.352 9.25 5.25 9.25s5.25-.979 5.25-2.188c0-1.208-2.352-2.187-5.25-2.187Zm5.996 1.54C12.887 6.118 14 5.538 14 4.874V3.707c-.97.687-2.639 1.056-4.394 1.143.806.391 1.4.916 1.64 1.564Z"
            })
        })
    });
var $5bfc193d5c8f814b$export$2e2bcd8739ae039 = $5bfc193d5c8f814b$var$SvgPileCoins;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $e034388069ade300$var$SvgRound = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 15,
        height: 15,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('d1ebb73211c8ae98')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.964 5.27a5.694 5.694 0 0 0-.449 2.1.133.133 0 0 1-.133.13h-1a.133.133 0 0 1-.133-.137A6.999 6.999 0 0 1 12.76 3.192l.94-.735a.133.133 0 0 1 .214.105l-.013 3.015a.134.134 0 0 1-.165.128l-2.928-.717a.133.133 0 0 1-.05-.235l1.003-.783a5.756 5.756 0 0 0-2.285-1.753 5.69 5.69 0 0 0-2.23-.45 5.704 5.704 0 0 0-4.055 1.68A5.721 5.721 0 0 0 1.964 5.27ZM13.116 7.5h1a.133.133 0 0 1 .133.137A6.998 6.998 0 0 1 1.737 11.81l-.94.735a.133.133 0 0 1-.215-.105l.012-3.017c0-.085.081-.148.165-.128l2.928.717a.133.133 0 0 1 .05.235l-1.003.783a5.748 5.748 0 0 0 2.322 1.769 5.705 5.705 0 0 0 2.194.434 5.705 5.705 0 0 0 4.056-1.68 5.7 5.7 0 0 0 1.676-3.923.133.133 0 0 1 .134-.13ZM9.57 6.687l.232.232a.246.246 0 0 1 0 .348L8.526 8.543a.246.246 0 0 1-.348 0l-.232-.232a.246.246 0 0 1 0-.348l.058-.058-.406-.406-.831.831.058.058a.328.328 0 0 1 0 .464L5.648 10.03a.328.328 0 0 1-.464 0l-.464-.464a.328.328 0 0 1 0-.464l1.176-1.177a.328.328 0 0 1 .465 0l.058.058.83-.83-.406-.407-.058.058a.246.246 0 0 1-.348 0l-.232-.232a.246.246 0 0 1 0-.348l1.276-1.276a.246.246 0 0 1 .349 0l.232.232a.246.246 0 0 1 0 .348l-.058.058 1.16 1.16.058-.058a.246.246 0 0 1 .348 0Z",
                fill: "#B45FFF"
            })
        })
    });
var $e034388069ade300$export$2e2bcd8739ae039 = $e034388069ade300$var$SvgRound;







var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





const $2a5b6389d5454647$var$courtTreeQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query CourtTree {
    court(id: "1") {
      name
      id
      children(orderBy: name) {
        name
        id
        children {
          name
          id
          children {
            name
            id
            children {
              name
              id
              children {
                name
                id
              }
            }
          }
        }
      }
    }
  }
`);
const $2a5b6389d5454647$export$2b3a4edc6425a652 = ()=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "courtTreeQuery"
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $2a5b6389d5454647$var$courtTreeQuery,
                variables: {}
            })
    });
};
const $2a5b6389d5454647$export$2d00adcfd7994092 = (court, value = "path")=>({
        label: court.name ? court.name : "Unnamed Court",
        value: value === "id" ? court.id : `/courts/${court.id}`,
        children: court.children.length > 0 ? court.children.map((child)=>$2a5b6389d5454647$export$2d00adcfd7994092(child, value)) : undefined
    });




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $683c94038b13f611$var$FieldContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  width: 100%;
  .value {
    flex-grow: 1;
    text-align: end;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
    margin-right: 8px;
    width: 14px;
  }

  .link {
    color: ${({ theme: theme })=>theme.primaryBlue};
    :hover {
      cursor: pointer;
    }
  }
  ${({ isList: isList })=>isList && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          width: auto;
          .value {
            flex-grow: 0;
            text-align: center;
          }
        `)}
    `};
  ${({ isOverview: isOverview, isJurorBalance: isJurorBalance })=>(isOverview || isJurorBalance) && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          width: auto;
          gap: 8px;
          .value {
            flex-grow: 0;
            text-align: none;
            font-weight: 600;
          }
          svg {
            margin-right: 0;
          }
        `)}
    `};
`;
const $683c94038b13f611$var$Field = ({ icon: Icon, name: name, value: value, link: link, width: width, displayAsList: displayAsList, isOverview: isOverview, isJurorBalance: isJurorBalance, className: className })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($683c94038b13f611$var$FieldContainer, {
        isList: displayAsList,
        isOverview: isOverview,
        isJurorBalance: isJurorBalance,
        width: width,
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {}),
            (!displayAsList || isOverview || isJurorBalance) && /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                children: [
                    name,
                    ":"
                ]
            }),
            link ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1d2829c53a2521b2$export$a6c7ac8248d6e38a), {
                className: "link value",
                to: link,
                onClick: (event)=>{
                    event.stopPropagation();
                },
                children: value
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                className: "value",
                children: value
            })
        ]
    });
};
var $683c94038b13f611$export$2e2bcd8739ae039 = $683c94038b13f611$var$Field;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");











var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $3Szoa = parcelRequire("3Szoa");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $75eea8b3d1f37d11$var$SvgFaucet = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('1ef9c1dad09c3106')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M7 .5c.553 0 1 .447 1 1v.375l3-.375a.999.999 0 1 1 0 2l-3-.375-.969-.122L7 3l-.031.003L6 3.125 3 3.5a.999.999 0 1 1 0-2l3 .375V1.5c0-.553.447-1 1-1Zm-7 7c0-.553.447-1 1-1h3l.706-.706a.998.998 0 0 1 .706-.294H6V4.131l1-.125 1 .125V5.5h.584c.266 0 .52.106.707.294L10 6.5h1c2.762 0 5 2.238 5 5 0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1 0-.553-.447-1-1-1H9.872a3.497 3.497 0 0 1-5.744 0H1c-.553 0-1-.447-1-1v-2Zm13.65 6.231a.382.382 0 0 1 .7 0l.569 1.325c.056.128.084.269.084.41v.034a.999.999 0 1 1-2 0v-.037c0-.141.028-.279.085-.41l.568-1.325-.006.003Z"
            })
        })
    });
var $75eea8b3d1f37d11$export$2e2bcd8739ae039 = $75eea8b3d1f37d11$var$SvgFaucet;






const $ad0594865d820998$export$b5c52d97c38147a8 = (getter)=>{
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    return getter({
        walletClient: publicClient
    });
};
const $ad0594865d820998$export$62b9d4edae1d009 = ()=>{
    return $ad0594865d820998$export$b5c52d97c38147a8((0, $f9a008fec395d7ff$export$212eea540589e65f))?.address;
};
const $ad0594865d820998$export$a01b1865a6fce02 = ()=>{
    return $ad0594865d820998$export$b5c52d97c38147a8((0, $f9a008fec395d7ff$export$15bab5d8b9fc2384))?.address;
};
const $ad0594865d820998$export$156244fe118d21f5 = ()=>{
    return $ad0594865d820998$export$b5c52d97c38147a8((0, $f9a008fec395d7ff$export$be79f9ce44da224f))?.address;
};
const $ad0594865d820998$export$f4e67b1b0d9b318a = ()=>{
    return $ad0594865d820998$export$b5c52d97c38147a8((0, $f9a008fec395d7ff$export$b545a82fd08a2b5f))?.address;
};






const $d4a20a0b6123562f$var$ClaimPnkButton = ()=>{
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $dup7A.useState)(false);
    const [hash, setHash] = (0, $dup7A.useState)();
    const { chain: chain } = (0, $1d657eb5d64e17dc$export$553aaf59afc1a2d8)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: claimed } = (0, $f9a008fec395d7ff$export$9825f67e3513975b)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address ?? "0x00"
        ],
        watch: true
    });
    const faucetAddress = (0, $ad0594865d820998$export$156244fe118d21f5)();
    const { data: balance } = (0, $f9a008fec395d7ff$export$a795cb8115233541)({
        args: [
            faucetAddress
        ],
        watch: true
    });
    const { data: dripAmount } = (0, $f9a008fec395d7ff$export$da74f019da0902b2)();
    const { data: walletClient } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const handleRequest = async ()=>{
        setIsSending(true);
        const { request: request } = await (0, $f9a008fec395d7ff$export$37d10d37681627fb)({
            functionName: "request"
        });
        if (walletClient) (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await walletClient.writeContract(request), publicClient).finally(()=>{
            setIsSending(false);
        }).then(({ result: result, status: status })=>{
            setIsPopupOpen(status);
            status && setHash(result?.transactionHash);
        });
    };
    const faucetCheck = !(0, $2d857633ba67aa25$export$fce6876652108ab)(balance) && parseInt((0, $3Szoa.formatEther)(balance)) > 200;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            chain?.id === (0, $32162005f9f3d1a7$export$8372812df8e8183f) && !claimed ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                variant: "primary",
                text: faucetCheck ? "Claim PNK" : "Empty Faucet",
                onClick: handleRequest,
                isLoading: isSending,
                disabled: isSending || claimed || !faucetCheck,
                Icon: faucetCheck ? (0, $75eea8b3d1f37d11$export$2e2bcd8739ae039) : undefined
            }) : null,
            isPopupOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$2e2bcd8739ae039), {
                title: "Success!",
                popupType: (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).SWAP_SUCCESS,
                hash: hash,
                amount: (0, $fccd0e08af927011$export$fe0dbb825775d15c)(dripAmount ?? BigInt(0)),
                isClaim: true,
                setIsOpen: setIsPopupOpen
            })
        ]
    });
};
var $d4a20a0b6123562f$export$2e2bcd8739ae039 = $d4a20a0b6123562f$var$ClaimPnkButton;




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");






const $a6542729828b5d85$export$550bd8d2805c8bd3 = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  fragment DisputeDetails on Dispute {
    id
    arbitrated {
      id
    }
    currentRoundIndex
    court {
      id
      policy
      feeForJuror
      timesPerPeriod
    }
    period
    lastPeriodChange
  }
`);
const $a6542729828b5d85$var$casesQueryWhere = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query CasesPageWhere($skip: Int, $where: Dispute_filter, $orderDirection: OrderDirection, $first: Int) {
    disputes(first: $first, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection, where: $where) {
      ...DisputeDetails
    }
  }
`);
const $a6542729828b5d85$var$casesQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query CasesPage($skip: Int, $orderDirection: OrderDirection, $first: Int) {
    disputes(first: $first, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection) {
      ...DisputeDetails
    }
  }
`);
const $a6542729828b5d85$var$myCasesQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query MyCases($id: ID!, $skip: Int, $orderDirection: OrderDirection) {
    user(id: $id) {
      disputes(first: 3, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection) {
        ...DisputeDetails
      }
    }
  }
`);
const $a6542729828b5d85$var$myCasesQueryWhere = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query myCasesPageWhere($id: ID!, $skip: Int, $where: Dispute_filter, $orderDirection: OrderDirection) {
    user(id: $id) {
      disputes(first: 3, skip: $skip, orderBy: lastPeriodChange, orderDirection: $orderDirection, where: $where) {
        ...DisputeDetails
      }
    }
  }
`);
const $a6542729828b5d85$export$1b652431a6f4c7f1 = (skip = 0, first = 3, where, sortOrder)=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `useCasesQuery`,
            skip,
            where,
            sortOrder,
            first
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: (0, $2d857633ba67aa25$export$fce6876652108ab)(where) ? $a6542729828b5d85$var$casesQuery : $a6542729828b5d85$var$casesQueryWhere,
                variables: {
                    first: first,
                    skip: skip,
                    where: where,
                    orderDirection: sortOrder ?? "desc"
                }
            })
    });
};
const $a6542729828b5d85$export$66e7a3048fa32afd = (user, skip = 0, where, sortOrder)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(user);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `useMyCasesQuery`,
            user,
            skip,
            where,
            sortOrder
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: (0, $2d857633ba67aa25$export$fce6876652108ab)(where) ? $a6542729828b5d85$var$myCasesQuery : $a6542729828b5d85$var$myCasesQueryWhere,
                variables: {
                    skip: skip,
                    id: user?.toLowerCase(),
                    where: where,
                    orderDirection: sortOrder ?? "desc"
                }
            })
    });
};




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $3Szoa = parcelRequire("3Szoa");







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



const $b14704401b6788bf$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: ${({ isCard: isCard })=>isCard ? "45px" : "100%"};
  width: ${({ isCard: isCard })=>isCard ? "auto" : (0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(140, 200, 900)};
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  padding: 0 ${({ isCard: isCard })=>isCard ? "24px" : (0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 24, 900)};
  flex-shrink: 0;
  ${({ frontColor: frontColor, backgroundColor: backgroundColor, isCard: isCard })=>{
    return `
      ${isCard ? `border-top: 5px solid ${frontColor}` : `border-left: 5px solid ${frontColor}`};
      ${isCard && `background-color: ${backgroundColor};`};
    `;
}};
`;
const $b14704401b6788bf$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  width: ${({ isCard: isCard })=>isCard ? "auto" : "min-content"};
  color: ${({ frontColor: frontColor })=>frontColor};
  ${({ withDot: withDot, frontColor: frontColor })=>withDot ? (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          ::before {
            content: "";
            display: inline-block;
            height: 8px;
            width: 8px;
            border-radius: 50%;
            margin-right: 8px;
            background-color: ${frontColor};
            flex-shrink: 0;
          }
        ` : null}
`;
const $b14704401b6788bf$var$getPeriodColors = (period, theme)=>{
    switch(period){
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal:
            return [
                theme.tint,
                theme.tintMedium
            ];
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).execution:
            return [
                theme.secondaryPurple,
                theme.mediumPurple
            ];
        default:
            return [
                theme.primaryBlue,
                theme.mediumBlue
            ];
    }
};
const $b14704401b6788bf$var$getPeriodLabel = (period, isCard)=>{
    switch(period){
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).evidence:
            return `${isCard ? "In Progress - " : ""}Submitting Evidence`;
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).commit:
            return `${isCard ? "In Progress - " : ""}Committing Vote`;
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).vote:
            return `${isCard ? "In Progress - " : ""}Voting`;
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal:
            return "Crowdfunding Appeal";
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).execution:
            return "Closed";
        default:
            return "In Progress";
    }
};
const $b14704401b6788bf$var$PeriodBanner = ({ id: id, period: period, isCard: isCard = true })=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const [frontColor, backgroundColor] = (0, $dup7A.useMemo)(()=>$b14704401b6788bf$var$getPeriodColors(period, theme), [
        theme,
        period
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($b14704401b6788bf$var$Container, {
        isCard: isCard,
        frontColor: frontColor,
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($b14704401b6788bf$var$StyledLabel, {
                frontColor: frontColor,
                isCard: isCard,
                withDot: true,
                children: $b14704401b6788bf$var$getPeriodLabel(period, isCard)
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($b14704401b6788bf$var$StyledLabel, {
                frontColor: frontColor,
                children: [
                    "#",
                    id
                ]
            })
        ]
    });
};
var $b14704401b6788bf$export$2e2bcd8739ae039 = $b14704401b6788bf$var$PeriodBanner;


const $3516b01f6e8e59b4$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  height: 100%;
  max-height: 335px;
  min-height: 290px;
`;
const $3516b01f6e8e59b4$var$CardContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: calc(100% - 45px);
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(20, 24)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $3516b01f6e8e59b4$var$TruncatedTitle = ({ text: text, maxLength: maxLength })=>{
    const truncatedText = text.length <= maxLength ? text : text.slice(0, maxLength) + "\u2026";
    return /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
        children: truncatedText
    });
};
const $3516b01f6e8e59b4$var$DisputeCardView = ({ isLoading: isLoading, ...props })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($3516b01f6e8e59b4$var$StyledCard, {
        hover: true,
        onClick: ()=>navigate(`/cases/${props?.disputeID?.toString()}`),
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b14704401b6788bf$export$2e2bcd8739ae039), {
                id: parseInt(props?.disputeID),
                period: props?.period
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($3516b01f6e8e59b4$var$CardContainer, {
                children: [
                    isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)($3516b01f6e8e59b4$var$TruncatedTitle, {
                        text: props?.title,
                        maxLength: 100
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $59b5241b7985f8c2$export$2e2bcd8739ae039), {
                        ...props
                    })
                ]
            })
        ]
    });
};
var $3516b01f6e8e59b4$export$2e2bcd8739ae039 = $3516b01f6e8e59b4$var$DisputeCardView;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $7d854bea53e84b3f$var$StyledListItem = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  display: flex;
  flex-grow: 1;
  width: 100%;
  height: 82px;
`;
const $7d854bea53e84b3f$var$ListContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
`;
const $7d854bea53e84b3f$var$TitleContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  height: 100%;
  justify-content: start;
  align-items: center;
  width: ${({ isLabel: isLabel })=>isLabel ? (0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(150, 340, 900) : "fit-content"};
  h3 {
    margin: 0;
  }
`;
const $7d854bea53e84b3f$var$TruncatedTitle = ({ text: text, maxLength: maxLength })=>{
    const truncatedText = text.length <= maxLength ? text : text.slice(0, maxLength) + "\u2026";
    return /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
        children: truncatedText
    });
};
const $7d854bea53e84b3f$var$DisputeListView = (props)=>{
    const { isDisconnected: isDisconnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($7d854bea53e84b3f$var$StyledListItem, {
        hover: true,
        onClick: ()=>navigate(`/cases/${props?.disputeID?.toString()}`),
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b14704401b6788bf$export$2e2bcd8739ae039), {
                isCard: false,
                id: parseInt(props?.disputeID ?? "0"),
                period: props.period
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($7d854bea53e84b3f$var$ListContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($7d854bea53e84b3f$var$TitleContainer, {
                        isLabel: !isDisconnected,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)($7d854bea53e84b3f$var$TruncatedTitle, {
                            text: props?.title,
                            maxLength: 50
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $59b5241b7985f8c2$export$2e2bcd8739ae039), {
                        ...props
                    })
                ]
            })
        ]
    });
};
var $7d854bea53e84b3f$export$2e2bcd8739ae039 = $7d854bea53e84b3f$var$DisputeListView;


const $9e213078be8217b5$export$f7b710e5dac82334 = (lastPeriodChange, currentPeriodIndex, timesPerPeriod)=>{
    const durationCurrentPeriod = parseInt(timesPerPeriod[currentPeriodIndex]);
    return parseInt(lastPeriodChange) + durationCurrentPeriod;
};
const $9e213078be8217b5$var$DisputeView = ({ id: id, currentRoundIndex: currentRoundIndex, arbitrated: arbitrated, period: period, lastPeriodChange: lastPeriodChange, court: court, overrideIsList: overrideIsList })=>{
    const { isList: isList } = (0, $b73946e052a4abb0$export$efcb02388d4a2108)();
    const currentPeriodIndex = (0, $2b4339c8418e3b6b$export$2be98a1249103ab1)[period];
    const rewards = `\u{2265} ${(0, $3Szoa.formatEther)(court.feeForJuror)} ETH`;
    const date = currentPeriodIndex === 4 ? lastPeriodChange : $9e213078be8217b5$export$f7b710e5dac82334(lastPeriodChange, currentPeriodIndex, court.timesPerPeriod);
    const { data: disputeDetails, isError: isError } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrated.id);
    const { data: courtPolicy } = (0, $3043cbfb1ed10cf4$export$e0985f714b0d92d6)(court.id);
    const courtName = courtPolicy?.name;
    const category = disputeDetails?.category;
    const errMsg = isError ? (0, $203b613495c69c62$export$adca62214545ea7b) : (0, $203b613495c69c62$export$7142fb39be536070);
    return !isList || overrideIsList ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3516b01f6e8e59b4$export$2e2bcd8739ae039), {
        title: disputeDetails?.title ?? errMsg,
        disputeID: id,
        courtId: court?.id,
        court: courtName,
        period: currentPeriodIndex,
        round: parseInt(currentRoundIndex) + 1,
        showLabels: true,
        category: category,
        rewards: rewards,
        date: date,
        overrideIsList: overrideIsList,
        isLoading: (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails)
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $7d854bea53e84b3f$export$2e2bcd8739ae039), {
        title: disputeDetails?.title ?? errMsg,
        disputeID: id,
        courtId: court?.id,
        court: courtName,
        period: currentPeriodIndex,
        round: parseInt(currentRoundIndex) + 1,
        showLabels: true,
        category: category,
        rewards: rewards,
        date: date
    });
};
var $9e213078be8217b5$export$2e2bcd8739ae039 = $9e213078be8217b5$var$DisputeView;



const $3086dc6786764df3$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(48, 80)};
`;
const $3086dc6786764df3$var$Title = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
`;
const $3086dc6786764df3$var$DisputeContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  --gap: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, max(350px, (100% - var(--gap) * 2)/3)), 1fr));
  align-items: center;
  gap: var(--gap);
`;
const $3086dc6786764df3$var$LatestCases = ({ filters: filters })=>{
    const { data: data } = (0, $a6542729828b5d85$export$1b652431a6f4c7f1)(0, 3, filters);
    const disputes = (0, $dup7A.useMemo)(()=>data?.disputes, [
        data
    ]);
    return (0, $2d857633ba67aa25$export$fce6876652108ab)(disputes) || disputes.length > 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)($3086dc6786764df3$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($3086dc6786764df3$var$Title, {
                children: "Latest Cases"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($3086dc6786764df3$var$DisputeContainer, {
                children: (0, $2d857633ba67aa25$export$fce6876652108ab)(disputes) ? Array.from({
                    length: 3
                }).map((_, index)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$84f3ad5c22cc3642), {}, index)) : disputes.map((dispute)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $9e213078be8217b5$export$2e2bcd8739ae039), {
                        ...dispute,
                        overrideIsList: true
                    }, dispute.id))
            })
        ]
    }) : null;
};
var $3086dc6786764df3$export$2e2bcd8739ae039 = $3086dc6786764df3$var$LatestCases;





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");






const $bf6c5bb922de0f6f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $bf6c5bb922de0f6f$var$TextContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 12px 0;
`;
const $bf6c5bb922de0f6f$var$StyledTabs = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Tabs))`
  width: 100%;
  > * {
    display: flex;
    flex-wrap: wrap;
    > svg {
      margin-right: 0px !important;
    }
  }
`;
const $bf6c5bb922de0f6f$var$TABS = [
    {
        text: "Purpose",
        value: 0,
        path: "purpose",
        isVisible: (policy)=>!!policy?.description
    },
    {
        text: "Skills",
        value: 1,
        path: "skills",
        isVisible: (policy)=>!!policy?.requiredSkills
    },
    {
        text: "Policy",
        value: 2,
        path: "policy",
        isVisible: (policy)=>!!policy?.summary
    }
];
const $bf6c5bb922de0f6f$var$Description = ()=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: policy } = (0, $3043cbfb1ed10cf4$export$e0985f714b0d92d6)(id);
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const currentPathName = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)().pathname.split("/").at(-1);
    const [currentTab, setCurrentTab] = (0, $dup7A.useState)($bf6c5bb922de0f6f$var$TABS.findIndex(({ path: path })=>path === currentPathName));
    (0, $dup7A.useEffect)(()=>setCurrentTab($bf6c5bb922de0f6f$var$TABS.findIndex(({ path: path })=>path === currentPathName)), [
        currentPathName
    ]);
    const filteredTabs = $bf6c5bb922de0f6f$var$TABS.filter(({ isVisible: isVisible })=>isVisible(policy));
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const scrollToSection = queryParams.get("section");
    (0, $dup7A.useEffect)(()=>{
        if (scrollToSection === "description") {
            const element = document.getElementById(scrollToSection);
            if (element) element.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        scrollToSection
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($bf6c5bb922de0f6f$var$Container, {
        id: "description",
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($bf6c5bb922de0f6f$var$StyledTabs, {
                currentValue: currentTab,
                items: filteredTabs,
                callback: (n)=>{
                    setCurrentTab(n);
                    navigate($bf6c5bb922de0f6f$var$TABS[n].path);
                }
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($bf6c5bb922de0f6f$var$TextContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                            path: "purpose",
                            element: $bf6c5bb922de0f6f$var$formatMarkdown(policy?.description)
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                            path: "skills",
                            element: /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                                children: policy?.requiredSkills
                            })
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                            path: "policy",
                            element: $bf6c5bb922de0f6f$var$formatMarkdown(policy?.summary)
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$444b3ab0cb9aec40), {
                                to: "purpose",
                                replace: true
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $bf6c5bb922de0f6f$var$formatMarkdown = (markdown)=>markdown ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201), {
        children: typeof markdown === "string" ? markdown.replace(/\n/g, "  \n") : markdown
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {});
var $bf6c5bb922de0f6f$export$2e2bcd8739ae039 = $bf6c5bb922de0f6f$var$Description;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $66d1db805a75a297$var$SvgThreePnks = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        width: 154,
        height: 61,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m105.851 0 33.801 2.204 13.97 30.882L134.522 61 99.96 59.53 86 25.731 105.851 0Zm.859 1.752-5.273 25.704 30.977-14.5L106.71 1.752Zm26.559 12.387-31.435 14.715 26.753 20.065 4.682-34.78Zm-5.701 35.808-26.403-19.802v27.723l26.403-7.92Zm-27.837 5.27V29.293l-11.728-2.47L99.73 55.218ZM88.087 25.375 99.89 27.86l4.97-24.227-16.773 21.742Zm16.642 32.922 28.24 1.201-4.206-8.412-24.034 7.21Zm25.319-7.848 4.204 8.407 15.612-22.82-19.816 14.413Zm20.289-21.144L139.143 4.561l-4.124 8.248 15.318 16.496Zm-16.519-17.302-23.583-10.28 27.816 1.814-4.233 8.466Zm.845 2.53-4.594 34.127 21.657-15.75-17.063-18.376Z",
                fill: "url(#three-pnks_svg__a)"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m43.75 14 18.306 1.194 7.566 16.724-10.344 15.118-18.718-.797L33 27.936 43.75 14Zm.466.949-2.856 13.92 16.776-7.852-13.92-6.068Zm14.383 6.708-17.024 7.97 14.489 10.866 2.535-18.836ZM55.512 41.05l-14.3-10.724V45.34l14.3-4.29Zm-15.076 2.854v-14.04l-6.351-1.337 6.351 15.377ZM34.13 27.742l6.392 1.346 2.692-13.12-9.084 11.774Zm9.013 17.83 15.294.65-2.278-4.555-13.016 3.904Zm13.712-4.25 2.276 4.552 8.456-12.358-10.732 7.805ZM67.843 29.87 61.78 16.47l-2.233 4.467 8.296 8.934Zm-8.946-9.37-12.772-5.568 15.064.983-2.292 4.585Zm.457 1.37-2.487 18.481 11.728-8.53-9.24-9.951Z",
                fill: "url(#three-pnks_svg__b)"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m4.881 23 8.312.542 3.435 7.594L11.932 38l-8.5-.362L0 29.328 4.881 23Zm.212.43-1.297 6.321 7.617-3.565-6.32-2.755Zm6.53 3.047-7.73 3.618 6.58 4.934 1.15-8.552Zm-1.401 8.805-6.493-4.87v6.818l6.493-1.948Zm-6.846 1.296v-6.375l-2.884-.607 2.884 6.982ZM.513 29.24l2.903.61 1.222-5.957L.513 29.24Zm4.092 8.095 6.945.296-1.035-2.069-5.91 1.773Zm6.226-1.93 1.034 2.068 3.84-5.611-4.873 3.543Zm4.99-5.199-2.753-6.085-1.014 2.029 3.767 4.056Zm-4.063-4.254L5.96 23.424l6.84.446-1.04 2.082Zm.208.622-1.13 8.391 5.326-3.873-4.196-4.518Z",
                fill: "url(#three-pnks_svg__c)"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "three-pnks_svg__a",
                        x1: 119.811,
                        y1: 0,
                        x2: 119.811,
                        y2: 61,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#6CC5FF"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B45FFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "three-pnks_svg__b",
                        x1: 51.311,
                        y1: 14,
                        x2: 51.311,
                        y2: 47.036,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#6CC5FF"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B45FFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "three-pnks_svg__c",
                        x1: 8.314,
                        y1: 23,
                        x2: 8.314,
                        y2: 38,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#6CC5FF"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B45FFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $66d1db805a75a297$export$2e2bcd8739ae039 = $66d1db805a75a297$var$SvgThreePnks;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $8038492093b5d637$var$SvgBalance = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 350 350",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M326.109 87.5 174.554 0 23 87.5v175L174.554 350l151.555-87.5v-175Zm-18.468 10.473L174.435 21.066 41.228 97.973v153.813l133.207 76.907 133.206-76.907V97.973Z",
                fill: "#F0F9FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m174.435 21.066 133.206 76.907v153.813l-133.206 76.907-133.207-76.907V97.973l133.207-76.907Z",
                fill: "#7E1BD4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m174.554 62.355-97.552 56.322v112.644l97.552 56.322 97.553-56.322V118.677l-97.553-56.322Zm100.553 54.59L174.554 58.891 74.002 116.945v116.108l100.552 58.054 100.553-58.054V116.945Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M238.247 57.462V231.26l-63.412-35.91-63.947 35.91V58.07L175.094 21l63.153 36.462Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M230.985 53.268V227.14l-1.946-1.102V52.144l1.946 1.124ZM120.309 52.63v173.338l-1.946 1.093V53.753l1.946-1.124Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m149.657 66.996-3.377 2.769 1.589-4.068-3.677-2.356 4.36.255 1.105-4.225 1.104 4.225 4.36-.255-3.677 2.356 1.59 4.068-3.377-2.77Zm12.927 0-3.377 2.769 1.59-4.068-3.677-2.356 4.359.255 1.105-4.225 1.105 4.225 4.359-.255-3.677 2.356 1.59 4.068-3.377-2.77Zm9.551 2.769 3.377-2.77 3.377 2.77-1.59-4.068 3.677-2.356-4.36.255-1.104-4.225-1.105 4.225-4.36-.255 3.677 2.356-1.589 4.068Zm16.304-2.77-3.377 2.77 1.59-4.068-3.677-2.356 4.36.255 1.104-4.225 1.105 4.225 4.36-.255-3.677 2.356 1.59 4.068-3.378-2.77Zm9.551 2.77 3.377-2.77 3.377 2.77-1.59-4.068 3.677-2.356-4.36.255-1.104-4.225-1.105 4.225-4.36-.255 3.677 2.356-1.589 4.068Z",
                fill: "#FCFEFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M180.315 104.18c0 2.567-.579 4.043-1.516 4.879l25.9 7.728a4.033 4.033 0 0 1 2.645-.984 4.04 4.04 0 0 1 4.047 4.032 4.028 4.028 0 0 1-2.341 3.653l9.064 26.075c2.874.457 4.774 1.131 4.774 2.023 0 3.658-7.164 6.624-16 6.624-8.837 0-16-2.966-16-6.624 0-.948 2.146-1.65 5.326-2.106l9.094-26.164a4.038 4.038 0 0 1-1.794-2.184c-.306-1.269-1.016-2.07-2.132-2.403-1.334-.398-2.641-.443-4.1-.494-1.843-.063-3.93-.135-6.621-.938l-13.159-3.926v26.819a4.02 4.02 0 0 1 1.695 3.277 4 4 0 0 1-.794 2.392 5.415 5.415 0 0 1 2.206 4.36 5.432 5.432 0 0 1-3.107 4.902v5.6c5.976.311 10.528 1.922 10.528 3.863 0 .032-.001.065-.004.098 9.646.831 16.305 2.602 16.305 4.652l.047 2.86c0 2.849-12.831 5.135-28.688 5.135s-28.688-2.333-28.688-5.182l-.094-2.813c0-2.017 6.448-3.764 15.844-4.611a1.307 1.307 0 0 1-.007-.139c0-1.909 4.406-3.499 10.239-3.847v-5.525a5.44 5.44 0 0 1-3.295-4.993 5.42 5.42 0 0 1 2.206-4.36 4.005 4.005 0 0 1-.794-2.392c0-1.433.753-2.688 1.883-3.403v-28.042l-15.007-4.478c-.999-.298-2.46-1.089-4.022-1.935-1.792-.97-3.716-2.011-5.223-2.461-1.044-.312-2.116-.086-3.216.678a4.139 4.139 0 0 1-.686.45l9.044 26.019c3.008.458 5.014 1.144 5.014 2.06 0 3.659-7.164 6.625-16 6.625-8.837 0-16-2.966-16-6.625 0-.888 1.887-1.561 4.746-2.018l9.124-26.249a4.024 4.024 0 0 1-1.851-3.384 4.04 4.04 0 0 1 4.048-4.033 4.048 4.048 0 0 1 3.869 2.846l23.259 6.941c-.128-.643-.196-1.396-.196-2.278 0-3.435 1.738-7.495 5.214-12.18 3.476 4.685 5.214 8.745 5.214 12.18Zm27.935 19.582 8.92 25.663c-5.629-.754-14.204-.777-20.016-.07l8.93-25.69a4.04 4.04 0 0 0 2.166.097Zm-75.672 6.436 8.943-25.727c.446.169.928.265 1.434.265a4.05 4.05 0 0 0 1.085-.151l8.891 25.578c-5.822-.747-14.623-.736-20.353.035ZM167.799 222.45l16.972.757 6.872 15.24-9.695 13.928-17.064-1.091-6.996-16.512 9.911-12.322Zm12.443 8.785-12.301 5.364 10.517 8.116 1.784-13.48Zm-1.424-2.688-9.83-4.225-2.065 8.883 11.895-4.658Zm-2.492 18.21-10.683-7.615.258 10.319 10.425-2.704Zm13.61-8.344-7.28-7.374-1.921 14.18 9.201-6.806Zm-11.105 10.003-9.01 2.35 10.596.677-1.586-3.027Zm9.683-6.657-7.887 5.865 1.567 3.057 6.32-8.922Zm-3.731-16.422-1.532 3.139 5.702 5.785-4.17-8.924Zm-1.909-1.502-10.012-.406 8.259 3.606 1.753-3.2Zm-16.537 1.451-7.014 8.84 4.689.991 2.325-9.831Zm-2.607 11.565-4.712-.996 4.916 11.561-.204-10.565Z",
                fill: "#fff"
            })
        ]
    });
var $8038492093b5d637$export$2e2bcd8739ae039 = $8038492093b5d637$var$SvgBalance;






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $5943a6ce69d75259$var$TagContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).button`
  padding: 0;
  border: none;
  background-color: transparent;
`;
const $5943a6ce69d75259$var$Tag = ({ text: text, active: active, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($5943a6ce69d75259$var$TagContainer, {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Tag), {
            text: text,
            active: active
        })
    });
};
var $5943a6ce69d75259$export$2e2bcd8739ae039 = $5943a6ce69d75259$var$Tag;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");










var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


const $9fac6c61e3520ef4$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
`;
const $9fac6c61e3520ef4$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 100%;
  height: fit-content;

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  input {
    border: 1px solid ${({ theme: theme })=>theme.stroke};
    border-right: none;
    height: 45px;
    font-size: 16px;
  }
`;
const $9fac6c61e3520ef4$export$8eabdd1cd59b4b71 = ({ placeholder: placeholder, message: message, value: value, onChange: onChange, formatter: formatter, className: className, variant: variant = "info" })=>{
    const [isEditing, setIsEditing] = (0, $dup7A.useState)(false);
    const toggleEditing = ()=>{
        setIsEditing(!isEditing);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)($9fac6c61e3520ef4$var$Container, {
        className: className,
        children: isEditing ? /*#__PURE__*/ (0, $cZGFG.jsx)($9fac6c61e3520ef4$var$StyledField, {
            type: "number",
            onChange: (event)=>{
                onChange?.(event.target.value);
            },
            onBlur: toggleEditing,
            value: value,
            placeholder: placeholder,
            message: message,
            variant: variant
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)($9fac6c61e3520ef4$var$StyledField, {
            type: "text",
            value: formatter ? formatter(value ?? "0") : value,
            onFocus: toggleEditing,
            placeholder: placeholder,
            message: message,
            variant: variant,
            readOnly: true
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");








var $cc88e7e3df6b7345$export$e4a712fff93fb00f;
(function(ActionType) {
    ActionType["allowance"] = "allowance";
    ActionType["stake"] = "stake";
    ActionType["withdraw"] = "withdraw";
})($cc88e7e3df6b7345$export$e4a712fff93fb00f || ($cc88e7e3df6b7345$export$e4a712fff93fb00f = {}));
const $cc88e7e3df6b7345$var$StakeWithdrawButton = ({ parsedAmount: parsedAmount, action: action, isSending: isSending, setIsSending: setIsSending, setIsPopupOpen: setIsPopupOpen, setErrorMsg: setErrorMsg })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const klerosCore = (0, $f9a008fec395d7ff$export$b545a82fd08a2b5f)({});
    const { data: courtDetails } = (0, $6c35bcc70e144cdf$export$cac3085b56a3ca27)(id);
    const { data: balance } = (0, $f9a008fec395d7ff$export$a795cb8115233541)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address
        ],
        watch: true
    });
    const { data: jurorBalance } = (0, $f9a008fec395d7ff$export$95ba38bd72119500)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address ?? "0x",
            BigInt(id ?? 0)
        ],
        watch: true
    });
    const { data: allowance } = (0, $f9a008fec395d7ff$export$6accc9716eb907c3)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address ?? "0x",
            klerosCore.address
        ],
        watch: true
    });
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const isStaking = action === "stake";
    const isAllowance = isStaking && !(0, $2d857633ba67aa25$export$fce6876652108ab)(allowance) && allowance < parsedAmount;
    const targetStake = (0, $dup7A.useMemo)(()=>{
        if (jurorBalance) {
            if (isAllowance) return parsedAmount;
            else if (isStaking) return jurorBalance[2] + parsedAmount;
            else return jurorBalance[2] - parsedAmount;
        }
        return 0n;
    }, [
        jurorBalance,
        parsedAmount,
        isAllowance,
        isStaking
    ]);
    const { config: increaseAllowanceConfig, error: allowanceError } = (0, $f9a008fec395d7ff$export$c2064b08c6a85a2c)({
        enabled: isAllowance && !(0, $2d857633ba67aa25$export$fce6876652108ab)(klerosCore) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(targetStake) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(allowance),
        args: [
            klerosCore?.address,
            BigInt(targetStake ?? 0) - BigInt(allowance ?? 0)
        ]
    });
    const { writeAsync: increaseAllowance } = (0, $f9a008fec395d7ff$export$ce0bb0eb43140aa0)(increaseAllowanceConfig);
    const handleAllowance = ()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(increaseAllowance)) {
            setIsSending(true);
            (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await increaseAllowance().then((response)=>response.hash), publicClient).finally(()=>{
                setIsSending(false);
            });
        }
    };
    const { config: setStakeConfig, error: setStakeError } = (0, $f9a008fec395d7ff$export$c1a272f3da30c17)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(targetStake) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(id) && !isAllowance,
        args: [
            BigInt(id ?? 0),
            targetStake
        ]
    });
    const { writeAsync: setStake } = (0, $f9a008fec395d7ff$export$be3ca3469e8da431)(setStakeConfig);
    const handleStake = ()=>{
        if (typeof setStake !== "undefined") {
            setIsSending(true);
            (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await setStake().then((response)=>response.hash), publicClient).then((res)=>res.status && setIsPopupOpen(true)).finally(()=>{
                setIsSending(false);
            });
        }
    };
    (0, $dup7A.useEffect)(()=>{
        if (isAllowance) setErrorMsg(allowanceError?.shortMessage);
        else setErrorMsg(setStakeError?.shortMessage);
    }, [
        allowanceError,
        setStakeError,
        isAllowance,
        isStaking,
        setErrorMsg
    ]);
    const buttonProps = {
        ["allowance"]: {
            text: "Allow PNK",
            checkDisabled: ()=>!balance || targetStake > balance,
            onClick: handleAllowance
        },
        ["stake"]: {
            text: "Stake",
            checkDisabled: ()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(setStakeError),
            onClick: handleStake
        },
        ["withdraw"]: {
            text: "Withdraw",
            checkDisabled: ()=>!jurorBalance || parsedAmount > jurorBalance[2],
            onClick: handleStake
        }
    };
    const { text: text, checkDisabled: checkDisabled, onClick: onClick } = buttonProps[isAllowance ? "allowance" : action];
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
            text: text,
            isLoading: isSending,
            disabled: isSending || parsedAmount == 0n || (0, $2d857633ba67aa25$export$fce6876652108ab)(targetStake) || (0, $2d857633ba67aa25$export$fce6876652108ab)(courtDetails) || checkDisabled() || targetStake !== 0n && targetStake < BigInt(courtDetails.court?.minStake) || isStaking && !isAllowance && (0, $2d857633ba67aa25$export$fce6876652108ab)(setStakeConfig.request),
            onClick: onClick
        })
    });
};
var $cc88e7e3df6b7345$export$2e2bcd8739ae039 = $cc88e7e3df6b7345$var$StakeWithdrawButton;


const $5bcc0a920e01c883$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $9fac6c61e3520ef4$export$8eabdd1cd59b4b71))`
  height: fit-content;
`;
const $5bcc0a920e01c883$var$LabelArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $5bcc0a920e01c883$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryBlue};
  cursor: pointer;
`;
const $5bcc0a920e01c883$var$InputArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
const $5bcc0a920e01c883$var$InputFieldAndButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
const $5bcc0a920e01c883$var$EnsureChainContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  button {
    height: 45px;
    border: 1px solid ${({ theme: theme })=>theme.stroke};
  }
`;
const $5bcc0a920e01c883$var$InputDisplay = ({ action: action, isSending: isSending, setIsSending: setIsSending, setIsPopupOpen: setIsPopupOpen, amount: amount, setAmount: setAmount })=>{
    const [debouncedAmount, setDebouncedAmount] = (0, $dup7A.useState)("");
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>setDebouncedAmount(amount), 500, [
        amount
    ]);
    const parsedAmount = (0, $10de1c6562b78ee0$export$8556e87f337547cd)((0, $9932208e3bd3cfac$export$44b9d1d1a3173788)(debouncedAmount));
    const [errorMsg, setErrorMsg] = (0, $dup7A.useState)();
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: balance } = (0, $f9a008fec395d7ff$export$a795cb8115233541)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address ?? "0x"
        ],
        watch: true
    });
    const parsedBalance = (0, $fccd0e08af927011$export$fe0dbb825775d15c)(balance ?? 0n, 0, true);
    const { data: jurorBalance } = (0, $f9a008fec395d7ff$export$95ba38bd72119500)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address,
            BigInt(id)
        ],
        watch: true
    });
    const parsedStake = (0, $fccd0e08af927011$export$fe0dbb825775d15c)(jurorBalance?.[2] || 0n, 0, true);
    const isStaking = (0, $dup7A.useMemo)(()=>action === (0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).stake, [
        action
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($5bcc0a920e01c883$var$LabelArea, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: `Available ${isStaking ? parsedBalance : parsedStake} PNK`
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($5bcc0a920e01c883$var$StyledLabel, {
                        onClick: ()=>{
                            const amount = isStaking ? parsedBalance : parsedStake;
                            setAmount(amount);
                        },
                        children: [
                            isStaking ? "Stake" : "Withdraw",
                            " all"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($5bcc0a920e01c883$var$InputArea, {
                children: /*#__PURE__*/ (0, $cZGFG.jsxs)($5bcc0a920e01c883$var$InputFieldAndButton, {
                    children: [
                        /*#__PURE__*/ (0, $cZGFG.jsx)($5bcc0a920e01c883$var$StyledField, {
                            value: (0, $9932208e3bd3cfac$export$44b9d1d1a3173788)(amount),
                            onChange: (e)=>{
                                setAmount(e);
                            },
                            placeholder: isStaking ? "Amount to stake" : "Amount to withdraw",
                            message: errorMsg ?? undefined,
                            variant: !(0, $2d857633ba67aa25$export$fce6876652108ab)(errorMsg) ? "error" : "info",
                            formatter: (number)=>(0, $9932208e3bd3cfac$export$de1294767e6ef661)((0, $fccd0e08af927011$export$f78533b8f2581318)(Number(number)))
                        }),
                        /*#__PURE__*/ (0, $cZGFG.jsx)($5bcc0a920e01c883$var$EnsureChainContainer, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cc88e7e3df6b7345$export$2e2bcd8739ae039), {
                                parsedAmount: parsedAmount,
                                action: action,
                                setAmount: setAmount,
                                isSending: isSending,
                                setIsSending: setIsSending,
                                setIsPopupOpen: setIsPopupOpen,
                                setErrorMsg: setErrorMsg
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $5bcc0a920e01c883$export$2e2bcd8739ae039 = $5bcc0a920e01c883$var$InputDisplay;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $3Szoa = parcelRequire("3Szoa");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $de98112b8f7c78be$var$SvgDice = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M11.784 1.375h-9.09c-1.006 0-1.819.783-1.819 1.75v8.75c0 .967.813 1.75 1.818 1.75h9.091c1.005 0 1.818-.783 1.818-1.75v-8.75c0-.967-.812-1.75-1.818-1.75ZM4.511 5.75c-.5 0-.909-.394-.909-.875S4.011 4 4.512 4c.5 0 .908.393.908.875s-.409.875-.909.875ZM9.966 11c-.5 0-.91-.393-.91-.875s.41-.875.91-.875.909.393.909.875-.41.875-.91.875Z"
        })
    });
var $de98112b8f7c78be$export$2e2bcd8739ae039 = $de98112b8f7c78be$var$SvgDice;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $2ebf3a18dc3f3ead$var$SvgPnk = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('5ca0ef96e2a06ef2')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m6.602 1.813 10.45.472 4.232 9.5-5.97 8.683-10.506-.68L.5 9.494l6.102-7.681Zm7.662 5.476L6.69 10.633l6.475 5.06 1.099-8.404Zm-.877-1.676L7.334 2.98 6.063 8.517l7.324-2.904Zm-1.534 11.352L5.275 12.22l.159 6.432 6.419-1.686Zm8.38-5.201L15.75 7.167l-1.183 8.84 5.666-4.243Zm-6.838 6.235-5.547 1.466 6.524.422-.977-1.888Zm5.962-4.15-4.856 3.657.965 1.905 3.891-5.561ZM17.06 3.613l-.943 1.957 3.51 3.606-2.567-5.563Zm-1.175-.936L9.72 2.423l5.085 2.248 1.08-1.995ZM5.702 3.58 1.384 9.091l2.887.618L5.702 3.58Zm-1.605 7.21-2.901-.62 3.027 7.206-.126-6.586Z"
            })
        })
    });
var $2ebf3a18dc3f3ead$export$2e2bcd8739ae039 = $2ebf3a18dc3f3ead$var$SvgPnk;







const $dd25e1eb51e69c37$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  margin-top: 12px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-top: 32px;
      gap: 32px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    `)}
`;
const $dd25e1eb51e69c37$var$format = (value)=>value !== undefined ? (0, $3Szoa.formatEther)(value) : "0";
const $dd25e1eb51e69c37$var$bigIntRatioToPercentage = (numerator, denominator)=>{
    const decimalPlaces = 2;
    const factor = BigInt(10) ** BigInt(decimalPlaces);
    const intermediate = numerator * factor * 100n / denominator;
    const result = intermediate.toString();
    const pointIndex = result.length - decimalPlaces;
    const integerPart = result.slice(0, pointIndex) || "0";
    const decimalPart = result.slice(pointIndex);
    return `${integerPart}${decimalPart.length > 0 ? "." + decimalPart : ".00"}%`;
};
const $dd25e1eb51e69c37$var$useCalculateJurorOdds = (jurorBalance, stakedByAllJurors, loading)=>{
    return (0, $dup7A.useMemo)(()=>{
        if (loading) return "Calculating...";
        if (!jurorBalance || !stakedByAllJurors || stakedByAllJurors === "0") return "0.00%";
        return $dd25e1eb51e69c37$var$bigIntRatioToPercentage(jurorBalance[2], BigInt(stakedByAllJurors));
    }, [
        jurorBalance,
        stakedByAllJurors,
        loading
    ]);
};
const $dd25e1eb51e69c37$var$JurorBalanceDisplay = ()=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: jurorBalance } = (0, $f9a008fec395d7ff$export$95ba38bd72119500)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(address),
        args: [
            address ?? "0x",
            BigInt(id ?? 0)
        ],
        watch: true
    });
    const { data: courtDetails } = (0, $6c35bcc70e144cdf$export$cac3085b56a3ca27)(id);
    const stakedByAllJurors = courtDetails?.court?.stake;
    const [loading, setLoading] = (0, $dup7A.useState)(false);
    const [previousJurorBalance, setPreviousJurorBalance] = (0, $dup7A.useState)(undefined);
    const [previousStakedByAllJurors, setPreviousStakedByAllJurors] = (0, $dup7A.useState)(undefined);
    (0, $dup7A.useEffect)(()=>{
        if (previousJurorBalance !== undefined && jurorBalance?.[2] !== previousJurorBalance) setLoading(true);
        setPreviousJurorBalance(jurorBalance?.[2]);
    }, [
        jurorBalance,
        previousJurorBalance
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (loading && stakedByAllJurors !== undefined && BigInt(stakedByAllJurors) !== previousStakedByAllJurors) setLoading(false);
        if (stakedByAllJurors !== undefined) setPreviousStakedByAllJurors(BigInt(stakedByAllJurors));
    }, [
        stakedByAllJurors,
        loading,
        previousStakedByAllJurors
    ]);
    const jurorOdds = $dd25e1eb51e69c37$var$useCalculateJurorOdds(jurorBalance, stakedByAllJurors, loading);
    const data = [
        {
            icon: (0, $2ebf3a18dc3f3ead$export$2e2bcd8739ae039),
            name: "My Stake",
            value: `${$dd25e1eb51e69c37$var$format(jurorBalance?.[2])} PNK`
        },
        {
            icon: (0, $de98112b8f7c78be$export$2e2bcd8739ae039),
            name: "Juror Odds",
            value: jurorOdds
        }
    ];
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dd25e1eb51e69c37$var$Container, {
        children: data.map(({ icon: icon, name: name, value: value })=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $683c94038b13f611$export$2e2bcd8739ae039), {
                isJurorBalance: true,
                icon: icon,
                name: name,
                value: value
            }, name))
    });
};
var $dd25e1eb51e69c37$export$2e2bcd8739ae039 = $dd25e1eb51e69c37$var$JurorBalanceDisplay;



const $6c5c842cad256af7$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 28px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
    `)};
`;
const $6c5c842cad256af7$var$LeftArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: 50%;
    `)};
`;
const $6c5c842cad256af7$var$TagArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
`;
const $6c5c842cad256af7$var$StakeArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)($6c5c842cad256af7$var$TagArea)`
  margin-top: 28px;
  flex-direction: column;
`;
const $6c5c842cad256af7$var$TextArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: 32px;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $6c5c842cad256af7$var$ThreePnksIconContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: 50%;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: 42px;
      margin-right: 52px;
    `)};
`;
const $6c5c842cad256af7$var$StakePanel = ({ courtName: courtName = "General Court", id: id })=>{
    const [amount, setAmount] = (0, $dup7A.useState)("");
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $dup7A.useState)(false);
    const [isActive, setIsActive] = (0, $dup7A.useState)(true);
    const [action, setAction] = (0, $dup7A.useState)((0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).stake);
    (0, $bafdb2a6661c2921$export$eb909a3d9177a60d)(isPopupOpen);
    const handleClick = (action)=>{
        setIsActive(action === (0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).stake);
        setAction(action);
    };
    const isStaking = action === (0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).stake;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($6c5c842cad256af7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($6c5c842cad256af7$var$LeftArea, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($6c5c842cad256af7$var$TagArea, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5943a6ce69d75259$export$2e2bcd8739ae039), {
                                text: "Stake",
                                active: isActive,
                                onClick: ()=>handleClick((0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).stake)
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5943a6ce69d75259$export$2e2bcd8739ae039), {
                                text: "Withdraw",
                                active: !isActive,
                                onClick: ()=>handleClick((0, $cc88e7e3df6b7345$export$e4a712fff93fb00f).withdraw)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($6c5c842cad256af7$var$TextArea, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("strong", {
                                children: `${isStaking ? "Stake" : "Withdraw"} PNK`
                            }),
                            " ",
                            `${isStaking ? "to join the" : "from"}`,
                            " ",
                            courtName,
                            " court"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($6c5c842cad256af7$var$StakeArea, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5bcc0a920e01c883$export$2e2bcd8739ae039), {
                                action: action,
                                isSending: isSending,
                                setIsSending: setIsSending,
                                setIsPopupOpen: setIsPopupOpen,
                                amount: amount,
                                setAmount: setAmount
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dd25e1eb51e69c37$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    isPopupOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$2e2bcd8739ae039), {
                        title: isStaking ? "Stake Confirmed" : "Withdraw Confirmed",
                        icon: (0, $8038492093b5d637$export$2e2bcd8739ae039),
                        popupType: (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).STAKE_WITHDRAW,
                        isStake: isStaking,
                        pnkStaked: amount,
                        courtName: courtName,
                        courtId: id,
                        setIsOpen: setIsPopupOpen,
                        setAmount: setAmount
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($6c5c842cad256af7$var$ThreePnksIconContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $66d1db805a75a297$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $6c5c842cad256af7$export$2e2bcd8739ae039 = $6c5c842cad256af7$var$StakePanel;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $2670defb153a6fcf$var$SvgEthereum = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 13 22",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "m12.667 11.197-6.133 3.806-6.137-3.806L6.534.5l6.133 10.697Zm-6.133 5.028L.397 12.42 6.534 21.5l6.137-9.08-6.137 3.805Z"
        })
    });
var $2670defb153a6fcf$export$2e2bcd8739ae039 = $2670defb153a6fcf$var$SvgEthereum;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $bbf587852a7c3e8e$var$SvgMinStake = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "10 9 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('f6920d35537b27d1')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m19.602 9.313 10.45.472 4.232 9.5-5.97 8.683-10.506-.68L13.5 16.994l6.102-7.681Zm7.662 5.476-7.574 3.344 6.475 5.06 1.099-8.404Zm-.877-1.676-6.053-2.634-1.271 5.538 7.324-2.904Zm-1.534 11.352-6.578-4.747.16 6.433 6.418-1.686Zm8.38-5.201-4.483-4.597-1.183 8.84 5.666-4.243Zm-6.838 6.235-5.547 1.466 6.524.422-.977-1.888Zm5.962-4.15-4.856 3.657.965 1.905 3.891-5.561ZM30.06 11.113l-.943 1.957 3.51 3.606-2.567-5.563Zm-1.175-.937-6.165-.252 5.085 2.248 1.08-1.995Zm-10.183.905-4.318 5.511 2.887.618 1.431-6.128Zm-1.605 7.21-2.901-.62 3.027 7.206-.126-6.586Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "m18.594 37-1.74-5.01h-.033c.046.743.07 1.44.07 2.092V37H16v-6h1.383l1.666 4.773h.025L20.789 31h1.387v6h-.943v-2.967c0-.298.006-.687.02-1.166.017-.478.03-.768.041-.87h-.033L19.46 37h-.866ZM23.756 37v-6h.981v6h-.98ZM31.324 37h-1.202l-2.951-4.781h-.033l.02.267c.039.509.058.974.058 1.395V37h-.89v-6h1.19l2.942 4.757h.025a27.612 27.612 0 0 1-.033-.686 23.963 23.963 0 0 1-.025-.927V31h.9v6Z"
            })
        ]
    });
var $bbf587852a7c3e8e$export$2e2bcd8739ae039 = $bbf587852a7c3e8e$var$SvgMinStake;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $4471110cf3694b38$var$SvgRedistributedPnk = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "6 6 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('8e71c3eac2e20dfd')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m19.602 14.813 10.45.472 4.232 9.5-5.97 8.683-10.506-.68L13.5 22.494l6.102-7.681Zm7.662 5.476-7.574 3.344 6.475 5.06 1.099-8.404Zm-.877-1.676-6.053-2.634-1.271 5.538 7.324-2.904Zm-1.534 11.352-6.578-4.747.16 6.433 6.418-1.686Zm8.38-5.201-4.483-4.597-1.183 8.84 5.666-4.243Zm-6.838 6.235-5.547 1.466 6.524.422-.977-1.888Zm5.962-4.15-4.856 3.657.965 1.905 3.891-5.561ZM30.06 16.613l-.943 1.957 3.51 3.607-2.567-5.564Zm-1.175-.936-6.165-.253 5.085 2.248 1.08-1.995Zm-10.183.905-4.318 5.51 2.887.618 1.431-6.128Zm-1.605 7.21-2.901-.622 3.027 7.207-.126-6.586Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('7ff924cb614b3874')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m8.3 25.626-.199.197a.214.214 0 0 1-.303 0l-1.735-1.729a.212.212 0 0 1 0-.301l1.735-1.73a.214.214 0 0 1 .303 0l.198.197a.213.213 0 0 1-.003.305L7.22 23.587h2.566c.118 0 .214.095.214.214v.284a.213.213 0 0 1-.214.214H7.22l1.076 1.021c.087.083.089.221.003.306Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('b5f02e1b89ca6595')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m39.7 22.374.199-.197a.214.214 0 0 1 .303 0l1.735 1.729a.212.212 0 0 1 0 .301l-1.735 1.73a.214.214 0 0 1-.303 0l-.198-.197a.213.213 0 0 1 .003-.305l1.076-1.022h-2.566a.213.213 0 0 1-.214-.214v-.284c0-.119.096-.214.214-.214h2.566l-1.076-1.021a.212.212 0 0 1-.003-.306Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('c1488807f22ede06')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m22.374 8.3-.197-.199a.214.214 0 0 1 0-.303l1.729-1.735a.212.212 0 0 1 .301 0l1.73 1.735a.214.214 0 0 1 0 .303l-.197.198a.213.213 0 0 1-.305-.003L24.413 7.22v2.566a.213.213 0 0 1-.214.214h-.284a.213.213 0 0 1-.214-.214V7.22L22.68 8.296a.212.212 0 0 1-.306.003Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('85b8ff2224b52232')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    d: "m25.626 39.7.197.199a.214.214 0 0 1 0 .303l-1.729 1.735a.212.212 0 0 1-.301 0l-1.73-1.735a.214.214 0 0 1 0-.303l.197-.198a.213.213 0 0 1 .305.003l1.022 1.076v-2.566c0-.118.095-.214.214-.214h.284c.119 0 .214.096.214.214v2.566l1.021-1.076a.212.212 0 0 1 .306-.003Z"
                })
            })
        ]
    });
var $4471110cf3694b38$export$2e2bcd8739ae039 = $4471110cf3694b38$var$SvgRedistributedPnk;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $21c4158800e7404c$var$SvgVoteStake = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "10 9 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
                clipPath: "url('cc48065326c4f652')",
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                    clipRule: "evenodd",
                    d: "m19.602 9.313 10.45.472 4.232 9.5-5.97 8.683-10.506-.68L13.5 16.994l6.102-7.681Zm7.662 5.476-7.574 3.344 6.475 5.06 1.099-8.404Zm-.877-1.676-6.053-2.634-1.271 5.538 7.324-2.904Zm-1.534 11.352-6.578-4.747.16 6.433 6.418-1.686Zm8.38-5.201-4.483-4.597-1.183 8.84 5.666-4.243Zm-6.838 6.235-5.547 1.466 6.524.422-.977-1.888Zm5.962-4.15-4.856 3.657.965 1.905 3.891-5.561ZM30.06 11.113l-.943 1.957 3.51 3.606-2.567-5.563Zm-1.175-.937-6.165-.252 5.085 2.248 1.08-1.995Zm-10.183.905-4.318 5.511 2.887.618 1.431-6.128Zm-1.605 7.21-2.901-.62 3.027 7.206-.126-6.586Z"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                clipRule: "evenodd",
                d: "M18.09 31.092h.99l-2.042 5.828h-1.005L14 31.092h.98l1.217 3.624c.064.172.131.396.203.67.072.27.118.472.14.605a7.76 7.76 0 0 1 .159-.701c.072-.266.13-.463.175-.59l1.216-3.608ZM25.023 33.998c0 .949-.238 1.686-.713 2.213-.473.526-1.145.789-2.014.789-.88 0-1.556-.26-2.029-.781-.47-.524-.706-1.267-.706-2.229 0-.962.237-1.701.71-2.217.476-.515 1.154-.773 2.033-.773.867 0 1.537.262 2.01.785.473.524.71 1.262.71 2.213Zm-4.449 0c0 .718.145 1.263.435 1.635.29.369.719.554 1.287.554.567 0 .993-.184 1.28-.55.29-.367.435-.913.435-1.639 0-.715-.144-1.257-.43-1.627-.285-.369-.71-.554-1.277-.554-.571 0-1.003.185-1.295.554-.29.37-.435.912-.435 1.627ZM28.288 36.92h-.953V31.91h-1.714v-.817h4.382v.817h-1.715v5.011ZM34.197 36.92H30.9v-5.828h3.297v.805h-2.345v1.587h2.197v.797h-2.197v1.83h2.345v.81Z"
            })
        ]
    });
var $21c4158800e7404c$export$2e2bcd8739ae039 = $21c4158800e7404c$var$SvgVoteStake;


// https://apiguide.coingecko.com/getting-started/10-min-tutorial-guide/1-get-data-by-id-or-address
const $dc69730cf3c4367b$export$9943437e13d9c9e1 = {
    ETH: "coingecko:ethereum",
    PNK: "coingecko:kleros"
};



const $395644ae226c29e9$var$fetchCoinPrices = async (...coinIds)=>{
    const response = await fetch(`https://coins.llama.fi/prices/current/${coinIds.join(",")}?searchWidth=1h`);
    const data = await response.json();
    return data.coins;
};
const $395644ae226c29e9$export$28d4a1ba7888e974 = (coinIds)=>{
    const isEnabled = coinIds !== undefined;
    const { data: prices, isError: isError } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `coinPrice${coinIds}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>$395644ae226c29e9$var$fetchCoinPrices(coinIds)
    });
    return {
        prices: prices,
        isError: isError
    };
};



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $ccd60bbb754b302e$export$789eb2f4a09b2030 = (countersOrCourtData, getSubtext, coinPrice)=>{
    if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(countersOrCourtData) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(getSubtext)) return getSubtext(countersOrCourtData, coinPrice);
    else if (getSubtext === undefined) return "";
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {});
};








var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $b3f034411f0a9f49$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  max-width: 196px;
  align-items: center;
  gap: 8px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 30)};
    `)}
`;
const $b3f034411f0a9f49$var$SVGContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background-color: ${({ backgroundColor: backgroundColor })=>backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    fill: ${({ iconColor: iconColor })=>iconColor};
    height: ${({ iconColor: iconColor, theme: theme })=>iconColor === theme.success ? "24px" : "32px"};
    width: ${({ iconColor: iconColor, theme: theme })=>iconColor === theme.success ? "24px" : "32px"};
  }
`;
const $b3f034411f0a9f49$var$TextContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  h1 {
    margin: 0;
  }
`;
const $b3f034411f0a9f49$var$createPair = (iconColor, backgroundColor)=>({
        iconColor: iconColor,
        backgroundColor: backgroundColor
    });
const $b3f034411f0a9f49$var$StatDisplay = ({ title: title, text: text, subtext: subtext, icon: Icon, color: color, ...props })=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const COLORS = {
        red: $b3f034411f0a9f49$var$createPair(theme.error, theme.errorLight),
        orange: $b3f034411f0a9f49$var$createPair(theme.warning, theme.warningLight),
        green: $b3f034411f0a9f49$var$createPair(theme.success, theme.successLight),
        blue: $b3f034411f0a9f49$var$createPair(theme.primaryBlue, theme.mediumBlue),
        purple: $b3f034411f0a9f49$var$createPair(theme.secondaryPurple, theme.mediumPurple)
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($b3f034411f0a9f49$var$Container, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($b3f034411f0a9f49$var$SVGContainer, {
                ...COLORS[color],
                children: /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($b3f034411f0a9f49$var$TextContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: subtext
                    })
                ]
            })
        ]
    });
};
var $b3f034411f0a9f49$export$2e2bcd8739ae039 = $b3f034411f0a9f49$var$StatDisplay;



const $44eeabff9b80a299$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: auto;
  height: fit-content;
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(0, 32)} 0;
  padding-bottom: 0px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 16px;
    `)}
`;
const $44eeabff9b80a299$var$stats = [
    {
        title: "Min Stake",
        coinId: 0,
        getText: (data)=>(0, $fccd0e08af927011$export$fe0dbb825775d15c)(data?.minStake),
        getSubtext: (data, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)(data?.minStake)) * (coinPrice ?? 0)),
        color: "purple",
        icon: (0, $bbf587852a7c3e8e$export$2e2bcd8739ae039)
    },
    {
        title: "Vote Stake",
        coinId: 0,
        getText: (data)=>{
            const stake = BigInt(data?.minStake * data?.alpha / 1e4);
            return (0, $fccd0e08af927011$export$fe0dbb825775d15c)(stake);
        },
        getSubtext: (data, coinPrice)=>{
            const stake = BigInt(data?.minStake * data?.alpha / 1e4);
            return (0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)(stake)) * (coinPrice ?? 0));
        },
        color: "purple",
        icon: (0, $21c4158800e7404c$export$2e2bcd8739ae039)
    },
    {
        title: "Active Jurors",
        getText: (data)=>data?.numberStakedJurors,
        color: "purple",
        icon: (0, $4471110cf3694b38$export$2e2bcd8739ae039)
    },
    {
        title: "PNK Staked",
        coinId: 0,
        getText: (data)=>(0, $fccd0e08af927011$export$fe0dbb825775d15c)(data?.stake),
        getSubtext: (data, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)(data?.stake)) * (coinPrice ?? 0)),
        color: "purple",
        icon: (0, $2ebf3a18dc3f3ead$export$2e2bcd8739ae039)
    },
    {
        title: "Cases",
        getText: (data)=>data?.numberDisputes,
        color: "orange",
        icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039)
    },
    {
        title: "In Progress",
        getText: (data)=>data?.numberDisputes - data?.numberClosedDisputes,
        color: "orange",
        icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039)
    },
    {
        title: "ETH paid to Jurors",
        coinId: 1,
        getText: (data)=>(0, $fccd0e08af927011$export$81d0e33f8b79c8db)(data?.paidETH),
        getSubtext: (data, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)(data?.paidETH)) * (coinPrice ?? 0)),
        color: "blue",
        icon: (0, $2670defb153a6fcf$export$2e2bcd8739ae039)
    },
    {
        title: "PNK redistributed",
        coinId: 0,
        getText: (data)=>(0, $fccd0e08af927011$export$fe0dbb825775d15c)(data?.paidPNK),
        getSubtext: (data, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)(data?.paidPNK)) * (coinPrice ?? 0)),
        color: "purple",
        icon: (0, $4471110cf3694b38$export$2e2bcd8739ae039)
    }
];
const $44eeabff9b80a299$var$Stats = ()=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $6c35bcc70e144cdf$export$cac3085b56a3ca27)(id);
    const coinIds = [
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).PNK,
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).ETH
    ];
    const { prices: pricesData } = (0, $395644ae226c29e9$export$28d4a1ba7888e974)(coinIds);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($44eeabff9b80a299$var$StyledCard, {
        children: $44eeabff9b80a299$var$stats.map(({ title: title, coinId: coinId, getText: getText, getSubtext: getSubtext, color: color, icon: icon }, i)=>{
            const coinPrice = !(0, $2d857633ba67aa25$export$fce6876652108ab)(pricesData) ? pricesData[coinIds[coinId]]?.price : undefined;
            return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b3f034411f0a9f49$export$2e2bcd8739ae039), {
                title: title,
                color: color,
                icon: icon,
                text: data ? getText(data.court) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {}),
                subtext: (0, $ccd60bbb754b302e$export$789eb2f4a09b2030)(data ? data.court : undefined, getSubtext, coinPrice)
            }, i);
        })
    });
};
var $44eeabff9b80a299$export$2e2bcd8739ae039 = $44eeabff9b80a299$var$Stats;


const $280911da292ab837$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div``;
const $280911da292ab837$var$CourtHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
`;
const $280911da292ab837$var$CourtInfo = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex:
  flex-direction: column;
  gap: 16px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 32px;
    `)};
`;
const $280911da292ab837$var$ButtonContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      align-items: flex-end;
      gap: 32px;
    `)};
`;
const $280911da292ab837$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 24)};
  width: 100%;
  height: auto;
  min-height: 100px;
`;
const $280911da292ab837$var$StyledBreadcrumb = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Breadcrumb))`
  display: flex;
  margin-top: 12px;
  align-items: center;
`;
const $280911da292ab837$var$StyledBreadcrumbSkeleton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: 12px;
`;
const $280911da292ab837$var$CourtDetails = ()=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: policy } = (0, $3043cbfb1ed10cf4$export$e0985f714b0d92d6)(id);
    const { data: data } = (0, $2a5b6389d5454647$export$2b3a4edc6425a652)();
    const [isStakingMiniGuideOpen, toggleStakingMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const courtPath = $280911da292ab837$export$fdd82b205ac64f8a(data?.court, id);
    const items = [
        {
            text: "\uD83C\uDFDB\uFE0F",
            value: "0"
        }
    ];
    items.push(...courtPath?.map((node)=>({
            text: node.name,
            value: node.id
        })) ?? []);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($280911da292ab837$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($280911da292ab837$var$StyledCard, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($280911da292ab837$var$CourtHeader, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($280911da292ab837$var$CourtInfo, {
                                children: [
                                    policy ? policy.name : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                                        width: 200
                                    }),
                                    items.length > 1 ? /*#__PURE__*/ (0, $cZGFG.jsx)($280911da292ab837$var$StyledBreadcrumb, {
                                        items: items
                                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)($280911da292ab837$var$StyledBreadcrumbSkeleton, {
                                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                                            width: 100
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($280911da292ab837$var$ButtonContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                                        isMiniGuideOpen: isStakingMiniGuideOpen,
                                        toggleMiniGuide: toggleStakingMiniGuide,
                                        MiniGuideComponent: (0, $ac6168883415b9aa$export$2e2bcd8739ae039)
                                    }),
                                    !(0, $203b613495c69c62$export$9eecd5eb17097ec3)() && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d4a20a0b6123562f$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $44eeabff9b80a299$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6c5c842cad256af7$export$2e2bcd8739ae039), {
                        id: !(0, $2d857633ba67aa25$export$fce6876652108ab)(id) ? id : "",
                        courtName: policy?.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($280911da292ab837$var$StyledCard, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $bf6c5bb922de0f6f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3086dc6786764df3$export$2e2bcd8739ae039), {
                filters: {
                    court: id
                }
            })
        ]
    });
};
var $280911da292ab837$export$2e2bcd8739ae039 = $280911da292ab837$var$CourtDetails;
const $280911da292ab837$export$fdd82b205ac64f8a = (node, id, path = [])=>{
    if (!node || !id) return null;
    if (node.id === id) {
        path.unshift({
            name: node.name || "",
            id: node.id
        });
        return path;
    }
    if (node.children) for (const child of node.children){
        const pathFromChild = $280911da292ab837$export$fdd82b205ac64f8a(child, id, path.slice());
        if (pathFromChild) {
            pathFromChild.unshift({
                name: node.name || "",
                id: node.id
            });
            return pathFromChild;
        }
    }
    return null;
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $3Szoa = parcelRequire("3Szoa");
var $lTCHO = parcelRequire("lTCHO");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $008bee41e7941136$var$SvgAppeal = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('654c809f86b9cb7f')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#DDB6FF",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M1.096 7.39C.943 7.192.87 6.924.874 6.583H0c-.005.29.036.545.123.767.092.222.22.41.383.565.164.15.36.266.59.348.23.083.483.127.759.132V9h.33v-.604c.254-.01.492-.054.712-.132.22-.072.41-.178.574-.317a1.5 1.5 0 0 0 .383-.534c.097-.217.146-.47.146-.76 0-.278-.051-.513-.153-.704a1.47 1.47 0 0 0-.406-.48 2.258 2.258 0 0 0-.583-.317 7.343 7.343 0 0 0-.674-.217V3.3c.276 0 .475.07.598.209.127.14.196.34.207.604h.873c0-.253-.046-.475-.138-.666a1.275 1.275 0 0 0-.36-.472 1.484 1.484 0 0 0-.529-.28 2.233 2.233 0 0 0-.65-.092V2h-.33v.604c-.23 0-.45.034-.66.1A1.76 1.76 0 0 0 .637 3a1.388 1.388 0 0 0-.383.472 1.45 1.45 0 0 0-.138.65c0 .285.051.522.154.713.102.191.235.351.398.48.169.124.355.227.56.31.209.077.418.144.628.201V7.7c-.353-.01-.606-.113-.759-.31Zm.115-3.911c.153-.119.368-.178.644-.178V4.85a3.774 3.774 0 0 1-.322-.093 1.196 1.196 0 0 1-.276-.155.81.81 0 0 1-.192-.225.62.62 0 0 1-.076-.317c0-.274.074-.467.222-.581Zm1.647 3.98c-.173.14-.398.22-.674.24V5.895c.118.03.233.067.345.108.112.042.212.096.299.163a.722.722 0 0 1 .299.612c0 .31-.09.537-.269.681ZM13.5 6.889c.298.173.5.492.5.861 0 .37-.202.688-.5.861V11c0 .144-.11.5-.5.5a.5.5 0 0 1-.312-.11l-1.329-1.063A3.792 3.792 0 0 0 9 9.5h-.439c-.043.16-.069.326-.069.5 0 .454.153.874.409 1.21.247.324.002.79-.405.79h-1.16a.49.49 0 0 1-.444-.267A3.958 3.958 0 0 1 6.527 9.5H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3c.854 0 1.692-.294 2.36-.827l1.328-1.063A.499.499 0 0 1 13 4c.39 0 .5.363.5.5V6.89Zm-1.516 2.658.516.413V5.54l-.516.413A4.794 4.794 0 0 1 9 7v1.5c1.08 0 2.14.372 2.984 1.047Z"
            })
        })
    });
var $008bee41e7941136$export$2e2bcd8739ae039 = $008bee41e7941136$var$SvgAppeal;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $0dcda8e8f0ff0e77$var$SvgEvidence = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.795 1.75h.534c.048 0 .072.023.072.068V4.49h2.653c.047 0 .071.023.071.068v.51c0 .046-.024.069-.071.069H3.4v2.67c0 .046-.024.069-.072.069h-.534c-.047 0-.071-.023-.071-.068V5.136H.071C.024 5.136 0 5.113 0 5.068v-.51c0-.046.024-.069.071-.069h2.653V1.82c0-.046.024-.069.071-.069Zm9.455 5.592v-.479c0-.113-.098-.205-.219-.205H8.97c-.12 0-.219.092-.219.205v.479c0 .113.098.205.219.205h3.062c.12 0 .219-.092.219-.205Zm-3.281.752h3.062c.12 0 .219.092.219.205v.478c0 .113-.098.205-.219.205H8.97c-.12 0-.219-.092-.219-.205V8.3c0-.113.098-.205.219-.205ZM14 10.554V4.88a.793.793 0 0 0-.257-.58l-1.53-1.433a.905.905 0 0 0-.617-.241H7.875c-.483 0-.875.367-.875.82v7.11c0 .453.392.82.875.82h5.25c.483 0 .875-.367.875-.82Zm-2.333-5.742v-1.3l1.387 1.3h-1.387Zm1.458.82v4.923h-5.25v-7.11h2.917v1.778c0 .227.195.41.437.41h1.896Z",
            fill: "#6CC5FF"
        })
    });
var $0dcda8e8f0ff0e77$export$2e2bcd8739ae039 = $0dcda8e8f0ff0e77$var$SvgEvidence;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $69e74902ce38d97d$var$SvgForgotVote = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M9.61 2.73 7.432 5.25l2.176 2.52c.037.041.006.105-.05.105h-.662a.134.134 0 0 1-.102-.046L7 5.751 5.205 7.829a.137.137 0 0 1-.102.046h-.662a.067.067 0 0 1-.035-.01.065.065 0 0 1-.025-.027.062.062 0 0 1 .01-.068l2.176-2.52-2.176-2.52c-.037-.041-.006-.105.05-.105h.662c.04 0 .077.017.102.046L7 4.749l1.795-2.078a.137.137 0 0 1 .102-.046h.662c.056 0 .087.064.05.105Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m11.667 2.805-.067-.441A1.75 1.75 0 0 0 9.87.875H4.13A1.75 1.75 0 0 0 2.4 2.364l-.067.441v7.335h9.334V2.805Zm-8.896.033v6.864h8.458V2.838l-.062-.41A1.313 1.313 0 0 0 9.87 1.314H4.13c-.649 0-1.2.474-1.297 1.116l-.062.409Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M1.167 7.824C.523 7.824 0 8.342 0 8.982v2.316c0 .64.523 1.158 1.167 1.158h11.666c.644 0 1.167-.519 1.167-1.158V8.982c0-.64-.523-1.158-1.167-1.158h-.389v3.088H1.556V7.824h-.39Z",
                fill: "#B45FFF"
            })
        ]
    });
var $69e74902ce38d97d$export$2e2bcd8739ae039 = $69e74902ce38d97d$var$SvgForgotVote;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $660e7fd187414818$var$SvgFunded = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M3.33 1.75h-.535c-.047 0-.071.023-.071.068V4.49H.071c-.047 0-.071.023-.071.068v.51c0 .046.024.069.071.069h2.653v2.67c0 .046.024.069.071.069h.534c.048 0 .072-.023.072-.068V5.136h2.653c.047 0 .071-.023.071-.068v-.51c0-.046-.024-.069-.071-.069H3.4V1.82c0-.046-.024-.069-.072-.069Z",
                fill: "#DDB6FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5 6.889c.298.173.5.492.5.861 0 .37-.202.688-.5.861V11c0 .144-.11.5-.5.5a.5.5 0 0 1-.312-.11l-1.329-1.063A3.792 3.792 0 0 0 9 9.5h-.439c-.043.16-.069.326-.069.5 0 .454.153.874.409 1.21.247.324.002.79-.405.79h-1.16a.49.49 0 0 1-.444-.267A3.958 3.958 0 0 1 6.527 9.5H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3c.854 0 1.692-.294 2.36-.827l1.328-1.063A.499.499 0 0 1 13 4c.39 0 .5.363.5.5V6.89Zm-1.516 2.658.516.413V5.54l-.516.413A4.794 4.794 0 0 1 9 7v1.5c1.08 0 2.14.372 2.984 1.047Z",
                fill: "#DDB6FF"
            })
        ]
    });
var $660e7fd187414818$export$2e2bcd8739ae039 = $660e7fd187414818$var$SvgFunded;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $10508f8c0d89a999$var$SvgMinusCircle = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('14070a1c3c01d080')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 7a7 7 0 1 1 14.001.001A7 7 0 0 1 0 7Zm1.188 0a5.813 5.813 0 0 0 11.624 0A5.813 5.813 0 0 0 1.188 7ZM4 6.625c0-.069.056-.125.125-.125h5.75c.069 0 .125.056.125.125v.75a.125.125 0 0 1-.125.125h-5.75A.125.125 0 0 1 4 7.375v-.75Z",
                fill: "#BECCE5"
            })
        })
    });
var $10508f8c0d89a999$export$2e2bcd8739ae039 = $10508f8c0d89a999$var$SvgMinusCircle;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $4d922f3bee3520b6$var$SvgVote = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.063 9.625H3.936c-.241 0-.437-.184-.437-.41V8.94c0-.226.196-.41.438-.41 0-1.554.93-2.866 2.202-3.281-1.273-.415-2.202-1.727-2.202-3.281-.242 0-.438-.184-.438-.41v-.274c0-.226.196-.41.438-.41h6.124c.242 0 .438.184.438.41v.274c0 .226-.196.41-.438.41 0 1.554-.93 2.866-2.202 3.281 1.273.415 2.202 1.727 2.202 3.281.242 0 .438.184.438.41v.274c0 .226-.196.41-.438.41ZM8.896 1.969H5.104c0 1.324.843 2.46 1.896 2.46 1.054 0 1.896-1.137 1.896-2.46Z",
                fill: "#6CC5FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M1.167 7.824C.523 7.824 0 8.342 0 8.982v2.316c0 .64.523 1.158 1.167 1.158h11.666c.644 0 1.167-.519 1.167-1.158V8.982c0-.64-.523-1.158-1.167-1.158h-.389v3.088H1.556V7.824h-.39Z",
                fill: "#6CC5FF"
            })
        ]
    });
var $4d922f3bee3520b6$export$2e2bcd8739ae039 = $4d922f3bee3520b6$var$SvgVote;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $340d48fa930a2975$var$SvgVoted = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M9.832 2.625h.6c.057 0 .088.066.053.11l-4.19 5.309a.275.275 0 0 1-.43 0l-2.35-2.977a.068.068 0 0 1 .054-.11h.6a.275.275 0 0 1 .215.104L6.08 7.21l3.536-4.48a.273.273 0 0 1 .216-.105Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m11.6 2.364.067.441v7.335H2.333V2.805l.067-.441A1.75 1.75 0 0 1 4.13.875h5.74a1.75 1.75 0 0 1 1.73 1.489ZM2.77 9.702V2.838l.063-.41A1.313 1.313 0 0 1 4.13 1.314h5.74c.649 0 1.2.474 1.297 1.116l.062.409v6.864H2.771Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M0 8.982c0-.64.523-1.158 1.167-1.158h.389v3.088h10.888V7.824h.39c.643 0 1.166.518 1.166 1.158v2.316c0 .64-.523 1.158-1.167 1.158H1.167A1.163 1.163 0 0 1 0 11.298V8.982Z",
                fill: "#B45FFF"
            })
        ]
    });
var $340d48fa930a2975$export$2e2bcd8739ae039 = $340d48fa930a2975$var$SvgVoted;





const $5ebf0e3ef82ae258$var$labelQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query LabelInfo($address: String, $disputeID: ID!) {
    dispute(id: $disputeID) {
      period

      shifts(where: { juror: $address }) {
        ethAmount
        pnkAmount
      }
      rounds {
        drawnJurors(where: { juror: $address }, first: 1) {
          vote {
            ... on ClassicVote {
              choice
            }
          }
        }
      }
      disputeKitDispute {
        localRounds {
          ... on ClassicRound {
            contributions(where: { contributor: $address }) {
              amount
              rewardAmount
            }
          }
        }
      }
    }
  }
`);
const $5ebf0e3ef82ae258$export$cd504ecfbce1e62c = (address, disputeID)=>{
    const isEnabled = !!(address && disputeID);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `labelQuery${[
                address,
                disputeID
            ]}`
        ],
        enabled: isEnabled,
        staleTime: 60000,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $5ebf0e3ef82ae258$var$labelQuery,
                variables: {
                    address: address,
                    disputeID: disputeID
                }
            })
    });
};





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

const $c7c4a60f4fa3056f$var$COLORS = {
    red: [
        "error",
        "errorLight"
    ],
    green: [
        "success",
        "successLight"
    ],
    blue: [
        "primaryBlue",
        "mediumBlue"
    ],
    purple: [
        "secondaryPurple",
        "mediumPurple"
    ],
    lightPurple: [
        "tint",
        "mediumPurple"
    ],
    grey: [
        "secondaryText",
        "lightGrey"
    ]
};
const $c7c4a60f4fa3056f$var$LabelContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: inline-flex;
  width: max-content;
  padding: 4px 8px;
  align-items: center;
  gap: 10px;
  border-radius: 300px;
  background-color: ${({ backgroundColor: backgroundColor })=>backgroundColor};
`;
const $c7c4a60f4fa3056f$var$IconContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 14px;
  width: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    fill: ${({ contentColor: contentColor })=>contentColor};
  }
`;
const $c7c4a60f4fa3056f$var$StyledText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 12px;
  font-weight: 400;
  color: ${({ contentColor: contentColor })=>contentColor};
`;
const $c7c4a60f4fa3056f$var$Label = ({ text: text, icon: Icon, color: color })=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const [contentColor, backgroundColor] = (0, $dup7A.useMemo)(()=>{
        return $c7c4a60f4fa3056f$var$COLORS[color].map((color)=>theme[color]);
    }, [
        theme,
        color
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($c7c4a60f4fa3056f$var$LabelContainer, {
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($c7c4a60f4fa3056f$var$IconContainer, {
                contentColor: contentColor,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($c7c4a60f4fa3056f$var$StyledText, {
                contentColor: contentColor,
                children: text
            })
        ]
    });
};
var $c7c4a60f4fa3056f$export$2e2bcd8739ae039 = $c7c4a60f4fa3056f$var$Label;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $8fb7e015e1b00a30$var$getFormattedValue = (value, decimals)=>{
    const withFixedDecimals = value % 1 !== 0 ? value.toFixed(decimals) : value.toFixed(0);
    if (value !== 0) {
        if (withFixedDecimals === `0.${"0".repeat(decimals)}`) return `< 0.${"0".repeat(decimals - 1)}1`;
        else if (withFixedDecimals === `-0.${"0".repeat(decimals)}`) return `> -0.${"0".repeat(decimals - 1)}1`;
    }
    return withFixedDecimals;
};
const $8fb7e015e1b00a30$var$NumberDisplay = ({ value: value, unit: unit, place: place, decimals: decimals = 2, showUnitInDisplay: showUnitInDisplay = true, isCurrency: isCurrency = false })=>{
    const parsedValue = Number(value);
    const formattedValue = $8fb7e015e1b00a30$var$getFormattedValue(parsedValue, decimals);
    const tooltipValue = isCurrency ? `${unit} ${value}` : `${value} ${unit}`;
    const displayUnit = showUnitInDisplay ? unit : "";
    const displayValue = isCurrency ? `${displayUnit} ${formattedValue}` : `${formattedValue} ${displayUnit}`;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Tooltip), {
        small: true,
        text: tooltipValue,
        place: place,
        children: displayValue
    });
};
var $8fb7e015e1b00a30$export$2e2bcd8739ae039 = $8fb7e015e1b00a30$var$NumberDisplay;


const $5f86112a4efebf96$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: wrap;
`;
const $5f86112a4efebf96$var$StyledIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 12px;
  height: 12px;

  path {
    fill: ${({ color: color })=>color};
  }
`;
const $5f86112a4efebf96$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ color: color })=>color};
`;
const $5f86112a4efebf96$var$RewardsAndFundLabel = ({ value: value, unit: unit = "ETH", isFund: isFund = false })=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const isWon = Number(value) > 0;
    const color = isWon ? theme.success : theme.error;
    return Number(value) !== 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)($5f86112a4efebf96$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($5f86112a4efebf96$var$StyledLabel, {
                color: isFund ? theme.tint : color,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: value,
                    unit: unit,
                    showUnitInDisplay: false
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($5f86112a4efebf96$var$StyledIcon, {
                as: unit === "ETH" ? (0, $ef68e50e48a94340$export$2e2bcd8739ae039) : (0, $c62dc91ec117256f$export$2e2bcd8739ae039),
                color: isFund ? theme.tint : color
            })
        ]
    }) : null;
};
var $5f86112a4efebf96$export$2e2bcd8739ae039 = $5f86112a4efebf96$var$RewardsAndFundLabel;


const $dae0c1c349d64b8c$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: end;
  ${({ isList: isList })=>!isList && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      margin-top: 16px;
      width: 100%;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
    `}
`;
const $dae0c1c349d64b8c$var$RewardsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px 8px;
  flex-wrap: wrap;
  justify-content: end;
`;
const $dae0c1c349d64b8c$var$LabelArgs = {
    EvidenceTime: {
        text: "Evidence Time",
        icon: (0, $0dcda8e8f0ff0e77$export$2e2bcd8739ae039),
        color: "blue"
    },
    NotDrawn: {
        text: "Not Drawn",
        icon: (0, $10508f8c0d89a999$export$2e2bcd8739ae039),
        color: "grey"
    },
    CanVote: {
        text: "Time to vote",
        icon: (0, $4d922f3bee3520b6$export$2e2bcd8739ae039),
        color: "blue"
    },
    Voted: {
        text: "I voted",
        icon: (0, $340d48fa930a2975$export$2e2bcd8739ae039),
        color: "purple"
    },
    DidNotVote: {
        text: "Didn't cast a vote",
        icon: (0, $69e74902ce38d97d$export$2e2bcd8739ae039),
        color: "purple"
    },
    CanFund: {
        text: "Appeal possible",
        icon: (0, $008bee41e7941136$export$2e2bcd8739ae039),
        color: "lightPurple"
    },
    Funded: {
        text: "I funded",
        icon: (0, $660e7fd187414818$export$2e2bcd8739ae039),
        color: "lightPurple"
    }
};
const $dae0c1c349d64b8c$var$getFundingRewards = (contributions, closed)=>{
    if ((0, $2d857633ba67aa25$export$fce6876652108ab)(contributions) || contributions.length === 0) return 0;
    const contribution = contributions.reduce((acc, val)=>{
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(val?.rewardAmount) && (0, $2d857633ba67aa25$export$fce6876652108ab)(val?.amount)) return acc;
        if (closed) acc += val.rewardAmount === null ? -1 * Number(val.amount) : Number(val.rewardAmount) - Number(val.amount);
        else acc += Number(val.amount);
        return acc;
    }, 0);
    return Number((0, $lTCHO.formatUnits)(BigInt(contribution), 18));
};
const $dae0c1c349d64b8c$var$CardLabel = ({ disputeId: disputeId, round: round, isList: isList })=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: labelInfo, isLoading: isLoading } = (0, $5ebf0e3ef82ae258$export$cd504ecfbce1e62c)(address?.toLowerCase(), disputeId);
    const localRounds = (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(labelInfo?.dispute?.disputeKitDispute);
    const rounds = labelInfo?.dispute?.rounds;
    const currentRound = rounds?.[round];
    const period = labelInfo?.dispute?.period;
    const hasVotedCurrentRound = !(0, $2d857633ba67aa25$export$fce6876652108ab)(currentRound?.drawnJurors?.[0]?.vote?.choice);
    const isDrawnCurrentRound = currentRound?.drawnJurors.length !== 0;
    const hasVotedInDispute = rounds?.some((item)=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(item.drawnJurors?.[0]?.vote?.choice));
    const isDrawnInDispute = rounds?.some((item)=>item?.drawnJurors.length);
    const hasFundedCurrentRound = localRounds?.[round]?.contributions.length !== 0;
    const currentRoundFund = $dae0c1c349d64b8c$var$getFundingRewards(localRounds?.[round]?.contributions, period === "execution");
    const shifts = labelInfo?.dispute?.shifts;
    const contributions = (0, $dup7A.useMemo)(()=>localRounds?.reduce((acc, val)=>{
            acc.push(...val.contributions);
            return acc;
        }, []), [
        localRounds
    ]);
    const contributionRewards = (0, $dup7A.useMemo)(()=>$dae0c1c349d64b8c$var$getFundingRewards(contributions, true), [
        contributions
    ]);
    const hasFundedDispute = contributions?.length !== 0; // if ever funded the dispute in any round
    const labelData = (0, $dup7A.useMemo)(()=>{
        if (period === "evidence") return $dae0c1c349d64b8c$var$LabelArgs.EvidenceTime;
        if (!isDrawnCurrentRound && period === "appeal") return hasFundedCurrentRound ? $dae0c1c349d64b8c$var$LabelArgs.Funded : $dae0c1c349d64b8c$var$LabelArgs.CanFund;
        if (!isDrawnCurrentRound && period === "execution" && hasFundedDispute) return $dae0c1c349d64b8c$var$LabelArgs.Funded;
        if (period === "execution" && hasVotedInDispute) return $dae0c1c349d64b8c$var$LabelArgs.Voted;
        if (period === "execution" && isDrawnInDispute && !hasVotedInDispute) return $dae0c1c349d64b8c$var$LabelArgs.DidNotVote;
        if (!isDrawnCurrentRound) return $dae0c1c349d64b8c$var$LabelArgs.NotDrawn;
        if ([
            "commit",
            "vote"
        ].includes(period ?? "") && !hasVotedCurrentRound) return $dae0c1c349d64b8c$var$LabelArgs.CanVote;
        if (hasVotedCurrentRound) return $dae0c1c349d64b8c$var$LabelArgs.Voted; // plus rewards if execution
        return $dae0c1c349d64b8c$var$LabelArgs.DidNotVote; // plus rewards if execution
    }, [
        hasFundedCurrentRound,
        hasVotedCurrentRound,
        hasFundedDispute,
        hasVotedInDispute,
        isDrawnCurrentRound,
        isDrawnInDispute,
        period
    ]);
    const rewardsData = (0, $dup7A.useMemo)(()=>{
        const shift = shifts?.reduce((acc, val)=>{
            acc.ethShift += Number((0, $3Szoa.formatEther)(val.ethAmount));
            acc.pnkShift += Number((0, $lTCHO.formatUnits)(val.pnkAmount, 18));
            return acc;
        }, {
            ethShift: 0,
            pnkShift: 0
        });
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(shift)) return undefined;
        shift.ethShift += contributionRewards;
        return shift;
    }, [
        contributionRewards,
        shifts
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dae0c1c349d64b8c$var$Container, {
        isList: isList,
        children: isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
            width: 130,
            height: 14
        }) : /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c7c4a60f4fa3056f$export$2e2bcd8739ae039), {
                    ...labelData
                }),
                /*#__PURE__*/ (0, $cZGFG.jsxs)($dae0c1c349d64b8c$var$RewardsContainer, {
                    children: [
                        " ",
                        !(0, $2d857633ba67aa25$export$fce6876652108ab)(rewardsData) && period === "execution" ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5f86112a4efebf96$export$2e2bcd8739ae039), {
                                    value: rewardsData.ethShift.toString(),
                                    unit: "ETH"
                                }),
                                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5f86112a4efebf96$export$2e2bcd8739ae039), {
                                    value: rewardsData.pnkShift.toString(),
                                    unit: "PNK"
                                })
                            ]
                        }) : null,
                        !(0, $2d857633ba67aa25$export$fce6876652108ab)(currentRoundFund) && period === "appeal" ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5f86112a4efebf96$export$2e2bcd8739ae039), {
                            value: currentRoundFund.toString(),
                            unit: "ETH",
                            isFund: true
                        }) : null
                    ]
                })
            ]
        })
    });
};
var $dae0c1c349d64b8c$export$2e2bcd8739ae039 = $dae0c1c349d64b8c$var$CardLabel;


const $33869189c3ebf233$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-direction: column;
  justify-content: flex-end;
`;
const $33869189c3ebf233$var$CourtBranchFieldContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin-top: 16px;
  flex-wrap: wrap;
`;
const $33869189c3ebf233$var$RestOfFieldsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  ${({ isOverview: isOverview })=>isOverview && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          margin-top: 16px;
          gap: 32px;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
        `)}
    `};
`;
const $33869189c3ebf233$var$DisputeInfoCard = ({ isOverview: isOverview, showLabels: showLabels, fieldItems: fieldItems, court: court, courtId: courtId, disputeID: disputeID, round: round })=>{
    const { data: data } = (0, $2a5b6389d5454647$export$2b3a4edc6425a652)();
    const courtPath = (0, $280911da292ab837$export$fdd82b205ac64f8a)(data?.court, courtId);
    const items = (0, $dup7A.useMemo)(()=>[
            ...courtPath?.map((node)=>({
                    text: node.name,
                    value: node.id
                })) ?? []
        ], [
        courtPath
    ]);
    const courtBranchValue = items.map((item)=>item.text).join(" / ");
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($33869189c3ebf233$var$Container, {
        children: [
            court && courtId && isOverview && /*#__PURE__*/ (0, $cZGFG.jsx)($33869189c3ebf233$var$CourtBranchFieldContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $683c94038b13f611$export$2e2bcd8739ae039), {
                    icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039),
                    name: "Court Branch",
                    value: courtBranchValue,
                    isOverview: isOverview
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($33869189c3ebf233$var$RestOfFieldsContainer, {
                isOverview: isOverview,
                children: fieldItems.map((item)=>item.display ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $683c94038b13f611$export$2e2bcd8739ae039), {
                        ...item,
                        isOverview: isOverview
                    }, item.name) : null)
            }),
            showLabels ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dae0c1c349d64b8c$export$2e2bcd8739ae039), {
                disputeId: disputeID,
                round: round - 1
            }) : null
        ]
    });
};
var $33869189c3ebf233$export$2e2bcd8739ae039 = $33869189c3ebf233$var$DisputeInfoCard;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $09b339e39f2fe811$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: ${({ isLabel: isLabel })=>isLabel ? "space-between" : "flex-end"};
  flex: 0 1 ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(400, 450, 900)};
  align-items: center;
  padding-right: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 24, 900)};
  gap: 8px;
`;
const $09b339e39f2fe811$var$RestOfFieldsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  gap: 8px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 32, 900)};
  align-items: center;
  height: min-content;
  width: max-content;
  display: grid;
  grid-template-columns: repeat(3, min-content);
  justify-content: start;
`;
const $09b339e39f2fe811$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $683c94038b13f611$export$2e2bcd8739ae039))`
  ${({ style: style })=>style ?? ""}
`;
const $09b339e39f2fe811$var$DisputeInfoList = ({ fieldItems: fieldItems, showLabels: showLabels, disputeID: disputeID, round: round })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($09b339e39f2fe811$var$Container, {
        isLabel: showLabels,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($09b339e39f2fe811$var$RestOfFieldsContainer, {
                children: fieldItems.map((item)=>item.display ? /*#__PURE__*/ (0, $cZGFG.jsx)($09b339e39f2fe811$var$StyledField, {
                        ...item,
                        displayAsList: true
                    }, item.name) : null)
            }),
            showLabels ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dae0c1c349d64b8c$export$2e2bcd8739ae039), {
                disputeId: disputeID,
                round: round - 1,
                isList: true
            }) : null
        ]
    });
};
var $09b339e39f2fe811$export$2e2bcd8739ae039 = $09b339e39f2fe811$var$DisputeInfoList;


const $59b5241b7985f8c2$var$getPeriodPhrase = (period)=>{
    switch(period){
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).evidence:
            return "Voting Starts";
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal:
            return "Appeal Deadline";
        case (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).execution:
            return "Final Decision";
        default:
            return "Voting Deadline";
    }
};
const $59b5241b7985f8c2$var$DisputeInfo = ({ disputeID: disputeID, courtId: courtId, court: court, category: category, rewards: rewards, period: period, date: date, round: round, overrideIsList: overrideIsList, isOverview: isOverview, showLabels: showLabels = false })=>{
    const { isList: isList } = (0, $b73946e052a4abb0$export$efcb02388d4a2108)();
    const { isDisconnected: isDisconnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const displayAsList = isList && !overrideIsList;
    const fieldItems = (0, $dup7A.useMemo)(()=>[
            {
                icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039),
                name: "Court",
                value: court,
                link: `/courts/${courtId}`,
                display: !(0, $2d857633ba67aa25$export$fce6876652108ab)(court) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(courtId) && !isOverview
            },
            {
                icon: (0, $e034388069ade300$export$2e2bcd8739ae039),
                name: "Round",
                value: round?.toString(),
                display: !(0, $2d857633ba67aa25$export$fce6876652108ab)(round)
            },
            {
                icon: (0, $d15fda946aef10b5$export$2e2bcd8739ae039),
                name: "Category",
                value: category ?? "General",
                display: true,
                style: "justify-self: end;"
            },
            {
                icon: (0, $5bfc193d5c8f814b$export$2e2bcd8739ae039),
                name: "Juror Rewards",
                value: rewards,
                display: !(0, $2d857633ba67aa25$export$fce6876652108ab)(rewards)
            },
            {
                icon: (0, $a1a18341232cf359$export$2e2bcd8739ae039),
                name: $59b5241b7985f8c2$var$getPeriodPhrase(period ?? 0),
                value: !displayAsList ? new Date(date * 1000).toLocaleString() : (0, $fee5256da5a38783$export$3ae94a2503e890a1)(date),
                display: !(0, $2d857633ba67aa25$export$fce6876652108ab)(period) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(date),
                style: "grid-column: 2 / 4;"
            }
        ], [
        category,
        court,
        courtId,
        date,
        displayAsList,
        isOverview,
        period,
        rewards,
        round
    ]);
    return displayAsList ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $09b339e39f2fe811$export$2e2bcd8739ae039), {
        showLabels: showLabels && !isDisconnected,
        disputeID: disputeID,
        round: round,
        fieldItems: fieldItems
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33869189c3ebf233$export$2e2bcd8739ae039), {
        showLabels: showLabels && !isDisconnected,
        disputeID: disputeID,
        round: round,
        fieldItems: fieldItems,
        court: court,
        courtId: courtId,
        isOverview: isOverview
    });
};
var $59b5241b7985f8c2$export$2e2bcd8739ae039 = $59b5241b7985f8c2$var$DisputeInfo;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $afb6bc5126ee75e4$var$SvgCheckCircleOutline = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('0408ced3003166f4')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#00C42B"
            })
        })
    });
var $afb6bc5126ee75e4$export$2e2bcd8739ae039 = $afb6bc5126ee75e4$var$SvgCheckCircleOutline;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $75625c1bb0e5163a$var$SvgCloseCircle = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z",
            fill: "#9013FE"
        })
    });
var $75625c1bb0e5163a$export$2e2bcd8739ae039 = $75625c1bb0e5163a$var$SvgCloseCircle;






const $de2bfa00360f89e4$export$f1796ea5e596b055 = (vote, answers)=>{
    const selectedAnswer = answers?.[vote - 1]?.title;
    if (vote === 0) return "Refuse to arbitrate";
    else if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(selectedAnswer)) return selectedAnswer;
    else return `Answer 0x${vote}`;
};





const $9b022e1544ef99cd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  position: relative;
  margin-left: 8px;
  flex-direction: column;
`;
const $9b022e1544ef99cd$var$StyledTimeline = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.CustomTimeline))`
  width: 100%;
`;
const $9b022e1544ef99cd$var$EnforcementContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 24)};
  fill: ${({ theme: theme })=>theme.secondaryText};

  small {
    font-weight: 400;
    line-height: 19px;
    color: ${({ theme: theme })=>theme.secondaryText};
  }
`;
const $9b022e1544ef99cd$var$StyledCalendarIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $a1a18341232cf359$export$2e2bcd8739ae039))`
  width: 14px;
  height: 14px;
`;
const $9b022e1544ef99cd$var$formatDate = (date)=>{
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    const startingDate = new Date(parseInt(date) * 1000);
    const formattedDate = startingDate.toLocaleDateString("en-US", options);
    return formattedDate;
};
const $9b022e1544ef99cd$var$useItems = (disputeDetails, arbitrable)=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: votingHistory } = (0, $2110a062d830c408$export$2d10fa524a206015)(id);
    const { data: disputeData } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const localRounds = (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(votingHistory?.dispute?.disputeKitDispute);
    const rounds = votingHistory?.dispute?.rounds;
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    return (0, $dup7A.useMemo)(()=>{
        const dispute = disputeDetails?.dispute;
        if (dispute) {
            const rulingOverride = dispute.overridden;
            const parsedDisputeFinalRuling = parseInt(dispute.currentRuling);
            const currentPeriodIndex = (0, $2b4339c8418e3b6b$export$2be98a1249103ab1)[dispute.period];
            return localRounds?.reduce((acc, { winningChoice: winningChoice }, index)=>{
                const parsedRoundChoice = parseInt(winningChoice);
                const isOngoing = index === localRounds.length - 1 && currentPeriodIndex < 3;
                const roundTimeline = rounds?.[index].timeline;
                const icon = dispute.ruled && !rulingOverride && index === localRounds.length - 1 ? (0, $afb6bc5126ee75e4$export$2e2bcd8739ae039) : "";
                const answers = disputeData?.answers;
                acc.push({
                    title: `Jury Decision - Round ${index + 1}`,
                    party: isOngoing ? "Voting is ongoing" : (0, $de2bfa00360f89e4$export$f1796ea5e596b055)(parsedRoundChoice, answers),
                    subtitle: isOngoing ? "" : `${$9b022e1544ef99cd$var$formatDate(roundTimeline?.[(0, $2b4339c8418e3b6b$export$2be98a1249103ab1).vote])} / ${votingHistory?.dispute?.rounds.at(index)?.court.name}`,
                    rightSided: true,
                    variant: theme.secondaryPurple,
                    Icon: icon !== "" ? icon : undefined
                });
                if (index < localRounds.length - 1) acc.push({
                    title: "Appealed",
                    party: "",
                    subtitle: $9b022e1544ef99cd$var$formatDate(roundTimeline?.[(0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal]),
                    rightSided: true,
                    Icon: (0, $75625c1bb0e5163a$export$2e2bcd8739ae039)
                });
                else if (rulingOverride && parsedDisputeFinalRuling !== parsedRoundChoice) acc.push({
                    title: "Won by Appeal",
                    party: (0, $de2bfa00360f89e4$export$f1796ea5e596b055)(parsedDisputeFinalRuling, answers),
                    subtitle: $9b022e1544ef99cd$var$formatDate(roundTimeline?.[(0, $2b4339c8418e3b6b$export$2be98a1249103ab1).appeal]),
                    rightSided: true,
                    Icon: (0, $afb6bc5126ee75e4$export$2e2bcd8739ae039)
                });
                return acc;
            }, [
                {
                    title: "Dispute created",
                    party: "",
                    subtitle: $9b022e1544ef99cd$var$formatDate(votingHistory?.dispute?.createdAt),
                    rightSided: true,
                    variant: theme.secondaryPurple
                }
            ]);
        }
        return;
    }, [
        disputeDetails,
        disputeData,
        localRounds,
        theme
    ]);
};
const $9b022e1544ef99cd$var$DisputeTimeline = ({ arbitrable: arbitrable })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: disputeDetails } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const items = $9b022e1544ef99cd$var$useItems(disputeDetails, arbitrable);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($9b022e1544ef99cd$var$Container, {
        children: [
            items && /*#__PURE__*/ (0, $cZGFG.jsx)($9b022e1544ef99cd$var$StyledTimeline, {
                items: items
            }),
            disputeDetails?.dispute?.ruled && items && /*#__PURE__*/ (0, $cZGFG.jsxs)($9b022e1544ef99cd$var$EnforcementContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($9b022e1544ef99cd$var$StyledCalendarIcon, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("small", {
                        children: [
                            "Enforcement: ",
                            items.at(-1)?.subtitle
                        ]
                    })
                ]
            })
        ]
    });
};
var $9b022e1544ef99cd$export$2e2bcd8739ae039 = $9b022e1544ef99cd$var$DisputeTimeline;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $5946df7c7bff186d$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('d2ffbd392142f833')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m6.516 1.803.792-.784a.86.86 0 0 1 1.211 0l6.942 6.863a.838.838 0 0 1 0 1.197L8.52 15.946a.86.86 0 0 1-1.21 0l-.793-.784a.842.842 0 0 1 .014-1.212l4.303-4.055H.57a.85.85 0 0 1-.857-.848v-1.13a.85.85 0 0 1 .857-.848h10.263L6.53 3.014a.836.836 0 0 1-.014-1.211Z",
                fill: "#009AFF"
            })
        })
    });
var $5946df7c7bff186d$export$2e2bcd8739ae039 = $5946df7c7bff186d$var$SvgArrow;












var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $d063156e80df88c5$var$AnswerTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h3`
  margin: 0;
`;
const $d063156e80df88c5$var$AnswerDisplay = ({ answer: answer, currentRuling: currentRuling })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: answer ? /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)($d063156e80df88c5$var$AnswerTitle, {
                    children: answer.title
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                    children: answer.description
                })
            ]
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
            children: currentRuling !== 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)("h3", {
                children: [
                    "Answer 0x",
                    currentRuling
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
                children: "Refuse to Arbitrate"
            })
        })
    });
};
var $d063156e80df88c5$export$2e2bcd8739ae039 = $d063156e80df88c5$var$AnswerDisplay;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $d5e36fd674e87599$var$BannerContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 24)};
  svg {
    width: 16px;
    height: 16px;
  }
`;
const $d5e36fd674e87599$var$VerdictTag = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  font-weight: 400;
  line-height: 19px;
  color: ${({ theme: theme, ruled: ruled })=>ruled ? theme.success : theme.primaryText};
`;
const $d5e36fd674e87599$var$StyledHourglassIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $baa851a3e705497f$export$2e2bcd8739ae039))`
  fill: ${({ theme: theme })=>theme.primaryText};
`;
const $d5e36fd674e87599$var$VerdictIcon = ({ ruled: ruled })=>{
    return ruled ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $afb6bc5126ee75e4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)($d5e36fd674e87599$var$StyledHourglassIcon, {});
};
const $d5e36fd674e87599$var$VerdictText = ({ ruled: ruled })=>{
    return ruled ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: "Case closed"
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: "Case ongoing"
    });
};
const $d5e36fd674e87599$var$VerdictBanner = ({ ruled: ruled })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($d5e36fd674e87599$var$BannerContainer, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($d5e36fd674e87599$var$VerdictIcon, {
                ruled: ruled
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($d5e36fd674e87599$var$VerdictTag, {
                ruled: ruled,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($d5e36fd674e87599$var$VerdictText, {
                    ruled: ruled
                })
            })
        ]
    });
};
var $d5e36fd674e87599$export$2e2bcd8739ae039 = $d5e36fd674e87599$var$VerdictBanner;


const $d4e4b66cd07485a8$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $d4e4b66cd07485a8$var$JuryContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  h3 {
    line-height: 21px;
    margin-bottom: 0px;
  }
`;
const $d4e4b66cd07485a8$var$JuryDecisionTag = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  font-weight: 400;
  line-height: 19px;
  color: ${({ theme: theme })=>theme.secondaryText};
`;
const $d4e4b66cd07485a8$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d86601acd95afa87$export$2e2bcd8739ae039))`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  > .button-text {
    color: ${({ theme: theme })=>theme.primaryBlue};
  }
  padding-top: 0px;
`;
const $d4e4b66cd07485a8$var$Divider = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).hr`
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)} 0px;
`;
const $d4e4b66cd07485a8$var$FinalDecision = ({ arbitrable: arbitrable })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { isDisconnected: isDisconnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: populatedDisputeData } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const { data: disputeDetails } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { wasDrawn: wasDrawn, hasVoted: hasVoted, isLoading: isLoading, isCommitPeriod: isCommitPeriod, isVotingPeriod: isVotingPeriod, commited: commited, isHiddenVotes: isHiddenVotes } = (0, $bb547b3a0533538e$export$332cfb3c10dd1fd7)();
    const { data: votingHistory } = (0, $2110a062d830c408$export$2d10fa524a206015)(id);
    const localRounds = (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(votingHistory?.dispute?.disputeKitDispute);
    const ruled = disputeDetails?.dispute?.ruled ?? false;
    const periodIndex = (0, $2b4339c8418e3b6b$export$2be98a1249103ab1)[disputeDetails?.dispute?.period ?? "evidence"];
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { data: currentRulingArray } = (0, $f9a008fec395d7ff$export$85e714ff5a370b37)({
        args: [
            BigInt(id ?? 0)
        ],
        watch: true
    });
    const currentRuling = Number(currentRulingArray?.[0]);
    const answer = populatedDisputeData?.answers?.[currentRuling - 1];
    const buttonText = (0, $dup7A.useMemo)(()=>{
        if (!wasDrawn || isDisconnected) return "Check how the jury voted";
        if (isCommitPeriod && !commited) return "Commit your vote";
        if (isVotingPeriod && isHiddenVotes && commited && !hasVoted) return "Reveal your vote";
        if (isVotingPeriod && !isHiddenVotes && !hasVoted) return "Cast your vote";
        return "Check how the jury voted";
    }, [
        wasDrawn,
        hasVoted,
        isCommitPeriod,
        isVotingPeriod,
        commited,
        isHiddenVotes
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($d4e4b66cd07485a8$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d5e36fd674e87599$export$2e2bcd8739ae039), {
                ruled: ruled
            }),
            ruled && /*#__PURE__*/ (0, $cZGFG.jsxs)($d4e4b66cd07485a8$var$JuryContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($d4e4b66cd07485a8$var$JuryDecisionTag, {
                        children: "The jury decided in favor of:"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d063156e80df88c5$export$2e2bcd8739ae039), {
                        answer: answer,
                        currentRuling: currentRuling
                    })
                ]
            }),
            !ruled && periodIndex > 1 && localRounds?.at(localRounds.length - 1)?.totalVoted > 0 && /*#__PURE__*/ (0, $cZGFG.jsxs)($d4e4b66cd07485a8$var$JuryContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($d4e4b66cd07485a8$var$JuryDecisionTag, {
                        children: "This option is winning:"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d063156e80df88c5$export$2e2bcd8739ae039), {
                        answer: answer,
                        currentRuling: currentRuling
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($d4e4b66cd07485a8$var$Divider, {}),
            isLoading && !isDisconnected ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                width: 250,
                height: 20
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)($d4e4b66cd07485a8$var$StyledButton, {
                onClick: ()=>navigate(`/cases/${id?.toString()}/voting`),
                text: buttonText,
                Icon: (0, $5946df7c7bff186d$export$2e2bcd8739ae039),
                className: "reverse-button"
            })
        ]
    });
};
var $d4e4b66cd07485a8$export$2e2bcd8739ae039 = $d4e4b66cd07485a8$var$FinalDecision;


const $f8c27559b56fa773$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;
const $f8c27559b56fa773$var$Verdict = ({ arbitrable: arbitrable })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($f8c27559b56fa773$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d4e4b66cd07485a8$export$2e2bcd8739ae039), {
                arbitrable: arbitrable
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9b022e1544ef99cd$export$2e2bcd8739ae039), {
                arbitrable: arbitrable
            })
        ]
    });
};
var $f8c27559b56fa773$export$2e2bcd8739ae039 = $f8c27559b56fa773$var$Verdict;


const $2c0a6b27618dbd0e$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $2c0a6b27618dbd0e$var$Divider = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).hr`
  width: 100%;
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: 0;
`;
const $2c0a6b27618dbd0e$var$Overview = ({ arbitrable: arbitrable, courtID: courtID, currentPeriodIndex: currentPeriodIndex })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: disputeDetails, isError: isError } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const { data: dispute } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { data: courtPolicy } = (0, $3043cbfb1ed10cf4$export$e0985f714b0d92d6)(courtID);
    const { data: votingHistory } = (0, $2110a062d830c408$export$2d10fa524a206015)(id);
    const localRounds = (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(votingHistory?.dispute?.disputeKitDispute);
    const courtName = courtPolicy?.name;
    const court = dispute?.dispute?.court;
    const rewards = (0, $dup7A.useMemo)(()=>court ? `\u{2265} ${(0, $3Szoa.formatEther)(court.feeForJuror)} ETH` : undefined, [
        court
    ]);
    const category = disputeDetails?.category;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($2c0a6b27618dbd0e$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $829f76996267db48$export$e7a634c764273922), {
                        disputeDetails: disputeDetails,
                        isRpcError: isError
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($2c0a6b27618dbd0e$var$Divider, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f8c27559b56fa773$export$2e2bcd8739ae039), {
                        arbitrable: arbitrable
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($2c0a6b27618dbd0e$var$Divider, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $59b5241b7985f8c2$export$2e2bcd8739ae039), {
                        isOverview: true,
                        overrideIsList: true,
                        courtId: court?.id,
                        court: courtName,
                        round: localRounds?.length,
                        rewards: rewards,
                        category: category
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $80e9b305c1fae669$export$e9859ad90648930b), {
                disputePolicyURI: disputeDetails?.policyURI,
                courtId: courtID,
                attachment: disputeDetails?.attachment
            })
        ]
    });
};
var $2c0a6b27618dbd0e$export$2e2bcd8739ae039 = $2c0a6b27618dbd0e$var$Overview;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $956987ff9f736a18$var$SvgBullhorn = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M16 7.618c0-.652-.36-1.215-.889-1.52V1.883c0-.242-.194-.883-.889-.883a.891.891 0 0 0-.555.194l-2.362 1.875a6.774 6.774 0 0 1-4.194 1.46H1.778C.796 4.53 0 5.32 0 6.294v2.647c0 .975.796 1.765 1.778 1.765h.936c-.039.289-.06.583-.06.882 0 1.097.257 2.133.71 3.06.143.294.458.47.788.47h2.064c.723 0 1.158-.823.719-1.395a3.495 3.495 0 0 1-.726-2.135c0-.306.045-.6.122-.882h.78c1.518 0 3.008.519 4.194 1.46l2.362 1.876a.894.894 0 0 0 .555.193c.692 0 .889-.628.889-.882V9.138c.53-.306.889-.869.889-1.52Zm-2.667 3.9-.918-.73a8.562 8.562 0 0 0-5.304-1.847V6.294c1.92 0 3.804-.656 5.304-1.847l.918-.729v7.8Z"
        })
    });
var $956987ff9f736a18$export$2e2bcd8739ae039 = $956987ff9f736a18$var$SvgBullhorn;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $28087fb399ad998a$var$SvgDoc = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M11.23 7.75v.875a.381.381 0 0 1-.384.375H5.462a.381.381 0 0 1-.385-.375V7.75c0-.206.173-.375.385-.375h5.384c.212 0 .385.169.385.375ZM10.847 10H5.462a.381.381 0 0 0-.385.375v.875c0 .206.173.375.385.375h5.384a.381.381 0 0 0 .385-.375v-.875a.381.381 0 0 0-.385-.375Zm3.462-5.878V14.5c0 .828-.69 1.5-1.539 1.5H3.54C2.688 16 2 15.328 2 14.5v-13C2 .672 2.69 0 3.538 0h6.542c.407 0 .798.16 1.087.44l2.689 2.623c.288.278.452.662.452 1.059Zm-4.103-2.5V4h2.44l-2.44-2.378ZM12.77 14.5v-9H9.436a.758.758 0 0 1-.77-.75V1.5H3.539v13h9.231Z"
        })
    });
var $28087fb399ad998a$export$2e2bcd8739ae039 = $28087fb399ad998a$var$SvgDoc;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $5443c9a9127b99fe$var$SvgEye = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('69284aa76652bd81')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M8 5.05a3.047 3.047 0 0 0-.868.141 1.573 1.573 0 0 1 .082 1.363 1.576 1.576 0 0 1-.841.852c-.19.079-.391.12-.596.12a1.524 1.524 0 0 1-.75-.204 3.18 3.18 0 0 0 .06 1.93c.22.62.627 1.156 1.163 1.53a3.076 3.076 0 0 0 3.628-.082c.52-.397.903-.95 1.096-1.58a3.18 3.18 0 0 0-.024-1.93 3.14 3.14 0 0 0-1.134-1.552 3.077 3.077 0 0 0-1.817-.587Zm7.903 2.74C14.396 4.814 11.414 2.8 7.999 2.8 4.585 2.8 1.603 4.817.097 7.79a.92.92 0 0 0 0 .821c1.507 2.976 4.489 4.99 7.904 4.99 3.414 0 6.397-2.015 7.903-4.99a.918.918 0 0 0 0-.82Zm-7.904 4.46c-2.74 0-5.252-1.546-6.609-4.05C2.747 5.699 5.26 4.15 8 4.15c2.74 0 5.252 1.548 6.609 4.05-1.357 2.504-3.869 4.05-6.61 4.05Z"
            })
        })
    });
var $5443c9a9127b99fe$export$2e2bcd8739ae039 = $5443c9a9127b99fe$var$SvgEye;








var $3Szoa = parcelRequire("3Szoa");

const $97c06093476515ae$export$8997e67ad6c0001c = (appealCost)=>{
    if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(appealCost) && Number((0, $3Szoa.formatEther)(appealCost)) > Number.MAX_SAFE_INTEGER) return true;
    return false;
};



const $0f706ac1dac5bf9d$var$StyledTabs = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Tabs))`
  width: 100%;
  > * {
    display: flex;
    flex-wrap: wrap;
    > svg {
      margin-right: 8px !important;
    }
  }
`;
const $0f706ac1dac5bf9d$var$TABS = [
    {
        text: "Overview",
        value: 0,
        Icon: (0, $5443c9a9127b99fe$export$2e2bcd8739ae039),
        path: "overview"
    },
    {
        text: "Evidence",
        value: 1,
        Icon: (0, $28087fb399ad998a$export$2e2bcd8739ae039),
        path: "evidence"
    },
    {
        text: "Voting",
        value: 2,
        Icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039),
        path: "voting"
    },
    {
        text: "Appeal",
        value: 3,
        Icon: (0, $956987ff9f736a18$export$2e2bcd8739ae039),
        path: "appeal",
        disabled: false
    }
];
const $0f706ac1dac5bf9d$var$Tabs = ()=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { data: votingHistory } = (0, $2110a062d830c408$export$2d10fa524a206015)(id);
    const { data: appealCost } = (0, $b6510298c52fe164$export$7188bdcf89640f6b)(id);
    const rounds = votingHistory?.dispute?.rounds ?? [
        1
    ];
    const dispute = data?.dispute;
    const currentPeriodIndex = (0, $2b4339c8418e3b6b$export$2be98a1249103ab1)[dispute?.period ?? 0];
    const currentPathName = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)().pathname.split("/").at(-1);
    const [currentTab, setCurrentTab] = (0, $dup7A.useState)($0f706ac1dac5bf9d$var$TABS.findIndex(({ path: path })=>path === currentPathName));
    (0, $dup7A.useEffect)(()=>{
        setCurrentTab($0f706ac1dac5bf9d$var$TABS.findIndex(({ path: path })=>path === currentPathName));
    }, [
        currentPathName
    ]);
    const tabs = (0, $dup7A.useMemo)(()=>{
        const updatedTabs = [
            ...$0f706ac1dac5bf9d$var$TABS
        ];
        updatedTabs[3].disabled = parseInt(currentPeriodIndex) < 3 && rounds.length === 1 || !(0, $2d857633ba67aa25$export$fce6876652108ab)(appealCost) && (0, $97c06093476515ae$export$8997e67ad6c0001c)(appealCost) && parseInt(currentPeriodIndex) === 3;
        return updatedTabs;
    }, [
        currentPeriodIndex,
        id,
        rounds.length,
        appealCost
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($0f706ac1dac5bf9d$var$StyledTabs, {
        currentValue: currentTab,
        items: tabs,
        callback: (n)=>{
            setCurrentTab(n);
            navigate($0f706ac1dac5bf9d$var$TABS[n].path);
        }
    });
};
var $0f706ac1dac5bf9d$export$2e2bcd8739ae039 = $0f706ac1dac5bf9d$var$Tabs;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $3e578f76c4f92bae$var$useEffectOnce = function(effect) {
    (0, $dup7A.useEffect)(effect, []);
};
var $3e578f76c4f92bae$export$2e2bcd8739ae039 = $3e578f76c4f92bae$var$useEffectOnce;


var $853a6cd1d208d03b$var$useUnmount = function(fn) {
    var fnRef = (0, $dup7A.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $3e578f76c4f92bae$export$2e2bcd8739ae039)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $853a6cd1d208d03b$export$2e2bcd8739ae039 = $853a6cd1d208d03b$var$useUnmount;


var $07adecbf47faf50d$var$useRafState = function(initialState) {
    var frame = (0, $dup7A.useRef)(0);
    var _a = (0, $dup7A.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $dup7A.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $853a6cd1d208d03b$export$2e2bcd8739ae039)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $07adecbf47faf50d$export$2e2bcd8739ae039 = $07adecbf47faf50d$var$useRafState;



var $d470e35ba62548b0$var$useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, $07adecbf47faf50d$export$2e2bcd8739ae039)({
        width: (0, $226407d615d776bb$export$4e09c449d6c407f7) ? window.innerWidth : initialWidth,
        height: (0, $226407d615d776bb$export$4e09c449d6c407f7) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, $dup7A.useEffect)(function() {
        if (0, $226407d615d776bb$export$4e09c449d6c407f7) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            (0, $226407d615d776bb$export$af631764ddc44097)(window, "resize", handler_1);
            return function() {
                (0, $226407d615d776bb$export$8c8705df4a2dcec9)(window, "resize", handler_1);
            };
        }
    }, []);
    return state;
};
var $d470e35ba62548b0$export$2e2bcd8739ae039 = $d470e35ba62548b0$var$useWindowSize;



const $a7773fb8c912d2f6$var$useIsDesktop = ()=>{
    const { width: width } = (0, $d470e35ba62548b0$export$2e2bcd8739ae039)();
    return (0, $dup7A.useMemo)(()=>width > (0, $1a81a644a2506b99$export$4cf8c0e020b1f8b2), [
        width
    ]);
};
var $a7773fb8c912d2f6$export$2e2bcd8739ae039 = $a7773fb8c912d2f6$var$useIsDesktop;






const $50b7f9ece81e5362$var$TimeLineContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Box))`
  display: block;
  width: 100%;
  height: 98px;
  border-radius: 0px;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)} 8px 0px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 22)};
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 22)};
  background-color: ${({ theme: theme })=>theme.whiteBackground};

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: block;
      padding: 28px 8px 8px 8px;
    `)}
`;
const $50b7f9ece81e5362$var$StyledSteps = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Steps))`
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: auto;
`;
const $50b7f9ece81e5362$var$Timeline = ({ currentPeriodIndex: currentPeriodIndex, dispute: dispute })=>{
    const currentItemIndex = $50b7f9ece81e5362$var$currentPeriodToCurrentItem(currentPeriodIndex, dispute?.court.hiddenVotes);
    const items = $50b7f9ece81e5362$var$useTimeline(dispute, currentItemIndex, currentItemIndex);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($50b7f9ece81e5362$var$TimeLineContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($50b7f9ece81e5362$var$StyledSteps, {
            horizontal: true,
            items: items,
            currentItemIndex: currentItemIndex,
            currentPeriodIndex: currentPeriodIndex
        })
    });
};
const $50b7f9ece81e5362$var$currentPeriodToCurrentItem = (currentPeriodIndex, hiddenVotes)=>{
    if (hiddenVotes) return currentPeriodIndex;
    if (currentPeriodIndex <= (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).commit) return currentPeriodIndex;
    else return currentPeriodIndex - 1;
};
const $50b7f9ece81e5362$var$useTimeline = (dispute, currentItemIndex, currentPeriodIndex)=>{
    const isDesktop = (0, $a7773fb8c912d2f6$export$2e2bcd8739ae039)();
    const titles = (0, $dup7A.useMemo)(()=>{
        const titles = [
            "Evidence",
            "Voting",
            "Appeal",
            "Executed"
        ];
        if (dispute?.court.hiddenVotes) titles.splice(1, 0, "Commit");
        return titles;
    }, [
        dispute
    ]);
    const deadlineCurrentPeriod = $50b7f9ece81e5362$var$getDeadline(currentPeriodIndex, dispute?.lastPeriodChange, dispute?.court.timesPerPeriod);
    const countdown = (0, $dde99d611beb8e78$export$8103f7eb37e19f7b)(deadlineCurrentPeriod);
    const getSubitems = (index)=>{
        if (typeof countdown !== "undefined" && dispute) {
            if (index === titles.length - 1) return [];
            else if (index === currentItemIndex && countdown === 0) return [
                "Time's up!"
            ];
            else if (index < currentItemIndex) return [];
            else if (index === currentItemIndex) return [
                (0, $fee5256da5a38783$export$727166c461d46c36)(countdown)
            ];
            else return [
                (0, $fee5256da5a38783$export$727166c461d46c36)(dispute?.court.timesPerPeriod[index])
            ];
        }
        return [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                width: 60
            }, index)
        ];
    };
    return titles.map((title, i)=>({
            title: i + 1 < titles.length && isDesktop ? `${title} Period` : title,
            subitems: getSubitems(i)
        }));
};
const $50b7f9ece81e5362$var$getDeadline = (currentPeriodIndex, lastPeriodChange, timesPerPeriod)=>{
    if (lastPeriodChange && timesPerPeriod && currentPeriodIndex < timesPerPeriod.length) {
        const parsedLastPeriodChange = parseInt(lastPeriodChange, 10);
        const parsedTimeCurrentPeriod = parseInt(timesPerPeriod[currentPeriodIndex]);
        return parsedLastPeriodChange + parsedTimeCurrentPeriod;
    }
    return 0;
};
var $50b7f9ece81e5362$export$2e2bcd8739ae039 = $50b7f9ece81e5362$var$Timeline;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $f80a17c1f1727e89$var$SvgVoted = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 350 350",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M326.109 87.5 174.554 0 23 87.5v175L174.554 350l151.555-87.5v-175Zm-18.468 10.473L174.435 21.066 41.228 97.973v153.813l133.207 76.907 133.206-76.907V97.973Z",
                fill: "#F0F9FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m174.435 21.066 133.206 76.907v153.813l-133.206 76.907-133.207-76.907V97.973l133.207-76.907Z",
                fill: "#7E1BD4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m290.662 261.589-116.227 67.104-115.989-66.966v-47.706h232.216v47.568Z",
                fill: "#973AE8"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M89.207 82.832H260.38a3.47 3.47 0 0 1 3.47 3.47v.002a3.47 3.47 0 0 1-3.47 3.47H89.207a3.47 3.47 0 0 1-3.47-3.47v-.002a3.47 3.47 0 0 1 3.47-3.47ZM89.207 105.335H260.38a3.47 3.47 0 0 1 3.47 3.471v.002a3.47 3.47 0 0 1-3.47 3.47H89.207a3.47 3.47 0 0 1-3.47-3.47v-.002a3.47 3.47 0 0 1 3.47-3.471ZM260.379 127.839H89.207a3.47 3.47 0 0 0-3.47 3.47v.002a3.47 3.47 0 0 0 3.47 3.47H260.38a3.47 3.47 0 0 0 3.47-3.47v-.002a3.47 3.47 0 0 0-3.47-3.47ZM89.207 150.342H260.38a3.47 3.47 0 0 1 3.47 3.47v.003a3.47 3.47 0 0 1-3.47 3.47H89.207a3.47 3.47 0 0 1-3.47-3.47v-.003a3.47 3.47 0 0 1 3.47-3.47ZM260.379 172.846H89.207a3.47 3.47 0 0 0-3.47 3.47v.002a3.47 3.47 0 0 0 3.47 3.47H260.38a3.47 3.47 0 0 0 3.47-3.47v-.002a3.47 3.47 0 0 0-3.47-3.47ZM89.207 195.349H260.38a3.47 3.47 0 0 1 3.47 3.47v.003a3.47 3.47 0 0 1-3.47 3.47H89.207a3.47 3.47 0 0 1-3.47-3.47v-.003a3.47 3.47 0 0 1 3.47-3.47Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m131.092 236.614 5.988 15.004 6.072-15.004h3.575l-9.717 23.277-9.493-23.277h3.575Zm16.294 10.727c0-3.048 1.118-5.665 3.352-7.853 2.225-2.187 4.898-3.281 8.021-3.281 3.085 0 5.73 1.103 7.936 3.309 2.216 2.207 3.324 4.857 3.324 7.951 0 3.113-1.113 5.754-3.338 7.923-2.234 2.178-4.931 3.267-8.091 3.267-2.795 0-5.305-.968-7.53-2.903-2.449-2.14-3.674-4.945-3.674-8.413Zm3.296.042c0 2.393.804 4.361 2.412 5.903 1.598 1.543 3.444 2.314 5.538 2.314 2.272 0 4.188-.785 5.75-2.356 1.561-1.589 2.341-3.524 2.341-5.805 0-2.309-.771-4.244-2.313-5.805-1.534-1.571-3.431-2.356-5.693-2.356-2.253 0-4.156.785-5.708 2.356-1.551 1.552-2.327 3.468-2.327 5.749Zm28.648-7.698v18.579h-3.268v-18.579h-4.978v-3.071h13.209v3.071h-4.963Zm19.827 0h-8.68v5.202h8.428v3.071h-8.428v7.235h8.68v3.071H187.21v-21.65h11.947v3.071Zm4.291 18.579v-21.65h4.543c2.179 0 3.899.215 5.161.645 1.355.42 2.584 1.136 3.688 2.145 2.234 2.038 3.351 4.716 3.351 8.035 0 3.328-1.164 6.02-3.492 8.077-1.168 1.028-2.393 1.743-3.674 2.145-1.196.402-2.893.603-5.09.603h-4.487Zm3.267-3.071h1.473c1.467 0 2.687-.154 3.66-.462a7.441 7.441 0 0 0 2.636-1.557c1.608-1.468 2.412-3.379 2.412-5.735 0-2.374-.795-4.3-2.384-5.777-1.431-1.318-3.539-1.977-6.324-1.977h-1.473v15.508ZM184.273 95.437c0 4.437-1.001 6.99-2.621 8.435l44.784 13.364a6.976 6.976 0 0 1 4.573-1.702c3.866 0 7 3.122 7 6.973 0 2.799-1.66 5.206-4.049 6.316l15.673 45.088c4.97.79 8.255 1.956 8.255 3.498 0 6.326-12.387 11.454-27.667 11.454-15.28 0-27.666-5.128-27.666-11.454 0-1.639 3.71-2.853 9.209-3.642l15.726-45.241a6.984 6.984 0 0 1-3.103-3.777c-.528-2.194-1.757-3.58-3.687-4.155-2.306-.689-4.566-.767-7.088-.854-3.188-.109-6.796-.234-11.45-1.622l-22.753-6.79v46.376a6.948 6.948 0 0 1 2.93 5.666c0 1.55-.514 2.978-1.373 4.135 2.311 1.715 3.815 4.449 3.815 7.54 0 3.741-2.198 6.962-5.372 8.477v9.682c10.333.54 18.204 3.325 18.204 6.68 0 .057-.002.114-.006.17 16.678 1.438 28.193 4.499 28.193 8.045l.082 4.946c0 4.925-22.188 8.877-49.607 8.877s-49.606-4.033-49.606-8.959l-.163-4.864c0-3.489 11.151-6.509 27.398-7.975a2.118 2.118 0 0 1-.014-.24c0-3.301 7.619-6.05 17.705-6.652v-9.554c-3.35-1.444-5.696-4.764-5.696-8.632 0-3.091 1.503-5.826 3.814-7.54a6.915 6.915 0 0 1-1.373-4.136 6.955 6.955 0 0 1 3.255-5.884v-48.489l-25.949-7.744c-1.726-.515-4.254-1.883-6.955-3.346-3.098-1.677-6.424-3.478-9.031-4.255-1.806-.54-3.659-.149-5.561 1.171a7.02 7.02 0 0 1-1.186.778l15.639 44.993c5.2.791 8.669 1.978 8.669 3.562 0 6.326-12.387 11.454-27.667 11.454-15.28 0-27.666-5.128-27.666-11.454 0-1.537 3.264-2.7 8.207-3.49l15.777-45.39a6.955 6.955 0 0 1-3.201-5.85c0-3.852 3.134-6.974 6.999-6.974a7 7 0 0 1 6.691 4.922l40.218 12.001c-.22-1.111-.339-2.413-.339-3.938 0-5.941 3.006-12.962 9.017-21.062 6.011 8.1 9.016 15.12 9.016 21.062Zm48.303 33.86 15.425 44.376c-9.733-1.304-24.562-1.344-34.611-.121l15.441-44.423a7.008 7.008 0 0 0 2.179.349c.539 0 1.062-.066 1.566-.181Zm-130.848 11.129 15.463-44.486a7 7 0 0 0 2.479.458c.651 0 1.279-.096 1.876-.261l15.375 44.229c-10.068-1.293-25.286-1.273-35.193.06Z",
                fill: "#fff"
            })
        ]
    });
var $f80a17c1f1727e89$export$2e2bcd8739ae039 = $f80a17c1f1727e89$var$SvgVoted;















var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");






var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $329cO = parcelRequire("329cO");

var $fcphM = parcelRequire("fcphM");

var $gg0RY = parcelRequire("gg0RY");

var $jSK74 = parcelRequire("jSK74");

var $15DC1 = parcelRequire("15DC1");

var $7S6Nv = parcelRequire("7S6Nv");

var $9rq6f = parcelRequire("9rq6f");
function $374503f3fb5f9122$export$92dace262a9f3722(types, values) {
    if (types.length !== values.length) throw new (0, $329cO.AbiEncodingLengthMismatchError)({
        expectedLength: types.length,
        givenLength: values.length
    });
    const data = [];
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const value = values[i];
        data.push($374503f3fb5f9122$var$encode(type, value));
    }
    return (0, $jSK74.concatHex)(data);
}
function $374503f3fb5f9122$var$encode(type, value, isArray = false) {
    if (type === "address") {
        const address = value;
        if (!(0, $gg0RY.isAddress)(address)) throw new (0, $fcphM.InvalidAddressError)({
            address: address
        });
        return (0, $15DC1.pad)(address.toLowerCase(), {
            size: isArray ? 32 : null
        });
    }
    if (type === "string") return (0, $7S6Nv.stringToHex)(value);
    if (type === "bytes") return value;
    if (type === "bool") return (0, $15DC1.pad)((0, $7S6Nv.boolToHex)(value), {
        size: isArray ? 32 : 1
    });
    const intMatch = type.match((0, $9rq6f.integerRegex));
    if (intMatch) {
        const [_type, baseType, bits = "256"] = intMatch;
        const size = parseInt(bits) / 8;
        return (0, $7S6Nv.numberToHex)(value, {
            size: isArray ? 32 : size,
            signed: baseType === "int"
        });
    }
    const bytesMatch = type.match((0, $9rq6f.bytesRegex));
    if (bytesMatch) {
        const [_type, size] = bytesMatch;
        if (parseInt(size) !== (value.length - 2) / 2) throw new (0, $329cO.BytesSizeMismatchError)({
            expectedSize: parseInt(size),
            givenSize: (value.length - 2) / 2
        });
        return (0, $15DC1.pad)(value, {
            dir: "right",
            size: isArray ? 32 : null
        });
    }
    const arrayMatch = type.match((0, $9rq6f.arrayRegex));
    if (arrayMatch && Array.isArray(value)) {
        const [_type, childType] = arrayMatch;
        const data = [];
        for(let i = 0; i < value.length; i++)data.push($374503f3fb5f9122$var$encode(childType, value[i], true));
        if (data.length === 0) return "0x";
        return (0, $jSK74.concatHex)(data);
    }
    throw new (0, $329cO.UnsupportedPackedAbiType)(type);
}


var $9mkfv = parcelRequire("9mkfv");




var $9mkfv = parcelRequire("9mkfv");
var $7bddc611d6926dce$exports = {};
"use strict";
Object.defineProperty($7bddc611d6926dce$exports, "__esModule", {
    value: true
});
$7bddc611d6926dce$exports.encodeToCurve = $7bddc611d6926dce$exports.hashToCurve = $7bddc611d6926dce$exports.schnorr = $7bddc611d6926dce$exports.secp256k1 = void 0;
var $0f6b86097fbea908$exports = {};
"use strict";
Object.defineProperty($0f6b86097fbea908$exports, "__esModule", {
    value: true
});
$0f6b86097fbea908$exports.sha224 = $0f6b86097fbea908$exports.sha256 = void 0;
var $561df128709d1a8c$exports = {};
"use strict";
Object.defineProperty($561df128709d1a8c$exports, "__esModule", {
    value: true
});
$561df128709d1a8c$exports.SHA2 = void 0;
var $7d852d00ae520d88$exports = {};
"use strict";
Object.defineProperty($7d852d00ae520d88$exports, "__esModule", {
    value: true
});
$7d852d00ae520d88$exports.output = $7d852d00ae520d88$exports.exists = $7d852d00ae520d88$exports.hash = $7d852d00ae520d88$exports.bytes = $7d852d00ae520d88$exports.bool = $7d852d00ae520d88$exports.number = void 0;
function $7d852d00ae520d88$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$7d852d00ae520d88$exports.number = $7d852d00ae520d88$var$number;
function $7d852d00ae520d88$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$7d852d00ae520d88$exports.bool = $7d852d00ae520d88$var$bool;
function $7d852d00ae520d88$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$7d852d00ae520d88$exports.bytes = $7d852d00ae520d88$var$bytes;
function $7d852d00ae520d88$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $7d852d00ae520d88$var$number(hash.outputLen);
    $7d852d00ae520d88$var$number(hash.blockLen);
}
$7d852d00ae520d88$exports.hash = $7d852d00ae520d88$var$hash;
function $7d852d00ae520d88$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$7d852d00ae520d88$exports.exists = $7d852d00ae520d88$var$exists;
function $7d852d00ae520d88$var$output(out, instance) {
    $7d852d00ae520d88$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$7d852d00ae520d88$exports.output = $7d852d00ae520d88$var$output;
const $7d852d00ae520d88$var$assert = {
    number: $7d852d00ae520d88$var$number,
    bool: $7d852d00ae520d88$var$bool,
    bytes: $7d852d00ae520d88$var$bytes,
    hash: $7d852d00ae520d88$var$hash,
    exists: $7d852d00ae520d88$var$exists,
    output: $7d852d00ae520d88$var$output
};
$7d852d00ae520d88$exports.default = $7d852d00ae520d88$var$assert;


var $2c08a667590999ce$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($2c08a667590999ce$exports, "__esModule", {
    value: true
});
$2c08a667590999ce$exports.randomBytes = $2c08a667590999ce$exports.wrapXOFConstructorWithOpts = $2c08a667590999ce$exports.wrapConstructorWithOpts = $2c08a667590999ce$exports.wrapConstructor = $2c08a667590999ce$exports.checkOpts = $2c08a667590999ce$exports.Hash = $2c08a667590999ce$exports.concatBytes = $2c08a667590999ce$exports.toBytes = $2c08a667590999ce$exports.utf8ToBytes = $2c08a667590999ce$exports.asyncLoop = $2c08a667590999ce$exports.nextTick = $2c08a667590999ce$exports.hexToBytes = $2c08a667590999ce$exports.bytesToHex = $2c08a667590999ce$exports.isLE = $2c08a667590999ce$exports.rotr = $2c08a667590999ce$exports.createView = $2c08a667590999ce$exports.u32 = $2c08a667590999ce$exports.u8 = void 0;
var $1f48a263a7733211$exports = {};
"use strict";
Object.defineProperty($1f48a263a7733211$exports, "__esModule", {
    value: true
});
$1f48a263a7733211$exports.crypto = void 0;
$1f48a263a7733211$exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $2c08a667590999ce$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $2c08a667590999ce$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$2c08a667590999ce$exports.u8 = $2c08a667590999ce$var$u8;
const $2c08a667590999ce$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$2c08a667590999ce$exports.u32 = $2c08a667590999ce$var$u32;
// Cast array to view
const $2c08a667590999ce$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$2c08a667590999ce$exports.createView = $2c08a667590999ce$var$createView;
// The rotate right (circular right shift) operation for uint32
const $2c08a667590999ce$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$2c08a667590999ce$exports.rotr = $2c08a667590999ce$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
$2c08a667590999ce$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$2c08a667590999ce$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $2c08a667590999ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $2c08a667590999ce$var$bytesToHex(bytes) {
    if (!$2c08a667590999ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $2c08a667590999ce$var$hexes[bytes[i]];
    return hex;
}
$2c08a667590999ce$exports.bytesToHex = $2c08a667590999ce$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $2c08a667590999ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$2c08a667590999ce$exports.hexToBytes = $2c08a667590999ce$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $2c08a667590999ce$var$nextTick = async ()=>{};
$2c08a667590999ce$exports.nextTick = $2c08a667590999ce$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $2c08a667590999ce$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $2c08a667590999ce$exports.nextTick)();
        ts += diff;
    }
}
$2c08a667590999ce$exports.asyncLoop = $2c08a667590999ce$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $2c08a667590999ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$2c08a667590999ce$exports.utf8ToBytes = $2c08a667590999ce$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $2c08a667590999ce$var$toBytes(data) {
    if (typeof data === "string") data = $2c08a667590999ce$var$utf8ToBytes(data);
    if (!$2c08a667590999ce$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
$2c08a667590999ce$exports.toBytes = $2c08a667590999ce$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $2c08a667590999ce$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$2c08a667590999ce$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
$2c08a667590999ce$exports.concatBytes = $2c08a667590999ce$var$concatBytes;
// For runtime check if class implements interface
class $2c08a667590999ce$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$2c08a667590999ce$exports.Hash = $2c08a667590999ce$var$Hash;
const $2c08a667590999ce$var$toStr = {}.toString;
function $2c08a667590999ce$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $2c08a667590999ce$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$2c08a667590999ce$exports.checkOpts = $2c08a667590999ce$var$checkOpts;
function $2c08a667590999ce$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($2c08a667590999ce$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
$2c08a667590999ce$exports.wrapConstructor = $2c08a667590999ce$var$wrapConstructor;
function $2c08a667590999ce$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($2c08a667590999ce$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$2c08a667590999ce$exports.wrapConstructorWithOpts = $2c08a667590999ce$var$wrapConstructorWithOpts;
function $2c08a667590999ce$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($2c08a667590999ce$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$2c08a667590999ce$exports.wrapXOFConstructorWithOpts = $2c08a667590999ce$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $2c08a667590999ce$var$randomBytes(bytesLength = 32) {
    if ($1f48a263a7733211$exports.crypto && typeof $1f48a263a7733211$exports.crypto.getRandomValues === "function") return $1f48a263a7733211$exports.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
$2c08a667590999ce$exports.randomBytes = $2c08a667590999ce$var$randomBytes;


// Polyfill for Safari 14
function $561df128709d1a8c$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $561df128709d1a8c$var$SHA2 extends $2c08a667590999ce$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $2c08a667590999ce$exports.createView)(this.buffer);
    }
    update(data) {
        (0, $7d852d00ae520d88$exports.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $2c08a667590999ce$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $2c08a667590999ce$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $7d852d00ae520d88$exports.exists)(this);
        (0, $7d852d00ae520d88$exports.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $561df128709d1a8c$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $2c08a667590999ce$exports.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$561df128709d1a8c$exports.SHA2 = $561df128709d1a8c$var$SHA2;



// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $0f6b86097fbea908$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $0f6b86097fbea908$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $0f6b86097fbea908$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $0f6b86097fbea908$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $0f6b86097fbea908$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $0f6b86097fbea908$var$SHA256 extends $561df128709d1a8c$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $0f6b86097fbea908$var$IV[0] | 0;
        this.B = $0f6b86097fbea908$var$IV[1] | 0;
        this.C = $0f6b86097fbea908$var$IV[2] | 0;
        this.D = $0f6b86097fbea908$var$IV[3] | 0;
        this.E = $0f6b86097fbea908$var$IV[4] | 0;
        this.F = $0f6b86097fbea908$var$IV[5] | 0;
        this.G = $0f6b86097fbea908$var$IV[6] | 0;
        this.H = $0f6b86097fbea908$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$0f6b86097fbea908$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $0f6b86097fbea908$var$SHA256_W[i - 15];
            const W2 = $0f6b86097fbea908$var$SHA256_W[i - 2];
            const s0 = (0, $2c08a667590999ce$exports.rotr)(W15, 7) ^ (0, $2c08a667590999ce$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $2c08a667590999ce$exports.rotr)(W2, 17) ^ (0, $2c08a667590999ce$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $0f6b86097fbea908$var$SHA256_W[i] = s1 + $0f6b86097fbea908$var$SHA256_W[i - 7] + s0 + $0f6b86097fbea908$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $2c08a667590999ce$exports.rotr)(E, 6) ^ (0, $2c08a667590999ce$exports.rotr)(E, 11) ^ (0, $2c08a667590999ce$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $0f6b86097fbea908$var$Chi(E, F, G) + $0f6b86097fbea908$var$SHA256_K[i] + $0f6b86097fbea908$var$SHA256_W[i] | 0;
            const sigma0 = (0, $2c08a667590999ce$exports.rotr)(A, 2) ^ (0, $2c08a667590999ce$exports.rotr)(A, 13) ^ (0, $2c08a667590999ce$exports.rotr)(A, 22);
            const T2 = sigma0 + $0f6b86097fbea908$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $0f6b86097fbea908$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $0f6b86097fbea908$var$SHA224 extends $0f6b86097fbea908$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $0f6b86097fbea908$exports.sha256 = (0, $2c08a667590999ce$exports.wrapConstructor)(()=>new $0f6b86097fbea908$var$SHA256());
$0f6b86097fbea908$exports.sha224 = (0, $2c08a667590999ce$exports.wrapConstructor)(()=>new $0f6b86097fbea908$var$SHA224());




var $NETJo = parcelRequire("NETJo");
var $f9b999781f43739e$exports = {};
"use strict";
Object.defineProperty($f9b999781f43739e$exports, "__esModule", {
    value: true
});
$f9b999781f43739e$exports.mapToCurveSimpleSWU = $f9b999781f43739e$exports.SWUFpSqrtRatio = $f9b999781f43739e$exports.weierstrass = $f9b999781f43739e$exports.weierstrassPoints = $f9b999781f43739e$exports.DER = void 0;

var $NETJo = parcelRequire("NETJo");

var $hEqBT = parcelRequire("hEqBT");

var $hEqBT = parcelRequire("hEqBT");

var $l5W0K = parcelRequire("l5W0K");
function $f9b999781f43739e$var$validatePointOpts(curve) {
    const opts = (0, $l5W0K.validateBasic)(curve);
    $hEqBT.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $f9b999781f43739e$var$b2n, hexToBytes: $f9b999781f43739e$var$h2b } = $hEqBT;
$f9b999781f43739e$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $f9b999781f43739e$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $f9b999781f43739e$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $f9b999781f43739e$exports.DER;
        const data = typeof hex === "string" ? $f9b999781f43739e$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $f9b999781f43739e$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $f9b999781f43739e$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $f9b999781f43739e$var$_0n = BigInt(0), $f9b999781f43739e$var$_1n = BigInt(1), $f9b999781f43739e$var$_2n = BigInt(2), $f9b999781f43739e$var$_3n = BigInt(3), $f9b999781f43739e$var$_4n = BigInt(4);
function $f9b999781f43739e$var$weierstrassPoints(opts) {
    const CURVE = $f9b999781f43739e$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $hEqBT.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $f9b999781f43739e$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $hEqBT.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $hEqBT.bytesToNumberBE((0, $hEqBT.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $NETJo.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $hEqBT.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $f9b999781f43739e$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $f9b999781f43739e$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $f9b999781f43739e$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $f9b999781f43739e$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $f9b999781f43739e$var$_0n || k2 > $f9b999781f43739e$var$_0n){
                if (k1 & $f9b999781f43739e$var$_1n) k1p = k1p.add(d);
                if (k2 & $f9b999781f43739e$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $f9b999781f43739e$var$_1n;
                k2 >>= $f9b999781f43739e$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $f9b999781f43739e$var$_0n || a === $f9b999781f43739e$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $f9b999781f43739e$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $f9b999781f43739e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $hEqBT.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $l5W0K.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$f9b999781f43739e$exports.weierstrassPoints = $f9b999781f43739e$var$weierstrassPoints;
function $f9b999781f43739e$var$validateOpts(curve) {
    const opts = (0, $l5W0K.validateBasic)(curve);
    $hEqBT.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $f9b999781f43739e$var$weierstrass(curveDef) {
    const CURVE = $f9b999781f43739e$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $f9b999781f43739e$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $NETJo.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $NETJo.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $f9b999781f43739e$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $hEqBT.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $hEqBT.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $f9b999781f43739e$var$_1n) === $f9b999781f43739e$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$hEqBT.bytesToHex($hEqBT.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $f9b999781f43739e$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$hEqBT.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $hEqBT.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $f9b999781f43739e$exports.DER.toSig((0, $hEqBT.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $hEqBT.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $hEqBT.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $f9b999781f43739e$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $hEqBT.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $NETJo.getMinHashLength(CURVE.n);
            return $NETJo.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $hEqBT.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $hEqBT.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($f9b999781f43739e$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $hEqBT.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $hEqBT.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $hEqBT.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $hEqBT.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $hEqBT.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $f9b999781f43739e$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $f9b999781f43739e$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $f9b999781f43739e$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $hEqBT.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $hEqBT.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $hEqBT.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $f9b999781f43739e$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$f9b999781f43739e$exports.weierstrass = $f9b999781f43739e$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $f9b999781f43739e$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $f9b999781f43739e$var$_0n;
    for(let o = q - $f9b999781f43739e$var$_1n; o % $f9b999781f43739e$var$_2n === $f9b999781f43739e$var$_0n; o /= $f9b999781f43739e$var$_2n)l += $f9b999781f43739e$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $f9b999781f43739e$var$_2n << c1 - $f9b999781f43739e$var$_1n - $f9b999781f43739e$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $f9b999781f43739e$var$_2n;
    const c2 = (q - $f9b999781f43739e$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $f9b999781f43739e$var$_1n) / $f9b999781f43739e$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $f9b999781f43739e$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $f9b999781f43739e$var$_1n) / $f9b999781f43739e$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $f9b999781f43739e$var$_1n; i--){
            let tv5 = i - $f9b999781f43739e$var$_2n; // 18.    tv5 = i - 2
            tv5 = $f9b999781f43739e$var$_2n << tv5 - $f9b999781f43739e$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $f9b999781f43739e$var$_4n === $f9b999781f43739e$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $f9b999781f43739e$var$_3n) / $f9b999781f43739e$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$f9b999781f43739e$exports.SWUFpSqrtRatio = $f9b999781f43739e$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $f9b999781f43739e$var$mapToCurveSimpleSWU(Fp, opts) {
    $NETJo.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $f9b999781f43739e$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$f9b999781f43739e$exports.mapToCurveSimpleSWU = $f9b999781f43739e$var$mapToCurveSimpleSWU;



var $hEqBT = parcelRequire("hEqBT");
var $e5fff4a769649725$exports = {};
"use strict";
Object.defineProperty($e5fff4a769649725$exports, "__esModule", {
    value: true
});
$e5fff4a769649725$exports.createHasher = $e5fff4a769649725$exports.isogenyMap = $e5fff4a769649725$exports.hash_to_field = $e5fff4a769649725$exports.expand_message_xof = $e5fff4a769649725$exports.expand_message_xmd = void 0;

var $NETJo = parcelRequire("NETJo");

var $hEqBT = parcelRequire("hEqBT");
function $e5fff4a769649725$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $hEqBT.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $e5fff4a769649725$var$os2ip = $hEqBT.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $e5fff4a769649725$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $e5fff4a769649725$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $e5fff4a769649725$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $e5fff4a769649725$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $e5fff4a769649725$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $e5fff4a769649725$var$isBytes(msg);
    $e5fff4a769649725$var$isBytes(DST);
    $e5fff4a769649725$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $hEqBT.concatBytes)((0, $hEqBT.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $hEqBT.concatBytes)(DST, $e5fff4a769649725$var$i2osp(DST.length, 1));
    const Z_pad = $e5fff4a769649725$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $e5fff4a769649725$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $hEqBT.concatBytes)(Z_pad, msg, l_i_b_str, $e5fff4a769649725$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $hEqBT.concatBytes)(b_0, $e5fff4a769649725$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $e5fff4a769649725$var$strxor(b_0, b[i - 1]),
            $e5fff4a769649725$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $hEqBT.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $hEqBT.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$e5fff4a769649725$exports.expand_message_xmd = $e5fff4a769649725$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $e5fff4a769649725$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $e5fff4a769649725$var$isBytes(msg);
    $e5fff4a769649725$var$isBytes(DST);
    $e5fff4a769649725$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $hEqBT.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($e5fff4a769649725$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($e5fff4a769649725$var$i2osp(DST.length, 1)).digest();
}
$e5fff4a769649725$exports.expand_message_xof = $e5fff4a769649725$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $e5fff4a769649725$var$hash_to_field(msg, count, options) {
    (0, $hEqBT.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $e5fff4a769649725$var$isBytes(msg);
    $e5fff4a769649725$var$isNum(count);
    const DST = $e5fff4a769649725$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $e5fff4a769649725$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $e5fff4a769649725$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $NETJo.mod)($e5fff4a769649725$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$e5fff4a769649725$exports.hash_to_field = $e5fff4a769649725$var$hash_to_field;
function $e5fff4a769649725$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$e5fff4a769649725$exports.isogenyMap = $e5fff4a769649725$var$isogenyMap;
function $e5fff4a769649725$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $e5fff4a769649725$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $e5fff4a769649725$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$e5fff4a769649725$exports.createHasher = $e5fff4a769649725$var$createHasher;


var $c5b7900fcf10f445$exports = {};
"use strict";
Object.defineProperty($c5b7900fcf10f445$exports, "__esModule", {
    value: true
});
$c5b7900fcf10f445$exports.createCurve = $c5b7900fcf10f445$exports.getHash = void 0;
var $f2d66bf659a6230c$exports = {};
"use strict";
Object.defineProperty($f2d66bf659a6230c$exports, "__esModule", {
    value: true
});
$f2d66bf659a6230c$exports.hmac = $f2d66bf659a6230c$exports.HMAC = void 0;


// HMAC (RFC 2104)
class $f2d66bf659a6230c$var$HMAC extends $2c08a667590999ce$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $7d852d00ae520d88$exports.hash)(hash);
        const key = (0, $2c08a667590999ce$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $7d852d00ae520d88$exports.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $7d852d00ae520d88$exports.exists)(this);
        (0, $7d852d00ae520d88$exports.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$f2d66bf659a6230c$exports.HMAC = $f2d66bf659a6230c$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $f2d66bf659a6230c$var$hmac = (hash, key, message)=>new $f2d66bf659a6230c$var$HMAC(hash, key).update(message).digest();
$f2d66bf659a6230c$exports.hmac = $f2d66bf659a6230c$var$hmac;
$f2d66bf659a6230c$exports.hmac.create = (hash, key)=>new $f2d66bf659a6230c$var$HMAC(hash, key);




// connects noble-curves to noble-hashes
function $c5b7900fcf10f445$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $f2d66bf659a6230c$exports.hmac)(hash, key, (0, $2c08a667590999ce$exports.concatBytes)(...msgs)),
        randomBytes: $2c08a667590999ce$exports.randomBytes
    };
}
$c5b7900fcf10f445$exports.getHash = $c5b7900fcf10f445$var$getHash;
function $c5b7900fcf10f445$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $f9b999781f43739e$exports.weierstrass)({
            ...curveDef,
            ...$c5b7900fcf10f445$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$c5b7900fcf10f445$exports.createCurve = $c5b7900fcf10f445$var$createCurve;


const $7bddc611d6926dce$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $7bddc611d6926dce$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $7bddc611d6926dce$var$_1n = BigInt(1);
const $7bddc611d6926dce$var$_2n = BigInt(2);
const $7bddc611d6926dce$var$divNearest = (a, b)=>(a + b / $7bddc611d6926dce$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $7bddc611d6926dce$var$sqrtMod(y) {
    const P = $7bddc611d6926dce$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $NETJo.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $NETJo.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $NETJo.pow2)(b9, $7bddc611d6926dce$var$_2n, P) * b2 % P;
    const b22 = (0, $NETJo.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $NETJo.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $NETJo.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $NETJo.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $NETJo.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $NETJo.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $NETJo.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $NETJo.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $NETJo.pow2)(t2, $7bddc611d6926dce$var$_2n, P);
    if (!$7bddc611d6926dce$var$Fp.eql($7bddc611d6926dce$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $7bddc611d6926dce$var$Fp = (0, $NETJo.Field)($7bddc611d6926dce$var$secp256k1P, undefined, undefined, {
    sqrt: $7bddc611d6926dce$var$sqrtMod
});
$7bddc611d6926dce$exports.secp256k1 = (0, $c5b7900fcf10f445$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $7bddc611d6926dce$var$Fp,
    n: $7bddc611d6926dce$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $7bddc611d6926dce$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$7bddc611d6926dce$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $7bddc611d6926dce$var$divNearest(b2 * k, n);
            const c2 = $7bddc611d6926dce$var$divNearest(-b1 * k, n);
            let k1 = (0, $NETJo.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $NETJo.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $0f6b86097fbea908$exports.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $7bddc611d6926dce$var$_0n = BigInt(0);
const $7bddc611d6926dce$var$fe = (x)=>typeof x === "bigint" && $7bddc611d6926dce$var$_0n < x && x < $7bddc611d6926dce$var$secp256k1P;
const $7bddc611d6926dce$var$ge = (x)=>typeof x === "bigint" && $7bddc611d6926dce$var$_0n < x && x < $7bddc611d6926dce$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $7bddc611d6926dce$var$TAGGED_HASH_PREFIXES = {};
function $7bddc611d6926dce$var$taggedHash(tag, ...messages) {
    let tagP = $7bddc611d6926dce$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $0f6b86097fbea908$exports.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $hEqBT.concatBytes)(tagH, tagH);
        $7bddc611d6926dce$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $0f6b86097fbea908$exports.sha256)((0, $hEqBT.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $7bddc611d6926dce$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $7bddc611d6926dce$var$numTo32b = (n)=>(0, $hEqBT.numberToBytesBE)(n, 32);
const $7bddc611d6926dce$var$modP = (x)=>(0, $NETJo.mod)(x, $7bddc611d6926dce$var$secp256k1P);
const $7bddc611d6926dce$var$modN = (x)=>(0, $NETJo.mod)(x, $7bddc611d6926dce$var$secp256k1N);
const $7bddc611d6926dce$var$Point = $7bddc611d6926dce$exports.secp256k1.ProjectivePoint;
const $7bddc611d6926dce$var$GmulAdd = (Q, a, b)=>$7bddc611d6926dce$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $7bddc611d6926dce$var$schnorrGetExtPubKey(priv) {
    let d_ = $7bddc611d6926dce$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $7bddc611d6926dce$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $7bddc611d6926dce$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $7bddc611d6926dce$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $7bddc611d6926dce$var$lift_x(x) {
    if (!$7bddc611d6926dce$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $7bddc611d6926dce$var$modP(x * x);
    const c = $7bddc611d6926dce$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $7bddc611d6926dce$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $7bddc611d6926dce$var$_2n !== $7bddc611d6926dce$var$_0n) y = $7bddc611d6926dce$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $7bddc611d6926dce$var$Point(x, y, $7bddc611d6926dce$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $7bddc611d6926dce$var$challenge(...args) {
    return $7bddc611d6926dce$var$modN((0, $hEqBT.bytesToNumberBE)($7bddc611d6926dce$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $7bddc611d6926dce$var$schnorrGetPublicKey(privateKey) {
    return $7bddc611d6926dce$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $7bddc611d6926dce$var$schnorrSign(message, privateKey, auxRand = (0, $2c08a667590999ce$exports.randomBytes)(32)) {
    const m = (0, $hEqBT.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $7bddc611d6926dce$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $hEqBT.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $7bddc611d6926dce$var$numTo32b(d ^ (0, $hEqBT.bytesToNumberBE)($7bddc611d6926dce$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $7bddc611d6926dce$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $7bddc611d6926dce$var$modN((0, $hEqBT.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $7bddc611d6926dce$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $7bddc611d6926dce$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $7bddc611d6926dce$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($7bddc611d6926dce$var$numTo32b($7bddc611d6926dce$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$7bddc611d6926dce$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $7bddc611d6926dce$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $hEqBT.ensureBytes)("signature", signature, 64);
    const m = (0, $hEqBT.ensureBytes)("message", message);
    const pub = (0, $hEqBT.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $7bddc611d6926dce$var$lift_x((0, $hEqBT.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $hEqBT.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$7bddc611d6926dce$var$fe(r)) return false;
        const s = (0, $hEqBT.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$7bddc611d6926dce$var$ge(s)) return false;
        const e = $7bddc611d6926dce$var$challenge($7bddc611d6926dce$var$numTo32b(r), $7bddc611d6926dce$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $7bddc611d6926dce$var$GmulAdd(P, s, $7bddc611d6926dce$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$7bddc611d6926dce$exports.schnorr = (()=>({
        getPublicKey: $7bddc611d6926dce$var$schnorrGetPublicKey,
        sign: $7bddc611d6926dce$var$schnorrSign,
        verify: $7bddc611d6926dce$var$schnorrVerify,
        utils: {
            randomPrivateKey: $7bddc611d6926dce$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $7bddc611d6926dce$var$lift_x,
            pointToBytes: $7bddc611d6926dce$var$pointToBytes,
            numberToBytesBE: $hEqBT.numberToBytesBE,
            bytesToNumberBE: $hEqBT.bytesToNumberBE,
            taggedHash: $7bddc611d6926dce$var$taggedHash,
            mod: $NETJo.mod
        }
    }))();
const $7bddc611d6926dce$var$isoMap = /* @__PURE__ */ (()=>(0, $e5fff4a769649725$exports.isogenyMap)($7bddc611d6926dce$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $7bddc611d6926dce$var$mapSWU = /* @__PURE__ */ (()=>(0, $f9b999781f43739e$exports.mapToCurveSimpleSWU)($7bddc611d6926dce$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $7bddc611d6926dce$var$Fp.create(BigInt("-11"))
    }))();
const $7bddc611d6926dce$var$htf = /* @__PURE__ */ (()=>(0, $e5fff4a769649725$exports.createHasher)($7bddc611d6926dce$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $7bddc611d6926dce$var$mapSWU($7bddc611d6926dce$var$Fp.create(scalars[0]));
        return $7bddc611d6926dce$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $7bddc611d6926dce$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $0f6b86097fbea908$exports.sha256
    }))();
$7bddc611d6926dce$exports.hashToCurve = (()=>$7bddc611d6926dce$var$htf.hashToCurve)();
$7bddc611d6926dce$exports.encodeToCurve = (()=>$7bddc611d6926dce$var$htf.encodeToCurve)();



var $7S6Nv = parcelRequire("7S6Nv");

var $fcphM = parcelRequire("fcphM");

var $gg0RY = parcelRequire("gg0RY");
function $3d436539f2136085$export$d8821aa75f4f0785(source) {
    if (typeof source === "string") {
        if (!(0, $gg0RY.isAddress)(source)) throw new (0, $fcphM.InvalidAddressError)({
            address: source
        });
        return {
            address: source,
            type: "json-rpc"
        };
    }
    if (!(0, $gg0RY.isAddress)(source.address)) throw new (0, $fcphM.InvalidAddressError)({
        address: source.address
    });
    return {
        address: source.address,
        signMessage: source.signMessage,
        signTransaction: source.signTransaction,
        signTypedData: source.signTypedData,
        source: "custom",
        type: "local"
    };
}



var $aegFK = parcelRequire("aegFK");

var $9mkfv = parcelRequire("9mkfv");
function $e90cc446d3301285$export$462669520a9d12d1(publicKey) {
    const address = (0, $9mkfv.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $aegFK.checksumAddress)(`0x${address}`);
}



var $hJsPq = parcelRequire("hJsPq");


var $dKCgU = parcelRequire("dKCgU");

var $7S6Nv = parcelRequire("7S6Nv");
function $58a4f039d7d2df15$export$acf1478c102d6a25({ r: r, s: s, v: v }) {
    return `0x${new (0, $7bddc611d6926dce$exports.secp256k1).Signature((0, $dKCgU.hexToBigInt)(r), (0, $dKCgU.hexToBigInt)(s)).toCompactHex()}${(0, $7S6Nv.toHex)(v).slice(2)}`;
}




var $7S6Nv = parcelRequire("7S6Nv");
async function $aa5cb483c7953923$export$c5552dfdbc7cec71({ hash: hash, privateKey: privateKey }) {
    const { r: r, s: s, recovery: recovery } = (0, $7bddc611d6926dce$exports.secp256k1).sign(hash.slice(2), privateKey.slice(2));
    return {
        r: (0, $7S6Nv.toHex)(r),
        s: (0, $7S6Nv.toHex)(s),
        v: recovery ? 28n : 27n
    };
}


async function $b29d6c85d8552f7e$export$1d9a7a8a40780de({ message: message, privateKey: privateKey }) {
    const signature = await (0, $aa5cb483c7953923$export$c5552dfdbc7cec71)({
        hash: (0, $hJsPq.hashMessage)(message),
        privateKey: privateKey
    });
    return (0, $58a4f039d7d2df15$export$acf1478c102d6a25)(signature);
}



var $9mkfv = parcelRequire("9mkfv");

var $7UNP4 = parcelRequire("7UNP4");

var $jSK74 = parcelRequire("jSK74");

var $f6c2v = parcelRequire("f6c2v");

var $7S6Nv = parcelRequire("7S6Nv");

var $kpVTR = parcelRequire("kpVTR");

var $kpVTR = parcelRequire("kpVTR");
class $26dd6ea0608583e5$export$4741ff085e62ac19 extends (0, $kpVTR.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NegativeOffsetError"
        });
    }
}
class $26dd6ea0608583e5$export$72dcc4230cbf50ba extends (0, $kpVTR.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PositionOutOfBoundsError"
        });
    }
}


const $2052028ae4bfbee1$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $26dd6ea0608583e5$export$72dcc4230cbf50ba)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $26dd6ea0608583e5$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $26dd6ea0608583e5$export$4741ff085e62ac19)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length) {
        const value = this.inspectBytes(length);
        this.position += length;
        return value;
    },
    readUint8 () {
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    setPosition (position) {
        this.assertPosition(position);
        this.position = position;
    }
};
function $2052028ae4bfbee1$export$fb542681b7c0dc55(bytes) {
    const cursor = Object.create($2052028ae4bfbee1$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return cursor;
}



var $ihras = parcelRequire("ihras");

var $7S6Nv = parcelRequire("7S6Nv");
function $c471e6e69eb5470d$export$140c78e750979cda(bytes, to = "hex") {
    const encodable = $c471e6e69eb5470d$var$getEncodable(bytes);
    const cursor = (0, $2052028ae4bfbee1$export$fb542681b7c0dc55)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $7S6Nv.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $c471e6e69eb5470d$export$643d3163062ff0f3(bytes, to = "bytes") {
    return $c471e6e69eb5470d$export$140c78e750979cda(bytes, to);
}
function $c471e6e69eb5470d$export$e01da38311234e95(hex, to = "hex") {
    return $c471e6e69eb5470d$export$140c78e750979cda(hex, to);
}
function $c471e6e69eb5470d$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $c471e6e69eb5470d$var$getEncodableList(bytes.map((x)=>$c471e6e69eb5470d$var$getEncodable(x)));
    return $c471e6e69eb5470d$var$getEncodableBytes(bytes);
}
function $c471e6e69eb5470d$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $c471e6e69eb5470d$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $c471e6e69eb5470d$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === "string" ? (0, $ihras.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $c471e6e69eb5470d$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $c471e6e69eb5470d$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $kpVTR.BaseError)("Length is too large.");
}



var $fcphM = parcelRequire("fcphM");

var $kpVTR = parcelRequire("kpVTR");

var $leMPQ = parcelRequire("leMPQ");

var $bI2Lm = parcelRequire("bI2Lm");

var $gg0RY = parcelRequire("gg0RY");
function $29b2d6aff198095f$export$9ce52ad2ebd4d8fd(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $leMPQ.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $gg0RY.isAddress)(to)) throw new (0, $fcphM.InvalidAddressError)({
        address: to
    });
    if (gasPrice) throw new (0, $kpVTR.BaseError)("`gasPrice` is not a valid EIP-1559 Transaction attribute.");
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $bI2Lm.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $bI2Lm.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}
function $29b2d6aff198095f$export$18dc5e03b8985881(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $leMPQ.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $gg0RY.isAddress)(to)) throw new (0, $fcphM.InvalidAddressError)({
        address: to
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $kpVTR.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
    if (gasPrice && gasPrice > 2n ** 256n - 1n) throw new (0, $bI2Lm.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}
function $29b2d6aff198095f$export$f9ff7fa58fadd108(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to, accessList: accessList } = transaction;
    if (to && !(0, $gg0RY.isAddress)(to)) throw new (0, $fcphM.InvalidAddressError)({
        address: to
    });
    if (typeof chainId !== "undefined" && chainId <= 0) throw new (0, $leMPQ.InvalidChainIdError)({
        chainId: chainId
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $kpVTR.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
    if (gasPrice && gasPrice > 2n ** 256n - 1n) throw new (0, $bI2Lm.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
    if (accessList) throw new (0, $kpVTR.BaseError)("`accessList` is not a valid Legacy Transaction attribute.");
}



var $1DQ5d = parcelRequire("1DQ5d");

var $fcphM = parcelRequire("fcphM");

var $7UNP4 = parcelRequire("7UNP4");

var $gg0RY = parcelRequire("gg0RY");

function $f72dc42b61bc715f$export$736ebd57ab43df1(accessList) {
    if (!accessList || accessList.length === 0) return [];
    const serializedAccessList = [];
    for(let i = 0; i < accessList.length; i++){
        const { address: address, storageKeys: storageKeys } = accessList[i];
        for(let j = 0; j < storageKeys.length; j++){
            if (storageKeys[j].length - 2 !== 64) throw new (0, $7UNP4.InvalidStorageKeySizeError)({
                storageKey: storageKeys[j]
            });
        }
        if (!(0, $gg0RY.isAddress)(address)) throw new (0, $fcphM.InvalidAddressError)({
            address: address
        });
        serializedAccessList.push([
            address,
            storageKeys
        ]);
    }
    return serializedAccessList;
}


function $ebbbf50716e69bb6$export$7cb44e9a321cd996(transaction, signature) {
    const type = (0, $1DQ5d.getTransactionType)(transaction);
    if (type === "eip1559") return $ebbbf50716e69bb6$var$serializeTransactionEIP1559(transaction, signature);
    if (type === "eip2930") return $ebbbf50716e69bb6$var$serializeTransactionEIP2930(transaction, signature);
    return $ebbbf50716e69bb6$var$serializeTransactionLegacy(transaction, signature);
}
function $ebbbf50716e69bb6$var$serializeTransactionEIP1559(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $29b2d6aff198095f$export$9ce52ad2ebd4d8fd)(transaction);
    const serializedAccessList = (0, $f72dc42b61bc715f$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $7S6Nv.toHex)(chainId),
        nonce ? (0, $7S6Nv.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $7S6Nv.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $7S6Nv.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $7S6Nv.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $7S6Nv.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList
    ];
    if (signature) {
        const yParity = (()=>{
            if (signature.v === 0n) return "0x";
            if (signature.v === 1n) return (0, $7S6Nv.toHex)(1);
            return signature.v === 27n ? "0x" : (0, $7S6Nv.toHex)(1);
        })();
        serializedTransaction.push(yParity, (0, $f6c2v.trim)(signature.r), (0, $f6c2v.trim)(signature.s));
    }
    return (0, $jSK74.concatHex)([
        "0x02",
        (0, $c471e6e69eb5470d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $ebbbf50716e69bb6$var$serializeTransactionEIP2930(transaction, signature) {
    const { chainId: chainId, gas: gas, data: data, nonce: nonce, to: to, value: value, accessList: accessList, gasPrice: gasPrice } = transaction;
    (0, $29b2d6aff198095f$export$18dc5e03b8985881)(transaction);
    const serializedAccessList = (0, $f72dc42b61bc715f$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $7S6Nv.toHex)(chainId),
        nonce ? (0, $7S6Nv.toHex)(nonce) : "0x",
        gasPrice ? (0, $7S6Nv.toHex)(gasPrice) : "0x",
        gas ? (0, $7S6Nv.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $7S6Nv.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList
    ];
    if (signature) {
        const yParity = (()=>{
            if (signature.v === 0n) return "0x";
            if (signature.v === 1n) return (0, $7S6Nv.toHex)(1);
            return signature.v === 27n ? "0x" : (0, $7S6Nv.toHex)(1);
        })();
        serializedTransaction.push(yParity, (0, $f6c2v.trim)(signature.r), (0, $f6c2v.trim)(signature.s));
    }
    return (0, $jSK74.concatHex)([
        "0x01",
        (0, $c471e6e69eb5470d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $ebbbf50716e69bb6$var$serializeTransactionLegacy(transaction, signature) {
    const { chainId: chainId = 0, gas: gas, data: data, nonce: nonce, to: to, value: value, gasPrice: gasPrice } = transaction;
    (0, $29b2d6aff198095f$export$f9ff7fa58fadd108)(transaction);
    let serializedTransaction = [
        nonce ? (0, $7S6Nv.toHex)(nonce) : "0x",
        gasPrice ? (0, $7S6Nv.toHex)(gasPrice) : "0x",
        gas ? (0, $7S6Nv.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $7S6Nv.toHex)(value) : "0x",
        data ?? "0x"
    ];
    if (signature) {
        const v = (()=>{
            // EIP-155 (explicit chainId)
            if (chainId > 0) return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                const inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0) return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // Pre-EIP-155 (no chainId)
            const v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v) throw new (0, $7UNP4.InvalidLegacyVError)({
                v: signature.v
            });
            return v;
        })();
        serializedTransaction = [
            ...serializedTransaction,
            (0, $7S6Nv.toHex)(v),
            signature.r,
            signature.s
        ];
    } else if (chainId > 0) serializedTransaction = [
        ...serializedTransaction,
        (0, $7S6Nv.toHex)(chainId),
        "0x",
        "0x"
    ];
    return (0, $c471e6e69eb5470d$export$140c78e750979cda)(serializedTransaction);
}



async function $9e4c8732af2a430d$export$6ad02cc4966b42ab({ privateKey: privateKey, transaction: transaction, serializer: serializer = (0, $ebbbf50716e69bb6$export$7cb44e9a321cd996) }) {
    const signature = await (0, $aa5cb483c7953923$export$c5552dfdbc7cec71)({
        hash: (0, $9mkfv.keccak256)(serializer(transaction)),
        privateKey: privateKey
    });
    return serializer(transaction, signature);
}



var $behyn = parcelRequire("behyn");


async function $04eb31a6d70f308c$export$9f05de2db4d31153({ privateKey: privateKey, ...typedData }) {
    const signature = await (0, $aa5cb483c7953923$export$c5552dfdbc7cec71)({
        hash: (0, $behyn.hashTypedData)(typedData),
        privateKey: privateKey
    });
    return (0, $58a4f039d7d2df15$export$acf1478c102d6a25)(signature);
}


function $3f975c687266e404$export$eea6da9db5fb64e0(privateKey) {
    const publicKey = (0, $7S6Nv.toHex)((0, $7bddc611d6926dce$exports.secp256k1).getPublicKey(privateKey.slice(2), false));
    const address = (0, $e90cc446d3301285$export$462669520a9d12d1)(publicKey);
    const account = (0, $3d436539f2136085$export$d8821aa75f4f0785)({
        address: address,
        async signMessage ({ message: message }) {
            return (0, $b29d6c85d8552f7e$export$1d9a7a8a40780de)({
                message: message,
                privateKey: privateKey
            });
        },
        async signTransaction (transaction, { serializer: serializer } = {}) {
            return (0, $9e4c8732af2a430d$export$6ad02cc4966b42ab)({
                privateKey: privateKey,
                transaction: transaction,
                serializer: serializer
            });
        },
        async signTypedData (typedData) {
            return (0, $04eb31a6d70f308c$export$9f05de2db4d31153)({
                ...typedData,
                privateKey: privateKey
            });
        }
    });
    return {
        ...account,
        publicKey: publicKey,
        source: "privateKey"
    };
}




var $72f8e370fc9ede1d$export$2e2bcd8739ae039 = {
    contactDetails: (address, nonce, telegram = "", email = "", chainId = (0, $32162005f9f3d1a7$export$8372812df8e8183f))=>({
            address: address.toLowerCase(),
            domain: {
                name: "Kleros v2",
                version: "1",
                chainId: chainId
            },
            types: {
                ContactDetails: [
                    {
                        name: "email",
                        type: "string"
                    },
                    {
                        name: "telegram",
                        type: "string"
                    },
                    {
                        name: "nonce",
                        type: "string"
                    }
                ]
            },
            primaryType: "ContactDetails",
            message: {
                email: email,
                telegram: telegram,
                nonce: nonce
            }
        }),
    signingAccount: (address, chainId = (0, $32162005f9f3d1a7$export$8372812df8e8183f))=>({
            account: address.toLowerCase(),
            domain: {
                name: "Kleros v2",
                version: "1",
                chainId: chainId
            },
            types: {
                SigningAccount: [
                    {
                        name: "body",
                        type: "string"
                    }
                ]
            },
            primaryType: "SigningAccount",
            message: {
                body: "To keep your data safe and to use certain features of Kleros, we ask that you sign these message to create a secret key for your account. This key is unrelated from your main Ethereum account and will not be able to send any transactions."
            }
        })
};



const $b53bb032fb27a937$var$useSigningAccount = ()=>{
    const { data: wallet } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const address = wallet?.account.address;
    const key = `signingAccount-${address}`;
    const [signingKey, setSigningKey] = (0, $f8fde51e27a510f9$export$2e2bcd8739ae039)(key);
    return {
        signingAccount: !(0, $2d857633ba67aa25$export$fce6876652108ab)(signingKey) ? (0, $3f975c687266e404$export$eea6da9db5fb64e0)(signingKey) : undefined,
        generateSigningAccount: ()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(wallet) ? $b53bb032fb27a937$var$generateSigningAccount(wallet, setSigningKey) : undefined
    };
};
const $b53bb032fb27a937$var$generateSigningAccount = async (wallet, setSigningKey)=>{
    if ((0, $2d857633ba67aa25$export$fce6876652108ab)(wallet.account)) return;
    const signature = await wallet.signTypedData((0, $72f8e370fc9ede1d$export$2e2bcd8739ae039).signingAccount(wallet.account.address));
    const signingKey = (0, $9mkfv.keccak256)(signature);
    setSigningKey(signingKey);
    return (0, $3f975c687266e404$export$eea6da9db5fb64e0)(signingKey);
};
var $b53bb032fb27a937$export$2e2bcd8739ae039 = $b53bb032fb27a937$var$useSigningAccount;






var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");








var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $0ecee72cd369050e$var$StyledTextarea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Textarea))`
  width: 100%;
  height: auto;
  textarea {
    height: 200px;
    border-color: ${({ theme: theme })=>theme.stroke};
  }
  small {
    font-weight: 400;
    hyphens: auto;
  }
`;
const $0ecee72cd369050e$var$JustificationArea = ({ justification: justification, setJustification: setJustification })=>/*#__PURE__*/ (0, $cZGFG.jsx)($0ecee72cd369050e$var$StyledTextarea, {
        value: justification,
        onChange: (e)=>setJustification(e.target.value),
        placeholder: "Justify your vote...",
        message: "A good justification contributes to case comprehension. Low quality justifications can be challenged.",
        variant: "info"
    });
var $0ecee72cd369050e$export$2e2bcd8739ae039 = $0ecee72cd369050e$var$JustificationArea;


const $984e05a479d5bb21$var$MainContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
`;
const $984e05a479d5bb21$var$OptionsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
`;
const $984e05a479d5bb21$var$RefuseToArbitrateContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  left: 0;
  right: 0;
  width: auto;
  margin: calc(-1 * (16px + (32 - 16) * (min(max(100vw, 375px), 1250px) - 375px) / 875));
  margin-top: 32px;
  background-color: ${({ theme: theme })=>theme.lightBlue};
  padding: 32px;
  display: flex;
  justify-content: center;
`;
const $984e05a479d5bb21$var$Options = ({ arbitrable: arbitrable, handleSelection: handleSelection, justification: justification, setJustification: setJustification })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: disputeDetails } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const [chosenOption, setChosenOption] = (0, $dup7A.useState)(-1);
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const onClick = (0, $dup7A.useCallback)(async (id)=>{
        setIsSending(true);
        setChosenOption(id);
        await handleSelection(id);
        setChosenOption(-1);
        setIsSending(false);
    }, [
        handleSelection,
        setChosenOption,
        setIsSending
    ]);
    return id ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($984e05a479d5bb21$var$MainContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201), {
                        children: disputeDetails?.question
                    }),
                    !(0, $2d857633ba67aa25$export$fce6876652108ab)(justification) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(setJustification) ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0ecee72cd369050e$export$2e2bcd8739ae039), {
                        justification: justification,
                        setJustification: setJustification
                    }) : null,
                    /*#__PURE__*/ (0, $cZGFG.jsx)($984e05a479d5bb21$var$OptionsContainer, {
                        children: disputeDetails?.answers?.map((answer, i)=>{
                            return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                                    text: answer.title,
                                    disabled: isSending,
                                    isLoading: chosenOption === i + 1,
                                    onClick: ()=>onClick(i + 1)
                                })
                            }, answer.title);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($984e05a479d5bb21$var$RefuseToArbitrateContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                        variant: "secondary",
                        text: "Refuse to Arbitrate",
                        disabled: isSending,
                        isLoading: chosenOption === 0,
                        onClick: ()=>onClick(0)
                    })
                })
            })
        ]
    }) : null;
};
var $984e05a479d5bb21$export$2e2bcd8739ae039 = $984e05a479d5bb21$var$Options;


const $1fd6f55e084a59c0$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
`;
const $1fd6f55e084a59c0$var$Commit = ({ arbitrable: arbitrable, voteIDs: voteIDs, setIsOpen: setIsOpen, refetch: refetch })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const parsedDisputeID = (0, $dup7A.useMemo)(()=>BigInt(id ?? 0), [
        id
    ]);
    const parsedVoteIDs = (0, $dup7A.useMemo)(()=>voteIDs.map((voteID)=>BigInt(voteID)), [
        voteIDs
    ]);
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const currentRoundIndex = disputeData?.dispute?.currentRoundIndex;
    const { data: walletClient } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const { signingAccount: signingAccount, generateSigningAccount: generateSigningAccount } = (0, $b53bb032fb27a937$export$2e2bcd8739ae039)();
    const saltKey = (0, $dup7A.useMemo)(()=>`dispute-${id}-round-${currentRoundIndex}-voteids-${voteIDs}`, [
        id,
        currentRoundIndex,
        voteIDs
    ]);
    const [_, setSalt] = (0, $f8fde51e27a510f9$export$2e2bcd8739ae039)(saltKey);
    const handleCommit = (0, $dup7A.useCallback)(async (choice)=>{
        const message = {
            message: saltKey
        };
        const rawSalt = !(0, $2d857633ba67aa25$export$fce6876652108ab)(signingAccount) ? await signingAccount.signMessage(message) : await (async ()=>{
            const account = await generateSigningAccount();
            return await account?.signMessage(message);
        })();
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(rawSalt)) return;
        const salt = (0, $9mkfv.keccak256)(rawSalt);
        setSalt(JSON.stringify({
            salt: salt,
            choice: choice
        }));
        const commit = (0, $9mkfv.keccak256)((0, $374503f3fb5f9122$export$92dace262a9f3722)([
            "uint256",
            "uint256"
        ], [
            BigInt(choice),
            BigInt(salt)
        ]));
        const { request: request } = await (0, $f9a008fec395d7ff$export$c468de00f7a9e817)({
            functionName: "castCommit",
            args: [
                parsedDisputeID,
                parsedVoteIDs,
                commit
            ]
        });
        if (walletClient) await (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await walletClient.writeContract(request), publicClient).then(({ status: status })=>{
            setIsOpen(status);
        });
        refetch();
    }, [
        saltKey,
        setSalt,
        parsedVoteIDs,
        parsedDisputeID,
        publicClient,
        setIsOpen,
        walletClient,
        generateSigningAccount,
        signingAccount,
        refetch
    ]);
    return id ? /*#__PURE__*/ (0, $cZGFG.jsx)($1fd6f55e084a59c0$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $984e05a479d5bb21$export$2e2bcd8739ae039), {
            arbitrable: arbitrable,
            handleSelection: handleCommit
        })
    }) : null;
};
var $1fd6f55e084a59c0$export$2e2bcd8739ae039 = $1fd6f55e084a59c0$var$Commit;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $9mkfv = parcelRequire("9mkfv");










const $fa8549c169118ce1$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
`;
const $fa8549c169118ce1$var$StyledInfoCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $83d1c59f988e57d7$export$2e2bcd8739ae039))`
  margin: 16px 0;
`;
const $fa8549c169118ce1$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  margin: 16px auto;
`;
const $fa8549c169118ce1$var$Reveal = ({ arbitrable: arbitrable, voteIDs: voteIDs, setIsOpen: setIsOpen, commit: commit, isRevealPeriod: isRevealPeriod })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const [isSending, setIsSending] = (0, $dup7A.useState)(false);
    const parsedDisputeID = (0, $dup7A.useMemo)(()=>BigInt(id ?? 0), [
        id
    ]);
    const parsedVoteIDs = (0, $dup7A.useMemo)(()=>voteIDs.map((voteID)=>BigInt(voteID)), [
        voteIDs
    ]);
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const [justification, setJustification] = (0, $dup7A.useState)("");
    const { data: disputeDetails } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const { data: walletClient } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const { signingAccount: signingAccount, generateSigningAccount: generateSigningAccount } = (0, $b53bb032fb27a937$export$2e2bcd8739ae039)();
    const currentRoundIndex = disputeData?.dispute?.currentRoundIndex;
    const saltKey = (0, $dup7A.useMemo)(()=>`dispute-${id}-round-${currentRoundIndex}-voteids-${voteIDs}`, [
        id,
        currentRoundIndex,
        voteIDs
    ]);
    const [storedSaltAndChoice, _] = (0, $f8fde51e27a510f9$export$2e2bcd8739ae039)(saltKey);
    const handleReveal = (0, $dup7A.useCallback)(async ()=>{
        setIsSending(true);
        const { salt: salt, choice: choice } = (0, $2d857633ba67aa25$export$fce6876652108ab)(storedSaltAndChoice) ? await $fa8549c169118ce1$var$getSaltAndChoice(signingAccount, generateSigningAccount, saltKey, disputeDetails.answers, commit) : JSON.parse(storedSaltAndChoice);
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(choice)) return;
        const { request: request } = await (0, $0b0903738c0da810$export$944c26d54e826586)((0, $f9a008fec395d7ff$export$c468de00f7a9e817)({
            functionName: "castVote",
            args: [
                parsedDisputeID,
                parsedVoteIDs,
                BigInt(choice),
                BigInt(salt),
                justification
            ]
        }));
        if (request && walletClient) await (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await walletClient.writeContract(request), publicClient).then(({ status: status })=>{
            setIsOpen(status);
        });
        setIsSending(false);
    }, [
        commit,
        disputeDetails?.answers,
        storedSaltAndChoice,
        generateSigningAccount,
        signingAccount,
        saltKey,
        justification,
        parsedVoteIDs,
        parsedDisputeID,
        publicClient,
        setIsOpen,
        walletClient
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($fa8549c169118ce1$var$Container, {
        children: (0, $2d857633ba67aa25$export$fce6876652108ab)(commit) ? /*#__PURE__*/ (0, $cZGFG.jsx)($fa8549c169118ce1$var$StyledInfoCard, {
            msg: "Failed to commit on time."
        }) : isRevealPeriod ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201), {
                    children: disputeDetails?.question
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0ecee72cd369050e$export$2e2bcd8739ae039), {
                    justification: justification,
                    setJustification: setJustification
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)($fa8549c169118ce1$var$StyledButton, {
                    variant: "secondary",
                    text: "Justify & Reveal",
                    disabled: isSending || (0, $2d857633ba67aa25$export$fce6876652108ab)(disputeDetails),
                    isLoading: isSending,
                    onClick: handleReveal
                })
            ]
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)($fa8549c169118ce1$var$StyledInfoCard, {
            msg: "Your vote was successfully commited, please wait until reveal period to reveal it."
        })
    });
};
const $fa8549c169118ce1$var$getSaltAndChoice = async (signingAccount, generateSigningAccount, saltKey, answers, commit)=>{
    const message = {
        message: saltKey
    };
    const rawSalt = !(0, $2d857633ba67aa25$export$fce6876652108ab)(signingAccount) ? await signingAccount.signMessage(message) : await (async ()=>{
        const account = await generateSigningAccount();
        return await account?.signMessage(message);
    })();
    if ((0, $2d857633ba67aa25$export$fce6876652108ab)(rawSalt)) return;
    const salt = (0, $9mkfv.keccak256)(rawSalt);
    answers.unshift({
        title: "Refuse To Arbitrate",
        description: "Refuse To Arbitrate"
    });
    const { choice: choice } = answers.reduce((acc, _, i)=>{
        if (acc.found) return acc;
        const innerCommit = (0, $9mkfv.keccak256)((0, $374503f3fb5f9122$export$92dace262a9f3722)([
            "uint256",
            "uint256"
        ], [
            BigInt(i),
            BigInt(salt)
        ]));
        if (innerCommit === commit) return {
            found: true,
            choice: i
        };
        else return acc;
    }, {
        found: false,
        choice: -1
    });
    return {
        salt: salt,
        choice: choice
    };
};
var $fa8549c169118ce1$export$2e2bcd8739ae039 = $fa8549c169118ce1$var$Reveal;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







const $70819c8674c532ec$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
`;
const $70819c8674c532ec$var$Vote = ({ arbitrable: arbitrable, voteIDs: voteIDs, setIsOpen: setIsOpen })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const parsedDisputeID = (0, $dup7A.useMemo)(()=>BigInt(id ?? 0), [
        id
    ]);
    const parsedVoteIDs = (0, $dup7A.useMemo)(()=>voteIDs.map((voteID)=>BigInt(voteID)), [
        voteIDs
    ]);
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const [justification, setJustification] = (0, $dup7A.useState)("");
    const { data: walletClient } = (0, $1d657eb5d64e17dc$export$742c698ad1033029)();
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const handleVote = (0, $dup7A.useCallback)(async (voteOption)=>{
        const { request: request } = await (0, $f9a008fec395d7ff$export$c468de00f7a9e817)({
            functionName: "castVote",
            args: [
                parsedDisputeID,
                parsedVoteIDs,
                BigInt(voteOption),
                BigInt(disputeData?.dispute?.currentRoundIndex),
                justification
            ]
        });
        if (walletClient) await (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await walletClient.writeContract(request), publicClient).then(({ status: status })=>{
            setIsOpen(status);
        });
    }, [
        disputeData?.dispute?.currentRoundIndex,
        justification,
        parsedVoteIDs,
        parsedDisputeID,
        publicClient,
        setIsOpen,
        walletClient
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($70819c8674c532ec$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $984e05a479d5bb21$export$2e2bcd8739ae039), {
            arbitrable: arbitrable,
            justification: justification,
            setJustification: setJustification,
            handleSelection: handleVote
        })
    });
};
var $70819c8674c532ec$export$2e2bcd8739ae039 = $70819c8674c532ec$var$Vote;


const $098847fc99401cd8$var$Classic = ({ arbitrable: arbitrable, setIsOpen: setIsOpen })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { data: drawData, refetch: refetch } = (0, $c2948331a6ec3f41$export$14dcb2ec2dc2058f)(address?.toLowerCase(), id, disputeData?.dispute?.currentRound.id);
    const { isHiddenVotes: isHiddenVotes, isCommitPeriod: isCommitPeriod, commit: commit, commited: commited } = (0, $bb547b3a0533538e$export$332cfb3c10dd1fd7)();
    const voteIDs = (0, $dup7A.useMemo)(()=>drawData?.draws?.map((draw)=>draw.voteIDNum), [
        drawData
    ]);
    return id && isHiddenVotes ? isCommitPeriod && !commited ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1fd6f55e084a59c0$export$2e2bcd8739ae039), {
        arbitrable: arbitrable,
        setIsOpen: setIsOpen,
        voteIDs: voteIDs,
        refetch: refetch
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa8549c169118ce1$export$2e2bcd8739ae039), {
        arbitrable: arbitrable,
        setIsOpen: setIsOpen,
        voteIDs: voteIDs,
        commit: commit,
        isRevealPeriod: !isCommitPeriod
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $70819c8674c532ec$export$2e2bcd8739ae039), {
        arbitrable: arbitrable,
        setIsOpen: setIsOpen,
        voteIDs: voteIDs
    });
};
var $098847fc99401cd8$export$2e2bcd8739ae039 = $098847fc99401cd8$var$Classic;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







const $0eb2327ecf84eb20$export$9aeb8792c467f36c = (drawnJurors)=>drawnJurors?.reduce((acc, current)=>{
        const jurorId = current.juror.id;
        const existingJuror = acc.find((item)=>item.juror.id === jurorId);
        existingJuror ? existingJuror.voteCount++ : acc.push({
            juror: {
                id: jurorId
            },
            voteCount: 1,
            vote: current.vote
        });
        return acc;
    }, []);










var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $e2f78c3858dc3624$var$StyledBox = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Box))`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBlue};
  height: auto;
  border-radius: 3px;
  padding: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  > p {
    margin: 0;
  }
  > svg {
    height: 16px;
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $e2f78c3858dc3624$var$StyledP = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).p`
  font-weight: 400;
`;
const $e2f78c3858dc3624$var$PendingVotesBox = ({ current: current, total: total, court: court })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($e2f78c3858dc3624$var$StyledBox, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6ffbdc979e08a453$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($e2f78c3858dc3624$var$StyledP, {
                children: current === total ? "All jurors voted" : `${current} vote${current === 1 ? "" : "s"} cast out of ${total} - ${court}`
            })
        ]
    });
var $e2f78c3858dc3624$export$2e2bcd8739ae039 = $e2f78c3858dc3624$var$PendingVotesBox;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $891cdb57837a31a2$var$TitleContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 12)};
  flex-wrap: wrap;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      align-items: center;
    `)}
`;
const $891cdb57837a31a2$var$AddressContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const $891cdb57837a31a2$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme, variant: variant })=>variant ? theme[variant] : theme.primaryText};
  font-size: 16px;
`;
const $891cdb57837a31a2$var$StyledSmall = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  font-size: 16px;
`;
const $891cdb57837a31a2$var$VoteStatus = ({ choice: choice, period: period, answers: answers, isActiveRound: isActiveRound })=>{
    if ((0, $2d857633ba67aa25$export$fce6876652108ab)(choice) && (isActiveRound ? [
        "appeal",
        "execution"
    ].includes(period) : true)) return /*#__PURE__*/ (0, $cZGFG.jsx)($891cdb57837a31a2$var$StyledLabel, {
        children: "Did not vote"
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($891cdb57837a31a2$var$StyledLabel, {
        children: (0, $2d857633ba67aa25$export$fce6876652108ab)(choice) ? "Pending Vote" : /*#__PURE__*/ (0, $cZGFG.jsx)($891cdb57837a31a2$var$StyledSmall, {
            children: (0, $de2bfa00360f89e4$export$f1796ea5e596b055)(parseInt(choice), answers)
        })
    });
};
const $891cdb57837a31a2$var$AccordionTitle = ({ juror: juror, choice: choice, voteCount: voteCount, period: period, answers: answers, isActiveRound: isActiveRound })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($891cdb57837a31a2$var$TitleContainer, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($891cdb57837a31a2$var$AddressContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0851f7d91966eb7d$exports))), {
                        size: "20",
                        string: juror
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($891cdb57837a31a2$var$StyledLabel, {
                        variant: "secondaryText",
                        children: (0, $db69162b86dec792$export$e6e2bc9967bf256c)(juror)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($891cdb57837a31a2$var$VoteStatus, {
                choice: choice,
                period: period,
                answers: answers,
                isActiveRound: isActiveRound
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($891cdb57837a31a2$var$StyledLabel, {
                variant: "secondaryPurple",
                children: [
                    voteCount,
                    " vote",
                    voteCount > 1 && "s"
                ]
            })
        ]
    });
};
var $891cdb57837a31a2$export$2e2bcd8739ae039 = $891cdb57837a31a2$var$AccordionTitle;


const $db83e6c0237bd6fd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;
const $db83e6c0237bd6fd$var$StyledAccordion = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.CustomAccordion))`
  width: 100%;
  > * > button {
    justify-content: unset;
    padding: 11.5px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 18)} !important;
    background-color: ${({ theme: theme })=>theme.whiteBackground} !important;
    border: 1px solid ${({ theme: theme })=>theme.stroke} !important;
    > svg {
      fill: ${({ theme: theme })=>theme.primaryText} !important;
    }
  }
  //adds padding to body container
  > * > div > div {
    padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 24)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 16)};
  }
`;
const $db83e6c0237bd6fd$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  height: auto;
  padding: 11.5px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 18)};
  margin: 8px 0;
`;
const $db83e6c0237bd6fd$var$AccordionContentContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $db83e6c0237bd6fd$var$JustificationText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.secondaryText};
  font-size: 16px;
  line-height: 1.2;
  &:before {
    content: "Justification: ";
    color: ${({ theme: theme })=>theme.primaryText};
  }
`;
const $db83e6c0237bd6fd$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryText};
  font-size: 16px;
`;
const $db83e6c0237bd6fd$var$SecondaryTextLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.secondaryText};
  font-size: 16px;
`;
const $db83e6c0237bd6fd$var$AccordionContent = ({ justification: justification, choice: choice, answers: answers })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($db83e6c0237bd6fd$var$AccordionContentContainer, {
        children: [
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(choice) && /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$StyledLabel, {
                        children: "Voted:\xa0"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$SecondaryTextLabel, {
                        children: (0, $de2bfa00360f89e4$export$f1796ea5e596b055)(parseInt(choice), answers)
                    })
                ]
            }),
            justification ? /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$JustificationText, {
                children: justification
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$SecondaryTextLabel, {
                children: "No justification provided"
            })
        ]
    });
const $db83e6c0237bd6fd$var$VotesAccordion = ({ drawnJurors: drawnJurors, period: period, answers: answers, isActiveRound: isActiveRound })=>{
    const accordionItems = (0, $dup7A.useMemo)(()=>{
        return drawnJurors.map((drawnJuror)=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(drawnJuror.vote?.justification?.choice) ? {
                title: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $891cdb57837a31a2$export$2e2bcd8739ae039), {
                    juror: drawnJuror.juror.id,
                    voteCount: drawnJuror.voteCount,
                    choice: drawnJuror.vote?.justification?.choice,
                    period: period,
                    answers: answers,
                    isActiveRound: isActiveRound
                }),
                body: /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$AccordionContent, {
                    justification: drawnJuror?.vote?.justification.reference ?? "",
                    choice: drawnJuror.vote?.justification?.choice,
                    answers: answers
                })
            } : null).filter((item)=>item !== null);
    }, [
        drawnJurors,
        period,
        answers,
        isActiveRound
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            drawnJurors.length === 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("br", {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $83d1c59f988e57d7$export$2e2bcd8739ae039), {
                        msg: "Jurors have not been drawn yet."
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $cZGFG.jsxs)($db83e6c0237bd6fd$var$Container, {
                children: [
                    accordionItems.length > 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$StyledAccordion, {
                        items: accordionItems
                    }) : null,
                    drawnJurors.map((drawnJuror)=>(0, $2d857633ba67aa25$export$fce6876652108ab)(drawnJuror.vote?.justification?.choice) && /*#__PURE__*/ (0, $cZGFG.jsx)($db83e6c0237bd6fd$var$StyledCard, {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $891cdb57837a31a2$export$2e2bcd8739ae039), {
                                juror: drawnJuror.juror.id,
                                voteCount: drawnJuror.voteCount,
                                period: period,
                                answers: answers,
                                isActiveRound: isActiveRound
                            })
                        }, drawnJuror.juror.id))
                ]
            })
        ]
    });
};
var $db83e6c0237bd6fd$export$2e2bcd8739ae039 = $db83e6c0237bd6fd$var$VotesAccordion;


const $d9f108ae1aba8735$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div``;
const $d9f108ae1aba8735$var$StyledTabs = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Tabs))`
  width: 100%;
  margin-bottom: 16px;
`;
const $d9f108ae1aba8735$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $d9f108ae1aba8735$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: 0;
`;
const $d9f108ae1aba8735$var$VotingHistory = ({ arbitrable: arbitrable, isQuestion: isQuestion })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: votingHistory } = (0, $2110a062d830c408$export$2d10fa524a206015)(id);
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const [currentTab, setCurrentTab] = (0, $dup7A.useState)(0);
    const { data: disputeDetails, isError: isError } = (0, $16b4cf141ce6646e$export$731762ca72fd57e0)(id, arbitrable);
    const rounds = votingHistory?.dispute?.rounds;
    const [isBinaryVotingMiniGuideOpen, toggleBinaryVotingMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const localRounds = (0, $efff76ebc0b7019d$export$7d08afb1cf7781e8)(votingHistory?.dispute?.disputeKitDispute);
    //set current tab to latest round
    (0, $dup7A.useEffect)(()=>setCurrentTab((rounds?.length && rounds?.length - 1) ?? 0), [
        rounds
    ]);
    const answers = disputeDetails?.answers;
    const drawnJurors = (0, $dup7A.useMemo)(()=>(0, $0eb2327ecf84eb20$export$9aeb8792c467f36c)(votingHistory?.dispute?.rounds.at(currentTab)?.drawnJurors ?? []), [
        votingHistory,
        currentTab
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($d9f108ae1aba8735$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($d9f108ae1aba8735$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($d9f108ae1aba8735$var$StyledTitle, {
                        children: "Voting History"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                        isMiniGuideOpen: isBinaryVotingMiniGuideOpen,
                        toggleMiniGuide: toggleBinaryVotingMiniGuide,
                        MiniGuideComponent: (0, $1458f55cef0c306d$export$2e2bcd8739ae039)
                    })
                ]
            }),
            rounds && localRounds && disputeDetails ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    isQuestion && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
                        children: disputeDetails.question ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201), {
                            children: disputeDetails.question
                        }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f9dbcfca8039a4$export$83ef7ab426386201), {
                            children: isError ? (0, $203b613495c69c62$export$adca62214545ea7b) : (0, $203b613495c69c62$export$7142fb39be536070)
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($d9f108ae1aba8735$var$StyledTabs, {
                        currentValue: currentTab,
                        items: rounds.map((_, i)=>({
                                text: `Round ${i + 1}`,
                                value: i
                            })),
                        callback: (i)=>setCurrentTab(i)
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e2f78c3858dc3624$export$2e2bcd8739ae039), {
                        current: localRounds.at(currentTab)?.totalVoted,
                        total: rounds.at(currentTab)?.nbVotes,
                        court: rounds.at(currentTab)?.court.name ?? ""
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $db83e6c0237bd6fd$export$2e2bcd8739ae039), {
                        drawnJurors: drawnJurors,
                        period: disputeData?.dispute?.period,
                        answers: answers,
                        isActiveRound: localRounds?.length - 1 === currentTab
                    })
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                height: 140
            })
        ]
    });
};
var $d9f108ae1aba8735$export$2e2bcd8739ae039 = $d9f108ae1aba8735$var$VotingHistory;


const $c5fbd9537271509e$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  padding-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(8, 16)};
`;
const $c5fbd9537271509e$var$useFinalDate = (lastPeriodChange, currentPeriodIndex, timesPerPeriod)=>(0, $dup7A.useMemo)(()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(currentPeriodIndex) && !(0, $2d857633ba67aa25$export$fce6876652108ab)(timesPerPeriod)) return (0, $9e213078be8217b5$export$f7b710e5dac82334)(lastPeriodChange, currentPeriodIndex, timesPerPeriod);
        else return undefined;
    }, [
        lastPeriodChange,
        currentPeriodIndex,
        timesPerPeriod
    ]);
const $c5fbd9537271509e$var$Voting = ({ arbitrable: arbitrable, currentPeriodIndex: currentPeriodIndex })=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { isDisconnected: isDisconnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: disputeData } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const { data: appealCost } = (0, $b6510298c52fe164$export$7188bdcf89640f6b)(id);
    const { wasDrawn: userWasDrawn, hasVoted: voted, isLoading: isDrawDataLoading } = (0, $bb547b3a0533538e$export$332cfb3c10dd1fd7)();
    const [isPopupOpen, setIsPopupOpen] = (0, $dup7A.useState)(false);
    (0, $bafdb2a6661c2921$export$eb909a3d9177a60d)(isPopupOpen);
    const lastPeriodChange = disputeData?.dispute?.lastPeriodChange;
    const timesPerPeriod = disputeData?.dispute?.court?.timesPerPeriod;
    const finalDate = $c5fbd9537271509e$var$useFinalDate(lastPeriodChange, currentPeriodIndex, timesPerPeriod);
    const isCommitOrVotePeriod = (0, $dup7A.useMemo)(()=>[
            (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).vote,
            (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).commit
        ].includes(currentPeriodIndex), [
        currentPeriodIndex
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($c5fbd9537271509e$var$Container, {
        children: [
            (0, $97c06093476515ae$export$8997e67ad6c0001c)(appealCost) && /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $83d1c59f988e57d7$export$2e2bcd8739ae039), {
                        msg: "This dispute is on its last round. Vote wisely, It cannot be appealed any further."
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("br", {})
                ]
            }),
            userWasDrawn || isDisconnected ? null : /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    isDrawDataLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                        width: 300,
                        height: 20
                    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $83d1c59f988e57d7$export$2e2bcd8739ae039), {
                        msg: "You were not drawn in current round."
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("br", {})
                ]
            }),
            isPopupOpen && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$2e2bcd8739ae039), {
                title: "Thanks for Voting",
                icon: (0, $f80a17c1f1727e89$export$2e2bcd8739ae039),
                popupType: disputeData?.dispute?.court?.hiddenVotes && currentPeriodIndex === (0, $2b4339c8418e3b6b$export$2be98a1249103ab1).commit ? (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).VOTE_WITH_COMMIT : (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).VOTE_WITHOUT_COMMIT,
                date: finalDate ? (0, $fee5256da5a38783$export$3ae94a2503e890a1)(finalDate) : "",
                isCommit: false,
                setIsOpen: setIsPopupOpen
            }),
            userWasDrawn && isCommitOrVotePeriod && !voted ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f108ae1aba8735$export$2e2bcd8739ae039), {
                        arbitrable: arbitrable,
                        isQuestion: false
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $098847fc99401cd8$export$2e2bcd8739ae039), {
                        arbitrable: arbitrable ?? "0x0",
                        setIsOpen: setIsPopupOpen
                    })
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d9f108ae1aba8735$export$2e2bcd8739ae039), {
                arbitrable: arbitrable,
                isQuestion: true
            })
        ]
    });
};
var $c5fbd9537271509e$export$2e2bcd8739ae039 = $c5fbd9537271509e$var$Voting;


const $3b208ca4d60996d1$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div``;
const $3b208ca4d60996d1$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  height: auto;
  min-height: 100px;
`;
const $3b208ca4d60996d1$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
`;
const $3b208ca4d60996d1$var$CaseDetails = ()=>{
    const { id: id } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { data: data } = (0, $73ef236f67d137a4$export$6b05b6ec027513e2)(id);
    const dispute = data?.dispute;
    const currentPeriodIndex = dispute ? (0, $2b4339c8418e3b6b$export$2be98a1249103ab1)[dispute.period] : 0;
    const arbitrable = dispute?.arbitrated.id;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $bb547b3a0533538e$export$25b3cbfdadc7108e), {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($3b208ca4d60996d1$var$Container, {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsxs)($3b208ca4d60996d1$var$Header, {
                    children: [
                        "Case #",
                        id
                    ]
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0f706ac1dac5bf9d$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $50b7f9ece81e5362$export$2e2bcd8739ae039), {
                    currentPeriodIndex: currentPeriodIndex,
                    dispute: dispute
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)($3b208ca4d60996d1$var$StyledCard, {
                    children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "overview",
                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2c0a6b27618dbd0e$export$2e2bcd8739ae039), {
                                    currentPeriodIndex: currentPeriodIndex,
                                    courtID: dispute?.court.id,
                                    arbitrable: arbitrable
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "evidence",
                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $04452cdeb639f166$export$2e2bcd8739ae039), {
                                    arbitrable: arbitrable
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "voting",
                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c5fbd9537271509e$export$2e2bcd8739ae039), {
                                    arbitrable: arbitrable,
                                    currentPeriodIndex: currentPeriodIndex
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "appeal",
                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $722961e830929345$export$2e2bcd8739ae039), {
                                    currentPeriodIndex: currentPeriodIndex
                                })
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$444b3ab0cb9aec40), {
                                    to: "overview",
                                    replace: true
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $3b208ca4d60996d1$export$2e2bcd8739ae039 = $3b208ca4d60996d1$var$CaseDetails;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




const $6a554d7d439ed7ed$export$393e2cd582c6728a = (filter)=>{
    if (Object.keys(filter).length === 0) return "all";
    else return encodeURI(JSON.stringify(filter));
};
const $6a554d7d439ed7ed$export$839ea60635874ac1 = (filter)=>{
    if (filter === "all") return {};
    else return JSON.parse(decodeURI(filter));
};
const $6a554d7d439ed7ed$export$e6340d5ca6801d59 = ()=>{
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    return location.pathname.split("/").slice(0, -3).join("/");
};






const $80d1ac2f360b3ef0$var$counterQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query Counter {
    counter(id: "0") {
      id
      cases
      casesRuled
      casesVoting
      casesAppealing
      stakedPNK
      redistributedPNK
      paidETH
      activeJurors
    }
  }
`);
const $80d1ac2f360b3ef0$export$8e66e0a593258089 = ()=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `useCounterQuery`
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $80d1ac2f360b3ef0$var$counterQuery,
                variables: {}
            })
    });
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");









const $5a53c1f59843a753$var$GridContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  --gap: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, max(350px, (100% - var(--gap) * 2)/3)), 1fr));
  align-items: center;
  gap: var(--gap);
`;
const $5a53c1f59843a753$var$ListContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;
// 24px as margin-top since we already have 8px from the flex gap
const $5a53c1f59843a753$var$StyledPagination = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.StandardPagination))`
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
`;
const $5a53c1f59843a753$var$CasesGrid = ({ disputes: disputes, casesPerPage: casesPerPage, totalPages: totalPages, currentPage: currentPage, setCurrentPage: setCurrentPage })=>{
    const { filter: filter } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const decodedFilter = (0, $6a554d7d439ed7ed$export$839ea60635874ac1)(filter ?? "all");
    const { id: searchValue } = decodedFilter;
    const { isList: isList } = (0, $b73946e052a4abb0$export$efcb02388d4a2108)();
    const isDesktop = (0, $a7773fb8c912d2f6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            isList && isDesktop ? /*#__PURE__*/ (0, $cZGFG.jsx)($5a53c1f59843a753$var$ListContainer, {
                children: (0, $2d857633ba67aa25$export$fce6876652108ab)(disputes) ? [
                    ...Array(casesPerPage)
                ].map((_, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$7cd623403cfd4f66), {}, i)) : disputes.map((dispute)=>{
                    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9e213078be8217b5$export$2e2bcd8739ae039), {
                        ...dispute
                    }, dispute.id);
                })
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)($5a53c1f59843a753$var$GridContainer, {
                children: (0, $2d857633ba67aa25$export$fce6876652108ab)(disputes) ? [
                    ...Array(casesPerPage)
                ].map((_, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$84f3ad5c22cc3642), {}, i)) : disputes.map((dispute)=>{
                    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9e213078be8217b5$export$2e2bcd8739ae039), {
                        ...dispute,
                        overrideIsList: true
                    }, dispute.id);
                })
            }),
            (0, $2d857633ba67aa25$export$fce6876652108ab)(searchValue) ? /*#__PURE__*/ (0, $cZGFG.jsx)($5a53c1f59843a753$var$StyledPagination, {
                currentPage: currentPage,
                numPages: Math.ceil(totalPages ?? 0),
                callback: (page)=>setCurrentPage(page)
            }) : null
        ]
    });
};
var $5a53c1f59843a753$export$2e2bcd8739ae039 = $5a53c1f59843a753$var$CasesGrid;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");










const $c41c1fed1791deff$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        flex-direction: row;
        gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(4, 22)};
      `)}
`;
const $c41c1fed1791deff$var$SearchBarContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
  z-index: 0;
`;
const $c41c1fed1791deff$var$StyledSearchbar = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Searchbar))`
  flex: 1;
  flex-basis: 310px;
  input {
    font-size: 16px;
    height: 45px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
const $c41c1fed1791deff$var$Search = ()=>{
    const { page: page, order: order, filter: filter } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const location = (0, $6a554d7d439ed7ed$export$e6340d5ca6801d59)();
    const decodedFilter = (0, $6a554d7d439ed7ed$export$839ea60635874ac1)(filter ?? "all");
    const { id: searchValue, ...filterObject } = decodedFilter;
    const [search, setSearch] = (0, $dup7A.useState)(searchValue ?? "");
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>{
        const newFilters = search === "" ? {
            ...filterObject
        } : {
            ...filterObject,
            id: search
        };
        const encodedFilter = (0, $6a554d7d439ed7ed$export$393e2cd582c6728a)(newFilters);
        navigate(`${location}/${page}/${order}/${encodedFilter}`);
    }, 500, [
        search
    ]);
    const { data: courtTreeData } = (0, $2a5b6389d5454647$export$2b3a4edc6425a652)();
    const items = (0, $dup7A.useMemo)(()=>{
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(courtTreeData)) {
            const courts = [
                (0, $2a5b6389d5454647$export$2d00adcfd7994092)(courtTreeData.court, "id")
            ];
            courts.push({
                label: "All Courts",
                value: "all"
            });
            return courts;
        }
        return undefined;
    }, [
        courtTreeData
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($c41c1fed1791deff$var$Container, {
        children: [
            items ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.DropdownCascader), {
                items: items,
                placeholder: "Select Court",
                onSelect: (value)=>{
                    const { court: _, ...filterWithoutCourt } = decodedFilter;
                    const newFilter = value === "all" ? filterWithoutCourt : {
                        ...decodedFilter,
                        court: value.toString()
                    };
                    navigate(`${location}/${page}/${order}/${(0, $6a554d7d439ed7ed$export$393e2cd582c6728a)(newFilter)}`);
                }
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {
                width: 240,
                height: 42
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($c41c1fed1791deff$var$SearchBarContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($c41c1fed1791deff$var$StyledSearchbar, {
                    type: "text",
                    placeholder: "Search By ID",
                    value: search,
                    onChange: (e)=>setSearch(e.target.value)
                })
            })
        ]
    });
};
var $c41c1fed1791deff$export$2e2bcd8739ae039 = $c41c1fed1791deff$var$Search;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $74a7cd4c56d00c89$var$SvgGrid = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M4.667 2.25v2.5a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 4.75v-2.5a.75.75 0 0 1 .75-.75h3.167a.75.75 0 0 1 .75.75Zm5.666 7.5v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75Zm1-7.5v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75Zm-1 2.5v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75ZM3.917 6.5H.75a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75ZM0 12.25v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75H.75a.75.75 0 0 0-.75.75Zm12.083-1.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75Zm0 5h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75Zm-6.416-3.25v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75Z"
        })
    });
var $74a7cd4c56d00c89$export$2e2bcd8739ae039 = $74a7cd4c56d00c89$var$SvgGrid;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $d0cff55ee95c940d$var$SvgList = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M3 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM1.5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm3-7.375h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Zm0 5h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Zm0 5h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Z"
        })
    });
var $d0cff55ee95c940d$export$2e2bcd8739ae039 = $d0cff55ee95c940d$var$SvgList;





const $2e010024e4587847$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
  gap: 12px;
  width: fit-content;
`;
const $2e010024e4587847$var$StyledGridIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $74a7cd4c56d00c89$export$2e2bcd8739ae039))`
  cursor: pointer;
  transition: filter 0.2s ease;
  fill: ${({ theme: theme })=>theme.primaryBlue};
  width: 16px;
  height: 16px;
  overflow: hidden;
`;
const $2e010024e4587847$var$IconsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
const $2e010024e4587847$var$StyledListIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d0cff55ee95c940d$export$2e2bcd8739ae039))`
  cursor: pointer;
  transition: filter 0.2s ease;
  fill: ${({ theme: theme })=>theme.primaryBlue};
  width: 16px;
  height: 16px;
  overflow: hidden;
`;
const $2e010024e4587847$var$Filters = ()=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const { order: order, filter: filter } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const { ruled: ruled, period: period, ...filterObject } = (0, $6a554d7d439ed7ed$export$839ea60635874ac1)(filter ?? "all");
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const location = (0, $6a554d7d439ed7ed$export$e6340d5ca6801d59)();
    const handleStatusChange = (value)=>{
        const parsedValue = JSON.parse(value);
        const encodedFilter = (0, $6a554d7d439ed7ed$export$393e2cd582c6728a)({
            ...filterObject,
            ...parsedValue
        });
        navigate(`${location}/1/${order}/${encodedFilter}`);
    };
    const handleOrderChange = (value)=>{
        const encodedFilter = (0, $6a554d7d439ed7ed$export$393e2cd582c6728a)({
            ruled: ruled,
            period: period,
            ...filterObject
        });
        navigate(`${location}/1/${value}/${encodedFilter}`);
    };
    const { isList: isList, setIsList: setIsList } = (0, $b73946e052a4abb0$export$efcb02388d4a2108)();
    const isDesktop = (0, $a7773fb8c912d2f6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($2e010024e4587847$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.DropdownSelect), {
                smallButton: true,
                simpleButton: true,
                items: [
                    {
                        value: JSON.stringify({}),
                        text: "All Cases",
                        dot: theme.primaryText
                    },
                    {
                        value: JSON.stringify({
                            ruled: false
                        }),
                        text: "In Progress",
                        dot: theme.primaryBlue
                    },
                    {
                        value: JSON.stringify({
                            period: "appeal"
                        }),
                        text: "Appeal",
                        dot: theme.tint
                    },
                    {
                        value: JSON.stringify({
                            ruled: true
                        }),
                        text: "Closed",
                        dot: theme.primaryPurple
                    }
                ],
                defaultValue: JSON.stringify({
                    ruled: ruled,
                    period: period
                }),
                callback: handleStatusChange
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.DropdownSelect), {
                smallButton: true,
                simpleButton: true,
                items: [
                    {
                        value: "desc",
                        text: "Newest"
                    },
                    {
                        value: "asc",
                        text: "Oldest"
                    }
                ],
                defaultValue: order,
                callback: handleOrderChange
            }),
            isDesktop ? /*#__PURE__*/ (0, $cZGFG.jsx)($2e010024e4587847$var$IconsContainer, {
                children: isList ? /*#__PURE__*/ (0, $cZGFG.jsx)($2e010024e4587847$var$StyledGridIcon, {
                    onClick: ()=>setIsList(false)
                }) : /*#__PURE__*/ (0, $cZGFG.jsx)($2e010024e4587847$var$StyledListIcon, {
                    onClick: ()=>{
                        if (isDesktop) setIsList(true);
                    }
                })
            }) : null
        ]
    });
};
var $2e010024e4587847$export$2e2bcd8739ae039 = $2e010024e4587847$var$Filters;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

const $862d34b86a8ec22d$var$FieldWrapper = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: inline-flex;
  gap: 8px;
`;
const $862d34b86a8ec22d$var$SeparatorLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  margin: 0 8px;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $862d34b86a8ec22d$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $862d34b86a8ec22d$var$Field = ({ label: label, value: value })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($862d34b86a8ec22d$var$FieldWrapper, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($862d34b86a8ec22d$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                children: value
            })
        ]
    });
const $862d34b86a8ec22d$var$Separator = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($862d34b86a8ec22d$var$SeparatorLabel, {
        children: "|"
    });
const $862d34b86a8ec22d$var$Stats = ({ totalDisputes: totalDisputes, closedDisputes: closedDisputes })=>{
    const inProgressDisputes = (totalDisputes - closedDisputes).toString();
    const fields = [
        {
            label: "Total",
            value: totalDisputes.toString()
        },
        {
            label: "In Progress",
            value: inProgressDisputes
        },
        {
            label: "Closed",
            value: closedDisputes.toString()
        }
    ];
    return /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
        children: fields.map(({ label: label, value: value }, i)=>/*#__PURE__*/ (0, $cZGFG.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($862d34b86a8ec22d$var$Field, {
                        label: label,
                        value: value
                    }),
                    i + 1 < fields.length ? /*#__PURE__*/ (0, $cZGFG.jsx)($862d34b86a8ec22d$var$Separator, {}) : null
                ]
            }, i))
    });
};
var $862d34b86a8ec22d$export$2e2bcd8739ae039 = $862d34b86a8ec22d$var$Stats;


const $33ffe1a7037f1726$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 11px;
  margin-bottom: 48px;
  justify-content: space-between;
`;
const $33ffe1a7037f1726$var$StatsAndFilters = ({ totalDisputes: totalDisputes, closedDisputes: closedDisputes })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($33ffe1a7037f1726$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $862d34b86a8ec22d$export$2e2bcd8739ae039), {
                totalDisputes: totalDisputes,
                closedDisputes: closedDisputes
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2e010024e4587847$export$2e2bcd8739ae039), {})
        ]
    });
var $33ffe1a7037f1726$export$2e2bcd8739ae039 = $33ffe1a7037f1726$var$StatsAndFilters;


const $db6ab98472834565$var$TitleContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 48)};
`;
const $db6ab98472834565$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin: 0px;
`;
const $db6ab98472834565$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $d86601acd95afa87$export$2e2bcd8739ae039))`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  > .button-text {
    color: ${({ theme: theme })=>theme.primaryBlue};
  }
  padding: 0px;
`;
const $db6ab98472834565$var$CasesDisplay = ({ disputes: disputes, currentPage: currentPage, setCurrentPage: setCurrentPage, numberDisputes: numberDisputes, numberClosedDisputes: numberClosedDisputes, casesPerPage: casesPerPage, title: title = "Cases", className: className, totalPages: totalPages })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($db6ab98472834565$var$TitleContainer, {
                className: "title",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($db6ab98472834565$var$StyledTitle, {
                        children: title
                    }),
                    location.pathname.startsWith("/cases/display/1/desc/all") ? /*#__PURE__*/ (0, $cZGFG.jsx)($db6ab98472834565$var$StyledButton, {
                        onClick: ()=>navigate(`/resolver`),
                        text: "Create a case",
                        Icon: (0, $5946df7c7bff186d$export$2e2bcd8739ae039)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c41c1fed1791deff$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33ffe1a7037f1726$export$2e2bcd8739ae039), {
                totalDisputes: numberDisputes ?? 0,
                closedDisputes: numberClosedDisputes ?? 0
            }),
            disputes?.length === 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                children: "No cases found"
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5a53c1f59843a753$export$2e2bcd8739ae039), {
                disputes: disputes,
                casesPerPage: casesPerPage,
                totalPages: totalPages,
                currentPage: currentPage,
                setCurrentPage: setCurrentPage
            })
        ]
    });
};
var $db6ab98472834565$export$2e2bcd8739ae039 = $db6ab98472834565$var$CasesDisplay;


const $f1b5e2748c36932f$var$calculateStats = (isCourtFilter, courtData, counters, filter)=>{
    let totalCases, ruledCases;
    if (filter?.period === "appeal") {
        totalCases = isCourtFilter ? courtData?.numberAppealingDisputes : counters?.casesAppealing;
        ruledCases = 0;
    } else if ((0, $2d857633ba67aa25$export$fce6876652108ab)(filter?.ruled)) {
        totalCases = isCourtFilter ? courtData?.numberDisputes : counters?.cases;
        ruledCases = isCourtFilter ? courtData?.numberClosedDisputes : counters?.casesRuled;
    } else if (filter?.ruled) {
        totalCases = isCourtFilter ? courtData?.numberClosedDisputes : counters?.casesRuled;
        ruledCases = totalCases;
    } else {
        totalCases = isCourtFilter ? courtData?.numberDisputes - courtData?.numberClosedDisputes : counters?.cases - counters?.casesRuled;
        ruledCases = 0;
    }
    return {
        totalCases: isNaN(totalCases) ? 0 : totalCases,
        ruledCases: isNaN(ruledCases) ? 0 : ruledCases
    };
};
const $f1b5e2748c36932f$var$CasesFetcher = ()=>{
    const { page: page, order: order, filter: filter } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const location = (0, $6a554d7d439ed7ed$export$e6340d5ca6801d59)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const isDesktop = (0, $a7773fb8c912d2f6$export$2e2bcd8739ae039)();
    const casesPerPage = isDesktop ? 9 : 3;
    const pageNumber = parseInt(page ?? "1");
    const disputeSkip = casesPerPage * (pageNumber - 1);
    const { data: counterData } = (0, $80d1ac2f360b3ef0$export$8e66e0a593258089)();
    const decodedFilter = (0, $6a554d7d439ed7ed$export$839ea60635874ac1)(filter ?? "all");
    const isCourtFilter = !(0, $2d857633ba67aa25$export$fce6876652108ab)(decodedFilter?.court);
    const { data: courtData } = (0, $6c35bcc70e144cdf$export$cac3085b56a3ca27)(decodedFilter?.court?.toString());
    const { data: data } = (0, $a6542729828b5d85$export$1b652431a6f4c7f1)(disputeSkip, casesPerPage, decodedFilter, order === "asc" ? (0, $29ccfa76e4432aad$export$6576b9de878968d6).Asc : (0, $29ccfa76e4432aad$export$6576b9de878968d6).Desc);
    const { totalCases: totalCases, ruledCases: ruledCases } = (0, $dup7A.useMemo)(()=>$f1b5e2748c36932f$var$calculateStats(isCourtFilter, courtData?.court, counterData?.counter, decodedFilter), [
        isCourtFilter,
        courtData?.court,
        counterData?.counter,
        decodedFilter
    ]);
    const totalPages = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(totalCases) ? Math.ceil(totalCases / casesPerPage) : 1, [
        totalCases,
        casesPerPage
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $db6ab98472834565$export$2e2bcd8739ae039), {
        disputes: data?.disputes,
        numberDisputes: totalCases,
        numberClosedDisputes: ruledCases,
        currentPage: pageNumber,
        setCurrentPage: (newPage)=>navigate(`${location}/${newPage}/${order}/${filter}`),
        totalPages: totalPages,
        casesPerPage: casesPerPage
    });
};
var $f1b5e2748c36932f$export$2e2bcd8739ae039 = $f1b5e2748c36932f$var$CasesFetcher;


const $24207fa12856df01$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 80)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 136)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $24207fa12856df01$var$Cases = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($24207fa12856df01$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                    path: "/display/:page/:order/:filter",
                    element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f1b5e2748c36932f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                    path: "/:id/*",
                    element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3b208ca4d60996d1$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
var $24207fa12856df01$export$2e2bcd8739ae039 = $24207fa12856df01$var$Cases;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





const $44e77a3ca4ef00b7$var$TopSearch = ()=>{
    const { data: data } = (0, $2a5b6389d5454647$export$2b3a4edc6425a652)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const items = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(data) && [
            (0, $2a5b6389d5454647$export$2d00adcfd7994092)(data.court)
        ], [
        data
    ]);
    return items ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.DropdownCascader), {
        items: items,
        onSelect: (path)=>navigate(path.toString()),
        placeholder: "Select Court"
    }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
        width: 240,
        height: 42
    });
};
var $44e77a3ca4ef00b7$export$2e2bcd8739ae039 = $44e77a3ca4ef00b7$var$TopSearch;


const $791c983324b55a5e$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 80)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 136)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $791c983324b55a5e$var$Courts = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($791c983324b55a5e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $44e77a3ca4ef00b7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                        path: "/:id/*",
                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $280911da292ab837$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$444b3ab0cb9aec40), {
                            to: "1",
                            replace: true
                        })
                    })
                ]
            })
        ]
    });
};
var $791c983324b55a5e$export$2e2bcd8739ae039 = $791c983324b55a5e$var$Courts;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");









const $9b3f9611a9d64fed$export$81ee62dfe1de490f = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  fragment UserDetails on User {
    totalDisputes
    totalResolvedDisputes
    totalAppealingDisputes
    totalCoherent
    coherenceScore
    tokens {
      court {
        id
        name
      }
    }
    shifts {
      pnkAmount
      ethAmount
    }
  }
`);
const $9b3f9611a9d64fed$var$userQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query User($address: ID!) {
    user(id: $address) {
      disputes(orderBy: lastPeriodChange) {
        id
      }
      ...UserDetails
    }
  }
`);
const $9b3f9611a9d64fed$var$userQueryDisputeFilter = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query UserDisputeFilter($address: ID!, $where: Dispute_filter) {
    user(id: $address) {
      disputes(orderBy: lastPeriodChange, where: $where) {
        id
      }
      ...UserDetails
    }
  }
`);
const $9b3f9611a9d64fed$export$68dae0b0cacaa18a = (address, where)=>{
    const isEnabled = address !== undefined;
    const query = where ? $9b3f9611a9d64fed$var$userQueryDisputeFilter : $9b3f9611a9d64fed$var$userQuery;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `userQuery${address?.toLowerCase()}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: query,
                variables: {
                    address: address?.toLowerCase(),
                    where: where
                }
            })
    });
};







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $6545b9ba7e6b4b1c$var$jurorStakeDetailsQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query JurorStakeDetails($userId: String) {
    jurorTokensPerCourts(where: { juror: $userId }) {
      court {
        id
        name
      }
      staked
      locked
    }
  }
`);
const $6545b9ba7e6b4b1c$export$c03ec2e7effec333 = (userId)=>{
    const isEnabled = userId !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `jurorStakeDetails${userId}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $6545b9ba7e6b4b1c$var$jurorStakeDetailsQuery,
                variables: {
                    userId: userId
                }
            })
    });
};




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $11d71e8177853b4a$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  justify-content: flex-start;

  small {
    height: 100%;
    font-weight: 600;
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        width: auto;
      `)}
`;
const $11d71e8177853b4a$var$StyledBreadcrumb = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Breadcrumb))`
  display: flex;
  align-items: center;
  height: 100%;
`;
const $11d71e8177853b4a$var$CourtName = ({ name: name })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($11d71e8177853b4a$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($11d71e8177853b4a$var$StyledBreadcrumb, {
            items: [
                {
                    text: name,
                    value: 0
                }
            ]
        })
    });
};
var $11d71e8177853b4a$export$2e2bcd8739ae039 = $11d71e8177853b4a$var$CourtName;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $lTCHO = parcelRequire("lTCHO");


const $86d58356dcb16b71$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  width: 100%;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      justify-content: flex-end;
      width: auto;
    `)}
`;
const $86d58356dcb16b71$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: flex;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
  font-size: 16px;
  align-items: center;
  gap: 4px;
`;
const $86d58356dcb16b71$var$Stake = ({ stake: stake })=>{
    const formattedStake = (0, $lTCHO.formatUnits)(stake, 18);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($86d58356dcb16b71$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: "Stake"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($86d58356dcb16b71$var$StyledLabel, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: formattedStake,
                    unit: "PNK"
                })
            })
        ]
    });
};
var $86d58356dcb16b71$export$2e2bcd8739ae039 = $86d58356dcb16b71$var$Stake;


const $19ed38f9a57561c5$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: auto;
  width: 100%;
  padding: 21px 24px 25px 19px;
  border-left: 5px solid ${({ theme: theme })=>theme.secondaryPurple};
  flex-wrap: wrap;
  gap: 12px;

  ${({ theme: theme })=>theme.name === "light" ? `box-shadow: 0px 2px 3px 0px ${theme.stroke};` : ""}

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        padding: 21.5px 32px 21.5px 27px;
      `)}
`;
const $19ed38f9a57561c5$var$CourtCard = ({ name: name, stake: stake })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($19ed38f9a57561c5$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $11d71e8177853b4a$export$2e2bcd8739ae039), {
                name: name
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $86d58356dcb16b71$export$2e2bcd8739ae039), {
                stake: stake
            })
        ]
    });
};
var $19ed38f9a57561c5$export$2e2bcd8739ae039 = $19ed38f9a57561c5$var$CourtCard;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $lTCHO = parcelRequire("lTCHO");

var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $4d329af293f9f7a8$var$SvgLocker = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M11.708 6.625h-.65V4.656C11.058 2.365 9.211.5 6.942.5c-2.27 0-4.117 1.865-4.117 4.156v1.969h-.65c-.718 0-1.3.588-1.3 1.313v5.25c0 .724.582 1.312 1.3 1.312h9.533c.718 0 1.3-.588 1.3-1.313v-5.25c0-.724-.582-1.312-1.3-1.312Zm-2.816 0h-3.9V4.656c0-1.085.874-1.968 1.95-1.968 1.075 0 1.95.883 1.95 1.968v1.969Z"
        })
    });
var $4d329af293f9f7a8$export$2e2bcd8739ae039 = $4d329af293f9f7a8$var$SvgLocker;






const $44ead72185397d79$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 48)};

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
    `)}
`;
const $44ead72185397d79$var$LockedPnk = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: flex-start;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      align-self: center;
    `)}
`;
const $44ead72185397d79$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: 0;
`;
const $44ead72185397d79$var$StyledLockerIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $4d329af293f9f7a8$export$2e2bcd8739ae039))`
  fill: ${({ theme: theme })=>theme.secondaryPurple};
  width: 14px;
`;
const $44ead72185397d79$var$Header = ({ lockedStake: lockedStake })=>{
    const formattedLockedStake = !(0, $2d857633ba67aa25$export$fce6876652108ab)(lockedStake) && (0, $lTCHO.formatUnits)(lockedStake, 18);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($44ead72185397d79$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($44ead72185397d79$var$StyledTitle, {
                children: "My Courts"
            }),
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(lockedStake) ? /*#__PURE__*/ (0, $cZGFG.jsxs)($44ead72185397d79$var$LockedPnk, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($44ead72185397d79$var$StyledLockerIcon, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: " Locked Stake: "
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("small", {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                            value: formattedLockedStake.toString(),
                            unit: "PNK"
                        })
                    })
                ]
            }) : null
        ]
    });
};
var $44ead72185397d79$export$2e2bcd8739ae039 = $44ead72185397d79$var$Header;


const $f863c0a429e72496$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: 64px;
`;
const $f863c0a429e72496$var$CourtCardsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 0;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 16px;
    `)}
`;
const $f863c0a429e72496$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 16px;
`;
const $f863c0a429e72496$var$Courts = ()=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: stakeData, isLoading: isLoading } = (0, $6545b9ba7e6b4b1c$export$c03ec2e7effec333)(address?.toLowerCase());
    const { data: jurorBalance } = (0, $f9a008fec395d7ff$export$95ba38bd72119500)({
        args: [
            address,
            BigInt(1)
        ]
    });
    const stakedCourts = stakeData?.jurorTokensPerCourts?.filter(({ staked: staked })=>staked > 0);
    const isStaked = stakedCourts && stakedCourts.length > 0;
    const lockedStake = jurorBalance?.[1];
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($f863c0a429e72496$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $44ead72185397d79$export$2e2bcd8739ae039), {
                lockedStake: lockedStake ?? BigInt(0)
            }),
            isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {}) : null,
            !isStaked && !isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)($f863c0a429e72496$var$StyledLabel, {
                children: "You are not staked in any court"
            }) : null,
            isStaked && !isLoading ? /*#__PURE__*/ (0, $cZGFG.jsx)($f863c0a429e72496$var$CourtCardsContainer, {
                children: stakeData?.jurorTokensPerCourts?.filter(({ staked: staked })=>staked > 0).map(({ court: { id: id, name: name }, staked: staked })=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $19ed38f9a57561c5$export$2e2bcd8739ae039), {
                        name: name ?? "",
                        stake: staked
                    }, id))
            }) : null
        ]
    });
};
var $f863c0a429e72496$export$2e2bcd8739ae039 = $f863c0a429e72496$var$Courts;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $36efe9648741c2ca$export$ff568cf35c0ad476 = [
    {
        scoreRange: [
            0,
            20
        ],
        level: 0,
        title: "Diogenes"
    },
    {
        scoreRange: [
            20,
            40
        ],
        level: 1,
        title: "Pythagoras"
    },
    {
        scoreRange: [
            40,
            60
        ],
        level: 2,
        title: "Socrates"
    },
    {
        scoreRange: [
            60,
            80
        ],
        level: 3,
        title: "Plato"
    },
    {
        scoreRange: [
            80,
            100
        ],
        level: 4,
        title: "Aristotle"
    }
];
const $36efe9648741c2ca$export$e85f3e8176d5b41b = (coherencyScore)=>{
    return $36efe9648741c2ca$export$ff568cf35c0ad476.find(({ scoreRange: scoreRange })=>{
        return coherencyScore >= scoreRange[0] && coherencyScore < scoreRange[1];
    }) ?? $36efe9648741c2ca$export$ff568cf35c0ad476[0];
};







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $533f332073ab6b4f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 48)};
  gap: 12px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    `)}
`;
const $533f332073ab6b4f$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: 0;
`;
const $533f332073ab6b4f$var$LinksContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  color: ${({ theme: theme })=>theme.primaryBlue};
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 32px;
    `)}
`;
const $533f332073ab6b4f$var$StyledXIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $373e5657daec75d9$export$2e2bcd8739ae039))`
  fill: ${({ theme: theme })=>theme.primaryBlue};
  width: 16px;
  height: 16px;
`;
const $533f332073ab6b4f$var$StyledLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  border: 0px;
  align-items: center;
  gap: 8px;

  &:hover {
    text-decoration: underline;
  }
`;
const $533f332073ab6b4f$var$Header = ({ levelTitle: levelTitle, levelNumber: levelNumber, totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes })=>{
    const [isJurorLevelsMiniGuideOpen, toggleJurorLevelsMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    const coherencePercentage = parseFloat((totalCoherent / Math.max(totalResolvedDisputes, 1) * 100).toFixed(2));
    const courtUrl = window.location.origin;
    const xPostText = `Hey I've been busy as a Juror on the Kleros court, check out my score: \n\nLevel: ${levelNumber} (${levelTitle})\nCoherence Percentage: ${coherencePercentage}%\nCoherent Votes: ${totalCoherent}/${totalResolvedDisputes}

Be a juror with me! \u{27A1}\u{FE0F} ${courtUrl}`;
    const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(xPostText)}`;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($533f332073ab6b4f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($533f332073ab6b4f$var$StyledTitle, {
                children: "Juror Dashboard"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($533f332073ab6b4f$var$LinksContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                        isMiniGuideOpen: isJurorLevelsMiniGuideOpen,
                        toggleMiniGuide: toggleJurorLevelsMiniGuide,
                        MiniGuideComponent: (0, $3641426bdc544c85$export$2e2bcd8739ae039)
                    }),
                    totalResolvedDisputes > 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)($533f332073ab6b4f$var$StyledLink, {
                        href: xShareUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($533f332073ab6b4f$var$StyledXIcon, {}),
                            " ",
                            /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                                children: "Share your juror score"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var $533f332073ab6b4f$export$2e2bcd8739ae039 = $533f332073ab6b4f$var$Header;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $3Szoa = parcelRequire("3Szoa");
var $lTCHO = parcelRequire("lTCHO");


const $7d17ffa0c53046b1$export$4b2cb815b21f438d = [
    {
        token: "ETH",
        coinId: 1,
        getAmount: (amount)=>(0, $3Szoa.formatEther)(amount),
        getValue: (amount, coinPrice)=>(Number((0, $3Szoa.formatEther)(amount)) * (coinPrice ?? 0)).toString()
    },
    {
        token: "PNK",
        coinId: 0,
        getAmount: (amount)=>(0, $lTCHO.formatUnits)(amount, 18),
        getValue: (amount, coinPrice)=>(Number((0, $lTCHO.formatUnits)(amount, 18)) * (coinPrice ?? 0)).toString()
    }
];
const $7d17ffa0c53046b1$export$bb6d1e204b7e2f6c = (coinId, data)=>{
    const total = data.user?.shifts.map((shift)=>parseInt(coinId === 0 ? shift.pnkAmount : shift.ethAmount)).reduce((acc, curr)=>acc + curr, 0);
    return BigInt(total ?? 0);
};
const $7d17ffa0c53046b1$export$c285ae1f36e15c2a = (data, pricesData)=>{
    return $7d17ffa0c53046b1$export$4b2cb815b21f438d.map(({ token: token, coinId: coinId, getValue: getValue, getAmount: getAmount })=>{
        const coinPrice = !(0, $2d857633ba67aa25$export$fce6876652108ab)(pricesData) ? pricesData[(0, $dc69730cf3c4367b$export$9943437e13d9c9e1)[token]]?.price : undefined;
        const totalReward = data && $7d17ffa0c53046b1$export$bb6d1e204b7e2f6c(coinId, data);
        return {
            token: token,
            amount: !(0, $2d857633ba67aa25$export$fce6876652108ab)(totalReward) ? getAmount(totalReward) : undefined,
            value: getValue ? !(0, $2d857633ba67aa25$export$fce6876652108ab)(totalReward) ? getValue(totalReward, coinPrice) : undefined : undefined
        };
    });
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $82e8cebc89e48fa1$var$LinearGradientPath = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).path`
  ${({ gradient: gradient })=>gradient && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      stroke: url(#${gradient});
    `}
`;
const $82e8cebc89e48fa1$var$GradientTokenIcons = ({ icon: icon })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: icon === "ETH" ? /*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)($82e8cebc89e48fa1$var$LinearGradientPath, {
                    gradient: "eth",
                    id: "paint0_linear_14360_27088",
                    d: "M9.86602 28.0687L22.923 36.0836V47.1905L9.86602 28.0687ZM23.423 36.0836L36.4799 28.0687L23.423 47.1905V36.0836ZM23.423 16.428V0.930308L36.666 23.7911L23.423 16.428ZM36.8415 24.4607L23.423 32.703V17L36.8415 24.4607ZM22.923 0.929777V16.4279L9.67081 23.7913L22.923 0.929777ZM22.923 32.7032L9.49539 24.4607L22.923 16.9999V32.7032Z"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "eth",
                        x1: "23.173",
                        y1: "0",
                        x2: "23.173",
                        y2: "48",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#6CC5FF"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B45FFF"
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)($82e8cebc89e48fa1$var$LinearGradientPath, {
                    gradient: "pnk",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.7151 6L35.6632 7.30096L43.9078 25.526L32.6361 42L12.2385 41.132L4 21.1862L15.7151 6ZM16.2222 7.03373L13.1105 22.2033L31.3917 13.6461L16.2222 7.03373ZM31.8965 14.3445L13.3445 23.0284L29.1334 34.8701L31.8965 14.3445ZM28.5319 35.4771L12.9497 23.7905V40.1518L28.5319 35.4771ZM12.1032 38.5872V23.2874L5.18188 21.8302L12.1032 38.5872ZM5.23158 20.9756L12.1974 22.4421L15.1303 8.14394L5.23158 20.9756ZM15.0532 40.4045L31.7195 41.1137L29.2373 36.1493L15.0532 40.4045ZM29.9956 35.773L32.4763 40.7345L41.6905 27.2676L29.9956 35.773ZM41.9695 23.295L35.3631 8.69144L32.9292 13.5593L41.9695 23.295ZM32.2205 13.0839L18.3024 7.01704L34.7186 8.08766L32.2205 13.0839ZM32.7193 14.5773L30.0082 34.7171L42.7892 25.4218L32.7193 14.5773Z",
                    fill: "url(#paint0_linear_14360_27090)"
                }),
                /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "pnk",
                        x1: "23.9539",
                        y1: "6",
                        x2: "23.9539",
                        y2: "42",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#6CC5FF"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B45FFF"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $82e8cebc89e48fa1$export$2e2bcd8739ae039 = $82e8cebc89e48fa1$var$GradientTokenIcons;




const $8bf8e112d6faf4d2$var$RewardContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;
const $8bf8e112d6faf4d2$var$StyledH1 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin: 0;
`;
const $8bf8e112d6faf4d2$var$TokenRewards = ({ token: token, amount: amount, value: value })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($8bf8e112d6faf4d2$var$RewardContainer, {
        children: [
            token && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $82e8cebc89e48fa1$export$2e2bcd8739ae039), {
                icon: token
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($8bf8e112d6faf4d2$var$StyledH1, {
                children: amount ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: amount,
                    unit: token,
                    place: "left"
                }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                    width: 76
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                children: value ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: value,
                    place: "right",
                    unit: "$",
                    isCurrency: true
                }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                    width: 32
                })
            })
        ]
    });
};
var $8bf8e112d6faf4d2$export$2e2bcd8739ae039 = $8bf8e112d6faf4d2$var$TokenRewards;


const $f699313ded2cd684$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
`;
const $f699313ded2cd684$var$tooltipMsg = "Users have an economic interest in serving as jurors in Kleros: collecting the Juror Rewards in exchange for their work. Each juror who is coherent with the final ruling receive the Juror Rewards composed of arbitration fees (ETH) + PNK redistribution between jurors.";
const $f699313ded2cd684$var$JurorRewards = ()=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: data } = (0, $9b3f9611a9d64fed$export$68dae0b0cacaa18a)(address?.toLowerCase());
    const coinIds = [
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).PNK,
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).ETH
    ];
    const { prices: pricesData } = (0, $395644ae226c29e9$export$28d4a1ba7888e974)(coinIds);
    const formattedRewards = (0, $7d17ffa0c53046b1$export$c285ae1f36e15c2a)(data, pricesData);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($f699313ded2cd684$var$Container, {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $30a2dcec41d4503b$export$2e2bcd8739ae039), {
                    place: "bottom",
                    tooltipMsg: $f699313ded2cd684$var$tooltipMsg,
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                        children: " Juror Rewards "
                    })
                }),
                formattedRewards.map(({ token: token, amount: amount, value: value })=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $8bf8e112d6faf4d2$export$2e2bcd8739ae039), {
                        token: token,
                        amount: amount,
                        value: value
                    }, token))
            ]
        })
    });
};
var $f699313ded2cd684$export$2e2bcd8739ae039 = $f699313ded2cd684$var$JurorRewards;



// import StakingRewards from "./StakingRewards";
const $9dfbaa0e00b8ab2a$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div``;
const $9dfbaa0e00b8ab2a$var$Card = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 40px;
  width: 100%;
  height: auto;
  padding: 24px 0;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 64)};
      height: 236px;
    `)}
`;
const $9dfbaa0e00b8ab2a$var$JurorInfo = ()=>{
    const { address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { data: data } = (0, $9b3f9611a9d64fed$export$68dae0b0cacaa18a)(address?.toLowerCase());
    const coherenceScore = data?.user ? parseInt(data?.user?.coherenceScore) : 0;
    const totalCoherent = data?.user ? parseInt(data?.user?.totalCoherent) : 0;
    const totalResolvedDisputes = data?.user ? parseInt(data?.user?.totalResolvedDisputes) : 0;
    const userLevelData = (0, $36efe9648741c2ca$export$e85f3e8176d5b41b)(coherenceScore);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($9dfbaa0e00b8ab2a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $533f332073ab6b4f$export$2e2bcd8739ae039), {
                levelTitle: userLevelData.title,
                levelNumber: userLevelData.level,
                totalCoherent: totalCoherent,
                totalResolvedDisputes: totalResolvedDisputes
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($9dfbaa0e00b8ab2a$var$Card, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b9a21c2e2f7668df$export$2e2bcd8739ae039), {
                        level: userLevelData.level,
                        width: "189px",
                        height: "189px"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e7f4f99826629822$export$2e2bcd8739ae039), {
                        userLevelData: userLevelData,
                        totalCoherent: totalCoherent,
                        totalResolvedDisputes: totalResolvedDisputes,
                        isMiniGuide: false
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f699313ded2cd684$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $9dfbaa0e00b8ab2a$export$2e2bcd8739ae039 = $9dfbaa0e00b8ab2a$var$JurorInfo;


const $02b519f108ac1b5b$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 80)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 136)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $02b519f108ac1b5b$var$StyledCasesDisplay = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $db6ab98472834565$export$2e2bcd8739ae039))`
  margin-top: 64px;

  .title {
    margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
  }
`;
const $02b519f108ac1b5b$var$ConnectWalletContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $02b519f108ac1b5b$var$Dashboard = ()=>{
    const { isConnected: isConnected, address: address } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const { page: page, order: order, filter: filter } = (0, $5c6d50c15e61ec01$export$99eaa27ddbbb95ef)();
    const location = (0, $6a554d7d439ed7ed$export$e6340d5ca6801d59)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const casesPerPage = 3;
    const pageNumber = parseInt(page ?? "1");
    const disputeSkip = casesPerPage * (pageNumber - 1);
    const decodedFilter = (0, $6a554d7d439ed7ed$export$839ea60635874ac1)(filter ?? "all");
    const { data: disputesData } = (0, $a6542729828b5d85$export$66e7a3048fa32afd)(address, disputeSkip, decodedFilter, order === "asc" ? (0, $29ccfa76e4432aad$export$6576b9de878968d6).Asc : (0, $29ccfa76e4432aad$export$6576b9de878968d6).Desc);
    const { data: userData } = (0, $9b3f9611a9d64fed$export$68dae0b0cacaa18a)(address, decodedFilter);
    const totalCases = userData?.user?.disputes.length;
    const totalResolvedCases = parseInt(userData?.user?.totalResolvedDisputes);
    const totalPages = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(totalCases) ? Math.ceil(totalCases / casesPerPage) : 1, [
        totalCases,
        casesPerPage
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($02b519f108ac1b5b$var$Container, {
        children: isConnected ? /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9dfbaa0e00b8ab2a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f863c0a429e72496$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)($02b519f108ac1b5b$var$StyledCasesDisplay, {
                    title: "My Cases",
                    disputes: userData?.user !== null ? disputesData?.user?.disputes : [],
                    numberDisputes: totalCases,
                    numberClosedDisputes: totalResolvedCases,
                    totalPages: totalPages,
                    currentPage: pageNumber,
                    setCurrentPage: (newPage)=>navigate(`${location}/${newPage}/${order}/${filter}`),
                    casesPerPage: casesPerPage
                })
            ]
        }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($02b519f108ac1b5b$var$ConnectWalletContainer, {
            children: [
                "To see your dashboard, connect first",
                /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5fd7f782fb0a380f$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $02b519f108ac1b5b$export$2e2bcd8739ae039 = $02b519f108ac1b5b$var$Dashboard;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $f9v1x = parcelRequire("f9v1x");









var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $f9v1x = parcelRequire("f9v1x");

const $75eace7478705485$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: calc(100vh - 180px);

  --text-color: ${({ theme: theme })=>theme.primaryText};
  --jse-text-readonly: ${({ theme: theme })=>theme.primaryText};
  --jse-theme-color: ${({ theme: theme })=>theme.primaryPurple};
  --jse-background-color: ${({ theme: theme })=>theme.whiteBackground};
  --jse-panel-background: ${({ theme: theme })=>theme.hoveredShadow};
  --jse-theme-color-highlight: ${({ theme: theme })=>theme.lightPurple};
  --jse-value-color-string: ${({ theme: theme })=>theme.primaryText};
  --jse-value-color-number: ${({ theme: theme })=>theme.primaryBlue};
  --jse-value-color-null: ${({ theme: theme })=>theme.error};
  --jse-main-border: 1px solid ${({ theme: theme })=>theme.stroke};
  --jse-key-color: ${({ theme: theme })=>theme.tint};
  --jse-value-color: ${({ theme: theme })=>theme.success};
  --jse-delimiter-color: ${({ theme: theme })=>theme.primaryText};
  .cm-gutter-lint {
    width: 0.6em;
  }
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: 30vw;
      height: calc(100vh - 300px);
    `)}
`;
const $75eace7478705485$var$JSONEditor = (props)=>{
    const refContainer = (0, $dup7A.useRef)(null);
    const refEditor = (0, $dup7A.useRef)(null);
    (0, $dup7A.useEffect)(()=>{
        refEditor.current = new (0, $f9v1x.JSONEditor)({
            target: refContainer.current,
            props: {
                ...props
            }
        });
        return ()=>{
            if (refEditor.current) {
                refEditor.current.destroy();
                refEditor.current = null;
            }
        };
    }, []);
    (0, $dup7A.useEffect)(()=>{
        if (refEditor.current) refEditor.current.updateProps(props);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($75eace7478705485$var$Container, {
        ref: refContainer
    });
};
var $75eace7478705485$export$2e2bcd8739ae039 = $75eace7478705485$var$JSONEditor;




var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





var $349Qk = parcelRequire("349Qk");
var $apDyM = parcelRequire("apDyM");

var $eUiaP = parcelRequire("eUiaP");


const $85fd5cffd11cb218$export$7449b88387595a50 = async (hash, chainId)=>{
    try {
        const publicClient = (0, $eUiaP.getPublicClient)({
            chainId: chainId
        });
        const txn = await publicClient.getTransactionReceipt({
            hash: hash
        });
        const selector = (0, $apDyM.getEventSelector)("DisputeRequest(address,uint256,uint256,uint256,string)");
        const disputeRequestEvent = txn.logs.find((log)=>log.topics[0] === selector);
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(disputeRequestEvent)) return undefined;
        const topics = (0, $349Qk.decodeEventLog)({
            abi: (0, $f9a008fec395d7ff$export$ee81f679a1a6e4b5),
            eventName: "DisputeRequest",
            topics: disputeRequestEvent?.topics,
            data: disputeRequestEvent?.data
        });
        return {
            ...topics?.args,
            _arbitrable: disputeRequestEvent.address
        };
    } catch (e) {
        return undefined;
    }
};



const $51cc31be852f49dd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-left: 24px;
`;
const $51cc31be852f49dd$var$InputContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const $51cc31be852f49dd$var$StyledChainInput = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 120px;
`;
const $51cc31be852f49dd$var$StyledHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h2`
  margin-top: 24px;
`;
const $51cc31be852f49dd$var$StyledH3 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h3`
  margin-top: 28px;
`;
const $51cc31be852f49dd$var$PresetsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
const $51cc31be852f49dd$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  cursor: pointer;
`;
const $51cc31be852f49dd$var$presets = [
    {
        title: "Escrow",
        txnHash: "0xfa24d589a0c26c71d06f6e0a151460783f70b51c174a08c04768f458c7817cd1",
        chainId: 421614
    },
    {
        title: "Curated Lists",
        txnHash: "0xd9ab4908fc5447d532bc287f49e2f2beb754fc62024b806f05a9abf706be7c06",
        chainId: 421614
    },
    {
        title: "Trump-Biden",
        txnHash: "0x9a3a420174f3c55c2b3eb2e77266777b74028b845e528a90142b5b57aafbdb90",
        chainId: 421614
    }
];
const $51cc31be852f49dd$var$FetchDisputeRequestInput = ({ setParams: setParams })=>{
    const [chainId, setChainId] = (0, $dup7A.useState)((0, $32162005f9f3d1a7$export$8372812df8e8183f));
    const [txnHash, setTxnHash] = (0, $dup7A.useState)("");
    const [debouncedTxnHash, setDebouncedTxnHash] = (0, $dup7A.useState)("");
    const [loading, setLoading] = (0, $dup7A.useState)(false);
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>{
        setDebouncedTxnHash(txnHash);
    }, 1000, [
        txnHash
    ]);
    (0, $dup7A.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            const params = await (0, $85fd5cffd11cb218$export$7449b88387595a50)(debouncedTxnHash, chainId);
            setLoading(false);
            if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(params)) setParams(params);
        };
        if (debouncedTxnHash && chainId) fetchData();
    }, [
        debouncedTxnHash
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($51cc31be852f49dd$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($51cc31be852f49dd$var$StyledHeader, {
                children: "Fetch Dispute Request params from transaction"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($51cc31be852f49dd$var$InputContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                        value: txnHash,
                        placeholder: "Enter transaction hash",
                        onChange: (e)=>setTxnHash(e.target.value),
                        message: loading ? "fetching ..." : ""
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($51cc31be852f49dd$var$StyledChainInput, {
                        value: chainId,
                        placeholder: "Enter chain Id",
                        type: "number",
                        onChange: (e)=>setChainId(Number(e.target.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($51cc31be852f49dd$var$StyledH3, {
                children: "Presets"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($51cc31be852f49dd$var$PresetsContainer, {
                children: $51cc31be852f49dd$var$presets.map((preset)=>/*#__PURE__*/ (0, $cZGFG.jsx)($51cc31be852f49dd$var$StyledA, {
                        onClick: ()=>{
                            setTxnHash(preset.txnHash);
                            setChainId(preset.chainId);
                        },
                        children: preset.title
                    }, preset.txnHash))
            })
        ]
    });
};
var $51cc31be852f49dd$export$2e2bcd8739ae039 = $51cc31be852f49dd$var$FetchDisputeRequestInput;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");







const $e2d307bb4dc83e4c$var$disputeTemplateQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query DisputeTemplate($id: ID!) {
    disputeTemplate(id: $id) {
      id
      templateTag
      templateData
      templateDataMappings
    }
  }
`);
const $e2d307bb4dc83e4c$export$d76e8b65d8aec0c9 = (templateId)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(templateId);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `disputeTemplate${templateId}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $e2d307bb4dc83e4c$var$disputeTemplateQuery,
                variables: {
                    id: templateId?.toString()
                },
                isDisputeTemplate: true
            })
    });
};



const $2b3b838cc2577652$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-left: 24px;
`;
const $2b3b838cc2577652$var$StyledInput = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))``;
const $2b3b838cc2577652$var$StyledHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h2`
  margin-top: 24px;
`;
const $2b3b838cc2577652$var$FetchFromIDInput = ({ setDisputeTemplateInput: setDisputeTemplateInput, setDataMappingsInput: setDataMappingsInput, defaultTemplateID: defaultTemplateID = "" })=>{
    const [templateId, setTemplateId] = (0, $dup7A.useState)("");
    const [debouncedTemplateId, setDebouncedTemplateId] = (0, $dup7A.useState)("");
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>{
        setDebouncedTemplateId(templateId);
    }, 1000, [
        templateId
    ]);
    (0, $dup7A.useEffect)(()=>setTemplateId(defaultTemplateID), [
        defaultTemplateID
    ]);
    const { data: templateFromId, isLoading: isLoading } = (0, $e2d307bb4dc83e4c$export$d76e8b65d8aec0c9)(debouncedTemplateId);
    (0, $dup7A.useEffect)(()=>{
        const templateData = templateFromId?.disputeTemplate?.templateData;
        const templateDataMappings = templateFromId?.disputeTemplate?.templateDataMappings;
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(templateData)) setDisputeTemplateInput($2b3b838cc2577652$var$tryPrettify(templateData));
        if (!(0, $2d857633ba67aa25$export$fce6876652108ab)(templateDataMappings)) setDataMappingsInput($2b3b838cc2577652$var$tryPrettify(templateDataMappings));
    }, [
        templateFromId
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($2b3b838cc2577652$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($2b3b838cc2577652$var$StyledHeader, {
                children: "Fetch dispute template from template ID"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($2b3b838cc2577652$var$StyledInput, {
                value: templateId,
                placeholder: "Enter template Id",
                message: isLoading ? "fetching ..." : "",
                onChange: (e)=>setTemplateId(e.target.value)
            })
        ]
    });
};
// will try to format else will be repaired in editor
const $2b3b838cc2577652$var$tryPrettify = (text)=>{
    try {
        return JSON.stringify(JSON.parse(text), null, 2);
    } catch  {
        return text;
    }
};
var $2b3b838cc2577652$export$2e2bcd8739ae039 = $2b3b838cc2577652$var$FetchFromIDInput;


const $1f7b26a96cfbff44$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  > h1 {
    margin: 0;
  }

  > hr {
    width: 100%;
  }
`;
const $1f7b26a96cfbff44$var$QuestionAndDescription = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  > * {
    margin: 0px;
  }
`;
const $1f7b26a96cfbff44$var$VotingOptions = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)($1f7b26a96cfbff44$var$QuestionAndDescription)`
  display: flex;
  flex-direction: column;
  > span {
    margin: 0px;
    display: flex;
    gap: 8px;
  }
`;
const $1f7b26a96cfbff44$var$ShadeArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 16px;
  margin-top: 16px;
  background-color: ${({ theme: theme })=>theme.mediumBlue};
  > p {
    margin-top: 0;
  }
`;
const $1f7b26a96cfbff44$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  align-items: center;
  gap: 4px;
  > svg {
    width: 16px;
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }
`;
const $1f7b26a96cfbff44$var$LinkContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $1f7b26a96cfbff44$var$LongTextSections = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  min-height: calc(100vh - 144px);
  margin: 24px;
  display: flex;
  gap: 12px;
  flex-direction: column;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
    `)}
`;
const $1f7b26a96cfbff44$var$UpperContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      grid-template-columns: 1fr 1fr;
    `)}
`;
const $1f7b26a96cfbff44$var$StyledForm = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 24px;
  margin-left: 24px;
`;
const $1f7b26a96cfbff44$var$StyledRow = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;
const $1f7b26a96cfbff44$var$StyledP = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).p`
  font-family: "Roboto Mono", monospace;
`;
const $1f7b26a96cfbff44$var$StyledHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h2`
  margin-top: 24px;
`;
const $1f7b26a96cfbff44$var$LongText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: auto;
`;
const $1f7b26a96cfbff44$var$DisputeTemplateView = ()=>{
    const klerosCoreAddress = (0, $ad0594865d820998$export$f4e67b1b0d9b318a)();
    const [disputeDetails, setDisputeDetails] = (0, $dup7A.useState)(undefined);
    const [disputeTemplateInput, setDisputeTemplateInput] = (0, $dup7A.useState)("");
    const [dataMappingsInput, setDataMappingsInput] = (0, $dup7A.useState)("");
    const [params, setParams] = (0, $dup7A.useState)({
        _arbitrable: "0x10f7A6f42Af606553883415bc8862643A6e63fdA",
        _arbitrator: klerosCoreAddress
    });
    const [debouncedParams, setDebouncedParams] = (0, $dup7A.useState)(params);
    const [loading, setLoading] = (0, $dup7A.useState)(false);
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>setDebouncedParams(params), 350, [
        params
    ]);
    const handleFormUpdate = (event)=>{
        const value = [
            "_arbitrator",
            "_arbitrable",
            "_templateUri"
        ].includes(event.target.name) ? event.target.value : BigInt(event.target.value);
        setParams({
            ...params,
            [event.target.name]: value
        });
    };
    (0, $dup7A.useEffect)(()=>{
        let isFetchDataScheduled = false;
        const scheduleFetchData = ()=>{
            if (!isFetchDataScheduled) {
                isFetchDataScheduled = true;
                setLoading(true);
                setTimeout(()=>{
                    const initialContext = {
                        arbitrator: debouncedParams._arbitrator,
                        arbitrable: debouncedParams._arbitrable,
                        arbitrableDisputeID: debouncedParams._arbitrableDisputeID,
                        externalDisputeID: debouncedParams._externalDisputeID,
                        templateID: debouncedParams._templateId,
                        templateUri: debouncedParams._templateUri
                    };
                    const fetchData = async ()=>{
                        try {
                            const data = dataMappingsInput ? await (0, $463e56179a7a7b53$export$43201cdb85c83f7e)(JSON.parse(dataMappingsInput), initialContext) : {};
                            const finalDisputeDetails = (0, $494ad55946d84593$export$8ca9e0624083b7f1)(disputeTemplateInput, data);
                            setDisputeDetails(finalDisputeDetails);
                        } catch (e) {
                            console.error(e);
                            setDisputeDetails(undefined);
                        } finally{
                            setLoading(false);
                        }
                    };
                    fetchData();
                    isFetchDataScheduled = false;
                }, 350);
            }
        };
        if (disputeTemplateInput || dataMappingsInput || debouncedParams) scheduleFetchData();
    }, [
        disputeTemplateInput,
        dataMappingsInput,
        debouncedParams
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$UpperContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledForm, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledHeader, {
                                children: "Dispute Request event parameters"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ arbitrator }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_arbitrator",
                                        value: params._arbitrator,
                                        onChange: handleFormUpdate,
                                        placeholder: "0x..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ arbitrable }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_arbitrable",
                                        value: params._arbitrable,
                                        onChange: handleFormUpdate,
                                        placeholder: "0x..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ arbitrableDisputeID }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_arbitrableDisputeID",
                                        value: params._arbitrableDisputeID?.toString(),
                                        onChange: handleFormUpdate,
                                        placeholder: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ externalDisputeID }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_externalDisputeID",
                                        value: params._externalDisputeID?.toString(),
                                        onChange: handleFormUpdate,
                                        placeholder: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ templateID }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_templateId",
                                        value: params._templateId?.toString(),
                                        onChange: handleFormUpdate,
                                        placeholder: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledRow, {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledP, {
                                        children: "{{ templateUri }}"
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Field), {
                                        type: "text",
                                        name: "_templateUri",
                                        value: params._templateUri,
                                        onChange: handleFormUpdate,
                                        placeholder: "ipfs://... (optional)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2b3b838cc2577652$export$2e2bcd8739ae039), {
                                setDataMappingsInput: setDataMappingsInput,
                                setDisputeTemplateInput: setDisputeTemplateInput,
                                defaultTemplateID: debouncedParams._templateId?.toString()
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $51cc31be852f49dd$export$2e2bcd8739ae039), {
                                setParams: setParams
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$LongTextSections, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$LongText, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledHeader, {
                                children: "Template"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $75eace7478705485$export$2e2bcd8739ae039), {
                                content: {
                                    text: disputeTemplateInput
                                },
                                mode: (0, $f9v1x.Mode).text,
                                onChange: (val)=>{
                                    setDisputeTemplateInput(val.text);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$LongText, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledHeader, {
                                children: "Data Mapping"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $75eace7478705485$export$2e2bcd8739ae039), {
                                content: {
                                    text: dataMappingsInput
                                },
                                mode: (0, $f9v1x.Mode).text,
                                onChange: (val)=>{
                                    setDataMappingsInput(val.text);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$LongText, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$StyledHeader, {
                                children: "Dispute Preview"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("br", {}),
                            loading ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $33a9103a3e154719$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$Overview, {
                                disputeDetails: disputeDetails
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $1f7b26a96cfbff44$var$Overview = ({ disputeDetails: disputeDetails })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                children: disputeDetails?.title ?? (0, $203b613495c69c62$export$7142fb39be536070)
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$QuestionAndDescription, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $66a2c9a2e00e09e7$export$2e2bcd8739ae039), {
                        children: disputeDetails?.question ?? (0, $203b613495c69c62$export$7142fb39be536070)
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $66a2c9a2e00e09e7$export$2e2bcd8739ae039), {
                        children: disputeDetails?.description ?? (0, $203b613495c69c62$export$7142fb39be536070)
                    })
                ]
            }),
            disputeDetails?.frontendUrl && /*#__PURE__*/ (0, $cZGFG.jsx)("a", {
                href: disputeDetails?.frontendUrl,
                target: "_blank",
                rel: "noreferrer",
                children: "Go to arbitrable"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$VotingOptions, {
                children: [
                    disputeDetails && /*#__PURE__*/ (0, $cZGFG.jsx)("h3", {
                        children: "Voting Options"
                    }),
                    disputeDetails?.answers?.map((answer, i)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $cZGFG.jsxs)("small", {
                                    children: [
                                        "Option ",
                                        i + 1,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cZGFG.jsxs)("label", {
                                    children: [
                                        answer.title,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cZGFG.jsx)("label", {
                                    children: answer.description
                                })
                            ]
                        }, answer.id))
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$ShadeArea, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("p", {
                        children: "Make sure you read and understand the Policies"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($1f7b26a96cfbff44$var$LinkContainer, {
                        children: disputeDetails?.policyURI && /*#__PURE__*/ (0, $cZGFG.jsxs)($1f7b26a96cfbff44$var$StyledA, {
                            href: (0, $862ad37af5a70e26$export$99de037bb933f932)(disputeDetails?.policyURI),
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9b3ea26762e25e53$export$2e2bcd8739ae039), {}),
                                "Dispute Policy"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $1f7b26a96cfbff44$export$2e2bcd8739ae039 = $1f7b26a96cfbff44$var$DisputeTemplateView;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $54569a2982a56f82$var$SvgHeroDarkmodeDesktop = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 1440 184",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#hero-darkmode-desktop_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                        clipPath: "url(#hero-darkmode-desktop_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M1440 0H0v185h1440V0Z",
                                fill: "#fff"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "m614.293 20.39 259.974 11.635 105.254 234.154-148.493 214-261.388-16.76-107.16-253.7L614.293 20.39Zm190.596 134.975-188.413 82.419 161.077 124.701 27.336-207.12Zm-21.814-41.3L632.502 49.148l-31.63 136.484 182.203-71.567Zm-38.165 279.8-163.643-117 3.958 158.539 159.685-41.539Zm208.472-128.2-111.514-113.3-29.433 217.87 140.947-104.57Zm-170.105 153.68-138.011 36.12 162.3 10.406-24.289-46.526Zm148.313-102.28-120.81 90.11 24.005 46.972 96.805-137.082ZM874.446 64.741l-23.465 48.23 87.34 88.892-63.875-137.122Zm-29.235-23.076-153.37-6.233 126.512 55.401 26.858-49.168Zm-253.315 22.3L484.47 199.783l71.823 15.232 35.603-151.05Zm-39.934 177.693-72.169-15.3 75.3 177.625-3.131-162.325Z",
                                fill: "#fff",
                                style: {
                                    mixBlendMode: "screen"
                                },
                                opacity: 0.085
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M1440 57.936H0v127h1440v-127Z",
                                fill: "url(#hero-darkmode-desktop_svg__c)"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M1440 0H0v185h1440V0Z",
                                fill: "url(#hero-darkmode-desktop_svg__d)"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "m614.293 11.39 259.974 11.635L979.521 257.18l-148.493 214-261.388-16.76-107.16-253.7L614.293 11.39Zm190.596 134.975-188.413 82.419 161.077 124.701 27.336-207.12Zm-21.814-41.3L632.502 40.148l-31.63 136.484 182.203-71.567Zm-38.165 279.8-163.643-117 3.958 158.539 159.685-41.539Zm208.472-128.2-111.514-113.3-29.433 217.87 140.947-104.57Zm-170.105 153.68-138.011 36.12 162.3 10.406-24.289-46.526Zm148.313-102.28-120.81 90.11 24.005 46.972 96.805-137.082ZM874.446 55.741l-23.465 48.23 87.34 88.892-63.875-137.122Zm-29.235-23.076-153.37-6.233 126.512 55.401 26.858-49.168Zm-253.315 22.3L484.47 190.783l71.823 15.232 35.603-151.05Zm-39.934 177.693-72.169-15.3 75.3 177.625-3.131-162.325Z",
                                fill: "#fff",
                                style: {
                                    mixBlendMode: "screen"
                                },
                                opacity: 0.085
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M798.441 153.754s4.77 7.523 13.186 8.983c8.416 1.46 4.064 9.382 4.064 9.382l-19.447-5.043-.584-13.322h2.783-.002Z",
                                fill: "#8C20FA"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1383.6 100.527v1.37h-.59v1.243h-4.11l-.32.518h-.39a5.828 5.828 0 0 1-.08-.589v-1.044a4.584 4.584 0 0 1-.58-.063 5.654 5.654 0 0 0-.46-.065v-.781h-1.3v.781h-4.76v.455h-.97l-.2-.518a5.951 5.951 0 0 0-.72-.463 2.932 2.932 0 0 0-.53 0s.22 1.115 0 1.115h-4.62v1.761h-1.25v.326h-.26l.06.389.72.2v18.005h-2.15v-.058h-1.57v-14.427l.4-.389.19-.389-1.1-.654-.27-.979s-.1-.326-.32-.326h-6.65v1.7h-1.44l.78.781v14.421h-2.28v1.433h-7.7c-.07 0-.07.071-.07.126v3.918c0 .063 0 .128.07.128h15.52v.326h51.02v-5.28h-21.27c-.04-.71 0-3.782 0-3.782h-.39l.33-1.37-.06-7.836-.27-3.258.13-1.3.39-1.044s-.39-.112-.39-.463c.02-.285.06-.568.14-.844 0 0-.14-.677-.14-.852 0-.175-.52-.715-.52-.715s.3-.3.13-.518c-.13-.31-.2-.644-.2-.981l-1.95-.008Zm-3.65 4.636h3.13v16.572l-.27.781h-2.86c0-1.1.03-2.214 0-2.35-.08-.3-.47-12.725-.47-12.725l.27-1.044.26-.518-.06-.716Zm-5.68.192h1.57v17.161h-2.61v-15.267l.18-.652.14-.589.13-.518.59-.135Zm-7.11.263h1.5v16.9h-1.7v-15.014l.2-.907.45-.463-.45-.516Zm-13.25 2.412h3.2v.652c.18.461.31.943.39 1.435-.06.222 0 12.725 0 12.725h-4.24c-.22-.391 0-12.988 0-12.988l.2-.781-.2-.392.13-.524.52-.127Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M1408.52 104.966c0-.609-3.72-1.187.3-3.436.13.327 1.15-.327 1.36-.349.55-.067.72-.165.66-.436-.02-.165.01-.3.12-.349a.221.221 0 0 0 .1-.114c.02-.048.02-.1 0-.149-.05-.12-.01-.176.09-.176.12 0 .15-.162.14-.774 0-.425-.03-.721-.05-.643-.05.087-.11.1-.25.02-.1-.053-.21-.075-.24-.042-.03.033-.16-.067-.28-.218-.12-.151-.26-.274-.31-.274-.16 0-.24-.263-.24-.676 0-.173-.04-.343-.11-.5-.07-.1-.06-.185.03-.229.1-.064.1-.087-.01-.087-.14-.759-.1-1.538.1-2.282.06-.216.08-.442.05-.665a.164.164 0 0 1-.01-.12c.01-.039.03-.074.07-.098.08-.252.11-.52.08-.785-.02-.3-.01-.604.05-.9.12-.282.2-.579.24-.883.02-.173.04-.774.05-1.333 0-.424.03-.848.11-1.265.1-.62.15-1.249.14-1.877.09-2.835.18-4.919.23-5.358.09-.8.09-.86 0-1.112-.05-.142-.04-.229.01-.2.06.029.1-.263.11-.656.01-.393.05-1.145.08-1.679s.11-1.877.16-3c.11-1.967.27-2.816.53-2.9.06-.034.12.053.12.173.01.139.07.27.16.372.22.621.32 1.282.27 1.941 0 .12.06.5.11.852.09.53.14 1.064.17 1.6.03.533.06 1.112.08 1.288.02.176.08.6.1.95.1 1.145.2 1.724.33 1.8.09.067.09.109 0 .165a.355.355 0 0 0-.08.136.412.412 0 0 0 0 .157c.02.12.07.721.09 1.333.04 1.212.07 1.374.2 1.581.05.078.03.131-.02.131-.06 0-.09.394-.08.939.05 1.374.05 1.344.22 1.265.18-.079.21.056.05.229-.13.131-.04.567.12.567.06 0 .03.112-.06.24-.13.2-.15.5-.12 1.464-.01.43.04.86.14 1.277.06.098.08.215.06.327-.11.639-.11 1.29-.02 1.93.05 0 .07.067.04.154-.02.321 0 .644.06.961.2 1.266.2 1.363.04 1.746-.08.184-.1.349-.06.349.11 0 .07.721-.07 1.33-.27 1.148-.37 1.453-.44 1.453-.03 0-.14.12-.22.263a.96.96 0 0 1-.55.391c-.41.12-.41.131-.41.687 0 .48.05.581.28.732.16.111.29.266.37.447.08.229.13.24.3.131.3-.184.8.045.73.338-.04.131-.01.187.09.142.04-.01.08-.009.12.005.03.013.07.037.09.07.06.1.1.089.17-.008.06-.12.13-.12.35 0 .41.184.25.053.84.293-.06.165.15.285.31.176.22-.12.74-.154.74-.033 0 .064.05.087.11.042a.18.18 0 0 0 .06-.099.163.163 0 0 0-.01-.119c-.02-.076-.01-.14.04-.14.06 0 .13.087.17.2.04.162.12.184.34.131.29-.078.29-.089.32-1.212.06-.4.04-.809-.06-1.2-.07-.042-.12-.031-.12.022 0 .218-.78-.011-1.12-.327-.6-.578-.66-1.78-.22-4.442.11-.397.13-.813.07-1.221-.06-.067-.02-.229.12-.469.29-.687.4-1.433.33-2.173 0-.351.05-.7.15-1.036.11-.335.13-.69.07-1.036-.05-.567-.04-.861.06-.97.12-.39.15-.797.11-1.2-.02-1.331.05-2.662.2-3.984.07-.211.09-.434.07-.654-.01-.262.05-1.343.13-2.4s.17-2.335.2-2.835c.01-.747.11-1.49.29-2.215.16-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.981.02.484.08.966.18 1.441.08.38.13.767.15 1.156-.03.306-.02.615.04.916.04.229.08.567.09.743.01.15.04.296.09.436.06.236.09.478.09.721.01.319.05.636.12.947a.84.84 0 0 1 .04.416c-.01.014-.01.029-.01.044v.046c.01.014.02.027.03.038.01.011.02.02.04.026.02.027.04.063.05.102.01.039.01.08-.01.116-.02.242-.01.486.05.721.09.38.09.567.01.6a.134.134 0 0 0-.03.025c-.01.01-.02.023-.02.036 0 .014-.01.028 0 .042 0 .014 0 .028.01.04.15.931.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.19.131.19.142-.03.318-.22.176-.21.26-.14 1.386.01.466.07.93.17 1.386a.4.4 0 0 1 .05.186c0 .065-.02.13-.05.186-.08.487-.08.984-.01 1.472.04.206.06.414.07.623-.01.266.04.53.15.774.09.1.11.371.05.818-.03.372-.06.763-.06.883 0 .765-.01.972-.11 1.081-.09.2-.15.414-.18.634a1.9 1.9 0 0 1-.43.927c-.22.265-.52.465-.84.579-.33.064-.36.109-.39.458a6.8 6.8 0 0 0 .08 1.352c.02.12.04.383.05.589.02.206.05.3.07.24.09-.207.34-.165.41.075.05.12.15.218.22.218.23 0 .2.21-.03.221-.14.008-.13.031.05.109.14.042.24.162.24.24 0 .349 2.05.6 2.25.282.06-.087.1-.1.15-.011.18-.511 1.05-1.43.89-.414.13.142.28.053.23.338l-.02.162.29.3c.3.293.6.3.6 0 0-.043.02-.084.05-.115a.166.166 0 0 1 .12-.05c.1 0 .14-.042.1-.1-.03-.058 0-.109.07-.109.06-.013.12-.04.16-.078a.426.426 0 0 0 .12-.14.47.47 0 0 1 .14-.144.428.428 0 0 1 .19-.063c.24 0 .35-.589.37-2.084l.01-.972-.53-.056c-.48-.042-1.11-.358-1.11-.556 0-.042-.08-.075-.16-.075-.21 0-.46-.405-.6-.972a3.36 3.36 0 0 0-.26-.687c-.2-.384-.26-.83-.16-1.254.08-.142.06-.3-.06-.534a1.73 1.73 0 0 1-.16-.743c0-.257.05-.51.16-.743.15-.249.22-.533.2-.819 0-.263.04-.524.12-.774.08-.288.12-.585.12-.883.03-.612-.01-.777-.18-.95-.11-.109-.15-.2-.1-.2.2 0 .32-.425.38-1.352.11-1.539.1-1.7-.19-1.964-.22-.207-.22-.218-.03-.36.12-.103.2-.24.24-.394a.609.609 0 0 1 .12-.316c.18-.318.27-.683.24-1.048-.04-.011-.04-.24 0-.48.05-.355.06-.714.02-1.07-.04-.458-.02-.609.08-.609s.12-.131.07-.469c-.04-.3-.02-.514.07-.589.1-.1.09-.154-.03-.229-.12-.075-.13-.142-.04-.3a.33.33 0 0 0 .07-.188.42.42 0 0 0-.05-.192c-.06-.112-.06-.176 0-.176.15 0 .22-.567.1-.721-.07-.1-.07-.143.03-.143.07 0 .11-.086.07-.207-.03-.121-.02-.218.02-.218.1 0 .21-.447.29-1.123.02-.36.08-.717.15-1.07.14-.422.21-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.168.09-.26a.634.634 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.08-.39.13-.783.15-1.179.06-.9.13-1.176.35-1.176.09 0 .19-.142.22-.318.09-.425.42-.436.51-.031.05.164.12.32.22.458.15.173.23.74.31 2.246.03.5.08 1 .16 1.494.08.374.12.755.12 1.137.01.413.04.824.11 1.232.08.585.12 1.176.12 1.768-.03.42 0 .842.09 1.254.1.414.15.839.15 1.265.04.656.11 1.637.14 2.162.03.525.06 1.265.05 1.626-.03.318.01.638.12.939.12.354.14.734.06 1.1-.06.7-.05.852.12 1.092.23.532.29 1.12.19 1.69a.507.507 0 0 0-.03.173.48.48 0 0 0 .06.165c.08.243.12.497.13.754.01.293.07.534.11.534.04 0 .08.067.08.154.05.157.14.3.26.413.15.176.21.3.13.318-.13.461-.13.949.01 1.408.07.153.11.32.12.489.02.221.08.438.16.645.09.206.12.432.09.654-.02.218 0 .427.07.458.15.1.16.492 0 .492-.07 0-.07.067 0 .207.08.129.12.279.12.43a.799.799 0 0 1-.15.422c-.05.07-.09.15-.12.236a.782.782 0 0 0-.02.264c.02.087.01.175-.01.26a.528.528 0 0 1-.12.231.743.743 0 0 1-.2.16.629.629 0 0 1-.26.059c-.16.008-.25.075-.23.151.07.154-.28.36-.62.36-.22.017-.44.054-.65.109l-.41.109.05 1.2a2.84 2.84 0 0 0 .27 1.57c.26.45.28.679.06.863-.25.207-.2.4.11.338a.256.256 0 0 0 .17-.065.33.33 0 0 0 .11-.153c0-.142.01-.154.08-.034.04.047.09.08.15.094.06.014.12.009.17-.016.16-.056.25-.022.3.087.07.184.36.24.36.064 0-.028.01-.055.03-.075.02-.02.05-.032.08-.034.06 0 .11.1.11.218 0 .03 0 .06.01.088.01.028.03.053.05.075a.17.17 0 0 0 .07.05c.03.011.06.017.09.016.1.011.27.022.33.034.69.721 1.45 1.19-.02 1.092-1.2-.159-2.42-.188-3.63-.087-2.16-.011-14.77.064-16.79-.21l-.04.007ZM1308.63 141.922c0-.609-3.72-1.187.3-3.436.13.327 1.14-.327 1.35-.349.56-.067.72-.165.67-.436-.02-.165.01-.3.12-.349.04-.027.08-.067.09-.114.02-.048.02-.1.01-.149-.06-.12-.01-.176.09-.176.12 0 .15-.162.14-.774 0-.425-.04-.721-.06-.643-.04.087-.11.1-.25.02-.1-.053-.21-.075-.24-.042-.03.033-.15-.067-.27-.218-.12-.151-.26-.274-.32-.274-.15 0-.24-.263-.24-.676 0-.173-.03-.343-.11-.5-.06-.1-.05-.185.04-.229.1-.064.1-.087-.02-.087-.13-.759-.1-1.538.1-2.282.07-.216.08-.442.06-.665a.163.163 0 0 1-.01-.119.18.18 0 0 1 .06-.099c.09-.252.12-.52.09-.785-.03-.301-.01-.604.05-.9.12-.282.2-.579.23-.883.02-.173.05-.774.06-1.333a5.97 5.97 0 0 1 .11-1.265c.1-.621.14-1.249.14-1.877.09-2.835.17-4.919.23-5.358.09-.8.09-.86 0-1.112-.06-.142-.05-.229.01-.2.06.029.1-.263.11-.656.01-.393.04-1.145.07-1.679.04-.534.11-1.877.17-3 .11-1.967.26-2.816.52-2.9.07-.034.12.053.12.173.02.139.07.269.17.372.22.621.31 1.282.27 1.941 0 .12.05.5.11.852.08.53.14 1.064.16 1.6.04.533.07 1.112.09 1.288.02.176.08.6.1.95.1 1.145.2 1.724.33 1.8.08.067.08.109 0 .165a.262.262 0 0 0-.08.136.415.415 0 0 0 0 .157c.02.12.06.721.09 1.333.04 1.212.06 1.374.2 1.581.04.078.03.131-.03.131-.05 0-.08.394-.07.939.04 1.374.04 1.344.22 1.265.17-.079.2.056.04.229-.13.131-.03.567.13.567.06 0 .02.112-.06.24-.13.2-.16.5-.12 1.464-.01.43.03.86.14 1.277.06.098.08.215.05.327a6.57 6.57 0 0 0-.02 1.93c.06 0 .08.067.05.154-.03.321-.01.644.05.961.2 1.266.2 1.363.04 1.746-.07.184-.1.349-.05.349.11 0 .06.721-.08 1.33-.27 1.148-.37 1.453-.43 1.453-.04 0-.15.12-.22.263a.953.953 0 0 1-.56.391c-.4.12-.4.131-.4.687 0 .48.04.581.27.732.17.111.29.266.37.447.09.229.13.24.3.131.3-.184.81.045.73.338-.03.131-.01.187.09.142.04-.01.08-.009.12.005.04.013.07.037.1.07.06.1.1.089.16-.008.07-.12.14-.12.35 0 .42.184.25.053.84.293-.05.165.16.285.32.176.22-.12.73-.154.73-.033 0 .064.06.087.11.042a.152.152 0 0 0 .07-.099c.01-.04 0-.082-.02-.119-.02-.076-.01-.14.05-.14.06 0 .13.087.16.2.05.162.12.184.35.131.29-.078.29-.089.32-1.212.06-.4.04-.809-.07-1.2-.06-.042-.12-.031-.12.022 0 .218-.77-.011-1.11-.327-.6-.578-.66-1.78-.23-4.442.11-.397.14-.813.08-1.221-.07-.067-.03-.229.12-.469a4.61 4.61 0 0 0 .32-2.173c0-.351.06-.7.16-1.036.1-.335.12-.691.06-1.036-.04-.567-.03-.861.07-.97.11-.389.15-.797.11-1.2-.02-1.331.04-2.662.2-3.984.06-.211.09-.434.06-.654-.01-.262.06-1.343.14-2.4.07-1.057.17-2.335.2-2.835.01-.747.11-1.49.29-2.215.15-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.981.02.484.08.966.17 1.441.09.38.14.767.16 1.156-.04.306-.02.615.04.916.03.229.08.567.09.743 0 .149.03.296.09.436.05.236.08.478.08.721.01.319.05.636.12.947.06.132.07.276.05.416-.01.014-.02.029-.02.044 0 .015 0 .031.01.045 0 .015.01.028.02.039.01.012.03.02.04.026.03.027.05.063.06.102.01.039 0 .08-.01.116-.03.242-.01.486.05.721.09.38.09.567.01.6a.133.133 0 0 0-.03.025c-.01.01-.02.023-.02.036-.01.014-.01.028-.01.042 0 .014.01.028.02.04.14.931.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.18.131.18.142-.03.318-.22.176-.21.26-.15 1.386.02.466.08.93.18 1.386a.4.4 0 0 1 .05.186.4.4 0 0 1-.05.186c-.08.487-.09.984-.02 1.472.04.206.06.414.07.623 0 .266.05.53.16.774.08.1.1.371.05.818-.04.372-.07.763-.07.883 0 .765-.01.972-.1 1.081-.1.2-.16.414-.18.634a1.99 1.99 0 0 1-.43.927 1.98 1.98 0 0 1-.85.579c-.32.064-.36.109-.38.458-.02.452 0 .905.08 1.352.02.12.04.383.05.589.01.206.05.3.07.24.08-.207.34-.165.41.075.05.12.14.218.22.218.23 0 .2.21-.04.221-.14.008-.12.031.06.109.13.042.24.162.24.24 0 .349 2.05.6 2.25.282.05-.087.1-.1.15-.011.18-.511 1.05-1.43.89-.414.13.142.28.053.23.338l-.03.162.3.3c.3.293.6.3.6 0 0-.043.02-.084.05-.115a.16.16 0 0 1 .11-.05c.1 0 .14-.042.11-.1-.03-.058 0-.109.06-.109a.426.426 0 0 0 .29-.218.379.379 0 0 1 .14-.144.39.39 0 0 1 .19-.063c.24 0 .35-.589.37-2.084l.01-.972-.54-.056c-.47-.042-1.11-.358-1.11-.556 0-.042-.07-.075-.15-.075-.21 0-.46-.405-.6-.972a3.35 3.35 0 0 0-.26-.687c-.21-.384-.27-.83-.17-1.254.09-.142.07-.3-.05-.534a1.738 1.738 0 0 1-.17-.743c0-.257.06-.511.17-.743.14-.249.21-.533.2-.819 0-.263.04-.524.12-.774.08-.288.12-.585.12-.883.02-.612-.01-.777-.19-.95-.11-.109-.15-.2-.1-.2.2 0 .32-.425.39-1.352.1-1.539.1-1.7-.19-1.964-.23-.207-.23-.218-.03-.36a.77.77 0 0 0 .24-.394.608.608 0 0 1 .12-.316c.18-.318.26-.683.24-1.048-.05-.011-.05-.24 0-.48.05-.354.06-.714.02-1.07-.04-.458-.02-.609.08-.609.09 0 .12-.131.07-.469-.04-.3-.02-.514.07-.589.1-.1.08-.154-.04-.229-.12-.075-.13-.142-.03-.3a.319.319 0 0 0 .06-.188.266.266 0 0 0-.05-.192c-.05-.112-.05-.176 0-.176.16 0 .23-.567.11-.721-.07-.1-.07-.143.02-.143.08 0 .11-.086.08-.207-.04-.121-.02-.218.02-.218.1 0 .21-.447.29-1.123.02-.36.07-.717.15-1.07.14-.422.21-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.168.09-.26a.84.84 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.07-.389.12-.783.15-1.179.05-.9.13-1.176.35-1.176.09 0 .18-.142.22-.318.08-.425.41-.436.51-.031.04.164.12.319.22.458.15.173.23.74.3 2.246.03.5.09.999.17 1.494.07.374.11.755.12 1.137 0 .413.04.824.1 1.232.09.585.13 1.176.12 1.768-.02.42.01.842.09 1.254.1.414.15.839.15 1.265.05.656.11 1.637.15 2.162.03.525.05 1.265.04 1.626-.03.318.02.638.12.939.12.354.15.734.07 1.1-.07.7-.06.852.12 1.092.23.532.29 1.121.18 1.69a.34.34 0 0 0-.02.173c0 .058.02.115.05.165.09.243.13.497.13.754.02.293.07.534.11.534.05 0 .08.067.08.154.05.157.14.299.26.413.16.176.21.3.13.318-.12.461-.12.949.01 1.408.08.153.12.319.12.489.03.221.09.438.17.645.09.206.12.432.09.654-.03.218 0 .427.07.458.14.1.15.492 0 .492-.07 0-.07.067 0 .207.08.129.12.279.12.431a.798.798 0 0 1-.15.421c-.06.07-.1.15-.12.236a.59.59 0 0 0-.02.264c.01.086.01.175-.01.26a.872.872 0 0 1-.12.231.652.652 0 0 1-.21.16.581.581 0 0 1-.25.059c-.17.008-.25.075-.23.151.06.154-.29.36-.62.36-.22.017-.44.054-.66.109l-.4.109.04 1.2a3.03 3.03 0 0 0 .27 1.57c.27.45.29.679.07.863-.25.207-.2.4.11.338a.304.304 0 0 0 .17-.065.256.256 0 0 0 .1-.153c0-.142.01-.154.09-.034.04.047.09.08.14.094.06.014.12.009.18-.016.16-.056.25-.022.3.087.07.184.36.24.36.064 0-.028.01-.055.03-.075.02-.02.05-.032.07-.034.07 0 .11.1.11.218 0 .03.01.06.02.088.01.028.02.053.04.075s.05.039.07.05c.03.011.06.017.09.016.11.011.27.022.34.034.69.721 1.44 1.19-.02 1.092a17.05 17.05 0 0 0-3.64-.087c-2.16-.011-14.76.064-16.79-.21l-.03.007Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m1185 168.582 66.59-18.9 68.44-21.077 21.52-5.61h39.09l25.86-22.4h33.5v83.409l-255-15.422ZM666.834 141.229l66.539-2.184 62.4 2.247-21.556 8.661H660.566l6.268-8.724Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m740.105 183.898 151.83 1.038c-.18-1.463-.385-2.95-.65-4.329a63.686 63.686 0 0 1-1.178-11.952v-.181a8.683 8.683 0 0 0-1.08-3.813.215.215 0 0 0 .033-.046c.043-.1.016-.129.054-.206a.632.632 0 0 0 .054-.351c0-.234-.367-.452-.362-.831.005-.379.585 1.1.634.591a3.52 3.52 0 0 0-.9-1.762c-.113-.011-.048.254-.027.335.021.081-.013.134-.07.131-.057-.003-.143-.112-.132-.22.011-.108.051-.232.016-.27-.035-.038-.024-.154-.051-.254-.027-.1-.081.017-.142-.072-.061-.089-.019-.315 0-.418.019-.103-.021-.055-.07-.045-.049.01-.016-.064-.1-.047s-.06.337-.052.432c.008.095-.016-.005-.078.073s.027.116-.038.287c-.065.171.069.364.065.5a.153.153 0 0 1-.069.122 20.104 20.104 0 0 0-1.658-2.08 17.268 17.268 0 0 0-1.5-1.362.14.14 0 0 1-.036-.044.139.139 0 0 1-.013-.056v-4.642c0-3.59-.524-5.055-.972-5.22-.255-.093-.381-.371-.5-.64-.16-.358-.312-.7-.74-.7a8.282 8.282 0 0 0-1.323.139 7.058 7.058 0 0 1-1.075.119c-.03 0-3.072-.082-3.273-.781a1.077 1.077 0 0 0-.854-.725c-.049 0-.123.005-.217.008a13.06 13.06 0 0 1-.639.018 3.598 3.598 0 0 1-1.569-.253 61.532 61.532 0 0 0-7.546-1.633 10.173 10.173 0 0 1-1.6-.333 4.75 4.75 0 0 0-1.414-.23c-.483.02-.946.203-1.313.518-.26.23-.586.372-.932.407-.17.005-.339.02-.507.047-.208.032-.419.05-.63.054a2.53 2.53 0 0 1-1.505-.518c-.642-.451-.691-.606-.654-.877a.846.846 0 0 0-.187-.634 4.038 4.038 0 0 1-.258-.508c-.185-.428-.393.33-2.257 0l-.331-.06v-.467h-1.816v-.874h-.842l-45.657-.182-10.915.224v-.017h-1.817v.873h-1.309a2.636 2.636 0 0 1-.248.012c-.1 0-.2-.005-.3-.008-.1-.003-.182-.01-.271-.01-.121 0-.256.005-.4.008-.162.005-.332.01-.5.01-.681 0-.994-.09-1.077-.312-.128-.333-3.633-.046-3.613-.637a.136.136 0 0 1 .034-.085.742.742 0 0 0 .108-.147h-1.66c-.1 0-.224-.008-.372-.018a7.967 7.967 0 0 0-.571-.026c-.43 0-.593.072-.652.134-.312.328-.93.328-1.584.328a5.495 5.495 0 0 1-.7-.07 7.125 7.125 0 0 0-.945-.088 1.586 1.586 0 0 0-.743.144.853.853 0 0 1-.411.1 2.154 2.154 0 0 1-.762-.206 3.955 3.955 0 0 0-1.567-.346c-.477.002-.953.031-1.427.085-.217.021-.386.039-.521.039-.1 0-.347 0-.423-.206a1.09 1.09 0 0 0-1.038-.555 1.929 1.929 0 0 0-.339.034c-.438.085-.509.351-.581.632-.062.229-.128.487-.423.549a.733.733 0 0 1-.175.018 2.131 2.131 0 0 1-.536-.1 3.316 3.316 0 0 0-.885-.139 2.847 2.847 0 0 0-.617.07 7.116 7.116 0 0 1-.974.139c-.558.051-.649.08-.649.359a2.159 2.159 0 0 1-.111.642c-.081.268-.071.286.037.335.391.181 3.932.61 3.854 1.761a.128.128 0 0 1-.038.084.128.128 0 0 1-.085.035h-8.466c-4.156 0-6.353.728-6.353 2.1 0 .867-.745.867-1.1.867-.135 0-.278-.008-.43-.013-.152-.005-.317-.013-.479-.013a1.635 1.635 0 0 0-.98.155 1.633 1.633 0 0 0-.707.696 6.676 6.676 0 0 0-.017 3.051c.285 2.334.6 4.978-1.695 5.782-3.276 1.145-4.764 5.855-4.838 6.1-.054.39-1.434 10.453-3.035 15.655a20.077 20.077 0 0 1-2.593 4.826",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m636.105 183.898 151.83 1.038c-.18-1.463-.385-2.95-.65-4.329a63.686 63.686 0 0 1-1.178-11.952v-.181a8.683 8.683 0 0 0-1.08-3.813.215.215 0 0 0 .033-.046c.043-.1.016-.129.054-.206a.632.632 0 0 0 .054-.351c0-.234-.367-.452-.362-.831.005-.379.585 1.1.634.591a3.52 3.52 0 0 0-.9-1.762c-.113-.011-.048.254-.027.335.021.081-.013.134-.07.131-.057-.003-.143-.112-.132-.22.011-.108.051-.232.016-.27-.035-.038-.024-.154-.051-.254-.027-.1-.081.017-.142-.072-.061-.089-.019-.315 0-.418.019-.103-.021-.055-.07-.045-.049.01-.016-.064-.1-.047s-.06.337-.052.432c.008.095-.016-.005-.078.073s.027.116-.038.287c-.065.171.069.364.065.5a.153.153 0 0 1-.069.122 20.104 20.104 0 0 0-1.658-2.08 17.268 17.268 0 0 0-1.5-1.362.14.14 0 0 1-.036-.044.139.139 0 0 1-.013-.056v-4.642c0-3.59-.524-5.055-.972-5.22-.255-.093-.381-.371-.5-.64-.16-.358-.312-.7-.74-.7a8.282 8.282 0 0 0-1.323.139 7.058 7.058 0 0 1-1.075.119c-.03 0-3.072-.082-3.273-.781a1.077 1.077 0 0 0-.854-.725c-.049 0-.123.005-.217.008a13.06 13.06 0 0 1-.639.018 3.598 3.598 0 0 1-1.569-.253 61.532 61.532 0 0 0-7.546-1.633 10.173 10.173 0 0 1-1.6-.333 4.75 4.75 0 0 0-1.414-.23c-.483.02-.946.203-1.313.518-.26.23-.586.372-.932.407-.17.005-.339.02-.507.047-.208.032-.419.05-.63.054a2.53 2.53 0 0 1-1.505-.518c-.642-.451-.691-.606-.654-.877a.846.846 0 0 0-.187-.634 4.038 4.038 0 0 1-.258-.508c-.185-.428-.224-.518-2.088-.848l-.331-.06v-.467h-1.816v-.874h-.842c-59.941 3.468-80.96 4.315-89.489 4.315-4.156 0-6.353.728-6.353 2.1 0 .867-.745.867-1.1.867-.135 0-.278-.008-.43-.013-.152-.005-.317-.013-.479-.013a1.628 1.628 0 0 0-1.687.851 6.676 6.676 0 0 0-.017 3.051c.285 2.334.6 4.978-1.695 5.782-3.276 1.145-4.764 5.855-4.838 6.1-.054.39-1.434 10.453-3.035 15.655a20.077 20.077 0 0 1-2.593 4.826",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m699.894 183.898-151.83 1.038c.18-1.463.385-2.95.65-4.329a63.603 63.603 0 0 0 1.178-11.952v-.181a8.688 8.688 0 0 1 1.08-3.812.215.215 0 0 1-.033-.046c-.043-.1-.016-.129-.054-.206a.632.632 0 0 1-.054-.351c0-.234.367-.452.362-.831-.005-.379-.585 1.1-.634.591a3.528 3.528 0 0 1 .9-1.762c.113-.011.048.254.027.335-.021.081.013.134.07.131.057-.003.143-.112.132-.22-.011-.108-.051-.232-.016-.27.035-.038.024-.154.051-.254.027-.1.081.017.142-.072.061-.089.019-.315 0-.418-.019-.103.021-.055.07-.045.049.01.016-.064.1-.047s.06.337.052.432c-.008.095.016-.005.078.073s-.027.116.038.287c.065.171-.069.364-.065.5a.167.167 0 0 0 .02.069.165.165 0 0 0 .049.053 20.104 20.104 0 0 1 1.658-2.08c.473-.483.974-.938 1.5-1.362a.127.127 0 0 0 .049-.1v-4.642c0-3.59.524-5.055.972-5.22.255-.093.381-.371.5-.64.16-.358.313-.7.74-.7a8.27 8.27 0 0 1 1.323.139c.355.067.715.107 1.075.119.03 0 3.072-.082 3.273-.781a1.085 1.085 0 0 1 .854-.725c.049 0 .123.005.217.008.165.008.391.018.639.018a3.594 3.594 0 0 0 1.569-.253 61.532 61.532 0 0 1 7.546-1.633 10.126 10.126 0 0 0 1.6-.333 4.75 4.75 0 0 1 1.414-.23c.484.02.946.203 1.313.518.261.23.587.372.932.407.17.005.34.021.507.047.209.032.419.05.63.054a2.525 2.525 0 0 0 1.505-.518c.642-.451.691-.606.654-.877a.867.867 0 0 1 .187-.634c.099-.163.185-.333.258-.508.185-.428.224-.518 2.088-.848l.331-.06v-.467h1.816v-.874h.842l25.748.19h.842v.874h1.817v.873h1.3v1.713c.085.008.167.012.248.012.1 0 .2-.005.3-.008.1-.003.182-.01.271-.01.121 0 .256.005.4.008.162.005.332.01.5.01.681 0 .994-.09 1.077-.312v-.6l-.011-.351-.01-.343a.136.136 0 0 0-.034-.085.784.784 0 0 1-.108-.147c29.046-.114 38.1-1.028 46.632-1.028 4.156 0 16.877 4.252 16.877 5.629 0 .867.745.867 1.1.867.135 0 .278-.008.43-.013.152-.005.317-.013.479-.013a1.622 1.622 0 0 1 1.687.851 6.676 6.676 0 0 1 .017 3.051c-.285 2.334-.6 4.978 1.695 5.782 3.276 1.145 4.764 5.855 4.838 6.1.054.39 1.434 10.453 3.035 15.655a20.112 20.112 0 0 0 2.593 4.826M945.83 184.325l-151.83.614c.171-.864.388-1.719.65-2.56a22.956 22.956 0 0 0 1.178-7.068v-.107a3.733 3.733 0 0 1 1.08-2.254.126.126 0 0 1-.033-.028c-.043-.056-.016-.076-.054-.122s-.054-.069-.054-.208c0-.139.367-.267.362-.492-.005-.225-.585.652-.634.35-.049-.302.788-1.036.9-1.042.112-.006.048.15.027.2-.021.05.013.079.07.078.057-.001.143-.066.132-.13-.011-.064-.051-.137-.016-.16.035-.023.024-.091.051-.15.027-.059.081.01.142-.043.061-.053.019-.187 0-.248s.021-.033.07-.026c.049.007.016-.038.1-.028.084.01.06.2.052.255-.008.055.016 0 .078.043s-.027.068.038.17c.065.102-.069.215-.065.295 0 .033.031.054.069.072a16.05 16.05 0 0 1 1.658-1.23c.664-.41 1.5-.8 1.5-.805.032-.015.049-.036.049-.061v-2.745c0-2.123.524-2.989.972-3.087a.835.835 0 0 0 .5-.378.81.81 0 0 1 .74-.412c.448 0 .893.041 1.323.082.384.037.748.07 1.075.07.03 0 3.072-.049 3.273-.462a1.116 1.116 0 0 1 .854-.428h.217c.165 0 .391.011.639.011a5.874 5.874 0 0 0 1.569-.149c.659-.2 6.035-.853 7.546-.966.723-.053 1.19-.13 1.6-.2a7.795 7.795 0 0 1 1.414-.136c.455.005.903.11 1.313.307.291.144.608.226.932.241.162 0 .329.014.507.028.2.015.4.032.63.032a3.783 3.783 0 0 0 1.505-.306c.642-.267.691-.358.654-.519-.015-.072-.034-.162.187-.375.095-.092.181-.192.258-.3.185-.253.224-.306 2.088-.5l.331-.035v-.276h1.816v-.517h57.584v.517h1.817v.516h1.3v1.013c.085 0 .167.007.248.007h.3c.1 0 .182-.006.271-.006h.4c.162 0 .332.006.5.006.681 0 .994-.053 1.077-.185a11.88 11.88 0 0 0 .01-2.294.066.066 0 0 0-.034-.05.535.535 0 0 1-.108-.087h1.66c.1 0 .224 0 .372-.01.177-.008.379-.015.571-.015.22-.023.443.004.652.079a3.6 3.6 0 0 0 1.584.194c.194 0 .438-.02.7-.041.3-.024.635-.052.945-.052.25-.008.501.02.743.085.133.042.272.062.411.061.258-.011.513-.052.762-.122a6.322 6.322 0 0 1 1.567-.2c.6 0 1.08.029 1.427.05.217.012.386.023.521.023.1 0 .347 0 .423-.122a1.318 1.318 0 0 1 1.038-.328c.113.001.226.008.339.02.438.051.509.208.581.374a.456.456 0 0 0 .423.325c.058.008.116.011.175.011.18-.005.359-.025.536-.058.292-.052.588-.08.885-.083.206 0 .412.014.617.041.394.052.713.069.974.082.558.031.649.047.649.212a.821.821 0 0 0 .111.38c.081.159.071.169-.037.2-.391.107-.317 1.264-.238 1.945 0 .04.059.07.123.07h8.466c4.156 0 6.353.43 6.353 1.245 0 .512.745.512 1.1.512.135 0 .278 0 .43-.008.152-.008.317-.008.479-.008a2.107 2.107 0 0 1 1.687.5c.307.381.167 1.072.017 1.8-.285 1.38-.6 2.943 1.695 3.419a7.473 7.473 0 0 1 4.838 3.606 50.984 50.984 0 0 0 3.035 9.258 12.107 12.107 0 0 0 2.593 2.854M501.83 184.325l-151.83.614c.171-.864.388-1.719.65-2.56a22.956 22.956 0 0 0 1.178-7.068v-.107a3.733 3.733 0 0 1 1.08-2.254.126.126 0 0 1-.033-.028c-.043-.056-.016-.076-.054-.122s-.054-.069-.054-.208c0-.139.367-.267.362-.492-.005-.225-.585.652-.634.35-.049-.302.788-1.036.9-1.042.112-.006.048.15.027.2-.021.05.013.079.07.078.057-.001.143-.066.132-.13-.011-.064-.051-.137-.016-.16.035-.023.024-.091.051-.15.027-.059.081.01.142-.043.061-.053.019-.187 0-.248s.021-.033.07-.026c.049.007.016-.038.1-.028.084.01.06.2.052.255-.008.055.016 0 .078.043s-.027.068.038.17c.065.102-.069.215-.065.295 0 .033.031.054.069.072a16.05 16.05 0 0 1 1.658-1.23c.664-.41 1.5-.8 1.5-.805.032-.015.049-.036.049-.061v-2.745c0-2.123.524-2.989.972-3.087a.835.835 0 0 0 .5-.378.81.81 0 0 1 .74-.412c.448 0 .893.041 1.323.082.384.037.748.07 1.075.07.03 0 3.072-.049 3.273-.462a1.116 1.116 0 0 1 .854-.428h.217c.165 0 .391.011.639.011a5.874 5.874 0 0 0 1.569-.149c.659-.2 6.035-.853 7.546-.966.723-.053 1.19-.13 1.6-.2a7.795 7.795 0 0 1 1.414-.136c.455.005.903.11 1.313.307.291.144.608.226.932.241.162 0 .329.014.507.028.2.015.4.032.63.032a3.783 3.783 0 0 0 1.505-.306c.642-.267.691-.358.654-.519-.015-.072-.034-.162.187-.375.095-.092.181-.192.258-.3.185-.253.224-.306 2.088-.5l.331-.035v-.276h1.816v-.517h57.584v.517h1.817v.516h1.3v1.013c.085 0 .167.007.248.007h.3c.1 0 .182-.006.271-.006h.4c.162 0 .332.006.5.006.681 0 .994-.053 1.077-.185a11.88 11.88 0 0 0 .01-2.294.066.066 0 0 0-.034-.05.535.535 0 0 1-.108-.087h1.66c.1 0 .224 0 .372-.01.177-.008.379-.015.571-.015.22-.023.443.004.652.079a3.6 3.6 0 0 0 1.584.194c.194 0 .438-.02.7-.041.3-.024.635-.052.945-.052.25-.008.501.02.743.085.133.042.272.062.411.061.258-.011.513-.052.762-.122a6.322 6.322 0 0 1 1.567-.2c.6 0 1.08.029 1.427.05.217.012.386.023.521.023.1 0 .347 0 .423-.122a1.318 1.318 0 0 1 1.038-.328c.113.001.226.008.339.02.438.051.509.208.581.374a.456.456 0 0 0 .423.325c.058.008.116.011.175.011.18-.005.359-.025.536-.058.292-.052.588-.08.885-.083.206 0 .412.014.617.041.394.052.713.069.974.082.558.031.649.047.649.212a.821.821 0 0 0 .111.38c.081.159.071.169-.037.2-.391.107-.317 1.264-.238 1.945 0 .04.059.07.123.07h8.466c4.156 0 6.353.43 6.353 1.245 0 .512.745.512 1.1.512.135 0 .278 0 .43-.008.152-.008.317-.008.479-.008a2.107 2.107 0 0 1 1.687.5c.307.381.167 1.072.017 1.8-.285 1.38-.6 2.943 1.695 3.419a7.473 7.473 0 0 1 4.838 3.606 50.984 50.984 0 0 0 3.035 9.258 12.107 12.107 0 0 0 2.593 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m382.83 184.325-151.83.614c.171-.864.388-1.719.65-2.56a22.956 22.956 0 0 0 1.178-7.068v-.107a3.733 3.733 0 0 1 1.08-2.254.126.126 0 0 1-.033-.028c-.043-.056-.016-.076-.054-.122s-.054-.069-.054-.208c0-.139.367-.267.362-.492-.005-.225-.585.652-.634.35-.049-.302.788-1.036.9-1.042.112-.006.048.15.027.2-.021.05.013.079.07.078.057-.001.143-.066.132-.13-.011-.064-.051-.137-.016-.16.035-.023.024-.091.051-.15.027-.059.081.01.142-.043.061-.053.019-.187 0-.248s.021-.033.07-.026c.049.007.016-.038.1-.028.084.01.06.2.052.255-.008.055.016 0 .078.043s-.027.068.038.17c.065.102-.069.215-.065.295 0 .033.031.054.069.072a16.05 16.05 0 0 1 1.658-1.23c.664-.41 1.5-.8 1.5-.805.032-.015.049-.036.049-.061v-2.745c0-2.123.524-2.989.972-3.087a.835.835 0 0 0 .5-.378.81.81 0 0 1 .74-.412c.448 0 .893.041 1.323.082.384.037.748.07 1.075.07.03 0 3.072-.049 3.273-.462a1.116 1.116 0 0 1 .854-.428h.217c.165 0 .391.011.639.011a5.874 5.874 0 0 0 1.569-.149c.659-.2 6.035-.853 7.546-.966.723-.053 1.19-.13 1.6-.2a7.795 7.795 0 0 1 1.414-.136c.455.005.903.11 1.313.307.291.144.608.226.932.241.162 0 .329.014.507.028.2.015.4.032.63.032a3.783 3.783 0 0 0 1.505-.306c.642-.267.691-.358.654-.519-.015-.072-.034-.162.187-.375.095-.092.181-.192.258-.3.185-.253.224-.306 2.088-.5l.331-.035v-.276h1.816v-.517h57.584v.517h1.817v.516h1.3v1.013c.085 0 .167.007.248.007h.3c.1 0 .182-.006.271-.006h.4c.162 0 .332.006.5.006.681 0 .994-.053 1.077-.185a11.88 11.88 0 0 0 .01-2.294.066.066 0 0 0-.034-.05.535.535 0 0 1-.108-.087h1.66c.1 0 .224 0 .372-.01.177-.008.379-.015.571-.015.22-.023.443.004.652.079a3.6 3.6 0 0 0 1.584.194c.194 0 .438-.02.7-.041.3-.024.635-.052.945-.052.25-.008.501.02.743.085.133.042.272.062.411.061.258-.011.513-.052.762-.122a6.322 6.322 0 0 1 1.567-.2c.6 0 1.08.029 1.427.05.217.012.386.023.521.023.1 0 .347 0 .423-.122a1.318 1.318 0 0 1 1.038-.328c.113.001.226.008.339.02.438.051.509.208.581.374a.456.456 0 0 0 .423.325c.058.008.116.011.175.011.18-.005.359-.025.536-.058.292-.052.588-.08.885-.083.206 0 .412.014.617.041.394.052.713.069.974.082.558.031.649.047.649.212a.821.821 0 0 0 .111.38c.081.159.071.169-.037.2-.391.107-.317 1.264-.238 1.945 0 .04.059.07.123.07h8.466c4.156 0 6.353.43 6.353 1.245 0 .512.745.512 1.1.512.135 0 .278 0 .43-.008.152-.008.317-.008.479-.008a2.107 2.107 0 0 1 1.687.5c.307.381.167 1.072.017 1.8-.285 1.38-.6 2.943 1.695 3.419a7.473 7.473 0 0 1 4.838 3.606 50.984 50.984 0 0 0 3.035 9.258 12.107 12.107 0 0 0 2.593 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m262.83 184.325-151.83.614c.171-.864.388-1.719.65-2.56a22.956 22.956 0 0 0 1.178-7.068v-.107a3.733 3.733 0 0 1 1.08-2.254.126.126 0 0 1-.033-.028c-.043-.056-.016-.076-.054-.122s-.054-.069-.054-.208c0-.139.367-.267.362-.492-.005-.225-.585.652-.634.35-.049-.302.788-1.036.9-1.042.112-.006.048.15.027.2-.021.05.013.079.07.078.057-.001.143-.066.132-.13-.011-.064-.051-.137-.016-.16.035-.023.024-.091.051-.15.027-.059.081.01.142-.043.061-.053.019-.187 0-.248s.021-.033.07-.026c.049.007.016-.038.1-.028.084.01.06.2.052.255-.008.055.016 0 .078.043s-.027.068.038.17c.065.102-.069.215-.065.295 0 .033.031.054.069.072a16.05 16.05 0 0 1 1.658-1.23c.664-.41 1.5-.8 1.5-.805.032-.015.049-.036.049-.061v-2.745c0-2.123.524-2.989.972-3.087a.835.835 0 0 0 .5-.378.81.81 0 0 1 .74-.412c.448 0 .893.041 1.323.082.384.037.748.07 1.075.07.03 0 3.072-.049 3.273-.462a1.116 1.116 0 0 1 .854-.428h.217c.165 0 .391.011.639.011a5.874 5.874 0 0 0 1.569-.149c.659-.2 6.035-.853 7.546-.966.723-.053 1.19-.13 1.6-.2a7.795 7.795 0 0 1 1.414-.136c.455.005.903.11 1.313.307.291.144.608.226.932.241.162 0 .329.014.507.028.2.015.4.032.63.032a3.783 3.783 0 0 0 1.505-.306c.642-.267.691-.358.654-.519-.015-.072-.034-.162.187-.375.095-.092.181-.192.258-.3.185-.253.224-.306 2.088-.5l.331-.035v-.276h1.816v-.517h57.584v.517h1.817v.516h1.3v1.013c.085 0 .167.007.248.007h.3c.1 0 .182-.006.271-.006h.4c.162 0 .332.006.5.006.681 0 .994-.053 1.077-.185a11.88 11.88 0 0 0 .01-2.294.066.066 0 0 0-.034-.05.535.535 0 0 1-.108-.087h1.66c.1 0 .224 0 .372-.01.177-.008.379-.015.571-.015.22-.023.443.004.652.079a3.6 3.6 0 0 0 1.584.194c.194 0 .438-.02.7-.041.3-.024.635-.052.945-.052.25-.008.501.02.743.085.133.042.272.062.411.061.258-.011.513-.052.762-.122a6.322 6.322 0 0 1 1.567-.2c.6 0 1.08.029 1.427.05.217.012.386.023.521.023.1 0 .347 0 .423-.122a1.318 1.318 0 0 1 1.038-.328c.113.001.226.008.339.02.438.051.509.208.581.374a.456.456 0 0 0 .423.325c.058.008.116.011.175.011.18-.005.359-.025.536-.058.292-.052.588-.08.885-.083.206 0 .412.014.617.041.394.052.713.069.974.082.558.031.649.047.649.212a.821.821 0 0 0 .111.38c.081.159.071.169-.037.2-.391.107-.317 1.264-.238 1.945 0 .04.059.07.123.07h8.466c4.156 0 6.353.43 6.353 1.245 0 .512.745.512 1.1.512.135 0 .278 0 .43-.008.152-.008.317-.008.479-.008a2.107 2.107 0 0 1 1.687.5c.307.381.167 1.072.017 1.8-.285 1.38-.6 2.943 1.695 3.419a7.473 7.473 0 0 1 4.838 3.606 50.984 50.984 0 0 0 3.035 9.258 12.107 12.107 0 0 0 2.593 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M151.83 184.325 0 184.939c.17-.864.388-1.719.65-2.56a22.936 22.936 0 0 0 1.178-7.068v-.107a3.732 3.732 0 0 1 1.08-2.254.125.125 0 0 1-.033-.028c-.043-.056-.016-.076-.054-.122s-.054-.069-.054-.208c0-.139.367-.267.362-.492-.005-.225-.585.652-.634.35-.05-.302.788-1.036.9-1.042.112-.006.048.15.027.2-.021.05.013.079.07.078.057-.001.143-.066.132-.13-.011-.064-.051-.137-.016-.16.035-.023.024-.091.05-.15.028-.059.082.01.143-.043.06-.053.019-.187 0-.248-.02-.061.02-.033.07-.026.049.007.016-.038.1-.028.084.01.06.2.052.255-.008.055.016 0 .078.043s-.027.068.038.17c.065.102-.069.215-.065.295 0 .033.03.054.069.072.526-.445 1.08-.856 1.658-1.23.664-.41 1.5-.8 1.5-.805.032-.015.049-.036.049-.061v-2.745c0-2.123.524-2.989.972-3.087a.833.833 0 0 0 .5-.378.805.805 0 0 1 .74-.412c.448 0 .893.041 1.323.082.384.037.748.07 1.075.07.03 0 3.072-.049 3.273-.462a1.119 1.119 0 0 1 .854-.428h.217c.165 0 .39.011.639.011a5.874 5.874 0 0 0 1.569-.149c.659-.2 6.035-.853 7.546-.966.723-.053 1.19-.13 1.6-.2a7.8 7.8 0 0 1 1.414-.136c.455.005.903.11 1.313.307.29.144.608.226.932.241.162 0 .329.014.507.028.2.015.4.032.63.032a3.78 3.78 0 0 0 1.505-.306c.642-.267.69-.358.654-.519-.015-.072-.034-.162.187-.375a2.18 2.18 0 0 0 .258-.3c.185-.253.224-.306 2.088-.5l.33-.035v-.276h1.817v-.517h57.584v.517h1.817v.516h1.3v1.013c.085 0 .167.007.248.007h.3c.1 0 .182-.006.271-.006h.4c.162 0 .332.006.5.006.681 0 .994-.053 1.077-.185a11.88 11.88 0 0 0 .01-2.294.066.066 0 0 0-.034-.05.535.535 0 0 1-.108-.087h1.66c.1 0 .224 0 .372-.01.177-.008.379-.015.571-.015.22-.023.443.004.652.079a3.6 3.6 0 0 0 1.584.194c.194 0 .438-.02.7-.041.3-.024.635-.052.945-.052.25-.008.501.02.743.085.133.042.272.062.411.061.258-.011.513-.052.762-.122a6.322 6.322 0 0 1 1.567-.2c.6 0 1.08.029 1.427.05.217.012.386.023.521.023.1 0 .347 0 .423-.122a1.318 1.318 0 0 1 1.038-.328c.113.001.226.008.339.02.438.051.509.208.581.374a.456.456 0 0 0 .423.325c.058.008.116.011.175.011.18-.005.359-.025.536-.058.292-.052.588-.08.885-.083.206 0 .412.014.617.041.394.052.713.069.974.082.558.031.649.047.649.212a.821.821 0 0 0 .111.38c.081.159.071.169-.037.2-.391.107-.317 1.264-.238 1.945 0 .04.059.07.123.07h8.466c4.156 0 6.353.43 6.353 1.245 0 .512.745.512 1.1.512.135 0 .278 0 .43-.008.152-.008.317-.008.479-.008a2.107 2.107 0 0 1 1.687.5c.307.381.167 1.072.017 1.8-.285 1.38-.6 2.943 1.695 3.419a7.473 7.473 0 0 1 4.838 3.606 50.984 50.984 0 0 0 3.035 9.258 12.107 12.107 0 0 0 2.593 2.854M918.041 184.325l151.829.614a25.05 25.05 0 0 0-.65-2.56 22.958 22.958 0 0 1-1.18-7.068v-.107a3.722 3.722 0 0 0-1.08-2.254.09.09 0 0 0 .04-.028c.04-.056.01-.076.05-.122s.05-.069.05-.208c0-.139-.36-.267-.36-.492.01-.225.59.652.64.35.04-.302-.79-1.036-.9-1.042-.12-.006-.05.15-.03.2.02.05-.01.079-.07.078-.06-.001-.14-.066-.13-.13.01-.064.05-.137.01-.16-.03-.023-.02-.091-.05-.15-.03-.059-.08.01-.14-.043-.06-.053-.02-.187 0-.248s-.02-.033-.07-.026c-.05.007-.02-.038-.1-.028-.08.01-.06.2-.05.255.01.055-.02 0-.08.043s.03.068-.04.17c-.06.102.07.215.07.295 0 .033-.03.054-.07.072-.53-.445-1.08-.856-1.66-1.23-.66-.41-1.5-.8-1.5-.805-.03-.015-.05-.036-.05-.061v-2.745c0-2.123-.52-2.989-.97-3.087a.83.83 0 0 1-.5-.378.814.814 0 0 0-.74-.412c-.45 0-.89.041-1.32.082-.39.037-.75.07-1.08.07-.03 0-3.07-.049-3.27-.462-.1-.13-.23-.236-.38-.31a1.133 1.133 0 0 0-.48-.118h-.21c-.17 0-.39.011-.64.011a5.854 5.854 0 0 1-1.57-.149c-.66-.2-6.04-.853-7.55-.966-.72-.053-1.19-.13-1.6-.2a7.743 7.743 0 0 0-1.41-.136c-.46.005-.9.11-1.31.307-.29.144-.61.226-.94.241-.16 0-.33.014-.5.028-.2.015-.4.032-.63.032a3.81 3.81 0 0 1-1.51-.306c-.64-.267-.69-.358-.65-.519.01-.072.03-.162-.19-.375a2.916 2.916 0 0 1-.26-.3c-.18-.253-.22-.306-2.09-.5l-.33-.035v-.276h-1.81v-.517h-57.586v.517h-1.817v.516h-1.3v1.013c-.085 0-.167.007-.248.007h-.3c-.1 0-.182-.006-.271-.006h-.4c-.162 0-.332.006-.5.006-.681 0-.994-.053-1.077-.185a11.8 11.8 0 0 1-.01-2.294.066.066 0 0 1 .034-.05.535.535 0 0 0 .108-.087h-1.66c-.1 0-.224 0-.372-.01a12.957 12.957 0 0 0-.571-.015 1.475 1.475 0 0 0-.652.079 3.6 3.6 0 0 1-1.584.194c-.194 0-.438-.02-.7-.041-.3-.024-.635-.052-.945-.052-.25-.008-.501.02-.743.085a1.334 1.334 0 0 1-.411.061 3.337 3.337 0 0 1-.762-.122 6.328 6.328 0 0 0-1.567-.2c-.6 0-1.08.029-1.427.05-.217.012-.386.023-.521.023-.1 0-.347 0-.423-.122a1.318 1.318 0 0 0-1.038-.328 3.484 3.484 0 0 0-.339.02c-.438.051-.509.208-.581.374a.456.456 0 0 1-.423.325 1.285 1.285 0 0 1-.175.011 3.446 3.446 0 0 1-.536-.058 5.357 5.357 0 0 0-.885-.083c-.206 0-.412.014-.617.041-.394.052-.713.069-.974.082-.558.031-.649.047-.649.212a.833.833 0 0 1-.111.38c-.081.159-.071.169.037.2.391.107.317 1.264.238 1.945 0 .04-.059.07-.123.07h-8.466c-4.156 0-6.353.43-6.353 1.245 0 .512-.745.512-1.1.512-.135 0-.278 0-.43-.008-.152-.008-.317-.008-.479-.008a2.097 2.097 0 0 0-.898.066 2.092 2.092 0 0 0-.789.434c-.307.381-.167 1.072-.017 1.8.285 1.38.6 2.943-1.695 3.419a7.473 7.473 0 0 0-4.838 3.606 51.061 51.061 0 0 1-3.035 9.258 12.107 12.107 0 0 1-2.593 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m1034.04 184.325 151.83.614a25.05 25.05 0 0 0-.65-2.56 22.958 22.958 0 0 1-1.18-7.068v-.107a3.722 3.722 0 0 0-1.08-2.254.09.09 0 0 0 .04-.028c.04-.056.01-.076.05-.122s.05-.069.05-.208c0-.139-.36-.267-.36-.492.01-.225.59.652.64.35.04-.302-.79-1.036-.9-1.042-.12-.006-.05.15-.03.2.02.05-.01.079-.07.078-.06-.001-.14-.066-.13-.13.01-.064.05-.137.01-.16-.03-.023-.02-.091-.05-.15-.03-.059-.08.01-.14-.043-.06-.053-.02-.187 0-.248s-.02-.033-.07-.026c-.05.007-.02-.038-.1-.028-.08.01-.06.2-.05.255.01.055-.02 0-.08.043s.03.068-.04.17c-.06.102.07.215.07.295 0 .033-.03.054-.07.072-.53-.445-1.08-.856-1.66-1.23-.66-.41-1.5-.8-1.5-.805-.03-.015-.05-.036-.05-.061v-2.745c0-2.123-.52-2.989-.97-3.087a.83.83 0 0 1-.5-.378.814.814 0 0 0-.74-.412c-.45 0-.89.041-1.32.082-.39.037-.75.07-1.08.07-.03 0-3.07-.049-3.27-.462-.1-.13-.23-.236-.38-.31a1.133 1.133 0 0 0-.48-.118h-.21c-.17 0-.39.011-.64.011a5.854 5.854 0 0 1-1.57-.149c-.66-.2-6.04-.853-7.55-.966-.72-.053-1.19-.13-1.6-.2a7.743 7.743 0 0 0-1.41-.136c-.46.005-.9.11-1.31.307-.29.144-.61.226-.94.241-.16 0-.33.014-.5.028-.2.015-.4.032-.63.032a3.81 3.81 0 0 1-1.51-.306c-.64-.267-.69-.358-.65-.519.01-.072.03-.162-.19-.375a2.916 2.916 0 0 1-.26-.3c-.18-.253-.22-.306-2.09-.5l-.33-.035v-.276h-1.81v-.517h-57.59v.517h-1.81v.516h-1.3v1.013c-.09 0-.17.007-.25.007h-.3c-.1 0-.18-.006-.27-.006h-.4c-.16 0-.33.006-.5.006-.68 0-1-.053-1.08-.185-.08-.762-.08-1.531-.01-2.294 0-.01.01-.02.01-.029.01-.009.02-.016.02-.021a.497.497 0 0 0 .11-.087h-1.66c-.1 0-.22 0-.37-.01a13.12 13.12 0 0 0-.57-.015 1.47 1.47 0 0 0-.65.079c-.51.182-1.05.249-1.59.194-.19 0-.43-.02-.7-.041-.3-.024-.63-.052-.94-.052-.25-.008-.5.02-.74.085-.14.042-.28.062-.42.061a3.4 3.4 0 0 1-.76-.122 6.309 6.309 0 0 0-1.56-.2c-.6 0-1.08.029-1.43.05-.22.012-.39.023-.52.023-.1 0-.35 0-.42-.122a1.42 1.42 0 0 0-.49-.275 1.309 1.309 0 0 0-.55-.053c-.12.001-.23.008-.34.02-.44.051-.51.208-.58.374a.51.51 0 0 1-.16.23.478.478 0 0 1-.27.095 1.12 1.12 0 0 1-.17.011 3.537 3.537 0 0 1-.54-.058c-.29-.052-.59-.08-.88-.083-.21 0-.41.014-.62.041-.39.052-.71.069-.97.082-.56.031-.65.047-.65.212a.994.994 0 0 1-.11.38c-.08.159-.07.169.03.2.39.107.32 1.264.24 1.945 0 .04-.06.07-.12.07h-8.47c-4.15 0-6.35.43-6.35 1.245 0 .512-.75.512-1.1.512-.14 0-.28 0-.43-.008-.15-.008-.32-.008-.48-.008a2.106 2.106 0 0 0-1.69.5c-.3.381-.16 1.072-.01 1.8.28 1.38.6 2.943-1.7 3.419a7.55 7.55 0 0 0-2.8 1.293 7.633 7.633 0 0 0-2.04 2.313 51.045 51.045 0 0 1-3.03 9.258 12.202 12.202 0 0 1-2.59 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m1164.04 184.325 151.83.614a25.05 25.05 0 0 0-.65-2.56 22.958 22.958 0 0 1-1.18-7.068v-.107a3.722 3.722 0 0 0-1.08-2.254.09.09 0 0 0 .04-.028c.04-.056.01-.076.05-.122s.05-.069.05-.208c0-.139-.36-.267-.36-.492.01-.225.59.652.64.35.04-.302-.79-1.036-.9-1.042-.12-.006-.05.15-.03.2.02.05-.01.079-.07.078-.06-.001-.14-.066-.13-.13.01-.064.05-.137.01-.16-.03-.023-.02-.091-.05-.15-.03-.059-.08.01-.14-.043-.06-.053-.02-.187 0-.248s-.02-.033-.07-.026c-.05.007-.02-.038-.1-.028-.08.01-.06.2-.05.255.01.055-.02 0-.08.043s.03.068-.04.17c-.06.102.07.215.07.295 0 .033-.03.054-.07.072-.53-.445-1.08-.856-1.66-1.23-.66-.41-1.5-.8-1.5-.805-.03-.015-.05-.036-.05-.061v-2.745c0-2.123-.52-2.989-.97-3.087a.83.83 0 0 1-.5-.378.814.814 0 0 0-.74-.412c-.45 0-.89.041-1.32.082-.39.037-.75.07-1.08.07-.03 0-3.07-.049-3.27-.462-.1-.13-.23-.236-.38-.31a1.133 1.133 0 0 0-.48-.118h-.21c-.17 0-.39.011-.64.011a5.854 5.854 0 0 1-1.57-.149c-.66-.2-6.04-.853-7.55-.966-.72-.053-1.19-.13-1.6-.2a7.743 7.743 0 0 0-1.41-.136c-.46.005-.9.11-1.31.307-.29.144-.61.226-.94.241-.16 0-.33.014-.5.028-.2.015-.4.032-.63.032a3.81 3.81 0 0 1-1.51-.306c-.64-.267-.69-.358-.65-.519.01-.072.03-.162-.19-.375a2.916 2.916 0 0 1-.26-.3c-.18-.253-.22-.306-2.09-.5l-.33-.035v-.276h-1.81v-.517h-57.59v.517h-1.81v.516h-1.3v1.013c-.09 0-.17.007-.25.007h-.3c-.1 0-.18-.006-.27-.006h-.4c-.16 0-.33.006-.5.006-.68 0-1-.053-1.08-.185-.08-.762-.08-1.531-.01-2.294 0-.01.01-.02.01-.029.01-.009.02-.016.02-.021a.497.497 0 0 0 .11-.087h-1.66c-.1 0-.22 0-.37-.01a13.12 13.12 0 0 0-.57-.015 1.47 1.47 0 0 0-.65.079c-.51.182-1.05.249-1.59.194-.19 0-.43-.02-.7-.041-.3-.024-.63-.052-.94-.052-.25-.008-.5.02-.74.085-.14.042-.28.062-.42.061a3.4 3.4 0 0 1-.76-.122 6.309 6.309 0 0 0-1.56-.2c-.6 0-1.08.029-1.43.05-.22.012-.39.023-.52.023-.1 0-.35 0-.42-.122a1.42 1.42 0 0 0-.49-.275 1.309 1.309 0 0 0-.55-.053c-.12.001-.23.008-.34.02-.44.051-.51.208-.58.374a.51.51 0 0 1-.16.23.478.478 0 0 1-.27.095 1.12 1.12 0 0 1-.17.011 3.537 3.537 0 0 1-.54-.058c-.29-.052-.59-.08-.88-.083-.21 0-.41.014-.62.041-.39.052-.71.069-.97.082-.56.031-.65.047-.65.212a.994.994 0 0 1-.11.38c-.08.159-.07.169.03.2.39.107.32 1.264.24 1.945 0 .04-.06.07-.12.07h-8.47c-4.15 0-6.35.43-6.35 1.245 0 .512-.75.512-1.1.512-.14 0-.28 0-.43-.008-.15-.008-.32-.008-.48-.008a2.106 2.106 0 0 0-1.69.5c-.3.381-.16 1.072-.01 1.8.28 1.38.6 2.943-1.7 3.419a7.55 7.55 0 0 0-2.8 1.293 7.633 7.633 0 0 0-2.04 2.313 51.045 51.045 0 0 1-3.03 9.258 12.202 12.202 0 0 1-2.59 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m1290.04 184.325 151.83.614a25.05 25.05 0 0 0-.65-2.56 22.958 22.958 0 0 1-1.18-7.068v-.107a3.722 3.722 0 0 0-1.08-2.254.09.09 0 0 0 .04-.028c.04-.056.01-.076.05-.122s.05-.069.05-.208c0-.139-.36-.267-.36-.492.01-.225.59.652.64.35.04-.302-.79-1.036-.9-1.042-.12-.006-.05.15-.03.2.02.05-.01.079-.07.078-.06-.001-.14-.066-.13-.13.01-.064.05-.137.01-.16-.03-.023-.02-.091-.05-.15-.03-.059-.08.01-.14-.043-.06-.053-.02-.187 0-.248s-.02-.033-.07-.026c-.05.007-.02-.038-.1-.028-.08.01-.06.2-.05.255.01.055-.02 0-.08.043s.03.068-.04.17c-.06.102.07.215.07.295 0 .033-.03.054-.07.072-.53-.445-1.08-.856-1.66-1.23-.66-.41-1.5-.8-1.5-.805-.03-.015-.05-.036-.05-.061v-2.745c0-2.123-.52-2.989-.97-3.087a.83.83 0 0 1-.5-.378.814.814 0 0 0-.74-.412c-.45 0-.89.041-1.32.082-.39.037-.75.07-1.08.07-.03 0-3.07-.049-3.27-.462-.1-.13-.23-.236-.38-.31a1.133 1.133 0 0 0-.48-.118h-.21c-.17 0-.39.011-.64.011a5.854 5.854 0 0 1-1.57-.149c-.66-.2-6.04-.853-7.55-.966-.72-.053-1.19-.13-1.6-.2a7.743 7.743 0 0 0-1.41-.136c-.46.005-.9.11-1.31.307-.29.144-.61.226-.94.241-.16 0-.33.014-.5.028-.2.015-.4.032-.63.032a3.81 3.81 0 0 1-1.51-.306c-.64-.267-.69-.358-.65-.519.01-.072.03-.162-.19-.375a2.916 2.916 0 0 1-.26-.3c-.18-.253-.22-.306-2.09-.5l-.33-.035v-.276h-1.81v-.517h-57.59v.517h-1.81v.516h-1.3v1.013c-.09 0-.17.007-.25.007h-.3c-.1 0-.18-.006-.27-.006h-.4c-.16 0-.33.006-.5.006-.68 0-1-.053-1.08-.185-.08-.762-.08-1.531-.01-2.294 0-.01.01-.02.01-.029.01-.009.02-.016.02-.021a.497.497 0 0 0 .11-.087h-1.66c-.1 0-.22 0-.37-.01a13.12 13.12 0 0 0-.57-.015 1.47 1.47 0 0 0-.65.079c-.51.182-1.05.249-1.59.194-.19 0-.43-.02-.7-.041-.3-.024-.63-.052-.94-.052-.25-.008-.5.02-.74.085-.14.042-.28.062-.42.061a3.4 3.4 0 0 1-.76-.122 6.309 6.309 0 0 0-1.56-.2c-.6 0-1.08.029-1.43.05-.22.012-.39.023-.52.023-.1 0-.35 0-.42-.122a1.42 1.42 0 0 0-.49-.275 1.309 1.309 0 0 0-.55-.053c-.12.001-.23.008-.34.02-.44.051-.51.208-.58.374a.51.51 0 0 1-.16.23.478.478 0 0 1-.27.095 1.12 1.12 0 0 1-.17.011 3.537 3.537 0 0 1-.54-.058c-.29-.052-.59-.08-.88-.083-.21 0-.41.014-.62.041-.39.052-.71.069-.97.082-.56.031-.65.047-.65.212a.994.994 0 0 1-.11.38c-.08.159-.07.169.03.2.39.107.32 1.264.24 1.945 0 .04-.06.07-.12.07h-8.47c-4.15 0-6.35.43-6.35 1.245 0 .512-.75.512-1.1.512-.14 0-.28 0-.43-.008-.15-.008-.32-.008-.48-.008a2.106 2.106 0 0 0-1.69.5c-.3.381-.16 1.072-.01 1.8.28 1.38.6 2.943-1.7 3.419a7.55 7.55 0 0 0-2.8 1.293 7.633 7.633 0 0 0-2.04 2.313 51.045 51.045 0 0 1-3.03 9.258 12.202 12.202 0 0 1-2.59 2.854",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m1327.04 184.325 151.83.614a25.05 25.05 0 0 0-.65-2.56 22.958 22.958 0 0 1-1.18-7.068v-.107a3.722 3.722 0 0 0-1.08-2.254.09.09 0 0 0 .04-.028c.04-.056.01-.076.05-.122s.05-.069.05-.208c0-.139-.36-.267-.36-.492.01-.225.59.652.64.35.04-.302-.79-1.036-.9-1.042-.12-.006-.05.15-.03.2.02.05-.01.079-.07.078-.06-.001-.14-.066-.13-.13.01-.064.05-.137.01-.16-.03-.023-.02-.091-.05-.15-.03-.059-.08.01-.14-.043-.06-.053-.02-.187 0-.248s-.02-.033-.07-.026c-.05.007-.02-.038-.1-.028-.08.01-.06.2-.05.255.01.055-.02 0-.08.043s.03.068-.04.17c-.06.102.07.215.07.295 0 .033-.03.054-.07.072-.53-.445-1.08-.856-1.66-1.23-.66-.41-1.5-.8-1.5-.805-.03-.015-.05-.036-.05-.061v-2.745c0-2.123-.52-2.989-.97-3.087a.83.83 0 0 1-.5-.378.814.814 0 0 0-.74-.412c-.45 0-.89.041-1.32.082-.39.037-.75.07-1.08.07-.03 0-3.07-.049-3.27-.462-.1-.13-.23-.236-.38-.31a1.133 1.133 0 0 0-.48-.118h-.21c-.17 0-.39.011-.64.011a5.854 5.854 0 0 1-1.57-.149c-.66-.2-6.04-.853-7.55-.966-.72-.053-1.19-.13-1.6-.2a7.743 7.743 0 0 0-1.41-.136c-.46.005-.9.11-1.31.307-.29.144-.61.226-.94.241-.16 0-.33.014-.5.028-.2.015-.4.032-.63.032a3.81 3.81 0 0 1-1.51-.306c-.64-.267-.69-.358-.65-.519.01-.072.03-.162-.19-.375a2.916 2.916 0 0 1-.26-.3c-.18-.253-.22-.306-2.09-.5l-.33-.035v-.276h-1.81v-.517h-57.59v.517h-1.81v.516h-1.3v1.013c-.09 0-.17.007-.25.007h-.3c-.1 0-.18-.006-.27-.006h-.4c-.16 0-.33.006-.5.006-.68 0-1-.053-1.08-.185-.08-.762-.08-1.531-.01-2.294 0-.01.01-.02.01-.029.01-.009.02-.016.02-.021a.497.497 0 0 0 .11-.087h-1.66c-.1 0-.22 0-.37-.01a13.12 13.12 0 0 0-.57-.015 1.47 1.47 0 0 0-.65.079c-.51.182-1.05.249-1.59.194-.19 0-.43-.02-.7-.041-.3-.024-.63-.052-.94-.052-.25-.008-.5.02-.74.085-.14.042-.28.062-.42.061a3.4 3.4 0 0 1-.76-.122 6.309 6.309 0 0 0-1.56-.2c-.6 0-1.08.029-1.43.05-.22.012-.39.023-.52.023-.1 0-.35 0-.42-.122a1.42 1.42 0 0 0-.49-.275 1.309 1.309 0 0 0-.55-.053c-.12.001-.23.008-.34.02-.44.051-.51.208-.58.374a.51.51 0 0 1-.16.23.478.478 0 0 1-.27.095 1.12 1.12 0 0 1-.17.011 3.537 3.537 0 0 1-.54-.058c-.29-.052-.59-.08-.88-.083-.21 0-.41.014-.62.041-.39.052-.71.069-.97.082-.56.031-.65.047-.65.212a.994.994 0 0 1-.11.38c-.08.159-.07.169.03.2.39.107.32 1.264.24 1.945 0 .04-.06.07-.12.07h-8.47c-4.15 0-6.35.43-6.35 1.245 0 .512-.75.512-1.1.512-.14 0-.28 0-.43-.008-.15-.008-.32-.008-.48-.008a2.106 2.106 0 0 0-1.69.5c-.3.381-.16 1.072-.01 1.8.28 1.38.6 2.943-1.7 3.419a7.55 7.55 0 0 0-2.8 1.293 7.633 7.633 0 0 0-2.04 2.313 51.045 51.045 0 0 1-3.03 9.258 12.202 12.202 0 0 1-2.59 2.854M556.641 153.808s-3.887 3.77-12.432 5.094c-8.545 1.324-25.992 0-25.992 0l-7.617 5.582h-17.606l-5.099-4.105-3.6 1.765 8.693 22.857h63.647l.006-31.193ZM254.998 168.646l-66.588-18.9-68.446-21.077-21.517-5.61h-39.09l-25.86-22.4h-33.5v83.409l255.001-15.422Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M56.394 100.655v1.37h.59v1.243h4.11l.325.518h.391c.035-.195.058-.392.071-.589v-1.044a4.36 4.36 0 0 0 .581-.063 5.9 5.9 0 0 1 .463-.065v-.781h1.3v.781h4.762v.455h.972l.2-.518c.227-.172.467-.327.718-.463.175-.016.351-.016.526 0 0 0-.216 1.115 0 1.115h4.626v1.761h1.244v.326h.263l-.065.389-.715.2v18.005h2.15v-.058h1.57V108.81l-.4-.389-.193-.389 1.107-.654.263-.979s.1-.326.326-.326h6.65v1.7h1.441l-.789.781v14.421h2.285v1.433h7.7c.065 0 .065.071.065.126v3.918c0 .063 0 .128-.065.128H83.343v.326h-51.02v-5.28h21.265c.05-.71 0-3.782 0-3.782h.391l-.326-1.37.063-7.836.263-3.258-.129-1.3-.389-1.044s.39-.112.39-.463a4.14 4.14 0 0 0-.136-.844s.135-.677.135-.852c0-.175.518-.715.518-.715s-.3-.3-.126-.518c.132-.31.2-.644.2-.981l1.952-.008Zm3.655 4.636H56.92v16.572l.263.781h2.866c-.008-1.1-.03-2.214 0-2.35.08-.3.463-12.725.463-12.725l-.263-1.044-.263-.518.063-.716Zm5.68.192h-1.57v17.161h2.612v-15.267l-.189-.652-.137-.589-.126-.518-.59-.135Zm7.111.263h-1.5v16.9h1.7v-15.014l-.2-.907-.455-.463.455-.516Zm13.243 2.412h-3.195v.652a6.228 6.228 0 0 0-.39 1.435c.054.222 0 12.725 0 12.725h4.235c.224-.391 0-12.988 0-12.988l-.2-.781.2-.392-.127-.524-.523-.127Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M31.48 105.094c0-.609 3.72-1.187-.3-3.436-.131.327-1.146-.327-1.353-.349-.559-.067-.72-.165-.668-.436.022-.165-.01-.3-.12-.349a.231.231 0 0 1-.1-.263c.056-.12.011-.176-.086-.176-.12 0-.154-.162-.143-.774 0-.425.034-.721.056-.643.042.087.11.1.251.02.1-.053.207-.075.239-.042.03.033.153-.067.273-.218.12-.151.263-.274.316-.274.154 0 .24-.263.24-.676 0-.173.038-.343.11-.5.066-.1.055-.185-.032-.229-.1-.064-.1-.087.011-.087a5.212 5.212 0 0 0-.1-2.282 1.728 1.728 0 0 1-.053-.665.176.176 0 0 0-.056-.218 1.822 1.822 0 0 1-.087-.785 3.17 3.17 0 0 0-.044-.9c-.12-.282-.2-.579-.238-.883a20.781 20.781 0 0 1-.056-1.333 6.474 6.474 0 0 0-.109-1.265 11.903 11.903 0 0 1-.143-1.877c-.086-2.835-.173-4.919-.229-5.358-.087-.8-.087-.86 0-1.112.056-.142.045-.229-.01-.2-.057.029-.1-.263-.11-.656a53.008 53.008 0 0 0-.075-1.679c-.033-.534-.109-1.877-.165-3-.109-1.967-.263-2.816-.522-2.9-.067-.034-.12.053-.12.173a.641.641 0 0 1-.165.372 4.78 4.78 0 0 0-.27 1.941c0 .12-.057.5-.113.852-.082.53-.137 1.064-.162 1.6-.034.533-.067 1.112-.087 1.288-.02.176-.078.6-.1.95-.1 1.145-.2 1.724-.326 1.8-.087.067-.087.109 0 .165a.314.314 0 0 1 .078.293c-.022.12-.068.721-.09 1.333-.043 1.212-.065 1.374-.2 1.581-.046.078-.034.131.022.131s.086.394.075.939c-.042 1.374-.042 1.344-.218 1.265-.176-.079-.207.056-.045.229.131.131.034.567-.128.567-.055 0-.022.112.064.24.131.2.154.5.12 1.464.011.43-.037.86-.143 1.277a.447.447 0 0 0-.053.327c.104.639.11 1.29.02 1.93-.054 0-.076.067-.043.154a3.73 3.73 0 0 1-.056.961c-.2 1.266-.2 1.363-.041 1.746.074.184.1.349.052.349-.109 0-.064.721.078 1.33.271 1.148.37 1.453.436 1.453.034 0 .143.12.218.263a.954.954 0 0 0 .556.391c.405.12.405.131.405.687 0 .48-.045.581-.274.732a1.05 1.05 0 0 0-.37.447c-.087.229-.132.24-.3.131-.3-.184-.808.045-.733.338.034.131.012.187-.087.142a.206.206 0 0 0-.12.005.203.203 0 0 0-.098.07c-.056.1-.1.089-.165-.008-.064-.12-.13-.12-.349 0-.413.184-.25.053-.84.293.055.165-.152.285-.317.176-.218-.12-.732-.154-.732-.033 0 .064-.053.087-.109.042a.172.172 0 0 1-.053-.218c.022-.076.011-.14-.045-.14-.056 0-.13.087-.162.2-.045.162-.12.184-.349.131-.285-.078-.285-.089-.319-1.212-.06-.4-.036-.809.067-1.2.064-.042.12-.031.12.022 0 .218.774-.011 1.112-.327.6-.578.665-1.78.23-4.442a2.888 2.888 0 0 1-.076-1.221c.064-.067.022-.229-.12-.469a4.54 4.54 0 0 1-.327-2.173c0-.351-.051-.7-.154-1.036a2.178 2.178 0 0 1-.063-1.036c.041-.567.03-.861-.068-.97a3.11 3.11 0 0 1-.109-1.2 29.677 29.677 0 0 0-.2-3.984 1.664 1.664 0 0 1-.067-.654c.011-.262-.053-1.343-.13-2.4-.079-1.057-.174-2.335-.2-2.835a9.696 9.696 0 0 0-.294-2.215c-.154-.556-.36-.668-.458-.24-.033.173-.109.293-.154.263-.12-.078-.218.338-.218.981-.021.484-.08.966-.175 1.441a6.83 6.83 0 0 0-.151 1.156c.033.306.018.615-.046.916-.034.229-.075.567-.087.743-.006.15-.036.296-.089.436a3.02 3.02 0 0 0-.087.721 4.735 4.735 0 0 1-.12.947.767.767 0 0 0-.042.416.11.11 0 0 1-.055.154.19.19 0 0 0-.046.218c.026.242.008.486-.053.721-.087.38-.087.567-.01.6a.1.1 0 0 1 .058.103.101.101 0 0 1-.014.04 16.581 16.581 0 0 0-.2 2.816 2.584 2.584 0 0 1-.39 1.592c-.188.131-.188.142.03.318.218.176.21.26.143 1.386a7.59 7.59 0 0 1-.172 1.386.368.368 0 0 0 0 .372c.078.487.082.984.01 1.472a4.3 4.3 0 0 0-.067.623 1.82 1.82 0 0 1-.154.774c-.086.1-.109.371-.053.818.034.372.064.763.064.883 0 .765.011.972.11 1.081.093.2.153.414.175.634a1.94 1.94 0 0 0 1.277 1.506c.327.064.36.109.383.458.023.452-.003.905-.078 1.352a7.36 7.36 0 0 0-.053.589c-.01.206-.045.3-.067.24-.087-.207-.338-.165-.413.075-.045.12-.143.218-.218.218-.229 0-.2.21.035.221.14.008.127.031-.057.109-.13.042-.24.162-.24.24 0 .349-2.05.6-2.249.282-.053-.087-.1-.1-.15-.011-.177-.511-1.049-1.43-.887-.414-.13.142-.282.053-.229.338l.023.162-.294.3c-.3.293-.6.3-.6 0a.172.172 0 0 0-.165-.165c-.1 0-.142-.042-.109-.1.034-.058 0-.109-.064-.109a.416.416 0 0 1-.166-.078.415.415 0 0 1-.118-.14.423.423 0 0 0-.327-.207c-.24 0-.35-.589-.373-2.084l-.01-.972.535-.056c.478-.042 1.112-.358 1.112-.556 0-.042.076-.075.154-.075.207 0 .458-.405.6-.972.061-.238.148-.468.26-.687.206-.384.264-.83.165-1.254-.087-.142-.067-.3.053-.534a1.736 1.736 0 0 0 0-1.486 1.516 1.516 0 0 1-.2-.819c0-.263-.04-.524-.12-.774a3.403 3.403 0 0 1-.12-.883c-.022-.612.012-.777.188-.95.109-.109.15-.2.1-.2-.2 0-.32-.425-.384-1.352-.109-1.539-.1-1.7.185-1.964.23-.207.23-.218.034-.36a.748.748 0 0 1-.24-.394.634.634 0 0 0-.12-.316 1.852 1.852 0 0 1-.24-1.048c.044-.011.044-.24 0-.48a4.34 4.34 0 0 1-.02-1.07c.041-.458.02-.609-.079-.609-.098 0-.12-.131-.075-.469.042-.3.022-.514-.067-.589-.1-.1-.087-.154.033-.229.12-.075.131-.142.034-.3a.342.342 0 0 1-.01-.38c.053-.112.053-.176 0-.176-.154 0-.23-.567-.11-.721.075-.1.075-.143-.023-.143-.075 0-.109-.086-.075-.207s.022-.218-.022-.218c-.1 0-.207-.447-.285-1.123a7.732 7.732 0 0 0-.15-1.07 3.91 3.91 0 0 1-.2-1.31c.056-.042.01-.218-.065-.383a.686.686 0 0 1-.067-.534c.1-.274.022-.927-.109-.927-.053 0-.1-.131-.1-.293a3.078 3.078 0 0 0-.1-.668 9.356 9.356 0 0 1-.154-1.179c-.053-.9-.129-1.176-.349-1.176-.087 0-.183-.142-.217-.318-.088-.425-.415-.436-.512-.031-.045.164-.119.32-.218.458-.154.173-.229.74-.307 2.246-.027.5-.082 1-.162 1.494a5.657 5.657 0 0 0-.12 1.137 9.147 9.147 0 0 1-.108 1.232 11.405 11.405 0 0 0-.12 1.768c.028.42-.002.842-.09 1.254-.099.414-.15.839-.15 1.265-.046.656-.11 1.637-.143 2.162a22.23 22.23 0 0 0-.045 1.626c.027.318-.014.638-.12.939a2.039 2.039 0 0 0-.064 1.1c.064.7.053.852-.12 1.092a2.905 2.905 0 0 0-.187 1.69.383.383 0 0 1-.03.338 2.519 2.519 0 0 0-.132.754c-.01.293-.067.534-.109.534-.042 0-.078.067-.078.154-.05.157-.14.3-.26.413-.154.176-.21.3-.13.318.127.461.123.949-.012 1.408-.073.153-.114.32-.12.489a2.586 2.586 0 0 1-.165.645 1.264 1.264 0 0 0-.087.654c.022.218 0 .427-.075.458-.143.1-.154.492 0 .492.075 0 .075.067 0 .207a.761.761 0 0 0 .031.852.675.675 0 0 1 .143.5.605.605 0 0 0 .59.71c.164.008.25.075.228.151-.064.154.285.36.623.36.221.017.44.054.654.109l.405.109-.045 1.2a2.947 2.947 0 0 1-.27 1.57c-.264.45-.286.679-.068.863.251.207.2.4-.109.338a.3.3 0 0 1-.274-.218c0-.142-.01-.154-.087-.034a.26.26 0 0 1-.316.078c-.165-.056-.25-.022-.3.087-.075.184-.36.24-.36.064a.118.118 0 0 0-.108-.109c-.064 0-.11.1-.11.218a.213.213 0 0 1-.218.229c-.109.011-.27.022-.338.034-.687.721-1.442 1.19.022 1.092a16.984 16.984 0 0 1 3.634-.087c2.16-.011 14.764.064 16.792-.21l.033.007ZM131.372 142.05c0-.609 3.721-1.187-.3-3.436-.131.327-1.145-.327-1.352-.349-.559-.067-.721-.165-.668-.436.022-.165-.011-.3-.12-.349a.23.23 0 0 1-.1-.263c.056-.12.011-.176-.086-.176-.12 0-.154-.162-.143-.774 0-.425.034-.721.056-.643.042.087.109.1.251.02.1-.053.207-.075.238-.042.031.033.154-.067.274-.218.12-.151.263-.274.316-.274.154 0 .24-.263.24-.676 0-.173.037-.343.109-.5.067-.1.056-.185-.031-.229-.1-.064-.1-.087.011-.087a5.204 5.204 0 0 0-.1-2.282 1.716 1.716 0 0 1-.053-.665.169.169 0 0 0 .011-.119.175.175 0 0 0-.067-.099 1.818 1.818 0 0 1-.087-.785 3.158 3.158 0 0 0-.045-.9 3.26 3.26 0 0 1-.237-.883 20.803 20.803 0 0 1-.056-1.333 6.467 6.467 0 0 0-.109-1.265 11.92 11.92 0 0 1-.143-1.877c-.086-2.835-.173-4.919-.229-5.358-.087-.8-.087-.86 0-1.112.056-.142.045-.229-.011-.2-.056.029-.1-.263-.109-.656a53.033 53.033 0 0 0-.075-1.679c-.033-.534-.109-1.877-.165-3-.109-1.967-.263-2.816-.522-2.9-.067-.034-.12.053-.12.173a.64.64 0 0 1-.165.372 4.78 4.78 0 0 0-.271 1.941c0 .12-.056.5-.112.852-.083.53-.137 1.064-.162 1.6-.034.533-.067 1.112-.087 1.288-.02.176-.078.6-.1.95-.1 1.145-.2 1.724-.327 1.8-.087.067-.087.109 0 .165a.313.313 0 0 1 .078.293c-.022.12-.067.721-.09 1.333-.042 1.212-.064 1.374-.2 1.581-.045.078-.033.131.023.131s.086.394.075.939c-.042 1.374-.042 1.344-.218 1.265-.176-.079-.207.056-.045.229.131.131.033.567-.128.567-.056 0-.022.112.064.24.131.2.154.5.12 1.464.011.43-.037.86-.143 1.277a.446.446 0 0 0-.053.327c.104.639.11 1.289.019 1.93-.053 0-.075.067-.042.154.023.321.004.644-.056.961-.2 1.266-.2 1.363-.042 1.746.075.184.1.349.053.349-.109 0-.064.721.078 1.33.271 1.148.369 1.453.436 1.453.034 0 .143.12.218.263a.956.956 0 0 0 .556.391c.405.12.405.131.405.687 0 .48-.045.581-.274.732a1.05 1.05 0 0 0-.371.447c-.086.229-.131.24-.3.131-.3-.184-.807.045-.732.338.034.131.011.187-.087.142a.204.204 0 0 0-.12.005.203.203 0 0 0-.098.07c-.056.1-.1.089-.165-.008-.064-.12-.131-.12-.349 0-.413.184-.251.053-.841.293.056.165-.151.285-.316.176-.218-.12-.732-.154-.732-.033 0 .064-.053.087-.109.042a.175.175 0 0 1-.067-.099.181.181 0 0 1 .014-.119c.022-.076.011-.14-.045-.14-.056 0-.131.087-.162.2-.045.162-.12.184-.349.131-.285-.078-.285-.089-.319-1.212-.06-.4-.037-.809.067-1.2.064-.042.12-.031.12.022 0 .218.774-.011 1.112-.327.6-.578.665-1.78.229-4.442a2.878 2.878 0 0 1-.075-1.221c.064-.067.022-.229-.12-.469a4.54 4.54 0 0 1-.327-2.173c0-.351-.052-.7-.154-1.036a2.19 2.19 0 0 1-.064-1.036c.042-.567.031-.861-.067-.97a3.12 3.12 0 0 1-.109-1.2 29.628 29.628 0 0 0-.2-3.984 1.664 1.664 0 0 1-.067-.654c.011-.262-.053-1.343-.131-2.4-.078-1.057-.173-2.335-.2-2.835a9.684 9.684 0 0 0-.293-2.215c-.154-.556-.36-.668-.458-.24-.033.173-.109.293-.154.263-.12-.078-.218.338-.218.981a9.565 9.565 0 0 1-.176 1.441c-.083.38-.134.767-.151 1.156.034.306.018.615-.045.916-.034.229-.075.567-.087.743a1.388 1.388 0 0 1-.089.436 3.02 3.02 0 0 0-.087.721 4.721 4.721 0 0 1-.12.947.767.767 0 0 0-.042.416.117.117 0 0 1 .013.044.1.1 0 0 1-.007.045.098.098 0 0 1-.024.039.108.108 0 0 1-.038.026.201.201 0 0 0-.058.102.192.192 0 0 0 .013.116c.025.242.007.486-.053.721-.087.38-.087.567-.011.6a.1.1 0 0 1 .055.061.12.12 0 0 1 .004.042.112.112 0 0 1-.014.04 16.485 16.485 0 0 0-.2 2.816 2.581 2.581 0 0 1-.391 1.592c-.187.131-.187.142.031.318.218.176.21.26.143 1.386-.015.466-.073.93-.173 1.386a.368.368 0 0 0 0 .372c.079.487.083.984.011 1.472-.037.206-.06.414-.067.623.006.266-.047.53-.154.774-.086.1-.109.371-.053.818.034.372.064.763.064.883 0 .765.011.972.109 1.081.094.2.153.414.176.634a1.937 1.937 0 0 0 1.277 1.506c.327.064.36.109.383.458.023.452-.003.905-.078 1.352-.019.12-.042.383-.053.589-.011.206-.045.3-.067.24-.087-.207-.338-.165-.413.075-.045.12-.143.218-.218.218-.229 0-.2.21.034.221.14.008.128.031-.056.109-.131.042-.24.162-.24.24 0 .349-2.05.6-2.249.282-.053-.087-.1-.1-.151-.011-.176-.511-1.048-1.43-.886-.414-.131.142-.282.053-.229.338l.022.162-.293.3c-.3.293-.6.3-.6 0a.168.168 0 0 0-.05-.115.168.168 0 0 0-.115-.05c-.1 0-.142-.042-.109-.1.033-.058 0-.109-.064-.109a.426.426 0 0 1-.285-.218.424.424 0 0 0-.327-.207c-.24 0-.349-.589-.372-2.084l-.011-.972.536-.056c.478-.042 1.112-.358 1.112-.556 0-.042.076-.075.154-.075.207 0 .458-.405.6-.972.061-.238.148-.469.26-.687.205-.384.264-.83.165-1.254-.087-.142-.067-.3.053-.534a1.735 1.735 0 0 0 0-1.486 1.517 1.517 0 0 1-.2-.819c0-.263-.04-.524-.12-.774a3.38 3.38 0 0 1-.12-.883c-.022-.612.011-.777.187-.95.109-.109.151-.2.1-.2-.2 0-.319-.425-.383-1.352-.109-1.539-.1-1.7.185-1.964.229-.207.229-.218.033-.36a.757.757 0 0 1-.24-.394.635.635 0 0 0-.12-.316 1.855 1.855 0 0 1-.24-1.048c.045-.011.045-.24 0-.48a4.354 4.354 0 0 1-.02-1.07c.042-.458.02-.609-.078-.609s-.12-.131-.075-.469c.042-.3.022-.514-.067-.589-.1-.1-.087-.154.033-.229.12-.075.131-.142.034-.3a.344.344 0 0 1-.011-.38c.053-.112.053-.176 0-.176-.154 0-.229-.567-.109-.721.075-.1.075-.143-.023-.143-.075 0-.109-.086-.075-.207s.022-.218-.022-.218c-.1 0-.207-.447-.285-1.123a7.719 7.719 0 0 0-.151-1.07 3.91 3.91 0 0 1-.2-1.31c.056-.042.011-.218-.064-.383a.685.685 0 0 1-.067-.534c.1-.274.022-.927-.109-.927-.053 0-.1-.131-.1-.293a3.073 3.073 0 0 0-.1-.668 9.344 9.344 0 0 1-.154-1.179c-.053-.9-.129-1.176-.349-1.176-.087 0-.184-.142-.218-.318-.087-.425-.414-.436-.511-.031a1.452 1.452 0 0 1-.218.458c-.154.173-.229.74-.307 2.246-.028.5-.082.999-.162 1.494a5.716 5.716 0 0 0-.12 1.137 9.08 9.08 0 0 1-.109 1.232 11.363 11.363 0 0 0-.12 1.768c.029.42-.001.842-.089 1.254-.099.414-.15.839-.151 1.265-.045.656-.109 1.637-.142 2.162a22.237 22.237 0 0 0-.045 1.626c.027.318-.014.638-.12.939a2.038 2.038 0 0 0-.064 1.1c.064.7.053.852-.12 1.092a2.906 2.906 0 0 0-.187 1.69.392.392 0 0 1-.031.338 2.51 2.51 0 0 0-.131.754c-.011.293-.067.534-.109.534-.042 0-.078.067-.078.154a.992.992 0 0 1-.26.413c-.154.176-.21.3-.131.318.128.461.124.949-.011 1.408a1.236 1.236 0 0 0-.12.489 2.57 2.57 0 0 1-.165.645 1.271 1.271 0 0 0-.087.654c.022.218 0 .427-.075.458-.143.1-.154.492 0 .492.075 0 .075.067 0 .207a.762.762 0 0 0 .031.852.679.679 0 0 1 .142.5.608.608 0 0 0 .59.71c.165.008.251.075.229.151-.064.154.285.36.623.36a3.8 3.8 0 0 1 .654.109l.405.109-.045 1.2a2.942 2.942 0 0 1-.271 1.57c-.263.45-.285.679-.067.863.251.207.2.4-.109.338a.299.299 0 0 1-.274-.218c0-.142-.011-.154-.087-.034a.26.26 0 0 1-.316.078c-.165-.056-.251-.022-.3.087-.075.184-.36.24-.36.064a.118.118 0 0 0-.034-.075.118.118 0 0 0-.075-.034c-.064 0-.109.1-.109.218a.219.219 0 0 1-.058.163.217.217 0 0 1-.16.066c-.109.011-.271.022-.338.034-.687.721-1.442 1.19.022 1.092a16.985 16.985 0 0 1 3.634-.087c2.159-.011 14.764.064 16.792-.21l.032.007ZM1262.44 128.996v-.174a2.71 2.71 0 0 0-.25-.882c-.13-.268-.3-.512-.51-.721a2.528 2.528 0 0 0-1.6-.718v-.36h-.31v-.43h.28v-.46h-.22l.05-.126.04-.11.03-.081.01-.037a.396.396 0 0 0 .02-.107c.01-.058.02-.134.03-.21.01-.076.02-.152.03-.212 0-.06.01-.1.01-.116s-.01-.094-.03-.211a3.989 3.989 0 0 0-.06-.42l-.05-.408-.02-.185-.08-.342-.16-.745-.16-.752-.07-.359c-.02-.045-.03-.089-.05-.132-.03-.071-.06-.163-.1-.254l-.09-.247-.05-.111-.1-1.036.16.138.01.022.01.056.02.056c0 .013.01.026.01.039l.01.05.02.08.02.075.01.033v.177c0 .015.01.031.01.045l.03.061.02.054.02.023.03.008.09.017a.554.554 0 0 0 .26.007l.01-.004V119.967l.02-.046.04-.11.06-.134c.02-.044.04-.086.05-.119a.153.153 0 0 1 .05-.062c.02-.009.04-.013.05-.01.02.002.03.007.04.015l.01.011v-.028c.01-.022.01-.044.02-.065 0-.027.01-.053.03-.077a.176.176 0 0 1 .05-.062.95.95 0 0 0 .06-.053.22.22 0 0 0 .05-.062c.02-.02.03-.04.05-.062a.108.108 0 0 0 .02-.053c.01-.01.01-.02 0-.03 0-.01 0-.019-.01-.027a.251.251 0 0 0-.05-.07c-.02-.024-.04-.048-.05-.068-.02-.014-.02-.031-.03-.049 0-.013.01-.025.02-.034a.424.424 0 0 1 .03-.03l.03-.021v-.007l.34-.207v-.503c0-.021 0-.041-.01-.062 0-.025 0-.05-.01-.075a.2.2 0 0 0-.02-.075.134.134 0 0 0-.02-.063c0-.019 0-.039-.01-.059V117.37c0-.014 0-.028-.01-.041l-.03-.04c0-.016-.01-.032-.01-.049 0-.024-.01-.048-.01-.071-.01-.029-.03-.06-.04-.091l-.04-.094c-.01-.03-.02-.059-.03-.084-.01-.025-.02-.052-.04-.079-.01-.027-.02-.056-.04-.083l-.04-.079-.04-.07-.06-.125-.1-.2-.09-.187-.05-.083-.33-.874c.17.253.34.494.5.712.16.205.33.399.51.579.15.152.32.28.51.381.16.086.34.128.53.12.41-.1.57-.52.56-1.108a6.527 6.527 0 0 0-.48-2.087 9.467 9.467 0 0 0-1.1-2.07 2.414 2.414 0 0 0-1.28-1.058.725.725 0 0 0-.45.111.833.833 0 0 0-.26.32 1.2 1.2 0 0 0-.11.414c-.02.13-.01.262.01.391l-.04.026-.08.059c-.03.022-.05.045-.08.065-.01.012-.03.026-.04.043 0 .014.01.027.01.039.01.019.02.038.04.056l.03.051.02.025-.22-.031-.01-.01-.02-.024-.03-.03a.365.365 0 0 1-.03-.027c0-.011-.01-.021-.02-.028-.02-.01-.04-.02-.05-.03l-.05-.02-.02-.01-.03-.026-.06-.064c-.03-.022-.05-.045-.07-.064-.01-.011-.03-.023-.04-.036 0-.011-.01-.023-.01-.035v-.483c0-.011.01-.021.01-.031.01-.009.01-.017.02-.024l.03-.027.05-.033.06-.037c.01-.012.03-.026.05-.04.01-.009.02-.02.02-.032.01-.003.01-.007.01-.01s0-.007-.01-.01v-.038c.01-.008.01-.018.01-.027 0-.014 0-.028.01-.041v-.046c.01-.015.01-.03.02-.044 0-.013.01-.027.01-.042V110.578c-.01-.016-.01-.032-.01-.049V110.426c0-.022 0-.044-.01-.066 0-.022 0-.045-.01-.065l-.01-.047c0-.014 0-.028-.01-.041-.01-.015-.01-.029-.02-.043l-.03-.045c0-.014-.01-.029-.01-.045 0-.015-.01-.029-.01-.043l-.02-.042-.01-.036-.02-.038c-.01-.016-.01-.031-.02-.045l-.04-.054a1.677 1.677 0 0 1-.06-.123c0-.017-.01-.035-.01-.053-.01-.012-.01-.025-.01-.037v-.056c0-.018-.01-.035-.02-.051-.01-.023-.02-.05-.03-.079l-.04-.083-.04-.064c-.01-.016-.01-.022-.02-.022s-.01.001-.02.003c0 .002 0 .005-.01.008 0 .007-.01.015-.01.023l-.01.012-.23.131-.01-.1v-.044a.296.296 0 0 0 .02-.1c.01-.037.01-.079.02-.113 0-.026.01-.052.01-.079v-.016c-.01-.005-.01-.008-.02-.009a.119.119 0 0 0-.04.006c-.01.005-.02.01-.04.017l-.01.01-.13-.022.01-.016c.01-.015.01-.029.02-.042a.119.119 0 0 0 .02-.059c.01-.023.01-.046.02-.069V108.735v.015l.03-.175.17.008h.01l.01-.011.03-.017.04-.026a.161.161 0 0 0 .03-.029c0-.013.01-.026.01-.04 0-.018 0-.035.01-.052 0-.019-.01-.04 0-.063.01-.018.01-.037.01-.056v-.186c0-.033 0-.067.01-.1V107.786a.142.142 0 0 0 0-.091.176.176 0 0 0-.02-.069c0-.015-.01-.03-.01-.046l-.01-.018h-.14l-.31.007-.12-.08-.2-.1-.2.016-.21.145-.2.407-.13.515v.776l-.2.246-.14.261.15.184v.784l.14.23.21.138c0 .013 0 .026-.01.039 0 .024-.01.057-.01.093l-.03.107c0 .029-.01.057-.03.083a.185.185 0 0 0-.02.072c-.01.029-.01.058-.02.088V112.044c0 .026-.01.052-.02.077a6.93 6.93 0 0 1-.03.08c-.02.025-.03.047-.04.063l-.02.025-.16.169-.07.042-.16.1-.18.108c-.05.033-.1.061-.12.076-.02.015-.06.042-.1.074l-.12.1-.1.091-.04.039-.18.737-.06.338-.05.215-.28.569-.58.493-.52.692-.77.755-.27.061h-.43l-.17.09-1.7-3.408.08-.131v-.123c0-.014 0-.023-.01-.023h-.13l-.02.006a.076.076 0 0 1-.03 0c0-.002-.01-.004-.01-.007s0-.007-.01-.011c0-.017 0-.034-.01-.051-.01-.023-.01-.049-.02-.074l-.02-.067v-.029l.01-.178-1.19-1.756.67 2.046.15.039.08.092.04.077-.03.116-.01.093.1.062.08.007h.02l1.78 3.568-.19.054-.02.169.05.215.15.215.18.077.11.277h.16l.05-.02 1.82 3.669v.065l.04.066c.02.04.05.093.09.147.03.054.06.111.1.156.02.034.04.065.07.091.02.013.04.033.05.056.01.027.01.055.01.084a.13.13 0 0 1 0 .087v.135c0 .03.01.064.01.1.01.036.01.069.01.1.01.023.01.047 0 .07 0 .046.01.092.01.138.01.07.02.159.02.247.01.088.02.177.03.247 0 .07.01.122.01.137a.246.246 0 0 1-.04.079c-.02.035-.04.075-.07.114-.03.039-.05.075-.07.1l-.04.044.15.276.49.158v.639h-.48v.461h.3v.431h-.31v.361a2.55 2.55 0 0 0-1.61.734c-.43.433-.7 1.004-.76 1.614v.673l.01.031.01.03v.031l.01.033v.032l.01.032.01.033v.032c.06.24.16.47.29.682a2.674 2.674 0 0 0 1.08.992c.22.112.45.19.7.232h.87l1.05-.007 2.06-.008 1.46-.019.62.008.27-.015h-.49l-5.42.042 5.7-.031c.56-.011 1.1-.208 1.53-.561.43-.35.74-.828.88-1.365v-.027l.02-.043.01-.041.01-.041V129.018c.04-.008.05-.015.05-.022Zm-8.42-9.053-.02.1-.03.234c-.02.086-.03.175-.04.246a.77.77 0 0 0-.03.139c0 .016-.01.046-.03.084l-.04.124-.05.112-.02.049-.02.35-1.62-3.251.05-.049.06-.05.06-.047.04-.039c.03-.02.05-.041.07-.064l.08-.082.07-.07.02-.03.3-.186 1.07-.677-.04.063-.09.124c-.03.046-.06.094-.09.134-.01.03-.03.061-.05.093-.01.028-.01.057-.01.087 0 .037-.01.082-.01.128s0 .093.01.139a.374.374 0 0 0 .05.222l.06.094c.01.028.03.051.05.068l.02.026.18.23-.01.042a.605.605 0 0 0-.03.079l-.03.1c-.01.028-.01.056-.01.085 0 .036 0 .073.01.108.01.046.02.1.04.148.01.048.02.1.03.131l.02.057.06.354-.08.595Zm8.91 27.038v4.357l.98-.01v-4.356l-.98.009Zm-11.74 4.478 12.72-.131v-4.356l-.98.009v-.556l-1.23.011v-.694h.34v-1.132l-.93.008v-1.82l-1.27.01v-10.422l-5.54.032v10.435l-1.28.01v1.823l-.94.008v1.131h.34v.7l-1.23.011v4.923Zm-.98-4.36v4.371l.98-.01v-4.374l-.98.013Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m648.834 140.391 83.293-2.276v-2.565l-83.293 4.841Z",
                                fill: "#FAFBFC"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m734.129 131.52.199 8.7 53.711 1.68-53.91-10.38Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m761.732 96.608-.006-1.662-27.228-15.038.385 3.929 26.849 12.771Zm26.45 14.084.09-1.082-7.874-4.4.134 1.5 7.65 3.982Zm-53.48-32.361 5.413 3.07-.331-2.06-4.789-4.386-.293 3.376Zm-77.744 23.6 76.674-14.608-.752-7.45-76.019 17.055.155 2.707-.554.347.233.562.263 1.387Zm76.3-25.412 1.006-2.756-8.094-.281-.238 2.094-4.176.054.026 1.832-29.641-1.434-.435 5.885-2.213.29.231-2.221-4.03 1.1.03 1.955-2.868.3.241-1.179-9.465 3.785-10.339 6.015-4.545 1.234 2.712-1.6-.28-1.04-2.064 1.2-.149-1.046-4.535 1.892.442 3.257.918.116 77.61-18.275-.144-1.177Zm2.119 10.793 53.794 26.831-.353-1.866L762.8 99.032l-27.568-13.793.145 2.073Zm-79.863 49.57 52.805-5.724-52.163 4.077-.642 1.647Zm135.074 4.212-56.45-10 .246 5.056 56.566 5.632-.362-.688Zm-.1 1.671-55.929-5.313.1 3.045 55.829 2.268Zm-141.445.217 55.953-2.55 27.328.242-.142-10.981-26.85 3.588-53.862 4.026-.106.967 50.14-3.119-34.351 3.244-17.7 1.1-.41 3.483Zm19.789-41.161 3.231 1.732v-.751l-3.148-1.684-5.628 1.05-.058.765 5.603-1.112Zm6.118 1.818-1.791 29.367.422-.029 1.718-29.8c0-.022.007-.044.012-.065a.623.623 0 0 1 .049-.137.315.315 0 0 1 .1-.126.235.235 0 0 1 .182-.029.295.295 0 0 1 .167.091.313.313 0 0 1 .067.141.465.465 0 0 1 .009.129c0 .019 0 .037-.006.056l-1.552 29.685.489-.035 1.442-30a.646.646 0 0 1 .059-.2.31.31 0 0 1 .1-.124.217.217 0 0 1 .089-.032.23.23 0 0 1 .094.005.28.28 0 0 1 .166.089c.034.04.056.088.066.139a.499.499 0 0 1 .001.184l-1.251 29.881.477-.033 1.109-29.915a.464.464 0 0 1 .011-.065.574.574 0 0 1 .043-.135.318.318 0 0 1 .1-.124.234.234 0 0 1 .184-.027.292.292 0 0 1 .166.091c.034.04.056.088.066.139.008.042.011.085.008.127a.343.343 0 0 1-.007.056l-.919 29.8.385-.026.9-29.561a.592.592 0 0 1 .058-.2.31.31 0 0 1 .1-.124.238.238 0 0 1 .185-.029.303.303 0 0 1 .167.093c.034.04.057.088.066.14a.499.499 0 0 1 .001.184l-.718 29.443.364-.026.639-30.031a4.805 4.805 0 0 0-.47-.174 6.607 6.607 0 0 0-1.187-.263 5.06 5.06 0 0 0-1.568.038 3.726 3.726 0 0 0-1.616.728c-.1 1.088-.26 3.241-.458 5.927-.198 2.686-.429 5.9-.658 9.125a10582.728 10582.728 0 0 0-1.06 15.11l.428-.03 1.966-29.486a.658.658 0 0 1 .06-.201.32.32 0 0 1 .106-.125.234.234 0 0 1 .183-.029.295.295 0 0 1 .168.092c.034.04.057.088.067.14.009.042.012.085.009.128 0 .018 0 .036-.007.054l.02-.001Zm-2.745-2.344 5.777-1.15 3.35 1.79-.018-.777-3.269-1.74-5.8 1.087-.04.79Zm12.845.544-1.529 30.416.436-.03 1.454-30.863a.594.594 0 0 1 .059-.209.322.322 0 0 1 .108-.129.258.258 0 0 1 .092-.035.254.254 0 0 1 .099.005.297.297 0 0 1 .172.094.324.324 0 0 1 .07.144.531.531 0 0 1 .01.132c0 .019 0 .039-.006.058l-1.277 30.744.5-.034 1.159-31.064a.637.637 0 0 1 .06-.207.318.318 0 0 1 .109-.129.254.254 0 0 1 .192-.03.306.306 0 0 1 .243.245.532.532 0 0 1 .011.132c0 .019 0 .039-.006.058l-.974 30.937.5-.04.815-30.972a.64.64 0 0 1 .057-.209.317.317 0 0 1 .106-.129.25.25 0 0 1 .189-.029.308.308 0 0 1 .245.245.487.487 0 0 1 .002.19l-.633 30.856.4-.029.606-30.613a.587.587 0 0 1 .059-.207.328.328 0 0 1 .107-.129.251.251 0 0 1 .189-.03.299.299 0 0 1 .172.095.332.332 0 0 1 .07.145.539.539 0 0 1 .004.191l-.419 30.492.374-.028.334-31.1a5.262 5.262 0 0 0-.487-.18c-.4-.128-.81-.219-1.227-.271a5.197 5.197 0 0 0-1.618.04 3.79 3.79 0 0 0-1.659.753 628.921 628.921 0 0 0-.408 6.171c-.177 2.8-.378 6.14-.578 9.485l-.565 9.466c-.165 2.781-.294 5-.359 6.11l.438-.03 1.7-30.531a.645.645 0 0 1 .06-.209.327.327 0 0 1 .109-.13.254.254 0 0 1 .191-.031.297.297 0 0 1 .171.1.32.32 0 0 1 .069.145.487.487 0 0 1 .003.183l.001-.005Zm25.674-7.808 3.735 1.965-.049-.857-3.632-1.909-6.311 1.194-.025.87 6.282-1.263Zm-28.533 5.387 5.944-1.19 3.485 1.853-.028-.8-3.39-1.8-5.97 1.116-.041.821Zm13.518.276-1.277 31.768.451-.029 1.193-32.235a.52.52 0 0 1 .011-.068.647.647 0 0 1 .045-.149.326.326 0 0 1 .109-.133.25.25 0 0 1 .2-.033.318.318 0 0 1 .178.1.348.348 0 0 1 .073.149c.01.045.014.09.012.136 0 .02 0 .039-.006.059l-1 32.112.518-.038.888-32.436a.628.628 0 0 1 .059-.214.327.327 0 0 1 .109-.134.248.248 0 0 1 .193-.033c.07.013.134.048.182.1a.333.333 0 0 1 .075.148.51.51 0 0 1 .006.194l-.7 32.318.512-.037.531-32.35a.628.628 0 0 1 .059-.214.321.321 0 0 1 .11-.133.245.245 0 0 1 .2-.03.309.309 0 0 1 .254.25.526.526 0 0 1 .006.197l-.345 32.222.417-.032.314-31.97a.678.678 0 0 1 .057-.215.326.326 0 0 1 .109-.133.256.256 0 0 1 .2-.03.318.318 0 0 1 .178.1.349.349 0 0 1 .073.149.518.518 0 0 1 .006.196l-.125 31.844.392-.025.026-32.472a4.916 4.916 0 0 0-.5-.186 7.067 7.067 0 0 0-1.267-.282 5.358 5.358 0 0 0-1.667.039 3.848 3.848 0 0 0-1.7.775c-.081 1.2-.215 3.63-.375 6.644-.16 3.014-.343 6.616-.521 10.176-.178 3.56-.353 7.074-.492 9.917l-.288 5.881.454-.033 1.458-31.892a.628.628 0 0 1 .059-.215.326.326 0 0 1 .109-.133.255.255 0 0 1 .195-.03.317.317 0 0 1 .179.1.346.346 0 0 1 .073.149c.01.045.014.091.012.137a.524.524 0 0 1-.016.055l-.006-.001Zm-2.966-2.5 6.112-1.228 3.61 1.91-.039-.83-3.513-1.855-6.136 1.159-.034.844Zm23.1-4.022 6.454-1.3 3.858 2.025-.054-.88-3.756-1.968-6.48 1.226-.022.897Zm-49.445 12.02-1.9 28.445.381-.032 1.853-28.862c0-.021.006-.042.011-.062a.554.554 0 0 1 .044-.132.3.3 0 0 1 .1-.12.184.184 0 0 1 .081-.032.197.197 0 0 1 .087.005.259.259 0 0 1 .21.224.516.516 0 0 1-.001.178l-1.692 28.756.443-.033 1.591-29.058c0-.021.006-.042.011-.062a.615.615 0 0 1 .045-.131.3.3 0 0 1 .1-.12.195.195 0 0 1 .081-.031.193.193 0 0 1 .086.004.262.262 0 0 1 .211.223.51.51 0 0 1 .002.177l-1.431 28.947.436-.033 1.285-28.977a.617.617 0 0 1 .055-.194.31.31 0 0 1 .1-.121.207.207 0 0 1 .165-.028c.06.011.114.042.153.089.031.04.052.086.06.136.007.041.01.083.007.124a.514.514 0 0 1-.006.055l-1.125 28.866.355-.027 1.1-28.636a.626.626 0 0 1 .053-.196.31.31 0 0 1 .1-.121.195.195 0 0 1 .081-.031.193.193 0 0 1 .086.005.259.259 0 0 1 .211.221c.007.041.01.082.007.123a.495.495 0 0 1-.006.054l-.931 28.535.334-.026.863-29.1a3.998 3.998 0 0 0-.425-.169 5.662 5.662 0 0 0-1.075-.255 4.315 4.315 0 0 0-1.425.035 3.31 3.31 0 0 0-1.474.7c-.1 1.056-.267 3.149-.473 5.759-.206 2.61-.447 5.736-.686 8.861-.239 3.125-.475 6.247-.672 8.851-.197 2.604-.352 4.689-.431 5.739l.393-.031 2.054-28.55c.003-.021.006-.042.011-.062a.602.602 0 0 1 .044-.132.3.3 0 0 1 .1-.12.195.195 0 0 1 .081-.031.192.192 0 0 1 .086.004.259.259 0 0 1 .151.089c.03.04.05.086.058.135a.508.508 0 0 1 .006.123c-.005.018-.012.035-.019.052Zm43.185-8.08-.412 33.28.531-.037.238-33.313a.658.658 0 0 1 .057-.221.33.33 0 0 1 .111-.137.252.252 0 0 1 .2-.032.331.331 0 0 1 .186.1.36.36 0 0 1 .078.154.55.55 0 0 1 .015.14.62.62 0 0 1 0 .061l-.055 33.185.432-.031.016-32.921a.669.669 0 0 1 .058-.222.338.338 0 0 1 .111-.139.256.256 0 0 1 .2-.035.326.326 0 0 1 .185.1.348.348 0 0 1 .076.155.557.557 0 0 1 .006.203l.18 32.8.4-.029-.286-33.441a5.44 5.44 0 0 0-.519-.192 7.342 7.342 0 0 0-1.3-.29 5.442 5.442 0 0 0-1.713.041 3.916 3.916 0 0 0-1.744.8 627.528 627.528 0 0 0-.322 6.816c-.135 3.093-.29 6.789-.44 10.447-.15 3.658-.3 7.274-.413 10.21-.113 2.936-.2 5.189-.241 6.119l.468-.038 1.193-32.842a.66.66 0 0 1 .058-.22.324.324 0 0 1 .112-.136.267.267 0 0 1 .2-.031.329.329 0 0 1 .186.1.34.34 0 0 1 .076.153c.01.046.014.093.012.14 0 .02 0 .041-.006.061l-1.006 32.718.463-.033.922-33.194a.657.657 0 0 1 .057-.221.317.317 0 0 1 .11-.137.246.246 0 0 1 .2-.031.328.328 0 0 1 .186.1.35.35 0 0 1 .077.152.507.507 0 0 1 .008.201l-.732 33.069.533-.041.6-33.407a.662.662 0 0 1 .06-.221.33.33 0 0 1 .112-.137.268.268 0 0 1 .2-.031.33.33 0 0 1 .185.1.355.355 0 0 1 .077.153.542.542 0 0 1 .014.139.662.662 0 0 1 0 .063Zm22.47-4.012.16 35.621.239-.018.321.06-.341-35.741a.677.677 0 0 1 .054-.234.34.34 0 0 1 .114-.146.274.274 0 0 1 .212-.035.36.36 0 0 1 .2.109.39.39 0 0 1 .085.163.568.568 0 0 1 .017.148v.065l.558 35.836.452.084-.58-35.673a.69.69 0 0 1 .058-.235.342.342 0 0 1 .115-.146.262.262 0 0 1 .21-.033c.076.013.146.05.2.106.041.046.07.102.085.162a.567.567 0 0 1 .017.148v.065l.8 35.774h.246v.048l.461.084.64-32.652a.624.624 0 0 1 .057-.223.324.324 0 0 1 .11-.139.251.251 0 0 1 .2-.033c.073.012.14.047.192.1.04.044.068.098.082.156a.53.53 0 0 1 .017.143v.063l-.464 32.739.46.086.373-33.34a.626.626 0 0 1 .052-.225.31.31 0 0 1 .109-.139.265.265 0 0 1 .2-.031.327.327 0 0 1 .189.1.356.356 0 0 1 .079.156.537.537 0 0 1 .009.207l-.18 33.427.536.1.035-33.911a.675.675 0 0 1 .055-.224.321.321 0 0 1 .11-.139.251.251 0 0 1 .2-.033.338.338 0 0 1 .189.1.366.366 0 0 1 .081.155.558.558 0 0 1 .016.141v.062l.142 34.006.537.1-.322-34.177c0-.024.005-.048.009-.071a.672.672 0 0 1 .045-.152.32.32 0 0 1 .11-.139.252.252 0 0 1 .2-.032.34.34 0 0 1 .189.1.367.367 0 0 1 .081.155.566.566 0 0 1 .016.142v.062l.526 34.268.433.08-.548-34.115a.673.673 0 0 1 .056-.223.329.329 0 0 1 .109-.138.245.245 0 0 1 .2-.031.34.34 0 0 1 .189.1.365.365 0 0 1 .081.155.567.567 0 0 1 .017.142v.062l.745 34.1h.41l-.876-34.78a5.441 5.441 0 0 0-.527-.193 7.458 7.458 0 0 0-1.322-.292 5.514 5.514 0 0 0-1.729.042 3.883 3.883 0 0 0-1.746.809c-.042 1-.1 2.811-.161 5.1-.061 2.289-.135 5.047-.207 7.949-.072 2.902-.145 5.944-.212 8.8l-.178 7.639-.832-32.725a7.854 7.854 0 0 0-1.939-.507 5.777 5.777 0 0 0-1.813.044 4.084 4.084 0 0 0-1.832.85 663.671 663.671 0 0 0-.228 7.579c-.091 3.441-.192 7.543-.288 11.549a8174.401 8174.401 0 0 0-.385 16.817l.491-.032.681-35.158a.681.681 0 0 1 .059-.234.342.342 0 0 1 .115-.146.268.268 0 0 1 .21-.035c.077.013.147.05.2.107a.39.39 0 0 1 .085.163.576.576 0 0 1 .017.149v.065l-.487 35.022.494-.038.382-35.525c0-.025 0-.05.009-.075a.688.688 0 0 1 .047-.16.345.345 0 0 1 .114-.147.272.272 0 0 1 .212-.036.36.36 0 0 1 .2.109.375.375 0 0 1 .083.163.567.567 0 0 1 .014.148c0 .022 0 .043-.006.065l-.179 35.4.564-.04.042-35.756a.69.69 0 0 1 .059-.235.342.342 0 0 1 .115-.146.265.265 0 0 1 .21-.034.353.353 0 0 1 .2.108c.041.047.07.103.084.163a.575.575 0 0 1 .017.149.57.57 0 0 1-.011.058l-.001-.005Zm-13.021 2.726-.748 33.9.48-.031.654-34.4a.648.648 0 0 1 .057-.228.325.325 0 0 1 .112-.142.262.262 0 0 1 .2-.031.334.334 0 0 1 .192.1c.039.046.067.1.08.159a.598.598 0 0 1 .015.146.683.683 0 0 1 0 .064l-.458 34.262.547-.036.33-34.617c0-.024 0-.049.009-.073a.648.648 0 0 1 .047-.155.325.325 0 0 1 .112-.142.261.261 0 0 1 .206-.033c.073.012.14.047.192.1.04.045.068.1.081.159a.59.59 0 0 1 .01.209l-.128 34.485.547-.039-.042-34.515a.685.685 0 0 1 .058-.225.33.33 0 0 1 .114-.14.26.26 0 0 1 .207-.033.338.338 0 0 1 .19.1c.039.046.067.1.08.159a.598.598 0 0 1 .015.146v.064l.258 34.39.436-.036-.283-34.112a.703.703 0 0 1 .058-.228.336.336 0 0 1 .113-.142.251.251 0 0 1 .2-.033.348.348 0 0 1 .194.1c.04.045.068.1.082.158a.582.582 0 0 1 .015.144.662.662 0 0 1 0 .063l.478 33.994.418-.033-.6-34.655a5.41 5.41 0 0 0-.537-.2 7.551 7.551 0 0 0-1.348-.3 5.649 5.649 0 0 0-1.765.043 4.002 4.002 0 0 0-1.788.824c-.064 1.3-.163 3.936-.277 7.208-.114 3.272-.243 7.176-.366 11.013a10535.978 10535.978 0 0 0-.518 16.587l.477-.037.943-34.034a.703.703 0 0 1 .058-.228.338.338 0 0 1 .114-.142.258.258 0 0 1 .207-.033.34.34 0 0 1 .191.1c.039.046.067.1.08.159a.59.59 0 0 1 .015.145.587.587 0 0 1-.014.072Zm-62.815 7.755-.066.738 5.441-1.07 3.106 1.669v-.724l-3.028-1.626-5.453 1.013Zm3.115 2.918-2.172 27.669.374-.026 2.121-28.078c0-.02.006-.04.011-.06a.637.637 0 0 1 .044-.127.288.288 0 0 1 .095-.115.199.199 0 0 1 .163-.024c.057.01.108.04.144.085a.297.297 0 0 1 .056.13.473.473 0 0 1-.002.171l-1.964 27.968.428-.029 1.876-28.26c.003-.02.006-.04.011-.06a.59.59 0 0 1 .045-.128.296.296 0 0 1 .1-.116.206.206 0 0 1 .163-.025c.057.01.108.04.144.085a.297.297 0 0 1 .056.13c.005.04.005.08 0 .119-.001.018-.004.035-.007.052l-1.722 28.153.426-.03 1.583-28.187a.573.573 0 0 1 .052-.187.284.284 0 0 1 .093-.116.203.203 0 0 1 .162-.027c.057.01.108.04.144.085a.284.284 0 0 1 .055.13.474.474 0 0 1 0 .119.463.463 0 0 1-.007.052l-1.41 28.078.34-.026 1.393-27.854c.003-.02.006-.04.011-.06a.646.646 0 0 1 .044-.128.288.288 0 0 1 .1-.116.207.207 0 0 1 .079-.031.216.216 0 0 1 .084.005.248.248 0 0 1 .145.086.3.3 0 0 1 .056.131.473.473 0 0 1 0 .171l-1.23 27.752.322-.025 1.162-28.3a4.003 4.003 0 0 0-.409-.163 5.408 5.408 0 0 0-1.036-.247 4.188 4.188 0 0 0-1.377.033 3.241 3.241 0 0 0-1.432.678c-.107 1.038-.3 3.112-.533 5.7-.233 2.588-.508 5.672-.778 8.743a19392.79 19392.79 0 0 0-1.222 13.969l.381-.025 2.322-27.779c0-.021.006-.042.011-.063a.637.637 0 0 1 .044-.127.295.295 0 0 1 .094-.116.203.203 0 0 1 .161-.027.243.243 0 0 1 .202.213c.007.04.009.08.006.12 0 .018 0 .037-.002.055Zm73.917-17.518-6.654 1.265-.012.925 6.621-1.343 3.983 2.086-.064-.909-3.874-2.024Zm21.075 10.614 3.608 1.777-.08-.79-3.5-1.721-1.451.289-1.069.976 2.492-.531Zm15.258 7.647-.907.848 2.157-.456 3.163 1.537-.085-.683-3.078-1.494-1.25.248Zm-9.2-4.646 3.473 1.705-.076-.759-3.374-1.654-1.4.274-1.02.94 2.397-.506Zm4.1 2.253-.973.9 2.285-.484 3.3 1.626-.069-.723-3.221-1.578-1.322.259Zm9.77 4.7-.86.8 2.048-.432 3 1.464-.076-.652-2.92-1.418-1.192.238Zm5.191 1.746-1.114.225-.8.752 1.913-.406 2.823 1.369-.08-.609-2.742-1.331Zm4.414 26.986-1.953-22.585c0-.053.01-.105.028-.155a.2.2 0 0 1 .071-.1.175.175 0 0 1 .14-.023.26.26 0 0 1 .139.068c.03.03.053.066.066.106a.378.378 0 0 1 .02.143l2.089 22.656.38.072-2.222-22.782a.442.442 0 0 1 .025-.153.196.196 0 0 1 .069-.1.21.21 0 0 1 .068-.027.18.18 0 0 1 .073.003.245.245 0 0 1 .128.057.245.245 0 0 1 .078.117.34.34 0 0 1 .018.143l2.37 22.852.309.058-2.373-22.75a.45.45 0 0 1 .024-.154.196.196 0 0 1 .069-.1.175.175 0 0 1 .14-.024.258.258 0 0 1 .205.174.424.424 0 0 1 .021.143l2.518 22.825.293.056-2.656-23.348s-.107-.042-.29-.1a5.724 5.724 0 0 0-.743-.163 4.714 4.714 0 0 0-1-.046c-.369.021-.73.107-1.069.254l1.319 13.936-1.024-13.415a.426.426 0 0 1 .022-.15.204.204 0 0 1 .068-.1.175.175 0 0 1 .139-.022.253.253 0 0 1 .207.173.377.377 0 0 1 .019.142l1.827 22.247.388.072Zm-36.286-41.716 3.658 1.9-.076-.824-3.557-1.839-2.293.435-1.219 1.042 3.487-.714Zm34.828 16.655-.614.7 1.172-.251 2.8 1.334-.1-.6-2.716-1.293-.542.11Zm-13.793 18.061-.735-20.682a.523.523 0 0 1 0-.056.505.505 0 0 1 .031-.12.248.248 0 0 1 .083-.111.208.208 0 0 1 .077-.031.19.19 0 0 1 .082.003c.054.007.105.03.146.066a.28.28 0 0 1 .087.134.438.438 0 0 1 .019.162l.816 24.906.376.068-.913-25.39a.523.523 0 0 1 0-.056.487.487 0 0 1 .032-.119.247.247 0 0 1 .084-.11.211.211 0 0 1 .161-.028.285.285 0 0 1 .23.2.437.437 0 0 1 .018.162l1.065 25.465.434.083-1.182-25.857a.548.548 0 0 1 .037-.178.24.24 0 0 1 .083-.111.19.19 0 0 1 .077-.03.19.19 0 0 1 .082.003.28.28 0 0 1 .234.2.424.424 0 0 1 .019.161l1.338 25.938.434.082-1.488-26.079a.543.543 0 0 1 .036-.178.247.247 0 0 1 .084-.112.225.225 0 0 1 .079-.031.301.301 0 0 1 .242.082.302.302 0 0 1 .072.122.424.424 0 0 1 .019.161l1.65 26.165.35.068-1.656-26.052a.543.543 0 0 1 .036-.178.25.25 0 0 1 .084-.111.198.198 0 0 1 .162-.025.273.273 0 0 1 .227.2.385.385 0 0 1 .017.112.4.4 0 0 1 0 .049l1.824 26.132.338.062-1.954-26.734s-.164-.068-.436-.148a6.277 6.277 0 0 0-1.086-.219 4.599 4.599 0 0 0-1.4.05 3.09 3.09 0 0 0-1.392.659c0 .331.066 1.826.158 3.882s.214 4.671.336 7.244a10945.508 10945.508 0 0 0 .483 10.125ZM740.18 92.844l3.794 1.986-.057-.864-3.7-1.927-1.825.344-1.06 1.039 2.848-.578Zm38.475 43.937-1.1-22.6a.467.467 0 0 1 .031-.157.211.211 0 0 1 .074-.1.184.184 0 0 1 .143-.023.248.248 0 0 1 .205.176.374.374 0 0 1 .017.144l1.272 23.206.389.071-1.384-23.552a.417.417 0 0 1 0-.05.43.43 0 0 1 .027-.107.211.211 0 0 1 .074-.1.185.185 0 0 1 .144-.024.263.263 0 0 1 .141.07c.03.031.052.068.065.109a.42.42 0 0 1 .018.144l1.524 23.624.394.072-1.66-23.753a.45.45 0 0 1 .029-.158.21.21 0 0 1 .073-.1.176.176 0 0 1 .07-.027.172.172 0 0 1 .075.002.257.257 0 0 1 .207.18.42.42 0 0 1 .018.144l1.808 23.826.315.057-1.814-23.722a.486.486 0 0 1 .022-.152.219.219 0 0 1 .072-.1.173.173 0 0 1 .142-.024.263.263 0 0 1 .141.07c.03.031.052.068.065.109a.42.42 0 0 1 .018.144l1.966 23.8.3.056-2.091-24.337s-.127-.051-.34-.113a5.713 5.713 0 0 0-.858-.18 4.46 4.46 0 0 0-1.137-.008 2.964 2.964 0 0 0-1.175.4l.034.445.024-.009.025-.007h.063a.247.247 0 0 1 .129.059.25.25 0 0 1 .078.119.34.34 0 0 1 .018.143l.514 11.411.58 7.927.255 2.895Zm8.177-21.244 2.754 1.3-.106-.577-2.682-1.266-.523.1-.587.679 1.144-.236Zm-42.221-15.265.1 30.712.441.081-.2-31.284a.61.61 0 0 1 .05-.213.3.3 0 0 1 .1-.133.242.242 0 0 1 .192-.031.329.329 0 0 1 .26.249.52.52 0 0 1 .016.136v.06l.369 31.371.514.1-.5-31.839a.657.657 0 0 1 .048-.214.299.299 0 0 1 .1-.132.24.24 0 0 1 .192-.029c.07.013.133.048.181.1a.348.348 0 0 1 .08.147c.012.044.018.09.018.135v.059l.685 31.921.513.1-.857-32.087a.566.566 0 0 1 .048-.213.299.299 0 0 1 .1-.132.241.241 0 0 1 .191-.031.337.337 0 0 1 .263.248c.012.044.018.09.018.136v.059l1.051 32.174.414.077-1.066-32.041a.663.663 0 0 1 .049-.213.299.299 0 0 1 .1-.132.242.242 0 0 1 .189-.031.337.337 0 0 1 .263.249c.012.044.018.09.018.136v.059l1.261 32.113.39.072-1.393-32.839a5.19 5.19 0 0 0-.506-.185 7.22 7.22 0 0 0-1.268-.279 5.286 5.286 0 0 0-1.651.04 3.647 3.647 0 0 0-1.657.77c-.026 1.1-.053 3.231-.079 5.9-.026 2.669-.051 5.873-.075 9.128s-.044 6.557-.062 9.422c-.018 2.865-.031 5.29-.04 6.79l.442.081.076-30.632a.596.596 0 0 1 .05-.212.299.299 0 0 1 .1-.132.242.242 0 0 1 .193-.031.327.327 0 0 1 .261.248c.012.044.017.09.017.136.001.019.002.037.001.056Zm29.636 36.215-.858-24.1a.486.486 0 0 1 0-.054.51.51 0 0 1 .029-.115.238.238 0 0 1 .079-.106.224.224 0 0 1 .074-.029.215.215 0 0 1 .08.003.272.272 0 0 1 .138.062.266.266 0 0 1 .081.129.434.434 0 0 1 .017.154l1 24.17.41.077-1.117-24.54a.515.515 0 0 1 .035-.169.228.228 0 0 1 .079-.1.191.191 0 0 1 .152-.025.265.265 0 0 1 .221.189.393.393 0 0 1 .018.154l1.263 24.619.414.077-1.408-24.755a.469.469 0 0 1 0-.053.457.457 0 0 1 .03-.114.238.238 0 0 1 .08-.1.204.204 0 0 1 .075-.03.221.221 0 0 1 .081.003.265.265 0 0 1 .219.19.38.38 0 0 1 .018.152l1.559 24.83.338.065-1.562-24.726a.486.486 0 0 1 0-.054.464.464 0 0 1 .03-.115.24.24 0 0 1 .08-.106.202.202 0 0 1 .155-.026.263.263 0 0 1 .216.191.426.426 0 0 1 .017.152l1.726 24.8.319.063-1.852-25.377s-.151-.063-.4-.136a5.983 5.983 0 0 0-1-.2 4.426 4.426 0 0 0-1.3.033c-.474.084-.92.282-1.3.577l.247 3.423-.1-2.826a.486.486 0 0 1 0-.054.464.464 0 0 1 .03-.115.24.24 0 0 1 .08-.106.177.177 0 0 1 .074-.029.275.275 0 0 1 .229.076.275.275 0 0 1 .069.116.437.437 0 0 1 .019.154l.482 14.962.638 8.743-.004-.004Zm16.382 3.05.288.054-3.035-22.318s-.106-.041-.285-.093a5.642 5.642 0 0 0-.727-.159 4.518 4.518 0 0 0-.979-.044c-.358.021-.71.105-1.039.25l1.589 13.59-1.3-13.085a.384.384 0 0 1 .021-.148.195.195 0 0 1 .066-.094.172.172 0 0 1 .136-.023.27.27 0 0 1 .206.171c.011.03.019.062.022.094a.28.28 0 0 1 0 .041l2.218 21.241.368.071-2.338-21.574a.384.384 0 0 1 .02-.148.19.19 0 0 1 .065-.093.172.172 0 0 1 .136-.023.266.266 0 0 1 .206.166.38.38 0 0 1 .022.142l2.477 21.641.37.071-2.611-21.765a.448.448 0 0 1 .023-.15.204.204 0 0 1 .067-.094.172.172 0 0 1 .136-.024.263.263 0 0 1 .203.168.38.38 0 0 1 .022.142l2.756 21.827.306.057-2.752-21.737a.384.384 0 0 1 .02-.148.18.18 0 0 1 .065-.093.17.17 0 0 1 .136-.021.263.263 0 0 1 .204.166c.011.03.019.062.022.094a.28.28 0 0 1 0 .041l2.896 21.807Zm-39.166-36.47.428 29.256.433.082-.529-29.813c0-.022 0-.044.006-.066a.617.617 0 0 1 .038-.14.286.286 0 0 1 .1-.128.251.251 0 0 1 .188-.03.322.322 0 0 1 .166.077.324.324 0 0 1 .095.156.475.475 0 0 1 .019.13.542.542 0 0 1 0 .057l.7 29.9.505.092-.839-30.351a.572.572 0 0 1 .046-.206.293.293 0 0 1 .1-.128.226.226 0 0 1 .09-.035.244.244 0 0 1 .097.004.323.323 0 0 1 .166.075c.046.041.08.095.096.155a.51.51 0 0 1 .02.184l1.013 30.449.506.091-1.192-30.609a.552.552 0 0 1 .046-.204.293.293 0 0 1 .1-.128.234.234 0 0 1 .092-.035.231.231 0 0 1 .098.003.325.325 0 0 1 .177.091c.037.04.065.089.079.142a.517.517 0 0 1 .019.187l1.376 30.7.407.076-1.392-30.569a.572.572 0 0 1 .046-.206.293.293 0 0 1 .1-.128.237.237 0 0 1 .185-.032.32.32 0 0 1 .261.232.51.51 0 0 1 .019.185l1.539 29.847v.812l.422.078-.007-.171-.242-27.268a.528.528 0 0 1 .046-.197.286.286 0 0 1 .1-.123.226.226 0 0 1 .086-.033.224.224 0 0 1 .093.003.291.291 0 0 1 .249.22.483.483 0 0 1 .017.125.505.505 0 0 1 0 .055l.4 27.533.413.079-.491-28.067a.57.57 0 0 1 .045-.197.286.286 0 0 1 .1-.123.25.25 0 0 1 .087-.034.248.248 0 0 1 .094.003.302.302 0 0 1 .251.224.485.485 0 0 1 .019.18l.65 28.155.485.088-.785-28.584a.577.577 0 0 1 .045-.198.286.286 0 0 1 .1-.123.235.235 0 0 1 .182-.029.317.317 0 0 1 .172.088.32.32 0 0 1 .077.135.471.471 0 0 1 .019.178l.95 28.673.48.089-1.112-28.832a.56.56 0 0 1 .043-.195.284.284 0 0 1 .1-.122.237.237 0 0 1 .183-.031c.065.01.125.04.172.086a.321.321 0 0 1 .076.136.446.446 0 0 1 .018.126.505.505 0 0 1 0 .055l1.29 28.919.392.074-1.3-28.793a.567.567 0 0 1 .043-.197.274.274 0 0 1 .1-.123.235.235 0 0 1 .181-.03c.065.01.126.041.173.087a.318.318 0 0 1 .076.135c.012.04.018.082.018.124a.486.486 0 0 1 0 .054l1.046 20.451c0 .836.009 1.653.013 2.439l.012 2.253.01 2 .009 1.672.759.142-.432-7.93-.152-18.1a.558.558 0 0 1 .042-.187.274.274 0 0 1 .092-.118.249.249 0 0 1 .083-.033.247.247 0 0 1 .09.002c.062.009.12.038.164.082a.3.3 0 0 1 .073.13.44.44 0 0 1 .017.12.469.469 0 0 1 0 .053l.365 26.048.4.072-.456-26.558c0-.02 0-.04.006-.06a.51.51 0 0 1 .035-.127.267.267 0 0 1 .089-.116.223.223 0 0 1 .082-.032.232.232 0 0 1 .087.004.31.31 0 0 1 .168.084.31.31 0 0 1 .074.129.439.439 0 0 1 .017.119.451.451 0 0 1 0 .052l.611 26.639.458.085-.732-27.053a.59.59 0 0 1 .041-.186.251.251 0 0 1 .09-.116.226.226 0 0 1 .173-.028.284.284 0 0 1 .24.21.439.439 0 0 1 .017.119.451.451 0 0 1 0 .052l.891 27.135.457.084-1.046-27.285a.61.61 0 0 1 .042-.187.271.271 0 0 1 .091-.118.24.24 0 0 1 .083-.033.31.31 0 0 1 .254.087c.035.037.06.081.074.13a.483.483 0 0 1 .018.171l1.211 27.372.373.071-1.225-27.25c0-.02 0-.04.006-.06a.517.517 0 0 1 .035-.128.254.254 0 0 1 .09-.117.221.221 0 0 1 .17-.027.284.284 0 0 1 .24.21.426.426 0 0 1 .017.118.451.451 0 0 1 0 .052l1.394 27.334.35.067-1.572-27.982a4.808 4.808 0 0 0-.456-.157 6.539 6.539 0 0 0-1.141-.231 4.824 4.824 0 0 0-1.483.053 3.331 3.331 0 0 0-1.483.7c0 .434-.009 1.051-.011 1.812-.002.761 0 1.665 0 2.674s0 2.122.005 3.3.007 2.421.012 3.69l-.788-14.4a4.761 4.761 0 0 0-.48-.164 6.916 6.916 0 0 0-1.2-.242 5.11 5.11 0 0 0-1.556.056c-.57.11-1.103.36-1.551.729-.009.67-.014 1.755-.015 3.123v4.826c0 1.806.01 3.764.018 5.746l.023 5.884-1.253-22.864a7.15 7.15 0 0 0-1.746-.424 5.291 5.291 0 0 0-1.618.058 3.615 3.615 0 0 0-1.615.76 492.833 492.833 0 0 0-.012 5.573c.004 2.52.013 5.547.025 8.631.012 3.084.027 6.222.041 8.962l.034 6.572.433.081-.256-29.166a.554.554 0 0 1 .047-.204.307.307 0 0 1 .1-.128.248.248 0 0 1 .188-.033.33.33 0 0 1 .179.091c.038.04.064.088.079.141a.517.517 0 0 1 .019.13.544.544 0 0 1 .003.057ZM1380 177H-60v56h1440v-56ZM178.477 129.125V128.951a2.606 2.606 0 0 1 .757-1.603 2.482 2.482 0 0 1 1.6-.718v-.36h.308v-.43h-.278v-.46h.213l-.045-.126-.04-.11-.03-.08-.014-.037a.776.776 0 0 1-.02-.107c-.009-.058-.018-.134-.028-.21-.01-.076-.018-.152-.025-.212-.007-.06-.011-.1-.011-.116s.01-.094.026-.211l.057-.42.057-.411.026-.185.072-.341.158-.745.159-.752.076-.359c0-.01.02-.061.047-.132.027-.071.061-.163.1-.254l.094-.247.043-.111.1-1.036-.157.138-.007.022-.016.051-.018.056c-.005.017-.01.031-.011.039l-.012.05-.02.08-.019.075-.008.033v.177a.62.62 0 0 1-.038.106l-.026.054-.012.023-.036.008-.086.017a1.801 1.801 0 0 1-.106.016.503.503 0 0 1-.149-.009c-.011 0-.015-.009-.016-.013l-.001-.006.001-.005h.005l-.018-.046-.044-.11c-.018-.043-.037-.09-.057-.134-.02-.044-.039-.086-.056-.119a.143.143 0 0 0-.052-.062.067.067 0 0 0-.048-.01.085.085 0 0 0-.035.015.076.076 0 0 0-.014.011v-.028c-.004-.022-.008-.044-.014-.065a.362.362 0 0 0-.03-.077.188.188 0 0 0-.05-.062.515.515 0 0 1-.061-.053c-.019-.02-.038-.04-.055-.062a.535.535 0 0 1-.071-.115.061.061 0 0 1 .001-.03.066.066 0 0 1 .012-.027.494.494 0 0 1 .05-.07l.054-.068a.114.114 0 0 0 .025-.049.053.053 0 0 0-.015-.034.243.243 0 0 0-.034-.03l-.034-.021.001-.001-.338-.207V118.533a.205.205 0 0 1 0-.035c.003-.02.004-.041.005-.061v-.307c0-.021.002-.041.005-.062 0-.024.008-.05.013-.075a1.39 1.39 0 0 1 .035-.138.236.236 0 0 0 .011-.059.817.817 0 0 0 0-.07v-.164a.271.271 0 0 1 .009-.107l.012-.035a.39.39 0 0 0 .012-.049.54.54 0 0 1 .036-.077l.034-.092.039-.094.034-.084a1.254 1.254 0 0 1 .075-.162l.041-.079.037-.069.063-.125.1-.2.094-.187.042-.083.331-.874a12.05 12.05 0 0 1-.5.712 5.155 5.155 0 0 1-.506.579c-.151.152-.324.28-.513.381-.16.086-.341.128-.523.12-.411-.1-.575-.52-.566-1.108a6.555 6.555 0 0 1 .481-2.087 9.239 9.239 0 0 1 1.1-2.07c.288-.491.74-.864 1.277-1.053a.707.707 0 0 1 .452.111.774.774 0 0 1 .263.32c.059.131.096.271.11.414.014.13.012.262-.007.391l.035.026.078.059c.029.022.058.045.08.065.016.012.03.026.04.043a.077.077 0 0 1-.011.039.558.558 0 0 1-.032.056l-.033.051-.015.02.211-.031.012-.01.027-.024.03-.03a.157.157 0 0 0 .02-.025.097.097 0 0 1 .029-.028c.014-.01.032-.02.048-.03l.048-.022.02-.01.029-.026.063-.064a2.224 2.224 0 0 0 .104-.1.14.14 0 0 0 .01-.035c0-.015.005-.033.007-.051.002-.018 0-.037 0-.054v-.334a.318.318 0 0 0-.006-.043.108.108 0 0 0-.029-.055.412.412 0 0 0-.031-.028l-.049-.033-.055-.037a.5.5 0 0 1-.051-.04.118.118 0 0 1-.027-.032.023.023 0 0 1 0-.02v-.015c.002-.004.002-.008.002-.012a.037.037 0 0 0-.005-.011.077.077 0 0 1-.007-.026c0-.012 0-.026-.006-.041-.006-.015 0-.031-.006-.046a.169.169 0 0 0-.012-.044.178.178 0 0 1-.018-.043.216.216 0 0 1 0-.036v-.079a.369.369 0 0 1 0-.047c0-.016 0-.032.008-.049s.006-.033.008-.049a.369.369 0 0 0 0-.047v-.056c0-.021 0-.044.006-.066.006-.022 0-.045.007-.065.007-.02 0-.038.007-.051a.15.15 0 0 1 .013-.041.437.437 0 0 1 .022-.043.633.633 0 0 0 .04-.09c0-.015.008-.029.012-.043.004-.014.013-.022.019-.038l.014-.036.016-.038a.388.388 0 0 1 .024-.045l.033-.054a.582.582 0 0 0 .085-.213v-.056a.178.178 0 0 1 .016-.051l.037-.079.042-.083.033-.06c.008-.015.016-.022.024-.022a.03.03 0 0 1 .013.003.044.044 0 0 1 .011.008.137.137 0 0 1 .019.023l.007.012.227.131.015-.1-.01-.04-.018-.1-.018-.113a.642.642 0 0 1-.009-.087c-.001-.006 0-.012.004-.016a.02.02 0 0 1 .014-.009.086.086 0 0 1 .039.006.33.33 0 0 1 .039.017l.018.01.121-.023-.009-.015c0-.01-.011-.024-.017-.042-.006-.018-.014-.037-.02-.059a.426.426 0 0 1-.015-.069c-.003-.014-.004-.029-.005-.043v-.011l.006.007v.008l-.036-.174-.166.008h-.007l-.018-.011-.028-.017-.036-.021a.071.071 0 0 1-.028-.029.142.142 0 0 1-.012-.04c0-.015 0-.033-.005-.052-.005-.019 0-.04-.007-.063s-.011-.048-.014-.062c-.003-.014 0-.031 0-.044V108.228c0-.03 0-.066-.005-.1s0-.079-.005-.117c-.005-.038 0-.073 0-.1a.452.452 0 0 1-.003-.09.59.59 0 0 1 .019-.069c.006-.02.015-.038.015-.047l.011-.017h.135l.309.007.12-.081.2-.1.2.016.211.146.2.407.128.515.008.775.2.246.135.261-.15.184v.784l-.136.23-.211.139s0 .015.006.039.009.057.015.093.015.073.024.107a.345.345 0 0 0 .031.083.27.27 0 0 1 .026.072.644.644 0 0 1 .013.088c0 .03 0 .059.005.085.005.026 0 .048 0 .063v.323a.23.23 0 0 0 .016.077.633.633 0 0 0 .072.143l.016.025.166.169.07.042.16.1.177.108c.054.033.1.061.12.076.02.015.057.042.095.074l.12.1.1.091.038.039.18.737.06.338.045.215.286.569.573.493.527.692.769.755.272.061h.422l.174.09 1.7-3.408-.083-.131V113.552a.21.21 0 0 1 0-.05c0-.014.007-.023.015-.023h.139l.02.006a.045.045 0 0 0 .023 0c.004-.001.007-.004.01-.007s.006-.006.007-.01c0-.01.009-.028.016-.051l.02-.074.017-.067.007-.029-.014-.178 1.195-1.755-.672 2.046-.151.039-.076.092-.037.077.03.116.007.093-.1.062-.083.007h-.023l-1.77 3.568.189.054.015.169-.045.215-.152.215-.181.077-.106.277h-.166l-.049-.02-1.824 3.669v.065l-.036.066a4.914 4.914 0 0 1-.186.304.38.38 0 0 1-.079.091.105.105 0 0 0-.041.056.339.339 0 0 0-.017.084.631.631 0 0 0 0 .087v.135c0 .03-.007.064-.011.1l-.011.1c-.003.031 0 .055 0 .07 0 .015 0 .068-.009.138s-.013.159-.021.247l-.021.247c-.006.07-.01.122-.01.137a.229.229 0 0 0 .033.079 2.97 2.97 0 0 0 .145.214l.033.044-.151.276-.489.158v.639h.482v.461h-.293v.431h.31v.361a2.509 2.509 0 0 1 1.606.733c.434.433.703 1.004.76 1.614V129.656l-.005.031-.006.031-.006.03-.006.031-.006.033-.006.032-.007.032-.007.033v.032c-.064.24-.163.47-.293.682a2.715 2.715 0 0 1-1.077.992c-.22.112-.456.19-.7.232h-.873l-1.049-.013-2.055-.008-1.467-.019-.617.007-.271-.015h.494l5.421.042-5.7-.031a2.513 2.513 0 0 1-1.535-.561 2.595 2.595 0 0 1-.88-1.364v-.027l-.018-.044-.008-.041-.008-.041-.008-.042v-.544c0-.007-.042-.014-.042-.021Zm8.414-9.053.017.1.038.234.04.246c.011.071.021.123.025.139a.99.99 0 0 0 .028.084l.046.124.043.112.019.049.026.35 1.621-3.251-.056-.049-.058-.05-.055-.047-.046-.039a.885.885 0 0 1-.069-.064l-.079-.082-.065-.07-.027-.03-.3-.186-1.07-.677.044.063.085.124c.031.046.063.093.088.134.02.03.038.061.053.094a.362.362 0 0 1 .017.087c0 .037.006.082.006.128s0 .094-.006.139a.995.995 0 0 1-.017.122.451.451 0 0 1-.039.1.887.887 0 0 1-.055.094c-.019.028-.037.051-.05.068l-.022.026-.18.23.009.04c.008.02.02.048.031.079s.022.064.031.1a.351.351 0 0 1 .014.085.654.654 0 0 1-.016.108c-.01.046-.023.1-.036.148-.013.048-.026.1-.036.131l-.016.057-.06.354.077.596Zm-8.912 27.042v4.357l-.977-.014v-4.356l.977.013Zm11.742 4.478-12.719-.135v-4.356l.978.009v-.556l1.231.011v-.694h-.342v-1.132l.934.008v-1.821l1.273.01v-10.422l5.537.031v10.437l1.277.011v1.821l.939.008v1.131h-.339v.7l1.233.011v1.27l-.002 3.658Zm.986-4.365v4.371l-.984-.01v-4.374l.984.013Z",
                                fill: "#1B023F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                        clipPath: "url(#hero-darkmode-desktop_svg__e)",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "M1440 0H0v185h1440V0Z",
                                fill: "#7E1BD4"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M952.586 185 880.033 23.594 620.972 12 488 177.832V185h8.163L598.654 55.422 568.112 185h154.777l88.01-38.499L805.818 185h36.325l5.605-41.488L888.582 185h47.581l-79.334-80.744 23.383-48.06 60 128.804h12.374ZM639.117 40.657l150.044 64.689-181.563 71.316 31.519-136.005Zm59.131-13.668L851.079 33.2l-26.763 48.996-126.068-55.207Z",
                                fill: "#892ED8"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                d: "m767.645 98.287-.007-1.889-31.083-17.094.439 4.466 30.651 14.517Zm30.195 16.009.103-1.23-8.989-5.001.153 1.705 8.733 4.526Zm-61.052-36.784 6.179 3.49-.378-2.342-5.467-4.986-.334 3.838Zm-88.752 26.826 87.53-16.605-.858-8.468-86.783 19.386.177 3.077-.633.394.267.639.3 1.577Zm87.103-28.886 1.149-3.133-9.24-.319-.272 2.38-4.767.062.029 2.082-33.837-1.63-.497 6.69-2.527.33.264-2.526-4.6 1.25.034 2.223-3.274.341.275-1.34-10.805 4.302-11.803 6.837-5.189 1.403 3.096-1.819-.32-1.182-2.356 1.364-.17-1.189-5.177 2.151.505 3.702 1.048.132 88.599-20.773-.165-1.338Zm2.419 12.269 61.411 30.498-.403-2.121-29.702-15.055-31.471-15.679.165 2.356Zm-91.171 56.345 60.282-6.506-59.549 4.634-.733 1.872Zm154.2 4.788-64.443-11.367.281 5.747L801 149.636l-.413-.782Zm-.114 1.899-63.848-6.039.114 3.461 63.734 2.578ZM639 151l63.876-2.899 31.197.276-.162-12.482-30.652 4.078-61.488 4.576-.121 1.1 57.239-3.546-39.215 3.688-20.206 1.25L639 151Zm22.591-46.787 3.688 1.968v-.853l-3.593-1.914-6.425 1.193-.066.87 6.396-1.264Zm6.984 2.066-2.044 33.381.482-.033 1.961-33.873c0-.025.008-.05.013-.074a.785.785 0 0 1 .056-.156.38.38 0 0 1 .114-.143.281.281 0 0 1 .101-.038.275.275 0 0 1 .107.005c.073.013.14.05.191.104a.345.345 0 0 1 .076.16c.011.048.014.097.011.147 0 .021 0 .042-.007.063l-1.772 33.743.558-.04 1.647-34.101a.697.697 0 0 1 .067-.227.348.348 0 0 1 .114-.141.266.266 0 0 1 .101-.036.262.262 0 0 1 .108.005c.073.011.14.047.19.102a.341.341 0 0 1 .075.158.587.587 0 0 1 .001.209l-1.428 33.965.544-.037 1.266-34.004a.602.602 0 0 1 .013-.074.643.643 0 0 1 .049-.154.364.364 0 0 1 .114-.141.263.263 0 0 1 .21-.03c.073.012.14.049.19.103.038.045.064.1.075.158.009.048.013.096.009.144a.34.34 0 0 1-.008.064l-1.049 33.873.44-.029 1.027-33.602a.653.653 0 0 1 .066-.227.348.348 0 0 1 .114-.141.284.284 0 0 1 .212-.033c.073.014.14.051.19.106.039.045.065.1.076.159.009.048.012.097.009.145a.448.448 0 0 1-.008.064l-.82 33.468.416-.03.729-34.136a5.64 5.64 0 0 0-.536-.198 7.592 7.592 0 0 0-1.355-.299 5.847 5.847 0 0 0-1.791.043 4.253 4.253 0 0 0-1.844.828c-.115 1.237-.297 3.684-.523 6.737-.226 3.053-.49 6.707-.751 10.372a11062.362 11062.362 0 0 0-1.211 17.176l.489-.034 2.244-33.517a.781.781 0 0 1 .069-.228.361.361 0 0 1 .121-.142.281.281 0 0 1 .101-.038.28.28 0 0 1 .108.005c.074.013.141.05.192.104a.346.346 0 0 1 .076.159c.01.048.014.097.01.146 0 .02 0 .041-.008.061l.023-.001Zm-3.133-2.664 6.595-1.307 3.824 2.034-.021-.883-3.732-1.978-6.621 1.236-.045.898Zm14.663.618-1.745 34.574.498-.034 1.66-35.082a.72.72 0 0 1 .067-.238.363.363 0 0 1 .123-.146.284.284 0 0 1 .106-.04.283.283 0 0 1 .112.006.333.333 0 0 1 .276.27c.01.05.014.1.012.15 0 .022 0 .045-.007.066l-1.458 34.947.571-.039 1.323-35.31a.715.715 0 0 1 .069-.236.358.358 0 0 1 .124-.146.29.29 0 0 1 .219-.034.354.354 0 0 1 .198.113c.04.048.067.105.08.165.01.05.014.1.012.15 0 .022 0 .045-.007.066l-1.112 35.166.571-.045.931-35.206a.717.717 0 0 1 .065-.238.357.357 0 0 1 .121-.146.28.28 0 0 1 .215-.033.348.348 0 0 1 .28.278.584.584 0 0 1 .002.216l-.722 35.074.457-.033.691-34.798a.654.654 0 0 1 .013-.075.62.62 0 0 1 .055-.16.353.353 0 0 1 .122-.146.28.28 0 0 1 .216-.035.358.358 0 0 1 .196.108c.04.048.067.105.08.165a.592.592 0 0 1 .004.217l-.478 34.66.427-.031.381-35.352a7.708 7.708 0 0 0-1.956-.512 5.967 5.967 0 0 0-1.848.045 4.344 4.344 0 0 0-1.893.856 681.964 681.964 0 0 0-.466 7.015c-.202 3.182-.432 6.979-.66 10.781-.228 3.802-.457 7.599-.645 10.76-.188 3.161-.336 5.684-.41 6.945l.5-.034 1.941-34.704a.839.839 0 0 1 .068-.238.37.37 0 0 1 .125-.147.286.286 0 0 1 .218-.036.342.342 0 0 1 .195.114c.04.047.067.104.079.165.01.049.013.1.01.15a.383.383 0 0 1-.007.058l.001-.006Zm29.31-8.875 4.263 2.233-.056-.974-4.146-2.17-7.204 1.358-.029.988 7.172-1.435Zm-32.574 6.123 6.786-1.352 3.979 2.106-.032-.91-3.87-2.046-6.816 1.269-.047.933Zm15.433.314-1.458 36.11.515-.033 1.361-36.641a.651.651 0 0 1 .013-.077.719.719 0 0 1 .052-.169.375.375 0 0 1 .124-.152.29.29 0 0 1 .228-.037.358.358 0 0 1 .287.283.618.618 0 0 1 .007.222l-1.142 36.501.591-.043 1.014-36.87a.689.689 0 0 1 .068-.243.37.37 0 0 1 .124-.153.291.291 0 0 1 .22-.037c.08.015.153.054.208.114a.38.38 0 0 1 .086.168.563.563 0 0 1 .007.22l-.8 36.736.585-.042.606-36.772a.689.689 0 0 1 .068-.243.363.363 0 0 1 .125-.152.275.275 0 0 1 .111-.04.288.288 0 0 1 .117.006.36.36 0 0 1 .29.285.578.578 0 0 1 .007.224l-.394 36.626.476-.036.359-36.34a.683.683 0 0 1 .065-.245.372.372 0 0 1 .124-.151.294.294 0 0 1 .229-.034.36.36 0 0 1 .203.114c.041.048.07.107.083.169a.578.578 0 0 1 .007.223l-.143 36.197.448-.029.029-36.911a5.723 5.723 0 0 0-.57-.211 8.151 8.151 0 0 0-1.447-.321 6.155 6.155 0 0 0-1.903.045 4.404 4.404 0 0 0-1.941.881 707.73 707.73 0 0 0-.428 7.552c-.182 3.426-.391 7.52-.594 11.567a9820.9 9820.9 0 0 0-.562 11.272l-.329 6.685.518-.037 1.665-36.252a.7.7 0 0 1 .067-.244.374.374 0 0 1 .125-.151.293.293 0 0 1 .108-.04.274.274 0 0 1 .114.006.364.364 0 0 1 .205.113c.041.049.07.107.083.17a.625.625 0 0 1 .014.156.632.632 0 0 1-.018.062l-.007-.001Zm-3.386-2.842 6.977-1.396 4.121 2.171-.044-.943-4.011-2.108-7.004 1.317-.039.96Zm26.37-4.572 7.368-1.477 4.405 2.302-.062-1-4.288-2.238-7.397 1.394-.026 1.02Zm-56.446 13.663-2.169 32.334.435-.037 2.116-32.807a.647.647 0 0 1 .063-.22.337.337 0 0 1 .114-.137.217.217 0 0 1 .092-.036.208.208 0 0 1 .099.006.29.29 0 0 1 .173.101.33.33 0 0 1 .067.153.607.607 0 0 1-.001.202l-1.932 32.687.506-.037 1.816-33.03c0-.024.007-.048.013-.071a.729.729 0 0 1 .051-.149.35.35 0 0 1 .114-.136.242.242 0 0 1 .191-.031.3.3 0 0 1 .173.101.347.347 0 0 1 .068.153.542.542 0 0 1 .002.201l-1.633 32.904.497-.038 1.468-32.938a.714.714 0 0 1 .062-.22.356.356 0 0 1 .114-.138.232.232 0 0 1 .189-.032c.068.013.13.048.174.102.036.045.06.098.069.154a.607.607 0 0 1 .008.141c-.001.021-.004.042-.007.063L660.46 140.1l.405-.03 1.256-32.551a.72.72 0 0 1 .06-.222.356.356 0 0 1 .114-.138.236.236 0 0 1 .191-.03.31.31 0 0 1 .173.099.347.347 0 0 1 .068.153c.008.046.011.093.008.139a.42.42 0 0 1-.007.062l-1.063 32.435.381-.029.986-33.078a4.629 4.629 0 0 0-.486-.192 6.518 6.518 0 0 0-1.227-.29 4.938 4.938 0 0 0-1.627.04 3.782 3.782 0 0 0-1.682.796c-.114 1.2-.305 3.579-.54 6.546-.235 2.967-.51 6.52-.783 10.072-.273 3.552-.543 7.101-.767 10.061-.225 2.96-.402 5.33-.492 6.523l.448-.035 2.345-32.452a.661.661 0 0 1 .063-.221.328.328 0 0 1 .114-.136.236.236 0 0 1 .191-.031.296.296 0 0 1 .172.101.348.348 0 0 1 .066.154.59.59 0 0 1 .007.139.377.377 0 0 1-.022.059Zm49.3-9.184-.47 37.829.606-.042.272-37.867a.731.731 0 0 1 .065-.25.377.377 0 0 1 .126-.156.301.301 0 0 1 .229-.037.378.378 0 0 1 .212.114c.044.05.074.11.089.175a.608.608 0 0 1 .017.159.401.401 0 0 1 0 .07l-.063 37.72.494-.035.018-37.42a.728.728 0 0 1 .066-.253.39.39 0 0 1 .127-.158.295.295 0 0 1 .228-.04.372.372 0 0 1 .211.114c.044.05.074.11.087.176a.617.617 0 0 1 .007.23l.206 37.284.456-.033-.327-38.012a6.06 6.06 0 0 0-.592-.218 8.38 8.38 0 0 0-1.484-.33 6.24 6.24 0 0 0-1.956.047 4.475 4.475 0 0 0-1.99.91 680.589 680.589 0 0 0-.368 7.747 4640.56 4640.56 0 0 0-.502 11.875c-.172 4.158-.343 8.268-.472 11.605-.129 3.338-.228 5.899-.275 6.956l.534-.043 1.362-37.332a.73.73 0 0 1 .066-.25.373.373 0 0 1 .128-.154.305.305 0 0 1 .229-.035.375.375 0 0 1 .212.113c.043.05.073.11.087.174a.608.608 0 0 1 .013.16c0 .022 0 .046-.006.069l-1.149 37.19.529-.038 1.052-37.73a.78.78 0 0 1 .065-.251.366.366 0 0 1 .126-.157.285.285 0 0 1 .228-.035.37.37 0 0 1 .301.286.568.568 0 0 1 .008.229l-.835 37.589.608-.047.685-37.973a.785.785 0 0 1 .069-.251.38.38 0 0 1 .128-.156.293.293 0 0 1 .228-.035.377.377 0 0 1 .211.114c.043.05.074.11.088.173a.6.6 0 0 1 .016.158.855.855 0 0 1 0 .072Zm25.652-4.56.182 40.49.273-.021.367.068-.39-40.626a.762.762 0 0 1 .062-.266.385.385 0 0 1 .13-.166.314.314 0 0 1 .242-.04c.088.016.168.06.228.124a.44.44 0 0 1 .097.185.637.637 0 0 1 .02.169v.074l.637 40.734.516.095-.662-40.549a.813.813 0 0 1 .066-.267.394.394 0 0 1 .131-.166.302.302 0 0 1 .24-.037.41.41 0 0 1 .228.12c.047.053.08.116.097.184a.637.637 0 0 1 .02.168v.074l.913 40.664h.281v.055l.526.095.731-37.115a.726.726 0 0 1 .065-.253.371.371 0 0 1 .125-.158.296.296 0 0 1 .229-.038c.083.014.16.054.219.114.046.05.078.111.094.177.013.053.02.108.019.163v.071l-.53 37.214.525.098.426-37.897a.705.705 0 0 1 .06-.256.35.35 0 0 1 .124-.158.297.297 0 0 1 .228-.035.371.371 0 0 1 .216.114.4.4 0 0 1 .09.177.601.601 0 0 1 .011.235l-.206 37.996.612.114.04-38.546a.801.801 0 0 1 .063-.255.362.362 0 0 1 .125-.158.296.296 0 0 1 .229-.037.384.384 0 0 1 .215.113c.045.05.077.111.093.176a.619.619 0 0 1 .018.16v.071l.162 38.655.613.113-.367-38.848a.798.798 0 0 1 .061-.254.363.363 0 0 1 .126-.158.288.288 0 0 1 .228-.036.39.39 0 0 1 .216.113c.044.05.076.111.092.177.013.052.02.107.019.161v.07l.6 38.953.495.09-.626-38.778a.8.8 0 0 1 .064-.253.368.368 0 0 1 .124-.157.286.286 0 0 1 .228-.035.383.383 0 0 1 .216.113.41.41 0 0 1 .093.177c.013.052.02.107.019.161v.07l.851 38.762h.468l-1-39.535a6.322 6.322 0 0 0-.602-.219 8.55 8.55 0 0 0-1.509-.332 6.318 6.318 0 0 0-1.974.048 4.442 4.442 0 0 0-1.993.92 441.452 441.452 0 0 0-.184 5.797 4392.805 4392.805 0 0 0-.478 19.038c-.077 3.247-.147 6.26-.203 8.683l-.95-37.198a8.954 8.954 0 0 0-2.214-.576 6.615 6.615 0 0 0-2.069.05 4.67 4.67 0 0 0-2.092.966 754.024 754.024 0 0 0-.26 8.615c-.104 3.911-.219 8.574-.329 13.128a8917.528 8917.528 0 0 0-.44 19.115l.561-.036.777-39.964a.818.818 0 0 1 .068-.266.389.389 0 0 1 .131-.166.31.31 0 0 1 .24-.04.412.412 0 0 1 .228.122c.047.053.08.117.097.185a.646.646 0 0 1 .02.17v.074l-.556 39.809.563-.043.437-40.381c0-.029 0-.057.01-.086a.768.768 0 0 1 .053-.181.4.4 0 0 1 .131-.168.306.306 0 0 1 .242-.04c.087.015.167.059.228.123a.435.435 0 0 1 .095.186.635.635 0 0 1 .016.168c0 .025 0 .049-.007.074l-.205 40.239.645-.046.048-40.643a.773.773 0 0 1 .067-.267.388.388 0 0 1 .131-.166.307.307 0 0 1 .24-.039.403.403 0 0 1 .324.308c.014.055.02.112.019.17a.727.727 0 0 1-.012.065l-.001-.005Zm-14.865 3.098-.854 38.534.548-.035.747-39.102a.77.77 0 0 1 .065-.26.367.367 0 0 1 .127-.161.305.305 0 0 1 .229-.035.377.377 0 0 1 .219.114.414.414 0 0 1 .091.18.62.62 0 0 1 .017.166.442.442 0 0 1 0 .073l-.522 38.945.624-.041.377-39.349c0-.027 0-.055.01-.082a.777.777 0 0 1 .054-.177.368.368 0 0 1 .128-.161.295.295 0 0 1 .235-.038c.083.014.16.054.219.114a.403.403 0 0 1 .093.18.702.702 0 0 1 .011.238l-.146 39.199.624-.044-.048-39.233a.759.759 0 0 1 .066-.256.375.375 0 0 1 .131-.159.295.295 0 0 1 .236-.037.387.387 0 0 1 .217.113.414.414 0 0 1 .091.181c.013.054.018.11.017.166v.073l.295 39.09.498-.04-.323-38.775a.77.77 0 0 1 .066-.26.372.372 0 0 1 .129-.16.291.291 0 0 1 .228-.038.397.397 0 0 1 .221.113.413.413 0 0 1 .094.18.644.644 0 0 1 .017.164.428.428 0 0 1 0 .071l.546 38.641.477-.038-.685-39.392a6.166 6.166 0 0 0-.613-.227 8.66 8.66 0 0 0-1.539-.341 6.477 6.477 0 0 0-2.015.049 4.578 4.578 0 0 0-2.041.937 729.772 729.772 0 0 0-.316 8.193c-.13 3.719-.277 8.157-.418 12.518a12649.735 12649.735 0 0 0-.591 18.854l.544-.042 1.077-38.686a.767.767 0 0 1 .066-.259.39.39 0 0 1 .13-.161.307.307 0 0 1 .236-.038c.084.014.16.053.218.114a.416.416 0 0 1 .092.18c.012.055.018.11.017.165a.753.753 0 0 1-.016.082Zm-71.709 8.815-.075.839 6.211-1.216 3.546 1.897v-.823l-3.457-1.848-6.225 1.151Zm3.556 3.317-2.48 31.451.427-.029 2.422-31.916c0-.023.006-.046.012-.069a.818.818 0 0 1 .05-.144.337.337 0 0 1 .109-.131.238.238 0 0 1 .186-.027.273.273 0 0 1 .164.097.334.334 0 0 1 .064.147.518.518 0 0 1-.002.195l-2.242 31.791.489-.033 2.141-32.123a.65.65 0 0 1 .064-.214.346.346 0 0 1 .114-.132.246.246 0 0 1 .09-.034.222.222 0 0 1 .096.006.278.278 0 0 1 .165.097.334.334 0 0 1 .064.147.618.618 0 0 1-.008.195l-1.966 32.001.486-.034 1.807-32.04a.742.742 0 0 1 .06-.213.315.315 0 0 1 .106-.131.239.239 0 0 1 .089-.036.239.239 0 0 1 .096.005.27.27 0 0 1 .164.097.322.322 0 0 1 .063.147.516.516 0 0 1 0 .136c-.002.019-.004.039-.008.059l-1.61 31.916.389-.03 1.59-31.661a.742.742 0 0 1 .063-.214.323.323 0 0 1 .114-.132.22.22 0 0 1 .186-.029.283.283 0 0 1 .165.097.342.342 0 0 1 .064.149.562.562 0 0 1 0 .195l-1.404 31.545.368-.028 1.326-32.169a4.579 4.579 0 0 0-.467-.185 6.237 6.237 0 0 0-1.182-.281 4.795 4.795 0 0 0-1.572.038 3.705 3.705 0 0 0-1.635.77c-.122 1.18-.343 3.538-.609 6.48-.266 2.941-.58 6.447-.888 9.938l-.863 9.801-.532 6.077.435-.028 2.651-31.576c0-.024.007-.048.013-.072a.664.664 0 0 1 .05-.144.337.337 0 0 1 .107-.132.234.234 0 0 1 .184-.031.282.282 0 0 1 .165.094.318.318 0 0 1 .065.148.523.523 0 0 1 .007.137c0 .021 0 .041-.002.062Zm84.383-19.912-7.596 1.438-.014 1.05 7.559-1.526 4.547 2.371-.073-1.033-4.423-2.3Zm24.059 12.064 4.119 2.02-.091-.898-3.996-1.956-1.656.329-1.221 1.109 2.845-.604Zm17.419 8.693-1.036.964 2.463-.519 3.61 1.747-.097-.776-3.513-1.698-1.427.282Zm-10.503-5.281 3.965 1.938-.087-.863-3.852-1.88-1.598.311-1.164 1.069 2.736-.575Zm4.68 2.561-1.11 1.023 2.608-.551 3.767 1.849-.078-.822-3.677-1.794-1.51.295Zm11.154 5.342-.982.909 2.338-.491 3.425 1.664-.087-.741-3.333-1.611-1.361.27Zm5.926 1.985-1.272.255-.913.855 2.184-.461 3.222 1.556-.091-.692-3.13-1.513Zm5.039 30.674-2.23-25.672a.531.531 0 0 1 .032-.176.238.238 0 0 1 .081-.114.2.2 0 0 1 .077-.029.193.193 0 0 1 .083.003.292.292 0 0 1 .234.198.444.444 0 0 1 .023.163l2.385 25.752.433.082-2.536-25.896a.493.493 0 0 1 .029-.174.223.223 0 0 1 .078-.113.203.203 0 0 1 .161-.028.286.286 0 0 1 .235.198.37.37 0 0 1 .021.114.4.4 0 0 1 0 .049l2.706 25.975.352.066-2.709-25.859a.503.503 0 0 1 .028-.176.215.215 0 0 1 .079-.113.192.192 0 0 1 .076-.03.193.193 0 0 1 .083.003.298.298 0 0 1 .158.077c.034.034.06.075.076.12a.446.446 0 0 1 .024.163l2.875 25.945.334.064-3.032-26.54s-.122-.048-.331-.114a6.64 6.64 0 0 0-.848-.185 5.387 5.387 0 0 0-1.142-.052c-.42.024-.833.121-1.22.289l1.506 15.841-1.169-15.249a.447.447 0 0 1 .025-.171.223.223 0 0 1 .078-.113.19.19 0 0 1 .158-.025.287.287 0 0 1 .236.196.404.404 0 0 1 .022.162l2.086 25.288.443.081Zm-41.424-47.418 4.176 2.16-.087-.937-4.061-2.09-2.617.494-1.392 1.185 3.981-.812Zm39.759 18.932-.701.796 1.338-.286 3.197 1.517-.114-.682-3.101-1.47-.619.125Zm-15.746 20.53-.839-23.509a.683.683 0 0 1 0-.064.525.525 0 0 1 .036-.136.278.278 0 0 1 .094-.127.25.25 0 0 1 .088-.035.248.248 0 0 1 .094.003.321.321 0 0 1 .266.228.513.513 0 0 1 .022.184l.931 28.31.429.078-1.042-28.861a.683.683 0 0 1 0-.064.589.589 0 0 1 .037-.135.275.275 0 0 1 .096-.125.23.23 0 0 1 .088-.034.234.234 0 0 1 .095.002.321.321 0 0 1 .263.228.503.503 0 0 1 .02.184l1.216 28.946.496.094-1.35-29.391a.682.682 0 0 1 .042-.203.282.282 0 0 1 .095-.126.237.237 0 0 1 .182-.031.321.321 0 0 1 .267.228.497.497 0 0 1 .022.183l1.527 29.483.496.093-1.699-29.643a.612.612 0 0 1 .041-.203.28.28 0 0 1 .096-.127.26.26 0 0 1 .09-.035.343.343 0 0 1 .276.093.334.334 0 0 1 .082.139.457.457 0 0 1 .022.183l1.884 29.741.399.078-1.89-29.614a.611.611 0 0 1 .041-.202.292.292 0 0 1 .096-.126.225.225 0 0 1 .185-.029.316.316 0 0 1 .259.228.454.454 0 0 1 .019.127.262.262 0 0 1 0 .056l2.083 29.704.385.07-2.23-30.388s-.187-.077-.498-.168a7.169 7.169 0 0 0-1.24-.249 5.257 5.257 0 0 0-1.598.057 3.535 3.535 0 0 0-1.589.749c0 .376.075 2.075.18 4.412.105 2.337.245 5.31.384 8.235a10183.666 10183.666 0 0 0 .551 11.509Zm-32.451-43.691 4.332 2.257-.065-.982-4.224-2.19-2.084.39-1.21 1.182 3.251-.657Zm43.923 49.942-1.256-25.689a.543.543 0 0 1 .036-.178.24.24 0 0 1 .084-.114.223.223 0 0 1 .079-.03.222.222 0 0 1 .085.004.282.282 0 0 1 .234.2.439.439 0 0 1 .019.164l1.452 26.378.444.08-1.58-26.771a.542.542 0 0 1 0-.057.513.513 0 0 1 .031-.121.241.241 0 0 1 .085-.114.207.207 0 0 1 .164-.027.296.296 0 0 1 .161.079.32.32 0 0 1 .074.124.546.546 0 0 1 .021.164l1.739 26.853.45.082-1.895-27a.53.53 0 0 1 .033-.18.236.236 0 0 1 .084-.113.21.21 0 0 1 .165-.029c.061.01.118.038.162.081.034.035.06.077.074.124a.441.441 0 0 1 .021.164l2.064 27.082.36.065-2.071-26.964a.533.533 0 0 1 .025-.173.247.247 0 0 1 .082-.114.22.22 0 0 1 .078-.031.216.216 0 0 1 .084.004.296.296 0 0 1 .161.079c.034.035.06.078.074.124a.441.441 0 0 1 .021.164l2.244 27.053.343.064-2.387-27.664s-.145-.058-.389-.128a6.524 6.524 0 0 0-.979-.205 5.126 5.126 0 0 0-1.298-.009 3.398 3.398 0 0 0-1.341.455l.038.506.028-.011.028-.008h.072a.29.29 0 0 1 .237.203.4.4 0 0 1 .02.162l.587 12.971.662 9.011.291 3.29Zm9.335-24.147 3.144 1.477-.121-.656-3.062-1.439-.597.114-.67.772 1.306-.268ZM748.1 102.452l.114 34.91.503.092-.228-35.56a.666.666 0 0 1 .057-.242.342.342 0 0 1 .114-.151.276.276 0 0 1 .219-.036.38.38 0 0 1 .208.114.379.379 0 0 1 .089.169.627.627 0 0 1 .019.155v.068l.421 35.659.587.114-.571-36.191a.722.722 0 0 1 .055-.243.332.332 0 0 1 .114-.15.268.268 0 0 1 .219-.033.373.373 0 0 1 .298.28c.014.05.021.102.02.154v.067l.783 36.284.585.114-.978-36.473a.662.662 0 0 1 .054-.242.341.341 0 0 1 .115-.15.27.27 0 0 1 .105-.04.386.386 0 0 1 .322.118.406.406 0 0 1 .091.168.545.545 0 0 1 .02.155v.067l1.2 36.572.473.087-1.217-36.42c.002-.026.004-.052.009-.078a.73.73 0 0 1 .047-.164.339.339 0 0 1 .114-.15.267.267 0 0 1 .216-.036c.08.015.153.055.209.114a.393.393 0 0 1 .091.169.585.585 0 0 1 .021.155v.067l1.439 36.503.446.081-1.591-37.327a6.217 6.217 0 0 0-.577-.211 8.332 8.332 0 0 0-1.448-.317 6.05 6.05 0 0 0-1.885.046 4.161 4.161 0 0 0-1.891.875c-.03 1.25-.061 3.673-.091 6.706a4802.61 4802.61 0 0 0-.085 10.376c-.028 3.7-.05 7.453-.071 10.71-.021 3.257-.035 6.013-.046 7.718l.505.092.087-34.819a.659.659 0 0 1 .057-.241.332.332 0 0 1 .114-.15.27.27 0 0 1 .22-.035.372.372 0 0 1 .298.282c.014.05.02.102.02.154a.683.683 0 0 1 .001.064Zm33.832 41.165-.98-27.394a.62.62 0 0 1 0-.061.587.587 0 0 1 .034-.131.27.27 0 0 1 .09-.121.23.23 0 0 1 .176-.029.3.3 0 0 1 .25.217.5.5 0 0 1 .019.175l1.142 27.474.468.087-1.276-27.894a.6.6 0 0 1 .041-.192.251.251 0 0 1 .09-.114.226.226 0 0 1 .173-.028.3.3 0 0 1 .252.215.486.486 0 0 1 .021.175l1.442 27.984.473.087-1.608-28.138a.62.62 0 0 1 0-.061.484.484 0 0 1 .035-.129.26.26 0 0 1 .091-.114.238.238 0 0 1 .086-.034.238.238 0 0 1 .092.003.307.307 0 0 1 .25.216.45.45 0 0 1 .02.173l1.78 28.224.386.074-1.783-28.106a.62.62 0 0 1 0-.061.538.538 0 0 1 .034-.131.271.271 0 0 1 .091-.12.233.233 0 0 1 .177-.03.304.304 0 0 1 .247.217.45.45 0 0 1 .019.173l1.971 28.19.364.071-2.114-28.845s-.173-.072-.457-.155a6.81 6.81 0 0 0-1.142-.227 5.057 5.057 0 0 0-1.484.037 3.4 3.4 0 0 0-1.484.656l.282 3.891-.114-3.212a.641.641 0 0 1 0-.062.542.542 0 0 1 .034-.13.282.282 0 0 1 .092-.121.227.227 0 0 1 .084-.033.32.32 0 0 1 .262.087.325.325 0 0 1 .078.131.468.468 0 0 1 .022.176l.55 17.007.729 9.938-.005-.005Zm18.702 3.467.328.061-3.464-25.368s-.121-.047-.326-.106a6.492 6.492 0 0 0-.83-.181 5.218 5.218 0 0 0-1.117-.05c-.409.024-.811.12-1.186.285l1.814 15.447-1.484-14.873a.446.446 0 0 1 .024-.169.23.23 0 0 1 .075-.107.22.22 0 0 1 .075-.029.307.307 0 0 1 .315.198.388.388 0 0 1 .025.153l2.533 24.145.42.08-2.669-24.523a.443.443 0 0 1 .022-.168.223.223 0 0 1 .075-.106.213.213 0 0 1 .075-.029.216.216 0 0 1 .08.003.3.3 0 0 1 .235.189.408.408 0 0 1 .025.161l2.828 24.6.422.08-2.98-24.74a.469.469 0 0 1 .026-.17.223.223 0 0 1 .076-.107.196.196 0 0 1 .155-.027.289.289 0 0 1 .156.077.326.326 0 0 1 .076.114.394.394 0 0 1 .025.161l3.147 24.81.349.065-3.142-24.708a.437.437 0 0 1 .023-.168.206.206 0 0 1 .074-.106.2.2 0 0 1 .156-.024.3.3 0 0 1 .156.075.3.3 0 0 1 .076.114.388.388 0 0 1 .025.153l3.307 24.788Zm-44.712-41.455.489 33.255.494.093-.604-33.888c0-.025 0-.05.007-.075a.718.718 0 0 1 .043-.159.34.34 0 0 1 .114-.146.296.296 0 0 1 .215-.034.363.363 0 0 1 .298.265.705.705 0 0 1 .022.213l.799 33.987.576.104-.958-34.499a.659.659 0 0 1 .053-.234.335.335 0 0 1 .114-.146.27.27 0 0 1 .214-.035.36.36 0 0 1 .299.261.549.549 0 0 1 .022.146.332.332 0 0 1 0 .063l1.157 34.611.578.104-1.361-34.793a.675.675 0 0 1 .052-.232.334.334 0 0 1 .115-.145.28.28 0 0 1 .216-.037.375.375 0 0 1 .203.104.395.395 0 0 1 .09.161.615.615 0 0 1 .021.213l1.571 34.896.465.086-1.589-34.747a.67.67 0 0 1 .052-.234.335.335 0 0 1 .114-.146.272.272 0 0 1 .212-.036.367.367 0 0 1 .298.264.599.599 0 0 1 .021.21l1.757 33.927v.923l.482.088-.008-.194-.276-30.995a.616.616 0 0 1 .052-.224.325.325 0 0 1 .114-.14.272.272 0 0 1 .205-.034.333.333 0 0 1 .284.25.523.523 0 0 1 .019.142.331.331 0 0 1 0 .063l.457 31.296.472.09-.561-31.904a.669.669 0 0 1 .051-.224.318.318 0 0 1 .115-.139.275.275 0 0 1 .206-.036.353.353 0 0 1 .287.255.567.567 0 0 1 .021.205l.742 32.003.554.1-.896-32.491a.683.683 0 0 1 .051-.225.325.325 0 0 1 .114-.14.281.281 0 0 1 .101-.038.275.275 0 0 1 .107.005.356.356 0 0 1 .285.254.553.553 0 0 1 .021.202l1.085 32.592.548.101-1.27-32.773a.65.65 0 0 1 .049-.221.329.329 0 0 1 .114-.139.283.283 0 0 1 .101-.039.28.28 0 0 1 .108.004.356.356 0 0 1 .197.098.351.351 0 0 1 .086.154.662.662 0 0 1 .021.206l1.473 32.872.447.084-1.484-32.729a.667.667 0 0 1 .049-.224.319.319 0 0 1 .114-.14.275.275 0 0 1 .207-.034.364.364 0 0 1 .197.099.349.349 0 0 1 .087.154.56.56 0 0 1 .021.202l1.194 23.246c0 .951.01 1.879.015 2.773l.013 2.561.012 2.273.01 1.901.867.161-.494-9.014-.173-20.574a.594.594 0 0 1 .048-.212.316.316 0 0 1 .105-.135.269.269 0 0 1 .197-.035c.071.01.137.043.188.093a.357.357 0 0 1 .083.148c.013.045.019.09.019.137a.3.3 0 0 1 0 .06l.417 29.608.457.082-.521-30.188c0-.023 0-.046.007-.068a.568.568 0 0 1 .04-.145.299.299 0 0 1 .102-.131.22.22 0 0 1 .093-.036.236.236 0 0 1 .099.004c.073.011.14.044.192.095.04.041.069.092.085.147a.512.512 0 0 1 .019.135.58.58 0 0 1 0 .059l.698 30.281.522.096-.835-30.751a.561.561 0 0 1 .047-.211.289.289 0 0 1 .102-.132.239.239 0 0 1 .096-.036.25.25 0 0 1 .102.004.332.332 0 0 1 .174.077.327.327 0 0 1 .1.162.512.512 0 0 1 .019.135.58.58 0 0 1 0 .059l1.017 30.844.522.096-1.194-31.015a.594.594 0 0 1 .048-.212.307.307 0 0 1 .104-.135.272.272 0 0 1 .094-.037.349.349 0 0 1 .29.099c.04.042.069.092.085.148a.613.613 0 0 1 .021.194l1.382 31.113.426.081-1.399-30.975c0-.022 0-.045.007-.068a.6.6 0 0 1 .04-.145.295.295 0 0 1 .103-.133.255.255 0 0 1 .094-.036.26.26 0 0 1 .1.005.32.32 0 0 1 .274.239.462.462 0 0 1 .019.134.29.29 0 0 1 0 .059l1.592 31.07.399.076-1.794-31.806a5.335 5.335 0 0 0-.521-.179 7.399 7.399 0 0 0-1.302-.262 5.527 5.527 0 0 0-1.693.06 3.804 3.804 0 0 0-1.693.795c0 .494-.011 1.195-.013 2.06s0 1.893 0 3.04 0 2.412.006 3.751.008 2.752.014 4.194l-.9-16.368a5.525 5.525 0 0 0-.548-.187 7.993 7.993 0 0 0-1.37-.275 5.846 5.846 0 0 0-1.776.064 3.97 3.97 0 0 0-1.771.829c-.01.761-.016 1.994-.017 3.549v5.486c0 2.053.011 4.279.021 6.532l.026 6.688-1.431-25.989a8.12 8.12 0 0 0-1.993-.482 6.025 6.025 0 0 0-1.847.066 4.128 4.128 0 0 0-1.844.863 572.617 572.617 0 0 0-.013 6.335c.004 2.865.014 6.305.028 9.811.014 3.505.031 7.072.047 10.187l.039 7.47.494.092-.292-33.152a.611.611 0 0 1 .054-.232.333.333 0 0 1 .114-.146.27.27 0 0 1 .103-.04.26.26 0 0 1 .111.003.379.379 0 0 1 .205.103.39.39 0 0 1 .09.16.623.623 0 0 1 .022.148.707.707 0 0 1 .003.065Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1426.43 100.596H1440V185H0v-84.342h13.58l.026-.686-.405-.108a3.802 3.802 0 0 0-.654-.11c-.338 0-.687-.206-.623-.36.022-.075-.064-.143-.229-.15a.607.607 0 0 1-.59-.71.675.675 0 0 0-.142-.5.761.761 0 0 1-.03-.853c.074-.14.074-.206 0-.206-.155 0-.144-.392 0-.492.074-.032.096-.24.074-.458-.03-.222 0-.448.087-.654.083-.207.138-.424.165-.645.006-.17.047-.336.12-.49.135-.459.14-.946.011-1.407-.079-.018-.023-.142.131-.319a.986.986 0 0 0 .26-.413c0-.086.036-.153.078-.153s.098-.242.11-.535c.004-.256.048-.51.13-.754a.383.383 0 0 0 .031-.337 2.905 2.905 0 0 1 .187-1.69c.173-.24.184-.392.12-1.093a2.039 2.039 0 0 1 .064-1.1c.106-.3.147-.62.12-.939-.01-.36.012-1.1.045-1.625.033-.525.097-1.506.142-2.162.001-.427.052-.851.151-1.266.088-.411.118-.833.09-1.254a11.42 11.42 0 0 1 .12-1.767c.063-.408.1-.82.108-1.233.002-.382.042-.762.12-1.136.08-.495.134-.994.162-1.495.078-1.505.153-2.073.307-2.246.1-.138.173-.293.218-.457.097-.406.424-.395.511.03.034.176.131.319.218.319.22 0 .296.276.35 1.175.025.396.077.79.153 1.18.058.218.092.442.1.668 0 .161.047.292.1.292.131 0 .21.654.11.927a.687.687 0 0 0 .066.535c.075.165.12.34.064.383-.008.444.06.887.2 1.31.076.352.126.71.151 1.07.078.675.185 1.123.285 1.123.044 0 .056.097.022.218-.034.12 0 .207.075.207.098 0 .098.043.023.142-.12.154-.045.722.11.722.052 0 .052.063 0 .175a.343.343 0 0 0 .01.38c.097.159.086.226-.034.3-.12.076-.133.13-.033.23.09.075.11.288.067.588-.045.339-.023.47.075.47s.12.15.078.608a4.34 4.34 0 0 0 .02 1.07c.045.24.045.47 0 .48-.025.366.058.73.24 1.049.068.092.11.201.12.316.037.153.12.29.24.394.196.142.196.153-.033.36-.285.264-.294.425-.185 1.964.064.926.183 1.351.383 1.351.051 0 .01.091-.1.2-.176.174-.209.339-.187.95.001.299.042.596.12.883.08.25.12.512.12.774-.012.287.058.571.2.82a1.738 1.738 0 0 1 0 1.486c-.12.233-.14.392-.053.534.1.424.04.87-.165 1.254a3.26 3.26 0 0 0-.26.686c-.142.568-.393.973-.6.973-.078 0-.154.033-.154.075 0 .198-.634.514-1.112.556l-.536.056.006.52h6.812a6.295 6.295 0 0 0-.008-.366c-.023-.35-.056-.395-.383-.459a1.94 1.94 0 0 1-1.277-1.505 1.964 1.964 0 0 0-.176-.635c-.098-.108-.109-.316-.109-1.08 0-.12-.03-.511-.064-.883-.056-.448-.033-.719.053-.819.108-.243.16-.507.154-.773.007-.21.03-.418.067-.624a4.834 4.834 0 0 0-.01-1.471.368.368 0 0 1 0-.373c.1-.455.157-.92.172-1.386l.003-.043c.064-1.085.07-1.169-.146-1.343-.218-.175-.218-.186-.03-.317.299-.475.436-1.033.39-1.593-.013-.942.054-1.884.2-2.816a.1.1 0 0 0-.045-.142c-.076-.034-.076-.22.011-.6.06-.236.078-.48.053-.722a.192.192 0 0 1 .045-.218.109.109 0 0 0 .069-.11.11.11 0 0 0-.013-.043.767.767 0 0 1 .042-.416 4.72 4.72 0 0 0 .12-.948c0-.242.03-.484.087-.72.053-.14.083-.287.09-.436.011-.176.052-.514.086-.743a2.9 2.9 0 0 0 .045-.916A6.83 6.83 0 0 1 21.238 77c.096-.475.154-.956.176-1.44 0-.644.098-1.06.218-.982.045.03.121-.09.154-.262.098-.428.304-.316.458.24.183.724.281 1.467.293 2.215.026.469.11 1.623.186 2.637l.014.198c.078 1.057.142 2.138.131 2.4-.021.22.002.442.067.653a29.68 29.68 0 0 1 .2 3.984c-.042.404-.005.811.11 1.2.097.11.108.404.066.97-.062.346-.04.701.064 1.037.102.335.154.684.154 1.036a4.54 4.54 0 0 0 .327 2.172c.142.24.184.403.12.47-.062.407-.037.824.075 1.22.436 2.663.371 3.865-.229 4.443-.338.316-1.112.545-1.112.327 0-.053-.056-.065-.12-.023-.1.38-.125.774-.072 1.162h4.845c.078-.129.183-.24.308-.325.23-.151.274-.252.274-.733 0-.555 0-.566-.405-.686a.953.953 0 0 1-.556-.392c-.075-.143-.184-.263-.218-.263-.067 0-.165-.305-.436-1.453-.142-.608-.187-1.33-.078-1.33.047 0 .022-.165-.053-.349-.158-.382-.158-.48.042-1.745.06-.317.08-.64.056-.962-.033-.087-.01-.154.042-.154a6.414 6.414 0 0 0-.019-1.93.447.447 0 0 1 .053-.326c.106-.418.154-.847.143-1.278.034-.963.011-1.263-.12-1.463-.086-.129-.12-.24-.064-.24.161 0 .26-.436.128-.567-.162-.174-.13-.309.045-.23l.011.005c.165.075.166.076.207-1.27.011-.544-.019-.939-.075-.939-.056 0-.068-.053-.023-.13.136-.207.158-.37.2-1.581.023-.612.068-1.213.09-1.333a.314.314 0 0 0-.078-.293c-.087-.056-.087-.099 0-.166.127-.076.227-.654.327-1.8.017-.273.057-.592.082-.802l.018-.148c.015-.133.038-.496.063-.895l.024-.392c.025-.536.08-1.07.162-1.6.056-.353.112-.733.112-.853a4.78 4.78 0 0 1 .271-1.94.64.64 0 0 0 .165-.373c0-.12.053-.206.12-.172.26.084.413.933.522 2.9.056 1.123.132 2.465.165 3 .033.534.066 1.285.075 1.678.01.394.053.686.11.656.055-.029.066.058.01.2-.087.253-.087.313 0 1.113.056.439.143 2.523.23 5.358-.003.628.045 1.256.142 1.877.078.417.114.84.11 1.265.01.559.033 1.16.055 1.333.037.304.117.6.237.882.058.297.073.6.045.9-.029.265.001.533.087.785a.176.176 0 0 1 .056.219c-.025.223-.008.448.053.665a5.21 5.21 0 0 1 .1 2.282c-.11 0-.11.023-.01.087.086.043.097.129.03.228a1.2 1.2 0 0 0-.109.5c0 .413-.086.677-.24.677-.053 0-.196.123-.316.273-.12.151-.243.252-.274.219-.03-.034-.138-.011-.238.042-.142.08-.209.067-.25-.02-.023-.078-.057.218-.057.642-.01.612.023.775.143.775.097 0 .142.056.086.176a.228.228 0 0 0 .1.263.2.2 0 0 1 .11.133H33.5l20.16 17.462.06-7.483.263-3.258-.129-1.3-.39-1.044s.39-.112.39-.463a4.14 4.14 0 0 0-.135-.844s.135-.677.135-.852c0-.175.518-.715.518-.715s-.3-.3-.126-.518c.131-.31.2-.644.2-.981l1.952-.008v1.37h.589v1.243h4.11l.326.518h.39c.035-.195.06-.391.072-.589v-1.044c.195-.008.389-.029.58-.063.215-.041.464-.065.464-.065v-.781h1.3v.781h4.762v.455h.972l.2-.518c.227-.172.467-.327.718-.463.175-.016.35-.016.526 0 0 0-.216 1.115 0 1.115h4.626v1.761h1.244v.326h.263l-.065.389-.715.2v17.769h3.719v-14.249l-.4-.389-.192-.389 1.107-.654.263-.979s.1-.326.326-.326h6.65v1.7h1.44l-.788.781v14.421h2.285v.084h7.28l13.526 3.526c.017-.343.096-.682.233-1.001.173-.24.184-.392.12-1.092a2.047 2.047 0 0 1 .064-1.1c.107-.301.147-.621.12-.939-.011-.361.012-1.101.045-1.626.033-.525.097-1.506.142-2.162.001-.426.052-.851.151-1.265.088-.412.118-.834.089-1.254-.005-.592.035-1.183.12-1.768.065-.408.101-.82.109-1.232.002-.382.042-.763.12-1.137.08-.495.135-.994.162-1.494.078-1.506.153-2.073.307-2.246.099-.139.173-.294.218-.458.097-.405.424-.394.511.031.034.176.131.318.218.318.22 0 .296.276.349 1.176.027.395.078.789.154 1.179.058.218.092.442.1.668 0 .162.047.293.1.293.131 0 .209.653.109.927a.7.7 0 0 0 .067.534c.075.165.12.341.064.383-.008.444.06.888.2 1.31.076.352.126.71.151 1.07.078.676.185 1.123.285 1.123.044 0 .056.097.022.218s0 .207.075.207c.098 0 .098.043.023.143-.12.154-.045.721.109.721.053 0 .053.064 0 .176a.348.348 0 0 0 .011.38c.097.158.086.225-.034.3-.12.075-.133.129-.033.229.089.075.109.289.067.589-.045.338-.023.469.075.469s.12.151.078.609c-.037.356-.03.715.02 1.07.045.24.045.469 0 .48-.025.365.059.73.24 1.048.068.092.11.201.12.316a.757.757 0 0 0 .24.394c.196.142.196.153-.033.36-.285.264-.294.425-.185 1.964.064.927.183 1.352.383 1.352.044 0 .02.066-.056.153l2.394.624c.1-.455.158-.918.172-1.384l.003-.044c.065-1.085.07-1.169-.146-1.342-.218-.176-.218-.187-.031-.318.3-.475.437-1.033.391-1.592-.013-.943.054-1.885.2-2.816a.101.101 0 0 0 .01-.082.091.091 0 0 0-.021-.037.092.092 0 0 0-.034-.024c-.076-.033-.076-.22.011-.6.061-.236.079-.48.053-.721a.196.196 0 0 1-.012-.117.19.19 0 0 1 .057-.101.103.103 0 0 0 .038-.026.1.1 0 0 0 .025-.039.131.131 0 0 0 .006-.027V119.336a.094.094 0 0 0-.013-.044.777.777 0 0 1 .042-.416c.072-.311.112-.628.12-.947 0-.243.03-.485.087-.721.053-.14.083-.287.089-.436.012-.176.053-.514.087-.743.064-.301.079-.611.045-.916.018-.389.068-.776.151-1.156.096-.476.155-.957.176-1.441 0-.643.098-1.059.218-.981.045.03.121-.09.154-.263.098-.428.304-.316.458.24a9.67 9.67 0 0 1 .293 2.215c.026.469.111 1.625.186 2.639l.014.196c.078 1.057.142 2.138.131 2.4-.021.22.002.442.067.654.156 1.322.223 2.653.2 3.984a3.12 3.12 0 0 0 .109 1.2c.098.109.109.403.067.97-.062.345-.04.7.064 1.036.103.335.155.685.154 1.036a4.562 4.562 0 0 0 .247 1.966l2.431.748.034-.219c.061-.317.079-.64.056-.961-.033-.087-.011-.154.042-.154a6.404 6.404 0 0 0-.019-1.93.45.45 0 0 1 .053-.327c.106-.418.154-.847.143-1.277.034-.964.011-1.264-.12-1.464-.086-.128-.12-.24-.064-.24.161 0 .259-.436.128-.567-.162-.173-.131-.308.045-.229l.011.005c.165.074.166.075.207-1.27.011-.545-.019-.939-.075-.939-.056 0-.068-.053-.023-.131.136-.207.158-.369.2-1.581.023-.612.068-1.213.09-1.333a.31.31 0 0 0-.078-.293c-.087-.056-.087-.098 0-.165.127-.076.227-.655.327-1.8.018-.274.057-.592.083-.803l.017-.147c.016-.133.038-.497.063-.896l.001-.021.023-.371c.025-.536.079-1.07.162-1.6.056-.352.112-.732.112-.852a4.798 4.798 0 0 1 .271-1.941.642.642 0 0 0 .165-.372c0-.12.053-.207.12-.173.259.084.413.933.522 2.9.056 1.123.132 2.466.165 3 .033.534.066 1.286.075 1.679.009.393.053.685.109.656.056-.029.067.058.011.2-.087.252-.087.312 0 1.112.056.439.143 2.523.229 5.358a11.92 11.92 0 0 0 .143 1.877c.078.417.115.84.109 1.265.011.559.034 1.16.056 1.333.037.304.117.601.237.883.058.296.073.599.045.9-.028.264.001.532.087.785a.173.173 0 0 1 .056.218c-.025.223-.007.449.053.665.04.146.073.294.1.443l47.981 14.775 1.163.011v-.694h-.342v-1.132l.934.008v-1.821l1.273.01v-10.422l5.537.031v10.437l1.277.011v1.821l.939.008v1.131h-.339v.7l1.233.011v.55l.984.013v3.17l28.541 8.101.085-.006c.29-.018.61-.039.907-.039.25-.007.501.016.743.069.134.033.272.05.412.049.258-.01.514-.042.762-.099a7.836 7.836 0 0 1 1.569-.161c.6 0 1.081.024 1.428.04l.098.005c.171.008.31.014.424.014.1 0 .347 0 .423-.098a1.42 1.42 0 0 1 .484-.222 1.64 1.64 0 0 1 .555-.043l.123.003.034.001.039.002.143.01c.438.041.51.168.582.302a.382.382 0 0 0 .159.185.536.536 0 0 0 .264.077c.058.006.117.009.175.009.18-.005.36-.02.537-.047a5.788 5.788 0 0 1 1.503-.034c.394.042.714.056.975.066.558.025.649.038.649.171a.57.57 0 0 0 .112.306c.081.129.071.137-.038.162-.391.086-.317 1.019-.238 1.568 0 .032.059.056.123.056h8.474c4.16 0 6.359.347 6.359 1.004 0 .294.379.379.725.403l.12.001a6.406 6.406 0 0 0 1.57-.137c.66-.183 6.041-.781 7.553-.885a16.45 16.45 0 0 0 1.601-.183 8.496 8.496 0 0 1 1.415-.125c.456.005.905.101 1.315.282a2.5 2.5 0 0 0 .933.22c.152 0 .31.012.477.024l.03.002.057.004c.181.013.365.025.574.025a4.082 4.082 0 0 0 1.506-.28c.643-.245.691-.328.654-.475-.015-.066-.034-.149.188-.344.094-.084.181-.176.258-.275.185-.232.224-.28 2.09-.458l.331-.032v-.253h1.818v-.473h57.635v.473h1.818v.473h1.301v.928h.027l.022.001.078.002.122.003h.3l.091-.001.053-.001a2.66 2.66 0 0 1 .127-.003h.4l.246.003.074.001h.048l.054.001h.079c.681 0 .995-.048 1.078-.169a9.98 9.98 0 0 0 .01-2.102l-.003-.009a.038.038 0 0 0-.008-.017.06.06 0 0 0-.023-.019.582.582 0 0 1-.108-.08h1.661l.143-.001c.068-.001.145-.003.23-.008.177-.008.379-.014.571-.014a1.62 1.62 0 0 1 .653.072 3.915 3.915 0 0 0 1.585.178c.189 0 .425-.017.678-.036l.062-.004c.29-.022.61-.045.906-.045.251-.008.502.018.744.078.133.038.272.057.411.056.259-.011.514-.048.763-.112a6.832 6.832 0 0 1 1.569-.183c.6 0 1.081.026 1.428.045l.098.005c.171.009.309.016.423.016.1 0 .348 0 .424-.111.14-.115.305-.201.484-.252.179-.052.368-.069.555-.049a4.402 4.402 0 0 1 .339.019c.438.046.509.19.581.342a.42.42 0 0 0 .16.211.49.49 0 0 0 .264.087l.06.006.023.001c.019.002.038.002.058.003h.034c.18-.005.359-.023.536-.053.293-.048.589-.073.886-.076.207 0 .413.013.618.037.394.048.713.064.975.076.558.028.649.043.649.194a.718.718 0 0 0 .111.348c.081.145.071.155-.037.183-.391.098-.317 1.158-.238 1.782 0 .037.059.064.123.064h8.474c3.935 0 6.116.353 6.339 1.023.483.008.965-.039 1.436-.14.659-.183 6.04-.781 7.552-.885a16.477 16.477 0 0 0 1.602-.183c.467-.081.94-.123 1.415-.125a3.35 3.35 0 0 1 1.314.282c.291.132.609.207.933.22.153 0 .31.012.477.024l.031.002c.2.014.4.029.63.029a4.084 4.084 0 0 0 1.507-.28c.642-.245.691-.328.654-.475-.015-.066-.034-.149.187-.344a2.03 2.03 0 0 0 .258-.275c.186-.232.225-.28 2.09-.458l.331-.032v-.253h1.818v-.473h57.635v.473h1.819v.473h1.301v.928h.03l.028.001.069.002.121.003h.3a6.293 6.293 0 0 0 .272-.005h.4l.246.003h.003l.251.002c.682 0 .995-.048 1.078-.169a9.913 9.913 0 0 0 .01-2.102.054.054 0 0 0-.011-.026.052.052 0 0 0-.01-.011l-.004-.003-.003-.002-.002-.002-.004-.001a.656.656 0 0 1-.108-.08h1.753l.076-.001c.062-.001.131-.004.205-.008a4.778 4.778 0 0 1 .249-.009c.107-.003.216-.005.323-.005.22-.021.443.004.652.072a3.915 3.915 0 0 0 1.585.178c.189 0 .425-.017.679-.036l.062-.004c.29-.022.609-.045.906-.045.251-.008.501.018.744.078.133.038.272.057.411.056.258-.011.514-.048.763-.112a6.823 6.823 0 0 1 1.568-.183c.601 0 1.081.026 1.428.045l.098.005c.171.009.31.016.424.016.1 0 .347 0 .423-.111.14-.115.305-.201.484-.252.179-.052.369-.069.555-.049.113.001.227.007.339.019.439.046.51.19.582.342a.42.42 0 0 0 .16.211.489.489 0 0 0 .263.087c.058.007.117.01.176.01.18-.005.359-.023.536-.053.292-.048.589-.073.886-.076.206 0 .412.013.617.037.395.048.714.064.975.076.559.028.65.043.65.194a.698.698 0 0 0 .111.348c.081.145.071.155-.037.183-.392.098-.318 1.158-.239 1.782 0 .037.06.064.124.064h8.473c4.16 0 6.359.394 6.359 1.141 0 .469.745.469 1.101.469.135 0 .278 0 .43-.008.151-.007.315-.007.476-.007h.004a2.29 2.29 0 0 1 .899.06c.291.079.56.215.789.398.307.349.167.982.017 1.649-.285 1.264-.6 2.696 1.697 3.132a7.829 7.829 0 0 1 2.801 1.185c.332.226.642.477.927.749h29.749l-.002-6.729 4.288.508 1.473-.566 4.172 2.632h14.402l6.231-3.579s14.273.849 21.264 0c4.752-.577 7.743-1.879 9.171-2.654v-.649c0-2.556.428-3.599.794-3.717.208-.066.311-.264.408-.456.131-.255.256-.498.604-.498.363.008.724.041 1.081.099.289.048.583.076.877.085.025 0 2.509-.059 2.673-.557a.775.775 0 0 1 .266-.343.943.943 0 0 1 .431-.173l.088.003.09.003c.134.006.319.013.521.013.437.024.875-.038 1.281-.18 2.024-.5 4.082-.889 6.162-1.163a9.421 9.421 0 0 0 1.307-.238c.373-.105.762-.16 1.154-.163.395.014.773.144 1.072.368.213.164.479.266.761.29.139.004.277.015.414.034.171.023.342.035.515.038a2.259 2.259 0 0 0 1.229-.369c.524-.321.564-.431.534-.624a.525.525 0 0 1 .024-.239.592.592 0 0 1 .128-.213c.081-.116.151-.236.211-.361.151-.305.183-.369 1.705-.604l.27-.043v-.333h1.483V149h.688l21.024.135h.688v.623h1.483v.621h1.062v1.22a2.326 2.326 0 0 0 .378.005l.069-.002.093-.003.058-.003.034-.001h.037l.215.003.046.001.065.002.186.004c.074.002.148.003.223.003.556 0 .811-.064.879-.222v-.428l-.009-.25-.008-.244a.094.094 0 0 0-.006-.028l-.006-.013a.055.055 0 0 0-.007-.009l-.003-.004-.006-.006a.545.545 0 0 1-.088-.105L675 146l52.426.969 4.575-1.969H737l-.5-4.5 53.51 8.099 37.175.14h.685v.673h1.479v.36l.269.046c.886.149 1.312.012 1.544-.063.165-.053.231-.074.294.063.06.136.13.266.21.392a.64.64 0 0 1 .152.488c-.03.209.01.328.533.676.352.254.782.394 1.225.399.172-.003.343-.017.513-.042l.114-.015.066-.007a3.64 3.64 0 0 1 .233-.014c.281-.027.547-.136.759-.314a1.818 1.818 0 0 1 1.069-.399c.391.004.779.064 1.151.178a8.7 8.7 0 0 0 1.303.256c2.074.297 4.126.717 6.144 1.258.405.154.842.221 1.277.195.202 0 .386-.008.521-.014l.027-.001.033-.001.029-.001h.003l.048-.002.019-.001h.017a.91.91 0 0 1 .431.187.839.839 0 0 1 .265.372c.163.538 2.64.601 2.665.601.293-.009.586-.04.875-.091a7.185 7.185 0 0 1 1.077-.108c.348 0 .472.263.602.538v.002c.097.207.2.421.408.493.364.127.791 1.255.791 4.021v3.576l.003.021v.003l.001.004a.069.069 0 0 0 .003.008l.004.007.002.004.002.003h5.297v.422h1.482v.42h1.06v.826c.035 0 .069.002.103.003l.099.003h.245l.117-.002.044-.002.06-.001h.326l.2.003.207.002c.556 0 .811-.043.879-.151a9.656 9.656 0 0 0 .008-1.87l-.001-.005-.001-.003-.003-.008-.002-.004-.002-.004-.007-.008-.006-.005-.002-.001-.004-.003a.464.464 0 0 1-.088-.071h1.354c.081 0 .182 0 .303-.008a11.707 11.707 0 0 1 .465-.012c.18-.019.362.003.532.064.413.149.855.203 1.292.158.153 0 .346-.015.553-.032l.05-.004c.236-.019.496-.04.738-.04.204-.006.408.017.606.07.108.034.221.05.335.049.21-.009.419-.042.621-.099a5.153 5.153 0 0 1 1.278-.163c.489 0 .881.024 1.164.041l.079.004c.14.008.252.014.345.014.082 0 .283 0 .345-.099a1.078 1.078 0 0 1 .847-.267c.092 0 .184.006.276.016.357.041.415.169.474.305a.374.374 0 0 0 .345.265c.047.006.095.009.142.009.147-.005.293-.021.437-.048a3.85 3.85 0 0 1 1.225-.034c.321.043.582.057.794.067.455.025.529.038.529.173a.68.68 0 0 0 .091.31c.066.129.058.138-.03.163-.319.087-.259 1.031-.194 1.586 0 .032.048.057.1.057h6.903c3.389 0 5.18.351 5.18 1.015 0 .418.608.417.897.417.11 0 .227 0 .351-.006.123-.007.256-.007.387-.007h.003a1.715 1.715 0 0 1 1.376.408c.25.311.136.874.014 1.468-.138.666.371.628 1.197.566.57-.042 1.29-.095 2.054.063.375.086 1.712-.516 3.124-1.151 1.698-.764 3.505-1.577 3.876-1.3.611 1.112 4.234-.359 7.059-1.505 1.802-.732 3.279-1.331 3.441-1.044v6.5h9.271a7.132 7.132 0 0 1 1.403-1.199 8 8 0 0 1 2.801-1.137c2.298-.419 1.982-1.794 1.697-3.007-.15-.641-.29-1.248.017-1.583.229-.176.498-.307.789-.383.292-.075.599-.095.899-.057H932.018l.107.001c.079.001.157.002.232.006.081.004.16.005.237.006l.193.001c.356 0 1.101 0 1.101-.45 0-.717 2.199-1.095 6.359-1.095h8.473c.065 0 .123-.027.123-.062.079-.599.154-1.616-.238-1.71-.108-.028-.118-.036-.037-.176a.652.652 0 0 0 .111-.335c0-.145.091-.159.65-.186.261-.011.581-.026.975-.072a5.306 5.306 0 0 1 1.503.037c.177.029.357.046.537.051.043 0 .086-.002.129-.005l.026-.003.02-.002a.5.5 0 0 0 .263-.083.41.41 0 0 0 .16-.203c.072-.146.143-.284.582-.329a5.371 5.371 0 0 1 .339-.017c.186-.019.376-.003.555.046.179.05.344.133.484.242.076.108.323.108.423.108.135 0 .304-.01.522-.021.347-.018.828-.044 1.428-.044.529.001 1.056.06 1.568.176.249.062.505.098.763.108.139.001.278-.018.411-.054.243-.057.493-.082.744-.075.297 0 .616.023.906.043l.062.005c.254.017.49.034.678.034a4.06 4.06 0 0 0 1.586-.171c.209-.065.432-.089.652-.069.193 0 .395.006.572.013a5.19 5.19 0 0 0 .372.009h1.662a.552.552 0 0 1-.108.076.071.071 0 0 0-.023.019.022.022 0 0 0-.005.008l-.002.004a.033.033 0 0 0-.004.013 9.138 9.138 0 0 0 .01 2.018c.083.116.396.163 1.078.163l.128-.001.244-.004.128-.001h.4c.044 0 .085.002.128.003l.114.003h.351l.016-.001h.024l.06-.002c.042-.002.084-.004.127-.004v-.89h1.301v-.454h1.819v-.455h57.633v.455h1.82v.243l.33.03c1.87.171 1.91.217 2.09.44.08.095.16.183.26.264.22.187.2.266.19.33-.04.141.01.221.65.456.48.179.99.271 1.51.269.13 0 .25-.005.36-.011l.09-.005.18-.012.03-.002c.16-.012.32-.023.48-.023.32-.013.64-.085.93-.211.41-.174.86-.266 1.31-.27.48.001.95.041 1.42.119.41.062.87.129 1.6.176 1.13.075 4.45.417 6.31.657.77-.431 2.81-.655 6.02-.655h8.47c.04 0 .08-.011.1-.028.01-.009.02-.021.02-.034.08-.599.16-1.616-.24-1.71-.1-.028-.11-.036-.03-.176a.68.68 0 0 0 .11-.335c0-.145.09-.159.65-.186.26-.011.58-.026.97-.072a5.37 5.37 0 0 1 1.51.037c.17.029.35.046.53.051.06 0 .12-.003.18-.01a.489.489 0 0 0 .26-.083.4.4 0 0 0 .16-.203c.07-.146.14-.284.58-.329.08-.007.16-.012.23-.015l.03-.001h.03l.05-.001c.19-.019.38-.003.56.046.18.05.34.133.48.242.08.108.32.108.42.108.12 0 .26-.007.43-.016l.1-.005c.34-.018.82-.044 1.42-.044.53.001 1.06.06 1.57.176.25.062.51.098.77.108.13.001.27-.018.41-.054.24-.057.49-.082.74-.075.3 0 .62.023.91.043l.06.005.32.021c.13.008.25.013.36.013a4.03 4.03 0 0 0 1.58-.171c.21-.065.43-.089.65-.069.2 0 .4.006.58.013.14.009.27.009.37.009h1.66c-.01.011-.02.022-.04.032a.167.167 0 0 1-.05.033l-.01.005-.01.006v.004c-.01.003-.01.006-.02.009v.006c-.01.008-.01.016-.01.025-.07.672-.07 1.347.01 2.018.08.116.39.163 1.08.163l.25-.003.08-.001.17-.002H1085.12l.04.001h.01l.1.003.1.002h.3l.12-.003c.04-.002.08-.004.13-.004v-.89h1.3v-.454h1.82v-.455h57.63v.455h1.82v.243l.33.03c1.87.171 1.91.217 2.09.44.08.095.16.183.26.264.22.187.2.266.19.33-.04.141.01.221.65.456.48.179.99.271 1.51.269.21 0 .39-.012.57-.024l.06-.004.03-.002a9.657 9.657 0 0 1 .47-.023c.33-.013.65-.085.94-.211.41-.174.86-.266 1.31-.27.48.001.95.041 1.42.119.41.062.87.129 1.6.176 1.51.099 6.89.674 7.55.85.52.105 1.04.149 1.57.131l.12-.001.16-.003.21-.004.08-.002H1169.9c.16.003.33.039.47.104.15.065.28.158.38.272.2.364 3.25.407 3.28.407.33 0 .69-.029 1.07-.062.43-.036.88-.072 1.33-.072.11-.004.22.011.32.044.02-.01.05-.02.08-.03l.08-.026.07-.018c.29-.075.6-.095.9-.057.16 0 .33 0 .48.007.15.007.29.007.43.007.35 0 1.1 0 1.1-.45 0-.717 2.2-1.095 6.36-1.095h8.47c.06 0 .12-.027.12-.062.08-.599.16-1.616-.24-1.71-.1-.028-.11-.036-.03-.176a.68.68 0 0 0 .11-.335c0-.145.09-.159.65-.186l.1-.005.07-.003.12-.006.27-.018c.13-.01.26-.023.41-.04a5.688 5.688 0 0 1 .62-.036c.3.003.59.027.89.073.17.029.35.046.53.051l.05-.001.03-.001.03-.002.03-.002.02-.002.02-.002a.489.489 0 0 0 .26-.083.4.4 0 0 0 .16-.203c.07-.146.14-.284.58-.329.12-.011.23-.016.34-.017.19-.019.38-.003.56.046.18.05.34.133.48.242.08.108.32.108.42.108h.02l.06-.001.05-.001.04-.002.26-.012.1-.005c.34-.018.82-.044 1.42-.044.53.001 1.06.06 1.57.176.25.062.51.098.77.108.13.001.27-.018.41-.054.24-.057.49-.082.74-.075.3 0 .62.023.91.043l.06.005.38.025.1.005c.07.002.14.004.2.004a4.03 4.03 0 0 0 1.58-.171c.21-.065.43-.089.65-.069l.23.002.35.011c.14.009.27.009.37.009h1.66c-.02.014-.03.028-.05.04a.273.273 0 0 1-.06.036c0 .002-.01.005-.01.007 0 .004-.01.008-.01.012 0 .003 0 .006-.01.009v.016c-.07.672-.07 1.347.01 2.018v.007l.01.01c.01.01.02.019.04.028.01.01.03.02.06.03l2.69-.764v-.045h.16l1.14-.324v-.13h.46l32.52-9.233v-2.976l.99-.013v-.55l1.23-.011v-.7h-.34v-1.131l.94-.008v-1.823l1.28-.01v-10.435l5.54-.032v10.422l1.27-.01v1.82l.93-.008v1.132h-.34v.694l.44-.004 47.78-14.713c.03-.172.07-.342.11-.51.07-.216.08-.442.06-.665a.164.164 0 0 1-.01-.119c0-.017.01-.032.01-.046.02-.021.03-.039.05-.053.09-.252.12-.52.09-.785-.03-.301-.01-.604.05-.9.12-.282.2-.579.23-.883.02-.173.05-.774.06-1.333-.01-.425.03-.848.11-1.265.09-.621.14-1.249.14-1.877.09-2.835.17-4.919.23-5.358.09-.8.09-.86 0-1.112-.06-.142-.05-.229.01-.2.06.029.1-.263.11-.656.01-.393.04-1.145.07-1.679.04-.534.11-1.877.17-3 .11-1.967.26-2.816.52-2.9.07-.034.12.053.12.173.01.138.07.269.17.372.22.621.31 1.282.27 1.941 0 .12.05.5.11.852.08.53.14 1.064.16 1.6l.04.632.01.197c.02.21.03.377.04.459 0 .038.01.088.02.146v.007c.01.121.03.276.05.438l.03.359c.1 1.145.2 1.724.33 1.8.08.067.08.109 0 .165a.262.262 0 0 0-.08.136v.013l-.01.015V117.736a.2.2 0 0 0 .01.076c.02.12.06.721.09 1.333.04 1.212.06 1.374.2 1.581.04.078.03.131-.03.131-.05 0-.08.394-.07.939.04 1.345.04 1.344.21 1.27l.01-.005c.17-.079.2.056.04.229-.13.131-.03.567.13.567.06 0 .02.112-.06.24-.13.2-.16.5-.12 1.464-.01.43.03.859.14 1.277.06.098.08.215.05.327a6.57 6.57 0 0 0-.02 1.93c.06 0 .08.067.05.154-.03.321-.01.644.05.961l.02.114.03.165 2.39-.737c.25-.649.34-1.346.27-2.037 0-.351.06-.701.16-1.036.1-.335.12-.691.06-1.036-.04-.567-.03-.861.07-.97.11-.389.15-.797.11-1.2a27.92 27.92 0 0 1 .2-3.984c.06-.212.09-.434.06-.654-.01-.262.06-1.343.14-2.4l.01-.186v-.061c.08-1.002.16-2.127.19-2.588.01-.747.11-1.491.29-2.215.15-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.981.02.484.08.966.17 1.441.09.38.14.767.16 1.156-.04.305-.02.615.04.916.03.229.08.567.09.743 0 .149.03.296.09.436.05.236.08.478.08.721.01.319.05.636.12.947.06.132.07.276.05.416-.01.013-.02.028-.02.044v.023c0 .007.01.015.01.022 0 .015.01.028.02.039s.03.02.04.026c.03.027.05.062.06.101.01.04 0 .08-.01.117-.03.241-.01.485.05.721.09.38.09.567.01.6-.01.003-.02.008-.02.014-.01.003-.01.007-.01.01l-.01.006v.007c-.01.003-.01.006-.01.009v.015c-.01.004-.01.007-.01.011v.031c0 .007 0 .014.01.021 0 .006 0 .013.01.019.14.931.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.18.131.18.142-.03.318-.22.173-.21.258-.15 1.343v.043c.02.466.08.93.18 1.386.01.017.01.036.02.055l2.42-.63-.01-.004c-.11-.109-.15-.2-.1-.2.2 0 .32-.425.39-1.352.1-1.539.1-1.7-.19-1.964-.23-.207-.23-.218-.03-.36a.77.77 0 0 0 .24-.394.605.605 0 0 1 .12-.316c.18-.318.26-.683.24-1.048-.05-.011-.05-.24 0-.48.05-.355.05-.714.02-1.07-.04-.458-.02-.609.08-.609.09 0 .12-.131.07-.469-.04-.3-.02-.514.07-.589.1-.1.08-.154-.04-.229-.12-.075-.13-.142-.03-.3l.03-.047a.341.341 0 0 0 .03-.142.265.265 0 0 0-.05-.191c-.05-.112-.05-.176 0-.176.16 0 .23-.567.11-.721-.07-.1-.07-.143.02-.143.08 0 .11-.086.08-.207-.01-.04-.02-.077-.02-.108 0-.046 0-.081.02-.098v-.004c0-.003.01-.004.01-.005 0-.002.01-.003.01-.003.1 0 .21-.447.29-1.123.02-.36.07-.718.15-1.07.14-.422.2-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.169.09-.26a.84.84 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.07-.39.12-.783.15-1.179.05-.9.13-1.176.35-1.176.09 0 .18-.142.22-.318.08-.425.41-.436.51-.031.04.164.12.319.22.458.15.173.23.74.3 2.246.03.5.09.999.17 1.494.07.374.11.755.12 1.137 0 .412.04.824.1 1.232.09.585.13 1.176.12 1.768-.02.42.01.842.09 1.254.1.414.15.839.15 1.265.05.656.11 1.637.15 2.162.03.525.05 1.265.04 1.626-.03.318.02.638.12.939.12.354.15.734.07 1.1-.07.7-.06.852.12 1.092a3 3 0 0 1 .23 1.064l13.52-3.524h7.27v-.149h2.29v-14.421l-.79-.781h1.45v-1.7h6.64c.23 0 .33.326.33.326l.26.979 1.11.654-.19.389-.4.389v14.314h3.72v-17.834l-.72-.2-.06-.389h.26v-.326h1.24v-1.761h4.63c.22 0 0-1.115 0-1.115.18-.016.35-.016.53 0 .25.136.49.291.71.463l.21.518h.97v-.455h4.76v-.781h1.3v.781s.25.024.46.065c.19.034.39.055.58.063v1.044c.02.198.04.394.07.589h.39l.33-.518h4.11v-1.243h.59v-1.37l1.95.008c0 .337.07.671.2.981.17.218-.13.518-.13.518s.52.54.52.715c0 .175.14.852.14.852-.08.276-.12.559-.14.844 0 .351.39.463.39.463l-.39 1.044-.13 1.3.26 3.258.07 7.552 20.16-17.466h4.34c.01-.095.05-.167.12-.2a.22.22 0 0 0 .1-.115c.01-.047.02-.1 0-.148-.05-.12-.01-.176.09-.176.12 0 .15-.162.14-.774 0-.425-.03-.721-.06-.643-.04.087-.1.1-.25.02-.1-.053-.2-.075-.23-.042-.04.033-.16-.067-.28-.218-.12-.151-.26-.274-.31-.274-.16 0-.24-.263-.24-.676 0-.173-.04-.343-.11-.5-.07-.1-.06-.185.03-.23.1-.063.1-.086-.01-.086a5.03 5.03 0 0 1 .1-2.282c.06-.216.08-.442.05-.665a.164.164 0 0 1-.01-.12c.01-.04.03-.074.07-.098.08-.252.11-.52.08-.785-.03-.301-.01-.604.05-.9.12-.282.2-.58.23-.883.03-.173.05-.774.06-1.333 0-.425.03-.848.11-1.265.1-.621.14-1.249.14-1.877.09-2.835.18-4.92.23-5.358.09-.8.09-.86 0-1.112-.05-.142-.04-.23.01-.2.06.029.1-.263.11-.656.01-.393.04-1.145.08-1.68.03-.533.11-1.876.16-3 .11-1.966.26-2.815.52-2.9.07-.033.12.054.12.174.02.138.07.269.17.372.22.621.31 1.282.27 1.94 0 .12.06.5.11.853.08.53.14 1.064.16 1.6l.03.396v.044c.02.38.05.72.06.848l.01.054.01.092c.02.21.06.53.08.804.1 1.145.2 1.724.33 1.8.08.067.08.109 0 .165a.263.263 0 0 0-.08.136.412.412 0 0 0 0 .157c.02.12.07.72.09 1.333.04 1.212.06 1.374.2 1.58.04.079.03.132-.02.132-.06 0-.09.394-.08.939.04 1.345.04 1.344.21 1.27l.01-.005c.18-.08.21.056.04.229-.13.13-.03.567.13.567.06 0 .02.112-.06.24-.13.2-.16.5-.12 1.464-.01.43.04.86.14 1.277.06.098.08.215.05.327-.1.638-.11 1.289-.01 1.93.05 0 .07.067.04.154-.03.321-.01.644.05.96.2 1.267.2 1.364.05 1.747-.08.184-.1.349-.06.349.11 0 .07.72-.08 1.33-.27 1.148-.36 1.453-.43 1.453-.04 0-.14.12-.22.263a.95.95 0 0 1-.56.39c-.4.12-.4.132-.4.688 0 .48.04.581.27.732.15.099.27.234.35.392h4.8v-.028c.06-.401.04-.81-.07-1.2-.06-.042-.12-.031-.12.022 0 .218-.77-.011-1.11-.327-.6-.578-.66-1.78-.23-4.442.12-.397.14-.814.08-1.221-.07-.067-.02-.23.12-.47.28-.686.4-1.432.33-2.172 0-.351.05-.7.15-1.036.1-.335.13-.69.06-1.036-.04-.567-.03-.861.07-.97.11-.39.15-.797.11-1.2-.02-1.331.04-2.662.2-3.984.07-.212.09-.434.07-.654-.01-.262.05-1.343.13-2.4l.01-.186.01-.06c.07-1.003.15-2.128.18-2.59.01-.746.11-1.49.29-2.214.15-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.98.02.485.08.966.18 1.442.08.38.13.767.15 1.156-.04.305-.02.615.04.916.04.229.08.567.09.743.01.149.04.296.09.436.06.236.09.478.09.72 0 .32.04.637.12.948a.84.84 0 0 1 .04.416c-.01.013-.01.028-.02.044 0 .015.01.03.01.045.01.015.01.028.03.039.01.011.02.02.03.026.03.027.05.062.06.101.01.04 0 .08-.01.117-.03.241-.01.485.05.72.09.38.09.568.01.6a.14.14 0 0 0-.03.025c-.01.011-.02.023-.02.037-.01.013-.01.028-.01.042.01.014.01.027.02.04.14.93.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.19.13.19.142-.03.318-.22.173-.21.258-.15 1.343v.043c.02.466.08.93.18 1.386.03.056.05.12.05.186v.033c-.01.03-.01.058-.02.085l-.03.068c-.08.487-.08.983-.01 1.472.03.205.06.414.06.623 0 .266.05.53.16.774.08.1.11.37.05.818-.03.372-.06.763-.06.883 0 .765-.01.972-.11 1.08-.1.2-.16.415-.18.635-.06.342-.21.662-.43.927-.23.265-.52.465-.85.579-.32.064-.36.109-.38.458-.01.144-.01.288-.01.433h6.81l.01-.587-.53-.056c-.48-.042-1.12-.358-1.12-.556 0-.042-.07-.075-.15-.075-.21 0-.46-.405-.6-.972a3.362 3.362 0 0 0-.26-.687 1.82 1.82 0 0 1-.17-1.254c.09-.142.07-.3-.05-.534a1.739 1.739 0 0 1-.17-.743c0-.257.06-.511.17-.743.14-.249.21-.533.2-.82 0-.262.04-.523.12-.773.08-.288.12-.585.12-.883.02-.612-.01-.777-.19-.95-.1-.11-.15-.2-.1-.2.2 0 .32-.425.39-1.352.11-1.54.1-1.7-.19-1.964-.23-.207-.23-.218-.03-.36.12-.103.2-.241.24-.394a.609.609 0 0 1 .12-.316c.18-.318.26-.683.24-1.048-.05-.011-.05-.24 0-.48.05-.355.06-.714.02-1.07-.04-.458-.02-.61.08-.61s.12-.13.07-.468c-.04-.3-.02-.514.07-.59.1-.1.09-.153-.03-.228-.12-.075-.13-.142-.04-.3a.315.315 0 0 0 .05-.087c.01-.033.01-.067.02-.102a.334.334 0 0 0-.06-.191c-.05-.112-.05-.176 0-.176.16 0 .23-.567.11-.721-.07-.1-.07-.143.03-.143.07 0 .1-.086.07-.207s-.02-.218.02-.218c.1 0 .21-.447.29-1.123.02-.36.07-.718.15-1.07.14-.422.21-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.169.09-.26a.634.634 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.07-.39.13-.784.15-1.18.06-.9.13-1.175.35-1.175.09 0 .19-.142.22-.318.09-.425.41-.436.51-.031.05.164.12.319.22.458.15.173.23.74.31 2.246.02.5.08.999.16 1.494.08.374.12.754.12 1.137.01.412.04.824.11 1.232.08.585.12 1.176.12 1.768-.03.42 0 .842.09 1.254.1.414.15.838.15 1.265.04.656.11 1.637.14 2.162.03.525.05 1.265.04 1.626-.02.318.02.638.12.939.13.353.15.734.07 1.1-.07.7-.06.852.12 1.092.23.532.29 1.12.18 1.69-.02.055-.02.114-.02.172.01.059.02.115.06.166.08.243.12.497.13.754.01.293.06.534.11.534.04 0 .07.067.07.154.05.157.14.299.26.413.16.176.21.3.13.318-.12.46-.12.948.02 1.408.07.153.11.32.12.489.02.22.08.438.16.645.09.206.12.432.09.654-.02.218 0 .427.07.458.15.1.16.492 0 .492-.07 0-.07.067 0 .207.08.129.12.279.12.43a.798.798 0 0 1-.15.422c-.05.07-.09.15-.12.236a.365.365 0 0 0-.02.102.44.44 0 0 0 0 .162c.01.086.01.175-.01.26a.66.66 0 0 1-.12.231.656.656 0 0 1-.33.204.452.452 0 0 1-.07.01.504.504 0 0 1-.06.005c-.17.008-.25.075-.23.15.06.155-.28.36-.62.36-.22.018-.44.054-.66.11l-.4.109.03.752ZM189.726 150.118v-2.184l-.001 2.183.001.001ZM58.882 122.643h1.17c-.001-.273-.004-.548-.007-.808-.008-.785-.015-1.44.008-1.542.079-.3.463-12.725.463-12.725l-.263-1.044-.263-.518.063-.716h-3.13v15.657l1.959 1.696Zm1322.308-.127 1.88-1.629v-15.724h-3.13l.07.716-.27.518-.26 1.044s.39 12.425.46 12.725c.03.102.02.754.01 1.538v.007c0 .259 0 .533-.01.805h1.25Zm-6.93-17.161h1.57v17.161h-2.61v-15.267l.19-.652.14-.589.13-.518.58-.135Zm-7.11.263h1.5v16.9h-1.7v-15.014l.2-.907.46-.463-.46-.516Zm-13.24 2.412h3.19v.652c.19.461.32.943.39 1.435-.05.222 0 12.725 0 12.725h-4.23c-.23-.391 0-12.988 0-12.988l.2-.781-.2-.392.13-.524.52-.127ZM64.163 105.482h1.57l.59.135.126.518.137.589.189.652v15.267h-2.612v-17.161Zm7.18.263h1.5l-.454.516.455.463.2.907v15.014h-1.7v-16.9Zm11.549 2.412h3.195l.523.127.127.524-.2.392.2.781s.224 12.597 0 12.988H82.5s.055-12.503 0-12.725c.072-.492.204-.974.39-1.435v-.652Z",
                                fill: "#1B023F"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1262.43 128.996v-.174a2.47 2.47 0 0 0-.24-.882 2.508 2.508 0 0 0-1.24-1.221c-.27-.126-.57-.2-.87-.218v-.36h-.31v-.43h.28v-.46h-.22l.05-.126.04-.11.03-.081.01-.037a.396.396 0 0 0 .02-.107c.01-.058.02-.134.03-.21l.01-.087c.01-.045.01-.088.02-.125v-.051c0-.032.01-.054.01-.065 0-.016-.01-.094-.03-.211l-.02-.147c-.01-.086-.02-.18-.04-.273l-.05-.408-.03-.185-.07-.342-.39-1.856c-.02-.045-.03-.089-.05-.132l-.04-.1-.06-.154-.09-.247-.05-.111-.1-1.036.16.138.01.022.01.056.02.056c0 .008 0 .017.01.026v.013l.01.05.02.08.02.075.01.033v.177c0 .015 0 .03.01.045l.03.061.02.054.01.023.04.008.09.017a.554.554 0 0 0 .26.007l.01-.004V119.967l.01-.046.05-.11.02-.049c.01-.019.01-.038.02-.057l.02-.028v-.005c.02-.042.04-.083.05-.114.01-.013.02-.026.02-.036.01-.01.02-.019.03-.026.02-.01.04-.013.05-.01.01.001.01.002.02.005.01.002.01.006.02.01l.01.011v-.028c0-.022.01-.044.01-.065l.03-.077c.02-.024.03-.045.05-.062a.306.306 0 0 0 .07-.053c.02-.02.03-.04.05-.062l.03-.031c0-.01.01-.021.02-.031a.112.112 0 0 0 .02-.053v-.043c0-.004-.01-.007-.01-.01v-.004l-.01-.008c0-.009-.01-.017-.01-.025a1.2 1.2 0 0 0-.03-.037c-.02-.024-.04-.048-.05-.068-.01-.009-.02-.019-.02-.029-.01-.007-.01-.013-.01-.02 0-.013.01-.025.02-.034a.212.212 0 0 1 .03-.03l.03-.021v-.007l.34-.207v-.503c0-.021-.01-.042-.01-.062 0-.026 0-.051-.01-.075 0-.016-.01-.033-.01-.049 0-.009-.01-.018-.01-.026v-.025c-.01-.014-.01-.027-.02-.038v-.017c0-.014-.01-.028-.01-.042v-.3c0-.014 0-.028-.01-.041l-.03-.04c0-.016-.01-.033-.01-.049v-.015l-.01-.015c0-.014 0-.028-.01-.041 0-.013-.01-.027-.01-.041l-.02-.05-.04-.094c-.01-.03-.02-.059-.03-.084-.01-.012-.01-.025-.02-.037 0-.014-.01-.028-.02-.042l-.02-.037c0-.016-.01-.031-.02-.046l-.04-.079-.04-.07-.06-.125-.1-.2-.09-.187-.05-.083-.33-.874c.17.253.34.494.5.712.16.205.33.399.51.579.15.152.32.28.51.381.16.086.34.127.52.12.42-.1.58-.52.57-1.108a6.515 6.515 0 0 0-.48-2.087 9.467 9.467 0 0 0-1.1-2.07 2.414 2.414 0 0 0-1.28-1.058.694.694 0 0 0-.45.111.752.752 0 0 0-.26.32 1.2 1.2 0 0 0-.11.414c-.02.13-.01.261 0 .391l-.03.026-.08.059a.743.743 0 0 0-.08.065c-.01.011-.03.026-.04.043 0 .008 0 .016.01.024v.015c.01.01.01.02.02.03l.01.014v.012l.04.051.01.025-.21-.031-.01-.01-.03-.024-.03-.03c0-.008-.01-.018-.02-.027 0-.011-.01-.021-.03-.028 0-.006-.01-.012-.02-.018l-.01-.006-.01-.006-.05-.02-.02-.01-.03-.026-.06-.064c-.03-.022-.05-.045-.07-.064-.01-.011-.03-.023-.04-.036 0-.011-.01-.023-.01-.035v-.03c0-.007 0-.014-.01-.021v-.389a.07.07 0 0 0 .01-.043c0-.011.01-.022.01-.031.01-.009.01-.017.02-.024l.01-.012c.01-.005.01-.01.02-.015l.1-.07a.498.498 0 0 0 .03-.019l.03-.021c0-.005.01-.009.01-.015.01-.005.01-.011.01-.017v-.005l.01-.003v-.002l-.01-.005v-.043c.01-.009.01-.018.01-.027 0-.014 0-.028.01-.041v-.046c0-.015.01-.03.01-.044.01-.008.01-.015.02-.023v-.221c0-.003 0-.006-.01-.009v-.049a.04.04 0 0 1 0-.047v-.056c0-.023-.01-.045-.01-.066v-.033c0-.011 0-.022-.01-.032l-.01-.047v-.023c-.01-.006-.01-.012-.01-.018-.01-.015-.02-.029-.02-.043l-.03-.045c0-.015-.01-.03-.01-.045-.01-.015-.01-.03-.02-.043l-.01-.042-.01-.036-.02-.038-.01-.015c0-.01-.01-.02-.01-.03l-.04-.054c0-.007 0-.014-.01-.02-.01-.013-.01-.027-.02-.04l-.03-.063c0-.018-.01-.035-.01-.053-.01-.008-.01-.015-.01-.023V109.547c0-.018-.01-.035-.02-.051-.01-.023-.02-.05-.03-.079l-.05-.083-.03-.064c0-.008-.01-.014-.01-.017l-.01-.005c-.01 0-.01.001-.02.003v.005l-.01.003c0 .007-.01.014-.02.023v.012l-.23.131-.02-.1.01-.044c.01-.027.01-.063.02-.1.01-.037.01-.079.02-.113 0-.026.01-.053.01-.079 0-.006 0-.012-.01-.016v-.006l-.01-.003a.093.093 0 0 0-.04.006c-.01.004-.02.01-.04.017l-.02.01-.12-.022.01-.016c.01-.015.01-.029.02-.042l.01-.024c0-.011.01-.023.01-.035.01-.023.01-.046.02-.069V108.735v.004l.03-.164.17.008.02-.011.03-.017.04-.026a.161.161 0 0 0 .03-.029v-.02c.01-.006.01-.013.01-.02v-.052c.01-.009.01-.018.01-.028v-.035c0-.012.01-.024.01-.036v-.206c0-.034 0-.067.01-.1V107.695a.171.171 0 0 0-.02-.069c0-.015-.01-.031-.01-.046l-.01-.018h-.14l-.31.007-.12-.08-.2-.1-.2.016-.21.145-.2.407-.13.515-.01.776-.2.246-.13.261.15.184v.784l.14.23.21.138v.015c-.01.008-.01.016-.01.024 0 .014-.01.032-.01.051v.042l-.03.107c0 .029-.02.056-.03.083l-.03.072c0 .029-.01.058-.01.088V111.658a.07.07 0 0 0 0 .063v.323c0 .026-.01.052-.02.077a.285.285 0 0 1-.04.08.417.417 0 0 1-.03.063l-.02.025-.16.169-.07.042-.16.1-.18.108-.01.005c-.05.031-.09.057-.11.071l-.04.029-.06.045-.12.1-.1.091-.04.039-.18.737-.06.338-.05.215-.29.569-.57.493-.53.692-.76.755-.28.061h-.42l-.17.09-1.7-3.408.08-.131v-.123c0-.014-.01-.023-.01-.023h-.14l-.02.006c0 .002-.01.002-.02 0 0-.002-.01-.004-.01-.007 0-.004 0-.007-.01-.011 0-.018-.01-.035-.01-.051-.01-.017-.01-.035-.02-.052v-.022l-.02-.067-.01-.029.02-.178-1.19-1.756.67 2.046.15.039.08.092.03.077-.03.116v.093l.1.062.08.007h.02l1.77 3.568-.18.054-.02.169.05.215.15.215.18.077.1.277h.17l.05-.02 1.82 3.669v.065l.04.066c.02.04.05.093.08.147.04.054.07.111.1.156.03.034.05.065.08.091.02.013.04.033.04.056.01.027.02.055.02.084v.263l.01.024v.035l.01.027v.073c.01.023.01.046 0 .07 0 .046.01.092.01.138.01.041.01.089.02.14v.107c.01.042.01.085.01.126l.01.121c.01.07.01.122.01.137 0 .011 0 .022-.01.032 0 .016-.01.032-.02.047-.01.022-.03.047-.04.072l-.03.042-.08.1-.03.044.15.276.49.158v.639h-.48v.461h.29v.431h-.31v.361a2.55 2.55 0 0 0-1.6.734c-.44.432-.7 1.003-.76 1.614v.673l.01.031.01.03v.031l.01.033v.032l.01.032.01.033v.032c.06.24.16.47.29.682.13.211.29.403.47.571.18.167.39.309.61.421.22.112.45.19.7.232h.87l1.05-.007 2.05-.008.45-.006 1.44-.008.2.003.05-.004c.06-.001.11-.004.16-.008l.04-.003c.49-.047.95-.238 1.34-.55.43-.35.74-.828.88-1.365v-.027l.02-.043.01-.041v-.041l.01-.042v-.544c.04-.008.04-.015.04-.022Zm-8.41-9.053-.02.1-.04.234-.01.114-.03.132-.01.065c0 .037-.01.063-.01.074a.349.349 0 0 0-.03.084l-.05.124-.04.112-.02.049-.02.35-1.62-3.251.05-.049.06-.05.05-.047.05-.039c.02-.02.05-.042.07-.064l.08-.082.06-.07.03-.03.3-.186 1.07-.677-.04.063-.09.124-.04.066c-.02.024-.03.047-.05.068-.02.029-.03.06-.05.093-.01.028-.01.057-.02.087v.267c.01.041.01.081.02.122.01.034.02.068.04.1s.03.064.05.094c.02.023.04.043.05.059v.009l.03.026.18.23-.01.042-.01.014c0 .018-.01.041-.02.065-.01.017-.01.035-.02.053 0 .015-.01.031-.01.047-.01.027-.01.056-.02.085.01.036.01.072.02.108.01.046.02.1.04.148.01.048.02.1.03.131l.02.057.06.354-.08.595ZM178.48 129.125c0 .007.042.014.042.021v.544l.008.042.016.082.018.044v.027a2.617 2.617 0 0 0 .88 1.364c.385.312.852.503 1.343.55h-.023l.061.003c.042.003.083.006.125.007l.085.005.22-.003 1.284.007.58.008 2.055.008 1.049.013h.873c.244-.042.48-.12.7-.232a2.678 2.678 0 0 0 1.37-1.674v-.032l.007-.033.007-.032.006-.032.006-.033.006-.031.006-.03.006-.031.005-.031v-.649a2.62 2.62 0 0 0-.76-1.614 2.509 2.509 0 0 0-1.606-.733v-.361h-.31v-.431h.293v-.461h-.482v-.639l.489-.158.151-.276-.033-.044a2.97 2.97 0 0 1-.105-.149l-.04-.065a.229.229 0 0 1-.033-.079c0-.015.004-.067.01-.137l.007-.079.014-.168.008-.103c.004-.052.008-.102.013-.144.009-.07.009-.123.009-.138l-.001-.028.001-.042.011-.1.005-.036c.003-.023.006-.044.006-.064v-.135a1.262 1.262 0 0 1 0-.087.339.339 0 0 1 .017-.084.106.106 0 0 1 .041-.056.38.38 0 0 0 .079-.091 4.914 4.914 0 0 0 .186-.304l.036-.066v-.065l1.824-3.669.049.02h.166l.106-.277.181-.077.152-.215.045-.215-.015-.169-.189-.054 1.77-3.568h.023l.083-.007.1-.062-.007-.093-.03-.116.037-.077.076-.092.151-.039.672-2.046-1.195 1.755.014.178-.007.029-.017.067a.353.353 0 0 0-.008.031l-.012.043c-.007.023-.016.041-.016.051a.06.06 0 0 1-.003.005l-.004.005c-.002.003-.006.005-.01.007a.045.045 0 0 1-.023 0l-.02-.006h-.139c-.008 0-.015.009-.015.023a.417.417 0 0 0 0 .05v.073l.083.131-1.7 3.408-.174-.09h-.422l-.272-.061-.769-.755-.527-.692-.573-.493-.286-.569-.045-.215-.06-.338-.18-.737-.038-.039-.1-.091-.12-.1c-.033-.028-.065-.052-.086-.068l-.009-.006c-.019-.015-.063-.041-.114-.073l-.183-.111-.16-.1-.07-.042-.166-.169-.016-.025a.935.935 0 0 1-.072-.143.258.258 0 0 1-.016-.077v-.323a.25.25 0 0 1 .002-.025.125.125 0 0 0-.002-.038.354.354 0 0 1-.005-.048v-.037a.644.644 0 0 0-.013-.088l-.008-.031a.3.3 0 0 0-.018-.041.38.38 0 0 1-.031-.083 1.192 1.192 0 0 1-.03-.147c-.003-.02-.005-.038-.009-.053-.006-.024-.006-.039-.006-.039l.211-.139.136-.23v-.784l.15-.184-.135-.261-.2-.246-.008-.775-.128-.515-.2-.407-.211-.146-.2-.016-.2.1-.12.081-.309-.007h-.135l-.011.017c0 .009-.009.027-.015.047a.358.358 0 0 0-.011.035l-.008.034a.452.452 0 0 0 .003.09l-.002.052c0 .015 0 .031.002.048a.389.389 0 0 1 .003.06c0 .02 0 .04.002.057.005.034.005.07.005.1v.142l-.001.015c0 .009-.001.02.001.029a.42.42 0 0 0 .014.062c.004.012.004.024.004.035.001.01.001.019.003.028.005.019.005.037.005.052a.142.142 0 0 0 .012.04.078.078 0 0 0 .028.029l.036.021.028.017.018.011h.007l.166-.008.034.163-.004-.004v.011a1.215 1.215 0 0 1 .005.043l.01.049.005.02.013.04a.107.107 0 0 1 .007.019c.006.018.017.032.017.042l.009.015-.121.023-.018-.01a.192.192 0 0 0-.039-.017.066.066 0 0 0-.039-.006.022.022 0 0 0-.014.008l-.004.01v.007a.642.642 0 0 0 .009.087l.018.113.015.082.003.018.01.04-.015.1-.227-.131-.007-.012a.106.106 0 0 0-.019-.023c-.003-.004-.007-.006-.011-.008a.028.028 0 0 0-.013-.003c-.008 0-.016.007-.024.022l-.033.06-.042.083a2.345 2.345 0 0 0-.043.093.156.156 0 0 0-.01.037v.027a.14.14 0 0 1 0 .029.24.24 0 0 1-.007.037c-.004.018-.01.035-.016.053a.578.578 0 0 1-.062.123l-.033.054a.254.254 0 0 0-.016.028l-.008.017-.016.038-.014.036a.114.114 0 0 1-.01.019c-.003.006-.007.011-.009.019l-.01.029a.059.059 0 0 0-.002.014.633.633 0 0 1-.04.09.437.437 0 0 0-.022.043.179.179 0 0 0-.013.041c-.007.013 0 .031-.007.051a.143.143 0 0 0-.004.022c0 .014.001.029-.003.043-.006.022-.006.045-.006.066v.056a.368.368 0 0 1 0 .047c-.002.016 0 .032-.008.049a.089.089 0 0 0-.008.035v.014l-.001.026.001.021v.079a.216.216 0 0 0 0 .036c.004.015.01.029.018.043.006.014.01.029.012.044.003.007.003.015.003.023 0 .007 0 .015.003.023.006.015.006.029.006.041a.084.084 0 0 0 .007.026.022.022 0 0 1 .005.011c0 .004 0 .008-.002.012v.015a.034.034 0 0 0 0 .02.118.118 0 0 0 .027.032l.026.021.025.019.104.07a.27.27 0 0 1 .031.028l.011.012.007.012c.005.009.009.02.011.031a.297.297 0 0 1 .006.043v.334l.001.017-.001.037-.003.021c-.002.011-.004.021-.004.03a.154.154 0 0 1-.01.035 2.224 2.224 0 0 1-.104.1l-.063.064-.029.026-.02.01-.048.022c-.016.01-.034.02-.048.03a.092.092 0 0 0-.027.025l-.002.003a.157.157 0 0 1-.02.025l-.03.03-.027.024-.012.01-.211.031.015-.02.033-.051a.558.558 0 0 0 .041-.078l.002-.017a.137.137 0 0 0-.04-.043 1.235 1.235 0 0 0-.08-.065l-.078-.059-.035-.026a1.506 1.506 0 0 0-.103-.805.768.768 0 0 0-.263-.32.707.707 0 0 0-.452-.111 2.406 2.406 0 0 0-1.277 1.053 9.258 9.258 0 0 0-1.1 2.07 6.543 6.543 0 0 0-.481 2.087c-.009.588.155 1.008.566 1.108.182.007.363-.034.523-.12a2.18 2.18 0 0 0 .513-.381c.183-.181.352-.374.506-.579.167-.218.334-.459.5-.712l-.331.874-.042.083-.094.187-.1.2-.063.125-.037.069-.041.079a3.186 3.186 0 0 0-.075.162l-.008.021-.026.063-.039.094-.009.024-.025.068a.493.493 0 0 0-.036.077.437.437 0 0 1-.012.049l-.012.035a.271.271 0 0 0-.009.041.726.726 0 0 0 0 .066v.164a.3.3 0 0 1 .001.03l-.001.04a.245.245 0 0 1-.011.059.568.568 0 0 0-.018.063 1.39 1.39 0 0 0-.017.075c-.005.025-.013.051-.013.075a.42.42 0 0 0-.005.062v.307a.43.43 0 0 1-.005.061.204.204 0 0 0 0 .035v.103l.338.207-.001.001.034.021a.138.138 0 0 1 .038.035.05.05 0 0 1 .011.029.104.104 0 0 1-.025.049l-.054.068a.59.59 0 0 0-.05.07.077.077 0 0 0-.013.057c.004.011.01.022.015.032l.012.021c.014.021.028.042.044.062a.515.515 0 0 0 .116.115.176.176 0 0 1 .05.062c.013.024.023.05.03.077l.008.031.006.034v.028a.076.076 0 0 1 .014-.011.083.083 0 0 1 .035-.015.063.063 0 0 1 .048.01.143.143 0 0 1 .052.062c.017.033.036.075.056.119.02.044.039.091.057.134l.044.11.018.046h-.005l-.001.005.001.006c.001.004.005.013.016.013a.254.254 0 0 0 .054.009.753.753 0 0 0 .201-.016l.086-.017.036-.008.012-.023.026-.054a.62.62 0 0 0 .038-.106v-.177l.008-.033.019-.075.02-.08.012-.05c.001-.008.006-.022.011-.039l.018-.056.016-.051.007-.022.157-.138-.1 1.036-.043.111-.094.247c-.03.07-.057.142-.081.203l-.019.051-.036.096a.165.165 0 0 0-.011.036l-.465 2.197-.026.185-.039.282-.018.129-.057.42a5.808 5.808 0 0 0-.026.211 1.477 1.477 0 0 0 .017.171l.019.157.015.113.013.097a.776.776 0 0 0 .02.107l.014.037.03.08.04.11.045.126h-.213v.46h.278v.43h-.308v.36a2.46 2.46 0 0 0-.876.218 2.553 2.553 0 0 0-1.237 1.221 2.629 2.629 0 0 0-.244.882v.174Zm8.431-8.953-.017-.1-.077-.596.06-.354.016-.057.025-.089.011-.042c.013-.048.026-.102.036-.148a.575.575 0 0 0 .016-.108.343.343 0 0 0-.014-.085 1.077 1.077 0 0 0-.055-.163l-.007-.016-.009-.04.18-.23.022-.026.005-.007.045-.061a1 1 0 0 0 .055-.094.471.471 0 0 0 .056-.222c.006-.045.006-.093.006-.139 0-.025-.002-.049-.003-.071a.606.606 0 0 1-.003-.057.362.362 0 0 0-.017-.087.667.667 0 0 0-.053-.094c-.025-.041-.057-.088-.088-.134l-.085-.124-.044-.063 1.07.677.3.186.027.03.065.07.079.082c.026.026.05.049.069.064l.046.039.055.047.058.05.056.049-1.621 3.251-.026-.35-.019-.049-.043-.112-.046-.124a.99.99 0 0 1-.028-.084 2.134 2.134 0 0 1-.025-.139l-.04-.246-.038-.234Z",
                                fill: "#1B023F"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "hero-darkmode-desktop_svg__a",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h1440v185H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "hero-darkmode-desktop_svg__b",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h1440v185H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                        id: "hero-darkmode-desktop_svg__e",
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h1440v185H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "hero-darkmode-desktop_svg__c",
                        x1: 720,
                        y1: 57.936,
                        x2: 720,
                        y2: 184.936,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#4D14B4"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 0.483,
                                stopColor: "#6118CB"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                stopColor: "#9021FE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)("linearGradient", {
                        id: "hero-darkmode-desktop_svg__d",
                        x1: 802.08,
                        y1: 185,
                        x2: 802.104,
                        y2: 17.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                stopColor: "#4D00B4"
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7E1BD4"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $54569a2982a56f82$export$2e2bcd8739ae039 = $54569a2982a56f82$var$SvgHeroDarkmodeDesktop;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $03a32c11bda34481$var$SvgHeroDarkmodeMobile = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 390 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#hero-darkmode-mobile_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "M390 0H0v151h390V0Z",
                        fill: "#7E1BD4"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M380.152 150.559 320.784 18.487 108.806 9 0 144.694v5.865h6.68L90.543 44.53 65.553 150.56H192.2l72.015-31.502-4.158 31.502h29.723l4.587-33.949 33.413 33.949h38.933l-64.916-66.07 19.133-39.326 49.096 105.396h10.126ZM123.653 32.449 246.428 85.38 97.862 143.736l25.791-111.287Zm48.384-11.184 125.056 5.082-21.9 40.091-103.156-45.173Z",
                        fill: "#892ED8"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m229.029 77.572.004 1.355-21.892-10.413-.314-3.204 22.202 12.262ZM250.674 89.529l-.074.882-6.237-3.247-.11-1.223 6.421 3.588ZM211.407 66.527l-4.413-2.503.238-2.753 3.905 3.577.27 1.68ZM206.121 71.356l-62.519 11.911-.214-1.13-.19-.459.452-.283-.127-2.207 61.985-13.907.613 6.075ZM206.636 60.3l-.82 2.247.118.96-63.283 14.9-.748-.094-.36-2.656 3.697-1.542.122.852 1.683-.978.228.848-2.211 1.305 3.706-1.007 8.43-4.904 7.718-3.086-.197.961 2.339-.245-.025-1.594 3.286-.897-.188 1.811 1.804-.236.355-4.799 24.169 1.17-.021-1.494 3.405-.044.194-1.708 6.599.23ZM251.407 93.225l-43.863-21.878-.118-1.69 22.478 11.246 21.215 10.8.288 1.522ZM185.481 107.098l-43.056 4.668.523-1.343 42.533-3.325Z",
                        fill: "#1B023F"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m206.534 107.046 46.028 8.154.121.23h.015c.075-.002.146-.004.212-.004.044 0 .085.002.129.004l.092.004.069.002a2.326 2.326 0 0 0 .377-.005h1.066v-.673h1.479v.013l8.888-.172 37.174.14h.686v.673h1.478v.36l.27.046c.885.149 1.312.012 1.543-.063.166-.053.232-.074.295.063.059.136.129.266.209.392a.631.631 0 0 1 .153.488c-.03.209.009.328.532.676.353.254.782.394 1.226.399.171-.003.343-.017.513-.042.136-.02.274-.032.412-.036.282-.027.547-.136.759-.314a1.82 1.82 0 0 1 1.069-.399c.391.004.78.064 1.152.178.426.118.862.204 1.302.256 2.074.297 4.126.717 6.144 1.258.406.154.842.221 1.278.195a11.414 11.414 0 0 0 .61-.017l.087-.003a.907.907 0 0 1 .43.187.83.83 0 0 1 .265.372c.164.538 2.641.601 2.665.601.294-.009.586-.04.875-.091a7.212 7.212 0 0 1 1.078-.108c.347 0 .471.263.601.538l.001.002c.097.207.199.421.407.493.365.127.792 1.255.792 4.021v3.576c0 .007 0 .013.002.02.002.008.004.016.008.023l.002.004.002.003h5.298v.422h1.481v.42h1.06v.826c.035 0 .07.002.104.003l.035.002.064.001h.244l.117-.002.058-.002.046-.001h.326l.201.003.125.002h.082c.555 0 .81-.043.878-.151a9.656 9.656 0 0 0 .008-1.87.05.05 0 0 0-.009-.024l-.007-.009-.011-.008a.435.435 0 0 1-.088-.071h1.353c.082 0 .183 0 .304-.008.144-.007.309-.012.465-.012.18-.019.361.003.532.064.413.149.854.203 1.291.158.154 0 .346-.015.553-.032l.05-.004c.237-.019.497-.04.739-.04.204-.006.408.017.605.07.109.034.222.05.336.049.21-.009.418-.042.621-.099a5.147 5.147 0 0 1 1.278-.163c.489 0 .88.024 1.163.041l.08.004c.139.008.252.014.345.014.082 0 .283 0 .345-.099a1.074 1.074 0 0 1 .846-.267c.093 0 .185.006.277.016.357.041.415.169.473.305a.38.38 0 0 0 .345.265c.048.006.095.009.143.009.147-.005.293-.021.437-.048a3.85 3.85 0 0 1 1.225-.034 8.8 8.8 0 0 0 .794.067c.455.025.529.038.529.173a.68.68 0 0 0 .091.31c.066.129.057.138-.031.163-.318.087-.258 1.03-.194 1.586 0 .032.048.057.101.057h6.903c3.388 0 5.18.351 5.18 1.015 0 .418.607.417.897.417.11 0 .227 0 .35-.006.123-.007.257-.007.388-.007h.003a1.717 1.717 0 0 1 1.376.408c.25.311.136.874.013 1.468-.137.666.371.628 1.197.566.57-.042 1.291-.095 2.055.063.375.086 1.711-.515 3.123-1.15 1.699-.765 3.506-1.578 3.877-1.301.611 1.112 4.234-.359 7.059-1.505 1.802-.732 3.279-1.331 3.441-1.044V151H0v-7h.004L0 129.271l4.289.508 1.472-.566 4.172 2.632h14.402l6.232-3.579s14.273.849 21.263 0c4.752-.577 7.743-1.879 9.172-2.654v-.649c0-2.556.427-3.599.793-3.717.208-.066.311-.264.408-.456.131-.255.256-.498.605-.498.362.008.724.041 1.08.099.29.048.583.076.878.085.024 0 2.508-.059 2.672-.557a.774.774 0 0 1 .266-.343.944.944 0 0 1 .432-.173l.087.003.04.001.05.002c.135.006.32.013.522.013a3.34 3.34 0 0 0 1.281-.18 56.43 56.43 0 0 1 6.162-1.163 9.4 9.4 0 0 0 1.306-.238 4.39 4.39 0 0 1 1.155-.163 1.91 1.91 0 0 1 1.072.368c.212.164.479.266.76.29.14.004.278.015.415.034.17.023.342.035.514.038a2.256 2.256 0 0 0 1.23-.369c.523-.321.563-.431.533-.624a.532.532 0 0 1 .024-.239.587.587 0 0 1 .129-.213c.08-.116.15-.236.21-.361.152-.305.184-.369 1.706-.604l.27-.043v-.333h1.483V115h.687l21.025.135h.687v.623h1.484v.621h1.062v1.22c.069.006.136.009.202.009.059 0 .117-.002.176-.004l.069-.002.092-.003.069-.003.034-.001h.026l.216.003.111.003c.132.003.271.007.408.007.556 0 .812-.064.88-.222v-.428l-.009-.25-.008-.244a.089.089 0 0 0-.028-.06.545.545 0 0 1-.088-.105c10.359-.036 17.604-.18 23.059-.331l.244-2.068 14.432-.897 28.009-2.645-40.883 2.543.086-.789 43.919-3.282 21.893-2.926.094 7.269 1.88.148-.036-1.091.123.012v-1.047l-.266-.026-.2-4.123ZM155.919 84.59l-2.635-1.413-4.568.907.047-.624 4.589-.856 2.567 1.373v.613ZM156.812 108.605l1.461-23.945h-.017c.006-.014.006-.029.006-.043a.406.406 0 0 0-.007-.105.246.246 0 0 0-.055-.114.243.243 0 0 0-.137-.075.195.195 0 0 0-.149.024.268.268 0 0 0-.087.102.552.552 0 0 0-.048.164l-1.604 24.042-.349.025a8625.91 8625.91 0 0 1 .865-12.321c.187-2.63.375-5.25.536-7.44.162-2.19.292-3.946.374-4.833a3.034 3.034 0 0 1 1.317-.594 4.126 4.126 0 0 1 1.279-.03c.329.04.653.113.968.214.13.04.258.088.383.142l-.521 24.486-.297.022.586-24.008a.366.366 0 0 0-.001-.15.245.245 0 0 0-.054-.114.246.246 0 0 0-.136-.076.198.198 0 0 0-.151.024.239.239 0 0 0-.081.101.44.44 0 0 0-.048.163l-.734 24.104-.314.021.75-24.299a.35.35 0 0 0-.001-.149.242.242 0 0 0-.054-.113.236.236 0 0 0-.135-.074.195.195 0 0 0-.15.022.252.252 0 0 0-.082.1.472.472 0 0 0-.044.164l-.904 24.392-.389.027 1.02-24.365a.407.407 0 0 0-.001-.15.242.242 0 0 0-.054-.113.227.227 0 0 0-.135-.073.192.192 0 0 0-.149.022.25.25 0 0 0-.082.102.539.539 0 0 0-.048.163l-1.176 24.461-.398.029 1.265-24.205c.005-.015.005-.03.005-.046a.412.412 0 0 0-.007-.105.25.25 0 0 0-.055-.115.244.244 0 0 0-.136-.074.19.19 0 0 0-.149.024.263.263 0 0 0-.081.102.493.493 0 0 0-.043.122c-.003.014-.007.029-.007.043l-1.401 24.299-.344.023ZM160.745 81.81l-4.711.939.033-.644 4.729-.887 2.666 1.419.014.633-2.731-1.46ZM165.261 107.993l1.247-24.8-.001.003c.003-.013.004-.027.005-.041a.432.432 0 0 0-.007-.108.244.244 0 0 0-.196-.2.2.2 0 0 0-.156.026.262.262 0 0 0-.088.106.48.48 0 0 0-.049.17l-1.387 24.894-.357.025.04-.675c.058-.999.146-2.509.253-4.307l.393-6.588.068-1.13c.163-2.728.327-5.451.471-7.734.144-2.284.263-4.112.333-5.032a3.086 3.086 0 0 1 1.352-.614c.436-.08.881-.09 1.32-.033a5.54 5.54 0 0 1 1 .221c.135.042.267.091.397.147l-.272 25.358-.305.023.341-24.862a.439.439 0 0 0-.003-.156.264.264 0 0 0-.057-.118.245.245 0 0 0-.14-.078.201.201 0 0 0-.154.025.258.258 0 0 0-.087.105.467.467 0 0 0-.048.169l-.495 24.961-.326.024.516-25.16a.27.27 0 0 0 .005-.028l.001-.02a.39.39 0 0 0-.007-.107.251.251 0 0 0-.2-.2.195.195 0 0 0-.154.024.26.26 0 0 0-.087.105.524.524 0 0 0-.046.17l-.665 25.255-.407.032.794-25.225c.005-.015.005-.031.005-.047a.494.494 0 0 0-.009-.108.251.251 0 0 0-.198-.2.208.208 0 0 0-.157.025.268.268 0 0 0-.089.105.577.577 0 0 0-.049.169l-.945 25.329-.407.027 1.041-25.068c.005-.015.005-.032.005-.047a.432.432 0 0 0-.008-.108.241.241 0 0 0-.198-.194.198.198 0 0 0-.155.025.262.262 0 0 0-.089.105.58.58 0 0 0-.048.17l-1.185 25.165-.356.025ZM190.488 78.428l-3.046-1.602-5.122 1.03.02-.71 5.146-.973 2.962 1.556.04.699ZM169.023 80.248l-4.846.97.033-.67 4.868-.91 2.764 1.468.023.653-2.842-1.511ZM174.158 107.346l1.041-25.903.005.001a.357.357 0 0 0 .013-.045.42.42 0 0 0-.01-.112.277.277 0 0 0-.059-.121.258.258 0 0 0-.146-.082.205.205 0 0 0-.159.025.27.27 0 0 0-.089.108.5.5 0 0 0-.048.176l-1.189 26.004-.37.027.1-2.055.135-2.74c.113-2.319.256-5.184.401-8.087.145-2.902.294-5.84.425-8.297.13-2.458.239-4.439.305-5.417.404-.322.88-.539 1.387-.632a4.372 4.372 0 0 1 1.359-.032c.351.045.696.122 1.033.23.138.043.275.094.408.151l-.021 26.478-.32.02.102-25.965a.459.459 0 0 0-.005-.16.258.258 0 0 0-.205-.203.207.207 0 0 0-.163.025.27.27 0 0 0-.089.108.551.551 0 0 0-.046.175l-.256 26.068-.34.026.281-26.273a.42.42 0 0 0-.005-.16.252.252 0 0 0-.207-.204.205.205 0 0 0-.163.024.267.267 0 0 0-.09.108.552.552 0 0 0-.048.175l-.433 26.377-.417.031.57-26.352a.407.407 0 0 0-.004-.158.266.266 0 0 0-.062-.12.267.267 0 0 0-.229-.085.201.201 0 0 0-.076.03.263.263 0 0 0-.089.109.5.5 0 0 0-.048.174l-.724 26.448-.423.031.816-26.184c.005-.016.005-.031.005-.048a.46.46 0 0 0-.01-.11.258.258 0 0 0-.205-.203.204.204 0 0 0-.163.026.27.27 0 0 0-.089.109.57.57 0 0 0-.046.177l-.972 26.284-.368.023ZM177.764 78.403l-4.983 1.002.028-.688 5.003-.945 2.864 1.512.032.677-2.944-1.558ZM196.879 75.065l-5.263 1.06.018-.731 5.284-1L199.98 76l.044.717-3.145-1.65ZM149.75 109.12l1.549-23.194a.329.329 0 0 0 .016-.042.421.421 0 0 0-.005-.1.248.248 0 0 0-.047-.11.214.214 0 0 0-.123-.073.171.171 0 0 0-.137.022.246.246 0 0 0-.081.098.51.51 0 0 0-.045.158l-1.675 23.279-.32.025.079-1.05c.069-.922.162-2.176.272-3.629l.014-.179c.158-2.087.345-4.561.534-7.038.195-2.548.392-5.097.56-7.225.167-2.128.304-3.835.385-4.696a2.7 2.7 0 0 1 1.202-.57 3.52 3.52 0 0 1 1.162-.03c.298.041.592.11.877.209.118.039.233.085.346.137l-.704 23.728-.272.021.759-23.267a.48.48 0 0 0 0-.144.246.246 0 0 0-.049-.11.215.215 0 0 0-.124-.07.163.163 0 0 0-.136.021.25.25 0 0 0-.081.099.463.463 0 0 0-.043.16l-.897 23.349-.29.022.917-23.537a.428.428 0 0 0 0-.146.251.251 0 0 0-.049-.11.211.211 0 0 0-.125-.073.164.164 0 0 0-.135.022.252.252 0 0 0-.081.099.51.51 0 0 0-.036.108l-.005.025-.004.025-1.048 23.628-.355.027 1.167-23.603c.001-.01.003-.02.003-.031l.001-.013a.422.422 0 0 0-.006-.1.246.246 0 0 0-.049-.11.213.213 0 0 0-.123-.073.163.163 0 0 0-.136.022.24.24 0 0 0-.082.098.567.567 0 0 0-.046.158l-1.297 23.693-.361.027 1.38-23.447.003-.02a.428.428 0 0 0-.002-.126.248.248 0 0 0-.049-.11.21.21 0 0 0-.123-.072.163.163 0 0 0-.137.022.246.246 0 0 0-.081.098.457.457 0 0 0-.036.108c-.004.016-.009.033-.009.05l-1.511 23.534-.311.026ZM186.176 106.474l.336-27.136v-.051a.479.479 0 0 0-.011-.114.293.293 0 0 0-.063-.125.27.27 0 0 0-.151-.081.21.21 0 0 0-.163.025.265.265 0 0 0-.091.112.533.533 0 0 0-.049.18l-.49 27.24-.434.033.596-26.964a.438.438 0 0 0-.006-.164.28.28 0 0 0-.063-.124.265.265 0 0 0-.152-.081.205.205 0 0 0-.163.025.265.265 0 0 0-.089.112.528.528 0 0 0-.039.122l-.005.032-.003.026-.751 27.066-.378.027.82-26.678c.005-.016.005-.033.005-.049a.4.4 0 0 0-.01-.115.27.27 0 0 0-.062-.125.267.267 0 0 0-.151-.081.215.215 0 0 0-.163.025.27.27 0 0 0-.092.11.527.527 0 0 0-.047.18l-.973 26.779-.381.031c.033-.758.104-2.595.196-4.989.077-1.997.175-4.379.276-6.845l.061-1.48c.122-2.983.249-5.997.359-8.519.11-2.522.204-4.55.262-5.557a3.197 3.197 0 0 1 1.422-.653 4.44 4.44 0 0 1 1.397-.033c.36.046.715.126 1.06.236.144.045.285.098.423.157l.233 27.267-.326.024-.147-26.745a.444.444 0 0 0-.004-.165.286.286 0 0 0-.062-.127.266.266 0 0 0-.151-.081.212.212 0 0 0-.163.028.28.28 0 0 0-.091.114.533.533 0 0 0-.047.18l-.013 26.844-.352.025.044-27.058a.412.412 0 0 0 0-.05.438.438 0 0 0-.012-.114.286.286 0 0 0-.063-.126.273.273 0 0 0-.152-.081.207.207 0 0 0-.163.026.272.272 0 0 0-.091.112.576.576 0 0 0-.046.18l-.194 27.163-.433.03ZM204.964 105.111l-.13-29.044v.004a.38.38 0 0 0 .009-.048.497.497 0 0 0-.013-.121.288.288 0 0 0-.232-.22.22.22 0 0 0-.171.027.28.28 0 0 0-.094.119.544.544 0 0 0-.048.191l-.034 29.155-.46.033.146-28.865c.005-.018.004-.035.004-.053a.445.445 0 0 0-.011-.12.295.295 0 0 0-.068-.133.29.29 0 0 0-.163-.09.217.217 0 0 0-.173.03.29.29 0 0 0-.093.12.59.59 0 0 0-.038.13c-.007.02-.007.041-.007.061l-.312 28.967-.402.031.397-28.556v-.053a.498.498 0 0 0-.014-.122.319.319 0 0 0-.069-.133.296.296 0 0 0-.163-.087.221.221 0 0 0-.172.028.288.288 0 0 0-.094.12.582.582 0 0 0-.048.19l-.555 28.668-.4.026a5348.46 5348.46 0 0 1 .548-23.13c.075-2.805.141-5.072.186-6.18a3.33 3.33 0 0 1 1.494-.692 4.71 4.71 0 0 1 1.479-.036 6.418 6.418 0 0 1 1.581.413l.678 26.684a10118.134 10118.134 0 0 1 .318-13.404c.054-2.175.109-4.251.156-6.022l.013-.46c.049-1.866.097-3.343.131-4.158a3.167 3.167 0 0 1 1.424-.66 4.489 4.489 0 0 1 1.409-.034 6.085 6.085 0 0 1 1.508.395l.714 28.359h-.334l-.607-27.804v-.05a.501.501 0 0 0-.014-.117.302.302 0 0 0-.066-.126.281.281 0 0 0-.154-.082.204.204 0 0 0-.164.026.26.26 0 0 0-.088.112.54.54 0 0 0-.038.124l-.005.028-.003.03.447 27.817-.353-.065-.429-27.942v-.05a.5.5 0 0 0-.013-.116.304.304 0 0 0-.066-.127.281.281 0 0 0-.154-.081.212.212 0 0 0-.163.026.25.25 0 0 0-.09.113.539.539 0 0 0-.037.124c-.003.019-.007.038-.007.058l.262 27.867-.437-.081-.116-27.728v-.05a.493.493 0 0 0-.013-.116.302.302 0 0 0-.066-.126.281.281 0 0 0-.154-.082.21.21 0 0 0-.164.027.255.255 0 0 0-.089.114.593.593 0 0 0-.045.182l-.029 27.651-.437-.082.147-27.256a.421.421 0 0 0-.007-.169.263.263 0 0 0-.219-.209.21.21 0 0 0-.163.026.254.254 0 0 0-.089.114.54.54 0 0 0-.042.183l-.304 27.185-.375-.07.378-26.695v-.051a.417.417 0 0 0-.014-.117.283.283 0 0 0-.067-.127.283.283 0 0 0-.156-.082.212.212 0 0 0-.163.027.265.265 0 0 0-.09.113.49.49 0 0 0-.044.16l-.003.022-.521 26.624-.376-.068v-.039h-.201l-.652-29.17v-.053a.446.446 0 0 0-.014-.12.315.315 0 0 0-.069-.133.296.296 0 0 0-.163-.086.217.217 0 0 0-.172.027.276.276 0 0 0-.093.119.544.544 0 0 0-.048.191l.473 29.088-.368-.069-.455-29.22v-.053a.49.49 0 0 0-.014-.12.292.292 0 0 0-.233-.222.222.222 0 0 0-.172.028.27.27 0 0 0-.093.12.534.534 0 0 0-.044.19l.278 29.143-.262-.049-.195.014ZM193.606 105.931l.61-27.642a.587.587 0 0 0 .012-.058.47.47 0 0 0-.012-.119.304.304 0 0 0-.066-.13.275.275 0 0 0-.155-.08.22.22 0 0 0-.169.026.277.277 0 0 0-.093.116.56.56 0 0 0-.047.186l-.769 27.751-.389.03a10186.967 10186.967 0 0 1 .422-13.525c.1-3.129.206-6.312.299-8.98.092-2.668.173-4.817.225-5.877a3.267 3.267 0 0 1 1.458-.672 4.613 4.613 0 0 1 1.44-.035c.373.048.74.13 1.099.245.148.046.295.1.438.163l.489 28.257-.341.027-.39-27.719a.44.44 0 0 0 0-.05.464.464 0 0 0-.012-.118.29.29 0 0 0-.067-.13.286.286 0 0 0-.158-.08.209.209 0 0 0-.163.026.267.267 0 0 0-.092.116.56.56 0 0 0-.048.186l.231 27.814-.355.03-.211-28.041v-.053a.476.476 0 0 0-.012-.119.303.303 0 0 0-.065-.13.279.279 0 0 0-.155-.08.215.215 0 0 0-.169.026.27.27 0 0 0-.093.114.546.546 0 0 0-.047.184l.034 28.143-.446.031.105-28.118.004-.052c0-.04-.004-.08-.013-.118a.28.28 0 0 0-.066-.13.282.282 0 0 0-.156-.082.213.213 0 0 0-.168.027.266.266 0 0 0-.092.116.612.612 0 0 0-.038.126c-.005.013-.006.026-.007.038v.022l-.269 28.226-.446.029.373-27.936a.455.455 0 0 0 0-.052.477.477 0 0 0-.012-.12.302.302 0 0 0-.065-.13.272.272 0 0 0-.157-.08.212.212 0 0 0-.163.025.264.264 0 0 0-.091.115.56.56 0 0 0-.047.186l-.533 28.05-.392.025ZM142.944 85.214l.054-.601 4.446-.826 2.469 1.325v.59l-2.532-1.36-4.437.872ZM143.767 109.553l1.771-22.561a.671.671 0 0 0-.003-.143.243.243 0 0 0-.047-.106.198.198 0 0 0-.118-.067.164.164 0 0 0-.131.022.245.245 0 0 0-.077.094.62.62 0 0 0-.036.104c-.004.017-.009.034-.009.051l-1.893 22.651-.311.02.38-4.359c.179-2.042.396-4.527.617-7.031.22-2.504.444-5.019.634-7.129.19-2.11.347-3.801.435-4.648a2.637 2.637 0 0 1 1.167-.552c.371-.071.75-.08 1.123-.028.288.04.57.107.845.202.113.038.225.083.333.133l-.947 23.075-.263.021 1.003-22.629a.395.395 0 0 0 0-.14.246.246 0 0 0-.045-.106.202.202 0 0 0-.119-.07.16.16 0 0 0-.133.02.234.234 0 0 0-.081.096.486.486 0 0 0-.045.153l-1.136 22.711-.277.022 1.15-22.895a.598.598 0 0 0 .005-.14.228.228 0 0 0-.044-.105.2.2 0 0 0-.118-.07.161.161 0 0 0-.132.023.23.23 0 0 0-.076.094.47.47 0 0 0-.042.153l-1.291 22.983-.347.024 1.404-22.955c.003-.014.004-.028.006-.043a.257.257 0 0 0-.046-.203.2.2 0 0 0-.118-.069.16.16 0 0 0-.132.02.24.24 0 0 0-.082.095.482.482 0 0 0-.042.13l-.004.023-1.529 23.043-.349.024 1.601-22.805a.394.394 0 0 0 .002-.14.256.256 0 0 0-.046-.105.197.197 0 0 0-.117-.07.165.165 0 0 0-.133.02.231.231 0 0 0-.078.094.62.62 0 0 0-.036.103c-.004.017-.009.033-.009.05l-1.729 22.894-.305.021ZM200.383 73.74l5.426-1.032 3.159 1.65.052.742-3.248-1.701-5.399 1.095.01-.755ZM225.935 82.811l-2.942-1.449-2.032.434.872-.796 1.183-.236 2.854 1.403.065.644ZM234.695 88.29l.739-.692 1.019-.203 2.51 1.219.07.557-2.58-1.254-1.758.372ZM230.764 85.2l-2.831-1.39-1.955.412.832-.766 1.141-.224 2.751 1.349.062.619ZM230.482 86.38l.794-.733 1.078-.212 2.626 1.287.056.59-2.691-1.326-1.863.394ZM238.541 90.131l.701-.652.972-.194 2.381 1.156.062.532-2.446-1.194-1.67.352ZM242.566 91.086l.909-.183 2.235 1.085.066.496-2.302-1.116-1.56.331.652-.613Z",
                        fill: "#1B023F"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m245.481 94.491 1.593 18.415-.317-.058-1.489-18.14a.323.323 0 0 0-.016-.116.205.205 0 0 0-.169-.141.137.137 0 0 0-.113.018.161.161 0 0 0-.055.082.288.288 0 0 0-.018.081l-.001.02.001.02.835 10.939-1.076-11.363c.276-.12.571-.19.872-.207a3.84 3.84 0 0 1 .815.037c.205.031.407.076.606.133.149.048.237.082.237.082l2.165 19.037-.239-.045-2.053-18.611a.326.326 0 0 0-.017-.117.213.213 0 0 0-.167-.142.144.144 0 0 0-.114.02.162.162 0 0 0-.057.081.382.382 0 0 0-.019.126l1.935 18.55-.252-.047-1.933-18.634a.283.283 0 0 0-.014-.117.208.208 0 0 0-.168-.141.148.148 0 0 0-.115.02.156.156 0 0 0-.056.081.333.333 0 0 0-.021.125l1.812 18.576-.31-.059-1.703-18.473a.285.285 0 0 0-.017-.117.205.205 0 0 0-.167-.142.144.144 0 0 0-.114.02.163.163 0 0 0-.058.08.39.39 0 0 0-.023.127ZM220.469 80.441l-2.982-1.55-2.844.583.994-.85 1.87-.354 2.9 1.5.062.671ZM245.384 93.043l.501-.57.442-.09 2.214 1.054.082.489-2.283-1.088-.956.205ZM234.039 90.335l.599 16.864-.122-2.556a7535.347 7535.347 0 0 1-.545-11.607c-.075-1.676-.129-2.895-.129-3.165a2.518 2.518 0 0 1 1.135-.537 3.746 3.746 0 0 1 1.141-.041 5.124 5.124 0 0 1 1.241.3l1.593 21.798-.275-.051-1.487-21.308v-.039a.402.402 0 0 0-.014-.092.227.227 0 0 0-.185-.163.162.162 0 0 0-.132.02.206.206 0 0 0-.069.091.425.425 0 0 0-.029.145l1.35 21.243-.285-.056-1.346-21.334a.354.354 0 0 0-.015-.131.256.256 0 0 0-.059-.1.245.245 0 0 0-.129-.065.18.18 0 0 0-.133.023.198.198 0 0 0-.068.091.452.452 0 0 0-.03.146l1.214 21.264-.354-.067-1.091-21.15.001-.013-.001-.026a.316.316 0 0 0-.016-.091.227.227 0 0 0-.19-.163.167.167 0 0 0-.13.021.204.204 0 0 0-.068.09.42.42 0 0 0-.03.146l.964 21.083-.354-.067-.868-20.764v-.04a.361.361 0 0 0-.015-.092.23.23 0 0 0-.187-.163.174.174 0 0 0-.132.023.201.201 0 0 0-.068.09.365.365 0 0 0-.026.096.348.348 0 0 0 0 .046l.744 20.703-.307-.056-.665-20.308a.36.36 0 0 0-.015-.132.23.23 0 0 0-.19-.163.165.165 0 0 0-.13.023.204.204 0 0 0-.068.09.412.412 0 0 0-.025.098l-.001.025a.14.14 0 0 1 .001.02ZM214.554 77.477l-3.094-1.62-2.322.472.864-.847 1.488-.28 3.017 1.57.047.705ZM241.935 93.256l.897 18.427-.208-2.36-.473-6.464-.419-9.304a.32.32 0 0 0-.014-.117.213.213 0 0 0-.169-.145h-.052l-.02.006-.02.007-.027-.363c.292-.175.619-.286.958-.326.308-.037.619-.035.927.007a4.669 4.669 0 0 1 .977.239l1.705 19.844-.245-.046-1.603-19.406a.376.376 0 0 0-.015-.117.212.212 0 0 0-.053-.09.21.21 0 0 0-.115-.056.146.146 0 0 0-.115.02.176.176 0 0 0-.059.08.372.372 0 0 0-.018.124l1.479 19.343-.257-.046-1.474-19.428a.376.376 0 0 0-.015-.118.212.212 0 0 0-.053-.088.212.212 0 0 0-.115-.058.154.154 0 0 0-.119.02.172.172 0 0 0-.059.082.355.355 0 0 0-.024.129l1.354 19.368-.322-.059-1.242-19.263V93.062a.375.375 0 0 0-.015-.081.235.235 0 0 0-.053-.089.217.217 0 0 0-.115-.057.15.15 0 0 0-.117.02.176.176 0 0 0-.061.081.374.374 0 0 0-.022.087.278.278 0 0 0 0 .041l1.129 19.204-.317-.058-1.037-18.922v-.036a.322.322 0 0 0-.014-.081.201.201 0 0 0-.168-.144.15.15 0 0 0-.116.02.176.176 0 0 0-.061.08.4.4 0 0 0-.025.129ZM251.745 95.421l-2.245-1.06-.933.193.478-.554.427-.081 2.187 1.032.086.47ZM215.155 106.957l-.082-25.042a.349.349 0 0 0-.001-.046.379.379 0 0 0-.014-.111.265.265 0 0 0-.212-.202.203.203 0 0 0-.158.025.238.238 0 0 0-.081.108.481.481 0 0 0-.041.173l-.062 24.976-.36-.066.008-1.484.024-4.052.007-1.036c.013-2.079.027-4.377.044-6.647.019-2.654.04-5.266.061-7.442.021-2.177.043-3.914.064-4.811.39-.32.855-.537 1.351-.628a4.314 4.314 0 0 1 1.347-.033c.35.045.696.121 1.034.228.14.043.277.093.412.15l1.136 26.777-.318-.059-1.028-26.184v-.048a.416.416 0 0 0-.015-.111.296.296 0 0 0-.065-.122.275.275 0 0 0-.149-.081.194.194 0 0 0-.154.025.24.24 0 0 0-.082.108.488.488 0 0 0-.04.173l.869 26.126-.337-.063-.857-26.234v-.048a.415.415 0 0 0-.015-.11.291.291 0 0 0-.065-.121.275.275 0 0 0-.23-.086.198.198 0 0 0-.075.03.247.247 0 0 0-.082.107.486.486 0 0 0-.039.173l.699 26.164-.418-.082-.559-26.028v-.048a.41.41 0 0 0-.015-.11.278.278 0 0 0-.065-.12.267.267 0 0 0-.147-.081.198.198 0 0 0-.157.023.238.238 0 0 0-.081.108.552.552 0 0 0-.04.174l.408 25.962-.419-.082-.301-25.58v-.048a.414.414 0 0 0-.013-.111.292.292 0 0 0-.063-.122.272.272 0 0 0-.149-.081.195.195 0 0 0-.156.025.241.241 0 0 0-.082.108.488.488 0 0 0-.041.174l.163 25.509-.359-.066ZM239.235 111.365l.003.079.003.003-.006-.082ZM238.538 91.793l.697 19.572-.514-7.047-.393-12.2a.371.371 0 0 0-.016-.126.222.222 0 0 0-.056-.094.226.226 0 0 0-.187-.062.165.165 0 0 0-.06.024.198.198 0 0 0-.065.086.377.377 0 0 0-.024.094.325.325 0 0 0 0 .044l.081 2.304-.202-2.79c.31-.241.674-.403 1.061-.471.35-.061.707-.07 1.06-.027.275.03.548.085.815.163.203.06.326.11.326.11l1.51 20.693-.26-.052-1.407-20.221a.36.36 0 0 0-.014-.124.216.216 0 0 0-.176-.156.167.167 0 0 0-.127.021.197.197 0 0 0-.065.087.38.38 0 0 0-.024.094.323.323 0 0 0 0 .044l1.273 20.161-.275-.053-1.271-20.246v-.038a.317.317 0 0 0-.015-.086.219.219 0 0 0-.179-.155.164.164 0 0 0-.127.022.192.192 0 0 0-.065.081.374.374 0 0 0-.025.094v.043l1.148 20.185-.337-.063-1.03-20.074a.324.324 0 0 0-.015-.126.214.214 0 0 0-.18-.154.159.159 0 0 0-.124.02.182.182 0 0 0-.064.082.434.434 0 0 0-.029.138l.911 20.009-.334-.062-.816-19.708a.367.367 0 0 0-.013-.126.216.216 0 0 0-.179-.156.164.164 0 0 0-.126.022.196.196 0 0 0-.064.086.433.433 0 0 0-.024.094.325.325 0 0 0 0 .044ZM252.83 113.975l-.234-.044-2.362-17.781a.187.187 0 0 0 0-.034.335.335 0 0 0-.018-.077.222.222 0 0 0-.054-.081.218.218 0 0 0-.112-.054.14.14 0 0 0-.111.017.149.149 0 0 0-.053.076.284.284 0 0 0-.016.12l2.244 17.725-.25-.047-2.247-17.797.001-.014-.001-.02a.287.287 0 0 0-.018-.082.229.229 0 0 0-.055-.082.21.21 0 0 0-.168-.056.139.139 0 0 0-.053.02.158.158 0 0 0-.055.077.364.364 0 0 0-.019.123l2.129 17.746-.301-.057-2.02-17.646a.285.285 0 0 0-.018-.116.215.215 0 0 0-.168-.135.139.139 0 0 0-.111.018.158.158 0 0 0-.053.076.285.285 0 0 0-.016.12l1.906 17.592-.3-.058-1.809-17.32.001-.014-.001-.019a.289.289 0 0 0-.017-.077.222.222 0 0 0-.226-.141.136.136 0 0 0-.053.02.163.163 0 0 0-.054.077.326.326 0 0 0-.017.121l1.06 10.669-1.296-11.08c.268-.118.555-.188.847-.204.267-.018.535-.005.799.035a4.593 4.593 0 0 1 .825.206l2.474 18.198ZM221.009 108.048l-.349-23.855a.72.72 0 0 0-.018-.152.281.281 0 0 0-.064-.115.272.272 0 0 0-.146-.074.198.198 0 0 0-.153.027.24.24 0 0 0-.082.104.449.449 0 0 0-.038.166l.208 23.782-.353-.066-.027-5.359c-.012-2.234-.024-4.793-.034-7.307-.01-2.515-.017-4.983-.02-7.038-.003-2.055-.001-3.693.01-4.544.38-.313.833-.526 1.316-.62.435-.083.88-.099 1.32-.047a5.83 5.83 0 0 1 1.423.346l1.022 18.643-.01-2.686-.009-2.112a40703.401 40703.401 0 0 0-.014-4.685l-.001-1.481.001-2.454c0-1.116.005-2 .012-2.547.365-.3.8-.505 1.265-.594a4.16 4.16 0 0 1 1.268-.046 5.643 5.643 0 0 1 1.37.331l.643 11.742-.005-1.47-.005-1.539c-.004-.96-.004-1.868-.004-2.69l-.001-.826.001-1.355.005-.871c.002-.234.004-.437.004-.607a2.716 2.716 0 0 1 1.209-.57 3.93 3.93 0 0 1 1.209-.043c.315.034.627.097.931.188.126.036.25.079.371.128l1.282 22.816-.285-.055-1.137-22.287.001-.025-.001-.018a.348.348 0 0 0-.014-.096.23.23 0 0 0-.195-.171.179.179 0 0 0-.139.022.208.208 0 0 0-.073.095.422.422 0 0 0-.029.105c-.005.016-.005.032-.005.048l.999 22.22-.304-.058-.988-22.319a.3.3 0 0 0 0-.042.354.354 0 0 0-.014-.097.247.247 0 0 0-.061-.106.248.248 0 0 0-.207-.071.18.18 0 0 0-.067.027.222.222 0 0 0-.075.096.464.464 0 0 0-.034.152l.853 22.248-.372-.068-.727-22.126a.3.3 0 0 0 0-.042.354.354 0 0 0-.014-.097.232.232 0 0 0-.196-.172.178.178 0 0 0-.141.023.211.211 0 0 0-.073.095.416.416 0 0 0-.034.151l.597 22.059-.373-.069-.498-21.721a.3.3 0 0 0 0-.043.353.353 0 0 0-.014-.097.252.252 0 0 0-.06-.105.256.256 0 0 0-.137-.068.179.179 0 0 0-.138.022.216.216 0 0 0-.073.095.412.412 0 0 0-.028.104c-.005.016-.005.032-.005.049l.372 21.655-.327-.059-.297-21.24a.311.311 0 0 0 0-.042.36.36 0 0 0-.014-.098.244.244 0 0 0-.06-.106.237.237 0 0 0-.133-.067.187.187 0 0 0-.141.025.215.215 0 0 0-.075.096.469.469 0 0 0-.035.153l.124 14.758.353 6.466-.619-.116-.008-1.363-.002-.382-.006-1.249-.01-1.837-.004-.666c-.003-.432-.006-.874-.006-1.322l-.853-16.676a.385.385 0 0 0-.015-.145.25.25 0 0 0-.062-.11.254.254 0 0 0-.141-.071.191.191 0 0 0-.147.024.223.223 0 0 0-.082.1.46.46 0 0 0-.035.161l1.06 23.478-.32-.061-1.051-23.58v-.045a.358.358 0 0 0-.015-.102.264.264 0 0 0-.062-.111.25.25 0 0 0-.14-.07.193.193 0 0 0-.15.025.229.229 0 0 0-.081.1.411.411 0 0 0-.03.108c-.003.017-.004.034-.005.05l.907 23.51-.392-.073-.774-23.38v-.043a.385.385 0 0 0-.016-.102.252.252 0 0 0-.203-.181.194.194 0 0 0-.148.023.226.226 0 0 0-.082.1.469.469 0 0 0-.037.162l.64 23.307-.395-.072-.53-22.957.001-.027-.001-.018a.437.437 0 0 0-.015-.102.25.25 0 0 0-.205-.183.197.197 0 0 0-.148.026.231.231 0 0 0-.081.1.461.461 0 0 0-.037.16l.4 22.886-.336-.064-.326-22.45v-.045a.437.437 0 0 0-.014-.102.244.244 0 0 0-.074-.121.236.236 0 0 0-.129-.058.19.19 0 0 0-.146.024.234.234 0 0 0-.082.1.46.46 0 0 0-.032.11l-.004.03-.001.021.197 22.234.006.139-.345-.063v-.662l-1.254-24.337a.416.416 0 0 0-.016-.15.257.257 0 0 0-.213-.19.193.193 0 0 0-.151.026.243.243 0 0 0-.081.104.454.454 0 0 0-.032.114l-.003.022-.003.032 1.136 24.926-.332-.062-1.122-25.032v-.047a.422.422 0 0 0-.016-.106.284.284 0 0 0-.064-.116.266.266 0 0 0-.145-.074.201.201 0 0 0-.154.026.237.237 0 0 0-.082.104.447.447 0 0 0-.038.167l.972 24.958-.412-.074-.826-24.828a.412.412 0 0 0-.017-.15.255.255 0 0 0-.213-.188.195.195 0 0 0-.153.026.243.243 0 0 0-.081.104.456.456 0 0 0-.032.114l-.003.023-.003.031.684 24.748-.411-.075-.571-24.38a.36.36 0 0 0 0-.047.382.382 0 0 0-.016-.106.259.259 0 0 0-.212-.19.201.201 0 0 0-.154.025.234.234 0 0 0-.081.104.502.502 0 0 0-.031.114c-.005.018-.005.036-.005.054l.431 24.309-.353-.067Z",
                        fill: "#1B023F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "hero-darkmode-mobile_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h390v151H0z"
                    })
                })
            })
        ]
    });
var $03a32c11bda34481$export$2e2bcd8739ae039 = $03a32c11bda34481$var$SvgHeroDarkmodeMobile;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $f7b7ad9f885c4152$var$SvgHeroLightmodeDesktop = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 1440 184",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#hero-lightmode-desktop_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "M1440 0H0v185h1440V0Z",
                        fill: "#4D00B4"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M952.586 185 880.033 23.594 620.972 12 488 177.832V185h8.163L598.654 55.422 568.112 185h154.777l88.01-38.499L805.818 185h36.325l5.605-41.488L888.582 185h47.581l-79.334-80.744 23.383-48.06 60 128.804h12.374ZM639.117 40.657l150.044 64.689-181.563 71.316 31.519-136.005Zm59.131-13.668L851.079 33.2l-26.763 48.996-126.068-55.207Z",
                        fill: "#5C16BA"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m767.645 98.287-.007-1.889-31.083-17.094.439 4.466 30.651 14.517Zm30.195 16.009.103-1.23-8.989-5.001.153 1.705 8.733 4.526Zm-61.052-36.784 6.179 3.49-.378-2.342-5.467-4.986-.334 3.838Zm-88.752 26.826 87.53-16.605-.858-8.468-86.783 19.386.177 3.077-.633.394.267.639.3 1.577Zm87.103-28.886 1.149-3.133-9.24-.319-.272 2.38-4.767.062.029 2.082-33.837-1.63-.497 6.69-2.527.33.264-2.526-4.6 1.25.034 2.223-3.274.341.275-1.34-10.805 4.302-11.803 6.837-5.189 1.403 3.096-1.819-.32-1.182-2.356 1.364-.17-1.189-5.177 2.151.505 3.702 1.048.132 88.599-20.773-.165-1.338Zm2.419 12.269 61.411 30.498-.403-2.121-29.702-15.055-31.471-15.679.165 2.356Zm-91.171 56.345 60.282-6.506-59.549 4.634-.733 1.872Zm154.2 4.788-64.443-11.367.281 5.747L801 149.636l-.413-.782Zm-.114 1.899-63.848-6.039.114 3.461 63.734 2.578ZM639 151l63.876-2.899 31.197.276-.162-12.482-30.652 4.078-61.488 4.576-.121 1.1 57.239-3.546-39.215 3.688-20.206 1.25L639 151Zm22.591-46.787 3.688 1.968v-.853l-3.593-1.914-6.425 1.193-.066.87 6.396-1.264Zm6.984 2.066-2.044 33.381.482-.033 1.961-33.873c0-.025.008-.05.013-.074a.785.785 0 0 1 .056-.156.38.38 0 0 1 .114-.143.281.281 0 0 1 .101-.038.275.275 0 0 1 .107.005c.073.013.14.05.191.104a.345.345 0 0 1 .076.16c.011.048.014.097.011.147 0 .021 0 .042-.007.063l-1.772 33.743.558-.04 1.647-34.101a.697.697 0 0 1 .067-.227.348.348 0 0 1 .114-.141.266.266 0 0 1 .101-.036.262.262 0 0 1 .108.005c.073.011.14.047.19.102a.341.341 0 0 1 .075.158.587.587 0 0 1 .001.209l-1.428 33.965.544-.037 1.266-34.004a.602.602 0 0 1 .013-.074.643.643 0 0 1 .049-.154.364.364 0 0 1 .114-.141.263.263 0 0 1 .21-.03c.073.012.14.049.19.103.038.045.064.1.075.158.009.048.013.096.009.144a.34.34 0 0 1-.008.064l-1.049 33.873.44-.029 1.027-33.602a.653.653 0 0 1 .066-.227.348.348 0 0 1 .114-.141.284.284 0 0 1 .212-.033c.073.014.14.051.19.106.039.045.065.1.076.159.009.048.012.097.009.145a.448.448 0 0 1-.008.064l-.82 33.468.416-.03.729-34.136a5.64 5.64 0 0 0-.536-.198 7.592 7.592 0 0 0-1.355-.299 5.847 5.847 0 0 0-1.791.043 4.253 4.253 0 0 0-1.844.828c-.115 1.237-.297 3.684-.523 6.737-.226 3.053-.49 6.707-.751 10.372a11062.362 11062.362 0 0 0-1.211 17.176l.489-.034 2.244-33.517a.781.781 0 0 1 .069-.228.361.361 0 0 1 .121-.142.281.281 0 0 1 .101-.038.28.28 0 0 1 .108.005c.074.013.141.05.192.104a.346.346 0 0 1 .076.159c.01.048.014.097.01.146 0 .02 0 .041-.008.061l.023-.001Zm-3.133-2.664 6.595-1.307 3.824 2.034-.021-.883-3.732-1.978-6.621 1.236-.045.898Zm14.663.618-1.745 34.574.498-.034 1.66-35.082a.72.72 0 0 1 .067-.238.363.363 0 0 1 .123-.146.284.284 0 0 1 .106-.04.283.283 0 0 1 .112.006.333.333 0 0 1 .276.27c.01.05.014.1.012.15 0 .022 0 .045-.007.066l-1.458 34.947.571-.039 1.323-35.31a.715.715 0 0 1 .069-.236.358.358 0 0 1 .124-.146.29.29 0 0 1 .219-.034.354.354 0 0 1 .198.113c.04.048.067.105.08.165.01.05.014.1.012.15 0 .022 0 .045-.007.066l-1.112 35.166.571-.045.931-35.206a.717.717 0 0 1 .065-.238.357.357 0 0 1 .121-.146.28.28 0 0 1 .215-.033.348.348 0 0 1 .28.278.584.584 0 0 1 .002.216l-.722 35.074.457-.033.691-34.798a.654.654 0 0 1 .013-.075.62.62 0 0 1 .055-.16.353.353 0 0 1 .122-.146.28.28 0 0 1 .216-.035.358.358 0 0 1 .196.108c.04.048.067.105.08.165a.592.592 0 0 1 .004.217l-.478 34.66.427-.031.381-35.352a7.708 7.708 0 0 0-1.956-.512 5.967 5.967 0 0 0-1.848.045 4.344 4.344 0 0 0-1.893.856 681.964 681.964 0 0 0-.466 7.015c-.202 3.182-.432 6.979-.66 10.781-.228 3.802-.457 7.599-.645 10.76-.188 3.161-.336 5.684-.41 6.945l.5-.034 1.941-34.704a.839.839 0 0 1 .068-.238.37.37 0 0 1 .125-.147.286.286 0 0 1 .218-.036.342.342 0 0 1 .195.114c.04.047.067.104.079.165.01.049.013.1.01.15a.383.383 0 0 1-.007.058l.001-.006Zm29.31-8.875 4.263 2.233-.056-.974-4.146-2.17-7.204 1.358-.029.988 7.172-1.435Zm-32.574 6.123 6.786-1.352 3.979 2.106-.032-.91-3.87-2.046-6.816 1.269-.047.933Zm15.433.314-1.458 36.11.515-.033 1.361-36.641a.651.651 0 0 1 .013-.077.719.719 0 0 1 .052-.169.375.375 0 0 1 .124-.152.29.29 0 0 1 .228-.037.358.358 0 0 1 .287.283.618.618 0 0 1 .007.222l-1.142 36.501.591-.043 1.014-36.87a.689.689 0 0 1 .068-.243.37.37 0 0 1 .124-.153.291.291 0 0 1 .22-.037c.08.015.153.054.208.114a.38.38 0 0 1 .086.168.563.563 0 0 1 .007.22l-.8 36.736.585-.042.606-36.772a.689.689 0 0 1 .068-.243.363.363 0 0 1 .125-.152.275.275 0 0 1 .111-.04.288.288 0 0 1 .117.006.36.36 0 0 1 .29.285.578.578 0 0 1 .007.224l-.394 36.626.476-.036.359-36.34a.683.683 0 0 1 .065-.245.372.372 0 0 1 .124-.151.294.294 0 0 1 .229-.034.36.36 0 0 1 .203.114c.041.048.07.107.083.169a.578.578 0 0 1 .007.223l-.143 36.197.448-.029.029-36.911a5.723 5.723 0 0 0-.57-.211 8.151 8.151 0 0 0-1.447-.321 6.155 6.155 0 0 0-1.903.045 4.404 4.404 0 0 0-1.941.881 707.73 707.73 0 0 0-.428 7.552c-.182 3.426-.391 7.52-.594 11.567a9820.9 9820.9 0 0 0-.562 11.272l-.329 6.685.518-.037 1.665-36.252a.7.7 0 0 1 .067-.244.374.374 0 0 1 .125-.151.293.293 0 0 1 .108-.04.274.274 0 0 1 .114.006.364.364 0 0 1 .205.113c.041.049.07.107.083.17a.625.625 0 0 1 .014.156.632.632 0 0 1-.018.062l-.007-.001Zm-3.386-2.842 6.977-1.396 4.121 2.171-.044-.943-4.011-2.108-7.004 1.317-.039.96Zm26.37-4.572 7.368-1.477 4.405 2.302-.062-1-4.288-2.238-7.397 1.394-.026 1.02Zm-56.446 13.663-2.169 32.334.435-.037 2.116-32.807a.647.647 0 0 1 .063-.22.337.337 0 0 1 .114-.137.217.217 0 0 1 .092-.036.208.208 0 0 1 .099.006.29.29 0 0 1 .173.101.33.33 0 0 1 .067.153.607.607 0 0 1-.001.202l-1.932 32.687.506-.037 1.816-33.03c0-.024.007-.048.013-.071a.729.729 0 0 1 .051-.149.35.35 0 0 1 .114-.136.242.242 0 0 1 .191-.031.3.3 0 0 1 .173.101.347.347 0 0 1 .068.153.542.542 0 0 1 .002.201l-1.633 32.904.497-.038 1.468-32.938a.714.714 0 0 1 .062-.22.356.356 0 0 1 .114-.138.232.232 0 0 1 .189-.032c.068.013.13.048.174.102.036.045.06.098.069.154a.607.607 0 0 1 .008.141c-.001.021-.004.042-.007.063L660.46 140.1l.405-.03 1.256-32.551a.72.72 0 0 1 .06-.222.356.356 0 0 1 .114-.138.236.236 0 0 1 .191-.03.31.31 0 0 1 .173.099.347.347 0 0 1 .068.153c.008.046.011.093.008.139a.42.42 0 0 1-.007.062l-1.063 32.435.381-.029.986-33.078a4.629 4.629 0 0 0-.486-.192 6.518 6.518 0 0 0-1.227-.29 4.938 4.938 0 0 0-1.627.04 3.782 3.782 0 0 0-1.682.796c-.114 1.2-.305 3.579-.54 6.546-.235 2.967-.51 6.52-.783 10.072-.273 3.552-.543 7.101-.767 10.061-.225 2.96-.402 5.33-.492 6.523l.448-.035 2.345-32.452a.661.661 0 0 1 .063-.221.328.328 0 0 1 .114-.136.236.236 0 0 1 .191-.031.296.296 0 0 1 .172.101.348.348 0 0 1 .066.154.59.59 0 0 1 .007.139.377.377 0 0 1-.022.059Zm49.3-9.184-.47 37.829.606-.042.272-37.867a.731.731 0 0 1 .065-.25.377.377 0 0 1 .126-.156.301.301 0 0 1 .229-.037.378.378 0 0 1 .212.114c.044.05.074.11.089.175a.608.608 0 0 1 .017.159.401.401 0 0 1 0 .07l-.063 37.72.494-.035.018-37.42a.728.728 0 0 1 .066-.253.39.39 0 0 1 .127-.158.295.295 0 0 1 .228-.04.372.372 0 0 1 .211.114c.044.05.074.11.087.176a.617.617 0 0 1 .007.23l.206 37.284.456-.033-.327-38.012a6.06 6.06 0 0 0-.592-.218 8.38 8.38 0 0 0-1.484-.33 6.24 6.24 0 0 0-1.956.047 4.475 4.475 0 0 0-1.99.91 680.589 680.589 0 0 0-.368 7.747 4640.56 4640.56 0 0 0-.502 11.875c-.172 4.158-.343 8.268-.472 11.605-.129 3.338-.228 5.899-.275 6.956l.534-.043 1.362-37.332a.73.73 0 0 1 .066-.25.373.373 0 0 1 .128-.154.305.305 0 0 1 .229-.035.375.375 0 0 1 .212.113c.043.05.073.11.087.174a.608.608 0 0 1 .013.16c0 .022 0 .046-.006.069l-1.149 37.19.529-.038 1.052-37.73a.78.78 0 0 1 .065-.251.366.366 0 0 1 .126-.157.285.285 0 0 1 .228-.035.37.37 0 0 1 .301.286.568.568 0 0 1 .008.229l-.835 37.589.608-.047.685-37.973a.785.785 0 0 1 .069-.251.38.38 0 0 1 .128-.156.293.293 0 0 1 .228-.035.377.377 0 0 1 .211.114c.043.05.074.11.088.173a.6.6 0 0 1 .016.158.855.855 0 0 1 0 .072Zm25.652-4.56.182 40.49.273-.021.367.068-.39-40.626a.762.762 0 0 1 .062-.266.385.385 0 0 1 .13-.166.314.314 0 0 1 .242-.04c.088.016.168.06.228.124a.44.44 0 0 1 .097.185.637.637 0 0 1 .02.169v.074l.637 40.734.516.095-.662-40.549a.813.813 0 0 1 .066-.267.394.394 0 0 1 .131-.166.302.302 0 0 1 .24-.037.41.41 0 0 1 .228.12c.047.053.08.116.097.184a.637.637 0 0 1 .02.168v.074l.913 40.664h.281v.055l.526.095.731-37.115a.726.726 0 0 1 .065-.253.371.371 0 0 1 .125-.158.296.296 0 0 1 .229-.038c.083.014.16.054.219.114.046.05.078.111.094.177.013.053.02.108.019.163v.071l-.53 37.214.525.098.426-37.897a.705.705 0 0 1 .06-.256.35.35 0 0 1 .124-.158.297.297 0 0 1 .228-.035.371.371 0 0 1 .216.114.4.4 0 0 1 .09.177.601.601 0 0 1 .011.235l-.206 37.996.612.114.04-38.546a.801.801 0 0 1 .063-.255.362.362 0 0 1 .125-.158.296.296 0 0 1 .229-.037.384.384 0 0 1 .215.113c.045.05.077.111.093.176a.619.619 0 0 1 .018.16v.071l.162 38.655.613.113-.367-38.848a.798.798 0 0 1 .061-.254.363.363 0 0 1 .126-.158.288.288 0 0 1 .228-.036.39.39 0 0 1 .216.113c.044.05.076.111.092.177.013.052.02.107.019.161v.07l.6 38.953.495.09-.626-38.778a.8.8 0 0 1 .064-.253.368.368 0 0 1 .124-.157.286.286 0 0 1 .228-.035.383.383 0 0 1 .216.113.41.41 0 0 1 .093.177c.013.052.02.107.019.161v.07l.851 38.762h.468l-1-39.535a6.322 6.322 0 0 0-.602-.219 8.55 8.55 0 0 0-1.509-.332 6.318 6.318 0 0 0-1.974.048 4.442 4.442 0 0 0-1.993.92 441.452 441.452 0 0 0-.184 5.797 4392.805 4392.805 0 0 0-.478 19.038c-.077 3.247-.147 6.26-.203 8.683l-.95-37.198a8.954 8.954 0 0 0-2.214-.576 6.615 6.615 0 0 0-2.069.05 4.67 4.67 0 0 0-2.092.966 754.024 754.024 0 0 0-.26 8.615c-.104 3.911-.219 8.574-.329 13.128a8917.528 8917.528 0 0 0-.44 19.115l.561-.036.777-39.964a.818.818 0 0 1 .068-.266.389.389 0 0 1 .131-.166.31.31 0 0 1 .24-.04.412.412 0 0 1 .228.122c.047.053.08.117.097.185a.646.646 0 0 1 .02.17v.074l-.556 39.809.563-.043.437-40.381c0-.029 0-.057.01-.086a.768.768 0 0 1 .053-.181.4.4 0 0 1 .131-.168.306.306 0 0 1 .242-.04c.087.015.167.059.228.123a.435.435 0 0 1 .095.186.635.635 0 0 1 .016.168c0 .025 0 .049-.007.074l-.205 40.239.645-.046.048-40.643a.773.773 0 0 1 .067-.267.388.388 0 0 1 .131-.166.307.307 0 0 1 .24-.039.403.403 0 0 1 .324.308c.014.055.02.112.019.17a.727.727 0 0 1-.012.065l-.001-.005Zm-14.865 3.098-.854 38.534.548-.035.747-39.102a.77.77 0 0 1 .065-.26.367.367 0 0 1 .127-.161.305.305 0 0 1 .229-.035.377.377 0 0 1 .219.114.414.414 0 0 1 .091.18.62.62 0 0 1 .017.166.442.442 0 0 1 0 .073l-.522 38.945.624-.041.377-39.349c0-.027 0-.055.01-.082a.777.777 0 0 1 .054-.177.368.368 0 0 1 .128-.161.295.295 0 0 1 .235-.038c.083.014.16.054.219.114a.403.403 0 0 1 .093.18.702.702 0 0 1 .011.238l-.146 39.199.624-.044-.048-39.233a.759.759 0 0 1 .066-.256.375.375 0 0 1 .131-.159.295.295 0 0 1 .236-.037.387.387 0 0 1 .217.113.414.414 0 0 1 .091.181c.013.054.018.11.017.166v.073l.295 39.09.498-.04-.323-38.775a.77.77 0 0 1 .066-.26.372.372 0 0 1 .129-.16.291.291 0 0 1 .228-.038.397.397 0 0 1 .221.113.413.413 0 0 1 .094.18.644.644 0 0 1 .017.164.428.428 0 0 1 0 .071l.546 38.641.477-.038-.685-39.392a6.166 6.166 0 0 0-.613-.227 8.66 8.66 0 0 0-1.539-.341 6.477 6.477 0 0 0-2.015.049 4.578 4.578 0 0 0-2.041.937 729.772 729.772 0 0 0-.316 8.193c-.13 3.719-.277 8.157-.418 12.518a12649.735 12649.735 0 0 0-.591 18.854l.544-.042 1.077-38.686a.767.767 0 0 1 .066-.259.39.39 0 0 1 .13-.161.307.307 0 0 1 .236-.038c.084.014.16.053.218.114a.416.416 0 0 1 .092.18c.012.055.018.11.017.165a.753.753 0 0 1-.016.082Zm-71.709 8.815-.075.839 6.211-1.216 3.546 1.897v-.823l-3.457-1.848-6.225 1.151Zm3.556 3.317-2.48 31.451.427-.029 2.422-31.916c0-.023.006-.046.012-.069a.818.818 0 0 1 .05-.144.337.337 0 0 1 .109-.131.238.238 0 0 1 .186-.027.273.273 0 0 1 .164.097.334.334 0 0 1 .064.147.518.518 0 0 1-.002.195l-2.242 31.791.489-.033 2.141-32.123a.65.65 0 0 1 .064-.214.346.346 0 0 1 .114-.132.246.246 0 0 1 .09-.034.222.222 0 0 1 .096.006.278.278 0 0 1 .165.097.334.334 0 0 1 .064.147.618.618 0 0 1-.008.195l-1.966 32.001.486-.034 1.807-32.04a.742.742 0 0 1 .06-.213.315.315 0 0 1 .106-.131.239.239 0 0 1 .089-.036.239.239 0 0 1 .096.005.27.27 0 0 1 .164.097.322.322 0 0 1 .063.147.516.516 0 0 1 0 .136c-.002.019-.004.039-.008.059l-1.61 31.916.389-.03 1.59-31.661a.742.742 0 0 1 .063-.214.323.323 0 0 1 .114-.132.22.22 0 0 1 .186-.029.283.283 0 0 1 .165.097.342.342 0 0 1 .064.149.562.562 0 0 1 0 .195l-1.404 31.545.368-.028 1.326-32.169a4.579 4.579 0 0 0-.467-.185 6.237 6.237 0 0 0-1.182-.281 4.795 4.795 0 0 0-1.572.038 3.705 3.705 0 0 0-1.635.77c-.122 1.18-.343 3.538-.609 6.48-.266 2.941-.58 6.447-.888 9.938l-.863 9.801-.532 6.077.435-.028 2.651-31.576c0-.024.007-.048.013-.072a.664.664 0 0 1 .05-.144.337.337 0 0 1 .107-.132.234.234 0 0 1 .184-.031.282.282 0 0 1 .165.094.318.318 0 0 1 .065.148.523.523 0 0 1 .007.137c0 .021 0 .041-.002.062Zm84.383-19.912-7.596 1.438-.014 1.05 7.559-1.526 4.547 2.371-.073-1.033-4.423-2.3Zm24.059 12.064 4.119 2.02-.091-.898-3.996-1.956-1.656.329-1.221 1.109 2.845-.604Zm17.419 8.693-1.036.964 2.463-.519 3.61 1.747-.097-.776-3.513-1.698-1.427.282Zm-10.503-5.281 3.965 1.938-.087-.863-3.852-1.88-1.598.311-1.164 1.069 2.736-.575Zm4.68 2.561-1.11 1.023 2.608-.551 3.767 1.849-.078-.822-3.677-1.794-1.51.295Zm11.154 5.342-.982.909 2.338-.491 3.425 1.664-.087-.741-3.333-1.611-1.361.27Zm5.926 1.985-1.272.255-.913.855 2.184-.461 3.222 1.556-.091-.692-3.13-1.513Zm5.039 30.674-2.23-25.672a.531.531 0 0 1 .032-.176.238.238 0 0 1 .081-.114.2.2 0 0 1 .077-.029.193.193 0 0 1 .083.003.292.292 0 0 1 .234.198.444.444 0 0 1 .023.163l2.385 25.752.433.082-2.536-25.896a.493.493 0 0 1 .029-.174.223.223 0 0 1 .078-.113.203.203 0 0 1 .161-.028.286.286 0 0 1 .235.198.37.37 0 0 1 .021.114.4.4 0 0 1 0 .049l2.706 25.975.352.066-2.709-25.859a.503.503 0 0 1 .028-.176.215.215 0 0 1 .079-.113.192.192 0 0 1 .076-.03.193.193 0 0 1 .083.003.298.298 0 0 1 .158.077c.034.034.06.075.076.12a.446.446 0 0 1 .024.163l2.875 25.945.334.064-3.032-26.54s-.122-.048-.331-.114a6.64 6.64 0 0 0-.848-.185 5.387 5.387 0 0 0-1.142-.052c-.42.024-.833.121-1.22.289l1.506 15.841-1.169-15.249a.447.447 0 0 1 .025-.171.223.223 0 0 1 .078-.113.19.19 0 0 1 .158-.025.287.287 0 0 1 .236.196.404.404 0 0 1 .022.162l2.086 25.288.443.081Zm-41.424-47.418 4.176 2.16-.087-.937-4.061-2.09-2.617.494-1.392 1.185 3.981-.812Zm39.759 18.932-.701.796 1.338-.286 3.197 1.517-.114-.682-3.101-1.47-.619.125Zm-15.746 20.53-.839-23.509a.683.683 0 0 1 0-.064.525.525 0 0 1 .036-.136.278.278 0 0 1 .094-.127.25.25 0 0 1 .088-.035.248.248 0 0 1 .094.003.321.321 0 0 1 .266.228.513.513 0 0 1 .022.184l.931 28.31.429.078-1.042-28.861a.683.683 0 0 1 0-.064.589.589 0 0 1 .037-.135.275.275 0 0 1 .096-.125.23.23 0 0 1 .088-.034.234.234 0 0 1 .095.002.321.321 0 0 1 .263.228.503.503 0 0 1 .02.184l1.216 28.946.496.094-1.35-29.391a.682.682 0 0 1 .042-.203.282.282 0 0 1 .095-.126.237.237 0 0 1 .182-.031.321.321 0 0 1 .267.228.497.497 0 0 1 .022.183l1.527 29.483.496.093-1.699-29.643a.612.612 0 0 1 .041-.203.28.28 0 0 1 .096-.127.26.26 0 0 1 .09-.035.343.343 0 0 1 .276.093.334.334 0 0 1 .082.139.457.457 0 0 1 .022.183l1.884 29.741.399.078-1.89-29.614a.611.611 0 0 1 .041-.202.292.292 0 0 1 .096-.126.225.225 0 0 1 .185-.029.316.316 0 0 1 .259.228.454.454 0 0 1 .019.127.262.262 0 0 1 0 .056l2.083 29.704.385.07-2.23-30.388s-.187-.077-.498-.168a7.169 7.169 0 0 0-1.24-.249 5.257 5.257 0 0 0-1.598.057 3.535 3.535 0 0 0-1.589.749c0 .376.075 2.075.18 4.412.105 2.337.245 5.31.384 8.235a10183.666 10183.666 0 0 0 .551 11.509Zm-32.451-43.691 4.332 2.257-.065-.982-4.224-2.19-2.084.39-1.21 1.182 3.251-.657Zm43.923 49.942-1.256-25.689a.543.543 0 0 1 .036-.178.24.24 0 0 1 .084-.114.223.223 0 0 1 .079-.03.222.222 0 0 1 .085.004.282.282 0 0 1 .234.2.439.439 0 0 1 .019.164l1.452 26.378.444.08-1.58-26.771a.542.542 0 0 1 0-.057.513.513 0 0 1 .031-.121.241.241 0 0 1 .085-.114.207.207 0 0 1 .164-.027.296.296 0 0 1 .161.079.32.32 0 0 1 .074.124.546.546 0 0 1 .021.164l1.739 26.853.45.082-1.895-27a.53.53 0 0 1 .033-.18.236.236 0 0 1 .084-.113.21.21 0 0 1 .165-.029c.061.01.118.038.162.081.034.035.06.077.074.124a.441.441 0 0 1 .021.164l2.064 27.082.36.065-2.071-26.964a.533.533 0 0 1 .025-.173.247.247 0 0 1 .082-.114.22.22 0 0 1 .078-.031.216.216 0 0 1 .084.004.296.296 0 0 1 .161.079c.034.035.06.078.074.124a.441.441 0 0 1 .021.164l2.244 27.053.343.064-2.387-27.664s-.145-.058-.389-.128a6.524 6.524 0 0 0-.979-.205 5.126 5.126 0 0 0-1.298-.009 3.398 3.398 0 0 0-1.341.455l.038.506.028-.011.028-.008h.072a.29.29 0 0 1 .237.203.4.4 0 0 1 .02.162l.587 12.971.662 9.011.291 3.29Zm9.335-24.147 3.144 1.477-.121-.656-3.062-1.439-.597.114-.67.772 1.306-.268ZM748.1 102.452l.114 34.91.503.092-.228-35.56a.666.666 0 0 1 .057-.242.342.342 0 0 1 .114-.151.276.276 0 0 1 .219-.036.38.38 0 0 1 .208.114.379.379 0 0 1 .089.169.627.627 0 0 1 .019.155v.068l.421 35.659.587.114-.571-36.191a.722.722 0 0 1 .055-.243.332.332 0 0 1 .114-.15.268.268 0 0 1 .219-.033.373.373 0 0 1 .298.28c.014.05.021.102.02.154v.067l.783 36.284.585.114-.978-36.473a.662.662 0 0 1 .054-.242.341.341 0 0 1 .115-.15.27.27 0 0 1 .105-.04.386.386 0 0 1 .322.118.406.406 0 0 1 .091.168.545.545 0 0 1 .02.155v.067l1.2 36.572.473.087-1.217-36.42c.002-.026.004-.052.009-.078a.73.73 0 0 1 .047-.164.339.339 0 0 1 .114-.15.267.267 0 0 1 .216-.036c.08.015.153.055.209.114a.393.393 0 0 1 .091.169.585.585 0 0 1 .021.155v.067l1.439 36.503.446.081-1.591-37.327a6.217 6.217 0 0 0-.577-.211 8.332 8.332 0 0 0-1.448-.317 6.05 6.05 0 0 0-1.885.046 4.161 4.161 0 0 0-1.891.875c-.03 1.25-.061 3.673-.091 6.706a4802.61 4802.61 0 0 0-.085 10.376c-.028 3.7-.05 7.453-.071 10.71-.021 3.257-.035 6.013-.046 7.718l.505.092.087-34.819a.659.659 0 0 1 .057-.241.332.332 0 0 1 .114-.15.27.27 0 0 1 .22-.035.372.372 0 0 1 .298.282c.014.05.02.102.02.154a.683.683 0 0 1 .001.064Zm33.832 41.165-.98-27.394a.62.62 0 0 1 0-.061.587.587 0 0 1 .034-.131.27.27 0 0 1 .09-.121.23.23 0 0 1 .176-.029.3.3 0 0 1 .25.217.5.5 0 0 1 .019.175l1.142 27.474.468.087-1.276-27.894a.6.6 0 0 1 .041-.192.251.251 0 0 1 .09-.114.226.226 0 0 1 .173-.028.3.3 0 0 1 .252.215.486.486 0 0 1 .021.175l1.442 27.984.473.087-1.608-28.138a.62.62 0 0 1 0-.061.484.484 0 0 1 .035-.129.26.26 0 0 1 .091-.114.238.238 0 0 1 .086-.034.238.238 0 0 1 .092.003.307.307 0 0 1 .25.216.45.45 0 0 1 .02.173l1.78 28.224.386.074-1.783-28.106a.62.62 0 0 1 0-.061.538.538 0 0 1 .034-.131.271.271 0 0 1 .091-.12.233.233 0 0 1 .177-.03.304.304 0 0 1 .247.217.45.45 0 0 1 .019.173l1.971 28.19.364.071-2.114-28.845s-.173-.072-.457-.155a6.81 6.81 0 0 0-1.142-.227 5.057 5.057 0 0 0-1.484.037 3.4 3.4 0 0 0-1.484.656l.282 3.891-.114-3.212a.641.641 0 0 1 0-.062.542.542 0 0 1 .034-.13.282.282 0 0 1 .092-.121.227.227 0 0 1 .084-.033.32.32 0 0 1 .262.087.325.325 0 0 1 .078.131.468.468 0 0 1 .022.176l.55 17.007.729 9.938-.005-.005Zm18.702 3.467.328.061-3.464-25.368s-.121-.047-.326-.106a6.492 6.492 0 0 0-.83-.181 5.218 5.218 0 0 0-1.117-.05c-.409.024-.811.12-1.186.285l1.814 15.447-1.484-14.873a.446.446 0 0 1 .024-.169.23.23 0 0 1 .075-.107.22.22 0 0 1 .075-.029.307.307 0 0 1 .315.198.388.388 0 0 1 .025.153l2.533 24.145.42.08-2.669-24.523a.443.443 0 0 1 .022-.168.223.223 0 0 1 .075-.106.213.213 0 0 1 .075-.029.216.216 0 0 1 .08.003.3.3 0 0 1 .235.189.408.408 0 0 1 .025.161l2.828 24.6.422.08-2.98-24.74a.469.469 0 0 1 .026-.17.223.223 0 0 1 .076-.107.196.196 0 0 1 .155-.027.289.289 0 0 1 .156.077.326.326 0 0 1 .076.114.394.394 0 0 1 .025.161l3.147 24.81.349.065-3.142-24.708a.437.437 0 0 1 .023-.168.206.206 0 0 1 .074-.106.2.2 0 0 1 .156-.024.3.3 0 0 1 .156.075.3.3 0 0 1 .076.114.388.388 0 0 1 .025.153l3.307 24.788Zm-44.712-41.455.489 33.255.494.093-.604-33.888c0-.025 0-.05.007-.075a.718.718 0 0 1 .043-.159.34.34 0 0 1 .114-.146.296.296 0 0 1 .215-.034.363.363 0 0 1 .298.265.705.705 0 0 1 .022.213l.799 33.987.576.104-.958-34.499a.659.659 0 0 1 .053-.234.335.335 0 0 1 .114-.146.27.27 0 0 1 .214-.035.36.36 0 0 1 .299.261.549.549 0 0 1 .022.146.332.332 0 0 1 0 .063l1.157 34.611.578.104-1.361-34.793a.675.675 0 0 1 .052-.232.334.334 0 0 1 .115-.145.28.28 0 0 1 .216-.037.375.375 0 0 1 .203.104.395.395 0 0 1 .09.161.615.615 0 0 1 .021.213l1.571 34.896.465.086-1.589-34.747a.67.67 0 0 1 .052-.234.335.335 0 0 1 .114-.146.272.272 0 0 1 .212-.036.367.367 0 0 1 .298.264.599.599 0 0 1 .021.21l1.757 33.927v.923l.482.088-.008-.194-.276-30.995a.616.616 0 0 1 .052-.224.325.325 0 0 1 .114-.14.272.272 0 0 1 .205-.034.333.333 0 0 1 .284.25.523.523 0 0 1 .019.142.331.331 0 0 1 0 .063l.457 31.296.472.09-.561-31.904a.669.669 0 0 1 .051-.224.318.318 0 0 1 .115-.139.275.275 0 0 1 .206-.036.353.353 0 0 1 .287.255.567.567 0 0 1 .021.205l.742 32.003.554.1-.896-32.491a.683.683 0 0 1 .051-.225.325.325 0 0 1 .114-.14.281.281 0 0 1 .101-.038.275.275 0 0 1 .107.005.356.356 0 0 1 .285.254.553.553 0 0 1 .021.202l1.085 32.592.548.101-1.27-32.773a.65.65 0 0 1 .049-.221.329.329 0 0 1 .114-.139.283.283 0 0 1 .101-.039.28.28 0 0 1 .108.004.356.356 0 0 1 .197.098.351.351 0 0 1 .086.154.662.662 0 0 1 .021.206l1.473 32.872.447.084-1.484-32.729a.667.667 0 0 1 .049-.224.319.319 0 0 1 .114-.14.275.275 0 0 1 .207-.034.364.364 0 0 1 .197.099.349.349 0 0 1 .087.154.56.56 0 0 1 .021.202l1.194 23.246c0 .951.01 1.879.015 2.773l.013 2.561.012 2.273.01 1.901.867.161-.494-9.014-.173-20.574a.594.594 0 0 1 .048-.212.316.316 0 0 1 .105-.135.269.269 0 0 1 .197-.035c.071.01.137.043.188.093a.357.357 0 0 1 .083.148c.013.045.019.09.019.137a.3.3 0 0 1 0 .06l.417 29.608.457.082-.521-30.188c0-.023 0-.046.007-.068a.568.568 0 0 1 .04-.145.299.299 0 0 1 .102-.131.22.22 0 0 1 .093-.036.236.236 0 0 1 .099.004c.073.011.14.044.192.095.04.041.069.092.085.147a.512.512 0 0 1 .019.135.58.58 0 0 1 0 .059l.698 30.281.522.096-.835-30.751a.561.561 0 0 1 .047-.211.289.289 0 0 1 .102-.132.239.239 0 0 1 .096-.036.25.25 0 0 1 .102.004.332.332 0 0 1 .174.077.327.327 0 0 1 .1.162.512.512 0 0 1 .019.135.58.58 0 0 1 0 .059l1.017 30.844.522.096-1.194-31.015a.594.594 0 0 1 .048-.212.307.307 0 0 1 .104-.135.272.272 0 0 1 .094-.037.349.349 0 0 1 .29.099c.04.042.069.092.085.148a.613.613 0 0 1 .021.194l1.382 31.113.426.081-1.399-30.975c0-.022 0-.045.007-.068a.6.6 0 0 1 .04-.145.295.295 0 0 1 .103-.133.255.255 0 0 1 .094-.036.26.26 0 0 1 .1.005.32.32 0 0 1 .274.239.462.462 0 0 1 .019.134.29.29 0 0 1 0 .059l1.592 31.07.399.076-1.794-31.806a5.335 5.335 0 0 0-.521-.179 7.399 7.399 0 0 0-1.302-.262 5.527 5.527 0 0 0-1.693.06 3.804 3.804 0 0 0-1.693.795c0 .494-.011 1.195-.013 2.06s0 1.893 0 3.04 0 2.412.006 3.751.008 2.752.014 4.194l-.9-16.368a5.525 5.525 0 0 0-.548-.187 7.993 7.993 0 0 0-1.37-.275 5.846 5.846 0 0 0-1.776.064 3.97 3.97 0 0 0-1.771.829c-.01.761-.016 1.994-.017 3.549v5.486c0 2.053.011 4.279.021 6.532l.026 6.688-1.431-25.989a8.12 8.12 0 0 0-1.993-.482 6.025 6.025 0 0 0-1.847.066 4.128 4.128 0 0 0-1.844.863 572.617 572.617 0 0 0-.013 6.335c.004 2.865.014 6.305.028 9.811.014 3.505.031 7.072.047 10.187l.039 7.47.494.092-.292-33.152a.611.611 0 0 1 .054-.232.333.333 0 0 1 .114-.146.27.27 0 0 1 .103-.04.26.26 0 0 1 .111.003.379.379 0 0 1 .205.103.39.39 0 0 1 .09.16.623.623 0 0 1 .022.148.707.707 0 0 1 .003.065Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1426.43 100.596H1440V185H0v-84.342h13.58l.026-.686-.405-.108a3.802 3.802 0 0 0-.654-.11c-.338 0-.687-.206-.623-.36.022-.075-.064-.143-.229-.15a.607.607 0 0 1-.59-.71.675.675 0 0 0-.142-.5.761.761 0 0 1-.03-.853c.074-.14.074-.206 0-.206-.155 0-.144-.392 0-.492.074-.032.096-.24.074-.458-.03-.222 0-.448.087-.654.083-.207.138-.424.165-.645.006-.17.047-.336.12-.49.135-.459.14-.946.011-1.407-.079-.018-.023-.142.131-.319a.986.986 0 0 0 .26-.413c0-.086.036-.153.078-.153s.098-.242.11-.535c.004-.256.048-.51.13-.754a.383.383 0 0 0 .031-.337 2.905 2.905 0 0 1 .187-1.69c.173-.24.184-.392.12-1.093a2.039 2.039 0 0 1 .064-1.1c.106-.3.147-.62.12-.939-.01-.36.012-1.1.045-1.625.033-.525.097-1.506.142-2.162.001-.427.052-.851.151-1.266.088-.411.118-.833.09-1.254a11.42 11.42 0 0 1 .12-1.767c.063-.408.1-.82.108-1.233.002-.382.042-.762.12-1.136.08-.495.134-.994.162-1.495.078-1.505.153-2.073.307-2.246.1-.138.173-.293.218-.457.097-.406.424-.395.511.03.034.176.131.319.218.319.22 0 .296.276.35 1.175.025.396.077.79.153 1.18.058.218.092.442.1.668 0 .161.047.292.1.292.131 0 .21.654.11.927a.687.687 0 0 0 .066.535c.075.165.12.34.064.383-.008.444.06.887.2 1.31.076.352.126.71.151 1.07.078.675.185 1.123.285 1.123.044 0 .056.097.022.218-.034.12 0 .207.075.207.098 0 .098.043.023.142-.12.154-.045.722.11.722.052 0 .052.063 0 .175a.343.343 0 0 0 .01.38c.097.159.086.226-.034.3-.12.076-.133.13-.033.23.09.075.11.288.067.588-.045.339-.023.47.075.47s.12.15.078.608a4.34 4.34 0 0 0 .02 1.07c.045.24.045.47 0 .48-.025.366.058.73.24 1.049.068.092.11.201.12.316.037.153.12.29.24.394.196.142.196.153-.033.36-.285.264-.294.425-.185 1.964.064.926.183 1.351.383 1.351.051 0 .01.091-.1.2-.176.174-.209.339-.187.95.001.299.042.596.12.883.08.25.12.512.12.774-.012.287.058.571.2.82a1.738 1.738 0 0 1 0 1.486c-.12.233-.14.392-.053.534.1.424.04.87-.165 1.254a3.26 3.26 0 0 0-.26.686c-.142.568-.393.973-.6.973-.078 0-.154.033-.154.075 0 .198-.634.514-1.112.556l-.536.056.006.52h6.812a6.295 6.295 0 0 0-.008-.366c-.023-.35-.056-.395-.383-.459a1.94 1.94 0 0 1-1.277-1.505 1.964 1.964 0 0 0-.176-.635c-.098-.108-.109-.316-.109-1.08 0-.12-.03-.511-.064-.883-.056-.448-.033-.719.053-.819.108-.243.16-.507.154-.773.007-.21.03-.418.067-.624a4.834 4.834 0 0 0-.01-1.471.368.368 0 0 1 0-.373c.1-.455.157-.92.172-1.386l.003-.043c.064-1.085.07-1.169-.146-1.343-.218-.175-.218-.186-.03-.317.299-.475.436-1.033.39-1.593-.013-.942.054-1.884.2-2.816a.1.1 0 0 0-.045-.142c-.076-.034-.076-.22.011-.6.06-.236.078-.48.053-.722a.192.192 0 0 1 .045-.218.109.109 0 0 0 .069-.11.11.11 0 0 0-.013-.043.767.767 0 0 1 .042-.416 4.72 4.72 0 0 0 .12-.948c0-.242.03-.484.087-.72.053-.14.083-.287.09-.436.011-.176.052-.514.086-.743a2.9 2.9 0 0 0 .045-.916A6.83 6.83 0 0 1 21.238 77c.096-.475.154-.956.176-1.44 0-.644.098-1.06.218-.982.045.03.121-.09.154-.262.098-.428.304-.316.458.24.183.724.281 1.467.293 2.215.026.469.11 1.623.186 2.637l.014.198c.078 1.057.142 2.138.131 2.4-.021.22.002.442.067.653a29.68 29.68 0 0 1 .2 3.984c-.042.404-.005.811.11 1.2.097.11.108.404.066.97-.062.346-.04.701.064 1.037.102.335.154.684.154 1.036a4.54 4.54 0 0 0 .327 2.172c.142.24.184.403.12.47-.062.407-.037.824.075 1.22.436 2.663.371 3.865-.229 4.443-.338.316-1.112.545-1.112.327 0-.053-.056-.065-.12-.023-.1.38-.125.774-.072 1.162h4.845c.078-.129.183-.24.308-.325.23-.151.274-.252.274-.733 0-.555 0-.566-.405-.686a.953.953 0 0 1-.556-.392c-.075-.143-.184-.263-.218-.263-.067 0-.165-.305-.436-1.453-.142-.608-.187-1.33-.078-1.33.047 0 .022-.165-.053-.349-.158-.382-.158-.48.042-1.745.06-.317.08-.64.056-.962-.033-.087-.01-.154.042-.154a6.414 6.414 0 0 0-.019-1.93.447.447 0 0 1 .053-.326c.106-.418.154-.847.143-1.278.034-.963.011-1.263-.12-1.463-.086-.129-.12-.24-.064-.24.161 0 .26-.436.128-.567-.162-.174-.13-.309.045-.23l.011.005c.165.075.166.076.207-1.27.011-.544-.019-.939-.075-.939-.056 0-.068-.053-.023-.13.136-.207.158-.37.2-1.581.023-.612.068-1.213.09-1.333a.314.314 0 0 0-.078-.293c-.087-.056-.087-.099 0-.166.127-.076.227-.654.327-1.8.017-.273.057-.592.082-.802l.018-.148c.015-.133.038-.496.063-.895l.024-.392c.025-.536.08-1.07.162-1.6.056-.353.112-.733.112-.853a4.78 4.78 0 0 1 .271-1.94.64.64 0 0 0 .165-.373c0-.12.053-.206.12-.172.26.084.413.933.522 2.9.056 1.123.132 2.465.165 3 .033.534.066 1.285.075 1.678.01.394.053.686.11.656.055-.029.066.058.01.2-.087.253-.087.313 0 1.113.056.439.143 2.523.23 5.358-.003.628.045 1.256.142 1.877.078.417.114.84.11 1.265.01.559.033 1.16.055 1.333.037.304.117.6.237.882.058.297.073.6.045.9-.029.265.001.533.087.785a.176.176 0 0 1 .056.219c-.025.223-.008.448.053.665a5.21 5.21 0 0 1 .1 2.282c-.11 0-.11.023-.01.087.086.043.097.129.03.228a1.2 1.2 0 0 0-.109.5c0 .413-.086.677-.24.677-.053 0-.196.123-.316.273-.12.151-.243.252-.274.219-.03-.034-.138-.011-.238.042-.142.08-.209.067-.25-.02-.023-.078-.057.218-.057.642-.01.612.023.775.143.775.097 0 .142.056.086.176a.228.228 0 0 0 .1.263.2.2 0 0 1 .11.133H33.5l20.16 17.462.06-7.483.263-3.258-.129-1.3-.39-1.044s.39-.112.39-.463a4.14 4.14 0 0 0-.135-.844s.135-.677.135-.852c0-.175.518-.715.518-.715s-.3-.3-.126-.518c.131-.31.2-.644.2-.981l1.952-.008v1.37h.589v1.243h4.11l.326.518h.39c.035-.195.06-.391.072-.589v-1.044c.195-.008.389-.029.58-.063.215-.041.464-.065.464-.065v-.781h1.3v.781h4.762v.455h.972l.2-.518c.227-.172.467-.327.718-.463.175-.016.35-.016.526 0 0 0-.216 1.115 0 1.115h4.626v1.761h1.244v.326h.263l-.065.389-.715.2v17.769h3.719v-14.249l-.4-.389-.192-.389 1.107-.654.263-.979s.1-.326.326-.326h6.65v1.7h1.44l-.788.781v14.421h2.285v.084h7.28l13.526 3.526c.017-.343.096-.682.233-1.001.173-.24.184-.392.12-1.092a2.047 2.047 0 0 1 .064-1.1c.107-.301.147-.621.12-.939-.011-.361.012-1.101.045-1.626.033-.525.097-1.506.142-2.162.001-.426.052-.851.151-1.265.088-.412.118-.834.089-1.254-.005-.592.035-1.183.12-1.768.065-.408.101-.82.109-1.232.002-.382.042-.763.12-1.137.08-.495.135-.994.162-1.494.078-1.506.153-2.073.307-2.246.099-.139.173-.294.218-.458.097-.405.424-.394.511.031.034.176.131.318.218.318.22 0 .296.276.349 1.176.027.395.078.789.154 1.179.058.218.092.442.1.668 0 .162.047.293.1.293.131 0 .209.653.109.927a.7.7 0 0 0 .067.534c.075.165.12.341.064.383-.008.444.06.888.2 1.31.076.352.126.71.151 1.07.078.676.185 1.123.285 1.123.044 0 .056.097.022.218s0 .207.075.207c.098 0 .098.043.023.143-.12.154-.045.721.109.721.053 0 .053.064 0 .176a.348.348 0 0 0 .011.38c.097.158.086.225-.034.3-.12.075-.133.129-.033.229.089.075.109.289.067.589-.045.338-.023.469.075.469s.12.151.078.609c-.037.356-.03.715.02 1.07.045.24.045.469 0 .48-.025.365.059.73.24 1.048.068.092.11.201.12.316a.757.757 0 0 0 .24.394c.196.142.196.153-.033.36-.285.264-.294.425-.185 1.964.064.927.183 1.352.383 1.352.044 0 .02.066-.056.153l2.394.624c.1-.455.158-.918.172-1.384l.003-.044c.065-1.085.07-1.169-.146-1.342-.218-.176-.218-.187-.031-.318.3-.475.437-1.033.391-1.592-.013-.943.054-1.885.2-2.816a.101.101 0 0 0 .01-.082.091.091 0 0 0-.021-.037.092.092 0 0 0-.034-.024c-.076-.033-.076-.22.011-.6.061-.236.079-.48.053-.721a.196.196 0 0 1-.012-.117.19.19 0 0 1 .057-.101.103.103 0 0 0 .038-.026.1.1 0 0 0 .025-.039.131.131 0 0 0 .006-.027V119.336a.094.094 0 0 0-.013-.044.777.777 0 0 1 .042-.416c.072-.311.112-.628.12-.947 0-.243.03-.485.087-.721.053-.14.083-.287.089-.436.012-.176.053-.514.087-.743.064-.301.079-.611.045-.916.018-.389.068-.776.151-1.156.096-.476.155-.957.176-1.441 0-.643.098-1.059.218-.981.045.03.121-.09.154-.263.098-.428.304-.316.458.24a9.67 9.67 0 0 1 .293 2.215c.026.469.111 1.625.186 2.639l.014.196c.078 1.057.142 2.138.131 2.4-.021.22.002.442.067.654.156 1.322.223 2.653.2 3.984a3.12 3.12 0 0 0 .109 1.2c.098.109.109.403.067.97-.062.345-.04.7.064 1.036.103.335.155.685.154 1.036a4.562 4.562 0 0 0 .247 1.966l2.431.748.034-.219c.061-.317.079-.64.056-.961-.033-.087-.011-.154.042-.154a6.404 6.404 0 0 0-.019-1.93.45.45 0 0 1 .053-.327c.106-.418.154-.847.143-1.277.034-.964.011-1.264-.12-1.464-.086-.128-.12-.24-.064-.24.161 0 .259-.436.128-.567-.162-.173-.131-.308.045-.229l.011.005c.165.074.166.075.207-1.27.011-.545-.019-.939-.075-.939-.056 0-.068-.053-.023-.131.136-.207.158-.369.2-1.581.023-.612.068-1.213.09-1.333a.31.31 0 0 0-.078-.293c-.087-.056-.087-.098 0-.165.127-.076.227-.655.327-1.8.018-.274.057-.592.083-.803l.017-.147c.016-.133.038-.497.063-.896l.001-.021.023-.371c.025-.536.079-1.07.162-1.6.056-.352.112-.732.112-.852a4.798 4.798 0 0 1 .271-1.941.642.642 0 0 0 .165-.372c0-.12.053-.207.12-.173.259.084.413.933.522 2.9.056 1.123.132 2.466.165 3 .033.534.066 1.286.075 1.679.009.393.053.685.109.656.056-.029.067.058.011.2-.087.252-.087.312 0 1.112.056.439.143 2.523.229 5.358a11.92 11.92 0 0 0 .143 1.877c.078.417.115.84.109 1.265.011.559.034 1.16.056 1.333.037.304.117.601.237.883.058.296.073.599.045.9-.028.264.001.532.087.785a.173.173 0 0 1 .056.218c-.025.223-.007.449.053.665.04.146.073.294.1.443l47.981 14.775 1.163.011v-.694h-.342v-1.132l.934.008v-1.821l1.273.01v-10.422l5.537.031v10.437l1.277.011v1.821l.939.008v1.131h-.339v.7l1.233.011v.55l.984.013v3.17l28.541 8.101.085-.006c.29-.018.61-.039.907-.039.25-.007.501.016.743.069.134.033.272.05.412.049.258-.01.514-.042.762-.099a7.836 7.836 0 0 1 1.569-.161c.6 0 1.081.024 1.428.04l.098.005c.171.008.31.014.424.014.1 0 .347 0 .423-.098a1.42 1.42 0 0 1 .484-.222 1.64 1.64 0 0 1 .555-.043l.123.003.034.001.039.002.143.01c.438.041.51.168.582.302a.382.382 0 0 0 .159.185.536.536 0 0 0 .264.077c.058.006.117.009.175.009.18-.005.36-.02.537-.047a5.788 5.788 0 0 1 1.503-.034c.394.042.714.056.975.066.558.025.649.038.649.171a.57.57 0 0 0 .112.306c.081.129.071.137-.038.162-.391.086-.317 1.019-.238 1.568 0 .032.059.056.123.056h8.474c4.16 0 6.359.347 6.359 1.004 0 .294.379.379.725.403l.12.001a6.406 6.406 0 0 0 1.57-.137c.66-.183 6.041-.781 7.553-.885a16.45 16.45 0 0 0 1.601-.183 8.496 8.496 0 0 1 1.415-.125c.456.005.905.101 1.315.282a2.5 2.5 0 0 0 .933.22c.152 0 .31.012.477.024l.03.002.057.004c.181.013.365.025.574.025a4.082 4.082 0 0 0 1.506-.28c.643-.245.691-.328.654-.475-.015-.066-.034-.149.188-.344.094-.084.181-.176.258-.275.185-.232.224-.28 2.09-.458l.331-.032v-.253h1.818v-.473h57.635v.473h1.818v.473h1.301v.928h.027l.022.001.078.002.122.003h.3l.091-.001.053-.001a2.66 2.66 0 0 1 .127-.003h.4l.246.003.074.001h.048l.054.001h.079c.681 0 .995-.048 1.078-.169a9.98 9.98 0 0 0 .01-2.102l-.003-.009a.038.038 0 0 0-.008-.017.06.06 0 0 0-.023-.019.582.582 0 0 1-.108-.08h1.661l.143-.001c.068-.001.145-.003.23-.008.177-.008.379-.014.571-.014a1.62 1.62 0 0 1 .653.072 3.915 3.915 0 0 0 1.585.178c.189 0 .425-.017.678-.036l.062-.004c.29-.022.61-.045.906-.045.251-.008.502.018.744.078.133.038.272.057.411.056.259-.011.514-.048.763-.112a6.832 6.832 0 0 1 1.569-.183c.6 0 1.081.026 1.428.045l.098.005c.171.009.309.016.423.016.1 0 .348 0 .424-.111.14-.115.305-.201.484-.252.179-.052.368-.069.555-.049a4.402 4.402 0 0 1 .339.019c.438.046.509.19.581.342a.42.42 0 0 0 .16.211.49.49 0 0 0 .264.087l.06.006.023.001c.019.002.038.002.058.003h.034c.18-.005.359-.023.536-.053.293-.048.589-.073.886-.076.207 0 .413.013.618.037.394.048.713.064.975.076.558.028.649.043.649.194a.718.718 0 0 0 .111.348c.081.145.071.155-.037.183-.391.098-.317 1.158-.238 1.782 0 .037.059.064.123.064h8.474c3.935 0 6.116.353 6.339 1.023.483.008.965-.039 1.436-.14.659-.183 6.04-.781 7.552-.885a16.477 16.477 0 0 0 1.602-.183c.467-.081.94-.123 1.415-.125a3.35 3.35 0 0 1 1.314.282c.291.132.609.207.933.22.153 0 .31.012.477.024l.031.002c.2.014.4.029.63.029a4.084 4.084 0 0 0 1.507-.28c.642-.245.691-.328.654-.475-.015-.066-.034-.149.187-.344a2.03 2.03 0 0 0 .258-.275c.186-.232.225-.28 2.09-.458l.331-.032v-.253h1.818v-.473h57.635v.473h1.819v.473h1.301v.928h.03l.028.001.069.002.121.003h.3a6.293 6.293 0 0 0 .272-.005h.4l.246.003h.003l.251.002c.682 0 .995-.048 1.078-.169a9.913 9.913 0 0 0 .01-2.102.054.054 0 0 0-.011-.026.052.052 0 0 0-.01-.011l-.004-.003-.003-.002-.002-.002-.004-.001a.656.656 0 0 1-.108-.08h1.753l.076-.001c.062-.001.131-.004.205-.008a4.778 4.778 0 0 1 .249-.009c.107-.003.216-.005.323-.005.22-.021.443.004.652.072a3.915 3.915 0 0 0 1.585.178c.189 0 .425-.017.679-.036l.062-.004c.29-.022.609-.045.906-.045.251-.008.501.018.744.078.133.038.272.057.411.056.258-.011.514-.048.763-.112a6.823 6.823 0 0 1 1.568-.183c.601 0 1.081.026 1.428.045l.098.005c.171.009.31.016.424.016.1 0 .347 0 .423-.111.14-.115.305-.201.484-.252.179-.052.369-.069.555-.049.113.001.227.007.339.019.439.046.51.19.582.342a.42.42 0 0 0 .16.211.489.489 0 0 0 .263.087c.058.007.117.01.176.01.18-.005.359-.023.536-.053.292-.048.589-.073.886-.076.206 0 .412.013.617.037.395.048.714.064.975.076.559.028.65.043.65.194a.698.698 0 0 0 .111.348c.081.145.071.155-.037.183-.392.098-.318 1.158-.239 1.782 0 .037.06.064.124.064h8.473c4.16 0 6.359.394 6.359 1.141 0 .469.745.469 1.101.469.135 0 .278 0 .43-.008.151-.007.315-.007.476-.007h.004a2.29 2.29 0 0 1 .899.06c.291.079.56.215.789.398.307.349.167.982.017 1.649-.285 1.264-.6 2.696 1.697 3.132a7.829 7.829 0 0 1 2.801 1.185c.332.226.642.477.927.749h29.749l-.002-6.729 4.288.508 1.473-.566 4.172 2.632h14.402l6.231-3.579s14.273.849 21.264 0c4.752-.577 7.743-1.879 9.171-2.654v-.649c0-2.556.428-3.599.794-3.717.208-.066.311-.264.408-.456.131-.255.256-.498.604-.498.363.008.724.041 1.081.099.289.048.583.076.877.085.025 0 2.509-.059 2.673-.557a.775.775 0 0 1 .266-.343.943.943 0 0 1 .431-.173l.088.003.09.003c.134.006.319.013.521.013.437.024.875-.038 1.281-.18 2.024-.5 4.082-.889 6.162-1.163a9.421 9.421 0 0 0 1.307-.238c.373-.105.762-.16 1.154-.163.395.014.773.144 1.072.368.213.164.479.266.761.29.139.004.277.015.414.034.171.023.342.035.515.038a2.259 2.259 0 0 0 1.229-.369c.524-.321.564-.431.534-.624a.525.525 0 0 1 .024-.239.592.592 0 0 1 .128-.213c.081-.116.151-.236.211-.361.151-.305.183-.369 1.705-.604l.27-.043v-.333h1.483V149h.688l21.024.135h.688v.623h1.483v.621h1.062v1.22a2.326 2.326 0 0 0 .378.005l.069-.002.093-.003.058-.003.034-.001h.037l.215.003.046.001.065.002.186.004c.074.002.148.003.223.003.556 0 .811-.064.879-.222v-.428l-.009-.25-.008-.244a.094.094 0 0 0-.006-.028l-.006-.013a.055.055 0 0 0-.007-.009l-.003-.004-.006-.006a.545.545 0 0 1-.088-.105L675 146l52.426.969 4.575-1.969H737l-.5-4.5 53.51 8.099 37.175.14h.685v.673h1.479v.36l.269.046c.886.149 1.312.012 1.544-.063.165-.053.231-.074.294.063.06.136.13.266.21.392a.64.64 0 0 1 .152.488c-.03.209.01.328.533.676.352.254.782.394 1.225.399.172-.003.343-.017.513-.042l.114-.015.066-.007a3.64 3.64 0 0 1 .233-.014c.281-.027.547-.136.759-.314a1.818 1.818 0 0 1 1.069-.399c.391.004.779.064 1.151.178a8.7 8.7 0 0 0 1.303.256c2.074.297 4.126.717 6.144 1.258.405.154.842.221 1.277.195.202 0 .386-.008.521-.014l.027-.001.033-.001.029-.001h.003l.048-.002.019-.001h.017a.91.91 0 0 1 .431.187.839.839 0 0 1 .265.372c.163.538 2.64.601 2.665.601.293-.009.586-.04.875-.091a7.185 7.185 0 0 1 1.077-.108c.348 0 .472.263.602.538v.002c.097.207.2.421.408.493.364.127.791 1.255.791 4.021v3.576l.003.021v.003l.001.004a.069.069 0 0 0 .003.008l.004.007.002.004.002.003h5.297v.422h1.482v.42h1.06v.826c.035 0 .069.002.103.003l.099.003h.245l.117-.002.044-.002.06-.001h.326l.2.003.207.002c.556 0 .811-.043.879-.151a9.656 9.656 0 0 0 .008-1.87l-.001-.005-.001-.003-.003-.008-.002-.004-.002-.004-.007-.008-.006-.005-.002-.001-.004-.003a.464.464 0 0 1-.088-.071h1.354c.081 0 .182 0 .303-.008a11.707 11.707 0 0 1 .465-.012c.18-.019.362.003.532.064.413.149.855.203 1.292.158.153 0 .346-.015.553-.032l.05-.004c.236-.019.496-.04.738-.04.204-.006.408.017.606.07.108.034.221.05.335.049.21-.009.419-.042.621-.099a5.153 5.153 0 0 1 1.278-.163c.489 0 .881.024 1.164.041l.079.004c.14.008.252.014.345.014.082 0 .283 0 .345-.099a1.078 1.078 0 0 1 .847-.267c.092 0 .184.006.276.016.357.041.415.169.474.305a.374.374 0 0 0 .345.265c.047.006.095.009.142.009.147-.005.293-.021.437-.048a3.85 3.85 0 0 1 1.225-.034c.321.043.582.057.794.067.455.025.529.038.529.173a.68.68 0 0 0 .091.31c.066.129.058.138-.03.163-.319.087-.259 1.031-.194 1.586 0 .032.048.057.1.057h6.903c3.389 0 5.18.351 5.18 1.015 0 .418.608.417.897.417.11 0 .227 0 .351-.006.123-.007.256-.007.387-.007h.003a1.715 1.715 0 0 1 1.376.408c.25.311.136.874.014 1.468-.138.666.371.628 1.197.566.57-.042 1.29-.095 2.054.063.375.086 1.712-.516 3.124-1.151 1.698-.764 3.505-1.577 3.876-1.3.611 1.112 4.234-.359 7.059-1.505 1.802-.732 3.279-1.331 3.441-1.044v6.5h9.271a7.132 7.132 0 0 1 1.403-1.199 8 8 0 0 1 2.801-1.137c2.298-.419 1.982-1.794 1.697-3.007-.15-.641-.29-1.248.017-1.583.229-.176.498-.307.789-.383.292-.075.599-.095.899-.057H932.018l.107.001c.079.001.157.002.232.006.081.004.16.005.237.006l.193.001c.356 0 1.101 0 1.101-.45 0-.717 2.199-1.095 6.359-1.095h8.473c.065 0 .123-.027.123-.062.079-.599.154-1.616-.238-1.71-.108-.028-.118-.036-.037-.176a.652.652 0 0 0 .111-.335c0-.145.091-.159.65-.186.261-.011.581-.026.975-.072a5.306 5.306 0 0 1 1.503.037c.177.029.357.046.537.051.043 0 .086-.002.129-.005l.026-.003.02-.002a.5.5 0 0 0 .263-.083.41.41 0 0 0 .16-.203c.072-.146.143-.284.582-.329a5.371 5.371 0 0 1 .339-.017c.186-.019.376-.003.555.046.179.05.344.133.484.242.076.108.323.108.423.108.135 0 .304-.01.522-.021.347-.018.828-.044 1.428-.044.529.001 1.056.06 1.568.176.249.062.505.098.763.108.139.001.278-.018.411-.054.243-.057.493-.082.744-.075.297 0 .616.023.906.043l.062.005c.254.017.49.034.678.034a4.06 4.06 0 0 0 1.586-.171c.209-.065.432-.089.652-.069.193 0 .395.006.572.013a5.19 5.19 0 0 0 .372.009h1.662a.552.552 0 0 1-.108.076.071.071 0 0 0-.023.019.022.022 0 0 0-.005.008l-.002.004a.033.033 0 0 0-.004.013 9.138 9.138 0 0 0 .01 2.018c.083.116.396.163 1.078.163l.128-.001.244-.004.128-.001h.4c.044 0 .085.002.128.003l.114.003h.351l.016-.001h.024l.06-.002c.042-.002.084-.004.127-.004v-.89h1.301v-.454h1.819v-.455h57.633v.455h1.82v.243l.33.03c1.87.171 1.91.217 2.09.44.08.095.16.183.26.264.22.187.2.266.19.33-.04.141.01.221.65.456.48.179.99.271 1.51.269.13 0 .25-.005.36-.011l.09-.005.18-.012.03-.002c.16-.012.32-.023.48-.023.32-.013.64-.085.93-.211.41-.174.86-.266 1.31-.27.48.001.95.041 1.42.119.41.062.87.129 1.6.176 1.13.075 4.45.417 6.31.657.77-.431 2.81-.655 6.02-.655h8.47c.04 0 .08-.011.1-.028.01-.009.02-.021.02-.034.08-.599.16-1.616-.24-1.71-.1-.028-.11-.036-.03-.176a.68.68 0 0 0 .11-.335c0-.145.09-.159.65-.186.26-.011.58-.026.97-.072a5.37 5.37 0 0 1 1.51.037c.17.029.35.046.53.051.06 0 .12-.003.18-.01a.489.489 0 0 0 .26-.083.4.4 0 0 0 .16-.203c.07-.146.14-.284.58-.329.08-.007.16-.012.23-.015l.03-.001h.03l.05-.001c.19-.019.38-.003.56.046.18.05.34.133.48.242.08.108.32.108.42.108.12 0 .26-.007.43-.016l.1-.005c.34-.018.82-.044 1.42-.044.53.001 1.06.06 1.57.176.25.062.51.098.77.108.13.001.27-.018.41-.054.24-.057.49-.082.74-.075.3 0 .62.023.91.043l.06.005.32.021c.13.008.25.013.36.013a4.03 4.03 0 0 0 1.58-.171c.21-.065.43-.089.65-.069.2 0 .4.006.58.013.14.009.27.009.37.009h1.66c-.01.011-.02.022-.04.032a.167.167 0 0 1-.05.033l-.01.005-.01.006v.004c-.01.003-.01.006-.02.009v.006c-.01.008-.01.016-.01.025-.07.672-.07 1.347.01 2.018.08.116.39.163 1.08.163l.25-.003.08-.001.17-.002H1085.12l.04.001h.01l.1.003.1.002h.3l.12-.003c.04-.002.08-.004.13-.004v-.89h1.3v-.454h1.82v-.455h57.63v.455h1.82v.243l.33.03c1.87.171 1.91.217 2.09.44.08.095.16.183.26.264.22.187.2.266.19.33-.04.141.01.221.65.456.48.179.99.271 1.51.269.21 0 .39-.012.57-.024l.06-.004.03-.002a9.657 9.657 0 0 1 .47-.023c.33-.013.65-.085.94-.211.41-.174.86-.266 1.31-.27.48.001.95.041 1.42.119.41.062.87.129 1.6.176 1.51.099 6.89.674 7.55.85.52.105 1.04.149 1.57.131l.12-.001.16-.003.21-.004.08-.002H1169.9c.16.003.33.039.47.104.15.065.28.158.38.272.2.364 3.25.407 3.28.407.33 0 .69-.029 1.07-.062.43-.036.88-.072 1.33-.072.11-.004.22.011.32.044.02-.01.05-.02.08-.03l.08-.026.07-.018c.29-.075.6-.095.9-.057.16 0 .33 0 .48.007.15.007.29.007.43.007.35 0 1.1 0 1.1-.45 0-.717 2.2-1.095 6.36-1.095h8.47c.06 0 .12-.027.12-.062.08-.599.16-1.616-.24-1.71-.1-.028-.11-.036-.03-.176a.68.68 0 0 0 .11-.335c0-.145.09-.159.65-.186l.1-.005.07-.003.12-.006.27-.018c.13-.01.26-.023.41-.04a5.688 5.688 0 0 1 .62-.036c.3.003.59.027.89.073.17.029.35.046.53.051l.05-.001.03-.001.03-.002.03-.002.02-.002.02-.002a.489.489 0 0 0 .26-.083.4.4 0 0 0 .16-.203c.07-.146.14-.284.58-.329.12-.011.23-.016.34-.017.19-.019.38-.003.56.046.18.05.34.133.48.242.08.108.32.108.42.108h.02l.06-.001.05-.001.04-.002.26-.012.1-.005c.34-.018.82-.044 1.42-.044.53.001 1.06.06 1.57.176.25.062.51.098.77.108.13.001.27-.018.41-.054.24-.057.49-.082.74-.075.3 0 .62.023.91.043l.06.005.38.025.1.005c.07.002.14.004.2.004a4.03 4.03 0 0 0 1.58-.171c.21-.065.43-.089.65-.069l.23.002.35.011c.14.009.27.009.37.009h1.66c-.02.014-.03.028-.05.04a.273.273 0 0 1-.06.036c0 .002-.01.005-.01.007 0 .004-.01.008-.01.012 0 .003 0 .006-.01.009v.016c-.07.672-.07 1.347.01 2.018v.007l.01.01c.01.01.02.019.04.028.01.01.03.02.06.03l2.69-.764v-.045h.16l1.14-.324v-.13h.46l32.52-9.233v-2.976l.99-.013v-.55l1.23-.011v-.7h-.34v-1.131l.94-.008v-1.823l1.28-.01v-10.435l5.54-.032v10.422l1.27-.01v1.82l.93-.008v1.132h-.34v.694l.44-.004 47.78-14.713c.03-.172.07-.342.11-.51.07-.216.08-.442.06-.665a.164.164 0 0 1-.01-.119c0-.017.01-.032.01-.046.02-.021.03-.039.05-.053.09-.252.12-.52.09-.785-.03-.301-.01-.604.05-.9.12-.282.2-.579.23-.883.02-.173.05-.774.06-1.333-.01-.425.03-.848.11-1.265.09-.621.14-1.249.14-1.877.09-2.835.17-4.919.23-5.358.09-.8.09-.86 0-1.112-.06-.142-.05-.229.01-.2.06.029.1-.263.11-.656.01-.393.04-1.145.07-1.679.04-.534.11-1.877.17-3 .11-1.967.26-2.816.52-2.9.07-.034.12.053.12.173.01.138.07.269.17.372.22.621.31 1.282.27 1.941 0 .12.05.5.11.852.08.53.14 1.064.16 1.6l.04.632.01.197c.02.21.03.377.04.459 0 .038.01.088.02.146v.007c.01.121.03.276.05.438l.03.359c.1 1.145.2 1.724.33 1.8.08.067.08.109 0 .165a.262.262 0 0 0-.08.136v.013l-.01.015V117.736a.2.2 0 0 0 .01.076c.02.12.06.721.09 1.333.04 1.212.06 1.374.2 1.581.04.078.03.131-.03.131-.05 0-.08.394-.07.939.04 1.345.04 1.344.21 1.27l.01-.005c.17-.079.2.056.04.229-.13.131-.03.567.13.567.06 0 .02.112-.06.24-.13.2-.16.5-.12 1.464-.01.43.03.859.14 1.277.06.098.08.215.05.327a6.57 6.57 0 0 0-.02 1.93c.06 0 .08.067.05.154-.03.321-.01.644.05.961l.02.114.03.165 2.39-.737c.25-.649.34-1.346.27-2.037 0-.351.06-.701.16-1.036.1-.335.12-.691.06-1.036-.04-.567-.03-.861.07-.97.11-.389.15-.797.11-1.2a27.92 27.92 0 0 1 .2-3.984c.06-.212.09-.434.06-.654-.01-.262.06-1.343.14-2.4l.01-.186v-.061c.08-1.002.16-2.127.19-2.588.01-.747.11-1.491.29-2.215.15-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.981.02.484.08.966.17 1.441.09.38.14.767.16 1.156-.04.305-.02.615.04.916.03.229.08.567.09.743 0 .149.03.296.09.436.05.236.08.478.08.721.01.319.05.636.12.947.06.132.07.276.05.416-.01.013-.02.028-.02.044v.023c0 .007.01.015.01.022 0 .015.01.028.02.039s.03.02.04.026c.03.027.05.062.06.101.01.04 0 .08-.01.117-.03.241-.01.485.05.721.09.38.09.567.01.6-.01.003-.02.008-.02.014-.01.003-.01.007-.01.01l-.01.006v.007c-.01.003-.01.006-.01.009v.015c-.01.004-.01.007-.01.011v.031c0 .007 0 .014.01.021 0 .006 0 .013.01.019.14.931.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.18.131.18.142-.03.318-.22.173-.21.258-.15 1.343v.043c.02.466.08.93.18 1.386.01.017.01.036.02.055l2.42-.63-.01-.004c-.11-.109-.15-.2-.1-.2.2 0 .32-.425.39-1.352.1-1.539.1-1.7-.19-1.964-.23-.207-.23-.218-.03-.36a.77.77 0 0 0 .24-.394.605.605 0 0 1 .12-.316c.18-.318.26-.683.24-1.048-.05-.011-.05-.24 0-.48.05-.355.05-.714.02-1.07-.04-.458-.02-.609.08-.609.09 0 .12-.131.07-.469-.04-.3-.02-.514.07-.589.1-.1.08-.154-.04-.229-.12-.075-.13-.142-.03-.3l.03-.047a.341.341 0 0 0 .03-.142.265.265 0 0 0-.05-.191c-.05-.112-.05-.176 0-.176.16 0 .23-.567.11-.721-.07-.1-.07-.143.02-.143.08 0 .11-.086.08-.207-.01-.04-.02-.077-.02-.108 0-.046 0-.081.02-.098v-.004c0-.003.01-.004.01-.005 0-.002.01-.003.01-.003.1 0 .21-.447.29-1.123.02-.36.07-.718.15-1.07.14-.422.2-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.169.09-.26a.84.84 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.07-.39.12-.783.15-1.179.05-.9.13-1.176.35-1.176.09 0 .18-.142.22-.318.08-.425.41-.436.51-.031.04.164.12.319.22.458.15.173.23.74.3 2.246.03.5.09.999.17 1.494.07.374.11.755.12 1.137 0 .412.04.824.1 1.232.09.585.13 1.176.12 1.768-.02.42.01.842.09 1.254.1.414.15.839.15 1.265.05.656.11 1.637.15 2.162.03.525.05 1.265.04 1.626-.03.318.02.638.12.939.12.354.15.734.07 1.1-.07.7-.06.852.12 1.092a3 3 0 0 1 .23 1.064l13.52-3.524h7.27v-.149h2.29v-14.421l-.79-.781h1.45v-1.7h6.64c.23 0 .33.326.33.326l.26.979 1.11.654-.19.389-.4.389v14.314h3.72v-17.834l-.72-.2-.06-.389h.26v-.326h1.24v-1.761h4.63c.22 0 0-1.115 0-1.115.18-.016.35-.016.53 0 .25.136.49.291.71.463l.21.518h.97v-.455h4.76v-.781h1.3v.781s.25.024.46.065c.19.034.39.055.58.063v1.044c.02.198.04.394.07.589h.39l.33-.518h4.11v-1.243h.59v-1.37l1.95.008c0 .337.07.671.2.981.17.218-.13.518-.13.518s.52.54.52.715c0 .175.14.852.14.852-.08.276-.12.559-.14.844 0 .351.39.463.39.463l-.39 1.044-.13 1.3.26 3.258.07 7.552 20.16-17.466h4.34c.01-.095.05-.167.12-.2a.22.22 0 0 0 .1-.115c.01-.047.02-.1 0-.148-.05-.12-.01-.176.09-.176.12 0 .15-.162.14-.774 0-.425-.03-.721-.06-.643-.04.087-.1.1-.25.02-.1-.053-.2-.075-.23-.042-.04.033-.16-.067-.28-.218-.12-.151-.26-.274-.31-.274-.16 0-.24-.263-.24-.676 0-.173-.04-.343-.11-.5-.07-.1-.06-.185.03-.23.1-.063.1-.086-.01-.086a5.03 5.03 0 0 1 .1-2.282c.06-.216.08-.442.05-.665a.164.164 0 0 1-.01-.12c.01-.04.03-.074.07-.098.08-.252.11-.52.08-.785-.03-.301-.01-.604.05-.9.12-.282.2-.58.23-.883.03-.173.05-.774.06-1.333 0-.425.03-.848.11-1.265.1-.621.14-1.249.14-1.877.09-2.835.18-4.92.23-5.358.09-.8.09-.86 0-1.112-.05-.142-.04-.23.01-.2.06.029.1-.263.11-.656.01-.393.04-1.145.08-1.68.03-.533.11-1.876.16-3 .11-1.966.26-2.815.52-2.9.07-.033.12.054.12.174.02.138.07.269.17.372.22.621.31 1.282.27 1.94 0 .12.06.5.11.853.08.53.14 1.064.16 1.6l.03.396v.044c.02.38.05.72.06.848l.01.054.01.092c.02.21.06.53.08.804.1 1.145.2 1.724.33 1.8.08.067.08.109 0 .165a.263.263 0 0 0-.08.136.412.412 0 0 0 0 .157c.02.12.07.72.09 1.333.04 1.212.06 1.374.2 1.58.04.079.03.132-.02.132-.06 0-.09.394-.08.939.04 1.345.04 1.344.21 1.27l.01-.005c.18-.08.21.056.04.229-.13.13-.03.567.13.567.06 0 .02.112-.06.24-.13.2-.16.5-.12 1.464-.01.43.04.86.14 1.277.06.098.08.215.05.327-.1.638-.11 1.289-.01 1.93.05 0 .07.067.04.154-.03.321-.01.644.05.96.2 1.267.2 1.364.05 1.747-.08.184-.1.349-.06.349.11 0 .07.72-.08 1.33-.27 1.148-.36 1.453-.43 1.453-.04 0-.14.12-.22.263a.95.95 0 0 1-.56.39c-.4.12-.4.132-.4.688 0 .48.04.581.27.732.15.099.27.234.35.392h4.8v-.028c.06-.401.04-.81-.07-1.2-.06-.042-.12-.031-.12.022 0 .218-.77-.011-1.11-.327-.6-.578-.66-1.78-.23-4.442.12-.397.14-.814.08-1.221-.07-.067-.02-.23.12-.47.28-.686.4-1.432.33-2.172 0-.351.05-.7.15-1.036.1-.335.13-.69.06-1.036-.04-.567-.03-.861.07-.97.11-.39.15-.797.11-1.2-.02-1.331.04-2.662.2-3.984.07-.212.09-.434.07-.654-.01-.262.05-1.343.13-2.4l.01-.186.01-.06c.07-1.003.15-2.128.18-2.59.01-.746.11-1.49.29-2.214.15-.556.36-.668.46-.24.03.173.11.293.15.263.12-.078.22.338.22.98.02.485.08.966.18 1.442.08.38.13.767.15 1.156-.04.305-.02.615.04.916.04.229.08.567.09.743.01.149.04.296.09.436.06.236.09.478.09.72 0 .32.04.637.12.948a.84.84 0 0 1 .04.416c-.01.013-.01.028-.02.044 0 .015.01.03.01.045.01.015.01.028.03.039.01.011.02.02.03.026.03.027.05.062.06.101.01.04 0 .08-.01.117-.03.241-.01.485.05.72.09.38.09.568.01.6a.14.14 0 0 0-.03.025c-.01.011-.02.023-.02.037-.01.013-.01.028-.01.042.01.014.01.027.02.04.14.93.21 1.873.2 2.816-.05.559.09 1.118.39 1.592.19.13.19.142-.03.318-.22.173-.21.258-.15 1.343v.043c.02.466.08.93.18 1.386.03.056.05.12.05.186v.033c-.01.03-.01.058-.02.085l-.03.068c-.08.487-.08.983-.01 1.472.03.205.06.414.06.623 0 .266.05.53.16.774.08.1.11.37.05.818-.03.372-.06.763-.06.883 0 .765-.01.972-.11 1.08-.1.2-.16.415-.18.635-.06.342-.21.662-.43.927-.23.265-.52.465-.85.579-.32.064-.36.109-.38.458-.01.144-.01.288-.01.433h6.81l.01-.587-.53-.056c-.48-.042-1.12-.358-1.12-.556 0-.042-.07-.075-.15-.075-.21 0-.46-.405-.6-.972a3.362 3.362 0 0 0-.26-.687 1.82 1.82 0 0 1-.17-1.254c.09-.142.07-.3-.05-.534a1.739 1.739 0 0 1-.17-.743c0-.257.06-.511.17-.743.14-.249.21-.533.2-.82 0-.262.04-.523.12-.773.08-.288.12-.585.12-.883.02-.612-.01-.777-.19-.95-.1-.11-.15-.2-.1-.2.2 0 .32-.425.39-1.352.11-1.54.1-1.7-.19-1.964-.23-.207-.23-.218-.03-.36.12-.103.2-.241.24-.394a.609.609 0 0 1 .12-.316c.18-.318.26-.683.24-1.048-.05-.011-.05-.24 0-.48.05-.355.06-.714.02-1.07-.04-.458-.02-.61.08-.61s.12-.13.07-.468c-.04-.3-.02-.514.07-.59.1-.1.09-.153-.03-.228-.12-.075-.13-.142-.04-.3a.315.315 0 0 0 .05-.087c.01-.033.01-.067.02-.102a.334.334 0 0 0-.06-.191c-.05-.112-.05-.176 0-.176.16 0 .23-.567.11-.721-.07-.1-.07-.143.03-.143.07 0 .1-.086.07-.207s-.02-.218.02-.218c.1 0 .21-.447.29-1.123.02-.36.07-.718.15-1.07.14-.422.21-.865.2-1.31-.06-.042-.01-.218.06-.383.05-.08.08-.169.09-.26a.634.634 0 0 0-.02-.274c-.1-.274-.02-.927.11-.927.05 0 .1-.131.1-.293.01-.226.04-.45.1-.668.07-.39.13-.784.15-1.18.06-.9.13-1.175.35-1.175.09 0 .19-.142.22-.318.09-.425.41-.436.51-.031.05.164.12.319.22.458.15.173.23.74.31 2.246.02.5.08.999.16 1.494.08.374.12.754.12 1.137.01.412.04.824.11 1.232.08.585.12 1.176.12 1.768-.03.42 0 .842.09 1.254.1.414.15.838.15 1.265.04.656.11 1.637.14 2.162.03.525.05 1.265.04 1.626-.02.318.02.638.12.939.13.353.15.734.07 1.1-.07.7-.06.852.12 1.092.23.532.29 1.12.18 1.69-.02.055-.02.114-.02.172.01.059.02.115.06.166.08.243.12.497.13.754.01.293.06.534.11.534.04 0 .07.067.07.154.05.157.14.299.26.413.16.176.21.3.13.318-.12.46-.12.948.02 1.408.07.153.11.32.12.489.02.22.08.438.16.645.09.206.12.432.09.654-.02.218 0 .427.07.458.15.1.16.492 0 .492-.07 0-.07.067 0 .207.08.129.12.279.12.43a.798.798 0 0 1-.15.422c-.05.07-.09.15-.12.236a.365.365 0 0 0-.02.102.44.44 0 0 0 0 .162c.01.086.01.175-.01.26a.66.66 0 0 1-.12.231.656.656 0 0 1-.33.204.452.452 0 0 1-.07.01.504.504 0 0 1-.06.005c-.17.008-.25.075-.23.15.06.155-.28.36-.62.36-.22.018-.44.054-.66.11l-.4.109.03.752ZM189.726 150.118v-2.184l-.001 2.183.001.001ZM58.882 122.643h1.17c-.001-.273-.004-.548-.007-.808-.008-.785-.015-1.44.008-1.542.079-.3.463-12.725.463-12.725l-.263-1.044-.263-.518.063-.716h-3.13v15.657l1.959 1.696Zm1322.308-.127 1.88-1.629v-15.724h-3.13l.07.716-.27.518-.26 1.044s.39 12.425.46 12.725c.03.102.02.754.01 1.538v.007c0 .259 0 .533-.01.805h1.25Zm-6.93-17.161h1.57v17.161h-2.61v-15.267l.19-.652.14-.589.13-.518.58-.135Zm-7.11.263h1.5v16.9h-1.7v-15.014l.2-.907.46-.463-.46-.516Zm-13.24 2.412h3.19v.652c.19.461.32.943.39 1.435-.05.222 0 12.725 0 12.725h-4.23c-.23-.391 0-12.988 0-12.988l.2-.781-.2-.392.13-.524.52-.127ZM64.163 105.482h1.57l.59.135.126.518.137.589.189.652v15.267h-2.612v-17.161Zm7.18.263h1.5l-.454.516.455.463.2.907v15.014h-1.7v-16.9Zm11.549 2.412h3.195l.523.127.127.524-.2.392.2.781s.224 12.597 0 12.988H82.5s.055-12.503 0-12.725c.072-.492.204-.974.39-1.435v-.652Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1262.43 128.996v-.174a2.47 2.47 0 0 0-.24-.882 2.508 2.508 0 0 0-1.24-1.221c-.27-.126-.57-.2-.87-.218v-.36h-.31v-.43h.28v-.46h-.22l.05-.126.04-.11.03-.081.01-.037a.396.396 0 0 0 .02-.107c.01-.058.02-.134.03-.21l.01-.087c.01-.045.01-.088.02-.125v-.051c0-.032.01-.054.01-.065 0-.016-.01-.094-.03-.211l-.02-.147c-.01-.086-.02-.18-.04-.273l-.05-.408-.03-.185-.07-.342-.39-1.856c-.02-.045-.03-.089-.05-.132l-.04-.1-.06-.154-.09-.247-.05-.111-.1-1.036.16.138.01.022.01.056.02.056c0 .008 0 .017.01.026v.013l.01.05.02.08.02.075.01.033v.177c0 .015 0 .03.01.045l.03.061.02.054.01.023.04.008.09.017a.554.554 0 0 0 .26.007l.01-.004V119.967l.01-.046.05-.11.02-.049c.01-.019.01-.038.02-.057l.02-.028v-.005c.02-.042.04-.083.05-.114.01-.013.02-.026.02-.036.01-.01.02-.019.03-.026.02-.01.04-.013.05-.01.01.001.01.002.02.005.01.002.01.006.02.01l.01.011v-.028c0-.022.01-.044.01-.065l.03-.077c.02-.024.03-.045.05-.062a.306.306 0 0 0 .07-.053c.02-.02.03-.04.05-.062l.03-.031c0-.01.01-.021.02-.031a.112.112 0 0 0 .02-.053v-.043c0-.004-.01-.007-.01-.01v-.004l-.01-.008c0-.009-.01-.017-.01-.025a1.2 1.2 0 0 0-.03-.037c-.02-.024-.04-.048-.05-.068-.01-.009-.02-.019-.02-.029-.01-.007-.01-.013-.01-.02 0-.013.01-.025.02-.034a.212.212 0 0 1 .03-.03l.03-.021v-.007l.34-.207v-.503c0-.021-.01-.042-.01-.062 0-.026 0-.051-.01-.075 0-.016-.01-.033-.01-.049 0-.009-.01-.018-.01-.026v-.025c-.01-.014-.01-.027-.02-.038v-.017c0-.014-.01-.028-.01-.042v-.3c0-.014 0-.028-.01-.041l-.03-.04c0-.016-.01-.033-.01-.049v-.015l-.01-.015c0-.014 0-.028-.01-.041 0-.013-.01-.027-.01-.041l-.02-.05-.04-.094c-.01-.03-.02-.059-.03-.084-.01-.012-.01-.025-.02-.037 0-.014-.01-.028-.02-.042l-.02-.037c0-.016-.01-.031-.02-.046l-.04-.079-.04-.07-.06-.125-.1-.2-.09-.187-.05-.083-.33-.874c.17.253.34.494.5.712.16.205.33.399.51.579.15.152.32.28.51.381.16.086.34.127.52.12.42-.1.58-.52.57-1.108a6.515 6.515 0 0 0-.48-2.087 9.467 9.467 0 0 0-1.1-2.07 2.414 2.414 0 0 0-1.28-1.058.694.694 0 0 0-.45.111.752.752 0 0 0-.26.32 1.2 1.2 0 0 0-.11.414c-.02.13-.01.261 0 .391l-.03.026-.08.059a.743.743 0 0 0-.08.065c-.01.011-.03.026-.04.043 0 .008 0 .016.01.024v.015c.01.01.01.02.02.03l.01.014v.012l.04.051.01.025-.21-.031-.01-.01-.03-.024-.03-.03c0-.008-.01-.018-.02-.027 0-.011-.01-.021-.03-.028 0-.006-.01-.012-.02-.018l-.01-.006-.01-.006-.05-.02-.02-.01-.03-.026-.06-.064c-.03-.022-.05-.045-.07-.064-.01-.011-.03-.023-.04-.036 0-.011-.01-.023-.01-.035v-.03c0-.007 0-.014-.01-.021v-.389a.07.07 0 0 0 .01-.043c0-.011.01-.022.01-.031.01-.009.01-.017.02-.024l.01-.012c.01-.005.01-.01.02-.015l.1-.07a.498.498 0 0 0 .03-.019l.03-.021c0-.005.01-.009.01-.015.01-.005.01-.011.01-.017v-.005l.01-.003v-.002l-.01-.005v-.043c.01-.009.01-.018.01-.027 0-.014 0-.028.01-.041v-.046c0-.015.01-.03.01-.044.01-.008.01-.015.02-.023v-.221c0-.003 0-.006-.01-.009v-.049a.04.04 0 0 1 0-.047v-.056c0-.023-.01-.045-.01-.066v-.033c0-.011 0-.022-.01-.032l-.01-.047v-.023c-.01-.006-.01-.012-.01-.018-.01-.015-.02-.029-.02-.043l-.03-.045c0-.015-.01-.03-.01-.045-.01-.015-.01-.03-.02-.043l-.01-.042-.01-.036-.02-.038-.01-.015c0-.01-.01-.02-.01-.03l-.04-.054c0-.007 0-.014-.01-.02-.01-.013-.01-.027-.02-.04l-.03-.063c0-.018-.01-.035-.01-.053-.01-.008-.01-.015-.01-.023V109.547c0-.018-.01-.035-.02-.051-.01-.023-.02-.05-.03-.079l-.05-.083-.03-.064c0-.008-.01-.014-.01-.017l-.01-.005c-.01 0-.01.001-.02.003v.005l-.01.003c0 .007-.01.014-.02.023v.012l-.23.131-.02-.1.01-.044c.01-.027.01-.063.02-.1.01-.037.01-.079.02-.113 0-.026.01-.053.01-.079 0-.006 0-.012-.01-.016v-.006l-.01-.003a.093.093 0 0 0-.04.006c-.01.004-.02.01-.04.017l-.02.01-.12-.022.01-.016c.01-.015.01-.029.02-.042l.01-.024c0-.011.01-.023.01-.035.01-.023.01-.046.02-.069V108.735v.004l.03-.164.17.008.02-.011.03-.017.04-.026a.161.161 0 0 0 .03-.029v-.02c.01-.006.01-.013.01-.02v-.052c.01-.009.01-.018.01-.028v-.035c0-.012.01-.024.01-.036v-.206c0-.034 0-.067.01-.1V107.695a.171.171 0 0 0-.02-.069c0-.015-.01-.031-.01-.046l-.01-.018h-.14l-.31.007-.12-.08-.2-.1-.2.016-.21.145-.2.407-.13.515-.01.776-.2.246-.13.261.15.184v.784l.14.23.21.138v.015c-.01.008-.01.016-.01.024 0 .014-.01.032-.01.051v.042l-.03.107c0 .029-.02.056-.03.083l-.03.072c0 .029-.01.058-.01.088V111.658a.07.07 0 0 0 0 .063v.323c0 .026-.01.052-.02.077a.285.285 0 0 1-.04.08.417.417 0 0 1-.03.063l-.02.025-.16.169-.07.042-.16.1-.18.108-.01.005c-.05.031-.09.057-.11.071l-.04.029-.06.045-.12.1-.1.091-.04.039-.18.737-.06.338-.05.215-.29.569-.57.493-.53.692-.76.755-.28.061h-.42l-.17.09-1.7-3.408.08-.131v-.123c0-.014-.01-.023-.01-.023h-.14l-.02.006c0 .002-.01.002-.02 0 0-.002-.01-.004-.01-.007 0-.004 0-.007-.01-.011 0-.018-.01-.035-.01-.051-.01-.017-.01-.035-.02-.052v-.022l-.02-.067-.01-.029.02-.178-1.19-1.756.67 2.046.15.039.08.092.03.077-.03.116v.093l.1.062.08.007h.02l1.77 3.568-.18.054-.02.169.05.215.15.215.18.077.1.277h.17l.05-.02 1.82 3.669v.065l.04.066c.02.04.05.093.08.147.04.054.07.111.1.156.03.034.05.065.08.091.02.013.04.033.04.056.01.027.02.055.02.084v.263l.01.024v.035l.01.027v.073c.01.023.01.046 0 .07 0 .046.01.092.01.138.01.041.01.089.02.14v.107c.01.042.01.085.01.126l.01.121c.01.07.01.122.01.137 0 .011 0 .022-.01.032 0 .016-.01.032-.02.047-.01.022-.03.047-.04.072l-.03.042-.08.1-.03.044.15.276.49.158v.639h-.48v.461h.29v.431h-.31v.361a2.55 2.55 0 0 0-1.6.734c-.44.432-.7 1.003-.76 1.614v.673l.01.031.01.03v.031l.01.033v.032l.01.032.01.033v.032c.06.24.16.47.29.682.13.211.29.403.47.571.18.167.39.309.61.421.22.112.45.19.7.232h.87l1.05-.007 2.05-.008.45-.006 1.44-.008.2.003.05-.004c.06-.001.11-.004.16-.008l.04-.003c.49-.047.95-.238 1.34-.55.43-.35.74-.828.88-1.365v-.027l.02-.043.01-.041v-.041l.01-.042v-.544c.04-.008.04-.015.04-.022Zm-8.41-9.053-.02.1-.04.234-.01.114-.03.132-.01.065c0 .037-.01.063-.01.074a.349.349 0 0 0-.03.084l-.05.124-.04.112-.02.049-.02.35-1.62-3.251.05-.049.06-.05.05-.047.05-.039c.02-.02.05-.042.07-.064l.08-.082.06-.07.03-.03.3-.186 1.07-.677-.04.063-.09.124-.04.066c-.02.024-.03.047-.05.068-.02.029-.03.06-.05.093-.01.028-.01.057-.02.087v.267c.01.041.01.081.02.122.01.034.02.068.04.1s.03.064.05.094c.02.023.04.043.05.059v.009l.03.026.18.23-.01.042-.01.014c0 .018-.01.041-.02.065-.01.017-.01.035-.02.053 0 .015-.01.031-.01.047-.01.027-.01.056-.02.085.01.036.01.072.02.108.01.046.02.1.04.148.01.048.02.1.03.131l.02.057.06.354-.08.595ZM178.48 129.125c0 .007.042.014.042.021v.544l.008.042.016.082.018.044v.027a2.617 2.617 0 0 0 .88 1.364c.385.312.852.503 1.343.55h-.023l.061.003c.042.003.083.006.125.007l.085.005.22-.003 1.284.007.58.008 2.055.008 1.049.013h.873c.244-.042.48-.12.7-.232a2.678 2.678 0 0 0 1.37-1.674v-.032l.007-.033.007-.032.006-.032.006-.033.006-.031.006-.03.006-.031.005-.031v-.649a2.62 2.62 0 0 0-.76-1.614 2.509 2.509 0 0 0-1.606-.733v-.361h-.31v-.431h.293v-.461h-.482v-.639l.489-.158.151-.276-.033-.044a2.97 2.97 0 0 1-.105-.149l-.04-.065a.229.229 0 0 1-.033-.079c0-.015.004-.067.01-.137l.007-.079.014-.168.008-.103c.004-.052.008-.102.013-.144.009-.07.009-.123.009-.138l-.001-.028.001-.042.011-.1.005-.036c.003-.023.006-.044.006-.064v-.135a1.262 1.262 0 0 1 0-.087.339.339 0 0 1 .017-.084.106.106 0 0 1 .041-.056.38.38 0 0 0 .079-.091 4.914 4.914 0 0 0 .186-.304l.036-.066v-.065l1.824-3.669.049.02h.166l.106-.277.181-.077.152-.215.045-.215-.015-.169-.189-.054 1.77-3.568h.023l.083-.007.1-.062-.007-.093-.03-.116.037-.077.076-.092.151-.039.672-2.046-1.195 1.755.014.178-.007.029-.017.067a.353.353 0 0 0-.008.031l-.012.043c-.007.023-.016.041-.016.051a.06.06 0 0 1-.003.005l-.004.005c-.002.003-.006.005-.01.007a.045.045 0 0 1-.023 0l-.02-.006h-.139c-.008 0-.015.009-.015.023a.417.417 0 0 0 0 .05v.073l.083.131-1.7 3.408-.174-.09h-.422l-.272-.061-.769-.755-.527-.692-.573-.493-.286-.569-.045-.215-.06-.338-.18-.737-.038-.039-.1-.091-.12-.1c-.033-.028-.065-.052-.086-.068l-.009-.006c-.019-.015-.063-.041-.114-.073l-.183-.111-.16-.1-.07-.042-.166-.169-.016-.025a.935.935 0 0 1-.072-.143.258.258 0 0 1-.016-.077v-.323a.25.25 0 0 1 .002-.025.125.125 0 0 0-.002-.038.354.354 0 0 1-.005-.048v-.037a.644.644 0 0 0-.013-.088l-.008-.031a.3.3 0 0 0-.018-.041.38.38 0 0 1-.031-.083 1.192 1.192 0 0 1-.03-.147c-.003-.02-.005-.038-.009-.053-.006-.024-.006-.039-.006-.039l.211-.139.136-.23v-.784l.15-.184-.135-.261-.2-.246-.008-.775-.128-.515-.2-.407-.211-.146-.2-.016-.2.1-.12.081-.309-.007h-.135l-.011.017c0 .009-.009.027-.015.047a.358.358 0 0 0-.011.035l-.008.034a.452.452 0 0 0 .003.09l-.002.052c0 .015 0 .031.002.048a.389.389 0 0 1 .003.06c0 .02 0 .04.002.057.005.034.005.07.005.1v.142l-.001.015c0 .009-.001.02.001.029a.42.42 0 0 0 .014.062c.004.012.004.024.004.035.001.01.001.019.003.028.005.019.005.037.005.052a.142.142 0 0 0 .012.04.078.078 0 0 0 .028.029l.036.021.028.017.018.011h.007l.166-.008.034.163-.004-.004v.011a1.215 1.215 0 0 1 .005.043l.01.049.005.02.013.04a.107.107 0 0 1 .007.019c.006.018.017.032.017.042l.009.015-.121.023-.018-.01a.192.192 0 0 0-.039-.017.066.066 0 0 0-.039-.006.022.022 0 0 0-.014.008l-.004.01v.007a.642.642 0 0 0 .009.087l.018.113.015.082.003.018.01.04-.015.1-.227-.131-.007-.012a.106.106 0 0 0-.019-.023c-.003-.004-.007-.006-.011-.008a.028.028 0 0 0-.013-.003c-.008 0-.016.007-.024.022l-.033.06-.042.083a2.345 2.345 0 0 0-.043.093.156.156 0 0 0-.01.037v.027a.14.14 0 0 1 0 .029.24.24 0 0 1-.007.037c-.004.018-.01.035-.016.053a.578.578 0 0 1-.062.123l-.033.054a.254.254 0 0 0-.016.028l-.008.017-.016.038-.014.036a.114.114 0 0 1-.01.019c-.003.006-.007.011-.009.019l-.01.029a.059.059 0 0 0-.002.014.633.633 0 0 1-.04.09.437.437 0 0 0-.022.043.179.179 0 0 0-.013.041c-.007.013 0 .031-.007.051a.143.143 0 0 0-.004.022c0 .014.001.029-.003.043-.006.022-.006.045-.006.066v.056a.368.368 0 0 1 0 .047c-.002.016 0 .032-.008.049a.089.089 0 0 0-.008.035v.014l-.001.026.001.021v.079a.216.216 0 0 0 0 .036c.004.015.01.029.018.043.006.014.01.029.012.044.003.007.003.015.003.023 0 .007 0 .015.003.023.006.015.006.029.006.041a.084.084 0 0 0 .007.026.022.022 0 0 1 .005.011c0 .004 0 .008-.002.012v.015a.034.034 0 0 0 0 .02.118.118 0 0 0 .027.032l.026.021.025.019.104.07a.27.27 0 0 1 .031.028l.011.012.007.012c.005.009.009.02.011.031a.297.297 0 0 1 .006.043v.334l.001.017-.001.037-.003.021c-.002.011-.004.021-.004.03a.154.154 0 0 1-.01.035 2.224 2.224 0 0 1-.104.1l-.063.064-.029.026-.02.01-.048.022c-.016.01-.034.02-.048.03a.092.092 0 0 0-.027.025l-.002.003a.157.157 0 0 1-.02.025l-.03.03-.027.024-.012.01-.211.031.015-.02.033-.051a.558.558 0 0 0 .041-.078l.002-.017a.137.137 0 0 0-.04-.043 1.235 1.235 0 0 0-.08-.065l-.078-.059-.035-.026a1.506 1.506 0 0 0-.103-.805.768.768 0 0 0-.263-.32.707.707 0 0 0-.452-.111 2.406 2.406 0 0 0-1.277 1.053 9.258 9.258 0 0 0-1.1 2.07 6.543 6.543 0 0 0-.481 2.087c-.009.588.155 1.008.566 1.108.182.007.363-.034.523-.12a2.18 2.18 0 0 0 .513-.381c.183-.181.352-.374.506-.579.167-.218.334-.459.5-.712l-.331.874-.042.083-.094.187-.1.2-.063.125-.037.069-.041.079a3.186 3.186 0 0 0-.075.162l-.008.021-.026.063-.039.094-.009.024-.025.068a.493.493 0 0 0-.036.077.437.437 0 0 1-.012.049l-.012.035a.271.271 0 0 0-.009.041.726.726 0 0 0 0 .066v.164a.3.3 0 0 1 .001.03l-.001.04a.245.245 0 0 1-.011.059.568.568 0 0 0-.018.063 1.39 1.39 0 0 0-.017.075c-.005.025-.013.051-.013.075a.42.42 0 0 0-.005.062v.307a.43.43 0 0 1-.005.061.204.204 0 0 0 0 .035v.103l.338.207-.001.001.034.021a.138.138 0 0 1 .038.035.05.05 0 0 1 .011.029.104.104 0 0 1-.025.049l-.054.068a.59.59 0 0 0-.05.07.077.077 0 0 0-.013.057c.004.011.01.022.015.032l.012.021c.014.021.028.042.044.062a.515.515 0 0 0 .116.115.176.176 0 0 1 .05.062c.013.024.023.05.03.077l.008.031.006.034v.028a.076.076 0 0 1 .014-.011.083.083 0 0 1 .035-.015.063.063 0 0 1 .048.01.143.143 0 0 1 .052.062c.017.033.036.075.056.119.02.044.039.091.057.134l.044.11.018.046h-.005l-.001.005.001.006c.001.004.005.013.016.013a.254.254 0 0 0 .054.009.753.753 0 0 0 .201-.016l.086-.017.036-.008.012-.023.026-.054a.62.62 0 0 0 .038-.106v-.177l.008-.033.019-.075.02-.08.012-.05c.001-.008.006-.022.011-.039l.018-.056.016-.051.007-.022.157-.138-.1 1.036-.043.111-.094.247c-.03.07-.057.142-.081.203l-.019.051-.036.096a.165.165 0 0 0-.011.036l-.465 2.197-.026.185-.039.282-.018.129-.057.42a5.808 5.808 0 0 0-.026.211 1.477 1.477 0 0 0 .017.171l.019.157.015.113.013.097a.776.776 0 0 0 .02.107l.014.037.03.08.04.11.045.126h-.213v.46h.278v.43h-.308v.36a2.46 2.46 0 0 0-.876.218 2.553 2.553 0 0 0-1.237 1.221 2.629 2.629 0 0 0-.244.882v.174Zm8.431-8.953-.017-.1-.077-.596.06-.354.016-.057.025-.089.011-.042c.013-.048.026-.102.036-.148a.575.575 0 0 0 .016-.108.343.343 0 0 0-.014-.085 1.077 1.077 0 0 0-.055-.163l-.007-.016-.009-.04.18-.23.022-.026.005-.007.045-.061a1 1 0 0 0 .055-.094.471.471 0 0 0 .056-.222c.006-.045.006-.093.006-.139 0-.025-.002-.049-.003-.071a.606.606 0 0 1-.003-.057.362.362 0 0 0-.017-.087.667.667 0 0 0-.053-.094c-.025-.041-.057-.088-.088-.134l-.085-.124-.044-.063 1.07.677.3.186.027.03.065.07.079.082c.026.026.05.049.069.064l.046.039.055.047.058.05.056.049-1.621 3.251-.026-.35-.019-.049-.043-.112-.046-.124a.99.99 0 0 1-.028-.084 2.134 2.134 0 0 1-.025-.139l-.04-.246-.038-.234Z",
                        fill: "#FAFBFC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "hero-lightmode-desktop_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h1440v185H0z"
                    })
                })
            })
        ]
    });
var $f7b7ad9f885c4152$export$2e2bcd8739ae039 = $f7b7ad9f885c4152$var$SvgHeroLightmodeDesktop;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $bf00831185afccc4$var$SvgHeroLightmodeMobile = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 390 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)("g", {
                clipPath: "url(#hero-lightmode-mobile_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "M390 0H0v151h390V0Z",
                        fill: "#4D00B4"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M380.152 150.559 320.784 18.487 108.806 9 0 144.694v5.865h6.68L90.543 44.53 65.553 150.56H192.2l72.015-31.502-4.158 31.502h29.723l4.587-33.949 33.413 33.949h38.933l-64.916-66.07 19.133-39.326 49.096 105.396h10.126ZM123.653 32.449 246.428 85.38 97.862 143.736l25.791-111.287Zm48.384-11.184 125.056 5.082-21.9 40.091-103.156-45.173Z",
                        fill: "#5C16BA"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m229.029 77.572.004 1.355-21.892-10.413-.314-3.204 22.202 12.262ZM250.674 89.529l-.074.882-6.237-3.247-.11-1.223 6.421 3.588ZM211.407 66.527l-4.413-2.503.238-2.753 3.905 3.577.27 1.68ZM206.121 71.356l-62.519 11.911-.214-1.13-.19-.459.452-.283-.127-2.207 61.985-13.907.613 6.075ZM206.636 60.3l-.82 2.247.118.96-63.283 14.9-.748-.094-.36-2.656 3.697-1.542.122.852 1.683-.978.228.848-2.211 1.305 3.706-1.007 8.43-4.904 7.718-3.086-.197.961 2.339-.245-.025-1.594 3.286-.897-.188 1.811 1.804-.236.355-4.799 24.169 1.17-.021-1.494 3.405-.044.194-1.708 6.599.23ZM251.407 93.225l-43.863-21.878-.118-1.69 22.478 11.246 21.215 10.8.288 1.522ZM185.481 107.098l-43.056 4.668.523-1.343 42.533-3.325Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m206.534 107.046 46.028 8.154.121.23h.015c.075-.002.146-.004.212-.004.044 0 .085.002.129.004l.092.004.069.002a2.326 2.326 0 0 0 .377-.005h1.066v-.673h1.479v.013l8.888-.172 37.174.14h.686v.673h1.478v.36l.27.046c.885.149 1.312.012 1.543-.063.166-.053.232-.074.295.063.059.136.129.266.209.392a.631.631 0 0 1 .153.488c-.03.209.009.328.532.676.353.254.782.394 1.226.399.171-.003.343-.017.513-.042.136-.02.274-.032.412-.036.282-.027.547-.136.759-.314a1.82 1.82 0 0 1 1.069-.399c.391.004.78.064 1.152.178.426.118.862.204 1.302.256 2.074.297 4.126.717 6.144 1.258.406.154.842.221 1.278.195a11.414 11.414 0 0 0 .61-.017l.087-.003a.907.907 0 0 1 .43.187.83.83 0 0 1 .265.372c.164.538 2.641.601 2.665.601.294-.009.586-.04.875-.091a7.212 7.212 0 0 1 1.078-.108c.347 0 .471.263.601.538l.001.002c.097.207.199.421.407.493.365.127.792 1.255.792 4.021v3.576c0 .007 0 .013.002.02.002.008.004.016.008.023l.002.004.002.003h5.298v.422h1.481v.42h1.06v.826c.035 0 .07.002.104.003l.035.002.064.001h.244l.117-.002.058-.002.046-.001h.326l.201.003.125.002h.082c.555 0 .81-.043.878-.151a9.656 9.656 0 0 0 .008-1.87.05.05 0 0 0-.009-.024l-.007-.009-.011-.008a.435.435 0 0 1-.088-.071h1.353c.082 0 .183 0 .304-.008.144-.007.309-.012.465-.012.18-.019.361.003.532.064.413.149.854.203 1.291.158.154 0 .346-.015.553-.032l.05-.004c.237-.019.497-.04.739-.04.204-.006.408.017.605.07.109.034.222.05.336.049.21-.009.418-.042.621-.099a5.147 5.147 0 0 1 1.278-.163c.489 0 .88.024 1.163.041l.08.004c.139.008.252.014.345.014.082 0 .283 0 .345-.099a1.074 1.074 0 0 1 .846-.267c.093 0 .185.006.277.016.357.041.415.169.473.305a.38.38 0 0 0 .345.265c.048.006.095.009.143.009.147-.005.293-.021.437-.048a3.85 3.85 0 0 1 1.225-.034 8.8 8.8 0 0 0 .794.067c.455.025.529.038.529.173a.68.68 0 0 0 .091.31c.066.129.057.138-.031.163-.318.087-.258 1.03-.194 1.586 0 .032.048.057.101.057h6.903c3.388 0 5.18.351 5.18 1.015 0 .418.607.417.897.417.11 0 .227 0 .35-.006.123-.007.257-.007.388-.007h.003a1.717 1.717 0 0 1 1.376.408c.25.311.136.874.013 1.468-.137.666.371.628 1.197.566.57-.042 1.291-.095 2.055.063.375.086 1.711-.515 3.123-1.15 1.699-.765 3.506-1.578 3.877-1.301.611 1.112 4.234-.359 7.059-1.505 1.802-.732 3.279-1.331 3.441-1.044V151H0v-7h.004L0 129.271l4.289.508 1.472-.566 4.172 2.632h14.402l6.232-3.579s14.273.849 21.263 0c4.752-.577 7.743-1.879 9.172-2.654v-.649c0-2.556.427-3.599.793-3.717.208-.066.311-.264.408-.456.131-.255.256-.498.605-.498.362.008.724.041 1.08.099.29.048.583.076.878.085.024 0 2.508-.059 2.672-.557a.774.774 0 0 1 .266-.343.944.944 0 0 1 .432-.173l.087.003.04.001.05.002c.135.006.32.013.522.013a3.34 3.34 0 0 0 1.281-.18 56.43 56.43 0 0 1 6.162-1.163 9.4 9.4 0 0 0 1.306-.238 4.39 4.39 0 0 1 1.155-.163 1.91 1.91 0 0 1 1.072.368c.212.164.479.266.76.29.14.004.278.015.415.034.17.023.342.035.514.038a2.256 2.256 0 0 0 1.23-.369c.523-.321.563-.431.533-.624a.532.532 0 0 1 .024-.239.587.587 0 0 1 .129-.213c.08-.116.15-.236.21-.361.152-.305.184-.369 1.706-.604l.27-.043v-.333h1.483V115h.687l21.025.135h.687v.623h1.484v.621h1.062v1.22c.069.006.136.009.202.009.059 0 .117-.002.176-.004l.069-.002.092-.003.069-.003.034-.001h.026l.216.003.111.003c.132.003.271.007.408.007.556 0 .812-.064.88-.222v-.428l-.009-.25-.008-.244a.089.089 0 0 0-.028-.06.545.545 0 0 1-.088-.105c10.359-.036 17.604-.18 23.059-.331l.244-2.068 14.432-.897 28.009-2.645-40.883 2.543.086-.789 43.919-3.282 21.893-2.926.094 7.269 1.88.148-.036-1.091.123.012v-1.047l-.266-.026-.2-4.123ZM155.919 84.59l-2.635-1.413-4.568.907.047-.624 4.589-.856 2.567 1.373v.613ZM156.812 108.605l1.461-23.945h-.017c.006-.014.006-.029.006-.043a.406.406 0 0 0-.007-.105.246.246 0 0 0-.055-.114.243.243 0 0 0-.137-.075.195.195 0 0 0-.149.024.268.268 0 0 0-.087.102.552.552 0 0 0-.048.164l-1.604 24.042-.349.025a8625.91 8625.91 0 0 1 .865-12.321c.187-2.63.375-5.25.536-7.44.162-2.19.292-3.946.374-4.833a3.034 3.034 0 0 1 1.317-.594 4.126 4.126 0 0 1 1.279-.03c.329.04.653.113.968.214.13.04.258.088.383.142l-.521 24.486-.297.022.586-24.008a.366.366 0 0 0-.001-.15.245.245 0 0 0-.054-.114.246.246 0 0 0-.136-.076.198.198 0 0 0-.151.024.239.239 0 0 0-.081.101.44.44 0 0 0-.048.163l-.734 24.104-.314.021.75-24.299a.35.35 0 0 0-.001-.149.242.242 0 0 0-.054-.113.236.236 0 0 0-.135-.074.195.195 0 0 0-.15.022.252.252 0 0 0-.082.1.472.472 0 0 0-.044.164l-.904 24.392-.389.027 1.02-24.365a.407.407 0 0 0-.001-.15.242.242 0 0 0-.054-.113.227.227 0 0 0-.135-.073.192.192 0 0 0-.149.022.25.25 0 0 0-.082.102.539.539 0 0 0-.048.163l-1.176 24.461-.398.029 1.265-24.205c.005-.015.005-.03.005-.046a.412.412 0 0 0-.007-.105.25.25 0 0 0-.055-.115.244.244 0 0 0-.136-.074.19.19 0 0 0-.149.024.263.263 0 0 0-.081.102.493.493 0 0 0-.043.122c-.003.014-.007.029-.007.043l-1.401 24.299-.344.023ZM160.745 81.81l-4.711.939.033-.644 4.729-.887 2.666 1.419.014.633-2.731-1.46ZM165.261 107.993l1.247-24.8-.001.003c.003-.013.004-.027.005-.041a.432.432 0 0 0-.007-.108.244.244 0 0 0-.196-.2.2.2 0 0 0-.156.026.262.262 0 0 0-.088.106.48.48 0 0 0-.049.17l-1.387 24.894-.357.025.04-.675c.058-.999.146-2.509.253-4.307l.393-6.588.068-1.13c.163-2.728.327-5.451.471-7.734.144-2.284.263-4.112.333-5.032a3.086 3.086 0 0 1 1.352-.614c.436-.08.881-.09 1.32-.033a5.54 5.54 0 0 1 1 .221c.135.042.267.091.397.147l-.272 25.358-.305.023.341-24.862a.439.439 0 0 0-.003-.156.264.264 0 0 0-.057-.118.245.245 0 0 0-.14-.078.201.201 0 0 0-.154.025.258.258 0 0 0-.087.105.467.467 0 0 0-.048.169l-.495 24.961-.326.024.516-25.16a.27.27 0 0 0 .005-.028l.001-.02a.39.39 0 0 0-.007-.107.251.251 0 0 0-.2-.2.195.195 0 0 0-.154.024.26.26 0 0 0-.087.105.524.524 0 0 0-.046.17l-.665 25.255-.407.032.794-25.225c.005-.015.005-.031.005-.047a.494.494 0 0 0-.009-.108.251.251 0 0 0-.198-.2.208.208 0 0 0-.157.025.268.268 0 0 0-.089.105.577.577 0 0 0-.049.169l-.945 25.329-.407.027 1.041-25.068c.005-.015.005-.032.005-.047a.432.432 0 0 0-.008-.108.241.241 0 0 0-.198-.194.198.198 0 0 0-.155.025.262.262 0 0 0-.089.105.58.58 0 0 0-.048.17l-1.185 25.165-.356.025ZM190.488 78.428l-3.046-1.602-5.122 1.03.02-.71 5.146-.973 2.962 1.556.04.699ZM169.023 80.248l-4.846.97.033-.67 4.868-.91 2.764 1.468.023.653-2.842-1.511ZM174.158 107.346l1.041-25.903.005.001a.357.357 0 0 0 .013-.045.42.42 0 0 0-.01-.112.277.277 0 0 0-.059-.121.258.258 0 0 0-.146-.082.205.205 0 0 0-.159.025.27.27 0 0 0-.089.108.5.5 0 0 0-.048.176l-1.189 26.004-.37.027.1-2.055.135-2.74c.113-2.319.256-5.184.401-8.087.145-2.902.294-5.84.425-8.297.13-2.458.239-4.439.305-5.417.404-.322.88-.539 1.387-.632a4.372 4.372 0 0 1 1.359-.032c.351.045.696.122 1.033.23.138.043.275.094.408.151l-.021 26.478-.32.02.102-25.965a.459.459 0 0 0-.005-.16.258.258 0 0 0-.205-.203.207.207 0 0 0-.163.025.27.27 0 0 0-.089.108.551.551 0 0 0-.046.175l-.256 26.068-.34.026.281-26.273a.42.42 0 0 0-.005-.16.252.252 0 0 0-.207-.204.205.205 0 0 0-.163.024.267.267 0 0 0-.09.108.552.552 0 0 0-.048.175l-.433 26.377-.417.031.57-26.352a.407.407 0 0 0-.004-.158.266.266 0 0 0-.062-.12.267.267 0 0 0-.229-.085.201.201 0 0 0-.076.03.263.263 0 0 0-.089.109.5.5 0 0 0-.048.174l-.724 26.448-.423.031.816-26.184c.005-.016.005-.031.005-.048a.46.46 0 0 0-.01-.11.258.258 0 0 0-.205-.203.204.204 0 0 0-.163.026.27.27 0 0 0-.089.109.57.57 0 0 0-.046.177l-.972 26.284-.368.023ZM177.764 78.403l-4.983 1.002.028-.688 5.003-.945 2.864 1.512.032.677-2.944-1.558ZM196.879 75.065l-5.263 1.06.018-.731 5.284-1L199.98 76l.044.717-3.145-1.65ZM149.75 109.12l1.549-23.194a.329.329 0 0 0 .016-.042.421.421 0 0 0-.005-.1.248.248 0 0 0-.047-.11.214.214 0 0 0-.123-.073.171.171 0 0 0-.137.022.246.246 0 0 0-.081.098.51.51 0 0 0-.045.158l-1.675 23.279-.32.025.079-1.05c.069-.922.162-2.176.272-3.629l.014-.179c.158-2.087.345-4.561.534-7.038.195-2.548.392-5.097.56-7.225.167-2.128.304-3.835.385-4.696a2.7 2.7 0 0 1 1.202-.57 3.52 3.52 0 0 1 1.162-.03c.298.041.592.11.877.209.118.039.233.085.346.137l-.704 23.728-.272.021.759-23.267a.48.48 0 0 0 0-.144.246.246 0 0 0-.049-.11.215.215 0 0 0-.124-.07.163.163 0 0 0-.136.021.25.25 0 0 0-.081.099.463.463 0 0 0-.043.16l-.897 23.349-.29.022.917-23.537a.428.428 0 0 0 0-.146.251.251 0 0 0-.049-.11.211.211 0 0 0-.125-.073.164.164 0 0 0-.135.022.252.252 0 0 0-.081.099.51.51 0 0 0-.036.108l-.005.025-.004.025-1.048 23.628-.355.027 1.167-23.603c.001-.01.003-.02.003-.031l.001-.013a.422.422 0 0 0-.006-.1.246.246 0 0 0-.049-.11.213.213 0 0 0-.123-.073.163.163 0 0 0-.136.022.24.24 0 0 0-.082.098.567.567 0 0 0-.046.158l-1.297 23.693-.361.027 1.38-23.447.003-.02a.428.428 0 0 0-.002-.126.248.248 0 0 0-.049-.11.21.21 0 0 0-.123-.072.163.163 0 0 0-.137.022.246.246 0 0 0-.081.098.457.457 0 0 0-.036.108c-.004.016-.009.033-.009.05l-1.511 23.534-.311.026ZM186.176 106.474l.336-27.136v-.051a.479.479 0 0 0-.011-.114.293.293 0 0 0-.063-.125.27.27 0 0 0-.151-.081.21.21 0 0 0-.163.025.265.265 0 0 0-.091.112.533.533 0 0 0-.049.18l-.49 27.24-.434.033.596-26.964a.438.438 0 0 0-.006-.164.28.28 0 0 0-.063-.124.265.265 0 0 0-.152-.081.205.205 0 0 0-.163.025.265.265 0 0 0-.089.112.528.528 0 0 0-.039.122l-.005.032-.003.026-.751 27.066-.378.027.82-26.678c.005-.016.005-.033.005-.049a.4.4 0 0 0-.01-.115.27.27 0 0 0-.062-.125.267.267 0 0 0-.151-.081.215.215 0 0 0-.163.025.27.27 0 0 0-.092.11.527.527 0 0 0-.047.18l-.973 26.779-.381.031c.033-.758.104-2.595.196-4.989.077-1.997.175-4.379.276-6.845l.061-1.48c.122-2.983.249-5.997.359-8.519.11-2.522.204-4.55.262-5.557a3.197 3.197 0 0 1 1.422-.653 4.44 4.44 0 0 1 1.397-.033c.36.046.715.126 1.06.236.144.045.285.098.423.157l.233 27.267-.326.024-.147-26.745a.444.444 0 0 0-.004-.165.286.286 0 0 0-.062-.127.266.266 0 0 0-.151-.081.212.212 0 0 0-.163.028.28.28 0 0 0-.091.114.533.533 0 0 0-.047.18l-.013 26.844-.352.025.044-27.058a.412.412 0 0 0 0-.05.438.438 0 0 0-.012-.114.286.286 0 0 0-.063-.126.273.273 0 0 0-.152-.081.207.207 0 0 0-.163.026.272.272 0 0 0-.091.112.576.576 0 0 0-.046.18l-.194 27.163-.433.03ZM204.964 105.111l-.13-29.044v.004a.38.38 0 0 0 .009-.048.497.497 0 0 0-.013-.121.288.288 0 0 0-.232-.22.22.22 0 0 0-.171.027.28.28 0 0 0-.094.119.544.544 0 0 0-.048.191l-.034 29.155-.46.033.146-28.865c.005-.018.004-.035.004-.053a.445.445 0 0 0-.011-.12.295.295 0 0 0-.068-.133.29.29 0 0 0-.163-.09.217.217 0 0 0-.173.03.29.29 0 0 0-.093.12.59.59 0 0 0-.038.13c-.007.02-.007.041-.007.061l-.312 28.967-.402.031.397-28.556v-.053a.498.498 0 0 0-.014-.122.319.319 0 0 0-.069-.133.296.296 0 0 0-.163-.087.221.221 0 0 0-.172.028.288.288 0 0 0-.094.12.582.582 0 0 0-.048.19l-.555 28.668-.4.026a5348.46 5348.46 0 0 1 .548-23.13c.075-2.805.141-5.072.186-6.18a3.33 3.33 0 0 1 1.494-.692 4.71 4.71 0 0 1 1.479-.036 6.418 6.418 0 0 1 1.581.413l.678 26.684a10118.134 10118.134 0 0 1 .318-13.404c.054-2.175.109-4.251.156-6.022l.013-.46c.049-1.866.097-3.343.131-4.158a3.167 3.167 0 0 1 1.424-.66 4.489 4.489 0 0 1 1.409-.034 6.085 6.085 0 0 1 1.508.395l.714 28.359h-.334l-.607-27.804v-.05a.501.501 0 0 0-.014-.117.302.302 0 0 0-.066-.126.281.281 0 0 0-.154-.082.204.204 0 0 0-.164.026.26.26 0 0 0-.088.112.54.54 0 0 0-.038.124l-.005.028-.003.03.447 27.817-.353-.065-.429-27.942v-.05a.5.5 0 0 0-.013-.116.304.304 0 0 0-.066-.127.281.281 0 0 0-.154-.081.212.212 0 0 0-.163.026.25.25 0 0 0-.09.113.539.539 0 0 0-.037.124c-.003.019-.007.038-.007.058l.262 27.867-.437-.081-.116-27.728v-.05a.493.493 0 0 0-.013-.116.302.302 0 0 0-.066-.126.281.281 0 0 0-.154-.082.21.21 0 0 0-.164.027.255.255 0 0 0-.089.114.593.593 0 0 0-.045.182l-.029 27.651-.437-.082.147-27.256a.421.421 0 0 0-.007-.169.263.263 0 0 0-.219-.209.21.21 0 0 0-.163.026.254.254 0 0 0-.089.114.54.54 0 0 0-.042.183l-.304 27.185-.375-.07.378-26.695v-.051a.417.417 0 0 0-.014-.117.283.283 0 0 0-.067-.127.283.283 0 0 0-.156-.082.212.212 0 0 0-.163.027.265.265 0 0 0-.09.113.49.49 0 0 0-.044.16l-.003.022-.521 26.624-.376-.068v-.039h-.201l-.652-29.17v-.053a.446.446 0 0 0-.014-.12.315.315 0 0 0-.069-.133.296.296 0 0 0-.163-.086.217.217 0 0 0-.172.027.276.276 0 0 0-.093.119.544.544 0 0 0-.048.191l.473 29.088-.368-.069-.455-29.22v-.053a.49.49 0 0 0-.014-.12.292.292 0 0 0-.233-.222.222.222 0 0 0-.172.028.27.27 0 0 0-.093.12.534.534 0 0 0-.044.19l.278 29.143-.262-.049-.195.014ZM193.606 105.931l.61-27.642a.587.587 0 0 0 .012-.058.47.47 0 0 0-.012-.119.304.304 0 0 0-.066-.13.275.275 0 0 0-.155-.08.22.22 0 0 0-.169.026.277.277 0 0 0-.093.116.56.56 0 0 0-.047.186l-.769 27.751-.389.03a10186.967 10186.967 0 0 1 .422-13.525c.1-3.129.206-6.312.299-8.98.092-2.668.173-4.817.225-5.877a3.267 3.267 0 0 1 1.458-.672 4.613 4.613 0 0 1 1.44-.035c.373.048.74.13 1.099.245.148.046.295.1.438.163l.489 28.257-.341.027-.39-27.719a.44.44 0 0 0 0-.05.464.464 0 0 0-.012-.118.29.29 0 0 0-.067-.13.286.286 0 0 0-.158-.08.209.209 0 0 0-.163.026.267.267 0 0 0-.092.116.56.56 0 0 0-.048.186l.231 27.814-.355.03-.211-28.041v-.053a.476.476 0 0 0-.012-.119.303.303 0 0 0-.065-.13.279.279 0 0 0-.155-.08.215.215 0 0 0-.169.026.27.27 0 0 0-.093.114.546.546 0 0 0-.047.184l.034 28.143-.446.031.105-28.118.004-.052c0-.04-.004-.08-.013-.118a.28.28 0 0 0-.066-.13.282.282 0 0 0-.156-.082.213.213 0 0 0-.168.027.266.266 0 0 0-.092.116.612.612 0 0 0-.038.126c-.005.013-.006.026-.007.038v.022l-.269 28.226-.446.029.373-27.936a.455.455 0 0 0 0-.052.477.477 0 0 0-.012-.12.302.302 0 0 0-.065-.13.272.272 0 0 0-.157-.08.212.212 0 0 0-.163.025.264.264 0 0 0-.091.115.56.56 0 0 0-.047.186l-.533 28.05-.392.025ZM142.944 85.214l.054-.601 4.446-.826 2.469 1.325v.59l-2.532-1.36-4.437.872ZM143.767 109.553l1.771-22.561a.671.671 0 0 0-.003-.143.243.243 0 0 0-.047-.106.198.198 0 0 0-.118-.067.164.164 0 0 0-.131.022.245.245 0 0 0-.077.094.62.62 0 0 0-.036.104c-.004.017-.009.034-.009.051l-1.893 22.651-.311.02.38-4.359c.179-2.042.396-4.527.617-7.031.22-2.504.444-5.019.634-7.129.19-2.11.347-3.801.435-4.648a2.637 2.637 0 0 1 1.167-.552c.371-.071.75-.08 1.123-.028.288.04.57.107.845.202.113.038.225.083.333.133l-.947 23.075-.263.021 1.003-22.629a.395.395 0 0 0 0-.14.246.246 0 0 0-.045-.106.202.202 0 0 0-.119-.07.16.16 0 0 0-.133.02.234.234 0 0 0-.081.096.486.486 0 0 0-.045.153l-1.136 22.711-.277.022 1.15-22.895a.598.598 0 0 0 .005-.14.228.228 0 0 0-.044-.105.2.2 0 0 0-.118-.07.161.161 0 0 0-.132.023.23.23 0 0 0-.076.094.47.47 0 0 0-.042.153l-1.291 22.983-.347.024 1.404-22.955c.003-.014.004-.028.006-.043a.257.257 0 0 0-.046-.203.2.2 0 0 0-.118-.069.16.16 0 0 0-.132.02.24.24 0 0 0-.082.095.482.482 0 0 0-.042.13l-.004.023-1.529 23.043-.349.024 1.601-22.805a.394.394 0 0 0 .002-.14.256.256 0 0 0-.046-.105.197.197 0 0 0-.117-.07.165.165 0 0 0-.133.02.231.231 0 0 0-.078.094.62.62 0 0 0-.036.103c-.004.017-.009.033-.009.05l-1.729 22.894-.305.021ZM200.383 73.74l5.426-1.032 3.159 1.65.052.742-3.248-1.701-5.399 1.095.01-.755ZM225.935 82.811l-2.942-1.449-2.032.434.872-.796 1.183-.236 2.854 1.403.065.644ZM234.695 88.29l.739-.692 1.019-.203 2.51 1.219.07.557-2.58-1.254-1.758.372ZM230.764 85.2l-2.831-1.39-1.955.412.832-.766 1.141-.224 2.751 1.349.062.619ZM230.482 86.38l.794-.733 1.078-.212 2.626 1.287.056.59-2.691-1.326-1.863.394ZM238.541 90.131l.701-.652.972-.194 2.381 1.156.062.532-2.446-1.194-1.67.352ZM242.566 91.086l.909-.183 2.235 1.085.066.496-2.302-1.116-1.56.331.652-.613Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        d: "m245.481 94.491 1.593 18.415-.317-.058-1.489-18.14a.323.323 0 0 0-.016-.116.205.205 0 0 0-.169-.141.137.137 0 0 0-.113.018.161.161 0 0 0-.055.082.288.288 0 0 0-.018.081l-.001.02.001.02.835 10.939-1.076-11.363c.276-.12.571-.19.872-.207a3.84 3.84 0 0 1 .815.037c.205.031.407.076.606.133.149.048.237.082.237.082l2.165 19.037-.239-.045-2.053-18.611a.326.326 0 0 0-.017-.117.213.213 0 0 0-.167-.142.144.144 0 0 0-.114.02.162.162 0 0 0-.057.081.382.382 0 0 0-.019.126l1.935 18.55-.252-.047-1.933-18.634a.283.283 0 0 0-.014-.117.208.208 0 0 0-.168-.141.148.148 0 0 0-.115.02.156.156 0 0 0-.056.081.333.333 0 0 0-.021.125l1.812 18.576-.31-.059-1.703-18.473a.285.285 0 0 0-.017-.117.205.205 0 0 0-.167-.142.144.144 0 0 0-.114.02.163.163 0 0 0-.058.08.39.39 0 0 0-.023.127ZM220.469 80.441l-2.982-1.55-2.844.583.994-.85 1.87-.354 2.9 1.5.062.671ZM245.384 93.043l.501-.57.442-.09 2.214 1.054.082.489-2.283-1.088-.956.205ZM234.039 90.335l.599 16.864-.122-2.556a7535.347 7535.347 0 0 1-.545-11.607c-.075-1.676-.129-2.895-.129-3.165a2.518 2.518 0 0 1 1.135-.537 3.746 3.746 0 0 1 1.141-.041 5.124 5.124 0 0 1 1.241.3l1.593 21.798-.275-.051-1.487-21.308v-.039a.402.402 0 0 0-.014-.092.227.227 0 0 0-.185-.163.162.162 0 0 0-.132.02.206.206 0 0 0-.069.091.425.425 0 0 0-.029.145l1.35 21.243-.285-.056-1.346-21.334a.354.354 0 0 0-.015-.131.256.256 0 0 0-.059-.1.245.245 0 0 0-.129-.065.18.18 0 0 0-.133.023.198.198 0 0 0-.068.091.452.452 0 0 0-.03.146l1.214 21.264-.354-.067-1.091-21.15.001-.013-.001-.026a.316.316 0 0 0-.016-.091.227.227 0 0 0-.19-.163.167.167 0 0 0-.13.021.204.204 0 0 0-.068.09.42.42 0 0 0-.03.146l.964 21.083-.354-.067-.868-20.764v-.04a.361.361 0 0 0-.015-.092.23.23 0 0 0-.187-.163.174.174 0 0 0-.132.023.201.201 0 0 0-.068.09.365.365 0 0 0-.026.096.348.348 0 0 0 0 .046l.744 20.703-.307-.056-.665-20.308a.36.36 0 0 0-.015-.132.23.23 0 0 0-.19-.163.165.165 0 0 0-.13.023.204.204 0 0 0-.068.09.412.412 0 0 0-.025.098l-.001.025a.14.14 0 0 1 .001.02ZM214.554 77.477l-3.094-1.62-2.322.472.864-.847 1.488-.28 3.017 1.57.047.705ZM241.935 93.256l.897 18.427-.208-2.36-.473-6.464-.419-9.304a.32.32 0 0 0-.014-.117.213.213 0 0 0-.169-.145h-.052l-.02.006-.02.007-.027-.363c.292-.175.619-.286.958-.326.308-.037.619-.035.927.007a4.669 4.669 0 0 1 .977.239l1.705 19.844-.245-.046-1.603-19.406a.376.376 0 0 0-.015-.117.212.212 0 0 0-.053-.09.21.21 0 0 0-.115-.056.146.146 0 0 0-.115.02.176.176 0 0 0-.059.08.372.372 0 0 0-.018.124l1.479 19.343-.257-.046-1.474-19.428a.376.376 0 0 0-.015-.118.212.212 0 0 0-.053-.088.212.212 0 0 0-.115-.058.154.154 0 0 0-.119.02.172.172 0 0 0-.059.082.355.355 0 0 0-.024.129l1.354 19.368-.322-.059-1.242-19.263V93.062a.375.375 0 0 0-.015-.081.235.235 0 0 0-.053-.089.217.217 0 0 0-.115-.057.15.15 0 0 0-.117.02.176.176 0 0 0-.061.081.374.374 0 0 0-.022.087.278.278 0 0 0 0 .041l1.129 19.204-.317-.058-1.037-18.922v-.036a.322.322 0 0 0-.014-.081.201.201 0 0 0-.168-.144.15.15 0 0 0-.116.02.176.176 0 0 0-.061.08.4.4 0 0 0-.025.129ZM251.745 95.421l-2.245-1.06-.933.193.478-.554.427-.081 2.187 1.032.086.47ZM215.155 106.957l-.082-25.042a.349.349 0 0 0-.001-.046.379.379 0 0 0-.014-.111.265.265 0 0 0-.212-.202.203.203 0 0 0-.158.025.238.238 0 0 0-.081.108.481.481 0 0 0-.041.173l-.062 24.976-.36-.066.008-1.484.024-4.052.007-1.036c.013-2.079.027-4.377.044-6.647.019-2.654.04-5.266.061-7.442.021-2.177.043-3.914.064-4.811.39-.32.855-.537 1.351-.628a4.314 4.314 0 0 1 1.347-.033c.35.045.696.121 1.034.228.14.043.277.093.412.15l1.136 26.777-.318-.059-1.028-26.184v-.048a.416.416 0 0 0-.015-.111.296.296 0 0 0-.065-.122.275.275 0 0 0-.149-.081.194.194 0 0 0-.154.025.24.24 0 0 0-.082.108.488.488 0 0 0-.04.173l.869 26.126-.337-.063-.857-26.234v-.048a.415.415 0 0 0-.015-.11.291.291 0 0 0-.065-.121.275.275 0 0 0-.23-.086.198.198 0 0 0-.075.03.247.247 0 0 0-.082.107.486.486 0 0 0-.039.173l.699 26.164-.418-.082-.559-26.028v-.048a.41.41 0 0 0-.015-.11.278.278 0 0 0-.065-.12.267.267 0 0 0-.147-.081.198.198 0 0 0-.157.023.238.238 0 0 0-.081.108.552.552 0 0 0-.04.174l.408 25.962-.419-.082-.301-25.58v-.048a.414.414 0 0 0-.013-.111.292.292 0 0 0-.063-.122.272.272 0 0 0-.149-.081.195.195 0 0 0-.156.025.241.241 0 0 0-.082.108.488.488 0 0 0-.041.174l.163 25.509-.359-.066ZM239.235 111.365l.003.079.003.003-.006-.082ZM238.538 91.793l.697 19.572-.514-7.047-.393-12.2a.371.371 0 0 0-.016-.126.222.222 0 0 0-.056-.094.226.226 0 0 0-.187-.062.165.165 0 0 0-.06.024.198.198 0 0 0-.065.086.377.377 0 0 0-.024.094.325.325 0 0 0 0 .044l.081 2.304-.202-2.79c.31-.241.674-.403 1.061-.471.35-.061.707-.07 1.06-.027.275.03.548.085.815.163.203.06.326.11.326.11l1.51 20.693-.26-.052-1.407-20.221a.36.36 0 0 0-.014-.124.216.216 0 0 0-.176-.156.167.167 0 0 0-.127.021.197.197 0 0 0-.065.087.38.38 0 0 0-.024.094.323.323 0 0 0 0 .044l1.273 20.161-.275-.053-1.271-20.246v-.038a.317.317 0 0 0-.015-.086.219.219 0 0 0-.179-.155.164.164 0 0 0-.127.022.192.192 0 0 0-.065.081.374.374 0 0 0-.025.094v.043l1.148 20.185-.337-.063-1.03-20.074a.324.324 0 0 0-.015-.126.214.214 0 0 0-.18-.154.159.159 0 0 0-.124.02.182.182 0 0 0-.064.082.434.434 0 0 0-.029.138l.911 20.009-.334-.062-.816-19.708a.367.367 0 0 0-.013-.126.216.216 0 0 0-.179-.156.164.164 0 0 0-.126.022.196.196 0 0 0-.064.086.433.433 0 0 0-.024.094.325.325 0 0 0 0 .044ZM252.83 113.975l-.234-.044-2.362-17.781a.187.187 0 0 0 0-.034.335.335 0 0 0-.018-.077.222.222 0 0 0-.054-.081.218.218 0 0 0-.112-.054.14.14 0 0 0-.111.017.149.149 0 0 0-.053.076.284.284 0 0 0-.016.12l2.244 17.725-.25-.047-2.247-17.797.001-.014-.001-.02a.287.287 0 0 0-.018-.082.229.229 0 0 0-.055-.082.21.21 0 0 0-.168-.056.139.139 0 0 0-.053.02.158.158 0 0 0-.055.077.364.364 0 0 0-.019.123l2.129 17.746-.301-.057-2.02-17.646a.285.285 0 0 0-.018-.116.215.215 0 0 0-.168-.135.139.139 0 0 0-.111.018.158.158 0 0 0-.053.076.285.285 0 0 0-.016.12l1.906 17.592-.3-.058-1.809-17.32.001-.014-.001-.019a.289.289 0 0 0-.017-.077.222.222 0 0 0-.226-.141.136.136 0 0 0-.053.02.163.163 0 0 0-.054.077.326.326 0 0 0-.017.121l1.06 10.669-1.296-11.08c.268-.118.555-.188.847-.204.267-.018.535-.005.799.035a4.593 4.593 0 0 1 .825.206l2.474 18.198ZM221.009 108.048l-.349-23.855a.72.72 0 0 0-.018-.152.281.281 0 0 0-.064-.115.272.272 0 0 0-.146-.074.198.198 0 0 0-.153.027.24.24 0 0 0-.082.104.449.449 0 0 0-.038.166l.208 23.782-.353-.066-.027-5.359c-.012-2.234-.024-4.793-.034-7.307-.01-2.515-.017-4.983-.02-7.038-.003-2.055-.001-3.693.01-4.544.38-.313.833-.526 1.316-.62.435-.083.88-.099 1.32-.047a5.83 5.83 0 0 1 1.423.346l1.022 18.643-.01-2.686-.009-2.112a40703.401 40703.401 0 0 0-.014-4.685l-.001-1.481.001-2.454c0-1.116.005-2 .012-2.547.365-.3.8-.505 1.265-.594a4.16 4.16 0 0 1 1.268-.046 5.643 5.643 0 0 1 1.37.331l.643 11.742-.005-1.47-.005-1.539c-.004-.96-.004-1.868-.004-2.69l-.001-.826.001-1.355.005-.871c.002-.234.004-.437.004-.607a2.716 2.716 0 0 1 1.209-.57 3.93 3.93 0 0 1 1.209-.043c.315.034.627.097.931.188.126.036.25.079.371.128l1.282 22.816-.285-.055-1.137-22.287.001-.025-.001-.018a.348.348 0 0 0-.014-.096.23.23 0 0 0-.195-.171.179.179 0 0 0-.139.022.208.208 0 0 0-.073.095.422.422 0 0 0-.029.105c-.005.016-.005.032-.005.048l.999 22.22-.304-.058-.988-22.319a.3.3 0 0 0 0-.042.354.354 0 0 0-.014-.097.247.247 0 0 0-.061-.106.248.248 0 0 0-.207-.071.18.18 0 0 0-.067.027.222.222 0 0 0-.075.096.464.464 0 0 0-.034.152l.853 22.248-.372-.068-.727-22.126a.3.3 0 0 0 0-.042.354.354 0 0 0-.014-.097.232.232 0 0 0-.196-.172.178.178 0 0 0-.141.023.211.211 0 0 0-.073.095.416.416 0 0 0-.034.151l.597 22.059-.373-.069-.498-21.721a.3.3 0 0 0 0-.043.353.353 0 0 0-.014-.097.252.252 0 0 0-.06-.105.256.256 0 0 0-.137-.068.179.179 0 0 0-.138.022.216.216 0 0 0-.073.095.412.412 0 0 0-.028.104c-.005.016-.005.032-.005.049l.372 21.655-.327-.059-.297-21.24a.311.311 0 0 0 0-.042.36.36 0 0 0-.014-.098.244.244 0 0 0-.06-.106.237.237 0 0 0-.133-.067.187.187 0 0 0-.141.025.215.215 0 0 0-.075.096.469.469 0 0 0-.035.153l.124 14.758.353 6.466-.619-.116-.008-1.363-.002-.382-.006-1.249-.01-1.837-.004-.666c-.003-.432-.006-.874-.006-1.322l-.853-16.676a.385.385 0 0 0-.015-.145.25.25 0 0 0-.062-.11.254.254 0 0 0-.141-.071.191.191 0 0 0-.147.024.223.223 0 0 0-.082.1.46.46 0 0 0-.035.161l1.06 23.478-.32-.061-1.051-23.58v-.045a.358.358 0 0 0-.015-.102.264.264 0 0 0-.062-.111.25.25 0 0 0-.14-.07.193.193 0 0 0-.15.025.229.229 0 0 0-.081.1.411.411 0 0 0-.03.108c-.003.017-.004.034-.005.05l.907 23.51-.392-.073-.774-23.38v-.043a.385.385 0 0 0-.016-.102.252.252 0 0 0-.203-.181.194.194 0 0 0-.148.023.226.226 0 0 0-.082.1.469.469 0 0 0-.037.162l.64 23.307-.395-.072-.53-22.957.001-.027-.001-.018a.437.437 0 0 0-.015-.102.25.25 0 0 0-.205-.183.197.197 0 0 0-.148.026.231.231 0 0 0-.081.1.461.461 0 0 0-.037.16l.4 22.886-.336-.064-.326-22.45v-.045a.437.437 0 0 0-.014-.102.244.244 0 0 0-.074-.121.236.236 0 0 0-.129-.058.19.19 0 0 0-.146.024.234.234 0 0 0-.082.1.46.46 0 0 0-.032.11l-.004.03-.001.021.197 22.234.006.139-.345-.063v-.662l-1.254-24.337a.416.416 0 0 0-.016-.15.257.257 0 0 0-.213-.19.193.193 0 0 0-.151.026.243.243 0 0 0-.081.104.454.454 0 0 0-.032.114l-.003.022-.003.032 1.136 24.926-.332-.062-1.122-25.032v-.047a.422.422 0 0 0-.016-.106.284.284 0 0 0-.064-.116.266.266 0 0 0-.145-.074.201.201 0 0 0-.154.026.237.237 0 0 0-.082.104.447.447 0 0 0-.038.167l.972 24.958-.412-.074-.826-24.828a.412.412 0 0 0-.017-.15.255.255 0 0 0-.213-.188.195.195 0 0 0-.153.026.243.243 0 0 0-.081.104.456.456 0 0 0-.032.114l-.003.023-.003.031.684 24.748-.411-.075-.571-24.38a.36.36 0 0 0 0-.047.382.382 0 0 0-.016-.106.259.259 0 0 0-.212-.19.201.201 0 0 0-.154.025.234.234 0 0 0-.081.104.502.502 0 0 0-.031.114c-.005.018-.005.036-.005.054l.431 24.309-.353-.067Z",
                        fill: "#FAFBFC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("defs", {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)("clipPath", {
                    id: "hero-lightmode-mobile_svg__a",
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h390v151H0z"
                    })
                })
            })
        ]
    });
var $bf00831185afccc4$export$2e2bcd8739ae039 = $bf00831185afccc4$var$SvgHeroLightmodeMobile;



const $0baf26b3b0f0403b$var$HeroImage = ()=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const themeIsLight = theme.name === "light";
    const isDesktop = (0, $a7773fb8c912d2f6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
        children: isDesktop ? /*#__PURE__*/ (0, $cZGFG.jsx)($0baf26b3b0f0403b$var$HeroDesktop, {
            themeIsLight: themeIsLight
        }) : /*#__PURE__*/ (0, $cZGFG.jsx)($0baf26b3b0f0403b$var$HeroMobile, {
            themeIsLight: themeIsLight
        })
    });
};
const $0baf26b3b0f0403b$var$HeroDesktop = ({ themeIsLight: themeIsLight })=>{
    return themeIsLight ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7b7ad9f885c4152$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $54569a2982a56f82$export$2e2bcd8739ae039), {});
};
const $0baf26b3b0f0403b$var$HeroMobile = ({ themeIsLight: themeIsLight })=>{
    return themeIsLight ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $bf00831185afccc4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $03a32c11bda34481$export$2e2bcd8739ae039), {});
};
var $0baf26b3b0f0403b$export$2e2bcd8739ae039 = $0baf26b3b0f0403b$var$HeroImage;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
var $93b69bb58ac1254b$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($93b69bb58ac1254b$exports, "__esModule", {
    value: true
});
$93b69bb58ac1254b$exports.default = void 0;

var $93b69bb58ac1254b$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $93b69bb58ac1254b$var$_default = $93b69bb58ac1254b$exports.default = (0, $93b69bb58ac1254b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), "KeyboardArrowLeft");


var $818bd5869d0697fa$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($818bd5869d0697fa$exports, "__esModule", {
    value: true
});
$818bd5869d0697fa$exports.default = void 0;

var $818bd5869d0697fa$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $818bd5869d0697fa$var$_default = $818bd5869d0697fa$exports.default = (0, $818bd5869d0697fa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), "KeyboardArrowRight");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
const $3397d1bce61a3d2d$var$_excluded = [
    "value"
];
const $3397d1bce61a3d2d$var$RtlContext = /*#__PURE__*/ $dup7A.createContext();
function $3397d1bce61a3d2d$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $bGxpK.default)(_ref, $3397d1bce61a3d2d$var$_excluded);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3397d1bce61a3d2d$var$RtlContext.Provider, (0, $3G4eg.default)({
        value: value != null ? value : true
    }, props));
}
const $3397d1bce61a3d2d$export$b2dd014b6c321cb = ()=>{
    const value = $dup7A.useContext($3397d1bce61a3d2d$var$RtlContext);
    return value != null ? value : false;
};
var $3397d1bce61a3d2d$export$2e2bcd8739ae039 = $3397d1bce61a3d2d$var$RtlProvider;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $ee74bf8ceade17f5$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $ed0adf8303ed21e1$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $dup7A.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $ee74bf8ceade17f5$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $3G4eg = parcelRequire("3G4eg");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $305e5bd3d224e36e$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $cadb5b489f8b66d9$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $305e5bd3d224e36e$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $3G4eg.default)({}, otherProps, {
        ownerState: (0, $3G4eg.default)({}, otherProps.ownerState, ownerState)
    });
}



var $3G4eg = parcelRequire("3G4eg");

var $aJAJS = parcelRequire("aJAJS");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $e07fd45336973170$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $e64991f3a514bc9c$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $36d10b367697a2f8$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $aJAJS.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $3G4eg.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $3G4eg.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $e07fd45336973170$export$24d5698b57eff81c)((0, $3G4eg.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $e64991f3a514bc9c$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $e64991f3a514bc9c$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $aJAJS.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $3G4eg.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $3G4eg.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $2a17380801fdceb6$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $50d4286570f9fa0f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $50d4286570f9fa0f$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $bGxpK.default)(parameters, $50d4286570f9fa0f$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $2a17380801fdceb6$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $36d10b367697a2f8$export$b01d1e419b049226)((0, $3G4eg.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(elementType, (0, $3G4eg.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $46d3bf2d9ae0a59d$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

function $c6658e3849b4f86d$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $6db36b98959a73d4$var$useEnhancedEffect = typeof window !== "undefined" ? $dup7A.useLayoutEffect : $dup7A.useEffect;
var $6db36b98959a73d4$export$2e2bcd8739ae039 = $6db36b98959a73d4$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $55cb61ffd149a974$var$useEventCallback(fn) {
    const ref = $dup7A.useRef(fn);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $dup7A.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $55cb61ffd149a974$export$2e2bcd8739ae039 = $55cb61ffd149a974$var$useEventCallback;



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $e3308ed46a76465c$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $f27c9b17b0ca6f7d$export$2e2bcd8739ae039(node) {
    const doc = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $5fdf32306d0f0582$var$isOverflowing(container) {
    const doc = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $5fdf32306d0f0582$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $5fdf32306d0f0582$var$getPaddingRight(element) {
    return parseInt((0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $5fdf32306d0f0582$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $5fdf32306d0f0582$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$5fdf32306d0f0582$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $5fdf32306d0f0582$export$e1bd0c6150f13d96(element, show);
    });
}
function $5fdf32306d0f0582$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $5fdf32306d0f0582$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($5fdf32306d0f0582$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $e3308ed46a76465c$export$2e2bcd8739ae039)((0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$5fdf32306d0f0582$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$5fdf32306d0f0582$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $5fdf32306d0f0582$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $5fdf32306d0f0582$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $5fdf32306d0f0582$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $5fdf32306d0f0582$var$getHiddenSiblings(container);
        $5fdf32306d0f0582$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $5fdf32306d0f0582$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $5fdf32306d0f0582$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $5fdf32306d0f0582$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $5fdf32306d0f0582$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $5fdf32306d0f0582$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $5fdf32306d0f0582$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $5fdf32306d0f0582$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $14e6b3701db8c97e$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $14e6b3701db8c97e$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $14e6b3701db8c97e$var$defaultManager = new (0, $5fdf32306d0f0582$export$ce11c4ecd08cea67)();
function $14e6b3701db8c97e$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $14e6b3701db8c97e$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $dup7A.useRef({});
    const mountNodeRef = $dup7A.useRef(null);
    const modalRef = $dup7A.useRef(null);
    const handleRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $dup7A.useState(!open);
    const hasTransition = $14e6b3701db8c97e$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $55cb61ffd149a974$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $14e6b3701db8c97e$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $dup7A.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $55cb61ffd149a974$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $5fdf32306d0f0582$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $dup7A.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $dup7A.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $dup7A.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $e07fd45336973170$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $3G4eg.default)({}, propsEventHandlers, otherHandlers);
        return (0, $3G4eg.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $3G4eg.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $46d3bf2d9ae0a59d$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $46d3bf2d9ae0a59d$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $2wgr3 = parcelRequire("2wgr3");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $a58659fd23b71354$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $a58659fd23b71354$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $a58659fd23b71354$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $a58659fd23b71354$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $a58659fd23b71354$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $a58659fd23b71354$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($a58659fd23b71354$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $a58659fd23b71354$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$a58659fd23b71354$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $a58659fd23b71354$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $a58659fd23b71354$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $a58659fd23b71354$var$defaultGetTabbable, isEnabled: isEnabled = $a58659fd23b71354$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $dup7A.useRef(false);
    const sentinelStart = $dup7A.useRef(null);
    const sentinelEnd = $dup7A.useRef(null);
    const nodeToRestore = $dup7A.useRef(null);
    const reactFocusEventTarget = $dup7A.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $dup7A.useRef(false);
    const rootRef = $dup7A.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $dup7A.useRef(null);
    $dup7A.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $dup7A.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $dup7A.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $dup7A.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
"use client";
function $bf1b7d92504c6f51$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $bf1b7d92504c6f51$export$602eac185826482c = /*#__PURE__*/ $dup7A.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $dup7A.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(/*#__PURE__*/ $dup7A.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($bf1b7d92504c6f51$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $ee74bf8ceade17f5$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $ee74bf8ceade17f5$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $dup7A.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $dup7A.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $cZGFG.jsx)($dup7A.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dup7A.Fragment, {
        children: mountNode ? /*#__PURE__*/ $e10f5070fc836746$exports.createPortal(children, mountNode) : mountNode
    });
});



var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $bGxpK = parcelRequire("bGxpK");

function $bdf8b94a1cab2162$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $8355d769ce7c2a91$export$2e2bcd8739ae039)(subClass, superClass);
}




var $dup7A = parcelRequire("dup7A");

var $5ccdf77e06d893d4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $dup7A = parcelRequire("dup7A");
var $f126b94d52f59e40$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(null);


var $b3783c8dd15399c0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $e41ac8e2c2248586$export$bb38bb9a1161268 = "unmounted";
var $e41ac8e2c2248586$export$84cbff306f539230 = "exited";
var $e41ac8e2c2248586$export$df38205c966be359 = "entering";
var $e41ac8e2c2248586$export$78e9e6e3e014d60a = "entered";
var $e41ac8e2c2248586$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e41ac8e2c2248586$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bdf8b94a1cab2162$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e41ac8e2c2248586$export$84cbff306f539230;
                _this.appearStatus = $e41ac8e2c2248586$export$df38205c966be359;
            } else initialStatus = $e41ac8e2c2248586$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e41ac8e2c2248586$export$bb38bb9a1161268;
        else initialStatus = $e41ac8e2c2248586$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e41ac8e2c2248586$export$bb38bb9a1161268) return {
            status: $e41ac8e2c2248586$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e41ac8e2c2248586$export$df38205c966be359 && status !== $e41ac8e2c2248586$export$78e9e6e3e014d60a) nextStatus = $e41ac8e2c2248586$export$df38205c966be359;
            } else if (status === $e41ac8e2c2248586$export$df38205c966be359 || status === $e41ac8e2c2248586$export$78e9e6e3e014d60a) nextStatus = $e41ac8e2c2248586$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e41ac8e2c2248586$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $b3783c8dd15399c0$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e41ac8e2c2248586$export$84cbff306f539230) this.setState({
            status: $e41ac8e2c2248586$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $5ccdf77e06d893d4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e41ac8e2c2248586$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e41ac8e2c2248586$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e41ac8e2c2248586$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $5ccdf77e06d893d4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e41ac8e2c2248586$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e41ac8e2c2248586$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e41ac8e2c2248586$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e41ac8e2c2248586$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bGxpK.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f126b94d52f59e40$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
$e41ac8e2c2248586$var$Transition.contextType = (0, $f126b94d52f59e40$export$2e2bcd8739ae039);
$e41ac8e2c2248586$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e41ac8e2c2248586$var$noop() {}
$e41ac8e2c2248586$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e41ac8e2c2248586$var$noop,
    onEntering: $e41ac8e2c2248586$var$noop,
    onEntered: $e41ac8e2c2248586$var$noop,
    onExit: $e41ac8e2c2248586$var$noop,
    onExiting: $e41ac8e2c2248586$var$noop,
    onExited: $e41ac8e2c2248586$var$noop
};
$e41ac8e2c2248586$var$Transition.UNMOUNTED = $e41ac8e2c2248586$export$bb38bb9a1161268;
$e41ac8e2c2248586$var$Transition.EXITED = $e41ac8e2c2248586$export$84cbff306f539230;
$e41ac8e2c2248586$var$Transition.ENTERING = $e41ac8e2c2248586$export$df38205c966be359;
$e41ac8e2c2248586$var$Transition.ENTERED = $e41ac8e2c2248586$export$78e9e6e3e014d60a;
$e41ac8e2c2248586$var$Transition.EXITING = $e41ac8e2c2248586$export$4aacc83d4d59139f;
var $e41ac8e2c2248586$export$2e2bcd8739ae039 = $e41ac8e2c2248586$var$Transition;



parcelRequire("dup7A");

var $lcALP = parcelRequire("lcALP");

var $hddxs = parcelRequire("hddxs");

var $7wciM = parcelRequire("7wciM");
"use client";
function $440caa946b5f115e$export$2e2bcd8739ae039() {
    const theme = (0, $lcALP.default)((0, $hddxs.default));
    return theme[0, $7wciM.default] || theme;
}


const $51a9aedde841c9be$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $51a9aedde841c9be$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



"use client";
var $164c28d960f5df34$export$2e2bcd8739ae039 = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039);



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $5759152b776d295d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5759152b776d295d$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5759152b776d295d$var$Fade = /*#__PURE__*/ $dup7A.forwardRef(function Fade(props, ref) {
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e41ac8e2c2248586$export$2e2bcd8739ae039) } = props, other = (0, $bGxpK.default)(props, $5759152b776d295d$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $dup7A.useRef(null);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $51a9aedde841c9be$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $dup7A.cloneElement(children, (0, $3G4eg.default)({
                style: (0, $3G4eg.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5759152b776d295d$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5759152b776d295d$export$2e2bcd8739ae039 = $5759152b776d295d$var$Fade;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $0a6a8f4e39dd4671$export$9927a91fd93152bd(slot) {
    return (0, $8iNDC.default)("MuiBackdrop", slot);
}
const $0a6a8f4e39dd4671$var$backdropClasses = (0, $fc1pF.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $0a6a8f4e39dd4671$export$2e2bcd8739ae039 = $0a6a8f4e39dd4671$var$backdropClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $a9d067e726ebb3f0$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $a9d067e726ebb3f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $0a6a8f4e39dd4671$export$9927a91fd93152bd), classes);
};
const $a9d067e726ebb3f0$var$BackdropRoot = (0, $jjHhy.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $a9d067e726ebb3f0$var$Backdrop = /*#__PURE__*/ $dup7A.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5759152b776d295d$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $bGxpK.default)(props, $a9d067e726ebb3f0$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $a9d067e726ebb3f0$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($a9d067e726ebb3f0$var$BackdropRoot, (0, $3G4eg.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $aJAJS.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $3G4eg.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $a9d067e726ebb3f0$export$2e2bcd8739ae039 = $a9d067e726ebb3f0$var$Backdrop;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $eca77e5909c71a86$export$67960e22b12a638d(slot) {
    return (0, $8iNDC.default)("MuiModal", slot);
}
const $eca77e5909c71a86$var$modalClasses = (0, $fc1pF.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $eca77e5909c71a86$export$2e2bcd8739ae039 = $eca77e5909c71a86$var$modalClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $6a8e94f31f514acc$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $6a8e94f31f514acc$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $eca77e5909c71a86$export$67960e22b12a638d), classes);
};
const $6a8e94f31f514acc$var$ModalRoot = (0, $jjHhy.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $6a8e94f31f514acc$var$ModalBackdrop = (0, $jjHhy.default)((0, $a9d067e726ebb3f0$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $6a8e94f31f514acc$var$Modal = /*#__PURE__*/ $dup7A.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $7ZufN.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $6a8e94f31f514acc$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $bGxpK.default)(props, $6a8e94f31f514acc$var$_excluded);
    const propsWithDefaults = (0, $3G4eg.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $14e6b3701db8c97e$export$33ffd74ebf07f060)((0, $3G4eg.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $3G4eg.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $6a8e94f31f514acc$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6a8e94f31f514acc$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $aJAJS.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $3G4eg.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $aJAJS.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $bf1b7d92504c6f51$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)(RootSlot, (0, $3G4eg.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $cZGFG.jsx)(BackdropSlot, (0, $3G4eg.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $a58659fd23b71354$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $dup7A.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $6a8e94f31f514acc$export$2e2bcd8739ae039 = $6a8e94f31f514acc$var$Modal;



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");





// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $6ed2fbb3df16a513$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $9cb364921dbb34c4$export$2e2bcd8739ae039 = (0, $6ed2fbb3df16a513$export$2e2bcd8739ae039);






var $c118840f30ef889d$export$2e2bcd8739ae039 = (0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039);



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $096557c2b2cf6c97$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $096557c2b2cf6c97$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $c118840f30ef889d$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $096557c2b2cf6c97$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $096557c2b2cf6c97$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $096557c2b2cf6c97$var$resolveContainer(containerProp);
    const transform = $096557c2b2cf6c97$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $096557c2b2cf6c97$var$Slide = /*#__PURE__*/ $dup7A.forwardRef(function Slide(props, ref) {
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e41ac8e2c2248586$export$2e2bcd8739ae039) } = props, other = (0, $bGxpK.default)(props, $096557c2b2cf6c97$var$_excluded);
    const childrenRef = $dup7A.useRef(null);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $096557c2b2cf6c97$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $51a9aedde841c9be$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $3G4eg.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $3G4eg.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $096557c2b2cf6c97$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $dup7A.useCallback(()=>{
        if (childrenRef.current) $096557c2b2cf6c97$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $dup7A.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $9cb364921dbb34c4$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $096557c2b2cf6c97$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $c118840f30ef889d$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $dup7A.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $dup7A.cloneElement(children, (0, $3G4eg.default)({
                ref: handleRef,
                style: (0, $3G4eg.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $096557c2b2cf6c97$export$2e2bcd8739ae039 = $096557c2b2cf6c97$var$Slide;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");



var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $3542b69d43777d27$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $3542b69d43777d27$export$2e2bcd8739ae039 = $3542b69d43777d27$var$getOverlayAlpha;



var $7ZufN = parcelRequire("7ZufN");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $aa82191c340fc7fa$export$29cdb466b9b6f20b(slot) {
    return (0, $8iNDC.default)("MuiPaper", slot);
}
const $aa82191c340fc7fa$var$paperClasses = (0, $fc1pF.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $aa82191c340fc7fa$export$2e2bcd8739ae039 = $aa82191c340fc7fa$var$paperClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $929a5b6600d07d14$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $929a5b6600d07d14$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $aa82191c340fc7fa$export$29cdb466b9b6f20b), classes);
};
const $929a5b6600d07d14$var$PaperRoot = (0, $jjHhy.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $3G4eg.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $3G4eg.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $emmvO.alpha)("#fff", (0, $3542b69d43777d27$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $emmvO.alpha)("#fff", (0, $3542b69d43777d27$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $929a5b6600d07d14$var$Paper = /*#__PURE__*/ $dup7A.forwardRef(function Paper(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $bGxpK.default)(props, $929a5b6600d07d14$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $929a5b6600d07d14$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($929a5b6600d07d14$var$PaperRoot, (0, $3G4eg.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref
    }, other));
});
var $929a5b6600d07d14$export$2e2bcd8739ae039 = $929a5b6600d07d14$var$Paper;



var $4y4xl = parcelRequire("4y4xl");


var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $cd123f93116fb4ce$export$b801318a856c9cd2(slot) {
    return (0, $8iNDC.default)("MuiDrawer", slot);
}
const $cd123f93116fb4ce$var$drawerClasses = (0, $fc1pF.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $cd123f93116fb4ce$export$2e2bcd8739ae039 = $cd123f93116fb4ce$var$drawerClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $087d17b7c478e027$var$_excluded = [
    "BackdropProps"
], $087d17b7c478e027$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $087d17b7c478e027$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $087d17b7c478e027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $4y4xl.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $4y4xl.default)(anchor)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $cd123f93116fb4ce$export$b801318a856c9cd2), classes);
};
const $087d17b7c478e027$var$DrawerRoot = (0, $jjHhy.default)((0, $6a8e94f31f514acc$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $087d17b7c478e027$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $087d17b7c478e027$var$DrawerDockedRoot = (0, $jjHhy.default)("div", {
    shouldForwardProp: (0, $dDUuw.default),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $087d17b7c478e027$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $087d17b7c478e027$var$DrawerPaper = (0, $jjHhy.default)((0, $929a5b6600d07d14$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $4y4xl.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $4y4xl.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $087d17b7c478e027$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $087d17b7c478e027$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $087d17b7c478e027$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === "rtl" && $087d17b7c478e027$export$2a62b49acb270576(anchor) ? $087d17b7c478e027$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $087d17b7c478e027$var$Drawer = /*#__PURE__*/ $dup7A.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const isRtl = (0, $3397d1bce61a3d2d$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $096557c2b2cf6c97$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $bGxpK.default)(props.ModalProps, $087d17b7c478e027$var$_excluded), other = (0, $bGxpK.default)(props, $087d17b7c478e027$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $dup7A.useRef(false);
    $dup7A.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $087d17b7c478e027$export$830f4f08342d299e({
        direction: isRtl ? "rtl" : "ltr"
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $3G4eg.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $087d17b7c478e027$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $cZGFG.jsx)($087d17b7c478e027$var$DrawerPaper, (0, $3G4eg.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $aJAJS.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $cZGFG.jsx)($087d17b7c478e027$var$DrawerDockedRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        in: open,
        direction: $087d17b7c478e027$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $cZGFG.jsx)($087d17b7c478e027$var$DrawerDockedRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $cZGFG.jsx)($087d17b7c478e027$var$DrawerRoot, (0, $3G4eg.default)({
        BackdropProps: (0, $3G4eg.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $aJAJS.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $087d17b7c478e027$export$2e2bcd8739ae039 = $087d17b7c478e027$var$Drawer;



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

var $d8FWH = parcelRequire("d8FWH");

var $dup7A = parcelRequire("dup7A");
var $489a9c751e5da436$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $489a9c751e5da436$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $a039d202c4e41f21$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $a039d202c4e41f21$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($489a9c751e5da436$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($a039d202c4e41f21$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $a039d202c4e41f21$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $a039d202c4e41f21$var$i = /^\s*$/, $a039d202c4e41f21$var$s = Object.create(null);
function $a039d202c4e41f21$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($a039d202c4e41f21$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $a039d202c4e41f21$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $a039d202c4e41f21$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($a039d202c4e41f21$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $a039d202c4e41f21$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $a039d202c4e41f21$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $a039d202c4e41f21$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $a039d202c4e41f21$var$a("", t);
        }, "");
    }
};
var $a039d202c4e41f21$export$2e2bcd8739ae039 = $a039d202c4e41f21$var$c;


function $a0ffa00a57814650$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $a0ffa00a57814650$var$alreadyWarned = {};
function $a0ffa00a57814650$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $a0ffa00a57814650$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $a0ffa00a57814650$var$alreadyWarned[args[0]] = new Date();
    $a0ffa00a57814650$export$c106dd0671a0fc2d(...args);
}
const $a0ffa00a57814650$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $a0ffa00a57814650$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $a0ffa00a57814650$var$loadedClb(i18n, cb));
}
function $a0ffa00a57814650$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $a0ffa00a57814650$var$loadedClb(i18n, cb));
}
function $a0ffa00a57814650$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $a0ffa00a57814650$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $a0ffa00a57814650$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $a0ffa00a57814650$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $a0ffa00a57814650$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $a9a7eb0eab2b32d0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $a9a7eb0eab2b32d0$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $a9a7eb0eab2b32d0$var$unescapeHtmlEntity = (m)=>$a9a7eb0eab2b32d0$var$htmlEntities[m];
const $a9a7eb0eab2b32d0$export$e8bacd2802a88316 = (text)=>text.replace($a9a7eb0eab2b32d0$var$matchHtmlEntity, $a9a7eb0eab2b32d0$var$unescapeHtmlEntity);


let $f87d37310a9a4854$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $a9a7eb0eab2b32d0$export$e8bacd2802a88316
};
function $f87d37310a9a4854$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $f87d37310a9a4854$var$defaultOptions = {
        ...$f87d37310a9a4854$var$defaultOptions,
        ...options
    };
}
function $f87d37310a9a4854$export$212bb2fc580a90a8() {
    return $f87d37310a9a4854$var$defaultOptions;
}


let $a51e9b3e4d5aa2db$var$i18nInstance;
function $a51e9b3e4d5aa2db$export$a039134f2fc7e0(instance) {
    $a51e9b3e4d5aa2db$var$i18nInstance = instance;
}
function $a51e9b3e4d5aa2db$export$64af334f494c2f47() {
    return $a51e9b3e4d5aa2db$var$i18nInstance;
}


function $b509cb90944adfb1$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $b509cb90944adfb1$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $b509cb90944adfb1$var$getAsArray(children) : children;
}
function $b509cb90944adfb1$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $dup7A.isValidElement)(child));
}
function $b509cb90944adfb1$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $b509cb90944adfb1$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $b509cb90944adfb1$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $b509cb90944adfb1$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $dup7A.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $b509cb90944adfb1$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $a0ffa00a57814650$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $a0ffa00a57814650$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $a0ffa00a57814650$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $b509cb90944adfb1$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $b509cb90944adfb1$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($b509cb90944adfb1$var$hasChildren(child)) getData($b509cb90944adfb1$var$getChildren(child));
            else if (typeof child === "object" && !(0, $dup7A.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $a039d202c4e41f21$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $b509cb90944adfb1$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $b509cb90944adfb1$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $dup7A.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $dup7A.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($d8FWH)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $b509cb90944adfb1$var$getAsArray(reactNode);
        const astNodes = $b509cb90944adfb1$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $b509cb90944adfb1$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $dup7A.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $b509cb90944adfb1$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($b509cb90944adfb1$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $dup7A.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $dup7A.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $dup7A.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $b509cb90944adfb1$var$getAsArray(children || []));
    return $b509cb90944adfb1$var$getChildren(result[0]);
}
function $b509cb90944adfb1$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $a51e9b3e4d5aa2db$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $a0ffa00a57814650$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $f87d37310a9a4854$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $b509cb90944adfb1$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, null, comp);
        }
        components[c] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(Componentized, null);
    });
    const content = $b509cb90944adfb1$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $dup7A.createElement)(useAsParent, additionalProps, content) : content;
}



var $dup7A = parcelRequire("dup7A");




const $2e6409c8619af830$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $f87d37310a9a4854$export$2e2366488d12e20d)(instance.options.react);
        (0, $a51e9b3e4d5aa2db$export$a039134f2fc7e0)(instance);
    }
};


const $f08c91ad8745462a$export$5603ab5ced17ce64 = (0, $dup7A.createContext)();
class $f08c91ad8745462a$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $f08c91ad8745462a$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $f08c91ad8745462a$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $f08c91ad8745462a$export$704200e5d0b9e8f() {
    const i18n = (0, $a51e9b3e4d5aa2db$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $2fb7372348de61af$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $dup7A.useContext)((0, $f08c91ad8745462a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a51e9b3e4d5aa2db$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $b509cb90944adfb1$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $dup7A = parcelRequire("dup7A");


const $242efbb298f787ec$var$usePrevious = (value, ignore)=>{
    const ref = (0, $dup7A.useRef)();
    (0, $dup7A.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $242efbb298f787ec$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $dup7A.useContext)((0, $f08c91ad8745462a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a51e9b3e4d5aa2db$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $f08c91ad8745462a$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $a0ffa00a57814650$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $a0ffa00a57814650$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $f87d37310a9a4854$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $a0ffa00a57814650$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $dup7A.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $242efbb298f787ec$var$usePrevious(joinedNS);
    const isMounted = (0, $dup7A.useRef)(true);
    (0, $dup7A.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $a0ffa00a57814650$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $a0ffa00a57814650$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $dup7A.useRef)(true);
    (0, $dup7A.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $a0ffa00a57814650$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $a0ffa00a57814650$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $dup7A = parcelRequire("dup7A");


function $0c6d63d5e1d0e842$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $242efbb298f787ec$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $dup7A.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $a0ffa00a57814650$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $dup7A.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $dup7A.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $4e19ecb18b8182b7$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $242efbb298f787ec$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $dup7A = parcelRequire("dup7A");

function $d33476ad4a6217f5$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $dup7A.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $dup7A.createElement)((0, $f08c91ad8745462a$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");

function $ece30a1fd9857b8f$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $dup7A.useContext)((0, $f08c91ad8745462a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $a51e9b3e4d5aa2db$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $d4bbf09cd999da18$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $ece30a1fd9857b8f$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $dup7A.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $f08c91ad8745462a$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $a0ffa00a57814650$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $161f6a3c4c59ddbd$export$324d90190a8b822a = ()=>"";
const $161f6a3c4c59ddbd$export$2da9be4cfdb689b1 = ()=>"";
const $161f6a3c4c59ddbd$export$98e628dec113755e = ()=>"";
const $161f6a3c4c59ddbd$export$2e6c959c16ff56b8 = ()=>"";
const $161f6a3c4c59ddbd$export$4e35d5c922a95490 = ()=>"";
const $161f6a3c4c59ddbd$export$720a3b9db04b7a0f = ()=>"";




var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $bNgkT = parcelRequire("bNgkT");

var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");



var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


"use client";
var $5cbcd99cab12064e$export$2e2bcd8739ae039 = (0, $55cb61ffd149a974$export$2e2bcd8739ae039);



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
"use client";
const $fbdce83642294b6a$var$UNINITIALIZED = {};
function $fbdce83642294b6a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $dup7A.useRef($fbdce83642294b6a$var$UNINITIALIZED);
    if (ref.current === $fbdce83642294b6a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $dup7A = parcelRequire("dup7A");
"use client";
const $c1d68ea9a7e06269$var$EMPTY = [];
function $c1d68ea9a7e06269$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $dup7A.useEffect(fn, $c1d68ea9a7e06269$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $625a659d3ca757bf$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $625a659d3ca757bf$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $625a659d3ca757bf$export$2e2bcd8739ae039() {
    const timeout = (0, $fbdce83642294b6a$export$2e2bcd8739ae039)($625a659d3ca757bf$export$786b4da70f00938b.create).current;
    (0, $c1d68ea9a7e06269$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $cd7b7379a32c2be2$var$hadKeyboardEvent = true;
let $cd7b7379a32c2be2$var$hadFocusVisibleRecently = false;
const $cd7b7379a32c2be2$var$hadFocusVisibleRecentlyTimeout = new (0, $625a659d3ca757bf$export$786b4da70f00938b)();
const $cd7b7379a32c2be2$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $cd7b7379a32c2be2$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $cd7b7379a32c2be2$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $cd7b7379a32c2be2$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $cd7b7379a32c2be2$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $cd7b7379a32c2be2$var$handlePointerDown() {
    $cd7b7379a32c2be2$var$hadKeyboardEvent = false;
}
function $cd7b7379a32c2be2$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($cd7b7379a32c2be2$var$hadFocusVisibleRecently) $cd7b7379a32c2be2$var$hadKeyboardEvent = true;
    }
}
function $cd7b7379a32c2be2$var$prepare(doc) {
    doc.addEventListener("keydown", $cd7b7379a32c2be2$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $cd7b7379a32c2be2$var$handleVisibilityChange, true);
}
function $cd7b7379a32c2be2$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $cd7b7379a32c2be2$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $cd7b7379a32c2be2$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $cd7b7379a32c2be2$var$handleVisibilityChange, true);
}
function $cd7b7379a32c2be2$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $cd7b7379a32c2be2$var$hadKeyboardEvent || $cd7b7379a32c2be2$var$focusTriggersKeyboardModality(target);
}
function $cd7b7379a32c2be2$export$2e2bcd8739ae039() {
    const ref = $dup7A.useCallback((node)=>{
        if (node != null) $cd7b7379a32c2be2$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $dup7A.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $cd7b7379a32c2be2$var$hadFocusVisibleRecently = true;
            $cd7b7379a32c2be2$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $cd7b7379a32c2be2$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($cd7b7379a32c2be2$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $e1af0238f772e7e3$export$2e2bcd8739ae039 = (0, $cd7b7379a32c2be2$export$2e2bcd8739ae039);



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");




var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
function $36680d516da82724$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $dup7A.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $dup7A.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $36680d516da82724$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $36680d516da82724$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $36680d516da82724$export$fa71e2345c31d7a2(props, onExited) {
    return $36680d516da82724$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $dup7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $36680d516da82724$var$getProp(child, "appear", props),
            enter: $36680d516da82724$var$getProp(child, "enter", props),
            exit: $36680d516da82724$var$getProp(child, "exit", props)
        });
    });
}
function $36680d516da82724$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $36680d516da82724$export$bbc8a025727ea824(nextProps.children);
    var children = $36680d516da82724$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $dup7A.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $dup7A.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $dup7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $36680d516da82724$var$getProp(child, "exit", nextProps),
            enter: $36680d516da82724$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $dup7A.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $dup7A.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $dup7A.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $36680d516da82724$var$getProp(child, "exit", nextProps),
            enter: $36680d516da82724$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $f0edd6a471530267$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $f0edd6a471530267$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $f0edd6a471530267$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bdf8b94a1cab2162$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $36680d516da82724$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $36680d516da82724$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $36680d516da82724$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $3G4eg.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $bGxpK.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $f0edd6a471530267$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f126b94d52f59e40$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f126b94d52f59e40$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
$f0edd6a471530267$var$TransitionGroup.propTypes = {};
$f0edd6a471530267$var$TransitionGroup.defaultProps = $f0edd6a471530267$var$defaultProps;
var $f0edd6a471530267$export$2e2bcd8739ae039 = $f0edd6a471530267$var$TransitionGroup;



var $aJAJS = parcelRequire("aJAJS");

var $8eVik = parcelRequire("8eVik");


var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $cZGFG = parcelRequire("cZGFG");
"use client";
function $450bbc9aa23b3b1b$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $dup7A.useState(false);
    const rippleClassName = (0, $aJAJS.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aJAJS.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $dup7A.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
            className: childClassName
        })
    });
}
var $450bbc9aa23b3b1b$export$2e2bcd8739ae039 = $450bbc9aa23b3b1b$var$Ripple;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $fce5e60dccd9caab$export$b464606f735ab902(slot) {
    return (0, $8iNDC.default)("MuiTouchRipple", slot);
}
const $fce5e60dccd9caab$var$touchRippleClasses = (0, $fc1pF.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $fce5e60dccd9caab$export$2e2bcd8739ae039 = $fce5e60dccd9caab$var$touchRippleClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $c8f15485272467a5$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $c8f15485272467a5$var$_ = (t)=>t, $c8f15485272467a5$var$_t, $c8f15485272467a5$var$_t2, $c8f15485272467a5$var$_t3, $c8f15485272467a5$var$_t4;
const $c8f15485272467a5$var$DURATION = 550;
const $c8f15485272467a5$export$95d0c9356b2231a3 = 80;
const $c8f15485272467a5$var$enterKeyframe = (0, $8eVik.keyframes)($c8f15485272467a5$var$_t || ($c8f15485272467a5$var$_t = $c8f15485272467a5$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c8f15485272467a5$var$exitKeyframe = (0, $8eVik.keyframes)($c8f15485272467a5$var$_t2 || ($c8f15485272467a5$var$_t2 = $c8f15485272467a5$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c8f15485272467a5$var$pulsateKeyframe = (0, $8eVik.keyframes)($c8f15485272467a5$var$_t3 || ($c8f15485272467a5$var$_t3 = $c8f15485272467a5$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c8f15485272467a5$export$f6b7418508c72c25 = (0, $jjHhy.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $c8f15485272467a5$export$676cfe7b12693c4b = (0, $jjHhy.default)((0, $450bbc9aa23b3b1b$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($c8f15485272467a5$var$_t4 || ($c8f15485272467a5$var$_t4 = $c8f15485272467a5$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).rippleVisible, $c8f15485272467a5$var$enterKeyframe, $c8f15485272467a5$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).child, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).childLeaving, $c8f15485272467a5$var$exitKeyframe, $c8f15485272467a5$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).childPulsate, $c8f15485272467a5$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c8f15485272467a5$var$TouchRipple = /*#__PURE__*/ $dup7A.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $bGxpK.default)(props, $c8f15485272467a5$var$_excluded);
    const [ripples, setRipples] = $dup7A.useState([]);
    const nextKey = $dup7A.useRef(0);
    const rippleCallback = $dup7A.useRef(null);
    $dup7A.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $dup7A.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $dup7A.useRef(null);
    const container = $dup7A.useRef(null);
    const startCommit = $dup7A.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $cZGFG.jsx)($c8f15485272467a5$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aJAJS.default)(classes.ripple, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $aJAJS.default)(classes.rippleVisible, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $aJAJS.default)(classes.ripplePulsate, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $aJAJS.default)(classes.child, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $aJAJS.default)(classes.childLeaving, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $aJAJS.default)(classes.childPulsate, (0, $fce5e60dccd9caab$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $c8f15485272467a5$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $dup7A.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c8f15485272467a5$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $dup7A.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $dup7A.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $dup7A.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($c8f15485272467a5$export$f6b7418508c72c25, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)((0, $fce5e60dccd9caab$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f0edd6a471530267$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $c8f15485272467a5$export$2e2bcd8739ae039 = $c8f15485272467a5$var$TouchRipple;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $4d6cdf8e851d356f$export$fccb0498dcd99783(slot) {
    return (0, $8iNDC.default)("MuiButtonBase", slot);
}
const $4d6cdf8e851d356f$var$buttonBaseClasses = (0, $fc1pF.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $4d6cdf8e851d356f$export$2e2bcd8739ae039 = $4d6cdf8e851d356f$var$buttonBaseClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $729321786c389df3$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $729321786c389df3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $4d6cdf8e851d356f$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $729321786c389df3$export$7ec0dcc5e3cdcd36 = (0, $jjHhy.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $4d6cdf8e851d356f$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $729321786c389df3$var$ButtonBase = /*#__PURE__*/ $dup7A.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $bGxpK.default)(props, $729321786c389df3$var$_excluded);
    const buttonRef = $dup7A.useRef(null);
    const rippleRef = $dup7A.useRef(null);
    const handleRippleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $e1af0238f772e7e3$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $dup7A.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $dup7A.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $dup7A.useState(false);
    $dup7A.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $dup7A.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $dup7A.useRef(false);
    const handleKeyDown = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $3G4eg.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $729321786c389df3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($729321786c389df3$export$7ec0dcc5e3cdcd36, (0, $3G4eg.default)({
        as: ComponentProp,
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $cZGFG.jsx)((0, $c8f15485272467a5$export$2e2bcd8739ae039), (0, $3G4eg.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $729321786c389df3$export$2e2bcd8739ae039 = $729321786c389df3$var$ButtonBase;



var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $497a5185a2231956$export$5a6f9035944c8119(slot) {
    return (0, $8iNDC.default)("MuiButton", slot);
}
const $497a5185a2231956$var$buttonClasses = (0, $fc1pF.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $497a5185a2231956$export$2e2bcd8739ae039 = $497a5185a2231956$var$buttonClasses;



var $dup7A = parcelRequire("dup7A");
/**
 * @ignore - internal component.
 */ const $e740a7bd42ab1ff6$var$ButtonGroupContext = /*#__PURE__*/ $dup7A.createContext({});
var $e740a7bd42ab1ff6$export$2e2bcd8739ae039 = $e740a7bd42ab1ff6$var$ButtonGroupContext;



var $dup7A = parcelRequire("dup7A");
/**
 * @ignore - internal component.
 */ const $ee35a1a3f748d745$var$ButtonGroupButtonContext = /*#__PURE__*/ $dup7A.createContext(undefined);
var $ee35a1a3f748d745$export$2e2bcd8739ae039 = $ee35a1a3f748d745$var$ButtonGroupButtonContext;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $67687db373c810bd$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $67687db373c810bd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $4y4xl.default)(color)}`,
            `size${(0, $4y4xl.default)(size)}`,
            `${variant}Size${(0, $4y4xl.default)(size)}`,
            `color${(0, $4y4xl.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $4y4xl.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $4y4xl.default)(size)}`
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $497a5185a2231956$export$5a6f9035944c8119), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $67687db373c810bd$var$commonIconStyles = (ownerState)=>(0, $3G4eg.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $67687db373c810bd$var$ButtonRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4y4xl.default)(ownerState.color)}`],
            styles[`size${(0, $4y4xl.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4y4xl.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $3G4eg.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $3G4eg.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $3G4eg.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $497a5185a2231956$export$2e2bcd8739ae039).focusVisible}`]: (0, $3G4eg.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $497a5185a2231956$export$2e2bcd8739ae039).disabled}`]: (0, $3G4eg.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $emmvO.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $497a5185a2231956$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $497a5185a2231956$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $67687db373c810bd$var$ButtonStartIcon = (0, $jjHhy.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $4y4xl.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $67687db373c810bd$var$commonIconStyles(ownerState)));
const $67687db373c810bd$var$ButtonEndIcon = (0, $jjHhy.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $4y4xl.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $67687db373c810bd$var$commonIconStyles(ownerState)));
const $67687db373c810bd$var$Button = /*#__PURE__*/ $dup7A.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $dup7A.useContext((0, $e740a7bd42ab1ff6$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $dup7A.useContext((0, $ee35a1a3f748d745$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bNgkT.default)(contextProps, inProps);
    const props = (0, $7ZufN.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $bGxpK.default)(props, $67687db373c810bd$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $67687db373c810bd$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $cZGFG.jsx)($67687db373c810bd$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $cZGFG.jsx)($67687db373c810bd$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($67687db373c810bd$var$ButtonRoot, (0, $3G4eg.default)({
        ownerState: ownerState,
        className: (0, $aJAJS.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aJAJS.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $67687db373c810bd$export$2e2bcd8739ae039 = $67687db373c810bd$var$Button;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $dde6c51a76ecb3f5$export$5e8702d71474f093(slot) {
    return (0, $8iNDC.default)("MuiIconButton", slot);
}
const $dde6c51a76ecb3f5$var$iconButtonClasses = (0, $fc1pF.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $dde6c51a76ecb3f5$export$2e2bcd8739ae039 = $dde6c51a76ecb3f5$var$iconButtonClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $510dba830cc31c9a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $510dba830cc31c9a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $4y4xl.default)(color)}`,
            edge && `edge${(0, $4y4xl.default)(edge)}`,
            `size${(0, $4y4xl.default)(size)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $dde6c51a76ecb3f5$export$5e8702d71474f093), classes);
};
const $510dba830cc31c9a$var$IconButtonRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $4y4xl.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $4y4xl.default)(ownerState.edge)}`],
            styles[`size${(0, $4y4xl.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $3G4eg.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $3G4eg.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $3G4eg.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $dde6c51a76ecb3f5$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $510dba830cc31c9a$var$IconButton = /*#__PURE__*/ $dup7A.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $bGxpK.default)(props, $510dba830cc31c9a$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $510dba830cc31c9a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($510dba830cc31c9a$var$IconButtonRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $510dba830cc31c9a$export$2e2bcd8739ae039 = $510dba830cc31c9a$var$IconButton;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $9qvqC = parcelRequire("9qvqC");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $f9f0aae8217b908f$export$24c1f8f60cbac79e(slot) {
    return (0, $8iNDC.default)("MuiTypography", slot);
}
const $f9f0aae8217b908f$var$typographyClasses = (0, $fc1pF.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $f9f0aae8217b908f$export$2e2bcd8739ae039 = $f9f0aae8217b908f$var$typographyClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $f7cbd0ed4c3e5464$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $f7cbd0ed4c3e5464$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $4y4xl.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $f9f0aae8217b908f$export$24c1f8f60cbac79e), classes);
};
const $f7cbd0ed4c3e5464$export$140e2f5526d3cad8 = (0, $jjHhy.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $4y4xl.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $f7cbd0ed4c3e5464$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $f7cbd0ed4c3e5464$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $f7cbd0ed4c3e5464$var$transformDeprecatedColors = (color)=>{
    return $f7cbd0ed4c3e5464$var$colorTransformations[color] || color;
};
const $f7cbd0ed4c3e5464$var$Typography = /*#__PURE__*/ $dup7A.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $f7cbd0ed4c3e5464$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $9qvqC.default)((0, $3G4eg.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $f7cbd0ed4c3e5464$var$defaultVariantMapping } = props, other = (0, $bGxpK.default)(props, $f7cbd0ed4c3e5464$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $f7cbd0ed4c3e5464$var$defaultVariantMapping[variant]) || "span";
    const classes = $f7cbd0ed4c3e5464$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($f7cbd0ed4c3e5464$export$140e2f5526d3cad8, (0, $3G4eg.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className)
    }, other));
});
var $f7cbd0ed4c3e5464$export$2e2bcd8739ae039 = $f7cbd0ed4c3e5464$var$Typography;



var $jjHhy = parcelRequire("jjHhy");
const $d29cf8ced0197b08$var$getButtonTransformWidth = (drawerWidth, drawerMaxWidth)=>{
    if (typeof drawerWidth === "number") return `${drawerWidth}px`;
    if (typeof drawerWidth === "string" && !drawerWidth.includes("%")) return drawerWidth;
    if (typeof drawerMaxWidth === "number") return `${drawerMaxWidth}px`;
    if (typeof drawerMaxWidth === "string" && !drawerMaxWidth.includes("%")) return drawerMaxWidth;
    return "392px";
};
const $d29cf8ced0197b08$export$54ae93b604e45132 = (0, $jjHhy.default)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "open",
            "drawerProps"
        ].includes(prop)
})(({ theme: theme, open: open, drawerProps: drawerProps })=>({
        background: theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white,
        color: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.common.black,
        alignItems: "center",
        borderRadius: `${theme.shape.borderRadiusSecondary}px 0 0 ${theme.shape.borderRadiusSecondary}px`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: 144,
        minWidth: 40,
        padding: theme.spacing(1, 0, 1, 0),
        position: "absolute",
        right: 0,
        top: "calc(50% - 74px)",
        transform: `translate3d(calc(${open ? $d29cf8ced0197b08$var$getButtonTransformWidth(drawerProps?.width, drawerProps?.maxWidth) : "0px"} * -1), 0, 0)`,
        transition: theme.transitions.create([
            "transform"
        ], {
            duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
            easing: open ? theme.transitions.easing.easeOut : theme.transitions.easing.sharp
        }),
        zIndex: 1500,
        "&:hover": {
            background: theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white
        },
        svg: {
            color: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.common.black
        }
    }));
const $d29cf8ced0197b08$export$94875d0613ab57d1 = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039))(({ theme: theme })=>({
        borderRadius: `0 ${theme.shape.borderRadiusSecondary}px ${theme.shape.borderRadiusSecondary}px 0`,
        background: theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white,
        color: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.common.black,
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        padding: theme.spacing(1),
        position: "relative",
        textTransform: "none",
        transform: "rotateZ(180deg)",
        writingMode: "vertical-rl"
    }));
const $d29cf8ced0197b08$export$48a57ef679e574fe = (0, $jjHhy.default)((0, $510dba830cc31c9a$export$2e2bcd8739ae039))(()=>({
        position: "absolute",
        top: "12px",
        right: "26px",
        zIndex: 1,
        height: "40px",
        width: "40px",
        alignItems: "center",
        justifyContent: "center"
    }));



var $dup7A = parcelRequire("dup7A");
const $5b08acff347f037c$export$de4a09415a19ee2c = (0, $dup7A.createContext)({});
const $5b08acff347f037c$export$a95dae48ffdecbeb = ()=>(0, $dup7A.useContext)($5b08acff347f037c$export$de4a09415a19ee2c);



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");


const $ace8c73f6df29a6f$export$7c07b633a151f9c5 = new (0, $05b7f67ee565c164$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            enabled: true,
            staleTime: 3600000,
            cacheTime: Infinity,
            refetchInterval: false,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
            refetchOnMount: true,
            retryOnMount: true,
            // suspense: true,
            onError: (error)=>{
            //
            }
        },
        mutations: {
            onError: (error)=>{
            //
            }
        }
    }
});



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $367773295ca041ba$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $367773295ca041ba$var$isDateObject = (value1)=>value1 instanceof Date;
var $367773295ca041ba$var$isNullOrUndefined = (value1)=>value1 == null;
const $367773295ca041ba$var$isObjectType = (value1)=>typeof value1 === "object";
var $367773295ca041ba$var$isObject = (value1)=>!$367773295ca041ba$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $367773295ca041ba$var$isObjectType(value1) && !$367773295ca041ba$var$isDateObject(value1);
var $367773295ca041ba$var$getEventValue = (event)=>$367773295ca041ba$var$isObject(event) && event.target ? $367773295ca041ba$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $367773295ca041ba$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $367773295ca041ba$var$isNameInFieldArray = (names, name)=>names.has($367773295ca041ba$var$getNodeParentName(name));
var $367773295ca041ba$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $367773295ca041ba$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $367773295ca041ba$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $367773295ca041ba$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($367773295ca041ba$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $367773295ca041ba$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$367773295ca041ba$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $367773295ca041ba$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $367773295ca041ba$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $367773295ca041ba$var$isUndefined = (val)=>val === undefined;
var $367773295ca041ba$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$367773295ca041ba$var$isObject(object)) return defaultValue;
    const result = $367773295ca041ba$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$367773295ca041ba$var$isNullOrUndefined(result) ? result : result[key], object);
    return $367773295ca041ba$var$isUndefined(result) || result === object ? $367773295ca041ba$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $367773295ca041ba$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $367773295ca041ba$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $367773295ca041ba$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $367773295ca041ba$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $367773295ca041ba$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $367773295ca041ba$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useContext($367773295ca041ba$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $367773295ca041ba$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($367773295ca041ba$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $367773295ca041ba$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $367773295ca041ba$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $367773295ca041ba$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $367773295ca041ba$var$isEmptyObject = (value1)=>$367773295ca041ba$var$isObject(value1) && !Object.keys(value1).length;
var $367773295ca041ba$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $367773295ca041ba$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $367773295ca041ba$var$VALIDATION_MODE.all));
};
var $367773295ca041ba$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $367773295ca041ba$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $367773295ca041ba$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $367773295ca041ba$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $367773295ca041ba$export$606f11b2eb45ecc6(props) {
    const methods = $367773295ca041ba$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(name);
    _name.current = name;
    $367773295ca041ba$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $367773295ca041ba$var$shouldSubscribeByName(_name.current, value1.name, exact) && $367773295ca041ba$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $367773295ca041ba$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $367773295ca041ba$var$isString = (value1)=>typeof value1 === "string";
var $367773295ca041ba$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($367773295ca041ba$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $367773295ca041ba$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $367773295ca041ba$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $367773295ca041ba$export$3c773aa2b84f29e0(props) {
    const methods = $367773295ca041ba$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(name);
    _name.current = name;
    $367773295ca041ba$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($367773295ca041ba$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($367773295ca041ba$var$cloneObject($367773295ca041ba$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $367773295ca041ba$var$isKey = (value1)=>/^\w*$/.test(value1);
var $367773295ca041ba$var$stringToPath = (input)=>$367773295ca041ba$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $367773295ca041ba$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $367773295ca041ba$var$isKey(path) ? [
        path
    ] : $367773295ca041ba$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $367773295ca041ba$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $367773295ca041ba$export$e8c786024a2b0a79(props) {
    const methods = $367773295ca041ba$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $367773295ca041ba$var$isNameInFieldArray(control._names.array, name);
    const value1 = $367773295ca041ba$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $367773295ca041ba$export$3988ae62b71be9a3(control._formValues, name, $367773295ca041ba$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $367773295ca041ba$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$367773295ca041ba$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $367773295ca041ba$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $367773295ca041ba$var$cloneObject($367773295ca041ba$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $367773295ca041ba$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($367773295ca041ba$var$isUndefined($367773295ca041ba$export$3988ae62b71be9a3(control._formValues, name))) $367773295ca041ba$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        if ($367773295ca041ba$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $367773295ca041ba$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$367773295ca041ba$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $367773295ca041ba$var$getEventValue(event),
                        name: name
                    },
                    type: $367773295ca041ba$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $367773295ca041ba$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $367773295ca041ba$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $367773295ca041ba$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$367773295ca041ba$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$367773295ca041ba$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$367773295ca041ba$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$367773295ca041ba$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$367773295ca041ba$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $367773295ca041ba$export$bd0bf19f25da8474 = (props)=>props.render($367773295ca041ba$export$e8c786024a2b0a79(props));
const $367773295ca041ba$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $367773295ca041ba$export$a7fed597f4b8afd8(props) {
    const methods = $367773295ca041ba$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $367773295ca041ba$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $367773295ca041ba$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $367773295ca041ba$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $367773295ca041ba$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $367773295ca041ba$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $367773295ca041ba$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$367773295ca041ba$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $367773295ca041ba$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $367773295ca041ba$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $367773295ca041ba$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $367773295ca041ba$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $367773295ca041ba$var$VALIDATION_MODE.all,
        isOnTouch: mode === $367773295ca041ba$var$VALIDATION_MODE.onTouched
    });
var $367773295ca041ba$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $367773295ca041ba$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $367773295ca041ba$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $367773295ca041ba$var$iterateFieldsByAction(currentField, action);
            } else if ($367773295ca041ba$var$isObject(currentField)) $367773295ca041ba$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $367773295ca041ba$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $367773295ca041ba$var$compact($367773295ca041ba$export$3988ae62b71be9a3(errors, name));
    $367773295ca041ba$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $367773295ca041ba$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $367773295ca041ba$var$isFileInput = (element)=>element.type === "file";
var $367773295ca041ba$var$isFunction = (value1)=>typeof value1 === "function";
var $367773295ca041ba$var$isHTMLElement = (value1)=>{
    if (!$367773295ca041ba$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $367773295ca041ba$var$isMessage = (value1)=>$367773295ca041ba$var$isString(value1);
var $367773295ca041ba$var$isRadioInput = (element)=>element.type === "radio";
var $367773295ca041ba$var$isRegex = (value1)=>value1 instanceof RegExp;
const $367773295ca041ba$var$defaultResult = {
    value: false,
    isValid: false
};
const $367773295ca041ba$var$validResult = {
    value: true,
    isValid: true
};
var $367773295ca041ba$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$367773295ca041ba$var$isUndefined(options[0].attributes.value) ? $367773295ca041ba$var$isUndefined(options[0].value) || options[0].value === "" ? $367773295ca041ba$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $367773295ca041ba$var$validResult : $367773295ca041ba$var$defaultResult;
    }
    return $367773295ca041ba$var$defaultResult;
};
const $367773295ca041ba$var$defaultReturn = {
    isValid: false,
    value: null
};
var $367773295ca041ba$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $367773295ca041ba$var$defaultReturn) : $367773295ca041ba$var$defaultReturn;
function $367773295ca041ba$var$getValidateError(result, ref, type = "validate") {
    if ($367773295ca041ba$var$isMessage(result) || Array.isArray(result) && result.every($367773295ca041ba$var$isMessage) || $367773295ca041ba$var$isBoolean(result) && !result) return {
        type: type,
        message: $367773295ca041ba$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $367773295ca041ba$var$getValueAndMessage = (validationData)=>$367773295ca041ba$var$isObject(validationData) && !$367773295ca041ba$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $367773295ca041ba$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $367773295ca041ba$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($367773295ca041ba$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $367773295ca041ba$var$isRadioInput(ref);
    const isCheckBox = $367773295ca041ba$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $367773295ca041ba$var$isFileInput(ref)) && $367773295ca041ba$var$isUndefined(ref.value) && $367773295ca041ba$var$isUndefined(inputValue) || $367773295ca041ba$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $367773295ca041ba$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $367773295ca041ba$var$INPUT_VALIDATION_RULES.maxLength, minType = $367773295ca041ba$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $367773295ca041ba$var$isNullOrUndefined(inputValue)) || $367773295ca041ba$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$367773295ca041ba$var$getCheckboxValue(refs).isValid || isRadio && !$367773295ca041ba$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $367773295ca041ba$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $367773295ca041ba$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $367773295ca041ba$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($367773295ca041ba$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$367773295ca041ba$var$isNullOrUndefined(min) || !$367773295ca041ba$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $367773295ca041ba$var$getValueAndMessage(max);
        const minOutput = $367773295ca041ba$var$getValueAndMessage(min);
        if (!$367773295ca041ba$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$367773295ca041ba$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$367773295ca041ba$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($367773295ca041ba$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($367773295ca041ba$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $367773295ca041ba$var$INPUT_VALIDATION_RULES.max, $367773295ca041ba$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($367773295ca041ba$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $367773295ca041ba$var$getValueAndMessage(maxLength);
        const minLengthOutput = $367773295ca041ba$var$getValueAndMessage(minLength);
        const exceedMax = !$367773295ca041ba$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$367773295ca041ba$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $367773295ca041ba$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $367773295ca041ba$var$getValueAndMessage(pattern);
        if ($367773295ca041ba$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $367773295ca041ba$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($367773295ca041ba$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($367773295ca041ba$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $367773295ca041ba$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($367773295ca041ba$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($367773295ca041ba$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$367773295ca041ba$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $367773295ca041ba$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$367773295ca041ba$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $367773295ca041ba$var$appendAt = (data, value1)=>[
        ...data,
        ...$367773295ca041ba$var$convertToArrayPayload(value1)
    ];
var $367773295ca041ba$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $367773295ca041ba$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$367773295ca041ba$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $367773295ca041ba$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($367773295ca041ba$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $367773295ca041ba$var$prependAt = (data, value1)=>[
        ...$367773295ca041ba$var$convertToArrayPayload(value1),
        ...$367773295ca041ba$var$convertToArrayPayload(data)
    ];
function $367773295ca041ba$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $367773295ca041ba$var$compact(temp).length ? temp : [];
}
var $367773295ca041ba$var$removeArrayAt = (data, index)=>$367773295ca041ba$var$isUndefined(index) ? [] : $367773295ca041ba$var$removeAtIndexes(data, $367773295ca041ba$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $367773295ca041ba$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $367773295ca041ba$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $367773295ca041ba$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $367773295ca041ba$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$367773295ca041ba$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $367773295ca041ba$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $367773295ca041ba$var$isKey(path) ? [
        path
    ] : $367773295ca041ba$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $367773295ca041ba$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($367773295ca041ba$var$isObject(childObject) && $367773295ca041ba$var$isEmptyObject(childObject) || Array.isArray(childObject) && $367773295ca041ba$var$isEmptyArray(childObject))) $367773295ca041ba$var$unset(object, paths.slice(0, -1));
    return object;
}
var $367773295ca041ba$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $367773295ca041ba$export$310131896651d559(props) {
    const methods = $367773295ca041ba$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(control._getFieldArray(name).map($367773295ca041ba$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $367773295ca041ba$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $367773295ca041ba$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($367773295ca041ba$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $367773295ca041ba$var$convertToArrayPayload($367773295ca041ba$var$cloneObject(value1));
        const updatedFieldArrayValues = $367773295ca041ba$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $367773295ca041ba$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $367773295ca041ba$var$appendAt(ids.current, appendValue.map($367773295ca041ba$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$appendAt, {
            argA: $367773295ca041ba$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $367773295ca041ba$var$convertToArrayPayload($367773295ca041ba$var$cloneObject(value1));
        const updatedFieldArrayValues = $367773295ca041ba$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $367773295ca041ba$var$getFocusFieldName(name, 0, options);
        ids.current = $367773295ca041ba$var$prependAt(ids.current, prependValue.map($367773295ca041ba$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$prependAt, {
            argA: $367773295ca041ba$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $367773295ca041ba$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $367773295ca041ba$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $367773295ca041ba$var$convertToArrayPayload($367773295ca041ba$var$cloneObject(value1));
        const updatedFieldArrayValues = $367773295ca041ba$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $367773295ca041ba$var$getFocusFieldName(name, index, options);
        ids.current = $367773295ca041ba$var$insert(ids.current, index, insertValue.map($367773295ca041ba$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$insert, {
            argA: index,
            argB: $367773295ca041ba$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $367773295ca041ba$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $367773295ca041ba$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $367773295ca041ba$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $367773295ca041ba$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $367773295ca041ba$var$cloneObject(value1);
        const updatedFieldArrayValues = $367773295ca041ba$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $367773295ca041ba$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $367773295ca041ba$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $367773295ca041ba$var$convertToArrayPayload($367773295ca041ba$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($367773295ca041ba$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        control._state.action = false;
        $367773295ca041ba$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$367773295ca041ba$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $367773295ca041ba$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $367773295ca041ba$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $367773295ca041ba$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $367773295ca041ba$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $367773295ca041ba$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($367773295ca041ba$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $367773295ca041ba$var$getValidationModes(control._options.mode).isOnSubmit)) $367773295ca041ba$var$validateField(field, control._formValues, control._options.criteriaMode === $367773295ca041ba$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$367773295ca041ba$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $367773295ca041ba$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $367773295ca041ba$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        !$367773295ca041ba$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $367773295ca041ba$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $367773295ca041ba$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $367773295ca041ba$var$isPrimitive = (value1)=>$367773295ca041ba$var$isNullOrUndefined(value1) || !$367773295ca041ba$var$isObjectType(value1);
function $367773295ca041ba$var$deepEqual(object1, object2) {
    if ($367773295ca041ba$var$isPrimitive(object1) || $367773295ca041ba$var$isPrimitive(object2)) return object1 === object2;
    if ($367773295ca041ba$var$isDateObject(object1) && $367773295ca041ba$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($367773295ca041ba$var$isDateObject(val1) && $367773295ca041ba$var$isDateObject(val2) || $367773295ca041ba$var$isObject(val1) && $367773295ca041ba$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$367773295ca041ba$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $367773295ca041ba$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $367773295ca041ba$var$isRadioOrCheckbox = (ref)=>$367773295ca041ba$var$isRadioInput(ref) || $367773295ca041ba$var$isCheckBoxInput(ref);
var $367773295ca041ba$var$live = (ref)=>$367773295ca041ba$var$isHTMLElement(ref) && ref.isConnected;
var $367773295ca041ba$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($367773295ca041ba$var$isFunction(data[key])) return true;
    }
    return false;
};
function $367773295ca041ba$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($367773295ca041ba$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $367773295ca041ba$var$isObject(data[key]) && !$367773295ca041ba$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $367773295ca041ba$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$367773295ca041ba$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $367773295ca041ba$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($367773295ca041ba$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $367773295ca041ba$var$isObject(data[key]) && !$367773295ca041ba$var$objectHasFunction(data[key])) {
            if ($367773295ca041ba$var$isUndefined(formValues) || $367773295ca041ba$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $367773295ca041ba$var$markFieldsDirty(data[key], []) : {
                ...$367773295ca041ba$var$markFieldsDirty(data[key])
            };
            else $367773295ca041ba$var$getDirtyFieldsFromDefaultValues(data[key], $367773295ca041ba$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$367773295ca041ba$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $367773295ca041ba$var$getDirtyFields = (defaultValues, formValues)=>$367773295ca041ba$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $367773295ca041ba$var$markFieldsDirty(formValues));
var $367773295ca041ba$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$367773295ca041ba$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $367773295ca041ba$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $367773295ca041ba$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($367773295ca041ba$var$isFileInput(ref)) return ref.files;
    if ($367773295ca041ba$var$isRadioInput(ref)) return $367773295ca041ba$var$getRadioValue(_f.refs).value;
    if ($367773295ca041ba$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($367773295ca041ba$var$isCheckBoxInput(ref)) return $367773295ca041ba$var$getCheckboxValue(_f.refs).value;
    return $367773295ca041ba$var$getFieldValueAs($367773295ca041ba$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $367773295ca041ba$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        field && $367773295ca041ba$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $367773295ca041ba$var$getRuleValue = (rule)=>$367773295ca041ba$var$isUndefined(rule) ? rule : $367773295ca041ba$var$isRegex(rule) ? rule.source : $367773295ca041ba$var$isObject(rule) ? $367773295ca041ba$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $367773295ca041ba$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $367773295ca041ba$var$schemaErrorLookup(errors, _fields, name) {
    const error = $367773295ca041ba$export$3988ae62b71be9a3(errors, name);
    if (error || $367773295ca041ba$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $367773295ca041ba$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $367773295ca041ba$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $367773295ca041ba$var$unsetEmptyArray = (ref, name)=>!$367773295ca041ba$var$compact($367773295ca041ba$export$3988ae62b71be9a3(ref, name)).length && $367773295ca041ba$var$unset(ref, name);
const $367773295ca041ba$var$defaultOptions = {
    mode: $367773295ca041ba$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $367773295ca041ba$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $367773295ca041ba$var$createFormControl(props = {}) {
    let _options = {
        ...$367773295ca041ba$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $367773295ca041ba$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $367773295ca041ba$var$isObject(_options.defaultValues) || $367773295ca041ba$var$isObject(_options.values) ? $367773295ca041ba$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $367773295ca041ba$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $367773295ca041ba$var$createSubject(),
        array: $367773295ca041ba$var$createSubject(),
        state: $367773295ca041ba$var$createSubject()
    };
    const validationModeBeforeSubmit = $367773295ca041ba$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $367773295ca041ba$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $367773295ca041ba$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $367773295ca041ba$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $367773295ca041ba$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$367773295ca041ba$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($367773295ca041ba$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($367773295ca041ba$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $367773295ca041ba$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($367773295ca041ba$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($367773295ca041ba$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $367773295ca041ba$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($367773295ca041ba$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($367773295ca041ba$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $367773295ca041ba$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $367773295ca041ba$export$3988ae62b71be9a3(_formValues, name, $367773295ca041ba$var$isUndefined(value1) ? $367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $367773295ca041ba$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $367773295ca041ba$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($367773295ca041ba$export$3988ae62b71be9a3(_fields, name) && $367773295ca041ba$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $367773295ca041ba$var$deepEqual($367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $367773295ca041ba$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $367773295ca041ba$var$unset(_formState.dirtyFields, name) : $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $367773295ca041ba$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $367773295ca041ba$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $367773295ca041ba$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $367773295ca041ba$var$unset(_formState.errors, name);
        }
        if ((error ? !$367773295ca041ba$var$deepEqual(previousFieldError, error) : previousFieldError) || !$367773295ca041ba$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $367773295ca041ba$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $367773295ca041ba$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $367773295ca041ba$export$3988ae62b71be9a3(errors, name);
            error ? $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $367773295ca041ba$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $367773295ca041ba$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($367773295ca041ba$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $367773295ca041ba$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $367773295ca041ba$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$367773295ca041ba$var$live(ref)) : !$367773295ca041ba$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, data), !$367773295ca041ba$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$367773295ca041ba$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $367773295ca041ba$var$isUndefined(defaultValue) ? _defaultValues : $367773295ca041ba$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$367773295ca041ba$var$compact($367773295ca041ba$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, $367773295ca041ba$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $367773295ca041ba$var$isHTMLElement(fieldReference.ref) && $367773295ca041ba$var$isNullOrUndefined(value1) ? "" : value1;
                if ($367773295ca041ba$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($367773295ca041ba$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($367773295ca041ba$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$367773295ca041ba$var$isPrimitive(fieldValue) || field && !field._f) && !$367773295ca041ba$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $367773295ca041ba$var$cloneObject(value1);
        $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $367773295ca041ba$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$367773295ca041ba$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $367773295ca041ba$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $367773295ca041ba$var$getFieldValue(field._f) : $367773295ca041ba$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $367773295ca041ba$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $367773295ca041ba$var$EVENTS.BLUR || event.type === $367773295ca041ba$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$367773295ca041ba$var$hasValidation(field._f) && !_options.resolver && !$367773295ca041ba$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $367773295ca041ba$var$skipValidation(isBlurEvent, $367773295ca041ba$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $367773295ca041ba$var$isWatched(name, _names, isBlurEvent);
            $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$367773295ca041ba$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $367773295ca041ba$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $367773295ca041ba$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $367773295ca041ba$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $367773295ca041ba$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($367773295ca041ba$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $367773295ca041ba$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($367773295ca041ba$var$isUndefined(name) ? name : fieldNames);
            isValid = $367773295ca041ba$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$367773295ca041ba$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$367773295ca041ba$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $367773295ca041ba$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $367773295ca041ba$var$isUndefined(fieldNames) ? values : $367773295ca041ba$var$isString(fieldNames) ? $367773295ca041ba$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$367773295ca041ba$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$367773295ca041ba$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$367773295ca041ba$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$367773295ca041ba$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            isValidating: !!$367773295ca041ba$export$3988ae62b71be9a3((formState || _formState).validatingFields, name),
            error: $367773295ca041ba$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $367773295ca041ba$var$convertToArrayPayload(name).forEach((inputName)=>$367773295ca041ba$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($367773295ca041ba$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $367773295ca041ba$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$367773295ca041ba$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $367773295ca041ba$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $367773295ca041ba$var$unset(_fields, fieldName);
                $367773295ca041ba$var$unset(_formValues, fieldName);
            }
            !options.keepError && $367773295ca041ba$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $367773295ca041ba$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $367773295ca041ba$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $367773295ca041ba$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $367773295ca041ba$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($367773295ca041ba$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $367773295ca041ba$var$isUndefined(value1) ? $367773295ca041ba$var$getFieldValue(field ? field._f : $367773295ca041ba$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $367773295ca041ba$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $367773295ca041ba$var$isBoolean(options.disabled);
        $367773295ca041ba$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $367773295ca041ba$var$getRuleValue(options.min),
                max: $367773295ca041ba$var$getRuleValue(options.max),
                minLength: $367773295ca041ba$var$getRuleValue(options.minLength),
                maxLength: $367773295ca041ba$var$getRuleValue(options.maxLength),
                pattern: $367773295ca041ba$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $367773295ca041ba$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $367773295ca041ba$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $367773295ca041ba$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($367773295ca041ba$var$live),
                                    fieldRef,
                                    ...Array.isArray($367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($367773295ca041ba$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $367773295ca041ba$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($367773295ca041ba$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $367773295ca041ba$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $367773295ca041ba$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $367773295ca041ba$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $367773295ca041ba$var$unset(_formState.errors, "root");
            if ($367773295ca041ba$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $367773295ca041ba$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($367773295ca041ba$export$3988ae62b71be9a3(_fields, name)) {
            if ($367773295ca041ba$var$isUndefined(options.defaultValue)) setValue(name, $367773295ca041ba$var$cloneObject($367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $367773295ca041ba$export$adaa4cf7ef1b65be(_defaultValues, name, $367773295ca041ba$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $367773295ca041ba$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $367773295ca041ba$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $367773295ca041ba$var$cloneObject($367773295ca041ba$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $367773295ca041ba$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $367773295ca041ba$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $367773295ca041ba$var$cloneObject(updatedValues);
        const isEmptyResetValues = $367773295ca041ba$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$367773295ca041ba$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $367773295ca041ba$export$adaa4cf7ef1b65be(values, fieldName, $367773295ca041ba$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $367773295ca041ba$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($367773295ca041ba$var$isWeb && $367773295ca041ba$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($367773295ca041ba$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $367773295ca041ba$var$cloneObject(_defaultValues) : {} : $367773295ca041ba$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$367773295ca041ba$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $367773295ca041ba$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $367773295ca041ba$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($367773295ca041ba$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $367773295ca041ba$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$367773295ca041ba$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $367773295ca041ba$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $367773295ca041ba$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $367773295ca041ba$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$367773295ca041ba$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $367773295ca041ba$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($367773295ca041ba$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        if (props.values && !$367773295ca041ba$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $367773295ca041ba$var$getProxyFormState(formState, control);
    return _formControl.current;
}



var $cZGFG = parcelRequire("cZGFG");
// expose types and helpers
var $664d8775a51d964a$export$5d3cfda82f2b887a;
(function(CoinKey) {
    CoinKey["ETH"] = "ETH";
    CoinKey["MATIC"] = "MATIC";
    CoinKey["BNB"] = "BNB";
    CoinKey["DAI"] = "DAI";
    CoinKey["FTM"] = "FTM";
    CoinKey["OKT"] = "OKT";
    CoinKey["AVAX"] = "AVAX";
    CoinKey["HT"] = "HT";
    CoinKey["ONE"] = "ONE";
    CoinKey["FSN"] = "FSN";
    CoinKey["MOVR"] = "MOVR";
    CoinKey["EXP"] = "EXP";
    CoinKey["TCH"] = "TCH";
    CoinKey["UBQ"] = "UBQ";
    CoinKey["META"] = "META";
    CoinKey["DIODE"] = "DIODE";
    CoinKey["CELO"] = "CELO";
    CoinKey["FUSE"] = "FUSE";
    CoinKey["TLOS"] = "TLOS";
    CoinKey["CRO"] = "CRO";
    CoinKey["SHIB"] = "SHIB";
    CoinKey["L1"] = "L1";
    CoinKey["RBTC"] = "RBTC";
    CoinKey["TBG"] = "TBG";
    CoinKey["VLX"] = "VLX";
    CoinKey["GLMR"] = "GLMR";
    CoinKey["METIS"] = "METIS";
    CoinKey["SOL"] = "SOL";
    CoinKey["EVM"] = "EVM";
    // Stable coins
    CoinKey["USDT"] = "USDT";
    CoinKey["USDC"] = "USDC";
    CoinKey["cbtUSDC"] = "cbtUSDC";
    CoinKey["cbtUSDT"] = "cbtUSDT";
    CoinKey["cbtWUSDT"] = "cbtWUSDT";
    CoinKey["cbtWUSDC"] = "cbtWUSDC";
    CoinKey["cbtCELR"] = "cbtCELR";
    CoinKey["BUSD"] = "BUSD";
    CoinKey["USDCe"] = "USDCe";
    // Testnet
    CoinKey["TEST"] = "TEST";
    CoinKey["KAL"] = "KAL";
    CoinKey["SDIODE"] = "SDIODE";
    CoinKey["SPARK"] = "SPARK";
    CoinKey["TRBTC"] = "TRBTC";
    CoinKey["CXTT"] = "CXTT";
    // stargate testnet tokens
    CoinKey["sgMETIS"] = "sgMETIS";
    CoinKey["sgWOO"] = "sgWOO";
    CoinKey["sgUSDT"] = "sgUSDT";
    CoinKey["sgBUSD"] = "sgBUSD";
    CoinKey["sgUSDC"] = "sgUSDC";
    // Other tokens
    CoinKey["WBTC"] = "WBTC";
    CoinKey["WETH"] = "WETH";
    CoinKey["SUSHI"] = "SUSHI";
    CoinKey["DODO"] = "DODO";
    CoinKey["MCB"] = "MCB";
    CoinKey["CELR"] = "CELR";
    CoinKey["IF"] = "IF";
})($664d8775a51d964a$export$5d3cfda82f2b887a || ($664d8775a51d964a$export$5d3cfda82f2b887a = {}));
var $664d8775a51d964a$export$41349f2dc0a89295;
(function(ChainKey) {
    ChainKey["ETH"] = "eth";
    ChainKey["POL"] = "pol";
    ChainKey["BSC"] = "bsc";
    ChainKey["DAI"] = "dai";
    ChainKey["OKT"] = "okt";
    ChainKey["FTM"] = "ftm";
    ChainKey["AVA"] = "ava";
    ChainKey["ARB"] = "arb";
    ChainKey["HEC"] = "hec";
    ChainKey["OPT"] = "opt";
    ChainKey["ONE"] = "one";
    ChainKey["FSN"] = "fsn";
    ChainKey["MOR"] = "mor";
    ChainKey["EXP"] = "exp";
    ChainKey["TCH"] = "tch";
    ChainKey["UBQ"] = "ubq";
    ChainKey["MET"] = "met";
    ChainKey["DIO"] = "dio";
    ChainKey["CEL"] = "cel";
    ChainKey["FUS"] = "fus";
    ChainKey["TLO"] = "tlo";
    ChainKey["CRO"] = "cro";
    ChainKey["BOB"] = "bob";
    ChainKey["SHI"] = "shi";
    ChainKey["GL1"] = "gl1";
    ChainKey["RSK"] = "rsk";
    ChainKey["TBW"] = "tbw";
    ChainKey["VEL"] = "vel";
    ChainKey["MOO"] = "moo";
    ChainKey["MAM"] = "mam";
    ChainKey["AUR"] = "aur";
    ChainKey["TER"] = "ter";
    ChainKey["OAS"] = "oas";
    ChainKey["SOL"] = "sol";
    ChainKey["EVM"] = "evm";
    ChainKey["ARN"] = "arn";
    ChainKey["ERA"] = "era";
    ChainKey["PZE"] = "pze";
    ChainKey["LNA"] = "lna";
    ChainKey["BAS"] = "bas";
    // Testnets
    ChainKey["GOR"] = "gor";
    ChainKey["METT"] = "mett";
    ChainKey["DIOT"] = "diot";
    ChainKey["MUM"] = "mum";
    ChainKey["ARBG"] = "arbg";
    ChainKey["OPTG"] = "optg";
    ChainKey["BSCT"] = "bsct";
    ChainKey["HECT"] = "hect";
    ChainKey["ONET"] = "onet";
    ChainKey["FUST"] = "fust";
    ChainKey["TLOT"] = "tlot";
    ChainKey["RSKT"] = "rskt";
    ChainKey["SOLT"] = "solt";
    ChainKey["OAST"] = "oast";
    ChainKey["TERT"] = "tert";
    ChainKey["AVAT"] = "avat";
    ChainKey["EVMT"] = "evmt";
    ChainKey["MORT"] = "mort";
    ChainKey["FTMT"] = "ftmt";
    ChainKey["LNAT"] = "lnat";
})($664d8775a51d964a$export$41349f2dc0a89295 || ($664d8775a51d964a$export$41349f2dc0a89295 = {}));
var $664d8775a51d964a$export$c06e1e7429de6283;
(function(ChainId) {
    ChainId[ChainId["ETH"] = 1] = "ETH";
    ChainId[ChainId["POL"] = 137] = "POL";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["DAI"] = 100] = "DAI";
    ChainId[ChainId["OKT"] = 66] = "OKT";
    ChainId[ChainId["FTM"] = 250] = "FTM";
    ChainId[ChainId["AVA"] = 43114] = "AVA";
    ChainId[ChainId["ARB"] = 42161] = "ARB";
    ChainId[ChainId["HEC"] = 128] = "HEC";
    ChainId[ChainId["OPT"] = 10] = "OPT";
    ChainId[ChainId["ONE"] = 1666600000] = "ONE";
    ChainId[ChainId["FSN"] = 32659] = "FSN";
    ChainId[ChainId["MOR"] = 1285] = "MOR";
    ChainId[ChainId["EXP"] = 2] = "EXP";
    ChainId[ChainId["TCH"] = 7] = "TCH";
    ChainId[ChainId["UBQ"] = 8] = "UBQ";
    ChainId[ChainId["MET"] = 11] = "MET";
    ChainId[ChainId["DIO"] = 15] = "DIO";
    ChainId[ChainId["CEL"] = 42220] = "CEL";
    ChainId[ChainId["FUS"] = 122] = "FUS";
    ChainId[ChainId["TLO"] = 40] = "TLO";
    ChainId[ChainId["CRO"] = 25] = "CRO";
    ChainId[ChainId["BOB"] = 288] = "BOB";
    ChainId[ChainId["SHI"] = 27] = "SHI";
    ChainId[ChainId["GL1"] = 29] = "GL1";
    ChainId[ChainId["RSK"] = 30] = "RSK";
    ChainId[ChainId["TBW"] = 35] = "TBW";
    ChainId[ChainId["VEL"] = 106] = "VEL";
    ChainId[ChainId["MOO"] = 1284] = "MOO";
    ChainId[ChainId["MAM"] = 1088] = "MAM";
    ChainId[ChainId["AUR"] = 1313161554] = "AUR";
    ChainId[ChainId["SOL"] = 1151111081099710] = "SOL";
    ChainId[ChainId["TER"] = 1161011141099710] = "TER";
    ChainId[ChainId["OAS"] = 111971151099710] = "OAS";
    ChainId[ChainId["EVM"] = 9001] = "EVM";
    ChainId[ChainId["ARN"] = 42170] = "ARN";
    ChainId[ChainId["ERA"] = 324] = "ERA";
    ChainId[ChainId["PZE"] = 1101] = "PZE";
    ChainId[ChainId["LNA"] = 59144] = "LNA";
    ChainId[ChainId["BAS"] = 8453] = "BAS";
    // Testnets
    ChainId[ChainId["GOR"] = 5] = "GOR";
    ChainId[ChainId["METT"] = 12] = "METT";
    ChainId[ChainId["DIOT"] = 13] = "DIOT";
    ChainId[ChainId["MUM"] = 80001] = "MUM";
    ChainId[ChainId["ARBG"] = 421613] = "ARBG";
    ChainId[ChainId["OPTG"] = 420] = "OPTG";
    ChainId[ChainId["BSCT"] = 97] = "BSCT";
    ChainId[ChainId["HECT"] = 256] = "HECT";
    ChainId[ChainId["ONET"] = 1666700000] = "ONET";
    ChainId[ChainId["FUST"] = 123] = "FUST";
    ChainId[ChainId["TLOT"] = 41] = "TLOT";
    ChainId[ChainId["RSKT"] = 31] = "RSKT";
    ChainId[ChainId["SOLT"] = 1151111081161011] = "SOLT";
    ChainId[ChainId["TERT"] = 1161011141161011] = "TERT";
    ChainId[ChainId["OAST"] = 1119711511610111] = "OAST";
    ChainId[ChainId["AVAT"] = 43113] = "AVAT";
    ChainId[ChainId["EVMT"] = 9000] = "EVMT";
    ChainId[ChainId["MORT"] = 1287] = "MORT";
    ChainId[ChainId["FTMT"] = 4002] = "FTMT";
    ChainId[ChainId["LNAT"] = 59140] = "LNAT";
})($664d8775a51d964a$export$c06e1e7429de6283 || ($664d8775a51d964a$export$c06e1e7429de6283 = {}));


/**
 * @deprecated
 * These values are now obtainable from the LI.FI API
 */ var $a9b32801196f922a$export$307469e715db6d2c;
(function(BridgeTool) {
    BridgeTool["connext"] = "connext";
    BridgeTool["hop"] = "hop";
    BridgeTool["multichain"] = "multichain";
    BridgeTool["cbridge"] = "cbridge";
    BridgeTool["hyphen"] = "hyphen";
    BridgeTool["polygon"] = "polygon";
    BridgeTool["arbitrum"] = "arbitrum";
    BridgeTool["avalanche"] = "avalanche";
    BridgeTool["optimism"] = "optimism";
    BridgeTool["across"] = "across";
    BridgeTool["portal"] = "portal";
    BridgeTool["stargate"] = "stargate";
})($a9b32801196f922a$export$307469e715db6d2c || ($a9b32801196f922a$export$307469e715db6d2c = {}));
const $a9b32801196f922a$export$550457157f2937e7 = [
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.connext,
        name: "Connext",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/connext.png",
        bridgeUrl: "https://xpollinate.io/",
        discordUrl: "https://chat.connext.network/",
        supportUrl: "https://www.notion.so/connext/Connext-NXTP-Support-19a357ebabdd4e888cfcd138fe3e4644",
        docsUrl: "https://docs.connext.network/",
        explorerUrl: "https://connextscan.io/",
        analyticsUrl: "https://connextscan.io/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.hop,
        name: "Hop",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/hop.png",
        bridgeUrl: "https://app.hop.exchange/",
        discordUrl: "https://discord.gg/PwCF88emV4",
        supportUrl: "https://help.hop.exchange/hc/en-us",
        docsUrl: "https://docs.hop.exchange/",
        explorerUrl: "https://explorer.hop.exchange/mainnet/",
        analyticsUrl: "https://explorer.hop.exchange/mainnet/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.multichain,
        name: "Multichain",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/anyswap.png",
        bridgeUrl: "https://app.multichain.org/",
        // discordUrl: '',
        supportUrl: "https://multichain.zendesk.com/hc/en-us",
        docsUrl: "https://docs.multichain.org/",
        explorerUrl: "https://anyswap.net/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.cbridge,
        name: "cBridge",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/cbridge.png",
        bridgeUrl: "https://cbridge.celer.network/",
        discordUrl: "https://discord.com/invite/uGx4fjQ",
        supportUrl: "https://form.typeform.com/to/Q4LMjUaK",
        docsUrl: "https://cbridge-docs.celer.network/",
        // explorerUrl: '',
        analyticsUrl: "https://cbridge-analytics.celer.network/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.hyphen,
        name: "Hyphen",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/hyphen.png",
        bridgeUrl: "https://hyphen.biconomy.io/",
        discordUrl: "https://discord.com/invite/HKHxgyEExQ",
        supportUrl: "https://discord.com/invite/HKHxgyEExQ",
        docsUrl: "https://docs.biconomy.io/products/hyphen-instant-cross-chain-transfers",
        // explorerUrl: '',
        analyticsUrl: "https://hyphen-info.biconomy.io/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.polygon,
        name: "Polygon Bridge (PoS)",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/polygon.png",
        bridgeUrl: "https://wallet.polygon.technology/bridge",
        // discordUrl: '',
        supportUrl: "https://forum.matic.network/",
        docsUrl: "https://docs.polygon.technology/docs/develop/ethereum-polygon/pos/getting-started"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.arbitrum,
        name: "Arbitrum Bridge",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/arbitrum.png",
        bridgeUrl: "https://bridge.arbitrum.io/",
        discordUrl: "https://discord.gg/ZpZuw7p",
        supportUrl: "https://discord.gg/ZpZuw7p",
        docsUrl: "https://developer.offchainlabs.com/docs/bridging_assets"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.avalanche,
        name: "AVAX Bridge",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/avalanche.png",
        bridgeUrl: "https://bridge.avax.network/",
        discordUrl: "https://chat.avalabs.org/",
        supportUrl: "https://docs.avax.network/learn/avalanche-bridge-faq/",
        docsUrl: "https://docs.avax.network/learn/avalanche-bridge-faq/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.optimism,
        name: "Optimism Gateway",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/optimism.png",
        bridgeUrl: "https://gateway.optimism.io/",
        discordUrl: "https://discord.com/invite/jrnFEvq",
        supportUrl: "https://discord.com/invite/jrnFEvq",
        docsUrl: "https://community.optimism.io/docs/developers/bridge/basics/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.across,
        name: "Across",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/acrossv2.png",
        bridgeUrl: "https://across.to/",
        discordUrl: "https://discord.gg/t4SZySkn",
        supportUrl: "https://discord.gg/t4SZySkn",
        docsUrl: "https://docs.across.to/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.portal,
        name: "Wormhole Portal",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/bridges/wormhole_portal.png",
        bridgeUrl: "https://portalbridge.com/",
        discordUrl: "https://discord.com/invite/wormholecrypto",
        supportUrl: "https://discord.com/invite/wormholecrypto",
        docsUrl: "https://docs.wormholenetwork.com/wormhole/"
    },
    {
        key: $a9b32801196f922a$export$307469e715db6d2c.stargate,
        name: "Stargate",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/5685c638772f533edad80fcb210b4bb89e30a50f/src/assets/icons/bridges/stargate.png",
        bridgeUrl: "https://stargate.finance/",
        discordUrl: "https://discord.com/invite/TyjeQ45",
        supportUrl: "https://discord.com/invite/TyjeQ45",
        docsUrl: "https://stargateprotocol.gitbook.io/stargate/"
    }
];


var $90ba2aa90df69a91$export$feb52200d964722b;
(function(ChainType) {
    ChainType["EVM"] = "EVM";
    // Solana virtual machine
    ChainType["SVM"] = "SVM";
})($90ba2aa90df69a91$export$feb52200d964722b || ($90ba2aa90df69a91$export$feb52200d964722b = {}));


/*
    This file is for legacy compatibility only.
    Data regarding supported chains *should* be fetched from the API.
    This file is only used to provide legacy compatibility for existing tools.
*/ 

const $846e8dc226ba78a9$export$623c94a6c41a6ddd = {
    // Mainnet
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FSN]: "0x0769fd68dFb93167989C6f7254cd0D766Fb2841F",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MAM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MET]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).RSK]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: "0x6ede559F2Bd951777470595761672091CCD21Ac6",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).PZE]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA]: "0xF9cda624FBC7e059355ce98a31693d299FACd963",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARN]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    // TODO
    // [ChainId.EXP]: '', // TODO
    // [ChainId.TCH]: '', // TODO
    // [ChainId.UBQ]: '', // TODO
    // [ChainId.DIO]: '', // TODO
    // [ChainId.TLO]: '', // TODO
    // [ChainId.SHI]: '', // TODO
    // [ChainId.GL1]: '', // TODO
    // [ChainId.TBW]: '', // TODO
    // [ChainId.PALM]: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
    // [ChainId.TELOS]: '0xdDCbf776dF3dE60163066A5ddDF2277cB445E0F3',
    // Testnet
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET]: "0xdDCbf776dF3dE60163066A5ddDF2277cB445E0F3",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVAT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVMT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MORT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTMT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).RSKT]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: "0xcA11bde05977b3631167028862bE2a173976CA11",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: "0xcA11bde05977b3631167028862bE2a173976CA11"
};




var $e0Utj = parcelRequire("e0Utj");
const $e2010b7659416a79$export$aecf6aa8f33b547c = (chainId)=>{
    return "0x" + (0, $e0Utj.BigNumber).from(chainId)._hex.split("0x")[1].replace(/\b0+/g, "");
};


const $5cec60a38f74f6e4$export$451e2796b12d86dc = [
    // 1 - Ethereum
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ETH,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Ethereum",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 1,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/ethereum.svg",
        tokenlistUrl: "https://gateway.ipfs.io/ipns/tokens.uniswap.org",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1),
            blockExplorerUrls: [
                "https://etherscan.io/"
            ],
            chainName: "Ethereum Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
            ]
        }
    },
    // 137 - Polygon
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).POL,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Polygon",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MATIC,
        id: 137,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/polygon.svg",
        tokenlistUrl: "https://unpkg.com/quickswap-default-token-list@1.0.71/build/quickswap-default.tokenlist.json",
        faucetUrls: [
            "https://stakely.io/faucet/polygon-matic"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).POL],
        // https://docs.matic.network/docs/develop/metamask/config-matic/
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(137),
            blockExplorerUrls: [
                "https://polygonscan.com/",
                "https://explorer-mainnet.maticvigil.com/"
            ],
            chainName: "Matic(Polygon) Mainnet",
            nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18
            },
            rpcUrls: [
                "https://polygon-rpc.com/",
                "https://rpc-mainnet.maticvigil.com/"
            ]
        }
    },
    // 56 - Binance Smart Chain
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).BSC,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "BSC",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BNB,
        id: 56,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/bsc.svg",
        tokenlistUrl: "https://tokens.pancakeswap.finance/pancakeswap-extended.json",
        faucetUrls: [
            "https://stakely.io/faucet/bsc-chain-bnb"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC],
        // https://docs.binance.org/smart-chain/wallet/metamask.html
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(56),
            blockExplorerUrls: [
                "https://bscscan.com/"
            ],
            chainName: "Binance Smart Chain Mainnet",
            nativeCurrency: {
                name: "BNB",
                symbol: "BNB",
                decimals: 18
            },
            rpcUrls: [
                "https://bsc-dataseed.binance.org/",
                "https://bsc-dataseed1.defibit.io/",
                "https://bsc-dataseed1.ninicoin.io/"
            ]
        }
    },
    // 100 - Gnosis
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).DAI,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Gnosis",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI,
        id: 100,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/gnosis.svg",
        tokenlistUrl: "https://tokens.honeyswap.org/",
        faucetUrls: [
            "https://stakely.io/faucet/xdai-chain"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI],
        // https://www.xdaichain.com/for-users/wallets/metamask/metamask-setup
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(100),
            blockExplorerUrls: [
                "https://blockscout.com/xdai/mainnet/"
            ],
            chainName: "Gnosis Chain",
            nativeCurrency: {
                name: "xDai",
                symbol: "xDai",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.gnosischain.com/",
                "https://rpc.ankr.com/gnosis",
                "https://xdai-rpc.gateway.pokt.network"
            ]
        }
    },
    // 250 - Fantom
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).FTM,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Fantom",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FTM,
        id: 250,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/fantom.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/SpookySwap/spooky-info/master/src/constants/token/spookyswap.json",
        faucetUrls: [
            "https://stakely.io/faucet/fantom-blockchain-ftm",
            "https://docs.spookyswap.finance/getting-started/how-to-get-fantom-gas"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM],
        // https://docs.fantom.foundation/tutorials/set-up-metamask
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(250),
            blockExplorerUrls: [
                "https://ftmscan.com/"
            ],
            chainName: "Fantom Opera",
            nativeCurrency: {
                name: "FTM",
                symbol: "FTM",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.ftm.tools/",
                "https://rpcapi.fantom.network"
            ]
        }
    },
    // 66 - OKXChain
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).OKT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "OKXChain",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).OKT,
        id: 66,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/okx.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/okex.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT],
        // https://okc-docs.readthedocs.io/en/latest/developers/quick-start-for-mainnet.html
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(66),
            blockExplorerUrls: [
                "https://www.oklink.com/en/okc/"
            ],
            chainName: "OKXChain Mainnet",
            nativeCurrency: {
                name: "OKT",
                symbol: "OKT",
                decimals: 18
            },
            rpcUrls: [
                "https://exchainrpc.okex.org"
            ]
        }
    },
    // 43114 - Avalanche
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).AVA,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Avalanche",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).AVAX,
        id: 43114,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/avalanche.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/avalanche.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA],
        // https://support.avax.network/en/articles/4626956-how-do-i-set-up-metamask-on-avalanche
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(43114),
            blockExplorerUrls: [
                "https://cchain.explorer.avax.network/"
            ],
            chainName: "Avalanche Mainnet",
            nativeCurrency: {
                name: "AVAX",
                symbol: "AVAX",
                decimals: 18
            },
            rpcUrls: [
                "https://api.avax.network/ext/bc/C/rpc"
            ]
        }
    },
    // 42161 - Arbitrum
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ARB,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Arbitrum",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 42161,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/arbitrum.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/arbitrum.json",
        faucetUrls: [
            "https://bridge.arbitrum.io/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(42161),
            blockExplorerUrls: [
                "https://arbiscan.io/"
            ],
            chainName: "Arbitrum",
            nativeCurrency: {
                name: "AETH",
                symbol: "AETH",
                decimals: 18
            },
            rpcUrls: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    // 128 - Huobi ECO Chain Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).HEC,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Huobi ECO Chain Mainnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).HT,
        id: 128,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/heco.png",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/heco.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(128),
            blockExplorerUrls: [
                "https://hecoinfo.com/"
            ],
            chainName: "Huobi ECO Chain Mainnet",
            nativeCurrency: {
                name: "HT",
                symbol: "HT",
                decimals: 18
            },
            rpcUrls: [
                "https://http-mainnet.hecochain.com"
            ]
        }
    },
    // 10 - Optimism
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).OPT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Optimism",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 10,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/optimism.svg",
        tokenlistUrl: "https://static.optimism.io/optimism.tokenlist.json",
        faucetUrls: [
            "https://gateway.optimism.io/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(10),
            blockExplorerUrls: [
                "https://optimistic.etherscan.io/"
            ],
            chainName: "Optimism",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.optimism.io/"
            ]
        }
    },
    // 32659 - Fusion (anyswap)
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).FSN,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Fusion Mainnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FSN,
        id: 32659,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/fusion.png",
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).FSN],
        // https://support.avax.network/en/articles/4626956-how-do-i-set-up-metamask-on-avalanche
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(32659),
            blockExplorerUrls: [
                "https://fsnex.com/"
            ],
            chainName: "Fusion Mainnet",
            nativeCurrency: {
                name: "FSN",
                symbol: "FSN",
                decimals: 18
            },
            rpcUrls: [
                "https://fsnmainnet2.anyswap.exchange"
            ]
        }
    },
    // 1666600000 - Harmony Mainnet Shard 0
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ONE,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Harmony",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ONE,
        id: 1666600000,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/harmony.svg",
        tokenlistUrl: "https://d1xrz6ki9z98vb.cloudfront.net/venomswap/lists/venomswap-default.tokenlist.json",
        faucetUrls: [
            "https://stakely.io/faucet/harmony-one"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE],
        // https://docs.harmony.one/home/developers/wallets/metamask/connect-metamask-to-the-harmony-chain
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1666600000),
            blockExplorerUrls: [
                "https://explorer.harmony.one/"
            ],
            chainName: "Harmony Mainnet Shard 0",
            nativeCurrency: {
                name: "ONE",
                symbol: "ONE",
                decimals: 18
            },
            rpcUrls: [
                "https://api.harmony.one"
            ]
        }
    },
    // 1285 - Moonriver
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).MOR,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Moonriver",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MOVR,
        id: 1285,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/moonriver.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/moonriver.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1285),
            blockExplorerUrls: [
                "https://blockscout.moonriver.moonbeam.network/"
            ],
            chainName: "Moonriver",
            nativeCurrency: {
                name: "Moonriver",
                symbol: "MOVR",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.api.moonriver.moonbeam.network"
            ]
        }
    },
    // 1284 Moonbeam
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).MOO,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Moonbeam",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).GLMR,
        id: 1284,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/moonbeam.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/BeamSwap/beamswap-tokenlist/main/tokenlist.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1284),
            blockExplorerUrls: [
                "https://blockscout.moonbeam.network/"
            ],
            chainName: "Moonbeam",
            nativeCurrency: {
                name: "GLMR",
                symbol: "GLMR",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.api.moonbeam.network"
            ]
        }
    },
    // 2 - Expanse Network
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).EXP,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Expanse Network",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).EXP,
        id: 2,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/expanse.png",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).EXP],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(2),
            blockExplorerUrls: [
                "https://expanse.tech/"
            ],
            chainName: "Expanse Network",
            nativeCurrency: {
                name: "EXP",
                symbol: "EXP",
                decimals: 18
            },
            rpcUrls: [
                "https://node.expanse.tech"
            ]
        }
    },
    // 7 - ThaiChain
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).TCH,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "ThaiChain",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TCH,
        id: 7,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).TCH],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(7),
            blockExplorerUrls: [
                "https://thaichain.io/"
            ],
            chainName: "ThaiChain",
            nativeCurrency: {
                name: "TCH",
                symbol: "TCH",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.dome.cloud/"
            ]
        }
    },
    // 8 - Ubiq
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).UBQ,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Ubiq",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).UBQ,
        id: 8,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).UBQ],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(8),
            blockExplorerUrls: [
                "https://ubiqscan.io/"
            ],
            chainName: "Ubiq",
            nativeCurrency: {
                name: "UBQ",
                symbol: "UBQ",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.octano.dev/"
            ]
        }
    },
    // 11 - Metadium Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).MET,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Metadium Mainnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).META,
        id: 11,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).MET],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(11),
            blockExplorerUrls: [
                "https://metadium.com/"
            ],
            chainName: "Metadium Mainnet",
            nativeCurrency: {
                name: "META",
                symbol: "META",
                decimals: 18
            },
            rpcUrls: [
                "https://api.metadium.com/prod"
            ]
        }
    },
    // 15 - Diode Prenet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).DIO,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "DIODE",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).DIODE,
        id: 15,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).DIO],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(15),
            blockExplorerUrls: [
                "https://diode.io/prenet/"
            ],
            chainName: "Diode Prenet",
            nativeCurrency: {
                name: "Diodes",
                symbol: "DIODE",
                decimals: 18
            },
            rpcUrls: [
                "https://prenet.diode.io:8443/"
            ]
        }
    },
    // 42220 Celo Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).CEL,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "CELO",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELO,
        id: 42220,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/celo.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/celo.json",
        faucetUrls: [
            "https://stakely.io/faucet/celo-platform",
            "https://free-online-app.com/faucet-for-eth-evm-chains/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(42220),
            blockExplorerUrls: [
                "https://explorer.celo.org/"
            ],
            chainName: "Celo Mainnet",
            nativeCurrency: {
                name: "CELO",
                symbol: "CELO",
                decimals: 18
            },
            rpcUrls: [
                "https://forno.celo.org"
            ]
        }
    },
    // 122 Fuse Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).FUS,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "FUSE",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FUSE,
        id: 122,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/fuse.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/fuse.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(122),
            blockExplorerUrls: [
                "https://explorer.fuse.io/"
            ],
            chainName: "Fuse Mainnet",
            nativeCurrency: {
                name: "FUSE",
                symbol: "FUSE",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.fuse.io"
            ]
        }
    },
    // 40 Telos EVM Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).TLO,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Telos",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TLOS,
        id: 40,
        mainnet: true,
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/default-token-list/master/tokens/telos.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).TLO],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(40),
            blockExplorerUrls: [
                "https://telos.net/"
            ],
            chainName: "Telos EVM Mainnet",
            nativeCurrency: {
                name: "Telos",
                symbol: "TLOS",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.telos.net/evm"
            ]
        }
    },
    // 25 Cronos Mainnet Beta
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).CRO,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Cronos",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CRO,
        id: 25,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/cronos.svg",
        tokenlistUrl: "https://raw.githubusercontent.com/cronaswap/cronaswap-tokenlists/main/cronaswap-default.tokenlist.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(25),
            blockExplorerUrls: [
                "https://cronos.crypto.org/explorer/"
            ],
            chainName: "Cronos",
            nativeCurrency: {
                name: "Crypto.org Coin",
                symbol: "CRO",
                decimals: 18
            },
            rpcUrls: [
                "https://evm-cronos.crypto.org"
            ]
        }
    },
    // 288 Boba Network
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).BOB,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Boba",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 288,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/boba.png",
        // TODO: we should update token list url to latest one
        tokenlistUrl: "https://raw.githubusercontent.com/OolongSwap/boba-community-token-list/main/build/boba.tokenlist.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(288),
            blockExplorerUrls: [
                "https://blockexplorer.boba.network/"
            ],
            chainName: "Boba",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.boba.network/"
            ]
        }
    },
    // 27 ShibaChain
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).SHI,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Shiba",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SHIB,
        id: 27,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).SHI],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(27),
            blockExplorerUrls: [
                "https://exp.shibachain.net/"
            ],
            chainName: "Shiba",
            nativeCurrency: {
                name: "SHIB",
                symbol: "SHIB",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.shibachain.net"
            ]
        }
    },
    // 29 Genesis L1
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).GL1,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Genesis L1",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).L1,
        id: 29,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).GL1],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(29),
            blockExplorerUrls: [
                "https://explorer.genesisl1.org/"
            ],
            chainName: "Genesis L1",
            nativeCurrency: {
                name: "L1",
                symbol: "L1",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.genesisl1.org"
            ]
        }
    },
    // 30 RSK Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).RSK,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "RSK Mainnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).RBTC,
        id: 30,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).RSK],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(30),
            blockExplorerUrls: [
                "https://explorer.rsk.co/"
            ],
            chainName: "RSK Mainnet",
            nativeCurrency: {
                name: "RBTC",
                symbol: "RBTC",
                decimals: 18
            },
            rpcUrls: [
                "https://public-node.rsk.co"
            ]
        }
    },
    // 35 TBWG Chain
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).TBW,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "TBWG",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TBG,
        id: 35,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).TBW],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(35),
            blockExplorerUrls: [
                "https://tbwg.io/"
            ],
            chainName: "TBWG",
            nativeCurrency: {
                name: "TBG",
                symbol: "TBG",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.tbwg.io"
            ]
        }
    },
    // 106 Velas EVM Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).VEL,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Velas",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).VLX,
        id: 106,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL],
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/velas.png",
        faucetUrls: [
            "https://stakely.io/faucet/velas-vlx"
        ],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(106),
            blockExplorerUrls: [
                "https://evmexplorer.velas.com/"
            ],
            chainName: "Velas",
            nativeCurrency: {
                name: "VLX",
                symbol: "VLX",
                decimals: 18
            },
            rpcUrls: [
                "https://evmexplorer.velas.com/rpc"
            ]
        }
    },
    // 1088 Metis Andromeda Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).MAM,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Metis",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).METIS,
        id: 1088,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/metis.png",
        tokenlistUrl: "https://raw.githubusercontent.com/digitalnativeinc/default-token-list/dnf/tokens/metis.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).MAM],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1088),
            blockExplorerUrls: [
                "https://andromeda-explorer.metis.io/"
            ],
            chainName: "Metis",
            nativeCurrency: {
                name: "METIS",
                symbol: "METIS",
                decimals: 18
            },
            rpcUrls: [
                "https://andromeda.metis.io/?owner=1088"
            ]
        }
    },
    // 1313161554 Aurora Mainnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).AUR,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Aurora",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 1313161554,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/aurora.png",
        tokenlistUrl: "https://aurora.dev/tokens.json",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1313161554),
            blockExplorerUrls: [
                "https://aurorascan.dev/"
            ],
            chainName: "Aurora",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.aurora.dev"
            ]
        }
    },
    // EVM = 9001,
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).EVM,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Evmos",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).EVM,
        id: 9001,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/evmos.svg",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(9001),
            blockExplorerUrls: [
                "https://evm.evmos.org/"
            ],
            chainName: "Evmos",
            nativeCurrency: {
                name: "EVMOS",
                symbol: "EVMOS",
                decimals: 18
            },
            rpcUrls: [
                "https://eth.bd.evmos.org:8545"
            ]
        }
    },
    // 324 - zksync ERA
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ERA,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "zkSync Era",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 324,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/zksync.svg",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(324),
            blockExplorerUrls: [
                "https://explorer.zksync.io/"
            ],
            chainName: "zkSync Era Mainnet",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.era.zksync.io"
            ]
        }
    },
    // 1101 - Polygon zkEVM
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).PZE,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Polygon zkEVM",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 1101,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/zkevm.png",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).PZE],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1101),
            blockExplorerUrls: [
                "https://zkevm.polygonscan.com/"
            ],
            chainName: "Polygon zkEVM",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://zkevm-rpc.com"
            ]
        }
    },
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).BAS,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "BASE",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 8453,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/base.svg",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(8453),
            blockExplorerUrls: [
                "https://basescan.org/"
            ],
            chainName: "BASE",
            nativeCurrency: {
                name: "Ethereum",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://mainnet.base.org"
            ]
        }
    },
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).LNA,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Linea",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 59144,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/linea.svg",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(59144),
            blockExplorerUrls: [
                "https://lineascan.build/"
            ],
            chainName: "LINEA",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.linea.build"
            ]
        }
    },
    // TESTNETS
    // 5 - Goerli
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).GOR,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Goerli",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 5,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/ethereum_goerli.png",
        tokenlistUrl: "https://raw.githubusercontent.com/compound-finance/token-list/master/compound.tokenlist.json",
        faucetUrls: [
            "https://goerli-faucet.slock.it/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(5),
            blockExplorerUrls: [
                "https://goerli.etherscan.io/"
            ],
            chainName: "Ethereum Testnet G\xf6rli",
            nativeCurrency: {
                name: "ETH",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        }
    },
    // 12 - Metadium Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).METT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Metadium Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).KAL,
        id: 12,
        mainnet: false,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).METT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(12),
            blockExplorerUrls: [
                "https://metadium.com/"
            ],
            chainName: "Metadium Testnet",
            nativeCurrency: {
                name: "KAL",
                symbol: "KAL",
                decimals: 18
            },
            rpcUrls: [
                "https://api.metadium.com/dev"
            ]
        }
    },
    // 13 - Diode Testnet Staging
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).DIOT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "DIODE",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SDIODE,
        id: 13,
        mainnet: false,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).DIOT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(13),
            blockExplorerUrls: [
                "https://diode.io/staging/"
            ],
            chainName: "Diode Testnet Staging",
            nativeCurrency: {
                name: "Staging Diodes",
                symbol: "sDIODE",
                decimals: 18
            },
            rpcUrls: [
                "https://staging.diode.io:8443/"
            ]
        }
    },
    // 80001 - Mumbai Polygon Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).MUM,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Polygon Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MATIC,
        id: 80001,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/polygon_test.png",
        tokenlistUrl: "https://raw.githubusercontent.com/elkfinance/tokens/main/mumbai.tokenlist.json",
        faucetUrls: [
            "https://faucet.matic.network/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(80001),
            blockExplorerUrls: [
                "https://explorer-mumbai.maticvigil.com/"
            ],
            chainName: "Matic(Polygon) Testnet Mumbai",
            nativeCurrency: {
                name: "MATIC",
                symbol: "tMATIC",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc-mumbai.matic.today"
            ]
        }
    },
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ARBG,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Arbitrum G\xf6rli",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 421613,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/arbitrum_test.png",
        faucetUrls: [
            "https://bridge.arbitrum.io/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(421613),
            blockExplorerUrls: [
                "https://goerli-rollup-explorer.arbitrum.io/"
            ],
            chainName: "Arbitrum G\xf6rli",
            nativeCurrency: {
                name: "AGOR",
                symbol: "AGOR",
                decimals: 18
            },
            rpcUrls: [
                "https://goerli-rollup.arbitrum.io/rpc/	"
            ]
        }
    },
    // 420 - Optimistic Ethereum (Goerli)
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).OPTG,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Optimistic Ethereum Testnet Goerli",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 420,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/optimism_test.png",
        faucetUrls: [
            "https://gateway.optimism.io/"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(420),
            blockExplorerUrls: [
                "https://blockscout.com/optimism/goerli/"
            ],
            chainName: "Optimistic Ethereum Testnet Goerli",
            nativeCurrency: {
                name: "tETH",
                symbol: "tETH",
                decimals: 18
            },
            rpcUrls: [
                "https://goerli.optimism.io/"
            ]
        }
    },
    // 97 - Binance Smart Chain Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).BSCT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Binance Smart Chain Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BNB,
        id: 97,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/bsc_test.png",
        faucetUrls: [
            "https://testnet.binance.org/faucet-smart"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(97),
            blockExplorerUrls: [
                "https://testnet.bscscan.com/"
            ],
            chainName: "Binance Smart Chain Testnet",
            nativeCurrency: {
                name: "tBNB",
                symbol: "tBNB",
                decimals: 18
            },
            rpcUrls: [
                "https://data-seed-prebsc-1-s1.binance.org:8545/"
            ]
        }
    },
    // 256 - Huobi ECO Chain Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).HECT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Huobi ECO Chain Testnet",
        coin: "HTT",
        id: 256,
        mainnet: false,
        faucetUrls: [
            "https://scan-testnet.hecochain.com/faucet"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).HECT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(256),
            blockExplorerUrls: [
                "https://scan-testnet.hecochain.com/"
            ],
            chainName: "Huobi ECO Chain Testnet",
            nativeCurrency: {
                name: "HT",
                symbol: "HT",
                decimals: 18
            },
            rpcUrls: [
                "https://http-testnet.hecochain.com"
            ]
        }
    },
    // 1666700000 - Harmony Testnet 0
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).ONET,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Harmony Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ONE,
        id: 1666700000,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/harmony_test.png",
        // https://docs.harmony.one/home/developers/wallets/metamask/connect-metamask-to-the-harmony-chain
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(1666700000),
            blockExplorerUrls: [
                "https://explorer.pops.one/",
                "https://explorer.testnet.harmony.one/"
            ],
            chainName: "Harmony Testnet Shard 0",
            nativeCurrency: {
                name: "ONE",
                symbol: "ONE",
                decimals: 18
            },
            rpcUrls: [
                "https://api.s0.b.hmny.io"
            ]
        }
    },
    // 123 Fuse Sparknet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).FUST,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "SPARK",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SPARK,
        id: 123,
        mainnet: false,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).FUST],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(123),
            blockExplorerUrls: [
                "https://explorer.fusespark.io/"
            ],
            chainName: "Fuse Sparknet",
            nativeCurrency: {
                name: "Spark",
                symbol: "SPARK",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.fusespark.io"
            ]
        }
    },
    // 41 Telos EVM Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).TLOT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Telos Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TLOS,
        id: 41,
        mainnet: false,
        faucetUrls: [
            "https://app.telos.net/testnet/developers"
        ],
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).TLOT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(41),
            blockExplorerUrls: [
                "https://telos.net/"
            ],
            chainName: "Telos EVM Mainnet",
            nativeCurrency: {
                name: "Telos",
                symbol: "TLOS",
                decimals: 18
            },
            rpcUrls: [
                "https://testnet.telos.net/evm"
            ]
        }
    },
    // 31 RSK Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).RSKT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "RSK Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TRBTC,
        id: 31,
        mainnet: true,
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).RSKT],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(31),
            blockExplorerUrls: [
                "https://rsk.co/"
            ],
            chainName: "RSK Testnet",
            nativeCurrency: {
                name: "tRBTC",
                symbol: "TRBTC",
                decimals: 18
            },
            rpcUrls: [
                "https://public-node.testnet.rsk.co"
            ]
        }
    },
    // 43113 - Avalanche Fuji Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).AVAT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Avalanche Fuji Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).AVAX,
        id: 43113,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/avalanche_test.png",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).AVAT],
        faucetUrls: [
            "https://faucet.avax-test.network/"
        ],
        // https://github.com/ethereum-lists/chains/blob/master/_data/chains/eip155-43113.json
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(43113),
            blockExplorerUrls: [
                "https://testnet.snowtrace.io/"
            ],
            chainName: "Avalanche Fuji Testnet",
            nativeCurrency: {
                name: "AVAX",
                symbol: "AVAX",
                decimals: 18
            },
            rpcUrls: [
                "https://api.avax-test.network/ext/bc/C/rpc"
            ]
        }
    },
    // 59140 - Linea (formerly ConsenSys zkEVM) Testnet
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).LNAT,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM,
        name: "Linea Testnet",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        id: 59140,
        mainnet: false,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/linea.svg",
        multicallAddress: (0, $846e8dc226ba78a9$export$623c94a6c41a6ddd)[(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT],
        faucetUrls: [
            "https://faucetlink.to/goerli"
        ],
        metamask: {
            chainId: (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(59140),
            blockExplorerUrls: [
                "https://explorer.goerli.linea.build/"
            ],
            chainName: "Linea Testnet",
            nativeCurrency: {
                name: "crETH",
                symbol: "crETH",
                decimals: 18
            },
            rpcUrls: [
                "https://rpc.goerli.linea.build"
            ]
        }
    }
];
const $5cec60a38f74f6e4$export$88f137b22863828a = [
    {
        key: (0, $664d8775a51d964a$export$41349f2dc0a89295).SOL,
        chainType: (0, $90ba2aa90df69a91$export$feb52200d964722b).SVM,
        name: "Solana",
        coin: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SOL,
        id: (0, $664d8775a51d964a$export$c06e1e7429de6283).SOL,
        mainnet: true,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/solana.svg",
        faucetUrls: [
            "https://stakely.io/faucet/solana-sol"
        ],
        metamask: {
            chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).SOL.toString(),
            blockExplorerUrls: [
                "https://explorer.solana.com/",
                "https://solscan.io/",
                "https://solana.fm/"
            ],
            chainName: "Solana",
            nativeCurrency: {
                name: "SOL",
                symbol: "SOL",
                decimals: 9
            },
            rpcUrls: [
                "https://api.mainnet-beta.solana.com"
            ]
        }
    }
];
const $5cec60a38f74f6e4$export$65f4d498acfedc7c = [
    ...$5cec60a38f74f6e4$export$451e2796b12d86dc,
    ...$5cec60a38f74f6e4$export$88f137b22863828a
];


const $6c3e4e2cfe28d8cc$var$supportedChains = [
    // This will be added in the future
    // ...supportedSolanaChains,
    ...(0, $5cec60a38f74f6e4$export$451e2796b12d86dc),
    ...(0, $5cec60a38f74f6e4$export$88f137b22863828a)
];
const $6c3e4e2cfe28d8cc$export$54c067a5f720c664 = (chainKey)=>{
    const chain = $6c3e4e2cfe28d8cc$var$supportedChains.find((c)=>c.key === chainKey);
    if (!chain) throw new Error("Invalid chainKey");
    return chain;
};
const $6c3e4e2cfe28d8cc$export$2889085f66c5f9c0 = (chainId)=>{
    const chain = $6c3e4e2cfe28d8cc$var$supportedChains.find((c)=>c.id === chainId);
    if (!chain) throw new Error("Invalid chainId");
    return chain;
};









const $05b0c12d0153e1ce$var$basicCoins = [
    // NATIVE COINS
    // > ETH
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
                decimals: 8,
                name: "Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1",
                decimals: 18,
                symbol: "WETH",
                name: "Wrapped Ether"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).PZE]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x74b23882a30290451a17c44f4f05243b6b58c76d",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
                decimals: 18,
                symbol: "WETH.e",
                name: "Wrapped Ether"
            },
            // [ChainId.ARB]: { // WETH
            //   address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            //   decimals: 18,
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0x6983d1e6def3690c4d616b13597a09e6193ea013",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0x64ff637fb478863b7468bc97d30a5bf3a428a1fd",
                decimals: 18,
                name: "Heco-Peg ETH Token"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0xef71ca2ee68f45b9ad6f72fbdb33d707b872315c",
                decimals: 18,
                symbol: "ETHK",
                name: "ETHK"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0xfa9343c3897324496a05fc75abed6bac29f8a40f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18,
                symbol: "AETH",
                name: "AETH"
            },
            // https://evmexplorer.velas.com/token/0x85219708c49aa701871Ad330A94EA0f41dFf24Ca
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0x85219708c49aa701871ad330a94ea0f41dff24ca",
                decimals: 18
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET]: {
                address: "0x268d6ff391b41b36a13b1693bd25f87fb4e4b392",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > MATIC
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MATIC,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MATIC,
        logoURI: "https://static.debank.com/image/matic_token/logo_url/matic/6f5a6b6f0732a7a235131bd7804d357c.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
                decimals: 18,
                name: "Matic Token"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
                decimals: 8,
                name: "Wrapped Matic (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0xcc42724c6683b7e57334c4e856f4c9965ed682bd",
                decimals: 18,
                name: "Matic Token"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x7122d7661c4564b7c6cd4878b06766489a6028a2",
                decimals: 18,
                name: "Matic Token"
            },
            // https://evmexplorer.velas.com/token/0x6ab0B8C1a35F9F4Ce107cCBd05049CB1Dbd99Ec5/
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0x6ab0b8c1a35f9f4ce107ccbd05049cb1dbd99ec5",
                decimals: 18
            },
            // Testnet
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0xa55C7E1274bE5db2275a0BDd055f81e8263b7954",
                decimals: 18
            }
        }
    },
    // > BNB
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BNB,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BNB,
        logoURI: "https://assets.coingecko.com/coins/images/825/small/binance-coin-logo.png?1547034615",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xb8c77482e45f1f44de1745f52c74426c631bdd52",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
                decimals: 8,
                name: "Wrapped BNB (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0xa649325aa7c5093d12d6f98eb4378deae68ce23f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0xca8d20f3e0144a72c6b5d576e9bd3fd8557e2b04",
                decimals: 18,
                symbol: "WBNB",
                name: "Wrapped BNB"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0xb1f6e61e1e113625593a22fa6aa94f8052bc39e0",
                decimals: 18,
                symbol: "bscBNB"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0xc9baa8cfdde8e328787e29b4b078abf2dadc2055",
                decimals: 18
            },
            // https://evmexplorer.velas.com/token/0x2B8e9cD44C9e09D936149549a8d207c918ecB5C4
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0x2b8e9cd44c9e09d936149549a8d207c918ecb5c4",
                decimals: 18
            },
            // Testnet
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET]: {
                address: "0xbef55684b382bae72051813a898d17282066c007",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x5471ea8f739dd37E9B81Be9c5c77754D8AA953E4",
                decimals: 18
            }
        }
    },
    // > DAI
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI,
        name: "DAI Stablecoin",
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x6b175474e89094c44da98b954eedeac495271d0f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
                decimals: 8,
                name: "DAI Stablecoin (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
                decimals: 18,
                name: "(PoS) DAI Stablecoin"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18,
                symbol: "xDAI",
                name: "xDAI Native Token"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA]: {
                address: "0x4bef76b6b7f2823c6c1f4fcfeacd85c24548ad7e",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0xef977d2f931c1978db5f6747666fa1eacb0d0339",
                decimals: 18,
                symbol: "1DAI"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0xd586e7f844cea2f87f50152665bcbc2c279d8d70",
                decimals: 18,
                symbol: "DAI.e"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0x21cde7e32a6caf4742d00d44b07279e7596d26b9",
                decimals: 18,
                symbol: "DAIK"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0xf2001b145b43032aaf5ee2884e456ccd805f677d",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x94ba7a27c7a95863d1bdc7645ac2951e0cca06ba",
                decimals: 18,
                name: "DAI Stablecoin"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0x90ca507a5d4458a4c6c6249d186b6dcb02a5bccd",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0x765277eebeca2e31912c9946eae1021199b39c61",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0xf74195bb8a5cf652411867c5c2c5b8c2a402be35",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0x461d52769884ca6235B685EF2040F47d30C94EB5",
                decimals: 18
            },
            // https://evmexplorer.velas.com/token/0xE3F5a90F9cb311505cd691a46596599aA1A0AD7D
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d",
                decimals: 18
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xdc31ee1784292379fbb2964b3b9c4124d8f89c60",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0xb224913ce3851b0a0d7c0fb461eef40f2e31ddb8",
                decimals: 18
            }
        }
    },
    // > FTM
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FTM,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FTM,
        logoURI: "https://static.debank.com/image/ftm_token/logo_url/ftm/33fdb9c5067e94f3a1b9e78f6fa86984.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "8gC27rQF4NEDYfyf5aS8ZmQJUum5gufowKGYRRba4ENN",
                decimals: 8,
                name: "Fantom Token (Wormhole)"
            }
        }
    },
    // > OKT
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).OKT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).OKT,
        logoURI: "https://static.debank.com/image/okt_token/logo_url/okt/1228cd92320b3d33769bd08eecfb5391.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > AVAX
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).AVAX,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).AVAX,
        logoURI: "https://static.debank.com/image/avax_token/logo_url/avax/0b9c84359c84d6bdd5bfda9c2d4c4a82.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
                decimals: 8,
                name: "Avalanche (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVAT]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x265B25e22bcd7f10a5bD6E6410F10537Cc7567e8",
                decimals: 18
            }
        }
    },
    // > HT
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).HT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).HT,
        logoURI: "https://static.debank.com/image/heco_token/logo_url/heco/c399dcddde07e1944c4dd8f922832b53.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > ONE
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ONE,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).ONE,
        logoURI: "https://assets.coingecko.com/coins/images/18183/small/wonelogo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x03ff0ff224f904be3118461335064bb48df47938",
                decimals: 18,
                name: "Harmony ONE"
            },
            // Testnet
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > FSN
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FSN,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FSN,
        logoURI: "https://www.bscscan.com/token/images/anyFSN_32.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FSN]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > MOVR
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MOVR,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MOVR,
        logoURI: "https://assets.coingecko.com/coins/images/17984/small/9285.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0x1d4c2a246311bb9f827f4c768e277ff5787b7d7e",
                decimals: 18
            }
        }
    },
    // OTHER STABLECOINS
    // USDT
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
                decimals: 6,
                name: "USDT"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x55d398326f99059ff775485246999027b3197955",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x4ecaba5870353805a9f068101a40e0f32ed605c6",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x049d68029688eabf473097a2fc38ef61633a3c7a",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0xc7198437980c041c805a1edcba50c1ce5db95118",
                decimals: 6,
                symbol: "USDT.e",
                name: "Tether USD"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0xb44a9b6905af7c801311e8f4e76932ee959c663c",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0x382bb369d343125bfb2117af9c149795c6c65c50",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0x66e428c3f67a68878562e79a0234c1f83c208770",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0xa71edc38d189767582c38a3145b5873052c3e47a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0xfadbbf8ce7d5b7041be672561bba99f79c532e10",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0x88eec49252c8cbc039dcdb394c0c2ba2f1637ea0",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0xefaeee334f0fd1712f9a8cc375f427d9cdd40d73",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0x5de1677344d3cb0d7d465c10b72a8f60699c062d",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0x7FF4a56B32ee13D7D4D405887E0eA37d61Ed919e",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
                decimals: 6
            },
            // https://evmexplorer.velas.com/token/0x01445C31581c354b7338AC35693AB2001B50b9aE
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0x01445c31581c354b7338ac35693ab2001b50b9ae",
                decimals: 6,
                name: "Multichain USDT"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: {
                address: "0xa219439258ca9da29e9cc4ce5596924745e12b93",
                decimals: 6,
                name: "USDT"
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x509ee0d083ddf8ac028f2a56731412edd63223b9",
                decimals: 6
            }
        }
    },
    // ======= STARGATE TESTNET TOKENS =======
    // stargate USDC testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgUSDC,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgUSDC,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xDf0360Ad8C5ccf25095Aa97ee5F2785c8d848620",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0x742DfA5Aa70a8212857966D491D67B09Ce7D6ec7",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
                address: "0x6aad876244e7a1ad44ec4824ce813729e5b6c291",
                decimals: 6
            }
        }
    },
    // stargate BUSD testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgBUSD,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgBUSD,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x1010Bb1b9Dff29e6233E7947e045e0ba58f6E92e",
                decimals: 6
            }
        }
    },
    // stargate USDT testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgUSDT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgUSDT,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x5bcc22abec37337630c0e0dd41d64fd86caee951",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0x6fc340be8e378c2ff56476409ef48da9a3b781a0",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0xf49e250aeb5abdf660d643583adfd0be41464efd",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
                address: "0x533046f316590c19d99c74ee661c6d541b64471c",
                decimals: 6
            }
        }
    },
    // stargate USDT testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgMETIS,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgMETIS,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x9874a71b976daa037741d18b86bc6b2f9957fc8a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x8362af3426e6c7a77438f29bdc81c8f27cd541ab",
                decimals: 18
            }
        }
    },
    // stargate WOO testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgWOO,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).sgWOO,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xc9ba30be110864264577ad091c47f986318b213e",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0xb9C468f4308f3f937B4Fc79946244459bBC3cf65",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x6df6db769dd1c845596f7e65a1c86c98d6147cc3",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
                address: "0xac9da6d889e82d08de63f5752f91b151ffe059fb",
                decimals: 18
            }
        }
    },
    // cBridge CELER testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtCELR,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtCELR,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x5D3c0F4cA5EE99f8E8F59Ff9A5fAb04F6a7e007f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x5471ea8f739dd37E9B81Be9c5c77754D8AA953E4",
                decimals: 18
            }
        }
    },
    // cBridge USDT testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtUSDT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtUSDT,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xf4b2cbc3ba04c478f0dc824f4806ac39982dce73",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x7d43AABC515C356145049227CeE54B608342c0ad",
                decimals: 6
            }
        }
    },
    // cBridge WUSDT testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtWUSDT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtWUSDT,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x9D39Fc627A6d9d9F8C831c16995b209548cc3401",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0xC826C23327098cd8A37f140114F2173A8F62DD29",
                decimals: 6
            }
        }
    },
    // cBridge WUSDC testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtWUSDC,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtWUSDC,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x4a63Afc71427807586dA190Bb0D3adB461fF9589",
                decimals: 6
            }
        }
    },
    // cBridge USDC testtoken
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtUSDC,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).cbtUSDC,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0x6de33698e9e9b787e09d3bd7771ef63557e148bb",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVAT]: {
                address: "0x2979a1cb90EEB9e75d7fB4f9813FCC40E4a7fD8b",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0x317F8d18FB16E49a958Becd0EA72f8E153d25654",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xCbE56b00d173A26a5978cE90Db2E33622fD95A28",
                decimals: 6
            }
        }
    },
    // USDC
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC,
        name: "USD Coin",
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS]: {
                address: "0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca",
                decimals: 6,
                name: "USD Base Coin"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
                decimals: 6,
                name: "USD Coin"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0xddafbb505ad214d7b80b1f830fccc89b60fb7a83",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA]: {
                address: "0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).PZE]: {
                address: "0xa8ce8aee21bc2a48a5ef670afcc9274c7bbbc035",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x04068da6c83afcfa0e13ba15a6696662335d5b75",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0x985458e523db3d53125813ed68c274899e9dfab4",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0x9362bbef4b8313a8aa9f0c9808b80577aa26b73b",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0xc946daf81b08146b1c7a8da2a851ddf2b3eaaf85",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0xc21223249ca28397b4b6541dffaecc539bff0c59",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x620fd5fa44be6af63715ef4e65ddfa0387ad13f5",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0xef4229c8c3250c675f21bcefa42f58efbff6002a",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0x66a2a913e447d6b4bf33efbec43aaef87890fbbc",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0x51e44FfaD5C2B122C8b635671FCC8139dc636E82",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0xB12BFcA5A55806AaF64E99521918A4bf0fC40802",
                decimals: 6
            },
            // https://evmexplorer.velas.com/token/0xe2C120f188eBd5389F71Cf4d9C16d05b62A58993
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0xe2c120f188ebd5389f71cf4d9c16d05b62a58993",
                decimals: 6,
                name: "Multichain USDC"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: {
                address: "0x176211869ca2b568f2a7d4ee941e073a821ee1ff",
                decimals: 6,
                name: "USDC.e"
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xd87ba7a50b2e7e660f678a895e4b72e7cb4ccd9c",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0x6d4dd09982853f08d9966ac3ca4eb5885f16f2b2",
                decimals: 6
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x964FF70695da981027c81020B1c58d833D49A640",
                decimals: 6,
                name: "Linea USD Coin"
            }
        }
    },
    // USDC.e
    // Represents the USD Coin (USDC) bridged from Ethereum (as opposed to the 'native' USDC issued by Circle)
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDCe,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDCe,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                decimals: 6,
                name: "Bridged USD Coin",
                symbol: "USDC.e"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
                decimals: 6,
                name: "Bridged USD Coin",
                symbol: "USDC.e"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664",
                decimals: 6,
                name: "Bridged USD Coin",
                symbol: "USDC.e"
            }
        }
    },
    // BUSD
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BUSD,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).BUSD,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/assets/BUSD-BD1/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x6a5F6A8121592BeCd6747a38d67451B310F7f156",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0xc111c29a988ae0c0087d97b33c6e6766808a3bd3",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0xe176ebe47d621b984a73036b9da5d834411ef734",
                decimals: 18
            },
            // testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0xeB3Eb991D39Dac92616da64b7c6D5af5cCFf1627",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x7d43AABC515C356145049227CeE54B608342c0ad",
                decimals: 18
            }
        }
    },
    // TEST COIN
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TEST,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).TEST,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
        verified: false,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x8a1cad3703e0beae0e0237369b4fcd04228d1682",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0xe71678794fff8846bff855f716b0ce9d9a78e844",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
                address: "0xd86bcb7d85163fbc81756bb9cc22225d6abccadb",
                decimals: 18
            }
        }
    },
    // Connext testnet coins
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CXTT,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CXTT,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
        verified: false,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0x7ea6eA49B0b0Ae9c5db7907d139D9Cd3439862a1",
                name: "Goerli CXTT",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0xb706319d37b945727e71ae0d4353699d19112576",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0xeDb95D8037f769B72AAab41deeC92903A98C9E16",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
                address: "0xDC805eAaaBd6F68904cA706C221c72F8a8a68F9f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG]: {
                address: "0x68Db1c8d85C09d546097C65ec7DCBFF4D6497CbF",
                decimals: 18
            }
        }
    },
    // > WBTC
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "qfnqNqs3nCAHjnyCgLRDbBtq4p2MtHZxw8YjSyYhPoL",
                decimals: 8,
                name: "Wrapped BTC (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x8e5bbbb09ed1ebde8674cda39a0c169401db4252",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x321162cd933e2be498cd2267a90534a804051b11",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x68f180fcce6836688e9084f035309e29bf0a2095",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0x50b7545627a5162f82a992c33b87adc75187b218",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0x3095c7557bcb296ccc6e363de01b760ba031f2d9",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0xe6a991ffa8cfe62b0bf6bf72959a3d4f11b2e0f5",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0x506f731f7656e2fb34b587b912808f2a7ab640bd",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0x062e66477faf219f25d27dced647bf57c3107d52",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x33284f95ccb7b948d9d352e1439561cf83d8d00d",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0xbaab46e28388d2779e6e31fd00cf0e5ad95e327b",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0x922d641a426dcffaef11680e5358f34d97d112e1",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0xdc0486f8bf31df57a952bcd3c1d3e166e3d9ec8b",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0xF80699Dc594e00aE7bA200c7533a07C1604A106D",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0xF4eB217Ba2454613b15dBdea6e5f22276410e89e",
                decimals: 8
            }
        }
    },
    // > WETH
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "AaAEw2VCw1XzgvKB8Rj2DyK2ZVau9fbt2bE8hZFWsMyE",
                decimals: 9,
                name: "Allbridge from Ethereum"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1",
                decimals: 18,
                symbol: "WETH",
                name: "Wrapped Ether"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
                decimals: 18,
                symbol: "WETH",
                name: "Wrapped Ether"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0x74b23882a30290451a17c44f4f05243b6b58c76d",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS]: {
                address: "0x4200000000000000000000000000000000000006",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: {
                address: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
                decimals: 18,
                symbol: "WETH.e",
                name: "Wrapped Ether"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
                address: "0x4200000000000000000000000000000000000006",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0xe44fd7fcb2b1581822d0c862b68222998a0c299a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0xa722c13135930332eb3d749b2f0906559d2c5b99",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0x122013fd7df1c6f636a5bb8f03108e876548b455",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
                address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0x5842C5532b61aCF3227679a8b1BD0242a41752f2",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB",
                decimals: 18
            },
            // Testnets
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
                address: "0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
                address: "0xa6fa4fb5f76172d178d61b04b0ecd319c5d1c0aa",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG]: {
                address: "0x4200000000000000000000000000000000000006",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
                address: "0x2C1b868d6596a18e32E61B901E4060C872647b6C",
                decimals: 18
            }
        }
    },
    // > SUSHI
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
                decimals: 8
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x947950bcc74888a40ffa2593c5798f11fc9124c4",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
                address: "0x2995d1317dcd4f0ab89f4ae60f3f020a4f17c7ce",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0xae75a438b2e0cb8bb01ec1e1e376de11d44477cc",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                // guessed from debank api
                address: "0x37b608519f91f70f2eeb0e5ed9af4061722e4f76",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0xd4d42f0b6def4ce0383636770ef773390d85c61a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
                address: "0xbec775cb42abfa4288de81f387a9b1a3c4bc552a",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
                address: "0xf390830df829cf22c53c8840554b98eafc5dcbc2",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
                address: "0x2218e0d5e0173769f5b4939a3ae423f7e5e4eab7",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
                address: "0x52e00b2da5bd7940ffe26b609a42f957f31118d5",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x90708b20ccc1eb95a4fa7c8b18fd2c22a0ff9e78",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0x29dfce9c22003a4999930382fd00f9fd6133acd1",
                decimals: 18
            }
        }
    },
    // used by cBridge v1:
    // > DODO
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).DODO,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).DODO,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x43Dfc4159D86F3A37A5A4B3D4580b888ad7d4DDd/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x69eb4fa4a2fbd498c257c57ea8b7655a2559a581",
                decimals: 18
            }
        }
    },
    // > MCB
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MCB,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).MCB,
        logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
                decimals: 18
            }
        }
    },
    // > CELR
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELR,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELR,
        logoURI: "https://static.debank.com/image/bsc_token/logo_url/0x1f9f6a696c6fd109cd3956f45dc709d2b3902163/1eb9c8f251098ea22a2cb30a877da86a.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0x1f9f6a696c6fd109cd3956f45dc709d2b3902163",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
                address: "0x3a8b787f78d775aecfeea15706d4221b40f345ab",
                decimals: 18
            }
        }
    },
    // > IF
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).IF,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).IF,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/10932.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xb0e1fc65c1a741b4662b813eb787d369b8614af1",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
                address: "0xb0e1fc65c1a741b4662b813eb787d369b8614af1",
                decimals: 18
            }
        }
    },
    // > CRO
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CRO,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CRO,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > FUS
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FUSE,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).FUSE,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/5634.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > CEL
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELO,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELO,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/5567.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                // The CELO token is not a native token (0x000...).
                // Instead it is this ERC20 token: https://explorer.celo.org/token/0x471EcE3750Da237f93B8E339c536989b8978a438
                address: "0x471ece3750da237f93b8e339c536989b8978a438",
                decimals: 18
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "GNCjk3FmPPgZTkbQRSxr6nCvLtYMbXKMnRxg8BgJs62e",
                decimals: 9,
                name: "Allbridge from Celo"
            }
        }
    },
    // > GLMR
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).GLMR,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).GLMR,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/6836.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > METIS
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).METIS,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).METIS,
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).MAM]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > EVM
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).EVM,
        name: "EVMOS",
        logoURI: "https://raw.githubusercontent.com/cronus-finance/token-list/main/assets/evmos/0xD4949664cD82660AaE99bEdc034a0deA8A0bd517/logo.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18,
                symbol: "EVMOS",
                name: "EVMOS"
            }
        }
    },
    // > VEL
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).VLX,
        name: "Velas",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/tokens/vlx.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
                address: "0x0000000000000000000000000000000000000000",
                decimals: 18
            }
        }
    },
    // > Solana
    {
        key: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SOL,
        name: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SOL,
        logoURI: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
        verified: true,
        chains: {
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
                address: "So11111111111111111111111111111111111111112",
                decimals: 9,
                name: "Wrapped SOL"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
                address: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
                decimals: 9,
                name: "Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
                address: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
                decimals: 9,
                name: "Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
                address: "0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1",
                decimals: 9,
                name: "Token Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
                address: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
                decimals: 9,
                symbol: "WSOL",
                name: "Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
                address: "0x3370C8961A1697F22B49c99669C1d98fE63d031D",
                decimals: 9,
                symbol: "WSOL",
                name: "Token Wrapped SOL (Wormhole)"
            },
            [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
                address: "0x4581E64115d46CcdeE65Be2336bEc86c9BA54C01",
                decimals: 9,
                symbol: "WSOL",
                name: "Token Wrapped SOL (Wormhole)"
            }
        }
    }
];
const $05b0c12d0153e1ce$export$96e85942147cff3a = $05b0c12d0153e1ce$var$basicCoins.map((coin)=>{
    var _a, _b, _c;
    const defaultCoin = {
        key: coin.key,
        name: coin.name,
        logoURI: coin.logoURI,
        verified: coin.verified,
        chains: {}
    };
    for (const [chainId, token] of Object.entries(coin.chains))defaultCoin.chains[chainId] = {
        address: token.address,
        decimals: token.decimals,
        symbol: (_a = token.symbol) !== null && _a !== void 0 ? _a : coin.key,
        chainId: parseInt(chainId),
        coinKey: coin.key,
        name: (_c = (_b = token.name) !== null && _b !== void 0 ? _b : coin.name) !== null && _c !== void 0 ? _c : coin.key,
        logoURI: coin.logoURI
    };
    return defaultCoin;
});
const $05b0c12d0153e1ce$export$d6ca8ca2446aad33 = {
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: {
        // https://ww7.etherscan.io/token/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/eth_token/logo_url/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).SOL]: {
        address: "So11111111111111111111111111111111111111112",
        symbol: "SOL",
        decimals: 9,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).SOL,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).SOL,
        name: "Wrapped SOL",
        logoURI: "https://assets.coingecko.com/coins/images/4128/small/solana.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: {
        // https://bscscan.com/token/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c
        address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
        symbol: "WBNB",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC,
        coinKey: "WBNB",
        name: "WBNB",
        logoURI: "https://static.debank.com/image/coin/logo_url/bnb/9784283a36f23a58982fc964574ea530.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: {
        // https://polygonscan.com/token/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270
        address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
        symbol: "WMATIC",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL,
        coinKey: "WMATIC",
        name: "WMATIC",
        logoURI: "https://static.debank.com/image/matic_token/logo_url/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270/f6e604ba0324726a3d687c618aa4f163.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).DAI]: {
        // https://blockscout.com/xdai/mainnet/address/0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d
        address: "0xe91d153e0b41518a2ce8dd3d7944fa863463a97d",
        symbol: "WXDAI",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI,
        coinKey: "WXDAI",
        name: "WXDAI",
        logoURI: "https://static.debank.com/image/xdai_token/logo_url/0xe91d153e0b41518a2ce8dd3d7944fa863463a97d/3fedab836c5425fc3fc2eb542c34c81a.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPT]: {
        // https://optimistic.etherscan.io/token/0x4200000000000000000000000000000000000006
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OPT,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped ETH",
        logoURI: "https://static.debank.com/image/op_token/logo_url/0x4200000000000000000000000000000000000006/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ERA]: {
        // https://explorer.zksync.io/address/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91
        address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ERA,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped Ether",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).PZE]: {
        // https://zkevm.polygonscan.com/token/0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9
        address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).PZE,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped Ether",
        logoURI: "https://static.debank.com/image/pze_token/logo_url/0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BAS]: {
        // https://basescan.org/address/0x4200000000000000000000000000000000000006
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BAS,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped Ether",
        logoURI: "https://static.debank.com/image/coin/logo_url/eth/d61441782d4a08a7479d54aea211679e.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNA]: {
        // https://lineascan.build/address/0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f
        address: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).LNA,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped Ether",
        logoURI: "https://static.debank.com/image/mtr_token/logo_url/0x79a61d3a28f8c8537a3df63092927cfa1150fb3c/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: {
        //
        address: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83",
        symbol: "wFTM",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM,
        coinKey: "wFTM",
        name: "wFTM",
        logoURI: "https://static.debank.com/image/ftm_token/logo_url/0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83/2b7d91858f9c62aafc8d7778b9c22f57.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONE]: {
        address: "0xcf664087a5bb0237a0bad6742852ec6c8d69a27a",
        symbol: "WONE",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE,
        coinKey: "WONE",
        name: "WRAPPED ONE",
        logoURI: "https://assets.coingecko.com/coins/images/18183/small/wonelogo.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVA]: {
        address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
        symbol: "WAVAX",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA,
        coinKey: "WAVAX",
        name: "Wrapped AVAX",
        logoURI: "https://static.debank.com/image/avax_token/logo_url/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7/753d82f0137617110f8dec56309b4065.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARB]: {
        address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOR]: {
        address: "0x98878b06940ae243284ca214f92bb71a2b032b8a",
        symbol: "WMOVR",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR,
        coinKey: "WMOVR",
        name: "WMOVR",
        logoURI: "https://assets.coingecko.com/coins/images/17984/small/9285.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OKT]: {
        address: "0x8f8526dbfd6e38e3d8307702ca8469bae6c56c15",
        symbol: "wOKT",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT,
        coinKey: "wOKT",
        name: "wOKT",
        logoURI: "https://static.debank.com/image/okt_token/logo_url/okt/1228cd92320b3d33769bd08eecfb5391.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).HEC]: {
        address: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
        symbol: "wHT",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC,
        coinKey: "wHT",
        name: "wHT",
        logoURI: "https://static.debank.com/image/heco_token/logo_url/heco/c399dcddde07e1944c4dd8f922832b53.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).CRO]: {
        address: "0x5c7f8a570d578ed84e63fdfa7b1ee72deae1ae23",
        symbol: "WCRO",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CRO,
        coinKey: "WCRO",
        name: "WCRO",
        logoURI: "https://raw.githubusercontent.com/cronaswap/default-token-list/main/assets/tokens/cronos/0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23/logo.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FUS]: {
        address: "0x0be9e53fd7edac9f859882afdda116645287c629",
        symbol: "WFUSE",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS,
        coinKey: "WFUSE",
        name: "Wrapped Fuse",
        logoURI: "https://fuselogo.s3.eu-central-1.amazonaws.com/wfuse.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MOO]: {
        address: "0xacc15dc74880c9944775448304b263d191c6077f",
        symbol: "WGLMR",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO,
        coinKey: "WGLMR",
        name: "Wrapped GLMR",
        logoURI: "https://static.debank.com/image/mobm_token/logo_url/0xacc15dc74880c9944775448304b263d191c6077f/a8442077d76b258297181c3e6eb8c9cc.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MAM]: {
        address: "0x75cb093E4D61d2A2e65D8e0BBb01DE8d89b53481",
        symbol: "WMETIS",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MAM,
        coinKey: "WMETIS",
        name: "Wrapped Metis",
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BOB]: {
        address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "Wrapped ETH",
        logoURI: "https://static.debank.com/image/boba_token/logo_url/0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000/b1947b38a90e559eb950453965714be4.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).CEL]: {
        address: "0x471ece3750da237f93b8e339c536989b8978a438",
        symbol: "CELO",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).CELO,
        name: "Celo native asset",
        logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/5567.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).EVM]: {
        address: "0xd4949664cd82660aae99bedc034a0dea8a0bd517",
        symbol: "WEVMOS",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).EVM,
        coinKey: "WEVMOS",
        name: "Wrapped Evmos",
        logoURI: "https://raw.githubusercontent.com/cronus-finance/token-list/main/assets/evmos/0xD4949664cD82660AaE99bEdc034a0deA8A0bd517/logo.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AUR]: {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "AETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).AUR,
        coinKey: "AETH",
        name: "AETH",
        logoURI: "https://static.debank.com/image/aurora_token/logo_url/aurora/d61441782d4a08a7479d54aea211679e.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).VEL]: {
        address: "0xc579d1f3cf86749e05cd06f7ade17856c2ce3126",
        symbol: "WVLX",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).VEL,
        coinKey: "WVLX",
        name: "Wrapped VLX",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/tokens/vlx.png"
    },
    // Testnets
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).GOR]: {
        // https://goerli.etherscan.io/token/0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6
        address: "0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).GOR,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).MUM]: {
        // https://mumbai.polygonscan.com/token/0x9c3c9283d3e44854697cd22d3faa240cfb032889
        address: "0x9c3c9283d3e44854697cd22d3faa240cfb032889",
        symbol: "WMATIC",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MUM,
        coinKey: "WMATIC",
        name: "WMATIC",
        logoURI: "https://static.debank.com/image/matic_token/logo_url/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270/f6e604ba0324726a3d687c618aa4f163.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ONET]: {
        address: "0x7466d7d0c21fa05f32f5a0fa27e12bdc06348ce2",
        symbol: "WONE",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONET,
        coinKey: "WONE",
        name: "WRAPPED ONE",
        logoURI: "https://assets.coingecko.com/coins/images/18183/small/wonelogo.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG]: {
        // https://goerli.arbiscan.io/token/0x42da9eE191833756c618778145A86E6709f70C9b
        address: "0x42da9eE191833756c618778145A86E6709f70C9b",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ARBG,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG]: {
        // https://blockscout.com/optimism/goerli/address/0x4200000000000000000000000000000000000006
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OPTG,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT]: {
        // https://testnet.bscscan.com/token/0xae13d989dac2f0debff460ac112a837c89baa7cd
        address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
        symbol: "WBNB",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT,
        coinKey: "WBNB",
        name: "WBNB",
        logoURI: "https://static.debank.com/image/coin/logo_url/bnb/9784283a36f23a58982fc964574ea530.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT]: {
        // https://explorer.prealpha.zkevm.consensys.net/address/0x2C1b868d6596a18e32E61B901E4060C872647b6C
        address: "0x2C1b868d6596a18e32E61B901E4060C872647b6C",
        symbol: "WETH",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).LNAT,
        coinKey: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH,
        name: "WETH",
        logoURI: "https://static.debank.com/image/era_token/logo_url/0x5aea5775959fbc2557cc8789bc1bf90a239d9a91/61844453e63cf81301f845d7864236f6.png"
    },
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).AVAT]: {
        // https://testnet.snowtrace.io/token/0xd00ae08403B9bbb9124bB305C09058E32C39A48c
        address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c",
        symbol: "WAVAX",
        decimals: 18,
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA,
        coinKey: "WAVAX",
        name: "Wrapped AVAX",
        logoURI: "https://static.debank.com/image/avax_token/logo_url/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7/753d82f0137617110f8dec56309b4065.png"
    }
};
const $05b0c12d0153e1ce$export$2ada04679f4c4e9d = (coinKey)=>{
    const coin = $05b0c12d0153e1ce$export$96e85942147cff3a.find((coin)=>coin.key === coinKey);
    if (!coin) throw new Error("Invalid Coin");
    return coin;
};
const $05b0c12d0153e1ce$export$eb4ff8029ea50908 = (coinKey, chainId)=>{
    const coin = $05b0c12d0153e1ce$export$2ada04679f4c4e9d(coinKey);
    const token = coin.chains[chainId];
    if (!token) throw new Error(`Invalid chain ${chainId} to coin ${coinKey}`);
    return token;
};
const $05b0c12d0153e1ce$export$5a628999992ba8d2 = (chainId)=>{
    const token = $05b0c12d0153e1ce$export$d6ca8ca2446aad33[chainId];
    if (!token) throw new Error(`Wrapped Gas Token not defined for chain ${chainId}.`);
    return token;
};
const $05b0c12d0153e1ce$export$ead323b33f66161e = (chainId, tokenAddress)=>{
    var _a;
    return (_a = $05b0c12d0153e1ce$export$96e85942147cff3a.flatMap(({ chains: chains })=>Object.values(chains)).find((token)=>token.chainId === chainId && tokenAddress.toLowerCase() === token.address.toLowerCase())) !== null && _a !== void 0 ? _a : null;
};



var $c04fb52a7bce8b13$export$7a1a989bd46c72e6;
(function(ExchangeTool) {
    ExchangeTool["oneinch"] = "1inch";
    ExchangeTool["paraswap"] = "paraswap";
    ExchangeTool["openocean"] = "openocean";
    ExchangeTool["zerox"] = "0x";
    ExchangeTool["dodo"] = "dodo";
})($c04fb52a7bce8b13$export$7a1a989bd46c72e6 || ($c04fb52a7bce8b13$export$7a1a989bd46c72e6 = {}));
const $c04fb52a7bce8b13$export$460011cb9309057b = [
    {
        key: $c04fb52a7bce8b13$export$7a1a989bd46c72e6.oneinch,
        name: "1inch",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/oneinch.png",
        webUrl: "https://app.1inch.io/"
    },
    {
        key: $c04fb52a7bce8b13$export$7a1a989bd46c72e6.paraswap,
        name: "ParaSwap",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/paraswap.png",
        webUrl: "https://paraswap.io/"
    },
    {
        key: $c04fb52a7bce8b13$export$7a1a989bd46c72e6.openocean,
        name: "OpenOcean",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/openocean.png",
        webUrl: "https://openocean.finance/classic"
    },
    {
        key: $c04fb52a7bce8b13$export$7a1a989bd46c72e6.zerox,
        name: "0x",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/zerox.png",
        webUrl: "https://matcha.xyz/markets/"
    },
    {
        key: $c04fb52a7bce8b13$export$7a1a989bd46c72e6.dodo,
        name: "DODO",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/dodo.png",
        webUrl: "https://app.dodoex.io/"
    }
];
const $c04fb52a7bce8b13$export$54a04ac60f0f5cdf = [
    // 1 - Ethereum
    {
        key: "uniswap-eth",
        name: "UniswapV2",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/uniswap.png",
        webUrl: "https://app.uniswap.org/#/swap",
        graph: "https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2",
        tokenlistUrl: "https://gateway.ipfs.io/ipns/tokens.uniswap.org",
        routerAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
        factoryAddress: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
        initCodeHash: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH)
        ]
    },
    {
        key: "sushiswap-eth",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        graph: "https://api.thegraph.com/subgraphs/name/sushiswap/exchange",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswapclassic/token-list/master/sushiswap.tokenlist.json",
        routerAddress: "0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F",
        factoryAddress: "0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH),
            {
                address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
                symbol: "OHM",
                decimals: 9,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH
            },
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ETH)
        ]
    },
    // 137 - Polygon
    {
        key: "quickswap-pol",
        name: "Quickswap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/quick.png",
        webUrl: "https://quickswap.exchange/",
        graph: "https://api.thegraph.com/subgraphs/name/sameepsi/quickswap06",
        tokenlistUrl: "https://unpkg.com/quickswap-default-token-list@1.0.71/build/quickswap-default.tokenlist.json",
        routerAddress: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
        factoryAddress: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32",
        initCodeHash: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            {
                address: "0x831753dd7087cac61ab5644b308642cc1c33dc13",
                symbol: "QUICK",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL
            }
        ]
    },
    {
        key: "honeyswap-pol",
        name: "Honeyswap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/honey.png",
        webUrl: "https://app.honeyswap.org/",
        graph: "https://api.thegraph.com/subgraphs/name/1hive/honeyswap-polygon",
        tokenlistUrl: "https://tokens.honeyswap.org/",
        routerAddress: "0xaD340d0CD0B117B0140671E7cB39770e7675C848",
        factoryAddress: "0x03daa61d8007443a6584e3d8f85105096543c19c",
        initCodeHash: "0xae81bbc68f315fbbf7617eb881349af83b1e95241f616966e1e0583ecd0793fe",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            {
                address: "0xb371248dd0f9e4061ccf8850e9223ca48aa7ca4b",
                symbol: "HNY",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL
            }
        ]
    },
    {
        key: "sushiswap-pol",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        graph: "https://api.thegraph.com/subgraphs/name/sushiswap/matic-exchange",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/polygon.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL)
        ]
    },
    {
        key: "lif3swap-pol",
        name: "Lif3 Swap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).POL,
        webUrl: "https://lif3.com/",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/lif3.png",
        tokenlistUrl: "https://assets.lif3.com/swap/polygon/tokens.json",
        routerAddress: "0x67dC2703D306F72E94DbB0cE0aa0CB86149EAc70",
        factoryAddress: "0x3FB1E7D5d9C974141A5B6E5fa4edab0a7Aa15C6A",
        initCodeHash: "0x57cf36086932d62d26c562d18d87afe373f166c06011dc35be0783e29c6eb4eb",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).POL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).POL)
        ]
    },
    // 56 - Binance Smart Chain
    {
        key: "pancakeswap-bsc",
        name: "Pancake",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/pancake.png",
        webUrl: "https://exchange.pancakeswap.finance/",
        graph: "https://api.thegraph.com/subgraphs/name/bscnodes/pancakeswap",
        tokenlistUrl: "https://tokens.pancakeswap.finance/pancakeswap-extended.json",
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        factoryAddress: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        initCodeHash: "0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            {
                address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                symbol: "BUSD",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC
            },
            {
                address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
                symbol: "CAKE",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC
            },
            {
                address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
                symbol: "BTCB",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC
            }
        ]
    },
    {
        key: "sushiswap-bsc",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        graph: "https://api.thegraph.com/subgraphs/name/sushiswap/bsc-exchange",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/bsc.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            {
                address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                symbol: "BUSD",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC
            },
            {
                address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
                symbol: "BTCB",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC
            },
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC)
        ]
    },
    {
        key: "lif3swap-bsc",
        name: "Lif3 Swap",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/lif3.png",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC,
        webUrl: "https://lif3.com/",
        tokenlistUrl: "https://assets.lif3.com/swap/bnb/tokens.json",
        routerAddress: "0x1956005bA9690B7A00b09c78769675C0cE1457AF",
        factoryAddress: "0x3FB1E7D5d9C974141A5B6E5fa4edab0a7Aa15C6A",
        initCodeHash: "0x57cf36086932d62d26c562d18d87afe373f166c06011dc35be0783e29c6eb4eb",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).BSC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).BSC)
        ]
    },
    // 100 - Gnosis
    {
        key: "honeyswap-dai",
        name: "Honeyswap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/honey.png",
        webUrl: "https://app.honeyswap.org/",
        graph: "https://api.thegraph.com/subgraphs/name/1hive/honeyswap-xdai",
        tokenlistUrl: "https://tokens.honeyswap.org/",
        routerAddress: "0x1C232F01118CB8B424793ae03F870aa7D0ac7f77",
        factoryAddress: "0xA818b4F111Ccac7AA31D0BCc0806d64F2E0737D7",
        initCodeHash: "0x3f88503e8580ab941773b59034fb4b2a63e86dbc031b3633a925533ad3ed2b93",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            {
                address: "0x71850b7e9ee3f13ab46d67167341e4bdc905eef9",
                symbol: "HNY",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI
            }
        ]
    },
    {
        key: "sushiswap-dai",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        graph: "https://api.thegraph.com/subgraphs/name/sushiswap/xdai-exchange",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/xdai.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI)
        ]
    },
    {
        key: "swapr-dai",
        name: "Swapr",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI,
        webUrl: "https://swapr.eth.limo/",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/swapr.png",
        tokenlistUrl: "https://gist.githubusercontent.com/mathiasmoeller/03525afe098af3d45b9aff1f8a04acd9/raw/76d9b818659fe1fe90c8f0f0edc36f23160d4dc1/swapr-token-list.json",
        routerAddress: "0xE43e60736b1cb4a75ad25240E2f9a62Bff65c0C0",
        factoryAddress: "0x5D48C95AdfFD4B40c1AAADc4e08fc44117E02179",
        initCodeHash: "0xd306a548755b9295ee49cc729e13ca4a45e00199bbd890fa146da43a50571776",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).DAI),
            {
                address: "0x532801ed6f82fffd2dab70a19fc2d7b2772c4f4b",
                symbol: "SWPR",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).DAI
            }
        ]
    },
    // 250 - Fantom
    {
        key: "spookyswap-ftm",
        name: "SpookySwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/spooky.png",
        webUrl: "https://spookyswap.finance/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/SpookySwap/spooky-info/master/src/constants/token/spookyswap.json",
        routerAddress: "0xF491e7B69E4244ad4002BC14e878a34207E38c29",
        factoryAddress: "0x152eE697f2E276fA89E96742e9bB9aB1F2E61bE3",
        initCodeHash: "0xcdf2deca40a0bd56de8e3ce5c7df6727e5b1bf2ac96f283fa9c4b3e6b42ea9d2",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM)
        ]
    },
    {
        key: "sushiswap-ftm",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        graph: "https://api.thegraph.com/subgraphs/name/sushiswap/fantom-exchange",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/fantom.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM)
        ]
    },
    {
        key: "spiritswap",
        name: "SpiritSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM,
        logoURI: "https://github.com/Layer3Org/spiritswap-tokens-list-icon/blob/master/token-list/images/inspirit.png?raw=true",
        webUrl: "https://app.spiritswap.finance/#/",
        tokenlistUrl: "https://gist.githubusercontent.com/mathiasmoeller/493b1ed01c2a789b2e785e51a2808412/raw/b157b697c72e8f3a6d5ef4851ceeb59bd4b64cd6/spiritswap_tokenlist.json",
        routerAddress: "0x16327E3FbDaCA3bcF7E38F5Af2599D2DDc33aE52",
        factoryAddress: "0xEF45d134b73241eDa7703fa787148D9C9F4950b0",
        initCodeHash: "0xe242e798f6cee26a9cb0bbf24653bf066e5356ffeac160907fe2cc108e238617",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM)
        ]
    },
    {
        key: "soulswap-ftm",
        name: "SoulSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM,
        webUrl: "https://app.soulswap.finance/",
        logoURI: "https://raw.githubusercontent.com/soulswapfinance/assets/prod/blockchains/fantom/assets/0xe2fb177009FF39F52C0134E8007FA0e4BaAcBd07/logo.png",
        tokenlistUrl: "https://raw.githubusercontent.com/soulswapfinance/default-token-list/master/soulswap.tokenlist.json",
        routerAddress: "0x6b3d631B87FE27aF29efeC61d2ab8CE4d621cCBF",
        factoryAddress: "0x1120e150dA9def6Fe930f4fEDeD18ef57c0CA7eF",
        initCodeHash: "0xf3dcc3c6c6e34d3981dd429ac942301b9ebdd05de1be17f646b55476c44dc951",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).FTM),
            {
                address: "0xe2fb177009FF39F52C0134E8007FA0e4BaAcBd07",
                symbol: "SOUL",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FTM
            }
        ]
    },
    // 1666600000 - Harmony Mainnet Shard 0
    {
        key: "viperswap-one",
        name: "ViperSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/viper.png",
        webUrl: "https://viper.exchange/#/swap",
        tokenlistUrl: "https://d1xrz6ki9z98vb.cloudfront.net/venomswap/lists/venomswap-default.tokenlist.json",
        routerAddress: "0xf012702a5f0e54015362cBCA26a26fc90AA832a3",
        factoryAddress: "0x7D02c116b98d0965ba7B642ace0183ad8b8D2196",
        initCodeHash: "0x162f79e638367cd45a118c778971dfd8d96c625d2798d3b71994b035cfe9b6dc",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ONE, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            {
                address: "0xEf977d2f931C1978Db5F6747666fa1eACB0d0339",
                symbol: "1DAI",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE
            },
            {
                address: "0xE176EBE47d621b984a73036B9DA5d834411ef734",
                symbol: "BUSD",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE
            },
            {
                address: "0x985458E523dB3d53125813eD68c274899e9DfAb4",
                symbol: "1USDC",
                decimals: 6,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE
            },
            {
                address: "0xEa589E93Ff18b1a1F1e9BaC7EF3E86Ab62addc79",
                symbol: "VIPER",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE
            },
            {
                address: "0x0dc78c79B4eB080eaD5C1d16559225a46b580694",
                symbol: "WAGMI",
                decimals: 9,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE
            }
        ]
    },
    {
        key: "sushiswap-one",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/harmony.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ONE)
        ]
    },
    // 43114 - Avalanche
    {
        key: "sushiswap-ava",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/avalanche.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA)
        ]
    },
    {
        key: "pangolin-ava",
        name: "Pangolin",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/pangolin.png",
        webUrl: "https://pangolin.exchange/",
        tokenlistUrl: "https://raw.githubusercontent.com/pangolindex/tokenlists/main/pangolin.tokenlist.json",
        routerAddress: "0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106",
        factoryAddress: "0xefa94DE7a4656D787667C749f7E1223D71E9FD88",
        initCodeHash: "0x40231f6b438bce0797c9ada29b718a87ea0a5cea3fe9a771abdd76bd41a3e545",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).AVA)
        ]
    },
    // 42161 - Arbitrum
    {
        key: "sushiswap-arb",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/arbitrum.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB),
            {
                address: "0x3e6648c5a70a150a88bce65f4ad4d506fe15d2af",
                symbol: "SPELL",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ARB
            }
        ]
    },
    // 10 - Optimistic Ethereum
    // Uniswap V3:
    // {
    //   key: 'uniswap-opt',
    //   name: 'UniswapV3',
    //   chainId: 10,
    //   logoURI: 'https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/uniswap.png',
    //   webUrl: 'https://app.uniswap.org/#/swap',
    //   graph: '',
    //   tokenlistUrl: 'https://static.optimism.io/optimism.tokenlist.json',
    //   routerAddress: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
    //   factoryAddress: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
    //   initCodeHash: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f',
    //   baseTokens: [
    //     findWrappedGasOnChain(ChainId.OPT),
    //     findDefaultToken(CoinKey.DAI, ChainId.OPT),
    //     findDefaultToken(CoinKey.USDC, ChainId.OPT),
    //     findDefaultToken(CoinKey.USDT, ChainId.OPT),
    //     findDefaultToken(CoinKey.WBTC, ChainId.OPT),
    //   ]
    // },
    // 1285 - Moonriver
    {
        key: "sushiswap-mor",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/moonriver.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            {
                address: "0x1a93b23281cc1cde4c4741353f3064709a16197d",
                symbol: "FRAX",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR
            },
            {
                address: "0x0cae51e1032e8461f4806e26332c030e34de3adb",
                symbol: "MIM",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR
            },
            {
                address: "0x3d2d044e8c6dad46b4f7896418d3d4dfaad902be",
                symbol: "aROME",
                decimals: 9,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR
            }
        ]
    },
    {
        key: "solarbeam-mor",
        name: "Solarbeam",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/solarbeam.png",
        webUrl: "https://app.solarbeam.io/exchange/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/solarbeamio/solarbeam-tokenlist/main/solarbeam.tokenlist.json",
        routerAddress: "0xAA30eF758139ae4a7f798112902Bf6d65612045f",
        factoryAddress: "0x049581aEB6Fe262727f290165C29BDAB065a1B68",
        initCodeHash: "0x9a100ded5f254443fbd264cb7e87831e398a8b642e061670a9bc35ba27293dbf",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR),
            {
                address: "0x1a93b23281cc1cde4c4741353f3064709a16197d",
                symbol: "FRAX",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR
            },
            {
                address: "0x6bd193ee6d2104f14f94e2ca6efefae561a4334b",
                symbol: "SOLAR",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOR
            }
        ]
    },
    // 128 - HECO Chain
    {
        key: "sushiswap-hec",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/heco.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).HEC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC),
            {
                address: "0x66a79d23e58475d2738179ca52cd0b41d73f0bea",
                symbol: "HBTC",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC
            },
            {
                address: "0x3d760a45d0887dfd89a2f5385a236b29cb46ed2a",
                symbol: "DAIHECO",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).HEC
            }
        ]
    },
    // 66 - OKEX
    {
        key: "sushiswap-okt",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/okex.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT)
        ]
    },
    {
        key: "jswap-okt",
        name: "JSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/jswap.png",
        webUrl: "https://app.jswap.finance/#/swap",
        tokenlistUrl: "https://resources.jswap.finance/token-list/oec/extended.tokenlist.json",
        routerAddress: "0x069A306A638ac9d3a68a6BD8BE898774C073DCb3",
        factoryAddress: "0xd654CbF99F2907F06c88399AE123606121247D5C",
        initCodeHash: "0xf6608394468275c0df88a8568e9fbf7295a0aebddd5ae966ce6dbf5bb4ee68a0",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).OKT, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT),
            {
                address: "0x54e4622dc504176b3bb432dccaf504569699a7ff",
                symbol: "BTCK",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT
            },
            {
                address: "0xdf54b6c6195ea4d948d03bfd818d365cf175cfc2",
                symbol: "OKB",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT
            },
            {
                address: "0x5fac926bf1e638944bb16fb5b787b5ba4bc85b0a",
                symbol: "JF",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT
            }
        ]
    },
    {
        key: "okcswap-okt",
        name: "OKCSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT,
        webUrl: "https://www.okx.com/okc/swap",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/okx.png",
        tokenlistUrl: "https://www.okx.com/okc/openapi/swap/tokens",
        routerAddress: "0xc97b81B8a38b9146010Df85f1Ac714aFE1554343",
        factoryAddress: "0x7b9F0a56cA7D20A44f603C03C6f45Db95b31e539",
        initCodeHash: "0x00c49b7a1b728b8f0185f09df0b8487b8f4fd0fc3b133cb58039e67a16acb657",
        baseTokens: [
            {
                address: "0x8f8526dbfd6e38e3d8307702ca8469bae6c56c15",
                symbol: "WOKT",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT
            },
            {
                address: "0x382bB369d343125BfB2117af9c149795C6C65C50",
                symbol: (0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT,
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).OKT
            }
        ]
    },
    // 25 - Cronos Mainnet Beta
    {
        key: "cronaswap-cro",
        name: "CronaSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CRO,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/cronaswap.png",
        webUrl: "https://app.cronaswap.org/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/cronaswap/default-token-list/main/assets/tokens/cronos.json",
        routerAddress: "0xcd7d16fB918511BF7269eC4f48d61D79Fb26f918",
        factoryAddress: "0x73A48f8f521EB31c55c0e1274dB0898dE599Cb11",
        initCodeHash: "0xc93158cffa5b575e32566e81e847754ce517f8fa988d3e25cf346d916216e06f",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).CRO, (0, $664d8775a51d964a$export$c06e1e7429de6283).CRO),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).CRO),
            {
                address: "0xadbd1231fb360047525bedf962581f3eee7b49fe",
                symbol: "CRONA",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CRO
            }
        ]
    },
    // TODO: For cronos chain, we will add KyberSwap in the near future, they're still in development
    // 1284 - Moonbeam
    {
        key: "stellaswap-moo",
        name: "StellaSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/stellaswap.png",
        webUrl: "https://app.stellaswap.com/",
        tokenlistUrl: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/tokens/stellaswap.json",
        routerAddress: "0xd0A01ec574D1fC6652eDF79cb2F880fd47D34Ab1",
        factoryAddress: "0x68A384D826D3678f78BB9FB1533c7E9577dACc0E",
        initCodeHash: "0x48a6ca3d52d0d0a6c53a83cc3c8688dd46ea4cb786b169ee959b95ad30f61643",
        baseTokens: [
            {
                address: "0x0E358838ce72d5e61E0018a2ffaC4bEC5F4c88d2",
                symbol: "STELLA",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO
            },
            {
                address: "0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b",
                symbol: "USDC",
                decimals: 6,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO
            },
            {
                address: "0xAcc15dC74880C9944775448304B263D191c6077F",
                symbol: "WGLMR",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO
            }
        ]
    },
    {
        key: "beamswap-moo",
        name: "BeamSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/beamswap.png",
        webUrl: "https://app.beamswap.io/",
        tokenlistUrl: "https://raw.githubusercontent.com/BeamSwap/beamswap-tokenlist/main/tokenlist.json",
        routerAddress: "0x96b244391D98B62D19aE89b1A4dCcf0fc56970C7",
        factoryAddress: "0x985BcA32293A7A496300a48081947321177a86FD",
        initCodeHash: "0xe31da4209ffcce713230a74b5287fa8ec84797c9e77e1f7cfeccea015cdc97ea",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).MOO),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).BNB, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).MOO),
            {
                chainId: 1284,
                address: "0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73",
                symbol: "USDT",
                name: "USDT Token",
                decimals: 6
            },
            {
                chainId: 1284,
                address: "0xA649325Aa7C5093d12D6F98EB4378deAe68CE23F",
                symbol: "BUSD",
                name: "BUSD Token",
                decimals: 18
            },
            {
                chainId: 1284,
                address: "0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b",
                symbol: "USDC",
                name: "USDC Token",
                decimals: 6
            }
        ]
    },
    // 122 - Fuse Mainnet // TODO: incomplete
    // {
    //   key: 'fuseswap-fus',
    //   name: 'FuseSwap',
    //   chainId: ChainId.FUS,
    //   logoURI:
    //     'https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/fuseswap.png',
    //   webUrl: 'https://app.fuse.fi/#/swap',
    //   graph: 'https://api.thegraph.com/subgraphs/name/fuseio/fuseswap',
    //   tokenlistUrl:
    //     'https://raw.githubusercontent.com/fuseio/fuseswap-default-token-list/master/build/fuseswap-default.tokenlist.json',
    //   // we should add router address, factory address and init code hash
    //   routerAddress: '',
    //   factoryAddress: '',
    //   initCodeHash: '',
    //   baseTokens: [
    //     findWrappedGasOnChain(ChainId.FUS),
    //     findDefaultToken(CoinKey.FUSE, ChainId.FUS),
    //     findDefaultToken(CoinKey.USDC, ChainId.FUS),
    //     findDefaultToken(CoinKey.USDT, ChainId.FUS),
    //     findDefaultToken(CoinKey.WBTC, ChainId.FUS),
    //     findDefaultToken(CoinKey.WETH, ChainId.FUS),
    //     {
    //       address: '0x249be57637d8b013ad64785404b24aebae9b098b',
    //       symbol: 'fUSD',
    //       decimals: 18,
    //       chainId: ChainId.FUS,
    //     } as StaticToken,
    //   ],
    // },
    {
        key: "sushiswap-fus",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/fuse.json",
        routerAddress: "0xF4d73326C13a4Fc5FD7A064217e12780e9Bd62c3",
        factoryAddress: "0x43eA90e2b786728520e4f930d2A71a477BF2737C",
        initCodeHash: "0x1901958ef8b470f2c0a3875a79ee0bd303866d85102c0f1ea820d317024d50b5",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).FUS)
        ]
    },
    // 42220 Celo Mainnet
    {
        key: "ubeswap-cel",
        name: "UbeSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/ubeswap.png",
        webUrl: "https://app.ubeswap.org/#/swap",
        graph: "https://api.thegraph.com/subgraphs/name/ubeswap/ubeswap",
        tokenlistUrl: "https://raw.githubusercontent.com/Ubeswap/default-token-list/master/ubeswap.token-list.json",
        routerAddress: "0xE3D8bd6Aed4F159bc8000a9cD47CffDb95F96121",
        factoryAddress: "0x62d5b84bE28a183aBB507E125B384122D2C25fAE",
        initCodeHash: "0xb3b8ff62960acea3a88039ebcf80699f15786f1b17cebd82802f7375827a339c",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            {
                address: "0x918146359264c492bd6934071c6bd31c854edbc3",
                symbol: "mCUSD",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL
            },
            {
                address: "0xe273ad7ee11dcfaa87383ad5977ee1504ac07568",
                symbol: "mCEUR",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL
            }
        ]
    },
    {
        key: "sushiswap-cel",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/celo.json",
        routerAddress: "0x1421bDe4B10e8dd459b3BCb598810B1337D56842",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).SUSHI, (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL),
            {
                address: "0x765de816845861e75a25fca122bb6898b8b1282a",
                symbol: "cUSD",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL
            },
            {
                address: "0xd8763cba276a3738e6de85b4b3bf5fded6d6ca73",
                symbol: "cEUR",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).CEL
            }
        ]
    },
    // 1088 Metis Andromeda Mainnet // TODO: incomplete
    // {
    //   key: 'standard-mam',
    //   name: 'Standard',
    //   chainId: ChainId.MAM,
    //   logoURI:
    //     'https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/standard.png',
    //   webUrl: 'https://apps.standard.tech/trade',
    //   tokenlistUrl:
    //     'https://raw.githubusercontent.com/digitalnativeinc/default-token-list/dnf/tokens/metis.json',
    //   // we should add router address, factory address and init code hash
    //   routerAddress: '',
    //   factoryAddress: '',
    //   initCodeHash: '',
    //   baseTokens: [
    //     findWrappedGasOnChain(ChainId.MAM),
    //     {
    //       address: '0xc12cac7090baa48ec750cceec57c80768f6ee58e',
    //       symbol: 'STND',
    //       decimals: 18,
    //       chainId: ChainId.MAM,
    //     } as StaticToken,
    //     {
    //       address: '0xea32a96608495e54156ae48931a7c20f0dcc1a21',
    //       symbol: 'm.USDC',
    //       decimals: 6,
    //       chainId: ChainId.MAM,
    //     } as StaticToken,
    //     {
    //       address: '0xbb06dca3ae6887fabf931640f67cab3e3a16f4dc',
    //       symbol: 'm.USDT',
    //       decimals: 6,
    //       chainId: ChainId.MAM,
    //     } as StaticToken,
    //   ],
    // },
    // 288 Boba Network
    {
        key: "oolongswap-bob",
        name: "OolongSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/oolongswap.png",
        webUrl: "https://oolongswap.com/#/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/OolongSwap/boba-community-token-list/main/build/boba.tokenlist.json",
        routerAddress: "0x17C83E2B96ACfb5190d63F5E46d93c107eC0b514",
        factoryAddress: "0x7DDaF116889D655D1c486bEB95017a8211265d29",
        initCodeHash: "0x1db9efb13a1398e31bb71895c392fa1217130f78dc65080174491adcec5da9b9",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WBTC, (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).DAI, (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDC, (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).USDT, (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB),
            {
                address: "0xa18bf3994c0cc6e3b63ac420308e5383f53120d7",
                symbol: "BOBA",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB
            },
            {
                address: "0x5008f837883ea9a07271a1b5eb0658404f5a9610",
                symbol: "OLO",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BOB
            }
        ]
    },
    // TESTNETS
    // 5 - Goerli
    {
        key: "uniswap-gor",
        name: "Uniswap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).GOR,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/uniswap.png",
        webUrl: "https://app.uniswap.org/",
        tokenlistUrl: "https://raw.githubusercontent.com/compound-finance/token-list/master/compound.tokenlist.json",
        routerAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
        factoryAddress: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
        initCodeHash: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).ETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).GOR),
            (0, $05b0c12d0153e1ce$export$eb4ff8029ea50908)((0, $664d8775a51d964a$export$5d3cfda82f2b887a).WETH, (0, $664d8775a51d964a$export$c06e1e7429de6283).GOR)
        ]
    },
    // TODO: sushiswap does not work properly
    // {
    //   key: 'sushiswap-gor',
    //   name: 'SushiSwap',
    //   chainId: ChainId.GOR,
    //   logoURI: 'https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png',
    //   webUrl: 'https://app.sushi.com/swap',
    //   tokenlistUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/goerli.json',
    //   routerAddress: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    //   factoryAddress: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    //   initCodeHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
    //   baseTokens: [],
    // },
    // 1666700000 - HARMONY TESTNET
    // TODO: Only sushiswap support ONET but official swap website also does not work correctly
    {
        key: "sushiswap-onet",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).ONET,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/harmony-testnet.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: []
    },
    // 97 - Binance Smart Chain TESTNET
    // TODO: Only sushiswap support BSCT but official swap website also does not work correctly
    {
        key: "sushiswap-bsct",
        name: "SushiSwap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).BSCT,
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/sushi.png",
        webUrl: "https://app.sushi.com/swap",
        tokenlistUrl: "https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/harmony-testnet.json",
        routerAddress: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
        factoryAddress: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
        initCodeHash: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
        baseTokens: [
            (0, $05b0c12d0153e1ce$export$5a628999992ba8d2)((0, $664d8775a51d964a$export$c06e1e7429de6283).ONET)
        ]
    },
    // 106 Velas
    {
        key: "wagyuswap-vel",
        name: "Wagyuswap",
        chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).VEL,
        webUrl: "https://exchange.wagyuswap.app",
        tokenlistUrl: "https://github.com/wagyuswapapp/wagyu-frontend/blob/wagyu/src/config/constants/tokenLists/pancake-default.tokenlist.json",
        logoURI: "https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/exchanges/wagyu.png",
        routerAddress: "0x3D1c58B6d4501E34DF37Cf0f664A58059a188F00",
        factoryAddress: "0x69f3212344A38b35844cCe4864C2af9c717F35e3",
        initCodeHash: "0x3f7eace9f1c10ecce400030e19a86fd03c98c3770ce239a9cdef3b33fb40e933",
        baseTokens: [
            {
                address: "0xabf26902fd7b624e0db40d31171ea9dddf078351",
                symbol: "WAG",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).VEL
            },
            {
                symbol: "WVLX",
                address: "0xc579d1f3cf86749e05cd06f7ade17856c2ce3126",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).VEL
            },
            {
                symbol: "ASTRO",
                address: "0x72eb7ca07399ec402c5b7aa6a65752b6a1dc0c27",
                decimals: 18,
                chainId: (0, $664d8775a51d964a$export$c06e1e7429de6283).VEL
            }
        ]
    }
];
const $c04fb52a7bce8b13$export$826550b985ae8878 = (key)=>{
    const exchange = $c04fb52a7bce8b13$export$54a04ac60f0f5cdf.find((exchange)=>exchange.key === key);
    if (!exchange) throw new Error("Invalid key");
    return exchange;
};


const $91793444b767c4bc$export$524a587514af3051 = {
    status: "NOT_STARTED",
    process: []
};
const $91793444b767c4bc$export$458fb0e0a716e51d = [
    "lifi",
    "swap",
    "cross",
    "protocol",
    "custom"
];
function $91793444b767c4bc$export$f36a9d321d06e63f(step) {
    return step.type === "swap";
}
function $91793444b767c4bc$export$f0424b118158bd07(step) {
    return step.type === "cross";
}
function $91793444b767c4bc$export$99e105b226f5d45a(step) {
    return step.type === "protocol";
}
function $91793444b767c4bc$export$4a277a2d4f7a8ba7(step) {
    return step.type === "custom";
}


const $a788d4856c753142$export$ed0df17bf864fd7b = [
    "RECOMMENDED",
    "FASTEST",
    "CHEAPEST",
    "SAFEST"
];
const $a788d4856c753142$export$bb167fcf312eb81d = [
    "INSURED",
    "INSURABLE",
    "NOT_INSURABLE"
];
const $a788d4856c753142$var$_StatusMessage = [
    // The transaction was not found -- likely not mined yet
    "NOT_FOUND",
    // A third party service is not available
    "INVALID",
    // The transfer is pending
    "PENDING",
    // The transfer is done
    "DONE",
    // The transfer failed
    "FAILED"
];
const $a788d4856c753142$var$_SubstatusPending = [
    // The bridge is waiting for additional confirmations
    "WAIT_SOURCE_CONFIRMATIONS",
    // The off-chain logic is in progress, waiting for the destination tx to be mined
    "WAIT_DESTINATION_TRANSACTION",
    // The bridge API / subgraph is temporarily unavailable
    "BRIDGE_NOT_AVAILABLE",
    // The RPC for source/destination chain is temporarily unavailable
    "CHAIN_NOT_AVAILABLE",
    // The transfer cannot be completed, a refund is required
    "NOT_PROCESSABLE_REFUND_NEEDED",
    // A refund has been requested and is in progress
    "REFUND_IN_PROGRESS",
    // We cannot determine the status of the transfer
    "UNKNOWN_ERROR"
];
const $a788d4856c753142$var$_SubstatusDone = [
    // The transfer was successful
    "COMPLETED",
    // The transfer was partially successful
    // This can happen for specific bridges like Across
    // which may provide alternative tokens in case of low liquidity
    "PARTIAL",
    // The transfer was not successful but it has been refunded
    "REFUNDED"
];
const $a788d4856c753142$export$bc2cced80d251fb3 = (substatus)=>$a788d4856c753142$var$_SubstatusPending.includes(substatus);
const $a788d4856c753142$export$8aaad8a9555ab0bc = (substatus)=>$a788d4856c753142$var$_SubstatusDone.includes(substatus);
const $a788d4856c753142$var$_LIFuelState = [
    "PENDING",
    "DONE",
    "NOT_FOUND"
];


// Error codes emitted by the LI.FI API
var $611f1cccc78c5f9a$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode[ErrorCode["DefaultError"] = 1000] = "DefaultError";
    ErrorCode[ErrorCode["FailedToBuildTransactionError"] = 1001] = "FailedToBuildTransactionError";
    ErrorCode[ErrorCode["NoQuoteError"] = 1002] = "NoQuoteError";
    ErrorCode[ErrorCode["NotFoundError"] = 1003] = "NotFoundError";
    ErrorCode[ErrorCode["NotProcessableError"] = 1004] = "NotProcessableError";
    ErrorCode[ErrorCode["RateLimitError"] = 1005] = "RateLimitError";
    ErrorCode[ErrorCode["ServerError"] = 1006] = "ServerError";
    ErrorCode[ErrorCode["SlippageError"] = 1007] = "SlippageError";
    ErrorCode[ErrorCode["ThirdPartyError"] = 1008] = "ThirdPartyError";
    ErrorCode[ErrorCode["TimeoutError"] = 1009] = "TimeoutError";
    ErrorCode[ErrorCode["UnauthorizedError"] = 1010] = "UnauthorizedError";
    ErrorCode[ErrorCode["ValidationError"] = 1011] = "ValidationError";
})($611f1cccc78c5f9a$export$d4e71bc0b80dc0fb || ($611f1cccc78c5f9a$export$d4e71bc0b80dc0fb = {}));







var $b6aa7c63b666337d$var$ErrorType;
(function(ErrorType) {
    ErrorType["RPCError"] = "RPCError";
    ErrorType["ProviderError"] = "ProviderError";
    ErrorType["ServerError"] = "ServerError";
    ErrorType["TransactionError"] = "TransactionError";
    ErrorType["ValidationError"] = "ValidationError";
    ErrorType["NotFoundError"] = "NotFoundError";
    ErrorType["UnknownError"] = "UnknownError";
    ErrorType["SlippageError"] = "SlippageError";
})($b6aa7c63b666337d$var$ErrorType || ($b6aa7c63b666337d$var$ErrorType = {}));
var $b6aa7c63b666337d$export$fe007b9cf5c9f36b;
(function(LifiErrorCode) {
    LifiErrorCode[LifiErrorCode["InternalError"] = 1000] = "InternalError";
    LifiErrorCode[LifiErrorCode["ValidationError"] = 1001] = "ValidationError";
    LifiErrorCode[LifiErrorCode["TransactionUnderpriced"] = 1002] = "TransactionUnderpriced";
    LifiErrorCode[LifiErrorCode["TransactionFailed"] = 1003] = "TransactionFailed";
    LifiErrorCode[LifiErrorCode["Timeout"] = 1004] = "Timeout";
    LifiErrorCode[LifiErrorCode["ProviderUnavailable"] = 1005] = "ProviderUnavailable";
    LifiErrorCode[LifiErrorCode["NotFound"] = 1006] = "NotFound";
    LifiErrorCode[LifiErrorCode["ChainSwitchError"] = 1007] = "ChainSwitchError";
    LifiErrorCode[LifiErrorCode["TransactionUnprepared"] = 1008] = "TransactionUnprepared";
    LifiErrorCode[LifiErrorCode["GasLimitError"] = 1009] = "GasLimitError";
    LifiErrorCode[LifiErrorCode["TransactionCanceled"] = 1010] = "TransactionCanceled";
    LifiErrorCode[LifiErrorCode["SlippageError"] = 1011] = "SlippageError";
    LifiErrorCode[LifiErrorCode["TransactionRejected"] = 1012] = "TransactionRejected";
    LifiErrorCode[LifiErrorCode["BalanceError"] = 1013] = "BalanceError";
    LifiErrorCode[LifiErrorCode["AllowanceRequired"] = 1014] = "AllowanceRequired";
    LifiErrorCode[LifiErrorCode["InsufficientFunds"] = 1015] = "InsufficientFunds";
})($b6aa7c63b666337d$export$fe007b9cf5c9f36b || ($b6aa7c63b666337d$export$fe007b9cf5c9f36b = {}));
var $b6aa7c63b666337d$export$f5c66e6f9b91f78;
(function(EthersErrorType) {
    EthersErrorType["ActionRejected"] = "ACTION_REJECTED";
    EthersErrorType["CallExecption"] = "CALL_EXCEPTION";
    EthersErrorType["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
})($b6aa7c63b666337d$export$f5c66e6f9b91f78 || ($b6aa7c63b666337d$export$f5c66e6f9b91f78 = {}));
var $b6aa7c63b666337d$export$5923f92edcc7db5f;
(function(EthersErrorMessage) {
    EthersErrorMessage["ERC20Allowance"] = "ERC20: transfer amount exceeds allowance";
    EthersErrorMessage["LowGas"] = "intrinsic gas too low";
    EthersErrorMessage["OutOfGas"] = "out of gas";
    EthersErrorMessage["Underpriced"] = "underpriced";
    EthersErrorMessage["LowReplacementFee"] = "replacement fee too low";
})($b6aa7c63b666337d$export$5923f92edcc7db5f || ($b6aa7c63b666337d$export$5923f92edcc7db5f = {}));
var $b6aa7c63b666337d$export$915e9e7bd4f0f96d;
(function(ErrorMessage) {
    ErrorMessage["UnknownError"] = "Unknown error occurred.";
    ErrorMessage["SlippageError"] = "The slippage is larger than the defined threshold. Please request a new route to get a fresh quote.";
    ErrorMessage["GasLimitLow"] = "Gas limit is too low.";
    ErrorMessage["TransactionUnderpriced"] = "Transaction is underpriced.";
    ErrorMessage["Default"] = "Something went wrong.";
})($b6aa7c63b666337d$export$915e9e7bd4f0f96d || ($b6aa7c63b666337d$export$915e9e7bd4f0f96d = {}));
var $b6aa7c63b666337d$export$712f1362a2ba1b57;
(function(MetaMaskRPCErrorCode) {
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["invalidInput"] = -32000] = "invalidInput";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["resourceNotFound"] = -32001] = "resourceNotFound";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["resourceUnavailable"] = -32002] = "resourceUnavailable";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["transactionRejected"] = -32003] = "transactionRejected";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["methodNotSupported"] = -32004] = "methodNotSupported";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["limitExceeded"] = -32005] = "limitExceeded";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["parse"] = -32700] = "parse";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["invalidRequest"] = -32600] = "invalidRequest";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["methodNotFound"] = -32601] = "methodNotFound";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["invalidParams"] = -32602] = "invalidParams";
    MetaMaskRPCErrorCode[MetaMaskRPCErrorCode["internal"] = -32603] = "internal";
})($b6aa7c63b666337d$export$712f1362a2ba1b57 || ($b6aa7c63b666337d$export$712f1362a2ba1b57 = {}));
var $b6aa7c63b666337d$export$54cb5cb2ed5e1b42;
(function(MetaMaskProviderErrorCode) {
    MetaMaskProviderErrorCode[MetaMaskProviderErrorCode["userRejectedRequest"] = 4001] = "userRejectedRequest";
    MetaMaskProviderErrorCode[MetaMaskProviderErrorCode["unauthorized"] = 4100] = "unauthorized";
    MetaMaskProviderErrorCode[MetaMaskProviderErrorCode["unsupportedMethod"] = 4200] = "unsupportedMethod";
    MetaMaskProviderErrorCode[MetaMaskProviderErrorCode["disconnected"] = 4900] = "disconnected";
    MetaMaskProviderErrorCode[MetaMaskProviderErrorCode["chainDisconnected"] = 4901] = "chainDisconnected";
})($b6aa7c63b666337d$export$54cb5cb2ed5e1b42 || ($b6aa7c63b666337d$export$54cb5cb2ed5e1b42 = {}));
class $b6aa7c63b666337d$export$f10322d889e30ec6 extends Error {
    constructor(type, code, message, htmlMessage, stack){
        super(message);
        // Set the prototype explicitly: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b6aa7c63b666337d$export$f10322d889e30ec6.prototype);
        this.code = code;
        // the name property is used by toString(). It is a string and we can't use our custom ErrorTypes, that's why we have to cast
        this.name = type.toString();
        this.htmlMessage = htmlMessage;
        // passing a stack allows us to preserve the stack from errors that we caught and just want to transform in one of our custom errors
        if (stack) this.stack = stack;
    }
}
class $b6aa7c63b666337d$export$1161c93bc08b4939 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(code, message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.RPCError, code, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$478ec1fdae99aa79 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(code, message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.ProviderError, code, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$ea52035eac03daf0 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.ServerError, $b6aa7c63b666337d$export$fe007b9cf5c9f36b.InternalError, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$2191b9da168c6cf0 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.ValidationError, $b6aa7c63b666337d$export$fe007b9cf5c9f36b.ValidationError, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$9dd357eddc48a7ff extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(code, message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.TransactionError, code, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$c2590ba98a2d1788 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.SlippageError, $b6aa7c63b666337d$export$fe007b9cf5c9f36b.SlippageError, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$3854bf6bc7d34120 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.ValidationError, $b6aa7c63b666337d$export$fe007b9cf5c9f36b.BalanceError, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$78c95b58762d2106 extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.NotFoundError, $b6aa7c63b666337d$export$fe007b9cf5c9f36b.NotFound, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$ff4405149dbd0c5c extends $b6aa7c63b666337d$export$f10322d889e30ec6 {
    constructor(code, message, htmlMessage, stack){
        super($b6aa7c63b666337d$var$ErrorType.UnknownError, code, message, htmlMessage, stack);
    }
}
class $b6aa7c63b666337d$export$aa9d629c530f62a7 extends Error {
    constructor(response){
        const code = response.status || response.status === 0 ? response.status : "";
        const title = response.statusText || "";
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : "an unknown error";
        super(`Request failed with ${reason}`);
        this.name = "HTTPError";
        this.response = response;
        this.status = response.status;
    }
}


const $0300b294012d359d$export$89843982d7e60b14 = [
    {
        name: "approve",
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        name: "allowance",
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];






var $323ab58d73f95cd0$exports = {};
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $323ab58d73f95cd0$exports) $323ab58d73f95cd0$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($323ab58d73f95cd0$exports);



const $efbe31fc65013819$var$DefaultExecutionSettings = {
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */ updateRouteHook: ()=>{},
    switchChainHook: ()=>Promise.resolve(undefined),
    acceptExchangeRateUpdateHook: ()=>Promise.resolve(undefined),
    infiniteApproval: false,
    executeInBackground: false
};
class $efbe31fc65013819$var$ConfigService {
    constructor(){
        this.resolveSetupPromise = undefined;
        /**
         * This call immediately returns the current config. It does not make sure that all chain data is already loaded
         * Use this if you need access to basic information like API urls or settings
         */ this.getConfig = ()=>{
            return this.config;
        };
        /**
         * This call waits for all setup promises to be done.
         * Use this if you need access to chain data (RPCs or multicalls)
         */ this.getConfigAsync = async ()=>{
            await this.setupPromise;
            return this.config;
        };
        this.updateConfig = (configUpdate)=>{
            // API
            this.config.apiUrl = configUpdate.apiUrl || this.config.apiUrl;
            // RPCS
            this.config.rpcs = Object.assign(this.config.rpcs, configUpdate.rpcs);
            // MULTICALL
            this.config.multicallAddresses = Object.assign(this.config.multicallAddresses, configUpdate.multicallAddresses);
            // SETTINGS
            this.config.defaultExecutionSettings = Object.assign(this.config.defaultExecutionSettings, configUpdate.defaultExecutionSettings);
            // OPTIONS
            this.config.defaultRouteOptions = Object.assign(this.config.defaultRouteOptions, configUpdate.defaultRouteOptions);
            this.config.apiKey = configUpdate.apiKey || this.config.apiKey;
            this.config.userId = configUpdate.userId || this.config.userId;
            this.config.integrator = configUpdate.integrator || this.config.integrator;
            this.config.defaultRouteOptions.integrator = configUpdate.integrator || configUpdate.defaultRouteOptions?.integrator || this.config.integrator;
            this.config.widgetVersion = configUpdate.widgetVersion || this.config.widgetVersion;
            this.config.multisigConfig = configUpdate.multisigConfig || this.config.multisigConfig;
            return this.config;
        };
        this.updateChains = (chains)=>{
            for (const chain of chains){
                const chainId = chain.id;
                // set RPCs if they were not configured by the user before
                if (!this.config.rpcs[chainId]?.length) this.config.rpcs[chainId] = chain.metamask.rpcUrls;
                // set multicall addresses if they exist and were not configured by the user before
                if (chain.multicallAddress && !this.config.multicallAddresses[chainId]) this.config.multicallAddresses[chainId] = chain.multicallAddress;
            }
            this.resolveSetupPromise?.();
            return this.config;
        };
        this.config = $efbe31fc65013819$var$ConfigService.getDefaultConfig();
        this.setupPromise = new Promise((resolve)=>{
            this.resolveSetupPromise = resolve;
        });
    }
    static chainIdToObject(val) {
        const result = {};
        const values = Object.values((0, $664d8775a51d964a$export$c06e1e7429de6283));
        values.forEach((chainId)=>{
            if (typeof chainId !== "string") result[chainId] = val ? JSON.parse(JSON.stringify(val)) : val;
        });
        return result;
    }
    static getInstance() {
        if (!this.instance) this.instance = new $efbe31fc65013819$var$ConfigService();
        return this.instance;
    }
}
$efbe31fc65013819$var$ConfigService.getDefaultConfig = ()=>{
    return {
        apiUrl: "https://li.quest/v1",
        rpcs: $efbe31fc65013819$var$ConfigService.chainIdToObject([]),
        multicallAddresses: $efbe31fc65013819$var$ConfigService.chainIdToObject(undefined),
        defaultExecutionSettings: $efbe31fc65013819$var$DefaultExecutionSettings,
        defaultRouteOptions: {
            integrator: "lifi-sdk"
        },
        integrator: "lifi-sdk"
    };
};
var $efbe31fc65013819$export$2e2bcd8739ae039 = $efbe31fc65013819$var$ConfigService;





var $ltcCO = parcelRequire("ltcCO");
parcelRequire("8VNI3");
var $80lZU = parcelRequire("80lZU");
var $cBOfq = parcelRequire("cBOfq");


const $d95ba1f5d0f173ae$export$a8ff84c12d48cfa6 = "@tractors/lifi-sdk-parcel";
const $d95ba1f5d0f173ae$export$83d89fbfd8236492 = "2.5.3";


const $c98bbf8bc8a02c8a$var$ethereumRequest = async (method, params)=>{
    // If ethereum.request() exists, the provider is probably EIP-1193 compliant.
    if (!ethereum?.request) throw new Error("Provider not available.");
    return ethereum.request({
        method: method,
        params: params
    });
};
const $c98bbf8bc8a02c8a$export$fb66c9a05e998ce0 = (walletAddress)=>{
    return (encryptedData)=>{
        return $c98bbf8bc8a02c8a$var$ethereumRequest("eth_decrypt", [
            encryptedData,
            walletAddress
        ]);
    };
};
const $c98bbf8bc8a02c8a$export$7d29da0cae32a638 = (walletAddress)=>{
    return ()=>{
        return $c98bbf8bc8a02c8a$var$ethereumRequest("eth_getEncryptionPublicKey", [
            walletAddress
        ]);
    };
};
const $c98bbf8bc8a02c8a$export$eab19c48dcb6310d = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1) + min);
};
const $c98bbf8bc8a02c8a$export$31799251d373ac68 = (tokenA, tokenB)=>tokenA.chainId === tokenB.chainId && tokenA.address.toLowerCase() === tokenB.address.toLowerCase();
function $c98bbf8bc8a02c8a$var$semverCompare(a, b) {
    if (a.startsWith(b + "-")) return -1;
    if (b.startsWith(a + "-")) return 1;
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: "case",
        caseFirst: "upper"
    });
}
const $c98bbf8bc8a02c8a$export$9fe272d016535f0b = async (packageName, packageVersion, disableCheck)=>{
    var error;
    return;
};
const $c98bbf8bc8a02c8a$export$a9651e84c0102bb7 = (step)=>{
    if (!step.estimate.fromAmountUSD) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Missing 'fromAmountUSD' in step estimate.");
    if (!step.estimate.toAmountUSD) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Missing 'toAmountUSD' in step estimate.");
    const route = {
        fromToken: step.action.fromToken,
        toToken: step.action.toToken,
        fromAmount: step.action.fromAmount,
        toAmount: step.estimate.toAmount,
        id: step.id,
        fromChainId: step.action.fromToken.chainId,
        toChainId: step.action.toToken.chainId,
        fromAmountUSD: step.estimate.fromAmountUSD,
        toAmountUSD: step.estimate.toAmountUSD,
        steps: [
            step
        ],
        toAmountMin: step.estimate.toAmountMin,
        insurance: {
            state: "NOT_INSURABLE",
            feeAmountUsd: "0"
        }
    };
    return route;
};
const $c98bbf8bc8a02c8a$export$2c08cff8406d70bc = async (txHash, chainId)=>{
    const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`https://api.tenderly.co/api/v1/public-contract/${chainId}/tx/${txHash}`);
    return response;
};





// cached providers
const $1fe769d8e0ee09c9$var$chainProviders = {};
// Archive RPC Provider
const $1fe769d8e0ee09c9$var$archiveRpcs = {
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).ETH]: "https://speedy-nodes-nyc.moralis.io/5ed6053dc39eba789ff466c9/eth/mainnet/archive",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).BSC]: "https://speedy-nodes-nyc.moralis.io/5ed6053dc39eba789ff466c9/bsc/mainnet/archive",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).POL]: "https://speedy-nodes-nyc.moralis.io/5ed6053dc39eba789ff466c9/polygon/mainnet/archive",
    [(0, $664d8775a51d964a$export$c06e1e7429de6283).FTM]: "https://speedy-nodes-nyc.moralis.io/5ed6053dc39eba789ff466c9/fantom/mainnet"
};
const $1fe769d8e0ee09c9$export$cea56c0e6b0b9390 = async (chainId, archive = false)=>{
    const rpcUrls = await $1fe769d8e0ee09c9$export$af9d6c6ce27802c9(chainId, archive);
    return rpcUrls[0];
};
const $1fe769d8e0ee09c9$export$af9d6c6ce27802c9 = async (chainId, archive = false)=>{
    if (archive && $1fe769d8e0ee09c9$var$archiveRpcs[chainId]) return [
        $1fe769d8e0ee09c9$var$archiveRpcs[chainId]
    ];
    const configService = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance();
    const config = await configService.getConfigAsync();
    return config.rpcs[chainId];
};
const $1fe769d8e0ee09c9$var$getRandomProvider = (providerList)=>{
    const index = (0, $c98bbf8bc8a02c8a$export$eab19c48dcb6310d)(0, providerList.length - 1);
    return providerList[index];
};
const $1fe769d8e0ee09c9$export$1a2da1764918cffa = async (chainId, archive = false)=>{
    if (archive && $1fe769d8e0ee09c9$var$archiveRpcs[chainId]) // return archive PRC, but don't cache it
    return new (0, $80lZU.FallbackProvider)([
        new (0, $cBOfq.StaticJsonRpcProvider)(await $1fe769d8e0ee09c9$export$cea56c0e6b0b9390(chainId, archive), chainId)
    ]);
    if (!$1fe769d8e0ee09c9$var$chainProviders[chainId]?.length) {
        $1fe769d8e0ee09c9$var$chainProviders[chainId] = [];
        const urls = await $1fe769d8e0ee09c9$export$af9d6c6ce27802c9(chainId, archive);
        urls.forEach((url)=>{
            $1fe769d8e0ee09c9$var$chainProviders[chainId].push(new (0, $80lZU.FallbackProvider)([
                new (0, $cBOfq.StaticJsonRpcProvider)(url, chainId)
            ]));
        });
    }
    if (!$1fe769d8e0ee09c9$var$chainProviders[chainId].length) throw new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)(`Unable to configure provider for chain ${chainId}`);
    return $1fe769d8e0ee09c9$var$getRandomProvider($1fe769d8e0ee09c9$var$chainProviders[chainId]);
};
const $1fe769d8e0ee09c9$export$d637027b214eb1ae = async (chainId)=>{
    const configService = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance();
    const config = await configService.getConfigAsync();
    return config.multicallAddresses[chainId];
};


const $23f7b917c62af19c$export$e772c8ff12451969 = (mills)=>{
    return new Promise((resolve)=>{
        setTimeout(resolve, mills);
    });
};
const $23f7b917c62af19c$export$7d7a0973a46be702 = async (signer, step)=>{
    if (step.action.toAddress && step.action.fromAddress) return step;
    const address = await signer.getAddress();
    const fromAddress = step.action.fromAddress || address;
    const toAddress = step.action.toAddress || address;
    return {
        ...step,
        action: {
            ...step.action,
            fromAddress: fromAddress,
            toAddress: toAddress
        }
    };
};
const $23f7b917c62af19c$export$cbdaa1f7433858de = (list, chunkSize)=>list.reduce((resultList, item, index)=>{
        const chunkIndex = Math.floor(index / chunkSize);
        if (!resultList[chunkIndex]) resultList[chunkIndex] = []; // start a new chunk
        resultList[chunkIndex].push(item);
        return resultList;
    }, []);
const $23f7b917c62af19c$export$46e63d905aeceed0 = (token, amount)=>{
    if (!amount) return "0.0";
    let floated;
    if (typeof amount === "string") {
        if (amount === "0") return "0.0";
        floated = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(amount).shiftedBy(-token.decimals);
    } else {
        floated = amount;
        if (floated.isZero()) return "0.0";
    }
    // show at least 4 decimal places and at least two non-zero digests
    let decimalPlaces = 3;
    while(floated.lt(1 / 10 ** decimalPlaces))decimalPlaces++;
    return floated.toFixed(decimalPlaces + 1, 1);
};
const $23f7b917c62af19c$export$2a305b84cb949d18 = async (toRepeat, timeout = 5000)=>{
    let result;
    while(!result){
        result = await toRepeat();
        if (!result) await $23f7b917c62af19c$export$e772c8ff12451969(timeout);
    }
    return result;
};
const $23f7b917c62af19c$export$53a06b77707b3d18 = async (chainId, txHash)=>{
    const rpc = await (0, $1fe769d8e0ee09c9$export$1a2da1764918cffa)(chainId);
    const tx = await rpc.getTransaction(txHash);
    return tx.wait();
};
const $23f7b917c62af19c$export$33367b16affb40dd = (address)=>{
    if (address === (0, $ltcCO).AddressZero || address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee") return true;
    return false;
};
const $23f7b917c62af19c$export$f2a4f85dc24b631e = (address)=>{
    if (address === (0, $ltcCO).AddressZero || address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" || // CELO native token
    address === "0x471ece3750da237f93b8e339c536989b8978a438") return true;
    return false;
};



const $d85a17d0bb819c54$export$d6ee1611cefc1bf = {
    retries: 1
};
const $d85a17d0bb819c54$export$b5fe3f66a567bec0 = async (url, options = {
    retries: $d85a17d0bb819c54$export$d6ee1611cefc1bf.retries
})=>{
    const { userId: userId, integrator: integrator, widgetVersion: widgetVersion, apiKey: apiKey } = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    options.retries = options.retries ?? $d85a17d0bb819c54$export$d6ee1611cefc1bf.retries;
    try {
        if (!options.skipTrackingHeaders) {
            if (apiKey) options.headers = {
                ...options.headers,
                "x-lifi-api-key": apiKey
            };
            if (userId) options.headers = {
                ...options.headers,
                "x-lifi-userid": userId
            };
            if (widgetVersion) options.headers = {
                ...options.headers,
                "x-lifi-widget": widgetVersion
            };
            if (0, $d95ba1f5d0f173ae$export$83d89fbfd8236492) options.headers = {
                ...options.headers,
                "x-lifi-sdk": (0, $d95ba1f5d0f173ae$export$83d89fbfd8236492)
            };
            // integrator is mandatory during SDK initialization
            options.headers = {
                ...options.headers,
                "x-lifi-integrator": integrator
            };
        }
        const response = await fetch(url, options);
        if (!response.ok) throw new (0, $b6aa7c63b666337d$export$aa9d629c530f62a7)(response);
        const data = await response.json();
        return data;
    } catch (error) {
        if (options.retries > 0 && error?.status === 500) {
            await (0, $23f7b917c62af19c$export$e772c8ff12451969)(500);
            return $d85a17d0bb819c54$export$b5fe3f66a567bec0(url, {
                ...options,
                retries: options.retries - 1
            });
        }
        throw error;
    }
};


const $b2df358172b4a603$export$f850eaa67d786012 = (routesRequest)=>{
    const { fromChainId: fromChainId, fromAmount: fromAmount, fromTokenAddress: fromTokenAddress, toChainId: toChainId, toTokenAddress: toTokenAddress, options: options } = routesRequest;
    return typeof fromChainId === "number" && typeof fromAmount === "string" && fromAmount !== "" && typeof fromTokenAddress === "string" && fromTokenAddress !== "" && typeof toChainId === "number" && typeof toTokenAddress === "string" && toTokenAddress !== "" && (!options || $b2df358172b4a603$var$isRoutesOptions(options));
};
const $b2df358172b4a603$var$isRoutesOptions = (routeOptions)=>!routeOptions?.slippage || typeof routeOptions.slippage === "number";
const $b2df358172b4a603$export$21684750287da054 = (step)=>{
    const { id: id, type: type, tool: tool, action: action, estimate: estimate } = step;
    return typeof id === "string" && [
        "swap",
        "cross",
        "lifi"
    ].includes(type) && typeof tool === "string" && $b2df358172b4a603$var$isAction(action) && $b2df358172b4a603$var$isEstimate(estimate);
};
const $b2df358172b4a603$var$isAction = (action)=>{
    const { fromChainId: fromChainId, fromAmount: fromAmount, fromToken: fromToken, toChainId: toChainId, toToken: toToken, slippage: slippage } = action;
    return typeof fromChainId === "number" && typeof fromAmount === "string" && fromAmount !== "" && $b2df358172b4a603$export$7c699a821ea811bc(fromToken) && typeof toChainId === "number" && $b2df358172b4a603$export$7c699a821ea811bc(toToken) && typeof slippage === "number";
};
const $b2df358172b4a603$var$isEstimate = (estimate)=>{
    const { fromAmount: fromAmount, toAmount: toAmount, toAmountMin: toAmountMin, approvalAddress: approvalAddress } = estimate;
    return typeof fromAmount === "string" && fromAmount !== "" && typeof toAmount === "string" && toAmount !== "" && typeof toAmountMin === "string" && toAmountMin !== "" && typeof approvalAddress === "string";
};
const $b2df358172b4a603$export$7c699a821ea811bc = (token)=>{
    const { address: address, decimals: decimals, chainId: chainId } = token;
    return typeof address === "string" && typeof decimals === "number" && typeof chainId === "number";
};



var $181d20f7e0f896fb$exports = {};
"use strict";
Object.defineProperty($181d20f7e0f896fb$exports, "__esModule", {
    value: true
});
$181d20f7e0f896fb$exports.getMessageFromCode = $181d20f7e0f896fb$exports.serializeError = $181d20f7e0f896fb$exports.EthereumProviderError = $181d20f7e0f896fb$exports.EthereumRpcError = $181d20f7e0f896fb$exports.ethErrors = $181d20f7e0f896fb$exports.errorCodes = void 0;
var $1f1e3b873ab0a060$exports = {};
"use strict";
Object.defineProperty($1f1e3b873ab0a060$exports, "__esModule", {
    value: true
});
$1f1e3b873ab0a060$exports.EthereumProviderError = $1f1e3b873ab0a060$exports.EthereumRpcError = void 0;
var $b536c7ecd363e2cd$exports = {};
$b536c7ecd363e2cd$exports = $b536c7ecd363e2cd$var$stringify;
$b536c7ecd363e2cd$var$stringify.default = $b536c7ecd363e2cd$var$stringify;
$b536c7ecd363e2cd$var$stringify.stable = $b536c7ecd363e2cd$var$deterministicStringify;
$b536c7ecd363e2cd$var$stringify.stableStringify = $b536c7ecd363e2cd$var$deterministicStringify;
var $b536c7ecd363e2cd$var$LIMIT_REPLACE_NODE = "[...]";
var $b536c7ecd363e2cd$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $b536c7ecd363e2cd$var$arr = [];
var $b536c7ecd363e2cd$var$replacerStack = [];
function $b536c7ecd363e2cd$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $b536c7ecd363e2cd$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $b536c7ecd363e2cd$var$defaultOptions();
    $b536c7ecd363e2cd$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($b536c7ecd363e2cd$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $b536c7ecd363e2cd$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($b536c7ecd363e2cd$var$arr.length !== 0){
            var part = $b536c7ecd363e2cd$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $b536c7ecd363e2cd$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $b536c7ecd363e2cd$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $b536c7ecd363e2cd$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $b536c7ecd363e2cd$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $b536c7ecd363e2cd$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$b536c7ecd363e2cd$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $b536c7ecd363e2cd$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $b536c7ecd363e2cd$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $b536c7ecd363e2cd$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $b536c7ecd363e2cd$var$defaultOptions();
    var tmp = $b536c7ecd363e2cd$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($b536c7ecd363e2cd$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $b536c7ecd363e2cd$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($b536c7ecd363e2cd$var$arr.length !== 0){
            var part = $b536c7ecd363e2cd$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $b536c7ecd363e2cd$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $b536c7ecd363e2cd$var$setReplace($b536c7ecd363e2cd$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$b536c7ecd363e2cd$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($b536c7ecd363e2cd$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $b536c7ecd363e2cd$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $b536c7ecd363e2cd$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $b536c7ecd363e2cd$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($b536c7ecd363e2cd$var$replacerStack.length > 0) for(var i = 0; i < $b536c7ecd363e2cd$var$replacerStack.length; i++){
            var part = $b536c7ecd363e2cd$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $b536c7ecd363e2cd$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}


/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP-1474.
 * Permits any integer error code.
 */ class $1f1e3b873ab0a060$var$EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
    /**
     * Returns a plain object with all public class properties.
     */ serialize() {
        const serialized = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) serialized.data = this.data;
        if (this.stack) serialized.stack = this.stack;
        return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     */ toString() {
        return $b536c7ecd363e2cd$exports.default(this.serialize(), $1f1e3b873ab0a060$var$stringifyReplacer, 2);
    }
}
$1f1e3b873ab0a060$exports.EthereumRpcError = $1f1e3b873ab0a060$var$EthereumRpcError;
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */ class $1f1e3b873ab0a060$var$EthereumProviderError extends $1f1e3b873ab0a060$var$EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!$1f1e3b873ab0a060$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
$1f1e3b873ab0a060$exports.EthereumProviderError = $1f1e3b873ab0a060$var$EthereumProviderError;
// Internal
function $1f1e3b873ab0a060$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function $1f1e3b873ab0a060$var$stringifyReplacer(_, value) {
    if (value === "[Circular]") return undefined;
    return value;
}


Object.defineProperty($181d20f7e0f896fb$exports, "EthereumRpcError", {
    enumerable: true,
    get: function() {
        return $1f1e3b873ab0a060$exports.EthereumRpcError;
    }
});
Object.defineProperty($181d20f7e0f896fb$exports, "EthereumProviderError", {
    enumerable: true,
    get: function() {
        return $1f1e3b873ab0a060$exports.EthereumProviderError;
    }
});
var $85ad1a5c577784e3$exports = {};
"use strict";
Object.defineProperty($85ad1a5c577784e3$exports, "__esModule", {
    value: true
});
$85ad1a5c577784e3$exports.serializeError = $85ad1a5c577784e3$exports.isValidCode = $85ad1a5c577784e3$exports.getMessageFromCode = $85ad1a5c577784e3$exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
var $6c55857ee6946642$exports = {};
"use strict";
Object.defineProperty($6c55857ee6946642$exports, "__esModule", {
    value: true
});
$6c55857ee6946642$exports.errorValues = $6c55857ee6946642$exports.errorCodes = void 0;
$6c55857ee6946642$exports.errorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
$6c55857ee6946642$exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    }
};



const $85ad1a5c577784e3$var$FALLBACK_ERROR_CODE = $6c55857ee6946642$exports.errorCodes.rpc.internal;
const $85ad1a5c577784e3$var$FALLBACK_MESSAGE = "Unspecified error message. This is a bug, please report it.";
const $85ad1a5c577784e3$var$FALLBACK_ERROR = {
    code: $85ad1a5c577784e3$var$FALLBACK_ERROR_CODE,
    message: $85ad1a5c577784e3$var$getMessageFromCode($85ad1a5c577784e3$var$FALLBACK_ERROR_CODE)
};
$85ad1a5c577784e3$exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function $85ad1a5c577784e3$var$getMessageFromCode(code, fallbackMessage = $85ad1a5c577784e3$var$FALLBACK_MESSAGE) {
    if (Number.isInteger(code)) {
        const codeString = code.toString();
        if ($85ad1a5c577784e3$var$hasKey($6c55857ee6946642$exports.errorValues, codeString)) return $6c55857ee6946642$exports.errorValues[codeString].message;
        if ($85ad1a5c577784e3$var$isJsonRpcServerError(code)) return $85ad1a5c577784e3$exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
$85ad1a5c577784e3$exports.getMessageFromCode = $85ad1a5c577784e3$var$getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function $85ad1a5c577784e3$var$isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if ($6c55857ee6946642$exports.errorValues[codeString]) return true;
    if ($85ad1a5c577784e3$var$isJsonRpcServerError(code)) return true;
    return false;
}
$85ad1a5c577784e3$exports.isValidCode = $85ad1a5c577784e3$var$isValidCode;
/**
 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
 * Merely copies the given error's values if it is already compatible.
 * If the given error is not fully compatible, it will be preserved on the
 * returned object's data.originalError property.
 */ function $85ad1a5c577784e3$var$serializeError(error, { fallbackError: fallbackError = $85ad1a5c577784e3$var$FALLBACK_ERROR, shouldIncludeStack: shouldIncludeStack = false } = {}) {
    var _a, _b;
    if (!fallbackError || !Number.isInteger(fallbackError.code) || typeof fallbackError.message !== "string") throw new Error("Must provide fallback error with integer number code and string message.");
    if (error instanceof $1f1e3b873ab0a060$exports.EthereumRpcError) return error.serialize();
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $85ad1a5c577784e3$var$hasKey(error, "code") && $85ad1a5c577784e3$var$isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($85ad1a5c577784e3$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $85ad1a5c577784e3$var$getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: $85ad1a5c577784e3$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = fallbackError.code;
        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
        serialized.message = message && typeof message === "string" ? message : fallbackError.message;
        serialized.data = {
            originalError: $85ad1a5c577784e3$var$assignOriginalError(error)
        };
    }
    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
    if (shouldIncludeStack && error && stack && typeof stack === "string") serialized.stack = stack;
    return serialized;
}
$85ad1a5c577784e3$exports.serializeError = $85ad1a5c577784e3$var$serializeError;
// Internal
function $85ad1a5c577784e3$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $85ad1a5c577784e3$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $85ad1a5c577784e3$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}


Object.defineProperty($181d20f7e0f896fb$exports, "serializeError", {
    enumerable: true,
    get: function() {
        return $85ad1a5c577784e3$exports.serializeError;
    }
});
Object.defineProperty($181d20f7e0f896fb$exports, "getMessageFromCode", {
    enumerable: true,
    get: function() {
        return $85ad1a5c577784e3$exports.getMessageFromCode;
    }
});
var $0825fe97201e1679$exports = {};
"use strict";
Object.defineProperty($0825fe97201e1679$exports, "__esModule", {
    value: true
});
$0825fe97201e1679$exports.ethErrors = void 0;



$0825fe97201e1679$exports.ethErrors = {
    rpc: {
        /**
         * Get a JSON RPC 2.0 Parse (-32700) error.
         */ parse: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.parse, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
         */ invalidRequest: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.invalidRequest, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
         */ invalidParams: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.invalidParams, arg),
        /**
         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
         */ methodNotFound: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.methodNotFound, arg),
        /**
         * Get a JSON RPC 2.0 Internal (-32603) error.
         */ internal: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.internal, arg),
        /**
         * Get a JSON RPC 2.0 Server error.
         * Permits integer error codes in the [ -32099 <= -32005 ] range.
         * Codes -32000 through -32004 are reserved by EIP-1474.
         */ server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code: code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $0825fe97201e1679$var$getEthJsonRpcError(code, opts);
        },
        /**
         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
         */ invalidInput: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.invalidInput, arg),
        /**
         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
         */ resourceNotFound: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.resourceNotFound, arg),
        /**
         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
         */ resourceUnavailable: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.resourceUnavailable, arg),
        /**
         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
         */ transactionRejected: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.transactionRejected, arg),
        /**
         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
         */ methodNotSupported: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.methodNotSupported, arg),
        /**
         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
         */ limitExceeded: (arg)=>$0825fe97201e1679$var$getEthJsonRpcError($6c55857ee6946642$exports.errorCodes.rpc.limitExceeded, arg)
    },
    provider: {
        /**
         * Get an Ethereum Provider User Rejected Request (4001) error.
         */ userRejectedRequest: (arg)=>{
            return $0825fe97201e1679$var$getEthProviderError($6c55857ee6946642$exports.errorCodes.provider.userRejectedRequest, arg);
        },
        /**
         * Get an Ethereum Provider Unauthorized (4100) error.
         */ unauthorized: (arg)=>{
            return $0825fe97201e1679$var$getEthProviderError($6c55857ee6946642$exports.errorCodes.provider.unauthorized, arg);
        },
        /**
         * Get an Ethereum Provider Unsupported Method (4200) error.
         */ unsupportedMethod: (arg)=>{
            return $0825fe97201e1679$var$getEthProviderError($6c55857ee6946642$exports.errorCodes.provider.unsupportedMethod, arg);
        },
        /**
         * Get an Ethereum Provider Not Connected (4900) error.
         */ disconnected: (arg)=>{
            return $0825fe97201e1679$var$getEthProviderError($6c55857ee6946642$exports.errorCodes.provider.disconnected, arg);
        },
        /**
         * Get an Ethereum Provider Chain Not Connected (4901) error.
         */ chainDisconnected: (arg)=>{
            return $0825fe97201e1679$var$getEthProviderError($6c55857ee6946642$exports.errorCodes.provider.chainDisconnected, arg);
        },
        /**
         * Get a custom Ethereum Provider error.
         */ custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code: code, message: message, data: data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $1f1e3b873ab0a060$exports.EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $0825fe97201e1679$var$getEthJsonRpcError(code, arg) {
    const [message, data] = $0825fe97201e1679$var$parseOpts(arg);
    return new $1f1e3b873ab0a060$exports.EthereumRpcError(code, message || $85ad1a5c577784e3$exports.getMessageFromCode(code), data);
}
function $0825fe97201e1679$var$getEthProviderError(code, arg) {
    const [message, data] = $0825fe97201e1679$var$parseOpts(arg);
    return new $1f1e3b873ab0a060$exports.EthereumProviderError(code, message || $85ad1a5c577784e3$exports.getMessageFromCode(code), data);
}
function $0825fe97201e1679$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message: message, data: data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}


Object.defineProperty($181d20f7e0f896fb$exports, "ethErrors", {
    enumerable: true,
    get: function() {
        return $0825fe97201e1679$exports.ethErrors;
    }
});

Object.defineProperty($181d20f7e0f896fb$exports, "errorCodes", {
    enumerable: true,
    get: function() {
        return $6c55857ee6946642$exports.errorCodes;
    }
});





class $5373603ab3f3b3c3$export$2e2bcd8739ae039 {
    constructor(){
        this.chains = [];
        this.loadingPromise = this.loadAvailableChains();
    }
    async loadAvailableChains() {
        try {
            this.chains = await (0, $988b46587540a82e$export$2e2bcd8739ae039).getChains();
        } catch (error) {
        // We try to load chains during initialization of the LiFi class and
        // because we no longer in scope of the constructor we fail silently here
        }
    }
    async checkLoading() {
        if (this.loadingPromise) await this.loadingPromise;
        if (!this.chains.length) await this.loadAvailableChains();
    }
    static getInstance() {
        if (!this.instance) this.instance = new $5373603ab3f3b3c3$export$2e2bcd8739ae039();
        return this.instance;
    }
    async getChainById(chainId) {
        await this.checkLoading();
        const chain = this.chains.find((chain)=>chain.id === chainId);
        if (!chain) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Unknown chainId passed: ${chainId}.`);
        return chain;
    }
    async getChains() {
        await this.checkLoading();
        return this.chains;
    }
}




const $c925d9fbcc898e0c$export$2dde327b9b0329a5 = async (step, process)=>{
    let transactionNotSend = "Transaction was not sent, your funds are still in your wallet";
    // add information about funds if available
    if (step) {
        const chainService = (0, $5373603ab3f3b3c3$export$2e2bcd8739ae039).getInstance();
        const chain = await chainService.getChainById(step.action.fromChainId);
        transactionNotSend += ` (${(0, $23f7b917c62af19c$export$46e63d905aeceed0)(step.action.fromToken, step.action.fromAmount)} ${step.action.fromToken.symbol} on ${chain.name})`;
    }
    transactionNotSend += ", please retry.<br/>If it still doesn't work, it is safe to delete this transfer and start a new one.";
    // add transaction explorer link if available
    transactionNotSend += process && process.txLink ? `<br>You can check the failed transaction&nbsp;<a href="${process.txLink}" target="_blank" rel="nofollow noreferrer">here</a>.` : "";
    return transactionNotSend;
};
const $c925d9fbcc898e0c$export$ab4f7fed7a3ee149 = async (step, txLink)=>{
    const chainsService = (0, $5373603ab3f3b3c3$export$2e2bcd8739ae039).getInstance();
    const chain = await chainsService.getChainById(step.action.toChainId);
    const baseString = `It appears that your transaction may not have been successful.
  However, to confirm this, please check your ${chain.name} wallet for ${step.action.toToken.symbol}.`;
    return txLink ? `${baseString}
    You can also check the&nbsp;<a href="${txLink}" target="_blank" rel="nofollow noreferrer">block explorer</a> for more information.` : baseString;
};
const $c925d9fbcc898e0c$export$e80a9284539c1797 = async (e, step, process)=>{
    if (e instanceof (0, $b6aa7c63b666337d$export$f10322d889e30ec6)) return e;
    if (e.code) // MetaMask errors have a numeric error code
    {
        if (typeof e.code === "number") {
            if (Object.values((0, $181d20f7e0f896fb$exports.errorCodes).rpc).includes(e.code)) {
                // rpc errors
                // underpriced errors are sent as internal errors, so we need to parse the message manually
                if (e.code === (0, $181d20f7e0f896fb$exports.errorCodes).rpc.internal && (e.message?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).Underpriced) || e.message?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).LowReplacementFee))) return new (0, $b6aa7c63b666337d$export$1161c93bc08b4939)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnderpriced, (0, $b6aa7c63b666337d$export$915e9e7bd4f0f96d).TransactionUnderpriced, await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
                if (e.message?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).LowGas) || e.message?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).OutOfGas)) return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).GasLimitError, (0, $b6aa7c63b666337d$export$915e9e7bd4f0f96d).GasLimitLow, await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
                return new (0, $b6aa7c63b666337d$export$1161c93bc08b4939)(e.code, (0, $181d20f7e0f896fb$exports.getMessageFromCode)(e.code), await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
            }
            // provider errors
            if (Object.values((0, $181d20f7e0f896fb$exports.errorCodes).provider).includes(e.code)) return new (0, $b6aa7c63b666337d$export$478ec1fdae99aa79)(e.code, (0, $181d20f7e0f896fb$exports.getMessageFromCode)(e.code), await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
        }
    }
    switch(e.code){
        case (0, $b6aa7c63b666337d$export$f5c66e6f9b91f78).CallExecption:
            const defaultErrorMessage = await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process);
            try {
                if (!step?.action.fromChainId) throw new Error("Signer is not defined.");
                const response = await (0, $c98bbf8bc8a02c8a$export$2c08cff8406d70bc)(e.transactionHash, step?.action.fromChainId);
                const errorMessage = response?.error_message ?? e.reason;
                const isAllowanceError = response?.error_message?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).ERC20Allowance) || e.reason?.includes((0, $b6aa7c63b666337d$export$5923f92edcc7db5f).ERC20Allowance);
                if (isAllowanceError) return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).AllowanceRequired, e.reason, errorMessage, e.stack);
                // Error messages other than allowance error will be handled in catch block
                throw new Error(e);
            } catch (error) {
                return new (0, $b6aa7c63b666337d$export$478ec1fdae99aa79)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionFailed, e.reason, defaultErrorMessage, e.stack);
            }
        case (0, $b6aa7c63b666337d$export$f5c66e6f9b91f78).InsufficientFunds:
            return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).InsufficientFunds, e.message, await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
        case (0, $b6aa7c63b666337d$export$f5c66e6f9b91f78).ActionRejected:
        case (0, $b6aa7c63b666337d$export$54cb5cb2ed5e1b42).userRejectedRequest:
            return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionRejected, e.message, await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
        case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnprepared:
            return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnprepared, e.message, await $c925d9fbcc898e0c$export$2dde327b9b0329a5(step, process), e.stack);
        case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ValidationError:
            return new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ValidationError, e.message, e.htmlMessage);
        default:
            return new (0, $b6aa7c63b666337d$export$ff4405149dbd0c5c)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).InternalError, e.message || (0, $b6aa7c63b666337d$export$915e9e7bd4f0f96d).UnknownError, undefined, e.stack);
    }
};
const $c925d9fbcc898e0c$export$9b596bfc8ebcb202 = async (e)=>{
    let data;
    try {
        data = await e.response?.json();
    } catch (error) {
    // ignore
    }
    if (e.response?.status === 400) return new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(data?.message || e.response?.statusText, undefined, e.stack);
    if (e.response?.status === 404) return new (0, $b6aa7c63b666337d$export$78c95b58762d2106)(data?.message || e.response?.statusText, undefined, e.stack);
    if (e.response?.status === 409) return new (0, $b6aa7c63b666337d$export$c2590ba98a2d1788)(data?.message || e.response?.statusText, (0, $b6aa7c63b666337d$export$915e9e7bd4f0f96d).SlippageError, e.stack);
    if (e.response?.status === 500) return new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)(data?.message || e.response?.statusText, undefined, e.stack);
    return new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)((0, $b6aa7c63b666337d$export$915e9e7bd4f0f96d).Default, undefined, e.stack);
};



/**
 * @deprecated We don't want to support this endpoint anymore in the future. /chains, /tools, /connections, and /tokens should be used instead
 */ const $988b46587540a82e$var$getPossibilities = async (requestConfig, options)=>{
    if (!requestConfig) requestConfig = {};
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    // apply defaults
    if (requestConfig.bridges || config.defaultRouteOptions.bridges) requestConfig.bridges = requestConfig.bridges || config.defaultRouteOptions.bridges;
    if (requestConfig.exchanges || config.defaultRouteOptions.exchanges) requestConfig.exchanges = requestConfig.exchanges || config.defaultRouteOptions.exchanges;
    // send request
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/advanced/possibilities`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestConfig),
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getToken = async (chain, token, options)=>{
    if (!chain) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "chain" is missing.');
    if (!token) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "token" is missing.');
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/token?${new URLSearchParams({
            chain: chain,
            token: token
        })}`, {
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getQuote = async (requestConfig, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    const requiredParameters = [
        "fromChain",
        "fromToken",
        "fromAddress",
        "fromAmount",
        "toChain",
        "toToken"
    ];
    requiredParameters.forEach((requiredParameter)=>{
        if (!requestConfig[requiredParameter]) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Required parameter "${requiredParameter}" is missing.`);
    });
    // apply defaults
    requestConfig.order || (requestConfig.order = config.defaultRouteOptions.order);
    requestConfig.slippage || (requestConfig.slippage = config.defaultRouteOptions.slippage);
    requestConfig.integrator || (requestConfig.integrator = config.defaultRouteOptions.integrator);
    requestConfig.referrer || (requestConfig.referrer = config.defaultRouteOptions.referrer);
    requestConfig.fee || (requestConfig.fee = config.defaultRouteOptions.fee);
    requestConfig.allowBridges || (requestConfig.allowBridges = config.defaultRouteOptions.bridges?.allow);
    requestConfig.denyBridges || (requestConfig.denyBridges = config.defaultRouteOptions.bridges?.deny);
    requestConfig.preferBridges || (requestConfig.preferBridges = config.defaultRouteOptions.bridges?.prefer);
    requestConfig.allowExchanges || (requestConfig.allowExchanges = config.defaultRouteOptions.exchanges?.allow);
    requestConfig.denyExchanges || (requestConfig.denyExchanges = config.defaultRouteOptions.exchanges?.deny);
    requestConfig.preferExchanges || (requestConfig.preferExchanges = config.defaultRouteOptions.exchanges?.prefer);
    Object.keys(requestConfig).forEach((key)=>!requestConfig[key] && delete requestConfig[key]);
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/quote?${new URLSearchParams(requestConfig)}`, {
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getContractCallQuote = async (requestConfig, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    // validation
    const requiredParameters = [
        "fromChain",
        "fromToken",
        "fromAddress",
        "toChain",
        "toToken",
        "toAmount",
        "toContractAddress",
        "toContractCallData",
        "toContractGasLimit"
    ];
    requiredParameters.forEach((requiredParameter)=>{
        if (!requestConfig[requiredParameter]) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Required parameter "${requiredParameter}" is missing.`);
    });
    // apply defaults
    // option.order is not used in this endpoint
    requestConfig.slippage || (requestConfig.slippage = config.defaultRouteOptions.slippage);
    requestConfig.integrator || (requestConfig.integrator = config.defaultRouteOptions.integrator);
    requestConfig.referrer || (requestConfig.referrer = config.defaultRouteOptions.referrer);
    requestConfig.fee || (requestConfig.fee = config.defaultRouteOptions.fee);
    requestConfig.allowBridges || (requestConfig.allowBridges = config.defaultRouteOptions.bridges?.allow);
    requestConfig.denyBridges || (requestConfig.denyBridges = config.defaultRouteOptions.bridges?.deny);
    requestConfig.preferBridges || (requestConfig.preferBridges = config.defaultRouteOptions.bridges?.prefer);
    requestConfig.allowExchanges || (requestConfig.allowExchanges = config.defaultRouteOptions.exchanges?.allow);
    requestConfig.denyExchanges || (requestConfig.denyExchanges = config.defaultRouteOptions.exchanges?.deny);
    requestConfig.preferExchanges || (requestConfig.preferExchanges = config.defaultRouteOptions.exchanges?.prefer);
    // send request
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/quote/contractCall`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestConfig),
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getContractCallsQuote = async (requestConfig, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    // validation
    const requiredParameters = [
        "fromChain",
        "fromToken",
        "fromAddress",
        "toChain",
        "toToken",
        "toAmount",
        "contractCalls"
    ];
    if (requestConfig.contractCalls.length === 0) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Parameter "contractCalls" is empty.`);
    requiredParameters.forEach((requiredParameter)=>{
        if (!requestConfig[requiredParameter]) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Required parameter "${requiredParameter}" is missing.`);
    });
    // apply defaults
    // option.order is not used in this endpoint
    requestConfig.slippage || (requestConfig.slippage = config.defaultRouteOptions.slippage);
    requestConfig.integrator || (requestConfig.integrator = config.defaultRouteOptions.integrator);
    requestConfig.referrer || (requestConfig.referrer = config.defaultRouteOptions.referrer);
    requestConfig.allowBridges || (requestConfig.allowBridges = config.defaultRouteOptions.bridges?.allow);
    requestConfig.denyBridges || (requestConfig.denyBridges = config.defaultRouteOptions.bridges?.deny);
    requestConfig.preferBridges || (requestConfig.preferBridges = config.defaultRouteOptions.bridges?.prefer);
    requestConfig.allowExchanges || (requestConfig.allowExchanges = config.defaultRouteOptions.exchanges?.allow);
    requestConfig.denyExchanges || (requestConfig.denyExchanges = config.defaultRouteOptions.exchanges?.deny);
    requestConfig.preferExchanges || (requestConfig.preferExchanges = config.defaultRouteOptions.exchanges?.prefer);
    // send request
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/quote/contractCalls`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestConfig),
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getStatus = async (requestConfig, options)=>{
    if (!requestConfig.txHash) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "txHash" is missing.');
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    const queryParams = new URLSearchParams(requestConfig);
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/status?${queryParams}`, {
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getChains = async (options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/chains`, {
            signal: options?.signal
        });
        return response.chains;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getRoutes = async (requestConfig, options)=>{
    if (!(0, $b2df358172b4a603$export$f850eaa67d786012)(requestConfig)) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Invalid routes request.");
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    // apply defaults
    requestConfig.options = {
        ...config.defaultRouteOptions,
        ...requestConfig.options
    };
    // send request
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/advanced/routes`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestConfig),
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getStepTransaction = async (step, options)=>{
    if (!(0, $b2df358172b4a603$export$21684750287da054)(step)) // While the validation fails for some users we should not enforce it
    // eslint-disable-next-line no-console
    console.warn("SDK Validation: Invalid Step", step);
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/advanced/stepTransaction`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(step),
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getTools = async (requestConfig, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    if (requestConfig) Object.keys(requestConfig).forEach((key)=>!requestConfig[key] && delete requestConfig[key]);
    const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/tools?${new URLSearchParams(requestConfig)}`, {
        signal: options?.signal
    });
    return response;
};
const $988b46587540a82e$var$getTokens = async (requestConfig, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    if (requestConfig) Object.keys(requestConfig).forEach((key)=>!requestConfig[key] && delete requestConfig[key]);
    const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(`${config.apiUrl}/tokens?${new URLSearchParams(requestConfig)}`, {
        signal: options?.signal
    });
    return response;
};
const $988b46587540a82e$var$getGasRecommendation = async ({ chainId: chainId, fromChain: fromChain, fromToken: fromToken }, options)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    if (!chainId) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "chainId" is missing.');
    const url = new URL(`${config.apiUrl}/gas/suggestion/${chainId}`);
    if (fromChain) url.searchParams.append("fromChain", fromChain);
    if (fromToken) url.searchParams.append("fromToken", fromToken);
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(url, {
            signal: options?.signal
        });
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getAvailableConnections = async (connectionRequest)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    const url = new URL(`${config.apiUrl}/connections`);
    const { fromChain: fromChain, fromToken: fromToken, toChain: toChain, toToken: toToken } = connectionRequest;
    if (fromChain) url.searchParams.append("fromChain", fromChain);
    if (fromToken) url.searchParams.append("fromToken", fromToken);
    if (toChain) url.searchParams.append("toChain", toChain);
    if (toToken) url.searchParams.append("toToken", toToken);
    const connectionRequestArrayParams = [
        "allowBridges",
        "denyBridges",
        "preferBridges",
        "allowExchanges",
        "denyExchanges",
        "preferExchanges"
    ];
    connectionRequestArrayParams.forEach((parameter)=>{
        const connectionRequestArrayParam = connectionRequest[parameter];
        if (connectionRequestArrayParam?.length) connectionRequestArrayParam?.forEach((value)=>{
            url.searchParams.append(parameter, value);
        });
    });
    try {
        const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(url);
        return response;
    } catch (e) {
        throw await (0, $c925d9fbcc898e0c$export$9b596bfc8ebcb202)(e);
    }
};
const $988b46587540a82e$var$getTransactionHistory = async (walletAnalyticsRequest)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    if (!walletAnalyticsRequest.fromTimestamp) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "fromTimestamp" is missing.');
    if (!walletAnalyticsRequest.toTimestamp) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('Required parameter "toTimestamp" is missing.');
    const url = new URL(`${config.apiUrl}/analytics/wallets/${walletAnalyticsRequest.walletAddress}`);
    url.searchParams.append("fromTimestamp", walletAnalyticsRequest.fromTimestamp.toString());
    url.searchParams.append("toTimestamp", walletAnalyticsRequest.toTimestamp.toString());
    const response = await (0, $d85a17d0bb819c54$export$b5fe3f66a567bec0)(url);
    return response;
};
var $988b46587540a82e$export$2e2bcd8739ae039 = {
    getChains: $988b46587540a82e$var$getChains,
    getContractCallQuote: $988b46587540a82e$var$getContractCallQuote,
    getContractCallsQuote: $988b46587540a82e$var$getContractCallsQuote,
    getGasRecommendation: $988b46587540a82e$var$getGasRecommendation,
    getPossibilities: $988b46587540a82e$var$getPossibilities,
    getQuote: $988b46587540a82e$var$getQuote,
    getRoutes: $988b46587540a82e$var$getRoutes,
    getStatus: $988b46587540a82e$var$getStatus,
    getStepTransaction: $988b46587540a82e$var$getStepTransaction,
    getToken: $988b46587540a82e$var$getToken,
    getTokens: $988b46587540a82e$var$getTokens,
    getTools: $988b46587540a82e$var$getTools,
    getAvailableConnections: $988b46587540a82e$var$getAvailableConnections,
    getTransactionHistory: $988b46587540a82e$var$getTransactionHistory
};




const $e0b24b0c36b29553$var$TRANSACTION_HASH_OBSERVERS = {};
async function $e0b24b0c36b29553$export$a2be98c1d4216702(txHash, statusManager, processType, step) {
    const getStatus = ()=>new Promise(async (resolve, reject)=>{
            let statusResponse;
            try {
                statusResponse = await (0, $988b46587540a82e$export$2e2bcd8739ae039).getStatus({
                    bridge: step.tool,
                    fromChain: step.action.fromChainId,
                    toChain: step.action.toChainId,
                    txHash: txHash
                });
            } catch (e) {
                console.debug("Fetching status from backend failed.", e);
                return resolve(undefined);
            }
            switch(statusResponse.status){
                case "DONE":
                    return resolve(statusResponse);
                case "PENDING":
                    statusManager?.updateProcess(step, processType, "PENDING", {
                        substatus: statusResponse.substatus,
                        substatusMessage: statusResponse.substatusMessage || $e0b24b0c36b29553$export$7270aac0245913d1(statusResponse.status, statusResponse.substatus),
                        txLink: statusResponse.bridgeExplorerLink
                    });
                    return resolve(undefined);
                case "NOT_FOUND":
                    return resolve(undefined);
                case "FAILED":
                default:
                    return reject();
            }
        });
    let status;
    if (txHash in $e0b24b0c36b29553$var$TRANSACTION_HASH_OBSERVERS) status = await $e0b24b0c36b29553$var$TRANSACTION_HASH_OBSERVERS[txHash];
    else {
        $e0b24b0c36b29553$var$TRANSACTION_HASH_OBSERVERS[txHash] = (0, $23f7b917c62af19c$export$2a305b84cb949d18)(getStatus, 5000);
        status = await $e0b24b0c36b29553$var$TRANSACTION_HASH_OBSERVERS[txHash];
    }
    if (!status.receiving) throw new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)("Status doesn't contain receiving information.");
    return status;
}
const $e0b24b0c36b29553$var$processMessages = {
    TOKEN_ALLOWANCE: {
        STARTED: "Setting token allowance.",
        PENDING: "Waiting for token allowance.",
        DONE: "Token allowance set."
    },
    SWITCH_CHAIN: {
        PENDING: "Chain switch required.",
        DONE: "Chain switched successfully."
    },
    SWAP: {
        STARTED: "Preparing swap transaction.",
        ACTION_REQUIRED: "Please sign the transaction.",
        PENDING: "Waiting for swap transaction.",
        DONE: "Swap completed."
    },
    CROSS_CHAIN: {
        STARTED: "Preparing bridge transaction.",
        ACTION_REQUIRED: "Please sign the transaction.",
        PENDING: "Waiting for bridge transaction.",
        DONE: "Bridge transaction confirmed."
    },
    RECEIVING_CHAIN: {
        PENDING: "Waiting for destination chain.",
        DONE: "Bridge completed."
    },
    TRANSACTION: {}
};
const $e0b24b0c36b29553$var$substatusMessages = {
    PENDING: {
        BRIDGE_NOT_AVAILABLE: "Bridge communication is temporarily unavailable.",
        CHAIN_NOT_AVAILABLE: "RPC communication is temporarily unavailable.",
        NOT_PROCESSABLE_REFUND_NEEDED: "The transfer cannot be completed successfully. A refund operation is required.",
        UNKNOWN_ERROR: "An unexpected error occurred. Please seek assistance in the LI.FI discord server.",
        WAIT_SOURCE_CONFIRMATIONS: "The bridge deposit has been received. The bridge is waiting for more confirmations to start the off-chain logic.",
        WAIT_DESTINATION_TRANSACTION: "The bridge off-chain logic is being executed. Wait for the transaction to appear on the destination chain."
    },
    DONE: {
        PARTIAL: "Some of the received tokens are not the requested destination tokens.",
        REFUNDED: "The tokens were refunded to the sender address.",
        COMPLETED: "The transfer is complete."
    },
    FAILED: {},
    INVALID: {},
    NOT_FOUND: {}
};
function $e0b24b0c36b29553$export$c1f6bd730b0cbdd0(type, status) {
    const processMessage = $e0b24b0c36b29553$var$processMessages[type][status];
    return processMessage;
}
function $e0b24b0c36b29553$export$7270aac0245913d1(status, substatus) {
    if (!substatus) return;
    const message = $e0b24b0c36b29553$var$substatusMessages[status][substatus];
    return message;
}
function $e0b24b0c36b29553$export$f05c5ad556e01436(oldStep, newStep) {
    const setSlippage = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(oldStep.action.slippage);
    const oldEstimatedToAmount = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(oldStep.estimate.toAmountMin);
    const newEstimatedToAmount = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(newStep.estimate.toAmountMin);
    const amountDifference = oldEstimatedToAmount.minus(newEstimatedToAmount);
    // oldEstimatedToAmount can be 0 when we use conract calls
    let actualSlippage = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(0);
    if (oldEstimatedToAmount.gt(0)) actualSlippage = amountDifference.dividedBy(oldEstimatedToAmount);
    return newEstimatedToAmount.gte(oldEstimatedToAmount) && actualSlippage.lte(setSlippage);
}


class $0ea94b0abab6ea85$export$ad37c92ba0ce98d5 {
    constructor(route, settings, internalUpdateRouteCallback){
        this.shouldUpdate = true;
        /**
         * Initializes the execution object of a Step.
         * @param  {LifiStep} step  The current step in execution
         * @return {Execution}       The initialized execution object for this step and a function to update this step
         */ this.initExecutionObject = (step)=>{
            const currentExecution = step.execution || structuredClone((0, $91793444b767c4bc$export$524a587514af3051));
            if (!step.execution) {
                step.execution = currentExecution;
                step.execution.status = "PENDING";
                this.updateStepInRoute(step);
            }
            // Change status to PENDING after resuming from FAILED
            if (currentExecution.status === "FAILED") {
                currentExecution.status = "PENDING";
                this.updateStepInRoute(step);
            }
            return currentExecution;
        };
        /**
         * Create and push a new process into the execution.
         * @param  {ProcessType} type Type of the process. Used to identify already existing processes.
         * @param  {LifiStep} step The step that should contain the new process.
         * @param  {Status} status By default created procces is set to the STARTED status. We can override new process with the needed status.
         * @return {Process}
         */ this.findOrCreateProcess = (step, type, status)=>{
            if (!step.execution?.process) throw new Error("Execution hasn't been initialized.");
            const process = step.execution.process.find((p)=>p.type === type);
            if (process) {
                if (status && process.status !== status) {
                    process.status = status;
                    this.updateStepInRoute(step);
                }
                return process;
            }
            const newProcess = {
                type: type,
                startedAt: Date.now(),
                message: (0, $e0b24b0c36b29553$export$c1f6bd730b0cbdd0)(type, status ?? "STARTED"),
                status: status ?? "STARTED"
            };
            step.execution.process.push(newProcess);
            this.updateStepInRoute(step);
            return newProcess;
        };
        /**
         * Update a process object.
         * @param  {LifiStep} step The step where the process should be updated
         * @param  {ProcessType} type  The process type to update
         * @param  {Status} status The status the process gets.
         * @param  {object} [params]   Additional parameters to append to the process.
         * @return {Process} The update process
         */ this.updateProcess = (step, type, status, params)=>{
            if (!step.execution) throw new Error("Can't update an empty step execution.");
            const currentProcess = step?.execution?.process.find((p)=>p.type === type);
            if (!currentProcess) throw new Error("Can't find a process for the given type.");
            switch(status){
                case "CANCELLED":
                    currentProcess.doneAt = Date.now();
                    break;
                case "FAILED":
                    currentProcess.doneAt = Date.now();
                    step.execution.status = "FAILED";
                    break;
                case "DONE":
                    currentProcess.doneAt = Date.now();
                    break;
                case "PENDING":
                    step.execution.status = "PENDING";
                    break;
                case "ACTION_REQUIRED":
                    step.execution.status = "ACTION_REQUIRED";
                    break;
                default:
                    break;
            }
            currentProcess.status = status;
            currentProcess.message = (0, $e0b24b0c36b29553$export$c1f6bd730b0cbdd0)(type, status);
            // set extra parameters or overwritte the standard params set in the switch statement
            if (params) for (const [key, value] of Object.entries(params))currentProcess[key] = value;
            // Sort processes, the ones with DONE status go first
            step.execution.process = [
                ...step?.execution?.process.filter((process)=>process.status === "DONE"),
                ...step?.execution?.process.filter((process)=>process.status !== "DONE")
            ];
            this.updateStepInRoute(step); // updates the step in the route
            return currentProcess;
        };
        /**
         * Remove a process from the execution
         * @param  {LifiStep} step The step where the process should be removed from
         * @param  {ProcessType} type  The process type to remove
         * @return {void}
         */ this.removeProcess = (step, type)=>{
            if (!step.execution) throw new Error("Execution hasn't been initialized.");
            const index = step.execution.process.findIndex((p)=>p.type === type);
            step.execution.process.splice(index, 1);
            this.updateStepInRoute(step);
        };
        this.updateStepInRoute = (step)=>{
            if (!this.shouldUpdate) return step;
            const stepIndex = this.route.steps.findIndex((routeStep)=>routeStep.id === step.id);
            if (stepIndex === -1) throw new Error("Couldn't find a step to update.");
            this.route.steps[stepIndex] = Object.assign(this.route.steps[stepIndex], step);
            this.settings.updateRouteHook(this.route);
            this.internalUpdateRouteCallback(this.route);
            return this.route.steps[stepIndex];
        };
        this.route = route;
        this.settings = settings;
        this.internalUpdateRouteCallback = internalUpdateRouteCallback;
    }
    /**
     * Updates the execution object of a Step.
     * @param  {LifiStep} step  The current step in execution
     * @param  {Status} status  The status for the execution
     * @param  {Receipt} receipt Optional. Information about received tokens
     * @return {Step}       The step with the updated execution object
     */ updateExecution(step, status, receipt) {
        if (!step.execution) throw Error("Can't update empty execution.");
        step.execution.status = status;
        if (receipt) step.execution = {
            ...step.execution,
            ...receipt
        };
        this.updateStepInRoute(step);
        return step;
    }
    allowUpdates(value) {
        this.shouldUpdate = value;
    }
}







var $ltcCO = parcelRequire("ltcCO");


var $4lHHr = parcelRequire("4lHHr");parcelRequire("98vyO");
var $1tsUk = parcelRequire("1tsUk");




var $6N7mB = parcelRequire("6N7mB");

var $4lHHr = parcelRequire("4lHHr");


var $74f9372f73340fc3$exports = {};
$74f9372f73340fc3$exports = JSON.parse('[{"inputs":[{"components":[{"internalType":"address","name":"target","type":"address"},{"internalType":"bytes","name":"callData","type":"bytes"}],"internalType":"struct Multicall2.Call[]","name":"calls","type":"tuple[]"}],"name":"aggregate","outputs":[{"internalType":"uint256","name":"blockNumber","type":"uint256"},{"internalType":"bytes[]","name":"returnData","type":"bytes[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"components":[{"internalType":"address","name":"target","type":"address"},{"internalType":"bytes","name":"callData","type":"bytes"}],"internalType":"struct Multicall2.Call[]","name":"calls","type":"tuple[]"}],"name":"blockAndAggregate","outputs":[{"internalType":"uint256","name":"blockNumber","type":"uint256"},{"internalType":"bytes32","name":"blockHash","type":"bytes32"},{"components":[{"internalType":"bool","name":"success","type":"bool"},{"internalType":"bytes","name":"returnData","type":"bytes"}],"internalType":"struct Multicall2.Result[]","name":"returnData","type":"tuple[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"name":"getBlockHash","outputs":[{"internalType":"bytes32","name":"blockHash","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getBlockNumber","outputs":[{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getCurrentBlockCoinbase","outputs":[{"internalType":"address","name":"coinbase","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getCurrentBlockDifficulty","outputs":[{"internalType":"uint256","name":"difficulty","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getCurrentBlockGasLimit","outputs":[{"internalType":"uint256","name":"gaslimit","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getCurrentBlockTimestamp","outputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"addr","type":"address"}],"name":"getEthBalance","outputs":[{"internalType":"uint256","name":"balance","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLastBlockHash","outputs":[{"internalType":"bytes32","name":"blockHash","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"requireSuccess","type":"bool"},{"components":[{"internalType":"address","name":"target","type":"address"},{"internalType":"bytes","name":"callData","type":"bytes"}],"internalType":"struct Multicall2.Call[]","name":"calls","type":"tuple[]"}],"name":"tryAggregate","outputs":[{"components":[{"internalType":"bool","name":"success","type":"bool"},{"internalType":"bytes","name":"returnData","type":"bytes"}],"internalType":"struct Multicall2.Result[]","name":"returnData","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"requireSuccess","type":"bool"},{"components":[{"internalType":"address","name":"target","type":"address"},{"internalType":"bytes","name":"callData","type":"bytes"}],"internalType":"struct Multicall2.Call[]","name":"calls","type":"tuple[]"}],"name":"tryBlockAndAggregate","outputs":[{"internalType":"uint256","name":"blockNumber","type":"uint256"},{"internalType":"bytes32","name":"blockHash","type":"bytes32"},{"components":[{"internalType":"bool","name":"success","type":"bool"},{"internalType":"bytes","name":"returnData","type":"bytes"}],"internalType":"struct Multicall2.Result[]","name":"returnData","type":"tuple[]"}],"stateMutability":"view","type":"function"}]');


const $a5635d45177ab422$var$MAX_MULTICALL_SIZE = 100;
const $a5635d45177ab422$export$30fae73316a85135 = async (calls, abi, chainId, multicallAddress, requireSuccess = false)=>{
    // 1. create contract using multicall contract address and abi...
    const provider = await (0, $1fe769d8e0ee09c9$export$1a2da1764918cffa)(chainId);
    const multicallContract = new (0, $4lHHr.Contract)(multicallAddress, (0, (/*@__PURE__*/$parcel$interopDefault($74f9372f73340fc3$exports))), provider);
    const abiInterface = new (0, $6N7mB.Interface)(abi);
    // split up lists into chunks to stay below multicall limit
    const chunkedList = (0, $23f7b917c62af19c$export$cbdaa1f7433858de)(calls, $a5635d45177ab422$var$MAX_MULTICALL_SIZE);
    const chunkedResults = await Promise.all(chunkedList.map(async (chunkedCalls)=>{
        const callData = chunkedCalls.map((call)=>[
                call.address.toLowerCase(),
                abiInterface.encodeFunctionData(call.name, call.params)
            ]);
        try {
            // 3. get bytes array from multicall contract by process aggregate method...
            const { blockNumber: blockNumber, returnData: returnData } = await multicallContract.tryBlockAndAggregate(requireSuccess, callData);
            // 4. decode bytes array to useful data array...
            return returnData.map(({ success: success, returnData: returnData }, i)=>{
                if (!success) {
                    // requested function failed
                    console.error(`Multicall unsuccessful for address "${chunkedCalls[i].address}", ` + `function "${chunkedCalls[i].name}", chainId "${chainId}"`);
                    return [];
                }
                if (returnData.toString() === "0x") {
                    // requested function does probably not exist
                    console.error(`Multicall no response for address "${chunkedCalls[i].address}", ` + `function "${chunkedCalls[i].name}", chainId "${chainId}"`);
                    return [];
                }
                try {
                    return abiInterface.decodeFunctionResult(chunkedCalls[i].name, returnData);
                } catch (e) {
                    // requested function returns other data than expected
                    console.error(`Multicall parsing unsuccessful for address "${chunkedCalls[i].address}", ` + `function "${chunkedCalls[i].name}", chainId "${chainId}"`);
                    return [];
                }
            }).map((data)=>{
                return {
                    data: data[0],
                    blockNumber: blockNumber.toNumber()
                };
            });
        } catch (e) {
            // whole rpc call failed, probably an rpc issue
            console.error(`Multicall failed on chainId "${chainId}"`, chunkedList, e);
            return [];
        }
    }));
    return chunkedResults.flat();
};


const $eebc1fe9c4e4019b$export$e61b7b27819ffb8e = async (signer, tokenAddress, contractAddress)=>{
    const signerAddress = await signer.getAddress();
    const erc20 = new (0, $4lHHr.Contract)(tokenAddress, (0, $0300b294012d359d$export$89843982d7e60b14), signer);
    try {
        const approved = await erc20.allowance(signerAddress, contractAddress);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(approved.toString());
    } catch (e) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(0);
    }
};
const $eebc1fe9c4e4019b$export$d00b36ef8d1fceeb = async (signer, tokenAddress, contractAddress, amount, returnPopulatedTransaction)=>{
    const erc20 = new (0, $4lHHr.Contract)(tokenAddress, (0, $0300b294012d359d$export$89843982d7e60b14), signer);
    if (returnPopulatedTransaction) return erc20.populateTransaction.approve(contractAddress, amount);
    const transactionRequest = await erc20.populateTransaction.approve(contractAddress, amount);
    try {
        const estimatedGasLimit = await signer.estimateGas(transactionRequest);
        if (estimatedGasLimit) {
            const formattedGasLimit = (0, $1tsUk).BigNumber.from(`${BigInt(estimatedGasLimit.toString()) * 125n / 100n}`);
            transactionRequest.gasLimit = formattedGasLimit;
        }
    } catch (error) {}
    return signer.sendTransaction(transactionRequest);
};
const $eebc1fe9c4e4019b$export$f38c69872a5e551b = async (signer, chainId, tokenData)=>{
    const chainsService = (0, $5373603ab3f3b3c3$export$2e2bcd8739ae039).getInstance();
    const chain = await chainsService.getChainById(chainId);
    if (!chain.multicallAddress) throw new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)(`No multicall address configured for chainId ${chainId}.`);
    const ownerAddress = await signer.getAddress();
    const calls = [];
    tokenData.map(({ token: token, approvalAddress: approvalAddress })=>{
        calls.push({
            address: token.address,
            name: "allowance",
            params: [
                ownerAddress,
                approvalAddress
            ]
        });
    });
    const result = await (0, $a5635d45177ab422$export$30fae73316a85135)(calls, (0, $0300b294012d359d$export$89843982d7e60b14), chainId, chain.multicallAddress);
    if (!result.length) throw new (0, $b6aa7c63b666337d$export$ea52035eac03daf0)(`Couldn't load allowance from chainId ${chainId} using multicall.`);
    const parsedResult = result.map(({ data: data })=>({
            approvalAmount: data ?? new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(0)
        }));
    return tokenData.map(({ token: token, approvalAddress: approvalAddress }, i)=>({
            token: token,
            approvalAddress: approvalAddress,
            approvedAmount: parsedResult[i].approvalAmount
        }));
};
const $eebc1fe9c4e4019b$export$256623fdb6925744 = (tokenDataList)=>{
    // group by chain
    const tokenDataByChain = {};
    tokenDataList.forEach((tokenData)=>{
        if (!tokenDataByChain[tokenData.token.chainId]) tokenDataByChain[tokenData.token.chainId] = [];
        tokenDataByChain[tokenData.token.chainId].push(tokenData);
    });
    return tokenDataByChain;
};



const $e844b7a8bf3cc657$export$57632def5536cb24 = (signer)=>{
    if (!signer.provider) throw new (0, $b6aa7c63b666337d$export$478ec1fdae99aa79)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ProviderUnavailable, "No provider available in signer.");
    return signer.provider;
};



const $c9446f11f7871dd9$export$6834e6d2916f76e8 = async (signer, step, statusManager, settings, chain, allowUserInteraction = false, shouldBatchTransactions = false)=>{
    // Ask the user to set an allowance
    let allowanceProcess = statusManager.findOrCreateProcess(step, "TOKEN_ALLOWANCE");
    // Check allowance
    try {
        if (allowanceProcess.txHash && allowanceProcess.status !== "DONE") {
            if (allowanceProcess.status !== "PENDING") allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "PENDING");
            await (0, $e844b7a8bf3cc657$export$57632def5536cb24)(signer).waitForTransaction(allowanceProcess.txHash);
            allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "DONE");
        } else {
            const approvalRequest = {
                from: step.action.fromToken.address,
                to: step.estimate.approvalAddress
            };
            if (settings.updateTransactionRequestHook) {
                const config = await settings.updateTransactionRequestHook(approvalRequest);
                approvalRequest.gasLimit = config.gasLimit;
                approvalRequest.gasPrice = config.gasPrice;
                approvalRequest.maxFeePerGas = config.maxFeePerGas;
                approvalRequest.maxPriorityFeePerGas = config.maxPriorityFeePerGas;
            }
            if (!approvalRequest.from) throw new Error("Missing Signer address");
            if (!approvalRequest.to) throw new Error("Missing ERC20 contract address");
            const approved = await (0, $eebc1fe9c4e4019b$export$e61b7b27819ffb8e)(signer, approvalRequest.from, approvalRequest.to);
            if (new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(step.action.fromAmount).gt(approved)) {
                if (!allowUserInteraction) return;
                const approvalAmount = settings.infiniteApproval ? (0, $ltcCO).MaxUint256.toString() : step.action.fromAmount;
                if (shouldBatchTransactions) {
                    const populatedTransaction = await (0, $eebc1fe9c4e4019b$export$d00b36ef8d1fceeb)(signer, step.action.fromToken.address, step.estimate.approvalAddress, approvalAmount, true);
                    allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "DONE");
                    return populatedTransaction;
                }
                const approveTx = await (0, $eebc1fe9c4e4019b$export$d00b36ef8d1fceeb)(signer, step.action.fromToken.address, step.estimate.approvalAddress, approvalAmount);
                allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "PENDING", {
                    txHash: approveTx.hash,
                    txLink: chain.metamask.blockExplorerUrls[0] + "tx/" + approveTx.hash
                });
                // Wait for the transcation
                await approveTx.wait();
                allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "DONE");
            } else allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "DONE");
        }
    } catch (e) {
        if (e.code === "TRANSACTION_REPLACED" && e.replacement) await $c9446f11f7871dd9$var$transactionReplaced(e.replacement, allowanceProcess, step, chain, statusManager);
        else {
            const error = await (0, $c925d9fbcc898e0c$export$e80a9284539c1797)(e, step, allowanceProcess);
            allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "FAILED", {
                error: {
                    message: error.message,
                    htmlMessage: error.htmlMessage,
                    code: error.code
                }
            });
            statusManager.updateExecution(step, "FAILED");
            throw error;
        }
    }
};
const $c9446f11f7871dd9$var$transactionReplaced = async (replacementTx, allowanceProcess, step, chain, statusManager)=>{
    try {
        allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "PENDING", {
            txHash: replacementTx.hash,
            txLink: chain.metamask.blockExplorerUrls[0] + "tx/" + replacementTx.hash
        });
        await replacementTx.wait();
        allowanceProcess = statusManager.updateProcess(step, allowanceProcess.type, "DONE");
    } catch (e) {
        if (e.code === "TRANSACTION_REPLACED" && e.replacement) await $c9446f11f7871dd9$var$transactionReplaced(e.replacement, allowanceProcess, step, chain, statusManager);
        throw e;
    }
};




var $ltcCO = parcelRequire("ltcCO");



const $c00661fa91c9b1bc$export$b91e4d0a5a23c200 = async (signer, token, approvalAddress)=>{
    // native token don't need approval
    if ((0, $23f7b917c62af19c$export$f2a4f85dc24b631e)(token.address)) return;
    const approved = await (0, $eebc1fe9c4e4019b$export$e61b7b27819ffb8e)(signer, token.address, approvalAddress);
    return approved.toFixed(0);
};
const $c00661fa91c9b1bc$export$7264455740d688de = async (signer, tokenData)=>{
    // filter out native tokens
    const filteredTokenData = tokenData.filter(({ token: token })=>!(0, $23f7b917c62af19c$export$f2a4f85dc24b631e)(token.address));
    // group by chain
    const tokenDataByChain = (0, $eebc1fe9c4e4019b$export$256623fdb6925744)(filteredTokenData);
    const approvalPromises = Object.keys(tokenDataByChain).map(async (chainId)=>{
        const parsedChainId = Number.parseInt(chainId);
        // get allowances for current chain and token list
        return (0, $eebc1fe9c4e4019b$export$f38c69872a5e551b)(signer, parsedChainId, tokenDataByChain[parsedChainId]);
    });
    const approvalsByChain = await Promise.all(approvalPromises);
    const approvals = approvalsByChain.flat();
    return tokenData.map(({ token: token })=>{
        // native token don't need approval
        if ((0, $23f7b917c62af19c$export$f2a4f85dc24b631e)(token.address)) return {
            token: token,
            approval: undefined
        };
        const approved = approvals.find((approval)=>(0, $c98bbf8bc8a02c8a$export$31799251d373ac68)(approval.token, token));
        return {
            token: token,
            approval: approved?.approvedAmount.toString()
        };
    });
};
const $c00661fa91c9b1bc$export$5245bb33fc1153cf = async ({ signer: signer, token: token, approvalAddress: approvalAddress, amount: amount, infiniteApproval: infiniteApproval = false })=>{
    // native token don't need approval
    if ((0, $23f7b917c62af19c$export$f2a4f85dc24b631e)(token.address)) return;
    const approvedAmount = await (0, $eebc1fe9c4e4019b$export$e61b7b27819ffb8e)(signer, token.address, approvalAddress);
    if (new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(amount).gt(approvedAmount)) {
        const approvalAmount = infiniteApproval ? (0, $ltcCO).MaxUint256.toString() : amount;
        const approveTx = await (0, $eebc1fe9c4e4019b$export$d00b36ef8d1fceeb)(signer, token.address, approvalAddress, approvalAmount);
        await approveTx.wait();
    }
};
const $c00661fa91c9b1bc$export$3cccd4793a96b52 = async ({ signer: signer, token: token, approvalAddress: approvalAddress })=>{
    // native token don't need approval
    if ((0, $23f7b917c62af19c$export$f2a4f85dc24b631e)(token.address)) return;
    const approvedAmount = await (0, $eebc1fe9c4e4019b$export$e61b7b27819ffb8e)(signer, token.address, approvalAddress);
    if (!approvedAmount.isZero()) {
        const approveTx = await (0, $eebc1fe9c4e4019b$export$d00b36ef8d1fceeb)(signer, token.address, approvalAddress, "0");
        await approveTx.wait();
    }
};







parcelRequire("98vyO");
var $1tsUk = parcelRequire("1tsUk");



const $e5fc29f0e2fd4163$var$balanceAbi = [
    {
        constant: true,
        inputs: [
            {
                name: "who",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "addr",
                type: "address"
            }
        ],
        name: "getEthBalance",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    }
];
const $e5fc29f0e2fd4163$export$a3238cee431627c6 = async (walletAddress, tokens)=>{
    if (tokens.length === 0) return [];
    const { chainId: chainId } = tokens[0];
    tokens.forEach((token)=>{
        if (token.chainId !== chainId) {
            // eslint-disable-next-line no-console
            console.warn(`Requested tokens have to be on the same chain.`);
            return [];
        }
    });
    if (await (0, $1fe769d8e0ee09c9$export$d637027b214eb1ae)(chainId) && tokens.length > 1) return $e5fc29f0e2fd4163$var$getBalancesFromProviderUsingMulticall(walletAddress, tokens);
    else return $e5fc29f0e2fd4163$var$getBalancesFromProvider(walletAddress, tokens);
};
const $e5fc29f0e2fd4163$var$getBalancesFromProviderUsingMulticall = async (walletAddress, tokens)=>{
    // Configuration
    const { chainId: chainId } = tokens[0];
    const multicallAddress = await (0, $1fe769d8e0ee09c9$export$d637027b214eb1ae)(chainId);
    if (!multicallAddress) throw new Error("No multicallAddress found for the given chain.");
    return $e5fc29f0e2fd4163$var$executeMulticall(walletAddress, tokens, multicallAddress, chainId);
};
const $e5fc29f0e2fd4163$var$executeMulticall = async (walletAddress, tokens, multicallAddress, chainId)=>{
    // Collect calls we want to make
    const calls = [];
    tokens.map((token)=>{
        if ((0, $23f7b917c62af19c$export$33367b16affb40dd)(token.address)) calls.push({
            address: multicallAddress,
            name: "getEthBalance",
            params: [
                walletAddress
            ]
        });
        else calls.push({
            address: token.address,
            name: "balanceOf",
            params: [
                walletAddress
            ]
        });
    });
    const res = await $e5fc29f0e2fd4163$var$fetchViaMulticall(calls, $e5fc29f0e2fd4163$var$balanceAbi, chainId, multicallAddress);
    if (!res.length) return [];
    return tokens.map((token, i)=>{
        const amount = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(res[i].amount.toString() || "0").shiftedBy(-token.decimals).toFixed();
        return {
            ...token,
            amount: amount || "0",
            blockNumber: res[i].blockNumber
        };
    });
};
const $e5fc29f0e2fd4163$var$fetchViaMulticall = async (calls, abi, chainId, multicallAddress)=>{
    const result = await (0, $a5635d45177ab422$export$30fae73316a85135)(calls, abi, chainId, multicallAddress);
    return result.map(({ data: data, blockNumber: blockNumber })=>({
            amount: data ? data : new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(0),
            blockNumber: blockNumber
        }));
};
const $e5fc29f0e2fd4163$var$getBalancesFromProvider = async (walletAddress, tokens)=>{
    const chainId = tokens[0].chainId;
    const rpc = await (0, $1fe769d8e0ee09c9$export$1a2da1764918cffa)(chainId);
    const tokenAmountPromises = tokens.map(async (token)=>{
        let amount = "0";
        let blockNumber;
        try {
            const balance = await $e5fc29f0e2fd4163$var$getBalanceFromProvider(walletAddress, token.address, chainId, rpc);
            amount = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(balance.amount.toString()).shiftedBy(-token.decimals).toString();
            blockNumber = balance.blockNumber;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e);
        }
        return {
            ...token,
            amount: amount,
            blockNumber: blockNumber
        };
    });
    return Promise.all(tokenAmountPromises);
};
const $e5fc29f0e2fd4163$var$getBalanceFromProvider = async (walletAddress, assetId, chainId, provider)=>{
    const blockNumber = await $e5fc29f0e2fd4163$var$getCurrentBlockNumber(chainId);
    let balance;
    if ((0, $23f7b917c62af19c$export$33367b16affb40dd)(assetId)) balance = await provider.getBalance(walletAddress, blockNumber);
    else {
        const contract = new (0, $1tsUk).Contract(assetId, [
            "function balanceOf(address owner) view returns (uint256)"
        ], provider);
        balance = await contract.balanceOf(walletAddress, {
            blockTag: blockNumber
        });
    }
    return {
        amount: balance,
        blockNumber: blockNumber
    };
};
const $e5fc29f0e2fd4163$var$getCurrentBlockNumber = async (chainId)=>{
    const rpc = await (0, $1fe769d8e0ee09c9$export$1a2da1764918cffa)(chainId);
    return rpc.getBlockNumber();
};
var $e5fc29f0e2fd4163$export$2e2bcd8739ae039 = {
    getBalances: $e5fc29f0e2fd4163$export$a3238cee431627c6
};


const $9faf5864d9403da5$export$5d75214593c7727f = async (walletAddress, token)=>{
    const tokenAmounts = await $9faf5864d9403da5$export$e7402a6520858264(walletAddress, [
        token
    ]);
    return tokenAmounts.length ? tokenAmounts[0] : null;
};
const $9faf5864d9403da5$export$e7402a6520858264 = async (walletAddress, tokens)=>{
    // split by chain
    const tokensByChain = {};
    tokens.forEach((token)=>{
        if (!tokensByChain[token.chainId]) tokensByChain[token.chainId] = [];
        tokensByChain[token.chainId].push(token);
    });
    const tokenAmountsByChain = await $9faf5864d9403da5$export$4a265ade7ae2b96d(walletAddress, tokensByChain);
    return Object.values(tokenAmountsByChain).flat();
};
const $9faf5864d9403da5$export$4a265ade7ae2b96d = async (walletAddress, tokensByChain)=>{
    const tokenAmountsByChain = {};
    const promises = Object.keys(tokensByChain).map(async (chainIdStr)=>{
        const chainId = parseInt(chainIdStr);
        const tokenAmounts = await (0, $e5fc29f0e2fd4163$export$2e2bcd8739ae039).getBalances(walletAddress, tokensByChain[chainId]);
        tokenAmountsByChain[chainId] = tokenAmounts;
    });
    await Promise.allSettled(promises);
    return tokenAmountsByChain;
};


const $96fbe5d8b1097a8d$export$6bb07c932af8cd5b = async (signer, step, depth = 0)=>{
    const tokenAmount = await (0, $9faf5864d9403da5$export$5d75214593c7727f)(await signer.getAddress(), step.action.fromToken);
    if (tokenAmount) {
        const currentBalance = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(tokenAmount.amount).shiftedBy(tokenAmount.decimals);
        const neededBalance = new (0, (/*@__PURE__*/$parcel$interopDefault($323ab58d73f95cd0$exports)))(step.action.fromAmount);
        if (currentBalance.lt(neededBalance)) {
            if (depth <= 3) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, 200);
                });
                await $96fbe5d8b1097a8d$export$6bb07c932af8cd5b(signer, step, depth + 1);
            } else if (neededBalance.multipliedBy(1 - step.action.slippage).lte(currentBalance)) // adjust amount in slippage limits
            step.action.fromAmount = currentBalance.toFixed(0);
            else {
                const neeeded = neededBalance.shiftedBy(-tokenAmount.decimals).toFixed();
                const current = currentBalance.shiftedBy(-tokenAmount.decimals).toFixed();
                let errorMessage = `Your ${tokenAmount.symbol} balance is too low, ` + `you try to transfer ${neeeded} ${tokenAmount.symbol}, ` + `but your wallet only holds ${current} ${tokenAmount.symbol}. ` + `No funds have been sent. `;
                if (!currentBalance.isZero()) errorMessage += `If the problem consists, please delete this transfer and ` + `start a new one with a maximum of ${current} ${tokenAmount.symbol}.`;
                throw new (0, $b6aa7c63b666337d$export$3854bf6bc7d34120)("The balance is too low.", errorMessage);
            }
        }
    }
};



var $3a9ba3cc63aeaf25$export$2e2bcd8739ae039 = {
    checkBalance: $96fbe5d8b1097a8d$export$6bb07c932af8cd5b,
    getTokenBalance: $9faf5864d9403da5$export$5d75214593c7727f,
    getTokenBalances: $9faf5864d9403da5$export$e7402a6520858264,
    getTokenBalancesForChains: $9faf5864d9403da5$export$4a265ade7ae2b96d
};





/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $e0Utj = parcelRequire("e0Utj");

const $9ba4ce4e04a052ef$export$af2ffe80e6d56a0e = async (route, signer)=>{
    for(let index = 0; index < route.steps.length; index++){
        const stepHasFailed = route.steps[index].execution?.status === "FAILED";
        if (stepHasFailed) {
            await $9ba4ce4e04a052ef$var$handleErrorType(route, index, signer);
            $9ba4ce4e04a052ef$var$deleteFailedProcesses(route, index);
            $9ba4ce4e04a052ef$var$deleteTransactionData(route, index);
        }
    }
};
const $9ba4ce4e04a052ef$var$handleErrorType = async (route, index, signer)=>{
    const isGasLimitError = route.steps[index].execution?.process.some((p)=>p.error?.code === (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).GasLimitError);
    const isGasPriceError = route.steps[index].execution?.process.some((p)=>p.error?.code === (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnderpriced);
    const { transactionRequest: transactionRequest } = route.steps[index];
    if (isGasLimitError) {
        if (transactionRequest) {
            let gasLimit = transactionRequest.gasLimit;
            try {
                gasLimit = await signer.estimateGas(transactionRequest);
            } catch (error) {}
            if (gasLimit) transactionRequest.gasLimit = (0, $e0Utj.BigNumber).from(`${BigInt(gasLimit.toString()) * 125n / 100n}`);
        }
        route.steps[index].estimate.gasCosts?.forEach((gasCost)=>gasCost.limit = `${Math.round(Number(gasCost.limit) * 1.25)}`);
    }
    if (isGasPriceError) {
        if (transactionRequest) {
            let gasPrice = transactionRequest.gasPrice;
            try {
                gasPrice = await signer.getGasPrice();
            } catch (error) {}
            if (gasPrice) transactionRequest.gasPrice = (0, $e0Utj.BigNumber).from(`${BigInt(gasPrice.toString()) * 125n / 100n}`);
        }
        route.steps[index].estimate.gasCosts?.forEach((gasCost)=>gasCost.price = `${Math.round(Number(gasCost.price) * 1.25)}`);
    }
};
const $9ba4ce4e04a052ef$var$deleteFailedProcesses = (route, index)=>{
    if (route.steps[index].execution) route.steps[index].execution.process = route.steps[index].execution.process.filter((process)=>process.status === "DONE");
};
const $9ba4ce4e04a052ef$var$deleteTransactionData = (route, index)=>{
    route.steps[index].transactionRequest = undefined;
};




var $e0Utj = parcelRequire("e0Utj");









const $9eba70b8d3f56d7a$export$aa24cf2a72da346c = async (statusManager, oldStep, newStep, settings, allowUserInteraction)=>{
    // Check if changed exchange rate is in the range of slippage threshold
    if ((0, $e0b24b0c36b29553$export$f05c5ad556e01436)(oldStep, newStep)) return statusManager.updateStepInRoute(newStep);
    let allowStepUpdate;
    if (allowUserInteraction) allowStepUpdate = await settings.acceptExchangeRateUpdateHook({
        oldToAmount: oldStep.estimate.toAmount,
        newToAmount: newStep.estimate.toAmount,
        toToken: newStep.action.toToken
    });
    if (!allowStepUpdate) // The user declined the new exchange rate, so we are not going to proceed
    throw new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionCanceled, "Exchange rate has changed!", `Transaction was not sent, your funds are still in your wallet.
      The exchange rate has changed and the previous estimation can not be fulfilled due to value loss.`);
    return statusManager.updateStepInRoute(newStep);
};



const $312bb4ab7e285761$export$15599da40e72d2f = async (signer, statusManager, step, switchChainHook, allowUserInteraction)=>{
    // if we are already on the correct chain we can proceed directly
    if (await signer.getChainId() === step.action.fromChainId) return signer;
    // -> set status message
    step.execution = statusManager.initExecutionObject(step);
    statusManager.updateExecution(step, "ACTION_REQUIRED");
    let switchProcess = statusManager.findOrCreateProcess(step, "SWITCH_CHAIN", "ACTION_REQUIRED");
    if (!allowUserInteraction) return;
    try {
        const updatedSigner = await switchChainHook(step.action.fromChainId);
        const updatedChainId = await updatedSigner?.getChainId();
        if (updatedChainId !== step.action.fromChainId) throw new (0, $b6aa7c63b666337d$export$478ec1fdae99aa79)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ChainSwitchError, "Chain switch required.");
        switchProcess = statusManager.updateProcess(step, switchProcess.type, "DONE");
        statusManager.updateExecution(step, "PENDING");
        return updatedSigner;
    } catch (error) {
        statusManager.updateProcess(step, switchProcess.type, "FAILED", {
            error: {
                message: error.message,
                code: (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ChainSwitchError
            }
        });
        statusManager.updateExecution(step, "FAILED");
        throw error;
    }
};






const $3a87152f8b634a45$export$29e955233c5e2e8 = async (internalTxHash, step, statusManager, process, fromChain)=>{
    const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
    if (!config.multisigConfig?.getMultisigTransactionDetails) throw new Error('"getMultisigTransactionDetails()" is missing in Multisig config.');
    const updateIntermediateMultisigStatus = ()=>{
        process = statusManager.updateProcess(step, process.type, "PENDING");
    };
    const multisigStatusResponse = await config.multisigConfig?.getMultisigTransactionDetails(internalTxHash, fromChain.id, updateIntermediateMultisigStatus);
    if (multisigStatusResponse.status === "DONE") process = statusManager.updateProcess(step, process.type, "PENDING", {
        txHash: multisigStatusResponse.txHash,
        multisigTxHash: undefined,
        txLink: fromChain.metamask.blockExplorerUrls[0] + "tx/" + multisigStatusResponse.txHash
    });
    if (multisigStatusResponse.status === "FAILED") throw new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionFailed, "Multisig transaction failed.");
    if (multisigStatusResponse.status === "CANCELLED") throw new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionRejected, "Transaction was rejected by users.");
};



class $58d59095f1d3bc53$export$479faae048c4e86b {
    constructor(){
        this.allowUserInteraction = true;
        this.allowInteraction = (value)=>{
            this.allowUserInteraction = value;
        };
        this.execute = async ({ signer: signer, step: step, statusManager: statusManager, settings: settings })=>{
            const config = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance().getConfig();
            const isMultisigSigner = !!config.multisigConfig?.isMultisigSigner;
            const multisigBatchTransactions = [];
            const shouldBatchTransactions = config.multisigConfig?.shouldBatchTransactions && !!config.multisigConfig.sendBatchTransaction;
            step.execution = statusManager.initExecutionObject(step);
            const chainsService = (0, $5373603ab3f3b3c3$export$2e2bcd8739ae039).getInstance();
            const fromChain = await chainsService.getChainById(step.action.fromChainId);
            const toChain = await chainsService.getChainById(step.action.toChainId);
            const isBridgeExecution = fromChain.id !== toChain.id;
            const currentProcessType = isBridgeExecution ? "CROSS_CHAIN" : "SWAP";
            // STEP 1: Check allowance
            const existingProcess = step.execution.process.find((p)=>p.type === currentProcessType);
            // Check token approval only if fromToken is not the native token => no approval needed in that case
            const checkForAllowance = !existingProcess?.txHash && !(0, $23f7b917c62af19c$export$33367b16affb40dd)(step.action.fromToken.address) && (shouldBatchTransactions || !isMultisigSigner);
            if (checkForAllowance) {
                const populatedTransaction = await (0, $c9446f11f7871dd9$export$6834e6d2916f76e8)(signer, step, statusManager, settings, fromChain, this.allowUserInteraction, shouldBatchTransactions);
                if (populatedTransaction) {
                    const { to: to, data: data } = populatedTransaction;
                    if (to && data) {
                        // allowance doesn't need value
                        const cleanedPopulatedTransaction = {
                            value: (0, $e0Utj.BigNumber).from(0).toString(),
                            to: to,
                            data: data
                        };
                        multisigBatchTransactions.push(cleanedPopulatedTransaction);
                    }
                }
            }
            // STEP 2: Get transaction
            let process = statusManager.findOrCreateProcess(step, currentProcessType);
            if (process.status !== "DONE") {
                const multisigProcess = step.execution.process.find((p)=>!!p.multisigTxHash);
                try {
                    if (isMultisigSigner && multisigProcess) {
                        if (!multisigProcess) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Multisig process is undefined.");
                        if (!config.multisigConfig?.getMultisigTransactionDetails) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)('"getMultisigTransactionDetails()" is missing in Multisig config.');
                        const multisigTxHash = multisigProcess.multisigTxHash;
                        if (!multisigTxHash) // need to check what happens in failed tx
                        throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Multisig internal transaction hash is undefined.");
                        await (0, $3a87152f8b634a45$export$29e955233c5e2e8)(multisigTxHash, step, statusManager, process, fromChain);
                    }
                    let transaction;
                    if (process.txHash) {
                        // Make sure that the chain is still correct
                        const updatedSigner = await (0, $312bb4ab7e285761$export$15599da40e72d2f)(signer, statusManager, step, settings.switchChainHook, this.allowUserInteraction);
                        if (!updatedSigner) // Chain switch was not successful, stop execution here
                        return step.execution;
                        signer = updatedSigner;
                        // Load exiting transaction
                        transaction = await (0, $e844b7a8bf3cc657$export$57632def5536cb24)(signer).getTransaction(process.txHash);
                    } else {
                        process = statusManager.updateProcess(step, process.type, "STARTED");
                        // Check balance
                        await (0, $96fbe5d8b1097a8d$export$6bb07c932af8cd5b)(signer, step);
                        // Create new transaction
                        if (!step.transactionRequest) {
                            const personalizedStep = await (0, $23f7b917c62af19c$export$7d7a0973a46be702)(signer, step);
                            const updatedStep = await (0, $988b46587540a82e$export$2e2bcd8739ae039).getStepTransaction(personalizedStep);
                            const comparedStep = await (0, $9eba70b8d3f56d7a$export$aa24cf2a72da346c)(statusManager, personalizedStep, updatedStep, settings, this.allowUserInteraction);
                            step = {
                                ...comparedStep,
                                execution: step.execution
                            };
                        }
                        const { transactionRequest: transactionRequest } = step;
                        if (!transactionRequest) throw new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnprepared, "Unable to prepare transaction.");
                        // STEP 3: Send the transaction
                        // Make sure that the chain is still correct
                        const updatedSigner = await (0, $312bb4ab7e285761$export$15599da40e72d2f)(signer, statusManager, step, settings.switchChainHook, this.allowUserInteraction);
                        if (!updatedSigner) // Chain switch was not successful, stop execution here
                        return step.execution;
                        signer = updatedSigner;
                        process = statusManager.updateProcess(step, process.type, "ACTION_REQUIRED");
                        if (!this.allowUserInteraction) return step.execution;
                        if (settings.updateTransactionRequestHook) {
                            const customConfig = await settings.updateTransactionRequestHook(transactionRequest);
                            transactionRequest.gasLimit = customConfig.gasLimit;
                            transactionRequest.gasPrice = customConfig.gasPrice;
                            transactionRequest.maxPriorityFeePerGas = customConfig.maxPriorityFeePerGas;
                            transactionRequest.maxFeePerGas = customConfig.maxFeePerGas;
                        } else try {
                            const estimatedGasLimit = await signer.estimateGas(transactionRequest);
                            if (estimatedGasLimit) transactionRequest.gasLimit = (0, $e0Utj.BigNumber).from(`${BigInt(estimatedGasLimit.toString()) * 125n / 100n}`);
                            // Fetch latest gasPrice from provider and use it
                            const gasPrice = await signer.getGasPrice();
                            if (gasPrice) transactionRequest.gasPrice = gasPrice;
                        } catch (error) {}
                        // Submit the transaction
                        if (shouldBatchTransactions && config.multisigConfig?.sendBatchTransaction) {
                            const { to: to, data: data, value: value } = await signer.populateTransaction(transactionRequest);
                            const isValidTransaction = to && data;
                            if (isValidTransaction) {
                                const populatedTransaction = {
                                    value: value?.toString() ?? (0, $e0Utj.BigNumber).from(0).toString(),
                                    to: to,
                                    data: data.toString()
                                };
                                multisigBatchTransactions.push(populatedTransaction);
                                transaction = await config.multisigConfig?.sendBatchTransaction(multisigBatchTransactions);
                            } else throw new (0, $b6aa7c63b666337d$export$9dd357eddc48a7ff)((0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnprepared, "Unable to prepare transaction.");
                        } else transaction = await signer.sendTransaction(transactionRequest);
                        // STEP 4: Wait for the transaction
                        if (isMultisigSigner) process = statusManager.updateProcess(step, process.type, "ACTION_REQUIRED", {
                            multisigTxHash: transaction.hash
                        });
                        else process = statusManager.updateProcess(step, process.type, "PENDING", {
                            txHash: transaction.hash,
                            txLink: fromChain.metamask.blockExplorerUrls[0] + "tx/" + transaction.hash
                        });
                    }
                    await transaction.wait?.();
                    // if it's multisig signer and the process is in ACTION_REQUIRED
                    // then signatures are still needed
                    if (isMultisigSigner && process.status === "ACTION_REQUIRED" && transaction.hash) // Return the execution object without updating the process
                    // The execution would progress once all multisigs signer approve
                    await (0, $3a87152f8b634a45$export$29e955233c5e2e8)(transaction.hash, step, statusManager, process, fromChain);
                    if (!isMultisigSigner) process = statusManager.updateProcess(step, process.type, "PENDING", {
                        txHash: transaction.hash,
                        txLink: fromChain.metamask.blockExplorerUrls[0] + "tx/" + transaction.hash
                    });
                    if (isBridgeExecution) process = statusManager.updateProcess(step, process.type, "DONE");
                } catch (e) {
                    if (e.code === "TRANSACTION_REPLACED" && e.replacement) process = statusManager.updateProcess(step, process.type, "DONE", {
                        txHash: e.replacement.hash,
                        txLink: fromChain.metamask.blockExplorerUrls[0] + "tx/" + e.replacement.hash
                    });
                    else {
                        const error = await (0, $c925d9fbcc898e0c$export$e80a9284539c1797)(e, step, process);
                        process = statusManager.updateProcess(step, process.type, "FAILED", {
                            error: {
                                message: error.message,
                                htmlMessage: error.htmlMessage,
                                code: error.code
                            }
                        });
                        statusManager.updateExecution(step, "FAILED");
                        throw error;
                    }
                }
            }
            // STEP 5: Wait for the receiving chain
            const processTxHash = process.txHash;
            if (isBridgeExecution) process = statusManager.findOrCreateProcess(step, "RECEIVING_CHAIN", "PENDING");
            let statusResponse;
            try {
                if (!processTxHash) throw new Error("Transaction hash is undefined.");
                statusResponse = await (0, $e0b24b0c36b29553$export$a2be98c1d4216702)(processTxHash, statusManager, process.type, step);
                const statusReceiving = statusResponse.receiving;
                process = statusManager.updateProcess(step, process.type, "DONE", {
                    substatus: statusResponse.substatus,
                    substatusMessage: statusResponse.substatusMessage || (0, $e0b24b0c36b29553$export$7270aac0245913d1)(statusResponse.status, statusResponse.substatus),
                    txHash: statusReceiving?.txHash,
                    txLink: toChain.metamask.blockExplorerUrls[0] + "tx/" + statusReceiving?.txHash
                });
                statusManager.updateExecution(step, "DONE", {
                    fromAmount: statusResponse.sending.amount,
                    toAmount: statusReceiving?.amount,
                    toToken: statusReceiving?.token,
                    gasAmount: statusResponse.sending.gasAmount,
                    gasAmountUSD: statusResponse.sending.gasAmountUSD,
                    gasPrice: statusResponse.sending.gasPrice,
                    gasToken: statusResponse.sending.gasToken,
                    gasUsed: statusResponse.sending.gasUsed
                });
            } catch (e) {
                const htmlMessage = await (0, $c925d9fbcc898e0c$export$ab4f7fed7a3ee149)(step, process.txLink);
                process = statusManager.updateProcess(step, process.type, "FAILED", {
                    error: {
                        code: (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionFailed,
                        message: "Failed while waiting for receiving chain.",
                        htmlMessage: htmlMessage
                    }
                });
                statusManager.updateExecution(step, "FAILED");
                console.warn(e);
                throw e;
            }
            // DONE
            return step.execution;
        };
    }
}



// Please be careful when changing the defaults as it may break the behavior (e.g., background execution)
const $f2fe05d2ab2669d0$var$defaultInteractionSettings = {
    allowInteraction: true,
    allowUpdates: true,
    stopExecution: false
};
class $f2fe05d2ab2669d0$export$7bf141542dfeedb6 {
    constructor(statusManager, settings){
        this.allowUserInteraction = true;
        this.executionStopped = false;
        this.setInteraction = (settings)=>{
            const interactionSettings = {
                ...$f2fe05d2ab2669d0$var$defaultInteractionSettings,
                ...settings
            };
            this.allowUserInteraction = interactionSettings.allowInteraction;
            this.stepExecutionManager.allowInteraction(interactionSettings.allowInteraction);
            this.statusManager.allowUpdates(interactionSettings.allowUpdates);
            this.executionStopped = interactionSettings.stopExecution;
        };
        // TODO: add checkChain method and update signer inside executors
        // This can come in handy when we execute multiple routes simultaneously and
        // should be sure that we are on the right chain when waiting for transactions.
        this.checkChain = ()=>{
            throw new Error("checkChain is not implemented.");
        };
        this.executeStep = async (signer, step)=>{
            // Make sure that the chain is still correct
            // Find if it's bridging and the step is waiting for a transaction on the receiving chain
            const recievingChainProcess = step.execution?.process.find((process)=>process.type === "RECEIVING_CHAIN");
            // If the step is waiting for a transaction on the receiving chain, we do not switch the chain
            // All changes are already done from the source chain
            // Return the step
            if (recievingChainProcess?.substatus !== "WAIT_DESTINATION_TRANSACTION" || !recievingChainProcess) {
                const updatedSigner = await (0, $312bb4ab7e285761$export$15599da40e72d2f)(signer, this.statusManager, step, this.settings.switchChainHook, this.allowUserInteraction);
                if (!updatedSigner) // Chain switch was not successful, stop execution here
                return step;
                signer = updatedSigner;
            }
            const parameters = {
                signer: signer,
                step: step,
                settings: this.settings,
                statusManager: this.statusManager
            };
            await this.stepExecutionManager.execute(parameters);
            return step;
        };
        this.stepExecutionManager = new (0, $58d59095f1d3bc53$export$479faae048c4e86b)();
        this.statusManager = statusManager;
        this.settings = settings;
    }
}


class $21d643bfce15e72a$export$713e1c9695104f2 {
    constructor(configUpdate){
        this.executionDictionary = {};
        this.executionPromiseDictionary = {};
        /**
         * Execute a route.
         * @param {Signer} signer - The signer required to send the transactions.
         * @param {Route} route - The route that should be executed. Cannot be an active route.
         * @param {ExecutionSettings} settings - An object containing settings and callbacks.
         * @return {Promise<Route>} The executed route.
         * @throws {LifiError} Throws a LifiError if the execution fails.
         */ this.executeRoute = async (signer, route, settings)=>{
            // Deep clone to prevent side effects
            const clonedRoute = structuredClone(route);
            let executionPromise = this.executionPromiseDictionary[clonedRoute.id];
            // Check if route is already running
            if (executionPromise) return executionPromise;
            executionPromise = this.executeSteps(signer, clonedRoute, settings);
            this.executionPromiseDictionary[clonedRoute.id] = executionPromise;
            return executionPromise;
        };
        /**
         * Resume the execution of a route that has been stopped or had an error while executing.
         * @param {Signer} signer - The signer required to send the transactions.
         * @param {Route} route - The route that is to be executed. Cannot be an active route.
         * @param {ExecutionSettings} settings - An object containing settings and callbacks.
         * @return {Promise<Route>} The executed route.
         * @throws {LifiError} Throws a LifiError if the execution fails.
         */ this.resumeRoute = async (signer, route, settings)=>{
            // Deep clone to prevent side effects
            const clonedRoute = structuredClone(route);
            const execution = this.executionDictionary[clonedRoute.id];
            if (execution) {
                const executionHalted = execution.executors.some((executor)=>executor.executionStopped);
                if (!executionHalted) {
                    // Check if we want to resume route execution in the background
                    this.updateRouteExecution(route, {
                        executeInBackground: settings?.executeInBackground
                    });
                    const executionPromise = this.executionPromiseDictionary[clonedRoute.id];
                    return executionPromise ?? clonedRoute;
                }
            }
            await (0, $9ba4ce4e04a052ef$export$af2ffe80e6d56a0e)(clonedRoute, signer);
            const executionPromise = this.executeSteps(signer, clonedRoute, settings);
            this.executionPromiseDictionary[clonedRoute.id] = executionPromise;
            return executionPromise;
        };
        this.executeSteps = async (signer, route, settings)=>{
            const config = this.configService.getConfig();
            const execution = {
                route: route,
                executors: [],
                settings: {
                    ...config.defaultExecutionSettings,
                    ...settings
                }
            };
            this.executionDictionary[route.id] = execution;
            const statusManager = new (0, $0ea94b0abab6ea85$export$ad37c92ba0ce98d5)(route, execution.settings, (route)=>{
                if (this.executionDictionary[route.id]) execution.route = route;
            });
            // Loop over steps and execute them
            for(let index = 0; index < route.steps.length; index++){
                const execution = this.executionDictionary[route.id];
                // Check if execution has stopped in the meantime
                if (!execution) break;
                const step = route.steps[index];
                const previousStep = route.steps[index - 1];
                // Check if the step is already done
                //
                if (step.execution?.status === "DONE") continue;
                // Update amount using output of previous execution. In the future this should be handled by calling `updateRoute`
                if (previousStep?.execution?.toAmount) step.action.fromAmount = previousStep.execution.toAmount;
                try {
                    const stepExecutor = new (0, $f2fe05d2ab2669d0$export$7bf141542dfeedb6)(statusManager, execution.settings);
                    execution.executors.push(stepExecutor);
                    // Check if we want to execute this step in the background
                    this.updateRouteExecution(route, execution.settings);
                    const executedStep = await stepExecutor.executeStep(signer, step);
                    // We may reach this point if user interaction isn't allowed. We want to stop execution until we resume it
                    if (executedStep.execution?.status !== "DONE") this.stopExecution(route);
                    // Execution stopped during the current step, we don't want to continue to the next step so we return already
                    if (stepExecutor.executionStopped) return route;
                } catch (e) {
                    this.stopExecution(route);
                    throw e;
                }
            }
            // Clean up after the execution
            delete this.executionDictionary[route.id];
            return route;
        };
        /**
         * Updates route execution to background or foreground state.
         * @param {Route} route - A route that is currently in execution.
         * @param {boolean} settings - An object with execution settings.
         */ this.updateRouteExecution = (route, settings)=>{
            const execution = this.executionDictionary[route.id];
            if (!execution) return;
            for (const executor of execution.executors)executor.setInteraction({
                allowInteraction: !settings.executeInBackground,
                allowUpdates: true
            });
            // Update active route settings so we know what the current state of execution is
            execution.settings = {
                ...execution.settings,
                ...settings
            };
        };
        /**
         * Update the ExecutionSettings for an active route.
         * @param {ExecutionSettings} settings - An object with execution settings.
         * @param {Route} route - The active route that gets the new execution settings.
         * @throws {ValidationError} Throws a ValidationError if parameters are invalid.
         */ this.updateExecutionSettings = (settings, route)=>{
            const execution = this.executionDictionary[route.id];
            if (!execution) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Can't set ExecutionSettings for the inactive route.");
            const config = this.configService.getConfig();
            execution.settings = {
                ...config.defaultExecutionSettings,
                ...settings
            };
        };
        /**
         * Executes a route until a user interaction is necessary (signing transactions, etc.) and then halts until the route is resumed.
         * @param {Route} route - A route that is currently in execution.
         * @deprecated use updateRouteExecution instead.
         */ this.moveExecutionToBackground = (route)=>{
            const execution = this.executionDictionary[route.id];
            if (!execution) return;
            for (const executor of execution.executors)executor.setInteraction({
                allowInteraction: false,
                allowUpdates: true
            });
            execution.settings = {
                ...execution.settings,
                executeInBackground: true
            };
        };
        /**
         * Stops the execution of an active route.
         * @param {Route} route - A route that is currently in execution.
         * @return {Route} The stopped route.
         */ this.stopExecution = (route)=>{
            const execution = this.executionDictionary[route.id];
            if (!execution) return route;
            for (const executor of execution.executors)executor.setInteraction({
                allowInteraction: false,
                allowUpdates: false,
                stopExecution: true
            });
            delete this.executionDictionary[route.id];
            return route;
        };
        /**
         * Get the list of active routes.
         * @return {Route[]} A list of routes.
         */ this.getActiveRoutes = ()=>{
            return Object.values(this.executionDictionary).map((dict)=>dict?.route).filter(Boolean);
        };
        /**
         * Return the current route information for given route. The route has to be active.
         * @param {Route} route - A route object.
         * @return {Route} The updated route.
         */ this.getActiveRoute = (route)=>{
            return this.executionDictionary[route.id]?.route;
        };
        this.configService = (0, $efbe31fc65013819$export$2e2bcd8739ae039).getInstance();
        if (configUpdate) // Update API urls before we request chains
        this.configService.updateConfig(configUpdate);
    }
}








class $815733ddabdce830$export$7e317191f16fbd67 extends (0, $21d643bfce15e72a$export$713e1c9695104f2) {
    constructor(configUpdate){
        super(configUpdate);
        /**
         * Get the current configuration of the SDK
         * @return {Config} - The config object
         */ this.getConfig = ()=>{
            return this.configService.getConfig();
        };
        /**
         * Get the SDK configuration after all setup calls are finished
         * @return {Promise<Config>} - The config object
         */ this.getConfigAsync = ()=>{
            return this.configService.getConfigAsync();
        };
        /**
         * Get an instance of a provider for a specific chain
         * @param {number} chainId - Id of the chain the provider is for
         * @param {boolean} archive - Whether to use an archive provider that is based on a default rpc or not. defaults to false
         * @return {FallbackProvider} The provider for the given chain
         */ this.getRpcProvider = (chainId, archive = false)=>{
            return (0, $1fe769d8e0ee09c9$export$1a2da1764918cffa)(chainId, archive);
        };
        /**
         * Set a new confuration for the SDK
         * @param {ConfigUpdate} configUpdate - An object containing the configuration fields that should be updated.
         * @return {Config} The renewed config object
         */ this.setConfig = (configUpdate)=>{
            return this.configService.updateConfig(configUpdate);
        };
        /**
         * Get a set of current possibilities based on a request that specifies which chains, exchanges and bridges are preferred or unwanted.
         * @param {PossibilitiesRequest} request - Object defining preferences regarding chain, exchanges and bridges
         * @return {Promise<PossibilitiesResponse>} Object listing current possibilities for any-to-any cross-chain-swaps based on the provided preferences.
         * @throws {LifiError} Throws a LifiError if request fails.
         * @deprecated We don't want to support this endpoint anymore in the future. /chains, /tools, /connections, and /tokens should be used instead
         */ this.getPossibilities = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getPossibilities(request, options);
        };
        /**
         * Fetch information about a Token
         * @param {ChainKey | ChainId} chain - Id or key of the chain that contains the token
         * @param {string} token - Address or symbol of the token on the requested chain
         * @throws {LifiError} - Throws a LifiError if request fails
         */ this.getToken = async (chain, token, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getToken(chain, token, options);
        };
        /**
         * Get a quote for a token transfer
         * @param {QuoteRequest} request - The configuration of the requested quote
         * @throws {LifiError} - Throws a LifiError if request fails
         */ this.getQuote = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getQuote(request, options);
        };
        /**
         * Get a quote for a destination contract call
         * @param {ContractCallQuoteRequest} request - The configuration of the requested destination call
         * @throws {LifiError} - Throws a LifiError if request fails
         * @deprecated This method is deprecated, please use `getContractCallsQuote` instead
         */ this.getContractCallQuote = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getContractCallQuote(request, options);
        };
        /**
         * Get a quotes for multiple destination contract call
         * @param {ContractCallsQuoteRequest} request - The configuration of the requested destination call
         * @throws {LifiError} - Throws a LifiError if request fails
         */ this.getContractCallsQuote = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getContractCallsQuote(request, options);
        };
        /**
         * Check the status of a transfer. For cross chain transfers, the "bridge" parameter is required.
         * @param {GetStatusRequest} request - Configuration of the requested status
         * @throws {LifiError} - Throws a LifiError if request fails
         */ this.getStatus = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getStatus(request, options);
        };
        /**
         * Get the available tools to bridge and swap tokens.
         * @param {ToolsRequest?} request - The configuration of the requested tools
         * @returns The tools that are available on the requested chains
         */ this.getTools = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getTools(request || {}, options);
        };
        /**
         * Get all known tokens.
         * @param {TokensRequest?} request - The configuration of the requested tokens
         * @returns The tokens that are available on the requested chains
         */ this.getTokens = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getTokens(request || {}, options);
        };
        /**
         * Get all available chains
         * @return {Promise<Chain[]>} A list of all available chains
         * @throws {LifiError} Throws a LifiError if request fails.
         */ this.getChains = async ()=>{
            return this.chainsService.getChains();
        };
        /**
         * Get a set of routes for a request that describes a transfer of tokens.
         * @param {RoutesRequest} request - A description of the transfer.
         * @return {Promise<RoutesResponse>} The resulting routes that can be used to realize the described transfer of tokens.
         * @throws {LifiError} Throws a LifiError if request fails.
         */ this.getRoutes = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getRoutes(request, options);
        };
        /**
         * Get the transaction data for a single step of a route
         * @param {LifiStep} step - The step object.
         * @return {Promise<LifiStep>} The step populated with the transaction data.
         * @throws {LifiError} Throws a LifiError if request fails.
         */ this.getStepTransaction = async (step, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getStepTransaction(step, options);
        };
        /**
         * Get gas recommendation for a certain chain
         * @param {GasRecommendationRequest} request - Configuration of the requested recommendation.
         * @throws {LifiError} Throws a LifiError if request fails.
         */ this.getGasRecommendation = async (request, options)=>{
            return (0, $988b46587540a82e$export$2e2bcd8739ae039).getGasRecommendation(request, options);
        };
        /**
         * Returns the balances of a specific token a wallet holds across all aggregated chains.
         * @param {string} walletAddress - A wallet address.
         * @param {Token} token - A Token object.
         * @return {Promise<TokenAmount | null>} An object containing the token and the amounts on different chains.
         * @throws {ValidationError} Throws a ValidationError if parameters are invalid.
         */ this.getTokenBalance = async (walletAddress, token)=>{
            if (!walletAddress) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Missing walletAddress.");
            if (!(0, $b2df358172b4a603$export$7c699a821ea811bc)(token)) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Invalid token passed: address "${token.address}" on chainId "${token.chainId}"`);
            return (0, $3a9ba3cc63aeaf25$export$2e2bcd8739ae039).getTokenBalance(walletAddress, token);
        };
        /**
         * Returns the balances for a list tokens a wallet holds  across all aggregated chains.
         * @param {string} walletAddress - A wallet address.
         * @param {Token[]} tokens - A list of Token objects.
         * @return {Promise<TokenAmount[]>} A list of objects containing the tokens and the amounts on different chains.
         * @throws {ValidationError} Throws a ValidationError if parameters are invalid.
         */ this.getTokenBalances = async (walletAddress, tokens)=>{
            if (!walletAddress) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Missing walletAddress.");
            const invalidTokens = tokens.filter((token)=>!(0, $b2df358172b4a603$export$7c699a821ea811bc)(token));
            if (invalidTokens.length) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Invalid token passed: address "${invalidTokens[0].address}" on chainId "${invalidTokens[0].chainId}"`);
            return (0, $3a9ba3cc63aeaf25$export$2e2bcd8739ae039).getTokenBalances(walletAddress, tokens);
        };
        /**
         * This method queries the balances of tokens for a specific list of chains for a given wallet.
         * @param {string} walletAddress - A walletaddress.
         * @param {{ [chainId: number]: Token[] }} tokensByChain - A list of Token objects organized by chain ids.
         * @return {Promise<{ [chainId: number]: TokenAmount[] }>} A list of objects containing the tokens and the amounts on different chains organized by the chosen chains.
         * @throws {ValidationError} Throws a ValidationError if parameters are invalid.
         */ this.getTokenBalancesForChains = async (walletAddress, tokensByChain)=>{
            if (!walletAddress) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)("Missing walletAddress.");
            const tokenList = Object.values(tokensByChain).flat();
            const invalidTokens = tokenList.filter((token)=>!(0, $b2df358172b4a603$export$7c699a821ea811bc)(token));
            if (invalidTokens.length) throw new (0, $b6aa7c63b666337d$export$2191b9da168c6cf0)(`Invalid token passed: address "${invalidTokens[0].address}" on chainId "${invalidTokens[0].chainId}"`);
            return (0, $3a9ba3cc63aeaf25$export$2e2bcd8739ae039).getTokenBalancesForChains(walletAddress, tokensByChain);
        };
        /**
         * Get the current approval for a certain token.
         * @param signer - The signer owning the token
         * @param token - The token that should be checked
         * @param approvalAddress - The address that has be approved
         */ this.getTokenApproval = async (signer, token, approvalAddress)=>{
            return (0, $c00661fa91c9b1bc$export$b91e4d0a5a23c200)(signer, token, approvalAddress);
        };
        /**
         * Get the current approval for a list of token / approval address pairs.
         * @param signer - The signer owning the tokens
         * @param tokenData - A list of token and approval address pairs
         */ this.bulkGetTokenApproval = async (signer, tokenData)=>{
            return (0, $c00661fa91c9b1bc$export$7264455740d688de)(signer, tokenData);
        };
        /**
         * Set approval for a certain token and amount.
         * @param { ApproveTokenRequest } request - The approval request
         */ this.approveToken = (request)=>{
            return (0, $c00661fa91c9b1bc$export$5245bb33fc1153cf)(request);
        };
        /**
         * Revoke approval for a certain token.
         * @param { RevokeApprovalRequest } request - The revoke request
         */ this.revokeTokenApproval = (request)=>{
            return (0, $c00661fa91c9b1bc$export$3cccd4793a96b52)(request);
        };
        /**
         * Get all the available connections for swap/bridging tokens
         * @param connectionRequest ConnectionsRequest
         * @returns ConnectionsResponse
         */ this.getConnections = async (connectionRequest)=>{
            const connections = await (0, $988b46587540a82e$export$2e2bcd8739ae039).getAvailableConnections(connectionRequest);
            return connections;
        };
        /**
         * Get all the transaction history for swap/bridging done via LiFi
         * @param walletAnalyticsRequest WalletAnalyticsRequest
         * @returns WalletAnalytics
         */ this.getTransactionHistory = async (walletAnalyticsRequest)=>{
            const transactions = await (0, $988b46587540a82e$export$2e2bcd8739ae039).getTransactionHistory(walletAnalyticsRequest);
            return transactions;
        };
        this.chainsService = (0, $5373603ab3f3b3c3$export$2e2bcd8739ae039).getInstance();
        this.chainsService.getChains().then((chains)=>{
            this.configService.updateChains(chains);
        });
        (0, $c98bbf8bc8a02c8a$export$9fe272d016535f0b)((0, $d95ba1f5d0f173ae$export$a8ff84c12d48cfa6), (0, $d95ba1f5d0f173ae$export$83d89fbfd8236492), configUpdate.disableVersionCheck);
    }
}







var $dup7A = parcelRequire("dup7A");

var $11Szb = parcelRequire("11Szb");
var $9dabe26fe674174f$export$c883e057baa24e24;
var $9dabe26fe674174f$export$2951cba41945c0c8;
"use strict";

var $dup7A = parcelRequire("dup7A");
var $578f60cc2ed38c69$exports = {};
"use strict";

$578f60cc2ed38c69$exports = (parcelRequire("2nfW6"));



var $i57sw = parcelRequire("i57sw");
var $9dabe26fe674174f$var$useDebugValue = $dup7A.useDebugValue;
var $9dabe26fe674174f$var$useSyncExternalStoreWithSelector = $578f60cc2ed38c69$exports.useSyncExternalStoreWithSelector;
var $9dabe26fe674174f$var$identity = function identity(arg) {
    return arg;
};
function $9dabe26fe674174f$var$useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = $9dabe26fe674174f$var$identity;
    var slice = $9dabe26fe674174f$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $9dabe26fe674174f$var$useDebugValue(slice);
    return slice;
}
var $9dabe26fe674174f$var$createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = $i57sw.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return $9dabe26fe674174f$var$useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var $9dabe26fe674174f$var$createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? $9dabe26fe674174f$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $9dabe26fe674174f$var$createWithEqualityFnImpl;
};
$9dabe26fe674174f$export$c883e057baa24e24 = $9dabe26fe674174f$var$createWithEqualityFn;
$9dabe26fe674174f$export$2951cba41945c0c8 = $9dabe26fe674174f$var$useStoreWithEqualityFn;


const $bbb643303e07c2aa$export$f198d20210ad72d2 = [
    "Bridges",
    "Exchanges"
];


const $80ac256836e84b51$export$8b8dbf18b008c4f9 = {
    routePriority: "RECOMMENDED",
    slippage: "0.5",
    gasPrice: "normal"
};
const $80ac256836e84b51$export$62680b65e63e14ec = {
    appearance: "auto",
    gasPrice: "normal",
    enabledAutoRefuel: true,
    showDestinationWallet: true,
    enabledBridges: [],
    enabledExchanges: []
};
const $80ac256836e84b51$export$772cdd5f573abcc9 = (0, $9dabe26fe674174f$export$c883e057baa24e24)((0, $11Szb.persist)((set, get)=>({
        ...$80ac256836e84b51$export$62680b65e63e14ec,
        setValue: (key, value)=>set(()=>({
                    [key]: value
                })),
        setValues: (values)=>set((state)=>{
                const updatedState = {
                    ...state
                };
                for(const key in values)if (Object.hasOwn(state, key)) updatedState[key] = values[key];
                return updatedState;
            }),
        initializeTools: (toolType, tools, reset)=>{
            if (!tools.length) return;
            set((state)=>{
                const updatedState = {
                    ...state
                };
                if (updatedState[`_enabled${toolType}`] && !reset) {
                    // Add new tools
                    const enabledTools = tools.filter((tool)=>!Object.hasOwn(updatedState[`_enabled${toolType}`], tool)).reduce((values, tool)=>{
                        values[tool] = true;
                        return values;
                    }, updatedState[`_enabled${toolType}`]);
                    // Filter tools we no longer have
                    updatedState[`_enabled${toolType}`] = Object.fromEntries(Object.entries(enabledTools).filter(([key])=>tools.includes(key)));
                } else updatedState[`_enabled${toolType}`] = tools.reduce((values, tool)=>{
                    values[tool] = true;
                    return values;
                }, {});
                updatedState[`enabled${toolType}`] = Object.entries(updatedState[`_enabled${toolType}`]).filter(([_, value])=>value).map(([key])=>key);
                return updatedState;
            });
        },
        setTools: (toolType, tools, availableTools)=>set(()=>({
                    [`enabled${toolType}`]: tools,
                    [`_enabled${toolType}`]: availableTools.reduce((values, toolKey)=>{
                        values[toolKey] = tools.includes(toolKey);
                        return values;
                    }, {})
                })),
        reset: (config, bridges, exchanges)=>{
            const { appearance: appearance, ...restDefaultSettings } = $80ac256836e84b51$export$62680b65e63e14ec;
            set(()=>({
                    ...restDefaultSettings,
                    ...$80ac256836e84b51$export$8b8dbf18b008c4f9
                }));
            get().initializeTools("Bridges", bridges, true);
            get().initializeTools("Exchanges", exchanges, true);
        }
    }), {
    name: `li.fi-widget-settings`,
    version: 2,
    partialize: (state)=>{
        const { enabledBridges: enabledBridges, enabledExchanges: enabledExchanges, ...partializedState } = state;
        return partializedState;
    },
    merge: (persistedState, currentState)=>{
        const state = {
            ...currentState,
            ...persistedState
        };
        (0, $bbb643303e07c2aa$export$f198d20210ad72d2).forEach((toolType)=>{
            state[`enabled${toolType}`] = Object.entries(persistedState[`_enabled${toolType}`]).filter(([_, value])=>value).map(([key])=>key);
        });
        return state;
    },
    migrate: (persistedState, version)=>{
        if (version === 0 && persistedState.appearance === "system") persistedState.appearance = $80ac256836e84b51$export$62680b65e63e14ec.appearance;
        if (version === 1) persistedState.slippage = $80ac256836e84b51$export$8b8dbf18b008c4f9.slippage;
        return persistedState;
    }
}), Object.is);
const $80ac256836e84b51$export$446ca6318ddf45cb = (config)=>{
    const { slippage: slippage, routePriority: routePriority, setValue: setValue, gasPrice: gasPrice } = $80ac256836e84b51$export$772cdd5f573abcc9.getState();
    const defaultSlippage = (config?.slippage || config?.sdkConfig?.defaultRouteOptions?.slippage || 0) * 100;
    const defaultRoutePriority = config?.routePriority || config?.sdkConfig?.defaultRouteOptions?.order;
    $80ac256836e84b51$export$8b8dbf18b008c4f9.slippage = (defaultSlippage || $80ac256836e84b51$export$8b8dbf18b008c4f9.slippage)?.toString();
    $80ac256836e84b51$export$8b8dbf18b008c4f9.routePriority = defaultRoutePriority || $80ac256836e84b51$export$8b8dbf18b008c4f9.routePriority;
    if (!slippage) setValue("slippage", $80ac256836e84b51$export$8b8dbf18b008c4f9.slippage);
    if (!routePriority) setValue("routePriority", $80ac256836e84b51$export$8b8dbf18b008c4f9.routePriority);
    if (!gasPrice) setValue("gasPrice", $80ac256836e84b51$export$8b8dbf18b008c4f9.gasPrice);
};


var $b344950477380f3f$exports = {};
(function(GLOBAL) {
    "use strict";
    var Big, /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */ DP = 20, /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */ NE = -7, /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */ PE = 21, /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */ STRICT = false, /**************************************************************************************************/ // Error messages.
    NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", // The shared prototype object.
    P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    /*
   * Create and return a Big constructor.
   */ function _Big_() {
        /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else {
                if (typeof n !== "string") {
                    if (Big.strict === true && typeof n !== "bigint") throw TypeError(INVALID + "value");
                    // Minus zero?
                    n = n === 0 && 1 / n < 0 ? "-0" : String(n);
                }
                parse(x, n);
            }
            // Retain a reference to this Big constructor.
            // Shadow Big.prototype.constructor which points to Object.
            x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.NE = NE;
        Big.PE = PE;
        Big.strict = STRICT;
        Big.roundDown = 0;
        Big.roundHalfUp = 1;
        Big.roundHalfEven = 2;
        Big.roundUp = 3;
        return Big;
    }
    /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */ function parse(x, n) {
        var e, i, nl;
        if (!NUMERIC.test(n)) throw Error(INVALID + "number");
        // Determine sign.
        x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        nl = n.length;
        // Determine leading zeros.
        for(i = 0; i < nl && n.charAt(i) == "0";)++i;
        if (i == nl) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; nl > 0 && n.charAt(--nl) == "0";);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
        }
        return x;
    }
    /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */ function round(x, sd, rm, more) {
        var xc = x.c;
        if (rm === UNDEFINED) rm = x.constructor.RM;
        if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error(INVALID_RM);
        if (sd < 1) {
            more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
            xc.length = 1;
            if (more) {
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = x.e - sd + 1;
                xc[0] = 1;
            } else // Zero.
            xc[0] = x.e = 0;
        } else if (sd < xc.length) {
            // xc[sd] is the digit after the digit that may be rounded up.
            more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
            // Remove any digits after the required precision.
            xc.length = sd;
            // Round up?
            if (more) // Rounding up may mean the previous digit has to be rounded up.
            for(; ++xc[--sd] > 9;){
                xc[sd] = 0;
                if (sd === 0) {
                    ++x.e;
                    xc.unshift(1);
                    break;
                }
            }
            // Remove trailing zeros.
            for(sd = xc.length; !xc[--sd];)xc.pop();
        }
        return x;
    }
    /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */ function stringify(x, doExponential, isNonzero) {
        var e = x.e, s = x.c.join(""), n = s.length;
        // Exponential notation?
        if (doExponential) s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
        else if (e < 0) {
            for(; ++e;)s = "0" + s;
            s = "0." + s;
        } else if (e > 0) {
            if (++e > n) for(e -= n; e--;)s += "0";
            else if (e < n) s = s.slice(0, e) + "." + s.slice(e);
        } else if (n > 1) s = s.charAt(0) + "." + s.slice(1);
        return x.s < 0 && isNonzero ? "-" + s : s;
    }
    // Prototype/instance methods
    /*
   * Return a new Big whose value is the absolute value of this Big.
   */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */ P.cmp = function(y) {
        var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        isneg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ isneg ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = -1; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ isneg ? 1 : -1;
    };
    /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.div = function(y) {
        var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
        // Divisor is zero?
        if (!b[0]) throw Error(DIV_BY_ZERO);
        // Dividend is 0? Return +-0.
        if (!a[0]) {
            y.s = k;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
        q.s = k;
        k = p < 0 ? 0 : p;
        // Create version of divisor with leading zero.
        bz.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; rl++ < bl;)r.push(0);
        do {
            // n is how many times the divisor goes into current remainder.
            for(n = 0; n < 10; n++){
                // Compare divisor and remainder.
                if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
                else {
                    for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                        cmp = b[ri] > r[ri] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(bt = rl == bl ? b : bz; rl;){
                        if (r[--rl] < bt[rl]) {
                            ri = rl;
                            for(; ri && !r[--ri];)r[ri] = 9;
                            --r[ri];
                            r[rl] += 10;
                        }
                        r[rl] -= bt[rl];
                    }
                    for(; !r[0];)r.shift();
                } else break;
            }
            // Add the digit n to the result array.
            qc[qi++] = cmp ? n : ++n;
            // Update the remainder.
            if (r[0] && cmp) r[rl] = a[ai] || 0;
            else r = [
                a[ai]
            ];
        }while ((ai++ < al || r[0] !== UNDEFINED) && k--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
            p--;
        }
        // Round?
        if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);
        return q;
    };
    /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */ P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */ P.minus = P.sub = function(y) {
        var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (yc[0]) y.s = -b;
            else if (xc[0]) y = new Big(x);
            else y.s = 1;
            return y;
        }
        // Determine which is the bigger number. Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xlty = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--;)t.push(0);
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xlty = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xlty = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xlty) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i];)xc[i] = 9;
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0;)xc.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */ P.mod = function(y) {
        var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throw Error(DIV_BY_ZERO);
        x.s = y.s = 1;
        ygtx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (ygtx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
   * Return a new Big whose value is the value of this Big negated.
   */ P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return x;
    };
    /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */ P.plus = P.add = function(y) {
        var e, k, t, x = this, Big = x.constructor;
        y = new Big(y);
        // Signs differ?
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (!yc[0]) {
                if (xc[0]) y = new Big(x);
                else y.s = x.s;
            }
            return y;
        }
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: reverse faster than unshifts.
        if (e = xe - ye) {
            if (e > 0) {
                ye = xe;
                t = yc;
            } else {
                e = -e;
                t = xc;
            }
            t.reverse();
            for(; e--;)t.push(0);
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        e = yc.length;
        // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
        for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (k) {
            xc.unshift(k);
            ++ye;
        }
        // Remove trailing zeros.
        for(e = xc.length; xc[--e] === 0;)xc.pop();
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */ P.pow = function(n) {
        var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + "exponent");
        if (isneg) n = -n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isneg ? one.div(y) : y;
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.prec = function(sd, rm) {
        if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
        return round(new this.constructor(this), sd, rm);
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.round = function(dp, rm) {
        if (dp === UNDEFINED) dp = 0;
        else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
        return round(new this.constructor(this), dp + this.e + 1, rm);
    };
    /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.sqrt = function() {
        var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big("0.5");
        // Zero?
        if (!x.c[0]) return new Big(x);
        // Negative?
        if (s < 0) throw Error(NAME + "No square root");
        // Estimate.
        s = Math.sqrt(x + "");
        // Math.sqrt underflow/overflow?
        // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
        if (s === 0 || s === 1 / 0) {
            c = x.c.join("");
            if (!(c.length + e & 1)) c += "0";
            s = Math.sqrt(c);
            e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
            r = new Big((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
        } else r = new Big(s + "");
        e = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            t = r;
            r = half.times(t.plus(x.div(t)));
        }while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
        return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
    };
    /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */ P.times = P.mul = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) {
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--;)c[j] = 0;
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = b;
        }
        // Increment result exponent if there is a final carry, otherwise remove leading zero.
        if (b) ++y.e;
        else c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i];)c.pop();
        y.c = c;
        return y;
    };
    /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toExponential = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), ++dp, rm);
            for(; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, true, !!n);
    };
    /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */ P.toFixed = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), dp + x.e + 1, rm);
            // x.e may have changed if the value is rounded up.
            for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, false, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */ P.toJSON = P.toString = function() {
        var x = this, Big = x.constructor;
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
    };
    /*
   * Return the value of this Big as a primitve number.
   */ P.toNumber = function() {
        var n = Number(stringify(this, true, true));
        if (this.constructor.strict === true && !this.eq(n.toString())) throw Error(NAME + "Imprecise conversion");
        return n;
    };
    /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toPrecision = function(sd, rm) {
        var x = this, Big = x.constructor, n = x.c[0];
        if (sd !== UNDEFINED) {
            if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
            x = round(new Big(x), sd, rm);
            for(; x.c.length < sd;)x.c.push(0);
        }
        return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */ P.valueOf = function() {
        var x = this, Big = x.constructor;
        if (Big.strict === true) throw Error(NAME + "valueOf disallowed");
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
    };
    // Export
    Big = _Big_();
    Big["default"] = Big.Big = Big;
    //AMD.
    if (typeof define === "function" && define.amd) define(function() {
        return Big;
    });
    else if (0, $b344950477380f3f$exports) $b344950477380f3f$exports = Big;
    else GLOBAL.Big = Big;
})($b344950477380f3f$exports);


// JavaScript numbers use exponential notation for positive exponents of 21 and above. We need more.
(0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports))).PE = 42;
// JavaScript numbers use exponential notation for negative exponents of -7 and below. We need more.
(0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports))).NE = -42;
const $2a25b0bfe67ae18c$export$36da51c03c5f8def = (amount = "0", decimals = 0, decimalPlaces = 3)=>{
    let shiftedAmount = amount;
    if (decimals) shiftedAmount = (Number(amount) / 10 ** decimals).toString();
    const parsedAmount = parseFloat(shiftedAmount);
    if (parsedAmount === 0 || isNaN(Number(shiftedAmount))) return "0";
    const absAmount = Math.abs(parsedAmount);
    while(absAmount < 1 / 10 ** decimalPlaces)decimalPlaces++;
    return parsedAmount.toFixed(decimalPlaces + 1);
};
const $2a25b0bfe67ae18c$export$c51f290eed53255d = (slippage = "", defaultValue = "", returnInitial = false)=>{
    if (!slippage) return slippage;
    const parsedSlippage = parseFloat(slippage);
    if (isNaN(Number(slippage)) && !isNaN(parsedSlippage)) return parsedSlippage.toString();
    if (isNaN(parsedSlippage)) return defaultValue;
    if (parsedSlippage > 100) return "100";
    if (parsedSlippage < 0) return Math.abs(parsedSlippage).toString();
    if (returnInitial) return slippage;
    return parsedSlippage.toString();
};
const $2a25b0bfe67ae18c$export$e772787f786097e7 = (amount, decimals = null, returnInitial = false)=>{
    if (!amount) return amount;
    let formattedAmount = amount.replaceAll(",", ".");
    if (formattedAmount.startsWith(".")) formattedAmount = "0" + formattedAmount;
    const parsedAmount = parseFloat(formattedAmount);
    if (isNaN(Number(formattedAmount)) && !isNaN(parsedAmount)) return parsedAmount.toString();
    if (isNaN(Math.abs(Number(formattedAmount)))) return "";
    if (returnInitial) return formattedAmount;
    let [integer, fraction = ""] = formattedAmount.split(".");
    if (decimals !== null && fraction.length > decimals) fraction = fraction.slice(0, decimals);
    integer = integer.replace(/^0+|-/, "");
    fraction = fraction.replace(/(0+)$/, "");
    return `${integer || (fraction ? "0" : "")}${fraction ? `.${fraction}` : ""}`;
};
const $2a25b0bfe67ae18c$export$78792d27fa2fce59 = (amount, price)=>{
    if (!amount || !price) return 0;
    if (isNaN(Number(amount)) || isNaN(Number(price))) return 0;
    return parseFloat(amount) * parseFloat(price);
};


const $3f300e2d42fad4b6$var$initialContext = {
    elementId: "",
    integrator: ""
};
const $3f300e2d42fad4b6$var$WidgetContext = (0, $dup7A.createContext)($3f300e2d42fad4b6$var$initialContext);
const $3f300e2d42fad4b6$export$3cc8cef7bbce91ae = ()=>(0, $dup7A.useContext)($3f300e2d42fad4b6$var$WidgetContext);
const $3f300e2d42fad4b6$export$42e76418f6ea3109 = ({ children: children, config: { fromChain: fromChain, fromToken: fromToken, toChain: toChain, toToken: toToken, fromAmount: fromAmount, toAddress: toAddress, integrator: integrator, ...config } = {} })=>{
    const elementId = (0, $dup7A.useId)();
    if (!integrator) throw Error('Required property "integrator" is missing.');
    const value = (0, $dup7A.useMemo)(()=>{
        try {
            const searchParams = Object.fromEntries(new URLSearchParams(window?.location.search));
            // Prevent using fromToken/toToken params if chain is not selected
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (searchParams[`${key}Token`] && !searchParams[`${key}Chain`]) delete searchParams[`${key}Token`];
            });
            const value = {
                ...config,
                fromChain: searchParams.fromChain && isNaN(parseInt(searchParams.fromChain, 10)) || typeof fromChain === "string" ? (0, $6c3e4e2cfe28d8cc$export$54c067a5f720c664)((searchParams.fromChain || fromChain)?.toLowerCase())?.id : searchParams.fromChain && !isNaN(parseInt(searchParams.fromChain, 10)) || typeof fromChain === "number" ? parseInt(searchParams.fromChain, 10) || fromChain : undefined,
                toChain: searchParams.toChain && isNaN(parseInt(searchParams.toChain, 10)) || typeof toChain === "string" ? (0, $6c3e4e2cfe28d8cc$export$54c067a5f720c664)((searchParams.toChain || toChain)?.toLowerCase())?.id : searchParams.toChain && !isNaN(parseInt(searchParams.toChain, 10)) || typeof toChain === "number" ? parseInt(searchParams.toChain, 10) || toChain : undefined,
                fromToken: searchParams.fromToken || fromToken,
                toToken: searchParams.toToken || toToken,
                fromAmount: typeof searchParams.fromAmount === "string" && !isNaN(parseFloat(searchParams.fromAmount)) ? (0, $2a25b0bfe67ae18c$export$e772787f786097e7)(searchParams.fromAmount) : fromAmount,
                toAddress: searchParams.toAddress || toAddress,
                elementId: elementId,
                integrator: integrator
            };
            (0, $80ac256836e84b51$export$446ca6318ddf45cb)(value);
            return value;
        } catch (e) {
            console.warn(e);
            return {
                ...config,
                elementId: elementId,
                integrator: integrator
            };
        }
    }, [
        config,
        elementId,
        fromAmount,
        fromChain,
        fromToken,
        integrator,
        toAddress,
        toChain,
        toToken
    ]);
    return (0, $cZGFG.jsx)($3f300e2d42fad4b6$var$WidgetContext.Provider, {
        value: value,
        children: children
    });
};


/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $dup7A = parcelRequire("dup7A");

var $98260d45445f6983$export$cf3347e5e7e1bef5;
(function(FormKey) {
    FormKey["ContractOutputsToken"] = "contractOutputsToken";
    FormKey["FromAmount"] = "fromAmount";
    FormKey["FromChain"] = "fromChain";
    FormKey["FromToken"] = "fromToken";
    FormKey["ToAddress"] = "toAddress";
    FormKey["ToAmount"] = "toAmount";
    FormKey["ToChain"] = "toChain";
    FormKey["ToContractAddress"] = "toContractAddress";
    FormKey["ToContractCallData"] = "toContractCallData";
    FormKey["ToContractGasLimit"] = "ToContractGasLimit";
    FormKey["ToToken"] = "toToken";
    FormKey["TokenSearchFilter"] = "tokenSearchFilter";
})($98260d45445f6983$export$cf3347e5e7e1bef5 || ($98260d45445f6983$export$cf3347e5e7e1bef5 = {}));
const $98260d45445f6983$export$69d9321fdf06d524 = {
    getChainKey: (formType)=>`${formType}Chain`,
    getTokenKey: (formType)=>`${formType}Token`,
    getAmountKey: (formType)=>`${formType}Amount`
};



var $cZGFG = parcelRequire("cZGFG");

const $ab4607e7fa73cc99$export$15599da40e72d2f = async (provider, chainId)=>{
    const params = {
        chainId: (0, $6c3e4e2cfe28d8cc$export$2889085f66c5f9c0)(chainId).metamask?.chainId
    };
    try {
        if (provider.send) {
            await provider.send("wallet_switchEthereumChain", [
                params
            ]);
            return true;
        } else {
            const switched = await new Promise((resolve, reject)=>{
                provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        params
                    ]
                }).catch((error)=>{
                    console.error(error);
                    reject(error);
                });
                provider.once("chainChanged", (id)=>{
                    if (parseInt(id) === chainId) resolve(true);
                    else resolve(false);
                });
            });
            return switched;
        }
    } catch (error) {
        // const ERROR_CODE_UNKNOWN_CHAIN = 4902
        if (error.code !== (0, $b6aa7c63b666337d$export$54cb5cb2ed5e1b42).userRejectedRequest) {
            const added = await $ab4607e7fa73cc99$export$e648161d6b1bb565(provider, chainId);
            return added;
        } else {
            console.error(error);
            return false;
        }
    }
};
const $ab4607e7fa73cc99$export$e648161d6b1bb565 = async (provider, chainId)=>{
    const params = (0, $6c3e4e2cfe28d8cc$export$2889085f66c5f9c0)(chainId).metamask;
    try {
        if (provider.send) await provider.send("wallet_addEthereumChain", [
            params
        ]);
        else await provider.request({
            method: "wallet_addEthereumChain",
            params: [
                params
            ]
        });
        return true;
    } catch (error) {
        console.error(`Error adding chain ${chainId}: ${error.message}`);
        return false;
    }
};
const $ab4607e7fa73cc99$export$bab68a8260c0354 = async (provider, token)=>{
    const params = {
        type: "ERC20",
        options: {
            address: token.address,
            symbol: token.symbol,
            decimals: token.decimals,
            image: token.logoURI
        }
    };
    try {
        if (provider.send) await provider.send("wallet_watchAsset", [
            params
        ]);
        else await provider.request({
            method: "wallet_watchAsset",
            params: [
                params
            ]
        });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};
const $ab4607e7fa73cc99$export$94064a5f8f757f28 = async (provider, chainId, token)=>{
    const chainIdPrefixed = (0, $e2010b7659416a79$export$aecf6aa8f33b547c)(chainId);
    try {
        if (chainIdPrefixed !== (0, $e2010b7659416a79$export$aecf6aa8f33b547c)((await provider.getNetwork()).chainId)) {
            const switched = await $ab4607e7fa73cc99$export$15599da40e72d2f(provider, chainId);
            if (switched) {
                const added = await new Promise((resolve, reject)=>{
                    provider.once("chainChanged", async (id)=>{
                        if (parseInt(id, 10) === chainId) {
                            const added = await $ab4607e7fa73cc99$export$bab68a8260c0354(provider, token);
                            resolve(added);
                        }
                    });
                });
                return added;
            }
            return switched;
        } else {
            const added = await $ab4607e7fa73cc99$export$bab68a8260c0354(provider, token);
            return added;
        }
    } catch (error) {
        console.error(error);
        return false;
    }
};


var $ej6Nm = parcelRequire("ej6Nm");
function $7a14c0cb67726ab9$var$isPersistedWallet(object) {
    return typeof object.address === "string" && typeof object.name === "string";
}
const $7a14c0cb67726ab9$var$normalizeWallets = (wallets)=>{
    return wallets.map((wallet)=>({
            address: wallet.address.toLowerCase(),
            name: wallet.name
        }));
};
const $7a14c0cb67726ab9$var$deepEqual = (x, y)=>{
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty ? ok(x).length === ok(y).length && ok(x).every((key)=>$7a14c0cb67726ab9$var$deepEqual(x[key], y[key])) : x === y;
};
const $7a14c0cb67726ab9$var$storeWallets = (wallets)=>{
    const normalizedWallets = $7a14c0cb67726ab9$var$normalizeWallets(wallets);
    localStorage.setItem("li.fi-wallets", JSON.stringify(Array.from(new Set(normalizedWallets))));
};
const $7a14c0cb67726ab9$export$1916c548b8c7395d = ()=>{
    const walletsString = localStorage.getItem("li.fi-wallets");
    if (walletsString) try {
        const parsedWalletObjects = JSON.parse(walletsString);
        if (parsedWalletObjects.some((wallet)=>!$7a14c0cb67726ab9$var$isPersistedWallet(wallet))) throw new Error("Malformed persisted active wallets");
        else return parsedWalletObjects;
    } catch (e) {
        localStorage.removeItem("li.fi-wallets");
        return [];
    }
    else return [];
};
const $7a14c0cb67726ab9$var$storeDeactivatedWallets = (wallets)=>{
    const normalizedWallets = $7a14c0cb67726ab9$var$normalizeWallets(wallets);
    localStorage.setItem("li.fi-deactivated-wallets", JSON.stringify(Array.from(new Set(normalizedWallets))));
};
const $7a14c0cb67726ab9$var$readDeactivatedWallets = ()=>{
    const walletsString = localStorage.getItem("li.fi-deactivated-wallets");
    if (walletsString) try {
        const parsedWalletObjects = JSON.parse(walletsString);
        if (parsedWalletObjects.some((wallet)=>!$7a14c0cb67726ab9$var$isPersistedWallet(wallet))) throw new Error("Malformed persisted deactivated wallets");
        else return parsedWalletObjects;
    } catch (e) {
        localStorage.removeItem("li.fi-deactivated-wallets");
        return [];
    }
    else return [];
};
const $7a14c0cb67726ab9$export$eb5be0f6d4296c77 = (wallet)=>{
    if (!wallet) return;
    const normalizedWallet = $7a14c0cb67726ab9$var$normalizeWallets([
        wallet
    ])[0];
    const wallets = $7a14c0cb67726ab9$export$1916c548b8c7395d();
    const filteredWallets = wallets.filter((wallet)=>!$7a14c0cb67726ab9$var$deepEqual(wallet, normalizedWallet));
    $7a14c0cb67726ab9$var$storeWallets(filteredWallets);
};
const $7a14c0cb67726ab9$export$737fc584bf9a27eb = (wallet)=>{
    if (!wallet) return;
    const normalizedWallet = $7a14c0cb67726ab9$var$normalizeWallets([
        wallet
    ])[0];
    const deactivatedWallets = $7a14c0cb67726ab9$var$readDeactivatedWallets();
    deactivatedWallets.push(normalizedWallet);
    $7a14c0cb67726ab9$var$storeDeactivatedWallets(deactivatedWallets);
};
const $7a14c0cb67726ab9$export$fd5bdffa9f46a794 = (wallet)=>{
    if (!wallet) return;
    const normalizedWallet = $7a14c0cb67726ab9$var$normalizeWallets([
        wallet
    ])[0];
    const activeWallets = $7a14c0cb67726ab9$export$1916c548b8c7395d();
    activeWallets.push(normalizedWallet);
    $7a14c0cb67726ab9$var$storeWallets(activeWallets);
};
const $7a14c0cb67726ab9$export$da026bb89fd41d74 = (wallet)=>{
    if (!wallet) return;
    const normalizedWallet = $7a14c0cb67726ab9$var$normalizeWallets([
        wallet
    ])[0];
    const deactivatedWallets = $7a14c0cb67726ab9$var$readDeactivatedWallets();
    const deactivatedWalletsWithoutAccount = deactivatedWallets.filter((wallet)=>!$7a14c0cb67726ab9$var$deepEqual(wallet, normalizedWallet));
    $7a14c0cb67726ab9$var$storeDeactivatedWallets(deactivatedWalletsWithoutAccount);
};
const $7a14c0cb67726ab9$export$1bafa89093a6a124 = (wallet)=>{
    if (!wallet) return true;
    const normalizedWallet = $7a14c0cb67726ab9$var$normalizeWallets([
        wallet
    ])[0];
    const deactivatedWallets = $7a14c0cb67726ab9$var$readDeactivatedWallets();
    return deactivatedWallets.some((deactivatedWallet)=>$7a14c0cb67726ab9$var$deepEqual(deactivatedWallet, normalizedWallet));
};


class $2ae5e5df9f9d28fe$export$92541f0969b14674 extends (0, $ej6Nm.EventEmitter) {
    constructor(){
        super(...arguments);
        this.connectedWallets = [];
        this.connect = async (wallet)=>{
            try {
                await wallet.connect();
                wallet.addListener("walletAccountChanged", this.handleAccountDataChange);
                this.connectedWallets.unshift(wallet);
                (0, $7a14c0cb67726ab9$export$da026bb89fd41d74)({
                    address: wallet.account?.address || "",
                    name: wallet.name
                });
                (0, $7a14c0cb67726ab9$export$fd5bdffa9f46a794)({
                    address: wallet.account?.address || "",
                    name: wallet.name
                });
            } catch (e) {
                throw e;
            }
        };
        this.disconnect = async (wallet)=>{
            wallet.removeAllListeners();
            (0, $7a14c0cb67726ab9$export$eb5be0f6d4296c77)({
                address: wallet.account?.address || "",
                name: wallet.name
            });
            (0, $7a14c0cb67726ab9$export$737fc584bf9a27eb)({
                address: wallet.account?.address || "",
                name: wallet.name
            });
            wallet.disconnect();
        };
    }
    async autoConnect(wallets) {
        for (const wallet of wallets)if (wallet.autoConnect) {
            await wallet.autoConnect();
            wallet.addListener("walletAccountChanged", this.handleAccountDataChange);
            this.connectedWallets.unshift(wallet);
        }
    }
    handleAccountDataChange() {
        this.emit("walletChanged", this.connectedWallets);
    }
}


var $6eaaae070ad95963$exports = {};
"use strict";
var $6eaaae070ad95963$var$__createBinding = $6eaaae070ad95963$exports && $6eaaae070ad95963$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6eaaae070ad95963$var$__exportStar = $6eaaae070ad95963$exports && $6eaaae070ad95963$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6eaaae070ad95963$var$__createBinding(exports1, m, p);
};
var $6eaaae070ad95963$var$__importDefault = $6eaaae070ad95963$exports && $6eaaae070ad95963$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($6eaaae070ad95963$exports, "__esModule", {
    value: true
});
$6eaaae070ad95963$exports.getSDKVersion = void 0;

const $6eaaae070ad95963$var$sdk_1 = $6eaaae070ad95963$var$__importDefault((parcelRequire("bMt2j")));
$6eaaae070ad95963$exports.default = $6eaaae070ad95963$var$sdk_1.default;

$6eaaae070ad95963$var$__exportStar((parcelRequire("bMt2j")), $6eaaae070ad95963$exports);

$6eaaae070ad95963$var$__exportStar((parcelRequire("dUSnl")), $6eaaae070ad95963$exports);

$6eaaae070ad95963$var$__exportStar((parcelRequire("2XHGr")), $6eaaae070ad95963$exports);

$6eaaae070ad95963$var$__exportStar((parcelRequire("lu5V3")), $6eaaae070ad95963$exports);

var $4QxQm = parcelRequire("4QxQm");
Object.defineProperty($6eaaae070ad95963$exports, "getSDKVersion", {
    enumerable: true,
    get: function() {
        return $4QxQm.getSDKVersion;
    }
});


parcelRequire("8VNI3");
var $5lu0X = parcelRequire("5lu0X");

var $ej6Nm = parcelRequire("ej6Nm");


class $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6 extends (0, $ej6Nm.EventEmitter) {
    constructor(constructorArgs, windowConnector = window.ethereum, autoConnect = false){
        super();
        this.isActivationInProgress = false;
        this.initializeProvider(windowConnector);
        this.name = constructorArgs.name;
        this.icon = constructorArgs.icon;
        this.installed = constructorArgs.installed;
    }
    initializeProvider(connectorWindowProperty) {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        this.windowProvider = connectorWindowProperty;
        this.windowProvider?.on("connect", async ({ chainId: chainId })=>{
            await this.calcAccountData();
        });
        this.windowProvider?.on("disconnect", async (error)=>{
            await this.calcAccountData();
        });
        this.windowProvider?.on("chainChanged", async (chainId)=>{
            await this.calcAccountData();
        });
        this.windowProvider?.on("accountsChanged", async (accounts)=>{
            if (!accounts.length) {
                this.account = undefined;
                this.emit("walletAccountChanged", this);
                return;
            }
            await this.calcAccountData();
        });
    }
    async autoConnect() {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        if (!this.windowProvider) throw new Error("provider is not defined.");
        if (this.isActivationInProgress) return;
        try {
            const selectedAddress = this.windowProvider.selectedAddress;
            if (!(0, $7a14c0cb67726ab9$export$1bafa89093a6a124)({
                address: selectedAddress || "",
                name: this.name
            })) await this.calcAccountData();
        } catch (e) {
            throw e;
        }
    }
    async connect() {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        if (!this.windowProvider) throw new Error("provider is not defined.");
        if (this.isActivationInProgress) return;
        this.isActivationInProgress = true;
        try {
            await this.windowProvider?.request({
                method: "eth_requestAccounts"
            });
            await this.calcAccountData();
        } catch (error) {
            this.isActivationInProgress = false;
            throw error;
        }
        this.isActivationInProgress = false;
    }
    disconnect() {
        this.account = undefined;
        this.isActivationInProgress = false;
    }
    async switchChain(chainId) {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        if (!this.account?.provider) throw new Error("provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$15599da40e72d2f)(this.account?.provider, chainId);
    }
    async addChain(chainId) {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        if (!this.account?.provider) throw new Error("provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$e648161d6b1bb565)(this.account?.provider, chainId);
    }
    async addToken(chainId, token) {
        if (window === undefined) throw new Error("window is not defined. This should not have happened.");
        if (!this.account?.provider) throw new Error("provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$94064a5f8f757f28)(this.account?.provider, chainId, token);
    }
    async calcAccountData() {
        if (!this.windowProvider) throw new Error("provider is not defined.");
        const provider = new (0, $5lu0X.Web3Provider)(this.windowProvider, "any");
        const accounts = await provider.listAccounts();
        if (!accounts.length) return;
        const signer = provider.getSigner();
        this.account = {
            chainId: await signer.getChainId(),
            address: await signer.getAddress(),
            signer: signer,
            provider: provider
        };
        this.emit("walletAccountChanged", this);
    }
}


parcelRequire("8VNI3");
var $5lu0X = parcelRequire("5lu0X");
var $6660f38355b02f56$exports = {};
"use strict";
Object.defineProperty($6660f38355b02f56$exports, "__esModule", {
    value: true
});
$6660f38355b02f56$exports.SafeAppProvider = void 0;
var $dffd674f859d8deb$exports = {};
"use strict";
Object.defineProperty($dffd674f859d8deb$exports, "__esModule", {
    value: true
});
$dffd674f859d8deb$exports.SafeAppProvider = void 0;

var $ej6Nm = parcelRequire("ej6Nm");
var $87ac475c2a83ba81$exports = {};
"use strict";
Object.defineProperty($87ac475c2a83ba81$exports, "__esModule", {
    value: true
});
$87ac475c2a83ba81$exports.getLowerCase = void 0;
function $87ac475c2a83ba81$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
$87ac475c2a83ba81$exports.getLowerCase = $87ac475c2a83ba81$var$getLowerCase;


// The API is based on Ethereum JavaScript API Provider Standard. Link: https://eips.ethereum.org/EIPS/eip-1193
class $dffd674f859d8deb$var$SafeAppProvider extends $ej6Nm.EventEmitter {
    constructor(safe, sdk){
        super();
        this.submittedTxs = new Map();
        this.safe = safe;
        this.sdk = sdk;
    }
    async connect() {
        this.emit("connect", {
            chainId: this.chainId
        });
        return;
    }
    async disconnect() {
        return;
    }
    get chainId() {
        return this.safe.chainId;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async request(request) {
        const { method: method, params: params = [] } = request;
        switch(method){
            case "eth_accounts":
                return [
                    this.safe.safeAddress
                ];
            case "net_version":
            case "eth_chainId":
                return `0x${this.chainId.toString(16)}`;
            case "personal_sign":
                {
                    const [message, address] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(message);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sign":
                {
                    const [address, messageHash] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase() || !messageHash.startsWith("0x")) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(messageHash);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_signTypedData":
            case "eth_signTypedData_v4":
                {
                    const [address, typedData] = params;
                    const parsedTypedData = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address is invalid");
                    const response = await this.sdk.txs.signTypedMessage(parsedTypedData);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sendTransaction":
                // `value` or `data` can be explicitly set as `undefined` for example in Viem. The spread will overwrite the fallback value.
                const tx = {
                    ...params[0],
                    value: params[0].value || "0",
                    data: params[0].data || "0x"
                };
                // Some ethereum libraries might pass the gas as a hex-encoded string
                // We need to convert it to a number because the SDK expects a number and our backend only supports
                // Decimal numbers
                if (typeof tx.gas === "string" && tx.gas.startsWith("0x")) tx.gas = parseInt(tx.gas, 16);
                const resp = await this.sdk.txs.send({
                    txs: [
                        tx
                    ],
                    params: {
                        safeTxGas: tx.gas
                    }
                });
                // Store fake transaction
                this.submittedTxs.set(resp.safeTxHash, {
                    from: this.safe.safeAddress,
                    hash: resp.safeTxHash,
                    gas: 0,
                    gasPrice: "0x00",
                    nonce: 0,
                    input: tx.data,
                    value: tx.value,
                    to: tx.to,
                    blockHash: null,
                    blockNumber: null,
                    transactionIndex: null
                });
                return resp.safeTxHash;
            case "eth_blockNumber":
                const block = await this.sdk.eth.getBlockByNumber([
                    "latest"
                ]);
                return block.number;
            case "eth_getBalance":
                return this.sdk.eth.getBalance([
                    (0, $87ac475c2a83ba81$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getCode":
                return this.sdk.eth.getCode([
                    (0, $87ac475c2a83ba81$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getTransactionCount":
                return this.sdk.eth.getTransactionCount([
                    (0, $87ac475c2a83ba81$exports.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getStorageAt":
                return this.sdk.eth.getStorageAt([
                    (0, $87ac475c2a83ba81$exports.getLowerCase)(params[0]),
                    params[1],
                    params[2]
                ]);
            case "eth_getBlockByNumber":
                return this.sdk.eth.getBlockByNumber([
                    params[0],
                    params[1]
                ]);
            case "eth_getBlockByHash":
                return this.sdk.eth.getBlockByHash([
                    params[0],
                    params[1]
                ]);
            case "eth_getTransactionByHash":
                let txHash = params[0];
                try {
                    const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                    txHash = resp.txHash || txHash;
                } catch (e) {}
                // Use fake transaction if we don't have a real tx hash
                if (this.submittedTxs.has(txHash)) return this.submittedTxs.get(txHash);
                return this.sdk.eth.getTransactionByHash([
                    txHash
                ]).then((tx)=>{
                    // We set the tx hash to the one requested, as some provider assert this
                    if (tx) tx.hash = params[0];
                    return tx;
                });
            case "eth_getTransactionReceipt":
                {
                    let txHash = params[0];
                    try {
                        const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                        txHash = resp.txHash || txHash;
                    } catch (e) {}
                    return this.sdk.eth.getTransactionReceipt([
                        txHash
                    ]).then((tx)=>{
                        // We set the tx hash to the one requested, as some provider assert this
                        if (tx) tx.transactionHash = params[0];
                        return tx;
                    });
                }
            case "eth_estimateGas":
                return this.sdk.eth.getEstimateGas(params[0]);
            case "eth_call":
                return this.sdk.eth.call([
                    params[0],
                    params[1]
                ]);
            case "eth_getLogs":
                return this.sdk.eth.getPastLogs([
                    params[0]
                ]);
            case "eth_gasPrice":
                return this.sdk.eth.getGasPrice();
            case "wallet_getPermissions":
                return this.sdk.wallet.getPermissions();
            case "wallet_requestPermissions":
                return this.sdk.wallet.requestPermissions(params[0]);
            case "safe_setSettings":
                return this.sdk.eth.setSafeSettings([
                    params[0]
                ]);
            default:
                throw Error(`"${request.method}" not implemented`);
        }
    }
    // this method is needed for ethers v4
    // https://github.com/ethers-io/ethers.js/blob/427e16826eb15d52d25c4f01027f8db22b74b76c/src.ts/providers/web3-provider.ts#L41-L55
    send(request, callback) {
        if (!request) callback("Undefined request");
        this.request(request).then((result)=>callback(null, {
                jsonrpc: "2.0",
                id: request.id,
                result: result
            })).catch((error)=>callback(error, null));
    }
}
$dffd674f859d8deb$exports.SafeAppProvider = $dffd674f859d8deb$var$SafeAppProvider;


Object.defineProperty($6660f38355b02f56$exports, "SafeAppProvider", {
    enumerable: true,
    get: function() {
        return $dffd674f859d8deb$exports.SafeAppProvider;
    }
});




var $ej6Nm = parcelRequire("ej6Nm");
class $2d55f8f7f1cec8ab$export$14207a2655efc957 extends (0, $ej6Nm.EventEmitter) {
    constructor(args){
        super();
        this.isActivationInProgress = false;
        this.autoConnect = async ()=>{
            await this.calcAccountData();
        };
        this.disconnect = ()=>{
            this.account = undefined;
        };
        this.connect = async ()=>{
            await this.calcAccountData();
        };
        this.switchChain = ()=>{
            console.warn("Method switchChain not allowed");
            return null;
        };
        this.addChain = ()=>{
            console.warn("Method addChain not allowed");
            return null;
        };
        this.addToken = ()=>{
            console.warn("Method addToken not allowed");
            return null;
        };
        this.name = args.name;
        this.icon = args.icon;
        this.installed = args.installed;
        this.calcAccountData();
    }
    async calcAccountData() {
        const sdk = new (0, (/*@__PURE__*/$parcel$interopDefault($6eaaae070ad95963$exports)))();
        const accountInfo = await sdk.safe.getInfo();
        const safe = {
            safeAddress: accountInfo.safeAddress,
            chainId: accountInfo.chainId,
            threshold: accountInfo.threshold,
            owners: accountInfo.owners,
            isReadOnly: accountInfo.isReadOnly
        };
        const safeInstance = new (0, $6660f38355b02f56$exports.SafeAppProvider)(safe, sdk);
        const provider = new (0, $5lu0X.Web3Provider)(safeInstance);
        const signer = provider.getSigner();
        this.account = {
            chainId: accountInfo.chainId,
            address: accountInfo.safeAddress,
            signer: signer,
            provider: provider,
            isMultisigWallet: true
        };
        this.emit("walletAccountChanged", this);
    }
}


parcelRequire("8VNI3");
var $5lu0X = parcelRequire("5lu0X");

var $ej6Nm = parcelRequire("ej6Nm");

var $lbkR2 = parcelRequire("lbkR2");

var $8Yg5s = parcelRequire("8Yg5s");

var $28JPH = parcelRequire("28JPH");

var $81v59 = parcelRequire("81v59");

var $7GGtC = parcelRequire("7GGtC");

var $g3kzz = parcelRequire("g3kzz");

var $bwGWz = parcelRequire("bwGWz");

var $lYmee = parcelRequire("lYmee");

var $5GkW9 = parcelRequire("5GkW9");

var $89Tbs = parcelRequire("89Tbs");
var $e077786f7a954859$exports = {};
"use strict";
Object.defineProperty($e077786f7a954859$exports, "__esModule", {
    value: true
});
var $ea33ae26301e22f9$exports = {};
"use strict";
Object.defineProperty($ea33ae26301e22f9$exports, "__esModule", {
    value: true
});
function $ea33ae26301e22f9$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$ea33ae26301e22f9$exports.compare = $ea33ae26301e22f9$var$compare;


var $2bb5cbb6bb39daba$exports = {};
"use strict";
Object.defineProperty($2bb5cbb6bb39daba$exports, "__esModule", {
    value: true
});
var $80f8ab4b16225486$exports = {};
"use strict";
Object.defineProperty($80f8ab4b16225486$exports, "__esModule", {
    value: true
});
function $80f8ab4b16225486$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $80f8ab4b16225486$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}
$80f8ab4b16225486$exports.alloc = $80f8ab4b16225486$var$alloc;
$80f8ab4b16225486$exports.allocUnsafe = $80f8ab4b16225486$var$allocUnsafe;


function $2bb5cbb6bb39daba$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $80f8ab4b16225486$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
$2bb5cbb6bb39daba$exports.concat = $2bb5cbb6bb39daba$var$concat;


var $d9126094c9589f9f$exports = {};
"use strict";
Object.defineProperty($d9126094c9589f9f$exports, "__esModule", {
    value: true
});
function $d9126094c9589f9f$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$d9126094c9589f9f$exports.equals = $d9126094c9589f9f$var$equals;


var $269808579d792179$exports = {};
"use strict";
Object.defineProperty($269808579d792179$exports, "__esModule", {
    value: true
});
var $6c6abc5e9e342e71$exports = {};
"use strict";

var $4tv9y = parcelRequire("4tv9y");

function $6c6abc5e9e342e71$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $6c6abc5e9e342e71$var$string = $6c6abc5e9e342e71$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $6c6abc5e9e342e71$var$ascii = $6c6abc5e9e342e71$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $80f8ab4b16225486$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $6c6abc5e9e342e71$var$BASES = {
    utf8: $6c6abc5e9e342e71$var$string,
    "utf-8": $6c6abc5e9e342e71$var$string,
    hex: $4tv9y.bases.base16,
    latin1: $6c6abc5e9e342e71$var$ascii,
    ascii: $6c6abc5e9e342e71$var$ascii,
    binary: $6c6abc5e9e342e71$var$ascii,
    ...$4tv9y.bases
};
$6c6abc5e9e342e71$exports = $6c6abc5e9e342e71$var$BASES;


function $269808579d792179$var$fromString(string, encoding = "utf8") {
    const base = $6c6abc5e9e342e71$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode(`${base.prefix}${string}`);
}
$269808579d792179$exports.fromString = $269808579d792179$var$fromString;


var $0afe45cc5959b50c$exports = {};
"use strict";
Object.defineProperty($0afe45cc5959b50c$exports, "__esModule", {
    value: true
});

function $0afe45cc5959b50c$var$toString(array, encoding = "utf8") {
    const base = $6c6abc5e9e342e71$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
$0afe45cc5959b50c$exports.toString = $0afe45cc5959b50c$var$toString;


var $294f5f2a6740f553$exports = {};
"use strict";
Object.defineProperty($294f5f2a6740f553$exports, "__esModule", {
    value: true
});

function $294f5f2a6740f553$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $80f8ab4b16225486$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}
$294f5f2a6740f553$exports.xor = $294f5f2a6740f553$var$xor;


$e077786f7a954859$exports.compare = $ea33ae26301e22f9$exports.compare;
$e077786f7a954859$exports.concat = $2bb5cbb6bb39daba$exports.concat;
$e077786f7a954859$exports.equals = $d9126094c9589f9f$exports.equals;
$e077786f7a954859$exports.fromString = $269808579d792179$exports.fromString;
$e077786f7a954859$exports.toString = $0afe45cc5959b50c$exports.toString;
$e077786f7a954859$exports.xor = $294f5f2a6740f553$exports.xor;



var $cZUWN = parcelRequire("cZUWN");

var $gbdt3 = parcelRequire("gbdt3");

var $7ts9d = parcelRequire("7ts9d");
var $17d123d3e821614f$require$Buffer = $7ts9d.Buffer;
const $17d123d3e821614f$var$Ir = ":";
function $17d123d3e821614f$export$4764229d78de4437(e) {
    const [t, r] = e.split($17d123d3e821614f$var$Ir);
    return {
        namespace: t,
        reference: r
    };
}
function $17d123d3e821614f$export$a5999672e4930644(e) {
    const { namespace: t, reference: r } = e;
    return [
        t,
        r
    ].join($17d123d3e821614f$var$Ir);
}
function $17d123d3e821614f$export$276ab0158c66e3d(e) {
    const [t, r, i] = e.split($17d123d3e821614f$var$Ir);
    return {
        namespace: t,
        reference: r,
        address: i
    };
}
function $17d123d3e821614f$export$566a25328fb93a18(e) {
    const { namespace: t, reference: r, address: i } = e;
    return [
        t,
        r,
        i
    ].join($17d123d3e821614f$var$Ir);
}
function $17d123d3e821614f$export$d579bc26e95946b5(e, t) {
    const r = [];
    return e.forEach((i)=>{
        const n = t(i);
        r.includes(n) || r.push(n);
    }), r;
}
function $17d123d3e821614f$export$2806d446053abd1d(e) {
    const { address: t } = $17d123d3e821614f$export$276ab0158c66e3d(e);
    return t;
}
function $17d123d3e821614f$export$93512919ec2ab555(e) {
    const { namespace: t, reference: r } = $17d123d3e821614f$export$276ab0158c66e3d(e);
    return $17d123d3e821614f$export$a5999672e4930644({
        namespace: t,
        reference: r
    });
}
function $17d123d3e821614f$export$40283ddc77f27f6e(e, t) {
    const { namespace: r, reference: i } = $17d123d3e821614f$export$4764229d78de4437(t);
    return $17d123d3e821614f$export$566a25328fb93a18({
        namespace: r,
        reference: i,
        address: e
    });
}
function $17d123d3e821614f$export$aa4a6b630dfcfa83(e) {
    return $17d123d3e821614f$export$d579bc26e95946b5(e, $17d123d3e821614f$export$2806d446053abd1d);
}
function $17d123d3e821614f$export$d5ee58c6b13696e9(e) {
    return $17d123d3e821614f$export$d579bc26e95946b5(e, $17d123d3e821614f$export$93512919ec2ab555);
}
function $17d123d3e821614f$export$23329703ad972840(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...n.accounts);
    }), r;
}
function $17d123d3e821614f$export$6281ff29da5f85fe(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$17d123d3e821614f$export$d5ee58c6b13696e9(n.accounts));
    }), r;
}
function $17d123d3e821614f$export$d1109eeb751412cf(e, t = []) {
    const r = [];
    return Object.keys(e).forEach((i)=>{
        if (t.length && !t.includes(i)) return;
        const n = e[i];
        r.push(...$17d123d3e821614f$export$376384387cd15b27(i, n));
    }), r;
}
function $17d123d3e821614f$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
var $17d123d3e821614f$var$Qo = Object.defineProperty, $17d123d3e821614f$var$bn = Object.getOwnPropertySymbols, $17d123d3e821614f$var$Jo = Object.prototype.hasOwnProperty, $17d123d3e821614f$var$Go = Object.prototype.propertyIsEnumerable, $17d123d3e821614f$var$yn = (e, t, r)=>t in e ? $17d123d3e821614f$var$Qo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $17d123d3e821614f$var$wn = (e, t)=>{
    for(var r in t || (t = {}))$17d123d3e821614f$var$Jo.call(t, r) && $17d123d3e821614f$var$yn(e, r, t[r]);
    if ($17d123d3e821614f$var$bn) for (var r of $17d123d3e821614f$var$bn(t))$17d123d3e821614f$var$Go.call(t, r) && $17d123d3e821614f$var$yn(e, r, t[r]);
    return e;
};
const $17d123d3e821614f$export$f12873d77424d47b = "ReactNative", $17d123d3e821614f$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $17d123d3e821614f$export$657dee6d5648750a = " ", $17d123d3e821614f$export$96c3628b3b9d2079 = ":", $17d123d3e821614f$export$98238152dfccf046 = "/", $17d123d3e821614f$export$7f882bb969de14a3 = 2, $17d123d3e821614f$export$77baccb4c6bd5852 = 1e3, $17d123d3e821614f$export$e08b61c98317d88c = "js";
function $17d123d3e821614f$export$8ee0fc9ee280b4ee() {
    return typeof $gbdt3 < "u" && typeof $gbdt3.versions < "u" && typeof $gbdt3.versions.node < "u";
}
function $17d123d3e821614f$export$f7a1e23e542d38e3() {
    return !(0, $28JPH.getDocument)() && !!(0, $28JPH.getNavigator)() && navigator.product === $17d123d3e821614f$export$f12873d77424d47b;
}
function $17d123d3e821614f$export$4e09c449d6c407f7() {
    return !$17d123d3e821614f$export$8ee0fc9ee280b4ee() && !!(0, $28JPH.getNavigator)() && !!(0, $28JPH.getDocument)();
}
function $17d123d3e821614f$export$57570b1603cf6adb() {
    return $17d123d3e821614f$export$f7a1e23e542d38e3() ? $17d123d3e821614f$export$86b1301a63b15dd9.reactNative : $17d123d3e821614f$export$8ee0fc9ee280b4ee() ? $17d123d3e821614f$export$86b1301a63b15dd9.node : $17d123d3e821614f$export$4e09c449d6c407f7() ? $17d123d3e821614f$export$86b1301a63b15dd9.browser : $17d123d3e821614f$export$86b1301a63b15dd9.unknown;
}
function $17d123d3e821614f$export$40a40f90174d197c() {
    var e;
    try {
        return $17d123d3e821614f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $17d123d3e821614f$export$c4147c69f6845da(e, t) {
    let r = $7GGtC.parse(e);
    return r = $17d123d3e821614f$var$wn($17d123d3e821614f$var$wn({}, r), t), e = $7GGtC.stringify(r), e;
}
function $17d123d3e821614f$export$ba31e015127122bb() {
    return (0, $81v59.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $17d123d3e821614f$export$6b05aa0115b6fc2d(e, t) {
    var r;
    const i = $17d123d3e821614f$export$57570b1603cf6adb(), n = {
        protocol: e,
        version: t,
        env: i
    };
    return i === "browser" && (n.host = ((r = (0, $28JPH.getLocation)()) == null ? void 0 : r.host) || "unknown"), n;
}
function $17d123d3e821614f$export$20d4a3cb5829b8b6() {
    if ($17d123d3e821614f$export$57570b1603cf6adb() === $17d123d3e821614f$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: r, Version: i } = $parcel$global.Platform;
        return [
            r,
            i
        ].join("-");
    }
    const e = (0, $lbkR2.detect)();
    if (e === null) return "unknown";
    const t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $17d123d3e821614f$export$4389b0987726d52d() {
    var e;
    const t = $17d123d3e821614f$export$57570b1603cf6adb();
    return t === $17d123d3e821614f$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $28JPH.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $17d123d3e821614f$export$b55a4c6e272b719f(e, t, r) {
    const i = $17d123d3e821614f$export$20d4a3cb5829b8b6(), n = $17d123d3e821614f$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $17d123d3e821614f$export$e08b61c98317d88c,
            r
        ].join("-"),
        i,
        n
    ].join("/");
}
function $17d123d3e821614f$export$d875b3963ef774f5({ protocol: e, version: t, relayUrl: r, sdkVersion: i, auth: n, projectId: o, useOnCloseEvent: h, bundleId: p }) {
    const b = r.split("?"), m = $17d123d3e821614f$export$b55a4c6e272b719f(e, t, i), w = {
        auth: n,
        ua: m,
        projectId: o,
        useOnCloseEvent: h || void 0,
        origin: p || void 0
    }, y = $17d123d3e821614f$export$c4147c69f6845da(b[1] || "", w);
    return b[0] + "?" + y;
}
function $17d123d3e821614f$export$ed08891a8a54eb(e) {
    let t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const r = typeof t < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        r
    ].join("://");
}
function $17d123d3e821614f$export$804de46662e4ac95(e, t, r) {
    if (!e[t] || typeof e[t] !== r) throw new Error(`Missing or invalid "${t}" param`);
}
function $17d123d3e821614f$export$1e21530e896c0b0b(e, t = $17d123d3e821614f$export$7f882bb969de14a3) {
    return $17d123d3e821614f$export$7f00885504704576(e.split($17d123d3e821614f$export$98238152dfccf046), t);
}
function $17d123d3e821614f$export$80bffd46c37a96f6(e) {
    return $17d123d3e821614f$export$1e21530e896c0b0b(e).join($17d123d3e821614f$export$657dee6d5648750a);
}
function $17d123d3e821614f$export$1468a49de573f7f9(e, t) {
    return e.filter((r)=>t.includes(r)).length === e.length;
}
function $17d123d3e821614f$export$7f00885504704576(e, t = $17d123d3e821614f$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - t, 0));
}
function $17d123d3e821614f$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $17d123d3e821614f$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $17d123d3e821614f$export$592ef47eabb05614(e, t) {
    const r = {};
    return Object.keys(e).forEach((i)=>{
        r[i] = t(e[i]);
    }), r;
}
const $17d123d3e821614f$export$85c927578394b28b = (e)=>e;
function $17d123d3e821614f$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (t)=>t.toUpperCase());
}
function $17d123d3e821614f$export$9a00dee1beb8f576(e) {
    return e.split($17d123d3e821614f$export$657dee6d5648750a).map((t)=>$17d123d3e821614f$export$e9f8fcacef3bca4b(t)).join($17d123d3e821614f$export$657dee6d5648750a);
}
function $17d123d3e821614f$export$cbf9e3cc9ffc85cb(e = (0, $8Yg5s.FIVE_MINUTES), t) {
    const r = (0, $8Yg5s.toMiliseconds)(e || (0, $8Yg5s.FIVE_MINUTES));
    let i, n, o;
    return {
        resolve: (h)=>{
            o && i && (clearTimeout(o), i(h));
        },
        reject: (h)=>{
            o && n && (clearTimeout(o), n(h));
        },
        done: ()=>new Promise((h, p)=>{
                o = setTimeout(()=>{
                    p(new Error(t));
                }, r), i = h, n = p;
            })
    };
}
function $17d123d3e821614f$export$3da2293b007ed708(e, t, r) {
    return new Promise(async (i, n)=>{
        const o = setTimeout(()=>n(new Error(r)), t);
        try {
            const h = await e;
            i(h);
        } catch (h) {
            n(h);
        }
        clearTimeout(o);
    });
}
function $17d123d3e821614f$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith(`${e}:`)) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${t}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${t}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $17d123d3e821614f$export$43ab92477f8713b9(e) {
    return $17d123d3e821614f$export$187ab6574b2ae23f("topic", e);
}
function $17d123d3e821614f$export$bd13103c2e5cc0c3(e) {
    return $17d123d3e821614f$export$187ab6574b2ae23f("id", e);
}
function $17d123d3e821614f$export$93adeb0f16e8e51d(e) {
    const [t, r] = e.split(":"), i = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof r == "string") i.topic = r;
    else if (t === "id" && Number.isInteger(Number(r))) i.id = Number(r);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${t}:${r}`);
    return i;
}
function $17d123d3e821614f$export$b136d03015bfc12(e, t) {
    return (0, $8Yg5s.fromMiliseconds)((t || Date.now()) + (0, $8Yg5s.toMiliseconds)(e));
}
function $17d123d3e821614f$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $8Yg5s.toMiliseconds)(e);
}
function $17d123d3e821614f$export$e3eb27ce66c0f6d9(e, t) {
    return `${e}${t ? `:${t}` : ""}`;
}
function $17d123d3e821614f$export$9826fe7ad3921016(e = [], t = []) {
    return [
        ...new Set([
            ...e,
            ...t
        ])
    ];
}
async function $17d123d3e821614f$export$694a208c8abca99a({ id: e, topic: t, wcDeepLink: r }) {
    try {
        if (!r) return;
        const i = typeof r == "string" ? JSON.parse(r) : r;
        let n = i?.href;
        if (typeof n != "string") return;
        n.endsWith("/") && (n = n.slice(0, -1));
        const o = `${n}/wc?requestId=${e}&sessionTopic=${t}`, h = $17d123d3e821614f$export$57570b1603cf6adb();
        h === $17d123d3e821614f$export$86b1301a63b15dd9.browser ? o.startsWith("https://") || o.startsWith("http://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener") : h === $17d123d3e821614f$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(o);
    } catch (i) {
        console.error(i);
    }
}
async function $17d123d3e821614f$export$e55bfdac47149a32(e, t) {
    try {
        return await e.getItem(t) || ($17d123d3e821614f$export$4e09c449d6c407f7() ? localStorage.getItem(t) : void 0);
    } catch (r) {
        console.error(r);
    }
}
function $17d123d3e821614f$export$f8aaf09178dd8b96(e, t) {
    return e.filter((r)=>t.includes(r));
}
var $17d123d3e821614f$var$On = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $17d123d3e821614f$var$A0(e) {
    var t = e.default;
    if (typeof t == "function") {
        var r = function() {
            return t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function() {
                return e[i];
            }
        });
    }), r;
}
var $17d123d3e821614f$var$Pn = {
    exports: {}
}; /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ 
(function(e) {
    (function() {
        var t = "input is invalid type", r = "finalize already called", i = typeof window == "object", n = i ? window : {};
        n.JS_SHA3_NO_WINDOW && (i = !1);
        var o = !i && typeof self == "object", h = !n.JS_SHA3_NO_NODE_JS && typeof $gbdt3 == "object" && $gbdt3.versions && $gbdt3.versions.node;
        h ? n = $17d123d3e821614f$var$On : o && (n = self);
        var p = !n.JS_SHA3_NO_COMMON_JS && !0 && e.exports, b = !n.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", m = "0123456789abcdef".split(""), w = [
            31,
            7936,
            2031616,
            520093696
        ], y = [
            4,
            1024,
            262144,
            67108864
        ], S = [
            1,
            256,
            65536,
            16777216
        ], I = [
            6,
            1536,
            393216,
            100663296
        ], N = [
            0,
            8,
            16,
            24
        ], C = [
            1,
            0,
            32898,
            0,
            32906,
            2147483648,
            2147516416,
            2147483648,
            32907,
            0,
            2147483649,
            0,
            2147516545,
            2147483648,
            32777,
            2147483648,
            138,
            0,
            136,
            0,
            2147516425,
            0,
            2147483658,
            0,
            2147516555,
            0,
            139,
            2147483648,
            32905,
            2147483648,
            32771,
            2147483648,
            32770,
            2147483648,
            128,
            2147483648,
            32778,
            0,
            2147483658,
            2147483648,
            2147516545,
            2147483648,
            32896,
            2147483648,
            2147483649,
            0,
            2147516424,
            2147483648
        ], F = [
            224,
            256,
            384,
            512
        ], U = [
            128,
            256
        ], J = [
            "hex",
            "buffer",
            "arrayBuffer",
            "array",
            "digest"
        ], Bt = {
            128: 168,
            256: 136
        };
        (n.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(u) {
            return Object.prototype.toString.call(u) === "[object Array]";
        }), b && (n.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(u) {
            return typeof u == "object" && u.buffer && u.buffer.constructor === ArrayBuffer;
        });
        for(var G = function(u, E, _) {
            return function(B) {
                return new s(u, E, u).update(B)[_]();
            };
        }, H = function(u, E, _) {
            return function(B, R) {
                return new s(u, E, R).update(B)[_]();
            };
        }, z = function(u, E, _) {
            return function(B, R, T, P) {
                return f["cshake" + u].update(B, R, T, P)[_]();
            };
        }, Pt = function(u, E, _) {
            return function(B, R, T, P) {
                return f["kmac" + u].update(B, R, T, P)[_]();
            };
        }, W = function(u, E, _, B) {
            for(var R = 0; R < J.length; ++R){
                var T = J[R];
                u[T] = E(_, B, T);
            }
            return u;
        }, Rt = function(u, E) {
            var _ = G(u, E, "hex");
            return _.create = function() {
                return new s(u, E, u);
            }, _.update = function(B) {
                return _.create().update(B);
            }, W(_, G, u, E);
        }, Yt = function(u, E) {
            var _ = H(u, E, "hex");
            return _.create = function(B) {
                return new s(u, E, B);
            }, _.update = function(B, R) {
                return _.create(R).update(B);
            }, W(_, H, u, E);
        }, Y = function(u, E) {
            var _ = Bt[u], B = z(u, E, "hex");
            return B.create = function(R, T, P) {
                return !T && !P ? f["shake" + u].create(R) : new s(u, E, R).bytepad([
                    T,
                    P
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(T, P, O).update(R);
            }, W(B, z, u, E);
        }, Vt = function(u, E) {
            var _ = Bt[u], B = Pt(u, E, "hex");
            return B.create = function(R, T, P) {
                return new v(u, E, T).bytepad([
                    "KMAC",
                    P
                ], _).bytepad([
                    R
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(R, P, O).update(T);
            }, W(B, Pt, u, E);
        }, A = [
            {
                name: "keccak",
                padding: S,
                bits: F,
                createMethod: Rt
            },
            {
                name: "sha3",
                padding: I,
                bits: F,
                createMethod: Rt
            },
            {
                name: "shake",
                padding: w,
                bits: U,
                createMethod: Yt
            },
            {
                name: "cshake",
                padding: y,
                bits: U,
                createMethod: Y
            },
            {
                name: "kmac",
                padding: y,
                bits: U,
                createMethod: Vt
            }
        ], f = {}, a = [], c = 0; c < A.length; ++c)for(var d = A[c], g = d.bits, x = 0; x < g.length; ++x){
            var M = d.name + "_" + g[x];
            if (a.push(M), f[M] = d.createMethod(g[x], d.padding), d.name !== "sha3") {
                var l = d.name + g[x];
                a.push(l), f[l] = f[M];
            }
        }
        function s(u, E, _) {
            this.blocks = [], this.s = [], this.padding = E, this.outputBits = _, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (u << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = _ >> 5, this.extraBytes = (_ & 31) >> 3;
            for(var B = 0; B < 50; ++B)this.s[B] = 0;
        }
        s.prototype.update = function(u) {
            if (this.finalized) throw new Error(r);
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            for(var B = this.blocks, R = this.byteCount, T = u.length, P = this.blockCount, O = 0, Ct = this.s, D, q; O < T;){
                if (this.reset) for(this.reset = !1, B[0] = this.block, D = 1; D < P + 1; ++D)B[D] = 0;
                if (E) for(D = this.start; O < T && D < R; ++O)B[D >> 2] |= u[O] << N[D++ & 3];
                else for(D = this.start; O < T && D < R; ++O)q = u.charCodeAt(O), q < 128 ? B[D >> 2] |= q << N[D++ & 3] : q < 2048 ? (B[D >> 2] |= (192 | q >> 6) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : q < 55296 || q >= 57344 ? (B[D >> 2] |= (224 | q >> 12) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : (q = 65536 + ((q & 1023) << 10 | u.charCodeAt(++O) & 1023), B[D >> 2] |= (240 | q >> 18) << N[D++ & 3], B[D >> 2] |= (128 | q >> 12 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]);
                if (this.lastByteIndex = D, D >= R) {
                    for(this.start = D - R, this.block = B[P], D = 0; D < P; ++D)Ct[D] ^= B[D];
                    k(Ct), this.reset = !0;
                } else this.start = D;
            }
            return this;
        }, s.prototype.encode = function(u, E) {
            var _ = u & 255, B = 1, R = [
                _
            ];
            for(u = u >> 8, _ = u & 255; _ > 0;)R.unshift(_), u = u >> 8, _ = u & 255, ++B;
            return E ? R.push(B) : R.unshift(B), this.update(R), R.length;
        }, s.prototype.encodeString = function(u) {
            var E, _ = typeof u;
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            var B = 0, R = u.length;
            if (E) B = R;
            else for(var T = 0; T < u.length; ++T){
                var P = u.charCodeAt(T);
                P < 128 ? B += 1 : P < 2048 ? B += 2 : P < 55296 || P >= 57344 ? B += 3 : (P = 65536 + ((P & 1023) << 10 | u.charCodeAt(++T) & 1023), B += 4);
            }
            return B += this.encode(B * 8), this.update(u), B;
        }, s.prototype.bytepad = function(u, E) {
            for(var _ = this.encode(E), B = 0; B < u.length; ++B)_ += this.encodeString(u[B]);
            var R = E - _ % E, T = [];
            return T.length = R, this.update(T), this;
        }, s.prototype.finalize = function() {
            if (!this.finalized) {
                this.finalized = !0;
                var u = this.blocks, E = this.lastByteIndex, _ = this.blockCount, B = this.s;
                if (u[E >> 2] |= this.padding[E & 3], this.lastByteIndex === this.byteCount) for(u[0] = u[_], E = 1; E < _ + 1; ++E)u[E] = 0;
                for(u[_ - 1] |= 2147483648, E = 0; E < _; ++E)B[E] ^= u[E];
                k(B);
            }
        }, s.prototype.toString = s.prototype.hex = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = "", O; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = E[R], P += m[O >> 4 & 15] + m[O & 15] + m[O >> 12 & 15] + m[O >> 8 & 15] + m[O >> 20 & 15] + m[O >> 16 & 15] + m[O >> 28 & 15] + m[O >> 24 & 15];
                T % u === 0 && (k(E), R = 0);
            }
            return B && (O = E[R], P += m[O >> 4 & 15] + m[O & 15], B > 1 && (P += m[O >> 12 & 15] + m[O >> 8 & 15]), B > 2 && (P += m[O >> 20 & 15] + m[O >> 16 & 15])), P;
        }, s.prototype.arrayBuffer = function() {
            this.finalize();
            var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = this.outputBits >> 3, O;
            B ? O = new ArrayBuffer(_ + 1 << 2) : O = new ArrayBuffer(P);
            for(var Ct = new Uint32Array(O); T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)Ct[T] = E[R];
                T % u === 0 && k(E);
            }
            return B && (Ct[R] = E[R], O = O.slice(0, P)), O;
        }, s.prototype.buffer = s.prototype.arrayBuffer, s.prototype.digest = s.prototype.array = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = [], O, Ct; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = T << 2, Ct = E[R], P[O] = Ct & 255, P[O + 1] = Ct >> 8 & 255, P[O + 2] = Ct >> 16 & 255, P[O + 3] = Ct >> 24 & 255;
                T % u === 0 && k(E);
            }
            return B && (O = T << 2, Ct = E[R], P[O] = Ct & 255, B > 1 && (P[O + 1] = Ct >> 8 & 255), B > 2 && (P[O + 2] = Ct >> 16 & 255)), P;
        };
        function v(u, E, _) {
            s.call(this, u, E, _);
        }
        v.prototype = new s, v.prototype.finalize = function() {
            return this.encode(this.outputBits, !0), s.prototype.finalize.call(this);
        };
        var k = function(u) {
            var E, _, B, R, T, P, O, Ct, D, q, De, X, Z, Fe, $, tt, Te, et, rt, Ue, it, nt, ke, ft, ot, qe, st, at, Ke, ut, ht, He, ct, lt, ze, dt, pt, Le, vt, mt, je, gt, At, Qe, bt, yt, Je, wt, xt, Ge, Mt, Et, Ye, St, Nt, Ve, It, _t, Me, Ee, Se, Ne, Ie;
            for(B = 0; B < 48; B += 2)R = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], T = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], P = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], O = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], Ct = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], D = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], q = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], De = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], X = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], Z = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], E = X ^ (P << 1 | O >>> 31), _ = Z ^ (O << 1 | P >>> 31), u[0] ^= E, u[1] ^= _, u[10] ^= E, u[11] ^= _, u[20] ^= E, u[21] ^= _, u[30] ^= E, u[31] ^= _, u[40] ^= E, u[41] ^= _, E = R ^ (Ct << 1 | D >>> 31), _ = T ^ (D << 1 | Ct >>> 31), u[2] ^= E, u[3] ^= _, u[12] ^= E, u[13] ^= _, u[22] ^= E, u[23] ^= _, u[32] ^= E, u[33] ^= _, u[42] ^= E, u[43] ^= _, E = P ^ (q << 1 | De >>> 31), _ = O ^ (De << 1 | q >>> 31), u[4] ^= E, u[5] ^= _, u[14] ^= E, u[15] ^= _, u[24] ^= E, u[25] ^= _, u[34] ^= E, u[35] ^= _, u[44] ^= E, u[45] ^= _, E = Ct ^ (X << 1 | Z >>> 31), _ = D ^ (Z << 1 | X >>> 31), u[6] ^= E, u[7] ^= _, u[16] ^= E, u[17] ^= _, u[26] ^= E, u[27] ^= _, u[36] ^= E, u[37] ^= _, u[46] ^= E, u[47] ^= _, E = q ^ (R << 1 | T >>> 31), _ = De ^ (T << 1 | R >>> 31), u[8] ^= E, u[9] ^= _, u[18] ^= E, u[19] ^= _, u[28] ^= E, u[29] ^= _, u[38] ^= E, u[39] ^= _, u[48] ^= E, u[49] ^= _, Fe = u[0], $ = u[1], yt = u[11] << 4 | u[10] >>> 28, Je = u[10] << 4 | u[11] >>> 28, at = u[20] << 3 | u[21] >>> 29, Ke = u[21] << 3 | u[20] >>> 29, Ee = u[31] << 9 | u[30] >>> 23, Se = u[30] << 9 | u[31] >>> 23, gt = u[40] << 18 | u[41] >>> 14, At = u[41] << 18 | u[40] >>> 14, lt = u[2] << 1 | u[3] >>> 31, ze = u[3] << 1 | u[2] >>> 31, tt = u[13] << 12 | u[12] >>> 20, Te = u[12] << 12 | u[13] >>> 20, wt = u[22] << 10 | u[23] >>> 22, xt = u[23] << 10 | u[22] >>> 22, ut = u[33] << 13 | u[32] >>> 19, ht = u[32] << 13 | u[33] >>> 19, Ne = u[42] << 2 | u[43] >>> 30, Ie = u[43] << 2 | u[42] >>> 30, St = u[5] << 30 | u[4] >>> 2, Nt = u[4] << 30 | u[5] >>> 2, dt = u[14] << 6 | u[15] >>> 26, pt = u[15] << 6 | u[14] >>> 26, et = u[25] << 11 | u[24] >>> 21, rt = u[24] << 11 | u[25] >>> 21, Ge = u[34] << 15 | u[35] >>> 17, Mt = u[35] << 15 | u[34] >>> 17, He = u[45] << 29 | u[44] >>> 3, ct = u[44] << 29 | u[45] >>> 3, ft = u[6] << 28 | u[7] >>> 4, ot = u[7] << 28 | u[6] >>> 4, Ve = u[17] << 23 | u[16] >>> 9, It = u[16] << 23 | u[17] >>> 9, Le = u[26] << 25 | u[27] >>> 7, vt = u[27] << 25 | u[26] >>> 7, Ue = u[36] << 21 | u[37] >>> 11, it = u[37] << 21 | u[36] >>> 11, Et = u[47] << 24 | u[46] >>> 8, Ye = u[46] << 24 | u[47] >>> 8, Qe = u[8] << 27 | u[9] >>> 5, bt = u[9] << 27 | u[8] >>> 5, qe = u[18] << 20 | u[19] >>> 12, st = u[19] << 20 | u[18] >>> 12, _t = u[29] << 7 | u[28] >>> 25, Me = u[28] << 7 | u[29] >>> 25, mt = u[38] << 8 | u[39] >>> 24, je = u[39] << 8 | u[38] >>> 24, nt = u[48] << 14 | u[49] >>> 18, ke = u[49] << 14 | u[48] >>> 18, u[0] = Fe ^ ~tt & et, u[1] = $ ^ ~Te & rt, u[10] = ft ^ ~qe & at, u[11] = ot ^ ~st & Ke, u[20] = lt ^ ~dt & Le, u[21] = ze ^ ~pt & vt, u[30] = Qe ^ ~yt & wt, u[31] = bt ^ ~Je & xt, u[40] = St ^ ~Ve & _t, u[41] = Nt ^ ~It & Me, u[2] = tt ^ ~et & Ue, u[3] = Te ^ ~rt & it, u[12] = qe ^ ~at & ut, u[13] = st ^ ~Ke & ht, u[22] = dt ^ ~Le & mt, u[23] = pt ^ ~vt & je, u[32] = yt ^ ~wt & Ge, u[33] = Je ^ ~xt & Mt, u[42] = Ve ^ ~_t & Ee, u[43] = It ^ ~Me & Se, u[4] = et ^ ~Ue & nt, u[5] = rt ^ ~it & ke, u[14] = at ^ ~ut & He, u[15] = Ke ^ ~ht & ct, u[24] = Le ^ ~mt & gt, u[25] = vt ^ ~je & At, u[34] = wt ^ ~Ge & Et, u[35] = xt ^ ~Mt & Ye, u[44] = _t ^ ~Ee & Ne, u[45] = Me ^ ~Se & Ie, u[6] = Ue ^ ~nt & Fe, u[7] = it ^ ~ke & $, u[16] = ut ^ ~He & ft, u[17] = ht ^ ~ct & ot, u[26] = mt ^ ~gt & lt, u[27] = je ^ ~At & ze, u[36] = Ge ^ ~Et & Qe, u[37] = Mt ^ ~Ye & bt, u[46] = Ee ^ ~Ne & St, u[47] = Se ^ ~Ie & Nt, u[8] = nt ^ ~Fe & tt, u[9] = ke ^ ~$ & Te, u[18] = He ^ ~ft & qe, u[19] = ct ^ ~ot & st, u[28] = gt ^ ~lt & dt, u[29] = At ^ ~ze & pt, u[38] = Et ^ ~Qe & yt, u[39] = Ye ^ ~bt & Je, u[48] = Ne ^ ~St & Ve, u[49] = Ie ^ ~Nt & It, u[0] ^= C[B], u[1] ^= C[B + 1];
        };
        if (p) e.exports = f;
        else for(c = 0; c < a.length; ++c)n[a[c]] = f[a[c]];
    })();
})($17d123d3e821614f$var$Pn);
var $17d123d3e821614f$var$b0 = $17d123d3e821614f$var$Pn.exports;
const $17d123d3e821614f$var$y0 = "logger/5.7.0";
let $17d123d3e821614f$var$Dn = !1, $17d123d3e821614f$var$Fn = !1;
const $17d123d3e821614f$var$Cr = {
    debug: 1,
    default: 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $17d123d3e821614f$var$Tn = $17d123d3e821614f$var$Cr.default, $17d123d3e821614f$var$gi = null;
function $17d123d3e821614f$var$w0() {
    try {
        const e = [];
        if ([
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((t)=>{
            try {
                if ("test".normalize(t) !== "test") throw new Error("bad normalize");
            } catch  {
                e.push(t);
            }
        }), e.length) throw new Error("missing " + e.join(", "));
        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
    } catch (e) {
        return e.message;
    }
    return null;
}
const $17d123d3e821614f$var$Un = $17d123d3e821614f$var$w0();
var $17d123d3e821614f$var$Ai;
(function(e) {
    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})($17d123d3e821614f$var$Ai || ($17d123d3e821614f$var$Ai = {}));
var $17d123d3e821614f$var$re;
(function(e) {
    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})($17d123d3e821614f$var$re || ($17d123d3e821614f$var$re = {}));
const $17d123d3e821614f$var$kn = "0123456789abcdef";
class $17d123d3e821614f$var$L {
    constructor(t){
        Object.defineProperty(this, "version", {
            enumerable: !0,
            value: t,
            writable: !1
        });
    }
    _log(t, r) {
        const i = t.toLowerCase();
        $17d123d3e821614f$var$Cr[i] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !($17d123d3e821614f$var$Tn > $17d123d3e821614f$var$Cr[i]) && console.log.apply(console, r);
    }
    debug(...t) {
        this._log($17d123d3e821614f$var$L.levels.DEBUG, t);
    }
    info(...t) {
        this._log($17d123d3e821614f$var$L.levels.INFO, t);
    }
    warn(...t) {
        this._log($17d123d3e821614f$var$L.levels.WARNING, t);
    }
    makeError(t, r, i) {
        if ($17d123d3e821614f$var$Fn) return this.makeError("censored error", r, {});
        r || (r = $17d123d3e821614f$var$L.errors.UNKNOWN_ERROR), i || (i = {});
        const n = [];
        Object.keys(i).forEach((b)=>{
            const m = i[b];
            try {
                if (m instanceof Uint8Array) {
                    let w = "";
                    for(let y = 0; y < m.length; y++)w += $17d123d3e821614f$var$kn[m[y] >> 4], w += $17d123d3e821614f$var$kn[m[y] & 15];
                    n.push(b + "=Uint8Array(0x" + w + ")");
                } else n.push(b + "=" + JSON.stringify(m));
            } catch  {
                n.push(b + "=" + JSON.stringify(i[b].toString()));
            }
        }), n.push(`code=${r}`), n.push(`version=${this.version}`);
        const o = t;
        let h = "";
        switch(r){
            case $17d123d3e821614f$var$re.NUMERIC_FAULT:
                {
                    h = "NUMERIC_FAULT";
                    const b = t;
                    switch(b){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            h += "-" + b;
                            break;
                        case "negative-power":
                        case "negative-width":
                            h += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            h += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $17d123d3e821614f$var$re.CALL_EXCEPTION:
            case $17d123d3e821614f$var$re.INSUFFICIENT_FUNDS:
            case $17d123d3e821614f$var$re.MISSING_NEW:
            case $17d123d3e821614f$var$re.NONCE_EXPIRED:
            case $17d123d3e821614f$var$re.REPLACEMENT_UNDERPRICED:
            case $17d123d3e821614f$var$re.TRANSACTION_REPLACED:
            case $17d123d3e821614f$var$re.UNPREDICTABLE_GAS_LIMIT:
                h = r;
                break;
        }
        h && (t += " [ See: https://links.ethers.org/v5-errors-" + h + " ]"), n.length && (t += " (" + n.join(", ") + ")");
        const p = new Error(t);
        return p.reason = o, p.code = r, Object.keys(i).forEach(function(b) {
            p[b] = i[b];
        }), p;
    }
    throwError(t, r, i) {
        throw this.makeError(t, r, i);
    }
    throwArgumentError(t, r, i) {
        return this.throwError(t, $17d123d3e821614f$var$L.errors.INVALID_ARGUMENT, {
            argument: r,
            value: i
        });
    }
    assert(t, r, i, n) {
        t || this.throwError(r, i, n);
    }
    assertArgument(t, r, i, n) {
        t || this.throwArgumentError(r, i, n);
    }
    checkNormalize(t) {
        $17d123d3e821614f$var$Un && this.throwError("platform missing String.prototype.normalize", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $17d123d3e821614f$var$Un
        });
    }
    checkSafeUint53(t, r) {
        typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, $17d123d3e821614f$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: t
        }), t % 1 && this.throwError(r, $17d123d3e821614f$var$L.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: t
        }));
    }
    checkArgumentCount(t, r, i) {
        i ? i = ": " + i : i = "", t < r && this.throwError("missing argument" + i, $17d123d3e821614f$var$L.errors.MISSING_ARGUMENT, {
            count: t,
            expectedCount: r
        }), t > r && this.throwError("too many arguments" + i, $17d123d3e821614f$var$L.errors.UNEXPECTED_ARGUMENT, {
            count: t,
            expectedCount: r
        });
    }
    checkNew(t, r) {
        (t === Object || t == null) && this.throwError("missing new", $17d123d3e821614f$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    checkAbstract(t, r) {
        t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            name: t.name,
            operation: "new"
        }) : (t === Object || t == null) && this.throwError("missing new", $17d123d3e821614f$var$L.errors.MISSING_NEW, {
            name: r.name
        });
    }
    static globalLogger() {
        return $17d123d3e821614f$var$gi || ($17d123d3e821614f$var$gi = new $17d123d3e821614f$var$L($17d123d3e821614f$var$y0)), $17d123d3e821614f$var$gi;
    }
    static setCensorship(t, r) {
        if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        }), $17d123d3e821614f$var$Dn) {
            if (!t) return;
            this.globalLogger().throwError("error censorship permanent", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $17d123d3e821614f$var$Fn = !!t, $17d123d3e821614f$var$Dn = !!r;
    }
    static setLogLevel(t) {
        const r = $17d123d3e821614f$var$Cr[t.toLowerCase()];
        if (r == null) {
            $17d123d3e821614f$var$L.globalLogger().warn("invalid log level - " + t);
            return;
        }
        $17d123d3e821614f$var$Tn = r;
    }
    static from(t) {
        return new $17d123d3e821614f$var$L(t);
    }
}
$17d123d3e821614f$var$L.errors = $17d123d3e821614f$var$re, $17d123d3e821614f$var$L.levels = $17d123d3e821614f$var$Ai;
const $17d123d3e821614f$var$x0 = "bytes/5.7.0", $17d123d3e821614f$var$Dt = new $17d123d3e821614f$var$L($17d123d3e821614f$var$x0);
function $17d123d3e821614f$var$qn(e) {
    return !!e.toHexString;
}
function $17d123d3e821614f$var$rr(e) {
    return e.slice || (e.slice = function() {
        const t = Array.prototype.slice.call(arguments);
        return $17d123d3e821614f$var$rr(new Uint8Array(Array.prototype.slice.apply(e, t)));
    }), e;
}
function $17d123d3e821614f$var$M0(e) {
    return $17d123d3e821614f$var$Qt(e) && !(e.length % 2) || $17d123d3e821614f$var$ir(e);
}
function $17d123d3e821614f$var$Kn(e) {
    return typeof e == "number" && e == e && e % 1 === 0;
}
function $17d123d3e821614f$var$ir(e) {
    if (e == null) return !1;
    if (e.constructor === Uint8Array) return !0;
    if (typeof e == "string" || !$17d123d3e821614f$var$Kn(e.length) || e.length < 0) return !1;
    for(let t = 0; t < e.length; t++){
        const r = e[t];
        if (!$17d123d3e821614f$var$Kn(r) || r < 0 || r >= 256) return !1;
    }
    return !0;
}
function $17d123d3e821614f$var$Ot(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $17d123d3e821614f$var$Dt.checkSafeUint53(e, "invalid arrayify value");
        const r = [];
        for(; e;)r.unshift(e & 255), e = parseInt(String(e / 256));
        return r.length === 0 && r.push(0), $17d123d3e821614f$var$rr(new Uint8Array(r));
    }
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $17d123d3e821614f$var$qn(e) && (e = e.toHexString()), $17d123d3e821614f$var$Qt(e)) {
        let r = e.substring(2);
        r.length % 2 && (t.hexPad === "left" ? r = "0" + r : t.hexPad === "right" ? r += "0" : $17d123d3e821614f$var$Dt.throwArgumentError("hex data is odd-length", "value", e));
        const i = [];
        for(let n = 0; n < r.length; n += 2)i.push(parseInt(r.substring(n, n + 2), 16));
        return $17d123d3e821614f$var$rr(new Uint8Array(i));
    }
    return $17d123d3e821614f$var$ir(e) ? $17d123d3e821614f$var$rr(new Uint8Array(e)) : $17d123d3e821614f$var$Dt.throwArgumentError("invalid arrayify value", "value", e);
}
function $17d123d3e821614f$var$E0(e) {
    const t = e.map((n)=>$17d123d3e821614f$var$Ot(n)), r = t.reduce((n, o)=>n + o.length, 0), i = new Uint8Array(r);
    return t.reduce((n, o)=>(i.set(o, n), n + o.length), 0), $17d123d3e821614f$var$rr(i);
}
function $17d123d3e821614f$var$S0(e, t) {
    e = $17d123d3e821614f$var$Ot(e), e.length > t && $17d123d3e821614f$var$Dt.throwArgumentError("value out of range", "value", arguments[0]);
    const r = new Uint8Array(t);
    return r.set(e, t - e.length), $17d123d3e821614f$var$rr(r);
}
function $17d123d3e821614f$var$Qt(e, t) {
    return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
const $17d123d3e821614f$var$bi = "0123456789abcdef";
function $17d123d3e821614f$var$Kt(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $17d123d3e821614f$var$Dt.checkSafeUint53(e, "invalid hexlify value");
        let r = "";
        for(; e;)r = $17d123d3e821614f$var$bi[e & 15] + r, e = Math.floor(e / 16);
        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
    }
    if (typeof e == "bigint") return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $17d123d3e821614f$var$qn(e)) return e.toHexString();
    if ($17d123d3e821614f$var$Qt(e)) return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : $17d123d3e821614f$var$Dt.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
    if ($17d123d3e821614f$var$ir(e)) {
        let r = "0x";
        for(let i = 0; i < e.length; i++){
            let n = e[i];
            r += $17d123d3e821614f$var$bi[(n & 240) >> 4] + $17d123d3e821614f$var$bi[n & 15];
        }
        return r;
    }
    return $17d123d3e821614f$var$Dt.throwArgumentError("invalid hexlify value", "value", e);
}
function $17d123d3e821614f$var$N0(e) {
    if (typeof e != "string") e = $17d123d3e821614f$var$Kt(e);
    else if (!$17d123d3e821614f$var$Qt(e) || e.length % 2) return null;
    return (e.length - 2) / 2;
}
function $17d123d3e821614f$var$Hn(e, t, r) {
    return typeof e != "string" ? e = $17d123d3e821614f$var$Kt(e) : (!$17d123d3e821614f$var$Qt(e) || e.length % 2) && $17d123d3e821614f$var$Dt.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, r != null ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
}
function $17d123d3e821614f$var$oe(e, t) {
    for(typeof e != "string" ? e = $17d123d3e821614f$var$Kt(e) : $17d123d3e821614f$var$Qt(e) || $17d123d3e821614f$var$Dt.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && $17d123d3e821614f$var$Dt.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
    return e;
}
function $17d123d3e821614f$var$zn(e) {
    const t = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($17d123d3e821614f$var$M0(e)) {
        let r = $17d123d3e821614f$var$Ot(e);
        r.length === 64 ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = $17d123d3e821614f$var$Kt(r.slice(0, 32)), t.s = $17d123d3e821614f$var$Kt(r.slice(32, 64))) : r.length === 65 ? (t.r = $17d123d3e821614f$var$Kt(r.slice(0, 32)), t.s = $17d123d3e821614f$var$Kt(r.slice(32, 64)), t.v = r[64]) : $17d123d3e821614f$var$Dt.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : $17d123d3e821614f$var$Dt.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = $17d123d3e821614f$var$Kt(r.slice(32, 64));
    } else {
        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, t._vs != null) {
            const n = $17d123d3e821614f$var$S0($17d123d3e821614f$var$Ot(t._vs), 32);
            t._vs = $17d123d3e821614f$var$Kt(n);
            const o = n[0] >= 128 ? 1 : 0;
            t.recoveryParam == null ? t.recoveryParam = o : t.recoveryParam !== o && $17d123d3e821614f$var$Dt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
            const h = $17d123d3e821614f$var$Kt(n);
            t.s == null ? t.s = h : t.s !== h && $17d123d3e821614f$var$Dt.throwArgumentError("signature v mismatch _vs", "signature", e);
        }
        if (t.recoveryParam == null) t.v == null ? $17d123d3e821614f$var$Dt.throwArgumentError("signature missing v and recoveryParam", "signature", e) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
        else if (t.v == null) t.v = 27 + t.recoveryParam;
        else {
            const n = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
            t.recoveryParam !== n && $17d123d3e821614f$var$Dt.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
        }
        t.r == null || !$17d123d3e821614f$var$Qt(t.r) ? $17d123d3e821614f$var$Dt.throwArgumentError("signature missing or invalid r", "signature", e) : t.r = $17d123d3e821614f$var$oe(t.r, 32), t.s == null || !$17d123d3e821614f$var$Qt(t.s) ? $17d123d3e821614f$var$Dt.throwArgumentError("signature missing or invalid s", "signature", e) : t.s = $17d123d3e821614f$var$oe(t.s, 32);
        const r = $17d123d3e821614f$var$Ot(t.s);
        r[0] >= 128 && $17d123d3e821614f$var$Dt.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (r[0] |= 128);
        const i = $17d123d3e821614f$var$Kt(r);
        t._vs && ($17d123d3e821614f$var$Qt(t._vs) || $17d123d3e821614f$var$Dt.throwArgumentError("signature invalid _vs", "signature", e), t._vs = $17d123d3e821614f$var$oe(t._vs, 32)), t._vs == null ? t._vs = i : t._vs !== i && $17d123d3e821614f$var$Dt.throwArgumentError("signature _vs mismatch v and s", "signature", e);
    }
    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function $17d123d3e821614f$var$yi(e) {
    return "0x" + $17d123d3e821614f$var$b0.keccak_256($17d123d3e821614f$var$Ot(e));
}
var $17d123d3e821614f$var$Ln = {
    exports: {}
}, $17d123d3e821614f$var$I0 = {}, $17d123d3e821614f$var$_0 = Object.freeze({
    __proto__: null,
    default: $17d123d3e821614f$var$I0
}), $17d123d3e821614f$var$B0 = $17d123d3e821614f$var$A0($17d123d3e821614f$var$_0);
(function(e) {
    (function(t, r) {
        function i(A, f) {
            if (!A) throw new Error(f || "Assertion failed");
        }
        function n(A, f) {
            A.super_ = f;
            var a = function() {};
            a.prototype = f.prototype, A.prototype = new a, A.prototype.constructor = A;
        }
        function o(A, f, a) {
            if (o.isBN(A)) return A;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, A !== null && ((f === "le" || f === "be") && (a = f, f = 10), this._init(A || 0, f || 10, a || "be"));
        }
        typeof t == "object" ? t.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
        var h;
        try {
            typeof window < "u" && typeof window.Buffer < "u" ? h = window.Buffer : h = $17d123d3e821614f$var$B0.Buffer;
        } catch  {}
        o.isBN = function(f) {
            return f instanceof o ? !0 : f !== null && typeof f == "object" && f.constructor.wordSize === o.wordSize && Array.isArray(f.words);
        }, o.max = function(f, a) {
            return f.cmp(a) > 0 ? f : a;
        }, o.min = function(f, a) {
            return f.cmp(a) < 0 ? f : a;
        }, o.prototype._init = function(f, a, c) {
            if (typeof f == "number") return this._initNumber(f, a, c);
            if (typeof f == "object") return this._initArray(f, a, c);
            a === "hex" && (a = 16), i(a === (a | 0) && a >= 2 && a <= 36), f = f.toString().replace(/\s+/g, "");
            var d = 0;
            f[0] === "-" && (d++, this.negative = 1), d < f.length && (a === 16 ? this._parseHex(f, d, c) : (this._parseBase(f, a, d), c === "le" && this._initArray(this.toArray(), a, c)));
        }, o.prototype._initNumber = function(f, a, c) {
            f < 0 && (this.negative = 1, f = -f), f < 67108864 ? (this.words = [
                f & 67108863
            ], this.length = 1) : f < 4503599627370496 ? (this.words = [
                f & 67108863,
                f / 67108864 & 67108863
            ], this.length = 2) : (i(f < 9007199254740992), this.words = [
                f & 67108863,
                f / 67108864 & 67108863,
                1
            ], this.length = 3), c === "le" && this._initArray(this.toArray(), a, c);
        }, o.prototype._initArray = function(f, a, c) {
            if (i(typeof f.length == "number"), f.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(f.length / 3), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g, x, M = 0;
            if (c === "be") for(d = f.length - 1, g = 0; d >= 0; d -= 3)x = f[d] | f[d - 1] << 8 | f[d - 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            else if (c === "le") for(d = 0, g = 0; d < f.length; d += 3)x = f[d] | f[d + 1] << 8 | f[d + 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            return this._strip();
        };
        function p(A, f) {
            var a = A.charCodeAt(f);
            if (a >= 48 && a <= 57) return a - 48;
            if (a >= 65 && a <= 70) return a - 55;
            if (a >= 97 && a <= 102) return a - 87;
            i(!1, "Invalid character in " + A);
        }
        function b(A, f, a) {
            var c = p(A, a);
            return a - 1 >= f && (c |= p(A, a - 1) << 4), c;
        }
        o.prototype._parseHex = function(f, a, c) {
            this.length = Math.ceil((f.length - a) / 6), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g = 0, x = 0, M;
            if (c === "be") for(d = f.length - 1; d >= a; d -= 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            else {
                var l = f.length - a;
                for(d = l % 2 === 0 ? a + 1 : a; d < f.length; d += 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            }
            this._strip();
        };
        function m(A, f, a, c) {
            for(var d = 0, g = 0, x = Math.min(A.length, a), M = f; M < x; M++){
                var l = A.charCodeAt(M) - 48;
                d *= c, l >= 49 ? g = l - 49 + 10 : l >= 17 ? g = l - 17 + 10 : g = l, i(l >= 0 && g < c, "Invalid character"), d += g;
            }
            return d;
        }
        o.prototype._parseBase = function(f, a, c) {
            this.words = [
                0
            ], this.length = 1;
            for(var d = 0, g = 1; g <= 67108863; g *= a)d++;
            d--, g = g / a | 0;
            for(var x = f.length - c, M = x % d, l = Math.min(x, x - M) + c, s = 0, v = c; v < l; v += d)s = m(f, v, v + d, a), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            if (M !== 0) {
                var k = 1;
                for(s = m(f, v, f.length, a), v = 0; v < M; v++)k *= a;
                this.imuln(k), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            }
            this._strip();
        }, o.prototype.copy = function(f) {
            f.words = new Array(this.length);
            for(var a = 0; a < this.length; a++)f.words[a] = this.words[a];
            f.length = this.length, f.negative = this.negative, f.red = this.red;
        };
        function w(A, f) {
            A.words = f.words, A.length = f.length, A.negative = f.negative, A.red = f.red;
        }
        if (o.prototype._move = function(f) {
            w(f, this);
        }, o.prototype.clone = function() {
            var f = new o(null);
            return this.copy(f), f;
        }, o.prototype._expand = function(f) {
            for(; this.length < f;)this.words[this.length++] = 0;
            return this;
        }, o.prototype._strip = function() {
            for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
            return this._normSign();
        }, o.prototype._normSign = function() {
            return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
        }, typeof Symbol < "u" && typeof Symbol.for == "function") try {
            o.prototype[Symbol.for("nodejs.util.inspect.custom")] = y;
        } catch  {
            o.prototype.inspect = y;
        }
        else o.prototype.inspect = y;
        function y() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }
        var S = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], I = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], N = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        o.prototype.toString = function(f, a) {
            f = f || 10, a = a | 0 || 1;
            var c;
            if (f === 16 || f === "hex") {
                c = "";
                for(var d = 0, g = 0, x = 0; x < this.length; x++){
                    var M = this.words[x], l = ((M << d | g) & 16777215).toString(16);
                    g = M >>> 24 - d & 16777215, d += 2, d >= 26 && (d -= 26, x--), g !== 0 || x !== this.length - 1 ? c = S[6 - l.length] + l + c : c = l + c;
                }
                for(g !== 0 && (c = g.toString(16) + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
                var s = I[f], v = N[f];
                c = "";
                var k = this.clone();
                for(k.negative = 0; !k.isZero();){
                    var u = k.modrn(v).toString(f);
                    k = k.idivn(v), k.isZero() ? c = u + c : c = S[s - u.length] + u + c;
                }
                for(this.isZero() && (c = "0" + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            i(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function() {
            var f = this.words[0];
            return this.length === 2 ? f += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? f += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -f : f;
        }, o.prototype.toJSON = function() {
            return this.toString(16, 2);
        }, h && (o.prototype.toBuffer = function(f, a) {
            return this.toArrayLike(h, f, a);
        }), o.prototype.toArray = function(f, a) {
            return this.toArrayLike(Array, f, a);
        };
        var C = function(f, a) {
            return f.allocUnsafe ? f.allocUnsafe(a) : new f(a);
        };
        o.prototype.toArrayLike = function(f, a, c) {
            this._strip();
            var d = this.byteLength(), g = c || Math.max(1, d);
            i(d <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0");
            var x = C(f, g), M = a === "le" ? "LE" : "BE";
            return this["_toArrayLike" + M](x, d), x;
        }, o.prototype._toArrayLikeLE = function(f, a) {
            for(var c = 0, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c++] = M & 255, c < f.length && (f[c++] = M >> 8 & 255), c < f.length && (f[c++] = M >> 16 & 255), x === 6 ? (c < f.length && (f[c++] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c < f.length) for(f[c++] = d; c < f.length;)f[c++] = 0;
        }, o.prototype._toArrayLikeBE = function(f, a) {
            for(var c = f.length - 1, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c--] = M & 255, c >= 0 && (f[c--] = M >> 8 & 255), c >= 0 && (f[c--] = M >> 16 & 255), x === 6 ? (c >= 0 && (f[c--] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c >= 0) for(f[c--] = d; c >= 0;)f[c--] = 0;
        }, Math.clz32 ? o.prototype._countBits = function(f) {
            return 32 - Math.clz32(f);
        } : o.prototype._countBits = function(f) {
            var a = f, c = 0;
            return a >= 4096 && (c += 13, a >>>= 13), a >= 64 && (c += 7, a >>>= 7), a >= 8 && (c += 4, a >>>= 4), a >= 2 && (c += 2, a >>>= 2), c + a;
        }, o.prototype._zeroBits = function(f) {
            if (f === 0) return 26;
            var a = f, c = 0;
            return a & 8191 || (c += 13, a >>>= 13), a & 127 || (c += 7, a >>>= 7), a & 15 || (c += 4, a >>>= 4), a & 3 || (c += 2, a >>>= 2), a & 1 || c++, c;
        }, o.prototype.bitLength = function() {
            var f = this.words[this.length - 1], a = this._countBits(f);
            return (this.length - 1) * 26 + a;
        };
        function F(A) {
            for(var f = new Array(A.bitLength()), a = 0; a < f.length; a++){
                var c = a / 26 | 0, d = a % 26;
                f[a] = A.words[c] >>> d & 1;
            }
            return f;
        }
        o.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var f = 0, a = 0; a < this.length; a++){
                var c = this._zeroBits(this.words[a]);
                if (f += c, c !== 26) break;
            }
            return f;
        }, o.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function(f) {
            return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function(f) {
            return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function() {
            return this.negative !== 0;
        }, o.prototype.neg = function() {
            return this.clone().ineg();
        }, o.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function(f) {
            for(; this.length < f.length;)this.words[this.length++] = 0;
            for(var a = 0; a < f.length; a++)this.words[a] = this.words[a] | f.words[a];
            return this._strip();
        }, o.prototype.ior = function(f) {
            return i((this.negative | f.negative) === 0), this.iuor(f);
        }, o.prototype.or = function(f) {
            return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
        }, o.prototype.uor = function(f) {
            return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
        }, o.prototype.iuand = function(f) {
            var a;
            this.length > f.length ? a = f : a = this;
            for(var c = 0; c < a.length; c++)this.words[c] = this.words[c] & f.words[c];
            return this.length = a.length, this._strip();
        }, o.prototype.iand = function(f) {
            return i((this.negative | f.negative) === 0), this.iuand(f);
        }, o.prototype.and = function(f) {
            return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
        }, o.prototype.uand = function(f) {
            return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
        }, o.prototype.iuxor = function(f) {
            var a, c;
            this.length > f.length ? (a = this, c = f) : (a = f, c = this);
            for(var d = 0; d < c.length; d++)this.words[d] = a.words[d] ^ c.words[d];
            if (this !== a) for(; d < a.length; d++)this.words[d] = a.words[d];
            return this.length = a.length, this._strip();
        }, o.prototype.ixor = function(f) {
            return i((this.negative | f.negative) === 0), this.iuxor(f);
        }, o.prototype.xor = function(f) {
            return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
        }, o.prototype.uxor = function(f) {
            return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
        }, o.prototype.inotn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = Math.ceil(f / 26) | 0, c = f % 26;
            this._expand(a), c > 0 && a--;
            for(var d = 0; d < a; d++)this.words[d] = ~this.words[d] & 67108863;
            return c > 0 && (this.words[d] = ~this.words[d] & 67108863 >> 26 - c), this._strip();
        }, o.prototype.notn = function(f) {
            return this.clone().inotn(f);
        }, o.prototype.setn = function(f, a) {
            i(typeof f == "number" && f >= 0);
            var c = f / 26 | 0, d = f % 26;
            return this._expand(c + 1), a ? this.words[c] = this.words[c] | 1 << d : this.words[c] = this.words[c] & ~(1 << d), this._strip();
        }, o.prototype.iadd = function(f) {
            var a;
            if (this.negative !== 0 && f.negative === 0) return this.negative = 0, a = this.isub(f), this.negative ^= 1, this._normSign();
            if (this.negative === 0 && f.negative !== 0) return f.negative = 0, a = this.isub(f), f.negative = 1, a._normSign();
            var c, d;
            this.length > f.length ? (c = this, d = f) : (c = f, d = this);
            for(var g = 0, x = 0; x < d.length; x++)a = (c.words[x] | 0) + (d.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            for(; g !== 0 && x < c.length; x++)a = (c.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            if (this.length = c.length, g !== 0) this.words[this.length] = g, this.length++;
            else if (c !== this) for(; x < c.length; x++)this.words[x] = c.words[x];
            return this;
        }, o.prototype.add = function(f) {
            var a;
            return f.negative !== 0 && this.negative === 0 ? (f.negative = 0, a = this.sub(f), f.negative ^= 1, a) : f.negative === 0 && this.negative !== 0 ? (this.negative = 0, a = f.sub(this), this.negative = 1, a) : this.length > f.length ? this.clone().iadd(f) : f.clone().iadd(this);
        }, o.prototype.isub = function(f) {
            if (f.negative !== 0) {
                f.negative = 0;
                var a = this.iadd(f);
                return f.negative = 1, a._normSign();
            } else if (this.negative !== 0) return this.negative = 0, this.iadd(f), this.negative = 1, this._normSign();
            var c = this.cmp(f);
            if (c === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            var d, g;
            c > 0 ? (d = this, g = f) : (d = f, g = this);
            for(var x = 0, M = 0; M < g.length; M++)a = (d.words[M] | 0) - (g.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            for(; x !== 0 && M < d.length; M++)a = (d.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            if (x === 0 && M < d.length && d !== this) for(; M < d.length; M++)this.words[M] = d.words[M];
            return this.length = Math.max(this.length, M), d !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function(f) {
            return this.clone().isub(f);
        };
        function U(A, f, a) {
            a.negative = f.negative ^ A.negative;
            var c = A.length + f.length | 0;
            a.length = c, c = c - 1 | 0;
            var d = A.words[0] | 0, g = f.words[0] | 0, x = d * g, M = x & 67108863, l = x / 67108864 | 0;
            a.words[0] = M;
            for(var s = 1; s < c; s++){
                for(var v = l >>> 26, k = l & 67108863, u = Math.min(s, f.length - 1), E = Math.max(0, s - A.length + 1); E <= u; E++){
                    var _ = s - E | 0;
                    d = A.words[_] | 0, g = f.words[E] | 0, x = d * g + k, v += x / 67108864 | 0, k = x & 67108863;
                }
                a.words[s] = k | 0, l = v | 0;
            }
            return l !== 0 ? a.words[s] = l | 0 : a.length--, a._strip();
        }
        var J = function(f, a, c) {
            var d = f.words, g = a.words, x = c.words, M = 0, l, s, v, k = d[0] | 0, u = k & 8191, E = k >>> 13, _ = d[1] | 0, B = _ & 8191, R = _ >>> 13, T = d[2] | 0, P = T & 8191, O = T >>> 13, Ct = d[3] | 0, D = Ct & 8191, q = Ct >>> 13, De = d[4] | 0, X = De & 8191, Z = De >>> 13, Fe = d[5] | 0, $ = Fe & 8191, tt = Fe >>> 13, Te = d[6] | 0, et = Te & 8191, rt = Te >>> 13, Ue = d[7] | 0, it = Ue & 8191, nt = Ue >>> 13, ke = d[8] | 0, ft = ke & 8191, ot = ke >>> 13, qe = d[9] | 0, st = qe & 8191, at = qe >>> 13, Ke = g[0] | 0, ut = Ke & 8191, ht = Ke >>> 13, He = g[1] | 0, ct = He & 8191, lt = He >>> 13, ze = g[2] | 0, dt = ze & 8191, pt = ze >>> 13, Le = g[3] | 0, vt = Le & 8191, mt = Le >>> 13, je = g[4] | 0, gt = je & 8191, At = je >>> 13, Qe = g[5] | 0, bt = Qe & 8191, yt = Qe >>> 13, Je = g[6] | 0, wt = Je & 8191, xt = Je >>> 13, Ge = g[7] | 0, Mt = Ge & 8191, Et = Ge >>> 13, Ye = g[8] | 0, St = Ye & 8191, Nt = Ye >>> 13, Ve = g[9] | 0, It = Ve & 8191, _t = Ve >>> 13;
            c.negative = f.negative ^ a.negative, c.length = 19, l = Math.imul(u, ut), s = Math.imul(u, ht), s = s + Math.imul(E, ut) | 0, v = Math.imul(E, ht);
            var Me = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, l = Math.imul(B, ut), s = Math.imul(B, ht), s = s + Math.imul(R, ut) | 0, v = Math.imul(R, ht), l = l + Math.imul(u, ct) | 0, s = s + Math.imul(u, lt) | 0, s = s + Math.imul(E, ct) | 0, v = v + Math.imul(E, lt) | 0;
            var Ee = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, l = Math.imul(P, ut), s = Math.imul(P, ht), s = s + Math.imul(O, ut) | 0, v = Math.imul(O, ht), l = l + Math.imul(B, ct) | 0, s = s + Math.imul(B, lt) | 0, s = s + Math.imul(R, ct) | 0, v = v + Math.imul(R, lt) | 0, l = l + Math.imul(u, dt) | 0, s = s + Math.imul(u, pt) | 0, s = s + Math.imul(E, dt) | 0, v = v + Math.imul(E, pt) | 0;
            var Se = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, l = Math.imul(D, ut), s = Math.imul(D, ht), s = s + Math.imul(q, ut) | 0, v = Math.imul(q, ht), l = l + Math.imul(P, ct) | 0, s = s + Math.imul(P, lt) | 0, s = s + Math.imul(O, ct) | 0, v = v + Math.imul(O, lt) | 0, l = l + Math.imul(B, dt) | 0, s = s + Math.imul(B, pt) | 0, s = s + Math.imul(R, dt) | 0, v = v + Math.imul(R, pt) | 0, l = l + Math.imul(u, vt) | 0, s = s + Math.imul(u, mt) | 0, s = s + Math.imul(E, vt) | 0, v = v + Math.imul(E, mt) | 0;
            var Ne = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l = Math.imul(X, ut), s = Math.imul(X, ht), s = s + Math.imul(Z, ut) | 0, v = Math.imul(Z, ht), l = l + Math.imul(D, ct) | 0, s = s + Math.imul(D, lt) | 0, s = s + Math.imul(q, ct) | 0, v = v + Math.imul(q, lt) | 0, l = l + Math.imul(P, dt) | 0, s = s + Math.imul(P, pt) | 0, s = s + Math.imul(O, dt) | 0, v = v + Math.imul(O, pt) | 0, l = l + Math.imul(B, vt) | 0, s = s + Math.imul(B, mt) | 0, s = s + Math.imul(R, vt) | 0, v = v + Math.imul(R, mt) | 0, l = l + Math.imul(u, gt) | 0, s = s + Math.imul(u, At) | 0, s = s + Math.imul(E, gt) | 0, v = v + Math.imul(E, At) | 0;
            var Ie = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul($, ut), s = Math.imul($, ht), s = s + Math.imul(tt, ut) | 0, v = Math.imul(tt, ht), l = l + Math.imul(X, ct) | 0, s = s + Math.imul(X, lt) | 0, s = s + Math.imul(Z, ct) | 0, v = v + Math.imul(Z, lt) | 0, l = l + Math.imul(D, dt) | 0, s = s + Math.imul(D, pt) | 0, s = s + Math.imul(q, dt) | 0, v = v + Math.imul(q, pt) | 0, l = l + Math.imul(P, vt) | 0, s = s + Math.imul(P, mt) | 0, s = s + Math.imul(O, vt) | 0, v = v + Math.imul(O, mt) | 0, l = l + Math.imul(B, gt) | 0, s = s + Math.imul(B, At) | 0, s = s + Math.imul(R, gt) | 0, v = v + Math.imul(R, At) | 0, l = l + Math.imul(u, bt) | 0, s = s + Math.imul(u, yt) | 0, s = s + Math.imul(E, bt) | 0, v = v + Math.imul(E, yt) | 0;
            var Wr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, l = Math.imul(et, ut), s = Math.imul(et, ht), s = s + Math.imul(rt, ut) | 0, v = Math.imul(rt, ht), l = l + Math.imul($, ct) | 0, s = s + Math.imul($, lt) | 0, s = s + Math.imul(tt, ct) | 0, v = v + Math.imul(tt, lt) | 0, l = l + Math.imul(X, dt) | 0, s = s + Math.imul(X, pt) | 0, s = s + Math.imul(Z, dt) | 0, v = v + Math.imul(Z, pt) | 0, l = l + Math.imul(D, vt) | 0, s = s + Math.imul(D, mt) | 0, s = s + Math.imul(q, vt) | 0, v = v + Math.imul(q, mt) | 0, l = l + Math.imul(P, gt) | 0, s = s + Math.imul(P, At) | 0, s = s + Math.imul(O, gt) | 0, v = v + Math.imul(O, At) | 0, l = l + Math.imul(B, bt) | 0, s = s + Math.imul(B, yt) | 0, s = s + Math.imul(R, bt) | 0, v = v + Math.imul(R, yt) | 0, l = l + Math.imul(u, wt) | 0, s = s + Math.imul(u, xt) | 0, s = s + Math.imul(E, wt) | 0, v = v + Math.imul(E, xt) | 0;
            var Xr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, l = Math.imul(it, ut), s = Math.imul(it, ht), s = s + Math.imul(nt, ut) | 0, v = Math.imul(nt, ht), l = l + Math.imul(et, ct) | 0, s = s + Math.imul(et, lt) | 0, s = s + Math.imul(rt, ct) | 0, v = v + Math.imul(rt, lt) | 0, l = l + Math.imul($, dt) | 0, s = s + Math.imul($, pt) | 0, s = s + Math.imul(tt, dt) | 0, v = v + Math.imul(tt, pt) | 0, l = l + Math.imul(X, vt) | 0, s = s + Math.imul(X, mt) | 0, s = s + Math.imul(Z, vt) | 0, v = v + Math.imul(Z, mt) | 0, l = l + Math.imul(D, gt) | 0, s = s + Math.imul(D, At) | 0, s = s + Math.imul(q, gt) | 0, v = v + Math.imul(q, At) | 0, l = l + Math.imul(P, bt) | 0, s = s + Math.imul(P, yt) | 0, s = s + Math.imul(O, bt) | 0, v = v + Math.imul(O, yt) | 0, l = l + Math.imul(B, wt) | 0, s = s + Math.imul(B, xt) | 0, s = s + Math.imul(R, wt) | 0, v = v + Math.imul(R, xt) | 0, l = l + Math.imul(u, Mt) | 0, s = s + Math.imul(u, Et) | 0, s = s + Math.imul(E, Mt) | 0, v = v + Math.imul(E, Et) | 0;
            var Zr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, l = Math.imul(ft, ut), s = Math.imul(ft, ht), s = s + Math.imul(ot, ut) | 0, v = Math.imul(ot, ht), l = l + Math.imul(it, ct) | 0, s = s + Math.imul(it, lt) | 0, s = s + Math.imul(nt, ct) | 0, v = v + Math.imul(nt, lt) | 0, l = l + Math.imul(et, dt) | 0, s = s + Math.imul(et, pt) | 0, s = s + Math.imul(rt, dt) | 0, v = v + Math.imul(rt, pt) | 0, l = l + Math.imul($, vt) | 0, s = s + Math.imul($, mt) | 0, s = s + Math.imul(tt, vt) | 0, v = v + Math.imul(tt, mt) | 0, l = l + Math.imul(X, gt) | 0, s = s + Math.imul(X, At) | 0, s = s + Math.imul(Z, gt) | 0, v = v + Math.imul(Z, At) | 0, l = l + Math.imul(D, bt) | 0, s = s + Math.imul(D, yt) | 0, s = s + Math.imul(q, bt) | 0, v = v + Math.imul(q, yt) | 0, l = l + Math.imul(P, wt) | 0, s = s + Math.imul(P, xt) | 0, s = s + Math.imul(O, wt) | 0, v = v + Math.imul(O, xt) | 0, l = l + Math.imul(B, Mt) | 0, s = s + Math.imul(B, Et) | 0, s = s + Math.imul(R, Mt) | 0, v = v + Math.imul(R, Et) | 0, l = l + Math.imul(u, St) | 0, s = s + Math.imul(u, Nt) | 0, s = s + Math.imul(E, St) | 0, v = v + Math.imul(E, Nt) | 0;
            var $r = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, l = Math.imul(st, ut), s = Math.imul(st, ht), s = s + Math.imul(at, ut) | 0, v = Math.imul(at, ht), l = l + Math.imul(ft, ct) | 0, s = s + Math.imul(ft, lt) | 0, s = s + Math.imul(ot, ct) | 0, v = v + Math.imul(ot, lt) | 0, l = l + Math.imul(it, dt) | 0, s = s + Math.imul(it, pt) | 0, s = s + Math.imul(nt, dt) | 0, v = v + Math.imul(nt, pt) | 0, l = l + Math.imul(et, vt) | 0, s = s + Math.imul(et, mt) | 0, s = s + Math.imul(rt, vt) | 0, v = v + Math.imul(rt, mt) | 0, l = l + Math.imul($, gt) | 0, s = s + Math.imul($, At) | 0, s = s + Math.imul(tt, gt) | 0, v = v + Math.imul(tt, At) | 0, l = l + Math.imul(X, bt) | 0, s = s + Math.imul(X, yt) | 0, s = s + Math.imul(Z, bt) | 0, v = v + Math.imul(Z, yt) | 0, l = l + Math.imul(D, wt) | 0, s = s + Math.imul(D, xt) | 0, s = s + Math.imul(q, wt) | 0, v = v + Math.imul(q, xt) | 0, l = l + Math.imul(P, Mt) | 0, s = s + Math.imul(P, Et) | 0, s = s + Math.imul(O, Mt) | 0, v = v + Math.imul(O, Et) | 0, l = l + Math.imul(B, St) | 0, s = s + Math.imul(B, Nt) | 0, s = s + Math.imul(R, St) | 0, v = v + Math.imul(R, Nt) | 0, l = l + Math.imul(u, It) | 0, s = s + Math.imul(u, _t) | 0, s = s + Math.imul(E, It) | 0, v = v + Math.imul(E, _t) | 0;
            var ti = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, l = Math.imul(st, ct), s = Math.imul(st, lt), s = s + Math.imul(at, ct) | 0, v = Math.imul(at, lt), l = l + Math.imul(ft, dt) | 0, s = s + Math.imul(ft, pt) | 0, s = s + Math.imul(ot, dt) | 0, v = v + Math.imul(ot, pt) | 0, l = l + Math.imul(it, vt) | 0, s = s + Math.imul(it, mt) | 0, s = s + Math.imul(nt, vt) | 0, v = v + Math.imul(nt, mt) | 0, l = l + Math.imul(et, gt) | 0, s = s + Math.imul(et, At) | 0, s = s + Math.imul(rt, gt) | 0, v = v + Math.imul(rt, At) | 0, l = l + Math.imul($, bt) | 0, s = s + Math.imul($, yt) | 0, s = s + Math.imul(tt, bt) | 0, v = v + Math.imul(tt, yt) | 0, l = l + Math.imul(X, wt) | 0, s = s + Math.imul(X, xt) | 0, s = s + Math.imul(Z, wt) | 0, v = v + Math.imul(Z, xt) | 0, l = l + Math.imul(D, Mt) | 0, s = s + Math.imul(D, Et) | 0, s = s + Math.imul(q, Mt) | 0, v = v + Math.imul(q, Et) | 0, l = l + Math.imul(P, St) | 0, s = s + Math.imul(P, Nt) | 0, s = s + Math.imul(O, St) | 0, v = v + Math.imul(O, Nt) | 0, l = l + Math.imul(B, It) | 0, s = s + Math.imul(B, _t) | 0, s = s + Math.imul(R, It) | 0, v = v + Math.imul(R, _t) | 0;
            var ei = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, l = Math.imul(st, dt), s = Math.imul(st, pt), s = s + Math.imul(at, dt) | 0, v = Math.imul(at, pt), l = l + Math.imul(ft, vt) | 0, s = s + Math.imul(ft, mt) | 0, s = s + Math.imul(ot, vt) | 0, v = v + Math.imul(ot, mt) | 0, l = l + Math.imul(it, gt) | 0, s = s + Math.imul(it, At) | 0, s = s + Math.imul(nt, gt) | 0, v = v + Math.imul(nt, At) | 0, l = l + Math.imul(et, bt) | 0, s = s + Math.imul(et, yt) | 0, s = s + Math.imul(rt, bt) | 0, v = v + Math.imul(rt, yt) | 0, l = l + Math.imul($, wt) | 0, s = s + Math.imul($, xt) | 0, s = s + Math.imul(tt, wt) | 0, v = v + Math.imul(tt, xt) | 0, l = l + Math.imul(X, Mt) | 0, s = s + Math.imul(X, Et) | 0, s = s + Math.imul(Z, Mt) | 0, v = v + Math.imul(Z, Et) | 0, l = l + Math.imul(D, St) | 0, s = s + Math.imul(D, Nt) | 0, s = s + Math.imul(q, St) | 0, v = v + Math.imul(q, Nt) | 0, l = l + Math.imul(P, It) | 0, s = s + Math.imul(P, _t) | 0, s = s + Math.imul(O, It) | 0, v = v + Math.imul(O, _t) | 0;
            var ri = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, l = Math.imul(st, vt), s = Math.imul(st, mt), s = s + Math.imul(at, vt) | 0, v = Math.imul(at, mt), l = l + Math.imul(ft, gt) | 0, s = s + Math.imul(ft, At) | 0, s = s + Math.imul(ot, gt) | 0, v = v + Math.imul(ot, At) | 0, l = l + Math.imul(it, bt) | 0, s = s + Math.imul(it, yt) | 0, s = s + Math.imul(nt, bt) | 0, v = v + Math.imul(nt, yt) | 0, l = l + Math.imul(et, wt) | 0, s = s + Math.imul(et, xt) | 0, s = s + Math.imul(rt, wt) | 0, v = v + Math.imul(rt, xt) | 0, l = l + Math.imul($, Mt) | 0, s = s + Math.imul($, Et) | 0, s = s + Math.imul(tt, Mt) | 0, v = v + Math.imul(tt, Et) | 0, l = l + Math.imul(X, St) | 0, s = s + Math.imul(X, Nt) | 0, s = s + Math.imul(Z, St) | 0, v = v + Math.imul(Z, Nt) | 0, l = l + Math.imul(D, It) | 0, s = s + Math.imul(D, _t) | 0, s = s + Math.imul(q, It) | 0, v = v + Math.imul(q, _t) | 0;
            var ii = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, l = Math.imul(st, gt), s = Math.imul(st, At), s = s + Math.imul(at, gt) | 0, v = Math.imul(at, At), l = l + Math.imul(ft, bt) | 0, s = s + Math.imul(ft, yt) | 0, s = s + Math.imul(ot, bt) | 0, v = v + Math.imul(ot, yt) | 0, l = l + Math.imul(it, wt) | 0, s = s + Math.imul(it, xt) | 0, s = s + Math.imul(nt, wt) | 0, v = v + Math.imul(nt, xt) | 0, l = l + Math.imul(et, Mt) | 0, s = s + Math.imul(et, Et) | 0, s = s + Math.imul(rt, Mt) | 0, v = v + Math.imul(rt, Et) | 0, l = l + Math.imul($, St) | 0, s = s + Math.imul($, Nt) | 0, s = s + Math.imul(tt, St) | 0, v = v + Math.imul(tt, Nt) | 0, l = l + Math.imul(X, It) | 0, s = s + Math.imul(X, _t) | 0, s = s + Math.imul(Z, It) | 0, v = v + Math.imul(Z, _t) | 0;
            var ni = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ni >>> 26) | 0, ni &= 67108863, l = Math.imul(st, bt), s = Math.imul(st, yt), s = s + Math.imul(at, bt) | 0, v = Math.imul(at, yt), l = l + Math.imul(ft, wt) | 0, s = s + Math.imul(ft, xt) | 0, s = s + Math.imul(ot, wt) | 0, v = v + Math.imul(ot, xt) | 0, l = l + Math.imul(it, Mt) | 0, s = s + Math.imul(it, Et) | 0, s = s + Math.imul(nt, Mt) | 0, v = v + Math.imul(nt, Et) | 0, l = l + Math.imul(et, St) | 0, s = s + Math.imul(et, Nt) | 0, s = s + Math.imul(rt, St) | 0, v = v + Math.imul(rt, Nt) | 0, l = l + Math.imul($, It) | 0, s = s + Math.imul($, _t) | 0, s = s + Math.imul(tt, It) | 0, v = v + Math.imul(tt, _t) | 0;
            var fi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (fi >>> 26) | 0, fi &= 67108863, l = Math.imul(st, wt), s = Math.imul(st, xt), s = s + Math.imul(at, wt) | 0, v = Math.imul(at, xt), l = l + Math.imul(ft, Mt) | 0, s = s + Math.imul(ft, Et) | 0, s = s + Math.imul(ot, Mt) | 0, v = v + Math.imul(ot, Et) | 0, l = l + Math.imul(it, St) | 0, s = s + Math.imul(it, Nt) | 0, s = s + Math.imul(nt, St) | 0, v = v + Math.imul(nt, Nt) | 0, l = l + Math.imul(et, It) | 0, s = s + Math.imul(et, _t) | 0, s = s + Math.imul(rt, It) | 0, v = v + Math.imul(rt, _t) | 0;
            var oi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, l = Math.imul(st, Mt), s = Math.imul(st, Et), s = s + Math.imul(at, Mt) | 0, v = Math.imul(at, Et), l = l + Math.imul(ft, St) | 0, s = s + Math.imul(ft, Nt) | 0, s = s + Math.imul(ot, St) | 0, v = v + Math.imul(ot, Nt) | 0, l = l + Math.imul(it, It) | 0, s = s + Math.imul(it, _t) | 0, s = s + Math.imul(nt, It) | 0, v = v + Math.imul(nt, _t) | 0;
            var si = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (si >>> 26) | 0, si &= 67108863, l = Math.imul(st, St), s = Math.imul(st, Nt), s = s + Math.imul(at, St) | 0, v = Math.imul(at, Nt), l = l + Math.imul(ft, It) | 0, s = s + Math.imul(ft, _t) | 0, s = s + Math.imul(ot, It) | 0, v = v + Math.imul(ot, _t) | 0;
            var ai = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, l = Math.imul(st, It), s = Math.imul(st, _t), s = s + Math.imul(at, It) | 0, v = Math.imul(at, _t);
            var ui = (M + l | 0) + ((s & 8191) << 13) | 0;
            return M = (v + (s >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, x[0] = Me, x[1] = Ee, x[2] = Se, x[3] = Ne, x[4] = Ie, x[5] = Wr, x[6] = Xr, x[7] = Zr, x[8] = $r, x[9] = ti, x[10] = ei, x[11] = ri, x[12] = ii, x[13] = ni, x[14] = fi, x[15] = oi, x[16] = si, x[17] = ai, x[18] = ui, M !== 0 && (x[19] = M, c.length++), c;
        };
        Math.imul || (J = U);
        function Bt(A, f, a) {
            a.negative = f.negative ^ A.negative, a.length = A.length + f.length;
            for(var c = 0, d = 0, g = 0; g < a.length - 1; g++){
                var x = d;
                d = 0;
                for(var M = c & 67108863, l = Math.min(g, f.length - 1), s = Math.max(0, g - A.length + 1); s <= l; s++){
                    var v = g - s, k = A.words[v] | 0, u = f.words[s] | 0, E = k * u, _ = E & 67108863;
                    x = x + (E / 67108864 | 0) | 0, _ = _ + M | 0, M = _ & 67108863, x = x + (_ >>> 26) | 0, d += x >>> 26, x &= 67108863;
                }
                a.words[g] = M, c = x, x = d;
            }
            return c !== 0 ? a.words[g] = c : a.length--, a._strip();
        }
        function G(A, f, a) {
            return Bt(A, f, a);
        }
        o.prototype.mulTo = function(f, a) {
            var c, d = this.length + f.length;
            return this.length === 10 && f.length === 10 ? c = J(this, f, a) : d < 63 ? c = U(this, f, a) : d < 1024 ? c = Bt(this, f, a) : c = G(this, f, a), c;
        }, o.prototype.mul = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), this.mulTo(f, a);
        }, o.prototype.mulf = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), G(this, f, a);
        }, o.prototype.imul = function(f) {
            return this.clone().mulTo(f, this);
        }, o.prototype.imuln = function(f) {
            var a = f < 0;
            a && (f = -f), i(typeof f == "number"), i(f < 67108864);
            for(var c = 0, d = 0; d < this.length; d++){
                var g = (this.words[d] | 0) * f, x = (g & 67108863) + (c & 67108863);
                c >>= 26, c += g / 67108864 | 0, c += x >>> 26, this.words[d] = x & 67108863;
            }
            return c !== 0 && (this.words[d] = c, this.length++), a ? this.ineg() : this;
        }, o.prototype.muln = function(f) {
            return this.clone().imuln(f);
        }, o.prototype.sqr = function() {
            return this.mul(this);
        }, o.prototype.isqr = function() {
            return this.imul(this.clone());
        }, o.prototype.pow = function(f) {
            var a = F(f);
            if (a.length === 0) return new o(1);
            for(var c = this, d = 0; d < a.length && a[d] === 0; d++, c = c.sqr());
            if (++d < a.length) for(var g = c.sqr(); d < a.length; d++, g = g.sqr())a[d] !== 0 && (c = c.mul(g));
            return c;
        }, o.prototype.iushln = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 67108863 >>> 26 - a << 26 - a, g;
            if (a !== 0) {
                var x = 0;
                for(g = 0; g < this.length; g++){
                    var M = this.words[g] & d, l = (this.words[g] | 0) - M << a;
                    this.words[g] = l | x, x = M >>> 26 - a;
                }
                x && (this.words[g] = x, this.length++);
            }
            if (c !== 0) {
                for(g = this.length - 1; g >= 0; g--)this.words[g + c] = this.words[g];
                for(g = 0; g < c; g++)this.words[g] = 0;
                this.length += c;
            }
            return this._strip();
        }, o.prototype.ishln = function(f) {
            return i(this.negative === 0), this.iushln(f);
        }, o.prototype.iushrn = function(f, a, c) {
            i(typeof f == "number" && f >= 0);
            var d;
            a ? d = (a - a % 26) / 26 : d = 0;
            var g = f % 26, x = Math.min((f - g) / 26, this.length), M = 67108863 ^ 67108863 >>> g << g, l = c;
            if (d -= x, d = Math.max(0, d), l) {
                for(var s = 0; s < x; s++)l.words[s] = this.words[s];
                l.length = x;
            }
            if (x !== 0) {
                if (this.length > x) for(this.length -= x, s = 0; s < this.length; s++)this.words[s] = this.words[s + x];
                else this.words[0] = 0, this.length = 1;
            }
            var v = 0;
            for(s = this.length - 1; s >= 0 && (v !== 0 || s >= d); s--){
                var k = this.words[s] | 0;
                this.words[s] = v << 26 - g | k >>> g, v = k & M;
            }
            return l && v !== 0 && (l.words[l.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function(f, a, c) {
            return i(this.negative === 0), this.iushrn(f, a, c);
        }, o.prototype.shln = function(f) {
            return this.clone().ishln(f);
        }, o.prototype.ushln = function(f) {
            return this.clone().iushln(f);
        }, o.prototype.shrn = function(f) {
            return this.clone().ishrn(f);
        }, o.prototype.ushrn = function(f) {
            return this.clone().iushrn(f);
        }, o.prototype.testn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return !1;
            var g = this.words[c];
            return !!(g & d);
        }, o.prototype.imaskn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26;
            if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= c) return this;
            if (a !== 0 && c++, this.length = Math.min(c, this.length), a !== 0) {
                var d = 67108863 ^ 67108863 >>> a << a;
                this.words[this.length - 1] &= d;
            }
            return this._strip();
        }, o.prototype.maskn = function(f) {
            return this.clone().imaskn(f);
        }, o.prototype.iaddn = function(f) {
            return i(typeof f == "number"), i(f < 67108864), f < 0 ? this.isubn(-f) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= f ? (this.words[0] = f - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(f), this.negative = 1, this) : this._iaddn(f);
        }, o.prototype._iaddn = function(f) {
            this.words[0] += f;
            for(var a = 0; a < this.length && this.words[a] >= 67108864; a++)this.words[a] -= 67108864, a === this.length - 1 ? this.words[a + 1] = 1 : this.words[a + 1]++;
            return this.length = Math.max(this.length, a + 1), this;
        }, o.prototype.isubn = function(f) {
            if (i(typeof f == "number"), i(f < 67108864), f < 0) return this.iaddn(-f);
            if (this.negative !== 0) return this.negative = 0, this.iaddn(f), this.negative = 1, this;
            if (this.words[0] -= f, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var a = 0; a < this.length && this.words[a] < 0; a++)this.words[a] += 67108864, this.words[a + 1] -= 1;
            return this._strip();
        }, o.prototype.addn = function(f) {
            return this.clone().iaddn(f);
        }, o.prototype.subn = function(f) {
            return this.clone().isubn(f);
        }, o.prototype.iabs = function() {
            return this.negative = 0, this;
        }, o.prototype.abs = function() {
            return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function(f, a, c) {
            var d = f.length + c, g;
            this._expand(d);
            var x, M = 0;
            for(g = 0; g < f.length; g++){
                x = (this.words[g + c] | 0) + M;
                var l = (f.words[g] | 0) * a;
                x -= l & 67108863, M = (x >> 26) - (l / 67108864 | 0), this.words[g + c] = x & 67108863;
            }
            for(; g < this.length - c; g++)x = (this.words[g + c] | 0) + M, M = x >> 26, this.words[g + c] = x & 67108863;
            if (M === 0) return this._strip();
            for(i(M === -1), M = 0, g = 0; g < this.length; g++)x = -(this.words[g] | 0) + M, M = x >> 26, this.words[g] = x & 67108863;
            return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function(f, a) {
            var c = this.length - f.length, d = this.clone(), g = f, x = g.words[g.length - 1] | 0, M = this._countBits(x);
            c = 26 - M, c !== 0 && (g = g.ushln(c), d.iushln(c), x = g.words[g.length - 1] | 0);
            var l = d.length - g.length, s;
            if (a !== "mod") {
                s = new o(null), s.length = l + 1, s.words = new Array(s.length);
                for(var v = 0; v < s.length; v++)s.words[v] = 0;
            }
            var k = d.clone()._ishlnsubmul(g, 1, l);
            k.negative === 0 && (d = k, s && (s.words[l] = 1));
            for(var u = l - 1; u >= 0; u--){
                var E = (d.words[g.length + u] | 0) * 67108864 + (d.words[g.length + u - 1] | 0);
                for(E = Math.min(E / x | 0, 67108863), d._ishlnsubmul(g, E, u); d.negative !== 0;)E--, d.negative = 0, d._ishlnsubmul(g, 1, u), d.isZero() || (d.negative ^= 1);
                s && (s.words[u] = E);
            }
            return s && s._strip(), d._strip(), a !== "div" && c !== 0 && d.iushrn(c), {
                div: s || null,
                mod: d
            };
        }, o.prototype.divmod = function(f, a, c) {
            if (i(!f.isZero()), this.isZero()) return {
                div: new o(0),
                mod: new o(0)
            };
            var d, g, x;
            return this.negative !== 0 && f.negative === 0 ? (x = this.neg().divmod(f, a), a !== "mod" && (d = x.div.neg()), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.iadd(f)), {
                div: d,
                mod: g
            }) : this.negative === 0 && f.negative !== 0 ? (x = this.divmod(f.neg(), a), a !== "mod" && (d = x.div.neg()), {
                div: d,
                mod: x.mod
            }) : this.negative & f.negative ? (x = this.neg().divmod(f.neg(), a), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.isub(f)), {
                div: x.div,
                mod: g
            }) : f.length > this.length || this.cmp(f) < 0 ? {
                div: new o(0),
                mod: this
            } : f.length === 1 ? a === "div" ? {
                div: this.divn(f.words[0]),
                mod: null
            } : a === "mod" ? {
                div: null,
                mod: new o(this.modrn(f.words[0]))
            } : {
                div: this.divn(f.words[0]),
                mod: new o(this.modrn(f.words[0]))
            } : this._wordDiv(f, a);
        }, o.prototype.div = function(f) {
            return this.divmod(f, "div", !1).div;
        }, o.prototype.mod = function(f) {
            return this.divmod(f, "mod", !1).mod;
        }, o.prototype.umod = function(f) {
            return this.divmod(f, "mod", !0).mod;
        }, o.prototype.divRound = function(f) {
            var a = this.divmod(f);
            if (a.mod.isZero()) return a.div;
            var c = a.div.negative !== 0 ? a.mod.isub(f) : a.mod, d = f.ushrn(1), g = f.andln(1), x = c.cmp(d);
            return x < 0 || g === 1 && x === 0 ? a.div : a.div.negative !== 0 ? a.div.isubn(1) : a.div.iaddn(1);
        }, o.prototype.modrn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 67108864 % f, d = 0, g = this.length - 1; g >= 0; g--)d = (c * d + (this.words[g] | 0)) % f;
            return a ? -d : d;
        }, o.prototype.modn = function(f) {
            return this.modrn(f);
        }, o.prototype.idivn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 0, d = this.length - 1; d >= 0; d--){
                var g = (this.words[d] | 0) + c * 67108864;
                this.words[d] = g / f | 0, c = g % f;
            }
            return this._strip(), a ? this.ineg() : this;
        }, o.prototype.divn = function(f) {
            return this.clone().idivn(f);
        }, o.prototype.egcd = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = new o(0), M = new o(1), l = 0; a.isEven() && c.isEven();)a.iushrn(1), c.iushrn(1), ++l;
            for(var s = c.clone(), v = a.clone(); !a.isZero();){
                for(var k = 0, u = 1; !(a.words[0] & u) && k < 26; ++k, u <<= 1);
                if (k > 0) for(a.iushrn(k); k-- > 0;)(d.isOdd() || g.isOdd()) && (d.iadd(s), g.isub(v)), d.iushrn(1), g.iushrn(1);
                for(var E = 0, _ = 1; !(c.words[0] & _) && E < 26; ++E, _ <<= 1);
                if (E > 0) for(c.iushrn(E); E-- > 0;)(x.isOdd() || M.isOdd()) && (x.iadd(s), M.isub(v)), x.iushrn(1), M.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(x), g.isub(M)) : (c.isub(a), x.isub(d), M.isub(g));
            }
            return {
                a: x,
                b: M,
                gcd: c.iushln(l)
            };
        }, o.prototype._invmp = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = c.clone(); a.cmpn(1) > 0 && c.cmpn(1) > 0;){
                for(var M = 0, l = 1; !(a.words[0] & l) && M < 26; ++M, l <<= 1);
                if (M > 0) for(a.iushrn(M); M-- > 0;)d.isOdd() && d.iadd(x), d.iushrn(1);
                for(var s = 0, v = 1; !(c.words[0] & v) && s < 26; ++s, v <<= 1);
                if (s > 0) for(c.iushrn(s); s-- > 0;)g.isOdd() && g.iadd(x), g.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(g)) : (c.isub(a), g.isub(d));
            }
            var k;
            return a.cmpn(1) === 0 ? k = d : k = g, k.cmpn(0) < 0 && k.iadd(f), k;
        }, o.prototype.gcd = function(f) {
            if (this.isZero()) return f.abs();
            if (f.isZero()) return this.abs();
            var a = this.clone(), c = f.clone();
            a.negative = 0, c.negative = 0;
            for(var d = 0; a.isEven() && c.isEven(); d++)a.iushrn(1), c.iushrn(1);
            do {
                for(; a.isEven();)a.iushrn(1);
                for(; c.isEven();)c.iushrn(1);
                var g = a.cmp(c);
                if (g < 0) {
                    var x = a;
                    a = c, c = x;
                } else if (g === 0 || c.cmpn(1) === 0) break;
                a.isub(c);
            }while (!0);
            return c.iushln(d);
        }, o.prototype.invm = function(f) {
            return this.egcd(f).a.umod(f);
        }, o.prototype.isEven = function() {
            return (this.words[0] & 1) === 0;
        }, o.prototype.isOdd = function() {
            return (this.words[0] & 1) === 1;
        }, o.prototype.andln = function(f) {
            return this.words[0] & f;
        }, o.prototype.bincn = function(f) {
            i(typeof f == "number");
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return this._expand(c + 1), this.words[c] |= d, this;
            for(var g = d, x = c; g !== 0 && x < this.length; x++){
                var M = this.words[x] | 0;
                M += g, g = M >>> 26, M &= 67108863, this.words[x] = M;
            }
            return g !== 0 && (this.words[x] = g, this.length++), this;
        }, o.prototype.isZero = function() {
            return this.length === 1 && this.words[0] === 0;
        }, o.prototype.cmpn = function(f) {
            var a = f < 0;
            if (this.negative !== 0 && !a) return -1;
            if (this.negative === 0 && a) return 1;
            this._strip();
            var c;
            if (this.length > 1) c = 1;
            else {
                a && (f = -f), i(f <= 67108863, "Number is too big");
                var d = this.words[0] | 0;
                c = d === f ? 0 : d < f ? -1 : 1;
            }
            return this.negative !== 0 ? -c | 0 : c;
        }, o.prototype.cmp = function(f) {
            if (this.negative !== 0 && f.negative === 0) return -1;
            if (this.negative === 0 && f.negative !== 0) return 1;
            var a = this.ucmp(f);
            return this.negative !== 0 ? -a | 0 : a;
        }, o.prototype.ucmp = function(f) {
            if (this.length > f.length) return 1;
            if (this.length < f.length) return -1;
            for(var a = 0, c = this.length - 1; c >= 0; c--){
                var d = this.words[c] | 0, g = f.words[c] | 0;
                if (d !== g) {
                    d < g ? a = -1 : d > g && (a = 1);
                    break;
                }
            }
            return a;
        }, o.prototype.gtn = function(f) {
            return this.cmpn(f) === 1;
        }, o.prototype.gt = function(f) {
            return this.cmp(f) === 1;
        }, o.prototype.gten = function(f) {
            return this.cmpn(f) >= 0;
        }, o.prototype.gte = function(f) {
            return this.cmp(f) >= 0;
        }, o.prototype.ltn = function(f) {
            return this.cmpn(f) === -1;
        }, o.prototype.lt = function(f) {
            return this.cmp(f) === -1;
        }, o.prototype.lten = function(f) {
            return this.cmpn(f) <= 0;
        }, o.prototype.lte = function(f) {
            return this.cmp(f) <= 0;
        }, o.prototype.eqn = function(f) {
            return this.cmpn(f) === 0;
        }, o.prototype.eq = function(f) {
            return this.cmp(f) === 0;
        }, o.red = function(f) {
            return new Y(f);
        }, o.prototype.toRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), f.convertTo(this)._forceRed(f);
        }, o.prototype.fromRed = function() {
            return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function(f) {
            return this.red = f, this;
        }, o.prototype.forceRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
        }, o.prototype.redAdd = function(f) {
            return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
        }, o.prototype.redIAdd = function(f) {
            return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
        }, o.prototype.redSub = function(f) {
            return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
        }, o.prototype.redISub = function(f) {
            return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
        }, o.prototype.redShl = function(f) {
            return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
        }, o.prototype.redMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.mul(this, f);
        }, o.prototype.redIMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.imul(this, f);
        }, o.prototype.redSqr = function() {
            return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function() {
            return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function() {
            return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function() {
            return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function() {
            return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function(f) {
            return i(this.red && !f.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, f);
        };
        var H = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function z(A, f) {
            this.name = A, this.p = new o(f, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        z.prototype._tmp = function() {
            var f = new o(null);
            return f.words = new Array(Math.ceil(this.n / 13)), f;
        }, z.prototype.ireduce = function(f) {
            var a = f, c;
            do this.split(a, this.tmp), a = this.imulK(a), a = a.iadd(this.tmp), c = a.bitLength();
            while (c > this.n);
            var d = c < this.n ? -1 : a.ucmp(this.p);
            return d === 0 ? (a.words[0] = 0, a.length = 1) : d > 0 ? a.isub(this.p) : a.strip !== void 0 ? a.strip() : a._strip(), a;
        }, z.prototype.split = function(f, a) {
            f.iushrn(this.n, 0, a);
        }, z.prototype.imulK = function(f) {
            return f.imul(this.k);
        };
        function Pt() {
            z.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        n(Pt, z), Pt.prototype.split = function(f, a) {
            for(var c = 4194303, d = Math.min(f.length, 9), g = 0; g < d; g++)a.words[g] = f.words[g];
            if (a.length = d, f.length <= 9) {
                f.words[0] = 0, f.length = 1;
                return;
            }
            var x = f.words[9];
            for(a.words[a.length++] = x & c, g = 10; g < f.length; g++){
                var M = f.words[g] | 0;
                f.words[g - 10] = (M & c) << 4 | x >>> 22, x = M;
            }
            x >>>= 22, f.words[g - 10] = x, x === 0 && f.length > 10 ? f.length -= 10 : f.length -= 9;
        }, Pt.prototype.imulK = function(f) {
            f.words[f.length] = 0, f.words[f.length + 1] = 0, f.length += 2;
            for(var a = 0, c = 0; c < f.length; c++){
                var d = f.words[c] | 0;
                a += d * 977, f.words[c] = a & 67108863, a = d * 64 + (a / 67108864 | 0);
            }
            return f.words[f.length - 1] === 0 && (f.length--, f.words[f.length - 1] === 0 && f.length--), f;
        };
        function W() {
            z.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        n(W, z);
        function Rt() {
            z.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        n(Rt, z);
        function Yt() {
            z.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        n(Yt, z), Yt.prototype.imulK = function(f) {
            for(var a = 0, c = 0; c < f.length; c++){
                var d = (f.words[c] | 0) * 19 + a, g = d & 67108863;
                d >>>= 26, f.words[c] = g, a = d;
            }
            return a !== 0 && (f.words[f.length++] = a), f;
        }, o._prime = function(f) {
            if (H[f]) return H[f];
            var a;
            if (f === "k256") a = new Pt;
            else if (f === "p224") a = new W;
            else if (f === "p192") a = new Rt;
            else if (f === "p25519") a = new Yt;
            else throw new Error("Unknown prime " + f);
            return H[f] = a, a;
        };
        function Y(A) {
            if (typeof A == "string") {
                var f = o._prime(A);
                this.m = f.p, this.prime = f;
            } else i(A.gtn(1), "modulus must be greater than 1"), this.m = A, this.prime = null;
        }
        Y.prototype._verify1 = function(f) {
            i(f.negative === 0, "red works only with positives"), i(f.red, "red works only with red numbers");
        }, Y.prototype._verify2 = function(f, a) {
            i((f.negative | a.negative) === 0, "red works only with positives"), i(f.red && f.red === a.red, "red works only with red numbers");
        }, Y.prototype.imod = function(f) {
            return this.prime ? this.prime.ireduce(f)._forceRed(this) : (w(f, f.umod(this.m)._forceRed(this)), f);
        }, Y.prototype.neg = function(f) {
            return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
        }, Y.prototype.add = function(f, a) {
            this._verify2(f, a);
            var c = f.add(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c._forceRed(this);
        }, Y.prototype.iadd = function(f, a) {
            this._verify2(f, a);
            var c = f.iadd(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c;
        }, Y.prototype.sub = function(f, a) {
            this._verify2(f, a);
            var c = f.sub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c._forceRed(this);
        }, Y.prototype.isub = function(f, a) {
            this._verify2(f, a);
            var c = f.isub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c;
        }, Y.prototype.shl = function(f, a) {
            return this._verify1(f), this.imod(f.ushln(a));
        }, Y.prototype.imul = function(f, a) {
            return this._verify2(f, a), this.imod(f.imul(a));
        }, Y.prototype.mul = function(f, a) {
            return this._verify2(f, a), this.imod(f.mul(a));
        }, Y.prototype.isqr = function(f) {
            return this.imul(f, f.clone());
        }, Y.prototype.sqr = function(f) {
            return this.mul(f, f);
        }, Y.prototype.sqrt = function(f) {
            if (f.isZero()) return f.clone();
            var a = this.m.andln(3);
            if (i(a % 2 === 1), a === 3) {
                var c = this.m.add(new o(1)).iushrn(2);
                return this.pow(f, c);
            }
            for(var d = this.m.subn(1), g = 0; !d.isZero() && d.andln(1) === 0;)g++, d.iushrn(1);
            i(!d.isZero());
            var x = new o(1).toRed(this), M = x.redNeg(), l = this.m.subn(1).iushrn(1), s = this.m.bitLength();
            for(s = new o(2 * s * s).toRed(this); this.pow(s, l).cmp(M) !== 0;)s.redIAdd(M);
            for(var v = this.pow(s, d), k = this.pow(f, d.addn(1).iushrn(1)), u = this.pow(f, d), E = g; u.cmp(x) !== 0;){
                for(var _ = u, B = 0; _.cmp(x) !== 0; B++)_ = _.redSqr();
                i(B < E);
                var R = this.pow(v, new o(1).iushln(E - B - 1));
                k = k.redMul(R), v = R.redSqr(), u = u.redMul(v), E = B;
            }
            return k;
        }, Y.prototype.invm = function(f) {
            var a = f._invmp(this.m);
            return a.negative !== 0 ? (a.negative = 0, this.imod(a).redNeg()) : this.imod(a);
        }, Y.prototype.pow = function(f, a) {
            if (a.isZero()) return new o(1).toRed(this);
            if (a.cmpn(1) === 0) return f.clone();
            var c = 4, d = new Array(1 << c);
            d[0] = new o(1).toRed(this), d[1] = f;
            for(var g = 2; g < d.length; g++)d[g] = this.mul(d[g - 1], f);
            var x = d[0], M = 0, l = 0, s = a.bitLength() % 26;
            for(s === 0 && (s = 26), g = a.length - 1; g >= 0; g--){
                for(var v = a.words[g], k = s - 1; k >= 0; k--){
                    var u = v >> k & 1;
                    if (x !== d[0] && (x = this.sqr(x)), u === 0 && M === 0) {
                        l = 0;
                        continue;
                    }
                    M <<= 1, M |= u, l++, !(l !== c && (g !== 0 || k !== 0)) && (x = this.mul(x, d[M]), l = 0, M = 0);
                }
                s = 26;
            }
            return x;
        }, Y.prototype.convertTo = function(f) {
            var a = f.umod(this.m);
            return a === f ? a.clone() : a;
        }, Y.prototype.convertFrom = function(f) {
            var a = f.clone();
            return a.red = null, a;
        }, o.mont = function(f) {
            return new Vt(f);
        };
        function Vt(A) {
            Y.call(this, A), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        n(Vt, Y), Vt.prototype.convertTo = function(f) {
            return this.imod(f.ushln(this.shift));
        }, Vt.prototype.convertFrom = function(f) {
            var a = this.imod(f.mul(this.rinv));
            return a.red = null, a;
        }, Vt.prototype.imul = function(f, a) {
            if (f.isZero() || a.isZero()) return f.words[0] = 0, f.length = 1, f;
            var c = f.imul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.mul = function(f, a) {
            if (f.isZero() || a.isZero()) return new o(0)._forceRed(this);
            var c = f.mul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.invm = function(f) {
            var a = this.imod(f._invmp(this.m).mul(this.r2));
            return a._forceRed(this);
        };
    })(e, $17d123d3e821614f$var$On);
})($17d123d3e821614f$var$Ln);
var $17d123d3e821614f$var$K = $17d123d3e821614f$var$Ln.exports;
const $17d123d3e821614f$var$jn = "bignumber/5.7.0";
var $17d123d3e821614f$var$Rr = $17d123d3e821614f$var$K.BN;
const $17d123d3e821614f$var$Ae = new $17d123d3e821614f$var$L($17d123d3e821614f$var$jn), $17d123d3e821614f$var$wi = {}, $17d123d3e821614f$var$Qn = 9007199254740991;
function $17d123d3e821614f$var$C0(e) {
    return e != null && ($17d123d3e821614f$var$V.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || $17d123d3e821614f$var$Qt(e) || typeof e == "bigint" || $17d123d3e821614f$var$ir(e));
}
let $17d123d3e821614f$var$Jn = !1;
class $17d123d3e821614f$var$V {
    constructor(t, r){
        t !== $17d123d3e821614f$var$wi && $17d123d3e821614f$var$Ae.throwError("cannot call constructor directly; use BigNumber.from", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
    }
    fromTwos(t) {
        return $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).fromTwos(t));
    }
    toTwos(t) {
        return $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).toTwos(t));
    }
    abs() {
        return this._hex[0] === "-" ? $17d123d3e821614f$var$V.from(this._hex.substring(1)) : this;
    }
    add(t) {
        return $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).add($17d123d3e821614f$var$j(t)));
    }
    sub(t) {
        return $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).sub($17d123d3e821614f$var$j(t)));
    }
    div(t) {
        return $17d123d3e821614f$var$V.from(t).isZero() && $17d123d3e821614f$var$Wt("division-by-zero", "div"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).div($17d123d3e821614f$var$j(t)));
    }
    mul(t) {
        return $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).mul($17d123d3e821614f$var$j(t)));
    }
    mod(t) {
        const r = $17d123d3e821614f$var$j(t);
        return r.isNeg() && $17d123d3e821614f$var$Wt("division-by-zero", "mod"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).umod(r));
    }
    pow(t) {
        const r = $17d123d3e821614f$var$j(t);
        return r.isNeg() && $17d123d3e821614f$var$Wt("negative-power", "pow"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).pow(r));
    }
    and(t) {
        const r = $17d123d3e821614f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $17d123d3e821614f$var$Wt("unbound-bitwise-result", "and"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).and(r));
    }
    or(t) {
        const r = $17d123d3e821614f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $17d123d3e821614f$var$Wt("unbound-bitwise-result", "or"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).or(r));
    }
    xor(t) {
        const r = $17d123d3e821614f$var$j(t);
        return (this.isNegative() || r.isNeg()) && $17d123d3e821614f$var$Wt("unbound-bitwise-result", "xor"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).xor(r));
    }
    mask(t) {
        return (this.isNegative() || t < 0) && $17d123d3e821614f$var$Wt("negative-width", "mask"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).maskn(t));
    }
    shl(t) {
        return (this.isNegative() || t < 0) && $17d123d3e821614f$var$Wt("negative-width", "shl"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).shln(t));
    }
    shr(t) {
        return (this.isNegative() || t < 0) && $17d123d3e821614f$var$Wt("negative-width", "shr"), $17d123d3e821614f$var$Lt($17d123d3e821614f$var$j(this).shrn(t));
    }
    eq(t) {
        return $17d123d3e821614f$var$j(this).eq($17d123d3e821614f$var$j(t));
    }
    lt(t) {
        return $17d123d3e821614f$var$j(this).lt($17d123d3e821614f$var$j(t));
    }
    lte(t) {
        return $17d123d3e821614f$var$j(this).lte($17d123d3e821614f$var$j(t));
    }
    gt(t) {
        return $17d123d3e821614f$var$j(this).gt($17d123d3e821614f$var$j(t));
    }
    gte(t) {
        return $17d123d3e821614f$var$j(this).gte($17d123d3e821614f$var$j(t));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $17d123d3e821614f$var$j(this).isZero();
    }
    toNumber() {
        try {
            return $17d123d3e821614f$var$j(this).toNumber();
        } catch  {
            $17d123d3e821614f$var$Wt("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch  {}
        return $17d123d3e821614f$var$Ae.throwError("this platform does not support BigInt", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        return arguments.length > 0 && (arguments[0] === 10 ? $17d123d3e821614f$var$Jn || ($17d123d3e821614f$var$Jn = !0, $17d123d3e821614f$var$Ae.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? $17d123d3e821614f$var$Ae.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", $17d123d3e821614f$var$L.errors.UNEXPECTED_ARGUMENT, {}) : $17d123d3e821614f$var$Ae.throwError("BigNumber.toString does not accept parameters", $17d123d3e821614f$var$L.errors.UNEXPECTED_ARGUMENT, {})), $17d123d3e821614f$var$j(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(t) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(t) {
        if (t instanceof $17d123d3e821614f$var$V) return t;
        if (typeof t == "string") return t.match(/^-?0x[0-9a-f]+$/i) ? new $17d123d3e821614f$var$V($17d123d3e821614f$var$wi, $17d123d3e821614f$var$vr(t)) : t.match(/^-?[0-9]+$/) ? new $17d123d3e821614f$var$V($17d123d3e821614f$var$wi, $17d123d3e821614f$var$vr(new $17d123d3e821614f$var$Rr(t))) : $17d123d3e821614f$var$Ae.throwArgumentError("invalid BigNumber string", "value", t);
        if (typeof t == "number") return t % 1 && $17d123d3e821614f$var$Wt("underflow", "BigNumber.from", t), (t >= $17d123d3e821614f$var$Qn || t <= -$17d123d3e821614f$var$Qn) && $17d123d3e821614f$var$Wt("overflow", "BigNumber.from", t), $17d123d3e821614f$var$V.from(String(t));
        const r = t;
        if (typeof r == "bigint") return $17d123d3e821614f$var$V.from(r.toString());
        if ($17d123d3e821614f$var$ir(r)) return $17d123d3e821614f$var$V.from($17d123d3e821614f$var$Kt(r));
        if (r) {
            if (r.toHexString) {
                const i = r.toHexString();
                if (typeof i == "string") return $17d123d3e821614f$var$V.from(i);
            } else {
                let i = r._hex;
                if (i == null && r.type === "BigNumber" && (i = r.hex), typeof i == "string" && ($17d123d3e821614f$var$Qt(i) || i[0] === "-" && $17d123d3e821614f$var$Qt(i.substring(1)))) return $17d123d3e821614f$var$V.from(i);
            }
        }
        return $17d123d3e821614f$var$Ae.throwArgumentError("invalid BigNumber value", "value", t);
    }
    static isBigNumber(t) {
        return !!(t && t._isBigNumber);
    }
}
function $17d123d3e821614f$var$vr(e) {
    if (typeof e != "string") return $17d123d3e821614f$var$vr(e.toString(16));
    if (e[0] === "-") return e = e.substring(1), e[0] === "-" && $17d123d3e821614f$var$Ae.throwArgumentError("invalid hex", "value", e), e = $17d123d3e821614f$var$vr(e), e === "0x00" ? e : "-" + e;
    if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x") return "0x00";
    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00";)e = "0x" + e.substring(4);
    return e;
}
function $17d123d3e821614f$var$Lt(e) {
    return $17d123d3e821614f$var$V.from($17d123d3e821614f$var$vr(e));
}
function $17d123d3e821614f$var$j(e) {
    const t = $17d123d3e821614f$var$V.from(e).toHexString();
    return t[0] === "-" ? new $17d123d3e821614f$var$Rr("-" + t.substring(3), 16) : new $17d123d3e821614f$var$Rr(t.substring(2), 16);
}
function $17d123d3e821614f$var$Wt(e, t, r) {
    const i = {
        fault: e,
        operation: t
    };
    return r != null && (i.value = r), $17d123d3e821614f$var$Ae.throwError(e, $17d123d3e821614f$var$L.errors.NUMERIC_FAULT, i);
}
function $17d123d3e821614f$var$R0(e) {
    return new $17d123d3e821614f$var$Rr(e, 36).toString(16);
}
const $17d123d3e821614f$var$Ht = new $17d123d3e821614f$var$L($17d123d3e821614f$var$jn), $17d123d3e821614f$var$mr = {}, $17d123d3e821614f$var$Gn = $17d123d3e821614f$var$V.from(0), $17d123d3e821614f$var$Yn = $17d123d3e821614f$var$V.from(-1);
function $17d123d3e821614f$var$Vn(e, t, r, i) {
    const n = {
        fault: t,
        operation: r
    };
    return i !== void 0 && (n.value = i), $17d123d3e821614f$var$Ht.throwError(e, $17d123d3e821614f$var$L.errors.NUMERIC_FAULT, n);
}
let $17d123d3e821614f$var$gr = "0";
for(; $17d123d3e821614f$var$gr.length < 256;)$17d123d3e821614f$var$gr += $17d123d3e821614f$var$gr;
function $17d123d3e821614f$var$xi(e) {
    if (typeof e != "number") try {
        e = $17d123d3e821614f$var$V.from(e).toNumber();
    } catch  {}
    return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + $17d123d3e821614f$var$gr.substring(0, e) : $17d123d3e821614f$var$Ht.throwArgumentError("invalid decimal size", "decimals", e);
}
function $17d123d3e821614f$var$Mi(e, t) {
    t == null && (t = 0);
    const r = $17d123d3e821614f$var$xi(t);
    e = $17d123d3e821614f$var$V.from(e);
    const i = e.lt($17d123d3e821614f$var$Gn);
    i && (e = e.mul($17d123d3e821614f$var$Yn));
    let n = e.mod(r).toString();
    for(; n.length < r.length - 1;)n = "0" + n;
    n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const o = e.div(r).toString();
    return r.length === 1 ? e = o : e = o + "." + n, i && (e = "-" + e), e;
}
function $17d123d3e821614f$var$be(e, t) {
    t == null && (t = 0);
    const r = $17d123d3e821614f$var$xi(t);
    (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && $17d123d3e821614f$var$Ht.throwArgumentError("invalid decimal value", "value", e);
    const i = e.substring(0, 1) === "-";
    i && (e = e.substring(1)), e === "." && $17d123d3e821614f$var$Ht.throwArgumentError("missing value", "value", e);
    const n = e.split(".");
    n.length > 2 && $17d123d3e821614f$var$Ht.throwArgumentError("too many decimal points", "value", e);
    let o = n[0], h = n[1];
    for(o || (o = "0"), h || (h = "0"); h[h.length - 1] === "0";)h = h.substring(0, h.length - 1);
    for(h.length > r.length - 1 && $17d123d3e821614f$var$Vn("fractional component exceeds decimals", "underflow", "parseFixed"), h === "" && (h = "0"); h.length < r.length - 1;)h += "0";
    const p = $17d123d3e821614f$var$V.from(o), b = $17d123d3e821614f$var$V.from(h);
    let m = p.mul(r).add(b);
    return i && (m = m.mul($17d123d3e821614f$var$Yn)), m;
}
class $17d123d3e821614f$var$dr {
    constructor(t, r, i, n){
        t !== $17d123d3e821614f$var$mr && $17d123d3e821614f$var$Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.signed = r, this.width = i, this.decimals = n, this.name = (r ? "" : "u") + "fixed" + String(i) + "x" + String(n), this._multiplier = $17d123d3e821614f$var$xi(n), Object.freeze(this);
    }
    static from(t) {
        if (t instanceof $17d123d3e821614f$var$dr) return t;
        typeof t == "number" && (t = `fixed128x${t}`);
        let r = !0, i = 128, n = 18;
        if (typeof t == "string") {
            if (t !== "fixed") {
                if (t === "ufixed") r = !1;
                else {
                    const o = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                    o || $17d123d3e821614f$var$Ht.throwArgumentError("invalid fixed format", "format", t), r = o[1] !== "u", i = parseInt(o[2]), n = parseInt(o[3]);
                }
            }
        } else if (t) {
            const o = (h, p, b)=>t[h] == null ? b : (typeof t[h] !== p && $17d123d3e821614f$var$Ht.throwArgumentError("invalid fixed format (" + h + " not " + p + ")", "format." + h, t[h]), t[h]);
            r = o("signed", "boolean", r), i = o("width", "number", i), n = o("decimals", "number", n);
        }
        return i % 8 && $17d123d3e821614f$var$Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", i), n > 80 && $17d123d3e821614f$var$Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", n), new $17d123d3e821614f$var$dr($17d123d3e821614f$var$mr, r, i, n);
    }
}
class $17d123d3e821614f$var$Ut {
    constructor(t, r, i, n){
        t !== $17d123d3e821614f$var$mr && $17d123d3e821614f$var$Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", $17d123d3e821614f$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.format = n, this._hex = r, this._value = i, this._isFixedNumber = !0, Object.freeze(this);
    }
    _checkFormat(t) {
        this.format.name !== t.format.name && $17d123d3e821614f$var$Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
    }
    addUnsafe(t) {
        this._checkFormat(t);
        const r = $17d123d3e821614f$var$be(this._value, this.format.decimals), i = $17d123d3e821614f$var$be(t._value, t.format.decimals);
        return $17d123d3e821614f$var$Ut.fromValue(r.add(i), this.format.decimals, this.format);
    }
    subUnsafe(t) {
        this._checkFormat(t);
        const r = $17d123d3e821614f$var$be(this._value, this.format.decimals), i = $17d123d3e821614f$var$be(t._value, t.format.decimals);
        return $17d123d3e821614f$var$Ut.fromValue(r.sub(i), this.format.decimals, this.format);
    }
    mulUnsafe(t) {
        this._checkFormat(t);
        const r = $17d123d3e821614f$var$be(this._value, this.format.decimals), i = $17d123d3e821614f$var$be(t._value, t.format.decimals);
        return $17d123d3e821614f$var$Ut.fromValue(r.mul(i).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(t) {
        this._checkFormat(t);
        const r = $17d123d3e821614f$var$be(this._value, this.format.decimals), i = $17d123d3e821614f$var$be(t._value, t.format.decimals);
        return $17d123d3e821614f$var$Ut.fromValue(r.mul(this.format._multiplier).div(i), this.format.decimals, this.format);
    }
    floor() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $17d123d3e821614f$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return this.isNegative() && i && (r = r.subUnsafe($17d123d3e821614f$var$Wn.toFormat(r.format))), r;
    }
    ceiling() {
        const t = this.toString().split(".");
        t.length === 1 && t.push("0");
        let r = $17d123d3e821614f$var$Ut.from(t[0], this.format);
        const i = !t[1].match(/^(0*)$/);
        return !this.isNegative() && i && (r = r.addUnsafe($17d123d3e821614f$var$Wn.toFormat(r.format))), r;
    }
    round(t) {
        t == null && (t = 0);
        const r = this.toString().split(".");
        if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && $17d123d3e821614f$var$Ht.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
        const i = $17d123d3e821614f$var$Ut.from("1" + $17d123d3e821614f$var$gr.substring(0, t), this.format), n = $17d123d3e821614f$var$O0.toFormat(this.format);
        return this.mulUnsafe(i).addUnsafe(n).floor().divUnsafe(i);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(t) {
        if (t == null) return this._hex;
        t % 8 && $17d123d3e821614f$var$Ht.throwArgumentError("invalid byte width", "width", t);
        const r = $17d123d3e821614f$var$V.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
        return $17d123d3e821614f$var$oe(r, t / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(t) {
        return $17d123d3e821614f$var$Ut.fromString(this._value, t);
    }
    static fromValue(t, r, i) {
        return i == null && r != null && !$17d123d3e821614f$var$C0(r) && (i = r, r = null), r == null && (r = 0), i == null && (i = "fixed"), $17d123d3e821614f$var$Ut.fromString($17d123d3e821614f$var$Mi(t, r), $17d123d3e821614f$var$dr.from(i));
    }
    static fromString(t, r) {
        r == null && (r = "fixed");
        const i = $17d123d3e821614f$var$dr.from(r), n = $17d123d3e821614f$var$be(t, i.decimals);
        !i.signed && n.lt($17d123d3e821614f$var$Gn) && $17d123d3e821614f$var$Vn("unsigned value cannot be negative", "overflow", "value", t);
        let o = null;
        i.signed ? o = n.toTwos(i.width).toHexString() : (o = n.toHexString(), o = $17d123d3e821614f$var$oe(o, i.width / 8));
        const h = $17d123d3e821614f$var$Mi(n, i.decimals);
        return new $17d123d3e821614f$var$Ut($17d123d3e821614f$var$mr, o, h, i);
    }
    static fromBytes(t, r) {
        r == null && (r = "fixed");
        const i = $17d123d3e821614f$var$dr.from(r);
        if ($17d123d3e821614f$var$Ot(t).length > i.width / 8) throw new Error("overflow");
        let n = $17d123d3e821614f$var$V.from(t);
        i.signed && (n = n.fromTwos(i.width));
        const o = n.toTwos((i.signed ? 0 : 1) + i.width).toHexString(), h = $17d123d3e821614f$var$Mi(n, i.decimals);
        return new $17d123d3e821614f$var$Ut($17d123d3e821614f$var$mr, o, h, i);
    }
    static from(t, r) {
        if (typeof t == "string") return $17d123d3e821614f$var$Ut.fromString(t, r);
        if ($17d123d3e821614f$var$ir(t)) return $17d123d3e821614f$var$Ut.fromBytes(t, r);
        try {
            return $17d123d3e821614f$var$Ut.fromValue(t, 0, r);
        } catch (i) {
            if (i.code !== $17d123d3e821614f$var$L.errors.INVALID_ARGUMENT) throw i;
        }
        return $17d123d3e821614f$var$Ht.throwArgumentError("invalid FixedNumber value", "value", t);
    }
    static isFixedNumber(t) {
        return !!(t && t._isFixedNumber);
    }
}
const $17d123d3e821614f$var$Wn = $17d123d3e821614f$var$Ut.from(1), $17d123d3e821614f$var$O0 = $17d123d3e821614f$var$Ut.from("0.5"), $17d123d3e821614f$var$P0 = "strings/5.7.0", $17d123d3e821614f$var$Xn = new $17d123d3e821614f$var$L($17d123d3e821614f$var$P0);
var $17d123d3e821614f$var$Or;
(function(e) {
    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})($17d123d3e821614f$var$Or || ($17d123d3e821614f$var$Or = {}));
var $17d123d3e821614f$var$nr;
(function(e) {
    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})($17d123d3e821614f$var$nr || ($17d123d3e821614f$var$nr = {}));
function $17d123d3e821614f$var$D0(e, t, r, i, n) {
    return $17d123d3e821614f$var$Xn.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
}
function $17d123d3e821614f$var$Zn(e, t, r, i, n) {
    if (e === $17d123d3e821614f$var$nr.BAD_PREFIX || e === $17d123d3e821614f$var$nr.UNEXPECTED_CONTINUE) {
        let o = 0;
        for(let h = t + 1; h < r.length && r[h] >> 6 === 2; h++)o++;
        return o;
    }
    return e === $17d123d3e821614f$var$nr.OVERRUN ? r.length - t - 1 : 0;
}
function $17d123d3e821614f$var$F0(e, t, r, i, n) {
    return e === $17d123d3e821614f$var$nr.OVERLONG ? (i.push(n), 0) : (i.push(65533), $17d123d3e821614f$var$Zn(e, t, r));
}
Object.freeze({
    error: $17d123d3e821614f$var$D0,
    ignore: $17d123d3e821614f$var$Zn,
    replace: $17d123d3e821614f$var$F0
});
function $17d123d3e821614f$var$Ei(e, t = $17d123d3e821614f$var$Or.current) {
    t != $17d123d3e821614f$var$Or.current && ($17d123d3e821614f$var$Xn.checkNormalize(), e = e.normalize(t));
    let r = [];
    for(let i = 0; i < e.length; i++){
        const n = e.charCodeAt(i);
        if (n < 128) r.push(n);
        else if (n < 2048) r.push(n >> 6 | 192), r.push(n & 63 | 128);
        else if ((n & 64512) == 55296) {
            i++;
            const o = e.charCodeAt(i);
            if (i >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            const h = 65536 + ((n & 1023) << 10) + (o & 1023);
            r.push(h >> 18 | 240), r.push(h >> 12 & 63 | 128), r.push(h >> 6 & 63 | 128), r.push(h & 63 | 128);
        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
    }
    return $17d123d3e821614f$var$Ot(r);
}
function $17d123d3e821614f$var$T0(e) {
    if (e.length % 4 !== 0) throw new Error("bad data");
    let t = [];
    for(let r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
    return t;
}
function $17d123d3e821614f$var$Si(e, t) {
    t || (t = function(n) {
        return [
            parseInt(n, 16)
        ];
    });
    let r = 0, i = {};
    return e.split(",").forEach((n)=>{
        let o = n.split(":");
        r += parseInt(o[0], 16), i[r] = t(o[1]);
    }), i;
}
function $17d123d3e821614f$var$$n(e) {
    let t = 0;
    return e.split(",").map((r)=>{
        let i = r.split("-");
        i.length === 1 ? i[1] = "0" : i[1] === "" && (i[1] = "1");
        let n = t + parseInt(i[0], 16);
        return t = parseInt(i[1], 16), {
            l: n,
            h: t
        };
    });
}
$17d123d3e821614f$var$$n("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((e)=>parseInt(e, 16)), $17d123d3e821614f$var$Si("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), $17d123d3e821614f$var$Si("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), $17d123d3e821614f$var$Si("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $17d123d3e821614f$var$T0), $17d123d3e821614f$var$$n("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
const $17d123d3e821614f$var$tf = "hash/5.7.0";
function $17d123d3e821614f$var$U0(e) {
    e = atob(e);
    const t = [];
    for(let r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
    return $17d123d3e821614f$var$Ot(t);
}
function $17d123d3e821614f$var$ef(e, t) {
    t == null && (t = 1);
    const r = [], i = r.forEach, n = function(o, h) {
        i.call(o, function(p) {
            h > 0 && Array.isArray(p) ? n(p, h - 1) : r.push(p);
        });
    };
    return n(e, t), r;
}
function $17d123d3e821614f$var$k0(e) {
    const t = {};
    for(let r = 0; r < e.length; r++){
        const i = e[r];
        t[i[0]] = i[1];
    }
    return t;
}
function $17d123d3e821614f$var$q0(e) {
    let t = 0;
    function r() {
        return e[t++] << 8 | e[t++];
    }
    let i = r(), n = 1, o = [
        0,
        1
    ];
    for(let H = 1; H < i; H++)o.push(n += r());
    let h = r(), p = t;
    t += h;
    let b = 0, m = 0;
    function w() {
        return b == 0 && (m = m << 8 | e[t++], b = 8), m >> --b & 1;
    }
    const y = 31, S = Math.pow(2, y), I = S >>> 1, N = I >> 1, C = S - 1;
    let F = 0;
    for(let H = 0; H < y; H++)F = F << 1 | w();
    let U = [], J = 0, Bt = S;
    for(;;){
        let H = Math.floor(((F - J + 1) * n - 1) / Bt), z = 0, Pt = i;
        for(; Pt - z > 1;){
            let Yt = z + Pt >>> 1;
            H < o[Yt] ? Pt = Yt : z = Yt;
        }
        if (z == 0) break;
        U.push(z);
        let W = J + Math.floor(Bt * o[z] / n), Rt = J + Math.floor(Bt * o[z + 1] / n) - 1;
        for(; !((W ^ Rt) & I);)F = F << 1 & C | w(), W = W << 1 & C, Rt = Rt << 1 & C | 1;
        for(; W & ~Rt & N;)F = F & I | F << 1 & C >>> 1 | w(), W = W << 1 ^ I, Rt = (Rt ^ I) << 1 | I | 1;
        J = W, Bt = 1 + Rt - W;
    }
    let G = i - 4;
    return U.map((H)=>{
        switch(H - G){
            case 3:
                return G + 65792 + (e[p++] << 16 | e[p++] << 8 | e[p++]);
            case 2:
                return G + 256 + (e[p++] << 8 | e[p++]);
            case 1:
                return G + e[p++];
            default:
                return H - 1;
        }
    });
}
function $17d123d3e821614f$var$K0(e) {
    let t = 0;
    return ()=>e[t++];
}
function $17d123d3e821614f$var$H0(e) {
    return $17d123d3e821614f$var$K0($17d123d3e821614f$var$q0(e));
}
function $17d123d3e821614f$var$z0(e) {
    return e & 1 ? ~e >> 1 : e >> 1;
}
function $17d123d3e821614f$var$L0(e, t) {
    let r = Array(e);
    for(let i = 0; i < e; i++)r[i] = 1 + t();
    return r;
}
function $17d123d3e821614f$var$rf(e, t) {
    let r = Array(e);
    for(let i = 0, n = -1; i < e; i++)r[i] = n += 1 + t();
    return r;
}
function $17d123d3e821614f$var$j0(e, t) {
    let r = Array(e);
    for(let i = 0, n = 0; i < e; i++)r[i] = n += $17d123d3e821614f$var$z0(t());
    return r;
}
function $17d123d3e821614f$var$Pr(e, t) {
    let r = $17d123d3e821614f$var$rf(e(), e), i = e(), n = $17d123d3e821614f$var$rf(i, e), o = $17d123d3e821614f$var$L0(i, e);
    for(let h = 0; h < i; h++)for(let p = 0; p < o[h]; p++)r.push(n[h] + p);
    return t ? r.map((h)=>t[h]) : r;
}
function $17d123d3e821614f$var$Q0(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push($17d123d3e821614f$var$G0(r, e));
    }
    for(;;){
        let r = e() - 1;
        if (r < 0) break;
        t.push($17d123d3e821614f$var$Y0(r, e));
    }
    return $17d123d3e821614f$var$k0($17d123d3e821614f$var$ef(t));
}
function $17d123d3e821614f$var$J0(e) {
    let t = [];
    for(;;){
        let r = e();
        if (r == 0) break;
        t.push(r);
    }
    return t;
}
function $17d123d3e821614f$var$nf(e, t, r) {
    let i = Array(e).fill(void 0).map(()=>[]);
    for(let n = 0; n < t; n++)$17d123d3e821614f$var$j0(e, r).forEach((o, h)=>i[h].push(o));
    return i;
}
function $17d123d3e821614f$var$G0(e, t) {
    let r = 1 + t(), i = t(), n = $17d123d3e821614f$var$J0(t), o = $17d123d3e821614f$var$nf(n.length, 1 + e, t);
    return $17d123d3e821614f$var$ef(o.map((h, p)=>{
        const b = h[0], m = h.slice(1);
        return Array(n[p]).fill(void 0).map((w, y)=>{
            let S = y * i;
            return [
                b + y * r,
                m.map((I)=>I + S)
            ];
        });
    }));
}
function $17d123d3e821614f$var$Y0(e, t) {
    let r = 1 + t();
    return $17d123d3e821614f$var$nf(r, 1 + e, t).map((n)=>[
            n[0],
            n.slice(1)
        ]);
}
function $17d123d3e821614f$var$V0(e) {
    let t = $17d123d3e821614f$var$Pr(e).sort((i, n)=>i - n);
    return r();
    function r() {
        let i = [];
        for(;;){
            let m = $17d123d3e821614f$var$Pr(e, t);
            if (m.length == 0) break;
            i.push({
                set: new Set(m),
                node: r()
            });
        }
        i.sort((m, w)=>w.set.size - m.set.size);
        let n = e(), o = n % 3;
        n = n / 3 | 0;
        let h = !!(n & 1);
        n >>= 1;
        let p = n == 1, b = n == 2;
        return {
            branches: i,
            valid: o,
            fe0f: h,
            save: p,
            check: b
        };
    }
}
function $17d123d3e821614f$var$W0() {
    return $17d123d3e821614f$var$H0($17d123d3e821614f$var$U0("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"));
}
const $17d123d3e821614f$var$Dr = $17d123d3e821614f$var$W0();
new Set($17d123d3e821614f$var$Pr($17d123d3e821614f$var$Dr)), new Set($17d123d3e821614f$var$Pr($17d123d3e821614f$var$Dr)), $17d123d3e821614f$var$Q0($17d123d3e821614f$var$Dr), $17d123d3e821614f$var$V0($17d123d3e821614f$var$Dr), new $17d123d3e821614f$var$L($17d123d3e821614f$var$tf);
const $17d123d3e821614f$var$X0 = new Uint8Array(32);
$17d123d3e821614f$var$X0.fill(0);
const $17d123d3e821614f$var$Z0 = `Ethereum Signed Message:
`;
function $17d123d3e821614f$var$ff(e) {
    return typeof e == "string" && (e = $17d123d3e821614f$var$Ei(e)), $17d123d3e821614f$var$yi($17d123d3e821614f$var$E0([
        $17d123d3e821614f$var$Ei($17d123d3e821614f$var$Z0),
        $17d123d3e821614f$var$Ei(String(e.length)),
        e
    ]));
}
const $17d123d3e821614f$var$$0 = "rlp/5.7.0";
new $17d123d3e821614f$var$L($17d123d3e821614f$var$$0);
const $17d123d3e821614f$var$ts = "address/5.7.0", $17d123d3e821614f$var$Ar = new $17d123d3e821614f$var$L($17d123d3e821614f$var$ts);
function $17d123d3e821614f$var$of(e) {
    $17d123d3e821614f$var$Qt(e, 20) || $17d123d3e821614f$var$Ar.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
    const t = e.substring(2).split(""), r = new Uint8Array(40);
    for(let n = 0; n < 40; n++)r[n] = t[n].charCodeAt(0);
    const i = $17d123d3e821614f$var$Ot($17d123d3e821614f$var$yi(r));
    for(let n = 0; n < 40; n += 2)i[n >> 1] >> 4 >= 8 && (t[n] = t[n].toUpperCase()), (i[n >> 1] & 15) >= 8 && (t[n + 1] = t[n + 1].toUpperCase());
    return "0x" + t.join("");
}
const $17d123d3e821614f$var$es = 9007199254740991;
function $17d123d3e821614f$var$rs(e) {
    return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
const $17d123d3e821614f$var$Ni = {};
for(let e = 0; e < 10; e++)$17d123d3e821614f$var$Ni[String(e)] = String(e);
for(let e = 0; e < 26; e++)$17d123d3e821614f$var$Ni[String.fromCharCode(65 + e)] = String(10 + e);
const $17d123d3e821614f$var$sf = Math.floor($17d123d3e821614f$var$rs($17d123d3e821614f$var$es));
function $17d123d3e821614f$var$is(e) {
    e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
    let t = e.split("").map((i)=>$17d123d3e821614f$var$Ni[i]).join("");
    for(; t.length >= $17d123d3e821614f$var$sf;){
        let i = t.substring(0, $17d123d3e821614f$var$sf);
        t = parseInt(i, 10) % 97 + t.substring(i.length);
    }
    let r = String(98 - parseInt(t, 10) % 97);
    for(; r.length < 2;)r = "0" + r;
    return r;
}
function $17d123d3e821614f$var$ns(e) {
    let t = null;
    if (typeof e != "string" && $17d123d3e821614f$var$Ar.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) e.substring(0, 2) !== "0x" && (e = "0x" + e), t = $17d123d3e821614f$var$of(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && $17d123d3e821614f$var$Ar.throwArgumentError("bad address checksum", "address", e);
    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        for(e.substring(2, 4) !== $17d123d3e821614f$var$is(e) && $17d123d3e821614f$var$Ar.throwArgumentError("bad icap checksum", "address", e), t = $17d123d3e821614f$var$R0(e.substring(4)); t.length < 40;)t = "0" + t;
        t = $17d123d3e821614f$var$of("0x" + t);
    } else $17d123d3e821614f$var$Ar.throwArgumentError("invalid address", "address", e);
    return t;
}
const $17d123d3e821614f$var$fs = "properties/5.7.0";
new $17d123d3e821614f$var$L($17d123d3e821614f$var$fs);
function $17d123d3e821614f$var$br(e, t, r) {
    Object.defineProperty(e, t, {
        enumerable: !0,
        value: r,
        writable: !1
    });
}
new $17d123d3e821614f$var$L($17d123d3e821614f$var$tf);
const $17d123d3e821614f$var$os = new Uint8Array(32);
$17d123d3e821614f$var$os.fill(0), $17d123d3e821614f$var$V.from(-1);
const $17d123d3e821614f$var$ss = $17d123d3e821614f$var$V.from(0), $17d123d3e821614f$var$as = $17d123d3e821614f$var$V.from(1);
$17d123d3e821614f$var$V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), $17d123d3e821614f$var$oe($17d123d3e821614f$var$as.toHexString(), 32), $17d123d3e821614f$var$oe($17d123d3e821614f$var$ss.toHexString(), 32);
var $17d123d3e821614f$var$se = {}, $17d123d3e821614f$var$Q = {}, $17d123d3e821614f$var$yr = $17d123d3e821614f$var$af;
function $17d123d3e821614f$var$af(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$17d123d3e821614f$var$af.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $17d123d3e821614f$var$Ii = {
    exports: {}
};
typeof Object.create == "function" ? $17d123d3e821614f$var$Ii.exports = function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
} : $17d123d3e821614f$var$Ii.exports = function(t, r) {
    if (r) {
        t.super_ = r;
        var i = function() {};
        i.prototype = r.prototype, t.prototype = new i, t.prototype.constructor = t;
    }
};
var $17d123d3e821614f$var$us = $17d123d3e821614f$var$yr, $17d123d3e821614f$var$hs = $17d123d3e821614f$var$Ii.exports;
$17d123d3e821614f$var$Q.inherits = $17d123d3e821614f$var$hs;
function $17d123d3e821614f$var$cs(e, t) {
    return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function $17d123d3e821614f$var$ls(e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if (typeof e == "string") {
        if (t) {
            if (t === "hex") for(e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
        } else for(var i = 0, n = 0; n < e.length; n++){
            var o = e.charCodeAt(n);
            o < 128 ? r[i++] = o : o < 2048 ? (r[i++] = o >> 6 | 192, r[i++] = o & 63 | 128) : $17d123d3e821614f$var$cs(e, n) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++n) & 1023), r[i++] = o >> 18 | 240, r[i++] = o >> 12 & 63 | 128, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128) : (r[i++] = o >> 12 | 224, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128);
        }
    } else for(n = 0; n < e.length; n++)r[n] = e[n] | 0;
    return r;
}
$17d123d3e821614f$var$Q.toArray = $17d123d3e821614f$var$ls;
function $17d123d3e821614f$var$ds(e) {
    for(var t = "", r = 0; r < e.length; r++)t += $17d123d3e821614f$var$hf(e[r].toString(16));
    return t;
}
$17d123d3e821614f$var$Q.toHex = $17d123d3e821614f$var$ds;
function $17d123d3e821614f$var$uf(e) {
    var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
    return t >>> 0;
}
$17d123d3e821614f$var$Q.htonl = $17d123d3e821614f$var$uf;
function $17d123d3e821614f$var$ps(e, t) {
    for(var r = "", i = 0; i < e.length; i++){
        var n = e[i];
        t === "little" && (n = $17d123d3e821614f$var$uf(n)), r += $17d123d3e821614f$var$cf(n.toString(16));
    }
    return r;
}
$17d123d3e821614f$var$Q.toHex32 = $17d123d3e821614f$var$ps;
function $17d123d3e821614f$var$hf(e) {
    return e.length === 1 ? "0" + e : e;
}
$17d123d3e821614f$var$Q.zero2 = $17d123d3e821614f$var$hf;
function $17d123d3e821614f$var$cf(e) {
    return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
$17d123d3e821614f$var$Q.zero8 = $17d123d3e821614f$var$cf;
function $17d123d3e821614f$var$vs(e, t, r, i) {
    var n = r - t;
    $17d123d3e821614f$var$us(n % 4 === 0);
    for(var o = new Array(n / 4), h = 0, p = t; h < o.length; h++, p += 4){
        var b;
        i === "big" ? b = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : b = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], o[h] = b >>> 0;
    }
    return o;
}
$17d123d3e821614f$var$Q.join32 = $17d123d3e821614f$var$vs;
function $17d123d3e821614f$var$ms(e, t) {
    for(var r = new Array(e.length * 4), i = 0, n = 0; i < e.length; i++, n += 4){
        var o = e[i];
        t === "big" ? (r[n] = o >>> 24, r[n + 1] = o >>> 16 & 255, r[n + 2] = o >>> 8 & 255, r[n + 3] = o & 255) : (r[n + 3] = o >>> 24, r[n + 2] = o >>> 16 & 255, r[n + 1] = o >>> 8 & 255, r[n] = o & 255);
    }
    return r;
}
$17d123d3e821614f$var$Q.split32 = $17d123d3e821614f$var$ms;
function $17d123d3e821614f$var$gs(e, t) {
    return e >>> t | e << 32 - t;
}
$17d123d3e821614f$var$Q.rotr32 = $17d123d3e821614f$var$gs;
function $17d123d3e821614f$var$As(e, t) {
    return e << t | e >>> 32 - t;
}
$17d123d3e821614f$var$Q.rotl32 = $17d123d3e821614f$var$As;
function $17d123d3e821614f$var$bs(e, t) {
    return e + t >>> 0;
}
$17d123d3e821614f$var$Q.sum32 = $17d123d3e821614f$var$bs;
function $17d123d3e821614f$var$ys(e, t, r) {
    return e + t + r >>> 0;
}
$17d123d3e821614f$var$Q.sum32_3 = $17d123d3e821614f$var$ys;
function $17d123d3e821614f$var$ws(e, t, r, i) {
    return e + t + r + i >>> 0;
}
$17d123d3e821614f$var$Q.sum32_4 = $17d123d3e821614f$var$ws;
function $17d123d3e821614f$var$xs(e, t, r, i, n) {
    return e + t + r + i + n >>> 0;
}
$17d123d3e821614f$var$Q.sum32_5 = $17d123d3e821614f$var$xs;
function $17d123d3e821614f$var$Ms(e, t, r, i) {
    var n = e[t], o = e[t + 1], h = i + o >>> 0, p = (h < i ? 1 : 0) + r + n;
    e[t] = p >>> 0, e[t + 1] = h;
}
$17d123d3e821614f$var$Q.sum64 = $17d123d3e821614f$var$Ms;
function $17d123d3e821614f$var$Es(e, t, r, i) {
    var n = t + i >>> 0, o = (n < t ? 1 : 0) + e + r;
    return o >>> 0;
}
$17d123d3e821614f$var$Q.sum64_hi = $17d123d3e821614f$var$Es;
function $17d123d3e821614f$var$Ss(e, t, r, i) {
    var n = t + i;
    return n >>> 0;
}
$17d123d3e821614f$var$Q.sum64_lo = $17d123d3e821614f$var$Ss;
function $17d123d3e821614f$var$Ns(e, t, r, i, n, o, h, p) {
    var b = 0, m = t;
    m = m + i >>> 0, b += m < t ? 1 : 0, m = m + o >>> 0, b += m < o ? 1 : 0, m = m + p >>> 0, b += m < p ? 1 : 0;
    var w = e + r + n + h + b;
    return w >>> 0;
}
$17d123d3e821614f$var$Q.sum64_4_hi = $17d123d3e821614f$var$Ns;
function $17d123d3e821614f$var$Is(e, t, r, i, n, o, h, p) {
    var b = t + i + o + p;
    return b >>> 0;
}
$17d123d3e821614f$var$Q.sum64_4_lo = $17d123d3e821614f$var$Is;
function $17d123d3e821614f$var$_s(e, t, r, i, n, o, h, p, b, m) {
    var w = 0, y = t;
    y = y + i >>> 0, w += y < t ? 1 : 0, y = y + o >>> 0, w += y < o ? 1 : 0, y = y + p >>> 0, w += y < p ? 1 : 0, y = y + m >>> 0, w += y < m ? 1 : 0;
    var S = e + r + n + h + b + w;
    return S >>> 0;
}
$17d123d3e821614f$var$Q.sum64_5_hi = $17d123d3e821614f$var$_s;
function $17d123d3e821614f$var$Bs(e, t, r, i, n, o, h, p, b, m) {
    var w = t + i + o + p + m;
    return w >>> 0;
}
$17d123d3e821614f$var$Q.sum64_5_lo = $17d123d3e821614f$var$Bs;
function $17d123d3e821614f$var$Cs(e, t, r) {
    var i = t << 32 - r | e >>> r;
    return i >>> 0;
}
$17d123d3e821614f$var$Q.rotr64_hi = $17d123d3e821614f$var$Cs;
function $17d123d3e821614f$var$Rs(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$17d123d3e821614f$var$Q.rotr64_lo = $17d123d3e821614f$var$Rs;
function $17d123d3e821614f$var$Os(e, t, r) {
    return e >>> r;
}
$17d123d3e821614f$var$Q.shr64_hi = $17d123d3e821614f$var$Os;
function $17d123d3e821614f$var$Ps(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$17d123d3e821614f$var$Q.shr64_lo = $17d123d3e821614f$var$Ps;
var $17d123d3e821614f$var$fr = {}, $17d123d3e821614f$var$lf = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Ds = $17d123d3e821614f$var$yr;
function $17d123d3e821614f$var$Fr() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
$17d123d3e821614f$var$fr.BlockHash = $17d123d3e821614f$var$Fr, $17d123d3e821614f$var$Fr.prototype.update = function(t, r) {
    if (t = $17d123d3e821614f$var$lf.toArray(t, r), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        t = this.pending;
        var i = t.length % this._delta8;
        this.pending = t.slice(t.length - i, t.length), this.pending.length === 0 && (this.pending = null), t = $17d123d3e821614f$var$lf.join32(t, 0, t.length - i, this.endian);
        for(var n = 0; n < t.length; n += this._delta32)this._update(t, n, n + this._delta32);
    }
    return this;
}, $17d123d3e821614f$var$Fr.prototype.digest = function(t) {
    return this.update(this._pad()), $17d123d3e821614f$var$Ds(this.pending === null), this._digest(t);
}, $17d123d3e821614f$var$Fr.prototype._pad = function() {
    var t = this.pendingTotal, r = this._delta8, i = r - (t + this.padLength) % r, n = new Array(i + this.padLength);
    n[0] = 128;
    for(var o = 1; o < i; o++)n[o] = 0;
    if (t <<= 3, this.endian === "big") {
        for(var h = 8; h < this.padLength; h++)n[o++] = 0;
        n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = t >>> 24 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 8 & 255, n[o++] = t & 255;
    } else for(n[o++] = t & 255, n[o++] = t >>> 8 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 24 & 255, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, h = 8; h < this.padLength; h++)n[o++] = 0;
    return n;
};
var $17d123d3e821614f$var$or = {}, $17d123d3e821614f$var$ae = {}, $17d123d3e821614f$var$Fs = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$ue = $17d123d3e821614f$var$Fs.rotr32;
function $17d123d3e821614f$var$Ts(e, t, r, i) {
    if (e === 0) return $17d123d3e821614f$var$df(t, r, i);
    if (e === 1 || e === 3) return $17d123d3e821614f$var$vf(t, r, i);
    if (e === 2) return $17d123d3e821614f$var$pf(t, r, i);
}
$17d123d3e821614f$var$ae.ft_1 = $17d123d3e821614f$var$Ts;
function $17d123d3e821614f$var$df(e, t, r) {
    return e & t ^ ~e & r;
}
$17d123d3e821614f$var$ae.ch32 = $17d123d3e821614f$var$df;
function $17d123d3e821614f$var$pf(e, t, r) {
    return e & t ^ e & r ^ t & r;
}
$17d123d3e821614f$var$ae.maj32 = $17d123d3e821614f$var$pf;
function $17d123d3e821614f$var$vf(e, t, r) {
    return e ^ t ^ r;
}
$17d123d3e821614f$var$ae.p32 = $17d123d3e821614f$var$vf;
function $17d123d3e821614f$var$Us(e) {
    return $17d123d3e821614f$var$ue(e, 2) ^ $17d123d3e821614f$var$ue(e, 13) ^ $17d123d3e821614f$var$ue(e, 22);
}
$17d123d3e821614f$var$ae.s0_256 = $17d123d3e821614f$var$Us;
function $17d123d3e821614f$var$ks(e) {
    return $17d123d3e821614f$var$ue(e, 6) ^ $17d123d3e821614f$var$ue(e, 11) ^ $17d123d3e821614f$var$ue(e, 25);
}
$17d123d3e821614f$var$ae.s1_256 = $17d123d3e821614f$var$ks;
function $17d123d3e821614f$var$qs(e) {
    return $17d123d3e821614f$var$ue(e, 7) ^ $17d123d3e821614f$var$ue(e, 18) ^ e >>> 3;
}
$17d123d3e821614f$var$ae.g0_256 = $17d123d3e821614f$var$qs;
function $17d123d3e821614f$var$Ks(e) {
    return $17d123d3e821614f$var$ue(e, 17) ^ $17d123d3e821614f$var$ue(e, 19) ^ e >>> 10;
}
$17d123d3e821614f$var$ae.g1_256 = $17d123d3e821614f$var$Ks;
var $17d123d3e821614f$var$sr = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Hs = $17d123d3e821614f$var$fr, $17d123d3e821614f$var$zs = $17d123d3e821614f$var$ae, $17d123d3e821614f$var$_i = $17d123d3e821614f$var$sr.rotl32, $17d123d3e821614f$var$wr = $17d123d3e821614f$var$sr.sum32, $17d123d3e821614f$var$Ls = $17d123d3e821614f$var$sr.sum32_5, $17d123d3e821614f$var$js = $17d123d3e821614f$var$zs.ft_1, $17d123d3e821614f$var$mf = $17d123d3e821614f$var$Hs.BlockHash, $17d123d3e821614f$var$Qs = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
];
function $17d123d3e821614f$var$he() {
    if (!(this instanceof $17d123d3e821614f$var$he)) return new $17d123d3e821614f$var$he;
    $17d123d3e821614f$var$mf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.W = new Array(80);
}
$17d123d3e821614f$var$sr.inherits($17d123d3e821614f$var$he, $17d123d3e821614f$var$mf);
var $17d123d3e821614f$var$Js = $17d123d3e821614f$var$he;
$17d123d3e821614f$var$he.blockSize = 512, $17d123d3e821614f$var$he.outSize = 160, $17d123d3e821614f$var$he.hmacStrength = 80, $17d123d3e821614f$var$he.padLength = 64, $17d123d3e821614f$var$he.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $17d123d3e821614f$var$_i(i[n - 3] ^ i[n - 8] ^ i[n - 14] ^ i[n - 16], 1);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4];
    for(n = 0; n < i.length; n++){
        var w = ~~(n / 20), y = $17d123d3e821614f$var$Ls($17d123d3e821614f$var$_i(o, 5), $17d123d3e821614f$var$js(w, h, p, b), m, i[n], $17d123d3e821614f$var$Qs[w]);
        m = b, b = p, p = $17d123d3e821614f$var$_i(h, 30), h = o, o = y;
    }
    this.h[0] = $17d123d3e821614f$var$wr(this.h[0], o), this.h[1] = $17d123d3e821614f$var$wr(this.h[1], h), this.h[2] = $17d123d3e821614f$var$wr(this.h[2], p), this.h[3] = $17d123d3e821614f$var$wr(this.h[3], b), this.h[4] = $17d123d3e821614f$var$wr(this.h[4], m);
}, $17d123d3e821614f$var$he.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$sr.toHex32(this.h, "big") : $17d123d3e821614f$var$sr.split32(this.h, "big");
};
var $17d123d3e821614f$var$ar = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Gs = $17d123d3e821614f$var$fr, $17d123d3e821614f$var$ur = $17d123d3e821614f$var$ae, $17d123d3e821614f$var$Ys = $17d123d3e821614f$var$yr, $17d123d3e821614f$var$ie = $17d123d3e821614f$var$ar.sum32, $17d123d3e821614f$var$Vs = $17d123d3e821614f$var$ar.sum32_4, $17d123d3e821614f$var$Ws = $17d123d3e821614f$var$ar.sum32_5, $17d123d3e821614f$var$Xs = $17d123d3e821614f$var$ur.ch32, $17d123d3e821614f$var$Zs = $17d123d3e821614f$var$ur.maj32, $17d123d3e821614f$var$$s = $17d123d3e821614f$var$ur.s0_256, $17d123d3e821614f$var$ta = $17d123d3e821614f$var$ur.s1_256, $17d123d3e821614f$var$ea = $17d123d3e821614f$var$ur.g0_256, $17d123d3e821614f$var$ra = $17d123d3e821614f$var$ur.g1_256, $17d123d3e821614f$var$gf = $17d123d3e821614f$var$Gs.BlockHash, $17d123d3e821614f$var$ia = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
];
function $17d123d3e821614f$var$ce() {
    if (!(this instanceof $17d123d3e821614f$var$ce)) return new $17d123d3e821614f$var$ce;
    $17d123d3e821614f$var$gf.call(this), this.h = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ], this.k = $17d123d3e821614f$var$ia, this.W = new Array(64);
}
$17d123d3e821614f$var$ar.inherits($17d123d3e821614f$var$ce, $17d123d3e821614f$var$gf);
var $17d123d3e821614f$var$Af = $17d123d3e821614f$var$ce;
$17d123d3e821614f$var$ce.blockSize = 512, $17d123d3e821614f$var$ce.outSize = 256, $17d123d3e821614f$var$ce.hmacStrength = 192, $17d123d3e821614f$var$ce.padLength = 64, $17d123d3e821614f$var$ce.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $17d123d3e821614f$var$Vs($17d123d3e821614f$var$ra(i[n - 2]), i[n - 7], $17d123d3e821614f$var$ea(i[n - 15]), i[n - 16]);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4], w = this.h[5], y = this.h[6], S = this.h[7];
    for($17d123d3e821614f$var$Ys(this.k.length === i.length), n = 0; n < i.length; n++){
        var I = $17d123d3e821614f$var$Ws(S, $17d123d3e821614f$var$ta(m), $17d123d3e821614f$var$Xs(m, w, y), this.k[n], i[n]), N = $17d123d3e821614f$var$ie($17d123d3e821614f$var$$s(o), $17d123d3e821614f$var$Zs(o, h, p));
        S = y, y = w, w = m, m = $17d123d3e821614f$var$ie(b, I), b = p, p = h, h = o, o = $17d123d3e821614f$var$ie(I, N);
    }
    this.h[0] = $17d123d3e821614f$var$ie(this.h[0], o), this.h[1] = $17d123d3e821614f$var$ie(this.h[1], h), this.h[2] = $17d123d3e821614f$var$ie(this.h[2], p), this.h[3] = $17d123d3e821614f$var$ie(this.h[3], b), this.h[4] = $17d123d3e821614f$var$ie(this.h[4], m), this.h[5] = $17d123d3e821614f$var$ie(this.h[5], w), this.h[6] = $17d123d3e821614f$var$ie(this.h[6], y), this.h[7] = $17d123d3e821614f$var$ie(this.h[7], S);
}, $17d123d3e821614f$var$ce.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$ar.toHex32(this.h, "big") : $17d123d3e821614f$var$ar.split32(this.h, "big");
};
var $17d123d3e821614f$var$Bi = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$bf = $17d123d3e821614f$var$Af;
function $17d123d3e821614f$var$ye() {
    if (!(this instanceof $17d123d3e821614f$var$ye)) return new $17d123d3e821614f$var$ye;
    $17d123d3e821614f$var$bf.call(this), this.h = [
        3238371032,
        914150663,
        812702999,
        4144912697,
        4290775857,
        1750603025,
        1694076839,
        3204075428
    ];
}
$17d123d3e821614f$var$Bi.inherits($17d123d3e821614f$var$ye, $17d123d3e821614f$var$bf);
var $17d123d3e821614f$var$na = $17d123d3e821614f$var$ye;
$17d123d3e821614f$var$ye.blockSize = 512, $17d123d3e821614f$var$ye.outSize = 224, $17d123d3e821614f$var$ye.hmacStrength = 192, $17d123d3e821614f$var$ye.padLength = 64, $17d123d3e821614f$var$ye.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$Bi.toHex32(this.h.slice(0, 7), "big") : $17d123d3e821614f$var$Bi.split32(this.h.slice(0, 7), "big");
};
var $17d123d3e821614f$var$jt = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$fa = $17d123d3e821614f$var$fr, $17d123d3e821614f$var$oa = $17d123d3e821614f$var$yr, $17d123d3e821614f$var$le = $17d123d3e821614f$var$jt.rotr64_hi, $17d123d3e821614f$var$de = $17d123d3e821614f$var$jt.rotr64_lo, $17d123d3e821614f$var$yf = $17d123d3e821614f$var$jt.shr64_hi, $17d123d3e821614f$var$wf = $17d123d3e821614f$var$jt.shr64_lo, $17d123d3e821614f$var$Be = $17d123d3e821614f$var$jt.sum64, $17d123d3e821614f$var$Ci = $17d123d3e821614f$var$jt.sum64_hi, $17d123d3e821614f$var$Ri = $17d123d3e821614f$var$jt.sum64_lo, $17d123d3e821614f$var$sa = $17d123d3e821614f$var$jt.sum64_4_hi, $17d123d3e821614f$var$aa = $17d123d3e821614f$var$jt.sum64_4_lo, $17d123d3e821614f$var$ua = $17d123d3e821614f$var$jt.sum64_5_hi, $17d123d3e821614f$var$ha = $17d123d3e821614f$var$jt.sum64_5_lo, $17d123d3e821614f$var$xf = $17d123d3e821614f$var$fa.BlockHash, $17d123d3e821614f$var$ca = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function $17d123d3e821614f$var$ne() {
    if (!(this instanceof $17d123d3e821614f$var$ne)) return new $17d123d3e821614f$var$ne;
    $17d123d3e821614f$var$xf.call(this), this.h = [
        1779033703,
        4089235720,
        3144134277,
        2227873595,
        1013904242,
        4271175723,
        2773480762,
        1595750129,
        1359893119,
        2917565137,
        2600822924,
        725511199,
        528734635,
        4215389547,
        1541459225,
        327033209
    ], this.k = $17d123d3e821614f$var$ca, this.W = new Array(160);
}
$17d123d3e821614f$var$jt.inherits($17d123d3e821614f$var$ne, $17d123d3e821614f$var$xf);
var $17d123d3e821614f$var$Mf = $17d123d3e821614f$var$ne;
$17d123d3e821614f$var$ne.blockSize = 1024, $17d123d3e821614f$var$ne.outSize = 512, $17d123d3e821614f$var$ne.hmacStrength = 192, $17d123d3e821614f$var$ne.padLength = 128, $17d123d3e821614f$var$ne.prototype._prepareBlock = function(t, r) {
    for(var i = this.W, n = 0; n < 32; n++)i[n] = t[r + n];
    for(; n < i.length; n += 2){
        var o = $17d123d3e821614f$var$xa(i[n - 4], i[n - 3]), h = $17d123d3e821614f$var$Ma(i[n - 4], i[n - 3]), p = i[n - 14], b = i[n - 13], m = $17d123d3e821614f$var$ya(i[n - 30], i[n - 29]), w = $17d123d3e821614f$var$wa(i[n - 30], i[n - 29]), y = i[n - 32], S = i[n - 31];
        i[n] = $17d123d3e821614f$var$sa(o, h, p, b, m, w, y, S), i[n + 1] = $17d123d3e821614f$var$aa(o, h, p, b, m, w, y, S);
    }
}, $17d123d3e821614f$var$ne.prototype._update = function(t, r) {
    this._prepareBlock(t, r);
    var i = this.W, n = this.h[0], o = this.h[1], h = this.h[2], p = this.h[3], b = this.h[4], m = this.h[5], w = this.h[6], y = this.h[7], S = this.h[8], I = this.h[9], N = this.h[10], C = this.h[11], F = this.h[12], U = this.h[13], J = this.h[14], Bt = this.h[15];
    $17d123d3e821614f$var$oa(this.k.length === i.length);
    for(var G = 0; G < i.length; G += 2){
        var H = J, z = Bt, Pt = $17d123d3e821614f$var$Aa(S, I), W = $17d123d3e821614f$var$ba(S, I), Rt = $17d123d3e821614f$var$la(S, I, N, C, F), Yt = $17d123d3e821614f$var$da(S, I, N, C, F, U), Y = this.k[G], Vt = this.k[G + 1], A = i[G], f = i[G + 1], a = $17d123d3e821614f$var$ua(H, z, Pt, W, Rt, Yt, Y, Vt, A, f), c = $17d123d3e821614f$var$ha(H, z, Pt, W, Rt, Yt, Y, Vt, A, f);
        H = $17d123d3e821614f$var$ma(n, o), z = $17d123d3e821614f$var$ga(n, o), Pt = $17d123d3e821614f$var$pa(n, o, h, p, b), W = $17d123d3e821614f$var$va(n, o, h, p, b, m);
        var d = $17d123d3e821614f$var$Ci(H, z, Pt, W), g = $17d123d3e821614f$var$Ri(H, z, Pt, W);
        J = F, Bt = U, F = N, U = C, N = S, C = I, S = $17d123d3e821614f$var$Ci(w, y, a, c), I = $17d123d3e821614f$var$Ri(y, y, a, c), w = b, y = m, b = h, m = p, h = n, p = o, n = $17d123d3e821614f$var$Ci(a, c, d, g), o = $17d123d3e821614f$var$Ri(a, c, d, g);
    }
    $17d123d3e821614f$var$Be(this.h, 0, n, o), $17d123d3e821614f$var$Be(this.h, 2, h, p), $17d123d3e821614f$var$Be(this.h, 4, b, m), $17d123d3e821614f$var$Be(this.h, 6, w, y), $17d123d3e821614f$var$Be(this.h, 8, S, I), $17d123d3e821614f$var$Be(this.h, 10, N, C), $17d123d3e821614f$var$Be(this.h, 12, F, U), $17d123d3e821614f$var$Be(this.h, 14, J, Bt);
}, $17d123d3e821614f$var$ne.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$jt.toHex32(this.h, "big") : $17d123d3e821614f$var$jt.split32(this.h, "big");
};
function $17d123d3e821614f$var$la(e, t, r, i, n) {
    var o = e & r ^ ~e & n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$da(e, t, r, i, n, o) {
    var h = t & i ^ ~t & o;
    return h < 0 && (h += 4294967296), h;
}
function $17d123d3e821614f$var$pa(e, t, r, i, n) {
    var o = e & r ^ e & n ^ r & n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$va(e, t, r, i, n, o) {
    var h = t & i ^ t & o ^ i & o;
    return h < 0 && (h += 4294967296), h;
}
function $17d123d3e821614f$var$ma(e, t) {
    var r = $17d123d3e821614f$var$le(e, t, 28), i = $17d123d3e821614f$var$le(t, e, 2), n = $17d123d3e821614f$var$le(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$ga(e, t) {
    var r = $17d123d3e821614f$var$de(e, t, 28), i = $17d123d3e821614f$var$de(t, e, 2), n = $17d123d3e821614f$var$de(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$Aa(e, t) {
    var r = $17d123d3e821614f$var$le(e, t, 14), i = $17d123d3e821614f$var$le(e, t, 18), n = $17d123d3e821614f$var$le(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$ba(e, t) {
    var r = $17d123d3e821614f$var$de(e, t, 14), i = $17d123d3e821614f$var$de(e, t, 18), n = $17d123d3e821614f$var$de(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$ya(e, t) {
    var r = $17d123d3e821614f$var$le(e, t, 1), i = $17d123d3e821614f$var$le(e, t, 8), n = $17d123d3e821614f$var$yf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$wa(e, t) {
    var r = $17d123d3e821614f$var$de(e, t, 1), i = $17d123d3e821614f$var$de(e, t, 8), n = $17d123d3e821614f$var$wf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$xa(e, t) {
    var r = $17d123d3e821614f$var$le(e, t, 19), i = $17d123d3e821614f$var$le(t, e, 29), n = $17d123d3e821614f$var$yf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $17d123d3e821614f$var$Ma(e, t) {
    var r = $17d123d3e821614f$var$de(e, t, 19), i = $17d123d3e821614f$var$de(t, e, 29), n = $17d123d3e821614f$var$wf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
var $17d123d3e821614f$var$Oi = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Ef = $17d123d3e821614f$var$Mf;
function $17d123d3e821614f$var$we() {
    if (!(this instanceof $17d123d3e821614f$var$we)) return new $17d123d3e821614f$var$we;
    $17d123d3e821614f$var$Ef.call(this), this.h = [
        3418070365,
        3238371032,
        1654270250,
        914150663,
        2438529370,
        812702999,
        355462360,
        4144912697,
        1731405415,
        4290775857,
        2394180231,
        1750603025,
        3675008525,
        1694076839,
        1203062813,
        3204075428
    ];
}
$17d123d3e821614f$var$Oi.inherits($17d123d3e821614f$var$we, $17d123d3e821614f$var$Ef);
var $17d123d3e821614f$var$Ea = $17d123d3e821614f$var$we;
$17d123d3e821614f$var$we.blockSize = 1024, $17d123d3e821614f$var$we.outSize = 384, $17d123d3e821614f$var$we.hmacStrength = 192, $17d123d3e821614f$var$we.padLength = 128, $17d123d3e821614f$var$we.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$Oi.toHex32(this.h.slice(0, 12), "big") : $17d123d3e821614f$var$Oi.split32(this.h.slice(0, 12), "big");
}, $17d123d3e821614f$var$or.sha1 = $17d123d3e821614f$var$Js, $17d123d3e821614f$var$or.sha224 = $17d123d3e821614f$var$na, $17d123d3e821614f$var$or.sha256 = $17d123d3e821614f$var$Af, $17d123d3e821614f$var$or.sha384 = $17d123d3e821614f$var$Ea, $17d123d3e821614f$var$or.sha512 = $17d123d3e821614f$var$Mf;
var $17d123d3e821614f$var$Sf = {}, $17d123d3e821614f$var$Xe = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Sa = $17d123d3e821614f$var$fr, $17d123d3e821614f$var$Tr = $17d123d3e821614f$var$Xe.rotl32, $17d123d3e821614f$var$Nf = $17d123d3e821614f$var$Xe.sum32, $17d123d3e821614f$var$xr = $17d123d3e821614f$var$Xe.sum32_3, $17d123d3e821614f$var$If = $17d123d3e821614f$var$Xe.sum32_4, $17d123d3e821614f$var$_f = $17d123d3e821614f$var$Sa.BlockHash;
function $17d123d3e821614f$var$pe() {
    if (!(this instanceof $17d123d3e821614f$var$pe)) return new $17d123d3e821614f$var$pe;
    $17d123d3e821614f$var$_f.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.endian = "little";
}
$17d123d3e821614f$var$Xe.inherits($17d123d3e821614f$var$pe, $17d123d3e821614f$var$_f), $17d123d3e821614f$var$Sf.ripemd160 = $17d123d3e821614f$var$pe, $17d123d3e821614f$var$pe.blockSize = 512, $17d123d3e821614f$var$pe.outSize = 160, $17d123d3e821614f$var$pe.hmacStrength = 192, $17d123d3e821614f$var$pe.padLength = 64, $17d123d3e821614f$var$pe.prototype._update = function(t, r) {
    for(var i = this.h[0], n = this.h[1], o = this.h[2], h = this.h[3], p = this.h[4], b = i, m = n, w = o, y = h, S = p, I = 0; I < 80; I++){
        var N = $17d123d3e821614f$var$Nf($17d123d3e821614f$var$Tr($17d123d3e821614f$var$If(i, $17d123d3e821614f$var$Bf(I, n, o, h), t[$17d123d3e821614f$var$_a[I] + r], $17d123d3e821614f$var$Na(I)), $17d123d3e821614f$var$Ca[I]), p);
        i = p, p = h, h = $17d123d3e821614f$var$Tr(o, 10), o = n, n = N, N = $17d123d3e821614f$var$Nf($17d123d3e821614f$var$Tr($17d123d3e821614f$var$If(b, $17d123d3e821614f$var$Bf(79 - I, m, w, y), t[$17d123d3e821614f$var$Ba[I] + r], $17d123d3e821614f$var$Ia(I)), $17d123d3e821614f$var$Ra[I]), S), b = S, S = y, y = $17d123d3e821614f$var$Tr(w, 10), w = m, m = N;
    }
    N = $17d123d3e821614f$var$xr(this.h[1], o, y), this.h[1] = $17d123d3e821614f$var$xr(this.h[2], h, S), this.h[2] = $17d123d3e821614f$var$xr(this.h[3], p, b), this.h[3] = $17d123d3e821614f$var$xr(this.h[4], i, m), this.h[4] = $17d123d3e821614f$var$xr(this.h[0], n, w), this.h[0] = N;
}, $17d123d3e821614f$var$pe.prototype._digest = function(t) {
    return t === "hex" ? $17d123d3e821614f$var$Xe.toHex32(this.h, "little") : $17d123d3e821614f$var$Xe.split32(this.h, "little");
};
function $17d123d3e821614f$var$Bf(e, t, r, i) {
    return e <= 15 ? t ^ r ^ i : e <= 31 ? t & r | ~t & i : e <= 47 ? (t | ~r) ^ i : e <= 63 ? t & i | r & ~i : t ^ (r | ~i);
}
function $17d123d3e821614f$var$Na(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function $17d123d3e821614f$var$Ia(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var $17d123d3e821614f$var$_a = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
], $17d123d3e821614f$var$Ba = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
], $17d123d3e821614f$var$Ca = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
], $17d123d3e821614f$var$Ra = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
], $17d123d3e821614f$var$Oa = $17d123d3e821614f$var$Q, $17d123d3e821614f$var$Pa = $17d123d3e821614f$var$yr;
function $17d123d3e821614f$var$hr(e, t, r) {
    if (!(this instanceof $17d123d3e821614f$var$hr)) return new $17d123d3e821614f$var$hr(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init($17d123d3e821614f$var$Oa.toArray(t, r));
}
var $17d123d3e821614f$var$Da = $17d123d3e821614f$var$hr;
$17d123d3e821614f$var$hr.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), $17d123d3e821614f$var$Pa(t.length <= this.blockSize);
    for(var r = t.length; r < this.blockSize; r++)t.push(0);
    for(r = 0; r < t.length; r++)t[r] ^= 54;
    for(this.inner = new this.Hash().update(t), r = 0; r < t.length; r++)t[r] ^= 106;
    this.outer = new this.Hash().update(t);
}, $17d123d3e821614f$var$hr.prototype.update = function(t, r) {
    return this.inner.update(t, r), this;
}, $17d123d3e821614f$var$hr.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
}, function(e) {
    var t = e;
    t.utils = $17d123d3e821614f$var$Q, t.common = $17d123d3e821614f$var$fr, t.sha = $17d123d3e821614f$var$or, t.ripemd = $17d123d3e821614f$var$Sf, t.hmac = $17d123d3e821614f$var$Da, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
}($17d123d3e821614f$var$se);
function $17d123d3e821614f$var$cr(e, t, r) {
    return r = {
        path: t,
        exports: {},
        require: function(i, n) {
            return $17d123d3e821614f$var$Fa(i, n ?? r.path);
        }
    }, e(r, r.exports), r.exports;
}
function $17d123d3e821614f$var$Fa() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $17d123d3e821614f$var$Pi = $17d123d3e821614f$var$Cf;
function $17d123d3e821614f$var$Cf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$17d123d3e821614f$var$Cf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $17d123d3e821614f$var$fe = $17d123d3e821614f$var$cr(function(e, t) {
    var r = t;
    function i(h, p) {
        if (Array.isArray(h)) return h.slice();
        if (!h) return [];
        var b = [];
        if (typeof h != "string") {
            for(var m = 0; m < h.length; m++)b[m] = h[m] | 0;
            return b;
        }
        if (p === "hex") {
            h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
            for(var m = 0; m < h.length; m += 2)b.push(parseInt(h[m] + h[m + 1], 16));
        } else for(var m = 0; m < h.length; m++){
            var w = h.charCodeAt(m), y = w >> 8, S = w & 255;
            y ? b.push(y, S) : b.push(S);
        }
        return b;
    }
    r.toArray = i;
    function n(h) {
        return h.length === 1 ? "0" + h : h;
    }
    r.zero2 = n;
    function o(h) {
        for(var p = "", b = 0; b < h.length; b++)p += n(h[b].toString(16));
        return p;
    }
    r.toHex = o, r.encode = function(p, b) {
        return b === "hex" ? o(p) : p;
    };
}), $17d123d3e821614f$var$Jt = $17d123d3e821614f$var$cr(function(e, t) {
    var r = t;
    r.assert = $17d123d3e821614f$var$Pi, r.toArray = $17d123d3e821614f$var$fe.toArray, r.zero2 = $17d123d3e821614f$var$fe.zero2, r.toHex = $17d123d3e821614f$var$fe.toHex, r.encode = $17d123d3e821614f$var$fe.encode;
    function i(b, m, w) {
        var y = new Array(Math.max(b.bitLength(), w) + 1);
        y.fill(0);
        for(var S = 1 << m + 1, I = b.clone(), N = 0; N < y.length; N++){
            var C, F = I.andln(S - 1);
            I.isOdd() ? (F > (S >> 1) - 1 ? C = (S >> 1) - F : C = F, I.isubn(C)) : C = 0, y[N] = C, I.iushrn(1);
        }
        return y;
    }
    r.getNAF = i;
    function n(b, m) {
        var w = [
            [],
            []
        ];
        b = b.clone(), m = m.clone();
        for(var y = 0, S = 0, I; b.cmpn(-y) > 0 || m.cmpn(-S) > 0;){
            var N = b.andln(3) + y & 3, C = m.andln(3) + S & 3;
            N === 3 && (N = -1), C === 3 && (C = -1);
            var F;
            N & 1 ? (I = b.andln(7) + y & 7, (I === 3 || I === 5) && C === 2 ? F = -N : F = N) : F = 0, w[0].push(F);
            var U;
            C & 1 ? (I = m.andln(7) + S & 7, (I === 3 || I === 5) && N === 2 ? U = -C : U = C) : U = 0, w[1].push(U), 2 * y === F + 1 && (y = 1 - y), 2 * S === U + 1 && (S = 1 - S), b.iushrn(1), m.iushrn(1);
        }
        return w;
    }
    r.getJSF = n;
    function o(b, m, w) {
        var y = "_" + m;
        b.prototype[m] = function() {
            return this[y] !== void 0 ? this[y] : this[y] = w.call(this);
        };
    }
    r.cachedProperty = o;
    function h(b) {
        return typeof b == "string" ? r.toArray(b, "hex") : b;
    }
    r.parseBytes = h;
    function p(b) {
        return new $17d123d3e821614f$var$K(b, "hex", "le");
    }
    r.intFromLE = p;
}), $17d123d3e821614f$var$Ur = $17d123d3e821614f$var$Jt.getNAF, $17d123d3e821614f$var$Ta = $17d123d3e821614f$var$Jt.getJSF, $17d123d3e821614f$var$kr = $17d123d3e821614f$var$Jt.assert;
function $17d123d3e821614f$var$Ce(e, t) {
    this.type = e, this.p = new $17d123d3e821614f$var$K(t.p, 16), this.red = t.prime ? $17d123d3e821614f$var$K.red(t.prime) : $17d123d3e821614f$var$K.mont(this.p), this.zero = new $17d123d3e821614f$var$K(0).toRed(this.red), this.one = new $17d123d3e821614f$var$K(1).toRed(this.red), this.two = new $17d123d3e821614f$var$K(2).toRed(this.red), this.n = t.n && new $17d123d3e821614f$var$K(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $17d123d3e821614f$var$Ze = $17d123d3e821614f$var$Ce;
$17d123d3e821614f$var$Ce.prototype.point = function() {
    throw new Error("Not implemented");
}, $17d123d3e821614f$var$Ce.prototype.validate = function() {
    throw new Error("Not implemented");
}, $17d123d3e821614f$var$Ce.prototype._fixedNafMul = function(t, r) {
    $17d123d3e821614f$var$kr(t.precomputed);
    var i = t._getDoubles(), n = $17d123d3e821614f$var$Ur(r, 1, this._bitLength), o = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
    o /= 3;
    var h = [], p, b;
    for(p = 0; p < n.length; p += i.step){
        b = 0;
        for(var m = p + i.step - 1; m >= p; m--)b = (b << 1) + n[m];
        h.push(b);
    }
    for(var w = this.jpoint(null, null, null), y = this.jpoint(null, null, null), S = o; S > 0; S--){
        for(p = 0; p < h.length; p++)b = h[p], b === S ? y = y.mixedAdd(i.points[p]) : b === -S && (y = y.mixedAdd(i.points[p].neg()));
        w = w.add(y);
    }
    return w.toP();
}, $17d123d3e821614f$var$Ce.prototype._wnafMul = function(t, r) {
    var i = 4, n = t._getNAFPoints(i);
    i = n.wnd;
    for(var o = n.points, h = $17d123d3e821614f$var$Ur(r, i, this._bitLength), p = this.jpoint(null, null, null), b = h.length - 1; b >= 0; b--){
        for(var m = 0; b >= 0 && h[b] === 0; b--)m++;
        if (b >= 0 && m++, p = p.dblp(m), b < 0) break;
        var w = h[b];
        $17d123d3e821614f$var$kr(w !== 0), t.type === "affine" ? w > 0 ? p = p.mixedAdd(o[w - 1 >> 1]) : p = p.mixedAdd(o[-w - 1 >> 1].neg()) : w > 0 ? p = p.add(o[w - 1 >> 1]) : p = p.add(o[-w - 1 >> 1].neg());
    }
    return t.type === "affine" ? p.toP() : p;
}, $17d123d3e821614f$var$Ce.prototype._wnafMulAdd = function(t, r, i, n, o) {
    var h = this._wnafT1, p = this._wnafT2, b = this._wnafT3, m = 0, w, y, S;
    for(w = 0; w < n; w++){
        S = r[w];
        var I = S._getNAFPoints(t);
        h[w] = I.wnd, p[w] = I.points;
    }
    for(w = n - 1; w >= 1; w -= 2){
        var N = w - 1, C = w;
        if (h[N] !== 1 || h[C] !== 1) {
            b[N] = $17d123d3e821614f$var$Ur(i[N], h[N], this._bitLength), b[C] = $17d123d3e821614f$var$Ur(i[C], h[C], this._bitLength), m = Math.max(b[N].length, m), m = Math.max(b[C].length, m);
            continue;
        }
        var F = [
            r[N],
            null,
            null,
            r[C]
        ];
        r[N].y.cmp(r[C].y) === 0 ? (F[1] = r[N].add(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg())) : r[N].y.cmp(r[C].y.redNeg()) === 0 ? (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].add(r[C].neg())) : (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg()));
        var U = [
            -3,
            -1,
            -5,
            -7,
            0,
            7,
            5,
            1,
            3
        ], J = $17d123d3e821614f$var$Ta(i[N], i[C]);
        for(m = Math.max(J[0].length, m), b[N] = new Array(m), b[C] = new Array(m), y = 0; y < m; y++){
            var Bt = J[0][y] | 0, G = J[1][y] | 0;
            b[N][y] = U[(Bt + 1) * 3 + (G + 1)], b[C][y] = 0, p[N] = F;
        }
    }
    var H = this.jpoint(null, null, null), z = this._wnafT4;
    for(w = m; w >= 0; w--){
        for(var Pt = 0; w >= 0;){
            var W = !0;
            for(y = 0; y < n; y++)z[y] = b[y][w] | 0, z[y] !== 0 && (W = !1);
            if (!W) break;
            Pt++, w--;
        }
        if (w >= 0 && Pt++, H = H.dblp(Pt), w < 0) break;
        for(y = 0; y < n; y++){
            var Rt = z[y];
            Rt !== 0 && (Rt > 0 ? S = p[y][Rt - 1 >> 1] : Rt < 0 && (S = p[y][-Rt - 1 >> 1].neg()), S.type === "affine" ? H = H.mixedAdd(S) : H = H.add(S));
        }
    }
    for(w = 0; w < n; w++)p[w] = null;
    return o ? H : H.toP();
};
function $17d123d3e821614f$var$Xt(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
}
$17d123d3e821614f$var$Ce.BasePoint = $17d123d3e821614f$var$Xt, $17d123d3e821614f$var$Xt.prototype.eq = function() {
    throw new Error("Not implemented");
}, $17d123d3e821614f$var$Xt.prototype.validate = function() {
    return this.curve.validate(this);
}, $17d123d3e821614f$var$Ce.prototype.decodePoint = function(t, r) {
    t = $17d123d3e821614f$var$Jt.toArray(t, r);
    var i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * i) {
        t[0] === 6 ? $17d123d3e821614f$var$kr(t[t.length - 1] % 2 === 0) : t[0] === 7 && $17d123d3e821614f$var$kr(t[t.length - 1] % 2 === 1);
        var n = this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
        return n;
    } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
}, $17d123d3e821614f$var$Xt.prototype.encodeCompressed = function(t) {
    return this.encode(t, !0);
}, $17d123d3e821614f$var$Xt.prototype._encode = function(t) {
    var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
    return t ? [
        this.getY().isEven() ? 2 : 3
    ].concat(i) : [
        4
    ].concat(i, this.getY().toArray("be", r));
}, $17d123d3e821614f$var$Xt.prototype.encode = function(t, r) {
    return $17d123d3e821614f$var$Jt.encode(this._encode(r), t);
}, $17d123d3e821614f$var$Xt.prototype.precompute = function(t) {
    if (this.precomputed) return this;
    var r = {
        doubles: null,
        naf: null,
        beta: null
    };
    return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, t), r.beta = this._getBeta(), this.precomputed = r, this;
}, $17d123d3e821614f$var$Xt.prototype._hasDoubles = function(t) {
    if (!this.precomputed) return !1;
    var r = this.precomputed.doubles;
    return r ? r.points.length >= Math.ceil((t.bitLength() + 1) / r.step) : !1;
}, $17d123d3e821614f$var$Xt.prototype._getDoubles = function(t, r) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for(var i = [
        this
    ], n = this, o = 0; o < r; o += t){
        for(var h = 0; h < t; h++)n = n.dbl();
        i.push(n);
    }
    return {
        step: t,
        points: i
    };
}, $17d123d3e821614f$var$Xt.prototype._getNAFPoints = function(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for(var r = [
        this
    ], i = (1 << t) - 1, n = i === 1 ? null : this.dbl(), o = 1; o < i; o++)r[o] = r[o - 1].add(n);
    return {
        wnd: t,
        points: r
    };
}, $17d123d3e821614f$var$Xt.prototype._getBeta = function() {
    return null;
}, $17d123d3e821614f$var$Xt.prototype.dblp = function(t) {
    for(var r = this, i = 0; i < t; i++)r = r.dbl();
    return r;
};
var $17d123d3e821614f$var$Di = $17d123d3e821614f$var$cr(function(e) {
    typeof Object.create == "function" ? e.exports = function(r, i) {
        i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : e.exports = function(r, i) {
        if (i) {
            r.super_ = i;
            var n = function() {};
            n.prototype = i.prototype, r.prototype = new n, r.prototype.constructor = r;
        }
    };
}), $17d123d3e821614f$var$Ua = $17d123d3e821614f$var$Jt.assert;
function $17d123d3e821614f$var$Zt(e) {
    $17d123d3e821614f$var$Ze.call(this, "short", e), this.a = new $17d123d3e821614f$var$K(e.a, 16).toRed(this.red), this.b = new $17d123d3e821614f$var$K(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
$17d123d3e821614f$var$Di($17d123d3e821614f$var$Zt, $17d123d3e821614f$var$Ze);
var $17d123d3e821614f$var$ka = $17d123d3e821614f$var$Zt;
$17d123d3e821614f$var$Zt.prototype._getEndomorphism = function(t) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var r, i;
        if (t.beta) r = new $17d123d3e821614f$var$K(t.beta, 16).toRed(this.red);
        else {
            var n = this._getEndoRoots(this.p);
            r = n[0].cmp(n[1]) < 0 ? n[0] : n[1], r = r.toRed(this.red);
        }
        if (t.lambda) i = new $17d123d3e821614f$var$K(t.lambda, 16);
        else {
            var o = this._getEndoRoots(this.n);
            this.g.mul(o[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = o[0] : (i = o[1], $17d123d3e821614f$var$Ua(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
        }
        var h;
        return t.basis ? h = t.basis.map(function(p) {
            return {
                a: new $17d123d3e821614f$var$K(p.a, 16),
                b: new $17d123d3e821614f$var$K(p.b, 16)
            };
        }) : h = this._getEndoBasis(i), {
            beta: r,
            lambda: i,
            basis: h
        };
    }
}, $17d123d3e821614f$var$Zt.prototype._getEndoRoots = function(t) {
    var r = t === this.p ? this.red : $17d123d3e821614f$var$K.mont(t), i = new $17d123d3e821614f$var$K(2).toRed(r).redInvm(), n = i.redNeg(), o = new $17d123d3e821614f$var$K(3).toRed(r).redNeg().redSqrt().redMul(i), h = n.redAdd(o).fromRed(), p = n.redSub(o).fromRed();
    return [
        h,
        p
    ];
}, $17d123d3e821614f$var$Zt.prototype._getEndoBasis = function(t) {
    for(var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = t, n = this.n.clone(), o = new $17d123d3e821614f$var$K(1), h = new $17d123d3e821614f$var$K(0), p = new $17d123d3e821614f$var$K(0), b = new $17d123d3e821614f$var$K(1), m, w, y, S, I, N, C, F = 0, U, J; i.cmpn(0) !== 0;){
        var Bt = n.div(i);
        U = n.sub(Bt.mul(i)), J = p.sub(Bt.mul(o));
        var G = b.sub(Bt.mul(h));
        if (!y && U.cmp(r) < 0) m = C.neg(), w = o, y = U.neg(), S = J;
        else if (y && ++F === 2) break;
        C = U, n = i, i = U, p = o, o = J, b = h, h = G;
    }
    I = U.neg(), N = J;
    var H = y.sqr().add(S.sqr()), z = I.sqr().add(N.sqr());
    return z.cmp(H) >= 0 && (I = m, N = w), y.negative && (y = y.neg(), S = S.neg()), I.negative && (I = I.neg(), N = N.neg()), [
        {
            a: y,
            b: S
        },
        {
            a: I,
            b: N
        }
    ];
}, $17d123d3e821614f$var$Zt.prototype._endoSplit = function(t) {
    var r = this.endo.basis, i = r[0], n = r[1], o = n.b.mul(t).divRound(this.n), h = i.b.neg().mul(t).divRound(this.n), p = o.mul(i.a), b = h.mul(n.a), m = o.mul(i.b), w = h.mul(n.b), y = t.sub(p).sub(b), S = m.add(w).neg();
    return {
        k1: y,
        k2: S
    };
}, $17d123d3e821614f$var$Zt.prototype.pointFromX = function(t, r) {
    t = new $17d123d3e821614f$var$K(t, 16), t.red || (t = t.toRed(this.red));
    var i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), n = i.redSqrt();
    if (n.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    var o = n.fromRed().isOdd();
    return (r && !o || !r && o) && (n = n.redNeg()), this.point(t, n);
}, $17d123d3e821614f$var$Zt.prototype.validate = function(t) {
    if (t.inf) return !0;
    var r = t.x, i = t.y, n = this.a.redMul(r), o = r.redSqr().redMul(r).redIAdd(n).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
}, $17d123d3e821614f$var$Zt.prototype._endoWnafMulAdd = function(t, r, i) {
    for(var n = this._endoWnafT1, o = this._endoWnafT2, h = 0; h < t.length; h++){
        var p = this._endoSplit(r[h]), b = t[h], m = b._getBeta();
        p.k1.negative && (p.k1.ineg(), b = b.neg(!0)), p.k2.negative && (p.k2.ineg(), m = m.neg(!0)), n[h * 2] = b, n[h * 2 + 1] = m, o[h * 2] = p.k1, o[h * 2 + 1] = p.k2;
    }
    for(var w = this._wnafMulAdd(1, n, o, h * 2, i), y = 0; y < h * 2; y++)n[y] = null, o[y] = null;
    return w;
};
function $17d123d3e821614f$var$Ft(e, t, r, i) {
    $17d123d3e821614f$var$Ze.BasePoint.call(this, e, "affine"), t === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $17d123d3e821614f$var$K(t, 16), this.y = new $17d123d3e821614f$var$K(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
$17d123d3e821614f$var$Di($17d123d3e821614f$var$Ft, $17d123d3e821614f$var$Ze.BasePoint), $17d123d3e821614f$var$Zt.prototype.point = function(t, r, i) {
    return new $17d123d3e821614f$var$Ft(this, t, r, i);
}, $17d123d3e821614f$var$Zt.prototype.pointFromJSON = function(t, r) {
    return $17d123d3e821614f$var$Ft.fromJSON(this, t, r);
}, $17d123d3e821614f$var$Ft.prototype._getBeta = function() {
    if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (t) {
            var i = this.curve, n = function(o) {
                return i.point(o.x.redMul(i.endo.beta), o.y);
            };
            t.beta = r, r.precomputed = {
                beta: null,
                naf: t.naf && {
                    wnd: t.naf.wnd,
                    points: t.naf.points.map(n)
                },
                doubles: t.doubles && {
                    step: t.doubles.step,
                    points: t.doubles.points.map(n)
                }
            };
        }
        return r;
    }
}, $17d123d3e821614f$var$Ft.prototype.toJSON = function() {
    return this.precomputed ? [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ] : [
        this.x,
        this.y
    ];
}, $17d123d3e821614f$var$Ft.fromJSON = function(t, r, i) {
    typeof r == "string" && (r = JSON.parse(r));
    var n = t.point(r[0], r[1], i);
    if (!r[2]) return n;
    function o(p) {
        return t.point(p[0], p[1], i);
    }
    var h = r[2];
    return n.precomputed = {
        beta: null,
        doubles: h.doubles && {
            step: h.doubles.step,
            points: [
                n
            ].concat(h.doubles.points.map(o))
        },
        naf: h.naf && {
            wnd: h.naf.wnd,
            points: [
                n
            ].concat(h.naf.points.map(o))
        }
    }, n;
}, $17d123d3e821614f$var$Ft.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, $17d123d3e821614f$var$Ft.prototype.isInfinity = function() {
    return this.inf;
}, $17d123d3e821614f$var$Ft.prototype.add = function(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    var r = this.y.redSub(t.y);
    r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(t.x).redInvm()));
    var i = r.redSqr().redISub(this.x).redISub(t.x), n = r.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, n);
}, $17d123d3e821614f$var$Ft.prototype.dbl = function() {
    if (this.inf) return this;
    var t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    var r = this.curve.a, i = this.x.redSqr(), n = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(n), h = o.redSqr().redISub(this.x.redAdd(this.x)), p = o.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, p);
}, $17d123d3e821614f$var$Ft.prototype.getX = function() {
    return this.x.fromRed();
}, $17d123d3e821614f$var$Ft.prototype.getY = function() {
    return this.y.fromRed();
}, $17d123d3e821614f$var$Ft.prototype.mul = function(t) {
    return t = new $17d123d3e821614f$var$K(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([
        this
    ], [
        t
    ]) : this.curve._wnafMul(this, t);
}, $17d123d3e821614f$var$Ft.prototype.mulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o) : this.curve._wnafMulAdd(1, n, o, 2);
}, $17d123d3e821614f$var$Ft.prototype.jmulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o, !0) : this.curve._wnafMulAdd(1, n, o, 2, !0);
}, $17d123d3e821614f$var$Ft.prototype.eq = function(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
}, $17d123d3e821614f$var$Ft.prototype.neg = function(t) {
    if (this.inf) return this;
    var r = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
        var i = this.precomputed, n = function(o) {
            return o.neg();
        };
        r.precomputed = {
            naf: i.naf && {
                wnd: i.naf.wnd,
                points: i.naf.points.map(n)
            },
            doubles: i.doubles && {
                step: i.doubles.step,
                points: i.doubles.points.map(n)
            }
        };
    }
    return r;
}, $17d123d3e821614f$var$Ft.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var t = this.curve.jpoint(this.x, this.y, this.curve.one);
    return t;
};
function $17d123d3e821614f$var$Tt(e, t, r, i) {
    $17d123d3e821614f$var$Ze.BasePoint.call(this, e, "jacobian"), t === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $17d123d3e821614f$var$K(0)) : (this.x = new $17d123d3e821614f$var$K(t, 16), this.y = new $17d123d3e821614f$var$K(r, 16), this.z = new $17d123d3e821614f$var$K(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
$17d123d3e821614f$var$Di($17d123d3e821614f$var$Tt, $17d123d3e821614f$var$Ze.BasePoint), $17d123d3e821614f$var$Zt.prototype.jpoint = function(t, r, i) {
    return new $17d123d3e821614f$var$Tt(this, t, r, i);
}, $17d123d3e821614f$var$Tt.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var t = this.z.redInvm(), r = t.redSqr(), i = this.x.redMul(r), n = this.y.redMul(r).redMul(t);
    return this.curve.point(i, n);
}, $17d123d3e821614f$var$Tt.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, $17d123d3e821614f$var$Tt.prototype.add = function(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var r = t.z.redSqr(), i = this.z.redSqr(), n = this.x.redMul(r), o = t.x.redMul(i), h = this.y.redMul(r.redMul(t.z)), p = t.y.redMul(i.redMul(this.z)), b = n.redSub(o), m = h.redSub(p);
    if (b.cmpn(0) === 0) return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var w = b.redSqr(), y = w.redMul(b), S = n.redMul(w), I = m.redSqr().redIAdd(y).redISub(S).redISub(S), N = m.redMul(S.redISub(I)).redISub(h.redMul(y)), C = this.z.redMul(t.z).redMul(b);
    return this.curve.jpoint(I, N, C);
}, $17d123d3e821614f$var$Tt.prototype.mixedAdd = function(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    var r = this.z.redSqr(), i = this.x, n = t.x.redMul(r), o = this.y, h = t.y.redMul(r).redMul(this.z), p = i.redSub(n), b = o.redSub(h);
    if (p.cmpn(0) === 0) return b.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = p.redSqr(), w = m.redMul(p), y = i.redMul(m), S = b.redSqr().redIAdd(w).redISub(y).redISub(y), I = b.redMul(y.redISub(S)).redISub(o.redMul(w)), N = this.z.redMul(p);
    return this.curve.jpoint(S, I, N);
}, $17d123d3e821614f$var$Tt.prototype.dblp = function(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    var r;
    if (this.curve.zeroA || this.curve.threeA) {
        var i = this;
        for(r = 0; r < t; r++)i = i.dbl();
        return i;
    }
    var n = this.curve.a, o = this.curve.tinv, h = this.x, p = this.y, b = this.z, m = b.redSqr().redSqr(), w = p.redAdd(p);
    for(r = 0; r < t; r++){
        var y = h.redSqr(), S = w.redSqr(), I = S.redSqr(), N = y.redAdd(y).redIAdd(y).redIAdd(n.redMul(m)), C = h.redMul(S), F = N.redSqr().redISub(C.redAdd(C)), U = C.redISub(F), J = N.redMul(U);
        J = J.redIAdd(J).redISub(I);
        var Bt = w.redMul(b);
        r + 1 < t && (m = m.redMul(I)), h = F, b = Bt, w = J;
    }
    return this.curve.jpoint(h, w.redMul(o), b);
}, $17d123d3e821614f$var$Tt.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, $17d123d3e821614f$var$Tt.prototype._zeroDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n), m = b.redSqr().redISub(p).redISub(p), w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), t = m, r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.x.redSqr(), S = this.y.redSqr(), I = S.redSqr(), N = this.x.redAdd(S).redSqr().redISub(y).redISub(I);
        N = N.redIAdd(N);
        var C = y.redAdd(y).redIAdd(y), F = C.redSqr(), U = I.redIAdd(I);
        U = U.redIAdd(U), U = U.redIAdd(U), t = F.redISub(N).redISub(N), r = C.redMul(N.redISub(t)).redISub(U), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, r, i);
}, $17d123d3e821614f$var$Tt.prototype._threeDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), m = b.redSqr().redISub(p).redISub(p);
        t = m;
        var w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.z.redSqr(), S = this.y.redSqr(), I = this.x.redMul(S), N = this.x.redSub(y).redMul(this.x.redAdd(y));
        N = N.redAdd(N).redIAdd(N);
        var C = I.redIAdd(I);
        C = C.redIAdd(C);
        var F = C.redAdd(C);
        t = N.redSqr().redISub(F), i = this.y.redAdd(this.z).redSqr().redISub(S).redISub(y);
        var U = S.redSqr();
        U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), r = N.redMul(C.redISub(t)).redISub(U);
    }
    return this.curve.jpoint(t, r, i);
}, $17d123d3e821614f$var$Tt.prototype._dbl = function() {
    var t = this.curve.a, r = this.x, i = this.y, n = this.z, o = n.redSqr().redSqr(), h = r.redSqr(), p = i.redSqr(), b = h.redAdd(h).redIAdd(h).redIAdd(t.redMul(o)), m = r.redAdd(r);
    m = m.redIAdd(m);
    var w = m.redMul(p), y = b.redSqr().redISub(w.redAdd(w)), S = w.redISub(y), I = p.redSqr();
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = b.redMul(S).redISub(I), C = i.redAdd(i).redMul(n);
    return this.curve.jpoint(y, N, C);
}, $17d123d3e821614f$var$Tt.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var t = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), n = r.redSqr(), o = t.redAdd(t).redIAdd(t), h = o.redSqr(), p = this.x.redAdd(r).redSqr().redISub(t).redISub(n);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(h);
    var b = p.redSqr(), m = n.redIAdd(n);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var w = o.redIAdd(p).redSqr().redISub(h).redISub(b).redISub(m), y = r.redMul(w);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var S = this.x.redMul(b).redISub(y);
    S = S.redIAdd(S), S = S.redIAdd(S);
    var I = this.y.redMul(w.redMul(m.redISub(w)).redISub(p.redMul(b)));
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = this.z.redAdd(p).redSqr().redISub(i).redISub(b);
    return this.curve.jpoint(S, I, N);
}, $17d123d3e821614f$var$Tt.prototype.mul = function(t, r) {
    return t = new $17d123d3e821614f$var$K(t, r), this.curve._wnafMul(this, t);
}, $17d123d3e821614f$var$Tt.prototype.eq = function(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    var r = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(r)).cmpn(0) !== 0) return !1;
    var n = r.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(n)).cmpn(0) === 0;
}, $17d123d3e821614f$var$Tt.prototype.eqXToP = function(t) {
    var r = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(r);
    if (this.x.cmp(i) === 0) return !0;
    for(var n = t.clone(), o = this.curve.redN.redMul(r);;){
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
}, $17d123d3e821614f$var$Tt.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, $17d123d3e821614f$var$Tt.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
};
var $17d123d3e821614f$var$qr = $17d123d3e821614f$var$cr(function(e, t) {
    var r = t;
    r.base = $17d123d3e821614f$var$Ze, r.short = $17d123d3e821614f$var$ka, r.mont = null, r.edwards = null;
}), $17d123d3e821614f$var$Kr = $17d123d3e821614f$var$cr(function(e, t) {
    var r = t, i = $17d123d3e821614f$var$Jt.assert;
    function n(p) {
        p.type === "short" ? this.curve = new $17d123d3e821614f$var$qr.short(p) : p.type === "edwards" ? this.curve = new $17d123d3e821614f$var$qr.edwards(p) : this.curve = new $17d123d3e821614f$var$qr.mont(p), this.g = this.curve.g, this.n = this.curve.n, this.hash = p.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = n;
    function o(p, b) {
        Object.defineProperty(r, p, {
            configurable: !0,
            enumerable: !0,
            get: function() {
                var m = new n(b);
                return Object.defineProperty(r, p, {
                    configurable: !0,
                    enumerable: !0,
                    value: m
                }), m;
            }
        });
    }
    o("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: $17d123d3e821614f$var$se.sha256,
        gRed: !1,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    }), o("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: $17d123d3e821614f$var$se.sha256,
        gRed: !1,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    }), o("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: $17d123d3e821614f$var$se.sha256,
        gRed: !1,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    }), o("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $17d123d3e821614f$var$se.sha384,
        gRed: !1,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    }), o("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $17d123d3e821614f$var$se.sha512,
        gRed: !1,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    }), o("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $17d123d3e821614f$var$se.sha256,
        gRed: !1,
        g: [
            "9"
        ]
    }), o("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $17d123d3e821614f$var$se.sha256,
        gRed: !1,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var h;
    try {
        h = null.crash();
    } catch  {
        h = void 0;
    }
    o("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: $17d123d3e821614f$var$se.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: !1,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            h
        ]
    });
});
function $17d123d3e821614f$var$Re(e) {
    if (!(this instanceof $17d123d3e821614f$var$Re)) return new $17d123d3e821614f$var$Re(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = $17d123d3e821614f$var$fe.toArray(e.entropy, e.entropyEnc || "hex"), r = $17d123d3e821614f$var$fe.toArray(e.nonce, e.nonceEnc || "hex"), i = $17d123d3e821614f$var$fe.toArray(e.pers, e.persEnc || "hex");
    $17d123d3e821614f$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, i);
}
var $17d123d3e821614f$var$Rf = $17d123d3e821614f$var$Re;
$17d123d3e821614f$var$Re.prototype._init = function(t, r, i) {
    var n = t.concat(r).concat(i);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for(var o = 0; o < this.V.length; o++)this.K[o] = 0, this.V[o] = 1;
    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
}, $17d123d3e821614f$var$Re.prototype._hmac = function() {
    return new $17d123d3e821614f$var$se.hmac(this.hash, this.K);
}, $17d123d3e821614f$var$Re.prototype._update = function(t) {
    var r = this._hmac().update(this.V).update([
        0
    ]);
    t && (r = r.update(t)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([
        1
    ]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
}, $17d123d3e821614f$var$Re.prototype.reseed = function(t, r, i, n) {
    typeof r != "string" && (n = i, i = r, r = null), t = $17d123d3e821614f$var$fe.toArray(t, r), i = $17d123d3e821614f$var$fe.toArray(i, n), $17d123d3e821614f$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(i || [])), this._reseed = 1;
}, $17d123d3e821614f$var$Re.prototype.generate = function(t, r, i, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    typeof r != "string" && (n = i, i = r, r = null), i && (i = $17d123d3e821614f$var$fe.toArray(i, n || "hex"), this._update(i));
    for(var o = []; o.length < t;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    var h = o.slice(0, t);
    return this._update(i), this._reseed++, $17d123d3e821614f$var$fe.encode(h, r);
};
var $17d123d3e821614f$var$Fi = $17d123d3e821614f$var$Jt.assert;
function $17d123d3e821614f$var$kt(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var $17d123d3e821614f$var$Ti = $17d123d3e821614f$var$kt;
$17d123d3e821614f$var$kt.fromPublic = function(t, r, i) {
    return r instanceof $17d123d3e821614f$var$kt ? r : new $17d123d3e821614f$var$kt(t, {
        pub: r,
        pubEnc: i
    });
}, $17d123d3e821614f$var$kt.fromPrivate = function(t, r, i) {
    return r instanceof $17d123d3e821614f$var$kt ? r : new $17d123d3e821614f$var$kt(t, {
        priv: r,
        privEnc: i
    });
}, $17d123d3e821614f$var$kt.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
    } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
    } : {
        result: !1,
        reason: "Public key * N != O"
    } : {
        result: !1,
        reason: "Public key is not a point"
    };
}, $17d123d3e821614f$var$kt.prototype.getPublic = function(t, r) {
    return typeof t == "string" && (r = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, t) : this.pub;
}, $17d123d3e821614f$var$kt.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
}, $17d123d3e821614f$var$kt.prototype._importPrivate = function(t, r) {
    this.priv = new $17d123d3e821614f$var$K(t, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, $17d123d3e821614f$var$kt.prototype._importPublic = function(t, r) {
    if (t.x || t.y) {
        this.ec.curve.type === "mont" ? $17d123d3e821614f$var$Fi(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && $17d123d3e821614f$var$Fi(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(t, r);
}, $17d123d3e821614f$var$kt.prototype.derive = function(t) {
    return t.validate() || $17d123d3e821614f$var$Fi(t.validate(), "public point not validated"), t.mul(this.priv).getX();
}, $17d123d3e821614f$var$kt.prototype.sign = function(t, r, i) {
    return this.ec.sign(t, this, r, i);
}, $17d123d3e821614f$var$kt.prototype.verify = function(t, r) {
    return this.ec.verify(t, r, this);
}, $17d123d3e821614f$var$kt.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var $17d123d3e821614f$var$qa = $17d123d3e821614f$var$Jt.assert;
function $17d123d3e821614f$var$Hr(e, t) {
    if (e instanceof $17d123d3e821614f$var$Hr) return e;
    this._importDER(e, t) || ($17d123d3e821614f$var$qa(e.r && e.s, "Signature without r or s"), this.r = new $17d123d3e821614f$var$K(e.r, 16), this.s = new $17d123d3e821614f$var$K(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var $17d123d3e821614f$var$zr = $17d123d3e821614f$var$Hr;
function $17d123d3e821614f$var$Ka() {
    this.place = 0;
}
function $17d123d3e821614f$var$Ui(e, t) {
    var r = e[t.place++];
    if (!(r & 128)) return r;
    var i = r & 15;
    if (i === 0 || i > 4) return !1;
    for(var n = 0, o = 0, h = t.place; o < i; o++, h++)n <<= 8, n |= e[h], n >>>= 0;
    return n <= 127 ? !1 : (t.place = h, n);
}
function $17d123d3e821614f$var$Of(e) {
    for(var t = 0, r = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < r;)t++;
    return t === 0 ? e : e.slice(t);
}
$17d123d3e821614f$var$Hr.prototype._importDER = function(t, r) {
    t = $17d123d3e821614f$var$Jt.toArray(t, r);
    var i = new $17d123d3e821614f$var$Ka;
    if (t[i.place++] !== 48) return !1;
    var n = $17d123d3e821614f$var$Ui(t, i);
    if (n === !1 || n + i.place !== t.length || t[i.place++] !== 2) return !1;
    var o = $17d123d3e821614f$var$Ui(t, i);
    if (o === !1) return !1;
    var h = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    var p = $17d123d3e821614f$var$Ui(t, i);
    if (p === !1 || t.length !== p + i.place) return !1;
    var b = t.slice(i.place, p + i.place);
    if (h[0] === 0) {
        if (h[1] & 128) h = h.slice(1);
        else return !1;
    }
    if (b[0] === 0) {
        if (b[1] & 128) b = b.slice(1);
        else return !1;
    }
    return this.r = new $17d123d3e821614f$var$K(h), this.s = new $17d123d3e821614f$var$K(b), this.recoveryParam = null, !0;
};
function $17d123d3e821614f$var$ki(e, t) {
    if (t < 128) {
        e.push(t);
        return;
    }
    var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
    for(e.push(r | 128); --r;)e.push(t >>> (r << 3) & 255);
    e.push(t);
}
$17d123d3e821614f$var$Hr.prototype.toDER = function(t) {
    var r = this.r.toArray(), i = this.s.toArray();
    for(r[0] & 128 && (r = [
        0
    ].concat(r)), i[0] & 128 && (i = [
        0
    ].concat(i)), r = $17d123d3e821614f$var$Of(r), i = $17d123d3e821614f$var$Of(i); !i[0] && !(i[1] & 128);)i = i.slice(1);
    var n = [
        2
    ];
    $17d123d3e821614f$var$ki(n, r.length), n = n.concat(r), n.push(2), $17d123d3e821614f$var$ki(n, i.length);
    var o = n.concat(i), h = [
        48
    ];
    return $17d123d3e821614f$var$ki(h, o.length), h = h.concat(o), $17d123d3e821614f$var$Jt.encode(h, t);
};
var $17d123d3e821614f$var$Ha = function() {
    throw new Error("unsupported");
}, $17d123d3e821614f$var$Pf = $17d123d3e821614f$var$Jt.assert;
function $17d123d3e821614f$var$$t(e) {
    if (!(this instanceof $17d123d3e821614f$var$$t)) return new $17d123d3e821614f$var$$t(e);
    typeof e == "string" && ($17d123d3e821614f$var$Pf(Object.prototype.hasOwnProperty.call($17d123d3e821614f$var$Kr, e), "Unknown curve " + e), e = $17d123d3e821614f$var$Kr[e]), e instanceof $17d123d3e821614f$var$Kr.PresetCurve && (e = {
        curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var $17d123d3e821614f$var$za = $17d123d3e821614f$var$$t;
$17d123d3e821614f$var$$t.prototype.keyPair = function(t) {
    return new $17d123d3e821614f$var$Ti(this, t);
}, $17d123d3e821614f$var$$t.prototype.keyFromPrivate = function(t, r) {
    return $17d123d3e821614f$var$Ti.fromPrivate(this, t, r);
}, $17d123d3e821614f$var$$t.prototype.keyFromPublic = function(t, r) {
    return $17d123d3e821614f$var$Ti.fromPublic(this, t, r);
}, $17d123d3e821614f$var$$t.prototype.genKeyPair = function(t) {
    t || (t = {});
    for(var r = new $17d123d3e821614f$var$Rf({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || $17d123d3e821614f$var$Ha(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
    }), i = this.n.byteLength(), n = this.n.sub(new $17d123d3e821614f$var$K(2));;){
        var o = new $17d123d3e821614f$var$K(r.generate(i));
        if (!(o.cmp(n) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
}, $17d123d3e821614f$var$$t.prototype._truncateToN = function(t, r) {
    var i = t.byteLength() * 8 - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !r && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
}, $17d123d3e821614f$var$$t.prototype.sign = function(t, r, i, n) {
    typeof i == "object" && (n = i, i = null), n || (n = {}), r = this.keyFromPrivate(r, i), t = this._truncateToN(new $17d123d3e821614f$var$K(t, 16));
    for(var o = this.n.byteLength(), h = r.getPrivate().toArray("be", o), p = t.toArray("be", o), b = new $17d123d3e821614f$var$Rf({
        hash: this.hash,
        entropy: h,
        nonce: p,
        pers: n.pers,
        persEnc: n.persEnc || "utf8"
    }), m = this.n.sub(new $17d123d3e821614f$var$K(1)), w = 0;; w++){
        var y = n.k ? n.k(w) : new $17d123d3e821614f$var$K(b.generate(this.n.byteLength()));
        if (y = this._truncateToN(y, !0), !(y.cmpn(1) <= 0 || y.cmp(m) >= 0)) {
            var S = this.g.mul(y);
            if (!S.isInfinity()) {
                var I = S.getX(), N = I.umod(this.n);
                if (N.cmpn(0) !== 0) {
                    var C = y.invm(this.n).mul(N.mul(r.getPrivate()).iadd(t));
                    if (C = C.umod(this.n), C.cmpn(0) !== 0) {
                        var F = (S.getY().isOdd() ? 1 : 0) | (I.cmp(N) !== 0 ? 2 : 0);
                        return n.canonical && C.cmp(this.nh) > 0 && (C = this.n.sub(C), F ^= 1), new $17d123d3e821614f$var$zr({
                            r: N,
                            s: C,
                            recoveryParam: F
                        });
                    }
                }
            }
        }
    }
}, $17d123d3e821614f$var$$t.prototype.verify = function(t, r, i, n) {
    t = this._truncateToN(new $17d123d3e821614f$var$K(t, 16)), i = this.keyFromPublic(i, n), r = new $17d123d3e821614f$var$zr(r, "hex");
    var o = r.r, h = r.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || h.cmpn(1) < 0 || h.cmp(this.n) >= 0) return !1;
    var p = h.invm(this.n), b = p.mul(t).umod(this.n), m = p.mul(o).umod(this.n), w;
    return this.curve._maxwellTrick ? (w = this.g.jmulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.eqXToP(o)) : (w = this.g.mulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.getX().umod(this.n).cmp(o) === 0);
}, $17d123d3e821614f$var$$t.prototype.recoverPubKey = function(e, t, r, i) {
    $17d123d3e821614f$var$Pf((3 & r) === r, "The recovery param is more than two bits"), t = new $17d123d3e821614f$var$zr(t, i);
    var n = this.n, o = new $17d123d3e821614f$var$K(e), h = t.r, p = t.s, b = r & 1, m = r >> 1;
    if (h.cmp(this.curve.p.umod(this.curve.n)) >= 0 && m) throw new Error("Unable to find sencond key candinate");
    m ? h = this.curve.pointFromX(h.add(this.curve.n), b) : h = this.curve.pointFromX(h, b);
    var w = t.r.invm(n), y = n.sub(o).mul(w).umod(n), S = p.mul(w).umod(n);
    return this.g.mulAdd(y, h, S);
}, $17d123d3e821614f$var$$t.prototype.getKeyRecoveryParam = function(e, t, r, i) {
    if (t = new $17d123d3e821614f$var$zr(t, i), t.recoveryParam !== null) return t.recoveryParam;
    for(var n = 0; n < 4; n++){
        var o;
        try {
            o = this.recoverPubKey(e, t, n);
        } catch  {
            continue;
        }
        if (o.eq(r)) return n;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $17d123d3e821614f$var$La = $17d123d3e821614f$var$cr(function(e, t) {
    var r = t;
    r.version = "6.5.4", r.utils = $17d123d3e821614f$var$Jt, r.rand = function() {
        throw new Error("unsupported");
    }, r.curve = $17d123d3e821614f$var$qr, r.curves = $17d123d3e821614f$var$Kr, r.ec = $17d123d3e821614f$var$za, r.eddsa = null;
}), $17d123d3e821614f$var$ja = $17d123d3e821614f$var$La.ec;
const $17d123d3e821614f$var$Qa = "signing-key/5.7.0", $17d123d3e821614f$var$qi = new $17d123d3e821614f$var$L($17d123d3e821614f$var$Qa);
let $17d123d3e821614f$var$Ki = null;
function $17d123d3e821614f$var$ve() {
    return $17d123d3e821614f$var$Ki || ($17d123d3e821614f$var$Ki = new $17d123d3e821614f$var$ja("secp256k1")), $17d123d3e821614f$var$Ki;
}
class $17d123d3e821614f$var$Ja {
    constructor(t){
        $17d123d3e821614f$var$br(this, "curve", "secp256k1"), $17d123d3e821614f$var$br(this, "privateKey", $17d123d3e821614f$var$Kt(t)), $17d123d3e821614f$var$N0(this.privateKey) !== 32 && $17d123d3e821614f$var$qi.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const r = $17d123d3e821614f$var$ve().keyFromPrivate($17d123d3e821614f$var$Ot(this.privateKey));
        $17d123d3e821614f$var$br(this, "publicKey", "0x" + r.getPublic(!1, "hex")), $17d123d3e821614f$var$br(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), $17d123d3e821614f$var$br(this, "_isSigningKey", !0);
    }
    _addPoint(t) {
        const r = $17d123d3e821614f$var$ve().keyFromPublic($17d123d3e821614f$var$Ot(this.publicKey)), i = $17d123d3e821614f$var$ve().keyFromPublic($17d123d3e821614f$var$Ot(t));
        return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
    }
    signDigest(t) {
        const r = $17d123d3e821614f$var$ve().keyFromPrivate($17d123d3e821614f$var$Ot(this.privateKey)), i = $17d123d3e821614f$var$Ot(t);
        i.length !== 32 && $17d123d3e821614f$var$qi.throwArgumentError("bad digest length", "digest", t);
        const n = r.sign(i, {
            canonical: !0
        });
        return $17d123d3e821614f$var$zn({
            recoveryParam: n.recoveryParam,
            r: $17d123d3e821614f$var$oe("0x" + n.r.toString(16), 32),
            s: $17d123d3e821614f$var$oe("0x" + n.s.toString(16), 32)
        });
    }
    computeSharedSecret(t) {
        const r = $17d123d3e821614f$var$ve().keyFromPrivate($17d123d3e821614f$var$Ot(this.privateKey)), i = $17d123d3e821614f$var$ve().keyFromPublic($17d123d3e821614f$var$Ot($17d123d3e821614f$var$Df(t)));
        return $17d123d3e821614f$var$oe("0x" + r.derive(i.getPublic()).toString(16), 32);
    }
    static isSigningKey(t) {
        return !!(t && t._isSigningKey);
    }
}
function $17d123d3e821614f$var$Ga(e, t) {
    const r = $17d123d3e821614f$var$zn(t), i = {
        r: $17d123d3e821614f$var$Ot(r.r),
        s: $17d123d3e821614f$var$Ot(r.s)
    };
    return "0x" + $17d123d3e821614f$var$ve().recoverPubKey($17d123d3e821614f$var$Ot(e), i, r.recoveryParam).encode("hex", !1);
}
function $17d123d3e821614f$var$Df(e, t) {
    const r = $17d123d3e821614f$var$Ot(e);
    if (r.length === 32) {
        const i = new $17d123d3e821614f$var$Ja(r);
        return t ? "0x" + $17d123d3e821614f$var$ve().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
    } else {
        if (r.length === 33) return t ? $17d123d3e821614f$var$Kt(r) : "0x" + $17d123d3e821614f$var$ve().keyFromPublic(r).getPublic(!1, "hex");
        if (r.length === 65) return t ? "0x" + $17d123d3e821614f$var$ve().keyFromPublic(r).getPublic(!0, "hex") : $17d123d3e821614f$var$Kt(r);
    }
    return $17d123d3e821614f$var$qi.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const $17d123d3e821614f$var$Ya = "transactions/5.7.0";
new $17d123d3e821614f$var$L($17d123d3e821614f$var$Ya);
var $17d123d3e821614f$var$Ff;
(function(e) {
    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})($17d123d3e821614f$var$Ff || ($17d123d3e821614f$var$Ff = {}));
function $17d123d3e821614f$var$Va(e) {
    const t = $17d123d3e821614f$var$Df(e);
    return $17d123d3e821614f$var$ns($17d123d3e821614f$var$Hn($17d123d3e821614f$var$yi($17d123d3e821614f$var$Hn(t, 1)), 12));
}
function $17d123d3e821614f$var$Wa(e, t) {
    return $17d123d3e821614f$var$Va($17d123d3e821614f$var$Ga($17d123d3e821614f$var$Ot(e), t));
}
const $17d123d3e821614f$var$Xa = "https://rpc.walletconnect.com/v1";
async function $17d123d3e821614f$export$ab54e47fdf2903bb(e, t, r, i, n, o) {
    switch(r.t){
        case "eip191":
            return $17d123d3e821614f$export$b5da105d64914e5a(e, t, r.s);
        case "eip1271":
            return await $17d123d3e821614f$export$9bffe3330373b76b(e, t, r.s, i, n, o);
        default:
            throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${r.t}`);
    }
}
function $17d123d3e821614f$export$b5da105d64914e5a(e, t, r) {
    return $17d123d3e821614f$var$Wa($17d123d3e821614f$var$ff(t), r).toLowerCase() === e.toLowerCase();
}
async function $17d123d3e821614f$export$9bffe3330373b76b(e, t, r, i, n, o) {
    try {
        const h = "0x1626ba7e", p = "0000000000000000000000000000000000000000000000000000000000000040", b = "0000000000000000000000000000000000000000000000000000000000000041", m = r.substring(2), w = $17d123d3e821614f$var$ff(t).substring(2), y = h + w + p + b + m, S = await fetch(`${o || $17d123d3e821614f$var$Xa}/?chainId=${i}&projectId=${n}`, {
            method: "POST",
            body: JSON.stringify({
                id: $17d123d3e821614f$var$Za(),
                jsonrpc: "2.0",
                method: "eth_call",
                params: [
                    {
                        to: e,
                        data: y
                    },
                    "latest"
                ]
            })
        }), { result: I } = await S.json();
        return I ? I.slice(0, h.length).toLowerCase() === h.toLowerCase() : !1;
    } catch (h) {
        return console.error("isValidEip1271Signature: ", h), !1;
    }
}
function $17d123d3e821614f$var$Za() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $17d123d3e821614f$var$$a = Object.defineProperty, $17d123d3e821614f$var$tu = Object.defineProperties, $17d123d3e821614f$var$eu = Object.getOwnPropertyDescriptors, $17d123d3e821614f$var$qf = Object.getOwnPropertySymbols, $17d123d3e821614f$var$ru = Object.prototype.hasOwnProperty, $17d123d3e821614f$var$iu = Object.prototype.propertyIsEnumerable, $17d123d3e821614f$var$Kf = (e, t, r)=>t in e ? $17d123d3e821614f$var$$a(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $17d123d3e821614f$var$Hi = (e, t)=>{
    for(var r in t || (t = {}))$17d123d3e821614f$var$ru.call(t, r) && $17d123d3e821614f$var$Kf(e, r, t[r]);
    if ($17d123d3e821614f$var$qf) for (var r of $17d123d3e821614f$var$qf(t))$17d123d3e821614f$var$iu.call(t, r) && $17d123d3e821614f$var$Kf(e, r, t[r]);
    return e;
}, $17d123d3e821614f$var$Hf = (e, t)=>$17d123d3e821614f$var$tu(e, $17d123d3e821614f$var$eu(t));
const $17d123d3e821614f$var$nu = "did:pkh:", $17d123d3e821614f$export$a524ae552db7912 = (e)=>e?.split(":"), $17d123d3e821614f$export$85f23c05c80b194 = (e)=>{
    const t = e && $17d123d3e821614f$export$a524ae552db7912(e);
    if (t) return e.includes($17d123d3e821614f$var$nu) ? t[3] : t[1];
}, $17d123d3e821614f$export$a8b149927aef7051 = (e)=>{
    const t = e && $17d123d3e821614f$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $17d123d3e821614f$export$bf43cfbb4bd95de9 = (e)=>{
    const t = e && $17d123d3e821614f$export$a524ae552db7912(e);
    if (t) return t.pop();
};
async function $17d123d3e821614f$export$b7d566fce8e2b970(e) {
    const { cacao: t, projectId: r } = e, { s: i, p: n } = t, o = $17d123d3e821614f$export$25868d1e8e76735f(n, n.iss), h = $17d123d3e821614f$export$bf43cfbb4bd95de9(n.iss);
    return await $17d123d3e821614f$export$ab54e47fdf2903bb(h, o, i, $17d123d3e821614f$export$85f23c05c80b194(n.iss), r);
}
const $17d123d3e821614f$export$25868d1e8e76735f = (e, t)=>{
    const r = `${e.domain} wants you to sign in with your Ethereum account:`, i = $17d123d3e821614f$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    let n = e.statement || void 0;
    const o = `URI: ${e.aud || e.uri}`, h = `Version: ${e.version}`, p = `Chain ID: ${$17d123d3e821614f$export$85f23c05c80b194(t)}`, b = `Nonce: ${e.nonce}`, m = `Issued At: ${e.iat}`, w = e.resources ? `Resources:${e.resources.map((S)=>`
- ${S}`).join("")}` : void 0, y = $17d123d3e821614f$export$3bb18ae0fb9a9fa9(e.resources);
    if (y) {
        const S = $17d123d3e821614f$export$d34522c9e5a1aed1(y);
        n = $17d123d3e821614f$export$51673931d3a8308d(n, S);
    }
    return [
        r,
        i,
        "",
        n,
        "",
        o,
        h,
        p,
        b,
        m,
        w
    ].filter((S)=>S != null).join(`
`);
};
function $17d123d3e821614f$export$905974078a05d5f9(e, t, r) {
    return r.includes("did:pkh:") || (r = `did:pkh:${r}`), {
        h: {
            t: "caip122"
        },
        p: {
            iss: r,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $17d123d3e821614f$export$2bfa2ac7d9bc193c(e) {
    var t;
    const { authPayload: r, chains: i, methods: n } = e, o = r.statement || "";
    if (!(i != null && i.length)) return r;
    const h = r.chains, p = $17d123d3e821614f$export$f8aaf09178dd8b96(h, i);
    if (!(p != null && p.length)) throw new Error("No supported chains");
    const b = $17d123d3e821614f$export$8db308c294c84efd(r.resources);
    if (!b) return r;
    $17d123d3e821614f$export$ae8075c482503f32(b);
    const m = $17d123d3e821614f$export$9595a56724061288(b, "eip155");
    let w = r?.resources || [];
    if (m != null && m.length) {
        const y = $17d123d3e821614f$export$e1a9af3d61db3b68(m), S = $17d123d3e821614f$export$f8aaf09178dd8b96(y, n);
        if (!(S != null && S.length)) throw new Error(`Supported methods don't satisfy the requested: ${JSON.stringify(y)}, supported: ${JSON.stringify(n)}`);
        const I = $17d123d3e821614f$export$987cafd76db78dd1("request", S, {
            chains: p
        }), N = $17d123d3e821614f$export$317cb0007b0867c1(b, "eip155", I);
        w = ((t = r?.resources) == null ? void 0 : t.slice(0, -1)) || [], w.push($17d123d3e821614f$export$79a538532b4f11f7(N));
    }
    return $17d123d3e821614f$var$Hf($17d123d3e821614f$var$Hi({}, r), {
        statement: $17d123d3e821614f$export$fb351782bc6f001e(o, $17d123d3e821614f$export$3bb18ae0fb9a9fa9(w)),
        chains: p,
        resources: r != null && r.resources || w.length > 0 ? w : void 0
    });
}
function $17d123d3e821614f$export$8db308c294c84efd(e) {
    const t = $17d123d3e821614f$export$3bb18ae0fb9a9fa9(e);
    if (t && $17d123d3e821614f$export$d9f11bd9fec5a64(t)) return $17d123d3e821614f$export$d34522c9e5a1aed1(t);
}
function $17d123d3e821614f$export$771534f1eaa353c(e, t) {
    var r;
    return (r = e?.att) == null ? void 0 : r.hasOwnProperty(t);
}
function $17d123d3e821614f$export$9595a56724061288(e, t) {
    var r, i;
    return (r = e?.att) != null && r[t] ? Object.keys((i = e?.att) == null ? void 0 : i[t]) : [];
}
function $17d123d3e821614f$export$d4548b739f9dafe(e) {
    return e?.map((t)=>Object.keys(t)) || [];
}
function $17d123d3e821614f$export$e1a9af3d61db3b68(e) {
    return e?.map((t)=>{
        var r;
        return (r = t.split("/")) == null ? void 0 : r[1];
    }) || [];
}
function $17d123d3e821614f$export$e510a73ee562749(e) {
    return $17d123d3e821614f$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $17d123d3e821614f$export$c62426fdd000a97e(e) {
    return JSON.parse($17d123d3e821614f$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $17d123d3e821614f$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    const t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach((r)=>{
        const i = e.att[r];
        if (Array.isArray(i)) throw new Error(`Resource must be an object: ${r}`);
        if (typeof i != "object") throw new Error(`Resource must be an object: ${r}`);
        if (!Object.keys(i).length) throw new Error(`Resource object is empty: ${r}`);
        Object.keys(i).forEach((n)=>{
            const o = i[n];
            if (!Array.isArray(o)) throw new Error(`Ability limits ${n} must be an array of objects, found: ${o}`);
            if (!o.length) throw new Error(`Value of ${n} is empty array, must be an array with objects`);
            o.forEach((h)=>{
                if (typeof h != "object") throw new Error(`Ability limits (${n}) must be an array of objects, found: ${h}`);
            });
        });
    });
}
function $17d123d3e821614f$export$eea18a04b33506ed(e, t, r, i = {}) {
    return r?.sort((n, o)=>n.localeCompare(o)), {
        att: {
            [e]: $17d123d3e821614f$export$987cafd76db78dd1(t, r, i)
        }
    };
}
function $17d123d3e821614f$export$317cb0007b0867c1(e, t, r) {
    var i;
    return e.att[t] = $17d123d3e821614f$var$Hi({}, r), ((i = Object.keys(e.att)) == null ? void 0 : i.sort((n, o)=>n.localeCompare(o))).reduce((n, o)=>(n.att[o] = e.att[o], n), {
        att: {}
    });
}
function $17d123d3e821614f$export$987cafd76db78dd1(e, t, r = {}) {
    t = t?.sort((n, o)=>n.localeCompare(o));
    const i = t.map((n)=>({
            [`${e}/${n}`]: [
                r
            ]
        }));
    return Object.assign({}, ...i);
}
function $17d123d3e821614f$export$79a538532b4f11f7(e) {
    return $17d123d3e821614f$export$ae8075c482503f32(e), `urn:recap:${$17d123d3e821614f$export$e510a73ee562749(e).replace(/=/g, "")}`;
}
function $17d123d3e821614f$export$d34522c9e5a1aed1(e) {
    const t = $17d123d3e821614f$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $17d123d3e821614f$export$ae8075c482503f32(t), t;
}
function $17d123d3e821614f$export$2bc35d2a08a09ad5(e, t, r) {
    const i = $17d123d3e821614f$export$eea18a04b33506ed(e, t, r);
    return $17d123d3e821614f$export$79a538532b4f11f7(i);
}
function $17d123d3e821614f$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $17d123d3e821614f$export$c7a40c552af428b5(e, t) {
    const r = $17d123d3e821614f$export$d34522c9e5a1aed1(e), i = $17d123d3e821614f$export$d34522c9e5a1aed1(t), n = $17d123d3e821614f$export$2445df2492ef2cbd(r, i);
    return $17d123d3e821614f$export$79a538532b4f11f7(n);
}
function $17d123d3e821614f$export$2445df2492ef2cbd(e, t) {
    $17d123d3e821614f$export$ae8075c482503f32(e), $17d123d3e821614f$export$ae8075c482503f32(t);
    const r = Object.keys(e.att).concat(Object.keys(t.att)).sort((n, o)=>n.localeCompare(o)), i = {
        att: {}
    };
    return r.forEach((n)=>{
        var o, h;
        Object.keys(((o = e.att) == null ? void 0 : o[n]) || {}).concat(Object.keys(((h = t.att) == null ? void 0 : h[n]) || {})).sort((p, b)=>p.localeCompare(b)).forEach((p)=>{
            var b, m;
            i.att[n] = $17d123d3e821614f$var$Hf($17d123d3e821614f$var$Hi({}, i.att[n]), {
                [p]: ((b = e.att[n]) == null ? void 0 : b[p]) || ((m = t.att[n]) == null ? void 0 : m[p])
            });
        });
    }), i;
}
function $17d123d3e821614f$export$51673931d3a8308d(e = "", t) {
    $17d123d3e821614f$export$ae8075c482503f32(t);
    const r = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(r)) return e;
    const i = [];
    let n = 0;
    Object.keys(t.att).forEach((p)=>{
        const b = Object.keys(t.att[p]).map((y)=>({
                ability: y.split("/")[0],
                action: y.split("/")[1]
            }));
        b.sort((y, S)=>y.action.localeCompare(S.action));
        const m = {};
        b.forEach((y)=>{
            m[y.ability] || (m[y.ability] = []), m[y.ability].push(y.action);
        });
        const w = Object.keys(m).map((y)=>(n++, `(${n}) '${y}': '${m[y].join("', '")}' for '${p}'.`));
        i.push(w.join(", ").replace(".,", "."));
    });
    const o = i.join(" "), h = `${r}${o}`;
    return `${e ? e + " " : ""}${h}`;
}
function $17d123d3e821614f$export$d6c6a43d36418efe(e) {
    var t;
    const r = $17d123d3e821614f$export$d34522c9e5a1aed1(e);
    $17d123d3e821614f$export$ae8075c482503f32(r);
    const i = (t = r.att) == null ? void 0 : t.eip155;
    return i ? Object.keys(i).map((n)=>n.split("/")[1]) : [];
}
function $17d123d3e821614f$export$372f88051a611988(e) {
    const t = $17d123d3e821614f$export$d34522c9e5a1aed1(e);
    $17d123d3e821614f$export$ae8075c482503f32(t);
    const r = [];
    return Object.values(t.att).forEach((i)=>{
        Object.values(i).forEach((n)=>{
            var o;
            (o = n?.[0]) != null && o.chains && r.push(n[0].chains);
        });
    }), [
        ...new Set(r.flat())
    ];
}
function $17d123d3e821614f$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    const r = $17d123d3e821614f$export$d34522c9e5a1aed1(t);
    return $17d123d3e821614f$export$ae8075c482503f32(r), $17d123d3e821614f$export$51673931d3a8308d(e, r);
}
function $17d123d3e821614f$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    const t = e?.[e.length - 1];
    return $17d123d3e821614f$export$d9f11bd9fec5a64(t) ? t : void 0;
}
const $17d123d3e821614f$export$f7403969428298bd = "base10", $17d123d3e821614f$export$49eb910ab2518105 = "base16", $17d123d3e821614f$export$9bff723d552e6bcf = "base64pad", $17d123d3e821614f$export$9560dad2a83e4f04 = "utf8", $17d123d3e821614f$export$3425bd336a9673d8 = 0, $17d123d3e821614f$export$406e97c329f0f3d4 = 1, $17d123d3e821614f$var$vu = 0, $17d123d3e821614f$var$Zf = 1, $17d123d3e821614f$var$Vi = 12, $17d123d3e821614f$var$Wi = 32;
function $17d123d3e821614f$export$a949d36eab55b41f() {
    const e = $89Tbs.generateKeyPair();
    return {
        privateKey: (0, $e077786f7a954859$exports.toString)(e.secretKey, $17d123d3e821614f$export$49eb910ab2518105),
        publicKey: (0, $e077786f7a954859$exports.toString)(e.publicKey, $17d123d3e821614f$export$49eb910ab2518105)
    };
}
function $17d123d3e821614f$export$d15a28e4f1821243() {
    const e = (0, $lYmee.randomBytes)($17d123d3e821614f$var$Wi);
    return (0, $e077786f7a954859$exports.toString)(e, $17d123d3e821614f$export$49eb910ab2518105);
}
function $17d123d3e821614f$export$f8378f68e053f5c6(e, t) {
    const r = $89Tbs.sharedKey((0, $e077786f7a954859$exports.fromString)(e, $17d123d3e821614f$export$49eb910ab2518105), (0, $e077786f7a954859$exports.fromString)(t, $17d123d3e821614f$export$49eb910ab2518105), !0), i = new (0, $bwGWz.HKDF)((0, $5GkW9.SHA256), r).expand($17d123d3e821614f$var$Wi);
    return (0, $e077786f7a954859$exports.toString)(i, $17d123d3e821614f$export$49eb910ab2518105);
}
function $17d123d3e821614f$export$1e87d19d4aab5805(e) {
    const t = (0, $5GkW9.hash)((0, $e077786f7a954859$exports.fromString)(e, $17d123d3e821614f$export$49eb910ab2518105));
    return (0, $e077786f7a954859$exports.toString)(t, $17d123d3e821614f$export$49eb910ab2518105);
}
function $17d123d3e821614f$export$d4c241cec96564c1(e) {
    const t = (0, $5GkW9.hash)((0, $e077786f7a954859$exports.fromString)(e, $17d123d3e821614f$export$9560dad2a83e4f04));
    return (0, $e077786f7a954859$exports.toString)(t, $17d123d3e821614f$export$49eb910ab2518105);
}
function $17d123d3e821614f$export$e9d2f9ba70428fb6(e) {
    return (0, $e077786f7a954859$exports.fromString)(`${e}`, $17d123d3e821614f$export$f7403969428298bd);
}
function $17d123d3e821614f$export$7547a514ee29b9d4(e) {
    return Number((0, $e077786f7a954859$exports.toString)(e, $17d123d3e821614f$export$f7403969428298bd));
}
function $17d123d3e821614f$export$5b0f6292f11d1d18(e) {
    const t = $17d123d3e821614f$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $17d123d3e821614f$export$3425bd336a9673d8);
    if ($17d123d3e821614f$export$7547a514ee29b9d4(t) === $17d123d3e821614f$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const r = typeof e.senderPublicKey < "u" ? (0, $e077786f7a954859$exports.fromString)(e.senderPublicKey, $17d123d3e821614f$export$49eb910ab2518105) : void 0, i = typeof e.iv < "u" ? (0, $e077786f7a954859$exports.fromString)(e.iv, $17d123d3e821614f$export$49eb910ab2518105) : (0, $lYmee.randomBytes)($17d123d3e821614f$var$Vi), n = new (0, $g3kzz.ChaCha20Poly1305)((0, $e077786f7a954859$exports.fromString)(e.symKey, $17d123d3e821614f$export$49eb910ab2518105)).seal(i, (0, $e077786f7a954859$exports.fromString)(e.message, $17d123d3e821614f$export$9560dad2a83e4f04));
    return $17d123d3e821614f$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: n,
        iv: i,
        senderPublicKey: r
    });
}
function $17d123d3e821614f$export$e85a0c9a1067c5d3(e) {
    const t = new (0, $g3kzz.ChaCha20Poly1305)((0, $e077786f7a954859$exports.fromString)(e.symKey, $17d123d3e821614f$export$49eb910ab2518105)), { sealed: r, iv: i } = $17d123d3e821614f$export$efcd34ab6248d3cd(e.encoded), n = t.open(i, r);
    if (n === null) throw new Error("Failed to decrypt");
    return (0, $e077786f7a954859$exports.toString)(n, $17d123d3e821614f$export$9560dad2a83e4f04);
}
function $17d123d3e821614f$export$dfdc1655ccc5b9cb(e) {
    if ($17d123d3e821614f$export$7547a514ee29b9d4(e.type) === $17d123d3e821614f$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $e077786f7a954859$exports.toString)((0, $e077786f7a954859$exports.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $17d123d3e821614f$export$9bff723d552e6bcf);
    }
    return (0, $e077786f7a954859$exports.toString)((0, $e077786f7a954859$exports.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $17d123d3e821614f$export$9bff723d552e6bcf);
}
function $17d123d3e821614f$export$efcd34ab6248d3cd(e) {
    const t = (0, $e077786f7a954859$exports.fromString)(e, $17d123d3e821614f$export$9bff723d552e6bcf), r = t.slice($17d123d3e821614f$var$vu, $17d123d3e821614f$var$Zf), i = $17d123d3e821614f$var$Zf;
    if ($17d123d3e821614f$export$7547a514ee29b9d4(r) === $17d123d3e821614f$export$406e97c329f0f3d4) {
        const p = i + $17d123d3e821614f$var$Wi, b = p + $17d123d3e821614f$var$Vi, m = t.slice(i, p), w = t.slice(p, b), y = t.slice(b);
        return {
            type: r,
            sealed: y,
            iv: w,
            senderPublicKey: m
        };
    }
    const n = i + $17d123d3e821614f$var$Vi, o = t.slice(i, n), h = t.slice(n);
    return {
        type: r,
        sealed: h,
        iv: o
    };
}
function $17d123d3e821614f$export$177f3e316562333d(e, t) {
    const r = $17d123d3e821614f$export$efcd34ab6248d3cd(e);
    return $17d123d3e821614f$export$7949f60f2444aef2({
        type: $17d123d3e821614f$export$7547a514ee29b9d4(r.type),
        senderPublicKey: typeof r.senderPublicKey < "u" ? (0, $e077786f7a954859$exports.toString)(r.senderPublicKey, $17d123d3e821614f$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t?.receiverPublicKey
    });
}
function $17d123d3e821614f$export$7949f60f2444aef2(e) {
    const t = e?.type || $17d123d3e821614f$export$3425bd336a9673d8;
    if (t === $17d123d3e821614f$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $17d123d3e821614f$export$8c165704db2d5c15(e) {
    return e.type === $17d123d3e821614f$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
const $17d123d3e821614f$export$822d0bd1635d5360 = "irn";
function $17d123d3e821614f$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $17d123d3e821614f$export$822d0bd1635d5360
    };
}
function $17d123d3e821614f$export$604e3deb95e1b734(e) {
    const t = (0, $cZUWN.RELAY_JSONRPC)[e];
    if (typeof t > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return t;
}
var $17d123d3e821614f$var$Iu = Object.defineProperty, $17d123d3e821614f$var$_u = Object.defineProperties, $17d123d3e821614f$var$Bu = Object.getOwnPropertyDescriptors, $17d123d3e821614f$var$io = Object.getOwnPropertySymbols, $17d123d3e821614f$var$Cu = Object.prototype.hasOwnProperty, $17d123d3e821614f$var$Ru = Object.prototype.propertyIsEnumerable, $17d123d3e821614f$var$no = (e, t, r)=>t in e ? $17d123d3e821614f$var$Iu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $17d123d3e821614f$var$fo = (e, t)=>{
    for(var r in t || (t = {}))$17d123d3e821614f$var$Cu.call(t, r) && $17d123d3e821614f$var$no(e, r, t[r]);
    if ($17d123d3e821614f$var$io) for (var r of $17d123d3e821614f$var$io(t))$17d123d3e821614f$var$Ru.call(t, r) && $17d123d3e821614f$var$no(e, r, t[r]);
    return e;
}, $17d123d3e821614f$var$Ou = (e, t)=>$17d123d3e821614f$var$_u(e, $17d123d3e821614f$var$Bu(t));
function $17d123d3e821614f$export$3d24f408c2ac468a(e, t = "-") {
    const r = {}, i = "relay" + t;
    return Object.keys(e).forEach((n)=>{
        if (n.startsWith(i)) {
            const o = n.replace(i, ""), h = e[n];
            r[o] = h;
        }
    }), r;
}
function $17d123d3e821614f$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const t = e.indexOf(":"), r = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, i = e.substring(0, t), n = e.substring(t + 1, r).split("@"), o = typeof r < "u" ? e.substring(r) : "", h = $7GGtC.parse(o), p = typeof h.methods == "string" ? h.methods.split(",") : void 0;
    return {
        protocol: i,
        topic: $17d123d3e821614f$export$5ddc9ebef1d00f28(n[0]),
        version: parseInt(n[1], 10),
        symKey: h.symKey,
        relay: $17d123d3e821614f$export$3d24f408c2ac468a(h),
        methods: p,
        expiryTimestamp: h.expiryTimestamp ? parseInt(h.expiryTimestamp, 10) : void 0
    };
}
function $17d123d3e821614f$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $17d123d3e821614f$export$65c55c7ccd19bb8f(e, t = "-") {
    const r = "relay", i = {};
    return Object.keys(e).forEach((n)=>{
        const o = r + t + n;
        e[n] && (i[o] = e[n]);
    }), i;
}
function $17d123d3e821614f$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $7GGtC.stringify($17d123d3e821614f$var$fo($17d123d3e821614f$var$Ou($17d123d3e821614f$var$fo({
        symKey: e.symKey
    }, $17d123d3e821614f$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }), e.methods ? {
        methods: e.methods.join(",")
    } : {}));
}
var $17d123d3e821614f$var$Fu = Object.defineProperty, $17d123d3e821614f$var$Tu = Object.defineProperties, $17d123d3e821614f$var$Uu = Object.getOwnPropertyDescriptors, $17d123d3e821614f$var$uo = Object.getOwnPropertySymbols, $17d123d3e821614f$var$ku = Object.prototype.hasOwnProperty, $17d123d3e821614f$var$qu = Object.prototype.propertyIsEnumerable, $17d123d3e821614f$var$ho = (e, t, r)=>t in e ? $17d123d3e821614f$var$Fu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $17d123d3e821614f$var$Ku = (e, t)=>{
    for(var r in t || (t = {}))$17d123d3e821614f$var$ku.call(t, r) && $17d123d3e821614f$var$ho(e, r, t[r]);
    if ($17d123d3e821614f$var$uo) for (var r of $17d123d3e821614f$var$uo(t))$17d123d3e821614f$var$qu.call(t, r) && $17d123d3e821614f$var$ho(e, r, t[r]);
    return e;
}, $17d123d3e821614f$var$Hu = (e, t)=>$17d123d3e821614f$var$Tu(e, $17d123d3e821614f$var$Uu(t));
function $17d123d3e821614f$export$d46695d9c3664fe9(e) {
    const t = [];
    return e.forEach((r)=>{
        const [i, n] = r.split(":");
        t.push(`${i}:${n}`);
    }), t;
}
function $17d123d3e821614f$export$fb6db6038e742b14(e) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        t.push(...$17d123d3e821614f$export$d46695d9c3664fe9(r.accounts));
    }), t;
}
function $17d123d3e821614f$export$7dcf4808e17b15ac(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $17d123d3e821614f$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.methods);
    }), r;
}
function $17d123d3e821614f$export$94ee6d00e384a22(e, t) {
    const r = [];
    return Object.values(e).forEach((i)=>{
        $17d123d3e821614f$export$d46695d9c3664fe9(i.accounts).includes(t) && r.push(...i.events);
    }), r;
}
function $17d123d3e821614f$export$a8daa26a7c60ef90(e, t) {
    const r = $17d123d3e821614f$export$93f7b81dc815a714(e, t);
    if (r) throw new Error(r.message);
    const i = {};
    for (const [n, o] of Object.entries(e))i[n] = {
        methods: o.methods,
        events: o.events,
        chains: o.accounts.map((h)=>`${h.split(":")[0]}:${h.split(":")[1]}`)
    };
    return i;
}
function $17d123d3e821614f$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: t, optionalNamespaces: r = {} }, supportedNamespaces: i } = e, n = $17d123d3e821614f$export$2994550cda701c96(t), o = $17d123d3e821614f$export$2994550cda701c96(r), h = {};
    Object.keys(i).forEach((m)=>{
        const w = i[m].chains, y = i[m].methods, S = i[m].events, I = i[m].accounts;
        w.forEach((N)=>{
            if (!I.some((C)=>C.includes(N))) throw new Error(`No accounts provided for chain ${N} in namespace ${m}`);
        }), h[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    });
    const p = $17d123d3e821614f$export$ba5b0a4b585cd1b4(t, h, "approve()");
    if (p) throw new Error(p.message);
    const b = {};
    return !Object.keys(t).length && !Object.keys(r).length ? h : (Object.keys(n).forEach((m)=>{
        const w = i[m].chains.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.chains) == null ? void 0 : F.includes(N);
        }), y = i[m].methods.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.methods) == null ? void 0 : F.includes(N);
        }), S = i[m].events.filter((N)=>{
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.events) == null ? void 0 : F.includes(N);
        }), I = w.map((N)=>i[m].accounts.filter((C)=>C.includes(`${N}:`))).flat();
        b[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    }), Object.keys(o).forEach((m)=>{
        var w, y, S, I, N, C;
        if (!i[m]) return;
        const F = (y = (w = o[m]) == null ? void 0 : w.chains) == null ? void 0 : y.filter((G)=>i[m].chains.includes(G)), U = i[m].methods.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.methods) == null ? void 0 : z.includes(G);
        }), J = i[m].events.filter((G)=>{
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.events) == null ? void 0 : z.includes(G);
        }), Bt = F?.map((G)=>i[m].accounts.filter((H)=>H.includes(`${G}:`))).flat();
        b[m] = {
            chains: $17d123d3e821614f$export$9826fe7ad3921016((S = b[m]) == null ? void 0 : S.chains, F),
            methods: $17d123d3e821614f$export$9826fe7ad3921016((I = b[m]) == null ? void 0 : I.methods, U),
            events: $17d123d3e821614f$export$9826fe7ad3921016((N = b[m]) == null ? void 0 : N.events, J),
            accounts: $17d123d3e821614f$export$9826fe7ad3921016((C = b[m]) == null ? void 0 : C.accounts, Bt)
        };
    }), b);
}
function $17d123d3e821614f$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $17d123d3e821614f$export$dd404c96fbbb1ff8(e) {
    return $17d123d3e821614f$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $17d123d3e821614f$export$2994550cda701c96(e) {
    var t, r, i;
    const n = {};
    if (!$17d123d3e821614f$export$16a0268bc22b47b0(e)) return n;
    for (const [o, h] of Object.entries(e)){
        const p = $17d123d3e821614f$export$e03e993df4723bde(o) ? [
            o
        ] : h.chains, b = h.methods || [], m = h.events || [], w = $17d123d3e821614f$export$dd404c96fbbb1ff8(o);
        n[w] = $17d123d3e821614f$var$Hu($17d123d3e821614f$var$Ku({}, n[w]), {
            chains: $17d123d3e821614f$export$9826fe7ad3921016(p, (t = n[w]) == null ? void 0 : t.chains),
            methods: $17d123d3e821614f$export$9826fe7ad3921016(b, (r = n[w]) == null ? void 0 : r.methods),
            events: $17d123d3e821614f$export$9826fe7ad3921016(m, (i = n[w]) == null ? void 0 : i.events)
        });
    }
    return n;
}
function $17d123d3e821614f$export$293459f1cc8d700(e) {
    const t = {};
    return e?.forEach((r)=>{
        const [i, n] = r.split(":");
        t[i] || (t[i] = {
            accounts: [],
            chains: [],
            events: []
        }), t[i].accounts.push(r), t[i].chains.push(`${i}:${n}`);
    }), t;
}
function $17d123d3e821614f$export$b5744b1c39447540(e, t) {
    t = t.map((i)=>i.replace("did:pkh:", ""));
    const r = $17d123d3e821614f$export$293459f1cc8d700(t);
    for (const [i, n] of Object.entries(r))n.methods ? n.methods = $17d123d3e821614f$export$9826fe7ad3921016(n.methods, e) : n.methods = e, n.events = [
        "chainChanged",
        "accountsChanged"
    ];
    return r;
}
const $17d123d3e821614f$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $17d123d3e821614f$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $17d123d3e821614f$export$500d4c4a8fafe35(e, t) {
    const { message: r, code: i } = $17d123d3e821614f$export$77b3faa414a0ce61[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $17d123d3e821614f$export$8203ef1531c8b5b5(e, t) {
    const { message: r, code: i } = $17d123d3e821614f$export$990de0b632caca05[e];
    return {
        message: t ? `${r} ${t}` : r,
        code: i
    };
}
function $17d123d3e821614f$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? typeof t < "u" && e.length ? e.every(t) : !0 : !1;
}
function $17d123d3e821614f$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $17d123d3e821614f$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $17d123d3e821614f$export$ee898ca48ab56c74(e, t) {
    return t && $17d123d3e821614f$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $17d123d3e821614f$export$d6781b696a0576d1(e, t) {
    return t && $17d123d3e821614f$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $17d123d3e821614f$export$6fc4971bf8f326a(e, t) {
    const { requiredNamespaces: r } = t, i = Object.keys(e.namespaces), n = Object.keys(r);
    let o = !0;
    return $17d123d3e821614f$export$1468a49de573f7f9(n, i) ? (i.forEach((h)=>{
        const { accounts: p, methods: b, events: m } = e.namespaces[h], w = $17d123d3e821614f$export$d46695d9c3664fe9(p), y = r[h];
        (!$17d123d3e821614f$export$1468a49de573f7f9($17d123d3e821614f$export$376384387cd15b27(h, y), w) || !$17d123d3e821614f$export$1468a49de573f7f9(y.methods, b) || !$17d123d3e821614f$export$1468a49de573f7f9(y.events, m)) && (o = !1);
    }), o) : !1;
}
function $17d123d3e821614f$export$e544b39f0a22e47a(e) {
    return $17d123d3e821614f$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $17d123d3e821614f$export$49e4a5b6862e3c71(e) {
    if ($17d123d3e821614f$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const t = e.split(":");
        if (t.length === 3) {
            const r = t[0] + ":" + t[1];
            return !!t[2] && $17d123d3e821614f$export$e544b39f0a22e47a(r);
        }
    }
    return !1;
}
function $17d123d3e821614f$export$bef94a5618bf18bf(e) {
    if ($17d123d3e821614f$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $17d123d3e821614f$export$f657f7976bb2769d(e) {
    var t;
    return (t = e?.proposer) == null ? void 0 : t.publicKey;
}
function $17d123d3e821614f$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $17d123d3e821614f$export$5e1c5c89613c213f(e, t) {
    let r = null;
    return $17d123d3e821614f$export$ee898ca48ab56c74(e?.publicKey, !1) || (r = $17d123d3e821614f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t} controller public key should be a string`)), r;
}
function $17d123d3e821614f$export$c12fced8176774f3(e) {
    let t = !0;
    return $17d123d3e821614f$export$41dd3d480aac4a71(e) ? e.length && (t = e.every((r)=>$17d123d3e821614f$export$ee898ca48ab56c74(r, !1))) : t = !1, t;
}
function $17d123d3e821614f$export$df46c123d7e298ce(e, t, r) {
    let i = null;
    return $17d123d3e821614f$export$41dd3d480aac4a71(t) && t.length ? t.forEach((n)=>{
        i || $17d123d3e821614f$export$e544b39f0a22e47a(n) || (i = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chain ${n} should be a string and conform to "namespace:chainId" format`));
    }) : $17d123d3e821614f$export$e544b39f0a22e47a(e) || (i = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), i;
}
function $17d123d3e821614f$export$94ae96fb66f29e08(e, t, r) {
    let i = null;
    return Object.entries(e).forEach(([n, o])=>{
        if (i) return;
        const h = $17d123d3e821614f$export$df46c123d7e298ce(n, $17d123d3e821614f$export$376384387cd15b27(n, o), `${t} ${r}`);
        h && (i = h);
    }), i;
}
function $17d123d3e821614f$export$d5644026aaffb9e7(e, t) {
    let r = null;
    return $17d123d3e821614f$export$41dd3d480aac4a71(e) ? e.forEach((i)=>{
        r || $17d123d3e821614f$export$49e4a5b6862e3c71(i) || (r = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, account ${i} should be a string and conform to "namespace:chainId:address" format`));
    }) : r = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${t}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function $17d123d3e821614f$export$2a2012e7bfa1cfb4(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $17d123d3e821614f$export$d5644026aaffb9e7(i?.accounts, `${t} namespace`);
        n && (r = n);
    }), r;
}
function $17d123d3e821614f$export$b32541d63753af56(e, t) {
    let r = null;
    return $17d123d3e821614f$export$c12fced8176774f3(e?.methods) ? $17d123d3e821614f$export$c12fced8176774f3(e?.events) || (r = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${t}, events should be an array of strings or empty array for no events`)) : r = $17d123d3e821614f$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${t}, methods should be an array of strings or empty array for no methods`), r;
}
function $17d123d3e821614f$export$27682c78deeca9d7(e, t) {
    let r = null;
    return Object.values(e).forEach((i)=>{
        if (r) return;
        const n = $17d123d3e821614f$export$b32541d63753af56(i, `${t}, namespace`);
        n && (r = n);
    }), r;
}
function $17d123d3e821614f$export$9e2b2cae22c6a8b3(e, t, r) {
    let i = null;
    if (e && $17d123d3e821614f$export$16a0268bc22b47b0(e)) {
        const n = $17d123d3e821614f$export$27682c78deeca9d7(e, t);
        n && (i = n);
        const o = $17d123d3e821614f$export$94ae96fb66f29e08(e, t, r);
        o && (i = o);
    } else i = $17d123d3e821614f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, ${r} should be an object with data`);
    return i;
}
function $17d123d3e821614f$export$93f7b81dc815a714(e, t) {
    let r = null;
    if (e && $17d123d3e821614f$export$16a0268bc22b47b0(e)) {
        const i = $17d123d3e821614f$export$27682c78deeca9d7(e, t);
        i && (r = i);
        const n = $17d123d3e821614f$export$2a2012e7bfa1cfb4(e, t);
        n && (r = n);
    } else r = $17d123d3e821614f$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${t}, namespaces should be an object with data`);
    return r;
}
function $17d123d3e821614f$export$1b3fc298be8c9a7b(e) {
    return $17d123d3e821614f$export$ee898ca48ab56c74(e.protocol, !0);
}
function $17d123d3e821614f$export$6294c30b976bd21e(e, t) {
    let r = !1;
    return t && !e ? r = !0 : e && $17d123d3e821614f$export$41dd3d480aac4a71(e) && e.length && e.forEach((i)=>{
        r = $17d123d3e821614f$export$1b3fc298be8c9a7b(i);
    }), r;
}
function $17d123d3e821614f$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $17d123d3e821614f$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $17d123d3e821614f$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$17d123d3e821614f$export$d6781b696a0576d1(e.code, !1) || !e.message || !$17d123d3e821614f$export$ee898ca48ab56c74(e.message, !1));
}
function $17d123d3e821614f$export$1a2af3c017fb6d42(e) {
    return !($17d123d3e821614f$export$fce6876652108ab(e) || !$17d123d3e821614f$export$ee898ca48ab56c74(e.method, !1));
}
function $17d123d3e821614f$export$1ae38cf0a848f651(e) {
    return !($17d123d3e821614f$export$fce6876652108ab(e) || $17d123d3e821614f$export$fce6876652108ab(e.result) && $17d123d3e821614f$export$fce6876652108ab(e.error) || !$17d123d3e821614f$export$d6781b696a0576d1(e.id, !1) || !$17d123d3e821614f$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $17d123d3e821614f$export$cbe4cdc5960cfa11(e) {
    return !($17d123d3e821614f$export$fce6876652108ab(e) || !$17d123d3e821614f$export$ee898ca48ab56c74(e.name, !1));
}
function $17d123d3e821614f$export$144fc36610eb6522(e, t) {
    return !(!$17d123d3e821614f$export$e544b39f0a22e47a(t) || !$17d123d3e821614f$export$fb6db6038e742b14(e).includes(t));
}
function $17d123d3e821614f$export$8db4804e3a6de711(e, t, r) {
    return $17d123d3e821614f$export$ee898ca48ab56c74(r, !1) ? $17d123d3e821614f$export$7dcf4808e17b15ac(e, t).includes(r) : !1;
}
function $17d123d3e821614f$export$df2c67ef8baad16b(e, t, r) {
    return $17d123d3e821614f$export$ee898ca48ab56c74(r, !1) ? $17d123d3e821614f$export$94ee6d00e384a22(e, t).includes(r) : !1;
}
function $17d123d3e821614f$export$ba5b0a4b585cd1b4(e, t, r) {
    let i = null;
    const n = $17d123d3e821614f$var$sh(e), o = $17d123d3e821614f$var$ah(t), h = Object.keys(n), p = Object.keys(o), b = $17d123d3e821614f$var$_o(Object.keys(e)), m = $17d123d3e821614f$var$_o(Object.keys(t)), w = b.filter((y)=>!m.includes(y));
    return w.length && (i = $17d123d3e821614f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${w.toString()}
      Received: ${Object.keys(t).toString()}`)), $17d123d3e821614f$export$1468a49de573f7f9(h, p) || (i = $17d123d3e821614f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${h.toString()}
      Approved: ${p.toString()}`)), Object.keys(t).forEach((y)=>{
        if (!y.includes(":") || i) return;
        const S = $17d123d3e821614f$export$d46695d9c3664fe9(t[y].accounts);
        S.includes(y) || (i = $17d123d3e821614f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${y}
        Required: ${y}
        Approved: ${S.toString()}`));
    }), h.forEach((y)=>{
        i || ($17d123d3e821614f$export$1468a49de573f7f9(n[y].methods, o[y].methods) ? $17d123d3e821614f$export$1468a49de573f7f9(n[y].events, o[y].events) || (i = $17d123d3e821614f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${y}`)) : i = $17d123d3e821614f$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${y}`));
    }), i;
}
function $17d123d3e821614f$var$sh(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        var i;
        r.includes(":") ? t[r] = e[r] : (i = e[r].chains) == null || i.forEach((n)=>{
            t[n] = {
                methods: e[r].methods,
                events: e[r].events
            };
        });
    }), t;
}
function $17d123d3e821614f$var$_o(e) {
    return [
        ...new Set(e.map((t)=>t.includes(":") ? t.split(":")[0] : t))
    ];
}
function $17d123d3e821614f$var$ah(e) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        if (r.includes(":")) t[r] = e[r];
        else {
            const i = $17d123d3e821614f$export$d46695d9c3664fe9(e[r].accounts);
            i?.forEach((n)=>{
                t[n] = {
                    accounts: e[r].accounts.filter((o)=>o.includes(`${n}:`)),
                    methods: e[r].methods,
                    events: e[r].events
                };
            });
        }
    }), t;
}
function $17d123d3e821614f$export$59fba2af1ac782b(e, t) {
    return $17d123d3e821614f$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $17d123d3e821614f$export$53c2fd0173ad2b80() {
    const e = $17d123d3e821614f$export$57570b1603cf6adb();
    return new Promise((t)=>{
        switch(e){
            case $17d123d3e821614f$export$86b1301a63b15dd9.browser:
                t($17d123d3e821614f$export$2f147c609a999e49());
                break;
            case $17d123d3e821614f$export$86b1301a63b15dd9.reactNative:
                t($17d123d3e821614f$export$1444c95b1570bd12());
                break;
            case $17d123d3e821614f$export$86b1301a63b15dd9.node:
                t($17d123d3e821614f$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $17d123d3e821614f$export$2f147c609a999e49() {
    return $17d123d3e821614f$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $17d123d3e821614f$export$1444c95b1570bd12() {
    if ($17d123d3e821614f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $17d123d3e821614f$export$aec5b2d627eec500() {
    return !0;
}
function $17d123d3e821614f$export$600a1ee4bc680996(e) {
    switch($17d123d3e821614f$export$57570b1603cf6adb()){
        case $17d123d3e821614f$export$86b1301a63b15dd9.browser:
            $17d123d3e821614f$export$d32b24f18d96c5f2(e);
            break;
        case $17d123d3e821614f$export$86b1301a63b15dd9.reactNative:
            $17d123d3e821614f$export$904edb1c18ec91c7(e);
            break;
        case $17d123d3e821614f$export$86b1301a63b15dd9.node:
            break;
    }
}
function $17d123d3e821614f$export$d32b24f18d96c5f2(e) {
    !$17d123d3e821614f$export$f7a1e23e542d38e3() && $17d123d3e821614f$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $17d123d3e821614f$export$904edb1c18ec91c7(e) {
    $17d123d3e821614f$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((t)=>e(t?.isConnected));
}
const $17d123d3e821614f$var$rn = {};
class $17d123d3e821614f$export$b72d712fed4d036d {
    static get(t) {
        return $17d123d3e821614f$var$rn[t];
    }
    static set(t, r) {
        $17d123d3e821614f$var$rn[t] = r;
    }
    static delete(t) {
        delete $17d123d3e821614f$var$rn[t];
    }
}



var $ej6Nm = parcelRequire("ej6Nm");

var $6QZmz = parcelRequire("6QZmz");

var $ej6Nm = parcelRequire("ej6Nm");

var $8Yg5s = parcelRequire("8Yg5s");
parcelRequire("fiZ0l");
var $69EOo = parcelRequire("69EOo");
class $0281ada4f6245029$export$d31d5212998928bd extends (0, $69EOo.IEvents) {
    constructor(e){
        super();
    }
}
const $0281ada4f6245029$export$31c453b5fe09788d = (0, $8Yg5s.FIVE_SECONDS), $0281ada4f6245029$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
class $0281ada4f6245029$export$996c9b2cd7645b55 extends $0281ada4f6245029$export$d31d5212998928bd {
    constructor(e){
        super(e), this.events = new (0, $ej6Nm.EventEmitter), this.interval = $0281ada4f6245029$export$31c453b5fe09788d, this.interval = e?.interval || $0281ada4f6245029$export$31c453b5fe09788d;
    }
    static async init(e) {
        const t = new $0281ada4f6245029$export$996c9b2cd7645b55(e);
        return await t.init(), t;
    }
    async init() {
        await this.initialize();
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async initialize() {
        this.intervalRef = setInterval(()=>this.pulse(), (0, $8Yg5s.toMiliseconds)(this.interval));
    }
    pulse() {
        this.events.emit($0281ada4f6245029$export$f3340c1af6bee4b5.pulse);
    }
}



var $c8Vuh = parcelRequire("c8Vuh");
var $77JzN = parcelRequire("77JzN");
parcelRequire("fiZ0l");
var $69EOo = parcelRequire("69EOo");

var $ej6Nm = parcelRequire("ej6Nm");
class $85826f5a95c74020$export$ed533416df113881 extends (0, $69EOo.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $85826f5a95c74020$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$45b2c2643615b67 extends (0, $69EOo.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $85826f5a95c74020$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $85826f5a95c74020$export$3b0872bbd7e675a2 extends (0, $69EOo.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$9a0f755fd4f79434 extends (0, $69EOo.IEvents) {
    constructor(s){
        super();
    }
}
class $85826f5a95c74020$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $85826f5a95c74020$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $85826f5a95c74020$export$300eed987e764b57 extends (0, $69EOo.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$41aaa3c39f6f2861 extends (0, $69EOo.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $85826f5a95c74020$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $85826f5a95c74020$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($ej6Nm))) {
    constructor(){
        super();
    }
}
class $85826f5a95c74020$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $85826f5a95c74020$export$623dd0f793f15643 extends (0, $ej6Nm.EventEmitter) {
    constructor(){
        super();
    }
}
class $85826f5a95c74020$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}



var $3zoS2 = parcelRequire("3zoS2");
parcelRequire("k2pOm");
var $4LcoU = parcelRequire("4LcoU");
var $lDjQh = parcelRequire("lDjQh");

var $494c115638f343c3$exports = {};
"use strict";
Object.defineProperty($494c115638f343c3$exports, "__esModule", {
    value: true
});
var $8831c688e8ed0714$exports = {};
"use strict";
Object.defineProperty($8831c688e8ed0714$exports, "__esModule", {
    value: true
});
function $8831c688e8ed0714$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$8831c688e8ed0714$exports.compare = $8831c688e8ed0714$var$compare;


var $6c07f0f4e43e1fe0$exports = {};
"use strict";
Object.defineProperty($6c07f0f4e43e1fe0$exports, "__esModule", {
    value: true
});
var $c31f79a97924b642$exports = {};
"use strict";
Object.defineProperty($c31f79a97924b642$exports, "__esModule", {
    value: true
});
function $c31f79a97924b642$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $c31f79a97924b642$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}
$c31f79a97924b642$exports.alloc = $c31f79a97924b642$var$alloc;
$c31f79a97924b642$exports.allocUnsafe = $c31f79a97924b642$var$allocUnsafe;


function $6c07f0f4e43e1fe0$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $c31f79a97924b642$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
$6c07f0f4e43e1fe0$exports.concat = $6c07f0f4e43e1fe0$var$concat;


var $d952b518aa654e22$exports = {};
"use strict";
Object.defineProperty($d952b518aa654e22$exports, "__esModule", {
    value: true
});
function $d952b518aa654e22$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$d952b518aa654e22$exports.equals = $d952b518aa654e22$var$equals;


var $e333090282672eb1$exports = {};
"use strict";
Object.defineProperty($e333090282672eb1$exports, "__esModule", {
    value: true
});
var $54a18ff71028e9f5$exports = {};
"use strict";

var $4tv9y = parcelRequire("4tv9y");

function $54a18ff71028e9f5$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $54a18ff71028e9f5$var$string = $54a18ff71028e9f5$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $54a18ff71028e9f5$var$ascii = $54a18ff71028e9f5$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $c31f79a97924b642$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $54a18ff71028e9f5$var$BASES = {
    utf8: $54a18ff71028e9f5$var$string,
    "utf-8": $54a18ff71028e9f5$var$string,
    hex: $4tv9y.bases.base16,
    latin1: $54a18ff71028e9f5$var$ascii,
    ascii: $54a18ff71028e9f5$var$ascii,
    binary: $54a18ff71028e9f5$var$ascii,
    ...$4tv9y.bases
};
$54a18ff71028e9f5$exports = $54a18ff71028e9f5$var$BASES;


function $e333090282672eb1$var$fromString(string, encoding = "utf8") {
    const base = $54a18ff71028e9f5$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode(`${base.prefix}${string}`);
}
$e333090282672eb1$exports.fromString = $e333090282672eb1$var$fromString;


var $b9171a754ee175d3$exports = {};
"use strict";
Object.defineProperty($b9171a754ee175d3$exports, "__esModule", {
    value: true
});

function $b9171a754ee175d3$var$toString(array, encoding = "utf8") {
    const base = $54a18ff71028e9f5$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
$b9171a754ee175d3$exports.toString = $b9171a754ee175d3$var$toString;


var $7e97b4904e2c3c5d$exports = {};
"use strict";
Object.defineProperty($7e97b4904e2c3c5d$exports, "__esModule", {
    value: true
});

function $7e97b4904e2c3c5d$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $c31f79a97924b642$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}
$7e97b4904e2c3c5d$exports.xor = $7e97b4904e2c3c5d$var$xor;


$494c115638f343c3$exports.compare = $8831c688e8ed0714$exports.compare;
$494c115638f343c3$exports.concat = $6c07f0f4e43e1fe0$exports.concat;
$494c115638f343c3$exports.equals = $d952b518aa654e22$exports.equals;
$494c115638f343c3$exports.fromString = $e333090282672eb1$exports.fromString;
$494c115638f343c3$exports.toString = $b9171a754ee175d3$exports.toString;
$494c115638f343c3$exports.xor = $7e97b4904e2c3c5d$exports.xor;



var $8Yg5s = parcelRequire("8Yg5s");

var $ej6Nm = parcelRequire("ej6Nm");
parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
var $dY7cQ = parcelRequire("dY7cQ");
var $5h2x7 = parcelRequire("5h2x7");
class $4f39d563736cd6ff$export$da28308012bf6748 extends (0, $dY7cQ.IJsonRpcProvider) {
    constructor(t){
        super(t), this.events = new (0, $ej6Nm.EventEmitter), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(t), this.connection.connected && this.registerEventListeners();
    }
    async connect(t = this.connection) {
        await this.open(t);
    }
    async disconnect() {
        await this.close();
    }
    on(t, e) {
        this.events.on(t, e);
    }
    once(t, e) {
        this.events.once(t, e);
    }
    off(t, e) {
        this.events.off(t, e);
    }
    removeListener(t, e) {
        this.events.removeListener(t, e);
    }
    async request(t, e) {
        return this.requestStrict((0, $4seG3.formatJsonRpcRequest)(t.method, t.params || [], t.id || (0, $4seG3.getBigIntRpcId)().toString()), e);
    }
    async requestStrict(t, e) {
        return new Promise(async (i, s)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (n) {
                s(n);
            }
            this.events.on(`${t.id}`, (n)=>{
                (0, $5h2x7.isJsonRpcError)(n) ? s(n.error) : i(n.result);
            });
            try {
                await this.connection.send(t, e);
            } catch (n) {
                s(n);
            }
        });
    }
    setConnection(t = this.connection) {
        return t;
    }
    onPayload(t) {
        this.events.emit("payload", t), (0, $5h2x7.isJsonRpcResponse)(t) ? this.events.emit(`${t.id}`, t) : this.events.emit("message", {
            type: t.method,
            data: t.params
        });
    }
    onClose(t) {
        t && t.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${t.code} ${t.reason ? `(${t.reason})` : ""}`)), this.events.emit("disconnect");
    }
    async open(t = this.connection) {
        this.connection === t && this.connection.connected || (this.connection.connected && this.close(), typeof t == "string" && (await this.connection.open(t), t = this.connection), this.connection = this.setConnection(t), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        this.hasRegisteredEventListeners || (this.connection.on("payload", (t)=>this.onPayload(t)), this.connection.on("close", (t)=>this.onClose(t)), this.connection.on("error", (t)=>this.events.emit("error", t)), this.connection.on("register_error", (t)=>this.onClose()), this.hasRegisteredEventListeners = !0);
    }
}


parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
var $5h2x7 = parcelRequire("5h2x7");

var $8jexD = parcelRequire("8jexD");

var $8ne5u = parcelRequire("8ne5u");

var $fdSc8 = parcelRequire("fdSc8");
function $8ce29b9d0d06659b$var$Hi(o, e) {
    if (o.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < o.length; s++){
        var r = o.charAt(s), n = r.charCodeAt(0);
        if (t[n] !== 255) throw new TypeError(r + " is ambiguous");
        t[n] = s;
    }
    var a = o.length, h = o.charAt(0), l = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function g(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var p = 0, T = 0, D = 0, P = u.length; D !== P && u[D] === 0;)D++, p++;
        for(var x = (P - D) * d + 1 >>> 0, w = new Uint8Array(x); D !== P;){
            for(var O = u[D], N = 0, _ = x - 1; (O !== 0 || N < T) && _ !== -1; _--, N++)O += 256 * w[_] >>> 0, w[_] = O % a >>> 0, O = O / a >>> 0;
            if (O !== 0) throw new Error("Non-zero carry");
            T = N, D++;
        }
        for(var A = x - T; A !== x && w[A] === 0;)A++;
        for(var G = h.repeat(p); A < x; ++A)G += o.charAt(w[A]);
        return G;
    }
    function m(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var p = 0;
        if (u[p] !== " ") {
            for(var T = 0, D = 0; u[p] === h;)T++, p++;
            for(var P = (u.length - p) * l + 1 >>> 0, x = new Uint8Array(P); u[p];){
                var w = t[u.charCodeAt(p)];
                if (w === 255) return;
                for(var O = 0, N = P - 1; (w !== 0 || O < D) && N !== -1; N--, O++)w += a * x[N] >>> 0, x[N] = w % 256 >>> 0, w = w / 256 >>> 0;
                if (w !== 0) throw new Error("Non-zero carry");
                D = O, p++;
            }
            if (u[p] !== " ") {
                for(var _ = P - D; _ !== P && x[_] === 0;)_++;
                for(var A = new Uint8Array(T + (P - _)), G = T; _ !== P;)A[G++] = x[_++];
                return A;
            }
        }
    }
    function L(u) {
        var p = m(u);
        if (p) return p;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: g,
        decodeUnsafe: m,
        decode: L
    };
}
var $8ce29b9d0d06659b$var$Ji = $8ce29b9d0d06659b$var$Hi, $8ce29b9d0d06659b$var$Xi = $8ce29b9d0d06659b$var$Ji;
const $8ce29b9d0d06659b$var$Ue = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $8ce29b9d0d06659b$var$Wi = (o)=>new TextEncoder().encode(o), $8ce29b9d0d06659b$var$Qi = (o)=>new TextDecoder().decode(o);
class $8ce29b9d0d06659b$var$Zi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $8ce29b9d0d06659b$var$es {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $8ce29b9d0d06659b$var$Fe(this, e);
    }
}
class $8ce29b9d0d06659b$var$ts {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $8ce29b9d0d06659b$var$Fe(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $8ce29b9d0d06659b$var$Fe = (o, e)=>new $8ce29b9d0d06659b$var$ts({
        ...o.decoders || {
            [o.prefix]: o
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $8ce29b9d0d06659b$var$is {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $8ce29b9d0d06659b$var$Zi(e, t, i), this.decoder = new $8ce29b9d0d06659b$var$es(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $8ce29b9d0d06659b$var$Q = ({ name: o, prefix: e, encode: t, decode: i })=>new $8ce29b9d0d06659b$var$is(o, e, t, i), $8ce29b9d0d06659b$var$V = ({ prefix: o, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $8ce29b9d0d06659b$var$Xi(t, e);
    return $8ce29b9d0d06659b$var$Q({
        prefix: o,
        name: e,
        encode: i,
        decode: (r)=>$8ce29b9d0d06659b$var$Ue(s(r))
    });
}, $8ce29b9d0d06659b$var$ss = (o, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let r = o.length;
    for(; o[r - 1] === "=";)--r;
    const n = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, l = 0;
    for(let d = 0; d < r; ++d){
        const g = s[o[d]];
        if (g === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | g, a += t, a >= 8 && (a -= 8, n[l++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return n;
}, $8ce29b9d0d06659b$var$rs = (o, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let r = "", n = 0, a = 0;
    for(let h = 0; h < o.length; ++h)for(a = a << 8 | o[h], n += 8; n > t;)n -= t, r += e[s & a >> n];
    if (n && (r += e[s & a << t - n]), i) for(; r.length * t & 7;)r += "=";
    return r;
}, $8ce29b9d0d06659b$var$y = ({ name: o, prefix: e, bitsPerChar: t, alphabet: i })=>$8ce29b9d0d06659b$var$Q({
        prefix: e,
        name: o,
        encode (s) {
            return $8ce29b9d0d06659b$var$rs(s, i, t);
        },
        decode (s) {
            return $8ce29b9d0d06659b$var$ss(s, i, t, o);
        }
    }), $8ce29b9d0d06659b$var$ns = $8ce29b9d0d06659b$var$Q({
    prefix: "\x00",
    name: "identity",
    encode: (o)=>$8ce29b9d0d06659b$var$Qi(o),
    decode: (o)=>$8ce29b9d0d06659b$var$Wi(o)
});
var $8ce29b9d0d06659b$var$os = Object.freeze({
    __proto__: null,
    identity: $8ce29b9d0d06659b$var$ns
});
const $8ce29b9d0d06659b$var$as = $8ce29b9d0d06659b$var$y({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $8ce29b9d0d06659b$var$hs = Object.freeze({
    __proto__: null,
    base2: $8ce29b9d0d06659b$var$as
});
const $8ce29b9d0d06659b$var$cs = $8ce29b9d0d06659b$var$y({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $8ce29b9d0d06659b$var$ls = Object.freeze({
    __proto__: null,
    base8: $8ce29b9d0d06659b$var$cs
});
const $8ce29b9d0d06659b$var$us = $8ce29b9d0d06659b$var$V({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $8ce29b9d0d06659b$var$ds = Object.freeze({
    __proto__: null,
    base10: $8ce29b9d0d06659b$var$us
});
const $8ce29b9d0d06659b$var$gs = $8ce29b9d0d06659b$var$y({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $8ce29b9d0d06659b$var$ps = $8ce29b9d0d06659b$var$y({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $8ce29b9d0d06659b$var$Ds = Object.freeze({
    __proto__: null,
    base16: $8ce29b9d0d06659b$var$gs,
    base16upper: $8ce29b9d0d06659b$var$ps
});
const $8ce29b9d0d06659b$var$ys = $8ce29b9d0d06659b$var$y({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$ms = $8ce29b9d0d06659b$var$y({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$bs = $8ce29b9d0d06659b$var$y({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$fs = $8ce29b9d0d06659b$var$y({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$Es = $8ce29b9d0d06659b$var$y({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$ws = $8ce29b9d0d06659b$var$y({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$vs = $8ce29b9d0d06659b$var$y({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$Is = $8ce29b9d0d06659b$var$y({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $8ce29b9d0d06659b$var$Cs = $8ce29b9d0d06659b$var$y({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $8ce29b9d0d06659b$var$Ts = Object.freeze({
    __proto__: null,
    base32: $8ce29b9d0d06659b$var$ys,
    base32upper: $8ce29b9d0d06659b$var$ms,
    base32pad: $8ce29b9d0d06659b$var$bs,
    base32padupper: $8ce29b9d0d06659b$var$fs,
    base32hex: $8ce29b9d0d06659b$var$Es,
    base32hexupper: $8ce29b9d0d06659b$var$ws,
    base32hexpad: $8ce29b9d0d06659b$var$vs,
    base32hexpadupper: $8ce29b9d0d06659b$var$Is,
    base32z: $8ce29b9d0d06659b$var$Cs
});
const $8ce29b9d0d06659b$var$_s = $8ce29b9d0d06659b$var$V({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $8ce29b9d0d06659b$var$Rs = $8ce29b9d0d06659b$var$V({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $8ce29b9d0d06659b$var$Ss = Object.freeze({
    __proto__: null,
    base36: $8ce29b9d0d06659b$var$_s,
    base36upper: $8ce29b9d0d06659b$var$Rs
});
const $8ce29b9d0d06659b$var$Ps = $8ce29b9d0d06659b$var$V({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $8ce29b9d0d06659b$var$xs = $8ce29b9d0d06659b$var$V({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $8ce29b9d0d06659b$var$Os = Object.freeze({
    __proto__: null,
    base58btc: $8ce29b9d0d06659b$var$Ps,
    base58flickr: $8ce29b9d0d06659b$var$xs
});
const $8ce29b9d0d06659b$var$As = $8ce29b9d0d06659b$var$y({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $8ce29b9d0d06659b$var$zs = $8ce29b9d0d06659b$var$y({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $8ce29b9d0d06659b$var$Ns = $8ce29b9d0d06659b$var$y({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $8ce29b9d0d06659b$var$Ls = $8ce29b9d0d06659b$var$y({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $8ce29b9d0d06659b$var$Us = Object.freeze({
    __proto__: null,
    base64: $8ce29b9d0d06659b$var$As,
    base64pad: $8ce29b9d0d06659b$var$zs,
    base64url: $8ce29b9d0d06659b$var$Ns,
    base64urlpad: $8ce29b9d0d06659b$var$Ls
});
const $8ce29b9d0d06659b$var$$e = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $8ce29b9d0d06659b$var$Fs = $8ce29b9d0d06659b$var$$e.reduce((o, e, t)=>(o[t] = e, o), []), $8ce29b9d0d06659b$var$$s = $8ce29b9d0d06659b$var$$e.reduce((o, e, t)=>(o[e.codePointAt(0)] = t, o), []);
function $8ce29b9d0d06659b$var$Bs(o) {
    return o.reduce((e, t)=>(e += $8ce29b9d0d06659b$var$Fs[t], e), "");
}
function $8ce29b9d0d06659b$var$Ms(o) {
    const e = [];
    for (const t of o){
        const i = $8ce29b9d0d06659b$var$$s[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $8ce29b9d0d06659b$var$ks = $8ce29b9d0d06659b$var$Q({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $8ce29b9d0d06659b$var$Bs,
    decode: $8ce29b9d0d06659b$var$Ms
});
var $8ce29b9d0d06659b$var$Ks = Object.freeze({
    __proto__: null,
    base256emoji: $8ce29b9d0d06659b$var$ks
}), $8ce29b9d0d06659b$var$Vs = $8ce29b9d0d06659b$var$Me, $8ce29b9d0d06659b$var$Be = 128, $8ce29b9d0d06659b$var$qs = 127, $8ce29b9d0d06659b$var$js = ~$8ce29b9d0d06659b$var$qs, $8ce29b9d0d06659b$var$Gs = Math.pow(2, 31);
function $8ce29b9d0d06659b$var$Me(o, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; o >= $8ce29b9d0d06659b$var$Gs;)e[t++] = o & 255 | $8ce29b9d0d06659b$var$Be, o /= 128;
    for(; o & $8ce29b9d0d06659b$var$js;)e[t++] = o & 255 | $8ce29b9d0d06659b$var$Be, o >>>= 7;
    return e[t] = o | 0, $8ce29b9d0d06659b$var$Me.bytes = t - i + 1, e;
}
var $8ce29b9d0d06659b$var$Ys = $8ce29b9d0d06659b$var$de, $8ce29b9d0d06659b$var$Hs = 128, $8ce29b9d0d06659b$var$ke = 127;
function $8ce29b9d0d06659b$var$de(o, i) {
    var t = 0, i = i || 0, s = 0, r = i, n, a = o.length;
    do {
        if (r >= a) throw $8ce29b9d0d06659b$var$de.bytes = 0, new RangeError("Could not decode varint");
        n = o[r++], t += s < 28 ? (n & $8ce29b9d0d06659b$var$ke) << s : (n & $8ce29b9d0d06659b$var$ke) * Math.pow(2, s), s += 7;
    }while (n >= $8ce29b9d0d06659b$var$Hs);
    return $8ce29b9d0d06659b$var$de.bytes = r - i, t;
}
var $8ce29b9d0d06659b$var$Js = Math.pow(2, 7), $8ce29b9d0d06659b$var$Xs = Math.pow(2, 14), $8ce29b9d0d06659b$var$Ws = Math.pow(2, 21), $8ce29b9d0d06659b$var$Qs = Math.pow(2, 28), $8ce29b9d0d06659b$var$Zs = Math.pow(2, 35), $8ce29b9d0d06659b$var$er = Math.pow(2, 42), $8ce29b9d0d06659b$var$tr = Math.pow(2, 49), $8ce29b9d0d06659b$var$ir = Math.pow(2, 56), $8ce29b9d0d06659b$var$sr = Math.pow(2, 63), $8ce29b9d0d06659b$var$rr = function(o) {
    return o < $8ce29b9d0d06659b$var$Js ? 1 : o < $8ce29b9d0d06659b$var$Xs ? 2 : o < $8ce29b9d0d06659b$var$Ws ? 3 : o < $8ce29b9d0d06659b$var$Qs ? 4 : o < $8ce29b9d0d06659b$var$Zs ? 5 : o < $8ce29b9d0d06659b$var$er ? 6 : o < $8ce29b9d0d06659b$var$tr ? 7 : o < $8ce29b9d0d06659b$var$ir ? 8 : o < $8ce29b9d0d06659b$var$sr ? 9 : 10;
}, $8ce29b9d0d06659b$var$nr = {
    encode: $8ce29b9d0d06659b$var$Vs,
    decode: $8ce29b9d0d06659b$var$Ys,
    encodingLength: $8ce29b9d0d06659b$var$rr
}, $8ce29b9d0d06659b$var$Ke = $8ce29b9d0d06659b$var$nr;
const $8ce29b9d0d06659b$var$Ve = (o, e, t = 0)=>($8ce29b9d0d06659b$var$Ke.encode(o, e, t), e), $8ce29b9d0d06659b$var$qe = (o)=>$8ce29b9d0d06659b$var$Ke.encodingLength(o), $8ce29b9d0d06659b$var$ge = (o, e)=>{
    const t = e.byteLength, i = $8ce29b9d0d06659b$var$qe(o), s = i + $8ce29b9d0d06659b$var$qe(t), r = new Uint8Array(s + t);
    return $8ce29b9d0d06659b$var$Ve(o, r, 0), $8ce29b9d0d06659b$var$Ve(t, r, i), r.set(e, s), new $8ce29b9d0d06659b$var$or(o, t, e, r);
};
class $8ce29b9d0d06659b$var$or {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $8ce29b9d0d06659b$var$je = ({ name: o, code: e, encode: t })=>new $8ce29b9d0d06659b$var$ar(o, e, t);
class $8ce29b9d0d06659b$var$ar {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $8ce29b9d0d06659b$var$ge(this.code, t) : t.then((i)=>$8ce29b9d0d06659b$var$ge(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $8ce29b9d0d06659b$var$Ge = (o)=>async (e)=>new Uint8Array(await crypto.subtle.digest(o, e)), $8ce29b9d0d06659b$var$hr = $8ce29b9d0d06659b$var$je({
    name: "sha2-256",
    code: 18,
    encode: $8ce29b9d0d06659b$var$Ge("SHA-256")
}), $8ce29b9d0d06659b$var$cr = $8ce29b9d0d06659b$var$je({
    name: "sha2-512",
    code: 19,
    encode: $8ce29b9d0d06659b$var$Ge("SHA-512")
});
var $8ce29b9d0d06659b$var$lr = Object.freeze({
    __proto__: null,
    sha256: $8ce29b9d0d06659b$var$hr,
    sha512: $8ce29b9d0d06659b$var$cr
});
const $8ce29b9d0d06659b$var$Ye = 0, $8ce29b9d0d06659b$var$ur = "identity", $8ce29b9d0d06659b$var$He = $8ce29b9d0d06659b$var$Ue, $8ce29b9d0d06659b$var$dr = (o)=>$8ce29b9d0d06659b$var$ge($8ce29b9d0d06659b$var$Ye, $8ce29b9d0d06659b$var$He(o)), $8ce29b9d0d06659b$var$gr = {
    code: $8ce29b9d0d06659b$var$Ye,
    name: $8ce29b9d0d06659b$var$ur,
    encode: $8ce29b9d0d06659b$var$He,
    digest: $8ce29b9d0d06659b$var$dr
};
var $8ce29b9d0d06659b$var$pr = Object.freeze({
    __proto__: null,
    identity: $8ce29b9d0d06659b$var$gr
});
new TextEncoder, new TextDecoder;
const $8ce29b9d0d06659b$var$Je = {
    ...$8ce29b9d0d06659b$var$os,
    ...$8ce29b9d0d06659b$var$hs,
    ...$8ce29b9d0d06659b$var$ls,
    ...$8ce29b9d0d06659b$var$ds,
    ...$8ce29b9d0d06659b$var$Ds,
    ...$8ce29b9d0d06659b$var$Ts,
    ...$8ce29b9d0d06659b$var$Ss,
    ...$8ce29b9d0d06659b$var$Os,
    ...$8ce29b9d0d06659b$var$Us,
    ...$8ce29b9d0d06659b$var$Ks
};
({
    ...$8ce29b9d0d06659b$var$lr,
    ...$8ce29b9d0d06659b$var$pr
});
function $8ce29b9d0d06659b$var$Dr(o = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(o) : new Uint8Array(o);
}
function $8ce29b9d0d06659b$var$Xe(o, e, t, i) {
    return {
        name: o,
        prefix: e,
        encoder: {
            name: o,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $8ce29b9d0d06659b$var$We = $8ce29b9d0d06659b$var$Xe("utf8", "u", (o)=>"u" + new TextDecoder("utf8").decode(o), (o)=>new TextEncoder().encode(o.substring(1))), $8ce29b9d0d06659b$var$pe = $8ce29b9d0d06659b$var$Xe("ascii", "a", (o)=>{
    let e = "a";
    for(let t = 0; t < o.length; t++)e += String.fromCharCode(o[t]);
    return e;
}, (o)=>{
    o = o.substring(1);
    const e = $8ce29b9d0d06659b$var$Dr(o.length);
    for(let t = 0; t < o.length; t++)e[t] = o.charCodeAt(t);
    return e;
}), $8ce29b9d0d06659b$var$yr = {
    utf8: $8ce29b9d0d06659b$var$We,
    "utf-8": $8ce29b9d0d06659b$var$We,
    hex: $8ce29b9d0d06659b$var$Je.base16,
    latin1: $8ce29b9d0d06659b$var$pe,
    ascii: $8ce29b9d0d06659b$var$pe,
    binary: $8ce29b9d0d06659b$var$pe,
    ...$8ce29b9d0d06659b$var$Je
};
function $8ce29b9d0d06659b$var$mr(o, e = "utf8") {
    const t = $8ce29b9d0d06659b$var$yr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(o, "utf8") : t.decoder.decode(`${t.prefix}${o}`);
}
const $8ce29b9d0d06659b$export$51b1c900ac262bdf = "wc", $8ce29b9d0d06659b$export$f30bd3c8747cdfbe = 2, $8ce29b9d0d06659b$export$d47601f9de5ee22b = "core", $8ce29b9d0d06659b$export$f258d29ae5e3d545 = `${$8ce29b9d0d06659b$export$51b1c900ac262bdf}@2:${$8ce29b9d0d06659b$export$d47601f9de5ee22b}:`, $8ce29b9d0d06659b$export$db0fdb6d486555c2 = {
    name: $8ce29b9d0d06659b$export$d47601f9de5ee22b,
    logger: "error"
}, $8ce29b9d0d06659b$export$ba920abfe854b85d = {
    database: ":memory:"
}, $8ce29b9d0d06659b$export$92a79f21481c803d = "crypto", $8ce29b9d0d06659b$export$3613aa6e652146e4 = "client_ed25519_seed", $8ce29b9d0d06659b$export$c4bc5e31a4d0ec78 = (0, $8Yg5s.ONE_DAY), $8ce29b9d0d06659b$export$9d7218f72e8dc49b = "keychain", $8ce29b9d0d06659b$export$34f82f4ba0c3d769 = "0.3", $8ce29b9d0d06659b$export$9662bbc7d10cf481 = "messages", $8ce29b9d0d06659b$export$19dfd1896412c038 = "0.3", $8ce29b9d0d06659b$export$8ddbe6611b67d926 = (0, $8Yg5s.SIX_HOURS), $8ce29b9d0d06659b$export$9d92662178f2abd1 = "publisher", $8ce29b9d0d06659b$export$822d0bd1635d5360 = "irn", $8ce29b9d0d06659b$export$5176ffa6778d6637 = "error", $8ce29b9d0d06659b$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $8ce29b9d0d06659b$export$27fee22bec112637 = "wss://relay.walletconnect.org", $8ce29b9d0d06659b$export$602d6e27611c3fcb = "relayer", $8ce29b9d0d06659b$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $8ce29b9d0d06659b$export$119b4645f6b233c8 = "_subscription", $8ce29b9d0d06659b$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $8ce29b9d0d06659b$export$11ccd39be2c57d6 = (0, $8Yg5s.ONE_SECOND), $8ce29b9d0d06659b$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $8ce29b9d0d06659b$export$5f30917a6f8c9025 = "2.13.0", $8ce29b9d0d06659b$export$fb3eab7adf12329d = 1e4, $8ce29b9d0d06659b$export$629a342182ba24b = "0.3", $8ce29b9d0d06659b$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $8ce29b9d0d06659b$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $8ce29b9d0d06659b$export$9d35d0a6a3599be = (0, $8Yg5s.THIRTY_DAYS), $8ce29b9d0d06659b$export$9c3a96bb670cddb8 = "subscription", $8ce29b9d0d06659b$export$fb57e03bef4c4cea = "0.3", $8ce29b9d0d06659b$export$9a2ddbfe54f8af77 = (0, $8Yg5s.FIVE_SECONDS) * 1e3, $8ce29b9d0d06659b$export$390360ea476c6145 = "pairing", $8ce29b9d0d06659b$export$5593ec74b27d1b18 = "0.3", $8ce29b9d0d06659b$export$ee4b1978d0aedfad = (0, $8Yg5s.THIRTY_DAYS), $8ce29b9d0d06659b$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $8Yg5s.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $8Yg5s.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $8ce29b9d0d06659b$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $8ce29b9d0d06659b$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $8ce29b9d0d06659b$export$160142c73cb99dc3 = "history", $8ce29b9d0d06659b$export$8eba9ce85616c607 = "0.3", $8ce29b9d0d06659b$export$4ddf883392bbc828 = "expirer", $8ce29b9d0d06659b$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $8ce29b9d0d06659b$export$717295846191925d = "0.3", $8ce29b9d0d06659b$export$3cfe73d6765db74 = (0, $8Yg5s.ONE_DAY), $8ce29b9d0d06659b$export$3b58f2450f2297e3 = "verify-api", $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $8ce29b9d0d06659b$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org", $8ce29b9d0d06659b$export$be24df03c4baa778 = [
    $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa,
    $8ce29b9d0d06659b$export$4fe83ee8f9aec7b6
], $8ce29b9d0d06659b$export$40c022d2cffe0adc = "echo", $8ce29b9d0d06659b$export$3c48c4faab79aab1 = "https://echo.walletconnect.com";
class $8ce29b9d0d06659b$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $8ce29b9d0d06659b$export$9d7218f72e8dc49b, this.version = $8ce29b9d0d06659b$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: r } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(r);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $17d123d3e821614f$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $17d123d3e821614f$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $8ce29b9d0d06659b$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), r = $lDjQh.generateKeyPair(s);
            return $4LcoU.encodeIss(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $17d123d3e821614f$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), n = $lDjQh.generateKeyPair(r), a = (0, $17d123d3e821614f$export$d15a28e4f1821243)(), h = $8ce29b9d0d06659b$export$c4bc5e31a4d0ec78;
            return await $lDjQh.signJWT(a, s, h, n);
        }, this.generateSharedKey = (s, r, n)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), h = (0, $17d123d3e821614f$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(h, n);
        }, this.setSymKey = async (s, r)=>{
            this.isInitialized();
            const n = r || (0, $17d123d3e821614f$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(n, s), n;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, r, n)=>{
            this.isInitialized();
            const a = (0, $17d123d3e821614f$export$7949f60f2444aef2)(n), h = (0, $3zoS2.safeJsonStringify)(r);
            if ((0, $17d123d3e821614f$export$8c165704db2d5c15)(a)) {
                const m = a.senderPublicKey, L = a.receiverPublicKey;
                s = await this.generateSharedKey(m, L);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: g } = a;
            return (0, $17d123d3e821614f$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: g
            });
        }, this.decode = async (s, r, n)=>{
            this.isInitialized();
            const a = (0, $17d123d3e821614f$export$177f3e316562333d)(r, n);
            if ((0, $17d123d3e821614f$export$8c165704db2d5c15)(a)) {
                const h = a.receiverPublicKey, l = a.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $17d123d3e821614f$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: r
                });
                return (0, $3zoS2.safeJsonParse)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const r = (0, $17d123d3e821614f$export$efcd34ab6248d3cd)(s);
            return (0, $17d123d3e821614f$export$7547a514ee29b9d4)(r.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const r = (0, $17d123d3e821614f$export$efcd34ab6248d3cd)(s);
            return r.senderPublicKey ? (0, $494c115638f343c3$exports.toString)(r.senderPublicKey, (0, $17d123d3e821614f$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.keychain = i || new $8ce29b9d0d06659b$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($8ce29b9d0d06659b$export$3613aa6e652146e4);
        } catch  {
            e = (0, $17d123d3e821614f$export$d15a28e4f1821243)(), await this.keychain.set($8ce29b9d0d06659b$export$3613aa6e652146e4, e);
        }
        return $8ce29b9d0d06659b$var$mr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$export$4a2542d0790ac2fd extends (0, $85826f5a95c74020$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $8ce29b9d0d06659b$export$9662bbc7d10cf481, this.version = $8ce29b9d0d06659b$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const r = (0, $17d123d3e821614f$export$d4c241cec96564c1)(s);
            let n = this.messages.get(i);
            return typeof n > "u" && (n = {}), typeof n[r] < "u" || (n[r] = s, this.messages.set(i, n), await this.persist()), r;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const r = this.get(i), n = (0, $17d123d3e821614f$export$d4c241cec96564c1)(s);
            return typeof r[n] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $c8Vuh.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $17d123d3e821614f$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $17d123d3e821614f$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$var$vr extends (0, $85826f5a95c74020$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $ej6Nm.EventEmitter), this.name = $8ce29b9d0d06659b$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.ONE_MINUTE)), this.failedPublishTimeout = (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.ONE_SECOND)), this.needsTransportRestart = !1, this.publish = async (i, s, r)=>{
            var n;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: r
                }
            });
            const a = r?.ttl || $8ce29b9d0d06659b$export$8ddbe6611b67d926, h = (0, $17d123d3e821614f$export$cf77af25151525db)(r), l = r?.prompt || !1, d = r?.tag || 0, g = r?.id || (0, $4seG3.getBigIntRpcId)().toString(), m = {
                topic: i,
                message: s,
                opts: {
                    ttl: a,
                    relay: h,
                    prompt: l,
                    tag: d,
                    id: g
                }
            }, L = `Failed to publish payload, please try again. id:${g} tag:${d}`, u = Date.now();
            let p, T = 1;
            try {
                for(; p === void 0;){
                    if (Date.now() - u > this.publishTimeout) throw new Error(L);
                    this.logger.trace({
                        id: g,
                        attempts: T
                    }, `publisher.publish - attempt ${T}`), p = await await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.rpcPublish(i, s, a, h, l, d, g).catch((D)=>this.logger.warn(D)), this.publishTimeout, L), T++, p || await new Promise((D)=>setTimeout(D, this.failedPublishTimeout));
                }
                this.relayer.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.publish, m), this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        id: g,
                        topic: i,
                        message: s,
                        opts: r
                    }
                });
            } catch (D) {
                if (this.logger.debug("Failed to Publish Payload"), this.logger.error(D), (n = r?.internal) != null && n.throwOnFailedPublish) throw D;
                this.queue.set(g, m);
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, r, n, a) {
        var h, l, d, g;
        const m = {
            method: (0, $17d123d3e821614f$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: r,
                tag: n
            },
            id: a
        };
        return (0, $17d123d3e821614f$export$fce6876652108ab)((h = m.params) == null ? void 0 : h.prompt) && ((l = m.params) == null || delete l.prompt), (0, $17d123d3e821614f$export$fce6876652108ab)((d = m.params) == null ? void 0 : d.tag) && ((g = m.params) == null || delete g.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: m
        }), this.relayer.request(m);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $0281ada4f6245029$export$f3340c1af6bee4b5).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($8ce29b9d0d06659b$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $8ce29b9d0d06659b$var$Ir {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((r)=>r !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $8ce29b9d0d06659b$var$Cr = Object.defineProperty, $8ce29b9d0d06659b$var$Tr = Object.defineProperties, $8ce29b9d0d06659b$var$_r = Object.getOwnPropertyDescriptors, $8ce29b9d0d06659b$var$zt = Object.getOwnPropertySymbols, $8ce29b9d0d06659b$var$Rr = Object.prototype.hasOwnProperty, $8ce29b9d0d06659b$var$Sr = Object.prototype.propertyIsEnumerable, $8ce29b9d0d06659b$var$Nt = (o, e, t)=>e in o ? $8ce29b9d0d06659b$var$Cr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $8ce29b9d0d06659b$var$j = (o, e)=>{
    for(var t in e || (e = {}))$8ce29b9d0d06659b$var$Rr.call(e, t) && $8ce29b9d0d06659b$var$Nt(o, t, e[t]);
    if ($8ce29b9d0d06659b$var$zt) for (var t of $8ce29b9d0d06659b$var$zt(e))$8ce29b9d0d06659b$var$Sr.call(e, t) && $8ce29b9d0d06659b$var$Nt(o, t, e[t]);
    return o;
}, $8ce29b9d0d06659b$var$fe = (o, e)=>$8ce29b9d0d06659b$var$Tr(o, $8ce29b9d0d06659b$var$_r(e));
class $8ce29b9d0d06659b$export$60959659b2c22881 extends (0, $85826f5a95c74020$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $8ce29b9d0d06659b$var$Ir, this.events = new (0, $ej6Nm.EventEmitter), this.name = $8ce29b9d0d06659b$export$9c3a96bb670cddb8, this.version = $8ce29b9d0d06659b$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.subscribeTimeout = (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.ONE_MINUTE)), this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.pendingBatchMessages = [], this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const r = (0, $17d123d3e821614f$export$cf77af25151525db)(s), n = {
                    topic: i,
                    relay: r
                };
                this.pending.set(i, n);
                const a = await this.rpcSubscribe(i, r);
                return typeof a == "string" && (this.onSubscribe(a, n), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                })), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>{
            if (this.topics.includes(i)) return !0;
            const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
            return await new Promise((r, n)=>{
                const a = new (0, $8Yg5s.Watch);
                a.start(s);
                const h = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), a.stop(s), r(!0)), a.elapsed(s) >= $8ce29b9d0d06659b$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(s), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.start = async ()=>{
            await this.onConnect();
        }, this.stop = async ()=>{
            await this.onDisconnect();
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $17d123d3e821614f$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const r = (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $17d123d3e821614f$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.relayer.request(i).catch((s)=>this.logger.warn(s)), this.subscribeTimeout) ? (0, $17d123d3e821614f$export$d4c241cec96564c1)(e + this.clientId) : null;
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.connection_stalled);
        }
        return null;
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $17d123d3e821614f$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.relayer.request(i).catch((s)=>this.logger.warn(s)), this.subscribeTimeout);
        } catch  {
            this.relayer.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.connection_stalled);
        }
    }
    async rpcBatchFetchMessages(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $17d123d3e821614f$export$604e3deb95e1b734)(t.protocol).batchFetchMessages,
            params: {
                topics: e.map((r)=>r.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        let s;
        try {
            s = await await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.relayer.request(i).catch((r)=>this.logger.warn(r)), this.subscribeTimeout);
        } catch  {
            this.relayer.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.connection_stalled);
        }
        return s;
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $17d123d3e821614f$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $8ce29b9d0d06659b$var$fe($8ce29b9d0d06659b$var$j({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $8ce29b9d0d06659b$var$j({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t);
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $8ce29b9d0d06659b$var$j({}, t)), this.topicMap.set(t.topic, e), this.events.emit($8ce29b9d0d06659b$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($8ce29b9d0d06659b$export$24ff3e54e94ef413.deleted, $8ce29b9d0d06659b$var$fe($8ce29b9d0d06659b$var$j({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($8ce29b9d0d06659b$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchFetchMessages(i), await this.batchSubscribe(i);
            }
        }
        this.events.emit($8ce29b9d0d06659b$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $17d123d3e821614f$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$8ce29b9d0d06659b$var$fe($8ce29b9d0d06659b$var$j({}, e[s]), {
                id: i
            })));
    }
    async batchFetchMessages(e) {
        if (!e.length) return;
        this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
        const t = await this.rpcBatchFetchMessages(e);
        t && t.messages && (this.pendingBatchMessages = this.pendingBatchMessages.concat(t.messages));
    }
    async onConnect() {
        await this.restart(), this.onEnable();
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || !this.relayer.connected) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e), this.pendingBatchMessages.length && (await this.relayer.handleBatchMessageEvents(this.pendingBatchMessages), this.pendingBatchMessages = []);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $0281ada4f6245029$export$f3340c1af6bee4b5).pulse, async ()=>{
            await this.checkPending();
        }), this.events.on($8ce29b9d0d06659b$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $8ce29b9d0d06659b$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($8ce29b9d0d06659b$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $8ce29b9d0d06659b$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $8ce29b9d0d06659b$var$Pr = Object.defineProperty, $8ce29b9d0d06659b$var$Ut = Object.getOwnPropertySymbols, $8ce29b9d0d06659b$var$xr = Object.prototype.hasOwnProperty, $8ce29b9d0d06659b$var$Or = Object.prototype.propertyIsEnumerable, $8ce29b9d0d06659b$var$Ft = (o, e, t)=>e in o ? $8ce29b9d0d06659b$var$Pr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $8ce29b9d0d06659b$var$Ar = (o, e)=>{
    for(var t in e || (e = {}))$8ce29b9d0d06659b$var$xr.call(e, t) && $8ce29b9d0d06659b$var$Ft(o, t, e[t]);
    if ($8ce29b9d0d06659b$var$Ut) for (var t of $8ce29b9d0d06659b$var$Ut(e))$8ce29b9d0d06659b$var$Or.call(e, t) && $8ce29b9d0d06659b$var$Ft(o, t, e[t]);
    return o;
};
class $8ce29b9d0d06659b$export$70e73aa29a3d4407 extends (0, $85826f5a95c74020$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $ej6Nm.EventEmitter), this.name = $8ce29b9d0d06659b$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "stalled",
            "interrupted"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.heartBeatTimeout = (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.THIRTY_SECONDS) + (0, $8Yg5s.ONE_SECOND)), this.request = async (t)=>{
            var i, s;
            this.logger.debug("Publishing Request Payload");
            const r = t.id || (0, $4seG3.getBigIntRpcId)().toString();
            await this.toEstablishConnection();
            try {
                const n = this.provider.request(t);
                this.requestsInFlight.set(r, {
                    promise: n,
                    request: t
                }), this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (i = t.params) == null ? void 0 : i.topic
                }, "relayer.request - attempt to publish...");
                const a = await new Promise(async (h, l)=>{
                    const d = ()=>{
                        l(new Error(`relayer.request - publish interrupted, id: ${r}`));
                    };
                    this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, d);
                    const g = await n;
                    this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, d), h(g);
                });
                return this.logger.trace({
                    id: r,
                    method: t.method,
                    topic: (s = t.params) == null ? void 0 : s.topic
                }, "relayer.request - published"), a;
            } catch (n) {
                throw this.logger.debug(`Failed to Publish Request: ${r}`), n;
            } finally{
                this.requestsInFlight.delete(r);
            }
        }, this.resetPingTimeout = ()=>{
            if ((0, $17d123d3e821614f$export$8ee0fc9ee280b4ee)()) try {
                clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(()=>{
                    var t, i, s;
                    (s = (i = (t = this.provider) == null ? void 0 : t.connection) == null ? void 0 : i.socket) == null || s.terminate();
                }, this.heartBeatTimeout);
            } catch (t) {
                this.logger.warn(t);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t), this.resetPingTimeout();
        }, this.onConnectHandler = ()=>{
            this.startPingTimeout(), this.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $c8Vuh.generateChildLogger)(e.logger, this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($77JzN)))((0, $c8Vuh.getDefaultLoggerOptions)({
            level: e.logger || $8ce29b9d0d06659b$export$5176ffa6778d6637
        })), this.messages = new $8ce29b9d0d06659b$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $8ce29b9d0d06659b$export$60959659b2c22881(this, this.logger), this.publisher = new $8ce29b9d0d06659b$var$vr(this, this.logger), this.relayUrl = e?.relayUrl || $8ce29b9d0d06659b$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $17d123d3e821614f$export$40a40f90174d197c)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$8ce29b9d0d06659b$export$27fee22bec112637}...`), await this.restartTransport($8ce29b9d0d06659b$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && this.subscriber.pending.size === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $8ce29b9d0d06659b$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get connected() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 1;
    }
    get connecting() {
        var e, t, i;
        return ((i = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : i.readyState) === 0;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "", r;
        const n = (a)=>{
            a.topic === e && (this.subscriber.off($8ce29b9d0d06659b$export$24ff3e54e94ef413.created, n), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($8ce29b9d0d06659b$export$24ff3e54e94ef413.created, n);
            }),
            new Promise(async (a)=>{
                s = await this.subscriber.subscribe(e, t) || s, a();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportDisconnect() {
        if (!this.hasExperiencedNetworkDisruption && this.connected && this.requestsInFlight.size > 0) try {
            await Promise.all(Array.from(this.requestsInFlight.values()).map((e)=>e.promise));
        } catch (e) {
            this.logger.warn(e);
        }
        this.hasExperiencedNetworkDisruption || this.connected ? await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.onProviderDisconnect();
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, await this.transportDisconnect();
    }
    async transportOpen(e) {
        await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), await this.createProvider(), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
        try {
            await new Promise(async (t, i)=>{
                const s = ()=>{
                    this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, s), i(new Error("Connection interrupted while trying to subscribe"));
                };
                this.provider.on($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, s), await (0, $17d123d3e821614f$export$3da2293b007ed708)(this.provider.connect(), (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.ONE_MINUTE)), `Socket stalled when trying to connect to ${this.relayUrl}`).catch((r)=>{
                    i(r);
                }), await this.subscriber.start(), this.hasExperiencedNetworkDisruption = !1, t();
            });
        } catch (t) {
            this.logger.error(t);
            const i = t;
            if (this.hasExperiencedNetworkDisruption = !0, !this.isConnectionStalled(i.message)) throw t;
        } finally{
            this.connectionAttemptInProgress = !1;
        }
    }
    async restartTransport(e) {
        this.connectionAttemptInProgress || (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $17d123d3e821614f$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    async handleBatchMessageEvents(e) {
        if (e?.length === 0) {
            this.logger.trace("Batch message events is empty. Ignoring...");
            return;
        }
        const t = e.sort((i, s)=>i.publishedAt - s.publishedAt);
        this.logger.trace(`Batch of ${t.length} message events sorted`);
        for (const i of t)try {
            await this.onMessageEvent(i);
        } catch (s) {
            this.logger.warn(s);
        }
        this.logger.trace(`Batch of ${t.length} message events processed`);
    }
    startPingTimeout() {
        var e, t, i, s, r;
        if ((0, $17d123d3e821614f$export$8ee0fc9ee280b4ee)()) try {
            (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((r = (s = (i = this.provider) == null ? void 0 : i.connection) == null ? void 0 : s.socket) == null || r.once("ping", ()=>{
                this.resetPingTimeout();
            })), this.resetPingTimeout();
        } catch (n) {
            this.logger.warn(n);
        }
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $8jexD.default)((0, $17d123d3e821614f$export$d875b3963ef774f5)({
            sdkVersion: $8ce29b9d0d06659b$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $5h2x7.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith($8ce29b9d0d06659b$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: r } = t.data, n = {
                topic: i,
                message: s,
                publishedAt: r
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($8ce29b9d0d06659b$var$Ar({
                type: "event",
                event: t.id
            }, n)), this.events.emit(t.id, n), await this.acknowledgePayload(e), await this.onMessageEvent(n);
        } else (0, $5h2x7.isJsonRpcResponse)(e) && this.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $4seG3.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($8ce29b9d0d06659b$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
    }
    async registerEventListeners() {
        let e = await (0, $17d123d3e821614f$export$53c2fd0173ad2b80)();
        (0, $17d123d3e821614f$export$600a1ee4bc680996)(async (t)=>{
            e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
        });
    }
    async onProviderDisconnect() {
        await this.subscriber.stop(), this.requestsInFlight.clear(), clearTimeout(this.pingTimeout), this.events.emit($8ce29b9d0d06659b$export$d56245796e2837d.disconnect), this.connectionAttemptInProgress = !1, !this.transportExplicitlyClosed && setTimeout(async ()=>{
            await this.transportOpen().catch((e)=>this.logger.error(e));
        }, (0, $8Yg5s.toMiliseconds)($8ce29b9d0d06659b$export$11ccd39be2c57d6));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        await this.confirmOnlineStateOrThrow(), !this.connected && (this.connectionAttemptInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.connected && (clearInterval(t), e());
            }, this.connectionStatusPollingInterval);
        }), await this.transportOpen());
    }
}
var $8ce29b9d0d06659b$var$zr = Object.defineProperty, $8ce29b9d0d06659b$var$Bt = Object.getOwnPropertySymbols, $8ce29b9d0d06659b$var$Nr = Object.prototype.hasOwnProperty, $8ce29b9d0d06659b$var$Lr = Object.prototype.propertyIsEnumerable, $8ce29b9d0d06659b$var$Mt = (o, e, t)=>e in o ? $8ce29b9d0d06659b$var$zr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $8ce29b9d0d06659b$var$kt = (o, e)=>{
    for(var t in e || (e = {}))$8ce29b9d0d06659b$var$Nr.call(e, t) && $8ce29b9d0d06659b$var$Mt(o, t, e[t]);
    if ($8ce29b9d0d06659b$var$Bt) for (var t of $8ce29b9d0d06659b$var$Bt(e))$8ce29b9d0d06659b$var$Lr.call(e, t) && $8ce29b9d0d06659b$var$Mt(o, t, e[t]);
    return o;
};
class $8ce29b9d0d06659b$export$390f32400eaf98c9 extends (0, $85826f5a95c74020$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $8ce29b9d0d06659b$export$f258d29ae5e3d545, r){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $8ce29b9d0d06659b$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.recentlyDeleted = [], this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((n)=>{
                this.getKey && n !== null && !(0, $17d123d3e821614f$export$fce6876652108ab)(n) ? this.map.set(this.getKey(n), n) : (0, $17d123d3e821614f$export$f657f7976bb2769d)(n) ? this.map.set(n.id, n) : (0, $17d123d3e821614f$export$c96d5113768aaf5e)(n) && this.map.set(n.topic, n);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (n, a)=>{
            this.isInitialized(), this.map.has(n) ? await this.update(n, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: n,
                value: a
            }), this.map.set(n, a), await this.persist());
        }, this.get = (n)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: n
            }), this.getData(n)), this.getAll = (n)=>(this.isInitialized(), n ? this.values.filter((a)=>Object.keys(n).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($8ne5u)))(a[h], n[h]))) : this.values), this.update = async (n, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: n,
                update: a
            });
            const h = $8ce29b9d0d06659b$var$kt($8ce29b9d0d06659b$var$kt({}, this.getData(n)), a);
            this.map.set(n, h), await this.persist();
        }, this.delete = async (n, a)=>{
            this.isInitialized(), this.map.has(n) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: n,
                reason: a
            }), this.map.delete(n), this.addToRecentlyDeleted(n), await this.persist());
        }, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = r;
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    addToRecentlyDeleted(e) {
        this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            if (this.recentlyDeleted.includes(e)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
                throw this.logger.error(s), new Error(s);
            }
            const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $8ce29b9d0d06659b$export$390360ea476c6145, this.version = $8ce29b9d0d06659b$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($ej6Nm))), this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $17d123d3e821614f$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async (i)=>{
            this.isInitialized();
            const s = (0, $17d123d3e821614f$export$d15a28e4f1821243)(), r = await this.core.crypto.setSymKey(s), n = (0, $17d123d3e821614f$export$b136d03015bfc12)((0, $8Yg5s.FIVE_MINUTES)), a = {
                protocol: $8ce29b9d0d06659b$export$822d0bd1635d5360
            }, h = {
                topic: r,
                expiry: n,
                relay: a,
                active: !1
            }, l = (0, $17d123d3e821614f$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: r,
                symKey: s,
                relay: a,
                expiryTimestamp: n,
                methods: i?.methods
            });
            return this.core.expirer.set(r, n), await this.pairings.set(r, h), await this.core.relayer.subscribe(r), {
                topic: r,
                uri: l
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: r, relay: n, expiryTimestamp: a, methods: h } = (0, $17d123d3e821614f$export$59f58847421cfb28)(i.uri);
            let l;
            if (this.pairings.keys.includes(s) && (l = this.pairings.get(s), l.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            const d = a || (0, $17d123d3e821614f$export$b136d03015bfc12)((0, $8Yg5s.FIVE_MINUTES)), g = {
                topic: s,
                relay: n,
                expiry: d,
                active: !1,
                methods: h
            };
            return this.core.expirer.set(s, d), await this.pairings.set(s, g), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($8ce29b9d0d06659b$export$ca3c0b962acf7b75.create, g), this.core.crypto.keychain.has(s) || await this.core.crypto.setSymKey(r, s), await this.core.relayer.subscribe(s, {
                relay: n
            }), g;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $17d123d3e821614f$export$b136d03015bfc12)((0, $8Yg5s.THIRTY_DAYS));
            this.core.expirer.set(i, s), await this.pairings.update(i, {
                active: !0,
                expiry: s
            });
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const r = await this.sendRequest(s, "wc_pairingPing", {}), { done: n, resolve: a, reject: h } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: l })=>{
                    l ? h(l) : a();
                }), await n();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, r)=>{
            const n = (0, $4seG3.formatJsonRpcRequest)(s, r), a = await this.core.crypto.encode(i, n), h = $8ce29b9d0d06659b$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, n), this.core.relayer.publish(i, a, h), n.id;
        }, this.sendResult = async (i, s, r)=>{
            const n = (0, $4seG3.formatJsonRpcResult)(i, r), a = await this.core.crypto.encode(s, n), h = await this.core.history.get(s, i), l = $8ce29b9d0d06659b$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(n);
        }, this.sendError = async (i, s, r)=>{
            const n = (0, $4seG3.formatJsonRpcError)(i, r), a = await this.core.crypto.encode(s, n), h = await this.core.history.get(s, i), l = $8ce29b9d0d06659b$export$d94d6986a8185883[h.request.method] ? $8ce29b9d0d06659b$export$d94d6986a8185883[h.request.method].res : $8ce29b9d0d06659b$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(n);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $17d123d3e821614f$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: r } = i;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, r);
                default:
                    return this.onUnknownRpcMethodRequest(s, r);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: r } = i, n = (await this.core.history.get(s, r.id)).request.method;
            switch(n){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, r);
                default:
                    return this.onUnknownRpcMethodResponse(n);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(r, i, !0), this.events.emit($8ce29b9d0d06659b$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: i
                });
            } catch (n) {
                await this.sendError(r, i, n), this.logger.error(n);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: r } = s;
            setTimeout(()=>{
                (0, $5h2x7.isJsonRpcResult)(s) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $5h2x7.isJsonRpcError)(s) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($8ce29b9d0d06659b$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: i
                });
            } catch (n) {
                await this.sendError(r, i, n), this.logger.error(n);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: r, method: n } = s;
            try {
                if (this.registeredMethods.includes(n)) return;
                const a = (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", n);
                await this.sendError(r, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $17d123d3e821614f$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            var s;
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(i)) {
                const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(n);
            }
            if (!(0, $17d123d3e821614f$export$bef94a5618bf18bf)(i.uri)) {
                const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(n);
            }
            const r = (0, $17d123d3e821614f$export$59f58847421cfb28)(i.uri);
            if (!((s = r?.relay) != null && s.protocol)) {
                const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw new Error(n);
            }
            if (!(r != null && r.symKey)) {
                const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw new Error(n);
            }
            if (r != null && r.expiryTimestamp && (0, $8Yg5s.toMiliseconds)(r?.expiryTimestamp) < Date.now()) {
                const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(n);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $17d123d3e821614f$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.pairings = new $8ce29b9d0d06659b$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($8ce29b9d0d06659b$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $5h2x7.isJsonRpcRequest)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $5h2x7.isJsonRpcResponse)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($8ce29b9d0d06659b$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $17d123d3e821614f$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($8ce29b9d0d06659b$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $8ce29b9d0d06659b$export$eeb4f10f25d479cb extends (0, $85826f5a95c74020$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $ej6Nm.EventEmitter), this.name = $8ce29b9d0d06659b$export$160142c73cb99dc3, this.version = $8ce29b9d0d06659b$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: r
            }), this.records.has(s.id)) return;
            const n = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: r,
                expiry: (0, $17d123d3e821614f$export$b136d03015bfc12)((0, $8Yg5s.THIRTY_DAYS))
            };
            this.records.set(n.id, n), this.persist(), this.events.emit($8ce29b9d0d06659b$export$a682338b5ffca937.created, n);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $5h2x7.isJsonRpcError)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.persist(), this.events.emit($8ce29b9d0d06659b$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((r)=>{
                if (r.topic === i) {
                    if (typeof s < "u" && r.id !== s) return;
                    this.records.delete(r.id), this.events.emit($8ce29b9d0d06659b$export$a682338b5ffca937.deleted, r);
                }
            }), this.persist();
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $4seG3.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($8ce29b9d0d06659b$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($8ce29b9d0d06659b$export$a682338b5ffca937.created, (e)=>{
            const t = $8ce29b9d0d06659b$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($8ce29b9d0d06659b$export$a682338b5ffca937.updated, (e)=>{
            const t = $8ce29b9d0d06659b$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.events.on($8ce29b9d0d06659b$export$a682338b5ffca937.deleted, (e)=>{
            const t = $8ce29b9d0d06659b$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            });
        }), this.core.heartbeat.on((0, $0281ada4f6245029$export$f3340c1af6bee4b5).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.isInitialized();
            let e = !1;
            this.records.forEach((t)=>{
                (0, $8Yg5s.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${t.id}`), this.records.delete(t.id), this.events.emit($8ce29b9d0d06659b$export$a682338b5ffca937.deleted, t, !1), e = !0);
            }), e && this.persist();
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$export$e76805ce609031cb extends (0, $85826f5a95c74020$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $ej6Nm.EventEmitter), this.name = $8ce29b9d0d06659b$export$4ddf883392bbc828, this.version = $8ce29b9d0d06659b$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $8ce29b9d0d06659b$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const r = this.formatTarget(i), n = {
                target: r,
                expiry: s
            };
            this.expirations.set(r, n), this.checkExpiry(r, n), this.events.emit($8ce29b9d0d06659b$export$9013719d9206b0c1.created, {
                target: r,
                expiration: n
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), r = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($8ce29b9d0d06659b$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: r
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $17d123d3e821614f$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $17d123d3e821614f$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($8ce29b9d0d06659b$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.warn(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $8Yg5s.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($8ce29b9d0d06659b$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $0281ada4f6245029$export$f3340c1af6bee4b5).pulse, ()=>this.checkExpirations()), this.events.on($8ce29b9d0d06659b$export$9013719d9206b0c1.created, (e)=>{
            const t = $8ce29b9d0d06659b$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($8ce29b9d0d06659b$export$9013719d9206b0c1.expired, (e)=>{
            const t = $8ce29b9d0d06659b$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($8ce29b9d0d06659b$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $8ce29b9d0d06659b$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $8ce29b9d0d06659b$export$91a8e56769aeb334 extends (0, $85826f5a95c74020$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $8ce29b9d0d06659b$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $17d123d3e821614f$export$f7a1e23e542d38e3)() || !(0, $17d123d3e821614f$export$4e09c449d6c407f7)()) return;
            const s = this.getVerifyUrl(i?.verifyUrl);
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (r) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $8ce29b9d0d06659b$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (r) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = this.getVerifyUrl(i?.verifyUrl);
            let r;
            try {
                r = await this.fetchAttestation(i.attestationId, s);
            } catch (n) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(n), r = await this.fetchAttestation(i.attestationId, $8ce29b9d0d06659b$export$4fe83ee8f9aec7b6);
            }
            return r;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const r = this.startAbortTimer((0, $8Yg5s.ONE_SECOND) * 2), n = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(r), n.status === 200 ? await n.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (r)=>{
                r.data === "verify_ready" && (this.onInit(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((r)=>{
                    const n = document.getElementById($8ce29b9d0d06659b$export$3b58f2450f2297e3);
                    if (n) return this.iframe = n, this.onInit(), r();
                    window.addEventListener("message", s);
                    const a = document.createElement("iframe");
                    a.id = $8ce29b9d0d06659b$export$3b58f2450f2297e3, a.src = `${this.verifyUrl}/${this.projectId}`, a.style.display = "none", document.body.append(a), this.iframe = a, i = r;
                }),
                new Promise((r, n)=>setTimeout(()=>{
                        window.removeEventListener("message", s), n("verify iframe load timeout");
                    }, (0, $8Yg5s.toMiliseconds)((0, $8Yg5s.FIVE_SECONDS))))
            ]);
        }, this.onInit = ()=>{
            this.initialized = !0, this.processQueue();
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.getVerifyUrl = (i)=>{
            let s = i || $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa;
            return $8ce29b9d0d06659b$export$be24df03c4baa778.includes(s) || (this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${$8ce29b9d0d06659b$export$7e3b1a28ddecdbaa}`), s = $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa), s;
        }, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.verifyUrl = $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $17d123d3e821614f$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $8Yg5s.toMiliseconds)(e));
    }
}
class $8ce29b9d0d06659b$export$c393c48c5b0cf59a extends (0, $85826f5a95c74020$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $8ce29b9d0d06659b$export$40c022d2cffe0adc, this.registerDeviceToken = async (i)=>{
            const { clientId: s, token: r, notificationType: n, enableEncrypted: a = !1 } = i, h = `${$8ce29b9d0d06659b$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await (0, (/*@__PURE__*/$parcel$interopDefault($fdSc8)))(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: n,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $c8Vuh.generateChildLogger)(t, this.context);
    }
}
var $8ce29b9d0d06659b$var$Ur = Object.defineProperty, $8ce29b9d0d06659b$var$Ht = Object.getOwnPropertySymbols, $8ce29b9d0d06659b$var$Fr = Object.prototype.hasOwnProperty, $8ce29b9d0d06659b$var$$r = Object.prototype.propertyIsEnumerable, $8ce29b9d0d06659b$var$Jt = (o, e, t)=>e in o ? $8ce29b9d0d06659b$var$Ur(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t, $8ce29b9d0d06659b$var$Xt = (o, e)=>{
    for(var t in e || (e = {}))$8ce29b9d0d06659b$var$Fr.call(e, t) && $8ce29b9d0d06659b$var$Jt(o, t, e[t]);
    if ($8ce29b9d0d06659b$var$Ht) for (var t of $8ce29b9d0d06659b$var$Ht(e))$8ce29b9d0d06659b$var$$r.call(e, t) && $8ce29b9d0d06659b$var$Jt(o, t, e[t]);
    return o;
};
class $8ce29b9d0d06659b$export$2e2bcd8739ae039 extends (0, $85826f5a95c74020$export$ed533416df113881) {
    constructor(e){
        var t;
        super(e), this.protocol = $8ce29b9d0d06659b$export$51b1c900ac262bdf, this.version = $8ce29b9d0d06659b$export$f30bd3c8747cdfbe, this.name = $8ce29b9d0d06659b$export$d47601f9de5ee22b, this.events = new (0, $ej6Nm.EventEmitter), this.initialized = !1, this.on = (n, a)=>this.events.on(n, a), this.once = (n, a)=>this.events.once(n, a), this.off = (n, a)=>this.events.off(n, a), this.removeListener = (n, a)=>this.events.removeListener(n, a), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $8ce29b9d0d06659b$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const i = (0, $c8Vuh.getDefaultLoggerOptions)({
            level: typeof e?.logger == "string" && e.logger ? e.logger : $8ce29b9d0d06659b$export$db0fdb6d486555c2.logger
        }), { logger: s, chunkLoggerController: r } = (0, $c8Vuh.generatePlatformLogger)({
            opts: i,
            maxSizeInBytes: e?.maxLogBlobSizeInBytes,
            loggerOverride: e?.logger
        });
        this.logChunkController = r, (t = this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async ()=>{
            var n, a;
            (n = this.logChunkController) != null && n.downloadLogsBlobInBrowser && ((a = this.logChunkController) == null || a.downloadLogsBlobInBrowser({
                clientId: await this.crypto.getClientId()
            }));
        }), this.logger = (0, $c8Vuh.generateChildLogger)(s, this.name), this.heartbeat = new (0, $0281ada4f6245029$export$996c9b2cd7645b55), this.crypto = new $8ce29b9d0d06659b$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $8ce29b9d0d06659b$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $8ce29b9d0d06659b$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $6QZmz.default)($8ce29b9d0d06659b$var$Xt($8ce29b9d0d06659b$var$Xt({}, $8ce29b9d0d06659b$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $8ce29b9d0d06659b$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $8ce29b9d0d06659b$export$3370ee24730992a3(this, this.logger), this.verify = new $8ce29b9d0d06659b$export$91a8e56769aeb334(this.projectId || "", this.logger), this.echoClient = new $8ce29b9d0d06659b$export$c393c48c5b0cf59a(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $8ce29b9d0d06659b$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($8ce29b9d0d06659b$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async getLogsBlob() {
        var e;
        return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({
            clientId: await this.crypto.getClientId()
        });
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $8ce29b9d0d06659b$export$4143ab5b91744744 = $8ce29b9d0d06659b$export$2e2bcd8739ae039;



var $c8Vuh = parcelRequire("c8Vuh");
var $77JzN = parcelRequire("77JzN");



var $ej6Nm = parcelRequire("ej6Nm");

var $8Yg5s = parcelRequire("8Yg5s");
parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
var $5h2x7 = parcelRequire("5h2x7");
const $47c1d2f2edc36dab$export$4fa962fc67384e02 = "wc", $47c1d2f2edc36dab$export$61085c48796ff049 = 2, $47c1d2f2edc36dab$export$94715592c220319a = "client", $47c1d2f2edc36dab$export$7fa6f9ee1e2cab96 = `${$47c1d2f2edc36dab$export$4fa962fc67384e02}@${$47c1d2f2edc36dab$export$61085c48796ff049}:${$47c1d2f2edc36dab$export$94715592c220319a}:`, $47c1d2f2edc36dab$export$8dffb3242f2c5f72 = {
    name: $47c1d2f2edc36dab$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $47c1d2f2edc36dab$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire"
}, $47c1d2f2edc36dab$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $47c1d2f2edc36dab$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $47c1d2f2edc36dab$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $47c1d2f2edc36dab$export$160142c73cb99dc3 = "history", $47c1d2f2edc36dab$export$8eba9ce85616c607 = "0.3", $47c1d2f2edc36dab$export$ae6c7a4f7ed730a1 = "proposal", $47c1d2f2edc36dab$export$6db28e89b135a53c = (0, $8Yg5s.THIRTY_DAYS), $47c1d2f2edc36dab$export$1e6a4dc5172f4830 = "Proposal expired", $47c1d2f2edc36dab$export$a069e98a8dfeec1e = "session", $47c1d2f2edc36dab$export$84b1b9dbcdea0475 = (0, $8Yg5s.SEVEN_DAYS), $47c1d2f2edc36dab$export$2db42d5151ad6eb8 = "engine", $47c1d2f2edc36dab$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $8Yg5s.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $8Yg5s.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $8Yg5s.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $8Yg5s.ONE_HOUR),
            prompt: !1,
            tag: 1117
        }
    }
}, $47c1d2f2edc36dab$export$409f0c0a13a1b7c6 = {
    min: (0, $8Yg5s.FIVE_MINUTES),
    max: (0, $8Yg5s.SEVEN_DAYS)
}, $47c1d2f2edc36dab$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $47c1d2f2edc36dab$export$40b296af21bd38a4 = "request", $47c1d2f2edc36dab$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
], $47c1d2f2edc36dab$export$e24c518fa7fc04c = "wc", $47c1d2f2edc36dab$export$af233b4aa2e30834 = 1.5, $47c1d2f2edc36dab$export$e8b9bbdca3ac0ed = "auth", $47c1d2f2edc36dab$export$ab815cb37981e7e0 = "authKeys", $47c1d2f2edc36dab$export$5d9af9e20f678626 = "pairingTopics", $47c1d2f2edc36dab$export$3643b3579d091159 = "requests", $47c1d2f2edc36dab$export$323ba3ebb8028ed0 = `${$47c1d2f2edc36dab$export$e24c518fa7fc04c}@${1.5}:${$47c1d2f2edc36dab$export$e8b9bbdca3ac0ed}:`, $47c1d2f2edc36dab$export$efef74cb455ac30f = `${$47c1d2f2edc36dab$export$323ba3ebb8028ed0}:PUB_KEY`;
var $47c1d2f2edc36dab$var$Yt = Object.defineProperty, $47c1d2f2edc36dab$var$Xt = Object.defineProperties, $47c1d2f2edc36dab$var$Jt = Object.getOwnPropertyDescriptors, $47c1d2f2edc36dab$var$Be = Object.getOwnPropertySymbols, $47c1d2f2edc36dab$var$Bt = Object.prototype.hasOwnProperty, $47c1d2f2edc36dab$var$Wt = Object.prototype.propertyIsEnumerable, $47c1d2f2edc36dab$var$We = (R, n, t)=>n in R ? $47c1d2f2edc36dab$var$Yt(R, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : R[n] = t, $47c1d2f2edc36dab$var$y = (R, n)=>{
    for(var t in n || (n = {}))$47c1d2f2edc36dab$var$Bt.call(n, t) && $47c1d2f2edc36dab$var$We(R, t, n[t]);
    if ($47c1d2f2edc36dab$var$Be) for (var t of $47c1d2f2edc36dab$var$Be(n))$47c1d2f2edc36dab$var$Wt.call(n, t) && $47c1d2f2edc36dab$var$We(R, t, n[t]);
    return R;
}, $47c1d2f2edc36dab$var$M = (R, n)=>$47c1d2f2edc36dab$var$Xt(R, $47c1d2f2edc36dab$var$Jt(n));
class $47c1d2f2edc36dab$var$Zt extends (0, $85826f5a95c74020$export$87df43c730effa30) {
    constructor(n){
        super(n), this.name = $47c1d2f2edc36dab$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($ej6Nm))), this.initialized = !1, this.requestQueue = {
            state: $47c1d2f2edc36dab$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $47c1d2f2edc36dab$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $8Yg5s.ONE_SECOND), this.expectedPairingMethodMap = new Map, this.recentlyDeletedMap = new Map, this.recentlyDeletedLimit = 200, this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($47c1d2f2edc36dab$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $8Yg5s.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (t)=>{
            await this.isInitialized();
            const e = $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, t), {
                requiredNamespaces: t.requiredNamespaces || {},
                optionalNamespaces: t.optionalNamespaces || {}
            });
            await this.isValidConnect(e);
            const { pairingTopic: s, requiredNamespaces: i, optionalNamespaces: r, sessionProperties: o, relays: a } = e;
            let c = s, h, p = !1;
            try {
                c && (p = this.client.core.pairing.pairings.get(c).active);
            } catch (P) {
                throw this.client.logger.error(`connect() -> pairing.get(${c}) failed`), P;
            }
            if (!c || !p) {
                const { topic: P, uri: v } = await this.client.core.pairing.create();
                c = P, h = v;
            }
            if (!c) {
                const { message: P } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(P);
            }
            const g = await this.client.core.crypto.generateKeyPair(), d = $47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $8Yg5s.FIVE_MINUTES), w = (0, $17d123d3e821614f$export$b136d03015bfc12)(d), m = $47c1d2f2edc36dab$var$y({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: a ?? [
                    {
                        protocol: (0, $8ce29b9d0d06659b$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: g,
                    metadata: this.client.metadata
                },
                expiryTimestamp: w
            }, o && {
                sessionProperties: o
            }), { reject: E, resolve: O, done: S } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)(d, $47c1d2f2edc36dab$export$1e6a4dc5172f4830);
            this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: P, session: v })=>{
                if (P) E(P);
                else if (v) {
                    v.self.publicKey = g;
                    const B = $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, v), {
                        requiredNamespaces: m.requiredNamespaces,
                        optionalNamespaces: m.optionalNamespaces
                    });
                    await this.client.session.set(v.topic, B), await this.setExpiry(v.topic, v.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: v.peer.metadata
                    }), O(B);
                }
            });
            const N = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: m,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(N, $47c1d2f2edc36dab$var$y({
                id: N
            }, m)), {
                uri: h,
                approval: S
            };
        }, this.pair = async (t)=>{
            await this.isInitialized();
            try {
                return await this.client.core.pairing.pair(t);
            } catch (e) {
                throw this.client.logger.error("pair() failed"), e;
            }
        }, this.approve = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidApprove(t);
            } catch (S) {
                throw this.client.logger.error("approve() -> isValidApprove() failed"), S;
            }
            const { id: e, relayProtocol: s, namespaces: i, sessionProperties: r, sessionConfig: o } = t;
            let a;
            try {
                a = this.client.proposal.get(e);
            } catch (S) {
                throw this.client.logger.error(`approve() -> proposal.get(${e}) failed`), S;
            }
            let { pairingTopic: c, proposer: h, requiredNamespaces: p, optionalNamespaces: g } = a;
            c = c || "";
            const d = await this.client.core.crypto.generateKeyPair(), w = h.publicKey, m = await this.client.core.crypto.generateSharedKey(d, w), E = $47c1d2f2edc36dab$var$y($47c1d2f2edc36dab$var$y({
                relay: {
                    protocol: s ?? "irn"
                },
                namespaces: i,
                pairingTopic: c,
                controller: {
                    publicKey: d,
                    metadata: this.client.metadata
                },
                expiry: (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475)
            }, r && {
                sessionProperties: r
            }), o && {
                sessionConfig: o
            });
            await this.client.core.relayer.subscribe(m);
            const O = $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, E), {
                topic: m,
                requiredNamespaces: p,
                optionalNamespaces: g,
                pairingTopic: c,
                acknowledged: !1,
                self: E.controller,
                peer: {
                    publicKey: h.publicKey,
                    metadata: h.metadata
                },
                controller: d
            });
            await this.client.session.set(m, O);
            try {
                await this.sendResult({
                    id: e,
                    topic: c,
                    result: {
                        relay: {
                            protocol: s ?? "irn"
                        },
                        responderPublicKey: d
                    },
                    throwOnFailedPublish: !0
                }), await this.sendRequest({
                    topic: m,
                    method: "wc_sessionSettle",
                    params: E,
                    throwOnFailedPublish: !0
                });
            } catch (S) {
                throw this.client.logger.error(S), this.client.session.delete(m, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(m), S;
            }
            return await this.client.core.pairing.updateMetadata({
                topic: c,
                metadata: h.metadata
            }), await this.client.proposal.delete(e, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: c
            }), await this.setExpiry(m, (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475)), {
                topic: m,
                acknowledged: ()=>new Promise((S)=>setTimeout(()=>S(this.client.session.get(m)), 500))
            };
        }, this.reject = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidReject(t);
            } catch (r) {
                throw this.client.logger.error("reject() -> isValidReject() failed"), r;
            }
            const { id: e, reason: s } = t;
            let i;
            try {
                i = this.client.proposal.get(e).pairingTopic;
            } catch (r) {
                throw this.client.logger.error(`reject() -> proposal.get(${e}) failed`), r;
            }
            i && (await this.sendError({
                id: e,
                topic: i,
                error: s
            }), await this.client.proposal.delete(e, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidUpdate(t);
            } catch (p) {
                throw this.client.logger.error("update() -> isValidUpdate() failed"), p;
            }
            const { topic: e, namespaces: s } = t, { done: i, resolve: r, reject: o } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)(), a = (0, $4seG3.payloadId)(), c = (0, $4seG3.getBigIntRpcId)().toString(), h = this.client.session.get(e).namespaces;
            return this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_update", a), ({ error: p })=>{
                p ? o(p) : r();
            }), await this.client.session.update(e, {
                namespaces: s
            }), await this.sendRequest({
                topic: e,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: c
            }).catch((p)=>{
                this.client.logger.error(p), this.client.session.update(e, {
                    namespaces: h
                }), o(p);
            }), {
                acknowledged: i
            };
        }, this.extend = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidExtend(t);
            } catch (a) {
                throw this.client.logger.error("extend() -> isValidExtend() failed"), a;
            }
            const { topic: e } = t, s = (0, $4seG3.payloadId)(), { done: i, resolve: r, reject: o } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_extend", s), ({ error: a })=>{
                a ? o(a) : r();
            }), await this.setExpiry(e, (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475)), this.sendRequest({
                topic: e,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
            }).catch((a)=>{
                o(a);
            }), {
                acknowledged: i
            };
        }, this.request = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidRequest(t);
            } catch (d) {
                throw this.client.logger.error("request() -> isValidRequest() failed"), d;
            }
            const { chainId: e, request: s, topic: i, expiry: r = $47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = t, o = this.client.session.get(i), a = (0, $4seG3.payloadId)(), c = (0, $4seG3.getBigIntRpcId)().toString(), { done: h, resolve: p, reject: g } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)(r, "Request expired. Please try again.");
            return this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", a), ({ error: d, result: w })=>{
                d ? g(d) : p(w);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: a,
                        relayRpcId: c,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, s), {
                                expiryTimestamp: (0, $17d123d3e821614f$export$b136d03015bfc12)(r)
                            }),
                            chainId: e
                        },
                        expiry: r,
                        throwOnFailedPublish: !0
                    }).catch((w)=>g(w)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: s,
                        chainId: e,
                        id: a
                    }), d();
                }),
                new Promise(async (d)=>{
                    var w;
                    if (!((w = o.sessionConfig) != null && w.disableDeepLink)) {
                        const m = await (0, $17d123d3e821614f$export$e55bfdac47149a32)(this.client.core.storage, $47c1d2f2edc36dab$export$a26ccd6441b7d638);
                        (0, $17d123d3e821614f$export$694a208c8abca99a)({
                            id: a,
                            topic: i,
                            wcDeepLink: m
                        });
                    }
                    d();
                }),
                h()
            ]).then((d)=>d[2]);
        }, this.respond = async (t)=>{
            await this.isInitialized(), await this.isValidRespond(t);
            const { topic: e, response: s } = t, { id: i } = s;
            (0, $5h2x7.isJsonRpcResult)(s) ? await this.sendResult({
                id: i,
                topic: e,
                result: s.result,
                throwOnFailedPublish: !0
            }) : (0, $5h2x7.isJsonRpcError)(s) && await this.sendError({
                id: i,
                topic: e,
                error: s.error
            }), this.cleanupAfterResponse(t);
        }, this.ping = async (t)=>{
            await this.isInitialized();
            try {
                await this.isValidPing(t);
            } catch (s) {
                throw this.client.logger.error("ping() -> isValidPing() failed"), s;
            }
            const { topic: e } = t;
            if (this.client.session.keys.includes(e)) {
                const s = (0, $4seG3.payloadId)(), i = (0, $4seG3.getBigIntRpcId)().toString(), { done: r, resolve: o, reject: a } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_ping", s), ({ error: c })=>{
                    c ? a(c) : o();
                }), await Promise.all([
                    this.sendRequest({
                        topic: e,
                        method: "wc_sessionPing",
                        params: {},
                        throwOnFailedPublish: !0,
                        clientRpcId: s,
                        relayRpcId: i
                    }),
                    r()
                ]);
            } else this.client.core.pairing.pairings.keys.includes(e) && await this.client.core.pairing.ping({
                topic: e
            });
        }, this.emit = async (t)=>{
            await this.isInitialized(), await this.isValidEmit(t);
            const { topic: e, event: s, chainId: i } = t, r = (0, $4seG3.getBigIntRpcId)().toString();
            await this.sendRequest({
                topic: e,
                method: "wc_sessionEvent",
                params: {
                    event: s,
                    chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r
            });
        }, this.disconnect = async (t)=>{
            await this.isInitialized(), await this.isValidDisconnect(t);
            const { topic: e } = t;
            if (this.client.session.keys.includes(e)) await this.sendRequest({
                topic: e,
                method: "wc_sessionDelete",
                params: (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: e,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(e)) await this.client.core.pairing.disconnect({
                topic: e
            });
            else {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${e}`);
                throw new Error(s);
            }
        }, this.find = (t)=>(this.isInitialized(), this.client.session.getAll().filter((e)=>(0, $17d123d3e821614f$export$6fc4971bf8f326a)(e, t))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.authenticate = async (t)=>{
            this.isInitialized(), this.isValidAuthenticate(t);
            const { chains: e, statement: s = "", uri: i, domain: r, nonce: o, type: a, exp: c, nbf: h, methods: p = [], expiry: g } = t, d = [
                ...t.resources || []
            ], { topic: w, uri: m } = await this.client.core.pairing.create({
                methods: [
                    "wc_sessionAuthenticate"
                ]
            });
            this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                    topic: w,
                    uri: m
                }
            });
            const E = await this.client.core.crypto.generateKeyPair(), O = (0, $17d123d3e821614f$export$1e87d19d4aab5805)(E);
            if (await Promise.all([
                this.client.auth.authKeys.set($47c1d2f2edc36dab$export$efef74cb455ac30f, {
                    responseTopic: O,
                    publicKey: E
                }),
                this.client.auth.pairingTopics.set(O, {
                    topic: O,
                    pairingTopic: w
                })
            ]), await this.client.core.relayer.subscribe(O), this.client.logger.info(`sending request to new pairing topic: ${w}`), p.length > 0) {
                const { namespace: T } = (0, $17d123d3e821614f$export$4764229d78de4437)(e[0]);
                let _ = (0, $17d123d3e821614f$export$2bc35d2a08a09ad5)(T, "request", p);
                (0, $17d123d3e821614f$export$3bb18ae0fb9a9fa9)(d) && (_ = (0, $17d123d3e821614f$export$c7a40c552af428b5)(_, d.pop())), d.push(_);
            }
            const S = g && g > $47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? g : $47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, N = {
                authPayload: {
                    type: a ?? "caip122",
                    chains: e,
                    statement: s,
                    aud: i,
                    domain: r,
                    version: "1",
                    nonce: o,
                    iat: new Date().toISOString(),
                    exp: c,
                    nbf: h,
                    resources: d
                },
                requester: {
                    publicKey: E,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $17d123d3e821614f$export$b136d03015bfc12)(S)
            }, P = {
                eip155: {
                    chains: e,
                    methods: [
                        ...new Set([
                            "personal_sign",
                            ...p
                        ])
                    ],
                    events: [
                        "chainChanged",
                        "accountsChanged"
                    ]
                }
            }, v = {
                requiredNamespaces: {},
                optionalNamespaces: P,
                relays: [
                    {
                        protocol: "irn"
                    }
                ],
                proposer: {
                    publicKey: E,
                    metadata: this.client.metadata
                },
                expiryTimestamp: (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)
            }, { done: B, resolve: Ie, reject: ae } = (0, $17d123d3e821614f$export$cbf9e3cc9ffc85cb)(S, "Request expired"), W = async ({ error: T, session: _ })=>{
                if (this.events.off((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", K), ce), T) ae(T);
                else if (_) {
                    _.self.publicKey = E, await this.client.session.set(_.topic, _), await this.setExpiry(_.topic, _.expiry), w && await this.client.core.pairing.updateMetadata({
                        topic: w,
                        metadata: _.peer.metadata
                    });
                    const j = this.client.session.get(_.topic);
                    await this.deleteProposal(Q), Ie({
                        session: j
                    });
                }
            }, ce = async (T)=>{
                if (await this.deletePendingAuthRequest(K, {
                    message: "fulfilled",
                    code: 0
                }), T.error) {
                    const z = (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                    return T.error.code === z.code ? void 0 : (this.events.off((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), W), ae(T.error.message));
                }
                await this.deleteProposal(Q), this.events.off((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), W);
                const { cacaos: _, responder: j } = T.result, le = [], fe = [];
                for (const z of _){
                    await (0, $17d123d3e821614f$export$b7d566fce8e2b970)({
                        cacao: z,
                        projectId: this.client.core.projectId
                    }) || (this.client.logger.error(z, "Signature verification failed"), ae((0, $17d123d3e821614f$export$8203ef1531c8b5b5)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                    const { p: he } = z, pe = (0, $17d123d3e821614f$export$3bb18ae0fb9a9fa9)(he.resources), qe = [
                        (0, $17d123d3e821614f$export$a8b149927aef7051)(he.iss)
                    ], et = (0, $17d123d3e821614f$export$bf43cfbb4bd95de9)(he.iss);
                    if (pe) {
                        const de = (0, $17d123d3e821614f$export$d6c6a43d36418efe)(pe), tt = (0, $17d123d3e821614f$export$372f88051a611988)(pe);
                        le.push(...de), qe.push(...tt);
                    }
                    for (const de of qe)fe.push(`${de}:${et}`);
                }
                const Z = await this.client.core.crypto.generateSharedKey(E, j.publicKey);
                let ee;
                le.length > 0 && (ee = {
                    topic: Z,
                    acknowledged: !0,
                    self: {
                        publicKey: E,
                        metadata: this.client.metadata
                    },
                    peer: j,
                    controller: j.publicKey,
                    expiry: (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475),
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    relay: {
                        protocol: "irn"
                    },
                    pairingTopic: w,
                    namespaces: (0, $17d123d3e821614f$export$b5744b1c39447540)([
                        ...new Set(le)
                    ], [
                        ...new Set(fe)
                    ])
                }, await this.client.core.relayer.subscribe(Z), await this.client.session.set(Z, ee), ee = this.client.session.get(Z)), Ie({
                    auths: _,
                    session: ee
                });
            }, K = (0, $4seG3.payloadId)(), Q = (0, $4seG3.payloadId)();
            this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), W), this.events.once((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", K), ce);
            try {
                await Promise.all([
                    this.sendRequest({
                        topic: w,
                        method: "wc_sessionAuthenticate",
                        params: N,
                        expiry: t.expiry,
                        throwOnFailedPublish: !0,
                        clientRpcId: K
                    }),
                    this.sendRequest({
                        topic: w,
                        method: "wc_sessionPropose",
                        params: v,
                        expiry: $47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                        throwOnFailedPublish: !0,
                        clientRpcId: Q
                    })
                ]);
            } catch (T) {
                throw this.events.off((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), W), this.events.off((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", K), ce), T;
            }
            return await this.setProposal(Q, $47c1d2f2edc36dab$var$y({
                id: Q
            }, v)), await this.setAuthRequest(K, {
                request: $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, N), {
                    verifyContext: {}
                }),
                pairingTopic: w
            }), {
                uri: m,
                response: B
            };
        }, this.approveSessionAuthenticate = async (t)=>{
            this.isInitialized();
            const { id: e, auths: s } = t, i = this.getPendingAuthRequest(e);
            if (!i) throw new Error(`Could not find pending auth request with id ${e}`);
            const r = i.requester.publicKey, o = await this.client.core.crypto.generateKeyPair(), a = (0, $17d123d3e821614f$export$1e87d19d4aab5805)(r), c = {
                type: (0, $17d123d3e821614f$export$406e97c329f0f3d4),
                receiverPublicKey: r,
                senderPublicKey: o
            }, h = [], p = [];
            for (const w of s){
                if (!await (0, $17d123d3e821614f$export$b7d566fce8e2b970)({
                    cacao: w,
                    projectId: this.client.core.projectId
                })) {
                    const N = (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                    throw await this.sendError({
                        id: e,
                        topic: a,
                        error: N,
                        encodeOpts: c
                    }), new Error(N.message);
                }
                const { p: m } = w, E = (0, $17d123d3e821614f$export$3bb18ae0fb9a9fa9)(m.resources), O = [
                    (0, $17d123d3e821614f$export$a8b149927aef7051)(m.iss)
                ], S = (0, $17d123d3e821614f$export$bf43cfbb4bd95de9)(m.iss);
                if (E) {
                    const N = (0, $17d123d3e821614f$export$d6c6a43d36418efe)(E), P = (0, $17d123d3e821614f$export$372f88051a611988)(E);
                    h.push(...N), O.push(...P);
                }
                for (const N of O)p.push(`${N}:${S}`);
            }
            const g = await this.client.core.crypto.generateSharedKey(o, r);
            let d;
            return h?.length > 0 && (d = {
                topic: g,
                acknowledged: !0,
                self: {
                    publicKey: o,
                    metadata: this.client.metadata
                },
                peer: {
                    publicKey: r,
                    metadata: i.requester.metadata
                },
                controller: r,
                expiry: (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475),
                authentication: s,
                requiredNamespaces: {},
                optionalNamespaces: {},
                relay: {
                    protocol: "irn"
                },
                pairingTopic: "",
                namespaces: (0, $17d123d3e821614f$export$b5744b1c39447540)([
                    ...new Set(h)
                ], [
                    ...new Set(p)
                ])
            }, await this.client.core.relayer.subscribe(g), await this.client.session.set(g, d)), await this.sendResult({
                topic: a,
                id: e,
                result: {
                    cacaos: s,
                    responder: {
                        publicKey: o,
                        metadata: this.client.metadata
                    }
                },
                encodeOpts: c,
                throwOnFailedPublish: !0
            }), await this.client.auth.requests.delete(e, {
                message: "fullfilled",
                code: 0
            }), await this.client.core.pairing.activate({
                topic: i.pairingTopic
            }), {
                session: d
            };
        }, this.rejectSessionAuthenticate = async (t)=>{
            await this.isInitialized();
            const { id: e, reason: s } = t, i = this.getPendingAuthRequest(e);
            if (!i) throw new Error(`Could not find pending auth request with id ${e}`);
            const r = i.requester.publicKey, o = await this.client.core.crypto.generateKeyPair(), a = (0, $17d123d3e821614f$export$1e87d19d4aab5805)(r), c = {
                type: (0, $17d123d3e821614f$export$406e97c329f0f3d4),
                receiverPublicKey: r,
                senderPublicKey: o
            };
            await this.sendError({
                id: e,
                topic: a,
                error: s,
                encodeOpts: c
            }), await this.client.auth.requests.delete(e, {
                message: "rejected",
                code: 0
            }), await this.client.proposal.delete(e, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
        }, this.formatAuthMessage = (t)=>{
            this.isInitialized();
            const { request: e, iss: s } = t;
            return (0, $17d123d3e821614f$export$25868d1e8e76735f)(e, s);
        }, this.cleanupDuplicatePairings = async (t)=>{
            if (t.pairingTopic) try {
                const e = this.client.core.pairing.pairings.get(t.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var r, o;
                    return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === t.peer.metadata.url && i.topic && i.topic !== e.topic;
                });
                if (s.length === 0) return;
                this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.deleteSession = async (t)=>{
            const { topic: e, expirerHasDeleted: s = !1, emitEvent: i = !0, id: r = 0 } = t, { self: o } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), await this.client.session.delete(e, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.addToRecentlyDeleted(e, "session"), this.client.core.crypto.keychain.has(o.publicKey) && await this.client.core.crypto.deleteKeyPair(o.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), s || this.client.core.expirer.del(e), this.client.core.storage.removeItem($47c1d2f2edc36dab$export$a26ccd6441b7d638).catch((a)=>this.client.logger.warn(a)), this.getPendingSessionRequests().forEach((a)=>{
                a.topic === e && this.deletePendingSessionRequest(a.id, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), i && this.client.events.emit("session_delete", {
                id: r,
                topic: e
            });
        }, this.deleteProposal = async (t, e)=>{
            await Promise.all([
                this.client.proposal.delete(t, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                e ? Promise.resolve() : this.client.core.expirer.del(t)
            ]), this.addToRecentlyDeleted(t, "proposal");
        }, this.deletePendingSessionRequest = async (t, e, s = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(t, e),
                s ? Promise.resolve() : this.client.core.expirer.del(t)
            ]), this.addToRecentlyDeleted(t, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== t), s && (this.sessionRequestQueue.state = $47c1d2f2edc36dab$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: t
            }));
        }, this.deletePendingAuthRequest = async (t, e, s = !1)=>{
            await Promise.all([
                this.client.auth.requests.delete(t, e),
                s ? Promise.resolve() : this.client.core.expirer.del(t)
            ]);
        }, this.setExpiry = async (t, e)=>{
            this.client.session.keys.includes(t) && (this.client.core.expirer.set(t, e), await this.client.session.update(t, {
                expiry: e
            }));
        }, this.setProposal = async (t, e)=>{
            this.client.core.expirer.set(t, (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)), await this.client.proposal.set(t, e);
        }, this.setAuthRequest = async (t, e)=>{
            const { request: s, pairingTopic: i } = e;
            this.client.core.expirer.set(t, s.expiryTimestamp), await this.client.auth.requests.set(t, {
                authPayload: s.authPayload,
                requester: s.requester,
                expiryTimestamp: s.expiryTimestamp,
                id: t,
                pairingTopic: i,
                verifyContext: s.verifyContext
            });
        }, this.setPendingSessionRequest = async (t)=>{
            const { id: e, topic: s, params: i, verifyContext: r } = t, o = i.request.expiryTimestamp || (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            this.client.core.expirer.set(e, o), await this.client.pendingRequest.set(e, {
                id: e,
                topic: s,
                params: i,
                verifyContext: r
            });
        }, this.sendRequest = async (t)=>{
            const { topic: e, method: s, params: i, expiry: r, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = t, h = (0, $4seG3.formatJsonRpcRequest)(s, i, a);
            if ((0, $17d123d3e821614f$export$4e09c449d6c407f7)() && $47c1d2f2edc36dab$export$63c37d8ae5931ad5.includes(s)) {
                const d = (0, $17d123d3e821614f$export$d4c241cec96564c1)(JSON.stringify(h));
                this.client.core.verify.register({
                    attestationId: d
                });
            }
            let p;
            try {
                p = await this.client.core.crypto.encode(e, h);
            } catch (d) {
                throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${e} failed`), d;
            }
            const g = $47c1d2f2edc36dab$export$4edb1ca37014192d[s].req;
            return r && (g.ttl = r), o && (g.id = o), this.client.core.history.set(e, h), c ? (g.internal = $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, g.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(e, p, g)) : this.client.core.relayer.publish(e, p, g).catch((d)=>this.client.logger.error(d)), h.id;
        }, this.sendResult = async (t)=>{
            const { id: e, topic: s, result: i, throwOnFailedPublish: r, encodeOpts: o } = t, a = (0, $4seG3.formatJsonRpcResult)(e, i);
            let c;
            try {
                c = await this.client.core.crypto.encode(s, a, o);
            } catch (g) {
                throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), g;
            }
            let h;
            try {
                h = await this.client.core.history.get(s, e);
            } catch (g) {
                throw this.client.logger.error(`sendResult() -> history.get(${s}, ${e}) failed`), g;
            }
            const p = $47c1d2f2edc36dab$export$4edb1ca37014192d[h.request.method].res;
            r ? (p.internal = $47c1d2f2edc36dab$var$M($47c1d2f2edc36dab$var$y({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, c, p)) : this.client.core.relayer.publish(s, c, p).catch((g)=>this.client.logger.error(g)), await this.client.core.history.resolve(a);
        }, this.sendError = async (t)=>{
            const { id: e, topic: s, error: i, encodeOpts: r } = t, o = (0, $4seG3.formatJsonRpcError)(e, i);
            let a;
            try {
                a = await this.client.core.crypto.encode(s, o, r);
            } catch (p) {
                throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), p;
            }
            let c;
            try {
                c = await this.client.core.history.get(s, e);
            } catch (p) {
                throw this.client.logger.error(`sendError() -> history.get(${s}, ${e}) failed`), p;
            }
            const h = $47c1d2f2edc36dab$export$4edb1ca37014192d[c.request.method].res;
            this.client.core.relayer.publish(s, a, h), await this.client.core.history.resolve(o);
        }, this.cleanup = async ()=>{
            const t = [], e = [];
            this.client.session.getAll().forEach((s)=>{
                let i = !1;
                (0, $17d123d3e821614f$export$57947cfd429801a2)(s.expiry) && (i = !0), this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && t.push(s.topic);
            }), this.client.proposal.getAll().forEach((s)=>{
                (0, $17d123d3e821614f$export$57947cfd429801a2)(s.expiryTimestamp) && e.push(s.id);
            }), await Promise.all([
                ...t.map((s)=>this.deleteSession({
                        topic: s
                    })),
                ...e.map((s)=>this.deleteProposal(s))
            ]);
        }, this.onRelayEventRequest = async (t)=>{
            this.requestQueue.queue.push(t), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $47c1d2f2edc36dab$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $47c1d2f2edc36dab$export$8602b201748df21a.active;
                const t = this.requestQueue.queue.shift();
                if (t) try {
                    this.processRequest(t), await new Promise((e)=>setTimeout(e, 300));
                } catch (e) {
                    this.client.logger.warn(e);
                }
            }
            this.requestQueue.state = $47c1d2f2edc36dab$export$8602b201748df21a.idle;
        }, this.processRequest = (t)=>{
            const { topic: e, payload: s } = t, i = s.method;
            if (!this.shouldIgnorePairingRequest({
                topic: e,
                requestMethod: i
            })) switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(e, s);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(e, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(e, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(e, s);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(e, s);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(e, s);
                case "wc_sessionRequest":
                    return this.onSessionRequest(e, s);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(e, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateRequest(e, s);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (t)=>{
            const { topic: e, payload: s } = t, i = (await this.client.core.history.get(e, s.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(e, s);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(e, s);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(e, s);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(e, s);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(e, s);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(e, s);
                case "wc_sessionAuthenticate":
                    return this.onSessionAuthenticateResponse(e, s);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (t)=>{
            const { topic: e } = t, { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${e} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(s);
        }, this.shouldIgnorePairingRequest = (t)=>{
            const { topic: e, requestMethod: s } = t, i = this.expectedPairingMethodMap.get(e);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
        }, this.onSessionProposeRequest = async (t, e)=>{
            const { params: s, id: i } = e;
            try {
                this.isValidConnect($47c1d2f2edc36dab$var$y({}, e.params));
                const r = s.expiryTimestamp || (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), o = $47c1d2f2edc36dab$var$y({
                    id: i,
                    pairingTopic: t,
                    expiryTimestamp: r
                }, s);
                await this.setProposal(i, o);
                const a = (0, $17d123d3e821614f$export$d4c241cec96564c1)(JSON.stringify(e)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionProposeResponse = async (t, e)=>{
            const { id: s } = e;
            if ((0, $5h2x7.isJsonRpcResult)(e)) {
                const { result: i } = e;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const r = this.client.proposal.get(s);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: r
                });
                const o = r.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const h = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: t
                });
            } else if ((0, $5h2x7.isJsonRpcError)(e)) {
                await this.client.proposal.delete(s, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
                const i = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners, 954`);
                this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), {
                    error: e.error
                });
            }
        }, this.onSessionSettleRequest = async (t, e)=>{
            const { id: s, params: i } = e;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: r, controller: o, expiry: a, namespaces: c, sessionProperties: h, pairingTopic: p, sessionConfig: g } = e.params, d = $47c1d2f2edc36dab$var$y($47c1d2f2edc36dab$var$y({
                    topic: t,
                    relay: r,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: p,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, h && {
                    sessionProperties: h
                }), g && {
                    sessionConfig: g
                });
                await this.sendResult({
                    id: e.id,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                });
                const w = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect");
                if (this.events.listenerCount(w) === 0) throw new Error(`emitting ${w} without any listeners 997`);
                this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: d
                }), this.cleanupDuplicatePairings(d);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionSettleResponse = async (t, e)=>{
            const { id: s } = e;
            (0, $5h2x7.isJsonRpcResult)(e) ? (await this.client.session.update(t, {
                acknowledged: !0
            }), this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_approve", s), {})) : (0, $5h2x7.isJsonRpcError)(e) && (await this.client.session.delete(t, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_approve", s), {
                error: e.error
            }));
        }, this.onSessionUpdateRequest = async (t, e)=>{
            const { params: s, id: i } = e;
            try {
                const r = `${t}_session_update`, o = (0, $17d123d3e821614f$export$b72d712fed4d036d).get(r);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`), this.sendError({
                        id: i,
                        topic: t,
                        error: (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("INVALID_UPDATE_REQUEST")
                    });
                    return;
                }
                this.isValidUpdate($47c1d2f2edc36dab$var$y({
                    topic: t
                }, s));
                try {
                    (0, $17d123d3e821614f$export$b72d712fed4d036d).set(r, i), await this.client.session.update(t, {
                        namespaces: s.namespaces
                    }), await this.sendResult({
                        id: i,
                        topic: t,
                        result: !0,
                        throwOnFailedPublish: !0
                    });
                } catch (a) {
                    throw (0, $17d123d3e821614f$export$b72d712fed4d036d).delete(r), a;
                }
                this.client.events.emit("session_update", {
                    id: i,
                    topic: t,
                    params: s
                });
            } catch (r) {
                await this.sendError({
                    id: i,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.isRequestOutOfSync = (t, e)=>parseInt(e.toString().slice(0, -3)) <= parseInt(t.toString().slice(0, -3)), this.onSessionUpdateResponse = (t, e)=>{
            const { id: s } = e, i = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_update", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5h2x7.isJsonRpcResult)(e) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_update", s), {}) : (0, $5h2x7.isJsonRpcError)(e) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_update", s), {
                error: e.error
            });
        }, this.onSessionExtendRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidExtend({
                    topic: t
                }), await this.setExpiry(t, (0, $17d123d3e821614f$export$b136d03015bfc12)($47c1d2f2edc36dab$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: s,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_extend", {
                    id: s,
                    topic: t
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (t, e)=>{
            const { id: s } = e, i = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_extend", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5h2x7.isJsonRpcResult)(e) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_extend", s), {}) : (0, $5h2x7.isJsonRpcError)(e) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_extend", s), {
                error: e.error
            });
        }, this.onSessionPingRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidPing({
                    topic: t
                }), await this.sendResult({
                    id: s,
                    topic: t,
                    result: !0,
                    throwOnFailedPublish: !0
                }), this.client.events.emit("session_ping", {
                    id: s,
                    topic: t
                });
            } catch (i) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: i
                }), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (t, e)=>{
            const { id: s } = e, i = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_ping", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            setTimeout(()=>{
                (0, $5h2x7.isJsonRpcResult)(e) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_ping", s), {}) : (0, $5h2x7.isJsonRpcError)(e) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_ping", s), {
                    error: e.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (t, e)=>{
            const { id: s } = e;
            try {
                this.isValidDisconnect({
                    topic: t,
                    reason: e.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $8ce29b9d0d06659b$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: t,
                                id: s
                            }));
                        });
                    }),
                    this.sendResult({
                        id: s,
                        topic: t,
                        result: !0,
                        throwOnFailedPublish: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: t,
                        error: (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (t, e)=>{
            var s;
            const { id: i, params: r } = e;
            try {
                await this.isValidRequest($47c1d2f2edc36dab$var$y({
                    topic: t
                }, r));
                const o = (0, $17d123d3e821614f$export$d4c241cec96564c1)(JSON.stringify((0, $4seG3.formatJsonRpcRequest)("wc_sessionRequest", r, i))), a = this.client.session.get(t), c = await this.getVerifyContext(o, a.peer.metadata), h = {
                    id: i,
                    topic: t,
                    params: r,
                    verifyContext: c
                };
                await this.setPendingSessionRequest(h), (s = this.client.signConfig) != null && s.disableRequestQueue ? this.emitSessionRequest(h) : (this.addSessionRequestToSessionRequestQueue(h), this.processSessionRequestQueue());
            } catch (o) {
                await this.sendError({
                    id: i,
                    topic: t,
                    error: o
                }), this.client.logger.error(o);
            }
        }, this.onSessionRequestResponse = (t, e)=>{
            const { id: s } = e, i = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", s);
            if (this.events.listenerCount(i) === 0) throw new Error(`emitting ${i} without any listeners`);
            (0, $5h2x7.isJsonRpcResult)(e) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", s), {
                result: e.result
            }) : (0, $5h2x7.isJsonRpcError)(e) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", s), {
                error: e.error
            });
        }, this.onSessionEventRequest = async (t, e)=>{
            const { id: s, params: i } = e;
            try {
                const r = `${t}_session_event_${i.event.name}`, o = (0, $17d123d3e821614f$export$b72d712fed4d036d).get(r);
                if (o && this.isRequestOutOfSync(o, s)) {
                    this.client.logger.info(`Discarding out of sync request - ${s}`);
                    return;
                }
                this.isValidEmit($47c1d2f2edc36dab$var$y({
                    topic: t
                }, i)), this.client.events.emit("session_event", {
                    id: s,
                    topic: t,
                    params: i
                }), (0, $17d123d3e821614f$export$b72d712fed4d036d).set(r, s);
            } catch (r) {
                await this.sendError({
                    id: s,
                    topic: t,
                    error: r
                }), this.client.logger.error(r);
            }
        }, this.onSessionAuthenticateResponse = (t, e)=>{
            const { id: s } = e;
            this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: t,
                payload: e
            }), (0, $5h2x7.isJsonRpcResult)(e) ? this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", s), {
                result: e.result
            }) : (0, $5h2x7.isJsonRpcError)(e) && this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", s), {
                error: e.error
            });
        }, this.onSessionAuthenticateRequest = async (t, e)=>{
            const { requester: s, authPayload: i, expiryTimestamp: r } = e.params, o = (0, $17d123d3e821614f$export$d4c241cec96564c1)(JSON.stringify(e)), a = await this.getVerifyContext(o, this.client.metadata), c = {
                requester: s,
                pairingTopic: t,
                id: e.id,
                authPayload: i,
                verifyContext: a,
                expiryTimestamp: r
            };
            await this.setAuthRequest(e.id, {
                request: c,
                pairingTopic: t
            }), this.client.events.emit("session_authenticate", {
                topic: t,
                params: e.params,
                id: e.id
            });
        }, this.addSessionRequestToSessionRequestQueue = (t)=>{
            this.sessionRequestQueue.queue.push(t);
        }, this.cleanupAfterResponse = (t)=>{
            this.deletePendingSessionRequest(t.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $47c1d2f2edc36dab$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $8Yg5s.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: t, error: e })=>{
            const s = this.client.core.history.pending;
            s.length > 0 && s.filter((i)=>i.topic === t && i.request.method === "wc_sessionRequest").forEach((i)=>{
                const r = i.request.id, o = (0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", r);
                if (this.events.listenerCount(o) === 0) throw new Error(`emitting ${o} without any listeners`);
                this.events.emit((0, $17d123d3e821614f$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: e
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $47c1d2f2edc36dab$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const t = this.sessionRequestQueue.queue[0];
            if (!t) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $47c1d2f2edc36dab$export$8602b201748df21a.active, this.emitSessionRequest(t);
            } catch (e) {
                this.client.logger.error(e);
            }
        }, this.emitSessionRequest = (t)=>{
            this.client.events.emit("session_request", t);
        }, this.onPairingCreated = (t)=>{
            if (t.methods && this.expectedPairingMethodMap.set(t.topic, t.methods), t.active) return;
            const e = this.client.proposal.getAll().find((s)=>s.pairingTopic === t.topic);
            e && this.onSessionProposeRequest(t.topic, (0, $4seG3.formatJsonRpcRequest)("wc_sessionPropose", {
                requiredNamespaces: e.requiredNamespaces,
                optionalNamespaces: e.optionalNamespaces,
                relays: e.relays,
                proposer: e.proposer,
                sessionProperties: e.sessionProperties
            }, e.id));
        }, this.isValidConnect = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            const { pairingTopic: e, requiredNamespaces: s, optionalNamespaces: i, sessionProperties: r, relays: o } = t;
            if ((0, $17d123d3e821614f$export$fce6876652108ab)(e) || await this.isValidPairingTopic(e), !(0, $17d123d3e821614f$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $17d123d3e821614f$export$fce6876652108ab)(s) && (0, $17d123d3e821614f$export$16a0268bc22b47b0)(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !(0, $17d123d3e821614f$export$fce6876652108ab)(i) && (0, $17d123d3e821614f$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $17d123d3e821614f$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.validateNamespaces = (t, e)=>{
            const s = (0, $17d123d3e821614f$export$9e2b2cae22c6a8b3)(t, "connect()", e);
            if (s) throw new Error(s.message);
        }, this.isValidApprove = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) throw new Error((0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${t}`).message);
            const { id: e, namespaces: s, relayProtocol: i, sessionProperties: r } = t;
            this.checkRecentlyDeleted(e), await this.isValidProposalId(e);
            const o = this.client.proposal.get(e), a = (0, $17d123d3e821614f$export$93f7b81dc815a714)(s, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $17d123d3e821614f$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, s, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(i, !0)) {
                const { message: h } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            (0, $17d123d3e821614f$export$fce6876652108ab)(r) || this.validateSessionProps(r, "sessionProperties");
        }, this.isValidReject = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${t}`);
                throw new Error(i);
            }
            const { id: e, reason: s } = t;
            if (this.checkRecentlyDeleted(e), await this.isValidProposalId(e), !(0, $17d123d3e821614f$export$766fe78377d96f2a)(s)) {
                const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: c } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${t}`);
                throw new Error(c);
            }
            const { relay: e, controller: s, namespaces: i, expiry: r } = t;
            if (!(0, $17d123d3e821614f$export$1b3fc298be8c9a7b)(e)) {
                const { message: c } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $17d123d3e821614f$export$5e1c5c89613c213f)(s, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $17d123d3e821614f$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $17d123d3e821614f$export$57947cfd429801a2)(r)) {
                const { message: c } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${t}`);
                throw new Error(a);
            }
            const { topic: e, namespaces: s } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const i = this.client.session.get(e), r = (0, $17d123d3e821614f$export$93f7b81dc815a714)(s, "update()");
            if (r) throw new Error(r.message);
            const o = (0, $17d123d3e821614f$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, s, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
        }, this.isValidRequest = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${t}`);
                throw new Error(a);
            }
            const { topic: e, request: s, chainId: i, expiry: r } = t;
            this.checkRecentlyDeleted(e), await this.isValidSessionTopic(e);
            const { namespaces: o } = this.client.session.get(e);
            if (!(0, $17d123d3e821614f$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $17d123d3e821614f$export$1a2af3c017fb6d42)(s)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
                throw new Error(a);
            }
            if (!(0, $17d123d3e821614f$export$8db4804e3a6de711)(o, i, s.method)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${s.method}`);
                throw new Error(a);
            }
            if (r && !(0, $17d123d3e821614f$export$59fba2af1ac782b)(r, $47c1d2f2edc36dab$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${r}. Expiry must be a number (in seconds) between ${$47c1d2f2edc36dab$export$409f0c0a13a1b7c6.min} and ${$47c1d2f2edc36dab$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (t)=>{
            var e;
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: r } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${t}`);
                throw new Error(r);
            }
            const { topic: s, response: i } = t;
            try {
                await this.isValidSessionTopic(s);
            } catch (r) {
                throw (e = t?.response) != null && e.id && this.cleanupAfterResponse(t), r;
            }
            if (!(0, $17d123d3e821614f$export$1ae38cf0a848f651)(i)) {
                const { message: r } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(r);
            }
        }, this.isValidPing = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            await this.isValidSessionOrPairingTopic(e);
        }, this.isValidEmit = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: o } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${t}`);
                throw new Error(o);
            }
            const { topic: e, event: s, chainId: i } = t;
            await this.isValidSessionTopic(e);
            const { namespaces: r } = this.client.session.get(e);
            if (!(0, $17d123d3e821614f$export$144fc36610eb6522)(r, i)) {
                const { message: o } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $17d123d3e821614f$export$cbe4cdc5960cfa11)(s)) {
                const { message: o } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
            if (!(0, $17d123d3e821614f$export$df2c67ef8baad16b)(r, i, s.name)) {
                const { message: o } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (t)=>{
            if (!(0, $17d123d3e821614f$export$b3f5fcca1d210454)(t)) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${t}`);
                throw new Error(s);
            }
            const { topic: e } = t;
            await this.isValidSessionOrPairingTopic(e);
        }, this.isValidAuthenticate = (t)=>{
            const { chains: e, uri: s, domain: i, nonce: r } = t;
            if (!Array.isArray(e) || e.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(r, !1)) throw new Error("nonce is required parameter");
            if ([
                ...new Set(e.map((a)=>(0, $17d123d3e821614f$export$4764229d78de4437)(a).namespace))
            ].length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            const { namespace: o } = (0, $17d123d3e821614f$export$4764229d78de4437)(e[0]);
            if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }, this.getVerifyContext = async (t, e)=>{
            const s = {
                verified: {
                    verifyUrl: e.verifyUrl || (0, $8ce29b9d0d06659b$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: e.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: t,
                    verifyUrl: e.verifyUrl
                });
                i && (s.verified.origin = i.origin, s.verified.isScam = i.isScam, s.verified.validation = i.origin === new URL(e.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(s)}`), s;
        }, this.validateSessionProps = (t, e)=>{
            Object.values(t).forEach((s)=>{
                if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(s, !1)) {
                    const { message: i } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${e} must be in Record<string, string> format. Received: ${JSON.stringify(s)}`);
                    throw new Error(i);
                }
            });
        }, this.getPendingAuthRequest = (t)=>{
            const e = this.client.auth.requests.get(t);
            return typeof e == "object" ? e : void 0;
        }, this.addToRecentlyDeleted = (t, e)=>{
            if (this.recentlyDeletedMap.set(t, e), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
                let s = 0;
                const i = this.recentlyDeletedLimit / 2;
                for (const r of this.recentlyDeletedMap.keys()){
                    if (s++ >= i) break;
                    this.recentlyDeletedMap.delete(r);
                }
            }
        }, this.checkRecentlyDeleted = (t)=>{
            const e = this.recentlyDeletedMap.get(t);
            if (e) {
                const { message: s } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Record was recently deleted - ${e}: ${t}`);
                throw new Error(s);
            }
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: n } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(n);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $8ce29b9d0d06659b$export$d56245796e2837d).message, async (n)=>{
            const { topic: t, message: e } = n, { publicKey: s } = this.client.auth.authKeys.keys.includes($47c1d2f2edc36dab$export$efef74cb455ac30f) ? this.client.auth.authKeys.get($47c1d2f2edc36dab$export$efef74cb455ac30f) : {
                responseTopic: void 0,
                publicKey: void 0
            }, i = await this.client.core.crypto.decode(t, e, {
                receiverPublicKey: s
            });
            try {
                (0, $5h2x7.isJsonRpcRequest)(i) ? (this.client.core.history.set(t, i), this.onRelayEventRequest({
                    topic: t,
                    payload: i
                })) : (0, $5h2x7.isJsonRpcResponse)(i) ? (await this.client.core.history.resolve(i), await this.onRelayEventResponse({
                    topic: t,
                    payload: i
                }), this.client.core.history.delete(t, i.id)) : this.onRelayEventUnknownPayload({
                    topic: t,
                    payload: i
                });
            } catch (r) {
                this.client.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $8ce29b9d0d06659b$export$9013719d9206b0c1).expired, async (n)=>{
            const { topic: t, id: e } = (0, $17d123d3e821614f$export$93adeb0f16e8e51d)(n.target);
            if (e && this.client.pendingRequest.keys.includes(e)) return await this.deletePendingSessionRequest(e, (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED"), !0);
            if (e && this.client.auth.requests.keys.includes(e)) return await this.deletePendingAuthRequest(e, (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED"), !0);
            t ? this.client.session.keys.includes(t) && (await this.deleteSession({
                topic: t,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: t
            })) : e && (await this.deleteProposal(e, !0), this.client.events.emit("proposal_expire", {
                id: e
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $8ce29b9d0d06659b$export$ca3c0b962acf7b75).create, (n)=>this.onPairingCreated(n)), this.client.core.pairing.events.on((0, $8ce29b9d0d06659b$export$ca3c0b962acf7b75).delete, (n)=>{
            this.addToRecentlyDeleted(n.topic, "pairing");
        });
    }
    isValidPairingTopic(n) {
        if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(n, !1)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${n}`);
            throw new Error(t);
        }
        if (!this.client.core.pairing.pairings.keys.includes(n)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $17d123d3e821614f$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(n).expiry)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${n}`);
            throw new Error(t);
        }
    }
    async isValidSessionTopic(n) {
        if (!(0, $17d123d3e821614f$export$ee898ca48ab56c74)(n, !1)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${n}`);
            throw new Error(t);
        }
        if (this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $17d123d3e821614f$export$57947cfd429801a2)(this.client.session.get(n).expiry)) {
            await this.deleteSession({
                topic: n
            });
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${n}`);
            throw new Error(t);
        }
        if (!this.client.core.crypto.keychain.has(n)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${n}`);
            throw await this.deleteSession({
                topic: n
            }), new Error(t);
        }
    }
    async isValidSessionOrPairingTopic(n) {
        if (this.checkRecentlyDeleted(n), this.client.session.keys.includes(n)) await this.isValidSessionTopic(n);
        else if (this.client.core.pairing.pairings.keys.includes(n)) this.isValidPairingTopic(n);
        else if ((0, $17d123d3e821614f$export$ee898ca48ab56c74)(n, !1)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${n}`);
            throw new Error(t);
        } else {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${n}`);
            throw new Error(t);
        }
    }
    async isValidProposalId(n) {
        if (!(0, $17d123d3e821614f$export$53551be28ad5e34d)(n)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${n}`);
            throw new Error(t);
        }
        if (!this.client.proposal.keys.includes(n)) {
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${n}`);
            throw new Error(t);
        }
        if ((0, $17d123d3e821614f$export$57947cfd429801a2)(this.client.proposal.get(n).expiryTimestamp)) {
            await this.deleteProposal(n);
            const { message: t } = (0, $17d123d3e821614f$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${n}`);
            throw new Error(t);
        }
    }
}
class $47c1d2f2edc36dab$var$es extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$ae6c7a4f7ed730a1, $47c1d2f2edc36dab$export$7fa6f9ee1e2cab96), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$Ze extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$a069e98a8dfeec1e, $47c1d2f2edc36dab$export$7fa6f9ee1e2cab96), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$ts extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$40b296af21bd38a4, $47c1d2f2edc36dab$export$7fa6f9ee1e2cab96, (e)=>e.id), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$ss extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$ab815cb37981e7e0, $47c1d2f2edc36dab$export$323ba3ebb8028ed0, ()=>$47c1d2f2edc36dab$export$efef74cb455ac30f), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$is extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$5d9af9e20f678626, $47c1d2f2edc36dab$export$323ba3ebb8028ed0), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$rs extends (0, $8ce29b9d0d06659b$export$390f32400eaf98c9) {
    constructor(n, t){
        super(n, t, $47c1d2f2edc36dab$export$3643b3579d091159, $47c1d2f2edc36dab$export$323ba3ebb8028ed0, (e)=>e.id), this.core = n, this.logger = t;
    }
}
class $47c1d2f2edc36dab$var$ns {
    constructor(n, t){
        this.core = n, this.logger = t, this.authKeys = new $47c1d2f2edc36dab$var$ss(this.core, this.logger), this.pairingTopics = new $47c1d2f2edc36dab$var$is(this.core, this.logger), this.requests = new $47c1d2f2edc36dab$var$rs(this.core, this.logger);
    }
    async init() {
        await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
    }
}
class $47c1d2f2edc36dab$export$2e2bcd8739ae039 extends (0, $85826f5a95c74020$export$2ebcf6eeacedad44) {
    constructor(n){
        super(n), this.protocol = $47c1d2f2edc36dab$export$4fa962fc67384e02, this.version = $47c1d2f2edc36dab$export$61085c48796ff049, this.name = $47c1d2f2edc36dab$export$8dffb3242f2c5f72.name, this.events = new (0, $ej6Nm.EventEmitter), this.on = (e, s)=>this.events.on(e, s), this.once = (e, s)=>this.events.once(e, s), this.off = (e, s)=>this.events.off(e, s), this.removeListener = (e, s)=>this.events.removeListener(e, s), this.removeAllListeners = (e)=>this.events.removeAllListeners(e), this.connect = async (e)=>{
            try {
                return await this.engine.connect(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.pair = async (e)=>{
            try {
                return await this.engine.pair(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approve = async (e)=>{
            try {
                return await this.engine.approve(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.reject = async (e)=>{
            try {
                return await this.engine.reject(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.update = async (e)=>{
            try {
                return await this.engine.update(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.extend = async (e)=>{
            try {
                return await this.engine.extend(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.request = async (e)=>{
            try {
                return await this.engine.request(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.respond = async (e)=>{
            try {
                return await this.engine.respond(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.ping = async (e)=>{
            try {
                return await this.engine.ping(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.emit = async (e)=>{
            try {
                return await this.engine.emit(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.disconnect = async (e)=>{
            try {
                return await this.engine.disconnect(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.find = (e)=>{
            try {
                return this.engine.find(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (e) {
                throw this.logger.error(e.message), e;
            }
        }, this.authenticate = async (e)=>{
            try {
                return await this.engine.authenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.formatAuthMessage = (e)=>{
            try {
                return this.engine.formatAuthMessage(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.approveSessionAuthenticate = async (e)=>{
            try {
                return await this.engine.approveSessionAuthenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.rejectSessionAuthenticate = async (e)=>{
            try {
                return await this.engine.rejectSessionAuthenticate(e);
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = n?.name || $47c1d2f2edc36dab$export$8dffb3242f2c5f72.name, this.metadata = n?.metadata || (0, $17d123d3e821614f$export$ba31e015127122bb)(), this.signConfig = n?.signConfig;
        const t = typeof n?.logger < "u" && typeof n?.logger != "string" ? n.logger : (0, (/*@__PURE__*/$parcel$interopDefault($77JzN)))((0, $c8Vuh.getDefaultLoggerOptions)({
            level: n?.logger || $47c1d2f2edc36dab$export$8dffb3242f2c5f72.logger
        }));
        this.core = n?.core || new (0, $8ce29b9d0d06659b$export$4143ab5b91744744)(n), this.logger = (0, $c8Vuh.generateChildLogger)(t, this.name), this.session = new $47c1d2f2edc36dab$var$Ze(this.core, this.logger), this.proposal = new $47c1d2f2edc36dab$var$es(this.core, this.logger), this.pendingRequest = new $47c1d2f2edc36dab$var$ts(this.core, this.logger), this.engine = new $47c1d2f2edc36dab$var$Zt(this), this.auth = new $47c1d2f2edc36dab$var$ns(this.core, this.logger);
    }
    static async init(n) {
        const t = new $47c1d2f2edc36dab$export$2e2bcd8739ae039(n);
        return await t.initialize(), t;
    }
    get context() {
        return (0, $c8Vuh.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), await this.auth.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (n) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(n.message), n;
        }
    }
}
const $47c1d2f2edc36dab$export$90b8cff65c105172 = $47c1d2f2edc36dab$var$Ze, $47c1d2f2edc36dab$export$bdf4ba258ec679dc = $47c1d2f2edc36dab$export$2e2bcd8739ae039;




var $c8Vuh = parcelRequire("c8Vuh");
var $77JzN = parcelRequire("77JzN");

var $itZgd = parcelRequire("itZgd");


var $ej6Nm = parcelRequire("ej6Nm");
parcelRequire("5Do7R");
var $4seG3 = parcelRequire("4seG3");
const $f7c469cbc3220931$var$xa = "error", $f7c469cbc3220931$var$Mg = "wss://relay.walletconnect.com", $f7c469cbc3220931$var$qg = "wc", $f7c469cbc3220931$var$Bg = "universal_provider", $f7c469cbc3220931$var$Ea = `${$f7c469cbc3220931$var$qg}@2:${$f7c469cbc3220931$var$Bg}:`, $f7c469cbc3220931$var$Gg = "https://rpc.walletconnect.com/v1/", $f7c469cbc3220931$var$Vn = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $f7c469cbc3220931$var$ge = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $f7c469cbc3220931$var$Ui = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(A, u) {
    (function() {
        var i, p = "4.17.21", w = 200, b = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", D = "Expected a function", En = "Invalid `variable` option passed into `_.template`", zt = "__lodash_hash_undefined__", pr = 500, It = "__lodash_placeholder__", Ln = 1, Fn = 2, xt = 4, Et = 1, ve = 2, vn = 1, ct = 2, Bi = 4, Dn = 8, yt = 16, Nn = 32, St = 64, Mn = 128, Kt = 256, dr = 512, Na = 30, Ha = "...", $a = 800, Ua = 16, Gi = 1, Wa = 2, Fa = 3, ht = 1 / 0, kn = 9007199254740991, Ma = 17976931348623157e292, _e = 0 / 0, Hn = 4294967295, qa = Hn - 1, Ba = Hn >>> 1, Ga = [
            [
                "ary",
                Mn
            ],
            [
                "bind",
                vn
            ],
            [
                "bindKey",
                ct
            ],
            [
                "curry",
                Dn
            ],
            [
                "curryRight",
                yt
            ],
            [
                "flip",
                dr
            ],
            [
                "partial",
                Nn
            ],
            [
                "partialRight",
                St
            ],
            [
                "rearg",
                Kt
            ]
        ], Ot = "[object Arguments]", me = "[object Array]", za = "[object AsyncFunction]", Yt = "[object Boolean]", Zt = "[object Date]", Ka = "[object DOMException]", we = "[object Error]", Pe = "[object Function]", zi = "[object GeneratorFunction]", yn = "[object Map]", Jt = "[object Number]", Ya = "[object Null]", qn = "[object Object]", Ki = "[object Promise]", Za = "[object Proxy]", Xt = "[object RegExp]", Sn = "[object Set]", Qt = "[object String]", Ae = "[object Symbol]", Ja = "[object Undefined]", Vt = "[object WeakMap]", Xa = "[object WeakSet]", kt = "[object ArrayBuffer]", Rt = "[object DataView]", gr = "[object Float32Array]", vr = "[object Float64Array]", _r = "[object Int8Array]", mr = "[object Int16Array]", wr = "[object Int32Array]", Pr = "[object Uint8Array]", Ar = "[object Uint8ClampedArray]", Cr = "[object Uint16Array]", Ir = "[object Uint32Array]", Qa = /\b__p \+= '';/g, Va = /\b(__p \+=) '' \+/g, ka = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Yi = /&(?:amp|lt|gt|quot|#39);/g, Zi = /[&<>"']/g, ja = RegExp(Yi.source), no = RegExp(Zi.source), to = /<%-([\s\S]+?)%>/g, eo = /<%([\s\S]+?)%>/g, Ji = /<%=([\s\S]+?)%>/g, ro = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, io = /^\w*$/, so = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, xr = /[\\^$.*+?()[\]{}|]/g, uo = RegExp(xr.source), Er = /^\s+/, ao = /\s/, oo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, fo = /\{\n\/\* \[wrapped with (.+)\] \*/, co = /,? & /, ho = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, lo = /[()=,{}\[\]\/\s]/, po = /\\(\\)?/g, go = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Xi = /\w*$/, vo = /^[-+]0x[0-9a-f]+$/i, _o = /^0b[01]+$/i, mo = /^\[object .+?Constructor\]$/, wo = /^0o[0-7]+$/i, Po = /^(?:0|[1-9]\d*)$/, Ao = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ce = /($^)/, Co = /['\n\r\u2028\u2029\\]/g, Ie = "\ud800-\udfff", Io = "\\u0300-\\u036f", xo = "\\ufe20-\\ufe2f", Eo = "\\u20d0-\\u20ff", Qi = Io + xo + Eo, Vi = "\\u2700-\\u27bf", ki = "a-z\\xdf-\\xf6\\xf8-\\xff", yo = "\\xac\\xb1\\xd7\\xf7", So = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Oo = "\\u2000-\\u206f", Ro = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ji = "A-Z\\xc0-\\xd6\\xd8-\\xde", ns = "\\ufe0e\\ufe0f", ts = yo + So + Oo + Ro, yr = "['\u2019]", bo = "[" + Ie + "]", es = "[" + ts + "]", xe = "[" + Qi + "]", rs = "\\d+", To = "[" + Vi + "]", is = "[" + ki + "]", ss = "[^" + Ie + ts + rs + Vi + ki + ji + "]", Sr = "\ud83c[\udffb-\udfff]", Lo = "(?:" + xe + "|" + Sr + ")", us = "[^" + Ie + "]", Or = "(?:\ud83c[\udde6-\uddff]){2}", Rr = "[\ud800-\udbff][\udc00-\udfff]", bt = "[" + ji + "]", as = "\\u200d", os = "(?:" + is + "|" + ss + ")", Do = "(?:" + bt + "|" + ss + ")", fs = "(?:" + yr + "(?:d|ll|m|re|s|t|ve))?", cs = "(?:" + yr + "(?:D|LL|M|RE|S|T|VE))?", hs = Lo + "?", ls = "[" + ns + "]?", No = "(?:" + as + "(?:" + [
            us,
            Or,
            Rr
        ].join("|") + ")" + ls + hs + ")*", Ho = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $o = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ps = ls + hs + No, Uo = "(?:" + [
            To,
            Or,
            Rr
        ].join("|") + ")" + ps, Wo = "(?:" + [
            us + xe + "?",
            xe,
            Or,
            Rr,
            bo
        ].join("|") + ")", Fo = RegExp(yr, "g"), Mo = RegExp(xe, "g"), br = RegExp(Sr + "(?=" + Sr + ")|" + Wo + ps, "g"), qo = RegExp([
            bt + "?" + is + "+" + fs + "(?=" + [
                es,
                bt,
                "$"
            ].join("|") + ")",
            Do + "+" + cs + "(?=" + [
                es,
                bt + os,
                "$"
            ].join("|") + ")",
            bt + "?" + os + "+" + fs,
            bt + "+" + cs,
            $o,
            Ho,
            rs,
            Uo
        ].join("|"), "g"), Bo = RegExp("[" + as + Ie + Qi + ns + "]"), Go = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, zo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Ko = -1, B = {};
        B[gr] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Ar] = B[Cr] = B[Ir] = !0, B[Ot] = B[me] = B[kt] = B[Yt] = B[Rt] = B[Zt] = B[we] = B[Pe] = B[yn] = B[Jt] = B[qn] = B[Xt] = B[Sn] = B[Qt] = B[Vt] = !1;
        var q = {};
        q[Ot] = q[me] = q[kt] = q[Rt] = q[Yt] = q[Zt] = q[gr] = q[vr] = q[_r] = q[mr] = q[wr] = q[yn] = q[Jt] = q[qn] = q[Xt] = q[Sn] = q[Qt] = q[Ae] = q[Pr] = q[Ar] = q[Cr] = q[Ir] = !0, q[we] = q[Pe] = q[Vt] = !1;
        var Yo = {
            \u00C0: "A",
            \u00C1: "A",
            \u00C2: "A",
            \u00C3: "A",
            \u00C4: "A",
            \u00C5: "A",
            \u00E0: "a",
            \u00E1: "a",
            \u00E2: "a",
            \u00E3: "a",
            \u00E4: "a",
            \u00E5: "a",
            \u00C7: "C",
            \u00E7: "c",
            \u00D0: "D",
            \u00F0: "d",
            \u00C8: "E",
            \u00C9: "E",
            \u00CA: "E",
            \u00CB: "E",
            \u00E8: "e",
            \u00E9: "e",
            \u00EA: "e",
            \u00EB: "e",
            \u00CC: "I",
            \u00CD: "I",
            \u00CE: "I",
            \u00CF: "I",
            \u00EC: "i",
            \u00ED: "i",
            \u00EE: "i",
            \u00EF: "i",
            \u00D1: "N",
            \u00F1: "n",
            \u00D2: "O",
            \u00D3: "O",
            \u00D4: "O",
            \u00D5: "O",
            \u00D6: "O",
            \u00D8: "O",
            \u00F2: "o",
            \u00F3: "o",
            \u00F4: "o",
            \u00F5: "o",
            \u00F6: "o",
            \u00F8: "o",
            \u00D9: "U",
            \u00DA: "U",
            \u00DB: "U",
            \u00DC: "U",
            \u00F9: "u",
            \u00FA: "u",
            \u00FB: "u",
            \u00FC: "u",
            \u00DD: "Y",
            \u00FD: "y",
            \u00FF: "y",
            \u00C6: "Ae",
            \u00E6: "ae",
            \u00DE: "Th",
            \u00FE: "th",
            \u00DF: "ss",
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        }, Zo = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, Jo = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Xo = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Qo = parseFloat, Vo = parseInt, ds = typeof $f7c469cbc3220931$var$ge == "object" && $f7c469cbc3220931$var$ge && $f7c469cbc3220931$var$ge.Object === Object && $f7c469cbc3220931$var$ge, ko = typeof self == "object" && self && self.Object === Object && self, k = ds || ko || Function("return this")(), Tr = u && !u.nodeType && u, lt = Tr && !0 && A && !A.nodeType && A, gs = lt && lt.exports === Tr, Lr = gs && ds.process, _n = function() {
            try {
                var h = lt && lt.require && lt.require("util").types;
                return h || Lr && Lr.binding && Lr.binding("util");
            } catch  {}
        }(), vs = _n && _n.isArrayBuffer, _s = _n && _n.isDate, ms = _n && _n.isMap, ws = _n && _n.isRegExp, Ps = _n && _n.isSet, As = _n && _n.isTypedArray;
        function cn(h, g, d) {
            switch(d.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, d[0]);
                case 2:
                    return h.call(g, d[0], d[1]);
                case 3:
                    return h.call(g, d[0], d[1], d[2]);
            }
            return h.apply(g, d);
        }
        function jo(h, g, d, C) {
            for(var S = -1, U = h == null ? 0 : h.length; ++S < U;){
                var X = h[S];
                g(C, X, d(X), h);
            }
            return C;
        }
        function mn(h, g) {
            for(var d = -1, C = h == null ? 0 : h.length; ++d < C && g(h[d], d, h) !== !1;);
            return h;
        }
        function nf(h, g) {
            for(var d = h == null ? 0 : h.length; d-- && g(h[d], d, h) !== !1;);
            return h;
        }
        function Cs(h, g) {
            for(var d = -1, C = h == null ? 0 : h.length; ++d < C;)if (!g(h[d], d, h)) return !1;
            return !0;
        }
        function jn(h, g) {
            for(var d = -1, C = h == null ? 0 : h.length, S = 0, U = []; ++d < C;){
                var X = h[d];
                g(X, d, h) && (U[S++] = X);
            }
            return U;
        }
        function Ee(h, g) {
            var d = h == null ? 0 : h.length;
            return !!d && Tt(h, g, 0) > -1;
        }
        function Dr(h, g, d) {
            for(var C = -1, S = h == null ? 0 : h.length; ++C < S;)if (d(g, h[C])) return !0;
            return !1;
        }
        function G(h, g) {
            for(var d = -1, C = h == null ? 0 : h.length, S = Array(C); ++d < C;)S[d] = g(h[d], d, h);
            return S;
        }
        function nt(h, g) {
            for(var d = -1, C = g.length, S = h.length; ++d < C;)h[S + d] = g[d];
            return h;
        }
        function Nr(h, g, d, C) {
            var S = -1, U = h == null ? 0 : h.length;
            for(C && U && (d = h[++S]); ++S < U;)d = g(d, h[S], S, h);
            return d;
        }
        function tf(h, g, d, C) {
            var S = h == null ? 0 : h.length;
            for(C && S && (d = h[--S]); S--;)d = g(d, h[S], S, h);
            return d;
        }
        function Hr(h, g) {
            for(var d = -1, C = h == null ? 0 : h.length; ++d < C;)if (g(h[d], d, h)) return !0;
            return !1;
        }
        var ef = $r("length");
        function rf(h) {
            return h.split("");
        }
        function sf(h) {
            return h.match(ho) || [];
        }
        function Is(h, g, d) {
            var C;
            return d(h, function(S, U, X) {
                if (g(S, U, X)) return C = U, !1;
            }), C;
        }
        function ye(h, g, d, C) {
            for(var S = h.length, U = d + (C ? 1 : -1); C ? U-- : ++U < S;)if (g(h[U], U, h)) return U;
            return -1;
        }
        function Tt(h, g, d) {
            return g === g ? _f(h, g, d) : ye(h, xs, d);
        }
        function uf(h, g, d, C) {
            for(var S = d - 1, U = h.length; ++S < U;)if (C(h[S], g)) return S;
            return -1;
        }
        function xs(h) {
            return h !== h;
        }
        function Es(h, g) {
            var d = h == null ? 0 : h.length;
            return d ? Wr(h, g) / d : _e;
        }
        function $r(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function Ur(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function ys(h, g, d, C, S) {
            return S(h, function(U, X, M) {
                d = C ? (C = !1, U) : g(d, U, X, M);
            }), d;
        }
        function af(h, g) {
            var d = h.length;
            for(h.sort(g); d--;)h[d] = h[d].value;
            return h;
        }
        function Wr(h, g) {
            for(var d, C = -1, S = h.length; ++C < S;){
                var U = g(h[C]);
                U !== i && (d = d === i ? U : d + U);
            }
            return d;
        }
        function Fr(h, g) {
            for(var d = -1, C = Array(h); ++d < h;)C[d] = g(d);
            return C;
        }
        function of(h, g) {
            return G(g, function(d) {
                return [
                    d,
                    h[d]
                ];
            });
        }
        function Ss(h) {
            return h && h.slice(0, Ts(h) + 1).replace(Er, "");
        }
        function hn(h) {
            return function(g) {
                return h(g);
            };
        }
        function Mr(h, g) {
            return G(g, function(d) {
                return h[d];
            });
        }
        function jt(h, g) {
            return h.has(g);
        }
        function Os(h, g) {
            for(var d = -1, C = h.length; ++d < C && Tt(g, h[d], 0) > -1;);
            return d;
        }
        function Rs(h, g) {
            for(var d = h.length; d-- && Tt(g, h[d], 0) > -1;);
            return d;
        }
        function ff(h, g) {
            for(var d = h.length, C = 0; d--;)h[d] === g && ++C;
            return C;
        }
        var cf = Ur(Yo), hf = Ur(Zo);
        function lf(h) {
            return "\\" + Xo[h];
        }
        function pf(h, g) {
            return h == null ? i : h[g];
        }
        function Lt(h) {
            return Bo.test(h);
        }
        function df(h) {
            return Go.test(h);
        }
        function gf(h) {
            for(var g, d = []; !(g = h.next()).done;)d.push(g.value);
            return d;
        }
        function qr(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(C, S) {
                d[++g] = [
                    S,
                    C
                ];
            }), d;
        }
        function bs(h, g) {
            return function(d) {
                return h(g(d));
            };
        }
        function tt(h, g) {
            for(var d = -1, C = h.length, S = 0, U = []; ++d < C;){
                var X = h[d];
                (X === g || X === It) && (h[d] = It, U[S++] = d);
            }
            return U;
        }
        function Se(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(C) {
                d[++g] = C;
            }), d;
        }
        function vf(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(C) {
                d[++g] = [
                    C,
                    C
                ];
            }), d;
        }
        function _f(h, g, d) {
            for(var C = d - 1, S = h.length; ++C < S;)if (h[C] === g) return C;
            return -1;
        }
        function mf(h, g, d) {
            for(var C = d + 1; C--;)if (h[C] === g) return C;
            return C;
        }
        function Dt(h) {
            return Lt(h) ? Pf(h) : ef(h);
        }
        function On(h) {
            return Lt(h) ? Af(h) : rf(h);
        }
        function Ts(h) {
            for(var g = h.length; g-- && ao.test(h.charAt(g)););
            return g;
        }
        var wf = Ur(Jo);
        function Pf(h) {
            for(var g = br.lastIndex = 0; br.test(h);)++g;
            return g;
        }
        function Af(h) {
            return h.match(br) || [];
        }
        function Cf(h) {
            return h.match(qo) || [];
        }
        var If = function h(g) {
            g = g == null ? k : Nt.defaults(k.Object(), g, Nt.pick(k, zo));
            var d = g.Array, C = g.Date, S = g.Error, U = g.Function, X = g.Math, M = g.Object, Br = g.RegExp, xf = g.String, wn = g.TypeError, Oe = d.prototype, Ef = U.prototype, Ht = M.prototype, Re = g["__core-js_shared__"], be = Ef.toString, F = Ht.hasOwnProperty, yf = 0, Ls = function() {
                var n = /[^.]+$/.exec(Re && Re.keys && Re.keys.IE_PROTO || "");
                return n ? "Symbol(src)_1." + n : "";
            }(), Te = Ht.toString, Sf = be.call(M), Of = k._, Rf = Br("^" + be.call(F).replace(xr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Le = gs ? g.Buffer : i, et = g.Symbol, De = g.Uint8Array, Ds = Le ? Le.allocUnsafe : i, Ne = bs(M.getPrototypeOf, M), Ns = M.create, Hs = Ht.propertyIsEnumerable, He = Oe.splice, $s = et ? et.isConcatSpreadable : i, ne = et ? et.iterator : i, pt = et ? et.toStringTag : i, $e = function() {
                try {
                    var n = mt(M, "defineProperty");
                    return n({}, "", {}), n;
                } catch  {}
            }(), bf = g.clearTimeout !== k.clearTimeout && g.clearTimeout, Tf = C && C.now !== k.Date.now && C.now, Lf = g.setTimeout !== k.setTimeout && g.setTimeout, Ue = X.ceil, We = X.floor, Gr = M.getOwnPropertySymbols, Df = Le ? Le.isBuffer : i, Us = g.isFinite, Nf = Oe.join, Hf = bs(M.keys, M), Q = X.max, nn = X.min, $f = C.now, Uf = g.parseInt, Ws = X.random, Wf = Oe.reverse, zr = mt(g, "DataView"), te = mt(g, "Map"), Kr = mt(g, "Promise"), $t = mt(g, "Set"), ee = mt(g, "WeakMap"), re = mt(M, "create"), Fe = ee && new ee, Ut = {}, Ff = wt(zr), Mf = wt(te), qf = wt(Kr), Bf = wt($t), Gf = wt(ee), Me = et ? et.prototype : i, ie = Me ? Me.valueOf : i, Fs = Me ? Me.toString : i;
            function a(n) {
                if (Y(n) && !O(n) && !(n instanceof H)) {
                    if (n instanceof Pn) return n;
                    if (F.call(n, "__wrapped__")) return Mu(n);
                }
                return new Pn(n);
            }
            var Wt = function() {
                function n() {}
                return function(t) {
                    if (!K(t)) return {};
                    if (Ns) return Ns(t);
                    n.prototype = t;
                    var e = new n;
                    return n.prototype = i, e;
                };
            }();
            function qe() {}
            function Pn(n, t) {
                this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: to,
                evaluate: eo,
                interpolate: Ji,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = qe.prototype, a.prototype.constructor = a, Pn.prototype = Wt(qe.prototype), Pn.prototype.constructor = Pn;
            function H(n) {
                this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Hn, this.__views__ = [];
            }
            function zf() {
                var n = new H(this.__wrapped__);
                return n.__actions__ = un(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = un(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = un(this.__views__), n;
            }
            function Kf() {
                if (this.__filtered__) {
                    var n = new H(this);
                    n.__dir__ = -1, n.__filtered__ = !0;
                } else n = this.clone(), n.__dir__ *= -1;
                return n;
            }
            function Yf() {
                var n = this.__wrapped__.value(), t = this.__dir__, e = O(n), r = t < 0, s = e ? n.length : 0, o = ih(0, s, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, P = 0, I = nn(l, this.__takeCount__);
                if (!e || !r && s == l && I == l) return fu(n, this.__actions__);
                var E = [];
                n: for(; l-- && P < I;){
                    v += t;
                    for(var T = -1, y = n[v]; ++T < m;){
                        var N = _[T], $ = N.iteratee, dn = N.type, sn = $(y);
                        if (dn == Wa) y = sn;
                        else if (!sn) {
                            if (dn == Gi) continue n;
                            break n;
                        }
                    }
                    E[P++] = y;
                }
                return E;
            }
            H.prototype = Wt(qe.prototype), H.prototype.constructor = H;
            function dt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function Zf() {
                this.__data__ = re ? re(null) : {}, this.size = 0;
            }
            function Jf(n) {
                var t = this.has(n) && delete this.__data__[n];
                return this.size -= t ? 1 : 0, t;
            }
            function Xf(n) {
                var t = this.__data__;
                if (re) {
                    var e = t[n];
                    return e === zt ? i : e;
                }
                return F.call(t, n) ? t[n] : i;
            }
            function Qf(n) {
                var t = this.__data__;
                return re ? t[n] !== i : F.call(t, n);
            }
            function Vf(n, t) {
                var e = this.__data__;
                return this.size += this.has(n) ? 0 : 1, e[n] = re && t === i ? zt : t, this;
            }
            dt.prototype.clear = Zf, dt.prototype.delete = Jf, dt.prototype.get = Xf, dt.prototype.has = Qf, dt.prototype.set = Vf;
            function Bn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function kf() {
                this.__data__ = [], this.size = 0;
            }
            function jf(n) {
                var t = this.__data__, e = Be(t, n);
                if (e < 0) return !1;
                var r = t.length - 1;
                return e == r ? t.pop() : He.call(t, e, 1), --this.size, !0;
            }
            function nc(n) {
                var t = this.__data__, e = Be(t, n);
                return e < 0 ? i : t[e][1];
            }
            function tc(n) {
                return Be(this.__data__, n) > -1;
            }
            function ec(n, t) {
                var e = this.__data__, r = Be(e, n);
                return r < 0 ? (++this.size, e.push([
                    n,
                    t
                ])) : e[r][1] = t, this;
            }
            Bn.prototype.clear = kf, Bn.prototype.delete = jf, Bn.prototype.get = nc, Bn.prototype.has = tc, Bn.prototype.set = ec;
            function Gn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function rc() {
                this.size = 0, this.__data__ = {
                    hash: new dt,
                    map: new (te || Bn),
                    string: new dt
                };
            }
            function ic(n) {
                var t = nr(this, n).delete(n);
                return this.size -= t ? 1 : 0, t;
            }
            function sc(n) {
                return nr(this, n).get(n);
            }
            function uc(n) {
                return nr(this, n).has(n);
            }
            function ac(n, t) {
                var e = nr(this, n), r = e.size;
                return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
            }
            Gn.prototype.clear = rc, Gn.prototype.delete = ic, Gn.prototype.get = sc, Gn.prototype.has = uc, Gn.prototype.set = ac;
            function gt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.__data__ = new Gn; ++t < e;)this.add(n[t]);
            }
            function oc(n) {
                return this.__data__.set(n, zt), this;
            }
            function fc(n) {
                return this.__data__.has(n);
            }
            gt.prototype.add = gt.prototype.push = oc, gt.prototype.has = fc;
            function Rn(n) {
                var t = this.__data__ = new Bn(n);
                this.size = t.size;
            }
            function cc() {
                this.__data__ = new Bn, this.size = 0;
            }
            function hc(n) {
                var t = this.__data__, e = t.delete(n);
                return this.size = t.size, e;
            }
            function lc(n) {
                return this.__data__.get(n);
            }
            function pc(n) {
                return this.__data__.has(n);
            }
            function dc(n, t) {
                var e = this.__data__;
                if (e instanceof Bn) {
                    var r = e.__data__;
                    if (!te || r.length < w - 1) return r.push([
                        n,
                        t
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new Gn(r);
                }
                return e.set(n, t), this.size = e.size, this;
            }
            Rn.prototype.clear = cc, Rn.prototype.delete = hc, Rn.prototype.get = lc, Rn.prototype.has = pc, Rn.prototype.set = dc;
            function Ms(n, t) {
                var e = O(n), r = !e && Pt(n), s = !e && !r && at(n), o = !e && !r && !s && Bt(n), f = e || r || s || o, c = f ? Fr(n.length, xf) : [], l = c.length;
                for(var v in n)(t || F.call(n, v)) && !(f && (v == "length" || s && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Zn(v, l))) && c.push(v);
                return c;
            }
            function qs(n) {
                var t = n.length;
                return t ? n[ei(0, t - 1)] : i;
            }
            function gc(n, t) {
                return tr(un(n), vt(t, 0, n.length));
            }
            function vc(n) {
                return tr(un(n));
            }
            function Yr(n, t, e) {
                (e !== i && !bn(n[t], e) || e === i && !(t in n)) && zn(n, t, e);
            }
            function se(n, t, e) {
                var r = n[t];
                (!(F.call(n, t) && bn(r, e)) || e === i && !(t in n)) && zn(n, t, e);
            }
            function Be(n, t) {
                for(var e = n.length; e--;)if (bn(n[e][0], t)) return e;
                return -1;
            }
            function _c(n, t, e, r) {
                return rt(n, function(s, o, f) {
                    t(r, s, e(s), f);
                }), r;
            }
            function Bs(n, t) {
                return n && Un(t, V(t), n);
            }
            function mc(n, t) {
                return n && Un(t, on(t), n);
            }
            function zn(n, t, e) {
                t == "__proto__" && $e ? $e(n, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : n[t] = e;
            }
            function Zr(n, t) {
                for(var e = -1, r = t.length, s = d(r), o = n == null; ++e < r;)s[e] = o ? i : Si(n, t[e]);
                return s;
            }
            function vt(n, t, e) {
                return n === n && (e !== i && (n = n <= e ? n : e), t !== i && (n = n >= t ? n : t)), n;
            }
            function An(n, t, e, r, s, o) {
                var f, c = t & Ln, l = t & Fn, v = t & xt;
                if (e && (f = s ? e(n, r, s, o) : e(n)), f !== i) return f;
                if (!K(n)) return n;
                var _ = O(n);
                if (_) {
                    if (f = uh(n), !c) return un(n, f);
                } else {
                    var m = tn(n), P = m == Pe || m == zi;
                    if (at(n)) return lu(n, c);
                    if (m == qn || m == Ot || P && !s) {
                        if (f = l || P ? {} : Tu(n), !c) return l ? Xc(n, mc(f, n)) : Jc(n, Bs(f, n));
                    } else {
                        if (!q[m]) return s ? n : {};
                        f = ah(n, m, c);
                    }
                }
                o || (o = new Rn);
                var I = o.get(n);
                if (I) return I;
                o.set(n, f), ua(n) ? n.forEach(function(y) {
                    f.add(An(y, t, e, y, n, o));
                }) : ia(n) && n.forEach(function(y, N) {
                    f.set(N, An(y, t, e, N, n, o));
                });
                var E = v ? l ? pi : li : l ? on : V, T = _ ? i : E(n);
                return mn(T || n, function(y, N) {
                    T && (N = y, y = n[N]), se(f, N, An(y, t, e, N, n, o));
                }), f;
            }
            function wc(n) {
                var t = V(n);
                return function(e) {
                    return Gs(e, n, t);
                };
            }
            function Gs(n, t, e) {
                var r = e.length;
                if (n == null) return !r;
                for(n = M(n); r--;){
                    var s = e[r], o = t[s], f = n[s];
                    if (f === i && !(s in n) || !o(f)) return !1;
                }
                return !0;
            }
            function zs(n, t, e) {
                if (typeof n != "function") throw new wn(D);
                return le(function() {
                    n.apply(i, e);
                }, t);
            }
            function ue(n, t, e, r) {
                var s = -1, o = Ee, f = !0, c = n.length, l = [], v = t.length;
                if (!c) return l;
                e && (t = G(t, hn(e))), r ? (o = Dr, f = !1) : t.length >= w && (o = jt, f = !1, t = new gt(t));
                n: for(; ++s < c;){
                    var _ = n[s], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var P = v; P--;)if (t[P] === m) continue n;
                        l.push(_);
                    } else o(t, m, r) || l.push(_);
                }
                return l;
            }
            var rt = _u($n), Ks = _u(Xr, !0);
            function Pc(n, t) {
                var e = !0;
                return rt(n, function(r, s, o) {
                    return e = !!t(r, s, o), e;
                }), e;
            }
            function Ge(n, t, e) {
                for(var r = -1, s = n.length; ++r < s;){
                    var o = n[r], f = t(o);
                    if (f != null && (c === i ? f === f && !pn(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function Ac(n, t, e, r) {
                var s = n.length;
                for(e = R(e), e < 0 && (e = -e > s ? 0 : s + e), r = r === i || r > s ? s : R(r), r < 0 && (r += s), r = e > r ? 0 : oa(r); e < r;)n[e++] = t;
                return n;
            }
            function Ys(n, t) {
                var e = [];
                return rt(n, function(r, s, o) {
                    t(r, s, o) && e.push(r);
                }), e;
            }
            function j(n, t, e, r, s) {
                var o = -1, f = n.length;
                for(e || (e = fh), s || (s = []); ++o < f;){
                    var c = n[o];
                    t > 0 && e(c) ? t > 1 ? j(c, t - 1, e, r, s) : nt(s, c) : r || (s[s.length] = c);
                }
                return s;
            }
            var Jr = mu(), Zs = mu(!0);
            function $n(n, t) {
                return n && Jr(n, t, V);
            }
            function Xr(n, t) {
                return n && Zs(n, t, V);
            }
            function ze(n, t) {
                return jn(t, function(e) {
                    return Jn(n[e]);
                });
            }
            function _t(n, t) {
                t = st(t, n);
                for(var e = 0, r = t.length; n != null && e < r;)n = n[Wn(t[e++])];
                return e && e == r ? n : i;
            }
            function Js(n, t, e) {
                var r = t(n);
                return O(n) ? r : nt(r, e(n));
            }
            function en(n) {
                return n == null ? n === i ? Ja : Ya : pt && pt in M(n) ? rh(n) : vh(n);
            }
            function Qr(n, t) {
                return n > t;
            }
            function Cc(n, t) {
                return n != null && F.call(n, t);
            }
            function Ic(n, t) {
                return n != null && t in M(n);
            }
            function xc(n, t, e) {
                return n >= nn(t, e) && n < Q(t, e);
            }
            function Vr(n, t, e) {
                for(var r = e ? Dr : Ee, s = n[0].length, o = n.length, f = o, c = d(o), l = 1 / 0, v = []; f--;){
                    var _ = n[f];
                    f && t && (_ = G(_, hn(t))), l = nn(_.length, l), c[f] = !e && (t || s >= 120 && _.length >= 120) ? new gt(f && _) : i;
                }
                _ = n[0];
                var m = -1, P = c[0];
                n: for(; ++m < s && v.length < l;){
                    var I = _[m], E = t ? t(I) : I;
                    if (I = e || I !== 0 ? I : 0, !(P ? jt(P, E) : r(v, E, e))) {
                        for(f = o; --f;){
                            var T = c[f];
                            if (!(T ? jt(T, E) : r(n[f], E, e))) continue n;
                        }
                        P && P.push(E), v.push(I);
                    }
                }
                return v;
            }
            function Ec(n, t, e, r) {
                return $n(n, function(s, o, f) {
                    t(r, e(s), o, f);
                }), r;
            }
            function ae(n, t, e) {
                t = st(t, n), n = Hu(n, t);
                var r = n == null ? n : n[Wn(In(t))];
                return r == null ? i : cn(r, n, e);
            }
            function Xs(n) {
                return Y(n) && en(n) == Ot;
            }
            function yc(n) {
                return Y(n) && en(n) == kt;
            }
            function Sc(n) {
                return Y(n) && en(n) == Zt;
            }
            function oe(n, t, e, r, s) {
                return n === t ? !0 : n == null || t == null || !Y(n) && !Y(t) ? n !== n && t !== t : Oc(n, t, e, r, oe, s);
            }
            function Oc(n, t, e, r, s, o) {
                var f = O(n), c = O(t), l = f ? me : tn(n), v = c ? me : tn(t);
                l = l == Ot ? qn : l, v = v == Ot ? qn : v;
                var _ = l == qn, m = v == qn, P = l == v;
                if (P && at(n)) {
                    if (!at(t)) return !1;
                    f = !0, _ = !1;
                }
                if (P && !_) return o || (o = new Rn), f || Bt(n) ? Ou(n, t, e, r, s, o) : th(n, t, l, e, r, s, o);
                if (!(e & Et)) {
                    var I = _ && F.call(n, "__wrapped__"), E = m && F.call(t, "__wrapped__");
                    if (I || E) {
                        var T = I ? n.value() : n, y = E ? t.value() : t;
                        return o || (o = new Rn), s(T, y, e, r, o);
                    }
                }
                return P ? (o || (o = new Rn), eh(n, t, e, r, s, o)) : !1;
            }
            function Rc(n) {
                return Y(n) && tn(n) == yn;
            }
            function kr(n, t, e, r) {
                var s = e.length, o = s, f = !r;
                if (n == null) return !o;
                for(n = M(n); s--;){
                    var c = e[s];
                    if (f && c[2] ? c[1] !== n[c[0]] : !(c[0] in n)) return !1;
                }
                for(; ++s < o;){
                    c = e[s];
                    var l = c[0], v = n[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in n)) return !1;
                    } else {
                        var m = new Rn;
                        if (r) var P = r(v, _, l, n, t, m);
                        if (!(P === i ? oe(_, v, Et | ve, r, m) : P)) return !1;
                    }
                }
                return !0;
            }
            function Qs(n) {
                if (!K(n) || hh(n)) return !1;
                var t = Jn(n) ? Rf : mo;
                return t.test(wt(n));
            }
            function bc(n) {
                return Y(n) && en(n) == Xt;
            }
            function Tc(n) {
                return Y(n) && tn(n) == Sn;
            }
            function Lc(n) {
                return Y(n) && ar(n.length) && !!B[en(n)];
            }
            function Vs(n) {
                return typeof n == "function" ? n : n == null ? fn : typeof n == "object" ? O(n) ? nu(n[0], n[1]) : js(n) : wa(n);
            }
            function jr(n) {
                if (!he(n)) return Hf(n);
                var t = [];
                for(var e in M(n))F.call(n, e) && e != "constructor" && t.push(e);
                return t;
            }
            function Dc(n) {
                if (!K(n)) return gh(n);
                var t = he(n), e = [];
                for(var r in n)r == "constructor" && (t || !F.call(n, r)) || e.push(r);
                return e;
            }
            function ni(n, t) {
                return n < t;
            }
            function ks(n, t) {
                var e = -1, r = an(n) ? d(n.length) : [];
                return rt(n, function(s, o, f) {
                    r[++e] = t(s, o, f);
                }), r;
            }
            function js(n) {
                var t = gi(n);
                return t.length == 1 && t[0][2] ? Du(t[0][0], t[0][1]) : function(e) {
                    return e === n || kr(e, n, t);
                };
            }
            function nu(n, t) {
                return _i(n) && Lu(t) ? Du(Wn(n), t) : function(e) {
                    var r = Si(e, n);
                    return r === i && r === t ? Oi(e, n) : oe(t, r, Et | ve);
                };
            }
            function Ke(n, t, e, r, s) {
                n !== t && Jr(t, function(o, f) {
                    if (s || (s = new Rn), K(o)) Nc(n, t, f, e, Ke, r, s);
                    else {
                        var c = r ? r(wi(n, f), o, f + "", n, t, s) : i;
                        c === i && (c = o), Yr(n, f, c);
                    }
                }, on);
            }
            function Nc(n, t, e, r, s, o, f) {
                var c = wi(n, e), l = wi(t, e), v = f.get(l);
                if (v) {
                    Yr(n, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", n, t, f) : i, m = _ === i;
                if (m) {
                    var P = O(l), I = !P && at(l), E = !P && !I && Bt(l);
                    _ = l, P || I || E ? O(c) ? _ = c : Z(c) ? _ = un(c) : I ? (m = !1, _ = lu(l, !0)) : E ? (m = !1, _ = pu(l, !0)) : _ = [] : pe(l) || Pt(l) ? (_ = c, Pt(c) ? _ = fa(c) : (!K(c) || Jn(c)) && (_ = Tu(l))) : m = !1;
                }
                m && (f.set(l, _), s(_, l, r, o, f), f.delete(l)), Yr(n, e, _);
            }
            function tu(n, t) {
                var e = n.length;
                if (e) return t += t < 0 ? e : 0, Zn(t, e) ? n[t] : i;
            }
            function eu(n, t, e) {
                t.length ? t = G(t, function(o) {
                    return O(o) ? function(f) {
                        return _t(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : t = [
                    fn
                ];
                var r = -1;
                t = G(t, hn(x()));
                var s = ks(n, function(o, f, c) {
                    var l = G(t, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return af(s, function(o, f) {
                    return Zc(o, f, e);
                });
            }
            function Hc(n, t) {
                return ru(n, t, function(e, r) {
                    return Oi(n, r);
                });
            }
            function ru(n, t, e) {
                for(var r = -1, s = t.length, o = {}; ++r < s;){
                    var f = t[r], c = _t(n, f);
                    e(c, f) && fe(o, st(f, n), c);
                }
                return o;
            }
            function $c(n) {
                return function(t) {
                    return _t(t, n);
                };
            }
            function ti(n, t, e, r) {
                var s = r ? uf : Tt, o = -1, f = t.length, c = n;
                for(n === t && (t = un(t)), e && (c = G(n, hn(e))); ++o < f;)for(var l = 0, v = t[o], _ = e ? e(v) : v; (l = s(c, _, l, r)) > -1;)c !== n && He.call(c, l, 1), He.call(n, l, 1);
                return n;
            }
            function iu(n, t) {
                for(var e = n ? t.length : 0, r = e - 1; e--;){
                    var s = t[e];
                    if (e == r || s !== o) {
                        var o = s;
                        Zn(s) ? He.call(n, s, 1) : si(n, s);
                    }
                }
                return n;
            }
            function ei(n, t) {
                return n + We(Ws() * (t - n + 1));
            }
            function Uc(n, t, e, r) {
                for(var s = -1, o = Q(Ue((t - n) / (e || 1)), 0), f = d(o); o--;)f[r ? o : ++s] = n, n += e;
                return f;
            }
            function ri(n, t) {
                var e = "";
                if (!n || t < 1 || t > kn) return e;
                do t % 2 && (e += n), t = We(t / 2), t && (n += n);
                while (t);
                return e;
            }
            function L(n, t) {
                return Pi(Nu(n, t, fn), n + "");
            }
            function Wc(n) {
                return qs(Gt(n));
            }
            function Fc(n, t) {
                var e = Gt(n);
                return tr(e, vt(t, 0, e.length));
            }
            function fe(n, t, e, r) {
                if (!K(n)) return n;
                t = st(t, n);
                for(var s = -1, o = t.length, f = o - 1, c = n; c != null && ++s < o;){
                    var l = Wn(t[s]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return n;
                    if (s != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = K(_) ? _ : Zn(t[s + 1]) ? [] : {});
                    }
                    se(c, l, v), c = c[l];
                }
                return n;
            }
            var su = Fe ? function(n, t) {
                return Fe.set(n, t), n;
            } : fn, Mc = $e ? function(n, t) {
                return $e(n, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: bi(t),
                    writable: !0
                });
            } : fn;
            function qc(n) {
                return tr(Gt(n));
            }
            function Cn(n, t, e) {
                var r = -1, s = n.length;
                t < 0 && (t = -t > s ? 0 : s + t), e = e > s ? s : e, e < 0 && (e += s), s = t > e ? 0 : e - t >>> 0, t >>>= 0;
                for(var o = d(s); ++r < s;)o[r] = n[r + t];
                return o;
            }
            function Bc(n, t) {
                var e;
                return rt(n, function(r, s, o) {
                    return e = t(r, s, o), !e;
                }), !!e;
            }
            function Ye(n, t, e) {
                var r = 0, s = n == null ? r : n.length;
                if (typeof t == "number" && t === t && s <= Ba) {
                    for(; r < s;){
                        var o = r + s >>> 1, f = n[o];
                        f !== null && !pn(f) && (e ? f <= t : f < t) ? r = o + 1 : s = o;
                    }
                    return s;
                }
                return ii(n, t, fn, e);
            }
            function ii(n, t, e, r) {
                var s = 0, o = n == null ? 0 : n.length;
                if (o === 0) return 0;
                t = e(t);
                for(var f = t !== t, c = t === null, l = pn(t), v = t === i; s < o;){
                    var _ = We((s + o) / 2), m = e(n[_]), P = m !== i, I = m === null, E = m === m, T = pn(m);
                    if (f) var y = r || E;
                    else v ? y = E && (r || P) : c ? y = E && P && (r || !I) : l ? y = E && P && !I && (r || !T) : I || T ? y = !1 : y = r ? m <= t : m < t;
                    y ? s = _ + 1 : o = _;
                }
                return nn(o, qa);
            }
            function uu(n, t) {
                for(var e = -1, r = n.length, s = 0, o = []; ++e < r;){
                    var f = n[e], c = t ? t(f) : f;
                    if (!e || !bn(c, l)) {
                        var l = c;
                        o[s++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function au(n) {
                return typeof n == "number" ? n : pn(n) ? _e : +n;
            }
            function ln(n) {
                if (typeof n == "string") return n;
                if (O(n)) return G(n, ln) + "";
                if (pn(n)) return Fs ? Fs.call(n) : "";
                var t = n + "";
                return t == "0" && 1 / n == -ht ? "-0" : t;
            }
            function it(n, t, e) {
                var r = -1, s = Ee, o = n.length, f = !0, c = [], l = c;
                if (e) f = !1, s = Dr;
                else if (o >= w) {
                    var v = t ? null : jc(n);
                    if (v) return Se(v);
                    f = !1, s = jt, l = new gt;
                } else l = t ? [] : c;
                n: for(; ++r < o;){
                    var _ = n[r], m = t ? t(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var P = l.length; P--;)if (l[P] === m) continue n;
                        t && l.push(m), c.push(_);
                    } else s(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function si(n, t) {
                return t = st(t, n), n = Hu(n, t), n == null || delete n[Wn(In(t))];
            }
            function ou(n, t, e, r) {
                return fe(n, t, e(_t(n, t)), r);
            }
            function Ze(n, t, e, r) {
                for(var s = n.length, o = r ? s : -1; (r ? o-- : ++o < s) && t(n[o], o, n););
                return e ? Cn(n, r ? 0 : o, r ? o + 1 : s) : Cn(n, r ? o + 1 : 0, r ? s : o);
            }
            function fu(n, t) {
                var e = n;
                return e instanceof H && (e = e.value()), Nr(t, function(r, s) {
                    return s.func.apply(s.thisArg, nt([
                        r
                    ], s.args));
                }, e);
            }
            function ui(n, t, e) {
                var r = n.length;
                if (r < 2) return r ? it(n[0]) : [];
                for(var s = -1, o = d(r); ++s < r;)for(var f = n[s], c = -1; ++c < r;)c != s && (o[s] = ue(o[s] || f, n[c], t, e));
                return it(j(o, 1), t, e);
            }
            function cu(n, t, e) {
                for(var r = -1, s = n.length, o = t.length, f = {}; ++r < s;){
                    var c = r < o ? t[r] : i;
                    e(f, n[r], c);
                }
                return f;
            }
            function ai(n) {
                return Z(n) ? n : [];
            }
            function oi(n) {
                return typeof n == "function" ? n : fn;
            }
            function st(n, t) {
                return O(n) ? n : _i(n, t) ? [
                    n
                ] : Fu(W(n));
            }
            var Gc = L;
            function ut(n, t, e) {
                var r = n.length;
                return e = e === i ? r : e, !t && e >= r ? n : Cn(n, t, e);
            }
            var hu = bf || function(n) {
                return k.clearTimeout(n);
            };
            function lu(n, t) {
                if (t) return n.slice();
                var e = n.length, r = Ds ? Ds(e) : new n.constructor(e);
                return n.copy(r), r;
            }
            function fi(n) {
                var t = new n.constructor(n.byteLength);
                return new De(t).set(new De(n)), t;
            }
            function zc(n, t) {
                var e = t ? fi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.byteLength);
            }
            function Kc(n) {
                var t = new n.constructor(n.source, Xi.exec(n));
                return t.lastIndex = n.lastIndex, t;
            }
            function Yc(n) {
                return ie ? M(ie.call(n)) : {};
            }
            function pu(n, t) {
                var e = t ? fi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.length);
            }
            function du(n, t) {
                if (n !== t) {
                    var e = n !== i, r = n === null, s = n === n, o = pn(n), f = t !== i, c = t === null, l = t === t, v = pn(t);
                    if (!c && !v && !o && n > t || o && f && l && !c && !v || r && f && l || !e && l || !s) return 1;
                    if (!r && !o && !v && n < t || v && e && s && !r && !o || c && e && s || !f && s || !l) return -1;
                }
                return 0;
            }
            function Zc(n, t, e) {
                for(var r = -1, s = n.criteria, o = t.criteria, f = s.length, c = e.length; ++r < f;){
                    var l = du(s[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return n.index - t.index;
            }
            function gu(n, t, e, r) {
                for(var s = -1, o = n.length, f = e.length, c = -1, l = t.length, v = Q(o - f, 0), _ = d(l + v), m = !r; ++c < l;)_[c] = t[c];
                for(; ++s < f;)(m || s < o) && (_[e[s]] = n[s]);
                for(; v--;)_[c++] = n[s++];
                return _;
            }
            function vu(n, t, e, r) {
                for(var s = -1, o = n.length, f = -1, c = e.length, l = -1, v = t.length, _ = Q(o - c, 0), m = d(_ + v), P = !r; ++s < _;)m[s] = n[s];
                for(var I = s; ++l < v;)m[I + l] = t[l];
                for(; ++f < c;)(P || s < o) && (m[I + e[f]] = n[s++]);
                return m;
            }
            function un(n, t) {
                var e = -1, r = n.length;
                for(t || (t = d(r)); ++e < r;)t[e] = n[e];
                return t;
            }
            function Un(n, t, e, r) {
                var s = !e;
                e || (e = {});
                for(var o = -1, f = t.length; ++o < f;){
                    var c = t[o], l = r ? r(e[c], n[c], c, e, n) : i;
                    l === i && (l = n[c]), s ? zn(e, c, l) : se(e, c, l);
                }
                return e;
            }
            function Jc(n, t) {
                return Un(n, vi(n), t);
            }
            function Xc(n, t) {
                return Un(n, Ru(n), t);
            }
            function Je(n, t) {
                return function(e, r) {
                    var s = O(e) ? jo : _c, o = t ? t() : {};
                    return s(e, n, x(r, 2), o);
                };
            }
            function Ft(n) {
                return L(function(t, e) {
                    var r = -1, s = e.length, o = s > 1 ? e[s - 1] : i, f = s > 2 ? e[2] : i;
                    for(o = n.length > 3 && typeof o == "function" ? (s--, o) : i, f && rn(e[0], e[1], f) && (o = s < 3 ? i : o, s = 1), t = M(t); ++r < s;){
                        var c = e[r];
                        c && n(t, c, r, o);
                    }
                    return t;
                });
            }
            function _u(n, t) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!an(e)) return n(e, r);
                    for(var s = e.length, o = t ? s : -1, f = M(e); (t ? o-- : ++o < s) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function mu(n) {
                return function(t, e, r) {
                    for(var s = -1, o = M(t), f = r(t), c = f.length; c--;){
                        var l = f[n ? c : ++s];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return t;
                };
            }
            function Qc(n, t, e) {
                var r = t & vn, s = ce(n);
                function o() {
                    var f = this && this !== k && this instanceof o ? s : n;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function wu(n) {
                return function(t) {
                    t = W(t);
                    var e = Lt(t) ? On(t) : i, r = e ? e[0] : t.charAt(0), s = e ? ut(e, 1).join("") : t.slice(1);
                    return r[n]() + s;
                };
            }
            function Mt(n) {
                return function(t) {
                    return Nr(_a(va(t).replace(Fo, "")), n, "");
                };
            }
            function ce(n) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new n;
                        case 1:
                            return new n(t[0]);
                        case 2:
                            return new n(t[0], t[1]);
                        case 3:
                            return new n(t[0], t[1], t[2]);
                        case 4:
                            return new n(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new n(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var e = Wt(n.prototype), r = n.apply(e, t);
                    return K(r) ? r : e;
                };
            }
            function Vc(n, t, e) {
                var r = ce(n);
                function s() {
                    for(var o = arguments.length, f = d(o), c = o, l = qt(s); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : tt(f, l);
                    if (o -= v.length, o < e) return xu(n, t, Xe, s.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== k && this instanceof s ? r : n;
                    return cn(_, this, f);
                }
                return s;
            }
            function Pu(n) {
                return function(t, e, r) {
                    var s = M(t);
                    if (!an(t)) {
                        var o = x(e, 3);
                        t = V(t), e = function(c) {
                            return o(s[c], c, s);
                        };
                    }
                    var f = n(t, e, r);
                    return f > -1 ? s[o ? t[f] : f] : i;
                };
            }
            function Au(n) {
                return Yn(function(t) {
                    var e = t.length, r = e, s = Pn.prototype.thru;
                    for(n && t.reverse(); r--;){
                        var o = t[r];
                        if (typeof o != "function") throw new wn(D);
                        if (s && !f && je(o) == "wrapper") var f = new Pn([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = t[r];
                        var c = je(o), l = c == "wrapper" ? di(o) : i;
                        l && mi(l[0]) && l[1] == (Mn | Dn | Nn | Kt) && !l[4].length && l[9] == 1 ? f = f[je(l[0])].apply(f, l[3]) : f = o.length == 1 && mi(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && O(_)) return f.plant(_).value();
                        for(var m = 0, P = e ? t[m].apply(this, v) : _; ++m < e;)P = t[m].call(this, P);
                        return P;
                    };
                });
            }
            function Xe(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Mn, m = t & vn, P = t & ct, I = t & (Dn | yt), E = t & dr, T = P ? i : ce(n);
                function y() {
                    for(var N = arguments.length, $ = d(N), dn = N; dn--;)$[dn] = arguments[dn];
                    if (I) var sn = qt(y), gn = ff($, sn);
                    if (r && ($ = gu($, r, s, I)), o && ($ = vu($, o, f, I)), N -= gn, I && N < v) {
                        var J = tt($, sn);
                        return xu(n, t, Xe, y.placeholder, e, $, J, c, l, v - N);
                    }
                    var Tn = m ? e : this, Qn = P ? Tn[n] : n;
                    return N = $.length, c ? $ = _h($, c) : E && N > 1 && $.reverse(), _ && l < N && ($.length = l), this && this !== k && this instanceof y && (Qn = T || ce(Qn)), Qn.apply(Tn, $);
                }
                return y;
            }
            function Cu(n, t) {
                return function(e, r) {
                    return Ec(e, n, t(r), {});
                };
            }
            function Qe(n, t) {
                return function(e, r) {
                    var s;
                    if (e === i && r === i) return t;
                    if (e !== i && (s = e), r !== i) {
                        if (s === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = ln(e), r = ln(r)) : (e = au(e), r = au(r)), s = n(e, r);
                    }
                    return s;
                };
            }
            function ci(n) {
                return Yn(function(t) {
                    return t = G(t, hn(x())), L(function(e) {
                        var r = this;
                        return n(t, function(s) {
                            return cn(s, r, e);
                        });
                    });
                });
            }
            function Ve(n, t) {
                t = t === i ? " " : ln(t);
                var e = t.length;
                if (e < 2) return e ? ri(t, n) : t;
                var r = ri(t, Ue(n / Dt(t)));
                return Lt(t) ? ut(On(r), 0, n).join("") : r.slice(0, n);
            }
            function kc(n, t, e, r) {
                var s = t & vn, o = ce(n);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = d(_ + l), P = this && this !== k && this instanceof f ? o : n; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return cn(P, s ? e : this, m);
                }
                return f;
            }
            function Iu(n) {
                return function(t, e, r) {
                    return r && typeof r != "number" && rn(t, e, r) && (e = r = i), t = Xn(t), e === i ? (e = t, t = 0) : e = Xn(e), r = r === i ? t < e ? 1 : -1 : Xn(r), Uc(t, e, r, n);
                };
            }
            function ke(n) {
                return function(t, e) {
                    return typeof t == "string" && typeof e == "string" || (t = xn(t), e = xn(e)), n(t, e);
                };
            }
            function xu(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Dn, m = _ ? f : i, P = _ ? i : f, I = _ ? o : i, E = _ ? i : o;
                t |= _ ? Nn : St, t &= ~(_ ? St : Nn), t & Bi || (t &= ~(vn | ct));
                var T = [
                    n,
                    t,
                    s,
                    I,
                    m,
                    E,
                    P,
                    c,
                    l,
                    v
                ], y = e.apply(i, T);
                return mi(n) && $u(y, T), y.placeholder = r, Uu(y, n, t);
            }
            function hi(n) {
                var t = X[n];
                return function(e, r) {
                    if (e = xn(e), r = r == null ? 0 : nn(R(r), 292), r && Us(e)) {
                        var s = (W(e) + "e").split("e"), o = t(s[0] + "e" + (+s[1] + r));
                        return s = (W(o) + "e").split("e"), +(s[0] + "e" + (+s[1] - r));
                    }
                    return t(e);
                };
            }
            var jc = $t && 1 / Se(new $t([
                ,
                -0
            ]))[1] == ht ? function(n) {
                return new $t(n);
            } : Di;
            function Eu(n) {
                return function(t) {
                    var e = tn(t);
                    return e == yn ? qr(t) : e == Sn ? vf(t) : of(t, n(t));
                };
            }
            function Kn(n, t, e, r, s, o, f, c) {
                var l = t & ct;
                if (!l && typeof n != "function") throw new wn(D);
                var v = r ? r.length : 0;
                if (v || (t &= ~(Nn | St), r = s = i), f = f === i ? f : Q(R(f), 0), c = c === i ? c : R(c), v -= s ? s.length : 0, t & St) {
                    var _ = r, m = s;
                    r = s = i;
                }
                var P = l ? i : di(n), I = [
                    n,
                    t,
                    e,
                    r,
                    s,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (P && dh(I, P), n = I[0], t = I[1], e = I[2], r = I[3], s = I[4], c = I[9] = I[9] === i ? l ? 0 : n.length : Q(I[9] - v, 0), !c && t & (Dn | yt) && (t &= ~(Dn | yt)), !t || t == vn) var E = Qc(n, t, e);
                else t == Dn || t == yt ? E = Vc(n, t, c) : (t == Nn || t == (vn | Nn)) && !s.length ? E = kc(n, t, e, r) : E = Xe.apply(i, I);
                var T = P ? su : $u;
                return Uu(T(E, I), n, t);
            }
            function yu(n, t, e, r) {
                return n === i || bn(n, Ht[e]) && !F.call(r, e) ? t : n;
            }
            function Su(n, t, e, r, s, o) {
                return K(n) && K(t) && (o.set(t, n), Ke(n, t, i, Su, o), o.delete(t)), n;
            }
            function nh(n) {
                return pe(n) ? i : n;
            }
            function Ou(n, t, e, r, s, o) {
                var f = e & Et, c = n.length, l = t.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(n), _ = o.get(t);
                if (v && _) return v == t && _ == n;
                var m = -1, P = !0, I = e & ve ? new gt : i;
                for(o.set(n, t), o.set(t, n); ++m < c;){
                    var E = n[m], T = t[m];
                    if (r) var y = f ? r(T, E, m, t, n, o) : r(E, T, m, n, t, o);
                    if (y !== i) {
                        if (y) continue;
                        P = !1;
                        break;
                    }
                    if (I) {
                        if (!Hr(t, function(N, $) {
                            if (!jt(I, $) && (E === N || s(E, N, e, r, o))) return I.push($);
                        })) {
                            P = !1;
                            break;
                        }
                    } else if (!(E === T || s(E, T, e, r, o))) {
                        P = !1;
                        break;
                    }
                }
                return o.delete(n), o.delete(t), P;
            }
            function th(n, t, e, r, s, o, f) {
                switch(e){
                    case Rt:
                        if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                        n = n.buffer, t = t.buffer;
                    case kt:
                        return !(n.byteLength != t.byteLength || !o(new De(n), new De(t)));
                    case Yt:
                    case Zt:
                    case Jt:
                        return bn(+n, +t);
                    case we:
                        return n.name == t.name && n.message == t.message;
                    case Xt:
                    case Qt:
                        return n == t + "";
                    case yn:
                        var c = qr;
                    case Sn:
                        var l = r & Et;
                        if (c || (c = Se), n.size != t.size && !l) return !1;
                        var v = f.get(n);
                        if (v) return v == t;
                        r |= ve, f.set(n, t);
                        var _ = Ou(c(n), c(t), r, s, o, f);
                        return f.delete(n), _;
                    case Ae:
                        if (ie) return ie.call(n) == ie.call(t);
                }
                return !1;
            }
            function eh(n, t, e, r, s, o) {
                var f = e & Et, c = li(n), l = c.length, v = li(t), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var P = c[m];
                    if (!(f ? P in t : F.call(t, P))) return !1;
                }
                var I = o.get(n), E = o.get(t);
                if (I && E) return I == t && E == n;
                var T = !0;
                o.set(n, t), o.set(t, n);
                for(var y = f; ++m < l;){
                    P = c[m];
                    var N = n[P], $ = t[P];
                    if (r) var dn = f ? r($, N, P, t, n, o) : r(N, $, P, n, t, o);
                    if (!(dn === i ? N === $ || s(N, $, e, r, o) : dn)) {
                        T = !1;
                        break;
                    }
                    y || (y = P == "constructor");
                }
                if (T && !y) {
                    var sn = n.constructor, gn = t.constructor;
                    sn != gn && "constructor" in n && "constructor" in t && !(typeof sn == "function" && sn instanceof sn && typeof gn == "function" && gn instanceof gn) && (T = !1);
                }
                return o.delete(n), o.delete(t), T;
            }
            function Yn(n) {
                return Pi(Nu(n, i, Gu), n + "");
            }
            function li(n) {
                return Js(n, V, vi);
            }
            function pi(n) {
                return Js(n, on, Ru);
            }
            var di = Fe ? function(n) {
                return Fe.get(n);
            } : Di;
            function je(n) {
                for(var t = n.name + "", e = Ut[t], r = F.call(Ut, t) ? e.length : 0; r--;){
                    var s = e[r], o = s.func;
                    if (o == null || o == n) return s.name;
                }
                return t;
            }
            function qt(n) {
                var t = F.call(a, "placeholder") ? a : n;
                return t.placeholder;
            }
            function x() {
                var n = a.iteratee || Ti;
                return n = n === Ti ? Vs : n, arguments.length ? n(arguments[0], arguments[1]) : n;
            }
            function nr(n, t) {
                var e = n.__data__;
                return ch(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
            }
            function gi(n) {
                for(var t = V(n), e = t.length; e--;){
                    var r = t[e], s = n[r];
                    t[e] = [
                        r,
                        s,
                        Lu(s)
                    ];
                }
                return t;
            }
            function mt(n, t) {
                var e = pf(n, t);
                return Qs(e) ? e : i;
            }
            function rh(n) {
                var t = F.call(n, pt), e = n[pt];
                try {
                    n[pt] = i;
                    var r = !0;
                } catch  {}
                var s = Te.call(n);
                return r && (t ? n[pt] = e : delete n[pt]), s;
            }
            var vi = Gr ? function(n) {
                return n == null ? [] : (n = M(n), jn(Gr(n), function(t) {
                    return Hs.call(n, t);
                }));
            } : Ni, Ru = Gr ? function(n) {
                for(var t = []; n;)nt(t, vi(n)), n = Ne(n);
                return t;
            } : Ni, tn = en;
            (zr && tn(new zr(new ArrayBuffer(1))) != Rt || te && tn(new te) != yn || Kr && tn(Kr.resolve()) != Ki || $t && tn(new $t) != Sn || ee && tn(new ee) != Vt) && (tn = function(n) {
                var t = en(n), e = t == qn ? n.constructor : i, r = e ? wt(e) : "";
                if (r) switch(r){
                    case Ff:
                        return Rt;
                    case Mf:
                        return yn;
                    case qf:
                        return Ki;
                    case Bf:
                        return Sn;
                    case Gf:
                        return Vt;
                }
                return t;
            });
            function ih(n, t, e) {
                for(var r = -1, s = e.length; ++r < s;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            n += f;
                            break;
                        case "dropRight":
                            t -= f;
                            break;
                        case "take":
                            t = nn(t, n + f);
                            break;
                        case "takeRight":
                            n = Q(n, t - f);
                            break;
                    }
                }
                return {
                    start: n,
                    end: t
                };
            }
            function sh(n) {
                var t = n.match(fo);
                return t ? t[1].split(co) : [];
            }
            function bu(n, t, e) {
                t = st(t, n);
                for(var r = -1, s = t.length, o = !1; ++r < s;){
                    var f = Wn(t[r]);
                    if (!(o = n != null && e(n, f))) break;
                    n = n[f];
                }
                return o || ++r != s ? o : (s = n == null ? 0 : n.length, !!s && ar(s) && Zn(f, s) && (O(n) || Pt(n)));
            }
            function uh(n) {
                var t = n.length, e = new n.constructor(t);
                return t && typeof n[0] == "string" && F.call(n, "index") && (e.index = n.index, e.input = n.input), e;
            }
            function Tu(n) {
                return typeof n.constructor == "function" && !he(n) ? Wt(Ne(n)) : {};
            }
            function ah(n, t, e) {
                var r = n.constructor;
                switch(t){
                    case kt:
                        return fi(n);
                    case Yt:
                    case Zt:
                        return new r(+n);
                    case Rt:
                        return zc(n, e);
                    case gr:
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Ar:
                    case Cr:
                    case Ir:
                        return pu(n, e);
                    case yn:
                        return new r;
                    case Jt:
                    case Qt:
                        return new r(n);
                    case Xt:
                        return Kc(n);
                    case Sn:
                        return new r;
                    case Ae:
                        return Yc(n);
                }
            }
            function oh(n, t) {
                var e = t.length;
                if (!e) return n;
                var r = e - 1;
                return t[r] = (e > 1 ? "& " : "") + t[r], t = t.join(e > 2 ? ", " : " "), n.replace(oo, `{
/* [wrapped with ` + t + `] */
`);
            }
            function fh(n) {
                return O(n) || Pt(n) || !!($s && n && n[$s]);
            }
            function Zn(n, t) {
                var e = typeof n;
                return t = t ?? kn, !!t && (e == "number" || e != "symbol" && Po.test(n)) && n > -1 && n % 1 == 0 && n < t;
            }
            function rn(n, t, e) {
                if (!K(e)) return !1;
                var r = typeof t;
                return (r == "number" ? an(e) && Zn(t, e.length) : r == "string" && t in e) ? bn(e[t], n) : !1;
            }
            function _i(n, t) {
                if (O(n)) return !1;
                var e = typeof n;
                return e == "number" || e == "symbol" || e == "boolean" || n == null || pn(n) ? !0 : io.test(n) || !ro.test(n) || t != null && n in M(t);
            }
            function ch(n) {
                var t = typeof n;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
            }
            function mi(n) {
                var t = je(n), e = a[t];
                if (typeof e != "function" || !(t in H.prototype)) return !1;
                if (n === e) return !0;
                var r = di(e);
                return !!r && n === r[0];
            }
            function hh(n) {
                return !!Ls && Ls in n;
            }
            var lh = Re ? Jn : Hi;
            function he(n) {
                var t = n && n.constructor, e = typeof t == "function" && t.prototype || Ht;
                return n === e;
            }
            function Lu(n) {
                return n === n && !K(n);
            }
            function Du(n, t) {
                return function(e) {
                    return e == null ? !1 : e[n] === t && (t !== i || n in M(e));
                };
            }
            function ph(n) {
                var t = sr(n, function(r) {
                    return e.size === pr && e.clear(), r;
                }), e = t.cache;
                return t;
            }
            function dh(n, t) {
                var e = n[1], r = t[1], s = e | r, o = s < (vn | ct | Mn), f = r == Mn && e == Dn || r == Mn && e == Kt && n[7].length <= t[8] || r == (Mn | Kt) && t[7].length <= t[8] && e == Dn;
                if (!(o || f)) return n;
                r & vn && (n[2] = t[2], s |= e & vn ? 0 : Bi);
                var c = t[3];
                if (c) {
                    var l = n[3];
                    n[3] = l ? gu(l, c, t[4]) : c, n[4] = l ? tt(n[3], It) : t[4];
                }
                return c = t[5], c && (l = n[5], n[5] = l ? vu(l, c, t[6]) : c, n[6] = l ? tt(n[5], It) : t[6]), c = t[7], c && (n[7] = c), r & Mn && (n[8] = n[8] == null ? t[8] : nn(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = s, n;
            }
            function gh(n) {
                var t = [];
                if (n != null) for(var e in M(n))t.push(e);
                return t;
            }
            function vh(n) {
                return Te.call(n);
            }
            function Nu(n, t, e) {
                return t = Q(t === i ? n.length - 1 : t, 0), function() {
                    for(var r = arguments, s = -1, o = Q(r.length - t, 0), f = d(o); ++s < o;)f[s] = r[t + s];
                    s = -1;
                    for(var c = d(t + 1); ++s < t;)c[s] = r[s];
                    return c[t] = e(f), cn(n, this, c);
                };
            }
            function Hu(n, t) {
                return t.length < 2 ? n : _t(n, Cn(t, 0, -1));
            }
            function _h(n, t) {
                for(var e = n.length, r = nn(t.length, e), s = un(n); r--;){
                    var o = t[r];
                    n[r] = Zn(o, e) ? s[o] : i;
                }
                return n;
            }
            function wi(n, t) {
                if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__") return n[t];
            }
            var $u = Wu(su), le = Lf || function(n, t) {
                return k.setTimeout(n, t);
            }, Pi = Wu(Mc);
            function Uu(n, t, e) {
                var r = t + "";
                return Pi(n, oh(r, mh(sh(r), e)));
            }
            function Wu(n) {
                var t = 0, e = 0;
                return function() {
                    var r = $f(), s = Ua - (r - e);
                    if (e = r, s > 0) {
                        if (++t >= $a) return arguments[0];
                    } else t = 0;
                    return n.apply(i, arguments);
                };
            }
            function tr(n, t) {
                var e = -1, r = n.length, s = r - 1;
                for(t = t === i ? r : t; ++e < t;){
                    var o = ei(e, s), f = n[o];
                    n[o] = n[e], n[e] = f;
                }
                return n.length = t, n;
            }
            var Fu = ph(function(n) {
                var t = [];
                return n.charCodeAt(0) === 46 && t.push(""), n.replace(so, function(e, r, s, o) {
                    t.push(s ? o.replace(po, "$1") : r || e);
                }), t;
            });
            function Wn(n) {
                if (typeof n == "string" || pn(n)) return n;
                var t = n + "";
                return t == "0" && 1 / n == -ht ? "-0" : t;
            }
            function wt(n) {
                if (n != null) {
                    try {
                        return be.call(n);
                    } catch  {}
                    try {
                        return n + "";
                    } catch  {}
                }
                return "";
            }
            function mh(n, t) {
                return mn(Ga, function(e) {
                    var r = "_." + e[0];
                    t & e[1] && !Ee(n, r) && n.push(r);
                }), n.sort();
            }
            function Mu(n) {
                if (n instanceof H) return n.clone();
                var t = new Pn(n.__wrapped__, n.__chain__);
                return t.__actions__ = un(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
            }
            function wh(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = Q(R(t), 0);
                var r = n == null ? 0 : n.length;
                if (!r || t < 1) return [];
                for(var s = 0, o = 0, f = d(Ue(r / t)); s < r;)f[o++] = Cn(n, s, s += t);
                return f;
            }
            function Ph(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = 0, s = []; ++t < e;){
                    var o = n[t];
                    o && (s[r++] = o);
                }
                return s;
            }
            function Ah() {
                var n = arguments.length;
                if (!n) return [];
                for(var t = d(n - 1), e = arguments[0], r = n; r--;)t[r - 1] = arguments[r];
                return nt(O(e) ? un(e) : [
                    e
                ], j(t, 1));
            }
            var Ch = L(function(n, t) {
                return Z(n) ? ue(n, j(t, 1, Z, !0)) : [];
            }), Ih = L(function(n, t) {
                var e = In(t);
                return Z(e) && (e = i), Z(n) ? ue(n, j(t, 1, Z, !0), x(e, 2)) : [];
            }), xh = L(function(n, t) {
                var e = In(t);
                return Z(e) && (e = i), Z(n) ? ue(n, j(t, 1, Z, !0), i, e) : [];
            });
            function Eh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function yh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function Sh(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !0, !0) : [];
            }
            function Oh(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !0) : [];
            }
            function Rh(n, t, e, r) {
                var s = n == null ? 0 : n.length;
                return s ? (e && typeof e != "number" && rn(n, t, e) && (e = 0, r = s), Ac(n, t, e, r)) : [];
            }
            function qu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), ye(n, x(t, 3), s);
            }
            function Bu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r - 1;
                return e !== i && (s = R(e), s = e < 0 ? Q(r + s, 0) : nn(s, r - 1)), ye(n, x(t, 3), s, !0);
            }
            function Gu(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, 1) : [];
            }
            function bh(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, ht) : [];
            }
            function Th(n, t) {
                var e = n == null ? 0 : n.length;
                return e ? (t = t === i ? 1 : R(t), j(n, t)) : [];
            }
            function Lh(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = {}; ++t < e;){
                    var s = n[t];
                    r[s[0]] = s[1];
                }
                return r;
            }
            function zu(n) {
                return n && n.length ? n[0] : i;
            }
            function Dh(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), Tt(n, t, s);
            }
            function Nh(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 0, -1) : [];
            }
            var Hh = L(function(n) {
                var t = G(n, ai);
                return t.length && t[0] === n[0] ? Vr(t) : [];
            }), $h = L(function(n) {
                var t = In(n), e = G(n, ai);
                return t === In(e) ? t = i : e.pop(), e.length && e[0] === n[0] ? Vr(e, x(t, 2)) : [];
            }), Uh = L(function(n) {
                var t = In(n), e = G(n, ai);
                return t = typeof t == "function" ? t : i, t && e.pop(), e.length && e[0] === n[0] ? Vr(e, i, t) : [];
            });
            function Wh(n, t) {
                return n == null ? "" : Nf.call(n, t);
            }
            function In(n) {
                var t = n == null ? 0 : n.length;
                return t ? n[t - 1] : i;
            }
            function Fh(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r;
                return e !== i && (s = R(e), s = s < 0 ? Q(r + s, 0) : nn(s, r - 1)), t === t ? mf(n, t, s) : ye(n, xs, s, !0);
            }
            function Mh(n, t) {
                return n && n.length ? tu(n, R(t)) : i;
            }
            var qh = L(Ku);
            function Ku(n, t) {
                return n && n.length && t && t.length ? ti(n, t) : n;
            }
            function Bh(n, t, e) {
                return n && n.length && t && t.length ? ti(n, t, x(e, 2)) : n;
            }
            function Gh(n, t, e) {
                return n && n.length && t && t.length ? ti(n, t, i, e) : n;
            }
            var zh = Yn(function(n, t) {
                var e = n == null ? 0 : n.length, r = Zr(n, t);
                return iu(n, G(t, function(s) {
                    return Zn(s, e) ? +s : s;
                }).sort(du)), r;
            });
            function Kh(n, t) {
                var e = [];
                if (!(n && n.length)) return e;
                var r = -1, s = [], o = n.length;
                for(t = x(t, 3); ++r < o;){
                    var f = n[r];
                    t(f, r, n) && (e.push(f), s.push(r));
                }
                return iu(n, s), e;
            }
            function Ai(n) {
                return n == null ? n : Wf.call(n);
            }
            function Yh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (e && typeof e != "number" && rn(n, t, e) ? (t = 0, e = r) : (t = t == null ? 0 : R(t), e = e === i ? r : R(e)), Cn(n, t, e)) : [];
            }
            function Zh(n, t) {
                return Ye(n, t);
            }
            function Jh(n, t, e) {
                return ii(n, t, x(e, 2));
            }
            function Xh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = Ye(n, t);
                    if (r < e && bn(n[r], t)) return r;
                }
                return -1;
            }
            function Qh(n, t) {
                return Ye(n, t, !0);
            }
            function Vh(n, t, e) {
                return ii(n, t, x(e, 2), !0);
            }
            function kh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = Ye(n, t, !0) - 1;
                    if (bn(n[r], t)) return r;
                }
                return -1;
            }
            function jh(n) {
                return n && n.length ? uu(n) : [];
            }
            function nl(n, t) {
                return n && n.length ? uu(n, x(t, 2)) : [];
            }
            function tl(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 1, t) : [];
            }
            function el(n, t, e) {
                return n && n.length ? (t = e || t === i ? 1 : R(t), Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function rl(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function il(n, t) {
                return n && n.length ? Ze(n, x(t, 3), !1, !0) : [];
            }
            function sl(n, t) {
                return n && n.length ? Ze(n, x(t, 3)) : [];
            }
            var ul = L(function(n) {
                return it(j(n, 1, Z, !0));
            }), al = L(function(n) {
                var t = In(n);
                return Z(t) && (t = i), it(j(n, 1, Z, !0), x(t, 2));
            }), ol = L(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, it(j(n, 1, Z, !0), i, t);
            });
            function fl(n) {
                return n && n.length ? it(n) : [];
            }
            function cl(n, t) {
                return n && n.length ? it(n, x(t, 2)) : [];
            }
            function hl(n, t) {
                return t = typeof t == "function" ? t : i, n && n.length ? it(n, i, t) : [];
            }
            function Ci(n) {
                if (!(n && n.length)) return [];
                var t = 0;
                return n = jn(n, function(e) {
                    if (Z(e)) return t = Q(e.length, t), !0;
                }), Fr(t, function(e) {
                    return G(n, $r(e));
                });
            }
            function Yu(n, t) {
                if (!(n && n.length)) return [];
                var e = Ci(n);
                return t == null ? e : G(e, function(r) {
                    return cn(t, i, r);
                });
            }
            var ll = L(function(n, t) {
                return Z(n) ? ue(n, t) : [];
            }), pl = L(function(n) {
                return ui(jn(n, Z));
            }), dl = L(function(n) {
                var t = In(n);
                return Z(t) && (t = i), ui(jn(n, Z), x(t, 2));
            }), gl = L(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, ui(jn(n, Z), i, t);
            }), vl = L(Ci);
            function _l(n, t) {
                return cu(n || [], t || [], se);
            }
            function ml(n, t) {
                return cu(n || [], t || [], fe);
            }
            var wl = L(function(n) {
                var t = n.length, e = t > 1 ? n[t - 1] : i;
                return e = typeof e == "function" ? (n.pop(), e) : i, Yu(n, e);
            });
            function Zu(n) {
                var t = a(n);
                return t.__chain__ = !0, t;
            }
            function Pl(n, t) {
                return t(n), n;
            }
            function er(n, t) {
                return t(n);
            }
            var Al = Yn(function(n) {
                var t = n.length, e = t ? n[0] : 0, r = this.__wrapped__, s = function(o) {
                    return Zr(o, n);
                };
                return t > 1 || this.__actions__.length || !(r instanceof H) || !Zn(e) ? this.thru(s) : (r = r.slice(e, +e + (t ? 1 : 0)), r.__actions__.push({
                    func: er,
                    args: [
                        s
                    ],
                    thisArg: i
                }), new Pn(r, this.__chain__).thru(function(o) {
                    return t && !o.length && o.push(i), o;
                }));
            });
            function Cl() {
                return Zu(this);
            }
            function Il() {
                return new Pn(this.value(), this.__chain__);
            }
            function xl() {
                this.__values__ === i && (this.__values__ = aa(this.value()));
                var n = this.__index__ >= this.__values__.length, t = n ? i : this.__values__[this.__index__++];
                return {
                    done: n,
                    value: t
                };
            }
            function El() {
                return this;
            }
            function yl(n) {
                for(var t, e = this; e instanceof qe;){
                    var r = Mu(e);
                    r.__index__ = 0, r.__values__ = i, t ? s.__wrapped__ = r : t = r;
                    var s = r;
                    e = e.__wrapped__;
                }
                return s.__wrapped__ = n, t;
            }
            function Sl() {
                var n = this.__wrapped__;
                if (n instanceof H) {
                    var t = n;
                    return this.__actions__.length && (t = new H(this)), t = t.reverse(), t.__actions__.push({
                        func: er,
                        args: [
                            Ai
                        ],
                        thisArg: i
                    }), new Pn(t, this.__chain__);
                }
                return this.thru(Ai);
            }
            function Ol() {
                return fu(this.__wrapped__, this.__actions__);
            }
            var Rl = Je(function(n, t, e) {
                F.call(n, e) ? ++n[e] : zn(n, e, 1);
            });
            function bl(n, t, e) {
                var r = O(n) ? Cs : Pc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            function Tl(n, t) {
                var e = O(n) ? jn : Ys;
                return e(n, x(t, 3));
            }
            var Ll = Pu(qu), Dl = Pu(Bu);
            function Nl(n, t) {
                return j(rr(n, t), 1);
            }
            function Hl(n, t) {
                return j(rr(n, t), ht);
            }
            function $l(n, t, e) {
                return e = e === i ? 1 : R(e), j(rr(n, t), e);
            }
            function Ju(n, t) {
                var e = O(n) ? mn : rt;
                return e(n, x(t, 3));
            }
            function Xu(n, t) {
                var e = O(n) ? nf : Ks;
                return e(n, x(t, 3));
            }
            var Ul = Je(function(n, t, e) {
                F.call(n, e) ? n[e].push(t) : zn(n, e, [
                    t
                ]);
            });
            function Wl(n, t, e, r) {
                n = an(n) ? n : Gt(n), e = e && !r ? R(e) : 0;
                var s = n.length;
                return e < 0 && (e = Q(s + e, 0)), or(n) ? e <= s && n.indexOf(t, e) > -1 : !!s && Tt(n, t, e) > -1;
            }
            var Fl = L(function(n, t, e) {
                var r = -1, s = typeof t == "function", o = an(n) ? d(n.length) : [];
                return rt(n, function(f) {
                    o[++r] = s ? cn(t, f, e) : ae(f, t, e);
                }), o;
            }), Ml = Je(function(n, t, e) {
                zn(n, e, t);
            });
            function rr(n, t) {
                var e = O(n) ? G : ks;
                return e(n, x(t, 3));
            }
            function ql(n, t, e, r) {
                return n == null ? [] : (O(t) || (t = t == null ? [] : [
                    t
                ]), e = r ? i : e, O(e) || (e = e == null ? [] : [
                    e
                ]), eu(n, t, e));
            }
            var Bl = Je(function(n, t, e) {
                n[e ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function Gl(n, t, e) {
                var r = O(n) ? Nr : ys, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, rt);
            }
            function zl(n, t, e) {
                var r = O(n) ? tf : ys, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, Ks);
            }
            function Kl(n, t) {
                var e = O(n) ? jn : Ys;
                return e(n, ur(x(t, 3)));
            }
            function Yl(n) {
                var t = O(n) ? qs : Wc;
                return t(n);
            }
            function Zl(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t);
                var r = O(n) ? gc : Fc;
                return r(n, t);
            }
            function Jl(n) {
                var t = O(n) ? vc : qc;
                return t(n);
            }
            function Xl(n) {
                if (n == null) return 0;
                if (an(n)) return or(n) ? Dt(n) : n.length;
                var t = tn(n);
                return t == yn || t == Sn ? n.size : jr(n).length;
            }
            function Ql(n, t, e) {
                var r = O(n) ? Hr : Bc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            var Vl = L(function(n, t) {
                if (n == null) return [];
                var e = t.length;
                return e > 1 && rn(n, t[0], t[1]) ? t = [] : e > 2 && rn(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), eu(n, j(t, 1), []);
            }), ir = Tf || function() {
                return k.Date.now();
            };
            function kl(n, t) {
                if (typeof t != "function") throw new wn(D);
                return n = R(n), function() {
                    if (--n < 1) return t.apply(this, arguments);
                };
            }
            function Qu(n, t, e) {
                return t = e ? i : t, t = n && t == null ? n.length : t, Kn(n, Mn, i, i, i, i, t);
            }
            function Vu(n, t) {
                var e;
                if (typeof t != "function") throw new wn(D);
                return n = R(n), function() {
                    return --n > 0 && (e = t.apply(this, arguments)), n <= 1 && (t = i), e;
                };
            }
            var Ii = L(function(n, t, e) {
                var r = vn;
                if (e.length) {
                    var s = tt(e, qt(Ii));
                    r |= Nn;
                }
                return Kn(n, r, t, e, s);
            }), ku = L(function(n, t, e) {
                var r = vn | ct;
                if (e.length) {
                    var s = tt(e, qt(ku));
                    r |= Nn;
                }
                return Kn(t, r, n, e, s);
            });
            function ju(n, t, e) {
                t = e ? i : t;
                var r = Kn(n, Dn, i, i, i, i, i, t);
                return r.placeholder = ju.placeholder, r;
            }
            function na(n, t, e) {
                t = e ? i : t;
                var r = Kn(n, yt, i, i, i, i, i, t);
                return r.placeholder = na.placeholder, r;
            }
            function ta(n, t, e) {
                var r, s, o, f, c, l, v = 0, _ = !1, m = !1, P = !0;
                if (typeof n != "function") throw new wn(D);
                t = xn(t) || 0, K(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xn(e.maxWait) || 0, t) : o, P = "trailing" in e ? !!e.trailing : P);
                function I(J) {
                    var Tn = r, Qn = s;
                    return r = s = i, v = J, f = n.apply(Qn, Tn), f;
                }
                function E(J) {
                    return v = J, c = le(N, t), _ ? I(J) : f;
                }
                function T(J) {
                    var Tn = J - l, Qn = J - v, Pa = t - Tn;
                    return m ? nn(Pa, o - Qn) : Pa;
                }
                function y(J) {
                    var Tn = J - l, Qn = J - v;
                    return l === i || Tn >= t || Tn < 0 || m && Qn >= o;
                }
                function N() {
                    var J = ir();
                    if (y(J)) return $(J);
                    c = le(N, T(J));
                }
                function $(J) {
                    return c = i, P && r ? I(J) : (r = s = i, f);
                }
                function dn() {
                    c !== i && hu(c), v = 0, r = l = s = c = i;
                }
                function sn() {
                    return c === i ? f : $(ir());
                }
                function gn() {
                    var J = ir(), Tn = y(J);
                    if (r = arguments, s = this, l = J, Tn) {
                        if (c === i) return E(l);
                        if (m) return hu(c), c = le(N, t), I(l);
                    }
                    return c === i && (c = le(N, t)), f;
                }
                return gn.cancel = dn, gn.flush = sn, gn;
            }
            var jl = L(function(n, t) {
                return zs(n, 1, t);
            }), np = L(function(n, t, e) {
                return zs(n, xn(t) || 0, e);
            });
            function tp(n) {
                return Kn(n, dr);
            }
            function sr(n, t) {
                if (typeof n != "function" || t != null && typeof t != "function") throw new wn(D);
                var e = function() {
                    var r = arguments, s = t ? t.apply(this, r) : r[0], o = e.cache;
                    if (o.has(s)) return o.get(s);
                    var f = n.apply(this, r);
                    return e.cache = o.set(s, f) || o, f;
                };
                return e.cache = new (sr.Cache || Gn), e;
            }
            sr.Cache = Gn;
            function ur(n) {
                if (typeof n != "function") throw new wn(D);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !n.call(this);
                        case 1:
                            return !n.call(this, t[0]);
                        case 2:
                            return !n.call(this, t[0], t[1]);
                        case 3:
                            return !n.call(this, t[0], t[1], t[2]);
                    }
                    return !n.apply(this, t);
                };
            }
            function ep(n) {
                return Vu(2, n);
            }
            var rp = Gc(function(n, t) {
                t = t.length == 1 && O(t[0]) ? G(t[0], hn(x())) : G(j(t, 1), hn(x()));
                var e = t.length;
                return L(function(r) {
                    for(var s = -1, o = nn(r.length, e); ++s < o;)r[s] = t[s].call(this, r[s]);
                    return cn(n, this, r);
                });
            }), xi = L(function(n, t) {
                var e = tt(t, qt(xi));
                return Kn(n, Nn, i, t, e);
            }), ea = L(function(n, t) {
                var e = tt(t, qt(ea));
                return Kn(n, St, i, t, e);
            }), ip = Yn(function(n, t) {
                return Kn(n, Kt, i, i, i, t);
            });
            function sp(n, t) {
                if (typeof n != "function") throw new wn(D);
                return t = t === i ? t : R(t), L(n, t);
            }
            function up(n, t) {
                if (typeof n != "function") throw new wn(D);
                return t = t == null ? 0 : Q(R(t), 0), L(function(e) {
                    var r = e[t], s = ut(e, 0, t);
                    return r && nt(s, r), cn(n, this, s);
                });
            }
            function ap(n, t, e) {
                var r = !0, s = !0;
                if (typeof n != "function") throw new wn(D);
                return K(e) && (r = "leading" in e ? !!e.leading : r, s = "trailing" in e ? !!e.trailing : s), ta(n, t, {
                    leading: r,
                    maxWait: t,
                    trailing: s
                });
            }
            function op(n) {
                return Qu(n, 1);
            }
            function fp(n, t) {
                return xi(oi(t), n);
            }
            function cp() {
                if (!arguments.length) return [];
                var n = arguments[0];
                return O(n) ? n : [
                    n
                ];
            }
            function hp(n) {
                return An(n, xt);
            }
            function lp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, xt, t);
            }
            function pp(n) {
                return An(n, Ln | xt);
            }
            function dp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ln | xt, t);
            }
            function gp(n, t) {
                return t == null || Gs(n, t, V(t));
            }
            function bn(n, t) {
                return n === t || n !== n && t !== t;
            }
            var vp = ke(Qr), _p = ke(function(n, t) {
                return n >= t;
            }), Pt = Xs(function() {
                return arguments;
            }()) ? Xs : function(n) {
                return Y(n) && F.call(n, "callee") && !Hs.call(n, "callee");
            }, O = d.isArray, mp = vs ? hn(vs) : yc;
            function an(n) {
                return n != null && ar(n.length) && !Jn(n);
            }
            function Z(n) {
                return Y(n) && an(n);
            }
            function wp(n) {
                return n === !0 || n === !1 || Y(n) && en(n) == Yt;
            }
            var at = Df || Hi, Pp = _s ? hn(_s) : Sc;
            function Ap(n) {
                return Y(n) && n.nodeType === 1 && !pe(n);
            }
            function Cp(n) {
                if (n == null) return !0;
                if (an(n) && (O(n) || typeof n == "string" || typeof n.splice == "function" || at(n) || Bt(n) || Pt(n))) return !n.length;
                var t = tn(n);
                if (t == yn || t == Sn) return !n.size;
                if (he(n)) return !jr(n).length;
                for(var e in n)if (F.call(n, e)) return !1;
                return !0;
            }
            function Ip(n, t) {
                return oe(n, t);
            }
            function xp(n, t, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(n, t) : i;
                return r === i ? oe(n, t, i, e) : !!r;
            }
            function Ei(n) {
                if (!Y(n)) return !1;
                var t = en(n);
                return t == we || t == Ka || typeof n.message == "string" && typeof n.name == "string" && !pe(n);
            }
            function Ep(n) {
                return typeof n == "number" && Us(n);
            }
            function Jn(n) {
                if (!K(n)) return !1;
                var t = en(n);
                return t == Pe || t == zi || t == za || t == Za;
            }
            function ra(n) {
                return typeof n == "number" && n == R(n);
            }
            function ar(n) {
                return typeof n == "number" && n > -1 && n % 1 == 0 && n <= kn;
            }
            function K(n) {
                var t = typeof n;
                return n != null && (t == "object" || t == "function");
            }
            function Y(n) {
                return n != null && typeof n == "object";
            }
            var ia = ms ? hn(ms) : Rc;
            function yp(n, t) {
                return n === t || kr(n, t, gi(t));
            }
            function Sp(n, t, e) {
                return e = typeof e == "function" ? e : i, kr(n, t, gi(t), e);
            }
            function Op(n) {
                return sa(n) && n != +n;
            }
            function Rp(n) {
                if (lh(n)) throw new S(b);
                return Qs(n);
            }
            function bp(n) {
                return n === null;
            }
            function Tp(n) {
                return n == null;
            }
            function sa(n) {
                return typeof n == "number" || Y(n) && en(n) == Jt;
            }
            function pe(n) {
                if (!Y(n) || en(n) != qn) return !1;
                var t = Ne(n);
                if (t === null) return !0;
                var e = F.call(t, "constructor") && t.constructor;
                return typeof e == "function" && e instanceof e && be.call(e) == Sf;
            }
            var yi = ws ? hn(ws) : bc;
            function Lp(n) {
                return ra(n) && n >= -kn && n <= kn;
            }
            var ua = Ps ? hn(Ps) : Tc;
            function or(n) {
                return typeof n == "string" || !O(n) && Y(n) && en(n) == Qt;
            }
            function pn(n) {
                return typeof n == "symbol" || Y(n) && en(n) == Ae;
            }
            var Bt = As ? hn(As) : Lc;
            function Dp(n) {
                return n === i;
            }
            function Np(n) {
                return Y(n) && tn(n) == Vt;
            }
            function Hp(n) {
                return Y(n) && en(n) == Xa;
            }
            var $p = ke(ni), Up = ke(function(n, t) {
                return n <= t;
            });
            function aa(n) {
                if (!n) return [];
                if (an(n)) return or(n) ? On(n) : un(n);
                if (ne && n[ne]) return gf(n[ne]());
                var t = tn(n), e = t == yn ? qr : t == Sn ? Se : Gt;
                return e(n);
            }
            function Xn(n) {
                if (!n) return n === 0 ? n : 0;
                if (n = xn(n), n === ht || n === -ht) {
                    var t = n < 0 ? -1 : 1;
                    return t * Ma;
                }
                return n === n ? n : 0;
            }
            function R(n) {
                var t = Xn(n), e = t % 1;
                return t === t ? e ? t - e : t : 0;
            }
            function oa(n) {
                return n ? vt(R(n), 0, Hn) : 0;
            }
            function xn(n) {
                if (typeof n == "number") return n;
                if (pn(n)) return _e;
                if (K(n)) {
                    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
                    n = K(t) ? t + "" : t;
                }
                if (typeof n != "string") return n === 0 ? n : +n;
                n = Ss(n);
                var e = _o.test(n);
                return e || wo.test(n) ? Vo(n.slice(2), e ? 2 : 8) : vo.test(n) ? _e : +n;
            }
            function fa(n) {
                return Un(n, on(n));
            }
            function Wp(n) {
                return n ? vt(R(n), -kn, kn) : n === 0 ? n : 0;
            }
            function W(n) {
                return n == null ? "" : ln(n);
            }
            var Fp = Ft(function(n, t) {
                if (he(t) || an(t)) {
                    Un(t, V(t), n);
                    return;
                }
                for(var e in t)F.call(t, e) && se(n, e, t[e]);
            }), ca = Ft(function(n, t) {
                Un(t, on(t), n);
            }), fr = Ft(function(n, t, e, r) {
                Un(t, on(t), n, r);
            }), Mp = Ft(function(n, t, e, r) {
                Un(t, V(t), n, r);
            }), qp = Yn(Zr);
            function Bp(n, t) {
                var e = Wt(n);
                return t == null ? e : Bs(e, t);
            }
            var Gp = L(function(n, t) {
                n = M(n);
                var e = -1, r = t.length, s = r > 2 ? t[2] : i;
                for(s && rn(t[0], t[1], s) && (r = 1); ++e < r;)for(var o = t[e], f = on(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = n[v];
                    (_ === i || bn(_, Ht[v]) && !F.call(n, v)) && (n[v] = o[v]);
                }
                return n;
            }), zp = L(function(n) {
                return n.push(i, Su), cn(ha, i, n);
            });
            function Kp(n, t) {
                return Is(n, x(t, 3), $n);
            }
            function Yp(n, t) {
                return Is(n, x(t, 3), Xr);
            }
            function Zp(n, t) {
                return n == null ? n : Jr(n, x(t, 3), on);
            }
            function Jp(n, t) {
                return n == null ? n : Zs(n, x(t, 3), on);
            }
            function Xp(n, t) {
                return n && $n(n, x(t, 3));
            }
            function Qp(n, t) {
                return n && Xr(n, x(t, 3));
            }
            function Vp(n) {
                return n == null ? [] : ze(n, V(n));
            }
            function kp(n) {
                return n == null ? [] : ze(n, on(n));
            }
            function Si(n, t, e) {
                var r = n == null ? i : _t(n, t);
                return r === i ? e : r;
            }
            function jp(n, t) {
                return n != null && bu(n, t, Cc);
            }
            function Oi(n, t) {
                return n != null && bu(n, t, Ic);
            }
            var nd = Cu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Te.call(t)), n[t] = e;
            }, bi(fn)), td = Cu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Te.call(t)), F.call(n, t) ? n[t].push(e) : n[t] = [
                    e
                ];
            }, x), ed = L(ae);
            function V(n) {
                return an(n) ? Ms(n) : jr(n);
            }
            function on(n) {
                return an(n) ? Ms(n, !0) : Dc(n);
            }
            function rd(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    zn(e, t(r, s, o), r);
                }), e;
            }
            function id(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    zn(e, s, t(r, s, o));
                }), e;
            }
            var sd = Ft(function(n, t, e) {
                Ke(n, t, e);
            }), ha = Ft(function(n, t, e, r) {
                Ke(n, t, e, r);
            }), ud = Yn(function(n, t) {
                var e = {};
                if (n == null) return e;
                var r = !1;
                t = G(t, function(o) {
                    return o = st(o, n), r || (r = o.length > 1), o;
                }), Un(n, pi(n), e), r && (e = An(e, Ln | Fn | xt, nh));
                for(var s = t.length; s--;)si(e, t[s]);
                return e;
            });
            function ad(n, t) {
                return la(n, ur(x(t)));
            }
            var od = Yn(function(n, t) {
                return n == null ? {} : Hc(n, t);
            });
            function la(n, t) {
                if (n == null) return {};
                var e = G(pi(n), function(r) {
                    return [
                        r
                    ];
                });
                return t = x(t), ru(n, e, function(r, s) {
                    return t(r, s[0]);
                });
            }
            function fd(n, t, e) {
                t = st(t, n);
                var r = -1, s = t.length;
                for(s || (s = 1, n = i); ++r < s;){
                    var o = n == null ? i : n[Wn(t[r])];
                    o === i && (r = s, o = e), n = Jn(o) ? o.call(n) : o;
                }
                return n;
            }
            function cd(n, t, e) {
                return n == null ? n : fe(n, t, e);
            }
            function hd(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : fe(n, t, e, r);
            }
            var pa = Eu(V), da = Eu(on);
            function ld(n, t, e) {
                var r = O(n), s = r || at(n) || Bt(n);
                if (t = x(t, 4), e == null) {
                    var o = n && n.constructor;
                    s ? e = r ? new o : [] : K(n) ? e = Jn(o) ? Wt(Ne(n)) : {} : e = {};
                }
                return (s ? mn : $n)(n, function(f, c, l) {
                    return t(e, f, c, l);
                }), e;
            }
            function pd(n, t) {
                return n == null ? !0 : si(n, t);
            }
            function dd(n, t, e) {
                return n == null ? n : ou(n, t, oi(e));
            }
            function gd(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : ou(n, t, oi(e), r);
            }
            function Gt(n) {
                return n == null ? [] : Mr(n, V(n));
            }
            function vd(n) {
                return n == null ? [] : Mr(n, on(n));
            }
            function _d(n, t, e) {
                return e === i && (e = t, t = i), e !== i && (e = xn(e), e = e === e ? e : 0), t !== i && (t = xn(t), t = t === t ? t : 0), vt(xn(n), t, e);
            }
            function md(n, t, e) {
                return t = Xn(t), e === i ? (e = t, t = 0) : e = Xn(e), n = xn(n), xc(n, t, e);
            }
            function wd(n, t, e) {
                if (e && typeof e != "boolean" && rn(n, t, e) && (t = e = i), e === i && (typeof t == "boolean" ? (e = t, t = i) : typeof n == "boolean" && (e = n, n = i)), n === i && t === i ? (n = 0, t = 1) : (n = Xn(n), t === i ? (t = n, n = 0) : t = Xn(t)), n > t) {
                    var r = n;
                    n = t, t = r;
                }
                if (e || n % 1 || t % 1) {
                    var s = Ws();
                    return nn(n + s * (t - n + Qo("1e-" + ((s + "").length - 1))), t);
                }
                return ei(n, t);
            }
            var Pd = Mt(function(n, t, e) {
                return t = t.toLowerCase(), n + (e ? ga(t) : t);
            });
            function ga(n) {
                return Ri(W(n).toLowerCase());
            }
            function va(n) {
                return n = W(n), n && n.replace(Ao, cf).replace(Mo, "");
            }
            function Ad(n, t, e) {
                n = W(n), t = ln(t);
                var r = n.length;
                e = e === i ? r : vt(R(e), 0, r);
                var s = e;
                return e -= t.length, e >= 0 && n.slice(e, s) == t;
            }
            function Cd(n) {
                return n = W(n), n && no.test(n) ? n.replace(Zi, hf) : n;
            }
            function Id(n) {
                return n = W(n), n && uo.test(n) ? n.replace(xr, "\\$&") : n;
            }
            var xd = Mt(function(n, t, e) {
                return n + (e ? "-" : "") + t.toLowerCase();
            }), Ed = Mt(function(n, t, e) {
                return n + (e ? " " : "") + t.toLowerCase();
            }), yd = wu("toLowerCase");
            function Sd(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Dt(n) : 0;
                if (!t || r >= t) return n;
                var s = (t - r) / 2;
                return Ve(We(s), e) + n + Ve(Ue(s), e);
            }
            function Od(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Dt(n) : 0;
                return t && r < t ? n + Ve(t - r, e) : n;
            }
            function Rd(n, t, e) {
                n = W(n), t = R(t);
                var r = t ? Dt(n) : 0;
                return t && r < t ? Ve(t - r, e) + n : n;
            }
            function bd(n, t, e) {
                return e || t == null ? t = 0 : t && (t = +t), Uf(W(n).replace(Er, ""), t || 0);
            }
            function Td(n, t, e) {
                return (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t), ri(W(n), t);
            }
            function Ld() {
                var n = arguments, t = W(n[0]);
                return n.length < 3 ? t : t.replace(n[1], n[2]);
            }
            var Dd = Mt(function(n, t, e) {
                return n + (e ? "_" : "") + t.toLowerCase();
            });
            function Nd(n, t, e) {
                return e && typeof e != "number" && rn(n, t, e) && (t = e = i), e = e === i ? Hn : e >>> 0, e ? (n = W(n), n && (typeof t == "string" || t != null && !yi(t)) && (t = ln(t), !t && Lt(n)) ? ut(On(n), 0, e) : n.split(t, e)) : [];
            }
            var Hd = Mt(function(n, t, e) {
                return n + (e ? " " : "") + Ri(t);
            });
            function $d(n, t, e) {
                return n = W(n), e = e == null ? 0 : vt(R(e), 0, n.length), t = ln(t), n.slice(e, e + t.length) == t;
            }
            function Ud(n, t, e) {
                var r = a.templateSettings;
                e && rn(n, t, e) && (t = i), n = W(n), t = fr({}, t, r, yu);
                var s = fr({}, t.imports, r.imports, yu), o = V(s), f = Mr(s, o), c, l, v = 0, _ = t.interpolate || Ce, m = "__p += '", P = Br((t.escape || Ce).source + "|" + _.source + "|" + (_ === Ji ? go : Ce).source + "|" + (t.evaluate || Ce).source + "|$", "g"), I = "//# sourceURL=" + (F.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ko + "]") + `
`;
                n.replace(P, function(y, N, $, dn, sn, gn) {
                    return $ || ($ = dn), m += n.slice(v, gn).replace(Co, lf), N && (c = !0, m += `' +
__e(` + N + `) +
'`), sn && (l = !0, m += `';
` + sn + `;
__p += '`), $ && (m += `' +
((__t = (` + $ + `)) == null ? '' : __t) +
'`), v = gn + y.length, y;
                }), m += `';
`;
                var E = F.call(t, "variable") && t.variable;
                if (!E) m = `with (obj) {
` + m + `
}
`;
                else if (lo.test(E)) throw new S(En);
                m = (l ? m.replace(Qa, "") : m).replace(Va, "$1").replace(ka, "$1;"), m = "function(" + (E || "obj") + `) {
` + (E ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + m + `return __p
}`;
                var T = ma(function() {
                    return U(o, I + "return " + m).apply(i, f);
                });
                if (T.source = m, Ei(T)) throw T;
                return T;
            }
            function Wd(n) {
                return W(n).toLowerCase();
            }
            function Fd(n) {
                return W(n).toUpperCase();
            }
            function Md(n, t, e) {
                if (n = W(n), n && (e || t === i)) return Ss(n);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = On(t), o = Os(r, s), f = Rs(r, s) + 1;
                return ut(r, o, f).join("");
            }
            function qd(n, t, e) {
                if (n = W(n), n && (e || t === i)) return n.slice(0, Ts(n) + 1);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Rs(r, On(t)) + 1;
                return ut(r, 0, s).join("");
            }
            function Bd(n, t, e) {
                if (n = W(n), n && (e || t === i)) return n.replace(Er, "");
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Os(r, On(t));
                return ut(r, s).join("");
            }
            function Gd(n, t) {
                var e = Na, r = Ha;
                if (K(t)) {
                    var s = "separator" in t ? t.separator : s;
                    e = "length" in t ? R(t.length) : e, r = "omission" in t ? ln(t.omission) : r;
                }
                n = W(n);
                var o = n.length;
                if (Lt(n)) {
                    var f = On(n);
                    o = f.length;
                }
                if (e >= o) return n;
                var c = e - Dt(r);
                if (c < 1) return r;
                var l = f ? ut(f, 0, c).join("") : n.slice(0, c);
                if (s === i) return l + r;
                if (f && (c += l.length - c), yi(s)) {
                    if (n.slice(c).search(s)) {
                        var v, _ = l;
                        for(s.global || (s = Br(s.source, W(Xi.exec(s)) + "g")), s.lastIndex = 0; v = s.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (n.indexOf(ln(s), c) != c) {
                    var P = l.lastIndexOf(s);
                    P > -1 && (l = l.slice(0, P));
                }
                return l + r;
            }
            function zd(n) {
                return n = W(n), n && ja.test(n) ? n.replace(Yi, wf) : n;
            }
            var Kd = Mt(function(n, t, e) {
                return n + (e ? " " : "") + t.toUpperCase();
            }), Ri = wu("toUpperCase");
            function _a(n, t, e) {
                return n = W(n), t = e ? i : t, t === i ? df(n) ? Cf(n) : sf(n) : n.match(t) || [];
            }
            var ma = L(function(n, t) {
                try {
                    return cn(n, i, t);
                } catch (e) {
                    return Ei(e) ? e : new S(e);
                }
            }), Yd = Yn(function(n, t) {
                return mn(t, function(e) {
                    e = Wn(e), zn(n, e, Ii(n[e], n));
                }), n;
            });
            function Zd(n) {
                var t = n == null ? 0 : n.length, e = x();
                return n = t ? G(n, function(r) {
                    if (typeof r[1] != "function") throw new wn(D);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], L(function(r) {
                    for(var s = -1; ++s < t;){
                        var o = n[s];
                        if (cn(o[0], this, r)) return cn(o[1], this, r);
                    }
                });
            }
            function Jd(n) {
                return wc(An(n, Ln));
            }
            function bi(n) {
                return function() {
                    return n;
                };
            }
            function Xd(n, t) {
                return n == null || n !== n ? t : n;
            }
            var Qd = Au(), Vd = Au(!0);
            function fn(n) {
                return n;
            }
            function Ti(n) {
                return Vs(typeof n == "function" ? n : An(n, Ln));
            }
            function kd(n) {
                return js(An(n, Ln));
            }
            function jd(n, t) {
                return nu(n, An(t, Ln));
            }
            var ng = L(function(n, t) {
                return function(e) {
                    return ae(e, n, t);
                };
            }), tg = L(function(n, t) {
                return function(e) {
                    return ae(n, e, t);
                };
            });
            function Li(n, t, e) {
                var r = V(t), s = ze(t, r);
                e == null && !(K(t) && (s.length || !r.length)) && (e = t, t = n, n = this, s = ze(t, V(t)));
                var o = !(K(e) && "chain" in e) || !!e.chain, f = Jn(n);
                return mn(s, function(c) {
                    var l = t[c];
                    n[c] = l, f && (n.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = n(this.__wrapped__), m = _.__actions__ = un(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: n
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(n, nt([
                            this.value()
                        ], arguments));
                    });
                }), n;
            }
            function eg() {
                return k._ === this && (k._ = Of), this;
            }
            function Di() {}
            function rg(n) {
                return n = R(n), L(function(t) {
                    return tu(t, n);
                });
            }
            var ig = ci(G), sg = ci(Cs), ug = ci(Hr);
            function wa(n) {
                return _i(n) ? $r(Wn(n)) : $c(n);
            }
            function ag(n) {
                return function(t) {
                    return n == null ? i : _t(n, t);
                };
            }
            var og = Iu(), fg = Iu(!0);
            function Ni() {
                return [];
            }
            function Hi() {
                return !1;
            }
            function cg() {
                return {};
            }
            function hg() {
                return "";
            }
            function lg() {
                return !0;
            }
            function pg(n, t) {
                if (n = R(n), n < 1 || n > kn) return [];
                var e = Hn, r = nn(n, Hn);
                t = x(t), n -= Hn;
                for(var s = Fr(r, t); ++e < n;)t(e);
                return s;
            }
            function dg(n) {
                return O(n) ? G(n, Wn) : pn(n) ? [
                    n
                ] : un(Fu(W(n)));
            }
            function gg(n) {
                var t = ++yf;
                return W(n) + t;
            }
            var vg = Qe(function(n, t) {
                return n + t;
            }, 0), _g = hi("ceil"), mg = Qe(function(n, t) {
                return n / t;
            }, 1), wg = hi("floor");
            function Pg(n) {
                return n && n.length ? Ge(n, fn, Qr) : i;
            }
            function Ag(n, t) {
                return n && n.length ? Ge(n, x(t, 2), Qr) : i;
            }
            function Cg(n) {
                return Es(n, fn);
            }
            function Ig(n, t) {
                return Es(n, x(t, 2));
            }
            function xg(n) {
                return n && n.length ? Ge(n, fn, ni) : i;
            }
            function Eg(n, t) {
                return n && n.length ? Ge(n, x(t, 2), ni) : i;
            }
            var yg = Qe(function(n, t) {
                return n * t;
            }, 1), Sg = hi("round"), Og = Qe(function(n, t) {
                return n - t;
            }, 0);
            function Rg(n) {
                return n && n.length ? Wr(n, fn) : 0;
            }
            function bg(n, t) {
                return n && n.length ? Wr(n, x(t, 2)) : 0;
            }
            return a.after = kl, a.ary = Qu, a.assign = Fp, a.assignIn = ca, a.assignInWith = fr, a.assignWith = Mp, a.at = qp, a.before = Vu, a.bind = Ii, a.bindAll = Yd, a.bindKey = ku, a.castArray = cp, a.chain = Zu, a.chunk = wh, a.compact = Ph, a.concat = Ah, a.cond = Zd, a.conforms = Jd, a.constant = bi, a.countBy = Rl, a.create = Bp, a.curry = ju, a.curryRight = na, a.debounce = ta, a.defaults = Gp, a.defaultsDeep = zp, a.defer = jl, a.delay = np, a.difference = Ch, a.differenceBy = Ih, a.differenceWith = xh, a.drop = Eh, a.dropRight = yh, a.dropRightWhile = Sh, a.dropWhile = Oh, a.fill = Rh, a.filter = Tl, a.flatMap = Nl, a.flatMapDeep = Hl, a.flatMapDepth = $l, a.flatten = Gu, a.flattenDeep = bh, a.flattenDepth = Th, a.flip = tp, a.flow = Qd, a.flowRight = Vd, a.fromPairs = Lh, a.functions = Vp, a.functionsIn = kp, a.groupBy = Ul, a.initial = Nh, a.intersection = Hh, a.intersectionBy = $h, a.intersectionWith = Uh, a.invert = nd, a.invertBy = td, a.invokeMap = Fl, a.iteratee = Ti, a.keyBy = Ml, a.keys = V, a.keysIn = on, a.map = rr, a.mapKeys = rd, a.mapValues = id, a.matches = kd, a.matchesProperty = jd, a.memoize = sr, a.merge = sd, a.mergeWith = ha, a.method = ng, a.methodOf = tg, a.mixin = Li, a.negate = ur, a.nthArg = rg, a.omit = ud, a.omitBy = ad, a.once = ep, a.orderBy = ql, a.over = ig, a.overArgs = rp, a.overEvery = sg, a.overSome = ug, a.partial = xi, a.partialRight = ea, a.partition = Bl, a.pick = od, a.pickBy = la, a.property = wa, a.propertyOf = ag, a.pull = qh, a.pullAll = Ku, a.pullAllBy = Bh, a.pullAllWith = Gh, a.pullAt = zh, a.range = og, a.rangeRight = fg, a.rearg = ip, a.reject = Kl, a.remove = Kh, a.rest = sp, a.reverse = Ai, a.sampleSize = Zl, a.set = cd, a.setWith = hd, a.shuffle = Jl, a.slice = Yh, a.sortBy = Vl, a.sortedUniq = jh, a.sortedUniqBy = nl, a.split = Nd, a.spread = up, a.tail = tl, a.take = el, a.takeRight = rl, a.takeRightWhile = il, a.takeWhile = sl, a.tap = Pl, a.throttle = ap, a.thru = er, a.toArray = aa, a.toPairs = pa, a.toPairsIn = da, a.toPath = dg, a.toPlainObject = fa, a.transform = ld, a.unary = op, a.union = ul, a.unionBy = al, a.unionWith = ol, a.uniq = fl, a.uniqBy = cl, a.uniqWith = hl, a.unset = pd, a.unzip = Ci, a.unzipWith = Yu, a.update = dd, a.updateWith = gd, a.values = Gt, a.valuesIn = vd, a.without = ll, a.words = _a, a.wrap = fp, a.xor = pl, a.xorBy = dl, a.xorWith = gl, a.zip = vl, a.zipObject = _l, a.zipObjectDeep = ml, a.zipWith = wl, a.entries = pa, a.entriesIn = da, a.extend = ca, a.extendWith = fr, Li(a, a), a.add = vg, a.attempt = ma, a.camelCase = Pd, a.capitalize = ga, a.ceil = _g, a.clamp = _d, a.clone = hp, a.cloneDeep = pp, a.cloneDeepWith = dp, a.cloneWith = lp, a.conformsTo = gp, a.deburr = va, a.defaultTo = Xd, a.divide = mg, a.endsWith = Ad, a.eq = bn, a.escape = Cd, a.escapeRegExp = Id, a.every = bl, a.find = Ll, a.findIndex = qu, a.findKey = Kp, a.findLast = Dl, a.findLastIndex = Bu, a.findLastKey = Yp, a.floor = wg, a.forEach = Ju, a.forEachRight = Xu, a.forIn = Zp, a.forInRight = Jp, a.forOwn = Xp, a.forOwnRight = Qp, a.get = Si, a.gt = vp, a.gte = _p, a.has = jp, a.hasIn = Oi, a.head = zu, a.identity = fn, a.includes = Wl, a.indexOf = Dh, a.inRange = md, a.invoke = ed, a.isArguments = Pt, a.isArray = O, a.isArrayBuffer = mp, a.isArrayLike = an, a.isArrayLikeObject = Z, a.isBoolean = wp, a.isBuffer = at, a.isDate = Pp, a.isElement = Ap, a.isEmpty = Cp, a.isEqual = Ip, a.isEqualWith = xp, a.isError = Ei, a.isFinite = Ep, a.isFunction = Jn, a.isInteger = ra, a.isLength = ar, a.isMap = ia, a.isMatch = yp, a.isMatchWith = Sp, a.isNaN = Op, a.isNative = Rp, a.isNil = Tp, a.isNull = bp, a.isNumber = sa, a.isObject = K, a.isObjectLike = Y, a.isPlainObject = pe, a.isRegExp = yi, a.isSafeInteger = Lp, a.isSet = ua, a.isString = or, a.isSymbol = pn, a.isTypedArray = Bt, a.isUndefined = Dp, a.isWeakMap = Np, a.isWeakSet = Hp, a.join = Wh, a.kebabCase = xd, a.last = In, a.lastIndexOf = Fh, a.lowerCase = Ed, a.lowerFirst = yd, a.lt = $p, a.lte = Up, a.max = Pg, a.maxBy = Ag, a.mean = Cg, a.meanBy = Ig, a.min = xg, a.minBy = Eg, a.stubArray = Ni, a.stubFalse = Hi, a.stubObject = cg, a.stubString = hg, a.stubTrue = lg, a.multiply = yg, a.nth = Mh, a.noConflict = eg, a.noop = Di, a.now = ir, a.pad = Sd, a.padEnd = Od, a.padStart = Rd, a.parseInt = bd, a.random = wd, a.reduce = Gl, a.reduceRight = zl, a.repeat = Td, a.replace = Ld, a.result = fd, a.round = Sg, a.runInContext = h, a.sample = Yl, a.size = Xl, a.snakeCase = Dd, a.some = Ql, a.sortedIndex = Zh, a.sortedIndexBy = Jh, a.sortedIndexOf = Xh, a.sortedLastIndex = Qh, a.sortedLastIndexBy = Vh, a.sortedLastIndexOf = kh, a.startCase = Hd, a.startsWith = $d, a.subtract = Og, a.sum = Rg, a.sumBy = bg, a.template = Ud, a.times = pg, a.toFinite = Xn, a.toInteger = R, a.toLength = oa, a.toLower = Wd, a.toNumber = xn, a.toSafeInteger = Wp, a.toString = W, a.toUpper = Fd, a.trim = Md, a.trimEnd = qd, a.trimStart = Bd, a.truncate = Gd, a.unescape = zd, a.uniqueId = gg, a.upperCase = Kd, a.upperFirst = Ri, a.each = Ju, a.eachRight = Xu, a.first = zu, Li(a, function() {
                var n = {};
                return $n(a, function(t, e) {
                    F.call(a.prototype, e) || (n[e] = t);
                }), n;
            }(), {
                chain: !1
            }), a.VERSION = p, mn([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(n) {
                a[n].placeholder = a;
            }), mn([
                "drop",
                "take"
            ], function(n, t) {
                H.prototype[n] = function(e) {
                    e = e === i ? 1 : Q(R(e), 0);
                    var r = this.__filtered__ && !t ? new H(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nn(e, r.__takeCount__) : r.__views__.push({
                        size: nn(e, Hn),
                        type: n + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, H.prototype[n + "Right"] = function(e) {
                    return this.reverse()[n](e).reverse();
                };
            }), mn([
                "filter",
                "map",
                "takeWhile"
            ], function(n, t) {
                var e = t + 1, r = e == Gi || e == Fa;
                H.prototype[n] = function(s) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: x(s, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mn([
                "head",
                "last"
            ], function(n, t) {
                var e = "take" + (t ? "Right" : "");
                H.prototype[n] = function() {
                    return this[e](1).value()[0];
                };
            }), mn([
                "initial",
                "tail"
            ], function(n, t) {
                var e = "drop" + (t ? "" : "Right");
                H.prototype[n] = function() {
                    return this.__filtered__ ? new H(this) : this[e](1);
                };
            }), H.prototype.compact = function() {
                return this.filter(fn);
            }, H.prototype.find = function(n) {
                return this.filter(n).head();
            }, H.prototype.findLast = function(n) {
                return this.reverse().find(n);
            }, H.prototype.invokeMap = L(function(n, t) {
                return typeof n == "function" ? new H(this) : this.map(function(e) {
                    return ae(e, n, t);
                });
            }), H.prototype.reject = function(n) {
                return this.filter(ur(x(n)));
            }, H.prototype.slice = function(n, t) {
                n = R(n);
                var e = this;
                return e.__filtered__ && (n > 0 || t < 0) ? new H(e) : (n < 0 ? e = e.takeRight(-n) : n && (e = e.drop(n)), t !== i && (t = R(t), e = t < 0 ? e.dropRight(-t) : e.take(t - n)), e);
            }, H.prototype.takeRightWhile = function(n) {
                return this.reverse().takeWhile(n).reverse();
            }, H.prototype.toArray = function() {
                return this.take(Hn);
            }, $n(H.prototype, function(n, t) {
                var e = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), s = a[r ? "take" + (t == "last" ? "Right" : "") : t], o = r || /^find/.test(t);
                s && (a.prototype[t] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof H, v = c[0], _ = l || O(f), m = function(N) {
                        var $ = s.apply(a, nt([
                            N
                        ], c));
                        return r && P ? $[0] : $;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var P = this.__chain__, I = !!this.__actions__.length, E = o && !P, T = l && !I;
                    if (!o && _) {
                        f = T ? f : new H(this);
                        var y = n.apply(f, c);
                        return y.__actions__.push({
                            func: er,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pn(y, P);
                    }
                    return E && T ? n.apply(this, c) : (y = this.thru(m), E ? r ? y.value()[0] : y.value() : y);
                });
            }), mn([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(n) {
                var t = Oe[n], e = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(n);
                a.prototype[n] = function() {
                    var s = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return t.apply(O(o) ? o : [], s);
                    }
                    return this[e](function(f) {
                        return t.apply(O(f) ? f : [], s);
                    });
                };
            }), $n(H.prototype, function(n, t) {
                var e = a[t];
                if (e) {
                    var r = e.name + "";
                    F.call(Ut, r) || (Ut[r] = []), Ut[r].push({
                        name: t,
                        func: e
                    });
                }
            }), Ut[Xe(i, ct).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], H.prototype.clone = zf, H.prototype.reverse = Kf, H.prototype.value = Yf, a.prototype.at = Al, a.prototype.chain = Cl, a.prototype.commit = Il, a.prototype.next = xl, a.prototype.plant = yl, a.prototype.reverse = Sl, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = Ol, a.prototype.first = a.prototype.head, ne && (a.prototype[ne] = El), a;
        }, Nt = If();
        lt ? ((lt.exports = Nt)._ = Nt, Tr._ = Nt) : k._ = Nt;
    }).call($f7c469cbc3220931$var$ge);
})($f7c469cbc3220931$var$Ui, $f7c469cbc3220931$var$Ui.exports);
var $f7c469cbc3220931$var$zg = Object.defineProperty, $f7c469cbc3220931$var$Kg = Object.defineProperties, $f7c469cbc3220931$var$Yg = Object.getOwnPropertyDescriptors, $f7c469cbc3220931$var$ya = Object.getOwnPropertySymbols, $f7c469cbc3220931$var$Zg = Object.prototype.hasOwnProperty, $f7c469cbc3220931$var$Jg = Object.prototype.propertyIsEnumerable, $f7c469cbc3220931$var$Sa = (A, u, i)=>u in A ? $f7c469cbc3220931$var$zg(A, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : A[u] = i, $f7c469cbc3220931$var$cr = (A, u)=>{
    for(var i in u || (u = {}))$f7c469cbc3220931$var$Zg.call(u, i) && $f7c469cbc3220931$var$Sa(A, i, u[i]);
    if ($f7c469cbc3220931$var$ya) for (var i of $f7c469cbc3220931$var$ya(u))$f7c469cbc3220931$var$Jg.call(u, i) && $f7c469cbc3220931$var$Sa(A, i, u[i]);
    return A;
}, $f7c469cbc3220931$var$Xg = (A, u)=>$f7c469cbc3220931$var$Kg(A, $f7c469cbc3220931$var$Yg(u));
function $f7c469cbc3220931$var$ft(A, u, i) {
    var p;
    const w = (0, $17d123d3e821614f$export$4764229d78de4437)(A);
    return ((p = u.rpcMap) == null ? void 0 : p[w.reference]) || `${$f7c469cbc3220931$var$Gg}?chainId=${w.namespace}:${w.reference}&projectId=${i}`;
}
function $f7c469cbc3220931$var$Ct(A) {
    return A.includes(":") ? A.split(":")[1] : A;
}
function $f7c469cbc3220931$var$Oa(A) {
    return A.map((u)=>`${u.split(":")[0]}:${u.split(":")[1]}`);
}
function $f7c469cbc3220931$var$Qg(A, u) {
    const i = Object.keys(u.namespaces).filter((w)=>w.includes(A));
    if (!i.length) return [];
    const p = [];
    return i.forEach((w)=>{
        const b = u.namespaces[w].accounts;
        p.push(...b);
    }), p;
}
function $f7c469cbc3220931$var$Wi(A = {}, u = {}) {
    const i = $f7c469cbc3220931$var$Ra(A), p = $f7c469cbc3220931$var$Ra(u);
    return $f7c469cbc3220931$var$Ui.exports.merge(i, p);
}
function $f7c469cbc3220931$var$Ra(A) {
    var u, i, p, w;
    const b = {};
    if (!(0, $17d123d3e821614f$export$16a0268bc22b47b0)(A)) return b;
    for (const [D, En] of Object.entries(A)){
        const zt = (0, $17d123d3e821614f$export$e03e993df4723bde)(D) ? [
            D
        ] : En.chains, pr = En.methods || [], It = En.events || [], Ln = En.rpcMap || {}, Fn = (0, $17d123d3e821614f$export$dd404c96fbbb1ff8)(D);
        b[Fn] = $f7c469cbc3220931$var$Xg($f7c469cbc3220931$var$cr($f7c469cbc3220931$var$cr({}, b[Fn]), En), {
            chains: (0, $17d123d3e821614f$export$9826fe7ad3921016)(zt, (u = b[Fn]) == null ? void 0 : u.chains),
            methods: (0, $17d123d3e821614f$export$9826fe7ad3921016)(pr, (i = b[Fn]) == null ? void 0 : i.methods),
            events: (0, $17d123d3e821614f$export$9826fe7ad3921016)(It, (p = b[Fn]) == null ? void 0 : p.events),
            rpcMap: $f7c469cbc3220931$var$cr($f7c469cbc3220931$var$cr({}, Ln), (w = b[Fn]) == null ? void 0 : w.rpcMap)
        });
    }
    return b;
}
function $f7c469cbc3220931$var$Vg(A) {
    return A.includes(":") ? A.split(":")[2] : A;
}
function $f7c469cbc3220931$var$ba(A) {
    const u = {};
    for (const [i, p] of Object.entries(A)){
        const w = p.methods || [], b = p.events || [], D = p.accounts || [], En = (0, $17d123d3e821614f$export$e03e993df4723bde)(i) ? [
            i
        ] : p.chains ? p.chains : $f7c469cbc3220931$var$Oa(p.accounts);
        u[i] = {
            chains: En,
            methods: w,
            events: b,
            accounts: D
        };
    }
    return u;
}
function $f7c469cbc3220931$var$Fi(A) {
    return typeof A == "number" ? A : A.includes("0x") ? parseInt(A, 16) : (A = A.includes(":") ? A.split(":")[1] : A, isNaN(Number(A)) ? A : Number(A));
}
const $f7c469cbc3220931$var$Ta = {}, $f7c469cbc3220931$var$z = (A)=>$f7c469cbc3220931$var$Ta[A], $f7c469cbc3220931$var$Mi = (A, u)=>{
    $f7c469cbc3220931$var$Ta[A] = u;
};
class $f7c469cbc3220931$var$kg {
    constructor(u){
        this.name = "polkadot", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$jg {
    constructor(u){
        this.name = "eip155", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(u) {
        switch(u.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(u);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
        }
        return this.namespace.methods.includes(u.request.method) ? await this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(parseInt(u), i), this.chainId = parseInt(u), this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.HttpConnection)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = parseInt($f7c469cbc3220931$var$Ct(i));
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const u = this.chainId, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    async handleSwitchChain(u) {
        var i, p;
        let w = u.request.params ? (i = u.request.params[0]) == null ? void 0 : i.chainId : "0x0";
        w = w.startsWith("0x") ? w : `0x${w}`;
        const b = parseInt(w, 16);
        if (this.isChainApproved(b)) this.setDefaultChain(`${b}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: u.topic,
            request: {
                method: u.request.method,
                params: [
                    {
                        chainId: w
                    }
                ]
            },
            chainId: (p = this.namespace.chains) == null ? void 0 : p[0]
        }), this.setDefaultChain(`${b}`);
        else throw new Error(`Failed to switch to chain 'eip155:${b}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(u) {
        return this.namespace.chains.includes(`${this.name}:${u}`);
    }
}
class $f7c469cbc3220931$var$nv {
    constructor(u){
        this.name = "solana", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$tv {
    constructor(u){
        this.name = "cosmos", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$ev {
    constructor(u){
        this.name = "cip34", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            const p = this.getCardanoRPCUrl(i), w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, p);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    getCardanoRPCUrl(u) {
        const i = this.namespace.rpcMap;
        if (i) return i[u];
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || this.getCardanoRPCUrl(u);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$rv {
    constructor(u){
        this.name = "elrond", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$iv {
    constructor(u){
        this.name = "multiversx", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        this.httpProviders[u] || this.setHttpProvider(u, i), this.chainId = u, this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${u}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const w = $f7c469cbc3220931$var$Ct(i);
            u[w] = this.createHttpProvider(w, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace, this.client.core.projectId);
        if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
        return new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
class $f7c469cbc3220931$var$sv {
    constructor(u){
        this.name = "near", this.namespace = u.namespace, this.events = $f7c469cbc3220931$var$z("events"), this.client = $f7c469cbc3220931$var$z("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || $f7c469cbc3220931$var$ft(`${this.name}:${u}`, this.namespace);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $f7c469cbc3220931$var$ft(u, this.namespace);
        return typeof p > "u" ? void 0 : new (0, $4f39d563736cd6ff$export$da28308012bf6748)(new (0, $itZgd.default)(p, $f7c469cbc3220931$var$z("disableProviderPing")));
    }
}
var $f7c469cbc3220931$var$uv = Object.defineProperty, $f7c469cbc3220931$var$av = Object.defineProperties, $f7c469cbc3220931$var$ov = Object.getOwnPropertyDescriptors, $f7c469cbc3220931$var$La = Object.getOwnPropertySymbols, $f7c469cbc3220931$var$fv = Object.prototype.hasOwnProperty, $f7c469cbc3220931$var$cv = Object.prototype.propertyIsEnumerable, $f7c469cbc3220931$var$Da = (A, u, i)=>u in A ? $f7c469cbc3220931$var$uv(A, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : A[u] = i, $f7c469cbc3220931$var$hr = (A, u)=>{
    for(var i in u || (u = {}))$f7c469cbc3220931$var$fv.call(u, i) && $f7c469cbc3220931$var$Da(A, i, u[i]);
    if ($f7c469cbc3220931$var$La) for (var i of $f7c469cbc3220931$var$La(u))$f7c469cbc3220931$var$cv.call(u, i) && $f7c469cbc3220931$var$Da(A, i, u[i]);
    return A;
}, $f7c469cbc3220931$var$qi = (A, u)=>$f7c469cbc3220931$var$av(A, $f7c469cbc3220931$var$ov(u));
class $f7c469cbc3220931$export$2e2bcd8739ae039 {
    constructor(u){
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($ej6Nm))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = u, this.logger = typeof u?.logger < "u" && typeof u?.logger != "string" ? u.logger : (0, (/*@__PURE__*/$parcel$interopDefault($77JzN)))((0, $c8Vuh.getDefaultLoggerOptions)({
            level: u?.logger || $f7c469cbc3220931$var$xa
        })), this.disableProviderPing = u?.disableProviderPing || !1;
    }
    static async init(u) {
        const i = new $f7c469cbc3220931$export$2e2bcd8739ae039(u);
        return await i.initialize(), i;
    }
    async request(u, i, p) {
        const [w, b] = this.validateChain(i);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(w).request({
            request: $f7c469cbc3220931$var$hr({}, u),
            chainId: `${w}:${b}`,
            topic: this.session.topic,
            expiry: p
        });
    }
    sendAsync(u, i, p, w) {
        const b = new Date().getTime();
        this.request(u, p, w).then((D)=>i(null, (0, $4seG3.formatJsonRpcResult)(b, D))).catch((D)=>i(D, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var u;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (u = this.session) == null ? void 0 : u.topic,
            reason: (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(u) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(u), await this.cleanupPendingPairings(), !u.skipPairing) return await this.pair(u.pairingTopic);
    }
    async authenticate(u) {
        if (!this.client) throw new Error("Sign Client not initialized");
        this.setNamespaces(u), await this.cleanupPendingPairings();
        const { uri: i, response: p } = await this.client.authenticate(u);
        i && (this.uri = i, this.events.emit("display_uri", i));
        const w = await p();
        if (this.session = w.session, this.session) {
            const b = $f7c469cbc3220931$var$ba(this.session.namespaces);
            this.namespaces = $f7c469cbc3220931$var$Wi(this.namespaces, b), this.persist("namespaces", this.namespaces), this.onConnect();
        }
        return w;
    }
    on(u, i) {
        this.events.on(u, i);
    }
    once(u, i) {
        this.events.once(u, i);
    }
    removeListener(u, i) {
        this.events.removeListener(u, i);
    }
    off(u, i) {
        this.events.off(u, i);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(u) {
        this.shouldAbortPairingAttempt = !1;
        let i = 0;
        do {
            if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
            if (i >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
            const { uri: p, approval: w } = await this.client.connect({
                pairingTopic: u,
                requiredNamespaces: this.namespaces,
                optionalNamespaces: this.optionalNamespaces,
                sessionProperties: this.sessionProperties
            });
            p && (this.uri = p, this.events.emit("display_uri", p)), await w().then((b)=>{
                this.session = b;
                const D = $f7c469cbc3220931$var$ba(b.namespaces);
                this.namespaces = $f7c469cbc3220931$var$Wi(this.namespaces, D), this.persist("namespaces", this.namespaces);
            }).catch((b)=>{
                if (b.message !== (0, $47c1d2f2edc36dab$export$1e6a4dc5172f4830)) throw b;
                i++;
            });
        }while (!this.session);
        return this.onConnect(), this.session;
    }
    setDefaultChain(u, i) {
        try {
            if (!this.session) return;
            const [p, w] = this.validateChain(u);
            this.getProvider(p).setDefaultChain(w, i);
        } catch (p) {
            if (!/Please call connect/.test(p.message)) throw p;
        }
    }
    async cleanupPendingPairings(u = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const i = this.client.pairing.getAll();
        if ((0, $17d123d3e821614f$export$41dd3d480aac4a71)(i)) {
            for (const p of i)u.deletePairings ? this.client.core.expirer.set(p.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(p.topic);
            this.logger.info(`Inactive pairings cleared: ${i.length}`);
        }
    }
    abortPairingAttempt() {
        this.shouldAbortPairingAttempt = !0;
    }
    async checkStorage() {
        if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
            const u = this.client.session.keys.length - 1;
            this.session = this.client.session.get(this.client.session.keys[u]), this.createProviders();
        }
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        this.client = this.providerOpts.client || await (0, $47c1d2f2edc36dab$export$2e2bcd8739ae039).init({
            logger: this.providerOpts.logger || $f7c469cbc3220931$var$xa,
            relayUrl: this.providerOpts.relayUrl || $f7c469cbc3220931$var$Mg,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name
        }), this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const u = [
            ...new Set(Object.keys(this.session.namespaces).map((i)=>(0, $17d123d3e821614f$export$dd404c96fbbb1ff8)(i)))
        ];
        $f7c469cbc3220931$var$Mi("client", this.client), $f7c469cbc3220931$var$Mi("events", this.events), $f7c469cbc3220931$var$Mi("disableProviderPing", this.disableProviderPing), u.forEach((i)=>{
            if (!this.session) return;
            const p = $f7c469cbc3220931$var$Qg(i, this.session), w = $f7c469cbc3220931$var$Oa(p), b = $f7c469cbc3220931$var$Wi(this.namespaces, this.optionalNamespaces), D = $f7c469cbc3220931$var$qi($f7c469cbc3220931$var$hr({}, b[i]), {
                accounts: p,
                chains: w
            });
            switch(i){
                case "eip155":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$jg({
                        namespace: D
                    });
                    break;
                case "solana":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$nv({
                        namespace: D
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$tv({
                        namespace: D
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$kg({
                        namespace: D
                    });
                    break;
                case "cip34":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$ev({
                        namespace: D
                    });
                    break;
                case "elrond":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$rv({
                        namespace: D
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$iv({
                        namespace: D
                    });
                    break;
                case "near":
                    this.rpcProviders[i] = new $f7c469cbc3220931$var$sv({
                        namespace: D
                    });
                    break;
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (u)=>{
            this.events.emit("session_ping", u);
        }), this.client.on("session_event", (u)=>{
            const { params: i } = u, { event: p } = i;
            if (p.name === "accountsChanged") {
                const w = p.data;
                w && (0, $17d123d3e821614f$export$41dd3d480aac4a71)(w) && this.events.emit("accountsChanged", w.map($f7c469cbc3220931$var$Vg));
            } else if (p.name === "chainChanged") {
                const w = i.chainId, b = i.event.data, D = (0, $17d123d3e821614f$export$dd404c96fbbb1ff8)(w), En = $f7c469cbc3220931$var$Fi(w) !== $f7c469cbc3220931$var$Fi(b) ? `${D}:${$f7c469cbc3220931$var$Fi(b)}` : w;
                this.onChainChanged(En);
            } else this.events.emit(p.name, p.data);
            this.events.emit("session_event", u);
        }), this.client.on("session_update", ({ topic: u, params: i })=>{
            var p;
            const { namespaces: w } = i, b = (p = this.client) == null ? void 0 : p.session.get(u);
            this.session = $f7c469cbc3220931$var$qi($f7c469cbc3220931$var$hr({}, b), {
                namespaces: w
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: u,
                params: i
            });
        }), this.client.on("session_delete", async (u)=>{
            await this.cleanup(), this.events.emit("session_delete", u), this.events.emit("disconnect", $f7c469cbc3220931$var$qi($f7c469cbc3220931$var$hr({}, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: u.topic
            }));
        }), this.on($f7c469cbc3220931$var$Vn.DEFAULT_CHAIN_CHANGED, (u)=>{
            this.onChainChanged(u, !0);
        });
    }
    getProvider(u) {
        if (!this.rpcProviders[u]) throw new Error(`Provider not found: ${u}`);
        return this.rpcProviders[u];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((u)=>{
            var i;
            this.getProvider(u).updateNamespace((i = this.session) == null ? void 0 : i.namespaces[u]);
        });
    }
    setNamespaces(u) {
        const { namespaces: i, optionalNamespaces: p, sessionProperties: w } = u;
        i && Object.keys(i).length && (this.namespaces = i), p && Object.keys(p).length && (this.optionalNamespaces = p), this.sessionProperties = w, this.persist("namespaces", i), this.persist("optionalNamespaces", p);
    }
    validateChain(u) {
        const [i, p] = u?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            i,
            p
        ];
        if (i && !Object.keys(this.namespaces || {}).map((D)=>(0, $17d123d3e821614f$export$dd404c96fbbb1ff8)(D)).includes(i)) throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);
        if (i && p) return [
            i,
            p
        ];
        const w = (0, $17d123d3e821614f$export$dd404c96fbbb1ff8)(Object.keys(this.namespaces)[0]), b = this.rpcProviders[w].getDefaultChain();
        return [
            w,
            b
        ];
    }
    async requestAccounts() {
        const [u] = this.validateChain();
        return await this.getProvider(u).requestAccounts();
    }
    onChainChanged(u, i = !1) {
        if (!this.namespaces) return;
        const [p, w] = this.validateChain(u);
        w && (i || this.getProvider(p).setDefaultChain(w), this.namespaces[p] ? this.namespaces[p].defaultChain = w : this.namespaces[`${p}:${w}`] ? this.namespaces[`${p}:${w}`].defaultChain = w : this.namespaces[`${p}:${w}`] = {
            defaultChain: w
        }, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", w));
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({
            deletePairings: !0
        });
    }
    persist(u, i) {
        this.client.core.storage.setItem(`${$f7c469cbc3220931$var$Ea}/${u}`, i);
    }
    async getFromStore(u) {
        return await this.client.core.storage.getItem(`${$f7c469cbc3220931$var$Ea}/${u}`);
    }
}
const $f7c469cbc3220931$export$63bc40680ab52599 = $f7c469cbc3220931$export$2e2bcd8739ae039;


const $a4ae90032eb46846$var$T = "wc", $a4ae90032eb46846$var$S = "ethereum_provider", $a4ae90032eb46846$var$$ = `${$a4ae90032eb46846$var$T}@2:${$a4ae90032eb46846$var$S}:`, $a4ae90032eb46846$var$j = "https://rpc.walletconnect.com/v1/", $a4ae90032eb46846$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $a4ae90032eb46846$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode",
    "wallet_sendCalls",
    "wallet_getCapabilities",
    "wallet_getCallsStatus",
    "wallet_showCallsStatus"
], $a4ae90032eb46846$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $a4ae90032eb46846$export$1d352f96d67d51e6 = [
    "chainChanged",
    "accountsChanged",
    "message",
    "disconnect",
    "connect"
];
var $a4ae90032eb46846$var$q = Object.defineProperty, $a4ae90032eb46846$var$N = Object.defineProperties, $a4ae90032eb46846$var$D = Object.getOwnPropertyDescriptors, $a4ae90032eb46846$var$O = Object.getOwnPropertySymbols, $a4ae90032eb46846$var$U = Object.prototype.hasOwnProperty, $a4ae90032eb46846$var$Q = Object.prototype.propertyIsEnumerable, $a4ae90032eb46846$var$b = (a, t, s)=>t in a ? $a4ae90032eb46846$var$q(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $a4ae90032eb46846$var$p = (a, t)=>{
    for(var s in t || (t = {}))$a4ae90032eb46846$var$U.call(t, s) && $a4ae90032eb46846$var$b(a, s, t[s]);
    if ($a4ae90032eb46846$var$O) for (var s of $a4ae90032eb46846$var$O(t))$a4ae90032eb46846$var$Q.call(t, s) && $a4ae90032eb46846$var$b(a, s, t[s]);
    return a;
}, $a4ae90032eb46846$var$E = (a, t)=>$a4ae90032eb46846$var$N(a, $a4ae90032eb46846$var$D(t));
function $a4ae90032eb46846$var$m(a) {
    return Number(a[0].split(":")[1]);
}
function $a4ae90032eb46846$var$v(a) {
    return `0x${a.toString(16)}`;
}
function $a4ae90032eb46846$var$L(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: e, events: n, optionalEvents: o, rpcMap: r } = a;
    if (!(0, $17d123d3e821614f$export$41dd3d480aac4a71)(t)) throw new Error("Invalid chains");
    const c = {
        chains: t,
        methods: i || $a4ae90032eb46846$export$cfec112b6d27bf,
        events: n || $a4ae90032eb46846$export$2c607e5ce12221af,
        rpcMap: $a4ae90032eb46846$var$p({}, t.length ? {
            [$a4ae90032eb46846$var$m(t)]: r[$a4ae90032eb46846$var$m(t)]
        } : {})
    }, h = n?.filter((l)=>!$a4ae90032eb46846$export$2c607e5ce12221af.includes(l)), d = i?.filter((l)=>!$a4ae90032eb46846$export$cfec112b6d27bf.includes(l));
    if (!s && !o && !e && !(h != null && h.length) && !(d != null && d.length)) return {
        required: t.length ? c : void 0
    };
    const w = h?.length && d?.length || !s, I = {
        chains: [
            ...new Set(w ? c.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(c.methods.concat(e != null && e.length ? e : $a4ae90032eb46846$export$bc85197675500780))
        ],
        events: [
            ...new Set(c.events.concat(o != null && o.length ? o : $a4ae90032eb46846$export$1d352f96d67d51e6))
        ],
        rpcMap: r
    };
    return {
        required: t.length ? c : void 0,
        optional: s.length ? I : void 0
    };
}

class $a4ae90032eb46846$export$2e2bcd8739ae039 {
    constructor(){
        this.events = new (0, $ej6Nm.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $a4ae90032eb46846$var$$, this.on = (t, s)=>(this.events.on(t, s), this), this.once = (t, s)=>(this.events.once(t, s), this), this.removeListener = (t, s)=>(this.events.removeListener(t, s), this), this.off = (t, s)=>(this.events.off(t, s), this), this.parseAccount = (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t, this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $a4ae90032eb46846$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t, s) {
        return await this.signer.request(t, this.formatChainId(this.chainId), s);
    }
    sendAsync(t, s, i) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId), i);
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $a4ae90032eb46846$var$L(this.rpc);
        try {
            const e = await new Promise(async (o, r)=>{
                var c;
                this.rpc.showQrModal && ((c = this.modal) == null || c.subscribeModal((h)=>{
                    !h.open && !this.signer.session && (this.signer.abortPairingAttempt(), r(new Error("Connection request reset. Please try again.")));
                })), await this.signer.connect($a4ae90032eb46846$var$E($a4ae90032eb46846$var$p({
                    namespaces: $a4ae90032eb46846$var$p({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic
                })).then((h)=>{
                    o(h);
                }).catch((h)=>{
                    r(new Error(h.message));
                });
            });
            if (!e) return;
            const n = (0, $17d123d3e821614f$export$23329703ad972840)(e.namespaces, [
                this.namespace
            ]);
            this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", {
                chainId: $a4ae90032eb46846$var$v(this.chainId)
            });
        } catch (e) {
            throw this.signer.logger.error(e), e;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async authenticate(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts({
            chains: t?.chains
        });
        try {
            const s = await new Promise(async (e, n)=>{
                var o;
                this.rpc.showQrModal && ((o = this.modal) == null || o.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), n(new Error("Connection request reset. Please try again.")));
                })), await this.signer.authenticate($a4ae90032eb46846$var$E($a4ae90032eb46846$var$p({}, t), {
                    chains: this.rpc.chains
                })).then((r)=>{
                    e(r);
                }).catch((r)=>{
                    n(new Error(r.message));
                });
            }), i = s.session;
            if (i) {
                const e = (0, $17d123d3e821614f$export$23329703ad972840)(i.namespaces, [
                    this.namespace
                ]);
                this.setChainIds(this.rpc.chains.length ? this.rpc.chains : e), this.setAccounts(e), this.events.emit("connect", {
                    chainId: $a4ae90032eb46846$var$v(this.chainId)
                });
            }
            return s;
        } catch (s) {
            throw this.signer.logger.error(s), s;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $a4ae90032eb46846$var$v(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $a4ae90032eb46846$var$E($a4ae90032eb46846$var$p({}, (0, $17d123d3e821614f$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $a4ae90032eb46846$var$v(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, e] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: e
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const e = (s = t?.chains) != null ? s : [], n = (i = t?.optionalChains) != null ? i : [], o = e.concat(n);
        if (!o.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const r = e.length ? t?.methods || $a4ae90032eb46846$export$cfec112b6d27bf : [], c = e.length ? t?.events || $a4ae90032eb46846$export$2c607e5ce12221af : [], h = t?.optionalMethods || [], d = t?.optionalEvents || [], w = t?.rpcMap || this.buildRpcMap(o, t.projectId), I = t?.qrModalOptions || void 0;
        return {
            chains: e?.map((l)=>this.formatChainId(l)),
            optionalChains: n.map((l)=>this.formatChainId(l)),
            methods: r,
            events: c,
            optionalMethods: h,
            optionalEvents: d,
            rpcMap: w,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: I,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((e)=>{
            i[e] = this.getRpcUrl(e, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $a4ae90032eb46846$var$m(this.rpc.chains) : $a4ae90032eb46846$var$m(this.rpc.optionalChains), this.signer = await (0, $f7c469cbc3220931$export$63bc40680ab52599).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storageOptions: t.storageOptions
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("bMvqo"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($a4ae90032eb46846$var$p({
                    projectId: this.rpc.projectId
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: e } = t;
        s && (0, $17d123d3e821614f$export$41dd3d480aac4a71)(s) && (this.rpc.chains = s.map((n)=>this.formatChainId(n)), s.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        })), i && (0, $17d123d3e821614f$export$41dd3d480aac4a71)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((n)=>this.formatChainId(n)), i.forEach((n)=>{
            this.rpc.rpcMap[n] = e?.[n] || this.getRpcUrl(n);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$a4ae90032eb46846$var$j}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (this.session) try {
            const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
            this.setChainIds(t ? [
                this.formatChainId(t)
            ] : s?.accounts), this.setAccounts(s?.accounts);
        } catch (t) {
            this.signer.logger.error("Failed to load persisted session, clearing state..."), this.signer.logger.error(t), await this.disconnect().catch((s)=>this.signer.logger.warn(s));
        }
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $a4ae90032eb46846$export$cdfbbad9b2980226 = $a4ae90032eb46846$export$2e2bcd8739ae039;



var $ej6Nm = parcelRequire("ej6Nm");

class $5fb7f5c20f07e18f$export$c456b2d327ac201f extends (0, $ej6Nm.EventEmitter) {
    constructor(args){
        super();
        this.isActivationInProgress = false;
        this.options = args.options;
        this.name = args.name;
        this.icon = args.icon;
        this.installed = args.installed;
    }
    async startListening() {
        // Subscribe to accounts change
        this.provider?.on("accountsChanged", async (accounts)=>{
            if (!accounts.length) {
                this.account = undefined;
                this.emit("walletAccountChanged", this);
                return;
            }
            await this.calcAccountData();
        });
        // Subscribe to chainId change
        this.provider?.on("chainChanged", async (chainId)=>{
            await this.calcAccountData();
        });
        // Subscribe to session disconnection
        this.provider?.on("disconnect", async (code, reason)=>{
        // await this.calcAccountData();
        });
    }
    async connect() {
        if (this.isActivationInProgress) return;
        this.isActivationInProgress = true;
        this.walletConnectProvider || (this.walletConnectProvider = await (0, $a4ae90032eb46846$export$2e2bcd8739ae039).init(this.options));
        this.provider = this.walletConnectProvider;
        try {
            // Open modal
            await this.walletConnectProvider?.enable();
            this.startListening();
            await this.calcAccountData();
        } catch (e) {
            this.isActivationInProgress = false;
            throw e;
        }
        this.isActivationInProgress = false;
    }
    async disconnect() {
        if (this.provider) {
            await this.provider?.disconnect();
            await this.walletConnectProvider?.disconnect();
            this.provider = undefined;
            this.walletConnectProvider = undefined;
            this.isActivationInProgress = false;
            this.account = undefined;
            this.emit("walletAccountChanged", this);
        }
    }
    async switchChain(chainId) {
        if (!this.provider) throw new Error("Provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$15599da40e72d2f)(this.walletConnectProvider, chainId);
    }
    async addChain(chainId) {
        if (!this.provider) throw new Error("Provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$e648161d6b1bb565)(this.walletConnectProvider, chainId);
    }
    async addToken(chainId, token) {
        if (!this.provider) throw new Error("Provider is not defined.");
        return (0, $ab4607e7fa73cc99$export$94064a5f8f757f28)(this.walletConnectProvider, chainId, token);
    }
    async calcAccountData() {
        if (!this.walletConnectProvider) throw new Error("Provider is not defined.");
        const provider = new (0, $5lu0X.Web3Provider)(this.walletConnectProvider, "any");
        const signer = provider.getSigner();
        this.account = {
            chainId: await signer.getChainId(),
            address: await signer.getAddress(),
            signer: signer,
            provider: provider
        };
        this.emit("walletAccountChanged", this);
    }
}


var $1f71d6f239486232$export$ed1aacaf3c5fdac4;
(function(ProviderIdentityFlag) {
    ProviderIdentityFlag["AlphaWallet"] = "isAlphaWallet";
    ProviderIdentityFlag["BlockWallet"] = "isBlockWallet";
    ProviderIdentityFlag["Binance"] = "bbcSignTx";
    ProviderIdentityFlag["Bitpie"] = "isBitpie";
    ProviderIdentityFlag["Coinbase"] = "isToshi";
    ProviderIdentityFlag["CoinbaseExtension"] = "isCoinbaseWallet";
    ProviderIdentityFlag["Detected"] = "request";
    ProviderIdentityFlag["Dcent"] = "isDcentWallet";
    ProviderIdentityFlag["Frame"] = "isFrame";
    ProviderIdentityFlag["HyperPay"] = "isHyperPay";
    ProviderIdentityFlag["ImToken"] = "isImToken";
    ProviderIdentityFlag["Liquality"] = "isLiquality";
    ProviderIdentityFlag["MetaMask"] = "isMetaMask";
    ProviderIdentityFlag["OwnBit"] = "isOwnbit";
    ProviderIdentityFlag["Status"] = "isStatus";
    ProviderIdentityFlag["TallyHo"] = "isTally";
    ProviderIdentityFlag["Trust"] = "isTrust";
    ProviderIdentityFlag["TokenPocket"] = "isTokenPocket";
    ProviderIdentityFlag["TP"] = "isTp";
    ProviderIdentityFlag["WalletIo"] = "isWalletIO";
    ProviderIdentityFlag["XDEFI"] = "__XDEFI";
    ProviderIdentityFlag["OneInch"] = "isOneInchIOSWallet";
    ProviderIdentityFlag["Tokenary"] = "isTokenary";
    ProviderIdentityFlag["MathWallet"] = "isMathWallet";
    ProviderIdentityFlag["Frontier"] = "isFrontier";
    ProviderIdentityFlag["ApexWallet"] = "isApexWallet";
    ProviderIdentityFlag["OkxWallet"] = "okxwallet";
    ProviderIdentityFlag["SafePal"] = "safepal";
})($1f71d6f239486232$export$ed1aacaf3c5fdac4 || ($1f71d6f239486232$export$ed1aacaf3c5fdac4 = {}));


var $6c5a229dea191cc2$exports = {};
$6c5a229dea191cc2$exports = new URL("alphawallet.b6df19bd.svg", import.meta.url).toString();


var $6bc8b141b59a1b83$exports = {};
$6bc8b141b59a1b83$exports = new URL("binance.fd2a2cc4.svg", import.meta.url).toString();


var $0f660d320e1bf35c$exports = {};
$0f660d320e1bf35c$exports = new URL("bitget.76135eab.svg", import.meta.url).toString();


var $1e6fe2347f427363$exports = {};
$1e6fe2347f427363$exports = new URL("bitpie.f7f37a63.svg", import.meta.url).toString();


var $bedcfa2d55e96ec3$exports = {};
$bedcfa2d55e96ec3$exports = new URL("blockwallet.c6a56de0.svg", import.meta.url).toString();


var $06a0a913d74a308e$exports = {};
$06a0a913d74a308e$exports = new URL("brave.fcb69d8b.svg", import.meta.url).toString();


var $9f03e06d3fb21089$exports = {};
$9f03e06d3fb21089$exports = new URL("coinbase.c169dc7d.svg", import.meta.url).toString();


var $fe746663887e7704$exports = {};
$fe746663887e7704$exports = new URL("dcent.e2c059f6.svg", import.meta.url).toString();


var $4992c1bec9356129$exports = {};
$4992c1bec9356129$exports = new URL("exodus.d248de81.svg", import.meta.url).toString();


var $10b0f1f85ab2ed95$exports = {};
$10b0f1f85ab2ed95$exports = new URL("frame.bbe65a09.svg", import.meta.url).toString();


var $6dc9a83211ed8969$exports = {};
$6dc9a83211ed8969$exports = new URL("frontier.27b1a632.svg", import.meta.url).toString();


var $c4f64103340a6807$exports = {};
$c4f64103340a6807$exports = new URL("gate.512dbc57.svg", import.meta.url).toString();


var $c3e643e453f922f7$exports = {};
$c3e643e453f922f7$exports = new URL("hyperpay.b038c996.svg", import.meta.url).toString();


var $f89b6cb5485c2d1f$exports = {};
$f89b6cb5485c2d1f$exports = new URL("imtoken.148ecc42.svg", import.meta.url).toString();


var $1cf5c5ef3a7dac06$exports = {};
$1cf5c5ef3a7dac06$exports = new URL("liquality.0b620ff6.svg", import.meta.url).toString();


var $4b0acdd9ed4fff13$exports = {};
$4b0acdd9ed4fff13$exports = new URL("mathWallet.346af017.svg", import.meta.url).toString();


var $aaf03e683308b50c$exports = {};
$aaf03e683308b50c$exports = new URL("metaMask.dfcc0ce3.svg", import.meta.url).toString();


var $8c5e1afa0cf49ce4$exports = {};
$8c5e1afa0cf49ce4$exports = new URL("okx.11891fb5.svg", import.meta.url).toString();


var $9a41141f017afc6f$exports = {};
$9a41141f017afc6f$exports = new URL("oneInch.1cfef62e.svg", import.meta.url).toString();


var $fc44fd1e238285fe$exports = {};
$fc44fd1e238285fe$exports = new URL("opera.219f2cfc.svg", import.meta.url).toString();


var $afb447aebe3814b2$exports = {};
$afb447aebe3814b2$exports = new URL("ownbit.63b0d0a3.svg", import.meta.url).toString();


var $de41eceed3cd191e$exports = {};
$de41eceed3cd191e$exports = new URL("placeholder.faea9478.svg", import.meta.url).toString();


var $4c9ab2314142c47d$exports = {};
$4c9ab2314142c47d$exports = new URL("rabbywallet.8b8736b0.svg", import.meta.url).toString();


var $ff6374c058613a3f$exports = {};
$ff6374c058613a3f$exports = new URL("safe.035c32f9.svg", import.meta.url).toString();


var $3cf2c69edec31d02$exports = {};
$3cf2c69edec31d02$exports = new URL("safepal.3b3954cf.svg", import.meta.url).toString();


var $ead91bc8947a48aa$exports = {};
$ead91bc8947a48aa$exports = new URL("status.b00914cb.svg", import.meta.url).toString();


var $ba01c42ae69b8ba7$exports = {};
$ba01c42ae69b8ba7$exports = new URL("tallyho.56ec6262.svg", import.meta.url).toString();


var $3ddf6ade1b28f61e$exports = {};
$3ddf6ade1b28f61e$exports = new URL("tokenary.adefe59c.svg", import.meta.url).toString();


var $80b8b70ce355abb5$exports = {};
$80b8b70ce355abb5$exports = new URL("tokenpocket.baf3cbdd.svg", import.meta.url).toString();


var $4155f5c46da7f9fe$exports = {};
$4155f5c46da7f9fe$exports = new URL("trust.610f9b95.svg", import.meta.url).toString();


var $25c9a5384854c701$exports = {};
$25c9a5384854c701$exports = new URL("walletConnect.ccd839a8.svg", import.meta.url).toString();


var $7878e2f869aa64ec$exports = {};
$7878e2f869aa64ec$exports = new URL("walletio.7403da40.svg", import.meta.url).toString();


var $4303a5e98bf76734$exports = {};
$4303a5e98bf76734$exports = new URL("xdefi.ace603cc.svg", import.meta.url).toString();


var $b44ca430e39b448c$exports = {};
$b44ca430e39b448c$exports = new URL("cyberconnect.027ff4b1.svg", import.meta.url).toString();


const $665a39d700b3e26a$export$e5b5d3016ab484ae = {
    mathwallet: (/*@__PURE__*/$parcel$interopDefault($4b0acdd9ed4fff13$exports)),
    walletConnect: (/*@__PURE__*/$parcel$interopDefault($25c9a5384854c701$exports)),
    alphawallet: (/*@__PURE__*/$parcel$interopDefault($6c5a229dea191cc2$exports)),
    frontier: (/*@__PURE__*/$parcel$interopDefault($6dc9a83211ed8969$exports)),
    blockwallet: (/*@__PURE__*/$parcel$interopDefault($bedcfa2d55e96ec3$exports)),
    bitGet: (/*@__PURE__*/$parcel$interopDefault($0f660d320e1bf35c$exports)),
    gate: (/*@__PURE__*/$parcel$interopDefault($c4f64103340a6807$exports)),
    binance: (/*@__PURE__*/$parcel$interopDefault($6bc8b141b59a1b83$exports)),
    placeholder: (/*@__PURE__*/$parcel$interopDefault($de41eceed3cd191e$exports)),
    bitpie: (/*@__PURE__*/$parcel$interopDefault($1e6fe2347f427363$exports)),
    brave: (/*@__PURE__*/$parcel$interopDefault($06a0a913d74a308e$exports)),
    coinbase: (/*@__PURE__*/$parcel$interopDefault($9f03e06d3fb21089$exports)),
    dcent: (/*@__PURE__*/$parcel$interopDefault($fe746663887e7704$exports)),
    frame: (/*@__PURE__*/$parcel$interopDefault($10b0f1f85ab2ed95$exports)),
    hyperpay: (/*@__PURE__*/$parcel$interopDefault($c3e643e453f922f7$exports)),
    imtoken: (/*@__PURE__*/$parcel$interopDefault($f89b6cb5485c2d1f$exports)),
    liquality: (/*@__PURE__*/$parcel$interopDefault($1cf5c5ef3a7dac06$exports)),
    metamask: (/*@__PURE__*/$parcel$interopDefault($aaf03e683308b50c$exports)),
    okx: (/*@__PURE__*/$parcel$interopDefault($8c5e1afa0cf49ce4$exports)),
    oneInch: (/*@__PURE__*/$parcel$interopDefault($9a41141f017afc6f$exports)),
    opera: (/*@__PURE__*/$parcel$interopDefault($fc44fd1e238285fe$exports)),
    ownbit: (/*@__PURE__*/$parcel$interopDefault($afb447aebe3814b2$exports)),
    status: (/*@__PURE__*/$parcel$interopDefault($ead91bc8947a48aa$exports)),
    tallyho: (/*@__PURE__*/$parcel$interopDefault($ba01c42ae69b8ba7$exports)),
    tokenary: (/*@__PURE__*/$parcel$interopDefault($3ddf6ade1b28f61e$exports)),
    tokenpocket: (/*@__PURE__*/$parcel$interopDefault($80b8b70ce355abb5$exports)),
    trust: (/*@__PURE__*/$parcel$interopDefault($4155f5c46da7f9fe$exports)),
    walletio: (/*@__PURE__*/$parcel$interopDefault($7878e2f869aa64ec$exports)),
    xdefi: (/*@__PURE__*/$parcel$interopDefault($4303a5e98bf76734$exports)),
    exodus: (/*@__PURE__*/$parcel$interopDefault($4992c1bec9356129$exports)),
    safe: (/*@__PURE__*/$parcel$interopDefault($ff6374c058613a3f$exports)),
    safepal: (/*@__PURE__*/$parcel$interopDefault($3cf2c69edec31d02$exports)),
    rabbywallet: (/*@__PURE__*/$parcel$interopDefault($4c9ab2314142c47d$exports)),
    cyberconnect: (/*@__PURE__*/$parcel$interopDefault($b44ca430e39b448c$exports))
};


parcelRequire("8VNI3");
var $5lu0X = parcelRequire("5lu0X");

var $lKw3B = parcelRequire("lKw3B");
const $b182faeaceab079c$export$857f1b5f596fb425 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 421613,
    name: "Arbitrum Goerli",
    network: "arbitrum-goerli",
    nativeCurrency: {
        name: "Arbitrum Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://arb-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://arb-goerli.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://arbitrum-goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://arbitrum-goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://goerli-rollup.arbitrum.io/rpc"
            ]
        },
        public: {
            http: [
                "https://goerli-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Arbiscan",
            url: "https://goerli.arbiscan.io"
        },
        default: {
            name: "Arbiscan",
            url: "https://goerli.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 88114
        }
    },
    testnet: true
});


var $lKw3B = parcelRequire("lKw3B");



var $dKCgU = parcelRequire("dKCgU");

var $6aJeG = parcelRequire("6aJeG");

var $icori = parcelRequire("icori");

var $8tYxy = parcelRequire("8tYxy");
const $b9bf5e575accd6cb$export$6036b136d25e5e12 = {
    block: /*#__PURE__*/ (0, $6aJeG.defineBlock)({
        format (args) {
            const transactions = args.transactions?.map((transaction)=>{
                if (typeof transaction === "string") return transaction;
                const formatted = (0, $icori.formatTransaction)(transaction);
                if (formatted.typeHex === "0x7e") {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint ? (0, $dKCgU.hexToBigInt)(transaction.mint) : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = "deposit";
                }
                return formatted;
            });
            return {
                transactions: transactions,
                stateRoot: args.stateRoot
            };
        }
    }),
    transaction: /*#__PURE__*/ (0, $icori.defineTransaction)({
        format (args) {
            const transaction = {};
            if (args.type === "0x7e") {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? (0, $dKCgU.hexToBigInt)(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = "deposit";
            }
            return transaction;
        }
    }),
    transactionReceipt: /*#__PURE__*/ (0, $8tYxy.defineTransactionReceipt)({
        format (args) {
            return {
                l1GasPrice: args.l1GasPrice ? (0, $dKCgU.hexToBigInt)(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? (0, $dKCgU.hexToBigInt)(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? (0, $dKCgU.hexToBigInt)(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
            };
        }
    })
};


const $bbaec386d69ac337$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 8453,
    network: "base",
    name: "Base",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://base-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://base-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://base-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://base-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://mainnet.base.org"
            ]
        },
        public: {
            http: [
                "https://mainnet.base.org"
            ]
        }
    },
    blockExplorers: {
        blockscout: {
            name: "Basescout",
            url: "https://base.blockscout.com"
        },
        default: {
            name: "Basescan",
            url: "https://basescan.org"
        },
        etherscan: {
            name: "Basescan",
            url: "https://basescan.org"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 5022
        }
    }
}, {
    formatters: (0, $b9bf5e575accd6cb$export$6036b136d25e5e12)
});


var $lKw3B = parcelRequire("lKw3B");

const $b1381acfd3dc911e$export$8ae5747389a6ab6b = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 84531,
    network: "base-goerli",
    name: "Base Goerli",
    nativeCurrency: {
        name: "Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://base-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://base-goerli.g.alchemy.com/v2"
            ]
        },
        default: {
            http: [
                "https://goerli.base.org"
            ]
        },
        public: {
            http: [
                "https://goerli.base.org"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Basescan",
            url: "https://goerli.basescan.org"
        },
        default: {
            name: "Basescan",
            url: "https://goerli.basescan.org"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 1376988
        }
    },
    testnet: true,
    sourceId: 5
}, {
    formatters: (0, $b9bf5e575accd6cb$export$6036b136d25e5e12)
});


var $lKw3B = parcelRequire("lKw3B");
const $aa8297a11a25ced8$export$170e8cdd0c4e59c8 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 56,
    name: "BNB Smart Chain",
    network: "bsc",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "BNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/bsc"
            ]
        },
        public: {
            http: [
                "https://rpc.ankr.com/bsc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "BscScan",
            url: "https://bscscan.com"
        },
        default: {
            name: "BscScan",
            url: "https://bscscan.com"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 15921452
        }
    }
});


var $lKw3B = parcelRequire("lKw3B");
const $38a8a4a6af502137$export$1c182ebff3ea4eef = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 97,
    name: "Binance Smart Chain Testnet",
    network: "bsc-testnet",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "tBNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://data-seed-prebsc-1-s1.bnbchain.org:8545"
            ]
        },
        public: {
            http: [
                "https://data-seed-prebsc-1-s1.bnbchain.org:8545"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "BscScan",
            url: "https://testnet.bscscan.com"
        },
        default: {
            name: "BscScan",
            url: "https://testnet.bscscan.com"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 17422483
        }
    },
    testnet: true
});


var $lKw3B = parcelRequire("lKw3B");
const $6fcbf55a6a0ee3d8$export$7d9a0b32b656284d = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 59144,
    name: "Linea Mainnet",
    network: "linea-mainnet",
    nativeCurrency: {
        name: "Linea Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        infura: {
            http: [
                "https://linea-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://linea-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.linea.build"
            ],
            webSocket: [
                "wss://rpc.linea.build"
            ]
        },
        public: {
            http: [
                "https://rpc.linea.build"
            ],
            webSocket: [
                "wss://rpc.linea.build"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://lineascan.build"
        },
        etherscan: {
            name: "Etherscan",
            url: "https://lineascan.build"
        },
        blockscout: {
            name: "Blockscout",
            url: "https://explorer.linea.build"
        }
    },
    contracts: {
        multicall3: {
            address: "0xcA11bde05977b3631167028862bE2a173976CA11",
            blockCreated: 42
        }
    },
    testnet: false
});


var $lKw3B = parcelRequire("lKw3B");
const $6e6e4b9aba927ad2$export$9b359a3964075c2b = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 59140,
    name: "Linea Goerli Testnet",
    network: "linea-testnet",
    nativeCurrency: {
        name: "Linea Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        infura: {
            http: [
                "https://linea-goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://linea-goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.goerli.linea.build"
            ],
            webSocket: [
                "wss://rpc.goerli.linea.build"
            ]
        },
        public: {
            http: [
                "https://rpc.goerli.linea.build"
            ],
            webSocket: [
                "wss://rpc.goerli.linea.build"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://goerli.lineascan.build"
        },
        etherscan: {
            name: "Etherscan",
            url: "https://goerli.lineascan.build"
        },
        blockscout: {
            name: "Blockscout",
            url: "https://explorer.goerli.linea.build"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 498623
        }
    },
    testnet: true
});


var $5Lqmg = parcelRequire("5Lqmg");
var $lKw3B = parcelRequire("lKw3B");

const $ed494f69289855f6$export$e584d4a579189f9b = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 10,
    name: "OP Mainnet",
    network: "optimism",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://opt-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://opt-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://optimism-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://optimism-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://mainnet.optimism.io"
            ]
        },
        public: {
            http: [
                "https://mainnet.optimism.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://optimistic.etherscan.io"
        },
        default: {
            name: "Optimism Explorer",
            url: "https://explorer.optimism.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 4286263
        }
    }
}, {
    formatters: (0, $b9bf5e575accd6cb$export$6036b136d25e5e12)
});


var $lKw3B = parcelRequire("lKw3B");

const $044ac089d639076b$export$50b3e5cabd7d7a60 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 420,
    name: "Optimism Goerli",
    network: "optimism-goerli",
    nativeCurrency: {
        name: "Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://opt-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://opt-goerli.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://optimism-goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://optimism-goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://goerli.optimism.io"
            ]
        },
        public: {
            http: [
                "https://goerli.optimism.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://goerli-optimism.etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://goerli-optimism.etherscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 49461
        }
    },
    testnet: true
}, {
    formatters: (0, $b9bf5e575accd6cb$export$6036b136d25e5e12)
});


var $lKw3B = parcelRequire("lKw3B");
const $492183b86609249a$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 137,
    name: "Polygon",
    network: "matic",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://polygon-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://polygon-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://polygon-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://polygon-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://polygon-rpc.com"
            ]
        },
        public: {
            http: [
                "https://polygon-rpc.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "PolygonScan",
            url: "https://polygonscan.com"
        },
        default: {
            name: "PolygonScan",
            url: "https://polygonscan.com"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    }
});


var $lKw3B = parcelRequire("lKw3B");
const $e60ec03cfca6bc86$export$34b6ef3a78067459 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 80001,
    name: "Polygon Mumbai",
    network: "maticmum",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://polygon-mumbai.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://polygon-mumbai.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://polygon-mumbai.infura.io/v3"
            ],
            webSocket: [
                "wss://polygon-mumbai.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.ankr.com/polygon_mumbai"
            ]
        },
        public: {
            http: [
                "https://rpc.ankr.com/polygon_mumbai"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "PolygonScan",
            url: "https://mumbai.polygonscan.com"
        },
        default: {
            name: "PolygonScan",
            url: "https://mumbai.polygonscan.com"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    },
    testnet: true
});


var $lKw3B = parcelRequire("lKw3B");
const $f6da5cc7f9e95595$export$209876d7b1ac8f3 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 534352,
    name: "Scroll",
    network: "scroll",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.scroll.io"
            ],
            webSocket: [
                "wss://wss-rpc.scroll.io/ws"
            ]
        },
        public: {
            http: [
                "https://rpc.scroll.io"
            ],
            webSocket: [
                "wss://wss-rpc.scroll.io/ws"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Scrollscan",
            url: "https://scrollscan.com"
        },
        blockscout: {
            name: "Blockscout",
            url: "https://blockscout.scroll.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14
        }
    },
    testnet: false
});


var $lKw3B = parcelRequire("lKw3B");
const $3fcab7f5fec3898b$export$76515ac31a151681 = /*#__PURE__*/ (0, $lKw3B.defineChain)({
    id: 534351,
    name: "Scroll Sepolia",
    network: "scroll-sepolia",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://sepolia-rpc.scroll.io"
            ]
        },
        public: {
            http: [
                "https://sepolia-rpc.scroll.io"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Blockscout",
            url: "https://sepolia-blockscout.scroll.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 9473
        }
    },
    testnet: true
});



var $ej6Nm = parcelRequire("ej6Nm");

var $8H2x6 = parcelRequire("8H2x6");
var $kSNL7 = parcelRequire("kSNL7");
var $bCHCD = parcelRequire("bCHCD");
var $aegFK = parcelRequire("aegFK");
var $dKCgU = parcelRequire("dKCgU");
var $8p0q4 = parcelRequire("8p0q4");
var $7S6Nv = parcelRequire("7S6Nv");
var $cYDOa = parcelRequire("cYDOa");

var $igV1L = parcelRequire("igV1L");
var $kD2va = parcelRequire("kD2va");
var $hvJ1R = parcelRequire("hvJ1R");
var $c68dba0bfcd6b9a3$var$__defProp = Object.defineProperty;
var $c68dba0bfcd6b9a3$var$__defProps = Object.defineProperties;
var $c68dba0bfcd6b9a3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c68dba0bfcd6b9a3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c68dba0bfcd6b9a3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c68dba0bfcd6b9a3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c68dba0bfcd6b9a3$var$__defNormalProp = (obj, key, value)=>key in obj ? $c68dba0bfcd6b9a3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c68dba0bfcd6b9a3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c68dba0bfcd6b9a3$var$__hasOwnProp.call(b, prop)) $c68dba0bfcd6b9a3$var$__defNormalProp(a, prop, b[prop]);
    if ($c68dba0bfcd6b9a3$var$__getOwnPropSymbols) {
        for (var prop of $c68dba0bfcd6b9a3$var$__getOwnPropSymbols(b))if ($c68dba0bfcd6b9a3$var$__propIsEnum.call(b, prop)) $c68dba0bfcd6b9a3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c68dba0bfcd6b9a3$var$__spreadProps = (a, b)=>$c68dba0bfcd6b9a3$var$__defProps(a, $c68dba0bfcd6b9a3$var$__getOwnPropDescs(b));
var $c68dba0bfcd6b9a3$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/types.ts
var $c68dba0bfcd6b9a3$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2["Request"] = "request";
    EventType2["Response"] = "response";
    return EventType2;
})($c68dba0bfcd6b9a3$export$3d7865934588d77e || {});
var $c68dba0bfcd6b9a3$export$dba1278861bf0dc1 = /* @__PURE__ */ ((ErrorType2)=>{
    ErrorType2["SendTransactionError"] = "SendTransactionError";
    return ErrorType2;
})($c68dba0bfcd6b9a3$export$dba1278861bf0dc1 || {});
// src/Messenger.ts
var $c68dba0bfcd6b9a3$var$Messenger = class {
    constructor({ walletWindow: walletWindow, appInfo: appInfo }){
        this.walletWindow = walletWindow;
        this.appWindow = window;
        this.appInfo = appInfo;
    }
    sendMessage(event) {
        const messageId = crypto.randomUUID();
        this.postMessage({
            appId: crypto.randomUUID(),
            appInfo: this.appInfo,
            messageId: messageId,
            target: "CyberWallet",
            event: event
        });
        return messageId;
    }
    onMessage(callback) {
        this.appWindow.onmessage = (event)=>{
            callback(event.data);
        };
    }
    postMessage(message) {
        this.walletWindow.postMessage(message, "*");
    }
};
var $c68dba0bfcd6b9a3$var$Messenger_default = $c68dba0bfcd6b9a3$var$Messenger;
// src/Chain.ts
var $c68dba0bfcd6b9a3$var$Chain = class {
    constructor({ id: id, sendTransaction: sendTransaction, appId: appId }){
        this.cyberAccount = null;
        this.id = id;
        this.sendTransactionBase = sendTransaction;
        this.appId = appId;
    }
    setCyberAccount(cyberAccount) {
        this.cyberAccount = cyberAccount;
    }
    sendTransaction(transaction, option) {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            if (!this.cyberAccount) return;
            return yield this.sendTransactionBase($c68dba0bfcd6b9a3$var$__spreadProps($c68dba0bfcd6b9a3$var$__spreadValues({}, transaction), {
                from: transaction.from || this.cyberAccount.address,
                ctx: {
                    chainId: this.id,
                    owner: this.cyberAccount.ownerAddress,
                    appId: this.appId
                }
            }), option);
        });
    }
};
var $c68dba0bfcd6b9a3$var$Chain_default = $c68dba0bfcd6b9a3$var$Chain;
var $c68dba0bfcd6b9a3$var$opBnbMainnet = {
    id: 204,
    name: "opBNB",
    network: "opBNB",
    rpcUrls: {
        public: {
            http: [
                "https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3"
            ]
        },
        default: {
            http: [
                `https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3`
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BlockScout",
            url: "https://opbnbscan.com"
        }
    },
    nativeCurrency: (0, $aa8297a11a25ced8$export$170e8cdd0c4e59c8).nativeCurrency
};
var $c68dba0bfcd6b9a3$var$opBnbTestnet = {
    id: 5611,
    name: "opBNB Testnet",
    network: "opBNB testnet",
    rpcUrls: {
        public: {
            http: [
                "https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3"
            ]
        },
        default: {
            http: [
                `https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3`
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BlockScout",
            url: "https://testnet.opbnbscan.com"
        }
    },
    nativeCurrency: (0, $38a8a4a6af502137$export$1c182ebff3ea4eef).nativeCurrency
};
var $c68dba0bfcd6b9a3$var$availableChains = {
    optimism: $ed494f69289855f6$export$e584d4a579189f9b,
    optimismGoerli: $044ac089d639076b$export$50b3e5cabd7d7a60,
    polygon: $492183b86609249a$export$b7b19aa0ee06c73,
    polygonMumbai: $e60ec03cfca6bc86$export$34b6ef3a78067459,
    arbitrum: $7c10d207e8d5c39f$export$625cf84d855940d4,
    arbitrumGoerli: $b182faeaceab079c$export$857f1b5f596fb425,
    linea: $6fcbf55a6a0ee3d8$export$7d9a0b32b656284d,
    lineaTestnet: $6e6e4b9aba927ad2$export$9b359a3964075c2b,
    base: $bbaec386d69ac337$export$e2253033e6e1df16,
    baseGoerli: $b1381acfd3dc911e$export$8ae5747389a6ab6b,
    opBnb: $c68dba0bfcd6b9a3$var$opBnbMainnet,
    scrollSepolia: $3fcab7f5fec3898b$export$76515ac31a151681,
    scroll: $f6da5cc7f9e95595$export$209876d7b1ac8f3,
    mainnet: $5Lqmg.mainnet,
    bscTestnet: $38a8a4a6af502137$export$1c182ebff3ea4eef,
    bsc: $aa8297a11a25ced8$export$170e8cdd0c4e59c8
};
// src/EventError.ts
var $c68dba0bfcd6b9a3$var$EventError = class extends Error {
    constructor({ name: name, details: details, shortMessage: shortMessage }){
        super(`${name || "UnknownEventError"}: ${shortMessage || "Unknown error, please check the details"}`);
        this.name = name || "UnknownEventError";
        this.details = details;
        this.shortMessage = shortMessage || "Unknown error, please check the details";
    }
};
var $c68dba0bfcd6b9a3$export$6dffbda7e4d8d9cc = $c68dba0bfcd6b9a3$var$EventError;
// src/CyberWallet.ts
var $c68dba0bfcd6b9a3$var$CyberWallet = class {
    constructor({ contextWindow: contextWindow, appInfo: appInfo }){
        this.cyberAccount = null;
        this.bindedSendTransaction = this.sendTransaction.bind(this);
        this.contextWindow = contextWindow;
        this.connected = false;
        this.messenger = new $c68dba0bfcd6b9a3$var$Messenger_default({
            walletWindow: this.contextWindow,
            appInfo: appInfo
        });
        this.cyberAccount = null;
        Object.entries($c68dba0bfcd6b9a3$var$availableChains).forEach(([key, chain])=>{
            this[key] = new $c68dba0bfcd6b9a3$var$Chain_default({
                id: chain.id,
                sendTransaction: this.bindedSendTransaction,
                appId: appInfo.appId
            });
        });
    }
    setConnection(connected) {
        this.connected = connected;
    }
    setCyberAccount(cyberAccount) {
        this.cyberAccount = cyberAccount;
        localStorage.removeItem("cyber-app-sdk");
        localStorage.setItem("cyber-app-sdk", JSON.stringify(cyberAccount));
        Object.keys($c68dba0bfcd6b9a3$var$availableChains).forEach((key)=>{
            this[key].setCyberAccount(cyberAccount);
        });
    }
    resolveActionResponse(message, reject, resolve) {
        var _a, _b, _c;
        if (message.target === "CyberApp") {
            if (message.event.name === "action") {
                if ((_a = message.event.data) == null ? void 0 : _a.error) {
                    if (((_b = message.event.data) == null ? void 0 : _b.method) === "sendTransaction") reject(new $c68dba0bfcd6b9a3$export$6dffbda7e4d8d9cc({
                        name: "SendTransactionError" /* SendTransactionError */ ,
                        details: message.event.data.error,
                        shortMessage: "Transaction failed"
                    }));
                    else reject(new $c68dba0bfcd6b9a3$export$6dffbda7e4d8d9cc({
                        details: message.event.data.error
                    }));
                } else resolve((_c = message.event.data) == null ? void 0 : _c.data);
            }
        }
    }
    sendTransaction(transaction) {
        var _a;
        this.messenger.sendMessage({
            name: "action",
            data: {
                type: "request" /* Request */ ,
                method: "sendTransaction",
                data: {
                    transaction: $c68dba0bfcd6b9a3$var$__spreadProps($c68dba0bfcd6b9a3$var$__spreadValues({}, transaction), {
                        from: transaction.from || ((_a = this.cyberAccount) == null ? void 0 : _a.address)
                    })
                }
            }
        });
        return new Promise((resolve, reject)=>{
            this.messenger.onMessage((message)=>{
                this.resolveActionResponse(message, reject, resolve);
            });
        });
    }
    signMessage(message) {
        this.messenger.sendMessage({
            name: "action",
            data: {
                type: "request" /* Request */ ,
                method: "signMessage",
                data: {
                    message: message
                }
            }
        });
        return new Promise((resolve, reject)=>{
            this.messenger.onMessage((message2)=>{
                this.resolveActionResponse(message2, reject, resolve);
            });
        });
    }
    signTypedData(typedData) {
        this.messenger.sendMessage({
            name: "action",
            data: {
                type: "request" /* Request */ ,
                method: "signTypedData",
                data: {
                    typedData: typedData
                }
            }
        });
        return new Promise((resolve, reject)=>{
            this.messenger.onMessage((message)=>{
                this.resolveActionResponse(message, reject, resolve);
            });
        });
    }
    getAuthToken() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            this.messenger.sendMessage({
                name: "action",
                data: {
                    type: "request" /* Request */ ,
                    method: "getAuthToken"
                }
            });
            return new Promise((resolve, reject)=>{
                this.messenger.onMessage((message)=>{
                    this.resolveActionResponse(message, reject, resolve);
                });
            });
        });
    }
};
var $c68dba0bfcd6b9a3$export$d3f31e93d48cfbac = $c68dba0bfcd6b9a3$var$CyberWallet;
// src/CyberApp.ts
var $c68dba0bfcd6b9a3$var$CyberApp = class {
    constructor({ appId: appId, name: name, icon: icon }){
        this.appId = appId;
        this.name = name;
        this.icon = icon;
        this.cyberWallet = new $c68dba0bfcd6b9a3$export$d3f31e93d48cfbac({
            contextWindow: window.parent,
            appInfo: {
                name: name,
                icon: icon,
                appId: appId
            }
        });
        this.messenger = new $c68dba0bfcd6b9a3$var$Messenger_default({
            walletWindow: this.cyberWallet.contextWindow
        });
    }
    start() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            return yield this.connect();
        });
    }
    connect() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            this.messenger.sendMessage({
                name: "connect"
            });
            return yield new Promise((resolve, reject)=>{
                this.messenger.onMessage((message)=>{
                    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
                    if (message.target === "CyberApp") {
                        if (message.event.name === "connect") {
                            if (((_b = (_a = message.event.data) == null ? void 0 : _a.data) == null ? void 0 : _b.result) === "success") {
                                (_c = this.cyberWallet) == null || _c.setConnection(true);
                                (_f = this.cyberWallet) == null || _f.setCyberAccount((_e = (_d = message.event.data) == null ? void 0 : _d.data) == null ? void 0 : _e.cyberAccount);
                                resolve((_h = (_g = message.event.data) == null ? void 0 : _g.data) == null ? void 0 : _h.cyberAccount);
                            } else if ((_i = message.event.data) == null ? void 0 : _i.error) reject((_j = message.event.data) == null ? void 0 : _j.error);
                        }
                    }
                });
            });
        });
    }
};
var $c68dba0bfcd6b9a3$export$4e52f65f91248259 = $c68dba0bfcd6b9a3$var$CyberApp;
var $c68dba0bfcd6b9a3$var$CyberProvider = class extends (0, $ej6Nm.EventEmitter) {
    constructor({ app: app, chainId: chainId }){
        super();
        this.name = "CyberWallet";
        this.cyberApp = app;
        this.chainId = chainId;
        this.isMetaMask = false;
        this.chain = this.getChainByChainId(this.chainId);
        this._events = {};
        this.publicClient = this.setPublicClient(this.chainId);
    }
    setPublicClient(chainId) {
        const targetChain = Object.values($c68dba0bfcd6b9a3$var$availableChains).find((chain)=>chain.id === chainId);
        return targetChain ? (0, $8H2x6.createPublicClient)({
            chain: Object.values($c68dba0bfcd6b9a3$var$availableChains).find((chain)=>chain.id === chainId),
            transport: (0, $8p0q4.http)()
        }) : void 0;
    }
    connect() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            this.emit("connect", {
                chainId: `0x${this.chainId.toString(16)}`
            });
            return;
        });
    }
    disconnect() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            this.emit("disconnect", new (0, $cYDOa.ProviderDisconnectedError)(Error()));
            return;
        });
    }
    getChainKeyByChainId(chainId) {
        const chainObj = Object.entries($c68dba0bfcd6b9a3$var$availableChains).find(([_, chain])=>chain.id === chainId);
        if (!chainObj) {
            console.error(`ChainId ${chainId} is not supported.`);
            return;
        }
        return chainObj[0];
    }
    getChainByChainId(id) {
        var _a;
        const chainKey = this.getChainKeyByChainId(id);
        return chainKey ? (_a = this.cyberApp.cyberWallet) == null ? void 0 : _a[chainKey] : void 0;
    }
    request(request) {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
            const { method: method, params: params = [] } = request;
            switch(method){
                case "wallet_switchEthereumChain":
                    this.chainId = Number(params[0].chainId);
                    this.chain = this.getChainByChainId(this.chainId);
                    this.publicClient = this.setPublicClient(this.chainId);
                    this.emit("chainChanged", params[0].chainId);
                    return;
                case "personal_sign":
                    return (_a = this.cyberApp.cyberWallet) == null ? void 0 : _a.signMessage((0, $dKCgU.hexToString)(params[0]));
                case "eth_signTypedData":
                case "eth_signTypedData_v4":
                    {
                        const [address, typedData] = params;
                        const parsedTypedData = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
                        if (((_b = this.cyberApp.cyberWallet.cyberAccount) == null ? void 0 : _b.address.toLowerCase()) !== address.toLowerCase()) throw new Error("The address is invalid");
                        const signature = yield this.cyberApp.cyberWallet.signTypedData(parsedTypedData);
                        return signature || "0x";
                    }
                case "eth_chainId":
                    return `0x${this.chainId.toString(16)}`;
                case "eth_sendTransaction":
                    {
                        const data = params[0].data || "0x";
                        return (_c = this.chain) == null ? void 0 : _c.sendTransaction($c68dba0bfcd6b9a3$var$__spreadProps($c68dba0bfcd6b9a3$var$__spreadValues({}, params[0]), {
                            data: data
                        }));
                    }
                case "eth_requestAccounts":
                    if (!((_d = this.cyberApp.cyberWallet) == null ? void 0 : _d.cyberAccount)) yield this.cyberApp.connect();
                    return [
                        (_f = (_e = this.cyberApp.cyberWallet) == null ? void 0 : _e.cyberAccount) == null ? void 0 : _f.address
                    ];
                case "eth_accounts":
                    if (!((_g = this.cyberApp.cyberWallet) == null ? void 0 : _g.cyberAccount)) yield this.cyberApp.connect();
                    return [
                        (_i = (_h = this.cyberApp.cyberWallet) == null ? void 0 : _h.cyberAccount) == null ? void 0 : _i.address
                    ];
                default:
                    return yield (_j = this.publicClient) == null ? void 0 : _j.request({
                        method: method,
                        params: params
                    });
            }
        });
    }
};
var $c68dba0bfcd6b9a3$export$a923436342eb4ba8 = $c68dba0bfcd6b9a3$var$CyberProvider;
// src/utils.ts
var $c68dba0bfcd6b9a3$export$9e9c40df25ce134 = ()=>typeof document !== "undefined" && [
        "https://next.wallet.cyber.co/",
        "https://wallet-sandbox.cyber.co/",
        "https://wallet.cyber.co/",
        "https://cyberwallet-sandbox-cyberconnect.vercel.app/"
    ].includes(document.referrer);
function $c68dba0bfcd6b9a3$export$bd8c190adca392e(chainId) {
    return !Object.values($c68dba0bfcd6b9a3$var$availableChains).map((chain)=>chain.id).includes(chainId);
}
function $c68dba0bfcd6b9a3$export$d342510f9a6548c2() {
    const storage = localStorage.getItem("cyber-app-sdk");
    if (!storage) return null;
    const cyberAccountData = JSON.parse(storage);
    return cyberAccountData.ownerAddress;
}
var $c68dba0bfcd6b9a3$var$CyberWalletConnector = class extends (0, $kD2va.Connector) {
    constructor({ chains: chains, options: options_ }){
        const options = $c68dba0bfcd6b9a3$var$__spreadValues({
            shimDisconnect: false
        }, options_);
        const chainIds = chains == null ? void 0 : chains.map((chain)=>chain.id);
        super({
            chains: Object.values($c68dba0bfcd6b9a3$var$availableChains).filter((chain)=>chainIds == null ? void 0 : chainIds.includes(chain.id)),
            options: options
        });
        this.id = "cyberwallet";
        this.name = "CyberWallet";
        this.shimDisconnectKey = `${this.id}.shimDisconnect`;
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $aegFK.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = (0, $hvJ1R.normalizeChainId)(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.id = "cyberwallet";
        this.name = "CyberWallet";
        this.getProvider();
    }
    connect() {
        return $c68dba0bfcd6b9a3$var$__async(this, arguments, function*({ chainId: chainId } = {}) {
            var _a;
            try {
                const provider = yield this.getProvider();
                if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
                if (provider.on) {
                    provider.on("accountsChanged", this.onAccountsChanged);
                    provider.on("chainChanged", this.onChainChanged);
                    provider.on("disconnect", this.onDisconnect);
                }
                this.emit("message", {
                    type: "connecting"
                });
                const accounts = yield provider.request({
                    method: "eth_requestAccounts"
                });
                const account = (0, $aegFK.getAddress)(accounts[0]);
                let id = yield this.getChainId();
                let unsupported = this.isChainUnsupported(id);
                if (chainId && id !== chainId) {
                    const chain = yield this.switchChain(chainId);
                    if (chain) {
                        id = chain.id;
                        unsupported = this.isChainUnsupported(id);
                    }
                }
                if (this.options.shimDisconnect) (_a = this.storage) == null || _a.setItem(this.shimDisconnectKey, true);
                return {
                    account: account,
                    chain: {
                        id: id,
                        unsupported: unsupported
                    }
                };
            } catch (error) {
                if (this.isUserRejectedRequestError(error)) throw new (0, $cYDOa.UserRejectedRequestError)(error);
                if (error.code === -32002) throw new (0, $cYDOa.ResourceUnavailableRpcError)(error);
                throw error;
            }
        });
    }
    disconnect() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            var _a;
            const provider = yield this.getProvider();
            if (!(provider == null ? void 0 : provider.removeListener)) return;
            provider.removeListener("accountsChanged", this.onAccountsChanged);
            provider.removeListener("chainChanged", this.onChainChanged);
            provider.removeListener("disconnect", this.onDisconnect);
            if (this.options.shimDisconnect) (_a = this.storage) == null || _a.removeItem(this.shimDisconnectKey);
        });
    }
    getAccount() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            const provider = yield this.getProvider();
            if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
            const accounts = yield provider.request({
                method: "eth_accounts"
            });
            return (0, $aegFK.getAddress)(accounts[0]);
        });
    }
    getChainId() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            const provider = yield this.getProvider();
            if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
            return provider.request({
                method: "eth_chainId"
            }).then((0, $hvJ1R.normalizeChainId));
        });
    }
    getProvider() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            const isInCyberWallet = $c68dba0bfcd6b9a3$export$9e9c40df25ce134();
            if (!isInCyberWallet) console.error("Could not load CyberWallet information.");
            if (!this.provider) {
                if (!this.options.appId) throw Error("CyberWalletConnector: appId is required");
                const app = new $c68dba0bfcd6b9a3$export$4e52f65f91248259({
                    appId: this.options.appId,
                    name: this.options.name || "",
                    icon: this.options.icon || ""
                });
                const cyberProvider = new $c68dba0bfcd6b9a3$export$a923436342eb4ba8({
                    app: app,
                    chainId: this.chains[0].id
                });
                this.provider = cyberProvider;
                this.ready = true;
            }
            return this.provider;
        });
    }
    getWalletClient() {
        return $c68dba0bfcd6b9a3$var$__async(this, arguments, function*({ chainId: chainId } = {}) {
            const [provider, account] = yield Promise.all([
                this.getProvider(),
                this.getAccount()
            ]);
            const chain = this.chains.find((x)=>x.id === chainId);
            if (!provider) throw new Error("provider is required.");
            return (0, $kSNL7.createWalletClient)({
                account: account,
                chain: chain,
                transport: (0, $bCHCD.custom)(provider)
            });
        });
    }
    isAuthorized() {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            var _a;
            try {
                if (this.options.shimDisconnect && // If shim does not exist in storage, wallet is disconnected
                !((_a = this.storage) == null ? void 0 : _a.getItem(this.shimDisconnectKey))) return false;
                const account = yield this.getAccount();
                return !!account;
            } catch (e) {
                return false;
            }
        });
    }
    switchChain(chainId) {
        return $c68dba0bfcd6b9a3$var$__async(this, null, function*() {
            var _a;
            const provider = yield this.getProvider();
            if (!provider) throw new (0, $igV1L.ConnectorNotFoundError)();
            const id = (0, $7S6Nv.numberToHex)(chainId);
            try {
                yield Promise.all([
                    provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: id
                            }
                        ]
                    }),
                    new Promise((res)=>{
                        this.getChainId().then((currentChainId)=>{
                            if (currentChainId === chainId) res();
                        });
                        this.on("change", ({ chain: chain })=>{
                            if ((chain == null ? void 0 : chain.id) === chainId) res();
                        });
                    })
                ]);
                return (_a = this.chains.find((x)=>x.id === chainId)) != null ? _a : {
                    id: chainId,
                    name: `Chain ${id}`,
                    network: `${id}`,
                    nativeCurrency: {
                        name: "Ether",
                        decimals: 18,
                        symbol: "ETH"
                    },
                    rpcUrls: {
                        default: {
                            http: [
                                ""
                            ]
                        },
                        public: {
                            http: [
                                ""
                            ]
                        }
                    }
                };
            } catch (error) {
                const chain = this.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $igV1L.ChainNotConfiguredForConnectorError)({
                    chainId: chainId,
                    connectorId: this.id
                });
                else throw new (0, $cYDOa.SwitchChainError)(error);
            }
        });
    }
    isChainUnsupported(chainId) {
        return !Object.values($c68dba0bfcd6b9a3$var$availableChains).map((chain)=>chain.id).includes(chainId);
    }
    onDisconnect() {
        this.emit("disconnect");
    }
    isUserRejectedRequestError(error) {
        return error.code === 4001;
    }
};
var $c68dba0bfcd6b9a3$export$3eae8d8bf4b510b6 = $c68dba0bfcd6b9a3$var$CyberWalletConnector;



var $ej6Nm = parcelRequire("ej6Nm");
const $6276aae3c88b904d$var$ARBITRUM_CHAIN_ID = 42161;
class $6276aae3c88b904d$export$457162b143d3d8e9 extends (0, $ej6Nm.EventEmitter) {
    constructor(args){
        super();
        this.isActivationInProgress = false;
        this.autoConnect = async ()=>{
            await this.calcAccountData();
        };
        this.disconnect = ()=>{
            this.account = undefined;
        };
        this.connect = async ()=>{
            await this.calcAccountData();
        };
        this.switchChain = async (chainId)=>{
            return this.calcAccountData(chainId);
        };
        this.addChain = ()=>{
            console.warn("Method addChain not allowed");
            return null;
        };
        this.addToken = ()=>{
            console.warn("Method addToken not allowed");
            return null;
        };
        this.name = args.name;
        this.icon = args.icon;
        this.installed = args.installed;
        this.calcAccountData();
    }
    async calcAccountData(currentChainId = $6276aae3c88b904d$var$ARBITRUM_CHAIN_ID) {
        const cyberApp = new (0, $c68dba0bfcd6b9a3$export$4e52f65f91248259)({
            appId: "jumper.exchange",
            name: "Jumper.Exchange",
            icon: "https://raw.githubusercontent.com/lifinance/jumper.exchange/e9ead2e32981db0bf47adf2b1b2781e31ad14650/packages/dapp/public/logo-144x144.svg"
        });
        const cyberProvider = new (0, $c68dba0bfcd6b9a3$export$a923436342eb4ba8)({
            app: cyberApp,
            chainId: currentChainId
        });
        const provider = new (0, $5lu0X.Web3Provider)(cyberProvider, "any");
        const signer = provider.getSigner();
        this.account = {
            chainId: currentChainId,
            address: await signer.getAddress(),
            signer: signer,
            provider: provider,
            isMultisigWallet: true
        };
        this.emit("walletAccountChanged", this);
    }
}



const $be6d26b6a5a22008$var$defaultWallet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    // unknown Default wallet that injects as metamask but is not metamask
    name: "Default Wallet",
    installed: async ()=>!!window.ethereum && !window?.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).MetaMask],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).placeholder
});
const $be6d26b6a5a22008$var$metamask = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "MetaMask",
    installed: async ()=>!!window?.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).MetaMask],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).metamask
});
const $be6d26b6a5a22008$var$walletConnect = new (0, $5fb7f5c20f07e18f$export$c456b2d327ac201f)({
    name: "WalletConnect",
    installed: async ()=>true,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).walletConnect,
    options: {
        projectId: "5432e3507d41270bee46b7b85bbc2ef8",
        rpcMap: (0, $5cec60a38f74f6e4$export$65f4d498acfedc7c).reduce((rpcMap, chain)=>{
            if (chain.chainType === (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM) rpcMap[`eip155:${chain.id}`] = chain.metamask.rpcUrls[0] || "";
            return rpcMap;
        }, {}),
        chains: [
            1
        ],
        optionalChains: (0, $5cec60a38f74f6e4$export$65f4d498acfedc7c).filter((chain)=>chain.chainType === (0, $90ba2aa90df69a91$export$feb52200d964722b).EVM).map((chain)=>chain.id),
        showQrModal: true,
        qrModalOptions: {
            themeVariables: {
                "--wcm-z-index": "3000"
            }
        }
    }
});
const $be6d26b6a5a22008$var$bitGet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Bitget Wallet",
    installed: async ()=>window.bitkeep && window.bitkeep?.ethereum,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).bitGet
}, window.bitkeep?.ethereum);
const $be6d26b6a5a22008$var$gate = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Gate Wallet",
    installed: async ()=>window.gatewallet,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).gate
}, window.gatewallet);
const $be6d26b6a5a22008$var$frontier = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Frontier",
    installed: async ()=>window.frontier,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).frontier
}, window.frontier?.ethereum);
const $be6d26b6a5a22008$var$safepal = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "SafePal",
    installed: async ()=>window.safepal,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).safepal
});
const $be6d26b6a5a22008$var$brave = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Brave",
    installed: async ()=>// eslint-disable-next-line no-underscore-dangle
        navigator.brave && window._web3Ref,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).brave
});
const $be6d26b6a5a22008$var$mathWallet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "MathWallet",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).MathWallet],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).mathwallet
});
const $be6d26b6a5a22008$var$tallyho = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Taho",
    installed: async ()=>window.tally && window.tally?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).TallyHo],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).tallyho
}, window.tally);
const $be6d26b6a5a22008$var$blockWallet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "BlockWallet",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).BlockWallet],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).blockwallet
});
const $be6d26b6a5a22008$var$binance = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Binance",
    installed: async ()=>window.BinanceChain,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).binance
}, window.BinanceChain);
const $be6d26b6a5a22008$var$coinbase = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Coinbase",
    installed: async ()=>window.coinbaseWalletExtension,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).coinbase
}, window.coinbaseWalletExtension);
const $be6d26b6a5a22008$var$trust = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Trust",
    installed: async ()=>window.trustWallet,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).trust
}, window.trustWallet);
const $be6d26b6a5a22008$var$status = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Status",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).Status],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).status
});
const $be6d26b6a5a22008$var$alphawallet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "AlphaWallet",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).AlphaWallet],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).alphawallet
});
const $be6d26b6a5a22008$var$apex = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Apex Wallet",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).ApexWallet],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).placeholder
});
const $be6d26b6a5a22008$var$bitpie = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Bitpie",
    installed: async ()=>window.ethereum?.Bitpie,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).bitpie
});
const $be6d26b6a5a22008$var$dcent = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Dcent",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).Dcent],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).dcent
});
const $be6d26b6a5a22008$var$frame = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Frame",
    installed: async ()=>window.frame,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).frame
}, window.frame);
const $be6d26b6a5a22008$var$hyperpay = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "HyperPay",
    // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
    // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
    // future changes
    installed: async ()=>window.ethereum?.hiWallet,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).hyperpay
});
const $be6d26b6a5a22008$var$imtoken = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "ImToken",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).ImToken],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).imtoken
});
const $be6d26b6a5a22008$var$liquality = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Liquality",
    installed: async ()=>window.liquality,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).liquality
}, window.liquality);
const $be6d26b6a5a22008$var$ownbit = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "OwnBit",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).OwnBit],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).ownbit
});
const $be6d26b6a5a22008$var$tokenpocket = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "TokenPocket",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).TokenPocket] && !window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).TP],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).tokenpocket
});
const $be6d26b6a5a22008$var$xdefi = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "XDEFI",
    // eslint-disable-next-line dot-notation
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).XDEFI],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).xdefi
});
const $be6d26b6a5a22008$var$oneInch = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "OneInch",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).OneInch],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).oneInch
});
const $be6d26b6a5a22008$var$tokenary = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Tokenary",
    installed: async ()=>window.ethereum?.[(0, $1f71d6f239486232$export$ed1aacaf3c5fdac4).Tokenary],
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).tokenary
});
const $be6d26b6a5a22008$var$okx = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "OKX",
    installed: async ()=>window.okxwallet,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).okx
}, window.okxwallet);
const $be6d26b6a5a22008$var$rabbywallet = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Rabby Wallet",
    installed: async ()=>window.rabby,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).rabbywallet
}, window.rabby);
const $be6d26b6a5a22008$var$exodus = new (0, $ecb9ac96d2a5b6ba$export$2180bbd5f43a00b6)({
    name: "Exodus",
    installed: async ()=>window.exodus?.ethereum,
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).exodus
}, window.exodus?.ethereum);
const $be6d26b6a5a22008$var$safe = new (0, $2d55f8f7f1cec8ab$export$14207a2655efc957)({
    name: "Safe",
    installed: async ()=>{
        // in Multisig env, window.parent is not equal to window
        const isIFrameEnvironment = window?.parent !== window;
        if (!isIFrameEnvironment) return false;
        const sdk = new (0, (/*@__PURE__*/$parcel$interopDefault($6eaaae070ad95963$exports)))();
        try {
            const accountInfo = await Promise.race([
                sdk.safe.getInfo(),
                new Promise((resolve)=>setTimeout(resolve, 200))
            ]);
            return !!accountInfo?.safeAddress;
        } catch (error) {
            return false;
        }
    },
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).safe
});
const $be6d26b6a5a22008$var$cyberConnect = new (0, $6276aae3c88b904d$export$457162b143d3d8e9)({
    name: "CyberConnect",
    installed: async ()=>(0, $c68dba0bfcd6b9a3$export$9e9c40df25ce134)(),
    icon: (0, $665a39d700b3e26a$export$e5b5d3016ab484ae).cyberconnect
});
const $be6d26b6a5a22008$export$40169737307666b4 = [
    $be6d26b6a5a22008$var$defaultWallet,
    $be6d26b6a5a22008$var$safe,
    $be6d26b6a5a22008$var$metamask,
    $be6d26b6a5a22008$var$walletConnect,
    $be6d26b6a5a22008$var$bitGet,
    $be6d26b6a5a22008$var$gate,
    $be6d26b6a5a22008$var$exodus,
    $be6d26b6a5a22008$var$tallyho,
    $be6d26b6a5a22008$var$binance,
    $be6d26b6a5a22008$var$frontier,
    $be6d26b6a5a22008$var$coinbase,
    $be6d26b6a5a22008$var$okx,
    $be6d26b6a5a22008$var$trust,
    $be6d26b6a5a22008$var$status,
    $be6d26b6a5a22008$var$alphawallet,
    $be6d26b6a5a22008$var$blockWallet,
    $be6d26b6a5a22008$var$bitpie,
    $be6d26b6a5a22008$var$brave,
    $be6d26b6a5a22008$var$apex,
    $be6d26b6a5a22008$var$dcent,
    $be6d26b6a5a22008$var$frame,
    $be6d26b6a5a22008$var$hyperpay,
    $be6d26b6a5a22008$var$imtoken,
    $be6d26b6a5a22008$var$liquality,
    $be6d26b6a5a22008$var$ownbit,
    $be6d26b6a5a22008$var$tokenpocket,
    $be6d26b6a5a22008$var$xdefi,
    $be6d26b6a5a22008$var$oneInch,
    $be6d26b6a5a22008$var$tokenary,
    $be6d26b6a5a22008$var$mathWallet,
    $be6d26b6a5a22008$var$cyberConnect,
    $be6d26b6a5a22008$var$safepal,
    $be6d26b6a5a22008$var$rabbywallet
];



var $dup7A = parcelRequire("dup7A");
function $988a78e4c7be8cf3$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}


const $eb9f1c9980ab77fe$export$655aac03a2123c12 = (0, $988a78e4c7be8cf3$export$2e2bcd8739ae039)();
const $eb9f1c9980ab77fe$export$f31d65a8503b5870 = ()=>{
    return $eb9f1c9980ab77fe$export$655aac03a2123c12;
};


var $1828d6f4ded3174a$export$ce4aabad2e495c53;
(function(WidgetEvent) {
    WidgetEvent["RouteExecutionStarted"] = "routeExecutionStarted";
    WidgetEvent["RouteExecutionUpdated"] = "routeExecutionUpdated";
    WidgetEvent["RouteExecutionCompleted"] = "routeExecutionCompleted";
    WidgetEvent["RouteExecutionFailed"] = "routeExecutionFailed";
    WidgetEvent["RouteHighValueLoss"] = "routeHighValueLoss";
    WidgetEvent["RouteContactSupport"] = "routeContactSupport";
    WidgetEvent["SourceChainTokenSelected"] = "sourceChainTokenSelected";
    WidgetEvent["DestinationChainTokenSelected"] = "destinationChainTokenSelected";
    WidgetEvent["SendToWalletToggled"] = "sendToWalletToggled";
    WidgetEvent["ReviewTransactionPageEntered"] = "reviewTransactionPageEntered";
    WidgetEvent["WalletConnected"] = "walletConnected";
})($1828d6f4ded3174a$export$ce4aabad2e495c53 || ($1828d6f4ded3174a$export$ce4aabad2e495c53 = {}));



const $fdce49c427c1eae3$var$liFiWalletManagement = new (0, $2ae5e5df9f9d28fe$export$92541f0969b14674)();
const $fdce49c427c1eae3$var$stub = ()=>{
    throw new Error(`You forgot to wrap your component in <${$fdce49c427c1eae3$export$717b22fc3a2082b3.name}>.`);
};
const $fdce49c427c1eae3$var$initialContext = {
    connect: $fdce49c427c1eae3$var$stub,
    disconnect: $fdce49c427c1eae3$var$stub,
    switchChain: $fdce49c427c1eae3$var$stub,
    addChain: $fdce49c427c1eae3$var$stub,
    addToken: $fdce49c427c1eae3$var$stub,
    account: {}
};
const $fdce49c427c1eae3$var$WalletContext = (0, $dup7A.createContext)($fdce49c427c1eae3$var$initialContext);
const $fdce49c427c1eae3$export$c34addee860b0acb = ()=>(0, $dup7A.useContext)($fdce49c427c1eae3$var$WalletContext);
const $fdce49c427c1eae3$export$717b22fc3a2082b3 = ({ children: children })=>{
    const emitter = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    const { walletManagement: walletManagement } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [account, setAccount] = (0, $dup7A.useState)({});
    const [currentWallet, setCurrentWallet] = (0, $dup7A.useState)();
    const handleWalletUpdate = async (wallet)=>{
        setCurrentWallet(wallet);
        const account = await $fdce49c427c1eae3$export$420804af3f1bbcdc(wallet?.account?.signer);
        setAccount(account);
        return account;
    };
    const connect = (0, $dup7A.useCallback)(async (wallet)=>{
        if (walletManagement) {
            const signer = await walletManagement.connect();
            const account = await $fdce49c427c1eae3$export$420804af3f1bbcdc(signer);
            setAccount(account);
            emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).WalletConnected, {
                address: account.address,
                chainId: account.chainId
            });
            return;
        }
        await $fdce49c427c1eae3$var$liFiWalletManagement.connect(wallet);
        wallet.on("walletAccountChanged", handleWalletUpdate);
        const account = await handleWalletUpdate(wallet);
        emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).WalletConnected, {
            address: account.address,
            chainId: account.chainId
        });
    }, [
        emitter,
        walletManagement
    ]);
    const disconnect = (0, $dup7A.useCallback)(async ()=>{
        if (walletManagement) {
            await walletManagement.disconnect();
            setAccount({});
            return;
        }
        if (currentWallet) {
            await $fdce49c427c1eae3$var$liFiWalletManagement.disconnect(currentWallet);
            currentWallet.removeAllListeners();
            await handleWalletUpdate(undefined);
        }
    }, [
        currentWallet,
        walletManagement
    ]);
    const switchChain = (0, $dup7A.useCallback)(async (chainId)=>{
        try {
            if (walletManagement?.switchChain) {
                const signer = await walletManagement.switchChain(chainId);
                const account = await $fdce49c427c1eae3$export$420804af3f1bbcdc(signer);
                setAccount(account);
                return signer;
            } else if (!currentWallet) {
                const provider = account.signer?.provider;
                if (!provider) throw new Error(`Switch chain: No provider available`);
                await (0, $ab4607e7fa73cc99$export$15599da40e72d2f)(provider, chainId);
            } else {
                await currentWallet?.switchChain(chainId);
                await handleWalletUpdate(currentWallet);
            }
            // TODO: this will fail if it's not created with ethers 'any' network, replace with the new signer when possible
            return account.signer;
        } catch  {
            return account.signer;
        }
    }, [
        account.signer,
        currentWallet,
        walletManagement
    ]);
    const addChain = (0, $dup7A.useCallback)(async (chainId)=>{
        try {
            if (walletManagement?.addChain) return walletManagement.addChain(chainId);
            else if (!currentWallet) {
                const provider = account.signer?.provider;
                if (!provider) throw new Error(`Add chain: No provider available`);
                await (0, $ab4607e7fa73cc99$export$e648161d6b1bb565)(provider, chainId);
            } else {
                await currentWallet?.addChain(chainId);
                await handleWalletUpdate(currentWallet);
            }
            return true;
        } catch  {
            return false;
        }
    }, [
        account.signer?.provider,
        currentWallet,
        walletManagement
    ]);
    const addToken = (0, $dup7A.useCallback)(async (chainId, token)=>{
        try {
            if (walletManagement?.addToken) return walletManagement.addToken(token, chainId);
            else if (!currentWallet) {
                const provider = account.signer?.provider;
                if (!provider) throw new Error(`Add token: No provider available`);
                await (0, $ab4607e7fa73cc99$export$94064a5f8f757f28)(provider, chainId, token);
            } else {
                await currentWallet?.addToken(chainId, token);
                await handleWalletUpdate(currentWallet);
            }
        } catch  {}
    }, [
        account.signer?.provider,
        currentWallet,
        walletManagement
    ]);
    (0, $dup7A.useEffect)(()=>{
        const autoConnect = async ()=>{
            const persistedActiveWallets = (0, $7a14c0cb67726ab9$export$1916c548b8c7395d)();
            const activeWallets = (0, $be6d26b6a5a22008$export$40169737307666b4).filter((wallet)=>persistedActiveWallets.some((perstistedWallet)=>perstistedWallet.name === wallet.name));
            if (!activeWallets.length) return;
            await $fdce49c427c1eae3$var$liFiWalletManagement.autoConnect(activeWallets);
            activeWallets[0].on("walletAccountChanged", handleWalletUpdate);
            await handleWalletUpdate(activeWallets[0]);
        };
        autoConnect();
    }, []);
    // keep widget in sync with changing external signer object
    (0, $dup7A.useEffect)(()=>{
        if (walletManagement) {
            let ignore = false;
            const updateAccount = async ()=>{
                const account = await $fdce49c427c1eae3$export$420804af3f1bbcdc(walletManagement?.signer);
                // we should ignore the update if there is a newer one
                if (!ignore) setAccount(account);
            };
            updateAccount();
            return ()=>{
                ignore = true;
            };
        }
    }, [
        walletManagement
    ]);
    const value = (0, $dup7A.useMemo)(()=>({
            connect: connect,
            disconnect: disconnect,
            switchChain: switchChain,
            addChain: addChain,
            addToken: addToken,
            account: account
        }), [
        account,
        addChain,
        addToken,
        connect,
        disconnect,
        switchChain
    ]);
    return (0, $cZGFG.jsx)($fdce49c427c1eae3$var$WalletContext.Provider, {
        value: value,
        children: children
    });
};
const $fdce49c427c1eae3$export$420804af3f1bbcdc = async (signer)=>{
    try {
        return {
            address: await signer?.getAddress(),
            isActive: (signer && await signer.getAddress(), !!signer),
            signer: signer,
            chainId: await signer?.getChainId()
        };
    } catch (error) {
        console.error(error);
        return {};
    }
};


const $cf40533b594545d4$export$5d91ca4c93de7266 = (itemId, items)=>{
    if (items?.allow?.length) return items.allow.includes(itemId);
    return !items?.deny?.includes(itemId);
};


const $6cd2c58767b225c2$export$200ba097cc01f0d8 = ({ defaultValues: defaultValues })=>{
    const { fromChain: fromChain, toChain: toChain, chains: chains } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const { setValue: setValue, getValues: getValues, getFieldState: getFieldState, resetField: resetField, // Subscription to touchedFields is required by getFieldState to work
    formState: { touchedFields: touchedFields } } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const previousDefaultValues = (0, $dup7A.useRef)(defaultValues);
    // Set wallet chain as default if no chains are provided by config and if they were not changed during widget usage
    (0, $dup7A.useEffect)(()=>{
        if (!account.isActive || !account.chainId) return;
        const chainAllowed = (0, $cf40533b594545d4$export$5d91ca4c93de7266)(account.chainId, chains);
        if (!chainAllowed) return;
        const { isTouched: isFromChainTouched } = getFieldState((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain);
        const { isTouched: isToChainTouched } = getFieldState((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain);
        const { isTouched: isFromTokenTouched } = getFieldState((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken);
        const { isTouched: isToTokenTouched } = getFieldState((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken);
        const { isTouched: isFromAmountTouched } = getFieldState((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount);
        if (!fromChain && !isFromChainTouched && !isFromTokenTouched) {
            resetField((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain, {
                defaultValue: account.chainId
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain, account.chainId);
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken, "");
            if (isFromAmountTouched) setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, "");
        }
        if (!toChain && !isToChainTouched && !isToTokenTouched) {
            resetField((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain, {
                defaultValue: account.chainId
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain, account.chainId);
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken, "");
        }
    }, [
        account.chainId,
        account.isActive,
        chains,
        fromChain,
        getFieldState,
        getValues,
        resetField,
        setValue,
        toChain
    ]);
    // Makes widget config options reactive to changes
    // Acts similar to values property from useForm, but includes additional logic for chains
    (0, $dup7A.useEffect)(()=>{
        Object.keys(defaultValues).forEach((key)=>{
            if (previousDefaultValues.current[key] !== defaultValues[key]) {
                const value = defaultValues[key] || // set the chain to the current user one if it is not present in the config
                (key === (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain || key === (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain ? account.chainId || "" : "");
                setValue(key, value);
                resetField(key, {
                    defaultValue: value
                });
            }
        });
        previousDefaultValues.current = defaultValues;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultValues,
        getValues,
        resetField,
        setValue
    ]);
    return null;
};



const $872a2ff67e940b37$export$bea03992e7f3cc18 = {
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).TokenSearchFilter]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ContractOutputsToken]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractAddress]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractCallData]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractGasLimit]: "",
    [(0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAmount]: ""
};
const $872a2ff67e940b37$export$8ce1ff4f94d08846 = ({ children: children })=>{
    const { fromChain: fromChain, fromToken: fromToken, fromAmount: fromAmount, toChain: toChain, toToken: toToken, toAddress: toAddress } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const defaultValues = (0, $dup7A.useMemo)(()=>({
            ...$872a2ff67e940b37$export$bea03992e7f3cc18,
            fromChain: fromChain,
            fromToken: fromToken,
            fromAmount: (typeof fromAmount === "number" ? fromAmount?.toPrecision() : fromAmount) || $872a2ff67e940b37$export$bea03992e7f3cc18.fromAmount,
            toChain: toChain,
            toToken: toToken,
            toAddress: toAddress || $872a2ff67e940b37$export$bea03992e7f3cc18.toAddress
        }), [
        fromAmount,
        fromChain,
        fromToken,
        toAddress,
        toChain,
        toToken
    ]);
    const methods = (0, $367773295ca041ba$export$87c0cf8eb5a167e0)({
        defaultValues: // values,
        defaultValues
    });
    return (0, $cZGFG.jsxs)((0, $367773295ca041ba$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            (0, $cZGFG.jsx)((0, $6cd2c58767b225c2$export$200ba097cc01f0d8), {
                defaultValues: defaultValues
            }),
            children
        ]
    });
};


var $cZGFG = parcelRequire("cZGFG");
const $6f06d8df3b1abd2f$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $6f06d8df3b1abd2f$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $6f06d8df3b1abd2f$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $6f06d8df3b1abd2f$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $6f06d8df3b1abd2f$var$Logger(this.logger, options);
    }
}
var $6f06d8df3b1abd2f$var$baseLogger = new $6f06d8df3b1abd2f$var$Logger();
class $6f06d8df3b1abd2f$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $6f06d8df3b1abd2f$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $6f06d8df3b1abd2f$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $6f06d8df3b1abd2f$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const $6f06d8df3b1abd2f$var$lastOfPathSeparatorRegExp = /###/g;
function $6f06d8df3b1abd2f$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace($6f06d8df3b1abd2f$var$lastOfPathSeparatorRegExp, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function $6f06d8df3b1abd2f$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $6f06d8df3b1abd2f$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $6f06d8df3b1abd2f$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $6f06d8df3b1abd2f$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function $6f06d8df3b1abd2f$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $6f06d8df3b1abd2f$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $6f06d8df3b1abd2f$var$getPath(object, path) {
    const { obj: obj, k: k } = $6f06d8df3b1abd2f$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $6f06d8df3b1abd2f$var$getPathWithDefaults(data, defaultData, key) {
    const value = $6f06d8df3b1abd2f$var$getPath(data, key);
    if (value !== undefined) return value;
    return $6f06d8df3b1abd2f$var$getPath(defaultData, key);
}
function $6f06d8df3b1abd2f$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $6f06d8df3b1abd2f$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $6f06d8df3b1abd2f$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $6f06d8df3b1abd2f$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $6f06d8df3b1abd2f$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$6f06d8df3b1abd2f$var$_entityMap[s]);
    return data;
}
class $6f06d8df3b1abd2f$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $6f06d8df3b1abd2f$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $6f06d8df3b1abd2f$var$looksLikeObjectPathRegExpCache = new $6f06d8df3b1abd2f$var$RegExpCache(20);
function $6f06d8df3b1abd2f$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $6f06d8df3b1abd2f$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $6f06d8df3b1abd2f$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $6f06d8df3b1abd2f$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function $6f06d8df3b1abd2f$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $6f06d8df3b1abd2f$var$ResourceStore extends $6f06d8df3b1abd2f$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $6f06d8df3b1abd2f$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $6f06d8df3b1abd2f$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $6f06d8df3b1abd2f$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $6f06d8df3b1abd2f$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $6f06d8df3b1abd2f$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $6f06d8df3b1abd2f$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $6f06d8df3b1abd2f$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $6f06d8df3b1abd2f$var$checkedLoadedFor = {};
class $6f06d8df3b1abd2f$var$Translator extends $6f06d8df3b1abd2f$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $6f06d8df3b1abd2f$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$6f06d8df3b1abd2f$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $6f06d8df3b1abd2f$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $6f06d8df3b1abd2f$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$6f06d8df3b1abd2f$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $6f06d8df3b1abd2f$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $6f06d8df3b1abd2f$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $6f06d8df3b1abd2f$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $6f06d8df3b1abd2f$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $6f06d8df3b1abd2f$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $6f06d8df3b1abd2f$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $6f06d8df3b1abd2f$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $6f06d8df3b1abd2f$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $6f06d8df3b1abd2f$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $6f06d8df3b1abd2f$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $6f06d8df3b1abd2f$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $6f06d8df3b1abd2f$var$intlVersions = [
    "v4"
];
const $6f06d8df3b1abd2f$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $6f06d8df3b1abd2f$var$createRules() {
    const rules = {};
    $6f06d8df3b1abd2f$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $6f06d8df3b1abd2f$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $6f06d8df3b1abd2f$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $6f06d8df3b1abd2f$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $6f06d8df3b1abd2f$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($6f06d8df3b1abd2f$var$getCleanedCode(code === "dev" ? "en" : code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$6f06d8df3b1abd2f$var$suffixesOrder[pluralCategory1] - $6f06d8df3b1abd2f$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$6f06d8df3b1abd2f$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $6f06d8df3b1abd2f$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $6f06d8df3b1abd2f$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $6f06d8df3b1abd2f$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $6f06d8df3b1abd2f$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $6f06d8df3b1abd2f$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $6f06d8df3b1abd2f$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $6f06d8df3b1abd2f$var$regexEscape(prefix) : prefixEscaped || "{{";
        this.suffix = suffix ? $6f06d8df3b1abd2f$var$regexEscape(suffix) : suffixEscaped || "}}";
        this.formatSeparator = formatSeparator || ",";
        this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
        this.nestingPrefix = nestingPrefix ? $6f06d8df3b1abd2f$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $6f06d8df3b1abd2f$var$regexEscape("$t(");
        this.nestingSuffix = nestingSuffix ? $6f06d8df3b1abd2f$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $6f06d8df3b1abd2f$var$regexEscape(")");
        this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $6f06d8df3b1abd2f$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($6f06d8df3b1abd2f$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $6f06d8df3b1abd2f$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $6f06d8df3b1abd2f$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $6f06d8df3b1abd2f$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $6f06d8df3b1abd2f$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($6f06d8df3b1abd2f$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $6f06d8df3b1abd2f$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $6f06d8df3b1abd2f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $6f06d8df3b1abd2f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $6f06d8df3b1abd2f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $6f06d8df3b1abd2f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $6f06d8df3b1abd2f$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $6f06d8df3b1abd2f$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $6f06d8df3b1abd2f$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $6f06d8df3b1abd2f$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $6f06d8df3b1abd2f$var$Connector extends $6f06d8df3b1abd2f$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $6f06d8df3b1abd2f$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $6f06d8df3b1abd2f$var$pushPath(q.loaded, [
                lng
            ], ns);
            $6f06d8df3b1abd2f$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $6f06d8df3b1abd2f$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $6f06d8df3b1abd2f$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $6f06d8df3b1abd2f$var$noop() {}
function $6f06d8df3b1abd2f$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $6f06d8df3b1abd2f$var$I18n extends $6f06d8df3b1abd2f$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $6f06d8df3b1abd2f$var$transformOptions(options);
        this.services = {};
        this.logger = $6f06d8df3b1abd2f$var$baseLogger;
        this.modules = {
            external: []
        };
        $6f06d8df3b1abd2f$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $6f06d8df3b1abd2f$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$6f06d8df3b1abd2f$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $6f06d8df3b1abd2f$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $6f06d8df3b1abd2f$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $6f06d8df3b1abd2f$var$Formatter;
            const lu = new $6f06d8df3b1abd2f$var$LanguageUtil(this.options);
            this.store = new $6f06d8df3b1abd2f$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $6f06d8df3b1abd2f$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $6f06d8df3b1abd2f$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $6f06d8df3b1abd2f$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $6f06d8df3b1abd2f$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $6f06d8df3b1abd2f$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $6f06d8df3b1abd2f$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $6f06d8df3b1abd2f$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6f06d8df3b1abd2f$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $6f06d8df3b1abd2f$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $6f06d8df3b1abd2f$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $6f06d8df3b1abd2f$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $6f06d8df3b1abd2f$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $6f06d8df3b1abd2f$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $6f06d8df3b1abd2f$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $6f06d8df3b1abd2f$var$LanguageUtil($6f06d8df3b1abd2f$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $6f06d8df3b1abd2f$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6f06d8df3b1abd2f$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $6f06d8df3b1abd2f$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $6f06d8df3b1abd2f$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $6f06d8df3b1abd2f$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $6f06d8df3b1abd2f$export$2e2bcd8739ae039 = $6f06d8df3b1abd2f$var$I18n.createInstance();
$6f06d8df3b1abd2f$export$2e2bcd8739ae039.createInstance = $6f06d8df3b1abd2f$var$I18n.createInstance;
const $6f06d8df3b1abd2f$export$99152e8d49ca4e7d = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.createInstance;
const $6f06d8df3b1abd2f$export$147ec2801e896265 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.dir;
const $6f06d8df3b1abd2f$export$2cd8252107eb640b = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.init;
const $6f06d8df3b1abd2f$export$d3d08d944062d7e = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.loadResources;
const $6f06d8df3b1abd2f$export$a5d9bf5d83fcab09 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.reloadResources;
const $6f06d8df3b1abd2f$export$1f96ae73734a86cc = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.use;
const $6f06d8df3b1abd2f$export$61465194746e7fd2 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.changeLanguage;
const $6f06d8df3b1abd2f$export$f90d180fc7da3b3b = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.getFixedT;
const $6f06d8df3b1abd2f$export$625550452a3fa3ec = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.t;
const $6f06d8df3b1abd2f$export$f7e9f41ea797a17 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.exists;
const $6f06d8df3b1abd2f$export$2b4b218e406d2d00 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.setDefaultNamespace;
const $6f06d8df3b1abd2f$export$93d9ee97c1ad3f31 = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.hasLoadedNamespace;
const $6f06d8df3b1abd2f$export$83be934b53fff43b = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.loadNamespaces;
const $6f06d8df3b1abd2f$export$8cd7e7a54fa865bc = $6f06d8df3b1abd2f$export$2e2bcd8739ae039.loadLanguages;




var $9bf43b2659564b51$var$arr = [];
var $9bf43b2659564b51$var$each = $9bf43b2659564b51$var$arr.forEach;
var $9bf43b2659564b51$var$slice = $9bf43b2659564b51$var$arr.slice;
function $9bf43b2659564b51$var$defaults(obj) {
    $9bf43b2659564b51$var$each.call($9bf43b2659564b51$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $9bf43b2659564b51$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $9bf43b2659564b51$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$9bf43b2659564b51$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$9bf43b2659564b51$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $9bf43b2659564b51$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $9bf43b2659564b51$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $9bf43b2659564b51$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $9bf43b2659564b51$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $9bf43b2659564b51$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $9bf43b2659564b51$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $9bf43b2659564b51$var$hasLocalStorageSupport = null;
var $9bf43b2659564b51$var$localStorageAvailable = function localStorageAvailable() {
    if ($9bf43b2659564b51$var$hasLocalStorageSupport !== null) return $9bf43b2659564b51$var$hasLocalStorageSupport;
    try {
        $9bf43b2659564b51$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $9bf43b2659564b51$var$hasLocalStorageSupport = false;
    }
    return $9bf43b2659564b51$var$hasLocalStorageSupport;
};
var $9bf43b2659564b51$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $9bf43b2659564b51$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $9bf43b2659564b51$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $9bf43b2659564b51$var$hasSessionStorageSupport = null;
var $9bf43b2659564b51$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($9bf43b2659564b51$var$hasSessionStorageSupport !== null) return $9bf43b2659564b51$var$hasSessionStorageSupport;
    try {
        $9bf43b2659564b51$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $9bf43b2659564b51$var$hasSessionStorageSupport = false;
    }
    return $9bf43b2659564b51$var$hasSessionStorageSupport;
};
var $9bf43b2659564b51$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $9bf43b2659564b51$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $9bf43b2659564b51$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $9bf43b2659564b51$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $9bf43b2659564b51$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $9bf43b2659564b51$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $9bf43b2659564b51$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $9bf43b2659564b51$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $9bf43b2659564b51$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $9bf43b2659564b51$var$defaults(options, this.options || {}, $9bf43b2659564b51$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($9bf43b2659564b51$var$cookie$1);
                this.addDetector($9bf43b2659564b51$var$querystring);
                this.addDetector($9bf43b2659564b51$var$localStorage);
                this.addDetector($9bf43b2659564b51$var$sessionStorage);
                this.addDetector($9bf43b2659564b51$var$navigator$1);
                this.addDetector($9bf43b2659564b51$var$htmlTag);
                this.addDetector($9bf43b2659564b51$var$path);
                this.addDetector($9bf43b2659564b51$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$9bf43b2659564b51$export$2e2bcd8739ae039.type = "languageDetector";



var $dup7A = parcelRequire("dup7A");

var $470f6ee0348b2c2f$exports = {};

$parcel$export($470f6ee0348b2c2f$exports, "bn", () => (/*@__PURE__*/$parcel$interopDefault($3e90eb3274eef0d4$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "de", () => (/*@__PURE__*/$parcel$interopDefault($547e4bb4d009cfd5$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "en", () => (/*@__PURE__*/$parcel$interopDefault($020e0b7a698d0af6$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "es", () => (/*@__PURE__*/$parcel$interopDefault($6d5e81dc2915c161$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "fr", () => (/*@__PURE__*/$parcel$interopDefault($c973622418f315a6$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "id", () => (/*@__PURE__*/$parcel$interopDefault($1ec7c7fd0fce1b9f$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "it", () => (/*@__PURE__*/$parcel$interopDefault($056a48947ac3d428$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "ko", () => (/*@__PURE__*/$parcel$interopDefault($e7631cbad3f30538$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "pt", () => (/*@__PURE__*/$parcel$interopDefault($76aa1cc1836a1d30$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "th", () => (/*@__PURE__*/$parcel$interopDefault($3178763582914df2$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "tr", () => (/*@__PURE__*/$parcel$interopDefault($17ee69e88425329d$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "uk", () => (/*@__PURE__*/$parcel$interopDefault($ef3b0edefb0433b5$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "vi", () => (/*@__PURE__*/$parcel$interopDefault($f422c8dd25836285$exports)));
$parcel$export($470f6ee0348b2c2f$exports, "zh", () => (/*@__PURE__*/$parcel$interopDefault($18c973451ffe3269$exports)));
var $3e90eb3274eef0d4$exports = {};
$3e90eb3274eef0d4$exports = JSON.parse('{"button":{"auto":"\u09B8\u09CD\u09AC\u09AF\u09BC\u0982\u0995\u09CD\u09B0\u09BF\u09AF\u09BC","cancel":"\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8","connectWallet":"\u0993\u09DF\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09C1\u09A8","contactSupport":"\u09B8\u09BE\u09AA\u09CB\u09B0\u09CD\u099F \u098F \u09AF\u09CB\u0997\u09BE\u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8","continue":"\u098F\u0997\u09BF\u09DF\u09C7 \u09AF\u09BE\u09A8","copyAddress":"\u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u0995\u09AA\u09BF \u0995\u09B0\u09C1\u09A8","dark":"\u0985\u09A8\u09CD\u09A7\u0995\u09BE\u09B0","delete":"\u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09C1\u09A8","disconnect":"\u09B8\u0982\u09AF\u09CB\u0997 \u09AC\u09BF\u099A\u09CD\u099B\u09BF\u09A8\u09CD\u09A8 \u0995\u09B0\u09C1\u09A8","done":"\u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09DF\u09C7\u099B\u09C7","getGas":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09AA\u09BE\u09A8","hide":"\u0997\u09CB\u09AA\u09A8 \u0995\u09B0\u09C1\u09A8","learnMore":"\u0986\u09B0\u0993 \u099C\u09BE\u09A8\u09C1\u09A8","lifiSwap":"\u09B2\u09BF.\u09AB\u09BE\u0987 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA","light":"\u09B2\u09BE\u0987\u099F","max":"\u09B8\u09B0\u09CD\u09AC\u09CB\u099A\u09CD\u099A","ok":"\u09A0\u09BF\u0995 \u0986\u099B\u09C7","okay":"\u09A0\u09BF\u0995 \u0986\u099B\u09C7","removeSwap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09B0\u09BE\u09A8","reset":"\u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u09B8\u09C7\u099F \u0995\u09B0\u09C1\u09A8","resetSettings":"\u09B8\u09C7\u099F\u09BF\u0982\u09B8 \u09B0\u09BF\u09B8\u09C7\u099F \u0995\u09B0\u09C1\u09A8","restartSwap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u099A\u09BE\u09B2\u09C1 \u0995\u09B0\u09C1\u09A8","reviewGasSwap":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AA\u09B0\u09CD\u09AF\u09BE\u09B2\u09CB\u099A\u09A8\u09BE \u0995\u09B0\u09C1\u09A8","reviewSwap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AA\u09B0\u09CD\u09AF\u09BE\u09B2\u09CB\u099A\u09A8\u09BE \u0995\u09B0\u09C1\u09A8","seeDetails":"\u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4 \u09A6\u09C7\u0996\u09C1\u09A8","showAll":"\u09B8\u09AC\u0997\u09C1\u09B2\u09CB \u09A6\u09C7\u0996\u09C1\u09A8","startGasSwap":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09B0\u09C1\u09A8","startSwap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B6\u09C1\u09B0\u09C1 \u0995\u09B0\u09C1\u09A8","swap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA","tryAgain":"\u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8","viewCoverage":"\u0995\u09AD\u09BE\u09B0\u09C7\u099C \u09A6\u09C7\u0996\u09C1\u09A8","viewOnExplorer":"\u098F\u0995\u09CD\u09B8\u09AA\u09CD\u09B2\u09CB\u09B0\u09BE\u09B0\u09C7 \u09A6\u09C7\u0996\u09C1\u09A8"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"header":{"activeSwaps":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC","checkout":"\u099A\u09C7\u0995\u0986\u0989\u099F","from":"\u09A5\u09C7\u0995\u09C7 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09B0\u09C1\u09A8","gas":"\u0997\u09CD\u09AF\u09BE\u09B8","gasSwap":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA","routes":"\u0986\u09AA\u09A8\u09BF \u09AA\u09BE\u09A8","selectChain":"\u099A\u09C7\u0987\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","selectWallet":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09DF\u09BE\u09B2\u09C7\u099F \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","settings":"\u09B8\u09C7\u099F\u09BF\u0982\u09B8","swap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA","swapDetails":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4","swapHistory":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0987\u09A4\u09BF\u09B9\u09BE\u09B8","to":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09B0\u09C1\u09A8","walletConnected":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4"},"language":{"name":"\u09AC\u09BE\u0982\u09B2\u09BE","title":"\u09AD\u09BE\u09B7\u09BE"},"settings":{"enabledBridges":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC","enabledExchanges":"\u098F\u0995\u09CD\u09B8\u099A\u09C7\u099E\u09CD\u099C \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC","gasPrice":{"fast":"\u09A6\u09CD\u09B0\u09C1\u09A4","normal":"\u09B8\u09CD\u09AC\u09BE\u09AD\u09BE\u09AC\u09BF\u0995","slow":"\u09A7\u09C0\u09B0\u09C7","title":"\u0997\u09CD\u09AF\u09BE\u09B8\u09C7\u09B0 \u09A6\u09BE\u09AE"},"routePriority":"\u09B0\u09C1\u099F \u0985\u0997\u09CD\u09B0\u09BE\u09A7\u09BF\u0995\u09BE\u09B0","showDestinationWallet":"\u0997\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF \u0993\u09DF\u09BE\u09B2\u09C7\u099F \u09A6\u09C7\u0996\u09BE\u09A8","slippage":"\u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C"},"info":{"message":{"autoRefuel":"\u0986\u09AA\u09A8\u09BE\u09B0 {{chainName}} \u0997\u09CD\u09AF\u09BE\u09B8 \u0995\u09AE\u0964 \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u0993\u09AF\u09BC\u09BE\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7, \u0986\u09AA\u09A8\u09BF \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0995\u09B0\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u09AA\u09B0\u09CD\u09AF\u09BE\u09AA\u09CD\u09A4 \u0997\u09CD\u09AF\u09BE\u09B8 \u09AA\u09BE\u09AC\u09C7\u09A8\u0964","emptyActiveSwaps":"\u09AA\u09CD\u09B0\u0997\u09A4\u09BF\u09A4\u09C7 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u098F\u0996\u09BE\u09A8\u09C7 \u09AA\u09CD\u09B0\u09A6\u09B0\u09CD\u09B6\u09BF\u09A4 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09AC\u09BE\u09B0 \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u09B9\u09B2\u09C7, \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0987\u09A4\u09BF\u09B9\u09BE\u09B8\u09C7 \u09A4\u09BE\u09A6\u09C7\u09B0 \u0996\u09C1\u0981\u099C\u09C1\u09A8\u0964","emptySwapHistory":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 \u09B8\u09CD\u09A5\u09BE\u09A8\u09C0\u09AF\u09BC\u09AD\u09BE\u09AC\u09C7 \u09B8\u0982\u09B0\u0995\u09CD\u09B7\u09A3 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC \u098F\u09AC\u0982 \u0986\u09AA\u09A8\u09BF \u09AF\u09A6\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u09AC\u09CD\u09B0\u09BE\u0989\u099C\u09BE\u09B0 \u09A1\u09C7\u099F\u09BE \u09B8\u09BE\u09AB \u0995\u09B0\u09C7\u09A8 \u09A4\u09BE\u09B9\u09B2\u09C7 \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09BE \u09B9\u09AC\u09C7\u0964","emptyTokenList":"\u0986\u09AE\u09B0\u09BE {{chainName}} \u099A\u09C7\u0987\u09A8\u09C7 \u099F\u09CB\u0995\u09C7\u09A8 \u0996\u09C1\u0981\u099C\u09C7 \u09AA\u09BE\u0987\u09A8\u09BF \u09AC\u09BE \u0986\u09AA\u09A8\u09BE\u09B0 \u0995\u09BE\u099B\u09C7 \u09A8\u09C7\u0987\u0964 \u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AC\u09BE\u09B0 \u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8 \u09AC\u09BE \u0985\u09A8\u09CD\u09AF \u098F\u0995\u099F\u09BF \u099A\u09C7\u0987\u09A8 \u09AA\u099B\u09A8\u09CD\u09A6 \u0995\u09B0\u09C1\u09A8\u0964","routeNotFound":"\u0985\u09A8\u09CD\u09AF \u099F\u09CB\u0995\u09C7\u09A8 \u09B8\u09AE\u09A8\u09CD\u09AC\u09AF\u09BC \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8\u0964"},"title":{"autoRefuel":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09AA\u09BE\u09A8","emptyActiveSwaps":"\u0995\u09CB\u09A8\u09CB \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09A8\u09C7\u0987","emptySwapHistory":"\u0995\u09CB\u09A8\u09CB \u09B8\u09BE\u09AE\u09CD\u09AA\u09CD\u09B0\u09A4\u09BF\u0995 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09A8\u09C7\u0987\u0964","routeNotFound":"\u0995\u09CB\u09A8 \u09B0\u09C1\u099F \u0989\u09AA\u09B2\u09AC\u09CD\u09A7"}},"success":{"message":{"swapPartiallySuccessful":"\u0986\u09AE\u09B0\u09BE \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0995\u09B0\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C7\u099B\u09BF, \u0995\u09BF\u09A8\u09CD\u09A4\u09C1 {{tokenSymbol}} \u099F\u09CB\u0995\u09C7\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF {{tool}} -\u098F\u09B0 \u09B2\u09BF\u0995\u09C1\u0987\u09A1\u09BF\u099F\u09BF \u09AB\u09C1\u09B0\u09BF\u09AF\u09BC\u09C7 \u0997\u09C7\u099B\u09C7\u0964","swapSuccessful":"\u098F\u0996\u09A8 {{chainName}} \u099A\u09C7\u0987\u09A8\u09C7 {{walletAddress}} \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u0986\u099B\u09C7\u0964"},"title":{"gasSwapSuccessful":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AB\u09B2","refundIssued":"\u09B0\u09BF\u09AB\u09BE\u09A8\u09CD\u09A1 \u099C\u09BE\u09B0\u09BF \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","swapPartiallySuccessful":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0986\u0982\u09B6\u09BF\u0995\u09AD\u09BE\u09AC\u09C7 \u09B8\u09AB\u09B2","swapSuccessful":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AB\u09B2"}},"warning":{"message":{"deleteActiveSwaps":"\u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 \u09B8\u09CD\u09A5\u09BE\u09A8\u09C0\u09AF\u09BC\u09AD\u09BE\u09AC\u09C7 \u09B8\u0982\u09B0\u0995\u09CD\u09B7\u09A3 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC \u098F\u09AC\u0982 \u09AF\u09A6\u09BF \u0986\u09AA\u09A8\u09BF \u09B8\u09C7\u0997\u09C1\u09B2\u09BF \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09C7\u09A8 \u09A4\u09AC\u09C7 \u09AA\u09C1\u09A8\u09B0\u09C1\u09A6\u09CD\u09A7\u09BE\u09B0 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7 \u09A8\u09BE\u0964","deleteSwapHistory":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 \u09B8\u09CD\u09A5\u09BE\u09A8\u09C0\u09AF\u09BC\u09AD\u09BE\u09AC\u09C7 \u09B8\u0982\u09B0\u0995\u09CD\u09B7\u09A3 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC \u098F\u09AC\u0982 \u0986\u09AA\u09A8\u09BF \u098F\u099F\u09BF \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09B2\u09C7 \u09AA\u09C1\u09A8\u09B0\u09C1\u09A6\u09CD\u09A7\u09BE\u09B0 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7 \u09A8\u09BE\u0964","highValueLoss":"\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u099F\u09CB\u0995\u09C7\u09A8\u0997\u09C1\u09B2\u09BF\u09B0 \u09AE\u09BE\u09A8 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09B0\u09BE \u099F\u09CB\u0995\u09C7\u09A8 \u098F\u09AC\u0982 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u0996\u09B0\u099A\u09C7\u09B0 \u09A4\u09C1\u09B2\u09A8\u09BE\u09AF\u09BC \u0989\u09B2\u09CD\u09B2\u09C7\u0996\u09AF\u09CB\u0997\u09CD\u09AF\u09AD\u09BE\u09AC\u09C7 \u0995\u09AE\u0964","insufficientFunds":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0995\u09B0\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AA\u09A8\u09BE\u09B0 \u0995\u09BE\u099B\u09C7 \u09AA\u09B0\u09CD\u09AF\u09BE\u09AA\u09CD\u09A4 \u09A4\u09B9\u09AC\u09BF\u09B2 \u09A8\u09C7\u0987\u0964","insufficientGas":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0995\u09B0\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AA\u09A8\u09BE\u09B0 \u0995\u09BE\u099B\u09C7 \u09AA\u09B0\u09CD\u09AF\u09BE\u09AA\u09CD\u09A4 \u0997\u09CD\u09AF\u09BE\u09B8 \u09A8\u09C7\u0987\u0964 \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u0985\u09A8\u09CD\u09A4\u09A4 \u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7:","rateChanged":"\u09AC\u09BF\u09A8\u09BF\u09AE\u09AF\u09BC \u09B9\u09BE\u09B0 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u0964 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u0993\u09AF\u09BC\u09BE\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7, \u0986\u09AA\u09A8\u09BF \u09A8\u09A4\u09C1\u09A8 \u09B9\u09BE\u09B0 \u0997\u09CD\u09B0\u09B9\u09A3 \u0995\u09B0\u09AC\u09C7\u09A8\u0964","resetSettings":"\u098F\u099F\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u09B0\u09C1\u099F\u09C7\u09B0 \u0985\u0997\u09CD\u09B0\u09BE\u09A7\u09BF\u0995\u09BE\u09B0, \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C, \u0997\u09CD\u09AF\u09BE\u09B8\u09C7\u09B0 \u09A6\u09BE\u09AE, \u09B8\u0995\u09CD\u09B7\u09AE \u09AC\u09CD\u09B0\u09BF\u099C \u098F\u09AC\u0982 \u098F\u0995\u09CD\u09B8\u099A\u09C7\u099E\u09CD\u099C \u09B0\u09BF\u09B8\u09C7\u099F \u0995\u09B0\u09AC\u09C7\u0964"},"title":{"deleteActiveSwaps":"\u09B8\u09AE\u09B8\u09CD\u09A4 \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AE\u09C1\u099B\u09AC\u09C7\u09A8?","deleteSwap":"\u098F\u0987 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09AC\u09C7\u09A8?","deleteSwapHistory":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09AE\u09C1\u099B\u09AC\u09C7\u09A8?","highValueLoss":"\u0989\u099A\u09CD\u099A \u09AE\u09C2\u09B2\u09CD\u09AF \u0995\u09CD\u09B7\u09A4\u09BF","insufficientGas":"\u0985\u09AA\u09B0\u09CD\u09AF\u09BE\u09AA\u09CD\u09A4 \u0997\u09CD\u09AF\u09BE\u09B8","rateChanged":"\u09B9\u09BE\u09B0 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","resetSettings":"\u09B0\u09BF\u09B8\u09C7\u099F \u09B8\u09C7\u099F\u09BF\u0982\u09B8?"}},"error":{"message":{"slippageThreshold":"\u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09B8\u0982\u099C\u09CD\u099E\u09BE\u09AF\u09BC\u09BF\u09A4 \u09A5\u09CD\u09B0\u09C7\u09B6\u09B9\u09CB\u09B2\u09CD\u09A1\u09C7\u09B0 \u099A\u09C7\u09AF\u09BC\u09C7 \u09AC\u09A1\u09BC\u0964 \u098F\u0995\u099F\u09BF \u09A8\u09A4\u09C1\u09A8 \u0989\u09A6\u09CD\u09A7\u09C3\u09A4\u09BF \u09AA\u09C7\u09A4\u09C7 \u098F\u0995\u099F\u09BF \u09A8\u09A4\u09C1\u09A8 \u09B0\u09C1\u099F \u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u0995\u09B0\u09C1\u09A8\u0964","transactionFailed":"\u0986\u09B0\u0993 \u09A4\u09A5\u09CD\u09AF\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u09AC\u09CD\u09B2\u0995 \u098F\u0995\u09CD\u09B8\u09AA\u09CD\u09B2\u09CB\u09B0\u09BE\u09B0 \u099A\u09C7\u0995 \u0995\u09B0\u09C1\u09A8\u0964","transactionNotSent":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AA\u09BE\u09A0\u09BE\u09A8\u09CB \u09B9\u09AF\u09BC\u09A8\u09BF\u0964 \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} \u09A5\u09C7\u0995\u09C7 \u09AF\u09BE\u09AF\u09BC\u0964","transactionRejected":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0995\u09B0\u09A4\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09B8\u09CD\u09AC\u09BE\u0995\u09CD\u09B7\u09B0 \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u0964 \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} \u09A5\u09C7\u0995\u09C7 \u09AF\u09BE\u09AF\u09BC\u0964","unknown":"\u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8 \u09AC\u09BE \u09B8\u09BE\u09AA\u09CB\u09B0\u09CD\u099F \u098F\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09AF\u09CB\u0997\u09BE\u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8\u0964"},"title":{"balanceIsTooLow":"\u09AC\u09CD\u09AF\u09BE\u09B2\u09C7\u09A8\u09CD\u09B8 \u0996\u09C1\u09AC \u0995\u09AE","chainSwitch":"\u099A\u09C7\u0987\u09A8 \u09B8\u09C1\u0987\u099A \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8","failed":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","gasLimitIsTooLow":"\u0997\u09CD\u09AF\u09BE\u09B8\u09C7\u09B0 \u09B8\u09C0\u09AE\u09BE \u0996\u09C1\u09AC \u0995\u09AE","slippageNotMet":"\u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09B6\u09B0\u09CD\u09A4 \u09AA\u09C2\u09B0\u09A3 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09A8\u09BF","transactionCanceled":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","transactionFailed":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","transactionRejected":"\u09B8\u09CD\u09AC\u09BE\u0995\u09CD\u09B7\u09B0 \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8","transactionUnderpriced":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u09A6\u09BE\u09AE \u0995\u09AE","transactionUnprepared":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AA\u09CD\u09B0\u09B8\u09CD\u09A4\u09C1\u09A4 \u0995\u09B0\u09A4\u09C7 \u0985\u0995\u09CD\u09B7\u09AE","unknown":"\u0995\u09BF\u099B\u09C1 \u09AD\u09C1\u09B2 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","walletAddressInvalid":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u0985\u09AC\u09C8\u09A7\u0964","walletAddressRequired":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u0964","walletEnsAddressInvalid":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u0985\u09AC\u09C8\u09A7 \u09AC\u09BE \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u0987\u098F\u09A8\u098F\u09B8 \u09B8\u09AE\u09B0\u09CD\u09A5\u09A8 \u0995\u09B0\u09C7 \u09A8\u09BE\u0964"}},"main":{"crossStepDetails":"{{tool}} \u09B9\u09AF\u09BC\u09C7 {{from}} \u09A5\u09C7\u0995\u09C7 {{to}} \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09CD\u09B0\u09BF\u099C","currentAmount":"\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3","estimatedTime":"{{value}}\u09AE\u09BF","featuredTokens":"\u09AC\u09C8\u09B6\u09BF\u09B7\u09CD\u099F\u09CD\u09AF\u09AF\u09C1\u0995\u09CD\u09A4 \u099F\u09CB\u0995\u09C7\u09A8","from":"\u09A5\u09C7\u0995\u09C7","fromAmount":"\u0986\u09AA\u09A8\u09BF \u099F\u09BE\u0995\u09BE \u09AA\u09BE\u09A0\u09BE\u09A8","gasCost":"\u0997\u09CD\u09AF\u09BE\u09B8 \u0996\u09B0\u099A","gasFeeEstimated":"\u0986\u09A8\u09C1\u09AE\u09BE\u09A8\u09BF\u0995 \u0997\u09CD\u09AF\u09BE\u09B8 \u09AB\u09BF","gasFeePaid":"\u0997\u09CD\u09AF\u09BE\u09B8 \u09AB\u09BF \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC","inProgress":"\u09AA\u09CD\u09B0\u0995\u09CD\u09B0\u09BF\u09AF\u09BC\u09BE\u09A7\u09C0\u09A8","nftStepDetails":"{{tool}} \u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 \u098F\u09A8\u098F\u09AB\u099F\u09BF \u0995\u09BF\u09A8\u09C1\u09A8","onChain":"{{chainName}} -\u098F","otherTokens":"\u0985\u09A8\u09CD\u09AF\u09BE\u09A8\u09CD\u09AF \u099F\u09CB\u0995\u09C7\u09A8","ownedBy":"\u09AE\u09BE\u09B2\u09BF\u0995","payWith":"\u09AA\u09C7 \u09A6\u09BF\u09A4\u09C7","process":{"crossChain":{"actionRequired":"\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09B8\u09CD\u09AC\u09BE\u0995\u09CD\u09B7\u09B0 \u0995\u09B0\u09C1\u09A8","done":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","pending":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u099B\u09C7","started":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u09AA\u09CD\u09B0\u09B8\u09CD\u09A4\u09C1\u09A4\u09BF"},"receivingChain":{"done":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","partial":"\u09AC\u09CD\u09B0\u09BF\u099C \u0986\u0982\u09B6\u09BF\u0995\u09AD\u09BE\u09AC\u09C7 \u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","pending":"\u0997\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF \u099A\u09C7\u0987\u09A8 \u098F\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE","refunded":"\u09AC\u09CD\u09B0\u09BF\u099C \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AB\u09C7\u09B0\u09A4 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7"},"swap":{"actionRequired":"\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09B8\u09CD\u09AC\u09BE\u0995\u09CD\u09B7\u09B0 \u0995\u09B0\u09C1\u09A8","done":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","pending":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","started":"\u09B8\u09CB\u09AF\u09BC\u09BE\u09AA \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AA\u09CD\u09B0\u09B8\u09CD\u09A4\u09C1\u09A4 \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7"},"switchChain":{"actionRequired":"\u099A\u09C7\u0987\u09A8 \u09B8\u09C1\u0987\u099A \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8","done":"\u099A\u09C7\u0987\u09A8 \u09B8\u09AB\u09B2\u09AD\u09BE\u09AC\u09C7 \u09B8\u09C1\u0987\u099A \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7"},"tokenAllowance":{"done":"\u099F\u09CB\u0995\u09C7\u09A8 \u0985\u09A8\u09C1\u09AE\u09A4\u09BF \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09BF\u09A4","pending":"\u099F\u09CB\u0995\u09C7\u09A8 \u0985\u09A8\u09C1\u09AE\u09A4\u09BF\u09B0 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE\u09AF\u09BC","started":"\u099F\u09CB\u0995\u09C7\u09A8 \u0985\u09A8\u09C1\u09AE\u09A4\u09BF\u09B0 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE\u09AF\u09BC"}},"quotedAmount":"\u0989\u09A6\u09CD\u09A7\u09C3\u09A4 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3","rateChange":"\u09B0\u09C7\u099F \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8","receiving":"\u09B0\u09BF\u09B8\u09BF\u09AD\u09BF\u0982","refuelStepDetails":"{{tool}} \u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 \u0997\u09CD\u09AF\u09BE\u09B8 \u09AA\u09BE\u09A8","routes":"\u0986\u09AA\u09A8\u09BF \u09AA\u09BE\u09A8","selectChain":"\u099A\u09C7\u0987\u09A8","selectChainAndToken":"\u099A\u09C7\u0987\u09A8 \u098F\u09AC\u0982 \u099F\u09CB\u0995\u09C7\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","selectToken":"\u099F\u09CB\u0995\u09C7\u09A8","sendToAddress":"{{address}} \u098F \u09AA\u09BE\u09A0\u09BE\u09A8","sendToWallet":"\u0985\u09A8\u09CD\u09AF \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 \u09AA\u09BE\u09A0\u09BE\u09A8","sentToAddress":"{{address}} \u098F \u09AA\u09BE\u09A0\u09BE\u09A8\u09CB \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","stepBridge":"\u09AC\u09CD\u09B0\u09BF\u099C","stepDetails":"\u09B2\u09BF.\u09AB\u09BE\u0987 \u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 {{tool}}","stepSwap":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA","stepSwapAndBridge":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u098F\u09AC\u0982 \u09AC\u09CD\u09B0\u09BF\u099C","supportId":"\u09B8\u09BE\u09AA\u09CB\u09B0\u09CD\u099F \u0986\u0987\u09A1\u09BF","swapStepDetails":"{{tool}} \u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 {{chain}} \u098F \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09B0\u09C1\u09A8","swapping":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA","tags":{"cheapest":"\u09B8\u09B8\u09CD\u09A4\u09BE","fastest":"\u09A6\u09CD\u09B0\u09C1\u09A4","insurable":"\u09AC\u09C0\u09AE\u09BE\u09AF\u09CB\u0997\u09CD\u09AF","insurance":"\u09AC\u09C0\u09AE\u09BE","insured":"\u09AC\u09C0\u09AE\u09BE\u0995\u09C3\u09A4","recommended":"Recommended","safest":"\u09A8\u09BF\u09B0\u09BE\u09AA\u09A6"},"to":"\u09AA\u09CD\u09B0\u09A4\u09BF","tokenOnChain":"{{chainName}} -\u098F {{tokenSymbol}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} -\u098F","tokenSearch":"\u0986\u09AA\u09A8\u09BE\u09B0 \u099F\u09CB\u0995\u09C7\u09A8 \u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8","valueLoss":"\u09AE\u09BE\u09A8 \u0995\u09CD\u09B7\u09A4\u09BF","walletAddressOrEns":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09AC\u09BE \u0987\u098F\u09A8\u098F\u09B8 \u09A8\u09BE\u09AE"},"insurance":{"bridgeExploits":"\u09AC\u09CD\u09B0\u09BF\u099C\u09C7\u09B0 \u09A4\u09CD\u09B0\u09C1\u099F\u09BF, \u09B9\u09CD\u09AF\u09BE\u0995 \u09AC\u09BE \u09B6\u09CB\u09B7\u09A3","insure":"\u099F\u09CD\u09B0\u09BE\u09A8\u099C\u09BF\u099F\u09C7 \u099F\u09CB\u0995\u09C7\u09A8\u09C7\u09B0 \u09E7\u09E6\u09E6% \u09AC\u09C0\u09AE\u09BE \u0995\u09B0\u09C1\u09A8\u0964","insured":"\u0986\u09AA\u09A8\u09BF \u099F\u09CD\u09B0\u09BE\u09A8\u099C\u09BF\u099F\u09C7\u09B0 \u09E7\u09E6\u09E6% \u099F\u09CB\u0995\u09C7\u09A8 \u09AC\u09C0\u09AE\u09BE \u0995\u09B0\u09C7\u099B\u09C7\u09A8:","slippageError":"\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u099F\u09CB\u0995\u09C7\u09A8\u0997\u09C1\u09B2\u09BF\u09B0 \u099C\u09A8\u09CD\u09AF \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C\u09C7 \u09A4\u09CD\u09B0\u09C1\u099F\u09BF\u0964"},"tooltip":{"additionalProviderFee":"\u0985\u09A4\u09BF\u09B0\u09BF\u0995\u09CD\u09A4 \u09B8\u09C7\u09A4\u09C1, \u09A1\u09C7\u0995\u09CD\u09B8, \u098F\u09AC\u0982 \u09AA\u09B0\u09BF\u09B7\u09C7\u09AC\u09BE \u09AB\u09BF\u0964","estimatedNetworkFee":"\u0986\u09A8\u09C1\u09AE\u09BE\u09A8\u09BF\u0995 \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AB\u09BF\u0964","estimatedTime":"\u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7 \u0986\u09A8\u09C1\u09AE\u09BE\u09A8\u09BF\u0995 \u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0 \u0995\u09B0\u09BE\u09B0 \u09B8\u09AE\u09AF\u09BC\u0964","notFound":{"text":"\u0986\u09AE\u09B0\u09BE \u098F\u0987 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u099F\u09BF \u0996\u09C1\u0981\u099C\u09C7 \u09AA\u09BE\u0987\u09A8\u09BF\u0964","title":"\u09EA\u09E6\u09EA"},"numberOfSteps":"\u09B8\u09CB\u0993\u09DF\u09BE\u09AA \u09AA\u09A6\u0995\u09CD\u09B7\u09C7\u09AA \u098F\u0995\u099F\u09BF \u09B8\u0982\u0996\u09CD\u09AF\u09BE. \u09AA\u09CD\u09B0\u09A4\u09BF\u099F\u09BF \u09A7\u09BE\u09AA\u09C7 \u09E7-\u09E8 \u099F\u09BF \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09A5\u09BE\u0995\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7 \u09AF\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u098F\u0995\u099F\u09BF \u09B8\u09CD\u09AC\u09BE\u0995\u09CD\u09B7\u09B0 \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u0964","progressToNextUpdate":"\u09AA\u09CD\u09B0\u09A6\u09B0\u09CD\u09B6\u09BF\u09A4 \u09A1\u09C7\u099F\u09BE {{value}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1 \u09AA\u09B0\u09C7 \u09B8\u09CD\u09AC\u09AF\u09BC\u0982\u0995\u09CD\u09B0\u09BF\u09AF\u09BC\u09AD\u09BE\u09AC\u09C7 \u09B0\u09BF\u09AB\u09CD\u09B0\u09C7\u09B6 \u09B9\u09AC\u09C7\u0964 \u09AE\u09CD\u09AF\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B2\u09BF \u0986\u09AA\u09A1\u09C7\u099F \u0995\u09B0\u09A4\u09C7 \u098F\u0996\u09BE\u09A8\u09C7 \u0995\u09CD\u09B2\u09BF\u0995 \u0995\u09B0\u09C1\u09A8\u0964","settingsModified":"\u09B8\u09C7\u099F\u09BF\u0982\u09B8 (\u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4)"},"wallet":{"extensionNotFound":"\u098F\u0987 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u099F\u09BF \u09AC\u09C7\u099B\u09C7 \u09A8\u09C7\u0993\u09AF\u09BC\u09BE\u09B0 \u0986\u0997\u09C7 \u09A6\u09AF\u09BC\u09BE \u0995\u09B0\u09C7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8 \u09AF\u09C7 \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 {{name}} \u09AC\u09CD\u09B0\u09BE\u0989\u099C\u09BE\u09B0 \u098F\u0995\u09CD\u09B8\u099F\u09C7\u09A8\u09B6\u09A8 \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u0986\u099B\u09C7\u0964"}}');


var $547e4bb4d009cfd5$exports = {};
$547e4bb4d009cfd5$exports = JSON.parse('{"language":{"name":"Deutsch","title":"Sprache"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 4)}}"},"button":{"auto":"Auto","bridge":"Bridge","buy":"Buy","buyNow":"Jetzt kaufen","cancel":"Abbrechen","connectWallet":"Wallet verbinden","contactSupport":"Support kontaktieren","continue":"Fortsetzen","copyAddress":"Adresse kopieren","dark":"Dunkel","delete":"L\xf6schen","disconnect":"Trennen","done":"Fertig","exchange":"Exchange","getGas":"Gas erhalten","hide":"Ausblenden","learnMore":"Mehr erfahren","lifiCheckout":"LI.FI Checkout","lifiExchange":"LI.FI Exchange","light":"Hell","max":"max","ok":"OK","removeTransaction":"Transaktion entfernen","reset":"Zur\xfccksetzen","resetSettings":"Einstellungen zur\xfccksetzen","reviewBridge":"Bridge \xfcberpr\xfcfen","reviewPurchase":"Kauf ansehen","reviewSwap":"Swap \xfcberpr\xfcfen","seeDetails":"Siehe Einzelheiten","showAll":"Alles anzeigen","startBridging":"Starte Bridge Protokoll","startSwapping":"Swap starten","swap":"Swap","tryAgain":"Erneut versuchen","viewCoverage":"Deckung anzeigen","viewOnExplorer":"Im Explorer anzeigen"},"header":{"activeTransactions":"Aktive Transaktion","bridge":"Bridge","checkout":"Zur Kasse","exchange":"Exchange","from":"Swap von","gas":"Gas","payWith":"Zahle mit","purchase":"Kauf","purchaseDetails":"Kaufdetails","selectChain":"Chain ausw\xe4hlen","selectWallet":"Wallet w\xe4hlen","settings":"Einstellungen","swap":"Swap","to":"Swap zu","transactionDetails":"Transaktionsdetails","transactionHistory":"Transaktionshistorie\u2028","walletConnected":"Wallet verbunden","youGet":"Sie erhalten"},"info":{"message":{"autoRefuel":"Sie haben nicht genug Gas auf {{chainName}}. Wenn Sie fortfahren, erhalten Sie zus\xe4tzlich genug Gas um den Swap abzuschlie\xdfen.","emptyActiveTransactions":"Laufende Swaps werden hier angezeigt. Sobald Sie fertig sind, finden Sie sie in der Transaktionshistorie.","emptyTokenList":"Es wurden keine Tokens auf der Chain {{chainName}} gefunden oder Sie haben keine. Bitte versuchen Sie die Suche erneut mit der Contract-Adresse falls Ihr Token nicht erscheint oder wechseln Sie die Chain.","emptyTransactionHistory":"Die Transaktionshistorie wird nur lokal gespeichert und gel\xf6scht, wenn Sie Ihre Browserdaten l\xf6schen.","routeNotFound":"Gr\xfcnde daf\xfcr k\xf6nnten lauten: geringe Liquidit\xe4t, gew\xe4hlter Betrag ist zu niedrig, die Gaskosten sind zu hoch oder es gibt keine Routen f\xfcr die ausgew\xe4hlte Kombination."},"title":{"autoRefuel":"Gas erhalten","emptyActiveTransactions":"Keine aktiven Transaktionen","emptyTransactionHistory":"Keine neuen Transaktionen","routeNotFound":"Keine Routen verf\xfcgbar"}},"success":{"message":{"exchangePartiallySuccessful":"Wir haben versucht, den Swap abzuschlie\xdfen, aber {{tool}} hat keine Liquidit\xe4t f\xfcr {{tokenSymbol}} Token.","exchangeSuccessful":"Es sind jetzt {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} in der Wallet {{walletAddress}} auf der {{chainName}}-Chain.","purchaseSuccessful":"Sie besitzen jetzt {{assetName}} in der Wallet {{walletAddress}} auf der {{chainName}}-Chain."},"title":{"bridgePartiallySuccessful":"Bridge teilweise erfolgreich","bridgeSuccessful":"Bridge erfolgreich","purchaseSuccessful":"Kauf abgeschlossen","refundIssued":"R\xfcckerstattung gew\xe4hrt","swapPartiallySuccessful":"Swap teilweise erfolgreich","swapSuccessful":"Swap erfolgreich"}},"warning":{"message":{"deleteActiveTransactions":"Aktive Swaps werden nur lokal gespeichert und k\xf6nnen nicht wiederhergestellt werden, wenn Sie sie l\xf6schen.","deleteTransactionHistory":"Die Transaktionshistorie wird nur lokal gespeichert und kann nicht wiederhergestellt werden, wenn Sie sie l\xf6schen.","highValueLoss":"Der Wert der erhaltenen Token ist deutlich niedriger als die getauschten Token und die Transaktionskosten.","insufficientFunds":"Sie haben nicht genug Token, um diesen Swap abzuschlie\xdfen.","insufficientGas":"Sie haben nicht genug Gas um diesen Swap abzuschlie\xdfen. Sie m\xfcssen mindestens hinzuf\xfcgen:","rateChanged":"Der Wechselkurs hat sich ge\xe4ndert. Durch Fortsetzen des Swaps akzeptieren Sie den neuen Kurs.","resetSettings":"Dies wird Ihre Routenpriorit\xe4t, Slippage, Gaspreis, aktivierte Br\xfccken und Exchanges zur\xfccksetzen."},"title":{"deleteActiveTransactions":"Alle aktiven Transaktionen entfernen?","deleteTransaction":"Transaktion l\xf6schen?","deleteTransactionHistory":"Transaktionshistorie entfernen?","highValueLoss":"Hoher Wertverlust","insufficientGas":"Unzureichendes Gas","rateChanged":"Wechselkurs ge\xe4ndert","resetSettings":"Einstellungen zur\xfccksetzen?"}},"error":{"message":{"allowanceRequired":"\xdcberweisungsbetrag f\xfcr {{tokenSymbol}} \xfcberschreitet Ihre derzeitige Zulassung. Bitte erh\xf6hen Sie das Limit und versuchen Sie es erneut.","insufficientFunds":"Sie haben nicht genug Gas, um die Kosten der Transaktion zu decken.","slippageThreshold":"Die Slippage ist gr\xf6\xdfer als der definierte Schwellenwert. Bitte fordern Sie eine neue Route an, um ein neues Angebot zu erhalten.","transactionFailed":"Weitere Informationen finden Sie im Block-Explorer.","transactionNotSent":"Die Transaktion wurde nicht gesendet, Ihr Geld befindet sich noch in Ihrer Brieftasche ({{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} auf {{chainName}}).","transactionRejected":"Ihre Signatur ist erforderlich, um die Transaktion abzuschlie\xdfen. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} auf {{chainName}} verbleiben in Ihrem Wallet.","unknown":"Bitte versuchen Sie es sp\xe4ter noch einmal oder kontaktieren Sie den Support."},"title":{"allowanceRequired":"Unzureichende Erlaubnis","balanceIsTooLow":"Ihr Guthaben ist zu gering","chainSwitch":"Chainwechsel erforderlich","gasLimitIsTooLow":"Das Gaslimit ist zu niedrig","insufficientFunds":"Unzureichendes Guthaben","slippageNotMet":"Slippagebedingungen nicht erf\xfcllt","transactionCanceled":"Transaktion abgebrochen","transactionFailed":"Transaktion ist fehlgeschlagen.","transactionRejected":"Signatur ben\xf6tigt.","transactionUnderpriced":"Transaktion ist unterbewertet.","transactionUnprepared":"Transaktion kann nicht vorbereitet werden.","unknown":"Etwas ist schief gelaufen.","walletAddressInvalid":"Wallet-Adresse ist ung\xfcltig.","walletAddressRequired":"Wallet-Adresse ist erforderlich.","walletEnsAddressInvalid":"Die Wallet-Adresse ist ung\xfcltig oder das Netzwerk unterst\xfctzt ENS nicht."}},"tooltip":{"additionalProviderFee":"Zus\xe4tzliche Bridges, DEXs und Servicegeb\xfchren.","estimatedNetworkFee":"Gesch\xe4tzte Netzwerkgeb\xfchr.","estimatedTime":"Gesch\xe4tzte Swap-Ausf\xfchrungszeit in Minuten.","notFound":{"text":"Wir konnten diese Seite nicht finden.","title":"404"},"numberOfSteps":"Eine Anzahl von Swap-Schritten. Jeder Schritt kann 2 Transaktionen enthalten, die eine Unterschrift erfordern.","progressToNextUpdate":"Angezeigte Daten werden nach {{value}} Sekunden automatisch aktualisiert. Klicken Sie hier, um manuell zu aktualisieren.","recommended":"Eine preiswerte Route, die Komplexit\xe4t und Benutzerfreundlichkeit in Einklang bringt.","settingsModified":"Einstellungen (ge\xe4ndert)"},"main":{"crossStepDetails":"Bridgen von {{from}} nach {{to}} \xfcber {{tool}}","currentAmount":"Aktueller Betrag","estimatedTime":"{{value}} m","featuredTokens":"Ausgew\xe4hlte Token","from":"Von","fromAmount":"Sie bezahlen","gasCost":"Gaskosten","gasFeeEstimated":"gesch\xe4tzte Gasgeb\xfchr","gasFeePaid":"gezahlte Gasgeb\xfchr","inProgress":"wird ausgef\xfchrt","nftStepDetails":"NFT \xfcber {{tool}} kaufen","onChain":"auf {{chainName}}","otherTokens":"Andere Token","ownedBy":"In Besitz von","process":{"crossChain":{"actionRequired":"Bitte signieren Sie die Transaktion.","done":"Transaktion genehmigt","pending":"Warten auf Transaktion","started":"Transaktion vorbereiten"},"nft":{"done":"NFT gekauft"},"receivingChain":{"done":"Bridge abgeschlossen","partial":"Bridge teilweise abgeschlossen","pending":"Warten auf Empf\xe4nger-Chain.","refunded":"Bridge Transaktion zur\xfcckerstattet"},"swap":{"actionRequired":"Bitte signieren Sie die Transaktion.","done":"Swap abgeschlossen","pending":"Warten auf Transaktion","started":"Swap vorbereiten"},"switchChain":{"actionRequired":"Chainwechsel erforderlich","done":"Chain erfolgreich gewechselt."},"tokenAllowance":{"done":"Token-Zulassung genehmigt.","pending":"Warten auf Token-Genehmigung.","started":"Token-Freigabe festlegen."}},"quotedAmount":"Angebotsbetrag","rateChange":"Wechselkurs ge\xe4ndert","receiving":"Eingehend","refuelStepDetails":"Gas \xfcber {{tool}} erhalten","selectChain":"Chain","selectChainAndToken":"Chain und Token ausw\xe4hlen","selectToken":"Token","sendToAddress":"An {{address}} senden","sendToWallet":"An eine andere Wallet senden","sending":"Wird gesendet","sentToAddress":"Gesendet an {{address}}","stepBridge":"Bridge","stepBridgeAndBuy":"Bridge und Kauf","stepDetails":"{{tool}} via LI.FI","stepSwap":"Swap","stepSwapAndBridge":"Tauschen und \xfcberbr\xfccken","stepSwapAndBuy":"Tauschen und kaufen","supportId":"Support-ID","swapStepDetails":"Tausche auf {{chain}} \xfcber {{tool}}","tags":{"cheapest":"G\xfcnstig","fastest":"Schnell","insurable":"Versicherbar","insurance":"Versicherung","insured":"Versichert","recommended":"Empfohlen","safest":"Sicher"},"to":"Zu","tokenOnChain":"{{tokenSymbol}} auf {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} auf {{chainName}}","tokenSearch":"Suchen Sie Ihren Token","valueLoss":"Wertverlust","walletAddressOrEns":"Wallet-Adresse oder ENS-Name"},"insurance":{"bridgeExploits":"Bridge-Fehlfunktionen, Hacks oder Exploits","insure":"Versichere <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> w\xe4hrend der \xdcbertragung.","insured":"Du hast <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> w\xe4hrend der \xdcbertragung versichert:","slippageError":"Fehler in Slippage f\xfcr empfangene Token"},"settings":{"enabledBridges":"Aktivierte Bridges","enabledExchanges":"Aktivierte Exchanges","gasPrice":{"fast":"Schnell","normal":"Normal","slow":"Langsam","title":"Gaspreis"},"routePriority":"Routenpriorit\xe4t","showDestinationWallet":"Ziel Wallet anzeigen","slippage":"Slippage","resetSettings":"Sie verwenden benutzerdefinierte Einstellungen, die die Anzahl der verf\xfcgbaren Routen begrenzen."},"wallet":{"extensionNotFound":"Bitte stellen Sie sicher, dass nur die Browsererweiterung {{name}} aktiv ist, bevor Sie dieses Wallet ausw\xe4hlen."}}');


var $020e0b7a698d0af6$exports = {};
$020e0b7a698d0af6$exports = JSON.parse('{"language":{"name":"English","title":"Language"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"Auto","bridge":"Bridge","buy":"Buy","buyNow":"Buy now","cancel":"Cancel","close":"Close","connectWallet":"Connect wallet","contactSupport":"Contact support","continue":"Continue","copyAddress":"Copy address","dark":"Dark","delete":"Delete","disconnect":"Disconnect","done":"Done","exchange":"Exchange","getGas":"Get gas","hide":"Hide","learnMore":"Learn more","lifiCheckout":"LI.FI Checkout","lifiExchange":"LI.FI Exchange","light":"Light","max":"max","ok":"Ok","removeTransaction":"Remove transaction","reset":"Reset","resetSettings":"Reset settings","reviewBridge":"Review bridge","reviewPurchase":"Review purchase","reviewSwap":"Review swap","seeDetails":"See details","showAll":"Show all","startBridging":"Start bridging","startSwapping":"Start swapping","swap":"Swap","tryAgain":"Try again","viewCoverage":"View coverage","viewOnExplorer":"View on explorer"},"header":{"activeTransactions":"Active transactions","bridge":"Bridge","checkout":"Checkout","exchange":"Exchange","from":"Exchange from","gas":"Gas","payWith":"Pay with","purchase":"Purchase","purchaseDetails":"Purchase details","selectChain":"Select chain","selectWallet":"Select your wallet","settings":"Settings","swap":"Swap","to":"Exchange to","transactionDetails":"Transaction details","transactionHistory":"Transaction history","walletConnected":"Wallet connected","youGet":"You get"},"info":{"message":{"autoRefuel":"You\'re low on {{chainName}} gas. By continuing, you\'ll get enough gas to complete the transaction.","emptyActiveTransactions":"Transactions in progress will appear here. Once completed, find them in transaction history.","emptyTokenList":"We couldn\'t find tokens on {{chainName}} chain or you don\'t have any. Please search by contract address if your token doesn\'t appear or choose another chain.","emptyTransactionHistory":"Transaction history is only stored locally and will be deleted if you clear your browser data.","routeNotFound":"Reasons for that could be: low liquidity, amount selected is too low, gas costs are too high or there are no routes for the selected combination."},"title":{"autoRefuel":"Get gas","emptyActiveTransactions":"No active transactions","emptyTransactionHistory":"No recent transactions","routeNotFound":"No routes available"}},"success":{"message":{"exchangePartiallySuccessful":"We\'ve tried to complete the transaction, but {{tool}} ran out of liquidity for {{tokenSymbol}} token.","exchangeSuccessful":"There are now {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} in {{walletAddress}} wallet on {{chainName}} chain.","purchaseSuccessful":"You now own {{assetName}} in {{walletAddress}} wallet on {{chainName}} chain."},"title":{"bridgePartiallySuccessful":"Bridge partially successful","bridgeSuccessful":"Bridge successful","purchaseSuccessful":"Purchase successful","refundIssued":"Refund issued","swapPartiallySuccessful":"Swap partially successful","swapSuccessful":"Swap successful"}},"warning":{"message":{"deleteActiveTransactions":"Active transactions are only stored locally and can\'t be recovered if you delete them.","deleteTransactionHistory":"Transaction history is only stored locally and can\'t be recovered if you delete it.","highValueLoss":"The value of the received tokens is significantly lower than the exchanged tokens and transaction cost.","insufficientFunds":"You don\'t have enough funds to complete the transaction.","insufficientGas":"You don\'t have enough gas to complete the transaction. You need to add at least:","rateChanged":"The exchange rate has changed. By continuing the transaction, you\'ll accept the new rate.","resetSettings":"This will reset your route priority, slippage, gas price, enabled bridges and exchanges."},"title":{"deleteActiveTransactions":"Delete all active transactions?","deleteTransaction":"Delete this transaction?","deleteTransactionHistory":"Delete transaction history?","highValueLoss":"High value loss","insufficientGas":"Insufficient gas","rateChanged":"Rate changed","resetSettings":"Reset settings?"}},"error":{"message":{"allowanceRequired":"Transfer amount for {{tokenSymbol}} exceeds your current allowance. Please increase your allowance and try again.","insufficientFunds":"You don\'t have enough gas to cover the cost of the transaction.","slippageThreshold":"The slippage is larger than the defined threshold. Please request a new quote.","transactionFailed":"Please check the block explorer for more information.","transactionNotSent":"Transaction was not sent. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} on {{chainName}} remain in your wallet.","transactionRejected":"Your signature is required to complete the transaction. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} on {{chainName}} remain in your wallet.","unknown":"Please try again or contact support."},"title":{"allowanceRequired":"Insufficient allowance","balanceIsTooLow":"The balance is too low","chainSwitch":"Chain switch required","gasLimitIsTooLow":"The gas limit is too low","insufficientFunds":"Insufficient funds","slippageNotMet":"Slippage conditions not met","transactionCanceled":"Transaction canceled","transactionFailed":"Transaction failed","transactionRejected":"Signature required","transactionUnderpriced":"Transaction is underpriced","transactionUnprepared":"Unable to prepare transaction","unknown":"Something went wrong","walletAddressInvalid":"Wallet address is invalid.","walletAddressRequired":"Wallet address is required.","walletEnsAddressInvalid":"Wallet address is invalid or network doesn\'t support ENS."}},"tooltip":{"additionalProviderFee":"Additional bridges, DEXs, and service fees.","estimatedNetworkFee":"Estimated network fee.","estimatedTime":"Estimated execution time in minutes.","notFound":{"text":"We couldn\'t find this page.","title":"404"},"numberOfSteps":"A number of exchange steps. Each step can contain 1-2 transactions that require a signature.","progressToNextUpdate":"Quotes will update in {{value}} seconds. <0/> Click here to update now.","recommended":"A cheap route that balances complexity and ease of use.","settingsModified":"Settings (modified)"},"main":{"crossStepDetails":"Bridge from {{from}} to {{to}} via {{tool}}","currentAmount":"Current amount","estimatedTime":"{{value}}m","featuredTokens":"Featured tokens","from":"From","fromAmount":"You pay","gasCost":"Gas cost","gasFeeEstimated":"estimated gas fee","gasFeePaid":"gas fee paid","inProgress":"in progress","nftStepDetails":"Purchase NFT via {{tool}}","onChain":"on {{chainName}}","otherTokens":"Other tokens","ownedBy":"Owned by","process":{"crossChain":{"actionRequired":"Please sign the transaction","done":"Bridge transaction confirmed","pending":"Waiting for bridge transaction","started":"Preparing bridge transaction"},"nft":{"done":"NFT purchased"},"receivingChain":{"done":"Bridge completed","partial":"Bridge partially completed","pending":"Waiting for destination chain","refunded":"Bridge transaction refunded"},"swap":{"actionRequired":"Please sign the transaction","done":"Swap completed","pending":"Waiting for swap transaction","started":"Preparing swap transaction"},"switchChain":{"actionRequired":"Chain switch required","done":"Chain switched successfully"},"tokenAllowance":{"done":"Token allowance approved","pending":"Waiting for token allowance","started":"Setting token allowance"}},"quotedAmount":"Quoted amount","rateChange":"Rate change","receiving":"Receiving","refuelStepDetails":"Get gas via {{tool}}","selectChain":"Select chain","selectChainAndToken":"Select chain and token","selectToken":"Select token","sendToAddress":"Send to {{address}}","sendToWallet":"Send to a different wallet","sending":"Sending","sentToAddress":"Sent to {{address}}","stepBridge":"Bridge","stepBridgeAndBuy":"Bridge and buy","stepDetails":"{{tool}} via LI.FI","stepSwap":"Swap","stepSwapAndBridge":"Swap and bridge","stepSwapAndBuy":"Swap and buy","supportId":"Support ID","swapStepDetails":"Swap on {{chain}} via {{tool}}","tags":{"cheapest":"Cheap","fastest":"Fast","insurable":"Insurable","insurance":"Insurance","insured":"Insured","recommended":"Recommended","safest":"Safe"},"to":"To","tokenOnChain":"{{tokenSymbol}} on {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} on {{chainName}}","tokenSearch":"Search by token name or address","valueLoss":"Value loss","walletAddressOrEns":"Wallet address or ENS name"},"insurance":{"bridgeExploits":"Bridge malfunctions, hacks or exploits","insure":"Insure <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> in transit.","insured":"You\'ve insured <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> in transit:","slippageError":"Error in slippage for tokens received"},"settings":{"enabledBridges":"Enabled bridges","enabledExchanges":"Enabled exchanges","gasPrice":{"fast":"Fast","normal":"Normal","slow":"Slow","title":"Gas price"},"routePriority":"Route priority","showDestinationWallet":"Show destination wallet","slippage":"Slippage","resetSettings":"You\'re using custom setting limiting the number of available routes."},"wallet":{"extensionNotFound":"Please make sure that only the {{name}} browser extension is active before choosing this wallet."}}');


var $6d5e81dc2915c161$exports = {};
$6d5e81dc2915c161$exports = JSON.parse('{"button":{"auto":"Auto","cancel":"Cancelar","connectWallet":"Conectar billetera","contactSupport":"Contactar soporte","continue":"Continuar","copyAddress":"Copiar direcci\xf3n","dark":"Oscuro","delete":"Eliminar","disconnect":"Desconectar","done":"Hecho","getGas":"Obtener gas","hide":"Esconder","lifiSwap":"LI.FI Swap","light":"Luz","max":"m\xe1ximo","ok":"Ok","okay":"Okay","removeSwap":"Eliminar swap","reset":"Reiniciar","resetSettings":"Reiniciar ajustes","restartSwap":"Reiniciar swap","reviewGasSwap":"Revisar swap de gas","reviewSwap":"Revisar swap","seeDetails":"Ver detalles","showAll":"Mostrar todo","startGasSwap":"Iniciar intercambio de gas","startSwap":"Iniciar swap","swap":"Swap","tryAgain":"Intentar otra vez","viewOnExplorer":"Ver en explorador"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 4)}}"},"header":{"activeSwaps":"Swaps activos","checkout":"Checkout","from":"Intercambiar de","gas":"Gas","gasSwap":"Swap de gas","routes":"Usted obtiene","selectChain":"Seleccione la cadena","selectWallet":"Seleccione su billetera","settings":"Ajustes","swap":"Swap","swapDetails":"Detalles del swap","swapHistory":"Historial de swaps","to":"Swap a","walletConnected":"Billetera conectada"},"language":{"name":"Espa\xf1ol","title":"Idioma"},"settings":{"enabledBridges":"Puentes habilitados","enabledExchanges":"Intercambios habilitados","gasPrice":{"fast":"R\xe1pido","normal":"Normal","slow":"Lento","title":"Precio de gas"},"routePriority":"Prioridad de ruta","showDestinationWallet":"Mostrar billetera de destino","slippage":"Diferencial"},"info":{"message":{"emptyActiveSwaps":"Los intercambios en curso aparecer\xe1n aqu\xed. Una vez completado, encu\xe9ntrelos en el historial de intercambio.","emptySwapHistory":"El historial de intercambio solo se almacena localmente y se eliminar\xe1 si borra los datos de su navegador.","emptyTokenList":"No pudimos encontrar tokens en la cadena {{chainName}} o no tienes ninguno. Por favor intente buscar de nuevo o elija otra cadena.","routeNotFound":"Pruebe con otra combinaci\xf3n de tokens."},"title":{"emptyActiveSwaps":"No hay intercambios activos","emptySwapHistory":"No hay intercambios recientes","routeNotFound":"No hay rutas disponibles"}},"success":{"message":{"swapPartiallySuccessful":"Hemos intentado completar el swap, pero {{tool}} se qued\xf3 sin liquidez para el token {{tokenSymbol}}.","swapSuccessful":"Ahora hay {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en la billetera {{walletAddress}} en la cadena {{chainName}}."},"title":{"gasSwapSuccessful":"Swap de gas exitoso","refundIssued":"Reembolso emitido","swapPartiallySuccessful":"Swap parcialmente exitoso","swapSuccessful":"Intercambio exitoso"}},"warning":{"message":{"deleteActiveSwaps":"Los intercambios activos solo se almacenan localmente y no se pueden recuperar si los elimina.","deleteSwapHistory":"El historial de intercambio solo se almacena localmente y no se puede recuperar si lo elimina.","highValueLoss":"El valor de los tokens recibidos es significativamente menor que los tokens intercambiados y el costo de la transacci\xf3n.","insufficientFunds":"No tiene fondos suficientes para ejecutar el intercambio.","insufficientGas":"Debes agregar al menos:","rateChanged":"La tasa de cambio ha cambiado. Continuar con el swap implica que estas de acuerdo con la nueva tasa.","resetSettings":"Esto restablecer\xe1 su prioridad de ruta, deslizamiento, precio de gas, puentes e intercambios habilitados."},"title":{"deleteActiveSwaps":"\xbfEliminar todos los intercambios activos?","deleteSwap":"\xbfEliminar este intercambio?","deleteSwapHistory":"\xbfEliminar el historial de intercambio?","highValueLoss":"P\xe9rdida de alto valor","insufficientGas":"Gas insuficiente","rateChanged":"Cambios de precio detectado","resetSettings":"\xbfReiniciar los ajustes?"}},"error":{"message":{"slippageThreshold":"El slippage es mayor que el umbral definido. Por favor, solicite una nueva ruta para obtener un presupuesto nuevo.","transactionFailed":"Por favor consulte el explorador de bloques para obtener mas informaci\xf3n","transactionNotSent":"La transacci\xf3n no fue enviada, sus fondos a\xfan est\xe1n en su billetera ({{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en {{chainName}}).","transactionRejected":"Se requiere su firma para completar la transacci\xf3n. {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en {{chainName}} permanecen en su billetera.","unknown":"Int\xe9ntalo de nuevo o ponte en contacto con soporte."},"title":{"balanceIsTooLow":"El balance es demasiado bajo","chainSwitch":"Se requiere cambiar cadena.","failed":"Swap ha fallado","gasLimitIsTooLow":"L\xedmite de gas es demasiado bajo","slippageNotMet":"Condiciones de slippage no cumplidas","transactionCanceled":"Transacci\xf3n cancelada","transactionFailed":"La transacci\xf3n ha fallado.","transactionRejected":"Firma requerida.","transactionUnderpriced":"La transacci\xf3n est\xe1 subvaluada.","transactionUnprepared":"No se puede preparar la transacci\xf3n.","unknown":"Algo sali\xf3 mal.","walletAddressInvalid":"La direcci\xf3n de la billetera no es v\xe1lida.","walletAddressRequired":"Direcci\xf3n de billetera es requerida.","walletEnsAddressInvalid":"La direcci\xf3n de la billetera no es v\xe1lida o la red no es compatible con ENS."}},"main":{"crossStepDetails":"Mover fondos de {{from}} {{to}} {{tool}}","currentAmount":"Cantidad actual","estimatedTime":"{{value}}m","featuredTokens":"Tokens destacados","from":"Desde","fromAmount":"Usted paga","gasCost":"Costo de gas","gasFeeEstimated":"tarifa de gas estimada","gasFeePaid":"comisi\xf3n de gas pagada","inProgress":"en progreso","nftStepDetails":"Compra NFT a trav\xe9s de {{tool}}","onChain":"en {{chainName}}","otherTokens":"Otros tokens","ownedBy":"Propiedad de","payWith":"Pagar con","process":{"crossChain":{"actionRequired":"Por favor firme la transacci\xf3n.","done":"Transacci\xf3n aprobada.","pending":"Esperando transacci\xf3n.","started":"Preparando transacci\xf3n."},"receivingChain":{"done":"Fondos recibidos.","partial":"Transacci\xf3n de bridge parcialmente completada","pending":"Esperando cadena de recepci\xf3n.","refunded":"Transacci\xf3n de bridge reembolsada"},"swap":{"actionRequired":"Por favor firme la transacci\xf3n.","done":"Swap completado.","pending":"Esperando transacci\xf3n del intercambio","started":"Preparando transacci\xf3n de intercambio"},"switchChain":{"actionRequired":"Cambiar cadenas es requerido","done":"Cadena cambiada con \xe9xito"},"tokenAllowance":{"done":"Permiso de token aprobado","pending":"Esperando permiso de token","started":"Configurando permiso de tokens"}},"quotedAmount":"Monto citado","rateChange":"Cambios de precio detectado","receiving":"Recibiendo","routes":"Usted obtiene","selectChain":"Cadena","selectChainAndToken":"Seleccione cadena y token","selectToken":"Token","sendToAddress":"Enviar a {{address}}","sendToWallet":"Enviar a una billetera diferente","sentToAddress":"Enviado a {{address}}","stepBridge":"Cruzar","stepSwap":"Swap","stepSwapAndBridge":"Swap y cruzar","supportId":"ID de soporte","swapStepDetails":"Intercambiar en {{chain}} a trav\xe9s de {{tool}}","swapping":"Intercambiando","tags":{"ALTERNATIVE":"ALTERNATIVO","CHEAPEST":"BARATO","FASTEST":"R\xc1PIDO","RECOMMENDED":"RECOMENDADO","SAFEST":"SEGURO"},"to":"A","tokenOnChain":"{{tokenSymbol}} en {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} on {{chainName}}","tokenSearch":"Busque su token","valueLoss":"Valor perdido","walletAddressOrEns":"Direcci\xf3n de billetera o nombre ENS"},"tooltip":{"estimatedNetworkFee":"Tarifa de red estimada.","estimatedTime":"Tiempo estimado de ejecuci\xf3n del swap en minutos.","notFound":{"text":"No pudimos encontrar esta p\xe1gina.","title":"404"},"numberOfSteps":"Una serie de pasos de intercambio. Cada paso puede contener 1-2 transacciones que requieren una firma.","progressToNextUpdate":"Los datos mostrados se actualizar\xe1n autom\xe1ticamente despu\xe9s de {{value}} segundos. Haga clic aqu\xed para actualizar manualmente.","settingsModified":"Ajustes (modificados)"},"wallet":{"extensionNotFound":"Por favor, aseg\xfarese de que s\xf3lo la extensi\xf3n {{name}} del navegador esta activa antes de elegir esta billetera."}}');


var $c973622418f315a6$exports = {};
$c973622418f315a6$exports = JSON.parse('{"language":{"name":"Fran\xe7ais","title":"Langue"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 4)}}"},"button":{"auto":"Auto","bridge":"Bridge","buy":"Acheter","buyNow":"Acheter maintenant","cancel":"Annuler","connectWallet":"Connecter un portefeuille","contactSupport":"Contacter le support","continue":"Continuer","copyAddress":"Copier l\u2019adresse","dark":"Sombre","delete":"Supprimer","disconnect":"D\xe9connecter","done":"Termin\xe9","exchange":"\xc9changer","getGas":"Obtenir du gaz","hide":"Cacher","learnMore":"Plus d\'info","lifiCheckout":"Paiement LI.FI","lifiExchange":"\xc9change LI.FI","light":"Clair","max":"max","ok":"Ok","removeTransaction":"Supprimer la transaction","reset":"R\xe9initialiser","resetSettings":"R\xe9initialiser les param\xe8tres","reviewBridge":"Revoir le pont","reviewPurchase":"V\xe9rifiez votre achat","reviewSwap":"V\xe9rifier l\'\xe9change","seeDetails":"Voir les d\xe9tails","showAll":"Afficher tout","startBridging":"Commencer le pont","startSwapping":"Commencer \xe0 \xe9changer","swap":"\xc9changer","tryAgain":"R\xe9essayer","viewCoverage":"Voir la couverture","viewOnExplorer":"Voir sur l\'explorateur"},"header":{"activeTransactions":"Transactions actives","bridge":"Bridge","checkout":"Paiement","exchange":"\xc9changer","from":"\xc9changer de","gas":"Gaz","payWith":"Payer avec","purchase":"Acheter","purchaseDetails":"D\xe9tails de l\'achat","selectChain":"S\xe9lectionner la cha\xeene","selectWallet":"S\xe9lectionnez votre portefeuille","settings":"Param\xe8tres","swap":"\xc9changer","to":"\xc9changer pour","transactionDetails":"D\xe9tails de la transaction","transactionHistory":"Historique de transaction","walletConnected":"Portefeuille connect\xe9","youGet":"Vous obtenez"},"info":{"message":{"autoRefuel":"Vous avez peu de gaz sur {{chainName}}. En continuant, vous aurez assez de gaz pour compl\xe9ter l\'\xe9change.","emptyActiveTransactions":"Les transactions en cours appara\xeetront ici. Une fois termin\xe9es, retrouvez-les dans l\'historique des transactions.","emptyTokenList":"Nous n\'avons pas pu trouver de jetons sur la cha\xeene {{chainName}} ou vous n\'en avez pas. Veuillez rechercher par adresse de contrat si votre jeton n\'appara\xeet pas ou choisissez une autre cha\xeene.","emptyTransactionHistory":"L\'historique de transaction est uniquement stock\xe9 au niveau local et sera supprim\xe9 si vous effacez les donn\xe9es de votre navigateur.","routeNotFound":"Raisons possibles : faible liquidit\xe9, le montant s\xe9lectionn\xe9 est trop faible, les co\xfbts de gaz sont trop \xe9lev\xe9s ou il n\'y a pas de routes pour la combinaison s\xe9lectionn\xe9e."},"title":{"autoRefuel":"Obtenir du gaz","emptyActiveTransactions":"Pas de transactions actives","emptyTransactionHistory":"Pas de transactions r\xe9centes","routeNotFound":"Aucun itin\xe9raire disponible"}},"success":{"message":{"exchangePartiallySuccessful":"Nous avons essay\xe9 de compl\xe9ter la transaction, mais {{tool}} a manqu\xe9 de liquidit\xe9 pour le jeton {{tokenSymbol}}.","exchangeSuccessful":"Il y a maintenant {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} dans le portefeuille {{walletAddress}} sur la cha\xeene {{chainName}}.","purchaseSuccessful":"Vous poss\xe9dez maintenant {{assetName}} dans le portefeuille {{walletAddress}} sur la cha\xeene {{chainName}}."},"title":{"bridgePartiallySuccessful":"Pont partiellement r\xe9ussi","bridgeSuccessful":"Pont r\xe9ussi","purchaseSuccessful":"Achat effectu\xe9","refundIssued":"Remboursement \xe9mis","swapPartiallySuccessful":"\xc9change partiellement r\xe9ussi","swapSuccessful":"\xc9change r\xe9ussi"}},"warning":{"message":{"deleteActiveTransactions":"Les transactions actives ne sont stock\xe9es que localement et ne peuvent \xeatre r\xe9cup\xe9r\xe9es si vous les supprimez.","deleteTransactionHistory":"L\'historique d transaction est uniquement stock\xe9 localement et ne peut \xeatre r\xe9cup\xe9r\xe9 si vous le supprimez.","highValueLoss":"La valeur des jetons re\xe7us est nettement inf\xe9rieure \xe0 celle des jetons \xe9chang\xe9s et au co\xfbt de la transaction.","insufficientFunds":"Vous n\'avez pas assez de fonds pour finaliser l\'\xe9change.","insufficientGas":"Vous n\'avez pas assez de gaz pour finaliser l\'\xe9change. Vous devez avoir au moins:","rateChanged":"Le taux de change a chang\xe9. En continuant l\'\xe9change, vous devrez accepter le nouveau taux.","resetSettings":"Cela r\xe9initialisera la priorit\xe9 de votre itin\xe9raire, l\'effet de glissement, le prix du gaz, les ponts et les plateformes d\'\xe9changes activ\xe9s."},"title":{"deleteActiveTransactions":"Supprimer toutes les transactions actives ?","deleteTransaction":"Supprimer cette transaction ?","deleteTransactionHistory":"Supprimer l\'historique de transaction ?","highValueLoss":"Perte de valeur \xe9lev\xe9e","insufficientGas":"Gaz insuffisant","rateChanged":"Taux modifi\xe9","resetSettings":"R\xe9initialiser les param\xe8tres ?"}},"error":{"message":{"allowanceRequired":"Le montant du transfert pour {{tokenSymbol}} d\xe9passe votre allocation actuelle. Veuillez augmenter votre allocation et r\xe9essayer.","insufficientFunds":"Vous n\'avez pas assez de gaz pour couvrir le co\xfbt de la transaction.","slippageThreshold":"L\'effet de glissement est sup\xe9rieur au seuil d\xe9fini. Veuillez demander un nouvel itin\xe9raire pour obtenir un nouveau devis.","transactionFailed":"Veuillez consulter l\'explorateur de blocs pour plus d\'informations.","transactionNotSent":"La transaction n\'a pas \xe9t\xe9 envoy\xe9e. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} sur {{chainName}} restent dans votre portefeuille.","transactionRejected":"Votre signature est requise pour compl\xe9ter la transaction. {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} sur {{chainName}} restent dans votre portefeuille.","unknown":"Veuillez r\xe9essayer ou contacter le support."},"title":{"allowanceRequired":"Allocation insuffisante","balanceIsTooLow":"Le solde est trop bas.","chainSwitch":"Changement de cha\xeene n\xe9cessaire.","gasLimitIsTooLow":"La limite de gaz est trop basse.","insufficientFunds":"Fonds insuffisants","slippageNotMet":"Les conditions de l\'effet de glissement ne sont pas remplies.","transactionCanceled":"Transaction annul\xe9e.","transactionFailed":"La transaction a \xe9chou\xe9.","transactionRejected":"Signature requise.","transactionUnderpriced":"La transaction est sous-\xe9valu\xe9e.","transactionUnprepared":"Impossible de pr\xe9parer la transaction.","unknown":"Il y a eu un probl\xe8me.","walletAddressInvalid":"L\'adresse du portefeuille n\'est pas valide.","walletAddressRequired":"L\'adresse du portefeuille est n\xe9cessaire.","walletEnsAddressInvalid":"L\'adresse du portefeuille n\'est pas valide ou le r\xe9seau ne supporte pas l\'ENS."}},"tooltip":{"additionalProviderFee":"Ponts additionnels, DEX et frais de service.","estimatedNetworkFee":"Frais de r\xe9seau estim\xe9s.","estimatedTime":"Dur\xe9e d\'ex\xe9cution de l\'\xe9change estim\xe9 en minutes.","notFound":{"text":"Nous n\'avons pas trouv\xe9 cette page.","title":"404"},"numberOfSteps":"Un certain nombre d\'\xe9tapes d\'\xe9change. Chaque \xe9tape peut contenir 1 \xe0 2 transactions n\xe9cessitant une signature.","progressToNextUpdate":"Les donn\xe9es affich\xe9es seront automatiquement actualis\xe9es apr\xe8s {{value}} secondes. Cliquez ici pour les mettre \xe0 jour manuellement.","recommended":"Une voie bon march\xe9 qui \xe9quilibre complexit\xe9 et facilit\xe9 d\'utilisation.","settingsModified":"Param\xe8tres (modifi\xe9s)"},"main":{"crossStepDetails":"Passer de {{from}} \xe0 {{to}} via {{tool}}","currentAmount":"Montant actuel","estimatedTime":"{{value}}m","featuredTokens":"Jetons en vedette","from":"De","fromAmount":"Vous payez","gasCost":"Co\xfbt du gaz","gasFeeEstimated":"frais de gaz estim\xe9s","gasFeePaid":"frais de gaz pay\xe9s","inProgress":"en cours","nftStepDetails":"Acheter un NFT via {{tool}}","onChain":"sur {{chainName}}","otherTokens":"Autres jetons","ownedBy":"Propri\xe9taire","process":{"crossChain":{"actionRequired":"Veuillez signer la transaction.","done":"Transaction Bridge confirm\xe9e","pending":"En attente de la transaction bridge","started":"Pr\xe9paration de la transaction bridge"},"nft":{"done":"NFT achet\xe9"},"receivingChain":{"done":"Bridge compl\xe9t\xe9","partial":"Bridge partiellement compl\xe9t\xe9","pending":"En attente de la cha\xeene de destination","refunded":"Transaction bridge rembours\xe9e"},"swap":{"actionRequired":"Veuillez signer la transaction.","done":"\xc9change termin\xe9.","pending":"En attente de la transaction d\'\xe9change","started":"Pr\xe9paration de la transaction d\'\xe9change"},"switchChain":{"actionRequired":"Changement de cha\xeene requis.","done":"Cha\xeene chang\xe9e avec succ\xe8s."},"tokenAllowance":{"done":"Allocation de jetons approuv\xe9e.","pending":"En attente de l\'allocation de jetons","started":"Fixation de l\'allocation de jeton."}},"quotedAmount":"Montant indiqu\xe9","rateChange":"Taux de change","receiving":"En cours de r\xe9ception","refuelStepDetails":"Obtenir du gaz via {{tool}}","selectChain":"S\xe9lectionner la cha\xeene","selectChainAndToken":"S\xe9lectionnez la cha\xeene et le jeton","selectToken":"Choisissez un jeton","sendToAddress":"Envoyer \xe0 {{address}}","sendToWallet":"Envoyer vers un autre portefeuille","sending":"Envoi","sentToAddress":"Envoy\xe9 \xe0 {{address}}","stepBridge":"Bridge","stepBridgeAndBuy":"Bridge et acheter","stepDetails":"{{tool}} via LI.FI","stepSwap":"\xc9changer","stepSwapAndBridge":"\xc9change et Bridge","stepSwapAndBuy":"\xc9changer et acheter","supportId":"ID de support","swapStepDetails":"\xc9changer sur {{chain}} via {{tool}}","tags":{"cheapest":"Pas cher","fastest":"Rapide","insurable":"Assurable","insurance":"Assurance","insured":"Assur\xe9","recommended":"Recommand\xe9","safest":"S\xfbr"},"to":"\xc0","tokenOnChain":"{{tokenSymbol}} sur {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} sur {{chainName}}","tokenSearch":"Recherche par nom de jeton ou adresse","valueLoss":"Perte de valeur","walletAddressOrEns":"Adresse du portefeuille ou nom ENS"},"insurance":{"bridgeExploits":"Des dysfonctionnements de pont, des hacks ou des exploits","insure":"Assurer <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> en transit :","insured":"Vous avez assur\xe9 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> en transit :","slippageError":"Erreur dans le slippage pour les jetons re\xe7us"},"settings":{"enabledBridges":"Bridges activ\xe9s","enabledExchanges":"\xc9changes autoris\xe9s","gasPrice":{"fast":"Rapide","normal":"Normal","slow":"Lent","title":"Prix du gaz"},"routePriority":"Priorit\xe9 de l\'itin\xe9raire","showDestinationWallet":"Afficher le portefeuille de destination","slippage":"Effet de glissement","resetSettings":"Vous utilisez des param\xe8tres personnalis\xe9s limitant le nombre de routes disponibles."},"wallet":{"extensionNotFound":"Veuillez vous assurer que seule l\'extension de navigateur {{name}} est active avant de choisir ce portefeuille."}}');


var $1ec7c7fd0fce1b9f$exports = {};
$1ec7c7fd0fce1b9f$exports = JSON.parse('{"language":{"name":"Indonesian","title":"Bahasa"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"Otomatis","bridge":"Bridge","buy":"Beli","buyNow":"Beli sekarang","cancel":"Batal","connectWallet":"Hubungkan dompet","contactSupport":"Kontak bantuan","continue":"Lanjutkan","copyAddress":"Salin alamat","dark":"Gelap","delete":"Hapus","disconnect":"Tidak terkoneksi","done":"Selesai","exchange":"Pertukaran","getGas":"Dapatkan gas","hide":"Sembunyikan","learnMore":"Pelajari lebih lanjut","lifiCheckout":"Pembayaran LI.FI","lifiExchange":"Pertukaran LI.FI","light":"Terang","max":"maks","ok":"Ya","removeTransaction":"Hapus transaksi","reset":"Atur ulang","resetSettings":"Setel ulang pengaturan","reviewBridge":"Peninjauan bridge","reviewPurchase":"Tinjau pembelian","reviewSwap":"Tinjau swap","seeDetails":"Lihat rinciannya","showAll":"Tampilkan semua","startBridging":"Mulai bridge","startSwapping":"Mulai swap","swap":"Swap","tryAgain":"Coba lagi","viewCoverage":"Melihat cakupan","viewOnExplorer":"Lihat di explorer"},"header":{"activeTransactions":"Transaksi aktif","bridge":"Bridge","checkout":"Checkout","exchange":"Pertukaran","from":"Swap dari","gas":"Gas","payWith":"Bayar dengan","purchase":"Pembelian","purchaseDetails":"Detail pembelian","selectChain":"Pilih jaringan","selectWallet":"Pilih dompet","settings":"Pengaturan","swap":"Swap","to":"Swap ke","transactionDetails":"Rincian transaksi","transactionHistory":"Riwayat transaksi","walletConnected":"Dompet terhubung","youGet":"Anda mendapatkan"},"info":{"message":{"autoRefuel":"Gas anda hampir habis {{chainName}}. Dengan melanjutkan, anda akan mendapatkan cukup gas untuk menyelesaikan penukaran.","emptyActiveTransactions":"Transaksi yang sedang berlangsung akan muncul di sini. Setelah selesai, temukan di riwayat transaksi.","emptyTokenList":"Kami tidak dapat menemukan token di jaringan {{chainName}} atau Anda tidak memilikinya. Silakan cari berdasarkan alamat kontrak jika token Anda tidak muncul atau pilih jaringan lain.","emptyTransactionHistory":"Riwayat transaksi hanya disimpan secara lokal dan akan dihapus jika Anda menghapus data browser.","routeNotFound":"Alasannya mungkin: likuiditas rendah, jumlah yang dipilih terlalu rendah, biaya gas terlalu tinggi, atau tidak ada rute untuk kombinasi yang dipilih."},"title":{"autoRefuel":"Dapatkan gas","emptyActiveTransactions":"Tidak ada transaksi yang aktif","emptyTransactionHistory":"Tidak ada transaksi terbaru","routeNotFound":"Rute tidak tersedia"}},"success":{"message":{"exchangePartiallySuccessful":"Kami telah mencoba menyelesaikan transaksi, tetapi {{tool}} kehabisan likuiditas untuk token {{tokenSymbol}}.","exchangeSuccessful":"Sekarang ada {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di dompet {{walletAddress}} pada jaringan {{chainName}}.","purchaseSuccessful":"Anda sekarang memiliki {{assetName}} di dompet {{walletAddress}} di chain {{chainName}}."},"title":{"bridgePartiallySuccessful":"Bridge sebagian berhasil","bridgeSuccessful":"Bridge berhasil","purchaseSuccessful":"Pembelian berhasil","refundIssued":"Pengembalian dana diterbitkan","swapPartiallySuccessful":"Swap sebagian berhasil","swapSuccessful":"Swap berhasil"}},"warning":{"message":{"deleteActiveTransactions":"Transaksi aktif hanya disimpan secara lokal dan tidak dapat dipulihkan jika Anda menghapusnya.","deleteTransactionHistory":"Riwayat transaksi hanya disimpan secara lokal dan tidak dapat dipulihkan jika Anda menghapusnya.","highValueLoss":"Nilai token yang diterima jauh lebih rendah daripada token yang ditukar dan biaya transaksi.","insufficientFunds":"Anda tidak memiliki cukup dana untuk menyelesaikan penukaran.","insufficientGas":"Anda tidak memiliki cukup gas untuk menyelesaikan penukaran. Anda perlu menambahkan setidaknya:","rateChanged":"Nilai tukar telah berubah. Dengan melanjutkan penukaran, Anda akan menerima tarif baru.","resetSettings":"Ini akan mengatur ulang prioritas rute Anda, slippage, harga gas, jembatan yang diaktifkan, dan pertukaran."},"title":{"deleteActiveTransactions":"Hapus seluruh transaksi aktif?","deleteTransaction":"Hapus transaksi ini?","deleteTransactionHistory":"Hapus riwayat transaksi?","highValueLoss":"Kehilangan nilai tinggi","insufficientGas":"Gas tidak mencukupi","rateChanged":"Rate berubah","resetSettings":"Setel ulang pengaturan?"}},"error":{"message":{"allowanceRequired":"Jumlah transfer untuk {{tokenSymbol}} melebihi jatah Anda saat ini. Tingkatkan jatah Anda dan coba lagi.","insufficientFunds":"Anda tidak memiliki cukup gas untuk menutup biaya transaksi.","slippageThreshold":"Slippage lebih besar dari ambang batas yang ditentukan. Silakan minta rute baru untuk mendapatkan penawaran baru.","transactionFailed":"Silakan periksa block explorer untuk informasi lebih lanjut.","transactionNotSent":"Transaksi tidak terkirim. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}} tetap berada di dompet Anda.","transactionRejected":"Tanda tangan Anda diperlukan untuk menyelesaikan transaksi. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}} tetap berada di dompet Anda.","unknown":"Silakan coba lagi atau hubungi bagian dukungan."},"title":{"allowanceRequired":"Saldo tidak mencukupi","balanceIsTooLow":"Saldo Anda terlalu sedikit","chainSwitch":"Penggantian jaringan diperlukan","gasLimitIsTooLow":"Gas limit terlalu rendah","insufficientFunds":"Dana tidak mencukupi","slippageNotMet":"Kondisi slippage tidak terpenuhi","transactionCanceled":"Transaksi dibatalkan","transactionFailed":"Transaksi gagal","transactionRejected":"Tanda tangan diperlukan","transactionUnderpriced":"Transaksi di bawah harga","transactionUnprepared":"Tidak dapat menguraikan transaksi","unknown":"Terjadi kesalahan","walletAddressInvalid":"Alamat dompet tidak valid.","walletAddressRequired":"Alamat dompet diperlukan.","walletEnsAddressInvalid":"Alamat dompet tidak valid atau jaringan tidak mendukung ENS."}},"tooltip":{"additionalProviderFee":"Jembatan tambahan, DEX, dan biaya layanan.","estimatedNetworkFee":"Perkiraan biaya jaringan.","estimatedTime":"Perkiraan waktu eksekusi swap dalam hitungan menit.","notFound":{"text":"Kami tidak dapat menemukan halaman ini.","title":"404"},"numberOfSteps":"Sejumlah langkah swap. Setiap langkah dapat berisi 1-2 transaksi yang memerlukan tanda tangan.","progressToNextUpdate":"Data yang ditampilkan akan disegarkan secara otomatis setelah {{value}} detik. Klik di sini untuk memperbarui secara manual.","recommended":"Rute murah yang menyeimbangkan kerumitan dan kemudahan penggunaan.","settingsModified":"Pengaturan (diubah)"},"main":{"crossStepDetails":"Bridge dari {{from}} to {{to}} via {{tool}}","currentAmount":"Jumlah saat ini","estimatedTime":"{{value}}m","featuredTokens":"Token unggulan","from":"Dari","fromAmount":"Anda membayar","gasCost":"Biaya Gas","gasFeeEstimated":"perkiraan biaya gas","gasFeePaid":"biaya gas yang dibayar","inProgress":"dalam proses","nftStepDetails":"Beli NFT melalui {{tool}}","onChain":"di {{chainName}}","otherTokens":"Token lainnya","ownedBy":"Dimiliki oleh","process":{"crossChain":{"actionRequired":"Mohon konfirmasi transaksi","done":"Bridge dikonfirmasi","pending":"Menunggu transaksi bridge","started":"Mempersiapkan transaksi bridge"},"nft":{"done":"NFT dibeli"},"receivingChain":{"done":"Bridge selesai","partial":"Bridge sebagian selesai","pending":"Menunggu jaringan tujuan","refunded":"Dana transaksi bridge dikembalikan"},"swap":{"actionRequired":"Mohon konfirmasi transaksi","done":"Swap selesai","pending":"Menunggu transaksi swap","started":"Mempersiapkan transaksi swap"},"switchChain":{"actionRequired":"Penggantian jaringan diperlukan","done":"Penggantian jaringan berhasil"},"tokenAllowance":{"done":"Izin token disetujui","pending":"Menunggu untuk izin token","started":"Pengaturan izin token"}},"quotedAmount":"Jumlah yang dikutip","rateChange":"Perubahan rate","receiving":"Menerima","refuelStepDetails":"Dapatkan gas melalui {{tool}}","selectChain":"Pilih jaringan","selectChainAndToken":"Pilih jaringan dan token","selectToken":"Pilih token","sendToAddress":"Kirim ke {{address}}","sendToWallet":"Kirim ke dompet berbeda","sending":"Mengirim","sentToAddress":"Dikirim ke {{address}}","stepBridge":"Bridge","stepBridgeAndBuy":"Bridge dan beli","stepDetails":"{{tool}} melalui LI.FI","stepSwap":"Swap","stepSwapAndBridge":"Swap dan bridge","stepSwapAndBuy":"Swap dan beli","supportId":"ID dukungan","swapStepDetails":"Swap di {{chain}} melalui {{tool}}","tags":{"cheapest":"Murah","fastest":"Cepat","insurable":"Dapat diasuransikan","insurance":"Asuransi","insured":"Diasuransikan","recommended":"Direkomendasikan","safest":"Aman"},"to":"Kepada","tokenOnChain":"{{tokenSymbol}} di {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} di {{chainName}}","tokenSearch":"Cari berdasarkan nama atau alamat token","valueLoss":"Kehilangan nilai","walletAddressOrEns":"Alamat dompet atau nama ENS"},"insurance":{"bridgeExploits":"Malfungsi jembatan, peretasan, atau eksploitasi","insure":"Asuransikan <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> dalam perjalanan.","insured":"Anda telah mengasuransikan <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> dalam perjalanan:","slippageError":"Kesalahan dalam slippage untuk token yang diterima"},"settings":{"enabledBridges":"Jembatan diaktifkan","enabledExchanges":"Pertukaran diaktifkan","gasPrice":{"fast":"Cepat","normal":"Normal","slow":"Lambat","title":"Harga gas"},"routePriority":"Prioritas rute","showDestinationWallet":"Tampilkan Alamat Tujuan","slippage":"Slippage"},"wallet":{"extensionNotFound":"Pastikan hanya ekstensi browser {{name}} yang aktif sebelum memilih dompet ini."}}');


var $056a48947ac3d428$exports = {};
$056a48947ac3d428$exports = JSON.parse('{"language":{"name":"Italiano","title":"Lingua"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"Auto","bridge":"Bridge","buy":"Acquista","buyNow":"Acquista subito","cancel":"Annulla","connectWallet":"Collega il portafoglio","contactSupport":"Contatta l\'assistenza","continue":"Continua","copyAddress":"Copia indirizzo","dark":"Scuro","delete":"Elimina","disconnect":"Disconnetti","done":"Fatto","exchange":"Scambia","getGas":"Ottieni gas","hide":"Nascondi","learnMore":"Ulteriori informazioni","lifiCheckout":"LI.FI Checkout","lifiExchange":"LI.FI Exchange","light":"Chiaro","max":"massimo","ok":"Ok","removeTransaction":"Rimuovi transazione","reset":"Ripristina","resetSettings":"Ripristina impostazioni","reviewBridge":"Rivedi bridge","reviewPurchase":"Rivedi acquisto","reviewSwap":"Rivedi lo scambio","seeDetails":"Vedi dettagli","showAll":"Mostra tutto","startBridging":"Inizia il bridge","startSwapping":"Avvia lo scambio","swap":"Scambio","tryAgain":"Riprova","viewCoverage":"Vedi copertura","viewOnExplorer":"Visualizza sull\'Explorer"},"header":{"activeTransactions":"Transazioni attive","bridge":"Bridge","checkout":"Checkout","exchange":"Exchange","from":"Scambia da","gas":"Gas","payWith":"Paga con","purchase":"Acquista","purchaseDetails":"Dettagli di acquisto","selectChain":"Seleziona la chain","selectWallet":"Seleziona il tuo portafoglio","settings":"Impostazioni","swap":"Scambio","to":"Scambia a","transactionDetails":"Dettagli transazione","transactionHistory":"Storico Transazioni","walletConnected":"Portafoglio collegato","youGet":"Ricevi"},"info":{"message":{"autoRefuel":"Livello basso di gas su {{chainName}}. Continuando avrai abbastanza gas per completare lo scambio.","emptyActiveTransactions":"Le transazioni in corso appariranno qui. Una volta completate, potrai trovarle nella cronologia delle transazioni.","emptyTokenList":"Non siamo riusciti a trovare token sulla chain {{chainName}} o non ne hai. Riprova o scegli un\'altra chain.","emptyTransactionHistory":"La cronologia delle transazioni \xe8 memorizzata solo localmente e verr\xe0 eliminata se si cancellano i dati del browser.","routeNotFound":"Le ragioni potrebbero essere: bassa liquidit\xe0, la quantit\xe0 selezionata \xe8 troppo bassa, i costi del gas sono troppo elevati o non ci sono routes per la combinazione selezionata."},"title":{"autoRefuel":"Ottieni gas","emptyActiveTransactions":"Nessuna transazione attiva","emptyTransactionHistory":"Nessuna transazione recente","routeNotFound":"Nessuna rotta disponibile"}},"success":{"message":{"exchangePartiallySuccessful":"Abbiamo provato a completare la transazione, ma {{tool}} ha esaurito la liquidit\xe0 per il token {{tokenSymbol}}.","exchangeSuccessful":"Sono presenti ora {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} nel portafoglio {{walletAddress}} sulla chain {{chainName}}.","purchaseSuccessful":"Ora possiedi {{assetName}} nel wallet {{walletAddress}} sulla chain {{chainName}}."},"title":{"bridgePartiallySuccessful":"Bridge parzialmente completato con successo","bridgeSuccessful":"Bridge avvenuto con successo","purchaseSuccessful":"Acquisto completato","refundIssued":"Rimborso inviato","swapPartiallySuccessful":"Scambio parzialmente completato con successo","swapSuccessful":"Scambio completato con successo"}},"warning":{"message":{"deleteActiveTransactions":"Gli scambi attivi vengono memorizzati solo localmente e non possono essere recuperati se vengono cancellati.","deleteTransactionHistory":"La cronologia delle transazioni \xe8 memorizzata solo localmente e non pu\xf2 essere recuperata se la elimini.","highValueLoss":"Il valore dei token ricevuti \xe8 significativamente inferiore ai token scambiati pi\xf9 il costo della transazione.","insufficientFunds":"Non hai abbastanza fondi per completare lo scambio.","insufficientGas":"Non hai abbastanza gas per completare lo scambio. Devi aggiungere almeno:","rateChanged":"Il tasso di scambio \xe8 cambiato. Se procedi, confermi di accettare il nuovo tasso.","resetSettings":"Questo porter\xe0 al ripristino della priorit\xe0 di route, slittamento di prezzo, prezzo del gas, bridge abilitati ed exchanges."},"title":{"deleteActiveTransactions":"Eliminare tutte le transazioni attive?","deleteTransaction":"Eliminare questa transazione?","deleteTransactionHistory":"Eliminare la cronologia transazioni?","highValueLoss":"Perdita di valore elevato","insufficientGas":"Gas insufficiente","rateChanged":"Tasso cambiato","resetSettings":"Ripristinare le impostazioni?"}},"error":{"message":{"allowanceRequired":"L\'importo di {{tokenSymbol}} supera la tua quota massima permessa. Aumenta la quota e riprova.","insufficientFunds":"Non hai abbastanza gas per coprire il costo della transazione.","slippageThreshold":"Lo slittamento di prezzo \xe8 pi\xf9 alto della soglia definita. Si prega di richiedere una nuova route per ottenere una quota aggiornata.","transactionFailed":"Per ulteriori informazioni, consultare il block explorer.","transactionNotSent":"La transazione non \xe8 stata inviata. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} su {{chainName}} sono ancora presenti nel tuo portafoglio.","transactionRejected":"Per completare la transazione \xe8 necessaria la tua firma. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} su {{chainName}} rimangono nel tuo portafoglio.","unknown":"Riprova o contatta il nostro supporto."},"title":{"allowanceRequired":"Quota massima insufficiente","balanceIsTooLow":"Il saldo \xe8 troppo basso","chainSwitch":"\xc8 necessario cambiare la chain","gasLimitIsTooLow":"Limite di gas troppo basso","insufficientFunds":"Fondi insufficienti","slippageNotMet":"Condizioni di slittamento di prezzo non rispettate","transactionCanceled":"Transazione cancellata","transactionFailed":"Transazione fallita","transactionRejected":"Firma obbligatoria","transactionUnderpriced":"L\'operazione \xe8 sottostimata","transactionUnprepared":"Impossibile preparare la transazione","unknown":"Qualcosa \xe8 andato storto","walletAddressInvalid":"L\'indirizzo del portafoglio non \xe8 valido.","walletAddressRequired":"L\'indirizzo \xe8 un campo obbligatorio.","walletEnsAddressInvalid":"L\'indirizzo non \xe8 valido o la rete non supporta ENS."}},"tooltip":{"additionalProviderFee":"Bridge aggiuntivi, DEX e spese di servizio.","estimatedNetworkFee":"Costo di rete stimato.","estimatedTime":"Tempo di esecuzione dello scambio stimato in minuti.","notFound":{"text":"Non siamo riusciti a trovare questa pagina.","title":"404"},"numberOfSteps":"Una serie di fasi di scambio. Ogni fase pu\xf2 contenere 1-3 transazioni che richiedono una firma.","progressToNextUpdate":"I dati visualizzati si aggiorneranno automaticamente dopo {{value}} secondi. Fai click qui per aggiornare manualmente.","recommended":"Una rotta economica che equilibra complessit\xe0 e facilit\xe0 di utilizzo.","settingsModified":"Impostazioni (modificate)"},"main":{"crossStepDetails":"Trasferisci da {{from}} a {{to}} tramite {{tool}}","currentAmount":"Quantit\xe0 corrente","estimatedTime":"{{value}}m","featuredTokens":"Token in evidenza","from":"Da","fromAmount":"Paghi","gasCost":"Costo del gas","gasFeeEstimated":"tassa di gas stimata","gasFeePaid":"tassa di gas pagata","inProgress":"in corso","nftStepDetails":"Acquista NFT tramite {{tool}}","onChain":"su {{chainName}}","otherTokens":"Altri token","ownedBy":"Di propriet\xe0 di","process":{"crossChain":{"actionRequired":"Si prega di firmare la transazione","done":"Transazione di bridge approvata","pending":"In attesa della transazione di bridge","started":"Preparazione della transazione di bridge"},"nft":{"done":"NFT acquistati"},"receivingChain":{"done":"Bridge completato","partial":"Bridge parzialmente completato","pending":"In attesa della chain di destinazione","refunded":"Transazione di bridge rimborsata"},"swap":{"actionRequired":"Si prega di firmare la transazione","done":"Scambio completato","pending":"In attesa della transazione di scambio","started":"Preparazione dello scambio"},"switchChain":{"actionRequired":"\xc8 necessario cambiare la chain","done":"La chain \xe8 stata cambiata con successo"},"tokenAllowance":{"done":"Indennit\xe0 del token approvata","pending":"In attesa dell\'indennit\xe0 del token","started":"Applicazione dell\'indennit\xe0 di token"}},"quotedAmount":"Totale quotato","rateChange":"Tasso di scambio","receiving":"In ricezione","refuelStepDetails":"Ottieni gas tramite {{tool}}","selectChain":"Seleziona la chain","selectChainAndToken":"Selezionare la chain ed il token","selectToken":"Seleziona un token","sendToAddress":"Invia a {{address}}","sendToWallet":"Invia ad un altro portafoglio","sending":"Invio in corso","sentToAddress":"Inviati a {{address}}","stepBridge":"Bridge","stepBridgeAndBuy":"Trasferisci e acquista","stepDetails":"{{tool}} tramite LI.FI","stepSwap":"Scambio","stepSwapAndBridge":"Scambia e bridge","stepSwapAndBuy":"Scambia e acquista","supportId":"ID supporto","swapStepDetails":"Scambio su {{chain}} tramite {{tool}}.","tags":{"cheapest":"Economico","fastest":"Veloce","insurable":"Assicurabile","insurance":"Assicurazione","insured":"Assicurato","recommended":"Consigliato","safest":"Sicuro"},"to":"A","tokenOnChain":"{{tokenSymbol}} su {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} su {{chainName}}","tokenSearch":"Cerca per nome token o indirizzo","valueLoss":"Perdita di valore","walletAddressOrEns":"Indirizzo del portafoglio o nome ENS"},"insurance":{"bridgeExploits":"Malfunzionamenti, hack o exploit di bridge","insure":"Assicura <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> in transito.","insured":"Hai assicurato <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> in transito:","slippageError":"Errore nello slippage dei token ricevuti"},"settings":{"enabledBridges":"Bridge abilitati","enabledExchanges":"Exchange abilitati","gasPrice":{"fast":"Veloce","normal":"Normale","slow":"Lento","title":"Prezzo gas"},"routePriority":"Priorit\xe0 di route","showDestinationWallet":"Mostra il portafoglio di destinazione","slippage":"Slittamento"},"wallet":{"extensionNotFound":"Assicurati che solo l\'estensione {{name}} del browser sia attiva prima di scegliere questo portafoglio."}}');


var $e7631cbad3f30538$exports = {};
$e7631cbad3f30538$exports = JSON.parse('{"language":{"name":"\uD55C\uAD6D\uC5B4","title":"\uC5B8\uC5B4"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"\uC790\uB3D9","bridge":"\uBE0C\uB9BF\uC9C0","buy":"\uB9E4\uC218","buyNow":"\uC989\uC2DC \uB9E4\uC218","cancel":"\uCDE8\uC18C","connectWallet":"\uC9C0\uAC11 \uC5F0\uACB0","contactSupport":"\uACE0\uAC1D \uC9C0\uC6D0","continue":"\uACC4\uC18D","copyAddress":"\uC8FC\uC18C \uBCF5\uC0AC","dark":"\uC5B4\uB461\uAC8C","delete":"\uC0AD\uC81C","disconnect":"\uC5F0\uACB0 \uD574\uC81C","done":"\uC644\uB8CC","exchange":"\uAD50\uD658","getGas":"\uAC00\uC2A4 \uBC1B\uAE30","hide":"\uC228\uAE30\uAE30","learnMore":"\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30","lifiCheckout":"LI.FI \uACB0\uC81C","lifiExchange":"LI.FI \uAD50\uD658","light":"\uBC1D\uAC8C","max":"\uCD5C\uB300","ok":"\uD655\uC778","removeTransaction":"\uAC70\uB798 \uC9C0\uC6B0\uAE30","reset":"\uCD08\uAE30\uD654","resetSettings":"\uC124\uC815 \uCD08\uAE30\uD654","reviewBridge":"\uBE0C\uB9BF\uC9C0 \uB9AC\uBDF0","reviewPurchase":"\uB9E4\uC218 \uAC80\uD1A0","reviewSwap":"\uC2A4\uC651 \uAC80\uD1A0","seeDetails":"\uC790\uC138\uD788 \uBCF4\uAE30","showAll":"\uBAA8\uB450 \uBCF4\uAE30","startBridging":"\uBE0C\uB9BF\uC9C0 \uC2DC\uC791\uD558\uAE30","startSwapping":"\uC2A4\uC651 \uC2DC\uC791\uD558\uAE30","swap":"\uC2A4\uC651","tryAgain":"\uB2E4\uC2DC \uC2DC\uB3C4","viewCoverage":"\uBCF4\uC7A5 \uBC94\uC704","viewOnExplorer":"\uD0D0\uC0C9\uAE30\uC5D0\uC11C \uBCF4\uAE30"},"header":{"activeTransactions":"\uD65C\uC131\uD654\uB41C \uAC70\uB798","bridge":"\uBE0C\uB9BF\uC9C0","checkout":"\uC8FC\uBB38","exchange":"\uAD50\uD658","from":"\uB2E4\uC74C\uC5D0\uC11C \uC2A4\uC651","gas":"\uAC00\uC2A4","payWith":"\uACB0\uC81C \uC218\uB2E8","purchase":"\uAD6C\uC785","purchaseDetails":"\uC8FC\uBB38 \uC138\uBD80\uC0AC\uD56D","selectChain":"\uCCB4\uC778 \uC120\uD0DD","selectWallet":"\uC9C0\uAC11 \uC120\uD0DD","settings":"\uC124\uC815","swap":"\uC2A4\uC651","to":"\uB2E4\uC74C\uC73C\uB85C \uC2A4\uC651","transactionDetails":"\uAC70\uB798 \uC138\uBD80\uC0AC\uD56D","transactionHistory":"\uAC70\uB798 \uB0B4\uC5ED","walletConnected":"\uC9C0\uAC11 \uC5F0\uACB0\uB428","youGet":"\uBC1B\uB294 \uC218\uB7C9"},"info":{"message":{"autoRefuel":"\uD604\uC7AC {{chainName}} \uAC00\uC2A4\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4. \uC774 \uAE30\uB2A5\uC744 \uD1B5\uD558\uC5EC \uC2A4\uC651\uC744 \uC644\uB8CC\uD560 \uAC00\uC2A4\uB97C \uBCF4\uCDA9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","emptyActiveTransactions":"\uC9C4\uD589 \uC911\uC778 \uC2A4\uC651\uC774 \uC5EC\uAE30\uC5D0 \uB098\uD0C0\uB0A9\uB2C8\uB2E4. \uC644\uB8CC \uD6C4\uC5D0\uB294 \uC2A4\uC651 \uAE30\uB85D\uC744 \uCC38\uC870\uD558\uC2ED\uC2DC\uC624","emptyTokenList":"{{chainName}} \uCCB4\uC778\uC5D0\uC11C \uD1A0\uD070\uC744 \uCC3E\uC744 \uC218 \uC5C6\uAC70\uB098 \uBCF4\uC720 \uC911\uC778 \uD1A0\uD070\uC774 \uC544\uB2D9\uB2C8\uB2E4. \uB2E4\uC2DC \uAC80\uC0C9\uD558\uAC70\uB098 \uB2E4\uB978 \uCCB4\uC778\uC744 \uC120\uD0DD\uD558\uC2ED\uC2DC\uC624.","emptyTransactionHistory":"\uC2A4\uC651 \uAE30\uB85D\uC740 \uB85C\uCEEC\uC5D0\uB9CC \uC800\uC7A5\uB418\uBA70 \uBE0C\uB77C\uC6B0\uC800 \uB370\uC774\uD130\uB97C \uC9C0\uC6B0\uBA74 \uC0AD\uC81C\uB429\uB2C8\uB2E4.","routeNotFound":"\uC774\uC720: \uB0AE\uC740 \uC720\uB3D9\uC131, \uC120\uD0DD\uB41C \uC218\uB7C9\uC774 \uB108\uBB34 \uC801\uC74C, \uAC00\uC2A4\uBE44\uAC00 \uB108\uBB34 \uBE44\uC2F8\uAC70\uB098 \uACBD\uB85C\uAC00 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC74C"},"title":{"autoRefuel":"\uAC00\uC2A4 \uBC1B\uAE30","emptyActiveTransactions":"\uD65C\uC131\uD654\uB41C \uAC70\uB798\uAC00 \uC5C6\uC74C","emptyTransactionHistory":"\uCD5C\uADFC \uAC70\uB798 \uC5C6\uC74C","routeNotFound":"\uAC00\uB2A5\uD55C \uACBD\uB85C\uAC00 \uC5C6\uC74C"}},"success":{"message":{"exchangePartiallySuccessful":"\uC2A4\uC651\uC744 \uC2DC\uB3C4\uD588\uC9C0\uB9CC, {{tokenSymbol}} \uD1A0\uD070\uC5D0 \uB300\uD55C {{tool}}\uC758 \uC720\uB3D9\uC131\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4.","exchangeSuccessful":"{{walletAddress}} \uC9C0\uAC11\uC758 {{chainName}} \uCCB4\uC778\uC5D0 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}\uC774(\uAC00) \uC788\uC2B5\uB2C8\uB2E4.","purchaseSuccessful":"{{walletAddress}} \uC9C0\uAC11\uC758 {{chainName}} \uCCB4\uC778\uC5D0 {{assetName}} \uC744 \uD68D\uB4DD\uD558\uC168\uC2B5\uB2C8\uB2E4."},"title":{"bridgePartiallySuccessful":"\uBD80\uBD84 \uC2A4\uC651 \uC131\uACF5","bridgeSuccessful":"\uBE0C\uB9BF\uC9C0 \uC131\uACF5","purchaseSuccessful":"\uAD6C\uC785 \uC131\uACF5","refundIssued":"\uD658\uBD88\uB418\uC5C8\uC2B5\uB2C8\uB2E4","swapPartiallySuccessful":"\uBD80\uBD84 \uC2A4\uC651 \uC131\uACF5","swapSuccessful":"\uC2A4\uC651 \uC131\uACF5"}},"warning":{"message":{"deleteActiveTransactions":"\uD65C\uC131\uD654\uB41C \uC2A4\uC651\uC740 \uB85C\uCEEC\uC5D0\uB9CC \uC800\uC7A5\uB418\uBA70 \uC0AD\uC81C\uC2DC \uBCF5\uAD6C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","deleteTransactionHistory":"\uC2A4\uC651 \uAE30\uB85D\uC740 \uB85C\uCEEC\uC5D0\uB9CC \uC800\uC7A5\uB418\uBA70 \uC0AD\uC81C\uC2DC \uBCF5\uAD6C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","highValueLoss":"\uBC1B\uC740 \uD1A0\uD070\uC758 \uAC00\uCE58\uAC00 \uC2A4\uC651\uB41C \uD1A0\uD070 \uBC0F \uD2B8\uB79C\uC7AD\uC158 \uBE44\uC6A9\uBCF4\uB2E4 \uC0C1\uB2F9\uD788 \uB0AE\uC2B5\uB2C8\uB2E4.","insufficientFunds":"\uC2A4\uC651\uC744 \uC9C4\uD589\uD560 \uC790\uAE08\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4.","insufficientGas":"\uC2A4\uC651\uC744 \uC9C4\uD589\uD560 \uAC00\uC2A4\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4. \uCD5C\uC18C \uB2E4\uC74C\uACFC \uAC19\uC740 \uAC00\uC2A4\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4:","rateChanged":"\uAC70\uB798 \uBE44\uC728\uC774 \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uC2A4\uC651\uC744 \uACC4\uC18D\uD558\uBA74 \uC0C8\uB85C\uC6B4 \uBE44\uC728\uC774 \uC801\uC6A9\uB429\uB2C8\uB2E4.","resetSettings":"\uC6B0\uC120 \uACBD\uB85C, \uC2AC\uB9AC\uD53C\uC9C0, \uAC00\uC2A4 \uBE44\uC6A9, \uD65C\uC131\uD654\uB41C \uBE0C\uB9BF\uC9C0 \uBC0F \uAC70\uB798\uC18C\uAC00 \uC7AC\uC124\uC815\uB429\uB2C8\uB2E4."},"title":{"deleteActiveTransactions":"\uBAA8\uB4E0 \uD65C\uC131\uD654\uB41C \uAC70\uB798\uB97C \uC0AD\uC81C\uD569\uB2C8\uAE4C?","deleteTransaction":"\uC774 \uAC70\uB798\uB97C \uC0AD\uC81C\uD569\uB2C8\uAE4C?","deleteTransactionHistory":"\uAC70\uB798 \uB0B4\uC5ED\uC744 \uC0AD\uC81C\uD569\uB2C8\uAE4C?","highValueLoss":"\uB192\uC740 \uAC00\uCE58 \uC190\uC2E4","insufficientGas":"\uAC00\uC2A4 \uBD80\uC871","rateChanged":"\uBE44\uC728 \uBCC0\uACBD\uB428","resetSettings":"\uC124\uC815\uC744 \uCD08\uAE30\uD654\uD569\uB2C8\uAE4C?"}},"error":{"message":{"allowanceRequired":"{{tokenSymbol}} \uC774\uCCB4 \uAE08\uC561\uC774 \uD55C\uB3C4\uB97C \uCD08\uACFC\uD588\uC2B5\uB2C8\uB2E4. \uD55C\uB3C4\uB97C \uC99D\uC561\uD55C \uB4A4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC2ED\uC2DC\uC624.","insufficientFunds":"\uD2B8\uB79C\uC7AD\uC158\uC5D0 \uD544\uC694\uD55C \uAC00\uC2A4\uBE44\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4.","slippageThreshold":"\uC2AC\uB9AC\uD53C\uC9C0\uAC00 \uD55C\uACC4\uC810\uBCF4\uB2E4 \uD07D\uB2C8\uB2E4. \uC0C8\uB85C\uC6B4 \uACAC\uC801\uC744 \uC5BB\uAE30 \uC704\uD574 \uC0C8 \uACBD\uB85C\uB97C \uC694\uCCAD\uD558\uC2ED\uC2DC\uC624.","transactionFailed":"\uC790\uC138\uD55C \uC815\uBCF4\uB294 \uBE14\uB85D \uD0D0\uC0C9\uAE30\uC5D0\uC11C \uD655\uC778\uD558\uC138\uC694.","transactionNotSent":"\uD2B8\uB79C\uC7AD\uC158 \uC804\uC1A1\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. {{chainName}}\uC758 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}\uC774 \uC9C0\uAC11\uC5D0 \uB0A8\uC544\uC788\uC2B5\uB2C8\uB2E4.","transactionRejected":"\uD2B8\uB79C\uC7AD\uC158 \uC644\uB8CC\uB97C \uC704\uD574 \uC11C\uBA85\uC774 \uD544\uC694\uD569\uB2C8\uB2E4. {{chainName}}\uC758 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}\uC774 \uC9C0\uAC11\uC5D0 \uB0A8\uC544\uC788\uC2B5\uB2C8\uB2E4.","unknown":"\uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uACE0\uAC1D \uC13C\uD130\uC5D0 \uBB38\uC758\uD558\uC2ED\uC2DC\uC624."},"title":{"allowanceRequired":"\uD55C\uB3C4 \uBD80\uC871","balanceIsTooLow":"\uC794\uC561\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4.","chainSwitch":"\uCCB4\uC778\uC744 \uBCC0\uACBD\uD558\uC2ED\uC2DC\uC624","gasLimitIsTooLow":"\uAC00\uC2A4 \uD55C\uB3C4\uAC00 \uB108\uBB34 \uB0AE\uC2B5\uB2C8\uB2E4","insufficientFunds":"\uC794\uACE0 \uBD80\uC871","slippageNotMet":"\uC2AC\uB9AC\uD53C\uC9C0 \uC870\uAC74\uC744 \uCDA9\uC871\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.","transactionCanceled":"\uAC70\uB798\uAC00 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4","transactionFailed":"\uAC70\uB798\uAC00 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4","transactionRejected":"\uC11C\uBA85\uC774 \uD544\uC694\uD569\uB2C8\uB2E4","transactionUnderpriced":"\uAC70\uB798 \uAC00\uACA9\uC774 \uB108\uBB34 \uB0AE\uC2B5\uB2C8\uB2E4","transactionUnprepared":"\uD2B8\uB79C\uC7AD\uC158\uC744 \uC9C4\uD589\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","unknown":"\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","walletAddressInvalid":"\uC9C0\uAC11 \uC8FC\uC18C\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.","walletAddressRequired":"\uC9C0\uAC11 \uC8FC\uC18C\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.","walletEnsAddressInvalid":"\uC9C0\uAC11 \uC8FC\uC18C\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uAC70\uB098 \uB124\uD2B8\uC6CC\uD06C\uAC00 ENS\uB97C \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."}},"tooltip":{"additionalProviderFee":"\uCD94\uAC00\uC801\uC778 \uBE0C\uB9BF\uC9C0, \uB371\uC2A4, \uADF8\uB9AC\uACE0 \uC11C\uBE44\uC2A4 \uC218\uC218\uB8CC","estimatedNetworkFee":"\uC608\uC0C1 \uB124\uD2B8\uC6CC\uD06C \uC218\uC218\uB8CC","estimatedTime":"\uC608\uC0C1 \uC2A4\uC651 \uC2DC\uAC04(\uBD84)","notFound":{"text":"\uD398\uC774\uC9C0\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","title":"404"},"numberOfSteps":"\uC5EC\uB7EC \uC2A4\uC651 \uB2E8\uACC4. \uAC01 \uB2E8\uACC4 \uC9C4\uD589\uC744 \uC704\uD574\uC11C\uB294 1-2\uAC1C\uC758 \uD2B8\uB79C\uC7AD\uC158 \uC11C\uBA85\uC774 \uD544\uC694\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","progressToNextUpdate":"\uD45C\uC2DC\uB41C \uB370\uC774\uD130\uAC00 {{value}} \uCD08 \uD6C4\uC5D0 \uC790\uB3D9 \uC0C8\uB85C\uACE0\uCE68 \uB429\uB2C8\uB2E4. \uC218\uB3D9\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8 \uD558\uB824\uBA74 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.","recommended":"\uD3B8\uB9AC\uC131\uACFC \uBCF5\uC7A1\uC131\uC5D0 \uADE0\uD615\uC744 \uB454 \uC800\uB834\uD55C \uB8E8\uD2B8","settingsModified":"\uC124\uC815 (\uC218\uC815\uB428)"},"main":{"crossStepDetails":"{{tool}}\uC744 \uD1B5\uD574 {{from}}(\uC73C)\uB85C\uBD80\uD130 {{to}}(\uC73C)\uB85C \uBE0C\uB9BF\uC9C0","currentAmount":"\uD604\uC7AC \uC218\uB7C9","estimatedTime":"{{value}}\uBD84","featuredTokens":"\uC8FC\uC694 \uD1A0\uD070","from":"[Value] \uB97C","fromAmount":"\uC9C0\uBD88 \uC218\uB7C9","gasCost":"\uAC00\uC2A4\uBE44","gasFeeEstimated":"\uC608\uC0C1 \uAC00\uC2A4\uBE44","gasFeePaid":"\uAC00\uC2A4\uBE44 \uC9C0\uBD88\uB428","inProgress":"\uC9C4\uD589 \uC911","nftStepDetails":"{{tool}} \uB97C \uD1B5\uD574 NFT \uAD6C\uC785","onChain":"{{chainName}} \uC5D0\uC11C","otherTokens":"\uB2E4\uB978 \uD1A0\uD070","ownedBy":"\uC18C\uC720\uC790: ","process":{"crossChain":{"actionRequired":"\uD2B8\uB79C\uC7AD\uC158\uC744 \uC11C\uBA85\uD558\uC2ED\uC2DC\uC624.","done":"\uBE0C\uB9BF\uC9C0 \uD2B8\uB79C\uC7AD\uC158\uC774 \uD655\uC778\uB428","pending":"\uBE0C\uB9BF\uC9C0 \uD2B8\uB79C\uC7AD\uC158 \uB300\uAE30 \uC911","started":"\uBE0C\uB9BF\uC9C0 \uD2B8\uB79C\uC7AD\uC158 \uC900\uBE44 \uC911"},"nft":{"done":"NFT \uAD6C\uC785 \uC131\uACF5"},"receivingChain":{"done":"\uBE0C\uB9BF\uC9C0 \uC644\uB8CC","partial":"\uBE0C\uB9BF\uC9C0 \uBD80\uBD84 \uC644\uB8CC","pending":"\uB3C4\uCC29 \uCCB4\uC778 \uB300\uAE30 \uC911","refunded":"\uBE0C\uB9BF\uC9C0 \uD2B8\uB79C\uC7AD\uC158 \uD658\uBD88\uB428"},"swap":{"actionRequired":"\uD2B8\uB79C\uC7AD\uC158\uC744 \uC11C\uBA85\uD558\uC2ED\uC2DC\uC624","done":"\uC2A4\uC651 \uC644\uB8CC","pending":"\uC2A4\uC651 \uD2B8\uB79C\uC7AD\uC158 \uB300\uAE30 \uC911","started":"\uC2A4\uC651 \uD2B8\uB79C\uC7AD\uC158 \uC900\uBE44 \uC911"},"switchChain":{"actionRequired":"\uCCB4\uC778 \uC804\uD658 \uC694\uCCAD\uB428","done":"\uCCB4\uC778 \uC804\uD658 \uC644\uB8CC"},"tokenAllowance":{"done":"\uD1A0\uD070 \uD5C8\uC6A9 \uC2B9\uC778\uB428","pending":"\uD1A0\uD070 \uD5C8\uC6A9 \uB300\uAE30 \uC911","started":"\uD1A0\uD070 \uD5C8\uC6A9 \uC124\uC815"}},"quotedAmount":"\uACAC\uC801","rateChange":"\uBE44\uC728 \uBCC0\uACBD","receiving":"\uBC1B\uB294 \uC911","refuelStepDetails":"{{tool}} \uB97C \uD1B5\uD574 \uAC00\uC2A4 \uC5BB\uAE30","selectChain":"\uCCB4\uC778 \uC120\uD0DD","selectChainAndToken":"\uCCB4\uC778\uACFC \uD1A0\uD070 \uC120\uD0DD","selectToken":"\uD1A0\uD070 \uC120\uD0DD","sendToAddress":"{{address}}\uB85C \uC804\uC1A1","sendToWallet":"\uB2E4\uB978 \uC9C0\uAC11\uC73C\uB85C \uC804\uC1A1","sending":"\uC804\uC1A1\uC911","sentToAddress":"{{address}}\uB85C \uC804\uC1A1","stepBridge":"\uBE0C\uB9BF\uC9C0","stepBridgeAndBuy":"\uBE0C\uB9BF\uC9C0 \uADF8\uB9AC\uACE0 \uB9E4\uC218","stepDetails":"LI.FI \uB97C \uD1B5\uD55C {{tool}}","stepSwap":"\uC2A4\uC651","stepSwapAndBridge":"\uC2A4\uC651 \uADF8\uB9AC\uACE0 \uBE0C\uB9BF\uC9C0","stepSwapAndBuy":"\uC2A4\uC651 \uADF8\uB9AC\uACE0 \uB9E4\uC218","supportId":"\uC11C\uD3EC\uD2B8 ID","swapStepDetails":"{{tool}}\uB85C {{chain}}\uC5D0\uC11C \uC2A4\uC651","tags":{"cheapest":"\uC800\uB834\uD55C","fastest":"\uBE60\uB974\uAC8C","insurable":"\uBCF4\uD5D8 \uC801\uC6A9 \uAC00\uB2A5\uD55C","insurance":"\uBCF4\uD5D8","insured":"\uBCF4\uD5D8 \uC801\uC6A9\uB428","recommended":"\uCD94\uCC9C","safest":"\uC548\uC804\uD55C"},"to":"\uB3C4\uCC29","tokenOnChain":"{{chainName}}\uC758 {{tokenSymbol}}","tokenOnChainAmount":"{{chainName}}\uC758 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}","tokenSearch":"\uC774\uB984 \uB610\uB294 \uCEE8\uD2B8\uB799\uD2B8 \uC8FC\uC18C\uB97C \uD1B5\uD574 \uAC80\uC0C9","valueLoss":"\uAC00\uCE58 \uC190\uC2E4","walletAddressOrEns":"\uC9C0\uAC11 \uC8FC\uC18C \uB610\uB294 ENS"},"insurance":{"bridgeExploits":"\uBE0C\uB9BF\uC9C0 \uC624\uB958, \uD574\uD0B9, \uCDE8\uC57D\uC810 \uACF5\uACA9","insure":"\uBE0C\uB9BF\uC9C0 \uC911\uC778 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \uBCF4\uD5D8 \uC801\uC6A9","insured":"\uBE0C\uB9BF\uC9C0 \uC911\uC778 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \uBCF4\uD5D8 \uC801\uC6A9 \uC644\uB8CC","slippageError":"\uBC1B\uC744 \uD1A0\uD070\uC758 \uC2AC\uB9AC\uD53C\uC9C0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."},"settings":{"enabledBridges":"\uD65C\uC131\uD654\uB41C \uBE0C\uB9BF\uC9C0","enabledExchanges":"\uC9C0\uC6D0 \uAC70\uB798\uC18C","gasPrice":{"fast":"\uBE60\uB974\uAC8C","normal":"\uD45C\uC900","slow":"\uB290\uB9AC\uAC8C","title":"\uAC00\uC2A4 \uAC00\uACA9"},"routePriority":"\uC6B0\uC120 \uACBD\uB85C","showDestinationWallet":"\uBC1B\uB294 \uC9C0\uAC11 \uBCF4\uAE30","slippage":"\uC2AC\uB9AC\uD53C\uC9C0"},"wallet":{"extensionNotFound":"\uC774 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uAE30 \uC804 {{name}} \uBE0C\uB77C\uC6B0\uC800\uB9CC \uD65C\uC131\uD654 \uC0C1\uD0DC\uC778\uC9C0 \uD655\uC778\uD558\uC2ED\uC2DC\uC624."}}');


var $76aa1cc1836a1d30$exports = {};
$76aa1cc1836a1d30$exports = JSON.parse('{"language":{"name":"Portugu\xeas","title":"Idioma"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"Autom\xe1tico","bridge":"Ponte","buy":"Comprar","buyNow":"Comprar agora","cancel":"Cancelar","connectWallet":"Conectar carteira","contactSupport":"Falar com o suporte","continue":"Continuar","copyAddress":"Copiar endere\xe7o","dark":"Escuro","delete":"Apagar","disconnect":"Desconectar","done":"Conclu\xeddo","exchange":"Convers\xe3o","getGas":"Obter g\xe1s","hide":"Ocultar","learnMore":"Saiba mais","lifiCheckout":"Finalizar Compra LI.FI","lifiExchange":"Convers\xe3o LI.FI","light":"Claro","max":"m\xe1ximo","ok":"Tudo certo","removeTransaction":"Remover transa\xe7\xe3o","reset":"Redefinir","resetSettings":"Redefinir as configura\xe7\xf5es","reviewBridge":"Revisar ponte","reviewPurchase":"Revisar compra","reviewSwap":"Rever convers\xe3o","seeDetails":"Ver detalhes","showAll":"Mostrar tudo","startBridging":"Iniciar ponte","startSwapping":"Iniciar convers\xe3o","swap":"Convers\xe3o","tryAgain":"Tente novamente","viewCoverage":"Ver cobertura","viewOnExplorer":"Ver no explorador"},"header":{"activeTransactions":"Transa\xe7\xf5es ativas","bridge":"Ponte","checkout":"Finalizar","exchange":"Convers\xe3o","from":"Converter a partir de","gas":"G\xe1s","payWith":"Pagar com","purchase":"Compra","purchaseDetails":"Detalhes da compra","selectChain":"Selecionar uma rede","selectWallet":"Selecionar sua carteira","settings":"Configura\xe7\xf5es","swap":"Convers\xe3o","to":"Converter para","transactionDetails":"Detalhes da transa\xe7\xe3o","transactionHistory":"Hist\xf3rico de transa\xe7\xf5es","walletConnected":"Carteira conectada","youGet":"Voc\xea recebe"},"info":{"message":{"autoRefuel":"Voc\xea est\xe1 com pouco g\xe1s na rede {{chainName}}. Ao continuar, voc\xea obter\xe1 g\xe1s suficiente para completar a convers\xe3o.","emptyActiveTransactions":"As transa\xe7\xf5es em andamento aparecer\xe3o aqui. Uma vez conclu\xeddas, encontre-as no hist\xf3rico de transa\xe7\xf5es.","emptyTokenList":"N\xe3o conseguimos encontrar tokens na rede {{chainName}} ou voc\xea n\xe3o possui nenhum. Por favor, procure pelo endere\xe7o de contrato caso o token n\xe3o apare\xe7a ou escolha outra rede.","emptyTransactionHistory":"O hist\xf3rico de transa\xe7\xf5es \xe9 armazenado apenas localmente e ser\xe1 exclu\xeddo se voc\xea limpar os dados do seu navegador.","routeNotFound":"Raz\xf5es para isso podem ser: baixa liquidez, valor selecionado \xe9 muito baixo, os custos com g\xe1s s\xe3o muito elevados ou n\xe3o h\xe1 rotas para a combina\xe7\xe3o selecionada."},"title":{"autoRefuel":"Obter g\xe1s","emptyActiveTransactions":"Nenhuma transa\xe7\xe3o ativa","emptyTransactionHistory":"Nenhuma transa\xe7\xe3o recente","routeNotFound":"Nenhuma rota dispon\xedvel"}},"success":{"message":{"exchangePartiallySuccessful":"Tentamos completar a transa\xe7\xe3o, mas {{tool}} ficou sem liquidez com o token {{tokenSymbol}}.","exchangeSuccessful":"Agora h\xe1 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na carteira {{walletAddress}} na rede {{chainName}}.","purchaseSuccessful":"Agora voc\xea tem {{assetName}} na carteira {{walletAddress}} na cadeia {{chainName}}"},"title":{"bridgePartiallySuccessful":"Ponte parcialmente conclu\xedda","bridgeSuccessful":"Ponte bem sucedida","purchaseSuccessful":"Compra efetuada com sucesso","refundIssued":"Reembolso emitido","swapPartiallySuccessful":"Convers\xe3o parcialmente bem sucedida","swapSuccessful":"Convers\xe3o bem sucedida"}},"warning":{"message":{"deleteActiveTransactions":"Transa\xe7\xf5es ativas s\xe3o armazenadas apenas localmente e n\xe3o podem ser recuperadas se voc\xea exclu\xed-las.","deleteTransactionHistory":"O hist\xf3rico de convers\xf5es \xe9 armazenado apenas localmente e n\xe3o pode ser recuperado caso seja exclu\xeddo.","highValueLoss":"A quantidade de tokens a serem recebidos \xe9 significativamente menor do que os tokens convertidos e os custos da transa\xe7\xe3o.","insufficientFunds":"Voc\xea n\xe3o possui fundos suficientes para completar a convers\xe3o.","insufficientGas":"Voc\xea n\xe3o tem g\xe1s suficiente para completar a convers\xe3o. \xc9 necess\xe1rio adicionar pelo menos:","rateChanged":"A taxa de c\xe2mbio mudou. Ao continuar a convers\xe3o, voc\xea aceitar\xe1 a nova taxa.","resetSettings":"Isto redefinir\xe1 sua prioridade de rota, toler\xe2ncia a derrapagem, pre\xe7o de g\xe1s, pontes e trocas ativadas."},"title":{"deleteActiveTransactions":"Excluir todas as transa\xe7\xf5es ativas?","deleteTransaction":"Excluir esta transa\xe7\xe3o?","deleteTransactionHistory":"Excluir hist\xf3rico de transa\xe7\xe3o?","highValueLoss":"Alta perda de valor","insufficientGas":"G\xe1s insuficiente","rateChanged":"Taxa alterada","resetSettings":"Redefinir as configura\xe7\xf5es?"}},"error":{"message":{"allowanceRequired":"A quantidade a ser transferida para {{tokenSymbol}} excede a sua permiss\xe3o atual. Por favor, aumente a sua permiss\xe3o e tente novamente.","insufficientFunds":"Voc\xea n\xe3o tem g\xe1s suficiente para cobrir o custo da transa\xe7\xe3o.","slippageThreshold":"A derrapagem \xe9 maior do que o limite definido. Solicite uma nova rota para obter uma nova cota\xe7\xe3o.","transactionFailed":"Por favor, verifique o explorador de blocos para mais informa\xe7\xf5es.","transactionNotSent":"A transa\xe7\xe3o n\xe3o foi enviada. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na {{chainName}} permanece na sua carteira.","transactionRejected":"Sua assinatura \xe9 necess\xe1ria para completar a transa\xe7\xe3o. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} em {{chainName}} permanece na sua carteira.","unknown":"Por favor, tente novamente ou fale com o suporte."},"title":{"allowanceRequired":"Permiss\xe3o insuficiente","balanceIsTooLow":"O saldo \xe9 muito baixo","chainSwitch":"Necess\xe1rio mudan\xe7a de rede","gasLimitIsTooLow":"O limite de g\xe1s \xe9 muito baixo","insufficientFunds":"Saldo insuficiente","slippageNotMet":"Condi\xe7\xf5es de toler\xe2ncia a discrep\xe2ncias n\xe3o foram atendidas","transactionCanceled":"Transa\xe7\xe3o cancelada","transactionFailed":"Transa\xe7\xe3o falhou","transactionRejected":"Necess\xe1rio assinatura","transactionUnderpriced":"Transa\xe7\xe3o est\xe1 abaixo do valor","transactionUnprepared":"N\xe3o foi poss\xedvel preparar a transa\xe7\xe3o","unknown":"Algo deu errado","walletAddressInvalid":"Endere\xe7o da carteira \xe9 inv\xe1lido.","walletAddressRequired":"Endere\xe7o da carteira \xe9 necess\xe1rio.","walletEnsAddressInvalid":"O endere\xe7o da carteira \xe9 inv\xe1lido ou a rede n\xe3o suporta ENS."}},"tooltip":{"additionalProviderFee":"Pontes adicionais, DEXes e taxas de servi\xe7o.","estimatedNetworkFee":"Taxa de rede estimada.","estimatedTime":"Tempo de execu\xe7\xe3o da convers\xe3o estimado em minutos.","notFound":{"text":"N\xe3o conseguimos encontrar esta p\xe1gina.","title":"404"},"numberOfSteps":"Um n\xfamero de passos para a convers\xe3o. Cada etapa pode conter 1-2 transa\xe7\xf5es que requerem uma assinatura.","progressToNextUpdate":"Os dados exibidos ser\xe3o atualizados automaticamente ap\xf3s {{value}} segundos. Clique aqui para atualizar manualmente.","recommended":"Uma rota econ\xf4mica que equilibra complexidade e facilidade de uso.","settingsModified":"Configura\xe7\xf5es (modificado)"},"main":{"crossStepDetails":"Ponte de {{from}} para {{to}} via {{tool}}","currentAmount":"Quantidade atual","estimatedTime":"{{value}}min","featuredTokens":"Tokens em destaque","from":"De","fromAmount":"Voc\xea paga","gasCost":"Custo do g\xe1s","gasFeeEstimated":"Taxa de g\xe1s estimada","gasFeePaid":"taxa de g\xe1s paga","inProgress":"em andamento","nftStepDetails":"Comprar NFT via {{tool}}","onChain":"em {{chainName}}","otherTokens":"Outros tokens","ownedBy":"Possu\xeddo por","process":{"crossChain":{"actionRequired":"Por favor, assine a transa\xe7\xe3o","done":"Transa\xe7\xe3o da ponte confirmada","pending":"Aguardando a transa\xe7\xe3o da ponte","started":"Preparando a transa\xe7\xe3o da ponte"},"nft":{"done":"NFT comprado"},"receivingChain":{"done":"Ponte conclu\xedda","partial":"Ponte parcialmente conclu\xedda","pending":"Aguardando a rede de destino","refunded":"Transa\xe7\xe3o de ponte reembolsada"},"swap":{"actionRequired":"Por favor, assine a transa\xe7\xe3o","done":"Convers\xe3o conclu\xedda","pending":"Aguardando a transa\xe7\xe3o de convers\xe3o","started":"Preparando a transa\xe7\xe3o de convers\xe3o"},"switchChain":{"actionRequired":"Necess\xe1rio mudan\xe7a de rede","done":"Rede alterada com sucesso"},"tokenAllowance":{"done":"Permiss\xe3o de token aprovada","pending":"Aguardando a permiss\xe3o do token","started":"Configurando a permiss\xe3o do token"}},"quotedAmount":"Valor da cota\xe7\xe3o","rateChange":"Alterar taxa","receiving":"Recebendo","refuelStepDetails":"Obter g\xe1s via {{tool}}","selectChain":"Selecione a rede","selectChainAndToken":"Selecione a rede e o token","selectToken":"Selecione o Token","sendToAddress":"Enviar para","sendToWallet":"Enviar para uma carteira diferente","sending":"Enviando","sentToAddress":"Enviar para","stepBridge":"Ponte","stepBridgeAndBuy":"Transfira e compre","stepDetails":"{{tool}} via LI.FI","stepSwap":"Convers\xe3o","stepSwapAndBridge":"Converter e enviar pela ponte","stepSwapAndBuy":"Converta e compre","supportId":"ID de suporte","swapStepDetails":"Converter na {{chain}} via {{tool}}","tags":{"cheapest":"Barato","fastest":"R\xe1pido","insurable":"Assegur\xe1vel","insurance":"Seguro","insured":"Segurado","recommended":"Recomendado","safest":"Seguro"},"to":"Para","tokenOnChain":"{{tokenSymbol}} na {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na {{chainName}}","tokenSearch":"Pesquisar pelo nome do token ou endere\xe7o","valueLoss":"Perda de Valor","walletAddressOrEns":"Endere\xe7o da carteira ou nome ENS"},"insurance":{"bridgeExploits":"Mau funcionamento da ponte, hacks ou exploits","insure":"Contratar seguro para <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> em tr\xe2nsito.","insured":"Voc\xea contratou seguro para <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> em tr\xe2nsito:","slippageError":"Erro na discrep\xe2ncia para tokens recebidos"},"settings":{"enabledBridges":"Pontes habilitadas","enabledExchanges":"Corretoras habilitadas","gasPrice":{"fast":"R\xe1pido","normal":"Normal","slow":"Lento","title":"Pre\xe7o do g\xe1s"},"routePriority":"Prioridade de rota / caminho","showDestinationWallet":"Mostrar carteira de destino","slippage":"Derrapagem","resetSettings":"Voc\xea est\xe1 usando a configura\xe7\xe3o personalizada que limita a quantidade de rotas dispon\xedveis."},"wallet":{"extensionNotFound":"Por favor, certifique-se de que apenas a extens\xe3o do navegador da {{name}} est\xe1 ativa antes de escolher esta carteira."}}');


var $3178763582914df2$exports = {};
$3178763582914df2$exports = JSON.parse('{"language":{"name":"\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22","title":"\u0E20\u0E32\u0E29\u0E32"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34","bridge":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","buy":"\u0E0B\u0E37\u0E49\u0E2D","buyNow":"\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49","cancel":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","connectWallet":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D \u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32","contactSupport":"\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19","continue":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","copyAddress":"\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","dark":"\u0E21\u0E37\u0E14","delete":"\u0E25\u0E1A","disconnect":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","done":"\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19","exchange":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","getGas":"\u0E23\u0E31\u0E1A\u0E41\u0E01\u0E47\u0E2A","hide":"\u0E0B\u0E48\u0E2D\u0E19","learnMore":"\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","lifiCheckout":"Li.Fi. \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A","lifiExchange":"LI.FI Exchange","light":"\u0E2A\u0E27\u0E48\u0E32\u0E07","max":"\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14","ok":"\u0E15\u0E01\u0E25\u0E07","removeTransaction":"\u0E19\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01","reset":"\u0E25\u0E49\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25","resetSettings":"\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","reviewBridge":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","reviewPurchase":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D","reviewSwap":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","seeDetails":"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14","showAll":"\u0E41\u0E2A\u0E14\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","startBridging":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","startSwapping":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","swap":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","tryAgain":"\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48","viewCoverage":"\u0E14\u0E39\u0E04\u0E27\u0E32\u0E21\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07","viewOnExplorer":"\u0E14\u0E39\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08"},"header":{"activeTransactions":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E21\u0E35\u0E1C\u0E25","bridge":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","checkout":"\u0E40\u0E0A\u0E47\u0E04\u0E40\u0E2D\u0E32\u0E17\u0E4C","exchange":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","from":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E08\u0E32\u0E01","gas":"\u0E41\u0E01\u0E47\u0E2A","payWith":"\u0E0A\u0E33\u0E23\u0E30\u0E14\u0E49\u0E27\u0E22","purchase":"\u0E0B\u0E37\u0E49\u0E2D","purchaseDetails":"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D","selectChain":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E0A\u0E19","selectWallet":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","settings":"\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","swap":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","to":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E1B\u0E47\u0E19","transactionDetails":"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E02\u0E2D\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","transactionHistory":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E22","walletConnected":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E16\u0E39\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27","youGet":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A"},"info":{"message":{"autoRefuel":"\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E41\u0E01\u0E47\u0E2A {{chainName}} \u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E19\u0E49\u0E2D\u0E22 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E41\u0E01\u0E47\u0E2A\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","emptyActiveTransactions":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48. \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19, \u0E08\u0E30\u0E1E\u0E1A\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19.","emptyTokenList":"\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E43\u0E19 {{chainName}} \u0E40\u0E0A\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19. \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E0A\u0E19\u0E2D\u0E37\u0E48\u0E19.","emptyTransactionHistory":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E41\u0E25\u0E30\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E49\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.","routeNotFound":"\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19 : \u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E15\u0E48\u0E33 , \u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E19\u0E49\u0E2D\u0E22\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B , \u0E15\u0E49\u0E19\u0E17\u0E38\u0E19\u0E41\u0E01\u0E47\u0E2A\u0E2A\u0E39\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49"},"title":{"autoRefuel":"\u0E23\u0E31\u0E1A\u0E41\u0E01\u0E47\u0E2A","emptyActiveTransactions":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1C\u0E25","emptyTransactionHistory":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14","routeNotFound":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07"}},"success":{"message":{"exchangePartiallySuccessful":"\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C\u0E41\u0E15\u0E48 {{tool}} \u0E02\u0E32\u0E14\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19 {{tokenSymbol}}","exchangeSuccessful":"\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E21\u0E35 {{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}} \u0E43\u0E19 {{walletAddress}} \u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E1A\u0E19 {{chainName}} \u0E40\u0E0A\u0E19.","purchaseSuccessful":"\u0E04\u0E38\u0E13\u0E21\u0E35 {{assetName}} \u0E43\u0E19{{walletAddress}} \u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32 \u0E1A\u0E19{{chainName}} \u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22"},"title":{"bridgePartiallySuccessful":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19","bridgeSuccessful":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","purchaseSuccessful":"\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","refundIssued":"\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E41\u0E25\u0E49\u0E27","swapPartiallySuccessful":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19","swapSuccessful":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"}},"warning":{"message":{"deleteActiveTransactions":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E08\u0E30\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E44\u0E14\u0E49\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E2D\u0E2D\u0E01.","deleteTransactionHistory":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E08\u0E30\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E44\u0E14\u0E49\u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E2D\u0E2D\u0E01","highValueLoss":"\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E19\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E01\u0E27\u0E48\u0E32\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E25\u0E30\u0E15\u0E49\u0E19\u0E17\u0E38\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E32\u0E01.","insufficientFunds":"\u0E04\u0E38\u0E13\u0E21\u0E35\u0E40\u0E07\u0E34\u0E19\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E17\u0E35\u0E48\u0E08\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19.","insufficientGas":"\u0E04\u0E38\u0E13\u0E21\u0E35\u0E41\u0E01\u0E4A\u0E2A\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E17\u0E35\u0E48\u0E08\u0E30\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22:","rateChanged":"\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E43\u0E2B\u0E21\u0E48.","resetSettings":"\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E02\u0E2D\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07 \u0E01\u0E32\u0E23\u0E04\u0E25\u0E32\u0E14\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19 \u0E04\u0E48\u0E32\u0E41\u0E01\u0E47\u0E2A \u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19"},"title":{"deleteActiveTransactions":"\u0E25\u0E1A\u200B\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u200B\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14?","deleteTransaction":"\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E19\u0E35\u0E49?","deleteTransactionHistory":"\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21?","highValueLoss":"\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E2A\u0E39\u0E07","insufficientGas":"\u0E04\u0E48\u0E32\u0E41\u0E01\u0E47\u0E2A\u0E44\u0E21\u0E48\u0E1E\u0E2D","rateChanged":"\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","resetSettings":"\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E17\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32?"}},"error":{"message":{"allowanceRequired":"\u0E42\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E08\u0E33\u0E19\u0E27\u0E19 {{tokenSymbol}} \u0E15\u0E32\u0E21\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.\u0E44\u0E14\u0E49\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","insufficientFunds":"\u0E04\u0E38\u0E13\u0E21\u0E35\u0E41\u0E01\u0E47\u0E2A\u0E44\u0E21\u0E48\u0E1E\u0E2D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E19\u0E35\u0E49","slippageThreshold":"\u0E01\u0E32\u0E23\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48\u0E01\u0E27\u0E48\u0E32\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E02\u0E2D\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E2A\u0E19\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E43\u0E2B\u0E21\u0E48.","transactionFailed":"\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21.","transactionNotSent":"\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u0E1A\u0E19 {{chainName}} \u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.","transactionRejected":"\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E21\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u0E1A\u0E19 {{chainName}} \u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.","unknown":"\u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19."},"title":{"allowanceRequired":"\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D","balanceIsTooLow":"\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E15\u0E48\u0E33\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B","chainSwitch":"\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E0A\u0E19","gasLimitIsTooLow":"\u0E41\u0E01\u0E4A\u0E2A\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E15\u0E48\u0E33\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B","insufficientFunds":"\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D","slippageNotMet":"\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E23\u0E32\u0E04\u0E32\u0E44\u0E21\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02.","transactionCanceled":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E41\u0E25\u0E49\u0E27","transactionFailed":"\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","transactionRejected":"\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19","transactionUnderpriced":"\u0E23\u0E32\u0E04\u0E32\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E15\u0E48\u0E33\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B","transactionUnprepared":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E08\u0E31\u0E14\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E44\u0E14\u0E49","unknown":"\u0E21\u0E35\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","walletAddressInvalid":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07.","walletAddressRequired":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19.","walletEnsAddressInvalid":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A ENS."}},"tooltip":{"additionalProviderFee":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21 DEX \u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23","estimatedNetworkFee":"\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E02\u0E2D\u0E07\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22","estimatedTime":"\u0E40\u0E27\u0E25\u0E32\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E19\u0E32\u0E17\u0E35.","notFound":{"text":"\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49.","title":"404"},"numberOfSteps":"\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2B\u0E25\u0E32\u0E22\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19 \u0E41\u0E15\u0E48\u0E25\u0E30\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E21\u0E35 1-2 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19.","progressToNextUpdate":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E08\u0E30\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01 {{value}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35 \u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07","recommended":"\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E21\u0E35\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D\u0E41\u0E25\u0E30\u0E07\u0E48\u0E32\u0E22\u0E15\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19","settingsModified":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 (\u0E41\u0E01\u0E49\u0E44\u0E02)"},"main":{"crossStepDetails":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E08\u0E32\u0E01{{from}} to {{to}} \u0E42\u0E14\u0E22 {{tool}}","currentAmount":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19","estimatedTime":"{{value}} \u0E19\u0E32\u0E17\u0E35","featuredTokens":"\u0E08\u0E38\u0E14\u0E40\u0E14\u0E48\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E2B\u0E23\u0E35\u0E22\u0E0D","from":"\u0E08\u0E32\u0E01","fromAmount":"\u0E04\u0E38\u0E13\u0E08\u0E48\u0E32\u0E22","gasCost":"\u0E04\u0E48\u0E32\u0E41\u0E01\u0E4A\u0E2A","gasFeeEstimated":"\u0E04\u0E48\u0E32\u0E41\u0E01\u0E4A\u0E2A\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13","gasFeePaid":"\u0E08\u0E48\u0E32\u0E22\u0E04\u0E48\u0E32\u0E17\u0E33\u0E40\u0E19\u0E35\u0E22\u0E21\u0E41\u0E25\u0E49\u0E27","inProgress":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","nftStepDetails":"\u0E0B\u0E37\u0E49\u0E2D NFT \u0E1C\u0E48\u0E32\u0E19 {{tool}}","onChain":"\u0E1A\u0E19 {{chainName}}","otherTokens":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E2D\u0E37\u0E48\u0E19","ownedBy":"\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E42\u0E14\u0E22","process":{"crossChain":{"actionRequired":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E0B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","done":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E49\u0E32\u0E21\u0E40\u0E0A\u0E19\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27","pending":"\u0E23\u0E2D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","started":"\u0E40\u0E15\u0E23\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C"},"nft":{"done":"\u0E0B\u0E37\u0E49\u0E2D NFT \u0E41\u0E25\u0E49\u0E27"},"receivingChain":{"done":"\u0E02\u0E49\u0E32\u0E21\u0E40\u0E0A\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","partial":"\u0E01\u0E32\u0E23\u0E02\u0E49\u0E32\u0E21\u0E40\u0E0A\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19","pending":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E40\u0E0A\u0E19\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07","refunded":"\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E49\u0E32\u0E21\u0E40\u0E0A\u0E19\u0E41\u0E25\u0E49\u0E27"},"swap":{"actionRequired":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E0B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","done":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","pending":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","started":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E15\u0E23\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21"},"switchChain":{"actionRequired":"\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E0A\u0E19","done":"\u0E2A\u0E25\u0E31\u0E1A\u0E40\u0E0A\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27"},"tokenAllowance":{"done":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E41\u0E25\u0E49\u0E27","pending":"\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E02\u0E2D\u0E07\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","started":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19"}},"quotedAmount":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E2A\u0E19\u0E2D","rateChange":"\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","receiving":"\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A","refuelStepDetails":"\u0E23\u0E31\u0E1A\u0E41\u0E01\u0E4A\u0E2A\u0E1C\u0E48\u0E32\u0E19 {{tool}}","selectChain":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E0A\u0E19","selectChainAndToken":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E0A\u0E19\u0E41\u0E25\u0E30\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","selectToken":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E17\u0E40\u0E04\u0E19","sendToAddress":"\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{address}}","sendToWallet":"\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E2D\u0E37\u0E48\u0E19","sending":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07","sentToAddress":"\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 {{address}}","stepBridge":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","stepBridgeAndBuy":"\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E41\u0E25\u0E30\u0E0B\u0E37\u0E49\u0E2D","stepDetails":"{{tool}} \u0E42\u0E14\u0E22 LI.FI","stepSwap":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","stepSwapAndBridge":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","stepSwapAndBuy":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19 \u0E41\u0E25\u0E30 \u0E0B\u0E37\u0E49\u0E2D","supportId":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19","swapStepDetails":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E1A\u0E19 {{chain}} \u0E1C\u0E48\u0E32\u0E19 {{tool}}","tags":{"cheapest":"\u0E23\u0E32\u0E04\u0E32\u0E16\u0E39\u0E01","fastest":"\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27","insurable":"\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19","insurance":"\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19","insured":"\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19","recommended":"\u0E41\u0E19\u0E30\u0E19\u0E33","safest":"\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22"},"to":"\u0E16\u0E36\u0E07","tokenOnChain":"{{tokenSymbol}} \u0E1A\u0E19 {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}} \u0E1A\u0E19 {{chainName}}","tokenSearch":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E40\u0E2B\u0E23\u0E35\u0E22\u0E0D \u0E2B\u0E23\u0E37\u0E2D \u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","valueLoss":"\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22","walletAddressOrEns":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2DENS"},"insurance":{"bridgeExploits":"\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C\u0E17\u0E33\u0E07\u0E32\u0E19\u0E1C\u0E34\u0E14\u0E1B\u0E01\u0E15\u0E34 \u0E41\u0E2E\u0E47\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E32\u0E1C\u0E25\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C","insure":"\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19<0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> \u0E43\u0E19\u0E01\u0E32\u0E23\u0E02\u0E19\u0E2A\u0E48\u0E07","insured":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19<0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> \u0E43\u0E19\u0E01\u0E32\u0E23\u0E02\u0E19\u0E2A\u0E48\u0E07","slippageError":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E43\u0E19\u0E01\u0E32\u0E23\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A"},"settings":{"enabledBridges":"\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E23\u0E34\u0E14\u0E08\u0E4C","enabledExchanges":"\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","gasPrice":{"fast":"\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27","normal":"\u0E1B\u0E01\u0E15\u0E34","slow":"\u0E0A\u0E49\u0E32","title":"\u0E04\u0E48\u0E32\u0E41\u0E01\u0E47\u0E2A"},"routePriority":"\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E02\u0E2D\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07","showDestinationWallet":"\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07","slippage":"\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19"},"wallet":{"extensionNotFound":"\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E21\u0E35\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C {{name}} \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E01\u0E48\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E19\u0E35\u0E49."}}');


var $17ee69e88425329d$exports = {};
$17ee69e88425329d$exports = JSON.parse('{"language":{"name":"T\xfcrk\xe7e","title":"Dil"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"Otomatik","bridge":"G\xf6nder","buy":"Sat\u0131n al","buyNow":"Hemen sat\u0131n al","cancel":"\u0130ptal","connectWallet":"C\xfczdan\u0131 Ba\u011Fla","contactSupport":"Destek Ekibine Ula\u015F","continue":"Devam et","copyAddress":"Adresi Kopyala","dark":"Koyu","delete":"Sil","disconnect":"Ba\u011Flant\u0131y\u0131 Kes","done":"Tamamland\u0131","exchange":"Al-Sat","getGas":"Gaz al","hide":"Gizle","learnMore":"Daha fazla bilgi edinin","lifiCheckout":"\u0130\u015Flem sonucu","lifiExchange":"LI-FI Al-Sat","light":"A\xe7\u0131k","max":"maksimum","ok":"Tamam","removeTransaction":"\u0130\u015Flemi kald\u0131r","reset":"S\u0131f\u0131rla","resetSettings":"Ayarlar\u0131 S\u0131f\u0131rla","reviewBridge":"K\xf6pr\xfcleri \u0130ncele","reviewPurchase":"Sat\u0131n almay\u0131 g\xf6zden ge\xe7ir","reviewSwap":"Takas i\u015Flemini incele","seeDetails":"Detaylar\u0131 G\xf6r","showAll":"T\xfcm\xfcn\xfc G\xf6ster","startBridging":"Ba\u015Fla","startSwapping":"Takas i\u015Flemini ba\u015Flat","swap":"Takas et","tryAgain":"Tekrar Deneyin","viewCoverage":"Kapsamaya bak","viewOnExplorer":"Taray\u0131c\u0131da G\xf6r\xfcnt\xfcle"},"header":{"activeTransactions":"Aktif i\u015Flemler","bridge":"G\xf6nder","checkout":"\xd6deme yap","exchange":"Al-Sat","from":"\u015Eundan takas et","gas":"Gaz","payWith":"\u015Eununla \xf6de","purchase":"Sat\u0131n al","purchaseDetails":"Sat\u0131n Alma Detaylar\u0131","selectChain":"Zincir Se\xe7","selectWallet":"Bir C\xfczdan Se\xe7in","settings":"Ayarlar","swap":"Takas","to":"\u015Euna takas et","transactionDetails":"\u0130\u015Flem ayr\u0131nt\u0131lar\u0131","transactionHistory":"\u0130\u015Flem ge\xe7mi\u015Fi","walletConnected":"C\xfczdan Ba\u011Fland\u0131","youGet":"Alaca\u011F\u0131n\u0131z"},"info":{"message":{"autoRefuel":"{{chainName}} a\u011F\u0131nda gaz yetersiz. Devam ederek, i\u015Flem i\xe7in gereken miktarda gaz alacaks\u0131n\u0131z.","emptyActiveTransactions":"Devam eden i\u015Flemler burada g\xf6r\xfcnecek. Tamamland\u0131\u011F\u0131nda, i\u015Flem ge\xe7mi\u015Finden bulabilirsiniz.","emptyTokenList":"{{chainName}} a\u011F\u0131nda token bulamad\u0131k veya sizde hi\xe7 token yok. L\xfctfen tekrar aramay\u0131 deneyin veya ba\u015Fka bir a\u011F se\xe7in.","emptyTransactionHistory":"\u0130\u015Flem ge\xe7mi\u015Fi yaln\u0131zca yerel olarak saklan\u0131r ve taray\u0131c\u0131 verilerinizi temizlerseniz silinir.","routeNotFound":"Muhtemel sebepler \u015Funlar olabilir: D\xfc\u015F\xfck likidite, se\xe7ilen miktar\u0131n \xe7ok d\xfc\u015F\xfck olmas\u0131, gaz masraf\u0131n\u0131n \xe7ok olmas\u0131 ya da se\xe7ilen kombinasyon i\xe7in rota olmamas\u0131."},"title":{"autoRefuel":"Gaz al","emptyActiveTransactions":"Aktif i\u015Flem bulunmamaktad\u0131r","emptyTransactionHistory":"Yak\u0131n zamanda bir i\u015Flem yok","routeNotFound":"Kullan\u0131labilir bir yol bulunamad\u0131"}},"success":{"message":{"exchangePartiallySuccessful":"\u0130\u015Flemi tamamlamaya \xe7al\u0131\u015Ft\u0131k, ancak {{tool}} \xfczerinde, {{tokenSymbol}} i\xe7in likidite bulunmuyor.","exchangeSuccessful":"\u015Eu anda {{chainName}} a\u011F\u0131ndaki {{walletAddress}} adresinde {{amount, number(maximumFractionDigits: 9)}} adet {{tokenSymbol}} bulunmaktad\u0131r.","purchaseSuccessful":"\u015Eu anda {{chainName}} a\u011F\u0131 {{walletAddress}} adresinde {{assetName}} bulunmaktad\u0131r."},"title":{"bridgePartiallySuccessful":"K\xf6pr\xfc i\u015Flemi k\u0131smen ba\u015Far\u0131l\u0131","bridgeSuccessful":"\u0130\u015Flem ba\u015Far\u0131l\u0131","purchaseSuccessful":"\u0130\u015Flem ba\u015Far\u0131l\u0131","refundIssued":"Geri \xf6deme yap\u0131ld\u0131","swapPartiallySuccessful":"Takas i\u015Flemi k\u0131smen ba\u015Far\u0131l\u0131","swapSuccessful":"Takas ba\u015Far\u0131l\u0131"}},"warning":{"message":{"deleteActiveTransactions":"Aktif i\u015Flemler yaln\u0131zca yerel olarak depolan\u0131r ve silerseniz kurtar\u0131lamaz.","deleteTransactionHistory":"\u0130\u015Flem ge\xe7mi\u015Fi yaln\u0131zca yerel olarak depolan\u0131r ve silerseniz kurtar\u0131lamaz.","highValueLoss":"Elde edilecek varl\u0131klar\u0131n de\u011Feri, takas edilen varl\u0131klardan ve i\u015Flem maliyetinden \xf6nemli \xf6l\xe7\xfcde d\xfc\u015F\xfckt\xfcr.","insufficientFunds":"Takas i\u015Flemini ger\xe7ekle\u015Ftirmek i\xe7in yeterli bakiyeniz bulunmamaktad\u0131r.","insufficientGas":"En az\u0131ndan \u015Funlar\u0131 eklemelisiniz:","rateChanged":"Takas oran\u0131 de\u011Fi\u015Fti. \u0130\u015Fleme devam ederek yeni oran\u0131 kabul etmi\u015F olursunuz.","resetSettings":"Bu, rota \xf6nceli\u011Finizi, slipaj\u0131, gaz fiyat\u0131n\u0131, etkin k\xf6pr\xfcleri ve takaslar\u0131 s\u0131f\u0131rlayacakt\u0131r."},"title":{"deleteActiveTransactions":"T\xfcm aktif i\u015Flemleri sil?","deleteTransaction":"Bu i\u015Flem silinsin mi?","deleteTransactionHistory":"\u0130\u015Flem ge\xe7mi\u015Fi silinsin mi?","highValueLoss":"Y\xfcksek de\u011Fer kayb\u0131","insufficientGas":"Yetersiz gaz","rateChanged":"Oran de\u011Fi\u015Fti","resetSettings":"Ayarlar\u0131 s\u0131f\u0131rla?"}},"error":{"message":{"allowanceRequired":"{{tokenSymbol}} i\xe7in verilen izinden fazla miktarda transfer yap\u0131lamaz. Token izinlerini artt\u0131r\u0131p tekrar deneyiniz.","insufficientFunds":"Bu i\u015Flemi ger\xe7ekle\u015Ftirmek i\xe7in yeterli gaz bulunmamaktad\u0131r.","slippageThreshold":"Slipaj, tan\u0131mlanan e\u015Fikten daha b\xfcy\xfck. Yeni bir fiyat teklifi almak i\xe7in l\xfctfen yeni bir rota isteyin.","transactionFailed":"Daha fazla bilgi i\xe7in a\u011F taray\u0131c\u0131s\u0131n\u0131 kontrol edin.","transactionNotSent":"\u0130\u015Flem g\xf6nderilmedi. {{chainName}} \xfczerinde {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} c\xfczdan\u0131n\u0131zda bulunmaktad\u0131r.","transactionRejected":"\u0130\u015Flemi tamamlamak i\xe7in imzan\u0131z gerekiyor. {{chainName}} \xfczerinde {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} c\xfczdan\u0131n\u0131zda bulunmaktad\u0131r.","unknown":"L\xfctfen tekrar deneyin veya deste\u011Fe ba\u015Fvurun."},"title":{"allowanceRequired":"\u0130zin miktar\u0131 yetersiz","balanceIsTooLow":"Bakiye \xe7ok d\xfc\u015F\xfck","chainSwitch":"L\xfctfen a\u011F\u0131 de\u011Fi\u015Ftirin","gasLimitIsTooLow":"Gaz limiti \xe7ok d\xfc\u015F\xfck","insufficientFunds":"Yetersiz bakiye","slippageNotMet":"Slipaj ko\u015Fullar\u0131 kar\u015F\u0131lanmad\u0131","transactionCanceled":"\u0130\u015Flem iptal edildi","transactionFailed":"\u0130\u015Flem ba\u015Far\u0131s\u0131z","transactionRejected":"\u0130mza gerekiyor","transactionUnderpriced":"\u0130\u015Flemin de\u011Feri d\xfc\u015F\xfck","transactionUnprepared":"\u0130\u015Flem ba\u015Flat\u0131lam\u0131yor","unknown":"Bir sorun olu\u015Ftu","walletAddressInvalid":"C\xfczdan adresi ge\xe7ersizdir.","walletAddressRequired":"C\xfczdan adresi gereklidir.","walletEnsAddressInvalid":"C\xfczdan adresi ge\xe7erli de\u011Fil veya a\u011F ENS desteklemiyor."}},"tooltip":{"additionalProviderFee":"Ek k\xf6pr\xfc, DEX\'ler ve hizmet \xfccretleri.","estimatedNetworkFee":"Tahmini a\u011F \xfccreti.","estimatedTime":"Dakika cinsinden tahmini i\u015Flem s\xfcresi.","notFound":{"text":"Arad\u0131\u011F\u0131n\u0131z sayfay\u0131 bulamad\u0131k.","title":"404"},"numberOfSteps":"\u0130\u015Flem birka\xe7 ad\u0131mdan olu\u015Fmaktad\u0131r. Her ad\u0131m, imza gerektiren 1-2 i\u015Flem i\xe7erebilir.","progressToNextUpdate":"G\xf6r\xfcnt\xfclenen veriler, {{value}} saniye sonra otomatik olarak yenilenecektir. Manuel olarak g\xfcncellemek i\xe7in buray\u0131 t\u0131klay\u0131n.","recommended":"Karma\u015F\u0131kl\u0131\u011F\u0131 ve kullan\u0131m kolayl\u0131\u011F\u0131n\u0131 dengeleyen ucuz bir rota.","settingsModified":"Ayarlar (de\u011Fi\u015Ftirilen)"},"main":{"crossStepDetails":"{{from}} ile {{to}} a\u011Flar\u0131 aras\u0131nda {{tool}} ile g\xf6nderim sa\u011Flay\u0131n","currentAmount":"Ge\xe7erli miktar","estimatedTime":"{{value}} dakika","featuredTokens":"\xd6ne \xe7\u0131kan jetonlar","from":"G\xf6nderen","fromAmount":"\xd6dedi\u011Finiz","gasCost":"Gaz Bedeli","gasFeeEstimated":"Tahmini Gaz \xdccreti","gasFeePaid":"\xd6denen Gaz \xfccreti","inProgress":"i\u015Flem devam ediyor","nftStepDetails":"{{tool}} arac\u0131l\u0131\u011F\u0131yla NFT sat\u0131n al\u0131n","onChain":"{{chainName}} \xfczerinde","otherTokens":"Di\u011Fer jetonlar","ownedBy":"Taraf\u0131ndan sahip olunan","process":{"crossChain":{"actionRequired":"L\xfctfen i\u015Flemi onaylay\u0131n","done":"K\xf6pr\xfc i\u015Flemi teyit edildi","pending":"K\xf6pr\xfc i\u015Flemi bekleniyor","started":"K\xf6pr\xfc i\u015Flemi haz\u0131rlan\u0131yor"},"nft":{"done":"NFT sat\u0131n al\u0131nd\u0131"},"receivingChain":{"done":"K\xf6pr\xfc i\u015Flemi tamamland\u0131","partial":"K\xf6pr\xfc i\u015Flemi k\u0131smen tamamland\u0131","pending":"Hedef zincir bekleniyor","refunded":"K\xf6pr\xfc i\u015Flemi iade edildi"},"swap":{"actionRequired":"L\xfctfen i\u015Flemi onaylay\u0131n","done":"Takas i\u015Flemi tamamland\u0131","pending":"Takas i\u015Flemi bekleniyor","started":"Takas i\u015Flemi haz\u0131rlan\u0131yor"},"switchChain":{"actionRequired":"L\xfctfen a\u011F\u0131 de\u011Fi\u015Ftirin","done":"A\u011F ba\u015Far\u0131yla de\u011Fi\u015Ftirildi"},"tokenAllowance":{"done":"Jeton izni onayland\u0131","pending":"Jeton izni bekleniyor","started":"Jeton izni ayarlan\u0131yor"}},"quotedAmount":"Teklif edilen tutar","rateChange":"De\u011Fi\u015Fiklik oran\u0131","receiving":"Al\u0131n\u0131yor","refuelStepDetails":"{{tool}} arac\u0131l\u0131\u011F\u0131yla gaz al","selectChain":"Zincir","selectChainAndToken":"A\u011F\u0131 ve jetonu se\xe7in","selectToken":"Jeton","sendToAddress":"Bu adrese g\xf6nder: {{address}}","sendToWallet":"Farkl\u0131 bir c\xfczdana g\xf6nder","sending":"G\xf6nderiliyor","sentToAddress":"Bu adrese g\xf6nderildi: {{address}}","stepBridge":"K\xf6pr\xfcle","stepBridgeAndBuy":"K\xf6pr\xfcle ve sat\u0131n al","stepDetails":"LI.FI arac\u0131l\u0131\u011F\u0131yla {{tool}}","stepSwap":"Takas et","stepSwapAndBridge":"Takas et ve K\xf6pr\xfcle","stepSwapAndBuy":"Takasla ve sat\u0131n al","supportId":"Destek","swapStepDetails":"{{chain}} \xfczerinde {{tool}} arac\u0131l\u0131\u011F\u0131yla takas et","tags":{"cheapest":"Ucuz","fastest":"H\u0131zl\u0131","insurable":"Sigortalanabilir","insurance":"Sigorta","insured":"Sigortal\u0131","recommended":"\xd6nerilen","safest":"G\xfcvenli"},"to":"\u015Euna","tokenOnChain":"{{chainName}} \xfczerindeki {{tokenSymbol}}","tokenOnChainAmount":"{{chainName}} \xfczerindeki {{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}","tokenSearch":"Tokenlerinizi adres ve ya isim arac\u0131l\u0131\u011F\u0131yla aray\u0131n","valueLoss":"De\u011Fer kayb\u0131","walletAddressOrEns":"C\xfczdan adresi veya ENS alan ad\u0131"},"insurance":{"bridgeExploits":"K\xf6pr\xfc ar\u0131zalar\u0131, hack veya istismarlar","insure":"<0>{{amount, number(maximumFractionDigits: 9)}} adet {{tokenSymbol}}</0>. Tek seferde sigortala.","insured":"<0>{{amount, number(maximumFractionDigits: 9)}} adet {{tokenSymbol}}</0> sigortaland\u0131:","slippageError":"Al\u0131nan tokenlar i\xe7in slipaj hatas\u0131"},"settings":{"enabledBridges":"Etkin K\xf6pr\xfcler","enabledExchanges":"Etkin platformlar","gasPrice":{"fast":"H\u0131zl\u0131","normal":"Standard","slow":"Yava\u015F","title":"Gaz \xfccreti"},"routePriority":"Rota \xf6nceli\u011Fi","showDestinationWallet":"Hedef Adresi G\xf6ster","slippage":"Sapma tolerans\u0131","resetSettings":"Kullan\u0131labilir rotalar\u0131n say\u0131s\u0131n\u0131 s\u0131n\u0131rlayan \xf6zel bir ayar kullan\u0131yorsunuz."},"wallet":{"extensionNotFound":"L\xfctfen bu c\xfczdan\u0131 se\xe7meden \xf6nce yaln\u0131zca {{name}} taray\u0131c\u0131 uzant\u0131s\u0131n\u0131n etkin oldu\u011Fundan emin olun."}}');


var $ef3b0edefb0433b5$exports = {};
$ef3b0edefb0433b5$exports = JSON.parse('{"language":{"name":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430","title":"\u041C\u043E\u0432\u0430"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"\u0410\u0432\u0442\u043E","bridge":"\u0411\u0440\u0438\u0434\u0436","buy":"\u041F\u0440\u0438\u0434\u0431\u0430\u0442\u0438","buyNow":"\u041F\u0440\u0438\u0434\u0431\u0430\u0442\u0438","cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","connectWallet":"\u041F\u0456\u0434\'\u0454\u0434\u043D\u0430\u0442\u0438 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","contactSupport":"\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438","continue":"\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438","copyAddress":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443","dark":"\u0422\u0435\u043C\u043D\u0430","delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","disconnect":"\u0412\u0456\u0434\'\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044C","done":"\u0413\u043E\u0442\u043E\u0432\u043E","exchange":"\u041E\u0431\u043C\u0456\u043D","getGas":"\u041E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0433\u0430\u0437","hide":"\u0421\u0445\u043E\u0432\u0430\u0442\u0438","learnMore":"\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435","lifiCheckout":"LI.FI Checkout","lifiExchange":"LI.FI \u041E\u0431\u043C\u0456\u043D","light":"\u0421\u0432\u0456\u0442\u043B\u0430","max":"\u043C\u0430\u043A\u0441","ok":"\u041E\u043A","removeTransaction":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E","reset":"\u0421\u043A\u0438\u043D\u0443\u0442\u0438","resetSettings":"\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","reviewBridge":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0431\u0440\u0438\u0434\u0436","reviewPurchase":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043F\u043E\u043A\u0443\u043F\u043A\u0438","reviewSwap":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0441\u0432\u043E\u043F","seeDetails":"\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0456\u0448\u0435","showAll":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456","startBridging":"\u041F\u043E\u0447\u0430\u0442\u0438 \u0431\u0440\u0438\u0434\u0436","startSwapping":"\u041F\u043E\u0447\u0430\u0442\u0438 \u0441\u0432\u043E\u043F","swap":"\u0421\u0432\u043E\u043F","tryAgain":"\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0449\u0435 \u0440\u0430\u0437","viewCoverage":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u043E\u043A\u0440\u0438\u0442\u0442\u044F","viewOnExplorer":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 \u043E\u0433\u043B\u044F\u0434\u0430\u0447\u0456"},"header":{"activeTransactions":"\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","bridge":"\u0411\u0440\u0438\u0434\u0436","checkout":"\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A","exchange":"\u041E\u0431\u043C\u0456\u043D","from":"\u0421\u0432\u043E\u043F \u0437","gas":"\u0413\u0430\u0437","payWith":"\u0421\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E","purchase":"\u041A\u0443\u043F\u0456\u0432\u043B\u044F","purchaseDetails":"\u0414\u0435\u0442\u0430\u043B\u0456 \u043F\u043E\u043A\u0443\u043F\u043A\u0438","selectChain":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0435\u0439\u043D","selectWallet":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u0432\u0456\u0439 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","settings":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","swap":"\u0421\u0432\u043E\u043F","to":"\u0421\u0432\u043E\u043F \u043D\u0430","transactionDetails":"\u0414\u0435\u0442\u0430\u043B\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","transactionHistory":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439","walletConnected":"\u0413\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043F\u0456\u0434\u02BC\u0454\u0434\u043D\u0430\u043D\u043E","youGet":"\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435"},"info":{"message":{"autoRefuel":"\u0423 \u0432\u0430\u0441 \u0437\u0430\u043C\u0430\u043B\u043E {{chainName}} \u0433\u0430\u0437\u0443. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u044E\u0447\u0438, \u0432\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0433\u0430\u0437\u0443, \u0449\u043E\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043E\u0431\u043C\u0456\u043D.","emptyActiveTransactions":"\u0422\u0443\u0442 \u043F\u043E\u043A\u0430\u0437\u0443\u044E\u0442\u044C\u0441\u044F \u043D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457. \u041F\u0456\u0441\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0437\u043D\u0430\u0439\u0442\u0438 \u0457\u0445 \u0432 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439.","emptyTokenList":"\u041D\u0430\u043C \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u043D\u0430\u0439\u0442\u0438 \u0442\u043E\u043A\u0435\u043D\u0438 \u043D\u0430 {{chainName}}, \u0430\u0431\u043E \u0443 \u0432\u0430\u0441 \u0457\u0445 \u043D\u0435\u043C\u0430\u0454. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0448\u0443\u043A \u0437\u0430 \u0430\u0434\u0440\u0435\u0441\u043E\u044E \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0443 \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0456\u043D\u0448\u0438\u0439 \u0447\u0435\u0439\u043D.","emptyTransactionHistory":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0442\u0430 \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0430, \u044F\u043A\u0449\u043E \u0432\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0435 \u0434\u0430\u043D\u0456 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.","routeNotFound":"\u041F\u0440\u0438\u0447\u0438\u043D\u0430\u043C\u0438 \u0446\u044C\u043E\u0433\u043E \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438: \u043D\u0438\u0437\u044C\u043A\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C, \u0432\u0438\u0431\u0440\u0430\u043D\u0430 \u043D\u0430\u0434\u0442\u043E \u043D\u0438\u0437\u044C\u043A\u0430 \u0441\u0443\u043C\u0430, \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0433\u0430\u0437 \u0430\u0431\u043E \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432 \u0434\u043B\u044F \u0432\u0438\u0431\u0440\u0430\u043D\u043E\u0457 \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u0457."},"title":{"autoRefuel":"\u041E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0433\u0430\u0437","emptyActiveTransactions":"\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439","emptyTransactionHistory":"\u041D\u0435\u043C\u0430\u0454 \u043E\u0441\u0442\u0430\u043D\u043D\u0456\u0445 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439","routeNotFound":"\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432"}},"success":{"message":{"exchangePartiallySuccessful":"\u041C\u0438 \u043D\u0430\u043C\u0430\u0433\u0430\u043B\u0438\u0441\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E, \u0430\u043B\u0435 {{tool}} \u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0447\u0438\u043B\u043E \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456 \u0442\u043E\u043A\u0435\u043D\u0443 {{tokenSymbol}}.","exchangeSuccessful":"\u0417\u0430\u0440\u0430\u0437 \u0454 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 {{walletAddress}} \u043D\u0430 \u0447\u0435\u0439\u043D\u0456 {{chainName}}.","purchaseSuccessful":"\u0422\u0435\u043F\u0435\u0440 \u0432\u0438 \u043C\u0430\u0454\u0442\u0435 {{assetName}} \u0432 {{walletAddress}} \u0433\u0430\u043C\u0430\u043D\u0446\u0456 \u043D\u0430 \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0443 {{chainName}}."},"title":{"bridgePartiallySuccessful":"\u0411\u0440\u0438\u0434\u0436 \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439","bridgeSuccessful":"\u0411\u0440\u0438\u0434\u0436 \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439","purchaseSuccessful":"\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u0430","refundIssued":"\u0417\u0434\u0456\u0439\u0441\u043D\u0435\u043D\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u043E\u0448\u0442\u0456\u0432","swapPartiallySuccessful":"\u0421\u0432\u043E\u043F \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439","swapSuccessful":"\u0421\u0432\u043E\u043F \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439"}},"warning":{"message":{"deleteActiveTransactions":"\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u044E\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0439 \u043D\u0435 \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0443\u0442\u0438 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0457\u0445 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0435.","deleteTransactionHistory":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0439 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u0430, \u044F\u043A\u0449\u043E \u0432\u0438 \u0457\u0445 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0435.","highValueLoss":"\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0456\u0432 \u0437\u043D\u0430\u0447\u043D\u043E \u043D\u0438\u0436\u0447\u0430, \u043D\u0456\u0436 \u043E\u0431\u043C\u0456\u043D\u0435\u043D\u0456 \u0442\u043E\u043A\u0435\u043D\u0438 \u0442\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457.","insufficientFunds":"\u0423 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u043A\u043E\u0448\u0442\u0456\u0432 \u0434\u043B\u044F \u0437\u0434\u0456\u0439\u0441\u043D\u0435\u043D\u043D\u044F \u0441\u0432\u043E\u043F\u0443.","insufficientGas":"\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0441\u0432\u043E\u043F\u0430 \u0443 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0433\u0430\u0437\u0443. \u0412\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0445\u043E\u0447\u0430 \u0431:","rateChanged":"\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0456\u043D\u0443 \u0437\u043C\u0456\u043D\u0438\u0432\u0441\u044F. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u044E\u0447\u0438 \u0441\u0432\u043E\u043F, \u0432\u0438 \u043F\u0440\u0438\u0439\u043C\u0435\u0442\u0435 \u043D\u043E\u0432\u0438\u0439 \u043A\u0443\u0440\u0441.","resetSettings":"\u0426\u0435 \u0441\u043A\u0438\u043D\u0435 \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442 \u0432\u0430\u0448\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443, \u043F\u0440\u043E\u0441\u043B\u0438\u0437\u0430\u043D\u043D\u044F, \u0446\u0456\u043D\u0443 \u0433\u0430\u0437\u0443, \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0456 \u0431\u0440\u0438\u0434\u0436\u0456 \u0442\u0430 \u043E\u0431\u043C\u0456\u043D\u043D\u0438\u043A\u0438."},"title":{"deleteActiveTransactions":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0432\u0441\u0456 \u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457?","deleteTransaction":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E?","deleteTransactionHistory":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439?","highValueLoss":"\u0412\u0438\u0441\u043E\u043A\u0430 \u0432\u0442\u0440\u0430\u0442\u0430 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456","insufficientGas":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044F \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0433\u0430\u0437\u0443","rateChanged":"\u041A\u0443\u0440\u0441 \u0437\u043C\u0456\u043D\u0438\u0432\u0441\u044F","resetSettings":"\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F?"}},"error":{"message":{"allowanceRequired":"\u0421\u0443\u043C\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0443 \u0434\u043B\u044F {{tokenSymbol}} \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u043F\u043E\u0442\u043E\u0447\u043D\u0443 \u043C\u0435\u0436\u0443. \u0417\u0431\u0456\u043B\u044C\u0448\u0456\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 \u0442\u0430 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.","insufficientFunds":"\u041D\u0435 \u0432\u0438\u0441\u0442\u0430\u0447\u0430\u0454 \u0433\u0430\u0437\u0443 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u0438\u0442\u0442\u044F \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457.","slippageThreshold":"\u041F\u0440\u043E\u0441\u043B\u0438\u0437\u0430\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u0440\u0456\u0433. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0440\u043E\u0431\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u043D\u043E\u0432\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u043E\u0432\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E.","transactionFailed":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043F\u0440\u043E\u0432\u0456\u0434\u043D\u0438\u043A \u0431\u043B\u043E\u043A\u0456\u0432 \u0434\u043B\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.","transactionNotSent":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F \u043D\u0435 \u0431\u0443\u043B\u0430 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u043D\u0430 {{chainName}} \u0432\u0441\u0435 \u0449\u0435 \u0437\u043D\u0430\u0445\u043E\u0434\u044F\u0442\u044C\u0441\u044F \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456.","transactionRejected":"\u0414\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0432\u0430\u0448 \u043F\u0456\u0434\u043F\u0438\u0441. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u043D\u0430 {{chainName}} \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456.","unknown":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0430\u0431\u043E \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438."},"title":{"allowanceRequired":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044F \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C","balanceIsTooLow":"\u0411\u0430\u043B\u0430\u043D\u0441 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043D\u0438\u0437\u044C\u043A\u0438\u0439","chainSwitch":"\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0447\u0435\u0439\u043D.","gasLimitIsTooLow":"\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u043D\u0438\u0437\u044C\u043A\u0438\u0439 \u043B\u0456\u043C\u0456\u0442 \u0433\u0430\u0437\u0443","insufficientFunds":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u043A\u043E\u0448\u0442\u0456\u0432","slippageNotMet":"\u041D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456 \u0443\u043C\u043E\u0432\u0438 \u043F\u0440\u043E\u0441\u043B\u0438\u0437\u0430\u043D\u043D\u044F","transactionCanceled":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E","transactionFailed":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F.","transactionRejected":"\u041F\u0456\u0434\u043F\u0438\u0441 \u043E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u0438\u0439.","transactionUnderpriced":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F \u0454 \u0437\u0430\u043D\u0438\u0436\u0435\u043D\u043E\u044E.","transactionUnprepared":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0456\u0434\u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E.","unknown":"\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A.","walletAddressInvalid":"\u0410\u0434\u0440\u0435\u0441\u0430 \u0433\u0430\u043C\u0430\u043D\u0446\u044F \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0430.","walletAddressRequired":"\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0432\u043A\u0430\u0437\u0430\u0442\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u044F.","walletEnsAddressInvalid":"\u0410\u0434\u0440\u0435\u0441\u0430 \u0433\u0430\u043C\u0430\u043D\u0446\u044F \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0430 \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0430 \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 ENS."}},"tooltip":{"additionalProviderFee":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u043A\u043E\u043C\u0456\u0441\u0456\u0457 \u0431\u0440\u0438\u0434\u0436\u0456\u0432, \u043E\u0431\u043C\u0456\u043D\u043D\u0438\u043A\u0456\u0432 \u0442\u0430 \u043F\u043E\u0441\u043B\u0443\u0433.","estimatedNetworkFee":"\u041E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0430 \u043C\u0435\u0440\u0435\u0436\u0435\u0432\u0430 \u043F\u043B\u0430\u0442\u0430.","estimatedTime":"\u041E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0438\u0439 \u0447\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0441\u0432\u043E\u043F\u0443 \u0432 \u0445\u0432\u0438\u043B\u0438\u043D\u0430\u0445.","notFound":{"text":"\u041C\u0438 \u043D\u0435 \u0437\u043C\u043E\u0433\u043B\u0438 \u0437\u043D\u0430\u0439\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.","title":"404"},"numberOfSteps":"\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043A\u0440\u043E\u043A\u0456\u0432 \u0441\u0432\u043E\u043F\u0443. \u041A\u043E\u0436\u0435\u043D \u043A\u0440\u043E\u043A \u043C\u043E\u0436\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 1-3 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457, \u044F\u043A\u0456 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u044E\u0442\u044C \u043F\u0456\u0434\u043F\u0438\u0441\u0443.","progressToNextUpdate":"\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043E\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {{value}} \u0441\u0435\u043A\u0443\u043D\u0434. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0432\u0440\u0443\u0447\u043D\u0443.","recommended":"\u0414\u0435\u0448\u0435\u0432\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442, \u044F\u043A\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441\u0443\u0454 \u0441\u043A\u043B\u0430\u0434\u043D\u0456\u0441\u0442\u044C \u0456 \u043B\u0435\u0433\u043A\u0456\u0441\u0442\u044C \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F.","settingsModified":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F (\u0437\u043C\u0456\u043D\u0435\u043D\u043E)"},"main":{"crossStepDetails":"\u0411\u0440\u0438\u0434\u0436 \u0437 {{from}} \u0434\u043E {{to}} \u0447\u0435\u0440\u0435\u0437 {{tool}}","currentAmount":"\u041F\u043E\u0442\u043E\u0447\u043D\u0430 \u0441\u0443\u043C\u0430","estimatedTime":"{{value}}\u0445","featuredTokens":"\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0442\u043E\u043A\u0435\u043D\u0438","from":"\u0417","fromAmount":"\u0412\u0438 \u043F\u043B\u0430\u0442\u0438\u0442\u0435","gasCost":"\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0433\u0430\u0437\u0443","gasFeeEstimated":"\u043E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u0430\u043D\u0430 \u043A\u043E\u043C\u0456\u0441\u0456\u044F \u0437\u0430 \u0433\u0430\u0437","gasFeePaid":"\u043E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0433\u0430\u0437","inProgress":"\u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0456","nftStepDetails":"\u041F\u0440\u0438\u0434\u0431\u0430\u0442\u0438 NFT \u0447\u0435\u0440\u0435\u0437 {{tool}}","onChain":"\u043D\u0430 {{chainName}}","otherTokens":"\u0406\u043D\u0448\u0456 \u0442\u043E\u043A\u0435\u043D\u0438","ownedBy":"\u0412\u043B\u0430\u0441\u043D\u0438\u043A","process":{"crossChain":{"actionRequired":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E","done":"\u0411\u0440\u0438\u0434\u0436 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043E","pending":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0431\u0440\u0438\u0434\u0436 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","started":"\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0431\u0440\u0438\u0434\u0436 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457"},"nft":{"done":"\u041F\u0440\u0438\u0434\u0431\u0430\u043D\u043E NFT"},"receivingChain":{"done":"\u0411\u0440\u0438\u0434\u0436 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E","partial":"\u0411\u0440\u0438\u0434\u0436 \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E","pending":"\u0412 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u0456 \u0447\u0435\u0439\u043D\u0430 \u0449\u043E \u043F\u0440\u0438\u0439\u043C\u0430\u0454","refunded":"\u0411\u0440\u0438\u0434\u0436 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u043E\u0432\u0430\u043D\u0430"},"swap":{"actionRequired":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E","done":"\u0421\u0432\u043E\u043F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E","pending":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0432\u043E\u043F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","started":"\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0441\u0432\u043E\u043F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457"},"switchChain":{"actionRequired":"\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u043D\u0443\u0442\u0438 \u0447\u0435\u0439\u043D","done":"\u0427\u0435\u0439\u043D \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u043D\u0443\u0432\u0441\u044F"},"tokenAllowance":{"done":"\u0422\u043E\u043A\u0435\u043D\u0438 \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043E","pending":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043D\u044F \u0442\u043E\u043A\u0435\u043D\u0456\u0432","started":"\u0421\u0445\u0432\u0430\u043B\u0435\u043D\u043D\u044F \u0442\u043E\u043A\u0435\u043D\u0456\u0432"}},"quotedAmount":"\u0417\u0430\u043F\u0440\u043E\u043F\u043E\u043D\u043E\u0432\u0430\u043D\u0430 \u0441\u0443\u043C\u0430","rateChange":"\u0417\u043C\u0456\u043D\u0430 \u043A\u0443\u0440\u0441\u0443","receiving":"\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F","refuelStepDetails":"\u041E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0433\u0430\u0437 \u0447\u0435\u0440\u0435\u0437 {{tool}}","selectChain":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0435\u0439\u043D","selectChainAndToken":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0435\u0439\u043D \u0456 \u0442\u043E\u043A\u0435\u043D","selectToken":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u043A\u0435\u043D","sendToAddress":"\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043D\u0430 {{address}}","sendToWallet":"\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043D\u0430 \u0456\u043D\u0448\u0438\u0439 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","sending":"\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F","sentToAddress":"\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 {{address}}","stepBridge":"\u0411\u0440\u0438\u0434\u0436","stepBridgeAndBuy":"\u0411\u0440\u0438\u0434\u0436 \u0442\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0430","stepDetails":"{{tool}} \u0447\u0435\u0440\u0435\u0437 LI.FI","stepSwap":"\u0421\u0432\u043E\u043F","stepSwapAndBridge":"\u0421\u0432\u043E\u043F \u0442\u0430 \u0431\u0440\u0438\u0434\u0436","stepSwapAndBuy":"\u0421\u0432\u043E\u043F \u0442\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0430","supportId":"\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438","swapStepDetails":"\u0421\u0432\u043E\u043F \u043D\u0430 {{chain}} \u0447\u0435\u0440\u0435\u0437 {{tool}}","tags":{"cheapest":"\u0414\u0435\u0448\u0435\u0432\u0438\u0439","fastest":"\u0428\u0432\u0438\u0434\u043A\u0438\u0439","insurable":"\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0430","insurance":"\u0421\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F","insured":"\u0417\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0439","recommended":"\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439","safest":"\u0411\u0435\u0437\u043F\u0435\u0447\u043D\u0438\u0439"},"to":"\u0414\u043E","tokenOnChain":"{{tokenSymbol}} \u043D\u0430 {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} \u043D\u0430 {{chainName}}","tokenSearch":"\u0428\u0443\u043A\u0430\u0442\u0438 \u0437\u0430 \u0456\u043C\'\u044F\u043C \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u043E\u044E","valueLoss":"\u0412\u0442\u0440\u0430\u0442\u0430 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456","walletAddressOrEns":"\u0410\u0434\u0440\u0435\u0441\u0430 \u0433\u0430\u043C\u0430\u043D\u0446\u044F \u0430\u0431\u043E \u0456\u043C\u2019\u044F ENS"},"insurance":{"bridgeExploits":"\u0417\u0431\u043E\u0457 \u0432 \u0440\u043E\u0431\u043E\u0442\u0456 \u0431\u0440\u0438\u0434\u0436\u0443, \u0437\u043B\u043E\u043C\u0438 \u0447\u0438 \u0435\u043A\u0441\u043F\u043B\u043E\u0439\u0442\u0438","insure":"\u0417\u0430\u0441\u0442\u0440\u0430\u0445\u0443\u0439\u0442\u0435 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \u0442\u043E\u043A\u0435\u043D\u0456\u0432 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457.","insured":"\u0412\u0438 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043B\u0438 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \u0442\u043E\u043A\u0435\u043D\u0456\u0432 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457:","slippageError":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u043F\u0440\u043E\u0441\u043B\u0438\u0437\u0430\u043D\u043D\u0456 \u0434\u043B\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0456\u0432"},"settings":{"enabledBridges":"\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0456 \u0431\u0440\u0438\u0434\u0436\u0456","enabledExchanges":"\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0456 \u043E\u0431\u043C\u0456\u043D\u043D\u0438\u043A\u0438","gasPrice":{"fast":"\u0428\u0432\u0438\u0434\u043A\u043E","normal":"\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E","slow":"\u041F\u043E\u0432\u0456\u043B\u044C\u043D\u043E","title":"\u0426\u0456\u043D\u0430 \u043D\u0430 \u0433\u0430\u0437"},"routePriority":"\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443","showDestinationWallet":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0446\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","slippage":"\u041F\u0440\u043E\u0441\u043B\u0438\u0437\u0430\u043D\u043D\u044F","resetSettings":"\u0412\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u044F\u043A\u0456 \u043C\u043E\u0436\u0443\u0442\u044C \u043E\u0431\u043C\u0435\u0436\u0443\u0432\u0430\u0442\u0438 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432."},"wallet":{"extensionNotFound":"\u041F\u0435\u0440\u0448 \u043D\u0456\u0436 \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0446\u0435\u0439 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C, \u043F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456 \u0430\u043A\u0442\u0438\u0432\u043D\u0435 \u043B\u0438\u0448\u0435 \u0440\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u043D\u044F {{name}}."}}');


var $f422c8dd25836285$exports = {};
$f422c8dd25836285$exports = JSON.parse('{"language":{"name":"Ti\u1EBFng Vi\u1EC7t","title":"Ng\xf4n ng\u1EEF"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"T\u1EF1 \u0111\u1ED9ng","bridge":"C\u1EA7u","buy":"Mua","buyNow":"Mua ngay b\xe2y gi\u1EDD","cancel":"Hu\u1EF7 b\u1ECF","connectWallet":"K\u1EBFt n\u1ED1i v\xed","contactSupport":"Li\xean h\u1EC7 h\u1ED7 tr\u1EE3","continue":"Ti\u1EBFp t\u1EE5c","copyAddress":"Sao ch\xe9p \u0111\u1ECBa ch\u1EC9","dark":"T\u1ED1i","delete":"X\xf3a","disconnect":"Ng\u1EAFt k\u1EBFt n\u1ED1i","done":"Ho\xe0n th\xe0nh","exchange":"Ho\xe1n \u0111\u1ED5i","getGas":"Thi\u1EBFt l\u1EADp gas","hide":"\u1EA8n","learnMore":"Xem th\xeam","lifiCheckout":"LI.FI Checkout","lifiExchange":"LI.FI Exchange","light":"S\xe1ng","max":"T\u1ED1i \u0111a","ok":"Ok","removeTransaction":"Xo\xe1 giao d\u1ECBch","reset":"\u0110\u1EB7t l\u1EA1i","resetSettings":"\u0110\u1EB7t l\u1EA1i c\xe0i \u0111\u1EB7t","reviewBridge":"Xem x\xe9t c\u1EA7u","reviewPurchase":"\u0110\xe1nh gi\xe1 thanh to\xe1n","reviewSwap":"Xem l\u1EA1i Swap","seeDetails":"Xem chi ti\u1EBFt","showAll":"Hi\u1EC3n th\u1ECB t\u1EA5t c\u1EA3","startBridging":"B\u1EAFt \u0111\u1EA7u \u0111i c\u1EA7u","startSwapping":"B\u1EAFt \u0111\u1EA7u Swap","swap":"Swap","tryAgain":"Th\u1EED l\u1EA1i","viewCoverage":"Xem ph\u1EA1m vi b\u1EA3o hi\u1EC3m","viewOnExplorer":"Xem t\u1EA1i Explorer"},"header":{"activeTransactions":"C\xe1c giao d\u1ECBch hi\u1EC7n t\u1EA1i","bridge":"C\u1EA7u","checkout":"Thanh to\xe1n","exchange":"Ho\xe1n \u0111\u1ED5i","from":"Swap t\u1EEB","gas":"Gas","payWith":"Thanh to\xe1n b\u1EB1ng","purchase":"Thanh to\xe1n","purchaseDetails":"Th\xf4ng tin chi ti\u1EBFt","selectChain":"Ch\u1ECDn chain","selectWallet":"Ch\u1ECDn v\xed","settings":"C\xe0i \u0111\u1EB7t","swap":"Swap","to":"Swap t\u1EEB","transactionDetails":"Chi ti\u1EBFt giao d\u1ECBch","transactionHistory":"L\u1ECBch s\u1EED giao d\u1ECBch","walletConnected":"Wallet connected","youGet":"B\u1EA1n nh\u1EADn"},"info":{"message":{"autoRefuel":"Gas tr\xean {{chainName}} chain c\u1EE7a b\u1EA1n \u0111ang th\u1EA5p. \u0110\u1EC3 ti\u1EBFp t\u1EE5c, b\u1EA1n n\xean c\xf3 th\xeam gas \u0111\u1EC3 ho\xe0n th\xe0nh vi\u1EC7c swap.","emptyActiveTransactions":"C\xe1c l\u1EC7nh swap \u0111ang x\u1EED l\xfd s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC7n \u1EDF \u0111\xe2y. Khi n\xe0o l\u1EC7nh ho\xe0n t\u1EA5t, b\u1EA1n c\xf3 th\u1EC3 ki\u1EC3m tra l\u1EA1i t\u1EA1i m\u1EE5c l\u1ECBch s\u1EED swap.","emptyTokenList":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm \u0111\u01B0\u1EE3c token \u1EDF {{chainName}} ho\u1EB7c s\u1ED1 d\u01B0 c\u1EE7a b\u1EA1n kh\xf4ng c\xf3. Vui l\xf2ng th\u1EED t\xecm ki\u1EBFm l\u1EA1i ho\u1EB7c ch\u1ECDn m\u1ED9t chain kh\xe1c.","emptyTransactionHistory":"L\u1ECBch s\u1EED Swap ch\u1EC9 \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF c\u1EE5c b\u1ED9 v\xe0 s\u1EBD b\u1ECB x\xf3a n\u1EBFu b\u1EA1n x\xf3a d\u1EEF li\u1EC7u tr\xecnh duy\u1EC7t c\u1EE7a m\xecnh.","routeNotFound":"L\xfd do cho \u0111i\u1EC1u \u0111\xf3 c\xf3 th\u1EC3 l\xe0: t\xednh thanh kho\u1EA3n th\u1EA5p, s\u1ED1 ti\u1EC1n \u0111\u01B0\u1EE3c ch\u1ECDn qu\xe1 th\u1EA5p, chi ph\xed gas qu\xe1 cao ho\u1EB7c kh\xf4ng c\xf3 l\u1ED9 tr\xecnh cho c\u1EB7p giao d\u1ECBch \u0111\xe3 ch\u1ECDn."},"title":{"autoRefuel":"Thi\u1EBFt l\u1EADp Gas","emptyActiveTransactions":"Kh\xf4ng c\xf3 th\xf4ng tin giao d\u1ECBch hi\u1EC7n t\u1EA1i","emptyTransactionHistory":"Ch\u01B0a c\xf3 giao d\u1ECBch","routeNotFound":"Kh\xf4ng c\xf3 \u0111\u01B0\u1EDDng \u0111i"}},"success":{"message":{"exchangePartiallySuccessful":"Ch\xfang t\xf4i \u0111\xe3 c\u1ED1 g\u1EAFng ho\xe0n th\xe0nh vi\u1EC7c ho\xe1n \u0111\u1ED5i, nh\u01B0ng {{tool}} \u0111\xe3 c\u1EA1n thanh kho\u1EA3n cho token {{tokenSymbol}}.","exchangeSuccessful":"Hi\u1EC7n t\u1EA1i {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} trong v\xed {{walletAddress}} t\u1EA1i {{chainName}} chain.","purchaseSuccessful":"Hi\u1EC7n t\u1EA1i b\u1EA1n \u0111ang n\u1EAFm gi\u1EEF {{assetName}} t\u1EA1i v\xed {{walletAddress}} tr\xean chain {{chainName}}."},"title":{"bridgePartiallySuccessful":"Swap th\xe0nh c\xf4ng m\u1ED9t ph\u1EA7n","bridgeSuccessful":"Bridge th\xe0nh c\xf4ng","purchaseSuccessful":"Mua th\xe0nh c\xf4ng","refundIssued":"\u0110\xe3 Refund","swapPartiallySuccessful":"Swap th\xe0nh c\xf4ng m\u1ED9t ph\u1EA7n","swapSuccessful":"Swap th\xe0nh c\xf4ng"}},"warning":{"message":{"deleteActiveTransactions":"C\xe1c giao d\u1ECBch \u0111ang ho\u1EA1t \u0111\u1ED9ng ch\u1EC9 \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF c\u1EE5c b\u1ED9 v\xe0 kh\xf4ng th\u1EC3 ph\u1EE5c h\u1ED3i n\u1EBFu b\u1EA1n x\xf3a ch\xfang.","deleteTransactionHistory":"L\u1ECBch s\u1EED Swap ch\u1EC9 l\u01B0u tr\u1EEF c\u1EE5c b\u1ED9 v\xe0 kh\xf4ng th\u1EC3 ph\u1EE5c h\u1ED3i khi b\u1EA1n xo\xe1 ch\xfang.","highValueLoss":"Gi\xe1 tr\u1ECB c\u1EE7a token nh\u1EADn \u0111\u01B0\u1EE3c \u0111ang th\u1EA5p h\u01A1n r\u1EA5t nhi\u1EC1u so v\u1EDBi token \u0111\u01B0\u1EE3c swap v\xe0 chi ph\xed giao d\u1ECBch.","insufficientFunds":"B\u1EA1n kh\xf4ng c\xf3 \u0111\u1EE7 ti\u1EC1n \u0111\u1EC3 th\u1EF1c hi\u1EC7n t\xe1c v\u1EE5 n\xe0y.","insufficientGas":"B\u1EA1n kh\xf4ng \u0111\u1EE7 gas \u0111\u1EC3 th\u1EF1c hi\u1EC7n swap. B\u1EA1n c\u1EA7n th\xeam \xedt nh\u1EA5t:","rateChanged":"T\u1EC9 l\u1EC7 ho\xe1n \u0111\u1ED5i \u0111\xe3 thay \u0111\u1ED5i. \u0110\u1EC3 ti\u1EBFp t\u1EE5c Swap, b\u1EA1n s\u1EBD ch\u1EA5p nh\u1EADn t\u1EC9 l\u1EC7 m\u1EDBi.","resetSettings":"Thao t\xe1c n\xe0y s\u1EBD \u0111\u1EB7t l\u1EA1i m\u1EE9c \u0111\u1ED9 \u01B0u ti\xean c\u1EE7a tuy\u1EBFn \u0111\u01B0\u1EDDng, \u0111\u1ED9 tr\u01B0\u1EE3t gi\xe1, gi\xe1 gas, bridge v\xe0 s\xe0n giao d\u1ECBch."},"title":{"deleteActiveTransactions":"X\xf3a t\u1EA5t c\u1EA3 giao d\u1ECBch \u0111ang th\u1EF1c hi\u1EC7n?","deleteTransaction":"X\xf3a giao d\u1ECBch n\xe0y?","deleteTransactionHistory":"Xo\xe1 l\u1ECBch s\u1EED giao d\u1ECBch?","highValueLoss":"T\u1ED5n th\u1EA5t l\u1EDBn","insufficientGas":"Kh\xf4ng \u0111\u1EE7 gas","rateChanged":"T\u1EC9 gi\xe1 \u0111\xe3 thay \u0111\u1ED5i","resetSettings":"\u0110\u1EB7t l\u1EA1i c\xe0i \u0111\u1EB7t?"}},"error":{"message":{"allowanceRequired":"Chuy\u1EC3n s\u1ED1 l\u01B0\u1EE3ng {{tokenSymbol}} v\u01B0\u1EE3t qu\xe1 m\u1EE9c cho ph\xe9p hi\u1EC7n t\u1EA1i c\u1EE7a b\u1EA1n. Vui l\xf2ng t\u0103ng m\u1EE9c \u0111\u1ED9 cho ph\xe9p s\u1EED d\u1EE5ng token v\xe0 th\u1EED l\u1EA1i.","insufficientFunds":"B\u1EA1n kh\xf4ng c\xf3 \u0111\u1EE7 gas \u0111\u1EC3 chi tr\u1EA3 cho chi ph\xed giao d\u1ECBch.","slippageThreshold":"\u0110\u1ED9 tr\u01B0\u1EE3t gi\xe1 l\u1EDBn h\u01A1n ng\u01B0\u1EE1ng x\xe1c \u0111\u1ECBnh. Vui l\xf2ng y\xeau c\u1EA7u m\u1ED9t tuy\u1EBFn \u0111\u01B0\u1EDDng m\u1EDBi \u0111\u1EC3 nh\u1EADn b\xe1o gi\xe1 m\u1EDBi.","transactionFailed":"Vui l\xf2ng ki\u1EC3m tra block explorer \u0111\u1EC3 bi\u1EBFt th\xeam th\xf4ng tin.","transactionNotSent":"Giao d\u1ECBch ch\u01B0a \u0111\u01B0\u1EE3c g\u1EEDi. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} t\u1EA1i {{chainName}} v\u1EABn c\xf2n trong v\xed c\u1EE7a b\u1EA1n.","transactionRejected":"C\u1EA7n c\xf3 ch\u1EEF k\xfd \u0111\u1EC3 ho\xe0n t\u1EA5t giao d\u1ECBch. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} t\u1EA1i {{chainName}} v\u1EABn c\xf2n trong v\xed c\u1EE7a b\u1EA1n.","unknown":"Vui l\xf2ng th\u1EED l\u1EA1i ho\u1EB7c li\xean h\u1EC7 h\u1ED7 tr\u1EE3."},"title":{"allowanceRequired":"S\u1EF1 cho ph\xe9p kh\xf4ng \u0111\u1EE7","balanceIsTooLow":"S\u1ED1 d\u01B0 qu\xe1 th\u1EA5p","chainSwitch":"Y\xeau c\u1EA7u \u0111\u1ED5i chain","gasLimitIsTooLow":"Gi\u1EDBi h\u1EA1n gas qu\xe1 th\u1EA5p","insufficientFunds":"Kh\xf4ng \u0111\u1EE7 t\xe0i s\u1EA3n","slippageNotMet":"\u0110i\u1EC1u ki\u1EC7n tr\u01B0\u1EE3t gi\xe1 kh\xf4ng \u0111\u01B0\u1EE3c \u0111\xe1p \u1EE9ng","transactionCanceled":"Giao d\u1ECBch b\u1ECB hu\u1EF7","transactionFailed":"Giao d\u1ECBch kh\xf4ng th\xe0nh c\xf4ng","transactionRejected":"Y\xeau c\u1EA7u ch\u1EEF k\xfd","transactionUnderpriced":"Giao d\u1ECBch b\u1ECB \u0111\u1ECBnh gi\xe1 th\u1EA5p","transactionUnprepared":"Kh\xf4ng th\u1EC3 t\u1EA3i giao d\u1ECBch","unknown":"X\u1EA3y ra l\u1ED7i","walletAddressInvalid":"\u0110\u1ECBa ch\u1EC9 v\xed kh\xf4ng h\u1EE3p l\u1EC7.","walletAddressRequired":"Y\xeau c\u1EA7u \u0111\u1ECBa ch\u1EC9 v\xed.","walletEnsAddressInvalid":"\u0110\u1ECBa ch\u1EC9 v\xed kh\xf4ng h\u1EE3p l\u1EC7 ho\u1EB7c m\u1EA1ng l\u01B0\u1EDBi kh\xf4ng h\u1ED7 tr\u1EE3 ENS."}},"tooltip":{"additionalProviderFee":"C\u1EA7u b\u1ED5 sung, DEX v\xe0 ph\xed d\u1ECBch v\u1EE5.","estimatedNetworkFee":"Ph\xed m\u1EA1ng \u01B0\u1EDBc t\xednh.","estimatedTime":"Th\u1EDDi gian th\u1EF1c hi\u1EC7n l\u1EC7nh swap (ph\xfat).","notFound":{"text":"Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm th\u1EA5y trang n\xe0y.","title":"404"},"numberOfSteps":"M\u1ED9t s\u1ED1 b\u01B0\u1EDBc swap. M\u1ED7i b\u01B0\u1EDBc c\xf3 th\u1EC3 ch\u1EE9a 1-2 giao d\u1ECBch y\xeau c\u1EA7u ch\u1EEF k\xfd.","progressToNextUpdate":"Th\xf4ng tin hi\u1EC3n th\u1ECB s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi sau {{value}} gi\xe2y. B\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 c\u1EADp nh\u1EADt th\u1EE7 c\xf4ng.","recommended":"M\u1ED9t tuy\u1EBFn \u0111\u01B0\u1EDDng gi\xe1 r\u1EBB c\xe2n b\u1EB1ng gi\u1EEFa s\u1EF1 ph\u1EE9c t\u1EA1p v\xe0 d\u1EC5 s\u1EED d\u1EE5ng.","settingsModified":"Thi\u1EBFt l\u1EADp (\u0110\xe3 \u0111i\u1EC1u ch\u1EC9nh)"},"main":{"crossStepDetails":"Chuy\u1EC3n t\u1EEB {{from}} \u0111\u1EBFn {{to}} th\xf4ng qua {{tool}}","currentAmount":"S\u1ED1 l\u01B0\u1EE3ng hi\u1EC7n t\u1EA1i","estimatedTime":"{{value}}m","featuredTokens":"Featured tokens","from":"T\u1EEB","fromAmount":"Y\xeau c\u1EA7u","gasCost":"Ph\xed Gas","gasFeeEstimated":"ph\xed Gas \u01B0\u1EDBc t\xednh","gasFeePaid":"ph\xed Gas \u0111\xe3 tr\u1EA3","inProgress":"\u0111ang x\u1EED l\xfd","nftStepDetails":"Mua NFT th\xf4ng qua {{tool}}","onChain":"t\u1EA1i {{chainName}}","otherTokens":"Token kh\xe1c","ownedBy":"\u0110\u01B0\u1EE3c s\u1EDF h\u1EEFu b\u1EDFi","process":{"crossChain":{"actionRequired":"Vui l\xf2ng k\xfd ho\xe0n th\xe0nh giao d\u1ECBch","done":"Giao d\u1ECBch bridge \u0111\xe3 \u0111\u01B0\u1EE3c x\xe1c nh\u1EADn","pending":"Ch\u1EDD giao d\u1ECBch Bridge","started":"Chu\u1EA9n b\u1ECB giao d\u1ECBch Bridge"},"nft":{"done":"NFT \u0111\xe3 mua"},"receivingChain":{"done":"Bridge th\xe0nh c\xf4ng","partial":"Bridge th\xe0nh c\xf4ng 1 ph\u1EA7n","pending":"\u0110\u1EA1ng chain \u0111\u1EBFn","refunded":"Giao d\u1ECBch Bridge \u0111\xe3 \u0111\u01B0\u1EE3c ho\xe0n tr\u1EA3"},"swap":{"actionRequired":"Vui l\xf2ng k\xfd ho\xe0n th\xe0nh giao d\u1ECBch","done":"L\u1EC7nh swap \u0111\xe3 ho\xe0n t\u1EA5t","pending":"Ch\u1EDD giao d\u1ECBch Swap","started":"\u0110ang chu\u1EA9n b\u1ECB giao d\u1ECBch Swap"},"switchChain":{"actionRequired":"Y\xeau c\u1EA7u \u0111\u1ED5i chain","done":"Chuy\u1EC3n \u0111\u1ED5i chain th\xe0nh c\xf4ng"},"tokenAllowance":{"done":"M\xe3 token \u0111\xe3 \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t","pending":"Ch\u1EDD ph\xea duy\u1EC7t quy\u1EC1n s\u1EED d\u1EE5ng token","started":"Thi\u1EBFt l\u1EADp quy\u1EC1n s\u1EED d\u1EE5ng token"}},"quotedAmount":"S\u1ED1 ti\u1EC1n tr\xedch d\u1EABn","rateChange":"Thay \u0111\u1ED5i t\u1EC9 gi\xe1","receiving":"\u0110ang nh\u1EADn","refuelStepDetails":"L\u1EA5y gas th\xf4ng qua {{tool}}","selectChain":"Ch\u1ECDn chain","selectChainAndToken":"Ch\u1ECDn chain v\xe0 token","selectToken":"Ch\u1ECDn Token","sendToAddress":"G\u1EEDi \u0111\u1EBFn {{address}}","sendToWallet":"G\u1EEDi \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 kh\xe1c","sending":"\u0110ang g\u1EEDi","sentToAddress":"G\u1EEDi \u0111\u1EBFn {{address}}","stepBridge":"C\u1EA7u","stepBridgeAndBuy":"Chuy\u1EC3n v\xe0 mua","stepDetails":"{{tool}} th\xf4ng qua LI.FI","stepSwap":"Swap","stepSwapAndBridge":"Swap v\xe0 Bridge","stepSwapAndBuy":"Ho\xe1n \u0111\u1ED5i v\xe0 mua","supportId":"M\xe3 ID y\xeau c\u1EA7u h\u1ED7 tr\u1EE3","swapStepDetails":"Swap t\u1EA1i {{chain}} th\xf4ng qua {{tool}}","tags":{"cheapest":"R\u1EBB","fastest":"Nhanh","insurable":"B\u1EA3o hi\u1EC3m","insurance":"B\u1EA3o hi\u1EC3m","insured":"An to\xe0n","recommended":"Khuy\u1EBFn ngh\u1ECB","safest":"An to\xe0n"},"to":"\u0110\u1EBFn","tokenOnChain":"{{tokenSymbol}} t\u1EA1i {{chainName}}","tokenOnChainAmount":"{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} t\u1EA1i {{chainName}}","tokenSearch":"T\xecm ki\u1EBFm b\u1EB1ng t\xean token ho\u1EB7c \u0111\u1ECBa ch\u1EC9","valueLoss":"B\u1EA1n s\u1EBD m\u1EA5t","walletAddressOrEns":"\u0110\u1ECBa ch\u1EC9 ho\u1EB7c t\xean mi\u1EC1n ENS"},"insurance":{"bridgeExploits":"C\u1EA7u tr\u1EE5c tr\u1EB7c, b\u1ECB hack ho\u1EB7c b\u1ECB khai th\xe1c","insure":"B\u1EA3o hi\u1EC3m <0>{{amount, number(maximumFractionDigits: 9)}}{{tokenSymbol}}</0> trong qu\xe1 tr\xecnh v\u1EADn chuy\u1EC3n.","insured":"B\u1EA1n \u0111\xe3 b\u1EA3o hi\u1EC3m <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> trong qu\xe1 tr\xecnh v\u1EADn chuy\u1EC3n:","slippageError":"L\u1ED7i tr\u01B0\u1EE3t gi\xe1 \u0111\u1ED1i v\u1EDBi token nh\u1EADn \u0111\u01B0\u1EE3c"},"settings":{"enabledBridges":"S\u1ED1 l\u01B0\u1EE3ng c\u1EA7u kh\u1EA3 d\u1EE5ng","enabledExchanges":"S\u1ED1 l\u01B0\u1EE3ng s\xe0n giao d\u1ECBch kh\u1EA3 d\u1EE5ng","gasPrice":{"fast":"Nhanh","normal":"B\xecnh th\u01B0\u1EDDng","slow":"Ch\u1EADm","title":"Gi\xe1 gas"},"routePriority":"Tuy\u1EC1n \u0111\u01B0\u1EDDng \u01B0u ti\xean","showDestinationWallet":"Hi\u1EC3n th\u1ECB \u0111\u1ECBa ch\u1EC9 v\xed nh\u1EADn","slippage":"Tr\u01B0\u1EE3t gi\xe1"},"wallet":{"extensionNotFound":"Ch\u1EAFc ch\u1EAFn r\u1EB1ng ti\u1EC7n \xedch tr\xean tr\xecnh duy\u1EC7t {{name}} \u0111\xe3 \u0111\u01B0\u1EE3c k\xedch ho\u1EA1t t\u01B0\u1EDBc khi ch\u1ECDn v\xed n\xe0y."}}');


var $18c973451ffe3269$exports = {};
$18c973451ffe3269$exports = JSON.parse('{"language":{"name":"\u4E2D\u6587","title":"\u8BED\u8A00"},"format":{"currency":"{{value, currency(currency: USD)}}","number":"{{value, number(maximumFractionDigits: 9)}}"},"button":{"auto":"\u81EA\u52A8","bridge":"\u8DE8\u94FE","buy":"\u8D2D\u4E70","buyNow":"\u7ACB\u5373\u8D2D\u4E70","cancel":"\u53D6\u6D88","connectWallet":"\u5173\u8054\u94B1\u5305","contactSupport":"\u8054\u7CFB\u6280\u672F\u652F\u6301","continue":"\u7EE7\u7EED","copyAddress":"\u590D\u5236\u5730\u5740","dark":"\u6DF1\u8272\u4E3B\u9898","delete":"\u5220\u9664","disconnect":"\u65AD\u5F00\u8FDE\u63A5","done":"\u5DF2\u5B8C\u6210","exchange":"\u5151\u6362","getGas":"\u5F00\u59CB\u5151\u6362\u71C3\u6C14\u8D39","hide":"\u9690\u85CF","learnMore":"\u4E86\u89E3\u66F4\u591A","lifiCheckout":"LI.FI \u7ED3\u7B97","lifiExchange":"LI.FI \u5151\u6362","light":"\u6D45\u8272\u4E3B\u9898","max":"\u6700\u5927","ok":"\u786E\u8BA4","removeTransaction":"\u5220\u9664\u4EA4\u6613","reset":"\u91CD\u7F6E","resetSettings":"\u6062\u590D\u9ED8\u8BA4\u8BBE\u7F6E","reviewBridge":"\u67E5\u770B\u8DE8\u94FE\u8BE6\u60C5","reviewPurchase":"\u67E5\u770B\u8D2D\u4E70\u8BE6\u60C5","reviewSwap":"\u67E5\u770B\u8BE5\u5151\u6362","seeDetails":"\u67E5\u770B\u8BE6\u60C5","showAll":"\u663E\u793A\u6240\u6709","startBridging":"\u5F00\u59CB\u8DE8\u94FE","startSwapping":"\u5F00\u59CB\u5151\u6362","swap":"\u5151\u6362","tryAgain":"\u91CD\u8BD5","viewCoverage":"\u67E5\u770B\u6211\u4EEC\u7684\u8986\u76D6\u8303\u56F4","viewOnExplorer":"\u5728\u533A\u5757\u94FE\u6D4F\u89C8\u5668\u4E0A\u67E5\u770B"},"header":{"activeTransactions":"\u8FDB\u884C\u4E2D\u7684\u4EA4\u6613","bridge":"\u8DE8\u94FE","checkout":"\u652F\u4ED8","exchange":"\u5151\u6362","from":"\u5151\u6362\u81EA","gas":"\u71C3\u6C14\u8D39","payWith":"\u652F\u4ED8\u65B9\u5F0F","purchase":"\u8D2D\u4E70","purchaseDetails":"\u4EA4\u6613\u660E\u7EC6","selectChain":"\u9009\u62E9\u7F51\u7EDC","selectWallet":"\u9009\u62E9\u4F60\u7684\u94B1\u5305","settings":"\u8BBE\u7F6E","swap":"\u5151\u6362","to":"\u5151\u6362\u4E3A","transactionDetails":"\u4EA4\u6613\u8BE6\u60C5","transactionHistory":"\u4EA4\u6613\u8BB0\u5F55","walletConnected":"\u8FDE\u63A5\u94B1\u5305","youGet":"\u60A8\u83B7\u5F97"},"info":{"message":{"autoRefuel":"\u60A8\u5728 {{chainName}} \u94FE\u4E0A\u7684\u71C3\u6C14\u8D39\u5F88\u4F4E\u3002\u5982\u679C\u542F\u7528\u8BE5\u9009\u9879\uFF0C\u60A8\u5C06\u83B7\u5F97\u8DB3\u591F\u7684\u71C3\u6C14\u8D39\u5B8C\u6210\u6B64\u6B21\u5151\u6362\u3002","emptyActiveTransactions":"\u6B63\u5728\u8FDB\u884C\u7684\u5151\u6362\u5C06\u5728\u8FD9\u91CC\u663E\u793A\u3002\u4E00\u65E6\u5B8C\u6210\uFF0C\u4F60\u53EF\u5728\u5151\u6362\u8BB0\u5F55\u4E2D\u627E\u5230\u5B83\u4EEC\u3002","emptyTokenList":"\u6211\u4EEC\u65E0\u6CD5\u5728 {{chainName}} \u94FE\u4E0A\u627E\u5230\u8FD9\u4E9B\u4EE3\u5E01\uFF0C\u6216\u8005\u4F60\u7684\u94B1\u5305\u5185\u6CA1\u6709\u8FD9\u4E9B\u4EE3\u5E01\u3002\u8BF7\u518D\u6B21\u641C\u7D22\u6216\u8005\u9009\u62E9\u5176\u4ED6\u94FE\u518D\u8BD5\u4E00\u6B21\u3002","emptyTransactionHistory":"\u4EA4\u6613\u8BB0\u5F55\u53EA\u5B58\u50A8\u5728\u672C\u5730\uFF0C\u5982\u679C\u60A8\u6E05\u9664\u6D4F\u89C8\u5668\u6570\u636E\uFF0C\u4EA4\u6613\u8BB0\u5F55\u5C06\u88AB\u5220\u9664\u3002","routeNotFound":"\u5BFC\u81F4\u5176\u7684\u539F\u56E0\u53EF\u80FD\u662F\uFF1A\u6D41\u52A8\u6027\u4F4E\uFF0C\u6240\u9009\u5B9A\u4EE3\u5E01\u7684\u6570\u989D\u592A\u4F4E\uFF0C\u71C3\u6C14\u8D39\u8FC7\u9AD8\uFF0C\u6216\u8005\u5F53\u524D\u6CA1\u6709\u5408\u9002\u7684\u4EA4\u6613\u8DEF\u5F84\u3002"},"title":{"autoRefuel":"\u83B7\u5F97\u71C3\u6C14\u8D39","emptyActiveTransactions":"\u6CA1\u6709\u6B63\u5728\u8FDB\u884C\u7684\u4EA4\u6613","emptyTransactionHistory":"\u8FD1\u671F\u65E0\u4EA4\u6613","routeNotFound":"\u6CA1\u6709\u53EF\u7528\u7684\u8DEF\u7531"}},"success":{"message":{"exchangePartiallySuccessful":"\u6211\u4EEC\u5C1D\u8BD5\u5B8C\u6210\u672C\u6B21\u4EA4\u6613\uFF0C\u4F46\u662F {{tool}} \u7684 {{tokenSymbol}} \u4EE3\u5E01\u6D41\u52A8\u6027\u4E0D\u8DB3\u3002","exchangeSuccessful":"{{walletAddress}} \u94B1\u5305\u5728 {{chainName}} \u94FE\u4E0A\u6536\u5230 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}","purchaseSuccessful":"\u60A8\u7684 {{walletAddress}} \u94B1\u5305\u5728 {{chainName}} \u94FE\u4E0A\u62E5\u6709\u8BE5 {{assetName}} \u8D22\u4EA7"},"title":{"bridgePartiallySuccessful":"\u8DE8\u94FE\u90E8\u5206\u6210\u529F","bridgeSuccessful":"\u8DE8\u94FE\u6210\u529F","purchaseSuccessful":"\u8D2D\u4E70\u6210\u529F","refundIssued":"\u9000\u6B3E\u5DF2\u53D7\u7406","swapPartiallySuccessful":"\u5151\u6362\u90E8\u5206\u5B8C\u6210","swapSuccessful":"\u5151\u6362\u6210\u529F"}},"warning":{"message":{"deleteActiveTransactions":"\u6B63\u5728\u8FDB\u884C\u7684\u4EA4\u6613\u8BB0\u5F55\u53EA\u5B58\u50A8\u5728\u672C\u5730\uFF0C\u5982\u679C\u5220\u9664\u5B83\u4EEC\uFF0C\u6211\u4EEC\u5C06\u65E0\u6CD5\u6062\u590D\u8FD9\u4E9B\u8BB0\u5F55\u3002","deleteTransactionHistory":"\u4EA4\u6613\u8BB0\u5F55\u53EA\u5B58\u50A8\u5728\u672C\u5730\uFF0C\u5982\u679C\u4F60\u5220\u9664\u5B83\uFF0C\u6211\u4EEC\u5C06\u65E0\u6CD5\u6062\u590D\u8FD9\u4E9B\u8BB0\u5F55\u3002","highValueLoss":"\u6536\u5230\u7684\u4EE3\u5E01\u7684\u4EF7\u503C\u660E\u663E\u4F4E\u4E8E\u8981\u88AB\u5151\u6362\u7684\u4EE3\u5E01\u548C\u4EA4\u6613\u6210\u672C\u3002","insufficientFunds":"\u4F60\u6CA1\u6709\u8DB3\u591F\u7684\u8D44\u91D1\u6765\u5B8C\u6210\u8FD9\u7B14\u4EA4\u6613\u3002","insufficientGas":"\u60A8\u6CA1\u6709\u8DB3\u591F\u7684\u71C3\u6C14\u8D39\u6765\u5B8C\u6210\u6B64\u6B21\u4EA4\u6613\u3002\u60A8\u81F3\u5C11\u9700\u8981\u6DFB\u52A0\uFF1A","rateChanged":"\u5151\u6362\u6BD4\u4F8B\u5DF2\u7ECF\u6539\u53D8\uFF0C\u5982\u679C\u7EE7\u7EED\u5151\u6362\uFF0C\u60A8\u5C06\u63A5\u53D7\u65B0\u7684\u5151\u6362\u6BD4\u4F8B\u3002","resetSettings":"\u8FD9\u5C06\u91CD\u7F6E\u60A8\u7684\u8DEF\u7531\u4F18\u5148\u7EA7\uFF0C\u6ED1\u70B9\uFF0C\u71C3\u6C14\u8D39\uFF0C\u9009\u4E2D\u7684\u8DE8\u94FE\u6865\u548C\u94FE\u4E0A\u4EA4\u6613\u6240\u3002"},"title":{"deleteActiveTransactions":"\u786E\u5B9A\u8981\u5220\u9664\u6240\u6709\u6B63\u5728\u8FDB\u884C\u7684\u4EA4\u6613\u5417\uFF1F","deleteTransaction":"\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u4EA4\u6613\u5417\uFF1F","deleteTransactionHistory":"\u786E\u5B9A\u8981\u6E05\u7A7A\u4EA4\u6613\u8BB0\u5F55\u5417?","highValueLoss":"\u5927\u989D\u8D44\u91D1\u635F\u5931","insufficientGas":"\u71C3\u6C14\u8D39\u4E0D\u8DB3","rateChanged":"\u5151\u6362\u6BD4\u4F8B\u53D8\u52A8","resetSettings":"\u786E\u5B9A\u8981\u6062\u590D\u9ED8\u8BA4\u8BBE\u7F6E\u5417?"}},"error":{"message":{"allowanceRequired":"{{tokenSymbol}} \u7684\u8F6C\u8D26\u91D1\u989D\u8D85\u8FC7\u4E86\u60A8\u8BBE\u7F6E\u7684\u652F\u51FA\u4E0A\u9650\u3002\u8BF7\u63D0\u9AD8\u8BE5\u4EE3\u5E01\u7684\u652F\u51FA\u4E0A\u9650\uFF0C\u7136\u540E\u91CD\u8BD5\u3002","insufficientFunds":"\u60A8\u6CA1\u6709\u8DB3\u591F\u7684\u71C3\u6C14\u8D39\u652F\u4ED8\u8BE5\u4EA4\u6613\u3002","slippageThreshold":"\u6ED1\u70B9\u5927\u4E8E\u9884\u8BBE\u503C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u8DEF\u7531\u5E76\u83B7\u53D6\u65B0\u7684\u4EF7\u683C\u3002","transactionFailed":"\u8BF7\u67E5\u770B\u533A\u5757\u6D4F\u89C8\u5668\u4EE5\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\u3002","transactionNotSent":"\u4EA4\u6613\u672A\u53D1\u9001\uFF0C\u4E0D\u7528\u62C5\u5FC3\uFF0C{{chainName}} \u94FE\u4E0A{{amount, number(maximumFractionDigits: 9)}} \u4E2A{{tokenSymbol}} \u4ECD\u5728\u60A8\u7684\u94B1\u5305\u91CC\u3002","transactionRejected":"\u9700\u8981\u60A8\u7B7E\u540D\u6765\u5B8C\u6210\u6B64\u6B21\u4EA4\u6613\uFF0C\u8D44\u91D1\u662F\u5B89\u5168\u7684\uFF0C{{chainName}} \u94FE\u4E0A{{amount, number(maximumFractionDigits: 9)}} \u4E2A{{tokenSymbol}} \u4ECD\u5728\u60A8\u7684\u94B1\u5305\u91CC\u3002","unknown":"\u8BF7\u518D\u8BD5\u4E00\u6B21\u6216\u8005\u8054\u7CFB\u652F\u6301\u3002"},"title":{"allowanceRequired":"\u4F59\u989D\u4E0D\u8DB3","balanceIsTooLow":"\u4F59\u989D\u592A\u4F4E","chainSwitch":"\u8BF7\u5207\u6362\u5F53\u524D\u7F51\u7EDC","gasLimitIsTooLow":"\u71C3\u6C14\u8D39\u8BBE\u7F6E\u8FC7\u4F4E","insufficientFunds":"\u8D44\u91D1\u4E0D\u8DB3","slippageNotMet":"\u6ED1\u70B9\u672A\u6EE1\u8DB3","transactionCanceled":"\u4EA4\u6613\u53D6\u6D88","transactionFailed":"\u4EA4\u6613\u5931\u8D25","transactionRejected":"\u4EA4\u6613\u9700\u8981\u7B7E\u540D","transactionUnderpriced":"\u4EA4\u6613\u5B9A\u4EF7\u8FC7\u4F4E","transactionUnprepared":"\u65E0\u6CD5\u5F00\u59CB\u8BE5\u4EA4\u6613","unknown":"\u672A\u77E5\u9519\u8BEF","walletAddressInvalid":"\u94B1\u5305\u5730\u5740\u65E0\u6548\u3002","walletAddressRequired":"\u8BF7\u8F93\u5165\u94B1\u5305\u5730\u5740\u3002","walletEnsAddressInvalid":"\u94B1\u5305\u5730\u5740\u65E0\u6548\u6216\u8005\u5F53\u524D\u7F51\u7EDC\u4E0D\u652F\u6301ENS\u3002"}},"tooltip":{"additionalProviderFee":"\u8DE8\u94FE\u548C\u4EA4\u6613\u6240\u7684\u624B\u7EED\u8D39\u3002","estimatedNetworkFee":"\u9884\u4F30\u7F51\u7EDC\u624B\u7EED\u8D39\u3002","estimatedTime":"\u9884\u8BA1\u5151\u6362\u7684\u6267\u884C\u65F6\u95F4\uFF08\u5206\u949F\uFF09\u3002","notFound":{"text":"\u6211\u4EEC\u627E\u4E0D\u5230\u8FD9\u4E2A\u9875\u9762\u3002","title":"404"},"numberOfSteps":"\u4E00\u7CFB\u5217\u7684\u5151\u6362\u6B65\u9AA4\uFF0C\u6BCF\u4E2A\u6B65\u9AA4\u53EF\u80FD\u5305\u542B1-2\u4E2A\u9700\u8981\u7B7E\u540D\u7684\u4EA4\u6613\u3002","progressToNextUpdate":"\u6570\u636E\u5C06\u5728{{value}} \u79D2\u540E\u81EA\u52A8\u5237\u65B0\uFF0C\u70B9\u51FB\u8FD9\u91CC\u53EF\u4EE5\u624B\u52A8\u66F4\u65B0\u3002","recommended":"\u4E00\u4E2A\u4EF7\u683C\u4F4E\u5EC9\u4F46\u662F\u517C\u987E\u590D\u6742\u6027\u548C\u6613\u7528\u6027\u7684\u8DEF\u7531\u65B9\u6848\u3002","settingsModified":"\u8BBE\u7F6E(\u5DF2\u4FEE\u6539)"},"main":{"crossStepDetails":"\u901A\u8FC7{{tool}}\u628A\u8D44\u4EA7\u4ECE{{from}}\u94FE\u8DE8\u5230{{to}}\u94FE\u4E0A","currentAmount":"\u5F53\u524D\u4F59\u989D","estimatedTime":"{{value}}\u5206\u949F","featuredTokens":"\u7CBE\u9009\u4EE3\u5E01","from":"\u4ECE","fromAmount":"\u9700\u8981\u652F\u4ED8","gasCost":"\u71C3\u6C14\u8D39\u6D88\u8017","gasFeeEstimated":"\u9884\u4F30\u71C3\u6C14\u8D39","gasFeePaid":"\u5DF2\u652F\u4ED8\u71C3\u6C14\u8D39","inProgress":"\u8FDB\u884C\u4E2D","nftStepDetails":"\u901A\u8FC7 {{tool}} \u8D2D\u4E70 NFT","onChain":"\u5728{{chainName}} \u4E0A","otherTokens":"\u5176\u4ED6\u4EE3\u5E01","ownedBy":"\u5C5E\u4E8E","process":{"crossChain":{"actionRequired":"\u8BF7\u7B7E\u7F72\u6B64\u4EA4\u6613","done":"\u8DE8\u94FE\u4EA4\u6613\u5DF2\u786E\u8BA4","pending":"\u8DE8\u94FE\u4EA4\u6613\u8FDB\u884C\u4E2D","started":"\u51C6\u5907\u6267\u884C\u8DE8\u94FE\u4EA4\u6613"},"nft":{"done":"NFT \u5DF2\u8D2D\u4E70"},"receivingChain":{"done":"\u8DE8\u94FE\u5B8C\u6210","partial":"\u8DE8\u94FE\u90E8\u5206\u5B8C\u6210","pending":"\u7B49\u5F85\u63A5\u6536\u94FE\u56DE\u5E94","refunded":"\u8DE8\u94FE\u4EA4\u6613\u8D44\u4EA7\u5DF2\u9000\u8FD8"},"swap":{"actionRequired":"\u8BF7\u7B7E\u7F72\u6B64\u4EA4\u6613","done":"\u5151\u6362\u5B8C\u6210","pending":"\u4EE3\u5E01\u5151\u6362\u4E2D","started":"\u51C6\u5907\u5151\u6362"},"switchChain":{"actionRequired":"\u8BF7\u5207\u6362\u5F53\u524D\u7F51\u7EDC","done":"\u7F51\u7EDC\u5207\u6362\u6210\u529F"},"tokenAllowance":{"done":"\u5DF2\u6279\u51C6\u4EE3\u5E01\u9650\u989D","pending":"\u4EE3\u5E01\u9650\u989D\u6279\u51C6\u8FDB\u884C\u4E2D","started":"\u8BBE\u7F6E\u4EE3\u5E01\u9650\u989D"}},"quotedAmount":"\u62A5\u4EF7\u91D1\u989D","rateChange":"\u6CE2\u52A8\u7387","receiving":"\u63A5\u6536","refuelStepDetails":"\u901A\u8FC7 {{tool}} \u83B7\u53D6\u71C3\u6C14\u8D39","selectChain":"\u9009\u62E9\u7F51\u7EDC","selectChainAndToken":"\u9009\u62E9\u94FE\u548C\u4EE3\u5E01","selectToken":"\u9009\u62E9\u4EE3\u5E01","sendToAddress":"\u53D1\u9001\u5230{{address}}","sendToWallet":"\u53D1\u9001\u5230\u53E6\u5916\u7684\u94B1\u5305","sending":"\u53D1\u9001\u4E2D","sentToAddress":"\u53D1\u9001\u5230{{address}}","stepBridge":"\u8DE8\u94FE","stepBridgeAndBuy":"\u8DE8\u94FE\u5E76\u8D2D\u4E70","stepDetails":"\u901A\u8FC7 LI.FI {{tool}}","stepSwap":"\u5151\u6362","stepSwapAndBridge":"\u5151\u6362\u548C\u8DE8\u94FE","stepSwapAndBuy":"\u5151\u6362\u5E76\u8D2D\u4E70","supportId":"\u652F\u6301ID","swapStepDetails":"\u901A\u8FC7{{tool}}\u5728{{chain}}\u94FE\u4E0A\u5151\u6362\u4EE3\u5E01","tags":{"cheapest":"\u4FBF\u5B9C\u7684","fastest":"\u5FEB\u901F\u7684","insurable":"\u53EF\u6295\u4FDD","insurance":"\u4FDD\u9669","insured":"\u53D7\u4FDD\u4E2D","recommended":"\u5EFA\u8BAE\u7684","safest":"\u6700\u4F73/\u5B89\u5168"},"to":"\u5230","tokenOnChain":"{{chainName}}\u94FE\u4E0A\u7684{{tokenSymbol}}","tokenOnChainAmount":"{{chainName}} \u94FE\u4E0A{{amount, number(maximumFractionDigits: 9)}} \u4E2A{{tokenSymbol}}","tokenSearch":"\u6309\u4EE3\u5E01\u540D\u79F0\u6216\u8005\u5730\u5740\u641C\u7D22","valueLoss":"\u8D44\u91D1\u635F\u5931","walletAddressOrEns":"\u94B1\u5305\u5730\u5740\u6216ENS\u540D\u79F0"},"insurance":{"bridgeExploits":"\u8DE8\u94FE\u6865\u6545\u969C\u3001\u88AB\u9ED1\u6216\u8005\u88AB\u5229\u7528\u6F0F\u6D1E","insure":"\u5728\u8DE8\u94FE\u671F\u95F4\u4E3A<0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \u6295\u4FDD\u3002","insured":"\u5728\u8DE8\u94FE\u671F\u95F4\u4E3A<0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> \u6295\u4FDD\u3002","slippageError":"\u76EE\u6807\u94FE\u4EE3\u5E01\u7684\u6ED1\u70B9\u9519\u8BEF"},"settings":{"enabledBridges":"\u5DF2\u9009\u4E2D\u7684\u8DE8\u94FE\u6865","enabledExchanges":"\u5DF2\u9009\u4E2D\u7684\u4EA4\u6613\u6240","gasPrice":{"fast":"\u5FEB\u901F","normal":"\u6B63\u5E38","slow":"\u7F13\u6162","title":"\u71C3\u6C14\u8D39"},"routePriority":"\u8DEF\u7531\u4F18\u5148\u7EA7","showDestinationWallet":"\u663E\u793A\u6536\u6B3E\u94B1\u5305","slippage":"\u6ED1\u70B9","resetSettings":"\u60A8\u6B63\u5728\u4F7F\u7528\u81EA\u5B9A\u4E49\u8BBE\u7F6E\u8FC7\u6EE4\u53EF\u7528\u8DEF\u7531\u3002"},"wallet":{"extensionNotFound":"\u5728\u9009\u62E9\u94B1\u5305\u4E4B\u524D\uFF0C\u8BF7\u786E\u4FDD\u53EA\u6709{{name}} \u6D4F\u89C8\u5668\u7684\u6269\u5C55\u5E94\u7528\u5904\u4E8E\u6FC0\u6D3B\u72B6\u6001\u3002"}}');





var $cZFtK = parcelRequire("cZFtK");

const $c85816f09d368c39$export$9115b42802a3e44f = (keys)=>{
    return (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>keys.reduce((values, key)=>{
            values[key] = state[key];
            return values;
        }, {}), (0, $cZFtK.shallow));
};


const $1a1163ff7243663e$var$isObject = (obj)=>obj && typeof obj === "object";
const $1a1163ff7243663e$export$6969335ea1e4e77c = (...objects)=>{
    return objects.reduce((prev, obj)=>{
        for(const key in obj)if ($1a1163ff7243663e$var$isObject(prev[key]) && $1a1163ff7243663e$var$isObject(obj[key])) prev[key] = $1a1163ff7243663e$export$6969335ea1e4e77c(prev[key], obj[key]);
        else prev[key] = obj[key];
        return prev;
    }, {});
};



const $f8d057fc1037c594$export$a54013f0d02a8f82 = ({ children: children })=>{
    const { languageResources: languageResources, languages: languages, disableLanguageDetector: disableLanguageDetector } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { language: language } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "language"
    ]);
    const i18n = (0, $dup7A.useMemo)(()=>{
        let resources = Object.keys($470f6ee0348b2c2f$exports).filter((lng)=>(0, $cf40533b594545d4$export$5d91ca4c93de7266)(lng, languages)).reduce((resources, lng)=>{
            resources[lng] = {
                translation: languageResources?.[lng] ? (0, $1a1163ff7243663e$export$6969335ea1e4e77c)($470f6ee0348b2c2f$exports[lng], languageResources[lng]) : $470f6ee0348b2c2f$exports[lng]
            };
            return resources;
        }, {});
        if (languageResources) resources = Object.keys(languageResources).reduce((resources, lng)=>{
            if (!resources[lng]) resources[lng] = {
                translation: languageResources[lng]
            };
            return resources;
        }, resources);
        let i18n = (0, $6f06d8df3b1abd2f$export$2e2bcd8739ae039).createInstance({
            lng: languages?.default || language,
            fallbackLng: resources.en ? "en" : languages?.default || languages?.allow?.[0] || Object.keys(resources)?.[0],
            lowerCaseLng: true,
            interpolation: {
                escapeValue: false
            },
            resources: resources,
            detection: {
                caches: []
            }
        });
        if (!language && !languages?.default && !disableLanguageDetector) i18n = i18n.use((0, $9bf43b2659564b51$export$2e2bcd8739ae039));
        i18n.use((0, $2e6409c8619af830$export$ae7e14d40d89f296)).init();
        return i18n;
    }, [
        disableLanguageDetector,
        language,
        languageResources,
        languages
    ]);
    return (0, $cZGFG.jsx)((0, $d33476ad4a6217f5$export$1325e8699caa160f), {
        i18n: i18n,
        children: children
    });
};


var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");
const $698a4cee1bbcf375$export$a8ff84c12d48cfa6 = "@lifi/widget";
const $698a4cee1bbcf375$export$83d89fbfd8236492 = "2.10.2";



let $b5765cf84e356f6b$var$lifi;
const $b5765cf84e356f6b$var$SDKContext = (0, $dup7A.createContext)(null);
const $b5765cf84e356f6b$export$cc1b3fea1f55c92e = ()=>(0, $dup7A.useContext)($b5765cf84e356f6b$var$SDKContext);
const $b5765cf84e356f6b$export$e582a1640bc4a6de = ({ children: children })=>{
    const { sdkConfig: sdkConfig, integrator: integrator, apiKey: apiKey, fee: fee, referrer: referrer, routePriority: routePriority, slippage: slippage } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const value = (0, $dup7A.useMemo)(()=>{
        const config = {
            ...sdkConfig,
            apiKey: apiKey,
            integrator: integrator ?? window.location.hostname,
            defaultRouteOptions: {
                integrator: integrator ?? window.location.hostname,
                fee: fee,
                referrer: referrer,
                order: routePriority,
                slippage: slippage,
                ...sdkConfig?.defaultRouteOptions
            }
        };
        if (!$b5765cf84e356f6b$var$lifi) $b5765cf84e356f6b$var$lifi = new (0, $815733ddabdce830$export$7e317191f16fbd67)({
            disableVersionCheck: true,
            widgetVersion: (0, $698a4cee1bbcf375$export$83d89fbfd8236492),
            ...config
        });
        $b5765cf84e356f6b$var$lifi.setConfig(config);
        return $b5765cf84e356f6b$var$lifi;
    }, [
        apiKey,
        fee,
        integrator,
        referrer,
        routePriority,
        sdkConfig,
        slippage
    ]);
    return (0, $cZGFG.jsx)($b5765cf84e356f6b$var$SDKContext.Provider, {
        value: value,
        children: children
    });
};


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $lk4Pv = parcelRequire("lk4Pv");

var $eVrzI = parcelRequire("eVrzI");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $b15e80d6e5586a57$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $dup7A.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $b15e80d6e5586a57$var$maybeReactUseSyncExternalStore = $dup7A.useSyncExternalStore;
function $b15e80d6e5586a57$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $dup7A.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $dup7A.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $dup7A.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $b15e80d6e5586a57$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $b15e80d6e5586a57$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $eVrzI.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $lk4Pv.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $b15e80d6e5586a57$var$maybeReactUseSyncExternalStore !== undefined ? $b15e80d6e5586a57$var$useMediaQueryNew : $b15e80d6e5586a57$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");
parcelRequire("dup7A");


var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");
const $a05e35ecdffd78b9$var$ThemeContext = /*#__PURE__*/ $dup7A.createContext(null);
var $a05e35ecdffd78b9$export$2e2bcd8739ae039 = $a05e35ecdffd78b9$var$ThemeContext;



var $dup7A = parcelRequire("dup7A");

function $03fa266cf6e71501$export$2e2bcd8739ae039() {
    const theme = $dup7A.useContext((0, $a05e35ecdffd78b9$export$2e2bcd8739ae039));
    return theme;
}


const $1a96869c3171311d$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $1a96869c3171311d$export$2e2bcd8739ae039 = $1a96869c3171311d$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $cZGFG = parcelRequire("cZGFG");
function $b873c500a3b877c5$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $3G4eg.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $b873c500a3b877c5$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $03fa266cf6e71501$export$2e2bcd8739ae039)();
    const theme = $dup7A.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $b873c500a3b877c5$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $1a96869c3171311d$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $a05e35ecdffd78b9$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $b873c500a3b877c5$export$2e2bcd8739ae039 = $b873c500a3b877c5$var$ThemeProvider;



parcelRequire("8eVik");
var $42TgP = parcelRequire("42TgP");

var $eVrzI = parcelRequire("eVrzI");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $3e6a8057b6fe07f6$var$EMPTY_THEME = {};
function $3e6a8057b6fe07f6$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $dup7A.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $3G4eg.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $3G4eg.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $3G4eg.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $3e6a8057b6fe07f6$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $eVrzI.default)($3e6a8057b6fe07f6$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $03fa266cf6e71501$export$2e2bcd8739ae039)() || $3e6a8057b6fe07f6$var$EMPTY_THEME;
    const engineTheme = $3e6a8057b6fe07f6$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $3e6a8057b6fe07f6$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b873c500a3b877c5$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $42TgP.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3397d1bce61a3d2d$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: children
            })
        })
    });
}
var $3e6a8057b6fe07f6$export$2e2bcd8739ae039 = $3e6a8057b6fe07f6$var$ThemeProvider;



var $7wciM = parcelRequire("7wciM");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $bde9fd0381544b49$var$_excluded = [
    "theme"
];
function $bde9fd0381544b49$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $bGxpK.default)(_ref, $bde9fd0381544b49$var$_excluded);
    const scopedTheme = themeInput[0, $7wciM.default];
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3e6a8057b6fe07f6$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, props, {
        themeId: scopedTheme ? (0, $7wciM.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $dup7A = parcelRequire("dup7A");

var $8iNDC = parcelRequire("8iNDC");

var $fc1pF = parcelRequire("fc1pF");
function $86dcf517ba3ba2cd$export$24fdd7c0683a4fed(slot) {
    return (0, $8iNDC.default)("MuiLoadingButton", slot);
}
const $86dcf517ba3ba2cd$var$loadingButtonClasses = (0, $fc1pF.default)("MuiLoadingButton", [
    "root",
    "loading",
    "loadingIndicator",
    "loadingIndicatorCenter",
    "loadingIndicatorStart",
    "loadingIndicatorEnd",
    "endIconLoadingEnd",
    "startIconLoadingStart"
]);
var $86dcf517ba3ba2cd$export$2e2bcd8739ae039 = $86dcf517ba3ba2cd$var$loadingButtonClasses;




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $b8a34d2290e9294f$export$5e57a444791c63be(slot) {
    return (0, $8iNDC.default)("MuiDialogActions", slot);
}
const $b8a34d2290e9294f$var$dialogActionsClasses = (0, $fc1pF.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $b8a34d2290e9294f$export$2e2bcd8739ae039 = $b8a34d2290e9294f$var$dialogActionsClasses;



var $ggEZq = parcelRequire("ggEZq");

var $e50cx = parcelRequire("e50cx");

var $5B1Jc = parcelRequire("5B1Jc");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ecd44ebd791a3fa9$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $5B1Jc.default)(value, min, max);
}
function $ecd44ebd791a3fa9$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $ecd44ebd791a3fa9$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ecd44ebd791a3fa9$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $ecd44ebd791a3fa9$export$677b39864803984e($ecd44ebd791a3fa9$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $e50cx.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $e50cx.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ecd44ebd791a3fa9$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $ecd44ebd791a3fa9$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ecd44ebd791a3fa9$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ecd44ebd791a3fa9$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $ecd44ebd791a3fa9$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ecd44ebd791a3fa9$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $ecd44ebd791a3fa9$export$29fb7152bd3f781a(color) {
    color = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $ecd44ebd791a3fa9$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ecd44ebd791a3fa9$export$c852d90bf7403b62(color) {
    color = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $ecd44ebd791a3fa9$export$677b39864803984e($ecd44ebd791a3fa9$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ecd44ebd791a3fa9$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ecd44ebd791a3fa9$export$c852d90bf7403b62(foreground);
    const lumB = $ecd44ebd791a3fa9$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ecd44ebd791a3fa9$export$58f0f39f63f3cf42(color, value) {
    color = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    value = $ecd44ebd791a3fa9$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ecd44ebd791a3fa9$export$211a73f2b8c10ce4(color);
}
function $ecd44ebd791a3fa9$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ecd44ebd791a3fa9$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ecd44ebd791a3fa9$export$4b073707ff63303(color, coefficient) {
    color = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    coefficient = $ecd44ebd791a3fa9$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ecd44ebd791a3fa9$export$211a73f2b8c10ce4(color);
}
function $ecd44ebd791a3fa9$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ecd44ebd791a3fa9$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ecd44ebd791a3fa9$export$c0816ed86df316af(color, coefficient) {
    color = $ecd44ebd791a3fa9$export$677b39864803984e(color);
    coefficient = $ecd44ebd791a3fa9$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ecd44ebd791a3fa9$export$211a73f2b8c10ce4(color);
}
function $ecd44ebd791a3fa9$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ecd44ebd791a3fa9$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ecd44ebd791a3fa9$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ecd44ebd791a3fa9$export$c852d90bf7403b62(color) > 0.5 ? $ecd44ebd791a3fa9$export$4b073707ff63303(color, coefficient) : $ecd44ebd791a3fa9$export$c0816ed86df316af(color, coefficient);
}
function $ecd44ebd791a3fa9$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ecd44ebd791a3fa9$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ecd44ebd791a3fa9$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $ecd44ebd791a3fa9$export$677b39864803984e(background);
    const overlayColor = $ecd44ebd791a3fa9$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $ecd44ebd791a3fa9$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}


var $9qP3P = parcelRequire("9qP3P");
var $8eVik = parcelRequire("8eVik");
const $dd8a96349ff48acc$var$palette = {
    primary: {
        main: "#3F49E1",
        light: (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)("#3F49E1", 0.5),
        dark: (0, $ecd44ebd791a3fa9$export$4b073707ff63303)("#3F49E1", 0.2)
    },
    secondary: {
        main: "#F5B5FF",
        light: (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)("#F5B5FF", 0.5),
        dark: (0, $ecd44ebd791a3fa9$export$4b073707ff63303)("#F5B5FF", 0.2)
    },
    success: {
        main: "#0AA65B"
    },
    warning: {
        main: "#FFCC00"
    },
    error: {
        main: "#E5452F"
    },
    info: {
        main: "#297EFF"
    }
};
const $dd8a96349ff48acc$var$paletteLight = {
    text: {
        primary: "#000000",
        secondary: "#747474"
    }
};
const $dd8a96349ff48acc$var$paletteDark = {
    background: {
        paper: "#212121"
    }
};
const $dd8a96349ff48acc$var$shape = {
    borderRadius: 12,
    borderRadiusSecondary: 8
};
const $dd8a96349ff48acc$var$enterKeyframe = (0, $8eVik.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.05;
  }
  100% {
    transform: scale(1);
    opacity: 0.1;
  }
`;
const $dd8a96349ff48acc$export$25d302a5b900a763 = (mode, theme = {})=>{
    const primaryMainColor = theme.palette?.primary?.main ?? $dd8a96349ff48acc$var$palette.primary.main;
    const primaryLightColor = (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(theme.palette?.primary?.main ?? $dd8a96349ff48acc$var$palette.primary.main, 0.5);
    const primaryDarkColor = (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(theme.palette?.primary?.main ?? $dd8a96349ff48acc$var$palette.primary.main, 0.2);
    const contrastButtonColor = (0, $ecd44ebd791a3fa9$export$d061e26956a60b0a)((0, $ggEZq.default).white, primaryMainColor) >= 3 ? (0, $ggEZq.default).white : (0, $ggEZq.default).black;
    const contrastTextButtonColor = (0, $ecd44ebd791a3fa9$export$d061e26956a60b0a)((0, $ggEZq.default).white, (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(primaryMainColor, 0.08)) >= 3 ? (0, $ggEZq.default).white : (0, $ggEZq.default).black;
    return (0, $9qP3P.default)({
        typography: {
            fontFamily: "Inter var, Inter, sans-serif",
            ...theme.typography
        },
        palette: {
            mode: mode,
            ...$dd8a96349ff48acc$var$palette,
            ...mode === "light" ? $dd8a96349ff48acc$var$paletteLight : $dd8a96349ff48acc$var$paletteDark,
            ...theme.palette,
            primary: {
                main: primaryMainColor,
                light: primaryLightColor,
                dark: primaryDarkColor
            },
            secondary: {
                main: theme.palette?.secondary?.main ?? $dd8a96349ff48acc$var$palette.secondary.main,
                light: (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(theme.palette?.secondary?.main ?? $dd8a96349ff48acc$var$palette.secondary.main, 0.5),
                dark: (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(theme.palette?.secondary?.main ?? $dd8a96349ff48acc$var$palette.secondary.main, 0.2)
            }
        },
        shape: {
            ...$dd8a96349ff48acc$var$shape,
            ...theme.shape
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 392,
                md: 900,
                lg: 1200,
                xl: 1536
            }
        },
        components: {
            MuiScopedCssBaseline: {
                styleOverrides: {
                    root: {
                        fontFamily: "Inter, sans-serif",
                        ...theme.typography,
                        "@supports (font-variation-settings: normal)": {
                            fontFamily: "Inter var, sans-serif",
                            ...theme.typography
                        }
                    }
                }
            },
            MuiButtonBase: {
                styleOverrides: {
                    // This `css()` function invokes keyframes. `styled-components` only supports keyframes
                    // in string templates. Do not convert these styles in JS object as it will break.
                    root: (0, $8eVik.css)`
            &
              .${(0, $fce5e60dccd9caab$export$2e2bcd8739ae039).ripple}.${(0, $fce5e60dccd9caab$export$2e2bcd8739ae039).rippleVisible} {
              opacity: 0.1;
              animation-name: ${$dd8a96349ff48acc$var$enterKeyframe};
            }
          `
                }
            },
            MuiButton: {
                defaultProps: {
                    disableElevation: true
                },
                styleOverrides: {
                    root: {
                        borderRadius: theme.shape?.borderRadiusSecondary ?? $dd8a96349ff48acc$var$shape.borderRadiusSecondary,
                        textTransform: "none",
                        fontSize: "1rem",
                        [`&.Mui-disabled, &.Mui-disabled:hover`]: {
                            color: mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)((0, $ggEZq.default).black, 0.56) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)((0, $ggEZq.default).white, 0.56),
                            cursor: "not-allowed",
                            pointerEvents: "auto"
                        },
                        [`&.${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).loading}.Mui-disabled`]: {
                            backgroundColor: primaryMainColor,
                            color: contrastButtonColor,
                            cursor: "auto",
                            pointerEvents: "auto"
                        },
                        [`.${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).loadingIndicator}`]: {
                            color: contrastButtonColor
                        },
                        [`&.${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).root}.${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).loading}`]: {
                            color: "transparent"
                        }
                    },
                    text: {
                        backgroundColor: mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(primaryMainColor, 0.08) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(primaryMainColor, 0.42),
                        "&:hover": {
                            backgroundColor: mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(primaryMainColor, 0.12) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(primaryMainColor, 0.56)
                        },
                        color: mode === "light" ? primaryMainColor : contrastTextButtonColor
                    },
                    contained: {
                        "&:hover": {
                            color: contrastButtonColor
                        }
                    },
                    sizeMedium: {
                        padding: "10px 14px",
                        [`.${(0, $b8a34d2290e9294f$export$2e2bcd8739ae039).root} &`]: {
                            padding: "6px 12px"
                        }
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: "inherit",
                        "&:hover": {
                            color: "inherit"
                        }
                    }
                }
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        height: 32,
                        width: 32
                    }
                },
                ...theme.components?.MuiAvatar
            },
            MuiListItemAvatar: {
                styleOverrides: {
                    root: {
                        minWidth: 48
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    primary: ({ theme: theme })=>({
                            fontWeight: "500",
                            fontSize: "1.125rem",
                            lineHeight: "1.2778",
                            color: theme.palette.text.primary
                        }),
                    secondary: ({ theme: theme })=>({
                            fontWeight: "400",
                            fontSize: "0.75rem",
                            color: theme.palette.text.secondary
                        })
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: ({ theme: theme })=>({
                            backgroundColor: "rgb(0 0 0 / 64%)",
                            backdropFilter: "blur(3px)",
                            fontSize: "0.75rem",
                            padding: theme.spacing(1, 1.5)
                        }),
                    arrow: {
                        color: "rgb(0 0 0 / 64%)"
                    }
                }
            }
        }
    });
};



var $cZFtK = parcelRequire("cZFtK");

const $f8c8844dd4dd78cf$export$39f27e3f9a019cbb = ()=>{
    const [appearance, setValue] = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>[
            state.appearance,
            state.setValue
        ], (0, $cZFtK.shallow));
    const setAppearance = (appearance)=>{
        setValue("appearance", appearance);
    };
    return [
        appearance,
        setAppearance
    ];
};



const $55479fe71b959a30$export$d8964aec282183a3 = ({ children: children })=>{
    const { appearance: colorSchemeMode, theme: themeConfig } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const prefersDarkMode = (0, $b15e80d6e5586a57$export$2e2bcd8739ae039)("(prefers-color-scheme: dark)");
    const [appearance, setAppearance] = (0, $f8c8844dd4dd78cf$export$39f27e3f9a019cbb)();
    const [mode, setMode] = (0, $dup7A.useState)(colorSchemeMode ?? appearance === "auto" ? prefersDarkMode ? "dark" : "light" : appearance);
    (0, $dup7A.useEffect)(()=>{
        if (appearance === "auto") setMode(prefersDarkMode ? "dark" : "light");
        else setMode(appearance);
    }, [
        appearance,
        prefersDarkMode
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (colorSchemeMode) setAppearance(colorSchemeMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        colorSchemeMode
    ]);
    const theme = (0, $dup7A.useMemo)(()=>(0, $dd8a96349ff48acc$export$25d302a5b900a763)(mode, themeConfig), [
        mode,
        themeConfig
    ]);
    return (0, $cZGFG.jsx)((0, $bde9fd0381544b49$export$2e2bcd8739ae039), {
        theme: theme,
        children: children
    });
};


var $dup7A = parcelRequire("dup7A");



const $d3d577616828ca00$var$formValueKeys = [
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount,
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress,
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain,
    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken
];
const $d3d577616828ca00$export$fe80d0156ad81b0f = ()=>{
    const { pathname: pathname } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const { // Have to use touchedFields, because default values are not considered dirty
    touchedFields: { ...touchedFields } } = (0, $367773295ca041ba$export$606f11b2eb45ecc6)();
    const values = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: $d3d577616828ca00$var$formValueKeys
    });
    (0, $dup7A.useEffect)(()=>{
        const url = new URL(window.location);
        $d3d577616828ca00$var$formValueKeys.forEach((key, index)=>{
            if (touchedFields[key] && values[index]) url.searchParams.set(key, values[index]);
            else if (url.searchParams.has(key) && !values[index]) url.searchParams.delete(key);
        });
        url.searchParams.sort();
        window.history.replaceState(window.history.state, "", url);
    }, [
        pathname,
        touchedFields,
        values
    ]);
    return null;
};



var $cZGFG = parcelRequire("cZGFG");

var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");

const $ca520e918cee1775$export$15806ff9a87500a1 = ()=>{
    const { chains: chains } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { data: availableChains, isLoading: isLoadingAvailableChains } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "chains"
    ], async ()=>lifi.getChains(), {
        refetchInterval: 300000,
        staleTime: 300000
    });
    const filteredChains = (0, $dup7A.useMemo)(()=>{
        const filteredChains = availableChains?.filter((chain)=>(0, $cf40533b594545d4$export$5d91ca4c93de7266)(chain.id, chains));
        return filteredChains;
    }, [
        availableChains,
        chains
    ]);
    const getChainById = (0, $dup7A.useCallback)((chainId)=>{
        const chain = availableChains?.find((chain)=>chain.id === chainId);
        // if (!chain) {
        //   throw new Error('Chain not found or chainId is invalid.');
        // }
        return chain;
    }, [
        availableChains
    ]);
    return {
        chains: filteredChains,
        getChainById: getChainById,
        isLoading: isLoadingAvailableChains
    };
};




var $11Szb = parcelRequire("11Szb");

const $95883be0589c1da3$export$8bac4e0f2426fc98 = 9;
const $95883be0589c1da3$export$1bb705fae3d112c1 = ({ namePrefix: namePrefix })=>(0, $9dabe26fe674174f$export$c883e057baa24e24)((0, $11Szb.persist)((set, get)=>({
            chainOrder: [],
            availableChains: [],
            initializeChains: (chainIds)=>{
                set((state)=>{
                    const chainOrder = state.chainOrder.filter((chainId)=>chainIds.includes(chainId));
                    const chainsToAdd = chainIds.filter((chainId)=>!chainOrder.includes(chainId));
                    if (chainOrder.length === $95883be0589c1da3$export$8bac4e0f2426fc98 || !chainsToAdd.length) return {
                        availableChains: chainIds,
                        chainOrder: chainOrder
                    };
                    const chainsToAddLength = $95883be0589c1da3$export$8bac4e0f2426fc98 - chainOrder.length;
                    for(let index = 0; index < chainsToAddLength; index++)chainOrder.push(chainsToAdd[index]);
                    return {
                        availableChains: chainIds,
                        chainOrder: chainOrder
                    };
                });
                return get().chainOrder;
            },
            setChain: (chainId)=>{
                const state = get();
                if (state.chainOrder.includes(chainId) || !state.availableChains.includes(chainId)) return;
                set((state)=>{
                    const chainOrder = state.chainOrder.slice();
                    chainOrder.unshift(chainId);
                    if (chainOrder.length > $95883be0589c1da3$export$8bac4e0f2426fc98) chainOrder.pop();
                    return {
                        chainOrder: chainOrder
                    };
                });
            }
        }), {
        name: `${namePrefix || "li.fi"}-widget-chains-order`,
        version: 0,
        partialize: (state)=>({
                chainOrder: state.chainOrder
            })
    }), Object.is);


const $69a4ee88cdb0522f$export$6fed5c070f5f65ec = (0, $dup7A.createContext)(null);
function $69a4ee88cdb0522f$export$392fc2eed868296c({ children: children, ...props }) {
    const storeRef = (0, $dup7A.useRef)();
    const { chains: filteredChains } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const { setValue: setValue, getValues: getValues } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    if (!storeRef.current) storeRef.current = (0, $95883be0589c1da3$export$1bb705fae3d112c1)(props);
    (0, $dup7A.useEffect)(()=>{
        if (filteredChains) {
            const chainOrder = storeRef.current?.getState().initializeChains(filteredChains.map((chain)=>chain.id));
            if (chainOrder) {
                const [fromChainValue, toChainValue] = getValues([
                    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
                    (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain
                ]);
                if (!fromChainValue) setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain, chainOrder[0]);
                if (!toChainValue) setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain, chainOrder[0]);
            }
        }
    }, [
        filteredChains,
        getValues,
        setValue
    ]);
    return (0, $cZGFG.jsx)($69a4ee88cdb0522f$export$6fed5c070f5f65ec.Provider, {
        value: storeRef.current,
        children: children
    });
}
function $69a4ee88cdb0522f$export$2dd9c4acc5986304(selector, equalityFn) {
    const useStore = (0, $dup7A.useContext)($69a4ee88cdb0522f$export$6fed5c070f5f65ec);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$69a4ee88cdb0522f$export$392fc2eed868296c.name}>.`);
    return useStore(selector, equalityFn);
}
function $69a4ee88cdb0522f$export$f5d19620f23b78b2() {
    const useStore = (0, $dup7A.useContext)($69a4ee88cdb0522f$export$6fed5c070f5f65ec);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$69a4ee88cdb0522f$export$392fc2eed868296c.name}>.`);
    return useStore;
}



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

const $91390e33d9f5c5f2$export$cb541196c71f8ad3 = (0, $dup7A.createContext)(null);
function $91390e33d9f5c5f2$export$269314564cf6de99({ children: children, ...props }) {
    const storeRef = (0, $dup7A.useRef)();
    if (!storeRef.current) storeRef.current = $91390e33d9f5c5f2$export$b4846f5344fffb96(props);
    return (0, $cZGFG.jsx)($91390e33d9f5c5f2$export$cb541196c71f8ad3.Provider, {
        value: storeRef.current,
        children: children
    });
}
function $91390e33d9f5c5f2$export$b7680113a886673e(selector, equalityFn) {
    const useStore = (0, $dup7A.useContext)($91390e33d9f5c5f2$export$cb541196c71f8ad3);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$91390e33d9f5c5f2$export$269314564cf6de99.name}>.`);
    return useStore(selector, equalityFn);
}
function $91390e33d9f5c5f2$export$5255361406b00845() {
    const useStore = (0, $dup7A.useContext)($91390e33d9f5c5f2$export$cb541196c71f8ad3);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$91390e33d9f5c5f2$export$269314564cf6de99.name}>.`);
    return useStore;
}
const $91390e33d9f5c5f2$export$b4846f5344fffb96 = ({ namePrefix: namePrefix })=>(0, $9dabe26fe674174f$export$c883e057baa24e24)((set, get)=>({
            setAction: (element)=>{
                set(()=>({
                        element: element
                    }));
                return get().removeAction;
            },
            setTitle: (title)=>{
                set(()=>({
                        title: title
                    }));
                return get().removeTitle;
            },
            removeAction: ()=>{
                set(()=>({
                        element: null
                    }));
            },
            removeTitle: ()=>{
                set(()=>({
                        title: undefined
                    }));
            }
        }), Object.is);



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $11Szb = parcelRequire("11Szb");

const $253a8a88e3ebc36f$export$3a633d5116c5b50b = (flags, flag)=>(flags & flag) === flag;


var $2226555593f1025b$export$c56db2dca1307c9d;
(function(RouteExecutionStatus) {
    RouteExecutionStatus[RouteExecutionStatus["Idle"] = 0] = "Idle";
    RouteExecutionStatus[RouteExecutionStatus["Pending"] = 1] = "Pending";
    RouteExecutionStatus[RouteExecutionStatus["Done"] = 2] = "Done";
    RouteExecutionStatus[RouteExecutionStatus["Failed"] = 4] = "Failed";
    RouteExecutionStatus[RouteExecutionStatus["Partial"] = 8] = "Partial";
    RouteExecutionStatus[RouteExecutionStatus["Refunded"] = 16] = "Refunded";
})($2226555593f1025b$export$c56db2dca1307c9d || ($2226555593f1025b$export$c56db2dca1307c9d = {}));


const $899564e3609636e7$var$richTypes = {
    Date: true,
    RegExp: true,
    String: true,
    Number: true
};
function $899564e3609636e7$export$2e2bcd8739ae039(obj, newObj, options = {
    cyclesFix: true
}, _stack = []) {
    let diffs = [];
    const isObjArray = Array.isArray(obj);
    for(const key in obj){
        const objKey = obj[key];
        const path = isObjArray ? +key : key;
        if (!(key in newObj)) {
            diffs.push({
                type: "REMOVE",
                path: [
                    path
                ],
                oldValue: obj[key]
            });
            continue;
        }
        const newObjKey = newObj[key];
        const areCompatibleObjects = typeof objKey === "object" && typeof newObjKey === "object" && Array.isArray(objKey) === Array.isArray(newObjKey);
        if (objKey && newObjKey && areCompatibleObjects && !$899564e3609636e7$var$richTypes[Object.getPrototypeOf(objKey)?.constructor?.name] && (!options.cyclesFix || !_stack.includes(objKey))) {
            const nestedDiffs = $899564e3609636e7$export$2e2bcd8739ae039(objKey, newObjKey, options, options.cyclesFix ? _stack.concat([
                objKey
            ]) : []);
            diffs.push.apply(diffs, nestedDiffs.map((difference)=>{
                difference.path.unshift(path);
                return difference;
            }));
        } else if (objKey !== newObjKey && // treat NaN values as equivalent
        !(Number.isNaN(objKey) && Number.isNaN(newObjKey)) && !(areCompatibleObjects && (isNaN(objKey) ? objKey + "" === newObjKey + "" : +objKey === +newObjKey))) diffs.push({
            path: [
                path
            ],
            type: "CHANGE",
            value: newObjKey,
            oldValue: objKey
        });
    }
    const isNewObjArray = Array.isArray(newObj);
    for(const key in newObj)if (!(key in obj)) diffs.push({
        type: "CREATE",
        path: [
            isNewObjArray ? +key : key
        ],
        value: newObj[key]
    });
    return diffs;
}


const $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11 = (route)=>{
    return route.steps.every((step)=>step.execution?.status === "DONE");
};
const $4441d4f2fb25e8a3$export$70fee2fb27657c53 = (route)=>{
    return route.steps.some((step)=>step.execution?.process.some((process)=>process.substatus === "PARTIAL"));
};
const $4441d4f2fb25e8a3$export$c5e3d909b75f6e5f = (route)=>{
    return route.steps.some((step)=>step.execution?.process.some((process)=>process.substatus === "REFUNDED"));
};
const $4441d4f2fb25e8a3$export$e25cb6225450b7dc = (route)=>{
    return route.steps.some((step)=>step.execution?.status === "FAILED");
};
const $4441d4f2fb25e8a3$export$c29bd2ff03b21cd0 = (route)=>{
    if (!route) return false;
    const isDone = $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11(route);
    const isFailed = $4441d4f2fb25e8a3$export$e25cb6225450b7dc(route);
    const alreadyStarted = route.steps.some((step)=>step.execution);
    return !isDone && !isFailed && alreadyStarted;
};
const $4441d4f2fb25e8a3$export$3c71d1e487146022 = (route)=>{
    return route.steps.some((step)=>step.tool === "custom" || step.toolDetails.key === "custom");
};
const $4441d4f2fb25e8a3$export$1190a44d65e7d153 = (currentRoute, updatedRoute)=>{
    const processDiff = (0, $899564e3609636e7$export$2e2bcd8739ae039)(currentRoute, updatedRoute).find((diff)=>diff.path.includes("process"));
    if (!processDiff) return undefined;
    // e.g. ['steps', 0, 'execution', 'process', 0]
    const process = processDiff.path.slice(0, processDiff.path.findIndex((path)=>path === "process") + 2).reduce((obj, path)=>obj[path], updatedRoute);
    return process;
};


const $b62a330216726a01$export$c41041a13e7d26c4 = ({ namePrefix: namePrefix })=>(0, $9dabe26fe674174f$export$c883e057baa24e24)((0, $11Szb.persist)((set, get)=>({
            routes: {},
            setExecutableRoute: (route, insurableRouteId)=>{
                if (!get().routes[route.id]) set((state)=>{
                    const routes = {
                        ...state.routes
                    };
                    // clean previous idle routes that were not executed
                    Object.keys(routes).filter((routeId)=>routeId !== insurableRouteId && routes[routeId]?.status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle).forEach((routeId)=>delete routes[routeId]);
                    routes[route.id] = {
                        route: route,
                        status: (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle
                    };
                    return {
                        routes: routes
                    };
                });
            },
            updateRoute: (route)=>{
                if (get().routes[route.id]) set((state)=>{
                    const updatedState = {
                        routes: {
                            ...state.routes,
                            [route.id]: {
                                ...state.routes[route.id],
                                route: route
                            }
                        }
                    };
                    const isFailed = (0, $4441d4f2fb25e8a3$export$e25cb6225450b7dc)(route);
                    if (isFailed) {
                        updatedState.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed;
                        return updatedState;
                    }
                    const isDone = (0, $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11)(route);
                    if (isDone) {
                        updatedState.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Done;
                        if ((0, $4441d4f2fb25e8a3$export$70fee2fb27657c53)(route)) updatedState.routes[route.id].status |= (0, $2226555593f1025b$export$c56db2dca1307c9d).Partial;
                        else if ((0, $4441d4f2fb25e8a3$export$c5e3d909b75f6e5f)(route)) updatedState.routes[route.id].status |= (0, $2226555593f1025b$export$c56db2dca1307c9d).Refunded;
                        return updatedState;
                    }
                    const isLoading = route.steps.some((step)=>step.execution);
                    if (isLoading) updatedState.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Pending;
                    return updatedState;
                });
            },
            restartRoute: (routeId)=>{
                if (get().routes[routeId]) set((state)=>({
                        routes: {
                            ...state.routes,
                            [routeId]: {
                                ...state.routes[routeId],
                                status: (0, $2226555593f1025b$export$c56db2dca1307c9d).Pending
                            }
                        }
                    }));
            },
            deleteRoute: (routeId)=>{
                if (get().routes[routeId]) set((state)=>{
                    const routes = {
                        ...state.routes
                    };
                    delete routes[routeId];
                    return {
                        routes: routes
                    };
                });
            },
            deleteRoutes: (type)=>set((state)=>{
                    const routes = {
                        ...state.routes
                    };
                    Object.keys(routes).filter((routeId)=>type === "completed" ? (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(routes[routeId]?.status ?? 0, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done) : !(0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(routes[routeId]?.status ?? 0, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done)).forEach((routeId)=>delete routes[routeId]);
                    return {
                        routes: routes
                    };
                })
        }), {
        name: `${namePrefix || "li.fi"}-widget-routes`,
        version: 1,
        partialize: (state)=>({
                routes: state.routes
            }),
        merge: (persistedState, currentState)=>{
            const state = {
                ...currentState,
                ...persistedState
            };
            try {
                // Move transactions to history after 1 day
                const currentTime = new Date().getTime();
                const oneDay = 86400000;
                Object.values(state.routes).forEach((routeExecution)=>{
                    const startedAt = routeExecution?.route.steps?.find((step)=>step.execution?.status === "FAILED")?.execution?.process.find((process)=>process.startedAt)?.startedAt ?? 0;
                    const outdated = startedAt > 0 && currentTime - startedAt > oneDay;
                    if (routeExecution?.route && outdated) routeExecution.status |= (0, $2226555593f1025b$export$c56db2dca1307c9d).Done;
                });
                // migrate old routes
                const routeString = localStorage.getItem("routes");
                if (routeString) {
                    const routes = JSON.parse(routeString);
                    routes.forEach((route)=>{
                        if (state.routes[route.id]) return;
                        state.routes[route.id] = {
                            route: route,
                            status: (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle
                        };
                        const isFailed = (0, $4441d4f2fb25e8a3$export$e25cb6225450b7dc)(route);
                        if (isFailed) {
                            state.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed;
                            return;
                        }
                        const isDone = (0, $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11)(route);
                        if (isDone) {
                            state.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Done;
                            return;
                        }
                        const isLoading = route.steps.some((step)=>step.execution);
                        if (isLoading) state.routes[route.id].status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Pending;
                    });
                    localStorage.removeItem("routes");
                }
            } catch (error) {
                console.error(error);
            }
            return state;
        },
        migrate: (persistedState, version)=>{
            if (version === 0) Object.values(persistedState.routes).forEach((route)=>{
                if (route) switch(route.status){
                    case "idle":
                        route.status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle;
                        break;
                    case "loading":
                        route.status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Pending;
                        break;
                    case "success":
                    case "warning":
                        route.status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Done;
                        break;
                    case "error":
                        route.status = (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed;
                        break;
                    default:
                        break;
                }
            });
            return persistedState;
        }
    }), Object.is);


const $6f14d8247607a81d$export$88072327bb52037a = (0, $dup7A.createContext)(null);
function $6f14d8247607a81d$export$9fc921f489fdf4ad({ children: children, ...props }) {
    const storeRef = (0, $dup7A.useRef)();
    if (!storeRef.current) storeRef.current = (0, $b62a330216726a01$export$c41041a13e7d26c4)(props);
    return (0, $cZGFG.jsx)($6f14d8247607a81d$export$88072327bb52037a.Provider, {
        value: storeRef.current,
        children: children
    });
}
function $6f14d8247607a81d$export$6405db3e9caa77c(selector, equalityFn) {
    const useStore = (0, $dup7A.useContext)($6f14d8247607a81d$export$88072327bb52037a);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$6f14d8247607a81d$export$9fc921f489fdf4ad.name}>.`);
    return useStore(selector, equalityFn);
}
function $6f14d8247607a81d$export$c19b2275dd3fa5c9() {
    const useStore = (0, $dup7A.useContext)($6f14d8247607a81d$export$88072327bb52037a);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$6f14d8247607a81d$export$9fc921f489fdf4ad.name}>.`);
    return useStore;
}



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

const $5e8b8f7a49e68349$export$7bac7e93ba7152da = (0, $dup7A.createContext)(null);
const $5e8b8f7a49e68349$var$shouldRecreateStore = (store, props)=>{
    const { state: state } = store.getState();
    return state !== props.state;
};
function $5e8b8f7a49e68349$export$355a74bb37370f09({ children: children, ...props }) {
    const storeRef = (0, $dup7A.useRef)();
    if (!storeRef.current || $5e8b8f7a49e68349$var$shouldRecreateStore(storeRef.current, props)) storeRef.current = $5e8b8f7a49e68349$export$e854a6338c4ecdb2(props);
    return (0, $cZGFG.jsx)($5e8b8f7a49e68349$export$7bac7e93ba7152da.Provider, {
        value: storeRef.current,
        children: children
    });
}
function $5e8b8f7a49e68349$export$a7844f191cd50a20(selector, equalityFn) {
    const useStore = (0, $dup7A.useContext)($5e8b8f7a49e68349$export$7bac7e93ba7152da);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$5e8b8f7a49e68349$export$355a74bb37370f09.name}>.`);
    return useStore(selector, equalityFn);
}
function $5e8b8f7a49e68349$export$d8418c565630383e() {
    const useStore = (0, $dup7A.useContext)($5e8b8f7a49e68349$export$7bac7e93ba7152da);
    if (!useStore) throw new Error(`You forgot to wrap your component in <${$5e8b8f7a49e68349$export$355a74bb37370f09.name}>.`);
    return useStore;
}
const $5e8b8f7a49e68349$export$e854a6338c4ecdb2 = ({ state: state })=>(0, $9dabe26fe674174f$export$c883e057baa24e24)((set)=>({
            state: state,
            setState (state) {
                set(()=>({
                        state: state
                    }));
            }
        }), Object.is);


const $ab79c73675746dab$export$3b5c74f3f11c675d = ({ children: children, config: config })=>{
    return (0, $cZGFG.jsx)((0, $5e8b8f7a49e68349$export$355a74bb37370f09), {
        state: config.subvariant === "split" ? config.subvariantOptions || "swap" : undefined,
        children: (0, $cZGFG.jsx)((0, $91390e33d9f5c5f2$export$269314564cf6de99), {
            namePrefix: config?.keyPrefix,
            children: (0, $cZGFG.jsx)((0, $69a4ee88cdb0522f$export$392fc2eed868296c), {
                namePrefix: config?.keyPrefix,
                children: (0, $cZGFG.jsx)((0, $6f14d8247607a81d$export$9fc921f489fdf4ad), {
                    namePrefix: config?.keyPrefix,
                    children: children
                })
            })
        })
    });
};


const $66e56c53d939a720$export$c7dacf3845253dcf = ({ children: children, config: config })=>{
    return (0, $cZGFG.jsx)((0, $838c1a6e5f3807de$export$45604f0cc8ae667b), {
        client: (0, $ace8c73f6df29a6f$export$7c07b633a151f9c5),
        children: (0, $cZGFG.jsx)((0, $3f300e2d42fad4b6$export$42e76418f6ea3109), {
            config: config,
            children: (0, $cZGFG.jsx)((0, $b5765cf84e356f6b$export$e582a1640bc4a6de), {
                children: (0, $cZGFG.jsx)((0, $55479fe71b959a30$export$d8964aec282183a3), {
                    children: (0, $cZGFG.jsx)((0, $f8d057fc1037c594$export$a54013f0d02a8f82), {
                        children: (0, $cZGFG.jsx)((0, $fdce49c427c1eae3$export$717b22fc3a2082b3), {
                            children: (0, $cZGFG.jsx)((0, $872a2ff67e940b37$export$8ce1ff4f94d08846), {
                                children: (0, $cZGFG.jsx)((0, $ab79c73675746dab$export$3b5c74f3f11c675d), {
                                    config: config,
                                    children: (0, $cZGFG.jsx)($66e56c53d939a720$export$8707b35fd1c03f46, {
                                        children: children
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $66e56c53d939a720$export$8707b35fd1c03f46 = ({ children: children })=>{
    const { buildUrl: buildUrl } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const inRouterContext = (0, $5c6d50c15e61ec01$export$9c954a9d03d32f4a)();
    const Router = inRouterContext ? (0, $dup7A.Fragment) : (0, $5c6d50c15e61ec01$export$ae46f04cfaffe093);
    return (0, $cZGFG.jsxs)(Router, {
        children: [
            children,
            buildUrl ? (0, $cZGFG.jsx)((0, $d3d577616828ca00$export$fe80d0156ad81b0f), {}) : null
        ]
    });
};


var $57f573099db3f258$export$d98e2f690b7e6bcf;
(function(DisabledUI) {
    DisabledUI["FromAmount"] = "fromAmount";
    DisabledUI["FromToken"] = "fromToken";
    DisabledUI["ToAddress"] = "toAddress";
    DisabledUI["ToToken"] = "toToken";
})($57f573099db3f258$export$d98e2f690b7e6bcf || ($57f573099db3f258$export$d98e2f690b7e6bcf = {}));
var $57f573099db3f258$export$26716459e5ab8661;
(function(HiddenUI) {
    HiddenUI["Appearance"] = "appearance";
    HiddenUI["DrawerButton"] = "drawerButton";
    HiddenUI["DrawerCloseButton"] = "drawerCloseButton";
    HiddenUI["History"] = "history";
    HiddenUI["Language"] = "language";
    HiddenUI["PoweredBy"] = "poweredBy";
    HiddenUI["ToAddress"] = "toAddress";
    HiddenUI["ToToken"] = "toToken";
    HiddenUI["WalletMenu"] = "walletMenu";
})($57f573099db3f258$export$26716459e5ab8661 || ($57f573099db3f258$export$26716459e5ab8661 = {}));
var $57f573099db3f258$export$e825d82b4280cef6;
(function(RequiredUI) {
    RequiredUI["ToAddress"] = "toAddress";
})($57f573099db3f258$export$e825d82b4280cef6 || ($57f573099db3f258$export$e825d82b4280cef6 = {}));


const $3031021edd1ee258$export$14d25181d0b81c70 = (0, $dup7A.forwardRef)(({ elementRef: elementRef, open: open, onClose: onClose, integrator: integrator, config: config }, ref)=>{
    const openRef = (0, $dup7A.useRef)(Boolean(open));
    const [drawerOpen, setDrawerOpen] = (0, $dup7A.useState)(Boolean(open));
    const toggleDrawer = (0, $dup7A.useCallback)(()=>{
        setDrawerOpen((open)=>{
            openRef.current = !open;
            return openRef.current;
        });
        if (!openRef.current) onClose?.();
    }, [
        onClose
    ]);
    const openDrawer = (0, $dup7A.useCallback)(()=>{
        setDrawerOpen(true);
        openRef.current = true;
    }, []);
    const closeDrawer = (0, $dup7A.useCallback)(()=>{
        setDrawerOpen(false);
        openRef.current = false;
        onClose?.();
    }, [
        onClose
    ]);
    (0, $dup7A.useImperativeHandle)(ref, ()=>({
            isOpen: ()=>openRef.current,
            toggleDrawer: toggleDrawer,
            openDrawer: openDrawer,
            closeDrawer: closeDrawer
        }), [
        closeDrawer,
        openDrawer,
        toggleDrawer
    ]);
    const widgetConfig = (0, $dup7A.useMemo)(()=>({
            ...config,
            integrator: integrator,
            containerStyle: {
                ...config?.containerStyle,
                height: "100%"
            }
        }), [
        config,
        integrator
    ]);
    const drawerContext = (0, $dup7A.useMemo)(()=>({
            closeDrawer: closeDrawer
        }), [
        closeDrawer
    ]);
    return (0, $cZGFG.jsx)((0, $5b08acff347f037c$export$de4a09415a19ee2c).Provider, {
        value: drawerContext,
        children: (0, $cZGFG.jsxs)((0, $66e56c53d939a720$export$c7dacf3845253dcf), {
            config: widgetConfig,
            children: [
                !widgetConfig.hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).DrawerButton) ? (0, $cZGFG.jsxs)((0, $d29cf8ced0197b08$export$54ae93b604e45132), {
                    variant: "contained",
                    onClick: toggleDrawer,
                    open: drawerOpen,
                    drawerProps: config?.containerStyle,
                    children: [
                        drawerOpen ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($818bd5869d0697fa$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93b69bb58ac1254b$exports))), {}),
                        (0, $cZGFG.jsx)($3031021edd1ee258$export$760f19a20abfda15, {
                            open: drawerOpen,
                            subvariant: config?.subvariant
                        })
                    ]
                }) : null,
                (0, $cZGFG.jsx)((0, $087d17b7c478e027$export$2e2bcd8739ae039), {
                    ref: elementRef,
                    anchor: "right",
                    open: drawerOpen,
                    onClose: closeDrawer,
                    BackdropProps: {
                        sx: {
                            backgroundColor: "rgb(0 0 0 / 48%)",
                            backdropFilter: "blur(3px)"
                        }
                    },
                    PaperProps: {
                        sx: {
                            width: config?.containerStyle?.width ?? "100%",
                            minWidth: config?.containerStyle?.minWidth ?? 360,
                            maxWidth: config?.containerStyle?.maxWidth ?? 392
                        }
                    },
                    keepMounted: true,
                    children: (0, $cZGFG.jsx)((0, $2970462a292692d6$export$c066b70df7829ba), {})
                })
            ]
        })
    });
});
const $3031021edd1ee258$export$760f19a20abfda15 = ({ open: open, subvariant: subvariant })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsx)((0, $d29cf8ced0197b08$export$94875d0613ab57d1), {
        children: open ? t("button.hide") : subvariant === "nft" ? t("button.lifiCheckout") : t("button.lifiExchange")
    });
};




var $cZGFG = parcelRequire("cZGFG");


var $cZGFG = parcelRequire("cZGFG");
var $319651782fce7a90$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($319651782fce7a90$exports, "__esModule", {
    value: true
});
$319651782fce7a90$exports.default = void 0;

var $319651782fce7a90$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $319651782fce7a90$var$_default = $319651782fce7a90$exports.default = (0, $319651782fce7a90$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12m8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8"
}), "Block");



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");

var $aJAJS = parcelRequire("aJAJS");

var $912Uw = parcelRequire("912Uw");

var $7eWjf = parcelRequire("7eWjf");
var $9qvqC = parcelRequire("9qvqC");

var $lcALP = parcelRequire("lcALP");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $8c779dbc79bb1185$var$_excluded = [
    "className",
    "component"
];
function $8c779dbc79bb1185$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $912Uw.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $7eWjf.default));
    const Box = /*#__PURE__*/ $dup7A.forwardRef(function Box(inProps, ref) {
        const theme = (0, $lcALP.default)(defaultTheme);
        const _extendSxProp = (0, $9qvqC.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $bGxpK.default)(_extendSxProp, $8c779dbc79bb1185$var$_excluded);
        return /*#__PURE__*/ (0, $cZGFG.jsx)(BoxRoot, (0, $3G4eg.default)({
            as: component,
            ref: ref,
            className: (0, $aJAJS.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $fjjjN = parcelRequire("fjjjN");

var $9qP3P = parcelRequire("9qP3P");

var $7wciM = parcelRequire("7wciM");

var $fc1pF = parcelRequire("fc1pF");
const $f5343c9fc7abf9a3$var$boxClasses = (0, $fc1pF.default)("MuiBox", [
    "root"
]);
var $f5343c9fc7abf9a3$export$2e2bcd8739ae039 = $f5343c9fc7abf9a3$var$boxClasses;


"use client";
const $2c3aac5995a8a92e$var$defaultTheme = (0, $9qP3P.default)();
const $2c3aac5995a8a92e$var$Box = (0, $8c779dbc79bb1185$export$2e2bcd8739ae039)({
    themeId: (0, $7wciM.default),
    defaultTheme: $2c3aac5995a8a92e$var$defaultTheme,
    defaultClassName: (0, $f5343c9fc7abf9a3$export$2e2bcd8739ae039).root,
    generateClassName: (0, $fjjjN.default).generate
});
var $2c3aac5995a8a92e$export$2e2bcd8739ae039 = $2c3aac5995a8a92e$var$Box;



const $01b233a6d29a8b98$export$271f9f08425019c7 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            flex: 1,
            padding: 3
        },
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 48,
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($319651782fce7a90$exports))), {
                    fontSize: "inherit"
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 18,
                fontWeight: 700,
                children: t("tooltip.notFound.title")
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 14,
                color: "text.secondary",
                textAlign: "center",
                mt: 2,
                children: t("tooltip.notFound.text")
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $e7063c060c419724$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($e7063c060c419724$exports, "__esModule", {
    value: true
});
$e7063c060c419724$exports.default = void 0;

var $e7063c060c419724$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $e7063c060c419724$var$_default = $e7063c060c419724$exports.default = (0, $e7063c060c419724$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), "DeleteOutline");




var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $8iNDC = parcelRequire("8iNDC");

var $2wgr3 = parcelRequire("2wgr3");

var $8xa0D = parcelRequire("8xa0D");

var $866st = parcelRequire("866st");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $912Uw = parcelRequire("912Uw");

var $gmeoE = parcelRequire("gmeoE");



var $1kGZC = parcelRequire("1kGZC");

var $7eWjf = parcelRequire("7eWjf");
const $9604c75f9a393fa6$var$_excluded = [
    "ownerState"
], $9604c75f9a393fa6$var$_excluded2 = [
    "variants"
], $9604c75f9a393fa6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $9604c75f9a393fa6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9604c75f9a393fa6$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9604c75f9a393fa6$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $9604c75f9a393fa6$export$35e57303dbd8a66 = (0, $1kGZC.default)();
const $9604c75f9a393fa6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $9604c75f9a393fa6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $9604c75f9a393fa6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $9604c75f9a393fa6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $9604c75f9a393fa6$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $bGxpK.default)(_ref, $9604c75f9a393fa6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $3G4eg.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$9604c75f9a393fa6$var$processStyleArg(resolvedStyle, (0, $3G4eg.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $bGxpK.default)(resolvedStylesArg, $9604c75f9a393fa6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $3G4eg.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $3G4eg.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $9604c75f9a393fa6$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9604c75f9a393fa6$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9604c75f9a393fa6$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9604c75f9a393fa6$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $7eWjf.default)((0, $3G4eg.default)({}, props, {
            theme: $9604c75f9a393fa6$var$resolveTheme((0, $3G4eg.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $912Uw.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9604c75f9a393fa6$var$defaultOverridesResolver($9604c75f9a393fa6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $bGxpK.default)(inputOptions, $9604c75f9a393fa6$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $9604c75f9a393fa6$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9604c75f9a393fa6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $912Uw.default)(tag, (0, $3G4eg.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $gmeoE.isPlainObject)(stylesArg)) return (props)=>$9604c75f9a393fa6$var$processStyleArg(stylesArg, (0, $3G4eg.default)({}, props, {
                    theme: $9604c75f9a393fa6$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $9604c75f9a393fa6$var$resolveTheme((0, $3G4eg.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $9604c75f9a393fa6$var$processStyleArg(slotStyle, (0, $3G4eg.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $9604c75f9a393fa6$var$resolveTheme((0, $3G4eg.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $9604c75f9a393fa6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $3G4eg.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $c4998d526f81b02b$var$styled = (0, $9604c75f9a393fa6$export$2e2bcd8739ae039)();
var $c4998d526f81b02b$export$2e2bcd8739ae039 = $c4998d526f81b02b$var$styled;



var $1kGZC = parcelRequire("1kGZC");

var $cZGFG = parcelRequire("cZGFG");
const $8905ecf1353e7883$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $8905ecf1353e7883$var$defaultTheme = (0, $1kGZC.default)();
const $8905ecf1353e7883$var$defaultCreateStyledComponent = (0, $c4998d526f81b02b$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $8xa0D.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $8905ecf1353e7883$var$useThemePropsDefault = (inProps)=>(0, $866st.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $8905ecf1353e7883$var$defaultTheme
    });
const $8905ecf1353e7883$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $8iNDC.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $8xa0D.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $2wgr3.default)(slots, getContainerUtilityClass, classes);
};
function $8905ecf1353e7883$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $8905ecf1353e7883$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $8905ecf1353e7883$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $dup7A.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $bGxpK.default)(props, $8905ecf1353e7883$var$_excluded);
        const ownerState = (0, $3G4eg.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $8905ecf1353e7883$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $cZGFG.jsx)(ContainerRoot, (0, $3G4eg.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aJAJS.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $4y4xl = parcelRequire("4y4xl");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");
"use client";
const $0aedfe5fa751939c$var$Container = (0, $8905ecf1353e7883$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $jjHhy.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $4y4xl.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $7ZufN.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $0aedfe5fa751939c$export$2e2bcd8739ae039 = $0aedfe5fa751939c$var$Container;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $20eff1c46eaadcad$var$_excluded = [
    "className",
    "disableSpacing"
];
const $20eff1c46eaadcad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $b8a34d2290e9294f$export$5e57a444791c63be), classes);
};
const $20eff1c46eaadcad$var$DialogActionsRoot = (0, $jjHhy.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $20eff1c46eaadcad$var$DialogActions = /*#__PURE__*/ $dup7A.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $bGxpK.default)(props, $20eff1c46eaadcad$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $20eff1c46eaadcad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($20eff1c46eaadcad$var$DialogActionsRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $20eff1c46eaadcad$export$2e2bcd8739ae039 = $20eff1c46eaadcad$var$DialogActions;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $01de7b03fde25bea$export$61b0ee1f05fb344e(slot) {
    return (0, $8iNDC.default)("MuiDialogContent", slot);
}
const $01de7b03fde25bea$var$dialogContentClasses = (0, $fc1pF.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $01de7b03fde25bea$export$2e2bcd8739ae039 = $01de7b03fde25bea$var$dialogContentClasses;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $05b6a399bdb88281$export$f5d2ec7e4c47e088(slot) {
    return (0, $8iNDC.default)("MuiDialogTitle", slot);
}
const $05b6a399bdb88281$var$dialogTitleClasses = (0, $fc1pF.default)("MuiDialogTitle", [
    "root"
]);
var $05b6a399bdb88281$export$2e2bcd8739ae039 = $05b6a399bdb88281$var$dialogTitleClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $da3939ee95c82076$var$_excluded = [
    "className",
    "dividers"
];
const $da3939ee95c82076$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $01de7b03fde25bea$export$61b0ee1f05fb344e), classes);
};
const $da3939ee95c82076$var$DialogContentRoot = (0, $jjHhy.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $05b6a399bdb88281$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $da3939ee95c82076$var$DialogContent = /*#__PURE__*/ $dup7A.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $bGxpK.default)(props, $da3939ee95c82076$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        dividers: dividers
    });
    const classes = $da3939ee95c82076$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($da3939ee95c82076$var$DialogContentRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $da3939ee95c82076$export$2e2bcd8739ae039 = $da3939ee95c82076$var$DialogContent;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $f1e6f0853c4cc10b$export$d9c6dc45f75b0e4f(slot) {
    return (0, $8iNDC.default)("MuiDialogContentText", slot);
}
const $f1e6f0853c4cc10b$var$dialogContentTextClasses = (0, $fc1pF.default)("MuiDialogContentText", [
    "root"
]);
var $f1e6f0853c4cc10b$export$2e2bcd8739ae039 = $f1e6f0853c4cc10b$var$dialogContentTextClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $1f0b92c5665aa4ca$var$_excluded = [
    "children",
    "className"
];
const $1f0b92c5665aa4ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $f1e6f0853c4cc10b$export$d9c6dc45f75b0e4f), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $1f0b92c5665aa4ca$var$DialogContentTextRoot = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $1f0b92c5665aa4ca$var$DialogContentText = /*#__PURE__*/ $dup7A.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $bGxpK.default)(props, $1f0b92c5665aa4ca$var$_excluded);
    const classes = $1f0b92c5665aa4ca$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($1f0b92c5665aa4ca$var$DialogContentTextRoot, (0, $3G4eg.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $1f0b92c5665aa4ca$export$2e2bcd8739ae039 = $1f0b92c5665aa4ca$var$DialogContentText;


var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");


var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $dup7A = parcelRequire("dup7A");
const $5184f1d168e90da6$var$DialogContext = /*#__PURE__*/ $dup7A.createContext({});
var $5184f1d168e90da6$export$2e2bcd8739ae039 = $5184f1d168e90da6$var$DialogContext;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $c7caddaf71674940$var$_excluded = [
    "className",
    "id"
];
const $c7caddaf71674940$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $05b6a399bdb88281$export$f5d2ec7e4c47e088), classes);
};
const $c7caddaf71674940$var$DialogTitleRoot = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $c7caddaf71674940$var$DialogTitle = /*#__PURE__*/ $dup7A.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $bGxpK.default)(props, $c7caddaf71674940$var$_excluded);
    const ownerState = props;
    const classes = $c7caddaf71674940$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $dup7A.useContext((0, $5184f1d168e90da6$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $cZGFG.jsx)($c7caddaf71674940$var$DialogTitleRoot, (0, $3G4eg.default)({
        component: "h2",
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $c7caddaf71674940$export$2e2bcd8739ae039 = $c7caddaf71674940$var$DialogTitle;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $dup7A = parcelRequire("dup7A");
"use client";
/**
 * @ignore - internal component.
 */ const $fa61e1e507b3416c$var$ListContext = /*#__PURE__*/ $dup7A.createContext({});
var $fa61e1e507b3416c$export$2e2bcd8739ae039 = $fa61e1e507b3416c$var$ListContext;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $c90d7a45c3d7a6ba$export$c6bd6795ed6e3203(slot) {
    return (0, $8iNDC.default)("MuiList", slot);
}
const $c90d7a45c3d7a6ba$var$listClasses = (0, $fc1pF.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $c90d7a45c3d7a6ba$export$2e2bcd8739ae039 = $c90d7a45c3d7a6ba$var$listClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $025f7c64e2fa0248$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $025f7c64e2fa0248$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $c90d7a45c3d7a6ba$export$c6bd6795ed6e3203), classes);
};
const $025f7c64e2fa0248$var$ListRoot = (0, $jjHhy.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $025f7c64e2fa0248$var$List = /*#__PURE__*/ $dup7A.forwardRef(function List(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $bGxpK.default)(props, $025f7c64e2fa0248$var$_excluded);
    const context = $dup7A.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $025f7c64e2fa0248$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa61e1e507b3416c$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)($025f7c64e2fa0248$var$ListRoot, (0, $3G4eg.default)({
            as: component,
            className: (0, $aJAJS.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $025f7c64e2fa0248$export$2e2bcd8739ae039 = $025f7c64e2fa0248$var$List;



var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
var $9ffa5f6fcfa1255e$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($9ffa5f6fcfa1255e$exports, "__esModule", {
    value: true
});
$9ffa5f6fcfa1255e$exports.default = void 0;

var $9ffa5f6fcfa1255e$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $9ffa5f6fcfa1255e$var$_default = $9ffa5f6fcfa1255e$exports.default = (0, $9ffa5f6fcfa1255e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");


var $80b718eceab489f4$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($80b718eceab489f4$exports, "__esModule", {
    value: true
});
$80b718eceab489f4$exports.default = void 0;

var $80b718eceab489f4$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $80b718eceab489f4$var$_default = $80b718eceab489f4$exports.default = (0, $80b718eceab489f4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), "ErrorRounded");


var $70197f36b6f91ee5$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($70197f36b6f91ee5$exports, "__esModule", {
    value: true
});
$70197f36b6f91ee5$exports.default = void 0;

var $70197f36b6f91ee5$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $70197f36b6f91ee5$var$_default = $70197f36b6f91ee5$exports.default = (0, $70197f36b6f91ee5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z"
}), "InfoRounded");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");


var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $628212a6f120377f$export$e4f04f80f2ce3fc0(slot) {
    return (0, $8iNDC.default)("MuiListItemAvatar", slot);
}
const $628212a6f120377f$var$listItemAvatarClasses = (0, $fc1pF.default)("MuiListItemAvatar", [
    "root",
    "alignItemsFlexStart"
]);
var $628212a6f120377f$export$2e2bcd8739ae039 = $628212a6f120377f$var$listItemAvatarClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $e53d295c232cfe79$var$_excluded = [
    "className"
];
const $e53d295c232cfe79$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $628212a6f120377f$export$e4f04f80f2ce3fc0), classes);
};
const $e53d295c232cfe79$var$ListItemAvatarRoot = (0, $jjHhy.default)("div", {
    name: "MuiListItemAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        minWidth: 56,
        flexShrink: 0
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $e53d295c232cfe79$var$ListItemAvatar = /*#__PURE__*/ $dup7A.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiListItemAvatar"
    });
    const { className: className } = props, other = (0, $bGxpK.default)(props, $e53d295c232cfe79$var$_excluded);
    const context = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    const ownerState = (0, $3G4eg.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $e53d295c232cfe79$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($e53d295c232cfe79$var$ListItemAvatarRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $e53d295c232cfe79$export$2e2bcd8739ae039 = $e53d295c232cfe79$var$ListItemAvatar;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");



var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $dfa991117ab0a5da$export$1061006a0db3aeb5(slot) {
    return (0, $8iNDC.default)("MuiListItemText", slot);
}
const $dfa991117ab0a5da$var$listItemTextClasses = (0, $fc1pF.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $dfa991117ab0a5da$export$2e2bcd8739ae039 = $dfa991117ab0a5da$var$listItemTextClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $ced3bf777dc38827$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $ced3bf777dc38827$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $dfa991117ab0a5da$export$1061006a0db3aeb5), classes);
};
const $ced3bf777dc38827$var$ListItemTextRoot = (0, $jjHhy.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $ced3bf777dc38827$var$ListItemText = /*#__PURE__*/ $dup7A.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $bGxpK.default)(props, $ced3bf777dc38827$var$_excluded);
    const { dense: dense } = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $3G4eg.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $ced3bf777dc38827$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($ced3bf777dc38827$var$ListItemTextRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $ced3bf777dc38827$export$2e2bcd8739ae039 = $ced3bf777dc38827$var$ListItemText;








const $a9b09eb4d34322c5$export$f8e5ba18f67b75bc = (step, process)=>{
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    if (!step || !process) return {};
    return $a9b09eb4d34322c5$export$c1f6bd730b0cbdd0(t, getChainById, step, process, subvariant);
};
const $a9b09eb4d34322c5$var$processStatusMessages = {
    TOKEN_ALLOWANCE: {
        STARTED: (t)=>t(`main.process.tokenAllowance.started`),
        ACTION_REQUIRED: (t)=>t(`main.process.tokenAllowance.pending`),
        PENDING: (t)=>t(`main.process.tokenAllowance.pending`),
        DONE: (t)=>t(`main.process.tokenAllowance.done`)
    },
    SWITCH_CHAIN: {
        ACTION_REQUIRED: (t)=>t(`main.process.switchChain.actionRequired`),
        DONE: (t)=>t(`main.process.switchChain.done`)
    },
    SWAP: {
        STARTED: (t)=>t(`main.process.swap.started`),
        ACTION_REQUIRED: (t)=>t(`main.process.swap.actionRequired`),
        PENDING: (t)=>t(`main.process.swap.pending`),
        DONE: (t, subvariant)=>subvariant === "nft" ? t(`main.process.nft.done`) : t(`main.process.swap.done`)
    },
    CROSS_CHAIN: {
        STARTED: (t)=>t(`main.process.crossChain.started`),
        ACTION_REQUIRED: (t)=>t(`main.process.crossChain.actionRequired`),
        PENDING: (t)=>t(`main.process.crossChain.pending`),
        DONE: (t)=>t(`main.process.crossChain.done`)
    },
    RECEIVING_CHAIN: {
        PENDING: (t)=>t(`main.process.receivingChain.pending`),
        DONE: (t, subvariant)=>subvariant === "nft" ? t(`main.process.nft.done`) : t(`main.process.receivingChain.done`)
    },
    TRANSACTION: {}
};
const $a9b09eb4d34322c5$var$processSubstatusMessages = {
    PENDING: {
    },
    DONE: {
        // COMPLETED: 'The transfer is complete.',
        PARTIAL: (t)=>t(`main.process.receivingChain.partial`),
        REFUNDED: (t)=>t(`main.process.receivingChain.partial`)
    },
    FAILED: {
    },
    INVALID: {},
    NOT_FOUND: {}
};
function $a9b09eb4d34322c5$export$c1f6bd730b0cbdd0(t, getChainById, step, process, subvariant) {
    if (process.error && process.status === "FAILED") {
        const getTransactionNotSentMessage = ()=>t(`error.message.transactionNotSent`, {
                amount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(step.action.fromAmount, step.action.fromToken.decimals),
                tokenSymbol: step.action.fromToken.symbol,
                chainName: getChainById(step.action.fromChainId)?.name ?? ""
            });
        let title = "";
        let message = "";
        switch(process.error.code){
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).AllowanceRequired:
                title = t(`error.title.allowanceRequired`);
                message = t(`error.message.allowanceRequired`, {
                    tokenSymbol: step.action.fromToken.symbol
                });
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).BalanceError:
                title = t(`error.title.balanceIsTooLow`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ChainSwitchError:
                title = t(`error.title.chainSwitch`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).GasLimitError:
                title = t(`error.title.gasLimitIsTooLow`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).InsufficientFunds:
                title = t(`error.title.insufficientFunds`);
                message = `${t(`error.message.insufficientFunds`)} ${getTransactionNotSentMessage()}`;
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).SlippageError:
                title = t(`error.title.slippageNotMet`);
                message = t(`error.message.slippageThreshold`);
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionFailed:
                title = t(`error.title.transactionFailed`);
                message = t(`error.message.transactionFailed`);
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnderpriced:
                title = t(`error.title.transactionUnderpriced`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionUnprepared:
                title = t(`error.title.transactionUnprepared`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionCanceled:
                title = t(`error.title.transactionCanceled`);
                message = getTransactionNotSentMessage();
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).TransactionRejected:
                title = t(`error.title.transactionRejected`);
                message = t(`error.message.transactionRejected`, {
                    amount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(step.action.fromAmount, step.action.fromToken.decimals),
                    tokenSymbol: step.action.fromToken.symbol,
                    chainName: getChainById(step.action.fromChainId)?.name ?? ""
                });
                break;
            case (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).ProviderUnavailable:
            default:
                title = t(`error.title.unknown`);
                if (process.txLink) message = t(`error.message.transactionFailed`);
                else message = t(`error.message.unknown`);
                break;
        }
        return {
            title: title,
            message: message
        };
    }
    const title = $a9b09eb4d34322c5$var$processSubstatusMessages[process.status]?.[process.substatus]?.(t) ?? $a9b09eb4d34322c5$var$processStatusMessages[process.type]?.[process.status]?.(t, subvariant);
    return {
        title: title
    };
}



var $dup7A = parcelRequire("dup7A");

var $cZFtK = parcelRequire("cZFtK");




const $3ebe4fdf186d93e7$export$f5db81c77ed06ae3 = ({ routeId: routeId, executeInBackground: executeInBackground, onAcceptExchangeRateUpdate: onAcceptExchangeRateUpdate })=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)();
    const { account: account, switchChain: switchChain } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const resumedAfterMount = (0, $dup7A.useRef)(false);
    const emitter = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    const routeExecutionStoreContext = (0, $6f14d8247607a81d$export$c19b2275dd3fa5c9)();
    const routeExecution = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>state.routes[routeId]);
    const [updateRoute, restartRoute, deleteRoute] = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>[
            state.updateRoute,
            state.restartRoute,
            state.deleteRoute
        ], (0, $cZFtK.shallow));
    const updateRouteHook = (updatedRoute)=>{
        const routeExecution = routeExecutionStoreContext.getState().routes[updatedRoute.id];
        if (!routeExecution) return;
        const clonedUpdatedRoute = structuredClone(updatedRoute);
        updateRoute(clonedUpdatedRoute);
        const process = (0, $4441d4f2fb25e8a3$export$1190a44d65e7d153)(routeExecution.route, clonedUpdatedRoute);
        if (process) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteExecutionUpdated, {
            route: clonedUpdatedRoute,
            process: process
        });
        if ((0, $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11)(clonedUpdatedRoute)) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteExecutionCompleted, clonedUpdatedRoute);
        if ((0, $4441d4f2fb25e8a3$export$e25cb6225450b7dc)(clonedUpdatedRoute) && process) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteExecutionFailed, {
            route: clonedUpdatedRoute,
            process: process
        });
        console.log("Route updated.", clonedUpdatedRoute);
    };
    const switchChainHook = async (requiredChainId)=>{
        if (!account.isActive || !account.signer) return account.signer;
        const currentChainId = await account.signer.getChainId();
        if (currentChainId !== requiredChainId) {
            const signer = await switchChain(requiredChainId);
            if (!signer) throw new Error("Chain was not switched.");
            return signer;
        }
        return account.signer;
    };
    const acceptExchangeRateUpdateHook = async (params)=>{
        if (!onAcceptExchangeRateUpdate) return false;
        const accepted = await new Promise((resolve)=>onAcceptExchangeRateUpdate(resolve, params));
        return accepted;
    };
    const executeRouteMutation = (0, $fb112f8e80340db4$export$609860bf8b0084c)(()=>{
        if (!account.signer) throw Error("Account signer not found.");
        if (!routeExecution?.route) throw Error("Execution route not found.");
        queryClient.removeQueries([
            "routes"
        ], {
            exact: false
        });
        return lifi.executeRoute(account.signer, routeExecution.route, {
            updateRouteHook: updateRouteHook,
            switchChainHook: switchChainHook,
            acceptExchangeRateUpdateHook: acceptExchangeRateUpdateHook,
            infiniteApproval: false,
            executeInBackground: executeInBackground
        });
    }, {
        onMutate: ()=>{
            console.log("Execution started.", routeId);
            if (routeExecution) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteExecutionStarted, routeExecution.route);
        }
    });
    const resumeRouteMutation = (0, $fb112f8e80340db4$export$609860bf8b0084c)((resumedRoute)=>{
        if (!account.signer) throw Error("Account signer not found.");
        if (!routeExecution?.route) throw Error("Execution route not found.");
        return lifi.resumeRoute(account.signer, resumedRoute ?? routeExecution.route, {
            updateRouteHook: updateRouteHook,
            switchChainHook: switchChainHook,
            acceptExchangeRateUpdateHook: acceptExchangeRateUpdateHook,
            infiniteApproval: false,
            executeInBackground: executeInBackground
        });
    }, {
        onMutate: ()=>{
            console.log("Resumed to execution.", routeId);
        }
    });
    const executeRoute = (0, $dup7A.useCallback)(()=>{
        executeRouteMutation.mutateAsync(undefined, {
            onError: (error)=>{
                console.warn("Execution failed!", routeId, error);
            },
            onSuccess: (route)=>{
                console.log("Executed successfully!", route);
            }
        });
    }, [
        executeRouteMutation,
        routeId
    ]);
    const resumeRoute = (0, $dup7A.useCallback)((route)=>{
        resumeRouteMutation.mutateAsync(route, {
            onError: (error)=>{
                console.warn("Resumed execution failed.", routeId, error);
            },
            onSuccess: (route)=>{
                console.log("Resumed execution successful.", route);
            }
        });
    }, [
        resumeRouteMutation,
        routeId
    ]);
    const restartRouteMutation = (0, $dup7A.useCallback)(()=>{
        restartRoute(routeId);
        resumeRoute(routeExecution?.route);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resumeRoute,
        routeExecution?.route,
        routeId
    ]);
    const deleteRouteMutation = (0, $dup7A.useCallback)(()=>{
        deleteRoute(routeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeId
    ]);
    // Resume route execution after page reload
    (0, $dup7A.useEffect)(()=>{
        // Check if route is eligible for automatic resuming
        if ((0, $4441d4f2fb25e8a3$export$c29bd2ff03b21cd0)(routeExecution?.route) && account.isActive && !resumedAfterMount.current) {
            resumedAfterMount.current = true;
            resumeRoute();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        account.isActive
    ]);
    (0, $dup7A.useEffect)(()=>{
        return ()=>{
            const route = routeExecutionStoreContext.getState().routes[routeId]?.route;
            if (!route || !(0, $4441d4f2fb25e8a3$export$c29bd2ff03b21cd0)(route)) return;
            lifi.updateRouteExecution(route, {
                executeInBackground: true
            });
            console.log("Move route execution to background.", routeId);
            resumedAfterMount.current = false;
        };
    }, [
        lifi,
        routeExecutionStoreContext,
        routeId
    ]);
    return {
        executeRoute: executeRoute,
        restartRoute: restartRouteMutation,
        deleteRoute: deleteRouteMutation,
        route: routeExecution?.route,
        status: routeExecution?.status
    };
};



const $8b67d0eddea325ef$export$492bdc31a14c4d1 = {
    home: "/",
    activeTransactions: "active-transactions",
    bridges: "bridges",
    exchanges: "exchanges",
    fromChain: "from-chain",
    fromToken: "from-token",
    routes: "routes",
    selectWallet: "wallet",
    settings: "settings",
    toChain: "to-chain",
    toToken: "to-token",
    toTokenNative: "to-token-native",
    transactionDetails: "transaction-details",
    transactionExecution: "transaction-execution",
    transactionHistory: "transaction-history"
};
const $8b67d0eddea325ef$export$7817d6e8e0e6a150 = Object.values($8b67d0eddea325ef$export$492bdc31a14c4d1);
const $8b67d0eddea325ef$export$b3fae4083350f87 = [
    $8b67d0eddea325ef$export$492bdc31a14c4d1.activeTransactions,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.bridges,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.exchanges,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.fromChain,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.home,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.routes,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.selectWallet,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.settings,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.toChain,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.toTokenNative,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionDetails,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionExecution,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionHistory
];
const $8b67d0eddea325ef$export$13424e02f438f2e = [
    $8b67d0eddea325ef$export$492bdc31a14c4d1.activeTransactions,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.bridges,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.exchanges,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.fromChain,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.fromToken,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.routes,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.selectWallet,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.settings,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.toChain,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.toToken,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.toTokenNative,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionDetails,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionExecution,
    $8b67d0eddea325ef$export$492bdc31a14c4d1.transactionHistory
];



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $2920a3e5548b5635$exports = {};

!function(e, t) {
    $2920a3e5548b5635$exports = t((parcelRequire("dup7A")));
}("undefined" != typeof self ? self : $2920a3e5548b5635$exports, (e)=>(()=>{
        "use strict";
        var t = {
            156: (t)=>{
                t.exports = e;
            }
        }, r = {};
        function o(e) {
            var n = r[e];
            if (void 0 !== n) return n.exports;
            var s = r[e] = {
                exports: {}
            };
            return t[e](s, s.exports, o), s.exports;
        }
        o.d = (e, t)=>{
            for(var r in t)o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, o.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), o.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            o.r(n), o.d(n, {
                default: ()=>l,
                useStopwatch: ()=>u,
                useTime: ()=>m,
                useTimer: ()=>c
            });
            var e = o(156);
            class t {
                static expiryTimestamp(e) {
                    const t = new Date(e).getTime() > 0;
                    return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                }
                static onExpire(e) {
                    const t = e && "function" == typeof e;
                    return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                }
            }
            class r {
                static getTimeFromSeconds(e) {
                    const t = Math.ceil(e), r = Math.floor(t / 86400), o = Math.floor(t % 86400 / 3600), n = Math.floor(t % 3600 / 60);
                    return {
                        totalSeconds: t,
                        seconds: Math.floor(t % 60),
                        minutes: n,
                        hours: o,
                        days: r
                    };
                }
                static getSecondsFromExpiry(e, t) {
                    const r = e - (new Date).getTime();
                    if (r > 0) {
                        const e = r / 1e3;
                        return t ? Math.round(e) : e;
                    }
                    return 0;
                }
                static getSecondsFromPrevTime(e, t) {
                    const r = (new Date).getTime() - e;
                    if (r > 0) {
                        const e = r / 1e3;
                        return t ? Math.round(e) : e;
                    }
                    return 0;
                }
                static getSecondsFromTimeNow() {
                    const e = new Date;
                    return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                }
                static getFormattedTimeFromSeconds(e, t) {
                    const { seconds: o, minutes: n, hours: s } = r.getTimeFromSeconds(e);
                    let i = "", a = s;
                    return "12-hour" === t && (i = s >= 12 ? "pm" : "am", a = s % 12), {
                        seconds: o,
                        minutes: n,
                        hours: a,
                        ampm: i
                    };
                }
            }
            function s(t, r) {
                const o = (0, e.useRef)();
                (0, e.useEffect)(()=>{
                    o.current = t;
                }), (0, e.useEffect)(()=>{
                    if (!r) return ()=>{};
                    const e = setInterval(()=>{
                        o.current && o.current();
                    }, r);
                    return ()=>clearInterval(e);
                }, [
                    r
                ]);
            }
            const i = 1e3;
            function a(e) {
                if (!t.expiryTimestamp(e)) return null;
                const o = r.getSecondsFromExpiry(e), n = Math.floor(1e3 * (o - Math.floor(o)));
                return n > 0 ? n : i;
            }
            function c() {
                let { expiryTimestamp: o, onExpire: n, autoStart: c = !0 } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [u, m] = (0, e.useState)(o), [l, d] = (0, e.useState)(r.getSecondsFromExpiry(u)), [p, f] = (0, e.useState)(c), [g, S] = (0, e.useState)(c), [T, y] = (0, e.useState)(a(u)), h = (0, e.useCallback)(()=>{
                    t.onExpire(n) && n(), f(!1), y(null);
                }, [
                    n
                ]), x = (0, e.useCallback)(()=>{
                    f(!1);
                }, []), v = (0, e.useCallback)(function(e) {
                    let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    y(a(e)), S(t), f(t), m(e), d(r.getSecondsFromExpiry(e));
                }, []), F = (0, e.useCallback)(()=>{
                    const e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * l), v(e);
                }, [
                    l,
                    v
                ]), b = (0, e.useCallback)(()=>{
                    g ? (d(r.getSecondsFromExpiry(u)), f(!0)) : F();
                }, [
                    u,
                    g,
                    F
                ]);
                return s(()=>{
                    T !== i && y(i);
                    const e = r.getSecondsFromExpiry(u);
                    d(e), e <= 0 && h();
                }, p ? T : null), {
                    ...r.getTimeFromSeconds(l),
                    start: b,
                    pause: x,
                    resume: F,
                    restart: v,
                    isRunning: p
                };
            }
            function u() {
                let { autoStart: t, offsetTimestamp: o } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [n, i] = (0, e.useState)(r.getSecondsFromExpiry(o, !0) || 0), [a, c] = (0, e.useState)(new Date), [u, m] = (0, e.useState)(n + r.getSecondsFromPrevTime(a || 0, !0)), [l, d] = (0, e.useState)(t);
                s(()=>{
                    m(n + r.getSecondsFromPrevTime(a, !0));
                }, l ? 1e3 : null);
                const p = (0, e.useCallback)(()=>{
                    const e = new Date;
                    c(e), d(!0), m(n + r.getSecondsFromPrevTime(e, !0));
                }, [
                    n
                ]), f = (0, e.useCallback)(()=>{
                    i(u), d(!1);
                }, [
                    u
                ]), g = (0, e.useCallback)(function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    const o = r.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                    c(n), i(o), d(t), m(o + r.getSecondsFromPrevTime(n, !0));
                }, []);
                return {
                    ...r.getTimeFromSeconds(u),
                    start: p,
                    pause: f,
                    reset: g,
                    isRunning: l
                };
            }
            function m() {
                let { format: t } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const [o, n] = (0, e.useState)(r.getSecondsFromTimeNow());
                return s(()=>{
                    n(r.getSecondsFromTimeNow());
                }, 1e3), {
                    ...r.getFormattedTimeFromSeconds(o, t)
                };
            }
            function l(t) {
                if ((0, e.useEffect)(()=>{
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), t.expiryTimestamp) {
                    const e = c(t);
                    return {
                        ...e,
                        startTimer: e.start,
                        stopTimer: e.pause,
                        resetTimer: ()=>{}
                    };
                }
                const r = u(t);
                return {
                    ...r,
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                };
            }
        })(), n;
    })());


const $5e8e03e301157ec7$var$getExpiryTimestamp = (step)=>new Date((step.execution?.process[0]?.startedAt ?? Date.now()) + step.estimate.executionDuration * 1000);
const $5e8e03e301157ec7$export$7f5b674fa502d40e = ({ step: step, hideInProgress: hideInProgress })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const [isExpired, setExpired] = (0, $dup7A.useState)(false);
    const [isExecutionStarted, setExecutionStarted] = (0, $dup7A.useState)(!!step.execution);
    const [expiryTimestamp] = (0, $dup7A.useState)(()=>$5e8e03e301157ec7$var$getExpiryTimestamp(step));
    const { seconds: seconds, minutes: minutes, isRunning: isRunning, pause: pause, resume: resume, restart: restart } = (0, $2920a3e5548b5635$exports.useTimer)({
        autoStart: false,
        expiryTimestamp: expiryTimestamp,
        onExpire: ()=>setExpired(true)
    });
    (0, $dup7A.useEffect)(()=>{
        if (isExpired || !step.execution) return;
        if (!isExecutionStarted) {
            setExecutionStarted(true);
            restart($5e8e03e301157ec7$var$getExpiryTimestamp(step));
        }
        const shouldBePaused = step.execution.process.some((process)=>process.status === "ACTION_REQUIRED" || process.status === "FAILED");
        if (isRunning && shouldBePaused) pause();
        else if (!isRunning && !shouldBePaused) resume();
    }, [
        expiryTimestamp,
        isExecutionStarted,
        isExpired,
        isRunning,
        pause,
        restart,
        resume,
        step
    ]);
    if (!isExecutionStarted) return (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: t("main.estimatedTime", {
            value: Math.ceil(step.estimate.executionDuration / 60)
        })
    });
    const isTimerExpired = isExpired || !minutes && !seconds;
    if (step.execution?.status === "DONE" || step.execution?.status === "FAILED" || isTimerExpired && hideInProgress) return null;
    return isTimerExpired ? (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: t("main.inProgress")
    }) : // eslint-disable-next-line react/jsx-no-useless-fragment
    (0, $cZGFG.jsx)((0, $cZGFG.Fragment), {
        children: `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");
function $49cad466f431519b$export$ff8356348e0cc878(name) {
    return 0, $7ZufN.default;
}


var $jjHhy = parcelRequire("jjHhy");
parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $be45d8c6e2509a7b$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $0b3483f892a4c486$export$ffd560f22c0ecf04(slot) {
    return (0, $8iNDC.default)("MuiAvatar", slot);
}
const $0b3483f892a4c486$var$avatarClasses = (0, $fc1pF.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $0b3483f892a4c486$export$2e2bcd8739ae039 = $0b3483f892a4c486$var$avatarClasses;



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");


"use client";
const $c245e07c2b962da7$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $c245e07c2b962da7$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $c245e07c2b962da7$var$_excluded3 = [
    "component"
];
function $c245e07c2b962da7$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $bGxpK.default)(parameters, $c245e07c2b962da7$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $bGxpK.default)(externalForwardedProps, $c245e07c2b962da7$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $2a17380801fdceb6$export$308c24034cde71de)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $36d10b367697a2f8$export$b01d1e419b049226)((0, $3G4eg.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $bGxpK.default)(_mergeSlotProps.props, $c245e07c2b962da7$var$_excluded3);
    const ref = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $3G4eg.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(elementType, (0, $3G4eg.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $585ddd894619170d$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $585ddd894619170d$var$useThemeProps = (0, $49cad466f431519b$export$ff8356348e0cc878)("MuiAvatar");
const $585ddd894619170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $0b3483f892a4c486$export$ffd560f22c0ecf04), classes);
};
const $585ddd894619170d$var$AvatarRoot = (0, $jjHhy.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $3G4eg.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $3G4eg.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $585ddd894619170d$var$AvatarImg = (0, $jjHhy.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $585ddd894619170d$var$AvatarFallback = (0, $jjHhy.default)((0, $be45d8c6e2509a7b$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $585ddd894619170d$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $dup7A.useState(false);
    $dup7A.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $585ddd894619170d$var$Avatar = /*#__PURE__*/ $dup7A.forwardRef(function Avatar(inProps, ref) {
    const props = $585ddd894619170d$var$useThemeProps({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $bGxpK.default)(props, $585ddd894619170d$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $585ddd894619170d$var$useLoaded((0, $3G4eg.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $3G4eg.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $585ddd894619170d$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $c245e07c2b962da7$export$2e2bcd8739ae039)("img", {
        className: classes.img,
        elementType: $585ddd894619170d$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $3G4eg.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $cZGFG.jsx)(ImgSlot, (0, $3G4eg.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $cZGFG.jsx)($585ddd894619170d$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($585ddd894619170d$var$AvatarRoot, (0, $3G4eg.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $585ddd894619170d$export$2e2bcd8739ae039 = $585ddd894619170d$var$Avatar;


var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $dup7A = parcelRequire("dup7A");
"use client";
const $2f127f329916f5b2$var$usePreviousProps = (value)=>{
    const ref = $dup7A.useRef({});
    $dup7A.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $2f127f329916f5b2$export$2e2bcd8739ae039 = $2f127f329916f5b2$var$usePreviousProps;



var $2wgr3 = parcelRequire("2wgr3");

"use client";
function $364fcfc80d44f21d$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $2f127f329916f5b2$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}




var $jjHhy = parcelRequire("jjHhy");

var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $59bc093316bf3eff$export$aaccef17e6dab084(slot) {
    return (0, $8iNDC.default)("MuiBadge", slot);
}
const $59bc093316bf3eff$var$badgeClasses = (0, $fc1pF.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $59bc093316bf3eff$export$2e2bcd8739ae039 = $59bc093316bf3eff$var$badgeClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $63d882d7181c3b8b$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $63d882d7181c3b8b$var$RADIUS_STANDARD = 10;
const $63d882d7181c3b8b$var$RADIUS_DOT = 4;
const $63d882d7181c3b8b$var$useThemeProps = (0, $49cad466f431519b$export$ff8356348e0cc878)("MuiBadge");
const $63d882d7181c3b8b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $4y4xl.default)(anchorOrigin.vertical)}${(0, $4y4xl.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $4y4xl.default)(anchorOrigin.vertical)}${(0, $4y4xl.default)(anchorOrigin.horizontal)}${(0, $4y4xl.default)(overlap)}`,
            `overlap${(0, $4y4xl.default)(overlap)}`,
            color !== "default" && `color${(0, $4y4xl.default)(color)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $59bc093316bf3eff$export$aaccef17e6dab084), classes);
};
const $63d882d7181c3b8b$var$BadgeRoot = (0, $jjHhy.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $63d882d7181c3b8b$var$BadgeBadge = (0, $jjHhy.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $4y4xl.default)(ownerState.anchorOrigin.vertical)}${(0, $4y4xl.default)(ownerState.anchorOrigin.horizontal)}${(0, $4y4xl.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $4y4xl.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $63d882d7181c3b8b$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $63d882d7181c3b8b$var$RADIUS_STANDARD * 2,
        borderRadius: $63d882d7181c3b8b$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: $63d882d7181c3b8b$var$RADIUS_DOT,
                    height: $63d882d7181c3b8b$var$RADIUS_DOT * 2,
                    minWidth: $63d882d7181c3b8b$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $63d882d7181c3b8b$var$Badge = /*#__PURE__*/ $dup7A.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = $63d882d7181c3b8b$var$useThemeProps({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $bGxpK.default)(props, $63d882d7181c3b8b$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $364fcfc80d44f21d$export$6105a25a68f1d9ae)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $2f127f329916f5b2$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, $3G4eg.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $63d882d7181c3b8b$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $63d882d7181c3b8b$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $63d882d7181c3b8b$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $aJAJS.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)(RootSlot, (0, $3G4eg.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $cZGFG.jsx)(BadgeSlot, (0, $3G4eg.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $63d882d7181c3b8b$export$2e2bcd8739ae039 = $63d882d7181c3b8b$var$Badge;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $aJAJS = parcelRequire("aJAJS");


var $8eVik = parcelRequire("8eVik");

var $2wgr3 = parcelRequire("2wgr3");
function $132f650fc8938a9f$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $132f650fc8938a9f$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $132f650fc8938a9f$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $132f650fc8938a9f$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $132f650fc8938a9f$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $132f650fc8938a9f$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $132f650fc8938a9f$export$8af1d214c6c2f0f1(length) * $132f650fc8938a9f$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $132f650fc8938a9f$export$8af1d214c6c2f0f1(length) * $132f650fc8938a9f$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $132f650fc8938a9f$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $132f650fc8938a9f$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $132f650fc8938a9f$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $132f650fc8938a9f$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $132f650fc8938a9f$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $b34d7e369c4698f8$export$c987db9fc844f86(slot) {
    return (0, $8iNDC.default)("MuiSkeleton", slot);
}
const $b34d7e369c4698f8$var$skeletonClasses = (0, $fc1pF.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $b34d7e369c4698f8$export$2e2bcd8739ae039 = $b34d7e369c4698f8$var$skeletonClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $d5ac3ea486321678$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $d5ac3ea486321678$var$_ = (t)=>t, $d5ac3ea486321678$var$_t, $d5ac3ea486321678$var$_t2, $d5ac3ea486321678$var$_t3, $d5ac3ea486321678$var$_t4;
const $d5ac3ea486321678$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $b34d7e369c4698f8$export$c987db9fc844f86), classes);
};
const $d5ac3ea486321678$var$pulseKeyframe = (0, $8eVik.keyframes)($d5ac3ea486321678$var$_t || ($d5ac3ea486321678$var$_t = $d5ac3ea486321678$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $d5ac3ea486321678$var$waveKeyframe = (0, $8eVik.keyframes)($d5ac3ea486321678$var$_t2 || ($d5ac3ea486321678$var$_t2 = $d5ac3ea486321678$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $d5ac3ea486321678$var$SkeletonRoot = (0, $jjHhy.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $132f650fc8938a9f$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $132f650fc8938a9f$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $3G4eg.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $8eVik.css)($d5ac3ea486321678$var$_t3 || ($d5ac3ea486321678$var$_t3 = $d5ac3ea486321678$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $d5ac3ea486321678$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $8eVik.css)($d5ac3ea486321678$var$_t4 || ($d5ac3ea486321678$var$_t4 = $d5ac3ea486321678$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $d5ac3ea486321678$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $d5ac3ea486321678$var$Skeleton = /*#__PURE__*/ $dup7A.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $bGxpK.default)(props, $d5ac3ea486321678$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $d5ac3ea486321678$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($d5ac3ea486321678$var$SkeletonRoot, (0, $3G4eg.default)({
        as: component,
        ref: ref,
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $3G4eg.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $d5ac3ea486321678$export$2e2bcd8739ae039 = $d5ac3ea486321678$var$Skeleton;



var $dup7A = parcelRequire("dup7A");

const $404c35d02d3b62e7$export$a4a17273dffcc09c = (chainId)=>{
    const { chains: chains, isLoading: isLoading } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const chain = (0, $dup7A.useMemo)(()=>{
        const chain = chains?.find((chain)=>chain.id === chainId);
        return chain;
    }, [
        chainId,
        chains
    ]);
    return {
        chain: chain,
        isLoading: isLoading
    };
};


var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");

const $d222653a4cfabf8d$export$c76ae3e918fa0ce4 = (selectedChainId)=>{
    const { tokens: tokens } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    return (0, $dup7A.useMemo)(()=>tokens?.featured?.filter((token)=>token.chainId === selectedChainId), [
        selectedChainId,
        tokens?.featured
    ]);
};


const $cc6b88a592537212$export$7c008f4adb925d9f = (selectedChainId)=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { data: data, isLoading: isLoading } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "tokens"
    ], ()=>lifi.getTokens(), {
        refetchInterval: 3600000
    });
    const { getChainById: getChainById, isLoading: isSupportedChainsLoading } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const featuredTokens = (0, $d222653a4cfabf8d$export$c76ae3e918fa0ce4)(selectedChainId);
    const { tokens: configTokens, chains: configChains } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const tokens = (0, $dup7A.useMemo)(()=>{
        if (isSupportedChainsLoading) return [];
        const chainAllowed = selectedChainId && getChainById(selectedChainId) && (0, $cf40533b594545d4$export$5d91ca4c93de7266)(selectedChainId, configChains);
        if (!chainAllowed) return [];
        let filteredTokens = data?.tokens[selectedChainId];
        const includedTokens = configTokens?.include?.filter((token)=>token.chainId === selectedChainId);
        if (includedTokens?.length) filteredTokens = filteredTokens ? [
            ...includedTokens,
            ...filteredTokens
        ] : includedTokens;
        const allowedTokens = configTokens?.allow?.filter((token)=>token.chainId === selectedChainId).map((token)=>token.address);
        if (allowedTokens?.length) filteredTokens = filteredTokens?.filter((token)=>allowedTokens.includes(token.address));
        const deniedTokenAddresses = configTokens?.deny?.filter((token)=>token.chainId === selectedChainId).map((token)=>token.address);
        if (deniedTokenAddresses?.length) filteredTokens = filteredTokens?.filter((token)=>!deniedTokenAddresses.includes(token.address));
        const featuredTokenAddresses = new Set(featuredTokens?.map((token)=>token.address));
        const tokens = [
            ...featuredTokens?.map((token)=>{
                token.featured = true;
                return token;
            }) ?? [],
            ...filteredTokens?.filter((token)=>!featuredTokenAddresses.has(token.address)) ?? []
        ];
        return tokens;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configChains,
        configTokens?.allow,
        configTokens?.deny,
        configTokens?.include,
        data?.tokens,
        data,
        featuredTokens,
        getChainById,
        isSupportedChainsLoading,
        selectedChainId
    ]);
    return {
        tokens: tokens,
        isLoading: isLoading
    };
};




const $d7d129fc68322cb5$export$865d60499a0ea4f0 = (chainId, tokenQuery, enabled)=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)();
    const { data: data, isLoading: isLoading } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "token-search",
        chainId,
        tokenQuery
    ], async ({ queryKey: [, chainId, tokenQuery], signal: signal })=>{
        const token = await lifi.getToken(chainId, tokenQuery, {
            signal: signal
        });
        if (token) queryClient.setQueriesData([
            "tokens"
        ], (data)=>{
            if (data && !data.tokens[chainId]?.some((t)=>t.address === token.address)) {
                const clonedData = {
                    ...data
                };
                clonedData.tokens[chainId]?.push(token);
                return clonedData;
            }
        });
        return token;
    }, {
        enabled: Boolean(chainId && tokenQuery && enabled),
        retry: false
    });
    return {
        token: data,
        isLoading: isLoading
    };
};


const $b486f29e55929307$export$31dcd79391e423fe = (chainId, tokenAddress)=>{
    const { tokens: tokens, isLoading: isLoading } = (0, $cc6b88a592537212$export$7c008f4adb925d9f)(chainId);
    const token = (0, $dup7A.useMemo)(()=>{
        const token = tokens?.find((token)=>token.address === tokenAddress && token.chainId === chainId);
        return token;
    }, [
        chainId,
        tokenAddress,
        tokens
    ]);
    const tokenSearchEnabled = !isLoading && !token;
    const { token: searchedToken, isLoading: isSearchedTokenLoading } = (0, $d7d129fc68322cb5$export$865d60499a0ea4f0)(chainId, tokenAddress, tokenSearchEnabled);
    return {
        token: token ?? searchedToken,
        isLoading: isLoading || tokenSearchEnabled && isSearchedTokenLoading
    };
};



var $cZGFG = parcelRequire("cZGFG");


var $jjHhy = parcelRequire("jjHhy");
const $27f4d60427bfd654$export$adf59ad56eeb21a2 = (0, $jjHhy.default)((0, $585ddd894619170d$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: theme.palette.background.paper,
        width: 16,
        height: 16,
        border: `2px solid ${theme.palette.background.paper}`
    }));
const $27f4d60427bfd654$export$87fd4c7f47a690e8 = (0, $jjHhy.default)((0, $d5ac3ea486321678$export$2e2bcd8739ae039))(({ theme: theme })=>({
        border: `2px solid ${theme.palette.background.paper}`,
        width: 16,
        height: 16
    }));
const $27f4d60427bfd654$export$2fc495b9b2e992a9 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: theme.palette.background.paper,
        borderRadius: "50%"
    }));
const $27f4d60427bfd654$export$d5ca290dbfd97557 = ()=>{
    return (0, $cZGFG.jsx)($27f4d60427bfd654$export$2fc495b9b2e992a9, {
        children: (0, $cZGFG.jsx)($27f4d60427bfd654$export$87fd4c7f47a690e8, {
            variant: "circular"
        })
    });
};



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

parcelRequire("8vAu6");

var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $6f0e1eefc0dce72f$export$e278541d928aee3a(slot) {
    return (0, $8iNDC.default)("MuiAvatarGroup", slot);
}
const $6f0e1eefc0dce72f$var$avatarGroupClasses = (0, $fc1pF.default)("MuiAvatarGroup", [
    "root",
    "avatar"
]);
var $6f0e1eefc0dce72f$export$2e2bcd8739ae039 = $6f0e1eefc0dce72f$var$avatarGroupClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $07158ac4b9182083$var$_excluded = [
    "children",
    "className",
    "component",
    "componentsProps",
    "max",
    "renderSurplus",
    "slotProps",
    "spacing",
    "total",
    "variant"
];
const $07158ac4b9182083$var$SPACINGS = {
    small: -16,
    medium: null
};
const $07158ac4b9182083$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $6f0e1eefc0dce72f$export$e278541d928aee3a), classes);
};
const $07158ac4b9182083$var$AvatarGroupRoot = (0, $jjHhy.default)("div", {
    name: "MuiAvatarGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $3G4eg.default)({
            [`& .${(0, $6f0e1eefc0dce72f$export$2e2bcd8739ae039).avatar}`]: styles.avatar
        }, styles.root)
})(({ theme: theme, ownerState: ownerState })=>{
    const marginValue = ownerState.spacing && $07158ac4b9182083$var$SPACINGS[ownerState.spacing] !== undefined ? $07158ac4b9182083$var$SPACINGS[ownerState.spacing] : -ownerState.spacing;
    return {
        [`& .${(0, $0b3483f892a4c486$export$2e2bcd8739ae039).root}`]: {
            border: `2px solid ${(theme.vars || theme).palette.background.default}`,
            boxSizing: "content-box",
            marginLeft: marginValue != null ? marginValue : -8,
            "&:last-child": {
                marginLeft: 0
            }
        },
        display: "flex",
        flexDirection: "row-reverse"
    };
});
const $07158ac4b9182083$var$AvatarGroup = /*#__PURE__*/ $dup7A.forwardRef(function AvatarGroup(inProps, ref) {
    var _slotProps$additional;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiAvatarGroup"
    });
    const { children: childrenProp, className: className, component: component = "div", componentsProps: componentsProps = {}, max: max = 5, renderSurplus: renderSurplus, slotProps: slotProps = {}, spacing: spacing = "medium", total: total, variant: variant = "circular" } = props, other = (0, $bGxpK.default)(props, $07158ac4b9182083$var$_excluded);
    let clampedMax = max < 2 ? 2 : max;
    const ownerState = (0, $3G4eg.default)({}, props, {
        max: max,
        spacing: spacing,
        component: component,
        variant: variant
    });
    const classes = $07158ac4b9182083$var$useUtilityClasses(ownerState);
    const children = $dup7A.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $dup7A.isValidElement(child);
    });
    const totalAvatars = total || children.length;
    if (totalAvatars === clampedMax) clampedMax += 1;
    clampedMax = Math.min(totalAvatars + 1, clampedMax);
    const maxAvatars = Math.min(children.length, clampedMax - 1);
    const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
    const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
    const additionalAvatarSlotProps = (_slotProps$additional = slotProps.additionalAvatar) != null ? _slotProps$additional : componentsProps.additionalAvatar;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($07158ac4b9182083$var$AvatarGroupRoot, (0, $3G4eg.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            extraAvatars ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), (0, $3G4eg.default)({
                variant: variant
            }, additionalAvatarSlotProps, {
                className: (0, $aJAJS.default)(classes.avatar, additionalAvatarSlotProps == null ? void 0 : additionalAvatarSlotProps.className),
                children: extraAvatarsElement
            })) : null,
            children.slice(0, maxAvatars).reverse().map((child)=>{
                return /*#__PURE__*/ $dup7A.cloneElement(child, {
                    className: (0, $aJAJS.default)(child.props.className, classes.avatar),
                    variant: child.props.variant || variant
                });
            })
        ]
    }));
});
var $07158ac4b9182083$export$2e2bcd8739ae039 = $07158ac4b9182083$var$AvatarGroup;





var $jjHhy = parcelRequire("jjHhy");
const $e82e88984bcce286$export$bca2c04c0e6cd524 = (0, $jjHhy.default)((0, $07158ac4b9182083$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`& .${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).badge}:last-child .${(0, $0b3483f892a4c486$export$2e2bcd8739ae039).root}`]: {
            marginLeft: theme.spacing(-1),
            boxSizing: "border-box"
        },
        [`& .${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).root}:last-child`]: {
            marginLeft: theme.spacing(1)
        }
    }));
const $e82e88984bcce286$export$d545813ac404ba6f = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        borderRadius: "50%"
    }));
const $e82e88984bcce286$export$7a9ffcf8ab158b16 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        border: `2px solid ${theme.palette.background.paper}`,
        borderRadius: "50%"
    }));


const $21d2469ec33e67c2$export$9dd64073d3423a1f = ({ token: token, isLoading: isLoading, sx: sx })=>{
    const { chain: chain } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(token?.chainId);
    const { token: chainToken, isLoading: isLoadingToken } = (0, $b486f29e55929307$export$31dcd79391e423fe)(token?.chainId, token?.address);
    return (0, $cZGFG.jsx)($21d2469ec33e67c2$export$679f46f554e8a9de, {
        token: chainToken ?? token,
        isLoading: isLoading || isLoadingToken,
        chain: chain,
        sx: sx
    });
};
const $21d2469ec33e67c2$export$679f46f554e8a9de = ({ token: token, chain: chain, isLoading: isLoading, sx: sx })=>{
    return (0, $cZGFG.jsx)((0, $63d882d7181c3b8b$export$2e2bcd8739ae039), {
        overlap: "circular",
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        badgeContent: chain && !isLoading ? (0, $cZGFG.jsx)((0, $27f4d60427bfd654$export$adf59ad56eeb21a2), {
            src: chain.logoURI,
            alt: chain.name,
            children: chain.name[0]
        }) : (0, $cZGFG.jsx)((0, $27f4d60427bfd654$export$d5ca290dbfd97557), {}),
        sx: sx,
        children: isLoading ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
            width: 32,
            height: 32,
            variant: "circular"
        }) : (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
            src: token?.logoURI,
            alt: token?.symbol,
            children: token?.symbol?.[0]
        })
    });
};
const $21d2469ec33e67c2$export$56e8839726e826f3 = ({ token: token, chain: chain, isLoading: isLoading, sx: sx })=>{
    if (!chain || !token?.logoURI) return (0, $cZGFG.jsx)($21d2469ec33e67c2$export$9dd64073d3423a1f, {
        token: token,
        isLoading: isLoading,
        sx: sx
    });
    return (0, $cZGFG.jsx)($21d2469ec33e67c2$export$679f46f554e8a9de, {
        token: token,
        chain: chain,
        isLoading: isLoading,
        sx: sx
    });
};
const $21d2469ec33e67c2$export$aeac0dce6f0792e = ({ sx: sx })=>{
    return (0, $cZGFG.jsx)((0, $63d882d7181c3b8b$export$2e2bcd8739ae039), {
        overlap: "circular",
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        badgeContent: (0, $cZGFG.jsx)((0, $e82e88984bcce286$export$7a9ffcf8ab158b16), {
            width: 16,
            height: 16
        }),
        sx: sx,
        children: (0, $cZGFG.jsx)((0, $e82e88984bcce286$export$d545813ac404ba6f), {
            width: 32,
            height: 32
        })
    });
};



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");



var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $dup7A = parcelRequire("dup7A");
function $f6620e42f1170b6a$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $dup7A.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $39313ccf598a6345$export$2e2bcd8739ae039 = (0, $f6620e42f1170b6a$export$2e2bcd8739ae039);



"use client";
var $48ac1416032c7f21$export$2e2bcd8739ae039 = (0, $6db36b98959a73d4$export$2e2bcd8739ae039);





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $23a208812445d8fb$export$5682c366c0c669d9(slot) {
    return (0, $8iNDC.default)("MuiListItem", slot);
}
const $23a208812445d8fb$var$listItemClasses = (0, $fc1pF.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $23a208812445d8fb$export$2e2bcd8739ae039 = $23a208812445d8fb$var$listItemClasses;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $63e07b9ad249e545$export$c09531d8563c67a5(slot) {
    return (0, $8iNDC.default)("MuiListItemButton", slot);
}
const $63e07b9ad249e545$var$listItemButtonClasses = (0, $fc1pF.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $63e07b9ad249e545$export$2e2bcd8739ae039 = $63e07b9ad249e545$var$listItemButtonClasses;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $9248fa0ee28b36bd$export$ccdb26aeba48a86e(slot) {
    return (0, $8iNDC.default)("MuiListItemSecondaryAction", slot);
}
const $9248fa0ee28b36bd$var$listItemSecondaryActionClasses = (0, $fc1pF.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $9248fa0ee28b36bd$export$2e2bcd8739ae039 = $9248fa0ee28b36bd$var$listItemSecondaryActionClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $f2a93b9cb1abf16d$var$_excluded = [
    "className"
];
const $f2a93b9cb1abf16d$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $9248fa0ee28b36bd$export$ccdb26aeba48a86e), classes);
};
const $f2a93b9cb1abf16d$var$ListItemSecondaryActionRoot = (0, $jjHhy.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $f2a93b9cb1abf16d$var$ListItemSecondaryAction = /*#__PURE__*/ $dup7A.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $bGxpK.default)(props, $f2a93b9cb1abf16d$var$_excluded);
    const context = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    const ownerState = (0, $3G4eg.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $f2a93b9cb1abf16d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($f2a93b9cb1abf16d$var$ListItemSecondaryActionRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$f2a93b9cb1abf16d$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $f2a93b9cb1abf16d$export$2e2bcd8739ae039 = $f2a93b9cb1abf16d$var$ListItemSecondaryAction;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $497c2145bd685a21$var$_excluded = [
    "className"
], $497c2145bd685a21$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $497c2145bd685a21$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $497c2145bd685a21$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $23a208812445d8fb$export$5682c366c0c669d9), classes);
};
const $497c2145bd685a21$export$aed538f7519abe89 = (0, $jjHhy.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $497c2145bd685a21$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $3G4eg.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $23a208812445d8fb$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $23a208812445d8fb$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $23a208812445d8fb$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $23a208812445d8fb$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $23a208812445d8fb$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $497c2145bd685a21$var$ListItemContainer = (0, $jjHhy.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $497c2145bd685a21$var$ListItem = /*#__PURE__*/ $dup7A.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $bGxpK.default)(props.ContainerProps, $497c2145bd685a21$var$_excluded), other = (0, $bGxpK.default)(props, $497c2145bd685a21$var$_excluded2);
    const context = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    const childContext = $dup7A.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $dup7A.useRef(null);
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $dup7A.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $39313ccf598a6345$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $497c2145bd685a21$var$useUtilityClasses(ownerState);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $497c2145bd685a21$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $aJAJS.default)((0, $23a208812445d8fb$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $729321786c389df3$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa61e1e507b3416c$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $cZGFG.jsxs)($497c2145bd685a21$var$ListItemContainer, (0, $3G4eg.default)({
                as: ContainerComponent,
                className: (0, $aJAJS.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)(Root, (0, $3G4eg.default)({}, rootProps, !(0, $305e5bd3d224e36e$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $3G4eg.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa61e1e507b3416c$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)(Root, (0, $3G4eg.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $305e5bd3d224e36e$export$e28348cc2430497)(Root) && {
            ownerState: (0, $3G4eg.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f2a93b9cb1abf16d$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $497c2145bd685a21$export$2e2bcd8739ae039 = $497c2145bd685a21$var$ListItem;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");






var $cZGFG = parcelRequire("cZGFG");
"use client";
const $bc0432b5ba91b8e1$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $bc0432b5ba91b8e1$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $bc0432b5ba91b8e1$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $63e07b9ad249e545$export$c09531d8563c67a5), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $bc0432b5ba91b8e1$var$ListItemButtonRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $bc0432b5ba91b8e1$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $63e07b9ad249e545$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $bc0432b5ba91b8e1$var$ListItemButton = /*#__PURE__*/ $dup7A.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $bGxpK.default)(props, $bc0432b5ba91b8e1$var$_excluded);
    const context = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    const childContext = $dup7A.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $dup7A.useRef(null);
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $bc0432b5ba91b8e1$var$useUtilityClasses(ownerState);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa61e1e507b3416c$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($bc0432b5ba91b8e1$var$ListItemButtonRoot, (0, $3G4eg.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $aJAJS.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $aJAJS.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $bc0432b5ba91b8e1$export$2e2bcd8739ae039 = $bc0432b5ba91b8e1$var$ListItemButton;




var $jjHhy = parcelRequire("jjHhy");

var $ggEZq = parcelRequire("ggEZq");

const $a0eca89cce449dbc$export$8f4fcaa5200816dd = (mode, alpha)=>mode === "light" ? `rgb(0 0 0 / ${alpha})` : `rgb(255 255 255 / ${alpha})`;
const $a0eca89cce449dbc$export$af04e678cd874b1a = (theme, background)=>(0, $ecd44ebd791a3fa9$export$d061e26956a60b0a)((0, $ggEZq.default).white, background ?? theme.palette.primary.main) >= 3 ? (0, $ggEZq.default).white : (0, $ggEZq.default).black;


const $d6bde46f492ab8fa$export$b3f67a2d87d5d23e = (0, $jjHhy.default)((0, $bc0432b5ba91b8e1$export$2e2bcd8739ae039))(({ theme: theme })=>({
        borderRadius: theme.shape.borderRadius,
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        height: 64,
        "&:hover": {
            backgroundColor: (0, $a0eca89cce449dbc$export$8f4fcaa5200816dd)(theme.palette.mode, "4%")
        }
    }));
const $d6bde46f492ab8fa$export$a7b06bfba60a8a78 = (0, $jjHhy.default)((0, $497c2145bd685a21$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "disableRipple"
})(({ theme: theme })=>({
        padding: theme.spacing(0, 1.5),
        [`.${(0, $9248fa0ee28b36bd$export$2e2bcd8739ae039).root}`]: {
            right: theme.spacing(3)
        },
        "&:hover": {
            cursor: "pointer"
        }
    }));
const $d6bde46f492ab8fa$export$ca24c7671afc5aa1 = (0, $jjHhy.default)((0, $67687db373c810bd$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: "none",
        "&:hover": {
            background: "none"
        },
        padding: theme.spacing(0.75, 2),
        fontSize: "0.875rem"
    }));


const $48f9e76cc8e0260e$export$de1effa3acc1a133 = ({ routeId: routeId, dense: dense })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { route: route, status: status } = (0, $3ebe4fdf186d93e7$export$f5db81c77ed06ae3)({
        routeId: routeId,
        executeInBackground: true
    });
    // TODO: replace with ES2023 findLast
    const lastActiveStep = route?.steps.slice().reverse().find((step)=>step.execution);
    const lastActiveProcess = lastActiveStep?.execution?.process.at(-1);
    const { title: title } = (0, $a9b09eb4d34322c5$export$f8e5ba18f67b75bc)(lastActiveStep, lastActiveProcess);
    if (!route || !lastActiveStep) return null;
    const handleClick = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution, {
            state: {
                routeId: routeId
            }
        });
    };
    const getStatusComponent = ()=>{
        switch(lastActiveProcess?.status){
            case "ACTION_REQUIRED":
                return (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70197f36b6f91ee5$exports))), {
                    color: "info",
                    fontSize: "small"
                });
            case "FAILED":
                return (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b718eceab489f4$exports))), {
                    color: "error",
                    fontSize: "small"
                });
            default:
                return (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontSize: 14,
                    fontWeight: 500,
                    children: (0, $cZGFG.jsx)((0, $5e8e03e301157ec7$export$7f5b674fa502d40e), {
                        step: lastActiveStep,
                        hideInProgress: true
                    })
                });
        }
    };
    const ListItemComponent = dense ? (0, $d6bde46f492ab8fa$export$a7b06bfba60a8a78) : (0, $d6bde46f492ab8fa$export$b3f67a2d87d5d23e);
    return (0, $cZGFG.jsxs)(ListItemComponent, {
        onClick: handleClick,
        dense: true,
        disableRipple: dense,
        children: [
            (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                children: (0, $cZGFG.jsxs)((0, $e82e88984bcce286$export$bca2c04c0e6cd524), {
                    total: 2,
                    children: [
                        (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$56e8839726e826f3), {
                            token: route.fromToken
                        }),
                        (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$56e8839726e826f3), {
                            token: route.toToken
                        })
                    ]
                })
            }),
            (0, $cZGFG.jsx)((0, $ced3bf777dc38827$export$2e2bcd8739ae039), {
                sx: {
                    margin: 0
                },
                disableTypography: true,
                primary: (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontWeight: 500,
                    lineHeight: 1,
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 2,
                        height: 16
                    },
                    children: [
                        route.fromToken.symbol,
                        (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ffa5f6fcfa1255e$exports))), {
                            sx: {
                                paddingX: 0.5
                            }
                        }),
                        route.toToken.symbol
                    ]
                }),
                secondary: status !== (0, $2226555593f1025b$export$c56db2dca1307c9d).Done ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontWeight: 400,
                    fontSize: 12,
                    color: "text.secondary",
                    lineHeight: 1,
                    mt: 0.75,
                    ml: 2,
                    children: title
                }) : null
            }),
            getStatusComponent()
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $dup7A = parcelRequire("dup7A");
"use client";
let $3f196c06f251b8ff$var$globalId = 0;
function $3f196c06f251b8ff$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $dup7A.useState(idOverride);
    const id = idOverride || defaultId;
    $dup7A.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $3f196c06f251b8ff$var$globalId += 1;
            setDefaultId(`mui-${$3f196c06f251b8ff$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $3f196c06f251b8ff$var$maybeReactUseId = $dup7A["useId".toString()];
function $3f196c06f251b8ff$export$2e2bcd8739ae039(idOverride) {
    if ($3f196c06f251b8ff$var$maybeReactUseId !== undefined) {
        const reactId = $3f196c06f251b8ff$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $3f196c06f251b8ff$var$useGlobalId(idOverride);
}



var $4y4xl = parcelRequire("4y4xl");




var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $8744a747e878806d$export$2177af0aa15c34c2(slot) {
    return (0, $8iNDC.default)("MuiDialog", slot);
}
const $8744a747e878806d$var$dialogClasses = (0, $fc1pF.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $8744a747e878806d$export$2e2bcd8739ae039 = $8744a747e878806d$var$dialogClasses;






var $cZGFG = parcelRequire("cZGFG");
"use client";
const $3d3ffc2372229c91$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $3d3ffc2372229c91$var$DialogBackdrop = (0, $jjHhy.default)((0, $a9d067e726ebb3f0$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $3d3ffc2372229c91$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $4y4xl.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $4y4xl.default)(scroll)}`,
            `paperWidth${(0, $4y4xl.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $8744a747e878806d$export$2177af0aa15c34c2), classes);
};
const $3d3ffc2372229c91$var$DialogRoot = (0, $jjHhy.default)((0, $6a8e94f31f514acc$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $3d3ffc2372229c91$var$DialogContainer = (0, $jjHhy.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $4y4xl.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $3d3ffc2372229c91$var$DialogPaper = (0, $jjHhy.default)((0, $929a5b6600d07d14$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $4y4xl.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $4y4xl.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $8744a747e878806d$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $8744a747e878806d$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $8744a747e878806d$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $3d3ffc2372229c91$var$Dialog = /*#__PURE__*/ $dup7A.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $929a5b6600d07d14$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $5759152b776d295d$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $bGxpK.default)(props, $3d3ffc2372229c91$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $3d3ffc2372229c91$var$useUtilityClasses(ownerState);
    const backdropClick = $dup7A.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $3f196c06f251b8ff$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $dup7A.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3d3ffc2372229c91$var$DialogRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $3d3ffc2372229c91$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $3G4eg.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $cZGFG.jsx)($3d3ffc2372229c91$var$DialogContainer, {
                className: (0, $aJAJS.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($3d3ffc2372229c91$var$DialogPaper, (0, $3G4eg.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $aJAJS.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5184f1d168e90da6$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $3d3ffc2372229c91$export$2e2bcd8739ae039 = $3d3ffc2372229c91$var$Dialog;



var $dup7A = parcelRequire("dup7A");
var $6dd4403cf87f98d9$export$6e4ebff0100bf466;
(function(ElementId) {
    ElementId["AppExpandedContainer"] = "widget-app-expanded-container";
    ElementId["Header"] = "widget-header";
    ElementId["RelativeContainer"] = "widget-relative-container";
    ElementId["ScrollableContainer"] = "widget-scrollable-container";
})($6dd4403cf87f98d9$export$6e4ebff0100bf466 || ($6dd4403cf87f98d9$export$6e4ebff0100bf466 = {}));
const $6dd4403cf87f98d9$export$e4789b5c419678e0 = (ElementId, elementId)=>elementId ? `${ElementId}-${elementId}` : ElementId;



const $43dd2a9adf98ce26$export$15dd38f06036bd30 = ()=>{
    const { elementId: elementId } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    return elementId;
};


const $ce8a180a0be6eb02$export$320287ee38b8cccd = (elementId)=>document.getElementById((0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).ScrollableContainer, elementId));
const $ce8a180a0be6eb02$export$1723bfc52a609875 = ()=>{
    const elementId = (0, $43dd2a9adf98ce26$export$15dd38f06036bd30)();
    const getContainer = (0, $dup7A.useCallback)(()=>$ce8a180a0be6eb02$export$320287ee38b8cccd(elementId), [
        elementId
    ]);
    return getContainer;
};
const $ce8a180a0be6eb02$export$6b1722966a7bf8c = (elementId)=>{
    const [containerElement, setContainerElement] = (0, $dup7A.useState)(()=>$ce8a180a0be6eb02$export$320287ee38b8cccd(elementId));
    (0, $dup7A.useLayoutEffect)(()=>{
        if (!containerElement) setContainerElement($ce8a180a0be6eb02$export$320287ee38b8cccd(elementId));
    }, [
        containerElement,
        elementId
    ]);
    return containerElement;
};
const $ce8a180a0be6eb02$export$d57c167c005d744a = ()=>{
    const elementId = (0, $43dd2a9adf98ce26$export$15dd38f06036bd30)();
    (0, $dup7A.useLayoutEffect)(()=>{
        const element = $ce8a180a0be6eb02$export$320287ee38b8cccd(elementId);
        if (element) element.style.overflowY = "hidden";
        return ()=>{
            if (element) element.style.overflowY = "auto";
        };
    }, [
        elementId
    ]);
};


const $f719477393eb6354$export$e6e63efe27adb93f = {
    sx: {
        position: "absolute",
        overflow: "hidden"
    }
};
const $f719477393eb6354$export$c83585ffd693a912 = {
    sx: (theme)=>({
            position: "absolute",
            backgroundImage: "none",
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius
        })
};
const $f719477393eb6354$export$1e727dea50000122 = {
    sx: {
        position: "absolute",
        backgroundColor: "rgb(0 0 0 / 32%)",
        backdropFilter: "blur(3px)"
    }
};
const $f719477393eb6354$export$3ddf2d174ce01153 = ({ children: children, open: open, onClose: onClose })=>{
    const getContainer = (0, $ce8a180a0be6eb02$export$1723bfc52a609875)();
    return (0, $cZGFG.jsx)((0, $3d3ffc2372229c91$export$2e2bcd8739ae039), {
        container: getContainer,
        open: open,
        onClose: onClose,
        sx: $f719477393eb6354$export$e6e63efe27adb93f.sx,
        PaperProps: $f719477393eb6354$export$c83585ffd693a912,
        BackdropProps: $f719477393eb6354$export$1e727dea50000122,
        children: children
    });
};




var $cZFtK = parcelRequire("cZFtK");


const $fc3b997b377b16fb$export$f775bbb41df04af1 = (address)=>{
    return (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>Object.values(state.routes).filter((item)=>item.route.fromAddress === address && (item.status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Pending || item.status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed)).sort((a, b)=>(b?.route.steps[0].execution?.process[0].startedAt ?? 0) - (a?.route.steps[0].execution?.process[0].startedAt ?? 0)).map(({ route: route })=>route.id), (0, $cZFtK.shallow));
};



var $cZGFG = parcelRequire("cZGFG");
var $61bd3631b85a0e88$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($61bd3631b85a0e88$exports, "__esModule", {
    value: true
});
$61bd3631b85a0e88$exports.default = void 0;

var $61bd3631b85a0e88$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $61bd3631b85a0e88$var$_default = $61bd3631b85a0e88$exports.default = (0, $61bd3631b85a0e88$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), "SwapHoriz");




const $6d8b5af83d7eb129$export$d26af64d939731a7 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingY: 12
        },
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 48,
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($61bd3631b85a0e88$exports))), {
                    fontSize: "inherit"
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 18,
                fontWeight: 700,
                children: t("info.title.emptyActiveTransactions")
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 14,
                color: "text.secondary",
                textAlign: "center",
                mt: 2,
                children: t("info.message.emptyActiveTransactions")
            })
        ]
    });
};


const $016c36cfdeb88c65$export$8b07b87de2e185c9 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const executingRoutes = (0, $fc3b997b377b16fb$export$f775bbb41df04af1)(account.address);
    const deleteRoutes = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((store)=>store.deleteRoutes);
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const [open, setOpen] = (0, $dup7A.useState)(false);
    const toggleDialog = (0, $dup7A.useCallback)(()=>{
        setOpen((open)=>!open);
    }, []);
    (0, $dup7A.useEffect)(()=>{
        if (executingRoutes.length) return headerStoreContext.getState().setAction((0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
            size: "medium",
            edge: "end",
            onClick: toggleDialog,
            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e7063c060c419724$exports))), {})
        }));
    }, [
        executingRoutes.length,
        headerStoreContext,
        toggleDialog
    ]);
    if (!executingRoutes.length) return (0, $cZGFG.jsx)((0, $6d8b5af83d7eb129$export$d26af64d939731a7), {});
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: [
            (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 1.5,
                    paddingRight: 1.5
                },
                children: executingRoutes.map((routeId)=>(0, $cZGFG.jsx)((0, $48f9e76cc8e0260e$export$de1effa3acc1a133), {
                        routeId: routeId
                    }, routeId))
            }),
            (0, $cZGFG.jsxs)((0, $f719477393eb6354$export$3ddf2d174ce01153), {
                open: open,
                onClose: toggleDialog,
                children: [
                    (0, $cZGFG.jsx)((0, $c7caddaf71674940$export$2e2bcd8739ae039), {
                        children: t("warning.title.deleteActiveTransactions")
                    }),
                    (0, $cZGFG.jsx)((0, $da3939ee95c82076$export$2e2bcd8739ae039), {
                        children: (0, $cZGFG.jsx)((0, $1f0b92c5665aa4ca$export$2e2bcd8739ae039), {
                            children: t("warning.message.deleteActiveTransactions")
                        })
                    }),
                    (0, $cZGFG.jsxs)((0, $20eff1c46eaadcad$export$2e2bcd8739ae039), {
                        children: [
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                onClick: toggleDialog,
                                children: t("button.cancel")
                            }),
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                variant: "contained",
                                onClick: ()=>deleteRoutes("active"),
                                autoFocus: true,
                                children: t("button.delete")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $cZGFG = parcelRequire("cZGFG");


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $gmeoE = parcelRequire("gmeoE");

var $8iNDC = parcelRequire("8iNDC");

var $2wgr3 = parcelRequire("2wgr3");


var $866st = parcelRequire("866st");

var $9qvqC = parcelRequire("9qvqC");

var $1kGZC = parcelRequire("1kGZC");

var $b9Q9P = parcelRequire("b9Q9P");

var $jXXjr = parcelRequire("jXXjr");

var $cZGFG = parcelRequire("cZGFG");
const $c0e0be4eb1485668$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $c0e0be4eb1485668$var$defaultTheme = (0, $1kGZC.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c0e0be4eb1485668$var$defaultCreateStyledComponent = (0, $c4998d526f81b02b$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $c0e0be4eb1485668$var$useThemePropsDefault(props) {
    return (0, $866st.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $c0e0be4eb1485668$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $c0e0be4eb1485668$var$joinChildren(children, separator) {
    const childrenArray = $dup7A.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $dup7A.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $c0e0be4eb1485668$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $c0e0be4eb1485668$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $3G4eg.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $b9Q9P.handleBreakpoints)({
        theme: theme
    }, (0, $b9Q9P.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $jXXjr.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $b9Q9P.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $b9Q9P.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $jXXjr.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$c0e0be4eb1485668$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $jXXjr.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $gmeoE.default)(styles, (0, $b9Q9P.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $b9Q9P.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $c0e0be4eb1485668$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c0e0be4eb1485668$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c0e0be4eb1485668$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $2wgr3.default)(slots, (slot)=>(0, $8iNDC.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($c0e0be4eb1485668$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $dup7A.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $9qvqC.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $bGxpK.default)(props, $c0e0be4eb1485668$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $cZGFG.jsx)(StackRoot, (0, $3G4eg.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $aJAJS.default)(classes.root, className)
        }, other, {
            children: divider ? $c0e0be4eb1485668$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");
"use client";
const $0fdecc513a2d3d55$var$Stack = (0, $c0e0be4eb1485668$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $jjHhy.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $7ZufN.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $0fdecc513a2d3d55$export$2e2bcd8739ae039 = $0fdecc513a2d3d55$var$Stack;










var $jjHhy = parcelRequire("jjHhy");
const $d481e0f0eb26e19b$var$getBackgroundColor = (theme, variant, selectionColor)=>variant === "selected" ? selectionColor === "primary" ? theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.04) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.42) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.mode === "light" ? 0.08 : 0.12) : theme.palette.background.paper;
const $d481e0f0eb26e19b$export$60332b2344f7fe41 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "variant",
            "indented",
            "selectionColor",
            "pointerEvents"
        ].includes(prop)
})(({ theme: theme, variant: variant, selectionColor: selectionColor = "primary", indented: indented, pointerEvents: pointerEvents, onClick: onClick })=>{
    const backgroundColor = $d481e0f0eb26e19b$var$getBackgroundColor(theme, variant, selectionColor);
    const backgroundHoverColor = onClick ? theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(backgroundColor, 0.02) : (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(backgroundColor, 0.02) : backgroundColor;
    return {
        backgroundColor: backgroundColor,
        border: `1px solid`,
        borderColor: variant === "error" ? theme.palette.error.main : variant === "selected" ? selectionColor === "primary" ? theme.palette.primary.main : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.secondary.main, 0.48) : theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        borderRadius: theme.shape.borderRadius,
        overflow: "hidden",
        position: "relative",
        padding: indented ? theme.spacing(2) : 0,
        boxSizing: "border-box",
        "&:hover": {
            cursor: onClick ? "pointer" : "default",
            backgroundColor: backgroundHoverColor
        },
        [`&:hover .${(0, $59bc093316bf3eff$export$2e2bcd8739ae039).badge} > div`]: {
            borderColor: backgroundHoverColor
        },
        transition: theme.transitions.create([
            "background-color"
        ], {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: pointerEvents
    };
});



var $jjHhy = parcelRequire("jjHhy");
const $1dd1e767d3ead2a1$export$474db65c3c394e1c = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "required"
        ].includes(prop)
})(({ theme: theme, required: required })=>({
        fontSize: "0.875rem",
        lineHeight: "1.286",
        letterSpacing: "0.01071em",
        fontWeight: 700,
        padding: theme.spacing(1.75, 2, 0, 2),
        "&:after": {
            content: required ? '" *"' : "none",
            color: theme.palette.error.main
        }
    }));




const $1fa3da4cb47a09c9$export$9c8f2a54692f7aed = (props)=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const executingRoutes = (0, $fc3b997b377b16fb$export$f775bbb41df04af1)(account.address);
    if (!executingRoutes?.length) return null;
    const handleShowAll = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).activeTransactions);
    };
    const hasShowAll = executingRoutes?.length > 2;
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        variant: "selected",
        selectionColor: "secondary",
        ...props,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t("header.activeTransactions")
            }),
            (0, $cZGFG.jsx)((0, $0fdecc513a2d3d55$export$2e2bcd8739ae039), {
                spacing: 1.5,
                pt: 1.5,
                pb: hasShowAll ? 0 : 2,
                children: executingRoutes.slice(0, 2).map((routeId)=>(0, $cZGFG.jsx)((0, $48f9e76cc8e0260e$export$de1effa3acc1a133), {
                        routeId: routeId,
                        dense: true
                    }, routeId))
            }),
            hasShowAll ? (0, $cZGFG.jsx)((0, $d6bde46f492ab8fa$export$ca24c7671afc5aa1), {
                disableRipple: true,
                fullWidth: true,
                onClick: handleShowAll,
                children: t("button.showAll")
            }) : null
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");





const $fa09cca94d74e1e2$export$9b092ff0aefac49e = (maxFontSize, minFontSize, element)=>{
    if (!element) return;
    let high = maxFontSize;
    let low = minFontSize;
    let size = minFontSize;
    let mid = 0;
    // Binary search for highest font size best fit
    while(low <= high){
        mid = high + low >> 1;
        const fontSize = `${mid + 1}px`;
        element.style.fontSize = fontSize;
        // scrollWidth has different rounding than clientWidth, remove 1px for consistency
        const scrollWidth = element.scrollWidth - 1;
        if (scrollWidth <= element.clientWidth) {
            size = mid;
            low = mid + 1;
        } else high = mid - 1;
    }
    const fontSize = `${size}px`;
    element.style.fontSize = fontSize;
};




var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $03e0b1a9e5bed7fb$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $03e0b1a9e5bed7fb$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($03e0b1a9e5bed7fb$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $03e0b1a9e5bed7fb$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $03e0b1a9e5bed7fb$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $4y4xl = parcelRequire("4y4xl");


var $dup7A = parcelRequire("dup7A");
/**
 * @ignore - internal component.
 */ const $075b291fbe8125ae$var$FormControlContext = /*#__PURE__*/ $dup7A.createContext(undefined);
var $075b291fbe8125ae$export$2e2bcd8739ae039 = $075b291fbe8125ae$var$FormControlContext;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $06fdb30217ae86f0$export$149c8b8bab2289d1(slot) {
    return (0, $8iNDC.default)("MuiFormControl", slot);
}
const $06fdb30217ae86f0$var$formControlClasses = (0, $fc1pF.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $06fdb30217ae86f0$export$2e2bcd8739ae039 = $06fdb30217ae86f0$var$formControlClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $e860bb7daa30c730$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $e860bb7daa30c730$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $4y4xl.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $06fdb30217ae86f0$export$149c8b8bab2289d1), classes);
};
const $e860bb7daa30c730$var$FormControlRoot = (0, $jjHhy.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $3G4eg.default)({}, styles.root, styles[`margin${(0, $4y4xl.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $e860bb7daa30c730$var$FormControl = /*#__PURE__*/ $dup7A.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $bGxpK.default)(props, $e860bb7daa30c730$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $e860bb7daa30c730$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $dup7A.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $dup7A.Children.forEach(children, (child)=>{
            if (!(0, $39313ccf598a6345$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $39313ccf598a6345$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $03e0b1a9e5bed7fb$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $dup7A.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $dup7A.Children.forEach(children, (child)=>{
            if (!(0, $39313ccf598a6345$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $03e0b1a9e5bed7fb$export$d652b828d7fdeff8)(child.props, true) || (0, $03e0b1a9e5bed7fb$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $dup7A.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $dup7A.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $075b291fbe8125ae$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($e860bb7daa30c730$var$FormControlRoot, (0, $3G4eg.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aJAJS.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $e860bb7daa30c730$export$2e2bcd8739ae039 = $e860bb7daa30c730$var$FormControl;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $e50cx = parcelRequire("e50cx");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $cd6bf2901c2a7132$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $cd6bf2901c2a7132$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $cd6bf2901c2a7132$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $cd6bf2901c2a7132$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $cd6bf2901c2a7132$export$d1710922ecaf577a = /*#__PURE__*/ $dup7A.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $bGxpK.default)(props, $cd6bf2901c2a7132$var$_excluded);
    const { current: isControlled } = $dup7A.useRef(value != null);
    const inputRef = $dup7A.useRef(null);
    const handleRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $dup7A.useRef(null);
    const calculateTextareaStyles = $dup7A.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $cd6bf2901c2a7132$var$getStyleValue(computedStyle.paddingBottom) + $cd6bf2901c2a7132$var$getStyleValue(computedStyle.paddingTop);
        const border = $cd6bf2901c2a7132$var$getStyleValue(computedStyle.borderBottomWidth) + $cd6bf2901c2a7132$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $dup7A.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($cd6bf2901c2a7132$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $6ed2fbb3df16a513$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $f27c9b17b0ca6f7d$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("textarea", (0, $3G4eg.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $cZGFG.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $3G4eg.default)({}, $cd6bf2901c2a7132$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});




var $2wgr3 = parcelRequire("2wgr3");
function $20c375fdd6e9cd4d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}




var $dup7A = parcelRequire("dup7A");

"use client";
function $dd81c7cf93ba27da$export$2e2bcd8739ae039() {
    return $dup7A.useContext((0, $075b291fbe8125ae$export$2e2bcd8739ae039));
}



var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $4y4xl = parcelRequire("4y4xl");



var $3G4eg = parcelRequire("3G4eg");
parcelRequire("dup7A");

parcelRequire("dup7A");


var $eAHa0 = parcelRequire("eAHa0");

var $lcALP = parcelRequire("lcALP");

var $cZGFG = parcelRequire("cZGFG");
"use client";
function $6c34004fedbb84c5$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $lcALP.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eAHa0.default), {
        styles: globalStyles
    });
}
var $6c34004fedbb84c5$export$2e2bcd8739ae039 = $6c34004fedbb84c5$var$GlobalStyles;



var $hddxs = parcelRequire("hddxs");

var $7wciM = parcelRequire("7wciM");

var $cZGFG = parcelRequire("cZGFG");
"use client";
function $dc9a4c1442b0896e$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6c34004fedbb84c5$export$2e2bcd8739ae039), (0, $3G4eg.default)({}, props, {
        defaultTheme: (0, $hddxs.default),
        themeId: (0, $7wciM.default)
    }));
}
var $dc9a4c1442b0896e$export$2e2bcd8739ae039 = $dc9a4c1442b0896e$var$GlobalStyles;




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $8febbde539987675$export$ef57d5c8ca2278f6(slot) {
    return (0, $8iNDC.default)("MuiInputBase", slot);
}
const $8febbde539987675$var$inputBaseClasses = (0, $fc1pF.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $8febbde539987675$export$2e2bcd8739ae039 = $8febbde539987675$var$inputBaseClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $8dd1262a4b8be7e8$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $8dd1262a4b8be7e8$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $4y4xl.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $8dd1262a4b8be7e8$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $8dd1262a4b8be7e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $4y4xl.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $4y4xl.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $8febbde539987675$export$ef57d5c8ca2278f6), classes);
};
const $8dd1262a4b8be7e8$export$298a043133d72a38 = (0, $jjHhy.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $8dd1262a4b8be7e8$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $3G4eg.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $8dd1262a4b8be7e8$export$a1ad29c901026019 = (0, $jjHhy.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $8dd1262a4b8be7e8$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $3G4eg.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $3G4eg.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $8febbde539987675$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $8dd1262a4b8be7e8$var$inputGlobalStyles = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dc9a4c1442b0896e$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $8dd1262a4b8be7e8$var$InputBase = /*#__PURE__*/ $dup7A.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $bGxpK.default)(props, $8dd1262a4b8be7e8$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $dup7A.useRef(value != null);
    const inputRef = $dup7A.useRef();
    const handleInputRefWarning = $dup7A.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $dup7A.useState(false);
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)();
    const fcs = (0, $20c375fdd6e9cd4d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $dup7A.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $dup7A.useCallback((obj)=>{
        if ((0, $03e0b1a9e5bed7fb$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $e50cx.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $dup7A.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $3G4eg.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $3G4eg.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $cd6bf2901c2a7132$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $dup7A.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $8dd1262a4b8be7e8$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $8dd1262a4b8be7e8$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $8dd1262a4b8be7e8$export$a1ad29c901026019;
    inputProps = (0, $3G4eg.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $8dd1262a4b8be7e8$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $cZGFG.jsxs)(Root, (0, $3G4eg.default)({}, rootProps, !(0, $305e5bd3d224e36e$export$e28348cc2430497)(Root) && {
                ownerState: (0, $3G4eg.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $aJAJS.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $075b291fbe8125ae$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)(Input, (0, $3G4eg.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $305e5bd3d224e36e$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $3G4eg.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $aJAJS.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $3G4eg.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $8dd1262a4b8be7e8$export$2e2bcd8739ae039 = $8dd1262a4b8be7e8$var$InputBase;




var $jjHhy = parcelRequire("jjHhy");
const $af2cdb1c6b5b659d$export$18e0188fec24ae27 = 24;
const $af2cdb1c6b5b659d$export$7f9a513a14e303ee = 14;
const $af2cdb1c6b5b659d$export$fe5d99d8691b3f62 = (0, $jjHhy.default)((0, $e860bb7daa30c730$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(1.5, 2, 1.5, 0)
    }));
const $af2cdb1c6b5b659d$export$f5b8910cec6cf069 = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039))(({ theme: theme })=>({
        fontSize: 24,
        fontWeight: 700,
        boxShadow: "none",
        // padding: theme.spacing(2, 2, 2, 0),
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}`]: {
            height: 32,
            padding: theme.spacing(0, 0, 0, 2)
        },
        '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
            WebkitAppearance: "none",
            margin: 0
        },
        '& input[type="number"]': {
            MozAppearance: "textfield"
        },
        [`&.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            color: "inherit"
        },
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            WebkitTextFillColor: "unset"
        }
    }));



var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");




var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $86175e21c1b59c43$export$4b135a4b3a6c4550(slot) {
    return (0, $8iNDC.default)("MuiInputAdornment", slot);
}
const $86175e21c1b59c43$var$inputAdornmentClasses = (0, $fc1pF.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $86175e21c1b59c43$export$2e2bcd8739ae039 = $86175e21c1b59c43$var$inputAdornmentClasses;



var $7ZufN = parcelRequire("7ZufN");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $024bdefb4f58bf2e$var$_span;
const $024bdefb4f58bf2e$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $024bdefb4f58bf2e$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $4y4xl.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $024bdefb4f58bf2e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $4y4xl.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $4y4xl.default)(size)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $86175e21c1b59c43$export$4b135a4b3a6c4550), classes);
};
const $024bdefb4f58bf2e$var$InputAdornmentRoot = (0, $jjHhy.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $024bdefb4f58bf2e$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $86175e21c1b59c43$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $86175e21c1b59c43$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $024bdefb4f58bf2e$var$InputAdornment = /*#__PURE__*/ $dup7A.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $bGxpK.default)(props, $024bdefb4f58bf2e$var$_excluded);
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $3G4eg.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $024bdefb4f58bf2e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $075b291fbe8125ae$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($024bdefb4f58bf2e$var$InputAdornmentRoot, (0, $3G4eg.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aJAJS.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $024bdefb4f58bf2e$var$_span || ($024bdefb4f58bf2e$var$_span = /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $024bdefb4f58bf2e$export$2e2bcd8739ae039 = $024bdefb4f58bf2e$var$InputAdornment;








const $26691b71e2f63cef$var$refetchInterval = 60000;
const $26691b71e2f63cef$export$6e4f7860967d45da = (chainId, fromChain, fromToken)=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { chains: chains } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "gas-recommendation",
        chainId,
        fromChain,
        fromToken
    ], async ({ queryKey: [_, chainId, fromChain, fromToken] })=>{
        if (!chains?.some((chain)=>chain.id === chainId)) return null;
        const gasRecommendation = await lifi.getGasRecommendation({
            chainId: chainId,
            fromChain: fromChain,
            fromToken: fromToken
        });
        return gasRecommendation;
    }, {
        enabled: Boolean(chainId),
        refetchInterval: $26691b71e2f63cef$var$refetchInterval,
        staleTime: $26691b71e2f63cef$var$refetchInterval,
        cacheTime: $26691b71e2f63cef$var$refetchInterval
    });
};


var $dup7A = parcelRequire("dup7A");




const $71ff1ba0752dd2af$var$defaultRefetchInterval = 32000;
const $71ff1ba0752dd2af$export$5ecd82d0a6d2bff6 = (selectedChainId)=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const featuredTokens = (0, $d222653a4cfabf8d$export$c76ae3e918fa0ce4)(selectedChainId);
    const { tokens: tokens, isLoading: isLoading } = (0, $cc6b88a592537212$export$7c008f4adb925d9f)(selectedChainId);
    const isBalanceLoadingEnabled = Boolean(account.address) && Boolean(tokens?.length) && Boolean(selectedChainId);
    const { data: tokensWithBalance, isLoading: isBalanceLoading, refetch: refetch } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "token-balances",
        account.address,
        selectedChainId,
        tokens?.length
    ], async ({ queryKey: [, accountAddress] })=>{
        const tokenBalances = await lifi.getTokenBalances(accountAddress, tokens);
        const featuredTokenAddresses = new Set(featuredTokens?.map((token)=>token.address));
        const sortFn = (a, b)=>parseFloat(b.amount ?? "0") * parseFloat(b.priceUSD ?? "0") - parseFloat(a.amount ?? "0") * parseFloat(a.priceUSD ?? "0");
        const formattedTokens = tokenBalances.length === 0 ? tokens : tokenBalances;
        const result = [
            ...formattedTokens.filter((token)=>token.amount !== "0" && featuredTokenAddresses.has(token.address)).sort(sortFn),
            ...formattedTokens.filter((token)=>token.amount === "0" && featuredTokenAddresses.has(token.address)),
            ...formattedTokens.filter((token)=>token.amount !== "0" && !featuredTokenAddresses.has(token.address)).sort(sortFn),
            ...formattedTokens.filter((token)=>token.amount === "0" && !featuredTokenAddresses.has(token.address))
        ];
        return result;
    }, {
        enabled: isBalanceLoadingEnabled,
        refetchInterval: $71ff1ba0752dd2af$var$defaultRefetchInterval,
        staleTime: $71ff1ba0752dd2af$var$defaultRefetchInterval
    });
    return {
        tokens: tokens,
        tokensWithBalance: tokensWithBalance,
        featuredTokens: featuredTokens,
        isLoading: isLoading,
        isBalanceLoading: isBalanceLoading && isBalanceLoadingEnabled,
        refetch: refetch
    };
};


const $5da48810ed56f459$export$b823943063e17b85 = (chainId, tokenAddress)=>{
    const { tokens: tokens, tokensWithBalance: tokensWithBalance, isBalanceLoading: isBalanceLoading, refetch: refetch } = (0, $71ff1ba0752dd2af$export$5ecd82d0a6d2bff6)(chainId);
    const token = (0, $dup7A.useMemo)(()=>{
        if (tokenAddress && chainId) {
            const token = (tokensWithBalance ?? tokens)?.find((token)=>token.address === tokenAddress && token.chainId === chainId);
            return token;
        }
    }, [
        chainId,
        tokenAddress,
        tokens,
        tokensWithBalance
    ]);
    return {
        token: token,
        isLoading: isBalanceLoading,
        refetch: refetch
    };
};






var $jjHhy = parcelRequire("jjHhy");
const $a2595a6c7b69a7eb$export$353f5b6fc5456de1 = (0, $jjHhy.default)((0, $67687db373c810bd$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1, 0.625, 1),
        lineHeight: 1.0715,
        fontSize: "0.875rem",
        minWidth: "unset"
    }));


const $6ca0126eea6be5aa$export$9ae79fe4ed27e4fc = ({ formType: formType })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const [chainId, tokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType),
            (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType)
        ]
    });
    const { data: data } = (0, $26691b71e2f63cef$export$6e4f7860967d45da)(chainId);
    const { token: token, isLoading: isLoading } = (0, $5da48810ed56f459$export$b823943063e17b85)(chainId, tokenAddress);
    const handleMax = ()=>{
        const chain = getChainById(chainId);
        let maxAmount = token?.amount;
        if (chain?.nativeToken.address === tokenAddress && data?.available && data?.recommended) {
            const tokenAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(token?.amount ?? 0);
            const recommendedAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(data.recommended.amount).div(10 ** data.recommended.token.decimals).div(2);
            if (tokenAmount.gt(recommendedAmount)) maxAmount = (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(tokenAmount.minus(recommendedAmount).toString());
        }
        setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getAmountKey(formType), maxAmount || "", {
            shouldTouch: true
        });
    };
    return (0, $cZGFG.jsx)((0, $024bdefb4f58bf2e$export$2e2bcd8739ae039), {
        position: "end",
        children: isLoading && tokenAddress ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
            variant: "rectangular",
            width: 46,
            height: 24,
            sx: {
                borderRadius: 0.5
            }
        }) : formType === "from" && token?.amount ? (0, $cZGFG.jsx)((0, $a2595a6c7b69a7eb$export$353f5b6fc5456de1), {
            onClick: handleMax,
            children: t("button.max")
        }) : null
    });
};



var $cZGFG = parcelRequire("cZGFG");




const $ae011fcf06bd97f0$export$f5ccca7c10f3156e = ({ formType: formType })=>{
    const [chainId, tokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType),
            (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType)
        ]
    });
    const { chain: chain } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(chainId);
    const { token: token } = (0, $b486f29e55929307$export$31dcd79391e423fe)(chainId, tokenAddress);
    const isSelected = !!(chain && token);
    return isSelected ? (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$56e8839726e826f3), {
        token: token,
        chain: chain,
        sx: {
            marginLeft: 2
        }
    }) : (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$aeac0dce6f0792e), {
        sx: {
            marginLeft: 2
        }
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");



var $jjHhy = parcelRequire("jjHhy");

var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $206f680068be6673$export$a394fa61b1d583a9(slot) {
    return (0, $8iNDC.default)("MuiFormHelperText", slot);
}
const $206f680068be6673$var$formHelperTextClasses = (0, $fc1pF.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $206f680068be6673$export$2e2bcd8739ae039 = $206f680068be6673$var$formHelperTextClasses;



var $7ZufN = parcelRequire("7ZufN");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $8a21bad991422587$var$_span;
const $8a21bad991422587$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $8a21bad991422587$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $4y4xl.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $206f680068be6673$export$a394fa61b1d583a9), classes);
};
const $8a21bad991422587$var$FormHelperTextRoot = (0, $jjHhy.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $4y4xl.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $206f680068be6673$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $206f680068be6673$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $8a21bad991422587$var$FormHelperText = /*#__PURE__*/ $dup7A.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $bGxpK.default)(props, $8a21bad991422587$var$_excluded);
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)();
    const fcs = (0, $20c375fdd6e9cd4d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $8a21bad991422587$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($8a21bad991422587$var$FormHelperTextRoot, (0, $3G4eg.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $8a21bad991422587$var$_span || ($8a21bad991422587$var$_span = /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $8a21bad991422587$export$2e2bcd8739ae039 = $8a21bad991422587$var$FormHelperText;







const $8ae90647c8a72898$export$92b7860a71276655 = ({ formType: formType })=>{
    const [chainId, tokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType),
            (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType)
        ]
    });
    const { token: token, isLoading: isLoading } = (0, $5da48810ed56f459$export$b823943063e17b85)(chainId, tokenAddress);
    return (0, $cZGFG.jsx)($8ae90647c8a72898$export$6a6bf914a63ee0b, {
        formType: formType,
        isLoading: isLoading,
        tokenAddress: tokenAddress,
        token: token
    });
};
const $8ae90647c8a72898$export$6a6bf914a63ee0b = ({ formType: formType, isLoading: isLoading, tokenAddress: tokenAddress, token: token })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const amount = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: (0, $98260d45445f6983$export$69d9321fdf06d524).getAmountKey(formType)
    });
    const fromAmountTokenPrice = (0, $2a25b0bfe67ae18c$export$78792d27fa2fce59)(amount, token?.priceUSD);
    return (0, $cZGFG.jsxs)((0, $8a21bad991422587$export$2e2bcd8739ae039), {
        component: "div",
        sx: {
            display: "flex",
            justifyContent: "space-between",
            margin: 0
        },
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                color: fromAmountTokenPrice ? "text.secondary" : "grey.600",
                fontWeight: 400,
                fontSize: 12,
                marginLeft: 8,
                lineHeight: 1.3334,
                flex: 1,
                sx: {
                    wordBreak: "break-word",
                    overflowWrap: "break-word"
                },
                children: t(`format.currency`, {
                    value: fromAmountTokenPrice
                })
            }),
            isLoading && tokenAddress ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                variant: "text",
                width: 48,
                height: 16,
                sx: {
                    borderRadius: 0.25
                }
            }) : token?.amount ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontWeight: 400,
                fontSize: 12,
                color: "text.secondary",
                lineHeight: 1.3334,
                pl: 0.25,
                children: `/ ${t(`format.number`, {
                    value: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token?.amount)
                })}`
            }) : null
        ]
    });
};


const $cb4e9235e80bb22a$export$1a8f21b7e95bd816 = ({ formType: formType, ...props })=>{
    const { disabledUI: disabledUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [chainId, tokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType),
            (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType)
        ]
    });
    const { token: token } = (0, $b486f29e55929307$export$31dcd79391e423fe)(chainId, tokenAddress);
    const disabled = disabledUI?.includes((0, $57f573099db3f258$export$d98e2f690b7e6bcf).FromAmount);
    return (0, $cZGFG.jsx)($cb4e9235e80bb22a$export$4ef71b43cc231bce, {
        formType: formType,
        token: token,
        startAdornment: (0, $cZGFG.jsx)((0, $ae011fcf06bd97f0$export$f5ccca7c10f3156e), {
            formType: formType
        }),
        endAdornment: !disabled ? (0, $cZGFG.jsx)((0, $6ca0126eea6be5aa$export$9ae79fe4ed27e4fc), {
            formType: formType
        }) : undefined,
        bottomAdornment: (0, $cZGFG.jsx)((0, $8ae90647c8a72898$export$92b7860a71276655), {
            formType: formType
        }),
        disabled: disabled,
        ...props
    });
};
const $cb4e9235e80bb22a$export$4ef71b43cc231bce = ({ formType: formType, token: token, startAdornment: startAdornment, endAdornment: endAdornment, bottomAdornment: bottomAdornment, disabled: disabled, ...props })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const amountKey = (0, $98260d45445f6983$export$69d9321fdf06d524).getAmountKey(formType);
    const { field: { onChange: onChange, onBlur: onBlur, value: value } } = (0, $367773295ca041ba$export$e8c786024a2b0a79)({
        name: amountKey
    });
    const ref = (0, $dup7A.useRef)(null);
    const handleChange = (event)=>{
        const { value: value } = event.target;
        const formattedAmount = (0, $2a25b0bfe67ae18c$export$e772787f786097e7)(value, token?.decimals, true);
        onChange(formattedAmount);
    };
    const handleBlur = (event)=>{
        const { value: value } = event.target;
        const formattedAmount = (0, $2a25b0bfe67ae18c$export$e772787f786097e7)(value, token?.decimals);
        onChange(formattedAmount);
        onBlur();
    };
    (0, $dup7A.useLayoutEffect)(()=>{
        if (ref.current) (0, $fa09cca94d74e1e2$export$9b092ff0aefac49e)((0, $af2cdb1c6b5b659d$export$18e0188fec24ae27), (0, $af2cdb1c6b5b659d$export$7f9a513a14e303ee), ref.current);
    }, [
        value,
        ref
    ]);
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        ...props,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t("main.fromAmount")
            }),
            (0, $cZGFG.jsxs)((0, $af2cdb1c6b5b659d$export$fe5d99d8691b3f62), {
                fullWidth: true,
                children: [
                    (0, $cZGFG.jsx)((0, $af2cdb1c6b5b659d$export$f5b8910cec6cf069), {
                        inputRef: ref,
                        size: "small",
                        autoComplete: "off",
                        placeholder: "0",
                        startAdornment: startAdornment,
                        endAdornment: endAdornment,
                        inputProps: {
                            inputMode: "decimal"
                        },
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: value,
                        name: amountKey,
                        disabled: disabled,
                        required: true
                    }),
                    bottomAdornment
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

const $7aeac184c64d60ca$export$e3ffc3645fcb5ea8 = ({ children: children, ...props })=>{
    if (!children) return null;
    return (0, $cZGFG.jsx)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        ...props,
        children: children
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $9955478a62ac183c$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($9955478a62ac183c$exports, "__esModule", {
    value: true
});
$9955478a62ac183c$exports.default = void 0;

var $9955478a62ac183c$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $9955478a62ac183c$var$_default = $9955478a62ac183c$exports.default = (0, $9955478a62ac183c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77M18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M8 18v-4.5H6L10 6v5h2z"
}), "EvStation");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $aJAJS = parcelRequire("aJAJS");





var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $lQ3HS = parcelRequire("lQ3HS");




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $c88a5a62bced7aeb$export$5162da8f798e0959(slot) {
    return (0, $8iNDC.default)("MuiCollapse", slot);
}
const $c88a5a62bced7aeb$var$collapseClasses = (0, $fc1pF.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $c88a5a62bced7aeb$export$2e2bcd8739ae039 = $c88a5a62bced7aeb$var$collapseClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $f6bd69894e5675e4$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $f6bd69894e5675e4$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $c88a5a62bced7aeb$export$5162da8f798e0959), classes);
};
const $f6bd69894e5675e4$var$CollapseRoot = (0, $jjHhy.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $3G4eg.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $f6bd69894e5675e4$var$CollapseWrapper = (0, $jjHhy.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $f6bd69894e5675e4$var$CollapseWrapperInner = (0, $jjHhy.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $f6bd69894e5675e4$var$Collapse = /*#__PURE__*/ $dup7A.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $lQ3HS.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e41ac8e2c2248586$export$2e2bcd8739ae039) } = props, other = (0, $bGxpK.default)(props, $f6bd69894e5675e4$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $f6bd69894e5675e4$var$useUtilityClasses(ownerState);
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const timer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const wrapperRef = $dup7A.useRef(null);
    const autoTransitionDuration = $dup7A.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $dup7A.useRef(null);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $cZGFG.jsx)($f6bd69894e5675e4$var$CollapseRoot, (0, $3G4eg.default)({
                as: component,
                className: (0, $aJAJS.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $3G4eg.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $3G4eg.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($f6bd69894e5675e4$var$CollapseWrapper, {
                    ownerState: (0, $3G4eg.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)($f6bd69894e5675e4$var$CollapseWrapperInner, {
                        ownerState: (0, $3G4eg.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$f6bd69894e5675e4$var$Collapse.muiSupportAuto = true;
var $f6bd69894e5675e4$export$2e2bcd8739ae039 = $f6bd69894e5675e4$var$Collapse;





var $dup7A = parcelRequire("dup7A");






var $dup7A = parcelRequire("dup7A");


var $8T6OQ = parcelRequire("8T6OQ");

var $dup7A = parcelRequire("dup7A");

const $a670161a467df0c7$export$eb3aa16b2ed13b52 = (provider)=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const getTokenBalancesWithRetry = (0, $dup7A.useCallback)(async (accountAddress, tokens, depth = 0)=>{
        try {
            const walletAddress = (0, $8T6OQ.isAddress)(accountAddress) ? accountAddress : await provider?.resolveName(accountAddress);
            const tokenBalances = await lifi.getTokenBalances(walletAddress, tokens);
            if (!tokenBalances.every((token)=>token.blockNumber)) {
                if (depth > 10) {
                    console.warn("Token balance backoff depth exceeded.");
                    return undefined;
                }
                await new Promise((resolve)=>{
                    setTimeout(resolve, 1.5 ** depth * 100);
                });
                return getTokenBalancesWithRetry(accountAddress, tokens, depth + 1);
            }
            return tokenBalances;
        } catch (error) {
        //
        }
    }, [
        lifi,
        provider
    ]);
    return getTokenBalancesWithRetry;
};


const $590670eb38959b19$var$defaultRefetchInterval = 30000;
const $590670eb38959b19$export$c79c82fb94eb75b4 = (token, accountAddress)=>{
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)();
    const walletAddress = accountAddress || account.address;
    const getTokenBalancesWithRetry = (0, $a670161a467df0c7$export$eb3aa16b2ed13b52)(account.signer?.provider);
    const tokenBalanceQueryKey = (0, $dup7A.useMemo)(()=>[
            "token-balance",
            walletAddress,
            token?.chainId,
            token?.address
        ], [
        token?.address,
        token?.chainId,
        walletAddress
    ]);
    const { data: data, isLoading: isLoading, refetch: refetch } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)(tokenBalanceQueryKey, async ({ queryKey: [, accountAddress] })=>{
        const cachedToken = queryClient.getQueryData([
            "token-balances",
            accountAddress,
            token.chainId
        ])?.find((t)=>t.address === token.address);
        if (cachedToken) return cachedToken;
        const tokenBalances = await getTokenBalancesWithRetry(accountAddress, [
            token
        ]);
        if (!tokenBalances?.length) throw Error("Could not get tokens balance.");
        const cachedTokenAmount = queryClient.getQueryData(tokenBalanceQueryKey);
        const tokenAmount = tokenBalances[0].amount;
        if (cachedTokenAmount?.amount !== tokenAmount) queryClient.setQueryDefaults(tokenBalanceQueryKey, {
            refetchInterval: $590670eb38959b19$var$defaultRefetchInterval,
            staleTime: $590670eb38959b19$var$defaultRefetchInterval
        });
        queryClient.setQueriesData([
            "token-balances",
            accountAddress,
            token.chainId
        ], (data)=>{
            if (data) {
                const clonedData = [
                    ...data
                ];
                const index = clonedData.findIndex((dataToken)=>dataToken.address === token.address);
                clonedData[index] = {
                    ...clonedData[index],
                    amount: tokenAmount
                };
                return clonedData;
            }
        });
        return {
            ...tokenBalances[0],
            amount: tokenAmount
        };
    }, {
        enabled: Boolean(walletAddress && token),
        refetchInterval: $590670eb38959b19$var$defaultRefetchInterval,
        staleTime: $590670eb38959b19$var$defaultRefetchInterval
    });
    const refetchAllBalances = ()=>{
        queryClient.refetchQueries([
            "token-balances",
            accountAddress,
            token?.chainId
        ], {
            exact: false
        });
    };
    const refetchNewBalance = (0, $dup7A.useCallback)(()=>{
        queryClient.setQueryDefaults(tokenBalanceQueryKey, {
            refetchInterval: 250,
            staleTime: 250
        });
    }, [
        queryClient,
        tokenBalanceQueryKey
    ]);
    return {
        token: data,
        isLoading: isLoading,
        refetch: refetch,
        refetchNewBalance: refetchNewBalance,
        refetchAllBalances: refetchAllBalances,
        getTokenBalancesWithRetry: getTokenBalancesWithRetry
    };
};


const $3abf02afa8091034$export$92b020e44091b5ca = ()=>{
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const [fromChainId, fromTokenAddress, toChainId, toAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress
        ]
    });
    const toChain = getChainById(toChainId);
    const { token: nativeToken } = (0, $590670eb38959b19$export$c79c82fb94eb75b4)(toChainId && toChain?.nativeToken, toAddress);
    const { data: gasRecommendation, isLoading: isLoading } = (0, $26691b71e2f63cef$export$6e4f7860967d45da)(toChainId, fromChainId, fromTokenAddress);
    const enabled = (0, $dup7A.useMemo)(()=>{
        if (// We don't allow same chain refuel.
        // If a user runs out of gas, he can't send a source chain transaction.
        fromChainId === toChainId || !gasRecommendation?.available || !nativeToken) return false;
        const tokenBalance = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(nativeToken.amount ?? 0);
        // check if the user balance < 50% of the recommended amount
        const recommendedAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(gasRecommendation.recommended.amount).div(10 ** gasRecommendation.recommended.token.decimals).div(2);
        const insufficientGas = tokenBalance.lt(recommendedAmount);
        return insufficientGas;
    }, [
        fromChainId,
        gasRecommendation,
        nativeToken,
        toChainId
    ]);
    return {
        enabled: enabled,
        availble: gasRecommendation?.available,
        isLoading: isLoading,
        chain: toChain,
        fromAmount: gasRecommendation?.available ? gasRecommendation.fromAmount : undefined
    };
};





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $7a99de72d8cdca22$export$39f6debbec19b3ba(slot) {
    return (0, $8iNDC.default)("MuiSwitch", slot);
}
const $7a99de72d8cdca22$var$switchClasses = (0, $fc1pF.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $7a99de72d8cdca22$export$2e2bcd8739ae039 = $7a99de72d8cdca22$var$switchClasses;



var $jjHhy = parcelRequire("jjHhy");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $4y4xl = parcelRequire("4y4xl");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $dup7A = parcelRequire("dup7A");
"use client";
function $86cf678e0a963c6e$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $dup7A.useRef(controlled !== undefined);
    const [valueState, setValue] = $dup7A.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $dup7A.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $c3c9d27e53aed175$export$2e2bcd8739ae039 = (0, $86cf678e0a963c6e$export$2e2bcd8739ae039);





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $1440baf56db12cb4$export$baa0faa0c7ad8085(slot) {
    return (0, $8iNDC.default)("PrivateSwitchBase", slot);
}
const $1440baf56db12cb4$var$switchBaseClasses = (0, $fc1pF.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $1440baf56db12cb4$export$2e2bcd8739ae039 = $1440baf56db12cb4$var$switchBaseClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $a7740cb4da7f3cdd$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $a7740cb4da7f3cdd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $4y4xl.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $1440baf56db12cb4$export$baa0faa0c7ad8085), classes);
};
const $a7740cb4da7f3cdd$var$SwitchBaseRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $a7740cb4da7f3cdd$var$SwitchBaseInput = (0, $jjHhy.default)("input", {
    shouldForwardProp: (0, $dDUuw.default)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $a7740cb4da7f3cdd$var$SwitchBase = /*#__PURE__*/ $dup7A.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $bGxpK.default)(props, $a7740cb4da7f3cdd$var$_excluded);
    const [checked, setCheckedState] = (0, $c3c9d27e53aed175$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $3G4eg.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $a7740cb4da7f3cdd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($a7740cb4da7f3cdd$var$SwitchBaseRoot, (0, $3G4eg.default)({
        component: "span",
        className: (0, $aJAJS.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($a7740cb4da7f3cdd$var$SwitchBaseInput, (0, $3G4eg.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $a7740cb4da7f3cdd$export$2e2bcd8739ae039 = $a7740cb4da7f3cdd$var$SwitchBase;



var $jjHhy = parcelRequire("jjHhy");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $68d627374e0fabd0$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $68d627374e0fabd0$var$useThemeProps = (0, $49cad466f431519b$export$ff8356348e0cc878)("MuiSwitch");
const $68d627374e0fabd0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $4y4xl.default)(edge)}`,
            `size${(0, $4y4xl.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $4y4xl.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $7a99de72d8cdca22$export$39f6debbec19b3ba), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $68d627374e0fabd0$var$SwitchRoot = (0, $jjHhy.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $4y4xl.default)(ownerState.edge)}`],
            styles[`size${(0, $4y4xl.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inline-flex",
    width: 58,
    height: 38,
    overflow: "hidden",
    padding: 12,
    boxSizing: "border-box",
    position: "relative",
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: "middle",
    // For correct alignment with the text.
    "@media print": {
        colorAdjust: "exact"
    },
    variants: [
        {
            props: {
                edge: "start"
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: "end"
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked}`]: {
                        transform: "translateX(16px)"
                    }
                }
            }
        }
    ]
});
const $68d627374e0fabd0$var$SwitchSwitchBase = (0, $jjHhy.default)((0, $a7740cb4da7f3cdd$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $4y4xl.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked} + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled} + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme })=>({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            "&:hover": {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $emmvO.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "@media (hover: none)": {
                                    backgroundColor: "transparent"
                                }
                            },
                            [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $emmvO.lighten)(theme.palette[color].main, 0.62) : (0, $emmvO.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked} + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $68d627374e0fabd0$var$SwitchTrack = (0, $jjHhy.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $68d627374e0fabd0$var$SwitchThumb = (0, $jjHhy.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $68d627374e0fabd0$var$Switch = /*#__PURE__*/ $dup7A.forwardRef(function Switch(inProps, ref) {
    const props = $68d627374e0fabd0$var$useThemeProps({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $bGxpK.default)(props, $68d627374e0fabd0$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $68d627374e0fabd0$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $cZGFG.jsx)($68d627374e0fabd0$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($68d627374e0fabd0$var$SwitchRoot, {
        className: (0, $aJAJS.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($68d627374e0fabd0$var$SwitchSwitchBase, (0, $3G4eg.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $3G4eg.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $cZGFG.jsx)($68d627374e0fabd0$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $68d627374e0fabd0$export$2e2bcd8739ae039 = $68d627374e0fabd0$var$Switch;



var $jjHhy = parcelRequire("jjHhy");

const $ce24fb090d208741$export$b5d5cf8927ab7262 = (0, $jjHhy.default)((0, $68d627374e0fabd0$export$2e2bcd8739ae039))(({ theme: theme })=>({
        width: 42,
        height: 24,
        padding: 0,
        [`.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 0,
            margin: theme.spacing(0.25),
            transitionDuration: theme.transitions.duration.standard,
            [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(18px)",
                color: theme.palette.common.white,
                [`& + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
                    backgroundColor: theme.palette.primary.main,
                    opacity: 1,
                    border: 0
                },
                [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled} + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
                    opacity: 0.5
                }
            },
            [`&.Mui-focusVisible .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).thumb}`]: {
                color: theme.palette.primary.main,
                border: "6px solid",
                borderColor: theme.palette.common.white
            },
            [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled} .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).thumb}`]: {
                color: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.12) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.12)
            },
            [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).disabled} + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3
            }
        },
        [`.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).thumb}`]: {
            boxSizing: "border-box",
            width: 20,
            height: 20
        },
        [`.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
            borderRadius: 12,
            backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.16) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.16),
            opacity: 1,
            transition: theme.transitions.create([
                "background-color"
            ], {
                duration: theme.transitions.duration.standard
            })
        }
    }));


const $df6885d8eb7cfb01$var$MessageCard = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        borderRadius: theme.shape.borderRadius,
        position: "relative",
        whiteSpace: "pre-line"
    }));
const $df6885d8eb7cfb01$export$1fe9999661564b94 = (0, $jjHhy.default)($df6885d8eb7cfb01$var$MessageCard)(({ theme: theme })=>({
        backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.warning.main, 0.32) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.warning.main, 0.16)
    }));
const $df6885d8eb7cfb01$export$80593e8ef4506f22 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(theme.palette.warning.main, 0.36) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.warning.main, 1)
    }));
const $df6885d8eb7cfb01$export$10c61473ad0b12ab = (0, $jjHhy.default)($df6885d8eb7cfb01$var$MessageCard)(({ theme: theme })=>({
        backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.info.main, 0.12) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.info.main, 0.16)
    }));
const $df6885d8eb7cfb01$export$ee03eb5bd15feefd = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: theme.palette.mode === "light" ? theme.palette.info.main : (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(theme.palette.info.main, 0.24)
    }));
const $df6885d8eb7cfb01$export$66da144a6bcbf8a0 = (0, $jjHhy.default)((0, $ce24fb090d208741$export$b5d5cf8927ab7262))(({ theme: theme })=>({
        [`.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).switchBase}`]: {
            [`&.${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).checked}`]: {
                [`& + .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).track}`]: {
                    backgroundColor: theme.palette.mode === "light" ? theme.palette.info.main : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.info.main, 0.84)
                }
            },
            [`&.Mui-focusVisible .${(0, $7a99de72d8cdca22$export$2e2bcd8739ae039).thumb}`]: {
                color: theme.palette.mode === "light" ? theme.palette.info.main : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.info.main, 0.84)
            }
        }
    }));


const $b142cba2da027a3f$export$f96732dcc82db8 = (props)=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const { enabledAutoRefuel: enabledAutoRefuel } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "enabledAutoRefuel"
    ]);
    const { enabled: enabled, chain: chain, isLoading: isRefuelLoading } = (0, $3abf02afa8091034$export$92b020e44091b5ca)();
    const onChange = (_, checked)=>{
        setValue("enabledAutoRefuel", checked);
    };
    const showGasRefuelMessage = chain && enabled && !isRefuelLoading;
    return (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
        timeout: 225,
        in: showGasRefuelMessage,
        unmountOnExit: true,
        mountOnEnter: true,
        children: (0, $cZGFG.jsxs)((0, $df6885d8eb7cfb01$export$10c61473ad0b12ab), {
            ...props,
            children: [
                (0, $cZGFG.jsxs)((0, $df6885d8eb7cfb01$export$ee03eb5bd15feefd), {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                    children: [
                        (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "center",
                            children: [
                                (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9955478a62ac183c$exports))), {
                                    sx: {
                                        marginRight: 1
                                    }
                                }),
                                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    fontWeight: 700,
                                    children: t(`info.title.autoRefuel`)
                                })
                            ]
                        }),
                        (0, $cZGFG.jsx)((0, $df6885d8eb7cfb01$export$66da144a6bcbf8a0), {
                            checked: enabledAutoRefuel,
                            onChange: onChange
                        })
                    ]
                }),
                (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                    timeout: 225,
                    in: enabledAutoRefuel,
                    unmountOnExit: true,
                    mountOnEnter: true,
                    children: (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        variant: "body2",
                        px: 2,
                        pb: 2,
                        children: t(`info.message.autoRefuel`, {
                            chainName: chain?.name
                        })
                    })
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");





var $8T6OQ = parcelRequire("8T6OQ");




const $fea84a7b0875fe08$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $fea84a7b0875fe08$export$2e2bcd8739ae039 = {
    randomUUID: $fea84a7b0875fe08$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $742f870b54ed243e$var$getRandomValues;
const $742f870b54ed243e$var$rnds8 = new Uint8Array(16);
function $742f870b54ed243e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$742f870b54ed243e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $742f870b54ed243e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$742f870b54ed243e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $742f870b54ed243e$var$getRandomValues($742f870b54ed243e$var$rnds8);
}


var $df5f68032d122b8f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $4bbe47a629cd6cd4$var$validate(uuid) {
    return typeof uuid === "string" && (0, $df5f68032d122b8f$export$2e2bcd8739ae039).test(uuid);
}
var $4bbe47a629cd6cd4$export$2e2bcd8739ae039 = $4bbe47a629cd6cd4$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $d12dbd23221d3b61$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$d12dbd23221d3b61$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $d12dbd23221d3b61$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $d12dbd23221d3b61$var$byteToHex[arr[offset + 0]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 1]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 2]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 3]] + "-" + $d12dbd23221d3b61$var$byteToHex[arr[offset + 4]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 5]] + "-" + $d12dbd23221d3b61$var$byteToHex[arr[offset + 6]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 7]] + "-" + $d12dbd23221d3b61$var$byteToHex[arr[offset + 8]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 9]] + "-" + $d12dbd23221d3b61$var$byteToHex[arr[offset + 10]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 11]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 12]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 13]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 14]] + $d12dbd23221d3b61$var$byteToHex[arr[offset + 15]];
}
function $d12dbd23221d3b61$var$stringify(arr, offset = 0) {
    const uuid = $d12dbd23221d3b61$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $4bbe47a629cd6cd4$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $d12dbd23221d3b61$export$2e2bcd8739ae039 = $d12dbd23221d3b61$var$stringify;


function $2c748512afe55347$var$v4(options, buf, offset) {
    if ((0, $fea84a7b0875fe08$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $fea84a7b0875fe08$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $742f870b54ed243e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $d12dbd23221d3b61$export$8fb373d660548968)(rnds);
}
var $2c748512afe55347$export$2e2bcd8739ae039 = $2c748512afe55347$var$v4;



var $dup7A = parcelRequire("dup7A");

const $833ae500abec472a$export$d2b8bdb5925c555f = (name, delay)=>{
    const watchedValue = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: name
    });
    const [debouncedValue, setDebouncedValue] = (0, $dup7A.useState)(watchedValue);
    const debouncedValueRef = (0, $dup7A.useRef)();
    const isMounted = (0, $dup7A.useRef)(false);
    (0, $dup7A.useEffect)(()=>{
        if (isMounted.current) {
            const hasWatchedValue = Array.isArray(watchedValue) ? watchedValue.some((value)=>value) : Boolean(watchedValue);
            if (hasWatchedValue) {
                const handler = setTimeout(()=>{
                    setDebouncedValue(watchedValue);
                }, delay);
                return ()=>clearTimeout(handler);
            }
            debouncedValueRef.current = watchedValue;
            setDebouncedValue(watchedValue);
            return undefined;
        }
        isMounted.current = true;
        return undefined;
    }, [
        delay,
        watchedValue
    ]);
    return debouncedValue;
};





const $420a652508d6fbf9$export$c4a81b0a847a209f = ()=>{
    const state = (0, $5e8b8f7a49e68349$export$a7844f191cd50a20)((state)=>state.state);
    return state === "swap";
};


const $36164d6f2c6fd483$var$refetchTime = 60000;
const $36164d6f2c6fd483$export$5d3fca4a98652595 = ({ insurableRoute: insurableRoute } = {})=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { subvariant: subvariant, sdkConfig: sdkConfig, insurance: insurance, contractTool: contractTool } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const queryClient = (0, $838c1a6e5f3807de$export$22e77b9572c4fded)();
    const swapOnly = (0, $420a652508d6fbf9$export$c4a81b0a847a209f)();
    const { slippage: slippage, enabledBridges: enabledBridges, enabledAutoRefuel: enabledAutoRefuel, enabledExchanges: enabledExchanges, routePriority: routePriority } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "slippage",
        "routePriority",
        "enabledAutoRefuel",
        "enabledBridges",
        "enabledExchanges"
    ]);
    const [fromTokenAmount] = (0, $833ae500abec472a$export$d2b8bdb5925c555f)([
        (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount
    ], 320);
    const [fromChainId, fromTokenAddress, toAddress, toTokenAmount, toChainId, toContractAddress, toContractCallData, toContractGasLimit, toTokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAmount,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractAddress,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractCallData,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToContractGasLimit,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken
        ]
    });
    const { token: fromToken } = (0, $b486f29e55929307$export$31dcd79391e423fe)(fromChainId, fromTokenAddress);
    const { token: toToken } = (0, $b486f29e55929307$export$31dcd79391e423fe)(toChainId, toTokenAddress);
    const { enabled: enabledRefuel, fromAmount: gasRecommendationFromAmount } = (0, $3abf02afa8091034$export$92b020e44091b5ca)();
    const hasAmount = !isNaN(fromTokenAmount) && Number(fromTokenAmount) > 0 || !isNaN(toTokenAmount) && Number(toTokenAmount) > 0;
    const contractCallQuoteEnabled = subvariant === "nft" ? Boolean(toContractAddress && toContractCallData && toContractGasLimit) : true;
    const isEnabled = !isNaN(fromChainId) && !isNaN(toChainId) && Boolean(fromToken?.address) && Boolean(toToken?.address) && !Number.isNaN(slippage) && hasAmount && contractCallQuoteEnabled;
    const queryKey = [
        "routes",
        account.address,
        fromChainId,
        fromToken?.address,
        fromTokenAmount,
        toAddress,
        toChainId,
        toToken?.address,
        toTokenAmount,
        toContractAddress,
        toContractCallData,
        toContractGasLimit,
        slippage,
        swapOnly ? [] : enabledBridges,
        enabledExchanges,
        routePriority,
        subvariant,
        sdkConfig?.defaultRouteOptions?.allowSwitchChain,
        enabledRefuel && enabledAutoRefuel,
        gasRecommendationFromAmount,
        insurance,
        insurableRoute?.id
    ];
    const { data: data, isLoading: isLoading, isFetching: isFetching, isFetched: isFetched, dataUpdatedAt: dataUpdatedAt, refetch: refetch } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)(queryKey, async ({ queryKey: [_, fromAddress, fromChainId, fromTokenAddress, fromTokenAmount, toAddress, toChainId, toTokenAddress, toTokenAmount, toContractAddress, toContractCallData, toContractGasLimit, slippage, enabledBridges, enabledExchanges, routePriority, subvariant, allowSwitchChain, enabledRefuel, gasRecommendationFromAmount, insurance, insurableRouteId], signal: signal })=>{
        let toWalletAddress;
        try {
            toWalletAddress = await account.signer?.provider?.resolveName(toAddress) ?? ((0, $8T6OQ.isAddress)(toAddress) ? toAddress : fromAddress);
        } catch  {
            toWalletAddress = (0, $8T6OQ.isAddress)(toAddress) ? toAddress : fromAddress;
        }
        const fromAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(fromTokenAmount || 0).mul(10 ** (fromToken?.decimals ?? 0)).toFixed(0);
        const formattedSlippage = parseFloat(slippage) / 100;
        const allowedBridges = insurableRoute ? insurableRoute.steps.flatMap((step)=>step.includedSteps.filter((includedStep)=>includedStep.type === "cross").map((includedStep)=>includedStep.toolDetails.key)) : enabledBridges;
        const allowedExchanges = insurableRoute ? insurableRoute.steps.flatMap((step)=>step.includedSteps.filter((includedStep)=>includedStep.type === "swap").map((includedStep)=>includedStep.toolDetails.key)) : enabledExchanges;
        if (subvariant === "nft") {
            const contractCallQuote = await lifi.getContractCallQuote({
                fromAddress: fromAddress,
                fromChain: fromChainId,
                fromToken: fromTokenAddress,
                toAmount: toTokenAmount,
                toChain: toChainId,
                toToken: toTokenAddress,
                toContractAddress: toContractAddress,
                toContractCallData: toContractCallData,
                toContractGasLimit: toContractGasLimit,
                allowBridges: allowedBridges,
                toFallbackAddress: toWalletAddress,
                slippage: formattedSlippage
            }, {
                signal: signal
            });
            contractCallQuote.action.toToken = toToken;
            const customStep = subvariant === "nft" ? contractCallQuote.includedSteps?.find((step)=>step.type === "custom") : undefined;
            if (customStep && contractTool) {
                const toolDetails = {
                    key: contractTool.name,
                    name: contractTool.name,
                    logoURI: contractTool.logoURI
                };
                customStep.toolDetails = toolDetails;
                contractCallQuote.toolDetails = toolDetails;
            }
            const route = {
                id: (0, $2c748512afe55347$export$2e2bcd8739ae039)(),
                fromChainId: contractCallQuote.action.fromChainId,
                fromAmountUSD: contractCallQuote.estimate.fromAmountUSD || "",
                fromAmount: contractCallQuote.action.fromAmount,
                fromToken: contractCallQuote.action.fromToken,
                fromAddress: contractCallQuote.action.fromAddress,
                toChainId: contractCallQuote.action.toChainId,
                toAmountUSD: contractCallQuote.estimate.toAmountUSD || "",
                toAmount: toTokenAmount,
                toAmountMin: toTokenAmount,
                toToken: toToken,
                toAddress: toWalletAddress,
                gasCostUSD: contractCallQuote.estimate.gasCosts?.[0].amountUSD,
                steps: [
                    contractCallQuote
                ],
                insurance: {
                    state: "NOT_INSURABLE",
                    feeAmountUsd: "0"
                }
            };
            return {
                routes: [
                    route
                ]
            };
        }
        return lifi.getRoutes({
            fromChainId: fromChainId,
            fromAmount: fromAmount,
            fromTokenAddress: fromTokenAddress,
            toChainId: toChainId,
            toTokenAddress: toTokenAddress,
            fromAddress: fromAddress,
            toAddress: toWalletAddress,
            fromAmountForGas: enabledRefuel && gasRecommendationFromAmount ? gasRecommendationFromAmount : undefined,
            options: {
                slippage: formattedSlippage,
                bridges: {
                    allow: allowedBridges
                },
                exchanges: {
                    allow: allowedExchanges
                },
                order: routePriority,
                allowSwitchChain: subvariant === "refuel" ? false : allowSwitchChain,
                insurance: insurance ? Boolean(insurableRoute) : undefined
            }
        }, {
            signal: signal
        });
    }, {
        enabled: isEnabled,
        staleTime: $36164d6f2c6fd483$var$refetchTime,
        cacheTime: $36164d6f2c6fd483$var$refetchTime,
        refetchInterval (data, query) {
            return Math.min(Math.abs($36164d6f2c6fd483$var$refetchTime - (Date.now() - query.state.dataUpdatedAt)), $36164d6f2c6fd483$var$refetchTime);
        },
        retry (failureCount, error) {
            if (error?.code === (0, $b6aa7c63b666337d$export$fe007b9cf5c9f36b).NotFound) return false;
            return true;
        },
        onSuccess (data) {
            if (data.routes[0]) {
                // Update local tokens cache to keep priceUSD in sync
                const { fromToken: fromToken, toToken: toToken } = data.routes[0];
                [
                    fromToken,
                    toToken
                ].forEach((token)=>{
                    queryClient.setQueriesData([
                        "token-balances",
                        account.address,
                        token.chainId
                    ], (data)=>{
                        if (data) {
                            const clonedData = [
                                ...data
                            ];
                            const index = clonedData.findIndex((dataToken)=>dataToken.address === token.address);
                            clonedData[index] = {
                                ...clonedData[index],
                                ...token
                            };
                            return clonedData;
                        }
                    });
                });
            }
        }
    });
    return {
        routes: data?.routes,
        isLoading: isEnabled && isLoading,
        isFetching: isFetching,
        isFetched: isFetched,
        dataUpdatedAt: dataUpdatedAt,
        refetchTime: $36164d6f2c6fd483$var$refetchTime,
        refetch: refetch
    };
};






var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $8eVik = parcelRequire("8eVik");

var $4y4xl = parcelRequire("4y4xl");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $43ce6436471940ae$export$29cad1383b3f235d(slot) {
    return (0, $8iNDC.default)("MuiCircularProgress", slot);
}
const $43ce6436471940ae$var$circularProgressClasses = (0, $fc1pF.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $43ce6436471940ae$export$2e2bcd8739ae039 = $43ce6436471940ae$var$circularProgressClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $65a11d953b0c04a5$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $65a11d953b0c04a5$var$_ = (t)=>t, $65a11d953b0c04a5$var$_t, $65a11d953b0c04a5$var$_t2, $65a11d953b0c04a5$var$_t3, $65a11d953b0c04a5$var$_t4;
const $65a11d953b0c04a5$var$SIZE = 44;
const $65a11d953b0c04a5$var$circularRotateKeyframe = (0, $8eVik.keyframes)($65a11d953b0c04a5$var$_t || ($65a11d953b0c04a5$var$_t = $65a11d953b0c04a5$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $65a11d953b0c04a5$var$circularDashKeyframe = (0, $8eVik.keyframes)($65a11d953b0c04a5$var$_t2 || ($65a11d953b0c04a5$var$_t2 = $65a11d953b0c04a5$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $65a11d953b0c04a5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $4y4xl.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $4y4xl.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $43ce6436471940ae$export$29cad1383b3f235d), classes);
};
const $65a11d953b0c04a5$var$CircularProgressRoot = (0, $jjHhy.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $4y4xl.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $8eVik.css)($65a11d953b0c04a5$var$_t3 || ($65a11d953b0c04a5$var$_t3 = $65a11d953b0c04a5$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $65a11d953b0c04a5$var$circularRotateKeyframe));
const $65a11d953b0c04a5$var$CircularProgressSVG = (0, $jjHhy.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $65a11d953b0c04a5$var$CircularProgressCircle = (0, $jjHhy.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $4y4xl.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $8eVik.css)($65a11d953b0c04a5$var$_t4 || ($65a11d953b0c04a5$var$_t4 = $65a11d953b0c04a5$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $65a11d953b0c04a5$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $65a11d953b0c04a5$var$CircularProgress = /*#__PURE__*/ $dup7A.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $bGxpK.default)(props, $65a11d953b0c04a5$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $65a11d953b0c04a5$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($65a11d953b0c04a5$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $cZGFG.jsx)($65a11d953b0c04a5$var$CircularProgressRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        style: (0, $3G4eg.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($65a11d953b0c04a5$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$65a11d953b0c04a5$var$SIZE / 2} ${$65a11d953b0c04a5$var$SIZE / 2} ${$65a11d953b0c04a5$var$SIZE} ${$65a11d953b0c04a5$var$SIZE}`,
            children: /*#__PURE__*/ (0, $cZGFG.jsx)($65a11d953b0c04a5$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $65a11d953b0c04a5$var$SIZE,
                cy: $65a11d953b0c04a5$var$SIZE,
                r: ($65a11d953b0c04a5$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $65a11d953b0c04a5$export$2e2bcd8739ae039 = $65a11d953b0c04a5$var$CircularProgress;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");




var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");


var $jjHhy = parcelRequire("jjHhy");


var $7ZufN = parcelRequire("7ZufN");

var $4y4xl = parcelRequire("4y4xl");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");








var $cZGFG = parcelRequire("cZGFG");
"use client";
const $651a53450047d63f$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $651a53450047d63f$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $651a53450047d63f$var$styles = {
    entering: {
        opacity: 1,
        transform: $651a53450047d63f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $651a53450047d63f$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $651a53450047d63f$var$Grow = /*#__PURE__*/ $dup7A.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e41ac8e2c2248586$export$2e2bcd8739ae039) } = props, other = (0, $bGxpK.default)(props, $651a53450047d63f$var$_excluded);
    const timer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const autoTimeout = $dup7A.useRef();
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const nodeRef = $dup7A.useRef(null);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $51a9aedde841c9be$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $651a53450047d63f$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $51a9aedde841c9be$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $651a53450047d63f$var$isWebKit154 ? duration : duration * 0.666,
                delay: $651a53450047d63f$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $651a53450047d63f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $dup7A.cloneElement(children, (0, $3G4eg.default)({
                style: (0, $3G4eg.default)({
                    opacity: 0,
                    transform: $651a53450047d63f$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $651a53450047d63f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$651a53450047d63f$var$Grow.muiSupportAuto = true;
var $651a53450047d63f$export$2e2bcd8739ae039 = $651a53450047d63f$var$Grow;



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");

function $e0677a97a4b82dde$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $cca8fc0d6c05a54b$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $cca8fc0d6c05a54b$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3b9cfba22cfc5efc$export$8960430cfd85939f = Math.max;
var $3b9cfba22cfc5efc$export$96ec731ed4dcb222 = Math.min;
var $3b9cfba22cfc5efc$export$2077e0241d6afd3c = Math.round;



function $fd05a089f7e176cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $1ea9551f9b5caa45$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fd05a089f7e176cf$export$2e2bcd8739ae039)());
}


function $82e1450554903243$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(element) ? (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $1ea9551f9b5caa45$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $72dfd4792923f202$export$2e2bcd8739ae039(node) {
    var win = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d1cf34b3f780ddc1$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $e4b073c40121ada3$export$2e2bcd8739ae039(node) {
    if (node === (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(node) || !(0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(node)) return (0, $72dfd4792923f202$export$2e2bcd8739ae039)(node);
    else return (0, $d1cf34b3f780ddc1$export$2e2bcd8739ae039)(node);
}


function $a0a5ed2473c57006$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $65079d2557eeec19$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $5d830c6a66d53fc9$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $82e1450554903243$export$2e2bcd8739ae039)((0, $65079d2557eeec19$export$2e2bcd8739ae039)(element)).left + (0, $72dfd4792923f202$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $bb00208fe1e6a718$export$2e2bcd8739ae039(element) {
    return (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $4ca33aa1878858c6$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1167047b40c83ffe$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1167047b40c83ffe$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(offsetParent) && $1167047b40c83ffe$var$isElementScaled(offsetParent);
    var documentElement = (0, $65079d2557eeec19$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $82e1450554903243$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4ca33aa1878858c6$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $e4b073c40121ada3$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $82e1450554903243$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5d830c6a66d53fc9$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c8681ef26237bdd3$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $82e1450554903243$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $867aa902f08d11d6$export$2e2bcd8739ae039(element) {
    if ((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $cca8fc0d6c05a54b$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $65079d2557eeec19$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $a578369116db5e6e$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(node) && (0, $4ca33aa1878858c6$export$2e2bcd8739ae039)(node)) return node;
    return $a578369116db5e6e$export$2e2bcd8739ae039((0, $867aa902f08d11d6$export$2e2bcd8739ae039)(node));
}





function $ae5f4dd435d0a058$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a578369116db5e6e$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4ca33aa1878858c6$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ae5f4dd435d0a058$export$2e2bcd8739ae039((0, $867aa902f08d11d6$export$2e2bcd8739ae039)(target)));
}







function $d9e2f8751c419dc3$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(element)) >= 0;
}




function $5566429e991d71d1$var$getTrueOffsetParent(element) {
    if (!(0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5566429e991d71d1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fd05a089f7e176cf$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $fd05a089f7e176cf$export$2e2bcd8739ae039)());
    if (isIE && (0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $867aa902f08d11d6$export$2e2bcd8739ae039)(element);
    if ((0, $cca8fc0d6c05a54b$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5566429e991d71d1$export$2e2bcd8739ae039(element) {
    var window = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(element);
    var offsetParent = $5566429e991d71d1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d9e2f8751c419dc3$export$2e2bcd8739ae039)(offsetParent) && (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $5566429e991d71d1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $5566429e991d71d1$var$getContainingBlock(element) || window;
}


var $7cbbe4209b3cf823$export$1e95b668f3b82d = "top";
var $7cbbe4209b3cf823$export$40e543e69a8b3fbb = "bottom";
var $7cbbe4209b3cf823$export$79ffe56a765070d2 = "right";
var $7cbbe4209b3cf823$export$eabcd2c8791e7bf4 = "left";
var $7cbbe4209b3cf823$export$dfb5619354ba860 = "auto";
var $7cbbe4209b3cf823$export$aec2ce47c367b8c3 = [
    $7cbbe4209b3cf823$export$1e95b668f3b82d,
    $7cbbe4209b3cf823$export$40e543e69a8b3fbb,
    $7cbbe4209b3cf823$export$79ffe56a765070d2,
    $7cbbe4209b3cf823$export$eabcd2c8791e7bf4
];
var $7cbbe4209b3cf823$export$b3571188c770cc5a = "start";
var $7cbbe4209b3cf823$export$bd5df0f255a350f8 = "end";
var $7cbbe4209b3cf823$export$390fd549c5303b4d = "clippingParents";
var $7cbbe4209b3cf823$export$d7b7311ec04a3e8f = "viewport";
var $7cbbe4209b3cf823$export$ae5ab1c730825774 = "popper";
var $7cbbe4209b3cf823$export$ca50aac9f3ba507f = "reference";
var $7cbbe4209b3cf823$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7cbbe4209b3cf823$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7cbbe4209b3cf823$export$b3571188c770cc5a,
        placement + "-" + $7cbbe4209b3cf823$export$bd5df0f255a350f8
    ]);
}, []);
var $7cbbe4209b3cf823$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7cbbe4209b3cf823$export$aec2ce47c367b8c3, [
    $7cbbe4209b3cf823$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7cbbe4209b3cf823$export$b3571188c770cc5a,
        placement + "-" + $7cbbe4209b3cf823$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7cbbe4209b3cf823$export$421679a7c3d56e = "beforeRead";
var $7cbbe4209b3cf823$export$aafa59e2e03f2942 = "read";
var $7cbbe4209b3cf823$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $7cbbe4209b3cf823$export$c65e99957a05207c = "beforeMain";
var $7cbbe4209b3cf823$export$f22da7240b7add18 = "main";
var $7cbbe4209b3cf823$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7cbbe4209b3cf823$export$8d4d2d70e7d46032 = "beforeWrite";
var $7cbbe4209b3cf823$export$68d8715fc104d294 = "write";
var $7cbbe4209b3cf823$export$70a6e5159acce2e6 = "afterWrite";
var $7cbbe4209b3cf823$export$d087d3878fdf71d5 = [
    $7cbbe4209b3cf823$export$421679a7c3d56e,
    $7cbbe4209b3cf823$export$aafa59e2e03f2942,
    $7cbbe4209b3cf823$export$6964f6c886723980,
    $7cbbe4209b3cf823$export$c65e99957a05207c,
    $7cbbe4209b3cf823$export$f22da7240b7add18,
    $7cbbe4209b3cf823$export$bab79516f2d662fe,
    $7cbbe4209b3cf823$export$8d4d2d70e7d46032,
    $7cbbe4209b3cf823$export$68d8715fc104d294,
    $7cbbe4209b3cf823$export$70a6e5159acce2e6
];


function $224b8d9f8fcc2e90$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $224b8d9f8fcc2e90$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $224b8d9f8fcc2e90$var$order(modifiers); // order based on phase
    return (0, $7cbbe4209b3cf823$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $3b51aae4d235ced3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $785beb9b6604eaed$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c199a11bfd96e76a$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $c199a11bfd96e76a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $c199a11bfd96e76a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c199a11bfd96e76a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $c199a11bfd96e76a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(reference) ? (0, $ae5f4dd435d0a058$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $ae5f4dd435d0a058$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $ae5f4dd435d0a058$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $224b8d9f8fcc2e90$export$2e2bcd8739ae039)((0, $785beb9b6604eaed$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c199a11bfd96e76a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1167047b40c83ffe$export$2e2bcd8739ae039)(reference, (0, $5566429e991d71d1$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $c8681ef26237bdd3$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3b51aae4d235ced3$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c199a11bfd96e76a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c199a11bfd96e76a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c199a11bfd96e76a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $a6959ae4a0aedc8b$var$passive = {
    passive: true
};
function $a6959ae4a0aedc8b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $a6959ae4a0aedc8b$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $a6959ae4a0aedc8b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $a6959ae4a0aedc8b$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $a6959ae4a0aedc8b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a6959ae4a0aedc8b$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $a6959ae4a0aedc8b$var$effect,
    data: {}
};



function $277f19ac62a605a6$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $bd61b37a2183c69a$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $af8222ebbcb9a186$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $e69c30dd2059ddce$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $7cbbe4209b3cf823$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $7cbbe4209b3cf823$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $af8222ebbcb9a186$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $7cbbe4209b3cf823$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $7cbbe4209b3cf823$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $338483cf90cc1aa3$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e69c30dd2059ddce$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $338483cf90cc1aa3$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $338483cf90cc1aa3$var$popperOffsets,
    data: {}
};










var $e47a37ccc424bfe9$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $e47a37ccc424bfe9$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3b9cfba22cfc5efc$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $e47a37ccc424bfe9$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4);
    var sideY = (0, $7cbbe4209b3cf823$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5566429e991d71d1$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $65079d2557eeec19$export$2e2bcd8739ae039)(popper);
            if ((0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $7cbbe4209b3cf823$export$1e95b668f3b82d) || (placement === (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4) || placement === (0, $7cbbe4209b3cf823$export$79ffe56a765070d2)) && variation === (0, $7cbbe4209b3cf823$export$bd5df0f255a350f8)) {
            sideY = (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4) || (placement === (0, $7cbbe4209b3cf823$export$1e95b668f3b82d) || placement === (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb)) && variation === (0, $7cbbe4209b3cf823$export$bd5df0f255a350f8)) {
            sideX = (0, $7cbbe4209b3cf823$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $e47a37ccc424bfe9$var$unsetSides);
    var _ref4 = roundOffsets === true ? $e47a37ccc424bfe9$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $e47a37ccc424bfe9$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $e47a37ccc424bfe9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $e47a37ccc424bfe9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e47a37ccc424bfe9$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $e47a37ccc424bfe9$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $b616a03c294d5b4b$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element) || !(0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $b616a03c294d5b4b$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element) || !(0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b616a03c294d5b4b$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $b616a03c294d5b4b$var$applyStyles,
    effect: $b616a03c294d5b4b$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $cc8baf1bc9b9ac65$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4),
        (0, $7cbbe4209b3cf823$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4),
        (0, $7cbbe4209b3cf823$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $cc8baf1bc9b9ac65$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $7cbbe4209b3cf823$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $cc8baf1bc9b9ac65$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cc8baf1bc9b9ac65$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $cc8baf1bc9b9ac65$var$offset
};


var $aaf71a747cf1c3c5$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaf71a747cf1c3c5$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaf71a747cf1c3c5$var$hash[matched];
    });
}



var $107f5fa9895994ab$var$hash = {
    start: "end",
    end: "start"
};
function $107f5fa9895994ab$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $107f5fa9895994ab$var$hash[matched];
    });
}







function $d6289857b2809107$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e0677a97a4b82dde$export$2e2bcd8739ae039)(element);
    var html = (0, $65079d2557eeec19$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $1ea9551f9b5caa45$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5d830c6a66d53fc9$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $bbee548e322a5ce3$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $65079d2557eeec19$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $72dfd4792923f202$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5d830c6a66d53fc9$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d660cbd52bf4d9fa$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $cca8fc0d6c05a54b$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b5f5029508423266$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $25de21c6f6bf8d6e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $82e1450554903243$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $25de21c6f6bf8d6e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $7cbbe4209b3cf823$export$d7b7311ec04a3e8f) ? (0, $b5f5029508423266$export$2e2bcd8739ae039)((0, $d6289857b2809107$export$2e2bcd8739ae039)(element, strategy)) : (0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(clippingParent) ? $25de21c6f6bf8d6e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b5f5029508423266$export$2e2bcd8739ae039)((0, $bbee548e322a5ce3$export$2e2bcd8739ae039)((0, $65079d2557eeec19$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $25de21c6f6bf8d6e$var$getClippingParents(element) {
    var clippingParents = (0, $ae5f4dd435d0a058$export$2e2bcd8739ae039)((0, $867aa902f08d11d6$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $bb00208fe1e6a718$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $cca8fc0d6c05a54b$export$1b3bfaa9684536aa)(element) ? (0, $5566429e991d71d1$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d660cbd52bf4d9fa$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $a0a5ed2473c57006$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $25de21c6f6bf8d6e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $25de21c6f6bf8d6e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $25de21c6f6bf8d6e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3b9cfba22cfc5efc$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3b9cfba22cfc5efc$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $25de21c6f6bf8d6e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b96a7130390d5948$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $7d77b3b2d7443a9d$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $b96a7130390d5948$export$2e2bcd8739ae039)(), paddingObject);
}


function $5f7f798b389f4db2$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $05923f4e29260ba2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $7cbbe4209b3cf823$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $7cbbe4209b3cf823$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $7cbbe4209b3cf823$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $7d77b3b2d7443a9d$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $5f7f798b389f4db2$export$2e2bcd8739ae039)(padding, (0, $7cbbe4209b3cf823$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $7cbbe4209b3cf823$export$ae5ab1c730825774) ? (0, $7cbbe4209b3cf823$export$ca50aac9f3ba507f) : (0, $7cbbe4209b3cf823$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $25de21c6f6bf8d6e$export$2e2bcd8739ae039)((0, $cca8fc0d6c05a54b$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $65079d2557eeec19$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $82e1450554903243$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $e69c30dd2059ddce$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b5f5029508423266$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $7cbbe4209b3cf823$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $7cbbe4209b3cf823$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $7cbbe4209b3cf823$export$79ffe56a765070d2),
                (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $7cbbe4209b3cf823$export$1e95b668f3b82d),
                (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b0be558d10533088$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $7cbbe4209b3cf823$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $7cbbe4209b3cf823$export$368f9a87e87fa4e1) : (0, $7cbbe4209b3cf823$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $7cbbe4209b3cf823$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $05923f4e29260ba2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $0a0b2e5cdfe80872$var$getExpandedFallbackPlacements(placement) {
    if ((0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement) === (0, $7cbbe4209b3cf823$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaf71a747cf1c3c5$export$2e2bcd8739ae039)(placement);
    return [
        (0, $107f5fa9895994ab$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $107f5fa9895994ab$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $0a0b2e5cdfe80872$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaf71a747cf1c3c5$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $0a0b2e5cdfe80872$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement) === (0, $7cbbe4209b3cf823$export$dfb5619354ba860) ? (0, $b0be558d10533088$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(placement) === (0, $7cbbe4209b3cf823$export$b3571188c770cc5a);
        var isVertical = [
            (0, $7cbbe4209b3cf823$export$1e95b668f3b82d),
            (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $05923f4e29260ba2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $7cbbe4209b3cf823$export$79ffe56a765070d2) : (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb) : (0, $7cbbe4209b3cf823$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaf71a747cf1c3c5$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaf71a747cf1c3c5$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $0a0b2e5cdfe80872$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $0a0b2e5cdfe80872$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $d28be6493ce65a88$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $20e60f6a912bb215$export$f28d906d67a997f3(min, value, max) {
    return (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(min, (0, $3b9cfba22cfc5efc$export$96ec731ed4dcb222)(value, max));
}
function $20e60f6a912bb215$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $20e60f6a912bb215$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $9e5e71ae0bd7c0ab$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $05923f4e29260ba2$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bd61b37a2183c69a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $af8222ebbcb9a186$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d28be6493ce65a88$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $7cbbe4209b3cf823$export$1e95b668f3b82d) : (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb) : (0, $7cbbe4209b3cf823$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $7cbbe4209b3cf823$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $7cbbe4209b3cf823$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c8681ef26237bdd3$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $b96a7130390d5948$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $20e60f6a912bb215$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5566429e991d71d1$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $20e60f6a912bb215$export$f28d906d67a997f3)(tether ? (0, $3b9cfba22cfc5efc$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3b9cfba22cfc5efc$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $7cbbe4209b3cf823$export$1e95b668f3b82d) : (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb) : (0, $7cbbe4209b3cf823$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $7cbbe4209b3cf823$export$1e95b668f3b82d),
            (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $20e60f6a912bb215$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $20e60f6a912bb215$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9e5e71ae0bd7c0ab$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $9e5e71ae0bd7c0ab$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $50729cdbe148a942$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $7d77b3b2d7443a9d$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $5f7f798b389f4db2$export$2e2bcd8739ae039)(padding, (0, $7cbbe4209b3cf823$export$aec2ce47c367b8c3)));
};
function $50729cdbe148a942$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $277f19ac62a605a6$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $af8222ebbcb9a186$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4),
        (0, $7cbbe4209b3cf823$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $50729cdbe148a942$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c8681ef26237bdd3$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $7cbbe4209b3cf823$export$1e95b668f3b82d) : (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb) : (0, $7cbbe4209b3cf823$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5566429e991d71d1$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $20e60f6a912bb215$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $50729cdbe148a942$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d660cbd52bf4d9fa$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $50729cdbe148a942$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $50729cdbe148a942$var$arrow,
    effect: $50729cdbe148a942$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $2be833b1b9cbde42$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2be833b1b9cbde42$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $7cbbe4209b3cf823$export$1e95b668f3b82d),
        (0, $7cbbe4209b3cf823$export$79ffe56a765070d2),
        (0, $7cbbe4209b3cf823$export$40e543e69a8b3fbb),
        (0, $7cbbe4209b3cf823$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2be833b1b9cbde42$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $05923f4e29260ba2$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $05923f4e29260ba2$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2be833b1b9cbde42$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2be833b1b9cbde42$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2be833b1b9cbde42$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2be833b1b9cbde42$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2be833b1b9cbde42$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $2be833b1b9cbde42$var$hide
};




var $0abaddc5196bc3c9$export$d34966752335dd47 = [
    (0, $a6959ae4a0aedc8b$export$2e2bcd8739ae039),
    (0, $338483cf90cc1aa3$export$2e2bcd8739ae039),
    (0, $e47a37ccc424bfe9$export$2e2bcd8739ae039),
    (0, $b616a03c294d5b4b$export$2e2bcd8739ae039),
    (0, $cc8baf1bc9b9ac65$export$2e2bcd8739ae039),
    (0, $0a0b2e5cdfe80872$export$2e2bcd8739ae039),
    (0, $9e5e71ae0bd7c0ab$export$2e2bcd8739ae039),
    (0, $50729cdbe148a942$export$2e2bcd8739ae039),
    (0, $2be833b1b9cbde42$export$2e2bcd8739ae039)
];
var $0abaddc5196bc3c9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $c199a11bfd96e76a$export$ed5e13716264f202)({
    defaultModifiers: $0abaddc5196bc3c9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $2wgr3 = parcelRequire("2wgr3");


var $8iNDC = parcelRequire("8iNDC");
const $8be08575d49a3d6a$var$GLOBAL_CLASS_PREFIX = "base";
function $8be08575d49a3d6a$var$buildStateClass(state) {
    return `${$8be08575d49a3d6a$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $8be08575d49a3d6a$var$buildSlotClass(componentName, slot) {
    return `${$8be08575d49a3d6a$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $8be08575d49a3d6a$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $8iNDC.globalStateClasses)[slot];
    return globalStateClass ? $8be08575d49a3d6a$var$buildStateClass(globalStateClass) : $8be08575d49a3d6a$var$buildSlotClass(componentName, slot);
}
function $8be08575d49a3d6a$export$34c0130b1f3e8ae3(slot) {
    return (0, $8iNDC.globalStateClasses)[slot] !== undefined;
}



function $e3cda9d7fcff4df4$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $8be08575d49a3d6a$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $72f5b6d53523ac7d$var$COMPONENT_NAME = "Popper";
function $72f5b6d53523ac7d$export$1b69b6cd0fa638a1(slot) {
    return (0, $8be08575d49a3d6a$export$1d132570e11858b0)($72f5b6d53523ac7d$var$COMPONENT_NAME, slot);
}
const $72f5b6d53523ac7d$export$b6aa214021e734b0 = (0, $e3cda9d7fcff4df4$export$de4f15803c389669)($72f5b6d53523ac7d$var$COMPONENT_NAME, [
    "root"
]);




var $dup7A = parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $b87ccd577176029c$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $b87ccd577176029c$var$ClassNameConfiguratorContext = /*#__PURE__*/ $dup7A.createContext($b87ccd577176029c$var$defaultContextValue);
function $b87ccd577176029c$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $dup7A.useContext($b87ccd577176029c$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $b87ccd577176029c$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $dup7A.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($b87ccd577176029c$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $4f2d8cc3ca1e62c3$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $4f2d8cc3ca1e62c3$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $4f2d8cc3ca1e62c3$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $4f2d8cc3ca1e62c3$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $4f2d8cc3ca1e62c3$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $4f2d8cc3ca1e62c3$var$isVirtualElement(element) {
    return !$4f2d8cc3ca1e62c3$var$isHTMLElement(element);
}
const $4f2d8cc3ca1e62c3$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $b87ccd577176029c$export$b0f7603cd2f9ee15)((0, $72f5b6d53523ac7d$export$1b69b6cd0fa638a1)));
};
const $4f2d8cc3ca1e62c3$var$defaultPopperOptions = {};
const $4f2d8cc3ca1e62c3$var$PopperTooltip = /*#__PURE__*/ $dup7A.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $bGxpK.default)(props, $4f2d8cc3ca1e62c3$var$_excluded);
    const tooltipRef = $dup7A.useRef(null);
    const ownRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $dup7A.useRef(null);
    const handlePopperRef = (0, $ed0adf8303ed21e1$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $dup7A.useRef(handlePopperRef);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $dup7A.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $4f2d8cc3ca1e62c3$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $dup7A.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $dup7A.useState($4f2d8cc3ca1e62c3$var$resolveAnchorEl(anchorEl));
    $dup7A.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $dup7A.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($4f2d8cc3ca1e62c3$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $6db36b98959a73d4$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $0abaddc5196bc3c9$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $3G4eg.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $4f2d8cc3ca1e62c3$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)(Root, (0, $3G4eg.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $4f2d8cc3ca1e62c3$export$badac9ada3a0bdf9 = /*#__PURE__*/ $dup7A.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $4f2d8cc3ca1e62c3$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $bGxpK.default)(props, $4f2d8cc3ca1e62c3$var$_excluded2);
    const [exited, setExited] = $dup7A.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $4f2d8cc3ca1e62c3$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $4f2d8cc3ca1e62c3$var$isHTMLElement(resolvedAnchorEl) ? (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $c6658e3849b4f86d$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $bf1b7d92504c6f51$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($4f2d8cc3ca1e62c3$var$PopperTooltip, (0, $3G4eg.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $3G4eg.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});


var $ace57a9cdf5e76f4$exports = {};
"use strict";
"use client";
Object.defineProperty($ace57a9cdf5e76f4$exports, "__esModule", {
    value: true
});
$ace57a9cdf5e76f4$exports.default = void 0;

var $ace57a9cdf5e76f4$var$React = $ace57a9cdf5e76f4$var$_interopRequireWildcard((parcelRequire("dup7A")));
parcelRequire("8eVik");
var $42TgP = parcelRequire("42TgP");
function $ace57a9cdf5e76f4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ace57a9cdf5e76f4$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ace57a9cdf5e76f4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ace57a9cdf5e76f4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $ace57a9cdf5e76f4$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $ace57a9cdf5e76f4$var$useTheme(defaultTheme = null) {
    const contextTheme = $ace57a9cdf5e76f4$var$React.useContext($42TgP.T);
    return !contextTheme || $ace57a9cdf5e76f4$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $ace57a9cdf5e76f4$var$_default = $ace57a9cdf5e76f4$exports.default = $ace57a9cdf5e76f4$var$useTheme;






var $dup7A = parcelRequire("dup7A");

var $jjHhy = parcelRequire("jjHhy");
var $7ZufN = parcelRequire("7ZufN");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $758c97659b8db72c$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $758c97659b8db72c$var$PopperRoot = (0, $jjHhy.default)((0, $4f2d8cc3ca1e62c3$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $758c97659b8db72c$var$Popper = /*#__PURE__*/ $dup7A.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($ace57a9cdf5e76f4$exports)))();
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $bGxpK.default)(props, $758c97659b8db72c$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $3G4eg.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($758c97659b8db72c$var$PopperRoot, (0, $3G4eg.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $758c97659b8db72c$export$2e2bcd8739ae039 = $758c97659b8db72c$var$Popper;





"use client";
var $59e5b3c850bbdd15$export$2e2bcd8739ae039 = (0, $3f196c06f251b8ff$export$2e2bcd8739ae039);





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $0e11eda5b8525704$export$837848f5f6cee923(slot) {
    return (0, $8iNDC.default)("MuiTooltip", slot);
}
const $0e11eda5b8525704$var$tooltipClasses = (0, $fc1pF.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $0e11eda5b8525704$export$2e2bcd8739ae039 = $0e11eda5b8525704$var$tooltipClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $fd8b0c9730d4163c$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $fd8b0c9730d4163c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $fd8b0c9730d4163c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $4y4xl.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $0e11eda5b8525704$export$837848f5f6cee923), classes);
};
const $fd8b0c9730d4163c$var$TooltipPopper = (0, $jjHhy.default)((0, $758c97659b8db72c$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $3G4eg.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).arrow}`]: (0, $3G4eg.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).arrow}`]: (0, $3G4eg.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $fd8b0c9730d4163c$var$TooltipTooltip = (0, $jjHhy.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $4y4xl.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $emmvO.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$fd8b0c9730d4163c$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $3G4eg.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $3G4eg.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $3G4eg.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $3G4eg.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $3G4eg.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $3G4eg.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $3G4eg.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $0e11eda5b8525704$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $3G4eg.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $fd8b0c9730d4163c$var$TooltipArrow = (0, $jjHhy.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $emmvO.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $fd8b0c9730d4163c$var$hystersisOpen = false;
const $fd8b0c9730d4163c$var$hystersisTimer = new (0, $625a659d3ca757bf$export$786b4da70f00938b)();
let $fd8b0c9730d4163c$var$cursorPosition = {
    x: 0,
    y: 0
};
function $fd8b0c9730d4163c$export$b9ee5a7ace0541f8() {
    $fd8b0c9730d4163c$var$hystersisOpen = false;
    $fd8b0c9730d4163c$var$hystersisTimer.clear();
}
function $fd8b0c9730d4163c$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $fd8b0c9730d4163c$var$Tooltip = /*#__PURE__*/ $dup7A.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $651a53450047d63f$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $bGxpK.default)(props, $fd8b0c9730d4163c$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $dup7A.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const isRtl = (0, $3397d1bce61a3d2d$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $dup7A.useState();
    const [arrowRef, setArrowRef] = $dup7A.useState(null);
    const ignoreNonTouchEvents = $dup7A.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const enterTimer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const touchTimer = (0, $625a659d3ca757bf$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $c3c9d27e53aed175$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $59e5b3c850bbdd15$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $dup7A.useRef();
    const stopTouchInteraction = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $dup7A.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $fd8b0c9730d4163c$var$hystersisTimer.clear();
        $fd8b0c9730d4163c$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $fd8b0c9730d4163c$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $fd8b0c9730d4163c$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $fd8b0c9730d4163c$var$hystersisOpen && enterNextDelay) enterTimer.start($fd8b0c9730d4163c$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $e1af0238f772e7e3$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $dup7A.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $dup7A.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $dup7A.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $fd8b0c9730d4163c$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $3G4eg.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $aJAJS.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $fd8b0c9730d4163c$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $fd8b0c9730d4163c$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $fd8b0c9730d4163c$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $fd8b0c9730d4163c$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $dup7A.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $3G4eg.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $fd8b0c9730d4163c$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $fd8b0c9730d4163c$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $651a53450047d63f$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $fd8b0c9730d4163c$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $fd8b0c9730d4163c$var$TooltipArrow;
    const popperProps = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(PopperComponent, (0, $3G4eg.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $aJAJS.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(TransitionComponent, (0, $3G4eg.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(TooltipComponent, (0, $3G4eg.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $aJAJS.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $cadb5b489f8b66d9$export$b089efb01a7bdf50)(ArrowComponent, (0, $3G4eg.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $aJAJS.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ $dup7A.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $cZGFG.jsx)(PopperComponent, (0, $3G4eg.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $758c97659b8db72c$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $fd8b0c9730d4163c$var$cursorPosition.y,
                            left: $fd8b0c9730d4163c$var$cursorPosition.x,
                            right: $fd8b0c9730d4163c$var$cursorPosition.x,
                            bottom: $fd8b0c9730d4163c$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $cZGFG.jsxs)(TooltipComponent, (0, $3G4eg.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $cZGFG.jsx)(ArrowComponent, (0, $3G4eg.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $fd8b0c9730d4163c$export$2e2bcd8739ae039 = $fd8b0c9730d4163c$var$Tooltip;



var $dup7A = parcelRequire("dup7A");

const $eb12012bc6102ab5$var$getProgressValue = (updatedAt, timeToUpdate)=>updatedAt ? Math.min(100, (Date.now() - updatedAt) / timeToUpdate * 100) : 0;
const $eb12012bc6102ab5$var$getSecondsToUpdate = (updatedAt, timeToUpdate)=>Math.max(Math.round((timeToUpdate - (Date.now() - updatedAt)) / 1000), 0);
const $eb12012bc6102ab5$export$9ff79255ead4ffb5 = ({ updatedAt: updatedAt, timeToUpdate: timeToUpdate, isLoading: isLoading, onClick: onClick, ...other })=>{
    const [value, setValue] = (0, $dup7A.useState)(()=>$eb12012bc6102ab5$var$getProgressValue(updatedAt, timeToUpdate));
    (0, $dup7A.useEffect)(()=>{
        setValue($eb12012bc6102ab5$var$getProgressValue(updatedAt, timeToUpdate));
        const id = setInterval(()=>{
            const time = $eb12012bc6102ab5$var$getProgressValue(updatedAt, timeToUpdate);
            setValue(time);
            if (time >= 100) clearInterval(id);
        }, 1000);
        return ()=>clearInterval(id);
    }, [
        timeToUpdate,
        updatedAt
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (isLoading) setValue(0);
    }, [
        isLoading
    ]);
    return (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
        onClick: onClick,
        disabled: isLoading,
        ...other,
        children: (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
            title: (0, $cZGFG.jsx)((0, $2fb7372348de61af$export$8d6a9236f2e3f2ce), {
                i18nKey: "tooltip.progressToNextUpdate",
                values: {
                    value: $eb12012bc6102ab5$var$getSecondsToUpdate(updatedAt, timeToUpdate)
                },
                components: [
                    (0, $cZGFG.jsx)("br", {})
                ]
            }),
            placement: "top",
            enterDelay: 400,
            arrow: true,
            children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "grid",
                    position: "relative",
                    placeItems: "center",
                    width: 24,
                    height: 24
                },
                children: [
                    (0, $cZGFG.jsx)((0, $65a11d953b0c04a5$export$2e2bcd8739ae039), {
                        variant: "determinate",
                        size: 24,
                        value: 100,
                        sx: (theme)=>({
                                position: "absolute",
                                color: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800]
                            })
                    }),
                    (0, $cZGFG.jsx)((0, $65a11d953b0c04a5$export$2e2bcd8739ae039), {
                        variant: isLoading ? "indeterminate" : "determinate",
                        size: 24,
                        value: value,
                        sx: (theme)=>({
                                opacity: value === 100 && !isLoading ? 0.5 : 1,
                                color: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light
                            })
                    })
                ]
            })
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $d6f937c21a39d4f3$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($d6f937c21a39d4f3$exports, "__esModule", {
    value: true
});
$d6f937c21a39d4f3$exports.default = void 0;

var $d6f937c21a39d4f3$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $d6f937c21a39d4f3$var$_default = $d6f937c21a39d4f3$exports.default = (0, $d6f937c21a39d4f3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");


var $4d3a704b8b3b6f33$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($4d3a704b8b3b6f33$exports, "__esModule", {
    value: true
});
$4d3a704b8b3b6f33$exports.default = void 0;

var $4d3a704b8b3b6f33$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $4d3a704b8b3b6f33$var$_default = $4d3a704b8b3b6f33$exports.default = (0, $4d3a704b8b3b6f33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");


var $f7e0ba82d268b078$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($f7e0ba82d268b078$exports, "__esModule", {
    value: true
});
$f7e0ba82d268b078$exports.default = void 0;

var $f7e0ba82d268b078$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $f7e0ba82d268b078$var$_default = $f7e0ba82d268b078$exports.default = (0, $f7e0ba82d268b078$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z"
}), "VerifiedUser");




var $dup7A = parcelRequire("dup7A");





var $jjHhy = parcelRequire("jjHhy");
const $1cb427f767e9e062$export$a03b0ac28c7e34b8 = (0, $jjHhy.default)((0, $510dba830cc31c9a$export$2e2bcd8739ae039))(({ theme: theme })=>{
    const backgroundColor = theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white;
    return {
        padding: theme.spacing(0.5),
        backgroundColor: (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(backgroundColor, 0.04),
        "&:hover": {
            backgroundColor: (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(backgroundColor, 0.08)
        }
    };
});



var $jjHhy = parcelRequire("jjHhy");
const $987da2744be1b393$export$e13aaac4037b0914 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "type"
})(({ theme: theme, type: type })=>({
        backgroundColor: type === "active" ? theme.palette.mode === "light" ? theme.palette.secondary.main : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.secondary.main, 0.32) : type?.includes("insurance") ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.success.main, theme.palette.mode === "light" ? 0.12 : 0.24) : theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.12) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.16),
        borderRadius: theme.shape.borderRadius,
        color: type?.includes("insurance") ? (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(theme.palette.success.main, theme.palette.mode === "light" ? 0 : 0.24) : theme.palette.text.primary,
        padding: type === "insurance" ? theme.spacing(0, 1.5) : 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 24,
        minWidth: 24,
        userSelect: "none",
        fontSize: "1rem",
        marginRight: theme.spacing(1)
    }));
const $987da2744be1b393$export$2eaa1bdbba29c923 = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "type"
})(({ theme: theme, type: type })=>({
        padding: type === "icon" ? theme.spacing(0.75, 0, 0.75, 0.75) : theme.spacing(0.75, 1.5),
        fontSize: 12,
        lineHeight: 1,
        fontWeight: "600",
        textTransform: "lowercase",
        "&::first-letter": {
            textTransform: "uppercase"
        }
    }));



var $cZGFG = parcelRequire("cZGFG");




var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $dup7A = parcelRequire("dup7A");
/**
 * Provides information about the current step in Stepper.
 */ const $4249de673b5c8f78$var$StepperContext = /*#__PURE__*/ $dup7A.createContext({});
function $4249de673b5c8f78$export$1ff9b16b13b0447() {
    return $dup7A.useContext($4249de673b5c8f78$var$StepperContext);
}
var $4249de673b5c8f78$export$2e2bcd8739ae039 = $4249de673b5c8f78$var$StepperContext;



var $dup7A = parcelRequire("dup7A");
/**
 * Provides information about the current step in Stepper.
 */ const $40e8c053a769a357$var$StepContext = /*#__PURE__*/ $dup7A.createContext({});
function $40e8c053a769a357$export$90d5f24cfecec416() {
    return $dup7A.useContext($40e8c053a769a357$var$StepContext);
}
var $40e8c053a769a357$export$2e2bcd8739ae039 = $40e8c053a769a357$var$StepContext;



var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $15ce1f4d38741f15$export$8977e0f3c012cfac(slot) {
    return (0, $8iNDC.default)("MuiStep", slot);
}
const $15ce1f4d38741f15$var$stepClasses = (0, $fc1pF.default)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
var $15ce1f4d38741f15$export$2e2bcd8739ae039 = $15ce1f4d38741f15$var$stepClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $e2bc52c707326083$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $e2bc52c707326083$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $15ce1f4d38741f15$export$8977e0f3c012cfac), classes);
};
const $e2bc52c707326083$var$StepRoot = (0, $jjHhy.default)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    }));
const $e2bc52c707326083$var$Step = /*#__PURE__*/ $dup7A.forwardRef(function Step(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStep"
    });
    const { active: activeProp, children: children, className: className, component: component = "div", completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $bGxpK.default)(props, $e2bc52c707326083$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $dup7A.useContext((0, $4249de673b5c8f78$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $dup7A.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $e2bc52c707326083$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $cZGFG.jsxs)($e2bc52c707326083$var$StepRoot, (0, $3G4eg.default)({
        as: component,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $40e8c053a769a357$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $e2bc52c707326083$export$2e2bcd8739ae039 = $e2bc52c707326083$var$Step;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $afd7a3040490b3f2$export$797947b6292e28e1(slot) {
    return (0, $8iNDC.default)("MuiStepper", slot);
}
const $afd7a3040490b3f2$var$stepperClasses = (0, $fc1pF.default)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
var $afd7a3040490b3f2$export$2e2bcd8739ae039 = $afd7a3040490b3f2$var$stepperClasses;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $af3745c9329fd167$export$6fbaff484b0d9308(slot) {
    return (0, $8iNDC.default)("MuiStepConnector", slot);
}
const $af3745c9329fd167$var$stepConnectorClasses = (0, $fc1pF.default)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
var $af3745c9329fd167$export$2e2bcd8739ae039 = $af3745c9329fd167$var$stepConnectorClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $92e209989adcbf29$var$_excluded = [
    "className"
];
const $92e209989adcbf29$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            `line${(0, $4y4xl.default)(orientation)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $af3745c9329fd167$export$6fbaff484b0d9308), classes);
};
const $92e209989adcbf29$var$StepConnectorRoot = (0, $jjHhy.default)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    }));
const $92e209989adcbf29$var$StepConnectorLine = (0, $jjHhy.default)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $4y4xl.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $3G4eg.default)({
        display: "block",
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $92e209989adcbf29$var$StepConnector = /*#__PURE__*/ $dup7A.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStepConnector"
    });
    const { className: className } = props, other = (0, $bGxpK.default)(props, $92e209989adcbf29$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = "horizontal" } = $dup7A.useContext((0, $4249de673b5c8f78$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $dup7A.useContext((0, $40e8c053a769a357$export$2e2bcd8739ae039));
    const ownerState = (0, $3G4eg.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $92e209989adcbf29$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($92e209989adcbf29$var$StepConnectorRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($92e209989adcbf29$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $92e209989adcbf29$export$2e2bcd8739ae039 = $92e209989adcbf29$var$StepConnector;




var $cZGFG = parcelRequire("cZGFG");
"use client";
const $e4c579a3d03aa3ea$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $e4c579a3d03aa3ea$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $afd7a3040490b3f2$export$797947b6292e28e1), classes);
};
const $e4c579a3d03aa3ea$var$StepperRoot = (0, $jjHhy.default)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    }));
const $e4c579a3d03aa3ea$var$defaultConnector = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $92e209989adcbf29$export$2e2bcd8739ae039), {});
const $e4c579a3d03aa3ea$var$Stepper = /*#__PURE__*/ $dup7A.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStepper"
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = "div", connector: connector = $e4c579a3d03aa3ea$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = "horizontal" } = props, other = (0, $bGxpK.default)(props, $e4c579a3d03aa3ea$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $e4c579a3d03aa3ea$var$useUtilityClasses(ownerState);
    const childrenArray = $dup7A.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $dup7A.cloneElement(step, (0, $3G4eg.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $dup7A.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $4249de673b5c8f78$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($e4c579a3d03aa3ea$var$StepperRoot, (0, $3G4eg.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aJAJS.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $e4c579a3d03aa3ea$export$2e2bcd8739ae039 = $e4c579a3d03aa3ea$var$Stepper;




var $dup7A = parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
const $d515ed01e031b861$export$cde918c6510c99b6 = (props)=>(0, $cZGFG.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $cZGFG.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#F5B5FF"
            }),
            (0, $cZGFG.jsx)("path", {
                d: "M15.5031 19.2031L10.1691 20.4379C9.97453 20.4867 9.82861 20.6816 9.82861 20.8766V24.5486C9.82861 24.8573 10.0718 25.0523 10.3798 24.9873L17.8215 23.265C18.1296 23.2 18.2593 22.9076 18.1296 22.6314L16.7839 19.853C16.5731 19.4143 16.7839 18.9594 17.2541 18.8619L22.1179 17.692C22.4584 17.6108 22.7502 17.2534 22.7502 16.8959V13.5001C22.7502 13.1914 22.507 12.9802 22.199 13.0614L15.1788 14.735C14.7411 14.8324 14.5465 15.2549 14.7411 15.6611L15.9733 18.212C16.184 18.6507 15.9733 19.0893 15.5031 19.2031Z",
                fill: "black"
            }),
            (0, $cZGFG.jsx)("path", {
                d: "M11.985 10.0233L13.3793 12.8829C13.5577 13.2566 13.3793 13.6466 12.974 13.7278L10.3962 14.329C10.0719 14.4102 9.8125 14.7352 9.8125 15.0601V18.1309C9.8125 18.6509 10.234 18.9758 10.7366 18.8621L13.1361 18.3097C13.4604 18.2447 13.7198 17.9035 13.7198 17.5785L13.736 14.4265C13.736 13.9878 14.0927 13.5491 14.5142 13.4516L22.3774 11.5669C22.572 11.5181 22.7179 11.3231 22.7179 11.1282V7.45618C22.7179 7.14747 22.4747 6.93625 22.1666 7.01749L12.2931 9.38966C11.985 9.45465 11.8553 9.74711 11.985 10.0233Z",
                fill: "black"
            })
        ]
    });







var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $ca5509f84c934516$export$2a65e9f482ac3350(slot) {
    return (0, $8iNDC.default)("MuiStepContent", slot);
}
const $ca5509f84c934516$var$stepContentClasses = (0, $fc1pF.default)("MuiStepContent", [
    "root",
    "last",
    "transition"
]);
var $ca5509f84c934516$export$2e2bcd8739ae039 = $ca5509f84c934516$var$stepContentClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $29f21dda307591f3$var$_excluded = [
    "children",
    "className",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $29f21dda307591f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, last: last } = ownerState;
    const slots = {
        root: [
            "root",
            last && "last"
        ],
        transition: [
            "transition"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $ca5509f84c934516$export$2a65e9f482ac3350), classes);
};
const $29f21dda307591f3$var$StepContentRoot = (0, $jjHhy.default)("div", {
    name: "MuiStepContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.last && styles.last
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        marginLeft: 12,
        // half icon
        paddingLeft: 20,
        // margin + half icon
        paddingRight: 8,
        borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]}`
    }, ownerState.last && {
        borderLeft: "none"
    }));
const $29f21dda307591f3$var$StepContentTransition = (0, $jjHhy.default)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
    name: "MuiStepContent",
    slot: "Transition",
    overridesResolver: (props, styles)=>styles.transition
})({});
const $29f21dda307591f3$var$StepContent = /*#__PURE__*/ $dup7A.forwardRef(function StepContent(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStepContent"
    });
    const { children: children, className: className, TransitionComponent: TransitionComponent = (0, $f6bd69894e5675e4$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: TransitionProps } = props, other = (0, $bGxpK.default)(props, $29f21dda307591f3$var$_excluded);
    const { orientation: orientation } = $dup7A.useContext((0, $4249de673b5c8f78$export$2e2bcd8739ae039));
    const { active: active, last: last, expanded: expanded } = $dup7A.useContext((0, $40e8c053a769a357$export$2e2bcd8739ae039));
    const ownerState = (0, $3G4eg.default)({}, props, {
        last: last
    });
    const classes = $29f21dda307591f3$var$useUtilityClasses(ownerState);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    return /*#__PURE__*/ (0, $cZGFG.jsx)($29f21dda307591f3$var$StepContentRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($29f21dda307591f3$var$StepContentTransition, (0, $3G4eg.default)({
            as: TransitionComponent,
            in: active || expanded,
            className: classes.transition,
            ownerState: ownerState,
            timeout: transitionDuration,
            unmountOnExit: true
        }, TransitionProps, {
            children: children
        }))
    }));
});
var $29f21dda307591f3$export$2e2bcd8739ae039 = $29f21dda307591f3$var$StepContent;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");
parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $56d80609f544f33d$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle");


parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $9d5807423ce92b5f$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");



var $cMinS = parcelRequire("cMinS");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $1e8933bcd51578dd$export$62a6e0748bec9297(slot) {
    return (0, $8iNDC.default)("MuiStepIcon", slot);
}
const $1e8933bcd51578dd$var$stepIconClasses = (0, $fc1pF.default)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
var $1e8933bcd51578dd$export$2e2bcd8739ae039 = $1e8933bcd51578dd$var$stepIconClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
var $d58fe3c7da19a320$var$_circle;
const $d58fe3c7da19a320$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $d58fe3c7da19a320$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $1e8933bcd51578dd$export$62a6e0748bec9297), classes);
};
const $d58fe3c7da19a320$var$StepIconRoot = (0, $jjHhy.default)((0, $cMinS.default), {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $1e8933bcd51578dd$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $1e8933bcd51578dd$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $1e8933bcd51578dd$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $d58fe3c7da19a320$var$StepIconText = (0, $jjHhy.default)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $d58fe3c7da19a320$var$StepIcon = /*#__PURE__*/ $dup7A.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStepIcon"
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $bGxpK.default)(props, $d58fe3c7da19a320$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $d58fe3c7da19a320$var$useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        const className = (0, $aJAJS.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $cZGFG.jsx)($d58fe3c7da19a320$var$StepIconRoot, (0, $3G4eg.default)({
            as: (0, $9d5807423ce92b5f$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $cZGFG.jsx)($d58fe3c7da19a320$var$StepIconRoot, (0, $3G4eg.default)({
            as: (0, $56d80609f544f33d$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $cZGFG.jsxs)($d58fe3c7da19a320$var$StepIconRoot, (0, $3G4eg.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $d58fe3c7da19a320$var$_circle || ($d58fe3c7da19a320$var$_circle = /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $cZGFG.jsx)($d58fe3c7da19a320$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $d58fe3c7da19a320$export$2e2bcd8739ae039 = $d58fe3c7da19a320$var$StepIcon;





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $88a2814c2d5b991e$export$9625a725551d158a(slot) {
    return (0, $8iNDC.default)("MuiStepLabel", slot);
}
const $88a2814c2d5b991e$var$stepLabelClasses = (0, $fc1pF.default)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
var $88a2814c2d5b991e$export$2e2bcd8739ae039 = $88a2814c2d5b991e$var$stepLabelClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $db2780e68942dc45$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $db2780e68942dc45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer",
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $88a2814c2d5b991e$export$9625a725551d158a), classes);
};
const $db2780e68942dc45$var$StepLabelRoot = (0, $jjHhy.default)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex",
        alignItems: "center",
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: "column"
        },
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    }));
const $db2780e68942dc45$var$StepLabelLabel = (0, $jjHhy.default)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $3G4eg.default)({}, theme.typography.body2, {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $db2780e68942dc45$var$StepLabelIconContainer = (0, $jjHhy.default)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8,
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $db2780e68942dc45$var$StepLabelLabelContainer = (0, $jjHhy.default)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: "100%",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: "center"
        }
    }));
const $db2780e68942dc45$var$StepLabel = /*#__PURE__*/ $dup7A.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiStepLabel"
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $bGxpK.default)(props, $db2780e68942dc45$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $dup7A.useContext((0, $4249de673b5c8f78$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $dup7A.useContext((0, $40e8c053a769a357$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $d58fe3c7da19a320$export$2e2bcd8739ae039);
    const ownerState = (0, $3G4eg.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $db2780e68942dc45$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($db2780e68942dc45$var$StepLabelRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $cZGFG.jsx)($db2780e68942dc45$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $cZGFG.jsx)(StepIconComponent, (0, $3G4eg.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $cZGFG.jsxs)($db2780e68942dc45$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $cZGFG.jsx)($db2780e68942dc45$var$StepLabelLabel, (0, $3G4eg.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $aJAJS.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$db2780e68942dc45$var$StepLabel.muiName = "StepLabel";
var $db2780e68942dc45$export$2e2bcd8739ae039 = $db2780e68942dc45$var$StepLabel;






var $jjHhy = parcelRequire("jjHhy");
const $18ecadc8fe7863a0$export$ae755fb12761fec1 = (0, $jjHhy.default)("span", {
    shouldForwardProp: (prop)=>![
            "active",
            "completed",
            "error"
        ].includes(prop)
})(({ theme: theme })=>({
        width: 12,
        height: 12,
        borderRadius: "50%",
        border: `2px solid ${theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800]}`
    }));
const $18ecadc8fe7863a0$export$4a156f5690e82b42 = (0, $jjHhy.default)((0, $92e209989adcbf29$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "active",
            "completed",
            "error"
        ].includes(prop)
})(({ theme: theme })=>({
        marginLeft: theme.spacing(1.875),
        [`.${(0, $af3745c9329fd167$export$2e2bcd8739ae039).line}`]: {
            minHeight: 8,
            borderLeftWidth: 2,
            borderColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800]
        }
    }));
const $18ecadc8fe7863a0$export$64aa61b1ef03133 = (0, $jjHhy.default)((0, $db2780e68942dc45$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "active",
            "completed",
            "error",
            "disabled"
        ].includes(prop)
})(({ theme: theme })=>({
        padding: 0,
        [`.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).iconContainer}`]: {
            paddingLeft: theme.spacing(0.75),
            paddingRight: theme.spacing(2.75)
        },
        [`&.${(0, $88a2814c2d5b991e$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "inherit"
        }
    }));
const $18ecadc8fe7863a0$export$2aebd25fada42a64 = (0, $jjHhy.default)((0, $29f21dda307591f3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "active",
            "completed",
            "error"
        ].includes(prop)
})(({ theme: theme })=>({
        borderLeft: `2px solid ${theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800]}`,
        marginLeft: theme.spacing(1.875),
        paddingLeft: theme.spacing(3.875),
        [`&.${(0, $ca5509f84c934516$export$2e2bcd8739ae039).last}`]: {
            borderLeft: "none",
            paddingLeft: theme.spacing(4.1875)
        }
    }));
const $18ecadc8fe7863a0$export$8df9bd51904b879b = (0, $jjHhy.default)((0, $585ddd894619170d$export$2e2bcd8739ae039))(({ theme: theme, variant: variant })=>({
        color: theme.palette.text.primary,
        backgroundColor: "transparent"
    }));


const $9e46d9a23b4027f5$export$f5a9677241e3f131 = ({ step: step, dense: dense, ...other })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [cardExpanded, setCardExpanded] = (0, $dup7A.useState)(false);
    const handleExpand = (e)=>{
        e.stopPropagation();
        setCardExpanded((expanded)=>!expanded);
    };
    const hasCollapsedSteps = dense && step.includedSteps?.length > 1;
    // FIXME: step transaction request overrides step tool details, but not included step tool details
    const toolDetails = subvariant === "nft" ? step.includedSteps.find((step)=>step.tool === "custom" && step.toolDetails.key !== "custom")?.toolDetails || step.toolDetails : step.toolDetails;
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        ...other,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                children: [
                    (0, $cZGFG.jsx)((0, $63d882d7181c3b8b$export$2e2bcd8739ae039), {
                        overlap: "circular",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        badgeContent: (0, $cZGFG.jsx)((0, $27f4d60427bfd654$export$adf59ad56eeb21a2), {
                            children: (0, $cZGFG.jsx)((0, $d515ed01e031b861$export$cde918c6510c99b6), {})
                        }),
                        children: (0, $cZGFG.jsx)((0, $18ecadc8fe7863a0$export$8df9bd51904b879b), {
                            variant: "circular",
                            src: toolDetails.logoURI,
                            alt: toolDetails.name,
                            children: toolDetails.name[0]
                        })
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        ml: 2,
                        fontSize: 18,
                        fontWeight: "500",
                        flex: 1,
                        children: t(`main.stepDetails`, {
                            tool: toolDetails.name
                        })
                    }),
                    hasCollapsedSteps ? (0, $cZGFG.jsx)((0, $1cb427f767e9e062$export$a03b0ac28c7e34b8), {
                        onClick: handleExpand,
                        size: "small",
                        children: cardExpanded ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6f937c21a39d4f3$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4d3a704b8b3b6f33$exports))), {})
                    }) : null
                ]
            }),
            hasCollapsedSteps ? (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                timeout: 225,
                in: cardExpanded,
                mountOnEnter: true,
                unmountOnExit: true,
                children: (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$2771106542ebaa3c, {
                    step: step,
                    subvariant: subvariant
                })
            }) : (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$2771106542ebaa3c, {
                step: step,
                subvariant: subvariant
            })
        ]
    });
};
const $9e46d9a23b4027f5$export$2771106542ebaa3c = ({ step: step, subvariant: subvariant })=>{
    // eslint-disable-next-line react/no-unstable-nested-components
    const StepIconComponent = ({ icon: icon })=>{
        const tool = step.includedSteps?.[Number(icon) - 1];
        return tool ? (0, $cZGFG.jsx)((0, $27f4d60427bfd654$export$adf59ad56eeb21a2), {
            src: tool.toolDetails.logoURI,
            alt: tool.toolDetails.name,
            sx: {
                boxSizing: "content-box"
            },
            children: tool.toolDetails.name[0]
        }) : null;
    };
    const StepDetailsLabel = step.tool === "custom" && subvariant === "nft" ? $9e46d9a23b4027f5$export$b7a9c43e8a53a96 : step.type === "lifi" && step.includedSteps.some((step)=>step.type === "cross") ? $9e46d9a23b4027f5$export$ee24067c7f4caa32 : $9e46d9a23b4027f5$export$594aa707fe74fb96;
    return step.includedSteps.length > 1 ? (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        mt: 1.5,
        children: (0, $cZGFG.jsx)((0, $e4c579a3d03aa3ea$export$2e2bcd8739ae039), {
            orientation: "vertical",
            connector: (0, $cZGFG.jsx)((0, $18ecadc8fe7863a0$export$4a156f5690e82b42), {}),
            activeStep: -1,
            children: step.includedSteps.map((step, i)=>(0, $cZGFG.jsxs)((0, $e2bc52c707326083$export$2e2bcd8739ae039), {
                    expanded: true,
                    children: [
                        (0, $cZGFG.jsx)((0, $18ecadc8fe7863a0$export$64aa61b1ef03133), {
                            StepIconComponent: StepIconComponent,
                            children: step.type === "custom" && subvariant === "nft" ? (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$b7a9c43e8a53a96, {
                                step: step,
                                subvariant: subvariant
                            }) : step.type === "cross" ? (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$ee24067c7f4caa32, {
                                step: step
                            }) : step.type === "protocol" ? (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$a97130a4c55c2c2, {
                                step: step
                            }) : (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$594aa707fe74fb96, {
                                step: step
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $18ecadc8fe7863a0$export$2aebd25fada42a64), {
                            children: (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$7c26183b1fb24e31, {
                                step: step,
                                subvariant: subvariant
                            })
                        })
                    ]
                }, step.id))
        })
    }) : (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        ml: 6,
        children: [
            (0, $cZGFG.jsx)(StepDetailsLabel, {
                step: step,
                subvariant: subvariant === "nft" ? subvariant : undefined
            }),
            (0, $cZGFG.jsx)($9e46d9a23b4027f5$export$7c26183b1fb24e31, {
                step: step,
                subvariant: subvariant
            })
        ]
    });
};
const $9e46d9a23b4027f5$export$7c26183b1fb24e31 = ({ step: step, subvariant: subvariant })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const sameTokenProtocolStep = step.action.fromToken.chainId === step.action.toToken.chainId && step.action.fromToken.address === step.action.toToken.address;
    let fromAmount;
    if (sameTokenProtocolStep) {
        const estimatedFromAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(step.estimate.fromAmount).div(10 ** step.action.fromToken.decimals).minus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(step.estimate.toAmount).div(10 ** step.action.toToken.decimals));
        fromAmount = estimatedFromAmount.gt(0) ? estimatedFromAmount.toString() : (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(step.estimate.fromAmount).div(10 ** step.action.fromToken.decimals).toString();
    } else fromAmount = (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(step.estimate.fromAmount, step.action.fromToken.decimals);
    const showToAmount = step.type !== "custom" && step.tool !== "custom" && !sameTokenProtocolStep;
    return (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
        fontSize: 12,
        fontWeight: "500",
        color: "text.secondary",
        alignItems: "center",
        display: "flex",
        children: [
            t("format.number", {
                value: fromAmount
            }),
            " ",
            step.action.fromToken.symbol,
            showToAmount ? (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ffa5f6fcfa1255e$exports))), {
                        sx: {
                            fontSize: 18,
                            paddingX: 0.5
                        }
                    }),
                    t("format.number", {
                        value: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(step.execution?.toAmount ?? step.estimate.toAmount, step.execution?.toToken?.decimals ?? step.action.toToken.decimals)
                    }),
                    " ",
                    step.execution?.toToken?.symbol ?? step.action.toToken.symbol
                ]
            }) : null
        ]
    });
};
const $9e46d9a23b4027f5$export$b7a9c43e8a53a96 = ({ step: step, subvariant: subvariant })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    if (!subvariant) return null;
    // FIXME: step transaction request overrides step tool details, but not included step tool details
    const toolDetails = subvariant === "nft" && step.includedSteps?.length > 0 ? step.includedSteps.find((step)=>step.tool === "custom" && step.toolDetails.key !== "custom")?.toolDetails || step.toolDetails : step.toolDetails;
    return (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
        fontSize: 12,
        fontWeight: "500",
        color: "text.secondary",
        children: t(`main.${subvariant}StepDetails`, {
            tool: toolDetails.name
        })
    });
};
const $9e46d9a23b4027f5$export$ee24067c7f4caa32 = ({ step: step })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    return (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
        fontSize: 12,
        fontWeight: "500",
        color: "text.secondary",
        children: t("main.crossStepDetails", {
            from: getChainById(step.action.fromChainId)?.name,
            to: getChainById(step.action.toChainId)?.name,
            tool: step.toolDetails.name
        })
    });
};
const $9e46d9a23b4027f5$export$594aa707fe74fb96 = ({ step: step })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    return (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
        fontSize: 12,
        fontWeight: "500",
        color: "text.secondary",
        children: t("main.swapStepDetails", {
            chain: getChainById(step.action.fromChainId)?.name,
            tool: step.toolDetails.name
        })
    });
};
const $9e46d9a23b4027f5$export$a97130a4c55c2c2 = ({ step: step })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
        fontSize: 12,
        fontWeight: "500",
        color: "text.secondary",
        children: step.toolDetails.key === "lifuelProtocol" ? t("main.refuelStepDetails", {
            tool: step.toolDetails.name
        }) : step.toolDetails.name
    });
};



var $cZGFG = parcelRequire("cZGFG");






var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
"use client";
var $161512f9cec8f8f4$var$__defProp = Object.defineProperty;
var $161512f9cec8f8f4$var$__defNormalProp = (obj, key, value)=>key in obj ? $161512f9cec8f8f4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $161512f9cec8f8f4$var$__publicField = (obj, key, value)=>{
    $161512f9cec8f8f4$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $161512f9cec8f8f4$var$observerMap = /* @__PURE__ */ new Map();
var $161512f9cec8f8f4$var$RootIds = /* @__PURE__ */ new WeakMap();
var $161512f9cec8f8f4$var$rootId = 0;
var $161512f9cec8f8f4$var$unsupportedValue = void 0;
function $161512f9cec8f8f4$export$2ef3a60ee1f37bec(inView) {
    $161512f9cec8f8f4$var$unsupportedValue = inView;
}
function $161512f9cec8f8f4$var$getRootId(root) {
    if (!root) return "0";
    if ($161512f9cec8f8f4$var$RootIds.has(root)) return $161512f9cec8f8f4$var$RootIds.get(root);
    $161512f9cec8f8f4$var$rootId += 1;
    $161512f9cec8f8f4$var$RootIds.set(root, $161512f9cec8f8f4$var$rootId.toString());
    return $161512f9cec8f8f4$var$RootIds.get(root);
}
function $161512f9cec8f8f4$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $161512f9cec8f8f4$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $161512f9cec8f8f4$var$createObserver(options) {
    const id = $161512f9cec8f8f4$var$optionsToId(options);
    let instance = $161512f9cec8f8f4$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $161512f9cec8f8f4$var$observerMap.set(id, instance);
    }
    return instance;
}
function $161512f9cec8f8f4$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $161512f9cec8f8f4$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $161512f9cec8f8f4$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $161512f9cec8f8f4$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $161512f9cec8f8f4$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $161512f9cec8f8f4$export$a62107ca74432f44 = class extends $dup7A.Component {
    constructor(props){
        super(props);
        $161512f9cec8f8f4$var$__publicField(this, "node", null);
        $161512f9cec8f8f4$var$__publicField(this, "_unobserveCb", null);
        $161512f9cec8f8f4$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $161512f9cec8f8f4$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$161512f9cec8f8f4$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $161512f9cec8f8f4$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $dup7A.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $161512f9cec8f8f4$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $dup7A.useState(null);
    const callback = $dup7A.useRef();
    const [state, setState] = $dup7A.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $dup7A.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $161512f9cec8f8f4$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $dup7A.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}


const $396aa0489978ac1a$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
};
const $396aa0489978ac1a$export$345b49b00c76d288 = ({ children: children, width: width = "100%", height: height, maxHeight: maxHeight, preserveAspectRatio: preserveAspectRatio = "xMinYMid meet", textStyle: textStyle, svgStyle: svgStyle, cropTop: cropTop, cropBottom: cropBottom, onFit: onFit })=>{
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const textRef = (0, $dup7A.useRef)(null);
    const [viewBox, setViewBox] = (0, $dup7A.useState)($396aa0489978ac1a$var$initialState);
    const [ref] = (0, $161512f9cec8f8f4$export$2f62ee6831462844)({
        onChange (inView) {
            if (inView) calculateBox();
        }
    });
    const calculateBox = (0, $dup7A.useCallback)(()=>{
        if (!textRef.current) return;
        const box = textRef.current.getBBox();
        if (cropTop) {
            box.y += box.height * cropTop;
            box.height -= box.height * cropTop;
        }
        if (cropBottom) box.height -= box.height * cropBottom;
        setViewBox(box);
        onFit?.();
    }, [
        cropBottom,
        cropTop,
        onFit
    ]);
    (0, $dup7A.useLayoutEffect)(()=>{
        calculateBox();
    }, [
        calculateBox,
        children
    ]);
    (0, $dup7A.useLayoutEffect)(()=>{
        if (document.fonts) document.fonts.ready.then(()=>{
            calculateBox();
        });
    }, [
        calculateBox
    ]);
    return (0, $cZGFG.jsx)("svg", {
        style: svgStyle,
        viewBox: `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`,
        width: width,
        height: height,
        // height={
        //   textRect.height && maxHeight && textRect.height >= maxHeight
        //     ? maxHeight
        //     : height
        // }
        preserveAspectRatio: preserveAspectRatio,
        fill: theme.palette.text.primary,
        ref: ref,
        children: (0, $cZGFG.jsx)("text", {
            x: 0,
            y: 0,
            style: textStyle,
            ref: textRef,
            children: children
        })
    });
};





var $jjHhy = parcelRequire("jjHhy");
const $fded27839ecb401f$export$1607b1561ce362e2 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "connected"
})(({ theme: theme, connected: connected })=>({
        borderLeftWidth: connected ? 2 : 0,
        borderLeftStyle: "solid",
        borderColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        margin: connected ? theme.spacing(0.5, 0, 0, 1.875) : theme.spacing(0, 0, 0, 6),
        padding: connected ? theme.spacing(0, 0, 0, 3.875) : theme.spacing(0, 0, 0, 0),
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap"
    }));
const $fded27839ecb401f$export$2149a3d619661ccd = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "connected",
            "dot"
        ].includes(prop)
})(({ theme: theme, connected: connected, dot: dot })=>({
        fontSize: 12,
        lineHeight: 1,
        fontWeight: 500,
        color: dot ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.text.secondary, 0.56) : theme.palette.text.secondary,
        marginTop: connected ? 0 : theme.spacing(0.5)
    }));
const $fded27839ecb401f$export$747e1a77b610cd5c = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        height: 12,
        borderLeftWidth: 2,
        borderLeftStyle: "solid",
        borderColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        margin: theme.spacing(0, 0, 0, 3.875),
        padding: theme.spacing(0, 0, 0, 3.875)
    }));


const $ce33ee047fb204c2$export$50792b0e93539fde = ({ token: token, ...other })=>{
    if (!token?.priceUSD || !token.logoURI) return (0, $cZGFG.jsx)($ce33ee047fb204c2$export$fcfa0996d21be810, {
        token: token,
        ...other
    });
    return (0, $cZGFG.jsx)($ce33ee047fb204c2$export$9f132adb8bb34003, {
        token: token,
        ...other
    });
};
const $ce33ee047fb204c2$export$fcfa0996d21be810 = ({ token: token, isLoading: isLoading, ...other })=>{
    const { token: chainToken, isLoading: isLoadingToken } = (0, $b486f29e55929307$export$31dcd79391e423fe)(token?.chainId, token?.address);
    return (0, $cZGFG.jsx)($ce33ee047fb204c2$export$9f132adb8bb34003, {
        token: {
            ...token,
            ...chainToken
        },
        isLoading: isLoading || isLoadingToken,
        ...other
    });
};
const $ce33ee047fb204c2$export$9f132adb8bb34003 = ({ token: token, connected: connected, step: step, disableDescription: disableDescription, isLoading: isLoading, ...other })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { chain: chain } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(token?.chainId);
    const formattedTokenAmount = (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token?.amount, token?.decimals);
    const formattedTokenPrice = (0, $2a25b0bfe67ae18c$export$78792d27fa2fce59)(formattedTokenAmount, token?.priceUSD);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        flex: 1,
        ...other,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                flex: 1,
                alignItems: "center",
                children: [
                    (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$56e8839726e826f3), {
                        token: token,
                        chain: chain,
                        isLoading: isLoading,
                        sx: {
                            marginRight: 2
                        }
                    }),
                    isLoading ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        width: 112,
                        height: 32,
                        variant: "text"
                    }) : (0, $cZGFG.jsx)((0, $396aa0489978ac1a$export$345b49b00c76d288), {
                        height: 30,
                        textStyle: {
                            fontWeight: 700
                        },
                        children: t("format.number", {
                            value: formattedTokenAmount
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $fded27839ecb401f$export$1607b1561ce362e2), {
                connected: connected,
                component: "span",
                children: [
                    isLoading ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        width: 48,
                        height: 12,
                        variant: "rounded",
                        sx: {
                            marginTop: 0.5
                        }
                    }) : (0, $cZGFG.jsx)((0, $fded27839ecb401f$export$2149a3d619661ccd), {
                        connected: connected,
                        children: t(`format.currency`, {
                            value: formattedTokenPrice
                        })
                    }),
                    !disableDescription ? (0, $cZGFG.jsx)((0, $fded27839ecb401f$export$2149a3d619661ccd), {
                        connected: connected,
                        px: 0.5,
                        dot: true,
                        children: "\u2022"
                    }) : null,
                    !step && !disableDescription ? isLoading ? (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12,
                        variant: "rounded",
                        sx: {
                            marginTop: 0.5
                        }
                    }) : (0, $cZGFG.jsx)((0, $fded27839ecb401f$export$2149a3d619661ccd), {
                        connected: connected,
                        children: t(`main.tokenOnChain`, {
                            tokenSymbol: token?.symbol,
                            chainName: chain?.name
                        })
                    }) : null,
                    step ? (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "flex-end",
                        height: 12,
                        mt: 0.5,
                        children: [
                            (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                pr: 0.75,
                                children: (0, $cZGFG.jsx)((0, $27f4d60427bfd654$export$adf59ad56eeb21a2), {
                                    src: step.toolDetails.logoURI,
                                    alt: step.toolDetails.name,
                                    sx: {
                                        border: 0,
                                        marginBottom: -0.25
                                    },
                                    children: step.toolDetails.name[0]
                                })
                            }),
                            (0, $cZGFG.jsx)((0, $fded27839ecb401f$export$2149a3d619661ccd), {
                                connected: true,
                                children: step.toolDetails.name
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $f4a8ea22f77f491a$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($f4a8ea22f77f491a$exports, "__esModule", {
    value: true
});
$f4a8ea22f77f491a$exports.default = void 0;

var $f4a8ea22f77f491a$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $f4a8ea22f77f491a$var$_default = $f4a8ea22f77f491a$exports.default = (0, $f4a8ea22f77f491a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m3.3 14.71L11 12.41V7h2v4.59l3.71 3.71z"
}), "AccessTimeFilled");



var $884efcab193d257d$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($884efcab193d257d$exports, "__esModule", {
    value: true
});
$884efcab193d257d$exports.default = void 0;

var $884efcab193d257d$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $884efcab193d257d$var$_default = $884efcab193d257d$exports.default = (0, $884efcab193d257d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), "Layers");


var $5300a283ab1c2383$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($5300a283ab1c2383$exports, "__esModule", {
    value: true
});
$5300a283ab1c2383$exports.default = void 0;

var $5300a283ab1c2383$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $5300a283ab1c2383$var$_default = $5300a283ab1c2383$exports.default = (0, $5300a283ab1c2383$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16"
}), "MonetizationOn");






var $jjHhy = parcelRequire("jjHhy");
const $cb070af505313685$export$6a4c33995ff67d72 = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.24) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.32),
        lineHeight: 0,
        marginRight: theme.spacing(0.5)
    }));



const $5754b028e1613147$export$90adcabd3c5a8aa7 = (route)=>{
    return Object.values(route.steps.reduce((groupedGasCosts, step)=>{
        if (step.estimate.gasCosts?.length) {
            const { token: token } = step.estimate.gasCosts[0];
            const gasCostAmount = step.estimate.gasCosts.reduce((amount, gasCost)=>amount.plus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(gasCost.amount || 0)), (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0)).div(10 ** token.decimals);
            const gasCostAmountUSD = step.estimate.gasCosts.reduce((amount, gasCost)=>amount + parseFloat(gasCost.amountUSD || "0"), 0);
            const groupedGasCost = groupedGasCosts[token.chainId];
            const amount = groupedGasCost ? groupedGasCost.amount.plus(gasCostAmount) : gasCostAmount;
            const amountUSD = groupedGasCost ? groupedGasCost.amountUSD + gasCostAmountUSD : gasCostAmountUSD;
            groupedGasCosts[token.chainId] = {
                amount: amount,
                amountUSD: amountUSD,
                token: token
            };
            return groupedGasCosts;
        }
        return groupedGasCosts;
    }, {}));
};
const $5754b028e1613147$export$e05bf30d8ff0b60f = (route, included)=>{
    return Object.values(route.steps.reduce((groupedFeeCosts, step)=>{
        let feeCosts = step.estimate.feeCosts;
        if (typeof included === "boolean") feeCosts = feeCosts?.filter((feeCost)=>feeCost.included === included);
        if (feeCosts?.length) {
            const { token: token } = feeCosts[0];
            const feeCostAmount = feeCosts.reduce((amount, feeCost)=>amount.plus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(feeCost.amount || 0)), (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0)).div(10 ** token.decimals);
            const feeCostAmountUSD = feeCosts.reduce((amount, feeCost)=>amount + parseFloat(feeCost.amountUSD || "0"), 0);
            const groupedFeeCost = groupedFeeCosts[token.chainId];
            const amount = groupedFeeCost ? groupedFeeCost.amount.plus(feeCostAmount) : feeCostAmount;
            const amountUSD = groupedFeeCost ? groupedFeeCost.amountUSD + feeCostAmountUSD : feeCostAmountUSD;
            groupedFeeCosts[token.chainId] = {
                amount: amount,
                amountUSD: amountUSD,
                token: token
            };
            return groupedFeeCosts;
        }
        return groupedFeeCosts;
    }, {}));
};


const $08eb9f49af46eed5$export$d4f616e049d65bf8 = ({ route: route, dense: dense })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const executionTimeMinutes = Math.ceil(route.steps.map((step)=>step.estimate.executionDuration).reduce((duration, x)=>duration + x, 0) / 60);
    const gasCostUSD = parseFloat(route.gasCostUSD ?? "") || 0.01;
    const gasCosts = (0, $5754b028e1613147$export$90adcabd3c5a8aa7)(route);
    const feeCosts = (0, $5754b028e1613147$export$e05bf30d8ff0b60f)(route, false);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "space-between",
        flex: 1,
        mt: 2,
        children: [
            (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                title: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    component: "span",
                    children: [
                        t(`tooltip.estimatedNetworkFee`),
                        gasCosts.map((gas, index)=>(0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                fontSize: 12,
                                fontWeight: "500",
                                children: [
                                    gas.amount?.toFixed(9),
                                    " ",
                                    gas.token.symbol,
                                    " (",
                                    t(`format.currency`, {
                                        value: gas.amountUSD
                                    }),
                                    ")"
                                ]
                            }, `${gas.token.address}${index}`))
                    ]
                }),
                placement: "top",
                enterDelay: 400,
                arrow: true,
                children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    mr: dense ? 0 : 2,
                    children: [
                        (0, $cZGFG.jsx)((0, $cb070af505313685$export$6a4c33995ff67d72), {
                            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9955478a62ac183c$exports))), {
                                fontSize: "small"
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            color: "text.primary",
                            fontWeight: "500",
                            lineHeight: 1,
                            children: t(`format.currency`, {
                                value: gasCostUSD
                            })
                        })
                    ]
                })
            }),
            (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                title: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    component: "span",
                    children: [
                        t(`tooltip.additionalProviderFee`),
                        feeCosts.map((fee, index)=>(0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                fontSize: 12,
                                fontWeight: "500",
                                children: [
                                    fee.amount?.toFixed(9),
                                    " ",
                                    fee.token.symbol,
                                    " (",
                                    t(`format.currency`, {
                                        value: fee.amountUSD
                                    }),
                                    ")"
                                ]
                            }, `${fee.token.address}${index}`))
                    ]
                }),
                placement: "top",
                enterDelay: 400,
                arrow: true,
                children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    mr: dense ? 0 : 2,
                    children: [
                        (0, $cZGFG.jsx)((0, $cb070af505313685$export$6a4c33995ff67d72), {
                            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5300a283ab1c2383$exports))), {
                                fontSize: "small"
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            color: "text.primary",
                            fontWeight: "500",
                            lineHeight: 1,
                            children: t(`format.currency`, {
                                value: feeCosts.reduce((sum, feeCost)=>sum + feeCost.amountUSD, 0)
                            })
                        })
                    ]
                })
            }),
            (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                title: t(`tooltip.estimatedTime`),
                placement: "top",
                enterDelay: 400,
                arrow: true,
                children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    mr: dense ? 0 : 2,
                    children: [
                        (0, $cZGFG.jsx)((0, $cb070af505313685$export$6a4c33995ff67d72), {
                            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4a8ea22f77f491a$exports))), {
                                fontSize: "small"
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            color: "text.primary",
                            fontWeight: "500",
                            lineHeight: 1,
                            children: t("main.estimatedTime", {
                                value: executionTimeMinutes
                            })
                        })
                    ]
                })
            }),
            (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                title: t(`tooltip.numberOfSteps`),
                placement: "top",
                enterDelay: 400,
                arrow: true,
                children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        (0, $cZGFG.jsx)((0, $cb070af505313685$export$6a4c33995ff67d72), {
                            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($884efcab193d257d$exports))), {
                                fontSize: "small"
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            color: "text.primary",
                            fontWeight: "500",
                            lineHeight: 1,
                            children: route.steps.length
                        })
                    ]
                })
            })
        ]
    });
};


const $748e91f2c262fb9d$export$d99fd5a1ae05e6cf = ({ route: route, active: active, variant: variant = "default", expanded: expanded, ...other })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [cardExpanded, setCardExpanded] = (0, $dup7A.useState)(expanded);
    const insurable = route.insurance?.state === "INSURABLE";
    const handleExpand = (e)=>{
        e.stopPropagation();
        setCardExpanded((expanded)=>!expanded);
    };
    const token = subvariant === "nft" ? {
        ...route.fromToken,
        amount: route.fromAmount
    } : {
        ...route.toToken,
        amount: route.toAmount
    };
    const RecommendedTagTooltip = route.tags?.[0] === "RECOMMENDED" ? $748e91f2c262fb9d$var$RecommendedTooltip : (0, $dup7A.Fragment);
    const cardContent = (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        flex: 1,
        children: [
            subvariant !== "refuel" && (insurable || route.tags?.length) ? (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                mb: 2,
                children: [
                    insurable ? (0, $cZGFG.jsx)($748e91f2c262fb9d$var$InsuranceTooltip, {
                        insuredAmount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(route.toAmountMin, route.toToken.decimals),
                        insuredTokenSymbol: route.toToken.symbol,
                        children: (0, $cZGFG.jsxs)((0, $987da2744be1b393$export$e13aaac4037b0914), {
                            type: route.tags?.length && !cardExpanded ? "insurance-icon" : "insurance",
                            children: [
                                (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7e0ba82d268b078$exports))), {
                                    fontSize: "inherit"
                                }),
                                cardExpanded || !route.tags?.length ? (0, $cZGFG.jsx)((0, $987da2744be1b393$export$2eaa1bdbba29c923), {
                                    type: "icon",
                                    children: t(`main.tags.insurable`)
                                }) : null
                            ]
                        })
                    }) : null,
                    route.tags?.length ? (0, $cZGFG.jsx)(RecommendedTagTooltip, {
                        children: (0, $cZGFG.jsx)((0, $987da2744be1b393$export$e13aaac4037b0914), {
                            type: active ? "active" : undefined,
                            children: (0, $cZGFG.jsx)((0, $987da2744be1b393$export$2eaa1bdbba29c923), {
                                children: t(`main.tags.${route.tags[0].toLowerCase()}`)
                            })
                        })
                    }) : null
                ]
            }) : null,
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                children: [
                    (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: token,
                        step: !cardExpanded ? route.steps[0] : undefined
                    }),
                    !expanded ? (0, $cZGFG.jsx)((0, $1cb427f767e9e062$export$a03b0ac28c7e34b8), {
                        onClick: handleExpand,
                        size: "small",
                        children: cardExpanded ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6f937c21a39d4f3$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4d3a704b8b3b6f33$exports))), {})
                    }) : null
                ]
            }),
            (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                timeout: 225,
                in: cardExpanded,
                mountOnEnter: true,
                unmountOnExit: true,
                children: route.steps.map((step)=>(0, $cZGFG.jsx)((0, $9e46d9a23b4027f5$export$f5a9677241e3f131), {
                        step: step,
                        mt: 2
                    }, step.id))
            }),
            (0, $cZGFG.jsx)((0, $08eb9f49af46eed5$export$d4f616e049d65bf8), {
                route: route
            })
        ]
    });
    return subvariant === "refuel" || variant === "cardless" ? cardContent : (0, $cZGFG.jsx)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        variant: active ? "selected" : "default",
        selectionColor: "secondary",
        indented: true,
        ...other,
        children: cardContent
    });
};
const $748e91f2c262fb9d$var$InsuranceTooltip = ({ insuredAmount: insuredAmount, insuredTokenSymbol: insuredTokenSymbol, children: children })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
        title: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            component: "span",
            children: [
                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontSize: 12,
                    fontWeight: "500",
                    children: (0, $cZGFG.jsx)((0, $2fb7372348de61af$export$8d6a9236f2e3f2ce), {
                        i18nKey: "insurance.insure",
                        values: {
                            amount: insuredAmount,
                            tokenSymbol: insuredTokenSymbol
                        },
                        components: [
                            (0, $cZGFG.jsx)("strong", {})
                        ]
                    })
                }),
                (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    sx: {
                        listStyleType: "disc",
                        pl: 2
                    },
                    children: [
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 12,
                            fontWeight: "500",
                            display: "list-item",
                            children: t("insurance.bridgeExploits")
                        }),
                        (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                            fontSize: 12,
                            fontWeight: "500",
                            display: "list-item",
                            children: t("insurance.slippageError")
                        })
                    ]
                })
            ]
        }),
        placement: "top",
        enterDelay: 400,
        arrow: true,
        children: children
    });
};
const $748e91f2c262fb9d$var$RecommendedTooltip = ({ children: children })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
        title: t("tooltip.recommended"),
        placement: "top",
        enterDelay: 400,
        arrow: true,
        children: children
    });
};


var $cZGFG = parcelRequire("cZGFG");



const $4c88d3e88750f71e$export$f6c2b491a88fe8ab = ({ variant: variant, ...other })=>{
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const cardContent = (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        flex: 1,
        children: [
            subvariant !== "refuel" && subvariant !== "nft" ? (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                mb: 2,
                children: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    width: 112,
                    height: 24,
                    sx: (theme)=>({
                            borderRadius: `${theme.shape.borderRadius}px`
                        })
                })
            }) : null,
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                children: [
                    (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                mr: 2,
                                children: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                                    variant: "circular",
                                    width: 32,
                                    height: 32
                                })
                            }),
                            (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: 96,
                                height: 32
                            })
                        ]
                    }),
                    (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        ml: 6,
                        display: "flex",
                        alignItems: "center",
                        children: [
                            (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: 102,
                                height: 16
                            }),
                            (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: 72,
                                height: 16,
                                sx: {
                                    marginLeft: 1
                                }
                            })
                        ]
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
                children: [
                    (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: 64,
                        height: 20
                    }),
                    (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: 64,
                        height: 20
                    }),
                    (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: 48,
                        height: 20
                    }),
                    (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: 32,
                        height: 20
                    })
                ]
            })
        ]
    });
    return subvariant === "refuel" || variant === "cardless" ? cardContent : (0, $cZGFG.jsx)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        indented: true,
        ...other,
        children: cardContent
    });
};


var $cZGFG = parcelRequire("cZGFG");
var $70a474af89fbd5ba$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($70a474af89fbd5ba$exports, "__esModule", {
    value: true
});
$70a474af89fbd5ba$exports.default = void 0;

var $70a474af89fbd5ba$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $70a474af89fbd5ba$var$_default = $70a474af89fbd5ba$exports.default = (0, $70a474af89fbd5ba$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18c-1.16.41-2 1.51-2 2.82 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82"
}), "Route");




const $346668b43c43be35$export$d9b32705cc00a1ab = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            flex: 1
        },
        py: 1.625,
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 48,
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70a474af89fbd5ba$exports))), {
                    fontSize: "inherit"
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 18,
                fontWeight: 700,
                children: t("info.title.routeNotFound")
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 14,
                color: "text.secondary",
                textAlign: "center",
                mt: 2,
                children: t("info.message.routeNotFound")
            })
        ]
    });
};


const $c14fc1f1ba0f1345$export$3565eb3d00ca5a74 = (props)=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { subvariant: subvariant, useRecommendedRoute: useRecommendedRoute } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { isValid: isValid, isValidating: isValidating } = (0, $367773295ca041ba$export$606f11b2eb45ecc6)();
    const { routes: routes, isLoading: isLoading, isFetching: isFetching, isFetched: isFetched, dataUpdatedAt: dataUpdatedAt, refetchTime: refetchTime, refetch: refetch } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)();
    const currentRoute = routes?.[0];
    if (!currentRoute && !isLoading && !isFetching && !isFetched) return null;
    const handleCardClick = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes);
    };
    const routeNotFound = !currentRoute && !isLoading && !isFetching;
    const onlyRecommendedRoute = subvariant === "refuel" || useRecommendedRoute;
    const showAll = !onlyRecommendedRoute && !routeNotFound && (routes?.length ?? 0) > 1;
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        ...props,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: subvariant === "nft" ? t("main.fromAmount") : t("header.youGet")
            }),
            (0, $cZGFG.jsx)((0, $eb12012bc6102ab5$export$9ff79255ead4ffb5), {
                updatedAt: dataUpdatedAt || new Date().getTime(),
                timeToUpdate: refetchTime,
                isLoading: isFetching,
                onClick: ()=>refetch(),
                sx: {
                    position: "absolute",
                    top: 8,
                    right: 8
                }
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                p: 2,
                children: [
                    isLoading ? (0, $cZGFG.jsx)((0, $4c88d3e88750f71e$export$f6c2b491a88fe8ab), {
                        variant: "cardless"
                    }) : !currentRoute ? (0, $cZGFG.jsx)((0, $346668b43c43be35$export$d9b32705cc00a1ab), {}) : (0, $cZGFG.jsx)((0, $748e91f2c262fb9d$export$d99fd5a1ae05e6cf), {
                        route: currentRoute,
                        variant: "cardless",
                        active: true
                    }),
                    (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                        timeout: 225,
                        in: showAll,
                        unmountOnExit: true,
                        mountOnEnter: true,
                        appear: true,
                        children: (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                            mt: 2,
                            children: (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                onClick: handleCardClick,
                                disabled: isValidating || !isValid,
                                fullWidth: true,
                                children: t("button.showAll")
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");



var $cZGFG = parcelRequire("cZGFG");

var $4eeb3b1ad7464c2d$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($4eeb3b1ad7464c2d$exports, "__esModule", {
    value: true
});
$4eeb3b1ad7464c2d$exports.default = void 0;

var $4eeb3b1ad7464c2d$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $4eeb3b1ad7464c2d$var$_default = $4eeb3b1ad7464c2d$exports.default = (0, $4eeb3b1ad7464c2d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), "SwapVert");






var $jjHhy = parcelRequire("jjHhy");
const $7827597360aea56f$export$c25acd513dcc8062 = (0, $jjHhy.default)((0, $510dba830cc31c9a$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        zIndex: 1100,
        padding: theme.spacing(0.5),
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(theme.palette.background.paper, 0.02) : (0, $ecd44ebd791a3fa9$export$c0816ed86df316af)(theme.palette.background.paper, 0.02)
        }
    }));


const $72387ffc70c78626$export$743da33ba10f0ce0 = ({ vertical: vertical })=>{
    const { setValue: setValue, getValues: getValues } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const handleClick = ()=>{
        const [fromChain, fromToken, toChain, toToken] = getValues([
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken
        ]);
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, "", {
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain, toChain, {
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken, toToken, {
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain, fromChain, {
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken, fromToken, {
            shouldTouch: true
        });
    };
    return (0, $cZGFG.jsx)((0, $7827597360aea56f$export$c25acd513dcc8062), {
        onClick: handleClick,
        size: "small",
        children: vertical ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4eeb3b1ad7464c2d$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($61bd3631b85a0e88$exports))), {})
    });
};



var $cZGFG = parcelRequire("cZGFG");










var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $cb01fd9edf15ea0f$export$f54c8b0d04b67946(slot) {
    return (0, $8iNDC.default)("MuiCardHeader", slot);
}
const $cb01fd9edf15ea0f$var$cardHeaderClasses = (0, $fc1pF.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $cb01fd9edf15ea0f$export$2e2bcd8739ae039 = $cb01fd9edf15ea0f$var$cardHeaderClasses;



var $jjHhy = parcelRequire("jjHhy");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");


var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $425930d910962e85$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $425930d910962e85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $cb01fd9edf15ea0f$export$f54c8b0d04b67946), classes);
};
const $425930d910962e85$var$CardHeaderRoot = (0, $jjHhy.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $3G4eg.default)({
            [`& .${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $425930d910962e85$var$CardHeaderAvatar = (0, $jjHhy.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $425930d910962e85$var$CardHeaderAction = (0, $jjHhy.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $425930d910962e85$var$CardHeaderContent = (0, $jjHhy.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $425930d910962e85$var$CardHeader = /*#__PURE__*/ $dup7A.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $bGxpK.default)(props, $425930d910962e85$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $425930d910962e85$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($425930d910962e85$var$CardHeaderRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $cZGFG.jsx)($425930d910962e85$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($425930d910962e85$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $cZGFG.jsx)($425930d910962e85$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $425930d910962e85$export$2e2bcd8739ae039 = $425930d910962e85$var$CardHeader;




var $jjHhy = parcelRequire("jjHhy");
const $d13789d183e3a07b$export$5665775b26e26c5d = (0, $jjHhy.default)((0, $425930d910962e85$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`.${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).action}`]: {
            marginTop: -2,
            alignSelf: "center"
        },
        [`.${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).title}`]: {
            fontWeight: "500",
            fontSize: "1.125rem",
            lineHeight: "1.2778",
            color: theme.palette.text.primary
        },
        [`.${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).subheader}`]: {
            fontWeight: "400",
            fontSize: "0.75rem",
            color: theme.palette.text.secondary
        }
    }));


const $f47d7575bbe3860e$export$ad1c2153a5bf9761 = (0, $jjHhy.default)((0, $d13789d183e3a07b$export$5665775b26e26c5d), {
    shouldForwardProp: (prop)=>![
            "selected",
            "compact"
        ].includes(prop)
})(({ theme: theme, selected: selected, compact: compact })=>({
        height: 64,
        [`.${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).title}`]: {
            color: selected ? theme.palette.text.primary : theme.palette.text.secondary,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: compact ? 92 : 256,
            fontWeight: selected ? 500 : 400,
            fontSize: compact && !selected ? "1rem" : "1.125rem",
            [theme.breakpoints.down(392)]: {
                width: compact ? 92 : 224
            }
        },
        [`.${(0, $cb01fd9edf15ea0f$export$2e2bcd8739ae039).subheader}`]: {
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: compact ? 92 : 256,
            [theme.breakpoints.down(392)]: {
                width: compact ? 92 : 224
            }
        }
    }));


const $a7c046f1bdc24de8$export$ac8970cedcd50e9a = ({ formType: formType, compact: compact })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { disabledUI: disabledUI, subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const swapOnly = (0, $420a652508d6fbf9$export$c4a81b0a847a209f)();
    const tokenKey = (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType);
    const [chainId, tokenAddress] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType),
            tokenKey
        ]
    });
    const { chain: chain, isLoading: isChainLoading } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(chainId);
    const { token: token, isLoading: isTokenLoading } = (0, $b486f29e55929307$export$31dcd79391e423fe)(chainId, tokenAddress);
    const handleClick = ()=>{
        navigate(formType === "from" ? (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromToken : subvariant === "refuel" ? (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toTokenNative : (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toToken);
    };
    const isSelected = !!(chain && token);
    const onClick = !disabledUI?.includes(tokenKey) ? handleClick : undefined;
    const defaultPlaceholder = formType === "to" && subvariant === "refuel" ? t("main.selectChain") : formType === "to" && swapOnly ? t("main.selectToken") : t("main.selectChainAndToken");
    const cardTitle = formType === "from" && subvariant === "nft" ? t(`header.payWith`) : t(`main.${formType}`);
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        flex: 1,
        onClick: onClick,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: cardTitle
            }),
            chainId && tokenAddress && (isChainLoading || isTokenLoading) ? (0, $cZGFG.jsx)((0, $f47d7575bbe3860e$export$ad1c2153a5bf9761), {
                avatar: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "circular",
                    width: 32,
                    height: 32
                }),
                title: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "text",
                    width: 64,
                    height: 24
                }),
                subheader: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "text",
                    width: 64,
                    height: 16
                }),
                compact: compact
            }) : (0, $cZGFG.jsx)((0, $f47d7575bbe3860e$export$ad1c2153a5bf9761), {
                avatar: isSelected ? (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$56e8839726e826f3), {
                    token: token,
                    chain: chain
                }) : (0, $cZGFG.jsx)((0, $21d2469ec33e67c2$export$aeac0dce6f0792e), {}),
                title: isSelected ? token.symbol : defaultPlaceholder,
                subheader: isSelected ? t(`main.onChain`, {
                    chainName: chain.name
                }) : null,
                selected: isSelected,
                compact: compact
            })
        ]
    });
};




const $3d6e2ba5bc37f625$export$d1bdbab86783985e = (props)=>{
    const prefersNarrowView = (0, $b15e80d6e5586a57$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.down("sm"));
    const { disabledUI: disabledUI, hiddenUI: hiddenUI, subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [fromChain, toChain, fromToken, toToken] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken
        ]
    });
    const hiddenReverse = subvariant === "refuel" || disabledUI?.includes((0, $57f573099db3f258$export$d98e2f690b7e6bcf).FromToken) || disabledUI?.includes((0, $57f573099db3f258$export$d98e2f690b7e6bcf).ToToken) || hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).ToToken);
    const hiddenToToken = subvariant === "nft" || hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).ToToken);
    const isCompact = fromChain && toChain && fromToken && toToken && !prefersNarrowView && !hiddenToToken;
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: isCompact ? "row" : "column"
        },
        ...props,
        children: [
            (0, $cZGFG.jsx)((0, $a7c046f1bdc24de8$export$ac8970cedcd50e9a), {
                formType: "from",
                compact: isCompact
            }),
            !hiddenToToken ? (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                m: !hiddenReverse ? -1.125 : 1,
                children: !hiddenReverse ? (0, $cZGFG.jsx)((0, $72387ffc70c78626$export$743da33ba10f0ce0), {
                    vertical: !isCompact
                }) : null
            }) : null,
            !hiddenToToken ? (0, $cZGFG.jsx)((0, $a7c046f1bdc24de8$export$ac8970cedcd50e9a), {
                formType: "to",
                compact: isCompact
            }) : null
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $8T6OQ = parcelRequire("8T6OQ");


var $dup7A = parcelRequire("dup7A");




const $8f69ee068e035a12$export$ebd60666ceae3007 = (0, $9dabe26fe674174f$export$c883e057baa24e24)((set)=>({
        showSendToWallet: false,
        showSendToWalletDirty: false,
        toggleSendToWallet: ()=>set((state)=>({
                    showSendToWallet: !state.showSendToWallet,
                    showSendToWalletDirty: true
                })),
        setSendToWallet: (value)=>set({
                showSendToWallet: value,
                showSendToWalletDirty: true
            })
    }), Object.is);







var $jjHhy = parcelRequire("jjHhy");
const $f4e64e0c503a26a0$export$fe5d99d8691b3f62 = (0, $jjHhy.default)((0, $e860bb7daa30c730$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(1.5, 2, 1.5, 0)
    }));
const $f4e64e0c503a26a0$export$f5b8910cec6cf069 = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}`]: {
            height: 32,
            padding: theme.spacing(0, 0, 0, 2)
        },
        [`&.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            color: "inherit"
        },
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}.${(0, $8febbde539987675$export$2e2bcd8739ae039).disabled}`]: {
            WebkitTextFillColor: "unset"
        }
    }));


const $25605faffb283351$export$c83dd197f0386b9e = (0, $dup7A.forwardRef)((props, ref)=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { trigger: trigger, getValues: getValues, setValue: setValue, clearErrors: clearErrors } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const { disabledUI: disabledUI, hiddenUI: hiddenUI, requiredUI: requiredUI, toAddress: toAddress } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { showSendToWallet: showSendToWallet, showSendToWalletDirty: showSendToWalletDirty, setSendToWallet: setSendToWallet } = (0, $8f69ee068e035a12$export$ebd60666ceae3007)();
    const { showDestinationWallet: showDestinationWallet } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "showDestinationWallet"
    ]);
    const hiddenToAddress = hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).ToAddress);
    const disabledToAddress = disabledUI?.includes((0, $57f573099db3f258$export$d98e2f690b7e6bcf).ToAddress);
    const requiredToAddress = requiredUI?.includes((0, $57f573099db3f258$export$e825d82b4280cef6).ToAddress);
    const requiredToAddressRef = (0, $dup7A.useRef)(requiredToAddress);
    const { field: { onChange: onChange, onBlur: onBlur, name: name, value: value } } = (0, $367773295ca041ba$export$e8c786024a2b0a79)({
        name: (0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress,
        rules: {
            required: requiredToAddress && t("error.title.walletAddressRequired"),
            onChange: (e)=>{
                setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress, e.target.value.trim());
            },
            validate: async (value)=>{
                try {
                    if (!value) return true;
                    const address = await account.signer?.provider?.resolveName(value);
                    return (0, $8T6OQ.isAddress)(address || value) || t("error.title.walletAddressInvalid");
                } catch  {
                    return t("error.title.walletEnsAddressInvalid");
                }
            },
            onBlur: ()=>trigger((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress)
        }
    });
    // We want to show toAddress field if it is set via widget configuration and not hidden
    const showInstantly = Boolean(!showSendToWalletDirty && showDestinationWallet && toAddress && !hiddenToAddress) || requiredToAddress;
    (0, $dup7A.useEffect)(()=>{
        if (showInstantly) setSendToWallet(true);
    }, [
        showInstantly,
        setSendToWallet
    ]);
    (0, $dup7A.useEffect)(()=>{
        const value = getValues((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress);
        if (value) trigger((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress);
        else if (requiredToAddressRef.current !== requiredToAddress) {
            requiredToAddressRef.current = requiredToAddress;
            trigger((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress).then(()=>clearErrors((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress));
        }
    }, [
        account.chainId,
        clearErrors,
        getValues,
        requiredToAddress,
        trigger
    ]);
    if (hiddenToAddress) return null;
    return (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
        timeout: showInstantly ? 0 : 225,
        in: showSendToWallet || showInstantly,
        mountOnEnter: true,
        unmountOnExit: true,
        children: (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
            ...props,
            ref: ref,
            children: [
                (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                    required: requiredToAddress,
                    children: t("main.sendToWallet")
                }),
                (0, $cZGFG.jsxs)((0, $f4e64e0c503a26a0$export$fe5d99d8691b3f62), {
                    fullWidth: true,
                    sx: {
                        paddingTop: "6px",
                        paddingBottom: "5px"
                    },
                    children: [
                        (0, $cZGFG.jsx)((0, $f4e64e0c503a26a0$export$f5b8910cec6cf069), {
                            size: "small",
                            autoComplete: "off",
                            autoCorrect: "off",
                            autoCapitalize: "off",
                            spellCheck: "false",
                            onChange: onChange,
                            onBlur: onBlur,
                            name: name,
                            value: value,
                            placeholder: t("main.walletAddressOrEns"),
                            disabled: Boolean(toAddress && disabledToAddress)
                        }),
                        (0, $cZGFG.jsx)($25605faffb283351$export$68a7ec99994bf98, {})
                    ]
                })
            ]
        })
    });
});
const $25605faffb283351$export$68a7ec99994bf98 = ()=>{
    const { errors: errors } = (0, $367773295ca041ba$export$606f11b2eb45ecc6)();
    return (0, $cZGFG.jsx)((0, $8a21bad991422587$export$2e2bcd8739ae039), {
        error: !!errors.toAddress,
        children: errors.toAddress?.message
    });
};


var $cZGFG = parcelRequire("cZGFG");
var $671d7c5a3f94d7f9$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($671d7c5a3f94d7f9$exports, "__esModule", {
    value: true
});
$671d7c5a3f94d7f9$exports.default = void 0;

var $671d7c5a3f94d7f9$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $671d7c5a3f94d7f9$var$_default = $671d7c5a3f94d7f9$exports.default = (0, $671d7c5a3f94d7f9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4m-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2"
}), "Wallet");









const $18517af472357d43$export$7771fdf68e7a837e = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const emitter = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    const { disabledUI: disabledUI, hiddenUI: hiddenUI, requiredUI: requiredUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { showSendToWallet: showSendToWallet, toggleSendToWallet: toggleSendToWallet } = (0, $8f69ee068e035a12$export$ebd60666ceae3007)();
    const { showDestinationWallet: showDestinationWallet } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "showDestinationWallet"
    ]);
    if (!showDestinationWallet || hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).ToAddress) || requiredUI?.includes((0, $57f573099db3f258$export$e825d82b4280cef6).ToAddress)) return null;
    const handleClick = ()=>{
        if (showSendToWallet && !disabledUI?.includes((0, $57f573099db3f258$export$d98e2f690b7e6bcf).ToAddress)) setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAddress, "", {
            shouldTouch: true
        });
        toggleSendToWallet();
        emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).SendToWalletToggled, (0, $8f69ee068e035a12$export$ebd60666ceae3007).getState().showSendToWallet);
    };
    return (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
        title: t("main.sendToWallet"),
        placement: "bottom-end",
        enterDelay: 400,
        arrow: true,
        children: (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
            variant: showSendToWallet ? "contained" : "text",
            onClick: handleClick,
            sx: {
                minWidth: 48,
                marginLeft: 1
            },
            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($671d7c5a3f94d7f9$exports))), {})
        })
    });
};




const $ea9b454d75cc3193$var$defaultExpandableWidth = 852;
const $ea9b454d75cc3193$export$b7fefcff97a6bbf8 = ()=>{
    const { variant: variant, useRecommendedRoute: useRecommendedRoute } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const expandableAllowed = (0, $b15e80d6e5586a57$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up($ea9b454d75cc3193$var$defaultExpandableWidth));
    return variant === "expandable" && expandableAllowed && !useRecommendedRoute;
};




var $cZGFG = parcelRequire("cZGFG");

var $cZGFG = parcelRequire("cZGFG");








const $5841b638342b4fa9$var$refetchInterval = 30000;
const $5841b638342b4fa9$export$3347879a42f96196 = (route)=>{
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const getTokenBalancesWithRetry = (0, $a670161a467df0c7$export$eb3aa16b2ed13b52)(account.signer?.provider);
    const [fromChainId, fromTokenAddress, fromAmount] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken,
            (0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount
        ]
    });
    let chainId = fromChainId;
    let tokenAddress = fromTokenAddress;
    if (route) {
        chainId = route.fromToken.chainId;
        tokenAddress = route.fromToken.address;
    }
    const { token: token, isLoading: isLoading } = (0, $5da48810ed56f459$export$b823943063e17b85)(chainId, tokenAddress);
    const { data: insufficientFromToken, isInitialLoading: isInitialLoading } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "from-token-sufficiency-check",
        account.address,
        chainId,
        tokenAddress,
        route?.id ?? fromAmount
    ], async ()=>{
        if (!account.address || !token) return;
        let currentTokenBalance = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(token?.amount || 0);
        if (!route || (0, $4441d4f2fb25e8a3$export$ae7676fc6d6e3d11)(route)) {
            const insufficientFunds = currentTokenBalance.lt((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(fromAmount || 0));
            return insufficientFunds;
        }
        const currentAction = route.steps.filter((step)=>!step.execution || step.execution.status !== "DONE")[0]?.action;
        if (token.chainId === currentAction.fromToken.chainId && token.address === currentAction.fromToken.address && currentTokenBalance.gt(0)) {
            const insufficientFunds = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(route.fromAmount).div(10 ** route.fromToken.decimals).gt(currentTokenBalance);
            return insufficientFunds;
        }
        const tokenBalances = await getTokenBalancesWithRetry(account.address, [
            currentAction.fromToken
        ]);
        currentTokenBalance = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(tokenBalances?.[0]?.amount || 0);
        const insufficientFunds = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(currentAction.fromAmount).div(10 ** currentAction.fromToken.decimals).gt(currentTokenBalance);
        return insufficientFunds;
    }, {
        enabled: Boolean(account.address && token && !isLoading),
        refetchInterval: $5841b638342b4fa9$var$refetchInterval,
        staleTime: $5841b638342b4fa9$var$refetchInterval,
        cacheTime: $5841b638342b4fa9$var$refetchInterval,
        keepPreviousData: true
    });
    return {
        insufficientFromToken: insufficientFromToken,
        isInitialLoading: isInitialLoading
    };
};






const $4fde403c8cd0fba4$var$refetchInterval = 30000;
const $4fde403c8cd0fba4$export$219afe79026b8536 = (route)=>{
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const getTokenBalancesWithRetry = (0, $a670161a467df0c7$export$eb3aa16b2ed13b52)(account.signer?.provider);
    const { sdkConfig: sdkConfig } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const isMultisigSigner = sdkConfig?.multisigConfig?.isMultisigSigner;
    const { enabledAutoRefuel: enabledAutoRefuel } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "enabledAutoRefuel"
    ]);
    const { enabled: enabled, isLoading: isRefuelLoading } = (0, $3abf02afa8091034$export$92b020e44091b5ca)();
    const enabledRefuel = enabled && enabledAutoRefuel;
    const { data: insufficientGas, isInitialLoading: isInitialLoading } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "gas-sufficiency-check",
        account.address,
        route?.id
    ], async ()=>{
        if (!account.address || !route) return;
        // TODO: include LI.Fuel into calculation once steps and tools are properly typed
        // const refuelSteps = route.steps
        //   .flatMap((step) => step.includedSteps)
        //   .filter((includedStep) => includedStep.tool === 'lifuelProtocol');
        const gasCosts = route.steps.filter((step)=>!step.execution || step.execution.status !== "DONE").reduce((groupedGasCosts, step)=>{
            if (step.estimate.gasCosts && !isMultisigSigner) {
                const { token: token } = step.estimate.gasCosts[0];
                const gasCostAmount = step.estimate.gasCosts.reduce((amount, gasCost)=>amount.plus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(gasCost.amount || 0)), (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0)).div(10 ** token.decimals);
                groupedGasCosts[token.chainId] = {
                    gasAmount: groupedGasCosts[token.chainId]?.gasAmount.plus(gasCostAmount) ?? gasCostAmount,
                    token: token
                };
            }
            // Add fees paid in native tokens to gas sufficiency check (included: false)
            const nonIncludedFeeCosts = step.estimate.feeCosts?.filter((feeCost)=>!feeCost.included);
            if (nonIncludedFeeCosts?.length) {
                const { token: token } = nonIncludedFeeCosts[0];
                const feeCostAmount = nonIncludedFeeCosts.reduce((amount, feeCost)=>amount.plus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(feeCost.amount || 0)), (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0)).div(10 ** token.decimals);
                groupedGasCosts[token.chainId] = {
                    gasAmount: groupedGasCosts[token.chainId]?.gasAmount.plus(feeCostAmount) ?? feeCostAmount,
                    token: token
                };
            }
            return groupedGasCosts;
        }, {});
        if (route.fromToken.address === gasCosts[route.fromChainId]?.token.address) gasCosts[route.fromChainId].tokenAmount = gasCosts[route.fromChainId].gasAmount.plus((0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(route.fromAmount).div(10 ** route.fromToken.decimals));
        const tokenBalances = await getTokenBalancesWithRetry(account.address, Object.values(gasCosts).map((item)=>item.token));
        if (!tokenBalances?.length) return;
        [
            route.fromChainId,
            route.toChainId
        ].forEach((chainId)=>{
            if (gasCosts[chainId]) {
                const gasTokenBalance = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(tokenBalances?.find((t)=>t.chainId === gasCosts[chainId].token.chainId && t.address === gasCosts[chainId].token.address)?.amount ?? 0);
                const insufficient = gasTokenBalance.lte(0) || gasTokenBalance.lt(gasCosts[chainId].gasAmount ?? (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0)) || gasTokenBalance.lt(gasCosts[chainId].tokenAmount ?? (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(0));
                const insufficientAmount = insufficient ? gasCosts[chainId].tokenAmount?.minus(gasTokenBalance) ?? gasCosts[chainId].gasAmount.minus(gasTokenBalance) : undefined;
                gasCosts[chainId] = {
                    ...gasCosts[chainId],
                    insufficient: insufficient,
                    insufficientAmount: insufficientAmount?.round(5, (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports))).roundUp),
                    chain: insufficient ? getChainById(chainId) : undefined
                };
            }
        });
        const gasCostResult = Object.values(gasCosts).filter((gasCost)=>gasCost.insufficient);
        return gasCostResult;
    }, {
        enabled: Boolean(account.address && route),
        refetchInterval: $4fde403c8cd0fba4$var$refetchInterval,
        staleTime: $4fde403c8cd0fba4$var$refetchInterval,
        cacheTime: $4fde403c8cd0fba4$var$refetchInterval
    });
    const isInsufficientGas = Boolean(insufficientGas?.length) && !isRefuelLoading && !enabledRefuel;
    return {
        insufficientGas: isInsufficientGas ? insufficientGas : undefined,
        isInitialLoading: isInitialLoading
    };
};



var $cZGFG = parcelRequire("cZGFG");
var $cdfc4e60aecac3af$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($cdfc4e60aecac3af$exports, "__esModule", {
    value: true
});
$cdfc4e60aecac3af$exports.default = void 0;

var $cdfc4e60aecac3af$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $cdfc4e60aecac3af$var$_default = $cdfc4e60aecac3af$exports.default = (0, $cdfc4e60aecac3af$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), "WarningRounded");





const $86a32990207a9785$export$6996528d1639c58a = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $df6885d8eb7cfb01$export$1fe9999661564b94), {
        display: "flex",
        children: [
            (0, $cZGFG.jsx)((0, $df6885d8eb7cfb01$export$80593e8ef4506f22), {
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cdfc4e60aecac3af$exports))), {
                    sx: {
                        marginTop: 2,
                        marginLeft: 2
                    }
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                variant: "body2",
                px: 2,
                pb: 2,
                pt: 2,
                children: t(`warning.message.insufficientFunds`)
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");




const $7659108dc68a7087$export$d76799653241d67d = ({ insufficientGas: insufficientGas })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $df6885d8eb7cfb01$export$1fe9999661564b94), {
        children: [
            (0, $cZGFG.jsxs)((0, $df6885d8eb7cfb01$export$80593e8ef4506f22), {
                display: "flex",
                alignItems: "center",
                px: 2,
                pt: 2,
                children: [
                    (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9955478a62ac183c$exports))), {
                        sx: {
                            marginRight: 1
                        }
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        variant: "body2",
                        fontWeight: 700,
                        children: t(`warning.title.insufficientGas`)
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                variant: "body2",
                px: 2,
                pt: 1,
                children: t(`warning.message.insufficientGas`)
            }),
            insufficientGas?.map((item, index)=>(0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    variant: "body2",
                    px: 2,
                    pb: insufficientGas?.length - 1 === index ? 2 : 0,
                    pt: 0.5,
                    children: t(`main.tokenOnChainAmount`, {
                        amount: item.insufficientAmount?.toString(),
                        tokenSymbol: item.token.symbol,
                        chainName: item.chain?.name
                    })
                }, index))
        ]
    });
};


const $222ddcb43da88869$export$2d75d7da0627a206 = ({ route: route, ...props })=>{
    const { insufficientGas: insufficientGas } = (0, $4fde403c8cd0fba4$export$219afe79026b8536)(route);
    const { insufficientFromToken: insufficientFromToken } = (0, $5841b638342b4fa9$export$3347879a42f96196)(route);
    const validInsufficientGas = insufficientGas?.length;
    return (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
        timeout: 225,
        in: Boolean(insufficientFromToken || validInsufficientGas),
        unmountOnExit: true,
        mountOnEnter: true,
        children: (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            ...props,
            children: insufficientFromToken ? (0, $cZGFG.jsx)((0, $86a32990207a9785$export$6996528d1639c58a), {}) : validInsufficientGas ? (0, $cZGFG.jsx)((0, $7659108dc68a7087$export$d76799653241d67d), {
                insufficientGas: insufficientGas
            }) : null
        })
    });
};



const $03dedad1b6577e6b$export$d83cc1372e9dded3 = (props)=>{
    const { routes: routes } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)();
    const currentRoute = routes?.[0];
    return (0, $cZGFG.jsx)((0, $222ddcb43da88869$export$2d75d7da0627a206), {
        route: currentRoute,
        ...props
    });
};




var $jjHhy = parcelRequire("jjHhy");
const $cd7ff4b96cdae14f$export$f06621d9ad29af97 = (0, $jjHhy.default)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039))({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    position: "relative"
});



var $cZGFG = parcelRequire("cZGFG");




var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");



var $4y4xl = parcelRequire("4y4xl");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");
var $7ZufN = parcelRequire("7ZufN");




var $bNgkT = parcelRequire("bNgkT");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $07d8875414641569$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $07d8875414641569$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            loading && "loading"
        ],
        startIcon: [
            loading && `startIconLoading${(0, $4y4xl.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $4y4xl.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            "loadingIndicator",
            loading && `loadingIndicator${(0, $4y4xl.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $86dcf517ba3ba2cd$export$24fdd7c0683a4fed), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $07d8875414641569$var$rootShouldForwardProp = (prop)=>prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as" && prop !== "classes";
const $07d8875414641569$var$LoadingButtonRoot = (0, $jjHhy.default)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>$07d8875414641569$var$rootShouldForwardProp(prop) || prop === "classes",
    name: "MuiLoadingButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        [`& .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === "center" && {
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).loading}`]: {
            color: "transparent"
        }
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        [`& .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        [`& .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $86dcf517ba3ba2cd$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $07d8875414641569$var$LoadingButtonLoadingIndicator = (0, $jjHhy.default)("span", {
    name: "MuiLoadingButton",
    slot: "LoadingIndicator",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $4y4xl.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        position: "absolute",
        visibility: "visible",
        display: "flex"
    }, ownerState.loadingPosition === "start" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        left: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "start" && ownerState.variant === "text" && {
        left: 6
    }, ownerState.loadingPosition === "center" && {
        left: "50%",
        transform: "translate(-50%)",
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === "end" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        right: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "end" && ownerState.variant === "text" && {
        right: 6
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        position: "relative",
        left: -10
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        position: "relative",
        right: -10
    }));
const $07d8875414641569$var$LoadingButton = /*#__PURE__*/ $dup7A.forwardRef(function LoadingButton(inProps, ref) {
    const contextProps = $dup7A.useContext((0, $e740a7bd42ab1ff6$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bNgkT.default)(contextProps, inProps);
    const props = (0, $7ZufN.default)({
        props: resolvedProps,
        name: "MuiLoadingButton"
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = "center", variant: variant = "text" } = props, other = (0, $bGxpK.default)(props, $07d8875414641569$var$_excluded);
    const id = (0, $59e5b3c850bbdd15$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $65a11d953b0c04a5$export$2e2bcd8739ae039), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $3G4eg.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $07d8875414641569$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $cZGFG.jsx)($07d8875414641569$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($07d8875414641569$var$LoadingButtonRoot, (0, $3G4eg.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === "end" ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === "end" ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $07d8875414641569$export$2e2bcd8739ae039 = $07d8875414641569$var$LoadingButton;






const $64045c4ec0f22d0f$export$f2dd1fb73bb18d9c = ({ onClick: onClick, text: text, disabled: disabled, loading: loading })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { walletManagement: walletManagement } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { account: account, connect: connect } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const handleClick = async ()=>{
        if (account.isActive) onClick?.();
        else if (walletManagement) await connect();
        else navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).selectWallet);
    };
    const getButtonText = ()=>{
        if (account.isActive) {
            if (text) return text;
        }
        return t(`button.connectWallet`);
    };
    return (0, $cZGFG.jsx)((0, $07d8875414641569$export$2e2bcd8739ae039), {
        variant: "contained",
        color: "primary",
        onClick: handleClick,
        disabled: disabled,
        loading: loading,
        loadingPosition: "center",
        fullWidth: true,
        children: getButtonText()
    });
};





const $07b0e9f0a3acbbd7$export$93756f4499f86d2b = ()=>{
    return (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>state.setExecutableRoute);
};



const $d04a850c903a3e8f$export$5712c6a61ac0c67e = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { isValid: isValid, isValidating: isValidating } = (0, $367773295ca041ba$export$606f11b2eb45ecc6)();
    const setExecutableRoute = (0, $07b0e9f0a3acbbd7$export$93756f4499f86d2b)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const splitState = (0, $5e8b8f7a49e68349$export$a7844f191cd50a20)((state)=>state.state);
    const { routes: routes } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)();
    const currentRoute = routes?.[0];
    const handleClick = async ()=>{
        if (currentRoute) {
            setExecutableRoute(currentRoute);
            navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution, {
                state: {
                    routeId: currentRoute.id
                }
            });
        }
    };
    const getButtonText = ()=>{
        if (currentRoute) switch(subvariant){
            case "nft":
                return t(`button.reviewPurchase`);
            case "refuel":
                return t(`button.reviewBridge`);
            default:
                const transactionType = currentRoute.fromChainId === currentRoute.toChainId ? "Swap" : "Bridge";
                return t(`button.review${transactionType}`);
        }
        else switch(subvariant){
            case "nft":
                return t(`button.buy`);
            case "refuel":
                return t(`button.getGas`);
            case "split":
                if (splitState) return t(`button.${splitState}`);
                return t(`button.exchange`);
            default:
                return t(`button.exchange`);
        }
    };
    return (0, $cZGFG.jsx)((0, $64045c4ec0f22d0f$export$f2dd1fb73bb18d9c), {
        text: getButtonText(),
        onClick: handleClick,
        disabled: currentRoute && (isValidating || !isValid)
    });
};


const $c3a7705c17635eb9$export$ceaf35c25d4b1fe2 = ()=>{
    const expandable = (0, $ea9b454d75cc3193$export$b7fefcff97a6bbf8)();
    const { subvariant: subvariant, contractComponent: contractComponent } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const nft = subvariant === "nft";
    return (0, $cZGFG.jsxs)((0, $cd7ff4b96cdae14f$export$f06621d9ad29af97), {
        disableGutters: true,
        children: [
            (0, $cZGFG.jsx)((0, $1fa3da4cb47a09c9$export$9c8f2a54692f7aed), {
                mx: 3,
                mt: 1,
                mb: 1
            }),
            nft ? (0, $cZGFG.jsx)((0, $7aeac184c64d60ca$export$e3ffc3645fcb5ea8), {
                mx: 3,
                mt: 1,
                mb: 1,
                children: contractComponent
            }) : null,
            (0, $cZGFG.jsx)((0, $3d6e2ba5bc37f625$export$d1bdbab86783985e), {
                mt: 1,
                mx: 3,
                mb: 2
            }),
            !nft ? (0, $cZGFG.jsx)((0, $cb4e9235e80bb22a$export$1a8f21b7e95bd816), {
                formType: "from",
                mx: 3,
                mb: 2
            }) : null,
            !expandable ? (0, $cZGFG.jsx)((0, $c14fc1f1ba0f1345$export$3565eb3d00ca5a74), {
                mx: 3,
                mb: 2
            }) : null,
            (0, $cZGFG.jsx)((0, $25605faffb283351$export$c83dd197f0386b9e), {
                mx: 3,
                mb: 2
            }),
            (0, $cZGFG.jsx)((0, $b142cba2da027a3f$export$f96732dcc82db8), {
                mx: 3,
                mb: 2
            }),
            (0, $cZGFG.jsx)((0, $03dedad1b6577e6b$export$d83cc1372e9dded3), {
                mx: 3,
                mb: 2
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                mx: 3,
                mb: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $d04a850c903a3e8f$export$5712c6a61ac0c67e), {}),
                    (0, $cZGFG.jsx)((0, $18517af472357d43$export$7771fdf68e7a837e), {})
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");

const $42acb71e74c74041$export$7ce1f551d78f9130 = ()=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const navigateBack = (0, $dup7A.useCallback)(()=>{
        // TODO: find a better router with nested memory routers support
        // https://github.com/remix-run/react-router/pull/9112
        // https://github.com/remix-run/react-router/discussions/9601
        //
        // if (window.history.length > 2) {
        navigate(-1);
    // } else {
    //   navigate(
    //     window.location.pathname.substring(
    //       0,
    //       window.location.pathname.lastIndexOf('/'),
    //     ) || '/',
    //     { replace: true },
    //   );
    // }
    }, [
        navigate
    ]);
    return {
        navigateBack: navigateBack,
        navigate: navigate
    };
};






var $jjHhy = parcelRequire("jjHhy");
const $cff7d32f27c9c849$export$694e0d28c7ffc90c = (0, $jjHhy.default)((0, $0fdecc513a2d3d55$export$2e2bcd8739ae039))(({ theme: theme })=>({
        position: "relative",
        padding: theme.spacing(1, 3)
    }));


const $96b3077f27b46816$export$ebde1f165243f87e = ()=>{
    const { navigateBack: navigateBack, navigate: navigate } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { routes: routes, isLoading: isLoading, isFetching: isFetching, dataUpdatedAt: dataUpdatedAt, refetchTime: refetchTime, refetch: refetch } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)();
    const setExecutableRoute = (0, $07b0e9f0a3acbbd7$export$93756f4499f86d2b)();
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const handleRouteClick = (route)=>{
        setExecutableRoute(route);
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution, {
            state: {
                routeId: route.id
            }
        });
    };
    (0, $dup7A.useEffect)(()=>{
        if (!routes?.length && !isLoading && !isFetching) navigateBack();
    // redirect to the home page if no routes are found on page reload
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $dup7A.useEffect)(()=>{
        return headerStoreContext.getState().setAction((0, $cZGFG.jsx)((0, $eb12012bc6102ab5$export$9ff79255ead4ffb5), {
            updatedAt: dataUpdatedAt || new Date().getTime(),
            timeToUpdate: refetchTime,
            isLoading: isFetching,
            onClick: ()=>refetch(),
            sx: {
                marginRight: -1
            },
            size: "medium",
            edge: "end"
        }));
    }, [
        dataUpdatedAt,
        headerStoreContext,
        isFetching,
        refetch,
        refetchTime
    ]);
    const routeNotFound = !routes?.length && !isLoading && !isFetching;
    return (0, $cZGFG.jsx)((0, $cff7d32f27c9c849$export$694e0d28c7ffc90c), {
        direction: "column",
        spacing: 2,
        flex: 1,
        children: routeNotFound ? (0, $cZGFG.jsx)((0, $346668b43c43be35$export$d9b32705cc00a1ab), {}) : isLoading ? Array.from({
            length: 3
        }).map((_, index)=>(0, $cZGFG.jsx)((0, $4c88d3e88750f71e$export$f6c2b491a88fe8ab), {}, index)) : routes?.map((route, index)=>(0, $cZGFG.jsx)((0, $748e91f2c262fb9d$export$d99fd5a1ae05e6cf), {
                route: route,
                onClick: ()=>handleRouteClick(route),
                active: index === 0,
                expanded: routes?.length <= 2
            }, route.id))
    });
};



var $cZGFG = parcelRequire("cZGFG");





var $cZFtK = parcelRequire("cZFtK");

const $dde5ac09ef900257$export$30031accdcb35d47 = ()=>{
    return (0, $69a4ee88cdb0522f$export$2dd9c4acc5986304)((state)=>[
            state.chainOrder,
            state.setChain
        ], (0, $cZFtK.shallow));
};


const $46eafddeeeff6ac0$export$ec26906862990ed9 = (formType)=>{
    const chainKey = (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType);
    const { field: { onChange: onChange, onBlur: onBlur } } = (0, $367773295ca041ba$export$e8c786024a2b0a79)({
        name: chainKey
    });
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const { chains: chains, isLoading: isLoading } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const [chainOrder, setChainOrder] = (0, $dde5ac09ef900257$export$30031accdcb35d47)();
    const swapOnly = (0, $420a652508d6fbf9$export$c4a81b0a847a209f)();
    const getChains = ()=>{
        if (!chains) return [];
        const selectedChains = chainOrder.map((chainId)=>chains.find((chain)=>chain.id === chainId)).filter(Boolean);
        return selectedChains;
    };
    const setCurrentChain = (chainId)=>{
        onChange(chainId);
        onBlur();
        if (swapOnly) setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey("to"), chainId, {
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType), "");
        setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getAmountKey(formType), "");
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).TokenSearchFilter, "");
        setChainOrder(chainId);
    };
    return {
        chainOrder: chainOrder,
        chains: chains,
        getChains: getChains,
        isLoading: isLoading,
        setChainOrder: setChainOrder,
        setCurrentChain: setCurrentChain
    };
};




var $jjHhy = parcelRequire("jjHhy");

const $7a9e74dd554f3c58$export$b3f67a2d87d5d23e = (0, $jjHhy.default)((0, $bc0432b5ba91b8e1$export$2e2bcd8739ae039))(({ theme: theme })=>({
        borderRadius: theme.shape.borderRadius,
        paddingLeft: theme.spacing(1.5),
        height: 56,
        "&:hover": {
            backgroundColor: (0, $a0eca89cce449dbc$export$8f4fcaa5200816dd)(theme.palette.mode, "4%")
        }
    }));





var $jjHhy = parcelRequire("jjHhy");
const $34b4d656d355bf22$export$da4f3923c9c71c37 = (0, $jjHhy.default)((0, $ced3bf777dc38827$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`.${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).primary}`]: {
            fontWeight: 400
        }
    }));




var $dup7A = parcelRequire("dup7A");


const $013386f5bd69200e$export$512b37692f9f43f3 = (formType, onClick)=>{
    const tokenKey = (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(formType);
    const { field: { onChange: onChange, onBlur: onBlur } } = (0, $367773295ca041ba$export$e8c786024a2b0a79)({
        name: tokenKey
    });
    const { setValue: setValue, getValues: getValues } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const emitter = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    return (0, $dup7A.useCallback)((tokenAddress, chainId)=>{
        onChange(tokenAddress);
        onBlur();
        const selectedChainId = chainId ?? getValues((0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType));
        // Set chain again to trigger URL builder update
        setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType), selectedChainId, {
            shouldDirty: true,
            shouldTouch: true
        });
        setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getAmountKey(formType), "");
        const oppositeFormType = formType === "from" ? "to" : "from";
        const [selectedOppositeToken, selectedOppositeChainId] = getValues([
            (0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(oppositeFormType),
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(oppositeFormType)
        ]);
        if (selectedOppositeToken === tokenAddress && selectedOppositeChainId === selectedChainId && subvariant !== "nft") setValue((0, $98260d45445f6983$export$69d9321fdf06d524).getTokenKey(oppositeFormType), "", {
            shouldDirty: true,
            shouldTouch: true
        });
        const eventToEmit = formType === "from" ? (0, $1828d6f4ded3174a$export$ce4aabad2e495c53).SourceChainTokenSelected : (0, $1828d6f4ded3174a$export$ce4aabad2e495c53).DestinationChainTokenSelected;
        emitter.emit(eventToEmit, {
            chainId: selectedChainId,
            tokenAddress: tokenAddress
        });
        onClick?.();
    }, [
        emitter,
        formType,
        getValues,
        onBlur,
        onChange,
        onClick,
        setValue,
        subvariant
    ]);
};



const $bdd2db4ad27ca836$export$e5956f5838b80deb = ({ formType: formType, selectNativeToken: selectNativeToken })=>{
    const { navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { chains: chains, setCurrentChain: setCurrentChain } = (0, $46eafddeeeff6ac0$export$ec26906862990ed9)(formType);
    const selectToken = (0, $013386f5bd69200e$export$512b37692f9f43f3)(formType, navigateBack);
    const handleClick = async (chain)=>{
        if (selectNativeToken) selectToken(chain.nativeToken.address, chain.id);
        else {
            setCurrentChain(chain.id);
            navigateBack();
        }
    };
    return (0, $cZGFG.jsx)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
            sx: {
                paddingLeft: 1.5,
                paddingRight: 1.5
            },
            children: chains?.map((chain)=>(0, $cZGFG.jsxs)((0, $7a9e74dd554f3c58$export$b3f67a2d87d5d23e), {
                    onClick: ()=>handleClick(chain),
                    children: [
                        (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                            children: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                                src: chain.logoURI,
                                alt: chain.name,
                                children: chain.name[0]
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $34b4d656d355bf22$export$da4f3923c9c71c37), {
                            primary: chain.name
                        })
                    ]
                }, chain.id))
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $a34289fdcbd5dc94$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($a34289fdcbd5dc94$exports, "__esModule", {
    value: true
});
$a34289fdcbd5dc94$exports.default = void 0;

var $a34289fdcbd5dc94$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $a34289fdcbd5dc94$var$_default = $a34289fdcbd5dc94$exports.default = (0, $a34289fdcbd5dc94$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckBox");


var $84afbce49070f554$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($84afbce49070f554$exports, "__esModule", {
    value: true
});
$84afbce49070f554$exports.default = void 0;

var $84afbce49070f554$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $84afbce49070f554$var$_default = $84afbce49070f554$exports.default = (0, $84afbce49070f554$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "CheckBoxOutlineBlankOutlined");


var $cf54f448f79fbac1$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($cf54f448f79fbac1$exports, "__esModule", {
    value: true
});
$cf54f448f79fbac1$exports.default = void 0;

var $cf54f448f79fbac1$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $cf54f448f79fbac1$var$_default = $cf54f448f79fbac1$exports.default = (0, $cf54f448f79fbac1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
}), "CheckBoxOutlined");


var $69ca26817ab0ef4d$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($69ca26817ab0ef4d$exports, "__esModule", {
    value: true
});
$69ca26817ab0ef4d$exports.default = void 0;

var $69ca26817ab0ef4d$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $69ca26817ab0ef4d$var$_default = $69ca26817ab0ef4d$exports.default = (0, $69ca26817ab0ef4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zM7 11h10v2H7z"
}), "IndeterminateCheckBoxOutlined");




var $dup7A = parcelRequire("dup7A");

var $cZFtK = parcelRequire("cZFtK");




const $d518138af9fbf856$export$746cb67d959fd2b5 = ()=>{
    const lifi = (0, $b5765cf84e356f6b$export$cc1b3fea1f55c92e)();
    const { bridges: bridges, exchanges: exchanges } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { data: data } = (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)([
        "tools"
    ], async ()=>{
        const tools = await lifi.getTools();
        return {
            bridges: tools.bridges.filter((bridge)=>(0, $cf40533b594545d4$export$5d91ca4c93de7266)(bridge.key, bridges)),
            exchanges: tools.exchanges.filter((exchange)=>(0, $cf40533b594545d4$export$5d91ca4c93de7266)(exchange.key, exchanges))
        };
    }, {
        onSuccess (data) {
            const { initializeTools: initializeTools } = (0, $80ac256836e84b51$export$772cdd5f573abcc9).getState();
            initializeTools("Bridges", data.bridges.map((bridge)=>bridge.key));
            initializeTools("Exchanges", data.exchanges.map((exchange)=>exchange.key));
        },
        refetchInterval: 180000,
        staleTime: 180000
    });
    return {
        tools: data
    };
};




var $jjHhy = parcelRequire("jjHhy");

const $2848ef8954825a67$export$b3f67a2d87d5d23e = (0, $jjHhy.default)((0, $7a9e74dd554f3c58$export$b3f67a2d87d5d23e))(({ theme: theme })=>({
        paddingRight: theme.spacing(1)
    }));


const $dfffc17238ad625c$export$ccc4668d06bbb9a5 = ({ type: type })=>{
    const typeKey = type.toLowerCase();
    const { tools: tools } = (0, $d518138af9fbf856$export$746cb67d959fd2b5)();
    const [enabledTools, setTools] = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>[
            state[`enabled${type}`],
            state.setTools
        ], (0, $cZFtK.shallow));
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const handleClick = (key)=>{
        if (!tools) return;
        const toolKeys = tools[typeKey].map((tool)=>tool.key);
        if (enabledTools?.includes(key)) setTools(type, enabledTools.filter((toolKey)=>toolKey !== key), toolKeys);
        else setTools(type, [
            ...enabledTools,
            key
        ], toolKeys);
    };
    (0, $dup7A.useEffect)(()=>{
        const allToolsSelected = tools?.[typeKey].length === enabledTools.length;
        const toggleCheckboxes = ()=>{
            if (!tools) return;
            const toolKeys = tools[typeKey].map((tool)=>tool.key);
            if (allToolsSelected) setTools(type, [], toolKeys);
            else setTools(type, toolKeys, toolKeys);
        };
        return headerStoreContext.getState().setAction((0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
            size: "medium",
            edge: "end",
            onClick: toggleCheckboxes,
            children: allToolsSelected ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf54f448f79fbac1$exports))), {}) : enabledTools.length ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69ca26817ab0ef4d$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84afbce49070f554$exports))), {})
        }));
    }, [
        enabledTools.length,
        headerStoreContext,
        setTools,
        tools,
        type,
        typeKey
    ]);
    return (0, $cZGFG.jsx)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
            sx: {
                paddingLeft: 1.5,
                paddingRight: 1.5
            },
            children: tools?.[typeKey].map((tool)=>(0, $cZGFG.jsxs)((0, $2848ef8954825a67$export$b3f67a2d87d5d23e), {
                    onClick: ()=>handleClick(tool.key),
                    children: [
                        (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                            children: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                                src: tool.logoURI,
                                alt: tool.name,
                                children: tool.name[0]
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $34b4d656d355bf22$export$da4f3923c9c71c37), {
                            primary: tool.name
                        }),
                        enabledTools?.includes(tool.key) ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a34289fdcbd5dc94$exports))), {
                            color: "primary"
                        }) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84afbce49070f554$exports))), {})
                    ]
                }, tool.name))
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");








var $jjHhy = parcelRequire("jjHhy");

const $a22285ba9d340d26$export$a6c5436a7391f2af = (0, $jjHhy.default)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41))({
    display: "grid",
    placeItems: "center",
    minWidth: 52,
    height: 56
});
const $a22285ba9d340d26$export$66feaf1e3dc56cd0 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(52px, 1fr))",
        gridAutoRows: "56px",
        justifyContent: "space-between",
        gap: theme.spacing(1.5)
    }));



const $3680a068472acf7f$export$650829afb5cca8be = ({ formType: formType })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { chainOrder: chainOrder, chains: chains, getChains: getChains, isLoading: isLoading, setChainOrder: setChainOrder, setCurrentChain: setCurrentChain } = (0, $46eafddeeeff6ac0$export$ec26906862990ed9)(formType);
    const [chainId] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType)
        ]
    });
    const hasChainInOrderedList = chainOrder.includes(chainId);
    // If we don't have a chain in the ordered chain list we should add it.
    if (!hasChainInOrderedList) setChainOrder(chainId);
    const showAllChains = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1)[`${formType}Chain`]);
    };
    const chainsToHide = (chains?.length ?? 0) - (0, $95883be0589c1da3$export$8bac4e0f2426fc98);
    return (0, $cZGFG.jsxs)((0, $a22285ba9d340d26$export$66feaf1e3dc56cd0), {
        children: [
            isLoading ? Array.from({
                length: (0, $95883be0589c1da3$export$8bac4e0f2426fc98) + 1
            }).map((_, index)=>(0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "rectangular",
                    width: 56,
                    height: 56,
                    sx: {
                        borderRadius: 1
                    }
                }, index)) : getChains().map((chain)=>(0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                    title: chain.name,
                    placement: "top",
                    enterDelay: 400,
                    arrow: true,
                    children: (0, $cZGFG.jsx)((0, $a22285ba9d340d26$export$a6c5436a7391f2af), {
                        onClick: ()=>setCurrentChain(chain.id),
                        variant: chainId === chain.id ? "selected" : "default",
                        children: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                            src: chain.logoURI,
                            alt: chain.key,
                            sx: {
                                width: 40,
                                height: 40
                            },
                            children: chain.name[0]
                        })
                    })
                }, chain.id)),
            chainsToHide > 0 ? (0, $cZGFG.jsx)((0, $a22285ba9d340d26$export$a6c5436a7391f2af), {
                onClick: showAllChains,
                children: (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    sx: {
                        width: 40,
                        height: 40,
                        display: "grid",
                        placeItems: "center"
                    },
                    children: (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 500,
                        children: [
                            "+",
                            chainsToHide
                        ]
                    })
                })
            }) : null
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
var $6bea372cc781c739$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($6bea372cc781c739$exports, "__esModule", {
    value: true
});
$6bea372cc781c739$exports.default = void 0;

var $6bea372cc781c739$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $6bea372cc781c739$var$_default = $6bea372cc781c739$exports.default = (0, $6bea372cc781c739$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3 6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19z"
    }, "0"),
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M6.47 10.82 4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
    }, "1")
], "SearchOff");







const $e661a5e793850695$export$ff805e3beb5e5b34 = ({ formType: formType })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const [selectedChainId] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType)
        ]
    });
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            flex: 1,
            padding: 3
        },
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 48,
                lineHeight: 1,
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bea372cc781c739$exports))), {
                    fontSize: "inherit"
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 14,
                color: "text.secondary",
                textAlign: "center",
                mt: 2,
                px: 2,
                children: t("info.message.emptyTokenList", {
                    chainName: getChainById(selectedChainId)?.name
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");

function $4b6de1fc0e4de1ac$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $4b6de1fc0e4de1ac$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $4b6de1fc0e4de1ac$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $4b6de1fc0e4de1ac$export$61fc7d43ac8f84b0 = (fn, ms)=>{
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $c042dde0009611c1$export$76974b428a49f15b = (index)=>index;
const $c042dde0009611c1$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $c042dde0009611c1$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $c042dde0009611c1$var$addEventListenerOptions = {
    passive: true
};
const $c042dde0009611c1$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $c042dde0009611c1$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $c042dde0009611c1$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $c042dde0009611c1$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $c042dde0009611c1$var$supportsScrollend ? ()=>void 0 : (0, $4b6de1fc0e4de1ac$export$61fc7d43ac8f84b0)(()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollLeft" : "scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c042dde0009611c1$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c042dde0009611c1$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c042dde0009611c1$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    let offset = 0;
    const fallback = $c042dde0009611c1$var$supportsScrollend ? ()=>void 0 : (0, $4b6de1fc0e4de1ac$export$61fc7d43ac8f84b0)(()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $c042dde0009611c1$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $c042dde0009611c1$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $c042dde0009611c1$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $c042dde0009611c1$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $c042dde0009611c1$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $c042dde0009611c1$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $c042dde0009611c1$export$76974b428a49f15b,
                rangeExtractor: $c042dde0009611c1$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $c042dde0009611c1$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                ...opts2
            };
        };
        this.notify = (force, sync)=>{
            var _a, _b;
            const { startIndex: startIndex, endIndex: endIndex } = this.range ?? {
                startIndex: void 0,
                endIndex: void 0
            };
            const range = this.calculateRange();
            if (force || startIndex !== (range == null ? void 0 : range.startIndex) || endIndex !== (range == null ? void 0 : range.endIndex)) (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.notify(false, false);
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.scrollOffset < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    const prevIsScrolling = this.isScrolling;
                    this.isScrolling = isScrolling;
                    this.notify(prevIsScrolling !== isScrolling, isScrolling);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getMeasurementOptions = (0, $4b6de1fc0e4de1ac$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $4b6de1fc0e4de1ac$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $4b6de1fc0e4de1ac$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $c042dde0009611c1$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $4b6de1fc0e4de1ac$export$7c73462e0d25e514)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(true, false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $4b6de1fc0e4de1ac$export$7c73462e0d25e514)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $4b6de1fc0e4de1ac$export$9a1adf421b69c6a)(measurements[$c042dde0009611c1$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $4b6de1fc0e4de1ac$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $4b6de1fc0e4de1ac$export$9a1adf421b69c6a)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $4b6de1fc0e4de1ac$export$8a4f1dcc58a69dbd)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            var _a, _b;
            this.itemSizeCache = /* @__PURE__ */ new Map();
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.notify(false, false);
    }
}
const $c042dde0009611c1$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $c042dde0009611c1$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $c042dde0009611c1$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $4c539737c2a16c9f$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $dup7A.useLayoutEffect : $dup7A.useEffect;
function $4c539737c2a16c9f$var$useVirtualizerBase(options) {
    const rerender = $dup7A.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $e10f5070fc836746$exports.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $dup7A.useState(()=>new (0, $c042dde0009611c1$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $dup7A.useEffect(()=>{
        return instance._didMount();
    }, []);
    $4c539737c2a16c9f$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $4c539737c2a16c9f$export$dd6d526d88b5a137(options) {
    return $4c539737c2a16c9f$var$useVirtualizerBase({
        observeElementRect: $c042dde0009611c1$export$5a50ff2cde8c3802,
        observeElementOffset: $c042dde0009611c1$export$fbc040aee017375a,
        scrollToFn: (0, $c042dde0009611c1$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $4c539737c2a16c9f$export$645722dcac657cb9(options) {
    return $4c539737c2a16c9f$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $c042dde0009611c1$export$e911b82c7a99311),
        observeElementOffset: (0, $c042dde0009611c1$export$518998f8c5d09287),
        scrollToFn: (0, $c042dde0009611c1$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}



var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
var $8f3ce3003f3baaf9$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($8f3ce3003f3baaf9$exports, "__esModule", {
    value: true
});
$8f3ce3003f3baaf9$exports.default = void 0;

var $8f3ce3003f3baaf9$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $8f3ce3003f3baaf9$var$_default = $8f3ce3003f3baaf9$exports.default = (0, $8f3ce3003f3baaf9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1M14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1"
}), "OpenInNewRounded");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $5cb647808a482a69$export$d6efab9620b78fec(slot) {
    return (0, $8iNDC.default)("MuiLink", slot);
}
const $5cb647808a482a69$var$linkClasses = (0, $fc1pF.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $5cb647808a482a69$export$2e2bcd8739ae039 = $5cb647808a482a69$var$linkClasses;



var $5NdnQ = parcelRequire("5NdnQ");

var $emmvO = parcelRequire("emmvO");
const $c3028491acfe998a$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $c3028491acfe998a$var$transformDeprecatedColors = (color)=>{
    return $c3028491acfe998a$export$c4e140d5d351182b[color] || color;
};
const $c3028491acfe998a$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $c3028491acfe998a$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $5NdnQ.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $5NdnQ.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $emmvO.alpha)(color, 0.4);
};
var $c3028491acfe998a$export$2e2bcd8739ae039 = $c3028491acfe998a$var$getTextDecoration;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $8e9053afbc4d5b0b$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $8e9053afbc4d5b0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $4y4xl.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $5cb647808a482a69$export$d6efab9620b78fec), classes);
};
const $8e9053afbc4d5b0b$var$LinkRoot = (0, $jjHhy.default)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $4y4xl.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $3G4eg.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $3G4eg.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $c3028491acfe998a$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $5cb647808a482a69$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $8e9053afbc4d5b0b$var$Link = /*#__PURE__*/ $dup7A.forwardRef(function Link(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $bGxpK.default)(props, $8e9053afbc4d5b0b$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $e1af0238f772e7e3$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $dup7A.useState(false);
    const handlerRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $8e9053afbc4d5b0b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($8e9053afbc4d5b0b$var$LinkRoot, (0, $3G4eg.default)({
        color: color,
        className: (0, $aJAJS.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $c3028491acfe998a$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $8e9053afbc4d5b0b$export$2e2bcd8739ae039 = $8e9053afbc4d5b0b$var$Link;



var $dup7A = parcelRequire("dup7A");

const $d5d1c02a6b00bbed$export$e6e2bc9967bf256c = (address)=>address ? `${address.substring(0, 5)}...${address.substring(address.length - 4)}` : null;






var $jjHhy = parcelRequire("jjHhy");

const $4abbf5060aed15c2$export$b3f67a2d87d5d23e = (0, $jjHhy.default)((0, $7a9e74dd554f3c58$export$b3f67a2d87d5d23e))(({ theme: theme })=>({
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        height: 64,
        width: "100%"
    }));
const $4abbf5060aed15c2$export$a7b06bfba60a8a78 = (0, $jjHhy.default)((0, $497c2145bd685a21$export$2e2bcd8739ae039))(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        height: 64,
        flexDirection: "column",
        alignItems: "flex-start",
        padding: theme.spacing(0, 1.5),
        [`.${(0, $9248fa0ee28b36bd$export$2e2bcd8739ae039).root}`]: {
            right: theme.spacing(3)
        },
        [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).primary}`]: {
            height: 22
        },
        [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).primary}, & .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).secondary}`]: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    }));
const $4abbf5060aed15c2$export$c25acd513dcc8062 = (0, $jjHhy.default)((0, $510dba830cc31c9a$export$2e2bcd8739ae039))(({ theme: theme })=>({
        lineHeight: 1,
        fontSize: "0.75rem",
        fontWeight: 400,
        padding: theme.spacing(0.375, 0.375),
        marginLeft: theme.spacing(0.25),
        color: "inherit",
        backgroundColor: "unset",
        minWidth: "unset",
        borderRadius: "50%",
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.04) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.08)
        },
        svg: {
            fontSize: "0.875rem"
        }
    }));


const $2b48541a54905380$export$3cd2c2efa7a0fbbb = (0, $dup7A.memo)(({ onClick: onClick, size: size, start: start, token: token, chain: chain, showBalance: showBalance, isBalanceLoading: isBalanceLoading, startAdornment: startAdornment, endAdornment: endAdornment })=>{
    const handleClick = ()=>onClick?.(token.address);
    return (0, $cZGFG.jsxs)((0, $4abbf5060aed15c2$export$a7b06bfba60a8a78), {
        disablePadding: true,
        style: {
            height: `${size}px`,
            transform: `translateY(${start}px)`
        },
        children: [
            startAdornment,
            (0, $cZGFG.jsx)($2b48541a54905380$export$3fdea91c245a250e, {
                token: token,
                chain: chain,
                showBalance: showBalance,
                isBalanceLoading: isBalanceLoading,
                onClick: handleClick
            }),
            endAdornment
        ]
    });
});
const $2b48541a54905380$export$3fdea91c245a250e = ({ onClick: onClick, token: token, chain: chain, showBalance: showBalance, isBalanceLoading: isBalanceLoading })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const tokenPrice = (0, $2a25b0bfe67ae18c$export$78792d27fa2fce59)(token.amount, token.priceUSD);
    const container = (0, $dup7A.useRef)(null);
    const timeoutId = (0, $dup7A.useRef)();
    const [showAddress, setShowAddress] = (0, $dup7A.useState)(false);
    const onMouseEnter = ()=>{
        timeoutId.current = setTimeout(()=>setShowAddress(true), 350);
    };
    const onMouseLeave = ()=>{
        clearTimeout(timeoutId.current);
        if (showAddress) setShowAddress(false);
    };
    return (0, $cZGFG.jsxs)((0, $4abbf5060aed15c2$export$b3f67a2d87d5d23e), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        dense: true,
        children: [
            (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                children: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                    src: token.logoURI,
                    alt: token.symbol,
                    children: token.symbol?.[0]
                })
            }),
            (0, $cZGFG.jsx)((0, $ced3bf777dc38827$export$2e2bcd8739ae039), {
                primary: token.symbol,
                secondaryTypographyProps: {
                    component: "div"
                },
                secondary: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    position: "relative",
                    height: 20,
                    ref: container,
                    children: [
                        (0, $cZGFG.jsx)((0, $096557c2b2cf6c97$export$2e2bcd8739ae039), {
                            direction: "down",
                            in: !showAddress,
                            container: container.current,
                            style: {
                                position: "absolute"
                            },
                            appear: false,
                            children: (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                pt: 0.25,
                                children: token.name
                            })
                        }),
                        (0, $cZGFG.jsx)((0, $096557c2b2cf6c97$export$2e2bcd8739ae039), {
                            direction: "up",
                            in: showAddress,
                            container: container.current,
                            style: {
                                position: "absolute"
                            },
                            appear: false,
                            mountOnEnter: true,
                            children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                display: "flex",
                                children: [
                                    (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        alignItems: "center",
                                        pt: 0.125,
                                        children: (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(token.address)
                                    }),
                                    (0, $cZGFG.jsx)((0, $4abbf5060aed15c2$export$c25acd513dcc8062), {
                                        size: "small",
                                        LinkComponent: (0, $8e9053afbc4d5b0b$export$2e2bcd8739ae039),
                                        href: `${chain?.metamask.blockExplorerUrls[0]}address/${token.address}`,
                                        target: "_blank",
                                        rel: "nofollow noreferrer",
                                        onClick: (e)=>e.stopPropagation(),
                                        children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8f3ce3003f3baaf9$exports))), {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showBalance ? isBalanceLoading ? (0, $cZGFG.jsx)($2b48541a54905380$export$d51a6d8091dd54a8, {}) : (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    textAlign: "right"
                },
                children: [
                    Number(token.amount) ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        variant: "body1",
                        noWrap: true,
                        children: t("format.number", {
                            value: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token.amount)
                        })
                    }) : null,
                    tokenPrice ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 400,
                        fontSize: 12,
                        color: "text.secondary",
                        "data-price": token.priceUSD,
                        children: t(`format.currency`, {
                            value: tokenPrice
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
const $2b48541a54905380$export$2808796de5ffe690 = ()=>{
    return (0, $cZGFG.jsxs)((0, $4abbf5060aed15c2$export$a7b06bfba60a8a78), {
        secondaryAction: (0, $cZGFG.jsx)($2b48541a54905380$export$d51a6d8091dd54a8, {}),
        disablePadding: true,
        sx: {
            position: "relative",
            flexDirection: "row",
            alignItems: "center"
        },
        children: [
            (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                children: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "circular",
                    width: 32,
                    height: 32,
                    sx: {
                        marginLeft: 1.5,
                        marginRight: 2
                    }
                })
            }),
            (0, $cZGFG.jsx)((0, $ced3bf777dc38827$export$2e2bcd8739ae039), {
                primary: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "text",
                    width: 48,
                    height: 20
                }),
                secondary: (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                    variant: "text",
                    width: 96,
                    height: 20
                })
            })
        ]
    });
};
const $2b48541a54905380$export$d51a6d8091dd54a8 = ()=>{
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end"
        },
        children: [
            (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                variant: "text",
                width: 56,
                height: 24
            }),
            (0, $cZGFG.jsx)((0, $d5ac3ea486321678$export$2e2bcd8739ae039), {
                variant: "text",
                width: 48,
                height: 18
            })
        ]
    });
};


const $195fd968fb0b658b$export$dca87cbda757b99e = ({ tokens: tokens, featuredTokensLength: featuredTokensLength, scrollElementRef: scrollElementRef, chainId: chainId, chain: chain, isLoading: isLoading, isBalanceLoading: isBalanceLoading, showBalance: showBalance, showFeatured: showFeatured, onClick: onClick })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const hasFeaturedTokens = !!featuredTokensLength && showFeatured;
    const featuredTokensLastIndex = (featuredTokensLength ?? 0) - 1;
    const tokensLastIndex = tokens.length - 1;
    const { getVirtualItems: getVirtualItems, getTotalSize: getTotalSize, scrollToIndex: scrollToIndex } = (0, $4c539737c2a16c9f$export$dd6d526d88b5a137)({
        count: tokens.length,
        getScrollElement: ()=>scrollElementRef.current,
        overscan: 10,
        paddingEnd: 12,
        estimateSize: (index)=>{
            // heigth of TokenListItem
            let size = 64;
            if (!hasFeaturedTokens) return size;
            if (index === 0 && tokens[index]?.featured) // height of startAdornment
            size += 24;
            if (index === featuredTokensLastIndex && index !== tokensLastIndex && tokens[index]?.featured) // height of endAdornment
            size += 32;
            return size;
        },
        getItemKey: (index)=>`${tokens[index].address}-${index}`
    });
    (0, $dup7A.useEffect)(()=>{
        if (getVirtualItems().length) scrollToIndex(0, {
            align: "start"
        });
    }, [
        scrollToIndex,
        chainId,
        getVirtualItems
    ]);
    if (isLoading) return (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
        disablePadding: true,
        children: Array.from({
            length: 3
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            (0, $cZGFG.jsx)((0, $2b48541a54905380$export$2808796de5ffe690), {}, index))
    });
    return (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
        style: {
            height: getTotalSize()
        },
        disablePadding: true,
        children: getVirtualItems().map((item)=>{
            const token = tokens[item.index];
            return (0, $cZGFG.jsx)((0, $2b48541a54905380$export$3cd2c2efa7a0fbbb), {
                onClick: onClick,
                size: item.size,
                start: item.start,
                token: token,
                chain: chain,
                isBalanceLoading: isBalanceLoading,
                showBalance: showBalance,
                startAdornment: hasFeaturedTokens && token.featured && item.index === 0 ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 1,
                    px: 2,
                    pb: 1.25,
                    children: t("main.featuredTokens")
                }) : null,
                endAdornment: hasFeaturedTokens && token.featured && item.index === featuredTokensLastIndex && item.index !== tokensLastIndex ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 1,
                    px: 2,
                    py: 1.25,
                    children: t("main.otherTokens")
                }) : null
            }, item.key);
        })
    });
};



const $b20ad9181fa23f6f$export$24d4785067273813 = ({ formType: formType, height: height, onClick: onClick })=>{
    const parentRef = (0, $dup7A.useRef)(null);
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const [selectedChainId] = (0, $367773295ca041ba$export$3c773aa2b84f29e0)({
        name: [
            (0, $98260d45445f6983$export$69d9321fdf06d524).getChainKey(formType)
        ]
    });
    const [tokenSearchFilter] = (0, $833ae500abec472a$export$d2b8bdb5925c555f)([
        (0, $98260d45445f6983$export$cf3347e5e7e1bef5).TokenSearchFilter
    ], 320);
    const { chain: chain, isLoading: isChainLoading } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(selectedChainId);
    const { tokens: chainTokens, tokensWithBalance: tokensWithBalance, isLoading: isTokensLoading, isBalanceLoading: isBalanceLoading, featuredTokens: featuredTokens } = (0, $71ff1ba0752dd2af$export$5ecd82d0a6d2bff6)(selectedChainId);
    let filteredTokens = tokensWithBalance ?? chainTokens ?? [];
    const searchFilter = tokenSearchFilter?.replaceAll("$", "")?.toUpperCase() ?? "";
    filteredTokens = tokenSearchFilter ? filteredTokens.filter((token)=>token.name.toUpperCase().includes(searchFilter) || token.symbol.toUpperCase().includes(searchFilter) || token.address.toUpperCase().includes(searchFilter)) : filteredTokens;
    const tokenSearchEnabled = !isTokensLoading && !filteredTokens.length && !!tokenSearchFilter && !!selectedChainId;
    const { token: searchedToken, isLoading: isSearchedTokenLoading } = (0, $d7d129fc68322cb5$export$865d60499a0ea4f0)(selectedChainId, tokenSearchFilter, tokenSearchEnabled);
    const isLoading = isTokensLoading || isChainLoading || tokenSearchEnabled && isSearchedTokenLoading;
    const tokens = filteredTokens.length ? filteredTokens : searchedToken ? [
        searchedToken
    ] : filteredTokens;
    const handleTokenClick = (0, $013386f5bd69200e$export$512b37692f9f43f3)(formType, onClick);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        ref: parentRef,
        style: {
            height: height,
            overflow: "auto"
        },
        children: [
            !tokens.length && !isLoading ? (0, $cZGFG.jsx)((0, $e661a5e793850695$export$ff805e3beb5e5b34), {
                formType: formType
            }) : null,
            (0, $cZGFG.jsx)((0, $195fd968fb0b658b$export$dca87cbda757b99e), {
                tokens: tokens,
                featuredTokensLength: featuredTokens?.length,
                scrollElementRef: parentRef,
                chainId: selectedChainId,
                chain: chain,
                isLoading: isLoading,
                isBalanceLoading: isBalanceLoading,
                showBalance: account.isActive,
                showFeatured: !tokenSearchFilter,
                onClick: handleTokenClick
            })
        ]
    });
};



var $dup7A = parcelRequire("dup7A");



const $a872f3383e413d03$var$getContentHeight = (elementId)=>{
    const containerElement = document.getElementById((0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).ScrollableContainer, elementId));
    const headerElement = document.getElementById((0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).Header, elementId));
    if (!containerElement || !headerElement) {
        console.warn(`Can't find ${(0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).ScrollableContainer} or ${(0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).Header} id.`);
        return 0;
    }
    const { height: containerHeight } = containerElement.getBoundingClientRect();
    const { height: headerHeight } = headerElement.getBoundingClientRect();
    return containerHeight - headerHeight;
};
const $a872f3383e413d03$export$1a3fa3380e91d2f = ()=>{
    const elementId = (0, $43dd2a9adf98ce26$export$15dd38f06036bd30)();
    const [contentHeight, setContentHeight] = (0, $dup7A.useState)(0);
    (0, $dup7A.useLayoutEffect)(()=>{
        setContentHeight($a872f3383e413d03$var$getContentHeight(elementId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return contentHeight;
};
const $a872f3383e413d03$export$954e3a846cea0a52 = (ref)=>{
    const elementId = (0, $43dd2a9adf98ce26$export$15dd38f06036bd30)();
    (0, $dup7A.useLayoutEffect)(()=>{
        const scrollableContainer = (0, $ce8a180a0be6eb02$export$320287ee38b8cccd)(elementId);
        if (!scrollableContainer || !ref.current || ref.current?.clientHeight <= scrollableContainer?.clientHeight) return;
        scrollableContainer.style.height = `${ref.current.clientHeight}px`;
        return ()=>{
            scrollableContainer.style.removeProperty("height");
        };
    }, [
        elementId,
        ref
    ]);
};



var $cZGFG = parcelRequire("cZGFG");
var $185e3e53f2b245b7$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($185e3e53f2b245b7$exports, "__esModule", {
    value: true
});
$185e3e53f2b245b7$exports.default = void 0;

var $185e3e53f2b245b7$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $185e3e53f2b245b7$var$_default = $185e3e53f2b245b7$exports.default = (0, $185e3e53f2b245b7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");




var $dup7A = parcelRequire("dup7A");





var $jjHhy = parcelRequire("jjHhy");



var $jjHhy = parcelRequire("jjHhy");
const $1bd38b4381d5e5f5$export$f5b8910cec6cf069 = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.background.paper,
        paddingRight: theme.spacing(2),
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}`]: {
            padding: theme.spacing(1.5, 1, 1.5, 2),
            height: "2.875em",
            boxSizing: "inherit"
        }
    }));


const $55214967326346b9$export$f5b8910cec6cf069 = (0, $jjHhy.default)((0, $1bd38b4381d5e5f5$export$f5b8910cec6cf069))(({ theme: theme })=>({
        paddingRight: theme.spacing(1.5)
    }));


const $09844be0b62b001e$export$63bb9e69c2a29cd2 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { register: register, setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    (0, $dup7A.useEffect)(()=>()=>{
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).TokenSearchFilter, "");
        }, [
        setValue
    ]);
    return (0, $cZGFG.jsx)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        children: (0, $cZGFG.jsx)((0, $e860bb7daa30c730$export$2e2bcd8739ae039), {
            fullWidth: true,
            children: (0, $cZGFG.jsx)((0, $55214967326346b9$export$f5b8910cec6cf069), {
                size: "small",
                placeholder: t(`main.tokenSearch`),
                defaultValue: "",
                endAdornment: (0, $cZGFG.jsx)((0, $024bdefb4f58bf2e$export$2e2bcd8739ae039), {
                    position: "end",
                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($185e3e53f2b245b7$exports))), {})
                }),
                inputProps: {
                    inputMode: "search",
                    ...register((0, $98260d45445f6983$export$cf3347e5e7e1bef5).TokenSearchFilter)
                },
                autoComplete: "off"
            })
        })
    });
};


const $a6d2d4ef9e269917$var$minTokenListHeight = 360;
const $a6d2d4ef9e269917$export$e89506ee3b10dad2 = ({ formType: formType })=>{
    (0, $ce8a180a0be6eb02$export$d57c167c005d744a)();
    const { navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const headerRef = (0, $dup7A.useRef)(null);
    const contentHeight = (0, $a872f3383e413d03$export$1a3fa3380e91d2f)();
    const [tokenListHeight, setTokenListHeight] = (0, $dup7A.useState)(0);
    const swapOnly = (0, $420a652508d6fbf9$export$c4a81b0a847a209f)();
    (0, $dup7A.useLayoutEffect)(()=>{
        setTokenListHeight(Math.max(contentHeight - (headerRef.current?.offsetHeight ?? 0), $a6d2d4ef9e269917$var$minTokenListHeight));
    }, [
        contentHeight
    ]);
    const hideChainSelect = swapOnly && formType === "to";
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                pt: 1,
                pb: 2,
                px: 3,
                ref: headerRef,
                children: [
                    !hideChainSelect ? (0, $cZGFG.jsx)((0, $3680a068472acf7f$export$650829afb5cca8be), {
                        formType: formType
                    }) : null,
                    (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        mt: !hideChainSelect ? 2 : 0,
                        children: (0, $cZGFG.jsx)((0, $09844be0b62b001e$export$63bb9e69c2a29cd2), {})
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $b20ad9181fa23f6f$export$24d4785067273813), {
                height: tokenListHeight,
                onClick: navigateBack,
                formType: formType
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");



var $dup7A = parcelRequire("dup7A");






const $95cddf1b891ddca9$export$a3514100e01c02be = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { connect: connect } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const [walletIdentity, setWalletIdentity] = (0, $dup7A.useState)({
        show: false
    });
    const [wallets, setWallets] = (0, $dup7A.useState)();
    const isDesktopView = (0, $b15e80d6e5586a57$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up("sm"));
    const closeDialog = ()=>{
        setWalletIdentity((state)=>({
                ...state,
                show: false
            }));
    };
    const handleConnect = (0, $dup7A.useCallback)(async (wallet)=>{
        const identityCheckPassed = await wallet.installed();
        if (!identityCheckPassed) {
            setWalletIdentity({
                show: true,
                wallet: wallet
            });
            return;
        }
        navigateBack();
        await connect(wallet);
    }, [
        connect,
        navigateBack
    ]);
    (0, $dup7A.useEffect)(()=>{
        Promise.all((0, $be6d26b6a5a22008$export$40169737307666b4).map((wallet)=>wallet.installed())).then((installed)=>{
            // separate into installed and not installed wallets
            const installedWallets = (0, $be6d26b6a5a22008$export$40169737307666b4).filter((_, index)=>installed[index]);
            // always remove Default Wallet from not installed Wallets
            const notInstalledWallets = (0, $be6d26b6a5a22008$export$40169737307666b4).filter((wallet, index)=>!installed[index] && wallet.name !== "Default Wallet");
            const allowedWallets = [
                ...installedWallets
            ];
            if (isDesktopView) allowedWallets.push(...notInstalledWallets);
            setWallets(allowedWallets);
        });
    }, []);
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: [
            (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 1.5,
                    paddingRight: 1.5
                },
                children: wallets?.map((wallet)=>(0, $cZGFG.jsxs)((0, $7a9e74dd554f3c58$export$b3f67a2d87d5d23e), {
                        onClick: ()=>handleConnect(wallet),
                        children: [
                            (0, $cZGFG.jsx)((0, $e53d295c232cfe79$export$2e2bcd8739ae039), {
                                children: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                                    src: wallet.icon.src || wallet.icon,
                                    alt: wallet.name,
                                    children: wallet.name[0]
                                })
                            }),
                            (0, $cZGFG.jsx)((0, $34b4d656d355bf22$export$da4f3923c9c71c37), {
                                primary: wallet.name
                            })
                        ]
                    }, wallet.name))
            }),
            (0, $cZGFG.jsxs)((0, $f719477393eb6354$export$3ddf2d174ce01153), {
                open: walletIdentity.show,
                onClose: closeDialog,
                children: [
                    (0, $cZGFG.jsx)((0, $da3939ee95c82076$export$2e2bcd8739ae039), {
                        children: (0, $cZGFG.jsx)((0, $1f0b92c5665aa4ca$export$2e2bcd8739ae039), {
                            children: t("wallet.extensionNotFound", {
                                name: walletIdentity.wallet?.name
                            })
                        })
                    }),
                    (0, $cZGFG.jsx)((0, $20eff1c46eaadcad$export$2e2bcd8739ae039), {
                        children: (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                            variant: "contained",
                            onClick: closeDialog,
                            autoFocus: true,
                            children: t("button.ok")
                        })
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $cZGFG = parcelRequire("cZGFG");
var $bc1a65b72853e59c$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($bc1a65b72853e59c$exports, "__esModule", {
    value: true
});
$bc1a65b72853e59c$exports.default = void 0;

var $bc1a65b72853e59c$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $bc1a65b72853e59c$var$_default = $bc1a65b72853e59c$exports.default = (0, $bc1a65b72853e59c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6"
}), "Brightness4");


var $2a492b47680cb11b$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($2a492b47680cb11b$exports, "__esModule", {
    value: true
});
$2a492b47680cb11b$exports.default = void 0;

var $2a492b47680cb11b$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $2a492b47680cb11b$var$_default = $2a492b47680cb11b$exports.default = (0, $2a492b47680cb11b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1"
}), "DarkMode");


var $3134672f4943a056$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($3134672f4943a056$exports, "__esModule", {
    value: true
});
$3134672f4943a056$exports.default = void 0;

var $3134672f4943a056$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $3134672f4943a056$var$_default = $3134672f4943a056$exports.default = (0, $3134672f4943a056$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5M2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1m18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1M11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1m0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1M5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0z"
}), "LightMode");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");
parcelRequire("8vAu6");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $dup7A = parcelRequire("dup7A");
function $2c88f88f2e0d0c5b$export$2e2bcd8739ae039(children) {
    return $dup7A.Children.toArray(children).filter((child)=>/*#__PURE__*/ $dup7A.isValidElement(child));
}



var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $854b57a353a58706$export$44aa3ae5b353cef1(slot) {
    return (0, $8iNDC.default)("MuiToggleButtonGroup", slot);
}
const $854b57a353a58706$var$toggleButtonGroupClasses = (0, $fc1pF.default)("MuiToggleButtonGroup", [
    "root",
    "selected",
    "vertical",
    "disabled",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "fullWidth",
    "firstButton",
    "lastButton",
    "middleButton"
]);
var $854b57a353a58706$export$2e2bcd8739ae039 = $854b57a353a58706$var$toggleButtonGroupClasses;



var $dup7A = parcelRequire("dup7A");
/**
 * @ignore - internal component.
 */ const $2cfc0ceb204f6f85$var$ToggleButtonGroupContext = /*#__PURE__*/ $dup7A.createContext({});
var $2cfc0ceb204f6f85$export$2e2bcd8739ae039 = $2cfc0ceb204f6f85$var$ToggleButtonGroupContext;



var $dup7A = parcelRequire("dup7A");
/**
 * @ignore - internal component.
 */ const $3129e9131d114b8a$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $dup7A.createContext(undefined);
var $3129e9131d114b8a$export$2e2bcd8739ae039 = $3129e9131d114b8a$var$ToggleButtonGroupButtonContext;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $6e8bb7ab21d90cb7$export$21f89b560b65a301(slot) {
    return (0, $8iNDC.default)("MuiToggleButton", slot);
}
const $6e8bb7ab21d90cb7$var$toggleButtonClasses = (0, $fc1pF.default)("MuiToggleButton", [
    "root",
    "disabled",
    "selected",
    "standard",
    "primary",
    "secondary",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "fullWidth"
]);
var $6e8bb7ab21d90cb7$export$2e2bcd8739ae039 = $6e8bb7ab21d90cb7$var$toggleButtonClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $fc51c2335d2e07c0$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $fc51c2335d2e07c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $4y4xl.default)(orientation)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $854b57a353a58706$export$44aa3ae5b353cef1), classes);
};
const $fc51c2335d2e07c0$var$ToggleButtonGroupRoot = (0, $jjHhy.default)("div", {
    name: "MuiToggleButtonGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $4y4xl.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).grouped}`]: (0, $3G4eg.default)({}, ownerState.orientation === "horizontal" ? {
            [`&.${(0, $854b57a353a58706$export$2e2bcd8739ae039).selected} + .${(0, $854b57a353a58706$export$2e2bcd8739ae039).grouped}.${(0, $854b57a353a58706$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $854b57a353a58706$export$2e2bcd8739ae039).selected} + .${(0, $854b57a353a58706$export$2e2bcd8739ae039).grouped}.${(0, $854b57a353a58706$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === "horizontal" ? {
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).firstButton},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).lastButton},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: "1px solid transparent",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).firstButton},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).lastButton},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: "1px solid transparent",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === "horizontal" ? {
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).lastButton}.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).disabled},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: "1px solid transparent"
        }
    } : {
        [`& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).lastButton}.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).disabled},& .${(0, $854b57a353a58706$export$2e2bcd8739ae039).middleButton}.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: "1px solid transparent"
        }
    }));
const $fc51c2335d2e07c0$var$ToggleButtonGroup = /*#__PURE__*/ $dup7A.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiToggleButtonGroup"
    });
    const { children: children, className: className, color: color = "standard", disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = "horizontal", size: size = "medium", value: value } = props, other = (0, $bGxpK.default)(props, $fc51c2335d2e07c0$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $fc51c2335d2e07c0$var$useUtilityClasses(ownerState);
    const handleChange = $dup7A.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $dup7A.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $dup7A.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $2c88f88f2e0d0c5b$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)($fc51c2335d2e07c0$var$ToggleButtonGroupRoot, (0, $3G4eg.default)({
        role: "group",
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2cfc0ceb204f6f85$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3129e9131d114b8a$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $fc51c2335d2e07c0$export$2e2bcd8739ae039 = $fc51c2335d2e07c0$var$ToggleButtonGroup;







var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $bNgkT = parcelRequire("bNgkT");

var $2wgr3 = parcelRequire("2wgr3");



var $4y4xl = parcelRequire("4y4xl");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");



// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $07132cdfe00b1832$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $83e1ff312285940b$var$_excluded = [
    "value"
], $83e1ff312285940b$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $83e1ff312285940b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled",
            fullWidth && "fullWidth",
            `size${(0, $4y4xl.default)(size)}`,
            color
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $6e8bb7ab21d90cb7$export$21f89b560b65a301), classes);
};
const $83e1ff312285940b$var$ToggleButtonRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    name: "MuiToggleButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $4y4xl.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === "standard" ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === "standard" ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === "standard" ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $3G4eg.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`&.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        "&:hover": {
            textDecoration: "none",
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === "small" && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $83e1ff312285940b$var$ToggleButton = /*#__PURE__*/ $dup7A.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $dup7A.useContext((0, $2cfc0ceb204f6f85$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $bGxpK.default)(_React$useContext, $83e1ff312285940b$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $dup7A.useContext((0, $3129e9131d114b8a$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bNgkT.default)((0, $3G4eg.default)({}, contextProps, {
        selected: (0, $07132cdfe00b1832$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $7ZufN.default)({
        props: resolvedProps,
        name: "MuiToggleButton"
    });
    const { children: children, className: className, color: color = "standard", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = "medium", value: value } = props, other = (0, $bGxpK.default)(props, $83e1ff312285940b$var$_excluded2);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $83e1ff312285940b$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $cZGFG.jsx)($83e1ff312285940b$var$ToggleButtonRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $83e1ff312285940b$export$2e2bcd8739ae039 = $83e1ff312285940b$var$ToggleButton;



var $jjHhy = parcelRequire("jjHhy");

const $ca38ea7cbf6c8d6c$export$d2b052e7b4be1756 = (0, $jjHhy.default)((0, $83e1ff312285940b$export$2e2bcd8739ae039))(({ theme: theme })=>({
        textTransform: "none",
        borderRadius: theme.shape.borderRadius,
        borderColor: theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800],
        [`&.${(0, $6e8bb7ab21d90cb7$export$2e2bcd8739ae039).selected}`]: {
            color: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light,
            borderColor: "currentColor !important"
        }
    }));


const $0a1b6bd577a06edb$export$fd2972c21a03f7b9 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const [appearance, setAppearance] = (0, $f8c8844dd4dd78cf$export$39f27e3f9a019cbb)();
    if (hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).Appearance)) return null;
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        pb: 2,
        children: (0, $cZGFG.jsxs)((0, $fc51c2335d2e07c0$export$2e2bcd8739ae039), {
            color: "primary",
            value: appearance,
            onChange: (_, value)=>{
                if (value) setAppearance(value);
            },
            exclusive: true,
            fullWidth: true,
            children: [
                (0, $cZGFG.jsxs)((0, $ca38ea7cbf6c8d6c$export$d2b052e7b4be1756), {
                    value: "light",
                    children: [
                        (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3134672f4943a056$exports))), {
                            sx: {
                                marginRight: 1
                            }
                        }),
                        t("button.light")
                    ]
                }),
                (0, $cZGFG.jsxs)((0, $ca38ea7cbf6c8d6c$export$d2b052e7b4be1756), {
                    value: "dark",
                    children: [
                        (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2a492b47680cb11b$exports))), {
                            sx: {
                                marginRight: 1
                            }
                        }),
                        t("button.dark")
                    ]
                }),
                (0, $cZGFG.jsxs)((0, $ca38ea7cbf6c8d6c$export$d2b052e7b4be1756), {
                    value: "auto",
                    children: [
                        (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bc1a65b72853e59c$exports))), {
                            sx: {
                                marginRight: 1
                            }
                        }),
                        t("button.auto")
                    ]
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $65425f7fa52bcb9e$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($65425f7fa52bcb9e$exports, "__esModule", {
    value: true
});
$65425f7fa52bcb9e$exports.default = void 0;

var $65425f7fa52bcb9e$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $65425f7fa52bcb9e$var$_default = $65425f7fa52bcb9e$exports.default = (0, $65425f7fa52bcb9e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");






var $cZFtK = parcelRequire("cZFtK");





var $jjHhy = parcelRequire("jjHhy");

const $5c2fa0714b89ac1c$export$b3f67a2d87d5d23e = (0, $jjHhy.default)((0, $7a9e74dd554f3c58$export$b3f67a2d87d5d23e))(({ theme: theme })=>({
        height: 48,
        paddingRight: theme.spacing(0.5)
    }));
const $5c2fa0714b89ac1c$export$da4f3923c9c71c37 = (0, $jjHhy.default)((0, $ced3bf777dc38827$export$2e2bcd8739ae039))({
    [`.${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).primary}`]: {
        fontWeight: 400,
        fontSize: "1rem"
    }
});


const $08d9e02f9fc951c4$export$225f85434b248369 = ({ type: type })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const [enabledTools, tools] = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>{
        const enabledTools = Object.values(state[`_enabled${type}`] ?? {});
        return [
            enabledTools.filter(Boolean).length,
            enabledTools.length
        ];
    }, (0, $cZFtK.shallow));
    const handleClick = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1)[type.toLowerCase()]);
    };
    return (0, $cZGFG.jsxs)((0, $5c2fa0714b89ac1c$export$b3f67a2d87d5d23e), {
        onClick: handleClick,
        children: [
            (0, $cZGFG.jsx)((0, $5c2fa0714b89ac1c$export$da4f3923c9c71c37), {
                primary: t(`settings.enabled${type}`)
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                children: [
                    (0, $cZGFG.jsx)((0, $5c2fa0714b89ac1c$export$da4f3923c9c71c37), {
                        primary: `${enabledTools}/${tools}`
                    }),
                    (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($65425f7fa52bcb9e$exports))), {})
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $6948928f378d97d8$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($6948928f378d97d8$exports, "__esModule", {
    value: true
});
$6948928f378d97d8$exports.default = void 0;

var $6948928f378d97d8$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $6948928f378d97d8$var$_default = $6948928f378d97d8$exports.default = (0, $6948928f378d97d8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");





var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $165ee4cc13ee6d25$export$46f01d01378ec5a2(slot) {
    return (0, $8iNDC.default)("MuiDivider", slot);
}
const $165ee4cc13ee6d25$var$dividerClasses = (0, $fc1pF.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $165ee4cc13ee6d25$export$2e2bcd8739ae039 = $165ee4cc13ee6d25$var$dividerClasses;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $9fd460fb6166bfca$export$81478e24460c57f2(slot) {
    return (0, $8iNDC.default)("MuiListItemIcon", slot);
}
const $9fd460fb6166bfca$var$listItemIconClasses = (0, $fc1pF.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $9fd460fb6166bfca$export$2e2bcd8739ae039 = $9fd460fb6166bfca$var$listItemIconClasses;




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $634bec21c7a731b8$export$515f8c67b5305377(slot) {
    return (0, $8iNDC.default)("MuiMenuItem", slot);
}
const $634bec21c7a731b8$var$menuItemClasses = (0, $fc1pF.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $634bec21c7a731b8$export$2e2bcd8739ae039 = $634bec21c7a731b8$var$menuItemClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $1a43c5555fb20cd2$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1a43c5555fb20cd2$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1a43c5555fb20cd2$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $634bec21c7a731b8$export$515f8c67b5305377), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $1a43c5555fb20cd2$var$MenuItemRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $1a43c5555fb20cd2$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $emmvO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $165ee4cc13ee6d25$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $165ee4cc13ee6d25$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $dfa991117ab0a5da$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9fd460fb6166bfca$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $3G4eg.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9fd460fb6166bfca$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $1a43c5555fb20cd2$var$MenuItem = /*#__PURE__*/ $dup7A.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $bGxpK.default)(props, $1a43c5555fb20cd2$var$_excluded);
    const context = $dup7A.useContext((0, $fa61e1e507b3416c$export$2e2bcd8739ae039));
    const childContext = $dup7A.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $dup7A.useRef(null);
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $3G4eg.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1a43c5555fb20cd2$var$useUtilityClasses(props);
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa61e1e507b3416c$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($1a43c5555fb20cd2$var$MenuItemRoot, (0, $3G4eg.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $aJAJS.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $aJAJS.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1a43c5555fb20cd2$export$2e2bcd8739ae039 = $1a43c5555fb20cd2$var$MenuItem;





var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $gmeoE = parcelRequire("gmeoE");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $e50cx = parcelRequire("e50cx");

var $dup7A = parcelRequire("dup7A");
parcelRequire("8vAu6");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");



var $2dc45eea0aa813fa$export$2e2bcd8739ae039 = (0, $c6658e3849b4f86d$export$2e2bcd8739ae039);



var $4y4xl = parcelRequire("4y4xl");

var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");
parcelRequire("8vAu6");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");




var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");
parcelRequire("8vAu6");




var $427d509f03acd2fd$export$2e2bcd8739ae039 = (0, $e3308ed46a76465c$export$2e2bcd8739ae039);





var $cZGFG = parcelRequire("cZGFG");
"use client";
const $c07b18a9dbf1912c$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $c07b18a9dbf1912c$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $c07b18a9dbf1912c$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $c07b18a9dbf1912c$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $c07b18a9dbf1912c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$c07b18a9dbf1912c$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $c07b18a9dbf1912c$var$MenuList = /*#__PURE__*/ $dup7A.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $bGxpK.default)(props, $c07b18a9dbf1912c$var$_excluded);
    const listRef = $dup7A.useRef(null);
    const textCriteriaRef = $dup7A.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $dup7A.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $427d509f03acd2fd$export$2e2bcd8739ae039)((0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $c07b18a9dbf1912c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c07b18a9dbf1912c$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $c07b18a9dbf1912c$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c07b18a9dbf1912c$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $c07b18a9dbf1912c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c07b18a9dbf1912c$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $c07b18a9dbf1912c$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c07b18a9dbf1912c$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $c07b18a9dbf1912c$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $c07b18a9dbf1912c$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $c07b18a9dbf1912c$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dup7A.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $dup7A.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $dup7A.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $dup7A.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $025f7c64e2fa0248$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $c07b18a9dbf1912c$export$2e2bcd8739ae039 = $c07b18a9dbf1912c$var$MenuList;



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");






var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");








var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $8782cdccc9459b8a$export$88f455dd56c95edb(slot) {
    return (0, $8iNDC.default)("MuiPopover", slot);
}
const $8782cdccc9459b8a$var$popoverClasses = (0, $fc1pF.default)("MuiPopover", [
    "root",
    "paper"
]);
var $8782cdccc9459b8a$export$2e2bcd8739ae039 = $8782cdccc9459b8a$var$popoverClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $67b8b1b1285af41b$var$_excluded = [
    "onEntering"
], $67b8b1b1285af41b$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $67b8b1b1285af41b$var$_excluded3 = [
    "slotProps"
];
function $67b8b1b1285af41b$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $67b8b1b1285af41b$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $67b8b1b1285af41b$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $67b8b1b1285af41b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $67b8b1b1285af41b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $8782cdccc9459b8a$export$88f455dd56c95edb), classes);
};
const $67b8b1b1285af41b$export$bcce13685275fc99 = (0, $jjHhy.default)((0, $6a8e94f31f514acc$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $67b8b1b1285af41b$export$821346c38a2d9390 = (0, $jjHhy.default)((0, $929a5b6600d07d14$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $67b8b1b1285af41b$var$Popover = /*#__PURE__*/ $dup7A.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $651a53450047d63f$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $bGxpK.default)(props.TransitionProps, $67b8b1b1285af41b$var$_excluded), other = (0, $bGxpK.default)(props, $67b8b1b1285af41b$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $dup7A.useRef();
    const handlePaperRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $3G4eg.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $67b8b1b1285af41b$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $dup7A.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $67b8b1b1285af41b$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $67b8b1b1285af41b$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $67b8b1b1285af41b$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $dup7A.useCallback((elemRect)=>{
        return {
            vertical: $67b8b1b1285af41b$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $67b8b1b1285af41b$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $dup7A.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $67b8b1b1285af41b$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $c118840f30ef889d$export$2e2bcd8739ae039)($67b8b1b1285af41b$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $67b8b1b1285af41b$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $dup7A.useState(open);
    const setPositioningStyles = $dup7A.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $dup7A.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $dup7A.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $dup7A.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $dup7A.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $9cb364921dbb34c4$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $c118840f30ef889d$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)($67b8b1b1285af41b$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $67b8b1b1285af41b$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $67b8b1b1285af41b$export$821346c38a2d9390;
    const paperProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $3G4eg.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $3G4eg.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $aJAJS.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $bGxpK.default)(_useSlotProps, $67b8b1b1285af41b$var$_excluded3);
    return /*#__PURE__*/ (0, $cZGFG.jsx)(RootSlot, (0, $3G4eg.default)({}, rootProps, !(0, $305e5bd3d224e36e$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)(TransitionComponent, (0, $3G4eg.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $cZGFG.jsx)(PaperSlot, (0, $3G4eg.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $67b8b1b1285af41b$export$2e2bcd8739ae039 = $67b8b1b1285af41b$var$Popover;



var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $eb4b8de9191c7017$export$2cf86a63a84fe23d(slot) {
    return (0, $8iNDC.default)("MuiMenu", slot);
}
const $eb4b8de9191c7017$var$menuClasses = (0, $fc1pF.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $eb4b8de9191c7017$export$2e2bcd8739ae039 = $eb4b8de9191c7017$var$menuClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $a3e4f10aa5e563e2$var$_excluded = [
    "onEntering"
], $a3e4f10aa5e563e2$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $a3e4f10aa5e563e2$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $a3e4f10aa5e563e2$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $a3e4f10aa5e563e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $eb4b8de9191c7017$export$2cf86a63a84fe23d), classes);
};
const $a3e4f10aa5e563e2$var$MenuRoot = (0, $jjHhy.default)((0, $67b8b1b1285af41b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $a3e4f10aa5e563e2$export$4f7c51a5920c9f33 = (0, $jjHhy.default)((0, $67b8b1b1285af41b$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $a3e4f10aa5e563e2$var$MenuMenuList = (0, $jjHhy.default)((0, $c07b18a9dbf1912c$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $a3e4f10aa5e563e2$var$Menu = /*#__PURE__*/ $dup7A.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $bGxpK.default)(props.TransitionProps, $a3e4f10aa5e563e2$var$_excluded), other = (0, $bGxpK.default)(props, $a3e4f10aa5e563e2$var$_excluded2);
    const isRtl = (0, $3397d1bce61a3d2d$export$b2dd014b6c321cb)();
    const ownerState = (0, $3G4eg.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $a3e4f10aa5e563e2$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $dup7A.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $dup7A.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $dup7A.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $a3e4f10aa5e563e2$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($a3e4f10aa5e563e2$var$MenuRoot, (0, $3G4eg.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $a3e4f10aa5e563e2$var$RTL_ORIGIN : $a3e4f10aa5e563e2$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $3G4eg.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($a3e4f10aa5e563e2$var$MenuMenuList, (0, $3G4eg.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $aJAJS.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $a3e4f10aa5e563e2$export$2e2bcd8739ae039 = $a3e4f10aa5e563e2$var$Menu;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

var $4y4xl = parcelRequire("4y4xl");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $9f08dd6f48fffe3b$export$1ee13051fd9e2ab5(slot) {
    return (0, $8iNDC.default)("MuiNativeSelect", slot);
}
const $9f08dd6f48fffe3b$var$nativeSelectClasses = (0, $fc1pF.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $9f08dd6f48fffe3b$export$2e2bcd8739ae039 = $9f08dd6f48fffe3b$var$nativeSelectClasses;



var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $d51a67c4e4ed338c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $d51a67c4e4ed338c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $4y4xl.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $9f08dd6f48fffe3b$export$1ee13051fd9e2ab5), classes);
};
const $d51a67c4e4ed338c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $3G4eg.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $9f08dd6f48fffe3b$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $d51a67c4e4ed338c$var$NativeSelectSelect = (0, $jjHhy.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $dDUuw.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $9f08dd6f48fffe3b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($d51a67c4e4ed338c$export$c1eccd1617458c87);
const $d51a67c4e4ed338c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $9f08dd6f48fffe3b$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $d51a67c4e4ed338c$var$NativeSelectIcon = (0, $jjHhy.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4y4xl.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($d51a67c4e4ed338c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $d51a67c4e4ed338c$var$NativeSelectInput = /*#__PURE__*/ $dup7A.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $bGxpK.default)(props, $d51a67c4e4ed338c$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $d51a67c4e4ed338c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($d51a67c4e4ed338c$var$NativeSelectSelect, (0, $3G4eg.default)({
                ownerState: ownerState,
                className: (0, $aJAJS.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $cZGFG.jsx)($d51a67c4e4ed338c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $d51a67c4e4ed338c$export$2e2bcd8739ae039 = $d51a67c4e4ed338c$var$NativeSelectInput;




var $jjHhy = parcelRequire("jjHhy");
var $f199g = parcelRequire("f199g");



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $8cbe4ff94a4175e2$export$2c0c1ee5a3392e(slot) {
    return (0, $8iNDC.default)("MuiSelect", slot);
}
const $8cbe4ff94a4175e2$var$selectClasses = (0, $fc1pF.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $8cbe4ff94a4175e2$export$2e2bcd8739ae039 = $8cbe4ff94a4175e2$var$selectClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
var $73801f280163b1e7$var$_span;
const $73801f280163b1e7$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $73801f280163b1e7$var$SelectSelect = (0, $jjHhy.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $d51a67c4e4ed338c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $73801f280163b1e7$var$SelectIcon = (0, $jjHhy.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4y4xl.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $d51a67c4e4ed338c$export$e7a817afd12a40d0));
const $73801f280163b1e7$var$SelectNativeInput = (0, $jjHhy.default)("input", {
    shouldForwardProp: (prop)=>(0, $f199g.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $73801f280163b1e7$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $73801f280163b1e7$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $73801f280163b1e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $4y4xl.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $8cbe4ff94a4175e2$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $73801f280163b1e7$var$SelectInput = /*#__PURE__*/ $dup7A.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $bGxpK.default)(props, $73801f280163b1e7$var$_excluded);
    const [value, setValueState] = (0, $c3c9d27e53aed175$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $c3c9d27e53aed175$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $dup7A.useRef(null);
    const displayRef = $dup7A.useRef(null);
    const [displayNode, setDisplayNode] = $dup7A.useState(null);
    const { current: isOpenControlled } = $dup7A.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $dup7A.useState();
    const handleRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $dup7A.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $dup7A.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $dup7A.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $dup7A.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $dup7A.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $dup7A.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $03e0b1a9e5bed7fb$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $dup7A.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $e50cx.default)(2));
            selected = value.some((v)=>$73801f280163b1e7$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $73801f280163b1e7$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $dup7A.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $3G4eg.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $73801f280163b1e7$var$useUtilityClasses(ownerState);
    const paperProps = (0, $3G4eg.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $3f196c06f251b8ff$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($73801f280163b1e7$var$SelectSelect, (0, $3G4eg.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $aJAJS.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $73801f280163b1e7$var$isEmpty(display) ? $73801f280163b1e7$var$_span || ($73801f280163b1e7$var$_span = /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $cZGFG.jsx)($73801f280163b1e7$var$SelectNativeInput, (0, $3G4eg.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $cZGFG.jsx)($73801f280163b1e7$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $a3e4f10aa5e563e2$export$2e2bcd8739ae039), (0, $3G4eg.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $3G4eg.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $3G4eg.default)({}, MenuProps.slotProps, {
                    paper: (0, $3G4eg.default)({}, paperProps, {
                        style: (0, $3G4eg.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $73801f280163b1e7$export$2e2bcd8739ae039 = $73801f280163b1e7$var$SelectInput;




parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $72dad9721f095796$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $2wgr3 = parcelRequire("2wgr3");

var $gmeoE = parcelRequire("gmeoE");



var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");

var $3G4eg = parcelRequire("3G4eg");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");

function $368ec4e8195c11f3$export$cdb270390122322b(slot) {
    return (0, $8iNDC.default)("MuiInput", slot);
}
const $368ec4e8195c11f3$var$inputClasses = (0, $3G4eg.default)({}, (0, $8febbde539987675$export$2e2bcd8739ae039), (0, $fc1pF.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $368ec4e8195c11f3$export$2e2bcd8739ae039 = $368ec4e8195c11f3$var$inputClasses;




var $cZGFG = parcelRequire("cZGFG");
"use client";
const $fdd06a390a83faaa$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $fdd06a390a83faaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $368ec4e8195c11f3$export$cdb270390122322b), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $fdd06a390a83faaa$var$InputRoot = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8dd1262a4b8be7e8$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $3G4eg.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $368ec4e8195c11f3$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $368ec4e8195c11f3$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $368ec4e8195c11f3$export$2e2bcd8739ae039).disabled}, .${(0, $368ec4e8195c11f3$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $368ec4e8195c11f3$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $fdd06a390a83faaa$var$InputInput = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $8dd1262a4b8be7e8$export$cf507b112810e72d)
})({});
const $fdd06a390a83faaa$var$Input = /*#__PURE__*/ $dup7A.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $bGxpK.default)(props, $fdd06a390a83faaa$var$_excluded);
    const classes = $fdd06a390a83faaa$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $gmeoE.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $fdd06a390a83faaa$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $fdd06a390a83faaa$var$InputInput;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$fdd06a390a83faaa$var$Input.muiName = "Input";
var $fdd06a390a83faaa$export$2e2bcd8739ae039 = $fdd06a390a83faaa$var$Input;




var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");

var $gmeoE = parcelRequire("gmeoE");



var $2wgr3 = parcelRequire("2wgr3");


var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $7ZufN = parcelRequire("7ZufN");

var $3G4eg = parcelRequire("3G4eg");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");

function $e9fe4f700ea26acb$export$3331e419f1a48437(slot) {
    return (0, $8iNDC.default)("MuiFilledInput", slot);
}
const $e9fe4f700ea26acb$var$filledInputClasses = (0, $3G4eg.default)({}, (0, $8febbde539987675$export$2e2bcd8739ae039), (0, $fc1pF.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $e9fe4f700ea26acb$export$2e2bcd8739ae039 = $e9fe4f700ea26acb$var$filledInputClasses;




var $cZGFG = parcelRequire("cZGFG");
"use client";
const $6f3fdb113ae1652b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $6f3fdb113ae1652b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $e9fe4f700ea26acb$export$3331e419f1a48437), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $6f3fdb113ae1652b$var$FilledInputRoot = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8dd1262a4b8be7e8$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $3G4eg.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).disabled}, .${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $e9fe4f700ea26acb$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $3G4eg.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $6f3fdb113ae1652b$var$FilledInputInput = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $8dd1262a4b8be7e8$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $6f3fdb113ae1652b$var$FilledInput = /*#__PURE__*/ $dup7A.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $bGxpK.default)(props, $6f3fdb113ae1652b$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $6f3fdb113ae1652b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $gmeoE.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $6f3fdb113ae1652b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $6f3fdb113ae1652b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$6f3fdb113ae1652b$var$FilledInput.muiName = "Input";
var $6f3fdb113ae1652b$export$2e2bcd8739ae039 = $6f3fdb113ae1652b$var$FilledInput;



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");



var $2wgr3 = parcelRequire("2wgr3");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");
parcelRequire("dup7A");


var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $3b31d16a03e88431$var$_span;
const $3b31d16a03e88431$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $3b31d16a03e88431$var$NotchedOutlineRoot = (0, $jjHhy.default)("fieldset", {
    shouldForwardProp: (0, $dDUuw.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $3b31d16a03e88431$var$NotchedOutlineLegend = (0, $jjHhy.default)("legend", {
    shouldForwardProp: (0, $dDUuw.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $3G4eg.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $3b31d16a03e88431$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $bGxpK.default)(props, $3b31d16a03e88431$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $3G4eg.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3b31d16a03e88431$var$NotchedOutlineRoot, (0, $3G4eg.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)($3b31d16a03e88431$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                children: label
            }) : $3b31d16a03e88431$var$_span || ($3b31d16a03e88431$var$_span = /*#__PURE__*/ (0, $cZGFG.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $3G4eg = parcelRequire("3G4eg");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");

function $b82d43853ee2dae4$export$89922944c7227687(slot) {
    return (0, $8iNDC.default)("MuiOutlinedInput", slot);
}
const $b82d43853ee2dae4$var$outlinedInputClasses = (0, $3G4eg.default)({}, (0, $8febbde539987675$export$2e2bcd8739ae039), (0, $fc1pF.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $b82d43853ee2dae4$export$2e2bcd8739ae039 = $b82d43853ee2dae4$var$outlinedInputClasses;




var $7ZufN = parcelRequire("7ZufN");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $74d3dc6090c26fa8$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $74d3dc6090c26fa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2wgr3.default)(slots, (0, $b82d43853ee2dae4$export$89922944c7227687), classes);
    return (0, $3G4eg.default)({}, classes, composedClasses);
};
const $74d3dc6090c26fa8$var$OutlinedInputRoot = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $8dd1262a4b8be7e8$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $3G4eg.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).focused} .${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).error} .${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).disabled} .${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $3G4eg.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $74d3dc6090c26fa8$var$NotchedOutlineRoot = (0, $jjHhy.default)((0, $3b31d16a03e88431$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $74d3dc6090c26fa8$var$OutlinedInputInput = (0, $jjHhy.default)((0, $8dd1262a4b8be7e8$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $8dd1262a4b8be7e8$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $74d3dc6090c26fa8$var$OutlinedInput = /*#__PURE__*/ $dup7A.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $bGxpK.default)(props, $74d3dc6090c26fa8$var$_excluded);
    const classes = $74d3dc6090c26fa8$var$useUtilityClasses(props);
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)();
    const fcs = (0, $20c375fdd6e9cd4d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $74d3dc6090c26fa8$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $74d3dc6090c26fa8$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8dd1262a4b8be7e8$export$2e2bcd8739ae039), (0, $3G4eg.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $cZGFG.jsx)($74d3dc6090c26fa8$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $3G4eg.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$74d3dc6090c26fa8$var$OutlinedInput.muiName = "Input";
var $74d3dc6090c26fa8$export$2e2bcd8739ae039 = $74d3dc6090c26fa8$var$OutlinedInput;



var $7ZufN = parcelRequire("7ZufN");


var $jjHhy = parcelRequire("jjHhy");
var $dDUuw = parcelRequire("dDUuw");

var $cZGFG = parcelRequire("cZGFG");
"use client";
const $ec036cfb14841ba3$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $ec036cfb14841ba3$var$_excluded2 = [
    "root"
];
const $ec036cfb14841ba3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $ec036cfb14841ba3$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $dDUuw.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $ec036cfb14841ba3$var$StyledInput = (0, $jjHhy.default)((0, $fdd06a390a83faaa$export$2e2bcd8739ae039), $ec036cfb14841ba3$var$styledRootConfig)("");
const $ec036cfb14841ba3$var$StyledOutlinedInput = (0, $jjHhy.default)((0, $74d3dc6090c26fa8$export$2e2bcd8739ae039), $ec036cfb14841ba3$var$styledRootConfig)("");
const $ec036cfb14841ba3$var$StyledFilledInput = (0, $jjHhy.default)((0, $6f3fdb113ae1652b$export$2e2bcd8739ae039), $ec036cfb14841ba3$var$styledRootConfig)("");
const $ec036cfb14841ba3$var$Select = /*#__PURE__*/ $dup7A.forwardRef(function Select(inProps, ref) {
    const props = (0, $7ZufN.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $72dad9721f095796$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $bGxpK.default)(props, $ec036cfb14841ba3$var$_excluded);
    const inputComponent = native ? (0, $d51a67c4e4ed338c$export$2e2bcd8739ae039) : (0, $73801f280163b1e7$export$2e2bcd8739ae039);
    const muiFormControl = (0, $dd81c7cf93ba27da$export$2e2bcd8739ae039)();
    const fcs = (0, $20c375fdd6e9cd4d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $3G4eg.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $ec036cfb14841ba3$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $bGxpK.default)(classes, $ec036cfb14841ba3$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $cZGFG.jsx)($ec036cfb14841ba3$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $cZGFG.jsx)($ec036cfb14841ba3$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $cZGFG.jsx)($ec036cfb14841ba3$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $164c28d960f5df34$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dup7A.Fragment, {
        children: /*#__PURE__*/ $dup7A.cloneElement(InputComponent, (0, $3G4eg.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $3G4eg.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $3G4eg.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $gmeoE.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $aJAJS.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$ec036cfb14841ba3$var$Select.muiName = "Select";
var $ec036cfb14841ba3$export$2e2bcd8739ae039 = $ec036cfb14841ba3$var$Select;







var $jjHhy = parcelRequire("jjHhy");
const $4f8a38debde50470$export$ef9b1a59e592288f = (0, $jjHhy.default)((0, $ec036cfb14841ba3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "dense"
})(({ theme: theme, dense: dense })=>({
        backgroundColor: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.background.paper,
        [`.${(0, $8febbde539987675$export$2e2bcd8739ae039).input}`]: {
            padding: dense ? theme.spacing(1.625, 2, 1.5, 2) : theme.spacing(2),
            display: "flex",
            alignItems: "center"
        },
        [`.${(0, $8cbe4ff94a4175e2$export$2e2bcd8739ae039).icon}`]: {
            right: 10,
            color: theme.palette.text.primary
        },
        [`.${(0, $9fd460fb6166bfca$export$2e2bcd8739ae039).root}`]: {
            minWidth: 38
        },
        [`.${(0, $b82d43853ee2dae4$export$2e2bcd8739ae039).notchedOutline}`]: {
            display: "none"
        }
    }));



const $7f76d6beaf54ed9f$export$da17f9869e12dc1 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const { gasPrice: gasPrice } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "gasPrice"
    ]);
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        flex: 1,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t(`settings.gasPrice.title`)
            }),
            (0, $cZGFG.jsx)((0, $e860bb7daa30c730$export$2e2bcd8739ae039), {
                fullWidth: true,
                children: (0, $cZGFG.jsxs)((0, $4f8a38debde50470$export$ef9b1a59e592288f), {
                    MenuProps: {
                        elevation: 2
                    },
                    value: gasPrice,
                    onChange: (event)=>setValue("gasPrice", event.target.value),
                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6948928f378d97d8$exports))),
                    dense: true,
                    children: [
                        (0, $cZGFG.jsx)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                            value: "slow",
                            children: t(`settings.gasPrice.slow`)
                        }),
                        (0, $cZGFG.jsx)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                            value: "normal",
                            children: t(`settings.gasPrice.normal`)
                        }),
                        (0, $cZGFG.jsx)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                            value: "fast",
                            children: t(`settings.gasPrice.fast`)
                        })
                    ]
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");








const $61032825871a8ac1$export$65f7da49be6579a0 = ()=>{
    const { t: t, i18n: i18n } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { languages: languages, hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const { language: language } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "language"
    ]);
    if (hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).Language)) return null;
    const handleChangeLanguage = (event)=>{
        const language = event.target.value;
        setValue("language", language);
        i18n.changeLanguage(language);
    };
    const filteredLanguages = Object.keys(i18n.store.data).sort();
    if (filteredLanguages.length <= 1) return null;
    const value = filteredLanguages.includes(language || i18n.resolvedLanguage || "") ? language || i18n.resolvedLanguage : languages?.default || languages?.allow?.[0];
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        mb: 2,
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t(`language.title`)
            }),
            (0, $cZGFG.jsx)((0, $e860bb7daa30c730$export$2e2bcd8739ae039), {
                fullWidth: true,
                children: (0, $cZGFG.jsx)((0, $4f8a38debde50470$export$ef9b1a59e592288f), {
                    MenuProps: {
                        elevation: 2
                    },
                    value: value,
                    onChange: handleChangeLanguage,
                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6948928f378d97d8$exports))),
                    dense: true,
                    children: filteredLanguages.map((lng)=>{
                        return (0, $cZGFG.jsx)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                            value: lng,
                            children: t("language.name", {
                                lng: lng
                            })
                        }, lng);
                    })
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");







var $jjHhy = parcelRequire("jjHhy");
const $b9c443ece3735c97$export$5a53b4fa294dd1a1 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        background: (0, $a0eca89cce449dbc$export$8f4fcaa5200816dd)(theme.palette.mode, "4%"),
        borderRadius: "16px",
        padding: "16px",
        [`svg`]: {
            fill: (0, $a0eca89cce449dbc$export$8f4fcaa5200816dd)(theme.palette.mode, "40%")
        }
    }));



var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $30b2819c1c33bf35$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z"
}), "InfoRounded");



var $cZFtK = parcelRequire("cZFtK");
const $38c0ea5bf783e9eb$export$cf7ebf3528ebf6da = ()=>{
    const [enabledBridges, enabledExchanges, routePriority, slippage, gasPrice] = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>[
            state.enabledBridges,
            state.enabledExchanges,
            state.routePriority,
            state.slippage,
            state.gasPrice
        ], (0, $cZFtK.shallow));
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { tools: tools } = (0, $d518138af9fbf856$export$746cb67d959fd2b5)();
    const config = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const resetSettings = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.reset);
    const [open, setOpen] = (0, $dup7A.useState)(false);
    const toggleDialog = (0, $dup7A.useCallback)(()=>{
        setOpen((open)=>!open);
    }, []);
    const handleReset = ()=>{
        if (tools) {
            resetSettings(config, tools.bridges.map((tool)=>tool.key), tools.exchanges.map((tool)=>tool.key));
            (0, $80ac256836e84b51$export$446ca6318ddf45cb)(config);
        }
        toggleDialog();
    };
    const isSlippageChanged = config.slippage ? Number(slippage) !== config.slippage * 100 : slippage !== (0, $80ac256836e84b51$export$8b8dbf18b008c4f9).slippage;
    const isRoutePriorityChanged = config.routePriority ? routePriority !== config.routePriority : routePriority !== (0, $80ac256836e84b51$export$8b8dbf18b008c4f9).routePriority;
    const isGasPriceChanged = gasPrice !== (0, $80ac256836e84b51$export$8b8dbf18b008c4f9).gasPrice;
    const isCustomRouteSettings = tools?.bridges?.length !== enabledBridges?.length || tools?.exchanges?.length !== enabledExchanges?.length || isSlippageChanged || isRoutePriorityChanged || isGasPriceChanged;
    if (!isCustomRouteSettings) return null;
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 3,
        mt: 1.5,
        mb: 1,
        children: (0, $cZGFG.jsxs)((0, $b9c443ece3735c97$export$5a53b4fa294dd1a1), {
            children: [
                (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    display: "flex",
                    marginBottom: "12px",
                    children: [
                        (0, $cZGFG.jsx)((0, $30b2819c1c33bf35$export$2e2bcd8739ae039), {
                            sx: {
                                marginRight: "8px"
                            }
                        }),
                        (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            children: t(`settings.resetSettings`)
                        })
                    ]
                }),
                (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                    onClick: toggleDialog,
                    fullWidth: true,
                    children: t("button.resetSettings")
                }),
                (0, $cZGFG.jsxs)((0, $f719477393eb6354$export$3ddf2d174ce01153), {
                    open: open,
                    onClose: toggleDialog,
                    children: [
                        (0, $cZGFG.jsx)((0, $c7caddaf71674940$export$2e2bcd8739ae039), {
                            children: t("warning.title.resetSettings")
                        }),
                        (0, $cZGFG.jsx)((0, $da3939ee95c82076$export$2e2bcd8739ae039), {
                            children: (0, $cZGFG.jsx)((0, $1f0b92c5665aa4ca$export$2e2bcd8739ae039), {
                                children: t("warning.message.resetSettings")
                            })
                        }),
                        (0, $cZGFG.jsxs)((0, $20eff1c46eaadcad$export$2e2bcd8739ae039), {
                            children: [
                                (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                    onClick: toggleDialog,
                                    children: t("button.cancel")
                                }),
                                (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    onClick: handleReset,
                                    autoFocus: true,
                                    children: t("button.reset")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");







const $54875b63b6ba5bae$export$cd6288f525075354 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const { routePriority: routePriority } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "routePriority"
    ]);
    const value = routePriority ?? "";
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t(`settings.routePriority`)
            }),
            (0, $cZGFG.jsx)((0, $e860bb7daa30c730$export$2e2bcd8739ae039), {
                fullWidth: true,
                children: (0, $cZGFG.jsx)((0, $4f8a38debde50470$export$ef9b1a59e592288f), {
                    MenuProps: {
                        elevation: 2
                    },
                    value: value,
                    onChange: (event)=>setValue("routePriority", event.target.value),
                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6948928f378d97d8$exports))),
                    dense: true,
                    children: (0, $a788d4856c753142$export$ed0df17bf864fd7b).map((order)=>{
                        const tag = t(`main.tags.${order.toLowerCase()}`);
                        const tagName = `${tag[0]}${tag.slice(1).toLowerCase()}`;
                        return (0, $cZGFG.jsx)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                            value: order,
                            children: tagName
                        }, order);
                    })
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");






const $0d9cb6549981e438$export$711d15726fdd3587 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const setSendToWallet = (0, $8f69ee068e035a12$export$ebd60666ceae3007)((state)=>state.setSendToWallet);
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const { showDestinationWallet: showDestinationWallet } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "showDestinationWallet"
    ]);
    if (hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).ToAddress)) return null;
    const onChange = (_, checked)=>{
        setValue("showDestinationWallet", checked);
        setSendToWallet(false);
    };
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 3,
        pt: 2,
        pb: 1.5,
        children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            },
            children: [
                (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        variant: "subtitle1",
                        color: "text.primary",
                        lineHeight: "normal",
                        children: t(`settings.showDestinationWallet`)
                    })
                }),
                (0, $cZGFG.jsx)((0, $ce24fb090d208741$export$b5d5cf8927ab7262), {
                    checked: showDestinationWallet,
                    onChange: onChange
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");





const $8b47c77f7f4a1bc3$export$c313fef2e23489b2 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { slippage: slippage } = (0, $c85816f09d368c39$export$9115b42802a3e44f)([
        "slippage"
    ]);
    const setValue = (0, $80ac256836e84b51$export$772cdd5f573abcc9)((state)=>state.setValue);
    const defaultValue = (0, $dup7A.useRef)(slippage);
    const handleChange = (event)=>{
        const { value: value } = event.target;
        setValue("slippage", (0, $2a25b0bfe67ae18c$export$c51f290eed53255d)(value, defaultValue.current, true));
    };
    const handleBlur = (event)=>{
        const { value: value } = event.target;
        setValue("slippage", (0, $2a25b0bfe67ae18c$export$c51f290eed53255d)(value, defaultValue.current));
    };
    const value = slippage ?? "";
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        children: [
            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                children: t(`settings.slippage`)
            }),
            (0, $cZGFG.jsx)((0, $e860bb7daa30c730$export$2e2bcd8739ae039), {
                fullWidth: true,
                children: (0, $cZGFG.jsx)((0, $1bd38b4381d5e5f5$export$f5b8910cec6cf069), {
                    size: "small",
                    placeholder: t(`settings.slippage`),
                    endAdornment: (0, $cZGFG.jsx)((0, $024bdefb4f58bf2e$export$2e2bcd8739ae039), {
                        position: "end",
                        children: "%"
                    }),
                    autoComplete: "off",
                    inputProps: {
                        inputMode: "decimal"
                    },
                    onChange: handleChange,
                    onBlur: handleBlur,
                    value: value
                })
            })
        ]
    });
};


const $eb9f5ab05109938a$export$8f6dcfe950367406 = ()=>{
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        disableGutters: true,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                px: 3,
                pt: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $0a1b6bd577a06edb$export$fd2972c21a03f7b9), {}),
                    (0, $cZGFG.jsx)((0, $61032825871a8ac1$export$65f7da49be6579a0), {}),
                    (0, $cZGFG.jsx)((0, $54875b63b6ba5bae$export$cd6288f525075354), {}),
                    (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        mt: 2,
                        children: [
                            (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                pr: 2,
                                flex: 1,
                                children: (0, $cZGFG.jsx)((0, $8b47c77f7f4a1bc3$export$c313fef2e23489b2), {})
                            }),
                            (0, $cZGFG.jsx)((0, $7f76d6beaf54ed9f$export$da17f9869e12dc1), {})
                        ]
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $0d9cb6549981e438$export$711d15726fdd3587), {}),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                px: 1.5,
                children: [
                    (0, $cZGFG.jsx)((0, $08d9e02f9fc951c4$export$225f85434b248369), {
                        type: "Bridges"
                    }),
                    (0, $cZGFG.jsx)((0, $08d9e02f9fc951c4$export$225f85434b248369), {
                        type: "Exchanges"
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $38c0ea5bf783e9eb$export$cf7ebf3528ebf6da), {})
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $99400aca3ce3aa54$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($99400aca3ce3aa54$exports, "__esModule", {
    value: true
});
$99400aca3ce3aa54$exports.default = void 0;

var $99400aca3ce3aa54$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $99400aca3ce3aa54$var$_default = $99400aca3ce3aa54$exports.default = (0, $99400aca3ce3aa54$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M15 20H5V7c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h10c.55 0 1-.45 1-1s-.45-1-1-1m5-4V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2m-2 0H9V4h9z"
}), "ContentCopyRounded");





var $dup7A = parcelRequire("dup7A");



var $cZFtK = parcelRequire("cZFtK");




var $cZGFG = parcelRequire("cZGFG");


var $cZGFG = parcelRequire("cZGFG");





var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

const $62f713f74732c24f$export$3a76f5d97788c0a2 = (props)=>{
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const insurColor = theme.palette.mode === "light" ? "#1C4332" : theme.palette.common.white;
    return (0, $cZGFG.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "58",
        height: "20",
        fill: "none",
        ...props,
        children: [
            (0, $cZGFG.jsx)("path", {
                fill: insurColor,
                fillRule: "evenodd",
                d: "M42.887 3.894a2.104 2.104 0 0 0-1.304.405 1.259 1.259 0 0 0-.544 1.046c0 .683.509 1.15 1.527 1.401.483.12.817.236 1 .345.184.11.276.234.276.373a.36.36 0 0 1-.227.331 1.25 1.25 0 0 1-.568.115c-.66 0-1.292-.25-1.896-.753V8.23c.473.418 1.082.637 1.826.656h.055c.46.01.912-.12 1.297-.37a1.19 1.19 0 0 0 .558-1.053c0-.734-.51-1.229-1.527-1.485a.532.532 0 0 1-.084-.02l-.097-.022a5.483 5.483 0 0 1-.826-.258c-.18-.079-.269-.192-.269-.341a.38.38 0 0 1 .23-.341c.178-.09.374-.133.572-.126.303.006.602.061.886.164a4 4 0 0 1 .906.443V4.41a3.55 3.55 0 0 0-1.791-.516Zm-11.621.056h1.052v4.88h-1.052V3.95Zm5.014 0 1.638 3.876V3.95h1.025v4.88h-1.625l-1.687-4.002V8.83h-1.025V3.95h1.674Zm10.56.007h1.053v2.9c-.007.28.102.55.3.746a.972.972 0 0 0 .711.3.982.982 0 0 0 .715-.3c.2-.196.31-.466.303-.746v-2.9h1.046v2.9c.013.543-.2 1.067-.59 1.447a2.158 2.158 0 0 1-2.941.007 1.934 1.934 0 0 1-.596-1.454v-2.9Zm9.283 1.653a.714.714 0 0 1-.718.71h-1.179V4.891h1.178a.7.7 0 0 1 .51.206.68.68 0 0 1 .209.505v.008ZM53.18 3.95v4.88h1.045V7.226h.823l.969 1.604h1.185l-1.046-1.736c.29-.114.538-.316.708-.578.176-.26.27-.565.268-.879a1.617 1.617 0 0 0-.505-1.185 1.673 1.673 0 0 0-1.224-.502h-2.223Z",
                clipRule: "evenodd"
            }),
            (0, $cZGFG.jsx)("path", {
                fill: "#28DA98",
                fillRule: "evenodd",
                d: "M32.366 13.05a1.27 1.27 0 0 0 .37.914c.238.252.57.391.917.383a1.317 1.317 0 0 0 1.296-1.296 1.267 1.267 0 0 0-.383-.913 1.233 1.233 0 0 0-.913-.393 1.216 1.216 0 0 0-.918.388c-.24.245-.373.575-.37.918Zm-.53-1.78a2.274 2.274 0 0 1 1.69-.721c.49-.01.966.166 1.332.493v-.411h1.324v4.838h-1.324v-.401c-.37.318-.845.488-1.333.475a2.252 2.252 0 0 1-1.684-.74 2.45 2.45 0 0 1-.708-1.752 2.471 2.471 0 0 1 .704-1.78v-.001Zm7.093 0c.461-.47 1.095-.73 1.753-.721.5-.006.99.148 1.397.438.408.284.72.685.895 1.15l-1.205.347a1.274 1.274 0 0 0-.434-.543 1.095 1.095 0 0 0-.652-.206 1.174 1.174 0 0 0-.895.393 1.31 1.31 0 0 0-.365.922c-.005.342.127.672.365.918.228.252.554.393.895.388.235.004.466-.068.657-.206a1.3 1.3 0 0 0 .429-.534l1.205.347c-.176.46-.486.858-.89 1.141a2.36 2.36 0 0 1-1.401.439 2.388 2.388 0 0 1-1.767-.736 2.501 2.501 0 0 1 .014-3.537Zm9.495 1.269h-2.346a1.16 1.16 0 0 1 .425-.585c.217-.16.482-.244.753-.237a1.195 1.195 0 0 1 1.168.822Zm.411-1.424a2.477 2.477 0 0 0-3.323.155 2.501 2.501 0 0 0-.013 3.537c.46.48 1.1.747 1.766.735a2.89 2.89 0 0 0 1.351-.342 2.08 2.08 0 0 0 .94-.908l-1.15-.33c-.313.28-.722.428-1.141.412a1.327 1.327 0 0 1-.758-.215 1.043 1.043 0 0 1-.429-.616h3.633c.037-.156.056-.315.055-.475a2.338 2.338 0 0 0-.064-.53 2.467 2.467 0 0 0-.867-1.423Z",
                clipRule: "evenodd"
            }),
            (0, $cZGFG.jsx)("path", {
                fill: "#28DA98",
                d: "M16.951 10a2.139 2.139 0 0 0-2.139-2.139l1.908-1.907c0 1.18.958 2.139 2.139 2.139L16.95 10ZM12.905 5.954a2.139 2.139 0 0 0-2.14-2.139l1.908-1.907c0 1.18.958 2.138 2.139 2.138l-1.907 1.908Z"
            }),
            (0, $cZGFG.jsx)("path", {
                fill: insurColor,
                d: "M16.951 18.093a2.139 2.139 0 0 0-2.138-2.14l1.907-1.907c0 1.181.958 2.139 2.139 2.139l-1.908 1.908ZM12.905 14.046a2.139 2.139 0 0 0-2.14-2.138L12.674 10c0 1.181.958 2.139 2.139 2.139l-1.907 1.907ZM16.938 2.147c.008-.078.013-.158.013-.24l-.014.24Z"
            }),
            (0, $cZGFG.jsx)("path", {
                fill: "#28DA98",
                d: "M20.207 8.651a1.907 1.907 0 0 0-2.698 0 1.901 1.901 0 0 0-.558 1.35c-.001 1.181-.958 2.138-2.14 2.138h.001c-.488 0-.976.186-1.349.559a1.9 1.9 0 0 0-.558 1.35c-.001 1.18-.957 2.135-2.136 2.137h-.004a2.139 2.139 0 0 1-2.138-2.138c0-.489-.186-.977-.559-1.35a1.901 1.901 0 0 0-1.349-.558 2.139 2.139 0 0 1-2.138-2.137v-.004c0-1.18.957-2.136 2.137-2.137.488 0 .977-.185 1.35-.558.373-.373.559-.861.559-1.35 0-1.18.958-2.138 2.139-2.138a1.907 1.907 0 1 0-1.907-1.907A2.139 2.139 0 0 1 6.72 4.046c-.488 0-.977.186-1.35.56-.372.372-.558.86-.558 1.348a2.139 2.139 0 0 1-2.138 2.139 1.907 1.907 0 1 0 .001 3.815 2.139 2.139 0 0 1 2.137 2.136c0 .489.185.978.559 1.351a1.9 1.9 0 0 0 1.354.559 2.139 2.139 0 0 1 2.133 2.139 1.908 1.908 0 0 0 3.815 0c0-1.182.958-2.14 2.139-2.14.488 0 .976-.185 1.349-.558.374-.374.56-.864.558-1.354a2.139 2.139 0 0 1 2.137-2.133 1.908 1.908 0 0 0 1.35-3.256Z"
            }),
            (0, $cZGFG.jsx)("path", {
                fill: insurColor,
                d: "M28.3 8.651a1.901 1.901 0 0 0-1.348-.558 2.139 2.139 0 0 1-2.139-2.139 1.9 1.9 0 0 0-.559-1.349 1.901 1.901 0 0 0-1.349-.559 2.139 2.139 0 0 1-2.138-2.135 1.907 1.907 0 1 0-3.815-.003c0 .082-.005.164-.014.244v-.005a2.13 2.13 0 0 1-.999 1.579l-.002.001a2.112 2.112 0 0 1-.16.09l-.012.006a2.11 2.11 0 0 1-.163.072l-.018.008c-.055.02-.11.04-.167.056l-.02.006c-.057.016-.115.03-.174.042l-.02.003c-.06.011-.12.02-.182.026l-.013.001c-.064.006-.129.01-.194.01-.06 0-.118.002-.176.008h-.007a1.909 1.909 0 0 0-.526.128l-.01.003a1.92 1.92 0 0 0-.166.077l-.003.002c-.046.024-.09.051-.135.08l-.027.016c-.045.029-.087.061-.13.095-.008.006-.017.011-.025.018a1.912 1.912 0 0 0-.39.43l-.046.08c-.016.027-.034.054-.05.083-.011.023-.02.047-.032.07-.015.033-.032.066-.046.1-.01.025-.018.053-.028.08-.01.03-.023.062-.033.094-.01.036-.018.073-.027.11-.005.023-.012.046-.016.068a1.9 1.9 0 0 0-.02.137l-.007.045a1.935 1.935 0 0 0-.007.154l-.001.029a2.139 2.139 0 0 1-2.138 2.139A1.907 1.907 0 1 0 12.675 10c0-1.18.956-2.138 2.136-2.139.243 0 .485-.045.713-.137l.006-.002c.052-.02.102-.045.152-.07l.018-.009c.045-.023.089-.05.132-.078l.03-.018c.042-.027.083-.058.123-.09l.032-.023a1.953 1.953 0 0 0 .276-.277c.01-.01.017-.023.026-.034.03-.04.06-.08.088-.12l.017-.03c.028-.044.055-.088.079-.133l.009-.02c.025-.049.049-.1.07-.15l.003-.01c.09-.227.136-.468.136-.71l.013-.236a2.139 2.139 0 0 1 4.264.237c0 .49.186.978.559 1.352.373.373.862.559 1.35.558a2.139 2.139 0 0 1-.001 4.278c-.488 0-.977.186-1.35.559-.372.373-.558.862-.558 1.35a2.139 2.139 0 0 1-2.136 2.137 1.908 1.908 0 0 0-1.352 3.256 1.908 1.908 0 0 0 3.257-1.349c0-1.18.958-2.138 2.139-2.138.488 0 .976-.186 1.349-.559.372-.372.558-.86.558-1.35 0-1.18.957-2.136 2.137-2.137a1.907 1.907 0 0 0 1.35-3.256Z"
            })
        ]
    });
};





const $30d6ab1b8e32914e$export$5bd3fd67ae7fff39 = ({ status: status, feeAmountUsd: feeAmountUsd, insuredAmount: insuredAmount, insuredTokenSymbol: insuredTokenSymbol, insuranceCoverageId: insuranceCoverageId, onChange: onChange, ...props })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const [enabled, setEnabled] = (0, $dup7A.useState)(false);
    const [cardExpanded, setCardExpanded] = (0, $dup7A.useState)(status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle);
    const handleExpand = (e)=>{
        e.stopPropagation();
        setCardExpanded((expanded)=>!expanded);
    };
    const handleSwitch = (_, checked)=>{
        setEnabled(checked);
        onChange?.(checked);
    };
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        selectionColor: "secondary",
        indented: true,
        ...props,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    (0, $cZGFG.jsxs)((0, $987da2744be1b393$export$e13aaac4037b0914), {
                        type: "insurance",
                        children: [
                            (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7e0ba82d268b078$exports))), {
                                fontSize: "inherit"
                            }),
                            (0, $cZGFG.jsx)((0, $987da2744be1b393$export$2eaa1bdbba29c923), {
                                type: "icon",
                                children: status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? t("main.tags.insurance") : t("main.tags.insured")
                            })
                        ]
                    }),
                    status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? (0, $cZGFG.jsx)((0, $ce24fb090d208741$export$b5d5cf8927ab7262), {
                        onChange: handleSwitch,
                        value: enabled
                    }) : (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        my: -0.5,
                        children: (0, $cZGFG.jsx)((0, $1cb427f767e9e062$export$a03b0ac28c7e34b8), {
                            onClick: handleExpand,
                            size: "small",
                            children: cardExpanded ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6f937c21a39d4f3$exports))), {}) : (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4d3a704b8b3b6f33$exports))), {})
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                timeout: 225,
                in: cardExpanded,
                mountOnEnter: true,
                unmountOnExit: true,
                children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    mt: 2,
                    children: [
                        (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mb: 2,
                            children: [
                                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                    fontSize: 24,
                                    fontWeight: 700,
                                    lineHeight: 1,
                                    children: t("format.currency", {
                                        value: feeAmountUsd
                                    })
                                }),
                                (0, $cZGFG.jsx)((0, $62f713f74732c24f$export$3a76f5d97788c0a2), {})
                            ]
                        }),
                        (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                            children: [
                                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                    fontSize: 14,
                                    children: (0, $cZGFG.jsx)((0, $2fb7372348de61af$export$8d6a9236f2e3f2ce), {
                                        i18nKey: status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? "insurance.insure" : "insurance.insured",
                                        values: {
                                            amount: insuredAmount,
                                            tokenSymbol: insuredTokenSymbol
                                        },
                                        components: [
                                            (0, $cZGFG.jsx)("strong", {})
                                        ]
                                    })
                                }),
                                (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
                                    timeout: 225,
                                    in: enabled || status !== (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle,
                                    mountOnEnter: true,
                                    unmountOnExit: true,
                                    children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                        sx: {
                                            listStyleType: "disc",
                                            pl: 2
                                        },
                                        children: [
                                            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                                fontSize: 14,
                                                display: "list-item",
                                                children: t("insurance.bridgeExploits")
                                            }),
                                            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                                fontSize: 14,
                                                display: "list-item",
                                                children: t("insurance.slippageError")
                                            })
                                        ]
                                    })
                                }),
                                (0, $cZGFG.jsx)((0, $8e9053afbc4d5b0b$export$2e2bcd8739ae039), {
                                    href: status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? "https://docs.insurace.io/landing-page/documentation/cover-products/bridge-cover/li.fi" : `https://app.insurace.io/bridge-cover?search=${insuranceCoverageId}`,
                                    target: "_blank",
                                    underline: "none",
                                    color: "text.primary",
                                    children: (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                        pt: 0.5,
                                        color: "primary",
                                        fontSize: 14,
                                        fontWeight: 600,
                                        children: status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? t("button.learnMore") : t("button.viewCoverage")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");





const $6ad56434ed4c517c$export$f09e5e439a6c53ac = ({ status: status, insurableRouteId: insurableRouteId, onChange: onChange, ...props })=>{
    const setExecutableRoute = (0, $07b0e9f0a3acbbd7$export$93756f4499f86d2b)();
    const routeExecution = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>state.routes[insurableRouteId]);
    const { routes: routes } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)({
        insurableRoute: routeExecution?.route
    });
    const insuredRoute = routes?.[0];
    const toggleInsurance = (checked)=>{
        if (insuredRoute) {
            if (checked) setExecutableRoute(insuredRoute, insurableRouteId);
            onChange?.(checked ? insuredRoute.id : insurableRouteId);
        }
    };
    if (!insuredRoute) return null;
    return (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
        timeout: 225,
        in: insuredRoute.insurance.state === "INSURED",
        unmountOnExit: true,
        mountOnEnter: true,
        appear: status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle,
        children: (0, $cZGFG.jsx)((0, $30d6ab1b8e32914e$export$5bd3fd67ae7fff39), {
            ...props,
            status: status,
            insuredAmount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(insuredRoute.toAmountMin, insuredRoute.toToken.decimals),
            insuredTokenSymbol: insuredRoute.toToken.symbol,
            onChange: toggleInsurance
        })
    });
};


const $ca8f2122b2b9bd8c$export$56ad944ccf4d3da9 = ({ status: status, insurableRouteId: insurableRouteId, onChange: onChange, ...props })=>{
    return status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? (0, $cZGFG.jsx)((0, $6ad56434ed4c517c$export$f09e5e439a6c53ac), {
        status: status,
        insurableRouteId: insurableRouteId,
        onChange: onChange,
        ...props
    }) : (0, $cZGFG.jsx)((0, $30d6ab1b8e32914e$export$5bd3fd67ae7fff39), {
        status: status,
        ...props
    });
};



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $emmvO = parcelRequire("emmvO");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $cb6d414fa3b7e2a5$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $cb6d414fa3b7e2a5$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $165ee4cc13ee6d25$export$46f01d01378ec5a2), classes);
};
const $cb6d414fa3b7e2a5$var$DividerRoot = (0, $jjHhy.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $emmvO.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $3G4eg.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $cb6d414fa3b7e2a5$var$DividerWrapper = (0, $jjHhy.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $cb6d414fa3b7e2a5$var$Divider = /*#__PURE__*/ $dup7A.forwardRef(function Divider(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $bGxpK.default)(props, $cb6d414fa3b7e2a5$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $cb6d414fa3b7e2a5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($cb6d414fa3b7e2a5$var$DividerRoot, (0, $3G4eg.default)({
        as: component,
        className: (0, $aJAJS.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $cZGFG.jsx)($cb6d414fa3b7e2a5$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $cb6d414fa3b7e2a5$var$Divider.muiSkipListHighlight = true;
var $cb6d414fa3b7e2a5$export$2e2bcd8739ae039 = $cb6d414fa3b7e2a5$var$Divider;




var $jjHhy = parcelRequire("jjHhy");
const $c049b1c7a0b075b4$export$42a852a2b6b56249 = (0, $jjHhy.default)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: theme.spacing(2)
    }));


const $c0137d9629ed98ce$export$e3b2e5a5ec9ae895 = ()=>{
    return (0, $cZGFG.jsx)((0, $c049b1c7a0b075b4$export$42a852a2b6b56249), {
        children: (0, $cZGFG.jsx)((0, $cb6d414fa3b7e2a5$export$2e2bcd8739ae039), {
            orientation: "vertical",
            flexItem: true
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");









var $cZGFG = parcelRequire("cZGFG");
var $5593d3c8427d3089$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($5593d3c8427d3089$exports, "__esModule", {
    value: true
});
$5593d3c8427d3089$exports.default = void 0;

var $5593d3c8427d3089$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $5593d3c8427d3089$var$_default = $5593d3c8427d3089$exports.default = (0, $5593d3c8427d3089$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5m-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1m2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1"
}), "LinkRounded");








var $8eVik = parcelRequire("8eVik");
var $jjHhy = parcelRequire("jjHhy");
const $c4ee22f6367ae259$var$getStatusColor = (theme, status, substatus)=>{
    switch(status){
        case "ACTION_REQUIRED":
            return (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.info.main, 0.12);
        case "DONE":
            if (substatus === "PARTIAL" || substatus === "REFUNDED") return (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.warning.main, 0.48);
            return (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.success.main, 0.12);
        case "FAILED":
            return (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.error.main, 0.12);
        default:
            return theme.palette.grey[theme.palette.mode === "light" ? 300 : 800];
    }
};
const $c4ee22f6367ae259$export$204b247bb76b35 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>![
            "status",
            "substatus"
        ].includes(prop)
})(({ theme: theme, status: status, substatus: substatus })=>({
        backgroundColor: [
            "ACTION_REQUIRED",
            "DONE",
            "FAILED"
        ].includes(status) ? $c4ee22f6367ae259$var$getStatusColor(theme, status, substatus) : theme.palette.background.paper,
        borderStyle: "solid",
        borderColor: $c4ee22f6367ae259$var$getStatusColor(theme, status, substatus),
        borderWidth: ![
            "ACTION_REQUIRED",
            "DONE",
            "FAILED"
        ].includes(status) ? 2 : 0,
        display: "grid",
        position: "relative",
        placeItems: "center",
        width: 32,
        height: 32,
        borderRadius: "50%"
    }));
const $c4ee22f6367ae259$var$circleAnimation = (0, $8eVik.keyframes)`
  0% {
    stroke-dashoffset: 129;
    transform: rotate(0);
  }
  50% {
    stroke-dashoffset: 56;
    transform: rotate(45deg);
  };
  100% {
    stroke-dashoffset: 129;
    transform: rotate(360deg);
  }
`;
const $c4ee22f6367ae259$export$df3885865e09a678 = (0, $jjHhy.default)((0, $65a11d953b0c04a5$export$2e2bcd8739ae039))`
  color: ${({ theme: theme })=>theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light};
  animation-duration: 3s;
  position: absolute;
  left: -2px;
  .${(0, $43ce6436471940ae$export$2e2bcd8739ae039).circle} {
    animation-duration: 2s;
    animation-timing-function: linear;
    animation-name: ${$c4ee22f6367ae259$var$circleAnimation};
    stroke-dasharray: 129;
    stroke-dashoffset: 129;
    stroke-linecap: round;
    transform-origin: 100% 100%;
  }
`;




var $jjHhy = parcelRequire("jjHhy");
const $eedaa44dc13263e1$export$29d11c0fe2fc51d8 = (0, $jjHhy.default)((0, $510dba830cc31c9a$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(0.5)
    }));


const $526d2a9488d7b041$export$edd7d34c7662d506 = ({ step: step, toAddress: toAddress, toAddressLink: toAddressLink })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const isDone = step.execution?.status === "DONE";
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 2,
        py: 1,
        children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                (0, $cZGFG.jsx)((0, $c4ee22f6367ae259$export$204b247bb76b35), {
                    status: isDone ? "DONE" : "NOT_STARTED",
                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($671d7c5a3f94d7f9$exports))), {
                        color: isDone ? "success" : "inherit",
                        sx: {
                            position: "absolute",
                            fontSize: "1rem"
                        }
                    })
                }),
                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    mx: 2,
                    flex: 1,
                    fontSize: 14,
                    fontWeight: 400,
                    children: isDone ? t("main.sentToAddress", {
                        address: toAddress
                    }) : t("main.sendToAddress", {
                        address: toAddress
                    })
                }),
                (0, $cZGFG.jsx)((0, $eedaa44dc13263e1$export$29d11c0fe2fc51d8), {
                    size: "small",
                    edge: "end",
                    LinkComponent: (0, $8e9053afbc4d5b0b$export$2e2bcd8739ae039),
                    href: toAddressLink,
                    target: "_blank",
                    rel: "nofollow noreferrer",
                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5593d3c8427d3089$exports))), {})
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");




const $ae3640a34ab2bd25$export$1e73db1bb241880b = ({ step: step })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const isDone = step.execution?.status === "DONE";
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 2,
        py: 1,
        children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                (0, $cZGFG.jsx)((0, $c4ee22f6367ae259$export$204b247bb76b35), {
                    status: isDone ? "DONE" : "NOT_STARTED",
                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9955478a62ac183c$exports))), {
                        color: isDone ? "success" : "inherit",
                        sx: {
                            position: "absolute",
                            fontSize: "1rem"
                        }
                    })
                }),
                (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    ml: 2,
                    flex: 1,
                    fontSize: 14,
                    fontWeight: 400,
                    children: [
                        t("format.currency", {
                            value: (step.execution?.gasAmountUSD || step.estimate.gasCosts?.reduce((amount, gasCost)=>amount + parseFloat(gasCost.amountUSD || "0"), 0)) ?? 0
                        }),
                        " ",
                        isDone ? t("main.gasFeePaid") : t("main.gasFeeEstimated")
                    ]
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");




var $cZGFG = parcelRequire("cZGFG");
var $ca117ed6cec72ff0$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($ca117ed6cec72ff0$exports, "__esModule", {
    value: true
});
$ca117ed6cec72ff0$exports.default = void 0;

var $ca117ed6cec72ff0$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $ca117ed6cec72ff0$var$_default = $ca117ed6cec72ff0$exports.default = (0, $ca117ed6cec72ff0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done");







function $4a4228a153ead893$export$9e72f56a493060bf({ process: process }) {
    return (0, $cZGFG.jsxs)((0, $c4ee22f6367ae259$export$204b247bb76b35), {
        status: process.status,
        substatus: process.substatus,
        children: [
            process.status === "STARTED" || process.status === "PENDING" ? (0, $cZGFG.jsx)((0, $c4ee22f6367ae259$export$df3885865e09a678), {
                size: 32,
                thickness: 3
            }) : null,
            process.status === "ACTION_REQUIRED" ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70197f36b6f91ee5$exports))), {
                color: "info",
                sx: {
                    position: "absolute",
                    fontSize: "1rem"
                }
            }) : null,
            process.status === "DONE" && (process.substatus === "PARTIAL" || process.substatus === "REFUNDED") ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cdfc4e60aecac3af$exports))), {
                sx: (theme)=>({
                        position: "absolute",
                        fontSize: "1rem",
                        color: (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(theme.palette.warning.main, 0.32)
                    })
            }) : process.status === "DONE" ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca117ed6cec72ff0$exports))), {
                color: "success",
                sx: {
                    position: "absolute",
                    fontSize: "1rem"
                }
            }) : null,
            process.status === "FAILED" ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b718eceab489f4$exports))), {
                color: "error",
                sx: {
                    position: "absolute",
                    fontSize: "1rem"
                }
            }) : null
        ]
    });
}



const $a42de8e3d9281cf9$export$2c7c0aed1e91313a = ({ step: step, process: process })=>{
    const { title: title, message: message } = (0, $a9b09eb4d34322c5$export$f8e5ba18f67b75bc)(step, process);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 2,
        py: 1,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    (0, $cZGFG.jsx)((0, $4a4228a153ead893$export$9e72f56a493060bf), {
                        process: process
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        mx: 2,
                        flex: 1,
                        fontSize: 14,
                        fontWeight: process.error ? 600 : 400,
                        children: title
                    }),
                    process.txLink ? (0, $cZGFG.jsx)((0, $eedaa44dc13263e1$export$29d11c0fe2fc51d8), {
                        size: "small",
                        edge: "end",
                        LinkComponent: (0, $8e9053afbc4d5b0b$export$2e2bcd8739ae039),
                        href: process.txLink,
                        target: "_blank",
                        rel: "nofollow noreferrer",
                        children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5593d3c8427d3089$exports))), {})
                    }) : null
                ]
            }),
            message ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                ml: 6,
                fontSize: 14,
                fontWeight: 500,
                color: "text.secondary",
                children: message
            }) : null
        ]
    });
};



const $6858562fe1a293ac$export$fd55ce593607084a = ({ step: step, fromToken: fromToken, toToken: toToken, toAddress: toAddress })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const stepHasError = step.execution?.process.some((process)=>process.status === "FAILED");
    const getCardTitle = ()=>{
        switch(step.type){
            case "lifi":
                const hasCrossStep = step.includedSteps.some((step)=>step.type === "cross");
                const hasSwapStep = step.includedSteps.some((step)=>step.type === "swap");
                if (hasCrossStep && hasSwapStep) return subvariant === "nft" ? t("main.stepBridgeAndBuy") : t("main.stepSwapAndBridge");
                if (hasCrossStep) return subvariant === "nft" ? t("main.stepBridgeAndBuy") : t("main.stepBridge");
                return subvariant === "nft" ? t("main.stepSwapAndBuy") : t("main.stepSwap");
            default:
                return subvariant === "nft" ? t("main.stepSwapAndBuy") : t("main.stepSwap");
        }
    };
    const formattedToAddress = (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(toAddress);
    const toAddressLink = toAddress ? `${getChainById(step.action.toChainId)?.metamask.blockExplorerUrls[0]}address/${toAddress}` : undefined;
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        variant: stepHasError ? "error" : "default",
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flex: 1
                },
                children: [
                    (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                        flex: 1,
                        children: getCardTitle()
                    }),
                    (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                        sx: {
                            fontWeight: 500
                        },
                        children: (0, $cZGFG.jsx)((0, $5e8e03e301157ec7$export$7f5b674fa502d40e), {
                            step: step
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                py: 1,
                children: [
                    fromToken ? (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: fromToken,
                        px: 2,
                        py: 1
                    }) : null,
                    (0, $cZGFG.jsx)((0, $9e46d9a23b4027f5$export$f5a9677241e3f131), {
                        step: step,
                        px: 2,
                        py: 1,
                        dense: true
                    }),
                    step.execution?.process.map((process, index)=>(0, $cZGFG.jsx)((0, $a42de8e3d9281cf9$export$2c7c0aed1e91313a), {
                            step: step,
                            process: process
                        }, index)),
                    (0, $cZGFG.jsx)((0, $ae3640a34ab2bd25$export$1e73db1bb241880b), {
                        step: step
                    }),
                    formattedToAddress && toAddressLink ? (0, $cZGFG.jsx)((0, $526d2a9488d7b041$export$edd7d34c7662d506), {
                        step: step,
                        toAddress: formattedToAddress,
                        toAddressLink: toAddressLink
                    }) : null,
                    toToken ? (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: toToken,
                        px: 2,
                        py: 1
                    }) : null
                ]
            })
        ]
    });
};


const $a65dacf8b3cba7ad$export$e9e7af8c51e203e0 = (route, subvariant)=>route?.steps.map((step, index, steps)=>{
        const lastIndex = steps.length - 1;
        const fromToken = index === 0 ? {
            ...step.action.fromToken,
            amount: step.action.fromAmount
        } : undefined;
        const toToken = index === lastIndex ? {
            ...step.execution?.toToken ?? step.action?.toToken,
            amount: step.execution?.toAmount ? step.execution.toAmount : subvariant === "nft" ? route.toAmount : step.estimate.toAmount
        } : undefined;
        const toAddress = index === lastIndex && route.fromAddress !== route.toAddress ? route.toAddress : undefined;
        return (0, $cZGFG.jsxs)((0, $dup7A.Fragment), {
            children: [
                (0, $cZGFG.jsx)((0, $6858562fe1a293ac$export$fd55ce593607084a), {
                    step: step,
                    fromToken: fromToken,
                    toToken: toToken,
                    toAddress: toAddress
                }),
                steps.length > 1 && index !== steps.length - 1 ? (0, $cZGFG.jsx)((0, $c0137d9629ed98ce$export$e3b2e5a5ec9ae895), {}) : null
            ]
        }, step.id);
    });







var $cZGFG = parcelRequire("cZGFG");




const $9ff5d560408334c6$export$29a9e05f3a79027f = ({ supportId: supportId })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const widgetEvents = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    const handleClick = ()=>{
        if (!widgetEvents.all.has((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteContactSupport)) {
            const url = "https://discord.gg/lifi";
            const target = "_blank";
            const rel = "nofollow noreferrer";
            window.open(url, target, rel);
        } else widgetEvents.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteContactSupport, {
            supportId: supportId
        });
    };
    return (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
        onClick: handleClick,
        fullWidth: true,
        children: t("button.contactSupport")
    });
};




var $jjHhy = parcelRequire("jjHhy");
const $352e9498331c5293$export$42a852a2b6b56249 = (0, $jjHhy.default)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(1, 3)
    }));


const $ad2662259f2bf6b3$export$ff09adaa2bbd5675 = ()=>{
    const { t: t, i18n: i18n } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { subvariant: subvariant, contractComponent: contractComponent, contractSecondaryComponent: contractSecondaryComponent } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { state: state } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const [routeExecution, deleteRoute] = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((store)=>[
            store.routes[state?.routeId],
            store.deleteRoute
        ], (0, $cZFtK.shallow));
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const [open, setOpen] = (0, $dup7A.useState)(false);
    const toggleDialog = (0, $dup7A.useCallback)(()=>{
        setOpen((open)=>!open);
    }, []);
    const handleDeleteRoute = ()=>{
        navigateBack();
        if (routeExecution) deleteRoute(routeExecution.route.id);
    };
    const sourceTxHash = routeExecution?.route.steps[0].execution?.process.filter((process)=>process.type !== "TOKEN_ALLOWANCE").find((process)=>process.txHash)?.txHash;
    const insuranceCoverageId = sourceTxHash ?? routeExecution?.route.fromAddress;
    let supportId = sourceTxHash ?? routeExecution?.route.id ?? "";
    const copySupportId = async ()=>{
        await navigator.clipboard.writeText(supportId);
    };
    (0, $dup7A.useEffect)(()=>{
        return headerStoreContext.getState().setAction((0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
            size: "medium",
            edge: "end",
            onClick: toggleDialog,
            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e7063c060c419724$exports))), {})
        }));
    }, [
        headerStoreContext,
        toggleDialog
    ]);
    const startedAt = new Date(routeExecution?.route.steps[0].execution?.process[0].startedAt ?? 0);
    return (0, $cZGFG.jsxs)((0, $352e9498331c5293$export$42a852a2b6b56249), {
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flex: 1,
                    justifyContent: "space-between"
                },
                pb: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontSize: 12,
                        children: new Intl.DateTimeFormat(i18n.language, {
                            dateStyle: "long"
                        }).format(startedAt)
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontSize: 12,
                        children: new Intl.DateTimeFormat(i18n.language, {
                            timeStyle: "short"
                        }).format(startedAt)
                    })
                ]
            }),
            (0, $a65dacf8b3cba7ad$export$e9e7af8c51e203e0)(routeExecution?.route, subvariant),
            subvariant === "nft" ? (0, $cZGFG.jsx)((0, $7aeac184c64d60ca$export$e3ffc3645fcb5ea8), {
                mt: 2,
                children: contractSecondaryComponent || contractComponent
            }) : null,
            routeExecution?.route?.insurance?.state === "INSURED" ? (0, $cZGFG.jsx)((0, $ca8f2122b2b9bd8c$export$56ad944ccf4d3da9), {
                mt: 2,
                status: routeExecution.status,
                feeAmountUsd: routeExecution.route.insurance.feeAmountUsd,
                insuredAmount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(routeExecution.route.toAmountMin, routeExecution.route.toToken.decimals),
                insuredTokenSymbol: routeExecution.route.toToken.symbol,
                insurableRouteId: routeExecution.route.id,
                insuranceCoverageId: insuranceCoverageId
            }) : null,
            (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
                mt: 2,
                children: [
                    (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            flex: 1
                        },
                        children: [
                            (0, $cZGFG.jsx)((0, $1dd1e767d3ead2a1$export$474db65c3c394e1c), {
                                flex: 1,
                                children: t("main.supportId")
                            }),
                            (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                mr: 1,
                                mt: 1,
                                children: (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
                                    size: "medium",
                                    onClick: copySupportId,
                                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99400aca3ce3aa54$exports))), {
                                        fontSize: "small"
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        variant: "body2",
                        pt: 1,
                        pb: 2,
                        px: 2,
                        sx: {
                            wordBreak: "break-all"
                        },
                        children: supportId
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                mt: 2,
                children: (0, $cZGFG.jsx)((0, $9ff5d560408334c6$export$29a9e05f3a79027f), {
                    supportId: supportId
                })
            }),
            (0, $cZGFG.jsxs)((0, $f719477393eb6354$export$3ddf2d174ce01153), {
                open: open,
                onClose: toggleDialog,
                children: [
                    (0, $cZGFG.jsx)((0, $c7caddaf71674940$export$2e2bcd8739ae039), {
                        children: t("warning.title.deleteTransaction")
                    }),
                    (0, $cZGFG.jsx)((0, $da3939ee95c82076$export$2e2bcd8739ae039), {
                        children: (0, $cZGFG.jsx)((0, $1f0b92c5665aa4ca$export$2e2bcd8739ae039), {
                            children: t("warning.message.deleteTransactionHistory")
                        })
                    }),
                    (0, $cZGFG.jsxs)((0, $20eff1c46eaadcad$export$2e2bcd8739ae039), {
                        children: [
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                onClick: toggleDialog,
                                children: t("button.cancel")
                            }),
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                variant: "contained",
                                onClick: handleDeleteRoute,
                                autoFocus: true,
                                children: t("button.delete")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");



var $dup7A = parcelRequire("dup7A");





var $cZFtK = parcelRequire("cZFtK");



const $09267de22dc8b3a3$export$eaffe3535a5f75b0 = (address)=>{
    return (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>Object.values(state.routes).filter((item)=>item?.route.fromAddress === address && (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(item.status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done)).sort((a, b)=>(b?.route.steps[0].execution?.process[0].startedAt ?? 0) - (a?.route.steps[0].execution?.process[0].startedAt ?? 0)), (0, $cZFtK.shallow));
};



var $cZGFG = parcelRequire("cZGFG");
var $35ae25d84ca97fc0$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($35ae25d84ca97fc0$exports, "__esModule", {
    value: true
});
$35ae25d84ca97fc0$exports.default = void 0;

var $35ae25d84ca97fc0$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $35ae25d84ca97fc0$var$_default = $35ae25d84ca97fc0$exports.default = (0, $35ae25d84ca97fc0$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M14 9h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1m0 3h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1"
    }, "0"),
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H4c-.55 0-1 .45-1 1v2c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2zM15 20H6c-.55 0-1-.45-1-1v-1h10zm4-1c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55-.45-1-1-1H8V5h11z"
    }, "1"),
    /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
        cx: "17",
        cy: "8",
        r: "1"
    }, "2"),
    /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
        cx: "17",
        cy: "11",
        r: "1"
    }, "3")
], "ReceiptLongRounded");




const $3970f21c72287795$export$1772c227860c1535 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingY: 12
        },
        children: [
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 48,
                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35ae25d84ca97fc0$exports))), {
                    fontSize: "inherit"
                })
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 18,
                fontWeight: 700,
                children: t("info.title.emptyTransactionHistory")
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                fontSize: 14,
                color: "text.secondary",
                textAlign: "center",
                mt: 2,
                children: t("info.message.emptyTransactionHistory")
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");






const $edaa6893165b9227$export$7555b95bb1e41cbc = ({ route: route })=>{
    const { i18n: i18n } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const handleClick = ()=>{
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionDetails, {
            state: {
                routeId: route.id
            }
        });
    };
    const startedAt = new Date(route.steps[0].execution?.process[0].startedAt ?? 0);
    const fromToken = {
        ...route.fromToken,
        amount: route.fromAmount
    };
    const toToken = {
        ...route.steps.at(-1)?.execution?.toToken ?? route.toToken,
        amount: route.steps.at(-1)?.execution?.toAmount ?? route.toAmount
    };
    return (0, $cZGFG.jsxs)((0, $d481e0f0eb26e19b$export$60332b2344f7fe41), {
        onClick: handleClick,
        children: [
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    flex: 1,
                    justifyContent: "space-between"
                },
                pt: 1.75,
                px: 2,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontSize: 12,
                        children: new Intl.DateTimeFormat(i18n.language, {
                            dateStyle: "long"
                        }).format(startedAt)
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontSize: 12,
                        children: new Intl.DateTimeFormat(i18n.language, {
                            timeStyle: "short"
                        }).format(startedAt)
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                py: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: fromToken,
                        px: 2,
                        pt: 1,
                        connected: true
                    }),
                    (0, $cZGFG.jsx)((0, $fded27839ecb401f$export$747e1a77b610cd5c), {}),
                    (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: toToken,
                        px: 2,
                        pt: 0.5,
                        pb: 1
                    })
                ]
            })
        ]
    });
};


const $00488d5f5482e973$export$31ee3f2f44c9cd11 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const transactions = (0, $09267de22dc8b3a3$export$eaffe3535a5f75b0)(account.address);
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const deleteRoutes = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((store)=>store.deleteRoutes);
    const [open, setOpen] = (0, $dup7A.useState)(false);
    const toggleDialog = (0, $dup7A.useCallback)(()=>{
        setOpen((open)=>!open);
    }, []);
    (0, $dup7A.useEffect)(()=>{
        if (transactions.length) return headerStoreContext.getState().setAction((0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
            size: "medium",
            edge: "end",
            onClick: toggleDialog,
            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e7063c060c419724$exports))), {})
        }));
    }, [
        transactions.length,
        toggleDialog,
        headerStoreContext
    ]);
    if (!transactions.length) return (0, $cZGFG.jsx)((0, $3970f21c72287795$export$1772c227860c1535), {});
    return (0, $cZGFG.jsxs)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039), {
        children: [
            (0, $cZGFG.jsx)((0, $0fdecc513a2d3d55$export$2e2bcd8739ae039), {
                spacing: 2,
                mt: 1,
                children: transactions.length ? transactions.map(({ route: route })=>(0, $cZGFG.jsx)((0, $edaa6893165b9227$export$7555b95bb1e41cbc), {
                        route: route
                    }, route.id)) : (0, $cZGFG.jsx)((0, $3970f21c72287795$export$1772c227860c1535), {})
            }),
            (0, $cZGFG.jsxs)((0, $f719477393eb6354$export$3ddf2d174ce01153), {
                open: open,
                onClose: toggleDialog,
                children: [
                    (0, $cZGFG.jsx)((0, $c7caddaf71674940$export$2e2bcd8739ae039), {
                        children: t("warning.title.deleteTransactionHistory")
                    }),
                    (0, $cZGFG.jsx)((0, $da3939ee95c82076$export$2e2bcd8739ae039), {
                        children: (0, $cZGFG.jsx)((0, $1f0b92c5665aa4ca$export$2e2bcd8739ae039), {
                            children: t("warning.message.deleteTransactionHistory")
                        })
                    }),
                    (0, $cZGFG.jsxs)((0, $20eff1c46eaadcad$export$2e2bcd8739ae039), {
                        children: [
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                onClick: toggleDialog,
                                children: t("button.cancel")
                            }),
                            (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                variant: "contained",
                                onClick: ()=>deleteRoutes("completed"),
                                autoFocus: true,
                                children: t("button.delete")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
var $bde90f4472499421$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($bde90f4472499421$exports, "__esModule", {
    value: true
});
$bde90f4472499421$exports.default = void 0;

var $bde90f4472499421$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $bde90f4472499421$var$_default = $bde90f4472499421$exports.default = (0, $bde90f4472499421$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");




var $dup7A = parcelRequire("dup7A");













var $cZGFG = parcelRequire("cZGFG");




var $dup7A = parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");


var $dup7A = parcelRequire("dup7A");


const $6ec3eac5c6df12c5$export$2058ef1a26004a97 = (0, $dup7A.forwardRef)(({ elementRef: elementRef, children: children, open: open, onClose: onClose }, ref)=>{
    const getContainer = (0, $ce8a180a0be6eb02$export$1723bfc52a609875)();
    const openRef = (0, $dup7A.useRef)(open);
    const [drawerOpen, setDrawerOpen] = (0, $dup7A.useState)(open);
    const close = (0, $dup7A.useCallback)(()=>{
        setDrawerOpen(false);
        openRef.current = false;
        onClose?.();
    }, [
        onClose
    ]);
    (0, $dup7A.useImperativeHandle)(ref, ()=>({
            isOpen: ()=>openRef.current,
            open: ()=>{
                setDrawerOpen(true);
                openRef.current = true;
            },
            close: close
        }), [
        close
    ]);
    return (0, $cZGFG.jsx)((0, $087d17b7c478e027$export$2e2bcd8739ae039), {
        container: getContainer,
        ref: elementRef,
        anchor: "bottom",
        open: drawerOpen,
        onClose: close,
        ModalProps: (0, $f719477393eb6354$export$e6e63efe27adb93f),
        PaperProps: (0, $f719477393eb6354$export$c83585ffd693a912),
        BackdropProps: (0, $f719477393eb6354$export$1e727dea50000122),
        disableAutoFocus: true,
        children: children
    });
});






var $jjHhy = parcelRequire("jjHhy");

const $549717d303e32d21$var$getStatusColor = (status, theme)=>{
    switch(status){
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done:
            return {
                color: theme.palette.success.main,
                alpha: 0.12,
                darken: 0
            };
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed:
            return {
                color: theme.palette.error.main,
                alpha: 0.12,
                darken: 0
            };
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done | (0, $2226555593f1025b$export$c56db2dca1307c9d).Partial:
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done | (0, $2226555593f1025b$export$c56db2dca1307c9d).Refunded:
        case "warning":
            return {
                color: theme.palette.warning.main,
                alpha: 0.48,
                darken: theme.palette.mode === "light" ? 0.32 : 0
            };
        default:
            return {
                color: theme.palette.primary.main,
                alpha: 0.12,
                darken: 0
            };
    }
};
const $549717d303e32d21$export$2b57589e501cde70 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "grid",
        placeItems: "center",
        position: "relative"
    }));
const $549717d303e32d21$export$c5585d306191014 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "status"
})(({ theme: theme, status: status })=>{
    const { color: color, alpha: alphaValue, darken: darkenValue } = $549717d303e32d21$var$getStatusColor(status, theme);
    return {
        backgroundColor: (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(color, alphaValue),
        borderRadius: "50%",
        width: 64,
        height: 64,
        display: "grid",
        position: "relative",
        placeItems: "center",
        "& > svg": {
            color: (0, $ecd44ebd791a3fa9$export$4b073707ff63303)(color, darkenValue),
            width: 32,
            height: 32
        }
    };
});


const $f747f7382c7f8f9f$export$ee8815e1290cb470 = (0, $dup7A.forwardRef)(({ onContinue: onContinue, onCancel: onCancel }, ref)=>{
    const [data, setData] = (0, $dup7A.useState)();
    const bottomSheetRef = (0, $dup7A.useRef)(null);
    const resolverRef = (0, $dup7A.useRef)();
    const handleContinue = ()=>{
        ref.current?.close(true);
        onContinue?.();
    };
    const handleCancel = (0, $dup7A.useCallback)(()=>{
        ref.current?.close(false);
        onCancel?.();
    }, [
        onCancel,
        ref
    ]);
    const handleClose = (0, $dup7A.useCallback)(()=>{
        ref.current?.close(false, false);
        onCancel?.();
    }, [
        onCancel,
        ref
    ]);
    (0, $dup7A.useImperativeHandle)(ref, ()=>({
            isOpen: ()=>bottomSheetRef.current?.isOpen(),
            open: (resolver, data)=>{
                setData(data);
                resolverRef.current = resolver;
                bottomSheetRef.current?.open();
            },
            close: (value = false, bottomSheetClose = true)=>{
                resolverRef.current?.(value);
                if (bottomSheetClose) bottomSheetRef.current?.close();
            }
        }), []);
    return (0, $cZGFG.jsx)((0, $6ec3eac5c6df12c5$export$2058ef1a26004a97), {
        ref: bottomSheetRef,
        onClose: handleClose,
        children: (0, $cZGFG.jsx)($f747f7382c7f8f9f$var$ExchangeRateBottomSheetContent, {
            data: data,
            onContinue: handleContinue,
            onCancel: handleCancel
        })
    });
});
const $f747f7382c7f8f9f$var$ExchangeRateBottomSheetContent = ({ data: data, onCancel: onCancel, onContinue: onContinue })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const ref = (0, $dup7A.useRef)();
    (0, $a872f3383e413d03$export$954e3a846cea0a52)(ref);
    const oldAmount = (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(data?.oldToAmount || 1);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        p: 3,
        ref: ref,
        children: [
            (0, $cZGFG.jsxs)((0, $549717d303e32d21$export$2b57589e501cde70), {
                children: [
                    (0, $cZGFG.jsx)((0, $549717d303e32d21$export$c5585d306191014), {
                        status: "warning",
                        mb: 1,
                        children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cdfc4e60aecac3af$exports))), {
                            color: "warning"
                        })
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        py: 1,
                        fontSize: 18,
                        fontWeight: 700,
                        children: t("warning.title.rateChanged")
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                py: 1,
                children: t("warning.message.rateChanged")
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.quotedAmount")
                    }),
                    (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: [
                            t("format.number", {
                                value: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(data?.oldToAmount, data?.toToken.decimals, 5)
                            }),
                            " ",
                            data?.toToken.symbol
                        ]
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 0.25,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.currentAmount")
                    }),
                    (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: [
                            t("format.number", {
                                value: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(data?.newToAmount, data?.toToken.decimals, 5)
                            }),
                            " ",
                            data?.toToken.symbol
                        ]
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 0.25,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.rateChange")
                    }),
                    (0, $cZGFG.jsxs)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(data?.newToAmount || 0).div(oldAmount.eq(0) ? (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports)))(1) : oldAmount).minus(1).mul(100).round(2, (0, (/*@__PURE__*/$parcel$interopDefault($b344950477380f3f$exports))).roundUp).toString(),
                            "%"
                        ]
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                mt: 3,
                children: [
                    (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "text",
                        onClick: onCancel,
                        fullWidth: true,
                        children: t("button.cancel")
                    }),
                    (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        display: "flex",
                        p: 1
                    }),
                    (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "contained",
                        onClick: onContinue,
                        fullWidth: true,
                        children: t("button.continue")
                    })
                ]
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");



const $60b33d2f2c07dbc5$export$934371125c6f69c4 = ({ onClick: onClick, route: route, text: text, loading: loading })=>{
    const { insufficientGas: insufficientGas, isInitialLoading: isGasSufficiencyLoading } = (0, $4fde403c8cd0fba4$export$219afe79026b8536)(route);
    const { insufficientFromToken: insufficientFromToken, isInitialLoading: isFromTokenSufficiencyLoading } = (0, $5841b638342b4fa9$export$3347879a42f96196)(route);
    const shouldDisableButton = insufficientFromToken || !!insufficientGas?.length;
    return (0, $cZGFG.jsx)((0, $64045c4ec0f22d0f$export$f2dd1fb73bb18d9c), {
        onClick: onClick,
        text: text,
        disabled: shouldDisableButton,
        loading: isFromTokenSufficiencyLoading || isGasSufficiencyLoading || loading
    });
};
const $60b33d2f2c07dbc5$export$668bec61373106c = ({ onClick: onClick, text: text, route: route, loading: loading, disabled: disabled, insurableRouteId: insurableRouteId })=>{
    const routeExecution = (0, $6f14d8247607a81d$export$6405db3e9caa77c)((state)=>state.routes[insurableRouteId]);
    const { isFetching: isFetching } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)({
        insurableRoute: routeExecution?.route
    });
    return (0, $cZGFG.jsx)($60b33d2f2c07dbc5$export$934371125c6f69c4, {
        onClick: onClick,
        text: text,
        route: route,
        disabled: disabled,
        loading: loading || isFetching,
        insurableRouteId: insurableRouteId
    });
};



var $cZGFG = parcelRequire("cZGFG");






var $dup7A = parcelRequire("dup7A");









const $eb7914ce98667d91$export$d4df7151f2dfc97b = ({ status: status, route: route })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { navigateBack: navigateBack, navigate: navigate } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const ref = (0, $dup7A.useRef)(null);
    const { getChainById: getChainById } = (0, $ca520e918cee1775$export$15806ff9a87500a1)();
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const { subvariant: subvariant, contractComponent: contractComponent, contractSecondaryComponent: contractSecondaryComponent, contractCompactComponent: contractCompactComponent } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const toToken = {
        ...route.steps.at(-1)?.execution?.toToken ?? route.toToken,
        amount: route.steps.at(-1)?.execution?.toAmount ?? route.steps.at(-1)?.estimate.toAmount ?? route.toAmount
    };
    const { token: token, refetch: refetch, refetchNewBalance: refetchNewBalance, refetchAllBalances: refetchAllBalances } = (0, $590670eb38959b19$export$c79c82fb94eb75b4)(toToken, route.toAddress);
    const clearFromAmount = ()=>{
        refetchAllBalances();
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, "");
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToAmount, "");
    };
    const handleDone = ()=>{
        clearFromAmount();
        navigateBack();
    };
    const handlePartialDone = ()=>{
        clearFromAmount();
        if (toToken.chainId !== route.toToken.chainId && toToken.address !== route.toToken.address) {
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(toToken.amount, toToken.decimals), {
                shouldTouch: true
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromChain, toToken.chainId, {
                shouldTouch: true
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken, toToken.address, {
                shouldTouch: true
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToChain, route.toToken.chainId, {
                shouldTouch: true
            });
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken, route.toToken.address, {
                shouldTouch: true
            });
        }
        navigateBack();
    };
    const handleClose = ()=>{
        clearFromAmount();
        ref.current?.close();
    };
    const handleSeeDetails = ()=>{
        handleClose();
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionDetails, {
            state: {
                routeId: route.id
            },
            replace: true
        });
    };
    const transactionType = route.fromChainId === route.toChainId ? "swap" : "bridge";
    let title;
    let primaryMessage;
    let secondaryMessage;
    let handlePrimaryButton = handleDone;
    switch(status){
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done:
            title = subvariant === "nft" ? t("success.title.purchaseSuccessful") : t(`success.title.${transactionType}Successful`);
            if (token) primaryMessage = t("success.message.exchangeSuccessful", {
                amount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token.amount),
                tokenSymbol: token.symbol,
                chainName: getChainById(token.chainId)?.name,
                walletAddress: (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(route.toAddress)
            });
            handlePrimaryButton = handleDone;
            break;
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done | (0, $2226555593f1025b$export$c56db2dca1307c9d).Partial:
            title = t(`success.title.${transactionType}PartiallySuccessful`);
            primaryMessage = t("success.message.exchangePartiallySuccessful", {
                tool: route.steps.at(-1)?.toolDetails.name,
                tokenSymbol: route.steps.at(-1)?.action.toToken.symbol
            });
            if (token) secondaryMessage = t("success.message.exchangeSuccessful", {
                amount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token.amount),
                tokenSymbol: token.symbol,
                chainName: getChainById(token.chainId)?.name,
                walletAddress: (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(route.toAddress)
            });
            handlePrimaryButton = handlePartialDone;
            break;
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Done | (0, $2226555593f1025b$export$c56db2dca1307c9d).Refunded:
            title = t("success.title.refundIssued");
            primaryMessage = t("success.message.exchangePartiallySuccessful", {
                tool: route.steps.at(-1)?.toolDetails.name,
                tokenSymbol: route.steps.at(-1)?.action.toToken.symbol
            });
            if (token) secondaryMessage = t("success.message.exchangeSuccessful", {
                amount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(token.amount),
                tokenSymbol: token.symbol,
                chainName: getChainById(token.chainId)?.name,
                walletAddress: (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(route.toAddress)
            });
            break;
        case (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed:
            {
                const step = route.steps.find((step)=>step.execution?.status === "FAILED");
                const process = step?.execution?.process.find((process)=>process.status === "FAILED");
                if (!step || !process) break;
                const processMessage = (0, $a9b09eb4d34322c5$export$c1f6bd730b0cbdd0)(t, getChainById, step, process);
                title = processMessage.title;
                primaryMessage = processMessage.message;
                handlePrimaryButton = handleClose;
                break;
            }
        default:
            break;
    }
    (0, $dup7A.useEffect)(()=>{
        const hasSuccessFlag = (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done);
        if ((hasSuccessFlag || (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed)) && !ref.current?.isOpen()) {
            if (hasSuccessFlag) {
                refetchNewBalance();
                refetch();
            }
            ref.current?.open();
        }
    }, [
        refetch,
        refetchNewBalance,
        status
    ]);
    const showContractComponent = subvariant === "nft" && (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done);
    return (0, $cZGFG.jsx)((0, $6ec3eac5c6df12c5$export$2058ef1a26004a97), {
        ref: ref,
        children: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
            p: 3,
            children: [
                !showContractComponent ? (0, $cZGFG.jsx)((0, $549717d303e32d21$export$2b57589e501cde70), {
                    children: (0, $cZGFG.jsxs)((0, $549717d303e32d21$export$c5585d306191014), {
                        status: status,
                        mb: 1,
                        children: [
                            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70197f36b6f91ee5$exports))), {
                                color: "primary"
                            }) : null,
                            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Done ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca117ed6cec72ff0$exports))), {
                                color: "success"
                            }) : null,
                            (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Partial) || (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Refunded) ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cdfc4e60aecac3af$exports))), {
                                color: "warning"
                            }) : null,
                            (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed) ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80b718eceab489f4$exports))), {
                                color: "error"
                            }) : null
                        ]
                    })
                }) : null,
                (0, $cZGFG.jsx)((0, $549717d303e32d21$export$2b57589e501cde70), {
                    children: (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        py: 1,
                        fontSize: 18,
                        fontWeight: 700,
                        children: title
                    })
                }),
                showContractComponent ? contractCompactComponent || contractSecondaryComponent || contractComponent : (0, $cZGFG.jsx)((0, $549717d303e32d21$export$2b57589e501cde70), {
                    children: (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done) ? (0, $cZGFG.jsx)((0, $ce33ee047fb204c2$export$50792b0e93539fde), {
                        token: toToken,
                        py: 1,
                        disableDescription: true
                    }) : null
                }),
                !showContractComponent ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    py: 1,
                    children: primaryMessage
                }) : null,
                secondaryMessage ? (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                    py: 1,
                    children: secondaryMessage
                }) : null,
                (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    mt: 2,
                    children: (0, $cZGFG.jsxs)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "contained",
                        fullWidth: true,
                        onClick: handlePrimaryButton,
                        children: [
                            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? t("button.ok") : null,
                            (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done) ? t("button.done") : null,
                            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed ? t("button.seeDetails") : null
                        ]
                    })
                }),
                (0, $253a8a88e3ebc36f$export$3a633d5116c5b50b)(status, (0, $2226555593f1025b$export$c56db2dca1307c9d).Done) ? (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                    mt: 2,
                    children: (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "text",
                        onClick: handleSeeDetails,
                        fullWidth: true,
                        children: t("button.seeDetails")
                    })
                }) : null
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");



var $dup7A = parcelRequire("dup7A");




const $01655fd3e9869e7e$export$d2dc472d1b98acb1 = (route)=>{
    return `${((Number(route.toAmountUSD || 0) / (Number(route.fromAmountUSD || 0) + Number(route.gasCostUSD || 0)) - 1) * 100).toFixed(2)}%`;
};


const $401471c9bd1fbcd4$export$c6b0ef5a22bd6531 = (0, $dup7A.forwardRef)(({ route: route, onContinue: onContinue, onCancel: onCancel }, ref)=>{
    const handleCancel = ()=>{
        ref.current?.close();
        onCancel?.();
    };
    return (0, $cZGFG.jsx)((0, $6ec3eac5c6df12c5$export$2058ef1a26004a97), {
        ref: ref,
        onClose: onCancel,
        children: (0, $cZGFG.jsx)($401471c9bd1fbcd4$var$TokenValueBottomSheetContent, {
            route: route,
            onContinue: onContinue,
            onCancel: handleCancel
        })
    });
});
const $401471c9bd1fbcd4$var$TokenValueBottomSheetContent = ({ route: route, onCancel: onCancel, onContinue: onContinue })=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const ref = (0, $dup7A.useRef)();
    (0, $a872f3383e413d03$export$954e3a846cea0a52)(ref);
    return (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        p: 3,
        ref: ref,
        children: [
            (0, $cZGFG.jsxs)((0, $549717d303e32d21$export$2b57589e501cde70), {
                children: [
                    (0, $cZGFG.jsx)((0, $549717d303e32d21$export$c5585d306191014), {
                        status: "warning",
                        mb: 1,
                        children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cdfc4e60aecac3af$exports))), {
                            color: "warning"
                        })
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        py: 1,
                        fontSize: 18,
                        fontWeight: 700,
                        children: t("warning.title.highValueLoss")
                    })
                ]
            }),
            (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                py: 1,
                children: t("warning.message.highValueLoss")
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 1,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.sending")
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: t("format.currency", {
                            value: route.fromAmountUSD
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 0.25,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.gasCost")
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: t("format.currency", {
                            value: route.gasCostUSD
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 0.25,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.receiving")
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: t("format.currency", {
                            value: route.toAmountUSD
                        })
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 0.25,
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        children: t("main.valueLoss")
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontWeight: 600,
                        children: (0, $01655fd3e9869e7e$export$d2dc472d1b98acb1)(route)
                    })
                ]
            }),
            (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                display: "flex",
                mt: 3,
                children: [
                    (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "text",
                        onClick: onCancel,
                        fullWidth: true,
                        children: t("button.cancel")
                    }),
                    (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        display: "flex",
                        p: 1
                    }),
                    (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        variant: "contained",
                        onClick: onContinue,
                        fullWidth: true,
                        children: t("button.continue")
                    })
                ]
            })
        ]
    });
};
const $401471c9bd1fbcd4$export$7ea1cb853ea36aa1 = (route)=>{
    if (!route) return false;
    const fromAmountUSD = Number(route.fromAmountUSD || 0);
    const toAmountUSD = Number(route.toAmountUSD || 0);
    const gasCostUSD = Number(route.gasCostUSD || 0);
    if (!fromAmountUSD && !toAmountUSD) return false;
    return toAmountUSD / (fromAmountUSD + gasCostUSD) < 0.9;
};




var $jjHhy = parcelRequire("jjHhy");
const $c83de39e1b9fbd88$export$42a852a2b6b56249 = (0, $jjHhy.default)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: theme.spacing(1, 3)
    }));



const $7e5753c2de4ab768$export$3320734e35b52717 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const emitter = (0, $eb9f1c9980ab77fe$export$f31d65a8503b5870)();
    const { navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { subvariant: subvariant, insurance: insurance, contractComponent: contractComponent, contractSecondaryComponent: contractSecondaryComponent } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { state: state } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const headerStoreContext = (0, $91390e33d9f5c5f2$export$5255361406b00845)();
    const stateRouteId = state?.routeId;
    const [routeId, setRouteId] = (0, $dup7A.useState)(stateRouteId);
    const tokenValueBottomSheetRef = (0, $dup7A.useRef)(null);
    const exchangeRateBottomSheetRef = (0, $dup7A.useRef)(null);
    const onAcceptExchangeRateUpdate = (resolver, data)=>{
        exchangeRateBottomSheetRef.current?.open(resolver, data);
    };
    const { route: route, status: status, executeRoute: executeRoute, restartRoute: restartRoute, deleteRoute: deleteRoute } = (0, $3ebe4fdf186d93e7$export$f5db81c77ed06ae3)({
        routeId: routeId,
        onAcceptExchangeRateUpdate: onAcceptExchangeRateUpdate
    });
    (0, $dup7A.useEffect)(()=>{
        if (route && subvariant !== "nft") {
            const transactionType = route.fromChainId === route.toChainId ? "Swap" : "Bridge";
            return headerStoreContext.getState().setTitle(status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle ? t(`button.review${transactionType}`) : t(`header.${transactionType.toLowerCase()}`));
        }
    }, [
        headerStoreContext,
        route,
        status,
        subvariant,
        t
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).ReviewTransactionPageEntered, route);
    // We want to emit event only when the page is mounted
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!route) return null;
    const tokenValueLossThresholdExceeded = (0, $401471c9bd1fbcd4$export$7ea1cb853ea36aa1)(route);
    const handleExecuteRoute = ()=>{
        if (tokenValueBottomSheetRef.current?.isOpen()) emitter.emit((0, $1828d6f4ded3174a$export$ce4aabad2e495c53).RouteHighValueLoss, {
            fromAmountUsd: route.fromAmountUSD,
            gasCostUSD: route.gasCostUSD,
            toAmountUSD: route.toAmountUSD,
            valueLoss: (0, $01655fd3e9869e7e$export$d2dc472d1b98acb1)(route)
        });
        tokenValueBottomSheetRef.current?.close();
        executeRoute();
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, "");
        if (subvariant === "nft") {
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken, "");
            setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken, "");
        }
    };
    const handleStartClick = async ()=>{
        if (status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle) {
            if (tokenValueLossThresholdExceeded && subvariant !== "nft") tokenValueBottomSheetRef.current?.open();
            else handleExecuteRoute();
        }
        if (status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed) restartRoute();
    };
    const handleRemoveRoute = ()=>{
        navigateBack();
        deleteRoute();
    };
    const getButtonText = ()=>{
        switch(status){
            case (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle:
                switch(subvariant){
                    case "nft":
                        return t("button.buyNow");
                    case "refuel":
                        return t("button.startBridging");
                    default:
                        const transactionType = route.fromChainId === route.toChainId ? "Swapping" : "Bridging";
                        return t(`button.start${transactionType}`);
                }
            case (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed:
                return t("button.tryAgain");
            default:
                return "";
        }
    };
    const insuredRoute = route.insurance?.state === "INSURED";
    const insurableRoute = insurance && subvariant !== "refuel" && status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle && route.insurance?.state === "INSURABLE";
    const insuranceAvailable = insuredRoute || insurableRoute;
    const StartButton = insurableRoute ? (0, $60b33d2f2c07dbc5$export$668bec61373106c) : (0, $60b33d2f2c07dbc5$export$934371125c6f69c4);
    const getInsuranceCoverageId = ()=>route.steps[0].execution?.process.filter((process)=>process.type !== "TOKEN_ALLOWANCE").find((process)=>process.txHash)?.txHash ?? route.fromAddress;
    return (0, $cZGFG.jsxs)((0, $c83de39e1b9fbd88$export$42a852a2b6b56249), {
        children: [
            (0, $a65dacf8b3cba7ad$export$e9e7af8c51e203e0)(route, subvariant),
            subvariant === "nft" ? (0, $cZGFG.jsx)((0, $7aeac184c64d60ca$export$e3ffc3645fcb5ea8), {
                mt: 2,
                children: contractSecondaryComponent || contractComponent
            }) : null,
            insuranceAvailable ? (0, $cZGFG.jsx)((0, $ca8f2122b2b9bd8c$export$56ad944ccf4d3da9), {
                mt: 2,
                status: status,
                insurableRouteId: stateRouteId,
                feeAmountUsd: route.insurance.feeAmountUsd,
                insuredAmount: (0, $2a25b0bfe67ae18c$export$36da51c03c5f8def)(route.toAmountMin, route.toToken.decimals),
                insuredTokenSymbol: route.toToken.symbol,
                insuranceCoverageId: getInsuranceCoverageId(),
                onChange: setRouteId
            }) : null,
            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Idle || status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed ? (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
                children: [
                    (0, $cZGFG.jsx)((0, $222ddcb43da88869$export$2d75d7da0627a206), {
                        mt: 2,
                        route: route
                    }),
                    (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        mt: 2,
                        display: "flex",
                        children: [
                            (0, $cZGFG.jsx)(StartButton, {
                                text: getButtonText(),
                                onClick: handleStartClick,
                                route: route,
                                insurableRouteId: stateRouteId
                            }),
                            status === (0, $2226555593f1025b$export$c56db2dca1307c9d).Failed ? (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                                title: t("button.removeTransaction"),
                                placement: "bottom-end",
                                enterDelay: 400,
                                arrow: true,
                                children: (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                                    onClick: handleRemoveRoute,
                                    sx: {
                                        minWidth: 48,
                                        marginLeft: 1
                                    },
                                    children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bde90f4472499421$exports))), {})
                                })
                            }) : null
                        ]
                    })
                ]
            }) : null,
            status ? (0, $cZGFG.jsx)((0, $eb7914ce98667d91$export$d4df7151f2dfc97b), {
                status: status,
                route: route
            }) : null,
            tokenValueLossThresholdExceeded && subvariant !== "nft" ? (0, $cZGFG.jsx)((0, $401471c9bd1fbcd4$export$c6b0ef5a22bd6531), {
                route: route,
                ref: tokenValueBottomSheetRef,
                onContinue: handleExecuteRoute
            }) : null,
            (0, $cZGFG.jsx)((0, $f747f7382c7f8f9f$export$ee8815e1290cb470), {
                ref: exchangeRateBottomSheetRef
            })
        ]
    });
};



const $db0c8d6fdd06befa$export$37d3279522fbf5e2 = ()=>{
    const element = (0, $5c6d50c15e61ec01$export$5d3fca4a98652595)([
        {
            path: "/",
            element: (0, $cZGFG.jsx)((0, $c3a7705c17635eb9$export$ceaf35c25d4b1fe2), {})
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).settings,
            element: (0, $cZGFG.jsx)((0, $eb9f5ab05109938a$export$8f6dcfe950367406), {})
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).settings}/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).bridges}`,
            element: (0, $cZGFG.jsx)((0, $dfffc17238ad625c$export$ccc4668d06bbb9a5), {
                type: "Bridges"
            })
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).settings}/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).exchanges}`,
            element: (0, $cZGFG.jsx)((0, $dfffc17238ad625c$export$ccc4668d06bbb9a5), {
                type: "Exchanges"
            })
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromToken,
            element: (0, $cZGFG.jsx)((0, $a6d2d4ef9e269917$export$e89506ee3b10dad2), {
                formType: "from"
            })
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toToken,
            element: (0, $cZGFG.jsx)((0, $a6d2d4ef9e269917$export$e89506ee3b10dad2), {
                formType: "to"
            })
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toTokenNative,
            element: (0, $cZGFG.jsx)((0, $bdd2db4ad27ca836$export$e5956f5838b80deb), {
                formType: "to",
                selectNativeToken: true
            })
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromToken}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromChain}`,
            element: (0, $cZGFG.jsx)((0, $bdd2db4ad27ca836$export$e5956f5838b80deb), {
                formType: "from"
            })
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toToken}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toChain}`,
            element: (0, $cZGFG.jsx)((0, $bdd2db4ad27ca836$export$e5956f5838b80deb), {
                formType: "to"
            })
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes,
            element: (0, $cZGFG.jsx)((0, $96b3077f27b46816$export$ebde1f165243f87e), {})
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).activeTransactions,
            element: (0, $cZGFG.jsx)((0, $016c36cfdeb88c65$export$8b07b87de2e185c9), {})
        },
        {
            path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionHistory,
            element: (0, $cZGFG.jsx)((0, $00488d5f5482e973$export$31ee3f2f44c9cd11), {})
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionHistory}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionDetails}`,
            element: (0, $cZGFG.jsx)((0, $ad2662259f2bf6b3$export$ff09adaa2bbd5675), {})
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).selectWallet}`,
            element: (0, $cZGFG.jsx)((0, $95cddf1b891ddca9$export$a3514100e01c02be), {})
        },
        {
            path: `${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).activeTransactions}?/${(0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution}`,
            element: (0, $cZGFG.jsx)((0, $7e5753c2de4ab768$export$3320734e35b52717), {})
        },
        {
            path: "*",
            element: (0, $cZGFG.jsx)((0, $01b233a6d29a8b98$export$271f9f08425019c7), {})
        }
    ]);
    return element;
};



var $cZGFG = parcelRequire("cZGFG");

var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $7ZufN = parcelRequire("7ZufN");


var $cZGFG = parcelRequire("cZGFG");
"use client";
const $2bdce3f16a251339$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $3G4eg.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $2bdce3f16a251339$export$32180ef41b15b513 = (theme)=>(0, $3G4eg.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $2bdce3f16a251339$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $3G4eg.default)({
        html: $2bdce3f16a251339$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $3G4eg.default)({
            margin: 0
        }, $2bdce3f16a251339$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $2bdce3f16a251339$var$CssBaseline(inProps) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dc9a4c1442b0896e$export$2e2bcd8739ae039), {
                styles: (theme)=>$2bdce3f16a251339$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $2bdce3f16a251339$export$2e2bcd8739ae039 = $2bdce3f16a251339$var$CssBaseline;



var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $f97d7ca9ce192401$export$a3f1a6e59bdd9d27(slot) {
    return (0, $8iNDC.default)("MuiScopedCssBaseline", slot);
}
const $f97d7ca9ce192401$var$scopedCssBaselineClasses = (0, $fc1pF.default)("MuiScopedCssBaseline", [
    "root"
]);
var $f97d7ca9ce192401$export$2e2bcd8739ae039 = $f97d7ca9ce192401$var$scopedCssBaselineClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $6b662c6fa7058012$var$_excluded = [
    "className",
    "component",
    "enableColorScheme"
];
const $6b662c6fa7058012$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $f97d7ca9ce192401$export$a3f1a6e59bdd9d27), classes);
};
const $6b662c6fa7058012$var$ScopedCssBaselineRoot = (0, $jjHhy.default)("div", {
    name: "MuiScopedCssBaseline",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const colorSchemeStyles = {};
    if (ownerState.enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[`&${theme.getColorSchemeSelector(key).replace(/\s*&/, "")}`] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    return (0, $3G4eg.default)({}, (0, $2bdce3f16a251339$export$c0bb0b647f701bb5)(theme, ownerState.enableColorScheme), (0, $2bdce3f16a251339$export$32180ef41b15b513)(theme), {
        "& *, & *::before, & *::after": {
            boxSizing: "inherit"
        },
        "& strong, & b": {
            fontWeight: theme.typography.fontWeightBold
        }
    }, colorSchemeStyles);
});
const $6b662c6fa7058012$var$ScopedCssBaseline = /*#__PURE__*/ $dup7A.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiScopedCssBaseline"
    });
    const { className: className, component: component = "div" } = props, other = (0, $bGxpK.default)(props, $6b662c6fa7058012$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component
    });
    const classes = $6b662c6fa7058012$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($6b662c6fa7058012$var$ScopedCssBaselineRoot, (0, $3G4eg.default)({
        as: component,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $6b662c6fa7058012$export$2e2bcd8739ae039 = $6b662c6fa7058012$var$ScopedCssBaseline;



var $jjHhy = parcelRequire("jjHhy");


const $38d3440a56c08e9f$export$dc0d8bd0b94f8570 = 680;
const $38d3440a56c08e9f$export$fd3b9ef612990a44 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "variant"
})(({ variant: variant })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        flex: 1,
        height: variant === "drawer" ? "none" : $38d3440a56c08e9f$export$dc0d8bd0b94f8570
    }));
const $38d3440a56c08e9f$var$RelativeContainer = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "variant"
})(({ theme: theme, variant: variant })=>({
        position: "relative",
        boxSizing: "content-box",
        width: "100%",
        minWidth: 360,
        maxWidth: 392,
        maxHeight: variant === "drawer" ? "none" : $38d3440a56c08e9f$export$dc0d8bd0b94f8570,
        background: theme.palette.background.default,
        overflow: "auto",
        flex: 1,
        zIndex: 0
    }));
const $38d3440a56c08e9f$var$CssBaselineContainer = (0, $jjHhy.default)((0, $6b662c6fa7058012$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "variant"
})(({ variant: variant })=>({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        overflowX: "clip",
        margin: 0,
        width: "100%",
        maxHeight: variant === "drawer" ? "none" : $38d3440a56c08e9f$export$dc0d8bd0b94f8570,
        overflowY: "auto",
        height: "100%"
    }));
const $38d3440a56c08e9f$export$124d4c7bf7db9715 = (0, $jjHhy.default)((0, $0aedfe5fa751939c$export$2e2bcd8739ae039))({
    display: "flex",
    flexDirection: "column",
    flex: 1
});
const $38d3440a56c08e9f$export$7469f2cda7546515 = ({ children: children })=>{
    // const ref = useRef<HTMLDivElement>(null);
    const { containerStyle: containerStyle, variant: variant, elementId: elementId } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    return (0, $cZGFG.jsx)($38d3440a56c08e9f$var$RelativeContainer, {
        sx: containerStyle,
        variant: variant,
        id: (0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).RelativeContainer, elementId),
        children: (0, $cZGFG.jsx)($38d3440a56c08e9f$var$CssBaselineContainer, {
            id: (0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).ScrollableContainer, elementId),
            variant: variant,
            enableColorScheme: true,
            children: (0, $cZGFG.jsx)($38d3440a56c08e9f$export$124d4c7bf7db9715, {
                disableGutters: true,
                children: children
            })
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");






var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");

var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");

var $4y4xl = parcelRequire("4y4xl");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $12846af4cc0aceb4$export$47a2da616e55e8e9(slot) {
    return (0, $8iNDC.default)("MuiAppBar", slot);
}
const $12846af4cc0aceb4$var$appBarClasses = (0, $fc1pF.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $12846af4cc0aceb4$export$2e2bcd8739ae039 = $12846af4cc0aceb4$var$appBarClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $a29213c34e3e0704$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $a29213c34e3e0704$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $4y4xl.default)(color)}`,
            `position${(0, $4y4xl.default)(position)}`
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $12846af4cc0aceb4$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $a29213c34e3e0704$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $a29213c34e3e0704$var$AppBarRoot = (0, $jjHhy.default)((0, $929a5b6600d07d14$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $4y4xl.default)(ownerState.position)}`],
            styles[`color${(0, $4y4xl.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $3G4eg.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $3G4eg.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $3G4eg.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $3G4eg.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $a29213c34e3e0704$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $a29213c34e3e0704$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $a29213c34e3e0704$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $a29213c34e3e0704$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $a29213c34e3e0704$var$AppBar = /*#__PURE__*/ $dup7A.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $bGxpK.default)(props, $a29213c34e3e0704$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $a29213c34e3e0704$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($a29213c34e3e0704$var$AppBarRoot, (0, $3G4eg.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $aJAJS.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $a29213c34e3e0704$export$2e2bcd8739ae039 = $a29213c34e3e0704$var$AppBar;




var $jjHhy = parcelRequire("jjHhy");
const $949a7f59b8dfb21d$export$b4cd521b286d07ee = (0, $jjHhy.default)((0, $a29213c34e3e0704$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        flexDirection: "row",
        alignItems: "center",
        position: "relative",
        minHeight: 40,
        padding: theme.spacing(0, 3, 0, 3),
        ":first-of-type": {
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(0.5)
        }
    }));
const $949a7f59b8dfb21d$export$42a852a2b6b56249 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "sticky"
})(({ theme: theme, sticky: sticky })=>({
        backgroundColor: theme.palette.background.default,
        backdropFilter: "blur(12px)",
        position: sticky ? "sticky" : "relative",
        top: 0,
        zIndex: 1200
    }));
const $949a7f59b8dfb21d$export$eab4424f030fcb21 = (0, $jjHhy.default)((0, $67687db373c810bd$export$2e2bcd8739ae039))(({ theme: theme })=>({
        color: theme.palette.text.primary,
        backgroundColor: "transparent",
        padding: theme.spacing(1, 1.5),
        maxHeight: 40,
        fontSize: "0.875rem",
        fontWeight: 600,
        borderRadius: theme.shape.borderRadius * 2,
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.04) : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.white, 0.08)
        },
        [`.${(0, $497a5185a2231956$export$2e2bcd8739ae039).endIcon} > *:nth-of-type(1)`]: {
            fontSize: "24px"
        },
        [`.${(0, $497a5185a2231956$export$2e2bcd8739ae039).startIcon} > *:nth-of-type(1)`]: {
            fontSize: "24px"
        }
    }));
const $949a7f59b8dfb21d$export$61e27313cefac91a = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        "& button:first-of-type": {
            marginLeft: theme.spacing(-1)
        },
        "& button:last-of-type": {
            marginRight: theme.spacing(-1.25)
        }
    }));



var $cZGFG = parcelRequire("cZGFG");
var $07dab7bc51534e6e$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($07dab7bc51534e6e$exports, "__esModule", {
    value: true
});
$07dab7bc51534e6e$exports.default = void 0;

var $07dab7bc51534e6e$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $07dab7bc51534e6e$var$_default = $07dab7bc51534e6e$exports.default = (0, $07dab7bc51534e6e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack");


var $71b1b76e074e8563$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($71b1b76e074e8563$exports, "__esModule", {
    value: true
});
$71b1b76e074e8563$exports.default = void 0;

var $71b1b76e074e8563$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $71b1b76e074e8563$var$_default = $71b1b76e074e8563$exports.default = (0, $71b1b76e074e8563$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11z"
    }, "0"),
    /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
        d: "M9 7h6v2H9zm7 0h2v2h-2zm-7 3h6v2H9zm7 0h2v2h-2z"
    }, "1")
], "ReceiptLong");


var $d98b1f94ada3da7c$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($d98b1f94ada3da7c$exports, "__esModule", {
    value: true
});
$d98b1f94ada3da7c$exports.default = void 0;

var $d98b1f94ada3da7c$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $d98b1f94ada3da7c$var$_default = $d98b1f94ada3da7c$exports.default = (0, $d98b1f94ada3da7c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings");











var $cZGFG = parcelRequire("cZGFG");
var $d51005c1901ba61d$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($d51005c1901ba61d$exports, "__esModule", {
    value: true
});
$d51005c1901ba61d$exports.default = void 0;

var $d51005c1901ba61d$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $d51005c1901ba61d$var$_default = $d51005c1901ba61d$exports.default = (0, $d51005c1901ba61d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), "CloseRounded");






const $2f4dc61ea713fde3$export$2ea49374cff85a1d = (props)=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { closeDrawer: closeDrawer } = (0, $5b08acff347f037c$export$a95dae48ffdecbeb)();
    return (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
        title: t("button.close"),
        enterDelay: 400,
        arrow: true,
        children: (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
            size: "medium",
            onClick: closeDrawer,
            ...props,
            children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d51005c1901ba61d$exports))), {})
        })
    });
};




var $cZGFG = parcelRequire("cZGFG");






var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");

var $2wgr3 = parcelRequire("2wgr3");


var $4y4xl = parcelRequire("4y4xl");

var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");


var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $9c2a7ff7518c08e4$export$72aef224d6115253(slot) {
    return (0, $8iNDC.default)("MuiTab", slot);
}
const $9c2a7ff7518c08e4$var$tabClasses = (0, $fc1pF.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $9c2a7ff7518c08e4$export$2e2bcd8739ae039 = $9c2a7ff7518c08e4$var$tabClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $5c7616e84f36bc4a$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $5c7616e84f36bc4a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $4y4xl.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $9c2a7ff7518c08e4$export$72aef224d6115253), classes);
};
const $5c7616e84f36bc4a$var$TabRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $4y4xl.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3G4eg.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).iconWrapper}`]: (0, $3G4eg.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $5c7616e84f36bc4a$var$Tab = /*#__PURE__*/ $dup7A.forwardRef(function Tab(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $bGxpK.default)(props, $5c7616e84f36bc4a$var$_excluded);
    const ownerState = (0, $3G4eg.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $5c7616e84f36bc4a$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $dup7A.isValidElement(iconProp) ? /*#__PURE__*/ $dup7A.cloneElement(iconProp, {
        className: (0, $aJAJS.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($5c7616e84f36bc4a$var$TabRoot, (0, $3G4eg.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($dup7A.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $5c7616e84f36bc4a$export$2e2bcd8739ae039 = $5c7616e84f36bc4a$var$Tab;


var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");
parcelRequire("8vAu6");


var $aJAJS = parcelRequire("aJAJS");



var $2wgr3 = parcelRequire("2wgr3");


var $jjHhy = parcelRequire("jjHhy");

var $7ZufN = parcelRequire("7ZufN");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $2da85368c97439a4$var$cachedType;
function $2da85368c97439a4$export$a10970ffb6510128() {
    if ($2da85368c97439a4$var$cachedType) return $2da85368c97439a4$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $2da85368c97439a4$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $2da85368c97439a4$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $2da85368c97439a4$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $2da85368c97439a4$var$cachedType;
}
function $2da85368c97439a4$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $2da85368c97439a4$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $e46cd16c4c058516$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $e46cd16c4c058516$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $e46cd16c4c058516$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $3G4eg = parcelRequire("3G4eg");

var $bGxpK = parcelRequire("bGxpK");

var $dup7A = parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
"use client";
const $6acbc592c80175e8$var$_excluded = [
    "onChange"
];
const $6acbc592c80175e8$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $6acbc592c80175e8$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $bGxpK.default)(props, $6acbc592c80175e8$var$_excluded);
    const scrollbarHeight = $dup7A.useRef();
    const nodeRef = $dup7A.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $48ac1416032c7f21$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $9cb364921dbb34c4$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $c118840f30ef889d$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $dup7A.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)("div", (0, $3G4eg.default)({
        style: $6acbc592c80175e8$var$styles,
        ref: nodeRef
    }, other));
}



var $bGxpK = parcelRequire("bGxpK");

var $3G4eg = parcelRequire("3G4eg");

var $dup7A = parcelRequire("dup7A");


var $aJAJS = parcelRequire("aJAJS");


var $2wgr3 = parcelRequire("2wgr3");

parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $5895cacc95fea55e$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("dup7A");

var $7Ii5r = parcelRequire("7Ii5r");

var $cZGFG = parcelRequire("cZGFG");
"use client";
var $1a39626dc3f5d6fa$export$2e2bcd8739ae039 = (0, $7Ii5r.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");




var $7ZufN = parcelRequire("7ZufN");

var $jjHhy = parcelRequire("jjHhy");

var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $a021b8f05c054998$export$34861783d3c2eef8(slot) {
    return (0, $8iNDC.default)("MuiTabScrollButton", slot);
}
const $a021b8f05c054998$var$tabScrollButtonClasses = (0, $fc1pF.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $a021b8f05c054998$export$2e2bcd8739ae039 = $a021b8f05c054998$var$tabScrollButtonClasses;



var $cZGFG = parcelRequire("cZGFG");
"use client";
const $dfb0ccc8af11c07e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $dfb0ccc8af11c07e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $a021b8f05c054998$export$34861783d3c2eef8), classes);
};
const $dfb0ccc8af11c07e$var$TabScrollButtonRoot = (0, $jjHhy.default)((0, $729321786c389df3$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $a021b8f05c054998$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $dfb0ccc8af11c07e$var$TabScrollButton = /*#__PURE__*/ $dup7A.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $bGxpK.default)(props, $dfb0ccc8af11c07e$var$_excluded);
    const isRtl = (0, $3397d1bce61a3d2d$export$b2dd014b6c321cb)();
    const ownerState = (0, $3G4eg.default)({
        isRtl: isRtl
    }, props);
    const classes = $dfb0ccc8af11c07e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $5895cacc95fea55e$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $1a39626dc3f5d6fa$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $cZGFG.jsx)($dfb0ccc8af11c07e$var$TabScrollButtonRoot, (0, $3G4eg.default)({
        component: "div",
        className: (0, $aJAJS.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $cZGFG.jsx)(StartButtonIcon, (0, $3G4eg.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $cZGFG.jsx)(EndButtonIcon, (0, $3G4eg.default)({}, endButtonIconProps))
    }));
});
var $dfb0ccc8af11c07e$export$2e2bcd8739ae039 = $dfb0ccc8af11c07e$var$TabScrollButton;




var $fc1pF = parcelRequire("fc1pF");

var $8iNDC = parcelRequire("8iNDC");
function $ce557820c3e98cb8$export$cdd93bd054dec359(slot) {
    return (0, $8iNDC.default)("MuiTabs", slot);
}
const $ce557820c3e98cb8$var$tabsClasses = (0, $fc1pF.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $ce557820c3e98cb8$export$2e2bcd8739ae039 = $ce557820c3e98cb8$var$tabsClasses;





var $cZGFG = parcelRequire("cZGFG");
"use client";
const $7ca3298e8ef97613$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7ca3298e8ef97613$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7ca3298e8ef97613$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7ca3298e8ef97613$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7ca3298e8ef97613$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $2wgr3.default)(slots, (0, $ce557820c3e98cb8$export$cdd93bd054dec359), classes);
};
const $7ca3298e8ef97613$var$TabsRoot = (0, $jjHhy.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $7ca3298e8ef97613$var$TabsScroller = (0, $jjHhy.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $7ca3298e8ef97613$var$FlexContainer = (0, $jjHhy.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $3G4eg.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $7ca3298e8ef97613$var$TabsIndicator = (0, $jjHhy.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $3G4eg.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $7ca3298e8ef97613$var$TabsScrollbarSize = (0, $jjHhy.default)((0, $6acbc592c80175e8$export$2e2bcd8739ae039))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $7ca3298e8ef97613$var$defaultIndicatorStyle = {};
let $7ca3298e8ef97613$var$warnedOnceTabPresent = false;
const $7ca3298e8ef97613$var$Tabs = /*#__PURE__*/ $dup7A.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $7ZufN.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $440caa946b5f115e$export$2e2bcd8739ae039)();
    const isRtl = (0, $3397d1bce61a3d2d$export$b2dd014b6c321cb)();
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $dfb0ccc8af11c07e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $bGxpK.default)(props, $7ca3298e8ef97613$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $3G4eg.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7ca3298e8ef97613$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $50d4286570f9fa0f$export$1e5c9e6e4e15efe3)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $dup7A.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $dup7A.useState($7ca3298e8ef97613$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $dup7A.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $dup7A.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $dup7A.useState(false);
    const [scrollerStyle, setScrollerStyle] = $dup7A.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $dup7A.useRef(null);
    const tabListRef = $dup7A.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $2da85368c97439a4$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? "rtl" : "ltr"),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $e46cd16c4c058516$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $2da85368c97439a4$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $dup7A.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $cZGFG.jsx)($7ca3298e8ef97613$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $aJAJS.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $cZGFG.jsx)(ScrollButtonComponent, (0, $3G4eg.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $aJAJS.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $cZGFG.jsx)(ScrollButtonComponent, (0, $3G4eg.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $aJAJS.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $5cbcd99cab12064e$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $dup7A.useEffect(()=>{
        const handleResize = (0, $9cb364921dbb34c4$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $c118840f30ef889d$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $dup7A.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $dup7A.useEffect(()=>{
        setMounted(true);
    }, []);
    $dup7A.useEffect(()=>{
        updateIndicatorState();
    });
    $dup7A.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7ca3298e8ef97613$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $dup7A.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $cZGFG.jsx)($7ca3298e8ef97613$var$TabsIndicator, (0, $3G4eg.default)({}, TabIndicatorProps, {
        className: (0, $aJAJS.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $3G4eg.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $dup7A.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $dup7A.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $dup7A.cloneElement(child, (0, $3G4eg.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $2dc45eea0aa813fa$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7ca3298e8ef97613$var$moveFocus(list, currentFocus, $7ca3298e8ef97613$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7ca3298e8ef97613$var$moveFocus(list, currentFocus, $7ca3298e8ef97613$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $7ca3298e8ef97613$var$moveFocus(list, null, $7ca3298e8ef97613$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $7ca3298e8ef97613$var$moveFocus(list, null, $7ca3298e8ef97613$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($7ca3298e8ef97613$var$TabsRoot, (0, $3G4eg.default)({
        className: (0, $aJAJS.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $cZGFG.jsxs)($7ca3298e8ef97613$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($7ca3298e8ef97613$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7ca3298e8ef97613$export$2e2bcd8739ae039 = $7ca3298e8ef97613$var$Tabs;



var $jjHhy = parcelRequire("jjHhy");
const $264ea6b4a64c2910$export$7ec4e459a2001a07 = (0, $jjHhy.default)((0, $7ca3298e8ef97613$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.paper : (0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.04),
        borderRadius: Math.max(theme.shape.borderRadius, theme.shape.borderRadiusSecondary),
        padding: theme.spacing(0.5),
        flex: 1,
        display: "flex",
        alignItems: "center",
        height: 56,
        [`.${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).flexContainer}`]: {
            alignItems: "center"
        },
        [`.${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).scroller}`]: {
            overflow: "initial !important"
        },
        [`.${(0, $ce557820c3e98cb8$export$2e2bcd8739ae039).indicator}`]: {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            height: 48,
            backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.default : theme.palette.common.white,
            borderRadius: theme.shape.borderRadiusSecondary,
            boxShadow: `0px 2px 4px ${(0, $ecd44ebd791a3fa9$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.04)}`
        }
    }));
const $264ea6b4a64c2910$export$59e5d9660d723b87 = (0, $jjHhy.default)((0, $5c7616e84f36bc4a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "isDarkMode"
})(({ theme: theme })=>({
        zIndex: 1,
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        textTransform: "none",
        height: 48,
        minHeight: 48,
        fontSize: "1rem",
        fontWeight: 700,
        color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black,
        textDecoration: "none",
        [`&.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).selected}`]: {
            color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black,
            backgroundColor: "transparent"
        },
        [`.${(0, $9c2a7ff7518c08e4$export$2e2bcd8739ae039).iconWrapper}`]: {
            margin: theme.spacing(0, 1, 0, 0)
        }
    }));


const $e630de33bcc01428$export$3c5752b247e1c562 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const [state, setState] = (0, $5e8b8f7a49e68349$export$a7844f191cd50a20)((state)=>[
            state.state,
            state.setState
        ]);
    const { setValue: setValue } = (0, $367773295ca041ba$export$4d957a5e1be13b03)();
    const handleChange = (_, value)=>{
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromAmount, "");
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).FromToken, "");
        setValue((0, $98260d45445f6983$export$cf3347e5e7e1bef5).ToToken, "");
        setState(value === 0 ? "swap" : "bridge");
    };
    return (0, $cZGFG.jsx)((0, $949a7f59b8dfb21d$export$b4cd521b286d07ee), {
        elevation: 0,
        sx: {
            py: 1
        },
        children: (0, $cZGFG.jsxs)((0, $264ea6b4a64c2910$export$7ec4e459a2001a07), {
            value: state === "swap" ? 0 : 1,
            onChange: handleChange,
            "aria-label": "tabs",
            indicatorColor: "primary",
            children: [
                (0, $cZGFG.jsx)((0, $264ea6b4a64c2910$export$59e5d9660d723b87), {
                    label: t("header.swap"),
                    disableRipple: true
                }),
                (0, $cZGFG.jsx)((0, $264ea6b4a64c2910$export$59e5d9660d723b87), {
                    label: t("header.bridge"),
                    disableRipple: true
                })
            ]
        })
    });
};



var $cZGFG = parcelRequire("cZGFG");



var $9de6e25e4a03d881$exports = {};
"use strict";
"use client";

var $gQ6R7 = parcelRequire("gQ6R7");
Object.defineProperty($9de6e25e4a03d881$exports, "__esModule", {
    value: true
});
$9de6e25e4a03d881$exports.default = void 0;

var $9de6e25e4a03d881$var$_createSvgIcon = $gQ6R7((parcelRequire("4cbVS")));

var $cZGFG = parcelRequire("cZGFG");
var $9de6e25e4a03d881$var$_default = $9de6e25e4a03d881$exports.default = (0, $9de6e25e4a03d881$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $cZGFG.jsx)("path", {
    d: "M12 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1m5.14 2.86c-.39.39-.38 1-.01 1.39 1.13 1.2 1.83 2.8 1.87 4.57.09 3.83-3.08 7.13-6.91 7.17C8.18 19.05 5 15.9 5 12c0-1.84.71-3.51 1.87-4.76.37-.39.37-1-.01-1.38-.4-.4-1.05-.39-1.43.02C3.98 7.42 3.07 9.47 3 11.74c-.14 4.88 3.83 9.1 8.71 9.25 5.1.16 9.29-3.93 9.29-9 0-2.37-.92-4.51-2.42-6.11-.38-.41-1.04-.42-1.44-.02"
}), "PowerSettingsNewRounded");





var $dup7A = parcelRequire("dup7A");












var $jjHhy = parcelRequire("jjHhy");

var $4CYID = parcelRequire("4CYID");
const $add714d2624f9472$export$13465f1b948ffc0e = (0, $jjHhy.default)((0, $a3e4f10aa5e563e2$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`& .${(0, $eb4b8de9191c7017$export$2e2bcd8739ae039).paper}`]: {
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            boxShadow: "0px 2px 4px rgb(0 0 0 / 8%), 0px 8px 16px rgb(0 0 0 / 8%)",
            padding: theme.spacing(2),
            [`& .${(0, $eb4b8de9191c7017$export$2e2bcd8739ae039).list}`]: {
                padding: 0
            },
            [`& .${(0, $634bec21c7a731b8$export$2e2bcd8739ae039).root}`]: {
                borderRadius: theme.shape.borderRadiusSecondary,
                padding: theme.spacing(1, 2, 1, 1),
                [`& .${(0, $4CYID.default).root}`]: {
                    fontSize: 20,
                    color: theme.palette.text.primary,
                    marginRight: theme.spacing(1.5)
                }
            }
        }
    }));


const $e84540eb7444621e$export$a87754ac8da603be = ()=>{
    return (0, $cZGFG.jsx)((0, $949a7f59b8dfb21d$export$b4cd521b286d07ee), {
        elevation: 0,
        sx: {
            justifyContent: "flex-end"
        },
        children: (0, $cZGFG.jsx)($e84540eb7444621e$export$5d3782f00e90e6cd, {})
    });
};
const $e84540eb7444621e$export$5d3782f00e90e6cd = ()=>{
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const { variant: variant, subvariant: subvariant, hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    if (variant === "drawer") return (0, $cZGFG.jsxs)((0, $949a7f59b8dfb21d$export$61e27313cefac91a), {
        children: [
            account.isActive ? (0, $cZGFG.jsx)($e84540eb7444621e$var$ConnectedButton, {}) : (0, $cZGFG.jsx)($e84540eb7444621e$var$ConnectButton, {}),
            subvariant !== "split" && !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).DrawerCloseButton) ? (0, $cZGFG.jsx)((0, $2f4dc61ea713fde3$export$2ea49374cff85a1d), {}) : null
        ]
    });
    return account.isActive ? (0, $cZGFG.jsx)($e84540eb7444621e$var$ConnectedButton, {}) : (0, $cZGFG.jsx)($e84540eb7444621e$var$ConnectButton, {});
};
const $e84540eb7444621e$var$ConnectButton = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { pathname: pathname } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const { walletManagement: walletManagement, subvariant: subvariant, variant: variant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { connect: connectWallet } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const connect = async ()=>{
        if (walletManagement) {
            await connectWallet();
            return;
        }
        navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).selectWallet);
    };
    return (0, $cZGFG.jsx)((0, $949a7f59b8dfb21d$export$eab4424f030fcb21), {
        endIcon: variant !== "drawer" && subvariant !== "split" ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($671d7c5a3f94d7f9$exports))), {}) : undefined,
        startIcon: variant === "drawer" || subvariant === "split" ? (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($671d7c5a3f94d7f9$exports))), {
            sx: {
                marginLeft: -0.25
            }
        }) : undefined,
        onClick: !pathname.includes((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).selectWallet) ? connect : undefined,
        sx: {
            marginRight: subvariant === "split" ? 0 : -1.25,
            marginLeft: subvariant === "split" ? -1.25 : 0
        },
        children: t(`button.connectWallet`)
    });
};
const $e84540eb7444621e$var$ConnectedButton = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { subvariant: subvariant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { account: account, disconnect: disconnect } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const walletAddress = (0, $d5d1c02a6b00bbed$export$e6e2bc9967bf256c)(account.address);
    const { chain: chain } = (0, $404c35d02d3b62e7$export$a4a17273dffcc09c)(account.chainId);
    const [anchorEl, setAnchorEl] = (0, $dup7A.useState)(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleDisconnect = ()=>{
        disconnect();
        handleClose();
    };
    const handleCopyAddress = async ()=>{
        await navigator.clipboard.writeText(account.address ?? "");
        handleClose();
    };
    return (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            (0, $cZGFG.jsx)((0, $949a7f59b8dfb21d$export$eab4424f030fcb21), {
                endIcon: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4d3a704b8b3b6f33$exports))), {}),
                startIcon: (0, $cZGFG.jsx)((0, $585ddd894619170d$export$2e2bcd8739ae039), {
                    src: chain?.logoURI,
                    alt: chain?.key,
                    sx: {
                        width: 24,
                        height: 24
                    },
                    children: chain?.name[0]
                }),
                sx: {
                    marginRight: subvariant === "split" ? 0 : -1.25,
                    marginLeft: subvariant === "split" ? -1 : 0
                },
                onClick: handleClick,
                children: walletAddress
            }),
            (0, $cZGFG.jsxs)((0, $add714d2624f9472$export$13465f1b948ffc0e), {
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    (0, $cZGFG.jsxs)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                        onClick: handleCopyAddress,
                        children: [
                            (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99400aca3ce3aa54$exports))), {}),
                            t(`button.copyAddress`)
                        ]
                    }),
                    (0, $cZGFG.jsxs)((0, $1a43c5555fb20cd2$export$2e2bcd8739ae039), {
                        component: "a",
                        onClick: handleClose,
                        href: `${chain?.metamask.blockExplorerUrls[0]}address/${account.address}`,
                        target: "_blank",
                        children: [
                            (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8f3ce3003f3baaf9$exports))), {}),
                            t(`button.viewOnExplorer`)
                        ]
                    }),
                    (0, $cZGFG.jsx)((0, $67687db373c810bd$export$2e2bcd8739ae039), {
                        onClick: handleDisconnect,
                        fullWidth: true,
                        startIcon: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9de6e25e4a03d881$exports))), {}),
                        sx: {
                            marginTop: 1
                        },
                        children: t(`button.disconnect`)
                    })
                ]
            })
        ]
    });
};


const $fc7e599600227d8d$export$791138eae2988149 = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const { subvariant: subvariant, hiddenUI: hiddenUI, variant: variant } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { navigate: navigate, navigateBack: navigateBack } = (0, $42acb71e74c74041$export$7ce1f551d78f9130)();
    const { account: account } = (0, $fdce49c427c1eae3$export$c34addee860b0acb)();
    const { element: element, title: title } = (0, $91390e33d9f5c5f2$export$b7680113a886673e)((state)=>state);
    const { pathname: pathname } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const cleanedPathname = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    const path = cleanedPathname.substring(cleanedPathname.lastIndexOf("/") + 1);
    const hasPath = (0, $8b67d0eddea325ef$export$7817d6e8e0e6a150).includes(path);
    const splitSubvariant = subvariant === "split" && !hasPath;
    const handleHeaderTitle = ()=>{
        switch(path){
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).selectWallet:
                return t(`header.selectWallet`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).settings:
                return t(`header.settings`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).bridges:
                return t(`settings.enabledBridges`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).exchanges:
                return t(`settings.enabledExchanges`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionHistory:
                return t(`header.transactionHistory`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromToken:
                if (subvariant === "nft") return t(`header.payWith`);
                return t(`header.from`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toToken:
                return t(`header.to`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromChain:
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toChain:
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toTokenNative:
                return t(`header.selectChain`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).routes:
                return t(`header.youGet`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).activeTransactions:
                return t(`header.activeTransactions`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution:
                if (subvariant === "nft") return t(`header.purchase`);
                return t(`header.exchange`);
            case (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionDetails:
                if (subvariant === "nft") return t(`header.purchaseDetails`);
                return t(`header.transactionDetails`);
            default:
                switch(subvariant){
                    case "nft":
                        return t(`header.checkout`);
                    case "refuel":
                        return t(`header.gas`);
                    default:
                        return t(`header.exchange`);
                }
        }
    };
    const showDrawerCloseButton = variant === "drawer" && subvariant === "split" && !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).DrawerCloseButton);
    return (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            (0, $cZGFG.jsxs)((0, $949a7f59b8dfb21d$export$b4cd521b286d07ee), {
                elevation: 0,
                children: [
                    (0, $8b67d0eddea325ef$export$13424e02f438f2e).includes(path) ? (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
                        size: "medium",
                        edge: "start",
                        onClick: navigateBack,
                        children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($07dab7bc51534e6e$exports))), {})
                    }) : null,
                    splitSubvariant ? (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                        flex: 1,
                        children: !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).WalletMenu) ? (0, $cZGFG.jsx)((0, $e84540eb7444621e$export$5d3782f00e90e6cd), {}) : null
                    }) : (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        fontSize: hasPath ? 18 : 24,
                        align: hasPath ? "center" : "left",
                        fontWeight: "700",
                        flex: 1,
                        noWrap: true,
                        children: title || handleHeaderTitle()
                    }),
                    (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
                        children: [
                            (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: (0, $8b67d0eddea325ef$export$492bdc31a14c4d1).home,
                                element: (0, $cZGFG.jsxs)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                    children: [
                                        account.isActive && !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).History) ? (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                                            title: t(`header.transactionHistory`),
                                            enterDelay: 400,
                                            arrow: true,
                                            children: (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
                                                size: "medium",
                                                edge: "start",
                                                onClick: ()=>navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionHistory),
                                                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71b1b76e074e8563$exports))), {})
                                            })
                                        }) : null,
                                        (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
                                            title: t(`header.settings`),
                                            enterDelay: 400,
                                            arrow: true,
                                            children: (0, $cZGFG.jsx)((0, $510dba830cc31c9a$export$2e2bcd8739ae039), {
                                                size: "medium",
                                                onClick: ()=>navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).settings),
                                                sx: {
                                                    marginRight: showDrawerCloseButton ? 0 : -1.25
                                                },
                                                children: (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d98b1f94ada3da7c$exports))), {})
                                            })
                                        }),
                                        showDrawerCloseButton ? (0, $cZGFG.jsx)((0, $2f4dc61ea713fde3$export$2ea49374cff85a1d), {
                                            sx: {
                                                marginRight: -1.25
                                            }
                                        }) : null
                                    ]
                                })
                            }),
                            (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: element || (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
                                    width: 28,
                                    height: 40
                                })
                            })
                        ]
                    })
                ]
            }),
            splitSubvariant ? (0, $cZGFG.jsx)((0, $e630de33bcc01428$export$3c5752b247e1c562), {}) : null
        ]
    });
};



const $30e6dc5a8beaada9$export$1e86fd0e1db89578 = ({ children: children })=>{
    const { pathname: pathname } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const elementId = (0, $43dd2a9adf98ce26$export$15dd38f06036bd30)();
    return (0, $cZGFG.jsx)((0, $949a7f59b8dfb21d$export$42a852a2b6b56249), {
        id: (0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).Header, elementId),
        sticky: (0, $8b67d0eddea325ef$export$b3fae4083350f87).some((route)=>pathname.includes(route)),
        children: children
    });
};
const $30e6dc5a8beaada9$export$8b251419efc915eb = ()=>{
    const { walletManagement: walletManagement, subvariant: subvariant, hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    return (0, $cZGFG.jsxs)($30e6dc5a8beaada9$export$1e86fd0e1db89578, {
        children: [
            !walletManagement && subvariant !== "split" && !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).WalletMenu) ? (0, $cZGFG.jsx)((0, $e84540eb7444621e$export$a87754ac8da603be), {}) : null,
            (0, $cZGFG.jsx)((0, $fc7e599600227d8d$export$791138eae2988149), {})
        ]
    });
};




var $dup7A = parcelRequire("dup7A");


let $df4ced44242d0b20$var$checkedPackageUpdates = false;
const $df4ced44242d0b20$export$1ab2950280c8492f = ()=>{
    (0, $d518138af9fbf856$export$746cb67d959fd2b5)();
    (0, $dup7A.useEffect)(()=>{
        if (!$df4ced44242d0b20$var$checkedPackageUpdates) {
            $df4ced44242d0b20$var$checkedPackageUpdates = true;
            (0, $c98bbf8bc8a02c8a$export$9fe272d016535f0b)((0, $698a4cee1bbcf375$export$a8ff84c12d48cfa6), (0, $698a4cee1bbcf375$export$83d89fbfd8236492));
        }
    }, []);
};


const $266bf1b92f999818$export$9e14a7677ef1423c = ()=>{
    (0, $df4ced44242d0b20$export$1ab2950280c8492f)();
    return null;
};



var $cZGFG = parcelRequire("cZGFG");








var $jjHhy = parcelRequire("jjHhy");
const $bec75cf7bc5474c2$export$a6c7ac8248d6e38a = (0, $jjHhy.default)((0, $8e9053afbc4d5b0b$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "flex",
        alignItems: "center",
        border: "none",
        ":hover": {
            color: theme.palette.primary.main
        }
    }));


const $0cc1de3a36852f12$export$3dbb5766eaeb5b24 = ()=>{
    const { hiddenUI: hiddenUI } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { pathname: pathname } = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    if (pathname.includes((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).fromToken) || pathname.includes((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).toToken)) return null;
    return (0, $cZGFG.jsx)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039), {
        px: 3,
        pt: 1,
        pb: hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).PoweredBy) ? 1 : 2,
        sx: {
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end"
        },
        children: !hiddenUI?.includes((0, $57f573099db3f258$export$26716459e5ab8661).PoweredBy) ? (0, $cZGFG.jsx)((0, $fd8b0c9730d4163c$export$2e2bcd8739ae039), {
            title: `v${(0, $698a4cee1bbcf375$export$83d89fbfd8236492)}`,
            placement: "top",
            enterDelay: 1000,
            arrow: true,
            children: (0, $cZGFG.jsxs)((0, $bec75cf7bc5474c2$export$a6c7ac8248d6e38a), {
                href: "https://li.fi",
                target: "_blank",
                underline: "none",
                color: "text.primary",
                children: [
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        fontSize: 12,
                        fontWeight: 500,
                        px: 0.5,
                        children: "Powered by"
                    }),
                    (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                        color: "text.primary",
                        fontSize: 12,
                        fontWeight: 500,
                        children: "LI.FI"
                    })
                ]
            })
        }) : null
    });
};



var $cZGFG = parcelRequire("cZGFG");












var $jjHhy = parcelRequire("jjHhy");

const $b4caaa8a02e90f79$export$b1e909ac1e3f6a09 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        height: (0, $38d3440a56c08e9f$export$dc0d8bd0b94f8570),
        zIndex: 0
    }));
const $b4caaa8a02e90f79$export$9778a85352188e27 = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))({
    overflowY: "auto",
    height: "100%",
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $b4caaa8a02e90f79$export$42a852a2b6b56249 = (0, $jjHhy.default)((0, $6b662c6fa7058012$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.background.default,
        overflow: "auto",
        width: 436,
        maxHeight: $38d3440a56c08e9f$export$dc0d8bd0b94f8570,
        marginLeft: theme.spacing(3),
        display: "flex",
        flexDirection: "column"
    }));
const $b4caaa8a02e90f79$export$8b251419efc915eb = (0, $jjHhy.default)((0, $2c3aac5995a8a92e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.background.default,
        backdropFilter: "blur(12px)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1.5, 3),
        position: "sticky",
        top: 0,
        zIndex: 1200
    }));


const $8a30ca236dfe8fad$var$timeout = {
    enter: 225,
    exit: 225,
    appear: 0
};
const $8a30ca236dfe8fad$var$routes = [
    {
        path: "/",
        element: true
    }
];
const $8a30ca236dfe8fad$export$40744082e8bc1d70 = ()=>{
    const match = (0, $5c6d50c15e61ec01$export$5d3fca4a98652595)($8a30ca236dfe8fad$var$routes);
    return (0, $cZGFG.jsx)((0, $b4caaa8a02e90f79$export$b1e909ac1e3f6a09), {
        children: (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
            timeout: $8a30ca236dfe8fad$var$timeout,
            in: !!match,
            orientation: "horizontal",
            children: (0, $cZGFG.jsx)((0, $651a53450047d63f$export$2e2bcd8739ae039), {
                timeout: $8a30ca236dfe8fad$var$timeout,
                in: !!match,
                mountOnEnter: true,
                unmountOnExit: true,
                children: (0, $cZGFG.jsx)("div", {
                    children: (0, $cZGFG.jsx)($8a30ca236dfe8fad$export$5ffea609c305c06b, {})
                })
            })
        })
    });
};
const $8a30ca236dfe8fad$export$5ffea609c305c06b = ()=>{
    const { t: t } = (0, $242efbb298f787ec$export$9fc83ad70ead8663)();
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const setExecutableRoute = (0, $07b0e9f0a3acbbd7$export$93756f4499f86d2b)();
    const { subvariant: subvariant, containerStyle: containerStyle } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const { isValid: isValid, isValidating: isValidating } = (0, $367773295ca041ba$export$606f11b2eb45ecc6)();
    const { routes: routes, isLoading: isLoading, isFetching: isFetching, isFetched: isFetched, dataUpdatedAt: dataUpdatedAt, refetchTime: refetchTime, refetch: refetch } = (0, $36164d6f2c6fd483$export$5d3fca4a98652595)();
    const handleRouteClick = (route)=>{
        if (isValid && !isValidating) {
            setExecutableRoute(route);
            navigate((0, $8b67d0eddea325ef$export$492bdc31a14c4d1).transactionExecution, {
                state: {
                    routeId: route.id
                }
            });
        }
    };
    const currentRoute = routes?.[0];
    const expanded = Boolean(currentRoute || isLoading || isFetching || isFetched);
    const routeNotFound = !currentRoute && !isLoading && !isFetching && expanded;
    return (0, $cZGFG.jsx)((0, $f6bd69894e5675e4$export$2e2bcd8739ae039), {
        timeout: $8a30ca236dfe8fad$var$timeout.enter,
        in: expanded,
        orientation: "horizontal",
        children: (0, $cZGFG.jsx)((0, $651a53450047d63f$export$2e2bcd8739ae039), {
            timeout: $8a30ca236dfe8fad$var$timeout.enter,
            in: expanded,
            mountOnEnter: true,
            unmountOnExit: true,
            children: (0, $cZGFG.jsx)((0, $b4caaa8a02e90f79$export$42a852a2b6b56249), {
                sx: containerStyle,
                enableColorScheme: true,
                children: (0, $cZGFG.jsxs)((0, $b4caaa8a02e90f79$export$9778a85352188e27), {
                    children: [
                        (0, $cZGFG.jsxs)((0, $b4caaa8a02e90f79$export$8b251419efc915eb), {
                            children: [
                                (0, $cZGFG.jsx)((0, $f7cbd0ed4c3e5464$export$2e2bcd8739ae039), {
                                    fontSize: 18,
                                    fontWeight: "700",
                                    flex: 1,
                                    noWrap: true,
                                    children: subvariant === "nft" ? t("main.fromAmount") : t("header.youGet")
                                }),
                                (0, $cZGFG.jsx)((0, $eb12012bc6102ab5$export$9ff79255ead4ffb5), {
                                    updatedAt: dataUpdatedAt || new Date().getTime(),
                                    timeToUpdate: refetchTime,
                                    isLoading: isFetching,
                                    onClick: ()=>refetch(),
                                    sx: {
                                        marginRight: -1
                                    }
                                })
                            ]
                        }),
                        (0, $cZGFG.jsx)((0, $0fdecc513a2d3d55$export$2e2bcd8739ae039), {
                            direction: "column",
                            spacing: 2,
                            flex: 1,
                            paddingX: 3,
                            paddingBottom: 3,
                            children: routeNotFound ? (0, $cZGFG.jsx)((0, $346668b43c43be35$export$d9b32705cc00a1ab), {}) : isLoading || isFetching && !routes?.length ? Array.from({
                                length: 3
                            }).map((_, index)=>(0, $cZGFG.jsx)((0, $4c88d3e88750f71e$export$f6c2b491a88fe8ab), {}, index)) : routes?.map((route, index)=>(0, $cZGFG.jsx)((0, $748e91f2c262fb9d$export$d99fd5a1ae05e6cf), {
                                    route: route,
                                    onClick: ()=>handleRouteClick(route),
                                    active: index === 0,
                                    expanded: routes?.length <= 2
                                }, route.id))
                        })
                    ]
                })
            })
        })
    });
};





const $2970462a292692d6$export$86fbec116b87613f = (0, $dup7A.forwardRef)(({ elementRef: elementRef, open: open, onClose: onClose, integrator: integrator, ...other }, ref)=>{
    const config = (0, $dup7A.useMemo)(()=>({
            integrator: integrator,
            ...other,
            ...other.config
        }), [
        integrator,
        other
    ]);
    return config?.variant !== "drawer" ? (0, $cZGFG.jsx)((0, $66e56c53d939a720$export$c7dacf3845253dcf), {
        config: config,
        children: (0, $cZGFG.jsx)($2970462a292692d6$export$c066b70df7829ba, {})
    }) : (0, $cZGFG.jsx)((0, $3031021edd1ee258$export$14d25181d0b81c70), {
        ref: ref,
        elementRef: elementRef,
        integrator: integrator,
        config: config,
        open: open,
        onClose: onClose
    });
});
const $2970462a292692d6$export$c066b70df7829ba = ()=>{
    const { elementId: elementId } = (0, $3f300e2d42fad4b6$export$3cc8cef7bbce91ae)();
    const expandable = (0, $ea9b454d75cc3193$export$b7fefcff97a6bbf8)();
    return (0, $cZGFG.jsxs)((0, $38d3440a56c08e9f$export$fd3b9ef612990a44), {
        id: (0, $6dd4403cf87f98d9$export$e4789b5c419678e0)((0, $6dd4403cf87f98d9$export$6e4ebff0100bf466).AppExpandedContainer, elementId),
        children: [
            (0, $cZGFG.jsxs)((0, $38d3440a56c08e9f$export$7469f2cda7546515), {
                children: [
                    (0, $cZGFG.jsx)((0, $30e6dc5a8beaada9$export$8b251419efc915eb), {}),
                    (0, $cZGFG.jsx)((0, $38d3440a56c08e9f$export$124d4c7bf7db9715), {
                        disableGutters: true,
                        children: (0, $cZGFG.jsx)((0, $db0c8d6fdd06befa$export$37d3279522fbf5e2), {})
                    }),
                    (0, $cZGFG.jsx)((0, $0cc1de3a36852f12$export$3dbb5766eaeb5b24), {}),
                    (0, $cZGFG.jsx)((0, $266bf1b92f999818$export$9e14a7677ef1423c), {})
                ]
            }),
            expandable ? (0, $cZGFG.jsx)((0, $8a30ca236dfe8fad$export$40744082e8bc1d70), {}) : null
        ]
    });
};










const $78c6eae7d51298bb$export$f00680a9caf05130 = (0, $2970462a292692d6$export$86fbec116b87613f);



const $7117c7d27b663f79$var$WidgetContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  > div {
    height: auto;
    > div > div {
      max-height: none;
    }
  }
`;
const $7117c7d27b663f79$var$getWidgetConfig = (theme)=>({
        fromChain: 1,
        toChain: 42161,
        fromToken: "0x93ED3FBe21207Ec2E8f2d3c3de6e058Cb73Bc04d",
        toToken: "0x330bD769382cFc6d50175903434CCC8D206DCAE5",
        containerStyle: {
            border: `1px solid ${theme.stroke}`,
            borderRadius: "3px",
            background: theme.whiteBackground,
            width: (0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(350, 500),
            maxWidth: "600px",
            height: "fit-content",
            maxHeight: "none",
            minWidth: "300px"
        },
        hiddenUI: [
            "appearance",
            "language"
        ],
        theme: {
            palette: {
                primary: {
                    main: theme.primaryBlue
                },
                secondary: {
                    main: theme.primaryBlue
                },
                background: {
                    paper: theme.whiteBackground,
                    default: theme.whiteBackground
                },
                grey: {
                    300: theme.stroke,
                    800: theme.stroke
                },
                text: {
                    primary: theme.primaryText,
                    secondary: theme.secondaryText
                }
            },
            shape: {
                borderRadius: 3,
                borderRadiusSecondary: 3
            },
            typography: {
            }
        },
        integrator: "Kleros"
    });
const $7117c7d27b663f79$export$a829527ff4e4114a = ()=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const widgetConfig = (0, $dup7A.useMemo)(()=>$7117c7d27b663f79$var$getWidgetConfig(theme), [
        theme
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($7117c7d27b663f79$var$WidgetContainer, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $78c6eae7d51298bb$export$f00680a9caf05130), {
            config: widgetConfig,
            integrator: "Kleros"
        })
    });
};


const $12de2bcf44014032$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 72)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 132)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
const $12de2bcf44014032$var$GetPnk = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0baf26b3b0f0403b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($12de2bcf44014032$var$Container, {
                children: [
                    !(0, $203b613495c69c62$export$9eecd5eb17097ec3)() && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $d4a20a0b6123562f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $7117c7d27b663f79$export$a829527ff4e4114a), {})
                ]
            })
        ]
    });
};
var $12de2bcf44014032$export$2e2bcd8739ae039 = $12de2bcf44014032$var$GetPnk;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");



const $3e479c7243cea69e$var$homePageQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query HomePage($timeframe: ID) {
    disputes(first: 3) {
      id
    }
    counters(where: { id_gt: $timeframe }) {
      id
      stakedPNK
      paidETH
      redistributedPNK
      activeJurors
      cases
    }
  }
`);
const $3e479c7243cea69e$export$652dddba2ce6a1de = (timeframe)=>{
    const isEnabled = timeframe !== undefined;
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `homePageQuery${timeframe}`
        ],
        enabled: isEnabled,
        queryFn: async ()=>{
            const data = await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $3e479c7243cea69e$var$homePageQuery,
                variables: {
                    timeframe: timeframe.toString()
                }
            });
            return data;
        }
    });
};


const $3767ddbf01f33684$var$Context = /*#__PURE__*/ (0, $dup7A.createContext)({
    data: undefined,
    error: null,
    isValidating: false
});
const $3767ddbf01f33684$export$77ba6708b1c2efce = ({ children: children, timeframe: timeframe })=>{
    const { data: data, error: error, isValidating: isValidating } = (0, $3e479c7243cea69e$export$652dddba2ce6a1de)(timeframe);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3767ddbf01f33684$var$Context.Provider, {
        value: {
            data: data,
            error: error,
            isValidating: isValidating
        },
        children: children
    });
};
const $3767ddbf01f33684$export$ce5cd65d5f2a5117 = ()=>{
    return (0, $dup7A.useContext)($3767ddbf01f33684$var$Context);
};







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $fba153e83a9d0635$var$SvgFrenchFlag = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fill: "#003493",
                d: "M0 3.5h5.333v10.476H0z"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fill: "#fff",
                d: "M5.333 3.5h5.333v10.476H5.333z"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fill: "#DD4D48",
                d: "M10.666 3.5h5.333v10.476h-5.333z"
            })
        ]
    });
var $fba153e83a9d0635$export$2e2bcd8739ae039 = $fba153e83a9d0635$var$SvgFrenchFlag;




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $76b41f0150753d53$var$SvgSnapshotColor = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 14 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M.138 9.146 10.008.6c.332-.288.816.098.61.486L7.394 7.133h5.601c.368 0 .538.458.258.698L3.242 16.4c-.332.284-.812-.098-.61-.484L5.81 9.842H.397a.396.396 0 0 1-.26-.696Z",
            fill: "#FFAC32"
        })
    });
var $76b41f0150753d53$export$2e2bcd8739ae039 = $76b41f0150753d53$var$SvgSnapshotColor;



const $246385d97b10b8ef$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryBlue};
  :hover {
    cursor: pointer;
  }
`;
const $246385d97b10b8ef$var$fillWithSecondaryPurple = (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
  fill: ${({ theme: theme })=>theme.secondaryPurple};
`;
const $246385d97b10b8ef$var$StyledPNKIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $2ebf3a18dc3f3ead$export$2e2bcd8739ae039))`
  ${$246385d97b10b8ef$var$fillWithSecondaryPurple}
`;
const $246385d97b10b8ef$var$fillWithPrimaryBlue = (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
  fill: ${({ theme: theme })=>theme.primaryBlue};
`;
const $246385d97b10b8ef$var$StyledTelegramIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $e5e17f601f1fb0e1$export$2e2bcd8739ae039))`
  ${$246385d97b10b8ef$var$fillWithPrimaryBlue}
`;
const $246385d97b10b8ef$export$fe2e36411d703b3d = [
    {
        Icon: $246385d97b10b8ef$var$StyledPNKIcon,
        urls: [
            {
                node: /*#__PURE__*/ (0, $cZGFG.jsx)($246385d97b10b8ef$var$StyledLabel, {
                    children: "Kleros Forum"
                }),
                link: "https://forum.kleros.io/"
            }
        ]
    },
    {
        Icon: (0, $76b41f0150753d53$export$2e2bcd8739ae039),
        urls: [
            {
                node: /*#__PURE__*/ (0, $cZGFG.jsx)($246385d97b10b8ef$var$StyledLabel, {
                    children: "Vote on proposals"
                }),
                link: "https://snapshot.org/#/kleros.eth/"
            }
        ]
    },
    {
        Icon: $246385d97b10b8ef$var$StyledTelegramIcon,
        primaryText: "Wednesday, 18h UTC",
        urls: [
            {
                node: /*#__PURE__*/ (0, $cZGFG.jsx)($246385d97b10b8ef$var$StyledLabel, {
                    children: "Community Calls"
                }),
                link: "https://t.me/kleros"
            }
        ]
    },
    {
        Icon: (0, $fba153e83a9d0635$export$2e2bcd8739ae039),
        urls: [
            {
                node: /*#__PURE__*/ (0, $cZGFG.jsx)($246385d97b10b8ef$var$StyledLabel, {
                    children: "Join the Coop\xe9rative"
                }),
                link: "https://kleros.io/coop/"
            }
        ]
    }
];





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $59dd79ea9a9520f4$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;

  svg {
    width: 16px;
    height: 16px;
  }

  .link-container {
    display: flex;
    gap: 8px;
  }
`;
const $59dd79ea9a9520f4$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryText};
  font-weight: 600;
`;
const $59dd79ea9a9520f4$var$StyledA = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  align-items: center;
`;
const $59dd79ea9a9520f4$export$db77ccec0bb4ccac = ({ primaryText: primaryText, urls: urls, Icon: Icon })=>/*#__PURE__*/ (0, $cZGFG.jsxs)($59dd79ea9a9520f4$var$Container, {
        children: [
            Icon && /*#__PURE__*/ (0, $cZGFG.jsx)(Icon, {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)("div", {
                className: "link-container",
                children: urls.map(({ node: node, link: link })=>/*#__PURE__*/ (0, $cZGFG.jsx)($59dd79ea9a9520f4$var$StyledA, {
                        href: link,
                        target: "_blank",
                        rel: "noreferrer",
                        children: node
                    }, link))
            }),
            primaryText && /*#__PURE__*/ (0, $cZGFG.jsx)($59dd79ea9a9520f4$var$StyledLabel, {
                children: primaryText
            })
        ]
    });


const $73f6489c485c3225$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(44, 64)};

  h1 {
    margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
  }
`;
const $73f6489c485c3225$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  display: flex;
  width: 100%;
  height: auto;
  gap: 12px;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 24px;
  align-items: flex-start;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      justify-content: space-between;
      gap: 20px;
      padding: 24px 32px;
    `)}
`;
const $73f6489c485c3225$var$ThreeElementContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      flex-direction: row;
      justify-content: space-between;
      gap: 48px;
    `)}
`;
const $73f6489c485c3225$var$Community = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)($73f6489c485c3225$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                children: "Community"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($73f6489c485c3225$var$StyledCard, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($73f6489c485c3225$var$ThreeElementContainer, {
                        children: (0, $246385d97b10b8ef$export$fe2e36411d703b3d).slice(0, 3).map((element)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $59dd79ea9a9520f4$export$db77ccec0bb4ccac), {
                                ...element
                            }, element.Icon))
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $59dd79ea9a9520f4$export$db77ccec0bb4ccac), {
                        ...(0, $246385d97b10b8ef$export$fe2e36411d703b3d)[3]
                    })
                ]
            })
        ]
    });
var $73f6489c485c3225$export$2e2bcd8739ae039 = $73f6489c485c3225$var$Community;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $lTCHO = parcelRequire("lTCHO");





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $1babab64a6c248e6$export$cf2f7c5792f80b46() {}
const $1babab64a6c248e6$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $1babab64a6c248e6$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
function $1babab64a6c248e6$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $1babab64a6c248e6$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $1babab64a6c248e6$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $1babab64a6c248e6$export$ef35774e6d314e91(value, defaultValue) {
    return $1babab64a6c248e6$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $1babab64a6c248e6$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $1babab64a6c248e6$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $1babab64a6c248e6$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $1babab64a6c248e6$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $1babab64a6c248e6$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($1babab64a6c248e6$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($1babab64a6c248e6$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $1babab64a6c248e6$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $1babab64a6c248e6$export$738ab4df8bf92ae9(source) {
    if ($1babab64a6c248e6$export$8b22cf2602fb60ce(source)) return source.map($1babab64a6c248e6$export$738ab4df8bf92ae9);
    if ($1babab64a6c248e6$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $1babab64a6c248e6$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $1babab64a6c248e6$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $1babab64a6c248e6$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$1babab64a6c248e6$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($1babab64a6c248e6$export$23f2a1d2818174ef(tval) && $1babab64a6c248e6$export$23f2a1d2818174ef(sval)) $1babab64a6c248e6$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $1babab64a6c248e6$export$738ab4df8bf92ae9(sval);
}
function $1babab64a6c248e6$export$e7c866399fa523f5(target, source, options) {
    const sources = $1babab64a6c248e6$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$1babab64a6c248e6$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $1babab64a6c248e6$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$1babab64a6c248e6$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $1babab64a6c248e6$export$2219238a014317b0(target, source) {
    return $1babab64a6c248e6$export$e7c866399fa523f5(target, source, {
        merger: $1babab64a6c248e6$export$667d3bf0c5f83305
    });
}
function $1babab64a6c248e6$export$667d3bf0c5f83305(key, target, source) {
    if (!$1babab64a6c248e6$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($1babab64a6c248e6$export$23f2a1d2818174ef(tval) && $1babab64a6c248e6$export$23f2a1d2818174ef(sval)) $1babab64a6c248e6$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $1babab64a6c248e6$export$738ab4df8bf92ae9(sval);
}
function $1babab64a6c248e6$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $1babab64a6c248e6$var$keyResolvers = {
    "": (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $1babab64a6c248e6$export$2d1720544b23b823(obj, key) {
    const resolver = $1babab64a6c248e6$var$keyResolvers[key] || ($1babab64a6c248e6$var$keyResolvers[key] = $1babab64a6c248e6$var$_getKeyResolver(key));
    return resolver(obj);
}
function $1babab64a6c248e6$var$_getKeyResolver(key) {
    const keys = $1babab64a6c248e6$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $1babab64a6c248e6$export$1ee57be6f6687d2c(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $1babab64a6c248e6$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $1babab64a6c248e6$export$35e795649ee09318 = (value)=>typeof value !== "undefined";
const $1babab64a6c248e6$export$c3950d9923825c02 = (value)=>typeof value === "function";
const $1babab64a6c248e6$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $1babab64a6c248e6$export$3b513254972cfc9c(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $1babab64a6c248e6$export$56c0d5a1e737357d = Math.PI;
const $1babab64a6c248e6$export$971d5caa766a69d7 = 2 * $1babab64a6c248e6$export$56c0d5a1e737357d;
const $1babab64a6c248e6$export$8c78c7c36408ea29 = $1babab64a6c248e6$export$971d5caa766a69d7 + $1babab64a6c248e6$export$56c0d5a1e737357d;
const $1babab64a6c248e6$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $1babab64a6c248e6$export$2ec5befb9e6c97d4 = $1babab64a6c248e6$export$56c0d5a1e737357d / 180;
const $1babab64a6c248e6$export$7f8ddf7c7c20b3cd = $1babab64a6c248e6$export$56c0d5a1e737357d / 2;
const $1babab64a6c248e6$export$53c86fa97d611818 = $1babab64a6c248e6$export$56c0d5a1e737357d / 4;
const $1babab64a6c248e6$export$39c1cc7c062529d4 = $1babab64a6c248e6$export$56c0d5a1e737357d * 2 / 3;
const $1babab64a6c248e6$export$df995fae86a55f06 = Math.log10;
const $1babab64a6c248e6$export$2408f22a0fab9ae5 = Math.sign;
function $1babab64a6c248e6$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $1babab64a6c248e6$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($1babab64a6c248e6$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $1babab64a6c248e6$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $1babab64a6c248e6$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $1babab64a6c248e6$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $1babab64a6c248e6$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $1babab64a6c248e6$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $1babab64a6c248e6$export$625550452a3fa3ec(degrees) {
    return degrees * ($1babab64a6c248e6$export$56c0d5a1e737357d / 180);
}
function $1babab64a6c248e6$export$d66501df72047452(radians) {
    return radians * (180 / $1babab64a6c248e6$export$56c0d5a1e737357d);
}
function $1babab64a6c248e6$export$91477dc880baac21(x) {
    if (!$1babab64a6c248e6$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $1babab64a6c248e6$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $1babab64a6c248e6$export$56c0d5a1e737357d) angle += $1babab64a6c248e6$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $1babab64a6c248e6$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $1babab64a6c248e6$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $1babab64a6c248e6$export$8c78c7c36408ea29) % $1babab64a6c248e6$export$971d5caa766a69d7 - $1babab64a6c248e6$export$56c0d5a1e737357d;
}
function $1babab64a6c248e6$export$3d12bd131bb975d1(a) {
    return (a % $1babab64a6c248e6$export$971d5caa766a69d7 + $1babab64a6c248e6$export$971d5caa766a69d7) % $1babab64a6c248e6$export$971d5caa766a69d7;
}
function $1babab64a6c248e6$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $1babab64a6c248e6$export$3d12bd131bb975d1(angle);
    const s = $1babab64a6c248e6$export$3d12bd131bb975d1(start);
    const e = $1babab64a6c248e6$export$3d12bd131bb975d1(end);
    const angleToStart = $1babab64a6c248e6$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $1babab64a6c248e6$export$3d12bd131bb975d1(e - a);
    const startToAngle = $1babab64a6c248e6$export$3d12bd131bb975d1(a - s);
    const endToAngle = $1babab64a6c248e6$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $1babab64a6c248e6$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $1babab64a6c248e6$export$9bb611d729802a56(value) {
    return $1babab64a6c248e6$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $1babab64a6c248e6$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $1babab64a6c248e6$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $1babab64a6c248e6$export$dc98b0b04f4c7758 = (table, key, value, last)=>$1babab64a6c248e6$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $1babab64a6c248e6$export$8743009a87fcb00f = (table, key, value)=>$1babab64a6c248e6$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $1babab64a6c248e6$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $1babab64a6c248e6$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $1babab64a6c248e6$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $1babab64a6c248e6$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $1babab64a6c248e6$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $1babab64a6c248e6$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $1babab64a6c248e6$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $1babab64a6c248e6$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $1babab64a6c248e6$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $1babab64a6c248e6$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $1babab64a6c248e6$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $1babab64a6c248e6$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $1babab64a6c248e6$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $1babab64a6c248e6$export$db202ddc8be9136 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $1babab64a6c248e6$export$25ce5a424b770e84 = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $1babab64a6c248e6$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $1babab64a6c248e6$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $1babab64a6c248e6$export$a9c23c6ac3fc3eca(Math.min($1babab64a6c248e6$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $1babab64a6c248e6$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $1babab64a6c248e6$export$a9c23c6ac3fc3eca(Math.max($1babab64a6c248e6$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $1babab64a6c248e6$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $1babab64a6c248e6$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $1babab64a6c248e6$var$atEdge = (t)=>t === 0 || t === 1;
const $1babab64a6c248e6$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $1babab64a6c248e6$export$971d5caa766a69d7 / p));
const $1babab64a6c248e6$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $1babab64a6c248e6$export$971d5caa766a69d7 / p) + 1;
const $1babab64a6c248e6$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $1babab64a6c248e6$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $1babab64a6c248e6$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($1babab64a6c248e6$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$1babab64a6c248e6$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$1babab64a6c248e6$var$atEdge(t) ? t : $1babab64a6c248e6$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$1babab64a6c248e6$var$atEdge(t) ? t : $1babab64a6c248e6$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $1babab64a6c248e6$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $1babab64a6c248e6$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $1babab64a6c248e6$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $1babab64a6c248e6$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $1babab64a6c248e6$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $1babab64a6c248e6$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $1babab64a6c248e6$var$round(v) {
    return v + 0.5 | 0;
}
const $1babab64a6c248e6$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $1babab64a6c248e6$var$p2b(v) {
    return $1babab64a6c248e6$var$lim($1babab64a6c248e6$var$round(v * 2.55), 0, 255);
}
function $1babab64a6c248e6$var$n2b(v) {
    return $1babab64a6c248e6$var$lim($1babab64a6c248e6$var$round(v * 255), 0, 255);
}
function $1babab64a6c248e6$var$b2n(v) {
    return $1babab64a6c248e6$var$lim($1babab64a6c248e6$var$round(v / 2.55) / 100, 0, 1);
}
function $1babab64a6c248e6$var$n2p(v) {
    return $1babab64a6c248e6$var$lim($1babab64a6c248e6$var$round(v * 100), 0, 100);
}
const $1babab64a6c248e6$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $1babab64a6c248e6$var$hex = [
    ..."0123456789ABCDEF"
];
const $1babab64a6c248e6$var$h1 = (b)=>$1babab64a6c248e6$var$hex[b & 0xF];
const $1babab64a6c248e6$var$h2 = (b)=>$1babab64a6c248e6$var$hex[(b & 0xF0) >> 4] + $1babab64a6c248e6$var$hex[b & 0xF];
const $1babab64a6c248e6$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $1babab64a6c248e6$var$isShort = (v)=>$1babab64a6c248e6$var$eq(v.r) && $1babab64a6c248e6$var$eq(v.g) && $1babab64a6c248e6$var$eq(v.b) && $1babab64a6c248e6$var$eq(v.a);
function $1babab64a6c248e6$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $1babab64a6c248e6$var$map$1[str[1]] * 17,
            g: 255 & $1babab64a6c248e6$var$map$1[str[2]] * 17,
            b: 255 & $1babab64a6c248e6$var$map$1[str[3]] * 17,
            a: len === 5 ? $1babab64a6c248e6$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $1babab64a6c248e6$var$map$1[str[1]] << 4 | $1babab64a6c248e6$var$map$1[str[2]],
            g: $1babab64a6c248e6$var$map$1[str[3]] << 4 | $1babab64a6c248e6$var$map$1[str[4]],
            b: $1babab64a6c248e6$var$map$1[str[5]] << 4 | $1babab64a6c248e6$var$map$1[str[6]],
            a: len === 9 ? $1babab64a6c248e6$var$map$1[str[7]] << 4 | $1babab64a6c248e6$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $1babab64a6c248e6$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $1babab64a6c248e6$var$hexString(v) {
    var f = $1babab64a6c248e6$var$isShort(v) ? $1babab64a6c248e6$var$h1 : $1babab64a6c248e6$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $1babab64a6c248e6$var$alpha(v.a, f) : undefined;
}
const $1babab64a6c248e6$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $1babab64a6c248e6$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $1babab64a6c248e6$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $1babab64a6c248e6$var$hwb2rgbn(h, w, b) {
    const rgb = $1babab64a6c248e6$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $1babab64a6c248e6$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $1babab64a6c248e6$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $1babab64a6c248e6$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $1babab64a6c248e6$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($1babab64a6c248e6$var$n2b);
}
function $1babab64a6c248e6$var$hsl2rgb(h, s, l) {
    return $1babab64a6c248e6$var$calln($1babab64a6c248e6$var$hsl2rgbn, h, s, l);
}
function $1babab64a6c248e6$var$hwb2rgb(h, w, b) {
    return $1babab64a6c248e6$var$calln($1babab64a6c248e6$var$hwb2rgbn, h, w, b);
}
function $1babab64a6c248e6$var$hsv2rgb(h, s, v) {
    return $1babab64a6c248e6$var$calln($1babab64a6c248e6$var$hsv2rgbn, h, s, v);
}
function $1babab64a6c248e6$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $1babab64a6c248e6$var$hueParse(str) {
    const m = $1babab64a6c248e6$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $1babab64a6c248e6$var$p2b(+m[5]) : $1babab64a6c248e6$var$n2b(+m[5]);
    const h = $1babab64a6c248e6$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $1babab64a6c248e6$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $1babab64a6c248e6$var$hsv2rgb(h, p1, p2);
    else v = $1babab64a6c248e6$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $1babab64a6c248e6$var$rotate(v, deg) {
    var h = $1babab64a6c248e6$var$rgb2hsl(v);
    h[0] = $1babab64a6c248e6$var$hue(h[0] + deg);
    h = $1babab64a6c248e6$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $1babab64a6c248e6$var$hslString(v) {
    if (!v) return;
    const a = $1babab64a6c248e6$var$rgb2hsl(v);
    const h = a[0];
    const s = $1babab64a6c248e6$var$n2p(a[1]);
    const l = $1babab64a6c248e6$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$1babab64a6c248e6$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $1babab64a6c248e6$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $1babab64a6c248e6$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $1babab64a6c248e6$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($1babab64a6c248e6$var$names$1);
    const tkeys = Object.keys($1babab64a6c248e6$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $1babab64a6c248e6$var$map[k]);
        }
        k = parseInt($1babab64a6c248e6$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $1babab64a6c248e6$var$names;
function $1babab64a6c248e6$var$nameParse(str) {
    if (!$1babab64a6c248e6$var$names) {
        $1babab64a6c248e6$var$names = $1babab64a6c248e6$var$unpack();
        $1babab64a6c248e6$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $1babab64a6c248e6$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $1babab64a6c248e6$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $1babab64a6c248e6$var$rgbParse(str) {
    const m = $1babab64a6c248e6$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $1babab64a6c248e6$var$p2b(v) : $1babab64a6c248e6$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $1babab64a6c248e6$var$p2b(r) : $1babab64a6c248e6$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $1babab64a6c248e6$var$p2b(g) : $1babab64a6c248e6$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $1babab64a6c248e6$var$p2b(b) : $1babab64a6c248e6$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $1babab64a6c248e6$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$1babab64a6c248e6$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $1babab64a6c248e6$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $1babab64a6c248e6$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $1babab64a6c248e6$var$interpolate(rgb1, rgb2, t) {
    const r = $1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb1.r));
    const g = $1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb1.g));
    const b = $1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb1.b));
    return {
        r: $1babab64a6c248e6$var$n2b($1babab64a6c248e6$var$to(r + t * ($1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb2.r)) - r))),
        g: $1babab64a6c248e6$var$n2b($1babab64a6c248e6$var$to(g + t * ($1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb2.g)) - g))),
        b: $1babab64a6c248e6$var$n2b($1babab64a6c248e6$var$to(b + t * ($1babab64a6c248e6$var$from($1babab64a6c248e6$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $1babab64a6c248e6$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $1babab64a6c248e6$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $1babab64a6c248e6$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $1babab64a6c248e6$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $1babab64a6c248e6$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $1babab64a6c248e6$var$n2b(input[3]);
        }
    } else {
        v = $1babab64a6c248e6$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $1babab64a6c248e6$var$n2b(v.a);
    }
    return v;
}
function $1babab64a6c248e6$var$functionParse(str) {
    if (str.charAt(0) === "r") return $1babab64a6c248e6$var$rgbParse(str);
    return $1babab64a6c248e6$var$hueParse(str);
}
class $1babab64a6c248e6$var$Color {
    constructor(input){
        if (input instanceof $1babab64a6c248e6$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $1babab64a6c248e6$var$fromObject(input);
        else if (type === "string") v = $1babab64a6c248e6$var$hexParse(input) || $1babab64a6c248e6$var$nameParse(input) || $1babab64a6c248e6$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $1babab64a6c248e6$var$clone(this._rgb);
        if (v) v.a = $1babab64a6c248e6$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $1babab64a6c248e6$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $1babab64a6c248e6$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $1babab64a6c248e6$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $1babab64a6c248e6$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $1babab64a6c248e6$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $1babab64a6c248e6$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $1babab64a6c248e6$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $1babab64a6c248e6$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $1babab64a6c248e6$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $1babab64a6c248e6$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $1babab64a6c248e6$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $1babab64a6c248e6$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $1babab64a6c248e6$var$rotate(this._rgb, deg);
        return this;
    }
}
function $1babab64a6c248e6$var$index_esm(input) {
    return new $1babab64a6c248e6$var$Color(input);
}
function $1babab64a6c248e6$export$2ed0fc6709e59212(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $1babab64a6c248e6$export$db3b6bfb95261072(value) {
    return $1babab64a6c248e6$export$2ed0fc6709e59212(value) ? value : $1babab64a6c248e6$var$index_esm(value);
}
function $1babab64a6c248e6$export$f96d196f7728bb5(value) {
    return $1babab64a6c248e6$export$2ed0fc6709e59212(value) ? value : $1babab64a6c248e6$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $1babab64a6c248e6$export$3a6d5c9ae78a2c08 = Object.create(null);
const $1babab64a6c248e6$export$a93c5207d687da10 = Object.create(null);
function $1babab64a6c248e6$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $1babab64a6c248e6$var$set(root, scope, values) {
    if (typeof scope === "string") return $1babab64a6c248e6$export$e7c866399fa523f5($1babab64a6c248e6$var$getScope$1(root, scope), values);
    return $1babab64a6c248e6$export$e7c866399fa523f5($1babab64a6c248e6$var$getScope$1(root, ""), scope);
}
class $1babab64a6c248e6$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$1babab64a6c248e6$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$1babab64a6c248e6$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$1babab64a6c248e6$export$f96d196f7728bb5(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $1babab64a6c248e6$var$set(this, scope, values);
    }
    get(scope) {
        return $1babab64a6c248e6$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $1babab64a6c248e6$var$set($1babab64a6c248e6$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $1babab64a6c248e6$var$set($1babab64a6c248e6$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $1babab64a6c248e6$var$getScope$1(this, scope);
        const targetScopeObject = $1babab64a6c248e6$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($1babab64a6c248e6$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $1babab64a6c248e6$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $1babab64a6c248e6$export$4368d992c4eafac0 = new $1babab64a6c248e6$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $1babab64a6c248e6$export$9d0e2d13d04f7070(font) {
    if (!font || $1babab64a6c248e6$export$342063e11d6c3cad(font.size) || $1babab64a6c248e6$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $1babab64a6c248e6$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $1babab64a6c248e6$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $1babab64a6c248e6$export$8b22cf2602fb60ce(thing) !== true) longest = $1babab64a6c248e6$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($1babab64a6c248e6$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$1babab64a6c248e6$export$8b22cf2602fb60ce(nestedThing)) longest = $1babab64a6c248e6$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $1babab64a6c248e6$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $1babab64a6c248e6$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $1babab64a6c248e6$export$1fbe638ecf81657e(ctx, options, x, y) {
    $1babab64a6c248e6$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $1babab64a6c248e6$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $1babab64a6c248e6$export$2ec5befb9e6c97d4;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $1babab64a6c248e6$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $1babab64a6c248e6$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $1babab64a6c248e6$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $1babab64a6c248e6$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $1babab64a6c248e6$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $1babab64a6c248e6$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $1babab64a6c248e6$export$56c0d5a1e737357d, rad - $1babab64a6c248e6$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $1babab64a6c248e6$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $1babab64a6c248e6$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $1babab64a6c248e6$export$7f8ddf7c7c20b3cd, rad + $1babab64a6c248e6$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $1babab64a6c248e6$export$53c86fa97d611818;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $1babab64a6c248e6$export$53c86fa97d611818;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $1babab64a6c248e6$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $1babab64a6c248e6$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $1babab64a6c248e6$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $1babab64a6c248e6$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $1babab64a6c248e6$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $1babab64a6c248e6$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $1babab64a6c248e6$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $1babab64a6c248e6$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $1babab64a6c248e6$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$1babab64a6c248e6$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $1babab64a6c248e6$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $1babab64a6c248e6$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$1babab64a6c248e6$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $1babab64a6c248e6$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $1babab64a6c248e6$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$1babab64a6c248e6$export$7f8ddf7c7c20b3cd, $1babab64a6c248e6$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $1babab64a6c248e6$export$56c0d5a1e737357d, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$1babab64a6c248e6$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $1babab64a6c248e6$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $1babab64a6c248e6$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $1babab64a6c248e6$export$fef3dfd9bad05307(value, size) {
    const matches = ("" + value).match($1babab64a6c248e6$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $1babab64a6c248e6$var$numberOrZero = (v)=>+v || 0;
function $1babab64a6c248e6$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $1babab64a6c248e6$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $1babab64a6c248e6$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$1babab64a6c248e6$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $1babab64a6c248e6$var$numberOrZero(read(prop));
    return ret;
}
function $1babab64a6c248e6$export$92108d983e8ee699(value) {
    return $1babab64a6c248e6$export$ab83b03e4111b1d0(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $1babab64a6c248e6$export$9fa96a7d116ea3ce(value) {
    return $1babab64a6c248e6$export$ab83b03e4111b1d0(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $1babab64a6c248e6$export$3466f893ebf79586(value) {
    const obj = $1babab64a6c248e6$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $1babab64a6c248e6$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $1babab64a6c248e6$export$4368d992c4eafac0.font;
    let size = $1babab64a6c248e6$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $1babab64a6c248e6$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($1babab64a6c248e6$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $1babab64a6c248e6$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $1babab64a6c248e6$export$fef3dfd9bad05307($1babab64a6c248e6$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $1babab64a6c248e6$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $1babab64a6c248e6$export$9d0e2d13d04f7070(font);
    return font;
}
function $1babab64a6c248e6$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $1babab64a6c248e6$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $1babab64a6c248e6$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $1babab64a6c248e6$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $1babab64a6c248e6$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $1babab64a6c248e6$export$7910e0436ed8d1de(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$1babab64a6c248e6$export$35e795649ee09318(fallback)) fallback = $1babab64a6c248e6$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$1babab64a6c248e6$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $1babab64a6c248e6$var$_cached(target, prop, ()=>$1babab64a6c248e6$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $1babab64a6c248e6$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $1babab64a6c248e6$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $1babab64a6c248e6$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $1babab64a6c248e6$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$1babab64a6c248e6$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$1babab64a6c248e6$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $1babab64a6c248e6$var$_cached(target, prop, ()=>$1babab64a6c248e6$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $1babab64a6c248e6$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $1babab64a6c248e6$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $1babab64a6c248e6$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $1babab64a6c248e6$var$readKey = (prefix, name)=>prefix ? prefix + $1babab64a6c248e6$export$71cec2538cb2c617(name) : name;
const $1babab64a6c248e6$var$needsSubResolver = (prop, value)=>$1babab64a6c248e6$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $1babab64a6c248e6$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $1babab64a6c248e6$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($1babab64a6c248e6$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $1babab64a6c248e6$var$_resolveScriptable(prop, value, target, receiver);
    if ($1babab64a6c248e6$export$8b22cf2602fb60ce(value) && value.length) value = $1babab64a6c248e6$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($1babab64a6c248e6$var$needsSubResolver(prop, value)) value = $1babab64a6c248e6$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $1babab64a6c248e6$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($1babab64a6c248e6$var$needsSubResolver(prop, value)) value = $1babab64a6c248e6$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $1babab64a6c248e6$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($1babab64a6c248e6$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($1babab64a6c248e6$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $1babab64a6c248e6$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($1babab64a6c248e6$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $1babab64a6c248e6$var$resolveFallback(fallback, prop, value) {
    return $1babab64a6c248e6$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $1babab64a6c248e6$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $1babab64a6c248e6$export$2d1720544b23b823(parent, key) : undefined;
function $1babab64a6c248e6$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $1babab64a6c248e6$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $1babab64a6c248e6$var$resolveFallback(scope._fallback, key, value);
            if ($1babab64a6c248e6$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $1babab64a6c248e6$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $1babab64a6c248e6$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $1babab64a6c248e6$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $1babab64a6c248e6$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($1babab64a6c248e6$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $1babab64a6c248e6$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $1babab64a6c248e6$export$7910e0436ed8d1de(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$1babab64a6c248e6$var$subGetTarget(resolver, prop, value));
}
function $1babab64a6c248e6$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $1babab64a6c248e6$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $1babab64a6c248e6$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($1babab64a6c248e6$export$8b22cf2602fb60ce(target) && $1babab64a6c248e6$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $1babab64a6c248e6$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $1babab64a6c248e6$var$_resolve($1babab64a6c248e6$var$readKey(prefix, prop), scopes);
        if ($1babab64a6c248e6$export$35e795649ee09318(value)) return $1babab64a6c248e6$var$needsSubResolver(prop, value) ? $1babab64a6c248e6$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $1babab64a6c248e6$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($1babab64a6c248e6$export$35e795649ee09318(value)) return value;
    }
}
function $1babab64a6c248e6$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $1babab64a6c248e6$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $1babab64a6c248e6$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $1babab64a6c248e6$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($1babab64a6c248e6$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $1babab64a6c248e6$var$EPSILON = Number.EPSILON || 1e-14;
const $1babab64a6c248e6$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $1babab64a6c248e6$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $1babab64a6c248e6$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $1babab64a6c248e6$export$53a70dd1ebbae346(current, previous);
    const d12 = $1babab64a6c248e6$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $1babab64a6c248e6$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $1babab64a6c248e6$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $1babab64a6c248e6$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($1babab64a6c248e6$export$23ebac1979863676(deltaK[i], 0, $1babab64a6c248e6$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $1babab64a6c248e6$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $1babab64a6c248e6$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $1babab64a6c248e6$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $1babab64a6c248e6$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $1babab64a6c248e6$export$e171bab687b50e0(points, indexAxis = "x") {
    const valueAxis = $1babab64a6c248e6$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $1babab64a6c248e6$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $1babab64a6c248e6$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $1babab64a6c248e6$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $1babab64a6c248e6$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $1babab64a6c248e6$var$monotoneAdjust(points, deltaK, mK);
    $1babab64a6c248e6$var$monotoneCompute(points, mK, indexAxis);
}
function $1babab64a6c248e6$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $1babab64a6c248e6$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $1babab64a6c248e6$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $1babab64a6c248e6$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $1babab64a6c248e6$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $1babab64a6c248e6$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $1babab64a6c248e6$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $1babab64a6c248e6$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $1babab64a6c248e6$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $1babab64a6c248e6$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $1babab64a6c248e6$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $1babab64a6c248e6$var$capBezierPoints(points, area);
}
function $1babab64a6c248e6$export$2e2af4578d910ddf() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $1babab64a6c248e6$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $1babab64a6c248e6$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $1babab64a6c248e6$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $1babab64a6c248e6$export$527e9aa3390079e9(el, property) {
    return $1babab64a6c248e6$var$getComputedStyle(el).getPropertyValue(property);
}
const $1babab64a6c248e6$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $1babab64a6c248e6$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $1babab64a6c248e6$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $1babab64a6c248e6$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $1babab64a6c248e6$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($1babab64a6c248e6$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $1babab64a6c248e6$export$78acf4525d8a74c4(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $1babab64a6c248e6$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $1babab64a6c248e6$var$getPositionedStyle(style, "padding");
    const borders = $1babab64a6c248e6$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $1babab64a6c248e6$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $1babab64a6c248e6$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $1babab64a6c248e6$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $1babab64a6c248e6$var$getComputedStyle(container);
            const containerBorder = $1babab64a6c248e6$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $1babab64a6c248e6$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $1babab64a6c248e6$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $1babab64a6c248e6$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $1babab64a6c248e6$export$d29e374196577086,
        maxHeight: maxHeight || $1babab64a6c248e6$export$d29e374196577086
    };
}
const $1babab64a6c248e6$var$round1 = (v)=>Math.round(v * 10) / 10;
function $1babab64a6c248e6$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $1babab64a6c248e6$var$getComputedStyle(canvas);
    const margins = $1babab64a6c248e6$var$getPositionedStyle(style, "margin");
    const maxWidth = $1babab64a6c248e6$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $1babab64a6c248e6$export$d29e374196577086;
    const maxHeight = $1babab64a6c248e6$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $1babab64a6c248e6$export$d29e374196577086;
    const containerSize = $1babab64a6c248e6$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $1babab64a6c248e6$var$getPositionedStyle(style, "border", "width");
        const paddings = $1babab64a6c248e6$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $1babab64a6c248e6$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $1babab64a6c248e6$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $1babab64a6c248e6$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $1babab64a6c248e6$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $1babab64a6c248e6$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $1babab64a6c248e6$export$6559d589eb85fbb6(element, property) {
    const value = $1babab64a6c248e6$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $1babab64a6c248e6$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $1babab64a6c248e6$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $1babab64a6c248e6$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $1babab64a6c248e6$export$d24c54395ce0c509(p1, cp1, t);
    const b = $1babab64a6c248e6$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $1babab64a6c248e6$export$d24c54395ce0c509(cp2, p2, t);
    const d = $1babab64a6c248e6$export$d24c54395ce0c509(a, b, t);
    const e = $1babab64a6c248e6$export$d24c54395ce0c509(b, c, t);
    return $1babab64a6c248e6$export$d24c54395ce0c509(d, e, t);
}
const $1babab64a6c248e6$var$intlCache = new Map();
function $1babab64a6c248e6$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $1babab64a6c248e6$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $1babab64a6c248e6$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $1babab64a6c248e6$export$ae1af26003f05816(num, locale, options) {
    return $1babab64a6c248e6$var$getNumberFormat(locale, options).format(num);
}
const $1babab64a6c248e6$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $1babab64a6c248e6$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $1babab64a6c248e6$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $1babab64a6c248e6$var$getRightToLeftAdapter(rectX, width) : $1babab64a6c248e6$var$getLeftToRightAdapter();
}
function $1babab64a6c248e6$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $1babab64a6c248e6$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $1babab64a6c248e6$var$propertyFn(property) {
    if (property === "angle") return {
        between: $1babab64a6c248e6$export$ffb5f4729a158638,
        compare: $1babab64a6c248e6$export$7a0bdf7d4a91ea88,
        normalize: $1babab64a6c248e6$export$3d12bd131bb975d1
    };
    return {
        between: $1babab64a6c248e6$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $1babab64a6c248e6$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $1babab64a6c248e6$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $1babab64a6c248e6$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $1babab64a6c248e6$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $1babab64a6c248e6$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $1babab64a6c248e6$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($1babab64a6c248e6$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($1babab64a6c248e6$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $1babab64a6c248e6$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $1babab64a6c248e6$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $1babab64a6c248e6$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $1babab64a6c248e6$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $1babab64a6c248e6$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $1babab64a6c248e6$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $1babab64a6c248e6$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $1babab64a6c248e6$var$splitByStyles(line, $1babab64a6c248e6$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $1babab64a6c248e6$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $1babab64a6c248e6$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $1babab64a6c248e6$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $1babab64a6c248e6$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $1babab64a6c248e6$var$readStyle(segmentOptions.setContext($1babab64a6c248e6$export$dda1d9f60106f0e9(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($1babab64a6c248e6$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $1babab64a6c248e6$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $1babab64a6c248e6$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}


class $f2a0fc44203c547a$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $1babab64a6c248e6$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $f2a0fc44203c547a$export$a424a0aa8f687495 = new $f2a0fc44203c547a$var$Animator();
const $f2a0fc44203c547a$var$transparent = "transparent";
const $f2a0fc44203c547a$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $1babab64a6c248e6$export$db3b6bfb95261072)(from || $f2a0fc44203c547a$var$transparent);
        const c1 = c0.valid && (0, $1babab64a6c248e6$export$db3b6bfb95261072)(to || $f2a0fc44203c547a$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $f2a0fc44203c547a$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $1babab64a6c248e6$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $1babab64a6c248e6$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $f2a0fc44203c547a$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $1babab64a6c248e6$export$f1e1789686576879)[cfg.easing] || (0, $1babab64a6c248e6$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $1babab64a6c248e6$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $1babab64a6c248e6$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $f2a0fc44203c547a$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $f2a0fc44203c547a$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $1babab64a6c248e6$export$4368d992c4eafac0).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $f2a0fc44203c547a$var$animationOptions = Object.keys((0, $1babab64a6c248e6$export$4368d992c4eafac0).animation);
(0, $1babab64a6c248e6$export$4368d992c4eafac0).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).set("animations", {
    colors: {
        type: "color",
        properties: $f2a0fc44203c547a$var$colors
    },
    numbers: {
        type: "number",
        properties: $f2a0fc44203c547a$var$numbers
    }
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).describe("animations", {
    _fallback: "animation"
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $f2a0fc44203c547a$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $1babab64a6c248e6$export$23f2a1d2818174ef)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $1babab64a6c248e6$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of $f2a0fc44203c547a$var$animationOptions)resolved[option] = cfg[option];
            ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $f2a0fc44203c547a$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $f2a0fc44203c547a$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $f2a0fc44203c547a$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $f2a0fc44203c547a$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $f2a0fc44203c547a$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $f2a0fc44203c547a$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $f2a0fc44203c547a$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $f2a0fc44203c547a$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $f2a0fc44203c547a$var$scaleClip(xScale, allowedOverflow);
    const y = $f2a0fc44203c547a$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $f2a0fc44203c547a$var$toClip(value) {
    let t, r, b, l;
    if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $f2a0fc44203c547a$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $f2a0fc44203c547a$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $1babab64a6c248e6$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(value) === (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $f2a0fc44203c547a$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $f2a0fc44203c547a$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $f2a0fc44203c547a$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $f2a0fc44203c547a$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $f2a0fc44203c547a$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $f2a0fc44203c547a$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $f2a0fc44203c547a$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $f2a0fc44203c547a$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $f2a0fc44203c547a$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $f2a0fc44203c547a$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $f2a0fc44203c547a$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $f2a0fc44203c547a$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $f2a0fc44203c547a$var$createDatasetContext(parent, index) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $f2a0fc44203c547a$var$createDataContext(parent, index, element) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $f2a0fc44203c547a$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $f2a0fc44203c547a$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $f2a0fc44203c547a$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $f2a0fc44203c547a$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $f2a0fc44203c547a$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $f2a0fc44203c547a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $f2a0fc44203c547a$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $f2a0fc44203c547a$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(dataset.xAxisID, $f2a0fc44203c547a$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(dataset.yAxisID, $f2a0fc44203c547a$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(dataset.rAxisID, $f2a0fc44203c547a$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $1babab64a6c248e6$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $f2a0fc44203c547a$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(data)) this._data = $f2a0fc44203c547a$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $1babab64a6c248e6$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $f2a0fc44203c547a$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $1babab64a6c248e6$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $f2a0fc44203c547a$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $f2a0fc44203c547a$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $f2a0fc44203c547a$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $f2a0fc44203c547a$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $1babab64a6c248e6$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $1babab64a6c248e6$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $f2a0fc44203c547a$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $f2a0fc44203c547a$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $f2a0fc44203c547a$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $f2a0fc44203c547a$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $f2a0fc44203c547a$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $1babab64a6c248e6$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $1babab64a6c248e6$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $f2a0fc44203c547a$var$toClip((0, $1babab64a6c248e6$export$90a7f3efeed30595)(this.options.clip, $f2a0fc44203c547a$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $f2a0fc44203c547a$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $f2a0fc44203c547a$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $1babab64a6c248e6$export$35e795649ee09318)(index);
        if (cached) return $f2a0fc44203c547a$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $1babab64a6c248e6$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($f2a0fc44203c547a$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $f2a0fc44203c547a$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $f2a0fc44203c547a$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($f2a0fc44203c547a$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$f2a0fc44203c547a$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $f2a0fc44203c547a$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$f2a0fc44203c547a$export$75572ec5c55b4048.defaults = {};
$f2a0fc44203c547a$export$75572ec5c55b4048.prototype.datasetElementType = null;
$f2a0fc44203c547a$export$75572ec5c55b4048.prototype.dataElementType = null;
function $f2a0fc44203c547a$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $1babab64a6c248e6$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $f2a0fc44203c547a$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $f2a0fc44203c547a$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $1babab64a6c248e6$export$35e795649ee09318)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $f2a0fc44203c547a$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $f2a0fc44203c547a$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $f2a0fc44203c547a$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $f2a0fc44203c547a$var$parseValue(entry, item, vScale, i) {
    if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(entry)) $f2a0fc44203c547a$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $f2a0fc44203c547a$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($f2a0fc44203c547a$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $f2a0fc44203c547a$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $f2a0fc44203c547a$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $f2a0fc44203c547a$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $f2a0fc44203c547a$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $f2a0fc44203c547a$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$f2a0fc44203c547a$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$f2a0fc44203c547a$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $f2a0fc44203c547a$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $f2a0fc44203c547a$var$swap(edge, a, b);
        edge = $f2a0fc44203c547a$var$startEnd(edge, b, a);
    } else edge = $f2a0fc44203c547a$var$startEnd(edge, a, b);
    return edge;
}
function $f2a0fc44203c547a$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $f2a0fc44203c547a$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $f2a0fc44203c547a$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $f2a0fc44203c547a$export$e97d5dc64e999004 extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $f2a0fc44203c547a$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $f2a0fc44203c547a$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $1babab64a6c248e6$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($f2a0fc44203c547a$var$parseValue((0, $1babab64a6c248e6$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $f2a0fc44203c547a$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $1babab64a6c248e6$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $f2a0fc44203c547a$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $f2a0fc44203c547a$var$setBorderSkipped(properties, options, stack, index);
            $f2a0fc44203c547a$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $f2a0fc44203c547a$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $f2a0fc44203c547a$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(value) !== (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $1babab64a6c248e6$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $f2a0fc44203c547a$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $f2a0fc44203c547a$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $f2a0fc44203c547a$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$f2a0fc44203c547a$export$e97d5dc64e999004.id = "bar";
$f2a0fc44203c547a$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$f2a0fc44203c547a$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $f2a0fc44203c547a$export$19b5c4773f17abe extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $1babab64a6c248e6$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
$f2a0fc44203c547a$export$19b5c4773f17abe.id = "bubble";
$f2a0fc44203c547a$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$f2a0fc44203c547a$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $f2a0fc44203c547a$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $1babab64a6c248e6$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $1babab64a6c248e6$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $1babab64a6c248e6$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $1babab64a6c248e6$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $1babab64a6c248e6$export$56c0d5a1e737357d) + (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $f2a0fc44203c547a$export$e04603e7d8b77172 extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $1babab64a6c248e6$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $1babab64a6c248e6$export$971d5caa766a69d7);
        let max = -(0, $1babab64a6c248e6$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $1babab64a6c248e6$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $f2a0fc44203c547a$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $1babab64a6c248e6$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $1babab64a6c248e6$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $1babab64a6c248e6$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $1babab64a6c248e6$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $1babab64a6c248e6$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$f2a0fc44203c547a$export$e04603e7d8b77172.id = "doughnut";
$f2a0fc44203c547a$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$f2a0fc44203c547a$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$f2a0fc44203c547a$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $f2a0fc44203c547a$export$3c9b5d28c11cbfd0 extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $1babab64a6c248e6$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $1babab64a6c248e6$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $1babab64a6c248e6$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $1babab64a6c248e6$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$f2a0fc44203c547a$export$3c9b5d28c11cbfd0.id = "line";
$f2a0fc44203c547a$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$f2a0fc44203c547a$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
class $f2a0fc44203c547a$export$2a270b3a0d973c85 extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $1babab64a6c248e6$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $1babab64a6c248e6$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $1babab64a6c248e6$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$f2a0fc44203c547a$export$2a270b3a0d973c85.id = "polarArea";
$f2a0fc44203c547a$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$f2a0fc44203c547a$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $f2a0fc44203c547a$export$b21a3f1286706191 extends $f2a0fc44203c547a$export$e04603e7d8b77172 {
}
$f2a0fc44203c547a$export$b21a3f1286706191.id = "pie";
$f2a0fc44203c547a$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $f2a0fc44203c547a$export$48dbc6ac651bf8be extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $1babab64a6c248e6$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$f2a0fc44203c547a$export$48dbc6ac651bf8be.id = "radar";
$f2a0fc44203c547a$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$f2a0fc44203c547a$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $1babab64a6c248e6$export$d141bba7fdc215a3)(this.x) && (0, $1babab64a6c248e6$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
$f2a0fc44203c547a$export$db77ccec0bb4ccac.defaults = {};
$f2a0fc44203c547a$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $f2a0fc44203c547a$var$formatters = {
    values (value) {
        return (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $f2a0fc44203c547a$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $1babab64a6c248e6$export$df995fae86a55f06)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $1babab64a6c248e6$export$ae1af26003f05816)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $f2a0fc44203c547a$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $f2a0fc44203c547a$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $f2a0fc44203c547a$export$27c7467594ef87bd = {
    formatters: $f2a0fc44203c547a$var$formatters
};
(0, $1babab64a6c248e6$export$4368d992c4eafac0).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $f2a0fc44203c547a$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).route("scale.ticks", "color", "", "color");
(0, $1babab64a6c248e6$export$4368d992c4eafac0).route("scale.grid", "color", "", "borderColor");
(0, $1babab64a6c248e6$export$4368d992c4eafac0).route("scale.grid", "borderColor", "", "borderColor");
(0, $1babab64a6c248e6$export$4368d992c4eafac0).route("scale.title", "color", "", "color");
(0, $1babab64a6c248e6$export$4368d992c4eafac0).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).describe("scales", {
    _fallback: "scale"
});
(0, $1babab64a6c248e6$export$4368d992c4eafac0).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $f2a0fc44203c547a$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $f2a0fc44203c547a$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $f2a0fc44203c547a$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $f2a0fc44203c547a$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $f2a0fc44203c547a$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $f2a0fc44203c547a$var$skip(ticks, newTicks, spacing, (0, $1babab64a6c248e6$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$f2a0fc44203c547a$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $f2a0fc44203c547a$var$skip(ticks, newTicks, spacing, last, (0, $1babab64a6c248e6$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $f2a0fc44203c547a$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $f2a0fc44203c547a$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $f2a0fc44203c547a$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $f2a0fc44203c547a$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $1babab64a6c248e6$export$ebd11618f299a286)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $f2a0fc44203c547a$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $f2a0fc44203c547a$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $f2a0fc44203c547a$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $1babab64a6c248e6$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $f2a0fc44203c547a$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $f2a0fc44203c547a$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $f2a0fc44203c547a$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $f2a0fc44203c547a$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $f2a0fc44203c547a$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $f2a0fc44203c547a$var$garbageCollect(caches, length) {
    (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $f2a0fc44203c547a$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $f2a0fc44203c547a$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.font, fallback);
    const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(options.padding);
    const lines = (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $f2a0fc44203c547a$var$createScaleContext(parent, scale) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $f2a0fc44203c547a$var$createTickContext(parent, index, tick) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $f2a0fc44203c547a$var$titleAlign(align, position, reverse) {
    let ret = (0, $1babab64a6c248e6$export$db202ddc8be9136)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $f2a0fc44203c547a$var$reverseAlign(ret);
    return ret;
}
function $f2a0fc44203c547a$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, left, right);
        if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $f2a0fc44203c547a$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $f2a0fc44203c547a$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, bottom, top);
        rotation = position === "left" ? -(0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd) : (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $f2a0fc44203c547a$export$d60cfc58d3c358b6 extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_userMin, _suggestedMin),
            max: (0, $1babab64a6c248e6$export$ef35774e6d314e91)(_userMax, _suggestedMax),
            minDefined: (0, $1babab64a6c248e6$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $1babab64a6c248e6$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $1babab64a6c248e6$export$ef35774e6d314e91)(min, (0, $1babab64a6c248e6$export$ef35774e6d314e91)(max, min)),
            max: (0, $1babab64a6c248e6$export$ef35774e6d314e91)(max, (0, $1babab64a6c248e6$export$ef35774e6d314e91)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $1babab64a6c248e6$export$96f57966bedc81b4)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $f2a0fc44203c547a$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $f2a0fc44203c547a$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $1babab64a6c248e6$export$e7094788287c5e9b)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $f2a0fc44203c547a$var$getTickMarkLength(options.grid) - tickOpts.padding - $f2a0fc44203c547a$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $1babab64a6c248e6$export$d66501df72047452)(Math.min(Math.asin((0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $f2a0fc44203c547a$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $f2a0fc44203c547a$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $f2a0fc44203c547a$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $f2a0fc44203c547a$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(label) && !(0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(label)) {
                width = (0, $1babab64a6c248e6$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(nestedLabel) && !(0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $1babab64a6c248e6$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $f2a0fc44203c547a$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $1babab64a6c248e6$export$9bb611d729802a56)(this._alignToPixels ? (0, $1babab64a6c248e6$export$b4171a6734a65d42)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $f2a0fc44203c547a$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $f2a0fc44203c547a$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $f2a0fc44203c547a$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $f2a0fc44203c547a$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $f2a0fc44203c547a$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $1babab64a6c248e6$export$b4171a6734a65d42)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $1babab64a6c248e6$export$61196ced6d74a310)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $1babab64a6c248e6$export$a07804094c3ecf2d)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(title.font);
        const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $1babab64a6c248e6$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $f2a0fc44203c547a$var$titleArgs(this, offset, position, align);
        (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $f2a0fc44203c547a$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $f2a0fc44203c547a$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $1babab64a6c248e6$export$c4ce752e73470fba)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $f2a0fc44203c547a$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($f2a0fc44203c547a$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $f2a0fc44203c547a$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $1babab64a6c248e6$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $1babab64a6c248e6$export$4368d992c4eafac0)[scope]) {
            delete (0, $1babab64a6c248e6$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)[id];
        }
    }
}
function $f2a0fc44203c547a$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $1babab64a6c248e6$export$e7c866399fa523f5)(Object.create(null), [
        parentScope ? (0, $1babab64a6c248e6$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $1babab64a6c248e6$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $1babab64a6c248e6$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $f2a0fc44203c547a$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $1babab64a6c248e6$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $f2a0fc44203c547a$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $1babab64a6c248e6$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $f2a0fc44203c547a$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $f2a0fc44203c547a$var$Registry {
    constructor(){
        this.controllers = new $f2a0fc44203c547a$var$TypedRegistry($f2a0fc44203c547a$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $f2a0fc44203c547a$var$TypedRegistry($f2a0fc44203c547a$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $f2a0fc44203c547a$var$TypedRegistry(Object, "plugins");
        this.scales = new $f2a0fc44203c547a$var$TypedRegistry($f2a0fc44203c547a$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $1babab64a6c248e6$export$71cec2538cb2c617)(method);
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $f2a0fc44203c547a$export$4bb7493d241fd8a5 = new $f2a0fc44203c547a$var$Registry();
class $f2a0fc44203c547a$export$b2f2bae6713db87 extends $f2a0fc44203c547a$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $1babab64a6c248e6$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $1babab64a6c248e6$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $f2a0fc44203c547a$export$4bb7493d241fd8a5.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $1babab64a6c248e6$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $1babab64a6c248e6$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$f2a0fc44203c547a$export$b2f2bae6713db87.id = "scatter";
$f2a0fc44203c547a$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
};
$f2a0fc44203c547a$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $f2a0fc44203c547a$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $f2a0fc44203c547a$export$e97d5dc64e999004,
    BubbleController: $f2a0fc44203c547a$export$19b5c4773f17abe,
    DoughnutController: $f2a0fc44203c547a$export$e04603e7d8b77172,
    LineController: $f2a0fc44203c547a$export$3c9b5d28c11cbfd0,
    PolarAreaController: $f2a0fc44203c547a$export$2a270b3a0d973c85,
    PieController: $f2a0fc44203c547a$export$b21a3f1286706191,
    RadarController: $f2a0fc44203c547a$export$48dbc6ac651bf8be,
    ScatterController: $f2a0fc44203c547a$export$b2f2bae6713db87
});
function $f2a0fc44203c547a$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $f2a0fc44203c547a$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $f2a0fc44203c547a$var$abstract();
    }
    parse(value, format) {
        return $f2a0fc44203c547a$var$abstract();
    }
    format(timestamp, format) {
        return $f2a0fc44203c547a$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $f2a0fc44203c547a$var$abstract();
    }
    diff(a, b, unit) {
        return $f2a0fc44203c547a$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $f2a0fc44203c547a$var$abstract();
    }
    endOf(timestamp, unit) {
        return $f2a0fc44203c547a$var$abstract();
    }
}
$f2a0fc44203c547a$var$DateAdapter.override = function(members) {
    Object.assign($f2a0fc44203c547a$var$DateAdapter.prototype, members);
};
var $f2a0fc44203c547a$export$f32766ea09ec8bc4 = {
    _date: $f2a0fc44203c547a$var$DateAdapter
};
function $f2a0fc44203c547a$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $1babab64a6c248e6$export$8743009a87fcb00f) : (0, $1babab64a6c248e6$export$dc98b0b04f4c7758);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $f2a0fc44203c547a$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $f2a0fc44203c547a$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $f2a0fc44203c547a$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $f2a0fc44203c547a$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $1babab64a6c248e6$export$3d8c2f653ac9d0b9)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $f2a0fc44203c547a$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $f2a0fc44203c547a$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $1babab64a6c248e6$export$34aec0b863436764)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $1babab64a6c248e6$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $f2a0fc44203c547a$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $f2a0fc44203c547a$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $f2a0fc44203c547a$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $f2a0fc44203c547a$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $f2a0fc44203c547a$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $f2a0fc44203c547a$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $f2a0fc44203c547a$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $f2a0fc44203c547a$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $f2a0fc44203c547a$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $f2a0fc44203c547a$export$a13296960cae0384 = {
    evaluateInteractionItems: $f2a0fc44203c547a$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $f2a0fc44203c547a$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $f2a0fc44203c547a$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $f2a0fc44203c547a$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $f2a0fc44203c547a$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $f2a0fc44203c547a$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $f2a0fc44203c547a$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            return $f2a0fc44203c547a$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(e, chart);
            return $f2a0fc44203c547a$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $f2a0fc44203c547a$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $f2a0fc44203c547a$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $f2a0fc44203c547a$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$f2a0fc44203c547a$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $f2a0fc44203c547a$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $f2a0fc44203c547a$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $f2a0fc44203c547a$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$f2a0fc44203c547a$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $f2a0fc44203c547a$var$setLayoutDims(layouts, params) {
    const stacks = $f2a0fc44203c547a$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $f2a0fc44203c547a$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $f2a0fc44203c547a$var$wrapBoxes(boxes);
    const fullSize = $f2a0fc44203c547a$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $f2a0fc44203c547a$var$sortByWeight($f2a0fc44203c547a$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $f2a0fc44203c547a$var$sortByWeight($f2a0fc44203c547a$var$filterByPosition(layoutBoxes, "right"));
    const top = $f2a0fc44203c547a$var$sortByWeight($f2a0fc44203c547a$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $f2a0fc44203c547a$var$sortByWeight($f2a0fc44203c547a$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $f2a0fc44203c547a$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $f2a0fc44203c547a$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $f2a0fc44203c547a$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $f2a0fc44203c547a$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $f2a0fc44203c547a$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $f2a0fc44203c547a$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $1babab64a6c248e6$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $f2a0fc44203c547a$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $f2a0fc44203c547a$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $f2a0fc44203c547a$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $f2a0fc44203c547a$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $f2a0fc44203c547a$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $f2a0fc44203c547a$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $f2a0fc44203c547a$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $f2a0fc44203c547a$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $f2a0fc44203c547a$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $f2a0fc44203c547a$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $f2a0fc44203c547a$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $1babab64a6c248e6$export$35e795649ee09318)(stack.start)) y = stack.start;
            if (box.fullSize) $f2a0fc44203c547a$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $f2a0fc44203c547a$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $1babab64a6c248e6$export$35e795649ee09318)(stack.start)) x = stack.start;
            if (box.fullSize) $f2a0fc44203c547a$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $f2a0fc44203c547a$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $1babab64a6c248e6$export$4368d992c4eafac0).set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $f2a0fc44203c547a$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $f2a0fc44203c547a$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $f2a0fc44203c547a$var$updateMaxPadding(maxPadding, (0, $1babab64a6c248e6$export$3466f893ebf79586)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $f2a0fc44203c547a$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $f2a0fc44203c547a$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $f2a0fc44203c547a$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($f2a0fc44203c547a$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $f2a0fc44203c547a$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $f2a0fc44203c547a$var$handleMaxPadding(chartArea);
        $f2a0fc44203c547a$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $f2a0fc44203c547a$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $f2a0fc44203c547a$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $f2a0fc44203c547a$export$a40a96b24b46cf35 extends $f2a0fc44203c547a$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $f2a0fc44203c547a$var$EXPANDO_KEY = "$chartjs";
const $f2a0fc44203c547a$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $f2a0fc44203c547a$var$isNullOrEmpty = (value)=>value === null || value === "";
function $f2a0fc44203c547a$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$f2a0fc44203c547a$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($f2a0fc44203c547a$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $1babab64a6c248e6$export$6559d589eb85fbb6)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($f2a0fc44203c547a$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $1babab64a6c248e6$export$6559d589eb85fbb6)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $f2a0fc44203c547a$var$eventListenerOptions = (0, $1babab64a6c248e6$export$a8550f7dbe79f93a) ? {
    passive: true
} : false;
function $f2a0fc44203c547a$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $f2a0fc44203c547a$var$eventListenerOptions);
}
function $f2a0fc44203c547a$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $f2a0fc44203c547a$var$eventListenerOptions);
}
function $f2a0fc44203c547a$var$fromNativeEvent(event, chart) {
    const type = $f2a0fc44203c547a$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $1babab64a6c248e6$export$78acf4525d8a74c4)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $f2a0fc44203c547a$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $f2a0fc44203c547a$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $f2a0fc44203c547a$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$f2a0fc44203c547a$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $f2a0fc44203c547a$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $f2a0fc44203c547a$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$f2a0fc44203c547a$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $f2a0fc44203c547a$var$drpListeningCharts = new Map();
let $f2a0fc44203c547a$var$oldDevicePixelRatio = 0;
function $f2a0fc44203c547a$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $f2a0fc44203c547a$var$oldDevicePixelRatio) return;
    $f2a0fc44203c547a$var$oldDevicePixelRatio = dpr;
    $f2a0fc44203c547a$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $f2a0fc44203c547a$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$f2a0fc44203c547a$var$drpListeningCharts.size) window.addEventListener("resize", $f2a0fc44203c547a$var$onWindowResize);
    $f2a0fc44203c547a$var$drpListeningCharts.set(chart, resize);
}
function $f2a0fc44203c547a$var$unlistenDevicePixelRatioChanges(chart) {
    $f2a0fc44203c547a$var$drpListeningCharts.delete(chart);
    if (!$f2a0fc44203c547a$var$drpListeningCharts.size) window.removeEventListener("resize", $f2a0fc44203c547a$var$onWindowResize);
}
function $f2a0fc44203c547a$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $1babab64a6c248e6$export$ce26c07117d59d6a)(canvas);
    if (!container) return;
    const resize = (0, $1babab64a6c248e6$export$efca4cbe5dd06740)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $f2a0fc44203c547a$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $f2a0fc44203c547a$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $f2a0fc44203c547a$var$unlistenDevicePixelRatioChanges(chart);
}
function $f2a0fc44203c547a$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $1babab64a6c248e6$export$efca4cbe5dd06740)((event)=>{
        if (chart.ctx !== null) listener($f2a0fc44203c547a$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $f2a0fc44203c547a$var$addListener(canvas, type, proxy);
    return proxy;
}
class $f2a0fc44203c547a$export$f02da7f882cf6b2e extends $f2a0fc44203c547a$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $f2a0fc44203c547a$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$f2a0fc44203c547a$var$EXPANDO_KEY]) return false;
        const initial = canvas[$f2a0fc44203c547a$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$f2a0fc44203c547a$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $f2a0fc44203c547a$var$createAttachObserver,
            detach: $f2a0fc44203c547a$var$createDetachObserver,
            resize: $f2a0fc44203c547a$var$createResizeObserver
        };
        const handler = handlers[type] || $f2a0fc44203c547a$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $f2a0fc44203c547a$var$releaseObserver,
            detach: $f2a0fc44203c547a$var$releaseObserver,
            resize: $f2a0fc44203c547a$var$releaseObserver
        };
        const handler = handlers[type] || $f2a0fc44203c547a$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $1babab64a6c248e6$export$3c2fa207a37baaea)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $1babab64a6c248e6$export$ce26c07117d59d6a)(canvas);
        return !!(container && container.isConnected);
    }
}
function $f2a0fc44203c547a$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $1babab64a6c248e6$export$2e2af4578d910ddf)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $f2a0fc44203c547a$export$a40a96b24b46cf35;
    return $f2a0fc44203c547a$export$f02da7f882cf6b2e;
}
class $f2a0fc44203c547a$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $1babab64a6c248e6$export$e7094788287c5e9b)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $f2a0fc44203c547a$var$allPlugins(config);
        return options === false && !all ? [] : $f2a0fc44203c547a$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $f2a0fc44203c547a$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($f2a0fc44203c547a$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($f2a0fc44203c547a$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $f2a0fc44203c547a$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $f2a0fc44203c547a$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $f2a0fc44203c547a$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $f2a0fc44203c547a$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $f2a0fc44203c547a$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $f2a0fc44203c547a$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $1babab64a6c248e6$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $f2a0fc44203c547a$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $f2a0fc44203c547a$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $f2a0fc44203c547a$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $f2a0fc44203c547a$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $f2a0fc44203c547a$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $f2a0fc44203c547a$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $f2a0fc44203c547a$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $1babab64a6c248e6$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $f2a0fc44203c547a$var$determineAxis(id, scaleConf);
        const defaultId = $f2a0fc44203c547a$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $1babab64a6c248e6$export$2219238a014317b0)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $f2a0fc44203c547a$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $f2a0fc44203c547a$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $1babab64a6c248e6$export$2219238a014317b0)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $1babab64a6c248e6$export$2219238a014317b0)(scale, [
            (0, $1babab64a6c248e6$export$4368d992c4eafac0).scales[scale.type],
            (0, $1babab64a6c248e6$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $f2a0fc44203c547a$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $f2a0fc44203c547a$var$mergeScaleConfig(config, options);
}
function $f2a0fc44203c547a$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $f2a0fc44203c547a$var$initConfig(config) {
    config = config || {};
    config.data = $f2a0fc44203c547a$var$initData(config.data);
    $f2a0fc44203c547a$var$initOptions(config);
    return config;
}
const $f2a0fc44203c547a$var$keyCache = new Map();
const $f2a0fc44203c547a$var$keysCached = new Set();
function $f2a0fc44203c547a$var$cachedKeys(cacheKey, generate) {
    let keys = $f2a0fc44203c547a$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $f2a0fc44203c547a$var$keyCache.set(cacheKey, keys);
        $f2a0fc44203c547a$var$keysCached.add(keys);
    }
    return keys;
}
const $f2a0fc44203c547a$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $1babab64a6c248e6$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $f2a0fc44203c547a$var$Config {
    constructor(config){
        this._config = $f2a0fc44203c547a$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $f2a0fc44203c547a$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $f2a0fc44203c547a$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $f2a0fc44203c547a$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $f2a0fc44203c547a$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $f2a0fc44203c547a$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $f2a0fc44203c547a$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$f2a0fc44203c547a$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$f2a0fc44203c547a$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$f2a0fc44203c547a$var$addIfFound(scopes, (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)[type] || {}, key));
            keys.forEach((key)=>$f2a0fc44203c547a$var$addIfFound(scopes, (0, $1babab64a6c248e6$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$f2a0fc44203c547a$var$addIfFound(scopes, (0, $1babab64a6c248e6$export$a93c5207d687da10), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($f2a0fc44203c547a$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)[type] || {},
            (0, $1babab64a6c248e6$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $1babab64a6c248e6$export$4368d992c4eafac0),
            (0, $1babab64a6c248e6$export$a93c5207d687da10)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $f2a0fc44203c547a$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($f2a0fc44203c547a$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $1babab64a6c248e6$export$c3950d9923825c02)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $1babab64a6c248e6$export$a9c996f45e5784d0)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $f2a0fc44203c547a$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $1babab64a6c248e6$export$23f2a1d2818174ef)(context) ? (0, $1babab64a6c248e6$export$a9c996f45e5784d0)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $f2a0fc44203c547a$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $1babab64a6c248e6$export$7910e0436ed8d1de)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $f2a0fc44203c547a$var$hasFunction = (value)=>(0, $1babab64a6c248e6$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $1babab64a6c248e6$export$c3950d9923825c02)(value[key]), false);
function $f2a0fc44203c547a$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $1babab64a6c248e6$export$555508cbc6add439)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $1babab64a6c248e6$export$c3950d9923825c02)(value) || $f2a0fc44203c547a$var$hasFunction(value)) || indexable && (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $f2a0fc44203c547a$var$version = "3.9.1";
const $f2a0fc44203c547a$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $f2a0fc44203c547a$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $f2a0fc44203c547a$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $f2a0fc44203c547a$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $f2a0fc44203c547a$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $1babab64a6c248e6$export$e7094788287c5e9b)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $f2a0fc44203c547a$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $1babab64a6c248e6$export$e7094788287c5e9b)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $f2a0fc44203c547a$var$getCanvas(item) {
    if ((0, $1babab64a6c248e6$export$2e2af4578d910ddf)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $f2a0fc44203c547a$var$instances = {};
const $f2a0fc44203c547a$var$getChart = (key)=>{
    const canvas = $f2a0fc44203c547a$var$getCanvas(key);
    return Object.values($f2a0fc44203c547a$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $f2a0fc44203c547a$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $f2a0fc44203c547a$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $f2a0fc44203c547a$export$acaa6426d77a227e {
    constructor(item, userConfig){
        const config = this.config = new $f2a0fc44203c547a$var$Config(userConfig);
        const initialCanvas = $f2a0fc44203c547a$var$getCanvas(item);
        const existingChart = $f2a0fc44203c547a$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $f2a0fc44203c547a$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $1babab64a6c248e6$export$4c3d22f3d993c33f)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $f2a0fc44203c547a$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $1babab64a6c248e6$export$f787f51d84a910ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $f2a0fc44203c547a$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $f2a0fc44203c547a$export$a424a0aa8f687495.listen(this, "complete", $f2a0fc44203c547a$var$onAnimationsComplete);
        $f2a0fc44203c547a$export$a424a0aa8f687495.listen(this, "progress", $f2a0fc44203c547a$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $1babab64a6c248e6$export$c9170ad7d4cd7e57)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $1babab64a6c248e6$export$ee7c8ad385a60b7b)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $f2a0fc44203c547a$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$f2a0fc44203c547a$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $1babab64a6c248e6$export$c9170ad7d4cd7e57)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $1babab64a6c248e6$export$e7094788287c5e9b)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $f2a0fc44203c547a$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $f2a0fc44203c547a$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $f2a0fc44203c547a$var$positionIsHorizontal(scaleOptions.position, axis) !== $f2a0fc44203c547a$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $f2a0fc44203c547a$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(scales, (scale)=>{
            $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $f2a0fc44203c547a$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($f2a0fc44203c547a$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $f2a0fc44203c547a$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $f2a0fc44203c547a$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $1babab64a6c248e6$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $f2a0fc44203c547a$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $f2a0fc44203c547a$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($f2a0fc44203c547a$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.scales, (scale)=>{
            $f2a0fc44203c547a$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $1babab64a6c248e6$export$995eb9fca571757)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $f2a0fc44203c547a$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $1babab64a6c248e6$export$995eb9fca571757)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $1babab64a6c248e6$export$c3950d9923825c02)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($f2a0fc44203c547a$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$f2a0fc44203c547a$export$a424a0aa8f687495.running(this)) $f2a0fc44203c547a$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $f2a0fc44203c547a$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $1babab64a6c248e6$export$61196ced6d74a310)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $1babab64a6c248e6$export$a07804094c3ecf2d)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $1babab64a6c248e6$export$3d8c2f653ac9d0b9)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $f2a0fc44203c547a$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $1babab64a6c248e6$export$35e795649ee09318)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $f2a0fc44203c547a$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $1babab64a6c248e6$export$ee7c8ad385a60b7b)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $f2a0fc44203c547a$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $1babab64a6c248e6$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $1babab64a6c248e6$export$3b513254972cfc9c)(e);
        const lastEvent = $f2a0fc44203c547a$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $1babab64a6c248e6$export$e7094788287c5e9b)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $1babab64a6c248e6$export$e7094788287c5e9b)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $1babab64a6c248e6$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
const $f2a0fc44203c547a$var$invalidatePlugins = ()=>(0, $1babab64a6c248e6$export$3722cfe417b6ed86)($f2a0fc44203c547a$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $f2a0fc44203c547a$var$enumerable = true;
Object.defineProperties($f2a0fc44203c547a$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: (0, $1babab64a6c248e6$export$4368d992c4eafac0)
    },
    instances: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: $f2a0fc44203c547a$var$instances
    },
    overrides: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: (0, $1babab64a6c248e6$export$3a6d5c9ae78a2c08)
    },
    registry: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: $f2a0fc44203c547a$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: $f2a0fc44203c547a$var$version
    },
    getChart: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: $f2a0fc44203c547a$var$getChart
    },
    register: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: (...items)=>{
            $f2a0fc44203c547a$export$4bb7493d241fd8a5.add(...items);
            $f2a0fc44203c547a$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $f2a0fc44203c547a$var$enumerable,
        value: (...items)=>{
            $f2a0fc44203c547a$export$4bb7493d241fd8a5.remove(...items);
            $f2a0fc44203c547a$var$invalidatePlugins();
        }
    }
});
function $f2a0fc44203c547a$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd), startAngle - (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $f2a0fc44203c547a$var$toRadiusCorners(value) {
    return (0, $1babab64a6c248e6$export$ab83b03e4111b1d0)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $f2a0fc44203c547a$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $f2a0fc44203c547a$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(o.innerEnd, 0, innerLimit)
    };
}
function $f2a0fc44203c547a$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $f2a0fc44203c547a$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $1babab64a6c248e6$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $f2a0fc44203c547a$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $f2a0fc44203c547a$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd));
        }
        const p4 = $f2a0fc44203c547a$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $f2a0fc44203c547a$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $f2a0fc44203c547a$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd));
        }
        const p8 = $f2a0fc44203c547a$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $f2a0fc44203c547a$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $f2a0fc44203c547a$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $f2a0fc44203c547a$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $1babab64a6c248e6$export$971d5caa766a69d7), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $1babab64a6c248e6$export$971d5caa766a69d7);
            if (circumference % (0, $1babab64a6c248e6$export$971d5caa766a69d7) === 0) endAngle += (0, $1babab64a6c248e6$export$971d5caa766a69d7);
        }
    }
    $f2a0fc44203c547a$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $f2a0fc44203c547a$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $f2a0fc44203c547a$var$clipArc(ctx, element, startAngle + (0, $1babab64a6c248e6$export$971d5caa766a69d7));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $1babab64a6c248e6$export$971d5caa766a69d7), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $1babab64a6c248e6$export$971d5caa766a69d7));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $f2a0fc44203c547a$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element.fullCircles) $f2a0fc44203c547a$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $f2a0fc44203c547a$var$clipArc(ctx, element, endAngle);
    $f2a0fc44203c547a$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $f2a0fc44203c547a$export$d48203c759d6a1fc extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $1babab64a6c248e6$export$34aec0b863436764)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $1babab64a6c248e6$export$971d5caa766a69d7) || (0, $1babab64a6c248e6$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $1babab64a6c248e6$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $1babab64a6c248e6$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $1babab64a6c248e6$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $1babab64a6c248e6$export$56c0d5a1e737357d)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $f2a0fc44203c547a$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $f2a0fc44203c547a$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$f2a0fc44203c547a$export$d48203c759d6a1fc.id = "arc";
$f2a0fc44203c547a$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$f2a0fc44203c547a$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $f2a0fc44203c547a$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $f2a0fc44203c547a$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $f2a0fc44203c547a$var$getLineMethod(options) {
    if (options.stepped) return 0, $1babab64a6c248e6$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $1babab64a6c248e6$export$493d36ec626b6698;
    return $f2a0fc44203c547a$var$lineTo;
}
function $f2a0fc44203c547a$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $f2a0fc44203c547a$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $f2a0fc44203c547a$var$pathVars(points, segment, params);
    const lineMethod = $f2a0fc44203c547a$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $f2a0fc44203c547a$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $f2a0fc44203c547a$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $f2a0fc44203c547a$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $f2a0fc44203c547a$var$fastPathSegment : $f2a0fc44203c547a$var$pathSegment;
}
function $f2a0fc44203c547a$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $1babab64a6c248e6$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $1babab64a6c248e6$export$8a5498727ef6be21;
    return 0, $1babab64a6c248e6$export$d24c54395ce0c509;
}
function $f2a0fc44203c547a$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $f2a0fc44203c547a$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $f2a0fc44203c547a$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $f2a0fc44203c547a$var$_getSegmentMethod(line);
    for (const segment of segments){
        $f2a0fc44203c547a$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $f2a0fc44203c547a$var$usePath2D = typeof Path2D === "function";
function $f2a0fc44203c547a$var$draw(ctx, line, start, count) {
    if ($f2a0fc44203c547a$var$usePath2D && !line.options.segment) $f2a0fc44203c547a$var$strokePathWithCache(ctx, line, start, count);
    else $f2a0fc44203c547a$var$strokePathDirect(ctx, line, start, count);
}
class $f2a0fc44203c547a$export$55e463fa7bcd3469 extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $1babab64a6c248e6$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $1babab64a6c248e6$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $1babab64a6c248e6$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $f2a0fc44203c547a$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $f2a0fc44203c547a$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $f2a0fc44203c547a$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $f2a0fc44203c547a$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
$f2a0fc44203c547a$export$55e463fa7bcd3469.id = "line";
$f2a0fc44203c547a$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$f2a0fc44203c547a$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$f2a0fc44203c547a$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $f2a0fc44203c547a$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $f2a0fc44203c547a$export$bd159b522b230b7a extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $f2a0fc44203c547a$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $f2a0fc44203c547a$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $1babab64a6c248e6$export$3d8c2f653ac9d0b9)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $1babab64a6c248e6$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$f2a0fc44203c547a$export$bd159b522b230b7a.id = "point";
$f2a0fc44203c547a$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$f2a0fc44203c547a$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $f2a0fc44203c547a$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $f2a0fc44203c547a$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(value, min, max);
}
function $f2a0fc44203c547a$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $1babab64a6c248e6$export$92108d983e8ee699)(value);
    return {
        t: $f2a0fc44203c547a$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $f2a0fc44203c547a$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $f2a0fc44203c547a$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $f2a0fc44203c547a$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $f2a0fc44203c547a$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $1babab64a6c248e6$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $f2a0fc44203c547a$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $f2a0fc44203c547a$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $f2a0fc44203c547a$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $f2a0fc44203c547a$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $f2a0fc44203c547a$var$boundingRects(bar) {
    const bounds = $f2a0fc44203c547a$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $f2a0fc44203c547a$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $f2a0fc44203c547a$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $f2a0fc44203c547a$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $f2a0fc44203c547a$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $1babab64a6c248e6$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $1babab64a6c248e6$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $f2a0fc44203c547a$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $f2a0fc44203c547a$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $f2a0fc44203c547a$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $f2a0fc44203c547a$export$a16ed71bf4b07672 extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $f2a0fc44203c547a$var$boundingRects(this);
        const addRectPath = $f2a0fc44203c547a$var$hasRadius(outer.radius) ? (0, $1babab64a6c248e6$export$d66dc83d8cfc8dd) : $f2a0fc44203c547a$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $f2a0fc44203c547a$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $f2a0fc44203c547a$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $f2a0fc44203c547a$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $f2a0fc44203c547a$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $f2a0fc44203c547a$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $f2a0fc44203c547a$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$f2a0fc44203c547a$export$a16ed71bf4b07672.id = "bar";
$f2a0fc44203c547a$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
};
$f2a0fc44203c547a$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $f2a0fc44203c547a$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $f2a0fc44203c547a$export$d48203c759d6a1fc,
    LineElement: $f2a0fc44203c547a$export$55e463fa7bcd3469,
    PointElement: $f2a0fc44203c547a$export$bd159b522b230b7a,
    BarElement: $f2a0fc44203c547a$export$a16ed71bf4b07672
});
function $f2a0fc44203c547a$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $f2a0fc44203c547a$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(minIndex) && !(0, $1babab64a6c248e6$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $f2a0fc44203c547a$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $f2a0fc44203c547a$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $f2a0fc44203c547a$var$cleanDecimatedDataset(dataset);
    });
}
function $f2a0fc44203c547a$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)((0, $1babab64a6c248e6$export$dc98b0b04f4c7758)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)((0, $1babab64a6c248e6$export$dc98b0b04f4c7758)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $f2a0fc44203c547a$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $f2a0fc44203c547a$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $1babab64a6c248e6$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $f2a0fc44203c547a$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $f2a0fc44203c547a$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $f2a0fc44203c547a$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $f2a0fc44203c547a$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $f2a0fc44203c547a$var$cleanDecimatedData(chart);
    }
};
function $f2a0fc44203c547a$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $f2a0fc44203c547a$var$_findSegmentEnd(start, end, points);
        const bounds = $f2a0fc44203c547a$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $1babab64a6c248e6$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $f2a0fc44203c547a$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $1babab64a6c248e6$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $f2a0fc44203c547a$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $f2a0fc44203c547a$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $f2a0fc44203c547a$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $1babab64a6c248e6$export$3d12bd131bb975d1)(start);
        end = (0, $1babab64a6c248e6$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $f2a0fc44203c547a$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $f2a0fc44203c547a$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $f2a0fc44203c547a$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $f2a0fc44203c547a$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $f2a0fc44203c547a$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $f2a0fc44203c547a$var$_pointsFromSegments(boundary, line);
    return points.length ? new $f2a0fc44203c547a$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $f2a0fc44203c547a$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $f2a0fc44203c547a$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $1babab64a6c248e6$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $f2a0fc44203c547a$var$_decodeFill(line, index, count) {
    const fill = $f2a0fc44203c547a$var$parseFillOption(line);
    if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $1babab64a6c248e6$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $f2a0fc44203c547a$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $f2a0fc44203c547a$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $f2a0fc44203c547a$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $f2a0fc44203c547a$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $1babab64a6c248e6$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $f2a0fc44203c547a$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $f2a0fc44203c547a$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $f2a0fc44203c547a$var$getLinesBelow(scale, index);
    linesBelow.push($f2a0fc44203c547a$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$f2a0fc44203c547a$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $f2a0fc44203c547a$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $f2a0fc44203c547a$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $f2a0fc44203c547a$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $f2a0fc44203c547a$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $f2a0fc44203c547a$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $1babab64a6c248e6$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $f2a0fc44203c547a$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $1babab64a6c248e6$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $f2a0fc44203c547a$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $1babab64a6c248e6$export$39b482c5e57630a8)(fill)) return $f2a0fc44203c547a$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $f2a0fc44203c547a$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $f2a0fc44203c547a$var$computeBoundary(source);
    if (boundary instanceof $f2a0fc44203c547a$var$simpleArc) return boundary;
    return $f2a0fc44203c547a$var$_createBoundaryLine(boundary, line);
}
function $f2a0fc44203c547a$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $f2a0fc44203c547a$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $f2a0fc44203c547a$var$computeCircularBoundary(source);
    return $f2a0fc44203c547a$var$computeLinearBoundary(source);
}
function $f2a0fc44203c547a$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $f2a0fc44203c547a$var$_getTargetPixel(fill, scale);
    if ((0, $1babab64a6c248e6$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $f2a0fc44203c547a$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $f2a0fc44203c547a$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $f2a0fc44203c547a$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $f2a0fc44203c547a$var$_drawfill(ctx, source, area) {
    const target = $f2a0fc44203c547a$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $1babab64a6c248e6$export$61196ced6d74a310)(ctx, area);
        $f2a0fc44203c547a$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $1babab64a6c248e6$export$a07804094c3ecf2d)(ctx);
    }
}
function $f2a0fc44203c547a$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $f2a0fc44203c547a$var$clipVertical(ctx, target, area.top);
        $f2a0fc44203c547a$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $f2a0fc44203c547a$var$clipVertical(ctx, target, area.bottom);
    }
    $f2a0fc44203c547a$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $f2a0fc44203c547a$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$f2a0fc44203c547a$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $f2a0fc44203c547a$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $f2a0fc44203c547a$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $f2a0fc44203c547a$var$clipBounds(ctx, scale, notShape && $f2a0fc44203c547a$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $f2a0fc44203c547a$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $f2a0fc44203c547a$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $f2a0fc44203c547a$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $f2a0fc44203c547a$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $f2a0fc44203c547a$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $f2a0fc44203c547a$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $f2a0fc44203c547a$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $f2a0fc44203c547a$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $f2a0fc44203c547a$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($f2a0fc44203c547a$var$_shouldApplyFill(source)) $f2a0fc44203c547a$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$f2a0fc44203c547a$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $f2a0fc44203c547a$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $f2a0fc44203c547a$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $f2a0fc44203c547a$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $f2a0fc44203c547a$var$Legend extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $1babab64a6c248e6$export$e7094788287c5e9b)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $f2a0fc44203c547a$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $1babab64a6c248e6$export$61196ced6d74a310)(ctx, this);
            this._draw();
            (0, $1babab64a6c248e6$export$a07804094c3ecf2d)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $1babab64a6c248e6$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $f2a0fc44203c547a$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $1babab64a6c248e6$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $1babab64a6c248e6$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $1babab64a6c248e6$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $1babab64a6c248e6$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $1babab64a6c248e6$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $1babab64a6c248e6$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $1babab64a6c248e6$export$25ce5a424b770e84)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $1babab64a6c248e6$export$db202ddc8be9136)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $1babab64a6c248e6$export$21579262ef46735b)(x, this.left, this.right) && (0, $1babab64a6c248e6$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $1babab64a6c248e6$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $1babab64a6c248e6$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$f2a0fc44203c547a$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $f2a0fc44203c547a$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $1babab64a6c248e6$export$e7094788287c5e9b)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $1babab64a6c248e6$export$e7094788287c5e9b)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $1babab64a6c248e6$export$e7094788287c5e9b)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $f2a0fc44203c547a$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $f2a0fc44203c547a$export$ed247974535929c7 = {
    id: "legend",
    _element: $f2a0fc44203c547a$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $f2a0fc44203c547a$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $1babab64a6c248e6$export$3466f893ebf79586)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $f2a0fc44203c547a$var$Title extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(opts.padding);
        const textSize = lineCount * (0, $1babab64a6c248e6$export$c4ce752e73470fba)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, bottom, top);
                rotation = (0, $1babab64a6c248e6$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $1babab64a6c248e6$export$25ce5a424b770e84)(align, top, bottom);
                rotation = (0, $1babab64a6c248e6$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $1babab64a6c248e6$export$db202ddc8be9136)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $f2a0fc44203c547a$var$createTitle(chart, titleOpts) {
    const title = new $f2a0fc44203c547a$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $f2a0fc44203c547a$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $f2a0fc44203c547a$export$f99233281efd08a0 = {
    id: "title",
    _element: $f2a0fc44203c547a$var$Title,
    start (chart, _args, options) {
        $f2a0fc44203c547a$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $f2a0fc44203c547a$var$map = new WeakMap();
var $f2a0fc44203c547a$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $f2a0fc44203c547a$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, title, options);
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.addBox(chart, title);
        $f2a0fc44203c547a$var$map.set(chart, title);
    },
    stop (chart) {
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.removeBox(chart, $f2a0fc44203c547a$var$map.get(chart));
        $f2a0fc44203c547a$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $f2a0fc44203c547a$var$map.get(chart);
        $f2a0fc44203c547a$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $f2a0fc44203c547a$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $1babab64a6c248e6$export$53a70dd1ebbae346)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $f2a0fc44203c547a$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $f2a0fc44203c547a$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $f2a0fc44203c547a$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $f2a0fc44203c547a$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.bodyFont);
    const titleFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.titleFont);
    const footerFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(body, (bodyItem)=>{
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(bodyItem.before, maxLineWidth);
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(bodyItem.lines, maxLineWidth);
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $f2a0fc44203c547a$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $f2a0fc44203c547a$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $f2a0fc44203c547a$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($f2a0fc44203c547a$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $f2a0fc44203c547a$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $f2a0fc44203c547a$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $f2a0fc44203c547a$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $f2a0fc44203c547a$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $f2a0fc44203c547a$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $f2a0fc44203c547a$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $f2a0fc44203c547a$var$alignX(size, xAlign);
    const y = $f2a0fc44203c547a$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(x, 0, chart.width - size.width),
        y: (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(y, 0, chart.height - size.height)
    };
}
function $f2a0fc44203c547a$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $f2a0fc44203c547a$var$getBeforeAfterBodyLines(callback) {
    return $f2a0fc44203c547a$var$pushOrConcat([], $f2a0fc44203c547a$var$splitNewlines(callback));
}
function $f2a0fc44203c547a$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $f2a0fc44203c547a$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $f2a0fc44203c547a$var$Tooltip extends $f2a0fc44203c547a$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $f2a0fc44203c547a$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $f2a0fc44203c547a$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(beforeTitle));
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(title));
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $f2a0fc44203c547a$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $f2a0fc44203c547a$var$overrideCallbacks(callbacks, context);
            $f2a0fc44203c547a$var$pushOrConcat(bodyItem.before, $f2a0fc44203c547a$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $f2a0fc44203c547a$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $f2a0fc44203c547a$var$pushOrConcat(bodyItem.after, $f2a0fc44203c547a$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $f2a0fc44203c547a$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(beforeFooter));
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(footer));
        lines = $f2a0fc44203c547a$var$pushOrConcat(lines, $f2a0fc44203c547a$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($f2a0fc44203c547a$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const scoped = $f2a0fc44203c547a$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $f2a0fc44203c547a$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $f2a0fc44203c547a$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $f2a0fc44203c547a$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $f2a0fc44203c547a$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $f2a0fc44203c547a$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.bodyFont);
        const colorX = $f2a0fc44203c547a$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $1babab64a6c248e6$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $1babab64a6c248e6$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $1babab64a6c248e6$export$23f2a1d2818174ef)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $1babab64a6c248e6$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $1babab64a6c248e6$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $f2a0fc44203c547a$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $1babab64a6c248e6$export$3722cfe417b6ed86)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $1babab64a6c248e6$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $f2a0fc44203c547a$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $f2a0fc44203c547a$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $f2a0fc44203c547a$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $f2a0fc44203c547a$var$determineAlignment(chart, options, positionAndSize);
            const point = $f2a0fc44203c547a$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $1babab64a6c248e6$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $1babab64a6c248e6$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $1babab64a6c248e6$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $1babab64a6c248e6$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $f2a0fc44203c547a$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$f2a0fc44203c547a$var$Tooltip.positioners = $f2a0fc44203c547a$var$positioners;
var $f2a0fc44203c547a$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $f2a0fc44203c547a$var$Tooltip,
    positioners: $f2a0fc44203c547a$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $f2a0fc44203c547a$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            beforeBody: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            beforeLabel: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            afterBody: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            beforeFooter: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            footer: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46),
            afterFooter: (0, $1babab64a6c248e6$export$cf2f7c5792f80b46)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $f2a0fc44203c547a$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $f2a0fc44203c547a$export$be17f937e9aa7533,
    Filler: $f2a0fc44203c547a$export$d19ba4d812bed757,
    Legend: $f2a0fc44203c547a$export$ed247974535929c7,
    SubTitle: $f2a0fc44203c547a$export$d5c56664638992a4,
    Title: $f2a0fc44203c547a$export$f99233281efd08a0,
    Tooltip: $f2a0fc44203c547a$export$28c660c63b792dea
});
const $f2a0fc44203c547a$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $f2a0fc44203c547a$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $f2a0fc44203c547a$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $f2a0fc44203c547a$var$validIndex = (index, max)=>index === null ? null : (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(Math.round(index), 0, max);
class $f2a0fc44203c547a$export$29e663ba4d09fe7 extends $f2a0fc44203c547a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $f2a0fc44203c547a$var$findOrAddLabel(labels, raw, (0, $1babab64a6c248e6$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $f2a0fc44203c547a$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$f2a0fc44203c547a$export$29e663ba4d09fe7.id = "category";
$f2a0fc44203c547a$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $f2a0fc44203c547a$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $f2a0fc44203c547a$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $1babab64a6c248e6$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $1babab64a6c248e6$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $1babab64a6c248e6$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $1babab64a6c248e6$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $1babab64a6c248e6$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $1babab64a6c248e6$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $1babab64a6c248e6$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $1babab64a6c248e6$export$91477dc880baac21)(spacing), (0, $1babab64a6c248e6$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $1babab64a6c248e6$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $1babab64a6c248e6$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $f2a0fc44203c547a$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $1babab64a6c248e6$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $f2a0fc44203c547a$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $f2a0fc44203c547a$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $1babab64a6c248e6$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $f2a0fc44203c547a$var$LinearScaleBase extends $f2a0fc44203c547a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $1babab64a6c248e6$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $f2a0fc44203c547a$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $1babab64a6c248e6$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $1babab64a6c248e6$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $f2a0fc44203c547a$export$e7f4e5e8656f0b93 extends $f2a0fc44203c547a$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$f2a0fc44203c547a$export$e7f4e5e8656f0b93.id = "linear";
$f2a0fc44203c547a$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $f2a0fc44203c547a$export$27c7467594ef87bd.formatters.numeric
    }
};
function $f2a0fc44203c547a$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(tickVal)));
    return remain === 1;
}
function $f2a0fc44203c547a$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(generationOptions.min, Math.pow(10, Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(dataRange.min))));
    let exp = Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $f2a0fc44203c547a$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $1babab64a6c248e6$export$ef35774e6d314e91)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $f2a0fc44203c547a$var$isMajor(tickVal)
    });
    return ticks;
}
class $f2a0fc44203c547a$export$85295eaf7cb3ac3e extends $f2a0fc44203c547a$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $f2a0fc44203c547a$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $1babab64a6c248e6$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $1babab64a6c248e6$export$df995fae86a55f06)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $f2a0fc44203c547a$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $1babab64a6c248e6$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $1babab64a6c248e6$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $1babab64a6c248e6$export$df995fae86a55f06)(start);
        this._valueRange = (0, $1babab64a6c248e6$export$df995fae86a55f06)(this.max) - (0, $1babab64a6c248e6$export$df995fae86a55f06)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $1babab64a6c248e6$export$df995fae86a55f06)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$f2a0fc44203c547a$export$85295eaf7cb3ac3e.id = "logarithmic";
$f2a0fc44203c547a$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $f2a0fc44203c547a$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $f2a0fc44203c547a$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(tickOpts.backdropPadding);
        return (0, $1babab64a6c248e6$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $1babab64a6c248e6$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $f2a0fc44203c547a$var$measureLabelSize(ctx, font, label) {
    label = (0, $1babab64a6c248e6$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $1babab64a6c248e6$export$9f4f30ee63539e24)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $f2a0fc44203c547a$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $f2a0fc44203c547a$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $1babab64a6c248e6$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(opts.font);
        const textSize = $f2a0fc44203c547a$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $1babab64a6c248e6$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $1babab64a6c248e6$export$d66501df72047452)(angleRadians));
        const hLimits = $f2a0fc44203c547a$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $f2a0fc44203c547a$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $f2a0fc44203c547a$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $f2a0fc44203c547a$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $f2a0fc44203c547a$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $f2a0fc44203c547a$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $f2a0fc44203c547a$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $1babab64a6c248e6$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $1babab64a6c248e6$export$d66501df72047452)((0, $1babab64a6c248e6$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd))));
        const size = labelSizes[i];
        const y = $f2a0fc44203c547a$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $f2a0fc44203c547a$var$getTextAlignForAngle(angle);
        const left = $f2a0fc44203c547a$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $f2a0fc44203c547a$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $f2a0fc44203c547a$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $f2a0fc44203c547a$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $f2a0fc44203c547a$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $1babab64a6c248e6$export$342063e11d6c3cad)(backdropColor)) {
            const borderRadius = (0, $1babab64a6c248e6$export$9fa96a7d116ea3ce)(optsAtIndex.borderRadius);
            const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $1babab64a6c248e6$export$d66dc83d8cfc8dd)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $f2a0fc44203c547a$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $1babab64a6c248e6$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $f2a0fc44203c547a$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $f2a0fc44203c547a$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $f2a0fc44203c547a$var$createPointLabelContext(parent, index, label) {
    return (0, $1babab64a6c248e6$export$dda1d9f60106f0e9)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $f2a0fc44203c547a$export$cfafc36d95386d38 extends $f2a0fc44203c547a$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)($f2a0fc44203c547a$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $f2a0fc44203c547a$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $f2a0fc44203c547a$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $1babab64a6c248e6$export$e7094788287c5e9b)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $f2a0fc44203c547a$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $1babab64a6c248e6$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $1babab64a6c248e6$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $1babab64a6c248e6$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $f2a0fc44203c547a$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $1babab64a6c248e6$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $f2a0fc44203c547a$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $f2a0fc44203c547a$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $f2a0fc44203c547a$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $1babab64a6c248e6$export$c4ce752e73470fba)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $1babab64a6c248e6$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $1babab64a6c248e6$export$3a1a48c8f6ef640e)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$f2a0fc44203c547a$export$cfafc36d95386d38.id = "radialLinear";
$f2a0fc44203c547a$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $f2a0fc44203c547a$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$f2a0fc44203c547a$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$f2a0fc44203c547a$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $f2a0fc44203c547a$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $f2a0fc44203c547a$var$UNITS = Object.keys($f2a0fc44203c547a$var$INTERVALS);
function $f2a0fc44203c547a$var$sorter(a, b) {
    return a - b;
}
function $f2a0fc44203c547a$var$parse(scale, input) {
    if ((0, $1babab64a6c248e6$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $1babab64a6c248e6$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $1babab64a6c248e6$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $f2a0fc44203c547a$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $f2a0fc44203c547a$var$UNITS.length;
    for(let i = $f2a0fc44203c547a$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $f2a0fc44203c547a$var$INTERVALS[$f2a0fc44203c547a$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $f2a0fc44203c547a$var$UNITS[i];
    }
    return $f2a0fc44203c547a$var$UNITS[ilen - 1];
}
function $f2a0fc44203c547a$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $f2a0fc44203c547a$var$UNITS.length - 1; i >= $f2a0fc44203c547a$var$UNITS.indexOf(minUnit); i--){
        const unit = $f2a0fc44203c547a$var$UNITS[i];
        if ($f2a0fc44203c547a$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $f2a0fc44203c547a$var$UNITS[minUnit ? $f2a0fc44203c547a$var$UNITS.indexOf(minUnit) : 0];
}
function $f2a0fc44203c547a$var$determineMajorUnit(unit) {
    for(let i = $f2a0fc44203c547a$var$UNITS.indexOf(unit) + 1, ilen = $f2a0fc44203c547a$var$UNITS.length; i < ilen; ++i){
        if ($f2a0fc44203c547a$var$INTERVALS[$f2a0fc44203c547a$var$UNITS[i]].common) return $f2a0fc44203c547a$var$UNITS[i];
    }
}
function $f2a0fc44203c547a$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $1babab64a6c248e6$export$c03999cb2f36933f)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $f2a0fc44203c547a$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $f2a0fc44203c547a$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $f2a0fc44203c547a$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $f2a0fc44203c547a$export$a894c72689ff3ec extends $f2a0fc44203c547a$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $f2a0fc44203c547a$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $1babab64a6c248e6$export$2219238a014317b0)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $f2a0fc44203c547a$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $1babab64a6c248e6$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $1babab64a6c248e6$export$faec65b429be379)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $f2a0fc44203c547a$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $f2a0fc44203c547a$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $f2a0fc44203c547a$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $f2a0fc44203c547a$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(start, 0, limit);
        end = (0, $1babab64a6c248e6$export$a9c23c6ac3fc3eca)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $f2a0fc44203c547a$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $1babab64a6c248e6$export$90a7f3efeed30595)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $1babab64a6c248e6$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$f2a0fc44203c547a$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $f2a0fc44203c547a$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $1babab64a6c248e6$export$e7094788287c5e9b)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $1babab64a6c248e6$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $f2a0fc44203c547a$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($f2a0fc44203c547a$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $1babab64a6c248e6$export$71511d61b312f219)(values.sort($f2a0fc44203c547a$var$sorter));
    }
}
$f2a0fc44203c547a$export$a894c72689ff3ec.id = "time";
$f2a0fc44203c547a$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $f2a0fc44203c547a$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $1babab64a6c248e6$export$dc98b0b04f4c7758)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $1babab64a6c248e6$export$dc98b0b04f4c7758)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $f2a0fc44203c547a$export$85df64a8eb6dc986 extends $f2a0fc44203c547a$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $f2a0fc44203c547a$var$interpolate(table, this.min);
        this._tableRange = $f2a0fc44203c547a$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($f2a0fc44203c547a$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $f2a0fc44203c547a$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$f2a0fc44203c547a$export$85df64a8eb6dc986.id = "timeseries";
$f2a0fc44203c547a$export$85df64a8eb6dc986.defaults = $f2a0fc44203c547a$export$a894c72689ff3ec.defaults;
var $f2a0fc44203c547a$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $f2a0fc44203c547a$export$29e663ba4d09fe7,
    LinearScale: $f2a0fc44203c547a$export$e7f4e5e8656f0b93,
    LogarithmicScale: $f2a0fc44203c547a$export$85295eaf7cb3ac3e,
    RadialLinearScale: $f2a0fc44203c547a$export$cfafc36d95386d38,
    TimeScale: $f2a0fc44203c547a$export$a894c72689ff3ec,
    TimeSeriesScale: $f2a0fc44203c547a$export$85df64a8eb6dc986
});
const $f2a0fc44203c547a$export$e8959e79e3af550f = [
    $f2a0fc44203c547a$export$a6506504f799c5d5,
    $f2a0fc44203c547a$export$7a5d735b2ab6389d,
    $f2a0fc44203c547a$export$8b3ca321c77fdea6,
    $f2a0fc44203c547a$export$bcac1c16f1530ec2
];



var $dup7A = parcelRequire("dup7A");

const $9d8979d56b6ef833$var$defaultDatasetIdKey = "label";
function $9d8979d56b6ef833$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $9d8979d56b6ef833$var$setOptions(chart, nextOptions) {
    Object.assign(chart.options, nextOptions);
}
function $9d8979d56b6ef833$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $9d8979d56b6ef833$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $9d8979d56b6ef833$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $9d8979d56b6ef833$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9d8979d56b6ef833$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $9d8979d56b6ef833$var$setLabels(nextData, data.labels);
    $9d8979d56b6ef833$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $9d8979d56b6ef833$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $9d8979d56b6ef833$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $9d8979d56b6ef833$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $9d8979d56b6ef833$var$ChartComponent(param, ref) {
    let { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...props } = param;
    const canvasRef = (0, $dup7A.useRef)(null);
    const chartRef = (0, $dup7A.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $f2a0fc44203c547a$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $9d8979d56b6ef833$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $9d8979d56b6ef833$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $9d8979d56b6ef833$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $dup7A.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $9d8979d56b6ef833$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!redraw && chartRef.current) $9d8979d56b6ef833$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $9d8979d56b6ef833$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $dup7A.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent);
}
const $9d8979d56b6ef833$export$acaa6426d77a227e = /*#__PURE__*/ (0, $dup7A.forwardRef)($9d8979d56b6ef833$var$ChartComponent);
function $9d8979d56b6ef833$var$createTypedChart(type, registerables) {
    (0, $f2a0fc44203c547a$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $dup7A.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($9d8979d56b6ef833$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $9d8979d56b6ef833$export$17d680238e50603e = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("line", (0, $f2a0fc44203c547a$export$3c9b5d28c11cbfd0));
const $9d8979d56b6ef833$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("bar", (0, $f2a0fc44203c547a$export$e97d5dc64e999004));
const $9d8979d56b6ef833$export$bace472c466fdd25 = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("radar", (0, $f2a0fc44203c547a$export$48dbc6ac651bf8be));
const $9d8979d56b6ef833$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("doughnut", (0, $f2a0fc44203c547a$export$e04603e7d8b77172));
const $9d8979d56b6ef833$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("polarArea", (0, $f2a0fc44203c547a$export$2a270b3a0d973c85));
const $9d8979d56b6ef833$export$646feb54fbadbe06 = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("bubble", (0, $f2a0fc44203c547a$export$19b5c4773f17abe));
const $9d8979d56b6ef833$export$2ae8800cf67c848c = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("pie", (0, $f2a0fc44203c547a$export$b21a3f1286706191));
const $9d8979d56b6ef833$export$1c460fb4285edadc = /* #__PURE__ */ $9d8979d56b6ef833$var$createTypedChart("scatter", (0, $f2a0fc44203c547a$export$b2f2bae6713db87));


/*!
  * chartjs-adapter-moment v1.0.1
  * https://www.chartjs.org
  * (c) 2022 chartjs-adapter-moment Contributors
  * Released under the MIT license
  */ 
var $pfIJM = parcelRequire("pfIJM");

const $d9024be13f3bc35d$var$FORMATS = {
    datetime: "MMM D, YYYY, h:mm:ss a",
    millisecond: "h:mm:ss.SSS a",
    second: "h:mm:ss a",
    minute: "h:mm a",
    hour: "hA",
    day: "MMM D",
    week: "ll",
    month: "MMM YYYY",
    quarter: "[Q]Q - YYYY",
    year: "YYYY"
};
(0, $f2a0fc44203c547a$export$f32766ea09ec8bc4)._date.override(typeof (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM))) === "function" ? {
    _id: "moment",
    formats: function() {
        return $d9024be13f3bc35d$var$FORMATS;
    },
    parse: function(value, format) {
        if (typeof value === "string" && typeof format === "string") value = (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(value, format);
        else if (!(value instanceof (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM))))) value = (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(value);
        return value.isValid() ? value.valueOf() : null;
    },
    format: function(time, format) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(time).format(format);
    },
    add: function(time, amount, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(time).add(amount, unit).valueOf();
    },
    diff: function(max, min, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(max).diff((0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(min), unit);
    },
    startOf: function(time, unit, weekday) {
        time = (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(time);
        if (unit === "isoWeek") {
            weekday = Math.trunc(Math.min(Math.max(0, weekday), 6));
            return time.isoWeekday(weekday).startOf("day").valueOf();
        }
        return time.startOf(unit).valueOf();
    },
    endOf: function(time, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($pfIJM)))(time).endOf(unit).valueOf();
    }
} : {});


const $3ad5ec6b4cfcedb4$var$LineContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 220px;
  margin-top: 16px;
`;
(0, $f2a0fc44203c547a$export$acaa6426d77a227e).register((0, $f2a0fc44203c547a$export$29e663ba4d09fe7), (0, $f2a0fc44203c547a$export$e7f4e5e8656f0b93), (0, $f2a0fc44203c547a$export$bd159b522b230b7a), (0, $f2a0fc44203c547a$export$55e463fa7bcd3469), (0, $f2a0fc44203c547a$export$a894c72689ff3ec), (0, $f2a0fc44203c547a$export$28c660c63b792dea));
const $3ad5ec6b4cfcedb4$var$TimeSeriesChart = ({ data: data })=>{
    const theme = (0, $e9f8389e4f70b5af$export$93d4e7f90805808f)();
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            point: {
                radius: 0
            }
        },
        interaction: {
            axis: "x",
            intersect: false
        },
        tooltips: {
            position: "nearest"
        },
        scales: {
            x: {
                type: "time",
                grid: {
                    display: false
                },
                ticks: {
                    color: theme.secondaryText
                }
            },
            y: {
                grid: {
                    color: theme.stroke
                },
                ticks: {
                    color: theme.secondaryText
                },
                suggestedMin: 0
            }
        }
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)($3ad5ec6b4cfcedb4$var$LineContainer, {
        children: // eslint-disable-next-line
        // @ts-ignore
        /*#__PURE__*/ (0, $cZGFG.jsx)((0, $9d8979d56b6ef833$export$17d680238e50603e), {
            data: {
                datasets: [
                    {
                        data: data,
                        borderColor: theme.primaryBlue,
                        stepped: true,
                        cubicInterpolationMode: "monotone"
                    }
                ]
            },
            options: options
        })
    });
};
var $3ad5ec6b4cfcedb4$export$2e2bcd8739ae039 = $3ad5ec6b4cfcedb4$var$TimeSeriesChart;


const $26333b8ddf3c2d90$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 48)};
  display: flex;
  flex-direction: column;
`;
const $26333b8ddf3c2d90$var$StyledDropdown = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.DropdownSelect))`
  width: fit-content;
  align-self: end;
`;
const $26333b8ddf3c2d90$var$CHART_OPTIONS = [
    {
        text: "Staked PNK",
        value: "stakedPNK"
    },
    {
        text: "Cases",
        value: "cases"
    },
    {
        text: "Cases per court",
        value: 2
    }
];
const $26333b8ddf3c2d90$var$ChartOptionsDropdown = ({ setChartOption: setChartOption })=>/*#__PURE__*/ (0, $cZGFG.jsx)($26333b8ddf3c2d90$var$StyledDropdown, {
        smallButton: true,
        simpleButton: true,
        alignRight: true,
        defaultValue: "stakedPNK",
        items: $26333b8ddf3c2d90$var$CHART_OPTIONS,
        callback: (newValue)=>{
            if (typeof newValue === "string") setChartOption(newValue);
        }
    });
const $26333b8ddf3c2d90$var$Chart = ()=>{
    const [chartOption, setChartOption] = (0, $dup7A.useState)("stakedPNK");
    const { data: data } = (0, $3767ddbf01f33684$export$ce5cd65d5f2a5117)();
    const chartData = data?.counters;
    const processedData = chartData?.reduce((accData, counter)=>{
        return [
            ...accData,
            {
                x: Number(counter.id) * 1000,
                y: Number(chartOption === "stakedPNK" ? (0, $lTCHO.formatUnits)(counter[chartOption], 18) : counter[chartOption])
            }
        ];
    }, []);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($26333b8ddf3c2d90$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($26333b8ddf3c2d90$var$ChartOptionsDropdown, {
                setChartOption: setChartOption
            }),
            processedData ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3ad5ec6b4cfcedb4$export$2e2bcd8739ae039), {
                data: processedData
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                height: 233
            })
        ]
    });
};
var $26333b8ddf3c2d90$export$2e2bcd8739ae039 = $26333b8ddf3c2d90$var$Chart;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





const $fa310ac3e8b6243d$var$StyledHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $fa310ac3e8b6243d$var$StyledH1 = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  font-size: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(21, 24)};
`;
const $fa310ac3e8b6243d$var$Header = ()=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($fa310ac3e8b6243d$var$StyledHeader, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($fa310ac3e8b6243d$var$StyledH1, {
                children: "Court Overview"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
                small: true,
                Icon: (0, $d15fda946aef10b5$export$2e2bcd8739ae039),
                text: "Create a Case",
                onClick: ()=>navigate("/resolver")
            })
        ]
    });
};
var $fa310ac3e8b6243d$export$2e2bcd8739ae039 = $fa310ac3e8b6243d$var$Header;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $81c14e8ea04403d8$var$SvgUser = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M10.892 12.313c3.227 0 5.845-2.646 5.845-5.907C16.737 3.146 14.12.5 10.892.5S5.046 3.146 5.046 6.406c0 3.261 2.619 5.907 5.846 5.907Zm5.196 1.312H13.85a7.012 7.012 0 0 1-2.96.656 7.026 7.026 0 0 1-2.958-.656H5.696c-2.87 0-5.196 2.35-5.196 5.25v.656A1.96 1.96 0 0 0 2.448 21.5h16.887a1.96 1.96 0 0 0 1.949-1.969v-.656c0-2.9-2.326-5.25-5.196-5.25Z"
        })
    });
var $81c14e8ea04403d8$export$2e2bcd8739ae039 = $81c14e8ea04403d8$var$SvgUser;












const $85a449e8df5eec94$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: auto;
  height: fit-content;
  gap: 32px;
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 30)};
  padding-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 35)};
  padding-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      padding-bottom: 0px;
      gap: 0px;
    `)}
`;
const $85a449e8df5eec94$var$getLastOrZero = (src, stat)=>src.length > 0 ? src.at(-1)?.[stat] : 0n.toString();
const $85a449e8df5eec94$var$stats = [
    {
        title: "PNK staked",
        coinId: 0,
        getText: (counters)=>(0, $fccd0e08af927011$export$fe0dbb825775d15c)($85a449e8df5eec94$var$getLastOrZero(counters, "stakedPNK")),
        getSubtext: (counters, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)($85a449e8df5eec94$var$getLastOrZero(counters, "stakedPNK"))) * (coinPrice ?? 0)),
        color: "purple",
        icon: (0, $2ebf3a18dc3f3ead$export$2e2bcd8739ae039)
    },
    {
        title: "ETH Paid to jurors",
        coinId: 1,
        getText: (counters)=>(0, $fccd0e08af927011$export$81d0e33f8b79c8db)($85a449e8df5eec94$var$getLastOrZero(counters, "paidETH")),
        getSubtext: (counters, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)($85a449e8df5eec94$var$getLastOrZero(counters, "paidETH"))) * (coinPrice ?? 0)),
        color: "blue",
        icon: (0, $2670defb153a6fcf$export$2e2bcd8739ae039)
    },
    {
        title: "PNK redistributed",
        coinId: 0,
        getText: (counters)=>(0, $fccd0e08af927011$export$fe0dbb825775d15c)($85a449e8df5eec94$var$getLastOrZero(counters, "redistributedPNK")),
        getSubtext: (counters, coinPrice)=>(0, $fccd0e08af927011$export$700d496f06f3d38f)(Number((0, $fccd0e08af927011$export$4adf19926ad5efb5)($85a449e8df5eec94$var$getLastOrZero(counters, "redistributedPNK"))) * (coinPrice ?? 0)),
        color: "purple",
        icon: (0, $4471110cf3694b38$export$2e2bcd8739ae039)
    },
    {
        title: "Active jurors",
        getText: (counters)=>$85a449e8df5eec94$var$getLastOrZero(counters, "activeJurors"),
        color: "green",
        icon: (0, $81c14e8ea04403d8$export$2e2bcd8739ae039)
    },
    {
        title: "Cases",
        getText: (counters)=>$85a449e8df5eec94$var$getLastOrZero(counters, "cases"),
        color: "orange",
        icon: (0, $6ffbdc979e08a453$export$2e2bcd8739ae039)
    }
];
const $85a449e8df5eec94$var$Stats = ()=>{
    const { data: data } = (0, $3767ddbf01f33684$export$ce5cd65d5f2a5117)();
    const coinIds = [
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).PNK,
        (0, $dc69730cf3c4367b$export$9943437e13d9c9e1).ETH
    ];
    const { prices: pricesData } = (0, $395644ae226c29e9$export$28d4a1ba7888e974)(coinIds);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($85a449e8df5eec94$var$StyledCard, {
        children: $85a449e8df5eec94$var$stats.map(({ title: title, coinId: coinId, getText: getText, getSubtext: getSubtext, color: color, icon: icon }, i)=>{
            const coinPrice = !(0, $2d857633ba67aa25$export$fce6876652108ab)(pricesData) ? pricesData[coinIds[coinId]]?.price : undefined;
            return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b3f034411f0a9f49$export$2e2bcd8739ae039), {
                title: title,
                color: color,
                icon: icon,
                text: data ? getText(data["counters"]) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {}),
                subtext: (0, $ccd60bbb754b302e$export$789eb2f4a09b2030)(data ? data["counters"] : undefined, getSubtext, coinPrice)
            }, i);
        })
    });
};
var $85a449e8df5eec94$export$2e2bcd8739ae039 = $85a449e8df5eec94$var$Stats;


const $5209bf62f2b623fb$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
`;
const $5209bf62f2b623fb$var$CourtOverview = ()=>/*#__PURE__*/ (0, $cZGFG.jsxs)($5209bf62f2b623fb$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $fa310ac3e8b6243d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $26333b8ddf3c2d90$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $85a449e8df5eec94$export$2e2bcd8739ae039), {})
        ]
    });
var $5209bf62f2b623fb$export$2e2bcd8739ae039 = $5209bf62f2b623fb$var$CourtOverview;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");






const $16c938365bcca44c$var$topUsersByCoherenceScoreQuery = (0, $172f779258b16045$export$1eb4e7c0ed67b035)(`
  query TopUsersByCoherenceScore($first: Int!, $orderBy: User_orderBy, $orderDirection: OrderDirection) {
    users(first: $first, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      coherenceScore
      totalCoherent
      totalResolvedDisputes
    }
  }
`);
const $16c938365bcca44c$export$98e9a7c9a3925bdf = (first = 5)=>{
    const isEnabled = !(0, $2d857633ba67aa25$export$fce6876652108ab)(first);
    const { graphqlBatcher: graphqlBatcher } = (0, $e6e1be54a100c2c5$export$45728877641088dc)();
    return (0, $b2d37ce55e9ca513$export$dd0a697e1782aedd)({
        queryKey: [
            `TopUsersByCoherenceScore${first}`
        ],
        enabled: isEnabled,
        staleTime: Infinity,
        queryFn: async ()=>isEnabled ? await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $16c938365bcca44c$var$topUsersByCoherenceScoreQuery,
                variables: {
                    first: first,
                    orderBy: "coherenceScore",
                    orderDirection: "desc"
                }
            }) : undefined
    });
};






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $ec38962cf22bd04f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  font-size: 12px !important;
  &::before {
    content: "Votes";
  }
  color: ${({ theme: theme })=>theme.secondaryText};
  align-items: center;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        font-size: 14px !important;
        justify-content: center;
        &::before {
          content: "Coherent Votes";
        }
      `)}
`;
const $ec38962cf22bd04f$var$coherentVotesTooltipMsg = "This is the ratio of coherent votes made by a juror: the number in the left is the number of times where the juror voted coherently and the number in the right is the total number of times the juror voted";
const $ec38962cf22bd04f$var$Coherency = ()=>{
    const { width: width } = (0, $d470e35ba62548b0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)($ec38962cf22bd04f$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $30a2dcec41d4503b$export$2e2bcd8739ae039), {
            place: width > (0, $1a81a644a2506b99$export$4cf8c0e020b1f8b2) ? "top" : "left",
            tooltipMsg: $ec38962cf22bd04f$var$coherentVotesTooltipMsg
        })
    });
};
var $ec38962cf22bd04f$export$2e2bcd8739ae039 = $ec38962cf22bd04f$var$Coherency;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $0a1d1eb47f97fd32$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  color: ${({ theme: theme })=>theme.secondaryText};
  gap: 0px;

  font-size: 12px !important;
  &::before {
    content: "Rewards";
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        font-size: 14px !important;
        justify-content: center;
        &::before {
          content: "Total Rewards";
        }
      `)}
`;
const $0a1d1eb47f97fd32$var$totalRewardsTooltipMsg = "Users have an economic interest in serving as jurors in Kleros: collecting the Juror Rewards in exchange for their work. Each juror who is coherent with the final ruling receive the Juror Rewards composed of arbitration fees (ETH) + PNK redistribution between jurors.";
const $0a1d1eb47f97fd32$var$Rewards = ()=>/*#__PURE__*/ (0, $cZGFG.jsx)($0a1d1eb47f97fd32$var$Container, {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $30a2dcec41d4503b$export$2e2bcd8739ae039), {
            place: "top",
            tooltipMsg: $0a1d1eb47f97fd32$var$totalRewardsTooltipMsg
        })
    });
var $0a1d1eb47f97fd32$export$2e2bcd8739ae039 = $0a1d1eb47f97fd32$var$Rewards;


const $6f27044db1b5093e$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: none;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBlue};
  border 1px solid ${({ theme: theme })=>theme.stroke};
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.stroke};
  padding: 18.6px 32px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        display: grid;
        grid-template-columns:
          min-content repeat(3, ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(160, 180, 900)})
          auto;
        column-gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 28, 900)};
        align-items: center;
      `)}
`;
const $6f27044db1b5093e$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 16px;
`;
const $6f27044db1b5093e$var$HowItWorksContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
`;
const $6f27044db1b5093e$export$57edc697ae8c38e = ()=>{
    const [isJurorLevelsMiniGuideOpen, toggleJurorLevelsMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($6f27044db1b5093e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($6f27044db1b5093e$var$StyledLabel, {
                children: "#"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($6f27044db1b5093e$var$StyledLabel, {
                children: "Juror"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0a1d1eb47f97fd32$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ec38962cf22bd04f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($6f27044db1b5093e$var$HowItWorksContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                    isMiniGuideOpen: isJurorLevelsMiniGuideOpen,
                    toggleMiniGuide: toggleJurorLevelsMiniGuide,
                    MiniGuideComponent: (0, $3641426bdc544c85$export$2e2bcd8739ae039)
                })
            })
        ]
    });
};



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");





const $0b51575f5a511620$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBlue};
  padding: 24px;
  border 1px solid ${({ theme: theme })=>theme.stroke};
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom: none;
  flex-wrap: wrap;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $0b51575f5a511620$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 16px;
`;
const $0b51575f5a511620$export$494cf78290fbe4c7 = ()=>{
    const [isJurorLevelsMiniGuideOpen, toggleJurorLevelsMiniGuide] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($0b51575f5a511620$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($0b51575f5a511620$var$StyledLabel, {
                children: "Ranking"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $caf7f2a3b06f5c4a$export$2e2bcd8739ae039), {
                isMiniGuideOpen: isJurorLevelsMiniGuideOpen,
                toggleMiniGuide: toggleJurorLevelsMiniGuide,
                MiniGuideComponent: (0, $3641426bdc544c85$export$2e2bcd8739ae039)
            })
        ]
    });
};


const $6ab0f971ddca7471$var$Header = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0b51575f5a511620$export$494cf78290fbe4c7), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6f27044db1b5093e$export$57edc697ae8c38e), {})
        ]
    });
};
var $6ab0f971ddca7471$export$2e2bcd8739ae039 = $6ab0f971ddca7471$var$Header;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");

const $878b3d3c000fe0f7$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
  flex-wrap: wrap;
  justify-content: center;
`;
const $878b3d3c000fe0f7$var$Coherency = ({ totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes })=>{
    const coherenceRatio = `${totalCoherent}/${totalResolvedDisputes}`;
    return /*#__PURE__*/ (0, $cZGFG.jsx)($878b3d3c000fe0f7$var$Container, {
        children: coherenceRatio
    });
};
var $878b3d3c000fe0f7$export$2e2bcd8739ae039 = $878b3d3c000fe0f7$var$Coherency;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $dc0293fdb592dc7d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      gap: 16px;
      justify-content: end;
    `)}
`;
const $dc0293fdb592dc7d$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 12px !important;

  &::before {
    content: "Lv. ";
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: 16px !important;

      &::before {
        content: "Level ";
      }
    `)}
`;
const $dc0293fdb592dc7d$var$JurorLevel = ({ coherenceScore: coherenceScore })=>{
    const userLevelData = (0, $36efe9648741c2ca$export$e85f3e8176d5b41b)(coherenceScore);
    const level = userLevelData.level;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($dc0293fdb592dc7d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($dc0293fdb592dc7d$var$StyledLabel, {
                children: level
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b9a21c2e2f7668df$export$2e2bcd8739ae039), {
                width: "32px",
                height: "32px",
                level: level
            })
        ]
    });
};
var $dc0293fdb592dc7d$export$2e2bcd8739ae039 = $dc0293fdb592dc7d$var$JurorLevel;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $8e25c4d68f4a150a$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;

  label {
    font-size: 16px;
  }

  canvas {
    width: 20px;
    height: 20px;
    border-radius: 10%;
  }
`;
const $8e25c4d68f4a150a$var$JurorTitle = ({ address: address })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($8e25c4d68f4a150a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$f8b4f9182cfa7b1d), {
                address: address
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c4fa15e9af440105$export$6cdabdfc8e8da8af), {
                address: address
            })
        ]
    });
};
var $8e25c4d68f4a150a$export$2e2bcd8739ae039 = $8e25c4d68f4a150a$var$JurorTitle;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $1090d4210dd754dd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.primaryText};

  &::before {
    content: "#";
    display: inline;
  }

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: flex;
      align-items: center;
      justify-content: start;
      &::before {
        display: none;
      }
    `)}
`;
const $1090d4210dd754dd$var$Rank = ({ rank: rank })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($1090d4210dd754dd$var$Container, {
        children: rank
    });
};
var $1090d4210dd754dd$export$2e2bcd8739ae039 = $1090d4210dd754dd$var$Rank;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $cad857128fb168d3$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      justify-content: center;
    `)}
`;
const $cad857128fb168d3$var$StyledIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 16px;
  height: 16px;

  path {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $cad857128fb168d3$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $cad857128fb168d3$var$Rewards = ({ address: address })=>{
    const { data: userData } = (0, $9b3f9611a9d64fed$export$68dae0b0cacaa18a)(address?.toLowerCase());
    const formattedRewards = (0, $7d17ffa0c53046b1$export$c285ae1f36e15c2a)(userData, {});
    const ethReward = formattedRewards.find((r)=>r.token === "ETH")?.amount;
    const pnkReward = formattedRewards.find((r)=>r.token === "PNK")?.amount;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($cad857128fb168d3$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($cad857128fb168d3$var$StyledLabel, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: ethReward ?? "",
                    unit: "ETH",
                    showUnitInDisplay: false
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cad857128fb168d3$var$StyledIcon, {
                as: (0, $ef68e50e48a94340$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cad857128fb168d3$var$StyledLabel, {
                children: "+"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cad857128fb168d3$var$StyledLabel, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8fb7e015e1b00a30$export$2e2bcd8739ae039), {
                    value: pnkReward ?? "",
                    unit: "PNK",
                    showUnitInDisplay: false
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cad857128fb168d3$var$StyledIcon, {
                as: (0, $c62dc91ec117256f$export$2e2bcd8739ae039)
            })
        ]
    });
};
var $cad857128fb168d3$export$2e2bcd8739ae039 = $cad857128fb168d3$var$Rewards;


const $2a28011501cc018f$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: none;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  border-top: none;
  align-items: center;
  padding: 15.55px 32px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: grid;
      grid-template-columns:
        min-content repeat(3, ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(160, 180, 900)})
        auto;
      column-gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(12, 28, 900)};
    `)}
`;
const $2a28011501cc018f$var$DesktopCard = ({ rank: rank, address: address, totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes, coherenceScore: coherenceScore })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($2a28011501cc018f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1090d4210dd754dd$export$2e2bcd8739ae039), {
                rank: rank
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8e25c4d68f4a150a$export$2e2bcd8739ae039), {
                address: address
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cad857128fb168d3$export$2e2bcd8739ae039), {
                address: address
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $878b3d3c000fe0f7$export$2e2bcd8739ae039), {
                totalCoherent: totalCoherent,
                totalResolvedDisputes: totalResolvedDisputes
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dc0293fdb592dc7d$export$2e2bcd8739ae039), {
                coherenceScore: coherenceScore
            })
        ]
    });
};
var $2a28011501cc018f$export$2e2bcd8739ae039 = $2a28011501cc018f$var$DesktopCard;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");









const $299508f2673ad4cf$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  padding: 16px 24px 24px 24px;
  border 1px solid ${({ theme: theme })=>theme.stroke};
  border-top: none;
  align-items: center;
  gap: 18px;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $299508f2673ad4cf$var$TopSide = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  align-items: center;
`;
const $299508f2673ad4cf$var$RankAndTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const $299508f2673ad4cf$var$HeaderRewardsAndRewards = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;
const $299508f2673ad4cf$var$BottomSide = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const $299508f2673ad4cf$var$HeaderCoherencyAndCoherency = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;

  svg {
    margin-right: 0;
  }
`;
const $299508f2673ad4cf$var$MobileCard = ({ rank: rank, address: address, coherenceScore: coherenceScore, totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$TopSide, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$RankAndTitle, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1090d4210dd754dd$export$2e2bcd8739ae039), {
                                rank: rank
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $8e25c4d68f4a150a$export$2e2bcd8739ae039), {
                                address: address
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $dc0293fdb592dc7d$export$2e2bcd8739ae039), {
                        coherenceScore: coherenceScore
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$BottomSide, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$HeaderRewardsAndRewards, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0a1d1eb47f97fd32$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cad857128fb168d3$export$2e2bcd8739ae039), {
                                address: address
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($299508f2673ad4cf$var$HeaderCoherencyAndCoherency, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $ec38962cf22bd04f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $878b3d3c000fe0f7$export$2e2bcd8739ae039), {
                                totalCoherent: totalCoherent,
                                totalResolvedDisputes: totalResolvedDisputes
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $299508f2673ad4cf$export$2e2bcd8739ae039 = $299508f2673ad4cf$var$MobileCard;


const $07dbe68df6c257c9$var$JurorCard = ({ rank: rank, address: address, coherenceScore: coherenceScore, totalCoherent: totalCoherent, totalResolvedDisputes: totalResolvedDisputes })=>{
    const allProps = {
        rank: rank,
        address: address,
        coherenceScore: coherenceScore,
        totalCoherent: totalCoherent,
        totalResolvedDisputes: totalResolvedDisputes
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $299508f2673ad4cf$export$2e2bcd8739ae039), {
                ...allProps
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2a28011501cc018f$export$2e2bcd8739ae039), {
                ...allProps
            })
        ]
    });
};
var $07dbe68df6c257c9$export$2e2bcd8739ae039 = $07dbe68df6c257c9$var$JurorCard;


const $cb210bdf7ffb195b$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(64, 80)};
`;
const $cb210bdf7ffb195b$var$Title = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 48)};
`;
const $cb210bdf7ffb195b$var$ListContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: grid;
      grid-template-columns: 1fr;
    `)}
`;
const $cb210bdf7ffb195b$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  font-size: 16px;
`;
const $cb210bdf7ffb195b$var$TopJurors = ()=>{
    const { data: queryJurors } = (0, $16c938365bcca44c$export$98e9a7c9a3925bdf)();
    const topJurors = queryJurors?.users?.map((juror, index)=>({
            ...juror,
            rank: index + 1
        }));
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($cb210bdf7ffb195b$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($cb210bdf7ffb195b$var$Title, {
                children: "Top Jurors"
            }),
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(topJurors) && topJurors.length === 0 ? /*#__PURE__*/ (0, $cZGFG.jsx)($cb210bdf7ffb195b$var$StyledLabel, {
                children: "There are no jurors staked yet."
            }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($cb210bdf7ffb195b$var$ListContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6ab0f971ddca7471$export$2e2bcd8739ae039), {}),
                    !(0, $2d857633ba67aa25$export$fce6876652108ab)(topJurors) ? topJurors.map((juror)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $07dbe68df6c257c9$export$2e2bcd8739ae039), {
                            address: juror.id,
                            ...juror
                        }, juror.rank)) : [
                        ...Array(5)
                    ].map((_, i)=>/*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$7cd623403cfd4f66), {}, i))
                ]
            })
        ]
    });
};
var $cb210bdf7ffb195b$export$2e2bcd8739ae039 = $cb210bdf7ffb195b$var$TopJurors;


const $f6992ffc8abff560$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 72)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 132)} ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $f6992ffc8abff560$var$Home = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $3767ddbf01f33684$export$77ba6708b1c2efce), {
        timeframe: (0, $fee5256da5a38783$export$38a99e5511b052ac)(),
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0baf26b3b0f0403b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($f6992ffc8abff560$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5209bf62f2b623fb$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3086dc6786764df3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cb210bdf7ffb195b$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $73f6489c485c3225$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $f6992ffc8abff560$export$2e2bcd8739ae039 = $f6992ffc8abff560$var$Home;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");








var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");






var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


const $62295d38f7113fb2$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h1`
  margin-bottom: 32px;
  width: 84vw;
  text-align: center;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: auto;
    `)}
`;
const $62295d38f7113fb2$var$Header = ({ text: text })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)($62295d38f7113fb2$var$Container, {
        children: text
    });
};
var $62295d38f7113fb2$export$2e2bcd8739ae039 = $62295d38f7113fb2$var$Header;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $f86466ae815264c0$var$NextButton = ({ nextRoute: nextRoute })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    const { disputeData: disputeData, isPolicyUploading: isPolicyUploading } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    //checks if each answer is filled in
    const areVotingOptionsFilled = disputeData.question !== "" && disputeData.answers.every((answer)=>answer.title !== "");
    //check if any filled address or ens is invalid
    const areFilledAddressesValid = disputeData?.aliases?.every((alias)=>alias.address === "" || alias.isValid);
    const isButtonDisabled = location.pathname.includes("/resolver/title") && !disputeData.title || location.pathname.includes("/resolver/description") && !disputeData.description || location.pathname.includes("/resolver/court") && !disputeData.courtId || location.pathname.includes("/resolver/jurors") && !disputeData.arbitrationCost || location.pathname.includes("/resolver/voting-options") && !areVotingOptionsFilled || location.pathname.includes("/resolver/notable-persons") && !areFilledAddressesValid || location.pathname.includes("/resolver/policy") && (isPolicyUploading || !disputeData.policyURI);
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.Button), {
        disabled: isButtonDisabled,
        onClick: ()=>navigate(nextRoute),
        text: "Next"
    });
};
var $f86466ae815264c0$export$2e2bcd8739ae039 = $f86466ae815264c0$var$NextButton;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $5e8873d05870d8ee$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  display: ${({ prevRoute: prevRoute })=>prevRoute === "" ? "none" : "flex"};
`;
const $5e8873d05870d8ee$var$ReturnButton = ({ prevRoute: prevRoute })=>{
    const navigate = (0, $5c6d50c15e61ec01$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $cZGFG.jsx)($5e8873d05870d8ee$var$StyledButton, {
        prevRoute: prevRoute,
        onClick: ()=>navigate(prevRoute),
        text: "Return",
        variant: "secondary"
    });
};
var $5e8873d05870d8ee$export$2e2bcd8739ae039 = $5e8873d05870d8ee$var$ReturnButton;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");


var $349Qk = parcelRequire("349Qk");


function $c41289d5de160ddc$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $4bb6460923149a59$export$6e5e6f927c48b857)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $a0fc1ac174d3ebdd$export$130f77ea18c25fb8)(signature)) continue;
        abi.push((0, $05865b6588c71d5d$export$dc1dc22ccf24efef)(signature, structs));
    }
    return abi;
}





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $8eac84ab21b77836$var$SvgDispute = (props)=>/*#__PURE__*/ (0, $cZGFG.jsxs)("svg", {
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M256.227 68.75 137.149 0 18.07 68.75v137.5L137.15 275l119.078-68.75V68.75Zm-14.51 8.229L137.055 16.552 32.393 76.98v120.853l104.662 60.427 104.662-60.427V76.979Z",
                fill: "#F0F9FF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m137.057 16.55 104.662 60.427v120.854l-104.662 60.426-104.662-60.426V76.977l104.662-60.426Z",
                fill: "#7E1BD4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M137.15 48.991 60.502 93.244v88.506l76.648 44.253 76.649-44.253V93.244L137.15 48.991Zm79.006 42.892L137.15 46.27 58.144 91.882v91.228l79.006 45.614 79.006-45.614V91.883Z",
                fill: "#B45FFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M187.193 45.148v136.556l-49.824-28.215-50.244 28.215V45.626L137.573 16.5l49.62 28.648Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "M181.489 41.852v136.613l-1.529-.866V40.969l1.529.883ZM94.529 41.35v136.195l-1.529.858V42.233l1.529-.883Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m117.586 52.64-2.653 2.175 1.249-3.196-2.889-1.851 3.425.2.868-3.32.868 3.32 3.426-.2-2.889 1.851 1.249 3.196-2.654-2.176Zm10.158 0-2.654 2.175 1.249-3.196-2.889-1.851 3.426.2.868-3.32.867 3.32 3.426-.2-2.889 1.851 1.249 3.196-2.653-2.176Zm7.504 2.175 2.653-2.176 2.653 2.176-1.249-3.196 2.889-1.851-3.425.2-.868-3.32-.868 3.32-3.425-.2 2.889 1.851-1.249 3.196Zm12.811-2.176-2.654 2.176 1.249-3.196-2.889-1.851 3.426.2.868-3.32.867 3.32 3.426-.2-2.889 1.851 1.249 3.196-2.653-2.176Zm7.503 2.176 2.654-2.176 2.653 2.176-1.249-3.196 2.889-1.851-3.425.2-.868-3.32-.868 3.32-3.426-.2 2.889 1.851-1.249 3.196Z",
                fill: "#FCFEFF"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M141.678 81.855c0 2.017-.455 3.177-1.191 3.834l20.349 6.072a3.174 3.174 0 0 1 2.079-.774 3.174 3.174 0 0 1 3.18 3.169 3.165 3.165 0 0 1-1.84 2.87l7.122 20.487c2.258.359 3.751.889 3.751 1.589 0 2.875-5.629 5.205-12.572 5.205s-12.571-2.33-12.571-5.205c0-.744 1.686-1.295 4.185-1.654l7.145-20.557a3.179 3.179 0 0 1-1.41-1.716c-.239-.998-.798-1.627-1.675-1.889-1.048-.312-2.075-.348-3.221-.387-1.448-.05-3.087-.107-5.202-.738l-10.339-3.085v21.073a3.157 3.157 0 0 1 1.331 2.574c0 .705-.233 1.353-.624 1.88a4.255 4.255 0 0 1 1.734 3.426c0 1.7-.999 3.163-2.441 3.851v4.4c4.695.245 8.272 1.511 8.272 3.035a.972.972 0 0 1-.003.077c7.578.654 12.811 2.045 12.811 3.656l.037 2.247c0 2.238-10.082 4.034-22.541 4.034s-22.541-1.833-22.541-4.071l-.073-2.21c0-1.586 5.066-2.958 12.449-3.624a.982.982 0 0 1-.006-.109c0-1.5 3.462-2.749 8.045-3.022v-4.342a4.258 4.258 0 0 1-.856-7.348 3.145 3.145 0 0 1-.624-1.879c0-1.126.592-2.112 1.48-2.674V88.017l-11.791-3.519c-.785-.234-1.934-.856-3.161-1.52-1.408-.762-2.919-1.58-4.103-1.934-.821-.245-1.663-.067-2.527.533a3.206 3.206 0 0 1-.539.353l7.106 20.444c2.363.36 3.939.899 3.939 1.619 0 2.874-5.628 5.205-12.571 5.205s-12.572-2.331-12.572-5.205c0-.698 1.483-1.227 3.729-1.586l7.169-20.624a3.161 3.161 0 0 1-1.454-2.66 3.174 3.174 0 0 1 3.18-3.168 3.18 3.18 0 0 1 3.04 2.237l18.275 5.453a9.263 9.263 0 0 1-.154-1.79c0-2.7 1.366-5.89 4.097-9.57 2.731 3.68 4.097 6.87 4.097 9.57Zm21.948 15.386 7.009 20.164c-4.422-.592-11.16-.611-15.726-.055l7.016-20.185c.312.102.644.158.99.158.245 0 .482-.03.711-.082Zm-59.456 5.057 7.027-20.214a3.18 3.18 0 0 0 1.126.208c.296 0 .581-.043.853-.118l6.986 20.097c-4.575-.588-11.49-.579-15.992.027Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                d: "m131.842 174.781 13.336.595 5.399 11.974-7.617 10.944-13.408-.858-5.497-12.973 7.787-9.682Zm9.777 6.902-9.665 4.215 8.263 6.377 1.402-10.592Zm-1.119-2.112-7.724-3.319-1.622 6.979 9.346-3.66Zm-1.958 14.308-8.394-5.983.203 8.108 8.191-2.125Zm10.694-6.555-5.72-5.794-1.51 11.141 7.23-5.347Zm-8.726 7.859-7.079 1.846 8.325.533-1.246-2.379Zm7.608-5.231-6.197 4.608 1.231 2.402 4.966-7.01Zm-2.931-12.903-1.204 2.467 4.48 4.545-3.276-7.012Zm-1.5-1.18-7.867-.319 6.489 2.833 1.378-2.514Zm-12.994 1.141-5.51 6.945 3.684.779 1.826-7.724Zm-2.048 9.086-3.702-.782 3.863 9.083-.161-8.301Z",
                fill: "#fff"
            })
        ]
    });
var $8eac84ab21b77836$export$2e2bcd8739ae039 = $8eac84ab21b77836$var$SvgDispute;





/**
 * @param subcourtID ID  of the court the dispute will take place in
 * @param noOfVotes Number of votes the dispute will have
 * @param disputeKit Id of the dispute kit to use
 * @returns arbitrator extradata passed in while creating a dispute or querying costs
 */ const $fe256908b8ec67fc$export$43ac8648b530f494 = (subcourtID, noOfVotes, disputeKit = 1)=>`0x${parseInt(subcourtID, 10).toString(16).padStart(64, "0") + noOfVotes.toString(16).padStart(64, "0") + disputeKit.toString(16).padStart(64, "0")}`;





const $f5a005247e9947b3$var$StyledButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))``;
const $f5a005247e9947b3$var$SubmitDisputeButton = ()=>{
    const publicClient = (0, $1d657eb5d64e17dc$export$3ca3483c611a99c4)();
    const [isPopupOpen, setIsPopupOpen] = (0, $dup7A.useState)(false);
    const [courtId, setCourtId] = (0, $dup7A.useState)("");
    const [disputeId, setDisputeId] = (0, $dup7A.useState)();
    const { disputeTemplate: disputeTemplate, disputeData: disputeData, resetDisputeData: resetDisputeData, isSubmittingCase: isSubmittingCase, setIsSubmittingCase: setIsSubmittingCase } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const { config: submitCaseConfig } = (0, $f9a008fec395d7ff$export$15e236dbfac1fe67)({
        enabled: $f5a005247e9947b3$var$isTemplateValid(disputeTemplate),
        args: [
            (0, $fe256908b8ec67fc$export$43ac8648b530f494)(disputeData.courtId ?? "1", disputeData.numberOfJurors ?? "", 1),
            JSON.stringify(disputeTemplate),
            "",
            BigInt(disputeTemplate.answers.length)
        ],
        value: BigInt(disputeData.arbitrationCost ?? 0)
    });
    const { writeAsync: submitCase } = (0, $f9a008fec395d7ff$export$220083d52cb8c725)(submitCaseConfig);
    const isButtonDisabled = (0, $dup7A.useMemo)(()=>isSubmittingCase || !$f5a005247e9947b3$var$isTemplateValid(disputeTemplate), [
        isSubmittingCase,
        disputeTemplate
    ]);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            " ",
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $57a33e957f4dc1ed$export$c640ece8678a7df5), {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)($f5a005247e9947b3$var$StyledButton, {
                    text: "Submit the case",
                    disabled: isButtonDisabled,
                    isLoading: isSubmittingCase,
                    onClick: ()=>{
                        if (submitCase) {
                            setIsSubmittingCase(true);
                            (0, $0b0903738c0da810$export$27738200007bd40a)(async ()=>await submitCase().then((response)=>response.hash), publicClient).then((res)=>{
                                if (res.status && !(0, $2d857633ba67aa25$export$fce6876652108ab)(res.result)) {
                                    const id = $f5a005247e9947b3$var$retrieveDisputeId(res.result.logs[1]);
                                    setDisputeId(Number(id));
                                    setCourtId(disputeData.courtId ?? "1");
                                    setIsPopupOpen(true);
                                    resetDisputeData();
                                }
                            }).finally(()=>{
                                setIsSubmittingCase(false);
                            });
                        }
                    }
                })
            }),
            isPopupOpen && disputeId && /*#__PURE__*/ (0, $cZGFG.jsx)((0, $6d5b5828a9c61872$export$2e2bcd8739ae039), {
                title: `Case #${disputeId} submitted`,
                icon: (0, $8eac84ab21b77836$export$2e2bcd8739ae039),
                popupType: (0, $6d5b5828a9c61872$export$9656cfe2bd6e411f).DISPUTE_CREATED,
                setIsOpen: setIsPopupOpen,
                disputeId: disputeId,
                courtId: courtId
            })
        ]
    });
};
const $f5a005247e9947b3$var$isTemplateValid = (disputeTemplate)=>{
    const areVotingOptionsFilled = disputeTemplate.question !== "" && disputeTemplate.answers.every((answer)=>answer.title !== "");
    return disputeTemplate.title && disputeTemplate.description && disputeTemplate.policyURI && areVotingOptionsFilled;
};
const $f5a005247e9947b3$var$retrieveDisputeId = (eventLog)=>(0, $349Qk.decodeEventLog)({
        abi: (0, $c41289d5de160ddc$export$4ab3f466fb8f069)([
            "event DisputeCreation(uint256 indexed, address indexed)"
        ]),
        data: eventLog.data,
        topics: eventLog.topics
    }).args[0];
var $f5a005247e9947b3$export$2e2bcd8739ae039 = $f5a005247e9947b3$var$SubmitDisputeButton;


const $16ec13d0d676614c$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 24px;
  margin-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(32, 24)};
  flex-wrap: wrap;
  justify-content: center;
`;
const $16ec13d0d676614c$var$NavigationButtons = ({ prevRoute: prevRoute, nextRoute: nextRoute })=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($16ec13d0d676614c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5e8873d05870d8ee$export$2e2bcd8739ae039), {
                prevRoute: prevRoute
            }),
            prevRoute === "/resolver/policy" ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f5a005247e9947b3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f86466ae815264c0$export$2e2bcd8739ae039), {
                nextRoute: nextRoute
            })
        ]
    });
};
var $16ec13d0d676614c$export$2e2bcd8739ae039 = $16ec13d0d676614c$var$NavigationButtons;


const $081e01c3f7d68814$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $081e01c3f7d68814$var$StyledTextArea = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Textarea))`
  width: 84vw;
  height: 300px;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $081e01c3f7d68814$var$Description = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const handleWrite = (event)=>{
        setDisputeData({
            ...disputeData,
            description: event.target.value
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($081e01c3f7d68814$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Describe the case"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($081e01c3f7d68814$var$StyledTextArea, {
                onChange: handleWrite,
                value: disputeData.description,
                placeholder: "eg. Bob hired Alice to develop a website for him. Bob claims the contract was not fully respected, and the website was delivered incomplete. For that reason, he wants to pay part of the agreed payment: 150 DAI. On the other hand, Alice claims she should receive the full payment: 250 DAI."
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/title",
                nextRoute: "/resolver/court"
            })
        ]
    });
};
var $081e01c3f7d68814$export$2e2bcd8739ae039 = $081e01c3f7d68814$var$Description;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $37ec7b6f3e1ff675$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $37ec7b6f3e1ff675$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 84vw;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $37ec7b6f3e1ff675$var$Title = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const handleWrite = (event)=>{
        setDisputeData({
            ...disputeData,
            title: event.target.value
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($37ec7b6f3e1ff675$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Choose a title"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($37ec7b6f3e1ff675$var$StyledField, {
                onChange: handleWrite,
                placeholder: "eg. Freelance work disagreement between Alice and Bob",
                value: disputeData.title
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "",
                nextRoute: "/resolver/description"
            })
        ]
    });
};
var $37ec7b6f3e1ff675$export$2e2bcd8739ae039 = $37ec7b6f3e1ff675$var$Title;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");







const $536303788b1828d6$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $536303788b1828d6$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 84vw;
  margin-bottom: 74px;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
      margin-bottom: 64px;
    `)}
  > small {
    margin-top: 16px;
  }
`;
const $536303788b1828d6$var$Category = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const handleWrite = (event)=>{
        setDisputeData({
            ...disputeData,
            category: event.target.value
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($536303788b1828d6$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Choose a category"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($536303788b1828d6$var$StyledField, {
                onChange: handleWrite,
                value: disputeData.category,
                placeholder: "eg. Freelance",
                variant: "info",
                message: "Type the category tag that you think best represents the case. eg. General, Curation, Freelancing, Listing, Insurance, Translation, Oracle, Identity, E-Commerce, etc."
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/court",
                nextRoute: "/resolver/jurors"
            })
        ]
    });
};
var $536303788b1828d6$export$2e2bcd8739ae039 = $536303788b1828d6$var$Category;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");










const $21dc216480f69e9d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $21dc216480f69e9d$var$StyledDropdownCascader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.DropdownCascader))`
  width: 84vw;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
  > button {
    width: 100%;
  }
`;
const $21dc216480f69e9d$var$AlertMessageContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 84vw;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
  margin-top: 24px;
`;
const $21dc216480f69e9d$var$Court = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const { data: data } = (0, $2a5b6389d5454647$export$2b3a4edc6425a652)();
    const items = (0, $dup7A.useMemo)(()=>!(0, $2d857633ba67aa25$export$fce6876652108ab)(data) && [
            (0, $2a5b6389d5454647$export$2d00adcfd7994092)(data.court)
        ], [
        data
    ]);
    const handleWrite = (courtId)=>{
        setDisputeData({
            ...disputeData,
            courtId: courtId
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($21dc216480f69e9d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Select a court to arbitrate the case"
            }),
            items ? /*#__PURE__*/ (0, $cZGFG.jsx)($21dc216480f69e9d$var$StyledDropdownCascader, {
                items: items,
                onSelect: (path)=>typeof path === "string" && handleWrite(path.split("/").pop()),
                placeholder: "Select Court",
                value: `/courts/${disputeData.courtId}`
            }) : /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eae6e90bb146718b$export$e4ecddc59e33f387), {
                width: 240,
                height: 42
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($21dc216480f69e9d$var$AlertMessageContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.AlertMessage), {
                    title: "Check the courts available beforehand",
                    msg: "Kleros has different courts arbitrating disputes in several areas. Each court has its own purpose and policy. Take some time to choose the best court for your case. Learn more about the available courts here.",
                    variant: "info"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/description",
                nextRoute: "/resolver/category"
            })
        ]
    });
};
var $21dc216480f69e9d$export$2e2bcd8739ae039 = $21dc216480f69e9d$var$Court;



var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");











const $22e7b3821e066bfe$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $22e7b3821e066bfe$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 290px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(20, 48)};
`;
const $22e7b3821e066bfe$var$StyledDisplay = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.DisplaySmall))`
  width: 290px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(20, 48)};
  h2::after {
    content: "ETH";
    margin-left: 4px;
  }
`;
const $22e7b3821e066bfe$var$Jurors = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const { data: data } = (0, $f9a008fec395d7ff$export$f8738efad6e9d34f)({
        enabled: !(0, $2d857633ba67aa25$export$fce6876652108ab)(disputeData.numberOfJurors) && !Number.isNaN(disputeData.numberOfJurors),
        args: [
            (0, $fe256908b8ec67fc$export$43ac8648b530f494)(disputeData.courtId, disputeData.numberOfJurors ?? "")
        ],
        watch: true
    });
    const arbitrationFee = (0, $fccd0e08af927011$export$81d0e33f8b79c8db)(data ?? BigInt(0), 5);
    (0, $dup7A.useEffect)(()=>setDisputeData({
            ...disputeData,
            arbitrationCost: data?.toString()
        }), [
        data
    ]);
    const handleJurorsWrite = (event)=>{
        setDisputeData({
            ...disputeData,
            numberOfJurors: parseInt(event.target.value.replace(/\D/g, ""), 10)
        });
    };
    const noOfVotes = Number.isNaN(disputeData.numberOfJurors) ? "" : disputeData.numberOfJurors;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($22e7b3821e066bfe$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Select the number of jurors"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($22e7b3821e066bfe$var$StyledField, {
                placeholder: "Select the number of jurors",
                value: noOfVotes,
                onChange: handleJurorsWrite
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($22e7b3821e066bfe$var$StyledDisplay, {
                text: arbitrationFee,
                Icon: (0, $ef68e50e48a94340$export$2e2bcd8739ae039),
                label: "Arbitration Cost"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/category",
                nextRoute: "/resolver/voting-options"
            })
        ]
    });
};
var $22e7b3821e066bfe$export$2e2bcd8739ae039 = $22e7b3821e066bfe$var$Jurors;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");


var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $a298c032f2e93c78$var$SvgEllipse = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 32,
        height: 32,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("circle", {
            cx: 16,
            cy: 16,
            r: 16,
            fill: "#009AFF"
        })
    });
var $a298c032f2e93c78$export$2e2bcd8739ae039 = $a298c032f2e93c78$var$SvgEllipse;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $507c09203874ecae$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
            d: "M15.826 7.332H.174A.174.174 0 0 0 0 7.506V8.81c0 .096.078.174.174.174h15.652A.174.174 0 0 0 16 8.81V7.506a.174.174 0 0 0-.174-.174Z",
            fill: "#fff"
        })
    });
var $507c09203874ecae$export$2e2bcd8739ae039 = $507c09203874ecae$var$SvgMinus;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");
const $3a8c0815bc43e4ed$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $cZGFG.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $cZGFG.jsx)("g", {
            clipPath: "url('5174470b1fd24e37')",
            children: /*#__PURE__*/ (0, $cZGFG.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z",
                fill: "#fff"
            })
        })
    });
var $3a8c0815bc43e4ed$export$2e2bcd8739ae039 = $3a8c0815bc43e4ed$var$SvgPlus;


const $1d1a0fc2d2502366$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  margin: 32px 0px 48px;
`;
const $1d1a0fc2d2502366$var$IconContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).button`
  position: relative;
  padding: 0;
  border-radius: 50%;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
const $1d1a0fc2d2502366$var$StyledEllipseIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $a298c032f2e93c78$export$2e2bcd8739ae039))`
  circle {
    ${({ isDisabled: isDisabled })=>isDisabled && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
        fill-opacity: 0.12;
      `};
  }
`;
const $1d1a0fc2d2502366$var$Icon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  fill: ${({ theme: theme })=>theme.white};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const $1d1a0fc2d2502366$var$PlusMinusField = ({ currentValue: currentValue, updateValue: updateValue, minValue: minValue = 0, className: className })=>{
    const incrementValue = ()=>updateValue(++currentValue);
    const decrementValue = ()=>currentValue > minValue && updateValue(--currentValue);
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($1d1a0fc2d2502366$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1d1a0fc2d2502366$var$IconContainer, {
                onClick: incrementValue,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($1d1a0fc2d2502366$var$StyledEllipseIcon, {}),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($1d1a0fc2d2502366$var$Icon, {
                        as: (0, $3a8c0815bc43e4ed$export$2e2bcd8739ae039)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($1d1a0fc2d2502366$var$IconContainer, {
                onClick: decrementValue,
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)($1d1a0fc2d2502366$var$StyledEllipseIcon, {
                        isDisabled: currentValue === minValue
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)($1d1a0fc2d2502366$var$Icon, {
                        as: (0, $507c09203874ecae$export$2e2bcd8739ae039)
                    })
                ]
            })
        ]
    });
};
var $1d1a0fc2d2502366$export$2e2bcd8739ae039 = $1d1a0fc2d2502366$var$PlusMinusField;





var $cZGFG = parcelRequire("cZGFG");

var $dup7A = parcelRequire("dup7A");




var $gg0RY = parcelRequire("gg0RY");

var $lIeXU = parcelRequire("lIeXU");

var $eUiaP = parcelRequire("eUiaP");
const $97bedde0100be15c$export$f78173835dcde49f = async (address)=>{
    try {
        if ((0, $gg0RY.isAddress)(address)) return true;
        const publicClient = (0, $eUiaP.getPublicClient)({
            chainId: 1
        });
        const isValidEns = await publicClient.getEnsAddress({
            name: (0, $lIeXU.normalize)(address)
        }) !== null;
        return isValidEns;
    } catch  {
        return false;
    }
};





var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");



const $2ed937fbb0eb511d$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const $2ed937fbb0eb511d$var$StyledField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Field))`
  width: 100%;
  > small {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
const $2ed937fbb0eb511d$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  width: 100%;
  margin-bottom: 12px;
`;
const $2ed937fbb0eb511d$var$LabeledInput = (props)=>{
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($2ed937fbb0eb511d$var$Container, {
        children: [
            !(0, $2d857633ba67aa25$export$fce6876652108ab)(props.label) ? /*#__PURE__*/ (0, $cZGFG.jsx)($2ed937fbb0eb511d$var$StyledLabel, {
                id: props.label,
                children: props.label
            }) : null,
            /*#__PURE__*/ (0, $cZGFG.jsx)($2ed937fbb0eb511d$var$StyledField, {
                ...props,
                id: props?.label
            })
        ]
    });
};
var $2ed937fbb0eb511d$export$2e2bcd8739ae039 = $2ed937fbb0eb511d$var$LabeledInput;


const $25fd3dcb58448693$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 84vw;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $25fd3dcb58448693$var$AliasContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: grid;
      grid-template-columns: 190px auto;
    `)}
`;
const $25fd3dcb58448693$var$PersonFields = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const validationTimerRef = (0, $dup7A.useRef)(null);
    const debounceValidateAddress = (address, key)=>{
        // Clear the existing timer
        if (validationTimerRef.current) clearTimeout(validationTimerRef.current);
        // Set a new timer for validation after 500 milliseconds
        validationTimerRef.current = setTimeout(async ()=>{
            const isValid = await (0, $97bedde0100be15c$export$f78173835dcde49f)(address);
            const updatedAliases = disputeData.aliases;
            if ((0, $2d857633ba67aa25$export$fce6876652108ab)(updatedAliases) || (0, $2d857633ba67aa25$export$fce6876652108ab)(updatedAliases[key])) return;
            updatedAliases[key].isValid = isValid;
            setDisputeData({
                ...disputeData,
                aliases: updatedAliases
            });
        }, 300);
    };
    const handleAliasesWrite = (event)=>{
        const key = parseInt(event.target.id.replace(/\D/g, ""), 10) - 1;
        let aliases = disputeData.aliases;
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(aliases)) return;
        aliases[key] = {
            ...aliases[key],
            [event.target.name]: event.target.value
        };
        setDisputeData({
            ...disputeData,
            aliases: aliases
        });
        //since resolving ens is async, we update asynchronously too with debounce
        event.target.name === "address" && debounceValidateAddress(event.target.value, key);
    };
    const showError = (alias)=>{
        return alias.address !== "" && !alias.isValid;
    };
    return /*#__PURE__*/ (0, $cZGFG.jsx)($25fd3dcb58448693$var$Container, {
        children: disputeData.aliases?.map((alias, index)=>/*#__PURE__*/ (0, $cZGFG.jsxs)($25fd3dcb58448693$var$AliasContainer, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2ed937fbb0eb511d$export$2e2bcd8739ae039), {
                        name: "name",
                        label: `Person ${index + 1}`,
                        placeholder: "eg. Alice (Developer)",
                        value: alias.name,
                        onChange: handleAliasesWrite
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2ed937fbb0eb511d$export$2e2bcd8739ae039), {
                        name: "address",
                        label: `Person ${index + 1} Address`,
                        variant: showError(alias) ? "error" : "",
                        message: showError(alias) ? "Invalid Address or ENS" : "",
                        placeholder: "eg. Alice.eth",
                        value: alias.address,
                        onChange: handleAliasesWrite
                    })
                ]
            }, alias?.id))
    });
};
var $25fd3dcb58448693$export$2e2bcd8739ae039 = $25fd3dcb58448693$var$PersonFields;


const $3bba0d2bf27f09d2$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $3bba0d2bf27f09d2$var$StyledPlusMinusField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $1d1a0fc2d2502366$export$2e2bcd8739ae039))`
  align-self: start;
`;
const $3bba0d2bf27f09d2$var$NotablePersons = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    //value here is the total number of fields-
    const updateNumberOfAliases = (value)=>{
        let defaultAlias = {
            name: "",
            address: "",
            id: value.toString()
        };
        let aliases = disputeData.aliases;
        if ((0, $2d857633ba67aa25$export$fce6876652108ab)(aliases)) return setDisputeData({
            ...disputeData,
            aliases: [
                defaultAlias
            ]
        });
        if (value < aliases?.length) return setDisputeData({
            ...disputeData,
            aliases: aliases.splice(0, value)
        });
        if (value > aliases?.length) return setDisputeData({
            ...disputeData,
            aliases: [
                ...aliases,
                defaultAlias
            ]
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($3bba0d2bf27f09d2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Notable Persons"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $25fd3dcb58448693$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($3bba0d2bf27f09d2$var$StyledPlusMinusField, {
                currentValue: disputeData.aliases?.length ?? 2,
                updateValue: updateNumberOfAliases,
                minValue: 2
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/voting-options",
                nextRoute: "/resolver/policy"
            })
        ]
    });
};
var $3bba0d2bf27f09d2$export$2e2bcd8739ae039 = $3bba0d2bf27f09d2$var$NotablePersons;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");









var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");






const $2cc8dd6942c68f69$var$OptionsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 84vw;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $2cc8dd6942c68f69$var$InputContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: grid;
      grid-template-columns: 160px auto;
    `)}
`;
const $2cc8dd6942c68f69$var$StyledPlusMinusField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $1d1a0fc2d2502366$export$2e2bcd8739ae039))`
  align-self: start;
  margin: 32px 0px 48px;
`;
const $2cc8dd6942c68f69$var$OptionsFields = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const updateOptions = (value)=>{
        let defaultAnswer = {
            title: "",
            id: value.toString()
        };
        let answers = disputeData.answers;
        if (value < answers?.length) return setDisputeData({
            ...disputeData,
            answers: answers.splice(0, value)
        });
        if (value > answers?.length) return setDisputeData({
            ...disputeData,
            answers: [
                ...answers,
                defaultAnswer
            ]
        });
    };
    const handleOptionWrite = (event, key)=>{
        let answers = disputeData.answers;
        answers[key] = {
            ...answers[key],
            [event.target.name]: event.target.value
        };
        setDisputeData({
            ...disputeData,
            answers: answers
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($2cc8dd6942c68f69$var$OptionsContainer, {
                children: disputeData.answers.map((answer, index)=>/*#__PURE__*/ (0, $cZGFG.jsxs)($2cc8dd6942c68f69$var$InputContainer, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2ed937fbb0eb511d$export$2e2bcd8739ae039), {
                                name: "title",
                                label: `Voting Option ${index + 1}`,
                                placeholder: "eg. Pay 150 DAI",
                                value: answer.title ?? "",
                                onChange: (event)=>handleOptionWrite(event, index)
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2ed937fbb0eb511d$export$2e2bcd8739ae039), {
                                name: "description",
                                label: "Option Description (Optional)",
                                placeholder: `Description for Option ${index + 1}`,
                                value: answer.description ?? "",
                                onChange: (event)=>handleOptionWrite(event, index)
                            })
                        ]
                    }, answer.id))
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($2cc8dd6942c68f69$var$StyledPlusMinusField, {
                currentValue: disputeData.answers?.length ?? 2,
                updateValue: updateOptions,
                minValue: 2
            })
        ]
    });
};
var $2cc8dd6942c68f69$export$2e2bcd8739ae039 = $2cc8dd6942c68f69$var$OptionsFields;


const $cdb75b4845db020a$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $cdb75b4845db020a$var$QuestionField = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $2ed937fbb0eb511d$export$2e2bcd8739ae039))`
  margin-bottom: 78px;
`;
const $cdb75b4845db020a$var$AlertMessageContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 84vw;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
  > div {
    width: 100%;
  }
`;
const $cdb75b4845db020a$var$VotingOptions = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const handleQuestionWrite = (event)=>{
        setDisputeData({
            ...disputeData,
            question: event.target.value
        });
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($cdb75b4845db020a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Voting options"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cdb75b4845db020a$var$QuestionField, {
                label: "Question",
                placeholder: "eg. How much should Alice receive?",
                message: "Type the question jurors will see when voting.",
                variant: "info",
                value: disputeData.question,
                onChange: handleQuestionWrite
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2cc8dd6942c68f69$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsx)($cdb75b4845db020a$var$AlertMessageContainer, {
                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $43afcb05ca3681f6$exports.AlertMessage), {
                    title: "Add the question and options jurors will see when voting",
                    msg: "Make it clear and objective.",
                    variant: "info"
                })
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/jurors",
                nextRoute: "/resolver/notable-persons"
            })
        ]
    });
};
var $cdb75b4845db020a$export$2e2bcd8739ae039 = $cdb75b4845db020a$var$VotingOptions;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");










const $f8b2c2611a19c0dd$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $f8b2c2611a19c0dd$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  width: 84vw;
  margin-bottom: 48px;
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $f8b2c2611a19c0dd$var$StyledFileUploader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.FileUploader))`
  width: 84vw;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(52, 32)};

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(442, 700, 900)};
    `)}
`;
const $f8b2c2611a19c0dd$var$Policy = ()=>{
    const { disputeData: disputeData, setDisputeData: setDisputeData, setIsPolicyUploading: setIsPolicyUploading } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const handleFileUpload = (file)=>{
        setIsPolicyUploading(true);
        (0, $b6ddc82ff82475c2$export$b410431fab84fa58).info("Uploading Policy to IPFS", (0, $0b0903738c0da810$export$8eb3892b442747bd));
        const fileFormData = new FormData();
        fileFormData.append("data", file, file.name);
        (0, $859309432da1acd9$export$8a748dfc8dae7a64)(fileFormData, "policy").then(async (res)=>{
            const response = await res.json();
            const policyURI = response["cids"][0];
            setDisputeData({
                ...disputeData,
                policyURI: policyURI
            });
        }).catch((err)=>console.log(err)).finally(()=>setIsPolicyUploading(false));
    };
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($f8b2c2611a19c0dd$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $62295d38f7113fb2$export$2e2bcd8739ae039), {
                text: "Submit the Policy File"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($f8b2c2611a19c0dd$var$StyledLabel, {
                children: "Fundamental to any case, the Policy provides jurors with a framework to vote fairly. It can be a set of criteria, a contract stating the rights and duties of the parties, or any set of pre-defined rules that are relevant to jurors' decision-making."
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)($f8b2c2611a19c0dd$var$StyledFileUploader, {
                callback: handleFileUpload,
                variant: "info",
                msg: "You can attach additional information as a PDF file. Important: the above description must reference the relevant parts of the file content."
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/notable-persons",
                nextRoute: "/resolver/preview"
            })
        ]
    });
};
var $f8b2c2611a19c0dd$export$2e2bcd8739ae039 = $f8b2c2611a19c0dd$var$Policy;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");










const $7fe41233c878d11e$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 0px ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(10, 130)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $7fe41233c878d11e$var$StyledCard = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Card))`
  width: 100%;
  height: auto;
  min-height: 100px;
  margin-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(130, 70)};
`;
const $7fe41233c878d11e$var$PreviewContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(16, 32)};
`;
const $7fe41233c878d11e$var$Divider = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).hr`
  width: 100%;
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: 0;
`;
const $7fe41233c878d11e$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h2`
  margin-bottom: 32px;
  width: 84vw;
  text-align: center;
  color: ${({ theme: theme })=>theme.secondaryPurple};
  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: auto;
    `)}
`;
const $7fe41233c878d11e$var$Preview = ()=>{
    const { disputeData: disputeData, disputeTemplate: disputeTemplate } = (0, $402e40eea0418fd8$export$e980d1a1a195f0af)();
    const { data: courtPolicy } = (0, $3043cbfb1ed10cf4$export$e0985f714b0d92d6)(disputeData.courtId);
    const courtName = courtPolicy?.name;
    return /*#__PURE__*/ (0, $cZGFG.jsxs)($7fe41233c878d11e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)($7fe41233c878d11e$var$Header, {
                children: "Preview"
            }),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($7fe41233c878d11e$var$StyledCard, {
                children: [
                    /*#__PURE__*/ (0, $cZGFG.jsxs)($7fe41233c878d11e$var$PreviewContainer, {
                        children: [
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $829f76996267db48$export$e7a634c764273922), {
                                disputeDetails: disputeTemplate
                            }),
                            /*#__PURE__*/ (0, $cZGFG.jsx)($7fe41233c878d11e$var$Divider, {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $59b5241b7985f8c2$export$2e2bcd8739ae039), {
                                isOverview: true,
                                overrideIsList: true,
                                courtId: disputeData.courtId,
                                court: courtName,
                                round: 1,
                                category: disputeData.category
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $80e9b305c1fae669$export$e9859ad90648930b), {
                        disputePolicyURI: disputeTemplate.policyURI,
                        courtId: disputeData.courtId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $16ec13d0d676614c$export$2e2bcd8739ae039), {
                prevRoute: "/resolver/policy"
            })
        ]
    });
};
var $7fe41233c878d11e$export$2e2bcd8739ae039 = $7fe41233c878d11e$var$Preview;



var $cZGFG = parcelRequire("cZGFG");
parcelRequire("dup7A");




const $c23f7c812346add3$var$StyledSteps = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Steps))`
  display: none;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: flex;
      position: absolute;
      left: 2%;
      height: 360px;
    `)}
`;
const $c23f7c812346add3$var$items = [
    {
        title: "Briefing",
        subitems: [
            "Title",
            "Description"
        ]
    },
    {
        title: "Parameters",
        subitems: [
            "Court",
            "Category",
            "Jurors",
            "Voting Options",
            "Notable Persons"
        ]
    },
    {
        title: "Policy"
    },
    {
        title: "Preview"
    }
];
const $c23f7c812346add3$var$Timeline = ()=>{
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const routeToIndexMap = {
        "/resolver/title": 0,
        "/resolver/description": 0,
        "/resolver/court": 1,
        "/resolver/category": 1,
        "/resolver/jurors": 1,
        "/resolver/voting-options": 1,
        "/resolver/notable-persons": 1,
        "/resolver/policy": 2,
        "/resolver/preview": 3
    };
    const currentItemIndex = Object.entries(routeToIndexMap).reduce((acc, [route, index])=>location.pathname.includes(route) ? index : acc, 0);
    return /*#__PURE__*/ (0, $cZGFG.jsx)($c23f7c812346add3$var$StyledSteps, {
        items: $c23f7c812346add3$var$items,
        currentItemIndex: currentItemIndex
    });
};
var $c23f7c812346add3$export$2e2bcd8739ae039 = $c23f7c812346add3$var$Timeline;


const $2ee9f47bb9d3eaf5$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 32)};
  padding-top: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(24, 28)};
  padding-bottom: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $2ee9f47bb9d3eaf5$var$ConnectWalletContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $2ee9f47bb9d3eaf5$var$MiddleContentContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  position: relative;
`;
const $2ee9f47bb9d3eaf5$var$StyledLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  display: none;

  ${(0, $1a81a644a2506b99$export$7432a1a850ec2b36)(()=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      display: flex;
      color: ${({ theme: theme })=>theme.secondaryPurple};
      margin-bottom: 20px;
      padding-left: ${(0, $72173f5a1c3efd56$export$1b3e91ab3ce1a831)(25, 65)};
    `)}
`;
const $2ee9f47bb9d3eaf5$var$DisputeResolver = ()=>{
    const location = (0, $5c6d50c15e61ec01$export$45d76561a5302f2b)();
    const { isConnected: isConnected } = (0, $1d657eb5d64e17dc$export$83a8e409853da004)();
    const isPreviewPage = location.pathname.includes("/preview");
    return /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $cZGFG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $0baf26b3b0f0403b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cZGFG.jsxs)($2ee9f47bb9d3eaf5$var$Container, {
                children: [
                    isConnected && !isPreviewPage ? /*#__PURE__*/ (0, $cZGFG.jsx)($2ee9f47bb9d3eaf5$var$StyledLabel, {
                        children: "Start a case"
                    }) : null,
                    isConnected ? /*#__PURE__*/ (0, $cZGFG.jsxs)($2ee9f47bb9d3eaf5$var$MiddleContentContainer, {
                        children: [
                            isConnected && !isPreviewPage ? /*#__PURE__*/ (0, $cZGFG.jsx)((0, $c23f7c812346add3$export$2e2bcd8739ae039), {}) : null,
                            /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$444b3ab0cb9aec40), {
                                            to: "title",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/title/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $37ec7b6f3e1ff675$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/description/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $081e01c3f7d68814$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/court/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $21dc216480f69e9d$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/category/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $536303788b1828d6$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/jurors/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $22e7b3821e066bfe$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/voting-options/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $cdb75b4845db020a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/notable-persons/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $3bba0d2bf27f09d2$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/policy/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f8b2c2611a19c0dd$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/preview/*",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $7fe41233c878d11e$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cZGFG.jsxs)($2ee9f47bb9d3eaf5$var$ConnectWalletContainer, {
                        children: [
                            "To create a new dispute, connect first",
                            /*#__PURE__*/ (0, $cZGFG.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5fd7f782fb0a380f$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $2ee9f47bb9d3eaf5$export$2e2bcd8739ae039 = $2ee9f47bb9d3eaf5$var$DisputeResolver;



var $dup7A = parcelRequire("dup7A");
// eslint-disable-next-line @typescript-eslint/unbound-method
const $48dc9950f67ce5b4$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$e6127cc7fe7395c3(wat) {
    switch($48dc9950f67ce5b4$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $48dc9950f67ce5b4$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$var$isBuiltin(wat, className) {
    return $48dc9950f67ce5b4$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$9f9636d330b71954(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$ef9e2056653f0c8e(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$12e869b2a583f783(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$844ec244b1367d54(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$c3825b437cbdea5c(wat) {
    return wat === null || $48dc9950f67ce5b4$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$53b83ca8eaab0383(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $48dc9950f67ce5b4$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $48dc9950f67ce5b4$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$49841c62b9eff15(wat) {
    return $48dc9950f67ce5b4$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $48dc9950f67ce5b4$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$bc2894c7158efbac(wat) {
    return $48dc9950f67ce5b4$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $48dc9950f67ce5b4$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $e237680456fd85d0$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $e237680456fd85d0$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $e237680456fd85d0$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $e237680456fd85d0$var$isGlobalObj(window) || typeof self == "object" && $e237680456fd85d0$var$isGlobalObj(self) || typeof $parcel$global == "object" && $e237680456fd85d0$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $e237680456fd85d0$export$256479dc0cea61c4() {
    return $e237680456fd85d0$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $e237680456fd85d0$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $e237680456fd85d0$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


// eslint-disable-next-line deprecation/deprecation
const $1862e47d17ed8624$var$WINDOW = (0, $e237680456fd85d0$export$256479dc0cea61c4)();
const $1862e47d17ed8624$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1862e47d17ed8624$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1862e47d17ed8624$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1862e47d17ed8624$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1862e47d17ed8624$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($1862e47d17ed8624$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $1862e47d17ed8624$export$1cfafeee2987818b() {
    try {
        return $1862e47d17ed8624$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1862e47d17ed8624$export$c660c1f3ab49225c(selector) {
    if ($1862e47d17ed8624$var$WINDOW.document && $1862e47d17ed8624$var$WINDOW.document.querySelector) return $1862e47d17ed8624$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $1862e47d17ed8624$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$1862e47d17ed8624$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4823161d30d5d56f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;





/** Prefix for logging strings */ const $6a114848ff8dae1d$var$PREFIX = "Sentry Logger ";
const $6a114848ff8dae1d$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $6a114848ff8dae1d$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $6a114848ff8dae1d$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $e237680456fd85d0$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6a114848ff8dae1d$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6a114848ff8dae1d$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6a114848ff8dae1d$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $4823161d30d5d56f$export$16a28057038b10ef) $6a114848ff8dae1d$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $6a114848ff8dae1d$export$cda52e2a8927a2ca(()=>{
                (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).console[name](`${$6a114848ff8dae1d$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $6a114848ff8dae1d$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $6a114848ff8dae1d$export$af88d00dbe7f521 = $6a114848ff8dae1d$var$makeLogger();



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $662e93ac017d9860$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $662e93ac017d9860$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $662e93ac017d9860$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $48dc9950f67ce5b4$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $662e93ac017d9860$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $48dc9950f67ce5b4$export$844ec244b1367d54)(value)) return false;
    if ((0, $48dc9950f67ce5b4$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $48dc9950f67ce5b4$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $662e93ac017d9860$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$662e93ac017d9860$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $95e32bdd0672a295$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $95e32bdd0672a295$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $95e32bdd0672a295$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $4823161d30d5d56f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $95e32bdd0672a295$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $95e32bdd0672a295$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $95e32bdd0672a295$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $95e32bdd0672a295$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $95e32bdd0672a295$export$62ff257738bf57f5(value) {
    if ((0, $48dc9950f67ce5b4$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$95e32bdd0672a295$var$getOwnProperties(value)
    };
    else if ((0, $48dc9950f67ce5b4$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $95e32bdd0672a295$var$serializeEventTarget(value.target),
            currentTarget: $95e32bdd0672a295$var$serializeEventTarget(value.currentTarget),
            ...$95e32bdd0672a295$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $48dc9950f67ce5b4$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $95e32bdd0672a295$var$serializeEventTarget(target) {
    try {
        return (0, $48dc9950f67ce5b4$export$45a5e7f76e0caa8d)(target) ? (0, $1862e47d17ed8624$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $95e32bdd0672a295$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $95e32bdd0672a295$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($95e32bdd0672a295$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $662e93ac017d9860$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $662e93ac017d9860$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $95e32bdd0672a295$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $95e32bdd0672a295$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $95e32bdd0672a295$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($95e32bdd0672a295$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $95e32bdd0672a295$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($95e32bdd0672a295$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $95e32bdd0672a295$var$isPojo(input) {
    if (!(0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $95e32bdd0672a295$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $48dc9950f67ce5b4$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $a4aec27f2b28cb05$export$19f53698e68b2496() {
    const gbl = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $a4aec27f2b28cb05$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $a4aec27f2b28cb05$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $a4aec27f2b28cb05$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $a4aec27f2b28cb05$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $a4aec27f2b28cb05$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $a4aec27f2b28cb05$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $a4aec27f2b28cb05$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $a4aec27f2b28cb05$export$d364f2020ab30578(input) {
    const match = input.match($a4aec27f2b28cb05$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $a4aec27f2b28cb05$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $662e93ac017d9860$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $662e93ac017d9860$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $662e93ac017d9860$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $a4aec27f2b28cb05$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $95e32bdd0672a295$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $a4aec27f2b28cb05$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9266143fc5665ff4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $e0170d90e8c79bf3$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($e0170d90e8c79bf3$var$States || ($e0170d90e8c79bf3$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $e0170d90e8c79bf3$export$1fda8aa4d135f8aa(value) {
    return new $e0170d90e8c79bf3$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $e0170d90e8c79bf3$export$78e43115b553f358(reason) {
    return new $e0170d90e8c79bf3$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $e0170d90e8c79bf3$export$6f292d4960313241 {
    constructor(executor){
        $e0170d90e8c79bf3$export$6f292d4960313241.prototype.__init.call(this);
        $e0170d90e8c79bf3$export$6f292d4960313241.prototype.__init2.call(this);
        $e0170d90e8c79bf3$export$6f292d4960313241.prototype.__init3.call(this);
        $e0170d90e8c79bf3$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $e0170d90e8c79bf3$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $e0170d90e8c79bf3$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $e0170d90e8c79bf3$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($e0170d90e8c79bf3$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($e0170d90e8c79bf3$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $e0170d90e8c79bf3$var$States.PENDING) return;
            if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $e0170d90e8c79bf3$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $e0170d90e8c79bf3$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $e0170d90e8c79bf3$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $9d8ff6549e1d9a72$export$3c4238858b85e8ac() {
    return (0, $e237680456fd85d0$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $9d8ff6549e1d9a72$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $9d8ff6549e1d9a72$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $9d8ff6549e1d9a72$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $e0170d90e8c79bf3$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && processor.id && result === null && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(result)) result.then((final)=>$9d8ff6549e1d9a72$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $9d8ff6549e1d9a72$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



const $9b109844d4ad1b74$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $9b109844d4ad1b74$export$7740643b9eeaf0c4() {
    return Date.now() / $9b109844d4ad1b74$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9b109844d4ad1b74$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $9b109844d4ad1b74$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $9b109844d4ad1b74$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $9b109844d4ad1b74$export$ee52dced521e3e18 = $9b109844d4ad1b74$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $9b109844d4ad1b74$export$c5907b5a8838db13 = $9b109844d4ad1b74$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $9b109844d4ad1b74$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $9b109844d4ad1b74$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $9b109844d4ad1b74$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $9b109844d4ad1b74$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $9b109844d4ad1b74$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $9b109844d4ad1b74$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();


const $4fdd446dbc10d80f$export$849dbeeeda01ae98 = "production";









/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $8b1b4b61d8616537$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$8b1b4b61d8616537$var$sessionToJSON(session)
    };
    if (context) $8b1b4b61d8616537$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $8b1b4b61d8616537$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $8b1b4b61d8616537$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $8b1b4b61d8616537$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $8b1b4b61d8616537$var$sessionToJSON(session) {
    return (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $8d3523928e82f4f4$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $e6f403c2b28dea63$export$9ca9946bd449ac06 = "baggage";
const $e6f403c2b28dea63$export$6e69537d67fa20f = "sentry-";
const $e6f403c2b28dea63$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $e6f403c2b28dea63$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $e6f403c2b28dea63$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $48dc9950f67ce5b4$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $e6f403c2b28dea63$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $e6f403c2b28dea63$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($e6f403c2b28dea63$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($e6f403c2b28dea63$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $e6f403c2b28dea63$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$e6f403c2b28dea63$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $e6f403c2b28dea63$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $e6f403c2b28dea63$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $e6f403c2b28dea63$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $e6f403c2b28dea63$export$bdd844ddb2def819) {
            (0, $4823161d30d5d56f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $adb2e0f3471b4e35$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $adb2e0f3471b4e35$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($adb2e0f3471b4e35$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $adb2e0f3471b4e35$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $adb2e0f3471b4e35$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $e6f403c2b28dea63$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
            spanId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16),
            spanId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $adb2e0f3471b4e35$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $adb2e0f3471b4e35$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $e6f403c2b28dea63$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
        spanId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16),
        spanId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $adb2e0f3471b4e35$export$f35d907436da45cf(traceId = (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(), spanId = (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $386b8b8fbbe8a075$export$208d5b368507fb8b = 0x0;
const $386b8b8fbbe8a075$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $386b8b8fbbe8a075$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $386b8b8fbbe8a075$export$92d8c23565496537(span);
    return (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $386b8b8fbbe8a075$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $386b8b8fbbe8a075$export$5caecac1caaf3a71(span);
    return (0, $adb2e0f3471b4e35$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $386b8b8fbbe8a075$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $386b8b8fbbe8a075$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $386b8b8fbbe8a075$var$ensureTimestampInSeconds(input.getTime());
    return (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $386b8b8fbbe8a075$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $386b8b8fbbe8a075$export$92d8c23565496537(span) {
    if ($386b8b8fbbe8a075$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $386b8b8fbbe8a075$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $386b8b8fbbe8a075$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $386b8b8fbbe8a075$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0e7916f5f7c1b648$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
        environment: options.environment || (0, $4fdd446dbc10d80f$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0e7916f5f7c1b648$export$a117f995597e25df(span) {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $0e7916f5f7c1b648$export$366bad00d6815eed((0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).trace_id || "", client, (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $8d3523928e82f4f4$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $386b8b8fbbe8a075$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $1cce09cd973639d1$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $1cce09cd973639d1$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $1cce09cd973639d1$var$applySpanToEvent(event, span);
    $1cce09cd973639d1$var$applyFingerprintToEvent(event, fingerprint);
    $1cce09cd973639d1$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $1cce09cd973639d1$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $1cce09cd973639d1$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $1cce09cd973639d1$export$b1a120a2871faa46(data, "extra", extra);
    $1cce09cd973639d1$export$b1a120a2871faa46(data, "tags", tags);
    $1cce09cd973639d1$export$b1a120a2871faa46(data, "user", user);
    $1cce09cd973639d1$export$b1a120a2871faa46(data, "contexts", contexts);
    $1cce09cd973639d1$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $1cce09cd973639d1$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $1cce09cd973639d1$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $95e32bdd0672a295$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $95e32bdd0672a295$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $95e32bdd0672a295$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $95e32bdd0672a295$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $1cce09cd973639d1$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $1cce09cd973639d1$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $1cce09cd973639d1$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $386b8b8fbbe8a075$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $8d3523928e82f4f4$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $0e7916f5f7c1b648$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $1cce09cd973639d1$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $a4aec27f2b28cb05$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $0d25217c6bb12b05$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $0d25217c6bb12b05$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $0d25217c6bb12b05$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $0d25217c6bb12b05$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $0d25217c6bb12b05$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $0d25217c6bb12b05$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $8b1b4b61d8616537$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $0d25217c6bb12b05$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $0d25217c6bb12b05$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $0d25217c6bb12b05$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $9b109844d4ad1b74$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $1cce09cd973639d1$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $9d8ff6549e1d9a72$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $9d8ff6549e1d9a72$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $0d25217c6bb12b05$export$aa55d5ab8e05984f() {
    if (!$0d25217c6bb12b05$var$globalScope) $0d25217c6bb12b05$var$globalScope = new $0d25217c6bb12b05$export$775b6bb06e53a214();
    return $0d25217c6bb12b05$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $0d25217c6bb12b05$export$c83048efd17527d6(scope) {
    $0d25217c6bb12b05$var$globalScope = scope;
}
function $0d25217c6bb12b05$var$generatePropagationContext() {
    return {
        traceId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
        spanId: (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16)
    };
}



const $eac5488800c23079$export$31499a9cd224b78c = "7.114.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $970ec608023beb99$export$24a86ef7798177e4 = parseFloat((0, $eac5488800c23079$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $970ec608023beb99$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $970ec608023beb99$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $970ec608023beb99$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $0d25217c6bb12b05$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $0d25217c6bb12b05$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $970ec608023beb99$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $9b109844d4ad1b74$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $6a114848ff8dae1d$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $970ec608023beb99$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $970ec608023beb99$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $9266143fc5665ff4$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8b1b4b61d8616537$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $4fdd446dbc10d80f$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $8b1b4b61d8616537$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $8b1b4b61d8616537$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $970ec608023beb99$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $970ec608023beb99$export$19eade501500c6c1() {
    (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $e237680456fd85d0$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$export$4188a14ad302d1bc(hub) {
    const registry = $970ec608023beb99$export$19eade501500c6c1();
    const oldHub = $970ec608023beb99$export$bfa8a924a84a76b7(registry);
    $970ec608023beb99$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $970ec608023beb99$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $970ec608023beb99$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $970ec608023beb99$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $970ec608023beb99$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$var$getGlobalHub(registry = $970ec608023beb99$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$970ec608023beb99$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $970ec608023beb99$export$bfa8a924a84a76b7(registry).isOlderThan($970ec608023beb99$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $970ec608023beb99$export$849f05434e95d2f2(registry, new $970ec608023beb99$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $970ec608023beb99$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$export$236689a79f5aa020(carrier, parent = $970ec608023beb99$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$970ec608023beb99$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $970ec608023beb99$export$bfa8a924a84a76b7(carrier).isOlderThan($970ec608023beb99$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $970ec608023beb99$export$849f05434e95d2f2(carrier, new $970ec608023beb99$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $970ec608023beb99$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $970ec608023beb99$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $970ec608023beb99$export$70d775fb1f267027(callback, options = {}) {
    const registry = $970ec608023beb99$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $970ec608023beb99$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e237680456fd85d0$export$7e223ec222791509)("hub", ()=>new $970ec608023beb99$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $970ec608023beb99$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $4fe357a034f1d74a$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $e050383763f01754$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $e050383763f01754$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $e050383763f01754$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $121116598fbd347a$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $121116598fbd347a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $121116598fbd347a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $121116598fbd347a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $121116598fbd347a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($121116598fbd347a$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $121116598fbd347a$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $121116598fbd347a$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $121116598fbd347a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $121116598fbd347a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $121116598fbd347a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($121116598fbd347a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($121116598fbd347a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $121116598fbd347a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $121116598fbd347a$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $121116598fbd347a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $121116598fbd347a$var$defaultFunctionName;
        return fn.name || $121116598fbd347a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $121116598fbd347a$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $121116598fbd347a$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $e050383763f01754$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c207ff544b279d26$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $c207ff544b279d26$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $c207ff544b279d26$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $c207ff544b279d26$export$a3295358bff77e(object, depth);
    if ($c207ff544b279d26$var$jsonSize(normalized) > maxSize) return $c207ff544b279d26$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $c207ff544b279d26$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $4fe357a034f1d74a$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $48dc9950f67ce5b4$export$c9f5652083b8129d)(value)) return value;
    const stringified = $c207ff544b279d26$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $c207ff544b279d26$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $95e32bdd0672a295$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $c207ff544b279d26$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $c207ff544b279d26$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $48dc9950f67ce5b4$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $48dc9950f67ce5b4$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $121116598fbd347a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $c207ff544b279d26$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $c207ff544b279d26$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $c207ff544b279d26$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c207ff544b279d26$var$jsonSize(value) {
    return $c207ff544b279d26$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $c207ff544b279d26$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $2ac4975231ecf8de$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $9b109844d4ad1b74$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $2ac4975231ecf8de$var$applyClientOptions(prepared, options);
    $2ac4975231ecf8de$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $2ac4975231ecf8de$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $2ac4975231ecf8de$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $0d25217c6bb12b05$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $1cce09cd973639d1$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $1cce09cd973639d1$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $1cce09cd973639d1$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $9d8ff6549e1d9a72$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $9d8ff6549e1d9a72$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $2ac4975231ecf8de$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $2ac4975231ecf8de$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $2ac4975231ecf8de$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $4fdd446dbc10d80f$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $662e93ac017d9860$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $662e93ac017d9860$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $662e93ac017d9860$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $2ac4975231ecf8de$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $2ac4975231ecf8de$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $2ac4975231ecf8de$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $2ac4975231ecf8de$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $2ac4975231ecf8de$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $2ac4975231ecf8de$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $2ac4975231ecf8de$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $c207ff544b279d26$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $c207ff544b279d26$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $c207ff544b279d26$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $c207ff544b279d26$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $c207ff544b279d26$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $c207ff544b279d26$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $2ac4975231ecf8de$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $0d25217c6bb12b05$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $2ac4975231ecf8de$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($2ac4975231ecf8de$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($2ac4975231ecf8de$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $2ac4975231ecf8de$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $0d25217c6bb12b05$export$775b6bb06e53a214) || typeof hint === "function";
}
const $2ac4975231ecf8de$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $2ac4975231ecf8de$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$2ac4975231ecf8de$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $cbe719ec84d28c68$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().captureException(exception, (0, $2ac4975231ecf8de$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $cbe719ec84d28c68$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $cbe719ec84d28c68$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $cbe719ec84d28c68$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $cbe719ec84d28c68$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $970ec608023beb99$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $cbe719ec84d28c68$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $cbe719ec84d28c68$export$9a4fed82c350c2bd(callback) {
    return (0, $970ec608023beb99$export$70d775fb1f267027)(()=>{
        return callback((0, $970ec608023beb99$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $cbe719ec84d28c68$export$e57ac09b143d92a2(span, callback) {
    return $cbe719ec84d28c68$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $cbe719ec84d28c68$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $cbe719ec84d28c68$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $cbe719ec84d28c68$export$c7be4b0125a10cba();
    const client = $cbe719ec84d28c68$export$6bb76d6eba7e258c();
    if (!client) (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $cbe719ec84d28c68$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $cbe719ec84d28c68$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $cbe719ec84d28c68$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $9b109844d4ad1b74$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $cbe719ec84d28c68$export$4909b86c8034bf73(timeout) {
    const client = $cbe719ec84d28c68$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $cbe719ec84d28c68$export$8360e631d277ea4d(timeout) {
    const client = $cbe719ec84d28c68$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $cbe719ec84d28c68$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $cbe719ec84d28c68$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $cbe719ec84d28c68$export$3f95c6f800b78024() {
    return !!$cbe719ec84d28c68$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $cbe719ec84d28c68$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $970ec608023beb99$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $cbe719ec84d28c68$export$c0d84948cecf78d8(context) {
    const client = $cbe719ec84d28c68$export$6bb76d6eba7e258c();
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    const currentScope = $cbe719ec84d28c68$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $4fdd446dbc10d80f$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $8b1b4b61d8616537$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $8b1b4b61d8616537$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $cbe719ec84d28c68$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $cbe719ec84d28c68$export$17a5be43989a0bc1() {
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    const currentScope = $cbe719ec84d28c68$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $8b1b4b61d8616537$export$56521d9ba90f62ee)(session);
    $cbe719ec84d28c68$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $cbe719ec84d28c68$var$_sendSessionUpdate() {
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    const currentScope = $cbe719ec84d28c68$export$c7be4b0125a10cba();
    const client = $cbe719ec84d28c68$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $cbe719ec84d28c68$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $cbe719ec84d28c68$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $cbe719ec84d28c68$var$_sendSessionUpdate();
}



const $bd021bfb8acb0c22$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $bd021bfb8acb0c22$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $bd021bfb8acb0c22$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $a4aec27f2b28cb05$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $bd021bfb8acb0c22$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $bd021bfb8acb0c22$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $bd021bfb8acb0c22$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $bd021bfb8acb0c22$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $bd021bfb8acb0c22$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $bd021bfb8acb0c22$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($bd021bfb8acb0c22$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $9d8ff6549e1d9a72$export$8e4e25f54d456511), (0, $970ec608023beb99$export$a07cdf6544bbd7c));
        $bd021bfb8acb0c22$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $bd021bfb8acb0c22$export$2d8f5188773bcddd(integration) {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $bd021bfb8acb0c22$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $bd021bfb8acb0c22$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $bd021bfb8acb0c22$export$2323046b9414659f(fn) {
    return fn;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $11d1c99fee2f5edd$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;








const $f6edc5f11df97b11$export$56d8a8a25bd48b81 = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
let $f6edc5f11df97b11$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $f6edc5f11df97b11$export$b79738ab10c590b2() {
    return $f6edc5f11df97b11$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $f6edc5f11df97b11$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $f6edc5f11df97b11$var$ignoreOnError++;
    setTimeout(()=>{
        $f6edc5f11df97b11$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $f6edc5f11df97b11$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $95e32bdd0672a295$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$f6edc5f11df97b11$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $f6edc5f11df97b11$export$1265a142ff5ba165();
            (0, $cbe719ec84d28c68$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $a4aec27f2b28cb05$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $cbe719ec84d28c68$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $95e32bdd0672a295$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $95e32bdd0672a295$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}





/** Regular expression used to parse a Dsn. */ const $c42afaae0022aed0$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $c42afaae0022aed0$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $c42afaae0022aed0$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $c42afaae0022aed0$export$b892860177f70a30(str) {
    const match = $c42afaae0022aed0$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $6a114848ff8dae1d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $c42afaae0022aed0$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $c42afaae0022aed0$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $c42afaae0022aed0$var$validateDsn(dsn) {
    if (!(0, $4823161d30d5d56f$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$c42afaae0022aed0$var$isValidProtocol(protocol)) {
        (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $c42afaae0022aed0$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $c42afaae0022aed0$export$b892860177f70a30(from) : $c42afaae0022aed0$var$dsnFromComponents(from);
    if (!components || !$c42afaae0022aed0$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a526f2a77773274f$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a526f2a77773274f$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a526f2a77773274f$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a526f2a77773274f$export$604a45d95a155e2b(envelope, types) {
    return $a526f2a77773274f$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $a526f2a77773274f$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $a526f2a77773274f$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $a526f2a77773274f$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $a526f2a77773274f$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $c207ff544b279d26$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $a526f2a77773274f$var$concatBuffers(parts);
}
function $a526f2a77773274f$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a526f2a77773274f$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $a526f2a77773274f$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $a526f2a77773274f$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $a526f2a77773274f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a526f2a77773274f$export$b11169581eeaf237(type) {
    return $a526f2a77773274f$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $a526f2a77773274f$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a526f2a77773274f$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/* eslint-disable max-lines */ const $3ff83b7ca9f1c666$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $3ff83b7ca9f1c666$var$THREAD_ID_STRING = String(0);
const $3ff83b7ca9f1c666$var$THREAD_NAME = "main";
// Machine properties (eval only once)
let $3ff83b7ca9f1c666$var$OS_PLATFORM = "";
let $3ff83b7ca9f1c666$var$OS_PLATFORM_VERSION = "";
let $3ff83b7ca9f1c666$var$OS_ARCH = "";
let $3ff83b7ca9f1c666$var$OS_BROWSER = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.userAgent || "";
let $3ff83b7ca9f1c666$var$OS_MODEL = "";
const $3ff83b7ca9f1c666$var$OS_LOCALE = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.language || (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.languages && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.languages[0] || "";
function $3ff83b7ca9f1c666$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $3ff83b7ca9f1c666$var$userAgentData = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.userAgentData;
if ($3ff83b7ca9f1c666$var$isUserAgentData($3ff83b7ca9f1c666$var$userAgentData)) $3ff83b7ca9f1c666$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $3ff83b7ca9f1c666$var$OS_PLATFORM = ua.platform || "";
    $3ff83b7ca9f1c666$var$OS_ARCH = ua.architecture || "";
    $3ff83b7ca9f1c666$var$OS_MODEL = ua.model || "";
    $3ff83b7ca9f1c666$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $3ff83b7ca9f1c666$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $3ff83b7ca9f1c666$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $3ff83b7ca9f1c666$export$7cbe6c4f12ea8325(profile) {
    if (!$3ff83b7ca9f1c666$var$isProcessedJSSelfProfile(profile)) return profile;
    return $3ff83b7ca9f1c666$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $3ff83b7ca9f1c666$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $3ff83b7ca9f1c666$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $3ff83b7ca9f1c666$var$getTraceId(event);
    const enrichedThreadProfile = $3ff83b7ca9f1c666$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $4fdd446dbc10d80f$export$849dbeeeda01ae98),
        runtime: {
            name: "javascript",
            version: (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $3ff83b7ca9f1c666$var$OS_PLATFORM,
            version: $3ff83b7ca9f1c666$var$OS_PLATFORM_VERSION,
            build_number: $3ff83b7ca9f1c666$var$OS_BROWSER
        },
        device: {
            locale: $3ff83b7ca9f1c666$var$OS_LOCALE,
            model: $3ff83b7ca9f1c666$var$OS_MODEL,
            manufacturer: $3ff83b7ca9f1c666$var$OS_BROWSER,
            architecture: $3ff83b7ca9f1c666$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $3ff83b7ca9f1c666$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)(),
                trace_id: traceId,
                active_thread_id: $3ff83b7ca9f1c666$var$THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function $3ff83b7ca9f1c666$export$7c501dd6adb8177c(transaction) {
    return transaction.op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $3ff83b7ca9f1c666$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$3ff83b7ca9f1c666$var$THREAD_ID_STRING]: {
                name: $3ff83b7ca9f1c666$var$THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : (0, $9b109844d4ad1b74$export$baf075a948ffc0bf) || 0;
    const adjustForOriginChange = origin - ((0, $9b109844d4ad1b74$export$baf075a948ffc0bf) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $3ff83b7ca9f1c666$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $3ff83b7ca9f1c666$var$THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $3ff83b7ca9f1c666$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $3ff83b7ca9f1c666$var$THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $3ff83b7ca9f1c666$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $3ff83b7ca9f1c666$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $a526f2a77773274f$export$c56c55acf0136fd3)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
const $3ff83b7ca9f1c666$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $3ff83b7ca9f1c666$export$4c0b0d8ee0d018b5(resource_paths) {
    const debugIdMap = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $3ff83b7ca9f1c666$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $3ff83b7ca9f1c666$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $3ff83b7ca9f1c666$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $3ff83b7ca9f1c666$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $3ff83b7ca9f1c666$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $3ff83b7ca9f1c666$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $3ff83b7ca9f1c666$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $3ff83b7ca9f1c666$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).Profiler;
    if (!$3ff83b7ca9f1c666$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($3ff83b7ca9f1c666$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) {
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Disabling profiling for current user session.");
        }
        $3ff83b7ca9f1c666$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $3ff83b7ca9f1c666$export$ea6683c0c72c1201(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($3ff83b7ca9f1c666$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$3ff83b7ca9f1c666$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $3ff83b7ca9f1c666$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$3ff83b7ca9f1c666$var$isValidProfile(profile)) return null;
    return $3ff83b7ca9f1c666$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const $3ff83b7ca9f1c666$var$PROFILE_MAP = new Map();
/**
 *
 */ function $3ff83b7ca9f1c666$export$9d723f414195854a() {
    return $3ff83b7ca9f1c666$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $3ff83b7ca9f1c666$export$6285310796363de1(profile_id) {
    const profile = $3ff83b7ca9f1c666$var$PROFILE_MAP.get(profile_id);
    if (profile) $3ff83b7ca9f1c666$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $3ff83b7ca9f1c666$export$7ddae68097f7e530(profile_id, profile) {
    $3ff83b7ca9f1c666$var$PROFILE_MAP.set(profile_id, profile);
    if ($3ff83b7ca9f1c666$var$PROFILE_MAP.size > 30) {
        const last = $3ff83b7ca9f1c666$var$PROFILE_MAP.keys().next().value;
        $3ff83b7ca9f1c666$var$PROFILE_MAP.delete(last);
    }
}


/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function $3eed3e509d516783$export$410ca53b300571c6(transaction) {
    if (!transaction) {
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] Transaction is undefined, skipping profiling");
        return transaction;
    }
    if ((0, $3ff83b7ca9f1c666$export$ea6683c0c72c1201)(transaction)) return $3eed3e509d516783$export$a5c90b2530e76e64(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $3eed3e509d516783$export$a5c90b2530e76e64(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $3ff83b7ca9f1c666$export$7c501dd6adb8177c)(transaction)) startTimestamp = (0, $9b109844d4ad1b74$export$ee52dced521e3e18)() * 1000;
    const profiler = (0, $3ff83b7ca9f1c666$export$9f4f648547a4284f)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] started profiling transaction: ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] stopped profiling of transaction: ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] profiler returned null profile for: ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction).description}`, "this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started");
                return null;
            }
            (0, $3ff83b7ca9f1c666$export$7ddae68097f7e530)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] error while stopping profiler:", error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $11d1c99fee2f5edd$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $3ff83b7ca9f1c666$export$8640c0b5c7d98a81));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext("profile", {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}



const $b89879432870128a$var$INTEGRATION_NAME = "BrowserProfiling";
const $b89879432870128a$var$_browserProfilingIntegration = ()=>{
    return {
        name: $b89879432870128a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, $3ff83b7ca9f1c666$export$7c501dd6adb8177c)(transaction)) {
                if ((0, $3ff83b7ca9f1c666$export$ea6683c0c72c1201)(transaction)) (0, $3eed3e509d516783$export$a5c90b2530e76e64)(transaction);
            }
            if (typeof client.on !== "function") {
                (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Profiling] Client does not support hooks, profiling will be disabled");
                return;
            }
            client.on("startTransaction", (transaction)=>{
                if ((0, $3ff83b7ca9f1c666$export$ea6683c0c72c1201)(transaction)) (0, $3eed3e509d516783$export$a5c90b2530e76e64)(transaction);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $3ff83b7ca9f1c666$export$9d723f414195854a)()) return;
                const profiledTransactionEvents = (0, $3ff83b7ca9f1c666$export$df9bb0fc214ff8cd)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context["profile"] && context["profile"]["profile_id"];
                    const start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context["profile"]) delete context.profile;
                    const profile = (0, $3ff83b7ca9f1c666$export$6285310796363de1)(profile_id);
                    if (!profile) {
                        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $3ff83b7ca9f1c666$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $3ff83b7ca9f1c666$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $b89879432870128a$export$2c7b5d6dd5622f23 = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($b89879432870128a$var$_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b89879432870128a$export$b0fe88803ed435e0 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($b89879432870128a$var$INTEGRATION_NAME, $b89879432870128a$export$2c7b5d6dd5622f23);









// We keep the handlers globally
const $55473128f666b930$var$handlers = {};
const $55473128f666b930$var$instrumented = {};
/** Add a handler function. */ function $55473128f666b930$export$a4e09611e30da72e(type, handler) {
    $55473128f666b930$var$handlers[type] = $55473128f666b930$var$handlers[type] || [];
    $55473128f666b930$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $55473128f666b930$export$b17eab759a1cb5fe() {
    Object.keys($55473128f666b930$var$handlers).forEach((key)=>{
        $55473128f666b930$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $55473128f666b930$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$55473128f666b930$var$instrumented[type]) {
        instrumentFn();
        $55473128f666b930$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $55473128f666b930$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $55473128f666b930$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4823161d30d5d56f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $121116598fbd347a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $277ad536ce22c36e$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $277ad536ce22c36e$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $277ad536ce22c36e$var$instrumentError);
}
function $277ad536ce22c36e$var$instrumentError() {
    $277ad536ce22c36e$var$_oldOnErrorHandler = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onerror;
    (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $55473128f666b930$export$b18c893e424d3127)("error", handlerData);
        if ($277ad536ce22c36e$var$_oldOnErrorHandler && !$277ad536ce22c36e$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $277ad536ce22c36e$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $078045da06d770e8$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $078045da06d770e8$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $078045da06d770e8$var$instrumentUnhandledRejection);
}
function $078045da06d770e8$var$instrumentUnhandledRejection() {
    $078045da06d770e8$var$_oldOnUnhandledRejectionHandler = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $55473128f666b930$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($078045da06d770e8$var$_oldOnUnhandledRejectionHandler && !$078045da06d770e8$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $078045da06d770e8$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $dd0a5dc41f00fcde$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $dd0a5dc41f00fcde$export$8e9a29865c0a1226 = (0, $adb2e0f3471b4e35$export$8e9a29865c0a1226);


let $e5c6bf97db65c500$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $e5c6bf97db65c500$export$637857c1d87b640c() {
    if ($e5c6bf97db65c500$var$errorsInstrumented) return;
    $e5c6bf97db65c500$var$errorsInstrumented = true;
    (0, $277ad536ce22c36e$export$55b5c3ba2194f0c6)($e5c6bf97db65c500$var$errorCallback);
    (0, $078045da06d770e8$export$8bf4fc6858821a4e)($e5c6bf97db65c500$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $e5c6bf97db65c500$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$e5c6bf97db65c500$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $85193a258f527e44$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $85193a258f527e44$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $85193a258f527e44$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e61cef59f2d69c3e$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $6e54f04d8cb2bbe5$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
    const scope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $6e54f04d8cb2bbe5$var$normalizeContext(context);
    const activeSpan = $6e54f04d8cb2bbe5$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $85193a258f527e44$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e54f04d8cb2bbe5$export$a1bd95187356f372(context, callback) {
    const spanContext = $6e54f04d8cb2bbe5$var$normalizeContext(context);
    return (0, $970ec608023beb99$export$70d775fb1f267027)(()=>{
        return (0, $cbe719ec84d28c68$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6e54f04d8cb2bbe5$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $85193a258f527e44$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $6e54f04d8cb2bbe5$export$cb9e396e6b90b703 = $6e54f04d8cb2bbe5$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e54f04d8cb2bbe5$export$c10292ad04b92aea(context, callback) {
    const spanContext = $6e54f04d8cb2bbe5$var$normalizeContext(context);
    return (0, $970ec608023beb99$export$70d775fb1f267027)(()=>{
        return (0, $cbe719ec84d28c68$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6e54f04d8cb2bbe5$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $85193a258f527e44$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e54f04d8cb2bbe5$export$63dbba021a6b4047(context) {
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $6e54f04d8cb2bbe5$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $6e54f04d8cb2bbe5$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $6e54f04d8cb2bbe5$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $6e54f04d8cb2bbe5$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)().getSpan();
}
const $6e54f04d8cb2bbe5$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $adb2e0f3471b4e35$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $9266143fc5665ff4$export$16a28057038b10ef) && traceparentData) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $970ec608023beb99$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $6e54f04d8cb2bbe5$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $0e7916f5f7c1b648$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $386b8b8fbbe8a075$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $6e54f04d8cb2bbe5$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $6e54f04d8cb2bbe5$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $386b8b8fbbe8a075$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $6e54f04d8cb2bbe5$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $6e54f04d8cb2bbe5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $6e54f04d8cb2bbe5$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $95e32bdd0672a295$export$e73679ffaf56810e)(span, $6e54f04d8cb2bbe5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $95e32bdd0672a295$export$e73679ffaf56810e)(span, $6e54f04d8cb2bbe5$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $6e54f04d8cb2bbe5$export$c08fbc656a245d03(span) {
    return {
        scope: span[$6e54f04d8cb2bbe5$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$6e54f04d8cb2bbe5$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY;
function $7dd5c66a936f1eea$var$getMetricStorageForSpan(span) {
    return $7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY ? $7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $7dd5c66a936f1eea$export$2e7205e45c58797d(span) {
    const storage = $7dd5c66a936f1eea$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $95e32bdd0672a295$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $7dd5c66a936f1eea$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $6e54f04d8cb2bbe5$export$1be426a8e585c83e)();
    if (span) {
        const storage = $7dd5c66a936f1eea$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY) $7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $7dd5c66a936f1eea$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $33c09cd2024ef047$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $33c09cd2024ef047$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $33c09cd2024ef047$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $33c09cd2024ef047$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $33c09cd2024ef047$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $1e2373d6e5ca32bd$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($1e2373d6e5ca32bd$export$beb8e6a823e89c5d || ($1e2373d6e5ca32bd$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $1e2373d6e5ca32bd$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $1e2373d6e5ca32bd$export$ac65c70d78fcdb55 = $1e2373d6e5ca32bd$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $1e2373d6e5ca32bd$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $1e2373d6e5ca32bd$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $6ba041936e3a2513$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $6ba041936e3a2513$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $a4aec27f2b28cb05$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $33c09cd2024ef047$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $33c09cd2024ef047$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $33c09cd2024ef047$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $33c09cd2024ef047$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $33c09cd2024ef047$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $386b8b8fbbe8a075$export$eb571cd9b5d98de8) : (0, $386b8b8fbbe8a075$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $6ba041936e3a2513$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $8d3523928e82f4f4$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $9266143fc5665ff4$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $1e2373d6e5ca32bd$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $8d3523928e82f4f4$export$c4c6a79b1260ca1b)(this);
        if ((0, $9266143fc5665ff4$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $386b8b8fbbe8a075$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $386b8b8fbbe8a075$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $386b8b8fbbe8a075$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $33c09cd2024ef047$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $33c09cd2024ef047$export$cca8dd30f57f805e],
            _metrics_summary: (0, $7dd5c66a936f1eea$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $33c09cd2024ef047$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $a35a40501cdf88f2$export$febc5573c75cefb0 extends (0, $6ba041936e3a2513$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $33c09cd2024ef047$export$d7a7d984b0791405] && {
                source: this._attributes[0, $33c09cd2024ef047$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $33c09cd2024ef047$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $33c09cd2024ef047$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $33c09cd2024ef047$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $6ba041936e3a2513$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $386b8b8fbbe8a075$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $95e32bdd0672a295$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $0e7916f5f7c1b648$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $6e54f04d8cb2bbe5$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $386b8b8fbbe8a075$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $95e32bdd0672a295$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $0e7916f5f7c1b648$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $7dd5c66a936f1eea$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $3c0a5b7663a36e68$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $3c0a5b7663a36e68$var$FINISH_REASON_TAG = "finishReason";
const $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $3c0a5b7663a36e68$export$370d6113c18ba86c extends (0, $6ba041936e3a2513$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $3c0a5b7663a36e68$export$b279e6bd7040371f extends (0, $a35a40501cdf88f2$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $3c0a5b7663a36e68$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $3c0a5b7663a36e68$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $3c0a5b7663a36e68$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $386b8b8fbbe8a075$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($3c0a5b7663a36e68$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $9266143fc5665ff4$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $3c0a5b7663a36e68$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $9b109844d4ad1b74$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $3c0a5b7663a36e68$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $d59a7f3a5ef40a7d$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $33c09cd2024ef047$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $33c09cd2024ef047$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $33c09cd2024ef047$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $33c09cd2024ef047$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$d59a7f3a5ef40a7d$export$2603c8d332a51c42(sampleRate)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $9266143fc5665ff4$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $d59a7f3a5ef40a7d$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $48dc9950f67ce5b4$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $c3bfa3c854ad9d71$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $386b8b8fbbe8a075$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $c3bfa3c854ad9d71$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $a35a40501cdf88f2$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $d59a7f3a5ef40a7d$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $c3bfa3c854ad9d71$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $3c0a5b7663a36e68$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $d59a7f3a5ef40a7d$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $c3bfa3c854ad9d71$export$653d0ef2bad9cdf9() {
    const carrier = (0, $970ec608023beb99$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $c3bfa3c854ad9d71$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $c3bfa3c854ad9d71$var$traceHeaders;
    (0, $e5c6bf97db65c500$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $310f3638d547d904$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81 = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $cdcc7b609e92e431$export$6f18f55521af71a1() {
    if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
        if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(activeTransaction);
            (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $e7901995b6c8f1f6$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $c8ed2b2a0711379b$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d2f191dece66300c$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $d2f191dece66300c$export$6431553786c94949 = ()=>{
    if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $d2f191dece66300c$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $25d4996608c97cf5$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $d2f191dece66300c$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc6ed2d3de1bf420$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $d2f191dece66300c$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.prerendering || (0, $25d4996608c97cf5$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $c8ed2b2a0711379b$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $67f0558b451c1918$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $4c51d66c8e90acab$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $fc6ed2d3de1bf420$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $67f0558b451c1918$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $e7901995b6c8f1f6$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e99a3d94931a1330$var$firstHiddenTime = -1;
const $e99a3d94931a1330$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.visibilityState) $e99a3d94931a1330$var$firstHiddenTime = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $e99a3d94931a1330$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $e99a3d94931a1330$var$firstHiddenTime = timeStamp;
    }, true);
};
const $e99a3d94931a1330$export$443f86b2c77012c4 = ()=>{
    if ($e99a3d94931a1330$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $e99a3d94931a1330$var$initHiddenTime();
        $e99a3d94931a1330$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $e99a3d94931a1330$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $7a45b8b46fdd868f$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $e99a3d94931a1330$export$443f86b2c77012c4)();
    const metric = (0, $fc6ed2d3de1bf420$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $67f0558b451c1918$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $e7901995b6c8f1f6$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $056d76d8588543d1$var$interactionCountEstimate = 0;
let $056d76d8588543d1$var$minKnownInteractionId = Infinity;
let $056d76d8588543d1$var$maxKnownInteractionId = 0;
const $056d76d8588543d1$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $056d76d8588543d1$var$minKnownInteractionId = Math.min($056d76d8588543d1$var$minKnownInteractionId, e.interactionId);
            $056d76d8588543d1$var$maxKnownInteractionId = Math.max($056d76d8588543d1$var$maxKnownInteractionId, e.interactionId);
            $056d76d8588543d1$var$interactionCountEstimate = $056d76d8588543d1$var$maxKnownInteractionId ? ($056d76d8588543d1$var$maxKnownInteractionId - $056d76d8588543d1$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $056d76d8588543d1$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $056d76d8588543d1$export$8a962f2683a476d1 = ()=>{
    return $056d76d8588543d1$var$po ? $056d76d8588543d1$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $056d76d8588543d1$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $056d76d8588543d1$var$po) return;
    $056d76d8588543d1$var$po = (0, $67f0558b451c1918$export$d1203567a167490e)("event", $056d76d8588543d1$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $ee50398b86983e96$var$getInteractionCountForNavigation = ()=>{
    return (0, $056d76d8588543d1$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $ee50398b86983e96$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $ee50398b86983e96$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $ee50398b86983e96$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $ee50398b86983e96$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $ee50398b86983e96$var$longestInteractionList[$ee50398b86983e96$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $ee50398b86983e96$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $ee50398b86983e96$var$longestInteractionList.length < $ee50398b86983e96$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $ee50398b86983e96$var$longestInteractionMap[interaction.id] = interaction;
            $ee50398b86983e96$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $ee50398b86983e96$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $ee50398b86983e96$var$longestInteractionList.splice($ee50398b86983e96$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $ee50398b86983e96$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $ee50398b86983e96$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($ee50398b86983e96$var$longestInteractionList.length - 1, Math.floor($ee50398b86983e96$var$getInteractionCountForNavigation() / 50));
    return $ee50398b86983e96$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $ee50398b86983e96$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $056d76d8588543d1$export$67d90cda6b78a2eb)();
    const metric = (0, $fc6ed2d3de1bf420$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $ee50398b86983e96$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$ee50398b86983e96$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $ee50398b86983e96$var$processEntry(entry);
            }
        });
        const inp = $ee50398b86983e96$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $67f0558b451c1918$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $e7901995b6c8f1f6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $ee50398b86983e96$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c8412919c956a3fe$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $c8412919c956a3fe$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $e99a3d94931a1330$export$443f86b2c77012c4)();
    const metric = (0, $fc6ed2d3de1bf420$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $25d4996608c97cf5$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $67f0558b451c1918$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $e7901995b6c8f1f6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$c8412919c956a3fe$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $c8412919c956a3fe$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $14bd7965cfd05a0e$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $642fe9f3f129a752$var$whenReady = (callback)=>{
    if (!(0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) return;
    if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$642fe9f3f129a752$var$whenReady(callback), true);
    else if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$642fe9f3f129a752$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $642fe9f3f129a752$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $fc6ed2d3de1bf420$export$3c29b44508a0612b)("TTFB");
    const report = (0, $e7901995b6c8f1f6$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $642fe9f3f129a752$var$whenReady(()=>{
        const navEntry = (0, $d2f191dece66300c$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $25d4996608c97cf5$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $6ba4605167f12edc$var$handlers = {};
const $6ba4605167f12edc$var$instrumented = {};
let $6ba4605167f12edc$var$_previousCls;
let $6ba4605167f12edc$var$_previousFid;
let $6ba4605167f12edc$var$_previousLcp;
let $6ba4605167f12edc$var$_previousTtfb;
let $6ba4605167f12edc$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $6ba4605167f12edc$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $6ba4605167f12edc$var$addMetricObserver("cls", callback, $6ba4605167f12edc$var$instrumentCls, $6ba4605167f12edc$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $6ba4605167f12edc$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $6ba4605167f12edc$var$addMetricObserver("lcp", callback, $6ba4605167f12edc$var$instrumentLcp, $6ba4605167f12edc$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $6ba4605167f12edc$export$699d9529c099a797(callback) {
    return $6ba4605167f12edc$var$addMetricObserver("ttfb", callback, $6ba4605167f12edc$var$instrumentTtfb, $6ba4605167f12edc$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6ba4605167f12edc$export$2707d7471c0b918f(callback) {
    return $6ba4605167f12edc$var$addMetricObserver("fid", callback, $6ba4605167f12edc$var$instrumentFid, $6ba4605167f12edc$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6ba4605167f12edc$export$da3b76aa2022cbd7(callback) {
    return $6ba4605167f12edc$var$addMetricObserver("inp", callback, $6ba4605167f12edc$var$instrumentInp, $6ba4605167f12edc$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $6ba4605167f12edc$export$69816c1a049f8db6(type, callback) {
    $6ba4605167f12edc$var$addHandler(type, callback);
    if (!$6ba4605167f12edc$var$instrumented[type]) {
        $6ba4605167f12edc$var$instrumentPerformanceObserver(type);
        $6ba4605167f12edc$var$instrumented[type] = true;
    }
    return $6ba4605167f12edc$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $6ba4605167f12edc$var$triggerHandlers(type, data) {
    const typeHandlers = $6ba4605167f12edc$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $121116598fbd347a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $6ba4605167f12edc$var$instrumentCls() {
    return (0, $4c51d66c8e90acab$export$a7873055838e5ad8)((metric)=>{
        $6ba4605167f12edc$var$triggerHandlers("cls", {
            metric: metric
        });
        $6ba4605167f12edc$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $6ba4605167f12edc$var$instrumentFid() {
    return (0, $7a45b8b46fdd868f$export$39705a25c49af873)((metric)=>{
        $6ba4605167f12edc$var$triggerHandlers("fid", {
            metric: metric
        });
        $6ba4605167f12edc$var$_previousFid = metric;
    });
}
function $6ba4605167f12edc$var$instrumentLcp() {
    return (0, $c8412919c956a3fe$export$947b1626ab8d5632)((metric)=>{
        $6ba4605167f12edc$var$triggerHandlers("lcp", {
            metric: metric
        });
        $6ba4605167f12edc$var$_previousLcp = metric;
    });
}
function $6ba4605167f12edc$var$instrumentTtfb() {
    return (0, $642fe9f3f129a752$export$33a01e6c5f2c7e33)((metric)=>{
        $6ba4605167f12edc$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $6ba4605167f12edc$var$_previousTtfb = metric;
    });
}
function $6ba4605167f12edc$var$instrumentInp() {
    return (0, $ee50398b86983e96$export$7df4b36ecaed99e1)((metric)=>{
        $6ba4605167f12edc$var$triggerHandlers("inp", {
            metric: metric
        });
        $6ba4605167f12edc$var$_previousInp = metric;
    });
}
function $6ba4605167f12edc$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $6ba4605167f12edc$var$addHandler(type, callback);
    let stopListening;
    if (!$6ba4605167f12edc$var$instrumented[type]) {
        stopListening = instrumentFn();
        $6ba4605167f12edc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $6ba4605167f12edc$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $6ba4605167f12edc$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $67f0558b451c1918$export$d1203567a167490e)(type, (entries)=>{
        $6ba4605167f12edc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $6ba4605167f12edc$var$addHandler(type, handler) {
    $6ba4605167f12edc$var$handlers[type] = $6ba4605167f12edc$var$handlers[type] || [];
    $6ba4605167f12edc$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $6ba4605167f12edc$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $6ba4605167f12edc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $582b47885dfe97f9$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn);
    const items = spans.map($582b47885dfe97f9$var$createSpanItem);
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(headers, items);
}
function $582b47885dfe97f9$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $3a899f6545f3cdbf$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $5575f47b3080309f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $5575f47b3080309f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $5575f47b3080309f$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $5575f47b3080309f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $eababdd2a9c56287$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $eababdd2a9c56287$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $b1bea7a7619b758e$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b1bea7a7619b758e$var$msToSec(time) {
    return time / 1000;
}
function $b1bea7a7619b758e$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81) && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).addEventListener && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance;
}
let $b1bea7a7619b758e$var$_performanceCursor = 0;
let $b1bea7a7619b758e$var$_measurements = {};
let $b1bea7a7619b758e$var$_lcpEntry;
let $b1bea7a7619b758e$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $b1bea7a7619b758e$export$7c69f0412d101b88() {
    const performance = $b1bea7a7619b758e$var$getBrowserPerformanceAPI();
    if (performance && (0, $9b109844d4ad1b74$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $b1bea7a7619b758e$var$_trackFID();
        const clsCallback = $b1bea7a7619b758e$var$_trackCLS();
        const lcpCallback = $b1bea7a7619b758e$var$_trackLCP();
        const ttfbCallback = $b1bea7a7619b758e$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $b1bea7a7619b758e$export$f396d19077034ad2() {
    (0, $6ba4605167f12edc$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $b1bea7a7619b758e$var$msToSec((0, $9b109844d4ad1b74$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $b1bea7a7619b758e$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $b1bea7a7619b758e$export$e27543e0976315e4() {
    (0, $6ba4605167f12edc$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $b1bea7a7619b758e$var$msToSec((0, $9b109844d4ad1b74$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $b1bea7a7619b758e$var$msToSec(entry.duration);
                const span = {
                    description: (0, $1862e47d17ed8624$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $1862e47d17ed8624$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $b1bea7a7619b758e$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $b1bea7a7619b758e$var$getBrowserPerformanceAPI();
    if (performance && (0, $9b109844d4ad1b74$export$baf075a948ffc0bf)) {
        const inpCallback = $b1bea7a7619b758e$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $b1bea7a7619b758e$var$_trackCLS() {
    return (0, $6ba4605167f12edc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $b1bea7a7619b758e$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $b1bea7a7619b758e$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $b1bea7a7619b758e$var$_trackLCP() {
    return (0, $6ba4605167f12edc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $b1bea7a7619b758e$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $b1bea7a7619b758e$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $b1bea7a7619b758e$var$_trackFID() {
    return (0, $6ba4605167f12edc$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $b1bea7a7619b758e$var$msToSec((0, $9b109844d4ad1b74$export$baf075a948ffc0bf));
        const startTime = $b1bea7a7619b758e$var$msToSec(entry.startTime);
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $b1bea7a7619b758e$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $b1bea7a7619b758e$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $b1bea7a7619b758e$var$_trackTtfb() {
    return (0, $6ba4605167f12edc$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $b1bea7a7619b758e$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $b1bea7a7619b758e$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $b1bea7a7619b758e$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $6ba4605167f12edc$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $b1bea7a7619b758e$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $b1bea7a7619b758e$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $b1bea7a7619b758e$var$msToSec((0, $9b109844d4ad1b74$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $b1bea7a7619b758e$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $6ba041936e3a2513$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $1862e47d17ed8624$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $b1bea7a7619b758e$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $582b47885dfe97f9$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $b1bea7a7619b758e$export$5f8fa6b3467a7443(transaction) {
    const performance = $b1bea7a7619b758e$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).performance.getEntries || !(0, $9b109844d4ad1b74$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $b1bea7a7619b758e$var$msToSec((0, $9b109844d4ad1b74$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($b1bea7a7619b758e$var$_performanceCursor).forEach((entry)=>{
        const startTime = $b1bea7a7619b758e$var$msToSec(entry.startTime);
        const duration = $b1bea7a7619b758e$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $b1bea7a7619b758e$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $b1bea7a7619b758e$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $e99a3d94931a1330$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $b1bea7a7619b758e$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $b1bea7a7619b758e$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $b1bea7a7619b758e$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $b1bea7a7619b758e$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $b1bea7a7619b758e$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $b1bea7a7619b758e$var$_addTtfbRequestTimeToMeasurements($b1bea7a7619b758e$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$b1bea7a7619b758e$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $b1bea7a7619b758e$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $b1bea7a7619b758e$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $b1bea7a7619b758e$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $b1bea7a7619b758e$var$_measurements["mark.fid"];
        if (fidMark && $b1bea7a7619b758e$var$_measurements["fid"]) {
            // create span for FID
            (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $b1bea7a7619b758e$var$msToSec($b1bea7a7619b758e$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $b1bea7a7619b758e$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $b1bea7a7619b758e$var$_measurements)) delete $b1bea7a7619b758e$var$_measurements.cls;
        Object.keys($b1bea7a7619b758e$var$_measurements).forEach((measurementName)=>{
            (0, $3a899f6545f3cdbf$export$7cc31b475d33a706)(measurementName, $b1bea7a7619b758e$var$_measurements[measurementName].value, $b1bea7a7619b758e$var$_measurements[measurementName].unit);
        });
        $b1bea7a7619b758e$var$_tagMetricInfo(transaction);
    }
    $b1bea7a7619b758e$var$_lcpEntry = undefined;
    $b1bea7a7619b758e$var$_clsEntry = undefined;
    $b1bea7a7619b758e$var$_measurements = {};
}
/** Create measure related spans */ function $b1bea7a7619b758e$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1bea7a7619b758e$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $b1bea7a7619b758e$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $b1bea7a7619b758e$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $b1bea7a7619b758e$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $b1bea7a7619b758e$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $b1bea7a7619b758e$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $b1bea7a7619b758e$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(start),
        endTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1bea7a7619b758e$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(entry.responseEnd)
        });
        (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $b1bea7a7619b758e$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $b1bea7a7619b758e$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $5575f47b3080309f$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $b1bea7a7619b758e$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $b1bea7a7619b758e$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $b1bea7a7619b758e$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $eababdd2a9c56287$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $b1bea7a7619b758e$var$_trackNavigator(transaction) {
    const navigator = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $eababdd2a9c56287$export$27169ccae1b439e3)(connection.rtt)) $b1bea7a7619b758e$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $eababdd2a9c56287$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $eababdd2a9c56287$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $b1bea7a7619b758e$var$_tagMetricInfo(transaction) {
    if ($b1bea7a7619b758e$var$_lcpEntry) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($b1bea7a7619b758e$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $1862e47d17ed8624$export$5647df6b7814ac86)($b1bea7a7619b758e$var$_lcpEntry.element));
        if ($b1bea7a7619b758e$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $b1bea7a7619b758e$var$_lcpEntry.id);
        if ($b1bea7a7619b758e$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $b1bea7a7619b758e$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $b1bea7a7619b758e$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($b1bea7a7619b758e$var$_clsEntry && $b1bea7a7619b758e$var$_clsEntry.sources) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $b1bea7a7619b758e$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $1862e47d17ed8624$export$5647df6b7814ac86)(source.node)));
    }
}
function $b1bea7a7619b758e$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $b1bea7a7619b758e$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $b1bea7a7619b758e$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $d2f191dece66300c$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $b1bea7a7619b758e$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $d59a7f3a5ef40a7d$export$2603c8d332a51c42)(sampleRate)) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $1ad3f51fc2e0aa3e$var$WINDOW = (0, $e237680456fd85d0$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $1ad3f51fc2e0aa3e$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1ad3f51fc2e0aa3e$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $1ad3f51fc2e0aa3e$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$1ad3f51fc2e0aa3e$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($1ad3f51fc2e0aa3e$export$18cf36ed71d733e7($1ad3f51fc2e0aa3e$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $1ad3f51fc2e0aa3e$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $1ad3f51fc2e0aa3e$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $4823161d30d5d56f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$531055a6c684a70a() {
    return "ReportingObserver" in $1ad3f51fc2e0aa3e$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $1ad3f51fc2e0aa3e$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$1ad3f51fc2e0aa3e$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $93aff2aa5d0065f7$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $93aff2aa5d0065f7$var$instrumentFetch);
}
function $93aff2aa5d0065f7$var$instrumentFetch() {
    if (!(0, $1ad3f51fc2e0aa3e$export$c82d238e23c40b21)()) return;
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)((0, $e237680456fd85d0$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $93aff2aa5d0065f7$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $55473128f666b930$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $e237680456fd85d0$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $55473128f666b930$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $55473128f666b930$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $93aff2aa5d0065f7$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $93aff2aa5d0065f7$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($93aff2aa5d0065f7$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $93aff2aa5d0065f7$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $93aff2aa5d0065f7$var$getUrlFromResource(url),
            method: $93aff2aa5d0065f7$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $93aff2aa5d0065f7$var$getUrlFromResource(arg),
        method: $93aff2aa5d0065f7$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $f7b6eb7bbcd641c1$var$WINDOW = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
const $f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f7b6eb7bbcd641c1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $f7b6eb7bbcd641c1$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $f7b6eb7bbcd641c1$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$f7b6eb7bbcd641c1$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $f7b6eb7bbcd641c1$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $55473128f666b930$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $95e32bdd0672a295$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $95e32bdd0672a295$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(header) && (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $55473128f666b930$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $f7b6eb7bbcd641c1$var$parseUrl(url) {
    if ((0, $48dc9950f67ce5b4$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $aaa60fcc79e68338$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $aaa60fcc79e68338$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $aaa60fcc79e68338$var$getFullURL(url);
    const host = fullUrl ? (0, $5575f47b3080309f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $6e54f04d8cb2bbe5$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $aaa60fcc79e68338$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $aaa60fcc79e68338$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $386b8b8fbbe8a075$export$7e9f8ae9e4a328ab)(span) : (0, $adb2e0f3471b4e35$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $e6f403c2b28dea63$export$56766feef403f365)(dsc || (span ? (0, $0e7916f5f7c1b648$export$a117f995597e25df)(span) : (0, $0e7916f5f7c1b648$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $48dc9950f67ce5b4$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $48dc9950f67ce5b4$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $e6f403c2b28dea63$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $e6f403c2b28dea63$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $aaa60fcc79e68338$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $aaa60fcc79e68338$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $1e2373d6e5ca32bd$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $7246d6029e412c22$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $7246d6029e412c22$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $7246d6029e412c22$export$15bd0305d05ad07b,
    tracePropagationTargets: $7246d6029e412c22$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $7246d6029e412c22$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $7246d6029e412c22$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $7246d6029e412c22$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$7246d6029e412c22$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $93aff2aa5d0065f7$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $aaa60fcc79e68338$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $7246d6029e412c22$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $5575f47b3080309f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $7246d6029e412c22$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $f7b6eb7bbcd641c1$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $7246d6029e412c22$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $7246d6029e412c22$var$addHTTPTimings(createdSpan);
    });
}
function $7246d6029e412c22$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $7246d6029e412c22$var$addHTTPTimings(span) {
    const { url: url } = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $6ba4605167f12edc$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($7246d6029e412c22$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $7246d6029e412c22$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $7246d6029e412c22$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $7246d6029e412c22$var$getAbsoluteTime(time = 0) {
    return (((0, $9b109844d4ad1b74$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $7246d6029e412c22$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $7246d6029e412c22$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $9b109844d4ad1b74$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $7246d6029e412c22$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $7246d6029e412c22$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $662e93ac017d9860$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $7246d6029e412c22$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $7246d6029e412c22$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59];
    if (!(0, $e61cef59f2d69c3e$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $1e2373d6e5ca32bd$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    const isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)();
    const fullUrl = $7246d6029e412c22$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $5575f47b3080309f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $6e54f04d8cb2bbe5$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $386b8b8fbbe8a075$export$7e9f8ae9e4a328ab)(span) : (0, $adb2e0f3471b4e35$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $e6f403c2b28dea63$export$56766feef403f365)(dsc || (span ? (0, $0e7916f5f7c1b648$export$a117f995597e25df)(span) : (0, $0e7916f5f7c1b648$export$366bad00d6815eed)(traceId, client, scope)));
        $7246d6029e412c22$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $7246d6029e412c22$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $e6f403c2b28dea63$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $7246d6029e412c22$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $c0e2795f7e421bdf$var$WINDOW = (0, $e237680456fd85d0$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c0e2795f7e421bdf$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $c0e2795f7e421bdf$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $c0e2795f7e421bdf$var$WINDOW && !!$c0e2795f7e421bdf$var$WINDOW.history.pushState && !!$c0e2795f7e421bdf$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $58855933738bc299$var$WINDOW = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
let $58855933738bc299$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $58855933738bc299$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $58855933738bc299$var$instrumentHistory);
}
function $58855933738bc299$var$instrumentHistory() {
    if (!(0, $c0e2795f7e421bdf$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $58855933738bc299$var$WINDOW.onpopstate;
    $58855933738bc299$var$WINDOW.onpopstate = function(...args) {
        const to = $58855933738bc299$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $58855933738bc299$var$lastHref;
        $58855933738bc299$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $55473128f666b930$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $58855933738bc299$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $58855933738bc299$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $55473128f666b930$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)($58855933738bc299$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)($58855933738bc299$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $60e41930760eb733$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81) || !(0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location) {
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $9b109844d4ad1b74$export$baf075a948ffc0bf) ? (0, $9b109844d4ad1b74$export$baf075a948ffc0bf) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $58855933738bc299$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $8dbddd3dbec405f5$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $8dbddd3dbec405f5$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $3c0a5b7663a36e68$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $60e41930760eb733$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $7246d6029e412c22$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $8dbddd3dbec405f5$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $8dbddd3dbec405f5$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $8dbddd3dbec405f5$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $c3bfa3c854ad9d71$export$653d0ef2bad9cdf9)();
        if (0, $310f3638d547d904$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$8dbddd3dbec405f5$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $b1bea7a7619b758e$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $b1bea7a7619b758e$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $b1bea7a7619b758e$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $b1bea7a7619b758e$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $310f3638d547d904$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $cdcc7b609e92e431$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $7246d6029e412c22$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $8dbddd3dbec405f5$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $8dbddd3dbec405f5$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $adb2e0f3471b4e35$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $c3bfa3c854ad9d71$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) {
                (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $b1bea7a7619b758e$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: this._latestRoute.context ? $8dbddd3dbec405f5$var$getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, $c3bfa3c854ad9d71$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
            const currentScope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($8dbddd3dbec405f5$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $8dbddd3dbec405f5$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $8dbddd3dbec405f5$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $6ba4605167f12edc$export$69816c1a049f8db6)("event", handleEntries);
        (0, $6ba4605167f12edc$export$69816c1a049f8db6)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function $8dbddd3dbec405f5$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $1862e47d17ed8624$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function $8dbddd3dbec405f5$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $33c09cd2024ef047$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $33c09cd2024ef047$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $8dbddd3dbec405f5$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}




let $4d387e0c1669908e$var$originalFunctionToString;
const $4d387e0c1669908e$var$INTEGRATION_NAME = "FunctionToString";
const $4d387e0c1669908e$var$SETUP_CLIENTS = new WeakMap();
const $4d387e0c1669908e$var$_functionToStringIntegration = ()=>{
    return {
        name: $4d387e0c1669908e$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $4d387e0c1669908e$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $95e32bdd0672a295$export$e6cc1e135e2092e5)(this);
                    const context = $4d387e0c1669908e$var$SETUP_CLIENTS.has((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $4d387e0c1669908e$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $4d387e0c1669908e$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $4d387e0c1669908e$export$7918117e9202e4fb = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($4d387e0c1669908e$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4d387e0c1669908e$export$da4704525c20ae79 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($4d387e0c1669908e$var$INTEGRATION_NAME, $4d387e0c1669908e$export$7918117e9202e4fb);


const $74dbbf1dc360cb47$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $74dbbf1dc360cb47$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $74dbbf1dc360cb47$var$_getIngestEndpoint(dsn) {
    return `${$74dbbf1dc360cb47$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $74dbbf1dc360cb47$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $95e32bdd0672a295$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $74dbbf1dc360cb47$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $74dbbf1dc360cb47$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$74dbbf1dc360cb47$var$_getIngestEndpoint(dsn)}?${$74dbbf1dc360cb47$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $74dbbf1dc360cb47$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $c42afaae0022aed0$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$74dbbf1dc360cb47$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $1d409873eef6730e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $1d409873eef6730e$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $1d409873eef6730e$var$INTEGRATION_NAME = "InboundFilters";
const $1d409873eef6730e$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $1d409873eef6730e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $1d409873eef6730e$var$_mergeOptions(options, clientOptions);
            return $1d409873eef6730e$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $1d409873eef6730e$export$cb3c5c2ceb9818ba = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($1d409873eef6730e$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1d409873eef6730e$export$2ffbb5359dcc6be4 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($1d409873eef6730e$var$INTEGRATION_NAME, $1d409873eef6730e$export$cb3c5c2ceb9818ba);
function $1d409873eef6730e$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $1d409873eef6730e$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $1d409873eef6730e$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $1d409873eef6730e$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $1d409873eef6730e$var$_isSentryError(event)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($1d409873eef6730e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($1d409873eef6730e$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($1d409873eef6730e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}.\nUrl: ${$1d409873eef6730e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$1d409873eef6730e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}.\nUrl: ${$1d409873eef6730e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $1d409873eef6730e$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $1d409873eef6730e$var$_getPossibleEventMessages(event).some((message)=>(0, $662e93ac017d9860$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $1d409873eef6730e$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $662e93ac017d9860$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $1d409873eef6730e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $1d409873eef6730e$var$_getEventFilterUrl(event);
    return !url ? false : (0, $662e93ac017d9860$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $1d409873eef6730e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $1d409873eef6730e$var$_getEventFilterUrl(event);
    return !url ? true : (0, $662e93ac017d9860$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $1d409873eef6730e$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $9266143fc5665ff4$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $1d409873eef6730e$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $1d409873eef6730e$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $1d409873eef6730e$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $1d409873eef6730e$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $7376790b83234bd9$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $9266143fc5665ff4$export$16a28057038b10ef) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $6a114848ff8dae1d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7376790b83234bd9$export$ecb76f41d43c0e43(client);
    $7376790b83234bd9$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $7376790b83234bd9$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $7376790b83234bd9$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $4c7c06c74524101e$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $eac5488800c23079$export$31499a9cd224b78c)
            })),
        version: (0, $eac5488800c23079$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $6d42b0ab376e7399$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $3e00bd82a72e3055$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $3e00bd82a72e3055$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a526f2a77773274f$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $3e00bd82a72e3055$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a526f2a77773274f$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $3e00bd82a72e3055$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $a526f2a77773274f$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $4e32a6eab61879d3$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $95e32bdd0672a295$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $4e32a6eab61879d3$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $4e32a6eab61879d3$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $4e32a6eab61879d3$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $4e32a6eab61879d3$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $4e32a6eab61879d3$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $4e32a6eab61879d3$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $4e32a6eab61879d3$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $4e32a6eab61879d3$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $4e32a6eab61879d3$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $4e32a6eab61879d3$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $4e32a6eab61879d3$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $4e32a6eab61879d3$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $4e32a6eab61879d3$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $f5a32a3a476fc2fd$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn);
    const item = $f5a32a3a476fc2fd$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $f5a32a3a476fc2fd$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $4e32a6eab61879d3$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $061a15a154fde7ce$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $061a15a154fde7ce$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $c42afaae0022aed0$export$128827c3562ec0cb)(options.dsn);
        else (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $74dbbf1dc360cb47$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $a4aec27f2b28cb05$export$6de4ffac6a2f1098)(exception)) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log($061a15a154fde7ce$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $48dc9950f67ce5b4$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $48dc9950f67ce5b4$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $a4aec27f2b28cb05$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log($061a15a154fde7ce$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $8b1b4b61d8616537$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $bd021bfb8acb0c22$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $bd021bfb8acb0c22$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $3e00bd82a72e3055$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $a526f2a77773274f$export$d650323442802f6f)(env, (0, $a526f2a77773274f$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $3e00bd82a72e3055$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $f5a32a3a476fc2fd$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $bd021bfb8acb0c22$export$51abed9797baa598)(this, integrations);
        (0, $bd021bfb8acb0c22$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $8b1b4b61d8616537$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $e0170d90e8c79bf3$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $970ec608023beb99$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $2ac4975231ecf8de$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $0e7916f5f7c1b648$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $9266143fc5665ff4$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $061a15a154fde7ce$var$isTransactionEvent(event);
        const isError = $061a15a154fde7ce$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $e0170d90e8c79bf3$export$78e43115b553f358)(new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $061a15a154fde7ce$var$processBeforeSend(options, prepared, hint);
            return $061a15a154fde7ce$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $061a15a154fde7ce$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $48dc9950f67ce5b4$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $061a15a154fde7ce$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($061a15a154fde7ce$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($061a15a154fde7ce$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $061a15a154fde7ce$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $061a15a154fde7ce$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $061a15a154fde7ce$export$9aac0b9f77928fbf(callback) {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $0b0f6344ad5b2132$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $9b109844d4ad1b74$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $c9868df368bf00a8$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $c9868df368bf00a8$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}





/**
 * This function creates an exception from a JavaScript Error
 */ function $95772c9d17189dab$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $95772c9d17189dab$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $95772c9d17189dab$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $95772c9d17189dab$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $48dc9950f67ce5b4$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $95772c9d17189dab$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $c207ff544b279d26$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $95772c9d17189dab$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $95772c9d17189dab$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $95772c9d17189dab$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $95772c9d17189dab$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $95772c9d17189dab$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $95772c9d17189dab$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $95772c9d17189dab$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($95772c9d17189dab$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $95772c9d17189dab$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $95772c9d17189dab$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $95772c9d17189dab$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $95772c9d17189dab$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $95772c9d17189dab$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $95772c9d17189dab$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $48dc9950f67ce5b4$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $95772c9d17189dab$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $48dc9950f67ce5b4$export$ef9e2056653f0c8e)(exception) || (0, $48dc9950f67ce5b4$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $95772c9d17189dab$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $48dc9950f67ce5b4$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $95772c9d17189dab$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $a4aec27f2b28cb05$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $48dc9950f67ce5b4$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $95772c9d17189dab$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(exception) || (0, $48dc9950f67ce5b4$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $95772c9d17189dab$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $95772c9d17189dab$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $a4aec27f2b28cb05$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $95772c9d17189dab$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $95772c9d17189dab$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $48dc9950f67ce5b4$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $95772c9d17189dab$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $95e32bdd0672a295$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $48dc9950f67ce5b4$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $48dc9950f67ce5b4$export$9671ea99bd126ace)(exception)) {
        const className = $95772c9d17189dab$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $95772c9d17189dab$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




/**
 * Creates an envelope from a user feedback.
 */ function $1d2f797adc1ae230$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $c42afaae0022aed0$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $1d2f797adc1ae230$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $a526f2a77773274f$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $1d2f797adc1ae230$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $393390313ad67c10$export$1df9218a526d318d extends (0, $061a15a154fde7ce$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $c9868df368bf00a8$export$8ad33f488b1ab046)();
        (0, $4c7c06c74524101e$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document) (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $95772c9d17189dab$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $95772c9d17189dab$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $1d2f797adc1ae230$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $0b0f6344ad5b2132$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $c42afaae0022aed0$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $bd315bbf4e44bc77$var$WINDOW = (0, $e237680456fd85d0$export$f1a6cdb1459e81d1);
const $bd315bbf4e44bc77$var$DEBOUNCE_DURATION = 1000;
let $bd315bbf4e44bc77$var$debounceTimerID;
let $bd315bbf4e44bc77$var$lastCapturedEventType;
let $bd315bbf4e44bc77$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $bd315bbf4e44bc77$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $bd315bbf4e44bc77$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $bd315bbf4e44bc77$export$3014bbf0af0e1d4a() {
    if (!$bd315bbf4e44bc77$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $55473128f666b930$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $bd315bbf4e44bc77$var$makeDOMEventHandler(triggerDOMHandler, true);
    $bd315bbf4e44bc77$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $bd315bbf4e44bc77$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $bd315bbf4e44bc77$var$WINDOW[target] && $bd315bbf4e44bc77$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $95e32bdd0672a295$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $bd315bbf4e44bc77$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $95e32bdd0672a295$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $bd315bbf4e44bc77$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $bd315bbf4e44bc77$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $bd315bbf4e44bc77$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $bd315bbf4e44bc77$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $bd315bbf4e44bc77$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $bd315bbf4e44bc77$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($bd315bbf4e44bc77$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $95e32bdd0672a295$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $95e32bdd0672a295$export$e73679ffaf56810e)(target, "_sentryId", (0, $a4aec27f2b28cb05$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$bd315bbf4e44bc77$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $bd315bbf4e44bc77$var$lastCapturedEventType = event.type;
            $bd315bbf4e44bc77$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($bd315bbf4e44bc77$var$debounceTimerID);
        $bd315bbf4e44bc77$var$debounceTimerID = $bd315bbf4e44bc77$var$WINDOW.setTimeout(()=>{
            $bd315bbf4e44bc77$var$lastCapturedEventTargetId = undefined;
            $bd315bbf4e44bc77$var$lastCapturedEventType = undefined;
        }, $bd315bbf4e44bc77$var$DEBOUNCE_DURATION);
    };
}
function $bd315bbf4e44bc77$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a3a4ec1f931a8ab8$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $55473128f666b930$export$a4e09611e30da72e)(type, handler);
    (0, $55473128f666b930$export$e18d6c5462c01368)(type, $a3a4ec1f931a8ab8$var$instrumentConsole);
}
function $a3a4ec1f931a8ab8$var$instrumentConsole() {
    if (!("console" in (0, $e237680456fd85d0$export$f1a6cdb1459e81d1))) return;
    (0, $6a114848ff8dae1d$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $e237680456fd85d0$export$f1a6cdb1459e81d1).console)) return;
        (0, $95e32bdd0672a295$export$9563e054e6f787fb)((0, $e237680456fd85d0$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $6a114848ff8dae1d$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $55473128f666b930$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $6a114848ff8dae1d$export$77c4ce905194557b)[level];
                log && log.apply((0, $e237680456fd85d0$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $e5a8a92b1348aa8d$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $e5a8a92b1348aa8d$export$e01cef29b4327697(level) {
    return $e5a8a92b1348aa8d$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $e5a8a92b1348aa8d$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $e5a8a92b1348aa8d$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $56bc6ca1bcc1c370$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $56bc6ca1bcc1c370$var$INTEGRATION_NAME = "Breadcrumbs";
const $56bc6ca1bcc1c370$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $56bc6ca1bcc1c370$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $a3a4ec1f931a8ab8$export$1d6e0d073f9e6723)($56bc6ca1bcc1c370$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $bd315bbf4e44bc77$export$5aeffd3db2cf9df7)($56bc6ca1bcc1c370$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $f7b6eb7bbcd641c1$export$26ace48dd54c9aea)($56bc6ca1bcc1c370$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $93aff2aa5d0065f7$export$f75d3c772c923df0)($56bc6ca1bcc1c370$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $58855933738bc299$export$3f18c56c58114e75)($56bc6ca1bcc1c370$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $56bc6ca1bcc1c370$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $56bc6ca1bcc1c370$export$c079d904b326663a = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($56bc6ca1bcc1c370$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $56bc6ca1bcc1c370$export$2dc68d50d56fbbd = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($56bc6ca1bcc1c370$var$INTEGRATION_NAME, $56bc6ca1bcc1c370$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $56bc6ca1bcc1c370$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        (0, $cbe719ec84d28c68$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $a4aec27f2b28cb05$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $56bc6ca1bcc1c370$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $56bc6ca1bcc1c370$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$56bc6ca1bcc1c370$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$56bc6ca1bcc1c370$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $56bc6ca1bcc1c370$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $56bc6ca1bcc1c370$var$_isEvent(event) ? event.target : event;
            target = (0, $1862e47d17ed8624$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $1862e47d17ed8624$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $cbe719ec84d28c68$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $56bc6ca1bcc1c370$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $e5a8a92b1348aa8d$export$d771ef054122c30a)(handlerData.level),
            message: (0, $662e93ac017d9860$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $662e93ac017d9860$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $cbe719ec84d28c68$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $56bc6ca1bcc1c370$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $f7b6eb7bbcd641c1$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $cbe719ec84d28c68$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $56bc6ca1bcc1c370$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $cbe719ec84d28c68$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $cbe719ec84d28c68$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $56bc6ca1bcc1c370$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $5575f47b3080309f$export$7a5253c0f62e0150)((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $5575f47b3080309f$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $5575f47b3080309f$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $cbe719ec84d28c68$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $56bc6ca1bcc1c370$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $9d028a1afa8c3eeb$var$INTEGRATION_NAME = "Dedupe";
const $9d028a1afa8c3eeb$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $9d028a1afa8c3eeb$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($9d028a1afa8c3eeb$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $9d028a1afa8c3eeb$export$6d39aa44cd0c7567 = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($9d028a1afa8c3eeb$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9d028a1afa8c3eeb$export$688d98c249d31ad3 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($9d028a1afa8c3eeb$var$INTEGRATION_NAME, $9d028a1afa8c3eeb$export$6d39aa44cd0c7567);
function $9d028a1afa8c3eeb$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($9d028a1afa8c3eeb$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($9d028a1afa8c3eeb$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $9d028a1afa8c3eeb$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$9d028a1afa8c3eeb$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9d028a1afa8c3eeb$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9d028a1afa8c3eeb$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $9d028a1afa8c3eeb$var$_getExceptionFromEvent(previousEvent);
    const currentException = $9d028a1afa8c3eeb$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$9d028a1afa8c3eeb$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9d028a1afa8c3eeb$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9d028a1afa8c3eeb$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $9d028a1afa8c3eeb$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $9d028a1afa8c3eeb$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $9d028a1afa8c3eeb$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $9d028a1afa8c3eeb$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $9d028a1afa8c3eeb$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $c33515e055bce561$var$INTEGRATION_NAME = "GlobalHandlers";
const $c33515e055bce561$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c33515e055bce561$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c33515e055bce561$var$_installGlobalOnErrorHandler(client);
                $c33515e055bce561$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $c33515e055bce561$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c33515e055bce561$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $c33515e055bce561$export$66acc70e8cf2b71a = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($c33515e055bce561$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c33515e055bce561$export$204155decbc90e5a = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($c33515e055bce561$var$INTEGRATION_NAME, $c33515e055bce561$export$66acc70e8cf2b71a);
function $c33515e055bce561$var$_installGlobalOnErrorHandler(client) {
    (0, $277ad536ce22c36e$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c33515e055bce561$var$getOptions();
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client || (0, $f6edc5f11df97b11$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(msg) ? $c33515e055bce561$var$_eventFromIncompleteOnError(msg, url, line, column) : $c33515e055bce561$var$_enhanceEventWithInitialFrame((0, $95772c9d17189dab$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $cbe719ec84d28c68$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $c33515e055bce561$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $078045da06d770e8$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c33515e055bce561$var$getOptions();
        if ((0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)() !== client || (0, $f6edc5f11df97b11$export$b79738ab10c590b2)()) return;
        const error = $c33515e055bce561$var$_getUnhandledRejectionError(e);
        const event = (0, $48dc9950f67ce5b4$export$c3825b437cbdea5c)(error) ? $c33515e055bce561$var$_eventFromRejectionWithPrimitive(error) : (0, $95772c9d17189dab$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $cbe719ec84d28c68$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $c33515e055bce561$var$_getUnhandledRejectionError(error) {
    if ((0, $48dc9950f67ce5b4$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $c33515e055bce561$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c33515e055bce561$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $48dc9950f67ce5b4$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $c33515e055bce561$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c33515e055bce561$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $48dc9950f67ce5b4$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $1862e47d17ed8624$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $c33515e055bce561$var$globalHandlerLog(type) {
    (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $c33515e055bce561$var$getOptions() {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $c85b7eda135e4819$var$INTEGRATION_NAME = "HttpContext";
const $c85b7eda135e4819$var$_httpContextIntegration = ()=>{
    return {
        name: $c85b7eda135e4819$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator && !(0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location && !(0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $c85b7eda135e4819$export$1378794447170364 = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($c85b7eda135e4819$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c85b7eda135e4819$export$5d2ee9a544b09a94 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($c85b7eda135e4819$var$INTEGRATION_NAME, $c85b7eda135e4819$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $a27cac548d46bee7$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $48dc9950f67ce5b4$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $a27cac548d46bee7$var$truncateAggregateExceptions($a27cac548d46bee7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $a27cac548d46bee7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $48dc9950f67ce5b4$export$49034edbe6b62415)(error[key], Error)) {
        $a27cac548d46bee7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $a27cac548d46bee7$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $a27cac548d46bee7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $48dc9950f67ce5b4$export$49034edbe6b62415)(childError, Error)) {
            $a27cac548d46bee7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $a27cac548d46bee7$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $a27cac548d46bee7$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $a27cac548d46bee7$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $a27cac548d46bee7$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $a27cac548d46bee7$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $662e93ac017d9860$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $e0422fc332223af4$var$DEFAULT_KEY = "cause";
const $e0422fc332223af4$var$DEFAULT_LIMIT = 5;
const $e0422fc332223af4$var$INTEGRATION_NAME = "LinkedErrors";
const $e0422fc332223af4$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e0422fc332223af4$var$DEFAULT_LIMIT;
    const key = options.key || $e0422fc332223af4$var$DEFAULT_KEY;
    return {
        name: $e0422fc332223af4$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $a27cac548d46bee7$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $95772c9d17189dab$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $e0422fc332223af4$export$ebabb00eb7f3a395 = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($e0422fc332223af4$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e0422fc332223af4$export$8d1e60aaf616fb4f = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($e0422fc332223af4$var$INTEGRATION_NAME, $e0422fc332223af4$export$ebabb00eb7f3a395);





const $65354d8149d0600c$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $65354d8149d0600c$var$INTEGRATION_NAME = "TryCatch";
const $65354d8149d0600c$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $65354d8149d0600c$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $95e32bdd0672a295$export$9563e054e6f787fb)((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81), "setTimeout", $65354d8149d0600c$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $95e32bdd0672a295$export$9563e054e6f787fb)((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81), "setInterval", $65354d8149d0600c$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $95e32bdd0672a295$export$9563e054e6f787fb)((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81), "requestAnimationFrame", $65354d8149d0600c$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81)) (0, $95e32bdd0672a295$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $65354d8149d0600c$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $65354d8149d0600c$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($65354d8149d0600c$var$_wrapEventTarget);
            }
        }
    };
};
const $65354d8149d0600c$export$59bfe9f1c76150e = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($65354d8149d0600c$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $65354d8149d0600c$export$f1a018517668e6d3 = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($65354d8149d0600c$var$INTEGRATION_NAME, $65354d8149d0600c$export$59bfe9f1c76150e);
function $65354d8149d0600c$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $121116598fbd347a$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $65354d8149d0600c$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $121116598fbd347a$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $65354d8149d0600c$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $95e32bdd0672a295$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $121116598fbd347a$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $95e32bdd0672a295$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $121116598fbd347a$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $65354d8149d0600c$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $121116598fbd347a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $121116598fbd347a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $95e32bdd0672a295$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION = "?";
const $59dbf9a2036d14cd$var$OPERA10_PRIORITY = 10;
const $59dbf9a2036d14cd$var$OPERA11_PRIORITY = 20;
const $59dbf9a2036d14cd$var$CHROME_PRIORITY = 30;
const $59dbf9a2036d14cd$var$WINJS_PRIORITY = 40;
const $59dbf9a2036d14cd$var$GECKO_PRIORITY = 50;
function $59dbf9a2036d14cd$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $59dbf9a2036d14cd$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $59dbf9a2036d14cd$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $59dbf9a2036d14cd$var$chromeStackParserFn = (line)=>{
    const parts = $59dbf9a2036d14cd$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $59dbf9a2036d14cd$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $59dbf9a2036d14cd$var$extractSafariExtensionDetails(parts[1] || $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION, parts[2]);
        return $59dbf9a2036d14cd$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $59dbf9a2036d14cd$export$263a749fff749872 = [
    $59dbf9a2036d14cd$var$CHROME_PRIORITY,
    $59dbf9a2036d14cd$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $59dbf9a2036d14cd$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $59dbf9a2036d14cd$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $59dbf9a2036d14cd$var$gecko = (line)=>{
    const parts = $59dbf9a2036d14cd$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $59dbf9a2036d14cd$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION;
        [func, filename] = $59dbf9a2036d14cd$var$extractSafariExtensionDetails(func, filename);
        return $59dbf9a2036d14cd$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $59dbf9a2036d14cd$export$cdba47a5dd2804d = [
    $59dbf9a2036d14cd$var$GECKO_PRIORITY,
    $59dbf9a2036d14cd$var$gecko
];
const $59dbf9a2036d14cd$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $59dbf9a2036d14cd$var$winjs = (line)=>{
    const parts = $59dbf9a2036d14cd$var$winjsRegex.exec(line);
    return parts ? $59dbf9a2036d14cd$var$createFrame(parts[2], parts[1] || $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $59dbf9a2036d14cd$export$179460296da408e8 = [
    $59dbf9a2036d14cd$var$WINJS_PRIORITY,
    $59dbf9a2036d14cd$var$winjs
];
const $59dbf9a2036d14cd$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $59dbf9a2036d14cd$var$opera10 = (line)=>{
    const parts = $59dbf9a2036d14cd$var$opera10Regex.exec(line);
    return parts ? $59dbf9a2036d14cd$var$createFrame(parts[2], parts[3] || $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $59dbf9a2036d14cd$export$f892b52c880ffc7a = [
    $59dbf9a2036d14cd$var$OPERA10_PRIORITY,
    $59dbf9a2036d14cd$var$opera10
];
const $59dbf9a2036d14cd$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $59dbf9a2036d14cd$var$opera11 = (line)=>{
    const parts = $59dbf9a2036d14cd$var$opera11Regex.exec(line);
    return parts ? $59dbf9a2036d14cd$var$createFrame(parts[5], parts[3] || parts[4] || $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $59dbf9a2036d14cd$export$af11af13f09fb0dc = [
    $59dbf9a2036d14cd$var$OPERA11_PRIORITY,
    $59dbf9a2036d14cd$var$opera11
];
const $59dbf9a2036d14cd$export$7197c0fe6554c079 = [
    $59dbf9a2036d14cd$export$263a749fff749872,
    $59dbf9a2036d14cd$export$cdba47a5dd2804d,
    $59dbf9a2036d14cd$export$179460296da408e8
];
const $59dbf9a2036d14cd$export$2b2b997d81bf3907 = (0, $121116598fbd347a$export$a5739666fb2d03d4)(...$59dbf9a2036d14cd$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $59dbf9a2036d14cd$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $59dbf9a2036d14cd$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $7d37deb2716d40d8$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $7d37deb2716d40d8$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $7d37deb2716d40d8$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $7d37deb2716d40d8$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $7d37deb2716d40d8$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $7d37deb2716d40d8$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $7d37deb2716d40d8$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $7d37deb2716d40d8$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $4b043d701f850828$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $e0170d90e8c79bf3$export$78e43115b553f358)(new (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $e0170d90e8c79bf3$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $fc505e45e4945d16$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $fc505e45e4945d16$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $4b043d701f850828$export$85a4f67f852183e6)(options.bufferSize || $fc505e45e4945d16$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $a526f2a77773274f$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $a526f2a77773274f$export$b11169581eeaf237)(type);
            if ((0, $7d37deb2716d40d8$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $fc505e45e4945d16$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $a526f2a77773274f$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $a526f2a77773274f$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $fc505e45e4945d16$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $a526f2a77773274f$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $a526f2a77773274f$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $7d37deb2716d40d8$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $6d42b0ab376e7399$export$5949942ba2a7c0e2)) {
                (0, $9266143fc5665ff4$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $e0170d90e8c79bf3$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $fc505e45e4945d16$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $30716abf0c342179$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $30716abf0c342179$export$8be2119ce08e3379() {
    if ($30716abf0c342179$var$cachedFetchImpl) return $30716abf0c342179$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $1ad3f51fc2e0aa3e$export$18cf36ed71d733e7)((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).fetch)) return $30716abf0c342179$var$cachedFetchImpl = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).fetch.bind((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81));
    const document = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $30716abf0c342179$var$cachedFetchImpl = fetchImpl.bind((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $30716abf0c342179$export$d499686d2dd738c6() {
    $30716abf0c342179$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $567ed7d2d0993015$export$b2311068c46d7cc8(options, nativeFetch = (0, $30716abf0c342179$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $30716abf0c342179$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $e0170d90e8c79bf3$export$78e43115b553f358)(e);
        }
    }
    return (0, $fc505e45e4945d16$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $43b696bb17919cb7$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $43b696bb17919cb7$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $e0170d90e8c79bf3$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $43b696bb17919cb7$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $fc505e45e4945d16$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $2927a72296a391dc$export$5ef831fccfce35e5 = [
    (0, $1d409873eef6730e$export$cb3c5c2ceb9818ba)(),
    (0, $4d387e0c1669908e$export$7918117e9202e4fb)(),
    (0, $65354d8149d0600c$export$59bfe9f1c76150e)(),
    (0, $56bc6ca1bcc1c370$export$c079d904b326663a)(),
    (0, $c33515e055bce561$export$66acc70e8cf2b71a)(),
    (0, $e0422fc332223af4$export$ebabb00eb7f3a395)(),
    (0, $9d028a1afa8c3eeb$export$6d39aa44cd0c7567)(),
    (0, $c85b7eda135e4819$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $2927a72296a391dc$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$2927a72296a391dc$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $2927a72296a391dc$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $2927a72296a391dc$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $121116598fbd347a$export$1d5cf88b347146d4)(options.stackParser || (0, $59dbf9a2036d14cd$export$2b2b997d81bf3907)),
        integrations: (0, $bd021bfb8acb0c22$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $1ad3f51fc2e0aa3e$export$edf3cb81fd7d2a3e)() ? (0, $567ed7d2d0993015$export$b2311068c46d7cc8) : (0, $43b696bb17919cb7$export$5e1441cee30d5a39))
    };
    (0, $7376790b83234bd9$export$5333c3f1c58d9bc1)((0, $393390313ad67c10$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $2927a72296a391dc$var$startSessionTracking();
}
const $2927a72296a391dc$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $74dbbf1dc360cb47$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document.head || (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2927a72296a391dc$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2927a72296a391dc$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2927a72296a391dc$export$4997ffc0176396a6(fn) {
    return (0, $f6edc5f11df97b11$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $2927a72296a391dc$var$startSessionTracking() {
    if (typeof (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $11d1c99fee2f5edd$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $cbe719ec84d28c68$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $cbe719ec84d28c68$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $58855933738bc299$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $cbe719ec84d28c68$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $cbe719ec84d28c68$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $2927a72296a391dc$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $42b2b92648747c8b$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $4c7c06c74524101e$export$b9f95b027256052c)(opts, "react");
    (0, $2927a72296a391dc$export$2cd8252107eb640b)(opts);
}









const $85e34ee80b6aa71e$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $85e34ee80b6aa71e$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $3c0a5b7663a36e68$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $7246d6029e412c22$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $85e34ee80b6aa71e$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $310f3638d547d904$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $c3bfa3c854ad9d71$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$85e34ee80b6aa71e$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $b1bea7a7619b758e$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $b1bea7a7619b758e$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $b1bea7a7619b758e$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $b1bea7a7619b758e$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $970ec608023beb99$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $85e34ee80b6aa71e$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $85e34ee80b6aa71e$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $adb2e0f3471b4e35$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $c3bfa3c854ad9d71$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) {
            (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $b1bea7a7619b758e$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $85e34ee80b6aa71e$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $310f3638d547d904$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $386b8b8fbbe8a075$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $9b109844d4ad1b74$export$baf075a948ffc0bf) ? (0, $9b109844d4ad1b74$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: "url"
                    }
                };
                $85e34ee80b6aa71e$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location) (0, $58855933738bc299$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $85e34ee80b6aa71e$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $cdcc7b609e92e431$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $85e34ee80b6aa71e$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $85e34ee80b6aa71e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $7246d6029e412c22$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $85e34ee80b6aa71e$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $6e54f04d8cb2bbe5$export$1be426a8e585c83e)();
    const op = span && (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $85e34ee80b6aa71e$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $6e54f04d8cb2bbe5$export$1be426a8e585c83e)();
    const op = span && (0, $386b8b8fbbe8a075$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $85e34ee80b6aa71e$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $1862e47d17ed8624$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $85e34ee80b6aa71e$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $310f3638d547d904$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: latestRoute.context ? $85e34ee80b6aa71e$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $c3bfa3c854ad9d71$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $970ec608023beb99$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $ad4c1d7ab2b57ce5$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $85e34ee80b6aa71e$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $85e34ee80b6aa71e$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $85e34ee80b6aa71e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $cbe719ec84d28c68$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $dd0a5dc41f00fcde$export$a7feb32fdd923295)();
        const currentScope = (0, $cbe719ec84d28c68$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($85e34ee80b6aa71e$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $85e34ee80b6aa71e$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $85e34ee80b6aa71e$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $6ba4605167f12edc$export$69816c1a049f8db6)("event", handleEntries);
    (0, $6ba4605167f12edc$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $85e34ee80b6aa71e$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $33c09cd2024ef047$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $33c09cd2024ef047$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}













































var $dcdfc56dd4177d56$exports = {};

$parcel$export($dcdfc56dd4177d56$exports, "FunctionToString", () => $4d387e0c1669908e$export$da4704525c20ae79);
$parcel$export($dcdfc56dd4177d56$exports, "InboundFilters", () => $1d409873eef6730e$export$2ffbb5359dcc6be4);
$parcel$export($dcdfc56dd4177d56$exports, "LinkedErrors", () => $7d7741e0c989ec51$export$8d1e60aaf616fb4f);






/**
 * Extracts stack frames from the error.stack string
 */ function $5c037a4f6c2a9979$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $5c037a4f6c2a9979$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $5c037a4f6c2a9979$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $5c037a4f6c2a9979$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $95e32bdd0672a295$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $5c037a4f6c2a9979$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $48dc9950f67ce5b4$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $48dc9950f67ce5b4$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $c207ff544b279d26$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $5c037a4f6c2a9979$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $5c037a4f6c2a9979$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $a4aec27f2b28cb05$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $a4aec27f2b28cb05$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $5c037a4f6c2a9979$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $5c037a4f6c2a9979$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $48dc9950f67ce5b4$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $7d7741e0c989ec51$var$DEFAULT_KEY = "cause";
const $7d7741e0c989ec51$var$DEFAULT_LIMIT = 5;
const $7d7741e0c989ec51$var$INTEGRATION_NAME = "LinkedErrors";
const $7d7741e0c989ec51$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $7d7741e0c989ec51$var$DEFAULT_LIMIT;
    const key = options.key || $7d7741e0c989ec51$var$DEFAULT_KEY;
    return {
        name: $7d7741e0c989ec51$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $a27cac548d46bee7$export$b91c38ed7d8ae9b2)((0, $5c037a4f6c2a9979$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $7d7741e0c989ec51$export$ebabb00eb7f3a395 = (0, $bd021bfb8acb0c22$export$2323046b9414659f)($7d7741e0c989ec51$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7d7741e0c989ec51$export$8d1e60aaf616fb4f = (0, $bd021bfb8acb0c22$export$afa219bf23651160)($7d7741e0c989ec51$var$INTEGRATION_NAME, $7d7741e0c989ec51$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $9825826675917abf$export$99d02219d259eb94 = $dcdfc56dd4177d56$exports;
















var $7e7b3ecfad4e9ecd$exports = {};

$parcel$export($7e7b3ecfad4e9ecd$exports, "GlobalHandlers", () => $c33515e055bce561$export$204155decbc90e5a);
$parcel$export($7e7b3ecfad4e9ecd$exports, "TryCatch", () => $65354d8149d0600c$export$f1a018517668e6d3);
$parcel$export($7e7b3ecfad4e9ecd$exports, "Breadcrumbs", () => $56bc6ca1bcc1c370$export$2dc68d50d56fbbd);
$parcel$export($7e7b3ecfad4e9ecd$exports, "LinkedErrors", () => $e0422fc332223af4$export$8d1e60aaf616fb4f);
$parcel$export($7e7b3ecfad4e9ecd$exports, "HttpContext", () => $c85b7eda135e4819$export$5d2ee9a544b09a94);
$parcel$export($7e7b3ecfad4e9ecd$exports, "Dedupe", () => $9d028a1afa8c3eeb$export$688d98c249d31ad3);






 /* eslint-disable deprecation/deprecation */ 









let $df9e10d3327317ee$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).Sentry && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).Sentry.Integrations) $df9e10d3327317ee$var$windowIntegrations = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $df9e10d3327317ee$export$99d02219d259eb94 = {
    ...$df9e10d3327317ee$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $9825826675917abf$export$99d02219d259eb94),
    ...$7e7b3ecfad4e9ecd$exports
};





var $5gHVI = parcelRequire("5gHVI");

var $dup7A = parcelRequire("dup7A");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b076c447913530f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $c740015d3cadd51a$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $c740015d3cadd51a$var$activeTransaction;
let $c740015d3cadd51a$var$_useEffect;
let $c740015d3cadd51a$var$_useLocation;
let $c740015d3cadd51a$var$_useNavigationType;
let $c740015d3cadd51a$var$_createRoutesFromChildren;
let $c740015d3cadd51a$var$_matchRoutes;
let $c740015d3cadd51a$var$_customStartTransaction;
let $c740015d3cadd51a$var$_startTransactionOnLocationChange;
let $c740015d3cadd51a$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $c740015d3cadd51a$export$47113a480541ff59(options) {
    const integration = (0, $85e34ee80b6aa71e$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $85e34ee80b6aa71e$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81) && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $85e34ee80b6aa71e$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: "url",
                    [(0, $33c09cd2024ef047$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $c740015d3cadd51a$var$_useEffect = useEffect;
            $c740015d3cadd51a$var$_useLocation = useLocation;
            $c740015d3cadd51a$var$_useNavigationType = useNavigationType;
            $c740015d3cadd51a$var$_matchRoutes = matchRoutes;
            $c740015d3cadd51a$var$_createRoutesFromChildren = createRoutesFromChildren;
            $c740015d3cadd51a$var$_stripBasename = stripBasename || false;
            $c740015d3cadd51a$var$_customStartTransaction = startNavigationCallback;
            $c740015d3cadd51a$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $c740015d3cadd51a$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81) && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location && (0, $f6edc5f11df97b11$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $c740015d3cadd51a$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: "url",
                [(0, $33c09cd2024ef047$export$1a413bd9a88fdb09)]: "pageload",
                [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $c740015d3cadd51a$var$_useEffect = useEffect;
        $c740015d3cadd51a$var$_useLocation = useLocation;
        $c740015d3cadd51a$var$_useNavigationType = useNavigationType;
        $c740015d3cadd51a$var$_matchRoutes = matchRoutes;
        $c740015d3cadd51a$var$_createRoutesFromChildren = createRoutesFromChildren;
        $c740015d3cadd51a$var$_stripBasename = stripBasename || false;
        $c740015d3cadd51a$var$_customStartTransaction = customStartTransaction;
        $c740015d3cadd51a$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $c740015d3cadd51a$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $c740015d3cadd51a$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $c740015d3cadd51a$var$_stripBasename ? $c740015d3cadd51a$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $c740015d3cadd51a$var$_stripBasename ? $c740015d3cadd51a$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $5575f47b3080309f$export$69dd85280a8d374c)(pathBuilder) !== (0, $5575f47b3080309f$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($c740015d3cadd51a$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($c740015d3cadd51a$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $c740015d3cadd51a$var$_stripBasename ? $c740015d3cadd51a$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $c740015d3cadd51a$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $c740015d3cadd51a$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $c740015d3cadd51a$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $33c09cd2024ef047$export$d7a7d984b0791405), source);
    }
}
function $c740015d3cadd51a$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $c740015d3cadd51a$var$_matchRoutes(routes, location, basename);
    if ($c740015d3cadd51a$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($c740015d3cadd51a$var$activeTransaction) $c740015d3cadd51a$var$activeTransaction.end();
        const [name, source] = $c740015d3cadd51a$var$getNormalizedName(routes, location, branches, basename);
        $c740015d3cadd51a$var$activeTransaction = $c740015d3cadd51a$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $33c09cd2024ef047$export$d7a7d984b0791405)]: source,
                [(0, $33c09cd2024ef047$export$1a413bd9a88fdb09)]: "navigation",
                [(0, $33c09cd2024ef047$export$cca8dd30f57f805e)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c740015d3cadd51a$export$c6111e8561a02a8b(Routes) {
    if (!$c740015d3cadd51a$var$_useEffect || !$c740015d3cadd51a$var$_useLocation || !$c740015d3cadd51a$var$_useNavigationType || !$c740015d3cadd51a$var$_createRoutesFromChildren || !$c740015d3cadd51a$var$_matchRoutes || !$c740015d3cadd51a$var$_customStartTransaction) {
        (0, $7b076c447913530f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$c740015d3cadd51a$var$_useEffect}. useLocation: ${$c740015d3cadd51a$var$_useLocation}. useNavigationType: ${$c740015d3cadd51a$var$_useNavigationType}.
      createRoutesFromChildren: ${$c740015d3cadd51a$var$_createRoutesFromChildren}. matchRoutes: ${$c740015d3cadd51a$var$_matchRoutes}. customStartTransaction: ${$c740015d3cadd51a$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $c740015d3cadd51a$var$_useLocation();
        const navigationType = $c740015d3cadd51a$var$_useNavigationType();
        $c740015d3cadd51a$var$_useEffect(()=>{
            const routes = $c740015d3cadd51a$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $c740015d3cadd51a$var$updatePageloadTransaction($c740015d3cadd51a$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $c740015d3cadd51a$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $dup7A.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $c740015d3cadd51a$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5gHVI)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $c740015d3cadd51a$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$c740015d3cadd51a$var$_useEffect || !$c740015d3cadd51a$var$_useLocation || !$c740015d3cadd51a$var$_useNavigationType || !$c740015d3cadd51a$var$_matchRoutes || !$c740015d3cadd51a$var$_customStartTransaction) {
        (0, $7b076c447913530f$export$16a28057038b10ef) && (0, $6a114848ff8dae1d$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $c740015d3cadd51a$var$_useLocation();
        const navigationType = $c740015d3cadd51a$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $c740015d3cadd51a$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $c740015d3cadd51a$var$updatePageloadTransaction($c740015d3cadd51a$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $c740015d3cadd51a$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $dup7A.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $c740015d3cadd51a$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $c740015d3cadd51a$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $c740015d3cadd51a$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $c740015d3cadd51a$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($c740015d3cadd51a$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $c740015d3cadd51a$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $c740015d3cadd51a$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($c740015d3cadd51a$var$activeTransaction) return $c740015d3cadd51a$var$activeTransaction;
    const span = (0, $6e54f04d8cb2bbe5$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $8d3523928e82f4f4$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $386b8b8fbbe8a075$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}




$42b2b92648747c8b$export$2cd8252107eb640b({
    dsn: "https://e4777c4e2a5d4de4a491fa8585b27ab8@o4504684856606720.ingest.sentry.io/4504685772079104",
    environment: "staging",
    release: `court-v2@${(0, $203b613495c69c62$export$f1af843f4d252578)}-${(0, $203b613495c69c62$export$8439c9c045e5384d)}${(0, $203b613495c69c62$export$91f55afd4519d50b)}`,
    integrations: [
        new $b89879432870128a$export$b0fe88803ed435e0(),
        new $8dbddd3dbec405f5$export$46d3bbd0375f5fa4({
            routingInstrumentation: $c740015d3cadd51a$export$e6e76890c5208db1((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect, (0, $5c6d50c15e61ec01$export$45d76561a5302f2b), (0, $5c6d50c15e61ec01$export$1b3f31771c5d07c), (0, $5c6d50c15e61ec01$export$16da398f5434bdec), (0, $812c9a0500c51f61$export$2708184779ceb39d))
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/.*--kleros-v2\.netlify\.app/
    ],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0
});
const $11a81dac4e2162d8$export$22a2709142043366 = $c740015d3cadd51a$export$c6111e8561a02a8b((0, $5c6d50c15e61ec01$export$3565eb3d00ca5a74));


const $36946ed7f3b98c78$var$App = ()=>{
    return /*#__PURE__*/ (0, $cZGFG.jsx)((0, $27c7d505e83322db$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $4843a074f5ea24c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $eb4899630ce86774$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cZGFG.jsx)((0, $e6e1be54a100c2c5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b60072fbac509c49$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $b73946e052a4abb0$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $402e40eea0418fd8$export$9b11d8be314cc86), {
                                children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $11a81dac4e2162d8$export$22a2709142043366), {
                                    children: /*#__PURE__*/ (0, $cZGFG.jsxs)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $68d9f874bacaa090$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $f6992ffc8abff560$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "cases/*",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $24207fa12856df01$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "courts/*",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $791c983324b55a5e$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "dashboard/:page/:order/:filter",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $02b519f108ac1b5b$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "dispute-template",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1f7b26a96cfbff44$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "resolver/*",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $2ee9f47bb9d3eaf5$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "get-pnk/*",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $12de2bcf44014032$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $cZGFG.jsx)((0, $5c6d50c15e61ec01$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $cZGFG.jsx)("h1", {
                                                    children: "Justice not found here \xaf\\_( \u0361\xb0 \u035C\u0296 \u0361\xb0)_/\xaf"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $36946ed7f3b98c78$export$2e2bcd8739ae039 = $36946ed7f3b98c78$var$App;


const $45b3b16ea68ae33d$var$container = document.getElementById("app");
(0, (/*@__PURE__*/$parcel$interopDefault($939f14b26ca18529$exports))).setAppElement($45b3b16ea68ae33d$var$container);
const $45b3b16ea68ae33d$var$root = (0, $1c1c7e7d360f5af6$export$882461b6382ed46c)($45b3b16ea68ae33d$var$container);
$45b3b16ea68ae33d$var$root.render(/*#__PURE__*/ (0, $cZGFG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).StrictMode, {
    children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $1d2829c53a2521b2$export$7221d69dcfc8e36b), {
        children: /*#__PURE__*/ (0, $cZGFG.jsx)((0, $36946ed7f3b98c78$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.b67d8b08.js.map
